
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecaae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecaae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6fXQY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $j7HZ4 = parcelRequire("j7HZ4");

var $33FUD = parcelRequire("33FUD");

var $krgs5 = parcelRequire("krgs5");

var $dRtIK = parcelRequire("dRtIK");

var $hhSBj = parcelRequire("hhSBj");

var $dAQ6V = parcelRequire("dAQ6V");

var $5VGek = parcelRequire("5VGek");

var $6vmlI = parcelRequire("6vmlI");

var $j5ojN = parcelRequire("j5ojN");

var $9c3TQ = parcelRequire("9c3TQ");

var $cXJ5I = parcelRequire("cXJ5I");

var $2VRKv = parcelRequire("2VRKv");

var $7nMWX = parcelRequire("7nMWX");

var $6a1Ld = parcelRequire("6a1Ld");

var $cwsTk = parcelRequire("cwsTk");

var $k1IvE = parcelRequire("k1IvE");

var $8cDmr = parcelRequire("8cDmr");

var $2JduQ = parcelRequire("2JduQ");

var $kJVFD = parcelRequire("kJVFD");

var $j3gO3 = parcelRequire("j3gO3");

var $logAX = parcelRequire("logAX");

var $3MW4D = parcelRequire("3MW4D");

var $1vcEw = parcelRequire("1vcEw");

var $hLkUK = parcelRequire("hLkUK");

var $eC4Ya = parcelRequire("eC4Ya");

var $jB2cn = parcelRequire("jB2cn");

var $3xShP = parcelRequire("3xShP");

var $kpDSY = parcelRequire("kpDSY");

var $2Rd9o = parcelRequire("2Rd9o");

var $LRu51 = parcelRequire("LRu51");

var $3kuJo = parcelRequire("3kuJo");

var $1OEds = parcelRequire("1OEds");

var $7dsZ5 = parcelRequire("7dsZ5");

var $7vf3z = parcelRequire("7vf3z");

var $7oq4J = parcelRequire("7oq4J");

var $baTSa = parcelRequire("baTSa");

var $3ldya = parcelRequire("3ldya");

var $60l9G = parcelRequire("60l9G");

var $4BYqM = parcelRequire("4BYqM");

var $gjtOy = parcelRequire("gjtOy");

var $3fFnG = parcelRequire("3fFnG");

var $4QmUc = parcelRequire("4QmUc");

var $c6nxn = parcelRequire("c6nxn");

var $aLprX = parcelRequire("aLprX");

var $hR4pa = parcelRequire("hR4pa");

var $43BuU = parcelRequire("43BuU");

var $jsTRh = parcelRequire("jsTRh");

var $bHxuO = parcelRequire("bHxuO");

var $hPQqG = parcelRequire("hPQqG");

var $95nH0 = parcelRequire("95nH0");

var $cagwd = parcelRequire("cagwd");

var $5mrku = parcelRequire("5mrku");

var $eDH5Q = parcelRequire("eDH5Q");

var $aD0ts = parcelRequire("aD0ts");

var $eldhF = parcelRequire("eldhF");

var $JJ1mC = parcelRequire("JJ1mC");

var $j5YQJ = parcelRequire("j5YQJ");

var $G7TwH = parcelRequire("G7TwH");

var $elK9c = parcelRequire("elK9c");

var $4wxG7 = parcelRequire("4wxG7");

var $jeFfT = parcelRequire("jeFfT");

var $az7hP = parcelRequire("az7hP");

var $lX3kc = parcelRequire("lX3kc");

var $7ytrB = parcelRequire("7ytrB");

var $v7agl = parcelRequire("v7agl");

var $iRNFQ = parcelRequire("iRNFQ");

var $kypyN = parcelRequire("kypyN");

var $h1kyh = parcelRequire("h1kyh");

var $5jtP2 = parcelRequire("5jtP2");

var $6HJK6 = parcelRequire("6HJK6");

var $4A7xx = parcelRequire("4A7xx");

var $k0yFa = parcelRequire("k0yFa");

var $505qn = parcelRequire("505qn");

var $6ZcNn = parcelRequire("6ZcNn");

var $3jKxo = parcelRequire("3jKxo");

var $7wfxr = parcelRequire("7wfxr");

var $9xCLH = parcelRequire("9xCLH");

var $jvFcx = parcelRequire("jvFcx");

var $kiSB9 = parcelRequire("kiSB9");

var $3bTow = parcelRequire("3bTow");

var $9a9TW = parcelRequire("9a9TW");

var $6RTLc = parcelRequire("6RTLc");

var $7P0a7 = parcelRequire("7P0a7");

var $cCx8R = parcelRequire("cCx8R");

var $91zPf = parcelRequire("91zPf");

var $g7oR3 = parcelRequire("g7oR3");

var $1P70f = parcelRequire("1P70f");

var $H7uFC = parcelRequire("H7uFC");

var $ho5on = parcelRequire("ho5on");

var $jF9EZ = parcelRequire("jF9EZ");

var $gwxpT = parcelRequire("gwxpT");

var $auUX5 = parcelRequire("auUX5");

var $6m1Z1 = parcelRequire("6m1Z1");

var $7W5hL = parcelRequire("7W5hL");

var $50tta = parcelRequire("50tta");

var $k11y2 = parcelRequire("k11y2");

var $eTHLH = parcelRequire("eTHLH");

var $lk94N = parcelRequire("lk94N");

var $b08Oi = parcelRequire("b08Oi");

var $lbqbj = parcelRequire("lbqbj");

var $i8h4C = parcelRequire("i8h4C");

var $1Jcad = parcelRequire("1Jcad");

var $luwRx = parcelRequire("luwRx");

var $6zypK = parcelRequire("6zypK");

var $NKzWo = parcelRequire("NKzWo");

var $f2MZk = parcelRequire("f2MZk");

var $fkTTl = parcelRequire("fkTTl");

var $lWHPW = parcelRequire("lWHPW");

var $ateCs = parcelRequire("ateCs");

var $ljaTH = parcelRequire("ljaTH");

var $jm1F1 = parcelRequire("jm1F1");

var $kQG62 = parcelRequire("kQG62");

var $jDmhV = parcelRequire("jDmhV");

var $aNZ1M = parcelRequire("aNZ1M");

var $04GFW = parcelRequire("04GFW");

var $3I8lv = parcelRequire("3I8lv");

var $56noD = parcelRequire("56noD");

var $iBZic = parcelRequire("iBZic");

var $hRFVl = parcelRequire("hRFVl");

var $iN4A1 = parcelRequire("iN4A1");

var $9Gk1l = parcelRequire("9Gk1l");

var $aWndQ = parcelRequire("aWndQ");

var $2b0FU = parcelRequire("2b0FU");

var $55Yug = parcelRequire("55Yug");

var $bxNZo = parcelRequire("bxNZo");

var $gQok6 = parcelRequire("gQok6");

var $8pUWd = parcelRequire("8pUWd");

var $94dSL = parcelRequire("94dSL");

var $dQ0Qv = parcelRequire("dQ0Qv");

var $2NgE3 = parcelRequire("2NgE3");

var $1NysQ = parcelRequire("1NysQ");

var $OCsCD = parcelRequire("OCsCD");

var $5xKoA = parcelRequire("5xKoA");

var $dtwvq = parcelRequire("dtwvq");

var $d2zen = parcelRequire("d2zen");

var $3kLni = parcelRequire("3kLni");

var $6j9aN = parcelRequire("6j9aN");

var $bVnNd = parcelRequire("bVnNd");

var $bwY2N = parcelRequire("bwY2N");

var $cWBJD = parcelRequire("cWBJD");

var $lc80H = parcelRequire("lc80H");

var $792Ou = parcelRequire("792Ou");

var $hM8bG = parcelRequire("hM8bG");
module.exports.registerSpanErrorInstrumentation = $j7HZ4.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $33FUD.getCapturedScopesOnSpan;
module.exports.setCapturedScopesOnSpan = $33FUD.setCapturedScopesOnSpan;
module.exports.TRACING_DEFAULTS = $krgs5.TRACING_DEFAULTS;
module.exports.startIdleSpan = $krgs5.startIdleSpan;
module.exports.SentrySpan = $dRtIK.SentrySpan;
module.exports.SentryNonRecordingSpan = $hhSBj.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $dAQ6V.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $dAQ6V.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $dAQ6V.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $dAQ6V.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $dAQ6V.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $5VGek.SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $5VGek.continueTrace;
module.exports.startInactiveSpan = $5VGek.startInactiveSpan;
module.exports.startNewTrace = $5VGek.startNewTrace;
module.exports.startSpan = $5VGek.startSpan;
module.exports.startSpanManual = $5VGek.startSpanManual;
module.exports.suppressTracing = $5VGek.suppressTracing;
module.exports.withActiveSpan = $5VGek.withActiveSpan;
module.exports.getDynamicSamplingContextFromClient = $6vmlI.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $6vmlI.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $6vmlI.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $6vmlI.spanToBaggageHeader;
module.exports.setMeasurement = $j5ojN.setMeasurement;
module.exports.timedEventsToMeasurements = $j5ojN.timedEventsToMeasurements;
module.exports.sampleSpan = $9c3TQ.sampleSpan;
module.exports.logSpanEnd = $cXJ5I.logSpanEnd;
module.exports.logSpanStart = $cXJ5I.logSpanStart;
module.exports.captureSpan = $2VRKv.captureSpan;
module.exports.safeSetSpanJSONAttributes = $2VRKv.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $7nMWX.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $7nMWX.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $7nMWX.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $7nMWX.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $7nMWX.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $7nMWX.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $7nMWX.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $7nMWX.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $7nMWX.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $7nMWX.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $7nMWX.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $7nMWX.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $7nMWX.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $6a1Ld.createEventEnvelope;
module.exports.createSessionEnvelope = $6a1Ld.createSessionEnvelope;
module.exports.createSpanEnvelope = $6a1Ld.createSpanEnvelope;
module.exports.addEventProcessor = $cwsTk.addEventProcessor;
module.exports.captureCheckIn = $cwsTk.captureCheckIn;
module.exports.captureEvent = $cwsTk.captureEvent;
module.exports.captureException = $cwsTk.captureException;
module.exports.captureMessage = $cwsTk.captureMessage;
module.exports.captureSession = $cwsTk.captureSession;
module.exports.close = $cwsTk.close;
module.exports.endSession = $cwsTk.endSession;
module.exports.flush = $cwsTk.flush;
module.exports.isEnabled = $cwsTk.isEnabled;
module.exports.isInitialized = $cwsTk.isInitialized;
module.exports.lastEventId = $cwsTk.lastEventId;
module.exports.setContext = $cwsTk.setContext;
module.exports.setConversationId = $cwsTk.setConversationId;
module.exports.setExtra = $cwsTk.setExtra;
module.exports.setExtras = $cwsTk.setExtras;
module.exports.setTag = $cwsTk.setTag;
module.exports.setTags = $cwsTk.setTags;
module.exports.setUser = $cwsTk.setUser;
module.exports.startSession = $cwsTk.startSession;
module.exports.withMonitor = $cwsTk.withMonitor;
module.exports.getClient = $k1IvE.getClient;
module.exports.getCurrentScope = $k1IvE.getCurrentScope;
module.exports.getExternalPropagationContext = $k1IvE.getExternalPropagationContext;
module.exports.getGlobalScope = $k1IvE.getGlobalScope;
module.exports.getIsolationScope = $k1IvE.getIsolationScope;
module.exports.getTraceContextFromScope = $k1IvE.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $k1IvE.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $k1IvE.registerExternalPropagationContext;
module.exports.withIsolationScope = $k1IvE.withIsolationScope;
module.exports.withScope = $k1IvE.withScope;
module.exports.getDefaultCurrentScope = $8cDmr.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $8cDmr.getDefaultIsolationScope;
module.exports.setAsyncContextStrategy = $2JduQ.setAsyncContextStrategy;
module.exports.getGlobalSingleton = $kJVFD.getGlobalSingleton;
module.exports.getMainCarrier = $kJVFD.getMainCarrier;
module.exports.closeSession = $j3gO3.closeSession;
module.exports.makeSession = $j3gO3.makeSession;
module.exports.updateSession = $j3gO3.updateSession;
module.exports.Scope = $logAX.Scope;
module.exports.notifyEventProcessors = $3MW4D.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $1vcEw.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $1vcEw.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $1vcEw.getReportDialogEndpoint;
module.exports.Client = $hLkUK.Client;
module.exports.initAndBind = $eC4Ya.initAndBind;
module.exports.setCurrentClient = $eC4Ya.setCurrentClient;
module.exports.createTransport = $jB2cn.createTransport;
module.exports.makeOfflineTransport = $3xShP.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $kpDSY.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $kpDSY.makeMultiplexedTransport;
module.exports.addIntegration = $2Rd9o.addIntegration;
module.exports.defineIntegration = $2Rd9o.defineIntegration;
module.exports.getIntegrationsToSetup = $2Rd9o.getIntegrationsToSetup;
module.exports.installedIntegrations = $2Rd9o.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $LRu51._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $LRu51._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $LRu51._INTERNAL_skipAiProviderWrapping;
module.exports._INTERNAL_filterKeyValueData = $3kuJo.filterKeyValueData;
module.exports._INTERNAL_filterCookies = $1OEds.filterCookies;
module.exports._INTERNAL_filterQueryParams = $7dsZ5.filterQueryParams;
module.exports.envToBool = $7vf3z.envToBool;
module.exports.applyScopeDataToEvent = $7oq4J.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $7oq4J.getCombinedScopeData;
module.exports.mergeScopeData = $7oq4J.mergeScopeData;
module.exports.prepareEvent = $baTSa.prepareEvent;
module.exports.createCheckInEnvelope = $3ldya.createCheckInEnvelope;
module.exports.hasSpansEnabled = $60l9G.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $4BYqM.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $4BYqM.withStreamedSpan;
module.exports.isSentryRequestUrl = $gjtOy.isSentryRequestUrl;
module.exports.handleCallbackErrors = $3fFnG.handleCallbackErrors;
module.exports.fmt = $4QmUc.fmt;
module.exports.parameterize = $4QmUc.parameterize;
module.exports.handleTunnelRequest = $c6nxn.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $aLprX.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $aLprX.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $hR4pa.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $hR4pa.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $hR4pa.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $hR4pa.getActiveSpan;
module.exports.getRootSpan = $hR4pa.getRootSpan;
module.exports.getSpanDescendants = $hR4pa.getSpanDescendants;
module.exports.getStatusMessage = $hR4pa.getStatusMessage;
module.exports.spanIsSampled = $hR4pa.spanIsSampled;
module.exports.spanTimeInputToSeconds = $hR4pa.spanTimeInputToSeconds;
module.exports.spanToJSON = $hR4pa.spanToJSON;
module.exports.spanToStreamedSpanJSON = $hR4pa.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $hR4pa.spanToTraceContext;
module.exports.spanToTraceHeader = $hR4pa.spanToTraceHeader;
module.exports.updateSpanName = $hR4pa.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $43BuU._setSpanForScope;
module.exports.parseSampleRate = $jsTRh.parseSampleRate;
module.exports.applySdkMetadata = $bHxuO.applySdkMetadata;
module.exports.getTraceData = $hPQqG.getTraceData;
module.exports.shouldPropagateTraceForUrl = $95nH0.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $cagwd.getTraceMetaTags;
module.exports.debounce = $5mrku.debounce;
module.exports.derefWeakRef = $eDH5Q.derefWeakRef;
module.exports.makeWeakRef = $eDH5Q.makeWeakRef;
module.exports.shouldIgnoreSpan = $aD0ts.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $eldhF.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $eldhF.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $eldhF.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $eldhF.getMaxBodyByteLength;
module.exports.headersToDict = $eldhF.headersToDict;
module.exports.httpHeadersToSpanAttributes = $eldhF.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $eldhF.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $eldhF.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $eldhF.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $JJ1mC.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $JJ1mC.DEV_ENVIRONMENT;
module.exports.addBreadcrumb = $j5YQJ.addBreadcrumb;
module.exports.functionToStringIntegration = $G7TwH.functionToStringIntegration;
module.exports.eventFiltersIntegration = $elK9c.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $elK9c.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $4wxG7.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $jeFfT.moduleMetadataIntegration;
module.exports.requestDataIntegration = $az7hP.requestDataIntegration;
module.exports.captureConsoleIntegration = $lX3kc.captureConsoleIntegration;
module.exports.dedupeIntegration = $7ytrB.dedupeIntegration;
module.exports.extraErrorDataIntegration = $v7agl.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $iRNFQ.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $kypyN.instrumentSupabaseClient;
module.exports.supabaseIntegration = $kypyN.supabaseIntegration;
module.exports.zodErrorsIntegration = $h1kyh.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $5jtP2.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $6HJK6.consoleIntegration;
module.exports.featureFlagsIntegration = $4A7xx.featureFlagsIntegration;
module.exports.growthbookIntegration = $k0yFa.growthbookIntegration;
module.exports.conversationIdIntegration = $505qn.conversationIdIntegration;
module.exports.profiler = $6ZcNn.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $3jKxo._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $3jKxo.instrumentFetchRequest;
module.exports.captureFeedback = $7wfxr.captureFeedback;
module.exports._INTERNAL_captureLog = $9xCLH._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $9xCLH._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $9xCLH._INTERNAL_flushLogsBuffer;
module.exports.logger = $jvFcx;
module.exports.consoleLoggingIntegration = $kiSB9.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $3bTow._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $3bTow._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $3bTow._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $9a9TW;
module.exports.createConsolaReporter = $6RTLc.createConsolaReporter;
module.exports.addVercelAiProcessors = $7P0a7.addVercelAiProcessors;
module.exports._INTERNAL_cleanupToolCallSpanContext = $cCx8R._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $cCx8R._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $91zPf.toolCallSpanContextMap;
module.exports.instrumentOpenAiClient = $g7oR3.instrumentOpenAiClient;
module.exports.OPENAI_INTEGRATION_NAME = $1P70f.OPENAI_INTEGRATION_NAME;
module.exports.instrumentAnthropicAiClient = $H7uFC.instrumentAnthropicAiClient;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $ho5on.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.instrumentGoogleGenAIClient = $jF9EZ.instrumentGoogleGenAIClient;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $gwxpT.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $auUX5.createLangChainCallbackHandler;
module.exports._INTERNAL_mergeLangChainCallbackHandler = $6m1Z1._INTERNAL_mergeLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $7W5hL.LANGCHAIN_INTEGRATION_NAME;
module.exports.instrumentCreateReactAgent = $50tta.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $50tta.instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $50tta.instrumentStateGraphCompile;
module.exports.LANGGRAPH_INTEGRATION_NAME = $k11y2.LANGGRAPH_INTEGRATION_NAME;
module.exports.SpanBuffer = $eTHLH.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $lk94N.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $b08Oi.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $lbqbj._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $lbqbj._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $lbqbj._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $lbqbj._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $lbqbj._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $i8h4C.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $1Jcad.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $luwRx.dsnFromString;
module.exports.dsnToString = $luwRx.dsnToString;
module.exports.makeDsn = $luwRx.makeDsn;
module.exports.SentryError = $6zypK.SentryError;
module.exports.GLOBAL_OBJ = $NKzWo.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $f2MZk.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $f2MZk.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $fkTTl.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $fkTTl.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $lWHPW.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $ateCs.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $ljaTH.addHandler;
module.exports.maybeInstrument = $ljaTH.maybeInstrument;
module.exports.resetInstrumentationHandlers = $ljaTH.resetInstrumentationHandlers;
module.exports.triggerHandlers = $ljaTH.triggerHandlers;
module.exports.isDOMError = $jm1F1.isDOMError;
module.exports.isDOMException = $jm1F1.isDOMException;
module.exports.isElement = $jm1F1.isElement;
module.exports.isError = $jm1F1.isError;
module.exports.isErrorEvent = $jm1F1.isErrorEvent;
module.exports.isEvent = $jm1F1.isEvent;
module.exports.isInstanceOf = $jm1F1.isInstanceOf;
module.exports.isParameterizedString = $jm1F1.isParameterizedString;
module.exports.isPlainObject = $jm1F1.isPlainObject;
module.exports.isPrimitive = $jm1F1.isPrimitive;
module.exports.isRegExp = $jm1F1.isRegExp;
module.exports.isString = $jm1F1.isString;
module.exports.isSyntheticEvent = $jm1F1.isSyntheticEvent;
module.exports.isThenable = $jm1F1.isThenable;
module.exports.isVueViewModel = $jm1F1.isVueViewModel;
module.exports.isBrowser = $kQG62.isBrowser;
module.exports.CONSOLE_LEVELS = $jDmhV.CONSOLE_LEVELS;
module.exports.consoleSandbox = $jDmhV.consoleSandbox;
module.exports.debug = $jDmhV.debug;
module.exports.originalConsoleMethods = $jDmhV.originalConsoleMethods;
module.exports.addContextToFrame = $aNZ1M.addContextToFrame;
module.exports.addExceptionMechanism = $aNZ1M.addExceptionMechanism;
module.exports.addExceptionTypeValue = $aNZ1M.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $aNZ1M.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $aNZ1M.getEventDescription;
module.exports.isAlreadyCaptured = $aNZ1M.isAlreadyCaptured;
module.exports.parseSemver = $aNZ1M.parseSemver;
module.exports.uuid4 = $aNZ1M.uuid4;
module.exports.normalize = $04GFW.normalize;
module.exports.normalizeToSize = $04GFW.normalizeToSize;
module.exports.normalizeUrlToBase = $04GFW.normalizeUrlToBase;
module.exports.setNormalizeStringifier = $04GFW.setNormalizeStringifier;
module.exports.setNormalizationDepthOverrideHint = $3I8lv.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $3I8lv.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $56noD.addNonEnumerableProperty;
module.exports.convertToPlainObject = $56noD.convertToPlainObject;
module.exports.dropUndefinedKeys = $56noD.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $56noD.extractExceptionKeysForMessage;
module.exports.fill = $56noD.fill;
module.exports.getOriginalFunction = $56noD.getOriginalFunction;
module.exports.markFunctionWrapped = $56noD.markFunctionWrapped;
module.exports.objectify = $56noD.objectify;
module.exports.basename = $iBZic.basename;
module.exports.dirname = $iBZic.dirname;
module.exports.isAbsolute = $iBZic.isAbsolute;
module.exports.join = $iBZic.join;
module.exports.normalizePath = $iBZic.normalizePath;
module.exports.relative = $iBZic.relative;
module.exports.resolve = $iBZic.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $hRFVl.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $hRFVl.makePromiseBuffer;
module.exports.severityLevelFromString = $iN4A1.severityLevelFromString;
module.exports.replaceExports = $9Gk1l.replaceExports;
module.exports.UNKNOWN_FUNCTION = $aWndQ.UNKNOWN_FUNCTION;
module.exports.createStackParser = $aWndQ.createStackParser;
module.exports.getFramesFromEvent = $aWndQ.getFramesFromEvent;
module.exports.getFunctionName = $aWndQ.getFunctionName;
module.exports.stackParserFromStackParserOptions = $aWndQ.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $aWndQ.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $2b0FU.isMatchingPattern;
module.exports.safeJoin = $2b0FU.safeJoin;
module.exports.snipLine = $2b0FU.snipLine;
module.exports.stringMatchesSomePattern = $2b0FU.stringMatchesSomePattern;
module.exports.truncate = $2b0FU.truncate;
module.exports.isNativeFunction = $55Yug.isNativeFunction;
module.exports.supportsDOMError = $55Yug.supportsDOMError;
module.exports.supportsDOMException = $55Yug.supportsDOMException;
module.exports.supportsErrorEvent = $55Yug.supportsErrorEvent;
module.exports.supportsFetch = $55Yug.supportsFetch;
module.exports.supportsHistory = $55Yug.supportsHistory;
module.exports.supportsNativeFetch = $55Yug.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $55Yug.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $55Yug.supportsReportingObserver;
module.exports.SyncPromise = $bxNZo.SyncPromise;
module.exports.rejectedSyncPromise = $bxNZo.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $bxNZo.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $gQok6.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $gQok6.dateTimestampInSeconds;
module.exports.timestampInSeconds = $gQok6.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $8pUWd.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $8pUWd.extractTraceparentData;
module.exports.generateSentryTraceHeader = $8pUWd.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $8pUWd.generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $8pUWd.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $8pUWd.shouldContinueTrace;
module.exports.getSDKSource = $94dSL.getSDKSource;
module.exports.isBrowserBundle = $94dSL.isBrowserBundle;
module.exports.addItemToEnvelope = $dQ0Qv.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $dQ0Qv.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $dQ0Qv.createEnvelope;
module.exports.createEventEnvelopeHeaders = $dQ0Qv.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $dQ0Qv.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $dQ0Qv.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $dQ0Qv.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $dQ0Qv.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $dQ0Qv.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $dQ0Qv.parseEnvelope;
module.exports.serializeEnvelope = $dQ0Qv.serializeEnvelope;
module.exports.createClientReportEnvelope = $2NgE3.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $1NysQ.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $1NysQ.disabledUntil;
module.exports.isRateLimited = $1NysQ.isRateLimited;
module.exports.parseRetryAfterHeader = $1NysQ.parseRetryAfterHeader;
module.exports.updateRateLimits = $1NysQ.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $OCsCD.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $OCsCD.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $OCsCD.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $OCsCD.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $OCsCD.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $OCsCD.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $OCsCD.objectToBaggageHeader;
module.exports.parseBaggageHeader = $OCsCD.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $5xKoA.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $5xKoA.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $5xKoA.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $5xKoA.isURLObjectRelative;
module.exports.parseStringToURLObject = $5xKoA.parseStringToURLObject;
module.exports.parseUrl = $5xKoA.parseUrl;
module.exports.stripDataUrlContent = $5xKoA.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $5xKoA.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $dtwvq._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $dtwvq.eventFromMessage;
module.exports.eventFromUnknownInput = $dtwvq.eventFromUnknownInput;
module.exports.exceptionFromError = $dtwvq.exceptionFromError;
module.exports.parseStackFrames = $dtwvq.parseStackFrames;
module.exports.LRUMap = $d2zen.LRUMap;
module.exports.generateSpanId = $3kLni.generateSpanId;
module.exports.generateTraceId = $3kLni.generateTraceId;
module.exports.SDK_VERSION = $6j9aN.SDK_VERSION;
module.exports.getDebugImagesForResources = $bVnNd.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $bVnNd.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $bwY2N.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $cWBJD.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $lc80H.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $lc80H.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $lc80H.withRandomSafeContext;
module.exports.getComponentName = $792Ou.getComponentName;
module.exports.getLocationHref = $792Ou.getLocationHref;
module.exports.htmlTreeAsString = $792Ou.htmlTreeAsString;
module.exports.instrumentLangChainEmbeddings = $hM8bG.instrumentLangChainEmbeddings;

});
parcelRegister("j7HZ4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $lWHPW = parcelRequire("lWHPW");

var $ateCs = parcelRequire("ateCs");

var $jDmhV = parcelRequire("jDmhV");

var $hR4pa = parcelRequire("hR4pa");

var $dAQ6V = parcelRequire("dAQ6V");
let $dec0ca0f59bd0305$var$errorsInstrumented = false;
function $dec0ca0f59bd0305$var$registerSpanErrorInstrumentation() {
    if ($dec0ca0f59bd0305$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = $hR4pa.getActiveSpan();
        const rootSpan = activeSpan && $hR4pa.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $dAQ6V.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    $dec0ca0f59bd0305$var$errorsInstrumented = true;
    $lWHPW.addGlobalErrorInstrumentationHandler(errorCallback);
    $ateCs.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $dec0ca0f59bd0305$var$registerSpanErrorInstrumentation;

});
parcelRegister("cWDS7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $96c9d48ef2a13188$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $96c9d48ef2a13188$var$DEBUG_BUILD;

});

parcelRegister("lWHPW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $NKzWo = parcelRequire("NKzWo");

var $ljaTH = parcelRequire("ljaTH");
let $ffa104d88e040320$var$_oldOnErrorHandler = null;
function $ffa104d88e040320$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    $ljaTH.addHandler(type, handler);
    $ljaTH.maybeInstrument(type, $ffa104d88e040320$var$instrumentError);
}
function $ffa104d88e040320$var$instrumentError() {
    $ffa104d88e040320$var$_oldOnErrorHandler = $NKzWo.GLOBAL_OBJ.onerror;
    $NKzWo.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $ljaTH.triggerHandlers("error", handlerData);
        if ($ffa104d88e040320$var$_oldOnErrorHandler) return $ffa104d88e040320$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $NKzWo.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $ffa104d88e040320$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("NKzWo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $0958b5469143dc5a$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $0958b5469143dc5a$var$GLOBAL_OBJ;

});

parcelRegister("ljaTH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $aWndQ = parcelRequire("aWndQ");
const $f833d35019123616$var$handlers = {};
const $f833d35019123616$var$instrumented = {};
function $f833d35019123616$var$addHandler(type, handler) {
    $f833d35019123616$var$handlers[type] = $f833d35019123616$var$handlers[type] || [];
    $f833d35019123616$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $f833d35019123616$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $f833d35019123616$var$resetInstrumentationHandlers() {
    Object.keys($f833d35019123616$var$handlers).forEach((key)=>{
        $f833d35019123616$var$handlers[key] = void 0;
    });
}
function $f833d35019123616$var$maybeInstrument(type, instrumentFn) {
    if (!$f833d35019123616$var$instrumented[type]) {
        $f833d35019123616$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $f833d35019123616$var$triggerHandlers(type, data) {
    const typeHandlers = type && $f833d35019123616$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${$aWndQ.getFunctionName(handler)}
Error:`, e);
    }
}
module.exports.addHandler = $f833d35019123616$var$addHandler;
module.exports.maybeInstrument = $f833d35019123616$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $f833d35019123616$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $f833d35019123616$var$triggerHandlers;

});
parcelRegister("jDmhV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kJVFD = parcelRequire("kJVFD");

var $cWDS7 = parcelRequire("cWDS7");

var $NKzWo = parcelRequire("NKzWo");
const $e4b2f2ccdc1916e2$var$CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $e4b2f2ccdc1916e2$var$PREFIX = "Sentry Logger ";
const $e4b2f2ccdc1916e2$var$originalConsoleMethods = {};
function $e4b2f2ccdc1916e2$var$consoleSandbox(callback) {
    if (!("console" in $NKzWo.GLOBAL_OBJ)) return callback();
    const console = $NKzWo.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($e4b2f2ccdc1916e2$var$originalConsoleMethods);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $e4b2f2ccdc1916e2$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $e4b2f2ccdc1916e2$var$enable() {
    $e4b2f2ccdc1916e2$var$_getLoggerSettings().enabled = true;
}
function $e4b2f2ccdc1916e2$var$disable() {
    $e4b2f2ccdc1916e2$var$_getLoggerSettings().enabled = false;
}
function $e4b2f2ccdc1916e2$var$isEnabled() {
    return $e4b2f2ccdc1916e2$var$_getLoggerSettings().enabled;
}
function $e4b2f2ccdc1916e2$var$log(...args) {
    $e4b2f2ccdc1916e2$var$_maybeLog("log", ...args);
}
function $e4b2f2ccdc1916e2$var$warn(...args) {
    $e4b2f2ccdc1916e2$var$_maybeLog("warn", ...args);
}
function $e4b2f2ccdc1916e2$var$error(...args) {
    $e4b2f2ccdc1916e2$var$_maybeLog("error", ...args);
}
function $e4b2f2ccdc1916e2$var$_maybeLog(level, ...args) {
    if (!$cWDS7.DEBUG_BUILD) return;
    if ($e4b2f2ccdc1916e2$var$isEnabled()) $e4b2f2ccdc1916e2$var$consoleSandbox(()=>{
        $NKzWo.GLOBAL_OBJ.console[level](`${$e4b2f2ccdc1916e2$var$PREFIX}[${level}]:`, ...args);
    });
}
function $e4b2f2ccdc1916e2$var$_getLoggerSettings() {
    if (!$cWDS7.DEBUG_BUILD) return {
        enabled: false
    };
    return $kJVFD.getGlobalSingleton("loggerSettings", ()=>({
            enabled: false
        }));
}
const $e4b2f2ccdc1916e2$var$debug = {
    enable: /** Enable logging. */ $e4b2f2ccdc1916e2$var$enable,
    disable: /** Disable logging. */ $e4b2f2ccdc1916e2$var$disable,
    isEnabled: /** Check if logging is enabled. */ $e4b2f2ccdc1916e2$var$isEnabled,
    log: /** Log a message. */ $e4b2f2ccdc1916e2$var$log,
    warn: /** Log a warning. */ $e4b2f2ccdc1916e2$var$warn,
    error: /** Log an error. */ $e4b2f2ccdc1916e2$var$error
};
module.exports.CONSOLE_LEVELS = $e4b2f2ccdc1916e2$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $e4b2f2ccdc1916e2$var$consoleSandbox;
module.exports.debug = $e4b2f2ccdc1916e2$var$debug;
module.exports.originalConsoleMethods = $e4b2f2ccdc1916e2$var$originalConsoleMethods;

});
parcelRegister("kJVFD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6j9aN = parcelRequire("6j9aN");

var $NKzWo = parcelRequire("NKzWo");
function $f194bec2106893bd$var$getMainCarrier() {
    $f194bec2106893bd$var$getSentryCarrier($NKzWo.GLOBAL_OBJ);
    return $NKzWo.GLOBAL_OBJ;
}
function $f194bec2106893bd$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || $6j9aN.SDK_VERSION;
    return __SENTRY__[$6j9aN.SDK_VERSION] = __SENTRY__[$6j9aN.SDK_VERSION] || {};
}
function $f194bec2106893bd$var$getGlobalSingleton(name, creator, obj = $NKzWo.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$6j9aN.SDK_VERSION] = __SENTRY__[$6j9aN.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $f194bec2106893bd$var$getGlobalSingleton;
module.exports.getMainCarrier = $f194bec2106893bd$var$getMainCarrier;
module.exports.getSentryCarrier = $f194bec2106893bd$var$getSentryCarrier;

});
parcelRegister("6j9aN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $497ba1ffe0ec8735$var$SDK_VERSION = "10.56.0";
module.exports.SDK_VERSION = $497ba1ffe0ec8735$var$SDK_VERSION;

});



parcelRegister("aWndQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $7f71559b170befbc$var$STACKTRACE_FRAME_LIMIT = 50;
const $7f71559b170befbc$var$UNKNOWN_FUNCTION = "?";
const $7f71559b170befbc$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $7f71559b170befbc$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $7f71559b170befbc$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $7f71559b170befbc$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($7f71559b170befbc$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $7f71559b170befbc$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $7f71559b170befbc$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
function $7f71559b170befbc$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $7f71559b170befbc$var$createStackParser(...stackParser);
    return stackParser;
}
function $7f71559b170befbc$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($7f71559b170befbc$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($7f71559b170befbc$var$STRIP_FRAME_REGEXP.test($7f71559b170befbc$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($7f71559b170befbc$var$STRIP_FRAME_REGEXP.test($7f71559b170befbc$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $7f71559b170befbc$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $7f71559b170befbc$var$getLastStackFrame(localStack).filename,
            function: frame.function || $7f71559b170befbc$var$UNKNOWN_FUNCTION
        }));
}
function $7f71559b170befbc$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $7f71559b170befbc$var$defaultFunctionName = "<anonymous>";
function $7f71559b170befbc$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return $7f71559b170befbc$var$defaultFunctionName;
        return fn.name || $7f71559b170befbc$var$defaultFunctionName;
    } catch  {
        return $7f71559b170befbc$var$defaultFunctionName;
    }
}
function $7f71559b170befbc$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $7f71559b170befbc$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $7f71559b170befbc$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $7f71559b170befbc$var$createStackParser;
module.exports.getFramesFromEvent = $7f71559b170befbc$var$getFramesFromEvent;
module.exports.getFunctionName = $7f71559b170befbc$var$getFunctionName;
module.exports.normalizeStackTracePath = $7f71559b170befbc$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $7f71559b170befbc$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $7f71559b170befbc$var$stripSentryFramesAndReverse;

});



parcelRegister("ateCs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $NKzWo = parcelRequire("NKzWo");

var $ljaTH = parcelRequire("ljaTH");
let $79f7f3e7e72ed4bb$var$_oldOnUnhandledRejectionHandler = null;
function $79f7f3e7e72ed4bb$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    $ljaTH.addHandler(type, handler);
    $ljaTH.maybeInstrument(type, $79f7f3e7e72ed4bb$var$instrumentUnhandledRejection);
}
function $79f7f3e7e72ed4bb$var$instrumentUnhandledRejection() {
    $79f7f3e7e72ed4bb$var$_oldOnUnhandledRejectionHandler = $NKzWo.GLOBAL_OBJ.onunhandledrejection;
    $NKzWo.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $ljaTH.triggerHandlers("unhandledrejection", handlerData);
        if ($79f7f3e7e72ed4bb$var$_oldOnUnhandledRejectionHandler) return $79f7f3e7e72ed4bb$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $NKzWo.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $79f7f3e7e72ed4bb$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("hR4pa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JduQ = parcelRequire("2JduQ");

var $gLiBf = parcelRequire("gLiBf");

var $kJVFD = parcelRequire("kJVFD");

var $k1IvE = parcelRequire("k1IvE");

var $7nMWX = parcelRequire("7nMWX");

var $dAQ6V = parcelRequire("dAQ6V");

var $33FUD = parcelRequire("33FUD");

var $56noD = parcelRequire("56noD");

var $3kLni = parcelRequire("3kLni");

var $gQok6 = parcelRequire("gQok6");

var $8pUWd = parcelRequire("8pUWd");

var $jDmhV = parcelRequire("jDmhV");

var $43BuU = parcelRequire("43BuU");
const $cffacd9e684d568e$var$TRACE_FLAG_NONE = 0;
const $cffacd9e684d568e$var$TRACE_FLAG_SAMPLED = 1;
let $cffacd9e684d568e$var$hasShownSpanDropWarning = false;
function $cffacd9e684d568e$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $cffacd9e684d568e$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $cffacd9e684d568e$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $cffacd9e684d568e$var$spanToJSON(span).parent_span_id;
    const scope = $33FUD.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $3kLni.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $cffacd9e684d568e$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $cffacd9e684d568e$var$spanIsSampled(span);
    return $8pUWd.generateSentryTraceHeader(traceId, spanId, sampled);
}
function $cffacd9e684d568e$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $cffacd9e684d568e$var$spanIsSampled(span);
    return $8pUWd.generateTraceparentHeader(traceId, spanId, sampled);
}
function $cffacd9e684d568e$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $cffacd9e684d568e$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $cffacd9e684d568e$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $cffacd9e684d568e$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return void 0;
}
function $cffacd9e684d568e$var$spanTimeInputToSeconds(input) {
    if (typeof input === "number") return $cffacd9e684d568e$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $cffacd9e684d568e$var$ensureTimestampInSeconds(input.getTime());
    return $gQok6.timestampInSeconds();
}
function $cffacd9e684d568e$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $cffacd9e684d568e$var$spanToJSON(span) {
    if ($cffacd9e684d568e$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($cffacd9e684d568e$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $cffacd9e684d568e$var$getOtelParentSpanId(span),
            start_timestamp: $cffacd9e684d568e$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $cffacd9e684d568e$var$spanTimeInputToSeconds(endTime) || void 0,
            status: $cffacd9e684d568e$var$getStatusMessage(status),
            op: attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $cffacd9e684d568e$var$convertSpanLinksForEnvelope(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $cffacd9e684d568e$var$spanToStreamedSpanJSON(span) {
    if ($cffacd9e684d568e$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($cffacd9e684d568e$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $cffacd9e684d568e$var$getOtelParentSpanId(span),
            start_timestamp: $cffacd9e684d568e$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $cffacd9e684d568e$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $cffacd9e684d568e$var$INTERNAL_getSegmentSpan(span),
            status: $cffacd9e684d568e$var$getSimpleStatusMessage(status),
            attributes: attributes,
            links: $cffacd9e684d568e$var$getStreamedSpanLinks(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $cffacd9e684d568e$var$INTERNAL_getSegmentSpan(span)
    };
}
function $cffacd9e684d568e$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $cffacd9e684d568e$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $gLiBf.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $gLiBf.serializeAttributes(link.attributes)
            }))
    };
}
function $cffacd9e684d568e$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $cffacd9e684d568e$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $cffacd9e684d568e$var$spanIsSampled(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $cffacd9e684d568e$var$TRACE_FLAG_SAMPLED;
}
function $cffacd9e684d568e$var$getStatusMessage(status) {
    if (!status || status.code === $dAQ6V.SPAN_STATUS_UNSET) return void 0;
    if (status.code === $dAQ6V.SPAN_STATUS_OK) return "ok";
    return status.message || "internal_error";
}
function $cffacd9e684d568e$var$getSimpleStatusMessage(status) {
    return !status || status.code === $dAQ6V.SPAN_STATUS_OK || status.code === $dAQ6V.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
}
const $cffacd9e684d568e$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $cffacd9e684d568e$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $cffacd9e684d568e$var$addChildSpanToSpan(span, childSpan) {
    const rootSpan = span[$cffacd9e684d568e$var$ROOT_SPAN_FIELD] || span;
    $56noD.addNonEnumerableProperty(childSpan, $cffacd9e684d568e$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$cffacd9e684d568e$var$CHILD_SPANS_FIELD]) span[$cffacd9e684d568e$var$CHILD_SPANS_FIELD].add(childSpan);
    else $56noD.addNonEnumerableProperty(span, $cffacd9e684d568e$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $cffacd9e684d568e$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$cffacd9e684d568e$var$CHILD_SPANS_FIELD]) span[$cffacd9e684d568e$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $cffacd9e684d568e$var$getSpanDescendants(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($cffacd9e684d568e$var$spanIsSampled(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$cffacd9e684d568e$var$CHILD_SPANS_FIELD] ? Array.from(span2[$cffacd9e684d568e$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $cffacd9e684d568e$var$getRootSpan = $cffacd9e684d568e$var$INTERNAL_getSegmentSpan;
function $cffacd9e684d568e$var$INTERNAL_getSegmentSpan(span) {
    return span[$cffacd9e684d568e$var$ROOT_SPAN_FIELD] || span;
}
function $cffacd9e684d568e$var$getActiveSpan() {
    const carrier$1 = $kJVFD.getMainCarrier();
    const acs = $2JduQ.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $43BuU._getSpanForScope($k1IvE.getCurrentScope());
}
function $cffacd9e684d568e$var$showSpanDropWarning() {
    if (!$cffacd9e684d568e$var$hasShownSpanDropWarning) {
        $jDmhV.consoleSandbox(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $cffacd9e684d568e$var$hasShownSpanDropWarning = true;
    }
}
function $cffacd9e684d568e$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $cffacd9e684d568e$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $cffacd9e684d568e$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $cffacd9e684d568e$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $cffacd9e684d568e$var$addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $cffacd9e684d568e$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $cffacd9e684d568e$var$getActiveSpan;
module.exports.getRootSpan = $cffacd9e684d568e$var$getRootSpan;
module.exports.getSimpleStatusMessage = $cffacd9e684d568e$var$getSimpleStatusMessage;
module.exports.getSpanDescendants = $cffacd9e684d568e$var$getSpanDescendants;
module.exports.getStatusMessage = $cffacd9e684d568e$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $cffacd9e684d568e$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $cffacd9e684d568e$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $cffacd9e684d568e$var$showSpanDropWarning;
module.exports.spanIsSampled = $cffacd9e684d568e$var$spanIsSampled;
module.exports.spanTimeInputToSeconds = $cffacd9e684d568e$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $cffacd9e684d568e$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $cffacd9e684d568e$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $cffacd9e684d568e$var$spanToTraceContext;
module.exports.spanToTraceHeader = $cffacd9e684d568e$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $cffacd9e684d568e$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $cffacd9e684d568e$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $cffacd9e684d568e$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $cffacd9e684d568e$var$updateSpanName;

});
parcelRegister("2JduQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kJVFD = parcelRequire("kJVFD");

var $1eswV = parcelRequire("1eswV");
function $1fca40e231344d6b$var$setAsyncContextStrategy(strategy) {
    const registry = $kJVFD.getMainCarrier();
    const sentry = $kJVFD.getSentryCarrier(registry);
    sentry.acs = strategy;
}
function $1fca40e231344d6b$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $kJVFD.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    return $1eswV.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $1fca40e231344d6b$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $1fca40e231344d6b$var$setAsyncContextStrategy;

});
parcelRegister("1eswV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8cDmr = parcelRequire("8cDmr");

var $logAX = parcelRequire("logAX");

var $6hZKT = parcelRequire("6hZKT");

var $jm1F1 = parcelRequire("jm1F1");

var $kJVFD = parcelRequire("kJVFD");
class $0e5d3ab675e9f4bf$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $logAX.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $logAX.Scope();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($jm1F1.isThenable(maybePromiseResult)) return $6hZKT.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $0e5d3ab675e9f4bf$var$getAsyncContextStack() {
    const registry = $kJVFD.getMainCarrier();
    const sentry = $kJVFD.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $0e5d3ab675e9f4bf$var$AsyncContextStack($8cDmr.getDefaultCurrentScope(), $8cDmr.getDefaultIsolationScope());
}
function $0e5d3ab675e9f4bf$var$withScope(callback) {
    return $0e5d3ab675e9f4bf$var$getAsyncContextStack().withScope(callback);
}
function $0e5d3ab675e9f4bf$var$withSetScope(scope, callback) {
    const stack = $0e5d3ab675e9f4bf$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $0e5d3ab675e9f4bf$var$withIsolationScope(callback) {
    return $0e5d3ab675e9f4bf$var$getAsyncContextStack().withScope(()=>{
        return callback($0e5d3ab675e9f4bf$var$getAsyncContextStack().getIsolationScope());
    });
}
function $0e5d3ab675e9f4bf$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $0e5d3ab675e9f4bf$var$withIsolationScope,
        withScope: $0e5d3ab675e9f4bf$var$withScope,
        withSetScope: $0e5d3ab675e9f4bf$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $0e5d3ab675e9f4bf$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$0e5d3ab675e9f4bf$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$0e5d3ab675e9f4bf$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $0e5d3ab675e9f4bf$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $0e5d3ab675e9f4bf$var$getStackAsyncContextStrategy;

});
parcelRegister("8cDmr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kJVFD = parcelRequire("kJVFD");

var $logAX = parcelRequire("logAX");
function $5f8df9f8cd989463$var$getDefaultCurrentScope() {
    return $kJVFD.getGlobalSingleton("defaultCurrentScope", ()=>new $logAX.Scope());
}
function $5f8df9f8cd989463$var$getDefaultIsolationScope() {
    return $kJVFD.getGlobalSingleton("defaultIsolationScope", ()=>new $logAX.Scope());
}
module.exports.getDefaultCurrentScope = $5f8df9f8cd989463$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $5f8df9f8cd989463$var$getDefaultIsolationScope;

});
parcelRegister("logAX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $j3gO3 = parcelRequire("j3gO3");

var $jDmhV = parcelRequire("jDmhV");

var $jm1F1 = parcelRequire("jm1F1");

var $6aWHc = parcelRequire("6aWHc");

var $aNZ1M = parcelRequire("aNZ1M");

var $3kLni = parcelRequire("3kLni");

var $lc80H = parcelRequire("lc80H");

var $43BuU = parcelRequire("43BuU");

var $2b0FU = parcelRequire("2b0FU");

var $gQok6 = parcelRequire("gQok6");
const $f928b64e9e42409a$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $f928b64e9e42409a$var$Scope {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $3kLni.generateTraceId(),
            sampleRand: $lc80H.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $f928b64e9e42409a$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $43BuU._setSpanForScope(newScope, $43BuU._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) $j3gO3.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $f928b64e9e42409a$var$Scope ? scopeToMerge.getScopeData() : $jm1F1.isPlainObject(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        $43BuU._setSpanForScope(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $3kLni.generateTraceId(),
            sampleRand: $lc80H.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $f928b64e9e42409a$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $gQok6.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $2b0FU.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $43BuU._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $6aWHc.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $aNZ1M.uuid4();
        if (!this._client) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $aNZ1M.uuid4();
        if (!this._client) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $aNZ1M.uuid4();
        if (!this._client) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $f928b64e9e42409a$var$Scope;

});
parcelRegister("j3gO3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aNZ1M = parcelRequire("aNZ1M");

var $gQok6 = parcelRequire("gQok6");
function $ddeb5588dbb82de6$var$makeSession(context) {
    const startingTime = $gQok6.timestampInSeconds();
    const session = {
        sid: $aNZ1M.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ddeb5588dbb82de6$var$sessionToJSON(session)
    };
    if (context) $ddeb5588dbb82de6$var$updateSession(session, context);
    return session;
}
function $ddeb5588dbb82de6$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $gQok6.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : $aNZ1M.uuid4();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $ddeb5588dbb82de6$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $ddeb5588dbb82de6$var$updateSession(session, context);
}
function $ddeb5588dbb82de6$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $ddeb5588dbb82de6$var$closeSession;
module.exports.makeSession = $ddeb5588dbb82de6$var$makeSession;
module.exports.updateSession = $ddeb5588dbb82de6$var$updateSession;

});
parcelRegister("aNZ1M", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $56noD = parcelRequire("56noD");

var $lc80H = parcelRequire("lc80H");

var $2b0FU = parcelRequire("2b0FU");

var $NKzWo = parcelRequire("NKzWo");
function $7dddd1d5e7fd8e29$var$getCrypto() {
    const gbl = $NKzWo.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $7dddd1d5e7fd8e29$var$emptyUuid;
function $7dddd1d5e7fd8e29$var$getRandomByte() {
    return $lc80H.safeMathRandom() * 16;
}
function $7dddd1d5e7fd8e29$var$uuid4(crypto = $7dddd1d5e7fd8e29$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return $lc80H.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$7dddd1d5e7fd8e29$var$emptyUuid) $7dddd1d5e7fd8e29$var$emptyUuid = "10000000100040008000100000000000";
    return $7dddd1d5e7fd8e29$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($7dddd1d5e7fd8e29$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $7dddd1d5e7fd8e29$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $7dddd1d5e7fd8e29$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $7dddd1d5e7fd8e29$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $7dddd1d5e7fd8e29$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $7dddd1d5e7fd8e29$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $7dddd1d5e7fd8e29$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $7dddd1d5e7fd8e29$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $7dddd1d5e7fd8e29$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $7dddd1d5e7fd8e29$var$parseSemver(input) {
    const match = input.match($7dddd1d5e7fd8e29$var$SEMVER_REGEXP) || [];
    const major = $7dddd1d5e7fd8e29$var$_parseInt(match[1]);
    const minor = $7dddd1d5e7fd8e29$var$_parseInt(match[2]);
    const patch = $7dddd1d5e7fd8e29$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $7dddd1d5e7fd8e29$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$2b0FU.snipLine(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = $2b0FU.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$2b0FU.snipLine(line, 0));
}
function $7dddd1d5e7fd8e29$var$checkOrSetAlreadyCaught(exception) {
    if ($7dddd1d5e7fd8e29$var$isAlreadyCaptured(exception)) return true;
    try {
        $56noD.addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $7dddd1d5e7fd8e29$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}
module.exports.addContextToFrame = $7dddd1d5e7fd8e29$var$addContextToFrame;
module.exports.addExceptionMechanism = $7dddd1d5e7fd8e29$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $7dddd1d5e7fd8e29$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $7dddd1d5e7fd8e29$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $7dddd1d5e7fd8e29$var$getEventDescription;
module.exports.isAlreadyCaptured = $7dddd1d5e7fd8e29$var$isAlreadyCaptured;
module.exports.parseSemver = $7dddd1d5e7fd8e29$var$parseSemver;
module.exports.uuid4 = $7dddd1d5e7fd8e29$var$uuid4;

});
parcelRegister("56noD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $jm1F1 = parcelRequire("jm1F1");
function $3b6fa950a889266c$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $3b6fa950a889266c$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
function $3b6fa950a889266c$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $3b6fa950a889266c$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $3b6fa950a889266c$var$addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $3b6fa950a889266c$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($3b6fa950a889266c$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $3b6fa950a889266c$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $3b6fa950a889266c$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
function $3b6fa950a889266c$var$convertToPlainObject(value) {
    if ($jm1F1.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$3b6fa950a889266c$var$getOwnProperties(value)
    };
    if ($jm1F1.isEvent(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$3b6fa950a889266c$var$getOwnProperties(value)
        };
    }
    return value;
}
function $3b6fa950a889266c$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $3b6fa950a889266c$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($3b6fa950a889266c$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $3b6fa950a889266c$var$dropUndefinedKeys(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $3b6fa950a889266c$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $3b6fa950a889266c$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($3b6fa950a889266c$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($3b6fa950a889266c$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $3b6fa950a889266c$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $3b6fa950a889266c$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $3b6fa950a889266c$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $jm1F1.isPrimitive(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $3b6fa950a889266c$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $3b6fa950a889266c$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $3b6fa950a889266c$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $3b6fa950a889266c$var$extractExceptionKeysForMessage;
module.exports.fill = $3b6fa950a889266c$var$fill;
module.exports.getOriginalFunction = $3b6fa950a889266c$var$getOriginalFunction;
module.exports.markFunctionWrapped = $3b6fa950a889266c$var$markFunctionWrapped;
module.exports.objectify = $3b6fa950a889266c$var$objectify;
module.exports.wrapMethod = $3b6fa950a889266c$var$wrapMethod;

});
parcelRegister("jm1F1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e1715c30174a465e$var$objectToString = Object.prototype.toString;
function $e1715c30174a465e$var$isError(wat) {
    switch($e1715c30174a465e$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $e1715c30174a465e$var$isInstanceOf(wat, Error);
    }
}
function $e1715c30174a465e$var$isBuiltin(wat, className) {
    return $e1715c30174a465e$var$objectToString.call(wat) === `[object ${className}]`;
}
function $e1715c30174a465e$var$isErrorEvent(wat) {
    return $e1715c30174a465e$var$isBuiltin(wat, "ErrorEvent");
}
function $e1715c30174a465e$var$isDOMError(wat) {
    return $e1715c30174a465e$var$isBuiltin(wat, "DOMError");
}
function $e1715c30174a465e$var$isDOMException(wat) {
    return $e1715c30174a465e$var$isBuiltin(wat, "DOMException");
}
function $e1715c30174a465e$var$isString(wat) {
    return $e1715c30174a465e$var$isBuiltin(wat, "String");
}
function $e1715c30174a465e$var$isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $e1715c30174a465e$var$isPrimitive(wat) {
    return wat === null || $e1715c30174a465e$var$isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $e1715c30174a465e$var$isPlainObject(wat) {
    return $e1715c30174a465e$var$isBuiltin(wat, "Object");
}
function $e1715c30174a465e$var$isEvent(wat) {
    return typeof Event !== "undefined" && $e1715c30174a465e$var$isInstanceOf(wat, Event);
}
function $e1715c30174a465e$var$isElement(wat) {
    return typeof Element !== "undefined" && $e1715c30174a465e$var$isInstanceOf(wat, Element);
}
function $e1715c30174a465e$var$isRegExp(wat) {
    return $e1715c30174a465e$var$isBuiltin(wat, "RegExp");
}
function $e1715c30174a465e$var$isThenable(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $e1715c30174a465e$var$isSyntheticEvent(wat) {
    return $e1715c30174a465e$var$isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $e1715c30174a465e$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $e1715c30174a465e$var$isVueViewModel(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $e1715c30174a465e$var$isRequest(request) {
    return typeof Request !== "undefined" && $e1715c30174a465e$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $e1715c30174a465e$var$isDOMError;
module.exports.isDOMException = $e1715c30174a465e$var$isDOMException;
module.exports.isElement = $e1715c30174a465e$var$isElement;
module.exports.isError = $e1715c30174a465e$var$isError;
module.exports.isErrorEvent = $e1715c30174a465e$var$isErrorEvent;
module.exports.isEvent = $e1715c30174a465e$var$isEvent;
module.exports.isInstanceOf = $e1715c30174a465e$var$isInstanceOf;
module.exports.isParameterizedString = $e1715c30174a465e$var$isParameterizedString;
module.exports.isPlainObject = $e1715c30174a465e$var$isPlainObject;
module.exports.isPrimitive = $e1715c30174a465e$var$isPrimitive;
module.exports.isRegExp = $e1715c30174a465e$var$isRegExp;
module.exports.isRequest = $e1715c30174a465e$var$isRequest;
module.exports.isString = $e1715c30174a465e$var$isString;
module.exports.isSyntheticEvent = $e1715c30174a465e$var$isSyntheticEvent;
module.exports.isThenable = $e1715c30174a465e$var$isThenable;
module.exports.isVueViewModel = $e1715c30174a465e$var$isVueViewModel;

});


parcelRegister("lc80H", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $NKzWo = parcelRequire("NKzWo");
let $f6e0eea8676dadab$var$RESOLVED_RUNNER;
function $f6e0eea8676dadab$var$withRandomSafeContext(cb) {
    if ($f6e0eea8676dadab$var$RESOLVED_RUNNER !== void 0) return $f6e0eea8676dadab$var$RESOLVED_RUNNER ? $f6e0eea8676dadab$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = $NKzWo.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $f6e0eea8676dadab$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $f6e0eea8676dadab$var$RESOLVED_RUNNER(cb);
    }
    $f6e0eea8676dadab$var$RESOLVED_RUNNER = null;
    return cb();
}
function $f6e0eea8676dadab$var$safeMathRandom() {
    return $f6e0eea8676dadab$var$withRandomSafeContext(()=>Math.random());
}
function $f6e0eea8676dadab$var$safeDateNow() {
    return $f6e0eea8676dadab$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $f6e0eea8676dadab$var$safeDateNow;
module.exports.safeMathRandom = $f6e0eea8676dadab$var$safeMathRandom;
module.exports.withRandomSafeContext = $f6e0eea8676dadab$var$withRandomSafeContext;

});

parcelRegister("2b0FU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jm1F1 = parcelRequire("jm1F1");

var $04GFW = parcelRequire("04GFW");
function $195d21e44ba6e9d1$var$truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $195d21e44ba6e9d1$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $195d21e44ba6e9d1$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ($jm1F1.isPrimitive(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push($04GFW.stringifyValue(void 0, value));
    }
    return output.join(delimiter);
}
function $195d21e44ba6e9d1$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$jm1F1.isString(value)) return false;
    if ($jm1F1.isRegExp(pattern)) return pattern.test(value);
    if ($jm1F1.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $195d21e44ba6e9d1$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($195d21e44ba6e9d1$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $195d21e44ba6e9d1$var$isMatchingPattern;
module.exports.safeJoin = $195d21e44ba6e9d1$var$safeJoin;
module.exports.snipLine = $195d21e44ba6e9d1$var$snipLine;
module.exports.stringMatchesSomePattern = $195d21e44ba6e9d1$var$stringMatchesSomePattern;
module.exports.truncate = $195d21e44ba6e9d1$var$truncate;

});
parcelRegister("04GFW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3I8lv = parcelRequire("3I8lv");

var $56noD = parcelRequire("56noD");

var $aWndQ = parcelRequire("aWndQ");
let $00e17a4b7b08d67d$var$stringifier;
function $00e17a4b7b08d67d$var$setNormalizeStringifier(newStringifier) {
    $00e17a4b7b08d67d$var$stringifier = newStringifier;
}
function $00e17a4b7b08d67d$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        return $00e17a4b7b08d67d$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $00e17a4b7b08d67d$var$normalizeToSize(object, depth = 3, maxSize = 102400) {
    const normalized = $00e17a4b7b08d67d$var$normalize(object, depth);
    if ($00e17a4b7b08d67d$var$jsonSize(normalized) > maxSize) return $00e17a4b7b08d67d$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
function $00e17a4b7b08d67d$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $00e17a4b7b08d67d$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $00e17a4b7b08d67d$var$stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ($3I8lv.hasSkipNormalizationHint(value)) return value;
    const overrideDepth = $3I8lv.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $00e17a4b7b08d67d$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = $56noD.convertToPlainObject(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $00e17a4b7b08d67d$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $00e17a4b7b08d67d$var$stringifyValue(key, value) {
    try {
        if ($00e17a4b7b08d67d$var$stringifier) {
            const stringified = $00e17a4b7b08d67d$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${$aWndQ.getFunctionName(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $00e17a4b7b08d67d$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $00e17a4b7b08d67d$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $00e17a4b7b08d67d$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $00e17a4b7b08d67d$var$jsonSize(value) {
    return $00e17a4b7b08d67d$var$utf8Length(JSON.stringify(value));
}
function $00e17a4b7b08d67d$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $00e17a4b7b08d67d$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $00e17a4b7b08d67d$var$normalize;
module.exports.normalizeToSize = $00e17a4b7b08d67d$var$normalizeToSize;
module.exports.normalizeUrlToBase = $00e17a4b7b08d67d$var$normalizeUrlToBase;
module.exports.setNormalizeStringifier = $00e17a4b7b08d67d$var$setNormalizeStringifier;
module.exports.stringifyValue = $00e17a4b7b08d67d$var$stringifyValue;

});
parcelRegister("3I8lv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $56noD = parcelRequire("56noD");
const $2b3bf475ef8c4fc1$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $2b3bf475ef8c4fc1$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $2b3bf475ef8c4fc1$var$setSkipNormalizationHint(obj) {
    $56noD.addNonEnumerableProperty(obj, $2b3bf475ef8c4fc1$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $2b3bf475ef8c4fc1$var$setNormalizationDepthOverrideHint(obj, depth) {
    $56noD.addNonEnumerableProperty(obj, $2b3bf475ef8c4fc1$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $2b3bf475ef8c4fc1$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$2b3bf475ef8c4fc1$var$SENTRY_SKIP_NORMALIZATION]);
}
function $2b3bf475ef8c4fc1$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$2b3bf475ef8c4fc1$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}
module.exports.getNormalizationDepthOverrideHint = $2b3bf475ef8c4fc1$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $2b3bf475ef8c4fc1$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $2b3bf475ef8c4fc1$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $2b3bf475ef8c4fc1$var$setSkipNormalizationHint;

});




parcelRegister("gQok6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lc80H = parcelRequire("lc80H");

var $NKzWo = parcelRequire("NKzWo");
const $c4345ec055232c47$var$ONE_SECOND_IN_MS = 1e3;
function $c4345ec055232c47$var$dateTimestampInSeconds() {
    return $lc80H.safeDateNow() / $c4345ec055232c47$var$ONE_SECOND_IN_MS;
}
function $c4345ec055232c47$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $NKzWo.GLOBAL_OBJ;
    if (!performance?.now || !performance.timeOrigin) return $c4345ec055232c47$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + $lc80H.withRandomSafeContext(()=>performance.now())) / $c4345ec055232c47$var$ONE_SECOND_IN_MS;
    };
}
let $c4345ec055232c47$var$_cachedTimestampInSeconds;
function $c4345ec055232c47$var$timestampInSeconds() {
    const func = $c4345ec055232c47$var$_cachedTimestampInSeconds ?? ($c4345ec055232c47$var$_cachedTimestampInSeconds = $c4345ec055232c47$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $c4345ec055232c47$var$cachedTimeOrigin = null;
function $c4345ec055232c47$var$getBrowserTimeOrigin() {
    const { performance: performance } = $NKzWo.GLOBAL_OBJ;
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = $lc80H.withRandomSafeContext(()=>performance.now());
    const dateNow = $lc80H.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $c4345ec055232c47$var$browserPerformanceTimeOrigin() {
    if ($c4345ec055232c47$var$cachedTimeOrigin === null) $c4345ec055232c47$var$cachedTimeOrigin = $c4345ec055232c47$var$getBrowserTimeOrigin();
    return $c4345ec055232c47$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $c4345ec055232c47$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $c4345ec055232c47$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $c4345ec055232c47$var$timestampInSeconds;

});


parcelRegister("6aWHc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $47f134fccd946747$var$merge(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $47f134fccd946747$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $47f134fccd946747$var$merge;

});

parcelRegister("3kLni", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aNZ1M = parcelRequire("aNZ1M");
function $26d7fcfccafc4849$var$generateTraceId() {
    return $aNZ1M.uuid4();
}
function $26d7fcfccafc4849$var$generateSpanId() {
    return $aNZ1M.uuid4().substring(16);
}
module.exports.generateSpanId = $26d7fcfccafc4849$var$generateSpanId;
module.exports.generateTraceId = $26d7fcfccafc4849$var$generateTraceId;

});

parcelRegister("43BuU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $56noD = parcelRequire("56noD");

var $eDH5Q = parcelRequire("eDH5Q");
const $2f448778be3e0f39$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $2f448778be3e0f39$var$_setSpanForScope(scope, span) {
    if (span) $56noD.addNonEnumerableProperty(scope, $2f448778be3e0f39$var$SCOPE_SPAN_FIELD, $eDH5Q.makeWeakRef(span));
    else delete scope[$2f448778be3e0f39$var$SCOPE_SPAN_FIELD];
}
function $2f448778be3e0f39$var$_getSpanForScope(scope) {
    return $eDH5Q.derefWeakRef(scope[$2f448778be3e0f39$var$SCOPE_SPAN_FIELD]);
}
module.exports._getSpanForScope = $2f448778be3e0f39$var$_getSpanForScope;
module.exports._setSpanForScope = $2f448778be3e0f39$var$_setSpanForScope;

});
parcelRegister("eDH5Q", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $NKzWo = parcelRequire("NKzWo");
function $aa8622a5baf793ae$var$makeWeakRef(value) {
    try {
        const WeakRefImpl = $NKzWo.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $aa8622a5baf793ae$var$derefWeakRef(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}
module.exports.derefWeakRef = $aa8622a5baf793ae$var$derefWeakRef;
module.exports.makeWeakRef = $aa8622a5baf793ae$var$makeWeakRef;

});




parcelRegister("6hZKT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $49443bee5ee14c31$var$isActualPromise = (p)=>p instanceof Promise && !p[$49443bee5ee14c31$var$kChainedCopy];
const $49443bee5ee14c31$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $49443bee5ee14c31$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $49443bee5ee14c31$var$isActualPromise(chained) && $49443bee5ee14c31$var$isActualPromise(original) ? chained : $49443bee5ee14c31$var$copyProps(original, chained);
};
const $49443bee5ee14c31$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$49443bee5ee14c31$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $49443bee5ee14c31$var$chainAndCopyPromiseLike;

});



parcelRegister("gLiBf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jm1F1 = parcelRequire("jm1F1");
function $c33f76a20d9c8a98$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $c33f76a20d9c8a98$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $c33f76a20d9c8a98$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $c33f76a20d9c8a98$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $c33f76a20d9c8a98$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $c33f76a20d9c8a98$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $c33f76a20d9c8a98$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $c33f76a20d9c8a98$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($jm1F1.isPrimitive(val)) weight += $c33f76a20d9c8a98$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $c33f76a20d9c8a98$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $c33f76a20d9c8a98$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $c33f76a20d9c8a98$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $c33f76a20d9c8a98$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $c33f76a20d9c8a98$var$isAttributeObject;
module.exports.serializeAttributes = $c33f76a20d9c8a98$var$serializeAttributes;

});

parcelRegister("k1IvE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JduQ = parcelRequire("2JduQ");

var $kJVFD = parcelRequire("kJVFD");

var $logAX = parcelRequire("logAX");

var $3kLni = parcelRequire("3kLni");
let $e9466d4a11817293$var$_externalPropagationContextProvider;
function $e9466d4a11817293$var$registerExternalPropagationContext(fn) {
    $e9466d4a11817293$var$_externalPropagationContextProvider = fn;
}
function $e9466d4a11817293$var$getExternalPropagationContext() {
    return $e9466d4a11817293$var$_externalPropagationContextProvider?.();
}
function $e9466d4a11817293$var$hasExternalPropagationContext() {
    return $e9466d4a11817293$var$_externalPropagationContextProvider !== void 0;
}
function $e9466d4a11817293$var$getCurrentScope() {
    const carrier$1 = $kJVFD.getMainCarrier();
    const acs = $2JduQ.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
function $e9466d4a11817293$var$getIsolationScope() {
    const carrier$1 = $kJVFD.getMainCarrier();
    const acs = $2JduQ.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
function $e9466d4a11817293$var$getGlobalScope() {
    return $kJVFD.getGlobalSingleton("globalScope", ()=>new $logAX.Scope());
}
function $e9466d4a11817293$var$withScope(...rest) {
    const carrier$1 = $kJVFD.getMainCarrier();
    const acs = $2JduQ.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $e9466d4a11817293$var$withIsolationScope(...rest) {
    const carrier$1 = $kJVFD.getMainCarrier();
    const acs = $2JduQ.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $e9466d4a11817293$var$getClient() {
    return $e9466d4a11817293$var$getCurrentScope().getClient();
}
function $e9466d4a11817293$var$getTraceContextFromScope(scope) {
    const externalContext = $e9466d4a11817293$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $3kLni.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $e9466d4a11817293$var$getClient;
module.exports.getCurrentScope = $e9466d4a11817293$var$getCurrentScope;
module.exports.getExternalPropagationContext = $e9466d4a11817293$var$getExternalPropagationContext;
module.exports.getGlobalScope = $e9466d4a11817293$var$getGlobalScope;
module.exports.getIsolationScope = $e9466d4a11817293$var$getIsolationScope;
module.exports.getTraceContextFromScope = $e9466d4a11817293$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $e9466d4a11817293$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $e9466d4a11817293$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $e9466d4a11817293$var$withIsolationScope;
module.exports.withScope = $e9466d4a11817293$var$withScope;

});

parcelRegister("7nMWX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const $5600a6d34a12fa78$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const $5600a6d34a12fa78$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $5600a6d34a12fa78$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $5600a6d34a12fa78$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $5600a6d34a12fa78$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("dAQ6V", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $9e570f42b2dc6ad7$var$SPAN_STATUS_UNSET = 0;
const $9e570f42b2dc6ad7$var$SPAN_STATUS_OK = 1;
const $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR = 2;
function $9e570f42b2dc6ad7$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $9e570f42b2dc6ad7$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
function $9e570f42b2dc6ad7$var$setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $9e570f42b2dc6ad7$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $9e570f42b2dc6ad7$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $9e570f42b2dc6ad7$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $9e570f42b2dc6ad7$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $9e570f42b2dc6ad7$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $9e570f42b2dc6ad7$var$setHttpStatus;

});

parcelRegister("33FUD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $56noD = parcelRequire("56noD");

var $eDH5Q = parcelRequire("eDH5Q");
const $23a229d6ebce6819$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $23a229d6ebce6819$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $23a229d6ebce6819$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $56noD.addNonEnumerableProperty(span, $23a229d6ebce6819$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $eDH5Q.makeWeakRef(isolationScope));
        $56noD.addNonEnumerableProperty(span, $23a229d6ebce6819$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $23a229d6ebce6819$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$23a229d6ebce6819$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $eDH5Q.derefWeakRef(spanWithScopes[$23a229d6ebce6819$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
module.exports.getCapturedScopesOnSpan = $23a229d6ebce6819$var$getCapturedScopesOnSpan;
module.exports.setCapturedScopesOnSpan = $23a229d6ebce6819$var$setCapturedScopesOnSpan;

});

parcelRegister("8pUWd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jDmhV = parcelRequire("jDmhV");

var $OCsCD = parcelRequire("OCsCD");

var $luwRx = parcelRequire("luwRx");

var $jsTRh = parcelRequire("jsTRh");

var $3kLni = parcelRequire("3kLni");

var $lc80H = parcelRequire("lc80H");
const $620cd33d34ac5ea9$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $620cd33d34ac5ea9$var$extractTraceparentData(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($620cd33d34ac5ea9$var$TRACEPARENT_REGEXP);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $620cd33d34ac5ea9$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $620cd33d34ac5ea9$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $OCsCD.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $3kLni.generateTraceId(),
        sampleRand: $lc80H.safeMathRandom()
    };
    const sampleRand = $620cd33d34ac5ea9$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $620cd33d34ac5ea9$var$generateSentryTraceHeader(traceId = $3kLni.generateTraceId(), spanId = $3kLni.generateSpanId(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $620cd33d34ac5ea9$var$generateTraceparentHeader(traceId = $3kLni.generateTraceId(), spanId = $3kLni.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $620cd33d34ac5ea9$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = $jsTRh.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = $jsTRh.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    $lc80H.safeMathRandom() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + $lc80H.safeMathRandom() * (1 - parsedSampleRate);
    else return $lc80H.safeMathRandom();
}
function $620cd33d34ac5ea9$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $luwRx.extractOrgIdFromClient(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $jDmhV.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $jDmhV.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $620cd33d34ac5ea9$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $620cd33d34ac5ea9$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $620cd33d34ac5ea9$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $620cd33d34ac5ea9$var$generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $620cd33d34ac5ea9$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $620cd33d34ac5ea9$var$shouldContinueTrace;

});
parcelRegister("OCsCD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $jm1F1 = parcelRequire("jm1F1");
const $0982811c3b988e5e$var$SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const $0982811c3b988e5e$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const $0982811c3b988e5e$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
function $0982811c3b988e5e$var$baggageHeaderToDynamicSamplingContext(baggageHeader) {
    const baggageObject = $0982811c3b988e5e$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($0982811c3b988e5e$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($0982811c3b988e5e$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $0982811c3b988e5e$var$dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$0982811c3b988e5e$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $0982811c3b988e5e$var$objectToBaggageHeader(sentryPrefixedDSC);
}
function $0982811c3b988e5e$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$jm1F1.isString(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $0982811c3b988e5e$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $0982811c3b988e5e$var$baggageHeaderToObject(baggageHeader);
}
function $0982811c3b988e5e$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $0982811c3b988e5e$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $0982811c3b988e5e$var$MAX_BAGGAGE_STRING_LENGTH) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $0982811c3b988e5e$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $0982811c3b988e5e$var$parseBaggageHeader(existing);
    const incomingEntries = $0982811c3b988e5e$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($0982811c3b988e5e$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($0982811c3b988e5e$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $0982811c3b988e5e$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $0982811c3b988e5e$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $0982811c3b988e5e$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $0982811c3b988e5e$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $0982811c3b988e5e$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $0982811c3b988e5e$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $0982811c3b988e5e$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $0982811c3b988e5e$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $0982811c3b988e5e$var$parseBaggageHeader;

});

parcelRegister("luwRx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");
const $fa55e421cdd41c95$var$ORG_ID_REGEX = /^o(\d+)\./;
const $fa55e421cdd41c95$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $fa55e421cdd41c95$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $fa55e421cdd41c95$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $fa55e421cdd41c95$var$dsnFromString(str) {
    const match = $fa55e421cdd41c95$var$DSN_REGEX.exec(str);
    if (!match) {
        $jDmhV.consoleSandbox(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $fa55e421cdd41c95$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $fa55e421cdd41c95$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $fa55e421cdd41c95$var$validateDsn(dsn) {
    if (!$cWDS7.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $jDmhV.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $jDmhV.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$fa55e421cdd41c95$var$isValidProtocol(protocol)) {
        $jDmhV.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $jDmhV.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $fa55e421cdd41c95$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($fa55e421cdd41c95$var$ORG_ID_REGEX);
    return match?.[1];
}
function $fa55e421cdd41c95$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $fa55e421cdd41c95$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
function $fa55e421cdd41c95$var$makeDsn(from) {
    const components = typeof from === "string" ? $fa55e421cdd41c95$var$dsnFromString(from) : $fa55e421cdd41c95$var$dsnFromComponents(from);
    if (!components || !$fa55e421cdd41c95$var$validateDsn(components)) return void 0;
    return components;
}
module.exports.dsnFromString = $fa55e421cdd41c95$var$dsnFromString;
module.exports.dsnToString = $fa55e421cdd41c95$var$dsnToString;
module.exports.extractOrgIdFromClient = $fa55e421cdd41c95$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $fa55e421cdd41c95$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $fa55e421cdd41c95$var$makeDsn;

});

parcelRegister("jsTRh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e2bbf62988e53595$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}
module.exports.parseSampleRate = $e2bbf62988e53595$var$parseSampleRate;

});




parcelRegister("krgs5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $7nMWX = parcelRequire("7nMWX");

var $jDmhV = parcelRequire("jDmhV");

var $60l9G = parcelRequire("60l9G");

var $aD0ts = parcelRequire("aD0ts");

var $43BuU = parcelRequire("43BuU");

var $hR4pa = parcelRequire("hR4pa");

var $gQok6 = parcelRequire("gQok6");

var $6vmlI = parcelRequire("6vmlI");

var $hhSBj = parcelRequire("hhSBj");

var $dRtIK = parcelRequire("dRtIK");

var $dAQ6V = parcelRequire("dAQ6V");

var $5VGek = parcelRequire("5VGek");
const $ee1317462e9dda4d$var$TRACING_DEFAULTS = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $ee1317462e9dda4d$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $ee1317462e9dda4d$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $ee1317462e9dda4d$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $ee1317462e9dda4d$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $ee1317462e9dda4d$var$startIdleSpan(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _finishReason = $ee1317462e9dda4d$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $ee1317462e9dda4d$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $ee1317462e9dda4d$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $ee1317462e9dda4d$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $k1IvE.getClient();
    if (!client || !$60l9G.hasSpansEnabled()) {
        const span2 = new $hhSBj.SentryNonRecordingSpan();
        const dsc = {
            sample_rate: "0",
            sampled: "false",
            ...$6vmlI.getDynamicSamplingContextFromSpan(span2)
        };
        $6vmlI.freezeDscOnSpan(span2, dsc);
        return span2;
    }
    const scope = $k1IvE.getCurrentScope();
    const previousActiveSpan = $hR4pa.getActiveSpan();
    const span = $ee1317462e9dda4d$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if (thisArg instanceof $hhSBj.SentryNonRecordingSpan) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $gQok6.timestampInSeconds();
            const spanEndTimestamp = $hR4pa.spanTimeInputToSeconds(timestamp);
            const spans = $hR4pa.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $hR4pa.spanToJSON(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $hR4pa.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && $aD0ts.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $ee1317462e9dda4d$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $ee1317462e9dda4d$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $gQok6.timestampInSeconds();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $gQok6.timestampInSeconds();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $43BuU._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $hR4pa.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: $dAQ6V.SPAN_STATUS_OK
        });
        $jDmhV.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $hR4pa.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $dAQ6V.SPAN_STATUS_ERROR,
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = $hR4pa.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($cWDS7.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) $jDmhV.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $jDmhV.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $hR4pa.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!$hR4pa.spanToJSON(startedSpan).timestamp || startedSpan instanceof $dRtIK.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $hR4pa.getSpanDescendants(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $dAQ6V.SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            });
            _finishReason = $ee1317462e9dda4d$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $ee1317462e9dda4d$var$_startIdleSpan(options) {
    const span = $5VGek.startInactiveSpan(options);
    $43BuU._setSpanForScope($k1IvE.getCurrentScope(), span);
    $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("[Tracing] Started span is an idle span");
    return span;
}
module.exports.TRACING_DEFAULTS = $ee1317462e9dda4d$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $ee1317462e9dda4d$var$startIdleSpan;

});
parcelRegister("60l9G", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");
function $45f3272742249d44$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $k1IvE.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $45f3272742249d44$var$hasSpansEnabled;

});

parcelRegister("aD0ts", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $2b0FU = parcelRequire("2b0FU");
function $7bcdea0ba7488a8b$var$logIgnoredSpan(droppedSpan) {
    $jDmhV.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $7bcdea0ba7488a8b$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($7bcdea0ba7488a8b$var$isStringOrRegExp(pattern)) {
            if (span.description && $2b0FU.isMatchingPattern(span.description, pattern)) {
                $cWDS7.DEBUG_BUILD && $7bcdea0ba7488a8b$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $2b0FU.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $2b0FU.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$7bcdea0ba7488a8b$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            $cWDS7.DEBUG_BUILD && $7bcdea0ba7488a8b$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $7bcdea0ba7488a8b$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return $2b0FU.isMatchingPattern(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $7bcdea0ba7488a8b$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $7bcdea0ba7488a8b$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}
module.exports.reparentChildSpans = $7bcdea0ba7488a8b$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $7bcdea0ba7488a8b$var$shouldIgnoreSpan;

});

parcelRegister("6vmlI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $JJ1mC = parcelRequire("JJ1mC");

var $k1IvE = parcelRequire("k1IvE");

var $7nMWX = parcelRequire("7nMWX");

var $OCsCD = parcelRequire("OCsCD");

var $luwRx = parcelRequire("luwRx");

var $60l9G = parcelRequire("60l9G");

var $56noD = parcelRequire("56noD");

var $hR4pa = parcelRequire("hR4pa");

var $33FUD = parcelRequire("33FUD");
const $4bc6f968d33e443f$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $4bc6f968d33e443f$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $56noD.addNonEnumerableProperty(spanWithMaybeDsc, $4bc6f968d33e443f$var$FROZEN_DSC_FIELD, dsc);
}
function $4bc6f968d33e443f$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || $JJ1mC.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $luwRx.extractOrgIdFromClient(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $4bc6f968d33e443f$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $4bc6f968d33e443f$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function $4bc6f968d33e443f$var$getDynamicSamplingContextFromSpan(span) {
    const client = $k1IvE.getClient();
    if (!client) return {};
    const rootSpan = $hR4pa.getRootSpan(span);
    const rootSpanJson = $hR4pa.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$4bc6f968d33e443f$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && $OCsCD.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $4bc6f968d33e443f$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    const source = rootSpanAttributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.span.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ($60l9G.hasSpansEnabled()) {
        dsc.sampled = String($hR4pa.spanIsSampled(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $33FUD.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $4bc6f968d33e443f$var$spanToBaggageHeader(span) {
    const dsc = $4bc6f968d33e443f$var$getDynamicSamplingContextFromSpan(span);
    return $OCsCD.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $4bc6f968d33e443f$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $4bc6f968d33e443f$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $4bc6f968d33e443f$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $4bc6f968d33e443f$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $4bc6f968d33e443f$var$spanToBaggageHeader;

});
parcelRegister("JJ1mC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $08972050f30d1080$var$DEFAULT_ENVIRONMENT = "production";
const $08972050f30d1080$var$DEV_ENVIRONMENT = "development";
module.exports.DEFAULT_ENVIRONMENT = $08972050f30d1080$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $08972050f30d1080$var$DEV_ENVIRONMENT;

});


parcelRegister("hhSBj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3kLni = parcelRequire("3kLni");

var $hR4pa = parcelRequire("hR4pa");
class $c95e60cb574611dc$var$SentryNonRecordingSpan {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $3kLni.generateTraceId();
        this._spanId = spanContext.spanId || $3kLni.generateSpanId();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $hR4pa.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
module.exports.SentryNonRecordingSpan = $c95e60cb574611dc$var$SentryNonRecordingSpan;

});

parcelRegister("dRtIK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $6a1Ld = parcelRequire("6a1Ld");

var $7nMWX = parcelRequire("7nMWX");

var $jDmhV = parcelRequire("jDmhV");

var $3kLni = parcelRequire("3kLni");

var $hR4pa = parcelRequire("hR4pa");

var $gQok6 = parcelRequire("gQok6");

var $6vmlI = parcelRequire("6vmlI");

var $cXJ5I = parcelRequire("cXJ5I");

var $j5ojN = parcelRequire("j5ojN");

var $lk94N = parcelRequire("lk94N");

var $33FUD = parcelRequire("33FUD");
const $a17747878e5352f7$var$MAX_SPAN_COUNT = 1e3;
class $a17747878e5352f7$var$SentrySpan {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $3kLni.generateTraceId();
        this._spanId = spanContext.spanId || $3kLni.generateSpanId();
        this._startTime = spanContext.startTimestamp || $gQok6.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $hR4pa.TRACE_FLAG_SAMPLED : $hR4pa.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = $hR4pa.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute($7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) return;
        this._endTime = $hR4pa.spanTimeInputToSeconds(endTimestamp);
        $cXJ5I.logSpanEnd(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $hR4pa.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$7nMWX.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$7nMWX.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $j5ojN.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $hR4pa.getRootSpan(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? $hR4pa.getRootSpan(this).spanContext().spanId : void 0,
            links: $hR4pa.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $hR4pa.getRootSpan(this),
            status: $hR4pa.getSimpleStatusMessage(this._status),
            attributes: this._attributes,
            links: $hR4pa.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("[Tracing] Adding an event to span:", name);
        const time$1 = $a17747878e5352f7$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $gQok6.timestampInSeconds();
        const attributes = $a17747878e5352f7$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $hR4pa.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $k1IvE.getClient();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const isSegmentSpan = this._isStandaloneSpan || this === $hR4pa.getRootSpan(this);
        if (!isSegmentSpan) return;
        if (this._isStandaloneSpan) {
            if (this._sampled) $a17747878e5352f7$var$sendSpanEnvelope($6a1Ld.createSpanEnvelope([
                this
            ], client));
            else {
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && $lk94N.hasSpanStreamingEnabled(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = $33FUD.getCapturedScopesOnSpan(this).scope || $k1IvE.getCurrentScope();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        if (!$a17747878e5352f7$var$isFullFinishedSpan($hR4pa.spanToJSON(this))) return void 0;
        if (!this._name) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $33FUD.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        const finishedSpans = $hR4pa.getSpanDescendants(this).filter((span)=>span !== this && !$a17747878e5352f7$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>$hR4pa.spanToJSON(span)).filter($a17747878e5352f7$var$isFullFinishedSpan);
        const source = this._attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        delete this._attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: $hR4pa.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $a17747878e5352f7$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $a17747878e5352f7$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $6vmlI.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $j5ojN.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $a17747878e5352f7$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $a17747878e5352f7$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $a17747878e5352f7$var$isStandaloneSpan(span) {
    return span instanceof $a17747878e5352f7$var$SentrySpan && span.isStandaloneSpan();
}
function $a17747878e5352f7$var$sendSpanEnvelope(envelope) {
    const client = $k1IvE.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $a17747878e5352f7$var$SentrySpan;

});
parcelRegister("6a1Ld", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6vmlI = parcelRequire("6vmlI");

var $4BYqM = parcelRequire("4BYqM");

var $luwRx = parcelRequire("luwRx");

var $dQ0Qv = parcelRequire("dQ0Qv");

var $aD0ts = parcelRequire("aD0ts");

var $hR4pa = parcelRequire("hR4pa");
function $47c50ad83e9447f4$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $47c50ad83e9447f4$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $dQ0Qv.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $luwRx.dsnToString(dsn$1)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return $dQ0Qv.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
function $47c50ad83e9447f4$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $dQ0Qv.getSdkMetadataForEnvelopeHeader(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $47c50ad83e9447f4$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $dQ0Qv.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $dQ0Qv.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
function $47c50ad83e9447f4$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = $6vmlI.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $luwRx.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $hR4pa.spanToJSON(span);
        return !$aD0ts.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $hR4pa.spanToJSON(span);
        const processedSpan = !$4BYqM.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $hR4pa.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $hR4pa.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($dQ0Qv.createSpanEnvelopeItem(spanJson));
    }
    return $dQ0Qv.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $47c50ad83e9447f4$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $47c50ad83e9447f4$var$createEventEnvelope;
module.exports.createSessionEnvelope = $47c50ad83e9447f4$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $47c50ad83e9447f4$var$createSpanEnvelope;

});
parcelRegister("4BYqM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $56noD = parcelRequire("56noD");
function $35b97e781e46a41e$var$withStreamedSpan(callback) {
    $56noD.addNonEnumerableProperty(callback, "_streamed", true);
    return callback;
}
function $35b97e781e46a41e$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $35b97e781e46a41e$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $35b97e781e46a41e$var$withStreamedSpan;

});

parcelRegister("dQ0Qv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kJVFD = parcelRequire("kJVFD");

var $luwRx = parcelRequire("luwRx");

var $04GFW = parcelRequire("04GFW");

var $NKzWo = parcelRequire("NKzWo");
function $a130c9b01d9bec45$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $a130c9b01d9bec45$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $a130c9b01d9bec45$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $a130c9b01d9bec45$var$envelopeContainsItemType(envelope, types) {
    return $a130c9b01d9bec45$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
function $a130c9b01d9bec45$var$encodeUTF8(input) {
    const carrier$1 = $kJVFD.getSentryCarrier($NKzWo.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $a130c9b01d9bec45$var$decodeUTF8(input) {
    const carrier$1 = $kJVFD.getSentryCarrier($NKzWo.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $a130c9b01d9bec45$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $a130c9b01d9bec45$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $a130c9b01d9bec45$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify($04GFW.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $a130c9b01d9bec45$var$concatBuffers(parts);
}
function $a130c9b01d9bec45$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $a130c9b01d9bec45$var$parseEnvelope(env) {
    let buffer = typeof env === "string" ? $a130c9b01d9bec45$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($a130c9b01d9bec45$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $a130c9b01d9bec45$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $a130c9b01d9bec45$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? $a130c9b01d9bec45$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $a130c9b01d9bec45$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $a130c9b01d9bec45$var$_isOverriddenType(type) {
    return type in $a130c9b01d9bec45$var$DATA_CATEGORY_OVERRIDES;
}
function $a130c9b01d9bec45$var$envelopeItemTypeToDataCategory(type) {
    return $a130c9b01d9bec45$var$_isOverriddenType(type) ? $a130c9b01d9bec45$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $a130c9b01d9bec45$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $a130c9b01d9bec45$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $luwRx.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $a130c9b01d9bec45$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $a130c9b01d9bec45$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $a130c9b01d9bec45$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $a130c9b01d9bec45$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $a130c9b01d9bec45$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $a130c9b01d9bec45$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $a130c9b01d9bec45$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $a130c9b01d9bec45$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $a130c9b01d9bec45$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $a130c9b01d9bec45$var$parseEnvelope;
module.exports.serializeEnvelope = $a130c9b01d9bec45$var$serializeEnvelope;

});


parcelRegister("cXJ5I", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $hR4pa = parcelRequire("hR4pa");
function $96fdf8eb6f931ba9$var$logSpanStart(span) {
    if (!$cWDS7.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = $hR4pa.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $hR4pa.spanIsSampled(span);
    const rootSpan = $hR4pa.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = $hR4pa.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    $jDmhV.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $96fdf8eb6f931ba9$var$logSpanEnd(span) {
    if (!$cWDS7.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = $hR4pa.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $hR4pa.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    $jDmhV.debug.log(msg);
}
module.exports.logSpanEnd = $96fdf8eb6f931ba9$var$logSpanEnd;
module.exports.logSpanStart = $96fdf8eb6f931ba9$var$logSpanStart;

});

parcelRegister("j5ojN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $7nMWX = parcelRequire("7nMWX");

var $jDmhV = parcelRequire("jDmhV");

var $hR4pa = parcelRequire("hR4pa");
function $de515914e313e127$var$setMeasurement(name, value, unit, activeSpan = $hR4pa.getActiveSpan()) {
    const rootSpan = activeSpan && $hR4pa.getRootSpan(activeSpan);
    if (rootSpan) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
function $de515914e313e127$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $de515914e313e127$var$setMeasurement;
module.exports.timedEventsToMeasurements = $de515914e313e127$var$timedEventsToMeasurements;

});

parcelRegister("lk94N", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $f8628197fa8ec666$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}
module.exports.hasSpanStreamingEnabled = $f8628197fa8ec666$var$hasSpanStreamingEnabled;

});


parcelRegister("5VGek", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JduQ = parcelRequire("2JduQ");

var $kJVFD = parcelRequire("kJVFD");

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $7nMWX = parcelRequire("7nMWX");

var $OCsCD = parcelRequire("OCsCD");

var $jDmhV = parcelRequire("jDmhV");

var $3fFnG = parcelRequire("3fFnG");

var $60l9G = parcelRequire("60l9G");

var $aD0ts = parcelRequire("aD0ts");

var $lk94N = parcelRequire("lk94N");

var $jsTRh = parcelRequire("jsTRh");

var $3kLni = parcelRequire("3kLni");

var $lc80H = parcelRequire("lc80H");

var $43BuU = parcelRequire("43BuU");

var $hR4pa = parcelRequire("hR4pa");

var $8pUWd = parcelRequire("8pUWd");

var $6vmlI = parcelRequire("6vmlI");

var $cXJ5I = parcelRequire("cXJ5I");

var $9c3TQ = parcelRequire("9c3TQ");

var $hhSBj = parcelRequire("hhSBj");

var $dRtIK = parcelRequire("dRtIK");

var $dAQ6V = parcelRequire("dAQ6V");

var $33FUD = parcelRequire("33FUD");
const $451308a7a6d7cf6c$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function $451308a7a6d7cf6c$var$startSpan(options, callback) {
    const acs = $451308a7a6d7cf6c$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $451308a7a6d7cf6c$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $k1IvE.withScope(customForkedScope, ()=>{
        const wrapper = $451308a7a6d7cf6c$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $k1IvE.getCurrentScope();
            const parentSpan = $451308a7a6d7cf6c$var$getParentSpan(scope, customParentSpan);
            const client = $k1IvE.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new $hhSBj.SentryNonRecordingSpan() : $451308a7a6d7cf6c$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent("no_parent_span", "span");
            if (!$451308a7a6d7cf6c$var$_isIgnoredSpan(activeSpan) || !parentSpan) $43BuU._setSpanForScope(scope, activeSpan);
            return $3fFnG.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                const { status: status } = $hR4pa.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $dAQ6V.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $451308a7a6d7cf6c$var$startSpanManual(options, callback) {
    const acs = $451308a7a6d7cf6c$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $451308a7a6d7cf6c$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $k1IvE.withScope(customForkedScope, ()=>{
        const wrapper = $451308a7a6d7cf6c$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $k1IvE.getCurrentScope();
            const parentSpan = $451308a7a6d7cf6c$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new $hhSBj.SentryNonRecordingSpan() : $451308a7a6d7cf6c$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) $k1IvE.getClient()?.recordDroppedEvent("no_parent_span", "span");
            if (!$451308a7a6d7cf6c$var$_isIgnoredSpan(activeSpan) || !parentSpan) $43BuU._setSpanForScope(scope, activeSpan);
            return $3fFnG.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = $hR4pa.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $dAQ6V.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            });
        });
    });
}
function $451308a7a6d7cf6c$var$startInactiveSpan(options) {
    const acs = $451308a7a6d7cf6c$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $451308a7a6d7cf6c$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>$k1IvE.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$451308a7a6d7cf6c$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $k1IvE.getCurrentScope();
        const parentSpan = $451308a7a6d7cf6c$var$getParentSpan(scope, customParentSpan);
        const client = $k1IvE.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent("no_parent_span", "span");
            return new $hhSBj.SentryNonRecordingSpan();
        }
        return $451308a7a6d7cf6c$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $451308a7a6d7cf6c$var$continueTrace = (options, callback)=>{
    const carrier$1 = $kJVFD.getMainCarrier();
    const acs = $2JduQ.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $k1IvE.getClient();
    const incomingDsc = $OCsCD.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$8pUWd.shouldContinueTrace(client, incomingDsc?.org_id)) return $451308a7a6d7cf6c$var$startNewTrace(callback);
    return $k1IvE.withScope((scope)=>{
        const propagationContext = $8pUWd.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $43BuU._setSpanForScope(scope, void 0);
        return callback();
    });
};
function $451308a7a6d7cf6c$var$withActiveSpan(span, callback) {
    const acs = $451308a7a6d7cf6c$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $k1IvE.withScope((scope)=>{
        $43BuU._setSpanForScope(scope, span || void 0);
        return callback(scope);
    });
}
function $451308a7a6d7cf6c$var$suppressTracing(callback) {
    const acs = $451308a7a6d7cf6c$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $k1IvE.withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [$451308a7a6d7cf6c$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$451308a7a6d7cf6c$var$SUPPRESS_TRACING_KEY]: void 0
        });
        return res;
    });
}
function $451308a7a6d7cf6c$var$startNewTrace(callback) {
    const acs = $451308a7a6d7cf6c$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $k1IvE.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $3kLni.generateTraceId(),
            sampleRand: $lc80H.safeMathRandom()
        });
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $451308a7a6d7cf6c$var$withActiveSpan(null, callback);
    });
}
function $451308a7a6d7cf6c$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!$60l9G.hasSpansEnabled()) {
        const span2 = new $hhSBj.SentryNonRecordingSpan();
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...$6vmlI.getDynamicSamplingContextFromSpan(span2)
            };
            $6vmlI.freezeDscOnSpan(span2, dsc);
        }
        return span2;
    }
    const client = $k1IvE.getClient();
    if ($451308a7a6d7cf6c$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$451308a7a6d7cf6c$var$_isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        return new $hhSBj.SentryNonRecordingSpan({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = $k1IvE.getIsolationScope();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $451308a7a6d7cf6c$var$_startChildSpan(parentSpan, scope, spanArguments);
        $hR4pa.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        const dsc = $6vmlI.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $hR4pa.spanIsSampled(parentSpan);
        span = $451308a7a6d7cf6c$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        $6vmlI.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $451308a7a6d7cf6c$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) $6vmlI.freezeDscOnSpan(span, dsc);
    }
    $cXJ5I.logSpanStart(span);
    $33FUD.setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
function $451308a7a6d7cf6c$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $hR4pa.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $451308a7a6d7cf6c$var$getAcs() {
    const carrier$1 = $kJVFD.getMainCarrier();
    return $2JduQ.getAsyncContextStrategy(carrier$1);
}
function $451308a7a6d7cf6c$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = $k1IvE.getClient();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $451308a7a6d7cf6c$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : $9c3TQ.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: $jsTRh.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $dRtIK.SentrySpan({
        ...spanArguments,
        attributes: {
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", $lk94N.hasSpanStreamingEnabled(client) ? "span" : "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $451308a7a6d7cf6c$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $451308a7a6d7cf6c$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : $hR4pa.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $dRtIK.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $hhSBj.SentryNonRecordingSpan({
        traceId: traceId
    });
    $hR4pa.addChildSpanToSpan(parentSpan, childSpan);
    const client = $k1IvE.getClient();
    if (!client) return childSpan;
    if ($lk94N.hasSpanStreamingEnabled(client) && childSpan instanceof $hhSBj.SentryNonRecordingSpan) {
        if (parentSpan instanceof $hhSBj.SentryNonRecordingSpan && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $451308a7a6d7cf6c$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = $43BuU._getSpanForScope(scope);
    if (!span) return void 0;
    const client = $k1IvE.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $hR4pa.getRootSpan(span);
    return span;
}
function $451308a7a6d7cf6c$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $451308a7a6d7cf6c$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
function $451308a7a6d7cf6c$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$lk94N.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $aD0ts.shouldIgnoreSpan({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $451308a7a6d7cf6c$var$_isIgnoredSpan(span) {
    return span instanceof $hhSBj.SentryNonRecordingSpan && span.dropReason === "ignored";
}
function $451308a7a6d7cf6c$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$451308a7a6d7cf6c$var$SUPPRESS_TRACING_KEY] === true;
}
module.exports.SUPPRESS_TRACING_KEY = $451308a7a6d7cf6c$var$SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $451308a7a6d7cf6c$var$continueTrace;
module.exports.startInactiveSpan = $451308a7a6d7cf6c$var$startInactiveSpan;
module.exports.startNewTrace = $451308a7a6d7cf6c$var$startNewTrace;
module.exports.startSpan = $451308a7a6d7cf6c$var$startSpan;
module.exports.startSpanManual = $451308a7a6d7cf6c$var$startSpanManual;
module.exports.suppressTracing = $451308a7a6d7cf6c$var$suppressTracing;
module.exports.withActiveSpan = $451308a7a6d7cf6c$var$withActiveSpan;

});
parcelRegister("3fFnG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6hZKT = parcelRequire("6hZKT");

var $jm1F1 = parcelRequire("jm1F1");
function $25e2df310332e192$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $25e2df310332e192$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $25e2df310332e192$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($jm1F1.isThenable(value)) return $6hZKT.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $25e2df310332e192$var$handleCallbackErrors;

});

parcelRegister("9c3TQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $60l9G = parcelRequire("60l9G");

var $jsTRh = parcelRequire("jsTRh");
function $6b18426f8e1cf45e$var$sampleSpan(options, samplingContext, sampleRand) {
    if (!$60l9G.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = $jsTRh.parseSampleRate(sampleRate);
    if (parsedSampleRate === void 0) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $6b18426f8e1cf45e$var$sampleSpan;

});



parcelRegister("2VRKv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7nMWX = parcelRequire("7nMWX");

var $7oq4J = parcelRequire("7oq4J");

var $5xKoA = parcelRequire("5xKoA");

var $hR4pa = parcelRequire("hR4pa");

var $33FUD = parcelRequire("33FUD");

var $4BYqM = parcelRequire("4BYqM");

var $1lgoW = parcelRequire("1lgoW");
function $222a991a859c4bb7$var$captureSpan(span, client) {
    const spanJSON = $hR4pa.spanToStreamedSpanJSON(span);
    const segmentSpan = $hR4pa.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $hR4pa.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $33FUD.getCapturedScopesOnSpan(span);
    const finalScopeData = $7oq4J.getCombinedScopeData(spanIsolationScope, spanScope);
    $222a991a859c4bb7$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    $222a991a859c4bb7$var$inferSpanDataFromOtelAttributes(spanJSON, spanKind);
    if (spanJSON.is_segment) {
        $222a991a859c4bb7$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $222a991a859c4bb7$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $4BYqM.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $222a991a859c4bb7$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanNameSource) $222a991a859c4bb7$var$safeSetSpanJSONAttributes(processedSpan, {
        // Purposefully not using a constant defined here like in other attributes:
        // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
        "sentry.span.source": spanNameSource
    });
    return {
        ...$hR4pa.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $222a991a859c4bb7$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = $1lgoW.scopeContextsToSpanAttributes(scopeData.contexts);
    $222a991a859c4bb7$var$safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function $222a991a859c4bb7$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $222a991a859c4bb7$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $222a991a859c4bb7$var$safeSetSpanJSONAttributes(segmentSpanJSON, {
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
    });
}
function $222a991a859c4bb7$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $222a991a859c4bb7$var$safeSetSpanJSONAttributes(spanJSON, {
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$7nMWX.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$7nMWX.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$7nMWX.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$7nMWX.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $222a991a859c4bb7$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $hR4pa.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
const $222a991a859c4bb7$var$SPAN_KIND_SERVER = 1;
const $222a991a859c4bb7$var$SPAN_KIND_CLIENT = 2;
function $222a991a859c4bb7$var$inferSpanDataFromOtelAttributes(spanJSON, spanKind) {
    const attributes = spanJSON.attributes;
    if (!attributes) return;
    const httpMethod = attributes["http.request.method"] || attributes["http.method"];
    if (httpMethod) {
        $222a991a859c4bb7$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod);
        return;
    }
    const dbSystem = attributes["db.system.name"] || attributes["db.system"];
    const opIsCache = typeof attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "string" && `${attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]}`.startsWith("cache.");
    if (dbSystem && !opIsCache) {
        $222a991a859c4bb7$var$inferDbSpanData(spanJSON, attributes);
        return;
    }
    if (attributes["rpc.service"]) {
        $222a991a859c4bb7$var$safeSetSpanJSONAttributes(spanJSON, {
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "rpc"
        });
        return;
    }
    if (attributes["messaging.system"]) {
        $222a991a859c4bb7$var$safeSetSpanJSONAttributes(spanJSON, {
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "message"
        });
        return;
    }
    const faasTrigger = attributes["faas.trigger"];
    if (faasTrigger) $222a991a859c4bb7$var$safeSetSpanJSONAttributes(spanJSON, {
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: `${faasTrigger}`
    });
}
function $222a991a859c4bb7$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod) {
    const opParts = [
        "http"
    ];
    if (spanKind === $222a991a859c4bb7$var$SPAN_KIND_CLIENT) opParts.push("client");
    else if (spanKind === $222a991a859c4bb7$var$SPAN_KIND_SERVER) opParts.push("server");
    if (attributes["sentry.http.prefetch"]) opParts.push("prefetch");
    $222a991a859c4bb7$var$safeSetSpanJSONAttributes(spanJSON, {
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: opParts.join(".")
    });
    const customName = attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === "custom") return;
    const httpRoute = attributes["http.route"];
    if (typeof httpRoute === "string") {
        spanJSON.name = `${httpMethod} ${httpRoute}`;
        $222a991a859c4bb7$var$safeSetSpanJSONAttributes(spanJSON, {
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "route"
        });
    } else {
        if (spanKind === $222a991a859c4bb7$var$SPAN_KIND_CLIENT || spanKind === $222a991a859c4bb7$var$SPAN_KIND_SERVER) {
            const urlPath = $222a991a859c4bb7$var$getUrlPath(attributes, spanKind);
            if (urlPath) spanJSON.name = `${httpMethod} ${urlPath}`;
        }
        $222a991a859c4bb7$var$safeSetSpanJSONAttributes(spanJSON, {
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
        });
    }
}
function $222a991a859c4bb7$var$getUrlPath(attributes, spanKind) {
    const httpUrl = attributes["http.url"] || attributes["url.full"];
    const httpTarget = attributes["http.target"];
    const parsedUrl = typeof httpUrl === "string" ? $5xKoA.parseUrl(httpUrl) : void 0;
    const sanitizedUrl = parsedUrl ? $5xKoA.getSanitizedUrlString(parsedUrl) : void 0;
    if (spanKind === $222a991a859c4bb7$var$SPAN_KIND_SERVER && typeof httpTarget === "string") return $5xKoA.stripUrlQueryAndFragment(httpTarget);
    if (sanitizedUrl) return sanitizedUrl;
    if (typeof httpTarget === "string") return $5xKoA.stripUrlQueryAndFragment(httpTarget);
    return void 0;
}
function $222a991a859c4bb7$var$inferDbSpanData(spanJSON, attributes) {
    $222a991a859c4bb7$var$safeSetSpanJSONAttributes(spanJSON, {
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
    });
    const customName = attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === "custom") return;
    const statement = attributes["db.statement"];
    if (statement) {
        spanJSON.name = `${statement}`;
        $222a991a859c4bb7$var$safeSetSpanJSONAttributes(spanJSON, {
            [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "task"
        });
    }
}
module.exports.applyBeforeSendSpanCallback = $222a991a859c4bb7$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $222a991a859c4bb7$var$captureSpan;
module.exports.inferSpanDataFromOtelAttributes = $222a991a859c4bb7$var$inferSpanDataFromOtelAttributes;
module.exports.safeSetSpanJSONAttributes = $222a991a859c4bb7$var$safeSetSpanJSONAttributes;

});
parcelRegister("7oq4J", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $6vmlI = parcelRequire("6vmlI");

var $6aWHc = parcelRequire("6aWHc");

var $hR4pa = parcelRequire("hR4pa");
function $561f0054630bfc5f$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $561f0054630bfc5f$var$applyDataToEvent(event, data);
    if (span) $561f0054630bfc5f$var$applySpanToEvent(event, span);
    $561f0054630bfc5f$var$applyFingerprintToEvent(event, fingerprint);
    $561f0054630bfc5f$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $561f0054630bfc5f$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $561f0054630bfc5f$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $561f0054630bfc5f$var$mergeAndOverwriteScopeData(data, "extra", extra);
    $561f0054630bfc5f$var$mergeAndOverwriteScopeData(data, "tags", tags);
    $561f0054630bfc5f$var$mergeAndOverwriteScopeData(data, "attributes", attributes);
    $561f0054630bfc5f$var$mergeAndOverwriteScopeData(data, "user", user);
    $561f0054630bfc5f$var$mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = $6aWHc.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $561f0054630bfc5f$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $6aWHc.merge(data[prop], mergeVal, 1);
}
function $561f0054630bfc5f$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $k1IvE.getGlobalScope().getScopeData();
    isolationScope && $561f0054630bfc5f$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $561f0054630bfc5f$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $561f0054630bfc5f$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $561f0054630bfc5f$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $561f0054630bfc5f$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $561f0054630bfc5f$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $hR4pa.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $6vmlI.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $hR4pa.getRootSpan(span);
    const transactionName = $hR4pa.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $561f0054630bfc5f$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $561f0054630bfc5f$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $561f0054630bfc5f$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $561f0054630bfc5f$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $561f0054630bfc5f$var$mergeScopeData;

});

parcelRegister("5xKoA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7nMWX = parcelRequire("7nMWX");
const $4094060293021f0c$var$DEFAULT_BASE_URL = "thismessage:/";
function $4094060293021f0c$var$isURLObjectRelative(url) {
    return "isRelative" in url;
}
function $4094060293021f0c$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $4094060293021f0c$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $4094060293021f0c$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($4094060293021f0c$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $4094060293021f0c$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $4094060293021f0c$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $4094060293021f0c$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes[$7nMWX.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$4094060293021f0c$var$isURLObjectRelative(urlObject)) {
            attributes[$7nMWX.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $4094060293021f0c$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $4094060293021f0c$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $4094060293021f0c$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $4094060293021f0c$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $4094060293021f0c$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $4094060293021f0c$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $4094060293021f0c$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $4094060293021f0c$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $4094060293021f0c$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $4094060293021f0c$var$parseStringToURLObject;
module.exports.parseUrl = $4094060293021f0c$var$parseUrl;
module.exports.stripDataUrlContent = $4094060293021f0c$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $4094060293021f0c$var$stripUrlQueryAndFragment;

});

parcelRegister("1lgoW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $0fa4798fa882104a$var$scopeContextsToSpanAttributes(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}
module.exports.scopeContextsToSpanAttributes = $0fa4798fa882104a$var$scopeContextsToSpanAttributes;

});


parcelRegister("cwsTk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $j3gO3 = parcelRequire("j3gO3");

var $5VGek = parcelRequire("5VGek");

var $jDmhV = parcelRequire("jDmhV");

var $jm1F1 = parcelRequire("jm1F1");

var $aNZ1M = parcelRequire("aNZ1M");

var $baTSa = parcelRequire("baTSa");

var $7oq4J = parcelRequire("7oq4J");

var $gQok6 = parcelRequire("gQok6");

var $NKzWo = parcelRequire("NKzWo");
function $91dee2721639f9bf$var$captureException(exception, hint) {
    return $k1IvE.getCurrentScope().captureException(exception, $baTSa.parseEventHintOrCaptureContext(hint));
}
function $91dee2721639f9bf$var$captureMessage(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return $k1IvE.getCurrentScope().captureMessage(message, level, hint);
}
function $91dee2721639f9bf$var$captureEvent(event, hint) {
    return $k1IvE.getCurrentScope().captureEvent(event, hint);
}
function $91dee2721639f9bf$var$setContext(name, context) {
    $k1IvE.getIsolationScope().setContext(name, context);
}
function $91dee2721639f9bf$var$setExtras(extras) {
    $k1IvE.getIsolationScope().setExtras(extras);
}
function $91dee2721639f9bf$var$setExtra(key, extra) {
    $k1IvE.getIsolationScope().setExtra(key, extra);
}
function $91dee2721639f9bf$var$setTags(tags) {
    $k1IvE.getIsolationScope().setTags(tags);
}
function $91dee2721639f9bf$var$setTag(key, value) {
    $k1IvE.getIsolationScope().setTag(key, value);
}
function $91dee2721639f9bf$var$setUser(user) {
    $k1IvE.getIsolationScope().setUser(user);
}
function $91dee2721639f9bf$var$setConversationId(conversationId) {
    $k1IvE.getIsolationScope().setConversationId(conversationId);
}
function $91dee2721639f9bf$var$lastEventId() {
    return $k1IvE.getIsolationScope().lastEventId();
}
function $91dee2721639f9bf$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $k1IvE.getCurrentScope();
    const client = $k1IvE.getClient();
    if (!client) $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $aNZ1M.uuid4();
}
function $91dee2721639f9bf$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $91dee2721639f9bf$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = $gQok6.timestampInSeconds();
        function finishCheckIn(status) {
            $91dee2721639f9bf$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $gQok6.timestampInSeconds() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ($jm1F1.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return $k1IvE.withIsolationScope(()=>upsertMonitorConfig?.isolateTrace ? $5VGek.startNewTrace(runCallback) : runCallback());
}
async function $91dee2721639f9bf$var$flush(timeout) {
    const client = $k1IvE.getClient();
    if (client) return client.flush(timeout);
    $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $91dee2721639f9bf$var$close(timeout) {
    const client = $k1IvE.getClient();
    if (client) return client.close(timeout);
    $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $91dee2721639f9bf$var$isInitialized() {
    return !!$k1IvE.getClient();
}
function $91dee2721639f9bf$var$isEnabled() {
    const client = $k1IvE.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $91dee2721639f9bf$var$addEventProcessor(callback) {
    $k1IvE.getIsolationScope().addEventProcessor(callback);
}
function $91dee2721639f9bf$var$startSession(context) {
    const isolationScope = $k1IvE.getIsolationScope();
    const { user: user } = $7oq4J.getCombinedScopeData(isolationScope, $k1IvE.getCurrentScope());
    const { userAgent: userAgent } = $NKzWo.GLOBAL_OBJ.navigator || {};
    const session$1 = $j3gO3.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") $j3gO3.updateSession(currentSession, {
        status: "exited"
    });
    $91dee2721639f9bf$var$endSession();
    isolationScope.setSession(session$1);
    return session$1;
}
function $91dee2721639f9bf$var$endSession() {
    const isolationScope = $k1IvE.getIsolationScope();
    const currentScope = $k1IvE.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $j3gO3.closeSession(session$1);
    $91dee2721639f9bf$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $91dee2721639f9bf$var$_sendSessionUpdate() {
    const isolationScope = $k1IvE.getIsolationScope();
    const client = $k1IvE.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $91dee2721639f9bf$var$captureSession(end = false) {
    if (end) {
        $91dee2721639f9bf$var$endSession();
        return;
    }
    $91dee2721639f9bf$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $91dee2721639f9bf$var$addEventProcessor;
module.exports.captureCheckIn = $91dee2721639f9bf$var$captureCheckIn;
module.exports.captureEvent = $91dee2721639f9bf$var$captureEvent;
module.exports.captureException = $91dee2721639f9bf$var$captureException;
module.exports.captureMessage = $91dee2721639f9bf$var$captureMessage;
module.exports.captureSession = $91dee2721639f9bf$var$captureSession;
module.exports.close = $91dee2721639f9bf$var$close;
module.exports.endSession = $91dee2721639f9bf$var$endSession;
module.exports.flush = $91dee2721639f9bf$var$flush;
module.exports.isEnabled = $91dee2721639f9bf$var$isEnabled;
module.exports.isInitialized = $91dee2721639f9bf$var$isInitialized;
module.exports.lastEventId = $91dee2721639f9bf$var$lastEventId;
module.exports.setContext = $91dee2721639f9bf$var$setContext;
module.exports.setConversationId = $91dee2721639f9bf$var$setConversationId;
module.exports.setExtra = $91dee2721639f9bf$var$setExtra;
module.exports.setExtras = $91dee2721639f9bf$var$setExtras;
module.exports.setTag = $91dee2721639f9bf$var$setTag;
module.exports.setTags = $91dee2721639f9bf$var$setTags;
module.exports.setUser = $91dee2721639f9bf$var$setUser;
module.exports.startSession = $91dee2721639f9bf$var$startSession;
module.exports.withMonitor = $91dee2721639f9bf$var$withMonitor;

});
parcelRegister("baTSa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $JJ1mC = parcelRequire("JJ1mC");

var $3MW4D = parcelRequire("3MW4D");

var $logAX = parcelRequire("logAX");

var $bVnNd = parcelRequire("bVnNd");

var $aNZ1M = parcelRequire("aNZ1M");

var $04GFW = parcelRequire("04GFW");

var $7oq4J = parcelRequire("7oq4J");

var $2b0FU = parcelRequire("2b0FU");

var $bxNZo = parcelRequire("bxNZo");

var $gQok6 = parcelRequire("gQok6");
function $822bf80bd9ff5cb9$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $aNZ1M.uuid4(),
        timestamp: event.timestamp || $gQok6.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $822bf80bd9ff5cb9$var$applyClientOptions(prepared, options);
    $822bf80bd9ff5cb9$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $822bf80bd9ff5cb9$var$applyDebugIds(prepared, options.stackParser);
    const finalScope = $822bf80bd9ff5cb9$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $aNZ1M.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = $7oq4J.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $7oq4J.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? $bxNZo.resolvedSyncPromise(prepared) : $3MW4D.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) $822bf80bd9ff5cb9$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $822bf80bd9ff5cb9$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $822bf80bd9ff5cb9$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || $JJ1mC.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $2b0FU.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = $2b0FU.truncate(exception.value, maxValueLength);
    });
}
function $822bf80bd9ff5cb9$var$applyDebugIds(event, stackParser) {
    const filenameDebugIdMap = $bVnNd.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $822bf80bd9ff5cb9$var$applyDebugMeta(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $822bf80bd9ff5cb9$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $822bf80bd9ff5cb9$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $04GFW.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $04GFW.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $04GFW.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $04GFW.normalize(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = $04GFW.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $04GFW.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $04GFW.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $822bf80bd9ff5cb9$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $logAX.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
function $822bf80bd9ff5cb9$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return void 0;
    if ($822bf80bd9ff5cb9$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($822bf80bd9ff5cb9$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $822bf80bd9ff5cb9$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $logAX.Scope || typeof hint === "function";
}
const $822bf80bd9ff5cb9$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $822bf80bd9ff5cb9$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$822bf80bd9ff5cb9$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $822bf80bd9ff5cb9$var$applyClientOptions;
module.exports.applyDebugIds = $822bf80bd9ff5cb9$var$applyDebugIds;
module.exports.applyDebugMeta = $822bf80bd9ff5cb9$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $822bf80bd9ff5cb9$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $822bf80bd9ff5cb9$var$prepareEvent;

});
parcelRegister("3MW4D", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $jm1F1 = parcelRequire("jm1F1");

var $bxNZo = parcelRequire("bxNZo");
function $2c22e70c755993f0$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $2c22e70c755993f0$var$_notifyEventProcessors(event, hint, processors, index);
        return $jm1F1.isThenable(result) ? result : $bxNZo.resolvedSyncPromise(result);
    } catch (error) {
        return $bxNZo.rejectedSyncPromise(error);
    }
}
function $2c22e70c755993f0$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $cWDS7.DEBUG_BUILD && result === null && $jDmhV.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
    if ($jm1F1.isThenable(result)) return result.then((final)=>$2c22e70c755993f0$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $2c22e70c755993f0$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $2c22e70c755993f0$var$notifyEventProcessors;

});
parcelRegister("bxNZo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jm1F1 = parcelRequire("jm1F1");
const $86798d9c0254fea8$var$STATE_PENDING = 0;
const $86798d9c0254fea8$var$STATE_RESOLVED = 1;
const $86798d9c0254fea8$var$STATE_REJECTED = 2;
function $86798d9c0254fea8$var$resolvedSyncPromise(value) {
    return new $86798d9c0254fea8$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
function $86798d9c0254fea8$var$rejectedSyncPromise(reason) {
    return new $86798d9c0254fea8$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
class $86798d9c0254fea8$var$SyncPromise {
    constructor(executor){
        this._state = $86798d9c0254fea8$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $86798d9c0254fea8$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $86798d9c0254fea8$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $86798d9c0254fea8$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $86798d9c0254fea8$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $86798d9c0254fea8$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $86798d9c0254fea8$var$STATE_PENDING) return;
            if ($jm1F1.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($86798d9c0254fea8$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($86798d9c0254fea8$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $86798d9c0254fea8$var$SyncPromise;
module.exports.rejectedSyncPromise = $86798d9c0254fea8$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $86798d9c0254fea8$var$resolvedSyncPromise;

});


parcelRegister("bVnNd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aWndQ = parcelRequire("aWndQ");

var $NKzWo = parcelRequire("NKzWo");
let $8ae779574c544f8b$var$parsedStackResults;
let $8ae779574c544f8b$var$lastSentryKeysCount;
let $8ae779574c544f8b$var$lastNativeKeysCount;
let $8ae779574c544f8b$var$cachedFilenameDebugIds;
function $8ae779574c544f8b$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $NKzWo.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $NKzWo.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($8ae779574c544f8b$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $8ae779574c544f8b$var$lastSentryKeysCount && nativeDebugIdKeys.length === $8ae779574c544f8b$var$lastNativeKeysCount) return $8ae779574c544f8b$var$cachedFilenameDebugIds;
    $8ae779574c544f8b$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $8ae779574c544f8b$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $8ae779574c544f8b$var$cachedFilenameDebugIds = {};
    if (!$8ae779574c544f8b$var$parsedStackResults) $8ae779574c544f8b$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $8ae779574c544f8b$var$parsedStackResults?.[key];
            if (result && $8ae779574c544f8b$var$cachedFilenameDebugIds && debugId) {
                $8ae779574c544f8b$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($8ae779574c544f8b$var$parsedStackResults) $8ae779574c544f8b$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $8ae779574c544f8b$var$cachedFilenameDebugIds && $8ae779574c544f8b$var$parsedStackResults) {
                        $8ae779574c544f8b$var$cachedFilenameDebugIds[filename] = debugId;
                        $8ae779574c544f8b$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $8ae779574c544f8b$var$cachedFilenameDebugIds;
}
function $8ae779574c544f8b$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $8ae779574c544f8b$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $aWndQ.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $8ae779574c544f8b$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $8ae779574c544f8b$var$getFilenameToDebugIdMap;

});



parcelRegister("1vcEw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $luwRx = parcelRequire("luwRx");
const $118280412a4ec45a$var$SENTRY_API_VERSION = "7";
function $118280412a4ec45a$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $118280412a4ec45a$var$_getIngestEndpoint(dsn) {
    return `${$118280412a4ec45a$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $118280412a4ec45a$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $118280412a4ec45a$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $118280412a4ec45a$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$118280412a4ec45a$var$_getIngestEndpoint(dsn)}?${$118280412a4ec45a$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $118280412a4ec45a$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $luwRx.makeDsn(dsnLike);
    if (!dsn$1) return "";
    const endpoint = `${$118280412a4ec45a$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$luwRx.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $118280412a4ec45a$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $118280412a4ec45a$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $118280412a4ec45a$var$getReportDialogEndpoint;

});

parcelRegister("hLkUK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1vcEw = parcelRequire("1vcEw");

var $JJ1mC = parcelRequire("JJ1mC");

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $6a1Ld = parcelRequire("6a1Ld");

var $2Rd9o = parcelRequire("2Rd9o");

var $9xCLH = parcelRequire("9xCLH");

var $3bTow = parcelRequire("3bTow");

var $j3gO3 = parcelRequire("j3gO3");

var $6vmlI = parcelRequire("6vmlI");

var $4BYqM = parcelRequire("4BYqM");

var $9tXk5 = parcelRequire("9tXk5");

var $jB2cn = parcelRequire("jB2cn");

var $2NgE3 = parcelRequire("2NgE3");

var $jDmhV = parcelRequire("jDmhV");

var $luwRx = parcelRequire("luwRx");

var $dQ0Qv = parcelRequire("dQ0Qv");

var $7BAlY = parcelRequire("7BAlY");

var $jm1F1 = parcelRequire("jm1F1");

var $6aWHc = parcelRequire("6aWHc");

var $aNZ1M = parcelRequire("aNZ1M");

var $jsTRh = parcelRequire("jsTRh");

var $baTSa = parcelRequire("baTSa");

var $hRFVl = parcelRequire("hRFVl");

var $lc80H = parcelRequire("lc80H");

var $aD0ts = parcelRequire("aD0ts");

var $hR4pa = parcelRequire("hR4pa");

var $bxNZo = parcelRequire("bxNZo");

var $40w67 = parcelRequire("40w67");

var $cjnV7 = parcelRequire("cjnV7");

var $9czdp = parcelRequire("9czdp");
const $cee70c9eef0ec50e$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $cee70c9eef0ec50e$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $cee70c9eef0ec50e$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $cee70c9eef0ec50e$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $cee70c9eef0ec50e$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $cee70c9eef0ec50e$var$_makeInternalError(message) {
    return {
        message: message,
        [$cee70c9eef0ec50e$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $cee70c9eef0ec50e$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$cee70c9eef0ec50e$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $cee70c9eef0ec50e$var$_isInternalError(error) {
    return !!error && typeof error === "object" && $cee70c9eef0ec50e$var$INTERNAL_ERROR_SYMBOL in error;
}
function $cee70c9eef0ec50e$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === "object" && $cee70c9eef0ec50e$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $cee70c9eef0ec50e$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $cee70c9eef0ec50e$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = $40w67.safeUnref(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $cee70c9eef0ec50e$var$Client {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $hRFVl.makePromiseBuffer(options.transportOptions?.bufferSize ?? $jB2cn.DEFAULT_TRANSPORT_BUFFER_SIZE);
        this._dataCollection = $9czdp.resolveDataCollectionOptions(options);
        if (options.dsn) this._dsn = $luwRx.makeDsn(options.dsn);
        else $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = $1vcEw.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        if (this._options.enableLogs) $cee70c9eef0ec50e$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $cee70c9eef0ec50e$var$estimateLogSizeInBytes, $9xCLH._INTERNAL_flushLogsBuffer);
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $cee70c9eef0ec50e$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $cee70c9eef0ec50e$var$estimateMetricSizeInBytes, $3bTow._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $aNZ1M.uuid4();
        if ($aNZ1M.checkOrSetAlreadyCaught(exception)) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.log($cee70c9eef0ec50e$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $aNZ1M.uuid4(),
            ...hint
        };
        const eventMessage = $jm1F1.isParameterizedString(message) ? message : String(message);
        const isMessage = $jm1F1.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $aNZ1M.uuid4();
        if (hint?.originalException && $aNZ1M.checkOrSetAlreadyCaught(hint.originalException)) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.log($cee70c9eef0ec50e$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $cee70c9eef0ec50e$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        $j3gO3.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        $9xCLH._INTERNAL_flushLogsBuffer(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        $2Rd9o.setupIntegration(this, integration$1, this._integrations);
        if (!isAlreadyInstalled) $2Rd9o.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = $9tXk5.extractGenAiSpansFromEvent(event, this);
        let env = $6a1Ld.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = $dQ0Qv.addItemToEnvelope(env, $dQ0Qv.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $dQ0Qv.addItemToEnvelope(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $JJ1mC.DEFAULT_ENVIRONMENT } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn($cee70c9eef0ec50e$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn($cee70c9eef0ec50e$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = $6a1Ld.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.error("Error while sending envelope:", reason);
            return {};
        }
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $2Rd9o.setupIntegrations(this, integrations);
        $2Rd9o.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session$1.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $j3gO3.updateSession(session$1, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $baTSa.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$k1IvE.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $6vmlI.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $k1IvE.getCurrentScope(), isolationScope = $k1IvE.getIsolationScope()) {
        if ($cWDS7.DEBUG_BUILD && $cee70c9eef0ec50e$var$isErrorEvent(event)) $jDmhV.debug.log(`Captured error event \`${$7BAlY.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($cWDS7.DEBUG_BUILD) {
                if ($cee70c9eef0ec50e$var$_isDoNotSendEventError(reason)) $jDmhV.debug.log(reason.message);
                else if ($cee70c9eef0ec50e$var$_isInternalError(reason)) $jDmhV.debug.warn(reason.message);
                else $jDmhV.debug.warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $cee70c9eef0ec50e$var$isTransactionEvent(event);
        const isError = $cee70c9eef0ec50e$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : $jsTRh.parseSampleRate(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && $lc80H.safeMathRandom() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return $bxNZo.rejectedSyncPromise($cee70c9eef0ec50e$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $cee70c9eef0ec50e$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $cee70c9eef0ec50e$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $cee70c9eef0ec50e$var$processBeforeSend(this, options, prepared, hint);
            return $cee70c9eef0ec50e$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $cee70c9eef0ec50e$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($cee70c9eef0ec50e$var$_isDoNotSendEventError(reason) || $cee70c9eef0ec50e$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $cee70c9eef0ec50e$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $hRFVl.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("No dsn provided, will not send outcomes");
            return;
        }
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("Sending outcomes:", outcomes);
        const envelope = $2NgE3.createClientReportEnvelope(outcomes, this._options.tunnel && $luwRx.dsnToString(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $cee70c9eef0ec50e$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $cee70c9eef0ec50e$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($jm1F1.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$jm1F1.isPlainObject(event) && event !== null) throw $cee70c9eef0ec50e$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $cee70c9eef0ec50e$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$jm1F1.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $cee70c9eef0ec50e$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $cee70c9eef0ec50e$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$4BYqM.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($cee70c9eef0ec50e$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($cee70c9eef0ec50e$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan$1 || ignoreSpans) {
            const rootSpanJson = $cjnV7.convertTransactionEventToSpanJson(processedEvent);
            if (ignoreSpans?.length && $aD0ts.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $hR4pa.showSpanDropWarning();
                else processedEvent = $6aWHc.merge(event, $cjnV7.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && $aD0ts.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $aD0ts.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $hR4pa.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $cee70c9eef0ec50e$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $cee70c9eef0ec50e$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $cee70c9eef0ec50e$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $cee70c9eef0ec50e$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $cee70c9eef0ec50e$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $cee70c9eef0ec50e$var$estimateAttributesSizeInBytes(log.attributes);
}
function $cee70c9eef0ec50e$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $cee70c9eef0ec50e$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($jm1F1.isPrimitive(value)) weight += $cee70c9eef0ec50e$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $cee70c9eef0ec50e$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}
module.exports.Client = $cee70c9eef0ec50e$var$Client;

});
parcelRegister("2Rd9o", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");
const $214abb710ae53e29$var$installedIntegrations = [];
function $214abb710ae53e29$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $214abb710ae53e29$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $214abb710ae53e29$var$filterDuplicates(integrations);
}
function $214abb710ae53e29$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $214abb710ae53e29$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $214abb710ae53e29$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $214abb710ae53e29$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$214abb710ae53e29$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $214abb710ae53e29$var$installedIntegrations.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`Integration installed: ${integration.name}`);
}
function $214abb710ae53e29$var$addIntegration(integration) {
    const client = $k1IvE.getClient();
    if (!client) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $214abb710ae53e29$var$defineIntegration(fn) {
    return fn;
}
module.exports.addIntegration = $214abb710ae53e29$var$addIntegration;
module.exports.afterSetupIntegrations = $214abb710ae53e29$var$afterSetupIntegrations;
module.exports.defineIntegration = $214abb710ae53e29$var$defineIntegration;
module.exports.getIntegrationsToSetup = $214abb710ae53e29$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $214abb710ae53e29$var$installedIntegrations;
module.exports.setupIntegration = $214abb710ae53e29$var$setupIntegration;
module.exports.setupIntegrations = $214abb710ae53e29$var$setupIntegrations;

});

parcelRegister("9xCLH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gLiBf = parcelRequire("gLiBf");

var $kJVFD = parcelRequire("kJVFD");

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $jm1F1 = parcelRequire("jm1F1");

var $7oq4J = parcelRequire("7oq4J");

var $43BuU = parcelRequire("43BuU");

var $gQok6 = parcelRequire("gQok6");

var $jEZVN = parcelRequire("jEZVN");

var $1DlTo = parcelRequire("1DlTo");

var $lpK0l = parcelRequire("lpK0l");

var $6TV5C = parcelRequire("6TV5C");
const $6f2544ba0d4757cf$var$MAX_LOG_BUFFER_SIZE = 100;
function $6f2544ba0d4757cf$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $6f2544ba0d4757cf$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $6f2544ba0d4757cf$var$_getBufferMap();
    const logBuffer = $6f2544ba0d4757cf$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $6f2544ba0d4757cf$var$MAX_LOG_BUFFER_SIZE) {
        $6f2544ba0d4757cf$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $6f2544ba0d4757cf$var$_INTERNAL_captureLog(beforeLog, currentScope = $k1IvE.getCurrentScope(), captureSerializedLog = $6f2544ba0d4757cf$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $k1IvE.getClient();
    if (!client) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = $1DlTo._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $7oq4J.getCombinedScopeData($k1IvE.getIsolationScope(), currentScope);
    $6f2544ba0d4757cf$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $6f2544ba0d4757cf$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $6f2544ba0d4757cf$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $6f2544ba0d4757cf$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $6f2544ba0d4757cf$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $6f2544ba0d4757cf$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $6f2544ba0d4757cf$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $6f2544ba0d4757cf$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $6f2544ba0d4757cf$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ($jm1F1.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $43BuU._getSpanForScope(currentScope);
    $6f2544ba0d4757cf$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? $jDmhV.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $gQok6.timestampInSeconds();
    const sequenceAttr = $jEZVN.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $6f2544ba0d4757cf$var$_removeLoneSurrogates(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $lpK0l.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: $6f2544ba0d4757cf$var$sanitizeLogAttributes({
            ...$gLiBf.serializeAttributes(scopeAttributes),
            ...$gLiBf.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $6f2544ba0d4757cf$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $6f2544ba0d4757cf$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $6TV5C.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $6f2544ba0d4757cf$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope$1);
}
function $6f2544ba0d4757cf$var$_INTERNAL_getLogBuffer(client) {
    return $6f2544ba0d4757cf$var$_getBufferMap().get(client);
}
function $6f2544ba0d4757cf$var$_getBufferMap() {
    return $kJVFD.getGlobalSingleton("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $6f2544ba0d4757cf$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $6f2544ba0d4757cf$var$_removeLoneSurrogates(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $6f2544ba0d4757cf$var$_removeLoneSurrogates(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $6f2544ba0d4757cf$var$_removeLoneSurrogates(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
module.exports._INTERNAL_captureLog = $6f2544ba0d4757cf$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $6f2544ba0d4757cf$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $6f2544ba0d4757cf$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $6f2544ba0d4757cf$var$_INTERNAL_getLogBuffer;
module.exports._removeLoneSurrogates = $6f2544ba0d4757cf$var$_removeLoneSurrogates;

});
parcelRegister("jEZVN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e501cafec268c9e3$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $e501cafec268c9e3$var$_sequenceNumber = 0;
let $e501cafec268c9e3$var$_previousTimestampMs;
function $e501cafec268c9e3$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($e501cafec268c9e3$var$_previousTimestampMs !== void 0 && nowMs !== $e501cafec268c9e3$var$_previousTimestampMs) $e501cafec268c9e3$var$_sequenceNumber = 0;
    const value = $e501cafec268c9e3$var$_sequenceNumber;
    $e501cafec268c9e3$var$_sequenceNumber++;
    $e501cafec268c9e3$var$_previousTimestampMs = nowMs;
    return {
        key: $e501cafec268c9e3$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}
module.exports.getSequenceAttribute = $e501cafec268c9e3$var$getSequenceAttribute;

});

parcelRegister("1DlTo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $6vmlI = parcelRequire("6vmlI");

var $hR4pa = parcelRequire("hR4pa");
function $130a6a5cf8d5ce14$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return $k1IvE.withScope(scope, ()=>{
        const span = $hR4pa.getActiveSpan();
        const traceContext = span ? $hR4pa.spanToTraceContext(span) : $k1IvE.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $6vmlI.getDynamicSamplingContextFromSpan(span) : $6vmlI.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $130a6a5cf8d5ce14$var$_getTraceInfoFromScope;

});

parcelRegister("lpK0l", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f96f9e54639dde7b$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $f96f9e54639dde7b$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("6TV5C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $luwRx = parcelRequire("luwRx");

var $dQ0Qv = parcelRequire("dQ0Qv");

var $kQG62 = parcelRequire("kQG62");
function $506429f4f68c1030$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...$kQG62.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $506429f4f68c1030$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $luwRx.dsnToString(dsn$1);
    return $dQ0Qv.createEnvelope(headers, [
        $506429f4f68c1030$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $506429f4f68c1030$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $506429f4f68c1030$var$createLogEnvelope;

});
parcelRegister("kQG62", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3FGHr = parcelRequire("3FGHr");

var $NKzWo = parcelRequire("NKzWo");
function $f2d95170ecd59e53$var$isBrowser() {
    return typeof window !== "undefined" && (!$3FGHr.isNodeEnv() || $f2d95170ecd59e53$var$isElectronNodeRenderer());
}
function $f2d95170ecd59e53$var$isElectronNodeRenderer() {
    const process = $NKzWo.GLOBAL_OBJ.process;
    return process?.type === "renderer";
}
module.exports.isBrowser = $f2d95170ecd59e53$var$isBrowser;

});
parcelRegister("3FGHr", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $94dSL = parcelRequire("94dSL");
function isNodeEnv() {
    return !$94dSL.isBrowserBundle() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("94dSL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $699f418422713b31$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $699f418422713b31$var$getSDKSource() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}
module.exports.getSDKSource = $699f418422713b31$var$getSDKSource;
module.exports.isBrowserBundle = $699f418422713b31$var$isBrowserBundle;

});





parcelRegister("3bTow", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gLiBf = parcelRequire("gLiBf");

var $kJVFD = parcelRequire("kJVFD");

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $7oq4J = parcelRequire("7oq4J");

var $43BuU = parcelRequire("43BuU");

var $gQok6 = parcelRequire("gQok6");

var $jEZVN = parcelRequire("jEZVN");

var $1DlTo = parcelRequire("1DlTo");

var $57AiB = parcelRequire("57AiB");
const $252d5e62d679a538$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $252d5e62d679a538$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $252d5e62d679a538$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $252d5e62d679a538$var$_getBufferMap();
    const metricBuffer = $252d5e62d679a538$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $252d5e62d679a538$var$MAX_METRIC_BUFFER_SIZE) {
        $252d5e62d679a538$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $252d5e62d679a538$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $252d5e62d679a538$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $252d5e62d679a538$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $252d5e62d679a538$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $252d5e62d679a538$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $252d5e62d679a538$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $252d5e62d679a538$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $252d5e62d679a538$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $252d5e62d679a538$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $252d5e62d679a538$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $252d5e62d679a538$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = $1DlTo._getTraceInfoFromScope(client, currentScope);
    const span = $43BuU._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = $gQok6.timestampInSeconds();
    const sequenceAttr = $jEZVN.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$gLiBf.serializeAttributes(scopeAttributes),
            ...$gLiBf.serializeAttributes(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $252d5e62d679a538$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $k1IvE.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $252d5e62d679a538$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $k1IvE.getClient();
    if (!client) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = $7oq4J.getCombinedScopeData($k1IvE.getIsolationScope(), currentScope);
    const enrichedMetric = $252d5e62d679a538$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $252d5e62d679a538$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $252d5e62d679a538$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $252d5e62d679a538$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $57AiB.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $252d5e62d679a538$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope$1);
}
function $252d5e62d679a538$var$_INTERNAL_getMetricBuffer(client) {
    return $252d5e62d679a538$var$_getBufferMap().get(client);
}
function $252d5e62d679a538$var$_getBufferMap() {
    return $kJVFD.getGlobalSingleton("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
module.exports._INTERNAL_captureMetric = $252d5e62d679a538$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $252d5e62d679a538$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $252d5e62d679a538$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $252d5e62d679a538$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("57AiB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $luwRx = parcelRequire("luwRx");

var $dQ0Qv = parcelRequire("dQ0Qv");

var $kQG62 = parcelRequire("kQG62");
function $3ba9c3710696379f$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...$kQG62.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $3ba9c3710696379f$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $luwRx.dsnToString(dsn$1);
    return $dQ0Qv.createEnvelope(headers, [
        $3ba9c3710696379f$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $3ba9c3710696379f$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $3ba9c3710696379f$var$createMetricEnvelope;

});


parcelRegister("9tXk5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kQG62 = parcelRequire("kQG62");

var $lk94N = parcelRequire("lk94N");

var $La0yh = parcelRequire("La0yh");
function $6e74d6cf8f33f864$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || !client.getOptions().streamGenAiSpans || $lk94N.hasSpanStreamingEnabled(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push($La0yh.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$kQG62.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $6e74d6cf8f33f864$var$extractGenAiSpansFromEvent;

});
parcelRegister("La0yh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hR4pa = parcelRequire("hR4pa");
function $08dc27431f1d2a72$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $hR4pa.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $08dc27431f1d2a72$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("jB2cn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $dQ0Qv = parcelRequire("dQ0Qv");

var $hRFVl = parcelRequire("hRFVl");

var $1NysQ = parcelRequire("1NysQ");
const $e4432d9fcd71e12d$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function $e4432d9fcd71e12d$var$createTransport(options, makeRequest, buffer = $hRFVl.makePromiseBuffer(options.bufferSize || $e4432d9fcd71e12d$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        $dQ0Qv.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $dQ0Qv.envelopeItemTypeToDataCategory(type);
            if ($1NysQ.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $dQ0Qv.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ($dQ0Qv.envelopeContainsItemType(filteredEnvelope, [
                "client_report"
            ])) {
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $dQ0Qv.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $dQ0Qv.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $dQ0Qv.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    $cWDS7.DEBUG_BUILD && $jDmhV.debug.error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ($cWDS7.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) $jDmhV.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $1NysQ.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $hRFVl.SENTRY_BUFFER_FULL_ERROR) {
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $e4432d9fcd71e12d$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $e4432d9fcd71e12d$var$createTransport;

});
parcelRegister("hRFVl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bxNZo = parcelRequire("bxNZo");

var $40w67 = parcelRequire("40w67");
const $d017e818c509616d$var$SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $d017e818c509616d$var$makePromiseBuffer(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return $bxNZo.rejectedSyncPromise($d017e818c509616d$var$SENTRY_BUFFER_FULL_ERROR);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return $bxNZo.resolvedSyncPromise(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$40w67.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $d017e818c509616d$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $d017e818c509616d$var$makePromiseBuffer;

});
parcelRegister("40w67", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $2eb00f78358cc88c$var$safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}
module.exports.safeUnref = $2eb00f78358cc88c$var$safeUnref;

});


parcelRegister("1NysQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lc80H = parcelRequire("lc80H");
const $14f519f16b6ca16b$var$DEFAULT_RETRY_AFTER = 60000;
function $14f519f16b6ca16b$var$parseRetryAfterHeader(header, now = $lc80H.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $14f519f16b6ca16b$var$DEFAULT_RETRY_AFTER;
}
function $14f519f16b6ca16b$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $14f519f16b6ca16b$var$isRateLimited(limits, dataCategory, now = $lc80H.safeDateNow()) {
    return $14f519f16b6ca16b$var$disabledUntil(limits, dataCategory) > now;
}
function $14f519f16b6ca16b$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $lc80H.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $14f519f16b6ca16b$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $14f519f16b6ca16b$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $14f519f16b6ca16b$var$disabledUntil;
module.exports.isRateLimited = $14f519f16b6ca16b$var$isRateLimited;
module.exports.parseRetryAfterHeader = $14f519f16b6ca16b$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $14f519f16b6ca16b$var$updateRateLimits;

});


parcelRegister("2NgE3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dQ0Qv = parcelRequire("dQ0Qv");

var $gQok6 = parcelRequire("gQok6");
function $208d11b7e0d64729$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || $gQok6.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $dQ0Qv.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $208d11b7e0d64729$var$createClientReportEnvelope;

});

parcelRegister("7BAlY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $5898301d1f6ef3dd$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $5898301d1f6ef3dd$var$getPossibleEventMessages;

});

parcelRegister("cjnV7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7nMWX = parcelRequire("7nMWX");
function $8f69d075c02d447e$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[$7nMWX.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$7nMWX.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $8f69d075c02d447e$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$7nMWX.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$7nMWX.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $8f69d075c02d447e$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $8f69d075c02d447e$var$convertTransactionEventToSpanJson;

});

parcelRegister("9czdp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8PgFX = parcelRequire("8PgFX");
const $6b308d103d3f87db$var$DEFAULTS = {
    userInfo: false,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [],
    queryParams: true,
    genAI: {
        inputs: true,
        outputs: true
    },
    stackFrameVariables: true,
    frameContextLines: 5
};
function $6b308d103d3f87db$var$resolveDataCollectionOptions(options) {
    const base = options.dataCollection != null ? $6b308d103d3f87db$var$DEFAULTS : $8PgFX.defaultPiiToCollectionOptions(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: {
            request: dc.httpHeaders?.request ?? base.httpHeaders.request,
            response: dc.httpHeaders?.response ?? base.httpHeaders.response
        },
        httpBodies: dc.httpBodies ?? base.httpBodies,
        queryParams: dc.queryParams ?? base.queryParams,
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}
module.exports.resolveDataCollectionOptions = $6b308d103d3f87db$var$resolveDataCollectionOptions;

});
parcelRegister("8PgFX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i9b9S = parcelRequire("i9b9S");
function $66d005a0b33e8c8d$var$defaultPiiToCollectionOptions(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        queryParams: true,
        genAI: {
            inputs: true,
            outputs: true
        },
        stackFrameVariables: true,
        frameContextLines: 5
    } : {
        userInfo: false,
        cookies: {
            deny: $i9b9S.PII_HEADER_SNIPPETS
        },
        httpHeaders: {
            request: {
                deny: $i9b9S.PII_HEADER_SNIPPETS
            },
            response: {
                deny: $i9b9S.PII_HEADER_SNIPPETS
            }
        },
        httpBodies: [],
        queryParams: {
            deny: $i9b9S.PII_HEADER_SNIPPETS
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        stackFrameVariables: true,
        frameContextLines: 5
    };
}
module.exports.defaultPiiToCollectionOptions = $66d005a0b33e8c8d$var$defaultPiiToCollectionOptions;

});
parcelRegister("i9b9S", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $d361b913463882ec$var$FILTERED_VALUE = "[Filtered]";
const $d361b913463882ec$var$PII_HEADER_SNIPPETS = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $d361b913463882ec$var$SENSITIVE_KEY_SNIPPETS = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $d361b913463882ec$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];
module.exports.FILTERED_VALUE = $d361b913463882ec$var$FILTERED_VALUE;
module.exports.PII_HEADER_SNIPPETS = $d361b913463882ec$var$PII_HEADER_SNIPPETS;
module.exports.SENSITIVE_COOKIE_NAME_SNIPPETS = $d361b913463882ec$var$SENSITIVE_COOKIE_NAME_SNIPPETS;
module.exports.SENSITIVE_KEY_SNIPPETS = $d361b913463882ec$var$SENSITIVE_KEY_SNIPPETS;

});




parcelRegister("eC4Ya", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");
function $aa38782505790c89$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($cWDS7.DEBUG_BUILD) $jDmhV.debug.enable();
        else $jDmhV.consoleSandbox(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = $k1IvE.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $aa38782505790c89$var$setCurrentClient(client);
    client.init();
    return client;
}
function $aa38782505790c89$var$setCurrentClient(client) {
    $k1IvE.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $aa38782505790c89$var$initAndBind;
module.exports.setCurrentClient = $aa38782505790c89$var$setCurrentClient;

});

parcelRegister("3xShP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $dQ0Qv = parcelRequire("dQ0Qv");

var $1NysQ = parcelRequire("1NysQ");

var $40w67 = parcelRequire("40w67");
const $294e90536e6ee5e4$var$MIN_DELAY = 100;
const $294e90536e6ee5e4$var$START_DELAY = 5e3;
const $294e90536e6ee5e4$var$MAX_DELAY = 36e5;
function $294e90536e6ee5e4$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $294e90536e6ee5e4$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay2) {
            if ($dQ0Qv.envelopeContainsItemType(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay2);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = $40w67.safeUnref(setTimeout(async ()=>{
                flushTimer = void 0;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    found[0].sent_at = /* @__PURE__ */ new Date().toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $294e90536e6ee5e4$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            if (!isRetry && $dQ0Qv.envelopeContainsItemType(envelope$1, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope$1);
                flushIn($294e90536e6ee5e4$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope$1);
                let delay = $294e90536e6ee5e4$var$MIN_DELAY;
                if (result) {
                    if (result.headers?.["retry-after"]) delay = $1NysQ.parseRetryAfterHeader(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 6e4;
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $294e90536e6ee5e4$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                if (timeout === void 0) {
                    retryDelay = $294e90536e6ee5e4$var$START_DELAY;
                    flushIn($294e90536e6ee5e4$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $294e90536e6ee5e4$var$MIN_DELAY;
module.exports.START_DELAY = $294e90536e6ee5e4$var$START_DELAY;
module.exports.makeOfflineTransport = $294e90536e6ee5e4$var$makeOfflineTransport;

});

parcelRegister("kpDSY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1vcEw = parcelRequire("1vcEw");

var $luwRx = parcelRequire("luwRx");

var $dQ0Qv = parcelRequire("dQ0Qv");
const $edc514e4ef478865$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
function $edc514e4ef478865$var$eventFromEnvelope(env, types) {
    let event;
    $dQ0Qv.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : void 0;
        return !!event;
    });
    return event;
}
function $edc514e4ef478865$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $edc514e4ef478865$var$eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
function $edc514e4ef478865$var$overrideDsn(envelope$1, dsn) {
    return $dQ0Qv.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
function $edc514e4ef478865$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = /* @__PURE__ */ new Map();
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$edc514e4ef478865$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$edc514e4ef478865$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$edc514e4ef478865$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $luwRx.dsnFromString(dsn$1);
                if (!validatedDsn) return void 0;
                const url = $1vcEw.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $edc514e4ef478865$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return $edc514e4ef478865$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, void 0);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($edc514e4ef478865$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $edc514e4ef478865$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $edc514e4ef478865$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $edc514e4ef478865$var$makeMultiplexedTransport;

});

parcelRegister("LRu51", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");
const $08fde0bdce1bf1fb$var$SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
function $08fde0bdce1bf1fb$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $08fde0bdce1bf1fb$var$SKIPPED_AI_PROVIDERS.add(module);
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
function $08fde0bdce1bf1fb$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $08fde0bdce1bf1fb$var$SKIPPED_AI_PROVIDERS.has(module);
}
function $08fde0bdce1bf1fb$var$_INTERNAL_clearAiProviderSkips() {
    $08fde0bdce1bf1fb$var$SKIPPED_AI_PROVIDERS.clear();
    $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("Cleared AI provider skip registrations");
}
module.exports._INTERNAL_clearAiProviderSkips = $08fde0bdce1bf1fb$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $08fde0bdce1bf1fb$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $08fde0bdce1bf1fb$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("3kuJo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i9b9S = parcelRequire("i9b9S");
function $26cb13ec9539854f$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $26cb13ec9539854f$var$filterKeyValueData(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const denySnippets = additionalDenyTerms != null ? [
        ...$i9b9S.SENSITIVE_KEY_SNIPPETS,
        ...additionalDenyTerms
    ] : $i9b9S.SENSITIVE_KEY_SNIPPETS;
    const result = {};
    if (behavior === true) {
        for (const key of Object.keys(data))result[key] = $26cb13ec9539854f$var$isSensitiveKey(key.toLowerCase(), denySnippets) ? $i9b9S.FILTERED_VALUE : data[key];
        return result;
    }
    if ("deny" in behavior) {
        const lowerTerms2 = behavior.deny.map((t)=>t.toLowerCase());
        for (const key of Object.keys(data)){
            const lower = key.toLowerCase();
            const isDenied = $26cb13ec9539854f$var$isSensitiveKey(lower, denySnippets) || lowerTerms2.some((term)=>lower.includes(term));
            result[key] = isDenied ? $i9b9S.FILTERED_VALUE : data[key];
        }
        return result;
    }
    const lowerTerms = behavior.allow.map((t)=>t.toLowerCase());
    for (const key of Object.keys(data)){
        const lower = key.toLowerCase();
        if ($26cb13ec9539854f$var$isSensitiveKey(lower, denySnippets)) result[key] = $i9b9S.FILTERED_VALUE;
        else {
            const isAllowed = lowerTerms.some((term)=>lower.includes(term));
            result[key] = isAllowed ? data[key] : $i9b9S.FILTERED_VALUE;
        }
    }
    return result;
}
module.exports.filterKeyValueData = $26cb13ec9539854f$var$filterKeyValueData;

});

parcelRegister("1OEds", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1y4io = parcelRequire("1y4io");

var $i9b9S = parcelRequire("i9b9S");

var $3kuJo = parcelRequire("3kuJo");
function $1529a80d39dd7c4c$var$filterCookies(cookieString, behavior) {
    if (behavior === false) return {};
    try {
        const parsed = $1y4io.parseCookie(cookieString);
        if (Object.keys(parsed).length === 0) return {};
        return $3kuJo.filterKeyValueData(parsed, behavior, $i9b9S.SENSITIVE_COOKIE_NAME_SNIPPETS);
    } catch  {
        return $i9b9S.FILTERED_VALUE;
    }
}
module.exports.filterCookies = $1529a80d39dd7c4c$var$filterCookies;

});
parcelRegister("1y4io", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $120c4c75f239ec65$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            if (val.charCodeAt(0) === 34) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $120c4c75f239ec65$var$parseCookie;

});


parcelRegister("7dsZ5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i9b9S = parcelRequire("i9b9S");

var $3kuJo = parcelRequire("3kuJo");
function $54103afc94ecf16d$var$filterQueryParams(queryString, behavior) {
    if (behavior === false) return {};
    try {
        const params = new URLSearchParams(queryString);
        const parsed = {};
        params.forEach((value, key)=>{
            parsed[key] = value;
        });
        if (Object.keys(parsed).length === 0) return {};
        return $3kuJo.filterKeyValueData(parsed, behavior);
    } catch  {
        return $i9b9S.FILTERED_VALUE;
    }
}
module.exports.filterQueryParams = $54103afc94ecf16d$var$filterQueryParams;

});

parcelRegister("7vf3z", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $57671b92dbd62e1c$var$FALSY_ENV_VALUES = /* @__PURE__ */ new Set([
    "false",
    "f",
    "n",
    "no",
    "off",
    "0"
]);
const $57671b92dbd62e1c$var$TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set([
    "true",
    "t",
    "y",
    "yes",
    "on",
    "1"
]);
function $57671b92dbd62e1c$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($57671b92dbd62e1c$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($57671b92dbd62e1c$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $57671b92dbd62e1c$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $57671b92dbd62e1c$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $57671b92dbd62e1c$var$envToBool;

});

parcelRegister("3ldya", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $luwRx = parcelRequire("luwRx");

var $dQ0Qv = parcelRequire("dQ0Qv");
function $26edd8077f989996$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: /* @__PURE__ */ new Date().toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $luwRx.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $26edd8077f989996$var$createCheckInEnvelopeItem(checkIn);
    return $dQ0Qv.createEnvelope(headers, [
        item
    ]);
}
function $26edd8077f989996$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $26edd8077f989996$var$createCheckInEnvelope;

});

parcelRegister("gjtOy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5xKoA = parcelRequire("5xKoA");
function $be058c39df37caf4$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $be058c39df37caf4$var$checkDsn(url, dsn) || $be058c39df37caf4$var$checkTunnel(url, tunnel);
}
function $be058c39df37caf4$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $be058c39df37caf4$var$removeTrailingSlash(url) === $be058c39df37caf4$var$removeTrailingSlash(tunnel);
}
function $be058c39df37caf4$var$checkDsn(url$1, dsn) {
    const urlParts = $5xKoA.parseStringToURLObject(url$1);
    if (!urlParts || $5xKoA.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $be058c39df37caf4$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $be058c39df37caf4$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $be058c39df37caf4$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $be058c39df37caf4$var$isSentryRequestUrl;

});

parcelRegister("4QmUc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $386dc94dd25041bc$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
const $386dc94dd25041bc$var$fmt = $386dc94dd25041bc$var$parameterize;
module.exports.fmt = $386dc94dd25041bc$var$fmt;
module.exports.parameterize = $386dc94dd25041bc$var$parameterize;

});

parcelRegister("c6nxn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1vcEw = parcelRequire("1vcEw");

var $jDmhV = parcelRequire("jDmhV");

var $luwRx = parcelRequire("luwRx");

var $dQ0Qv = parcelRequire("dQ0Qv");
async function $8cf84d9786ab8209$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response("Tunnel not configured", {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $dQ0Qv.parseEnvelope(body);
    } catch  {
        return new Response("Invalid envelope", {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response("Invalid envelope: missing header", {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response("Invalid envelope: missing DSN", {
        status: 400
    });
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $jDmhV.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response("DSN not allowed", {
            status: 403
        });
    }
    const dsnComponents = $luwRx.makeDsn(dsn$1);
    if (!dsnComponents) {
        $jDmhV.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response("Invalid DSN", {
            status: 403
        });
    }
    const sentryIngestUrl = $1vcEw.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            body: body
        });
    } catch (error) {
        $jDmhV.debug.error("Sentry tunnel: failed to forward envelope", error);
        return new Response("Failed to forward envelope to Sentry", {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $8cf84d9786ab8209$var$handleTunnelRequest;

});

parcelRegister("aLprX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $7d6208fa5cf2ca43$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $7d6208fa5cf2ca43$var$addAutoIpAddressToSession(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}
module.exports.addAutoIpAddressToSession = $7d6208fa5cf2ca43$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $7d6208fa5cf2ca43$var$addAutoIpAddressToUser;

});

parcelRegister("bHxuO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6j9aN = parcelRequire("6j9aN");
function $884db175c5a40569$var$applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: $6j9aN.SDK_VERSION
            }));
        sdk.version = $6j9aN.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $884db175c5a40569$var$applySdkMetadata;

});

parcelRegister("hPQqG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JduQ = parcelRequire("2JduQ");

var $kJVFD = parcelRequire("kJVFD");

var $k1IvE = parcelRequire("k1IvE");

var $cwsTk = parcelRequire("cwsTk");

var $jDmhV = parcelRequire("jDmhV");

var $hR4pa = parcelRequire("hR4pa");

var $6vmlI = parcelRequire("6vmlI");

var $OCsCD = parcelRequire("OCsCD");

var $8pUWd = parcelRequire("8pUWd");
function $cfbfde7aa89f85df$var$getTraceData(options = {}) {
    const client = options.client || $k1IvE.getClient();
    if (!$cwsTk.isEnabled() || !client) return {};
    const carrier$1 = $kJVFD.getMainCarrier();
    const acs = $2JduQ.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $k1IvE.getCurrentScope();
    const span = options.span || $hR4pa.getActiveSpan();
    if (!span && $k1IvE.hasExternalPropagationContext()) return {};
    const sentryTrace = span ? $hR4pa.spanToTraceHeader(span) : $cfbfde7aa89f85df$var$scopeToTraceHeader(scope);
    const dsc = span ? $6vmlI.getDynamicSamplingContextFromSpan(span) : $6vmlI.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $OCsCD.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $8pUWd.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $jDmhV.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span ? $hR4pa.spanToTraceparentHeader(span) : $cfbfde7aa89f85df$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $cfbfde7aa89f85df$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $8pUWd.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $cfbfde7aa89f85df$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $8pUWd.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $cfbfde7aa89f85df$var$getTraceData;

});

parcelRegister("95nH0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $2b0FU = parcelRequire("2b0FU");
const $69d6f58e8a2fd3e8$var$NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
function $69d6f58e8a2fd3e8$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== "string" || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== void 0) {
        $cWDS7.DEBUG_BUILD && !cachedDecision && $jDmhV.debug.log($69d6f58e8a2fd3e8$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $2b0FU.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $cWDS7.DEBUG_BUILD && !decision && $jDmhV.debug.log($69d6f58e8a2fd3e8$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $69d6f58e8a2fd3e8$var$shouldPropagateTraceForUrl;

});

parcelRegister("cagwd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hPQqG = parcelRequire("hPQqG");
function $8db33b6fade7aeba$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $hPQqG.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join("\n");
}
module.exports.getTraceMetaTags = $8db33b6fade7aeba$var$getTraceMetaTags;

});

parcelRegister("5mrku", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $3e7434e131734fc1$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $3e7434e131734fc1$var$debounce;

});

parcelRegister("eldhF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $8PgFX = parcelRequire("8PgFX");

var $i9b9S = parcelRequire("i9b9S");

var $3kuJo = parcelRequire("3kuJo");

var $40w67 = parcelRequire("40w67");
const $a70d54ca49469980$var$MAX_BODY_BYTE_LENGTH = 1048576;
const $a70d54ca49469980$var$TEXT_CONTENT_TYPES = [
    "text/",
    "application/json",
    "application/x-www-form-urlencoded",
    "application/xml",
    "application/graphql"
];
function $a70d54ca49469980$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === "small") return 1e3;
    if (maxRequestBodySize === "medium") return 1e4;
    return $a70d54ca49469980$var$MAX_BODY_BYTE_LENGTH;
}
function $a70d54ca49469980$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") headers[key] = value;
        });
    } catch  {}
    return headers;
}
function $a70d54ca49469980$var$headersToDict(reqHeaders) {
    const headers = /* @__PURE__ */ Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === "string") headers[key] = value;
            else if (typeof value === "number") headers[key] = String(value);
        });
    } catch  {}
    return headers;
}
function $a70d54ca49469980$var$winterCGRequestToRequestData(req) {
    const headers = $a70d54ca49469980$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $a70d54ca49469980$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
function $a70d54ca49469980$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $a70d54ca49469980$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
async function $a70d54ca49469980$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get("content-type");
        if (!$a70d54ca49469980$var$isTextualContentType(contentType)) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("Skipping body capture for non-textual content type:", contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get("content-length");
        const maxBodySize = $a70d54ca49469980$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $a70d54ca49469980$var$MAX_BODY_BYTE_LENGTH) {
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("Skipping body capture: body too large", length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $40w67.safeUnref(setTimeout(()=>resolve(null), 2e3));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("Timeout reading request body");
            return;
        }
        if (!body) return;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log("Captured request body:", bodyByteLength, "bytes");
    } catch (error) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.error("Error capturing request body:", error);
    }
}
function $a70d54ca49469980$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
    const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
    const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? "https" : "http");
    const url = request.url || "";
    const absoluteUrl = $a70d54ca49469980$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    const data = request.body || void 0;
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $a70d54ca49469980$var$extractQueryParamsFromUrl(url),
        headers: $a70d54ca49469980$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $a70d54ca49469980$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith("http")) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return void 0;
}
function $a70d54ca49469980$var$httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
    const resolvedDataCollection = typeof dataCollection === "boolean" ? $8PgFX.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
    const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
    const cookieBehavior = resolvedDataCollection.cookies;
    const prefix = `http.${lifecycle}.header.`;
    const spanAttributes = {};
    try {
        const regularHeaders = {};
        for (const [key, value] of Object.entries(headers)){
            if (value == null) continue;
            const lowerKey = key.toLowerCase();
            const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
            if (isCookieHeader) {
                if (cookieBehavior === false) continue;
                if (typeof value === "string" && value !== "") {
                    const parsed = $a70d54ca49469980$var$parseCookieHeader(value, lowerKey === "set-cookie");
                    const filtered = $3kuJo.filterKeyValueData(parsed, cookieBehavior, $i9b9S.SENSITIVE_COOKIE_NAME_SNIPPETS);
                    for (const [cookieKey, cookieValue] of Object.entries(filtered))spanAttributes[`${prefix}${$a70d54ca49469980$var$normalizeAttributeKey(lowerKey)}.${$a70d54ca49469980$var$normalizeAttributeKey(cookieKey)}`] = cookieValue;
                } else spanAttributes[`${prefix}${$a70d54ca49469980$var$normalizeAttributeKey(lowerKey)}`] = $i9b9S.FILTERED_VALUE;
            } else {
                if (headerBehavior === false) continue;
                if (Array.isArray(value)) regularHeaders[lowerKey] = value.map((v)=>v != null ? String(v) : v).join(";");
                else if (typeof value === "string") regularHeaders[lowerKey] = value;
            }
        }
        if (headerBehavior !== false) {
            const filtered = $3kuJo.filterKeyValueData(regularHeaders, headerBehavior);
            for (const [headerKey, headerValue] of Object.entries(filtered))spanAttributes[`${prefix}${$a70d54ca49469980$var$normalizeAttributeKey(headerKey)}`] = headerValue;
        }
    } catch  {}
    return spanAttributes;
}
function $a70d54ca49469980$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, "_");
}
function $a70d54ca49469980$var$parseCookieHeader(value, isSetCookie) {
    const semicolonIndex = value.indexOf(";");
    const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
    const cookies = isSetCookie ? [
        cookieString
    ] : cookieString.split("; ");
    const result = {};
    for (const cookie of cookies){
        const equalSignIndex = cookie.indexOf("=");
        const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
        const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
        result[cookieKey] = cookieValue;
    }
    return result;
}
function $a70d54ca49469980$var$extractQueryParamsFromUrl(url) {
    if (!url) return;
    try {
        const queryParams = new URL(url, "http://s.io").search.slice(1);
        return queryParams.length ? queryParams : void 0;
    } catch  {
        return void 0;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $a70d54ca49469980$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $a70d54ca49469980$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $a70d54ca49469980$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $a70d54ca49469980$var$getMaxBodyByteLength;
module.exports.headersToDict = $a70d54ca49469980$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $a70d54ca49469980$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $a70d54ca49469980$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $a70d54ca49469980$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $a70d54ca49469980$var$winterCGRequestToRequestData;

});

parcelRegister("j5YQJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $jDmhV = parcelRequire("jDmhV");

var $gQok6 = parcelRequire("gQok6");
const $de6daf6a7a4e82e4$var$DEFAULT_BREADCRUMBS = 100;
function $de6daf6a7a4e82e4$var$addBreadcrumb(breadcrumb, hint) {
    const client = $k1IvE.getClient();
    const isolationScope = $k1IvE.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $de6daf6a7a4e82e4$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $gQok6.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $jDmhV.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $de6daf6a7a4e82e4$var$addBreadcrumb;

});

parcelRegister("G7TwH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $2Rd9o = parcelRequire("2Rd9o");

var $56noD = parcelRequire("56noD");
let $07ea0c0f26c8a670$var$originalFunctionToString;
const $07ea0c0f26c8a670$var$INTEGRATION_NAME = "FunctionToString";
const $07ea0c0f26c8a670$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $07ea0c0f26c8a670$var$_functionToStringIntegration = ()=>{
    return {
        name: $07ea0c0f26c8a670$var$INTEGRATION_NAME,
        setupOnce () {
            $07ea0c0f26c8a670$var$originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $56noD.getOriginalFunction(this);
                    const context = $07ea0c0f26c8a670$var$SETUP_CLIENTS.has($k1IvE.getClient()) && originalFunction !== void 0 ? originalFunction : this;
                    return $07ea0c0f26c8a670$var$originalFunctionToString.apply(context, args);
                };
            } catch  {}
        },
        setup (client) {
            $07ea0c0f26c8a670$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $07ea0c0f26c8a670$var$functionToStringIntegration = $2Rd9o.defineIntegration($07ea0c0f26c8a670$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $07ea0c0f26c8a670$var$functionToStringIntegration;

});

parcelRegister("elK9c", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $2Rd9o = parcelRequire("2Rd9o");

var $jDmhV = parcelRequire("jDmhV");

var $7BAlY = parcelRequire("7BAlY");

var $aNZ1M = parcelRequire("aNZ1M");

var $2b0FU = parcelRequire("2b0FU");
const $a726d2bced57149b$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /^Java exception was raised during method invocation$/
];
const $a726d2bced57149b$var$INTEGRATION_NAME = "EventFilters";
const $a726d2bced57149b$var$eventFiltersIntegration = $2Rd9o.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $a726d2bced57149b$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $a726d2bced57149b$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $a726d2bced57149b$var$_mergeOptions(options, clientOptions);
            }
            return $a726d2bced57149b$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $a726d2bced57149b$var$inboundFiltersIntegration = $2Rd9o.defineIntegration((options = {})=>{
    return {
        ...$a726d2bced57149b$var$eventFiltersIntegration(options),
        name: "InboundFilters"
    };
});
function $a726d2bced57149b$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $a726d2bced57149b$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $a726d2bced57149b$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($a726d2bced57149b$var$_isIgnoredError(event, options.ignoreErrors)) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${$aNZ1M.getEventDescription(event)}`);
            return true;
        }
        if ($a726d2bced57149b$var$_isUselessError(event)) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${$aNZ1M.getEventDescription(event)}`);
            return true;
        }
        if ($a726d2bced57149b$var$_isDeniedUrl(event, options.denyUrls)) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${$aNZ1M.getEventDescription(event)}.
Url: ${$a726d2bced57149b$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$a726d2bced57149b$var$_isAllowedUrl(event, options.allowUrls)) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${$aNZ1M.getEventDescription(event)}.
Url: ${$a726d2bced57149b$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($a726d2bced57149b$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${$aNZ1M.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $a726d2bced57149b$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $7BAlY.getPossibleEventMessages(event).some((message)=>$2b0FU.stringMatchesSomePattern(message, ignoreErrors));
}
function $a726d2bced57149b$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $2b0FU.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $a726d2bced57149b$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $a726d2bced57149b$var$_getEventFilterUrl(event);
    return !url ? false : $2b0FU.stringMatchesSomePattern(url, denyUrls);
}
function $a726d2bced57149b$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $a726d2bced57149b$var$_getEventFilterUrl(event);
    return !url ? true : $2b0FU.stringMatchesSomePattern(url, allowUrls);
}
function $a726d2bced57149b$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $a726d2bced57149b$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $a726d2bced57149b$var$_getLastValidUrl(frames) : null;
    } catch  {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.error(`Cannot extract url for event ${$aNZ1M.getEventDescription(event)}`);
        return null;
    }
}
function $a726d2bced57149b$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}
module.exports.eventFiltersIntegration = $a726d2bced57149b$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $a726d2bced57149b$var$inboundFiltersIntegration;

});

parcelRegister("4wxG7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Rd9o = parcelRequire("2Rd9o");

var $i8h4C = parcelRequire("i8h4C");

var $dtwvq = parcelRequire("dtwvq");
const $34b44668d3b4fe9b$var$DEFAULT_KEY = "cause";
const $34b44668d3b4fe9b$var$DEFAULT_LIMIT = 5;
const $34b44668d3b4fe9b$var$INTEGRATION_NAME = "LinkedErrors";
const $34b44668d3b4fe9b$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $34b44668d3b4fe9b$var$DEFAULT_LIMIT;
    const key = options.key || $34b44668d3b4fe9b$var$DEFAULT_KEY;
    return {
        name: $34b44668d3b4fe9b$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            $i8h4C.applyAggregateErrorsToEvent($dtwvq.exceptionFromError, options2.stackParser, key, limit, event, hint);
        }
    };
};
const $34b44668d3b4fe9b$var$linkedErrorsIntegration = $2Rd9o.defineIntegration($34b44668d3b4fe9b$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $34b44668d3b4fe9b$var$linkedErrorsIntegration;

});
parcelRegister("i8h4C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jm1F1 = parcelRequire("jm1F1");
function $d33637cdeb3021f6$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$jm1F1.isInstanceOf(hint.originalException, Error)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $d33637cdeb3021f6$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $d33637cdeb3021f6$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ($jm1F1.isInstanceOf(error[key], Error)) {
        $d33637cdeb3021f6$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $d33637cdeb3021f6$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $d33637cdeb3021f6$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($d33637cdeb3021f6$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($jm1F1.isInstanceOf(childError, Error)) {
            $d33637cdeb3021f6$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $d33637cdeb3021f6$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $d33637cdeb3021f6$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $d33637cdeb3021f6$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $d33637cdeb3021f6$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$d33637cdeb3021f6$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $d33637cdeb3021f6$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $d33637cdeb3021f6$var$applyAggregateErrorsToEvent;

});

parcelRegister("dtwvq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jm1F1 = parcelRequire("jm1F1");

var $aNZ1M = parcelRequire("aNZ1M");

var $04GFW = parcelRequire("04GFW");

var $56noD = parcelRequire("56noD");
function $9cf732ccc63dfab1$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $9cf732ccc63dfab1$var$hasSentryFetchUrlHost(error) {
    return $jm1F1.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $9cf732ccc63dfab1$var$_enhanceErrorWithSentryInfo(error) {
    if ($9cf732ccc63dfab1$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $9cf732ccc63dfab1$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $9cf732ccc63dfab1$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $9cf732ccc63dfab1$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $9cf732ccc63dfab1$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return void 0;
}
function $9cf732ccc63dfab1$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = $56noD.extractExceptionKeysForMessage(exception);
    if ($jm1F1.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $9cf732ccc63dfab1$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $9cf732ccc63dfab1$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $9cf732ccc63dfab1$var$getException(client, mechanism, exception, hint) {
    if ($jm1F1.isError(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ($jm1F1.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: $04GFW.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $9cf732ccc63dfab1$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $9cf732ccc63dfab1$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $9cf732ccc63dfab1$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $9cf732ccc63dfab1$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $9cf732ccc63dfab1$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $aNZ1M.addExceptionTypeValue(event, void 0, void 0);
    $aNZ1M.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $9cf732ccc63dfab1$var$eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $9cf732ccc63dfab1$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $aNZ1M.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($jm1F1.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $9cf732ccc63dfab1$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $9cf732ccc63dfab1$var$eventFromMessage;
module.exports.eventFromUnknownInput = $9cf732ccc63dfab1$var$eventFromUnknownInput;
module.exports.exceptionFromError = $9cf732ccc63dfab1$var$exceptionFromError;
module.exports.parseStackFrames = $9cf732ccc63dfab1$var$parseStackFrames;

});


parcelRegister("jeFfT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Rd9o = parcelRequire("2Rd9o");

var $bwY2N = parcelRequire("bwY2N");

var $dQ0Qv = parcelRequire("dQ0Qv");
const $e00f538d995f8edb$var$moduleMetadataIntegration = $2Rd9o.defineIntegration(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $dQ0Qv.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $bwY2N.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $bwY2N.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $e00f538d995f8edb$var$moduleMetadataIntegration;

});
parcelRegister("bwY2N", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $NKzWo = parcelRequire("NKzWo");
const $86514261c6456d41$var$filenameMetadataMap = /* @__PURE__ */ new Map();
const $86514261c6456d41$var$parsedStacks = /* @__PURE__ */ new Set();
function $86514261c6456d41$var$getFilenameToMetadataMap(parser) {
    if (!$NKzWo.GLOBAL_OBJ._sentryModuleMetadata) return {};
    const filenameMap = {};
    for (const stack of Object.keys($NKzWo.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $NKzWo.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $86514261c6456d41$var$ensureMetadataStacksAreParsed(parser) {
    if (!$NKzWo.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($NKzWo.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $NKzWo.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($86514261c6456d41$var$parsedStacks.has(stack)) continue;
        $86514261c6456d41$var$parsedStacks.add(stack);
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            $86514261c6456d41$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
function $86514261c6456d41$var$getMetadataForUrl(parser, filename) {
    $86514261c6456d41$var$ensureMetadataStacksAreParsed(parser);
    return $86514261c6456d41$var$filenameMetadataMap.get(filename);
}
function $86514261c6456d41$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $86514261c6456d41$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
function $86514261c6456d41$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $86514261c6456d41$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $86514261c6456d41$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $86514261c6456d41$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $86514261c6456d41$var$stripMetadataFromStackFrames;

});


parcelRegister("az7hP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $2Rd9o = parcelRequire("2Rd9o");

var $7nMWX = parcelRequire("7nMWX");

var $1y4io = parcelRequire("1y4io");

var $eldhF = parcelRequire("eldhF");

var $8PwuM = parcelRequire("8PwuM");

var $2VRKv = parcelRequire("2VRKv");
const $7b12d338974e8f5f$var$INTEGRATION_NAME = "RequestData";
const $7b12d338974e8f5f$var$_requestDataIntegration = (options = {})=>{
    function resolveIncludeAndDataCollection(client) {
        const dc = client.getDataCollectionOptions();
        const dataCollection = {
            ...dc,
            ...options.include?.cookies === true && dc.cookies === false && {
                cookies: true
            },
            ...options.include?.headers === true && dc.httpHeaders.request === false && {
                httpHeaders: {
                    ...dc.httpHeaders,
                    request: true
                }
            }
        };
        return {
            dataCollection: dataCollection,
            include: {
                cookies: dataCollection.cookies !== false,
                // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
                data: true,
                headers: dataCollection.httpHeaders.request !== false,
                ip: dataCollection.userInfo,
                query_string: dataCollection.queryParams !== false,
                // No dataCollection equivalent — URL is always included
                url: true,
                ...options.include
            }
        };
    }
    return {
        name: $7b12d338974e8f5f$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const { include: include } = resolveIncludeAndDataCollection(client);
            if (normalizedRequest) $7b12d338974e8f5f$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, include);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $k1IvE.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            $7b12d338974e8f5f$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
        }
    };
};
const $7b12d338974e8f5f$var$requestDataIntegration = $2Rd9o.defineIntegration($7b12d338974e8f5f$var$_requestDataIntegration);
function $7b12d338974e8f5f$var$addNormalizedRequestDataToEvent(event, req, additionalData, include) {
    event.request = {
        ...event.request,
        ...$7b12d338974e8f5f$var$extractNormalizedRequestData(req, include)
    };
    if (include.ip) {
        const ip = req.headers && $8PwuM.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $7b12d338974e8f5f$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
    const requestData = $7b12d338974e8f5f$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes = {};
    if (requestData.url) attributes["url.full"] = requestData.url;
    if (requestData.method) attributes["http.request.method"] = requestData.method;
    if (requestData.query_string) attributes["url.query"] = $7b12d338974e8f5f$var$normalizeQueryString(requestData.query_string);
    $2VRKv.safeSetSpanJSONAttributes(span, attributes);
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join("; ");
        const cookieAttributes = $eldhF.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, dataCollection, "request");
        $2VRKv.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $eldhF.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
        $2VRKv.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $2VRKv.safeSetSpanJSONAttributes(span, {
            "http.request.body.data": serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $8PwuM.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
        if (ip) $2VRKv.safeSetSpanJSONAttributes(span, {
            [$7nMWX.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $7b12d338974e8f5f$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($8PwuM.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $1y4io.parseCookie(headers.cookie) : void 0);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $7b12d338974e8f5f$var$normalizeQueryString(queryString) {
    if (typeof queryString === "string") return queryString || void 0;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const result = pairs.map(([key, value])=>`${key}=${value}`).join("&");
    return result || void 0;
}
module.exports.requestDataIntegration = $7b12d338974e8f5f$var$requestDataIntegration;

});
parcelRegister("8PwuM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $66dc4b1004719b85$var$ipHeaderNames = [
    "X-Client-IP",
    "X-Forwarded-For",
    "Fly-Client-IP",
    "CF-Connecting-IP",
    "Fastly-Client-Ip",
    "True-Client-Ip",
    "X-Real-IP",
    "X-Cluster-Client-IP",
    "X-Forwarded",
    "Forwarded-For",
    "Forwarded",
    "X-Vercel-Forwarded-For"
];
function $66dc4b1004719b85$var$getClientIPAddress(headers) {
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    const headerValues = $66dc4b1004719b85$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
        if (headerName === "Forwarded") return $66dc4b1004719b85$var$parseForwardedHeader(value);
        return value?.split(",").map((v)=>v.trim());
    });
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $66dc4b1004719b85$var$isIP(ip));
    return ipAddress || null;
}
function $66dc4b1004719b85$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(";")){
        if (part.startsWith("for=")) return part.slice(4);
    }
    return null;
}
function $66dc4b1004719b85$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $66dc4b1004719b85$var$getClientIPAddress;
module.exports.ipHeaderNames = $66dc4b1004719b85$var$ipHeaderNames;

});


parcelRegister("lX3kc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $cwsTk = parcelRequire("cwsTk");

var $f2MZk = parcelRequire("f2MZk");

var $2Rd9o = parcelRequire("2Rd9o");

var $jDmhV = parcelRequire("jDmhV");

var $aNZ1M = parcelRequire("aNZ1M");

var $iN4A1 = parcelRequire("iN4A1");

var $2b0FU = parcelRequire("2b0FU");

var $NKzWo = parcelRequire("NKzWo");
const $ffb1afe564636b09$var$INTEGRATION_NAME = "CaptureConsole";
const $ffb1afe564636b09$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $jDmhV.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $ffb1afe564636b09$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in $NKzWo.GLOBAL_OBJ)) return;
            $f2MZk.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($k1IvE.getClient() !== client || !levels.includes(level)) return;
                $ffb1afe564636b09$var$consoleHandler(args, level, handled);
            });
        }
    };
};
const $ffb1afe564636b09$var$captureConsoleIntegration = $2Rd9o.defineIntegration($ffb1afe564636b09$var$_captureConsoleIntegration);
function $ffb1afe564636b09$var$consoleHandler(args, level, handled) {
    const severityLevel = $iN4A1.severityLevelFromString(level);
    const syntheticException = new Error();
    const captureContext = {
        level: $iN4A1.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $k1IvE.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            $aNZ1M.addExceptionMechanism(event, {
                handled: handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message2 = `Assertion failed: ${$2b0FU.safeJoin(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message2, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $cwsTk.captureException(error, captureContext);
            return;
        }
        const message = $2b0FU.safeJoin(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $ffb1afe564636b09$var$captureConsoleIntegration;

});
parcelRegister("f2MZk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $56noD = parcelRequire("56noD");

var $2b0FU = parcelRequire("2b0FU");

var $NKzWo = parcelRequire("NKzWo");

var $ljaTH = parcelRequire("ljaTH");
const $af3d0af2cac22de0$var$_filter = /* @__PURE__ */ new Set([]);
function $af3d0af2cac22de0$var$addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = $ljaTH.addHandler(type, handler);
    $ljaTH.maybeInstrument(type, $af3d0af2cac22de0$var$instrumentConsole);
    return removeHandler;
}
function $af3d0af2cac22de0$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$af3d0af2cac22de0$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$af3d0af2cac22de0$var$_filter.delete(f);
    };
}
function $af3d0af2cac22de0$var$instrumentConsole() {
    if (!("console" in $NKzWo.GLOBAL_OBJ)) return;
    $jDmhV.CONSOLE_LEVELS.forEach(function(level) {
        if (!(level in $NKzWo.GLOBAL_OBJ.console)) return;
        $56noD.fill($NKzWo.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $jDmhV.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $jDmhV.originalConsoleMethods[level];
                const isFiltered = $af3d0af2cac22de0$var$_filter.size && typeof firstArg === "string" && $2b0FU.stringMatchesSomePattern(firstArg, $af3d0af2cac22de0$var$_filter);
                if (!isFiltered) $ljaTH.triggerHandlers("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || $cWDS7.DEBUG_BUILD && $jDmhV.debug.isEnabled()) log?.apply($NKzWo.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $af3d0af2cac22de0$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $af3d0af2cac22de0$var$addConsoleInstrumentationHandler;

});

parcelRegister("iN4A1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $dae05b172b60da74$var$severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}
module.exports.severityLevelFromString = $dae05b172b60da74$var$severityLevelFromString;

});


parcelRegister("7ytrB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $2Rd9o = parcelRequire("2Rd9o");

var $jDmhV = parcelRequire("jDmhV");

var $aWndQ = parcelRequire("aWndQ");
const $58028c5eed000a60$var$INTEGRATION_NAME = "Dedupe";
const $58028c5eed000a60$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $58028c5eed000a60$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($58028c5eed000a60$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $58028c5eed000a60$var$dedupeIntegration = $2Rd9o.defineIntegration($58028c5eed000a60$var$_dedupeIntegration);
function $58028c5eed000a60$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($58028c5eed000a60$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($58028c5eed000a60$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $58028c5eed000a60$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$58028c5eed000a60$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$58028c5eed000a60$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $58028c5eed000a60$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $58028c5eed000a60$var$_getExceptionFromEvent(previousEvent);
    const currentException = $58028c5eed000a60$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$58028c5eed000a60$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$58028c5eed000a60$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $58028c5eed000a60$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $aWndQ.getFramesFromEvent(currentEvent);
    let previousFrames = $aWndQ.getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $58028c5eed000a60$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $58028c5eed000a60$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $58028c5eed000a60$var$_shouldDropEvent;
module.exports.dedupeIntegration = $58028c5eed000a60$var$dedupeIntegration;

});

parcelRegister("v7agl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $2Rd9o = parcelRequire("2Rd9o");

var $jDmhV = parcelRequire("jDmhV");

var $jm1F1 = parcelRequire("jm1F1");

var $04GFW = parcelRequire("04GFW");

var $3I8lv = parcelRequire("3I8lv");

var $2b0FU = parcelRequire("2b0FU");
const $05d874172fe543a1$var$INTEGRATION_NAME = "ExtraErrorData";
const $05d874172fe543a1$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $05d874172fe543a1$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $05d874172fe543a1$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $05d874172fe543a1$var$extraErrorDataIntegration = $2Rd9o.defineIntegration($05d874172fe543a1$var$_extraErrorDataIntegration);
function $05d874172fe543a1$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$jm1F1.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $05d874172fe543a1$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $04GFW.normalize(errorData, depth);
        if ($jm1F1.isPlainObject(normalizedErrorData)) {
            $3I8lv.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
function $05d874172fe543a1$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $jm1F1.isError(value) || typeof value === "string" ? maxValueLength ? $2b0FU.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        if (captureErrorCause && error.cause !== void 0) {
            if ($jm1F1.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $05d874172fe543a1$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $jm1F1.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $05d874172fe543a1$var$extraErrorDataIntegration;

});

parcelRegister("iRNFQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Rd9o = parcelRequire("2Rd9o");

var $iBZic = parcelRequire("iBZic");

var $NKzWo = parcelRequire("NKzWo");
const $dbc3b56c1fc09165$var$INTEGRATION_NAME = "RewriteFrames";
const $dbc3b56c1fc09165$var$rewriteFramesIntegration = $2Rd9o.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in $NKzWo.GLOBAL_OBJ && !!$NKzWo.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $dbc3b56c1fc09165$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $dbc3b56c1fc09165$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
function $dbc3b56c1fc09165$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
            const base = root ? $iBZic.relative(root, filename) : $iBZic.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $dbc3b56c1fc09165$var$generateIteratee;
module.exports.rewriteFramesIntegration = $dbc3b56c1fc09165$var$rewriteFramesIntegration;

});
parcelRegister("iBZic", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $d8cb3a1cf867503e$var$normalizeArray(parts, allowAboveRoot) {
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
const $d8cb3a1cf867503e$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
function $d8cb3a1cf867503e$var$splitPath(filename) {
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $d8cb3a1cf867503e$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
function $d8cb3a1cf867503e$var$resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    resolvedPath = $d8cb3a1cf867503e$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
function $d8cb3a1cf867503e$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $d8cb3a1cf867503e$var$relative(from, to) {
    from = $d8cb3a1cf867503e$var$resolve(from).slice(1);
    to = $d8cb3a1cf867503e$var$resolve(to).slice(1);
    const fromParts = $d8cb3a1cf867503e$var$trim(from.split("/"));
    const toParts = $d8cb3a1cf867503e$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $d8cb3a1cf867503e$var$normalizePath(path) {
    const isPathAbsolute = $d8cb3a1cf867503e$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    let normalizedPath = $d8cb3a1cf867503e$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $d8cb3a1cf867503e$var$isAbsolute(path) {
    return path.charAt(0) === "/";
}
function $d8cb3a1cf867503e$var$join(...args) {
    return $d8cb3a1cf867503e$var$normalizePath(args.join("/"));
}
function $d8cb3a1cf867503e$var$dirname(path) {
    const result = $d8cb3a1cf867503e$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) return ".";
    if (dir) dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
function $d8cb3a1cf867503e$var$basename(path, ext) {
    let f = $d8cb3a1cf867503e$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $d8cb3a1cf867503e$var$basename;
module.exports.dirname = $d8cb3a1cf867503e$var$dirname;
module.exports.isAbsolute = $d8cb3a1cf867503e$var$isAbsolute;
module.exports.join = $d8cb3a1cf867503e$var$join;
module.exports.normalizePath = $d8cb3a1cf867503e$var$normalizePath;
module.exports.relative = $d8cb3a1cf867503e$var$relative;
module.exports.resolve = $d8cb3a1cf867503e$var$resolve;

});


parcelRegister("kypyN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $j5YQJ = parcelRequire("j5YQJ");

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $cwsTk = parcelRequire("cwsTk");

var $2Rd9o = parcelRequire("2Rd9o");

var $7nMWX = parcelRequire("7nMWX");

var $jDmhV = parcelRequire("jDmhV");

var $aNZ1M = parcelRequire("aNZ1M");

var $jm1F1 = parcelRequire("jm1F1");

var $dAQ6V = parcelRequire("dAQ6V");

var $5VGek = parcelRequire("5VGek");
const $ef6acf5f8a7dbd19$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $ef6acf5f8a7dbd19$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $ef6acf5f8a7dbd19$var$FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $ef6acf5f8a7dbd19$var$DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $ef6acf5f8a7dbd19$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {}
}
function $ef6acf5f8a7dbd19$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
function $ef6acf5f8a7dbd19$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return void 0;
}
function $ef6acf5f8a7dbd19$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $ef6acf5f8a7dbd19$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
}
function $ef6acf5f8a7dbd19$var$extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if (headers["Prefer"]?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
function $ef6acf5f8a7dbd19$var$translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $ef6acf5f8a7dbd19$var$FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $ef6acf5f8a7dbd19$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $5VGek.startSpan({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if (res && typeof res === "object" && "error" in res && res.error) {
                        span.setStatus({
                            code: $dAQ6V.SPAN_STATUS_ERROR
                        });
                        $cwsTk.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: $dAQ6V.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $dAQ6V.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $cwsTk.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $ef6acf5f8a7dbd19$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $ef6acf5f8a7dbd19$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $ef6acf5f8a7dbd19$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $ef6acf5f8a7dbd19$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $ef6acf5f8a7dbd19$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $ef6acf5f8a7dbd19$var$instrumentAuthOperation(authOperation, true);
    }
    $ef6acf5f8a7dbd19$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $ef6acf5f8a7dbd19$var$instrumentSupabaseClientConstructor(SupabaseClient, _options) {
    if ($ef6acf5f8a7dbd19$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $ef6acf5f8a7dbd19$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
            return rv;
        }
    });
    $ef6acf5f8a7dbd19$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $ef6acf5f8a7dbd19$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
    if ($ef6acf5f8a7dbd19$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $ef6acf5f8a7dbd19$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $ef6acf5f8a7dbd19$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())queryItems.push($ef6acf5f8a7dbd19$var$translateFiltersIntoMethods(key, value));
            const body = /* @__PURE__ */ Object.create(null);
            if ($jm1F1.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const client = $k1IvE.getClient();
            const shouldSendData = _options.sendOperationData ?? client?.getDataCollectionOptions().userInfo === true;
            const bodyPayload = $ef6acf5f8a7dbd19$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            const mutationPart = operation === "select" ? "" : `${operation}${$ef6acf5f8a7dbd19$var$hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": typedThis.headers["X-Client-Info"],
                "db.system": "postgresql",
                "db.operation": operation,
                [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
            };
            if (queryItems.length && shouldSendData) attributes["db.query"] = queryItems;
            if (bodyPayload !== void 0 && shouldSendData) attributes["db.body"] = bodyPayload;
            return $5VGek.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) $dAQ6V.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && shouldSendData) supabaseContext.query = queryItems;
                        if (bodyPayload !== void 0 && shouldSendData) supabaseContext.body = bodyPayload;
                        $cwsTk.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $aNZ1M.addExceptionMechanism(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && shouldSendData) data.query = queryItems;
                    if (bodyPayload !== void 0 && shouldSendData) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $j5YQJ.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        $dAQ6V.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $ef6acf5f8a7dbd19$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $ef6acf5f8a7dbd19$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
    for (const operation of $ef6acf5f8a7dbd19$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($ef6acf5f8a7dbd19$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $ef6acf5f8a7dbd19$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
                return rv;
            }
        });
        $ef6acf5f8a7dbd19$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $ef6acf5f8a7dbd19$var$instrumentSupabaseClient = (supabaseClient, options = {})=>{
    if (!supabaseClient) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $ef6acf5f8a7dbd19$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
    $ef6acf5f8a7dbd19$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $ef6acf5f8a7dbd19$var$INTEGRATION_NAME = "Supabase";
const $ef6acf5f8a7dbd19$var$_supabaseIntegration = (supabaseClient, options)=>{
    return {
        setupOnce () {
            $ef6acf5f8a7dbd19$var$instrumentSupabaseClient(supabaseClient, options);
        },
        name: $ef6acf5f8a7dbd19$var$INTEGRATION_NAME
    };
};
const $ef6acf5f8a7dbd19$var$supabaseIntegration = $2Rd9o.defineIntegration((options)=>{
    return $ef6acf5f8a7dbd19$var$_supabaseIntegration(options.supabaseClient, {
        sendOperationData: options.sendOperationData
    });
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $ef6acf5f8a7dbd19$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $ef6acf5f8a7dbd19$var$FILTER_MAPPINGS;
module.exports.extractOperation = $ef6acf5f8a7dbd19$var$extractOperation;
module.exports.instrumentSupabaseClient = $ef6acf5f8a7dbd19$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $ef6acf5f8a7dbd19$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $ef6acf5f8a7dbd19$var$translateFiltersIntoMethods;

});

parcelRegister("h1kyh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Rd9o = parcelRequire("2Rd9o");

var $jm1F1 = parcelRequire("jm1F1");

var $2b0FU = parcelRequire("2b0FU");
const $c64278d3fc889fb3$var$DEFAULT_LIMIT = 10;
const $c64278d3fc889fb3$var$INTEGRATION_NAME = "ZodErrors";
function $c64278d3fc889fb3$var$originalExceptionIsZodError(originalException) {
    return $jm1F1.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
function $c64278d3fc889fb3$var$flattenIssue(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
    };
}
function $c64278d3fc889fb3$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
function $c64278d3fc889fb3$var$formatIssueMessage(zodError) {
    const errorKeyMap = /* @__PURE__ */ new Set();
    for (const iss of zodError.issues){
        const issuePath = $c64278d3fc889fb3$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$2b0FU.truncate(errorKeys.join(", "), 100)}`;
}
function $c64278d3fc889fb3$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$c64278d3fc889fb3$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($c64278d3fc889fb3$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $c64278d3fc889fb3$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
                }
            }
        };
    }
}
const $c64278d3fc889fb3$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $c64278d3fc889fb3$var$DEFAULT_LIMIT;
    return {
        name: $c64278d3fc889fb3$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $c64278d3fc889fb3$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
const $c64278d3fc889fb3$var$zodErrorsIntegration = $2Rd9o.defineIntegration($c64278d3fc889fb3$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $c64278d3fc889fb3$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $c64278d3fc889fb3$var$flattenIssue;
module.exports.flattenIssuePath = $c64278d3fc889fb3$var$flattenIssuePath;
module.exports.formatIssueMessage = $c64278d3fc889fb3$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $c64278d3fc889fb3$var$zodErrorsIntegration;

});

parcelRegister("5jtP2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Rd9o = parcelRequire("2Rd9o");

var $bwY2N = parcelRequire("bwY2N");

var $dQ0Qv = parcelRequire("dQ0Qv");

var $aWndQ = parcelRequire("aWndQ");

var $NKzWo = parcelRequire("NKzWo");
const $3de5dc30b3389655$var$thirdPartyErrorFilterIntegration = $2Rd9o.defineIntegration((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $dQ0Qv.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $bwY2N.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $bwY2N.addMetadataToStackFrames(stackParser, event);
            });
        },
        preprocessEvent (event) {
            if (options.ignoreSentryInternalFrames && ($NKzWo.GLOBAL_OBJ._sentryWrappedDepth ?? 0) > 0) event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                insideSentryWrapped: true
            };
        },
        processEvent (event) {
            const insideSentryWrapped = options.ignoreSentryInternalFrames ? event.sdkProcessingMetadata?.insideSentryWrapped === true && event.exception?.values?.length === 1 : false;
            const frameKeys = $3de5dc30b3389655$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames, insideSentryWrapped);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
function $3de5dc30b3389655$var$isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
    if (frameIndex !== 0) return false;
    if (insideSentryWrapped && $3de5dc30b3389655$var$isLikelyMinifiedSentryWrappedFrame(frame)) return true;
    if (frame.function === "sentryWrapped") return true;
    if (!frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($3de5dc30b3389655$var$SENTRY_INTERNAL_FN_APPLY)) return false;
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($3de5dc30b3389655$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $3de5dc30b3389655$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
    const frames = $aWndQ.getFramesFromEvent(event);
    if (!frames) return void 0;
    return frames.filter((frame, index)=>{
        if (!frame.filename) return false;
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        return !ignoreSentryInternalFrames || !$3de5dc30b3389655$var$isSentryInternalFrame(frame, index, !!insideSentryWrapped);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($3de5dc30b3389655$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($3de5dc30b3389655$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
function $3de5dc30b3389655$var$isLikelyMinifiedSentryWrappedFrame(frame) {
    return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
}
const $3de5dc30b3389655$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const $3de5dc30b3389655$var$SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const $3de5dc30b3389655$var$SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";
module.exports.thirdPartyErrorFilterIntegration = $3de5dc30b3389655$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("6HJK6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $j5YQJ = parcelRequire("j5YQJ");

var $k1IvE = parcelRequire("k1IvE");

var $f2MZk = parcelRequire("f2MZk");

var $2Rd9o = parcelRequire("2Rd9o");

var $jDmhV = parcelRequire("jDmhV");

var $iN4A1 = parcelRequire("iN4A1");

var $2b0FU = parcelRequire("2b0FU");

var $NKzWo = parcelRequire("NKzWo");
const $4e1a3dc3ed3968ce$var$INTEGRATION_NAME = "Console";
const $4e1a3dc3ed3968ce$var$consoleIntegration = $2Rd9o.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $jDmhV.CONSOLE_LEVELS);
    return {
        name: $4e1a3dc3ed3968ce$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $f2MZk.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($k1IvE.getClient() !== client || !levels.has(level)) return;
                $4e1a3dc3ed3968ce$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = $f2MZk.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $4e1a3dc3ed3968ce$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: $iN4A1.severityLevelFromString(level),
        message: $4e1a3dc3ed3968ce$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$4e1a3dc3ed3968ce$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    $j5YQJ.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $4e1a3dc3ed3968ce$var$formatConsoleArgs(values) {
    return "util" in $NKzWo.GLOBAL_OBJ && typeof $NKzWo.GLOBAL_OBJ.util.format === "function" ? $NKzWo.GLOBAL_OBJ.util.format(...values) : $2b0FU.safeJoin(values, " ");
}
module.exports.addConsoleBreadcrumb = $4e1a3dc3ed3968ce$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $4e1a3dc3ed3968ce$var$consoleIntegration;

});

parcelRegister("4A7xx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Rd9o = parcelRequire("2Rd9o");

var $lbqbj = parcelRequire("lbqbj");
const $35605f8257a8d940$var$featureFlagsIntegration = $2Rd9o.defineIntegration(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return $lbqbj._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $lbqbj._INTERNAL_insertFlagToScope(name, value);
            $lbqbj._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $35605f8257a8d940$var$featureFlagsIntegration;

});
parcelRegister("lbqbj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $hR4pa = parcelRequire("hR4pa");
const $f6beef2bf14a39e5$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
const $f6beef2bf14a39e5$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $f6beef2bf14a39e5$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
function $f6beef2bf14a39e5$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) return event;
    const scope = $k1IvE.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === void 0) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
function $f6beef2bf14a39e5$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $f6beef2bf14a39e5$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $k1IvE.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $f6beef2bf14a39e5$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
function $f6beef2bf14a39e5$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) flags.splice(index, 1);
    if (flags.length === maxSize) flags.shift();
    flags.push({
        flag: name,
        result: value
    });
}
function $f6beef2bf14a39e5$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $f6beef2bf14a39e5$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = $hR4pa.getActiveSpan();
    if (!span) return;
    const attributes = $hR4pa.spanToJSON(span).data;
    if (`${$f6beef2bf14a39e5$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$f6beef2bf14a39e5$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($f6beef2bf14a39e5$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$f6beef2bf14a39e5$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $f6beef2bf14a39e5$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $f6beef2bf14a39e5$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $f6beef2bf14a39e5$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $f6beef2bf14a39e5$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $f6beef2bf14a39e5$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $f6beef2bf14a39e5$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("k0yFa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Rd9o = parcelRequire("2Rd9o");

var $lbqbj = parcelRequire("lbqbj");

var $56noD = parcelRequire("56noD");
const $e90eb2122f1d171c$var$growthbookIntegration = $2Rd9o.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            if (typeof proto.isOn === "function") $56noD.fill(proto, "isOn", $e90eb2122f1d171c$var$_wrapAndCaptureBooleanResult);
            if (typeof proto.getFeatureValue === "function") $56noD.fill(proto, "getFeatureValue", $e90eb2122f1d171c$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $lbqbj._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $e90eb2122f1d171c$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            $lbqbj._INTERNAL_insertFlagToScope(flagName, result);
            $lbqbj._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $e90eb2122f1d171c$var$growthbookIntegration;

});

parcelRegister("505qn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $2Rd9o = parcelRequire("2Rd9o");

var $7nMWX = parcelRequire("7nMWX");

var $hR4pa = parcelRequire("hR4pa");
const $3a41290521d9a40a$var$INTEGRATION_NAME = "ConversationId";
const $3a41290521d9a40a$var$_conversationIdIntegration = ()=>{
    return {
        name: $3a41290521d9a40a$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = $k1IvE.getCurrentScope().getScopeData();
                const isolationScopeData = $k1IvE.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $hR4pa.spanToJSON(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute($7nMWX.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
const $3a41290521d9a40a$var$conversationIdIntegration = $2Rd9o.defineIntegration($3a41290521d9a40a$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $3a41290521d9a40a$var$conversationIdIntegration;

});

parcelRegister("6ZcNn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");
function $51625d77923d758d$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
}
function $51625d77923d758d$var$startProfiler() {
    const client = $k1IvE.getClient();
    if (!client) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$51625d77923d758d$var$isProfilingIntegrationWithProfiler(integration)) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.start();
}
function $51625d77923d758d$var$stopProfiler() {
    const client = $k1IvE.getClient();
    if (!client) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$51625d77923d758d$var$isProfilingIntegrationWithProfiler(integration)) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.stop();
}
const $51625d77923d758d$var$profiler = {
    startProfiler: $51625d77923d758d$var$startProfiler,
    stopProfiler: $51625d77923d758d$var$stopProfiler
};
module.exports.profiler = $51625d77923d758d$var$profiler;

});

parcelRegister("3jKxo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $7nMWX = parcelRequire("7nMWX");

var $hR4pa = parcelRequire("hR4pa");

var $dAQ6V = parcelRequire("dAQ6V");

var $jm1F1 = parcelRequire("jm1F1");

var $60l9G = parcelRequire("60l9G");

var $OCsCD = parcelRequire("OCsCD");

var $hhSBj = parcelRequire("hhSBj");

var $lk94N = parcelRequire("lk94N");

var $5VGek = parcelRequire("5VGek");

var $5xKoA = parcelRequire("5xKoA");

var $hPQqG = parcelRequire("hPQqG");
function $26a73ed749895540$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $60l9G.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $26a73ed749895540$var$endSpan(span2, handlerData);
                $26a73ed749895540$var$_callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $k1IvE.getClient();
    const hasParent = !!$hR4pa.getActiveSpan();
    const shouldEmitSpan = hasParent || !!client && $lk94N.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $5VGek.startInactiveSpan($26a73ed749895540$var$getSpanStartOptions(url, method, spanOrigin)) : new $hhSBj.SentryNonRecordingSpan();
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $26a73ed749895540$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $60l9G.hasSpansEnabled() && shouldEmitSpan ? span : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $26a73ed749895540$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
function $26a73ed749895540$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $hPQqG.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ($jm1F1.isRequest(request) ? request.headers : void 0);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($26a73ed749895540$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$26a73ed749895540$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($26a73ed749895540$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $26a73ed749895540$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$26a73ed749895540$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $26a73ed749895540$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : void 0
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $26a73ed749895540$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $dAQ6V.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $dAQ6V.SPAN_STATUS_ERROR,
        message: "internal_error"
    });
    span.end();
}
function $26a73ed749895540$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith($OCsCD.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $26a73ed749895540$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && $jm1F1.isInstanceOf(headers, Headers);
}
function $26a73ed749895540$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $26a73ed749895540$var$getSpanStartOptions(url$1, method, spanOrigin) {
    if (url$1.startsWith("data:")) {
        const sanitizedUrl2 = $5xKoA.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $26a73ed749895540$var$getFetchSpanAttributes(url$1, void 0, method, spanOrigin)
        };
    }
    const parsedUrl = $5xKoA.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $5xKoA.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $26a73ed749895540$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
    };
}
function $26a73ed749895540$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: $5xKoA.stripDataUrlContent(url$1),
        type: "fetch",
        "http.method": method,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
    };
    if (parsedUrl) {
        if (!$5xKoA.isURLObjectRelative(parsedUrl)) {
            attributes["http.url"] = $5xKoA.stripDataUrlContent(parsedUrl.href);
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $26a73ed749895540$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $26a73ed749895540$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $26a73ed749895540$var$instrumentFetchRequest;

});

parcelRegister("7wfxr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");
function $5797932c1b72fd27$var$captureFeedback(params, hint = {}, scope = $k1IvE.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || $k1IvE.getClient();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $5797932c1b72fd27$var$captureFeedback;

});

parcelRegister("jvFcx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9xCLH = parcelRequire("9xCLH");

var $4QmUc = parcelRequire("4QmUc");
function $e340df4d61a454ae$var$captureLog(level, message, attributes, scope, severityNumber) {
    $9xCLH._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
function $e340df4d61a454ae$var$trace(message, attributes, { scope: scope } = {}) {
    $e340df4d61a454ae$var$captureLog("trace", message, attributes, scope);
}
function $e340df4d61a454ae$var$debug(message, attributes, { scope: scope } = {}) {
    $e340df4d61a454ae$var$captureLog("debug", message, attributes, scope);
}
function $e340df4d61a454ae$var$info(message, attributes, { scope: scope } = {}) {
    $e340df4d61a454ae$var$captureLog("info", message, attributes, scope);
}
function $e340df4d61a454ae$var$warn(message, attributes, { scope: scope } = {}) {
    $e340df4d61a454ae$var$captureLog("warn", message, attributes, scope);
}
function $e340df4d61a454ae$var$error(message, attributes, { scope: scope } = {}) {
    $e340df4d61a454ae$var$captureLog("error", message, attributes, scope);
}
function $e340df4d61a454ae$var$fatal(message, attributes, { scope: scope } = {}) {
    $e340df4d61a454ae$var$captureLog("fatal", message, attributes, scope);
}
module.exports.fmt = $4QmUc.fmt;
module.exports.debug = $e340df4d61a454ae$var$debug;
module.exports.error = $e340df4d61a454ae$var$error;
module.exports.fatal = $e340df4d61a454ae$var$fatal;
module.exports.info = $e340df4d61a454ae$var$info;
module.exports.trace = $e340df4d61a454ae$var$trace;
module.exports.warn = $e340df4d61a454ae$var$warn;

});

parcelRegister("kiSB9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $cWDS7 = parcelRequire("cWDS7");

var $f2MZk = parcelRequire("f2MZk");

var $2Rd9o = parcelRequire("2Rd9o");

var $7nMWX = parcelRequire("7nMWX");

var $jDmhV = parcelRequire("jDmhV");

var $9xCLH = parcelRequire("9xCLH");

var $2Y2MZ = parcelRequire("2Y2MZ");
const $ec7fd72b8ae10169$var$INTEGRATION_NAME = "ConsoleLogs";
const $ec7fd72b8ae10169$var$DEFAULT_ATTRIBUTES = {
    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
};
const $ec7fd72b8ae10169$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $jDmhV.CONSOLE_LEVELS;
    return {
        name: $ec7fd72b8ae10169$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = $f2MZk.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($k1IvE.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$2Y2MZ.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        $9xCLH._INTERNAL_captureLog({
                            level: "error",
                            message: assertionMessage,
                            attributes: $ec7fd72b8ae10169$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const shouldGenerateTemplate = args.length > 1 && typeof args[0] === "string" && !$2Y2MZ.hasConsoleSubstitutions(args[0]);
                const attributes = {
                    ...$ec7fd72b8ae10169$var$DEFAULT_ATTRIBUTES,
                    ...shouldGenerateTemplate ? $2Y2MZ.createConsoleTemplateAttributes(firstArg, followingArgs) : {}
                };
                $9xCLH._INTERNAL_captureLog({
                    level: isLevelLog ? "info" : level,
                    message: $2Y2MZ.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $ec7fd72b8ae10169$var$consoleLoggingIntegration = $2Rd9o.defineIntegration($ec7fd72b8ae10169$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $ec7fd72b8ae10169$var$consoleLoggingIntegration;

});
parcelRegister("2Y2MZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jm1F1 = parcelRequire("jm1F1");

var $04GFW = parcelRequire("04GFW");

var $NKzWo = parcelRequire("NKzWo");
function $229359427793fa38$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in $NKzWo.GLOBAL_OBJ && typeof $NKzWo.GLOBAL_OBJ.util.format === "function" ? $NKzWo.GLOBAL_OBJ.util.format(...values) : $229359427793fa38$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $229359427793fa38$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$jm1F1.isPrimitive(value) ? String(value) : JSON.stringify($04GFW.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $229359427793fa38$var$hasConsoleSubstitutions(str) {
    return /%[sdifocO]/.test(str);
}
function $229359427793fa38$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $229359427793fa38$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $229359427793fa38$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $229359427793fa38$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $229359427793fa38$var$safeJoinConsoleArgs;

});


parcelRegister("9a9TW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3bTow = parcelRequire("3bTow");
function $6abcba70bf5932f4$var$captureMetric(type, name, value, options) {
    $3bTow._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
function $6abcba70bf5932f4$var$count(name, value = 1, options) {
    $6abcba70bf5932f4$var$captureMetric("counter", name, value, options);
}
function $6abcba70bf5932f4$var$gauge(name, value, options) {
    $6abcba70bf5932f4$var$captureMetric("gauge", name, value, options);
}
function $6abcba70bf5932f4$var$distribution(name, value, options) {
    $6abcba70bf5932f4$var$captureMetric("distribution", name, value, options);
}
module.exports.count = $6abcba70bf5932f4$var$count;
module.exports.distribution = $6abcba70bf5932f4$var$distribution;
module.exports.gauge = $6abcba70bf5932f4$var$gauge;

});

parcelRegister("6RTLc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $9xCLH = parcelRequire("9xCLH");

var $2Y2MZ = parcelRequire("2Y2MZ");

var $jm1F1 = parcelRequire("jm1F1");

var $04GFW = parcelRequire("04GFW");
const $5002f22646ada381$var$DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
function $5002f22646ada381$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $5002f22646ada381$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            const client = providedClient || $k1IvE.getClient();
            if (!client) return;
            const logSeverityLevel = $5002f22646ada381$var$getLogSeverityLevel(type, level);
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            const attributes = {};
            for (const [key, value] of Object.entries(rest))attributes[key] = $04GFW.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = $5002f22646ada381$var$processExtractedAttributes($5002f22646ada381$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $9xCLH._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $2Y2MZ.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes: attributes
            });
        }
    };
}
const $5002f22646ada381$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
const $5002f22646ada381$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    // Fatal and Error
    1: "warn",
    // Warnings
    2: "info",
    // Normal logs
    3: "info",
    // Informational logs, success, fail, ready, start, ...
    4: "debug",
    // Debug logs
    5: "trace"
};
function $5002f22646ada381$var$getLogSeverityLevel(type, level) {
    if (type === "verbose") return "debug";
    if (type === "silent") return "trace";
    if (type) {
        const mappedLevel = $5002f22646ada381$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    if (typeof level === "number") {
        const mappedLevel = $5002f22646ada381$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    return "info";
}
function $5002f22646ada381$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ""
    };
    const message = $2Y2MZ.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($jm1F1.isPlainObject(firstArg)) {
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !$2Y2MZ.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
            messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
        };
    }
}
function $5002f22646ada381$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $2Y2MZ.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? $04GFW.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $04GFW.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$04GFW.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $5002f22646ada381$var$createConsolaReporter;

});

parcelRegister("7P0a7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $7nMWX = parcelRequire("7nMWX");

var $brX6l = parcelRequire("brX6l");

var $hR4pa = parcelRequire("hR4pa");

var $31Di6 = parcelRequire("31Di6");

var $91zPf = parcelRequire("91zPf");

var $lk94N = parcelRequire("lk94N");

var $cCx8R = parcelRequire("cCx8R");

var $9kWTX = parcelRequire("9kWTX");
function $5b1d6c0b580b17e2$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $hR4pa.spanToJSON(span);
    if (!name) return;
    if (attributes[$9kWTX.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$9kWTX.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
        $5b1d6c0b580b17e2$var$processToolCallSpan(span, attributes);
        return;
    }
    if (!attributes[$9kWTX.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) return;
    const client = $k1IvE.getClient();
    const integration = client?.getIntegrationByName("VercelAI");
    const enableTruncation = $brX6l.shouldEnableTruncation(integration?.options?.enableTruncation);
    $5b1d6c0b580b17e2$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $5b1d6c0b580b17e2$var$vercelAiEventProcessor(event) {
    if (event.type === "transaction" && event.spans) {
        const tokenAccumulator = /* @__PURE__ */ new Map();
        for (const span of event.spans){
            $5b1d6c0b580b17e2$var$processEndedVercelAiSpan(span);
            $cCx8R.accumulateTokensForParent(span, tokenAccumulator);
        }
        $cCx8R.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        const trace = event.contexts?.trace;
        if (trace?.op === "gen_ai.invoke_agent") $cCx8R.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
function $5b1d6c0b580b17e2$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== "string") return "stop";
    switch(finishReason){
        case "tool-calls":
            return "tool_call";
        case "stop":
        case "length":
        case "content_filter":
        case "error":
            return finishReason;
        default:
            return finishReason;
    }
}
function $5b1d6c0b580b17e2$var$buildOutputMessages(attributes) {
    const responseText = attributes[$9kWTX.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$9kWTX.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$9kWTX.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (responseToolCalls != null) try {
        const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: "tool_call",
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
                });
            }
            delete attributes[$9kWTX.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {}
    if (parts.length > 0) {
        const outputMessage = {
            role: "assistant",
            parts: parts,
            finish_reason: $5b1d6c0b580b17e2$var$normalizeFinishReason(finishReason)
        };
        attributes[$31Di6.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        delete attributes[$9kWTX.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
function $5b1d6c0b580b17e2$var$processVercelAiSpanAttributes(attributes) {
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, "ai.usage.inputTokens", $31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, "ai.usage.outputTokens", $31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_USAGE_TOKENS_ATTRIBUTE, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
    if (typeof attributes[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") attributes[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    if (typeof attributes[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
        const outputTokens = typeof attributes[$31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[$31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$31Di6.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    if (attributes[$9kWTX.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$9kWTX.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$9kWTX.AI_PROMPT_TOOLS_ATTRIBUTE] = $cCx8R.convertAvailableToolsToJsonString(attributes[$9kWTX.AI_PROMPT_TOOLS_ATTRIBUTE]);
    if (attributes[$9kWTX.OPERATION_NAME_ATTRIBUTE]) {
        const rawOperationName = attributes[$9kWTX.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$9kWTX.AI_OPERATION_ID_ATTRIBUTE] : attributes[$9kWTX.OPERATION_NAME_ATTRIBUTE];
        const operationName = $91zPf.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        delete attributes[$9kWTX.OPERATION_NAME_ATTRIBUTE];
    }
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_PROMPT_MESSAGES_ATTRIBUTE, $31Di6.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    $5b1d6c0b580b17e2$var$buildOutputMessages(attributes);
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_TOOL_CALL_ARGS_ATTRIBUTE, $31Di6.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_TOOL_CALL_RESULT_ATTRIBUTE, $31Di6.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_MODEL_ID_ATTRIBUTE, $31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    if (Array.isArray(attributes[$9kWTX.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$9kWTX.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$31Di6.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $5b1d6c0b580b17e2$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        if (key.startsWith("ai.")) $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $5b1d6c0b580b17e2$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== "auto.vercelai.otel") return;
    if (span.status && span.status !== "ok") span.status = "internal_error";
    $5b1d6c0b580b17e2$var$processVercelAiSpanAttributes(attributes);
}
function $5b1d6c0b580b17e2$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== "auto.vercelai.otel") return;
    $5b1d6c0b580b17e2$var$processVercelAiSpanAttributes(attributes);
    if (attributes[$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
        const descriptions = $91zPf.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$31Di6.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$31Di6.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    $91zPf.toolDescriptionMap.delete(span.span_id);
}
function $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        delete attributes[oldKey];
    }
}
function $5b1d6c0b580b17e2$var$processToolCallSpan(span, attributes) {
    span.setAttribute($7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    span.setAttribute($7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
    span.setAttribute($31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_TOOL_CALL_NAME_ATTRIBUTE, $31Di6.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $5b1d6c0b580b17e2$var$renameAttributeKey(attributes, $9kWTX.AI_TOOL_CALL_ID_ATTRIBUTE, $31Di6.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    const toolCallId = attributes[$31Di6.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === "string") $91zPf.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    if (!attributes[$31Di6.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($31Di6.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
    const toolName = attributes[$31Di6.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $5b1d6c0b580b17e2$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    const nameWthoutAi = name.replace("ai.", "");
    span.setAttribute("ai.pipeline.name", nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$9kWTX.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === "string") span.setAttribute("gen_ai.function_id", functionId);
    $cCx8R.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$9kWTX.AI_MODEL_ID_ATTRIBUTE] && !attributes[$31Di6.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($31Di6.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$9kWTX.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute("ai.streaming", name.includes("stream"));
    const operationName = $91zPf.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith("ai.stream")) span.setAttribute($7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
    if (operationName === "invoke_agent") {
        if (functionId && typeof functionId === "string") span.updateName(`invoke_agent ${functionId}`);
        else span.updateName("invoke_agent");
        return;
    }
    const modelId = attributes[$9kWTX.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    const client = $k1IvE.getClient();
    if (client && $lk94N.hasSpanStreamingEnabled(client) && attributes[$9kWTX.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$9kWTX.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = /* @__PURE__ */ new Map();
        for (const toolStr of attributes[$9kWTX.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {}
        if (descriptions.size > 0) {
            const parentSpanId = $hR4pa.spanToJSON(span).parent_span_id;
            if (parentSpanId) $91zPf.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
function $5b1d6c0b580b17e2$var$addVercelAiProcessors(client) {
    client.on("spanStart", $5b1d6c0b580b17e2$var$onVercelAiSpanStart);
    client.addEventProcessor(Object.assign($5b1d6c0b580b17e2$var$vercelAiEventProcessor, {
        id: "VercelAiEventProcessor"
    }));
    client.on("processSpan", (span)=>{
        $5b1d6c0b580b17e2$var$processVercelAiStreamedSpan(span);
    });
}
function $5b1d6c0b580b17e2$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$9kWTX.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (providerMetadata) try {
        const providerMetadataObject = JSON.parse(providerMetadata);
        const openaiMetadata = providerMetadataObject.openai ?? providerMetadataObject.azure;
        if (openaiMetadata) {
            $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
            $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
            $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_accepted", openaiMetadata.acceptedPredictionTokens);
            $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_rejected", openaiMetadata.rejectedPredictionTokens);
            if (!attributes["gen_ai.conversation.id"]) $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, "gen_ai.conversation.id", openaiMetadata.responseId);
        }
        if (providerMetadataObject.anthropic) {
            const cachedInputTokens = providerMetadataObject.anthropic.usage?.cache_read_input_tokens ?? providerMetadataObject.anthropic.cacheReadInputTokens;
            $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
            const cacheWriteInputTokens = providerMetadataObject.anthropic.usage?.cache_creation_input_tokens ?? providerMetadataObject.anthropic.cacheCreationInputTokens;
            $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
        }
        if (providerMetadataObject.bedrock?.usage) {
            $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, providerMetadataObject.bedrock.usage.cacheReadInputTokens);
            $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, providerMetadataObject.bedrock.usage.cacheWriteInputTokens);
        }
        if (providerMetadataObject.deepseek) {
            $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, providerMetadataObject.deepseek.promptCacheHitTokens);
            $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, "gen_ai.usage.input_tokens.cache_miss", providerMetadataObject.deepseek.promptCacheMissTokens);
        }
    } catch  {}
}
function $5b1d6c0b580b17e2$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.addVercelAiProcessors = $5b1d6c0b580b17e2$var$addVercelAiProcessors;
module.exports.processVercelAiSpanAttributes = $5b1d6c0b580b17e2$var$processVercelAiSpanAttributes;

});
parcelRegister("brX6l", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $k1IvE = parcelRequire("k1IvE");

var $lk94N = parcelRequire("lk94N");

var $jm1F1 = parcelRequire("jm1F1");

var $31Di6 = parcelRequire("31Di6");

var $3JBo7 = parcelRequire("3JBo7");
function $85600f9f81a71a1b$var$resolveAIRecordingOptions(options) {
    const genAI = $k1IvE.getClient()?.getDataCollectionOptions().genAI;
    return {
        ...options,
        recordInputs: options?.recordInputs ?? genAI?.inputs ?? false,
        recordOutputs: options?.recordOutputs ?? genAI?.outputs ?? false
    };
}
function $85600f9f81a71a1b$var$shouldEnableTruncation(enableTruncation) {
    const client = $k1IvE.getClient();
    return enableTruncation ?? !(client && $lk94N.hasSpanStreamingEnabled(client));
}
function $85600f9f81a71a1b$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
function $85600f9f81a71a1b$var$setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== void 0) span.setAttributes({
        [$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
    });
    if (completionTokens !== void 0) span.setAttributes({
        [$31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
    });
    if (promptTokens !== void 0 || completionTokens !== void 0 || cachedInputTokens !== void 0 || cachedOutputTokens !== void 0) {
        const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [$31Di6.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
        });
    }
}
function $85600f9f81a71a1b$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$31Di6.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$31Di6.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$31Di6.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== void 0) attrs[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== void 0) attrs[$31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    if (state.totalTokens !== void 0) attrs[$31Di6.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== void 0 || state.completionTokens !== void 0 || state.cacheCreationInputTokens !== void 0 || state.cacheReadInputTokens !== void 0) attrs[$31Di6.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
    if (state.finishReasons.length) attrs[$31Di6.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$31Di6.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[$31Di6.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
function $85600f9f81a71a1b$var$getJsonString(value) {
    if (typeof value === "string") return value;
    return JSON.stringify(value);
}
function $85600f9f81a71a1b$var$getTruncatedJsonString(value) {
    if (typeof value === "string") return $3JBo7.truncateGenAiStringInput(value);
    if (Array.isArray(value)) {
        const truncatedMessages = $3JBo7.truncateGenAiMessages(value);
        return JSON.stringify(truncatedMessages);
    }
    return JSON.stringify(value);
}
function $85600f9f81a71a1b$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
    if (!systemContent) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
async function $85600f9f81a71a1b$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType) {
    const safeOriginalWithResponse = originalWithResponse.catch((error)=>{
        $cwsTk.captureException(error, {
            mechanism: {
                handled: false,
                type: mechanismType
            }
        });
        throw error;
    });
    const instrumentedResult = await instrumentedPromise;
    const originalWrapper = await safeOriginalWithResponse;
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
function $85600f9f81a71a1b$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise, mechanismType) {
    if (!$jm1F1.isThenable(originalPromiseLike)) return instrumentedPromise;
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $85600f9f81a71a1b$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $85600f9f81a71a1b$var$buildMethodPath;
module.exports.endStreamSpan = $85600f9f81a71a1b$var$endStreamSpan;
module.exports.extractSystemInstructions = $85600f9f81a71a1b$var$extractSystemInstructions;
module.exports.getJsonString = $85600f9f81a71a1b$var$getJsonString;
module.exports.getTruncatedJsonString = $85600f9f81a71a1b$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $85600f9f81a71a1b$var$resolveAIRecordingOptions;
module.exports.setTokenUsageAttributes = $85600f9f81a71a1b$var$setTokenUsageAttributes;
module.exports.shouldEnableTruncation = $85600f9f81a71a1b$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $85600f9f81a71a1b$var$wrapPromiseWithMethods;

});
parcelRegister("31Di6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $233ff17cb4a6f9fc$var$GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
const $233ff17cb4a6f9fc$var$GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
const $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
const $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
const $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
const $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
const $233ff17cb4a6f9fc$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
const $233ff17cb4a6f9fc$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
const $233ff17cb4a6f9fc$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
const $233ff17cb4a6f9fc$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
const $233ff17cb4a6f9fc$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
const $233ff17cb4a6f9fc$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
const $233ff17cb4a6f9fc$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
const $233ff17cb4a6f9fc$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
const $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
const $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
const $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
const $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
const $233ff17cb4a6f9fc$var$GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
const $233ff17cb4a6f9fc$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
const $233ff17cb4a6f9fc$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const $233ff17cb4a6f9fc$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_creation_input_tokens";
const $233ff17cb4a6f9fc$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_read_input_tokens";
const $233ff17cb4a6f9fc$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
const $233ff17cb4a6f9fc$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
const $233ff17cb4a6f9fc$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
const $233ff17cb4a6f9fc$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
const $233ff17cb4a6f9fc$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
const $233ff17cb4a6f9fc$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
const $233ff17cb4a6f9fc$var$GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
const $233ff17cb4a6f9fc$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
const $233ff17cb4a6f9fc$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
const $233ff17cb4a6f9fc$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
const $233ff17cb4a6f9fc$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
const $233ff17cb4a6f9fc$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $233ff17cb4a6f9fc$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("3JBo7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8MUh4 = parcelRequire("8MUh4");
const $2b8293881ceb36c1$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
const $2b8293881ceb36c1$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
const $2b8293881ceb36c1$var$jsonBytes = (value)=>{
    return $2b8293881ceb36c1$var$utf8Bytes(JSON.stringify(value));
};
function $2b8293881ceb36c1$var$truncateTextByBytes(text, maxBytes) {
    if ($2b8293881ceb36c1$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $2b8293881ceb36c1$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
function $2b8293881ceb36c1$var$getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
function $2b8293881ceb36c1$var$withItemText(item, text) {
    if (typeof item === "string") return text;
    return {
        ...item,
        text: text
    };
}
function $2b8293881ceb36c1$var$isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
function $2b8293881ceb36c1$var$isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
function $2b8293881ceb36c1$var$isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
function $2b8293881ceb36c1$var$truncateContentMessage(message, maxBytes) {
    const emptyMessage = {
        ...message,
        content: ""
    };
    const overhead = $2b8293881ceb36c1$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $2b8293881ceb36c1$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
function $2b8293881ceb36c1$var$getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
function $2b8293881ceb36c1$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $2b8293881ceb36c1$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    const emptyItems = items.map((item)=>$2b8293881ceb36c1$var$withItemText(item, ""));
    const overhead = $2b8293881ceb36c1$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    const includedItems = [];
    for (const item of items){
        const text = $2b8293881ceb36c1$var$getItemText(item);
        const textSize = $2b8293881ceb36c1$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            const truncated = $2b8293881ceb36c1$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($2b8293881ceb36c1$var$withItemText(item, truncated));
            break;
        } else break;
    }
    if (includedItems.length <= 0) return [];
    else return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
function $2b8293881ceb36c1$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    if (typeof message === "string") {
        const truncated = $2b8293881ceb36c1$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if ($2b8293881ceb36c1$var$isContentMessage(message)) return $2b8293881ceb36c1$var$truncateContentMessage(message, maxBytes);
    if ($2b8293881ceb36c1$var$isContentArrayMessage(message) || $2b8293881ceb36c1$var$isPartsMessage(message)) return $2b8293881ceb36c1$var$truncateArrayMessage(message, maxBytes);
    return [];
}
function $2b8293881ceb36c1$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = void 0;
        if (!!message && typeof message === "object") {
            if ($2b8293881ceb36c1$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $2b8293881ceb36c1$var$stripInlineMediaFromMessages(message.content)
            };
            else if ("content" in message && $8MUh4.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $8MUh4.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($2b8293881ceb36c1$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $2b8293881ceb36c1$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($8MUh4.isContentMedia(newMessage)) newMessage = $8MUh4.stripInlineMediaFromSingleMessage(newMessage);
            else if ($8MUh4.isContentMedia(message)) newMessage = $8MUh4.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
function $2b8293881ceb36c1$var$truncateMessagesByBytes(messages, maxBytes) {
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    const effectiveMaxBytes = maxBytes - 2;
    const lastMessage = messages[messages.length - 1];
    const stripped = $2b8293881ceb36c1$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    const messageBytes = $2b8293881ceb36c1$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    return $2b8293881ceb36c1$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
function $2b8293881ceb36c1$var$truncateGenAiMessages(messages) {
    return $2b8293881ceb36c1$var$truncateMessagesByBytes(messages, $2b8293881ceb36c1$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
function $2b8293881ceb36c1$var$truncateGenAiStringInput(input) {
    return $2b8293881ceb36c1$var$truncateTextByBytes(input, $2b8293881ceb36c1$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $2b8293881ceb36c1$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $2b8293881ceb36c1$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $2b8293881ceb36c1$var$truncateGenAiStringInput;

});
parcelRegister("8MUh4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $665e75507d532e6b$var$isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return $665e75507d532e6b$var$isContentMediaSource(part) || $665e75507d532e6b$var$hasInlineData(part) || $665e75507d532e6b$var$hasImageUrl(part) || $665e75507d532e6b$var$hasInputAudio(part) || $665e75507d532e6b$var$hasFileData(part) || $665e75507d532e6b$var$hasMediaTypeData(part) || $665e75507d532e6b$var$hasVercelFileData(part) || $665e75507d532e6b$var$hasVercelImageData(part) || $665e75507d532e6b$var$hasBlobOrBase64Type(part) || $665e75507d532e6b$var$hasB64Json(part) || $665e75507d532e6b$var$hasImageGenerationResult(part) || $665e75507d532e6b$var$hasDataUri(part);
}
function $665e75507d532e6b$var$hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return $665e75507d532e6b$var$hasNestedImageUrl(part);
}
function $665e75507d532e6b$var$hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function $665e75507d532e6b$var$isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && $665e75507d532e6b$var$isContentMedia(part.source);
}
function $665e75507d532e6b$var$hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function $665e75507d532e6b$var$hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function $665e75507d532e6b$var$hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function $665e75507d532e6b$var$hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
function $665e75507d532e6b$var$hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
function $665e75507d532e6b$var$hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function $665e75507d532e6b$var$hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function $665e75507d532e6b$var$hasB64Json(part) {
    return "b64_json" in part;
}
function $665e75507d532e6b$var$hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function $665e75507d532e6b$var$hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const $665e75507d532e6b$var$REMOVED_STRING = "[Blob substitute]";
const $665e75507d532e6b$var$MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
function $665e75507d532e6b$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($665e75507d532e6b$var$isContentMedia(strip.source)) strip.source = $665e75507d532e6b$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($665e75507d532e6b$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $665e75507d532e6b$var$REMOVED_STRING
    };
    if ($665e75507d532e6b$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $665e75507d532e6b$var$REMOVED_STRING
    };
    if ($665e75507d532e6b$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $665e75507d532e6b$var$REMOVED_STRING
    };
    if ($665e75507d532e6b$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $665e75507d532e6b$var$REMOVED_STRING
    };
    for (const field of $665e75507d532e6b$var$MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = $665e75507d532e6b$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $665e75507d532e6b$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $665e75507d532e6b$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("91zPf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $691fff3f59c16535$var$toolCallSpanContextMap = /* @__PURE__ */ new Map();
const $691fff3f59c16535$var$toolDescriptionMap = /* @__PURE__ */ new Map();
const $691fff3f59c16535$var$SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
    [
        "ai.generateText",
        "invoke_agent"
    ],
    [
        "ai.streamText",
        "invoke_agent"
    ],
    [
        "ai.generateObject",
        "invoke_agent"
    ],
    [
        "ai.streamObject",
        "invoke_agent"
    ],
    [
        "ai.generateText.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamText.doStream",
        "generate_content"
    ],
    [
        "ai.generateObject.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamObject.doStream",
        "generate_content"
    ],
    [
        "ai.embed.doEmbed",
        "embeddings"
    ],
    [
        "ai.embedMany.doEmbed",
        "embeddings"
    ],
    [
        "ai.rerank.doRerank",
        "rerank"
    ],
    [
        "ai.toolCall",
        "execute_tool"
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $691fff3f59c16535$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $691fff3f59c16535$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $691fff3f59c16535$var$toolDescriptionMap;

});

parcelRegister("cCx8R", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $31Di6 = parcelRequire("31Di6");

var $brX6l = parcelRequire("brX6l");

var $91zPf = parcelRequire("91zPf");

var $9kWTX = parcelRequire("9kWTX");
function $9302bdf67f659505$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === "number" || typeof outputTokens === "number") {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === "number") existing.inputTokens += inputTokens;
        if (typeof outputTokens === "number") existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
function $9302bdf67f659505$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
}
function $9302bdf67f659505$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = /* @__PURE__ */ new Map();
    for (const span of spans){
        const availableTools = span.data[$31Di6.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== "string") continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {}
    }
    return toolDescriptions;
}
function $9302bdf67f659505$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    const toolDescriptions = $9302bdf67f659505$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === "gen_ai.execute_tool") {
            const toolName = span.data[$31Di6.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$31Di6.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === "gen_ai.invoke_agent") $9302bdf67f659505$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
function $9302bdf67f659505$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $91zPf.toolCallSpanContextMap.get(toolCallId);
}
function $9302bdf67f659505$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $91zPf.toolCallSpanContextMap.delete(toolCallId);
}
function $9302bdf67f659505$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === "string") try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
function $9302bdf67f659505$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === "object" && "role" in m && "content" in m);
}
function $9302bdf67f659505$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === "object") {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            if (typeof system === "string") result.push({
                role: "system",
                content: system
            });
            if (typeof messages === "string") try {
                messages = JSON.parse(messages);
            } catch  {}
            if (Array.isArray(messages)) {
                result.push(...$9302bdf67f659505$var$filterMessagesArray(messages));
                return result;
            }
            if (Array.isArray(prompt)) {
                result.push(...$9302bdf67f659505$var$filterMessagesArray(prompt));
                return result;
            }
            if (typeof prompt === "string") result.push({
                role: "user",
                content: prompt
            });
            if (result.length > 0) return result;
        }
    } catch  {}
    return [];
}
function $9302bdf67f659505$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$9kWTX.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[$31Di6.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$9kWTX.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        const userInput = attributes[$9kWTX.AI_PROMPT_ATTRIBUTE];
        const messages = $9302bdf67f659505$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $brX6l.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($31Di6.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $brX6l.getTruncatedJsonString(filteredMessages) : $brX6l.getJsonString(filteredMessages);
            span.setAttributes({
                [$9kWTX.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$31Di6.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$31Di6.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$9kWTX.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") try {
        const messages = JSON.parse(attributes[$9kWTX.AI_PROMPT_MESSAGES_ATTRIBUTE]);
        if (Array.isArray(messages)) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $brX6l.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($31Di6.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $brX6l.getTruncatedJsonString(filteredMessages) : $brX6l.getJsonString(filteredMessages);
            span.setAttributes({
                [$9kWTX.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$31Di6.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$31Di6.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } catch  {}
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $9302bdf67f659505$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $9302bdf67f659505$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $9302bdf67f659505$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $9302bdf67f659505$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $9302bdf67f659505$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $9302bdf67f659505$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $9302bdf67f659505$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $9302bdf67f659505$var$requestMessagesFromPrompt;

});
parcelRegister("9kWTX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $6cc3abebc41f790a$var$OPERATION_NAME_ATTRIBUTE = "operation.name";
const $6cc3abebc41f790a$var$AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
const $6cc3abebc41f790a$var$AI_PROMPT_ATTRIBUTE = "ai.prompt";
const $6cc3abebc41f790a$var$AI_SCHEMA_ATTRIBUTE = "ai.schema";
const $6cc3abebc41f790a$var$AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
const $6cc3abebc41f790a$var$AI_VALUES_ATTRIBUTE = "ai.values";
const $6cc3abebc41f790a$var$AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
const $6cc3abebc41f790a$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
const $6cc3abebc41f790a$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
const $6cc3abebc41f790a$var$AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
const $6cc3abebc41f790a$var$AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
const $6cc3abebc41f790a$var$AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
const $6cc3abebc41f790a$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
const $6cc3abebc41f790a$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
const $6cc3abebc41f790a$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
const $6cc3abebc41f790a$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
const $6cc3abebc41f790a$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
const $6cc3abebc41f790a$var$AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
const $6cc3abebc41f790a$var$AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
const $6cc3abebc41f790a$var$AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
const $6cc3abebc41f790a$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
const $6cc3abebc41f790a$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";
module.exports.AI_MODEL_ID_ATTRIBUTE = $6cc3abebc41f790a$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $6cc3abebc41f790a$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $6cc3abebc41f790a$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $6cc3abebc41f790a$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $6cc3abebc41f790a$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $6cc3abebc41f790a$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $6cc3abebc41f790a$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $6cc3abebc41f790a$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $6cc3abebc41f790a$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $6cc3abebc41f790a$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $6cc3abebc41f790a$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $6cc3abebc41f790a$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $6cc3abebc41f790a$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $6cc3abebc41f790a$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $6cc3abebc41f790a$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $6cc3abebc41f790a$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $6cc3abebc41f790a$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $6cc3abebc41f790a$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $6cc3abebc41f790a$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $6cc3abebc41f790a$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $6cc3abebc41f790a$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $6cc3abebc41f790a$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("g7oR3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $cwsTk = parcelRequire("cwsTk");

var $7nMWX = parcelRequire("7nMWX");

var $jDmhV = parcelRequire("jDmhV");

var $dAQ6V = parcelRequire("dAQ6V");

var $5VGek = parcelRequire("5VGek");

var $31Di6 = parcelRequire("31Di6");

var $brX6l = parcelRequire("brX6l");

var $1P70f = parcelRequire("1P70f");

var $4OG0w = parcelRequire("4OG0w");

var $6T62n = parcelRequire("6T62n");
function $bbc0946ead694175$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: "web_search_options",
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return void 0;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.error("Failed to serialize OpenAI tools:", error);
        return void 0;
    }
}
function $bbc0946ead694175$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$31Di6.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
        [$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = $bbc0946ead694175$var$extractAvailableTools(params);
        if (availableTools) attributes[$31Di6.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $6T62n.extractRequestParameters(params));
    } else attributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $bbc0946ead694175$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        if (input == null) return;
        if (typeof input === "string" && input.length === 0) return;
        if (Array.isArray(input) && input.length === 0) return;
        span.setAttribute($31Di6.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $brX6l.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($31Di6.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($31Di6.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $brX6l.getTruncatedJsonString(filteredMessages) : $brX6l.getJsonString(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($31Di6.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($31Di6.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
function $bbc0946ead694175$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = $bbc0946ead694175$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult2;
            const instrumentedPromise2 = $5VGek.startSpanManual(spanConfig, (span)=>{
                originalResult2 = originalMethod.apply(context, args);
                if (options.recordInputs && params) $bbc0946ead694175$var$addRequestAttributes(span, params, operationName, $brX6l.shouldEnableTruncation(options.enableTruncation));
                return (async ()=>{
                    try {
                        const result = await originalResult2;
                        return $4OG0w.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $dAQ6V.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $cwsTk.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.openai.stream",
                                data: {
                                    function: methodPath
                                }
                            }
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $brX6l.wrapPromiseWithMethods(originalResult2, instrumentedPromise2, "auto.ai.openai");
        }
        let originalResult;
        const instrumentedPromise = $5VGek.startSpan(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $bbc0946ead694175$var$addRequestAttributes(span, params, operationName, $brX6l.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $6T62n.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            }, (error)=>{
                $cwsTk.captureException(error, {
                    mechanism: {
                        handled: false,
                        type: "auto.ai.openai",
                        data: {
                            function: methodPath
                        }
                    }
                });
                throw error;
            });
        });
        return $brX6l.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.openai");
    };
}
function $bbc0946ead694175$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $brX6l.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $1P70f.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $bbc0946ead694175$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $bbc0946ead694175$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $bbc0946ead694175$var$instrumentOpenAiClient(client, options) {
    return $bbc0946ead694175$var$createDeepProxy(client, "", $brX6l.resolveAIRecordingOptions(options));
}
module.exports.instrumentOpenAiClient = $bbc0946ead694175$var$instrumentOpenAiClient;

});
parcelRegister("1P70f", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $153ffc84cf80abc9$var$OPENAI_INTEGRATION_NAME = "OpenAI";
const $153ffc84cf80abc9$var$OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const $153ffc84cf80abc9$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const $153ffc84cf80abc9$var$RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...$153ffc84cf80abc9$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $153ffc84cf80abc9$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $153ffc84cf80abc9$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $153ffc84cf80abc9$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $153ffc84cf80abc9$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("4OG0w", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $dAQ6V = parcelRequire("dAQ6V");

var $brX6l = parcelRequire("brX6l");

var $1P70f = parcelRequire("1P70f");

var $6T62n = parcelRequire("6T62n");
function $381c6ac08b04d962$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === void 0 || !toolCall.function) continue;
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        };
        else {
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
function $381c6ac08b04d962$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            if (choice.delta?.tool_calls) $381c6ac08b04d962$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
function $381c6ac08b04d962$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $dAQ6V.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $cwsTk.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!$1P70f.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    if (recordOutputs) {
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
async function* $381c6ac08b04d962$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($6T62n.isChatCompletionChunk(event)) $381c6ac08b04d962$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($6T62n.isResponsesApiStreamEvent(event)) $381c6ac08b04d962$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $brX6l.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $381c6ac08b04d962$var$instrumentStream;

});
parcelRegister("6T62n", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $31Di6 = parcelRequire("31Di6");
function $503c90017c82dea0$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
function $503c90017c82dea0$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
function $503c90017c82dea0$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    if (typeof response.id === "string") attrs[$31Di6.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    if (typeof response.model === "string") attrs[$31Di6.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    if (response.object === "conversation" && typeof response.id === "string") attrs[$31Di6.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === "number") attrs[$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === "number") attrs[$31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[$31Di6.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[$31Di6.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || "";
            });
            attrs[$31Di6.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$31Di6.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    if (typeof response.status === "string") {
        if (!attrs[$31Di6.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$31Di6.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        if (typeof response.output_text === "string" && !attrs[$31Di6.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$31Di6.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$31Di6.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === "function_call");
            if (functionCalls.length > 0) attrs[$31Di6.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
function $503c90017c82dea0$var$extractConversationId(params) {
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return void 0;
}
function $503c90017c82dea0$var$extractRequestParameters(params) {
    const attributes = {
        [$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? "unknown"
    };
    if ("temperature" in params) attributes[$31Di6.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[$31Di6.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[$31Di6.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[$31Di6.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[$31Di6.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[$31Di6.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[$31Di6.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    const conversationId = $503c90017c82dea0$var$extractConversationId(params);
    if (conversationId) attributes[$31Di6.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $503c90017c82dea0$var$addResponseAttributes;
module.exports.extractRequestParameters = $503c90017c82dea0$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $503c90017c82dea0$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $503c90017c82dea0$var$isResponsesApiStreamEvent;

});



parcelRegister("H7uFC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $7nMWX = parcelRequire("7nMWX");

var $dAQ6V = parcelRequire("dAQ6V");

var $5VGek = parcelRequire("5VGek");

var $31Di6 = parcelRequire("31Di6");

var $brX6l = parcelRequire("brX6l");

var $ho5on = parcelRequire("ho5on");

var $2tEoB = parcelRequire("2tEoB");

var $eih5o = parcelRequire("eih5o");
function $0819d45b451329b2$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$31Di6.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
        [$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$31Di6.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
        if ("temperature" in params) attributes[$31Di6.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[$31Di6.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[$31Di6.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[$31Di6.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[$31Di6.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[$31Di6.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") attributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $0819d45b451329b2$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $eih5o.messagesFromParams(params);
    $eih5o.setMessagesAttribute(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [$31Di6.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
function $0819d45b451329b2$var$addContentAttributes(span, response) {
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$31Di6.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$31Di6.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    if ("completion" in response) span.setAttributes({
        [$31Di6.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    if ("input_tokens" in response) span.setAttributes({
        [$31Di6.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
function $0819d45b451329b2$var$addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [$31Di6.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$31Di6.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ("usage" in response && response.usage) $brX6l.setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
function $0819d45b451329b2$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if ("type" in response && response.type === "error") {
        $eih5o.handleResponseError(span, response);
        return;
    }
    if (recordOutputs) $0819d45b451329b2$var$addContentAttributes(span, response);
    $0819d45b451329b2$var$addMetadataAttributes(span, response);
}
function $0819d45b451329b2$var$handleStreamingError(error, span, methodPath) {
    $cwsTk.captureException(error, {
        mechanism: {
            handled: false,
            type: "auto.ai.anthropic",
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: $dAQ6V.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
function $0819d45b451329b2$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $5VGek.startSpanManual(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $0819d45b451329b2$var$addPrivateRequestAttributes(span, params, $brX6l.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $2tEoB.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $0819d45b451329b2$var$handleStreamingError(error, span, methodPath);
                }
            })();
        });
        return $brX6l.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
    } else return $5VGek.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $0819d45b451329b2$var$addPrivateRequestAttributes(span, params, $brX6l.shouldEnableTruncation(options.enableTruncation));
            const messageStream = target.apply(context, args);
            return $2tEoB.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            return $0819d45b451329b2$var$handleStreamingError(error, span, methodPath);
        }
    });
}
function $0819d45b451329b2$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = $0819d45b451329b2$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            const params = typeof args[0] === "object" ? args[0] : void 0;
            const isStreamRequested = Boolean(params?.stream);
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (isStreamRequested || isStreamingMethod) return $0819d45b451329b2$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $5VGek.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(context, args);
                if (options.recordInputs && params) $0819d45b451329b2$var$addPrivateRequestAttributes(span, params, $brX6l.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $0819d45b451329b2$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                }, (error)=>{
                    $cwsTk.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.anthropic",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    throw error;
                });
            });
            return $brX6l.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
        }
    });
}
function $0819d45b451329b2$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $brX6l.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $ho5on.ANTHROPIC_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $0819d45b451329b2$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $0819d45b451329b2$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $0819d45b451329b2$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $0819d45b451329b2$var$createDeepProxy(anthropicAiClient, "", $brX6l.resolveAIRecordingOptions(options));
}
module.exports.instrumentAnthropicAiClient = $0819d45b451329b2$var$instrumentAnthropicAiClient;

});
parcelRegister("ho5on", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ca88dc4f8da6e3e9$var$ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
const $ca88dc4f8da6e3e9$var$ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $ca88dc4f8da6e3e9$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $ca88dc4f8da6e3e9$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("2tEoB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $dAQ6V = parcelRequire("dAQ6V");

var $brX6l = parcelRequire("brX6l");

var $eih5o = parcelRequire("eih5o");
function $1cdd9ffe2b9b8ae6$var$isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") {
        if (event.type === "error") {
            span.setStatus({
                code: $dAQ6V.SPAN_STATUS_ERROR,
                message: $eih5o.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            $cwsTk.captureException(event.error, {
                mechanism: {
                    handled: false,
                    type: "auto.ai.anthropic.anthropic_error"
                }
            });
            return true;
        }
    }
    return false;
}
function $1cdd9ffe2b9b8ae6$var$handleMessageMetadata(event, state) {
    if (event.type === "message_delta" && event.usage) {
        if ("output_tokens" in event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.stop_reason) state.finishReasons.push(message.stop_reason);
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
function $1cdd9ffe2b9b8ae6$var$handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
function $1cdd9ffe2b9b8ae6$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
function $1cdd9ffe2b9b8ae6$var$handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    delete state.activeToolBlocks[event.index];
}
function $1cdd9ffe2b9b8ae6$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = $1cdd9ffe2b9b8ae6$var$isErrorEvent(event, span);
    if (isError) return;
    $1cdd9ffe2b9b8ae6$var$handleMessageMetadata(event, state);
    $1cdd9ffe2b9b8ae6$var$handleContentBlockStart(event, state);
    $1cdd9ffe2b9b8ae6$var$handleContentBlockDelta(event, state, recordOutputs);
    $1cdd9ffe2b9b8ae6$var$handleContentBlockStop(event, state);
}
async function* $1cdd9ffe2b9b8ae6$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $1cdd9ffe2b9b8ae6$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $brX6l.endStreamSpan(span, state, recordOutputs);
    }
}
function $1cdd9ffe2b9b8ae6$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        $1cdd9ffe2b9b8ae6$var$processEvent(event, state, recordOutputs, span);
    });
    stream.on("message", ()=>{
        $brX6l.endStreamSpan(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        $cwsTk.captureException(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $dAQ6V.SPAN_STATUS_ERROR,
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $1cdd9ffe2b9b8ae6$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $1cdd9ffe2b9b8ae6$var$instrumentMessageStream;

});
parcelRegister("eih5o", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $dAQ6V = parcelRequire("dAQ6V");

var $31Di6 = parcelRequire("31Di6");

var $brX6l = parcelRequire("brX6l");
function $a6800008e19f02ff$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $brX6l.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$31Di6.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$31Di6.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $brX6l.getTruncatedJsonString(filteredMessages) : $brX6l.getJsonString(filteredMessages),
        [$31Di6.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $a6800008e19f02ff$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
function $a6800008e19f02ff$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return $a6800008e19f02ff$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
function $a6800008e19f02ff$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $dAQ6V.SPAN_STATUS_ERROR,
            message: $a6800008e19f02ff$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $cwsTk.captureException(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
function $a6800008e19f02ff$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : void 0;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $a6800008e19f02ff$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $a6800008e19f02ff$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $a6800008e19f02ff$var$messagesFromParams;
module.exports.setMessagesAttribute = $a6800008e19f02ff$var$setMessagesAttribute;

});



parcelRegister("jF9EZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $7nMWX = parcelRequire("7nMWX");

var $dAQ6V = parcelRequire("dAQ6V");

var $5VGek = parcelRequire("5VGek");

var $3fFnG = parcelRequire("3fFnG");

var $31Di6 = parcelRequire("31Di6");

var $brX6l = parcelRequire("brX6l");

var $gwxpT = parcelRequire("gwxpT");

var $7i6v9 = parcelRequire("7i6v9");

var $e6PKK = parcelRequire("e6PKK");
function $e50956f54b7c73ad$var$extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    if (context && typeof context === "object") {
        const contextObj = context;
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
function $e50956f54b7c73ad$var$extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[$31Di6.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[$31Di6.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[$31Di6.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[$31Di6.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[$31Di6.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[$31Di6.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
function $e50956f54b7c73ad$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$31Di6.GEN_AI_SYSTEM_ATTRIBUTE]: $gwxpT.GOOGLE_GENAI_SYSTEM_NAME,
        [$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $e50956f54b7c73ad$var$extractModel(params, context);
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, $e50956f54b7c73ad$var$extractConfigAttributes(config));
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$31Di6.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $e50956f54b7c73ad$var$extractModel({}, context);
    return attributes;
}
function $e50956f54b7c73ad$var$addPrivateRequestAttributes(span, params, isEmbeddings, enableTruncation) {
    if (isEmbeddings) {
        const contents = params.contents;
        if (contents != null) span.setAttribute($31Di6.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...$e6PKK.contentUnionToMessages(params.config.systemInstruction, "system"));
    if ("history" in params) messages.push(...$e6PKK.contentUnionToMessages(params.history, "user"));
    if ("contents" in params) messages.push(...$e6PKK.contentUnionToMessages(params.contents, "user"));
    if ("message" in params) messages.push(...$e6PKK.contentUnionToMessages(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $brX6l.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($31Di6.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$31Di6.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$31Di6.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $brX6l.getTruncatedJsonString(filteredMessages) : $brX6l.getJsonString(filteredMessages)
        });
    }
}
function $e50956f54b7c73ad$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute($31Di6.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === "number") span.setAttributes({
            [$31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === "number") span.setAttributes({
            [$31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === "number") span.setAttributes({
            [$31Di6.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
        });
    }
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$31Di6.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
        });
    }
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$31Di6.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
function $e50956f54b7c73ad$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = $e50956f54b7c73ad$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            if (instrumentedMethod.streaming) return $5VGek.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $e50956f54b7c73ad$var$addPrivateRequestAttributes(span, params, isEmbeddings, $brX6l.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $7i6v9.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $dAQ6V.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $cwsTk.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    span.end();
                    throw error;
                }
            });
            return $5VGek.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $e50956f54b7c73ad$var$addPrivateRequestAttributes(span, params, isEmbeddings, $brX6l.shouldEnableTruncation(options.enableTruncation));
                return $3fFnG.handleCallbackErrors(()=>target.apply(context, args), (error)=>{
                    $cwsTk.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>{
                    if (!isEmbeddings) $e50956f54b7c73ad$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
function $e50956f54b7c73ad$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $brX6l.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $gwxpT.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                const wrappedMethod = instrumentedMethod.operation ? $e50956f54b7c73ad$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return $e50956f54b7c73ad$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") return value.bind(t);
            if (value && typeof value === "object") return $e50956f54b7c73ad$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $e50956f54b7c73ad$var$instrumentGoogleGenAIClient(client, options) {
    return $e50956f54b7c73ad$var$createDeepProxy(client, "", $brX6l.resolveAIRecordingOptions(options));
}
module.exports.extractModel = $e50956f54b7c73ad$var$extractModel;
module.exports.instrumentGoogleGenAIClient = $e50956f54b7c73ad$var$instrumentGoogleGenAIClient;

});
parcelRegister("gwxpT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c0798e529e2d798b$var$GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const $c0798e529e2d798b$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
const $c0798e529e2d798b$var$GOOGLE_GENAI_SYSTEM_NAME = "google_genai";
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $c0798e529e2d798b$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $c0798e529e2d798b$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $c0798e529e2d798b$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("7i6v9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $dAQ6V = parcelRequire("dAQ6V");

var $brX6l = parcelRequire("brX6l");
function $54ef41e876f1a099$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $dAQ6V.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $cwsTk.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
function $54ef41e876f1a099$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
    }
}
function $54ef41e876f1a099$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
function $54ef41e876f1a099$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $54ef41e876f1a099$var$isErrorChunk(chunk, span)) return;
    $54ef41e876f1a099$var$handleResponseMetadata(chunk, state);
    $54ef41e876f1a099$var$handleCandidateContent(chunk, state, recordOutputs);
}
async function* $54ef41e876f1a099$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $54ef41e876f1a099$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $brX6l.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $54ef41e876f1a099$var$instrumentStream;

});

parcelRegister("e6PKK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $a459c5514dc681d4$var$contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content2)=>$a459c5514dc681d4$var$contentUnionToMessages(content2, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $a459c5514dc681d4$var$contentUnionToMessages;

});


parcelRegister("auUX5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $7nMWX = parcelRequire("7nMWX");

var $dAQ6V = parcelRequire("dAQ6V");

var $5VGek = parcelRequire("5VGek");

var $31Di6 = parcelRequire("31Di6");

var $brX6l = parcelRequire("brX6l");

var $7W5hL = parcelRequire("7W5hL");

var $6m1Z1 = parcelRequire("6m1Z1");
function $7a48e23a9a3d9f1f$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $brX6l.resolveAIRecordingOptions(options);
    const enableTruncation = $brX6l.shouldEnableTruncation(options.enableTruncation);
    const spanMap = /* @__PURE__ */ new Map();
    const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: void 0,
        lc_attributes: void 0,
        lc_aliases: void 0,
        lc_serializable_keys: void 0,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $6m1Z1.getInvocationParams(tags);
            const attributes = $6m1Z1.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $5VGek.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$6m1Z1.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $6m1Z1.getInvocationParams(tags);
            const attributes = $6m1Z1.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $6m1Z1.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$31Di6.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $5VGek.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$6m1Z1.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $6m1Z1.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $dAQ6V.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $cwsTk.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$7W5hL.LANGCHAIN_ORIGIN}.llm_error_handler`
                }
            });
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            $5VGek.startSpanManual({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: {
                    ...attributes,
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $dAQ6V.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $cwsTk.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$7W5hL.LANGCHAIN_ORIGIN}.chain_error_handler`
                }
            });
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = {
                ...$6m1Z1.getAgentNameFromMetadata(metadata),
                [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $7W5hL.LANGCHAIN_ORIGIN,
                [$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                [$31Di6.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$31Di6.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $5VGek.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: {
                    ...attributes,
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$31Di6.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $dAQ6V.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $cwsTk.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$7W5hL.LANGCHAIN_ORIGIN}.tool_error_handler`
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $7a48e23a9a3d9f1f$var$createLangChainCallbackHandler;

});
parcelRegister("7W5hL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $5c720cc4cac126a6$var$LANGCHAIN_INTEGRATION_NAME = "LangChain";
const $5c720cc4cac126a6$var$LANGCHAIN_ORIGIN = "auto.ai.langchain";
const $5c720cc4cac126a6$var$ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $5c720cc4cac126a6$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $5c720cc4cac126a6$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $5c720cc4cac126a6$var$ROLE_MAP;

});

parcelRegister("6m1Z1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7nMWX = parcelRequire("7nMWX");

var $31Di6 = parcelRequire("31Di6");

var $8MUh4 = parcelRequire("8MUh4");

var $brX6l = parcelRequire("brX6l");

var $7W5hL = parcelRequire("7W5hL");
const $4a0655f686557fbc$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
const $4a0655f686557fbc$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
function $4a0655f686557fbc$var$asString(v) {
    if (typeof v === "string") return v;
    try {
        return JSON.stringify(v);
    } catch  {
        return String(v);
    }
}
function $4a0655f686557fbc$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && $8MUh4.isContentMedia(part) ? $8MUh4.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $4a0655f686557fbc$var$asString(v);
}
function $4a0655f686557fbc$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $7W5hL.ROLE_MAP[normalized] ?? normalized;
}
function $4a0655f686557fbc$var$normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
function $4a0655f686557fbc$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return void 0;
    return tags.invocation_params;
}
function $4a0655f686557fbc$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: $4a0655f686557fbc$var$normalizeMessageRole(messageType),
                content: $4a0655f686557fbc$var$normalizeContent(message.content)
            };
        }
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? $4a0655f686557fbc$var$normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: $4a0655f686557fbc$var$normalizeMessageRole(role),
                content: $4a0655f686557fbc$var$normalizeContent(message.kwargs?.content)
            };
        }
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $4a0655f686557fbc$var$normalizeMessageRole(role),
                content: $4a0655f686557fbc$var$normalizeContent(message.content)
            };
        }
        if (message.role) return {
            role: $4a0655f686557fbc$var$normalizeMessageRole(String(message.role)),
            content: $4a0655f686557fbc$var$normalizeContent(message.content)
        };
        const ctor = message.constructor?.name;
        if (ctor && ctor !== "Object") return {
            role: $4a0655f686557fbc$var$normalizeMessageRole($4a0655f686557fbc$var$normalizeRoleNameFromCtor(ctor)),
            content: $4a0655f686557fbc$var$normalizeContent(message.content)
        };
        return {
            role: "user",
            content: $4a0655f686557fbc$var$normalizeContent(message.content)
        };
    });
}
function $4a0655f686557fbc$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    if (invocationParams && "stream" in invocationParams) $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
function $4a0655f686557fbc$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$31Di6.GEN_AI_SYSTEM_ATTRIBUTE]: $4a0655f686557fbc$var$asString(system ?? "langchain"),
        [$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
        [$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $4a0655f686557fbc$var$asString(modelName),
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $7W5hL.LANGCHAIN_ORIGIN,
        ...$4a0655f686557fbc$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
function $4a0655f686557fbc$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $4a0655f686557fbc$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $brX6l.getTruncatedJsonString(messages) : $brX6l.getJsonString(messages));
    }
    return attrs;
}
function $4a0655f686557fbc$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $4a0655f686557fbc$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $4a0655f686557fbc$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $brX6l.extractSystemInstructions(normalized);
        if (systemInstructions) $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $brX6l.getTruncatedJsonString(filteredMessages) : $brX6l.getJsonString(filteredMessages));
    }
    return attrs;
}
function $4a0655f686557fbc$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $4a0655f686557fbc$var$asString(toolCalls));
}
function $4a0655f686557fbc$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
        $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
        $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
        $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
        if (anthropicUsage.cache_creation_input_tokens !== void 0) $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== void 0) $4a0655f686557fbc$var$setNumberIfDefined(attrs, $31Di6.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
    }
}
function $4a0655f686557fbc$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $4a0655f686557fbc$var$asString(finishReasons));
        $4a0655f686557fbc$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === "string");
            if (texts.length > 0) $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $4a0655f686557fbc$var$asString(texts));
        }
    }
    $4a0655f686557fbc$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $4a0655f686557fbc$var$setIfDefined(attrs, $31Di6.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $4a0655f686557fbc$var$asString(stopReason));
    return attrs;
}
function $4a0655f686557fbc$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === "string") attrs[$31Di6.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $4a0655f686557fbc$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return void 0;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: "function",
            name: tool.name ?? fn?.name ?? "",
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
function $4a0655f686557fbc$var$isCallbackManager(value) {
    if (!value || typeof value !== "object") return false;
    const candidate = value;
    return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
}
function $4a0655f686557fbc$var$isSentryHandler(handler) {
    return typeof handler === "object" && handler?.name === "SentryCallbackHandler";
}
function $4a0655f686557fbc$var$containsSentryHandler(handlers) {
    return handlers.some($4a0655f686557fbc$var$isSentryHandler);
}
function $4a0655f686557fbc$var$_INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if ($4a0655f686557fbc$var$isCallbackManager(existing)) {
        if ($4a0655f686557fbc$var$containsSentryHandler(existing.handlers ?? [])) return existing;
        const copied = existing.copy();
        copied.addHandler(sentryHandler, true);
        return copied;
    }
    const handlers = Array.isArray(existing) ? existing : [
        existing
    ];
    if ($4a0655f686557fbc$var$containsSentryHandler(handlers)) return existing;
    return [
        ...handlers,
        sentryHandler
    ];
}
module.exports._INTERNAL_mergeLangChainCallbackHandler = $4a0655f686557fbc$var$_INTERNAL_mergeLangChainCallbackHandler;
module.exports.extractChatModelRequestAttributes = $4a0655f686557fbc$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $4a0655f686557fbc$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $4a0655f686557fbc$var$extractLlmResponseAttributes;
module.exports.extractToolDefinitions = $4a0655f686557fbc$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $4a0655f686557fbc$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $4a0655f686557fbc$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $4a0655f686557fbc$var$normalizeLangChainMessages;

});


parcelRegister("50tta", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $7nMWX = parcelRequire("7nMWX");

var $dAQ6V = parcelRequire("dAQ6V");

var $5VGek = parcelRequire("5VGek");

var $31Di6 = parcelRequire("31Di6");

var $brX6l = parcelRequire("brX6l");

var $auUX5 = parcelRequire("auUX5");

var $6m1Z1 = parcelRequire("6m1Z1");

var $k11y2 = parcelRequire("k11y2");

var $6f5Bq = parcelRequire("6f5Bq");
let $3a53cfd44b9803b0$var$_insideCreateReactAgent = false;
const $3a53cfd44b9803b0$var$SENTRY_PATCHED = "__sentry_patched__";
function $3a53cfd44b9803b0$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $3a53cfd44b9803b0$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $auUX5.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            if ($3a53cfd44b9803b0$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $5VGek.startSpan({
                op: "gen_ai.create_agent",
                name: "create_agent",
                attributes: {
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $k11y2.LANGGRAPH_ORIGIN,
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
                    [$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
                }
            }, (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    if (compileOptions?.name && typeof compileOptions.name === "string") {
                        span.setAttribute($31Di6.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = $3a53cfd44b9803b0$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, void 0, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $dAQ6V.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $cwsTk.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $3a53cfd44b9803b0$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $3a53cfd44b9803b0$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $5VGek.startSpan({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $k11y2.LANGGRAPH_ORIGIN,
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $31Di6.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute($31Di6.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($31Di6.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    const config = args.length > 1 ? args[1] : void 0;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute($31Di6.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === "string" ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $6m1Z1._INTERNAL_mergeLangChainCallbackHandler(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    const tools = $6f5Bq.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($31Di6.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $6m1Z1.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $brX6l.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($31Di6.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $brX6l.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$31Di6.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $brX6l.getTruncatedJsonString(filteredMessages) : $brX6l.getJsonString(filteredMessages),
                            [$31Di6.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $6f5Bq.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $dAQ6V.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $cwsTk.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
function $3a53cfd44b9803b0$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $3a53cfd44b9803b0$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $brX6l.resolveAIRecordingOptions(options);
    const sentryHandler = $auUX5.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $6f5Bq.extractLLMFromParams(args);
            const agentName = $6f5Bq.extractAgentNameFromParams(args);
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $6f5Bq.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? void 0);
            $3a53cfd44b9803b0$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $3a53cfd44b9803b0$var$_insideCreateReactAgent = false;
            }
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $3a53cfd44b9803b0$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $3a53cfd44b9803b0$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $3a53cfd44b9803b0$var$instrumentLangGraph(stateGraph, options) {
    stateGraph.compile = $3a53cfd44b9803b0$var$instrumentStateGraphCompile(stateGraph.compile, $brX6l.resolveAIRecordingOptions(options));
    return stateGraph;
}
module.exports.instrumentCreateReactAgent = $3a53cfd44b9803b0$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $3a53cfd44b9803b0$var$instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $3a53cfd44b9803b0$var$instrumentStateGraphCompile;

});
parcelRegister("k11y2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e9251a0c5491a8dd$var$LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const $e9251a0c5491a8dd$var$LANGGRAPH_ORIGIN = "auto.ai.langgraph";
module.exports.LANGGRAPH_INTEGRATION_NAME = $e9251a0c5491a8dd$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $e9251a0c5491a8dd$var$LANGGRAPH_ORIGIN;

});

parcelRegister("6f5Bq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $7nMWX = parcelRequire("7nMWX");

var $dAQ6V = parcelRequire("dAQ6V");

var $5VGek = parcelRequire("5VGek");

var $31Di6 = parcelRequire("31Di6");

var $6m1Z1 = parcelRequire("6m1Z1");

var $k11y2 = parcelRequire("k11y2");
function $48b87d5d8bf5b0f5$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
function $48b87d5d8bf5b0f5$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
function $48b87d5d8bf5b0f5$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : void 0;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $k11y2.LANGGRAPH_ORIGIN,
                    [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $31Di6.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                    [$31Di6.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$31Di6.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
                };
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === "string") spanAttributes[$31Di6.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$31Di6.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[$31Di6.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[$31Di6.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {}
                    }
                }
                return $5VGek.startSpan({
                    op: $31Di6.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute($31Di6.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === "string" ? content : JSON.stringify(content));
                        } catch  {}
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $dAQ6V.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $cwsTk.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.langgraph.error"
                            }
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
function $48b87d5d8bf5b0f5$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
function $48b87d5d8bf5b0f5$var$extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    if (msg.usage_metadata && typeof msg.usage_metadata === "object") {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === "number") inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === "number") outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === "number") totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === "object") {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === "number") inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === "number") outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === "number") totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
function $48b87d5d8bf5b0f5$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute($31Di6.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute($31Di6.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
function $48b87d5d8bf5b0f5$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
function $48b87d5d8bf5b0f5$var$setResponseAttributes(span, inputMessages, result) {
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    const toolCalls = $48b87d5d8bf5b0f5$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($31Di6.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    const normalizedNewMessages = $6m1Z1.normalizeLangChainMessages(newMessages);
    span.setAttribute($31Di6.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    for (const message of newMessages){
        const tokens = $48b87d5d8bf5b0f5$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        $48b87d5d8bf5b0f5$var$extractModelMetadata(span, message);
    }
    if (totalInputTokens > 0) span.setAttribute($31Di6.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($31Di6.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($31Di6.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
}
module.exports.extractAgentNameFromParams = $48b87d5d8bf5b0f5$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $48b87d5d8bf5b0f5$var$extractLLMFromParams;
module.exports.extractModelMetadata = $48b87d5d8bf5b0f5$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $48b87d5d8bf5b0f5$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $48b87d5d8bf5b0f5$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $48b87d5d8bf5b0f5$var$extractToolsFromCompiledGraph;
module.exports.setResponseAttributes = $48b87d5d8bf5b0f5$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $48b87d5d8bf5b0f5$var$wrapToolsWithSpans;

});


parcelRegister("eTHLH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $40w67 = parcelRequire("40w67");

var $6vmlI = parcelRequire("6vmlI");

var $1KWCd = parcelRequire("1KWCd");

var $4T84q = parcelRequire("4T84q");
const $ad8827343c183e00$var$MAX_SPANS_PER_ENVELOPE = 1e3;
const $ad8827343c183e00$var$MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
class $ad8827343c183e00$var$SpanBuffer {
    constructor(client, options){
        this._traceBuckets = /* @__PURE__ */ new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $ad8827343c183e00$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $ad8827343c183e00$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $ad8827343c183e00$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: /* @__PURE__ */ new Set(),
                size: 0,
                timeout: $40w67.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $4T84q.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = $6vmlI.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $1KWCd.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $cWDS7.DEBUG_BUILD && $jDmhV.debug.error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $ad8827343c183e00$var$SpanBuffer;

});
parcelRegister("1KWCd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $luwRx = parcelRequire("luwRx");

var $dQ0Qv = parcelRequire("dQ0Qv");

var $kQG62 = parcelRequire("kQG62");
function $14778e1a748b6197$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $dQ0Qv.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...$14778e1a748b6197$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $luwRx.dsnToString(dsn$1)
        }
    };
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$kQG62.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $dQ0Qv.createEnvelope(headers, [
        spanContainer
    ]);
}
function $14778e1a748b6197$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $14778e1a748b6197$var$createStreamedSpanEnvelope;

});

parcelRegister("4T84q", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gLiBf = parcelRequire("gLiBf");
function $38f28f1b35350096$var$estimateSerializedSpanSizeInBytes(span) {
    let weight = 156;
    weight += span.name.length * 2;
    weight += $gLiBf.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        const linkWeight = 100 + (attributes$1 ? $gLiBf.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $38f28f1b35350096$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("b08Oi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $2Rd9o = parcelRequire("2Rd9o");

var $4BYqM = parcelRequire("4BYqM");

var $2VRKv = parcelRequire("2VRKv");

var $lk94N = parcelRequire("lk94N");

var $eTHLH = parcelRequire("eTHLH");

var $jDmhV = parcelRequire("jDmhV");

var $hR4pa = parcelRequire("hR4pa");
const $8026874ef469656f$var$spanStreamingIntegration = $2Rd9o.defineIntegration(()=>{
    return {
        name: "SpanStreaming",
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!$lk94N.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = "static";
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$4BYqM.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = "static";
                $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $eTHLH.SpanBuffer(client);
            client.on("afterSpanEnd", (span)=>{
                if (!$hR4pa.spanIsSampled(span)) return;
                buffer.add($2VRKv.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $8026874ef469656f$var$spanStreamingIntegration;

});

parcelRegister("1Jcad", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $14236de5313fd3b3$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $14236de5313fd3b3$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("6zypK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $4c90b4e95dcae288$var$SentryError extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $4c90b4e95dcae288$var$SentryError;

});

parcelRegister("fkTTl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k1IvE = parcelRequire("k1IvE");

var $jm1F1 = parcelRequire("jm1F1");

var $56noD = parcelRequire("56noD");

var $55Yug = parcelRequire("55Yug");

var $gQok6 = parcelRequire("gQok6");

var $NKzWo = parcelRequire("NKzWo");

var $ljaTH = parcelRequire("ljaTH");
function $b2a4142cb4b8d3c9$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = $ljaTH.addHandler(type, handler);
    $ljaTH.maybeInstrument(type, ()=>$b2a4142cb4b8d3c9$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $b2a4142cb4b8d3c9$var$addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = $ljaTH.addHandler(type, handler);
    $ljaTH.maybeInstrument(type, ()=>$b2a4142cb4b8d3c9$var$instrumentFetch($b2a4142cb4b8d3c9$var$streamHandler));
    return removeHandler;
}
function $b2a4142cb4b8d3c9$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$55Yug.supportsNativeFetch()) return;
    $56noD.fill($NKzWo.GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $b2a4142cb4b8d3c9$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $gQok6.timestampInSeconds() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $b2a4142cb4b8d3c9$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) $ljaTH.triggerHandlers("fetch", {
                ...handlerData
            });
            return originalFetch.apply($NKzWo.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $ljaTH.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $gQok6.timestampInSeconds() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                $ljaTH.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $gQok6.timestampInSeconds() * 1e3,
                    error: error
                });
                if ($jm1F1.isError(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    $56noD.addNonEnumerableProperty(error, "framesToPop", 1);
                }
                const client = $k1IvE.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else $56noD.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $b2a4142cb4b8d3c9$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $b2a4142cb4b8d3c9$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $b2a4142cb4b8d3c9$var$resolveResponse(clonedResponseForResolving, ()=>{
        $ljaTH.triggerHandlers("fetch-body-resolved", {
            endTimestamp: $gQok6.timestampInSeconds() * 1e3,
            response: response
        });
    });
}
function $b2a4142cb4b8d3c9$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $b2a4142cb4b8d3c9$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($b2a4142cb4b8d3c9$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $b2a4142cb4b8d3c9$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $b2a4142cb4b8d3c9$var$getUrlFromResource(resource),
            method: $b2a4142cb4b8d3c9$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            $jm1F1.isRequest(resource) && $b2a4142cb4b8d3c9$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $b2a4142cb4b8d3c9$var$getUrlFromResource(arg),
        method: $b2a4142cb4b8d3c9$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $b2a4142cb4b8d3c9$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($jm1F1.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}
module.exports.addFetchEndInstrumentationHandler = $b2a4142cb4b8d3c9$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $b2a4142cb4b8d3c9$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $b2a4142cb4b8d3c9$var$parseFetchArgs;

});
parcelRegister("55Yug", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWDS7 = parcelRequire("cWDS7");

var $jDmhV = parcelRequire("jDmhV");

var $NKzWo = parcelRequire("NKzWo");
const $3b5c56db65b220f8$var$WINDOW = $NKzWo.GLOBAL_OBJ;
function $3b5c56db65b220f8$var$supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $3b5c56db65b220f8$var$supportsDOMError() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $3b5c56db65b220f8$var$supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $3b5c56db65b220f8$var$supportsHistory() {
    return "history" in $3b5c56db65b220f8$var$WINDOW && !!$3b5c56db65b220f8$var$WINDOW.history;
}
const $3b5c56db65b220f8$var$supportsFetch = $3b5c56db65b220f8$var$_isFetchSupported;
function $3b5c56db65b220f8$var$_isFetchSupported() {
    if (!("fetch" in $3b5c56db65b220f8$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $3b5c56db65b220f8$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $3b5c56db65b220f8$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$3b5c56db65b220f8$var$_isFetchSupported()) return false;
    if ($3b5c56db65b220f8$var$isNativeFunction($3b5c56db65b220f8$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $3b5c56db65b220f8$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $3b5c56db65b220f8$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $cWDS7.DEBUG_BUILD && $jDmhV.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $3b5c56db65b220f8$var$supportsReportingObserver() {
    return "ReportingObserver" in $3b5c56db65b220f8$var$WINDOW;
}
function $3b5c56db65b220f8$var$supportsReferrerPolicy() {
    if (!$3b5c56db65b220f8$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $3b5c56db65b220f8$var$isNativeFunction;
module.exports.supportsDOMError = $3b5c56db65b220f8$var$supportsDOMError;
module.exports.supportsDOMException = $3b5c56db65b220f8$var$supportsDOMException;
module.exports.supportsErrorEvent = $3b5c56db65b220f8$var$supportsErrorEvent;
module.exports.supportsFetch = $3b5c56db65b220f8$var$supportsFetch;
module.exports.supportsHistory = $3b5c56db65b220f8$var$supportsHistory;
module.exports.supportsNativeFetch = $3b5c56db65b220f8$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $3b5c56db65b220f8$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $3b5c56db65b220f8$var$supportsReportingObserver;

});


parcelRegister("9Gk1l", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $70c79102338016cd$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== "function") return;
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, "default", {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $70c79102338016cd$var$replaceExports;

});

parcelRegister("d2zen", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $97e6ca5f02c751f4$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $97e6ca5f02c751f4$var$LRUMap;

});

parcelRegister("cWBJD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $96c82c33ec6482c6$var$escapeStringForRegex(regexString) {
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
module.exports.escapeStringForRegex = $96c82c33ec6482c6$var$escapeStringForRegex;

});

parcelRegister("792Ou", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jm1F1 = parcelRequire("jm1F1");

var $NKzWo = parcelRequire("NKzWo");
const $533b8e5aace3edac$var$WINDOW = $NKzWo.GLOBAL_OBJ;
const $533b8e5aace3edac$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $533b8e5aace3edac$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $533b8e5aace3edac$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $533b8e5aace3edac$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $533b8e5aace3edac$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($533b8e5aace3edac$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $jm1F1.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $533b8e5aace3edac$var$getLocationHref() {
    try {
        return $533b8e5aace3edac$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $533b8e5aace3edac$var$getComponentName(elem, maxTraverseHeight = 5) {
    if (!$533b8e5aace3edac$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $533b8e5aace3edac$var$getComponentName;
module.exports.getLocationHref = $533b8e5aace3edac$var$getLocationHref;
module.exports.htmlTreeAsString = $533b8e5aace3edac$var$htmlTreeAsString;

});

parcelRegister("hM8bG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cwsTk = parcelRequire("cwsTk");

var $7nMWX = parcelRequire("7nMWX");

var $5VGek = parcelRequire("5VGek");

var $31Di6 = parcelRequire("31Di6");

var $brX6l = parcelRequire("brX6l");

var $7W5hL = parcelRequire("7W5hL");
function $cf0d4535e8f9c3a1$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
function $cf0d4535e8f9c3a1$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $7W5hL.LANGCHAIN_ORIGIN,
        [$7nMWX.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $31Di6.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$31Di6.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
        [$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? "unknown"
    };
    attributes[$31Di6.GEN_AI_SYSTEM_ATTRIBUTE] = $cf0d4535e8f9c3a1$var$inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[$31Di6.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[$31Di6.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
function $cf0d4535e8f9c3a1$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    const { recordInputs: recordInputs } = $brX6l.resolveAIRecordingOptions(options);
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const attributes = $cf0d4535e8f9c3a1$var$extractEmbeddingAttributes(thisArg);
            const modelName = attributes[$31Di6.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
            if (recordInputs) {
                const input = args[0];
                if (input != null) attributes[$31Di6.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
            }
            return $5VGek.startSpan({
                name: `embeddings ${modelName}`,
                op: $31Di6.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
                attributes: attributes
            }, ()=>{
                return Reflect.apply(target, thisArg, args).then(void 0, (error)=>{
                    $cwsTk.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langchain"
                        }
                    });
                    throw error;
                });
            });
        }
    });
}
function $cf0d4535e8f9c3a1$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = $cf0d4535e8f9c3a1$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = $cf0d4535e8f9c3a1$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports.instrumentEmbeddingMethod = $cf0d4535e8f9c3a1$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $cf0d4535e8f9c3a1$var$instrumentLangChainEmbeddings;

});


parcelRegister("dwpdt", function(module, exports) {

var $jBmpJ = parcelRequire("jBmpJ");
"use strict";
































module.exports = function() {
    var makeSelfResolutionError = function() {
        return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    };
    var reflectHandler = function() {
        return new Promise.PromiseInspection(this._target());
    };
    var apiRejection = function(msg) {
        return Promise.reject(new TypeError(msg));
    };
    function Proxyable() {}
    var UNDEFINED_BINDING = {};
    var util = (parcelRequire("gwhLZ"));
    var getDomain;
    if (util.isNode) getDomain = function() {
        var ret = $jBmpJ.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
    else getDomain = function() {
        return null;
    };
    util.notEnumerableProp(Promise, "_getDomain", getDomain);
    var es5 = (parcelRequire("4Ys6H"));
    var Async = (parcelRequire("l8ya4"));
    var async = new Async();
    es5.defineProperty(Promise, "_async", {
        value: async
    });
    var errors = (parcelRequire("8iBp5"));
    var TypeError = Promise.TypeError = errors.TypeError;
    Promise.RangeError = errors.RangeError;
    var CancellationError = Promise.CancellationError = errors.CancellationError;
    Promise.TimeoutError = errors.TimeoutError;
    Promise.OperationalError = errors.OperationalError;
    Promise.RejectionError = errors.OperationalError;
    Promise.AggregateError = errors.AggregateError;
    var INTERNAL = function() {};
    var APPLY = {};
    var NEXT_FILTER = {};
    var tryConvertToPromise = (parcelRequire("hidIl"))(Promise, INTERNAL);
    var PromiseArray = (parcelRequire("dXJVZ"))(Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
    var Context = (parcelRequire("bZvzT"))(Promise);
    /*jshint unused:false*/ var createContext = Context.create;
    var debug = (parcelRequire("7mX4p"))(Promise, Context);
    var CapturedTrace = debug.CapturedTrace;
    var PassThroughHandlerContext = (parcelRequire("hrFux"))(Promise, tryConvertToPromise);
    var catchFilter = (parcelRequire("6aswz"))(NEXT_FILTER);
    var nodebackForPromise = (parcelRequire("D39zY"));
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    function check(self, executor) {
        if (typeof executor !== "function") throw new TypeError("expecting a function but got " + util.classString(executor));
        if (self.constructor !== Promise) throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    function Promise(executor) {
        this._bitField = 0;
        this._fulfillmentHandler0 = undefined;
        this._rejectionHandler0 = undefined;
        this._promise0 = undefined;
        this._receiver0 = undefined;
        if (executor !== INTERNAL) {
            check(this, executor);
            this._resolveFromExecutor(executor);
        }
        this._promiseCreated();
        this._fireEvent("promiseCreated", this);
    }
    Promise.prototype.toString = function() {
        return "[object Promise]";
    };
    Promise.prototype.caught = Promise.prototype["catch"] = function(fn) {
        var len = arguments.length;
        if (len > 1) {
            var catchInstances = new Array(len - 1), j = 0, i;
            for(i = 0; i < len - 1; ++i){
                var item = arguments[i];
                if (util.isObject(item)) catchInstances[j++] = item;
                else return apiRejection("expecting an object but got A catch statement predicate " + util.classString(item));
            }
            catchInstances.length = j;
            fn = arguments[i];
            return this.then(undefined, catchFilter(catchInstances, fn, this));
        }
        return this.then(undefined, fn);
    };
    Promise.prototype.reflect = function() {
        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
    };
    Promise.prototype.then = function(didFulfill, didReject) {
        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
            if (arguments.length > 1) msg += ", " + util.classString(didReject);
            this._warn(msg);
        }
        return this._then(didFulfill, didReject, undefined, undefined, undefined);
    };
    Promise.prototype.done = function(didFulfill, didReject) {
        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
        promise._setIsFinal();
    };
    Promise.prototype.spread = function(fn) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
    };
    Promise.prototype.toJSON = function() {
        var ret = {
            isFulfilled: false,
            isRejected: false,
            fulfillmentValue: undefined,
            rejectionReason: undefined
        };
        if (this.isFulfilled()) {
            ret.fulfillmentValue = this.value();
            ret.isFulfilled = true;
        } else if (this.isRejected()) {
            ret.rejectionReason = this.reason();
            ret.isRejected = true;
        }
        return ret;
    };
    Promise.prototype.all = function() {
        if (arguments.length > 0) this._warn(".all() was passed arguments but it does not take any");
        return new PromiseArray(this).promise();
    };
    Promise.prototype.error = function(fn) {
        return this.caught(util.originatesFromRejection, fn);
    };
    Promise.getNewLibraryCopy = module.exports;
    Promise.is = function(val) {
        return val instanceof Promise;
    };
    Promise.fromNode = Promise.fromCallback = function(fn) {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
        if (result === errorObj) ret._rejectCallback(result.e, true);
        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
        return ret;
    };
    Promise.all = function(promises) {
        return new PromiseArray(promises).promise();
    };
    Promise.cast = function(obj) {
        var ret = tryConvertToPromise(obj);
        if (!(ret instanceof Promise)) {
            ret = new Promise(INTERNAL);
            ret._captureStackTrace();
            ret._setFulfilled();
            ret._rejectionHandler0 = obj;
        }
        return ret;
    };
    Promise.resolve = Promise.fulfilled = Promise.cast;
    Promise.reject = Promise.rejected = function(reason) {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._rejectCallback(reason, true);
        return ret;
    };
    Promise.setScheduler = function(fn) {
        if (typeof fn !== "function") throw new TypeError("expecting a function but got " + util.classString(fn));
        return async.setScheduler(fn);
    };
    Promise.prototype._then = function(didFulfill, didReject, _, receiver, internalData) {
        var haveInternalData = internalData !== undefined;
        var promise = haveInternalData ? internalData : new Promise(INTERNAL);
        var target = this._target();
        var bitField = target._bitField;
        if (!haveInternalData) {
            promise._propagateFrom(this, 3);
            promise._captureStackTrace();
            if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                if (!((bitField & 50397184) === 0)) receiver = this._boundValue();
                else receiver = target === this ? undefined : this._boundTo;
            }
            this._fireEvent("promiseChained", this, promise);
        }
        var domain = getDomain();
        if (!((bitField & 50397184) === 0)) {
            var handler, value, settler = target._settlePromiseCtx;
            if ((bitField & 33554432) !== 0) {
                value = target._rejectionHandler0;
                handler = didFulfill;
            } else if ((bitField & 16777216) !== 0) {
                value = target._fulfillmentHandler0;
                handler = didReject;
                target._unsetRejectionIsUnhandled();
            } else {
                settler = target._settlePromiseLateCancellationObserver;
                value = new CancellationError("late cancellation observer");
                target._attachExtraTrace(value);
                handler = didReject;
            }
            async.invoke(settler, target, {
                handler: domain === null ? handler : typeof handler === "function" && util.domainBind(domain, handler),
                promise: promise,
                receiver: receiver,
                value: value
            });
        } else target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
        return promise;
    };
    Promise.prototype._length = function() {
        return this._bitField & 65535;
    };
    Promise.prototype._isFateSealed = function() {
        return (this._bitField & 117506048) !== 0;
    };
    Promise.prototype._isFollowing = function() {
        return (this._bitField & 67108864) === 67108864;
    };
    Promise.prototype._setLength = function(len) {
        this._bitField = this._bitField & -65536 | len & 65535;
    };
    Promise.prototype._setFulfilled = function() {
        this._bitField = this._bitField | 33554432;
        this._fireEvent("promiseFulfilled", this);
    };
    Promise.prototype._setRejected = function() {
        this._bitField = this._bitField | 16777216;
        this._fireEvent("promiseRejected", this);
    };
    Promise.prototype._setFollowing = function() {
        this._bitField = this._bitField | 67108864;
        this._fireEvent("promiseResolved", this);
    };
    Promise.prototype._setIsFinal = function() {
        this._bitField = this._bitField | 4194304;
    };
    Promise.prototype._isFinal = function() {
        return (this._bitField & 4194304) > 0;
    };
    Promise.prototype._unsetCancelled = function() {
        this._bitField = this._bitField & -65537;
    };
    Promise.prototype._setCancelled = function() {
        this._bitField = this._bitField | 65536;
        this._fireEvent("promiseCancelled", this);
    };
    Promise.prototype._setWillBeCancelled = function() {
        this._bitField = this._bitField | 8388608;
    };
    Promise.prototype._setAsyncGuaranteed = function() {
        if (async.hasCustomScheduler()) return;
        this._bitField = this._bitField | 134217728;
    };
    Promise.prototype._receiverAt = function(index) {
        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
        if (ret === UNDEFINED_BINDING) return undefined;
        else if (ret === undefined && this._isBound()) return this._boundValue();
        return ret;
    };
    Promise.prototype._promiseAt = function(index) {
        return this[index * 4 - 4 + 2];
    };
    Promise.prototype._fulfillmentHandlerAt = function(index) {
        return this[index * 4 - 4 + 0];
    };
    Promise.prototype._rejectionHandlerAt = function(index) {
        return this[index * 4 - 4 + 1];
    };
    Promise.prototype._boundValue = function() {};
    Promise.prototype._migrateCallback0 = function(follower) {
        var bitField = follower._bitField;
        var fulfill = follower._fulfillmentHandler0;
        var reject = follower._rejectionHandler0;
        var promise = follower._promise0;
        var receiver = follower._receiverAt(0);
        if (receiver === undefined) receiver = UNDEFINED_BINDING;
        this._addCallbacks(fulfill, reject, promise, receiver, null);
    };
    Promise.prototype._migrateCallbackAt = function(follower, index) {
        var fulfill = follower._fulfillmentHandlerAt(index);
        var reject = follower._rejectionHandlerAt(index);
        var promise = follower._promiseAt(index);
        var receiver = follower._receiverAt(index);
        if (receiver === undefined) receiver = UNDEFINED_BINDING;
        this._addCallbacks(fulfill, reject, promise, receiver, null);
    };
    Promise.prototype._addCallbacks = function(fulfill, reject, promise, receiver, domain) {
        var index = this._length();
        if (index >= 65531) {
            index = 0;
            this._setLength(0);
        }
        if (index === 0) {
            this._promise0 = promise;
            this._receiver0 = receiver;
            if (typeof fulfill === "function") this._fulfillmentHandler0 = domain === null ? fulfill : util.domainBind(domain, fulfill);
            if (typeof reject === "function") this._rejectionHandler0 = domain === null ? reject : util.domainBind(domain, reject);
        } else {
            var base = index * 4 - 4;
            this[base + 2] = promise;
            this[base + 3] = receiver;
            if (typeof fulfill === "function") this[base + 0] = domain === null ? fulfill : util.domainBind(domain, fulfill);
            if (typeof reject === "function") this[base + 1] = domain === null ? reject : util.domainBind(domain, reject);
        }
        this._setLength(index + 1);
        return index;
    };
    Promise.prototype._proxy = function(proxyable, arg) {
        this._addCallbacks(undefined, undefined, arg, proxyable, null);
    };
    Promise.prototype._resolveCallback = function(value, shouldBind) {
        if ((this._bitField & 117506048) !== 0) return;
        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
        var maybePromise = tryConvertToPromise(value, this);
        if (!(maybePromise instanceof Promise)) return this._fulfill(value);
        if (shouldBind) this._propagateFrom(maybePromise, 2);
        var promise = maybePromise._target();
        if (promise === this) {
            this._reject(makeSelfResolutionError());
            return;
        }
        var bitField = promise._bitField;
        if ((bitField & 50397184) === 0) {
            var len = this._length();
            if (len > 0) promise._migrateCallback0(this);
            for(var i = 1; i < len; ++i)promise._migrateCallbackAt(this, i);
            this._setFollowing();
            this._setLength(0);
            this._setFollowee(promise);
        } else if ((bitField & 33554432) !== 0) this._fulfill(promise._value());
        else if ((bitField & 16777216) !== 0) this._reject(promise._reason());
        else {
            var reason = new CancellationError("late cancellation observer");
            promise._attachExtraTrace(reason);
            this._reject(reason);
        }
    };
    Promise.prototype._rejectCallback = function(reason, synchronous, ignoreNonErrorWarnings) {
        var trace = util.ensureErrorObject(reason);
        var hasStack = trace === reason;
        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
            var message = "a promise was rejected with a non-error: " + util.classString(reason);
            this._warn(message, true);
        }
        this._attachExtraTrace(trace, synchronous ? hasStack : false);
        this._reject(reason);
    };
    Promise.prototype._resolveFromExecutor = function(executor) {
        var promise = this;
        this._captureStackTrace();
        this._pushContext();
        var synchronous = true;
        var r = this._execute(executor, function(value) {
            promise._resolveCallback(value);
        }, function(reason) {
            promise._rejectCallback(reason, synchronous);
        });
        synchronous = false;
        this._popContext();
        if (r !== undefined) promise._rejectCallback(r, true);
    };
    Promise.prototype._settlePromiseFromHandler = function(handler, receiver, value, promise) {
        var bitField = promise._bitField;
        if ((bitField & 65536) !== 0) return;
        promise._pushContext();
        var x;
        if (receiver === APPLY) {
            if (!value || typeof value.length !== "number") {
                x = errorObj;
                x.e = new TypeError("cannot .spread() a non-array: " + util.classString(value));
            } else x = tryCatch(handler).apply(this._boundValue(), value);
        } else x = tryCatch(handler).call(receiver, value);
        var promiseCreated = promise._popContext();
        bitField = promise._bitField;
        if ((bitField & 65536) !== 0) return;
        if (x === NEXT_FILTER) promise._reject(value);
        else if (x === errorObj) promise._rejectCallback(x.e, false);
        else {
            debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
            promise._resolveCallback(x);
        }
    };
    Promise.prototype._target = function() {
        var ret = this;
        while(ret._isFollowing())ret = ret._followee();
        return ret;
    };
    Promise.prototype._followee = function() {
        return this._rejectionHandler0;
    };
    Promise.prototype._setFollowee = function(promise) {
        this._rejectionHandler0 = promise;
    };
    Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
        var isPromise = promise instanceof Promise;
        var bitField = this._bitField;
        var asyncGuaranteed = (bitField & 134217728) !== 0;
        if ((bitField & 65536) !== 0) {
            if (isPromise) promise._invokeInternalOnCancel();
            if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                receiver.cancelPromise = promise;
                if (tryCatch(handler).call(receiver, value) === errorObj) promise._reject(errorObj.e);
            } else if (handler === reflectHandler) promise._fulfill(reflectHandler.call(receiver));
            else if (receiver instanceof Proxyable) receiver._promiseCancelled(promise);
            else if (isPromise || promise instanceof PromiseArray) promise._cancel();
            else receiver.cancel();
        } else if (typeof handler === "function") {
            if (!isPromise) handler.call(receiver, value, promise);
            else {
                if (asyncGuaranteed) promise._setAsyncGuaranteed();
                this._settlePromiseFromHandler(handler, receiver, value, promise);
            }
        } else if (receiver instanceof Proxyable) {
            if (!receiver._isResolved()) {
                if ((bitField & 33554432) !== 0) receiver._promiseFulfilled(value, promise);
                else receiver._promiseRejected(value, promise);
            }
        } else if (isPromise) {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            if ((bitField & 33554432) !== 0) promise._fulfill(value);
            else promise._reject(value);
        }
    };
    Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
        var handler = ctx.handler;
        var promise = ctx.promise;
        var receiver = ctx.receiver;
        var value = ctx.value;
        if (typeof handler === "function") {
            if (!(promise instanceof Promise)) handler.call(receiver, value, promise);
            else this._settlePromiseFromHandler(handler, receiver, value, promise);
        } else if (promise instanceof Promise) promise._reject(value);
    };
    Promise.prototype._settlePromiseCtx = function(ctx) {
        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
    };
    Promise.prototype._settlePromise0 = function(handler, value, bitField) {
        var promise = this._promise0;
        var receiver = this._receiverAt(0);
        this._promise0 = undefined;
        this._receiver0 = undefined;
        this._settlePromise(promise, handler, receiver, value);
    };
    Promise.prototype._clearCallbackDataAtIndex = function(index) {
        var base = index * 4 - 4;
        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
    };
    Promise.prototype._fulfill = function(value) {
        var bitField = this._bitField;
        if ((bitField & 117506048) >>> 16) return;
        if (value === this) {
            var err = makeSelfResolutionError();
            this._attachExtraTrace(err);
            return this._reject(err);
        }
        this._setFulfilled();
        this._rejectionHandler0 = value;
        if ((bitField & 65535) > 0) {
            if ((bitField & 134217728) !== 0) this._settlePromises();
            else async.settlePromises(this);
        }
    };
    Promise.prototype._reject = function(reason) {
        var bitField = this._bitField;
        if ((bitField & 117506048) >>> 16) return;
        this._setRejected();
        this._fulfillmentHandler0 = reason;
        if (this._isFinal()) return async.fatalError(reason, util.isNode);
        if ((bitField & 65535) > 0) async.settlePromises(this);
        else this._ensurePossibleRejectionHandled();
    };
    Promise.prototype._fulfillPromises = function(len, value) {
        for(var i = 1; i < len; i++){
            var handler = this._fulfillmentHandlerAt(i);
            var promise = this._promiseAt(i);
            var receiver = this._receiverAt(i);
            this._clearCallbackDataAtIndex(i);
            this._settlePromise(promise, handler, receiver, value);
        }
    };
    Promise.prototype._rejectPromises = function(len, reason) {
        for(var i = 1; i < len; i++){
            var handler = this._rejectionHandlerAt(i);
            var promise = this._promiseAt(i);
            var receiver = this._receiverAt(i);
            this._clearCallbackDataAtIndex(i);
            this._settlePromise(promise, handler, receiver, reason);
        }
    };
    Promise.prototype._settlePromises = function() {
        var bitField = this._bitField;
        var len = bitField & 65535;
        if (len > 0) {
            if ((bitField & 16842752) !== 0) {
                var reason = this._fulfillmentHandler0;
                this._settlePromise0(this._rejectionHandler0, reason, bitField);
                this._rejectPromises(len, reason);
            } else {
                var value = this._rejectionHandler0;
                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                this._fulfillPromises(len, value);
            }
            this._setLength(0);
        }
        this._clearCancellationData();
    };
    Promise.prototype._settledValue = function() {
        var bitField = this._bitField;
        if ((bitField & 33554432) !== 0) return this._rejectionHandler0;
        else if ((bitField & 16777216) !== 0) return this._fulfillmentHandler0;
    };
    function deferResolve(v) {
        this.promise._resolveCallback(v);
    }
    function deferReject(v) {
        this.promise._rejectCallback(v, false);
    }
    Promise.defer = Promise.pending = function() {
        debug.deprecated("Promise.defer", "new Promise");
        var promise = new Promise(INTERNAL);
        return {
            promise: promise,
            resolve: deferResolve,
            reject: deferReject
        };
    };
    util.notEnumerableProp(Promise, "_makeSelfResolutionError", makeSelfResolutionError);
    (parcelRequire("1tSGu"))(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug);
    (parcelRequire("gMrzh"))(Promise, INTERNAL, tryConvertToPromise, debug);
    (parcelRequire("3GkZ6"))(Promise, PromiseArray, apiRejection, debug);
    (parcelRequire("bGq8S"))(Promise);
    (parcelRequire("cj9Tm"))(Promise);
    (parcelRequire("cMkgr"))(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
    Promise.Promise = Promise;
    Promise.version = "3.4.7";
    (parcelRequire("c9ZhW"))(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
    (parcelRequire("6SIZX"))(Promise);
    (parcelRequire("esLGl"))(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
    (parcelRequire("12Uxu"))(Promise, INTERNAL, debug);
    (parcelRequire("jwKcE"))(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
    (parcelRequire("5cDyD"))(Promise);
    (parcelRequire("hGrtj"))(Promise, INTERNAL);
    (parcelRequire("5pXF9"))(Promise, PromiseArray, tryConvertToPromise, apiRejection);
    (parcelRequire("kcs7Z"))(Promise, INTERNAL, tryConvertToPromise, apiRejection);
    (parcelRequire("lnjFX"))(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
    (parcelRequire("h6MiK"))(Promise, PromiseArray, debug);
    (parcelRequire("2umIb"))(Promise, PromiseArray, apiRejection);
    (parcelRequire("kTmEu"))(Promise, INTERNAL);
    (parcelRequire("c3h5Z"))(Promise, INTERNAL);
    (parcelRequire("jesev"))(Promise);
    util.toFastProperties(Promise);
    util.toFastProperties(Promise.prototype);
    function fillTypes(value) {
        var p = new Promise(INTERNAL);
        p._fulfillmentHandler0 = value;
        p._rejectionHandler0 = value;
        p._promise0 = value;
        p._receiver0 = value;
    }
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({
        a: 1
    });
    fillTypes({
        b: 2
    });
    fillTypes({
        c: 3
    });
    fillTypes(1);
    fillTypes(function() {});
    fillTypes(undefined);
    fillTypes(false);
    fillTypes(new Promise(INTERNAL));
    debug.setBounds(Async.firstLineError, util.lastLineError);
    return Promise;
};

});
parcelRegister("jBmpJ", function(module, exports) {
// shim for using process in browser
var $e452dbfd2d820d88$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e452dbfd2d820d88$var$cachedSetTimeout;
var $e452dbfd2d820d88$var$cachedClearTimeout;
function $e452dbfd2d820d88$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $e452dbfd2d820d88$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $e452dbfd2d820d88$var$cachedSetTimeout = setTimeout;
        else $e452dbfd2d820d88$var$cachedSetTimeout = $e452dbfd2d820d88$var$defaultSetTimout;
    } catch (e) {
        $e452dbfd2d820d88$var$cachedSetTimeout = $e452dbfd2d820d88$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $e452dbfd2d820d88$var$cachedClearTimeout = clearTimeout;
        else $e452dbfd2d820d88$var$cachedClearTimeout = $e452dbfd2d820d88$var$defaultClearTimeout;
    } catch (e) {
        $e452dbfd2d820d88$var$cachedClearTimeout = $e452dbfd2d820d88$var$defaultClearTimeout;
    }
})();
function $e452dbfd2d820d88$var$runTimeout(fun) {
    if ($e452dbfd2d820d88$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e452dbfd2d820d88$var$cachedSetTimeout === $e452dbfd2d820d88$var$defaultSetTimout || !$e452dbfd2d820d88$var$cachedSetTimeout) && setTimeout) {
        $e452dbfd2d820d88$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e452dbfd2d820d88$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e452dbfd2d820d88$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e452dbfd2d820d88$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e452dbfd2d820d88$var$runClearTimeout(marker) {
    if ($e452dbfd2d820d88$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e452dbfd2d820d88$var$cachedClearTimeout === $e452dbfd2d820d88$var$defaultClearTimeout || !$e452dbfd2d820d88$var$cachedClearTimeout) && clearTimeout) {
        $e452dbfd2d820d88$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e452dbfd2d820d88$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e452dbfd2d820d88$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e452dbfd2d820d88$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e452dbfd2d820d88$var$queue = [];
var $e452dbfd2d820d88$var$draining = false;
var $e452dbfd2d820d88$var$currentQueue;
var $e452dbfd2d820d88$var$queueIndex = -1;
function $e452dbfd2d820d88$var$cleanUpNextTick() {
    if (!$e452dbfd2d820d88$var$draining || !$e452dbfd2d820d88$var$currentQueue) return;
    $e452dbfd2d820d88$var$draining = false;
    if ($e452dbfd2d820d88$var$currentQueue.length) $e452dbfd2d820d88$var$queue = $e452dbfd2d820d88$var$currentQueue.concat($e452dbfd2d820d88$var$queue);
    else $e452dbfd2d820d88$var$queueIndex = -1;
    if ($e452dbfd2d820d88$var$queue.length) $e452dbfd2d820d88$var$drainQueue();
}
function $e452dbfd2d820d88$var$drainQueue() {
    if ($e452dbfd2d820d88$var$draining) return;
    var timeout = $e452dbfd2d820d88$var$runTimeout($e452dbfd2d820d88$var$cleanUpNextTick);
    $e452dbfd2d820d88$var$draining = true;
    var len = $e452dbfd2d820d88$var$queue.length;
    while(len){
        $e452dbfd2d820d88$var$currentQueue = $e452dbfd2d820d88$var$queue;
        $e452dbfd2d820d88$var$queue = [];
        while(++$e452dbfd2d820d88$var$queueIndex < len)if ($e452dbfd2d820d88$var$currentQueue) $e452dbfd2d820d88$var$currentQueue[$e452dbfd2d820d88$var$queueIndex].run();
        $e452dbfd2d820d88$var$queueIndex = -1;
        len = $e452dbfd2d820d88$var$queue.length;
    }
    $e452dbfd2d820d88$var$currentQueue = null;
    $e452dbfd2d820d88$var$draining = false;
    $e452dbfd2d820d88$var$runClearTimeout(timeout);
}
$e452dbfd2d820d88$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e452dbfd2d820d88$var$queue.push(new $e452dbfd2d820d88$var$Item(fun, args));
    if ($e452dbfd2d820d88$var$queue.length === 1 && !$e452dbfd2d820d88$var$draining) $e452dbfd2d820d88$var$runTimeout($e452dbfd2d820d88$var$drainQueue);
};
// v8 likes predictible objects
function $e452dbfd2d820d88$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e452dbfd2d820d88$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e452dbfd2d820d88$var$process.title = 'browser';
$e452dbfd2d820d88$var$process.browser = true;
$e452dbfd2d820d88$var$process.env = {};
$e452dbfd2d820d88$var$process.argv = [];
$e452dbfd2d820d88$var$process.version = ''; // empty string to avoid regexp issues
$e452dbfd2d820d88$var$process.versions = {};
function $e452dbfd2d820d88$var$noop() {}
$e452dbfd2d820d88$var$process.on = $e452dbfd2d820d88$var$noop;
$e452dbfd2d820d88$var$process.addListener = $e452dbfd2d820d88$var$noop;
$e452dbfd2d820d88$var$process.once = $e452dbfd2d820d88$var$noop;
$e452dbfd2d820d88$var$process.off = $e452dbfd2d820d88$var$noop;
$e452dbfd2d820d88$var$process.removeListener = $e452dbfd2d820d88$var$noop;
$e452dbfd2d820d88$var$process.removeAllListeners = $e452dbfd2d820d88$var$noop;
$e452dbfd2d820d88$var$process.emit = $e452dbfd2d820d88$var$noop;
$e452dbfd2d820d88$var$process.prependListener = $e452dbfd2d820d88$var$noop;
$e452dbfd2d820d88$var$process.prependOnceListener = $e452dbfd2d820d88$var$noop;
$e452dbfd2d820d88$var$process.listeners = function(name) {
    return [];
};
$e452dbfd2d820d88$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$e452dbfd2d820d88$var$process.cwd = function() {
    return '/';
};
$e452dbfd2d820d88$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$e452dbfd2d820d88$var$process.umask = function() {
    return 0;
};

});

parcelRegister("gwhLZ", function(module, exports) {

var $jBmpJ = parcelRequire("jBmpJ");
"use strict";

var $4Ys6H = parcelRequire("4Ys6H");
var $c06d6bda72f24959$var$canEvaluate = typeof navigator == "undefined";
var $c06d6bda72f24959$var$errorObj = {
    e: {}
};
var $c06d6bda72f24959$var$tryCatchTarget;
var $c06d6bda72f24959$var$globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : module.exports !== undefined ? module.exports : null;
function $c06d6bda72f24959$var$tryCatcher() {
    try {
        var target = $c06d6bda72f24959$var$tryCatchTarget;
        $c06d6bda72f24959$var$tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        $c06d6bda72f24959$var$errorObj.e = e;
        return $c06d6bda72f24959$var$errorObj;
    }
}
function $c06d6bda72f24959$var$tryCatch(fn) {
    $c06d6bda72f24959$var$tryCatchTarget = fn;
    return $c06d6bda72f24959$var$tryCatcher;
}
var $c06d6bda72f24959$var$inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;
    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for(var propertyName in Parent.prototype)if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") this[propertyName + "$"] = Parent.prototype[propertyName];
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};
function $c06d6bda72f24959$var$isPrimitive(val) {
    return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
}
function $c06d6bda72f24959$var$isObject(value) {
    return typeof value === "function" || typeof value === "object" && value !== null;
}
function $c06d6bda72f24959$var$maybeWrapAsError(maybeError) {
    if (!$c06d6bda72f24959$var$isPrimitive(maybeError)) return maybeError;
    return new Error($c06d6bda72f24959$var$safeToString(maybeError));
}
function $c06d6bda72f24959$var$withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for(i = 0; i < len; ++i)ret[i] = target[i];
    ret[i] = appendee;
    return ret;
}
function $c06d6bda72f24959$var$getDataPropertyOrDefault(obj, key, defaultValue) {
    if ($4Ys6H.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);
        if (desc != null) return desc.get == null && desc.set == null ? desc.value : defaultValue;
    } else return ({}).hasOwnProperty.call(obj, key) ? obj[key] : undefined;
}
function $c06d6bda72f24959$var$notEnumerableProp(obj, name, value) {
    if ($c06d6bda72f24959$var$isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    $4Ys6H.defineProperty(obj, name, descriptor);
    return obj;
}
function $c06d6bda72f24959$var$thrower(r) {
    throw r;
}
var $c06d6bda72f24959$var$inheritedDataKeys = function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];
    var isExcludedProto = function(val) {
        for(var i = 0; i < excludedPrototypes.length; ++i){
            if (excludedPrototypes[i] === val) return true;
        }
        return false;
    };
    if ($4Ys6H.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while(obj != null && !isExcludedProto(obj)){
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for(var i = 0; i < keys.length; ++i){
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) ret.push(key);
                }
                obj = $4Ys6H.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];
            /*jshint forin:false */ enumeration: for(var key in obj)if (hasProp.call(obj, key)) ret.push(key);
            else {
                for(var i = 0; i < excludedPrototypes.length; ++i){
                    if (hasProp.call(excludedPrototypes[i], key)) continue enumeration;
                }
                ret.push(key);
            }
            return ret;
        };
    }
}();
var $c06d6bda72f24959$var$thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function $c06d6bda72f24959$var$isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = $4Ys6H.names(fn.prototype);
            var hasMethods = $4Ys6H.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods = $c06d6bda72f24959$var$thisAssignmentPattern.test(fn + "") && $4Ys6H.names(fn).length > 0;
            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) return true;
        }
        return false;
    } catch (e) {
        return false;
    }
}
function $c06d6bda72f24959$var$toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/ function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var l = 8;
    while(l--)new FakeConstructor();
    return obj;
}
var $c06d6bda72f24959$var$rident = /^[a-z$_][a-z$_0-9]*$/i;
function $c06d6bda72f24959$var$isIdentifier(str) {
    return $c06d6bda72f24959$var$rident.test(str);
}
function $c06d6bda72f24959$var$filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i)ret[i] = prefix + i + suffix;
    return ret;
}
function $c06d6bda72f24959$var$safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}
function $c06d6bda72f24959$var$isError(obj) {
    return obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
}
function $c06d6bda72f24959$var$markAsOriginatingFromRejection(e) {
    try {
        $c06d6bda72f24959$var$notEnumerableProp(e, "isOperational", true);
    } catch (ignore) {}
}
function $c06d6bda72f24959$var$originatesFromRejection(e) {
    if (e == null) return false;
    return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
}
function $c06d6bda72f24959$var$canAttachTrace(obj) {
    return $c06d6bda72f24959$var$isError(obj) && $4Ys6H.propertyIsWritable(obj, "stack");
}
var $c06d6bda72f24959$var$ensureErrorObject = function() {
    if (!("stack" in new Error())) return function(value) {
        if ($c06d6bda72f24959$var$canAttachTrace(value)) return value;
        try {
            throw new Error($c06d6bda72f24959$var$safeToString(value));
        } catch (err) {
            return err;
        }
    };
    else return function(value) {
        if ($c06d6bda72f24959$var$canAttachTrace(value)) return value;
        return new Error($c06d6bda72f24959$var$safeToString(value));
    };
}();
function $c06d6bda72f24959$var$classString(obj) {
    return ({}).toString.call(obj);
}
function $c06d6bda72f24959$var$copyDescriptors(from, to, filter) {
    var keys = $4Ys6H.names(from);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        if (filter(key)) try {
            $4Ys6H.defineProperty(to, key, $4Ys6H.getDescriptor(from, key));
        } catch (ignore) {}
    }
}
var $c06d6bda72f24959$var$asArray = function(v) {
    if ($4Ys6H.isArray(v)) return v;
    return null;
};
if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var $c06d6bda72f24959$var$ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while(!(itResult = it.next()).done)ret.push(itResult.value);
        return ret;
    };
    $c06d6bda72f24959$var$asArray = function(v) {
        if ($4Ys6H.isArray(v)) return v;
        else if (v != null && typeof v[Symbol.iterator] === "function") return $c06d6bda72f24959$var$ArrayFrom(v);
        return null;
    };
}
var $c06d6bda72f24959$var$isNode = false;
var $c06d6bda72f24959$var$hasEnvVariables = false;
function $c06d6bda72f24959$var$env(key) {
    return $c06d6bda72f24959$var$hasEnvVariables ? $jBmpJ.env[key] : undefined;
}
function $c06d6bda72f24959$var$getNativePromise() {
    if (typeof Promise === "function") try {
        var promise = new Promise(function() {});
        if (({}).toString.call(promise) === "[object Promise]") return Promise;
    } catch (e) {}
}
function $c06d6bda72f24959$var$domainBind(self1, cb) {
    return self1.bind(cb);
}
var $c06d6bda72f24959$var$ret = {
    isClass: $c06d6bda72f24959$var$isClass,
    isIdentifier: $c06d6bda72f24959$var$isIdentifier,
    inheritedDataKeys: $c06d6bda72f24959$var$inheritedDataKeys,
    getDataPropertyOrDefault: $c06d6bda72f24959$var$getDataPropertyOrDefault,
    thrower: $c06d6bda72f24959$var$thrower,
    isArray: $4Ys6H.isArray,
    asArray: $c06d6bda72f24959$var$asArray,
    notEnumerableProp: $c06d6bda72f24959$var$notEnumerableProp,
    isPrimitive: $c06d6bda72f24959$var$isPrimitive,
    isObject: $c06d6bda72f24959$var$isObject,
    isError: $c06d6bda72f24959$var$isError,
    canEvaluate: $c06d6bda72f24959$var$canEvaluate,
    errorObj: $c06d6bda72f24959$var$errorObj,
    tryCatch: $c06d6bda72f24959$var$tryCatch,
    inherits: $c06d6bda72f24959$var$inherits,
    withAppended: $c06d6bda72f24959$var$withAppended,
    maybeWrapAsError: $c06d6bda72f24959$var$maybeWrapAsError,
    toFastProperties: $c06d6bda72f24959$var$toFastProperties,
    filledRange: $c06d6bda72f24959$var$filledRange,
    toString: $c06d6bda72f24959$var$safeToString,
    canAttachTrace: $c06d6bda72f24959$var$canAttachTrace,
    ensureErrorObject: $c06d6bda72f24959$var$ensureErrorObject,
    originatesFromRejection: $c06d6bda72f24959$var$originatesFromRejection,
    markAsOriginatingFromRejection: $c06d6bda72f24959$var$markAsOriginatingFromRejection,
    classString: $c06d6bda72f24959$var$classString,
    copyDescriptors: $c06d6bda72f24959$var$copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome && typeof chrome.loadTimes === "function",
    isNode: $c06d6bda72f24959$var$isNode,
    hasEnvVariables: $c06d6bda72f24959$var$hasEnvVariables,
    env: $c06d6bda72f24959$var$env,
    global: $c06d6bda72f24959$var$globalObject,
    getNativePromise: $c06d6bda72f24959$var$getNativePromise,
    domainBind: $c06d6bda72f24959$var$domainBind
};
$c06d6bda72f24959$var$ret.isRecentNode = $c06d6bda72f24959$var$ret.isNode && function() {
    var version = $jBmpJ.versions.node.split(".").map(Number);
    return version[0] === 0 && version[1] > 10 || version[0] > 0;
}();
if ($c06d6bda72f24959$var$ret.isNode) $c06d6bda72f24959$var$ret.toFastProperties($jBmpJ);
try {
    throw new Error();
} catch (e) {
    $c06d6bda72f24959$var$ret.lastLineError = e;
}
module.exports = $c06d6bda72f24959$var$ret;

});
parcelRegister("4Ys6H", function(module, exports) {
var $39f2918135f24e59$var$isES5 = function() {
    "use strict";
    return this === undefined;
}();
if ($39f2918135f24e59$var$isES5) module.exports = {
    freeze: Object.freeze,
    defineProperty: Object.defineProperty,
    getDescriptor: Object.getOwnPropertyDescriptor,
    keys: Object.keys,
    names: Object.getOwnPropertyNames,
    getPrototypeOf: Object.getPrototypeOf,
    isArray: Array.isArray,
    isES5: $39f2918135f24e59$var$isES5,
    propertyIsWritable: function(obj, prop) {
        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!(!descriptor || descriptor.writable || descriptor.set);
    }
};
else {
    var $39f2918135f24e59$var$has = {}.hasOwnProperty;
    var $39f2918135f24e59$var$str = {}.toString;
    var $39f2918135f24e59$var$proto = {}.constructor.prototype;
    var $39f2918135f24e59$var$ObjectKeys = function(o) {
        var ret = [];
        for(var key in o)if ($39f2918135f24e59$var$has.call(o, key)) ret.push(key);
        return ret;
    };
    var $39f2918135f24e59$var$ObjectGetDescriptor = function(o, key) {
        return {
            value: o[key]
        };
    };
    var $39f2918135f24e59$var$ObjectDefineProperty = function(o, key, desc) {
        o[key] = desc.value;
        return o;
    };
    var $39f2918135f24e59$var$ObjectFreeze = function(obj) {
        return obj;
    };
    var $39f2918135f24e59$var$ObjectGetPrototypeOf = function(obj) {
        try {
            return Object(obj).constructor.prototype;
        } catch (e) {
            return $39f2918135f24e59$var$proto;
        }
    };
    var $39f2918135f24e59$var$ArrayIsArray = function(obj) {
        try {
            return $39f2918135f24e59$var$str.call(obj) === "[object Array]";
        } catch (e) {
            return false;
        }
    };
    module.exports = {
        isArray: $39f2918135f24e59$var$ArrayIsArray,
        keys: $39f2918135f24e59$var$ObjectKeys,
        names: $39f2918135f24e59$var$ObjectKeys,
        defineProperty: $39f2918135f24e59$var$ObjectDefineProperty,
        getDescriptor: $39f2918135f24e59$var$ObjectGetDescriptor,
        freeze: $39f2918135f24e59$var$ObjectFreeze,
        getPrototypeOf: $39f2918135f24e59$var$ObjectGetPrototypeOf,
        isES5: $39f2918135f24e59$var$isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

});


parcelRegister("l8ya4", function(module, exports) {

var $jBmpJ = parcelRequire("jBmpJ");
"use strict";
var $f634d814d14ce079$var$firstLineError;
try {
    throw new Error();
} catch (e) {
    $f634d814d14ce079$var$firstLineError = e;
}

var $aIMp9 = parcelRequire("aIMp9");

var $80jOE = parcelRequire("80jOE");

var $gwhLZ = parcelRequire("gwhLZ");
function $f634d814d14ce079$var$Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new $80jOE(16);
    this._normalQueue = new $80jOE(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function() {
        self._drainQueues();
    };
    this._schedule = $aIMp9;
}
$f634d814d14ce079$var$Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};
$f634d814d14ce079$var$Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};
$f634d814d14ce079$var$Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};
$f634d814d14ce079$var$Async.prototype.disableTrampolineIfNecessary = function() {
    if ($gwhLZ.hasDevTools) this._trampolineEnabled = false;
};
$f634d814d14ce079$var$Async.prototype.haveItemsQueued = function() {
    return this._isTickUsed || this._haveDrainedQueues;
};
$f634d814d14ce079$var$Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        $jBmpJ.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
        $jBmpJ.exit(2);
    } else this.throwLater(e);
};
$f634d814d14ce079$var$Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function() {
            throw arg;
        };
    }
    if (typeof setTimeout !== "undefined") setTimeout(function() {
        fn(arg);
    }, 0);
    else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};
function $f634d814d14ce079$var$AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}
function $f634d814d14ce079$var$AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}
function $f634d814d14ce079$var$AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}
if (!$gwhLZ.hasDevTools) {
    $f634d814d14ce079$var$Async.prototype.invokeLater = $f634d814d14ce079$var$AsyncInvokeLater;
    $f634d814d14ce079$var$Async.prototype.invoke = $f634d814d14ce079$var$AsyncInvoke;
    $f634d814d14ce079$var$Async.prototype.settlePromises = $f634d814d14ce079$var$AsyncSettlePromises;
} else {
    $f634d814d14ce079$var$Async.prototype.invokeLater = function(fn, receiver, arg) {
        if (this._trampolineEnabled) $f634d814d14ce079$var$AsyncInvokeLater.call(this, fn, receiver, arg);
        else this._schedule(function() {
            setTimeout(function() {
                fn.call(receiver, arg);
            }, 100);
        });
    };
    $f634d814d14ce079$var$Async.prototype.invoke = function(fn, receiver, arg) {
        if (this._trampolineEnabled) $f634d814d14ce079$var$AsyncInvoke.call(this, fn, receiver, arg);
        else this._schedule(function() {
            fn.call(receiver, arg);
        });
    };
    $f634d814d14ce079$var$Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) $f634d814d14ce079$var$AsyncSettlePromises.call(this, promise);
        else this._schedule(function() {
            promise._settlePromises();
        });
    };
}
$f634d814d14ce079$var$Async.prototype._drainQueue = function(queue) {
    while(queue.length() > 0){
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};
$f634d814d14ce079$var$Async.prototype._drainQueues = function() {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    this._drainQueue(this._lateQueue);
};
$f634d814d14ce079$var$Async.prototype._queueTick = function() {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};
$f634d814d14ce079$var$Async.prototype._reset = function() {
    this._isTickUsed = false;
};
module.exports = $f634d814d14ce079$var$Async;
module.exports.firstLineError = $f634d814d14ce079$var$firstLineError;

});
parcelRegister("aIMp9", function(module, exports) {

var $jBmpJ = parcelRequire("jBmpJ");
"use strict";

var $gwhLZ = parcelRequire("gwhLZ");
var $0203ab9b38b00d16$var$schedule;
var $0203ab9b38b00d16$var$noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var $0203ab9b38b00d16$var$NativePromise = $gwhLZ.getNativePromise();
if ($gwhLZ.isNode && typeof MutationObserver === "undefined") {
    var $0203ab9b38b00d16$var$GlobalSetImmediate = $parcel$global.setImmediate;
    var $0203ab9b38b00d16$var$ProcessNextTick = $jBmpJ.nextTick;
    $0203ab9b38b00d16$var$schedule = $gwhLZ.isRecentNode ? function(fn) {
        $0203ab9b38b00d16$var$GlobalSetImmediate.call($parcel$global, fn);
    } : function(fn) {
        $0203ab9b38b00d16$var$ProcessNextTick.call($jBmpJ, fn);
    };
} else if (typeof $0203ab9b38b00d16$var$NativePromise === "function" && typeof $0203ab9b38b00d16$var$NativePromise.resolve === "function") {
    var $0203ab9b38b00d16$var$nativePromise = $0203ab9b38b00d16$var$NativePromise.resolve();
    $0203ab9b38b00d16$var$schedule = function(fn) {
        $0203ab9b38b00d16$var$nativePromise.then(fn);
    };
} else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova))) $0203ab9b38b00d16$var$schedule = function() {
    var div = document.createElement("div");
    var opts = {
        attributes: true
    };
    var toggleScheduled = false;
    var div2 = document.createElement("div");
    var o2 = new MutationObserver(function() {
        div.classList.toggle("foo");
        toggleScheduled = false;
    });
    o2.observe(div2, opts);
    var scheduleToggle = function() {
        if (toggleScheduled) return;
        toggleScheduled = true;
        div2.classList.toggle("foo");
    };
    return function schedule(fn) {
        var o = new MutationObserver(function() {
            o.disconnect();
            fn();
        });
        o.observe(div, opts);
        scheduleToggle();
    };
}();
else if (typeof setImmediate !== "undefined") $0203ab9b38b00d16$var$schedule = function(fn) {
    setImmediate(fn);
};
else if (typeof setTimeout !== "undefined") $0203ab9b38b00d16$var$schedule = function(fn) {
    setTimeout(fn, 0);
};
else $0203ab9b38b00d16$var$schedule = $0203ab9b38b00d16$var$noAsyncScheduler;
module.exports = $0203ab9b38b00d16$var$schedule;

});

parcelRegister("80jOE", function(module, exports) {
"use strict";
function $5d3db1e03201628c$var$arrayMove(src, srcIndex, dst, dstIndex, len) {
    for(var j = 0; j < len; ++j){
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}
function $5d3db1e03201628c$var$Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}
$5d3db1e03201628c$var$Queue.prototype._willBeOverCapacity = function(size) {
    return this._capacity < size;
};
$5d3db1e03201628c$var$Queue.prototype._pushOne = function(arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = this._front + length & this._capacity - 1;
    this[i] = arg;
    this._length = length + 1;
};
$5d3db1e03201628c$var$Queue.prototype.push = function(fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[j + 0 & wrapMask] = fn;
    this[j + 1 & wrapMask] = receiver;
    this[j + 2 & wrapMask] = arg;
    this._length = length;
};
$5d3db1e03201628c$var$Queue.prototype.shift = function() {
    var front = this._front, ret = this[front];
    this[front] = undefined;
    this._front = front + 1 & this._capacity - 1;
    this._length--;
    return ret;
};
$5d3db1e03201628c$var$Queue.prototype.length = function() {
    return this._length;
};
$5d3db1e03201628c$var$Queue.prototype._checkCapacity = function(size) {
    if (this._capacity < size) this._resizeTo(this._capacity << 1);
};
$5d3db1e03201628c$var$Queue.prototype._resizeTo = function(capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = front + length & oldCapacity - 1;
    $5d3db1e03201628c$var$arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};
module.exports = $5d3db1e03201628c$var$Queue;

});


parcelRegister("8iBp5", function(module, exports) {
"use strict";

var $4Ys6H = parcelRequire("4Ys6H");
var $60ad04b9cf82f9b7$var$Objectfreeze = $4Ys6H.freeze;

var $gwhLZ = parcelRequire("gwhLZ");
var $60ad04b9cf82f9b7$var$inherits = $gwhLZ.inherits;
var $60ad04b9cf82f9b7$var$notEnumerableProp = $gwhLZ.notEnumerableProp;
function $60ad04b9cf82f9b7$var$subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        $60ad04b9cf82f9b7$var$notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
        $60ad04b9cf82f9b7$var$notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
        else Error.call(this);
    }
    $60ad04b9cf82f9b7$var$inherits(SubError, Error);
    return SubError;
}
var $60ad04b9cf82f9b7$var$_TypeError, $60ad04b9cf82f9b7$var$_RangeError;
var $60ad04b9cf82f9b7$var$Warning = $60ad04b9cf82f9b7$var$subError("Warning", "warning");
var $60ad04b9cf82f9b7$var$CancellationError = $60ad04b9cf82f9b7$var$subError("CancellationError", "cancellation error");
var $60ad04b9cf82f9b7$var$TimeoutError = $60ad04b9cf82f9b7$var$subError("TimeoutError", "timeout error");
var $60ad04b9cf82f9b7$var$AggregateError = $60ad04b9cf82f9b7$var$subError("AggregateError", "aggregate error");
try {
    $60ad04b9cf82f9b7$var$_TypeError = TypeError;
    $60ad04b9cf82f9b7$var$_RangeError = RangeError;
} catch (e) {
    $60ad04b9cf82f9b7$var$_TypeError = $60ad04b9cf82f9b7$var$subError("TypeError", "type error");
    $60ad04b9cf82f9b7$var$_RangeError = $60ad04b9cf82f9b7$var$subError("RangeError", "range error");
}
var $60ad04b9cf82f9b7$var$methods = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" ");
for(var $60ad04b9cf82f9b7$var$i = 0; $60ad04b9cf82f9b7$var$i < $60ad04b9cf82f9b7$var$methods.length; ++$60ad04b9cf82f9b7$var$i)if (typeof Array.prototype[$60ad04b9cf82f9b7$var$methods[$60ad04b9cf82f9b7$var$i]] === "function") $60ad04b9cf82f9b7$var$AggregateError.prototype[$60ad04b9cf82f9b7$var$methods[$60ad04b9cf82f9b7$var$i]] = Array.prototype[$60ad04b9cf82f9b7$var$methods[$60ad04b9cf82f9b7$var$i]];
$4Ys6H.defineProperty($60ad04b9cf82f9b7$var$AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
$60ad04b9cf82f9b7$var$AggregateError.prototype["isOperational"] = true;
var $60ad04b9cf82f9b7$var$level = 0;
$60ad04b9cf82f9b7$var$AggregateError.prototype.toString = function() {
    var indent = Array($60ad04b9cf82f9b7$var$level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    $60ad04b9cf82f9b7$var$level++;
    indent = Array($60ad04b9cf82f9b7$var$level * 4 + 1).join(" ");
    for(var i = 0; i < this.length; ++i){
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for(var j = 0; j < lines.length; ++j)lines[j] = indent + lines[j];
        str = lines.join("\n");
        ret += str + "\n";
    }
    $60ad04b9cf82f9b7$var$level--;
    return ret;
};
function $60ad04b9cf82f9b7$var$OperationalError(message) {
    if (!(this instanceof $60ad04b9cf82f9b7$var$OperationalError)) return new $60ad04b9cf82f9b7$var$OperationalError(message);
    $60ad04b9cf82f9b7$var$notEnumerableProp(this, "name", "OperationalError");
    $60ad04b9cf82f9b7$var$notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;
    if (message instanceof Error) {
        $60ad04b9cf82f9b7$var$notEnumerableProp(this, "message", message.message);
        $60ad04b9cf82f9b7$var$notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
}
$60ad04b9cf82f9b7$var$inherits($60ad04b9cf82f9b7$var$OperationalError, Error);
var $60ad04b9cf82f9b7$var$errorTypes = Error["__BluebirdErrorTypes__"];
if (!$60ad04b9cf82f9b7$var$errorTypes) {
    $60ad04b9cf82f9b7$var$errorTypes = $60ad04b9cf82f9b7$var$Objectfreeze({
        CancellationError: $60ad04b9cf82f9b7$var$CancellationError,
        TimeoutError: $60ad04b9cf82f9b7$var$TimeoutError,
        OperationalError: $60ad04b9cf82f9b7$var$OperationalError,
        RejectionError: $60ad04b9cf82f9b7$var$OperationalError,
        AggregateError: $60ad04b9cf82f9b7$var$AggregateError
    });
    $4Ys6H.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: $60ad04b9cf82f9b7$var$errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}
module.exports = {
    Error: Error,
    TypeError: $60ad04b9cf82f9b7$var$_TypeError,
    RangeError: $60ad04b9cf82f9b7$var$_RangeError,
    CancellationError: $60ad04b9cf82f9b7$var$errorTypes.CancellationError,
    OperationalError: $60ad04b9cf82f9b7$var$errorTypes.OperationalError,
    TimeoutError: $60ad04b9cf82f9b7$var$errorTypes.TimeoutError,
    AggregateError: $60ad04b9cf82f9b7$var$errorTypes.AggregateError,
    Warning: $60ad04b9cf82f9b7$var$Warning
};

});

parcelRegister("hidIl", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL) {
    var util = (parcelRequire("gwhLZ"));
    var errorObj = util.errorObj;
    var isObject = util.isObject;
    function tryConvertToPromise(obj, context) {
        if (isObject(obj)) {
            if (obj instanceof Promise) return obj;
            var then = getThen(obj);
            if (then === errorObj) {
                if (context) context._pushContext();
                var ret = Promise.reject(then.e);
                if (context) context._popContext();
                return ret;
            } else if (typeof then === "function") {
                if (isAnyBluebirdPromise(obj)) {
                    var ret = new Promise(INTERNAL);
                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);
                    return ret;
                }
                return doThenable(obj, then, context);
            }
        }
        return obj;
    }
    function doGetThen(obj) {
        return obj.then;
    }
    function getThen(obj) {
        try {
            return doGetThen(obj);
        } catch (e) {
            errorObj.e = e;
            return errorObj;
        }
    }
    var hasProp = {}.hasOwnProperty;
    function isAnyBluebirdPromise(obj) {
        try {
            return hasProp.call(obj, "_promise0");
        } catch (e) {
            return false;
        }
    }
    function doThenable(x, then, context) {
        var promise = new Promise(INTERNAL);
        var ret = promise;
        if (context) context._pushContext();
        promise._captureStackTrace();
        if (context) context._popContext();
        var synchronous = true;
        var result = util.tryCatch(then).call(x, resolve, reject);
        synchronous = false;
        if (promise && result === errorObj) {
            promise._rejectCallback(result.e, true, true);
            promise = null;
        }
        function resolve(value) {
            if (!promise) return;
            promise._resolveCallback(value);
            promise = null;
        }
        function reject(reason) {
            if (!promise) return;
            promise._rejectCallback(reason, synchronous, true);
            promise = null;
        }
        return ret;
    }
    return tryConvertToPromise;
};

});

parcelRegister("dXJVZ", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
    var util = (parcelRequire("gwhLZ"));
    var isArray = util.isArray;
    function toResolutionValue(val) {
        switch(val){
            case -2:
                return [];
            case -3:
                return {};
        }
    }
    function PromiseArray(values) {
        var promise = this._promise = new Promise(INTERNAL);
        if (values instanceof Promise) promise._propagateFrom(values, 3);
        promise._setOnCancel(this);
        this._values = values;
        this._length = 0;
        this._totalResolved = 0;
        this._init(undefined, -2);
    }
    util.inherits(PromiseArray, Proxyable);
    PromiseArray.prototype.length = function() {
        return this._length;
    };
    PromiseArray.prototype.promise = function() {
        return this._promise;
    };
    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
        var values = tryConvertToPromise(this._values, this._promise);
        if (values instanceof Promise) {
            values = values._target();
            var bitField = values._bitField;
            this._values = values;
            if ((bitField & 50397184) === 0) {
                this._promise._setAsyncGuaranteed();
                return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
            } else if ((bitField & 33554432) !== 0) values = values._value();
            else if ((bitField & 16777216) !== 0) return this._reject(values._reason());
            else return this._cancel();
        }
        values = util.asArray(values);
        if (values === null) {
            var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
            this._promise._rejectCallback(err, false);
            return;
        }
        if (values.length === 0) {
            if (resolveValueIfEmpty === -5) this._resolveEmptyArray();
            else this._resolve(toResolutionValue(resolveValueIfEmpty));
            return;
        }
        this._iterate(values);
    };
    PromiseArray.prototype._iterate = function(values) {
        var len = this.getActualLength(values.length);
        this._length = len;
        this._values = this.shouldCopyValues() ? new Array(len) : this._values;
        var result = this._promise;
        var isResolved = false;
        var bitField = null;
        for(var i = 0; i < len; ++i){
            var maybePromise = tryConvertToPromise(values[i], result);
            if (maybePromise instanceof Promise) {
                maybePromise = maybePromise._target();
                bitField = maybePromise._bitField;
            } else bitField = null;
            if (isResolved) {
                if (bitField !== null) maybePromise.suppressUnhandledRejections();
            } else if (bitField !== null) {
                if ((bitField & 50397184) === 0) {
                    maybePromise._proxy(this, i);
                    this._values[i] = maybePromise;
                } else if ((bitField & 33554432) !== 0) isResolved = this._promiseFulfilled(maybePromise._value(), i);
                else if ((bitField & 16777216) !== 0) isResolved = this._promiseRejected(maybePromise._reason(), i);
                else isResolved = this._promiseCancelled(i);
            } else isResolved = this._promiseFulfilled(maybePromise, i);
        }
        if (!isResolved) result._setAsyncGuaranteed();
    };
    PromiseArray.prototype._isResolved = function() {
        return this._values === null;
    };
    PromiseArray.prototype._resolve = function(value) {
        this._values = null;
        this._promise._fulfill(value);
    };
    PromiseArray.prototype._cancel = function() {
        if (this._isResolved() || !this._promise._isCancellable()) return;
        this._values = null;
        this._promise._cancel();
    };
    PromiseArray.prototype._reject = function(reason) {
        this._values = null;
        this._promise._rejectCallback(reason, false);
    };
    PromiseArray.prototype._promiseFulfilled = function(value, index) {
        this._values[index] = value;
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= this._length) {
            this._resolve(this._values);
            return true;
        }
        return false;
    };
    PromiseArray.prototype._promiseCancelled = function() {
        this._cancel();
        return true;
    };
    PromiseArray.prototype._promiseRejected = function(reason) {
        this._totalResolved++;
        this._reject(reason);
        return true;
    };
    PromiseArray.prototype._resultCancelled = function() {
        if (this._isResolved()) return;
        var values = this._values;
        this._cancel();
        if (values instanceof Promise) values.cancel();
        else {
            for(var i = 0; i < values.length; ++i)if (values[i] instanceof Promise) values[i].cancel();
        }
    };
    PromiseArray.prototype.shouldCopyValues = function() {
        return true;
    };
    PromiseArray.prototype.getActualLength = function(len) {
        return len;
    };
    return PromiseArray;
};

});

parcelRegister("bZvzT", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    var longStackTraces = false;
    var contextStack = [];
    Promise.prototype._promiseCreated = function() {};
    Promise.prototype._pushContext = function() {};
    Promise.prototype._popContext = function() {
        return null;
    };
    Promise._peekContext = Promise.prototype._peekContext = function() {};
    function Context() {
        this._trace = new Context.CapturedTrace(peekContext());
    }
    Context.prototype._pushContext = function() {
        if (this._trace !== undefined) {
            this._trace._promiseCreated = null;
            contextStack.push(this._trace);
        }
    };
    Context.prototype._popContext = function() {
        if (this._trace !== undefined) {
            var trace = contextStack.pop();
            var ret = trace._promiseCreated;
            trace._promiseCreated = null;
            return ret;
        }
        return null;
    };
    function createContext() {
        if (longStackTraces) return new Context();
    }
    function peekContext() {
        var lastIndex = contextStack.length - 1;
        if (lastIndex >= 0) return contextStack[lastIndex];
        return undefined;
    }
    Context.CapturedTrace = null;
    Context.create = createContext;
    Context.deactivateLongStackTraces = function() {};
    Context.activateLongStackTraces = function() {
        var Promise_pushContext = Promise.prototype._pushContext;
        var Promise_popContext = Promise.prototype._popContext;
        var Promise_PeekContext = Promise._peekContext;
        var Promise_peekContext = Promise.prototype._peekContext;
        var Promise_promiseCreated = Promise.prototype._promiseCreated;
        Context.deactivateLongStackTraces = function() {
            Promise.prototype._pushContext = Promise_pushContext;
            Promise.prototype._popContext = Promise_popContext;
            Promise._peekContext = Promise_PeekContext;
            Promise.prototype._peekContext = Promise_peekContext;
            Promise.prototype._promiseCreated = Promise_promiseCreated;
            longStackTraces = false;
        };
        longStackTraces = true;
        Promise.prototype._pushContext = Context.prototype._pushContext;
        Promise.prototype._popContext = Context.prototype._popContext;
        Promise._peekContext = Promise.prototype._peekContext = peekContext;
        Promise.prototype._promiseCreated = function() {
            var ctx = this._peekContext();
            if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
        };
    };
    return Context;
};

});

parcelRegister("7mX4p", function(module, exports) {

var $jBmpJ = parcelRequire("jBmpJ");
"use strict";


module.exports = function(Promise, Context) {
    var getDomain = Promise._getDomain;
    var async = Promise._async;
    var Warning = (parcelRequire("8iBp5")).Warning;
    var util = (parcelRequire("gwhLZ"));
    var canAttachTrace = util.canAttachTrace;
    var unhandledRejectionHandled;
    var possiblyUnhandledRejection;
    var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
    var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
    var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
    var stackFramePattern = null;
    var formatStack = null;
    var indentStackFrames = false;
    var printWarning;
    var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && (util.env("BLUEBIRD_DEBUG") || util.env("NODE_ENV") === "development"));
    var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
    var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
    var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
    Promise.prototype.suppressUnhandledRejections = function() {
        var target = this._target();
        target._bitField = target._bitField & -1048577 | 524288;
    };
    Promise.prototype._ensurePossibleRejectionHandled = function() {
        if ((this._bitField & 524288) !== 0) return;
        this._setRejectionIsUnhandled();
        async.invokeLater(this._notifyUnhandledRejection, this, undefined);
    };
    Promise.prototype._notifyUnhandledRejectionIsHandled = function() {
        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
    };
    Promise.prototype._setReturnedNonUndefined = function() {
        this._bitField = this._bitField | 268435456;
    };
    Promise.prototype._returnedNonUndefined = function() {
        return (this._bitField & 268435456) !== 0;
    };
    Promise.prototype._notifyUnhandledRejection = function() {
        if (this._isRejectionUnhandled()) {
            var reason = this._settledValue();
            this._setUnhandledRejectionIsNotified();
            fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
        }
    };
    Promise.prototype._setUnhandledRejectionIsNotified = function() {
        this._bitField = this._bitField | 262144;
    };
    Promise.prototype._unsetUnhandledRejectionIsNotified = function() {
        this._bitField = this._bitField & -262145;
    };
    Promise.prototype._isUnhandledRejectionNotified = function() {
        return (this._bitField & 262144) > 0;
    };
    Promise.prototype._setRejectionIsUnhandled = function() {
        this._bitField = this._bitField | 1048576;
    };
    Promise.prototype._unsetRejectionIsUnhandled = function() {
        this._bitField = this._bitField & -1048577;
        if (this._isUnhandledRejectionNotified()) {
            this._unsetUnhandledRejectionIsNotified();
            this._notifyUnhandledRejectionIsHandled();
        }
    };
    Promise.prototype._isRejectionUnhandled = function() {
        return (this._bitField & 1048576) > 0;
    };
    Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
        return warn(message, shouldUseOwnTrace, promise || this);
    };
    Promise.onPossiblyUnhandledRejection = function(fn) {
        var domain = getDomain();
        possiblyUnhandledRejection = typeof fn === "function" ? domain === null ? fn : util.domainBind(domain, fn) : undefined;
    };
    Promise.onUnhandledRejectionHandled = function(fn) {
        var domain = getDomain();
        unhandledRejectionHandled = typeof fn === "function" ? domain === null ? fn : util.domainBind(domain, fn) : undefined;
    };
    var disableLongStackTraces = function() {};
    Promise.longStackTraces = function() {
        if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        if (!config.longStackTraces && longStackTracesIsSupported()) {
            var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
            var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
            config.longStackTraces = true;
            disableLongStackTraces = function() {
                if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                Promise.prototype._captureStackTrace = Promise_captureStackTrace;
                Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
                Context.deactivateLongStackTraces();
                async.enableTrampoline();
                config.longStackTraces = false;
            };
            Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
            Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
            Context.activateLongStackTraces();
            async.disableTrampolineIfNecessary();
        }
    };
    Promise.hasLongStackTraces = function() {
        return config.longStackTraces && longStackTracesIsSupported();
    };
    var fireDomEvent = function() {
        try {
            if (typeof CustomEvent === "function") {
                var event = new CustomEvent("CustomEvent");
                util.global.dispatchEvent(event);
                return function(name, event) {
                    var domEvent = new CustomEvent(name.toLowerCase(), {
                        detail: event,
                        cancelable: true
                    });
                    return !util.global.dispatchEvent(domEvent);
                };
            } else if (typeof Event === "function") {
                var event = new Event("CustomEvent");
                util.global.dispatchEvent(event);
                return function(name, event) {
                    var domEvent = new Event(name.toLowerCase(), {
                        cancelable: true
                    });
                    domEvent.detail = event;
                    return !util.global.dispatchEvent(domEvent);
                };
            } else {
                var event = document.createEvent("CustomEvent");
                event.initCustomEvent("testingtheevent", false, true, {});
                util.global.dispatchEvent(event);
                return function(name, event) {
                    var domEvent = document.createEvent("CustomEvent");
                    domEvent.initCustomEvent(name.toLowerCase(), false, true, event);
                    return !util.global.dispatchEvent(domEvent);
                };
            }
        } catch (e) {}
        return function() {
            return false;
        };
    }();
    var fireGlobalEvent = function() {
        if (util.isNode) return function() {
            return $jBmpJ.emit.apply($jBmpJ, arguments);
        };
        else {
            if (!util.global) return function() {
                return false;
            };
            return function(name) {
                var methodName = "on" + name.toLowerCase();
                var method = util.global[methodName];
                if (!method) return false;
                method.apply(util.global, [].slice.call(arguments, 1));
                return true;
            };
        }
    }();
    function generatePromiseLifecycleEventObject(name, promise) {
        return {
            promise: promise
        };
    }
    var eventToObjectGenerator = {
        promiseCreated: generatePromiseLifecycleEventObject,
        promiseFulfilled: generatePromiseLifecycleEventObject,
        promiseRejected: generatePromiseLifecycleEventObject,
        promiseResolved: generatePromiseLifecycleEventObject,
        promiseCancelled: generatePromiseLifecycleEventObject,
        promiseChained: function(name, promise, child) {
            return {
                promise: promise,
                child: child
            };
        },
        warning: function(name, warning) {
            return {
                warning: warning
            };
        },
        unhandledRejection: function(name, reason, promise) {
            return {
                reason: reason,
                promise: promise
            };
        },
        rejectionHandled: generatePromiseLifecycleEventObject
    };
    var activeFireEvent = function(name) {
        var globalEventFired = false;
        try {
            globalEventFired = fireGlobalEvent.apply(null, arguments);
        } catch (e) {
            async.throwLater(e);
            globalEventFired = true;
        }
        var domEventFired = false;
        try {
            domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
        } catch (e) {
            async.throwLater(e);
            domEventFired = true;
        }
        return domEventFired || globalEventFired;
    };
    Promise.config = function(opts) {
        opts = Object(opts);
        if ("longStackTraces" in opts) {
            if (opts.longStackTraces) Promise.longStackTraces();
            else if (!opts.longStackTraces && Promise.hasLongStackTraces()) disableLongStackTraces();
        }
        if ("warnings" in opts) {
            var warningsOption = opts.warnings;
            config.warnings = !!warningsOption;
            wForgottenReturn = config.warnings;
            if (util.isObject(warningsOption)) {
                if ("wForgottenReturn" in warningsOption) wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
            if (async.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
            Promise.prototype._clearCancellationData = cancellationClearCancellationData;
            Promise.prototype._propagateFrom = cancellationPropagateFrom;
            Promise.prototype._onCancel = cancellationOnCancel;
            Promise.prototype._setOnCancel = cancellationSetOnCancel;
            Promise.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
            Promise.prototype._execute = cancellationExecute;
            propagateFromFunction = cancellationPropagateFrom;
            config.cancellation = true;
        }
        if ("monitoring" in opts) {
            if (opts.monitoring && !config.monitoring) {
                config.monitoring = true;
                Promise.prototype._fireEvent = activeFireEvent;
            } else if (!opts.monitoring && config.monitoring) {
                config.monitoring = false;
                Promise.prototype._fireEvent = defaultFireEvent;
            }
        }
        return Promise;
    };
    function defaultFireEvent() {
        return false;
    }
    Promise.prototype._fireEvent = defaultFireEvent;
    Promise.prototype._execute = function(executor, resolve, reject) {
        try {
            executor(resolve, reject);
        } catch (e) {
            return e;
        }
    };
    Promise.prototype._onCancel = function() {};
    Promise.prototype._setOnCancel = function(handler) {};
    Promise.prototype._attachCancellationCallback = function(onCancel) {};
    Promise.prototype._captureStackTrace = function() {};
    Promise.prototype._attachExtraTrace = function() {};
    Promise.prototype._clearCancellationData = function() {};
    Promise.prototype._propagateFrom = function(parent, flags) {};
    function cancellationExecute(executor, resolve, reject) {
        var promise = this;
        try {
            executor(resolve, reject, function(onCancel) {
                if (typeof onCancel !== "function") throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                promise._attachCancellationCallback(onCancel);
            });
        } catch (e) {
            return e;
        }
    }
    function cancellationAttachCancellationCallback(onCancel) {
        if (!this._isCancellable()) return this;
        var previousOnCancel = this._onCancel();
        if (previousOnCancel !== undefined) {
            if (util.isArray(previousOnCancel)) previousOnCancel.push(onCancel);
            else this._setOnCancel([
                previousOnCancel,
                onCancel
            ]);
        } else this._setOnCancel(onCancel);
    }
    function cancellationOnCancel() {
        return this._onCancelField;
    }
    function cancellationSetOnCancel(onCancel) {
        this._onCancelField = onCancel;
    }
    function cancellationClearCancellationData() {
        this._cancellationParent = undefined;
        this._onCancelField = undefined;
    }
    function cancellationPropagateFrom(parent, flags) {
        if ((flags & 1) !== 0) {
            this._cancellationParent = parent;
            var branchesRemainingToCancel = parent._branchesRemainingToCancel;
            if (branchesRemainingToCancel === undefined) branchesRemainingToCancel = 0;
            parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
        }
        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
    }
    function bindingPropagateFrom(parent, flags) {
        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
    }
    var propagateFromFunction = bindingPropagateFrom;
    function boundValueFunction() {
        var ret = this._boundTo;
        if (ret !== undefined) {
            if (ret instanceof Promise) {
                if (ret.isFulfilled()) return ret.value();
                else return undefined;
            }
        }
        return ret;
    }
    function longStackTracesCaptureStackTrace() {
        this._trace = new CapturedTrace(this._peekContext());
    }
    function longStackTracesAttachExtraTrace(error, ignoreSelf) {
        if (canAttachTrace(error)) {
            var trace = this._trace;
            if (trace !== undefined) {
                if (ignoreSelf) trace = trace._parent;
            }
            if (trace !== undefined) trace.attachExtraTrace(error);
            else if (!error.__stackCleaned__) {
                var parsed = parseStackAndMessage(error);
                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                util.notEnumerableProp(error, "__stackCleaned__", true);
            }
        }
    }
    function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
            if (parent !== undefined && parent._returnedNonUndefined()) return;
            if ((promise._bitField & 65535) === 0) return;
            if (name) name = name + " ";
            var handlerLine = "";
            var creatorLine = "";
            if (promiseCreated._trace) {
                var traceLines = promiseCreated._trace.stack.split("\n");
                var stack = cleanStack(traceLines);
                for(var i = stack.length - 1; i >= 0; --i){
                    var line = stack[i];
                    if (!nodeFramePattern.test(line)) {
                        var lineMatches = line.match(parseLinePattern);
                        if (lineMatches) handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                        break;
                    }
                }
                if (stack.length > 0) {
                    var firstUserLine = stack[0];
                    for(var i = 0; i < traceLines.length; ++i)if (traceLines[i] === firstUserLine) {
                        if (i > 0) creatorLine = "\n" + traceLines[i - 1];
                        break;
                    }
                }
            }
            var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
            promise._warn(msg, true, promiseCreated);
        }
    }
    function deprecated(name, replacement) {
        var message = name + " is deprecated and will be removed in a future version.";
        if (replacement) message += " Use " + replacement + " instead.";
        return warn(message);
    }
    function warn(message, shouldUseOwnTrace, promise) {
        if (!config.warnings) return;
        var warning = new Warning(message);
        var ctx;
        if (shouldUseOwnTrace) promise._attachExtraTrace(warning);
        else if (config.longStackTraces && (ctx = Promise._peekContext())) ctx.attachExtraTrace(warning);
        else {
            var parsed = parseStackAndMessage(warning);
            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
        }
        if (!activeFireEvent("warning", warning)) formatAndLogError(warning, "", true);
    }
    function reconstructStack(message, stacks) {
        for(var i = 0; i < stacks.length - 1; ++i){
            stacks[i].push("From previous event:");
            stacks[i] = stacks[i].join("\n");
        }
        if (i < stacks.length) stacks[i] = stacks[i].join("\n");
        return message + "\n" + stacks.join("\n");
    }
    function removeDuplicateOrEmptyJumps(stacks) {
        for(var i = 0; i < stacks.length; ++i)if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
            stacks.splice(i, 1);
            i--;
        }
    }
    function removeCommonRoots(stacks) {
        var current = stacks[0];
        for(var i = 1; i < stacks.length; ++i){
            var prev = stacks[i];
            var currentLastIndex = current.length - 1;
            var currentLastLine = current[currentLastIndex];
            var commonRootMeetPoint = -1;
            for(var j = prev.length - 1; j >= 0; --j)if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
            for(var j = commonRootMeetPoint; j >= 0; --j){
                var line = prev[j];
                if (current[currentLastIndex] === line) {
                    current.pop();
                    currentLastIndex--;
                } else break;
            }
            current = prev;
        }
    }
    function cleanStack(stack) {
        var ret = [];
        for(var i = 0; i < stack.length; ++i){
            var line = stack[i];
            var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
            var isInternalFrame = isTraceLine && shouldIgnore(line);
            if (isTraceLine && !isInternalFrame) {
                if (indentStackFrames && line.charAt(0) !== " ") line = "    " + line;
                ret.push(line);
            }
        }
        return ret;
    }
    function stackFramesAsArray(error) {
        var stack = error.stack.replace(/\s+$/g, "").split("\n");
        for(var i = 0; i < stack.length; ++i){
            var line = stack[i];
            if ("    (No stack trace)" === line || stackFramePattern.test(line)) break;
        }
        if (i > 0 && error.name != "SyntaxError") stack = stack.slice(i);
        return stack;
    }
    function parseStackAndMessage(error) {
        var stack = error.stack;
        var message = error.toString();
        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : [
            "    (No stack trace)"
        ];
        return {
            message: message,
            stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
        };
    }
    function formatAndLogError(error, title, isSoft) {
        if (typeof console !== "undefined") {
            var message;
            if (util.isObject(error)) {
                var stack = error.stack;
                message = title + formatStack(stack, error);
            } else message = title + String(error);
            if (typeof printWarning === "function") printWarning(message, isSoft);
            else if (typeof console.log === "function" || typeof console.log === "object") console.log(message);
        }
    }
    function fireRejectionEvent(name, localHandler, reason, promise) {
        var localEventFired = false;
        try {
            if (typeof localHandler === "function") {
                localEventFired = true;
                if (name === "rejectionHandled") localHandler(promise);
                else localHandler(reason, promise);
            }
        } catch (e) {
            async.throwLater(e);
        }
        if (name === "unhandledRejection") {
            if (!activeFireEvent(name, reason, promise) && !localEventFired) formatAndLogError(reason, "Unhandled rejection ");
        } else activeFireEvent(name, promise);
    }
    function formatNonError(obj) {
        var str;
        if (typeof obj === "function") str = "[function " + (obj.name || "anonymous") + "]";
        else {
            str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
            if (ruselessToString.test(str)) try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            } catch (e) {}
            if (str.length === 0) str = "(empty array)";
        }
        return "(<" + snip(str) + ">, no stack trace)";
    }
    function snip(str) {
        var maxChars = 41;
        if (str.length < maxChars) return str;
        return str.substr(0, maxChars - 3) + "...";
    }
    function longStackTracesIsSupported() {
        return typeof captureStackTrace === "function";
    }
    var shouldIgnore = function() {
        return false;
    };
    var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
    function parseLineInfo(line) {
        var matches = line.match(parseLineInfoRegex);
        if (matches) return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
    function setBounds(firstLineError, lastLineError) {
        if (!longStackTracesIsSupported()) return;
        var firstStackLines = firstLineError.stack.split("\n");
        var lastStackLines = lastLineError.stack.split("\n");
        var firstIndex = -1;
        var lastIndex = -1;
        var firstFileName;
        var lastFileName;
        for(var i = 0; i < firstStackLines.length; ++i){
            var result = parseLineInfo(firstStackLines[i]);
            if (result) {
                firstFileName = result.fileName;
                firstIndex = result.line;
                break;
            }
        }
        for(var i = 0; i < lastStackLines.length; ++i){
            var result = parseLineInfo(lastStackLines[i]);
            if (result) {
                lastFileName = result.fileName;
                lastIndex = result.line;
                break;
            }
        }
        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) return;
        shouldIgnore = function(line) {
            if (bluebirdFramePattern.test(line)) return true;
            var info = parseLineInfo(line);
            if (info) {
                if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) return true;
            }
            return false;
        };
    }
    function CapturedTrace(parent) {
        this._parent = parent;
        this._promisesCreated = 0;
        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
        captureStackTrace(this, CapturedTrace);
        if (length > 32) this.uncycle();
    }
    util.inherits(CapturedTrace, Error);
    Context.CapturedTrace = CapturedTrace;
    CapturedTrace.prototype.uncycle = function() {
        var length = this._length;
        if (length < 2) return;
        var nodes = [];
        var stackToIndex = {};
        for(var i = 0, node = this; node !== undefined; ++i){
            nodes.push(node);
            node = node._parent;
        }
        length = this._length = i;
        for(var i = length - 1; i >= 0; --i){
            var stack = nodes[i].stack;
            if (stackToIndex[stack] === undefined) stackToIndex[stack] = i;
        }
        for(var i = 0; i < length; ++i){
            var currentStack = nodes[i].stack;
            var index = stackToIndex[currentStack];
            if (index !== undefined && index !== i) {
                if (index > 0) {
                    nodes[index - 1]._parent = undefined;
                    nodes[index - 1]._length = 1;
                }
                nodes[i]._parent = undefined;
                nodes[i]._length = 1;
                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                if (index < length - 1) {
                    cycleEdgeNode._parent = nodes[index + 1];
                    cycleEdgeNode._parent.uncycle();
                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                } else {
                    cycleEdgeNode._parent = undefined;
                    cycleEdgeNode._length = 1;
                }
                var currentChildLength = cycleEdgeNode._length + 1;
                for(var j = i - 2; j >= 0; --j){
                    nodes[j]._length = currentChildLength;
                    currentChildLength++;
                }
                return;
            }
        }
    };
    CapturedTrace.prototype.attachExtraTrace = function(error) {
        if (error.__stackCleaned__) return;
        this.uncycle();
        var parsed = parseStackAndMessage(error);
        var message = parsed.message;
        var stacks = [
            parsed.stack
        ];
        var trace = this;
        while(trace !== undefined){
            stacks.push(cleanStack(trace.stack.split("\n")));
            trace = trace._parent;
        }
        removeCommonRoots(stacks);
        removeDuplicateOrEmptyJumps(stacks);
        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
        util.notEnumerableProp(error, "__stackCleaned__", true);
    };
    var captureStackTrace = function stackDetection() {
        var v8stackFramePattern = /^\s*at\s*/;
        var v8stackFormatter = function(stack, error) {
            if (typeof stack === "string") return stack;
            if (error.name !== undefined && error.message !== undefined) return error.toString();
            return formatNonError(error);
        };
        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
            Error.stackTraceLimit += 6;
            stackFramePattern = v8stackFramePattern;
            formatStack = v8stackFormatter;
            var captureStackTrace = Error.captureStackTrace;
            shouldIgnore = function(line) {
                return bluebirdFramePattern.test(line);
            };
            return function(receiver, ignoreUntil) {
                Error.stackTraceLimit += 6;
                captureStackTrace(receiver, ignoreUntil);
                Error.stackTraceLimit -= 6;
            };
        }
        var err = new Error();
        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
            stackFramePattern = /@/;
            formatStack = v8stackFormatter;
            indentStackFrames = true;
            return function captureStackTrace(o) {
                o.stack = new Error().stack;
            };
        }
        var hasStackAfterThrow;
        try {
            throw new Error();
        } catch (e) {
            hasStackAfterThrow = "stack" in e;
        }
        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
            stackFramePattern = v8stackFramePattern;
            formatStack = v8stackFormatter;
            return function captureStackTrace(o) {
                Error.stackTraceLimit += 6;
                try {
                    throw new Error();
                } catch (e) {
                    o.stack = e.stack;
                }
                Error.stackTraceLimit -= 6;
            };
        }
        formatStack = function(stack, error) {
            if (typeof stack === "string") return stack;
            if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) return error.toString();
            return formatNonError(error);
        };
        return null;
    }([]);
    if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
        printWarning = function(message) {
            console.warn(message);
        };
        if (util.isNode && $jBmpJ.stderr.isTTY) printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
        else if (!util.isNode && typeof new Error().stack === "string") printWarning = function(message, isSoft) {
            console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
        };
    }
    var config = {
        warnings: warnings,
        longStackTraces: false,
        cancellation: false,
        monitoring: false
    };
    if (longStackTraces) Promise.longStackTraces();
    return {
        longStackTraces: function() {
            return config.longStackTraces;
        },
        warnings: function() {
            return config.warnings;
        },
        cancellation: function() {
            return config.cancellation;
        },
        monitoring: function() {
            return config.monitoring;
        },
        propagateFromFunction: function() {
            return propagateFromFunction;
        },
        boundValueFunction: function() {
            return boundValueFunction;
        },
        checkForgottenReturns: checkForgottenReturns,
        setBounds: setBounds,
        warn: warn,
        deprecated: deprecated,
        CapturedTrace: CapturedTrace,
        fireDomEvent: fireDomEvent,
        fireGlobalEvent: fireGlobalEvent
    };
};

});

parcelRegister("hrFux", function(module, exports) {
"use strict";

module.exports = function(Promise, tryConvertToPromise) {
    var util = (parcelRequire("gwhLZ"));
    var CancellationError = Promise.CancellationError;
    var errorObj = util.errorObj;
    function PassThroughHandlerContext(promise, type, handler) {
        this.promise = promise;
        this.type = type;
        this.handler = handler;
        this.called = false;
        this.cancelPromise = null;
    }
    PassThroughHandlerContext.prototype.isFinallyHandler = function() {
        return this.type === 0;
    };
    function FinallyHandlerCancelReaction(finallyHandler) {
        this.finallyHandler = finallyHandler;
    }
    FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
        checkCancel(this.finallyHandler);
    };
    function checkCancel(ctx, reason) {
        if (ctx.cancelPromise != null) {
            if (arguments.length > 1) ctx.cancelPromise._reject(reason);
            else ctx.cancelPromise._cancel();
            ctx.cancelPromise = null;
            return true;
        }
        return false;
    }
    function succeed() {
        return finallyHandler.call(this, this.promise._target()._settledValue());
    }
    function fail(reason) {
        if (checkCancel(this, reason)) return;
        errorObj.e = reason;
        return errorObj;
    }
    function finallyHandler(reasonOrValue) {
        var promise = this.promise;
        var handler = this.handler;
        if (!this.called) {
            this.called = true;
            var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
            if (ret !== undefined) {
                promise._setReturnedNonUndefined();
                var maybePromise = tryConvertToPromise(ret, promise);
                if (maybePromise instanceof Promise) {
                    if (this.cancelPromise != null) {
                        if (maybePromise._isCancelled()) {
                            var reason = new CancellationError("late cancellation observer");
                            promise._attachExtraTrace(reason);
                            errorObj.e = reason;
                            return errorObj;
                        } else if (maybePromise.isPending()) maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                    }
                    return maybePromise._then(succeed, fail, undefined, this, undefined);
                }
            }
        }
        if (promise.isRejected()) {
            checkCancel(this);
            errorObj.e = reasonOrValue;
            return errorObj;
        } else {
            checkCancel(this);
            return reasonOrValue;
        }
    }
    Promise.prototype._passThrough = function(handler, type, success, fail) {
        if (typeof handler !== "function") return this.then();
        return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
    };
    Promise.prototype.lastly = Promise.prototype["finally"] = function(handler) {
        return this._passThrough(handler, 0, finallyHandler, finallyHandler);
    };
    Promise.prototype.tap = function(handler) {
        return this._passThrough(handler, 1, finallyHandler);
    };
    return PassThroughHandlerContext;
};

});

parcelRegister("6aswz", function(module, exports) {
"use strict";


module.exports = function(NEXT_FILTER) {
    var util = (parcelRequire("gwhLZ"));
    var getKeys = (parcelRequire("4Ys6H")).keys;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    function catchFilter(instances, cb, promise) {
        return function(e) {
            var boundTo = promise._boundValue();
            predicateLoop: for(var i = 0; i < instances.length; ++i){
                var item = instances[i];
                if (item === Error || item != null && item.prototype instanceof Error) {
                    if (e instanceof item) return tryCatch(cb).call(boundTo, e);
                } else if (typeof item === "function") {
                    var matchesPredicate = tryCatch(item).call(boundTo, e);
                    if (matchesPredicate === errorObj) return matchesPredicate;
                    else if (matchesPredicate) return tryCatch(cb).call(boundTo, e);
                } else if (util.isObject(e)) {
                    var keys = getKeys(item);
                    for(var j = 0; j < keys.length; ++j){
                        var key = keys[j];
                        if (item[key] != e[key]) continue predicateLoop;
                    }
                    return tryCatch(cb).call(boundTo, e);
                }
            }
            return NEXT_FILTER;
        };
    }
    return catchFilter;
};

});

parcelRegister("D39zY", function(module, exports) {
"use strict";

var $gwhLZ = parcelRequire("gwhLZ");
var $075616da5dcb9a1d$var$maybeWrapAsError = $gwhLZ.maybeWrapAsError;

var $8iBp5 = parcelRequire("8iBp5");
var $075616da5dcb9a1d$var$OperationalError = $8iBp5.OperationalError;

var $4Ys6H = parcelRequire("4Ys6H");
function $075616da5dcb9a1d$var$isUntypedError(obj) {
    return obj instanceof Error && $4Ys6H.getPrototypeOf(obj) === Error.prototype;
}
var $075616da5dcb9a1d$var$rErrorKey = /^(?:name|message|stack|cause)$/;
function $075616da5dcb9a1d$var$wrapAsOperationalError(obj) {
    var ret;
    if ($075616da5dcb9a1d$var$isUntypedError(obj)) {
        ret = new $075616da5dcb9a1d$var$OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = $4Ys6H.keys(obj);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$075616da5dcb9a1d$var$rErrorKey.test(key)) ret[key] = obj[key];
        }
        return ret;
    }
    $gwhLZ.markAsOriginatingFromRejection(obj);
    return obj;
}
function $075616da5dcb9a1d$var$nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = $075616da5dcb9a1d$var$wrapAsOperationalError($075616da5dcb9a1d$var$maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) promise._fulfill(value);
        else {
            var $_len = arguments.length;
            var args = new Array(Math.max($_len - 1, 0));
            for(var $_i = 1; $_i < $_len; ++$_i)args[$_i - 1] = arguments[$_i];
            promise._fulfill(args);
        }
        promise = null;
    };
}
module.exports = $075616da5dcb9a1d$var$nodebackForPromise;

});

parcelRegister("1tSGu", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
    var util = (parcelRequire("gwhLZ"));
    var tryCatch = util.tryCatch;
    Promise.method = function(fn) {
        if (typeof fn !== "function") throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
        return function() {
            var ret = new Promise(INTERNAL);
            ret._captureStackTrace();
            ret._pushContext();
            var value = tryCatch(fn).apply(this, arguments);
            var promiseCreated = ret._popContext();
            debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
            ret._resolveFromSyncValue(value);
            return ret;
        };
    };
    Promise.attempt = Promise["try"] = function(fn) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value;
        if (arguments.length > 1) {
            debug.deprecated("calling Promise.try with more than 1 argument");
            var arg = arguments[1];
            var ctx = arguments[2];
            value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
        } else value = tryCatch(fn)();
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
    Promise.prototype._resolveFromSyncValue = function(value) {
        if (value === util.errorObj) this._rejectCallback(value.e, false);
        else this._resolveCallback(value, true);
    };
};

});

parcelRegister("gMrzh", function(module, exports) {
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
    var calledBind = false;
    var rejectThis = function(_, e) {
        this._reject(e);
    };
    var targetRejected = function(e, context) {
        context.promiseRejectionQueued = true;
        context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
    };
    var bindingResolved = function(thisArg, context) {
        if ((this._bitField & 50397184) === 0) this._resolveCallback(context.target);
    };
    var bindingRejected = function(e, context) {
        if (!context.promiseRejectionQueued) this._reject(e);
    };
    Promise.prototype.bind = function(thisArg) {
        if (!calledBind) {
            calledBind = true;
            Promise.prototype._propagateFrom = debug.propagateFromFunction();
            Promise.prototype._boundValue = debug.boundValueFunction();
        }
        var maybePromise = tryConvertToPromise(thisArg);
        var ret = new Promise(INTERNAL);
        ret._propagateFrom(this, 1);
        var target = this._target();
        ret._setBoundTo(maybePromise);
        if (maybePromise instanceof Promise) {
            var context = {
                promiseRejectionQueued: false,
                promise: ret,
                target: target,
                bindingPromise: maybePromise
            };
            target._then(INTERNAL, targetRejected, undefined, ret, context);
            maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
            ret._setOnCancel(maybePromise);
        } else ret._resolveCallback(target);
        return ret;
    };
    Promise.prototype._setBoundTo = function(obj) {
        if (obj !== undefined) {
            this._bitField = this._bitField | 2097152;
            this._boundTo = obj;
        } else this._bitField = this._bitField & -2097153;
    };
    Promise.prototype._isBound = function() {
        return (this._bitField & 2097152) === 2097152;
    };
    Promise.bind = function(thisArg, value) {
        return Promise.resolve(value).bind(thisArg);
    };
};

});

parcelRegister("3GkZ6", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, apiRejection, debug) {
    var util = (parcelRequire("gwhLZ"));
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var async = Promise._async;
    Promise.prototype["break"] = Promise.prototype.cancel = function() {
        if (!debug.cancellation()) return this._warn("cancellation is disabled");
        var promise = this;
        var child = promise;
        while(promise._isCancellable()){
            if (!promise._cancelBy(child)) {
                if (child._isFollowing()) child._followee().cancel();
                else child._cancelBranched();
                break;
            }
            var parent = promise._cancellationParent;
            if (parent == null || !parent._isCancellable()) {
                if (promise._isFollowing()) promise._followee().cancel();
                else promise._cancelBranched();
                break;
            } else {
                if (promise._isFollowing()) promise._followee().cancel();
                promise._setWillBeCancelled();
                child = promise;
                promise = parent;
            }
        }
    };
    Promise.prototype._branchHasCancelled = function() {
        this._branchesRemainingToCancel--;
    };
    Promise.prototype._enoughBranchesHaveCancelled = function() {
        return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
    };
    Promise.prototype._cancelBy = function(canceller) {
        if (canceller === this) {
            this._branchesRemainingToCancel = 0;
            this._invokeOnCancel();
            return true;
        } else {
            this._branchHasCancelled();
            if (this._enoughBranchesHaveCancelled()) {
                this._invokeOnCancel();
                return true;
            }
        }
        return false;
    };
    Promise.prototype._cancelBranched = function() {
        if (this._enoughBranchesHaveCancelled()) this._cancel();
    };
    Promise.prototype._cancel = function() {
        if (!this._isCancellable()) return;
        this._setCancelled();
        async.invoke(this._cancelPromises, this, undefined);
    };
    Promise.prototype._cancelPromises = function() {
        if (this._length() > 0) this._settlePromises();
    };
    Promise.prototype._unsetOnCancel = function() {
        this._onCancelField = undefined;
    };
    Promise.prototype._isCancellable = function() {
        return this.isPending() && !this._isCancelled();
    };
    Promise.prototype.isCancellable = function() {
        return this.isPending() && !this.isCancelled();
    };
    Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
        if (util.isArray(onCancelCallback)) for(var i = 0; i < onCancelCallback.length; ++i)this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        else if (onCancelCallback !== undefined) {
            if (typeof onCancelCallback === "function") {
                if (!internalOnly) {
                    var e = tryCatch(onCancelCallback).call(this._boundValue());
                    if (e === errorObj) {
                        this._attachExtraTrace(e.e);
                        async.throwLater(e.e);
                    }
                }
            } else onCancelCallback._resultCancelled(this);
        }
    };
    Promise.prototype._invokeOnCancel = function() {
        var onCancelCallback = this._onCancel();
        this._unsetOnCancel();
        async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
    };
    Promise.prototype._invokeInternalOnCancel = function() {
        if (this._isCancellable()) {
            this._doInvokeOnCancel(this._onCancel(), true);
            this._unsetOnCancel();
        }
    };
    Promise.prototype._resultCancelled = function() {
        this.cancel();
    };
};

});

parcelRegister("bGq8S", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    function returner() {
        return this.value;
    }
    function thrower() {
        throw this.reason;
    }
    Promise.prototype["return"] = Promise.prototype.thenReturn = function(value) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(returner, undefined, undefined, {
            value: value
        }, undefined);
    };
    Promise.prototype["throw"] = Promise.prototype.thenThrow = function(reason) {
        return this._then(thrower, undefined, undefined, {
            reason: reason
        }, undefined);
    };
    Promise.prototype.catchThrow = function(reason) {
        if (arguments.length <= 1) return this._then(undefined, thrower, undefined, {
            reason: reason
        }, undefined);
        else {
            var _reason = arguments[1];
            var handler = function() {
                throw _reason;
            };
            return this.caught(reason, handler);
        }
    };
    Promise.prototype.catchReturn = function(value) {
        if (arguments.length <= 1) {
            if (value instanceof Promise) value.suppressUnhandledRejections();
            return this._then(undefined, returner, undefined, {
                value: value
            }, undefined);
        } else {
            var _value = arguments[1];
            if (_value instanceof Promise) _value.suppressUnhandledRejections();
            var handler = function() {
                return _value;
            };
            return this.caught(value, handler);
        }
    };
};

});

parcelRegister("cj9Tm", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    function PromiseInspection(promise) {
        if (promise !== undefined) {
            promise = promise._target();
            this._bitField = promise._bitField;
            this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
        } else {
            this._bitField = 0;
            this._settledValueField = undefined;
        }
    }
    PromiseInspection.prototype._settledValue = function() {
        return this._settledValueField;
    };
    var value = PromiseInspection.prototype.value = function() {
        if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        return this._settledValue();
    };
    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function() {
        if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        return this._settledValue();
    };
    var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
        return (this._bitField & 33554432) !== 0;
    };
    var isRejected = PromiseInspection.prototype.isRejected = function() {
        return (this._bitField & 16777216) !== 0;
    };
    var isPending = PromiseInspection.prototype.isPending = function() {
        return (this._bitField & 50397184) === 0;
    };
    var isResolved = PromiseInspection.prototype.isResolved = function() {
        return (this._bitField & 50331648) !== 0;
    };
    PromiseInspection.prototype.isCancelled = function() {
        return (this._bitField & 8454144) !== 0;
    };
    Promise.prototype.__isCancelled = function() {
        return (this._bitField & 65536) === 65536;
    };
    Promise.prototype._isCancelled = function() {
        return this._target().__isCancelled();
    };
    Promise.prototype.isCancelled = function() {
        return (this._target()._bitField & 8454144) !== 0;
    };
    Promise.prototype.isPending = function() {
        return isPending.call(this._target());
    };
    Promise.prototype.isRejected = function() {
        return isRejected.call(this._target());
    };
    Promise.prototype.isFulfilled = function() {
        return isFulfilled.call(this._target());
    };
    Promise.prototype.isResolved = function() {
        return isResolved.call(this._target());
    };
    Promise.prototype.value = function() {
        return value.call(this._target());
    };
    Promise.prototype.reason = function() {
        var target = this._target();
        target._unsetRejectionIsUnhandled();
        return reason.call(target);
    };
    Promise.prototype._value = function() {
        return this._settledValue();
    };
    Promise.prototype._reason = function() {
        this._unsetRejectionIsUnhandled();
        return this._settledValue();
    };
    Promise.PromiseInspection = PromiseInspection;
};

});

parcelRegister("cMkgr", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain) {
    var util = (parcelRequire("gwhLZ"));
    var canEvaluate = util.canEvaluate;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var reject;
    if (canEvaluate) {
        var thenCallback = function(i) {
            return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
        };
        var promiseSetter = function(i) {
            return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
        };
        var generateHolderClass = function(total) {
            var props = new Array(total);
            for(var i = 0; i < props.length; ++i)props[i] = "this.p" + (i + 1);
            var assignment = props.join(" = ") + " = null;";
            var cancellationCode = "var promise;\n" + props.map(function(prop) {
                return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
            }).join("\n");
            var passedArguments = props.join(", ");
            var name = "Holder$" + total;
            var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";
            code = code.replace(/\[TheName\]/g, name).replace(/\[TheTotal\]/g, total).replace(/\[ThePassedArguments\]/g, passedArguments).replace(/\[TheProperties\]/g, assignment).replace(/\[CancellationCode\]/g, cancellationCode);
            return new Function("tryCatch", "errorObj", "Promise", "async", code)(tryCatch, errorObj, Promise, async);
        };
        var holderClasses = [];
        var thenCallbacks = [];
        var promiseSetters = [];
        for(var i = 0; i < 8; ++i){
            holderClasses.push(generateHolderClass(i + 1));
            thenCallbacks.push(thenCallback(i + 1));
            promiseSetters.push(promiseSetter(i + 1));
        }
        reject = function(reason) {
            this._reject(reason);
        };
    }
    Promise.join = function() {
        var last = arguments.length - 1;
        var fn;
        if (last > 0 && typeof arguments[last] === "function") {
            fn = arguments[last];
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;
                for(var i = 0; i < last; ++i){
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        if ((bitField & 50397184) === 0) {
                            maybePromise._then(callbacks[i], reject, undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if ((bitField & 33554432) !== 0) callbacks[i].call(ret, maybePromise._value(), holder);
                        else if ((bitField & 16777216) !== 0) ret._reject(maybePromise._reason());
                        else ret._cancel();
                    } else callbacks[i].call(ret, maybePromise, holder);
                }
                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) holder.fn = util.domainBind(domain, holder.fn);
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
        var $_len = arguments.length;
        var args = new Array($_len);
        for(var $_i = 0; $_i < $_len; ++$_i)args[$_i] = arguments[$_i];
        if (fn) args.pop();
        var ret = new PromiseArray(args).promise();
        return fn !== undefined ? ret.spread(fn) : ret;
    };
};

});

parcelRegister("c9ZhW", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
    var getDomain = Promise._getDomain;
    var util = (parcelRequire("gwhLZ"));
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var async = Promise._async;
    function MappingPromiseArray(promises, fn, limit, _filter) {
        this.constructor$(promises);
        this._promise._captureStackTrace();
        var domain = getDomain();
        this._callback = domain === null ? fn : util.domainBind(domain, fn);
        this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
        this._limit = limit;
        this._inFlight = 0;
        this._queue = [];
        async.invoke(this._asyncInit, this, undefined);
    }
    util.inherits(MappingPromiseArray, PromiseArray);
    MappingPromiseArray.prototype._asyncInit = function() {
        this._init$(undefined, -2);
    };
    MappingPromiseArray.prototype._init = function() {};
    MappingPromiseArray.prototype._promiseFulfilled = function(value, index) {
        var values = this._values;
        var length = this.length();
        var preservedValues = this._preservedValues;
        var limit = this._limit;
        if (index < 0) {
            index = index * -1 - 1;
            values[index] = value;
            if (limit >= 1) {
                this._inFlight--;
                this._drainQueue();
                if (this._isResolved()) return true;
            }
        } else {
            if (limit >= 1 && this._inFlight >= limit) {
                values[index] = value;
                this._queue.push(index);
                return false;
            }
            if (preservedValues !== null) preservedValues[index] = value;
            var promise = this._promise;
            var callback = this._callback;
            var receiver = promise._boundValue();
            promise._pushContext();
            var ret = tryCatch(callback).call(receiver, value, index, length);
            var promiseCreated = promise._popContext();
            debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
            if (ret === errorObj) {
                this._reject(ret.e);
                return true;
            }
            var maybePromise = tryConvertToPromise(ret, this._promise);
            if (maybePromise instanceof Promise) {
                maybePromise = maybePromise._target();
                var bitField = maybePromise._bitField;
                if ((bitField & 50397184) === 0) {
                    if (limit >= 1) this._inFlight++;
                    values[index] = maybePromise;
                    maybePromise._proxy(this, (index + 1) * -1);
                    return false;
                } else if ((bitField & 33554432) !== 0) ret = maybePromise._value();
                else if ((bitField & 16777216) !== 0) {
                    this._reject(maybePromise._reason());
                    return true;
                } else {
                    this._cancel();
                    return true;
                }
            }
            values[index] = ret;
        }
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= length) {
            if (preservedValues !== null) this._filter(values, preservedValues);
            else this._resolve(values);
            return true;
        }
        return false;
    };
    MappingPromiseArray.prototype._drainQueue = function() {
        var queue = this._queue;
        var limit = this._limit;
        var values = this._values;
        while(queue.length > 0 && this._inFlight < limit){
            if (this._isResolved()) return;
            var index = queue.pop();
            this._promiseFulfilled(values[index], index);
        }
    };
    MappingPromiseArray.prototype._filter = function(booleans, values) {
        var len = values.length;
        var ret = new Array(len);
        var j = 0;
        for(var i = 0; i < len; ++i)if (booleans[i]) ret[j++] = values[i];
        ret.length = j;
        this._resolve(ret);
    };
    MappingPromiseArray.prototype.preservedValues = function() {
        return this._preservedValues;
    };
    function map(promises, fn, options, _filter) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var limit = 0;
        if (options !== undefined) {
            if (typeof options === "object" && options !== null) {
                if (typeof options.concurrency !== "number") return Promise.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                limit = options.concurrency;
            } else return Promise.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
        }
        limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
        return new MappingPromiseArray(promises, fn, limit, _filter).promise();
    }
    Promise.prototype.map = function(fn, options) {
        return map(this, fn, options, null);
    };
    Promise.map = function(promises, fn, options, _filter) {
        return map(promises, fn, options, _filter);
    };
};

});

parcelRegister("6SIZX", function(module, exports) {
"use strict";
var $502ab0f60bb41d27$var$cr = Object.create;
if ($502ab0f60bb41d27$var$cr) {
    var $502ab0f60bb41d27$var$callerCache = $502ab0f60bb41d27$var$cr(null);
    var $502ab0f60bb41d27$var$getterCache = $502ab0f60bb41d27$var$cr(null);
    $502ab0f60bb41d27$var$callerCache[" size"] = $502ab0f60bb41d27$var$getterCache[" size"] = 0;
}

module.exports = function(Promise) {
    var util = (parcelRequire("gwhLZ"));
    var canEvaluate = util.canEvaluate;
    var isIdentifier = util.isIdentifier;
    var getMethodCaller;
    var getGetter;
    var makeMethodCaller = function(methodName) {
        return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
    };
    var makeGetter = function(propertyName) {
        return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
    };
    var getCompiled = function(name, compiler, cache) {
        var ret = cache[name];
        if (typeof ret !== "function") {
            if (!isIdentifier(name)) return null;
            ret = compiler(name);
            cache[name] = ret;
            cache[" size"]++;
            if (cache[" size"] > 512) {
                var keys = Object.keys(cache);
                for(var i = 0; i < 256; ++i)delete cache[keys[i]];
                cache[" size"] = keys.length - 256;
            }
        }
        return ret;
    };
    getMethodCaller = function(name) {
        return getCompiled(name, makeMethodCaller, $502ab0f60bb41d27$var$callerCache);
    };
    getGetter = function(name) {
        return getCompiled(name, makeGetter, $502ab0f60bb41d27$var$getterCache);
    };
    function ensureMethod(obj, methodName) {
        var fn;
        if (obj != null) fn = obj[methodName];
        if (typeof fn !== "function") {
            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
            throw new Promise.TypeError(message);
        }
        return fn;
    }
    function caller(obj) {
        var methodName = this.pop();
        var fn = ensureMethod(obj, methodName);
        return fn.apply(obj, this);
    }
    Promise.prototype.call = function(methodName) {
        var $_len = arguments.length;
        var args = new Array(Math.max($_len - 1, 0));
        for(var $_i = 1; $_i < $_len; ++$_i)args[$_i - 1] = arguments[$_i];
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) return this._then(maybeCaller, undefined, undefined, args, undefined);
        }
        args.push(methodName);
        return this._then(caller, undefined, undefined, args, undefined);
    };
    function namedGetter(obj) {
        return obj[this];
    }
    function indexedGetter(obj) {
        var index = +this;
        if (index < 0) index = Math.max(0, index + obj.length);
        return obj[index];
    }
    Promise.prototype.get = function(propertyName) {
        var isIndex = typeof propertyName === "number";
        var getter;
        if (!isIndex) {
            if (canEvaluate) {
                var maybeGetter = getGetter(propertyName);
                getter = maybeGetter !== null ? maybeGetter : namedGetter;
            } else getter = namedGetter;
        } else getter = indexedGetter;
        return this._then(getter, undefined, undefined, propertyName, undefined);
    };
};

});

parcelRegister("esLGl", function(module, exports) {
"use strict";



module.exports = function(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
    var util = (parcelRequire("gwhLZ"));
    var TypeError = (parcelRequire("8iBp5")).TypeError;
    var inherits = (parcelRequire("gwhLZ")).inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};
    function thrower(e) {
        setTimeout(function() {
            throw e;
        }, 0);
    }
    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) maybePromise._setDisposable(thenable._getDisposer());
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise && maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) return maybePromise._then(iterator, thrower, null, null, null);
            }
            iterator();
        }
        iterator();
        return ret;
    }
    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }
    Disposer.prototype.data = function() {
        return this._data;
    };
    Disposer.prototype.promise = function() {
        return this._promise;
    };
    Disposer.prototype.resource = function() {
        if (this.promise().isFulfilled()) return this.promise().value();
        return NULL;
    };
    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };
    Disposer.isDisposer = function(d) {
        return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
    };
    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);
    FunctionDisposer.prototype.doDispose = function(resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };
    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }
    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length - 1] = null;
    }
    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for(var i = 0; i < len; ++i){
            var item = this[i];
            if (item instanceof Promise) item.cancel();
        }
    };
    Promise.using = function() {
        var len = arguments.length;
        if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for(var i = 0; i < len; ++i){
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                    resources: resources,
                    index: i
                }, undefined);
            }
            resources[i] = resource;
        }
        var reflectedResources = new Array(resources.length);
        for(var i = 0; i < reflectedResources.length; ++i)reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        var resultPromise = Promise.all(reflectedResources).then(function(inspections) {
            for(var i = 0; i < inspections.length; ++i){
                var inspection = inspections[i];
                if (inspection.isRejected()) {
                    errorObj.e = inspection.error();
                    return errorObj;
                } else if (!inspection.isFulfilled()) {
                    resultPromise.cancel();
                    return;
                }
                inspections[i] = inspection.value();
            }
            promise._pushContext();
            fn = tryCatch(fn);
            var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
            var promiseCreated = promise._popContext();
            debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
            return ret;
        });
        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };
    Promise.prototype._setDisposable = function(disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };
    Promise.prototype._isDisposable = function() {
        return (this._bitField & 131072) > 0;
    };
    Promise.prototype._getDisposer = function() {
        return this._disposer;
    };
    Promise.prototype._unsetDisposable = function() {
        this._bitField = this._bitField & -131073;
        this._disposer = undefined;
    };
    Promise.prototype.disposer = function(fn) {
        if (typeof fn === "function") return new FunctionDisposer(fn, this, createContext());
        throw new TypeError();
    };
};

});

parcelRegister("12Uxu", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, debug) {
    var util = (parcelRequire("gwhLZ"));
    var TimeoutError = Promise.TimeoutError;
    function HandleWrapper(handle) {
        this.handle = handle;
    }
    HandleWrapper.prototype._resultCancelled = function() {
        clearTimeout(this.handle);
    };
    var afterValue = function(value) {
        return delay(+this).thenReturn(value);
    };
    var delay = Promise.delay = function(ms, value) {
        var ret;
        var handle;
        if (value !== undefined) {
            ret = Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
            if (debug.cancellation() && value instanceof Promise) ret._setOnCancel(value);
        } else {
            ret = new Promise(INTERNAL);
            handle = setTimeout(function() {
                ret._fulfill();
            }, +ms);
            if (debug.cancellation()) ret._setOnCancel(new HandleWrapper(handle));
            ret._captureStackTrace();
        }
        ret._setAsyncGuaranteed();
        return ret;
    };
    Promise.prototype.delay = function(ms) {
        return delay(ms, this);
    };
    var afterTimeout = function(promise, message, parent) {
        var err;
        if (typeof message !== "string") {
            if (message instanceof Error) err = message;
            else err = new TimeoutError("operation timed out");
        } else err = new TimeoutError(message);
        util.markAsOriginatingFromRejection(err);
        promise._attachExtraTrace(err);
        promise._reject(err);
        if (parent != null) parent.cancel();
    };
    function successClear(value) {
        clearTimeout(this.handle);
        return value;
    }
    function failureClear(reason) {
        clearTimeout(this.handle);
        throw reason;
    }
    Promise.prototype.timeout = function(ms, message) {
        ms = +ms;
        var ret, parent;
        var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
            if (ret.isPending()) afterTimeout(ret, message, parent);
        }, ms));
        if (debug.cancellation()) {
            parent = this.then();
            ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
            ret._setOnCancel(handleWrapper);
        } else ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
        return ret;
    };
};

});

parcelRegister("jwKcE", function(module, exports) {
"use strict";


module.exports = function(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
    var errors = (parcelRequire("8iBp5"));
    var TypeError = errors.TypeError;
    var util = (parcelRequire("gwhLZ"));
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var yieldHandlers = [];
    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
        for(var i = 0; i < yieldHandlers.length; ++i){
            traceParent._pushContext();
            var result = tryCatch(yieldHandlers[i])(value);
            traceParent._popContext();
            if (result === errorObj) {
                traceParent._pushContext();
                var ret = Promise.reject(errorObj.e);
                traceParent._popContext();
                return ret;
            }
            var maybePromise = tryConvertToPromise(result, traceParent);
            if (maybePromise instanceof Promise) return maybePromise;
        }
        return null;
    }
    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
        if (debug.cancellation()) {
            var internal = new Promise(INTERNAL);
            var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
            this._promise = internal.lastly(function() {
                return _finallyPromise;
            });
            internal._captureStackTrace();
            internal._setOnCancel(this);
        } else {
            var promise = this._promise = new Promise(INTERNAL);
            promise._captureStackTrace();
        }
        this._stack = stack;
        this._generatorFunction = generatorFunction;
        this._receiver = receiver;
        this._generator = undefined;
        this._yieldHandlers = typeof yieldHandler === "function" ? [
            yieldHandler
        ].concat(yieldHandlers) : yieldHandlers;
        this._yieldedPromise = null;
        this._cancellationPhase = false;
    }
    util.inherits(PromiseSpawn, Proxyable);
    PromiseSpawn.prototype._isResolved = function() {
        return this._promise === null;
    };
    PromiseSpawn.prototype._cleanup = function() {
        this._promise = this._generator = null;
        if (debug.cancellation() && this._finallyPromise !== null) {
            this._finallyPromise._fulfill();
            this._finallyPromise = null;
        }
    };
    PromiseSpawn.prototype._promiseCancelled = function() {
        if (this._isResolved()) return;
        var implementsReturn = typeof this._generator["return"] !== "undefined";
        var result;
        if (!implementsReturn) {
            var reason = new Promise.CancellationError("generator .return() sentinel");
            Promise.coroutine.returnSentinel = reason;
            this._promise._attachExtraTrace(reason);
            this._promise._pushContext();
            result = tryCatch(this._generator["throw"]).call(this._generator, reason);
            this._promise._popContext();
        } else {
            this._promise._pushContext();
            result = tryCatch(this._generator["return"]).call(this._generator, undefined);
            this._promise._popContext();
        }
        this._cancellationPhase = true;
        this._yieldedPromise = null;
        this._continue(result);
    };
    PromiseSpawn.prototype._promiseFulfilled = function(value) {
        this._yieldedPromise = null;
        this._promise._pushContext();
        var result = tryCatch(this._generator.next).call(this._generator, value);
        this._promise._popContext();
        this._continue(result);
    };
    PromiseSpawn.prototype._promiseRejected = function(reason) {
        this._yieldedPromise = null;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
        this._promise._popContext();
        this._continue(result);
    };
    PromiseSpawn.prototype._resultCancelled = function() {
        if (this._yieldedPromise instanceof Promise) {
            var promise = this._yieldedPromise;
            this._yieldedPromise = null;
            promise.cancel();
        }
    };
    PromiseSpawn.prototype.promise = function() {
        return this._promise;
    };
    PromiseSpawn.prototype._run = function() {
        this._generator = this._generatorFunction.call(this._receiver);
        this._receiver = this._generatorFunction = undefined;
        this._promiseFulfilled(undefined);
    };
    PromiseSpawn.prototype._continue = function(result) {
        var promise = this._promise;
        if (result === errorObj) {
            this._cleanup();
            if (this._cancellationPhase) return promise.cancel();
            else return promise._rejectCallback(result.e, false);
        }
        var value = result.value;
        if (result.done === true) {
            this._cleanup();
            if (this._cancellationPhase) return promise.cancel();
            else return promise._resolveCallback(value);
        } else {
            var maybePromise = tryConvertToPromise(value, this._promise);
            if (!(maybePromise instanceof Promise)) {
                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                if (maybePromise === null) {
                    this._promiseRejected(new TypeError("A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", value) + "From coroutine:\u000a" + this._stack.split("\n").slice(1, -7).join("\n")));
                    return;
                }
            }
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            if ((bitField & 50397184) === 0) {
                this._yieldedPromise = maybePromise;
                maybePromise._proxy(this, null);
            } else if ((bitField & 33554432) !== 0) Promise._async.invoke(this._promiseFulfilled, this, maybePromise._value());
            else if ((bitField & 16777216) !== 0) Promise._async.invoke(this._promiseRejected, this, maybePromise._reason());
            else this._promiseCancelled();
        }
    };
    Promise.coroutine = function(generatorFunction, options) {
        if (typeof generatorFunction !== "function") throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var yieldHandler = Object(options).yieldHandler;
        var PromiseSpawn$ = PromiseSpawn;
        var stack = new Error().stack;
        return function() {
            var generator = generatorFunction.apply(this, arguments);
            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
            var ret = spawn.promise();
            spawn._generator = generator;
            spawn._promiseFulfilled(undefined);
            return ret;
        };
    };
    Promise.coroutine.addYieldHandler = function(fn) {
        if (typeof fn !== "function") throw new TypeError("expecting a function but got " + util.classString(fn));
        yieldHandlers.push(fn);
    };
    Promise.spawn = function(generatorFunction) {
        debug.deprecated("Promise.spawn()", "Promise.coroutine()");
        if (typeof generatorFunction !== "function") return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var spawn = new PromiseSpawn(generatorFunction, this);
        var ret = spawn.promise();
        spawn._run(Promise.spawn);
        return ret;
    };
};

});

parcelRegister("5cDyD", function(module, exports) {
"use strict";

module.exports = function(Promise) {
    var util = (parcelRequire("gwhLZ"));
    var async = Promise._async;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    function spreadAdapter(val, nodeback) {
        var promise = this;
        if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
        var ret = tryCatch(nodeback).apply(promise._boundValue(), [
            null
        ].concat(val));
        if (ret === errorObj) async.throwLater(ret.e);
    }
    function successAdapter(val, nodeback) {
        var promise = this;
        var receiver = promise._boundValue();
        var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
        if (ret === errorObj) async.throwLater(ret.e);
    }
    function errorAdapter(reason, nodeback) {
        var promise = this;
        if (!reason) {
            var newReason = new Error(reason + "");
            newReason.cause = reason;
            reason = newReason;
        }
        var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
        if (ret === errorObj) async.throwLater(ret.e);
    }
    Promise.prototype.asCallback = Promise.prototype.nodeify = function(nodeback, options) {
        if (typeof nodeback == "function") {
            var adapter = successAdapter;
            if (options !== undefined && Object(options).spread) adapter = spreadAdapter;
            this._then(adapter, errorAdapter, undefined, this, nodeback);
        }
        return this;
    };
};

});

parcelRegister("hGrtj", function(module, exports) {
"use strict";



module.exports = function(Promise, INTERNAL) {
    var THIS = {};
    var util = (parcelRequire("gwhLZ"));
    var nodebackForPromise = (parcelRequire("D39zY"));
    var withAppended = util.withAppended;
    var maybeWrapAsError = util.maybeWrapAsError;
    var canEvaluate = util.canEvaluate;
    var TypeError = (parcelRequire("8iBp5")).TypeError;
    var defaultSuffix = "Async";
    var defaultPromisified = {
        __isPromisified__: true
    };
    var noCopyProps = [
        "arity",
        "length",
        "name",
        "arguments",
        "caller",
        "callee",
        "prototype",
        "__isPromisified__"
    ];
    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
    var defaultFilter = function(name) {
        return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
    };
    function propsFilter(key) {
        return !noCopyPropsPattern.test(key);
    }
    function isPromisified(fn) {
        try {
            return fn.__isPromisified__ === true;
        } catch (e) {
            return false;
        }
    }
    function hasPromisified(obj, key, suffix) {
        var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
        return val ? isPromisified(val) : false;
    }
    function checkValid(ret, suffix, suffixRegexp) {
        for(var i = 0; i < ret.length; i += 2){
            var key = ret[i];
            if (suffixRegexp.test(key)) {
                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                for(var j = 0; j < ret.length; j += 2){
                    if (ret[j] === keyWithoutAsyncSuffix) throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a".replace("%s", suffix));
                }
            }
        }
    }
    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
        var keys = util.inheritedDataKeys(obj);
        var ret = [];
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            var value = obj[key];
            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) ret.push(key, value);
        }
        checkValid(ret, suffix, suffixRegexp);
        return ret;
    }
    var escapeIdentRegex = function(str) {
        return str.replace(/([$])/, "\\$");
    };
    var makeNodePromisifiedEval;
    var switchCaseArgumentOrder = function(likelyArgumentCount) {
        var ret = [
            likelyArgumentCount
        ];
        var min = Math.max(0, likelyArgumentCount - 1 - 3);
        for(var i = likelyArgumentCount - 1; i >= min; --i)ret.push(i);
        for(var i = likelyArgumentCount + 1; i <= 3; ++i)ret.push(i);
        return ret;
    };
    var argumentSequence = function(argumentCount) {
        return util.filledRange(argumentCount, "_arg", "");
    };
    var parameterDeclaration = function(parameterCount) {
        return util.filledRange(Math.max(parameterCount, 3), "_arg", "");
    };
    var parameterCount = function(fn) {
        if (typeof fn.length === "number") return Math.max(Math.min(fn.length, 1024), 0);
        return 0;
    };
    makeNodePromisifiedEval = function(callback, receiver, originalName, fn, _, multiArgs) {
        var newParameterCount = Math.max(0, parameterCount(fn) - 1);
        var argumentOrder = switchCaseArgumentOrder(newParameterCount);
        var shouldProxyThis = typeof callback === "string" || receiver === THIS;
        function generateCallForArgumentCount(count) {
            var args = argumentSequence(count).join(", ");
            var comma = count > 0 ? ", " : "";
            var ret;
            if (shouldProxyThis) ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
            else ret = receiver === undefined ? "ret = callback({{args}}, nodeback); break;\n" : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
            return ret.replace("{{args}}", args).replace(", ", comma);
        }
        function generateArgumentSwitchCase() {
            var ret = "";
            for(var i = 0; i < argumentOrder.length; ++i)ret += "case " + argumentOrder[i] + ":" + generateCallForArgumentCount(argumentOrder[i]);
            ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", shouldProxyThis ? "ret = callback.apply(this, args);\n" : "ret = callback.apply(receiver, args);\n");
            return ret;
        }
        var getFunctionCode = typeof callback === "string" ? "this != null ? this['" + callback + "'] : fn" : "fn";
        var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase()).replace("[GetFunctionCode]", getFunctionCode);
        body = body.replace("Parameters", parameterDeclaration(newParameterCount));
        return new Function("Promise", "fn", "receiver", "withAppended", "maybeWrapAsError", "nodebackForPromise", "tryCatch", "errorObj", "notEnumerableProp", "INTERNAL", body)(Promise, fn, receiver, withAppended, maybeWrapAsError, nodebackForPromise, util.tryCatch, util.errorObj, util.notEnumerableProp, INTERNAL);
    };
    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
        var defaultThis = function() {
            return this;
        }();
        var method = callback;
        if (typeof method === "string") callback = fn;
        function promisified() {
            var _receiver = receiver;
            if (receiver === THIS) _receiver = this;
            var promise = new Promise(INTERNAL);
            promise._captureStackTrace();
            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
            var fn = nodebackForPromise(promise, multiArgs);
            try {
                cb.apply(_receiver, withAppended(arguments, fn));
            } catch (e) {
                promise._rejectCallback(maybeWrapAsError(e), true, true);
            }
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
            return promise;
        }
        util.notEnumerableProp(promisified, "__isPromisified__", true);
        return promisified;
    }
    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
        var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
        var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
        for(var i = 0, len = methods.length; i < len; i += 2){
            var key = methods[i];
            var fn = methods[i + 1];
            var promisifiedKey = key + suffix;
            if (promisifier === makeNodePromisified) obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
            else {
                var promisified = promisifier(fn, function() {
                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                });
                util.notEnumerableProp(promisified, "__isPromisified__", true);
                obj[promisifiedKey] = promisified;
            }
        }
        util.toFastProperties(obj);
        return obj;
    }
    function promisify(callback, receiver, multiArgs) {
        return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
    }
    Promise.promisify = function(fn, options) {
        if (typeof fn !== "function") throw new TypeError("expecting a function but got " + util.classString(fn));
        if (isPromisified(fn)) return fn;
        options = Object(options);
        var receiver = options.context === undefined ? THIS : options.context;
        var multiArgs = !!options.multiArgs;
        var ret = promisify(fn, receiver, multiArgs);
        util.copyDescriptors(fn, ret, propsFilter);
        return ret;
    };
    Promise.promisifyAll = function(target, options) {
        if (typeof target !== "function" && typeof target !== "object") throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        options = Object(options);
        var multiArgs = !!options.multiArgs;
        var suffix = options.suffix;
        if (typeof suffix !== "string") suffix = defaultSuffix;
        var filter = options.filter;
        if (typeof filter !== "function") filter = defaultFilter;
        var promisifier = options.promisifier;
        if (typeof promisifier !== "function") promisifier = makeNodePromisified;
        if (!util.isIdentifier(suffix)) throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var keys = util.inheritedDataKeys(target);
        for(var i = 0; i < keys.length; ++i){
            var value = target[keys[i]];
            if (keys[i] !== "constructor" && util.isClass(value)) {
                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                promisifyAll(value, suffix, filter, promisifier, multiArgs);
            }
        }
        return promisifyAll(target, suffix, filter, promisifier, multiArgs);
    };
};

});

parcelRegister("5pXF9", function(module, exports) {
"use strict";


module.exports = function(Promise, PromiseArray, tryConvertToPromise, apiRejection) {
    var util = (parcelRequire("gwhLZ"));
    var isObject = util.isObject;
    var es5 = (parcelRequire("4Ys6H"));
    var Es6Map;
    if (typeof Map === "function") Es6Map = Map;
    var mapToEntries = function() {
        var index = 0;
        var size = 0;
        function extractEntry(value, key) {
            this[index] = value;
            this[index + size] = key;
            index++;
        }
        return function mapToEntries(map) {
            size = map.size;
            index = 0;
            var ret = new Array(map.size * 2);
            map.forEach(extractEntry, ret);
            return ret;
        };
    }();
    var entriesToMap = function(entries) {
        var ret = new Es6Map();
        var length = entries.length / 2 | 0;
        for(var i = 0; i < length; ++i){
            var key = entries[length + i];
            var value = entries[i];
            ret.set(key, value);
        }
        return ret;
    };
    function PropertiesPromiseArray(obj) {
        var isMap = false;
        var entries;
        if (Es6Map !== undefined && obj instanceof Es6Map) {
            entries = mapToEntries(obj);
            isMap = true;
        } else {
            var keys = es5.keys(obj);
            var len = keys.length;
            entries = new Array(len * 2);
            for(var i = 0; i < len; ++i){
                var key = keys[i];
                entries[i] = obj[key];
                entries[i + len] = key;
            }
        }
        this.constructor$(entries);
        this._isMap = isMap;
        this._init$(undefined, -3);
    }
    util.inherits(PropertiesPromiseArray, PromiseArray);
    PropertiesPromiseArray.prototype._init = function() {};
    PropertiesPromiseArray.prototype._promiseFulfilled = function(value, index) {
        this._values[index] = value;
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= this._length) {
            var val;
            if (this._isMap) val = entriesToMap(this._values);
            else {
                val = {};
                var keyOffset = this.length();
                for(var i = 0, len = this.length(); i < len; ++i)val[this._values[i + keyOffset]] = this._values[i];
            }
            this._resolve(val);
            return true;
        }
        return false;
    };
    PropertiesPromiseArray.prototype.shouldCopyValues = function() {
        return false;
    };
    PropertiesPromiseArray.prototype.getActualLength = function(len) {
        return len >> 1;
    };
    function props(promises) {
        var ret;
        var castValue = tryConvertToPromise(promises);
        if (!isObject(castValue)) return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        else if (castValue instanceof Promise) ret = castValue._then(Promise.props, undefined, undefined, undefined, undefined);
        else ret = new PropertiesPromiseArray(castValue).promise();
        if (castValue instanceof Promise) ret._propagateFrom(castValue, 2);
        return ret;
    }
    Promise.prototype.props = function() {
        return props(this);
    };
    Promise.props = function(promises) {
        return props(promises);
    };
};

});

parcelRegister("kcs7Z", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, tryConvertToPromise, apiRejection) {
    var util = (parcelRequire("gwhLZ"));
    var raceLater = function(promise) {
        return promise.then(function(array) {
            return race(array, promise);
        });
    };
    function race(promises, parent) {
        var maybePromise = tryConvertToPromise(promises);
        if (maybePromise instanceof Promise) return raceLater(maybePromise);
        else {
            promises = util.asArray(promises);
            if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
        }
        var ret = new Promise(INTERNAL);
        if (parent !== undefined) ret._propagateFrom(parent, 3);
        var fulfill = ret._fulfill;
        var reject = ret._reject;
        for(var i = 0, len = promises.length; i < len; ++i){
            var val = promises[i];
            if (val === undefined && !(i in promises)) continue;
            Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
        }
        return ret;
    }
    Promise.race = function(promises) {
        return race(promises, undefined);
    };
    Promise.prototype.race = function() {
        return race(this, undefined);
    };
};

});

parcelRegister("lnjFX", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
    var getDomain = Promise._getDomain;
    var util = (parcelRequire("gwhLZ"));
    var tryCatch = util.tryCatch;
    function ReductionPromiseArray(promises, fn, initialValue, _each) {
        this.constructor$(promises);
        var domain = getDomain();
        this._fn = domain === null ? fn : util.domainBind(domain, fn);
        if (initialValue !== undefined) {
            initialValue = Promise.resolve(initialValue);
            initialValue._attachCancellationCallback(this);
        }
        this._initialValue = initialValue;
        this._currentCancellable = null;
        if (_each === INTERNAL) this._eachValues = Array(this._length);
        else if (_each === 0) this._eachValues = null;
        else this._eachValues = undefined;
        this._promise._captureStackTrace();
        this._init$(undefined, -5);
    }
    util.inherits(ReductionPromiseArray, PromiseArray);
    ReductionPromiseArray.prototype._gotAccum = function(accum) {
        if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) this._eachValues.push(accum);
    };
    ReductionPromiseArray.prototype._eachComplete = function(value) {
        if (this._eachValues !== null) this._eachValues.push(value);
        return this._eachValues;
    };
    ReductionPromiseArray.prototype._init = function() {};
    ReductionPromiseArray.prototype._resolveEmptyArray = function() {
        this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
    };
    ReductionPromiseArray.prototype.shouldCopyValues = function() {
        return false;
    };
    ReductionPromiseArray.prototype._resolve = function(value) {
        this._promise._resolveCallback(value);
        this._values = null;
    };
    ReductionPromiseArray.prototype._resultCancelled = function(sender) {
        if (sender === this._initialValue) return this._cancel();
        if (this._isResolved()) return;
        this._resultCancelled$();
        if (this._currentCancellable instanceof Promise) this._currentCancellable.cancel();
        if (this._initialValue instanceof Promise) this._initialValue.cancel();
    };
    ReductionPromiseArray.prototype._iterate = function(values) {
        this._values = values;
        var value;
        var i;
        var length = values.length;
        if (this._initialValue !== undefined) {
            value = this._initialValue;
            i = 0;
        } else {
            value = Promise.resolve(values[0]);
            i = 1;
        }
        this._currentCancellable = value;
        if (!value.isRejected()) for(; i < length; ++i){
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
        if (this._eachValues !== undefined) value = value._then(this._eachComplete, undefined, undefined, this, undefined);
        value._then(completed, completed, undefined, value, this);
    };
    Promise.prototype.reduce = function(fn, initialValue) {
        return reduce(this, fn, initialValue, null);
    };
    Promise.reduce = function(promises, fn, initialValue, _each) {
        return reduce(promises, fn, initialValue, _each);
    };
    function completed(valueOrReason, array) {
        if (this.isFulfilled()) array._resolve(valueOrReason);
        else array._reject(valueOrReason);
    }
    function reduce(promises, fn, initialValue, _each) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
        return array.promise();
    }
    function gotAccum(accum) {
        this.accum = accum;
        this.array._gotAccum(accum);
        var value = tryConvertToPromise(this.value, this.array._promise);
        if (value instanceof Promise) {
            this.array._currentCancellable = value;
            return value._then(gotValue, undefined, undefined, this, undefined);
        } else return gotValue.call(this, value);
    }
    function gotValue(value) {
        var array = this.array;
        var promise = array._promise;
        var fn = tryCatch(array._fn);
        promise._pushContext();
        var ret;
        if (array._eachValues !== undefined) ret = fn.call(promise._boundValue(), value, this.index, this.length);
        else ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
        if (ret instanceof Promise) array._currentCancellable = ret;
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
        return ret;
    }
};

});

parcelRegister("h6MiK", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, debug) {
    var PromiseInspection = Promise.PromiseInspection;
    var util = (parcelRequire("gwhLZ"));
    function SettledPromiseArray(values) {
        this.constructor$(values);
    }
    util.inherits(SettledPromiseArray, PromiseArray);
    SettledPromiseArray.prototype._promiseResolved = function(index, inspection) {
        this._values[index] = inspection;
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= this._length) {
            this._resolve(this._values);
            return true;
        }
        return false;
    };
    SettledPromiseArray.prototype._promiseFulfilled = function(value, index) {
        var ret = new PromiseInspection();
        ret._bitField = 33554432;
        ret._settledValueField = value;
        return this._promiseResolved(index, ret);
    };
    SettledPromiseArray.prototype._promiseRejected = function(reason, index) {
        var ret = new PromiseInspection();
        ret._bitField = 16777216;
        ret._settledValueField = reason;
        return this._promiseResolved(index, ret);
    };
    Promise.settle = function(promises) {
        debug.deprecated(".settle()", ".reflect()");
        return new SettledPromiseArray(promises).promise();
    };
    Promise.prototype.settle = function() {
        return Promise.settle(this);
    };
};

});

parcelRegister("2umIb", function(module, exports) {
"use strict";



module.exports = function(Promise, PromiseArray, apiRejection) {
    var util = (parcelRequire("gwhLZ"));
    var RangeError = (parcelRequire("8iBp5")).RangeError;
    var AggregateError = (parcelRequire("8iBp5")).AggregateError;
    var isArray = util.isArray;
    var CANCELLATION = {};
    function SomePromiseArray(values) {
        this.constructor$(values);
        this._howMany = 0;
        this._unwrap = false;
        this._initialized = false;
    }
    util.inherits(SomePromiseArray, PromiseArray);
    SomePromiseArray.prototype._init = function() {
        if (!this._initialized) return;
        if (this._howMany === 0) {
            this._resolve([]);
            return;
        }
        this._init$(undefined, -5);
        var isArrayResolved = isArray(this._values);
        if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) this._reject(this._getRangeError(this.length()));
    };
    SomePromiseArray.prototype.init = function() {
        this._initialized = true;
        this._init();
    };
    SomePromiseArray.prototype.setUnwrap = function() {
        this._unwrap = true;
    };
    SomePromiseArray.prototype.howMany = function() {
        return this._howMany;
    };
    SomePromiseArray.prototype.setHowMany = function(count) {
        this._howMany = count;
    };
    SomePromiseArray.prototype._promiseFulfilled = function(value) {
        this._addFulfilled(value);
        if (this._fulfilled() === this.howMany()) {
            this._values.length = this.howMany();
            if (this.howMany() === 1 && this._unwrap) this._resolve(this._values[0]);
            else this._resolve(this._values);
            return true;
        }
        return false;
    };
    SomePromiseArray.prototype._promiseRejected = function(reason) {
        this._addRejected(reason);
        return this._checkOutcome();
    };
    SomePromiseArray.prototype._promiseCancelled = function() {
        if (this._values instanceof Promise || this._values == null) return this._cancel();
        this._addRejected(CANCELLATION);
        return this._checkOutcome();
    };
    SomePromiseArray.prototype._checkOutcome = function() {
        if (this.howMany() > this._canPossiblyFulfill()) {
            var e = new AggregateError();
            for(var i = this.length(); i < this._values.length; ++i)if (this._values[i] !== CANCELLATION) e.push(this._values[i]);
            if (e.length > 0) this._reject(e);
            else this._cancel();
            return true;
        }
        return false;
    };
    SomePromiseArray.prototype._fulfilled = function() {
        return this._totalResolved;
    };
    SomePromiseArray.prototype._rejected = function() {
        return this._values.length - this.length();
    };
    SomePromiseArray.prototype._addRejected = function(reason) {
        this._values.push(reason);
    };
    SomePromiseArray.prototype._addFulfilled = function(value) {
        this._values[this._totalResolved++] = value;
    };
    SomePromiseArray.prototype._canPossiblyFulfill = function() {
        return this.length() - this._rejected();
    };
    SomePromiseArray.prototype._getRangeError = function(count) {
        var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
        return new RangeError(message);
    };
    SomePromiseArray.prototype._resolveEmptyArray = function() {
        this._reject(this._getRangeError(0));
    };
    function some(promises, howMany) {
        if ((howMany | 0) !== howMany || howMany < 0) return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var ret = new SomePromiseArray(promises);
        var promise = ret.promise();
        ret.setHowMany(howMany);
        ret.init();
        return promise;
    }
    Promise.some = function(promises, howMany) {
        return some(promises, howMany);
    };
    Promise.prototype.some = function(howMany) {
        return some(this, howMany);
    };
    Promise._SomePromiseArray = SomePromiseArray;
};

});

parcelRegister("kTmEu", function(module, exports) {
"use strict";
module.exports = function(Promise, INTERNAL) {
    var PromiseMap = Promise.map;
    Promise.prototype.filter = function(fn, options) {
        return PromiseMap(this, fn, options, INTERNAL);
    };
    Promise.filter = function(promises, fn, options) {
        return PromiseMap(promises, fn, options, INTERNAL);
    };
};

});

parcelRegister("c3h5Z", function(module, exports) {
"use strict";
module.exports = function(Promise, INTERNAL) {
    var PromiseReduce = Promise.reduce;
    var PromiseAll = Promise.all;
    function promiseAllThis() {
        return PromiseAll(this);
    }
    function PromiseMapSeries(promises, fn) {
        return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
    }
    Promise.prototype.each = function(fn) {
        return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
    };
    Promise.prototype.mapSeries = function(fn) {
        return PromiseReduce(this, fn, INTERNAL, INTERNAL);
    };
    Promise.each = function(promises, fn) {
        return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
    };
    Promise.mapSeries = PromiseMapSeries;
};

});

parcelRegister("jesev", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    var SomePromiseArray = Promise._SomePromiseArray;
    function any(promises) {
        var ret = new SomePromiseArray(promises);
        var promise = ret.promise();
        ret.setHowMany(1);
        ret.setUnwrap();
        ret.init();
        return promise;
    }
    Promise.any = function(promises) {
        return any(promises);
    };
    Promise.prototype.any = function() {
        return any(this);
    };
};

});


parcelRegister("huomN", function(module, exports) {

$parcel$export(module.exports, "readString", function () { return $cbb823b9713d93be$export$dda73877cb166cd3; }, function (v) { return $cbb823b9713d93be$export$dda73877cb166cd3 = v; });
var $cbb823b9713d93be$export$dda73877cb166cd3;

var $lUVKW = parcelRequire("lUVKW");
parcelRequire("eSbtG");
var $6YL8K = parcelRequire("6YL8K");

var $dk6N3 = parcelRequire("dk6N3");

var $cCCVy = parcelRequire("cCCVy");
var $cbb823b9713d93be$var$Element = $cCCVy.Element;
$cbb823b9713d93be$export$dda73877cb166cd3 = $cbb823b9713d93be$var$readString;
var $cbb823b9713d93be$var$Node = $dk6N3.Node;
function $cbb823b9713d93be$var$readString(xmlString, namespaceMap) {
    namespaceMap = namespaceMap || {};
    try {
        var document = $dk6N3.parseFromString(xmlString, "text/xml");
    } catch (error) {
        return $lUVKW.reject(error);
    }
    if (document.documentElement.tagName === "parsererror") return $lUVKW.resolve(new Error(document.documentElement.textContent));
    function convertNode(node) {
        switch(node.nodeType){
            case $cbb823b9713d93be$var$Node.ELEMENT_NODE:
                return convertElement(node);
            case $cbb823b9713d93be$var$Node.TEXT_NODE:
                return $cCCVy.text(node.nodeValue);
        }
    }
    function convertElement(element) {
        var convertedName = convertName(element);
        var convertedChildren = [];
        $6YL8K.default(element.childNodes, function(childNode) {
            var convertedNode = convertNode(childNode);
            if (convertedNode) convertedChildren.push(convertedNode);
        });
        var convertedAttributes = {};
        $6YL8K.default(element.attributes, function(attribute) {
            convertedAttributes[convertName(attribute)] = attribute.value;
        });
        return new $cbb823b9713d93be$var$Element(convertedName, convertedAttributes, convertedChildren);
    }
    function convertName(node) {
        if (node.namespaceURI) {
            var mappedPrefix = namespaceMap[node.namespaceURI];
            var prefix;
            if (mappedPrefix) prefix = mappedPrefix + ":";
            else prefix = "{" + node.namespaceURI + "}";
            return prefix + node.localName;
        } else return node.localName;
    }
    return $lUVKW.resolve(convertNode(document.documentElement));
}

});
parcelRegister("lUVKW", function(module, exports) {

$parcel$export(module.exports, "when", function () { return $ff4ba11f46a1d60b$export$a55877ca9db47377; }, function (v) { return $ff4ba11f46a1d60b$export$a55877ca9db47377 = v; });
$parcel$export(module.exports, "resolve", function () { return $ff4ba11f46a1d60b$export$f7ad0328861e2f03; }, function (v) { return $ff4ba11f46a1d60b$export$f7ad0328861e2f03 = v; });
$parcel$export(module.exports, "props", function () { return $ff4ba11f46a1d60b$export$8128bb6492cf3de7; }, function (v) { return $ff4ba11f46a1d60b$export$8128bb6492cf3de7 = v; });
$parcel$export(module.exports, "reject", function () { return $ff4ba11f46a1d60b$export$2800f3ceda99eb84; }, function (v) { return $ff4ba11f46a1d60b$export$2800f3ceda99eb84 = v; });
$parcel$export(module.exports, "mapSeries", function () { return $ff4ba11f46a1d60b$export$9a85c32cda85b0dd; }, function (v) { return $ff4ba11f46a1d60b$export$9a85c32cda85b0dd = v; });
$parcel$export(module.exports, "attempt", function () { return $ff4ba11f46a1d60b$export$77f9e426014f6edd; }, function (v) { return $ff4ba11f46a1d60b$export$77f9e426014f6edd = v; });
var $ff4ba11f46a1d60b$export$260e5c0943f31606;
var $ff4ba11f46a1d60b$export$a55877ca9db47377;
var $ff4ba11f46a1d60b$export$f7ad0328861e2f03;
var $ff4ba11f46a1d60b$export$84bf76cd7afc7469;
var $ff4ba11f46a1d60b$export$8128bb6492cf3de7;
var $ff4ba11f46a1d60b$export$2800f3ceda99eb84;
var $ff4ba11f46a1d60b$export$1d1d2ed6b55cf67f;
var $ff4ba11f46a1d60b$export$9a85c32cda85b0dd;
var $ff4ba11f46a1d60b$export$77f9e426014f6edd;
var $ff4ba11f46a1d60b$export$8429d1d5679bc81e;
parcelRequire("eSbtG");
var $1kSpe = parcelRequire("1kSpe");

var $ff4ba11f46a1d60b$var$bluebird = (parcelRequire("dwpdt"))();
$ff4ba11f46a1d60b$export$260e5c0943f31606 = $ff4ba11f46a1d60b$var$defer;
$ff4ba11f46a1d60b$export$a55877ca9db47377 = $ff4ba11f46a1d60b$var$bluebird.resolve;
$ff4ba11f46a1d60b$export$f7ad0328861e2f03 = $ff4ba11f46a1d60b$var$bluebird.resolve;
$ff4ba11f46a1d60b$export$84bf76cd7afc7469 = $ff4ba11f46a1d60b$var$bluebird.all;
$ff4ba11f46a1d60b$export$8128bb6492cf3de7 = $ff4ba11f46a1d60b$var$bluebird.props;
$ff4ba11f46a1d60b$export$2800f3ceda99eb84 = $ff4ba11f46a1d60b$var$bluebird.reject;
$ff4ba11f46a1d60b$export$1d1d2ed6b55cf67f = $ff4ba11f46a1d60b$var$bluebird.promisify;
$ff4ba11f46a1d60b$export$9a85c32cda85b0dd = $ff4ba11f46a1d60b$var$bluebird.mapSeries;
$ff4ba11f46a1d60b$export$77f9e426014f6edd = $ff4ba11f46a1d60b$var$bluebird.attempt;
$ff4ba11f46a1d60b$export$8429d1d5679bc81e = function(func) {
    var args = Array.prototype.slice.call(arguments, 1);
    var promisedFunc = $ff4ba11f46a1d60b$var$bluebird.promisify(func);
    return promisedFunc.apply(null, args);
};
$ff4ba11f46a1d60b$var$bluebird.prototype.fail = $ff4ba11f46a1d60b$var$bluebird.prototype.caught;
$ff4ba11f46a1d60b$var$bluebird.prototype.also = function(func) {
    return this.then(function(value) {
        var returnValue = $1kSpe.default({}, value, func(value));
        return $ff4ba11f46a1d60b$var$bluebird.props(returnValue);
    });
};
function $ff4ba11f46a1d60b$var$defer() {
    var resolve;
    var reject;
    var promise = new $ff4ba11f46a1d60b$var$bluebird.Promise(function(resolveArg, rejectArg) {
        resolve = resolveArg;
        reject = rejectArg;
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise
    };
}

});
parcelRegister("eSbtG", function(module, exports) {
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.

var $0E0qW = parcelRequire("0E0qW");

var $anMz3 = parcelRequire("anMz3");
$parcel$exportWildcard(module.exports, $anMz3);

});
parcelRegister("0E0qW", function(module, exports) {
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
parcelRequire("anMz3");
var $cpls5 = parcelRequire("cpls5");
var $anMz3 = parcelRequire("anMz3");
// Add all of the Underscore functions to the wrapper object.
var $001f088f10fed04b$var$_ = (0, $cpls5.default)($anMz3);
// Legacy Node.js API.
$001f088f10fed04b$var$_._ = $001f088f10fed04b$var$_;
var // Export the Underscore API.
$001f088f10fed04b$export$2e2bcd8739ae039 = $001f088f10fed04b$var$_;

});
parcelRegister("anMz3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VERSION", function () { return (parcelRequire("37Qb5")).VERSION; });
$parcel$export(module.exports, "restArguments", function () { return (parcelRequire("5IPcr")).default; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("fwv49")).default; });
$parcel$export(module.exports, "isNull", function () { return (parcelRequire("8HrEz")).default; });
$parcel$export(module.exports, "isUndefined", function () { return (parcelRequire("ltf7S")).default; });
$parcel$export(module.exports, "isBoolean", function () { return (parcelRequire("4AbmA")).default; });
$parcel$export(module.exports, "isElement", function () { return (parcelRequire("e1sBD")).default; });
$parcel$export(module.exports, "isString", function () { return (parcelRequire("04NNv")).default; });
$parcel$export(module.exports, "isNumber", function () { return (parcelRequire("3lUvS")).default; });
$parcel$export(module.exports, "isDate", function () { return (parcelRequire("3lcmK")).default; });
$parcel$export(module.exports, "isRegExp", function () { return (parcelRequire("ji05E")).default; });
$parcel$export(module.exports, "isError", function () { return (parcelRequire("hTekK")).default; });
$parcel$export(module.exports, "isSymbol", function () { return (parcelRequire("2U3nB")).default; });
$parcel$export(module.exports, "isArrayBuffer", function () { return (parcelRequire("6Ex6P")).default; });
$parcel$export(module.exports, "isDataView", function () { return (parcelRequire("gmFEj")).default; });
$parcel$export(module.exports, "isArray", function () { return (parcelRequire("iXrUt")).default; });
$parcel$export(module.exports, "isFunction", function () { return (parcelRequire("g4AGd")).default; });
$parcel$export(module.exports, "isArguments", function () { return (parcelRequire("bQBbO")).default; });
$parcel$export(module.exports, "isFinite", function () { return (parcelRequire("6nc3n")).default; });
$parcel$export(module.exports, "isNaN", function () { return (parcelRequire("6xEml")).default; });
$parcel$export(module.exports, "isTypedArray", function () { return (parcelRequire("iOF4y")).default; });
$parcel$export(module.exports, "isEmpty", function () { return (parcelRequire("e99DW")).default; });
$parcel$export(module.exports, "isMatch", function () { return (parcelRequire("NFS00")).default; });
$parcel$export(module.exports, "isEqual", function () { return (parcelRequire("2nWzp")).default; });
$parcel$export(module.exports, "isMap", function () { return (parcelRequire("6BRhG")).default; });
$parcel$export(module.exports, "isWeakMap", function () { return (parcelRequire("kOrIP")).default; });
$parcel$export(module.exports, "isSet", function () { return (parcelRequire("90YCY")).default; });
$parcel$export(module.exports, "isWeakSet", function () { return (parcelRequire("hzWzu")).default; });
$parcel$export(module.exports, "keys", function () { return (parcelRequire("aBvn7")).default; });
$parcel$export(module.exports, "allKeys", function () { return (parcelRequire("gWO4X")).default; });
$parcel$export(module.exports, "values", function () { return (parcelRequire("adQgf")).default; });
$parcel$export(module.exports, "pairs", function () { return (parcelRequire("7q6RL")).default; });
$parcel$export(module.exports, "invert", function () { return (parcelRequire("1OS4y")).default; });
$parcel$export(module.exports, "functions", function () { return (parcelRequire("bHXja")).default; });
$parcel$export(module.exports, "methods", function () { return (parcelRequire("bHXja")).default; });
$parcel$export(module.exports, "extend", function () { return (parcelRequire("1kSpe")).default; });
$parcel$export(module.exports, "extendOwn", function () { return (parcelRequire("1j2TW")).default; });
$parcel$export(module.exports, "assign", function () { return (parcelRequire("1j2TW")).default; });
$parcel$export(module.exports, "defaults", function () { return (parcelRequire("lK2s3")).default; });
$parcel$export(module.exports, "create", function () { return (parcelRequire("6ylWu")).default; });
$parcel$export(module.exports, "clone", function () { return (parcelRequire("4zp9I")).default; });
$parcel$export(module.exports, "tap", function () { return (parcelRequire("8QJv8")).default; });
$parcel$export(module.exports, "get", function () { return (parcelRequire("hR2rh")).default; });
$parcel$export(module.exports, "has", function () { return (parcelRequire("blQap")).default; });
$parcel$export(module.exports, "mapObject", function () { return (parcelRequire("8qblL")).default; });
$parcel$export(module.exports, "identity", function () { return (parcelRequire("khymw")).default; });
$parcel$export(module.exports, "constant", function () { return (parcelRequire("b9gV1")).default; });
$parcel$export(module.exports, "noop", function () { return (parcelRequire("aXh6e")).default; });
$parcel$export(module.exports, "toPath", function () { return (parcelRequire("9gvBp")).default; });
$parcel$export(module.exports, "property", function () { return (parcelRequire("4s03j")).default; });
$parcel$export(module.exports, "propertyOf", function () { return (parcelRequire("5A4MA")).default; });
$parcel$export(module.exports, "matcher", function () { return (parcelRequire("4xNbh")).default; });
$parcel$export(module.exports, "matches", function () { return (parcelRequire("4xNbh")).default; });
$parcel$export(module.exports, "times", function () { return (parcelRequire("3akHm")).default; });
$parcel$export(module.exports, "random", function () { return (parcelRequire("dlR7J")).default; });
$parcel$export(module.exports, "now", function () { return (parcelRequire("6vrf4")).default; });
$parcel$export(module.exports, "escape", function () { return (parcelRequire("2PZuG")).default; });
$parcel$export(module.exports, "unescape", function () { return (parcelRequire("gyHqX")).default; });
$parcel$export(module.exports, "templateSettings", function () { return (parcelRequire("WZ5tW")).default; });
$parcel$export(module.exports, "template", function () { return (parcelRequire("biLCB")).default; });
$parcel$export(module.exports, "result", function () { return (parcelRequire("doxTs")).default; });
$parcel$export(module.exports, "uniqueId", function () { return (parcelRequire("ktm5J")).default; });
$parcel$export(module.exports, "chain", function () { return (parcelRequire("9tPuy")).default; });
$parcel$export(module.exports, "iteratee", function () { return (parcelRequire("6FZW9")).default; });
$parcel$export(module.exports, "partial", function () { return (parcelRequire("53HbL")).default; });
$parcel$export(module.exports, "bind", function () { return (parcelRequire("5LiiG")).default; });
$parcel$export(module.exports, "bindAll", function () { return (parcelRequire("ftoIz")).default; });
$parcel$export(module.exports, "memoize", function () { return (parcelRequire("gOLnz")).default; });
$parcel$export(module.exports, "delay", function () { return (parcelRequire("hHUwS")).default; });
$parcel$export(module.exports, "defer", function () { return (parcelRequire("gKMii")).default; });
$parcel$export(module.exports, "throttle", function () { return (parcelRequire("1WA9G")).default; });
$parcel$export(module.exports, "debounce", function () { return (parcelRequire("gE85z")).default; });
$parcel$export(module.exports, "wrap", function () { return (parcelRequire("cL6lC")).default; });
$parcel$export(module.exports, "negate", function () { return (parcelRequire("abVpn")).default; });
$parcel$export(module.exports, "compose", function () { return (parcelRequire("edpsq")).default; });
$parcel$export(module.exports, "after", function () { return (parcelRequire("9uZPt")).default; });
$parcel$export(module.exports, "before", function () { return (parcelRequire("7HMvI")).default; });
$parcel$export(module.exports, "once", function () { return (parcelRequire("e6vvn")).default; });
$parcel$export(module.exports, "findKey", function () { return (parcelRequire("bj3e2")).default; });
$parcel$export(module.exports, "findIndex", function () { return (parcelRequire("9YYAC")).default; });
$parcel$export(module.exports, "findLastIndex", function () { return (parcelRequire("k5nEN")).default; });
$parcel$export(module.exports, "sortedIndex", function () { return (parcelRequire("cA3fU")).default; });
$parcel$export(module.exports, "indexOf", function () { return (parcelRequire("4yx50")).default; });
$parcel$export(module.exports, "lastIndexOf", function () { return (parcelRequire("10gKh")).default; });
$parcel$export(module.exports, "find", function () { return (parcelRequire("6dYu1")).default; });
$parcel$export(module.exports, "detect", function () { return (parcelRequire("6dYu1")).default; });
$parcel$export(module.exports, "findWhere", function () { return (parcelRequire("77Oh7")).default; });
$parcel$export(module.exports, "each", function () { return (parcelRequire("6YL8K")).default; });
$parcel$export(module.exports, "forEach", function () { return (parcelRequire("6YL8K")).default; });
$parcel$export(module.exports, "map", function () { return (parcelRequire("apU8A")).default; });
$parcel$export(module.exports, "collect", function () { return (parcelRequire("apU8A")).default; });
$parcel$export(module.exports, "reduce", function () { return (parcelRequire("d6ISG")).default; });
$parcel$export(module.exports, "foldl", function () { return (parcelRequire("d6ISG")).default; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("d6ISG")).default; });
$parcel$export(module.exports, "reduceRight", function () { return (parcelRequire("h3I4T")).default; });
$parcel$export(module.exports, "foldr", function () { return (parcelRequire("h3I4T")).default; });
$parcel$export(module.exports, "filter", function () { return (parcelRequire("e4fgt")).default; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("e4fgt")).default; });
$parcel$export(module.exports, "reject", function () { return (parcelRequire("iWtfe")).default; });
$parcel$export(module.exports, "every", function () { return (parcelRequire("1Frrs")).default; });
$parcel$export(module.exports, "all", function () { return (parcelRequire("1Frrs")).default; });
$parcel$export(module.exports, "some", function () { return (parcelRequire("4PhZa")).default; });
$parcel$export(module.exports, "any", function () { return (parcelRequire("4PhZa")).default; });
$parcel$export(module.exports, "contains", function () { return (parcelRequire("3AjBd")).default; });
$parcel$export(module.exports, "includes", function () { return (parcelRequire("3AjBd")).default; });
$parcel$export(module.exports, "include", function () { return (parcelRequire("3AjBd")).default; });
$parcel$export(module.exports, "invoke", function () { return (parcelRequire("1UMD9")).default; });
$parcel$export(module.exports, "pluck", function () { return (parcelRequire("6yCKd")).default; });
$parcel$export(module.exports, "where", function () { return (parcelRequire("iuwlg")).default; });
$parcel$export(module.exports, "max", function () { return (parcelRequire("6fBin")).default; });
$parcel$export(module.exports, "min", function () { return (parcelRequire("2VQkU")).default; });
$parcel$export(module.exports, "shuffle", function () { return (parcelRequire("dpq6U")).default; });
$parcel$export(module.exports, "sample", function () { return (parcelRequire("6QcNa")).default; });
$parcel$export(module.exports, "sortBy", function () { return (parcelRequire("eE5Rm")).default; });
$parcel$export(module.exports, "groupBy", function () { return (parcelRequire("d2d02")).default; });
$parcel$export(module.exports, "indexBy", function () { return (parcelRequire("6BxOE")).default; });
$parcel$export(module.exports, "countBy", function () { return (parcelRequire("flGPh")).default; });
$parcel$export(module.exports, "partition", function () { return (parcelRequire("lNAB2")).default; });
$parcel$export(module.exports, "toArray", function () { return (parcelRequire("khA8o")).default; });
$parcel$export(module.exports, "size", function () { return (parcelRequire("fhh1h")).default; });
$parcel$export(module.exports, "pick", function () { return (parcelRequire("6z54P")).default; });
$parcel$export(module.exports, "omit", function () { return (parcelRequire("9hu7P")).default; });
$parcel$export(module.exports, "first", function () { return (parcelRequire("ihycS")).default; });
$parcel$export(module.exports, "head", function () { return (parcelRequire("ihycS")).default; });
$parcel$export(module.exports, "take", function () { return (parcelRequire("ihycS")).default; });
$parcel$export(module.exports, "initial", function () { return (parcelRequire("8wtiu")).default; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("bLfRy")).default; });
$parcel$export(module.exports, "rest", function () { return (parcelRequire("hpUIg")).default; });
$parcel$export(module.exports, "tail", function () { return (parcelRequire("hpUIg")).default; });
$parcel$export(module.exports, "drop", function () { return (parcelRequire("hpUIg")).default; });
$parcel$export(module.exports, "compact", function () { return (parcelRequire("8LgiM")).default; });
$parcel$export(module.exports, "flatten", function () { return (parcelRequire("3CMFi")).default; });
$parcel$export(module.exports, "without", function () { return (parcelRequire("cyfya")).default; });
$parcel$export(module.exports, "uniq", function () { return (parcelRequire("7ptoh")).default; });
$parcel$export(module.exports, "unique", function () { return (parcelRequire("7ptoh")).default; });
$parcel$export(module.exports, "union", function () { return (parcelRequire("79ikz")).default; });
$parcel$export(module.exports, "intersection", function () { return (parcelRequire("4ZrUf")).default; });
$parcel$export(module.exports, "difference", function () { return (parcelRequire("k4a10")).default; });
$parcel$export(module.exports, "unzip", function () { return (parcelRequire("lfs4W")).default; });
$parcel$export(module.exports, "transpose", function () { return (parcelRequire("lfs4W")).default; });
$parcel$export(module.exports, "zip", function () { return (parcelRequire("9xwpw")).default; });
$parcel$export(module.exports, "object", function () { return (parcelRequire("1TNXe")).default; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("a0GO7")).default; });
$parcel$export(module.exports, "chunk", function () { return (parcelRequire("9C5sD")).default; });
$parcel$export(module.exports, "mixin", function () { return (parcelRequire("cpls5")).default; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("3yhVi")).default; });
// Named Exports
// =============
//     Underscore.js 1.13.8
//     https://underscorejs.org
//     (c) 2009-2026 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.

var $37Qb5 = parcelRequire("37Qb5");

var $5IPcr = parcelRequire("5IPcr");

var $fwv49 = parcelRequire("fwv49");

var $8HrEz = parcelRequire("8HrEz");

var $ltf7S = parcelRequire("ltf7S");

var $4AbmA = parcelRequire("4AbmA");

var $e1sBD = parcelRequire("e1sBD");

var $04NNv = parcelRequire("04NNv");

var $3lUvS = parcelRequire("3lUvS");

var $3lcmK = parcelRequire("3lcmK");

var $ji05E = parcelRequire("ji05E");

var $hTekK = parcelRequire("hTekK");

var $2U3nB = parcelRequire("2U3nB");

var $6Ex6P = parcelRequire("6Ex6P");

var $gmFEj = parcelRequire("gmFEj");

var $iXrUt = parcelRequire("iXrUt");

var $g4AGd = parcelRequire("g4AGd");

var $bQBbO = parcelRequire("bQBbO");

var $6nc3n = parcelRequire("6nc3n");

var $6xEml = parcelRequire("6xEml");

var $iOF4y = parcelRequire("iOF4y");

var $e99DW = parcelRequire("e99DW");

var $NFS00 = parcelRequire("NFS00");

var $2nWzp = parcelRequire("2nWzp");

var $6BRhG = parcelRequire("6BRhG");

var $kOrIP = parcelRequire("kOrIP");

var $90YCY = parcelRequire("90YCY");

var $hzWzu = parcelRequire("hzWzu");

var $aBvn7 = parcelRequire("aBvn7");

var $gWO4X = parcelRequire("gWO4X");

var $adQgf = parcelRequire("adQgf");

var $7q6RL = parcelRequire("7q6RL");

var $1OS4y = parcelRequire("1OS4y");

var $bHXja = parcelRequire("bHXja");

var $1kSpe = parcelRequire("1kSpe");

var $1j2TW = parcelRequire("1j2TW");

var $lK2s3 = parcelRequire("lK2s3");

var $6ylWu = parcelRequire("6ylWu");

var $4zp9I = parcelRequire("4zp9I");

var $8QJv8 = parcelRequire("8QJv8");

var $hR2rh = parcelRequire("hR2rh");

var $blQap = parcelRequire("blQap");

var $8qblL = parcelRequire("8qblL");

var $khymw = parcelRequire("khymw");

var $b9gV1 = parcelRequire("b9gV1");

var $aXh6e = parcelRequire("aXh6e");

var $9gvBp = parcelRequire("9gvBp");

var $4s03j = parcelRequire("4s03j");

var $5A4MA = parcelRequire("5A4MA");

var $4xNbh = parcelRequire("4xNbh");

var $3akHm = parcelRequire("3akHm");

var $dlR7J = parcelRequire("dlR7J");

var $6vrf4 = parcelRequire("6vrf4");

var $2PZuG = parcelRequire("2PZuG");

var $gyHqX = parcelRequire("gyHqX");

var $WZ5tW = parcelRequire("WZ5tW");

var $biLCB = parcelRequire("biLCB");

var $doxTs = parcelRequire("doxTs");

var $ktm5J = parcelRequire("ktm5J");

var $9tPuy = parcelRequire("9tPuy");

var $6FZW9 = parcelRequire("6FZW9");

var $53HbL = parcelRequire("53HbL");

var $5LiiG = parcelRequire("5LiiG");

var $ftoIz = parcelRequire("ftoIz");

var $gOLnz = parcelRequire("gOLnz");

var $hHUwS = parcelRequire("hHUwS");

var $gKMii = parcelRequire("gKMii");

var $1WA9G = parcelRequire("1WA9G");

var $gE85z = parcelRequire("gE85z");

var $cL6lC = parcelRequire("cL6lC");

var $abVpn = parcelRequire("abVpn");

var $edpsq = parcelRequire("edpsq");

var $9uZPt = parcelRequire("9uZPt");

var $7HMvI = parcelRequire("7HMvI");

var $e6vvn = parcelRequire("e6vvn");

var $bj3e2 = parcelRequire("bj3e2");

var $9YYAC = parcelRequire("9YYAC");

var $k5nEN = parcelRequire("k5nEN");

var $cA3fU = parcelRequire("cA3fU");

var $4yx50 = parcelRequire("4yx50");

var $10gKh = parcelRequire("10gKh");

var $6dYu1 = parcelRequire("6dYu1");

var $77Oh7 = parcelRequire("77Oh7");

var $6YL8K = parcelRequire("6YL8K");

var $apU8A = parcelRequire("apU8A");

var $d6ISG = parcelRequire("d6ISG");

var $h3I4T = parcelRequire("h3I4T");

var $e4fgt = parcelRequire("e4fgt");

var $iWtfe = parcelRequire("iWtfe");

var $1Frrs = parcelRequire("1Frrs");

var $4PhZa = parcelRequire("4PhZa");

var $3AjBd = parcelRequire("3AjBd");

var $1UMD9 = parcelRequire("1UMD9");

var $6yCKd = parcelRequire("6yCKd");

var $iuwlg = parcelRequire("iuwlg");

var $6fBin = parcelRequire("6fBin");

var $2VQkU = parcelRequire("2VQkU");

var $dpq6U = parcelRequire("dpq6U");

var $6QcNa = parcelRequire("6QcNa");

var $eE5Rm = parcelRequire("eE5Rm");

var $d2d02 = parcelRequire("d2d02");

var $6BxOE = parcelRequire("6BxOE");

var $flGPh = parcelRequire("flGPh");

var $lNAB2 = parcelRequire("lNAB2");

var $khA8o = parcelRequire("khA8o");

var $fhh1h = parcelRequire("fhh1h");

var $6z54P = parcelRequire("6z54P");

var $9hu7P = parcelRequire("9hu7P");

var $ihycS = parcelRequire("ihycS");

var $8wtiu = parcelRequire("8wtiu");

var $bLfRy = parcelRequire("bLfRy");

var $hpUIg = parcelRequire("hpUIg");

var $8LgiM = parcelRequire("8LgiM");

var $3CMFi = parcelRequire("3CMFi");

var $cyfya = parcelRequire("cyfya");

var $7ptoh = parcelRequire("7ptoh");

var $79ikz = parcelRequire("79ikz");

var $4ZrUf = parcelRequire("4ZrUf");

var $k4a10 = parcelRequire("k4a10");

var $lfs4W = parcelRequire("lfs4W");

var $9xwpw = parcelRequire("9xwpw");

var $1TNXe = parcelRequire("1TNXe");

var $a0GO7 = parcelRequire("a0GO7");

var $9C5sD = parcelRequire("9C5sD");

var $cpls5 = parcelRequire("cpls5");

var $3yhVi = parcelRequire("3yhVi");

});
parcelRegister("37Qb5", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $246a7ffeabc214e7$export$a4ad2735b021c132; });
$parcel$export(module.exports, "root", function () { return $246a7ffeabc214e7$export$e8e78c978b129247; });
$parcel$export(module.exports, "ArrayProto", function () { return $246a7ffeabc214e7$export$aabeece9448a227a; });
$parcel$export(module.exports, "ObjProto", function () { return $246a7ffeabc214e7$export$e77bb59b5e655b3d; });
$parcel$export(module.exports, "SymbolProto", function () { return $246a7ffeabc214e7$export$e229dcb397ceea81; });
$parcel$export(module.exports, "push", function () { return $246a7ffeabc214e7$export$4cbf152802aa238; });
$parcel$export(module.exports, "slice", function () { return $246a7ffeabc214e7$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "toString", function () { return $246a7ffeabc214e7$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $246a7ffeabc214e7$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "supportsArrayBuffer", function () { return $246a7ffeabc214e7$export$20eaf89d899ede58; });
$parcel$export(module.exports, "supportsDataView", function () { return $246a7ffeabc214e7$export$a2e478ad34dac33e; });
$parcel$export(module.exports, "nativeIsArray", function () { return $246a7ffeabc214e7$export$552cf9b635cef256; });
$parcel$export(module.exports, "nativeKeys", function () { return $246a7ffeabc214e7$export$e676cf06d7fd2114; });
$parcel$export(module.exports, "nativeCreate", function () { return $246a7ffeabc214e7$export$5b53dc95b548c58c; });
$parcel$export(module.exports, "nativeIsView", function () { return $246a7ffeabc214e7$export$35fc70fc5e80d5a7; });
$parcel$export(module.exports, "_isNaN", function () { return $246a7ffeabc214e7$export$a739ba33a90be0a1; });
$parcel$export(module.exports, "_isFinite", function () { return $246a7ffeabc214e7$export$8b48b92f6c9d5ad; });
$parcel$export(module.exports, "hasEnumBug", function () { return $246a7ffeabc214e7$export$7dcea4d27900b116; });
$parcel$export(module.exports, "nonEnumerableProps", function () { return $246a7ffeabc214e7$export$f8fa596d5e31cb19; });
$parcel$export(module.exports, "MAX_ARRAY_INDEX", function () { return $246a7ffeabc214e7$export$63b3abc5cd28bc48; });
// Current version.
var $246a7ffeabc214e7$export$a4ad2735b021c132 = '1.13.8';
var $246a7ffeabc214e7$export$e8e78c978b129247 = typeof self == 'object' && self.self === self && self || typeof $parcel$global == 'object' && $parcel$global.global === $parcel$global && $parcel$global || Function('return this')() || {};
var $246a7ffeabc214e7$export$aabeece9448a227a = Array.prototype, $246a7ffeabc214e7$export$e77bb59b5e655b3d = Object.prototype;
var $246a7ffeabc214e7$export$e229dcb397ceea81 = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
var $246a7ffeabc214e7$export$4cbf152802aa238 = $246a7ffeabc214e7$export$aabeece9448a227a.push, $246a7ffeabc214e7$export$58adb3bec8346d0f = $246a7ffeabc214e7$export$aabeece9448a227a.slice, $246a7ffeabc214e7$export$f84e8e69fd4488a5 = $246a7ffeabc214e7$export$e77bb59b5e655b3d.toString, $246a7ffeabc214e7$export$5a15a386532a5ea4 = $246a7ffeabc214e7$export$e77bb59b5e655b3d.hasOwnProperty;
var $246a7ffeabc214e7$export$20eaf89d899ede58 = typeof ArrayBuffer !== 'undefined', $246a7ffeabc214e7$export$a2e478ad34dac33e = typeof DataView !== 'undefined';
var $246a7ffeabc214e7$export$552cf9b635cef256 = Array.isArray, $246a7ffeabc214e7$export$e676cf06d7fd2114 = Object.keys, $246a7ffeabc214e7$export$5b53dc95b548c58c = Object.create, $246a7ffeabc214e7$export$35fc70fc5e80d5a7 = $246a7ffeabc214e7$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $246a7ffeabc214e7$export$a739ba33a90be0a1 = isNaN, $246a7ffeabc214e7$export$8b48b92f6c9d5ad = isFinite;
var $246a7ffeabc214e7$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable('toString');
var $246a7ffeabc214e7$export$f8fa596d5e31cb19 = [
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
var $246a7ffeabc214e7$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;

});

parcelRegister("5IPcr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42a8c6f95dd25bce$export$2e2bcd8739ae039; });
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $42a8c6f95dd25bce$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}

});

parcelRegister("fwv49", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4d1f135e1f2bf83$export$2e2bcd8739ae039; });
// Is a given variable an object?
function $b4d1f135e1f2bf83$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
}

});

parcelRegister("8HrEz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6557ca44e442af39$export$2e2bcd8739ae039; });
// Is a given value equal to null?
function $6557ca44e442af39$export$2e2bcd8739ae039(obj) {
    return obj === null;
}

});

parcelRegister("ltf7S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa180a204499cc91$export$2e2bcd8739ae039; });
// Is a given variable undefined?
function $fa180a204499cc91$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}

});

parcelRegister("4AbmA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $356356ba78929abf$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");
function $356356ba78929abf$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $37Qb5.toString).call(obj) === '[object Boolean]';
}

});

parcelRegister("e1sBD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a357593801fd98ff$export$2e2bcd8739ae039; });
// Is a given value a DOM element?
function $a357593801fd98ff$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}

});

parcelRegister("04NNv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00e7009269b17d0f$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");
var $00e7009269b17d0f$export$2e2bcd8739ae039 = (0, $8Jr3K.default)('String');

});
parcelRegister("8Jr3K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65b784229213f569$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");
function $65b784229213f569$export$2e2bcd8739ae039(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
        return (0, $37Qb5.toString).call(obj) === tag;
    };
}

});


parcelRegister("3lUvS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $270f2b95533c4dee$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");
var $270f2b95533c4dee$export$2e2bcd8739ae039 = (0, $8Jr3K.default)('Number');

});

parcelRegister("3lcmK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26ecece5a0cbf05e$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");
var $26ecece5a0cbf05e$export$2e2bcd8739ae039 = (0, $8Jr3K.default)('Date');

});

parcelRegister("ji05E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0afc4a3aa272bcb$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");
var $e0afc4a3aa272bcb$export$2e2bcd8739ae039 = (0, $8Jr3K.default)('RegExp');

});

parcelRegister("hTekK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d062b115abf9eeb6$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");
var $d062b115abf9eeb6$export$2e2bcd8739ae039 = (0, $8Jr3K.default)('Error');

});

parcelRegister("2U3nB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21d36edf47a630f1$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");
var $21d36edf47a630f1$export$2e2bcd8739ae039 = (0, $8Jr3K.default)('Symbol');

});

parcelRegister("6Ex6P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d80294d0f7cc435$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");
var $4d80294d0f7cc435$export$2e2bcd8739ae039 = (0, $8Jr3K.default)('ArrayBuffer');

});

parcelRegister("gmFEj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be9f02195199efcc$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");

var $g4AGd = parcelRequire("g4AGd");

var $6Ex6P = parcelRequire("6Ex6P");

var $7HJCm = parcelRequire("7HJCm");
var $be9f02195199efcc$var$isDataView = (0, $8Jr3K.default)('DataView');
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
// Also, in cases where the native `DataView` is
// overridden we can't rely on the tag itself.
function $be9f02195199efcc$var$alternateIsDataView(obj) {
    return obj != null && (0, $g4AGd.default)(obj.getInt8) && (0, $6Ex6P.default)(obj.buffer);
}
var $be9f02195199efcc$export$2e2bcd8739ae039 = (0, $7HJCm.hasDataViewBug) ? $be9f02195199efcc$var$alternateIsDataView : $be9f02195199efcc$var$isDataView;

});
parcelRegister("g4AGd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb3978ea87ee584b$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");

var $37Qb5 = parcelRequire("37Qb5");
var $bb3978ea87ee584b$var$isFunction = (0, $8Jr3K.default)('Function');
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $bb3978ea87ee584b$var$nodelist = (0, $37Qb5.root).document && (0, $37Qb5.root).document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof $bb3978ea87ee584b$var$nodelist != 'function') $bb3978ea87ee584b$var$isFunction = function(obj) {
    return typeof obj == 'function' || false;
};
var $bb3978ea87ee584b$export$2e2bcd8739ae039 = $bb3978ea87ee584b$var$isFunction;

});

parcelRegister("7HJCm", function(module, exports) {

$parcel$export(module.exports, "hasDataViewBug", function () { return $59bfef44c4a91118$export$29b9ed4126fa90ab; });
$parcel$export(module.exports, "isIE11", function () { return $59bfef44c4a91118$export$f7bad96d83325a34; });

var $37Qb5 = parcelRequire("37Qb5");

var $lV1l6 = parcelRequire("lV1l6");
var $59bfef44c4a91118$export$29b9ed4126fa90ab = (0, $37Qb5.supportsDataView) && (!/\[native code\]/.test(String(DataView)) || (0, $lV1l6.default)(new DataView(new ArrayBuffer(8)))), $59bfef44c4a91118$export$f7bad96d83325a34 = typeof Map !== 'undefined' && (0, $lV1l6.default)(new Map);

});
parcelRegister("lV1l6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff4ff5ccc6f2cf50$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");
var $ff4ff5ccc6f2cf50$export$2e2bcd8739ae039 = (0, $8Jr3K.default)('Object');

});



parcelRegister("iXrUt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcd3630089eb55c7$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");

var $8Jr3K = parcelRequire("8Jr3K");
var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$dcd3630089eb55c7$export$2e2bcd8739ae039 = (0, $37Qb5.nativeIsArray) || (0, $8Jr3K.default)('Array');

});

parcelRegister("bQBbO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a016615269232d5$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");

var $1ROAV = parcelRequire("1ROAV");
var $8a016615269232d5$var$isArguments = (0, $8Jr3K.default)('Arguments');
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$8a016615269232d5$var$isArguments(arguments)) $8a016615269232d5$var$isArguments = function(obj) {
        return (0, $1ROAV.default)(obj, 'callee');
    };
})();
var $8a016615269232d5$export$2e2bcd8739ae039 = $8a016615269232d5$var$isArguments;

});
parcelRegister("1ROAV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15c1fcb73469f74a$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");
function $15c1fcb73469f74a$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $37Qb5.hasOwnProperty).call(obj, key);
}

});


parcelRegister("6nc3n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a3e3d9d563e2dd2$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");

var $2U3nB = parcelRequire("2U3nB");
function $4a3e3d9d563e2dd2$export$2e2bcd8739ae039(obj) {
    return !(0, $2U3nB.default)(obj) && (0, $37Qb5._isFinite)(obj) && !isNaN(parseFloat(obj));
}

});

parcelRegister("6xEml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c3521b0663b56bf$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");

var $3lUvS = parcelRequire("3lUvS");
function $4c3521b0663b56bf$export$2e2bcd8739ae039(obj) {
    return (0, $3lUvS.default)(obj) && (0, $37Qb5._isNaN)(obj);
}

});

parcelRegister("iOF4y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db2cc1a5424d35ce$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");

var $gmFEj = parcelRequire("gmFEj");

var $b9gV1 = parcelRequire("b9gV1");

var $fZdyH = parcelRequire("fZdyH");
// Is a given value a typed array?
var $db2cc1a5424d35ce$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $db2cc1a5424d35ce$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $37Qb5.nativeIsView) ? (0, $37Qb5.nativeIsView)(obj) && !(0, $gmFEj.default)(obj) : (0, $fZdyH.default)(obj) && $db2cc1a5424d35ce$var$typedArrayPattern.test((0, $37Qb5.toString).call(obj));
}
var $db2cc1a5424d35ce$export$2e2bcd8739ae039 = (0, $37Qb5.supportsArrayBuffer) ? $db2cc1a5424d35ce$var$isTypedArray : (0, $b9gV1.default)(false);

});
parcelRegister("b9gV1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81dda8b3bcd1e3fb$export$2e2bcd8739ae039; });
// Predicate-generating function. Often useful outside of Underscore.
function $81dda8b3bcd1e3fb$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}

});

parcelRegister("fZdyH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba3711f85794c3a4$export$2e2bcd8739ae039; });

var $9wRQj = parcelRequire("9wRQj");

var $g2XPc = parcelRequire("g2XPc");
var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$ba3711f85794c3a4$export$2e2bcd8739ae039 = (0, $9wRQj.default)((0, $g2XPc.default));

});
parcelRegister("9wRQj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f00de425c2c1428$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");
function $6f00de425c2c1428$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= (0, $37Qb5.MAX_ARRAY_INDEX);
    };
}

});

parcelRegister("g2XPc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baeb3d32bb508f3f$export$2e2bcd8739ae039; });

var $16YX1 = parcelRequire("16YX1");
var // Internal helper to obtain the `byteLength` property of an object.
$baeb3d32bb508f3f$export$2e2bcd8739ae039 = (0, $16YX1.default)('byteLength');

});
parcelRegister("16YX1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf5a1939f8e7063$export$2e2bcd8739ae039; });
// Internal helper to generate a function to obtain property `key` from `obj`.
function $0cf5a1939f8e7063$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}

});




parcelRegister("e99DW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4c962eb03ffe718$export$2e2bcd8739ae039; });

var $hnef7 = parcelRequire("hnef7");

var $iXrUt = parcelRequire("iXrUt");

var $04NNv = parcelRequire("04NNv");

var $bQBbO = parcelRequire("bQBbO");

var $aBvn7 = parcelRequire("aBvn7");
function $a4c962eb03ffe718$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $hnef7.default)(obj);
    if (typeof length == 'number' && ((0, $iXrUt.default)(obj) || (0, $04NNv.default)(obj) || (0, $bQBbO.default)(obj))) return length === 0;
    return (0, $hnef7.default)((0, $aBvn7.default)(obj)) === 0;
}

});
parcelRegister("hnef7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca5fa1f958edd822$export$2e2bcd8739ae039; });

var $16YX1 = parcelRequire("16YX1");
var // Internal helper to obtain the `length` property of an object.
$ca5fa1f958edd822$export$2e2bcd8739ae039 = (0, $16YX1.default)('length');

});

parcelRegister("aBvn7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b85b1e1ad63190b$export$2e2bcd8739ae039; });

var $fwv49 = parcelRequire("fwv49");

var $37Qb5 = parcelRequire("37Qb5");

var $1ROAV = parcelRequire("1ROAV");

var $idedA = parcelRequire("idedA");
function $7b85b1e1ad63190b$export$2e2bcd8739ae039(obj) {
    if (!(0, $fwv49.default)(obj)) return [];
    if (0, $37Qb5.nativeKeys) return (0, $37Qb5.nativeKeys)(obj);
    var keys = [];
    for(var key in obj)if ((0, $1ROAV.default)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $37Qb5.hasEnumBug) (0, $idedA.default)(obj, keys);
    return keys;
}

});
parcelRegister("idedA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d42478561a546714$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");

var $g4AGd = parcelRequire("g4AGd");

var $1ROAV = parcelRequire("1ROAV");
// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $d42478561a546714$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key] === true;
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $d42478561a546714$export$2e2bcd8739ae039(obj, keys) {
    keys = $d42478561a546714$var$emulatedSet(keys);
    var nonEnumIdx = (0, $37Qb5.nonEnumerableProps).length;
    var constructor = obj.constructor;
    var proto = (0, $g4AGd.default)(constructor) && constructor.prototype || (0, $37Qb5.ObjProto);
    // Constructor is a special case.
    var prop = 'constructor';
    if ((0, $1ROAV.default)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $37Qb5.nonEnumerableProps)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}

});



parcelRegister("NFS00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09550e37e0e3e99b$export$2e2bcd8739ae039; });

var $aBvn7 = parcelRequire("aBvn7");
function $09550e37e0e3e99b$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $aBvn7.default)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}

});

parcelRegister("2nWzp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bcb298a97649b15$export$2e2bcd8739ae039; });

var $js9rY = parcelRequire("js9rY");

var $37Qb5 = parcelRequire("37Qb5");

var $g2XPc = parcelRequire("g2XPc");

var $iOF4y = parcelRequire("iOF4y");

var $g4AGd = parcelRequire("g4AGd");

var $7HJCm = parcelRequire("7HJCm");

var $gmFEj = parcelRequire("gmFEj");

var $aBvn7 = parcelRequire("aBvn7");

var $1ROAV = parcelRequire("1ROAV");

var $3asqm = parcelRequire("3asqm");
// We use this string twice, so give it a name for minification.
var $1bcb298a97649b15$var$tagDataView = '[object DataView]';
function $1bcb298a97649b15$export$2e2bcd8739ae039(a, b) {
    var todo = [
        {
            a: a,
            b: b
        }
    ];
    // Initializing stacks of traversed objects for cycle detection.
    var aStack = [], bStack = [];
    while(todo.length){
        var frame = todo.pop();
        if (frame === true) {
            // Remove the first object from the stack of traversed objects.
            aStack.pop();
            bStack.pop();
            continue;
        }
        a = frame.a;
        b = frame.b;
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) {
            if (a !== 0 || 1 / a === 1 / b) continue;
            return false;
        }
        // `null` or `undefined` only equal to itself (strict comparison).
        if (a == null || b == null) return false;
        // `NaN`s are equivalent, but non-reflexive.
        if (a !== a) {
            if (b !== b) continue;
            return false;
        }
        // Exhaust primitive checks
        var type = typeof a;
        if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
        // Internal recursive comparison function for `_.isEqual`.
        // Unwrap any wrapped objects.
        if (a instanceof (0, $js9rY.default)) a = a._wrapped;
        if (b instanceof (0, $js9rY.default)) b = b._wrapped;
        // Compare `[[Class]]` names.
        var className = (0, $37Qb5.toString).call(a);
        if (className !== (0, $37Qb5.toString).call(b)) return false;
        // Work around a bug in IE 10 - Edge 13.
        if ((0, $7HJCm.hasDataViewBug) && className == '[object Object]' && (0, $gmFEj.default)(a)) {
            if (!(0, $gmFEj.default)(b)) return false;
            className = $1bcb298a97649b15$var$tagDataView;
        }
        switch(className){
            // These types are compared by value.
            case '[object RegExp]':
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                if ('' + a === '' + b) continue;
                return false;
            case '[object Number]':
                todo.push({
                    a: +a,
                    b: +b
                });
                continue;
            case '[object Date]':
            case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                if (+a === +b) continue;
                return false;
            case '[object Symbol]':
                if ((0, $37Qb5.SymbolProto).valueOf.call(a) === (0, $37Qb5.SymbolProto).valueOf.call(b)) continue;
                return false;
            case '[object ArrayBuffer]':
            case $1bcb298a97649b15$var$tagDataView:
                // Coerce to typed array so we can fall through.
                todo.push({
                    a: (0, $3asqm.default)(a),
                    b: (0, $3asqm.default)(b)
                });
                continue;
        }
        var areArrays = className === '[object Array]';
        if (!areArrays && (0, $iOF4y.default)(a)) {
            var byteLength = (0, $g2XPc.default)(a);
            if (byteLength !== (0, $g2XPc.default)(b)) return false;
            if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) continue;
            areArrays = true;
        }
        if (!areArrays) {
            if (typeof a != 'object' || typeof b != 'object') return false;
            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor, bCtor = b.constructor;
            if (aCtor !== bCtor && !((0, $g4AGd.default)(aCtor) && aCtor instanceof aCtor && (0, $g4AGd.default)(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) return false;
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
        var length = aStack.length;
        while(length--)// Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) {
            if (bStack[length] === b) break;
            return false;
        }
        if (length >= 0) continue;
        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);
        todo.push(true);
        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.
            while(length--)todo.push({
                a: a[length],
                b: b[length]
            });
        } else {
            // Deep compare objects.
            var _keys = (0, $aBvn7.default)(a), key;
            length = _keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if ((0, $aBvn7.default)(b).length !== length) return false;
            while(length--){
                // Deep compare each member
                key = _keys[length];
                if (!(0, $1ROAV.default)(b, key)) return false;
                todo.push({
                    a: a[key],
                    b: b[key]
                });
            }
        }
    }
    return true;
}

});
parcelRegister("js9rY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e297f67a2306c3cc$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");
function $e297f67a2306c3cc$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $e297f67a2306c3cc$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $e297f67a2306c3cc$export$2e2bcd8739ae039)) return new $e297f67a2306c3cc$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$e297f67a2306c3cc$export$2e2bcd8739ae039.VERSION = (0, $37Qb5.VERSION);
// Extracts the result from a wrapped and chained object.
$e297f67a2306c3cc$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$e297f67a2306c3cc$export$2e2bcd8739ae039.prototype.valueOf = $e297f67a2306c3cc$export$2e2bcd8739ae039.prototype.toJSON = $e297f67a2306c3cc$export$2e2bcd8739ae039.prototype.value;
$e297f67a2306c3cc$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};

});

parcelRegister("3asqm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24e85ab8e803454a$export$2e2bcd8739ae039; });

var $g2XPc = parcelRequire("g2XPc");
function $24e85ab8e803454a$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $g2XPc.default)(bufferSource));
}

});


parcelRegister("6BRhG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cff87e7a555c8ce$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");

var $7HJCm = parcelRequire("7HJCm");

var $5GZfA = parcelRequire("5GZfA");
var $4cff87e7a555c8ce$export$2e2bcd8739ae039 = (0, $7HJCm.isIE11) ? (0, $5GZfA.ie11fingerprint)((0, $5GZfA.mapMethods)) : (0, $8Jr3K.default)('Map');

});
parcelRegister("5GZfA", function(module, exports) {

$parcel$export(module.exports, "ie11fingerprint", function () { return $4250630cb0e467b8$export$15230eca1f400e40; });
$parcel$export(module.exports, "weakMapMethods", function () { return $4250630cb0e467b8$export$2f74b890a72cf48; });
$parcel$export(module.exports, "mapMethods", function () { return $4250630cb0e467b8$export$de9acb94190bb764; });
$parcel$export(module.exports, "setMethods", function () { return $4250630cb0e467b8$export$60e14a5e2a057f78; });

var $hnef7 = parcelRequire("hnef7");

var $g4AGd = parcelRequire("g4AGd");

var $gWO4X = parcelRequire("gWO4X");
function $4250630cb0e467b8$export$15230eca1f400e40(methods) {
    var length = (0, $hnef7.default)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $gWO4X.default)(obj);
        if ((0, $hnef7.default)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $g4AGd.default)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $4250630cb0e467b8$export$2f74b890a72cf48 || !(0, $g4AGd.default)(obj[$4250630cb0e467b8$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $4250630cb0e467b8$var$forEachName = 'forEach', $4250630cb0e467b8$var$hasName = 'has', $4250630cb0e467b8$var$commonInit = [
    'clear',
    'delete'
], $4250630cb0e467b8$var$mapTail = [
    'get',
    $4250630cb0e467b8$var$hasName,
    'set'
];
var $4250630cb0e467b8$export$de9acb94190bb764 = $4250630cb0e467b8$var$commonInit.concat($4250630cb0e467b8$var$forEachName, $4250630cb0e467b8$var$mapTail), $4250630cb0e467b8$export$2f74b890a72cf48 = $4250630cb0e467b8$var$commonInit.concat($4250630cb0e467b8$var$mapTail), $4250630cb0e467b8$export$60e14a5e2a057f78 = [
    'add'
].concat($4250630cb0e467b8$var$commonInit, $4250630cb0e467b8$var$forEachName, $4250630cb0e467b8$var$hasName);

});
parcelRegister("gWO4X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c568e8c38b99e73e$export$2e2bcd8739ae039; });

var $fwv49 = parcelRequire("fwv49");

var $37Qb5 = parcelRequire("37Qb5");

var $idedA = parcelRequire("idedA");
function $c568e8c38b99e73e$export$2e2bcd8739ae039(obj) {
    if (!(0, $fwv49.default)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $37Qb5.hasEnumBug) (0, $idedA.default)(obj, keys);
    return keys;
}

});



parcelRegister("kOrIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f26dfb2c46399397$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");

var $7HJCm = parcelRequire("7HJCm");

var $5GZfA = parcelRequire("5GZfA");
var $f26dfb2c46399397$export$2e2bcd8739ae039 = (0, $7HJCm.isIE11) ? (0, $5GZfA.ie11fingerprint)((0, $5GZfA.weakMapMethods)) : (0, $8Jr3K.default)('WeakMap');

});

parcelRegister("90YCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6903248b88081c8c$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");

var $7HJCm = parcelRequire("7HJCm");

var $5GZfA = parcelRequire("5GZfA");
var $6903248b88081c8c$export$2e2bcd8739ae039 = (0, $7HJCm.isIE11) ? (0, $5GZfA.ie11fingerprint)((0, $5GZfA.setMethods)) : (0, $8Jr3K.default)('Set');

});

parcelRegister("hzWzu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccc323a16d60d2a4$export$2e2bcd8739ae039; });

var $8Jr3K = parcelRequire("8Jr3K");
var $ccc323a16d60d2a4$export$2e2bcd8739ae039 = (0, $8Jr3K.default)('WeakSet');

});

parcelRegister("adQgf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7713a8404076f798$export$2e2bcd8739ae039; });

var $aBvn7 = parcelRequire("aBvn7");
function $7713a8404076f798$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $aBvn7.default)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}

});

parcelRegister("7q6RL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56704995e2c0de6e$export$2e2bcd8739ae039; });

var $aBvn7 = parcelRequire("aBvn7");
function $56704995e2c0de6e$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $aBvn7.default)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}

});

parcelRegister("1OS4y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1534679b67a58c3f$export$2e2bcd8739ae039; });

var $aBvn7 = parcelRequire("aBvn7");
function $1534679b67a58c3f$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $aBvn7.default)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}

});

parcelRegister("bHXja", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8861b736e9285104$export$2e2bcd8739ae039; });

var $g4AGd = parcelRequire("g4AGd");
function $8861b736e9285104$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $g4AGd.default)(obj[key])) names.push(key);
    return names.sort();
}

});

parcelRegister("1kSpe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f91dc94a0c57791$export$2e2bcd8739ae039; });

var $bUGM6 = parcelRequire("bUGM6");

var $gWO4X = parcelRequire("gWO4X");
var // Extend a given object with all the properties in passed-in object(s).
$0f91dc94a0c57791$export$2e2bcd8739ae039 = (0, $bUGM6.default)((0, $gWO4X.default));

});
parcelRegister("bUGM6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ac61ade2862c981$export$2e2bcd8739ae039; });
// An internal function for creating assigner functions.
function $8ac61ade2862c981$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}

});


parcelRegister("1j2TW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f39d0eda1be9b76$export$2e2bcd8739ae039; });

var $bUGM6 = parcelRequire("bUGM6");

var $aBvn7 = parcelRequire("aBvn7");
var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$0f39d0eda1be9b76$export$2e2bcd8739ae039 = (0, $bUGM6.default)((0, $aBvn7.default));

});

parcelRegister("lK2s3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3fcbab846dd332$export$2e2bcd8739ae039; });

var $bUGM6 = parcelRequire("bUGM6");

var $gWO4X = parcelRequire("gWO4X");
var // Fill in a given object with default properties.
$fd3fcbab846dd332$export$2e2bcd8739ae039 = (0, $bUGM6.default)((0, $gWO4X.default), true);

});

parcelRegister("6ylWu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c56f05891c7b53d$export$2e2bcd8739ae039; });

var $39ERR = parcelRequire("39ERR");

var $1j2TW = parcelRequire("1j2TW");
function $4c56f05891c7b53d$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $39ERR.default)(prototype);
    if (props) (0, $1j2TW.default)(result, props);
    return result;
}

});
parcelRegister("39ERR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24c1e9dc0a1a809d$export$2e2bcd8739ae039; });

var $fwv49 = parcelRequire("fwv49");

var $37Qb5 = parcelRequire("37Qb5");
// Create a naked function reference for surrogate-prototype-swapping.
function $24c1e9dc0a1a809d$var$ctor() {
    return function() {};
}
function $24c1e9dc0a1a809d$export$2e2bcd8739ae039(prototype) {
    if (!(0, $fwv49.default)(prototype)) return {};
    if (0, $37Qb5.nativeCreate) return (0, $37Qb5.nativeCreate)(prototype);
    var Ctor = $24c1e9dc0a1a809d$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}

});


parcelRegister("4zp9I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $353df1b11990aa45$export$2e2bcd8739ae039; });

var $fwv49 = parcelRequire("fwv49");

var $iXrUt = parcelRequire("iXrUt");

var $1kSpe = parcelRequire("1kSpe");
function $353df1b11990aa45$export$2e2bcd8739ae039(obj) {
    if (!(0, $fwv49.default)(obj)) return obj;
    return (0, $iXrUt.default)(obj) ? obj.slice() : (0, $1kSpe.default)({}, obj);
}

});

parcelRegister("8QJv8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $671679a5f0b57517$export$2e2bcd8739ae039; });
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $671679a5f0b57517$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}

});

parcelRegister("hR2rh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cff9473db2ee7987$export$2e2bcd8739ae039; });

var $2KQHm = parcelRequire("2KQHm");

var $2ENPp = parcelRequire("2ENPp");

var $ltf7S = parcelRequire("ltf7S");
function $cff9473db2ee7987$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $2ENPp.default)(object, (0, $2KQHm.default)(path));
    return (0, $ltf7S.default)(value) ? defaultValue : value;
}

});
parcelRegister("2KQHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2018c171eeb8d091$export$2e2bcd8739ae039; });

var $js9rY = parcelRequire("js9rY");
parcelRequire("9gvBp");
function $2018c171eeb8d091$export$2e2bcd8739ae039(path) {
    return (0, $js9rY.default).toPath(path);
}

});
parcelRegister("9gvBp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bee1f3ef606cdc1$export$2e2bcd8739ae039; });

var $js9rY = parcelRequire("js9rY");

var $iXrUt = parcelRequire("iXrUt");
function $6bee1f3ef606cdc1$export$2e2bcd8739ae039(path) {
    return (0, $iXrUt.default)(path) ? path : [
        path
    ];
}
(0, $js9rY.default).toPath = $6bee1f3ef606cdc1$export$2e2bcd8739ae039;

});


parcelRegister("2ENPp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ef5f80c8ec95bc1$export$2e2bcd8739ae039; });
// Internal function to obtain a nested property in `obj` along `path`.
function $1ef5f80c8ec95bc1$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}

});


parcelRegister("blQap", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $843a1f2776386701$export$2e2bcd8739ae039; });

var $1ROAV = parcelRequire("1ROAV");

var $2KQHm = parcelRequire("2KQHm");
function $843a1f2776386701$export$2e2bcd8739ae039(obj, path) {
    path = (0, $2KQHm.default)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $1ROAV.default)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}

});

parcelRegister("8qblL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62198e4ff54f6aa8$export$2e2bcd8739ae039; });

var $jRTVw = parcelRequire("jRTVw");

var $aBvn7 = parcelRequire("aBvn7");
function $62198e4ff54f6aa8$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $jRTVw.default)(iteratee, context);
    var _keys = (0, $aBvn7.default)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});
parcelRegister("jRTVw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e76e5976d4d409a6$export$2e2bcd8739ae039; });

var $js9rY = parcelRequire("js9rY");

var $CDSLm = parcelRequire("CDSLm");

var $6FZW9 = parcelRequire("6FZW9");
function $e76e5976d4d409a6$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $js9rY.default).iteratee !== (0, $6FZW9.default)) return (0, $js9rY.default).iteratee(value, context);
    return (0, $CDSLm.default)(value, context, argCount);
}

});
parcelRegister("CDSLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07427c836d742d22$export$2e2bcd8739ae039; });

var $khymw = parcelRequire("khymw");

var $g4AGd = parcelRequire("g4AGd");

var $fwv49 = parcelRequire("fwv49");

var $iXrUt = parcelRequire("iXrUt");

var $4xNbh = parcelRequire("4xNbh");

var $4s03j = parcelRequire("4s03j");

var $cH1sp = parcelRequire("cH1sp");
function $07427c836d742d22$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $khymw.default;
    if ((0, $g4AGd.default)(value)) return (0, $cH1sp.default)(value, context, argCount);
    if ((0, $fwv49.default)(value) && !(0, $iXrUt.default)(value)) return (0, $4xNbh.default)(value);
    return (0, $4s03j.default)(value);
}

});
parcelRegister("khymw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec400ccf5c9c8f16$export$2e2bcd8739ae039; });
// Keep the identity function around for default iteratees.
function $ec400ccf5c9c8f16$export$2e2bcd8739ae039(value) {
    return value;
}

});

parcelRegister("4xNbh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34f064d252f35755$export$2e2bcd8739ae039; });

var $1j2TW = parcelRequire("1j2TW");

var $NFS00 = parcelRequire("NFS00");
function $34f064d252f35755$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $1j2TW.default)({}, attrs);
    return function(obj) {
        return (0, $NFS00.default)(obj, attrs);
    };
}

});

parcelRegister("4s03j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33d9d15eae29ac3f$export$2e2bcd8739ae039; });

var $2ENPp = parcelRequire("2ENPp");

var $2KQHm = parcelRequire("2KQHm");
function $33d9d15eae29ac3f$export$2e2bcd8739ae039(path) {
    path = (0, $2KQHm.default)(path);
    return function(obj) {
        return (0, $2ENPp.default)(obj, path);
    };
}

});

parcelRegister("cH1sp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93daa18cbcdb8aa4$export$2e2bcd8739ae039; });
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $93daa18cbcdb8aa4$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}

});


parcelRegister("6FZW9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dc69dca484a8a00$export$2e2bcd8739ae039; });

var $js9rY = parcelRequire("js9rY");

var $CDSLm = parcelRequire("CDSLm");
function $4dc69dca484a8a00$export$2e2bcd8739ae039(value, context) {
    return (0, $CDSLm.default)(value, context, Infinity);
}
(0, $js9rY.default).iteratee = $4dc69dca484a8a00$export$2e2bcd8739ae039;

});



parcelRegister("aXh6e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f9cadb3ef5abd1c$export$2e2bcd8739ae039; });
// Predicate-generating function. Often useful outside of Underscore.
function $7f9cadb3ef5abd1c$export$2e2bcd8739ae039() {}

});

parcelRegister("5A4MA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4104064609d8a39e$export$2e2bcd8739ae039; });

var $aXh6e = parcelRequire("aXh6e");

var $hR2rh = parcelRequire("hR2rh");
function $4104064609d8a39e$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $aXh6e.default;
    return function(path) {
        return (0, $hR2rh.default)(obj, path);
    };
}

});

parcelRegister("3akHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24e25c830cca8f70$export$2e2bcd8739ae039; });

var $cH1sp = parcelRequire("cH1sp");
function $24e25c830cca8f70$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $cH1sp.default)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}

});

parcelRegister("dlR7J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b8671cb351b62d0$export$2e2bcd8739ae039; });
// Return a random integer between `min` and `max` (inclusive).
function $9b8671cb351b62d0$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});

parcelRegister("6vrf4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bcac5038f7fdb61$export$2e2bcd8739ae039; });
// A (possibly faster) way to get the current timestamp as an integer.
var $4bcac5038f7fdb61$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};

});

parcelRegister("2PZuG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21100b94d176598a$export$2e2bcd8739ae039; });

var $jzM6Y = parcelRequire("jzM6Y");

var $dvZRI = parcelRequire("dvZRI");
var // Function for escaping strings to HTML interpolation.
$21100b94d176598a$export$2e2bcd8739ae039 = (0, $jzM6Y.default)((0, $dvZRI.default));

});
parcelRegister("jzM6Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4069b1eabbfd71b$export$2e2bcd8739ae039; });

var $aBvn7 = parcelRequire("aBvn7");
function $e4069b1eabbfd71b$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + (0, $aBvn7.default)(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}

});

parcelRegister("dvZRI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d6e28ceaaa7fdd2$export$2e2bcd8739ae039; });
// Internal list of HTML entities for escaping.
var $9d6e28ceaaa7fdd2$export$2e2bcd8739ae039 = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
};

});


parcelRegister("gyHqX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0e1835cfc0f52ef$export$2e2bcd8739ae039; });

var $jzM6Y = parcelRequire("jzM6Y");

var $b4rd3 = parcelRequire("b4rd3");
var // Function for unescaping strings from HTML interpolation.
$c0e1835cfc0f52ef$export$2e2bcd8739ae039 = (0, $jzM6Y.default)((0, $b4rd3.default));

});
parcelRegister("b4rd3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80f52cb2898c026f$export$2e2bcd8739ae039; });

var $1OS4y = parcelRequire("1OS4y");

var $dvZRI = parcelRequire("dvZRI");
var // Internal list of HTML entities for unescaping.
$80f52cb2898c026f$export$2e2bcd8739ae039 = (0, $1OS4y.default)((0, $dvZRI.default));

});


parcelRegister("WZ5tW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b14cd9540243481$export$2e2bcd8739ae039; });

var $js9rY = parcelRequire("js9rY");
var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$0b14cd9540243481$export$2e2bcd8739ae039 = (0, $js9rY.default).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};

});

parcelRegister("biLCB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83a650ccbb3f52c0$export$2e2bcd8739ae039; });

var $lK2s3 = parcelRequire("lK2s3");

var $js9rY = parcelRequire("js9rY");
parcelRequire("WZ5tW");
// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $83a650ccbb3f52c0$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $83a650ccbb3f52c0$var$escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
};
var $83a650ccbb3f52c0$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $83a650ccbb3f52c0$var$escapeChar(match) {
    return '\\' + $83a650ccbb3f52c0$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $83a650ccbb3f52c0$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $83a650ccbb3f52c0$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $lK2s3.default)({}, settings, (0, $js9rY.default).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $83a650ccbb3f52c0$var$noMatch).source,
        (settings.interpolate || $83a650ccbb3f52c0$var$noMatch).source,
        (settings.evaluate || $83a650ccbb3f52c0$var$noMatch).source
    ].join('|') + '|$', 'g');
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($83a650ccbb3f52c0$var$escapeRegExp, $83a650ccbb3f52c0$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$83a650ccbb3f52c0$var$bareIdentifier.test(argument)) throw new Error('variable is not a bare identifier: ' + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = 'with(obj||{}){\n' + source + '}\n';
        argument = 'obj';
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
    var render;
    try {
        render = new Function(argument, '_', source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $js9rY.default));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';
    return template;
}

});

parcelRegister("doxTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c07cecb7cacf213$export$2e2bcd8739ae039; });

var $g4AGd = parcelRequire("g4AGd");

var $2KQHm = parcelRequire("2KQHm");
function $9c07cecb7cacf213$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $2KQHm.default)(path);
    var length = path.length;
    if (!length) return (0, $g4AGd.default)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $g4AGd.default)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}

});

parcelRegister("ktm5J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee77a6fc2ef81397$export$2e2bcd8739ae039; });
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $ee77a6fc2ef81397$var$idCounter = 0;
function $ee77a6fc2ef81397$export$2e2bcd8739ae039(prefix) {
    var id = ++$ee77a6fc2ef81397$var$idCounter + '';
    return prefix ? prefix + id : id;
}

});

parcelRegister("9tPuy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e6ec3b75e0838e1$export$2e2bcd8739ae039; });

var $js9rY = parcelRequire("js9rY");
function $6e6ec3b75e0838e1$export$2e2bcd8739ae039(obj) {
    var instance = (0, $js9rY.default)(obj);
    instance._chain = true;
    return instance;
}

});

parcelRegister("53HbL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aeebbf2053fe5b7$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $2vjTc = parcelRequire("2vjTc");

var $js9rY = parcelRequire("js9rY");
// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $3aeebbf2053fe5b7$var$partial = (0, $5IPcr.default)(function(func, boundArgs) {
    var placeholder = $3aeebbf2053fe5b7$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $2vjTc.default)(func, bound, this, this, args);
    };
    return bound;
});
$3aeebbf2053fe5b7$var$partial.placeholder = (0, $js9rY.default);
var $3aeebbf2053fe5b7$export$2e2bcd8739ae039 = $3aeebbf2053fe5b7$var$partial;

});
parcelRegister("2vjTc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d2de7996b768569$export$2e2bcd8739ae039; });

var $39ERR = parcelRequire("39ERR");

var $fwv49 = parcelRequire("fwv49");
function $1d2de7996b768569$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $39ERR.default)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $fwv49.default)(result)) return result;
    return self;
}

});


parcelRegister("5LiiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $431f8999486b76f2$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $g4AGd = parcelRequire("g4AGd");

var $2vjTc = parcelRequire("2vjTc");
var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$431f8999486b76f2$export$2e2bcd8739ae039 = (0, $5IPcr.default)(function(func, context, args) {
    if (!(0, $g4AGd.default)(func)) throw new TypeError('Bind must be called on a function');
    var bound = (0, $5IPcr.default)(function(callArgs) {
        return (0, $2vjTc.default)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});

});

parcelRegister("ftoIz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b43cbce30093919c$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $hZKPY = parcelRequire("hZKPY");

var $5LiiG = parcelRequire("5LiiG");
var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$b43cbce30093919c$export$2e2bcd8739ae039 = (0, $5IPcr.default)(function(obj, keys) {
    keys = (0, $hZKPY.default)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while(index--){
        var key = keys[index];
        obj[key] = (0, $5LiiG.default)(obj[key], obj);
    }
    return obj;
});

});
parcelRegister("hZKPY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d19c7715e5320d5c$export$2e2bcd8739ae039; });

var $hnef7 = parcelRequire("hnef7");

var $iGg24 = parcelRequire("iGg24");

var $iXrUt = parcelRequire("iXrUt");

var $bQBbO = parcelRequire("bQBbO");
function $d19c7715e5320d5c$export$2e2bcd8739ae039(input, depth, strict) {
    if (!depth && depth !== 0) depth = Infinity;
    var output = [], idx = 0, i = 0, length = (0, $hnef7.default)(input) || 0, stack = [];
    while(true){
        if (i >= length) {
            if (!stack.length) break;
            var frame = stack.pop();
            i = frame.i;
            input = frame.v;
            length = (0, $hnef7.default)(input);
            continue;
        }
        var value = input[i++];
        if (stack.length >= depth) output[idx++] = value;
        else if ((0, $iGg24.default)(value) && ((0, $iXrUt.default)(value) || (0, $bQBbO.default)(value))) {
            // Flatten current level of array or arguments object.
            stack.push({
                i: i,
                v: input
            });
            i = 0;
            input = value;
            length = (0, $hnef7.default)(input);
        } else if (!strict) output[idx++] = value;
    }
    return output;
}

});
parcelRegister("iGg24", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d99895f5c1b3661b$export$2e2bcd8739ae039; });

var $9wRQj = parcelRequire("9wRQj");

var $hnef7 = parcelRequire("hnef7");
var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$d99895f5c1b3661b$export$2e2bcd8739ae039 = (0, $9wRQj.default)((0, $hnef7.default));

});



parcelRegister("gOLnz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3e61161cebce2eb$export$2e2bcd8739ae039; });

var $1ROAV = parcelRequire("1ROAV");
function $c3e61161cebce2eb$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = '' + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $1ROAV.default)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}

});

parcelRegister("hHUwS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce424d6079aca79d$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");
var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$ce424d6079aca79d$export$2e2bcd8739ae039 = (0, $5IPcr.default)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});

});

parcelRegister("gKMii", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c326676f9f1603be$export$2e2bcd8739ae039; });

var $53HbL = parcelRequire("53HbL");

var $hHUwS = parcelRequire("hHUwS");

var $js9rY = parcelRequire("js9rY");
var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$c326676f9f1603be$export$2e2bcd8739ae039 = (0, $53HbL.default)((0, $hHUwS.default), (0, $js9rY.default), 1);

});

parcelRegister("1WA9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16a740e90b8f410d$export$2e2bcd8739ae039; });

var $6vrf4 = parcelRequire("6vrf4");
function $16a740e90b8f410d$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $6vrf4.default)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $6vrf4.default)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}

});

parcelRegister("gE85z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1e6a809cc9a24e4$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $6vrf4 = parcelRequire("6vrf4");
function $c1e6a809cc9a24e4$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $6vrf4.default)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $5IPcr.default)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $6vrf4.default)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}

});

parcelRegister("cL6lC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $949ecc514945ac88$export$2e2bcd8739ae039; });

var $53HbL = parcelRequire("53HbL");
function $949ecc514945ac88$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $53HbL.default)(wrapper, func);
}

});

parcelRegister("abVpn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76b7768b155bf81c$export$2e2bcd8739ae039; });
// Returns a negated version of the passed-in predicate.
function $76b7768b155bf81c$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}

});

parcelRegister("edpsq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a59606ec60691684$export$2e2bcd8739ae039; });
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $a59606ec60691684$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}

});

parcelRegister("9uZPt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ea6e066845f91f1$export$2e2bcd8739ae039; });
// Returns a function that will only be executed on and after the Nth call.
function $6ea6e066845f91f1$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}

});

parcelRegister("7HMvI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c22dc0d598247e$export$2e2bcd8739ae039; });
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $59c22dc0d598247e$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}

});

parcelRegister("e6vvn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a44a107c98dc6b37$export$2e2bcd8739ae039; });

var $53HbL = parcelRequire("53HbL");

var $7HMvI = parcelRequire("7HMvI");
var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$a44a107c98dc6b37$export$2e2bcd8739ae039 = (0, $53HbL.default)((0, $7HMvI.default), 2);

});

parcelRegister("bj3e2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83b3f8915cb479f2$export$2e2bcd8739ae039; });

var $jRTVw = parcelRequire("jRTVw");

var $aBvn7 = parcelRequire("aBvn7");
function $83b3f8915cb479f2$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $jRTVw.default)(predicate, context);
    var _keys = (0, $aBvn7.default)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}

});

parcelRegister("9YYAC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7448b77981e749fe$export$2e2bcd8739ae039; });

var $1yYtO = parcelRequire("1yYtO");
var // Returns the first index on an array-like that passes a truth test.
$7448b77981e749fe$export$2e2bcd8739ae039 = (0, $1yYtO.default)(1);

});
parcelRegister("1yYtO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1237e16f34716f22$export$2e2bcd8739ae039; });

var $jRTVw = parcelRequire("jRTVw");

var $hnef7 = parcelRequire("hnef7");
function $1237e16f34716f22$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $jRTVw.default)(predicate, context);
        var length = (0, $hnef7.default)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}

});


parcelRegister("k5nEN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9f6a00cc3feffb2$export$2e2bcd8739ae039; });

var $1yYtO = parcelRequire("1yYtO");
var // Returns the last index on an array-like that passes a truth test.
$e9f6a00cc3feffb2$export$2e2bcd8739ae039 = (0, $1yYtO.default)(-1);

});

parcelRegister("cA3fU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $928b5f54816188da$export$2e2bcd8739ae039; });

var $jRTVw = parcelRequire("jRTVw");

var $hnef7 = parcelRequire("hnef7");
function $928b5f54816188da$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $jRTVw.default)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $hnef7.default)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}

});

parcelRegister("4yx50", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3513ff56791dbc25$export$2e2bcd8739ae039; });

var $cA3fU = parcelRequire("cA3fU");

var $9YYAC = parcelRequire("9YYAC");

var $b08TD = parcelRequire("b08TD");
var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$3513ff56791dbc25$export$2e2bcd8739ae039 = (0, $b08TD.default)(1, (0, $9YYAC.default), (0, $cA3fU.default));

});
parcelRegister("b08TD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $802698672ac9488c$export$2e2bcd8739ae039; });

var $hnef7 = parcelRequire("hnef7");

var $37Qb5 = parcelRequire("37Qb5");

var $6xEml = parcelRequire("6xEml");
function $802698672ac9488c$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $hnef7.default)(array);
        if (typeof idx == 'number') {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $37Qb5.slice).call(array, i, length), (0, $6xEml.default));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}

});


parcelRegister("10gKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bb2c7cf550a6540$export$2e2bcd8739ae039; });

var $k5nEN = parcelRequire("k5nEN");

var $b08TD = parcelRequire("b08TD");
var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$0bb2c7cf550a6540$export$2e2bcd8739ae039 = (0, $b08TD.default)(-1, (0, $k5nEN.default));

});

parcelRegister("6dYu1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4882dfac3baa51cc$export$2e2bcd8739ae039; });

var $iGg24 = parcelRequire("iGg24");

var $9YYAC = parcelRequire("9YYAC");

var $bj3e2 = parcelRequire("bj3e2");
function $4882dfac3baa51cc$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $iGg24.default)(obj) ? (0, $9YYAC.default) : (0, $bj3e2.default);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}

});

parcelRegister("77Oh7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53002f74edb62100$export$2e2bcd8739ae039; });

var $6dYu1 = parcelRequire("6dYu1");

var $4xNbh = parcelRequire("4xNbh");
function $53002f74edb62100$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $6dYu1.default)(obj, (0, $4xNbh.default)(attrs));
}

});

parcelRegister("6YL8K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $514ce9b8ad71c025$export$2e2bcd8739ae039; });

var $cH1sp = parcelRequire("cH1sp");

var $iGg24 = parcelRequire("iGg24");

var $aBvn7 = parcelRequire("aBvn7");
function $514ce9b8ad71c025$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $cH1sp.default)(iteratee, context);
    var i, length;
    if ((0, $iGg24.default)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $aBvn7.default)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}

});

parcelRegister("apU8A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7957c8e7c7816d5f$export$2e2bcd8739ae039; });

var $jRTVw = parcelRequire("jRTVw");

var $iGg24 = parcelRequire("iGg24");

var $aBvn7 = parcelRequire("aBvn7");
function $7957c8e7c7816d5f$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $jRTVw.default)(iteratee, context);
    var _keys = !(0, $iGg24.default)(obj) && (0, $aBvn7.default)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});

parcelRegister("d6ISG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98aea650fbf7d27f$export$2e2bcd8739ae039; });

var $jJ2Dq = parcelRequire("jJ2Dq");
var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$98aea650fbf7d27f$export$2e2bcd8739ae039 = (0, $jJ2Dq.default)(1);

});
parcelRegister("jJ2Dq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5c44381101087cd$export$2e2bcd8739ae039; });

var $iGg24 = parcelRequire("iGg24");

var $aBvn7 = parcelRequire("aBvn7");

var $cH1sp = parcelRequire("cH1sp");
function $e5c44381101087cd$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $iGg24.default)(obj) && (0, $aBvn7.default)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $cH1sp.default)(iteratee, context, 4), memo, initial);
    };
}

});


parcelRegister("h3I4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6b4e86e68451059$export$2e2bcd8739ae039; });

var $jJ2Dq = parcelRequire("jJ2Dq");
var // The right-associative version of reduce, also known as `foldr`.
$c6b4e86e68451059$export$2e2bcd8739ae039 = (0, $jJ2Dq.default)(-1);

});

parcelRegister("e4fgt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3dd47ac9bee4126$export$2e2bcd8739ae039; });

var $jRTVw = parcelRequire("jRTVw");

var $6YL8K = parcelRequire("6YL8K");
function $a3dd47ac9bee4126$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $jRTVw.default)(predicate, context);
    (0, $6YL8K.default)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

});

parcelRegister("iWtfe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dca45422893a04ac$export$2e2bcd8739ae039; });

var $e4fgt = parcelRequire("e4fgt");

var $abVpn = parcelRequire("abVpn");

var $jRTVw = parcelRequire("jRTVw");
function $dca45422893a04ac$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $e4fgt.default)(obj, (0, $abVpn.default)((0, $jRTVw.default)(predicate)), context);
}

});

parcelRegister("1Frrs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $136ee82b1b536ad9$export$2e2bcd8739ae039; });

var $jRTVw = parcelRequire("jRTVw");

var $iGg24 = parcelRequire("iGg24");

var $aBvn7 = parcelRequire("aBvn7");
function $136ee82b1b536ad9$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $jRTVw.default)(predicate, context);
    var _keys = !(0, $iGg24.default)(obj) && (0, $aBvn7.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}

});

parcelRegister("4PhZa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3839e06d61b26451$export$2e2bcd8739ae039; });

var $jRTVw = parcelRequire("jRTVw");

var $iGg24 = parcelRequire("iGg24");

var $aBvn7 = parcelRequire("aBvn7");
function $3839e06d61b26451$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $jRTVw.default)(predicate, context);
    var _keys = !(0, $iGg24.default)(obj) && (0, $aBvn7.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}

});

parcelRegister("3AjBd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29c3efeae343545a$export$2e2bcd8739ae039; });

var $iGg24 = parcelRequire("iGg24");

var $adQgf = parcelRequire("adQgf");

var $4yx50 = parcelRequire("4yx50");
function $29c3efeae343545a$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $iGg24.default)(obj)) obj = (0, $adQgf.default)(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return (0, $4yx50.default)(obj, item, fromIndex) >= 0;
}

});

parcelRegister("1UMD9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1650be62d2ab5aeb$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $g4AGd = parcelRequire("g4AGd");

var $apU8A = parcelRequire("apU8A");

var $2ENPp = parcelRequire("2ENPp");

var $2KQHm = parcelRequire("2KQHm");
var // Invoke a method (with arguments) on every item in a collection.
$1650be62d2ab5aeb$export$2e2bcd8739ae039 = (0, $5IPcr.default)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $g4AGd.default)(path)) func = path;
    else {
        path = (0, $2KQHm.default)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $apU8A.default)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $2ENPp.default)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});

});

parcelRegister("6yCKd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c63f8e4cee5509f$export$2e2bcd8739ae039; });

var $apU8A = parcelRequire("apU8A");

var $4s03j = parcelRequire("4s03j");
function $4c63f8e4cee5509f$export$2e2bcd8739ae039(obj, key) {
    return (0, $apU8A.default)(obj, (0, $4s03j.default)(key));
}

});

parcelRegister("iuwlg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7641dcb87fc6126$export$2e2bcd8739ae039; });

var $e4fgt = parcelRequire("e4fgt");

var $4xNbh = parcelRequire("4xNbh");
function $d7641dcb87fc6126$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $e4fgt.default)(obj, (0, $4xNbh.default)(attrs));
}

});

parcelRegister("6fBin", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48d112dcdf4e6de5$export$2e2bcd8739ae039; });

var $iGg24 = parcelRequire("iGg24");

var $adQgf = parcelRequire("adQgf");

var $jRTVw = parcelRequire("jRTVw");

var $6YL8K = parcelRequire("6YL8K");
function $48d112dcdf4e6de5$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $iGg24.default)(obj) ? obj : (0, $adQgf.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $jRTVw.default)(iteratee, context);
        (0, $6YL8K.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("2VQkU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $222980831152eec2$export$2e2bcd8739ae039; });

var $iGg24 = parcelRequire("iGg24");

var $adQgf = parcelRequire("adQgf");

var $jRTVw = parcelRequire("jRTVw");

var $6YL8K = parcelRequire("6YL8K");
function $222980831152eec2$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $iGg24.default)(obj) ? obj : (0, $adQgf.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $jRTVw.default)(iteratee, context);
        (0, $6YL8K.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("dpq6U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c31dd20265a8f46$export$2e2bcd8739ae039; });

var $6QcNa = parcelRequire("6QcNa");
function $9c31dd20265a8f46$export$2e2bcd8739ae039(obj) {
    return (0, $6QcNa.default)(obj, Infinity);
}

});
parcelRegister("6QcNa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fb1859ecdd3eb1d$export$2e2bcd8739ae039; });

var $iGg24 = parcelRequire("iGg24");

var $adQgf = parcelRequire("adQgf");

var $hnef7 = parcelRequire("hnef7");

var $dlR7J = parcelRequire("dlR7J");

var $khA8o = parcelRequire("khA8o");
function $4fb1859ecdd3eb1d$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $iGg24.default)(obj)) obj = (0, $adQgf.default)(obj);
        return obj[(0, $dlR7J.default)(obj.length - 1)];
    }
    var sample = (0, $khA8o.default)(obj);
    var length = (0, $hnef7.default)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $dlR7J.default)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}

});
parcelRegister("khA8o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec416cb207efde87$export$2e2bcd8739ae039; });

var $iXrUt = parcelRequire("iXrUt");

var $37Qb5 = parcelRequire("37Qb5");

var $04NNv = parcelRequire("04NNv");

var $iGg24 = parcelRequire("iGg24");

var $apU8A = parcelRequire("apU8A");

var $khymw = parcelRequire("khymw");

var $adQgf = parcelRequire("adQgf");
// Safely create a real, live array from anything iterable.
var $ec416cb207efde87$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $ec416cb207efde87$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $iXrUt.default)(obj)) return (0, $37Qb5.slice).call(obj);
    if ((0, $04NNv.default)(obj)) // Keep surrogate pair characters together.
    return obj.match($ec416cb207efde87$var$reStrSymbol);
    if ((0, $iGg24.default)(obj)) return (0, $apU8A.default)(obj, (0, $khymw.default));
    return (0, $adQgf.default)(obj);
}

});



parcelRegister("eE5Rm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa9958bc237a249f$export$2e2bcd8739ae039; });

var $jRTVw = parcelRequire("jRTVw");

var $6yCKd = parcelRequire("6yCKd");

var $apU8A = parcelRequire("apU8A");
function $aa9958bc237a249f$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $jRTVw.default)(iteratee, context);
    return (0, $6yCKd.default)((0, $apU8A.default)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), 'value');
}

});

parcelRegister("d2d02", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97d58bb4ee30c01c$export$2e2bcd8739ae039; });

var $kDHN4 = parcelRequire("kDHN4");

var $1ROAV = parcelRequire("1ROAV");
var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$97d58bb4ee30c01c$export$2e2bcd8739ae039 = (0, $kDHN4.default)(function(result, value, key) {
    if ((0, $1ROAV.default)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});

});
parcelRegister("kDHN4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0696b04e48c1a92$export$2e2bcd8739ae039; });

var $jRTVw = parcelRequire("jRTVw");

var $6YL8K = parcelRequire("6YL8K");
function $f0696b04e48c1a92$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $jRTVw.default)(iteratee, context);
        (0, $6YL8K.default)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}

});


parcelRegister("6BxOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf06df18f0e01f3$export$2e2bcd8739ae039; });

var $kDHN4 = parcelRequire("kDHN4");
var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$4cf06df18f0e01f3$export$2e2bcd8739ae039 = (0, $kDHN4.default)(function(result, value, key) {
    result[key] = value;
});

});

parcelRegister("flGPh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2ca098abc2cb5cf$export$2e2bcd8739ae039; });

var $kDHN4 = parcelRequire("kDHN4");

var $1ROAV = parcelRequire("1ROAV");
var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$b2ca098abc2cb5cf$export$2e2bcd8739ae039 = (0, $kDHN4.default)(function(result, value, key) {
    if ((0, $1ROAV.default)(result, key)) result[key]++;
    else result[key] = 1;
});

});

parcelRegister("lNAB2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdea8fde0f295000$export$2e2bcd8739ae039; });

var $kDHN4 = parcelRequire("kDHN4");
var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$fdea8fde0f295000$export$2e2bcd8739ae039 = (0, $kDHN4.default)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);

});

parcelRegister("fhh1h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1f5a54d018a3b82$export$2e2bcd8739ae039; });

var $iGg24 = parcelRequire("iGg24");

var $aBvn7 = parcelRequire("aBvn7");
function $b1f5a54d018a3b82$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $iGg24.default)(obj) ? obj.length : (0, $aBvn7.default)(obj).length;
}

});

parcelRegister("6z54P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c79f31ff557f9bc$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $g4AGd = parcelRequire("g4AGd");

var $cH1sp = parcelRequire("cH1sp");

var $gWO4X = parcelRequire("gWO4X");

var $kpxXl = parcelRequire("kpxXl");

var $hZKPY = parcelRequire("hZKPY");
var // Return a copy of the object only containing the allowed properties.
$4c79f31ff557f9bc$export$2e2bcd8739ae039 = (0, $5IPcr.default)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $g4AGd.default)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $cH1sp.default)(iteratee, keys[1]);
        keys = (0, $gWO4X.default)(obj);
    } else {
        iteratee = (0, $kpxXl.default);
        keys = (0, $hZKPY.default)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});

});
parcelRegister("kpxXl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edc07b691a65b91b$export$2e2bcd8739ae039; });
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $edc07b691a65b91b$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}

});


parcelRegister("9hu7P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c1d11d3e2688844$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $g4AGd = parcelRequire("g4AGd");

var $abVpn = parcelRequire("abVpn");

var $apU8A = parcelRequire("apU8A");

var $hZKPY = parcelRequire("hZKPY");

var $3AjBd = parcelRequire("3AjBd");

var $6z54P = parcelRequire("6z54P");
var // Return a copy of the object without the disallowed properties.
$6c1d11d3e2688844$export$2e2bcd8739ae039 = (0, $5IPcr.default)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $g4AGd.default)(iteratee)) {
        iteratee = (0, $abVpn.default)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $apU8A.default)((0, $hZKPY.default)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $3AjBd.default)(keys, key);
        };
    }
    return (0, $6z54P.default)(obj, iteratee, context);
});

});

parcelRegister("ihycS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4f4593e4b41f2e6$export$2e2bcd8739ae039; });

var $8wtiu = parcelRequire("8wtiu");
function $d4f4593e4b41f2e6$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $8wtiu.default)(array, array.length - n);
}

});
parcelRegister("8wtiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $634809b2d34ac223$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");
function $634809b2d34ac223$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $37Qb5.slice).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

});


parcelRegister("bLfRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $890063855372e85d$export$2e2bcd8739ae039; });

var $hpUIg = parcelRequire("hpUIg");
function $890063855372e85d$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $hpUIg.default)(array, Math.max(0, array.length - n));
}

});
parcelRegister("hpUIg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cae0c37f85d39bcd$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");
function $cae0c37f85d39bcd$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $37Qb5.slice).call(array, n == null || guard ? 1 : n);
}

});


parcelRegister("8LgiM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $660f5bbe810d52b8$export$2e2bcd8739ae039; });

var $e4fgt = parcelRequire("e4fgt");
function $660f5bbe810d52b8$export$2e2bcd8739ae039(array) {
    return (0, $e4fgt.default)(array, Boolean);
}

});

parcelRegister("3CMFi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a3aab937ba47f82$export$2e2bcd8739ae039; });

var $hZKPY = parcelRequire("hZKPY");
function $2a3aab937ba47f82$export$2e2bcd8739ae039(array, depth) {
    return (0, $hZKPY.default)(array, depth, false);
}

});

parcelRegister("cyfya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9234b8ec69f48535$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $k4a10 = parcelRequire("k4a10");
var // Return a version of the array that does not contain the specified value(s).
$9234b8ec69f48535$export$2e2bcd8739ae039 = (0, $5IPcr.default)(function(array, otherArrays) {
    return (0, $k4a10.default)(array, otherArrays);
});

});
parcelRegister("k4a10", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9bbf3345dd14941$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $hZKPY = parcelRequire("hZKPY");

var $e4fgt = parcelRequire("e4fgt");

var $3AjBd = parcelRequire("3AjBd");
var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$e9bbf3345dd14941$export$2e2bcd8739ae039 = (0, $5IPcr.default)(function(array, rest) {
    rest = (0, $hZKPY.default)(rest, true, true);
    return (0, $e4fgt.default)(array, function(value) {
        return !(0, $3AjBd.default)(rest, value);
    });
});

});


parcelRegister("7ptoh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5651aa8bcc8f8765$export$2e2bcd8739ae039; });

var $4AbmA = parcelRequire("4AbmA");

var $jRTVw = parcelRequire("jRTVw");

var $hnef7 = parcelRequire("hnef7");

var $3AjBd = parcelRequire("3AjBd");
function $5651aa8bcc8f8765$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $4AbmA.default)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $jRTVw.default)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $hnef7.default)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $3AjBd.default)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $3AjBd.default)(result, value)) result.push(value);
    }
    return result;
}

});

parcelRegister("79ikz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $534797c3037da8f0$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $7ptoh = parcelRequire("7ptoh");

var $hZKPY = parcelRequire("hZKPY");
var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$534797c3037da8f0$export$2e2bcd8739ae039 = (0, $5IPcr.default)(function(arrays) {
    return (0, $7ptoh.default)((0, $hZKPY.default)(arrays, true, true));
});

});

parcelRegister("4ZrUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a22818547298e04$export$2e2bcd8739ae039; });

var $hnef7 = parcelRequire("hnef7");

var $3AjBd = parcelRequire("3AjBd");
function $3a22818547298e04$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $hnef7.default)(array); i < length; i++){
        var item = array[i];
        if ((0, $3AjBd.default)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $3AjBd.default)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}

});

parcelRegister("lfs4W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f780c78ab0bc1ef9$export$2e2bcd8739ae039; });

var $6fBin = parcelRequire("6fBin");

var $hnef7 = parcelRequire("hnef7");

var $6yCKd = parcelRequire("6yCKd");
function $f780c78ab0bc1ef9$export$2e2bcd8739ae039(array) {
    var length = array && (0, $6fBin.default)(array, (0, $hnef7.default)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $6yCKd.default)(array, index);
    return result;
}

});

parcelRegister("9xwpw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f20562df25baca7$export$2e2bcd8739ae039; });

var $5IPcr = parcelRequire("5IPcr");

var $lfs4W = parcelRequire("lfs4W");
var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$6f20562df25baca7$export$2e2bcd8739ae039 = (0, $5IPcr.default)((0, $lfs4W.default));

});

parcelRegister("1TNXe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1621ad645a084e6f$export$2e2bcd8739ae039; });

var $hnef7 = parcelRequire("hnef7");
function $1621ad645a084e6f$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $hnef7.default)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}

});

parcelRegister("a0GO7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $749b1c1cfb945c4f$export$2e2bcd8739ae039; });
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $749b1c1cfb945c4f$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}

});

parcelRegister("9C5sD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ffbe617c4cde53d$export$2e2bcd8739ae039; });

var $37Qb5 = parcelRequire("37Qb5");
function $6ffbe617c4cde53d$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $37Qb5.slice).call(array, i, i += count));
    return result;
}

});

parcelRegister("cpls5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $908875c1e44921ef$export$2e2bcd8739ae039; });

var $js9rY = parcelRequire("js9rY");

var $6YL8K = parcelRequire("6YL8K");

var $bHXja = parcelRequire("bHXja");

var $37Qb5 = parcelRequire("37Qb5");

var $g8Aze = parcelRequire("g8Aze");
function $908875c1e44921ef$export$2e2bcd8739ae039(obj) {
    (0, $6YL8K.default)((0, $bHXja.default)(obj), function(name) {
        var func = (0, $js9rY.default)[name] = obj[name];
        (0, $js9rY.default).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $37Qb5.push).apply(args, arguments);
            return (0, $g8Aze.default)(this, func.apply((0, $js9rY.default), args));
        };
    });
    return 0, $js9rY.default;
}

});
parcelRegister("g8Aze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbf9c23099459d3c$export$2e2bcd8739ae039; });

var $js9rY = parcelRequire("js9rY");
function $bbf9c23099459d3c$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $js9rY.default)(obj).chain() : obj;
}

});


parcelRegister("3yhVi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29627339e72b8426$export$2e2bcd8739ae039; });

var $js9rY = parcelRequire("js9rY");

var $6YL8K = parcelRequire("6YL8K");

var $37Qb5 = parcelRequire("37Qb5");

var $g8Aze = parcelRequire("g8Aze");
// Add all mutator `Array` functions to the wrapper.
(0, $6YL8K.default)([
    'pop',
    'push',
    'reverse',
    'shift',
    'sort',
    'splice',
    'unshift'
], function(name) {
    var method = (0, $37Qb5.ArrayProto)[name];
    (0, $js9rY.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
        }
        return (0, $g8Aze.default)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $6YL8K.default)([
    'concat',
    'join',
    'slice'
], function(name) {
    var method = (0, $37Qb5.ArrayProto)[name];
    (0, $js9rY.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $g8Aze.default)(this, obj);
    };
});
var $29627339e72b8426$export$2e2bcd8739ae039 = (0, $js9rY.default);

});





parcelRegister("dk6N3", function(module, exports) {

$parcel$export(module.exports, "parseFromString", function () { return $9b32690801825cce$export$26cfb4a895d40b24; }, function (v) { return $9b32690801825cce$export$26cfb4a895d40b24 = v; });
$parcel$export(module.exports, "Node", function () { return $9b32690801825cce$export$85c928794f8d04d4; }, function (v) { return $9b32690801825cce$export$85c928794f8d04d4 = v; });
var $9b32690801825cce$export$26cfb4a895d40b24;
var $9b32690801825cce$export$85c928794f8d04d4;

var $dcLlQ = parcelRequire("dcLlQ");

var $15vCs = parcelRequire("15vCs");
function $9b32690801825cce$var$parseFromString(string) {
    var error = null;
    var domParser = new $dcLlQ.DOMParser({
        errorHandler: function(level, message) {
            error = {
                level: level,
                message: message
            };
        }
    });
    var document = domParser.parseFromString(string);
    if (error === null) return document;
    else throw new Error(error.level + ": " + error.message);
}
$9b32690801825cce$export$26cfb4a895d40b24 = $9b32690801825cce$var$parseFromString;
$9b32690801825cce$export$85c928794f8d04d4 = $15vCs.Node;

});
parcelRegister("dcLlQ", function(module, exports) {

$parcel$export(module.exports, "DOMParser", function () { return $99d12051cd556ccf$export$1059c6e7d2ce5669; }, function (v) { return $99d12051cd556ccf$export$1059c6e7d2ce5669 = v; });
var $99d12051cd556ccf$export$455426655eab1d48;
var $99d12051cd556ccf$export$64f0bed4ae6f0f24;
var $99d12051cd556ccf$export$1059c6e7d2ce5669;

var $15vCs = parcelRequire("15vCs");
$99d12051cd556ccf$export$455426655eab1d48 = $15vCs.DOMImplementation;
$99d12051cd556ccf$export$64f0bed4ae6f0f24 = $15vCs.XMLSerializer;

$99d12051cd556ccf$export$1059c6e7d2ce5669 = (parcelRequire("fsGQ2")).DOMParser;

});
parcelRegister("15vCs", function(module, exports) {

$parcel$export(module.exports, "DOMImplementation", function () { return $0caec907a5497a5f$export$455426655eab1d48; }, function (v) { return $0caec907a5497a5f$export$455426655eab1d48 = v; });
$parcel$export(module.exports, "Node", function () { return $0caec907a5497a5f$export$85c928794f8d04d4; }, function (v) { return $0caec907a5497a5f$export$85c928794f8d04d4 = v; });
$parcel$export(module.exports, "XMLSerializer", function () { return $0caec907a5497a5f$export$64f0bed4ae6f0f24; }, function (v) { return $0caec907a5497a5f$export$64f0bed4ae6f0f24 = v; });
//if(typeof require == 'function'){
var $0caec907a5497a5f$export$d1d99cf900472499;
var $0caec907a5497a5f$export$fe58bcf938607f6a;
var $0caec907a5497a5f$export$455426655eab1d48;
var $0caec907a5497a5f$export$db77ccec0bb4ccac;
var $0caec907a5497a5f$export$85c928794f8d04d4;
var $0caec907a5497a5f$export$79b41aa5d56abdff;
var $0caec907a5497a5f$export$5118471ee5d5453b;
var $0caec907a5497a5f$export$64f0bed4ae6f0f24;

var $2Nc10 = parcelRequire("2Nc10");
var $0caec907a5497a5f$var$find = $2Nc10.find;
var $0caec907a5497a5f$var$NAMESPACE = $2Nc10.NAMESPACE;
/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */ function $0caec907a5497a5f$var$notEmptyString(input) {
    return input !== '';
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */ function $0caec907a5497a5f$var$splitOnASCIIWhitespace(input) {
    // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
    return input ? input.split(/[\t\n\f\r ]+/).filter($0caec907a5497a5f$var$notEmptyString) : [];
}
/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */ function $0caec907a5497a5f$var$orderedSetReducer(current, element) {
    if (!current.hasOwnProperty(element)) current[element] = true;
    return current;
}
/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */ function $0caec907a5497a5f$var$toOrderedSet(input) {
    if (!input) return [];
    var list = $0caec907a5497a5f$var$splitOnASCIIWhitespace(input);
    return Object.keys(list.reduce($0caec907a5497a5f$var$orderedSetReducer, {}));
}
/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */ function $0caec907a5497a5f$var$arrayIncludes(list) {
    return function(element) {
        return list && list.indexOf(element) !== -1;
    };
}
function $0caec907a5497a5f$var$copy(src, dest) {
    for(var p in src)if (Object.prototype.hasOwnProperty.call(src, p)) dest[p] = src[p];
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */ function $0caec907a5497a5f$var$_extends(Class, Super) {
    var pt = Class.prototype;
    if (!(pt instanceof Super)) {
        function t() {}
        t.prototype = Super.prototype;
        t = new t();
        $0caec907a5497a5f$var$copy(pt, t);
        Class.prototype = pt = t;
    }
    if (pt.constructor != Class) {
        if (typeof Class != 'function') console.error("unknown Class:" + Class);
        pt.constructor = Class;
    }
}
// Node Types
var $0caec907a5497a5f$var$NodeType = {};
var $0caec907a5497a5f$var$ELEMENT_NODE = $0caec907a5497a5f$var$NodeType.ELEMENT_NODE = 1;
var $0caec907a5497a5f$var$ATTRIBUTE_NODE = $0caec907a5497a5f$var$NodeType.ATTRIBUTE_NODE = 2;
var $0caec907a5497a5f$var$TEXT_NODE = $0caec907a5497a5f$var$NodeType.TEXT_NODE = 3;
var $0caec907a5497a5f$var$CDATA_SECTION_NODE = $0caec907a5497a5f$var$NodeType.CDATA_SECTION_NODE = 4;
var $0caec907a5497a5f$var$ENTITY_REFERENCE_NODE = $0caec907a5497a5f$var$NodeType.ENTITY_REFERENCE_NODE = 5;
var $0caec907a5497a5f$var$ENTITY_NODE = $0caec907a5497a5f$var$NodeType.ENTITY_NODE = 6;
var $0caec907a5497a5f$var$PROCESSING_INSTRUCTION_NODE = $0caec907a5497a5f$var$NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var $0caec907a5497a5f$var$COMMENT_NODE = $0caec907a5497a5f$var$NodeType.COMMENT_NODE = 8;
var $0caec907a5497a5f$var$DOCUMENT_NODE = $0caec907a5497a5f$var$NodeType.DOCUMENT_NODE = 9;
var $0caec907a5497a5f$var$DOCUMENT_TYPE_NODE = $0caec907a5497a5f$var$NodeType.DOCUMENT_TYPE_NODE = 10;
var $0caec907a5497a5f$var$DOCUMENT_FRAGMENT_NODE = $0caec907a5497a5f$var$NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var $0caec907a5497a5f$var$NOTATION_NODE = $0caec907a5497a5f$var$NodeType.NOTATION_NODE = 12;
// ExceptionCode
var $0caec907a5497a5f$var$ExceptionCode = {};
var $0caec907a5497a5f$var$ExceptionMessage = {};
var $0caec907a5497a5f$var$INDEX_SIZE_ERR = $0caec907a5497a5f$var$ExceptionCode.INDEX_SIZE_ERR = ($0caec907a5497a5f$var$ExceptionMessage[1] = "Index size error", 1);
var $0caec907a5497a5f$var$DOMSTRING_SIZE_ERR = $0caec907a5497a5f$var$ExceptionCode.DOMSTRING_SIZE_ERR = ($0caec907a5497a5f$var$ExceptionMessage[2] = "DOMString size error", 2);
var $0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR = $0caec907a5497a5f$var$ExceptionCode.HIERARCHY_REQUEST_ERR = ($0caec907a5497a5f$var$ExceptionMessage[3] = "Hierarchy request error", 3);
var $0caec907a5497a5f$var$WRONG_DOCUMENT_ERR = $0caec907a5497a5f$var$ExceptionCode.WRONG_DOCUMENT_ERR = ($0caec907a5497a5f$var$ExceptionMessage[4] = "Wrong document", 4);
var $0caec907a5497a5f$var$INVALID_CHARACTER_ERR = $0caec907a5497a5f$var$ExceptionCode.INVALID_CHARACTER_ERR = ($0caec907a5497a5f$var$ExceptionMessage[5] = "Invalid character", 5);
var $0caec907a5497a5f$var$NO_DATA_ALLOWED_ERR = $0caec907a5497a5f$var$ExceptionCode.NO_DATA_ALLOWED_ERR = ($0caec907a5497a5f$var$ExceptionMessage[6] = "No data allowed", 6);
var $0caec907a5497a5f$var$NO_MODIFICATION_ALLOWED_ERR = $0caec907a5497a5f$var$ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ($0caec907a5497a5f$var$ExceptionMessage[7] = "No modification allowed", 7);
var $0caec907a5497a5f$var$NOT_FOUND_ERR = $0caec907a5497a5f$var$ExceptionCode.NOT_FOUND_ERR = ($0caec907a5497a5f$var$ExceptionMessage[8] = "Not found", 8);
var $0caec907a5497a5f$var$NOT_SUPPORTED_ERR = $0caec907a5497a5f$var$ExceptionCode.NOT_SUPPORTED_ERR = ($0caec907a5497a5f$var$ExceptionMessage[9] = "Not supported", 9);
var $0caec907a5497a5f$var$INUSE_ATTRIBUTE_ERR = $0caec907a5497a5f$var$ExceptionCode.INUSE_ATTRIBUTE_ERR = ($0caec907a5497a5f$var$ExceptionMessage[10] = "Attribute in use", 10);
//level2
var $0caec907a5497a5f$var$INVALID_STATE_ERR = $0caec907a5497a5f$var$ExceptionCode.INVALID_STATE_ERR = ($0caec907a5497a5f$var$ExceptionMessage[11] = "Invalid state", 11);
var $0caec907a5497a5f$var$SYNTAX_ERR = $0caec907a5497a5f$var$ExceptionCode.SYNTAX_ERR = ($0caec907a5497a5f$var$ExceptionMessage[12] = "Syntax error", 12);
var $0caec907a5497a5f$var$INVALID_MODIFICATION_ERR = $0caec907a5497a5f$var$ExceptionCode.INVALID_MODIFICATION_ERR = ($0caec907a5497a5f$var$ExceptionMessage[13] = "Invalid modification", 13);
var $0caec907a5497a5f$var$NAMESPACE_ERR = $0caec907a5497a5f$var$ExceptionCode.NAMESPACE_ERR = ($0caec907a5497a5f$var$ExceptionMessage[14] = "Invalid namespace", 14);
var $0caec907a5497a5f$var$INVALID_ACCESS_ERR = $0caec907a5497a5f$var$ExceptionCode.INVALID_ACCESS_ERR = ($0caec907a5497a5f$var$ExceptionMessage[15] = "Invalid access", 15);
/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */ function $0caec907a5497a5f$var$DOMException(code, message) {
    if (message instanceof Error) var error = message;
    else {
        error = this;
        Error.call(this, $0caec907a5497a5f$var$ExceptionMessage[code]);
        this.message = $0caec907a5497a5f$var$ExceptionMessage[code];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $0caec907a5497a5f$var$DOMException);
    }
    error.code = code;
    if (message) this.message = this.message + ": " + message;
    return error;
}
$0caec907a5497a5f$var$DOMException.prototype = Error.prototype;
$0caec907a5497a5f$var$copy($0caec907a5497a5f$var$ExceptionCode, $0caec907a5497a5f$var$DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */ function $0caec907a5497a5f$var$NodeList() {}
$0caec907a5497a5f$var$NodeList.prototype = {
    /**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */ length: 0,
    /**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
	 */ item: function(index) {
        return index >= 0 && index < this.length ? this[index] : null;
    },
    toString: function(isHTML, nodeFilter, options) {
        var requireWellFormed = !!options && !!options.requireWellFormed;
        for(var buf = [], i = 0; i < this.length; i++)$0caec907a5497a5f$var$serializeToString(this[i], buf, isHTML, nodeFilter, null, requireWellFormed);
        return buf.join('');
    },
    /**
	 * @private
	 * @param {function (Node):boolean} predicate
	 * @returns {Node[]}
	 */ filter: function(predicate) {
        return Array.prototype.filter.call(this, predicate);
    },
    /**
	 * @private
	 * @param {Node} item
	 * @returns {number}
	 */ indexOf: function(item) {
        return Array.prototype.indexOf.call(this, item);
    }
};
function $0caec907a5497a5f$var$LiveNodeList(node, refresh) {
    this._node = node;
    this._refresh = refresh;
    $0caec907a5497a5f$var$_updateLiveList(this);
}
function $0caec907a5497a5f$var$_updateLiveList(list) {
    var inc = list._node._inc || list._node.ownerDocument._inc;
    if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        $0caec907a5497a5f$var$__set__(list, 'length', ls.length);
        if (!list.$$length || ls.length < list.$$length) {
            for(var i = ls.length; i in list; i++)if (Object.prototype.hasOwnProperty.call(list, i)) delete list[i];
        }
        $0caec907a5497a5f$var$copy(ls, list);
        list._inc = inc;
    }
}
$0caec907a5497a5f$var$LiveNodeList.prototype.item = function(i) {
    $0caec907a5497a5f$var$_updateLiveList(this);
    return this[i] || null;
};
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$LiveNodeList, $0caec907a5497a5f$var$NodeList);
/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */ function $0caec907a5497a5f$var$NamedNodeMap() {}
function $0caec907a5497a5f$var$_findNodeIndex(list, node) {
    var i = list.length;
    while(i--){
        if (list[i] === node) return i;
    }
}
function $0caec907a5497a5f$var$_addNamedNode(el, list, newAttr, oldAttr) {
    if (oldAttr) list[$0caec907a5497a5f$var$_findNodeIndex(list, oldAttr)] = newAttr;
    else list[list.length++] = newAttr;
    if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
            oldAttr && $0caec907a5497a5f$var$_onRemoveAttribute(doc, el, oldAttr);
            $0caec907a5497a5f$var$_onAddAttribute(doc, el, newAttr);
        }
    }
}
function $0caec907a5497a5f$var$_removeNamedNode(el, list, attr) {
    //console.log('remove attr:'+attr)
    var i = $0caec907a5497a5f$var$_findNodeIndex(list, attr);
    if (i >= 0) {
        var lastIndex = list.length - 1;
        while(i < lastIndex)list[i] = list[++i];
        list.length = lastIndex;
        if (el) {
            var doc = el.ownerDocument;
            if (doc) {
                $0caec907a5497a5f$var$_onRemoveAttribute(doc, el, attr);
                attr.ownerElement = null;
            }
        }
    } else throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$NOT_FOUND_ERR, new Error(el.tagName + '@' + attr));
}
$0caec907a5497a5f$var$NamedNodeMap.prototype = {
    length: 0,
    item: $0caec907a5497a5f$var$NodeList.prototype.item,
    getNamedItem: function(key) {
        //		if(key.indexOf(':')>0 || key == 'xmlns'){
        //			return null;
        //		}
        //console.log()
        var i = this.length;
        while(i--){
            var attr = this[i];
            //console.log(attr.nodeName,key)
            if (attr.nodeName == key) return attr;
        }
    },
    setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el != this._ownerElement) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$INUSE_ATTRIBUTE_ERR);
        var oldAttr = this.getNamedItem(attr.nodeName);
        $0caec907a5497a5f$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ setNamedItemNS: function(attr) {
        var el = attr.ownerElement, oldAttr;
        if (el && el != this._ownerElement) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$INUSE_ATTRIBUTE_ERR);
        oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        $0caec907a5497a5f$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ removeNamedItem: function(key) {
        var attr = this.getNamedItem(key);
        $0caec907a5497a5f$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    //for level2
    removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        $0caec907a5497a5f$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    getNamedItemNS: function(namespaceURI, localName) {
        var i = this.length;
        while(i--){
            var node = this[i];
            if (node.localName == localName && node.namespaceURI == namespaceURI) return node;
        }
        return null;
    }
};
/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */ function $0caec907a5497a5f$var$DOMImplementation() {}
$0caec907a5497a5f$var$DOMImplementation.prototype = {
    /**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */ hasFeature: function(feature, version) {
        return true;
    },
    /**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocument: function(namespaceURI, qualifiedName, doctype) {
        var doc = new $0caec907a5497a5f$var$Document();
        doc.implementation = this;
        doc.childNodes = new $0caec907a5497a5f$var$NodeList();
        doc.doctype = doctype || null;
        if (doctype) doc.appendChild(doctype);
        if (qualifiedName) {
            var root = doc.createElementNS(namespaceURI, qualifiedName);
            doc.appendChild(root);
        }
        return doc;
    },
    /**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This implementation differs from the specification:__
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * Note: `internalSubset` can only be introduced via a direct property write to `node.internalSubset` after creation.
	 * Creation-time validation of `publicId`, `systemId` is not enforced.
	 * The serializer-level check covers all mutation vectors, including direct property writes.
	 * `internalSubset` is only serialized as `[ ... ]` when both `publicId` and `systemId` are
	 * absent (empty or `'.'`) — if either external identifier is present, `internalSubset` is
	 * silently omitted from the serialized output.
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * The external subset public identifier. Stored verbatim including surrounding quotes.
	 * When serialized with `requireWellFormed: true` (via the 4th-parameter options object),
	 * throws `DOMException` with code `INVALID_STATE_ERR` if the value is non-empty and does
	 * not match the XML `PubidLiteral` production (W3C DOM Parsing §3.2.1.3; XML 1.0 [12]).
	 * @param {string} [systemId]
	 * The external subset system identifier. Stored verbatim including surrounding quotes.
	 * When serialized with `requireWellFormed: true`, throws `DOMException` with code
	 * `INVALID_STATE_ERR` if the value is non-empty and does not match the XML `SystemLiteral`
	 * production (W3C DOM Parsing §3.2.1.3; XML 1.0 [11]).
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocumentType: function(qualifiedName, publicId, systemId) {
        var node = new $0caec907a5497a5f$var$DocumentType();
        node.name = qualifiedName;
        node.nodeName = qualifiedName;
        node.publicId = publicId || '';
        node.systemId = systemId || '';
        return node;
    }
};
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */ function $0caec907a5497a5f$var$Node() {}
$0caec907a5497a5f$var$Node.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(newChild, refChild) {
        return $0caec907a5497a5f$var$_insertBefore(this, newChild, refChild);
    },
    replaceChild: function(newChild, oldChild) {
        $0caec907a5497a5f$var$_insertBefore(this, newChild, oldChild, $0caec907a5497a5f$var$assertPreReplacementValidityInDocument);
        if (oldChild) this.removeChild(oldChild);
    },
    removeChild: function(oldChild) {
        return $0caec907a5497a5f$var$_removeChild(this, oldChild);
    },
    appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
    },
    hasChildNodes: function() {
        return this.firstChild != null;
    },
    cloneNode: function(deep) {
        return $0caec907a5497a5f$var$cloneNode(this.ownerDocument || this, this, deep);
    },
    // Modified in DOM Level 2:
    /**
	 * Puts the specified node and all of its subtree into a "normalized" form. In a normalized
	 * subtree, no text nodes in the subtree are empty and there are no adjacent text nodes.
	 *
	 * Specifically, this method merges any adjacent text nodes (i.e., nodes for which `nodeType`
	 * is `TEXT_NODE`) into a single node with the combined data. It also removes any empty text
	 * nodes.
	 *
	 * This method iteratively traverses all child nodes to normalize all descendant nodes within
	 * the subtree.
	 *
	 * @throws {DOMException}
	 * May throw a DOMException if operations within removeChild or appendData (which are
	 * potentially invoked in this method) do not meet their specific constraints.
	 * @see {@link Node.removeChild}
	 * @see {@link CharacterData.appendData}
	 * @see ../docs/walk-dom.md.
	 */ normalize: function() {
        $0caec907a5497a5f$var$walkDOM(this, null, {
            enter: function(node) {
                // Merge adjacent text children of node before walkDOM schedules them.
                // walkDOM reads lastChild/previousSibling after enter returns, so the
                // surviving post-merge children are what it descends into.
                var child = node.firstChild;
                while(child){
                    var next = child.nextSibling;
                    if (next !== null && next.nodeType === $0caec907a5497a5f$var$TEXT_NODE && child.nodeType === $0caec907a5497a5f$var$TEXT_NODE) {
                        node.removeChild(next);
                        child.appendData(next.data);
                    // Do not advance child: re-check new nextSibling for another text run
                    } else child = next;
                }
                return true; // descend into surviving children
            }
        });
    },
    // Introduced in DOM Level 2:
    isSupported: function(feature, version) {
        return this.ownerDocument.implementation.hasFeature(feature, version);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
        return this.attributes.length > 0;
    },
    /**
	 * Look up the prefix associated to the given namespace URI, starting from this node.
	 * **The default namespace declarations are ignored by this method.**
	 * See Namespace Prefix Lookup for details on the algorithm used by this method.
	 *
	 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
	 *
	 * @param {string | null} namespaceURI
	 * @returns {string | null}
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
	 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
	 * @see https://github.com/xmldom/xmldom/issues/322
	 */ lookupPrefix: function(namespaceURI) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) for(var n in map){
                if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) return n;
            }
            el = el.nodeType == $0caec907a5497a5f$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(prefix) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) {
                if (Object.prototype.hasOwnProperty.call(map, prefix)) return map[prefix];
            }
            el = el.nodeType == $0caec907a5497a5f$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(namespaceURI) {
        var prefix = this.lookupPrefix(namespaceURI);
        return prefix == null;
    }
};
function $0caec907a5497a5f$var$_xmlEncoder(c) {
    return c == '<' && '&lt;' || c == '>' && '&gt;' || c == '&' && '&amp;' || c == '"' && '&quot;' || '&#' + c.charCodeAt() + ';';
}
$0caec907a5497a5f$var$copy($0caec907a5497a5f$var$NodeType, $0caec907a5497a5f$var$Node);
$0caec907a5497a5f$var$copy($0caec907a5497a5f$var$NodeType, $0caec907a5497a5f$var$Node.prototype);
/**
 * @param {Node} node
 * Root of the subtree to visit.
 * @param {function(Node): boolean} callback
 * Called for each node in depth-first pre-order. Return a truthy value to stop traversal early.
 * @return {boolean} `true` if traversal was aborted by the callback, `false` otherwise.
 */ function $0caec907a5497a5f$var$_visitNode(node, callback) {
    return $0caec907a5497a5f$var$walkDOM(node, null, {
        enter: function(n) {
            return callback(n) ? $0caec907a5497a5f$var$walkDOM.STOP : true;
        }
    }) === $0caec907a5497a5f$var$walkDOM.STOP;
}
/**
 * Depth-first pre/post-order DOM tree walker.
 *
 * Visits every node in the subtree rooted at `node`. For each node:
 *
 * 1. Calls `callbacks.enter(node, context)` before descending into the node's children. The
 * return value becomes the `context` passed to each child's `enter` call and to the matching
 * `exit` call.
 * 2. If `enter` returns `null` or `undefined`, the node's children are skipped;
 * sibling traversal continues normally.
 * 3. If `enter` returns `walkDOM.STOP`, the entire traversal is aborted immediately — no
 * further `enter` or `exit` calls are made.
 * 4. `lastChild` and `previousSibling` are read **after** `enter` returns, so `enter` may
 * safely modify the node's own child list before the walker descends. Modifying siblings of
 * the current node or any other part of the tree produces unpredictable results: nodes already
 * queued on the stack are visited regardless of DOM changes, and newly inserted nodes outside
 * the current child list are never visited.
 * 5. Calls `callbacks.exit(node, context)` (if provided) after all of a node's children have
 * been visited, passing the same `context` that `enter`
 * returned for that node.
 *
 * This implementation uses an explicit stack and does not recurse — it is safe on arbitrarily
 * deep trees.
 *
 * @param {Node} node
 * Root of the subtree to walk.
 * @param {*} context
 * Initial context value passed to the root node's `enter`.
 * @param {{ enter: function(Node, *): *, exit?: function(Node, *): void }} callbacks
 * @returns {void | walkDOM.STOP}
 * @see ../docs/walk-dom.md.
 */ function $0caec907a5497a5f$var$walkDOM(node, context, callbacks) {
    // Each stack frame is {node, context, phase}:
    //   walkDOM.ENTER — call enter, then push children
    //   walkDOM.EXIT  — call exit
    var stack = [
        {
            node: node,
            context: context,
            phase: $0caec907a5497a5f$var$walkDOM.ENTER
        }
    ];
    while(stack.length > 0){
        var frame = stack.pop();
        if (frame.phase === $0caec907a5497a5f$var$walkDOM.ENTER) {
            var childContext = callbacks.enter(frame.node, frame.context);
            if (childContext === $0caec907a5497a5f$var$walkDOM.STOP) return $0caec907a5497a5f$var$walkDOM.STOP;
            // Push exit frame before children so it fires after all children are processed (Last In First Out)
            stack.push({
                node: frame.node,
                context: childContext,
                phase: $0caec907a5497a5f$var$walkDOM.EXIT
            });
            if (childContext === null || childContext === undefined) continue; // skip children
            // lastChild is read after enter returns, so enter may modify the child list.
            var child = frame.node.lastChild;
            // Traverse from lastChild backwards so that pushing onto the stack
            // naturally yields firstChild on top (processed first).
            while(child){
                stack.push({
                    node: child,
                    context: childContext,
                    phase: $0caec907a5497a5f$var$walkDOM.ENTER
                });
                child = child.previousSibling;
            }
        } else // frame.phase === walkDOM.EXIT
        if (callbacks.exit) callbacks.exit(frame.node, frame.context);
    }
}
/**
 * Sentinel value returned from a `walkDOM` `enter` callback to abort the entire traversal
 * immediately.
 *
 * @type {symbol}
 */ $0caec907a5497a5f$var$walkDOM.STOP = Symbol('walkDOM.STOP');
/**
 * Phase constant for a stack frame that has not yet been visited.
 * The `enter` callback is called and children are scheduled.
 *
 * @type {number}
 */ $0caec907a5497a5f$var$walkDOM.ENTER = 0;
/**
 * Phase constant for a stack frame whose subtree has been fully visited.
 * The `exit` callback is called.
 *
 * @type {number}
 */ $0caec907a5497a5f$var$walkDOM.EXIT = 1;
function $0caec907a5497a5f$var$Document() {
    this.ownerDocument = this;
}
function $0caec907a5497a5f$var$_onAddAttribute(doc, el, newAttr) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $0caec907a5497a5f$var$NAMESPACE.XMLNS) //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value;
}
function $0caec907a5497a5f$var$_onRemoveAttribute(doc, el, newAttr, remove) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $0caec907a5497a5f$var$NAMESPACE.XMLNS) //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ''];
}
/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */ function $0caec907a5497a5f$var$_onUpdateChild(doc, el, newChild) {
    if (doc && doc._inc) {
        doc._inc++;
        //update childNodes
        var cs = el.childNodes;
        if (newChild) cs[cs.length++] = newChild;
        else {
            var child = el.firstChild;
            var i = 0;
            while(child){
                cs[i++] = child;
                child = child.nextSibling;
            }
            cs.length = i;
            delete cs[cs.length];
        }
    }
}
/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */ function $0caec907a5497a5f$var$_removeChild(parentNode, child) {
    var previous = child.previousSibling;
    var next = child.nextSibling;
    if (previous) previous.nextSibling = next;
    else parentNode.firstChild = next;
    if (next) next.previousSibling = previous;
    else parentNode.lastChild = previous;
    child.parentNode = null;
    child.previousSibling = null;
    child.nextSibling = null;
    $0caec907a5497a5f$var$_onUpdateChild(parentNode.ownerDocument, parentNode);
    return child;
}
/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */ function $0caec907a5497a5f$var$hasValidParentNodeType(node) {
    return node && (node.nodeType === $0caec907a5497a5f$var$Node.DOCUMENT_NODE || node.nodeType === $0caec907a5497a5f$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $0caec907a5497a5f$var$Node.ELEMENT_NODE);
}
/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */ function $0caec907a5497a5f$var$hasInsertableNodeType(node) {
    return node && ($0caec907a5497a5f$var$isElementNode(node) || $0caec907a5497a5f$var$isTextNode(node) || $0caec907a5497a5f$var$isDocTypeNode(node) || node.nodeType === $0caec907a5497a5f$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $0caec907a5497a5f$var$Node.COMMENT_NODE || node.nodeType === $0caec907a5497a5f$var$Node.PROCESSING_INSTRUCTION_NODE);
}
/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */ function $0caec907a5497a5f$var$isDocTypeNode(node) {
    return node && node.nodeType === $0caec907a5497a5f$var$Node.DOCUMENT_TYPE_NODE;
}
/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */ function $0caec907a5497a5f$var$isElementNode(node) {
    return node && node.nodeType === $0caec907a5497a5f$var$Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */ function $0caec907a5497a5f$var$isTextNode(node) {
    return node && node.nodeType === $0caec907a5497a5f$var$Node.TEXT_NODE;
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $0caec907a5497a5f$var$isElementInsertionPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    if ($0caec907a5497a5f$var$find(parentChildNodes, $0caec907a5497a5f$var$isElementNode) || $0caec907a5497a5f$var$isDocTypeNode(child)) return false;
    var docTypeNode = $0caec907a5497a5f$var$find(parentChildNodes, $0caec907a5497a5f$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $0caec907a5497a5f$var$isElementReplacementPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    function hasElementChildThatIsNotChild(node) {
        return $0caec907a5497a5f$var$isElementNode(node) && node !== child;
    }
    if ($0caec907a5497a5f$var$find(parentChildNodes, hasElementChildThatIsNotChild)) return false;
    var docTypeNode = $0caec907a5497a5f$var$find(parentChildNodes, $0caec907a5497a5f$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $0caec907a5497a5f$var$assertPreInsertionValidity1to5(parent, node, child) {
    // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
    if (!$0caec907a5497a5f$var$hasValidParentNodeType(parent)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
    // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
    // not implemented!
    // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
    if (child && child.parentNode !== parent) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$NOT_FOUND_ERR, 'child not in parent');
    if (// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !$0caec907a5497a5f$var$hasInsertableNodeType(node) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    $0caec907a5497a5f$var$isDocTypeNode(node) && parent.nodeType !== $0caec907a5497a5f$var$Node.DOCUMENT_NODE) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType);
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $0caec907a5497a5f$var$assertPreInsertionValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $0caec907a5497a5f$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($0caec907a5497a5f$var$isElementNode);
        // If node has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $0caec907a5497a5f$var$find(nodeChildNodes, $0caec907a5497a5f$var$isTextNode)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child,
        // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$0caec907a5497a5f$var$isElementInsertionPossible(parent, child)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($0caec907a5497a5f$var$isElementNode(node)) {
        // `parent` has an element child, `child` is a doctype,
        // or `child` is non-null and a doctype is following `child`.
        if (!$0caec907a5497a5f$var$isElementInsertionPossible(parent, child)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($0caec907a5497a5f$var$isDocTypeNode(node)) {
        // `parent` has a doctype child,
        if ($0caec907a5497a5f$var$find(parentChildNodes, $0caec907a5497a5f$var$isDocTypeNode)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $0caec907a5497a5f$var$find(parentChildNodes, $0caec907a5497a5f$var$isElementNode);
        // `child` is non-null and an element is preceding `child`,
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
        // or `child` is null and `parent` has an element child.
        if (!child && parentElementChild) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
    }
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $0caec907a5497a5f$var$assertPreReplacementValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $0caec907a5497a5f$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($0caec907a5497a5f$var$isElementNode);
        // If `node` has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $0caec907a5497a5f$var$find(nodeChildNodes, $0caec907a5497a5f$var$isTextNode)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$0caec907a5497a5f$var$isElementReplacementPossible(parent, child)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($0caec907a5497a5f$var$isElementNode(node)) {
        // `parent` has an element child that is not `child` or a doctype is following `child`.
        if (!$0caec907a5497a5f$var$isElementReplacementPossible(parent, child)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($0caec907a5497a5f$var$isDocTypeNode(node)) {
        function hasDoctypeChildThatIsNotChild(node) {
            return $0caec907a5497a5f$var$isDocTypeNode(node) && node !== child;
        }
        // `parent` has a doctype child that is not `child`,
        if ($0caec907a5497a5f$var$find(parentChildNodes, hasDoctypeChildThatIsNotChild)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $0caec907a5497a5f$var$find(parentChildNodes, $0caec907a5497a5f$var$isElementNode);
        // or an element is preceding `child`.
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
    }
}
/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $0caec907a5497a5f$var$_insertBefore(parent, node, child, _inDocumentAssertion) {
    // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
    $0caec907a5497a5f$var$assertPreInsertionValidity1to5(parent, node, child);
    // If parent is a document, and any of the statements below, switched on the interface node implements,
    // are true, then throw a "HierarchyRequestError" DOMException.
    if (parent.nodeType === $0caec907a5497a5f$var$Node.DOCUMENT_NODE) (_inDocumentAssertion || $0caec907a5497a5f$var$assertPreInsertionValidityInDocument)(parent, node, child);
    var cp = node.parentNode;
    if (cp) cp.removeChild(node); //remove and update
    if (node.nodeType === $0caec907a5497a5f$var$DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node.firstChild;
        if (newFirst == null) return node;
        var newLast = node.lastChild;
    } else newFirst = newLast = node;
    var pre = child ? child.previousSibling : parent.lastChild;
    newFirst.previousSibling = pre;
    newLast.nextSibling = child;
    if (pre) pre.nextSibling = newFirst;
    else parent.firstChild = newFirst;
    if (child == null) parent.lastChild = newLast;
    else child.previousSibling = newLast;
    do {
        newFirst.parentNode = parent;
        // Update ownerDocument for each node being inserted
        var targetDoc = parent.ownerDocument || parent;
        $0caec907a5497a5f$var$_updateOwnerDocument(newFirst, targetDoc);
    }while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
    $0caec907a5497a5f$var$_onUpdateChild(parent.ownerDocument || parent, parent);
    //console.log(parent.lastChild.nextSibling == null)
    if (node.nodeType == $0caec907a5497a5f$var$DOCUMENT_FRAGMENT_NODE) node.firstChild = node.lastChild = null;
    return node;
}
/**
 * Recursively updates the ownerDocument property for a node and all its descendants
 * @param {Node} node
 * @param {Document} newOwnerDocument
 * @private
 */ function $0caec907a5497a5f$var$_updateOwnerDocument(node, newOwnerDocument) {
    if (node.ownerDocument === newOwnerDocument) return;
    node.ownerDocument = newOwnerDocument;
    // Update attributes if this is an element
    if (node.nodeType === $0caec907a5497a5f$var$ELEMENT_NODE && node.attributes) for(var i = 0; i < node.attributes.length; i++){
        var attr = node.attributes.item(i);
        if (attr) attr.ownerDocument = newOwnerDocument;
    }
    // Recursively update child nodes
    var child = node.firstChild;
    while(child){
        $0caec907a5497a5f$var$_updateOwnerDocument(child, newOwnerDocument);
        child = child.nextSibling;
    }
}
/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */ function $0caec907a5497a5f$var$_appendSingleChild(parentNode, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.parentNode = parentNode;
    newChild.previousSibling = parentNode.lastChild;
    newChild.nextSibling = null;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parentNode.firstChild = newChild;
    parentNode.lastChild = newChild;
    $0caec907a5497a5f$var$_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
    // Update ownerDocument for the new child and all its descendants
    var targetDoc = parentNode.ownerDocument || parentNode;
    $0caec907a5497a5f$var$_updateOwnerDocument(newChild, targetDoc);
    return newChild;
}
$0caec907a5497a5f$var$Document.prototype = {
    //implementation : null,
    nodeName: '#document',
    nodeType: $0caec907a5497a5f$var$DOCUMENT_NODE,
    /**
	 * The DocumentType node of the document.
	 *
	 * @readonly
	 * @type DocumentType
	 */ doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(newChild, refChild) {
        if (newChild.nodeType == $0caec907a5497a5f$var$DOCUMENT_FRAGMENT_NODE) {
            var child = newChild.firstChild;
            while(child){
                var next = child.nextSibling;
                this.insertBefore(child, refChild);
                child = next;
            }
            return newChild;
        }
        $0caec907a5497a5f$var$_insertBefore(this, newChild, refChild);
        $0caec907a5497a5f$var$_updateOwnerDocument(newChild, this);
        if (this.documentElement === null && newChild.nodeType === $0caec907a5497a5f$var$ELEMENT_NODE) this.documentElement = newChild;
        return newChild;
    },
    removeChild: function(oldChild) {
        if (this.documentElement == oldChild) this.documentElement = null;
        return $0caec907a5497a5f$var$_removeChild(this, oldChild);
    },
    replaceChild: function(newChild, oldChild) {
        //raises
        $0caec907a5497a5f$var$_insertBefore(this, newChild, oldChild, $0caec907a5497a5f$var$assertPreReplacementValidityInDocument);
        $0caec907a5497a5f$var$_updateOwnerDocument(newChild, this);
        if (oldChild) this.removeChild(oldChild);
        if ($0caec907a5497a5f$var$isElementNode(newChild)) this.documentElement = newChild;
    },
    // Introduced in DOM Level 2:
    importNode: function(importedNode, deep) {
        return $0caec907a5497a5f$var$importNode(this, importedNode, deep);
    },
    // Introduced in DOM Level 2:
    getElementById: function(id) {
        var rtv = null;
        $0caec907a5497a5f$var$_visitNode(this.documentElement, function(node) {
            if (node.nodeType == $0caec907a5497a5f$var$ELEMENT_NODE) {
                if (node.getAttribute('id') == id) {
                    rtv = node;
                    return true;
                }
            }
        });
        return rtv;
    },
    /**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */ getElementsByClassName: function(classNames) {
        var classNamesSet = $0caec907a5497a5f$var$toOrderedSet(classNames);
        return new $0caec907a5497a5f$var$LiveNodeList(this, function(base) {
            var ls = [];
            if (classNamesSet.length > 0) $0caec907a5497a5f$var$_visitNode(base.documentElement, function(node) {
                if (node !== base && node.nodeType === $0caec907a5497a5f$var$ELEMENT_NODE) {
                    var nodeClassNames = node.getAttribute('class');
                    // can be null if the attribute does not exist
                    if (nodeClassNames) {
                        // before splitting and iterating just compare them for the most common case
                        var matches = classNames === nodeClassNames;
                        if (!matches) {
                            var nodeClassNamesSet = $0caec907a5497a5f$var$toOrderedSet(nodeClassNames);
                            matches = classNamesSet.every($0caec907a5497a5f$var$arrayIncludes(nodeClassNamesSet));
                        }
                        if (matches) ls.push(node);
                    }
                }
            });
            return ls;
        });
    },
    //document factory method:
    createElement: function(tagName) {
        var node = new $0caec907a5497a5f$var$Element();
        node.ownerDocument = this;
        node.nodeName = tagName;
        node.tagName = tagName;
        node.localName = tagName;
        node.childNodes = new $0caec907a5497a5f$var$NodeList();
        var attrs = node.attributes = new $0caec907a5497a5f$var$NamedNodeMap();
        attrs._ownerElement = node;
        return node;
    },
    createDocumentFragment: function() {
        var node = new $0caec907a5497a5f$var$DocumentFragment();
        node.ownerDocument = this;
        node.childNodes = new $0caec907a5497a5f$var$NodeList();
        return node;
    },
    createTextNode: function(data) {
        var node = new $0caec907a5497a5f$var$Text();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createComment: function(data) {
        var node = new $0caec907a5497a5f$var$Comment();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    /**
	 * Returns a new CDATASection node whose data is `data`.
	 *
	 * __This implementation differs from the specification:__
	 * - calling this method on an HTML document does not throw `NotSupportedError`.
	 *
	 * @param {string} data
	 * @returns {CDATASection}
	 * @throws DOMException with code `INVALID_CHARACTER_ERR` if `data` contains `"]]>"`.
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/createCDATASection
	 * @see https://dom.spec.whatwg.org/#dom-document-createcdatasection
	 */ createCDATASection: function(data) {
        if (data.indexOf(']]>') !== -1) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$INVALID_CHARACTER_ERR, 'data contains "]]>"');
        var node = new $0caec907a5497a5f$var$CDATASection();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    /**
	 * Returns a ProcessingInstruction node whose target is target and data is data.
	 *
	 * __This implementation differs from the specification:__
	 * - it does not do any input validation on the arguments and doesn't throw "InvalidCharacterError".
	 *
	 * Note: When the resulting document is serialized with `requireWellFormed: true`, the
	 * serializer throws with code `INVALID_STATE_ERR` if `.data` contains `?>` (W3C DOM Parsing
	 * §3.2.1.7). Without that option the data is emitted verbatim.
	 *
	 * @param {string} target
	 * @param {string} data
	 * @returns {ProcessingInstruction}
	 * @see https://developer.mozilla.org/docs/Web/API/Document/createProcessingInstruction
	 * @see https://dom.spec.whatwg.org/#dom-document-createprocessinginstruction
	 * @see https://www.w3.org/TR/DOM-Parsing/#dfn-concept-serialize-xml §3.2.1.7
	 */ createProcessingInstruction: function(target, data) {
        var node = new $0caec907a5497a5f$var$ProcessingInstruction();
        node.ownerDocument = this;
        node.tagName = node.nodeName = node.target = target;
        node.nodeValue = node.data = data;
        return node;
    },
    createAttribute: function(name) {
        var node = new $0caec907a5497a5f$var$Attr();
        node.ownerDocument = this;
        node.name = name;
        node.nodeName = name;
        node.localName = name;
        node.specified = true;
        return node;
    },
    createEntityReference: function(name) {
        var node = new $0caec907a5497a5f$var$EntityReference();
        node.ownerDocument = this;
        node.nodeName = name;
        return node;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(namespaceURI, qualifiedName) {
        var node = new $0caec907a5497a5f$var$Element();
        var pl = qualifiedName.split(':');
        var attrs = node.attributes = new $0caec907a5497a5f$var$NamedNodeMap();
        node.childNodes = new $0caec907a5497a5f$var$NodeList();
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.tagName = qualifiedName;
        node.namespaceURI = namespaceURI;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        attrs._ownerElement = node;
        return node;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(namespaceURI, qualifiedName) {
        var node = new $0caec907a5497a5f$var$Attr();
        var pl = qualifiedName.split(':');
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.name = qualifiedName;
        node.namespaceURI = namespaceURI;
        node.specified = true;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        return node;
    }
};
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$Document, $0caec907a5497a5f$var$Node);
function $0caec907a5497a5f$var$Element() {
    this._nsMap = {};
}
$0caec907a5497a5f$var$Element.prototype = {
    nodeType: $0caec907a5497a5f$var$ELEMENT_NODE,
    hasAttribute: function(name) {
        return this.getAttributeNode(name) != null;
    },
    getAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        return attr && attr.value || '';
    },
    getAttributeNode: function(name) {
        return this.attributes.getNamedItem(name);
    },
    setAttribute: function(name, value) {
        var attr = this.ownerDocument.createAttribute(name);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    removeAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        attr && this.removeAttributeNode(attr);
    },
    //four real opeartion method
    appendChild: function(newChild) {
        if (newChild.nodeType === $0caec907a5497a5f$var$DOCUMENT_FRAGMENT_NODE) return this.insertBefore(newChild, null);
        else return $0caec907a5497a5f$var$_appendSingleChild(this, newChild);
    },
    setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
    },
    setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
    },
    removeAttributeNode: function(oldAttr) {
        //console.log(this == oldAttr.ownerElement)
        return this.attributes.removeNamedItem(oldAttr.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
    },
    hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
    },
    getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr && attr.value || '';
    },
    setAttributeNS: function(namespaceURI, qualifiedName, value) {
        var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
    },
    getElementsByTagName: function(tagName) {
        return new $0caec907a5497a5f$var$LiveNodeList(this, function(base) {
            var ls = [];
            $0caec907a5497a5f$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType == $0caec907a5497a5f$var$ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) ls.push(node);
            });
            return ls;
        });
    },
    getElementsByTagNameNS: function(namespaceURI, localName) {
        return new $0caec907a5497a5f$var$LiveNodeList(this, function(base) {
            var ls = [];
            $0caec907a5497a5f$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType === $0caec907a5497a5f$var$ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) ls.push(node);
            });
            return ls;
        });
    }
};
$0caec907a5497a5f$var$Document.prototype.getElementsByTagName = $0caec907a5497a5f$var$Element.prototype.getElementsByTagName;
$0caec907a5497a5f$var$Document.prototype.getElementsByTagNameNS = $0caec907a5497a5f$var$Element.prototype.getElementsByTagNameNS;
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$Element, $0caec907a5497a5f$var$Node);
function $0caec907a5497a5f$var$Attr() {}
$0caec907a5497a5f$var$Attr.prototype.nodeType = $0caec907a5497a5f$var$ATTRIBUTE_NODE;
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$Attr, $0caec907a5497a5f$var$Node);
function $0caec907a5497a5f$var$CharacterData() {}
$0caec907a5497a5f$var$CharacterData.prototype = {
    data: '',
    substringData: function(offset, count) {
        return this.data.substring(offset, offset + count);
    },
    appendData: function(text) {
        text = this.data + text;
        this.nodeValue = this.data = text;
        this.length = text.length;
    },
    insertData: function(offset, text) {
        this.replaceData(offset, 0, text);
    },
    appendChild: function(newChild) {
        throw new Error($0caec907a5497a5f$var$ExceptionMessage[$0caec907a5497a5f$var$HIERARCHY_REQUEST_ERR]);
    },
    deleteData: function(offset, count) {
        this.replaceData(offset, count, "");
    },
    replaceData: function(offset, count, text) {
        var start = this.data.substring(0, offset);
        var end = this.data.substring(offset + count);
        text = start + text + end;
        this.nodeValue = this.data = text;
        this.length = text.length;
    }
};
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$CharacterData, $0caec907a5497a5f$var$Node);
function $0caec907a5497a5f$var$Text() {}
$0caec907a5497a5f$var$Text.prototype = {
    nodeName: "#text",
    nodeType: $0caec907a5497a5f$var$TEXT_NODE,
    splitText: function(offset) {
        var text = this.data;
        var newText = text.substring(offset);
        text = text.substring(0, offset);
        this.data = this.nodeValue = text;
        this.length = text.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) this.parentNode.insertBefore(newNode, this.nextSibling);
        return newNode;
    }
};
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$Text, $0caec907a5497a5f$var$CharacterData);
function $0caec907a5497a5f$var$Comment() {}
$0caec907a5497a5f$var$Comment.prototype = {
    nodeName: "#comment",
    nodeType: $0caec907a5497a5f$var$COMMENT_NODE
};
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$Comment, $0caec907a5497a5f$var$CharacterData);
function $0caec907a5497a5f$var$CDATASection() {}
$0caec907a5497a5f$var$CDATASection.prototype = {
    nodeName: "#cdata-section",
    nodeType: $0caec907a5497a5f$var$CDATA_SECTION_NODE
};
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$CDATASection, $0caec907a5497a5f$var$CharacterData);
/**
 * Represents a DocumentType node (the `<!DOCTYPE ...>` declaration).
 *
 * `publicId`, `systemId`, and `internalSubset` are plain own-property assignments.
 * xmldom does not enforce the `readonly` constraint declared by the WHATWG DOM spec —
 * direct property writes succeed silently. Values are serialized verbatim when
 * `requireWellFormed` is false (the default). When the serializer is invoked with
 * `requireWellFormed: true` (via the 4th-parameter options object), it validates each
 * field and throws `DOMException` with code `INVALID_STATE_ERR` on invalid values.
 *
 * @class
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DocumentType MDN
 */ function $0caec907a5497a5f$var$DocumentType() {}
$0caec907a5497a5f$var$DocumentType.prototype.nodeType = $0caec907a5497a5f$var$DOCUMENT_TYPE_NODE;
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$DocumentType, $0caec907a5497a5f$var$Node);
function $0caec907a5497a5f$var$Notation() {}
$0caec907a5497a5f$var$Notation.prototype.nodeType = $0caec907a5497a5f$var$NOTATION_NODE;
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$Notation, $0caec907a5497a5f$var$Node);
function $0caec907a5497a5f$var$Entity() {}
$0caec907a5497a5f$var$Entity.prototype.nodeType = $0caec907a5497a5f$var$ENTITY_NODE;
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$Entity, $0caec907a5497a5f$var$Node);
function $0caec907a5497a5f$var$EntityReference() {}
$0caec907a5497a5f$var$EntityReference.prototype.nodeType = $0caec907a5497a5f$var$ENTITY_REFERENCE_NODE;
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$EntityReference, $0caec907a5497a5f$var$Node);
function $0caec907a5497a5f$var$DocumentFragment() {}
$0caec907a5497a5f$var$DocumentFragment.prototype.nodeName = "#document-fragment";
$0caec907a5497a5f$var$DocumentFragment.prototype.nodeType = $0caec907a5497a5f$var$DOCUMENT_FRAGMENT_NODE;
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$DocumentFragment, $0caec907a5497a5f$var$Node);
function $0caec907a5497a5f$var$ProcessingInstruction() {}
$0caec907a5497a5f$var$ProcessingInstruction.prototype.nodeType = $0caec907a5497a5f$var$PROCESSING_INSTRUCTION_NODE;
$0caec907a5497a5f$var$_extends($0caec907a5497a5f$var$ProcessingInstruction, $0caec907a5497a5f$var$Node);
function $0caec907a5497a5f$var$XMLSerializer() {}
/**
 * Returns the result of serializing `node` to XML.
 *
 * When `options.requireWellFormed` is `true`, the serializer throws for content that would
 * produce ill-formed XML.
 *
 * __This implementation differs from the specification:__
 * - CDATASection nodes whose data contains `]]>` are serialized by splitting the section
 *   at each `]]>` occurrence (following W3C DOM Level 3 Core `split-cdata-sections`
 *   default behaviour) unless `requireWellFormed` is `true`.
 * - when `requireWellFormed` is `true`, `DOMException` with code `INVALID_STATE_ERR`
 *   is only thrown to prevent injection vectors, not for all the spec mandated checks.
 *
 * @param {Node} node
 * @param {boolean} [isHtml]
 * @param {function} [nodeFilter]
 * @param {Object} [options]
 * @param {boolean} [options.requireWellFormed=false]
 * When `true`, throws for content that would produce ill-formed XML.
 * @returns {string}
 * @throws {DOMException}
 * With code `INVALID_STATE_ERR` when `requireWellFormed` is `true` and:
 * - a CDATASection node's data contains `"]]>"`,
 * - a Comment node's data contains `"-->"` (bare `"--"` does not throw on this branch),
 * - a ProcessingInstruction's data contains `"?>"`,
 * - a DocumentType's `publicId` is non-empty and does not match the XML `PubidLiteral`
 *   production,
 * - a DocumentType's `systemId` is non-empty and does not match the XML `SystemLiteral`
 *   production, or
 * - a DocumentType's `internalSubset` contains `"]>"`.
 * Note: xmldom does not enforce `readonly` on DocumentType fields — direct property
 * writes succeed and are covered by the serializer-level checks above.
 * @see https://html.spec.whatwg.org/#dom-xmlserializer-serializetostring
 * @see https://w3c.github.io/DOM-Parsing/#xml-serialization
 * @see https://github.com/w3c/DOM-Parsing/issues/84
 */ $0caec907a5497a5f$var$XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter, options) {
    return $0caec907a5497a5f$var$nodeSerializeToString.call(node, isHtml, nodeFilter, options);
};
$0caec907a5497a5f$var$Node.prototype.toString = $0caec907a5497a5f$var$nodeSerializeToString;
function $0caec907a5497a5f$var$nodeSerializeToString(isHtml, nodeFilter, options) {
    var requireWellFormed = !!options && !!options.requireWellFormed;
    var buf = [];
    var refNode = this.nodeType == 9 && this.documentElement || this;
    var prefix = refNode.prefix;
    var uri = refNode.namespaceURI;
    if (uri && prefix == null) {
        //console.log(prefix)
        var prefix = refNode.lookupPrefix(uri);
        if (prefix == null) //isHTML = true;
        var visibleNamespaces = [
            {
                namespace: uri,
                prefix: null
            }
        ];
    }
    $0caec907a5497a5f$var$serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces, requireWellFormed);
    //console.log('###',this.nodeType,uri,prefix,buf.join(''))
    return buf.join('');
}
function $0caec907a5497a5f$var$needNamespaceDefine(node, isHTML, visibleNamespaces) {
    var prefix = node.prefix || '';
    var uri = node.namespaceURI;
    // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
    // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
    // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
    // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
    // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
    // > [...] Furthermore, the attribute value [...] must not be an empty string.
    // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
    if (!uri) return false;
    if (prefix === "xml" && uri === $0caec907a5497a5f$var$NAMESPACE.XML || uri === $0caec907a5497a5f$var$NAMESPACE.XMLNS) return false;
    var i = visibleNamespaces.length;
    while(i--){
        var ns = visibleNamespaces[i];
        // get namespace prefix
        if (ns.prefix === prefix) return ns.namespace !== uri;
    }
    return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */ function $0caec907a5497a5f$var$addSerializedAttribute(buf, qualifiedName, value) {
    buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, $0caec907a5497a5f$var$_xmlEncoder), '"');
}
function $0caec907a5497a5f$var$serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces, requireWellFormed) {
    if (!visibleNamespaces) visibleNamespaces = [];
    $0caec907a5497a5f$var$walkDOM(node, {
        ns: visibleNamespaces,
        isHTML: isHTML
    }, {
        enter: function(n, ctx) {
            var ns = ctx.ns;
            var html = ctx.isHTML;
            if (nodeFilter) {
                n = nodeFilter(n);
                if (n) {
                    if (typeof n == 'string') {
                        buf.push(n);
                        return null;
                    }
                } else return null;
            }
            switch(n.nodeType){
                case $0caec907a5497a5f$var$ELEMENT_NODE:
                    var attrs = n.attributes;
                    var len = attrs.length;
                    var nodeName = n.tagName;
                    html = $0caec907a5497a5f$var$NAMESPACE.isHTML(n.namespaceURI) || html;
                    var prefixedNodeName = nodeName;
                    if (!html && !n.prefix && n.namespaceURI) {
                        var defaultNS;
                        // lookup current default ns from `xmlns` attribute
                        for(var ai = 0; ai < attrs.length; ai++)if (attrs.item(ai).name === 'xmlns') {
                            defaultNS = attrs.item(ai).value;
                            break;
                        }
                        if (!defaultNS) // lookup current default ns in visibleNamespaces
                        for(var nsi = ns.length - 1; nsi >= 0; nsi--){
                            var nsEntry = ns[nsi];
                            if (nsEntry.prefix === '' && nsEntry.namespace === n.namespaceURI) {
                                defaultNS = nsEntry.namespace;
                                break;
                            }
                        }
                        if (defaultNS !== n.namespaceURI) for(var nsi = ns.length - 1; nsi >= 0; nsi--){
                            var nsEntry = ns[nsi];
                            if (nsEntry.namespace === n.namespaceURI) {
                                if (nsEntry.prefix) prefixedNodeName = nsEntry.prefix + ':' + nodeName;
                                break;
                            }
                        }
                    }
                    buf.push('<', prefixedNodeName);
                    // Build a fresh namespace snapshot for this element's children.
                    // The slice prevents sibling elements from inheriting each other's declarations.
                    var childNs = ns.slice();
                    for(var i = 0; i < len; i++){
                        var attr = attrs.item(i);
                        if (attr.prefix == 'xmlns') childNs.push({
                            prefix: attr.localName,
                            namespace: attr.value
                        });
                        else if (attr.nodeName == 'xmlns') childNs.push({
                            prefix: '',
                            namespace: attr.value
                        });
                    }
                    for(var i = 0; i < len; i++){
                        var attr = attrs.item(i);
                        if ($0caec907a5497a5f$var$needNamespaceDefine(attr, html, childNs)) {
                            var attrPrefix = attr.prefix || '';
                            var uri = attr.namespaceURI;
                            $0caec907a5497a5f$var$addSerializedAttribute(buf, attrPrefix ? 'xmlns:' + attrPrefix : 'xmlns', uri);
                            childNs.push({
                                prefix: attrPrefix,
                                namespace: uri
                            });
                        }
                        // Apply nodeFilter and serialize the attribute.
                        var filteredAttr = nodeFilter ? nodeFilter(attr) : attr;
                        if (filteredAttr) {
                            if (typeof filteredAttr === 'string') buf.push(filteredAttr);
                            else $0caec907a5497a5f$var$addSerializedAttribute(buf, filteredAttr.name, filteredAttr.value);
                        }
                    }
                    // add namespace for current node
                    if (nodeName === prefixedNodeName && $0caec907a5497a5f$var$needNamespaceDefine(n, html, childNs)) {
                        var nodePrefix = n.prefix || '';
                        var uri = n.namespaceURI;
                        $0caec907a5497a5f$var$addSerializedAttribute(buf, nodePrefix ? 'xmlns:' + nodePrefix : 'xmlns', uri);
                        childNs.push({
                            prefix: nodePrefix,
                            namespace: uri
                        });
                    }
                    var child = n.firstChild;
                    if (child || html && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
                        buf.push('>');
                        if (html && /^script$/i.test(nodeName)) {
                            // Inline serialization for <script> children; return null to skip walkDOM descent.
                            while(child){
                                if (child.data) buf.push(child.data);
                                else $0caec907a5497a5f$var$serializeToString(child, buf, html, nodeFilter, childNs.slice(), requireWellFormed);
                                child = child.nextSibling;
                            }
                            buf.push('</', nodeName, '>');
                            return null;
                        }
                        // Return child context; walkDOM descends and exit emits the closing tag.
                        return {
                            ns: childNs,
                            isHTML: html,
                            tag: prefixedNodeName
                        };
                    } else {
                        buf.push('/>');
                        return null;
                    }
                case $0caec907a5497a5f$var$DOCUMENT_NODE:
                case $0caec907a5497a5f$var$DOCUMENT_FRAGMENT_NODE:
                    // Descend into children; exit is a no-op (tag is null).
                    return {
                        ns: ns.slice(),
                        isHTML: html,
                        tag: null
                    };
                case $0caec907a5497a5f$var$ATTRIBUTE_NODE:
                    $0caec907a5497a5f$var$addSerializedAttribute(buf, n.name, n.value);
                    return null;
                case $0caec907a5497a5f$var$TEXT_NODE:
                    /**
					 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
					 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
					 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
					 * `&amp;` and `&lt;` respectively.
					 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
					 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
					 * when that string is not marking the end of a CDATA section.
					 *
					 * In the content of elements, character data is any string of characters
					 * which does not contain the start-delimiter of any markup
					 * and does not include the CDATA-section-close delimiter, `]]>`.
					 *
					 * @see https://www.w3.org/TR/xml/#NT-CharData
					 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
					 */ buf.push(n.data.replace(/[<&>]/g, $0caec907a5497a5f$var$_xmlEncoder));
                    return null;
                case $0caec907a5497a5f$var$CDATA_SECTION_NODE:
                    if (requireWellFormed && n.data.indexOf(']]>') !== -1) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$INVALID_STATE_ERR, 'The CDATASection data contains "]]>"');
                    buf.push('<![CDATA[', n.data.replace(/]]>/g, ']]]]><![CDATA[>'), ']]>');
                    return null;
                case $0caec907a5497a5f$var$COMMENT_NODE:
                    if (requireWellFormed && n.data.indexOf('-->') !== -1) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$INVALID_STATE_ERR, 'The comment node data contains "-->"');
                    buf.push('<!--', n.data, '-->');
                    return null;
                case $0caec907a5497a5f$var$DOCUMENT_TYPE_NODE:
                    if (requireWellFormed) {
                        if (n.publicId && !/^("[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%']*"|'[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%'"]*')$/.test(n.publicId)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$INVALID_STATE_ERR, 'DocumentType publicId is not a valid PubidLiteral');
                        if (n.systemId && !/^("[^"]*"|'[^']*')$/.test(n.systemId)) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$INVALID_STATE_ERR, 'DocumentType systemId is not a valid SystemLiteral');
                        if (n.internalSubset && n.internalSubset.indexOf(']>') !== -1) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$INVALID_STATE_ERR, 'DocumentType internalSubset contains "]>"');
                    }
                    var pubid = n.publicId;
                    var sysid = n.systemId;
                    buf.push('<!DOCTYPE ', n.name);
                    if (pubid) {
                        buf.push(' PUBLIC ', pubid);
                        if (sysid && sysid != '.') buf.push(' ', sysid);
                        buf.push('>');
                    } else if (sysid && sysid != '.') buf.push(' SYSTEM ', sysid, '>');
                    else {
                        var sub = n.internalSubset;
                        if (sub) buf.push(' [', sub, ']');
                        buf.push('>');
                    }
                    return null;
                case $0caec907a5497a5f$var$PROCESSING_INSTRUCTION_NODE:
                    if (requireWellFormed && n.data.indexOf('?>') !== -1) throw new $0caec907a5497a5f$var$DOMException($0caec907a5497a5f$var$INVALID_STATE_ERR, 'The ProcessingInstruction data contains "?>"');
                    buf.push('<?', n.target, ' ', n.data, '?>');
                    return null;
                case $0caec907a5497a5f$var$ENTITY_REFERENCE_NODE:
                    buf.push('&', n.nodeName, ';');
                    return null;
                //case ENTITY_NODE:
                //case NOTATION_NODE:
                default:
                    buf.push('??', n.nodeName);
                    return null;
            }
        },
        exit: function(n, childCtx) {
            if (childCtx && childCtx.tag) buf.push('</', childCtx.tag, '>');
        }
    });
}
/**
 * Imports a node from a different document into `doc`, creating a new copy.
 * Delegates to {@link walkDOM} for traversal. Each node in the subtree is shallow-cloned,
 * stamped with `doc` as its `ownerDocument`, and detached (`parentNode` set to `null`).
 * Children are imported recursively when `deep` is `true`; for {@link Attr} nodes `deep` is
 * always forced to `true`
 * because an attribute's value lives in a child text node.
 *
 * @param {Document} doc
 * The document that will own the imported node.
 * @param {Node} node
 * The node to import.
 * @param {boolean} deep
 * If `true`, descendants are imported recursively.
 * @returns {Node}
 * The newly imported node, now owned by `doc`.
 */ function $0caec907a5497a5f$var$importNode(doc, node, deep) {
    var destRoot;
    $0caec907a5497a5f$var$walkDOM(node, null, {
        enter: function(srcNode, destParent) {
            // Shallow-clone the node and stamp it into the target document.
            var destNode = srcNode.cloneNode(false);
            destNode.ownerDocument = doc;
            destNode.parentNode = null;
            // capture as the root of the imported subtree or attach to parent.
            if (destParent === null) destRoot = destNode;
            else destParent.appendChild(destNode);
            // ATTRIBUTE_NODE must always be imported deeply: its value lives in a child text node.
            var shouldDeep = srcNode.nodeType === $0caec907a5497a5f$var$ATTRIBUTE_NODE || deep;
            return shouldDeep ? destNode : null;
        }
    });
    return destRoot;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function $0caec907a5497a5f$var$cloneNode(doc, node, deep) {
    var destRoot;
    $0caec907a5497a5f$var$walkDOM(node, null, {
        enter: function(srcNode, destParent) {
            // 1. Create a blank node of the same type and copy all scalar own properties.
            var destNode = new srcNode.constructor();
            for(var n in srcNode)if (Object.prototype.hasOwnProperty.call(srcNode, n)) {
                var v = srcNode[n];
                if (typeof v != 'object') {
                    if (v != destNode[n]) destNode[n] = v;
                }
            }
            if (srcNode.childNodes) destNode.childNodes = new $0caec907a5497a5f$var$NodeList();
            destNode.ownerDocument = doc;
            // 2. Handle node-type-specific setup.
            //    Attributes are not DOM children, so they are cloned inline here
            //    rather than by walkDOM descent.
            //    ATTRIBUTE_NODE forces deep=true so its own children are walked.
            var shouldDeep = deep;
            switch(destNode.nodeType){
                case $0caec907a5497a5f$var$ELEMENT_NODE:
                    var attrs = srcNode.attributes;
                    var attrs2 = destNode.attributes = new $0caec907a5497a5f$var$NamedNodeMap();
                    var len = attrs.length;
                    attrs2._ownerElement = destNode;
                    for(var i = 0; i < len; i++)destNode.setAttributeNode($0caec907a5497a5f$var$cloneNode(doc, attrs.item(i), true));
                    break;
                case $0caec907a5497a5f$var$ATTRIBUTE_NODE:
                    shouldDeep = true;
            }
            // 3. Attach to parent, or capture as the root of the cloned subtree.
            if (destParent !== null) destParent.appendChild(destNode);
            else destRoot = destNode;
            // 4. Return destNode as the context for children (causes walkDOM to descend),
            //    or null to skip children (shallow clone).
            return shouldDeep ? destNode : null;
        }
    });
    return destRoot;
}
function $0caec907a5497a5f$var$__set__(object, key, value) {
    object[key] = value;
}
//do dynamic
try {
    if (Object.defineProperty) {
        Object.defineProperty($0caec907a5497a5f$var$LiveNodeList.prototype, 'length', {
            get: function() {
                $0caec907a5497a5f$var$_updateLiveList(this);
                return this.$$length;
            }
        });
        /**
		 * The text content of this node and its descendants.
		 *
		 * Setting `textContent` on an element or document fragment replaces all child nodes with a
		 * single text node; on other nodes it sets `data`, `value`, and `nodeValue` directly.
		 *
		 * @type {string | null}
		 * @see {@link https://dom.spec.whatwg.org/#dom-node-textcontent}
		 */ Object.defineProperty($0caec907a5497a5f$var$Node.prototype, 'textContent', {
            get: function() {
                if (this.nodeType === $0caec907a5497a5f$var$ELEMENT_NODE || this.nodeType === $0caec907a5497a5f$var$DOCUMENT_FRAGMENT_NODE) {
                    var buf = [];
                    $0caec907a5497a5f$var$walkDOM(this, null, {
                        enter: function(n) {
                            if (n.nodeType === $0caec907a5497a5f$var$ELEMENT_NODE || n.nodeType === $0caec907a5497a5f$var$DOCUMENT_FRAGMENT_NODE) return true; // enter children
                            if (n.nodeType === $0caec907a5497a5f$var$PROCESSING_INSTRUCTION_NODE || n.nodeType === $0caec907a5497a5f$var$COMMENT_NODE) return null; // excluded from text content
                            buf.push(n.nodeValue);
                        }
                    });
                    return buf.join('');
                }
                return this.nodeValue;
            },
            set: function(data) {
                switch(this.nodeType){
                    case $0caec907a5497a5f$var$ELEMENT_NODE:
                    case $0caec907a5497a5f$var$DOCUMENT_FRAGMENT_NODE:
                        while(this.firstChild)this.removeChild(this.firstChild);
                        if (data || String(data)) this.appendChild(this.ownerDocument.createTextNode(data));
                        break;
                    default:
                        this.data = data;
                        this.value = data;
                        this.nodeValue = data;
                }
            }
        });
        $0caec907a5497a5f$var$__set__ = function(object, key, value) {
            //console.log(value)
            object['$$' + key] = value;
        };
    }
} catch (e) {}
$0caec907a5497a5f$export$d1d99cf900472499 = $0caec907a5497a5f$var$DocumentType;
$0caec907a5497a5f$export$fe58bcf938607f6a = $0caec907a5497a5f$var$DOMException;
$0caec907a5497a5f$export$455426655eab1d48 = $0caec907a5497a5f$var$DOMImplementation;
$0caec907a5497a5f$export$db77ccec0bb4ccac = $0caec907a5497a5f$var$Element;
$0caec907a5497a5f$export$85c928794f8d04d4 = $0caec907a5497a5f$var$Node;
$0caec907a5497a5f$export$79b41aa5d56abdff = $0caec907a5497a5f$var$NodeList;
$0caec907a5497a5f$export$5118471ee5d5453b = $0caec907a5497a5f$var$walkDOM;
$0caec907a5497a5f$export$64f0bed4ae6f0f24 = $0caec907a5497a5f$var$XMLSerializer; //}

});
parcelRegister("2Nc10", function(module, exports) {

$parcel$export(module.exports, "find", function () { return $20897a5894ba978f$export$71aa6c912b956294; }, function (v) { return $20897a5894ba978f$export$71aa6c912b956294 = v; });
$parcel$export(module.exports, "freeze", function () { return $20897a5894ba978f$export$792f3d81ea979f55; }, function (v) { return $20897a5894ba978f$export$792f3d81ea979f55 = v; });
$parcel$export(module.exports, "NAMESPACE", function () { return $20897a5894ba978f$export$6aad947bda0f3f46; }, function (v) { return $20897a5894ba978f$export$6aad947bda0f3f46 = v; });
var $20897a5894ba978f$export$e6e34fd1f2686227;
var $20897a5894ba978f$export$71aa6c912b956294;
var $20897a5894ba978f$export$792f3d81ea979f55;
var $20897a5894ba978f$export$c6cb9dd1e3ada1aa;
var $20897a5894ba978f$export$6aad947bda0f3f46;
'use strict';
/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */ function $20897a5894ba978f$var$find(list, predicate, ac) {
    if (ac === undefined) ac = Array.prototype;
    if (list && typeof ac.find === 'function') return ac.find.call(list, predicate);
    for(var i = 0; i < list.length; i++)if (Object.prototype.hasOwnProperty.call(list, i)) {
        var item = list[i];
        if (predicate.call(undefined, item, i, list)) return item;
    }
}
/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */ function $20897a5894ba978f$var$freeze(object, oc) {
    if (oc === undefined) oc = Object;
    return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object;
}
/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */ function $20897a5894ba978f$var$assign(target, source) {
    if (target === null || typeof target !== 'object') throw new TypeError('target is not an object');
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    return target;
}
/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */ var $20897a5894ba978f$var$MIME_TYPE = $20897a5894ba978f$var$freeze({
    /**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */ HTML: 'text/html',
    /**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */ isHTML: function(value) {
        return value === $20897a5894ba978f$var$MIME_TYPE.HTML;
    },
    /**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_APPLICATION: 'application/xml',
    /**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_TEXT: 'text/xml',
    /**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */ XML_XHTML_APPLICATION: 'application/xhtml+xml',
    /**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */ XML_SVG_IMAGE: 'image/svg+xml'
});
/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */ var $20897a5894ba978f$var$NAMESPACE = $20897a5894ba978f$var$freeze({
    /**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */ HTML: 'http://www.w3.org/1999/xhtml',
    /**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */ isHTML: function(uri) {
        return uri === $20897a5894ba978f$var$NAMESPACE.HTML;
    },
    /**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */ SVG: 'http://www.w3.org/2000/svg',
    /**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */ XML: 'http://www.w3.org/XML/1998/namespace',
    /**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */ XMLNS: 'http://www.w3.org/2000/xmlns/'
});
$20897a5894ba978f$export$e6e34fd1f2686227 = $20897a5894ba978f$var$assign;
$20897a5894ba978f$export$71aa6c912b956294 = $20897a5894ba978f$var$find;
$20897a5894ba978f$export$792f3d81ea979f55 = $20897a5894ba978f$var$freeze;
$20897a5894ba978f$export$c6cb9dd1e3ada1aa = $20897a5894ba978f$var$MIME_TYPE;
$20897a5894ba978f$export$6aad947bda0f3f46 = $20897a5894ba978f$var$NAMESPACE;

});


parcelRegister("fsGQ2", function(module, exports) {

$parcel$export(module.exports, "DOMParser", function () { return $b41ab35b597fa4a1$export$1059c6e7d2ce5669; }, function (v) { return $b41ab35b597fa4a1$export$1059c6e7d2ce5669 = v; });
var $b41ab35b597fa4a1$export$181392475aa39887;
var $b41ab35b597fa4a1$export$ba13e0e2f19e61a1;
var $b41ab35b597fa4a1$export$1059c6e7d2ce5669;

var $2Nc10 = parcelRequire("2Nc10");

var $15vCs = parcelRequire("15vCs");

var $iKHcI = parcelRequire("iKHcI");

var $lt8RX = parcelRequire("lt8RX");
var $b41ab35b597fa4a1$var$DOMImplementation = $15vCs.DOMImplementation;
var $b41ab35b597fa4a1$var$NAMESPACE = $2Nc10.NAMESPACE;
var $b41ab35b597fa4a1$var$ParseError = $lt8RX.ParseError;
var $b41ab35b597fa4a1$var$XMLReader = $lt8RX.XMLReader;
/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */ function $b41ab35b597fa4a1$var$normalizeLineEndings(input) {
    return input.replace(/\r[\n\u0085]/g, '\n').replace(/[\r\u0085\u2028]/g, '\n');
}
/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */ /**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */ /**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */ function $b41ab35b597fa4a1$var$DOMParser(options) {
    this.options = options || {
        locator: {}
    };
}
$b41ab35b597fa4a1$var$DOMParser.prototype.parseFromString = function(source, mimeType) {
    var options = this.options;
    var sax = new $b41ab35b597fa4a1$var$XMLReader();
    var domBuilder = options.domBuilder || new $b41ab35b597fa4a1$var$DOMHandler(); //contentHandler and LexicalHandler
    var errorHandler = options.errorHandler;
    var locator = options.locator;
    var defaultNSMap = options.xmlns || {};
    var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
    var entityMap = isHTML ? $iKHcI.HTML_ENTITIES : $iKHcI.XML_ENTITIES;
    if (locator) domBuilder.setDocumentLocator(locator);
    sax.errorHandler = $b41ab35b597fa4a1$var$buildErrorHandler(errorHandler, domBuilder, locator);
    sax.domBuilder = options.domBuilder || domBuilder;
    if (isHTML) defaultNSMap[''] = $b41ab35b597fa4a1$var$NAMESPACE.HTML;
    defaultNSMap.xml = defaultNSMap.xml || $b41ab35b597fa4a1$var$NAMESPACE.XML;
    var normalize = options.normalizeLineEndings || $b41ab35b597fa4a1$var$normalizeLineEndings;
    if (source && typeof source === 'string') sax.parse(normalize(source), defaultNSMap, entityMap);
    else sax.errorHandler.error('invalid doc source');
    return domBuilder.doc;
};
function $b41ab35b597fa4a1$var$buildErrorHandler(errorImpl, domBuilder, locator) {
    if (!errorImpl) {
        if (domBuilder instanceof $b41ab35b597fa4a1$var$DOMHandler) return domBuilder;
        errorImpl = domBuilder;
    }
    var errorHandler = {};
    var isCallback = errorImpl instanceof Function;
    locator = locator || {};
    function build(key) {
        var fn = errorImpl[key];
        if (!fn && isCallback) fn = errorImpl.length == 2 ? function(msg) {
            errorImpl(key, msg);
        } : errorImpl;
        errorHandler[key] = fn && function(msg) {
            fn('[xmldom ' + key + ']\t' + msg + $b41ab35b597fa4a1$var$_locator(locator));
        } || function() {};
    }
    build('warning');
    build('error');
    build('fatalError');
    return errorHandler;
}
//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */ function $b41ab35b597fa4a1$var$DOMHandler() {
    this.cdata = false;
}
function $b41ab35b597fa4a1$var$position(locator, node) {
    node.lineNumber = locator.lineNumber;
    node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */ $b41ab35b597fa4a1$var$DOMHandler.prototype = {
    startDocument: function() {
        this.doc = new $b41ab35b597fa4a1$var$DOMImplementation().createDocument(null, null, null);
        if (this.locator) this.doc.documentURI = this.locator.systemId;
    },
    startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        $b41ab35b597fa4a1$var$appendElement(this, el);
        this.currentElement = el;
        this.locator && $b41ab35b597fa4a1$var$position(this.locator, el);
        for(var i = 0; i < len; i++){
            var namespaceURI = attrs.getURI(i);
            var value = attrs.getValue(i);
            var qName = attrs.getQName(i);
            var attr = doc.createAttributeNS(namespaceURI, qName);
            this.locator && $b41ab35b597fa4a1$var$position(attrs.getLocator(i), attr);
            attr.value = attr.nodeValue = value;
            el.setAttributeNode(attr);
        }
    },
    endElement: function(namespaceURI, localName, qName) {
        var current = this.currentElement;
        var tagName = current.tagName;
        this.currentElement = current.parentNode;
    },
    startPrefixMapping: function(prefix, uri) {},
    endPrefixMapping: function(prefix) {},
    processingInstruction: function(target, data) {
        var ins = this.doc.createProcessingInstruction(target, data);
        this.locator && $b41ab35b597fa4a1$var$position(this.locator, ins);
        $b41ab35b597fa4a1$var$appendElement(this, ins);
    },
    ignorableWhitespace: function(ch, start, length) {},
    characters: function(chars, start, length) {
        chars = $b41ab35b597fa4a1$var$_toString.apply(this, arguments);
        //console.log(chars)
        if (chars) {
            if (this.cdata) var charNode = this.doc.createCDATASection(chars);
            else var charNode = this.doc.createTextNode(chars);
            if (this.currentElement) this.currentElement.appendChild(charNode);
            else if (/^\s*$/.test(chars)) this.doc.appendChild(charNode);
            this.locator && $b41ab35b597fa4a1$var$position(this.locator, charNode);
        }
    },
    skippedEntity: function(name) {},
    endDocument: function() {
        this.doc.normalize();
    },
    setDocumentLocator: function(locator) {
        if (this.locator = locator) locator.lineNumber = 0;
    },
    //LexicalHandler
    comment: function(chars, start, length) {
        chars = $b41ab35b597fa4a1$var$_toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && $b41ab35b597fa4a1$var$position(this.locator, comm);
        $b41ab35b597fa4a1$var$appendElement(this, comm);
    },
    startCDATA: function() {
        //used in characters() methods
        this.cdata = true;
    },
    endCDATA: function() {
        this.cdata = false;
    },
    startDTD: function(name, publicId, systemId) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
            var dt = impl.createDocumentType(name, publicId, systemId);
            this.locator && $b41ab35b597fa4a1$var$position(this.locator, dt);
            $b41ab35b597fa4a1$var$appendElement(this, dt);
            this.doc.doctype = dt;
        }
    },
    /**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */ warning: function(error) {
        console.warn('[xmldom warning]\t' + error, $b41ab35b597fa4a1$var$_locator(this.locator));
    },
    error: function(error) {
        console.error('[xmldom error]\t' + error, $b41ab35b597fa4a1$var$_locator(this.locator));
    },
    fatalError: function(error) {
        throw new $b41ab35b597fa4a1$var$ParseError(error, this.locator);
    }
};
function $b41ab35b597fa4a1$var$_locator(l) {
    if (l) return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']';
}
function $b41ab35b597fa4a1$var$_toString(chars, start, length) {
    if (typeof chars == 'string') return chars.substr(start, length);
    else {
        if (chars.length >= start + length || start) return new java.lang.String(chars, start, length) + '';
        return chars;
    }
}
/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */ "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
    $b41ab35b597fa4a1$var$DOMHandler.prototype[key] = function() {
        return null;
    };
});
/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */ function $b41ab35b597fa4a1$var$appendElement(hander, node) {
    if (!hander.currentElement) hander.doc.appendChild(node);
    else hander.currentElement.appendChild(node);
} //appendChild and setAttributeNS are preformance key
$b41ab35b597fa4a1$export$181392475aa39887 = $b41ab35b597fa4a1$var$DOMHandler;
$b41ab35b597fa4a1$export$ba13e0e2f19e61a1 = $b41ab35b597fa4a1$var$normalizeLineEndings;
$b41ab35b597fa4a1$export$1059c6e7d2ce5669 = $b41ab35b597fa4a1$var$DOMParser;

});
parcelRegister("iKHcI", function(module, exports) {

$parcel$export(module.exports, "XML_ENTITIES", function () { return $da6e094d46e1b593$export$91f0e5ff03dc84f; }, function (v) { return $da6e094d46e1b593$export$91f0e5ff03dc84f = v; });
$parcel$export(module.exports, "HTML_ENTITIES", function () { return $da6e094d46e1b593$export$b7e4d4631df36afa; }, function (v) { return $da6e094d46e1b593$export$b7e4d4631df36afa = v; });
/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */ var $da6e094d46e1b593$export$91f0e5ff03dc84f;
/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */ var $da6e094d46e1b593$export$b7e4d4631df36afa;
/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */ var $da6e094d46e1b593$export$79451380caed3f98;
'use strict';

var $2Nc10 = parcelRequire("2Nc10");
var $da6e094d46e1b593$require$freeze = $2Nc10.freeze;
$da6e094d46e1b593$export$91f0e5ff03dc84f = $da6e094d46e1b593$require$freeze({
    amp: '&',
    apos: "'",
    gt: '>',
    lt: '<',
    quot: '"'
});
$da6e094d46e1b593$export$b7e4d4631df36afa = $da6e094d46e1b593$require$freeze({
    Aacute: '\u00C1',
    aacute: '\u00E1',
    Abreve: '\u0102',
    abreve: '\u0103',
    ac: '\u223E',
    acd: '\u223F',
    acE: '\u223E\u0333',
    Acirc: '\u00C2',
    acirc: '\u00E2',
    acute: '\u00B4',
    Acy: '\u0410',
    acy: '\u0430',
    AElig: '\u00C6',
    aelig: '\u00E6',
    af: '\u2061',
    Afr: '\uD835\uDD04',
    afr: '\uD835\uDD1E',
    Agrave: '\u00C0',
    agrave: '\u00E0',
    alefsym: '\u2135',
    aleph: '\u2135',
    Alpha: '\u0391',
    alpha: '\u03B1',
    Amacr: '\u0100',
    amacr: '\u0101',
    amalg: '\u2A3F',
    AMP: '\u0026',
    amp: '\u0026',
    And: '\u2A53',
    and: '\u2227',
    andand: '\u2A55',
    andd: '\u2A5C',
    andslope: '\u2A58',
    andv: '\u2A5A',
    ang: '\u2220',
    ange: '\u29A4',
    angle: '\u2220',
    angmsd: '\u2221',
    angmsdaa: '\u29A8',
    angmsdab: '\u29A9',
    angmsdac: '\u29AA',
    angmsdad: '\u29AB',
    angmsdae: '\u29AC',
    angmsdaf: '\u29AD',
    angmsdag: '\u29AE',
    angmsdah: '\u29AF',
    angrt: '\u221F',
    angrtvb: '\u22BE',
    angrtvbd: '\u299D',
    angsph: '\u2222',
    angst: '\u00C5',
    angzarr: '\u237C',
    Aogon: '\u0104',
    aogon: '\u0105',
    Aopf: '\uD835\uDD38',
    aopf: '\uD835\uDD52',
    ap: '\u2248',
    apacir: '\u2A6F',
    apE: '\u2A70',
    ape: '\u224A',
    apid: '\u224B',
    apos: '\u0027',
    ApplyFunction: '\u2061',
    approx: '\u2248',
    approxeq: '\u224A',
    Aring: '\u00C5',
    aring: '\u00E5',
    Ascr: '\uD835\uDC9C',
    ascr: '\uD835\uDCB6',
    Assign: '\u2254',
    ast: '\u002A',
    asymp: '\u2248',
    asympeq: '\u224D',
    Atilde: '\u00C3',
    atilde: '\u00E3',
    Auml: '\u00C4',
    auml: '\u00E4',
    awconint: '\u2233',
    awint: '\u2A11',
    backcong: '\u224C',
    backepsilon: '\u03F6',
    backprime: '\u2035',
    backsim: '\u223D',
    backsimeq: '\u22CD',
    Backslash: '\u2216',
    Barv: '\u2AE7',
    barvee: '\u22BD',
    Barwed: '\u2306',
    barwed: '\u2305',
    barwedge: '\u2305',
    bbrk: '\u23B5',
    bbrktbrk: '\u23B6',
    bcong: '\u224C',
    Bcy: '\u0411',
    bcy: '\u0431',
    bdquo: '\u201E',
    becaus: '\u2235',
    Because: '\u2235',
    because: '\u2235',
    bemptyv: '\u29B0',
    bepsi: '\u03F6',
    bernou: '\u212C',
    Bernoullis: '\u212C',
    Beta: '\u0392',
    beta: '\u03B2',
    beth: '\u2136',
    between: '\u226C',
    Bfr: '\uD835\uDD05',
    bfr: '\uD835\uDD1F',
    bigcap: '\u22C2',
    bigcirc: '\u25EF',
    bigcup: '\u22C3',
    bigodot: '\u2A00',
    bigoplus: '\u2A01',
    bigotimes: '\u2A02',
    bigsqcup: '\u2A06',
    bigstar: '\u2605',
    bigtriangledown: '\u25BD',
    bigtriangleup: '\u25B3',
    biguplus: '\u2A04',
    bigvee: '\u22C1',
    bigwedge: '\u22C0',
    bkarow: '\u290D',
    blacklozenge: '\u29EB',
    blacksquare: '\u25AA',
    blacktriangle: '\u25B4',
    blacktriangledown: '\u25BE',
    blacktriangleleft: '\u25C2',
    blacktriangleright: '\u25B8',
    blank: '\u2423',
    blk12: '\u2592',
    blk14: '\u2591',
    blk34: '\u2593',
    block: '\u2588',
    bne: '\u003D\u20E5',
    bnequiv: '\u2261\u20E5',
    bNot: '\u2AED',
    bnot: '\u2310',
    Bopf: '\uD835\uDD39',
    bopf: '\uD835\uDD53',
    bot: '\u22A5',
    bottom: '\u22A5',
    bowtie: '\u22C8',
    boxbox: '\u29C9',
    boxDL: '\u2557',
    boxDl: '\u2556',
    boxdL: '\u2555',
    boxdl: '\u2510',
    boxDR: '\u2554',
    boxDr: '\u2553',
    boxdR: '\u2552',
    boxdr: '\u250C',
    boxH: '\u2550',
    boxh: '\u2500',
    boxHD: '\u2566',
    boxHd: '\u2564',
    boxhD: '\u2565',
    boxhd: '\u252C',
    boxHU: '\u2569',
    boxHu: '\u2567',
    boxhU: '\u2568',
    boxhu: '\u2534',
    boxminus: '\u229F',
    boxplus: '\u229E',
    boxtimes: '\u22A0',
    boxUL: '\u255D',
    boxUl: '\u255C',
    boxuL: '\u255B',
    boxul: '\u2518',
    boxUR: '\u255A',
    boxUr: '\u2559',
    boxuR: '\u2558',
    boxur: '\u2514',
    boxV: '\u2551',
    boxv: '\u2502',
    boxVH: '\u256C',
    boxVh: '\u256B',
    boxvH: '\u256A',
    boxvh: '\u253C',
    boxVL: '\u2563',
    boxVl: '\u2562',
    boxvL: '\u2561',
    boxvl: '\u2524',
    boxVR: '\u2560',
    boxVr: '\u255F',
    boxvR: '\u255E',
    boxvr: '\u251C',
    bprime: '\u2035',
    Breve: '\u02D8',
    breve: '\u02D8',
    brvbar: '\u00A6',
    Bscr: '\u212C',
    bscr: '\uD835\uDCB7',
    bsemi: '\u204F',
    bsim: '\u223D',
    bsime: '\u22CD',
    bsol: '\u005C',
    bsolb: '\u29C5',
    bsolhsub: '\u27C8',
    bull: '\u2022',
    bullet: '\u2022',
    bump: '\u224E',
    bumpE: '\u2AAE',
    bumpe: '\u224F',
    Bumpeq: '\u224E',
    bumpeq: '\u224F',
    Cacute: '\u0106',
    cacute: '\u0107',
    Cap: '\u22D2',
    cap: '\u2229',
    capand: '\u2A44',
    capbrcup: '\u2A49',
    capcap: '\u2A4B',
    capcup: '\u2A47',
    capdot: '\u2A40',
    CapitalDifferentialD: '\u2145',
    caps: '\u2229\uFE00',
    caret: '\u2041',
    caron: '\u02C7',
    Cayleys: '\u212D',
    ccaps: '\u2A4D',
    Ccaron: '\u010C',
    ccaron: '\u010D',
    Ccedil: '\u00C7',
    ccedil: '\u00E7',
    Ccirc: '\u0108',
    ccirc: '\u0109',
    Cconint: '\u2230',
    ccups: '\u2A4C',
    ccupssm: '\u2A50',
    Cdot: '\u010A',
    cdot: '\u010B',
    cedil: '\u00B8',
    Cedilla: '\u00B8',
    cemptyv: '\u29B2',
    cent: '\u00A2',
    CenterDot: '\u00B7',
    centerdot: '\u00B7',
    Cfr: '\u212D',
    cfr: '\uD835\uDD20',
    CHcy: '\u0427',
    chcy: '\u0447',
    check: '\u2713',
    checkmark: '\u2713',
    Chi: '\u03A7',
    chi: '\u03C7',
    cir: '\u25CB',
    circ: '\u02C6',
    circeq: '\u2257',
    circlearrowleft: '\u21BA',
    circlearrowright: '\u21BB',
    circledast: '\u229B',
    circledcirc: '\u229A',
    circleddash: '\u229D',
    CircleDot: '\u2299',
    circledR: '\u00AE',
    circledS: '\u24C8',
    CircleMinus: '\u2296',
    CirclePlus: '\u2295',
    CircleTimes: '\u2297',
    cirE: '\u29C3',
    cire: '\u2257',
    cirfnint: '\u2A10',
    cirmid: '\u2AEF',
    cirscir: '\u29C2',
    ClockwiseContourIntegral: '\u2232',
    CloseCurlyDoubleQuote: '\u201D',
    CloseCurlyQuote: '\u2019',
    clubs: '\u2663',
    clubsuit: '\u2663',
    Colon: '\u2237',
    colon: '\u003A',
    Colone: '\u2A74',
    colone: '\u2254',
    coloneq: '\u2254',
    comma: '\u002C',
    commat: '\u0040',
    comp: '\u2201',
    compfn: '\u2218',
    complement: '\u2201',
    complexes: '\u2102',
    cong: '\u2245',
    congdot: '\u2A6D',
    Congruent: '\u2261',
    Conint: '\u222F',
    conint: '\u222E',
    ContourIntegral: '\u222E',
    Copf: '\u2102',
    copf: '\uD835\uDD54',
    coprod: '\u2210',
    Coproduct: '\u2210',
    COPY: '\u00A9',
    copy: '\u00A9',
    copysr: '\u2117',
    CounterClockwiseContourIntegral: '\u2233',
    crarr: '\u21B5',
    Cross: '\u2A2F',
    cross: '\u2717',
    Cscr: '\uD835\uDC9E',
    cscr: '\uD835\uDCB8',
    csub: '\u2ACF',
    csube: '\u2AD1',
    csup: '\u2AD0',
    csupe: '\u2AD2',
    ctdot: '\u22EF',
    cudarrl: '\u2938',
    cudarrr: '\u2935',
    cuepr: '\u22DE',
    cuesc: '\u22DF',
    cularr: '\u21B6',
    cularrp: '\u293D',
    Cup: '\u22D3',
    cup: '\u222A',
    cupbrcap: '\u2A48',
    CupCap: '\u224D',
    cupcap: '\u2A46',
    cupcup: '\u2A4A',
    cupdot: '\u228D',
    cupor: '\u2A45',
    cups: '\u222A\uFE00',
    curarr: '\u21B7',
    curarrm: '\u293C',
    curlyeqprec: '\u22DE',
    curlyeqsucc: '\u22DF',
    curlyvee: '\u22CE',
    curlywedge: '\u22CF',
    curren: '\u00A4',
    curvearrowleft: '\u21B6',
    curvearrowright: '\u21B7',
    cuvee: '\u22CE',
    cuwed: '\u22CF',
    cwconint: '\u2232',
    cwint: '\u2231',
    cylcty: '\u232D',
    Dagger: '\u2021',
    dagger: '\u2020',
    daleth: '\u2138',
    Darr: '\u21A1',
    dArr: '\u21D3',
    darr: '\u2193',
    dash: '\u2010',
    Dashv: '\u2AE4',
    dashv: '\u22A3',
    dbkarow: '\u290F',
    dblac: '\u02DD',
    Dcaron: '\u010E',
    dcaron: '\u010F',
    Dcy: '\u0414',
    dcy: '\u0434',
    DD: '\u2145',
    dd: '\u2146',
    ddagger: '\u2021',
    ddarr: '\u21CA',
    DDotrahd: '\u2911',
    ddotseq: '\u2A77',
    deg: '\u00B0',
    Del: '\u2207',
    Delta: '\u0394',
    delta: '\u03B4',
    demptyv: '\u29B1',
    dfisht: '\u297F',
    Dfr: '\uD835\uDD07',
    dfr: '\uD835\uDD21',
    dHar: '\u2965',
    dharl: '\u21C3',
    dharr: '\u21C2',
    DiacriticalAcute: '\u00B4',
    DiacriticalDot: '\u02D9',
    DiacriticalDoubleAcute: '\u02DD',
    DiacriticalGrave: '\u0060',
    DiacriticalTilde: '\u02DC',
    diam: '\u22C4',
    Diamond: '\u22C4',
    diamond: '\u22C4',
    diamondsuit: '\u2666',
    diams: '\u2666',
    die: '\u00A8',
    DifferentialD: '\u2146',
    digamma: '\u03DD',
    disin: '\u22F2',
    div: '\u00F7',
    divide: '\u00F7',
    divideontimes: '\u22C7',
    divonx: '\u22C7',
    DJcy: '\u0402',
    djcy: '\u0452',
    dlcorn: '\u231E',
    dlcrop: '\u230D',
    dollar: '\u0024',
    Dopf: '\uD835\uDD3B',
    dopf: '\uD835\uDD55',
    Dot: '\u00A8',
    dot: '\u02D9',
    DotDot: '\u20DC',
    doteq: '\u2250',
    doteqdot: '\u2251',
    DotEqual: '\u2250',
    dotminus: '\u2238',
    dotplus: '\u2214',
    dotsquare: '\u22A1',
    doublebarwedge: '\u2306',
    DoubleContourIntegral: '\u222F',
    DoubleDot: '\u00A8',
    DoubleDownArrow: '\u21D3',
    DoubleLeftArrow: '\u21D0',
    DoubleLeftRightArrow: '\u21D4',
    DoubleLeftTee: '\u2AE4',
    DoubleLongLeftArrow: '\u27F8',
    DoubleLongLeftRightArrow: '\u27FA',
    DoubleLongRightArrow: '\u27F9',
    DoubleRightArrow: '\u21D2',
    DoubleRightTee: '\u22A8',
    DoubleUpArrow: '\u21D1',
    DoubleUpDownArrow: '\u21D5',
    DoubleVerticalBar: '\u2225',
    DownArrow: '\u2193',
    Downarrow: '\u21D3',
    downarrow: '\u2193',
    DownArrowBar: '\u2913',
    DownArrowUpArrow: '\u21F5',
    DownBreve: '\u0311',
    downdownarrows: '\u21CA',
    downharpoonleft: '\u21C3',
    downharpoonright: '\u21C2',
    DownLeftRightVector: '\u2950',
    DownLeftTeeVector: '\u295E',
    DownLeftVector: '\u21BD',
    DownLeftVectorBar: '\u2956',
    DownRightTeeVector: '\u295F',
    DownRightVector: '\u21C1',
    DownRightVectorBar: '\u2957',
    DownTee: '\u22A4',
    DownTeeArrow: '\u21A7',
    drbkarow: '\u2910',
    drcorn: '\u231F',
    drcrop: '\u230C',
    Dscr: '\uD835\uDC9F',
    dscr: '\uD835\uDCB9',
    DScy: '\u0405',
    dscy: '\u0455',
    dsol: '\u29F6',
    Dstrok: '\u0110',
    dstrok: '\u0111',
    dtdot: '\u22F1',
    dtri: '\u25BF',
    dtrif: '\u25BE',
    duarr: '\u21F5',
    duhar: '\u296F',
    dwangle: '\u29A6',
    DZcy: '\u040F',
    dzcy: '\u045F',
    dzigrarr: '\u27FF',
    Eacute: '\u00C9',
    eacute: '\u00E9',
    easter: '\u2A6E',
    Ecaron: '\u011A',
    ecaron: '\u011B',
    ecir: '\u2256',
    Ecirc: '\u00CA',
    ecirc: '\u00EA',
    ecolon: '\u2255',
    Ecy: '\u042D',
    ecy: '\u044D',
    eDDot: '\u2A77',
    Edot: '\u0116',
    eDot: '\u2251',
    edot: '\u0117',
    ee: '\u2147',
    efDot: '\u2252',
    Efr: '\uD835\uDD08',
    efr: '\uD835\uDD22',
    eg: '\u2A9A',
    Egrave: '\u00C8',
    egrave: '\u00E8',
    egs: '\u2A96',
    egsdot: '\u2A98',
    el: '\u2A99',
    Element: '\u2208',
    elinters: '\u23E7',
    ell: '\u2113',
    els: '\u2A95',
    elsdot: '\u2A97',
    Emacr: '\u0112',
    emacr: '\u0113',
    empty: '\u2205',
    emptyset: '\u2205',
    EmptySmallSquare: '\u25FB',
    emptyv: '\u2205',
    EmptyVerySmallSquare: '\u25AB',
    emsp: '\u2003',
    emsp13: '\u2004',
    emsp14: '\u2005',
    ENG: '\u014A',
    eng: '\u014B',
    ensp: '\u2002',
    Eogon: '\u0118',
    eogon: '\u0119',
    Eopf: '\uD835\uDD3C',
    eopf: '\uD835\uDD56',
    epar: '\u22D5',
    eparsl: '\u29E3',
    eplus: '\u2A71',
    epsi: '\u03B5',
    Epsilon: '\u0395',
    epsilon: '\u03B5',
    epsiv: '\u03F5',
    eqcirc: '\u2256',
    eqcolon: '\u2255',
    eqsim: '\u2242',
    eqslantgtr: '\u2A96',
    eqslantless: '\u2A95',
    Equal: '\u2A75',
    equals: '\u003D',
    EqualTilde: '\u2242',
    equest: '\u225F',
    Equilibrium: '\u21CC',
    equiv: '\u2261',
    equivDD: '\u2A78',
    eqvparsl: '\u29E5',
    erarr: '\u2971',
    erDot: '\u2253',
    Escr: '\u2130',
    escr: '\u212F',
    esdot: '\u2250',
    Esim: '\u2A73',
    esim: '\u2242',
    Eta: '\u0397',
    eta: '\u03B7',
    ETH: '\u00D0',
    eth: '\u00F0',
    Euml: '\u00CB',
    euml: '\u00EB',
    euro: '\u20AC',
    excl: '\u0021',
    exist: '\u2203',
    Exists: '\u2203',
    expectation: '\u2130',
    ExponentialE: '\u2147',
    exponentiale: '\u2147',
    fallingdotseq: '\u2252',
    Fcy: '\u0424',
    fcy: '\u0444',
    female: '\u2640',
    ffilig: '\uFB03',
    fflig: '\uFB00',
    ffllig: '\uFB04',
    Ffr: '\uD835\uDD09',
    ffr: '\uD835\uDD23',
    filig: '\uFB01',
    FilledSmallSquare: '\u25FC',
    FilledVerySmallSquare: '\u25AA',
    fjlig: '\u0066\u006A',
    flat: '\u266D',
    fllig: '\uFB02',
    fltns: '\u25B1',
    fnof: '\u0192',
    Fopf: '\uD835\uDD3D',
    fopf: '\uD835\uDD57',
    ForAll: '\u2200',
    forall: '\u2200',
    fork: '\u22D4',
    forkv: '\u2AD9',
    Fouriertrf: '\u2131',
    fpartint: '\u2A0D',
    frac12: '\u00BD',
    frac13: '\u2153',
    frac14: '\u00BC',
    frac15: '\u2155',
    frac16: '\u2159',
    frac18: '\u215B',
    frac23: '\u2154',
    frac25: '\u2156',
    frac34: '\u00BE',
    frac35: '\u2157',
    frac38: '\u215C',
    frac45: '\u2158',
    frac56: '\u215A',
    frac58: '\u215D',
    frac78: '\u215E',
    frasl: '\u2044',
    frown: '\u2322',
    Fscr: '\u2131',
    fscr: '\uD835\uDCBB',
    gacute: '\u01F5',
    Gamma: '\u0393',
    gamma: '\u03B3',
    Gammad: '\u03DC',
    gammad: '\u03DD',
    gap: '\u2A86',
    Gbreve: '\u011E',
    gbreve: '\u011F',
    Gcedil: '\u0122',
    Gcirc: '\u011C',
    gcirc: '\u011D',
    Gcy: '\u0413',
    gcy: '\u0433',
    Gdot: '\u0120',
    gdot: '\u0121',
    gE: '\u2267',
    ge: '\u2265',
    gEl: '\u2A8C',
    gel: '\u22DB',
    geq: '\u2265',
    geqq: '\u2267',
    geqslant: '\u2A7E',
    ges: '\u2A7E',
    gescc: '\u2AA9',
    gesdot: '\u2A80',
    gesdoto: '\u2A82',
    gesdotol: '\u2A84',
    gesl: '\u22DB\uFE00',
    gesles: '\u2A94',
    Gfr: '\uD835\uDD0A',
    gfr: '\uD835\uDD24',
    Gg: '\u22D9',
    gg: '\u226B',
    ggg: '\u22D9',
    gimel: '\u2137',
    GJcy: '\u0403',
    gjcy: '\u0453',
    gl: '\u2277',
    gla: '\u2AA5',
    glE: '\u2A92',
    glj: '\u2AA4',
    gnap: '\u2A8A',
    gnapprox: '\u2A8A',
    gnE: '\u2269',
    gne: '\u2A88',
    gneq: '\u2A88',
    gneqq: '\u2269',
    gnsim: '\u22E7',
    Gopf: '\uD835\uDD3E',
    gopf: '\uD835\uDD58',
    grave: '\u0060',
    GreaterEqual: '\u2265',
    GreaterEqualLess: '\u22DB',
    GreaterFullEqual: '\u2267',
    GreaterGreater: '\u2AA2',
    GreaterLess: '\u2277',
    GreaterSlantEqual: '\u2A7E',
    GreaterTilde: '\u2273',
    Gscr: '\uD835\uDCA2',
    gscr: '\u210A',
    gsim: '\u2273',
    gsime: '\u2A8E',
    gsiml: '\u2A90',
    Gt: '\u226B',
    GT: '\u003E',
    gt: '\u003E',
    gtcc: '\u2AA7',
    gtcir: '\u2A7A',
    gtdot: '\u22D7',
    gtlPar: '\u2995',
    gtquest: '\u2A7C',
    gtrapprox: '\u2A86',
    gtrarr: '\u2978',
    gtrdot: '\u22D7',
    gtreqless: '\u22DB',
    gtreqqless: '\u2A8C',
    gtrless: '\u2277',
    gtrsim: '\u2273',
    gvertneqq: '\u2269\uFE00',
    gvnE: '\u2269\uFE00',
    Hacek: '\u02C7',
    hairsp: '\u200A',
    half: '\u00BD',
    hamilt: '\u210B',
    HARDcy: '\u042A',
    hardcy: '\u044A',
    hArr: '\u21D4',
    harr: '\u2194',
    harrcir: '\u2948',
    harrw: '\u21AD',
    Hat: '\u005E',
    hbar: '\u210F',
    Hcirc: '\u0124',
    hcirc: '\u0125',
    hearts: '\u2665',
    heartsuit: '\u2665',
    hellip: '\u2026',
    hercon: '\u22B9',
    Hfr: '\u210C',
    hfr: '\uD835\uDD25',
    HilbertSpace: '\u210B',
    hksearow: '\u2925',
    hkswarow: '\u2926',
    hoarr: '\u21FF',
    homtht: '\u223B',
    hookleftarrow: '\u21A9',
    hookrightarrow: '\u21AA',
    Hopf: '\u210D',
    hopf: '\uD835\uDD59',
    horbar: '\u2015',
    HorizontalLine: '\u2500',
    Hscr: '\u210B',
    hscr: '\uD835\uDCBD',
    hslash: '\u210F',
    Hstrok: '\u0126',
    hstrok: '\u0127',
    HumpDownHump: '\u224E',
    HumpEqual: '\u224F',
    hybull: '\u2043',
    hyphen: '\u2010',
    Iacute: '\u00CD',
    iacute: '\u00ED',
    ic: '\u2063',
    Icirc: '\u00CE',
    icirc: '\u00EE',
    Icy: '\u0418',
    icy: '\u0438',
    Idot: '\u0130',
    IEcy: '\u0415',
    iecy: '\u0435',
    iexcl: '\u00A1',
    iff: '\u21D4',
    Ifr: '\u2111',
    ifr: '\uD835\uDD26',
    Igrave: '\u00CC',
    igrave: '\u00EC',
    ii: '\u2148',
    iiiint: '\u2A0C',
    iiint: '\u222D',
    iinfin: '\u29DC',
    iiota: '\u2129',
    IJlig: '\u0132',
    ijlig: '\u0133',
    Im: '\u2111',
    Imacr: '\u012A',
    imacr: '\u012B',
    image: '\u2111',
    ImaginaryI: '\u2148',
    imagline: '\u2110',
    imagpart: '\u2111',
    imath: '\u0131',
    imof: '\u22B7',
    imped: '\u01B5',
    Implies: '\u21D2',
    in: '\u2208',
    incare: '\u2105',
    infin: '\u221E',
    infintie: '\u29DD',
    inodot: '\u0131',
    Int: '\u222C',
    int: '\u222B',
    intcal: '\u22BA',
    integers: '\u2124',
    Integral: '\u222B',
    intercal: '\u22BA',
    Intersection: '\u22C2',
    intlarhk: '\u2A17',
    intprod: '\u2A3C',
    InvisibleComma: '\u2063',
    InvisibleTimes: '\u2062',
    IOcy: '\u0401',
    iocy: '\u0451',
    Iogon: '\u012E',
    iogon: '\u012F',
    Iopf: '\uD835\uDD40',
    iopf: '\uD835\uDD5A',
    Iota: '\u0399',
    iota: '\u03B9',
    iprod: '\u2A3C',
    iquest: '\u00BF',
    Iscr: '\u2110',
    iscr: '\uD835\uDCBE',
    isin: '\u2208',
    isindot: '\u22F5',
    isinE: '\u22F9',
    isins: '\u22F4',
    isinsv: '\u22F3',
    isinv: '\u2208',
    it: '\u2062',
    Itilde: '\u0128',
    itilde: '\u0129',
    Iukcy: '\u0406',
    iukcy: '\u0456',
    Iuml: '\u00CF',
    iuml: '\u00EF',
    Jcirc: '\u0134',
    jcirc: '\u0135',
    Jcy: '\u0419',
    jcy: '\u0439',
    Jfr: '\uD835\uDD0D',
    jfr: '\uD835\uDD27',
    jmath: '\u0237',
    Jopf: '\uD835\uDD41',
    jopf: '\uD835\uDD5B',
    Jscr: '\uD835\uDCA5',
    jscr: '\uD835\uDCBF',
    Jsercy: '\u0408',
    jsercy: '\u0458',
    Jukcy: '\u0404',
    jukcy: '\u0454',
    Kappa: '\u039A',
    kappa: '\u03BA',
    kappav: '\u03F0',
    Kcedil: '\u0136',
    kcedil: '\u0137',
    Kcy: '\u041A',
    kcy: '\u043A',
    Kfr: '\uD835\uDD0E',
    kfr: '\uD835\uDD28',
    kgreen: '\u0138',
    KHcy: '\u0425',
    khcy: '\u0445',
    KJcy: '\u040C',
    kjcy: '\u045C',
    Kopf: '\uD835\uDD42',
    kopf: '\uD835\uDD5C',
    Kscr: '\uD835\uDCA6',
    kscr: '\uD835\uDCC0',
    lAarr: '\u21DA',
    Lacute: '\u0139',
    lacute: '\u013A',
    laemptyv: '\u29B4',
    lagran: '\u2112',
    Lambda: '\u039B',
    lambda: '\u03BB',
    Lang: '\u27EA',
    lang: '\u27E8',
    langd: '\u2991',
    langle: '\u27E8',
    lap: '\u2A85',
    Laplacetrf: '\u2112',
    laquo: '\u00AB',
    Larr: '\u219E',
    lArr: '\u21D0',
    larr: '\u2190',
    larrb: '\u21E4',
    larrbfs: '\u291F',
    larrfs: '\u291D',
    larrhk: '\u21A9',
    larrlp: '\u21AB',
    larrpl: '\u2939',
    larrsim: '\u2973',
    larrtl: '\u21A2',
    lat: '\u2AAB',
    lAtail: '\u291B',
    latail: '\u2919',
    late: '\u2AAD',
    lates: '\u2AAD\uFE00',
    lBarr: '\u290E',
    lbarr: '\u290C',
    lbbrk: '\u2772',
    lbrace: '\u007B',
    lbrack: '\u005B',
    lbrke: '\u298B',
    lbrksld: '\u298F',
    lbrkslu: '\u298D',
    Lcaron: '\u013D',
    lcaron: '\u013E',
    Lcedil: '\u013B',
    lcedil: '\u013C',
    lceil: '\u2308',
    lcub: '\u007B',
    Lcy: '\u041B',
    lcy: '\u043B',
    ldca: '\u2936',
    ldquo: '\u201C',
    ldquor: '\u201E',
    ldrdhar: '\u2967',
    ldrushar: '\u294B',
    ldsh: '\u21B2',
    lE: '\u2266',
    le: '\u2264',
    LeftAngleBracket: '\u27E8',
    LeftArrow: '\u2190',
    Leftarrow: '\u21D0',
    leftarrow: '\u2190',
    LeftArrowBar: '\u21E4',
    LeftArrowRightArrow: '\u21C6',
    leftarrowtail: '\u21A2',
    LeftCeiling: '\u2308',
    LeftDoubleBracket: '\u27E6',
    LeftDownTeeVector: '\u2961',
    LeftDownVector: '\u21C3',
    LeftDownVectorBar: '\u2959',
    LeftFloor: '\u230A',
    leftharpoondown: '\u21BD',
    leftharpoonup: '\u21BC',
    leftleftarrows: '\u21C7',
    LeftRightArrow: '\u2194',
    Leftrightarrow: '\u21D4',
    leftrightarrow: '\u2194',
    leftrightarrows: '\u21C6',
    leftrightharpoons: '\u21CB',
    leftrightsquigarrow: '\u21AD',
    LeftRightVector: '\u294E',
    LeftTee: '\u22A3',
    LeftTeeArrow: '\u21A4',
    LeftTeeVector: '\u295A',
    leftthreetimes: '\u22CB',
    LeftTriangle: '\u22B2',
    LeftTriangleBar: '\u29CF',
    LeftTriangleEqual: '\u22B4',
    LeftUpDownVector: '\u2951',
    LeftUpTeeVector: '\u2960',
    LeftUpVector: '\u21BF',
    LeftUpVectorBar: '\u2958',
    LeftVector: '\u21BC',
    LeftVectorBar: '\u2952',
    lEg: '\u2A8B',
    leg: '\u22DA',
    leq: '\u2264',
    leqq: '\u2266',
    leqslant: '\u2A7D',
    les: '\u2A7D',
    lescc: '\u2AA8',
    lesdot: '\u2A7F',
    lesdoto: '\u2A81',
    lesdotor: '\u2A83',
    lesg: '\u22DA\uFE00',
    lesges: '\u2A93',
    lessapprox: '\u2A85',
    lessdot: '\u22D6',
    lesseqgtr: '\u22DA',
    lesseqqgtr: '\u2A8B',
    LessEqualGreater: '\u22DA',
    LessFullEqual: '\u2266',
    LessGreater: '\u2276',
    lessgtr: '\u2276',
    LessLess: '\u2AA1',
    lesssim: '\u2272',
    LessSlantEqual: '\u2A7D',
    LessTilde: '\u2272',
    lfisht: '\u297C',
    lfloor: '\u230A',
    Lfr: '\uD835\uDD0F',
    lfr: '\uD835\uDD29',
    lg: '\u2276',
    lgE: '\u2A91',
    lHar: '\u2962',
    lhard: '\u21BD',
    lharu: '\u21BC',
    lharul: '\u296A',
    lhblk: '\u2584',
    LJcy: '\u0409',
    ljcy: '\u0459',
    Ll: '\u22D8',
    ll: '\u226A',
    llarr: '\u21C7',
    llcorner: '\u231E',
    Lleftarrow: '\u21DA',
    llhard: '\u296B',
    lltri: '\u25FA',
    Lmidot: '\u013F',
    lmidot: '\u0140',
    lmoust: '\u23B0',
    lmoustache: '\u23B0',
    lnap: '\u2A89',
    lnapprox: '\u2A89',
    lnE: '\u2268',
    lne: '\u2A87',
    lneq: '\u2A87',
    lneqq: '\u2268',
    lnsim: '\u22E6',
    loang: '\u27EC',
    loarr: '\u21FD',
    lobrk: '\u27E6',
    LongLeftArrow: '\u27F5',
    Longleftarrow: '\u27F8',
    longleftarrow: '\u27F5',
    LongLeftRightArrow: '\u27F7',
    Longleftrightarrow: '\u27FA',
    longleftrightarrow: '\u27F7',
    longmapsto: '\u27FC',
    LongRightArrow: '\u27F6',
    Longrightarrow: '\u27F9',
    longrightarrow: '\u27F6',
    looparrowleft: '\u21AB',
    looparrowright: '\u21AC',
    lopar: '\u2985',
    Lopf: '\uD835\uDD43',
    lopf: '\uD835\uDD5D',
    loplus: '\u2A2D',
    lotimes: '\u2A34',
    lowast: '\u2217',
    lowbar: '\u005F',
    LowerLeftArrow: '\u2199',
    LowerRightArrow: '\u2198',
    loz: '\u25CA',
    lozenge: '\u25CA',
    lozf: '\u29EB',
    lpar: '\u0028',
    lparlt: '\u2993',
    lrarr: '\u21C6',
    lrcorner: '\u231F',
    lrhar: '\u21CB',
    lrhard: '\u296D',
    lrm: '\u200E',
    lrtri: '\u22BF',
    lsaquo: '\u2039',
    Lscr: '\u2112',
    lscr: '\uD835\uDCC1',
    Lsh: '\u21B0',
    lsh: '\u21B0',
    lsim: '\u2272',
    lsime: '\u2A8D',
    lsimg: '\u2A8F',
    lsqb: '\u005B',
    lsquo: '\u2018',
    lsquor: '\u201A',
    Lstrok: '\u0141',
    lstrok: '\u0142',
    Lt: '\u226A',
    LT: '\u003C',
    lt: '\u003C',
    ltcc: '\u2AA6',
    ltcir: '\u2A79',
    ltdot: '\u22D6',
    lthree: '\u22CB',
    ltimes: '\u22C9',
    ltlarr: '\u2976',
    ltquest: '\u2A7B',
    ltri: '\u25C3',
    ltrie: '\u22B4',
    ltrif: '\u25C2',
    ltrPar: '\u2996',
    lurdshar: '\u294A',
    luruhar: '\u2966',
    lvertneqq: '\u2268\uFE00',
    lvnE: '\u2268\uFE00',
    macr: '\u00AF',
    male: '\u2642',
    malt: '\u2720',
    maltese: '\u2720',
    Map: '\u2905',
    map: '\u21A6',
    mapsto: '\u21A6',
    mapstodown: '\u21A7',
    mapstoleft: '\u21A4',
    mapstoup: '\u21A5',
    marker: '\u25AE',
    mcomma: '\u2A29',
    Mcy: '\u041C',
    mcy: '\u043C',
    mdash: '\u2014',
    mDDot: '\u223A',
    measuredangle: '\u2221',
    MediumSpace: '\u205F',
    Mellintrf: '\u2133',
    Mfr: '\uD835\uDD10',
    mfr: '\uD835\uDD2A',
    mho: '\u2127',
    micro: '\u00B5',
    mid: '\u2223',
    midast: '\u002A',
    midcir: '\u2AF0',
    middot: '\u00B7',
    minus: '\u2212',
    minusb: '\u229F',
    minusd: '\u2238',
    minusdu: '\u2A2A',
    MinusPlus: '\u2213',
    mlcp: '\u2ADB',
    mldr: '\u2026',
    mnplus: '\u2213',
    models: '\u22A7',
    Mopf: '\uD835\uDD44',
    mopf: '\uD835\uDD5E',
    mp: '\u2213',
    Mscr: '\u2133',
    mscr: '\uD835\uDCC2',
    mstpos: '\u223E',
    Mu: '\u039C',
    mu: '\u03BC',
    multimap: '\u22B8',
    mumap: '\u22B8',
    nabla: '\u2207',
    Nacute: '\u0143',
    nacute: '\u0144',
    nang: '\u2220\u20D2',
    nap: '\u2249',
    napE: '\u2A70\u0338',
    napid: '\u224B\u0338',
    napos: '\u0149',
    napprox: '\u2249',
    natur: '\u266E',
    natural: '\u266E',
    naturals: '\u2115',
    nbsp: '\u00A0',
    nbump: '\u224E\u0338',
    nbumpe: '\u224F\u0338',
    ncap: '\u2A43',
    Ncaron: '\u0147',
    ncaron: '\u0148',
    Ncedil: '\u0145',
    ncedil: '\u0146',
    ncong: '\u2247',
    ncongdot: '\u2A6D\u0338',
    ncup: '\u2A42',
    Ncy: '\u041D',
    ncy: '\u043D',
    ndash: '\u2013',
    ne: '\u2260',
    nearhk: '\u2924',
    neArr: '\u21D7',
    nearr: '\u2197',
    nearrow: '\u2197',
    nedot: '\u2250\u0338',
    NegativeMediumSpace: '\u200B',
    NegativeThickSpace: '\u200B',
    NegativeThinSpace: '\u200B',
    NegativeVeryThinSpace: '\u200B',
    nequiv: '\u2262',
    nesear: '\u2928',
    nesim: '\u2242\u0338',
    NestedGreaterGreater: '\u226B',
    NestedLessLess: '\u226A',
    NewLine: '\u000A',
    nexist: '\u2204',
    nexists: '\u2204',
    Nfr: '\uD835\uDD11',
    nfr: '\uD835\uDD2B',
    ngE: '\u2267\u0338',
    nge: '\u2271',
    ngeq: '\u2271',
    ngeqq: '\u2267\u0338',
    ngeqslant: '\u2A7E\u0338',
    nges: '\u2A7E\u0338',
    nGg: '\u22D9\u0338',
    ngsim: '\u2275',
    nGt: '\u226B\u20D2',
    ngt: '\u226F',
    ngtr: '\u226F',
    nGtv: '\u226B\u0338',
    nhArr: '\u21CE',
    nharr: '\u21AE',
    nhpar: '\u2AF2',
    ni: '\u220B',
    nis: '\u22FC',
    nisd: '\u22FA',
    niv: '\u220B',
    NJcy: '\u040A',
    njcy: '\u045A',
    nlArr: '\u21CD',
    nlarr: '\u219A',
    nldr: '\u2025',
    nlE: '\u2266\u0338',
    nle: '\u2270',
    nLeftarrow: '\u21CD',
    nleftarrow: '\u219A',
    nLeftrightarrow: '\u21CE',
    nleftrightarrow: '\u21AE',
    nleq: '\u2270',
    nleqq: '\u2266\u0338',
    nleqslant: '\u2A7D\u0338',
    nles: '\u2A7D\u0338',
    nless: '\u226E',
    nLl: '\u22D8\u0338',
    nlsim: '\u2274',
    nLt: '\u226A\u20D2',
    nlt: '\u226E',
    nltri: '\u22EA',
    nltrie: '\u22EC',
    nLtv: '\u226A\u0338',
    nmid: '\u2224',
    NoBreak: '\u2060',
    NonBreakingSpace: '\u00A0',
    Nopf: '\u2115',
    nopf: '\uD835\uDD5F',
    Not: '\u2AEC',
    not: '\u00AC',
    NotCongruent: '\u2262',
    NotCupCap: '\u226D',
    NotDoubleVerticalBar: '\u2226',
    NotElement: '\u2209',
    NotEqual: '\u2260',
    NotEqualTilde: '\u2242\u0338',
    NotExists: '\u2204',
    NotGreater: '\u226F',
    NotGreaterEqual: '\u2271',
    NotGreaterFullEqual: '\u2267\u0338',
    NotGreaterGreater: '\u226B\u0338',
    NotGreaterLess: '\u2279',
    NotGreaterSlantEqual: '\u2A7E\u0338',
    NotGreaterTilde: '\u2275',
    NotHumpDownHump: '\u224E\u0338',
    NotHumpEqual: '\u224F\u0338',
    notin: '\u2209',
    notindot: '\u22F5\u0338',
    notinE: '\u22F9\u0338',
    notinva: '\u2209',
    notinvb: '\u22F7',
    notinvc: '\u22F6',
    NotLeftTriangle: '\u22EA',
    NotLeftTriangleBar: '\u29CF\u0338',
    NotLeftTriangleEqual: '\u22EC',
    NotLess: '\u226E',
    NotLessEqual: '\u2270',
    NotLessGreater: '\u2278',
    NotLessLess: '\u226A\u0338',
    NotLessSlantEqual: '\u2A7D\u0338',
    NotLessTilde: '\u2274',
    NotNestedGreaterGreater: '\u2AA2\u0338',
    NotNestedLessLess: '\u2AA1\u0338',
    notni: '\u220C',
    notniva: '\u220C',
    notnivb: '\u22FE',
    notnivc: '\u22FD',
    NotPrecedes: '\u2280',
    NotPrecedesEqual: '\u2AAF\u0338',
    NotPrecedesSlantEqual: '\u22E0',
    NotReverseElement: '\u220C',
    NotRightTriangle: '\u22EB',
    NotRightTriangleBar: '\u29D0\u0338',
    NotRightTriangleEqual: '\u22ED',
    NotSquareSubset: '\u228F\u0338',
    NotSquareSubsetEqual: '\u22E2',
    NotSquareSuperset: '\u2290\u0338',
    NotSquareSupersetEqual: '\u22E3',
    NotSubset: '\u2282\u20D2',
    NotSubsetEqual: '\u2288',
    NotSucceeds: '\u2281',
    NotSucceedsEqual: '\u2AB0\u0338',
    NotSucceedsSlantEqual: '\u22E1',
    NotSucceedsTilde: '\u227F\u0338',
    NotSuperset: '\u2283\u20D2',
    NotSupersetEqual: '\u2289',
    NotTilde: '\u2241',
    NotTildeEqual: '\u2244',
    NotTildeFullEqual: '\u2247',
    NotTildeTilde: '\u2249',
    NotVerticalBar: '\u2224',
    npar: '\u2226',
    nparallel: '\u2226',
    nparsl: '\u2AFD\u20E5',
    npart: '\u2202\u0338',
    npolint: '\u2A14',
    npr: '\u2280',
    nprcue: '\u22E0',
    npre: '\u2AAF\u0338',
    nprec: '\u2280',
    npreceq: '\u2AAF\u0338',
    nrArr: '\u21CF',
    nrarr: '\u219B',
    nrarrc: '\u2933\u0338',
    nrarrw: '\u219D\u0338',
    nRightarrow: '\u21CF',
    nrightarrow: '\u219B',
    nrtri: '\u22EB',
    nrtrie: '\u22ED',
    nsc: '\u2281',
    nsccue: '\u22E1',
    nsce: '\u2AB0\u0338',
    Nscr: '\uD835\uDCA9',
    nscr: '\uD835\uDCC3',
    nshortmid: '\u2224',
    nshortparallel: '\u2226',
    nsim: '\u2241',
    nsime: '\u2244',
    nsimeq: '\u2244',
    nsmid: '\u2224',
    nspar: '\u2226',
    nsqsube: '\u22E2',
    nsqsupe: '\u22E3',
    nsub: '\u2284',
    nsubE: '\u2AC5\u0338',
    nsube: '\u2288',
    nsubset: '\u2282\u20D2',
    nsubseteq: '\u2288',
    nsubseteqq: '\u2AC5\u0338',
    nsucc: '\u2281',
    nsucceq: '\u2AB0\u0338',
    nsup: '\u2285',
    nsupE: '\u2AC6\u0338',
    nsupe: '\u2289',
    nsupset: '\u2283\u20D2',
    nsupseteq: '\u2289',
    nsupseteqq: '\u2AC6\u0338',
    ntgl: '\u2279',
    Ntilde: '\u00D1',
    ntilde: '\u00F1',
    ntlg: '\u2278',
    ntriangleleft: '\u22EA',
    ntrianglelefteq: '\u22EC',
    ntriangleright: '\u22EB',
    ntrianglerighteq: '\u22ED',
    Nu: '\u039D',
    nu: '\u03BD',
    num: '\u0023',
    numero: '\u2116',
    numsp: '\u2007',
    nvap: '\u224D\u20D2',
    nVDash: '\u22AF',
    nVdash: '\u22AE',
    nvDash: '\u22AD',
    nvdash: '\u22AC',
    nvge: '\u2265\u20D2',
    nvgt: '\u003E\u20D2',
    nvHarr: '\u2904',
    nvinfin: '\u29DE',
    nvlArr: '\u2902',
    nvle: '\u2264\u20D2',
    nvlt: '\u003C\u20D2',
    nvltrie: '\u22B4\u20D2',
    nvrArr: '\u2903',
    nvrtrie: '\u22B5\u20D2',
    nvsim: '\u223C\u20D2',
    nwarhk: '\u2923',
    nwArr: '\u21D6',
    nwarr: '\u2196',
    nwarrow: '\u2196',
    nwnear: '\u2927',
    Oacute: '\u00D3',
    oacute: '\u00F3',
    oast: '\u229B',
    ocir: '\u229A',
    Ocirc: '\u00D4',
    ocirc: '\u00F4',
    Ocy: '\u041E',
    ocy: '\u043E',
    odash: '\u229D',
    Odblac: '\u0150',
    odblac: '\u0151',
    odiv: '\u2A38',
    odot: '\u2299',
    odsold: '\u29BC',
    OElig: '\u0152',
    oelig: '\u0153',
    ofcir: '\u29BF',
    Ofr: '\uD835\uDD12',
    ofr: '\uD835\uDD2C',
    ogon: '\u02DB',
    Ograve: '\u00D2',
    ograve: '\u00F2',
    ogt: '\u29C1',
    ohbar: '\u29B5',
    ohm: '\u03A9',
    oint: '\u222E',
    olarr: '\u21BA',
    olcir: '\u29BE',
    olcross: '\u29BB',
    oline: '\u203E',
    olt: '\u29C0',
    Omacr: '\u014C',
    omacr: '\u014D',
    Omega: '\u03A9',
    omega: '\u03C9',
    Omicron: '\u039F',
    omicron: '\u03BF',
    omid: '\u29B6',
    ominus: '\u2296',
    Oopf: '\uD835\uDD46',
    oopf: '\uD835\uDD60',
    opar: '\u29B7',
    OpenCurlyDoubleQuote: '\u201C',
    OpenCurlyQuote: '\u2018',
    operp: '\u29B9',
    oplus: '\u2295',
    Or: '\u2A54',
    or: '\u2228',
    orarr: '\u21BB',
    ord: '\u2A5D',
    order: '\u2134',
    orderof: '\u2134',
    ordf: '\u00AA',
    ordm: '\u00BA',
    origof: '\u22B6',
    oror: '\u2A56',
    orslope: '\u2A57',
    orv: '\u2A5B',
    oS: '\u24C8',
    Oscr: '\uD835\uDCAA',
    oscr: '\u2134',
    Oslash: '\u00D8',
    oslash: '\u00F8',
    osol: '\u2298',
    Otilde: '\u00D5',
    otilde: '\u00F5',
    Otimes: '\u2A37',
    otimes: '\u2297',
    otimesas: '\u2A36',
    Ouml: '\u00D6',
    ouml: '\u00F6',
    ovbar: '\u233D',
    OverBar: '\u203E',
    OverBrace: '\u23DE',
    OverBracket: '\u23B4',
    OverParenthesis: '\u23DC',
    par: '\u2225',
    para: '\u00B6',
    parallel: '\u2225',
    parsim: '\u2AF3',
    parsl: '\u2AFD',
    part: '\u2202',
    PartialD: '\u2202',
    Pcy: '\u041F',
    pcy: '\u043F',
    percnt: '\u0025',
    period: '\u002E',
    permil: '\u2030',
    perp: '\u22A5',
    pertenk: '\u2031',
    Pfr: '\uD835\uDD13',
    pfr: '\uD835\uDD2D',
    Phi: '\u03A6',
    phi: '\u03C6',
    phiv: '\u03D5',
    phmmat: '\u2133',
    phone: '\u260E',
    Pi: '\u03A0',
    pi: '\u03C0',
    pitchfork: '\u22D4',
    piv: '\u03D6',
    planck: '\u210F',
    planckh: '\u210E',
    plankv: '\u210F',
    plus: '\u002B',
    plusacir: '\u2A23',
    plusb: '\u229E',
    pluscir: '\u2A22',
    plusdo: '\u2214',
    plusdu: '\u2A25',
    pluse: '\u2A72',
    PlusMinus: '\u00B1',
    plusmn: '\u00B1',
    plussim: '\u2A26',
    plustwo: '\u2A27',
    pm: '\u00B1',
    Poincareplane: '\u210C',
    pointint: '\u2A15',
    Popf: '\u2119',
    popf: '\uD835\uDD61',
    pound: '\u00A3',
    Pr: '\u2ABB',
    pr: '\u227A',
    prap: '\u2AB7',
    prcue: '\u227C',
    prE: '\u2AB3',
    pre: '\u2AAF',
    prec: '\u227A',
    precapprox: '\u2AB7',
    preccurlyeq: '\u227C',
    Precedes: '\u227A',
    PrecedesEqual: '\u2AAF',
    PrecedesSlantEqual: '\u227C',
    PrecedesTilde: '\u227E',
    preceq: '\u2AAF',
    precnapprox: '\u2AB9',
    precneqq: '\u2AB5',
    precnsim: '\u22E8',
    precsim: '\u227E',
    Prime: '\u2033',
    prime: '\u2032',
    primes: '\u2119',
    prnap: '\u2AB9',
    prnE: '\u2AB5',
    prnsim: '\u22E8',
    prod: '\u220F',
    Product: '\u220F',
    profalar: '\u232E',
    profline: '\u2312',
    profsurf: '\u2313',
    prop: '\u221D',
    Proportion: '\u2237',
    Proportional: '\u221D',
    propto: '\u221D',
    prsim: '\u227E',
    prurel: '\u22B0',
    Pscr: '\uD835\uDCAB',
    pscr: '\uD835\uDCC5',
    Psi: '\u03A8',
    psi: '\u03C8',
    puncsp: '\u2008',
    Qfr: '\uD835\uDD14',
    qfr: '\uD835\uDD2E',
    qint: '\u2A0C',
    Qopf: '\u211A',
    qopf: '\uD835\uDD62',
    qprime: '\u2057',
    Qscr: '\uD835\uDCAC',
    qscr: '\uD835\uDCC6',
    quaternions: '\u210D',
    quatint: '\u2A16',
    quest: '\u003F',
    questeq: '\u225F',
    QUOT: '\u0022',
    quot: '\u0022',
    rAarr: '\u21DB',
    race: '\u223D\u0331',
    Racute: '\u0154',
    racute: '\u0155',
    radic: '\u221A',
    raemptyv: '\u29B3',
    Rang: '\u27EB',
    rang: '\u27E9',
    rangd: '\u2992',
    range: '\u29A5',
    rangle: '\u27E9',
    raquo: '\u00BB',
    Rarr: '\u21A0',
    rArr: '\u21D2',
    rarr: '\u2192',
    rarrap: '\u2975',
    rarrb: '\u21E5',
    rarrbfs: '\u2920',
    rarrc: '\u2933',
    rarrfs: '\u291E',
    rarrhk: '\u21AA',
    rarrlp: '\u21AC',
    rarrpl: '\u2945',
    rarrsim: '\u2974',
    Rarrtl: '\u2916',
    rarrtl: '\u21A3',
    rarrw: '\u219D',
    rAtail: '\u291C',
    ratail: '\u291A',
    ratio: '\u2236',
    rationals: '\u211A',
    RBarr: '\u2910',
    rBarr: '\u290F',
    rbarr: '\u290D',
    rbbrk: '\u2773',
    rbrace: '\u007D',
    rbrack: '\u005D',
    rbrke: '\u298C',
    rbrksld: '\u298E',
    rbrkslu: '\u2990',
    Rcaron: '\u0158',
    rcaron: '\u0159',
    Rcedil: '\u0156',
    rcedil: '\u0157',
    rceil: '\u2309',
    rcub: '\u007D',
    Rcy: '\u0420',
    rcy: '\u0440',
    rdca: '\u2937',
    rdldhar: '\u2969',
    rdquo: '\u201D',
    rdquor: '\u201D',
    rdsh: '\u21B3',
    Re: '\u211C',
    real: '\u211C',
    realine: '\u211B',
    realpart: '\u211C',
    reals: '\u211D',
    rect: '\u25AD',
    REG: '\u00AE',
    reg: '\u00AE',
    ReverseElement: '\u220B',
    ReverseEquilibrium: '\u21CB',
    ReverseUpEquilibrium: '\u296F',
    rfisht: '\u297D',
    rfloor: '\u230B',
    Rfr: '\u211C',
    rfr: '\uD835\uDD2F',
    rHar: '\u2964',
    rhard: '\u21C1',
    rharu: '\u21C0',
    rharul: '\u296C',
    Rho: '\u03A1',
    rho: '\u03C1',
    rhov: '\u03F1',
    RightAngleBracket: '\u27E9',
    RightArrow: '\u2192',
    Rightarrow: '\u21D2',
    rightarrow: '\u2192',
    RightArrowBar: '\u21E5',
    RightArrowLeftArrow: '\u21C4',
    rightarrowtail: '\u21A3',
    RightCeiling: '\u2309',
    RightDoubleBracket: '\u27E7',
    RightDownTeeVector: '\u295D',
    RightDownVector: '\u21C2',
    RightDownVectorBar: '\u2955',
    RightFloor: '\u230B',
    rightharpoondown: '\u21C1',
    rightharpoonup: '\u21C0',
    rightleftarrows: '\u21C4',
    rightleftharpoons: '\u21CC',
    rightrightarrows: '\u21C9',
    rightsquigarrow: '\u219D',
    RightTee: '\u22A2',
    RightTeeArrow: '\u21A6',
    RightTeeVector: '\u295B',
    rightthreetimes: '\u22CC',
    RightTriangle: '\u22B3',
    RightTriangleBar: '\u29D0',
    RightTriangleEqual: '\u22B5',
    RightUpDownVector: '\u294F',
    RightUpTeeVector: '\u295C',
    RightUpVector: '\u21BE',
    RightUpVectorBar: '\u2954',
    RightVector: '\u21C0',
    RightVectorBar: '\u2953',
    ring: '\u02DA',
    risingdotseq: '\u2253',
    rlarr: '\u21C4',
    rlhar: '\u21CC',
    rlm: '\u200F',
    rmoust: '\u23B1',
    rmoustache: '\u23B1',
    rnmid: '\u2AEE',
    roang: '\u27ED',
    roarr: '\u21FE',
    robrk: '\u27E7',
    ropar: '\u2986',
    Ropf: '\u211D',
    ropf: '\uD835\uDD63',
    roplus: '\u2A2E',
    rotimes: '\u2A35',
    RoundImplies: '\u2970',
    rpar: '\u0029',
    rpargt: '\u2994',
    rppolint: '\u2A12',
    rrarr: '\u21C9',
    Rrightarrow: '\u21DB',
    rsaquo: '\u203A',
    Rscr: '\u211B',
    rscr: '\uD835\uDCC7',
    Rsh: '\u21B1',
    rsh: '\u21B1',
    rsqb: '\u005D',
    rsquo: '\u2019',
    rsquor: '\u2019',
    rthree: '\u22CC',
    rtimes: '\u22CA',
    rtri: '\u25B9',
    rtrie: '\u22B5',
    rtrif: '\u25B8',
    rtriltri: '\u29CE',
    RuleDelayed: '\u29F4',
    ruluhar: '\u2968',
    rx: '\u211E',
    Sacute: '\u015A',
    sacute: '\u015B',
    sbquo: '\u201A',
    Sc: '\u2ABC',
    sc: '\u227B',
    scap: '\u2AB8',
    Scaron: '\u0160',
    scaron: '\u0161',
    sccue: '\u227D',
    scE: '\u2AB4',
    sce: '\u2AB0',
    Scedil: '\u015E',
    scedil: '\u015F',
    Scirc: '\u015C',
    scirc: '\u015D',
    scnap: '\u2ABA',
    scnE: '\u2AB6',
    scnsim: '\u22E9',
    scpolint: '\u2A13',
    scsim: '\u227F',
    Scy: '\u0421',
    scy: '\u0441',
    sdot: '\u22C5',
    sdotb: '\u22A1',
    sdote: '\u2A66',
    searhk: '\u2925',
    seArr: '\u21D8',
    searr: '\u2198',
    searrow: '\u2198',
    sect: '\u00A7',
    semi: '\u003B',
    seswar: '\u2929',
    setminus: '\u2216',
    setmn: '\u2216',
    sext: '\u2736',
    Sfr: '\uD835\uDD16',
    sfr: '\uD835\uDD30',
    sfrown: '\u2322',
    sharp: '\u266F',
    SHCHcy: '\u0429',
    shchcy: '\u0449',
    SHcy: '\u0428',
    shcy: '\u0448',
    ShortDownArrow: '\u2193',
    ShortLeftArrow: '\u2190',
    shortmid: '\u2223',
    shortparallel: '\u2225',
    ShortRightArrow: '\u2192',
    ShortUpArrow: '\u2191',
    shy: '\u00AD',
    Sigma: '\u03A3',
    sigma: '\u03C3',
    sigmaf: '\u03C2',
    sigmav: '\u03C2',
    sim: '\u223C',
    simdot: '\u2A6A',
    sime: '\u2243',
    simeq: '\u2243',
    simg: '\u2A9E',
    simgE: '\u2AA0',
    siml: '\u2A9D',
    simlE: '\u2A9F',
    simne: '\u2246',
    simplus: '\u2A24',
    simrarr: '\u2972',
    slarr: '\u2190',
    SmallCircle: '\u2218',
    smallsetminus: '\u2216',
    smashp: '\u2A33',
    smeparsl: '\u29E4',
    smid: '\u2223',
    smile: '\u2323',
    smt: '\u2AAA',
    smte: '\u2AAC',
    smtes: '\u2AAC\uFE00',
    SOFTcy: '\u042C',
    softcy: '\u044C',
    sol: '\u002F',
    solb: '\u29C4',
    solbar: '\u233F',
    Sopf: '\uD835\uDD4A',
    sopf: '\uD835\uDD64',
    spades: '\u2660',
    spadesuit: '\u2660',
    spar: '\u2225',
    sqcap: '\u2293',
    sqcaps: '\u2293\uFE00',
    sqcup: '\u2294',
    sqcups: '\u2294\uFE00',
    Sqrt: '\u221A',
    sqsub: '\u228F',
    sqsube: '\u2291',
    sqsubset: '\u228F',
    sqsubseteq: '\u2291',
    sqsup: '\u2290',
    sqsupe: '\u2292',
    sqsupset: '\u2290',
    sqsupseteq: '\u2292',
    squ: '\u25A1',
    Square: '\u25A1',
    square: '\u25A1',
    SquareIntersection: '\u2293',
    SquareSubset: '\u228F',
    SquareSubsetEqual: '\u2291',
    SquareSuperset: '\u2290',
    SquareSupersetEqual: '\u2292',
    SquareUnion: '\u2294',
    squarf: '\u25AA',
    squf: '\u25AA',
    srarr: '\u2192',
    Sscr: '\uD835\uDCAE',
    sscr: '\uD835\uDCC8',
    ssetmn: '\u2216',
    ssmile: '\u2323',
    sstarf: '\u22C6',
    Star: '\u22C6',
    star: '\u2606',
    starf: '\u2605',
    straightepsilon: '\u03F5',
    straightphi: '\u03D5',
    strns: '\u00AF',
    Sub: '\u22D0',
    sub: '\u2282',
    subdot: '\u2ABD',
    subE: '\u2AC5',
    sube: '\u2286',
    subedot: '\u2AC3',
    submult: '\u2AC1',
    subnE: '\u2ACB',
    subne: '\u228A',
    subplus: '\u2ABF',
    subrarr: '\u2979',
    Subset: '\u22D0',
    subset: '\u2282',
    subseteq: '\u2286',
    subseteqq: '\u2AC5',
    SubsetEqual: '\u2286',
    subsetneq: '\u228A',
    subsetneqq: '\u2ACB',
    subsim: '\u2AC7',
    subsub: '\u2AD5',
    subsup: '\u2AD3',
    succ: '\u227B',
    succapprox: '\u2AB8',
    succcurlyeq: '\u227D',
    Succeeds: '\u227B',
    SucceedsEqual: '\u2AB0',
    SucceedsSlantEqual: '\u227D',
    SucceedsTilde: '\u227F',
    succeq: '\u2AB0',
    succnapprox: '\u2ABA',
    succneqq: '\u2AB6',
    succnsim: '\u22E9',
    succsim: '\u227F',
    SuchThat: '\u220B',
    Sum: '\u2211',
    sum: '\u2211',
    sung: '\u266A',
    Sup: '\u22D1',
    sup: '\u2283',
    sup1: '\u00B9',
    sup2: '\u00B2',
    sup3: '\u00B3',
    supdot: '\u2ABE',
    supdsub: '\u2AD8',
    supE: '\u2AC6',
    supe: '\u2287',
    supedot: '\u2AC4',
    Superset: '\u2283',
    SupersetEqual: '\u2287',
    suphsol: '\u27C9',
    suphsub: '\u2AD7',
    suplarr: '\u297B',
    supmult: '\u2AC2',
    supnE: '\u2ACC',
    supne: '\u228B',
    supplus: '\u2AC0',
    Supset: '\u22D1',
    supset: '\u2283',
    supseteq: '\u2287',
    supseteqq: '\u2AC6',
    supsetneq: '\u228B',
    supsetneqq: '\u2ACC',
    supsim: '\u2AC8',
    supsub: '\u2AD4',
    supsup: '\u2AD6',
    swarhk: '\u2926',
    swArr: '\u21D9',
    swarr: '\u2199',
    swarrow: '\u2199',
    swnwar: '\u292A',
    szlig: '\u00DF',
    Tab: '\u0009',
    target: '\u2316',
    Tau: '\u03A4',
    tau: '\u03C4',
    tbrk: '\u23B4',
    Tcaron: '\u0164',
    tcaron: '\u0165',
    Tcedil: '\u0162',
    tcedil: '\u0163',
    Tcy: '\u0422',
    tcy: '\u0442',
    tdot: '\u20DB',
    telrec: '\u2315',
    Tfr: '\uD835\uDD17',
    tfr: '\uD835\uDD31',
    there4: '\u2234',
    Therefore: '\u2234',
    therefore: '\u2234',
    Theta: '\u0398',
    theta: '\u03B8',
    thetasym: '\u03D1',
    thetav: '\u03D1',
    thickapprox: '\u2248',
    thicksim: '\u223C',
    ThickSpace: '\u205F\u200A',
    thinsp: '\u2009',
    ThinSpace: '\u2009',
    thkap: '\u2248',
    thksim: '\u223C',
    THORN: '\u00DE',
    thorn: '\u00FE',
    Tilde: '\u223C',
    tilde: '\u02DC',
    TildeEqual: '\u2243',
    TildeFullEqual: '\u2245',
    TildeTilde: '\u2248',
    times: '\u00D7',
    timesb: '\u22A0',
    timesbar: '\u2A31',
    timesd: '\u2A30',
    tint: '\u222D',
    toea: '\u2928',
    top: '\u22A4',
    topbot: '\u2336',
    topcir: '\u2AF1',
    Topf: '\uD835\uDD4B',
    topf: '\uD835\uDD65',
    topfork: '\u2ADA',
    tosa: '\u2929',
    tprime: '\u2034',
    TRADE: '\u2122',
    trade: '\u2122',
    triangle: '\u25B5',
    triangledown: '\u25BF',
    triangleleft: '\u25C3',
    trianglelefteq: '\u22B4',
    triangleq: '\u225C',
    triangleright: '\u25B9',
    trianglerighteq: '\u22B5',
    tridot: '\u25EC',
    trie: '\u225C',
    triminus: '\u2A3A',
    TripleDot: '\u20DB',
    triplus: '\u2A39',
    trisb: '\u29CD',
    tritime: '\u2A3B',
    trpezium: '\u23E2',
    Tscr: '\uD835\uDCAF',
    tscr: '\uD835\uDCC9',
    TScy: '\u0426',
    tscy: '\u0446',
    TSHcy: '\u040B',
    tshcy: '\u045B',
    Tstrok: '\u0166',
    tstrok: '\u0167',
    twixt: '\u226C',
    twoheadleftarrow: '\u219E',
    twoheadrightarrow: '\u21A0',
    Uacute: '\u00DA',
    uacute: '\u00FA',
    Uarr: '\u219F',
    uArr: '\u21D1',
    uarr: '\u2191',
    Uarrocir: '\u2949',
    Ubrcy: '\u040E',
    ubrcy: '\u045E',
    Ubreve: '\u016C',
    ubreve: '\u016D',
    Ucirc: '\u00DB',
    ucirc: '\u00FB',
    Ucy: '\u0423',
    ucy: '\u0443',
    udarr: '\u21C5',
    Udblac: '\u0170',
    udblac: '\u0171',
    udhar: '\u296E',
    ufisht: '\u297E',
    Ufr: '\uD835\uDD18',
    ufr: '\uD835\uDD32',
    Ugrave: '\u00D9',
    ugrave: '\u00F9',
    uHar: '\u2963',
    uharl: '\u21BF',
    uharr: '\u21BE',
    uhblk: '\u2580',
    ulcorn: '\u231C',
    ulcorner: '\u231C',
    ulcrop: '\u230F',
    ultri: '\u25F8',
    Umacr: '\u016A',
    umacr: '\u016B',
    uml: '\u00A8',
    UnderBar: '\u005F',
    UnderBrace: '\u23DF',
    UnderBracket: '\u23B5',
    UnderParenthesis: '\u23DD',
    Union: '\u22C3',
    UnionPlus: '\u228E',
    Uogon: '\u0172',
    uogon: '\u0173',
    Uopf: '\uD835\uDD4C',
    uopf: '\uD835\uDD66',
    UpArrow: '\u2191',
    Uparrow: '\u21D1',
    uparrow: '\u2191',
    UpArrowBar: '\u2912',
    UpArrowDownArrow: '\u21C5',
    UpDownArrow: '\u2195',
    Updownarrow: '\u21D5',
    updownarrow: '\u2195',
    UpEquilibrium: '\u296E',
    upharpoonleft: '\u21BF',
    upharpoonright: '\u21BE',
    uplus: '\u228E',
    UpperLeftArrow: '\u2196',
    UpperRightArrow: '\u2197',
    Upsi: '\u03D2',
    upsi: '\u03C5',
    upsih: '\u03D2',
    Upsilon: '\u03A5',
    upsilon: '\u03C5',
    UpTee: '\u22A5',
    UpTeeArrow: '\u21A5',
    upuparrows: '\u21C8',
    urcorn: '\u231D',
    urcorner: '\u231D',
    urcrop: '\u230E',
    Uring: '\u016E',
    uring: '\u016F',
    urtri: '\u25F9',
    Uscr: '\uD835\uDCB0',
    uscr: '\uD835\uDCCA',
    utdot: '\u22F0',
    Utilde: '\u0168',
    utilde: '\u0169',
    utri: '\u25B5',
    utrif: '\u25B4',
    uuarr: '\u21C8',
    Uuml: '\u00DC',
    uuml: '\u00FC',
    uwangle: '\u29A7',
    vangrt: '\u299C',
    varepsilon: '\u03F5',
    varkappa: '\u03F0',
    varnothing: '\u2205',
    varphi: '\u03D5',
    varpi: '\u03D6',
    varpropto: '\u221D',
    vArr: '\u21D5',
    varr: '\u2195',
    varrho: '\u03F1',
    varsigma: '\u03C2',
    varsubsetneq: '\u228A\uFE00',
    varsubsetneqq: '\u2ACB\uFE00',
    varsupsetneq: '\u228B\uFE00',
    varsupsetneqq: '\u2ACC\uFE00',
    vartheta: '\u03D1',
    vartriangleleft: '\u22B2',
    vartriangleright: '\u22B3',
    Vbar: '\u2AEB',
    vBar: '\u2AE8',
    vBarv: '\u2AE9',
    Vcy: '\u0412',
    vcy: '\u0432',
    VDash: '\u22AB',
    Vdash: '\u22A9',
    vDash: '\u22A8',
    vdash: '\u22A2',
    Vdashl: '\u2AE6',
    Vee: '\u22C1',
    vee: '\u2228',
    veebar: '\u22BB',
    veeeq: '\u225A',
    vellip: '\u22EE',
    Verbar: '\u2016',
    verbar: '\u007C',
    Vert: '\u2016',
    vert: '\u007C',
    VerticalBar: '\u2223',
    VerticalLine: '\u007C',
    VerticalSeparator: '\u2758',
    VerticalTilde: '\u2240',
    VeryThinSpace: '\u200A',
    Vfr: '\uD835\uDD19',
    vfr: '\uD835\uDD33',
    vltri: '\u22B2',
    vnsub: '\u2282\u20D2',
    vnsup: '\u2283\u20D2',
    Vopf: '\uD835\uDD4D',
    vopf: '\uD835\uDD67',
    vprop: '\u221D',
    vrtri: '\u22B3',
    Vscr: '\uD835\uDCB1',
    vscr: '\uD835\uDCCB',
    vsubnE: '\u2ACB\uFE00',
    vsubne: '\u228A\uFE00',
    vsupnE: '\u2ACC\uFE00',
    vsupne: '\u228B\uFE00',
    Vvdash: '\u22AA',
    vzigzag: '\u299A',
    Wcirc: '\u0174',
    wcirc: '\u0175',
    wedbar: '\u2A5F',
    Wedge: '\u22C0',
    wedge: '\u2227',
    wedgeq: '\u2259',
    weierp: '\u2118',
    Wfr: '\uD835\uDD1A',
    wfr: '\uD835\uDD34',
    Wopf: '\uD835\uDD4E',
    wopf: '\uD835\uDD68',
    wp: '\u2118',
    wr: '\u2240',
    wreath: '\u2240',
    Wscr: '\uD835\uDCB2',
    wscr: '\uD835\uDCCC',
    xcap: '\u22C2',
    xcirc: '\u25EF',
    xcup: '\u22C3',
    xdtri: '\u25BD',
    Xfr: '\uD835\uDD1B',
    xfr: '\uD835\uDD35',
    xhArr: '\u27FA',
    xharr: '\u27F7',
    Xi: '\u039E',
    xi: '\u03BE',
    xlArr: '\u27F8',
    xlarr: '\u27F5',
    xmap: '\u27FC',
    xnis: '\u22FB',
    xodot: '\u2A00',
    Xopf: '\uD835\uDD4F',
    xopf: '\uD835\uDD69',
    xoplus: '\u2A01',
    xotime: '\u2A02',
    xrArr: '\u27F9',
    xrarr: '\u27F6',
    Xscr: '\uD835\uDCB3',
    xscr: '\uD835\uDCCD',
    xsqcup: '\u2A06',
    xuplus: '\u2A04',
    xutri: '\u25B3',
    xvee: '\u22C1',
    xwedge: '\u22C0',
    Yacute: '\u00DD',
    yacute: '\u00FD',
    YAcy: '\u042F',
    yacy: '\u044F',
    Ycirc: '\u0176',
    ycirc: '\u0177',
    Ycy: '\u042B',
    ycy: '\u044B',
    yen: '\u00A5',
    Yfr: '\uD835\uDD1C',
    yfr: '\uD835\uDD36',
    YIcy: '\u0407',
    yicy: '\u0457',
    Yopf: '\uD835\uDD50',
    yopf: '\uD835\uDD6A',
    Yscr: '\uD835\uDCB4',
    yscr: '\uD835\uDCCE',
    YUcy: '\u042E',
    yucy: '\u044E',
    Yuml: '\u0178',
    yuml: '\u00FF',
    Zacute: '\u0179',
    zacute: '\u017A',
    Zcaron: '\u017D',
    zcaron: '\u017E',
    Zcy: '\u0417',
    zcy: '\u0437',
    Zdot: '\u017B',
    zdot: '\u017C',
    zeetrf: '\u2128',
    ZeroWidthSpace: '\u200B',
    Zeta: '\u0396',
    zeta: '\u03B6',
    Zfr: '\u2128',
    zfr: '\uD835\uDD37',
    ZHcy: '\u0416',
    zhcy: '\u0436',
    zigrarr: '\u21DD',
    Zopf: '\u2124',
    zopf: '\uD835\uDD6B',
    Zscr: '\uD835\uDCB5',
    zscr: '\uD835\uDCCF',
    zwj: '\u200D',
    zwnj: '\u200C'
});
$da6e094d46e1b593$export$79451380caed3f98 = $da6e094d46e1b593$export$b7e4d4631df36afa;

});

parcelRegister("lt8RX", function(module, exports) {

$parcel$export(module.exports, "XMLReader", function () { return $fa132fa34720508b$export$ccbc9f9f018333e9; }, function (v) { return $fa132fa34720508b$export$ccbc9f9f018333e9 = v; });
$parcel$export(module.exports, "ParseError", function () { return $fa132fa34720508b$export$f9c837a54db411d; }, function (v) { return $fa132fa34720508b$export$f9c837a54db411d = v; });
var $fa132fa34720508b$export$ccbc9f9f018333e9;
var $fa132fa34720508b$export$f9c837a54db411d;

var $2Nc10 = parcelRequire("2Nc10");
var $fa132fa34720508b$require$NAMESPACE = $2Nc10.NAMESPACE;
//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var $fa132fa34720508b$var$nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/ //\u10000-\uEFFFF
;
var $fa132fa34720508b$var$nameChar = new RegExp("[\\-\\.0-9" + $fa132fa34720508b$var$nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var $fa132fa34720508b$var$tagNamePattern = new RegExp('^' + $fa132fa34720508b$var$nameStartChar.source + $fa132fa34720508b$var$nameChar.source + '*(?:\:' + $fa132fa34720508b$var$nameStartChar.source + $fa132fa34720508b$var$nameChar.source + '*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var $fa132fa34720508b$var$S_TAG = 0; //tag name offerring
var $fa132fa34720508b$var$S_ATTR = 1; //attr name offerring
var $fa132fa34720508b$var$S_ATTR_SPACE = 2; //attr name end and space offer
var $fa132fa34720508b$var$S_EQ = 3; //=space?
var $fa132fa34720508b$var$S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var $fa132fa34720508b$var$S_ATTR_END = 5; //attr value end and no space(quot end)
var $fa132fa34720508b$var$S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var $fa132fa34720508b$var$S_TAG_CLOSE = 7; //closed el<el />
/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */ function $fa132fa34720508b$var$ParseError(message, locator) {
    this.message = message;
    this.locator = locator;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $fa132fa34720508b$var$ParseError);
}
$fa132fa34720508b$var$ParseError.prototype = new Error();
$fa132fa34720508b$var$ParseError.prototype.name = $fa132fa34720508b$var$ParseError.name;
function $fa132fa34720508b$var$XMLReader() {}
$fa132fa34720508b$var$XMLReader.prototype = {
    parse: function(source, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        $fa132fa34720508b$var$_copy(defaultNSMap, defaultNSMap = {});
        $fa132fa34720508b$var$parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
        domBuilder.endDocument();
    }
};
function $fa132fa34720508b$var$parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
    function fixedFromCharCode(code) {
        // String.prototype.fromCharCode does not supports
        // > 2 bytes unicode chars directly
        if (code > 0xffff) {
            code -= 0x10000;
            var surrogate1 = 0xd800 + (code >> 10), surrogate2 = 0xdc00 + (code & 0x3ff);
            return String.fromCharCode(surrogate1, surrogate2);
        } else return String.fromCharCode(code);
    }
    function entityReplacer(a) {
        var k = a.slice(1, -1);
        if (Object.hasOwnProperty.call(entityMap, k)) return entityMap[k];
        else if (k.charAt(0) === '#') return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')));
        else {
            errorHandler.error('entity not found:' + a);
            return a;
        }
    }
    function appendText(end) {
        if (end > start) {
            var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
            locator && position(start);
            domBuilder.characters(xt, 0, end - start);
            start = end;
        }
    }
    function position(p, m) {
        while(p >= lineEnd && (m = linePattern.exec(source))){
            lineStart = m.index;
            lineEnd = lineStart + m[0].length;
            locator.lineNumber++;
        //console.log('line++:',locator,startPos,endPos)
        }
        locator.columnNumber = p - lineStart + 1;
    }
    var lineStart = 0;
    var lineEnd = 0;
    var linePattern = /.*(?:\r\n?|\n)|.*$/g;
    var locator = domBuilder.locator;
    var parseStack = [
        {
            currentNSMap: defaultNSMapCopy
        }
    ];
    var closeMap = {};
    var start = 0;
    while(true){
        try {
            var tagStart = source.indexOf('<', start);
            if (tagStart < 0) {
                if (!source.substr(start).match(/^\s*$/)) {
                    var doc = domBuilder.doc;
                    var text = doc.createTextNode(source.substr(start));
                    doc.appendChild(text);
                    domBuilder.currentElement = text;
                }
                return;
            }
            if (tagStart > start) appendText(tagStart);
            switch(source.charAt(tagStart + 1)){
                case '/':
                    var end = source.indexOf('>', tagStart + 3);
                    var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
                    var config = parseStack.pop();
                    if (end < 0) {
                        tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
                        end = tagStart + 1 + tagName.length;
                    } else if (tagName.match(/\s</)) {
                        tagName = tagName.replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' maybe not complete');
                        end = tagStart + 1 + tagName.length;
                    }
                    var localNSMap = config.localNSMap;
                    var endMatch = config.tagName == tagName;
                    var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
                    if (endIgnoreCaseMach) {
                        domBuilder.endElement(config.uri, config.localName, tagName);
                        if (localNSMap) {
                            for(var prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
                        }
                        if (!endMatch) errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName); // No known test case
                    } else parseStack.push(config);
                    end++;
                    break;
                // end elment
                case '?':
                    locator && position(tagStart);
                    end = $fa132fa34720508b$var$parseInstruction(source, tagStart, domBuilder);
                    break;
                case '!':
                    locator && position(tagStart);
                    end = $fa132fa34720508b$var$parseDCC(source, tagStart, domBuilder, errorHandler);
                    break;
                default:
                    locator && position(tagStart);
                    var el = new $fa132fa34720508b$var$ElementAttributes();
                    var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
                    //elStartEnd
                    var end = $fa132fa34720508b$var$parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
                    var len = el.length;
                    if (!el.closed && $fa132fa34720508b$var$fixSelfClosed(source, end, el.tagName, closeMap)) {
                        el.closed = true;
                        if (!entityMap.nbsp) errorHandler.warning('unclosed xml attribute');
                    }
                    if (locator && len) {
                        var locator2 = $fa132fa34720508b$var$copyLocator(locator, {});
                        //try{//attribute position fixed
                        for(var i = 0; i < len; i++){
                            var a = el[i];
                            position(a.offset);
                            a.locator = $fa132fa34720508b$var$copyLocator(locator, {});
                        }
                        domBuilder.locator = locator2;
                        if ($fa132fa34720508b$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                        domBuilder.locator = locator;
                    } else if ($fa132fa34720508b$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                    if ($fa132fa34720508b$require$NAMESPACE.isHTML(el.uri) && !el.closed) end = $fa132fa34720508b$var$parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
                    else end++;
            }
        } catch (e) {
            if (e instanceof $fa132fa34720508b$var$ParseError) throw e;
            errorHandler.error('element parse error: ' + e);
            end = -1;
        }
        if (end > start) start = end;
        else //TODO: 这里有可能sax回退，有位置错误风险
        appendText(Math.max(tagStart, start) + 1);
    }
}
function $fa132fa34720508b$var$copyLocator(f, t) {
    t.lineNumber = f.lineNumber;
    t.columnNumber = f.columnNumber;
    return t;
}
/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */ function $fa132fa34720508b$var$parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
    /**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */ function addAttribute(qname, value, startIndex) {
        if (el.attributeNames.hasOwnProperty(qname)) errorHandler.fatalError('Attribute ' + qname + ' redefined');
        el.addValue(qname, // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer), startIndex);
    }
    var attrName;
    var value;
    var p = ++start;
    var s = $fa132fa34720508b$var$S_TAG; //status
    while(true){
        var c = source.charAt(p);
        switch(c){
            case '=':
                if (s === $fa132fa34720508b$var$S_ATTR) {
                    attrName = source.slice(start, p);
                    s = $fa132fa34720508b$var$S_EQ;
                } else if (s === $fa132fa34720508b$var$S_ATTR_SPACE) s = $fa132fa34720508b$var$S_EQ;
                else //fatalError: equal must after attrName or space after attrName
                throw new Error('attribute equal must after attrName'); // No known test case
                break;
            case '\'':
            case '"':
                if (s === $fa132fa34720508b$var$S_EQ || s === $fa132fa34720508b$var$S_ATTR //|| s == S_ATTR_SPACE
                ) {
                    if (s === $fa132fa34720508b$var$S_ATTR) {
                        errorHandler.warning('attribute value must after "="');
                        attrName = source.slice(start, p);
                    }
                    start = p + 1;
                    p = source.indexOf(c, start);
                    if (p > 0) {
                        value = source.slice(start, p);
                        addAttribute(attrName, value, start - 1);
                        s = $fa132fa34720508b$var$S_ATTR_END;
                    } else //fatalError: no end quot match
                    throw new Error('attribute value no end \'' + c + '\' match');
                } else if (s == $fa132fa34720508b$var$S_ATTR_NOQUOT_VALUE) {
                    value = source.slice(start, p);
                    addAttribute(attrName, value, start);
                    errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
                    start = p + 1;
                    s = $fa132fa34720508b$var$S_ATTR_END;
                } else //fatalError: no equal before
                throw new Error('attribute value must after "="'); // No known test case
                break;
            case '/':
                switch(s){
                    case $fa132fa34720508b$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $fa132fa34720508b$var$S_ATTR_END:
                    case $fa132fa34720508b$var$S_TAG_SPACE:
                    case $fa132fa34720508b$var$S_TAG_CLOSE:
                        s = $fa132fa34720508b$var$S_TAG_CLOSE;
                        el.closed = true;
                    case $fa132fa34720508b$var$S_ATTR_NOQUOT_VALUE:
                    case $fa132fa34720508b$var$S_ATTR:
                        break;
                    case $fa132fa34720508b$var$S_ATTR_SPACE:
                        el.closed = true;
                        break;
                    //case S_EQ:
                    default:
                        throw new Error("attribute invalid close char('/')") // No known test case
                        ;
                }
                break;
            case '':
                errorHandler.error('unexpected end of input');
                if (s == $fa132fa34720508b$var$S_TAG) el.setTagName(source.slice(start, p));
                return p;
            case '>':
                switch(s){
                    case $fa132fa34720508b$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $fa132fa34720508b$var$S_ATTR_END:
                    case $fa132fa34720508b$var$S_TAG_SPACE:
                    case $fa132fa34720508b$var$S_TAG_CLOSE:
                        break; //normal
                    case $fa132fa34720508b$var$S_ATTR_NOQUOT_VALUE:
                    case $fa132fa34720508b$var$S_ATTR:
                        value = source.slice(start, p);
                        if (value.slice(-1) === '/') {
                            el.closed = true;
                            value = value.slice(0, -1);
                        }
                    case $fa132fa34720508b$var$S_ATTR_SPACE:
                        if (s === $fa132fa34720508b$var$S_ATTR_SPACE) value = attrName;
                        if (s == $fa132fa34720508b$var$S_ATTR_NOQUOT_VALUE) {
                            errorHandler.warning('attribute "' + value + '" missed quot(")!');
                            addAttribute(attrName, value, start);
                        } else {
                            if (!$fa132fa34720508b$require$NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
                            addAttribute(value, value, start);
                        }
                        break;
                    case $fa132fa34720508b$var$S_EQ:
                        throw new Error('attribute value missed!!');
                }
                //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
                return p;
            /*xml space '\x20' | #x9 | #xD | #xA; */ case '\u0080':
                c = ' ';
            default:
                if (c <= ' ') switch(s){
                    case $fa132fa34720508b$var$S_TAG:
                        el.setTagName(source.slice(start, p)); //tagName
                        s = $fa132fa34720508b$var$S_TAG_SPACE;
                        break;
                    case $fa132fa34720508b$var$S_ATTR:
                        attrName = source.slice(start, p);
                        s = $fa132fa34720508b$var$S_ATTR_SPACE;
                        break;
                    case $fa132fa34720508b$var$S_ATTR_NOQUOT_VALUE:
                        var value = source.slice(start, p);
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        addAttribute(attrName, value, start);
                    case $fa132fa34720508b$var$S_ATTR_END:
                        s = $fa132fa34720508b$var$S_TAG_SPACE;
                        break;
                }
                else //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
                //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
                switch(s){
                    //case S_TAG:void();break;
                    //case S_ATTR:void();break;
                    //case S_ATTR_NOQUOT_VALUE:void();break;
                    case $fa132fa34720508b$var$S_ATTR_SPACE:
                        var tagName = el.tagName;
                        if (!$fa132fa34720508b$require$NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                        addAttribute(attrName, attrName, start);
                        start = p;
                        s = $fa132fa34720508b$var$S_ATTR;
                        break;
                    case $fa132fa34720508b$var$S_ATTR_END:
                        errorHandler.warning('attribute space is required"' + attrName + '"!!');
                    case $fa132fa34720508b$var$S_TAG_SPACE:
                        s = $fa132fa34720508b$var$S_ATTR;
                        start = p;
                        break;
                    case $fa132fa34720508b$var$S_EQ:
                        s = $fa132fa34720508b$var$S_ATTR_NOQUOT_VALUE;
                        start = p;
                        break;
                    case $fa132fa34720508b$var$S_TAG_CLOSE:
                        throw new Error("elements closed character '/' and '>' must be connected to");
                }
        } //end outer switch
        //console.log('p++',p)
        p++;
    }
}
/**
 * @return true if has new namespace define
 */ function $fa132fa34720508b$var$appendElement(el, domBuilder, currentNSMap) {
    var tagName = el.tagName;
    var localNSMap = null;
    //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
    var i = el.length;
    while(i--){
        var a = el[i];
        var qName = a.qName;
        var value = a.value;
        var nsp = qName.indexOf(':');
        if (nsp > 0) {
            var prefix = a.prefix = qName.slice(0, nsp);
            var localName = qName.slice(nsp + 1);
            var nsPrefix = prefix === 'xmlns' && localName;
        } else {
            localName = qName;
            prefix = null;
            nsPrefix = qName === 'xmlns' && '';
        }
        //can not set prefix,because prefix !== ''
        a.localName = localName;
        //prefix == null for no ns prefix attribute
        if (nsPrefix !== false) {
            if (localNSMap == null) {
                localNSMap = {};
                //console.log(currentNSMap,0)
                $fa132fa34720508b$var$_copy(currentNSMap, currentNSMap = {});
            //console.log(currentNSMap,1)
            }
            currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
            a.uri = $fa132fa34720508b$require$NAMESPACE.XMLNS;
            domBuilder.startPrefixMapping(nsPrefix, value);
        }
    }
    var i = el.length;
    while(i--){
        a = el[i];
        var prefix = a.prefix;
        if (prefix) {
            if (prefix === 'xml') a.uri = $fa132fa34720508b$require$NAMESPACE.XML;
            if (prefix !== 'xmlns') a.uri = currentNSMap[prefix || ''];
        }
    }
    var nsp = tagName.indexOf(':');
    if (nsp > 0) {
        prefix = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
    } else {
        prefix = null; //important!!
        localName = el.localName = tagName;
    }
    //no prefix element has default namespace
    var ns = el.uri = currentNSMap[prefix || ''];
    domBuilder.startElement(ns, localName, tagName, el);
    //endPrefixMapping and startPrefixMapping have not any help for dom builder
    //localNSMap = null
    if (el.closed) {
        domBuilder.endElement(ns, localName, tagName);
        if (localNSMap) {
            for(prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
        }
    } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        //parseStack.push(el);
        return true;
    }
}
function $fa132fa34720508b$var$parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
    if (/^(?:script|textarea)$/i.test(tagName)) {
        var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
        var text = source.substring(elStartEnd + 1, elEndStart);
        if (/[&<]/.test(text)) {
            if (/^script$/i.test(tagName)) {
                //if(!/\]\]>/.test(text)){
                //lexHandler.startCDATA();
                domBuilder.characters(text, 0, text.length);
                //lexHandler.endCDATA();
                return elEndStart;
            //}
            } //}else{//text area
            text = text.replace(/&#?\w+;/g, entityReplacer);
            domBuilder.characters(text, 0, text.length);
            return elEndStart;
        //}
        }
    }
    return elStartEnd + 1;
}
function $fa132fa34720508b$var$fixSelfClosed(source, elStartEnd, tagName, closeMap) {
    //if(tagName in closeMap){
    var pos = closeMap[tagName];
    if (pos == null) {
        //console.log(tagName)
        pos = source.lastIndexOf('</' + tagName + '>');
        if (pos < elStartEnd) pos = source.lastIndexOf('</' + tagName);
        closeMap[tagName] = pos;
    }
    return pos < elStartEnd;
//}
}
function $fa132fa34720508b$var$_copy(source, target) {
    for(var n in source)if (Object.prototype.hasOwnProperty.call(source, n)) target[n] = source[n];
}
function $fa132fa34720508b$var$parseDCC(source, start, domBuilder, errorHandler) {
    var next = source.charAt(start + 2);
    switch(next){
        case '-':
            if (source.charAt(start + 3) === '-') {
                var end = source.indexOf('-->', start + 4);
                //append comment source.substring(4,end)//<!--
                if (end > start) {
                    domBuilder.comment(source, start + 4, end - start - 4);
                    return end + 3;
                } else {
                    errorHandler.error("Unclosed comment");
                    return -1;
                }
            } else //error
            return -1;
        default:
            if (source.substr(start + 3, 6) == 'CDATA[') {
                var end = source.indexOf(']]>', start + 9);
                domBuilder.startCDATA();
                domBuilder.characters(source, start + 9, end - start - 9);
                domBuilder.endCDATA();
                return end + 3;
            }
            //<!DOCTYPE
            //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
            var matchs = $fa132fa34720508b$var$split(source, start);
            var len = matchs.length;
            if (len > 1 && /!doctype/i.test(matchs[0][0])) {
                var name = matchs[1][0];
                var pubid = false;
                var sysid = false;
                if (len > 3) {
                    if (/^public$/i.test(matchs[2][0])) {
                        pubid = matchs[3][0];
                        sysid = len > 4 && matchs[4][0];
                    } else if (/^system$/i.test(matchs[2][0])) sysid = matchs[3][0];
                }
                var lastMatch = matchs[len - 1];
                domBuilder.startDTD(name, pubid, sysid);
                domBuilder.endDTD();
                return lastMatch.index + lastMatch[0].length;
            }
    }
    return -1;
}
function $fa132fa34720508b$var$parseInstruction(source, start, domBuilder) {
    var end = source.indexOf('?>', start);
    if (end) {
        var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)$/);
        if (match) {
            var len = match[0].length;
            domBuilder.processingInstruction(match[1], match[2]);
            return end + 2;
        } else return -1;
    }
    return -1;
}
function $fa132fa34720508b$var$ElementAttributes() {
    this.attributeNames = {};
}
$fa132fa34720508b$var$ElementAttributes.prototype = {
    setTagName: function(tagName) {
        if (!$fa132fa34720508b$var$tagNamePattern.test(tagName)) throw new Error('invalid tagName:' + tagName);
        this.tagName = tagName;
    },
    addValue: function(qName, value, offset) {
        if (!$fa132fa34720508b$var$tagNamePattern.test(qName)) throw new Error('invalid attribute:' + qName);
        this.attributeNames[qName] = this.length;
        this[this.length++] = {
            qName: qName,
            value: value,
            offset: offset
        };
    },
    length: 0,
    getLocalName: function(i) {
        return this[i].localName;
    },
    getLocator: function(i) {
        return this[i].locator;
    },
    getQName: function(i) {
        return this[i].qName;
    },
    getURI: function(i) {
        return this[i].uri;
    },
    getValue: function(i) {
        return this[i].value;
    }
};
function $fa132fa34720508b$var$split(source, start) {
    var match;
    var buf = [];
    var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    reg.lastIndex = start;
    reg.exec(source); //skip <
    while(match = reg.exec(source)){
        buf.push(match);
        if (match[1]) return buf;
    }
}
$fa132fa34720508b$export$ccbc9f9f018333e9 = $fa132fa34720508b$var$XMLReader;
$fa132fa34720508b$export$f9c837a54db411d = $fa132fa34720508b$var$ParseError;

});




parcelRegister("cCCVy", function(module, exports) {

$parcel$export(module.exports, "Element", function () { return $93073ac61096a9a1$export$db77ccec0bb4ccac; }, function (v) { return $93073ac61096a9a1$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "element", function () { return $93073ac61096a9a1$export$8454457683f90105; }, function (v) { return $93073ac61096a9a1$export$8454457683f90105 = v; });
$parcel$export(module.exports, "text", function () { return $93073ac61096a9a1$export$6f093cfa640b7166; }, function (v) { return $93073ac61096a9a1$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "emptyElement", function () { return $93073ac61096a9a1$export$ae6de35c16b306df; }, function (v) { return $93073ac61096a9a1$export$ae6de35c16b306df = v; });
var $93073ac61096a9a1$export$db77ccec0bb4ccac;
var $93073ac61096a9a1$export$8454457683f90105;
var $93073ac61096a9a1$export$6f093cfa640b7166;
var $93073ac61096a9a1$export$ae6de35c16b306df;
parcelRequire("eSbtG");
var $1kSpe = parcelRequire("1kSpe");
var $e4fgt = parcelRequire("e4fgt");
var $6dYu1 = parcelRequire("6dYu1");
var $3CMFi = parcelRequire("3CMFi");
$93073ac61096a9a1$export$db77ccec0bb4ccac = $93073ac61096a9a1$var$Element;
$93073ac61096a9a1$export$8454457683f90105 = function(name, attributes, children) {
    return new $93073ac61096a9a1$var$Element(name, attributes, children);
};
$93073ac61096a9a1$export$6f093cfa640b7166 = function(value) {
    return {
        type: "text",
        value: value
    };
};
var $93073ac61096a9a1$var$emptyElement = $93073ac61096a9a1$export$ae6de35c16b306df = {
    first: function() {
        return null;
    },
    firstOrEmpty: function() {
        return $93073ac61096a9a1$var$emptyElement;
    },
    attributes: {},
    children: []
};
function $93073ac61096a9a1$var$Element(name, attributes, children) {
    this.type = "element";
    this.name = name;
    this.attributes = attributes || {};
    this.children = children || [];
}
$93073ac61096a9a1$var$Element.prototype.first = function(name) {
    return $6dYu1.default(this.children, function(child) {
        return child.name === name;
    });
};
$93073ac61096a9a1$var$Element.prototype.firstOrEmpty = function(name) {
    return this.first(name) || $93073ac61096a9a1$var$emptyElement;
};
$93073ac61096a9a1$var$Element.prototype.getElementsByTagName = function(name) {
    var elements = $e4fgt.default(this.children, function(child) {
        return child.name === name;
    });
    return $93073ac61096a9a1$var$toElementList(elements);
};
$93073ac61096a9a1$var$Element.prototype.text = function() {
    if (this.children.length === 0) return "";
    else if (this.children.length !== 1 || this.children[0].type !== "text") throw new Error("Not implemented");
    return this.children[0].value;
};
var $93073ac61096a9a1$var$elementListPrototype = {
    getElementsByTagName: function(name) {
        return $93073ac61096a9a1$var$toElementList($3CMFi.default(this.map(function(element) {
            return element.getElementsByTagName(name);
        }, true)));
    }
};
function $93073ac61096a9a1$var$toElementList(array) {
    return $1kSpe.default(array, $93073ac61096a9a1$var$elementListPrototype);
}

});


parcelRegister("83iSM", function(module, exports) {

$parcel$export(module.exports, "writeString", function () { return $5dcd403c32c9c239$export$48a3ce3d8cfe0ce1; }, function (v) { return $5dcd403c32c9c239$export$48a3ce3d8cfe0ce1 = v; });
var $5dcd403c32c9c239$export$48a3ce3d8cfe0ce1;
parcelRequire("eSbtG");
var $6YL8K = parcelRequire("6YL8K");
var $1OS4y = parcelRequire("1OS4y");

var $ewVHs = parcelRequire("ewVHs");
$5dcd403c32c9c239$export$48a3ce3d8cfe0ce1 = $5dcd403c32c9c239$var$writeString;
function $5dcd403c32c9c239$var$writeString(root, namespaces) {
    var uriToPrefix = $1OS4y.default(namespaces);
    var nodeWriters = {
        element: writeElement,
        text: $5dcd403c32c9c239$var$writeTextNode
    };
    function writeNode(builder, node) {
        return nodeWriters[node.type](builder, node);
    }
    function writeElement(builder, element) {
        var elementBuilder = builder.element(mapElementName(element.name), element.attributes);
        element.children.forEach(function(child) {
            writeNode(elementBuilder, child);
        });
    }
    function mapElementName(name) {
        var longFormMatch = /^\{(.*)\}(.*)$/.exec(name);
        if (longFormMatch) {
            var prefix = uriToPrefix[longFormMatch[1]];
            return prefix + (prefix === "" ? "" : ":") + longFormMatch[2];
        } else return name;
    }
    function writeDocument(root) {
        var builder = $ewVHs.create(mapElementName(root.name), {
            version: '1.0',
            encoding: 'UTF-8',
            standalone: true
        });
        $6YL8K.default(namespaces, function(uri, prefix) {
            var key = "xmlns" + (prefix === "" ? "" : ":" + prefix);
            builder.attribute(key, uri);
        });
        root.children.forEach(function(child) {
            writeNode(builder, child);
        });
        return builder.end();
    }
    return writeDocument(root);
}
function $5dcd403c32c9c239$var$writeTextNode(builder, node) {
    builder.text(node.value);
}

});
parcelRegister("ewVHs", function(module, exports) {





// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;
    ref = (parcelRequire("bYeh6")), assign = ref.assign, isFunction = ref.isFunction;
    XMLDocument = (parcelRequire("jRRsS"));
    XMLDocumentCB = (parcelRequire("lTOY3"));
    XMLStringWriter = (parcelRequire("dqkHE"));
    XMLStreamWriter = (parcelRequire("444Ot"));
    module.exports.create = function(name, xmldec, doctype, options) {
        var doc, root;
        if (name == null) throw new Error("Root element needs a name.");
        options = assign({}, xmldec, doctype, options);
        doc = new XMLDocument(options);
        root = doc.element(name);
        if (!options.headless) {
            doc.declaration(options);
            if (options.pubID != null || options.sysID != null) doc.doctype(options);
        }
        return root;
    };
    module.exports.begin = function(options, onData, onEnd) {
        var ref1;
        if (isFunction(options)) {
            ref1 = [
                options,
                onData
            ], onData = ref1[0], onEnd = ref1[1];
            options = {};
        }
        if (onData) return new XMLDocumentCB(options, onData, onEnd);
        else return new XMLDocument(options);
    };
    module.exports.stringWriter = function(options) {
        return new XMLStringWriter(options);
    };
    module.exports.streamWriter = function(stream, options) {
        return new XMLStreamWriter(stream, options);
    };
}).call(module.exports);

});
parcelRegister("bYeh6", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var assign, getValue, isArray, isEmpty, isFunction, isObject, isPlainObject, slice = [].slice, hasProp = {}.hasOwnProperty;
    assign = function() {
        var i, key, len, source, sources, target;
        target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
        if (isFunction(Object.assign)) Object.assign.apply(null, arguments);
        else for(i = 0, len = sources.length; i < len; i++){
            source = sources[i];
            if (source != null) for(key in source){
                if (!hasProp.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    };
    isFunction = function(val) {
        return !!val && Object.prototype.toString.call(val) === '[object Function]';
    };
    isObject = function(val) {
        var ref;
        return !!val && ((ref = typeof val) === 'function' || ref === 'object');
    };
    isArray = function(val) {
        if (isFunction(Array.isArray)) return Array.isArray(val);
        else return Object.prototype.toString.call(val) === '[object Array]';
    };
    isEmpty = function(val) {
        var key;
        if (isArray(val)) return !val.length;
        else {
            for(key in val){
                if (!hasProp.call(val, key)) continue;
                return false;
            }
            return true;
        }
    };
    isPlainObject = function(val) {
        var ctor, proto;
        return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && typeof ctor === 'function' && ctor instanceof ctor && Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object);
    };
    getValue = function(obj) {
        if (isFunction(obj.valueOf)) return obj.valueOf();
        else return obj;
    };
    module.exports.assign = assign;
    module.exports.isFunction = isFunction;
    module.exports.isObject = isObject;
    module.exports.isArray = isArray;
    module.exports.isEmpty = isEmpty;
    module.exports.isPlainObject = isPlainObject;
    module.exports.getValue = getValue;
}).call(module.exports);

});

parcelRegister("jRRsS", function(module, exports) {




// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isPlainObject = (parcelRequire("bYeh6")).isPlainObject;
    XMLNode = (parcelRequire("bcvYM"));
    XMLStringifier = (parcelRequire("lASXj"));
    XMLStringWriter = (parcelRequire("dqkHE"));
    module.exports = XMLDocument = function(superClass) {
        extend(XMLDocument, superClass);
        function XMLDocument(options) {
            XMLDocument.__super__.constructor.call(this, null);
            this.name = "?xml";
            options || (options = {});
            if (!options.writer) options.writer = new XMLStringWriter();
            this.options = options;
            this.stringify = new XMLStringifier(options);
            this.isDocument = true;
        }
        XMLDocument.prototype.end = function(writer) {
            var writerOptions;
            if (!writer) writer = this.options.writer;
            else if (isPlainObject(writer)) {
                writerOptions = writer;
                writer = this.options.writer.set(writerOptions);
            }
            return writer.document(this);
        };
        XMLDocument.prototype.toString = function(options) {
            return this.options.writer.set(options).document(this);
        };
        return XMLDocument;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("bcvYM", function(module, exports) {










// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLNode, XMLProcessingInstruction, XMLRaw, XMLText, getValue, isEmpty, isFunction, isObject, ref, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("bYeh6")), isObject = ref.isObject, isFunction = ref.isFunction, isEmpty = ref.isEmpty, getValue = ref.getValue;
    XMLElement = null;
    XMLCData = null;
    XMLComment = null;
    XMLDeclaration = null;
    XMLDocType = null;
    XMLRaw = null;
    XMLText = null;
    XMLProcessingInstruction = null;
    XMLDummy = null;
    module.exports = XMLNode = function() {
        function XMLNode(parent) {
            this.parent = parent;
            if (this.parent) {
                this.options = this.parent.options;
                this.stringify = this.parent.stringify;
            }
            this.children = [];
            if (!XMLElement) {
                XMLElement = (parcelRequire("5kEbD"));
                XMLCData = (parcelRequire("73EDm"));
                XMLComment = (parcelRequire("gp1wF"));
                XMLDeclaration = (parcelRequire("9pGkJ"));
                XMLDocType = (parcelRequire("7tjYi"));
                XMLRaw = (parcelRequire("66i9K"));
                XMLText = (parcelRequire("k9JpZ"));
                XMLProcessingInstruction = (parcelRequire("3LBrm"));
                XMLDummy = (parcelRequire("M2us3"));
            }
        }
        XMLNode.prototype.element = function(name, attributes, text) {
            var childNode, item, j, k, key, lastChild, len, len1, ref1, ref2, val;
            lastChild = null;
            if (attributes === null && text == null) ref1 = [
                {},
                null
            ], attributes = ref1[0], text = ref1[1];
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref2 = [
                attributes,
                text
            ], text = ref2[0], attributes = ref2[1];
            if (name != null) name = getValue(name);
            if (Array.isArray(name)) for(j = 0, len = name.length; j < len; j++){
                item = name[j];
                lastChild = this.element(item);
            }
            else if (isFunction(name)) lastChild = this.element(name.apply());
            else if (isObject(name)) for(key in name){
                if (!hasProp.call(name, key)) continue;
                val = name[key];
                if (isFunction(val)) val = val.apply();
                if (isObject(val) && isEmpty(val)) val = null;
                if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
                else if (!this.options.separateArrayItems && Array.isArray(val)) for(k = 0, len1 = val.length; k < len1; k++){
                    item = val[k];
                    childNode = {};
                    childNode[key] = item;
                    lastChild = this.element(childNode);
                }
                else if (isObject(val)) {
                    lastChild = this.element(key);
                    lastChild.element(val);
                } else lastChild = this.element(key, val);
            }
            else if (this.options.skipNullNodes && text === null) lastChild = this.dummy();
            else {
                if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) lastChild = this.text(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) lastChild = this.cdata(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) lastChild = this.comment(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) lastChild = this.raw(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
                else lastChild = this.node(name, attributes, text);
            }
            if (lastChild == null) throw new Error("Could not create any elements with: " + name + ". " + this.debugInfo());
            return lastChild;
        };
        XMLNode.prototype.insertBefore = function(name, attributes, text) {
            var child, i, removed;
            if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.element(name, attributes, text);
            Array.prototype.push.apply(this.parent.children, removed);
            return child;
        };
        XMLNode.prototype.insertAfter = function(name, attributes, text) {
            var child, i, removed;
            if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.element(name, attributes, text);
            Array.prototype.push.apply(this.parent.children, removed);
            return child;
        };
        XMLNode.prototype.remove = function() {
            var i, ref1;
            if (this.isRoot) throw new Error("Cannot remove the root element. " + this.debugInfo());
            i = this.parent.children.indexOf(this);
            [].splice.apply(this.parent.children, [
                i,
                i - i + 1
            ].concat(ref1 = [])), ref1;
            return this.parent;
        };
        XMLNode.prototype.node = function(name, attributes, text) {
            var child, ref1;
            if (name != null) name = getValue(name);
            attributes || (attributes = {});
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref1 = [
                attributes,
                text
            ], text = ref1[0], attributes = ref1[1];
            child = new XMLElement(this, name, attributes);
            if (text != null) child.text(text);
            this.children.push(child);
            return child;
        };
        XMLNode.prototype.text = function(value) {
            var child;
            child = new XMLText(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.cdata = function(value) {
            var child;
            child = new XMLCData(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.comment = function(value) {
            var child;
            child = new XMLComment(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.commentBefore = function(value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.comment(value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.commentAfter = function(value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.comment(value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.raw = function(value) {
            var child;
            child = new XMLRaw(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.dummy = function() {
            var child;
            child = new XMLDummy(this);
            this.children.push(child);
            return child;
        };
        XMLNode.prototype.instruction = function(target, value) {
            var insTarget, insValue, instruction, j, len;
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(j = 0, len = target.length; j < len; j++){
                insTarget = target[j];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                instruction = new XMLProcessingInstruction(this, target, value);
                this.children.push(instruction);
            }
            return this;
        };
        XMLNode.prototype.instructionBefore = function(target, value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.instruction(target, value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.instructionAfter = function(target, value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.instruction(target, value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.declaration = function(version, encoding, standalone) {
            var doc, xmldec;
            doc = this.document();
            xmldec = new XMLDeclaration(doc, version, encoding, standalone);
            if (doc.children[0] instanceof XMLDeclaration) doc.children[0] = xmldec;
            else doc.children.unshift(xmldec);
            return doc.root() || doc;
        };
        XMLNode.prototype.doctype = function(pubID, sysID) {
            var child, doc, doctype, i, j, k, len, len1, ref1, ref2;
            doc = this.document();
            doctype = new XMLDocType(doc, pubID, sysID);
            ref1 = doc.children;
            for(i = j = 0, len = ref1.length; j < len; i = ++j){
                child = ref1[i];
                if (child instanceof XMLDocType) {
                    doc.children[i] = doctype;
                    return doctype;
                }
            }
            ref2 = doc.children;
            for(i = k = 0, len1 = ref2.length; k < len1; i = ++k){
                child = ref2[i];
                if (child.isRoot) {
                    doc.children.splice(i, 0, doctype);
                    return doctype;
                }
            }
            doc.children.push(doctype);
            return doctype;
        };
        XMLNode.prototype.up = function() {
            if (this.isRoot) throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
            return this.parent;
        };
        XMLNode.prototype.root = function() {
            var node;
            node = this;
            while(node){
                if (node.isDocument) return node.rootObject;
                else if (node.isRoot) return node;
                else node = node.parent;
            }
        };
        XMLNode.prototype.document = function() {
            var node;
            node = this;
            while(node){
                if (node.isDocument) return node;
                else node = node.parent;
            }
        };
        XMLNode.prototype.end = function(options) {
            return this.document().end(options);
        };
        XMLNode.prototype.prev = function() {
            var i;
            i = this.parent.children.indexOf(this);
            while(i > 0 && this.parent.children[i - 1].isDummy)i = i - 1;
            if (i < 1) throw new Error("Already at the first node. " + this.debugInfo());
            return this.parent.children[i - 1];
        };
        XMLNode.prototype.next = function() {
            var i;
            i = this.parent.children.indexOf(this);
            while(i < this.parent.children.length - 1 && this.parent.children[i + 1].isDummy)i = i + 1;
            if (i === -1 || i === this.parent.children.length - 1) throw new Error("Already at the last node. " + this.debugInfo());
            return this.parent.children[i + 1];
        };
        XMLNode.prototype.importDocument = function(doc) {
            var clonedRoot;
            clonedRoot = doc.root().clone();
            clonedRoot.parent = this;
            clonedRoot.isRoot = false;
            this.children.push(clonedRoot);
            return this;
        };
        XMLNode.prototype.debugInfo = function(name) {
            var ref1, ref2;
            name = name || this.name;
            if (name == null && !((ref1 = this.parent) != null ? ref1.name : void 0)) return "";
            else if (name == null) return "parent: <" + this.parent.name + ">";
            else if (!((ref2 = this.parent) != null ? ref2.name : void 0)) return "node: <" + name + ">";
            else return "node: <" + name + ">, parent: <" + this.parent.name + ">";
        };
        XMLNode.prototype.ele = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLNode.prototype.nod = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLNode.prototype.txt = function(value) {
            return this.text(value);
        };
        XMLNode.prototype.dat = function(value) {
            return this.cdata(value);
        };
        XMLNode.prototype.com = function(value) {
            return this.comment(value);
        };
        XMLNode.prototype.ins = function(target, value) {
            return this.instruction(target, value);
        };
        XMLNode.prototype.doc = function() {
            return this.document();
        };
        XMLNode.prototype.dec = function(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        };
        XMLNode.prototype.dtd = function(pubID, sysID) {
            return this.doctype(pubID, sysID);
        };
        XMLNode.prototype.e = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLNode.prototype.n = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLNode.prototype.t = function(value) {
            return this.text(value);
        };
        XMLNode.prototype.d = function(value) {
            return this.cdata(value);
        };
        XMLNode.prototype.c = function(value) {
            return this.comment(value);
        };
        XMLNode.prototype.r = function(value) {
            return this.raw(value);
        };
        XMLNode.prototype.i = function(target, value) {
            return this.instruction(target, value);
        };
        XMLNode.prototype.u = function() {
            return this.up();
        };
        XMLNode.prototype.importXMLBuilder = function(doc) {
            return this.importDocument(doc);
        };
        return XMLNode;
    }();
}).call(module.exports);

});
parcelRegister("5kEbD", function(module, exports) {



// Generated by CoffeeScript 1.12.7
(function() {
    var XMLAttribute, XMLElement, XMLNode, getValue, isFunction, isObject, ref, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("bYeh6")), isObject = ref.isObject, isFunction = ref.isFunction, getValue = ref.getValue;
    XMLNode = (parcelRequire("bcvYM"));
    XMLAttribute = (parcelRequire("kiXJB"));
    module.exports = XMLElement = function(superClass) {
        extend(XMLElement, superClass);
        function XMLElement(parent, name, attributes) {
            XMLElement.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing element name. " + this.debugInfo());
            this.name = this.stringify.eleName(name);
            this.attributes = {};
            if (attributes != null) this.attribute(attributes);
            if (parent.isDocument) {
                this.isRoot = true;
                this.documentObject = parent;
                parent.rootObject = this;
            }
        }
        XMLElement.prototype.clone = function() {
            var att, attName, clonedSelf, ref1;
            clonedSelf = Object.create(this);
            if (clonedSelf.isRoot) clonedSelf.documentObject = null;
            clonedSelf.attributes = {};
            ref1 = this.attributes;
            for(attName in ref1){
                if (!hasProp.call(ref1, attName)) continue;
                att = ref1[attName];
                clonedSelf.attributes[attName] = att.clone();
            }
            clonedSelf.children = [];
            this.children.forEach(function(child) {
                var clonedChild;
                clonedChild = child.clone();
                clonedChild.parent = clonedSelf;
                return clonedSelf.children.push(clonedChild);
            });
            return clonedSelf;
        };
        XMLElement.prototype.attribute = function(name, value) {
            var attName, attValue;
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (!this.options.skipNullAttributes || value != null) this.attributes[name] = new XMLAttribute(this, name, value);
            }
            return this;
        };
        XMLElement.prototype.removeAttribute = function(name) {
            var attName, i, len;
            if (name == null) throw new Error("Missing attribute name. " + this.debugInfo());
            name = getValue(name);
            if (Array.isArray(name)) for(i = 0, len = name.length; i < len; i++){
                attName = name[i];
                delete this.attributes[attName];
            }
            else delete this.attributes[name];
            return this;
        };
        XMLElement.prototype.toString = function(options) {
            return this.options.writer.set(options).element(this);
        };
        XMLElement.prototype.att = function(name, value) {
            return this.attribute(name, value);
        };
        XMLElement.prototype.a = function(name, value) {
            return this.attribute(name, value);
        };
        return XMLElement;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("kiXJB", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLAttribute;
    module.exports = XMLAttribute = function() {
        function XMLAttribute(parent, name, value) {
            this.options = parent.options;
            this.stringify = parent.stringify;
            this.parent = parent;
            if (name == null) throw new Error("Missing attribute name. " + this.debugInfo(name));
            if (value == null) throw new Error("Missing attribute value. " + this.debugInfo(name));
            this.name = this.stringify.attName(name);
            this.value = this.stringify.attValue(value);
        }
        XMLAttribute.prototype.clone = function() {
            return Object.create(this);
        };
        XMLAttribute.prototype.toString = function(options) {
            return this.options.writer.set(options).attribute(this);
        };
        XMLAttribute.prototype.debugInfo = function(name) {
            name = name || this.name;
            if (name == null) return "parent: <" + this.parent.name + ">";
            else return "attribute: {" + name + "}, parent: <" + this.parent.name + ">";
        };
        return XMLAttribute;
    }();
}).call(module.exports);

});


parcelRegister("73EDm", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLCData = function(superClass) {
        extend(XMLCData, superClass);
        function XMLCData(parent, text) {
            XMLCData.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing CDATA text. " + this.debugInfo());
            this.text = this.stringify.cdata(text);
        }
        XMLCData.prototype.clone = function() {
            return Object.create(this);
        };
        XMLCData.prototype.toString = function(options) {
            return this.options.writer.set(options).cdata(this);
        };
        return XMLCData;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("gp1wF", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLComment, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLComment = function(superClass) {
        extend(XMLComment, superClass);
        function XMLComment(parent, text) {
            XMLComment.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing comment text. " + this.debugInfo());
            this.text = this.stringify.comment(text);
        }
        XMLComment.prototype.clone = function() {
            return Object.create(this);
        };
        XMLComment.prototype.toString = function(options) {
            return this.options.writer.set(options).comment(this);
        };
        return XMLComment;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("9pGkJ", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDeclaration, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("bYeh6")).isObject;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLDeclaration = function(superClass) {
        extend(XMLDeclaration, superClass);
        function XMLDeclaration(parent, version, encoding, standalone) {
            var ref;
            XMLDeclaration.__super__.constructor.call(this, parent);
            if (isObject(version)) ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
            if (!version) version = '1.0';
            this.version = this.stringify.xmlVersion(version);
            if (encoding != null) this.encoding = this.stringify.xmlEncoding(encoding);
            if (standalone != null) this.standalone = this.stringify.xmlStandalone(standalone);
        }
        XMLDeclaration.prototype.toString = function(options) {
            return this.options.writer.set(options).declaration(this);
        };
        return XMLDeclaration;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("7tjYi", function(module, exports) {






// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("bYeh6")).isObject;
    XMLNode = (parcelRequire("bcvYM"));
    XMLDTDAttList = (parcelRequire("5FtTh"));
    XMLDTDEntity = (parcelRequire("1oLLR"));
    XMLDTDElement = (parcelRequire("heKvN"));
    XMLDTDNotation = (parcelRequire("fvQnb"));
    module.exports = XMLDocType = function(superClass) {
        extend(XMLDocType, superClass);
        function XMLDocType(parent, pubID, sysID) {
            var ref, ref1;
            XMLDocType.__super__.constructor.call(this, parent);
            this.name = "!DOCTYPE";
            this.documentObject = parent;
            if (isObject(pubID)) ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
            if (sysID == null) ref1 = [
                pubID,
                sysID
            ], sysID = ref1[0], pubID = ref1[1];
            if (pubID != null) this.pubID = this.stringify.dtdPubID(pubID);
            if (sysID != null) this.sysID = this.stringify.dtdSysID(sysID);
        }
        XMLDocType.prototype.element = function(name, value) {
            var child;
            child = new XMLDTDElement(this, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var child;
            child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.entity = function(name, value) {
            var child;
            child = new XMLDTDEntity(this, false, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.pEntity = function(name, value) {
            var child;
            child = new XMLDTDEntity(this, true, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.notation = function(name, value) {
            var child;
            child = new XMLDTDNotation(this, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.toString = function(options) {
            return this.options.writer.set(options).docType(this);
        };
        XMLDocType.prototype.ele = function(name, value) {
            return this.element(name, value);
        };
        XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
        };
        XMLDocType.prototype.ent = function(name, value) {
            return this.entity(name, value);
        };
        XMLDocType.prototype.pent = function(name, value) {
            return this.pEntity(name, value);
        };
        XMLDocType.prototype.not = function(name, value) {
            return this.notation(name, value);
        };
        XMLDocType.prototype.up = function() {
            return this.root() || this.documentObject;
        };
        return XMLDocType;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("5FtTh", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDAttList, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLDTDAttList = function(superClass) {
        extend(XMLDTDAttList, superClass);
        function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            XMLDTDAttList.__super__.constructor.call(this, parent);
            if (elementName == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (attributeName == null) throw new Error("Missing DTD attribute name. " + this.debugInfo(elementName));
            if (!attributeType) throw new Error("Missing DTD attribute type. " + this.debugInfo(elementName));
            if (!defaultValueType) throw new Error("Missing DTD attribute default. " + this.debugInfo(elementName));
            if (defaultValueType.indexOf('#') !== 0) defaultValueType = '#' + defaultValueType;
            if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) throw new Error("Default value only applies to #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            this.elementName = this.stringify.eleName(elementName);
            this.attributeName = this.stringify.attName(attributeName);
            this.attributeType = this.stringify.dtdAttType(attributeType);
            this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
            this.defaultValueType = defaultValueType;
        }
        XMLDTDAttList.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdAttList(this);
        };
        return XMLDTDAttList;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("1oLLR", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDEntity, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("bYeh6")).isObject;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLDTDEntity = function(superClass) {
        extend(XMLDTDEntity, superClass);
        function XMLDTDEntity(parent, pe, name, value) {
            XMLDTDEntity.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD entity name. " + this.debugInfo(name));
            if (value == null) throw new Error("Missing DTD entity value. " + this.debugInfo(name));
            this.pe = !!pe;
            this.name = this.stringify.eleName(name);
            if (!isObject(value)) this.value = this.stringify.dtdEntityValue(value);
            else {
                if (!value.pubID && !value.sysID) throw new Error("Public and/or system identifiers are required for an external entity. " + this.debugInfo(name));
                if (value.pubID && !value.sysID) throw new Error("System identifier is required for a public external entity. " + this.debugInfo(name));
                if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
                if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
                if (value.nData != null) this.nData = this.stringify.dtdNData(value.nData);
                if (this.pe && this.nData) throw new Error("Notation declaration is not allowed in a parameter entity. " + this.debugInfo(name));
            }
        }
        XMLDTDEntity.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdEntity(this);
        };
        return XMLDTDEntity;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("heKvN", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDElement, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLDTDElement = function(superClass) {
        extend(XMLDTDElement, superClass);
        function XMLDTDElement(parent, name, value) {
            XMLDTDElement.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (!value) value = '(#PCDATA)';
            if (Array.isArray(value)) value = '(' + value.join(',') + ')';
            this.name = this.stringify.eleName(name);
            this.value = this.stringify.dtdElementValue(value);
        }
        XMLDTDElement.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdElement(this);
        };
        return XMLDTDElement;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("fvQnb", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDNotation, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLDTDNotation = function(superClass) {
        extend(XMLDTDNotation, superClass);
        function XMLDTDNotation(parent, name, value) {
            XMLDTDNotation.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD notation name. " + this.debugInfo(name));
            if (!value.pubID && !value.sysID) throw new Error("Public or system identifiers are required for an external entity. " + this.debugInfo(name));
            this.name = this.stringify.eleName(name);
            if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
            if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        XMLDTDNotation.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdNotation(this);
        };
        return XMLDTDNotation;
    }(XMLNode);
}).call(module.exports);

});


parcelRegister("66i9K", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNode, XMLRaw, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLRaw = function(superClass) {
        extend(XMLRaw, superClass);
        function XMLRaw(parent, text) {
            XMLRaw.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing raw text. " + this.debugInfo());
            this.value = this.stringify.raw(text);
        }
        XMLRaw.prototype.clone = function() {
            return Object.create(this);
        };
        XMLRaw.prototype.toString = function(options) {
            return this.options.writer.set(options).raw(this);
        };
        return XMLRaw;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("k9JpZ", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNode, XMLText, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLText = function(superClass) {
        extend(XMLText, superClass);
        function XMLText(parent, text) {
            XMLText.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing element text. " + this.debugInfo());
            this.value = this.stringify.eleText(text);
        }
        XMLText.prototype.clone = function() {
            return Object.create(this);
        };
        XMLText.prototype.toString = function(options) {
            return this.options.writer.set(options).text(this);
        };
        return XMLText;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("3LBrm", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNode, XMLProcessingInstruction, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLProcessingInstruction = function(superClass) {
        extend(XMLProcessingInstruction, superClass);
        function XMLProcessingInstruction(parent, target, value) {
            XMLProcessingInstruction.__super__.constructor.call(this, parent);
            if (target == null) throw new Error("Missing instruction target. " + this.debugInfo());
            this.target = this.stringify.insTarget(target);
            if (value) this.value = this.stringify.insValue(value);
        }
        XMLProcessingInstruction.prototype.clone = function() {
            return Object.create(this);
        };
        XMLProcessingInstruction.prototype.toString = function(options) {
            return this.options.writer.set(options).processingInstruction(this);
        };
        return XMLProcessingInstruction;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("M2us3", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDummy, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("bcvYM"));
    module.exports = XMLDummy = function(superClass) {
        extend(XMLDummy, superClass);
        function XMLDummy(parent) {
            XMLDummy.__super__.constructor.call(this, parent);
            this.isDummy = true;
        }
        XMLDummy.prototype.clone = function() {
            return Object.create(this);
        };
        XMLDummy.prototype.toString = function(options) {
            return '';
        };
        return XMLDummy;
    }(XMLNode);
}).call(module.exports);

});


parcelRegister("lASXj", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLStringifier, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, hasProp = {}.hasOwnProperty;
    module.exports = XMLStringifier = function() {
        function XMLStringifier(options) {
            this.assertLegalChar = bind(this.assertLegalChar, this);
            var key, ref, value;
            options || (options = {});
            this.noDoubleEncoding = options.noDoubleEncoding;
            ref = options.stringify || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this[key] = value;
            }
        }
        XMLStringifier.prototype.eleName = function(val) {
            val = '' + val || '';
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.eleText = function(val) {
            val = '' + val || '';
            return this.assertLegalChar(this.elEscape(val));
        };
        XMLStringifier.prototype.cdata = function(val) {
            val = '' + val || '';
            val = val.replace(']]>', ']]]]><![CDATA[>');
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.comment = function(val) {
            val = '' + val || '';
            if (val.match(/--/)) throw new Error("Comment text cannot contain double-hypen: " + val);
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.raw = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.attName = function(val) {
            return val = '' + val || '';
        };
        XMLStringifier.prototype.attValue = function(val) {
            val = '' + val || '';
            return this.attEscape(val);
        };
        XMLStringifier.prototype.insTarget = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.insValue = function(val) {
            val = '' + val || '';
            if (val.match(/\?>/)) throw new Error("Invalid processing instruction value: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlVersion = function(val) {
            val = '' + val || '';
            if (!val.match(/1\.[0-9]+/)) throw new Error("Invalid version number: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlEncoding = function(val) {
            val = '' + val || '';
            if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) throw new Error("Invalid encoding: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlStandalone = function(val) {
            if (val) return "yes";
            else return "no";
        };
        XMLStringifier.prototype.dtdPubID = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdSysID = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdElementValue = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdAttType = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdAttDefault = function(val) {
            if (val != null) return '' + val || '';
            else return val;
        };
        XMLStringifier.prototype.dtdEntityValue = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdNData = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.convertAttKey = '@';
        XMLStringifier.prototype.convertPIKey = '?';
        XMLStringifier.prototype.convertTextKey = '#text';
        XMLStringifier.prototype.convertCDataKey = '#cdata';
        XMLStringifier.prototype.convertCommentKey = '#comment';
        XMLStringifier.prototype.convertRawKey = '#raw';
        XMLStringifier.prototype.assertLegalChar = function(str) {
            var res;
            res = str.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/);
            if (res) throw new Error("Invalid character in string: " + str + " at index " + res.index);
            return str;
        };
        XMLStringifier.prototype.elEscape = function(str) {
            var ampregex;
            ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
            return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
        };
        XMLStringifier.prototype.attEscape = function(str) {
            var ampregex;
            ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
            return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
        };
        return XMLStringifier;
    }();
}).call(module.exports);

});

parcelRegister("dqkHE", function(module, exports) {














// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLText, XMLWriterBase, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLDeclaration = (parcelRequire("9pGkJ"));
    XMLDocType = (parcelRequire("7tjYi"));
    XMLCData = (parcelRequire("73EDm"));
    XMLComment = (parcelRequire("gp1wF"));
    XMLElement = (parcelRequire("5kEbD"));
    XMLRaw = (parcelRequire("66i9K"));
    XMLText = (parcelRequire("k9JpZ"));
    XMLProcessingInstruction = (parcelRequire("3LBrm"));
    XMLDummy = (parcelRequire("M2us3"));
    XMLDTDAttList = (parcelRequire("5FtTh"));
    XMLDTDElement = (parcelRequire("heKvN"));
    XMLDTDEntity = (parcelRequire("1oLLR"));
    XMLDTDNotation = (parcelRequire("fvQnb"));
    XMLWriterBase = (parcelRequire("bLkj1"));
    module.exports = XMLStringWriter = function(superClass) {
        extend(XMLStringWriter, superClass);
        function XMLStringWriter(options) {
            XMLStringWriter.__super__.constructor.call(this, options);
        }
        XMLStringWriter.prototype.document = function(doc) {
            var child, i, len, r, ref;
            this.textispresent = false;
            r = '';
            ref = doc.children;
            for(i = 0, len = ref.length; i < len; i++){
                child = ref[i];
                if (child instanceof XMLDummy) continue;
                r += (function() {
                    switch(false){
                        case !(child instanceof XMLDeclaration):
                            return this.declaration(child);
                        case !(child instanceof XMLDocType):
                            return this.docType(child);
                        case !(child instanceof XMLComment):
                            return this.comment(child);
                        case !(child instanceof XMLProcessingInstruction):
                            return this.processingInstruction(child);
                        default:
                            return this.element(child, 0);
                    }
                }).call(this);
            }
            if (this.pretty && r.slice(-this.newline.length) === this.newline) r = r.slice(0, -this.newline.length);
            return r;
        };
        XMLStringWriter.prototype.attribute = function(att) {
            return ' ' + att.name + '="' + att.value + '"';
        };
        XMLStringWriter.prototype.cdata = function(node, level) {
            return this.space(level) + '<![CDATA[' + node.text + ']]>' + this.newline;
        };
        XMLStringWriter.prototype.comment = function(node, level) {
            return this.space(level) + '<!-- ' + node.text + ' -->' + this.newline;
        };
        XMLStringWriter.prototype.declaration = function(node, level) {
            var r;
            r = this.space(level);
            r += '<?xml version="' + node.version + '"';
            if (node.encoding != null) r += ' encoding="' + node.encoding + '"';
            if (node.standalone != null) r += ' standalone="' + node.standalone + '"';
            r += this.spacebeforeslash + '?>';
            r += this.newline;
            return r;
        };
        XMLStringWriter.prototype.docType = function(node, level) {
            var child, i, len, r, ref;
            level || (level = 0);
            r = this.space(level);
            r += '<!DOCTYPE ' + node.root().name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            if (node.children.length > 0) {
                r += ' [';
                r += this.newline;
                ref = node.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    r += (function() {
                        switch(false){
                            case !(child instanceof XMLDTDAttList):
                                return this.dtdAttList(child, level + 1);
                            case !(child instanceof XMLDTDElement):
                                return this.dtdElement(child, level + 1);
                            case !(child instanceof XMLDTDEntity):
                                return this.dtdEntity(child, level + 1);
                            case !(child instanceof XMLDTDNotation):
                                return this.dtdNotation(child, level + 1);
                            case !(child instanceof XMLCData):
                                return this.cdata(child, level + 1);
                            case !(child instanceof XMLComment):
                                return this.comment(child, level + 1);
                            case !(child instanceof XMLProcessingInstruction):
                                return this.processingInstruction(child, level + 1);
                            default:
                                throw new Error("Unknown DTD node type: " + child.constructor.name);
                        }
                    }).call(this);
                }
                r += ']';
            }
            r += this.spacebeforeslash + '>';
            r += this.newline;
            return r;
        };
        XMLStringWriter.prototype.element = function(node, level) {
            var att, child, i, j, len, len1, name, r, ref, ref1, ref2, space, textispresentwasset;
            level || (level = 0);
            textispresentwasset = false;
            if (this.textispresent) {
                this.newline = '';
                this.pretty = false;
            } else {
                this.newline = this.newlinedefault;
                this.pretty = this.prettydefault;
            }
            space = this.space(level);
            r = '';
            r += space + '<' + node.name;
            ref = node.attributes;
            for(name in ref){
                if (!hasProp.call(ref, name)) continue;
                att = ref[name];
                r += this.attribute(att);
            }
            if (node.children.length === 0 || node.children.every(function(e) {
                return e.value === '';
            })) {
                if (this.allowEmpty) r += '></' + node.name + '>' + this.newline;
                else r += this.spacebeforeslash + '/>' + this.newline;
            } else if (this.pretty && node.children.length === 1 && node.children[0].value != null) {
                r += '>';
                r += node.children[0].value;
                r += '</' + node.name + '>' + this.newline;
            } else {
                if (this.dontprettytextnodes) {
                    ref1 = node.children;
                    for(i = 0, len = ref1.length; i < len; i++){
                        child = ref1[i];
                        if (child.value != null) {
                            this.textispresent++;
                            textispresentwasset = true;
                            break;
                        }
                    }
                }
                if (this.textispresent) {
                    this.newline = '';
                    this.pretty = false;
                    space = this.space(level);
                }
                r += '>' + this.newline;
                ref2 = node.children;
                for(j = 0, len1 = ref2.length; j < len1; j++){
                    child = ref2[j];
                    r += (function() {
                        switch(false){
                            case !(child instanceof XMLCData):
                                return this.cdata(child, level + 1);
                            case !(child instanceof XMLComment):
                                return this.comment(child, level + 1);
                            case !(child instanceof XMLElement):
                                return this.element(child, level + 1);
                            case !(child instanceof XMLRaw):
                                return this.raw(child, level + 1);
                            case !(child instanceof XMLText):
                                return this.text(child, level + 1);
                            case !(child instanceof XMLProcessingInstruction):
                                return this.processingInstruction(child, level + 1);
                            case !(child instanceof XMLDummy):
                                return '';
                            default:
                                throw new Error("Unknown XML node type: " + child.constructor.name);
                        }
                    }).call(this);
                }
                if (textispresentwasset) this.textispresent--;
                if (!this.textispresent) {
                    this.newline = this.newlinedefault;
                    this.pretty = this.prettydefault;
                }
                r += space + '</' + node.name + '>' + this.newline;
            }
            return r;
        };
        XMLStringWriter.prototype.processingInstruction = function(node, level) {
            var r;
            r = this.space(level) + '<?' + node.target;
            if (node.value) r += ' ' + node.value;
            r += this.spacebeforeslash + '?>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.raw = function(node, level) {
            return this.space(level) + node.value + this.newline;
        };
        XMLStringWriter.prototype.text = function(node, level) {
            return this.space(level) + node.value + this.newline;
        };
        XMLStringWriter.prototype.dtdAttList = function(node, level) {
            var r;
            r = this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType;
            if (node.defaultValueType !== '#DEFAULT') r += ' ' + node.defaultValueType;
            if (node.defaultValue) r += ' "' + node.defaultValue + '"';
            r += this.spacebeforeslash + '>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.dtdElement = function(node, level) {
            return this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value + this.spacebeforeslash + '>' + this.newline;
        };
        XMLStringWriter.prototype.dtdEntity = function(node, level) {
            var r;
            r = this.space(level) + '<!ENTITY';
            if (node.pe) r += ' %';
            r += ' ' + node.name;
            if (node.value) r += ' "' + node.value + '"';
            else {
                if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
                if (node.nData) r += ' NDATA ' + node.nData;
            }
            r += this.spacebeforeslash + '>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.dtdNotation = function(node, level) {
            var r;
            r = this.space(level) + '<!NOTATION ' + node.name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.pubID) r += ' PUBLIC "' + node.pubID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            r += this.spacebeforeslash + '>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.openNode = function(node, level) {
            var att, name, r, ref;
            level || (level = 0);
            if (node instanceof XMLElement) {
                r = this.space(level) + '<' + node.name;
                ref = node.attributes;
                for(name in ref){
                    if (!hasProp.call(ref, name)) continue;
                    att = ref[name];
                    r += this.attribute(att);
                }
                r += (node.children ? '>' : '/>') + this.newline;
                return r;
            } else {
                r = this.space(level) + '<!DOCTYPE ' + node.rootNodeName;
                if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
                r += (node.children ? ' [' : '>') + this.newline;
                return r;
            }
        };
        XMLStringWriter.prototype.closeNode = function(node, level) {
            level || (level = 0);
            switch(false){
                case !(node instanceof XMLElement):
                    return this.space(level) + '</' + node.name + '>' + this.newline;
                case !(node instanceof XMLDocType):
                    return this.space(level) + ']>' + this.newline;
            }
        };
        return XMLStringWriter;
    }(XMLWriterBase);
}).call(module.exports);

});
parcelRegister("bLkj1", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLWriterBase, hasProp = {}.hasOwnProperty;
    module.exports = XMLWriterBase = function() {
        function XMLWriterBase(options) {
            var key, ref, ref1, ref2, ref3, ref4, ref5, ref6, value;
            options || (options = {});
            this.pretty = options.pretty || false;
            this.allowEmpty = (ref = options.allowEmpty) != null ? ref : false;
            if (this.pretty) {
                this.indent = (ref1 = options.indent) != null ? ref1 : '  ';
                this.newline = (ref2 = options.newline) != null ? ref2 : '\n';
                this.offset = (ref3 = options.offset) != null ? ref3 : 0;
                this.dontprettytextnodes = (ref4 = options.dontprettytextnodes) != null ? ref4 : 0;
            } else {
                this.indent = '';
                this.newline = '';
                this.offset = 0;
                this.dontprettytextnodes = 0;
            }
            this.spacebeforeslash = (ref5 = options.spacebeforeslash) != null ? ref5 : '';
            if (this.spacebeforeslash === true) this.spacebeforeslash = ' ';
            this.newlinedefault = this.newline;
            this.prettydefault = this.pretty;
            ref6 = options.writer || {};
            for(key in ref6){
                if (!hasProp.call(ref6, key)) continue;
                value = ref6[key];
                this[key] = value;
            }
        }
        XMLWriterBase.prototype.set = function(options) {
            var key, ref, value;
            options || (options = {});
            if ("pretty" in options) this.pretty = options.pretty;
            if ("allowEmpty" in options) this.allowEmpty = options.allowEmpty;
            if (this.pretty) {
                this.indent = "indent" in options ? options.indent : '  ';
                this.newline = "newline" in options ? options.newline : '\n';
                this.offset = "offset" in options ? options.offset : 0;
                this.dontprettytextnodes = "dontprettytextnodes" in options ? options.dontprettytextnodes : 0;
            } else {
                this.indent = '';
                this.newline = '';
                this.offset = 0;
                this.dontprettytextnodes = 0;
            }
            this.spacebeforeslash = "spacebeforeslash" in options ? options.spacebeforeslash : '';
            if (this.spacebeforeslash === true) this.spacebeforeslash = ' ';
            this.newlinedefault = this.newline;
            this.prettydefault = this.pretty;
            ref = options.writer || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this[key] = value;
            }
            return this;
        };
        XMLWriterBase.prototype.space = function(level) {
            var indent;
            if (this.pretty) {
                indent = (level || 0) + this.offset + 1;
                if (indent > 0) return new Array(indent).join(this.indent);
                else return '';
            } else return '';
        };
        return XMLWriterBase;
    }();
}).call(module.exports);

});



parcelRegister("lTOY3", function(module, exports) {
















// Generated by CoffeeScript 1.12.7
(function() {
    var XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, getValue, isFunction, isObject, isPlainObject, ref, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("bYeh6")), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject, getValue = ref.getValue;
    XMLElement = (parcelRequire("5kEbD"));
    XMLCData = (parcelRequire("73EDm"));
    XMLComment = (parcelRequire("gp1wF"));
    XMLRaw = (parcelRequire("66i9K"));
    XMLText = (parcelRequire("k9JpZ"));
    XMLProcessingInstruction = (parcelRequire("3LBrm"));
    XMLDeclaration = (parcelRequire("9pGkJ"));
    XMLDocType = (parcelRequire("7tjYi"));
    XMLDTDAttList = (parcelRequire("5FtTh"));
    XMLDTDEntity = (parcelRequire("1oLLR"));
    XMLDTDElement = (parcelRequire("heKvN"));
    XMLDTDNotation = (parcelRequire("fvQnb"));
    XMLAttribute = (parcelRequire("kiXJB"));
    XMLStringifier = (parcelRequire("lASXj"));
    XMLStringWriter = (parcelRequire("dqkHE"));
    module.exports = XMLDocumentCB = function() {
        function XMLDocumentCB(options, onData, onEnd) {
            var writerOptions;
            this.name = "?xml";
            options || (options = {});
            if (!options.writer) options.writer = new XMLStringWriter(options);
            else if (isPlainObject(options.writer)) {
                writerOptions = options.writer;
                options.writer = new XMLStringWriter(writerOptions);
            }
            this.options = options;
            this.writer = options.writer;
            this.stringify = new XMLStringifier(options);
            this.onDataCallback = onData || function() {};
            this.onEndCallback = onEnd || function() {};
            this.currentNode = null;
            this.currentLevel = -1;
            this.openTags = {};
            this.documentStarted = false;
            this.documentCompleted = false;
            this.root = null;
        }
        XMLDocumentCB.prototype.node = function(name, attributes, text) {
            var ref1, ref2;
            if (name == null) throw new Error("Missing node name.");
            if (this.root && this.currentLevel === -1) throw new Error("Document can only have one root node. " + this.debugInfo(name));
            this.openCurrent();
            name = getValue(name);
            if (attributes === null && text == null) ref1 = [
                {},
                null
            ], attributes = ref1[0], text = ref1[1];
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref2 = [
                attributes,
                text
            ], text = ref2[0], attributes = ref2[1];
            this.currentNode = new XMLElement(this, name, attributes);
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            if (text != null) this.text(text);
            return this;
        };
        XMLDocumentCB.prototype.element = function(name, attributes, text) {
            if (this.currentNode && this.currentNode instanceof XMLDocType) return this.dtdElement.apply(this, arguments);
            else return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.attribute = function(name, value) {
            var attName, attValue;
            if (!this.currentNode || this.currentNode.children) throw new Error("att() can only be used immediately after an ele() call in callback mode. " + this.debugInfo(name));
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (!this.options.skipNullAttributes || value != null) this.currentNode.attributes[name] = new XMLAttribute(this, name, value);
            }
            return this;
        };
        XMLDocumentCB.prototype.text = function(value) {
            var node;
            this.openCurrent();
            node = new XMLText(this, value);
            this.onData(this.writer.text(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.cdata = function(value) {
            var node;
            this.openCurrent();
            node = new XMLCData(this, value);
            this.onData(this.writer.cdata(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.comment = function(value) {
            var node;
            this.openCurrent();
            node = new XMLComment(this, value);
            this.onData(this.writer.comment(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.raw = function(value) {
            var node;
            this.openCurrent();
            node = new XMLRaw(this, value);
            this.onData(this.writer.raw(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.instruction = function(target, value) {
            var i, insTarget, insValue, len, node;
            this.openCurrent();
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(i = 0, len = target.length; i < len; i++){
                insTarget = target[i];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                node = new XMLProcessingInstruction(this, target, value);
                this.onData(this.writer.processingInstruction(node, this.currentLevel + 1), this.currentLevel + 1);
            }
            return this;
        };
        XMLDocumentCB.prototype.declaration = function(version, encoding, standalone) {
            var node;
            this.openCurrent();
            if (this.documentStarted) throw new Error("declaration() must be the first node.");
            node = new XMLDeclaration(this, version, encoding, standalone);
            this.onData(this.writer.declaration(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.doctype = function(root, pubID, sysID) {
            this.openCurrent();
            if (root == null) throw new Error("Missing root node name.");
            if (this.root) throw new Error("dtd() must come before the root node.");
            this.currentNode = new XMLDocType(this, pubID, sysID);
            this.currentNode.rootNodeName = root;
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            return this;
        };
        XMLDocumentCB.prototype.dtdElement = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDElement(this, name, value);
            this.onData(this.writer.dtdElement(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var node;
            this.openCurrent();
            node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.onData(this.writer.dtdAttList(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.entity = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, false, name, value);
            this.onData(this.writer.dtdEntity(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.pEntity = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, true, name, value);
            this.onData(this.writer.dtdEntity(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.notation = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDNotation(this, name, value);
            this.onData(this.writer.dtdNotation(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.up = function() {
            if (this.currentLevel < 0) throw new Error("The document node has no parent.");
            if (this.currentNode) {
                if (this.currentNode.children) this.closeNode(this.currentNode);
                else this.openNode(this.currentNode);
                this.currentNode = null;
            } else this.closeNode(this.openTags[this.currentLevel]);
            delete this.openTags[this.currentLevel];
            this.currentLevel--;
            return this;
        };
        XMLDocumentCB.prototype.end = function() {
            while(this.currentLevel >= 0)this.up();
            return this.onEnd();
        };
        XMLDocumentCB.prototype.openCurrent = function() {
            if (this.currentNode) {
                this.currentNode.children = true;
                return this.openNode(this.currentNode);
            }
        };
        XMLDocumentCB.prototype.openNode = function(node) {
            if (!node.isOpen) {
                if (!this.root && this.currentLevel === 0 && node instanceof XMLElement) this.root = node;
                this.onData(this.writer.openNode(node, this.currentLevel), this.currentLevel);
                return node.isOpen = true;
            }
        };
        XMLDocumentCB.prototype.closeNode = function(node) {
            if (!node.isClosed) {
                this.onData(this.writer.closeNode(node, this.currentLevel), this.currentLevel);
                return node.isClosed = true;
            }
        };
        XMLDocumentCB.prototype.onData = function(chunk, level) {
            this.documentStarted = true;
            return this.onDataCallback(chunk, level + 1);
        };
        XMLDocumentCB.prototype.onEnd = function() {
            this.documentCompleted = true;
            return this.onEndCallback();
        };
        XMLDocumentCB.prototype.debugInfo = function(name) {
            if (name == null) return "";
            else return "node: <" + name + ">";
        };
        XMLDocumentCB.prototype.ele = function() {
            return this.element.apply(this, arguments);
        };
        XMLDocumentCB.prototype.nod = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.txt = function(value) {
            return this.text(value);
        };
        XMLDocumentCB.prototype.dat = function(value) {
            return this.cdata(value);
        };
        XMLDocumentCB.prototype.com = function(value) {
            return this.comment(value);
        };
        XMLDocumentCB.prototype.ins = function(target, value) {
            return this.instruction(target, value);
        };
        XMLDocumentCB.prototype.dec = function(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        };
        XMLDocumentCB.prototype.dtd = function(root, pubID, sysID) {
            return this.doctype(root, pubID, sysID);
        };
        XMLDocumentCB.prototype.e = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLDocumentCB.prototype.n = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.t = function(value) {
            return this.text(value);
        };
        XMLDocumentCB.prototype.d = function(value) {
            return this.cdata(value);
        };
        XMLDocumentCB.prototype.c = function(value) {
            return this.comment(value);
        };
        XMLDocumentCB.prototype.r = function(value) {
            return this.raw(value);
        };
        XMLDocumentCB.prototype.i = function(target, value) {
            return this.instruction(target, value);
        };
        XMLDocumentCB.prototype.att = function() {
            if (this.currentNode && this.currentNode instanceof XMLDocType) return this.attList.apply(this, arguments);
            else return this.attribute.apply(this, arguments);
        };
        XMLDocumentCB.prototype.a = function() {
            if (this.currentNode && this.currentNode instanceof XMLDocType) return this.attList.apply(this, arguments);
            else return this.attribute.apply(this, arguments);
        };
        XMLDocumentCB.prototype.ent = function(name, value) {
            return this.entity(name, value);
        };
        XMLDocumentCB.prototype.pent = function(name, value) {
            return this.pEntity(name, value);
        };
        XMLDocumentCB.prototype.not = function(name, value) {
            return this.notation(name, value);
        };
        return XMLDocumentCB;
    }();
}).call(module.exports);

});

parcelRegister("444Ot", function(module, exports) {














// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStreamWriter, XMLText, XMLWriterBase, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLDeclaration = (parcelRequire("9pGkJ"));
    XMLDocType = (parcelRequire("7tjYi"));
    XMLCData = (parcelRequire("73EDm"));
    XMLComment = (parcelRequire("gp1wF"));
    XMLElement = (parcelRequire("5kEbD"));
    XMLRaw = (parcelRequire("66i9K"));
    XMLText = (parcelRequire("k9JpZ"));
    XMLProcessingInstruction = (parcelRequire("3LBrm"));
    XMLDummy = (parcelRequire("M2us3"));
    XMLDTDAttList = (parcelRequire("5FtTh"));
    XMLDTDElement = (parcelRequire("heKvN"));
    XMLDTDEntity = (parcelRequire("1oLLR"));
    XMLDTDNotation = (parcelRequire("fvQnb"));
    XMLWriterBase = (parcelRequire("bLkj1"));
    module.exports = XMLStreamWriter = function(superClass) {
        extend(XMLStreamWriter, superClass);
        function XMLStreamWriter(stream, options) {
            XMLStreamWriter.__super__.constructor.call(this, options);
            this.stream = stream;
        }
        XMLStreamWriter.prototype.document = function(doc) {
            var child, i, j, len, len1, ref, ref1, results;
            ref = doc.children;
            for(i = 0, len = ref.length; i < len; i++){
                child = ref[i];
                child.isLastRootNode = false;
            }
            doc.children[doc.children.length - 1].isLastRootNode = true;
            ref1 = doc.children;
            results = [];
            for(j = 0, len1 = ref1.length; j < len1; j++){
                child = ref1[j];
                if (child instanceof XMLDummy) continue;
                switch(false){
                    case !(child instanceof XMLDeclaration):
                        results.push(this.declaration(child));
                        break;
                    case !(child instanceof XMLDocType):
                        results.push(this.docType(child));
                        break;
                    case !(child instanceof XMLComment):
                        results.push(this.comment(child));
                        break;
                    case !(child instanceof XMLProcessingInstruction):
                        results.push(this.processingInstruction(child));
                        break;
                    default:
                        results.push(this.element(child));
                }
            }
            return results;
        };
        XMLStreamWriter.prototype.attribute = function(att) {
            return this.stream.write(' ' + att.name + '="' + att.value + '"');
        };
        XMLStreamWriter.prototype.cdata = function(node, level) {
            return this.stream.write(this.space(level) + '<![CDATA[' + node.text + ']]>' + this.endline(node));
        };
        XMLStreamWriter.prototype.comment = function(node, level) {
            return this.stream.write(this.space(level) + '<!-- ' + node.text + ' -->' + this.endline(node));
        };
        XMLStreamWriter.prototype.declaration = function(node, level) {
            this.stream.write(this.space(level));
            this.stream.write('<?xml version="' + node.version + '"');
            if (node.encoding != null) this.stream.write(' encoding="' + node.encoding + '"');
            if (node.standalone != null) this.stream.write(' standalone="' + node.standalone + '"');
            this.stream.write(this.spacebeforeslash + '?>');
            return this.stream.write(this.endline(node));
        };
        XMLStreamWriter.prototype.docType = function(node, level) {
            var child, i, len, ref;
            level || (level = 0);
            this.stream.write(this.space(level));
            this.stream.write('<!DOCTYPE ' + node.root().name);
            if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
            else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
            if (node.children.length > 0) {
                this.stream.write(' [');
                this.stream.write(this.endline(node));
                ref = node.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    switch(false){
                        case !(child instanceof XMLDTDAttList):
                            this.dtdAttList(child, level + 1);
                            break;
                        case !(child instanceof XMLDTDElement):
                            this.dtdElement(child, level + 1);
                            break;
                        case !(child instanceof XMLDTDEntity):
                            this.dtdEntity(child, level + 1);
                            break;
                        case !(child instanceof XMLDTDNotation):
                            this.dtdNotation(child, level + 1);
                            break;
                        case !(child instanceof XMLCData):
                            this.cdata(child, level + 1);
                            break;
                        case !(child instanceof XMLComment):
                            this.comment(child, level + 1);
                            break;
                        case !(child instanceof XMLProcessingInstruction):
                            this.processingInstruction(child, level + 1);
                            break;
                        default:
                            throw new Error("Unknown DTD node type: " + child.constructor.name);
                    }
                }
                this.stream.write(']');
            }
            this.stream.write(this.spacebeforeslash + '>');
            return this.stream.write(this.endline(node));
        };
        XMLStreamWriter.prototype.element = function(node, level) {
            var att, child, i, len, name, ref, ref1, space;
            level || (level = 0);
            space = this.space(level);
            this.stream.write(space + '<' + node.name);
            ref = node.attributes;
            for(name in ref){
                if (!hasProp.call(ref, name)) continue;
                att = ref[name];
                this.attribute(att);
            }
            if (node.children.length === 0 || node.children.every(function(e) {
                return e.value === '';
            })) {
                if (this.allowEmpty) this.stream.write('></' + node.name + '>');
                else this.stream.write(this.spacebeforeslash + '/>');
            } else if (this.pretty && node.children.length === 1 && node.children[0].value != null) {
                this.stream.write('>');
                this.stream.write(node.children[0].value);
                this.stream.write('</' + node.name + '>');
            } else {
                this.stream.write('>' + this.newline);
                ref1 = node.children;
                for(i = 0, len = ref1.length; i < len; i++){
                    child = ref1[i];
                    switch(false){
                        case !(child instanceof XMLCData):
                            this.cdata(child, level + 1);
                            break;
                        case !(child instanceof XMLComment):
                            this.comment(child, level + 1);
                            break;
                        case !(child instanceof XMLElement):
                            this.element(child, level + 1);
                            break;
                        case !(child instanceof XMLRaw):
                            this.raw(child, level + 1);
                            break;
                        case !(child instanceof XMLText):
                            this.text(child, level + 1);
                            break;
                        case !(child instanceof XMLProcessingInstruction):
                            this.processingInstruction(child, level + 1);
                            break;
                        case !(child instanceof XMLDummy):
                            '';
                            break;
                        default:
                            throw new Error("Unknown XML node type: " + child.constructor.name);
                    }
                }
                this.stream.write(space + '</' + node.name + '>');
            }
            return this.stream.write(this.endline(node));
        };
        XMLStreamWriter.prototype.processingInstruction = function(node, level) {
            this.stream.write(this.space(level) + '<?' + node.target);
            if (node.value) this.stream.write(' ' + node.value);
            return this.stream.write(this.spacebeforeslash + '?>' + this.endline(node));
        };
        XMLStreamWriter.prototype.raw = function(node, level) {
            return this.stream.write(this.space(level) + node.value + this.endline(node));
        };
        XMLStreamWriter.prototype.text = function(node, level) {
            return this.stream.write(this.space(level) + node.value + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdAttList = function(node, level) {
            this.stream.write(this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType);
            if (node.defaultValueType !== '#DEFAULT') this.stream.write(' ' + node.defaultValueType);
            if (node.defaultValue) this.stream.write(' "' + node.defaultValue + '"');
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdElement = function(node, level) {
            this.stream.write(this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value);
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdEntity = function(node, level) {
            this.stream.write(this.space(level) + '<!ENTITY');
            if (node.pe) this.stream.write(' %');
            this.stream.write(' ' + node.name);
            if (node.value) this.stream.write(' "' + node.value + '"');
            else {
                if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
                else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
                if (node.nData) this.stream.write(' NDATA ' + node.nData);
            }
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdNotation = function(node, level) {
            this.stream.write(this.space(level) + '<!NOTATION ' + node.name);
            if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
            else if (node.pubID) this.stream.write(' PUBLIC "' + node.pubID + '"');
            else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.endline = function(node) {
            if (!node.isLastRootNode) return this.newline;
            else return '';
        };
        return XMLStreamWriter;
    }(XMLWriterBase);
}).call(module.exports);

});



parcelRegister("2nE2Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1bbccb41dd858aa1$var$dingbats = [
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "33",
        "Unicode hex": "21"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "8704",
        "Unicode hex": "2200"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "35",
        "Unicode hex": "23"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "8707",
        "Unicode hex": "2203"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "37",
        "Unicode hex": "25"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "38",
        "Unicode hex": "26"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "8717",
        "Unicode hex": "220D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "40",
        "Unicode hex": "28"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "41",
        "Unicode hex": "29"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "42",
        "Unicode hex": "2A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "43",
        "Unicode hex": "2B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "44",
        "Unicode hex": "2C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "8722",
        "Unicode hex": "2212"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "46",
        "Unicode hex": "2E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "47",
        "Unicode hex": "2F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "48",
        "Unicode hex": "30"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "49",
        "Unicode hex": "31"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "50",
        "Unicode hex": "32"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "51",
        "Unicode hex": "33"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "52",
        "Unicode hex": "34"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "53",
        "Unicode hex": "35"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "54",
        "Unicode hex": "36"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "55",
        "Unicode hex": "37"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "56",
        "Unicode hex": "38"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "57",
        "Unicode hex": "39"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "58",
        "Unicode hex": "3A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "59",
        "Unicode hex": "3B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "60",
        "Unicode hex": "3C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "61",
        "Unicode hex": "3D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "62",
        "Unicode hex": "3E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "63",
        "Unicode hex": "3F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "8773",
        "Unicode hex": "2245"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "913",
        "Unicode hex": "391"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "914",
        "Unicode hex": "392"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "935",
        "Unicode hex": "3A7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "916",
        "Unicode hex": "394"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "917",
        "Unicode hex": "395"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "934",
        "Unicode hex": "3A6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "915",
        "Unicode hex": "393"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "919",
        "Unicode hex": "397"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "921",
        "Unicode hex": "399"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "977",
        "Unicode hex": "3D1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "922",
        "Unicode hex": "39A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "923",
        "Unicode hex": "39B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "924",
        "Unicode hex": "39C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "925",
        "Unicode hex": "39D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "927",
        "Unicode hex": "39F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "928",
        "Unicode hex": "3A0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "920",
        "Unicode hex": "398"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "929",
        "Unicode hex": "3A1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "931",
        "Unicode hex": "3A3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "932",
        "Unicode hex": "3A4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "933",
        "Unicode hex": "3A5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "962",
        "Unicode hex": "3C2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "937",
        "Unicode hex": "3A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "926",
        "Unicode hex": "39E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "936",
        "Unicode hex": "3A8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "918",
        "Unicode hex": "396"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "91",
        "Unicode hex": "5B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "8756",
        "Unicode hex": "2234"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "93",
        "Unicode hex": "5D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "8869",
        "Unicode hex": "22A5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "95",
        "Unicode hex": "5F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "8254",
        "Unicode hex": "203E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "945",
        "Unicode hex": "3B1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "946",
        "Unicode hex": "3B2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "967",
        "Unicode hex": "3C7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "948",
        "Unicode hex": "3B4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "949",
        "Unicode hex": "3B5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "966",
        "Unicode hex": "3C6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "947",
        "Unicode hex": "3B3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "951",
        "Unicode hex": "3B7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "953",
        "Unicode hex": "3B9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "981",
        "Unicode hex": "3D5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "954",
        "Unicode hex": "3BA"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "955",
        "Unicode hex": "3BB"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "956",
        "Unicode hex": "3BC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "957",
        "Unicode hex": "3BD"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "959",
        "Unicode hex": "3BF"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "960",
        "Unicode hex": "3C0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "952",
        "Unicode hex": "3B8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "961",
        "Unicode hex": "3C1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "963",
        "Unicode hex": "3C3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "964",
        "Unicode hex": "3C4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "965",
        "Unicode hex": "3C5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "982",
        "Unicode hex": "3D6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "969",
        "Unicode hex": "3C9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "958",
        "Unicode hex": "3BE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "968",
        "Unicode hex": "3C8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "950",
        "Unicode hex": "3B6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "123",
        "Unicode hex": "7B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "124",
        "Unicode hex": "7C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "125",
        "Unicode hex": "7D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "126",
        "Unicode hex": "7E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "8364",
        "Unicode hex": "20AC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "978",
        "Unicode hex": "3D2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "8242",
        "Unicode hex": "2032"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "8804",
        "Unicode hex": "2264"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "8260",
        "Unicode hex": "2044"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "8734",
        "Unicode hex": "221E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "402",
        "Unicode hex": "192"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "9827",
        "Unicode hex": "2663"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "9830",
        "Unicode hex": "2666"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "9829",
        "Unicode hex": "2665"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "9824",
        "Unicode hex": "2660"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "8596",
        "Unicode hex": "2194"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "8592",
        "Unicode hex": "2190"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "8593",
        "Unicode hex": "2191"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "8594",
        "Unicode hex": "2192"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "8595",
        "Unicode hex": "2193"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "176",
        "Unicode hex": "B0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "177",
        "Unicode hex": "B1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "8243",
        "Unicode hex": "2033"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "8805",
        "Unicode hex": "2265"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "215",
        "Unicode hex": "D7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "8733",
        "Unicode hex": "221D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "8706",
        "Unicode hex": "2202"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "8226",
        "Unicode hex": "2022"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "247",
        "Unicode hex": "F7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "8800",
        "Unicode hex": "2260"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "8801",
        "Unicode hex": "2261"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "8776",
        "Unicode hex": "2248"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "8230",
        "Unicode hex": "2026"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "9168",
        "Unicode hex": "23D0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "9135",
        "Unicode hex": "23AF"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "8629",
        "Unicode hex": "21B5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "8501",
        "Unicode hex": "2135"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "8465",
        "Unicode hex": "2111"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "8476",
        "Unicode hex": "211C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "8472",
        "Unicode hex": "2118"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "8855",
        "Unicode hex": "2297"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "8853",
        "Unicode hex": "2295"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "8709",
        "Unicode hex": "2205"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "8745",
        "Unicode hex": "2229"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "8746",
        "Unicode hex": "222A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "8835",
        "Unicode hex": "2283"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "8839",
        "Unicode hex": "2287"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "8836",
        "Unicode hex": "2284"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "8834",
        "Unicode hex": "2282"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "8838",
        "Unicode hex": "2286"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "8712",
        "Unicode hex": "2208"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "8713",
        "Unicode hex": "2209"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "8736",
        "Unicode hex": "2220"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "8711",
        "Unicode hex": "2207"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "174",
        "Unicode hex": "AE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "169",
        "Unicode hex": "A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "8482",
        "Unicode hex": "2122"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "8719",
        "Unicode hex": "220F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "8730",
        "Unicode hex": "221A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "8901",
        "Unicode hex": "22C5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "172",
        "Unicode hex": "AC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "8743",
        "Unicode hex": "2227"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "8744",
        "Unicode hex": "2228"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "8660",
        "Unicode hex": "21D4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "8656",
        "Unicode hex": "21D0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "8657",
        "Unicode hex": "21D1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "8658",
        "Unicode hex": "21D2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "8659",
        "Unicode hex": "21D3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "9674",
        "Unicode hex": "25CA"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "12296",
        "Unicode hex": "3008"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "174",
        "Unicode hex": "AE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "169",
        "Unicode hex": "A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "8482",
        "Unicode hex": "2122"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "8721",
        "Unicode hex": "2211"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "9115",
        "Unicode hex": "239B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "9116",
        "Unicode hex": "239C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "9117",
        "Unicode hex": "239D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "9121",
        "Unicode hex": "23A1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "9122",
        "Unicode hex": "23A2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "9123",
        "Unicode hex": "23A3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "9127",
        "Unicode hex": "23A7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "9128",
        "Unicode hex": "23A8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "9129",
        "Unicode hex": "23A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "9130",
        "Unicode hex": "23AA"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "63743",
        "Unicode hex": "F8FF"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "12297",
        "Unicode hex": "3009"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "8747",
        "Unicode hex": "222B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "8992",
        "Unicode hex": "2320"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "9134",
        "Unicode hex": "23AE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "8993",
        "Unicode hex": "2321"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "9118",
        "Unicode hex": "239E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "9119",
        "Unicode hex": "239F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "9120",
        "Unicode hex": "23A0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "9124",
        "Unicode hex": "23A4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "250",
        "Dingbat hex": "FA",
        "Unicode dec": "9125",
        "Unicode hex": "23A5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "251",
        "Dingbat hex": "FB",
        "Unicode dec": "9126",
        "Unicode hex": "23A6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "252",
        "Dingbat hex": "FC",
        "Unicode dec": "9131",
        "Unicode hex": "23AB"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "253",
        "Dingbat hex": "FD",
        "Unicode dec": "9132",
        "Unicode hex": "23AC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "254",
        "Dingbat hex": "FE",
        "Unicode dec": "9133",
        "Unicode hex": "23AD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "128375",
        "Unicode hex": "1F577"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "128376",
        "Unicode hex": "1F578"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "128370",
        "Unicode hex": "1F572"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "128374",
        "Unicode hex": "1F576"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "127942",
        "Unicode hex": "1F3C6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "127894",
        "Unicode hex": "1F396"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "128391",
        "Unicode hex": "1F587"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "128488",
        "Unicode hex": "1F5E8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "128489",
        "Unicode hex": "1F5E9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "128496",
        "Unicode hex": "1F5F0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "128497",
        "Unicode hex": "1F5F1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "127798",
        "Unicode hex": "1F336"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "127895",
        "Unicode hex": "1F397"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "128638",
        "Unicode hex": "1F67E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "128636",
        "Unicode hex": "1F67C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "128469",
        "Unicode hex": "1F5D5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "128470",
        "Unicode hex": "1F5D6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "128471",
        "Unicode hex": "1F5D7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "9204",
        "Unicode hex": "23F4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "9205",
        "Unicode hex": "23F5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "9206",
        "Unicode hex": "23F6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "9207",
        "Unicode hex": "23F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "9194",
        "Unicode hex": "23EA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "9193",
        "Unicode hex": "23E9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "9198",
        "Unicode hex": "23EE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "9197",
        "Unicode hex": "23ED"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "9208",
        "Unicode hex": "23F8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "9209",
        "Unicode hex": "23F9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "9210",
        "Unicode hex": "23FA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "128474",
        "Unicode hex": "1F5DA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "128499",
        "Unicode hex": "1F5F3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "128736",
        "Unicode hex": "1F6E0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "127959",
        "Unicode hex": "1F3D7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "127960",
        "Unicode hex": "1F3D8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "127961",
        "Unicode hex": "1F3D9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "127962",
        "Unicode hex": "1F3DA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "127964",
        "Unicode hex": "1F3DC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "127981",
        "Unicode hex": "1F3ED"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "127963",
        "Unicode hex": "1F3DB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "127968",
        "Unicode hex": "1F3E0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "127958",
        "Unicode hex": "1F3D6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "127965",
        "Unicode hex": "1F3DD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "128739",
        "Unicode hex": "1F6E3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "128269",
        "Unicode hex": "1F50D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "127956",
        "Unicode hex": "1F3D4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "128065",
        "Unicode hex": "1F441"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "128066",
        "Unicode hex": "1F442"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "127966",
        "Unicode hex": "1F3DE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "127957",
        "Unicode hex": "1F3D5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "128740",
        "Unicode hex": "1F6E4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "127967",
        "Unicode hex": "1F3DF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "128755",
        "Unicode hex": "1F6F3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "128364",
        "Unicode hex": "1F56C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "128363",
        "Unicode hex": "1F56B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "128360",
        "Unicode hex": "1F568"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "128264",
        "Unicode hex": "1F508"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "127892",
        "Unicode hex": "1F394"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "127893",
        "Unicode hex": "1F395"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "128492",
        "Unicode hex": "1F5EC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "128637",
        "Unicode hex": "1F67D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "128493",
        "Unicode hex": "1F5ED"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "128490",
        "Unicode hex": "1F5EA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "128491",
        "Unicode hex": "1F5EB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "11156",
        "Unicode hex": "2B94"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "10004",
        "Unicode hex": "2714"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "128690",
        "Unicode hex": "1F6B2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "11036",
        "Unicode hex": "2B1C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "128737",
        "Unicode hex": "1F6E1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "128230",
        "Unicode hex": "1F4E6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "128753",
        "Unicode hex": "1F6F1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "11035",
        "Unicode hex": "2B1B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "128657",
        "Unicode hex": "1F691"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "128712",
        "Unicode hex": "1F6C8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "128745",
        "Unicode hex": "1F6E9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "128752",
        "Unicode hex": "1F6F0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "128968",
        "Unicode hex": "1F7C8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "128372",
        "Unicode hex": "1F574"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "11044",
        "Unicode hex": "2B24"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "128741",
        "Unicode hex": "1F6E5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "128660",
        "Unicode hex": "1F694"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "128472",
        "Unicode hex": "1F5D8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "128473",
        "Unicode hex": "1F5D9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "10067",
        "Unicode hex": "2753"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "128754",
        "Unicode hex": "1F6F2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "128647",
        "Unicode hex": "1F687"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "128653",
        "Unicode hex": "1F68D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "9971",
        "Unicode hex": "26F3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "10680",
        "Unicode hex": "29B8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "8854",
        "Unicode hex": "2296"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "128685",
        "Unicode hex": "1F6AD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "128494",
        "Unicode hex": "1F5EE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "9168",
        "Unicode hex": "23D0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "128495",
        "Unicode hex": "1F5EF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "128498",
        "Unicode hex": "1F5F2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "128697",
        "Unicode hex": "1F6B9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "128698",
        "Unicode hex": "1F6BA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "128713",
        "Unicode hex": "1F6C9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "128714",
        "Unicode hex": "1F6CA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "128700",
        "Unicode hex": "1F6BC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "128125",
        "Unicode hex": "1F47D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "127947",
        "Unicode hex": "1F3CB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "9975",
        "Unicode hex": "26F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "127938",
        "Unicode hex": "1F3C2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "127948",
        "Unicode hex": "1F3CC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "127946",
        "Unicode hex": "1F3CA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "127940",
        "Unicode hex": "1F3C4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "127949",
        "Unicode hex": "1F3CD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "127950",
        "Unicode hex": "1F3CE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "128664",
        "Unicode hex": "1F698"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "128480",
        "Unicode hex": "1F5E0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "128738",
        "Unicode hex": "1F6E2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "128176",
        "Unicode hex": "1F4B0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "127991",
        "Unicode hex": "1F3F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "128179",
        "Unicode hex": "1F4B3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "128106",
        "Unicode hex": "1F46A"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "128481",
        "Unicode hex": "1F5E1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "128482",
        "Unicode hex": "1F5E2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "128483",
        "Unicode hex": "1F5E3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "10031",
        "Unicode hex": "272F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "128388",
        "Unicode hex": "1F584"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "128389",
        "Unicode hex": "1F585"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "128387",
        "Unicode hex": "1F583"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "128390",
        "Unicode hex": "1F586"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "128441",
        "Unicode hex": "1F5B9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "128442",
        "Unicode hex": "1F5BA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "128443",
        "Unicode hex": "1F5BB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "128373",
        "Unicode hex": "1F575"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "128368",
        "Unicode hex": "1F570"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "128445",
        "Unicode hex": "1F5BD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "128446",
        "Unicode hex": "1F5BE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "128203",
        "Unicode hex": "1F4CB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "128466",
        "Unicode hex": "1F5D2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "128467",
        "Unicode hex": "1F5D3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "128366",
        "Unicode hex": "1F56E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "128218",
        "Unicode hex": "1F4DA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "128478",
        "Unicode hex": "1F5DE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "128479",
        "Unicode hex": "1F5DF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "128451",
        "Unicode hex": "1F5C3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "128450",
        "Unicode hex": "1F5C2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "128444",
        "Unicode hex": "1F5BC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "127917",
        "Unicode hex": "1F3AD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "127900",
        "Unicode hex": "1F39C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "127896",
        "Unicode hex": "1F398"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "127897",
        "Unicode hex": "1F399"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "127911",
        "Unicode hex": "1F3A7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "128191",
        "Unicode hex": "1F4BF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "127902",
        "Unicode hex": "1F39E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "128247",
        "Unicode hex": "1F4F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "127903",
        "Unicode hex": "1F39F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "127916",
        "Unicode hex": "1F3AC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "128253",
        "Unicode hex": "1F4FD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "128249",
        "Unicode hex": "1F4F9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "128254",
        "Unicode hex": "1F4FE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "128251",
        "Unicode hex": "1F4FB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "127898",
        "Unicode hex": "1F39A"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "127899",
        "Unicode hex": "1F39B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "128250",
        "Unicode hex": "1F4FA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "128187",
        "Unicode hex": "1F4BB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "128421",
        "Unicode hex": "1F5A5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "128422",
        "Unicode hex": "1F5A6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "128423",
        "Unicode hex": "1F5A7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "128377",
        "Unicode hex": "1F579"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "127918",
        "Unicode hex": "1F3AE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "128379",
        "Unicode hex": "1F57B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "128380",
        "Unicode hex": "1F57C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "128223",
        "Unicode hex": "1F4DF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "128385",
        "Unicode hex": "1F581"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "128384",
        "Unicode hex": "1F580"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "128424",
        "Unicode hex": "1F5A8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "128425",
        "Unicode hex": "1F5A9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "128447",
        "Unicode hex": "1F5BF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "128426",
        "Unicode hex": "1F5AA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "128476",
        "Unicode hex": "1F5DC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "128274",
        "Unicode hex": "1F512"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "128275",
        "Unicode hex": "1F513"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "128477",
        "Unicode hex": "1F5DD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "128229",
        "Unicode hex": "1F4E5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "128228",
        "Unicode hex": "1F4E4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "128371",
        "Unicode hex": "1F573"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "127779",
        "Unicode hex": "1F323"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "127780",
        "Unicode hex": "1F324"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "127781",
        "Unicode hex": "1F325"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "127782",
        "Unicode hex": "1F326"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "9729",
        "Unicode hex": "2601"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "127784",
        "Unicode hex": "1F328"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "127783",
        "Unicode hex": "1F327"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "127785",
        "Unicode hex": "1F329"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "127786",
        "Unicode hex": "1F32A"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "127788",
        "Unicode hex": "1F32C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "127787",
        "Unicode hex": "1F32B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "127772",
        "Unicode hex": "1F31C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "127777",
        "Unicode hex": "1F321"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "128715",
        "Unicode hex": "1F6CB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "128719",
        "Unicode hex": "1F6CF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "127869",
        "Unicode hex": "1F37D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "127864",
        "Unicode hex": "1F378"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "128718",
        "Unicode hex": "1F6CE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "128717",
        "Unicode hex": "1F6CD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "9413",
        "Unicode hex": "24C5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "9855",
        "Unicode hex": "267F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "128710",
        "Unicode hex": "1F6C6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "128392",
        "Unicode hex": "1F588"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "127891",
        "Unicode hex": "1F393"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "128484",
        "Unicode hex": "1F5E4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "128485",
        "Unicode hex": "1F5E5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "128486",
        "Unicode hex": "1F5E6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "128487",
        "Unicode hex": "1F5E7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "128746",
        "Unicode hex": "1F6EA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "128063",
        "Unicode hex": "1F43F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "128038",
        "Unicode hex": "1F426"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "128031",
        "Unicode hex": "1F41F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "128021",
        "Unicode hex": "1F415"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "128008",
        "Unicode hex": "1F408"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "128620",
        "Unicode hex": "1F66C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "128622",
        "Unicode hex": "1F66E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "128621",
        "Unicode hex": "1F66D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "250",
        "Dingbat hex": "FA",
        "Unicode dec": "128623",
        "Unicode hex": "1F66F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "251",
        "Dingbat hex": "FB",
        "Unicode dec": "128506",
        "Unicode hex": "1F5FA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "252",
        "Dingbat hex": "FC",
        "Unicode dec": "127757",
        "Unicode hex": "1F30D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "253",
        "Dingbat hex": "FD",
        "Unicode dec": "127759",
        "Unicode hex": "1F30F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "254",
        "Dingbat hex": "FE",
        "Unicode dec": "127758",
        "Unicode hex": "1F30E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "255",
        "Dingbat hex": "FF",
        "Unicode dec": "128330",
        "Unicode hex": "1F54A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "128393",
        "Unicode hex": "1F589"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "9986",
        "Unicode hex": "2702"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "9985",
        "Unicode hex": "2701"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "128083",
        "Unicode hex": "1F453"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "128365",
        "Unicode hex": "1F56D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "128366",
        "Unicode hex": "1F56E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "128367",
        "Unicode hex": "1F56F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "128383",
        "Unicode hex": "1F57F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "9990",
        "Unicode hex": "2706"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "128386",
        "Unicode hex": "1F582"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "128387",
        "Unicode hex": "1F583"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "128234",
        "Unicode hex": "1F4EA"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "128235",
        "Unicode hex": "1F4EB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "128236",
        "Unicode hex": "1F4EC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "128237",
        "Unicode hex": "1F4ED"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "128448",
        "Unicode hex": "1F5C0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "128449",
        "Unicode hex": "1F5C1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "128462",
        "Unicode hex": "1F5CE"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "128463",
        "Unicode hex": "1F5CF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "128464",
        "Unicode hex": "1F5D0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "128452",
        "Unicode hex": "1F5C4"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "8987",
        "Unicode hex": "231B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "128430",
        "Unicode hex": "1F5AE"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "128432",
        "Unicode hex": "1F5B0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "128434",
        "Unicode hex": "1F5B2"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "128435",
        "Unicode hex": "1F5B3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "128436",
        "Unicode hex": "1F5B4"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "128427",
        "Unicode hex": "1F5AB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "128428",
        "Unicode hex": "1F5AC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "9991",
        "Unicode hex": "2707"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "9997",
        "Unicode hex": "270D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "128398",
        "Unicode hex": "1F58E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "9996",
        "Unicode hex": "270C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "128399",
        "Unicode hex": "1F58F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "128077",
        "Unicode hex": "1F44D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "128078",
        "Unicode hex": "1F44E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "9756",
        "Unicode hex": "261C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "9758",
        "Unicode hex": "261E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "9757",
        "Unicode hex": "261D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "9759",
        "Unicode hex": "261F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "128400",
        "Unicode hex": "1F590"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "9786",
        "Unicode hex": "263A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "128528",
        "Unicode hex": "1F610"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "9785",
        "Unicode hex": "2639"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "128163",
        "Unicode hex": "1F4A3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "128369",
        "Unicode hex": "1F571"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "127987",
        "Unicode hex": "1F3F3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "127985",
        "Unicode hex": "1F3F1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "9992",
        "Unicode hex": "2708"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "9788",
        "Unicode hex": "263C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "127778",
        "Unicode hex": "1F322"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "10052",
        "Unicode hex": "2744"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "128326",
        "Unicode hex": "1F546"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "10014",
        "Unicode hex": "271E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "128328",
        "Unicode hex": "1F548"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "10016",
        "Unicode hex": "2720"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "10017",
        "Unicode hex": "2721"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "9770",
        "Unicode hex": "262A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "9775",
        "Unicode hex": "262F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "128329",
        "Unicode hex": "1F549"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "9784",
        "Unicode hex": "2638"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "9800",
        "Unicode hex": "2648"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "9801",
        "Unicode hex": "2649"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "9802",
        "Unicode hex": "264A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "9803",
        "Unicode hex": "264B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "9804",
        "Unicode hex": "264C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "9805",
        "Unicode hex": "264D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "9806",
        "Unicode hex": "264E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "9807",
        "Unicode hex": "264F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "9808",
        "Unicode hex": "2650"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "9809",
        "Unicode hex": "2651"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "9810",
        "Unicode hex": "2652"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "9811",
        "Unicode hex": "2653"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "128624",
        "Unicode hex": "1F670"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "128629",
        "Unicode hex": "1F675"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "9899",
        "Unicode hex": "26AB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "128318",
        "Unicode hex": "1F53E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "9724",
        "Unicode hex": "25FC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "128911",
        "Unicode hex": "1F78F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "128912",
        "Unicode hex": "1F790"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "10065",
        "Unicode hex": "2751"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "10066",
        "Unicode hex": "2752"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "128927",
        "Unicode hex": "1F79F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "10731",
        "Unicode hex": "29EB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "9670",
        "Unicode hex": "25C6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "10070",
        "Unicode hex": "2756"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "11049",
        "Unicode hex": "2B29"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "8999",
        "Unicode hex": "2327"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "11193",
        "Unicode hex": "2BB9"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "8984",
        "Unicode hex": "2318"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "127989",
        "Unicode hex": "1F3F5"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "127990",
        "Unicode hex": "1F3F6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "128630",
        "Unicode hex": "1F676"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "128631",
        "Unicode hex": "1F677"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "127",
        "Dingbat hex": "7F",
        "Unicode dec": "9647",
        "Unicode hex": "25AF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "127243",
        "Unicode hex": "1F10B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "10112",
        "Unicode hex": "2780"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "10113",
        "Unicode hex": "2781"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "10114",
        "Unicode hex": "2782"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "10115",
        "Unicode hex": "2783"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "10116",
        "Unicode hex": "2784"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "10117",
        "Unicode hex": "2785"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "10118",
        "Unicode hex": "2786"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "10119",
        "Unicode hex": "2787"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "10120",
        "Unicode hex": "2788"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "10121",
        "Unicode hex": "2789"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "127244",
        "Unicode hex": "1F10C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "10122",
        "Unicode hex": "278A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "10123",
        "Unicode hex": "278B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "10124",
        "Unicode hex": "278C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "10125",
        "Unicode hex": "278D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "10126",
        "Unicode hex": "278E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "10127",
        "Unicode hex": "278F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "10128",
        "Unicode hex": "2790"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "10129",
        "Unicode hex": "2791"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "10130",
        "Unicode hex": "2792"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "10131",
        "Unicode hex": "2793"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "128610",
        "Unicode hex": "1F662"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "128608",
        "Unicode hex": "1F660"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "128609",
        "Unicode hex": "1F661"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "128611",
        "Unicode hex": "1F663"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "128606",
        "Unicode hex": "1F65E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "128604",
        "Unicode hex": "1F65C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "128605",
        "Unicode hex": "1F65D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "128607",
        "Unicode hex": "1F65F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "8729",
        "Unicode hex": "2219"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "8226",
        "Unicode hex": "2022"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "11037",
        "Unicode hex": "2B1D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "11096",
        "Unicode hex": "2B58"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "128902",
        "Unicode hex": "1F786"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "128904",
        "Unicode hex": "1F788"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "128906",
        "Unicode hex": "1F78A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "128907",
        "Unicode hex": "1F78B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "128319",
        "Unicode hex": "1F53F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "9642",
        "Unicode hex": "25AA"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "128910",
        "Unicode hex": "1F78E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "128961",
        "Unicode hex": "1F7C1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "128965",
        "Unicode hex": "1F7C5"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "9733",
        "Unicode hex": "2605"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "128971",
        "Unicode hex": "1F7CB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "128975",
        "Unicode hex": "1F7CF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "128979",
        "Unicode hex": "1F7D3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "128977",
        "Unicode hex": "1F7D1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "11216",
        "Unicode hex": "2BD0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "8982",
        "Unicode hex": "2316"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "11214",
        "Unicode hex": "2BCE"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "11215",
        "Unicode hex": "2BCF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "11217",
        "Unicode hex": "2BD1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "10026",
        "Unicode hex": "272A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "10032",
        "Unicode hex": "2730"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "128336",
        "Unicode hex": "1F550"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "128337",
        "Unicode hex": "1F551"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "128338",
        "Unicode hex": "1F552"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "128339",
        "Unicode hex": "1F553"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "128340",
        "Unicode hex": "1F554"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "128341",
        "Unicode hex": "1F555"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "128342",
        "Unicode hex": "1F556"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "128343",
        "Unicode hex": "1F557"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "128344",
        "Unicode hex": "1F558"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "128345",
        "Unicode hex": "1F559"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "128346",
        "Unicode hex": "1F55A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "128347",
        "Unicode hex": "1F55B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "11184",
        "Unicode hex": "2BB0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "11185",
        "Unicode hex": "2BB1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "11186",
        "Unicode hex": "2BB2"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "11187",
        "Unicode hex": "2BB3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "11188",
        "Unicode hex": "2BB4"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "11189",
        "Unicode hex": "2BB5"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "11190",
        "Unicode hex": "2BB6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "11191",
        "Unicode hex": "2BB7"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "128618",
        "Unicode hex": "1F66A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "128619",
        "Unicode hex": "1F66B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "128597",
        "Unicode hex": "1F655"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "128596",
        "Unicode hex": "1F654"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "128599",
        "Unicode hex": "1F657"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "128598",
        "Unicode hex": "1F656"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "128592",
        "Unicode hex": "1F650"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "128593",
        "Unicode hex": "1F651"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "128594",
        "Unicode hex": "1F652"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "128595",
        "Unicode hex": "1F653"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "9003",
        "Unicode hex": "232B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "8998",
        "Unicode hex": "2326"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "11160",
        "Unicode hex": "2B98"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "11162",
        "Unicode hex": "2B9A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "11161",
        "Unicode hex": "2B99"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "11163",
        "Unicode hex": "2B9B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "11144",
        "Unicode hex": "2B88"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "11146",
        "Unicode hex": "2B8A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "11145",
        "Unicode hex": "2B89"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "11147",
        "Unicode hex": "2B8B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "129128",
        "Unicode hex": "1F868"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "129130",
        "Unicode hex": "1F86A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "129129",
        "Unicode hex": "1F869"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "129131",
        "Unicode hex": "1F86B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "129132",
        "Unicode hex": "1F86C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "129133",
        "Unicode hex": "1F86D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "129135",
        "Unicode hex": "1F86F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "129134",
        "Unicode hex": "1F86E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "129144",
        "Unicode hex": "1F878"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "129146",
        "Unicode hex": "1F87A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "129145",
        "Unicode hex": "1F879"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "129147",
        "Unicode hex": "1F87B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "129148",
        "Unicode hex": "1F87C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "129149",
        "Unicode hex": "1F87D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "129151",
        "Unicode hex": "1F87F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "129150",
        "Unicode hex": "1F87E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "8678",
        "Unicode hex": "21E6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "8680",
        "Unicode hex": "21E8"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "8679",
        "Unicode hex": "21E7"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "8681",
        "Unicode hex": "21E9"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "11012",
        "Unicode hex": "2B04"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "8691",
        "Unicode hex": "21F3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "11009",
        "Unicode hex": "2B01"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "11008",
        "Unicode hex": "2B00"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "11011",
        "Unicode hex": "2B03"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "11010",
        "Unicode hex": "2B02"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "129196",
        "Unicode hex": "1F8AC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "250",
        "Dingbat hex": "FA",
        "Unicode dec": "129197",
        "Unicode hex": "1F8AD"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "251",
        "Dingbat hex": "FB",
        "Unicode dec": "128502",
        "Unicode hex": "1F5F6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "252",
        "Dingbat hex": "FC",
        "Unicode dec": "10003",
        "Unicode hex": "2713"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "253",
        "Dingbat hex": "FD",
        "Unicode dec": "128503",
        "Unicode hex": "1F5F7"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "254",
        "Dingbat hex": "FE",
        "Unicode dec": "128505",
        "Unicode hex": "1F5F9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "128394",
        "Unicode hex": "1F58A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "128395",
        "Unicode hex": "1F58B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "128396",
        "Unicode hex": "1F58C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "128397",
        "Unicode hex": "1F58D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "9988",
        "Unicode hex": "2704"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "9984",
        "Unicode hex": "2700"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "128382",
        "Unicode hex": "1F57E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "128381",
        "Unicode hex": "1F57D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "128453",
        "Unicode hex": "1F5C5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "128454",
        "Unicode hex": "1F5C6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "128455",
        "Unicode hex": "1F5C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "128456",
        "Unicode hex": "1F5C8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "128457",
        "Unicode hex": "1F5C9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "128458",
        "Unicode hex": "1F5CA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "128459",
        "Unicode hex": "1F5CB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "128460",
        "Unicode hex": "1F5CC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "128461",
        "Unicode hex": "1F5CD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "128203",
        "Unicode hex": "1F4CB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "128465",
        "Unicode hex": "1F5D1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "128468",
        "Unicode hex": "1F5D4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "128437",
        "Unicode hex": "1F5B5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "128438",
        "Unicode hex": "1F5B6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "128439",
        "Unicode hex": "1F5B7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "128440",
        "Unicode hex": "1F5B8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "128429",
        "Unicode hex": "1F5AD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "128431",
        "Unicode hex": "1F5AF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "128433",
        "Unicode hex": "1F5B1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "128402",
        "Unicode hex": "1F592"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "128403",
        "Unicode hex": "1F593"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "128408",
        "Unicode hex": "1F598"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "128409",
        "Unicode hex": "1F599"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "128410",
        "Unicode hex": "1F59A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "128411",
        "Unicode hex": "1F59B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "128072",
        "Unicode hex": "1F448"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "128073",
        "Unicode hex": "1F449"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "128412",
        "Unicode hex": "1F59C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "128413",
        "Unicode hex": "1F59D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "128414",
        "Unicode hex": "1F59E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "128415",
        "Unicode hex": "1F59F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "128416",
        "Unicode hex": "1F5A0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "128417",
        "Unicode hex": "1F5A1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "128070",
        "Unicode hex": "1F446"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "128071",
        "Unicode hex": "1F447"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "128418",
        "Unicode hex": "1F5A2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "128419",
        "Unicode hex": "1F5A3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "128401",
        "Unicode hex": "1F591"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "128500",
        "Unicode hex": "1F5F4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "128504",
        "Unicode hex": "1F5F8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "128501",
        "Unicode hex": "1F5F5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "9745",
        "Unicode hex": "2611"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "11197",
        "Unicode hex": "2BBD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "9746",
        "Unicode hex": "2612"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "11198",
        "Unicode hex": "2BBE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "11199",
        "Unicode hex": "2BBF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "128711",
        "Unicode hex": "1F6C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "10680",
        "Unicode hex": "29B8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "128625",
        "Unicode hex": "1F671"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "128628",
        "Unicode hex": "1F674"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "128626",
        "Unicode hex": "1F672"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "128627",
        "Unicode hex": "1F673"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "8253",
        "Unicode hex": "203D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "128633",
        "Unicode hex": "1F679"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "128634",
        "Unicode hex": "1F67A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "128635",
        "Unicode hex": "1F67B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "128614",
        "Unicode hex": "1F666"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "128612",
        "Unicode hex": "1F664"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "128613",
        "Unicode hex": "1F665"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "128615",
        "Unicode hex": "1F667"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "128602",
        "Unicode hex": "1F65A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "128600",
        "Unicode hex": "1F658"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "128601",
        "Unicode hex": "1F659"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "128603",
        "Unicode hex": "1F65B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "9450",
        "Unicode hex": "24EA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "9312",
        "Unicode hex": "2460"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "9313",
        "Unicode hex": "2461"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "9314",
        "Unicode hex": "2462"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "9315",
        "Unicode hex": "2463"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "9316",
        "Unicode hex": "2464"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "9317",
        "Unicode hex": "2465"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "9318",
        "Unicode hex": "2466"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "9319",
        "Unicode hex": "2467"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "9320",
        "Unicode hex": "2468"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "9321",
        "Unicode hex": "2469"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "9471",
        "Unicode hex": "24FF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "10102",
        "Unicode hex": "2776"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "10103",
        "Unicode hex": "2777"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "10104",
        "Unicode hex": "2778"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "10105",
        "Unicode hex": "2779"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "10106",
        "Unicode hex": "277A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "10107",
        "Unicode hex": "277B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "10108",
        "Unicode hex": "277C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "10109",
        "Unicode hex": "277D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "10110",
        "Unicode hex": "277E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "10111",
        "Unicode hex": "277F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "9737",
        "Unicode hex": "2609"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "127765",
        "Unicode hex": "1F315"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "9789",
        "Unicode hex": "263D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "9790",
        "Unicode hex": "263E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "11839",
        "Unicode hex": "2E3F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "10013",
        "Unicode hex": "271D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "128327",
        "Unicode hex": "1F547"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "128348",
        "Unicode hex": "1F55C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "128349",
        "Unicode hex": "1F55D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "128350",
        "Unicode hex": "1F55E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "128351",
        "Unicode hex": "1F55F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "128352",
        "Unicode hex": "1F560"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "128353",
        "Unicode hex": "1F561"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "128354",
        "Unicode hex": "1F562"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "128355",
        "Unicode hex": "1F563"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "128356",
        "Unicode hex": "1F564"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "128357",
        "Unicode hex": "1F565"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "128358",
        "Unicode hex": "1F566"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "128359",
        "Unicode hex": "1F567"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "128616",
        "Unicode hex": "1F668"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "128617",
        "Unicode hex": "1F669"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "8901",
        "Unicode hex": "22C5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "128900",
        "Unicode hex": "1F784"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "10625",
        "Unicode hex": "2981"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "9679",
        "Unicode hex": "25CF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "9675",
        "Unicode hex": "25CB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "128901",
        "Unicode hex": "1F785"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "128903",
        "Unicode hex": "1F787"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "128905",
        "Unicode hex": "1F789"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "8857",
        "Unicode hex": "2299"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "10687",
        "Unicode hex": "29BF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "128908",
        "Unicode hex": "1F78C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "128909",
        "Unicode hex": "1F78D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "9726",
        "Unicode hex": "25FE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "9632",
        "Unicode hex": "25A0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "9633",
        "Unicode hex": "25A1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "128913",
        "Unicode hex": "1F791"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "128914",
        "Unicode hex": "1F792"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "128915",
        "Unicode hex": "1F793"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "128916",
        "Unicode hex": "1F794"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "9635",
        "Unicode hex": "25A3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "128917",
        "Unicode hex": "1F795"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "128918",
        "Unicode hex": "1F796"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "128919",
        "Unicode hex": "1F797"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "128920",
        "Unicode hex": "1F798"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "11049",
        "Unicode hex": "2B29"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "11045",
        "Unicode hex": "2B25"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "9671",
        "Unicode hex": "25C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "128922",
        "Unicode hex": "1F79A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "9672",
        "Unicode hex": "25C8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "128923",
        "Unicode hex": "1F79B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "128924",
        "Unicode hex": "1F79C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "128925",
        "Unicode hex": "1F79D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "128926",
        "Unicode hex": "1F79E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "11050",
        "Unicode hex": "2B2A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "11047",
        "Unicode hex": "2B27"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "9674",
        "Unicode hex": "25CA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "128928",
        "Unicode hex": "1F7A0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "9686",
        "Unicode hex": "25D6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "9687",
        "Unicode hex": "25D7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "11210",
        "Unicode hex": "2BCA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "11211",
        "Unicode hex": "2BCB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "11200",
        "Unicode hex": "2BC0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "11201",
        "Unicode hex": "2BC1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "11039",
        "Unicode hex": "2B1F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "11202",
        "Unicode hex": "2BC2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "11043",
        "Unicode hex": "2B23"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "11042",
        "Unicode hex": "2B22"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "11203",
        "Unicode hex": "2BC3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "11204",
        "Unicode hex": "2BC4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "128929",
        "Unicode hex": "1F7A1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "128930",
        "Unicode hex": "1F7A2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "128931",
        "Unicode hex": "1F7A3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "128932",
        "Unicode hex": "1F7A4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "128933",
        "Unicode hex": "1F7A5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "128934",
        "Unicode hex": "1F7A6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "128935",
        "Unicode hex": "1F7A7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "128936",
        "Unicode hex": "1F7A8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "128937",
        "Unicode hex": "1F7A9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "128938",
        "Unicode hex": "1F7AA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "128939",
        "Unicode hex": "1F7AB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "128940",
        "Unicode hex": "1F7AC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "128941",
        "Unicode hex": "1F7AD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "128942",
        "Unicode hex": "1F7AE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "128943",
        "Unicode hex": "1F7AF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "128944",
        "Unicode hex": "1F7B0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "128945",
        "Unicode hex": "1F7B1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "128946",
        "Unicode hex": "1F7B2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "128947",
        "Unicode hex": "1F7B3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "128948",
        "Unicode hex": "1F7B4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "128949",
        "Unicode hex": "1F7B5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "128950",
        "Unicode hex": "1F7B6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "128951",
        "Unicode hex": "1F7B7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "128952",
        "Unicode hex": "1F7B8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "128953",
        "Unicode hex": "1F7B9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "128954",
        "Unicode hex": "1F7BA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "128955",
        "Unicode hex": "1F7BB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "128956",
        "Unicode hex": "1F7BC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "128957",
        "Unicode hex": "1F7BD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "128958",
        "Unicode hex": "1F7BE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "128959",
        "Unicode hex": "1F7BF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "128960",
        "Unicode hex": "1F7C0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "128962",
        "Unicode hex": "1F7C2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "128964",
        "Unicode hex": "1F7C4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "128966",
        "Unicode hex": "1F7C6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "128969",
        "Unicode hex": "1F7C9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "128970",
        "Unicode hex": "1F7CA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "10038",
        "Unicode hex": "2736"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "128972",
        "Unicode hex": "1F7CC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "128974",
        "Unicode hex": "1F7CE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "128976",
        "Unicode hex": "1F7D0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "128978",
        "Unicode hex": "1F7D2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "10041",
        "Unicode hex": "2739"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "128963",
        "Unicode hex": "1F7C3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "128967",
        "Unicode hex": "1F7C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "10031",
        "Unicode hex": "272F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "128973",
        "Unicode hex": "1F7CD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "128980",
        "Unicode hex": "1F7D4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "11212",
        "Unicode hex": "2BCC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "11213",
        "Unicode hex": "2BCD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "8251",
        "Unicode hex": "203B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "8258",
        "Unicode hex": "2042"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "11104",
        "Unicode hex": "2B60"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "11106",
        "Unicode hex": "2B62"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "11105",
        "Unicode hex": "2B61"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "11107",
        "Unicode hex": "2B63"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "11110",
        "Unicode hex": "2B66"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "11111",
        "Unicode hex": "2B67"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "11113",
        "Unicode hex": "2B69"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "11112",
        "Unicode hex": "2B68"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "11120",
        "Unicode hex": "2B70"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "11122",
        "Unicode hex": "2B72"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "11121",
        "Unicode hex": "2B71"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "11123",
        "Unicode hex": "2B73"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "11126",
        "Unicode hex": "2B76"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "11128",
        "Unicode hex": "2B78"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "11131",
        "Unicode hex": "2B7B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "11133",
        "Unicode hex": "2B7D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "11108",
        "Unicode hex": "2B64"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "11109",
        "Unicode hex": "2B65"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "11114",
        "Unicode hex": "2B6A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "11116",
        "Unicode hex": "2B6C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "11115",
        "Unicode hex": "2B6B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "11117",
        "Unicode hex": "2B6D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "11085",
        "Unicode hex": "2B4D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "11168",
        "Unicode hex": "2BA0"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "11169",
        "Unicode hex": "2BA1"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "11170",
        "Unicode hex": "2BA2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "11171",
        "Unicode hex": "2BA3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "11172",
        "Unicode hex": "2BA4"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "11173",
        "Unicode hex": "2BA5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "11174",
        "Unicode hex": "2BA6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "11175",
        "Unicode hex": "2BA7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "11152",
        "Unicode hex": "2B90"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "11153",
        "Unicode hex": "2B91"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "11154",
        "Unicode hex": "2B92"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "11155",
        "Unicode hex": "2B93"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "11136",
        "Unicode hex": "2B80"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "11139",
        "Unicode hex": "2B83"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "11134",
        "Unicode hex": "2B7E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "11135",
        "Unicode hex": "2B7F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "11140",
        "Unicode hex": "2B84"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "11142",
        "Unicode hex": "2B86"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "11141",
        "Unicode hex": "2B85"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "11143",
        "Unicode hex": "2B87"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "11151",
        "Unicode hex": "2B8F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "11149",
        "Unicode hex": "2B8D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "11150",
        "Unicode hex": "2B8E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "11148",
        "Unicode hex": "2B8C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "11118",
        "Unicode hex": "2B6E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "11119",
        "Unicode hex": "2B6F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "9099",
        "Unicode hex": "238B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "8996",
        "Unicode hex": "2324"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "8963",
        "Unicode hex": "2303"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "8997",
        "Unicode hex": "2325"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "9251",
        "Unicode hex": "2423"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "9085",
        "Unicode hex": "237D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "8682",
        "Unicode hex": "21EA"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "11192",
        "Unicode hex": "2BB8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "129184",
        "Unicode hex": "1F8A0"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "129185",
        "Unicode hex": "1F8A1"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "129186",
        "Unicode hex": "1F8A2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "129187",
        "Unicode hex": "1F8A3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "129188",
        "Unicode hex": "1F8A4"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "129189",
        "Unicode hex": "1F8A5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "129190",
        "Unicode hex": "1F8A6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "129191",
        "Unicode hex": "1F8A7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "129192",
        "Unicode hex": "1F8A8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "129193",
        "Unicode hex": "1F8A9"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "129194",
        "Unicode hex": "1F8AA"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "129195",
        "Unicode hex": "1F8AB"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "129104",
        "Unicode hex": "1F850"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "129106",
        "Unicode hex": "1F852"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "129105",
        "Unicode hex": "1F851"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "129107",
        "Unicode hex": "1F853"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "129108",
        "Unicode hex": "1F854"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "129109",
        "Unicode hex": "1F855"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "129111",
        "Unicode hex": "1F857"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "129110",
        "Unicode hex": "1F856"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "129112",
        "Unicode hex": "1F858"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "129113",
        "Unicode hex": "1F859"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "9650",
        "Unicode hex": "25B2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "9660",
        "Unicode hex": "25BC"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "9651",
        "Unicode hex": "25B3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "9661",
        "Unicode hex": "25BD"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "9664",
        "Unicode hex": "25C0"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "9654",
        "Unicode hex": "25B6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "9665",
        "Unicode hex": "25C1"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "9655",
        "Unicode hex": "25B7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "9699",
        "Unicode hex": "25E3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "9698",
        "Unicode hex": "25E2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "9700",
        "Unicode hex": "25E4"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "9701",
        "Unicode hex": "25E5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "128896",
        "Unicode hex": "1F780"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "128898",
        "Unicode hex": "1F782"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "128897",
        "Unicode hex": "1F781"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "128899",
        "Unicode hex": "1F783"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "11205",
        "Unicode hex": "2BC5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "11206",
        "Unicode hex": "2BC6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "11207",
        "Unicode hex": "2BC7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "11208",
        "Unicode hex": "2BC8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "11164",
        "Unicode hex": "2B9C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "11166",
        "Unicode hex": "2B9E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "11165",
        "Unicode hex": "2B9D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "11167",
        "Unicode hex": "2B9F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "129040",
        "Unicode hex": "1F810"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "129042",
        "Unicode hex": "1F812"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "129041",
        "Unicode hex": "1F811"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "129043",
        "Unicode hex": "1F813"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "129044",
        "Unicode hex": "1F814"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "129046",
        "Unicode hex": "1F816"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "129045",
        "Unicode hex": "1F815"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "129047",
        "Unicode hex": "1F817"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "129048",
        "Unicode hex": "1F818"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "129050",
        "Unicode hex": "1F81A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "129049",
        "Unicode hex": "1F819"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "129051",
        "Unicode hex": "1F81B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "129052",
        "Unicode hex": "1F81C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "129054",
        "Unicode hex": "1F81E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "129053",
        "Unicode hex": "1F81D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "129055",
        "Unicode hex": "1F81F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "129024",
        "Unicode hex": "1F800"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "129026",
        "Unicode hex": "1F802"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "129025",
        "Unicode hex": "1F801"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "129027",
        "Unicode hex": "1F803"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "129028",
        "Unicode hex": "1F804"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "129030",
        "Unicode hex": "1F806"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "129029",
        "Unicode hex": "1F805"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "129031",
        "Unicode hex": "1F807"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "129032",
        "Unicode hex": "1F808"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "129034",
        "Unicode hex": "1F80A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "129033",
        "Unicode hex": "1F809"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "129035",
        "Unicode hex": "1F80B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "129056",
        "Unicode hex": "1F820"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "129058",
        "Unicode hex": "1F822"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "129060",
        "Unicode hex": "1F824"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "129062",
        "Unicode hex": "1F826"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "129064",
        "Unicode hex": "1F828"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "129066",
        "Unicode hex": "1F82A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "129068",
        "Unicode hex": "1F82C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "129180",
        "Unicode hex": "1F89C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "129181",
        "Unicode hex": "1F89D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "129182",
        "Unicode hex": "1F89E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "129183",
        "Unicode hex": "1F89F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "129070",
        "Unicode hex": "1F82E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "129072",
        "Unicode hex": "1F830"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "129074",
        "Unicode hex": "1F832"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "129076",
        "Unicode hex": "1F834"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "129078",
        "Unicode hex": "1F836"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "129080",
        "Unicode hex": "1F838"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "129082",
        "Unicode hex": "1F83A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "129081",
        "Unicode hex": "1F839"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "129083",
        "Unicode hex": "1F83B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "129176",
        "Unicode hex": "1F898"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "129178",
        "Unicode hex": "1F89A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "129177",
        "Unicode hex": "1F899"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "129179",
        "Unicode hex": "1F89B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "129084",
        "Unicode hex": "1F83C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "129086",
        "Unicode hex": "1F83E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "129085",
        "Unicode hex": "1F83D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "129087",
        "Unicode hex": "1F83F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "129088",
        "Unicode hex": "1F840"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "129090",
        "Unicode hex": "1F842"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "129089",
        "Unicode hex": "1F841"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "129091",
        "Unicode hex": "1F843"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "129092",
        "Unicode hex": "1F844"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "129094",
        "Unicode hex": "1F846"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "129093",
        "Unicode hex": "1F845"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "129095",
        "Unicode hex": "1F847"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "11176",
        "Unicode hex": "2BA8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "11177",
        "Unicode hex": "2BA9"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "11178",
        "Unicode hex": "2BAA"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "11179",
        "Unicode hex": "2BAB"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "11180",
        "Unicode hex": "2BAC"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "11181",
        "Unicode hex": "2BAD"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "11182",
        "Unicode hex": "2BAE"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "11183",
        "Unicode hex": "2BAF"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "129120",
        "Unicode hex": "1F860"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "129122",
        "Unicode hex": "1F862"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "129121",
        "Unicode hex": "1F861"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "129123",
        "Unicode hex": "1F863"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "129124",
        "Unicode hex": "1F864"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "129125",
        "Unicode hex": "1F865"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "129127",
        "Unicode hex": "1F867"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "129126",
        "Unicode hex": "1F866"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "129136",
        "Unicode hex": "1F870"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "129138",
        "Unicode hex": "1F872"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "129137",
        "Unicode hex": "1F871"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "129139",
        "Unicode hex": "1F873"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "129140",
        "Unicode hex": "1F874"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "129141",
        "Unicode hex": "1F875"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "129143",
        "Unicode hex": "1F877"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "129142",
        "Unicode hex": "1F876"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "129152",
        "Unicode hex": "1F880"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "129154",
        "Unicode hex": "1F882"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "129153",
        "Unicode hex": "1F881"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "129155",
        "Unicode hex": "1F883"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "129156",
        "Unicode hex": "1F884"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "129157",
        "Unicode hex": "1F885"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "129159",
        "Unicode hex": "1F887"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "129158",
        "Unicode hex": "1F886"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "129168",
        "Unicode hex": "1F890"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "129170",
        "Unicode hex": "1F892"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "129169",
        "Unicode hex": "1F891"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "129171",
        "Unicode hex": "1F893"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "129172",
        "Unicode hex": "1F894"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "129174",
        "Unicode hex": "1F896"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "129173",
        "Unicode hex": "1F895"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "129175",
        "Unicode hex": "1F897"
    }
];
module.exports.default = $1bbccb41dd858aa1$var$dingbats;

});

parcelRegister("jS8wL", function(module, exports) {

$parcel$export(module.exports, "paragraph", function () { return $e779acd2c53c2515$export$9c206ddddb32a9b; }, function (v) { return $e779acd2c53c2515$export$9c206ddddb32a9b = v; });
$parcel$export(module.exports, "run", function () { return $e779acd2c53c2515$export$889ea624f2cb2c57; }, function (v) { return $e779acd2c53c2515$export$889ea624f2cb2c57 = v; });
$parcel$export(module.exports, "_elements", function () { return $e779acd2c53c2515$export$297bfd0191b750db; }, function (v) { return $e779acd2c53c2515$export$297bfd0191b750db = v; });
$parcel$export(module.exports, "_elementsOfType", function () { return $e779acd2c53c2515$export$e7e1b0baa764e14f; }, function (v) { return $e779acd2c53c2515$export$e7e1b0baa764e14f = v; });
$parcel$export(module.exports, "getDescendantsOfType", function () { return $e779acd2c53c2515$export$a892993bbae48540; }, function (v) { return $e779acd2c53c2515$export$a892993bbae48540 = v; });
$parcel$export(module.exports, "getDescendants", function () { return $e779acd2c53c2515$export$d607bcb6675e3e03; }, function (v) { return $e779acd2c53c2515$export$d607bcb6675e3e03 = v; });
var $e779acd2c53c2515$export$9c206ddddb32a9b;
var $e779acd2c53c2515$export$889ea624f2cb2c57;
var $e779acd2c53c2515$export$297bfd0191b750db;
var $e779acd2c53c2515$export$e7e1b0baa764e14f;
var $e779acd2c53c2515$export$a892993bbae48540;
var $e779acd2c53c2515$export$d607bcb6675e3e03;
parcelRequire("eSbtG");
var $1kSpe = parcelRequire("1kSpe");
var $apU8A = parcelRequire("apU8A");
$e779acd2c53c2515$export$9c206ddddb32a9b = $e779acd2c53c2515$var$paragraph;
$e779acd2c53c2515$export$889ea624f2cb2c57 = $e779acd2c53c2515$var$run;
$e779acd2c53c2515$export$297bfd0191b750db = $e779acd2c53c2515$var$elements;
$e779acd2c53c2515$export$e7e1b0baa764e14f = $e779acd2c53c2515$var$elementsOfType;
$e779acd2c53c2515$export$a892993bbae48540 = $e779acd2c53c2515$var$getDescendantsOfType;
$e779acd2c53c2515$export$d607bcb6675e3e03 = $e779acd2c53c2515$var$getDescendants;
function $e779acd2c53c2515$var$paragraph(transform) {
    return $e779acd2c53c2515$var$elementsOfType("paragraph", transform);
}
function $e779acd2c53c2515$var$run(transform) {
    return $e779acd2c53c2515$var$elementsOfType("run", transform);
}
function $e779acd2c53c2515$var$elementsOfType(elementType, transform) {
    return $e779acd2c53c2515$var$elements(function(element) {
        if (element.type === elementType) return transform(element);
        else return element;
    });
}
function $e779acd2c53c2515$var$elements(transform) {
    return function transformElement(element) {
        if (element.children) {
            var children = $apU8A.default(element.children, transformElement);
            element = $1kSpe.default(element, {
                children: children
            });
        }
        return transform(element);
    };
}
function $e779acd2c53c2515$var$getDescendantsOfType(element, type) {
    return $e779acd2c53c2515$var$getDescendants(element).filter(function(descendant) {
        return descendant.type === type;
    });
}
function $e779acd2c53c2515$var$getDescendants(element) {
    var descendants = [];
    $e779acd2c53c2515$var$visitDescendants(element, function(descendant) {
        descendants.push(descendant);
    });
    return descendants;
}
function $e779acd2c53c2515$var$visitDescendants(element, visit) {
    if (element.children) element.children.forEach(function(child) {
        $e779acd2c53c2515$var$visitDescendants(child, visit);
        visit(child);
    });
}

});

parcelRegister("1c9jc", function(module, exports) {
parcelRequire("eSbtG");
var $3CMFi = parcelRequire("3CMFi");
var $apU8A = parcelRequire("apU8A");

var $6qB5W = parcelRequire("6qB5W");
function $0dee21f2df7147ae$var$simplify(nodes) {
    return $0dee21f2df7147ae$var$collapse($0dee21f2df7147ae$var$removeEmpty(nodes));
}
function $0dee21f2df7147ae$var$collapse(nodes) {
    var children = [];
    nodes.map($0dee21f2df7147ae$var$collapseNode).forEach(function(child) {
        $0dee21f2df7147ae$var$appendChild(children, child);
    });
    return children;
}
function $0dee21f2df7147ae$var$collapseNode(node) {
    return $0dee21f2df7147ae$var$collapsers[node.type](node);
}
var $0dee21f2df7147ae$var$collapsers = {
    element: $0dee21f2df7147ae$var$collapseElement,
    text: $0dee21f2df7147ae$var$identity,
    forceWrite: $0dee21f2df7147ae$var$identity
};
function $0dee21f2df7147ae$var$collapseElement(node) {
    return $6qB5W.elementWithTag(node.tag, $0dee21f2df7147ae$var$collapse(node.children));
}
function $0dee21f2df7147ae$var$identity(value) {
    return value;
}
function $0dee21f2df7147ae$var$appendChild(children, child) {
    var lastChild = children[children.length - 1];
    if (child.type === "element" && !child.tag.fresh && lastChild && lastChild.type === "element" && child.tag.matchesElement(lastChild.tag)) {
        if (child.tag.separator) $0dee21f2df7147ae$var$appendChild(lastChild.children, $6qB5W.text(child.tag.separator));
        child.children.forEach(function(grandChild) {
            // Mutation is fine since simplifying elements create a copy of the children.
            $0dee21f2df7147ae$var$appendChild(lastChild.children, grandChild);
        });
    } else children.push(child);
}
function $0dee21f2df7147ae$var$removeEmpty(nodes) {
    return $0dee21f2df7147ae$var$flatMap(nodes, function(node) {
        return $0dee21f2df7147ae$var$emptiers[node.type](node);
    });
}
function $0dee21f2df7147ae$var$flatMap(values, func) {
    return $3CMFi.default($apU8A.default(values, func), true);
}
var $0dee21f2df7147ae$var$emptiers = {
    element: $0dee21f2df7147ae$var$elementEmptier,
    text: $0dee21f2df7147ae$var$textEmptier,
    forceWrite: $0dee21f2df7147ae$var$neverEmpty
};
function $0dee21f2df7147ae$var$neverEmpty(node) {
    return [
        node
    ];
}
function $0dee21f2df7147ae$var$elementEmptier(element) {
    var children = $0dee21f2df7147ae$var$removeEmpty(element.children);
    if (children.length === 0 && !$6qB5W.isVoidElement(element)) return [];
    else return [
        $6qB5W.elementWithTag(element.tag, children)
    ];
}
function $0dee21f2df7147ae$var$textEmptier(node) {
    if (node.value.length === 0) return [];
    else return [
        node
    ];
}
module.exports = $0dee21f2df7147ae$var$simplify;

});
parcelRegister("6qB5W", function(module, exports) {

$parcel$export(module.exports, "freshElement", function () { return $4ae1f2088f3d15e8$export$930fc3b604aa2e41; }, function (v) { return $4ae1f2088f3d15e8$export$930fc3b604aa2e41 = v; });
$parcel$export(module.exports, "nonFreshElement", function () { return $4ae1f2088f3d15e8$export$288e963e20e7093f; }, function (v) { return $4ae1f2088f3d15e8$export$288e963e20e7093f = v; });
$parcel$export(module.exports, "elementWithTag", function () { return $4ae1f2088f3d15e8$export$dca5772e3b681cdf; }, function (v) { return $4ae1f2088f3d15e8$export$dca5772e3b681cdf = v; });
$parcel$export(module.exports, "text", function () { return $4ae1f2088f3d15e8$export$6f093cfa640b7166; }, function (v) { return $4ae1f2088f3d15e8$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "forceWrite", function () { return $4ae1f2088f3d15e8$export$a98c45d6a360f787; }, function (v) { return $4ae1f2088f3d15e8$export$a98c45d6a360f787 = v; });
$parcel$export(module.exports, "isVoidElement", function () { return $4ae1f2088f3d15e8$export$ce7b605508b1d8cd; }, function (v) { return $4ae1f2088f3d15e8$export$ce7b605508b1d8cd = v; });
var $4ae1f2088f3d15e8$export$930fc3b604aa2e41;
var $4ae1f2088f3d15e8$export$288e963e20e7093f;
var $4ae1f2088f3d15e8$export$dca5772e3b681cdf;
var $4ae1f2088f3d15e8$export$6f093cfa640b7166;
var $4ae1f2088f3d15e8$export$a98c45d6a360f787;
var $4ae1f2088f3d15e8$export$ce7b605508b1d8cd;

var $2q3gK = parcelRequire("2q3gK");
function $4ae1f2088f3d15e8$var$nonFreshElement(tagName, attributes, children) {
    return $4ae1f2088f3d15e8$var$elementWithTag($2q3gK.element(tagName, attributes, {
        fresh: false
    }), children);
}
function $4ae1f2088f3d15e8$var$freshElement(tagName, attributes, children) {
    var tag = $2q3gK.element(tagName, attributes, {
        fresh: true
    });
    return $4ae1f2088f3d15e8$var$elementWithTag(tag, children);
}
function $4ae1f2088f3d15e8$var$elementWithTag(tag, children) {
    return {
        type: "element",
        tag: tag,
        children: children || []
    };
}
function $4ae1f2088f3d15e8$var$text(value) {
    return {
        type: "text",
        value: value
    };
}
var $4ae1f2088f3d15e8$var$forceWrite = {
    type: "forceWrite"
};
$4ae1f2088f3d15e8$export$930fc3b604aa2e41 = $4ae1f2088f3d15e8$var$freshElement;
$4ae1f2088f3d15e8$export$288e963e20e7093f = $4ae1f2088f3d15e8$var$nonFreshElement;
$4ae1f2088f3d15e8$export$dca5772e3b681cdf = $4ae1f2088f3d15e8$var$elementWithTag;
$4ae1f2088f3d15e8$export$6f093cfa640b7166 = $4ae1f2088f3d15e8$var$text;
$4ae1f2088f3d15e8$export$a98c45d6a360f787 = $4ae1f2088f3d15e8$var$forceWrite;
var $4ae1f2088f3d15e8$var$voidTagNames = {
    "br": true,
    "hr": true,
    "img": true,
    "input": true
};
function $4ae1f2088f3d15e8$var$isVoidElement(node) {
    return node.children.length === 0 && $4ae1f2088f3d15e8$var$voidTagNames[node.tag.tagName];
}
$4ae1f2088f3d15e8$export$ce7b605508b1d8cd = $4ae1f2088f3d15e8$var$isVoidElement;

});
parcelRegister("2q3gK", function(module, exports) {

$parcel$export(module.exports, "topLevelElement", function () { return $1c308ba3a7814364$export$3f0e324b0c23f49b; }, function (v) { return $1c308ba3a7814364$export$3f0e324b0c23f49b = v; });
$parcel$export(module.exports, "elements", function () { return $1c308ba3a7814364$export$7a5d735b2ab6389d; }, function (v) { return $1c308ba3a7814364$export$7a5d735b2ab6389d = v; });
$parcel$export(module.exports, "element", function () { return $1c308ba3a7814364$export$8454457683f90105; }, function (v) { return $1c308ba3a7814364$export$8454457683f90105 = v; });
$parcel$export(module.exports, "empty", function () { return $1c308ba3a7814364$export$6e22c362a0406a2c; }, function (v) { return $1c308ba3a7814364$export$6e22c362a0406a2c = v; });
$parcel$export(module.exports, "ignore", function () { return $1c308ba3a7814364$export$738b109e247a462c; }, function (v) { return $1c308ba3a7814364$export$738b109e247a462c = v; });
var $1c308ba3a7814364$export$3f0e324b0c23f49b;
var $1c308ba3a7814364$export$7a5d735b2ab6389d;
var $1c308ba3a7814364$export$8454457683f90105;
var $1c308ba3a7814364$export$6e22c362a0406a2c;
var $1c308ba3a7814364$export$738b109e247a462c;
parcelRequire("eSbtG");
var $iXrUt = parcelRequire("iXrUt");
var $2nWzp = parcelRequire("2nWzp");
var $04NNv = parcelRequire("04NNv");

var $2bFLC = parcelRequire("2bFLC");
$1c308ba3a7814364$export$3f0e324b0c23f49b = $1c308ba3a7814364$var$topLevelElement;
$1c308ba3a7814364$export$7a5d735b2ab6389d = $1c308ba3a7814364$var$elements;
$1c308ba3a7814364$export$8454457683f90105 = $1c308ba3a7814364$var$element;
function $1c308ba3a7814364$var$topLevelElement(tagName, attributes) {
    return $1c308ba3a7814364$var$elements([
        $1c308ba3a7814364$var$element(tagName, attributes, {
            fresh: true
        })
    ]);
}
function $1c308ba3a7814364$var$elements(elementStyles) {
    return new $1c308ba3a7814364$var$HtmlPath(elementStyles.map(function(elementStyle) {
        if ($04NNv.default(elementStyle)) return $1c308ba3a7814364$var$element(elementStyle);
        else return elementStyle;
    }));
}
function $1c308ba3a7814364$var$HtmlPath(elements) {
    this._elements = elements;
}
$1c308ba3a7814364$var$HtmlPath.prototype.wrap = function wrap(children) {
    var result = children();
    for(var index = this._elements.length - 1; index >= 0; index--)result = this._elements[index].wrapNodes(result);
    return result;
};
function $1c308ba3a7814364$var$element(tagName, attributes, options) {
    options = options || {};
    return new $1c308ba3a7814364$var$Element(tagName, attributes, options);
}
function $1c308ba3a7814364$var$Element(tagName, attributes, options) {
    var tagNames = {};
    if ($iXrUt.default(tagName)) {
        tagName.forEach(function(tagName) {
            tagNames[tagName] = true;
        });
        tagName = tagName[0];
    } else tagNames[tagName] = true;
    this.tagName = tagName;
    this.tagNames = tagNames;
    this.attributes = attributes || {};
    this.fresh = options.fresh;
    this.separator = options.separator;
}
$1c308ba3a7814364$var$Element.prototype.matchesElement = function(element) {
    return this.tagNames[element.tagName] && $2nWzp.default(this.attributes || {}, element.attributes || {});
};
$1c308ba3a7814364$var$Element.prototype.wrap = function wrap(generateNodes) {
    return this.wrapNodes(generateNodes());
};
$1c308ba3a7814364$var$Element.prototype.wrapNodes = function wrapNodes(nodes) {
    return [
        $2bFLC.elementWithTag(this, nodes)
    ];
};
$1c308ba3a7814364$export$6e22c362a0406a2c = $1c308ba3a7814364$var$elements([]);
$1c308ba3a7814364$export$738b109e247a462c = {
    wrap: function() {
        return [];
    }
};

});
parcelRegister("2bFLC", function(module, exports) {

$parcel$export(module.exports, "freshElement", function () { return $197d01f110135805$export$930fc3b604aa2e41; }, function (v) { return $197d01f110135805$export$930fc3b604aa2e41 = v; });
$parcel$export(module.exports, "nonFreshElement", function () { return $197d01f110135805$export$288e963e20e7093f; }, function (v) { return $197d01f110135805$export$288e963e20e7093f = v; });
$parcel$export(module.exports, "elementWithTag", function () { return $197d01f110135805$export$dca5772e3b681cdf; }, function (v) { return $197d01f110135805$export$dca5772e3b681cdf = v; });
$parcel$export(module.exports, "text", function () { return $197d01f110135805$export$6f093cfa640b7166; }, function (v) { return $197d01f110135805$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "forceWrite", function () { return $197d01f110135805$export$a98c45d6a360f787; }, function (v) { return $197d01f110135805$export$a98c45d6a360f787 = v; });
$parcel$export(module.exports, "simplify", function () { return $197d01f110135805$export$798b53621063651; }, function (v) { return $197d01f110135805$export$798b53621063651 = v; });
$parcel$export(module.exports, "write", function () { return $197d01f110135805$export$68d8715fc104d294; }, function (v) { return $197d01f110135805$export$68d8715fc104d294 = v; });
var $197d01f110135805$export$930fc3b604aa2e41;
var $197d01f110135805$export$288e963e20e7093f;
var $197d01f110135805$export$dca5772e3b681cdf;
var $197d01f110135805$export$6f093cfa640b7166;
var $197d01f110135805$export$a98c45d6a360f787;
var $197d01f110135805$export$798b53621063651;
var $197d01f110135805$export$68d8715fc104d294;

var $6qB5W = parcelRequire("6qB5W");
$197d01f110135805$export$930fc3b604aa2e41 = $6qB5W.freshElement;
$197d01f110135805$export$288e963e20e7093f = $6qB5W.nonFreshElement;
$197d01f110135805$export$dca5772e3b681cdf = $6qB5W.elementWithTag;
$197d01f110135805$export$6f093cfa640b7166 = $6qB5W.text;
$197d01f110135805$export$a98c45d6a360f787 = $6qB5W.forceWrite;

$197d01f110135805$export$798b53621063651 = (parcelRequire("1c9jc"));
function $197d01f110135805$var$write(writer, nodes) {
    nodes.forEach(function(node) {
        $197d01f110135805$var$writeNode(writer, node);
    });
}
function $197d01f110135805$var$writeNode(writer, node) {
    $197d01f110135805$var$toStrings[node.type](writer, node);
}
var $197d01f110135805$var$toStrings = {
    element: $197d01f110135805$var$generateElementString,
    text: $197d01f110135805$var$generateTextString,
    forceWrite: function() {}
};
function $197d01f110135805$var$generateElementString(writer, node) {
    if ($6qB5W.isVoidElement(node)) writer.selfClosing(node.tag.tagName, node.tag.attributes);
    else {
        writer.open(node.tag.tagName, node.tag.attributes);
        $197d01f110135805$var$write(writer, node.children);
        writer.close(node.tag.tagName);
    }
}
function $197d01f110135805$var$generateTextString(writer, node) {
    writer.text(node.value);
}
$197d01f110135805$export$68d8715fc104d294 = $197d01f110135805$var$write;

});




parcelRegister("fb1ge", function(module, exports) {

$parcel$export(module.exports, "imgElement", function () { return $b0c8dc784159fc0a$export$447d08562cb82152; }, function (v) { return $b0c8dc784159fc0a$export$447d08562cb82152 = v; });
$parcel$export(module.exports, "inline", function () { return $b0c8dc784159fc0a$export$18c8ad048e32c7d5; }, function (v) { return $b0c8dc784159fc0a$export$18c8ad048e32c7d5 = v; });
$parcel$export(module.exports, "dataUri", function () { return $b0c8dc784159fc0a$export$bc36deb06467538e; }, function (v) { return $b0c8dc784159fc0a$export$bc36deb06467538e = v; });
var $b0c8dc784159fc0a$export$447d08562cb82152;
// Undocumented, but retained for backwards-compatibility with 0.3.x
var $b0c8dc784159fc0a$export$18c8ad048e32c7d5;
var $b0c8dc784159fc0a$export$bc36deb06467538e;
parcelRequire("eSbtG");
var $1kSpe = parcelRequire("1kSpe");

var $lUVKW = parcelRequire("lUVKW");

var $2bFLC = parcelRequire("2bFLC");
$b0c8dc784159fc0a$export$447d08562cb82152 = $b0c8dc784159fc0a$var$imgElement;
function $b0c8dc784159fc0a$var$imgElement(func) {
    return function(element, messages) {
        return $lUVKW.when(func(element)).then(function(result) {
            var attributes = {};
            if (element.altText) attributes.alt = element.altText;
            $1kSpe.default(attributes, result);
            return [
                $2bFLC.freshElement("img", attributes)
            ];
        });
    };
}
$b0c8dc784159fc0a$export$18c8ad048e32c7d5 = $b0c8dc784159fc0a$export$447d08562cb82152;
$b0c8dc784159fc0a$export$bc36deb06467538e = $b0c8dc784159fc0a$var$imgElement(function(element) {
    return element.readAsBase64String().then(function(imageBuffer) {
        return {
            src: "data:" + element.contentType + ";base64," + imageBuffer
        };
    });
});

});

parcelRegister("5dm5a", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $3cbf4bc34981cbac$export$7acfa6ed01010e37; }, function (v) { return $3cbf4bc34981cbac$export$7acfa6ed01010e37 = v; });
var $3cbf4bc34981cbac$export$7acfa6ed01010e37;

var $ieMp2 = parcelRequire("ieMp2");
$3cbf4bc34981cbac$export$7acfa6ed01010e37 = function(options) {
    var parseTokens = function(parser, tokens) {
        return parser(new $ieMp2(tokens));
    };
    return {
        parseTokens: parseTokens
    };
};

});
parcelRegister("ieMp2", function(module, exports) {
var $d46f14987b898086$var$TokenIterator = module.exports = function(tokens, startIndex) {
    this._tokens = tokens;
    this._startIndex = startIndex || 0;
};
$d46f14987b898086$var$TokenIterator.prototype.head = function() {
    return this._tokens[this._startIndex];
};
$d46f14987b898086$var$TokenIterator.prototype.tail = function(startIndex) {
    return new $d46f14987b898086$var$TokenIterator(this._tokens, this._startIndex + 1);
};
$d46f14987b898086$var$TokenIterator.prototype.toArray = function() {
    return this._tokens.slice(this._startIndex);
};
$d46f14987b898086$var$TokenIterator.prototype.end = function() {
    return this._tokens[this._tokens.length - 1];
};
// TODO: doesn't need to be a method, can be a separate function,
// which simplifies implementation of the TokenIterator interface
$d46f14987b898086$var$TokenIterator.prototype.to = function(end) {
    var start = this.head().source;
    var endToken = end.head() || end.end();
    return start.to(endToken.source);
};

});


parcelRegister("2VAUF", function(module, exports) {

$parcel$export(module.exports, "token", function () { return $221d89c94f47f4c6$export$9e1725a4cfeada27; }, function (v) { return $221d89c94f47f4c6$export$9e1725a4cfeada27 = v; });
$parcel$export(module.exports, "tokenOfType", function () { return $221d89c94f47f4c6$export$41696449d44bc99f; }, function (v) { return $221d89c94f47f4c6$export$41696449d44bc99f = v; });
$parcel$export(module.exports, "firstOf", function () { return $221d89c94f47f4c6$export$320dfad4854fb566; }, function (v) { return $221d89c94f47f4c6$export$320dfad4854fb566 = v; });
$parcel$export(module.exports, "then", function () { return $221d89c94f47f4c6$export$ff2899a39f81dcfa; }, function (v) { return $221d89c94f47f4c6$export$ff2899a39f81dcfa = v; });
$parcel$export(module.exports, "sequence", function () { return $221d89c94f47f4c6$export$49bb65c2ea163039; }, function (v) { return $221d89c94f47f4c6$export$49bb65c2ea163039 = v; });
$parcel$export(module.exports, "optional", function () { return $221d89c94f47f4c6$export$516e28dec6a4b6d4; }, function (v) { return $221d89c94f47f4c6$export$516e28dec6a4b6d4 = v; });
$parcel$export(module.exports, "zeroOrMoreWithSeparator", function () { return $221d89c94f47f4c6$export$3efe17da37330ee1; }, function (v) { return $221d89c94f47f4c6$export$3efe17da37330ee1 = v; });
$parcel$export(module.exports, "oneOrMoreWithSeparator", function () { return $221d89c94f47f4c6$export$e4021a525ad1b87a; }, function (v) { return $221d89c94f47f4c6$export$e4021a525ad1b87a = v; });
$parcel$export(module.exports, "zeroOrMore", function () { return $221d89c94f47f4c6$export$d72c500c373b4da6; }, function (v) { return $221d89c94f47f4c6$export$d72c500c373b4da6 = v; });
$parcel$export(module.exports, "oneOrMore", function () { return $221d89c94f47f4c6$export$c207d1ebdac09916; }, function (v) { return $221d89c94f47f4c6$export$c207d1ebdac09916 = v; });
$parcel$export(module.exports, "leftAssociative", function () { return $221d89c94f47f4c6$export$ae4cf6488905ca50; }, function (v) { return $221d89c94f47f4c6$export$ae4cf6488905ca50 = v; });
$parcel$export(module.exports, "nonConsuming", function () { return $221d89c94f47f4c6$export$e85d6b145bf6c7b6; }, function (v) { return $221d89c94f47f4c6$export$e85d6b145bf6c7b6 = v; });
var $221d89c94f47f4c6$export$9e1725a4cfeada27;
var $221d89c94f47f4c6$export$41696449d44bc99f;
var $221d89c94f47f4c6$export$320dfad4854fb566;
var $221d89c94f47f4c6$export$ff2899a39f81dcfa;
var $221d89c94f47f4c6$export$49bb65c2ea163039;
var $221d89c94f47f4c6$export$516e28dec6a4b6d4;
var $221d89c94f47f4c6$export$3efe17da37330ee1;
var $221d89c94f47f4c6$export$e4021a525ad1b87a;
var $221d89c94f47f4c6$export$d72c500c373b4da6;
var $221d89c94f47f4c6$export$c207d1ebdac09916;
var $221d89c94f47f4c6$export$ae4cf6488905ca50;
var $221d89c94f47f4c6$export$e85d6b145bf6c7b6;
parcelRequire("eSbtG");
var $4zp9I = parcelRequire("4zp9I");
var $6dYu1 = parcelRequire("6dYu1");
var $d6ISG = parcelRequire("d6ISG");
var $iXrUt = parcelRequire("iXrUt");

var $fXHcZ = parcelRequire("fXHcZ");

var $3rodx = parcelRequire("3rodx");

var $aZ3NE = parcelRequire("aZ3NE");

var $69Dz4 = parcelRequire("69Dz4");
$221d89c94f47f4c6$export$9e1725a4cfeada27 = function(tokenType, value) {
    var matchValue = value !== undefined;
    return function(input) {
        var token = input.head();
        if (token && token.name === tokenType && (!matchValue || token.value === value)) return $3rodx.success(token.value, input.tail(), token.source);
        else {
            var expected = $221d89c94f47f4c6$var$describeToken({
                name: tokenType,
                value: value
            });
            return $221d89c94f47f4c6$var$describeTokenMismatch(input, expected);
        }
    };
};
$221d89c94f47f4c6$export$41696449d44bc99f = function(tokenType) {
    return $221d89c94f47f4c6$export$9e1725a4cfeada27(tokenType);
};
$221d89c94f47f4c6$export$320dfad4854fb566 = function(name, parsers) {
    if (!$iXrUt.default(parsers)) parsers = Array.prototype.slice.call(arguments, 1);
    return function(input) {
        return $69Dz4.fromArray(parsers).map(function(parser) {
            return parser(input);
        }).filter(function(result) {
            return result.isSuccess() || result.isError();
        }).first() || $221d89c94f47f4c6$var$describeTokenMismatch(input, name);
    };
};
$221d89c94f47f4c6$export$ff2899a39f81dcfa = function(parser, func) {
    return function(input) {
        var result = parser(input);
        if (!result.map) console.log(result);
        return result.map(func);
    };
};
$221d89c94f47f4c6$export$49bb65c2ea163039 = function() {
    var parsers = Array.prototype.slice.call(arguments, 0);
    var rule = function(input) {
        var result = $d6ISG.default(parsers, function(memo, parser) {
            var result = memo.result;
            var hasCut = memo.hasCut;
            if (!result.isSuccess()) return {
                result: result,
                hasCut: hasCut
            };
            var subResult = parser(result.remaining());
            if (subResult.isCut()) return {
                result: result,
                hasCut: true
            };
            else if (subResult.isSuccess()) {
                var values;
                if (parser.isCaptured) values = result.value().withValue(parser, subResult.value());
                else values = result.value();
                var remaining = subResult.remaining();
                var source = input.to(remaining);
                return {
                    result: $3rodx.success(values, remaining, source),
                    hasCut: hasCut
                };
            } else if (hasCut) return {
                result: $3rodx.error(subResult.errors(), subResult.remaining()),
                hasCut: hasCut
            };
            else return {
                result: subResult,
                hasCut: hasCut
            };
        }, {
            result: $3rodx.success(new $221d89c94f47f4c6$var$SequenceValues(), input),
            hasCut: false
        }).result;
        var source = input.to(result.remaining());
        return result.map(function(values) {
            return values.withValue($221d89c94f47f4c6$export$49bb65c2ea163039.source, source);
        });
    };
    rule.head = function() {
        var firstCapture = $6dYu1.default(parsers, isCapturedRule);
        return $221d89c94f47f4c6$export$ff2899a39f81dcfa(rule, $221d89c94f47f4c6$export$49bb65c2ea163039.extract(firstCapture));
    };
    rule.map = function(func) {
        return $221d89c94f47f4c6$export$ff2899a39f81dcfa(rule, function(result) {
            return func.apply(this, result.toArray());
        });
    };
    function isCapturedRule(subRule) {
        return subRule.isCaptured;
    }
    return rule;
};
var $221d89c94f47f4c6$var$SequenceValues = function(values, valuesArray) {
    this._values = values || {};
    this._valuesArray = valuesArray || [];
};
$221d89c94f47f4c6$var$SequenceValues.prototype.withValue = function(rule, value) {
    if (rule.captureName && rule.captureName in this._values) throw new Error("Cannot add second value for capture \"" + rule.captureName + "\"");
    else {
        var newValues = $4zp9I.default(this._values);
        newValues[rule.captureName] = value;
        var newValuesArray = this._valuesArray.concat([
            value
        ]);
        return new $221d89c94f47f4c6$var$SequenceValues(newValues, newValuesArray);
    }
};
$221d89c94f47f4c6$var$SequenceValues.prototype.get = function(rule) {
    if (rule.captureName in this._values) return this._values[rule.captureName];
    else throw new Error("No value for capture \"" + rule.captureName + "\"");
};
$221d89c94f47f4c6$var$SequenceValues.prototype.toArray = function() {
    return this._valuesArray;
};
$221d89c94f47f4c6$export$49bb65c2ea163039.capture = function(rule, name) {
    var captureRule = function() {
        return rule.apply(this, arguments);
    };
    captureRule.captureName = name;
    captureRule.isCaptured = true;
    return captureRule;
};
$221d89c94f47f4c6$export$49bb65c2ea163039.extract = function(rule) {
    return function(result) {
        return result.get(rule);
    };
};
$221d89c94f47f4c6$export$49bb65c2ea163039.applyValues = function(func) {
    // TODO: check captureName doesn't conflict with source or other captures
    var rules = Array.prototype.slice.call(arguments, 1);
    return function(result) {
        var values = rules.map(function(rule) {
            return result.get(rule);
        });
        return func.apply(this, values);
    };
};
$221d89c94f47f4c6$export$49bb65c2ea163039.source = {
    captureName: "\u2603source\u2603"
};
$221d89c94f47f4c6$export$49bb65c2ea163039.cut = function() {
    return function(input) {
        return $3rodx.cut(input);
    };
};
$221d89c94f47f4c6$export$516e28dec6a4b6d4 = function(rule) {
    return function(input) {
        var result = rule(input);
        if (result.isSuccess()) return result.map($fXHcZ.some);
        else if (result.isFailure()) return $3rodx.success($fXHcZ.none, input);
        else return result;
    };
};
$221d89c94f47f4c6$export$3efe17da37330ee1 = function(rule, separator) {
    return $221d89c94f47f4c6$var$repeatedWithSeparator(rule, separator, false);
};
$221d89c94f47f4c6$export$e4021a525ad1b87a = function(rule, separator) {
    return $221d89c94f47f4c6$var$repeatedWithSeparator(rule, separator, true);
};
var $221d89c94f47f4c6$var$zeroOrMore = $221d89c94f47f4c6$export$d72c500c373b4da6 = function(rule) {
    return function(input) {
        var values = [];
        var result;
        while((result = rule(input)) && result.isSuccess()){
            input = result.remaining();
            values.push(result.value());
        }
        if (result.isError()) return result;
        else return $3rodx.success(values, input);
    };
};
$221d89c94f47f4c6$export$c207d1ebdac09916 = function(rule) {
    return $221d89c94f47f4c6$export$e4021a525ad1b87a(rule, $221d89c94f47f4c6$var$noOpRule);
};
function $221d89c94f47f4c6$var$noOpRule(input) {
    return $3rodx.success(null, input);
}
var $221d89c94f47f4c6$var$repeatedWithSeparator = function(rule, separator, isOneOrMore) {
    return function(input) {
        var result = rule(input);
        if (result.isSuccess()) {
            var mainRule = $221d89c94f47f4c6$export$49bb65c2ea163039.capture(rule, "main");
            var remainingRule = $221d89c94f47f4c6$var$zeroOrMore($221d89c94f47f4c6$export$ff2899a39f81dcfa($221d89c94f47f4c6$export$49bb65c2ea163039(separator, mainRule), $221d89c94f47f4c6$export$49bb65c2ea163039.extract(mainRule)));
            var remainingResult = remainingRule(result.remaining());
            return $3rodx.success([
                result.value()
            ].concat(remainingResult.value()), remainingResult.remaining());
        } else if (isOneOrMore || result.isError()) return result;
        else return $3rodx.success([], input);
    };
};
$221d89c94f47f4c6$export$ae4cf6488905ca50 = function(leftRule, rightRule, func) {
    var rights;
    if (func) rights = [
        {
            func: func,
            rule: rightRule
        }
    ];
    else rights = rightRule;
    rights = rights.map(function(right) {
        return $221d89c94f47f4c6$export$ff2899a39f81dcfa(right.rule, function(rightValue) {
            return function(leftValue, source) {
                return right.func(leftValue, rightValue, source);
            };
        });
    });
    var repeatedRule = $221d89c94f47f4c6$export$320dfad4854fb566.apply(null, [
        "rules"
    ].concat(rights));
    return function(input) {
        var start = input;
        var leftResult = leftRule(input);
        if (!leftResult.isSuccess()) return leftResult;
        var repeatedResult = repeatedRule(leftResult.remaining());
        while(repeatedResult.isSuccess()){
            var remaining = repeatedResult.remaining();
            var source = start.to(repeatedResult.remaining());
            var right = repeatedResult.value();
            leftResult = $3rodx.success(right(leftResult.value(), source), remaining, source);
            repeatedResult = repeatedRule(leftResult.remaining());
        }
        if (repeatedResult.isError()) return repeatedResult;
        return leftResult;
    };
};
$221d89c94f47f4c6$export$ae4cf6488905ca50.firstOf = function() {
    return Array.prototype.slice.call(arguments, 0);
};
$221d89c94f47f4c6$export$e85d6b145bf6c7b6 = function(rule) {
    return function(input) {
        return rule(input).changeRemaining(input);
    };
};
var $221d89c94f47f4c6$var$describeToken = function(token) {
    if (token.value) return token.name + " \"" + token.value + "\"";
    else return token.name;
};
function $221d89c94f47f4c6$var$describeTokenMismatch(input, expected) {
    var error;
    var token = input.head();
    if (token) error = $aZ3NE.error({
        expected: expected,
        actual: $221d89c94f47f4c6$var$describeToken(token),
        location: token.source
    });
    else error = $aZ3NE.error({
        expected: expected,
        actual: "end of tokens"
    });
    return $3rodx.failure([
        error
    ], input);
}

});
parcelRegister("fXHcZ", function(module, exports) {

$parcel$export(module.exports, "none", function () { return $b9ede208266681e7$export$f883a24d5edde77c; }, function (v) { return $b9ede208266681e7$export$f883a24d5edde77c = v; });
$parcel$export(module.exports, "some", function () { return $b9ede208266681e7$export$ad14ef4001db2bcd; }, function (v) { return $b9ede208266681e7$export$ad14ef4001db2bcd = v; });
var $b9ede208266681e7$export$f883a24d5edde77c;
var $b9ede208266681e7$export$ad14ef4001db2bcd;
var $b9ede208266681e7$export$707cacfe2982dfac;
var $b9ede208266681e7$export$b601f49376b4621a;
$b9ede208266681e7$export$f883a24d5edde77c = Object.create({
    value: function() {
        throw new Error('Called value on none');
    },
    isNone: function() {
        return true;
    },
    isSome: function() {
        return false;
    },
    map: function() {
        return $b9ede208266681e7$export$f883a24d5edde77c;
    },
    flatMap: function() {
        return $b9ede208266681e7$export$f883a24d5edde77c;
    },
    filter: function() {
        return $b9ede208266681e7$export$f883a24d5edde77c;
    },
    toArray: function() {
        return [];
    },
    orElse: $b9ede208266681e7$var$callOrReturn,
    valueOrElse: $b9ede208266681e7$var$callOrReturn
});
function $b9ede208266681e7$var$callOrReturn(value) {
    if (typeof value == "function") return value();
    else return value;
}
$b9ede208266681e7$export$ad14ef4001db2bcd = function(value) {
    return new $b9ede208266681e7$var$Some(value);
};
var $b9ede208266681e7$var$Some = function(value) {
    this._value = value;
};
$b9ede208266681e7$var$Some.prototype.value = function() {
    return this._value;
};
$b9ede208266681e7$var$Some.prototype.isNone = function() {
    return false;
};
$b9ede208266681e7$var$Some.prototype.isSome = function() {
    return true;
};
$b9ede208266681e7$var$Some.prototype.map = function(func) {
    return new $b9ede208266681e7$var$Some(func(this._value));
};
$b9ede208266681e7$var$Some.prototype.flatMap = function(func) {
    return func(this._value);
};
$b9ede208266681e7$var$Some.prototype.filter = function(predicate) {
    return predicate(this._value) ? this : $b9ede208266681e7$export$f883a24d5edde77c;
};
$b9ede208266681e7$var$Some.prototype.toArray = function() {
    return [
        this._value
    ];
};
$b9ede208266681e7$var$Some.prototype.orElse = function(value) {
    return this;
};
$b9ede208266681e7$var$Some.prototype.valueOrElse = function(value) {
    return this._value;
};
$b9ede208266681e7$export$707cacfe2982dfac = function(value) {
    return value === $b9ede208266681e7$export$f883a24d5edde77c || value instanceof $b9ede208266681e7$var$Some;
};
$b9ede208266681e7$export$b601f49376b4621a = function(value) {
    if (value == null) return $b9ede208266681e7$export$f883a24d5edde77c;
    return new $b9ede208266681e7$var$Some(value);
};

});

parcelRegister("3rodx", function(module, exports) {
module.exports = {
    failure: function(errors, remaining) {
        if (errors.length < 1) throw new Error("Failure must have errors");
        return new $2816adc9dff8ad1f$var$Result({
            status: "failure",
            remaining: remaining,
            errors: errors
        });
    },
    error: function(errors, remaining) {
        if (errors.length < 1) throw new Error("Failure must have errors");
        return new $2816adc9dff8ad1f$var$Result({
            status: "error",
            remaining: remaining,
            errors: errors
        });
    },
    success: function(value, remaining, source) {
        return new $2816adc9dff8ad1f$var$Result({
            status: "success",
            value: value,
            source: source,
            remaining: remaining,
            errors: []
        });
    },
    cut: function(remaining) {
        return new $2816adc9dff8ad1f$var$Result({
            status: "cut",
            remaining: remaining,
            errors: []
        });
    }
};
var $2816adc9dff8ad1f$var$Result = function(options) {
    this._value = options.value;
    this._status = options.status;
    this._hasValue = options.value !== undefined;
    this._remaining = options.remaining;
    this._source = options.source;
    this._errors = options.errors;
};
$2816adc9dff8ad1f$var$Result.prototype.map = function(func) {
    if (this._hasValue) return new $2816adc9dff8ad1f$var$Result({
        value: func(this._value, this._source),
        status: this._status,
        remaining: this._remaining,
        source: this._source,
        errors: this._errors
    });
    else return this;
};
$2816adc9dff8ad1f$var$Result.prototype.changeRemaining = function(remaining) {
    return new $2816adc9dff8ad1f$var$Result({
        value: this._value,
        status: this._status,
        remaining: remaining,
        source: this._source,
        errors: this._errors
    });
};
$2816adc9dff8ad1f$var$Result.prototype.isSuccess = function() {
    return this._status === "success" || this._status === "cut";
};
$2816adc9dff8ad1f$var$Result.prototype.isFailure = function() {
    return this._status === "failure";
};
$2816adc9dff8ad1f$var$Result.prototype.isError = function() {
    return this._status === "error";
};
$2816adc9dff8ad1f$var$Result.prototype.isCut = function() {
    return this._status === "cut";
};
$2816adc9dff8ad1f$var$Result.prototype.value = function() {
    return this._value;
};
$2816adc9dff8ad1f$var$Result.prototype.remaining = function() {
    return this._remaining;
};
$2816adc9dff8ad1f$var$Result.prototype.source = function() {
    return this._source;
};
$2816adc9dff8ad1f$var$Result.prototype.errors = function() {
    return this._errors;
};

});

parcelRegister("aZ3NE", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $02104c9683b1da83$export$a3bc9b8ed74fc; }, function (v) { return $02104c9683b1da83$export$a3bc9b8ed74fc = v; });
var $02104c9683b1da83$export$a3bc9b8ed74fc;
$02104c9683b1da83$export$a3bc9b8ed74fc = function(options) {
    return new $02104c9683b1da83$var$Error(options);
};
var $02104c9683b1da83$var$Error = function(options) {
    this.expected = options.expected;
    this.actual = options.actual;
    this._location = options.location;
};
$02104c9683b1da83$var$Error.prototype.describe = function() {
    var locationDescription = this._location ? this._location.describe() + ":\n" : "";
    return locationDescription + "Expected " + this.expected + "\nbut got " + this.actual;
};
$02104c9683b1da83$var$Error.prototype.lineNumber = function() {
    return this._location.lineNumber();
};
$02104c9683b1da83$var$Error.prototype.characterNumber = function() {
    return this._location.characterNumber();
};

});

parcelRegister("69Dz4", function(module, exports) {

$parcel$export(module.exports, "fromArray", function () { return $47b2460a6e8f02e1$export$571d59b505e6bb4e; }, function (v) { return $47b2460a6e8f02e1$export$571d59b505e6bb4e = v; });
var $47b2460a6e8f02e1$export$571d59b505e6bb4e;
var $47b2460a6e8f02e1$var$fromArray = $47b2460a6e8f02e1$export$571d59b505e6bb4e = function(array) {
    var index = 0;
    var hasNext = function() {
        return index < array.length;
    };
    return new $47b2460a6e8f02e1$var$LazyIterator({
        hasNext: hasNext,
        next: function() {
            if (!hasNext()) throw new Error("No more elements");
            else return array[index++];
        }
    });
};
var $47b2460a6e8f02e1$var$LazyIterator = function(iterator) {
    this._iterator = iterator;
};
$47b2460a6e8f02e1$var$LazyIterator.prototype.map = function(func) {
    var iterator = this._iterator;
    return new $47b2460a6e8f02e1$var$LazyIterator({
        hasNext: function() {
            return iterator.hasNext();
        },
        next: function() {
            return func(iterator.next());
        }
    });
};
$47b2460a6e8f02e1$var$LazyIterator.prototype.filter = function(condition) {
    var iterator = this._iterator;
    var moved = false;
    var hasNext = false;
    var next;
    var moveIfNecessary = function() {
        if (moved) return;
        moved = true;
        hasNext = false;
        while(iterator.hasNext() && !hasNext){
            next = iterator.next();
            hasNext = condition(next);
        }
    };
    return new $47b2460a6e8f02e1$var$LazyIterator({
        hasNext: function() {
            moveIfNecessary();
            return hasNext;
        },
        next: function() {
            moveIfNecessary();
            var toReturn = next;
            moved = false;
            return toReturn;
        }
    });
};
$47b2460a6e8f02e1$var$LazyIterator.prototype.first = function() {
    var iterator = this._iterator;
    if (this._iterator.hasNext()) return iterator.next();
    else return null;
};
$47b2460a6e8f02e1$var$LazyIterator.prototype.toArray = function() {
    var result = [];
    while(this._iterator.hasNext())result.push(this._iterator.next());
    return result;
};

});


parcelRegister("1J3fu", function(module, exports) {
var $141c838e0f376858$var$StringSource = module.exports = function(string, description) {
    var self = {
        asString: function() {
            return string;
        },
        range: function(startIndex, endIndex) {
            return new $141c838e0f376858$var$StringSourceRange(string, description, startIndex, endIndex);
        }
    };
    return self;
};
var $141c838e0f376858$var$StringSourceRange = function(string, description, startIndex, endIndex) {
    this._string = string;
    this._description = description;
    this._startIndex = startIndex;
    this._endIndex = endIndex;
};
$141c838e0f376858$var$StringSourceRange.prototype.to = function(otherRange) {
    // TODO: Assert that tokens are the same across both iterators
    return new $141c838e0f376858$var$StringSourceRange(this._string, this._description, this._startIndex, otherRange._endIndex);
};
$141c838e0f376858$var$StringSourceRange.prototype.describe = function() {
    var position = this._position();
    var description = this._description ? this._description + "\n" : "";
    return description + "Line number: " + position.lineNumber + "\nCharacter number: " + position.characterNumber;
};
$141c838e0f376858$var$StringSourceRange.prototype.lineNumber = function() {
    return this._position().lineNumber;
};
$141c838e0f376858$var$StringSourceRange.prototype.characterNumber = function() {
    return this._position().characterNumber;
};
$141c838e0f376858$var$StringSourceRange.prototype._position = function() {
    var self = this;
    var index = 0;
    var nextNewLine = function() {
        return self._string.indexOf("\n", index);
    };
    var lineNumber = 1;
    while(nextNewLine() !== -1 && nextNewLine() < this._startIndex){
        index = nextNewLine() + 1;
        lineNumber += 1;
    }
    var characterNumber = this._startIndex - index + 1;
    return {
        lineNumber: lineNumber,
        characterNumber: characterNumber
    };
};

});

parcelRegister("kojsS", function(module, exports) {
module.exports = function(name, value, source) {
    this.name = name;
    this.value = value;
    if (source) this.source = source;
};

});

parcelRegister("77zof", function(module, exports) {

$parcel$export(module.exports, "parser", function () { return $52f4a39a3fbd9472$export$8f49e4af10703ce3; }, function (v) { return $52f4a39a3fbd9472$export$8f49e4af10703ce3 = v; });
$parcel$export(module.exports, "infix", function () { return $52f4a39a3fbd9472$export$556631376a476def; }, function (v) { return $52f4a39a3fbd9472$export$556631376a476def = v; });
var $52f4a39a3fbd9472$export$8f49e4af10703ce3;
var $52f4a39a3fbd9472$export$556631376a476def;

var $2VAUF = parcelRequire("2VAUF");

var $3rodx = parcelRequire("3rodx");
$52f4a39a3fbd9472$export$8f49e4af10703ce3 = function(name, prefixRules, infixRuleBuilders) {
    var self = {
        rule: rule,
        leftAssociative: leftAssociative,
        rightAssociative: rightAssociative
    };
    var infixRules = new $52f4a39a3fbd9472$var$InfixRules(infixRuleBuilders.map(createInfixRule));
    var prefixRule = $2VAUF.firstOf(name, prefixRules);
    function createInfixRule(infixRuleBuilder) {
        return {
            name: infixRuleBuilder.name,
            rule: $52f4a39a3fbd9472$var$lazyRule(infixRuleBuilder.ruleBuilder.bind(null, self))
        };
    }
    function rule() {
        return createRule(infixRules);
    }
    function leftAssociative(name) {
        return createRule(infixRules.untilExclusive(name));
    }
    function rightAssociative(name) {
        return createRule(infixRules.untilInclusive(name));
    }
    function createRule(infixRules) {
        return apply.bind(null, infixRules);
    }
    function apply(infixRules, tokens) {
        var leftResult = prefixRule(tokens);
        if (leftResult.isSuccess()) return infixRules.apply(leftResult);
        else return leftResult;
    }
    return self;
};
function $52f4a39a3fbd9472$var$InfixRules(infixRules) {
    function untilExclusive(name) {
        return new $52f4a39a3fbd9472$var$InfixRules(infixRules.slice(0, ruleNames().indexOf(name)));
    }
    function untilInclusive(name) {
        return new $52f4a39a3fbd9472$var$InfixRules(infixRules.slice(0, ruleNames().indexOf(name) + 1));
    }
    function ruleNames() {
        return infixRules.map(function(rule) {
            return rule.name;
        });
    }
    function apply(leftResult) {
        var currentResult;
        var source;
        while(true){
            currentResult = applyToTokens(leftResult.remaining());
            if (currentResult.isSuccess()) {
                source = leftResult.source().to(currentResult.source());
                leftResult = $3rodx.success(currentResult.value()(leftResult.value(), source), currentResult.remaining(), source);
            } else if (currentResult.isFailure()) return leftResult;
            else return currentResult;
        }
    }
    function applyToTokens(tokens) {
        return $2VAUF.firstOf("infix", infixRules.map(function(infix) {
            return infix.rule;
        }))(tokens);
    }
    return {
        apply: apply,
        untilExclusive: untilExclusive,
        untilInclusive: untilInclusive
    };
}
$52f4a39a3fbd9472$export$556631376a476def = function(name, ruleBuilder) {
    function map(func) {
        return $52f4a39a3fbd9472$export$556631376a476def(name, function(parser) {
            var rule = ruleBuilder(parser);
            return function(tokens) {
                var result = rule(tokens);
                return result.map(function(right) {
                    return function(left, source) {
                        return func(left, right, source);
                    };
                });
            };
        });
    }
    return {
        name: name,
        ruleBuilder: ruleBuilder,
        map: map
    };
};
// TODO: move into a sensible place and remove duplication
var $52f4a39a3fbd9472$var$lazyRule = function(ruleBuilder) {
    var rule;
    return function(input) {
        if (!rule) rule = ruleBuilder();
        return rule(input);
    };
};

});

parcelRegister("1tQWe", function(module, exports) {

$parcel$export(module.exports, "RegexTokeniser", function () { return $1141904df5fd3650$export$74d15b5d79bf9ea; }, function (v) { return $1141904df5fd3650$export$74d15b5d79bf9ea = v; });
var $1141904df5fd3650$export$74d15b5d79bf9ea;

var $kojsS = parcelRequire("kojsS");

var $1J3fu = parcelRequire("1J3fu");
$1141904df5fd3650$export$74d15b5d79bf9ea = $1141904df5fd3650$var$RegexTokeniser;
function $1141904df5fd3650$var$RegexTokeniser(rules) {
    rules = rules.map(function(rule) {
        return {
            name: rule.name,
            regex: new RegExp(rule.regex.source, "g")
        };
    });
    function tokenise(input, description) {
        var source = new $1J3fu(input, description);
        var index = 0;
        var tokens = [];
        while(index < input.length){
            var result = readNextToken(input, index, source);
            index = result.endIndex;
            tokens.push(result.token);
        }
        tokens.push(endToken(input, source));
        return tokens;
    }
    function readNextToken(string, startIndex, source) {
        for(var i = 0; i < rules.length; i++){
            var regex = rules[i].regex;
            regex.lastIndex = startIndex;
            var result = regex.exec(string);
            if (result) {
                var endIndex = startIndex + result[0].length;
                if (result.index === startIndex && endIndex > startIndex) {
                    var value = result[1];
                    var token = new $kojsS(rules[i].name, value, source.range(startIndex, endIndex));
                    return {
                        token: token,
                        endIndex: endIndex
                    };
                }
            }
        }
        var endIndex = startIndex + 1;
        var token = new $kojsS("unrecognisedCharacter", string.substring(startIndex, endIndex), source.range(startIndex, endIndex));
        return {
            token: token,
            endIndex: endIndex
        };
    }
    function endToken(input, source) {
        return new $kojsS("end", null, source.range(input.length, input.length));
    }
    return {
        tokenise: tokenise
    };
}

});

parcelRegister("l1uRy", function(module, exports) {

$parcel$export(module.exports, "element", function () { return $f4e1a1a6818c724f$export$8454457683f90105; }, function (v) { return $f4e1a1a6818c724f$export$8454457683f90105 = v; });
var $f4e1a1a6818c724f$export$8454457683f90105;

var $2q3gK = parcelRequire("2q3gK");

var $2bFLC = parcelRequire("2bFLC");
$f4e1a1a6818c724f$export$8454457683f90105 = $f4e1a1a6818c724f$var$element;
function $f4e1a1a6818c724f$var$element(name) {
    return function(html) {
        return $2bFLC.elementWithTag($2q3gK.element(name), [
            html
        ]);
    };
}

});

var $678f6fd52942a696$exports = {};
$parcel$extendImportMap({
    "kinXO": "c1611b73759069af84fe508b2934a3ed5c535559/pdf.worker.min.35975b0a.js",
    "hW73M": "cda.8f0fae79.xsl"
});

/* global CONFIGURATION, setupNewRelic */ var $b073bf4933b0a980$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$b073bf4933b0a980$exports = (parcelRequire("6fXQY"));




function $a646f36963f427e4$export$a6c2d27607295951(stackParser, ex) {
    const frames = $a646f36963f427e4$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $a646f36963f427e4$export$2e9ae379995d99e3(ex),
        value: $a646f36963f427e4$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $a646f36963f427e4$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $b073bf4933b0a980$exports.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $a646f36963f427e4$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $b073bf4933b0a980$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $a646f36963f427e4$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $b073bf4933b0a980$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $a646f36963f427e4$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $a646f36963f427e4$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $a646f36963f427e4$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $a646f36963f427e4$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $a646f36963f427e4$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $a646f36963f427e4$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $a646f36963f427e4$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $a646f36963f427e4$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $a646f36963f427e4$var$getSkipFirstStackStringLines(ex) {
    if (ex && $a646f36963f427e4$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $a646f36963f427e4$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $a646f36963f427e4$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $a646f36963f427e4$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $a646f36963f427e4$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $a646f36963f427e4$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($a646f36963f427e4$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $b073bf4933b0a980$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $b073bf4933b0a980$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
function $a646f36963f427e4$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $a646f36963f427e4$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b073bf4933b0a980$exports.addExceptionMechanism)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $b073bf4933b0a980$exports.resolvedSyncPromise)(event);
}
function $a646f36963f427e4$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $a646f36963f427e4$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $b073bf4933b0a980$exports.resolvedSyncPromise)(event);
}
function $a646f36963f427e4$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $b073bf4933b0a980$exports.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $a646f36963f427e4$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $b073bf4933b0a980$exports.isDOMError)(exception) || (0, $b073bf4933b0a980$exports.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $a646f36963f427e4$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $a646f36963f427e4$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $b073bf4933b0a980$exports.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $b073bf4933b0a980$exports.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $a646f36963f427e4$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $b073bf4933b0a980$exports.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $b073bf4933b0a980$exports.isError)(exception)) return $a646f36963f427e4$var$eventFromError(stackParser, exception);
    if ((0, $b073bf4933b0a980$exports.isPlainObject)(exception) || (0, $b073bf4933b0a980$exports.isEvent)(exception)) {
        const objectException = exception;
        event = $a646f36963f427e4$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $b073bf4933b0a980$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $a646f36963f427e4$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b073bf4933b0a980$exports.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $b073bf4933b0a980$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $a646f36963f427e4$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $a646f36963f427e4$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $b073bf4933b0a980$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $b073bf4933b0a980$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $a646f36963f427e4$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $b073bf4933b0a980$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $b073bf4933b0a980$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $b073bf4933b0a980$exports.isEvent)(exception)) {
        const className = $a646f36963f427e4$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $a646f36963f427e4$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $a646f36963f427e4$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}



const $8c48fcb428d33ad9$export$56d8a8a25bd48b81 = (0, $b073bf4933b0a980$exports.GLOBAL_OBJ);
let $8c48fcb428d33ad9$var$ignoreOnError = 0;
function $8c48fcb428d33ad9$export$b79738ab10c590b2() {
    return $8c48fcb428d33ad9$var$ignoreOnError > 0;
}
function $8c48fcb428d33ad9$export$1265a142ff5ba165() {
    $8c48fcb428d33ad9$var$ignoreOnError++;
    setTimeout(()=>{
        $8c48fcb428d33ad9$var$ignoreOnError--;
    });
}
function $8c48fcb428d33ad9$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $b073bf4933b0a980$exports.getOriginalFunction)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $b073bf4933b0a980$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $b073bf4933b0a980$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$8c48fcb428d33ad9$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $8c48fcb428d33ad9$export$1265a142ff5ba165();
            (0, $b073bf4933b0a980$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $b073bf4933b0a980$exports.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $b073bf4933b0a980$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $b073bf4933b0a980$exports.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $b073bf4933b0a980$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $b073bf4933b0a980$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $b073bf4933b0a980$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $b073bf4933b0a980$exports.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $8c48fcb428d33ad9$export$a3c4a8453e8936f0() {
    const url = (0, $b073bf4933b0a980$exports.getLocationHref)();
    const { referrer: referrer } = $8c48fcb428d33ad9$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $8c48fcb428d33ad9$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


class $f6e68edc2641a721$export$1df9218a526d318d extends (0, $b073bf4933b0a980$exports.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $f6e68edc2641a721$export$4e107b20a7f977(options);
        const sdkSource = (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $b073bf4933b0a980$exports.getSDKSource)();
        (0, $b073bf4933b0a980$exports.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        if ((0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $b073bf4933b0a980$exports._INTERNAL_flushLogsBuffer)(this);
                if (enableMetrics) (0, $b073bf4933b0a980$exports._INTERNAL_flushMetricsBuffer)(this);
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $b073bf4933b0a980$exports.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $a646f36963f427e4$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $a646f36963f427e4$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $f6e68edc2641a721$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}



const $7910e7169ee640e3$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $e6fb95e27b6d19a8$export$31499a9cd224b78c = "10.56.0";


const $3680d3e125893809$export$f1a6cdb1459e81d1 = globalThis;


function $f94fe0325c06ff6e$export$19eade501500c6c1() {
    $f94fe0325c06ff6e$export$c8bfa33e4e8ae492((0, $3680d3e125893809$export$f1a6cdb1459e81d1));
    return 0, $3680d3e125893809$export$f1a6cdb1459e81d1;
}
function $f94fe0325c06ff6e$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $e6fb95e27b6d19a8$export$31499a9cd224b78c);
    return __SENTRY__[0, $e6fb95e27b6d19a8$export$31499a9cd224b78c] = __SENTRY__[0, $e6fb95e27b6d19a8$export$31499a9cd224b78c] || {};
}
function $f94fe0325c06ff6e$export$7e223ec222791509(name, creator, obj = (0, $3680d3e125893809$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $e6fb95e27b6d19a8$export$31499a9cd224b78c] = __SENTRY__[0, $e6fb95e27b6d19a8$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}




const $1f9025cf3cccadf5$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $1f9025cf3cccadf5$var$PREFIX = "Sentry Logger ";
const $1f9025cf3cccadf5$export$77c4ce905194557b = {};
function $1f9025cf3cccadf5$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $3680d3e125893809$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $3680d3e125893809$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($1f9025cf3cccadf5$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $1f9025cf3cccadf5$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $1f9025cf3cccadf5$var$enable() {
    $1f9025cf3cccadf5$var$_getLoggerSettings().enabled = true;
}
function $1f9025cf3cccadf5$var$disable() {
    $1f9025cf3cccadf5$var$_getLoggerSettings().enabled = false;
}
function $1f9025cf3cccadf5$var$isEnabled() {
    return $1f9025cf3cccadf5$var$_getLoggerSettings().enabled;
}
function $1f9025cf3cccadf5$var$log(...args) {
    $1f9025cf3cccadf5$var$_maybeLog("log", ...args);
}
function $1f9025cf3cccadf5$var$warn(...args) {
    $1f9025cf3cccadf5$var$_maybeLog("warn", ...args);
}
function $1f9025cf3cccadf5$var$error(...args) {
    $1f9025cf3cccadf5$var$_maybeLog("error", ...args);
}
function $1f9025cf3cccadf5$var$_maybeLog(level, ...args) {
    if (!(0, $7910e7169ee640e3$export$16a28057038b10ef)) return;
    if ($1f9025cf3cccadf5$var$isEnabled()) $1f9025cf3cccadf5$export$cda52e2a8927a2ca(()=>{
        (0, $3680d3e125893809$export$f1a6cdb1459e81d1).console[level](`${$1f9025cf3cccadf5$var$PREFIX}[${level}]:`, ...args);
    });
}
function $1f9025cf3cccadf5$var$_getLoggerSettings() {
    if (!(0, $7910e7169ee640e3$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $f94fe0325c06ff6e$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $1f9025cf3cccadf5$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $1f9025cf3cccadf5$var$enable,
    disable: /** Disable logging. */ $1f9025cf3cccadf5$var$disable,
    isEnabled: /** Check if logging is enabled. */ $1f9025cf3cccadf5$var$isEnabled,
    log: /** Log a message. */ $1f9025cf3cccadf5$var$log,
    warn: /** Log a warning. */ $1f9025cf3cccadf5$var$warn,
    error: /** Log an error. */ $1f9025cf3cccadf5$var$error
};


const $5bb4cabfa5635a20$var$STACKTRACE_FRAME_LIMIT = 50;
const $5bb4cabfa5635a20$export$27c7e15d453fc0ac = "?";
const $5bb4cabfa5635a20$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $5bb4cabfa5635a20$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $5bb4cabfa5635a20$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $5bb4cabfa5635a20$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($5bb4cabfa5635a20$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $5bb4cabfa5635a20$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $5bb4cabfa5635a20$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $5bb4cabfa5635a20$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $5bb4cabfa5635a20$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $5bb4cabfa5635a20$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($5bb4cabfa5635a20$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($5bb4cabfa5635a20$var$STRIP_FRAME_REGEXP.test($5bb4cabfa5635a20$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($5bb4cabfa5635a20$var$STRIP_FRAME_REGEXP.test($5bb4cabfa5635a20$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $5bb4cabfa5635a20$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $5bb4cabfa5635a20$var$getLastStackFrame(localStack).filename,
            function: frame.function || $5bb4cabfa5635a20$export$27c7e15d453fc0ac
        }));
}
function $5bb4cabfa5635a20$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $5bb4cabfa5635a20$var$defaultFunctionName = "<anonymous>";
function $5bb4cabfa5635a20$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $5bb4cabfa5635a20$var$defaultFunctionName;
        return fn.name || $5bb4cabfa5635a20$var$defaultFunctionName;
    } catch  {
        return $5bb4cabfa5635a20$var$defaultFunctionName;
    }
}
function $5bb4cabfa5635a20$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $5bb4cabfa5635a20$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


const $7e48b28f1a178342$var$handlers = {};
const $7e48b28f1a178342$var$instrumented = {};
function $7e48b28f1a178342$export$a4e09611e30da72e(type, handler) {
    $7e48b28f1a178342$var$handlers[type] = $7e48b28f1a178342$var$handlers[type] || [];
    $7e48b28f1a178342$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $7e48b28f1a178342$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $7e48b28f1a178342$export$b17eab759a1cb5fe() {
    Object.keys($7e48b28f1a178342$var$handlers).forEach((key)=>{
        $7e48b28f1a178342$var$handlers[key] = void 0;
    });
}
function $7e48b28f1a178342$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$7e48b28f1a178342$var$instrumented[type]) {
        $7e48b28f1a178342$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $7910e7169ee640e3$export$16a28057038b10ef) && (0, $1f9025cf3cccadf5$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $7e48b28f1a178342$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $7e48b28f1a178342$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $7910e7169ee640e3$export$16a28057038b10ef) && (0, $1f9025cf3cccadf5$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $5bb4cabfa5635a20$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}



const $2d1ea9cd01cc2fee$var$objectToString = Object.prototype.toString;
function $2d1ea9cd01cc2fee$export$e6127cc7fe7395c3(wat) {
    switch($2d1ea9cd01cc2fee$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $2d1ea9cd01cc2fee$export$49034edbe6b62415(wat, Error);
    }
}
function $2d1ea9cd01cc2fee$var$isBuiltin(wat, className) {
    return $2d1ea9cd01cc2fee$var$objectToString.call(wat) === `[object ${className}]`;
}
function $2d1ea9cd01cc2fee$export$9f9636d330b71954(wat) {
    return $2d1ea9cd01cc2fee$var$isBuiltin(wat, "ErrorEvent");
}
function $2d1ea9cd01cc2fee$export$ef9e2056653f0c8e(wat) {
    return $2d1ea9cd01cc2fee$var$isBuiltin(wat, "DOMError");
}
function $2d1ea9cd01cc2fee$export$12e869b2a583f783(wat) {
    return $2d1ea9cd01cc2fee$var$isBuiltin(wat, "DOMException");
}
function $2d1ea9cd01cc2fee$export$844ec244b1367d54(wat) {
    return $2d1ea9cd01cc2fee$var$isBuiltin(wat, "String");
}
function $2d1ea9cd01cc2fee$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $2d1ea9cd01cc2fee$export$c3825b437cbdea5c(wat) {
    return wat === null || $2d1ea9cd01cc2fee$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $2d1ea9cd01cc2fee$export$53b83ca8eaab0383(wat) {
    return $2d1ea9cd01cc2fee$var$isBuiltin(wat, "Object");
}
function $2d1ea9cd01cc2fee$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $2d1ea9cd01cc2fee$export$49034edbe6b62415(wat, Event);
}
function $2d1ea9cd01cc2fee$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $2d1ea9cd01cc2fee$export$49034edbe6b62415(wat, Element);
}
function $2d1ea9cd01cc2fee$export$49841c62b9eff15(wat) {
    return $2d1ea9cd01cc2fee$var$isBuiltin(wat, "RegExp");
}
function $2d1ea9cd01cc2fee$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $2d1ea9cd01cc2fee$export$bc2894c7158efbac(wat) {
    return $2d1ea9cd01cc2fee$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $2d1ea9cd01cc2fee$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $2d1ea9cd01cc2fee$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $2d1ea9cd01cc2fee$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $2d1ea9cd01cc2fee$export$49034edbe6b62415(request, Request);
}


function $56466368086379a2$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $56466368086379a2$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $7910e7169ee640e3$export$16a28057038b10ef) && (0, $1f9025cf3cccadf5$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $56466368086379a2$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $7910e7169ee640e3$export$16a28057038b10ef) && (0, $1f9025cf3cccadf5$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $56466368086379a2$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $56466368086379a2$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $56466368086379a2$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($56466368086379a2$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $56466368086379a2$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $56466368086379a2$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $56466368086379a2$export$62ff257738bf57f5(value) {
    if ((0, $2d1ea9cd01cc2fee$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$56466368086379a2$var$getOwnProperties(value)
    };
    if ((0, $2d1ea9cd01cc2fee$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$56466368086379a2$var$getOwnProperties(value)
        };
    }
    return value;
}
function $56466368086379a2$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $56466368086379a2$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($56466368086379a2$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $56466368086379a2$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $56466368086379a2$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $56466368086379a2$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($56466368086379a2$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($56466368086379a2$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $56466368086379a2$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $56466368086379a2$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $56466368086379a2$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $2d1ea9cd01cc2fee$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



let $30b3a78241863236$var$RESOLVED_RUNNER;
function $30b3a78241863236$export$ff239213cb80e2da(cb) {
    if ($30b3a78241863236$var$RESOLVED_RUNNER !== void 0) return $30b3a78241863236$var$RESOLVED_RUNNER ? $30b3a78241863236$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $3680d3e125893809$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $30b3a78241863236$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $30b3a78241863236$var$RESOLVED_RUNNER(cb);
    }
    $30b3a78241863236$var$RESOLVED_RUNNER = null;
    return cb();
}
function $30b3a78241863236$export$9869d72de32a3917() {
    return $30b3a78241863236$export$ff239213cb80e2da(()=>Math.random());
}
function $30b3a78241863236$export$65b1bada40c91b34() {
    return $30b3a78241863236$export$ff239213cb80e2da(()=>Date.now());
}




const $7c311601e8ce5848$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $7c311601e8ce5848$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $7c311601e8ce5848$export$280812de8e91ea53(obj) {
    (0, $56466368086379a2$export$e73679ffaf56810e)(obj, $7c311601e8ce5848$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $7c311601e8ce5848$export$610d1422c4bdc4c1(obj, depth) {
    (0, $56466368086379a2$export$e73679ffaf56810e)(obj, $7c311601e8ce5848$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $7c311601e8ce5848$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$7c311601e8ce5848$var$SENTRY_SKIP_NORMALIZATION]);
}
function $7c311601e8ce5848$export$fe95a19841c4b155(value) {
    const v = value[$7c311601e8ce5848$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}




let $622be04b0f284d9c$var$stringifier;
function $622be04b0f284d9c$export$575c40989754ba4d(newStringifier) {
    $622be04b0f284d9c$var$stringifier = newStringifier;
}
function $622be04b0f284d9c$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $622be04b0f284d9c$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $622be04b0f284d9c$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $622be04b0f284d9c$export$a3295358bff77e(object, depth);
    if ($622be04b0f284d9c$var$jsonSize(normalized) > maxSize) return $622be04b0f284d9c$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $622be04b0f284d9c$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $622be04b0f284d9c$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $622be04b0f284d9c$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $7c311601e8ce5848$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $7c311601e8ce5848$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $622be04b0f284d9c$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $56466368086379a2$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $622be04b0f284d9c$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $622be04b0f284d9c$export$a110e5bc79f44a84(key, value) {
    try {
        if ($622be04b0f284d9c$var$stringifier) {
            const stringified = $622be04b0f284d9c$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $5bb4cabfa5635a20$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $622be04b0f284d9c$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $622be04b0f284d9c$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $622be04b0f284d9c$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $622be04b0f284d9c$var$jsonSize(value) {
    return $622be04b0f284d9c$var$utf8Length(JSON.stringify(value));
}
function $622be04b0f284d9c$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $622be04b0f284d9c$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $80daf55d56969ce0$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $80daf55d56969ce0$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $80daf55d56969ce0$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $2d1ea9cd01cc2fee$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $622be04b0f284d9c$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $80daf55d56969ce0$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $2d1ea9cd01cc2fee$export$844ec244b1367d54)(value)) return false;
    if ((0, $2d1ea9cd01cc2fee$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $2d1ea9cd01cc2fee$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $80daf55d56969ce0$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($80daf55d56969ce0$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $0c9a2cc6a8e57ead$var$getCrypto() {
    const gbl = (0, $3680d3e125893809$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $0c9a2cc6a8e57ead$var$emptyUuid;
function $0c9a2cc6a8e57ead$var$getRandomByte() {
    return (0, $30b3a78241863236$export$9869d72de32a3917)() * 16;
}
function $0c9a2cc6a8e57ead$export$19f53698e68b2496(crypto = $0c9a2cc6a8e57ead$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $30b3a78241863236$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$0c9a2cc6a8e57ead$var$emptyUuid) $0c9a2cc6a8e57ead$var$emptyUuid = "10000000100040008000100000000000";
    return $0c9a2cc6a8e57ead$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($0c9a2cc6a8e57ead$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $0c9a2cc6a8e57ead$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $0c9a2cc6a8e57ead$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $0c9a2cc6a8e57ead$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $0c9a2cc6a8e57ead$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $0c9a2cc6a8e57ead$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $0c9a2cc6a8e57ead$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $0c9a2cc6a8e57ead$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $0c9a2cc6a8e57ead$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $0c9a2cc6a8e57ead$export$d364f2020ab30578(input) {
    const match = input.match($0c9a2cc6a8e57ead$var$SEMVER_REGEXP) || [];
    const major = $0c9a2cc6a8e57ead$var$_parseInt(match[1]);
    const minor = $0c9a2cc6a8e57ead$var$_parseInt(match[2]);
    const patch = $0c9a2cc6a8e57ead$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $0c9a2cc6a8e57ead$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $80daf55d56969ce0$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $80daf55d56969ce0$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $80daf55d56969ce0$export$4215662d762d6f9d)(line, 0));
}
function $0c9a2cc6a8e57ead$export$6de4ffac6a2f1098(exception) {
    if ($0c9a2cc6a8e57ead$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $56466368086379a2$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $0c9a2cc6a8e57ead$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}



const $7cecaea49413b9ae$export$56d8a8a25bd48b81 = (0, $3680d3e125893809$export$f1a6cdb1459e81d1);


const $b0053120e810c9d4$var$DEBOUNCE_DURATION = 1e3;
let $b0053120e810c9d4$var$debounceTimerID;
let $b0053120e810c9d4$var$lastCapturedEventType;
let $b0053120e810c9d4$var$lastCapturedEventTargetId;
function $b0053120e810c9d4$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $7e48b28f1a178342$export$a4e09611e30da72e)(type, handler);
    (0, $7e48b28f1a178342$export$e18d6c5462c01368)(type, $b0053120e810c9d4$export$3014bbf0af0e1d4a);
}
function $b0053120e810c9d4$export$3014bbf0af0e1d4a() {
    if (!(0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $7e48b28f1a178342$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $b0053120e810c9d4$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $7cecaea49413b9ae$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $56466368086379a2$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $b0053120e810c9d4$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $56466368086379a2$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $b0053120e810c9d4$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $b0053120e810c9d4$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $b0053120e810c9d4$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $b0053120e810c9d4$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $b0053120e810c9d4$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $b0053120e810c9d4$var$getEventTarget(event);
        if ($b0053120e810c9d4$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $56466368086379a2$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $56466368086379a2$export$e73679ffaf56810e)(target, "_sentryId", (0, $0c9a2cc6a8e57ead$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$b0053120e810c9d4$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $b0053120e810c9d4$var$lastCapturedEventType = event.type;
            $b0053120e810c9d4$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($b0053120e810c9d4$var$debounceTimerID);
        $b0053120e810c9d4$var$debounceTimerID = (0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).setTimeout(()=>{
            $b0053120e810c9d4$var$lastCapturedEventTargetId = void 0;
            $b0053120e810c9d4$var$lastCapturedEventType = void 0;
        }, $b0053120e810c9d4$var$DEBOUNCE_DURATION);
    };
}
function $b0053120e810c9d4$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}




const $f83b1c1eaa7a807b$var$WINDOW = (0, $3680d3e125893809$export$f1a6cdb1459e81d1);
function $f83b1c1eaa7a807b$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $f83b1c1eaa7a807b$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $f83b1c1eaa7a807b$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $f83b1c1eaa7a807b$export$67fc34576016d6ec() {
    return "history" in $f83b1c1eaa7a807b$var$WINDOW && !!$f83b1c1eaa7a807b$var$WINDOW.history;
}
const $f83b1c1eaa7a807b$export$edf3cb81fd7d2a3e = $f83b1c1eaa7a807b$var$_isFetchSupported;
function $f83b1c1eaa7a807b$var$_isFetchSupported() {
    if (!("fetch" in $f83b1c1eaa7a807b$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $f83b1c1eaa7a807b$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $f83b1c1eaa7a807b$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$f83b1c1eaa7a807b$var$_isFetchSupported()) return false;
    if ($f83b1c1eaa7a807b$export$d5f608b368e73f38($f83b1c1eaa7a807b$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $f83b1c1eaa7a807b$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $f83b1c1eaa7a807b$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $7910e7169ee640e3$export$16a28057038b10ef) && (0, $1f9025cf3cccadf5$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $f83b1c1eaa7a807b$export$531055a6c684a70a() {
    return "ReportingObserver" in $f83b1c1eaa7a807b$var$WINDOW;
}
function $f83b1c1eaa7a807b$export$2d308b428295192f() {
    if (!$f83b1c1eaa7a807b$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}



let $ebc5cee5cf428c77$var$lastHref;
function $ebc5cee5cf428c77$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $7e48b28f1a178342$export$a4e09611e30da72e)(type, handler);
    (0, $7e48b28f1a178342$export$e18d6c5462c01368)(type, $ebc5cee5cf428c77$export$d9b613a6254a184e);
}
function $ebc5cee5cf428c77$export$d9b613a6254a184e() {
    (0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).location.href;
        const from = $ebc5cee5cf428c77$var$lastHref;
        $ebc5cee5cf428c77$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $7e48b28f1a178342$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $f83b1c1eaa7a807b$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $ebc5cee5cf428c77$var$lastHref;
                const to = $ebc5cee5cf428c77$var$getAbsoluteUrl(String(url));
                $ebc5cee5cf428c77$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $7e48b28f1a178342$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $56466368086379a2$export$9563e054e6f787fb)((0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $56466368086379a2$export$9563e054e6f787fb)((0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $ebc5cee5cf428c77$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}



const $8e6c651fcfe4fd47$var$ONE_SECOND_IN_MS = 1e3;
function $8e6c651fcfe4fd47$export$7740643b9eeaf0c4() {
    return (0, $30b3a78241863236$export$65b1bada40c91b34)() / $8e6c651fcfe4fd47$var$ONE_SECOND_IN_MS;
}
function $8e6c651fcfe4fd47$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $3680d3e125893809$export$f1a6cdb1459e81d1);
    if (!performance?.now || !performance.timeOrigin) return $8e6c651fcfe4fd47$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $30b3a78241863236$export$ff239213cb80e2da)(()=>performance.now())) / $8e6c651fcfe4fd47$var$ONE_SECOND_IN_MS;
    };
}
let $8e6c651fcfe4fd47$var$_cachedTimestampInSeconds;
function $8e6c651fcfe4fd47$export$ee52dced521e3e18() {
    const func = $8e6c651fcfe4fd47$var$_cachedTimestampInSeconds ?? ($8e6c651fcfe4fd47$var$_cachedTimestampInSeconds = $8e6c651fcfe4fd47$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $8e6c651fcfe4fd47$var$cachedTimeOrigin = null;
function $8e6c651fcfe4fd47$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $3680d3e125893809$export$f1a6cdb1459e81d1);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $30b3a78241863236$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $30b3a78241863236$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $8e6c651fcfe4fd47$export$baf075a948ffc0bf() {
    if ($8e6c651fcfe4fd47$var$cachedTimeOrigin === null) $8e6c651fcfe4fd47$var$cachedTimeOrigin = $8e6c651fcfe4fd47$var$getBrowserTimeOrigin();
    return $8e6c651fcfe4fd47$var$cachedTimeOrigin;
}



const $2df0ac08a6a0630d$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $2df0ac08a6a0630d$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $7e48b28f1a178342$export$a4e09611e30da72e)(type, handler);
    (0, $7e48b28f1a178342$export$e18d6c5462c01368)(type, $2df0ac08a6a0630d$export$c67d533bf77cbf54);
}
function $2df0ac08a6a0630d$export$c67d533bf77cbf54() {
    if (!(0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const virtualError = new Error();
            const startTimestamp = (0, $8e6c651fcfe4fd47$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $2d1ea9cd01cc2fee$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $2df0ac08a6a0630d$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$2df0ac08a6a0630d$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$2df0ac08a6a0630d$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $8e6c651fcfe4fd47$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $7e48b28f1a178342$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$2df0ac08a6a0630d$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $2d1ea9cd01cc2fee$export$844ec244b1367d54)(header) && (0, $2d1ea9cd01cc2fee$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$2df0ac08a6a0630d$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $8e6c651fcfe4fd47$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $7e48b28f1a178342$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $2df0ac08a6a0630d$var$parseXhrUrlArg(url) {
    if ((0, $2d1ea9cd01cc2fee$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}


const $66d7fe846cafdd7f$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $66d7fe846cafdd7f$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $66d7fe846cafdd7f$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $66d7fe846cafdd7f$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $66d7fe846cafdd7f$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $2d1ea9cd01cc2fee$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}


const $9e5249435ea722e8$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $62af16a5fab52797$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $62af16a5fab52797$var$INTEGRATION_NAME = "Breadcrumbs";
const $62af16a5fab52797$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $62af16a5fab52797$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $b073bf4933b0a980$exports.addConsoleInstrumentationHandler)($62af16a5fab52797$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $b0053120e810c9d4$export$5aeffd3db2cf9df7)($62af16a5fab52797$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $2df0ac08a6a0630d$export$26ace48dd54c9aea)($62af16a5fab52797$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $b073bf4933b0a980$exports.addFetchInstrumentationHandler)($62af16a5fab52797$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $ebc5cee5cf428c77$export$3f18c56c58114e75)($62af16a5fab52797$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $62af16a5fab52797$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $62af16a5fab52797$export$c079d904b326663a = (0, $b073bf4933b0a980$exports.defineIntegration)($62af16a5fab52797$var$_breadcrumbsIntegration);
function $62af16a5fab52797$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $b073bf4933b0a980$exports.getClient)() !== client) return;
        (0, $b073bf4933b0a980$exports.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $b073bf4933b0a980$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $62af16a5fab52797$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $b073bf4933b0a980$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $62af16a5fab52797$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $9e5249435ea722e8$export$16a28057038b10ef) && (0, $b073bf4933b0a980$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$62af16a5fab52797$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$62af16a5fab52797$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $62af16a5fab52797$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $62af16a5fab52797$var$_isEvent(event) ? event.target : event;
            target = (0, $66d7fe846cafdd7f$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $b073bf4933b0a980$exports.getComponentName)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $b073bf4933b0a980$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $62af16a5fab52797$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $b073bf4933b0a980$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $b073bf4933b0a980$exports.severityLevelFromString)(handlerData.level),
            message: (0, $b073bf4933b0a980$exports.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $b073bf4933b0a980$exports.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $b073bf4933b0a980$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $62af16a5fab52797$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $b073bf4933b0a980$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $2df0ac08a6a0630d$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $b073bf4933b0a980$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $b073bf4933b0a980$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
function $62af16a5fab52797$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $b073bf4933b0a980$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $b073bf4933b0a980$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $b073bf4933b0a980$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $b073bf4933b0a980$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
function $62af16a5fab52797$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $b073bf4933b0a980$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $b073bf4933b0a980$exports.parseUrl)((0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $b073bf4933b0a980$exports.parseUrl)(from) : void 0;
        const parsedTo = (0, $b073bf4933b0a980$exports.parseUrl)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $b073bf4933b0a980$exports.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $62af16a5fab52797$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $f1e42a35db8952ed$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $f1e42a35db8952ed$var$INTEGRATION_NAME = "BrowserApiErrors";
const $f1e42a35db8952ed$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $f1e42a35db8952ed$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $b073bf4933b0a980$exports.fill)((0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81), "setTimeout", $f1e42a35db8952ed$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $b073bf4933b0a980$exports.fill)((0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81), "setInterval", $f1e42a35db8952ed$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $b073bf4933b0a980$exports.fill)((0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81), "requestAnimationFrame", $f1e42a35db8952ed$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81)) (0, $b073bf4933b0a980$exports.fill)(XMLHttpRequest.prototype, "send", $f1e42a35db8952ed$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $f1e42a35db8952ed$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$f1e42a35db8952ed$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $f1e42a35db8952ed$export$59bfe9f1c76150e = (0, $b073bf4933b0a980$exports.defineIntegration)($f1e42a35db8952ed$var$_browserApiErrorsIntegration);
function $f1e42a35db8952ed$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $8c48fcb428d33ad9$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $b073bf4933b0a980$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $f1e42a35db8952ed$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $8c48fcb428d33ad9$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $b073bf4933b0a980$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $f1e42a35db8952ed$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $b073bf4933b0a980$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $b073bf4933b0a980$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $b073bf4933b0a980$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $b073bf4933b0a980$exports.getFunctionName)(originalFunction);
                return (0, $8c48fcb428d33ad9$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $f1e42a35db8952ed$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $b073bf4933b0a980$exports.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($f1e42a35db8952ed$var$isEventListenerObject(fn)) fn.handleEvent = (0, $8c48fcb428d33ad9$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $b073bf4933b0a980$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $f1e42a35db8952ed$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $8c48fcb428d33ad9$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $b073bf4933b0a980$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $b073bf4933b0a980$exports.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $f1e42a35db8952ed$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $f1e42a35db8952ed$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}






const $1c08d11d128a43b3$export$1baa7880e357371c = (0, $b073bf4933b0a980$exports.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $9e5249435ea722e8$export$16a28057038b10ef) && (0, $b073bf4933b0a980$exports.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $b073bf4933b0a980$exports.startSession)({
                ignoreDuration: true
            });
            (0, $b073bf4933b0a980$exports.captureSession)();
            const isolationScope = (0, $b073bf4933b0a980$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    (0, $b073bf4933b0a980$exports.captureSession)();
                    previousUser = maybeNewUser;
                }
            });
            if (lifecycle === "route") (0, $ebc5cee5cf428c77$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $b073bf4933b0a980$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $b073bf4933b0a980$exports.captureSession)();
                }
            });
        }
    };
});




const $ae42735744fb59ea$var$INTEGRATION_NAME = "CultureContext";
const $ae42735744fb59ea$var$_cultureContextIntegration = ()=>{
    return {
        name: $ae42735744fb59ea$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $ae42735744fb59ea$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $ae42735744fb59ea$var$getCultureContext();
            if (culture) (0, $b073bf4933b0a980$exports.safeSetSpanJSONAttributes)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $ae42735744fb59ea$export$ec5976aacdc85985 = (0, $b073bf4933b0a980$exports.defineIntegration)($ae42735744fb59ea$var$_cultureContextIntegration);
function $ae42735744fb59ea$var$getCultureContext() {
    try {
        const intl = (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}






const $23119dd2ed8ed32e$var$INTEGRATION_NAME = "GlobalHandlers";
const $23119dd2ed8ed32e$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $23119dd2ed8ed32e$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $23119dd2ed8ed32e$var$_installGlobalOnErrorHandler(client);
                $23119dd2ed8ed32e$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $23119dd2ed8ed32e$var$_installGlobalOnUnhandledRejectionHandler(client);
                $23119dd2ed8ed32e$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $23119dd2ed8ed32e$export$66acc70e8cf2b71a = (0, $b073bf4933b0a980$exports.defineIntegration)($23119dd2ed8ed32e$var$_globalHandlersIntegration);
function $23119dd2ed8ed32e$var$_installGlobalOnErrorHandler(client) {
    (0, $b073bf4933b0a980$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $23119dd2ed8ed32e$var$getOptions();
        if ((0, $b073bf4933b0a980$exports.getClient)() !== client || (0, $8c48fcb428d33ad9$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $23119dd2ed8ed32e$var$_enhanceEventWithInitialFrame((0, $a646f36963f427e4$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $b073bf4933b0a980$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $23119dd2ed8ed32e$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $b073bf4933b0a980$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $23119dd2ed8ed32e$var$getOptions();
        if ((0, $b073bf4933b0a980$exports.getClient)() !== client || (0, $8c48fcb428d33ad9$export$b79738ab10c590b2)()) return;
        const error = $23119dd2ed8ed32e$export$b2cc40fa8241780(e);
        const event = (0, $b073bf4933b0a980$exports.isPrimitive)(error) ? $23119dd2ed8ed32e$export$1353b5b36844a9ed(error) : (0, $a646f36963f427e4$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $b073bf4933b0a980$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $23119dd2ed8ed32e$export$b2cc40fa8241780(error) {
    if ((0, $b073bf4933b0a980$exports.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $23119dd2ed8ed32e$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $23119dd2ed8ed32e$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $23119dd2ed8ed32e$var$getFilenameFromUrl(url) ?? (0, $b073bf4933b0a980$exports.getLocationHref)(),
        function: (0, $b073bf4933b0a980$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $23119dd2ed8ed32e$var$globalHandlerLog(type) {
    (0, $9e5249435ea722e8$export$16a28057038b10ef) && (0, $b073bf4933b0a980$exports.debug).log(`Global Handler attached: ${type}`);
}
function $23119dd2ed8ed32e$var$getOptions() {
    const client = (0, $b073bf4933b0a980$exports.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $23119dd2ed8ed32e$var$getFilenameFromUrl(url) {
    if (!(0, $b073bf4933b0a980$exports.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $b073bf4933b0a980$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}




const $b95fa410234c4580$export$1378794447170364 = (0, $b073bf4933b0a980$exports.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            if (!(0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).navigator && !(0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).location && !(0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $8c48fcb428d33ad9$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSegmentSpan (span) {
            if (!(0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).navigator && !(0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).location && !(0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $8c48fcb428d33ad9$export$a3c4a8453e8936f0)();
            (0, $b073bf4933b0a980$exports.safeSetSpanJSONAttributes)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                "url.full": reqData.url || void 0,
                "http.request.header.user_agent": reqData.headers["User-Agent"],
                "http.request.header.referer": reqData.headers["Referer"]
            });
        }
    };
});




const $4f384e9791120df1$var$DEFAULT_KEY = "cause";
const $4f384e9791120df1$var$DEFAULT_LIMIT = 5;
const $4f384e9791120df1$var$INTEGRATION_NAME = "LinkedErrors";
const $4f384e9791120df1$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $4f384e9791120df1$var$DEFAULT_LIMIT;
    const key = options.key || $4f384e9791120df1$var$DEFAULT_KEY;
    return {
        name: $4f384e9791120df1$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $b073bf4933b0a980$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $a646f36963f427e4$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $4f384e9791120df1$export$ebabb00eb7f3a395 = (0, $b073bf4933b0a980$exports.defineIntegration)($4f384e9791120df1$var$_linkedErrorsIntegration);



const $722e9dde38cc7959$var$OPERA10_PRIORITY = 10;
const $722e9dde38cc7959$var$OPERA11_PRIORITY = 20;
const $722e9dde38cc7959$var$CHROME_PRIORITY = 30;
const $722e9dde38cc7959$var$WINJS_PRIORITY = 40;
const $722e9dde38cc7959$var$GECKO_PRIORITY = 50;
function $722e9dde38cc7959$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $b073bf4933b0a980$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $722e9dde38cc7959$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $722e9dde38cc7959$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $722e9dde38cc7959$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $722e9dde38cc7959$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $722e9dde38cc7959$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($722e9dde38cc7959$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $722e9dde38cc7959$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $722e9dde38cc7959$var$createFrame(filename, (0, $b073bf4933b0a980$exports.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $722e9dde38cc7959$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $722e9dde38cc7959$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $722e9dde38cc7959$var$extractSafariExtensionDetails(parts[1] || (0, $b073bf4933b0a980$exports.UNKNOWN_FUNCTION), parts[2]);
        return $722e9dde38cc7959$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $722e9dde38cc7959$export$263a749fff749872 = [
    $722e9dde38cc7959$var$CHROME_PRIORITY,
    $722e9dde38cc7959$var$chromeStackParserFn
];
const $722e9dde38cc7959$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $722e9dde38cc7959$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $722e9dde38cc7959$var$gecko = (line)=>{
    const parts = $722e9dde38cc7959$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $722e9dde38cc7959$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $b073bf4933b0a980$exports.UNKNOWN_FUNCTION);
        [func, filename] = $722e9dde38cc7959$var$extractSafariExtensionDetails(func, filename);
        return $722e9dde38cc7959$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $722e9dde38cc7959$export$cdba47a5dd2804d = [
    $722e9dde38cc7959$var$GECKO_PRIORITY,
    $722e9dde38cc7959$var$gecko
];
const $722e9dde38cc7959$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $722e9dde38cc7959$var$winjs = (line)=>{
    const parts = $722e9dde38cc7959$var$winjsRegex.exec(line);
    return parts ? $722e9dde38cc7959$var$createFrame(parts[2], parts[1] || (0, $b073bf4933b0a980$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $722e9dde38cc7959$export$179460296da408e8 = [
    $722e9dde38cc7959$var$WINJS_PRIORITY,
    $722e9dde38cc7959$var$winjs
];
const $722e9dde38cc7959$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $722e9dde38cc7959$var$opera10 = (line)=>{
    const parts = $722e9dde38cc7959$var$opera10Regex.exec(line);
    return parts ? $722e9dde38cc7959$var$createFrame(parts[2], parts[3] || (0, $b073bf4933b0a980$exports.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $722e9dde38cc7959$export$f892b52c880ffc7a = [
    $722e9dde38cc7959$var$OPERA10_PRIORITY,
    $722e9dde38cc7959$var$opera10
];
const $722e9dde38cc7959$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $722e9dde38cc7959$var$opera11 = (line)=>{
    const parts = $722e9dde38cc7959$var$opera11Regex.exec(line);
    return parts ? $722e9dde38cc7959$var$createFrame(parts[5], parts[3] || parts[4] || (0, $b073bf4933b0a980$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $722e9dde38cc7959$export$af11af13f09fb0dc = [
    $722e9dde38cc7959$var$OPERA11_PRIORITY,
    $722e9dde38cc7959$var$opera11
];
const $722e9dde38cc7959$export$7197c0fe6554c079 = [
    $722e9dde38cc7959$export$263a749fff749872,
    $722e9dde38cc7959$export$cdba47a5dd2804d
];
const $722e9dde38cc7959$export$2b2b997d81bf3907 = (0, $b073bf4933b0a980$exports.createStackParser)(...$722e9dde38cc7959$export$7197c0fe6554c079);
const $722e9dde38cc7959$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $b073bf4933b0a980$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




const $f467f7904dd50dc6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $3fd1d21ba6cef3ad$var$cachedImplementations = {};
function $3fd1d21ba6cef3ad$export$e464f4a514ac28a8(name) {
    const cached = $3fd1d21ba6cef3ad$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $7cecaea49413b9ae$export$56d8a8a25bd48b81)[name];
    if ((0, $f83b1c1eaa7a807b$export$d5f608b368e73f38)(impl)) return $3fd1d21ba6cef3ad$var$cachedImplementations[name] = impl.bind((0, $7cecaea49413b9ae$export$56d8a8a25bd48b81));
    const document = (0, $7cecaea49413b9ae$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $f467f7904dd50dc6$export$16a28057038b10ef) && (0, $1f9025cf3cccadf5$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $3fd1d21ba6cef3ad$var$cachedImplementations[name] = impl.bind((0, $7cecaea49413b9ae$export$56d8a8a25bd48b81));
}
function $3fd1d21ba6cef3ad$export$8aa36702e8c8978(name) {
    $3fd1d21ba6cef3ad$var$cachedImplementations[name] = void 0;
}
function $3fd1d21ba6cef3ad$export$e7aa7bc5c1b3cfb3(...rest) {
    return $3fd1d21ba6cef3ad$export$e464f4a514ac28a8("fetch")(...rest);
}
function $3fd1d21ba6cef3ad$export$831dc9f2ab0a617b(...rest) {
    return $3fd1d21ba6cef3ad$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $9482b9004bfd4fcc$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $9482b9004bfd4fcc$export$b2311068c46d7cc8(options, nativeFetch = (0, $3fd1d21ba6cef3ad$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $3fd1d21ba6cef3ad$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $b073bf4933b0a980$exports.createTransport)(options, makeRequest, (0, $b073bf4933b0a980$exports.makePromiseBuffer)(options.bufferSize || $9482b9004bfd4fcc$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $3a359f6e5c348888$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $3c8d89476dd790f5$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $3c8d89476dd790f5$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $3a359f6e5c348888$export$45a5e7f76e0caa8d)(value)) {
        const objName = $3c8d89476dd790f5$var$getConstructorName(value);
        if ($3c8d89476dd790f5$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $66d7fe846cafdd7f$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $3c8d89476dd790f5$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}





function $7cb81745451ea2a4$export$dc236a86065879fc() {
    if ($7cb81745451ea2a4$var$_isEmbeddedBrowserExtension()) {
        if (0, $9e5249435ea722e8$export$16a28057038b10ef) (0, $b073bf4933b0a980$exports.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $7cb81745451ea2a4$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $b073bf4933b0a980$exports.getLocationHref)();
    const isDedicatedExtensionPage = (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81) === (0, $8c48fcb428d33ad9$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $fb9aa293de3186c7$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $b073bf4933b0a980$exports.inboundFiltersIntegration)(),
        (0, $b073bf4933b0a980$exports.functionToStringIntegration)(),
        (0, $b073bf4933b0a980$exports.conversationIdIntegration)(),
        (0, $f1e42a35db8952ed$export$59bfe9f1c76150e)(),
        (0, $62af16a5fab52797$export$c079d904b326663a)(),
        (0, $23119dd2ed8ed32e$export$66acc70e8cf2b71a)(),
        (0, $4f384e9791120df1$export$ebabb00eb7f3a395)(),
        (0, $b073bf4933b0a980$exports.dedupeIntegration)(),
        (0, $b95fa410234c4580$export$1378794447170364)(),
        (0, $ae42735744fb59ea$export$ec5976aacdc85985)(),
        (0, $1c08d11d128a43b3$export$1baa7880e357371c)()
    ];
}
function $fb9aa293de3186c7$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $7cb81745451ea2a4$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $fb9aa293de3186c7$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $b073bf4933b0a980$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $722e9dde38cc7959$export$2b2b997d81bf3907)),
        integrations: (0, $b073bf4933b0a980$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $9482b9004bfd4fcc$export$b2311068c46d7cc8)
    };
    (0, $b073bf4933b0a980$exports.setNormalizeStringifier)((0, $3c8d89476dd790f5$export$4c88c355e6072df5));
    return (0, $b073bf4933b0a980$exports.initAndBind)((0, $f6e68edc2641a721$export$1df9218a526d318d), clientOptions);
}
function $fb9aa293de3186c7$export$a3f323d81eede727() {}
function $fb9aa293de3186c7$export$4e4d8b287d028b6b(callback) {
    callback();
}


// Development: Parcel compiles Elm via @parcel/transformer-elm
var $b9e750d20bbc1f0f$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return n(r, t, e, u, a, i, c);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return n(r, t, e, u, a, i, c, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return n(r, t, e, u, a, i, c, o, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, c) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, c) : n(r)(t)(e)(u)(a)(i)(c);
    }
    function A8(n, r, t, e, u, a, i, c, o) {
        return 8 === n.a ? n.f(r, t, e, u, a, i, c, o) : n(r)(t)(e)(u)(a)(i)(c)(o);
    }
    function A9(n, r, t, e, u, a, i, c, o, f) {
        return 9 === n.a ? n.f(r, t, e, u, a, i, c, o, f) : n(r)(t)(e)(u)(a)(i)(c)(o)(f);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, v(t, r);
    }), u = F2(function(n, r) {
        return r[n];
    });
    function a(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function i(n, r) {
        for(var t, e = [], u = c(n, r, 0, e); u && (t = e.pop()); u = c(t.a, t.b, 0, e));
        return u;
    }
    function c(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && a(5), !1;
        if (t > 100) return e.push(v(n, r)), !0;
        for(var u in 0 > n.$ && (n = Ut(n), r = Ut(r)), n)if (!c(n[u], r[u], t + 1, e)) return !1;
        return !0;
    }
    var o = F2(i), f = F2(function(n, r) {
        return !i(n, r);
    });
    function s(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = s(n.a, r.a)) || (t = s(n.b, r.b)) ? t : s(n.c, r.c);
        for(; n.b && r.b && !(t = s(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var l = F2(function(n, r) {
        return 1 > s(n, r);
    }), d = F2(function(n, r) {
        var t = s(n, r);
        return 0 > t ? Xt : t ? Wt : Kt;
    });
    function v(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function b(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function m(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var p = F2($);
    function $(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = h(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = h(n.a, r);
        return t;
    }
    var g = {
        $: 0
    };
    function h(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var y = F2(h);
    function w(n) {
        for(var r = g, t = n.length; t--;)r = h(n[t], r);
        return r;
    }
    function x(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var _ = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return w(e);
    }), C = F2(function(n, r) {
        return w(x(r).sort(function(r, t) {
            return s(n(r), n(t));
        }));
    }), A = F2(function(n, r) {
        return w(x(r).sort(function(r, t) {
            var e = A2(n, r, t);
            return e === Kt ? 0 : e === Xt ? -1 : 1;
        }));
    }), k = F2(function(n, r) {
        return n + r;
    }), E = F2(function(n, r) {
        return n * r;
    }), q = F2(Math.pow), F = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? a(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), j = Math.ceil, D = Math.floor, V = Math.round, B = Math.log, G = isNaN, z = F2(function(n, r) {
        return n + r;
    }), S = F2(function(n, r) {
        return n + r;
    }), T = F2(function(n, r) {
        for(var t = r.length, e = Array(t), u = 0; t > u;){
            var a = r.charCodeAt(u);
            55296 > a || a > 56319 ? (e[u] = n(r[u]), u++) : (e[u] = n(r[u] + r[u + 1]), u += 2);
        }
        return e.join("");
    }), P = F2(function(n, r) {
        for(var t = [], e = r.length, u = 0; e > u;){
            var a = r[u], i = r.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += r[u], u++), n(a) && t.push(a);
        }
        return t.join("");
    }), Z = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], a = t.charCodeAt(e);
            56320 > a || a > 57343 || (u = t[--e] + u), r = A2(n, u, r);
        }
        return r;
    }), M = F2(function(n, r) {
        return r.split(n);
    }), L = F2(function(n, r) {
        return r.join(n);
    }), N = F3(function(n, r, t) {
        return t.slice(n, r);
    }), H = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(e)) return !1;
        }
        return !0;
    }), I = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), O = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), Q = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    }), R = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return g;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return w(u);
    });
    function U(n) {
        return n + "";
    }
    function K(n) {
        return {
            $: 2,
            b: n
        };
    }
    var W = K(function(n) {
        return "number" != typeof n ? pn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? te(n) : !isFinite(n) || n % 1 ? pn("an INT", n) : te(n);
    }), X = K(function(n) {
        return "boolean" == typeof n ? te(n) : pn("a BOOL", n);
    }), Y = K(function(n) {
        return "number" == typeof n ? te(n) : pn("a FLOAT", n);
    }), J = K(function(n) {
        return te(n);
    }), nn = K(function(n) {
        return "string" == typeof n ? te(n) : n instanceof String ? te(n + "") : pn("a STRING", n);
    }), rn = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    }), tn = F2(function(n, r) {
        return {
            $: 7,
            e: n,
            b: r
        };
    });
    function en(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var un = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), an = F2(function(n, r) {
        return en(n, [
            r
        ]);
    }), cn = F3(function(n, r, t) {
        return en(n, [
            r,
            t
        ]);
    }), on = F4(function(n, r, t, e) {
        return en(n, [
            r,
            t,
            e
        ]);
    }), fn = F6(function(n, r, t, e, u, a) {
        return en(n, [
            r,
            t,
            e,
            u,
            a
        ]);
    }), sn = F2(function(n, r) {
        try {
            return dn(n, JSON.parse(r));
        } catch (n) {
            return Yt(A2(Jt, "This is not valid JSON! " + n.message, r));
        }
    }), ln = F2(function(n, r) {
        return dn(n, r);
    });
    function dn(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? te(n.c) : pn("null", r);
            case 3:
                return bn(r) ? vn(n.b, r, w) : pn("a LIST", r);
            case 4:
                return bn(r) ? vn(n.b, r, mn) : pn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return pn("an OBJECT with a field named `" + t + "`", r);
                var e = dn(n.b, r[t]);
                return Je(e) ? e : Yt(A2(ne, t, e.a));
            case 7:
                var u = n.e;
                return bn(r) ? r.length > u ? (e = dn(n.b, r[u]), Je(e) ? e : Yt(A2(re, u, e.a))) : pn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : pn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || bn(r)) return pn("an OBJECT", r);
                var a = g;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = dn(n.b, r[i]), !Je(e)) return Yt(A2(ne, i, e.a));
                    a = h(v(i, e.a), a);
                }
                return te(Ae(a));
            case 9:
                for(var c = n.f, o = n.g, f = 0; o.length > f; f++){
                    if (e = dn(o[f], r), !Je(e)) return e;
                    c = c(e.a);
                }
                return te(c);
            case 10:
                return e = dn(n.b, r), Je(e) ? dn(n.h(e.a), r) : e;
            case 11:
                for(var s = g, l = n.g; l.b; l = l.b){
                    if (e = dn(l.a, r), Je(e)) return e;
                    s = h(e.a, s);
                }
                return Yt(ee(Ae(s)));
            case 1:
                return Yt(A2(Jt, n.a, r));
            case 0:
                return te(n.a);
        }
    }
    function vn(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = dn(n, r[a]);
            if (!Je(i)) return Yt(A2(re, a, i.a));
            u[a] = i.a;
        }
        return te(t(u));
    }
    function bn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function mn(n) {
        return A2(Ye, n.length, function(r) {
            return n[r];
        });
    }
    function pn(n, r) {
        return Yt(A2(Jt, "Expecting " + n, r));
    }
    function $n(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return $n(n.b, r.b);
            case 6:
                return n.d === r.d && $n(n.b, r.b);
            case 7:
                return n.e === r.e && $n(n.b, r.b);
            case 9:
                return n.f === r.f && gn(n.g, r.g);
            case 10:
                return n.h === r.h && $n(n.b, r.b);
            case 11:
                return gn(n.g, r.g);
        }
    }
    function gn(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!$n(n[e], r[e])) return !1;
        return !0;
    }
    var hn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function yn(n) {
        return n;
    }
    var wn = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function xn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function _n(n) {
        return {
            $: 1,
            a: n
        };
    }
    function Cn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var An = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), kn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), En = 0;
    function qn(n) {
        var r = {
            $: 0,
            e: En++,
            f: n,
            g: null,
            h: []
        };
        return Gn(r), r;
    }
    function Fn(n) {
        return Cn(function(r) {
            r(xn(qn(n)));
        });
    }
    function jn(n, r) {
        n.h.push(r), Gn(n);
    }
    var Dn = F2(function(n, r) {
        return Cn(function(t) {
            jn(n, r), t(xn(0));
        });
    }), Vn = !1, Bn = [];
    function Gn(n) {
        if (Bn.push(n), !Vn) {
            for(Vn = !0; n = Bn.shift();)zn(n);
            Vn = !1;
        }
    }
    function zn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, Gn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function Sn(n) {
        return Cn(function(r) {
            var t = setTimeout(function() {
                r(xn(0));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }
    var Tn = {};
    function Pn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function Zn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function c(n) {
            return A2(An, c, {
                $: 5,
                b: function(r) {
                    var c = r.a;
                    return 0 === r.$ ? A3(u, t, c, n) : a && i ? A4(e, t, c.i, c.j, n) : A3(e, t, a ? c.i : c.j, n);
                }
            });
        }
        return t.h = qn(A2(An, c, n.b));
    }
    var Mn = F2(function(n, r) {
        return Cn(function(t) {
            n.g(r), t(xn(0));
        });
    }), Ln = F2(function(n, r) {
        return A2(Dn, n.h, {
            $: 0,
            a: r
        });
    });
    function Nn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function Hn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var In = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), On = [], Qn = !1;
    function Rn(n, r, t) {
        if (On.push({
            p: n,
            q: r,
            r: t
        }), !Qn) {
            Qn = !0;
            for(var e; e = On.shift();)Un(e.p, e.q, e.r);
            Qn = !1;
        }
    }
    function Un(n, r, t) {
        var e = {};
        for(var u in Kn(!0, r, e, null), Kn(!1, t, e, null), n)jn(n[u], {
            $: "fx",
            a: e[u] || {
                i: g,
                j: g
            }
        });
    }
    function Kn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? Tn[r].e : Tn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: g,
                        j: g
                    }, n ? t.i = h(r, t.i) : t.j = h(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)Kn(n, i.a, t, e);
                return;
            case 3:
                return void Kn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    function Wn(n) {
        Tn[n] && a(3);
    }
    function Xn(n, r) {
        return Wn(n), Tn[n] = {
            e: Yn,
            u: r,
            a: Jn
        }, Nn(n);
    }
    var Yn = F2(function(n, r) {
        return r;
    });
    function Jn(n) {
        var r = [], t = Tn[n].u, e = Sn(0);
        return Tn[n].b = e, Tn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, i = t(u.a), c = 0; a.length > c; c++)a[c](i);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function nr(n, r) {
        return Wn(n), Tn[n] = {
            f: rr,
            u: r,
            a: tr
        }, Nn(n);
    }
    var rr = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function tr(n, r) {
        var t = g, e = Tn[n].u, u = xn(null);
        return Tn[n].b = u, Tn[n].c = F3(function(n, r) {
            return t = r, u;
        }), {
            send: function(n) {
                var u = A2(ln, e, n);
                Je(u) || a(4);
                for(var i = u.a, c = t; c.b; c = c.b)r(c.a(i));
            }
        };
    }
    var er = "undefined" != typeof document ? document : {};
    function ur(n, r) {
        n.appendChild(r);
    }
    function ar(n) {
        return {
            $: 0,
            a: n
        };
    }
    var ir = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Cr(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), cr = ir(void 0), or = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Cr(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0), fr = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), sr = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), lr = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), dr = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), vr = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), br = /^script$/i, mr = /^(on|formAction$)/i, pr = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, $r = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function gr(n) {
        return br.test(n) ? "p" : n;
    }
    function hr(n) {
        return $r.test(n) ? "" : n;
    }
    var yr, wr = F2(function(n, r) {
        return "a0" === r.$ ? A2(sr, r.n, function(n, r) {
            var t = iu(r);
            return {
                $: r.$,
                a: t ? A3(uu, 3 > t ? xr : _r, au(n), r.a) : A2(eu, n, r.a)
            };
        }(n, r.o)) : r;
    }), xr = F2(function(n, r) {
        return v(n(r.a), r.b);
    }), _r = F2(function(n, r) {
        return {
            tO: n(r.tO),
            yc: r.yc,
            wd: r.wd
        };
    });
    function Cr(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Ar(i, u, a) : i[u] = a;
            } else "className" === u ? Ar(r, u, a) : r[u] = a;
        }
        return r;
    }
    function Ar(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function kr(n, r) {
        var t = n.$;
        if (5 === t) return kr(n.k || (n.k = n.m()), r);
        if (0 === t) return er.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = kr(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return Er(i = n.h(n.g), r, n.d), i;
        var i = n.f ? er.createElementNS(n.f, n.c) : er.createElement(n.c);
        Er(i, r, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)ur(i, kr(1 === t ? c[o] : c[o].b, r));
        return i;
    }
    function Er(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? qr(n, u) : "a0" === e ? Dr(n, r, u) : "a3" === e ? Fr(n, u) : "a4" === e ? jr(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function qr(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Fr(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function jr(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Dr(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = Vr(r, a), n.addEventListener(u, i, yr && {
                    passive: 2 > iu(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                yr = !0;
            }
        }));
    } catch (n) {}
    function Vr(n, r) {
        function t(r) {
            var e = t.q, u = dn(e.a, r);
            if (Je(u)) {
                for(var a, i = iu(e), c = u.a, o = i ? 3 > i ? c.a : c.tO : c, f = 1 == i ? c.b : 3 == i && c.yc, s = (f && r.stopPropagation(), (2 == i ? c.b : 3 == i && c.wd) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) o = a(o);
                    else for(var l = a.length; l--;)o = a[l](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function Br(n, r) {
        return n.$ == r.$ && $n(n.a, r.a);
    }
    function Gr(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function zr(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Gr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, c = r.l, o = i.length, f = o === c.length; f && o--;)f = i[o] === c[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return zr(n.k, r.k, s, 0), void (s.length > 0 && Gr(t, 1, e, s));
                case 4:
                    for(var l = n.j, d = r.j, v = !1, b = n.k; 4 === b.$;)v = !0, "object" != typeof l ? l = [
                        l,
                        b.j
                    ] : l.push(b.j), b = b.k;
                    for(var m = r.k; 4 === m.$;)v = !0, "object" != typeof d ? d = [
                        d,
                        m.j
                    ] : d.push(m.j), m = m.k;
                    return v && l.length !== d.length ? void Gr(t, 0, e, r) : ((v ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, d) : l === d) || Gr(t, 2, e, d), void zr(b, m, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Gr(t, 3, e, r.a));
                case 1:
                    return void Sr(n, r, t, e, Pr);
                case 2:
                    return void Sr(n, r, t, e, Zr);
                case 3:
                    if (n.h !== r.h) return void Gr(t, 0, e, r);
                    var p = Tr(n.d, r.d);
                    p && Gr(t, 4, e, p);
                    var $ = r.i(n.g, r.g);
                    return void ($ && Gr(t, 5, e, $));
            }
        }
    }
    function Sr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = Tr(n.d, r.d);
            a && Gr(t, 4, e, a), u(n, r, t, e);
        } else Gr(t, 0, e, r);
    }
    function Tr(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && Br(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var c = Tr(n[u], r[u] || {}, u);
            c && ((e = e || {})[u] = c);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function Pr(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, c = a.length;
        i > c ? Gr(t, 6, e, {
            v: c,
            i: i - c
        }) : c > i && Gr(t, 7, e, {
            v: i,
            e: a
        });
        for(var o = c > i ? i : c, f = 0; o > f; f++){
            var s = u[f];
            zr(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function Zr(n, r, t, e) {
        for(var u = [], a = {}, i = [], c = n.e, o = r.e, f = c.length, s = o.length, l = 0, d = 0, v = e; f > l && s > d;){
            var b = (k = c[l]).a, m = (E = o[d]).a, p = k.b, $ = E.b, g = void 0, h = void 0;
            if (b !== m) {
                var y = c[l + 1], w = o[d + 1];
                if (y) {
                    var x = y.a, _ = y.b;
                    h = m === x;
                }
                if (w) {
                    var C = w.a, A = w.b;
                    g = b === C;
                }
                if (g && h) zr(p, A, u, ++v), Lr(a, u, b, $, d, i), v += p.b || 0, Nr(a, u, b, _, ++v), v += _.b || 0, l += 2, d += 2;
                else if (g) v++, Lr(a, u, m, $, d, i), zr(p, A, u, v), v += p.b || 0, l += 1, d += 2;
                else if (h) Nr(a, u, b, p, ++v), v += p.b || 0, zr(_, $, u, ++v), v += _.b || 0, l += 2, d += 1;
                else {
                    if (!y || x !== C) break;
                    Nr(a, u, b, p, ++v), Lr(a, u, m, $, d, i), v += p.b || 0, zr(_, A, u, ++v), v += _.b || 0, l += 2, d += 2;
                }
            } else zr(p, $, u, ++v), v += p.b || 0, l++, d++;
        }
        for(; f > l;){
            var k;
            v++, Nr(a, u, (k = c[l]).a, p = k.b, v), v += p.b || 0, l++;
        }
        for(; s > d;){
            var E, q = q || [];
            Lr(a, u, (E = o[d]).a, E.b, void 0, q), d++;
        }
        (u.length > 0 || i.length > 0 || q) && Gr(t, 8, e, {
            w: u,
            x: i,
            y: q
        });
    }
    var Mr = "_elmW6BL";
    function Lr(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var c = [];
            return zr(i.z, e, c, i.r), i.r = u, void (i.s.s = {
                w: c,
                A: i
            });
        }
        Lr(n, r, t + Mr, e, u, a);
    }
    function Nr(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return zr(e, a.z, i, u), void Gr(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            Nr(n, r, t + Mr, e, u);
        } else {
            var c = Gr(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: c
            };
        }
    }
    function Hr(n, r, t, e) {
        Ir(n, r, t, 0, 0, r.b, e);
    }
    function Ir(n, r, t, e, u, a, i) {
        for(var c = t[e], o = c.r; o === u;){
            var f = c.$;
            if (1 === f) Hr(n, r.k, c.s, i);
            else if (8 === f) c.t = n, c.u = i, (s = c.s.w).length > 0 && Ir(n, r, s, 0, u, a, i);
            else if (9 === f) {
                c.t = n, c.u = i;
                var s, l = c.s;
                l && (l.A.s = n, (s = l.w).length > 0 && Ir(n, r, s, 0, u, a, i));
            } else c.t = n, c.u = i;
            if (!(c = t[++e]) || (o = c.r) > a) return e;
        }
        var d = r.$;
        if (4 === d) {
            for(var v = r.k; 4 === v.$;)v = v.k;
            return Ir(n, v, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var b = r.e, m = n.childNodes, p = 0; b.length > p; p++){
            u++;
            var $ = 1 === d ? b[p] : b[p].b, g = u + ($.b || 0);
            if (!(u > o || o > g || (c = t[e = Ir(m[p], $, t, e, u, g, i)]) && (o = c.r) <= a)) return e;
            u = g;
        }
        return e;
    }
    function Or(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Qr(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Qr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = kr(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Er(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Or(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, i = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(kr(u[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var c = t.A;
                return void 0 !== c.r && n.parentNode.removeChild(n), c.s = Or(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = er.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                ur(t, 2 === u.c ? u.s : kr(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Or(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], c = i.A, o = 2 === c.c ? c.s : kr(c.z, r.u);
                        n.insertBefore(o, n.childNodes[i.r]);
                    }
                    return e && ur(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                a(10);
        }
    }
    function Rr(n) {
        if (3 === n.nodeType) return ar(n.textContent);
        if (1 !== n.nodeType) return ar("");
        for(var r = g, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = h(A2(vr, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = g, c = n.childNodes;
        for(e = c.length; e--;)i = h(Rr(c[e]), i);
        return A3(cr, a, r, i);
    }
    var Ur = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, i) {
            var c = A2(ln, n, r ? r.flags : void 0);
            Je(c) || a(2);
            var o = {}, f = t(c.a), s = f.a, l = i(v, s), d = function(n, r) {
                var t;
                for(var e in Tn){
                    var u = Tn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = Zn(u, r);
                }
                return t;
            }(o, v);
            function v(n, r) {
                var t = A2(e, n, s);
                l(s = t.a, r), Rn(o, t.b, u(s));
            }
            return Rn(o, f.b, u(s)), d ? {
                ports: d
            } : {};
        }(r, e, n.Cl, n.Gv, n.F4, function(r, t) {
            var u = n.GB, a = e.node, i = Rr(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Kr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && Kr(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return zr(n, r, t, 0), t;
                }(i, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (Hr(n, r, t, e), Or(n, t));
                }(a, i, e, r), i = t;
            });
        });
    }), Kr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    var Wr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, Xr = "undefined" != typeof document ? document : Wr, Yr = "undefined" != typeof window ? window : Wr, Jr = F3(function(n, r, t) {
        return Fn(Cn(function() {
            function e(n) {
                qn(t(n));
            }
            return n.addEventListener(r, e, yr && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), nt = F2(function(n, r) {
        var t = dn(n, r);
        return Je(t) ? It(t.a) : Ot;
    });
    function rt(n, r) {
        return Cn(function(t) {
            Kr(function() {
                var e = document.getElementById(n);
                t(e ? xn(r(e)) : _n(ou(n)));
            });
        });
    }
    function tt(n) {
        return Cn(function(r) {
            Kr(function() {
                r(xn(n()));
            });
        });
    }
    var et = F2(function(n, r) {
        return rt(r, function(r) {
            return r[n](), 0;
        });
    });
    function ut() {
        var n = Xr.body, r = Xr.documentElement;
        return {
            cv: Math.max(n.scrollWidth, n.offsetWidth, r.scrollWidth, r.offsetWidth, r.clientWidth),
            r8: Math.max(n.scrollHeight, n.offsetHeight, r.scrollHeight, r.offsetHeight, r.clientHeight)
        };
    }
    var at = F2(function(n, r) {
        return tt(function() {
            return Yr.scroll(n, r), 0;
        });
    }), it = F3(function(n, r, t) {
        return rt(n, function(n) {
            return n.scrollLeft = r, n.scrollTop = t, 0;
        });
    }), ct = F2(function(n, r) {
        return Cn(function() {
            var t = setInterval(function() {
                qn(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), ot = F2(function(n, r) {
        var t = "g";
        n.Dg && (t += "m"), n.At && (t += "i");
        try {
            return It(RegExp(r, t));
        } catch (n) {
            return Ot;
        }
    }), ft = F2(function(n, r) {
        return null !== r.match(n);
    }), st = F3(function(n, r, t) {
        for(var e, u = [], a = 0, i = t, c = r.lastIndex, o = -1; a++ < n && (e = r.exec(i)) && o != r.lastIndex;){
            for(var f = e.length - 1, s = Array(f); f > 0;){
                var l = e[f];
                s[--f] = l ? It(l) : Ot;
            }
            u.push(A4(fb, e[0], e.index, a, w(s))), o = r.lastIndex;
        }
        return r.lastIndex = c, w(u);
    }), lt = F4(function(n, r, t, e) {
        var u = 0;
        return e.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var e = arguments.length - 3, a = Array(e); e > 0;){
                var i = arguments[e];
                a[--e] = i ? It(i) : Ot;
            }
            return t(A4(fb, r, arguments[arguments.length - 2], u, w(a)));
        });
    }), dt = 1 / 0, vt = F5(function(n, r, t, e, u) {
        for(var a = n.length, i = u.length >= r + a, c = 0; i && a > c;){
            var o = u.charCodeAt(r);
            i = n[c++] === u[r++] && (10 === o ? (t++, e = 1) : (e++, 55296 == (63488 & o) ? n[c++] === u[r++] : 1));
        }
        return b(i ? r : -1, t, e);
    }), bt = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), mt = F3(function(n, r, t) {
        return t.charCodeAt(r) === n;
    }), pt = F2(function(n, r) {
        for(; r.length > n; n++){
            var t = r.charCodeAt(n);
            if (48 > t || t > 57) return n;
        }
        return n;
    }), $t = F3(function(n, r, t) {
        for(var e = 0; t.length > r; r++){
            var u = t.charCodeAt(r) - 48;
            if (0 > u || u >= n) break;
            e = n * e + u;
        }
        return v(r, e);
    }), gt = F2(function(n, r) {
        for(var t = 0; r.length > n; n++){
            var e = r.charCodeAt(n);
            if (48 > e || e > 57) {
                if (65 > e || e > 70) {
                    if (97 > e || e > 102) break;
                    t = 16 * t + e - 87;
                } else t = 16 * t + e - 55;
            } else t = 16 * t + e - 48;
        }
        return v(n, t);
    }), ht = F5(function(n, r, t, e, u) {
        for(var a = u.indexOf(n, r), i = 0 > a ? u.length : a + n.length; i > r;){
            var c = u.charCodeAt(r++);
            10 === c ? (e = 1, t++) : (e++, 55296 == (63488 & c) && r++);
        }
        return b(a, t, e);
    });
    function yt(n) {
        return n.byteLength;
    }
    var wt = F3(function(n, r, t) {
        return n.setInt8(r, t), r + 1;
    }), xt = F4(function(n, r, t, e) {
        return n.setInt16(r, t, e), r + 2;
    }), _t = F4(function(n, r, t, e) {
        return n.setInt32(r, t, e), r + 4;
    }), Ct = F3(function(n, r, t) {
        return n.setUint8(r, t), r + 1;
    }), At = F4(function(n, r, t, e) {
        return n.setUint16(r, t, e), r + 2;
    }), kt = F4(function(n, r, t, e) {
        return n.setUint32(r, t, e), r + 4;
    }), Et = F4(function(n, r, t, e) {
        return n.setFloat32(r, t, e), r + 4;
    }), qt = F4(function(n, r, t, e) {
        return n.setFloat64(r, t, e), r + 8;
    }), Ft = F3(function(n, r, t) {
        for(var e = 0, u = t.byteLength, a = u - 4; a >= e; e += 4)n.setUint32(r + e, t.getUint32(e));
        for(; u > e; e++)n.setUint8(r + e, t.getUint8(e));
        return r + u;
    }), jt = F3(function(n, r, t) {
        for(var e = 0; t.length > e; e++){
            var u = t.charCodeAt(e);
            r += 128 > u ? (n.setUint8(r, u), 1) : 2048 > u ? (n.setUint16(r, 49280 | (u >>> 6 & 31) << 8 | 63 & u), 2) : 55296 > u || u > 56319 ? (n.setUint16(r, 57472 | (u >>> 12 & 15) << 8 | u >>> 6 & 63), n.setUint8(r + 2, 128 | 63 & u), 3) : (u = 1024 * (u - 55296) + t.charCodeAt(++e) - 56320 + 65536, n.setUint32(r, 4034953344 | (u >>> 18 & 7) << 24 | (u >>> 12 & 63) << 16 | (u >>> 6 & 63) << 8 | 63 & u), 4);
        }
        return r;
    }), Dt = F2(function(n, r) {
        try {
            return It(A2(n, r, 0).b);
        } catch (n) {
            return Ot;
        }
    }), Vt = F2(function(n, r) {
        return v(r + 1, n.getUint8(r));
    }), Bt = F3(function(n, r, t) {
        return v(t + 2, r.getUint16(t, n));
    }), Gt = F3(function(n, r, t) {
        return v(t + 4, r.getUint32(t, n));
    }), zt = F3(function(n, r, t) {
        for(var e = "", u = t + n; u > t;){
            var a = r.getUint8(t++);
            e += 128 > a ? String.fromCharCode(a) : 192 == (224 & a) ? String.fromCharCode((31 & a) << 6 | 63 & r.getUint8(t++)) : 224 == (240 & a) ? String.fromCharCode((15 & a) << 12 | (63 & r.getUint8(t++)) << 6 | 63 & r.getUint8(t++)) : (a = ((7 & a) << 18 | (63 & r.getUint8(t++)) << 12 | (63 & r.getUint8(t++)) << 6 | 63 & r.getUint8(t++)) - 65536, String.fromCharCode(Math.floor(a / 1024) + 55296, a % 1024 + 56320));
        }
        return v(t, e);
    }), St = F3(function(n, r, t) {
        return Cn(function(e) {
            function u(n) {
                e(r(t.BF.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(U_);
            }), a.addEventListener("timeout", function() {
                u(X_);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? R_ : O_, function(n) {
                        return {
                            yZ: n.responseURL,
                            F_: n.status,
                            F$: n.statusText,
                            h3: Tt(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.BF.b, a));
            }), Y_(t.Gp) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || qn(A2(J_, n, v(t, W_({
                        Fu: e.loaded,
                        FO: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || qn(A2(J_, n, v(t, K_({
                        EY: e.loaded,
                        FO: e.lengthComputable ? It(e.total) : Ot
                    }))));
                });
            }(n, a, t.Gp.a);
            try {
                a.open(t.Dd, t.yZ, !0);
            } catch (n) {
                return u(Q_(t.yZ));
            }
            return function(n, r) {
                for(var t = r.h3; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.Gg.a || 0, n.responseType = r.BF.d, n.withCredentials = r.zV;
            }(a, t), t.g8.a && a.setRequestHeader("Content-Type", t.g8.a), a.send(t.g8.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function Tt(n) {
        if (!n) return pa;
        for(var r = pa, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), c = u.substring(a + 2);
                r = A3(ba, i, function(n) {
                    return It(Y_(n) ? c + ", " + n.a : c);
                }, r);
            }
        }
        return r;
    }
    var Pt = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), Zt = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    });
    function Mt(n) {
        return new DataView(n);
    }
    var Lt, Nt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    K(function(n) {
        return "undefined" != typeof File && n instanceof File ? te(n) : pn("a FILE", n);
    });
    var Ht = F3(function(n, r, t) {
        return Cn(function() {
            var e = new Blob([
                t
            ], {
                type: r
            });
            if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(e, n);
            else {
                var u = Lt || (Lt = document.createElement("a")), a = URL.createObjectURL(e);
                u.href = a, u.download = n, function(n) {
                    if ("function" == typeof MouseEvent) n.dispatchEvent(new MouseEvent("click"));
                    else {
                        var r = document.createEvent("MouseEvents");
                        r.initMouseEvent("click", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), document.body.appendChild(n), n.dispatchEvent(r), document.body.removeChild(n);
                    }
                }(u), URL.revokeObjectURL(a);
            }
        });
    });
    var It = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ot = {
        $: 1
    }, Qt = y, Rt = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(Rt, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), Ut = function(n) {
        return A3(Rt, F3(function(n, r, t) {
            return A2(Qt, v(n, r), t);
        }), g, n);
    }, Kt = 1, Wt = 2, Xt = 0, Yt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Jt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ne = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), re = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), te = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ee = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ue = k, ae = H, ie = p, ce = hn, oe = U, fe = F2(function(n, r) {
        return A2(L, n, x(r));
    }), se = F2(function(n, r) {
        return w(A2(M, n, r));
    }), le = function(n) {
        return A2(fe, "\n    ", A2(se, "\n", n));
    }, de = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), ve = function(n) {
        return A3(de, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, be = _, me = l, pe = F3(function(n, r, t) {
        for(;;){
            if (s(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(Qt, r, t);
            n = e, r = u, t = a;
        }
    }), $e = F2(function(n, r) {
        return A3(pe, n, r, g);
    }), ge = F2(function(n, r) {
        return A3(be, n, A2($e, 0, ve(r) - 1), r);
    }), he = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, ye = function(n) {
        var r = he(n);
        return r >= 97 && 122 >= r;
    }, we = function(n) {
        var r = he(n);
        return 90 >= r && r >= 65;
    }, xe = function(n) {
        return ye(n) || we(n);
    }, _e = function(n) {
        var r = he(n);
        return 57 >= r && r >= 48;
    }, Ce = function(n) {
        return ye(n) || we(n) || _e(n);
    }, Ae = function(n) {
        return A3(de, Qt, g, n);
    }, ke = function(n) {
        var r = n.charCodeAt(0);
        return isNaN(r) ? Ot : It(55296 > r || r > 56319 ? v(n[0], n.slice(1)) : v(n[0] + n[1], n.slice(2)));
    }, Ee = F2(function(n, r) {
        return "\n\n(" + oe(n + 1) + ") " + le(qe(r));
    }), qe = function(n) {
        return A2(Fe, n, g);
    }, Fe = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n = ke(t);
                    if (1 === n.$) return !1;
                    var r = n.a, e = r.b;
                    return xe(r.a) && A2(ae, Ce, e);
                }();
                n = e, r = A2(Qt, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + oe(n.a) + "]";
                n = e, r = A2(Qt, a, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var c = (r.b ? "The Json.Decode.oneOf at json" + A2(fe, "", Ae(r)) : "Json.Decode.oneOf") + " failed in the following " + oe(ve(i)) + " ways:";
                        return A2(fe, "\n\n", A2(Qt, c, A2(ge, Ee, i)));
                    }
                    n = e = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(fe, "", Ae(r)) : "!");
            default:
                var o = n.a, f = n.b;
                return (c = r.b ? "Problem with the value at json" + A2(fe, "", Ae(r)) + ":\n\n    " : "Problem with the given value:\n\n") + le(A2(ce, 4, f)) + "\n\n" + o;
        }
    }), je = 32, De = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Ve = [], Be = j, Ge = F2(function(n, r) {
        return B(r) / B(n);
    }), ze = Be(A2(Ge, 2, je)), Se = A4(De, 0, ze, Ve, Ve), Te = t, Pe = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ze = F2(function(n, r) {
        return n(r);
    }), Me = F2(function(n, r) {
        return r(n);
    }), Le = o, Ne = D, He = function(n) {
        return n.length;
    }, Ie = F2(function(n, r) {
        return s(n, r) > 0 ? n : r;
    }), Oe = E, Qe = e, Re = F2(function(n, r) {
        for(;;){
            var t = A2(Qe, je, n), e = t.b, u = A2(Qt, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return Ae(u);
            n = e, r = u;
        }
    }), Ue = function(n) {
        return n.a;
    }, Ke = F2(function(n, r) {
        for(;;){
            var t = Be(r / je);
            if (1 === t) return A2(Qe, je, n).a;
            n = A2(Re, n, g), r = t;
        }
    }), We = F2(function(n, r) {
        if (r.F) {
            var t = r.F * je, e = Ne(A2(Ge, je, t - 1)), u = n ? Ae(r.M) : r.M, a = A2(Ke, u, r.F);
            return A4(De, He(r.J) + t, A2(Ie, 5, e * ze), a, r.J);
        }
        return A4(De, He(r.J), ze, Ve, r.J);
    }), Xe = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(We, !1, {
                M: e,
                F: t / je | 0,
                J: u
            });
            var a = Pe(A3(Te, je, r, n));
            r -= je, e = A2(Qt, a, e);
        }
    }), Ye = F2(function(n, r) {
        if (n > 0) {
            var t = n % je;
            return A5(Xe, r, n - t - je, n, g, A3(Te, t, n - t, r));
        }
        return Se;
    }), Je = function(n) {
        return !n.$;
    }, nu = un, ru = X, tu = F3(function(n, r, t) {
        return r(n(t));
    }), eu = an, uu = cn, au = function(n) {
        return {
            $: 0,
            a: n
        };
    }, iu = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, cu = function(n) {
        return n;
    }, ou = cu, fu = F6(function(n, r, t, e, u, a) {
        return {
            BX: a,
            Cc: r,
            Ev: e,
            v_: t,
            wn: n,
            jb: u
        };
    }), su = I, lu = function(n) {
        return n.length;
    }, du = N, vu = F2(function(n, r) {
        return 1 > n ? r : A3(du, n, lu(r), r);
    }), bu = R, mu = function(n) {
        return "" === n;
    }, pu = F2(function(n, r) {
        return 1 > n ? "" : A3(du, 0, n, r);
    }), $u = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return Ot;
            r = 10 * r + a - 48;
        }
        return u == e ? Ot : It(45 == t ? -r : r);
    }, gu = F5(function(n, r, t, e, u) {
        if (mu(u) || A2(su, "@", u)) return Ot;
        var a = A2(bu, ":", u);
        if (a.b) {
            if (a.b.b) return Ot;
            var i = a.a, c = $u(A2(vu, i + 1, u));
            if (1 === c.$) return Ot;
            var o = c;
            return It(A6(fu, n, A2(pu, i, u), o, r, t, e));
        }
        return It(A6(fu, n, u, Ot, r, t, e));
    }), hu = F4(function(n, r, t, e) {
        if (mu(e)) return Ot;
        var u = A2(bu, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(gu, n, A2(vu, a, e), r, t, A2(pu, a, e));
        }
        return A5(gu, n, "/", r, t, e);
    }), yu = F3(function(n, r, t) {
        if (mu(t)) return Ot;
        var e = A2(bu, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(hu, n, It(A2(vu, u + 1, t)), r, A2(pu, u, t));
        }
        return A4(hu, n, Ot, r, t);
    }), wu = F2(function(n, r) {
        if (mu(r)) return Ot;
        var t = A2(bu, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(yu, n, It(A2(vu, e + 1, r)), A2(pu, e, r));
        }
        return A3(yu, n, Ot, r);
    }), xu = O, _u = function(n) {
        return A2(xu, "http://", n) ? A2(wu, 0, A2(vu, 7, n)) : A2(xu, "https://", n) ? A2(wu, 1, A2(vu, 8, n)) : Ot;
    }, Cu = function() {
        for(;;);
    }, Au = xn, ku = Au(0), Eu = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, c = a.b;
                if (c.b) {
                    var o = c.a, f = c.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, o, A2(n, f.a, t > 500 ? A3(de, n, r, Ae(s)) : A4(Eu, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, o, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), qu = F3(function(n, r, t) {
        return A4(Eu, n, r, 0, t);
    }), Fu = F2(function(n, r) {
        return A3(qu, F2(function(r, t) {
            return A2(Qt, n(r), t);
        }), g, r);
    }), ju = An, Du = F2(function(n, r) {
        return A2(ju, function(r) {
            return Au(n(r));
        }, r);
    }), Vu = F3(function(n, r, t) {
        return A2(ju, function(r) {
            return A2(ju, function(t) {
                return Au(A2(n, r, t));
            }, t);
        }, r);
    }), Bu = function(n) {
        return A3(qu, Vu(Qt), Au(g), n);
    }, Gu = Mn, zu = F2(function(n, r) {
        var t = r;
        return Fn(A2(ju, Gu(n), t));
    }), Su = F3(function(n, r) {
        return A2(Du, function() {
            return 0;
        }, Bu(A2(Fu, zu(n), r)));
    }), Tu = F3(function() {
        return Au(0);
    }), Pu = F2(function(n, r) {
        return A2(Du, n, r);
    });
    Tn.Task = Pn(ku, Su, Tu, Pu);
    var Zu, Mu, Lu = Nn("Task"), Nu = F2(function(n, r) {
        return Lu(A2(Du, n, r));
    }), Hu = Ur, Iu = rn, Ou = F3(function(n, r, t) {
        return {
            fb: t,
            bc: r,
            Fz: n
        };
    }), Qu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ru = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Uu = Hn, Ku = {
        $: 2
    }, Wu = F5(function(n, r, t, e, u) {
        return {
            cU: e,
            Ep: t,
            cu: r,
            y4: u,
            dk: n
        };
    }), Xu = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(Qt, n.a, Xu(n.b)) : g;
    }, Yu = F2(function(n, r) {
        return It(1 === r.$ ? w([
            n
        ]) : A2(Qt, n, r.a));
    }), Ju = function(n) {
        try {
            return It(decodeURIComponent(n));
        } catch (n) {
            return Ot;
        }
    }, na = d, ra = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Ot;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(na, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return It(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), ta = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), ea = {
        $: -2
    }, ua = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(ta, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5(ta, 0, e.b, e.c, A5(ta, 1, a.b, a.c, a.d, a.e), A5(ta, 1, r, t, i, u));
        }
        var i, c = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(ta, n, c, o, A5(ta, 0, r, t, e, f), s) : A5(ta, 0, r, t, A5(ta, 1, e.b, e.c, e.d, i = e.e), A5(ta, 1, c, o, f, s));
    }), aa = F3(function(n, r, t) {
        if (-2 === t.$) return A5(ta, 0, n, r, ea, ea);
        var e = t.a, u = t.b, a = t.c, i = t.d, c = t.e;
        switch(A2(na, n, u)){
            case 0:
                return A5(ua, e, u, a, A3(aa, n, r, i), c);
            case 1:
                return A5(ta, e, u, r, i, c);
            default:
                return A5(ua, e, u, a, i, A3(aa, n, r, c));
        }
    }), ia = F3(function(n, r, t) {
        var e = A3(aa, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(ta, 1, e.b, e.c, e.d, e.e);
    }), ca = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, c = t.c, e = t.d, s = t.e, A5(ta, 1, n.b, n.c, A5(ta, 0, r.b, r.c, r.d, r.e), A5(ta, 0, i, c, e, s));
            }
            var e, u = n.d, a = n.e, i = a.b, c = a.c, o = (e = a.d).d, f = e.e, s = a.e;
            return A5(ta, 0, e.b, e.c, A5(ta, 1, n.b, n.c, A5(ta, 0, u.b, u.c, u.d, u.e), o), A5(ta, 1, i, c, f, s));
        }
        return n;
    }, oa = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, l = t.d, d = t.e, A5(ta, 1, e = n.b, u = n.c, A5(ta, 0, r.b, r.c, r.d, c = r.e), A5(ta, 0, f, s, l, d));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, c = a.e, o = n.e, f = o.b, s = o.c, l = o.d, d = o.e;
            return A5(ta, 0, a.b, a.c, A5(ta, 1, i.b, i.c, i.d, i.e), A5(ta, 1, e, u, c, A5(ta, 0, f, s, l, d)));
        }
        return n;
    }, fa = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return oa(r);
                        break n;
                    }
                    return oa(r);
                }
                break n;
            }
            return r;
        }
        return A5(ta, t, a.b, a.c, a.d, A5(ta, 0, e, u, a.e, i));
    }), sa = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var c = ca(n);
                    if (-1 === c.$) {
                        var o = c.e;
                        return A5(ua, c.a, c.b, c.c, sa(c.d), o);
                    }
                    return ea;
                }
                return A5(ta, r, t, e, sa(u), i);
            }
            return A5(ta, r, t, e, sa(u), i);
        }
        return ea;
    }, la = F2(function(n, r) {
        if (-2 === r.$) return ea;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > s(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var c = a.d;
                if (-1 !== c.$ || c.a) {
                    var o = ca(r);
                    if (-1 === o.$) {
                        var f = o.e;
                        return A5(ua, o.a, o.b, o.c, A2(la, n, o.d), f);
                    }
                    return ea;
                }
                return A5(ta, t, e, u, A2(la, n, a), i);
            }
            return A5(ta, t, e, u, A2(la, n, a), i);
        }
        return A2(da, n, A7(fa, n, r, t, e, u, a, i));
    }), da = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, a = r.d, c = r.e;
            if (i(n, e)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(c);
                return -1 === o.$ ? A5(ua, t, o.b, o.c, a, sa(c)) : ea;
            }
            return A5(ua, t, e, u, a, A2(la, n, c));
        }
        return ea;
    }), va = F2(function(n, r) {
        var t = A2(la, n, r);
        return -1 !== t.$ || t.a ? t : A5(ta, 1, t.b, t.c, t.d, t.e);
    }), ba = F3(function(n, r, t) {
        var e = r(A2(ra, n, t));
        return e.$ ? A2(va, n, t) : A3(ia, n, e.a, t);
    }), ma = F2(function(n, r) {
        var t = A2(se, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = Ju(t.a);
            if (1 === u.$) return r;
            var a = u.a, i = Ju(e);
            return 1 === i.$ ? r : A3(ba, a, Yu(i.a), r);
        }
        return r;
    }), pa = ea, $a = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.cu;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return It(r.y4);
                    }
                    return It(r.y4);
                }
                return Ot;
            }
        }(n(A5(Wu, g, function(n) {
            var r = A2(se, "/", n);
            return Xu(r.b && "" === r.a ? r.b : r);
        }(r.Ev), 1 === (t = r.jb).$ ? pa : A3(qu, ma, pa, A2(se, "&", t.a)), r.BX, cu)));
    }), ga = {
        $: 12
    }, ha = function(n) {
        return {
            $: 79,
            a: n
        };
    }, ya = function(n) {
        return {
            $: 86,
            a: n
        };
    }, wa = function(n) {
        return {
            $: 87,
            a: n
        };
    }, xa = function(n) {
        return {
            $: 88,
            a: n
        };
    }, _a = {
        $: 13
    }, Ca = function(n) {
        return {
            $: 99,
            a: n
        };
    }, Aa = function(n) {
        return {
            $: 100,
            a: n
        };
    }, ka = {
        $: 14
    }, Ea = {
        $: 66
    }, qa = {
        $: 67
    }, Fa = {
        $: 15
    }, ja = {
        $: 16
    }, Da = {
        $: 17
    }, Va = {
        $: 18
    }, Ba = {
        $: 19
    }, Ga = function(n) {
        return {
            $: 80,
            a: n
        };
    }, za = {
        $: 20
    }, Sa = function(n) {
        return {
            $: 81,
            a: n
        };
    }, Ta = function(n) {
        return {
            $: 89,
            a: n
        };
    }, Pa = {
        $: 21
    }, Za = function(n) {
        return {
            $: 82,
            a: n
        };
    }, Ma = function(n) {
        return {
            $: 90,
            a: n
        };
    }, La = function(n) {
        return {
            $: 91,
            a: n
        };
    }, Na = {
        $: 22
    }, Ha = function(n) {
        return {
            $: 83,
            a: n
        };
    }, Ia = function(n) {
        return {
            $: 92,
            a: n
        };
    }, Oa = function(n) {
        return {
            $: 93,
            a: n
        };
    }, Qa = {
        $: 23
    }, Ra = {
        $: 68
    }, Ua = {
        $: 24
    }, Ka = function(n) {
        return {
            $: 84,
            a: n
        };
    }, Wa = function(n) {
        return {
            $: 94,
            a: n
        };
    }, Xa = {
        $: 25
    }, Ya = function(n) {
        return {
            $: 85,
            a: n
        };
    }, Ja = function(n) {
        return {
            $: 95,
            a: n
        };
    }, ni = function(n) {
        return {
            $: 96,
            a: n
        };
    }, ri = {
        $: 26
    }, ti = {
        $: 27
    }, ei = function(n) {
        return {
            $: 62,
            a: n
        };
    }, ui = {
        $: 6
    }, ai = function(n) {
        return {
            $: 69,
            a: n
        };
    }, ii = function(n) {
        return {
            $: 63,
            a: n
        };
    }, ci = function(n) {
        return {
            $: 97,
            a: n
        };
    }, oi = function(n) {
        return {
            $: 98,
            a: n
        };
    }, fi = {
        $: 28
    }, si = {
        $: 7
    }, li = function(n) {
        return {
            $: 64,
            a: n
        };
    }, di = {
        $: 8
    }, vi = {
        $: 1
    }, bi = {
        $: 9
    }, mi = {
        $: 29
    }, pi = {
        $: 30
    }, $i = {
        $: 31
    }, gi = {
        $: 3
    }, hi = function(n) {
        return {
            $: 70,
            a: n
        };
    }, yi = function(n) {
        return {
            $: 71,
            a: n
        };
    }, wi = function(n) {
        return {
            $: 72,
            a: n
        };
    }, xi = function(n) {
        return {
            $: 73,
            a: n
        };
    }, _i = function(n) {
        return {
            $: 74,
            a: n
        };
    }, Ci = function(n) {
        return {
            $: 75,
            a: n
        };
    }, Ai = function(n) {
        return {
            $: 76,
            a: n
        };
    }, ki = function(n) {
        return {
            $: 77,
            a: n
        };
    }, Ei = function(n) {
        return {
            $: 78,
            a: n
        };
    }, qi = function(n) {
        return {
            $: 65,
            a: n
        };
    }, Fi = {
        $: 10
    }, ji = {
        $: 32
    }, Di = {
        $: 33
    }, Vi = {
        $: 34
    }, Bi = {
        $: 35
    }, Gi = {
        $: 36
    }, zi = {
        $: 37
    }, Si = {
        $: 38
    }, Ti = {
        $: 39
    }, Pi = {
        $: 40
    }, Zi = {
        $: 41
    }, Mi = {
        $: 42
    }, Li = {
        $: 43
    }, Ni = {
        $: 44
    }, Hi = {
        $: 45
    }, Ii = {
        $: 46
    }, Oi = {
        $: 47
    }, Qi = {
        $: 48
    }, Ri = {
        $: 49
    }, Ui = {
        $: 50
    }, Ki = {
        $: 51
    }, Wi = {
        $: 52
    }, Xi = {
        $: 53
    }, Yi = {
        $: 54
    }, Ji = {
        $: 55
    }, nc = {
        $: 56
    }, rc = {
        $: 57
    }, tc = {
        $: 58
    }, ec = {
        $: 59
    }, uc = {
        $: 60
    }, ac = {
        $: 11
    }, ic = {
        $: 61
    }, cc = {
        $: 4
    }, oc = {
        $: 0
    }, fc = {
        $: 5
    }, sc = F2(function(n, r) {
        return A5(Wu, r.dk, r.cu, r.Ep, r.cU, n(r.y4));
    }), lc = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.dk, u = r.cu, a = r.Ep, i = r.cU;
            return A2(Fu, sc(r.y4), t(A5(Wu, e, u, a, i, n)));
        };
    }), dc = F2(function(n, r) {
        return r.b ? A3(qu, Qt, r, n) : n;
    }), vc = function(n) {
        return A3(qu, dc, g, n);
    }, bc = F2(function(n, r) {
        return vc(A2(Fu, n, r));
    }), mc = function(n) {
        return function(r) {
            var t = r.dk, e = r.cu, u = r.Ep, a = r.cU, c = r.y4;
            if (e.b) {
                var o = e.a, f = e.b;
                return i(o, n) ? w([
                    A5(Wu, A2(Qt, o, t), f, u, a, c)
                ]) : g;
            }
            return g;
        };
    }, pc = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(bc, e, t(n));
        };
    }), $c = F2(function(n, r) {
        return function(n) {
            var t = n.dk, e = n.cu, u = n.Ep, a = n.cU, i = n.y4;
            if (e.b) {
                var c = e.a, o = e.b, f = r(c);
                if (f.$) return g;
                var s = f.a;
                return w([
                    A5(Wu, A2(Qt, c, t), o, u, a, i(s))
                ]);
            }
            return g;
        };
    }), gc = A2($c, "STRING", It), hc = function(n) {
        return w([
            n
        ]);
    }, yc = (Zu = w([
        A2(lc, oc, hc),
        A2(lc, vi, mc("enroll-thanks")),
        A2(lc, Ku, mc("not-found")),
        A2(lc, gi, mc("patient-documents")),
        A2(lc, cc, mc("thanks")),
        A2(lc, fc, mc("waitlist")),
        A2(lc, ui, mc("account")),
        A2(lc, si, mc("booking")),
        A2(lc, di, mc("checkout")),
        A2(lc, bi, mc("enroll")),
        A2(lc, Fi, mc("signup")),
        A2(lc, ac, mc("style-guide")),
        A2(lc, ga, A2(pc, mc("account"), mc("appointments"))),
        A2(lc, _a, A2(pc, mc("account"), mc("booking"))),
        A2(lc, ka, A2(pc, mc("account"), mc("cart"))),
        A2(lc, Fa, A2(pc, mc("account"), mc("chat"))),
        A2(lc, ja, A2(pc, mc("account"), mc("documents"))),
        A2(lc, Da, A2(pc, mc("account"), mc("explore-services"))),
        A2(lc, Va, A2(pc, mc("account"), mc("forbidden"))),
        A2(lc, Ba, A2(pc, mc("account"), mc("health-information"))),
        A2(lc, za, A2(pc, mc("account"), mc("invoices"))),
        A2(lc, Pa, A2(pc, mc("account"), mc("members"))),
        A2(lc, Na, A2(pc, mc("account"), mc("memberships"))),
        A2(lc, Qa, A2(pc, mc("account"), mc("messaging"))),
        A2(lc, Ua, A2(pc, mc("account"), mc("not-found"))),
        A2(lc, Xa, A2(pc, mc("account"), mc("payment-sources"))),
        A2(lc, ri, A2(pc, mc("account"), mc("practitioner-location"))),
        A2(lc, ti, A2(pc, mc("account"), mc("session-expired"))),
        A2(lc, fi, A2(pc, mc("booking"), mc("empty"))),
        A2(lc, mi, A2(pc, mc("login"), mc("request"))),
        A2(lc, pi, A2(pc, mc("login"), mc("select-patient"))),
        A2(lc, $i, A2(pc, mc("login"), mc("verify-code"))),
        A2(lc, ji, A2(pc, mc("style-guide"), mc("action-menu"))),
        A2(lc, Di, A2(pc, mc("style-guide"), mc("activity-indicator"))),
        A2(lc, Vi, A2(pc, mc("style-guide"), mc("address-input"))),
        A2(lc, Bi, A2(pc, mc("style-guide"), mc("alerts"))),
        A2(lc, Gi, A2(pc, mc("style-guide"), mc("api-select"))),
        A2(lc, zi, A2(pc, mc("style-guide"), mc("button"))),
        A2(lc, Si, A2(pc, mc("style-guide"), mc("card"))),
        A2(lc, Ti, A2(pc, mc("style-guide"), mc("card-example"))),
        A2(lc, Pi, A2(pc, mc("style-guide"), mc("cart-icon"))),
        A2(lc, Zi, A2(pc, mc("style-guide"), mc("checkbox"))),
        A2(lc, Mi, A2(pc, mc("style-guide"), mc("code-sent-confirmation"))),
        A2(lc, Li, A2(pc, mc("style-guide"), mc("filter-example"))),
        A2(lc, Ni, A2(pc, mc("style-guide"), mc("form-example"))),
        A2(lc, Hi, A2(pc, mc("style-guide"), mc("grid"))),
        A2(lc, Ii, A2(pc, mc("style-guide"), mc("input"))),
        A2(lc, Oi, A2(pc, mc("style-guide"), mc("insurance-info"))),
        A2(lc, Qi, A2(pc, mc("style-guide"), mc("modal"))),
        A2(lc, Ri, A2(pc, mc("style-guide"), mc("multi-form"))),
        A2(lc, Ui, A2(pc, mc("style-guide"), mc("phone-input"))),
        A2(lc, Ki, A2(pc, mc("style-guide"), mc("radio"))),
        A2(lc, Wi, A2(pc, mc("style-guide"), mc("searchable-select"))),
        A2(lc, Xi, A2(pc, mc("style-guide"), mc("segmented-control"))),
        A2(lc, Yi, A2(pc, mc("style-guide"), mc("select"))),
        A2(lc, Ji, A2(pc, mc("style-guide"), mc("table"))),
        A2(lc, nc, A2(pc, mc("style-guide"), mc("tabs"))),
        A2(lc, rc, A2(pc, mc("style-guide"), mc("tag"))),
        A2(lc, tc, A2(pc, mc("style-guide"), mc("title-band"))),
        A2(lc, ec, A2(pc, mc("style-guide"), mc("toggle"))),
        A2(lc, uc, A2(pc, mc("style-guide"), mc("tooltip"))),
        A2(lc, ic, A2(pc, mc("style-guide"), mc("typography"))),
        A2(lc, ei, A2(lc, function(n) {
            return {
                yI: n
            };
        }, A2(pc, mc("account"), gc))),
        A2(lc, ii, A2(lc, function(n) {
            return {
                yI: n
            };
        }, A2(pc, mc("bills"), gc))),
        A2(lc, li, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("checkout"), gc))),
        A2(lc, qi, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("signup"), gc))),
        A2(lc, Ea, A2(pc, mc("account"), A2(pc, mc("cart"), mc("confirm-pay")))),
        A2(lc, qa, A2(pc, mc("account"), A2(pc, mc("cart"), mc("confirmation")))),
        A2(lc, Ra, A2(pc, mc("account"), A2(pc, mc("messaging"), mc("chat")))),
        A2(lc, ai, A2(lc, function(n) {
            return {
                z1: n
            };
        }, A2(pc, mc("appointments"), A2(pc, gc, mc("cancellation-policy"))))),
        A2(lc, hi, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("signup"), A2(pc, gc, mc("additional-details"))))),
        A2(lc, yi, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("signup"), A2(pc, gc, mc("confirmation"))))),
        A2(lc, wi, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("signup"), A2(pc, gc, mc("contacts"))))),
        A2(lc, xi, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("signup"), A2(pc, gc, mc("custom-details"))))),
        A2(lc, _i, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("signup"), A2(pc, gc, mc("location"))))),
        A2(lc, Ci, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("signup"), A2(pc, gc, mc("members"))))),
        A2(lc, Ai, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("signup"), A2(pc, gc, mc("membership"))))),
        A2(lc, ki, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("signup"), A2(pc, gc, mc("provider"))))),
        A2(lc, Ei, A2(lc, function(n) {
            return {
                xQ: n
            };
        }, A2(pc, mc("signup"), A2(pc, gc, mc("thanks"))))),
        A2(lc, ha, A2(lc, function(n) {
            return {
                z1: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("appointments"), gc)))),
        A2(lc, Ga, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("health-information"), gc)))),
        A2(lc, Sa, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("invoices"), gc)))),
        A2(lc, Za, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("members"), gc)))),
        A2(lc, Ha, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("memberships"), gc)))),
        A2(lc, Ka, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("packages"), gc)))),
        A2(lc, Ya, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("payment-sources"), gc)))),
        A2(lc, ya, A2(lc, function(n) {
            return {
                z1: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("appointments"), A2(pc, gc, mc("cancel")))))),
        A2(lc, wa, A2(lc, function(n) {
            return {
                z1: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("appointments"), A2(pc, gc, mc("cancel-appointment")))))),
        A2(lc, xa, A2(lc, function(n) {
            return {
                z1: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("appointments"), A2(pc, gc, mc("reschedule")))))),
        A2(lc, Ta, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("invoices"), A2(pc, gc, mc("payment")))))),
        A2(lc, Ma, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("members"), A2(pc, gc, mc("edit")))))),
        A2(lc, La, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("members"), A2(pc, gc, mc("emergency-contact")))))),
        A2(lc, Ia, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("memberships"), A2(pc, gc, mc("add-member")))))),
        A2(lc, Oa, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("memberships"), A2(pc, gc, mc("renew")))))),
        A2(lc, Wa, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("packages"), A2(pc, gc, mc("checkout")))))),
        A2(lc, Ja, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("payment-sources"), A2(pc, gc, mc("edit")))))),
        A2(lc, ni, A2(lc, function(n) {
            return {
                sl: n
            };
        }, A2(pc, mc("account"), A2(pc, mc("plans"), A2(pc, gc, mc("checkout")))))),
        A2(lc, ci, A2(lc, F2(function(n, r) {
            return {
                nv: n,
                n3: r
            };
        }), A2(pc, mc("booking"), A2(pc, gc, A2(pc, mc("location"), A2(pc, gc, mc("date"))))))),
        A2(lc, oi, A2(lc, F2(function(n, r) {
            return {
                nv: n,
                n3: r
            };
        }), A2(pc, mc("booking"), A2(pc, gc, A2(pc, mc("location"), A2(pc, gc, mc("enter-info"))))))),
        A2(lc, Ca, A2(lc, F2(function(n, r) {
            return {
                nv: n,
                n3: r
            };
        }), A2(pc, mc("account"), A2(pc, mc("booking"), A2(pc, gc, A2(pc, mc("location"), A2(pc, gc, mc("date")))))))),
        A2(lc, Aa, A2(lc, F2(function(n, r) {
            return {
                nv: n,
                n3: r
            };
        }), A2(pc, mc("account"), A2(pc, mc("booking"), A2(pc, gc, A2(pc, mc("location"), A2(pc, gc, mc("enter-info"))))))))
    ]), function(n) {
        return A2(bc, function(r) {
            return r(n);
        }, Zu);
    }), wc = $a(yc), xc = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), _c = A2(tu, wc, xc(Ku)), Cc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ac = {
        $: 0
    }, kc = {
        $: 0
    }, Ec = function(n) {
        return {
            $: 13,
            a: n
        };
    }, qc = F3(function(n, r, t) {
        return n(r(t));
    }), Fc = kn, jc = F2(function(n, r) {
        return Lu(A2(Fc, A2(qc, A2(qc, Au, n), Yt), A2(ju, A2(qc, A2(qc, Au, n), te), r)));
    }), Dc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Vc = F4(function(n, r, t, e) {
        return Dc({
            j: e,
            bk: r,
            aN: !0,
            bV: t,
            im: 0,
            bL: n
        });
    }), Bc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Gc = F4(function(n, r, t, e) {
        return Bc({
            j: e,
            bk: r,
            aN: !0,
            bV: t,
            bL: n
        });
    }), zc = F4(function(n, r, t, e) {
        return Bc({
            j: e,
            bk: r,
            aN: !0,
            bV: t,
            bL: n
        });
    }), Sc = F4(function(n, r, t, e) {
        return Bc({
            j: e,
            bk: r,
            aN: !0,
            bV: t,
            bL: n
        });
    }), Tc = F4(function(n, r, t, e) {
        return Bc({
            j: e,
            bk: r,
            aN: !1,
            bV: t,
            bL: n
        });
    }), Pc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Zc = F2(function(n, r) {
        return {
            pI: r,
            aT: n
        };
    }), Mc = F2(function(n, r) {
        return {
            mr: n,
            mG: r
        };
    }), Lc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Nc = Lc, Hc = 2037, Ic = F5(function(n, r, t, e, u) {
        return {
            bZ: u,
            pW: t,
            un: r,
            Gf: e,
            zq: n
        };
    }), Oc = function(n) {
        return n.b;
    }, Qc = F, Rc = F2(function(n, r) {
        var t = A2(Qc, 7, function(n) {
            return A2(Qc, 7, n) || 7;
        }(r) + 7 - function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                default:
                    return 7;
            }
        }(n));
        return r - t;
    }), Uc = F2(function(n, r) {
        var t = A2(Rc, n, r);
        return i(r, t) ? r : t + 7;
    }), Kc = f, Wc = function(n) {
        return !A2(Qc, 4, n) && !!A2(Qc, 100, n) || !A2(Qc, 400, n);
    }, Xc = F2(function(n, r) {
        var t = Wc(n) ? 1 : 0;
        switch(r){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + t;
            case 3:
                return 90 + t;
            case 4:
                return 120 + t;
            case 5:
                return 151 + t;
            case 6:
                return 181 + t;
            case 7:
                return 212 + t;
            case 8:
                return 243 + t;
            case 9:
                return 273 + t;
            case 10:
                return 304 + t;
            default:
                return 334 + t;
        }
    }), Yc = function(n) {
        var r = n - 1;
        return 365 * r + ((r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0));
    }, Jc = F3(function(n, r, t) {
        return Yc(n) + A2(Xc, n, r) + t;
    }), no = F2(function(n, r) {
        return A3(qu, F2(function(r, t) {
            return n(r) ? A2(Qt, r, t) : t;
        }), g, r);
    }), ro = F2(function(n, r) {
        switch(r){
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            default:
                return 31;
            case 1:
                return Wc(n) ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
        }
    }), to = F2(function(n, r) {
        return Yc(n) + A2(Xc, n, r) + A2(ro, n, r);
    }), eo = function(n) {
        return 1440 * (n - 719163);
    }, uo = C, ao = F2(function(n, r) {
        var t = r.ct, e = r.Fj;
        switch(n){
            case 0:
                return 0;
            case 1:
                return 0 - t;
            default:
                return 0 - (t + e);
        }
    }), io = F2(function(n, r) {
        var t, e;
        return e = (t = r).Gf, eo(A3(Jc, t.zq, t.un, t.pW)) + e + A2(ao, r.bZ, n);
    }), co = F5(function(n, r, t, e, u) {
        var a = A2(bc, function(n) {
            return A2(uo, function(n) {
                return n.x$;
            }, A2(Fu, function(r) {
                return {
                    bZ: r.bZ,
                    Fj: r.Fj,
                    x$: eo(function() {
                        var t = r.pW;
                        switch(t.$){
                            case 0:
                                return A3(Jc, n, r.un, t.a);
                            case 1:
                                return A2(Uc, t.a, A3(Jc, n, r.un, t.b));
                            case 2:
                                return A2(Rc, t.a, A3(Jc, n, r.un, t.b));
                            default:
                                return A2(Rc, t.a, A2(to, n, r.un));
                        }
                    }()) + r.Gf
                };
            }, A2(no, function(r) {
                return 1 > s(r.rP, n) && 1 > s(n, r.yy);
            }, u)));
        }, A2($e, r.zq - 1, t.zq)), i = {
            Fj: 0,
            ct: e
        }, c = {
            iH: e,
            x$: A2(io, n, r)
        }, o = A3(de, F2(function(r, u) {
            var a = u.a, i = u.b, o = {
                Fj: r.Fj,
                ct: e
            };
            return 1 > s(r.x$ + A2(ao, r.bZ, n), c.x$) ? v(o, w([
                {
                    iH: e + r.Fj,
                    x$: c.x$
                }
            ])) : 0 > s(r.x$ + A2(ao, r.bZ, a), A2(io, a, t)) ? v(o, A2(Qt, {
                iH: e + r.Fj,
                x$: r.x$ + A2(ao, r.bZ, a)
            }, i)) : v(a, i);
        }), v(i, w([
            c
        ])), a), f = o.a;
        return v(Ae(o.b), f);
    }), oo = F4(function(n, r, t, e) {
        var u = e.mr, a = e.mG;
        if (a.$) return A5(co, n, r, t, u, a.a);
        var i = a.a;
        return v(w([
            {
                iH: u + i,
                x$: A2(io, n, r)
            }
        ]), {
            Fj: i,
            ct: u
        });
    }), fo = F4(function(n, r, t, e) {
        for(;;){
            if (!e.b) return Ae(t);
            var u = e.a, a = e.b, c = n(u), o = i(r, c) ? t : A2(Qt, u, t);
            r = c, t = o, e = a;
        }
    }), so = F3(function(n, r, t) {
        var e = A3(de, F2(function(n, r) {
            var t = n.b, e = r.b;
            return v(t, A2(Qt, b(r.a, n.a, t), e));
        }), v(n, g), t.aT), u = e.b;
        return Ae(A2(Qt, b(e.a, t.pI, r), u));
    }), lo = F3(function(n, r, t) {
        var e, u, a = (e = t.aT).b ? e.a.a : t.pI, i = {
            Fj: (u = a.mG, u.$ ? 0 : u.a),
            ct: a.mr
        }, c = A4(fo, function(n) {
            return n.iH;
        }, i.ct + i.Fj, g, A3(de, F2(function(n, r) {
            var t = r.b, e = A4(oo, r.a, n.a, n.c, n.b);
            return v(e.b, $(t, e.a));
        }), v(i, g), A3(so, A5(Ic, n, 0, 1, 0, 0), A5(Ic, r + 1, 0, 1, 0, 0), t)).b), o = function(n) {
            for(;;){
                var r = n.a, t = n.b;
                if (!t.b) return v(r, g);
                var e = t.a, u = t.b;
                if (e.x$ > 0) return v(r, t);
                n = v(e.iH, u);
            }
        }(v(i.ct + i.Fj, c)), f = o.a;
        return v(Ae(o.b), f);
    }), vo = function(n) {
        var r = A3(lo, 1970, Hc, n);
        return A2(Nc, r.b, r.a);
    }, bo = function(n) {
        return -n;
    }, mo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, po = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $o = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), go = F7(function(n, r, t, e, u, a, i) {
        return {
            bZ: a,
            pW: e,
            rP: n,
            un: t,
            Fj: i,
            Gf: u,
            yy: r
        };
    }), ho = w([
        A7(go, 1967, 2006, 9, po(6), 120, 2, 0),
        A7(go, 1967, 1973, 3, po(6), 120, 2, 60),
        A7(go, 1974, 1974, 0, mo(6), 120, 2, 60),
        A7(go, 1975, 1975, 1, po(6), 120, 2, 60),
        A7(go, 1976, 1986, 3, po(6), 120, 2, 60),
        A7(go, 1987, 2006, 3, A2($o, 6, 1), 120, 2, 60),
        A7(go, 2007, Hc, 2, A2($o, 6, 8), 120, 2, 60),
        A7(go, 2007, Hc, 10, A2($o, 6, 1), 120, 2, 0)
    ]), yo = function() {
        return vo(A2(Zc, g, A2(Mc, -480, Pc(ho))));
    }, wo = yo(), xo = {
        $: 0
    }, _o = _n, Co = Cn(function(n) {
        try {
            var r = {
                $: 0,
                a: Intl.DateTimeFormat().resolvedOptions().timeZone
            };
        } catch (n) {
            r = function(n) {
                return {
                    $: 1,
                    a: n
                };
            }((new Date).getTimezoneOffset());
        }
        n(xn(r));
    }), Ao = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ko = function() {
        return vo(A2(Zc, g, A2(Mc, 0, Ao(0))));
    }, Eo = function() {
        return vo(A2(Zc, g, A2(Mc, 180, Ao(0))));
    }, qo = Eo, Fo = w([
        A7(go, 1971, 1971, 3, mo(25), 1380, 1, 60),
        A7(go, 1971, 1971, 8, mo(26), 1380, 1, 0),
        A7(go, 1977, 1977, 4, mo(6), 0, 2, 60),
        A7(go, 1977, 1977, 9, mo(21), 0, 2, 0),
        A7(go, 1978, 1978, 2, mo(24), 60, 2, 60),
        A7(go, 1978, 1978, 8, mo(22), 180, 2, 0),
        A7(go, 1980, 1980, 3, mo(25), 0, 2, 60),
        A7(go, 1980, 1980, 9, mo(31), 120, 2, 0)
    ]), jo = Eo, Do = ko, Vo = function() {
        return vo(A2(Zc, g, A2(Mc, 60, Ao(0))));
    }, Bo = Vo, Go = ko, zo = function() {
        return vo(A2(Zc, g, A2(Mc, 120, Ao(0))));
    }, So = zo, To = Vo, Po = zo, Zo = w([
        A7(go, 1959, 1981, 4, mo(1), 60, 2, 60),
        A7(go, 1966, 1994, 9, mo(1), 180, 2, 0),
        A7(go, 1982, 1982, 6, mo(25), 60, 2, 60),
        A7(go, 1983, 1983, 6, mo(12), 60, 2, 60),
        A7(go, 1984, 1988, 4, mo(1), 60, 2, 60),
        A7(go, 1989, 1989, 4, mo(6), 60, 2, 60),
        A7(go, 1990, 1994, 4, mo(1), 60, 2, 60),
        A7(go, 1995, 2010, 3, po(4), 0, 1, 60),
        A7(go, 1995, 2005, 8, po(3), 1440, 2, 0),
        A7(go, 2006, 2006, 8, mo(21), 1440, 2, 0),
        A7(go, 2007, 2007, 8, A2($o, 3, 1), 1440, 2, 0),
        A7(go, 2008, 2008, 7, po(3), 1440, 2, 0),
        A7(go, 2009, 2009, 7, mo(20), 1440, 2, 0),
        A7(go, 2010, 2010, 7, mo(10), 1440, 2, 0),
        A7(go, 2010, 2010, 8, mo(9), 1440, 2, 60),
        A7(go, 2010, 2010, 8, po(3), 1440, 2, 0),
        A7(go, 2014, 2014, 4, mo(15), 1440, 2, 60),
        A7(go, 2014, 2014, 5, mo(26), 1440, 2, 0),
        A7(go, 2014, 2014, 6, mo(31), 1440, 2, 60),
        A7(go, 2014, 2014, 8, po(3), 1440, 2, 0)
    ]), Mo = w([
        A7(go, 1974, 1974, 5, mo(24), 0, 2, 60),
        A7(go, 1974, 1974, 8, mo(1), 0, 2, 0),
        A7(go, 1976, 1977, 4, mo(1), 0, 2, 60),
        A7(go, 1976, 1976, 7, mo(1), 0, 2, 0),
        A7(go, 1977, 1977, 8, mo(28), 0, 2, 0),
        A7(go, 1978, 1978, 5, mo(1), 0, 2, 60),
        A7(go, 1978, 1978, 7, mo(4), 0, 2, 0),
        A7(go, 2008, 2008, 5, mo(1), 0, 2, 60),
        A7(go, 2008, 2008, 8, mo(1), 0, 2, 0),
        A7(go, 2009, 2009, 5, mo(1), 0, 2, 60),
        A7(go, 2009, 2009, 7, mo(21), 0, 2, 0),
        A7(go, 2010, 2010, 4, mo(2), 0, 2, 60),
        A7(go, 2010, 2010, 7, mo(8), 0, 2, 0),
        A7(go, 2011, 2011, 3, mo(3), 0, 2, 60),
        A7(go, 2011, 2011, 6, mo(31), 0, 2, 0),
        A7(go, 2012, 2013, 3, po(6), 120, 2, 60),
        A7(go, 2012, 2012, 6, mo(20), 180, 2, 0),
        A7(go, 2012, 2012, 7, mo(20), 120, 2, 60),
        A7(go, 2012, 2012, 8, mo(30), 180, 2, 0),
        A7(go, 2013, 2013, 6, mo(7), 180, 2, 0),
        A7(go, 2013, 2013, 7, mo(10), 120, 2, 60),
        A7(go, 2013, 2018, 9, po(6), 180, 2, 0),
        A7(go, 2014, 2018, 2, po(6), 120, 2, 60),
        A7(go, 2014, 2014, 5, mo(28), 180, 2, 0),
        A7(go, 2014, 2014, 7, mo(2), 120, 2, 60),
        A7(go, 2015, 2015, 5, mo(14), 180, 2, 0),
        A7(go, 2015, 2015, 6, mo(19), 120, 2, 60),
        A7(go, 2016, 2016, 5, mo(5), 180, 2, 0),
        A7(go, 2016, 2016, 6, mo(10), 120, 2, 60),
        A7(go, 2017, 2017, 4, mo(21), 180, 2, 0),
        A7(go, 2017, 2017, 6, mo(2), 120, 2, 60),
        A7(go, 2018, 2018, 4, mo(13), 180, 2, 0),
        A7(go, 2018, 2018, 5, mo(17), 120, 2, 60),
        A7(go, 2019, 2019, 4, mo(5), 180, 2, -60),
        A7(go, 2019, 2019, 5, mo(9), 120, 2, 0),
        A7(go, 2020, 2020, 3, mo(19), 180, 2, -60),
        A7(go, 2020, 2020, 4, mo(31), 120, 2, 0),
        A7(go, 2021, 2021, 3, mo(11), 180, 2, -60),
        A7(go, 2021, 2021, 4, mo(16), 120, 2, 0),
        A7(go, 2022, 2022, 2, mo(27), 180, 2, -60),
        A7(go, 2022, 2022, 4, mo(8), 120, 2, 0),
        A7(go, 2023, 2023, 2, mo(19), 180, 2, -60),
        A7(go, 2023, 2023, 3, mo(30), 120, 2, 0),
        A7(go, 2024, 2024, 2, mo(10), 180, 2, -60),
        A7(go, 2024, 2024, 3, mo(14), 120, 2, 0),
        A7(go, 2025, 2025, 1, mo(23), 180, 2, -60),
        A7(go, 2025, 2025, 3, mo(6), 120, 2, 0),
        A7(go, 2026, 2026, 1, mo(15), 180, 2, -60),
        A7(go, 2026, 2026, 2, mo(22), 120, 2, 0),
        A7(go, 2027, 2027, 1, mo(7), 180, 2, -60),
        A7(go, 2027, 2027, 2, mo(14), 120, 2, 0),
        A7(go, 2028, 2028, 0, mo(23), 180, 2, -60),
        A7(go, 2028, 2028, 2, mo(5), 120, 2, 0),
        A7(go, 2029, 2029, 0, mo(14), 180, 2, -60),
        A7(go, 2029, 2029, 1, mo(18), 120, 2, 0),
        A7(go, 2029, 2029, 11, mo(30), 180, 2, -60),
        A7(go, 2030, 2030, 1, mo(10), 120, 2, 0),
        A7(go, 2030, 2030, 11, mo(22), 180, 2, -60),
        A7(go, 2031, 2031, 1, mo(2), 120, 2, 0),
        A7(go, 2031, 2031, 11, mo(14), 180, 2, -60),
        A7(go, 2032, 2032, 0, mo(18), 120, 2, 0),
        A7(go, 2032, 2032, 10, mo(28), 180, 2, -60),
        A7(go, 2033, 2033, 0, mo(9), 120, 2, 0),
        A7(go, 2033, 2033, 10, mo(20), 180, 2, -60),
        A7(go, 2033, 2033, 11, mo(25), 120, 2, 0),
        A7(go, 2034, 2034, 10, mo(5), 180, 2, -60),
        A7(go, 2034, 2034, 11, mo(17), 120, 2, 0),
        A7(go, 2035, 2035, 9, mo(28), 180, 2, -60),
        A7(go, 2035, 2035, 11, mo(9), 120, 2, 0),
        A7(go, 2036, 2036, 9, mo(19), 180, 2, -60),
        A7(go, 2036, 2036, 10, mo(23), 120, 2, 0),
        A7(go, 2037, 2037, 9, mo(4), 180, 2, -60),
        A7(go, 2037, 2037, 10, mo(15), 120, 2, 0)
    ]), Lo = w([
        A7(go, 1977, 1980, 3, A2($o, 6, 1), 60, 0, 60),
        A7(go, 1977, 1977, 8, po(6), 60, 0, 0),
        A7(go, 1978, 1978, 9, mo(1), 60, 0, 0),
        A7(go, 1979, 1995, 8, po(6), 60, 0, 0),
        A7(go, 1981, Hc, 2, po(6), 60, 0, 60),
        A7(go, 1996, Hc, 9, po(6), 60, 0, 0)
    ]), No = w([
        A7(go, 1974, 1974, 5, mo(24), 0, 2, 60),
        A7(go, 1974, 1974, 8, mo(1), 0, 2, 0),
        A7(go, 1976, 1977, 4, mo(1), 0, 2, 60),
        A7(go, 1976, 1976, 7, mo(1), 0, 2, 0),
        A7(go, 1977, 1977, 8, mo(28), 0, 2, 0),
        A7(go, 1978, 1978, 5, mo(1), 0, 2, 60),
        A7(go, 1978, 1978, 7, mo(4), 0, 2, 0)
    ]), Ho = ko, Io = ko, Oo = Eo, Qo = Eo, Ro = Vo, Uo = ko, Ko = zo, Wo = zo, Xo = function() {
        return vo(A2(Zc, g, A2(Mc, 120, Ao(0))));
    }, Yo = w([
        A7(go, 1970, 1970, 4, mo(1), 0, 2, 60),
        A7(go, 1970, 1985, 9, mo(15), 0, 2, 0),
        A7(go, 1971, 1971, 3, mo(30), 0, 2, 60),
        A7(go, 1972, 1985, 3, po(6), 0, 2, 60)
    ]), Jo = Eo, nf = zo, rf = Vo, tf = Vo, ef = ko, uf = Vo, af = zo, cf = zo, of = Vo, ff = Xo, sf = Xo, lf = Eo, df = Vo, vf = ko, bf = ko, mf = Vo, pf = w([
        A7(go, 1982, 1984, 3, mo(1), 0, 2, 60),
        A7(go, 1982, 1985, 9, mo(1), 0, 2, 0),
        A7(go, 1985, 1985, 3, mo(6), 0, 2, 60),
        A7(go, 1986, 1986, 3, mo(4), 0, 2, 60),
        A7(go, 1986, 1986, 9, mo(3), 0, 2, 0),
        A7(go, 1987, 1989, 3, mo(1), 0, 2, 60),
        A7(go, 1987, 1989, 9, mo(1), 0, 2, 0),
        A7(go, 1997, 1997, 3, mo(4), 0, 2, 60),
        A7(go, 1997, 1997, 9, mo(4), 0, 2, 0),
        A7(go, 2013, 2013, 2, po(4), 60, 2, 60),
        A7(go, 2013, 2013, 9, po(4), 120, 2, 0)
    ]), $f = w([
        A7(go, 1977, 1977, 3, mo(30), 0, 1, 60),
        A7(go, 1977, 1977, 8, mo(24), 0, 1, 0),
        A7(go, 1978, 1978, 4, mo(1), 0, 1, 60),
        A7(go, 1978, 1978, 9, mo(1), 0, 1, 0),
        A7(go, 1988, 1988, 5, mo(1), 0, 1, 60),
        A7(go, 1988, 1990, 8, po(6), 0, 1, 0),
        A7(go, 1989, 1989, 2, mo(26), 0, 1, 60),
        A7(go, 1990, 1990, 4, mo(1), 0, 1, 60),
        A7(go, 2005, 2005, 4, mo(1), 0, 1, 60),
        A7(go, 2005, 2005, 8, mo(30), 60, 1, 0),
        A7(go, 2006, 2008, 2, po(6), 120, 1, 60),
        A7(go, 2006, 2008, 9, po(6), 120, 1, 0)
    ]), gf = w([
        A7(go, 1994, 1994, 2, mo(21), 0, 2, -60),
        A7(go, 1994, 2017, 8, A2($o, 6, 1), 120, 2, 0),
        A7(go, 1995, 2017, 3, A2($o, 6, 1), 120, 2, -60)
    ]), hf = function() {
        return vo(A2(Zc, g, A2(Mc, -240, Ao(0))));
    }, yf = hf, wf = hf, xf = w([
        A7(go, 1985, 1985, 10, mo(2), 0, 2, 60),
        A7(go, 1986, 1986, 2, mo(15), 0, 2, 0),
        A7(go, 1986, 1986, 9, mo(25), 0, 2, 60),
        A7(go, 1987, 1987, 1, mo(14), 0, 2, 0),
        A7(go, 1987, 1987, 9, mo(25), 0, 2, 60),
        A7(go, 1988, 1988, 1, mo(7), 0, 2, 0),
        A7(go, 1988, 1988, 9, mo(16), 0, 2, 60),
        A7(go, 1989, 1989, 0, mo(29), 0, 2, 0),
        A7(go, 1989, 1989, 9, mo(15), 0, 2, 60),
        A7(go, 1990, 1990, 1, mo(11), 0, 2, 0),
        A7(go, 1990, 1990, 9, mo(21), 0, 2, 60),
        A7(go, 1991, 1991, 1, mo(17), 0, 2, 0),
        A7(go, 1991, 1991, 9, mo(20), 0, 2, 60),
        A7(go, 1992, 1992, 1, mo(9), 0, 2, 0),
        A7(go, 1992, 1992, 9, mo(25), 0, 2, 60),
        A7(go, 1993, 1993, 0, mo(31), 0, 2, 0),
        A7(go, 1993, 1995, 9, A2($o, 6, 11), 0, 2, 60),
        A7(go, 1994, 1995, 1, A2($o, 6, 15), 0, 2, 0),
        A7(go, 1996, 1996, 1, mo(11), 0, 2, 0),
        A7(go, 1996, 1996, 9, mo(6), 0, 2, 60),
        A7(go, 1997, 1997, 1, mo(16), 0, 2, 0),
        A7(go, 1997, 1997, 9, mo(6), 0, 2, 60),
        A7(go, 1998, 1998, 2, mo(1), 0, 2, 0),
        A7(go, 1998, 1998, 9, mo(11), 0, 2, 60),
        A7(go, 1999, 1999, 1, mo(21), 0, 2, 0),
        A7(go, 1999, 1999, 9, mo(3), 0, 2, 60),
        A7(go, 2e3, 2e3, 1, mo(27), 0, 2, 0),
        A7(go, 2e3, 2001, 9, A2($o, 6, 8), 0, 2, 60),
        A7(go, 2001, 2006, 1, A2($o, 6, 15), 0, 2, 0),
        A7(go, 2002, 2002, 10, mo(3), 0, 2, 60),
        A7(go, 2003, 2003, 9, mo(19), 0, 2, 60),
        A7(go, 2004, 2004, 10, mo(2), 0, 2, 60),
        A7(go, 2005, 2005, 9, mo(16), 0, 2, 60),
        A7(go, 2006, 2006, 10, mo(5), 0, 2, 60),
        A7(go, 2007, 2007, 1, mo(25), 0, 2, 0),
        A7(go, 2007, 2007, 9, A2($o, 6, 8), 0, 2, 60),
        A7(go, 2008, 2017, 9, A2($o, 6, 15), 0, 2, 60),
        A7(go, 2008, 2011, 1, A2($o, 6, 15), 0, 2, 0),
        A7(go, 2012, 2012, 1, A2($o, 6, 22), 0, 2, 0),
        A7(go, 2013, 2014, 1, A2($o, 6, 15), 0, 2, 0),
        A7(go, 2015, 2015, 1, A2($o, 6, 22), 0, 2, 0),
        A7(go, 2016, 2019, 1, A2($o, 6, 15), 0, 2, 0),
        A7(go, 2018, 2018, 10, A2($o, 6, 1), 0, 2, 60)
    ]), _f = w([
        A7(go, 1968, 1969, 3, A2($o, 6, 1), 0, 2, 0),
        A7(go, 1974, 1974, 0, mo(23), 0, 2, 60),
        A7(go, 1974, 1974, 4, mo(1), 0, 2, 0),
        A7(go, 1988, 1988, 11, mo(1), 0, 2, 60),
        A7(go, 1989, 1993, 2, A2($o, 6, 1), 0, 2, 0),
        A7(go, 1989, 1992, 9, A2($o, 6, 15), 0, 2, 60),
        A7(go, 1999, 1999, 9, A2($o, 6, 1), 0, 2, 60),
        A7(go, 2e3, 2e3, 2, mo(3), 0, 2, 0),
        A7(go, 2007, 2007, 11, mo(30), 0, 2, 60),
        A7(go, 2008, 2009, 2, A2($o, 6, 15), 0, 2, 0),
        A7(go, 2008, 2008, 9, A2($o, 6, 15), 0, 2, 60)
    ]), Cf = w([
        A7(go, 2008, 2009, 2, A2($o, 6, 8), 0, 2, 0),
        A7(go, 2007, 2008, 9, A2($o, 6, 8), 0, 2, 60)
    ]), Af = function() {
        return vo(A2(Zc, g, A2(Mc, -240, Ao(0))));
    }, kf = Af, Ef = w([
        A7(go, 1975, 1988, 9, mo(1), 0, 2, 60),
        A7(go, 1975, 1978, 2, mo(1), 0, 2, 0),
        A7(go, 1979, 1991, 3, mo(1), 0, 2, 0),
        A7(go, 1989, 1989, 9, mo(22), 0, 2, 60),
        A7(go, 1990, 1990, 9, mo(1), 0, 2, 60),
        A7(go, 1991, 1991, 9, mo(6), 0, 2, 60),
        A7(go, 1992, 1992, 2, mo(1), 0, 2, 0),
        A7(go, 1992, 1992, 9, mo(5), 0, 2, 60),
        A7(go, 1993, 1993, 2, mo(31), 0, 2, 0),
        A7(go, 1993, 1995, 9, mo(1), 0, 2, 60),
        A7(go, 1994, 1995, 1, po(6), 0, 2, 0),
        A7(go, 1996, 1996, 2, mo(1), 0, 2, 0),
        A7(go, 1996, 2001, 9, A2($o, 6, 1), 0, 2, 60),
        A7(go, 1997, 1997, 1, po(6), 0, 2, 0),
        A7(go, 1998, 2001, 2, A2($o, 6, 1), 0, 2, 0),
        A7(go, 2002, 2004, 3, A2($o, 6, 1), 0, 2, 0),
        A7(go, 2002, 2003, 8, A2($o, 6, 1), 0, 2, 60),
        A7(go, 2004, 2009, 9, A2($o, 6, 15), 0, 2, 60),
        A7(go, 2005, 2009, 2, A2($o, 6, 8), 0, 2, 0),
        A7(go, 2010, Hc, 9, A2($o, 6, 1), 0, 2, 60),
        A7(go, 2010, 2012, 3, A2($o, 6, 8), 0, 2, 0),
        A7(go, 2013, Hc, 2, A2($o, 6, 22), 0, 2, 0)
    ]), qf = w([
        A7(go, 1996, 2e3, 3, A2($o, 6, 1), 120, 2, 60),
        A7(go, 1996, 2e3, 9, po(6), 120, 2, 0),
        A7(go, 2001, 2001, 4, A2($o, 6, 1), 120, 2, 60),
        A7(go, 2001, 2001, 8, po(6), 120, 2, 0),
        A7(go, 2002, Hc, 3, A2($o, 6, 1), 120, 2, 60),
        A7(go, 2002, Hc, 9, po(6), 120, 2, 0)
    ]), Ff = w([
        A7(go, 1977, 1977, 5, mo(12), 120, 2, 60),
        A7(go, 1977, 1978, 9, A2($o, 6, 1), 120, 2, 0),
        A7(go, 1978, 1980, 3, A2($o, 6, 15), 120, 2, 60),
        A7(go, 1979, 1979, 8, mo(30), 120, 2, 0),
        A7(go, 1980, 1980, 8, mo(25), 120, 2, 0)
    ]), jf = w([
        A7(go, 1973, 1973, 11, mo(5), 0, 2, 60),
        A7(go, 1974, 1974, 1, mo(9), 0, 2, 0),
        A7(go, 1982, 1982, 11, mo(18), 0, 2, 60),
        A7(go, 1983, 1983, 1, mo(12), 0, 2, 0)
    ]), Df = w([
        A7(go, 1974, 1986, 3, po(6), 120, 2, 60),
        A7(go, 1974, 2006, 9, po(6), 120, 2, 0),
        A7(go, 1987, 2006, 3, A2($o, 6, 1), 120, 2, 60),
        A7(go, 2007, Hc, 2, A2($o, 6, 8), 120, 2, 60),
        A7(go, 2007, Hc, 10, A2($o, 6, 1), 120, 2, 0)
    ]), Vf = w([
        A7(go, 1992, 1992, 4, mo(3), 0, 2, 60),
        A7(go, 1993, 1993, 3, mo(4), 0, 2, 0)
    ]), Bf = w([
        A7(go, 1980, 1986, 3, po(6), 120, 2, 60),
        A7(go, 1980, 2006, 9, po(6), 120, 2, 0),
        A7(go, 1987, 2006, 3, A2($o, 6, 1), 120, 2, 60)
    ]), Gf = function() {
        return vo(A2(Zc, g, A2(Mc, -300, Ao(0))));
    }, zf = Gf, Sf = w([
        A7(go, 1979, 1980, 1, po(6), 0, 2, 60),
        A7(go, 1979, 1980, 5, A2($o, 6, 1), 0, 2, 0),
        A7(go, 1991, 1992, 0, A2($o, 5, 15), 0, 2, 60),
        A7(go, 1991, 1991, 6, mo(1), 0, 2, 0),
        A7(go, 1992, 1992, 2, mo(15), 0, 2, 0)
    ]), Tf = w([
        A7(go, 1946, 1986, 3, po(6), 120, 2, 60),
        A7(go, 1962, 2006, 9, po(6), 120, 2, 0)
    ]), Pf = hf, Zf = w([
        A7(go, 1972, 1986, 3, po(6), 120, 2, 60),
        A7(go, 1972, 2006, 9, po(6), 120, 2, 0)
    ]), Mf = w([
        A7(go, 1987, 1988, 4, A2($o, 6, 1), 0, 2, 60),
        A7(go, 1987, 1988, 8, po(6), 0, 2, 0)
    ]), Lf = w([
        A7(go, 1962, 1973, 3, po(6), 120, 2, 60),
        A7(go, 1962, 1973, 9, po(6), 120, 2, 0)
    ]), Nf = w([
        A7(go, 1951, 1986, 3, po(6), 120, 2, 60),
        A7(go, 1960, 1986, 9, po(6), 120, 2, 0),
        A7(go, 1987, 1987, 3, A2($o, 6, 1), 1, 2, 60),
        A7(go, 1987, 2006, 9, po(6), 1, 2, 0),
        A7(go, 1988, 1988, 3, A2($o, 6, 1), 1, 2, 120),
        A7(go, 1989, 2006, 3, A2($o, 6, 1), 1, 2, 60),
        A7(go, 2007, 2011, 2, A2($o, 6, 8), 1, 2, 60),
        A7(go, 2007, 2010, 10, A2($o, 6, 1), 1, 2, 0)
    ]), Hf = hf, If = hf, Of = w([
        A7(go, 1973, 1973, 10, mo(25), 0, 2, 60),
        A7(go, 1974, 1974, 1, mo(24), 0, 2, 0),
        A7(go, 1983, 1983, 4, mo(21), 0, 2, 60),
        A7(go, 1983, 1983, 8, mo(22), 0, 2, 0),
        A7(go, 1991, 1991, 2, mo(23), 0, 2, 60),
        A7(go, 1991, 1991, 8, mo(7), 0, 2, 0),
        A7(go, 2006, 2006, 3, mo(30), 0, 2, 60),
        A7(go, 2006, 2006, 9, mo(1), 0, 2, 0)
    ]), Qf = w([
        A7(go, 1992, 1992, 10, mo(28), 0, 2, 60),
        A7(go, 1993, 1993, 1, mo(5), 0, 2, 0)
    ]), Rf = w([
        A7(go, 1969, 1977, 3, po(6), 0, 2, 60),
        A7(go, 1969, 1971, 9, po(6), 0, 2, 0),
        A7(go, 1972, 1974, 9, mo(8), 0, 2, 0),
        A7(go, 1975, 1977, 9, po(6), 0, 2, 0),
        A7(go, 1978, 1978, 4, mo(7), 0, 2, 60),
        A7(go, 1978, 1990, 9, A2($o, 6, 8), 0, 2, 0),
        A7(go, 1979, 1980, 2, A2($o, 6, 15), 0, 2, 60),
        A7(go, 1981, 1985, 4, A2($o, 6, 5), 0, 2, 60),
        A7(go, 1986, 1989, 2, A2($o, 6, 14), 0, 2, 60),
        A7(go, 1990, 1997, 3, A2($o, 6, 1), 0, 2, 60),
        A7(go, 1991, 1995, 9, A2($o, 6, 8), 0, 1, 0),
        A7(go, 1996, 1996, 9, mo(6), 0, 1, 0),
        A7(go, 1997, 1997, 9, mo(12), 0, 1, 0),
        A7(go, 1998, 1999, 2, po(6), 0, 1, 60),
        A7(go, 1998, 2003, 9, po(6), 0, 1, 0),
        A7(go, 2e3, 2003, 3, A2($o, 6, 1), 0, 1, 60),
        A7(go, 2004, 2004, 2, po(6), 0, 1, 60),
        A7(go, 2006, 2010, 9, po(6), 0, 1, 0),
        A7(go, 2007, 2007, 2, A2($o, 6, 8), 0, 1, 60),
        A7(go, 2008, 2008, 2, A2($o, 6, 15), 0, 1, 60),
        A7(go, 2009, 2010, 2, A2($o, 6, 8), 0, 1, 60),
        A7(go, 2011, 2011, 2, A2($o, 6, 15), 0, 1, 60),
        A7(go, 2011, 2011, 10, mo(13), 0, 1, 0),
        A7(go, 2012, 2012, 3, mo(1), 0, 1, 60),
        A7(go, 2012, Hc, 10, A2($o, 6, 1), 0, 1, 0),
        A7(go, 2013, Hc, 2, A2($o, 6, 8), 0, 1, 60)
    ]), Uf = Af, Kf = w([
        A7(go, 1986, 1987, 0, mo(1), 0, 2, 60),
        A7(go, 1986, 1987, 3, mo(1), 0, 2, 0),
        A7(go, 1990, 1990, 0, mo(1), 0, 2, 60),
        A7(go, 1990, 1990, 3, mo(1), 0, 2, 0),
        A7(go, 1994, 1994, 0, mo(1), 0, 2, 60),
        A7(go, 1994, 1994, 3, mo(1), 0, 2, 0)
    ]), Wf = Af, Xf = w([
        A7(go, 1979, 1980, 2, A2($o, 6, 16), 0, 2, 60),
        A7(go, 1979, 1980, 5, A2($o, 0, 23), 0, 2, 0),
        A7(go, 2005, 2005, 3, mo(10), 0, 2, 60),
        A7(go, 2005, 2005, 9, A2($o, 6, 1), 0, 2, 0),
        A7(go, 2006, 2006, 3, mo(30), 120, 2, 60),
        A7(go, 2006, 2006, 9, A2($o, 6, 1), 60, 2, 0)
    ]), Yf = hf, Jf = w([
        A7(go, 1946, 1972, 3, po(6), 120, 2, 60),
        A7(go, 1957, 1972, 9, po(6), 120, 2, 0),
        A7(go, 1993, 2006, 3, A2($o, 6, 1), 1, 2, 60),
        A7(go, 1993, 2006, 9, po(6), 1, 2, 0)
    ]), ns = w([
        A7(go, 1970, 1970, 3, mo(25), 0, 2, 60),
        A7(go, 1970, 1970, 5, mo(14), 0, 2, 0),
        A7(go, 1972, 1972, 3, mo(23), 0, 2, 60),
        A7(go, 1972, 1972, 6, mo(16), 0, 2, 0),
        A7(go, 1974, 1974, 0, mo(13), 0, 2, 90),
        A7(go, 1974, 1974, 2, mo(10), 0, 2, 30),
        A7(go, 1974, 1974, 8, mo(1), 0, 2, 0),
        A7(go, 1974, 1974, 11, mo(22), 0, 2, 60),
        A7(go, 1975, 1975, 2, mo(30), 0, 2, 0),
        A7(go, 1976, 1976, 11, mo(19), 0, 2, 60),
        A7(go, 1977, 1977, 2, mo(6), 0, 2, 0),
        A7(go, 1977, 1977, 11, mo(4), 0, 2, 60),
        A7(go, 1978, 1979, 2, A2($o, 6, 1), 0, 2, 0),
        A7(go, 1978, 1978, 11, mo(17), 0, 2, 60),
        A7(go, 1979, 1979, 3, mo(29), 0, 2, 60),
        A7(go, 1980, 1980, 2, mo(16), 0, 2, 0),
        A7(go, 1987, 1987, 11, mo(14), 0, 2, 60),
        A7(go, 1988, 1988, 1, mo(28), 0, 2, 0),
        A7(go, 1988, 1988, 11, mo(11), 0, 2, 60),
        A7(go, 1989, 1989, 2, mo(5), 0, 2, 0),
        A7(go, 1989, 1989, 9, mo(29), 0, 2, 60),
        A7(go, 1990, 1990, 1, mo(25), 0, 2, 0),
        A7(go, 1990, 1991, 9, A2($o, 6, 21), 0, 2, 60),
        A7(go, 1991, 1992, 2, A2($o, 6, 1), 0, 2, 0),
        A7(go, 1992, 1992, 9, mo(18), 0, 2, 60),
        A7(go, 1993, 1993, 1, mo(28), 0, 2, 0),
        A7(go, 2004, 2004, 8, mo(19), 0, 2, 60),
        A7(go, 2005, 2005, 2, mo(27), 120, 2, 0),
        A7(go, 2005, 2005, 9, mo(9), 120, 2, 60),
        A7(go, 2006, 2015, 2, A2($o, 6, 8), 120, 2, 0),
        A7(go, 2006, 2014, 9, A2($o, 6, 1), 120, 2, 60)
    ]), rs = hf, ts = w([
        A7(go, 1964, 1975, 9, po(6), 120, 2, 0),
        A7(go, 1964, 1975, 3, po(6), 120, 2, 60)
    ]), es = w([
        A7(go, 1983, 1983, 4, mo(8), 0, 2, 60),
        A7(go, 1984, 1987, 3, po(6), 0, 2, 60),
        A7(go, 1983, 1987, 9, po(6), 0, 2, 0),
        A7(go, 1988, 1997, 3, A2($o, 6, 1), 60, 1, 60),
        A7(go, 1988, 1997, 9, po(6), 60, 1, 0),
        A7(go, 2005, 2006, 3, A2($o, 6, 1), 0, 2, 60),
        A7(go, 2005, 2006, 9, po(6), 0, 2, 0),
        A7(go, 2012, 2015, 2, A2($o, 6, 8), 120, 2, 60),
        A7(go, 2012, 2015, 10, A2($o, 6, 1), 120, 2, 0),
        A7(go, 2017, Hc, 2, A2($o, 6, 8), 120, 2, 60),
        A7(go, 2017, Hc, 10, A2($o, 6, 1), 120, 2, 0)
    ]), us = w([
        A7(go, 1969, 1969, 2, mo(30), 180, 0, 0),
        A7(go, 1969, 1969, 10, mo(23), 240, 0, 60),
        A7(go, 1970, 1970, 2, mo(29), 180, 0, 0),
        A7(go, 1971, 1971, 2, mo(14), 180, 0, 0),
        A7(go, 1970, 1972, 9, A2($o, 6, 9), 240, 0, 60),
        A7(go, 1972, 1986, 2, A2($o, 6, 9), 180, 0, 0),
        A7(go, 1973, 1973, 8, mo(30), 240, 0, 60),
        A7(go, 1974, 1987, 9, A2($o, 6, 9), 240, 0, 60),
        A7(go, 1987, 1987, 3, mo(12), 180, 0, 0),
        A7(go, 1988, 1990, 2, A2($o, 6, 9), 180, 0, 0),
        A7(go, 1988, 1989, 9, A2($o, 6, 9), 240, 0, 60),
        A7(go, 1990, 1990, 8, mo(16), 240, 0, 60),
        A7(go, 1991, 1996, 2, A2($o, 6, 9), 180, 0, 0),
        A7(go, 1991, 1997, 9, A2($o, 6, 9), 240, 0, 60),
        A7(go, 1997, 1997, 2, mo(30), 180, 0, 0),
        A7(go, 1998, 1998, 2, A2($o, 6, 9), 180, 0, 0),
        A7(go, 1998, 1998, 8, mo(27), 240, 0, 60),
        A7(go, 1999, 1999, 3, mo(4), 180, 0, 0),
        A7(go, 1999, 2010, 9, A2($o, 6, 9), 240, 0, 60),
        A7(go, 2e3, 2007, 2, A2($o, 6, 9), 180, 0, 0),
        A7(go, 2008, 2008, 2, mo(30), 180, 0, 0),
        A7(go, 2009, 2009, 2, A2($o, 6, 9), 180, 0, 0),
        A7(go, 2010, 2010, 3, A2($o, 6, 1), 180, 0, 0),
        A7(go, 2011, 2011, 4, A2($o, 6, 2), 180, 0, 0),
        A7(go, 2011, 2011, 7, A2($o, 6, 16), 240, 0, 60),
        A7(go, 2012, 2014, 3, A2($o, 6, 23), 180, 0, 0),
        A7(go, 2012, 2014, 8, A2($o, 6, 2), 240, 0, 60),
        A7(go, 2016, 2018, 4, A2($o, 6, 9), 180, 0, 0),
        A7(go, 2016, 2018, 7, A2($o, 6, 9), 240, 0, 60),
        A7(go, 2019, Hc, 3, A2($o, 6, 2), 180, 0, 0),
        A7(go, 2019, Hc, 8, A2($o, 6, 2), 240, 0, 60)
    ]), as = w([
        A7(go, 1969, 1973, 9, po(6), 0, 2, 30),
        A7(go, 1970, 1970, 1, mo(21), 0, 2, 0),
        A7(go, 1971, 1971, 0, mo(20), 0, 2, 0),
        A7(go, 1972, 1974, 0, mo(21), 0, 2, 0)
    ]), is = w([
        A7(go, 1977, 1980, 3, A2($o, 6, 1), 120, 1, 60),
        A7(go, 1977, 1977, 8, po(6), 120, 1, 0),
        A7(go, 1978, 1978, 9, mo(1), 120, 1, 0),
        A7(go, 1979, 1995, 8, po(6), 120, 1, 0),
        A7(go, 1981, Hc, 2, po(6), 120, 1, 60),
        A7(go, 1996, Hc, 9, po(6), 120, 1, 0)
    ]), cs = hf, os = hf, fs = hf, ss = hf, ls = hf, ds = w([
        A7(go, 1987, 1988, 4, A2($o, 6, 1), 0, 2, 60),
        A7(go, 1987, 1988, 8, po(6), 0, 2, 0),
        A7(go, 2006, 2006, 4, A2($o, 6, 1), 0, 2, 60),
        A7(go, 2006, 2006, 7, A2($o, 0, 1), 0, 2, 0)
    ]), vs = w([
        A7(go, 1991, 1992, 2, po(6), 120, 2, 60),
        A7(go, 1991, 1992, 8, po(6), 120, 2, 0),
        A7(go, 1993, 2006, 3, A2($o, 6, 1), 120, 2, 60),
        A7(go, 1993, 2006, 9, po(6), 120, 2, 0),
        A7(go, 2007, Hc, 2, A2($o, 6, 8), 120, 2, 60),
        A7(go, 2007, Hc, 10, A2($o, 6, 1), 120, 2, 0)
    ]), bs = w([
        A7(go, 1950, 1973, 3, po(6), 120, 2, 60),
        A7(go, 1957, 1973, 9, po(6), 120, 2, 0)
    ]), ms = hf, ps = w([
        A7(go, 1966, 1986, 3, po(6), 120, 1, 60),
        A7(go, 1966, 2005, 9, po(6), 120, 1, 0),
        A7(go, 1987, 2005, 3, A2($o, 6, 1), 120, 1, 60)
    ]), $s = w([
        A7(go, 1968, 1985, 9, po(6), 120, 1, 60),
        A7(go, 1969, 1971, 2, A2($o, 6, 8), 120, 1, 0),
        A7(go, 1972, 1972, 1, po(6), 120, 1, 0),
        A7(go, 1973, 1981, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1982, 1983, 2, po(6), 120, 1, 0),
        A7(go, 1984, 1986, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1986, 1986, 9, A2($o, 6, 15), 120, 1, 60),
        A7(go, 1987, 1990, 2, A2($o, 6, 15), 120, 1, 0),
        A7(go, 1987, 1987, 9, A2($o, 6, 22), 120, 1, 60),
        A7(go, 1988, 1990, 9, po(6), 120, 1, 60),
        A7(go, 1991, 1999, 9, A2($o, 6, 1), 120, 1, 60),
        A7(go, 1991, 2005, 2, po(6), 120, 1, 0),
        A7(go, 2e3, 2e3, 7, po(6), 120, 1, 60),
        A7(go, 2001, Hc, 9, A2($o, 6, 1), 120, 1, 60),
        A7(go, 2006, 2006, 3, A2($o, 6, 1), 120, 1, 0),
        A7(go, 2007, 2007, 2, po(6), 120, 1, 0),
        A7(go, 2008, Hc, 3, A2($o, 6, 1), 120, 1, 0)
    ]), gs = w([
        A7(go, 1974, 1974, 10, A2($o, 6, 1), 120, 1, 60),
        A7(go, 1975, 1975, 1, po(6), 120, 1, 0),
        A7(go, 1975, 1988, 9, po(6), 120, 1, 60),
        A7(go, 1976, 1989, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1989, 1989, 9, A2($o, 6, 8), 120, 1, 60),
        A7(go, 1990, 2006, 9, A2($o, 6, 1), 120, 1, 60),
        A7(go, 1990, 2007, 2, A2($o, 6, 15), 120, 1, 0),
        A7(go, 2007, Hc, 8, po(6), 120, 1, 60),
        A7(go, 2008, Hc, 3, A2($o, 6, 1), 120, 1, 0)
    ]), hs = function() {
        return vo(A2(Zc, g, A2(Mc, 720, Pc(gs))));
    }, ys = hs, ws = w([
        A7(go, 2005, Hc, 2, po(6), 60, 0, 120),
        A7(go, 2004, Hc, 9, po(6), 60, 0, 0)
    ]), xs = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 60, Ao(0)), A5(Ic, 1980, 0, 1, 0, 2))
        ]), A2(Mc, 60, Pc(Lo))));
    }, _s = xs, Cs = function() {
        return vo(A2(Zc, g, A2(Mc, 180, Ao(0))));
    }, As = Cs, ks = w([
        A7(go, 1981, 1984, 3, mo(1), 0, 2, 60),
        A7(go, 1981, 1983, 9, mo(1), 0, 2, 0),
        A7(go, 1984, 1995, 8, po(6), 120, 1, 0),
        A7(go, 1985, 2010, 2, po(6), 120, 1, 60),
        A7(go, 1996, 2010, 9, po(6), 120, 1, 0)
    ]), Es = w([
        A7(go, 1973, 1973, 5, mo(6), 0, 2, 60),
        A7(go, 1973, 1975, 9, mo(1), 0, 2, 0),
        A7(go, 1974, 1977, 4, mo(1), 0, 2, 60),
        A7(go, 1976, 1976, 10, mo(1), 0, 2, 0),
        A7(go, 1977, 1977, 9, mo(1), 0, 2, 0),
        A7(go, 1978, 1978, 3, mo(30), 0, 2, 60),
        A7(go, 1978, 1978, 8, mo(30), 0, 2, 0),
        A7(go, 1985, 1985, 3, mo(1), 0, 2, 60),
        A7(go, 1985, 1985, 9, mo(1), 0, 2, 0),
        A7(go, 1986, 1988, 3, A2($o, 4, 1), 0, 2, 60),
        A7(go, 1986, 1990, 9, A2($o, 4, 1), 0, 2, 0),
        A7(go, 1989, 1989, 4, mo(8), 0, 2, 60),
        A7(go, 1990, 1990, 3, mo(27), 0, 2, 60),
        A7(go, 1991, 1991, 3, mo(17), 0, 2, 60),
        A7(go, 1991, 1991, 8, mo(27), 0, 2, 0),
        A7(go, 1992, 1992, 3, mo(10), 0, 2, 60),
        A7(go, 1992, 1993, 9, A2($o, 4, 1), 0, 2, 0),
        A7(go, 1993, 1998, 3, A2($o, 4, 1), 0, 2, 60),
        A7(go, 1994, 1994, 8, A2($o, 4, 15), 0, 2, 0),
        A7(go, 1995, 1998, 8, A2($o, 4, 15), 0, 1, 0),
        A7(go, 1999, 1999, 6, mo(1), 0, 1, 60),
        A7(go, 1999, 2002, 8, po(4), 0, 1, 0),
        A7(go, 2e3, 2001, 2, po(3), 0, 1, 60),
        A7(go, 2002, 2012, 2, po(3), 1440, 2, 60),
        A7(go, 2003, 2003, 9, mo(24), 0, 1, 0),
        A7(go, 2004, 2004, 9, mo(15), 0, 1, 0),
        A7(go, 2005, 2005, 8, po(4), 0, 1, 0),
        A7(go, 2006, 2011, 9, po(4), 0, 1, 0),
        A7(go, 2013, 2013, 11, mo(20), 0, 2, 0),
        A7(go, 2014, Hc, 2, po(3), 1440, 2, 60),
        A7(go, 2014, Hc, 9, po(4), 0, 1, 0)
    ]), qs = w([
        A7(go, 1981, 1984, 3, mo(1), 0, 2, 60),
        A7(go, 1981, 1983, 9, mo(1), 0, 2, 0),
        A7(go, 1984, 1995, 8, po(6), 120, 1, 0),
        A7(go, 1985, 2010, 2, po(6), 120, 1, 60),
        A7(go, 1996, 2010, 9, po(6), 120, 1, 0)
    ]), Fs = w([
        A7(go, 1982, 1982, 4, mo(1), 0, 2, 60),
        A7(go, 1982, 1984, 9, mo(1), 0, 2, 0),
        A7(go, 1983, 1983, 2, mo(31), 0, 2, 60),
        A7(go, 1984, 1985, 3, mo(1), 0, 2, 60),
        A7(go, 1985, 1990, 8, po(6), 60, 1, 0),
        A7(go, 1986, 1990, 2, po(6), 60, 1, 60),
        A7(go, 1991, 2007, 3, mo(1), 180, 1, 60),
        A7(go, 1991, 2007, 9, mo(1), 180, 1, 0)
    ]), js = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 240, Ao(0)), A5(Ic, 1972, 5, 1, 0, 2))
        ]), A2(Mc, 180, Ao(0))));
    }, Ds = js, Vs = w([
        A7(go, 1997, 2015, 2, po(6), 240, 2, 60),
        A7(go, 1997, 2015, 9, po(6), 300, 2, 0)
    ]), Bs = w([
        A7(go, 1981, Hc, 2, po(6), 60, 0, 60),
        A7(go, 1979, 1995, 8, po(6), 60, 0, 0),
        A7(go, 1996, Hc, 9, po(6), 60, 0, 0)
    ]), Gs = function() {
        return vo(A2(Zc, g, A2(Mc, 420, Ao(0))));
    }, zs = w([
        A7(go, 1972, 1972, 5, mo(22), 0, 2, 60),
        A7(go, 1972, 1977, 9, mo(1), 0, 2, 0),
        A7(go, 1973, 1977, 4, mo(1), 0, 2, 60),
        A7(go, 1978, 1978, 3, mo(30), 0, 2, 60),
        A7(go, 1978, 1978, 8, mo(30), 0, 2, 0),
        A7(go, 1984, 1987, 4, mo(1), 0, 2, 60),
        A7(go, 1984, 1991, 9, mo(16), 0, 2, 0),
        A7(go, 1988, 1988, 5, mo(1), 0, 2, 60),
        A7(go, 1989, 1989, 4, mo(10), 0, 2, 60),
        A7(go, 1990, 1992, 4, mo(1), 0, 2, 60),
        A7(go, 1992, 1992, 9, mo(4), 0, 2, 0),
        A7(go, 1993, Hc, 2, po(6), 0, 2, 60),
        A7(go, 1993, 1998, 8, po(6), 0, 2, 0),
        A7(go, 1999, Hc, 9, po(6), 0, 2, 0)
    ]), Ss = w([
        A7(go, 1992, 1996, 3, A2($o, 6, 7), 0, 1, 60),
        A7(go, 1992, 1996, 8, po(6), 0, 2, 0),
        A7(go, 1997, 2005, 2, po(6), 150, 2, 60),
        A7(go, 1997, 2004, 9, po(6), 150, 2, 0)
    ]), Ts = w([
        A7(go, 1983, 1984, 3, mo(1), 0, 2, 60),
        A7(go, 1983, 1983, 9, mo(1), 0, 2, 0),
        A7(go, 1985, 1998, 2, po(6), 0, 2, 60),
        A7(go, 1984, 1998, 8, po(6), 0, 2, 0),
        A7(go, 2001, 2001, 3, po(5), 120, 2, 60),
        A7(go, 2001, 2006, 8, po(5), 120, 2, 0),
        A7(go, 2002, 2006, 2, po(5), 120, 2, 60),
        A7(go, 2015, 2016, 2, po(5), 120, 2, 60),
        A7(go, 2015, 2016, 8, po(5), 0, 2, 0)
    ]), Ps = w([
        A7(go, 1966, 1976, 9, mo(1), 120, 2, 0),
        A7(go, 1967, 1978, 4, mo(1), 120, 2, 60),
        A7(go, 1977, 1978, 8, mo(1), 120, 2, 0),
        A7(go, 1983, 1984, 3, mo(9), 120, 2, 60),
        A7(go, 1983, 1984, 9, mo(1), 120, 2, 0),
        A7(go, 1986, 1986, 1, mo(16), 120, 2, 60),
        A7(go, 1986, 1986, 9, mo(9), 120, 2, 0),
        A7(go, 1987, 1987, 2, mo(1), 120, 2, 60),
        A7(go, 1987, 1988, 9, mo(31), 120, 2, 0),
        A7(go, 1988, 1988, 2, mo(15), 120, 2, 60),
        A7(go, 1989, 1989, 2, mo(31), 120, 2, 60),
        A7(go, 1989, 1989, 9, mo(1), 120, 2, 0),
        A7(go, 1990, 1990, 3, mo(1), 120, 2, 60),
        A7(go, 1990, 1990, 8, mo(30), 120, 2, 0),
        A7(go, 1991, 1991, 3, mo(1), 0, 2, 60),
        A7(go, 1991, 1992, 9, mo(1), 0, 2, 0),
        A7(go, 1992, 1992, 3, mo(8), 0, 2, 60),
        A7(go, 1993, 1993, 2, mo(26), 0, 2, 60),
        A7(go, 1993, 1993, 8, mo(25), 0, 2, 0),
        A7(go, 1994, 1996, 3, mo(1), 0, 2, 60),
        A7(go, 1994, 2005, 9, mo(1), 0, 2, 0),
        A7(go, 1997, 1998, 2, po(0), 0, 2, 60),
        A7(go, 1999, 2006, 3, mo(1), 0, 2, 60),
        A7(go, 2006, 2006, 8, mo(22), 0, 2, 0),
        A7(go, 2007, 2007, 2, po(4), 0, 2, 60),
        A7(go, 2007, 2007, 10, A2($o, 4, 1), 0, 2, 0),
        A7(go, 2008, 2008, 3, A2($o, 4, 1), 0, 2, 60),
        A7(go, 2008, 2008, 10, mo(1), 0, 2, 0),
        A7(go, 2009, 2009, 2, po(4), 0, 2, 60),
        A7(go, 2010, 2011, 3, A2($o, 4, 1), 0, 2, 60),
        A7(go, 2012, Hc, 2, po(4), 0, 2, 60),
        A7(go, 2009, Hc, 9, po(4), 0, 2, 0)
    ]), Zs = w([
        A7(go, 2009, 2009, 5, mo(19), 1380, 2, 60),
        A7(go, 2009, 2009, 11, mo(31), 1440, 2, 0)
    ]), Ms = function() {
        return vo(A2(Zc, g, A2(Mc, 240, Ao(0))));
    }, Ls = w([
        A7(go, 1975, 1975, 3, mo(13), 0, 2, 60),
        A7(go, 1975, 1975, 9, mo(12), 0, 2, 0),
        A7(go, 1976, 1976, 4, mo(15), 0, 2, 60),
        A7(go, 1976, 1976, 9, mo(11), 0, 2, 0),
        A7(go, 1977, 1980, 3, A2($o, 6, 1), 0, 2, 60),
        A7(go, 1977, 1977, 8, mo(25), 0, 2, 0),
        A7(go, 1978, 1978, 9, mo(2), 0, 2, 0),
        A7(go, 1979, 1997, 8, po(6), 0, 2, 0),
        A7(go, 1981, 1998, 2, po(6), 0, 2, 60)
    ]), Ns = w([
        A7(go, 1999, 2005, 3, A2($o, 4, 15), 0, 2, 60),
        A7(go, 1999, 2003, 9, A2($o, 4, 15), 0, 2, 0),
        A7(go, 2004, 2004, 9, mo(1), 60, 2, 0),
        A7(go, 2005, 2005, 9, mo(4), 120, 2, 0),
        A7(go, 2006, 2007, 3, mo(1), 0, 2, 60),
        A7(go, 2006, 2006, 8, mo(22), 0, 2, 0),
        A7(go, 2007, 2007, 8, mo(13), 120, 2, 0),
        A7(go, 2008, 2009, 2, po(4), 0, 2, 60),
        A7(go, 2008, 2008, 8, mo(1), 0, 2, 0),
        A7(go, 2009, 2009, 8, mo(4), 60, 2, 0),
        A7(go, 2010, 2010, 2, mo(26), 0, 2, 60),
        A7(go, 2010, 2010, 7, mo(11), 0, 2, 0),
        A7(go, 2011, 2011, 3, mo(1), 1, 2, 60),
        A7(go, 2011, 2011, 7, mo(1), 0, 2, 0),
        A7(go, 2011, 2011, 7, mo(30), 0, 2, 60),
        A7(go, 2011, 2011, 8, mo(30), 0, 2, 0),
        A7(go, 2012, 2014, 2, po(3), 1440, 2, 60),
        A7(go, 2012, 2012, 8, mo(21), 60, 2, 0),
        A7(go, 2013, 2013, 8, mo(27), 0, 2, 0),
        A7(go, 2014, 2014, 9, mo(24), 0, 2, 0),
        A7(go, 2015, 2015, 2, mo(28), 0, 2, 60),
        A7(go, 2015, 2015, 9, mo(23), 60, 2, 0),
        A7(go, 2016, 2018, 2, A2($o, 5, 24), 60, 2, 60),
        A7(go, 2016, 2018, 9, A2($o, 5, 24), 60, 2, 0),
        A7(go, 2019, 2019, 2, mo(29), 0, 2, 60),
        A7(go, 2019, 2019, 9, A2($o, 5, 24), 0, 2, 0),
        A7(go, 2020, Hc, 2, A2($o, 5, 24), 0, 2, 60),
        A7(go, 2020, Hc, 9, A2($o, 5, 24), 60, 2, 0)
    ]), Hs = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Is = w([
        A7(go, 1974, 1974, 6, mo(7), 0, 2, 60),
        A7(go, 1974, 1974, 9, mo(13), 0, 2, 0),
        A7(go, 1975, 1975, 3, mo(20), 0, 2, 60),
        A7(go, 1975, 1975, 7, mo(31), 0, 2, 0),
        A7(go, 1980, 1980, 7, mo(2), 0, 2, 60),
        A7(go, 1980, 1980, 8, mo(13), 60, 2, 0),
        A7(go, 1984, 1984, 4, mo(5), 0, 2, 60),
        A7(go, 1984, 1984, 7, mo(25), 60, 2, 0),
        A7(go, 1985, 1985, 3, mo(14), 0, 2, 60),
        A7(go, 1985, 1985, 8, mo(15), 0, 2, 0),
        A7(go, 1986, 1986, 4, mo(18), 0, 2, 60),
        A7(go, 1986, 1986, 8, mo(7), 0, 2, 0),
        A7(go, 1987, 1987, 3, mo(15), 0, 2, 60),
        A7(go, 1987, 1987, 8, mo(13), 0, 2, 0),
        A7(go, 1988, 1988, 3, mo(10), 0, 2, 60),
        A7(go, 1988, 1988, 8, mo(4), 0, 2, 0),
        A7(go, 1989, 1989, 3, mo(30), 0, 2, 60),
        A7(go, 1989, 1989, 8, mo(3), 0, 2, 0),
        A7(go, 1990, 1990, 2, mo(25), 0, 2, 60),
        A7(go, 1990, 1990, 7, mo(26), 0, 2, 0),
        A7(go, 1991, 1991, 2, mo(24), 0, 2, 60),
        A7(go, 1991, 1991, 8, mo(1), 0, 2, 0),
        A7(go, 1992, 1992, 2, mo(29), 0, 2, 60),
        A7(go, 1992, 1992, 8, mo(6), 0, 2, 0),
        A7(go, 1993, 1993, 3, mo(2), 0, 2, 60),
        A7(go, 1993, 1993, 8, mo(5), 0, 2, 0),
        A7(go, 1994, 1994, 3, mo(1), 0, 2, 60),
        A7(go, 1994, 1994, 7, mo(28), 0, 2, 0),
        A7(go, 1995, 1995, 2, mo(31), 0, 2, 60),
        A7(go, 1995, 1995, 8, mo(3), 0, 2, 0),
        A7(go, 1996, 1996, 2, mo(15), 0, 2, 60),
        A7(go, 1996, 1996, 8, mo(16), 0, 2, 0),
        A7(go, 1997, 1997, 2, mo(21), 0, 2, 60),
        A7(go, 1997, 1997, 8, mo(14), 0, 2, 0),
        A7(go, 1998, 1998, 2, mo(20), 0, 2, 60),
        A7(go, 1998, 1998, 8, mo(6), 0, 2, 0),
        A7(go, 1999, 1999, 3, mo(2), 120, 2, 60),
        A7(go, 1999, 1999, 8, mo(3), 120, 2, 0),
        A7(go, 2e3, 2e3, 3, mo(14), 120, 2, 60),
        A7(go, 2e3, 2e3, 9, mo(6), 60, 2, 0),
        A7(go, 2001, 2001, 3, mo(9), 60, 2, 60),
        A7(go, 2001, 2001, 8, mo(24), 60, 2, 0),
        A7(go, 2002, 2002, 2, mo(29), 60, 2, 60),
        A7(go, 2002, 2002, 9, mo(7), 60, 2, 0),
        A7(go, 2003, 2003, 2, mo(28), 60, 2, 60),
        A7(go, 2003, 2003, 9, mo(3), 60, 2, 0),
        A7(go, 2004, 2004, 3, mo(7), 60, 2, 60),
        A7(go, 2004, 2004, 8, mo(22), 60, 2, 0),
        A7(go, 2005, 2012, 3, A2(Hs, 4, 1), 120, 2, 60),
        A7(go, 2005, 2005, 9, mo(9), 120, 2, 0),
        A7(go, 2006, 2006, 9, mo(1), 120, 2, 0),
        A7(go, 2007, 2007, 8, mo(16), 120, 2, 0),
        A7(go, 2008, 2008, 9, mo(5), 120, 2, 0),
        A7(go, 2009, 2009, 8, mo(27), 120, 2, 0),
        A7(go, 2010, 2010, 8, mo(12), 120, 2, 0),
        A7(go, 2011, 2011, 9, mo(2), 120, 2, 0),
        A7(go, 2012, 2012, 8, mo(23), 120, 2, 0),
        A7(go, 2013, Hc, 2, A2($o, 4, 23), 120, 2, 60),
        A7(go, 2013, Hc, 9, po(6), 120, 2, 0)
    ]), Os = w([
        A7(go, 1965, 1976, 3, A2($o, 6, 16), 210, 2, 60),
        A7(go, 1965, 1976, 9, A2($o, 6, 16), 210, 2, 0),
        A7(go, 1973, 1973, 11, mo(30), 210, 2, 60),
        A7(go, 1979, 1979, 4, mo(13), 210, 2, 60),
        A7(go, 1979, 1979, 9, mo(21), 210, 2, 0)
    ]), Qs = w([
        A7(go, 1973, 1973, 5, mo(3), 60, 2, 60),
        A7(go, 1973, 1976, 9, A2($o, 6, 31), 120, 2, 0),
        A7(go, 1974, 1974, 2, mo(31), 120, 2, 60),
        A7(go, 1975, 1975, 2, mo(22), 120, 2, 60),
        A7(go, 1976, 1976, 2, mo(21), 120, 2, 60),
        A7(go, 1977, 1978, 3, A2($o, 6, 1), 120, 2, 60),
        A7(go, 1977, 1978, 9, A2($o, 6, 15), 120, 2, 0),
        A7(go, 1978, 1978, 5, mo(29), 0, 2, 0),
        A7(go, 1983, 1983, 6, mo(31), 120, 2, 60),
        A7(go, 1983, 1983, 9, mo(2), 120, 2, 0),
        A7(go, 1985, 1985, 3, mo(20), 60, 1, 60),
        A7(go, 1985, 1985, 8, mo(28), 60, 1, 0),
        A7(go, 1986, 1993, 2, po(6), 60, 1, 60),
        A7(go, 1986, 1995, 8, po(6), 60, 1, 0),
        A7(go, 1994, 1994, 2, mo(20), 60, 1, 60),
        A7(go, 1995, 2006, 2, po(6), 60, 1, 60),
        A7(go, 1996, 2006, 9, po(6), 60, 1, 0)
    ]), Rs = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 120, Pc(Qs)), A5(Ic, 1978, 5, 29, 0, 2)),
            v(A2(Mc, 180, Pc(Qs)), A5(Ic, 1984, 10, 1, 120, 2)),
            v(A2(Mc, 120, Pc(Qs)), A5(Ic, 2007, 0, 1, 0, 2)),
            v(A2(Mc, 120, Pc(Lo)), A5(Ic, 2011, 2, 27, 60, 0)),
            v(A2(Mc, 120, Ao(0)), A5(Ic, 2011, 2, 28, 60, 0)),
            v(A2(Mc, 120, Pc(Lo)), A5(Ic, 2014, 2, 30, 60, 0)),
            v(A2(Mc, 120, Ao(0)), A5(Ic, 2014, 2, 31, 60, 0)),
            v(A2(Mc, 120, Pc(Lo)), A5(Ic, 2015, 9, 25, 60, 0)),
            v(A2(Mc, 120, Ao(60)), A5(Ic, 2015, 10, 8, 60, 0)),
            v(A2(Mc, 120, Pc(Lo)), A5(Ic, 2016, 8, 7, 0, 2))
        ]), A2(Mc, 180, Ao(0))));
    }, Us = Rs, Ks = w([
        A7(go, 2002, 2002, 3, A2($o, 6, 2), 0, 2, 60),
        A7(go, 2002, 2002, 9, A2($o, 6, 2), 0, 2, 0),
        A7(go, 2008, 2008, 5, mo(1), 0, 2, 60),
        A7(go, 2008, 2009, 10, mo(1), 0, 2, 0),
        A7(go, 2009, 2009, 3, mo(15), 0, 2, 60)
    ]), Ws = Cs, Xs = w([
        A7(go, 1965, 1973, 3, A2($o, 6, 16), 210, 2, 60),
        A7(go, 1967, 1976, 9, A2($o, 6, 16), 210, 2, 0),
        A7(go, 1973, 1973, 11, mo(30), 210, 2, 60),
        A7(go, 1975, 1976, 3, A2($o, 6, 16), 210, 2, 60),
        A7(go, 1979, 1979, 4, mo(13), 210, 2, 60),
        A7(go, 1979, 1979, 9, A2($o, 6, 16), 210, 2, 0)
    ]), Ys = w([
        A7(go, 1978, 1978, 2, mo(22), 0, 2, 60),
        A7(go, 1978, 1978, 8, mo(21), 0, 2, 0)
    ]), Js = Ms, nl = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 120, Pc(Ls)), A5(Ic, 1998, 8, 1, 0, 2))
        ]), A2(Mc, 120, Pc(Bs))));
    }, rl = Gs, tl = w([
        A7(go, 1987, 1988, 4, A2($o, 6, 8), 120, 2, 60),
        A7(go, 1987, 1988, 9, A2($o, 6, 8), 180, 2, 0)
    ]), el = w([
        A7(go, 1986, 1986, 4, mo(4), 120, 2, 60),
        A7(go, 1986, 1991, 8, A2($o, 6, 11), 120, 2, 0),
        A7(go, 1987, 1991, 3, A2($o, 6, 11), 120, 2, 60)
    ]), ul = w([
        A7(go, 1974, 1975, 3, mo(1), 0, 2, 60),
        A7(go, 1974, 1975, 9, mo(1), 0, 2, 0),
        A7(go, 1979, 1979, 6, mo(1), 0, 2, 60),
        A7(go, 1979, 1979, 9, mo(1), 0, 2, 0)
    ]), al = w([
        A7(go, 1981, Hc, 2, po(6), 0, 2, 60),
        A7(go, 1979, 1995, 8, po(6), 0, 2, 0),
        A7(go, 1996, Hc, 9, po(6), 0, 2, 0)
    ]), il = w([
        A7(go, 1978, 1980, 2, mo(20), 1440, 2, 60),
        A7(go, 1978, 1978, 9, mo(20), 1440, 2, 0),
        A7(go, 1979, 1979, 8, mo(18), 1440, 2, 0),
        A7(go, 1980, 1980, 8, mo(22), 1440, 2, 0),
        A7(go, 1991, 1991, 4, mo(2), 1440, 2, 60),
        A7(go, 1992, 1995, 2, mo(21), 1440, 2, 60),
        A7(go, 1991, 1995, 8, mo(21), 1440, 2, 0),
        A7(go, 1996, 1996, 2, mo(20), 1440, 2, 60),
        A7(go, 1996, 1996, 8, mo(20), 1440, 2, 0),
        A7(go, 1997, 1999, 2, mo(21), 1440, 2, 60),
        A7(go, 1997, 1999, 8, mo(21), 1440, 2, 0),
        A7(go, 2e3, 2e3, 2, mo(20), 1440, 2, 60),
        A7(go, 2e3, 2e3, 8, mo(20), 1440, 2, 0),
        A7(go, 2001, 2003, 2, mo(21), 1440, 2, 60),
        A7(go, 2001, 2003, 8, mo(21), 1440, 2, 0),
        A7(go, 2004, 2004, 2, mo(20), 1440, 2, 60),
        A7(go, 2004, 2004, 8, mo(20), 1440, 2, 0),
        A7(go, 2005, 2005, 2, mo(21), 1440, 2, 60),
        A7(go, 2005, 2005, 8, mo(21), 1440, 2, 0),
        A7(go, 2008, 2008, 2, mo(20), 1440, 2, 60),
        A7(go, 2008, 2008, 8, mo(20), 1440, 2, 0),
        A7(go, 2009, 2011, 2, mo(21), 1440, 2, 60),
        A7(go, 2009, 2011, 8, mo(21), 1440, 2, 0),
        A7(go, 2012, 2012, 2, mo(20), 1440, 2, 60),
        A7(go, 2012, 2012, 8, mo(20), 1440, 2, 0),
        A7(go, 2013, 2015, 2, mo(21), 1440, 2, 60),
        A7(go, 2013, 2015, 8, mo(21), 1440, 2, 0),
        A7(go, 2016, 2016, 2, mo(20), 1440, 2, 60),
        A7(go, 2016, 2016, 8, mo(20), 1440, 2, 0),
        A7(go, 2017, 2019, 2, mo(21), 1440, 2, 60),
        A7(go, 2017, 2019, 8, mo(21), 1440, 2, 0),
        A7(go, 2020, 2020, 2, mo(20), 1440, 2, 60),
        A7(go, 2020, 2020, 8, mo(20), 1440, 2, 0),
        A7(go, 2021, 2023, 2, mo(21), 1440, 2, 60),
        A7(go, 2021, 2023, 8, mo(21), 1440, 2, 0),
        A7(go, 2024, 2024, 2, mo(20), 1440, 2, 60),
        A7(go, 2024, 2024, 8, mo(20), 1440, 2, 0),
        A7(go, 2025, 2027, 2, mo(21), 1440, 2, 60),
        A7(go, 2025, 2027, 8, mo(21), 1440, 2, 0),
        A7(go, 2028, 2029, 2, mo(20), 1440, 2, 60),
        A7(go, 2028, 2029, 8, mo(20), 1440, 2, 0),
        A7(go, 2030, 2031, 2, mo(21), 1440, 2, 60),
        A7(go, 2030, 2031, 8, mo(21), 1440, 2, 0),
        A7(go, 2032, 2033, 2, mo(20), 1440, 2, 60),
        A7(go, 2032, 2033, 8, mo(20), 1440, 2, 0),
        A7(go, 2034, 2035, 2, mo(21), 1440, 2, 60),
        A7(go, 2034, 2035, 8, mo(21), 1440, 2, 0),
        A7(go, 2036, 2037, 2, mo(20), 1440, 2, 60),
        A7(go, 2036, 2037, 8, mo(20), 1440, 2, 0)
    ]), cl = Gs, ol = w([
        A7(go, 2011, 2011, 2, po(6), 120, 1, 60),
        A7(go, 2011, 2011, 9, po(6), 120, 1, 0)
    ]), fl = w([
        A7(go, 1977, 1977, 2, mo(27), 0, 1, 60),
        A7(go, 1977, 1977, 8, mo(25), 0, 1, 0),
        A7(go, 1978, 1979, 3, A2($o, 6, 1), 0, 1, 60),
        A7(go, 1978, 1978, 9, mo(1), 0, 1, 0),
        A7(go, 1979, 1982, 8, po(6), 60, 1, 0),
        A7(go, 1980, 1980, 2, po(6), 0, 1, 60),
        A7(go, 1981, 1982, 2, po(6), 60, 1, 60),
        A7(go, 1983, 1983, 2, po(6), 120, 1, 60)
    ]), sl = w([
        A7(go, 1977, 1980, 3, A2($o, 6, 1), 60, 1, 60),
        A7(go, 1977, 1977, 8, po(6), 60, 1, 0),
        A7(go, 1978, 1978, 9, mo(1), 60, 1, 0),
        A7(go, 1979, 1995, 8, po(6), 60, 1, 0),
        A7(go, 1981, Hc, 2, po(6), 60, 1, 60),
        A7(go, 1996, Hc, 9, po(6), 60, 1, 0)
    ]), ll = ko, dl = w([
        A7(go, 1983, 1983, 8, po(6), 0, 2, 60),
        A7(go, 1984, 1985, 3, po(6), 0, 2, 0),
        A7(go, 1984, 1984, 8, mo(16), 0, 2, 60),
        A7(go, 1985, 2e3, 8, A2($o, 6, 9), 0, 2, 60),
        A7(go, 1986, 2e3, 3, A2($o, 6, 16), 0, 2, 0),
        A7(go, 2001, 2010, 3, A2($o, 6, 15), 120, 2, 0),
        A7(go, 2001, 2010, 8, A2($o, 6, 1), 120, 2, 60)
    ]), vl = w([
        A7(go, 1971, 1985, 9, po(6), 120, 1, 60),
        A7(go, 1986, 1986, 9, mo(19), 120, 1, 60),
        A7(go, 1987, 2007, 9, po(6), 120, 1, 60),
        A7(go, 1972, 1972, 1, mo(27), 120, 1, 0),
        A7(go, 1973, 1985, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1986, 1990, 2, A2($o, 6, 15), 120, 1, 0),
        A7(go, 1991, 1991, 2, mo(3), 120, 1, 0),
        A7(go, 1992, 1992, 2, mo(22), 120, 1, 0),
        A7(go, 1993, 1993, 2, mo(7), 120, 1, 0),
        A7(go, 1994, 1994, 2, mo(20), 120, 1, 0),
        A7(go, 1995, 2005, 2, po(6), 120, 1, 0),
        A7(go, 2006, 2006, 3, mo(2), 120, 1, 0),
        A7(go, 2007, 2007, 2, po(6), 120, 1, 0),
        A7(go, 2008, Hc, 3, A2($o, 6, 1), 120, 1, 0),
        A7(go, 2008, Hc, 9, A2($o, 6, 1), 120, 1, 60)
    ]), bl = w([
        A7(go, 1971, 1971, 9, po(6), 120, 1, 60),
        A7(go, 1972, 1972, 1, po(6), 120, 1, 0),
        A7(go, 1989, 1991, 9, po(6), 120, 1, 60),
        A7(go, 1990, 1992, 2, A2($o, 6, 1), 120, 1, 0)
    ]), ml = w([
        A7(go, 1971, 1985, 9, po(6), 120, 1, 60),
        A7(go, 1972, 1972, 1, mo(27), 120, 1, 0),
        A7(go, 1973, 1981, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1982, 1982, 3, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1983, 1985, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1986, 1989, 2, A2($o, 6, 15), 120, 1, 0),
        A7(go, 1986, 1986, 9, mo(19), 120, 1, 60),
        A7(go, 1987, 1999, 9, po(6), 120, 1, 60),
        A7(go, 1990, 1995, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1996, 2005, 2, po(6), 120, 1, 0),
        A7(go, 2e3, 2e3, 7, po(6), 120, 1, 60),
        A7(go, 2001, 2007, 9, po(6), 120, 1, 60),
        A7(go, 2006, 2006, 3, A2($o, 6, 1), 120, 1, 0),
        A7(go, 2007, 2007, 2, po(6), 120, 1, 0),
        A7(go, 2008, Hc, 3, A2($o, 6, 1), 120, 1, 0),
        A7(go, 2008, Hc, 9, A2($o, 6, 1), 120, 1, 60)
    ]), pl = w([
        A7(go, 1974, 1974, 9, po(6), 120, 1, 60),
        A7(go, 1975, 1975, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1983, 1983, 9, po(6), 120, 1, 60),
        A7(go, 1984, 1984, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1991, 1991, 10, mo(17), 120, 1, 60),
        A7(go, 1992, 1992, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 2006, 2006, 11, mo(3), 120, 1, 60),
        A7(go, 2007, 2009, 2, po(6), 120, 1, 0),
        A7(go, 2007, 2008, 9, po(6), 120, 1, 60)
    ]), $l = w([
        A7(go, 1992, 1993, 9, po(6), 120, 1, 60),
        A7(go, 1993, 1994, 2, A2($o, 6, 1), 120, 1, 0)
    ]), gl = w([
        A7(go, 1981, 1984, 9, po(6), 120, 2, 60),
        A7(go, 1982, 1985, 2, A2($o, 6, 1), 120, 2, 0),
        A7(go, 1985, 1985, 9, po(6), 120, 2, 30),
        A7(go, 1986, 1989, 2, A2($o, 6, 15), 120, 2, 0),
        A7(go, 1986, 1986, 9, mo(19), 120, 2, 30),
        A7(go, 1987, 1999, 9, po(6), 120, 2, 30),
        A7(go, 1990, 1995, 2, A2($o, 6, 1), 120, 2, 0),
        A7(go, 1996, 2005, 2, po(6), 120, 2, 0),
        A7(go, 2e3, 2e3, 7, po(6), 120, 2, 30),
        A7(go, 2001, 2007, 9, po(6), 120, 2, 30),
        A7(go, 2006, 2006, 3, A2($o, 6, 1), 120, 2, 0),
        A7(go, 2007, 2007, 2, po(6), 120, 2, 0),
        A7(go, 2008, Hc, 3, A2($o, 6, 1), 120, 2, 0),
        A7(go, 2008, Hc, 9, A2($o, 6, 1), 120, 2, 30)
    ]), hl = w([
        A7(go, 1971, 1985, 9, po(6), 120, 1, 60),
        A7(go, 1972, 1972, 1, po(6), 120, 1, 0),
        A7(go, 1973, 1985, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1986, 1990, 2, A2($o, 6, 15), 120, 1, 0),
        A7(go, 1986, 1987, 9, A2($o, 6, 15), 120, 1, 60),
        A7(go, 1988, 1999, 9, po(6), 120, 1, 60),
        A7(go, 1991, 1994, 2, A2($o, 6, 1), 120, 1, 0),
        A7(go, 1995, 2005, 2, po(6), 120, 1, 0),
        A7(go, 2e3, 2e3, 7, po(6), 120, 1, 60),
        A7(go, 2001, 2007, 9, po(6), 120, 1, 60),
        A7(go, 2006, 2006, 3, A2($o, 6, 1), 120, 1, 0),
        A7(go, 2007, 2007, 2, po(6), 120, 1, 0),
        A7(go, 2008, Hc, 3, A2($o, 6, 1), 120, 1, 0),
        A7(go, 2008, Hc, 9, A2($o, 6, 1), 120, 1, 60)
    ]), yl = w([
        A7(go, 1975, 1975, 3, mo(12), 0, 1, 60),
        A7(go, 1975, 1975, 10, mo(26), 0, 1, 0),
        A7(go, 1976, 1976, 3, mo(11), 120, 1, 60),
        A7(go, 1976, 1976, 9, mo(10), 120, 1, 0),
        A7(go, 1977, 1978, 3, A2($o, 6, 1), 120, 1, 60),
        A7(go, 1977, 1977, 8, mo(26), 120, 1, 0),
        A7(go, 1978, 1978, 8, mo(24), 240, 2, 0),
        A7(go, 1979, 1979, 3, mo(1), 540, 2, 60),
        A7(go, 1979, 1979, 8, mo(29), 120, 2, 0),
        A7(go, 1980, 1980, 3, mo(1), 0, 2, 60),
        A7(go, 1980, 1980, 8, mo(28), 0, 2, 0)
    ]), wl = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 60, Ao(0)), A5(Ic, 1982, 10, 27, 0, 2))
        ]), A2(Mc, 60, Pc(Lo))));
    }, xl = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 60, Ao(0)), A5(Ic, 1979, 0, 1, 0, 2))
        ]), A2(Mc, 60, Pc(Lo))));
    }, _l = xl, Cl = w([
        A7(go, 1977, 1980, 3, A2($o, 6, 1), 0, 2, 60),
        A7(go, 1977, 1977, 8, po(6), 0, 2, 0),
        A7(go, 1978, 1978, 9, mo(1), 0, 2, 0),
        A7(go, 1979, 1995, 8, po(6), 0, 2, 0),
        A7(go, 1981, Hc, 2, po(6), 0, 2, 60),
        A7(go, 1996, Hc, 9, po(6), 0, 2, 0)
    ]), Al = w([
        A7(go, 1979, 1979, 4, mo(27), 0, 2, 60),
        A7(go, 1979, 1979, 8, po(6), 0, 2, 0),
        A7(go, 1980, 1980, 3, mo(5), 1380, 2, 60),
        A7(go, 1980, 1980, 8, po(6), 60, 2, 0),
        A7(go, 1991, 1993, 2, po(6), 0, 1, 60),
        A7(go, 1991, 1993, 8, po(6), 0, 1, 0)
    ]), kl = w([
        A7(go, 1980, 1980, 3, mo(6), 0, 2, 60),
        A7(go, 1980, 1980, 8, mo(28), 60, 2, 0),
        A7(go, 1981, 1983, 2, po(6), 0, 2, 60),
        A7(go, 1981, 1983, 8, po(6), 60, 2, 0)
    ]), El = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 60, Ao(0)), A5(Ic, 1981, 0, 1, 0, 2))
        ]), A2(Mc, 60, Pc(Lo))));
    }, ql = El, Fl = w([
        A7(go, 1997, Hc, 2, po(6), 120, 2, 60),
        A7(go, 1997, Hc, 9, po(6), 180, 2, 0)
    ]), jl = w([
        A7(go, 1971, 1971, 9, mo(31), 120, 0, -60),
        A7(go, 1972, 1980, 2, A2($o, 6, 16), 120, 0, 0),
        A7(go, 1972, 1980, 9, A2($o, 6, 23), 120, 0, -60),
        A7(go, 1981, Hc, 2, po(6), 60, 0, 0),
        A7(go, 1981, 1989, 9, A2($o, 6, 23), 60, 0, -60),
        A7(go, 1990, 1995, 9, A2($o, 6, 22), 60, 0, -60),
        A7(go, 1996, Hc, 9, po(6), 60, 0, -60)
    ]), Dl = w([
        A7(go, 1972, 1980, 2, A2($o, 6, 16), 120, 1, 60),
        A7(go, 1972, 1980, 9, A2($o, 6, 23), 120, 1, 0),
        A7(go, 1981, 1995, 2, po(6), 60, 0, 60),
        A7(go, 1981, 1989, 9, A2($o, 6, 23), 60, 0, 0),
        A7(go, 1990, 1995, 9, A2($o, 6, 22), 60, 0, 0)
    ]), Vl = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 60, Ao(0)), A5(Ic, 1971, 9, 31, 120, 0)),
            v(A2(Mc, 0, Pc(Dl)), A5(Ic, 1996, 0, 1, 0, 2))
        ]), A2(Mc, 0, Pc(Lo))));
    }, Bl = Vl, Gl = w([
        A7(go, 1981, 1982, 2, po(6), 120, 2, 60),
        A7(go, 1981, 1982, 8, po(6), 180, 2, 0)
    ]), zl = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 120, Pc(Gl)), A5(Ic, 1983, 0, 1, 0, 2))
        ]), A2(Mc, 120, Pc(Lo))));
    }, Sl = Vl, Tl = Vl, Pl = wl, Zl = w([
        A7(go, 1974, 1975, 3, A2($o, 5, 12), 1380, 2, 60),
        A7(go, 1974, 1975, 9, A2($o, 6, 1), 60, 2, 0),
        A7(go, 1976, 1976, 2, mo(27), 1380, 2, 60),
        A7(go, 1976, 1977, 8, po(6), 60, 2, 0),
        A7(go, 1977, 1977, 3, mo(2), 1380, 2, 60),
        A7(go, 1978, 1978, 3, mo(2), 120, 1, 60),
        A7(go, 1978, 1978, 9, mo(1), 120, 1, 0)
    ]), Ml = w([
        A7(go, 1967, 1969, 8, A2($o, 6, 22), 0, 1, 0),
        A7(go, 1969, 1969, 5, mo(1), 0, 1, 60),
        A7(go, 1970, 1970, 4, mo(31), 0, 1, 60),
        A7(go, 1970, 1970, 8, po(6), 0, 1, 0),
        A7(go, 1971, 1972, 4, A2($o, 6, 22), 0, 1, 60),
        A7(go, 1971, 1971, 8, po(6), 0, 1, 0),
        A7(go, 1972, 1972, 9, mo(1), 0, 1, 0),
        A7(go, 1973, 1973, 5, mo(3), 0, 1, 60),
        A7(go, 1973, 1974, 8, po(6), 0, 1, 0),
        A7(go, 1974, 1974, 4, mo(26), 0, 1, 60),
        A7(go, 1975, 1975, 5, mo(1), 0, 1, 60),
        A7(go, 1975, 1977, 8, po(6), 0, 1, 0),
        A7(go, 1976, 1976, 4, mo(30), 0, 1, 60),
        A7(go, 1977, 1979, 4, A2($o, 6, 22), 0, 1, 60),
        A7(go, 1978, 1978, 9, mo(1), 0, 1, 0),
        A7(go, 1979, 1979, 8, mo(30), 0, 1, 0)
    ]), Ll = w([
        A7(go, 1973, 1973, 2, mo(31), 0, 1, 60),
        A7(go, 1973, 1973, 8, mo(29), 0, 1, 0),
        A7(go, 1974, 1974, 3, mo(21), 0, 1, 60),
        A7(go, 1974, 1974, 8, mo(16), 0, 1, 0),
        A7(go, 1975, 1979, 3, A2($o, 6, 15), 120, 2, 60),
        A7(go, 1975, 1980, 8, A2($o, 6, 15), 120, 2, 0),
        A7(go, 1980, 1980, 2, mo(31), 120, 2, 60)
    ]), Nl = zl, Hl = w([
        A7(go, 1976, 1976, 2, mo(28), 60, 2, 60),
        A7(go, 1976, 1976, 8, mo(26), 60, 2, 0)
    ]), Il = nl, Ol = wl, Ql = w([
        A7(go, 1989, 1996, 2, po(6), 120, 1, 60),
        A7(go, 1989, 1996, 8, po(6), 120, 1, 0)
    ]), Rl = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 60, Pc(Ml)), A5(Ic, 1980, 0, 1, 0, 2))
        ]), A2(Mc, 60, Pc(Lo))));
    }, Ul = Rl, Kl = wl, Wl = wl, Xl = w([
        A7(go, 1979, 1979, 2, mo(31), 1380, 2, 60),
        A7(go, 1979, 1979, 9, mo(1), 60, 2, 0),
        A7(go, 1980, 1982, 3, A2($o, 5, 1), 1380, 2, 60),
        A7(go, 1980, 1980, 8, mo(29), 60, 2, 0),
        A7(go, 1981, 1981, 8, mo(27), 120, 2, 0)
    ]), Yl = w([
        A7(go, 1974, 1974, 4, mo(4), 0, 2, 60),
        A7(go, 1974, 1974, 9, mo(2), 0, 2, 0),
        A7(go, 1975, 1975, 4, mo(1), 0, 2, 60),
        A7(go, 1975, 1975, 9, mo(2), 0, 2, 0),
        A7(go, 1976, 1976, 4, mo(2), 0, 2, 60),
        A7(go, 1976, 1976, 9, mo(3), 0, 2, 0),
        A7(go, 1977, 1977, 4, mo(8), 0, 2, 60),
        A7(go, 1977, 1977, 9, mo(2), 0, 2, 0),
        A7(go, 1978, 1978, 4, mo(6), 0, 2, 60),
        A7(go, 1978, 1978, 9, mo(1), 0, 2, 0),
        A7(go, 1979, 1979, 4, mo(5), 0, 2, 60),
        A7(go, 1979, 1979, 8, mo(30), 0, 2, 0),
        A7(go, 1980, 1980, 4, mo(3), 0, 2, 60),
        A7(go, 1980, 1980, 9, mo(4), 0, 2, 0),
        A7(go, 1981, 1981, 3, mo(26), 0, 2, 60),
        A7(go, 1981, 1981, 8, mo(27), 0, 2, 0),
        A7(go, 1982, 1982, 4, mo(2), 0, 2, 60),
        A7(go, 1982, 1982, 9, mo(3), 0, 2, 0),
        A7(go, 1983, 1983, 3, mo(18), 0, 2, 60),
        A7(go, 1983, 1983, 9, mo(1), 0, 2, 0),
        A7(go, 1984, 1984, 3, mo(1), 0, 2, 60)
    ]), Jl = El, nd = Rl, rd = w([
        A7(go, 1980, 1980, 3, mo(6), 0, 2, 60),
        A7(go, 1980, 1980, 8, mo(28), 0, 2, 0)
    ]), td = wl, ed = function(n) {
        return A3(de, F2(function(n, r) {
            return A3(ia, n.a, n.b, r);
        }), pa, n);
    }, ud = Eo, ad = Eo, id = w([
        A7(go, 1982, 1982, 9, mo(10), 0, 2, 60),
        A7(go, 1983, 1983, 2, mo(21), 0, 2, 0),
        A7(go, 2008, 2008, 9, po(6), 120, 2, 60),
        A7(go, 2009, 2009, 2, po(6), 120, 2, 0)
    ]), cd = Eo, od = w([
        A7(go, 2010, 2010, 8, po(6), 0, 2, 60),
        A7(go, 2011, 2011, 3, A2($o, 5, 1), 240, 2, 0),
        A7(go, 2011, 2011, 8, po(5), 180, 2, 60),
        A7(go, 2012, Hc, 3, A2($o, 6, 1), 240, 2, 0),
        A7(go, 2012, Hc, 8, po(6), 180, 2, 60)
    ]), fd = w([
        A7(go, 1974, 1974, 10, A2($o, 6, 1), 165, 1, 60),
        A7(go, 1975, 1975, 1, po(6), 165, 1, 0),
        A7(go, 1975, 1988, 9, po(6), 165, 1, 60),
        A7(go, 1976, 1989, 2, A2($o, 6, 1), 165, 1, 0),
        A7(go, 1989, 1989, 9, A2($o, 6, 8), 165, 1, 60),
        A7(go, 1990, 2006, 9, A2($o, 6, 1), 165, 1, 60),
        A7(go, 1990, 2007, 2, A2($o, 6, 15), 165, 1, 0),
        A7(go, 2007, Hc, 8, po(6), 165, 1, 60),
        A7(go, 2008, Hc, 3, A2($o, 6, 1), 165, 1, 0)
    ]), sd = w([
        A7(go, 1983, 1983, 8, mo(25), 0, 2, 60),
        A7(go, 1984, 1991, 2, A2($o, 6, 23), 0, 2, 0),
        A7(go, 1984, 1984, 9, mo(23), 0, 2, 60),
        A7(go, 1985, 1991, 8, A2($o, 6, 23), 0, 2, 60),
        A7(go, 1992, 1993, 0, A2($o, 6, 23), 0, 2, 0),
        A7(go, 1992, 1992, 9, A2($o, 6, 23), 0, 2, 60)
    ]), ld = w([
        A7(go, 1998, 1999, 10, A2($o, 6, 1), 120, 2, 60),
        A7(go, 1999, 2e3, 1, po(6), 180, 2, 0),
        A7(go, 2009, 2009, 10, mo(29), 120, 2, 60),
        A7(go, 2010, 2010, 2, po(6), 180, 2, 0),
        A7(go, 2010, 2013, 9, A2($o, 6, 21), 120, 2, 60),
        A7(go, 2011, 2011, 2, A2($o, 6, 1), 180, 2, 0),
        A7(go, 2012, 2013, 0, A2($o, 6, 18), 180, 2, 0),
        A7(go, 2014, 2014, 0, A2($o, 6, 18), 120, 2, 0),
        A7(go, 2014, 2018, 10, A2($o, 6, 1), 120, 2, 60),
        A7(go, 2015, Hc, 0, A2($o, 6, 12), 180, 2, 0),
        A7(go, 2019, 2019, 10, A2($o, 6, 8), 120, 2, 60),
        A7(go, 2020, 2020, 11, mo(20), 120, 2, 60),
        A7(go, 2021, Hc, 10, A2($o, 6, 8), 120, 2, 60)
    ]), dd = w([
        A7(go, 1969, 1969, 0, mo(26), 1, 2, 0),
        A7(go, 1969, 1969, 5, mo(22), 120, 2, 60),
        A7(go, 1969, 1969, 7, mo(31), 120, 2, 0),
        A7(go, 1970, 1971, 3, po(6), 120, 2, 60),
        A7(go, 1970, 1971, 8, A2($o, 6, 1), 120, 2, 0),
        A7(go, 1973, 1973, 11, mo(16), 120, 2, 60),
        A7(go, 1974, 1974, 1, mo(24), 120, 2, 0),
        A7(go, 1976, 1976, 4, mo(26), 120, 2, 60),
        A7(go, 1976, 1976, 7, mo(22), 121, 2, 0),
        A7(go, 1977, 1977, 3, mo(24), 120, 2, 60),
        A7(go, 1977, 1977, 7, mo(28), 120, 2, 0)
    ]), vd = function() {
        return vo(A2(Zc, w([
            v(A2(Mc, 600, Pc(dd)), A5(Ic, 2e3, 11, 23, 0, 2))
        ]), A2(Mc, 600, Ao(0))));
    }, bd = function() {
        return vo(A2(Zc, g, A2(Mc, -660, Ao(0))));
    }, md = bd, pd = w([
        A7(go, 1977, 1978, 11, A2($o, 6, 1), 0, 2, 60),
        A7(go, 1978, 1979, 1, mo(27), 0, 2, 0),
        A7(go, 1996, 1996, 11, mo(1), 120, 1, 60),
        A7(go, 1997, 1997, 2, mo(2), 120, 1, 0)
    ]), $d = w([
        A7(go, 1978, 1978, 10, mo(12), 0, 2, 30),
        A7(go, 1979, 1991, 2, A2($o, 6, 1), 0, 2, 0),
        A7(go, 1979, 1990, 9, po(6), 0, 2, 30)
    ]), gd = vd, hd = w([
        A7(go, 1999, 1999, 9, mo(7), 120, 1, 60),
        A7(go, 2e3, 2e3, 2, mo(19), 120, 1, 0),
        A7(go, 2e3, 2001, 10, A2($o, 6, 1), 120, 2, 60),
        A7(go, 2001, 2002, 0, po(6), 120, 2, 0),
        A7(go, 2016, 2016, 10, A2($o, 6, 1), 120, 2, 60),
        A7(go, 2017, 2017, 0, A2($o, 6, 15), 180, 2, 0)
    ]), yd = ed(w([
        v("Africa/Abidjan", ko),
        v("Africa/Accra", function() {
            return vo(A2(Zc, g, A2(Mc, 0, Ao(0))));
        }),
        v("Africa/Addis_Ababa", qo),
        v("Africa/Algiers", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 0, Pc(Fo)), A5(Ic, 1977, 9, 21, 0, 2)),
                v(A2(Mc, 60, Pc(Fo)), A5(Ic, 1979, 9, 26, 0, 2)),
                v(A2(Mc, 0, Pc(Fo)), A5(Ic, 1981, 4, 1, 0, 2))
            ]), A2(Mc, 60, Ao(0))));
        }),
        v("Africa/Asmara", jo),
        v("Africa/Bamako", Do),
        v("Africa/Bangui", Bo),
        v("Africa/Banjul", Go),
        v("Africa/Bissau", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -60, Ao(0)), A5(Ic, 1975, 0, 1, 0, 2))
            ]), A2(Mc, 0, Ao(0))));
        }),
        v("Africa/Blantyre", So),
        v("Africa/Brazzaville", To),
        v("Africa/Bujumbura", Po),
        v("Africa/Cairo", function() {
            return vo(A2(Zc, g, A2(Mc, 120, Pc(Zo))));
        }),
        v("Africa/Casablanca", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 0, Pc(Mo)), A5(Ic, 1984, 2, 16, 0, 2)),
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1986, 0, 1, 0, 2)),
                v(A2(Mc, 0, Pc(Mo)), A5(Ic, 2018, 9, 28, 180, 2))
            ]), A2(Mc, 60, Pc(Mo))));
        }),
        v("Africa/Ceuta", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 0, Pc(No)), A5(Ic, 1984, 2, 16, 0, 2)),
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1986, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Africa/Conakry", Ho),
        v("Africa/Dakar", Io),
        v("Africa/Dar_es_Salaam", Oo),
        v("Africa/Djibouti", Qo),
        v("Africa/Douala", Ro),
        v("Africa/El_Aaiun", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -60, Ao(0)), A5(Ic, 1976, 3, 14, 0, 2)),
                v(A2(Mc, 0, Pc(Mo)), A5(Ic, 2018, 9, 28, 180, 2))
            ]), A2(Mc, 60, Pc(Mo))));
        }),
        v("Africa/Freetown", Uo),
        v("Africa/Gaborone", Ko),
        v("Africa/Harare", Wo),
        v("Africa/Johannesburg", Xo),
        v("Africa/Juba", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 120, Pc(Yo)), A5(Ic, 2e3, 0, 15, 720, 2))
            ]), A2(Mc, 180, Ao(0))));
        }),
        v("Africa/Kampala", Jo),
        v("Africa/Khartoum", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 120, Pc(Yo)), A5(Ic, 2e3, 0, 15, 720, 2)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 2017, 10, 1, 0, 2))
            ]), A2(Mc, 120, Ao(0))));
        }),
        v("Africa/Kigali", nf),
        v("Africa/Kinshasa", rf),
        v("Africa/Lagos", Vo),
        v("Africa/Libreville", tf),
        v("Africa/Lome", ef),
        v("Africa/Luanda", uf),
        v("Africa/Lubumbashi", af),
        v("Africa/Lusaka", cf),
        v("Africa/Malabo", of),
        v("Africa/Maputo", zo),
        v("Africa/Maseru", ff),
        v("Africa/Mbabane", sf),
        v("Africa/Mogadishu", lf),
        v("Africa/Monrovia", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -45, Ao(0)), A5(Ic, 1972, 0, 7, 0, 2))
            ]), A2(Mc, 0, Ao(0))));
        }),
        v("Africa/Nairobi", Eo),
        v("Africa/Ndjamena", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1979, 9, 14, 0, 2)),
                v(A2(Mc, 60, Ao(60)), A5(Ic, 1980, 2, 8, 0, 2))
            ]), A2(Mc, 60, Ao(0))));
        }),
        v("Africa/Niamey", df),
        v("Africa/Nouakchott", vf),
        v("Africa/Ouagadougou", bf),
        v("Africa/Porto-Novo", mf),
        v("Africa/Sao_Tome", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 0, Ao(0)), A5(Ic, 2018, 0, 1, 60, 2)),
                v(A2(Mc, 60, Ao(0)), A5(Ic, 2019, 0, 1, 120, 2))
            ]), A2(Mc, 0, Ao(0))));
        }),
        v("Africa/Tripoli", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 120, Ao(0)), A5(Ic, 1982, 0, 1, 0, 2)),
                v(A2(Mc, 60, Pc(pf)), A5(Ic, 1990, 4, 4, 0, 2)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 1996, 8, 30, 0, 2)),
                v(A2(Mc, 60, Pc(pf)), A5(Ic, 1997, 9, 4, 0, 2)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 2012, 10, 10, 120, 2)),
                v(A2(Mc, 60, Pc(pf)), A5(Ic, 2013, 9, 25, 120, 2))
            ]), A2(Mc, 120, Ao(0))));
        }),
        v("Africa/Tunis", function() {
            return vo(A2(Zc, g, A2(Mc, 60, Pc($f))));
        }),
        v("Africa/Windhoek", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 120, Ao(0)), A5(Ic, 1990, 2, 21, 0, 2))
            ]), A2(Mc, 120, Pc(gf))));
        }),
        v("America/Adak", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -660, Pc(ho)), A5(Ic, 1983, 9, 30, 120, 2)),
                v(A2(Mc, -600, Pc(ho)), A5(Ic, 1983, 10, 30, 0, 2))
            ]), A2(Mc, -600, Pc(ho))));
        }),
        v("America/Anchorage", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -600, Pc(ho)), A5(Ic, 1983, 9, 30, 120, 2)),
                v(A2(Mc, -540, Pc(ho)), A5(Ic, 1983, 10, 30, 0, 2))
            ]), A2(Mc, -540, Pc(ho))));
        }),
        v("America/Anguilla", yf),
        v("America/Antigua", wf),
        v("America/Araguaina", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 1990, 8, 17, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1995, 8, 14, 0, 2)),
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 2003, 8, 24, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2012, 9, 21, 0, 2)),
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 2013, 8, 1, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Argentina/Buenos_Aires", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2))
            ]), A2(Mc, -180, Pc(_f))));
        }),
        v("America/Argentina/Catamarca", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1991, 2, 3, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1991, 9, 20, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2004, 5, 1, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2004, 5, 20, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 2008, 9, 18, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Argentina/Cordoba", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1991, 2, 3, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1991, 9, 20, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2))
            ]), A2(Mc, -180, Pc(_f))));
        }),
        v("America/Argentina/Jujuy", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1990, 2, 4, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1990, 9, 28, 0, 2)),
                v(A2(Mc, -240, Ao(60)), A5(Ic, 1991, 2, 17, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1991, 9, 6, 0, 2)),
                v(A2(Mc, -180, Ao(60)), A5(Ic, 1992, 0, 1, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 2008, 9, 18, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Argentina/La_Rioja", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1991, 2, 1, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1991, 4, 7, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2004, 5, 1, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2004, 5, 20, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 2008, 9, 18, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Argentina/Mendoza", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1990, 2, 4, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1990, 9, 15, 0, 2)),
                v(A2(Mc, -240, Ao(60)), A5(Ic, 1991, 2, 1, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1991, 9, 15, 0, 2)),
                v(A2(Mc, -240, Ao(60)), A5(Ic, 1992, 2, 1, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1992, 9, 18, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2004, 4, 23, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2004, 8, 26, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 2008, 9, 18, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Argentina/Rio_Gallegos", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2004, 5, 1, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2004, 5, 20, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 2008, 9, 18, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Argentina/Salta", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1991, 2, 3, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1991, 9, 20, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 2008, 9, 18, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Argentina/San_Juan", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1991, 2, 1, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1991, 4, 7, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2004, 4, 31, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2004, 6, 25, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 2008, 9, 18, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Argentina/San_Luis", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1990, 0, 1, 0, 2)),
                v(A2(Mc, -180, Ao(60)), A5(Ic, 1990, 2, 14, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1990, 9, 15, 0, 2)),
                v(A2(Mc, -240, Ao(60)), A5(Ic, 1991, 2, 1, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1991, 5, 1, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Ao(60)), A5(Ic, 2e3, 2, 3, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2004, 4, 31, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2004, 6, 25, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 2008, 0, 21, 0, 2)),
                v(A2(Mc, -240, Pc(Cf)), A5(Ic, 2009, 9, 11, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Argentina/Tucuman", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1991, 2, 3, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1991, 9, 20, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2004, 5, 1, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2004, 5, 13, 0, 2))
            ]), A2(Mc, -180, Pc(_f))));
        }),
        v("America/Argentina/Ushuaia", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1999, 9, 3, 0, 2)),
                v(A2(Mc, -240, Pc(_f)), A5(Ic, 2e3, 2, 3, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2004, 4, 30, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2004, 5, 20, 0, 2)),
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 2008, 9, 18, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Aruba", kf),
        v("America/Asuncion", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1972, 9, 1, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1974, 3, 1, 0, 2))
            ]), A2(Mc, -240, Pc(Ef))));
        }),
        v("America/Atikokan", function() {
            return vo(A2(Zc, g, A2(Mc, -300, Ao(0))));
        }),
        v("America/Bahia", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 2003, 8, 24, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2011, 9, 16, 0, 2)),
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 2012, 9, 21, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Bahia_Banderas", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Ao(0)), A5(Ic, 1970, 0, 1, 0, 2)),
                v(A2(Mc, -420, Pc(qf)), A5(Ic, 2010, 3, 4, 120, 2))
            ]), A2(Mc, -360, Pc(qf))));
        }),
        v("America/Barbados", function() {
            return vo(A2(Zc, g, A2(Mc, -240, Pc(Ff))));
        }),
        v("America/Belem", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 1988, 8, 12, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Belize", function() {
            return vo(A2(Zc, g, A2(Mc, -360, Pc(jf))));
        }),
        v("America/Blanc-Sablon", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(Df)), A5(Ic, 1970, 0, 1, 0, 2))
            ]), A2(Mc, -240, Ao(0))));
        }),
        v("America/Boa_Vista", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(xf)), A5(Ic, 1988, 8, 12, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1999, 8, 30, 0, 2)),
                v(A2(Mc, -240, Pc(xf)), A5(Ic, 2e3, 9, 15, 0, 2))
            ]), A2(Mc, -240, Ao(0))));
        }),
        v("America/Bogota", function() {
            return vo(A2(Zc, g, A2(Mc, -300, Pc(Vf))));
        }),
        v("America/Boise", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -420, Pc(ho)), A5(Ic, 1974, 0, 1, 0, 2)),
                v(A2(Mc, -420, Ao(0)), A5(Ic, 1974, 1, 3, 120, 2))
            ]), A2(Mc, -420, Pc(ho))));
        }),
        v("America/Cambridge_Bay", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -420, Pc(Bf)), A5(Ic, 1999, 9, 31, 120, 2)),
                v(A2(Mc, -360, Pc(Df)), A5(Ic, 2e3, 9, 29, 120, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2e3, 10, 5, 0, 2)),
                v(A2(Mc, -360, Ao(0)), A5(Ic, 2001, 3, 1, 180, 2))
            ]), A2(Mc, -420, Pc(Df))));
        }),
        v("America/Campo_Grande", function() {
            return vo(A2(Zc, g, A2(Mc, -240, Pc(xf))));
        }),
        v("America/Cancun", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Ao(0)), A5(Ic, 1981, 11, 23, 0, 2)),
                v(A2(Mc, -300, Pc(qf)), A5(Ic, 1998, 7, 2, 120, 2)),
                v(A2(Mc, -360, Pc(qf)), A5(Ic, 2015, 1, 1, 120, 2))
            ]), A2(Mc, -300, Ao(0))));
        }),
        v("America/Caracas", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2007, 11, 9, 180, 2)),
                v(A2(Mc, -270, Ao(0)), A5(Ic, 2016, 4, 1, 150, 2))
            ]), A2(Mc, -240, Ao(0))));
        }),
        v("America/Cayenne", function() {
            return vo(A2(Zc, g, A2(Mc, -180, Ao(0))));
        }),
        v("America/Cayman", zf),
        v("America/Chicago", function() {
            return vo(A2(Zc, g, A2(Mc, -360, Pc(ho))));
        }),
        v("America/Chihuahua", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Ao(0)), A5(Ic, 1996, 0, 1, 0, 2)),
                v(A2(Mc, -360, Pc(qf)), A5(Ic, 1998, 0, 1, 0, 2)),
                v(A2(Mc, -360, Ao(0)), A5(Ic, 1998, 3, 5, 180, 2))
            ]), A2(Mc, -420, Pc(qf))));
        }),
        v("America/Costa_Rica", function() {
            return vo(A2(Zc, g, A2(Mc, -360, Pc(Sf))));
        }),
        v("America/Creston", function() {
            return vo(A2(Zc, g, A2(Mc, -420, Ao(0))));
        }),
        v("America/Cuiaba", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(xf)), A5(Ic, 2003, 8, 24, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2004, 9, 1, 0, 2))
            ]), A2(Mc, -240, Pc(xf))));
        }),
        v("America/Curacao", Af),
        v("America/Danmarkshavn", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1980, 3, 6, 120, 2)),
                v(A2(Mc, -180, Pc(Lo)), A5(Ic, 1996, 0, 1, 0, 2))
            ]), A2(Mc, 0, Ao(0))));
        }),
        v("America/Dawson", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -540, Pc(Bf)), A5(Ic, 1973, 9, 28, 0, 2)),
                v(A2(Mc, -480, Pc(Bf)), A5(Ic, 1980, 0, 1, 0, 2)),
                v(A2(Mc, -480, Pc(Df)), A5(Ic, 2020, 10, 1, 0, 2))
            ]), A2(Mc, -420, Ao(0))));
        }),
        v("America/Dawson_Creek", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Pc(Tf)), A5(Ic, 1972, 7, 30, 120, 2))
            ]), A2(Mc, -420, Ao(0))));
        }),
        v("America/Denver", function() {
            return vo(A2(Zc, g, A2(Mc, -420, Pc(ho))));
        }),
        v("America/Detroit", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1973, 0, 1, 0, 2)),
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 1975, 0, 1, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1975, 3, 27, 120, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/Dominica", Pf),
        v("America/Edmonton", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -420, Pc(Zf)), A5(Ic, 1987, 0, 1, 0, 2))
            ]), A2(Mc, -420, Pc(Df))));
        }),
        v("America/Eirunepe", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(xf)), A5(Ic, 1988, 8, 12, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1993, 8, 28, 0, 2)),
                v(A2(Mc, -300, Pc(xf)), A5(Ic, 1994, 8, 22, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2008, 5, 24, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2013, 10, 10, 0, 2))
            ]), A2(Mc, -300, Ao(0))));
        }),
        v("America/El_Salvador", function() {
            return vo(A2(Zc, g, A2(Mc, -360, Pc(Mf))));
        }),
        v("America/Fort_Nelson", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Pc(Tf)), A5(Ic, 1987, 0, 1, 0, 2)),
                v(A2(Mc, -480, Pc(Df)), A5(Ic, 2015, 2, 8, 120, 2))
            ]), A2(Mc, -420, Ao(0))));
        }),
        v("America/Fortaleza", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 1990, 8, 17, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1999, 8, 30, 0, 2)),
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 2e3, 9, 22, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2001, 8, 13, 0, 2)),
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 2002, 9, 1, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Glace_Bay", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1972, 0, 1, 0, 2)),
                v(A2(Mc, -240, Pc(Lf)), A5(Ic, 1974, 0, 1, 0, 2))
            ]), A2(Mc, -240, Pc(Df))));
        }),
        v("America/Goose_Bay", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(Nf)), A5(Ic, 2011, 10, 1, 0, 2))
            ]), A2(Mc, -240, Pc(Df))));
        }),
        v("America/Grand_Turk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1979, 0, 1, 0, 2)),
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 2015, 10, 1, 120, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2018, 2, 11, 180, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/Grenada", Hf),
        v("America/Guadeloupe", If),
        v("America/Guatemala", function() {
            return vo(A2(Zc, g, A2(Mc, -360, Pc(Of))));
        }),
        v("America/Guayaquil", function() {
            return vo(A2(Zc, g, A2(Mc, -300, Pc(Qf))));
        }),
        v("America/Guyana", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -225, Ao(0)), A5(Ic, 1975, 6, 31, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1991, 0, 1, 0, 2))
            ]), A2(Mc, -240, Ao(0))));
        }),
        v("America/Halifax", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(Lf)), A5(Ic, 1974, 0, 1, 0, 2))
            ]), A2(Mc, -240, Pc(Df))));
        }),
        v("America/Havana", function() {
            return vo(A2(Zc, g, A2(Mc, -300, Pc(Rf))));
        }),
        v("America/Hermosillo", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Ao(0)), A5(Ic, 1970, 0, 1, 0, 2)),
                v(A2(Mc, -420, Pc(qf)), A5(Ic, 1999, 0, 1, 0, 2))
            ]), A2(Mc, -420, Ao(0))));
        }),
        v("America/Indiana/Indianapolis", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 1971, 0, 1, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2006, 0, 1, 0, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/Indiana/Knox", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Pc(ho)), A5(Ic, 1991, 9, 27, 120, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2006, 3, 2, 120, 2))
            ]), A2(Mc, -360, Pc(ho))));
        }),
        v("America/Indiana/Marengo", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 1974, 0, 6, 120, 2)),
                v(A2(Mc, -360, Ao(60)), A5(Ic, 1974, 9, 27, 120, 2)),
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 1976, 0, 1, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2006, 0, 1, 0, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/Indiana/Petersburg", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Pc(ho)), A5(Ic, 1977, 9, 30, 120, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2006, 3, 2, 120, 2)),
                v(A2(Mc, -360, Pc(ho)), A5(Ic, 2007, 10, 4, 120, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/Indiana/Tell_City", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 1971, 0, 1, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2006, 3, 2, 120, 2))
            ]), A2(Mc, -360, Pc(ho))));
        }),
        v("America/Indiana/Vevay", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 1973, 0, 1, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2006, 0, 1, 0, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/Indiana/Vincennes", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 1971, 0, 1, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2006, 3, 2, 120, 2)),
                v(A2(Mc, -360, Pc(ho)), A5(Ic, 2007, 10, 4, 120, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/Indiana/Winamac", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 1971, 0, 1, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2006, 3, 2, 120, 2)),
                v(A2(Mc, -360, Pc(ho)), A5(Ic, 2007, 2, 11, 120, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/Inuvik", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Pc(Bf)), A5(Ic, 1979, 3, 29, 120, 2)),
                v(A2(Mc, -420, Pc(Bf)), A5(Ic, 1980, 0, 1, 0, 2))
            ]), A2(Mc, -420, Pc(Df))));
        }),
        v("America/Iqaluit", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(Bf)), A5(Ic, 1999, 9, 31, 120, 2)),
                v(A2(Mc, -360, Pc(Df)), A5(Ic, 2e3, 9, 29, 120, 2))
            ]), A2(Mc, -300, Pc(Df))));
        }),
        v("America/Jamaica", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1974, 0, 1, 0, 2)),
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 1984, 0, 1, 0, 2))
            ]), A2(Mc, -300, Ao(0))));
        }),
        v("America/Juneau", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Pc(ho)), A5(Ic, 1980, 3, 27, 120, 2)),
                v(A2(Mc, -540, Pc(ho)), A5(Ic, 1980, 9, 26, 120, 2)),
                v(A2(Mc, -480, Pc(ho)), A5(Ic, 1983, 9, 30, 120, 2)),
                v(A2(Mc, -540, Pc(ho)), A5(Ic, 1983, 10, 30, 0, 2))
            ]), A2(Mc, -540, Pc(ho))));
        }),
        v("America/Kentucky/Louisville", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 1974, 0, 6, 120, 2)),
                v(A2(Mc, -360, Ao(60)), A5(Ic, 1974, 9, 27, 120, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/Kentucky/Monticello", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Pc(ho)), A5(Ic, 2e3, 9, 29, 120, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/Kralendijk", Uf),
        v("America/La_Paz", function() {
            return vo(A2(Zc, g, A2(Mc, -240, Ao(0))));
        }),
        v("America/Lima", function() {
            return vo(A2(Zc, g, A2(Mc, -300, Pc(Kf))));
        }),
        v("America/Los_Angeles", yo),
        v("America/Lower_Princes", Wf),
        v("America/Maceio", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 1990, 8, 17, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1995, 9, 13, 0, 2)),
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 1996, 8, 4, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1999, 8, 30, 0, 2)),
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 2e3, 9, 22, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2001, 8, 13, 0, 2)),
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 2002, 9, 1, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Managua", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Ao(0)), A5(Ic, 1973, 4, 1, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1975, 1, 16, 0, 2)),
                v(A2(Mc, -360, Pc(Xf)), A5(Ic, 1992, 0, 1, 240, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1992, 8, 24, 0, 2)),
                v(A2(Mc, -360, Ao(0)), A5(Ic, 1993, 0, 1, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1997, 0, 1, 0, 2))
            ]), A2(Mc, -360, Pc(Xf))));
        }),
        v("America/Manaus", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(xf)), A5(Ic, 1988, 8, 12, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1993, 8, 28, 0, 2)),
                v(A2(Mc, -240, Pc(xf)), A5(Ic, 1994, 8, 22, 0, 2))
            ]), A2(Mc, -240, Ao(0))));
        }),
        v("America/Marigot", Yf),
        v("America/Martinique", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1980, 3, 6, 0, 2)),
                v(A2(Mc, -240, Ao(60)), A5(Ic, 1980, 8, 28, 0, 2))
            ]), A2(Mc, -240, Ao(0))));
        }),
        v("America/Matamoros", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Ao(0)), A5(Ic, 1988, 0, 1, 0, 2)),
                v(A2(Mc, -360, Pc(ho)), A5(Ic, 1989, 0, 1, 0, 2)),
                v(A2(Mc, -360, Pc(qf)), A5(Ic, 2010, 0, 1, 0, 2))
            ]), A2(Mc, -360, Pc(ho))));
        }),
        v("America/Mazatlan", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Ao(0)), A5(Ic, 1970, 0, 1, 0, 2))
            ]), A2(Mc, -420, Pc(qf))));
        }),
        v("America/Menominee", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1973, 3, 29, 120, 2))
            ]), A2(Mc, -360, Pc(ho))));
        }),
        v("America/Merida", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Ao(0)), A5(Ic, 1981, 11, 23, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1982, 11, 2, 0, 2))
            ]), A2(Mc, -360, Pc(qf))));
        }),
        v("America/Metlakatla", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Pc(ho)), A5(Ic, 1983, 9, 30, 120, 2)),
                v(A2(Mc, -480, Ao(0)), A5(Ic, 2015, 10, 1, 120, 2)),
                v(A2(Mc, -540, Pc(ho)), A5(Ic, 2018, 10, 4, 120, 2)),
                v(A2(Mc, -480, Ao(0)), A5(Ic, 2019, 0, 20, 120, 2))
            ]), A2(Mc, -540, Pc(ho))));
        }),
        v("America/Mexico_City", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Pc(qf)), A5(Ic, 2001, 8, 30, 120, 2)),
                v(A2(Mc, -360, Ao(0)), A5(Ic, 2002, 1, 20, 0, 2))
            ]), A2(Mc, -360, Pc(qf))));
        }),
        v("America/Miquelon", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1980, 4, 1, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1987, 0, 1, 0, 2))
            ]), A2(Mc, -180, Pc(Df))));
        }),
        v("America/Moncton", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(Jf)), A5(Ic, 1973, 0, 1, 0, 2)),
                v(A2(Mc, -240, Pc(Df)), A5(Ic, 1993, 0, 1, 0, 2)),
                v(A2(Mc, -240, Pc(Jf)), A5(Ic, 2007, 0, 1, 0, 2))
            ]), A2(Mc, -240, Pc(Df))));
        }),
        v("America/Monterrey", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Ao(0)), A5(Ic, 1988, 0, 1, 0, 2)),
                v(A2(Mc, -360, Pc(ho)), A5(Ic, 1989, 0, 1, 0, 2))
            ]), A2(Mc, -360, Pc(qf))));
        }),
        v("America/Montevideo", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(ns)), A5(Ic, 1970, 0, 1, 0, 2)),
                v(A2(Mc, -180, Pc(ns)), A5(Ic, 1974, 0, 1, 0, 2)),
                v(A2(Mc, -180, Pc(ns)), A5(Ic, 1974, 2, 10, 0, 2)),
                v(A2(Mc, -180, Pc(ns)), A5(Ic, 1974, 11, 22, 0, 2))
            ]), A2(Mc, -180, Pc(ns))));
        }),
        v("America/Montserrat", rs),
        v("America/Nassau", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(ts)), A5(Ic, 1976, 0, 1, 0, 2))
            ]), A2(Mc, -300, Pc(ho))));
        }),
        v("America/New_York", function() {
            return vo(A2(Zc, g, A2(Mc, -300, Pc(ho))));
        }),
        v("America/Nipigon", function() {
            return vo(A2(Zc, g, A2(Mc, -300, Pc(Df))));
        }),
        v("America/Nome", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -660, Pc(ho)), A5(Ic, 1983, 9, 30, 120, 2)),
                v(A2(Mc, -540, Pc(ho)), A5(Ic, 1983, 10, 30, 0, 2))
            ]), A2(Mc, -540, Pc(ho))));
        }),
        v("America/Noronha", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -120, Pc(xf)), A5(Ic, 1990, 8, 17, 0, 2)),
                v(A2(Mc, -120, Ao(0)), A5(Ic, 1999, 8, 30, 0, 2)),
                v(A2(Mc, -120, Pc(xf)), A5(Ic, 2e3, 9, 15, 0, 2)),
                v(A2(Mc, -120, Ao(0)), A5(Ic, 2001, 8, 13, 0, 2)),
                v(A2(Mc, -120, Pc(xf)), A5(Ic, 2002, 9, 1, 0, 2))
            ]), A2(Mc, -120, Ao(0))));
        }),
        v("America/North_Dakota/Beulah", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -420, Pc(ho)), A5(Ic, 2010, 10, 7, 120, 2))
            ]), A2(Mc, -360, Pc(ho))));
        }),
        v("America/North_Dakota/Center", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -420, Pc(ho)), A5(Ic, 1992, 9, 25, 120, 2))
            ]), A2(Mc, -360, Pc(ho))));
        }),
        v("America/North_Dakota/New_Salem", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -420, Pc(ho)), A5(Ic, 2003, 9, 26, 120, 2))
            ]), A2(Mc, -360, Pc(ho))));
        }),
        v("America/Nuuk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1980, 3, 6, 120, 2))
            ]), A2(Mc, -180, Pc(Lo))));
        }),
        v("America/Ojinaga", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Ao(0)), A5(Ic, 1996, 0, 1, 0, 2)),
                v(A2(Mc, -360, Pc(qf)), A5(Ic, 1998, 0, 1, 0, 2)),
                v(A2(Mc, -360, Ao(0)), A5(Ic, 1998, 3, 5, 180, 2)),
                v(A2(Mc, -420, Pc(qf)), A5(Ic, 2010, 0, 1, 0, 2))
            ]), A2(Mc, -420, Pc(ho))));
        }),
        v("America/Panama", Gf),
        v("America/Pangnirtung", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(Bf)), A5(Ic, 1995, 3, 2, 120, 2)),
                v(A2(Mc, -300, Pc(Df)), A5(Ic, 1999, 9, 31, 120, 2)),
                v(A2(Mc, -360, Pc(Df)), A5(Ic, 2e3, 9, 29, 120, 2))
            ]), A2(Mc, -300, Pc(Df))));
        }),
        v("America/Paramaribo", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -210, Ao(0)), A5(Ic, 1984, 9, 1, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Phoenix", function() {
            return vo(A2(Zc, g, A2(Mc, -420, Ao(0))));
        }),
        v("America/Port-au-Prince", function() {
            return vo(A2(Zc, g, A2(Mc, -300, Pc(es))));
        }),
        v("America/Port_of_Spain", hf),
        v("America/Porto_Velho", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(xf)), A5(Ic, 1988, 8, 12, 0, 2))
            ]), A2(Mc, -240, Ao(0))));
        }),
        v("America/Puerto_Rico", function() {
            return vo(A2(Zc, g, A2(Mc, -240, Ao(0))));
        }),
        v("America/Punta_Arenas", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(us)), A5(Ic, 2016, 11, 4, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Rainy_River", function() {
            return vo(A2(Zc, g, A2(Mc, -360, Pc(Df))));
        }),
        v("America/Rankin_Inlet", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Pc(Bf)), A5(Ic, 2e3, 9, 29, 120, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2001, 3, 1, 180, 2))
            ]), A2(Mc, -360, Pc(Df))));
        }),
        v("America/Recife", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 1990, 8, 17, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 1999, 8, 30, 0, 2)),
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 2e3, 9, 15, 0, 2)),
                v(A2(Mc, -180, Ao(0)), A5(Ic, 2001, 8, 13, 0, 2)),
                v(A2(Mc, -180, Pc(xf)), A5(Ic, 2002, 9, 1, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Regina", function() {
            return vo(A2(Zc, g, A2(Mc, -360, Ao(0))));
        }),
        v("America/Resolute", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Pc(Bf)), A5(Ic, 2e3, 9, 29, 120, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2001, 3, 1, 180, 2)),
                v(A2(Mc, -360, Pc(Df)), A5(Ic, 2006, 9, 29, 120, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2007, 2, 11, 180, 2))
            ]), A2(Mc, -360, Pc(Df))));
        }),
        v("America/Rio_Branco", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(xf)), A5(Ic, 1988, 8, 12, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 2008, 5, 24, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2013, 10, 10, 0, 2))
            ]), A2(Mc, -300, Ao(0))));
        }),
        v("America/Santarem", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(xf)), A5(Ic, 1988, 8, 12, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2008, 5, 24, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("America/Santiago", function() {
            return vo(A2(Zc, g, A2(Mc, -240, Pc(us))));
        }),
        v("America/Santo_Domingo", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(as)), A5(Ic, 1974, 9, 27, 0, 2)),
                v(A2(Mc, -240, Ao(0)), A5(Ic, 2e3, 9, 29, 120, 2)),
                v(A2(Mc, -300, Pc(ho)), A5(Ic, 2e3, 11, 3, 60, 2))
            ]), A2(Mc, -240, Ao(0))));
        }),
        v("America/Sao_Paulo", function() {
            return vo(A2(Zc, g, A2(Mc, -180, Pc(xf))));
        }),
        v("America/Scoresbysund", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -120, Ao(0)), A5(Ic, 1980, 3, 6, 120, 2)),
                v(A2(Mc, -120, Pc(is)), A5(Ic, 1981, 2, 29, 0, 2))
            ]), A2(Mc, -60, Pc(Lo))));
        }),
        v("America/Sitka", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Pc(ho)), A5(Ic, 1983, 9, 30, 120, 2)),
                v(A2(Mc, -540, Pc(ho)), A5(Ic, 1983, 10, 30, 0, 2))
            ]), A2(Mc, -540, Pc(ho))));
        }),
        v("America/St_Barthelemy", cs),
        v("America/St_Johns", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -210, Pc(Nf)), A5(Ic, 2011, 10, 1, 0, 2))
            ]), A2(Mc, -210, Pc(Df))));
        }),
        v("America/St_Kitts", os),
        v("America/St_Lucia", fs),
        v("America/St_Thomas", ss),
        v("America/St_Vincent", ls),
        v("America/Swift_Current", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -420, Ao(0)), A5(Ic, 1972, 3, 30, 120, 2))
            ]), A2(Mc, -360, Ao(0))));
        }),
        v("America/Tegucigalpa", function() {
            return vo(A2(Zc, g, A2(Mc, -360, Pc(ds))));
        }),
        v("America/Thule", function() {
            return vo(A2(Zc, g, A2(Mc, -240, Pc(vs))));
        }),
        v("America/Thunder_Bay", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(Df)), A5(Ic, 1970, 0, 1, 0, 2)),
                v(A2(Mc, -300, Pc(bs)), A5(Ic, 1973, 0, 1, 0, 2)),
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1974, 0, 1, 0, 2))
            ]), A2(Mc, -300, Pc(Df))));
        }),
        v("America/Tijuana", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Ao(0)), A5(Ic, 1976, 0, 1, 0, 2)),
                v(A2(Mc, -480, Pc(ho)), A5(Ic, 1996, 0, 1, 0, 2)),
                v(A2(Mc, -480, Pc(qf)), A5(Ic, 2001, 0, 1, 0, 2)),
                v(A2(Mc, -480, Pc(ho)), A5(Ic, 2002, 1, 20, 0, 2)),
                v(A2(Mc, -480, Pc(qf)), A5(Ic, 2010, 0, 1, 0, 2))
            ]), A2(Mc, -480, Pc(ho))));
        }),
        v("America/Toronto", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Pc(bs)), A5(Ic, 1974, 0, 1, 0, 2))
            ]), A2(Mc, -300, Pc(Df))));
        }),
        v("America/Tortola", ms),
        v("America/Vancouver", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Pc(Tf)), A5(Ic, 1987, 0, 1, 0, 2))
            ]), A2(Mc, -480, Pc(Df))));
        }),
        v("America/Whitehorse", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -480, Pc(Bf)), A5(Ic, 1980, 0, 1, 0, 2)),
                v(A2(Mc, -480, Pc(Df)), A5(Ic, 2020, 10, 1, 0, 2))
            ]), A2(Mc, -420, Ao(0))));
        }),
        v("America/Winnipeg", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -360, Pc(ps)), A5(Ic, 2006, 0, 1, 0, 2))
            ]), A2(Mc, -360, Pc(Df))));
        }),
        v("America/Yakutat", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -540, Pc(ho)), A5(Ic, 1983, 10, 30, 0, 2))
            ]), A2(Mc, -540, Pc(ho))));
        }),
        v("America/Yellowknife", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -420, Pc(Bf)), A5(Ic, 1980, 0, 1, 0, 2))
            ]), A2(Mc, -420, Pc(Df))));
        }),
        v("Antarctica/Casey", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 480, Ao(0)), A5(Ic, 2009, 9, 18, 120, 2)),
                v(A2(Mc, 660, Ao(0)), A5(Ic, 2010, 2, 5, 120, 2)),
                v(A2(Mc, 480, Ao(0)), A5(Ic, 2011, 9, 28, 120, 2)),
                v(A2(Mc, 660, Ao(0)), A5(Ic, 2012, 1, 21, 1020, 0)),
                v(A2(Mc, 480, Ao(0)), A5(Ic, 2016, 9, 22, 0, 2)),
                v(A2(Mc, 660, Ao(0)), A5(Ic, 2018, 2, 11, 240, 2)),
                v(A2(Mc, 480, Ao(0)), A5(Ic, 2018, 9, 7, 240, 2)),
                v(A2(Mc, 660, Ao(0)), A5(Ic, 2019, 2, 17, 180, 2)),
                v(A2(Mc, 480, Ao(0)), A5(Ic, 2019, 9, 4, 180, 2)),
                v(A2(Mc, 660, Ao(0)), A5(Ic, 2020, 2, 8, 180, 2)),
                v(A2(Mc, 480, Ao(0)), A5(Ic, 2020, 9, 4, 1, 2))
            ]), A2(Mc, 660, Ao(0))));
        }),
        v("Antarctica/Davis", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 420, Ao(0)), A5(Ic, 2009, 9, 18, 120, 2)),
                v(A2(Mc, 300, Ao(0)), A5(Ic, 2010, 2, 10, 1200, 0)),
                v(A2(Mc, 420, Ao(0)), A5(Ic, 2011, 9, 28, 120, 2)),
                v(A2(Mc, 300, Ao(0)), A5(Ic, 2012, 1, 21, 1200, 0))
            ]), A2(Mc, 420, Ao(0))));
        }),
        v("Antarctica/DumontDUrville", function() {
            return vo(A2(Zc, g, A2(Mc, 600, Ao(0))));
        }),
        v("Antarctica/Macquarie", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 600, Pc($s)), A5(Ic, 2010, 0, 1, 0, 2)),
                v(A2(Mc, 600, Ao(60)), A5(Ic, 2011, 0, 1, 0, 2))
            ]), A2(Mc, 600, Pc($s))));
        }),
        v("Antarctica/Mawson", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 360, Ao(0)), A5(Ic, 2009, 9, 18, 120, 2))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Antarctica/McMurdo", ys),
        v("Antarctica/Palmer", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -180, Pc(_f)), A5(Ic, 1982, 4, 1, 0, 2)),
                v(A2(Mc, -240, Pc(us)), A5(Ic, 2016, 11, 4, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("Antarctica/Rothera", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 0, Ao(0)), A5(Ic, 1976, 11, 1, 0, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("Antarctica/Syowa", function() {
            return vo(A2(Zc, g, A2(Mc, 180, Ao(0))));
        }),
        v("Antarctica/Troll", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 0, Ao(0)), A5(Ic, 2005, 1, 12, 0, 2))
            ]), A2(Mc, 0, Pc(ws))));
        }),
        v("Antarctica/Vostok", function() {
            return vo(A2(Zc, g, A2(Mc, 360, Ao(0))));
        }),
        v("Arctic/Longyearbyen", _s),
        v("Asia/Aden", As),
        v("Asia/Almaty", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 360, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 360, Pc(ks)), A5(Ic, 2004, 9, 31, 120, 1))
            ]), A2(Mc, 360, Ao(0))));
        }),
        v("Asia/Amman", function() {
            return vo(A2(Zc, g, A2(Mc, 120, Pc(Es))));
        }),
        v("Asia/Anadyr", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 780, Pc(qs)), A5(Ic, 1982, 3, 1, 0, 1)),
                v(A2(Mc, 720, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 720, Pc(qs)), A5(Ic, 2010, 2, 28, 120, 1)),
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1))
            ]), A2(Mc, 720, Ao(0))));
        }),
        v("Asia/Aqtau", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Ao(0)), A5(Ic, 1981, 9, 1, 0, 2)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 1982, 3, 1, 0, 2)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1994, 8, 25, 120, 1)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 2004, 9, 31, 120, 1))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Asia/Aqtobe", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Ao(0)), A5(Ic, 1981, 3, 1, 0, 2)),
                v(A2(Mc, 300, Ao(60)), A5(Ic, 1981, 9, 1, 0, 2)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 1982, 3, 1, 0, 2)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 2004, 9, 31, 120, 1))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Asia/Ashgabat", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 2)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 1992, 0, 19, 120, 2))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Asia/Atyrau", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Ao(0)), A5(Ic, 1981, 9, 1, 0, 2)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 1982, 3, 1, 0, 2)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1999, 2, 28, 120, 1)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 2004, 9, 31, 120, 1))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Asia/Baghdad", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Ao(0)), A5(Ic, 1982, 4, 1, 0, 2))
            ]), A2(Mc, 180, Pc(Fs))));
        }),
        v("Asia/Bahrain", Ds),
        v("Asia/Baku", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 180, Pc(ks)), A5(Ic, 1992, 8, 27, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 1996, 0, 1, 0, 2)),
                v(A2(Mc, 240, Pc(Bs)), A5(Ic, 1997, 0, 1, 0, 2))
            ]), A2(Mc, 240, Pc(Vs))));
        }),
        v("Asia/Bangkok", Gs),
        v("Asia/Barnaul", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 1995, 4, 28, 0, 2)),
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 420, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 2016, 2, 27, 120, 1))
            ]), A2(Mc, 420, Ao(0))));
        }),
        v("Asia/Beirut", function() {
            return vo(A2(Zc, g, A2(Mc, 120, Pc(zs))));
        }),
        v("Asia/Bishkek", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 360, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1991, 7, 31, 120, 2)),
                v(A2(Mc, 300, Pc(Ss)), A5(Ic, 2005, 7, 12, 0, 2))
            ]), A2(Mc, 360, Ao(0))));
        }),
        v("Asia/Brunei", function() {
            return vo(A2(Zc, g, A2(Mc, 480, Ao(0))));
        }),
        v("Asia/Chita", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 540, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 480, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 540, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 600, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1)),
                v(A2(Mc, 480, Ao(0)), A5(Ic, 2016, 2, 27, 120, 2))
            ]), A2(Mc, 540, Ao(0))));
        }),
        v("Asia/Choibalsan", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 420, Ao(0)), A5(Ic, 1978, 0, 1, 0, 2)),
                v(A2(Mc, 480, Ao(0)), A5(Ic, 1983, 3, 1, 0, 2)),
                v(A2(Mc, 540, Pc(Ts)), A5(Ic, 2008, 2, 31, 0, 2))
            ]), A2(Mc, 480, Pc(Ts))));
        }),
        v("Asia/Colombo", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 330, Ao(0)), A5(Ic, 1996, 4, 25, 0, 2)),
                v(A2(Mc, 390, Ao(0)), A5(Ic, 1996, 9, 26, 30, 2)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 2006, 3, 15, 30, 2))
            ]), A2(Mc, 330, Ao(0))));
        }),
        v("Asia/Damascus", function() {
            return vo(A2(Zc, g, A2(Mc, 120, Pc(Ps))));
        }),
        v("Asia/Dhaka", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 360, Ao(0)), A5(Ic, 2009, 0, 1, 0, 2))
            ]), A2(Mc, 360, Pc(Zs))));
        }),
        v("Asia/Dili", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 540, Ao(0)), A5(Ic, 1976, 4, 3, 0, 2)),
                v(A2(Mc, 480, Ao(0)), A5(Ic, 2e3, 8, 17, 0, 2))
            ]), A2(Mc, 540, Ao(0))));
        }),
        v("Asia/Dubai", Ms),
        v("Asia/Dushanbe", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 360, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 300, Ao(60)), A5(Ic, 1991, 8, 9, 120, 1))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Asia/Famagusta", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 120, Pc(Ls)), A5(Ic, 1998, 8, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Bs)), A5(Ic, 2016, 8, 8, 0, 2)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 2017, 9, 29, 60, 0))
            ]), A2(Mc, 120, Pc(Bs))));
        }),
        v("Asia/Gaza", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 120, Pc(Is)), A5(Ic, 1996, 0, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Es)), A5(Ic, 1999, 0, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Ns)), A5(Ic, 2008, 7, 29, 0, 2)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 2008, 8, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Ns)), A5(Ic, 2010, 0, 1, 0, 2)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 2010, 2, 27, 1, 2)),
                v(A2(Mc, 120, Pc(Ns)), A5(Ic, 2011, 7, 1, 0, 2)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 2012, 0, 1, 0, 2))
            ]), A2(Mc, 120, Pc(Ns))));
        }),
        v("Asia/Hebron", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 120, Pc(Is)), A5(Ic, 1996, 0, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Es)), A5(Ic, 1999, 0, 1, 0, 2))
            ]), A2(Mc, 120, Pc(Ns))));
        }),
        v("Asia/Ho_Chi_Minh", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 480, Ao(0)), A5(Ic, 1975, 5, 13, 0, 2))
            ]), A2(Mc, 420, Ao(0))));
        }),
        v("Asia/Hong_Kong", function() {
            return vo(A2(Zc, g, A2(Mc, 480, Pc(Os))));
        }),
        v("Asia/Hovd", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 360, Ao(0)), A5(Ic, 1978, 0, 1, 0, 2))
            ]), A2(Mc, 420, Pc(Ts))));
        }),
        v("Asia/Irkutsk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 480, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 480, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 540, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 480, Ao(0))));
        }),
        v("Asia/Istanbul", Us),
        v("Asia/Jakarta", function() {
            return vo(A2(Zc, g, A2(Mc, 420, Ao(0))));
        }),
        v("Asia/Jayapura", function() {
            return vo(A2(Zc, g, A2(Mc, 540, Ao(0))));
        }),
        v("Asia/Jerusalem", function() {
            return vo(A2(Zc, g, A2(Mc, 120, Pc(Is))));
        }),
        v("Asia/Kabul", function() {
            return vo(A2(Zc, g, A2(Mc, 270, Ao(0))));
        }),
        v("Asia/Kamchatka", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 720, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 720, Pc(qs)), A5(Ic, 2010, 2, 28, 120, 1)),
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1))
            ]), A2(Mc, 720, Ao(0))));
        }),
        v("Asia/Karachi", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Ao(0)), A5(Ic, 1971, 2, 26, 0, 2))
            ]), A2(Mc, 300, Pc(Ks))));
        }),
        v("Asia/Kathmandu", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 330, Ao(0)), A5(Ic, 1986, 0, 1, 0, 2))
            ]), A2(Mc, 345, Ao(0))));
        }),
        v("Asia/Khandyga", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 540, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 480, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 540, Pc(qs)), A5(Ic, 2004, 0, 1, 0, 2)),
                v(A2(Mc, 600, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 660, Ao(0)), A5(Ic, 2011, 8, 13, 0, 1)),
                v(A2(Mc, 600, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 540, Ao(0))));
        }),
        v("Asia/Kolkata", function() {
            return vo(A2(Zc, g, A2(Mc, 330, Ao(0))));
        }),
        v("Asia/Krasnoyarsk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 480, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 420, Ao(0))));
        }),
        v("Asia/Kuala_Lumpur", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 450, Ao(0)), A5(Ic, 1982, 0, 1, 0, 2))
            ]), A2(Mc, 480, Ao(0))));
        }),
        v("Asia/Kuching", function() {
            return vo(A2(Zc, g, A2(Mc, 480, Ao(0))));
        }),
        v("Asia/Kuwait", Ws),
        v("Asia/Macau", function() {
            return vo(A2(Zc, g, A2(Mc, 480, Pc(Xs))));
        }),
        v("Asia/Magadan", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 600, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 720, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1)),
                v(A2(Mc, 600, Ao(0)), A5(Ic, 2016, 3, 24, 120, 1))
            ]), A2(Mc, 660, Ao(0))));
        }),
        v("Asia/Makassar", function() {
            return vo(A2(Zc, g, A2(Mc, 480, Ao(0))));
        }),
        v("Asia/Manila", function() {
            return vo(A2(Zc, g, A2(Mc, 480, Pc(Ys))));
        }),
        v("Asia/Muscat", Js),
        v("Asia/Nicosia", nl),
        v("Asia/Novokuznetsk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 2010, 2, 28, 120, 1)),
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1))
            ]), A2(Mc, 420, Ao(0))));
        }),
        v("Asia/Novosibirsk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 1993, 4, 23, 0, 2)),
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 420, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 2016, 6, 24, 120, 1))
            ]), A2(Mc, 420, Ao(0))));
        }),
        v("Asia/Omsk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 300, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 420, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 360, Ao(0))));
        }),
        v("Asia/Oral", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Ao(0)), A5(Ic, 1981, 3, 1, 0, 2)),
                v(A2(Mc, 300, Ao(60)), A5(Ic, 1981, 9, 1, 0, 2)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 1982, 3, 1, 0, 2)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1989, 2, 26, 120, 1)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1992, 2, 29, 120, 1)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 2004, 9, 31, 120, 1))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Asia/Phnom_Penh", rl),
        v("Asia/Pontianak", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 480, Ao(0)), A5(Ic, 1988, 0, 1, 0, 2))
            ]), A2(Mc, 420, Ao(0))));
        }),
        v("Asia/Pyongyang", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 540, Ao(0)), A5(Ic, 2015, 7, 15, 0, 2)),
                v(A2(Mc, 510, Ao(0)), A5(Ic, 2018, 4, 4, 1410, 2))
            ]), A2(Mc, 540, Ao(0))));
        }),
        v("Asia/Qatar", js),
        v("Asia/Qostanay", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Ao(0)), A5(Ic, 1981, 3, 1, 0, 2)),
                v(A2(Mc, 300, Ao(60)), A5(Ic, 1981, 9, 1, 0, 2)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 1982, 3, 1, 0, 2)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 2004, 9, 31, 120, 1))
            ]), A2(Mc, 360, Ao(0))));
        }),
        v("Asia/Qyzylorda", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Ao(0)), A5(Ic, 1981, 3, 1, 0, 2)),
                v(A2(Mc, 300, Ao(60)), A5(Ic, 1981, 9, 1, 0, 2)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 1982, 3, 1, 0, 2)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 1991, 8, 29, 120, 1)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 360, Pc(ks)), A5(Ic, 1992, 2, 29, 120, 1)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 2004, 9, 31, 120, 1)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 2018, 11, 21, 0, 2))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Asia/Riyadh", Cs),
        v("Asia/Sakhalin", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 600, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 1997, 2, 30, 120, 1)),
                v(A2(Mc, 600, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 660, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1)),
                v(A2(Mc, 600, Ao(0)), A5(Ic, 2016, 2, 27, 120, 1))
            ]), A2(Mc, 660, Ao(0))));
        }),
        v("Asia/Samarkand", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Ao(0)), A5(Ic, 1981, 3, 1, 0, 2)),
                v(A2(Mc, 300, Ao(60)), A5(Ic, 1981, 9, 1, 0, 2)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 1982, 3, 1, 0, 2)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1992, 0, 1, 0, 2))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Asia/Seoul", function() {
            return vo(A2(Zc, g, A2(Mc, 540, Pc(tl))));
        }),
        v("Asia/Shanghai", function() {
            return vo(A2(Zc, g, A2(Mc, 480, Pc(el))));
        }),
        v("Asia/Singapore", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 450, Ao(0)), A5(Ic, 1982, 0, 1, 0, 2))
            ]), A2(Mc, 480, Ao(0))));
        }),
        v("Asia/Srednekolymsk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 600, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 720, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 660, Ao(0))));
        }),
        v("Asia/Taipei", function() {
            return vo(A2(Zc, g, A2(Mc, 480, Pc(ul))));
        }),
        v("Asia/Tashkent", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 360, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 2)),
                v(A2(Mc, 300, Pc(ks)), A5(Ic, 1992, 0, 1, 0, 2))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Asia/Tbilisi", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 180, Pc(ks)), A5(Ic, 1992, 0, 1, 0, 2)),
                v(A2(Mc, 180, Pc(al)), A5(Ic, 1994, 8, 25, 0, 2)),
                v(A2(Mc, 240, Pc(al)), A5(Ic, 1996, 9, 27, 0, 2)),
                v(A2(Mc, 240, Ao(60)), A5(Ic, 1997, 2, 30, 0, 2)),
                v(A2(Mc, 240, Pc(al)), A5(Ic, 2004, 5, 27, 0, 2)),
                v(A2(Mc, 180, Pc(ks)), A5(Ic, 2005, 2, 27, 120, 2))
            ]), A2(Mc, 240, Ao(0))));
        }),
        v("Asia/Tehran", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 210, Ao(0)), A5(Ic, 1977, 10, 1, 0, 2)),
                v(A2(Mc, 240, Pc(il)), A5(Ic, 1979, 0, 1, 0, 2))
            ]), A2(Mc, 210, Pc(il))));
        }),
        v("Asia/Thimphu", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 330, Ao(0)), A5(Ic, 1987, 9, 1, 0, 2))
            ]), A2(Mc, 360, Ao(0))));
        }),
        v("Asia/Tokyo", function() {
            return vo(A2(Zc, g, A2(Mc, 540, Ao(0))));
        }),
        v("Asia/Tomsk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 420, Pc(qs)), A5(Ic, 2002, 4, 1, 180, 2)),
                v(A2(Mc, 360, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 420, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 2016, 4, 29, 120, 1))
            ]), A2(Mc, 420, Ao(0))));
        }),
        v("Asia/Ulaanbaatar", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 420, Ao(0)), A5(Ic, 1978, 0, 1, 0, 2))
            ]), A2(Mc, 480, Pc(Ts))));
        }),
        v("Asia/Urumqi", function() {
            return vo(A2(Zc, g, A2(Mc, 360, Ao(0))));
        }),
        v("Asia/Ust-Nera", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 540, Pc(qs)), A5(Ic, 1981, 3, 1, 0, 2)),
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 600, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 660, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 720, Ao(0)), A5(Ic, 2011, 8, 13, 0, 1)),
                v(A2(Mc, 660, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 600, Ao(0))));
        }),
        v("Asia/Vientiane", cl),
        v("Asia/Vladivostok", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 600, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 540, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 600, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 660, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 600, Ao(0))));
        }),
        v("Asia/Yakutsk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 540, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 480, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 540, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 600, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 540, Ao(0))));
        }),
        v("Asia/Yangon", function() {
            return vo(A2(Zc, g, A2(Mc, 390, Ao(0))));
        }),
        v("Asia/Yekaterinburg", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 240, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 300, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 360, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 300, Ao(0))));
        }),
        v("Asia/Yerevan", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 180, Pc(ks)), A5(Ic, 1995, 8, 24, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 1997, 0, 1, 0, 2)),
                v(A2(Mc, 240, Pc(ks)), A5(Ic, 2011, 0, 1, 0, 2))
            ]), A2(Mc, 240, Pc(ol))));
        }),
        v("Atlantic/Azores", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -60, Pc(fl)), A5(Ic, 1983, 8, 25, 60, 1)),
                v(A2(Mc, -60, Pc(sl)), A5(Ic, 1992, 8, 27, 60, 1)),
                v(A2(Mc, 0, Pc(Lo)), A5(Ic, 1993, 2, 28, 60, 0))
            ]), A2(Mc, -60, Pc(Lo))));
        }),
        v("Atlantic/Bermuda", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Ao(0)), A5(Ic, 1974, 3, 28, 120, 2)),
                v(A2(Mc, -240, Pc(Df)), A5(Ic, 1976, 0, 1, 0, 2))
            ]), A2(Mc, -240, Pc(ho))));
        }),
        v("Atlantic/Canary", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 0, Ao(0)), A5(Ic, 1980, 3, 6, 0, 1)),
                v(A2(Mc, 0, Ao(60)), A5(Ic, 1980, 8, 28, 60, 0))
            ]), A2(Mc, 0, Pc(Lo))));
        }),
        v("Atlantic/Cape_Verde", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -120, Ao(0)), A5(Ic, 1975, 10, 25, 120, 2))
            ]), A2(Mc, -60, Ao(0))));
        }),
        v("Atlantic/Faroe", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 0, Ao(0)), A5(Ic, 1981, 0, 1, 0, 2))
            ]), A2(Mc, 0, Pc(Lo))));
        }),
        v("Atlantic/Madeira", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 0, Pc(fl)), A5(Ic, 1983, 8, 25, 60, 1))
            ]), A2(Mc, 0, Pc(Lo))));
        }),
        v("Atlantic/Reykjavik", function() {
            return vo(A2(Zc, g, A2(Mc, 0, Ao(0))));
        }),
        v("Atlantic/South_Georgia", function() {
            return vo(A2(Zc, g, A2(Mc, -120, Ao(0))));
        }),
        v("Atlantic/St_Helena", ll),
        v("Atlantic/Stanley", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -240, Pc(dl)), A5(Ic, 1983, 4, 1, 0, 2)),
                v(A2(Mc, -180, Pc(dl)), A5(Ic, 1985, 8, 15, 0, 2)),
                v(A2(Mc, -240, Pc(dl)), A5(Ic, 2010, 8, 5, 120, 2))
            ]), A2(Mc, -180, Ao(0))));
        }),
        v("Australia/Adelaide", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 570, Ao(0)), A5(Ic, 1971, 0, 1, 0, 2))
            ]), A2(Mc, 570, Pc(vl))));
        }),
        v("Australia/Brisbane", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 600, Ao(0)), A5(Ic, 1971, 0, 1, 0, 2))
            ]), A2(Mc, 600, Pc(bl))));
        }),
        v("Australia/Broken_Hill", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 570, Ao(0)), A5(Ic, 1971, 0, 1, 0, 2)),
                v(A2(Mc, 570, Pc(ml)), A5(Ic, 2e3, 0, 1, 0, 2))
            ]), A2(Mc, 570, Pc(vl))));
        }),
        v("Australia/Currie", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 600, Ao(0)), A5(Ic, 1971, 6, 1, 0, 2))
            ]), A2(Mc, 600, Pc($s))));
        }),
        v("Australia/Darwin", function() {
            return vo(A2(Zc, g, A2(Mc, 570, Ao(0))));
        }),
        v("Australia/Eucla", function() {
            return vo(A2(Zc, g, A2(Mc, 525, Pc(pl))));
        }),
        v("Australia/Hobart", function() {
            return vo(A2(Zc, g, A2(Mc, 600, Pc($s))));
        }),
        v("Australia/Lindeman", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 600, Ao(0)), A5(Ic, 1971, 0, 1, 0, 2)),
                v(A2(Mc, 600, Pc(bl)), A5(Ic, 1992, 6, 1, 0, 2))
            ]), A2(Mc, 600, Pc($l))));
        }),
        v("Australia/Lord_Howe", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 600, Ao(0)), A5(Ic, 1981, 2, 1, 0, 2)),
                v(A2(Mc, 630, Pc(gl)), A5(Ic, 1985, 6, 1, 0, 2))
            ]), A2(Mc, 630, Pc(gl))));
        }),
        v("Australia/Melbourne", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 600, Ao(0)), A5(Ic, 1971, 0, 1, 0, 2))
            ]), A2(Mc, 600, Pc(hl))));
        }),
        v("Australia/Perth", function() {
            return vo(A2(Zc, g, A2(Mc, 480, Pc(pl))));
        }),
        v("Australia/Sydney", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 600, Ao(0)), A5(Ic, 1971, 0, 1, 0, 2))
            ]), A2(Mc, 600, Pc(ml))));
        }),
        v("Europe/Amsterdam", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1977, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Andorra", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1985, 2, 31, 120, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Astrakhan", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 240, Pc(qs)), A5(Ic, 1989, 2, 26, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 1992, 2, 29, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 2016, 2, 27, 120, 1))
            ]), A2(Mc, 240, Ao(0))));
        }),
        v("Europe/Athens", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 120, Pc(yl)), A5(Ic, 1981, 0, 1, 0, 2))
            ]), A2(Mc, 120, Pc(Lo))));
        }),
        v("Europe/Belgrade", wl),
        v("Europe/Berlin", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1980, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Bratislava", _l),
        v("Europe/Brussels", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1977, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Bucharest", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 120, Pc(Al)), A5(Ic, 1981, 2, 29, 120, 1)),
                v(A2(Mc, 120, Pc(is)), A5(Ic, 1991, 0, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Al)), A5(Ic, 1994, 0, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Cl)), A5(Ic, 1997, 0, 1, 0, 2))
            ]), A2(Mc, 120, Pc(Lo))));
        }),
        v("Europe/Budapest", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Pc(kl)), A5(Ic, 1984, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Busingen", ql),
        v("Europe/Chisinau", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1990, 4, 6, 120, 2)),
                v(A2(Mc, 120, Pc(qs)), A5(Ic, 1992, 0, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Cl)), A5(Ic, 1997, 0, 1, 0, 2))
            ]), A2(Mc, 120, Pc(Fl))));
        }),
        v("Europe/Copenhagen", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1980, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Dublin", function() {
            return vo(A2(Zc, g, A2(Mc, 60, Pc(jl))));
        }),
        v("Europe/Gibraltar", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1982, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Guernsey", Bl),
        v("Europe/Helsinki", zl),
        v("Europe/Isle_of_Man", Sl),
        v("Europe/Istanbul", Rs),
        v("Europe/Jersey", Tl),
        v("Europe/Kaliningrad", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1989, 2, 26, 120, 1)),
                v(A2(Mc, 120, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 120, Ao(0))));
        }),
        v("Europe/Kiev", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1990, 6, 1, 120, 2)),
                v(A2(Mc, 120, Ao(60)), A5(Ic, 1991, 8, 29, 180, 2)),
                v(A2(Mc, 120, Pc(Cl)), A5(Ic, 1995, 0, 1, 0, 2))
            ]), A2(Mc, 120, Pc(Lo))));
        }),
        v("Europe/Kirov", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 240, Pc(qs)), A5(Ic, 1989, 2, 26, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 1992, 2, 29, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 180, Ao(0))));
        }),
        v("Europe/Lisbon", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1976, 8, 26, 60, 2)),
                v(A2(Mc, 0, Pc(fl)), A5(Ic, 1983, 8, 25, 60, 1)),
                v(A2(Mc, 0, Pc(sl)), A5(Ic, 1992, 8, 27, 60, 1)),
                v(A2(Mc, 60, Pc(Lo)), A5(Ic, 1996, 2, 31, 60, 0))
            ]), A2(Mc, 0, Pc(Lo))));
        }),
        v("Europe/Ljubljana", Pl),
        v("Europe/London", Vl),
        v("Europe/Luxembourg", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1977, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Madrid", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Pc(Zl)), A5(Ic, 1979, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Malta", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Pc(Ml)), A5(Ic, 1973, 2, 31, 0, 2)),
                v(A2(Mc, 60, Pc(Ll)), A5(Ic, 1981, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Mariehamn", Nl),
        v("Europe/Minsk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1990, 0, 1, 0, 2)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 120, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1))
            ]), A2(Mc, 180, Ao(0))));
        }),
        v("Europe/Monaco", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Pc(Hl)), A5(Ic, 1977, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Moscow", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 120, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 180, Ao(0))));
        }),
        v("Europe/Nicosia", Il),
        v("Europe/Oslo", xs),
        v("Europe/Paris", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Pc(Hl)), A5(Ic, 1977, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Podgorica", Ol),
        v("Europe/Prague", xl),
        v("Europe/Riga", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1989, 2, 26, 120, 1)),
                v(A2(Mc, 120, Ao(60)), A5(Ic, 1989, 8, 24, 120, 1)),
                v(A2(Mc, 120, Pc(Ql)), A5(Ic, 1997, 0, 21, 0, 2)),
                v(A2(Mc, 120, Pc(Lo)), A5(Ic, 2e3, 1, 29, 0, 2)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 2001, 0, 2, 0, 2))
            ]), A2(Mc, 120, Pc(Lo))));
        }),
        v("Europe/Rome", Rl),
        v("Europe/Samara", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 240, Pc(qs)), A5(Ic, 1989, 2, 26, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 120, Pc(qs)), A5(Ic, 1991, 8, 29, 120, 1)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 1991, 9, 20, 180, 2)),
                v(A2(Mc, 240, Pc(qs)), A5(Ic, 2010, 2, 28, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1))
            ]), A2(Mc, 240, Ao(0))));
        }),
        v("Europe/San_Marino", Ul),
        v("Europe/Sarajevo", Kl),
        v("Europe/Saratov", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 240, Pc(qs)), A5(Ic, 1988, 2, 27, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 1992, 2, 29, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 2016, 11, 4, 120, 1))
            ]), A2(Mc, 240, Ao(0))));
        }),
        v("Europe/Simferopol", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1990, 0, 1, 0, 2)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 1990, 6, 1, 120, 2)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 1992, 0, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Cl)), A5(Ic, 1994, 4, 1, 0, 2)),
                v(A2(Mc, 180, Pc(Cl)), A5(Ic, 1996, 2, 31, 0, 1)),
                v(A2(Mc, 180, Ao(60)), A5(Ic, 1996, 9, 27, 180, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1997, 0, 1, 0, 2)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 1997, 2, 30, 60, 0)),
                v(A2(Mc, 120, Pc(Lo)), A5(Ic, 2014, 2, 30, 120, 2)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1))
            ]), A2(Mc, 180, Ao(0))));
        }),
        v("Europe/Skopje", Wl),
        v("Europe/Sofia", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 120, Ao(0)), A5(Ic, 1979, 2, 31, 1380, 2)),
                v(A2(Mc, 120, Pc(Xl)), A5(Ic, 1982, 8, 26, 180, 2)),
                v(A2(Mc, 120, Pc(is)), A5(Ic, 1991, 0, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Cl)), A5(Ic, 1997, 0, 1, 0, 2))
            ]), A2(Mc, 120, Pc(Lo))));
        }),
        v("Europe/Stockholm", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1980, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Tallinn", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1989, 2, 26, 120, 1)),
                v(A2(Mc, 120, Ao(60)), A5(Ic, 1989, 8, 24, 120, 1)),
                v(A2(Mc, 120, Pc(is)), A5(Ic, 1998, 8, 22, 0, 2)),
                v(A2(Mc, 120, Pc(Lo)), A5(Ic, 1999, 9, 31, 240, 2)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 2002, 1, 21, 0, 2))
            ]), A2(Mc, 120, Pc(Lo))));
        }),
        v("Europe/Tirane", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Pc(Yl)), A5(Ic, 1984, 6, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Ulyanovsk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 240, Pc(qs)), A5(Ic, 1989, 2, 26, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 120, Pc(qs)), A5(Ic, 1992, 0, 19, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 2016, 2, 27, 120, 1))
            ]), A2(Mc, 240, Ao(0))));
        }),
        v("Europe/Uzhgorod", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1990, 0, 1, 0, 2)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 1990, 6, 1, 120, 2)),
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1991, 2, 31, 180, 2)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 1992, 0, 1, 0, 2)),
                v(A2(Mc, 120, Pc(Cl)), A5(Ic, 1995, 0, 1, 0, 2))
            ]), A2(Mc, 120, Pc(Lo))));
        }),
        v("Europe/Vaduz", Jl),
        v("Europe/Vatican", nd),
        v("Europe/Vienna", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Pc(rd)), A5(Ic, 1981, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Vilnius", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1989, 2, 26, 120, 1)),
                v(A2(Mc, 120, Pc(qs)), A5(Ic, 1991, 8, 29, 120, 1)),
                v(A2(Mc, 120, Pc(is)), A5(Ic, 1998, 0, 1, 0, 2)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 1998, 2, 29, 60, 0)),
                v(A2(Mc, 60, Pc(Lo)), A5(Ic, 1999, 9, 31, 60, 0)),
                v(A2(Mc, 120, Ao(0)), A5(Ic, 2003, 0, 1, 0, 2))
            ]), A2(Mc, 120, Pc(Lo))));
        }),
        v("Europe/Volgograd", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 240, Pc(qs)), A5(Ic, 1988, 2, 27, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 1992, 2, 29, 120, 1)),
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 2011, 2, 27, 120, 1)),
                v(A2(Mc, 240, Ao(0)), A5(Ic, 2014, 9, 26, 120, 1)),
                v(A2(Mc, 180, Ao(0)), A5(Ic, 2018, 9, 28, 120, 1))
            ]), A2(Mc, 240, Ao(0))));
        }),
        v("Europe/Warsaw", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 60, Ao(0)), A5(Ic, 1977, 0, 1, 0, 2)),
                v(A2(Mc, 60, Pc(sl)), A5(Ic, 1988, 0, 1, 0, 2))
            ]), A2(Mc, 60, Pc(Lo))));
        }),
        v("Europe/Zagreb", td),
        v("Europe/Zaporozhye", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 180, Pc(qs)), A5(Ic, 1991, 2, 31, 120, 2)),
                v(A2(Mc, 120, Pc(Cl)), A5(Ic, 1995, 0, 1, 0, 2))
            ]), A2(Mc, 120, Pc(Lo))));
        }),
        v("Europe/Zurich", El),
        v("Indian/Antananarivo", ud),
        v("Indian/Chagos", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 300, Ao(0)), A5(Ic, 1996, 0, 1, 0, 2))
            ]), A2(Mc, 360, Ao(0))));
        }),
        v("Indian/Christmas", function() {
            return vo(A2(Zc, g, A2(Mc, 420, Ao(0))));
        }),
        v("Indian/Cocos", function() {
            return vo(A2(Zc, g, A2(Mc, 390, Ao(0))));
        }),
        v("Indian/Comoro", ad),
        v("Indian/Kerguelen", function() {
            return vo(A2(Zc, g, A2(Mc, 300, Ao(0))));
        }),
        v("Indian/Mahe", function() {
            return vo(A2(Zc, g, A2(Mc, 240, Ao(0))));
        }),
        v("Indian/Maldives", function() {
            return vo(A2(Zc, g, A2(Mc, 300, Ao(0))));
        }),
        v("Indian/Mauritius", function() {
            return vo(A2(Zc, g, A2(Mc, 240, Pc(id))));
        }),
        v("Indian/Mayotte", cd),
        v("Indian/Reunion", function() {
            return vo(A2(Zc, g, A2(Mc, 240, Ao(0))));
        }),
        v("Pacific/Apia", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -660, Pc(od)), A5(Ic, 2011, 11, 29, 1440, 2))
            ]), A2(Mc, 780, Pc(od))));
        }),
        v("Pacific/Auckland", hs),
        v("Pacific/Bougainville", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 600, Ao(0)), A5(Ic, 2014, 11, 28, 120, 2))
            ]), A2(Mc, 660, Ao(0))));
        }),
        v("Pacific/Chatham", function() {
            return vo(A2(Zc, g, A2(Mc, 765, Pc(fd))));
        }),
        v("Pacific/Chuuk", function() {
            return vo(A2(Zc, g, A2(Mc, 600, Ao(0))));
        }),
        v("Pacific/Easter", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -420, Pc(us)), A5(Ic, 1982, 2, 14, 180, 0))
            ]), A2(Mc, -360, Pc(us))));
        }),
        v("Pacific/Efate", function() {
            return vo(A2(Zc, g, A2(Mc, 660, Pc(sd))));
        }),
        v("Pacific/Enderbury", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -720, Ao(0)), A5(Ic, 1979, 9, 1, 0, 2)),
                v(A2(Mc, -660, Ao(0)), A5(Ic, 1994, 11, 31, 0, 2))
            ]), A2(Mc, 780, Ao(0))));
        }),
        v("Pacific/Fakaofo", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -660, Ao(0)), A5(Ic, 2011, 11, 30, 0, 2))
            ]), A2(Mc, 780, Ao(0))));
        }),
        v("Pacific/Fiji", function() {
            return vo(A2(Zc, g, A2(Mc, 720, Pc(ld))));
        }),
        v("Pacific/Funafuti", function() {
            return vo(A2(Zc, g, A2(Mc, 720, Ao(0))));
        }),
        v("Pacific/Galapagos", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -300, Ao(0)), A5(Ic, 1986, 0, 1, 0, 2))
            ]), A2(Mc, -360, Pc(Qf))));
        }),
        v("Pacific/Gambier", function() {
            return vo(A2(Zc, g, A2(Mc, -540, Ao(0))));
        }),
        v("Pacific/Guadalcanal", function() {
            return vo(A2(Zc, g, A2(Mc, 660, Ao(0))));
        }),
        v("Pacific/Guam", vd),
        v("Pacific/Honolulu", function() {
            return vo(A2(Zc, g, A2(Mc, -600, Ao(0))));
        }),
        v("Pacific/Kiritimati", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -640, Ao(0)), A5(Ic, 1979, 9, 1, 0, 2)),
                v(A2(Mc, -600, Ao(0)), A5(Ic, 1994, 11, 31, 0, 2))
            ]), A2(Mc, 840, Ao(0))));
        }),
        v("Pacific/Kosrae", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 720, Ao(0)), A5(Ic, 1999, 0, 1, 0, 2))
            ]), A2(Mc, 660, Ao(0))));
        }),
        v("Pacific/Kwajalein", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -720, Ao(0)), A5(Ic, 1993, 7, 20, 1440, 2))
            ]), A2(Mc, 720, Ao(0))));
        }),
        v("Pacific/Majuro", function() {
            return vo(A2(Zc, g, A2(Mc, 720, Ao(0))));
        }),
        v("Pacific/Marquesas", function() {
            return vo(A2(Zc, g, A2(Mc, -570, Ao(0))));
        }),
        v("Pacific/Midway", md),
        v("Pacific/Nauru", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 690, Ao(0)), A5(Ic, 1979, 1, 10, 120, 2))
            ]), A2(Mc, 720, Ao(0))));
        }),
        v("Pacific/Niue", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -690, Ao(0)), A5(Ic, 1978, 9, 1, 0, 2))
            ]), A2(Mc, -660, Ao(0))));
        }),
        v("Pacific/Norfolk", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 690, Ao(0)), A5(Ic, 1974, 9, 27, 120, 1)),
                v(A2(Mc, 690, Ao(60)), A5(Ic, 1975, 2, 2, 120, 1)),
                v(A2(Mc, 690, Ao(0)), A5(Ic, 2015, 9, 4, 120, 1)),
                v(A2(Mc, 660, Ao(0)), A5(Ic, 2019, 6, 1, 0, 2))
            ]), A2(Mc, 660, Pc(ml))));
        }),
        v("Pacific/Noumea", function() {
            return vo(A2(Zc, g, A2(Mc, 660, Pc(pd))));
        }),
        v("Pacific/Pago_Pago", bd),
        v("Pacific/Palau", function() {
            return vo(A2(Zc, g, A2(Mc, 540, Ao(0))));
        }),
        v("Pacific/Pitcairn", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -510, Ao(0)), A5(Ic, 1998, 3, 27, 0, 2))
            ]), A2(Mc, -480, Ao(0))));
        }),
        v("Pacific/Pohnpei", function() {
            return vo(A2(Zc, g, A2(Mc, 660, Ao(0))));
        }),
        v("Pacific/Port_Moresby", function() {
            return vo(A2(Zc, g, A2(Mc, 600, Ao(0))));
        }),
        v("Pacific/Rarotonga", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, -630, Ao(0)), A5(Ic, 1978, 10, 12, 0, 2))
            ]), A2(Mc, -600, Pc($d))));
        }),
        v("Pacific/Saipan", gd),
        v("Pacific/Tahiti", function() {
            return vo(A2(Zc, g, A2(Mc, -600, Ao(0))));
        }),
        v("Pacific/Tarawa", function() {
            return vo(A2(Zc, g, A2(Mc, 720, Ao(0))));
        }),
        v("Pacific/Tongatapu", function() {
            return vo(A2(Zc, w([
                v(A2(Mc, 780, Ao(0)), A5(Ic, 1999, 0, 1, 0, 2))
            ]), A2(Mc, 780, Pc(hd))));
        }),
        v("Pacific/Wake", function() {
            return vo(A2(Zc, g, A2(Mc, 720, Ao(0))));
        }),
        v("Pacific/Wallis", function() {
            return vo(A2(Zc, g, A2(Mc, 720, Ao(0))));
        })
    ])), wd = A2(ju, function(n) {
        if (n.$) return _o(xo);
        var r = n.a, t = A2(ra, r, yd);
        return t.$ ? _o({
            $: 1,
            a: r
        }) : Au(v(r, (0, t.a)(0)));
    }, Co), xd = ar, _d = xd, Cd = function(n) {
        var r = n.Gj;
        return {
            hv: Le,
            sl: n.sl,
            dJ: function(n) {
                return A2(tu, r(n), _d);
            },
            ln: n.Gk,
            Eg: !1
        };
    }, Ad = function(n) {
        return n.ut;
    }, kd = function(n) {
        return n.xH;
    }, Ed = {
        n0: function(n) {
            return n.z3.n0;
        },
        n1: function(n) {
            return n.z3.n1;
        },
        Aj: function(n) {
            return n.z3.Aj;
        },
        hf: function(n) {
            return n.z3.hf;
        },
        n7: function(n) {
            return n.z3.n7;
        },
        n8: function(n) {
            return n.z3.n8;
        },
        n9: function(n) {
            return n.z3.n9;
        },
        od: function(n) {
            return n.z3.od;
        },
        oG: function(n) {
            return n.z3.oG;
        },
        qa: function(n) {
            return n.z3.qa;
        },
        qb: function(n) {
            return n.z3.qb;
        },
        cb: function(n) {
            return n.z3.cb;
        },
        vm: function(n) {
            return n.z3.vm;
        },
        x7: function(n) {
            return n.z3.x7;
        },
        x8: function(n) {
            return n.z3.x8;
        },
        x9: function(n) {
            return n.z3.x9;
        },
        ya: function(n) {
            return n.z3.ya;
        },
        yb: function(n) {
            return n.z3.yb;
        },
        yx: function(n) {
            return n.z3.yx;
        },
        yV: function(n) {
            return n.z3.yV;
        },
        zB: function(n) {
            return n.z3.zB;
        },
        zC: function(n) {
            return n.z3.zC;
        }
    }, qd = function(n) {
        return n.aa.yx;
    }, Fd = function(n) {
        return n.dB.yx;
    }, jd = function(n) {
        return n.h4.qV;
    }, Dd = function(n) {
        return n.h4.rd;
    }, Vd = function(n) {
        return n.h4.yx;
    }, Bd = function(n) {
        return n.h.zP;
    }, Gd = function(n) {
        return n.h.np;
    }, zd = function(n) {
        return n.h.ou;
    }, Sd = function(n) {
        return n.h.py;
    }, Td = function(n) {
        return n.h.AU;
    }, Pd = function(n) {
        return n.h.pz;
    }, Zd = function(n) {
        return n.h.AV;
    }, Md = function(n) {
        return n.h.pA;
    }, Ld = function(n) {
        return n.h.pB;
    }, Nd = function(n) {
        return n.h.Bk;
    }, Hd = function(n) {
        return n.h.qA;
    }, Id = function(n) {
        return n.h.qB;
    }, Od = function(n) {
        return n.h.qC;
    }, Qd = function(n) {
        return n.h.sE;
    }, Rd = function(n) {
        return n.h.cb;
    }, Ud = function(n) {
        return n.h.uM;
    }, Kd = function(n) {
        return n.h.Eo;
    }, Wd = function(n) {
        return n.h.vw;
    }, Xd = function(n) {
        return n.h.vH;
    }, Yd = function(n) {
        return n.h.vI;
    }, Jd = function(n) {
        return n.h.vY;
    }, nv = function(n) {
        return n.h.yj;
    }, rv = function(n) {
        return n.h.F6;
    }, tv = function(n) {
        return n.h.yx;
    }, ev = function(n) {
        return n.h.Gm;
    }, uv = function(n) {
        return n.h.yL;
    }, av = function(n) {
        return n.h.yO;
    }, iv = function(n) {
        return n.h.zu;
    }, cv = function(n) {
        return n.h.GO;
    }, ov = {
        mS: function(n) {
            return n.fm.mS;
        },
        mT: function(n) {
            return n.fm.mT;
        },
        mU: function(n) {
            return n.fm.mU;
        },
        mV: function(n) {
            return n.fm.mV;
        },
        mX: function(n) {
            return n.fm.mX;
        },
        mY: function(n) {
            return n.fm.mY;
        },
        mZ: function(n) {
            return n.fm.mZ;
        },
        m5: function(n) {
            return n.fm.m5;
        },
        Bb: function(n) {
            return n.fm.Bb;
        },
        qJ: function(n) {
            return n.fm.qJ;
        },
        qS: function(n) {
            return n.fm.qS;
        },
        r2: function(n) {
            return n.fm.r2;
        },
        r3: function(n) {
            return n.fm.r3;
        },
        r4: function(n) {
            return n.fm.r4;
        },
        r5: function(n) {
            return n.fm.r5;
        },
        sp: function(n) {
            return n.fm.sp;
        },
        sq: function(n) {
            return n.fm.sq;
        },
        cb: function(n) {
            return n.fm.cb;
        },
        ts: function(n) {
            return n.fm.ts;
        },
        C_: function(n) {
            return n.fm.C_;
        },
        uF: function(n) {
            return n.fm.uF;
        },
        yx: function(n) {
            return n.fm.yx;
        },
        GO: function(n) {
            return n.fm.GO;
        }
    }, fv = {
        pm: function(n) {
            return n.ad.pm;
        },
        pI: function(n) {
            return n.ad.pI;
        },
        pN: function(n) {
            return n.ad.pN;
        },
        q$: function(n) {
            return n.ad.q$;
        },
        q0: function(n) {
            return n.ad.q0;
        },
        i_: function(n) {
            return n.ad.i_;
        },
        wV: function(n) {
            return n.ad.wV;
        },
        xy: function(n) {
            return n.ad.xy;
        },
        yx: function(n) {
            return n.ad.yx;
        },
        Gi: function(n) {
            return n.ad.Gi;
        },
        GO: function(n) {
            return n.ad.GO;
        },
        zD: function(n) {
            return n.ad.zD;
        }
    }, sv = function(n) {
        return n.E.zN;
    }, lv = function(n) {
        return n.E.AC;
    }, dv = function(n) {
        return n.E.AQ;
    }, vv = function(n) {
        return n.E.rn;
    }, bv = function(n) {
        return n.E.BM;
    }, mv = function(n) {
        return n.E.BN;
    }, pv = function(n) {
        return n.E.ro;
    }, $v = function(n) {
        return n.E.BO;
    }, gv = function(n) {
        return n.E.uz;
    }, hv = function(n) {
        return n.E.uA;
    }, yv = function(n) {
        return n.E.uB;
    }, wv = function(n) {
        return n.E.uD;
    }, xv = function(n) {
        return n.E.uE;
    }, _v = function(n) {
        return n.E.E7;
    }, Cv = function(n) {
        return n.E.yx;
    }, Av = function(n) {
        return n.lW.mS;
    }, kv = function(n) {
        return n.lW.m_;
    }, Ev = function(n) {
        return n.lW.hg;
    }, qv = function(n) {
        return n.lW.pw;
    }, Fv = function(n) {
        return n.lW.qt;
    }, jv = function(n) {
        return n.lW.qL;
    }, Dv = function(n) {
        return n.lW.hT;
    }, Vv = function(n) {
        return n.lW.hU;
    }, Bv = function(n) {
        return n.lW.sH;
    }, Gv = function(n) {
        return n.lW.cb;
    }, zv = function(n) {
        return n.lW.tr;
    }, Sv = function(n) {
        return n.lW.vx;
    }, Tv = function(n) {
        return n.lW.Fj;
    }, Pv = function(n) {
        return n.lW.yx;
    }, Zv = function(n) {
        return n.lW.yJ;
    }, Mv = function(n) {
        return n.lW.kt;
    }, Lv = function(n) {
        return n.lW.GO;
    }, Nv = function(n) {
        return n.lW.zF;
    }, Hv = function(n) {
        return n.lW.zH;
    }, Iv = function(n) {
        return n.l3.xn;
    }, Ov = function(n) {
        return n.l3.yx;
    }, Qv = function(n) {
        switch(n){
            case 0:
                return tv;
            case 1:
                return ov.yx;
            case 2:
                return fv.yx;
            case 3:
                return Pv;
            case 4:
                return qd;
            case 5:
                return Fd;
            case 6:
                return Ov;
            case 7:
                return Vd;
            case 8:
                return Cv;
            default:
                return Ed.yx;
        }
    }, Rv = F3(function(n, r, t) {
        return r(t.$ ? n ? Ad : kd : Qv(t.a));
    }), Uv = function(n) {
        return n.$ ? "LogOut" : function(n) {
            switch(n){
                case 0:
                    return "Invoices";
                case 1:
                    return "Members";
                case 2:
                    return "Memberships";
                case 3:
                    return "PaymentSources";
                case 4:
                    return "Documents";
                case 5:
                    return "ExploreServices";
                case 6:
                    return "ProviderLocation";
                case 7:
                    return "HealthInformation";
                case 8:
                    return "Chat";
                case 9:
                    return "Booking";
                default:
                    return "Appointments";
            }
        }(n.a);
    }, Kv = function(n) {
        return {
            ce: !1,
            d$: Cd({
                sl: "profile-menu",
                Gj: Rv(n),
                Gk: A2(tu, Uv, It)
            })
        };
    }, Wv = Kv(!1), Xv = function(n) {
        return n.q2;
    }, Yv = function(n) {
        return n.xW;
    }, Jv = function(n) {
        return n ? Yv : Xv;
    }, nb = function(n) {
        return n ? "es" : "en";
    }, rb = function(n) {
        return {
            sl: n,
            CK: 0,
            fW: Cd({
                sl: n + "-preferred-language-select",
                Gj: function(n) {
                    return A2(tu, Jv, n);
                },
                Gk: function(n) {
                    return It(nb(n));
                }
            })
        };
    }, tb = z, eb = function(n) {
        return A2(tb, n, "");
    }, ub = F3(function(n, r, t) {
        return n > 0 ? A3(ub, n >> 1, $(r, r), 1 & n ? $(t, r) : t) : t;
    }), ab = F2(function(n, r) {
        return A3(ub, n, r, "");
    }), ib = F3(function(n, r, t) {
        return $(A2(ab, n - lu(t), eb(r)), t);
    }), cb = F2(function(n, r) {
        var t = function() {
            switch(r){
                case 1:
                    return "1st";
                case 21:
                    return "21st";
                case 2:
                    return "2nd";
                case 22:
                    return "22nd";
                case 3:
                    return "3rd";
                case 23:
                    return "23rd";
                case 31:
                    return "31st";
                default:
                    return oe(r) + "th";
            }
        }();
        return n ? A3(ib, 4, " ", t) : t;
    }), ob = {
        BV: {
            pS: "%-m/%-d/%Y",
            A3: "%-m/%-d/%Y %-I:%M %p",
            hZ: 6,
            CU: "%A, %B %d, %Y",
            CV: "%-I:%M:%S %p",
            Gf: "%-I:%M %p"
        },
        aD: {
            pX: function(n) {
                switch(n){
                    case 0:
                        return "Monday";
                    case 1:
                        return "Tuesday";
                    case 2:
                        return "Wednesday";
                    case 3:
                        return "Thursday";
                    case 4:
                        return "Friday";
                    case 5:
                        return "Saturday";
                    default:
                        return "Sunday";
                }
            },
            pY: cb,
            pZ: function(n) {
                switch(n){
                    case 0:
                        return "Mon";
                    case 1:
                        return "Tue";
                    case 2:
                        return "Wed";
                    case 3:
                        return "Thu";
                    case 4:
                        return "Fri";
                    case 5:
                        return "Sat";
                    default:
                        return "Sun";
                }
            },
            uo: function(n) {
                switch(n){
                    case 0:
                        return "January";
                    case 1:
                        return "February";
                    case 2:
                        return "March";
                    case 3:
                        return "April";
                    case 4:
                        return "May";
                    case 5:
                        return "June";
                    case 6:
                        return "July";
                    case 7:
                        return "August";
                    case 8:
                        return "September";
                    case 9:
                        return "October";
                    case 10:
                        return "November";
                    default:
                        return "December";
                }
            },
            up: function(n) {
                switch(n){
                    case 0:
                        return "Jan";
                    case 1:
                        return "Feb";
                    case 2:
                        return "Mar";
                    case 3:
                        return "Apr";
                    case 4:
                        return "May";
                    case 5:
                        return "Jun";
                    case 6:
                        return "Jul";
                    case 7:
                        return "Aug";
                    case 8:
                        return "Sep";
                    case 9:
                        return "Oct";
                    case 10:
                        return "Nov";
                    default:
                        return "Dec";
                }
            },
            yQ: function(n) {
                return n ? "PM" : "AM";
            }
        }
    }, fb = F4(function(n, r, t, e) {
        return {
            lh: r,
            lr: n,
            uM: t,
            F3: e
        };
    }), sb = ot, lb = function(n) {
        return A2(sb, {
            At: !1,
            Dg: !1
        }, n);
    }, db = /.^/, vb = A2(xc, db, lb("%(y|Y|m|_m|-m|B|^B|b|^b|d|-d|-@d|e|@e|A|^A|a|^a|H|-H|k|I|-I|l|p|P|M|S|%|L)")), bb = F2(function(n, r) {
        return r.$ ? Ot : n(r.a);
    }), mb = function(n) {
        return n.b ? It(n.a) : Ot;
    }, pb = function(n) {
        return A2(Qc, 12, n) ? A2(Qc, 12, n) : 12;
    }, $b = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, gb = function(n) {
        return A2(qc, A2(ib, 2, n), oe);
    }, hb = F2(function(n, r) {
        return A2(qc, A2(ib, n, r), oe);
    }), yb = F2(function(n, r) {
        return 1 > n ? "" : A3(du, -n, lu(r), r);
    }), wb = F2(function(n, r) {
        return Ne(n / r);
    }), xb = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r + n;
            var e = t.a, u = t.b;
            if (0 > s(e.x$, r)) return r + e.iH;
            t = u;
        }
    }), _b = F2(function(n, r) {
        var t = n.b;
        return A3(xb, n.a, A2(wb, r, 6e4), t);
    }), Cb = function(n) {
        var r = A2(wb, n, 1440) + 719468, t = (0 > r ? r - 146096 : r) / 146097 | 0, e = r - 146097 * t, u = (e - (e / 1460 | 0) + (e / 36524 | 0) - (e / 146096 | 0)) / 365 | 0, a = e - (365 * u + (u / 4 | 0) - (u / 100 | 0)), i = (5 * a + 2) / 153 | 0, c = i + (10 > i ? 3 : -9);
        return {
            pW: a - ((153 * i + 2) / 5 | 0) + 1,
            un: c,
            zq: u + 400 * t + (c > 2 ? 0 : 1)
        };
    }, Ab = F2(function(n, r) {
        return Cb(A2(_b, n, r)).pW;
    }), kb = F2(function(n, r) {
        return A2(Qc, 24, A2(wb, A2(_b, n, r), 60));
    }), Eb = F2(function(n, r) {
        return A2(Qc, 1e3, r);
    }), qb = F2(function(n, r) {
        return A2(Qc, 60, A2(_b, n, r));
    }), Fb = F2(function(n, r) {
        switch(Cb(A2(_b, n, r)).un){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), jb = F2(function(n, r) {
        return A2(Qc, 60, A2(wb, r, 1e3));
    }), Db = function(n) {
        return n.toUpperCase();
    }, Vb = F2(function(n, r) {
        switch(A2(Qc, 7, A2(wb, A2(_b, n, r), 1440))){
            case 0:
                return 3;
            case 1:
                return 4;
            case 2:
                return 5;
            case 3:
                return 6;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 2;
        }
    }), Bb = F2(function(n, r) {
        return Cb(A2(_b, n, r)).zq;
    }), Gb = F2(function(n, r) {
        return 12 > A2(kb, n, r) ? 0 : 1;
    }), zb = F4(function(n, r, t, e) {
        var u = A2(xc, " ", function(n) {
            return A2(bb, cu, n);
        }(mb(e.F3)));
        switch(u){
            case "Y":
                return A3(hb, 4, "0", A2(Bb, r, t));
            case "y":
                return A2(yb, 2, A3(hb, 2, "0", A2(Bb, r, t)));
            case "m":
                return A2(gb, "0", $b(A2(Fb, r, t)));
            case "_m":
                return A2(gb, " ", $b(A2(Fb, r, t)));
            case "-m":
                return oe($b(A2(Fb, r, t)));
            case "B":
                return n.aD.uo(A2(Fb, r, t));
            case "^B":
                return Db(n.aD.uo(A2(Fb, r, t)));
            case "b":
                return n.aD.up(A2(Fb, r, t));
            case "^b":
                return Db(n.aD.up(A2(Fb, r, t)));
            case "d":
                return A2(gb, "0", A2(Ab, r, t));
            case "-d":
                return oe(A2(Ab, r, t));
            case "-@d":
                return A2(n.aD.pY, !1, A2(Ab, r, t));
            case "e":
                return A2(gb, " ", A2(Ab, r, t));
            case "@e":
                return A2(n.aD.pY, !0, A2(Ab, r, t));
            case "A":
                return n.aD.pX(A2(Vb, r, t));
            case "^A":
                return Db(n.aD.pX(A2(Vb, r, t)));
            case "a":
                return n.aD.pZ(A2(Vb, r, t));
            case "^a":
                return Db(n.aD.pZ(A2(Vb, r, t)));
            case "H":
                return A2(gb, "0", A2(kb, r, t));
            case "-H":
                return oe(A2(kb, r, t));
            case "k":
                return A2(gb, " ", A2(kb, r, t));
            case "I":
                return A2(gb, "0", pb(A2(kb, r, t)));
            case "-I":
                return oe(pb(A2(kb, r, t)));
            case "l":
                return A2(gb, " ", pb(A2(kb, r, t)));
            case "p":
                return Db(n.aD.yQ(A2(Gb, r, t)));
            case "P":
                return n.aD.yQ(A2(Gb, r, t));
            case "M":
                return A2(gb, "0", A2(qb, r, t));
            case "S":
                return A2(gb, "0", A2(jb, r, t));
            case "L":
                return A3(hb, 3, "0", A2(Eb, r, t));
            case "%":
                return u;
            default:
                return "";
        }
    }), Sb = lt(dt), Tb = F4(function(n, r, t, e) {
        return A3(Sb, vb, A3(zb, n, t, e), r);
    }), Pb = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, Zb = function(n) {
        return !A2(Qc, 4, n) && !!A2(Qc, 100, n) || !A2(Qc, 400, n);
    }, Mb = F2(function(n, r) {
        switch(r){
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            default:
                return 31;
            case 1:
                return Zb(n) ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
        }
    }), Lb = function(n) {
        switch(A2(Ie, 1, n)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }, Nb = F3(function(n, r, t) {
        for(;;){
            var e = A2(Mb, n, r), u = Pb(r);
            if (u >= 12 || 0 >= s(t, e)) return {
                pW: t,
                un: r,
                zq: n
            };
            r = Lb(u + 1), t -= e;
        }
    }), Hb = F2(function(n, r) {
        return Ne(n / r);
    }), Ib = function(n) {
        var r = n - 1;
        return 365 * r + (A2(Hb, r, 4) - A2(Hb, r, 100) + A2(Hb, r, 400));
    }, Ob = F2(function(n, r) {
        return v(A2(Hb, n, r), A2(Qc, r, n));
    }), Qb = function(n) {
        var r = A2(Ob, n, 146097), t = r.a, e = A2(Ob, r.b, 36524), u = e.a, a = A2(Ob, e.b, 1461), i = a.a, c = A2(Ob, a.b, 365);
        return 400 * t + 100 * u + 4 * i + c.a + (c.b ? 1 : 0);
    }, Rb = function(n) {
        var r = n, t = Qb(r);
        return {
            lO: r - Ib(t),
            zq: t
        };
    }, Ub = function(n) {
        var r = Rb(n);
        return A3(Nb, r.zq, 0, r.lO);
    }, Kb = function(n) {
        var r = Ub(n);
        return 12 * (r.zq - 1) + (Pb(r.un) - 1) + r.pW / 100;
    }, Wb = F3(function(n, r, t) {
        var e = r, u = t;
        switch(n){
            case 0:
                return (Kb(u) - Kb(e) | 0) / 12 | 0;
            case 1:
                return Kb(u) - Kb(e) | 0;
            case 2:
                return (u - e) / 7 | 0;
            default:
                return u - e;
        }
    }), Xb = A2(tu, Ub, function(n) {
        return n.pW;
    }), Yb = A2(tu, Ub, function(n) {
        return n.un;
    }), Jb = A2(tu, Yb, Pb), nm = A2(tu, Rb, function(n) {
        return n.lO;
    }), rm = function(n) {
        return 0 > n ? -n : n;
    }, tm = F2(function(n, r) {
        return $(0 > r ? "-" : "", A3(ib, n, "0", oe(rm(r))));
    }), em = function(n) {
        return (Pb(n) + 2) / 3 | 0;
    }, um = A2(tu, Yb, em), am = function(n) {
        return A2(Qc, 7, n) || 7;
    }, im = function(n) {
        var r = Ib(n) + 4;
        return r - am(r);
    }, cm = function(n) {
        switch(A2(Ie, 1, n)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            default:
                return 6;
        }
    }, om = function(n) {
        var r = n, t = am(r), e = Qb(r + (4 - t));
        return {
            zj: 1 + ((r - (im(e) + 1)) / 7 | 0),
            zk: e,
            GE: cm(t)
        };
    }, fm = A2(tu, om, function(n) {
        return n.zj;
    }), sm = A2(tu, om, function(n) {
        return n.zk;
    }), lm = A2(tu, am, cm), dm = F2(function(n, r) {
        return 0 > s(n, r) ? n : r;
    }), vm = function(n) {
        return $(oe(n), function(n) {
            var r = A2(Qc, 100, n);
            switch(A2(dm, 20 > r ? r : A2(Qc, 10, r), 4)){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        }(n));
    }, bm = F4(function(n, r, t, e) {
        switch(r){
            case "y":
                return 2 === t ? A2(yb, 2, A3(ib, 2, "0", oe(Qb(e)))) : A2(tm, t, Qb(e));
            case "Y":
                return 2 === t ? A2(yb, 2, A3(ib, 2, "0", oe(sm(e)))) : A2(tm, t, sm(e));
            case "Q":
                switch(t){
                    case 1:
                    case 2:
                    case 5:
                        return oe(um(e));
                    case 3:
                        return "Q" + oe(um(e));
                    case 4:
                        return vm(um(e));
                    default:
                        return "";
                }
            case "M":
                switch(t){
                    case 1:
                        return oe(Jb(e));
                    case 2:
                        return A3(ib, 2, "0", oe(Jb(e)));
                    case 3:
                        return n.iB(Yb(e));
                    case 4:
                        return n.uo(Yb(e));
                    case 5:
                        return A2(pu, 1, n.iB(Yb(e)));
                    default:
                        return "";
                }
            case "w":
                switch(t){
                    case 1:
                        return oe(fm(e));
                    case 2:
                        return A3(ib, 2, "0", oe(fm(e)));
                    default:
                        return "";
                }
            case "d":
                switch(t){
                    case 1:
                        return oe(Xb(e));
                    case 2:
                        return A3(ib, 2, "0", oe(Xb(e)));
                    case 3:
                        return n.k$(Xb(e));
                    default:
                        return "";
                }
            case "D":
                switch(t){
                    case 1:
                        return oe(nm(e));
                    case 2:
                        return A3(ib, 2, "0", oe(nm(e)));
                    case 3:
                        return A3(ib, 3, "0", oe(nm(e)));
                    default:
                        return "";
                }
            case "E":
                switch(t){
                    case 1:
                    case 2:
                    case 3:
                        return n.dn(lm(e));
                    case 4:
                        return n.mC(lm(e));
                    case 5:
                        return A2(pu, 1, n.dn(lm(e)));
                    case 6:
                        return A2(pu, 2, n.dn(lm(e)));
                    default:
                        return "";
                }
            case "e":
                switch(t){
                    case 1:
                    case 2:
                        return oe(am(e));
                    default:
                        return A4(bm, n, "E", t, e);
                }
            default:
                return "";
        }
    }), mm = F3(function(n, r, t) {
        return A3(de, F2(function(r, e) {
            return $(r.$ ? r.a : A4(bm, n, r.a, r.b, t), e);
        }), "", r);
    }), pm = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $m = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), gm = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), hm = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2($m, e.a, e.b);
            var u = e.a, a = e.c, i = n(e.b)(a);
            if (1 === i.$) {
                var c = i.a;
                return A2($m, u || c, i.b);
            }
            return c = i.a, A3(gm, u || c, i.b, i.c);
        };
    }), ym = hm, wm = F2(function(n) {
        return n;
    }), xm = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2($m, t.a, t.b);
            var a = t.a, i = t.b, c = u(t.c);
            if (1 === c.$) {
                var o = c.a;
                return A2($m, a || o, c.b);
            }
            o = c.a;
            var f = c.c;
            return A3(gm, a || o, A2(n, i, c.b), f);
        };
    }), _m = F2(function(n, r) {
        return A3(xm, wm, n, r);
    }), Cm = _m, Am = function(n) {
        return function(r) {
            return A3(gm, !1, n, r);
        };
    }, km = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Em = function(n) {
        return A2(km, n, {
            $: 0,
            a: n
        });
    }, qm = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Fm = F4(function(n, r, t, e) {
        return {
            oL: r,
            AP: e,
            wg: t,
            xd: n
        };
    }), jm = {
        $: 0
    }, Dm = F2(function(n, r) {
        return A2(qm, jm, A4(Fm, n.xd, n.oL, r, n.f));
    }), Vm = vt, Bm = function(n) {
        return !n;
    }, Gm = function(n) {
        var r = n.a, t = n.b, e = !mu(r);
        return function(n) {
            var u = A5(Vm, r, n.iH, n.xd, n.oL, n.d), a = u.a, c = u.b, o = u.c;
            return i(a, -1) ? A2($m, !1, A2(Dm, n, t)) : A3(gm, e, 0, {
                oL: o,
                f: n.f,
                n: n.n,
                iH: a,
                xd: c,
                d: n.d
            });
        };
    }, zm = function(n) {
        return Gm(Em(n));
    }, Sm = A2(Cm, Am(pm("'")), zm("''")), Tm = {
        $: 11
    }, Pm = bt, Zm = F2(function(n, r) {
        return function(t) {
            var e = A3(Pm, n, t.iH, t.d);
            return i(e, -1) ? A2($m, !1, A2(Dm, t, r)) : i(e, -2) ? A3(gm, !0, 0, {
                oL: 1,
                f: t.f,
                n: t.n,
                iH: t.iH + 1,
                xd: t.xd + 1,
                d: t.d
            }) : A3(gm, !0, 0, {
                oL: t.oL + 1,
                f: t.f,
                n: t.n,
                iH: e,
                xd: t.xd,
                d: t.d
            });
        };
    }), Mm = function(n) {
        return A2(Zm, n, Tm);
    }, Lm = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Nm = F5(function(n, r, t, e, u) {
        for(;;){
            var a = A3(Pm, n, r, u.d);
            if (i(a, -1)) return A3(gm, 0 > s(u.iH, r), 0, {
                oL: e,
                f: u.f,
                n: u.n,
                iH: r,
                xd: t,
                d: u.d
            });
            i(a, -2) ? (r += 1, t += 1, e = 1) : (r = a, e += 1);
        }
    }), Hm = function(n) {
        return function(r) {
            return A5(Nm, n, r.iH, r.xd, r.oL, r);
        };
    }, Im = Hm, Om = function(n) {
        return A3(gm, !1, n.iH, n);
    }, Qm = F2(function(n, r) {
        return A3(xm, Ze, n, r);
    }), Rm = Qm, Um = function(n) {
        var r;
        return r = {
            $: 12,
            a: n
        }, function(n) {
            return A2($m, !1, A2(Dm, n, r));
        };
    }, Km = Z, Wm = function(n) {
        return A3(Km, Qt, g, n);
    }, Xm = function(n) {
        var r = Wm(n);
        if (r.b && !r.b.b) {
            var t = r.a;
            return A2(Rm, A2(Rm, Am(F2(function(n, r) {
                return A2(Lm, t, r - n + 1);
            })), A2(Cm, Om, Im(Le(t)))), Om);
        }
        return Um("expected exactly one char");
    }, Ym = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2($m, e.a, e.b);
            var u = e.b, a = e.c;
            return A3(gm, e.a, A2(n, A3(du, r.iH, a.iH, r.d), u), a);
        };
    }), Jm = function(n) {
        return A2(Ym, wm, n);
    }, np = A2(ym, Xm, Jm(Mm(xe))), rp = A2(de, F2(function(n, r) {
        var t = v(n, r);
        if (1 === t.a.$ && t.b.b && 1 === t.b.a.$) {
            var e = t.b, u = e.b;
            return A2(Qt, pm($(t.a.a, e.a.a)), u);
        }
        return A2(Qt, n, r);
    }), g), tp = function(n) {
        return "'" !== n && !xe(n);
    }, ep = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2($m, e.a, e.b);
            var u = e.c;
            return A3(gm, e.a, n(e.b), u);
        };
    }), up = ep, ap = A2(up, pm, Jm(A2(Cm, A2(Cm, Am(0), Mm(tp)), Im(tp)))), ip = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), cp = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, u = (0, t.a)(n);
                if (u.$) {
                    var a;
                    if ((a = u).a) return a;
                    r = A2(ip, r, a.b), t = e;
                    continue n;
                }
                return u;
            }
            return A2($m, !1, r);
        }
    }), op = function(n) {
        return function(r) {
            return A3(cp, r, jm, n);
        };
    }, fp = (Mu = {
        $: 10
    }, function(n) {
        return i(lu(n.d), n.iH) ? A3(gm, !1, 0, n) : A2($m, !1, A2(Dm, n, Mu));
    }), sp = function(n) {
        return op(w([
            A2(ym, function(r) {
                return sp($(n, r));
            }, Jm(A2(Cm, A2(Cm, Am(0), Mm(Kc("'"))), Im(Kc("'"))))),
            A2(ym, function() {
                return sp(n + "'");
            }, zm("''")),
            Am(n)
        ]));
    }, lp = A2(Rm, A2(Cm, Am(pm), Mm(Le("'"))), A2(Cm, sp(""), op(w([
        Mm(Le("'")),
        fp
    ])))), dp = function(n) {
        var r;
        return op(w([
            A2(ym, function(r) {
                return dp(A2(Qt, r, n));
            }, op(w([
                np,
                ap,
                Sm,
                lp
            ]))),
            (r = function() {
                return Am(rp(n));
            }, function(n) {
                return r(0)(n);
            })
        ]));
    }, vp = F3(function(n, r, t) {
        return {
            oL: r,
            wg: t,
            xd: n
        };
    }), bp = function(n) {
        return A3(vp, n.xd, n.oL, n.wg);
    }, mp = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(Qt, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(mp, e, r);
                continue n;
        }
    }), pp = F2(function(n, r) {
        var t = n({
            oL: 1,
            f: g,
            n: 1,
            iH: 0,
            xd: 1,
            d: r
        });
        return t.$ ? Yt(A2(mp, t.b, g)) : te(t.b);
    }), $p = F2(function(n, r) {
        var t = A2(pp, n, r);
        return t.$ ? Yt(A2(Fu, bp, t.a)) : te(t.a);
    }), gp = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), hp = F2(function(n, r) {
        var t, e = Ae(A2(gp, w([
            pm(t = r)
        ]), A2($p, dp(g), t)));
        return A2(mm, n, e);
    }), yp = function(n) {
        switch(n){
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            default:
                return "December";
        }
    }, wp = function(n) {
        switch(n){
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            case 5:
                return "Saturday";
            default:
                return "Sunday";
        }
    }, xp = {
        k$: vm,
        uo: yp,
        iB: A2(tu, yp, pu(3)),
        mC: wp,
        dn: A2(tu, wp, pu(3))
    }, _p = function(n) {
        return A2(hp, xp, n);
    }, Cp = F3(function(n, r, t) {
        return 0 > s(t, n) ? n : s(t, r) > 0 ? r : t;
    }), Ap = F2(function(n, r) {
        var t = Zb(n) ? 1 : 0;
        switch(r){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + t;
            case 3:
                return 90 + t;
            case 4:
                return 120 + t;
            case 5:
                return 151 + t;
            case 6:
                return 181 + t;
            case 7:
                return 212 + t;
            case 8:
                return 243 + t;
            case 9:
                return 273 + t;
            case 10:
                return 304 + t;
            default:
                return 334 + t;
        }
    }), kp = F3(function(n, r, t) {
        return Ib(n) + A2(Ap, n, r) + A3(Cp, 1, A2(Mb, n, r), t);
    }), Ep = F2(function(n, r) {
        return A3(kp, A2(Bb, n, r), A2(Fb, n, r), A2(Ab, n, r));
    }), qp = F3(function(n, r, t) {
        var e = A2(Ep, n, t), u = A2(Ep, n, r), a = A3(Wb, 0, e, u), i = A3(Wb, 3, e, u);
        return i ? 1 === i ? "Yesterday" : 2 > i || i > 6 ? A4(Tb, ob, 1 > a ? "%d/%m" : "%d/%m/%y", n, t) : A2(_p, "EEEE", e) : A4(Tb, ob, "%l:%M %p", n, t);
    }), Fp = F3(function(n, r, t) {
        var e = A2(Ep, n, t), u = A2(Ep, n, r), a = A3(Wb, 0, e, u), i = A3(Wb, 3, e, u);
        return i ? 1 === i ? "Yesterday" : 2 > i || i > 6 ? A4(Tb, ob, 1 > a ? "%d/%m" : "%d/%m/%y", n, t) : A2(_p, "EEEE", e) : "Today";
    }), jp = F3(function(n, r, t) {
        var e, u, a = n.GK, i = oe;
        return e = function() {
            switch(t.$){
                case 0:
                    return 1 === (n = t.a) ? "less than 1 second" : "less than " + i(n) + " seconds";
                case 1:
                    return "half a minute";
                case 2:
                    return 1 === (n = t.a) ? "less than a minute" : "less than " + i(n) + " minutes";
                case 3:
                    return 1 === (n = t.a) ? "1 minute" : i(n) + " minutes";
                case 4:
                    return 1 === (n = t.a) ? "about 1 hour" : "about " + i(n) + " hours";
                case 5:
                    return 1 === (n = t.a) ? "1 day" : i(n) + " days";
                case 6:
                    return 1 === (n = t.a) ? "about 1 month" : "about " + i(n) + " months";
                case 7:
                    return 1 === (n = t.a) ? "1 month" : i(n) + " months";
                case 8:
                    return 1 === (n = t.a) ? "about 1 year" : "about " + i(n) + " years";
                case 9:
                    return 1 === (n = t.a) ? "over 1 year" : "over " + i(n) + " years";
                default:
                    var n;
                    return 1 === (n = t.a) ? "almost 1 year" : "almost " + i(n) + " years";
            }
        }(), (u = v(a, r)).a ? u.b ? "in " + e : e + " ago" : e;
    }), Dp = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Vp = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Bp = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Gp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, zp = 43200, Sp = V, Tp = {
        $: 1
    }, Pp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Zp = F3(function(n, r, t) {
        var e = rm(t - r) / 1e3 | 0, u = Sp(e / 60);
        return n && 2 > u ? function(n) {
            return 5 > n ? Pp(5) : 10 > n ? Pp(10) : 20 > n ? Pp(20) : 40 > n ? Tp : 60 > n ? Vp(1) : Gp(1);
        }(e) : u ? 2 > u || 45 > u ? Gp(u) : 90 > u ? Dp(1) : 0 > s(u, 1440) ? function(n) {
            var r = Sp(n / 60);
            return Dp(r);
        }(u) : 0 > s(u, 2520) ? Bp(1) : 0 > s(u, zp) ? function(n) {
            var r = Sp(n / 1440);
            return Bp(r);
        }(u) : 0 > s(u, 86400) ? function(n) {
            return {
                $: 6,
                a: Sp(n / zp)
            };
        }(u) : function(n) {
            var r = n / zp | 0;
            if (12 > r) return function(n) {
                return {
                    $: 7,
                    a: Sp(n / zp)
                };
            }(n);
            var t = Ne(r / 12), e = A2(Qc, 12, r);
            var u;
            return 3 > e ? {
                $: 8,
                a: t
            } : 9 > e ? {
                $: 9,
                a: t
            } : (u = t + 1, {
                $: 10,
                a: u
            });
        }(u) : Vp(1);
    }), Mp = F4(function(n, r, t, e) {
        var u = t, a = e, i = A3(Zp, !0, u, a);
        return A3(r, n, 2 === A2(na, a, u) ? 0 : 1, i);
    }), Lp = F2(function(n, r) {
        return A4(Mp, {
            GK: !0
        }, jp, n, r);
    }), Np = F4(function(n, r, t, e) {
        var u = function() {
            switch(t){
                case 0:
                    return "%m/%d/%Y";
                case 1:
                    return "%B %-d, %Y";
                case 4:
                    return "%l:%M %p";
                case 5:
                    return "%l:%M:%S %p";
                case 6:
                    return A2(Lp, e, r);
                case 2:
                    return A3(qp, n, r, e);
                default:
                    return A3(Fp, n, r, e);
            }
        }();
        return A4(Tb, ob, u, n, e);
    }), Hp = F2(function(n, r) {
        return A2(Np, n, r);
    }), Ip = {
        cz: g,
        dR: 0
    }, Op = F2(function(n, r) {
        return r.$ ? Ot : It(n(r.a));
    }), Qp = Uu(g), Rp = {
        $: 1
    }, Up = Sn, Kp = A2(jc, function() {
        return Rp;
    }, Up(1e4)), Wp = In, Xp = cu, Yp = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Jp = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(Qt, e.a, t);
    }), n$ = F2(function(n, r) {
        return A3(qu, Jp(n), g, r);
    }), r$ = F3(function(n, r, t) {
        var e = t.b;
        return v(n(t.a), r(e));
    }), t$ = function(n) {
        var r = A2(tu, Yp(1), mb), t = function(n) {
            return A2(Op, function(t) {
                return v(t, A2(xc, "", r(n)));
            }, mb(n));
        }, e = A2(tu, Ju, xc(""));
        return ed(A2(Fu, A2(r$, e, e), A2(n$, t, A2(Fu, se("="), A2(se, "&", n)))));
    }, e$ = function(n) {
        return t$(A2(xc, "", n));
    }, u$ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, a$ = F2(function(n, r) {
        return r.$ ? Yt(r.a) : n(r.a);
    }), i$ = sn, c$ = {
        $: 2
    }, o$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, f$ = function(n) {
        return A2(fe, "", n);
    }, s$ = function(n) {
        switch(A2(Qc, 4, lu(n))){
            case 0:
                return te(n);
            case 2:
                return te(f$(w([
                    n,
                    "=="
                ])));
            case 3:
                return te(f$(w([
                    n,
                    "="
                ])));
            default:
                return Yt(o$("Wrong length"));
        }
    }, l$ = F2(function(n, r) {
        return r.$ ? Yt(n) : te(r.a);
    }), d$ = F2(function(n, r) {
        return r.$ ? Yt(r.a) : te(n(r.a));
    }), v$ = F3(function(n, r, t) {
        if (1 === r.$) return Yt(r.a);
        var e = r.a;
        return 1 === t.$ ? Yt(t.a) : te(A2(n, e, t.a));
    }), b$ = F2(function(n, r) {
        return r.$ ? Yt(n(r.a)) : te(r.a);
    }), m$ = function(n) {
        switch(n.$){
            case 0:
            case 3:
                return 1;
            case 1:
            case 4:
                return 2;
            case 2:
            case 5:
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
            case 9:
                return n.a;
            default:
                return yt(n.a);
        }
    }, p$ = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return A3(wt, r, t, n.a);
            case 1:
                return A4(xt, r, t, n.b, !n.a);
            case 2:
                return A4(_t, r, t, n.b, !n.a);
            case 3:
                return A3(Ct, r, t, n.a);
            case 4:
                return A4(At, r, t, n.b, !n.a);
            case 5:
                return A4(kt, r, t, n.b, !n.a);
            case 6:
                return A4(Et, r, t, n.b, !n.a);
            case 7:
                return A4(qt, r, t, n.b, !n.a);
            case 8:
                return A3($$, n.b, r, t);
            case 9:
                return A3(jt, r, t, n.b);
            default:
                return A3(Ft, r, t, n.a);
        }
    }), $$ = F3(function(n, r, t) {
        for(;;){
            if (!n.b) return t;
            var e = n.b, u = r, a = A3(p$, n.a, r, t);
            n = e, r = u, t = a;
        }
    }), g$ = F2(function(n, r) {
        return A2(Dt, n, r);
    }), h$ = function(n) {
        var r = new DataView(new ArrayBuffer(m$(n)));
        return p$(n)(r)(0), r;
    }, y$ = function(n) {
        if (Ce(n)) return !0;
        switch(n){
            case "+":
            case "/":
                return !0;
            default:
                return !1;
        }
    }, w$ = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), x$ = F2(function(n, r) {
        for(;;){
            if (!r.b) return n;
            var t = r.b;
            n += m$(r.a), r = t;
        }
    }), _$ = function(n) {
        return A2(w$, A2(x$, 0, n), n);
    }, C$ = function(n) {
        var r = he(n);
        if (r >= 65 && 90 >= r) return r - 65;
        if (r >= 97 && 122 >= r) return r - 97 + 26;
        if (r >= 48 && 57 >= r) return r - 48 + 26 + 26;
        switch(n){
            case "+":
                return 62;
            case "/":
                return 63;
            default:
                return -1;
        }
    }, A$ = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), k$ = A$, E$ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, q$ = F4(function(n, r, t, e) {
        if (y$(n) && y$(r)) {
            var u = C$(r), a = C$(n);
            if ("=" === e) {
                if ("=" === t) return It(E$((c = a << 18 | u << 12) >> 16));
                if (y$(t)) {
                    var i = C$(t);
                    return It(A2(k$, 1, (c = a << 18 | u << 12 | i << 6) >> 8));
                }
                return Ot;
            }
            if (y$(t) && y$(e)) {
                var c, o = C$(e), f = c = a << 18 | u << 12 | (i = C$(t)) << 6 | o;
                return It(_$(w([
                    A2(k$, 1, c >> 8),
                    E$(f)
                ])));
            }
            return Ot;
        }
        return Ot;
    }), F$ = F2(function(n, r) {
        n: for(;;){
            var t = Wm(A2(pu, 4, n));
            r: for(;;){
                if (t.b) {
                    if (t.b.b) {
                        if (t.b.b.b) {
                            if (t.b.b.b.b) {
                                if (t.b.b.b.b.b) break r;
                                var e = t.b, u = e.b, a = A4(q$, t.a, e.a, u.a, u.b.a);
                                if (a.$) return Ot;
                                var i = a.a;
                                n = A2(vu, 4, n), r = A2(Qt, i, r);
                                continue n;
                            }
                            var c = t.b, o = A4(q$, t.a, c.a, c.b.a, "=");
                            return 1 === o.$ ? Ot : It(A2(Qt, i = o.a, r));
                        }
                        var f = A4(q$, t.a, t.b.a, "=", "=");
                        return 1 === f.$ ? Ot : It(A2(Qt, i = f.a, r));
                    }
                    break r;
                }
                return It(r);
            }
            return Ot;
        }
    }), j$ = yt, D$ = function(n) {
        var r = A2(Op, h$, function(n) {
            return A2(Op, A2(tu, Ae, _$), A2(F$, n, g));
        }(n));
        if (1 === r.$) return Ot;
        var t, e = r.a;
        return A2(g$, (t = j$(e), zt(t)), e);
    }, V$ = T, B$ = V$(function(n) {
        switch(n){
            case "-":
                return "+";
            case "_":
                return "/";
            default:
                return n;
        }
    }), G$ = J, z$ = F2(function(n, r) {
        return A2(a$, A2(tu, i$(n), b$(u$)), A2(d$, Oc, function(n) {
            var r = F2(function(n, r) {
                return A2(b$, n, A2(d$, function() {
                    return r;
                }, A2(i$, G$, r)));
            }), t = A2(tu, B$, A2(tu, se("."), Fu(s$)))(n);
            n: for(;;){
                if (t.b && t.b.b && t.b.b.b && !t.b.b.b.b) {
                    if (t.a.$) {
                        if (1 === t.b.a.$) break n;
                        return Yt(t.a.a);
                    }
                    if (t.b.a.$) break n;
                    var e = t.a.a, u = t.b.a.a, a = A2(a$, r(function() {
                        return c$;
                    }), A2(l$, c$, D$(e))), i = A2(a$, r(u$), A2(l$, o$("Invalid UTF-16"), D$(u)));
                    return A3(v$, F2(function(n, r) {
                        return v(n, r);
                    }), a, i);
                }
                return Yt(o$("Token has invalid shape"));
            }
            return Yt(t.b.a.a);
        }(r)));
    }), S$ = ft, T$ = F2(function(n, r) {
        var t = lb(n);
        return 1 !== t.$ && A2(S$, t.a, r);
    }), P$ = function(n) {
        return A2(T$, "^[\\w-]*\\.[\\w-]*\\.[\\w-]*$", n);
    }, Z$ = function(n) {
        return A2(su, "full_access", n) ? 0 : 1;
    }, M$ = nn, L$ = function(n) {
        return n.$ ? Ot : It(n.a);
    }, N$ = function(n) {
        if (n.$) return 1;
        var r = n.a;
        return P$(r) ? A2(xc, 1, A2(Op, Z$, L$(A2(z$, A2(Iu, "scope", M$), r)))) : 1;
    }, H$ = function(n) {
        return !N$(n);
    }, I$ = Y, O$ = W, Q$ = function(n) {
        return {
            $: 11,
            g: n
        };
    }, R$ = function(n) {
        var r = Q$(w([
            O$,
            A2(eu, Sp, I$)
        ]));
        return A2(d$, function(n) {
            return 1e3 * n;
        }, A2(z$, A2(Iu, "exp", r), n));
    }, U$ = F2(function(n, r) {
        return A2(d$, function(r) {
            return s(n, r) > 0;
        }, R$(r));
    }), K$ = F2(function(n, r) {
        return !!n.$ || A2(xc, !0, L$(A2(U$, r, n.a)));
    }), W$ = function(n) {
        return It({
            $: 4,
            a: n
        });
    }, X$ = {
        $: 3
    }, Y$ = F2(function(n, r) {
        return 1 === n.$ ? r : n;
    }), J$ = function(n) {
        return A2(xc, X$, A2(bb, W$, A2(Y$, A2(ra, "account_token", n), A2(ra, "exchange_token", n))));
    }, ng = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rg = function(n) {
        return It(ng(n));
    }, tg = F4(function(n, r, t, e) {
        var u = A2(bb, rg, r);
        if (u.$) return J$(n);
        var a = u.a, i = e || !A2(K$, a, t);
        return H$(a) && i ? a : J$(n);
    }), eg = F2(function(n, r) {
        return m(r, {
            CK: n
        });
    }), ug = F2(function(n, r) {
        var t = function(n) {
            switch(A2(pu, 2, n)){
                case "es":
                    return It(1);
                case "en":
                    return It(0);
                default:
                    return Ot;
            }
        }(A2(xc, n.CK, A2(ra, "language", e$(r.jb)))), e = e$(r.jb), u = Xp(n.bp), a = A4(tg, e, n.j, u, n.De), i = function(n) {
            var r = n.E2, t = n.FQ;
            return v({
                pM: A2(xc, "", r),
                iF: !1
            }, t ? Qp : A2(xc, Qp, A2(Op, wm(Kp), r)));
        }({
            E2: n.E2,
            FQ: n.De
        }), c = i.a, o = i.b;
        return v({
            gk: Ac,
            zJ: n.zJ,
            zK: Ot,
            cz: Ip,
            g0: A4(Vc, n.z0 + "/api", n.bk, n.bV, a),
            Ab: !1,
            g9: kc,
            Z: g,
            os: !1,
            AF: {
                Ao: A4(Gc, n.Bt, n.Bu, n.bV, a),
                E: A4(zc, n.Bv, n.Bw, n.bV, a),
                ft: A4(Sc, n.Bx, n.By, n.bV, a),
                EU: A4(Tc, n.Bt, n.Bu, n.bV, a)
            },
            bY: !1,
            bp: u,
            hH: !1,
            e_: !1,
            hX: A4(zc, n.Bv, n.Bw, n.bV, a),
            ld: 0,
            Ca: n.Ca,
            CL: A2(eg, A2(xc, 0, t), rb("language-select")),
            $9: Ot,
            De: n.De,
            dQ: Wv,
            c1: !1,
            fu: Ac,
            vn: kc,
            vu: kc,
            EA: Ot,
            dV: kc,
            fF: kc,
            E2: c,
            f2: kc,
            FN: kc,
            eh: g,
            dg: Ot,
            kn: A2(Hp, wo, u),
            f9: wo,
            ek: Ot,
            yZ: r,
            Gy: t,
            au: kc
        }, Uu(w([
            A2(jc, Cc, wd),
            A2(Wp, Ec, o)
        ])));
    }), ag = function(n) {
        return {
            $: 87,
            a: n
        };
    }, ig = function(n) {
        return {
            $: 87,
            a: n
        };
    }, cg = function(n) {
        return {
            $: 86,
            a: n
        };
    }, og = function(n) {
        return {
            $: 86,
            a: n
        };
    }, fg = function(n) {
        return {
            $: 79,
            a: n
        };
    }, sg = function(n) {
        return {
            $: 79,
            a: n
        };
    }, lg = function(n) {
        return {
            $: 88,
            a: n
        };
    }, dg = function(n) {
        return {
            $: 88,
            a: n
        };
    }, vg = function(n) {
        return {
            $: 12,
            a: n
        };
    }, bg = function(n) {
        return {
            $: 12,
            a: n
        };
    }, mg = function(n) {
        return {
            $: 99,
            a: n
        };
    }, pg = function(n) {
        return {
            $: 99,
            a: n
        };
    }, $g = function(n) {
        return {
            $: 100,
            a: n
        };
    }, gg = function(n) {
        return {
            $: 100,
            a: n
        };
    }, hg = function(n) {
        return {
            $: 13,
            a: n
        };
    }, yg = function(n) {
        return {
            $: 13,
            a: n
        };
    }, wg = function(n) {
        return {
            $: 66,
            a: n
        };
    }, xg = function(n) {
        return {
            $: 66,
            a: n
        };
    }, _g = function(n) {
        return {
            $: 67,
            a: n
        };
    }, Cg = function(n) {
        return {
            $: 67,
            a: n
        };
    }, Ag = function(n) {
        return {
            $: 14,
            a: n
        };
    }, kg = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Eg = function(n) {
        return {
            $: 15,
            a: n
        };
    }, qg = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Fg = function(n) {
        return {
            $: 16,
            a: n
        };
    }, jg = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Dg = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Vg = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Bg = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Gg = function(n) {
        return {
            $: 18,
            a: n
        };
    }, zg = function(n) {
        return {
            $: 80,
            a: n
        };
    }, Sg = function(n) {
        return {
            $: 80,
            a: n
        };
    }, Tg = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Pg = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Zg = function(n) {
        return {
            $: 81,
            a: n
        };
    }, Mg = function(n) {
        return {
            $: 81,
            a: n
        };
    }, Lg = function(n) {
        return {
            $: 89,
            a: n
        };
    }, Ng = function(n) {
        return {
            $: 89,
            a: n
        };
    }, Hg = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Ig = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Og = function(n) {
        return {
            $: 90,
            a: n
        };
    }, Qg = function(n) {
        return {
            $: 90,
            a: n
        };
    }, Rg = function(n) {
        return {
            $: 91,
            a: n
        };
    }, Ug = function(n) {
        return {
            $: 91,
            a: n
        };
    }, Kg = function(n) {
        return {
            $: 82,
            a: n
        };
    }, Wg = function(n) {
        return {
            $: 82,
            a: n
        };
    }, Xg = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Yg = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Jg = function(n) {
        return {
            $: 92,
            a: n
        };
    }, nh = function(n) {
        return {
            $: 92,
            a: n
        };
    }, rh = function(n) {
        return {
            $: 83,
            a: n
        };
    }, th = function(n) {
        return {
            $: 83,
            a: n
        };
    }, eh = function(n) {
        return {
            $: 93,
            a: n
        };
    }, uh = function(n) {
        return {
            $: 93,
            a: n
        };
    }, ah = function(n) {
        return {
            $: 22,
            a: n
        };
    }, ih = function(n) {
        return {
            $: 22,
            a: n
        };
    }, ch = function(n) {
        return {
            $: 68,
            a: n
        };
    }, oh = function(n) {
        return {
            $: 68,
            a: n
        };
    }, fh = function(n) {
        return {
            $: 23,
            a: n
        };
    }, sh = function(n) {
        return {
            $: 23,
            a: n
        };
    }, lh = function(n) {
        return {
            $: 24,
            a: n
        };
    }, dh = function(n) {
        return {
            $: 24,
            a: n
        };
    }, vh = function(n) {
        return {
            $: 94,
            a: n
        };
    }, bh = function(n) {
        return {
            $: 94,
            a: n
        };
    }, mh = function(n) {
        return {
            $: 84,
            a: n
        };
    }, ph = function(n) {
        return {
            $: 84,
            a: n
        };
    }, $h = function(n) {
        return {
            $: 95,
            a: n
        };
    }, gh = function(n) {
        return {
            $: 95,
            a: n
        };
    }, hh = function(n) {
        return {
            $: 85,
            a: n
        };
    }, yh = function(n) {
        return {
            $: 85,
            a: n
        };
    }, wh = function(n) {
        return {
            $: 25,
            a: n
        };
    }, xh = function(n) {
        return {
            $: 25,
            a: n
        };
    }, _h = function(n) {
        return {
            $: 96,
            a: n
        };
    }, Ch = function(n) {
        return {
            $: 96,
            a: n
        };
    }, Ah = function(n) {
        return {
            $: 26,
            a: n
        };
    }, kh = function(n) {
        return {
            $: 26,
            a: n
        };
    }, Eh = function(n) {
        return {
            $: 27,
            a: n
        };
    }, qh = function(n) {
        return {
            $: 27,
            a: n
        };
    }, Fh = function(n) {
        return {
            $: 62,
            a: n
        };
    }, jh = function(n) {
        return {
            $: 62,
            a: n
        };
    }, Dh = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Vh = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Bh = function(n) {
        return {
            $: 69,
            a: n
        };
    }, Gh = function(n) {
        return {
            $: 69,
            a: n
        };
    }, zh = function(n) {
        return {
            $: 63,
            a: n
        };
    }, Sh = function(n) {
        return {
            $: 63,
            a: n
        };
    }, Th = function(n) {
        return {
            $: 97,
            a: n
        };
    }, Ph = function(n) {
        return {
            $: 97,
            a: n
        };
    }, Zh = function(n) {
        return {
            $: 98,
            a: n
        };
    }, Mh = function(n) {
        return {
            $: 98,
            a: n
        };
    }, Lh = function(n) {
        return {
            $: 28,
            a: n
        };
    }, Nh = function(n) {
        return {
            $: 28,
            a: n
        };
    }, Hh = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ih = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Oh = function(n) {
        return {
            $: 64,
            a: n
        };
    }, Qh = function(n) {
        return {
            $: 64,
            a: n
        };
    }, Rh = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Uh = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Kh = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wh = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xh = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Yh = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Jh = function(n) {
        return {
            $: 29,
            a: n
        };
    }, ny = function(n) {
        return {
            $: 29,
            a: n
        };
    }, ry = function(n) {
        return {
            $: 30,
            a: n
        };
    }, ty = function(n) {
        return {
            $: 30,
            a: n
        };
    }, ey = function(n) {
        return {
            $: 31,
            a: n
        };
    }, uy = function(n) {
        return {
            $: 31,
            a: n
        };
    }, ay = function(n) {
        return {
            $: 2,
            a: n
        };
    }, iy = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cy = function(n) {
        return {
            $: 3,
            a: n
        };
    }, oy = function(n) {
        return {
            $: 3,
            a: n
        };
    }, fy = function(n) {
        return {
            $: 70,
            a: n
        };
    }, sy = function(n) {
        return {
            $: 70,
            a: n
        };
    }, ly = function(n) {
        return {
            $: 71,
            a: n
        };
    }, dy = function(n) {
        return {
            $: 71,
            a: n
        };
    }, vy = function(n) {
        return {
            $: 72,
            a: n
        };
    }, by = function(n) {
        return {
            $: 72,
            a: n
        };
    }, my = function(n) {
        return {
            $: 73,
            a: n
        };
    }, py = function(n) {
        return {
            $: 73,
            a: n
        };
    }, $y = function(n) {
        return {
            $: 74,
            a: n
        };
    }, gy = function(n) {
        return {
            $: 74,
            a: n
        };
    }, hy = function(n) {
        return {
            $: 75,
            a: n
        };
    }, yy = function(n) {
        return {
            $: 75,
            a: n
        };
    }, wy = function(n) {
        return {
            $: 76,
            a: n
        };
    }, xy = function(n) {
        return {
            $: 76,
            a: n
        };
    }, _y = function(n) {
        return {
            $: 77,
            a: n
        };
    }, Cy = function(n) {
        return {
            $: 77,
            a: n
        };
    }, Ay = function(n) {
        return {
            $: 78,
            a: n
        };
    }, ky = function(n) {
        return {
            $: 78,
            a: n
        };
    }, Ey = function(n) {
        return {
            $: 65,
            a: n
        };
    }, qy = function(n) {
        return {
            $: 65,
            a: n
        };
    }, Fy = function(n) {
        return {
            $: 10,
            a: n
        };
    }, jy = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Dy = function(n) {
        return {
            $: 32,
            a: n
        };
    }, Vy = function(n) {
        return {
            $: 32,
            a: n
        };
    }, By = function(n) {
        return {
            $: 33,
            a: n
        };
    }, Gy = function(n) {
        return {
            $: 33,
            a: n
        };
    }, zy = function(n) {
        return {
            $: 34,
            a: n
        };
    }, Sy = function(n) {
        return {
            $: 34,
            a: n
        };
    }, Ty = function(n) {
        return {
            $: 35,
            a: n
        };
    }, Py = function(n) {
        return {
            $: 35,
            a: n
        };
    }, Zy = function(n) {
        return {
            $: 36,
            a: n
        };
    }, My = function(n) {
        return {
            $: 36,
            a: n
        };
    }, Ly = function(n) {
        return {
            $: 37,
            a: n
        };
    }, Ny = function(n) {
        return {
            $: 37,
            a: n
        };
    }, Hy = function(n) {
        return {
            $: 39,
            a: n
        };
    }, Iy = function(n) {
        return {
            $: 39,
            a: n
        };
    }, Oy = function(n) {
        return {
            $: 38,
            a: n
        };
    }, Qy = function(n) {
        return {
            $: 38,
            a: n
        };
    }, Ry = function(n) {
        return {
            $: 40,
            a: n
        };
    }, Uy = function(n) {
        return {
            $: 40,
            a: n
        };
    }, Ky = function(n) {
        return {
            $: 41,
            a: n
        };
    }, Wy = function(n) {
        return {
            $: 41,
            a: n
        };
    }, Xy = function(n) {
        return {
            $: 42,
            a: n
        };
    }, Yy = function(n) {
        return {
            $: 42,
            a: n
        };
    }, Jy = function(n) {
        return {
            $: 43,
            a: n
        };
    }, nw = function(n) {
        return {
            $: 43,
            a: n
        };
    }, rw = function(n) {
        return {
            $: 44,
            a: n
        };
    }, tw = function(n) {
        return {
            $: 44,
            a: n
        };
    }, ew = function(n) {
        return {
            $: 45,
            a: n
        };
    }, uw = function(n) {
        return {
            $: 45,
            a: n
        };
    }, aw = function(n) {
        return {
            $: 46,
            a: n
        };
    }, iw = function(n) {
        return {
            $: 46,
            a: n
        };
    }, cw = function(n) {
        return {
            $: 47,
            a: n
        };
    }, ow = function(n) {
        return {
            $: 47,
            a: n
        };
    }, fw = function(n) {
        return {
            $: 48,
            a: n
        };
    }, sw = function(n) {
        return {
            $: 48,
            a: n
        };
    }, lw = function(n) {
        return {
            $: 49,
            a: n
        };
    }, dw = function(n) {
        return {
            $: 49,
            a: n
        };
    }, vw = function(n) {
        return {
            $: 50,
            a: n
        };
    }, bw = function(n) {
        return {
            $: 50,
            a: n
        };
    }, mw = function(n) {
        return {
            $: 51,
            a: n
        };
    }, pw = function(n) {
        return {
            $: 51,
            a: n
        };
    }, $w = function(n) {
        return {
            $: 52,
            a: n
        };
    }, gw = function(n) {
        return {
            $: 52,
            a: n
        };
    }, hw = function(n) {
        return {
            $: 53,
            a: n
        };
    }, yw = function(n) {
        return {
            $: 53,
            a: n
        };
    }, ww = function(n) {
        return {
            $: 54,
            a: n
        };
    }, xw = function(n) {
        return {
            $: 54,
            a: n
        };
    }, _w = function(n) {
        return {
            $: 55,
            a: n
        };
    }, Cw = function(n) {
        return {
            $: 55,
            a: n
        };
    }, Aw = function(n) {
        return {
            $: 56,
            a: n
        };
    }, kw = function(n) {
        return {
            $: 56,
            a: n
        };
    }, Ew = function(n) {
        return {
            $: 57,
            a: n
        };
    }, qw = function(n) {
        return {
            $: 57,
            a: n
        };
    }, Fw = function(n) {
        return {
            $: 58,
            a: n
        };
    }, jw = function(n) {
        return {
            $: 58,
            a: n
        };
    }, Dw = function(n) {
        return {
            $: 59,
            a: n
        };
    }, Vw = function(n) {
        return {
            $: 59,
            a: n
        };
    }, Bw = function(n) {
        return {
            $: 60,
            a: n
        };
    }, Gw = function(n) {
        return {
            $: 60,
            a: n
        };
    }, zw = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Sw = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Tw = function(n) {
        return {
            $: 61,
            a: n
        };
    }, Pw = function(n) {
        return {
            $: 61,
            a: n
        };
    }, Zw = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Mw = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Lw = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nw = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hw = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Iw = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Ow = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Qw = {
        $: 2
    }, Rw = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Uw = function(n) {
        return 4 === n.$;
    }, Kw = function(n) {
        return Uw(n.a.j);
    }, Ww = F2(function(n, r) {
        return b(r.a, r.b, n);
    }), Xw = function(n) {
        return n.b.qN;
    }, Yw = yn, Jw = F3(function(n, r, t) {
        return t.$ ? n : r(t.a);
    }), nx = null, rx = function(n) {
        return A3(de, F2(function(n, r) {
            return A3(wn, n.a, n.b, r);
        }), {}, n);
    }, tx = yn, ex = Xn("fullStoryPortInit", function(n) {
        return rx(w([
            v("email", function(n) {
                return A3(Jw, nx, tx, n);
            }(n.qN)),
            v("id", tx(n.sl)),
            v("name", tx(n.ur)),
            v("sandbox", Yw(n.xe))
        ]));
    }), ux = function(n) {
        return function(n) {
            return n.sl;
        }(n.a);
    }, ax = function(n) {
        return function(n) {
            return n.ur;
        }(n.a);
    }, ix = function(n) {
        return function(n) {
            return n.xe;
        }(n.a);
    }, cx = function(n) {
        return ex({
            qN: Xw(n),
            sl: ux(n),
            ur: ax(n),
            xe: ix(n)
        });
    }, ox = Xn("meticulousRecordContext", cu), fx = function(n) {
        return ox(rx(w([
            v("practiceId", tx(ux(n)))
        ])));
    }, sx = function(n) {
        return Uu(w([
            cx(n),
            fx(n)
        ]));
    }, lx = F2(function(n, r) {
        var t = r.b;
        return v(n(r.a), t);
    }), dx = F2(function(n, r) {
        var t = r.b, e = r.c;
        return b(n(r.a), t, e);
    }), vx = Hn, bx = vx(g), mx = cu, px = "Date", $x = "doctor", gx = "Select", hx = "Location", yx = "Your membership has been renewed", wx = "Provider", xx = "Start date", _x = mx({
        mO: F2(function(n, r) {
            return "Using a credit card will cost " + n + " an additional " + r + " in processing fees for your membership. Please consider using a bank account instead.";
        }),
        mP: function(n) {
            return "Using a credit card will cost " + n + " additional processing fees. Please consider using a bank account instead.";
        },
        m1: function(n) {
            return "Added " + n;
        },
        m6: "Additional Details",
        m7: "Additional details for primary member",
        kD: {
            qN: "Email me details",
            hP: "Enroll now"
        },
        m9: {
            nM: "Billing Address",
            nV: "Billing address is the same",
            oE: "City",
            AS: "Country",
            s4: "Address Line 1",
            CO: "Street address, P. O. box, company name, c/o",
            s5: "Address Line 2",
            CP: "Apartment, suite, unit, building, floor, etc.",
            tp: "Mailing Address",
            tq: "Mailing address is the same",
            ur: "Address",
            Ff: "Use primary member's address",
            x6: "State (abbv.)",
            FY: "Please use a 2 letter abbreviation.",
            FZ: "[See USPS Abreviations] (https://pe.usps.com/text/pub28/28apb.htm)",
            zF: "ZIP code",
            zG: "We do not have coverage in your area",
            GP: "Please enter a valid US zip code."
        },
        nh: F2(function(n, r) {
            return "Minimum age for range for this plan is from " + n + " to " + r + " years old.";
        }),
        kJ: "Amount",
        z_: F2(function(n, r) {
            return n + " and " + r;
        }),
        z3: {
            n0: "Book",
            n1: "Book a new appointment",
            Aj: "Book an appointment",
            hf: "Cancel appointment",
            n7: "This will notify your practice and free up the time slot. This cannot be undone.",
            n8: "Cancel appointment",
            n9: "Cancel this appointment?",
            od: "Your appointment has been cancelled",
            oG: "Close",
            qa: "Appointment details",
            qb: "This appointment can't be viewed or managed online. Please contact your practice.",
            cb: "There was an error loading your appointments",
            vm: "Past",
            x7: "Cancelled",
            x8: "Completed",
            x9: "Confirmed",
            ya: "Declined",
            yb: "Unconfirmed",
            yx: "Appointments",
            yV: "Upcoming",
            zB: "You have no past appointments",
            zC: "You have no upcoming appointments"
        },
        ny: "At least one dependent must be added to the plan.",
        nz: "At least one member must be added to the plan.",
        nD: function(n) {
            return "authored by " + n;
        },
        nI: "Bank Account",
        Ag: {
            kK: "Annually",
            lC: "Monthly",
            l6: "Quarterly",
            mk: "Semi-Annually"
        },
        he: {
            n6: "Broker",
            sT: "Who is your broker?",
            EC: "Select"
        },
        hf: "Cancel",
        O: {
            nK: "before appointment",
            O: "Cancel Appointment",
            oa: "Cancellation Contact",
            oc: "Cancellation Policy",
            pb: "Contact us at",
            sh: "hours",
            sm: 'If you wish to reschedule your appointment, simply click the "Reschedule" button to book a new time.',
            um: "Minimum Cancellation Notice",
            w5: "Reschedule",
            w6: "Reschedule Appointment",
            yz: "to cancel your appointment.",
            yA: "To cancel your appointment, contact us at",
            zv: "Your appointment has been cancelled"
        },
        bl: {
            An: "End Membership",
            Ap: "Cancellation Reason",
            C9: "Ending Membership for:",
            E4: "Remove Member",
            E5: "Member has been removed from the membership",
            Fa: "Please enter a cancellation reason.",
            Fi: "We're sorry to see you go!",
            F5: "Membership has been cancelled"
        },
        hg: "Card",
        ol: function(n) {
            return "Some items could not be checked out: " + n + ". They are still in your cart - please try again.";
        },
        cF: {
            o4: "Confirm & Pay",
            qI: "Edit Cart",
            dS: "No payment methods on file",
            cg: "Payment Method",
            yx: "Confirm & Pay",
            zw: "Your Cart"
        },
        hi: {
            g8: "You'll receive a confirmation email shortly with all the details.",
            qs: "Done",
            yx: "All set!"
        },
        aO: {
            Bq: "(Due Today)",
            Bs: "Edit",
            qU: "Your cart is empty",
            CH: "Item actions",
            tK: "Membership Fee",
            Ed: "One-Time",
            Ef: "One-Time Registration Fee",
            EZ: "Recurring",
            E3: "Remove from Cart",
            Gu: "\u2014"
        },
        om: function(n) {
            return "Recurring (starting " + n + ")";
        },
        cG: {
            ph: "Continue to Payment",
            qT: "Add a membership or package to get started with your purchase.",
            qW: "Your cart is empty",
            dB: "Explore Services",
            yx: "Your Cart",
            yX: "Couldn\u2019t update the cart item. Please try again."
        },
        aw: {
            A0: "MMMM d, y",
            Bl: "Due Annually",
            Bm: "Due Quarterly",
            Bn: "Due Monthly",
            Bo: "Due Semi-Annually",
            Bp: "Due Today",
            Dj: "Next Bill Date: { $date }",
            i9: "Pricing Breakdown",
            E1: "Registration Fees",
            FV: "Starting { $date }",
            ms: "Starting Today"
        },
        kR: {
            FH: "Show less",
            FJ: "Show more"
        },
        AA: {
            yx: "Checkout"
        },
        oy: function(n) {
            return "This plan does not allow children over the age of " + n + " to enroll.";
        },
        cH: {
            rA: "Chosen First Name",
            Cv: "Chosen name is different?",
            sV: "Chosen Last Name",
            ue: "Chosen Middle Name",
            ym: "Chosen Suffix",
            yx: "Chosen Title"
        },
        oH: "Close menu",
        oK: {
            sv: "Code format is invalid."
        },
        o3: "Confirm",
        AK: {
            mW: "Add Later",
            oo: "Change Your Payment Method",
            pC: "Credit or Debit card",
            pD: "Credit/debit card or bank",
            xs: "Setup options"
        },
        o7: "Please contact the practice if you have any questions",
        o8: function(n) {
            return "Please contact the practice at " + n + " if you have any questions.";
        },
        o9: function(n) {
            return "Please contact the practice at " + n + " if you have any questions.";
        },
        pa: F2(function(n, r) {
            return "Please contact the practice at " + n + " or " + r + " if you have any questions.";
        }),
        pe: "Continue to next step",
        pf: function(n) {
            return "Continue to " + n + " page";
        },
        pg: "Continue",
        po: function(n) {
            return "Contract renews On #" + n;
        },
        pq: function(n) {
            return "Contract Terminates On " + n;
        },
        kZ: {
            z3: "Appointments",
            zn: "Welcome back,"
        },
        pR: {
            uC: "No data"
        },
        pS: px,
        bq: px + " of Birth",
        p9: function(n) {
            return "Ending this membership will stop recurring charges for the selected patient(s), and remove access to membership benefits effective " + n + ".";
        },
        hK: {
            r$: "Have a discount code?",
            Cr: "This is not a valid discount code.",
            sT: "Discount code"
        },
        eT: {
            z$: "Any distance",
            sT: "Distance",
            Dl: "No Filter",
            EC: "Filter by distance"
        },
        qk: "Date of birth cannot be in the future.",
        ql: $x,
        qm: gx + " " + $x,
        qo: function(n) {
            return n + " accepted!";
        },
        T: {
            zI: "Accept",
            A6: "No Thanks",
            k2: "Type your first name and last name",
            A9: "Member e-signature",
            Cs: "Please type either name exactly as it appears above.",
            Ct: "Please type your name exactly as it appears above.",
            C6: "Member Name",
            lu: "Name",
            Di: "New Member name",
            EP: "Primary Member Name",
            EQ: "Type the first and last name of either member",
            ER: "New or Primary Member e-signature",
            Fd: "Please sign this document.",
            xK: "E-signature",
            yU: "Signature does not match signee name."
        },
        qq: {
            Bk: "Due",
            Eo: "Paid",
            GC: "Void"
        },
        aa: {
            yx: "Agreements"
        },
        qu: "Download",
        bu: {
            zU: "All Time",
            AX: "Current Year",
            AZ: "Custom",
            qZ: "End Date",
            Cj: "In Progress",
            Ck: "Your file is being processed and may take a few seconds.",
            CM: "Last Year",
            x0: "Start Date"
        },
        qw: "DPC Practice",
        cN: {
            sT: "DPC Practice",
            CR: "Loading DPC practices...",
            Ei: "DPC Practice's name",
            Ej: "Your DPC Practice's name",
            EC: "Start typing to find your DPC Practice",
            GO: "No DPC practices found"
        },
        qz: function(n) {
            return "Due on " + n;
        },
        qE: "Membership patients can't be duplicated in the same membership.",
        Bs: "Edit",
        qN: "Email",
        aQ: {
            qN: "Email",
            rA: "First Name",
            sV: "Last Name",
            ur: "Full Name",
            vO: "Phone",
            wQ: "Relationship",
            Fb: "Please enter phone or email.",
            Fc: "Please enter at least first name, last name or relationship.",
            FP: "Use primary member as emergency contact",
            yx: "Emergency Contact"
        },
        a5: {
            AB: "Child",
            BZ: "Grandparent",
            B0: "Guardian",
            Dl: "None",
            Ei: "Other",
            Eq: "Parent",
            fW: "Select a relationship",
            FM: "Sibling",
            FU: "Spouse"
        },
        q2: "English",
        eY: {
            nU: "Billing Frequency",
            EO: "Primary",
            yx: "Enrolled Members",
            GO: "No patients to show"
        },
        q6: function(n) {
            return "ended on " + n;
        },
        q7: function(n) {
            return "ending on " + n;
        },
        q8: function(n) {
            return "Enrolled on " + n;
        },
        q9: {
            qi: "Do not enroll me",
            q4: "Enroll me",
            ur: "Enrollment Status",
            Ds: "Paying for someone else and don\u2019t want to be enrolled as a patient? Select \u201CDo not enroll me\u201D."
        },
        re: F2(function(n, r) {
            return n + ": " + r;
        }),
        rf: F3(function(n, r, t) {
            return n + " " + r + ": " + t;
        }),
        rm: F2(function(n, r) {
            return "Expires " + n + "/" + r;
        }),
        dB: {
            yx: "Explore Services"
        },
        o: {
            zM: "+ Add Another Member",
            m$: "Add to Cart",
            m2: "has been added to your cart!",
            ni: "All",
            Ae: "Billing",
            Aw: "Change Member",
            AI: "Configure Membership Details",
            AJ: "Configure Package Details",
            AN: "Contact practice for pricing",
            qK: "Edit Item in Cart",
            hP: "Enroll",
            dB: "Explore Services",
            C4: "Member",
            C7: "Yourself",
            Db: "Membership Start Date",
            ad: "Memberships",
            iQ: "Packages",
            wo: "Provider",
            EW: "Purchase",
            E4: "Remove",
            yW: "Update Cart",
            ze: "View Cart",
            GO: "No additional services are available right now"
        },
        rE: "for",
        e0: {
            oF: "click here",
            sa: "You do not have authorization to view this page. Please use the link in your email, or",
            sb: "to go to your patient portal homepage.",
            yx: "Authorization Required"
        },
        dE: {
            A2: "Date Sent",
            pU: "Date Submitted",
            Dn: "# of Questions",
            Fw: "Sent to",
            mt: "Status"
        },
        rG: {
            so: "Please complete the form questions."
        },
        rU: {
            BP: "Female",
            sT: "Gender",
            CY: "Male",
            Ei: "Other"
        },
        rV: {
            sT: "Gender Identity",
            CZ: "Man",
            Dk: "Non-binary",
            Dm: "Not Listed",
            EC: "Select",
            Gq: "Trans Man",
            Gr: "Trans Woman",
            GL: "Woman"
        },
        h4: {
            qV: "No data has been shared by the practice.",
            rd: "There was an error loading your health information",
            yx: "Health"
        },
        r6: "Healthcare Insurance",
        aE: {
            oi: "Insurance carrier",
            Ar: "Start typing to find your carrier",
            ok: "Carrier's name",
            As: "Pick an item",
            ab: "Existing coverage",
            BD: "Do you have either insurance or an insurance alternative?",
            rZ: "Group ID",
            sf: "High deductible",
            B9: "Are you on a high-deductible plan?",
            tD: "Member ID",
            Fm: "Search to filter..."
        },
        su: function(n) {
            return "Please enter a valid " + n + ".";
        },
        sx: function(n) {
            return "A valid " + n + " phone is required.";
        },
        sA: function(n) {
            return "Invoice " + n;
        },
        sB: function(n) {
            return "Due Date: " + n;
        },
        e6: {
            vz: "Payment",
            xS: "Payment Source",
            kg: "Pay Invoice",
            yx: "Pay Invoice"
        },
        h: {
            zP: "additional fees",
            np: "Amount Due",
            ou: "Charges",
            py: "Credit",
            AU: "Credit Card Fee",
            pz: "To avoid transaction fees, consider using a bank account (ACH) or debit.",
            AV: "Using a credit card will incur transaction fees.",
            pA: "Credit Card Fees",
            pB: "Credit Card Fees Paid",
            Bk: "Due",
            qA: "due to the",
            qB: "due to your membership",
            qC: "due to your package",
            sE: "Invoice Total",
            cb: "There was an error loading your invoices",
            uM: "Invoice Number",
            Eo: "Paid",
            vw: "Pay Invoice",
            vH: "Payment Total",
            vI: "Payments",
            vY: "+ tax",
            yj: "Subtotal",
            F6: "Tax",
            yx: "Invoices",
            Gm: "Total",
            yL: "Total Due",
            yO: "Transferred to Credit",
            zu: "You saved",
            GO: "No invoices to show"
        },
        ao: "Item",
        ip: {
            sT: "How did you hear about us?",
            s_: "Lead source",
            EC: "Select"
        },
        s0: "Learn more",
        lp: hx,
        cc: {
            z$: "Any location",
            p8: "Select location where you'd like to meet your provider.",
            Cr: "Location is invalid, please select a different option.",
            sT: "Location",
            EC: "Filter by location",
            wZ: "Location is required.",
            fW: "Select"
        },
        tc: function(n) {
            return "+ " + n + " other";
        },
        iu: {
            ht: "code",
            rF: "Sign into your patient portal",
            to: "magic-link"
        },
        td: function(n) {
            return "We don't like passwords any more than you do. Enter your email and we will send you a " + n + " to log in instantly.";
        },
        te: function(n) {
            return "We don't like passwords any more than you do. Enter your phone number and we will send you a " + n + " to log in instantly.";
        },
        tf: "Email me",
        tg: "Enter your email to get a login code",
        th: "Enter your phone number to get a login code",
        ti: "Your mobile number",
        tj: "Text me",
        tk: function(n) {
            return "Send " + n;
        },
        tu: function(n) {
            return "Maximum age for this plan is " + n + " years old.";
        },
        tB: function(n) {
            return "Age " + n;
        },
        tC: "Dependent",
        tF: "Primary",
        tG: function(n) {
            return "Provider: " + n;
        },
        fm: {
            mS: "Add members",
            mT: "Add another member",
            mU: "Demographics",
            mV: "Add Emergency Contact",
            mX: "Add Member",
            mY: "+ Add New Member",
            mZ: "Member created successfully!",
            m5: "Are you adding members?",
            Bb: "Please contact the practice to change these patient details.",
            qJ: "Edit Emergency Contact",
            qS: "Emergency Contact",
            r2: "Health Insurance",
            r3: "Insurance",
            r4: "Group ID",
            r5: "Member ID",
            sp: "Member Information",
            sq: "Edit Member Information",
            cb: "There was an error loading members",
            ts: "Manage Member",
            C_: "Manage Members",
            uF: "No dependents are allowed on this membership",
            yx: "Members",
            GO: "No members to show"
        },
        tH: function(n) {
            return "This membership allows " + n + " dependents";
        },
        tJ: function(n) {
            return "Your membership is ending on " + n;
        },
        fo: {
            hI: "Default",
            sT: "Payment Method",
            kt: "Payment method updated successfully",
            yY: "Any upcoming payments for this membership will be charged to the new payment method."
        },
        tM: yx,
        tN: function(n) {
            return yx + " till " + n;
        },
        Db: {
            sT: "Membership start date"
        },
        ad: {
            pm: "Contract Period",
            pI: "Current Memberships",
            pN: "Current",
            q$: "Ended Memberships",
            q0: "Ended",
            i_: "Pending Memberships",
            wV: "Renew Membership",
            xy: "View Membership Details",
            yx: "Memberships",
            Gi: "Memberships & Packages",
            GO: "No Memberships to Show",
            zD: "No Items To Display"
        },
        E: {
            zN: "Add Recipients",
            ov: "Chat for conversation",
            ow: "This is where the chat messages would appear.",
            AC: "Click to load providers",
            AQ: "Copy",
            rn: "Failed to load conversations",
            BM: "Failed to load file",
            BN: "Failed to load image",
            ro: "Failed to load messages.",
            BO: "Failed to load providers.",
            uz: "No conversation selected",
            uA: "See conversations on the left, or start a new message.",
            uB: "No conversations",
            uD: "No messages yet",
            uE: "See conversations on the left or start a new message.",
            E7: "Reply",
            yx: "Chat",
            yR: "Type a message..."
        },
        tP: "Pause",
        tQ: "Play",
        tR: function(n) {
            return "Preview " + n;
        },
        tS: "Tap to expand",
        tT: "Cannot preview this file",
        tU: "Loading CSV",
        tV: function(n) {
            return "CSV preview: " + n;
        },
        tW: "Loading document",
        tX: "Loading Word document",
        tY: function(n) {
            return "Document preview: " + n;
        },
        tZ: "Loading PDF",
        t_: "Loading PDF preview",
        t$: function(n) {
            return "Column " + n;
        },
        t0: "Loading spreadsheet",
        t1: "No rows to display.",
        t2: "To view this file, please download it and open it with the appropriate application on your device.",
        t3: "This workbook has no sheets to display.",
        t4: "Loading Excel workbook",
        t5: F2(function(n, r) {
            return "Excel preview: " + n + " \u2014 " + r;
        }),
        t6: function(n) {
            return "Excel preview: " + n;
        },
        t7: "Loading XML",
        t8: "Loading XML",
        t9: function(n) {
            return "XML preview: " + n;
        },
        ua: function(n) {
            return n + " joined conversation";
        },
        ub: function(n) {
            return n + " was removed from conversation";
        },
        uc: function(n) {
            return "Reply to " + n;
        },
        ud: "Reply to you",
        uf: function(n) {
            return n + " miles away";
        },
        uh: function(n) {
            return "Minimum age for this plan is " + n + " years old.";
        },
        c$: {
            rA: "First Name",
            sV: "Last Name",
            ue: "Middle Name",
            ym: "Suffix",
            yx: "Title",
            Gh: "Select"
        },
        us: "Cart",
        ut: "Logout",
        uu: "Next Bill",
        uw: "Next Step",
        ux: "No",
        uy: function(n) {
            return "At least one patient on the membership must be " + n + " years old.";
        },
        uI: {
            aP: "Document",
            qH: "Prescription",
            rq: "Fax",
            le: "form",
            sn: "Prescription",
            sS: "Lab Results",
            uG: "Note",
            zh: "Vitals"
        },
        uQ: function(n) {
            return "of " + n + " due";
        },
        uT: function(n) {
            return "on " + n;
        },
        u3: "Open menu",
        Ei: "Other",
        aJ: {
            o2: "Complete Purchase",
            hN: "Done",
            Bp: "Due Today",
            C4: "Member",
            dS: "No payment methods available",
            cg: "Payment Method",
            i9: "Pricing Breakdown",
            ww: "Purchase completed successfully",
            ki: "You're all set! The package is available immediately.",
            eg: "Purchase Successful!",
            yx: "Review & Pay"
        },
        u9: function(n) {
            return "Expires on " + n;
        },
        va: function(n) {
            return n + " utilized";
        },
        iQ: {
            xy: "View Package Details"
        },
        vn: "Patient",
        cg: "Payment method",
        c2: {
            zY: "American Express is not accepted.",
            rT: "Future expiration date",
            sw: "Please enter a valid payment method holder name.",
            sT: "Payment Source",
            Fd: "Please add a payment method.",
            Fj: "Save Payment Method"
        },
        vB: function(n) {
            return n + " is not configured to accept payments.";
        },
        bH: {
            Ai: "Blocked",
            AL: "Confirmed",
            BG: "Expiring",
            BL: "Failed",
            Cr: "Invalid",
            Dh: "New",
            wk: "Processing",
            GD: "Warning"
        },
        vD: function(n) {
            return n + " is now the default source";
        },
        vE: function(n) {
            return n + " was successfully removed.";
        },
        lW: {
            mS: "+ Add Payment Method",
            m_: "Add a Payment Method",
            hg: "Card",
            pw: "Your payment source was successfully created",
            qt: "Don't Save Payment Source",
            qL: "Edit Payment Source",
            hT: "Expiration Month",
            hU: "Expiration Year",
            sH: "Selected as Default",
            cb: "There Was an Error Loading Your Sources",
            tr: "Make Default",
            vx: "Use This Payment Source to Pay Past Due Invoices",
            Fj: "Save Payment Method",
            yx: "Payment Sources",
            yJ: "Link Already Used",
            kt: "Your payment information has successfully been updated",
            GO: "No Sources to Show",
            zF: "Zip",
            zH: "Zip Code"
        },
        vG: "Payment terms",
        vI: {
            vA: "Payment failed!",
            vF: "Payment successful!"
        },
        fA: {
            Ds: "On behalf of the new member:",
            uR: "Terms and Conditions:",
            Dt: "On behalf of each member in this membership:",
            i_: "Not Accepted"
        },
        vJ: "Required for: All enrollees",
        vK: function(n) {
            return "Required for: " + n;
        },
        fB: {
            kK: "/year",
            lC: "/month",
            l6: "/quarter",
            mk: "/6 months"
        },
        fC: {
            kK: "/yr",
            lC: "/mo",
            l6: "/qtr",
            mk: "/6mo"
        },
        vO: "Phone",
        c4: {
            mS: "Add another phone number",
            Cb: "Home",
            sT: "Phone Number",
            Df: "Mobile",
            Do: "Office",
            E3: "Remove phone"
        },
        vU: "Plan",
        I: {
            nq: "Annual",
            nW: "Billing Schedule",
            o1: "Complete Enrollment",
            hN: "Done",
            Bp: "Due Today",
            ra: "Enrollment completed successfully",
            C4: "Member",
            Db: "Membership Start Date",
            lC: "Monthly",
            dS: "No payment methods available",
            u1: "One time registration fee",
            cg: "Payment Method",
            EZ: "Recurring",
            x5: "Starts Today",
            ki: "You'll receive a confirmation email shortly with all the details.",
            eg: "You are Enrolled!",
            yx: "Review & Pay"
        },
        vX: "Please",
        v3: function(n) {
            return "Practice does not accept members under age " + n;
        },
        v9: "Preferred Language",
        ae: {
            A$: "Date Filled",
            k_: "Date Prescribed",
            k0: "# days of treatment",
            le: "Form",
            rO: "Frequency",
            lk: "Instructions",
            C3: "Medication",
            l0: "Prescriber",
            l1: "Price",
            wx: "Qty",
            E0: "Refills",
            me: "Route of Administration",
            mu: "Strength",
            mB: "Use by Date"
        },
        wm: {
            B1: "He/Him/His",
            sT: "Pronouns",
            Dm: "Not Listed",
            EC: "Select",
            FA: "She/Her/Hers",
            Gd: "They/Them/Theirs"
        },
        wo: wx,
        wp: gx + " " + wx + " and " + hx,
        wq: wx + " is invalid, please select a different option.",
        l3: {
            xn: "Provider and location selected!",
            yx: "Select Provider & Location"
        },
        ws: wx + " is required.",
        wt: {
            Fl: "Search by name"
        },
        wu: gx + " " + wx,
        wv: "Provider selected!",
        EW: function(n) {
            return "Purchase " + n;
        },
        wy: "Qty",
        fL: {
            k6: "Due Now",
            rz: "First Bill",
            Ee: "One time registration fee",
            EZ: "Recurring",
            E_: "Recurring Bills",
            Fo: "Second Bill",
            Gn: "Total Bill"
        },
        l7: {
            sT: "Rate & Schedule",
            EC: "Select"
        },
        fN: {
            z_: "and",
            CN: "This site is protected by reCAPTCHA and the Google",
            ES: "Privacy Policy",
            Ga: "Terms of service"
        },
        wG: ".",
        wQ: {
            zS: "Adult",
            AB: "Child",
            sT: "Member Type",
            iO: "Owner"
        },
        E3: "Remove",
        wU: "Removing",
        w_: "Please describe.",
        w$: function(n) {
            return "Please enter " + n + ".";
        },
        w0: function(n) {
            return "Please select " + n + ".";
        },
        xf: {
            AY: "Currently viewing sandbox data."
        },
        Fj: "Save",
        xk: function(n) {
            return "By submitting your account information, you authorize " + n + " to electronically debit and credit your account on a recurring basis as set forth in your membership agreement or as displayed to you during the signup process. You understand you can contact " + n + " to revoke this authorization at any time.";
        },
        xl: function(n) {
            return "By submitting your account information, you authorize " + n + " to electronically debit and credit your account for this service as displayed to you.";
        },
        d4: {
            AH: "security and compliance",
            BY: "frameworks",
            Ek: "Our",
            EE: "platform",
            F7: "uses state-of-the-art data encryption technology and is regularly audited against comprehensive"
        },
        fW: gx,
        ml: {
            p8: "Your session expired, please sign in again.",
            yx: "Session Expired"
        },
        xt: {
            BP: "Female",
            Cq: "Intersex",
            sT: "Sex",
            CY: "Male",
            EC: "Select"
        },
        xC: "Login",
        xD: function(n) {
            return "By clicking " + n + ", I hereby acknowledge that I meet the age";
        },
        xE: "requirements",
        xF: "allowing this platform to collect the information I have provided.",
        xG: "Message and data rates may apply. Reply STOP to opt out at any time.",
        xH: "Sign Out",
        xI: function(n) {
            return "Don't have a membership with " + n + " ?";
        },
        xJ: "Sign up today",
        jw: {
            AO: "Please contact us and let us know the plan you would like to sign up for at",
            Eh: "or",
            yx: "The practice is not currently accepting new members"
        },
        xO: F2(function(n, r) {
            return "Sign up with " + n + " through " + r;
        }),
        xP: function(n) {
            return "Sign up with " + n;
        },
        xW: "Spanish",
        x_: "SSN",
        x0: xx,
        x2: function(n) {
            return xx + " cannot be prior to " + n + ".";
        },
        bi: {
            zO: "Additional Details",
            AK: "Confirmation",
            AM: "Contact",
            A_: "Custom Details",
            lp: "Location",
            fm: "Members",
            C8: "Demographics",
            Da: "Membership",
            wo: "Provider"
        },
        yd: "Please enter a valid payment method or account holder name.",
        ye: function(n) {
            return n;
        },
        dh: {
            AA: "You will receive a purchase confirmation if you authorized us to send you emails. If you have any further questions, please reach out to us directly.",
            qQ: "Failed to send email!",
            qR: "Email sent!",
            EW: "Thank you for your purchase!",
            yx: "Thank You",
            GH: "We are thrilled to have you as a new member! Expect to receive an invoice once your membership is confirmed."
        },
        ko: {
            Bi: "Does not use tobacco",
            yx: "Tobacco Use",
            y3: "Uses tobacco"
        },
        yK: "There are too many dependents on this membership.",
        yT: "An error occurred, please try again.",
        dj: {
            rc: "Patient cannot be verified",
            w7: "Resend code",
            kg: "Sign In",
            F5: "Patient verified",
            yx: "Enter your code",
            zx: "Your code"
        },
        y5: "It may take a few seconds to arrive, and will be valid for 15 minutes.",
        y6: "It may take a few seconds to arrive, and will be valid for 10 minutes.",
        y7: function(n) {
            return "Enter the code we just sent to " + n;
        },
        y8: function(n) {
            return "Enter the code we just texted to " + n;
        },
        y9: function(n) {
            return "An email with a code has been sent to " + n + ". Please enter the code within 15 minutes.";
        },
        za: function(n) {
            return "A text message with a code has been sent to " + n + ". Please enter the code within 10 minutes.";
        },
        zb: "If we have an account matching your email address, you will receive an email with the code. If you do not receive an email",
        zc: "If we have an account matching your phone number, you will receive a text with the code. If you do not receive a text",
        zg: function(n) {
            return "Go to " + n + " Website";
        },
        Y: {
            n$: "BMI",
            qc: "Diastolic (mmHg)",
            B2: "Head circumference (in)",
            B3: "Head circumference (cm)",
            B5: "Height (in)",
            B6: "Height (cm)",
            EV: "Pulse (bpm)",
            xa: "Respiratory Rate (bpm)",
            xY: "SpO2 (%)",
            yn: "Systolic (mmHg)",
            F8: "Temp (\xb0F)",
            F9: "Temp (\xb0C)",
            GF: "Weight (lbs)",
            GG: "Weight (kg)",
            GI: "When"
        },
        t: {
            m3: "You've been added to the waitlist!",
            m4: "We'll notify you when a spot opens up with",
            nH: "Full - Join Waitlist",
            qO: "Email",
            qP: "jane@example.com",
            q3: "# People to Enroll",
            rB: "First Name",
            rC: "Jane",
            sy: "Complete your signup below to join",
            sz: "You've been invited off the waitlist!",
            CJ: "Join Waitlist",
            sP: "Joining",
            sQ: "waitlist...",
            sW: "Last Name",
            sX: "Doe",
            vd: "Join the Waitlist",
            vP: "Phone",
            wr: "Provider",
            xm: "Select a provider",
            yf: "Something went wrong. Please try again.",
            yl: "We'll contact you when a spot opens up with",
            eg: "You're on the waitlist!"
        },
        zo: function(n) {
            return "Welcome to " + n;
        },
        zt: "Yes",
        zy: "Your contact details",
        zz: "Your Email"
    }), Cx = "Fecha", Ax = "doctor", kx = "Seleccionar", Ex = "location", qx = "Su membres\xeda ha sido renovada", Fx = "proveedor", jx = "Fecha de inicio", Dx = mx({
        mO: F2(function(n, r) {
            return "Usar una tarjeta de cr\xe9dito le costar\xe1 a " + n + " un " + r + " adicional en tarifas de procesamiento para su membres\xeda. Por favor, considere usar una cuenta bancaria en su lugar.";
        }),
        mP: function(n) {
            return "Usar una tarjeta de cr\xe9dito le costar\xe1 a " + n + " gastos de procesamiento adicionales. Por favor, considere usar una cuenta bancaria en su lugar.";
        },
        m1: function(n) {
            return "Agregado " + n;
        },
        m6: "Datos adicionales",
        m7: "Datos adicionales para el miembro principal",
        kD: {
            qN: "Env\xedame los detalles por correo electr\xf3nico",
            hP: "Inscr\xedbete ahora"
        },
        m9: {
            nM: "Direcci\xf3n de facturaci\xf3n",
            nV: "Misma direcci\xf3n de facturaci\xf3n",
            oE: "Ciudad",
            AS: "Pa\xeds",
            s4: "Direcci\xf3n",
            CO: "Calle, apartado postal, nombre de empresa, a/c",
            s5: "Direcci\xf3n complementaria",
            CP: "Apartamento, suite, unidad, edificio, piso, etc.",
            tp: "Direcci\xf3n Postal",
            tq: "Misma direcci\xf3n postal",
            ur: "Direcci\xf3n",
            Ff: "Usar la direcci\xf3n del miembro principal",
            x6: "Estado (abrev.)",
            FY: "Por favor use la abreviatura de dos letras.",
            FZ: "[Abreviaturas de USPS] (https://pe.usps.com/text/pub28/28apb.htm)",
            zF: "C\xf3digo Postal",
            zG: "No tenemos cobertura en su \xe1rea",
            GP: "Por favor, ingrese un c\xf3digo postal v\xe1lido de EE.UU."
        },
        nh: F2(function(n, r) {
            return "El rango de edad para este plan es de " + n + " a " + r + " a\xf1os.";
        }),
        kJ: "Monto",
        z_: F2(function(n, r) {
            return n + " y " + r;
        }),
        z3: {
            n0: "Reservar",
            n1: "Reservar una nueva cita",
            Aj: "Reservar una cita",
            hf: "Cancelar cita",
            n7: "Esto notificar\xe1 a tu consultorio y liberar\xe1 el horario. No se puede deshacer.",
            n8: "Cancelar cita",
            n9: "\xbfCancelar esta cita?",
            od: "Tu cita ha sido cancelada",
            oG: "Cerrar",
            qa: "Detalles de la cita",
            qb: "Esta cita no se puede ver ni gestionar en l\xednea. Comun\xedcate con tu consultorio.",
            cb: "Hubo un error al cargar tus citas",
            vm: "Pasadas",
            x7: "Cancelada",
            x8: "Completada",
            x9: "Confirmada",
            ya: "Rechazada",
            yb: "Sin confirmar",
            yx: "Citas",
            yV: "Pr\xf3ximas",
            zB: "No tienes citas pasadas",
            zC: "No tienes citas pr\xf3ximas"
        },
        ny: "Se debe agregar al menos un dependiente al plan.",
        nz: "Se debe agregar al menos un miembro al plan.",
        nD: function(n) {
            return "escrito por " + n;
        },
        nI: "Cuenta Bancaria",
        Ag: {
            kK: "Anual",
            lC: "Mensual",
            l6: "Trimestral",
            mk: "Semestral"
        },
        he: {
            n6: "Agente comercial",
            sT: "Qui\xe9n es tu agente comercial?",
            EC: "Seleccionar"
        },
        hf: "Cancelar",
        O: {
            nK: "antes de la cita",
            O: "Cancelar la Cita",
            oa: "Contacto para Cancelaciones",
            oc: "Pol\xedtica de Cancelaci\xf3n",
            pb: "Cont\xe1ctenos al",
            sh: "horas",
            sm: "Si desea reprogramar su cita, haga click en el bot\xf3n Reprogramar para reservar un nuevo horario.",
            um: "Plazo M\xednimo de Cancelaci\xf3n",
            w5: "Reprogramar",
            w6: "Reprogramar Cita",
            yz: "para cancelar su cita.",
            yA: "Para cancelar su cita, cont\xe1ctenos al",
            zv: "Su cita ha sido cancelada"
        },
        bl: {
            An: "Cancelar la membres\xeda",
            Ap: "Motivo de la cancelaci\xf3n",
            C9: "Cancelando la membres\xeda para:",
            E4: "Remover Miembro",
            E5: "El miembro ha sido removido de la membres\xeda",
            Fa: "Por favor ingrese una raz\xf3n de cancelaci\xf3n.",
            Fi: "\xa1Lamentamos que se vaya!",
            F5: "La membres\xeda ha sido cancelada"
        },
        hg: "Tarjeta",
        ol: function(n) {
            return "Algunos art\xedculos no se pudieron procesar: " + n + ". Siguen en tu carrito, int\xe9ntalo de nuevo.";
        },
        cF: {
            o4: "Confirmar y Pagar",
            qI: "Editar carrito",
            dS: "No hay m\xe9todos de pago registrados",
            cg: "M\xe9todo de pago",
            yx: "Confirmar y pagar",
            zw: "Tu carrito"
        },
        hi: {
            g8: "Recibir\xe1s un correo de confirmaci\xf3n con todos los detalles en breve.",
            qs: "Listo",
            yx: "\xa1Todo listo!"
        },
        aO: {
            Bq: "(A Pagar Hoy)",
            Bs: "Editar",
            qU: "Tu carrito est\xe1 vac\xedo",
            CH: "Acciones del art\xedculo",
            tK: "Cuota de Membres\xeda",
            Ed: "Pago \xdanico",
            Ef: "Cuota de Inscripci\xf3n \xdanica",
            EZ: "Recurrente",
            E3: "Quitar del Carrito",
            Gu: "\u2014"
        },
        om: function(n) {
            return "Recurrente (desde el " + n + ")";
        },
        cG: {
            ph: "Continuar al Pago",
            qT: "Agrega una membres\xeda o paquete para comenzar tu compra.",
            qW: "Tu carrito est\xe1 vac\xedo",
            dB: "Explorar Servicios",
            yx: "Tu Carrito",
            yX: "No pudimos actualizar el art\xedculo del carrito. Int\xe9ntalo de nuevo."
        },
        aw: {
            A0: "dd/MM/yyyy",
            Bl: "A Pagar Anualmente",
            Bm: "A Pagar Trimestralmente",
            Bn: "A Pagar Mensualmente",
            Bo: "A Pagar Semestralmente",
            Bp: "A Pagar Hoy",
            Dj: "Pr\xf3ximo cobro: { $date }",
            i9: "Desglose de Precios",
            E1: "Cargos de Inscripci\xf3n",
            FV: "A partir del { $date }",
            ms: "A partir de hoy"
        },
        kR: {
            FH: "Ver menos",
            FJ: "Ver m\xe1s"
        },
        AA: {
            yx: "Checkout"
        },
        oy: function(n) {
            return "Este plan no permite ni\xf1os de mas de " + n + " a\xf1os.";
        },
        cH: {
            rA: "Nombre Elegido",
            Cv: "Nombre elegido es distinto?",
            sV: "Apellido Elegido",
            ue: "Segundo Nombre Elegido",
            ym: "Sufijo Elegido",
            yx: "T\xedtulo Elegido"
        },
        oH: "Cerrar men\xfa",
        oK: {
            sv: "El formato del c\xf3digo es inv\xe1lido."
        },
        o3: "Confirmar",
        AK: {
            mW: "Agregar luego",
            oo: "Cambia tu m\xe9todo de pago",
            pC: "Tarjeta de Cr\xe9dito o D\xe9bito",
            pD: "Tarjeta de Cr\xe9dito o D\xe9bito o Cuenta Bancaria",
            xs: "Opciones"
        },
        o7: "Por favor, contacte a la pr\xe1ctica si tiene alguna pregunta.",
        o8: function(n) {
            return "Por favor, contacte a la pr\xe1ctica al " + n + " si tiene alguna pregunta.";
        },
        o9: function(n) {
            return "Por favor, contacte a la pr\xe1ctica al " + n + " si tiene alguna pregunta.";
        },
        pa: F2(function(n, r) {
            return "Por favor, contacte a la pr\xe1ctica al " + n + " o al " + r + " si tiene alguna pregunta.";
        }),
        pe: "Continuar al siguiente paso",
        pf: function(n) {
            return "Continuar a " + n;
        },
        pg: "Continuar",
        po: function(n) {
            return "Contrato Renueva en #" + n;
        },
        pq: function(n) {
            return "Contrato Termina en " + n;
        },
        kZ: {
            z3: "Citas",
            zn: "Bienvenido/a de nuevo,"
        },
        pR: {
            uC: "Sin datos"
        },
        pS: Cx,
        bq: Cx + " de nacimiento",
        p9: function(n) {
            return "La cancelaci\xf3n de esta membres\xeda detendr\xe1 los cargos recurrentes para los pacientes seleccionados y eliminar\xe1 el acceso a las ventajas de la membres\xeda a partir de " + n + ".";
        },
        hK: {
            r$: "\xbfTienes un c\xf3digo de descuento?",
            Cr: "Este no es un c\xf3digo de descuento v\xe1lido.",
            sT: "C\xf3digo de descuento"
        },
        eT: {
            z$: "Cualquier distancia",
            sT: "Distancia",
            Dl: "Sin filtro",
            EC: "Filtrar por distancia"
        },
        qk: "Fecha de nacimiento no puede ser en el futuro.",
        ql: Ax,
        qm: kx + " " + Ax,
        qo: function(n) {
            return n + " aceptado!";
        },
        T: {
            zI: "Aceptar",
            A6: "No, gracias",
            k2: "Escribe tu nombre y apellido",
            A9: "Firma electr\xf3nica del miembro",
            Cs: "Por favor, escribe cualquiera de los nombres exactamente como aparece arriba.",
            Ct: "Por favor, escribe tu nombre exactamente como aparece arriba.",
            C6: "Nombre del Miembro",
            lu: "Nombre",
            Di: "Nombre del Nuevo Miembro",
            EP: "Nombre del Miembro Principal",
            EQ: "Escribe el nombre y apellido de cualquier miembro",
            ER: "Firma electr\xf3nica del nuevo o miembro principal",
            Fd: "Por favor, firme este documento.",
            xK: "Firma electr\xf3nica",
            yU: "La firma no coincide con el nombre del firmante."
        },
        qq: {
            Bk: "Pendiente",
            Eo: "Pagado",
            GC: "Anulado"
        },
        aa: {
            yx: "Documentos"
        },
        qu: "Descargar",
        bu: {
            zU: "Desde el inicio",
            AX: "A\xf1o actual",
            AZ: "Personalizado",
            qZ: "Fecha de Fin",
            Cj: "En Progreso",
            Ck: "Su archivo est\xe1 siendo procesado y puede tardar unos segundos.",
            CM: "A\xf1o pasado",
            x0: "Fecha de Inicio"
        },
        qw: "Pr\xe1ctica DPC",
        cN: {
            sT: "Pr\xe1ctica DPC",
            CR: "Cargando pr\xe1cticas DPC...",
            Ei: "Nombre de la Pr\xe1ctica DPC",
            Ej: "El nombre de tu Pr\xe1ctica DPC",
            EC: "Empieza a escribir para encontrar tu Pr\xe1ctica DPC",
            GO: "No se encontraron pr\xe1cticas DPC"
        },
        qz: function(n) {
            return "Vence el " + n;
        },
        qE: "Los pacientes de la membres\xeda no pueden duplicarse en la misma membres\xeda.",
        Bs: "Editar",
        qN: "Email",
        aQ: {
            qN: "Correo Electr\xf3nico",
            rA: "Nombre",
            sV: "Apellido",
            ur: "Nombre Completo",
            vO: "Tel\xe9fono",
            wQ: "Relaci\xf3n",
            Fb: "Por favor ingrese tel\xe9fono o correo electr\xf3nico.",
            Fc: "Por favor, ingrese al menos nombre, apellido o relaci\xf3n.",
            FP: "Usar miembro principal como contacto de emergencia",
            yx: "Contacto de emergencia"
        },
        a5: {
            AB: "Hijo/Hija",
            BZ: "Abuelo/Abuela",
            B0: "Tutor/Tutora",
            Dl: "Ninguno",
            Ei: "Otro",
            Eq: "Padre/Madre",
            fW: "Selecciona una relaci\xf3n",
            FM: "Hermano/Hermana",
            FU: "C\xf3nyuge"
        },
        q2: "Ingl\xe9s",
        eY: {
            nU: "Frecuencia de Facturaci\xf3n",
            EO: "Principal",
            yx: "Miembros inscritos",
            GO: "No hay pacientes inscritos"
        },
        q6: function(n) {
            return "termin\xf3 el " + n;
        },
        q7: function(n) {
            return "termina el " + n;
        },
        q8: function(n) {
            return "Inscrito el " + n;
        },
        q9: {
            qi: "No me inscriba",
            q4: "Inscr\xedbame",
            ur: "Estado de Inscripci\xf3n",
            Ds: "\xbfEst\xe1 pagando por otra persona y no desea inscribirse como paciente? Seleccione \u201CNo me inscriba\u201D."
        },
        re: F2(function(n, r) {
            return n + ": " + r;
        }),
        rf: F3(function(n, r, t) {
            return n + " " + r + ": " + t;
        }),
        rm: F2(function(n, r) {
            return "Expira " + n + "/" + r;
        }),
        dB: {
            yx: "Explorar Servicios"
        },
        o: {
            zM: "+ Agregar Otro Miembro",
            m$: "Agregar al carrito",
            m2: "ha sido agregado a tu carrito!",
            ni: "Todos",
            Ae: "Facturaci\xf3n",
            Aw: "Cambiar Miembro",
            AI: "Configurar detalles de la membres\xeda",
            AJ: "Configurar detalles del paquete",
            AN: "Contacte a la pr\xe1ctica para obtener precios",
            qK: "Editar Art\xedculo en el Carrito",
            hP: "Inscribirse",
            dB: "Explorar servicios",
            C4: "Miembro",
            C7: "T\xfa mismo",
            Db: "Fecha de Inicio de Membres\xeda",
            ad: "Membres\xedas",
            iQ: "Paquetes",
            wo: "Proveedor",
            EW: "Comprar",
            E4: "Quitar",
            yW: "Actualizar Carrito",
            ze: "Ver Carrito",
            GO: "No hay servicios adicionales disponibles en este momento"
        },
        rE: "para",
        e0: {
            oF: "haz clic aqu\xed",
            sa: "No tienes autorizaci\xf3n para ver esta p\xe1gina. Por favor, usa el enlace en tu correo electr\xf3nico, o",
            sb: "para ir a la p\xe1gina principal de tu portal de pacientes.",
            yx: "Autorizaci\xf3n Requerida"
        },
        dE: {
            A2: "Fecha de Env\xedo",
            pU: "Fecha de Env\xedo",
            Dn: "# de Preguntas",
            Fw: "Enviado a",
            mt: "Estado"
        },
        rG: {
            so: "Por favor, complete las preguntas del formulario."
        },
        rU: {
            BP: "Femenino",
            sT: "G\xe9nero",
            CY: "Masculino",
            Ei: "Otro"
        },
        rV: {
            sT: "Identidad de g\xe9nero",
            CZ: "Hombre",
            Dk: "No binario",
            Dm: "No listado",
            EC: "Seleccionar",
            Gq: "Hombre trans",
            Gr: "Mujer trans",
            GL: "Mujer"
        },
        h4: {
            qV: "No se ha compartido informaci\xf3n de la pr\xe1ctica.",
            rd: "Hubo un error al cargar su informaci\xf3n de salud.",
            yx: "Salud"
        },
        r6: "Cobertura de salud",
        aE: {
            oi: "Aseguradora",
            Ar: "Comience a escribir para encontrar su aseguradora",
            ok: "Nombre de aseguradora",
            As: "Elija una opci\xf3n",
            ab: "Cobertura existente",
            BD: "\xbfTiene seguro o una alternativa de seguro?",
            rZ: "ID de grupo",
            sf: "Deducible alto",
            B9: "\xbfEst\xe1 en un plan con deducible alto?",
            tD: "ID de miembro",
            Fm: "Busque para filtrar..."
        },
        su: function(n) {
            return "Por favor, ingrese " + n + " v\xe1lido.";
        },
        sx: function(n) {
            return "Se requiere un t\xe9lefono " + n + " v\xe1lido.";
        },
        sA: function(n) {
            return "Factura " + n;
        },
        sB: function(n) {
            return "Fecha de Vencimiento: " + n;
        },
        e6: {
            vz: "Pago",
            xS: "Fuente de Pago",
            kg: "Pagar Factura",
            yx: "Pagar Factura"
        },
        h: {
            zP: "cargos adiconales",
            np: "Monto a Pagar",
            ou: "Cargos",
            py: "Cr\xe9dito",
            AU: "Cargo por tarjeta",
            pz: "Para evitar cargos por transacci\xf3n, considere usar una cuenta bancaria (ACH) o d\xe9bito.",
            AV: "Usar una tarjeta de cr\xe9dito implicar\xe1 cargos por transacci\xf3n.",
            pA: "Cargos por tarjeta",
            pB: "Cargos pagados por tarjeta",
            Bk: "A pagar",
            qA: "gracias a",
            qB: "gracias a tu membres\xeda",
            qC: "gracias a tu paquete",
            sE: "Total de la Factura",
            cb: "Hubo un error al cargar sus facturas",
            uM: "N\xfamero de Factura",
            Eo: "Pagado",
            vw: "Pagar Factura",
            vH: "Total a Pagar",
            vI: "Pagos",
            vY: "+ impuestos",
            yj: "Subtotal",
            F6: "Impuesto",
            yx: "Facturas",
            Gm: "Total",
            yL: "Total a Pagar",
            yO: "Transferido a Cr\xe9dito",
            zu: "Has ahorrado",
            GO: "No hay facturas para mostrar"
        },
        ao: "Art\xedculo",
        ip: {
            sT: "C\xf3mo escuchaste sobre nosotros?",
            s_: "Fuente de contacto",
            EC: "Seleccionar"
        },
        s0: "Saber m\xe1s",
        lp: Ex,
        cc: {
            z$: "Cualquier ubicaci\xf3n",
            p8: "Selecciona la ubicaci\xf3n donde te gustar\xeda reunirte con tu proveedor",
            Cr: "La ubicaci\xf3n es inv\xe1lida, seleccione una opci\xf3n diferente.",
            sT: "Ubicaci\xf3n",
            EC: "Filtrar por ubicaci\xf3n",
            wZ: "Ubicaci\xf3n es requerida.",
            fW: "Seleccionar"
        },
        tc: function(n) {
            return "+ " + n + " otros";
        },
        iu: {
            ht: "c\xf3digo",
            rF: "Iniciar sesi\xf3n en su portal del paciente",
            to: "enlace m\xe1gico"
        },
        td: function(n) {
            return "No nos gustan las contrase\xf1as m\xe1s que a ti. Ingresa tu correo electr\xf3nico y te enviaremos un " + n + " para iniciar sesi\xf3n al instante.";
        },
        te: function(n) {
            return "No nos gustan las contrase\xf1as m\xe1s que a ti. Ingresa tu n\xfamero de tel\xe9fono y te enviaremos un " + n + " para iniciar sesi\xf3n al instante.";
        },
        tf: "Env\xedame un correo",
        tg: "Ingresa tu correo electr\xf3nico para obtener un c\xf3digo de inicio de sesi\xf3n",
        th: "Ingresa tu n\xfamero de tel\xe9fono para obtener un c\xf3digo de inicio de sesi\xf3n",
        ti: "Tu n\xfamero de celular",
        tj: "Env\xedame un texto",
        tk: function(n) {
            return "Enviar " + n;
        },
        tu: function(n) {
            return "La edad m\xe1xima para este plan es de " + n + " a\xf1os.";
        },
        tB: function(n) {
            return "Edad " + n;
        },
        tC: "Dependiente",
        tF: "Miembro principal",
        tG: function(n) {
            return "Proveedor: " + n;
        },
        fm: {
            mS: "Agregar miembros",
            mT: "Agregar otro miembro",
            mU: "Demograf\xeda",
            mV: "Agregar Contacto de Emergencia",
            mX: "Agregar Miembro",
            mY: "+ Agregar Nuevo Miembro",
            mZ: "\xa1Miembro creado exitosamente!",
            m5: "Agregando miembros?",
            Bb: "Por favor, contacte a la cl\xednica para cambiar estos detalles del paciente.",
            qJ: "Editar Contacto de Emergencia",
            qS: "Contacto de Emergencia",
            r2: "Seguro M\xe9dico",
            r3: "Seguro",
            r4: "N\xfamero de Grupo",
            r5: "N\xfamero de Miembro",
            sp: "Informaci\xf3n de Miembro",
            sq: "Editar Informaci\xf3n de Miembro",
            cb: "Hubo un error cargando miembros",
            ts: "Gestionar Miembro",
            C_: "Gestionar Miembros",
            uF: "No se permiten m\xe1s miembros dependientes para esta membres\xeda",
            yx: "Miembros",
            GO: "No hay miembros para mostrar"
        },
        tH: function(n) {
            return "Se permiten " + n + " miembros dependientes para esta membres\xeda";
        },
        tJ: function(n) {
            return "Su membres\xeda finaliza el " + n;
        },
        fo: {
            hI: "Predeterminado",
            sT: "M\xe9todo de Pago",
            kt: "M\xe9todo de pago actualizado exitosamente",
            yY: "Cualquier pago pendiente de esta membres\xeda se cobrar\xe1 al nuevo m\xe9todo de pago."
        },
        tM: qx,
        tN: function(n) {
            return qx + " hasta " + n;
        },
        Db: {
            sT: "Fecha de inicio de la membres\xeda"
        },
        ad: {
            pm: "Per\xedodo de contrato",
            pI: "Membres\xedas Actuales",
            pN: "Actual",
            q$: "Membres\xedas Finalizadas",
            q0: "Finalizada",
            i_: "Membres\xedas Pendientes",
            wV: "Renueva la Membres\xeda",
            xy: "Ver Detalles de la Membres\xeda",
            yx: "Membres\xedas",
            Gi: "Membres\xedas y paquetes",
            GO: "No Hay Membres\xedas Para Mostrar",
            zD: "No hay elementos para mostrar"
        },
        E: {
            zN: "Agregar Destinatarios",
            ov: "Chat para conversaci\xf3n",
            ow: "Aqu\xed es donde aparecer\xedan los mensajes del chat.",
            AC: "Haga clic para cargar proveedores",
            AQ: "Copiar",
            rn: "Error al cargar conversaciones",
            BM: "Error al cargar archivo",
            BN: "Error al cargar imagen",
            ro: "Error al cargar mensajes.",
            BO: "Error al cargar proveedores.",
            uz: "Ninguna conversaci\xf3n seleccionada",
            uA: "Vea las conversaciones a la izquierda, o inicie un nuevo mensaje.",
            uB: "Sin conversaciones",
            uD: "A\xfan no hay mensajes",
            uE: "Vea las conversaciones a la izquierda o inicie un nuevo mensaje.",
            E7: "Responder",
            yx: "Chat",
            yR: "Escribir un mensaje..."
        },
        tP: "Pausa",
        tQ: "Reproducir",
        tR: function(n) {
            return "Vista previa de " + n;
        },
        tS: "Toca para ampliar",
        tT: "No se puede previsualizar este archivo",
        tU: "Cargando CSV",
        tV: function(n) {
            return "Vista previa de CSV: " + n;
        },
        tW: "Cargando documento",
        tX: "Cargando documento de Word",
        tY: function(n) {
            return "Vista previa del documento: " + n;
        },
        tZ: "Cargando PDF",
        t_: "Cargando vista previa del PDF",
        t$: function(n) {
            return "Columna " + n;
        },
        t0: "Cargando hoja de c\xe1lculo",
        t1: "No hay filas para mostrar.",
        t2: "Para ver este archivo, desc\xe1rgalo y \xe1brelo con la aplicaci\xf3n adecuada en tu dispositivo.",
        t3: "Este libro no tiene hojas para mostrar.",
        t4: "Cargando libro de Excel",
        t5: F2(function(n, r) {
            return "Vista previa de Excel: " + n + " \u2014 " + r;
        }),
        t6: function(n) {
            return "Vista previa de Excel: " + n;
        },
        t7: "Cargando XML",
        t8: "Cargando XML",
        t9: function(n) {
            return "Vista previa XML: " + n;
        },
        ua: function(n) {
            return n + " se uni\xf3 a la conversaci\xf3n";
        },
        ub: function(n) {
            return n + " fue eliminado de la conversaci\xf3n";
        },
        uc: function(n) {
            return "Respondiendo a " + n;
        },
        ud: "Respondiendo a ti",
        uf: function(n) {
            return "a " + n + "  millas";
        },
        uh: function(n) {
            return "La edad m\xednima para este plan es de " + n + " a\xf1os.";
        },
        c$: {
            rA: "Nombre",
            sV: "Apellido",
            ue: "Segundo Nombre",
            ym: "Sufijo",
            yx: "T\xedtulo",
            Gh: "Seleccionar"
        },
        us: "Carrito",
        ut: "Cerrar sesi\xf3n",
        uu: "Pr\xf3xima factura",
        uw: "Siguiente paso",
        ux: "No",
        uy: function(n) {
            return "Al menos un miembro de la membres\xeda debe tener " + n + " a\xf1os o m\xe1s.";
        },
        uI: {
            aP: "Documento",
            qH: "Prescripci\xf3n",
            rq: "Fax",
            le: "Formulario",
            sn: "Prescripci\xf3n",
            sS: "Resultados de Laboratorio",
            uG: "Nota",
            zh: "Signos Vitales"
        },
        uQ: function(n) {
            return "de " + n + " pendiente";
        },
        uT: function(n) {
            return "el " + n;
        },
        u3: "Abrir men\xfa",
        Ei: "Otro",
        aJ: {
            o2: "Completar Compra",
            hN: "Finalizar",
            Bp: "Total a Pagar Hoy",
            C4: "Miembro",
            dS: "No hay m\xe9todos de pago disponibles",
            cg: "M\xe9todo de Pago",
            i9: "Desglose de Precios",
            ww: "Compra completada exitosamente",
            ki: "\xa1Todo listo! El paquete est\xe1 disponible de inmediato.",
            eg: "\xa1Compra realizada con \xe9xito!",
            yx: "Revisar y Pagar"
        },
        u9: function(n) {
            return "Expira el " + n;
        },
        va: function(n) {
            return n + " utilizados";
        },
        iQ: {
            xy: "Ver Detalles del Paquete"
        },
        vn: "Paciente",
        cg: "M\xe9todo de pago",
        c2: {
            zY: "American Express no es aceptado.",
            rT: "Fecha de vencimiento futura",
            sw: "Por favor, ingrese un nombre v\xe1lido para el titular del m\xe9todo de pago.",
            sT: "Fuente de pago",
            Fd: "Por favor, agregue un m\xe9todo de pago.",
            Fj: "Guardar m\xe9todo de pago"
        },
        vB: function(n) {
            return n + " no tiene pagos configurados.";
        },
        bH: {
            Ai: "Bloqueado",
            AL: "Confirmado",
            BG: "A punto de expirar",
            BL: "Fallido",
            Cr: "Inv\xe1lido",
            Dh: "Nuevo",
            wk: "Procesando",
            GD: "Advertencia"
        },
        vD: function(n) {
            return n + " es ahora la fuente predeterminada";
        },
        vE: function(n) {
            return n + " fue eliminado exitosamente.";
        },
        lW: {
            mS: "+ Agregar M\xe9todo de Pago",
            m_: "Agrega un M\xe9todo de Pago",
            hg: "Tarjeta",
            pw: "Su fuente de pago se ha creado con \xe9xito",
            qt: "No guardar fuente de pago",
            qL: "Editar Fuente de Pago",
            hT: "Mes de Expiraci\xf3n",
            hU: "A\xf1o de Expiraci\xf3n",
            sH: "Predeterminado",
            cb: "Hubo un Error Cargando Tus Fuentes de Pago",
            tr: "Hacer predeterminado",
            vx: "Usa esta fuente de pago para pagar facturas vencidas",
            Fj: "Guardar M\xe9todo de Pago",
            yx: "Fuentes de pago",
            yJ: "Enlace ya utilizado",
            kt: "Su informaci\xf3n de pago se ha actualizado con \xe9xito",
            GO: "No Hay Fuentes de Pago Para Mostrar",
            zF: "C\xf3digo Postal",
            zH: "12345"
        },
        vG: "T\xe9rminos de pago",
        vI: {
            vA: "Pago fallido!",
            vF: "Pago exitoso!"
        },
        fA: {
            Ds: "En nombre del nuevo miembro:",
            uR: "Condiciones generales:",
            Dt: "En nombre de cada miembro de la membres\xeda:",
            i_: "No aceptados"
        },
        vJ: "Requerido para: todos los inscritos",
        vK: function(n) {
            return "Requerido para: " + n;
        },
        fB: {
            kK: "/a\xf1o",
            lC: "/mes",
            l6: "/trimestre",
            mk: "/6 meses"
        },
        fC: {
            kK: "/a\xf1o",
            lC: "/mes",
            l6: "/trim",
            mk: "/6m"
        },
        vO: "Tel\xe9fono",
        c4: {
            mS: "Agregar otro n\xfamero de tel\xe9fono",
            Cb: "Casa",
            sT: "N\xfamero de tel\xe9fono",
            Df: "Movil",
            Do: "Oficina",
            E3: "Borrar n\xfamero de tel\xe9fono"
        },
        vU: "Plan",
        I: {
            nq: "Anual",
            nW: "Frecuencia de Facturaci\xf3n",
            o1: "Completar Inscripci\xf3n",
            hN: "Finalizar",
            Bp: "Total a Pagar Hoy",
            ra: "Inscripci\xf3n completada exitosamente",
            C4: "Miembro",
            Db: "Fecha de Inicio de Membres\xeda",
            lC: "Mensual",
            dS: "No hay m\xe9todos de pago disponibles",
            u1: "Tarifa \xfanica de registro",
            cg: "M\xe9todo de Pago",
            EZ: "Recurrente",
            x5: "Comienza Hoy",
            ki: "Recibir\xe1 un correo electr\xf3nico de confirmaci\xf3n en breve con todos los detalles.",
            eg: "\xa1Est\xe1 inscrito!",
            yx: "Revisar y Pagar"
        },
        vX: "Por favor",
        v3: function(n) {
            return "La pr\xe1ctica no acepta miembros menores a " + n;
        },
        v9: "Idioma preferido",
        ae: {
            A$: "Fecha de Dispensaci\xf3n",
            k_: "Fecha de Prescripci\xf3n",
            k0: "# d\xedas de tratamiento",
            le: "Forma",
            rO: "Frecuencia",
            lk: "Instrucciones",
            C3: "Medicaci\xf3n",
            l0: "Prescriptor",
            l1: "Precio",
            wx: "Cant.",
            E0: "Repeticiones",
            me: "V\xeda de Administraci\xf3n",
            mu: "Concentraci\xf3n",
            mB: "Fecha de Uso"
        },
        wm: {
            B1: "\xc9l",
            sT: "Pronombres",
            Dm: "No listado",
            EC: "Seleccionar",
            FA: "Ella",
            Gd: "Ellos"
        },
        wo: Fx,
        wp: kx + " " + Fx + " y " + Ex,
        wq: Fx + " inv\xe1lido, por favor seleccione una opci\xf3n v\xe1lida.",
        l3: {
            xn: "Proveedor y ubicaci\xf3n seleccionados!",
            yx: "Seleccionar Proveedor y Ubicaci\xf3n"
        },
        ws: Fx + " es requerido.",
        wt: {
            Fl: "Buscar por nombre"
        },
        wu: kx + " " + Fx,
        wv: "Proveedor seleccionado!",
        EW: function(n) {
            return "Compra " + n;
        },
        wy: "Cant.",
        fL: {
            k6: "Cobro inmediato",
            rz: "Primera Factura",
            Ee: "Tarifa \xfanica de registro",
            EZ: "Recurrente",
            E_: "Facturas Recurrentes",
            Fo: "Segunda Factura",
            Gn: "Factura Total"
        },
        l7: {
            sT: "Tarifa y per\xedodo de pago",
            EC: "Seleccionar"
        },
        fN: {
            z_: "y los",
            CN: "Este sitio est\xe1 protegido por reCAPTCHA y se aplican la",
            ES: "Pol\xedtica de Privacidad",
            Ga: "T\xe9rminos de Servicio"
        },
        wG: " de Google.",
        wQ: {
            zS: "Adulto/a",
            AB: "Hijo/a",
            sT: "Relaci\xf3n con usted",
            iO: "Titular"
        },
        E3: "Eliminar",
        wU: "Eliminando",
        w_: "Por favor, describa.",
        w$: function(n) {
            return "Por favor, ingrese " + n + ".";
        },
        w0: function(n) {
            return "Por favor, seleccione " + n + ".";
        },
        xf: {
            AY: "Actualmente viendo datos de sandbox."
        },
        Fj: "Guardar",
        xk: function(n) {
            return "Al enviar la informaci\xf3n de su cuenta, usted autoriza a " + n + " a debitar y acreditar electr\xf3nicamente su cuenta de forma recurrente como se establece en su acuerdo de membres\xeda o como se le muestra durante el proceso de registro. Usted comprende que puede comunicarse con " + n + " para revocar esta autorizaci\xf3n en cualquier momento.";
        },
        xl: function(n) {
            return "Al enviar la informaci\xf3n de su cuenta, usted autoriza a " + n + " a debitar y acreditar electr\xf3nicamente su cuenta este servicio tal y como se le muestra.";
        },
        d4: {
            AH: "marcos integrales",
            BY: "de seguridad y cumplimiento",
            Ek: "Nuestra",
            EE: "plataforma",
            F7: "utiliza tecnolog\xeda de cifrado de datos de \xfaltima generaci\xf3n y se audita peri\xf3dicamente seg\xfan"
        },
        fW: kx,
        ml: {
            p8: "Tu sesi\xf3n expir\xf3, por favor inicia sesi\xf3n nuevamente.",
            yx: "Sesi\xf3n Expirada"
        },
        xt: {
            BP: "Femenino",
            Cq: "Intersexual",
            sT: "Sexo",
            CY: "Masculino",
            EC: "Seleccionar"
        },
        xC: "Iniciar sesi\xf3n",
        xD: function(n) {
            return "Al hacer clic en " + n + ", reconozco que cumplo con los";
        },
        xE: "requisitos",
        xF: "que permiten a esta plataforma recopilar la informaci\xf3n que he proporcionado.",
        xG: "Pueden aplicarse tarifas de mensajes y datos. Responde STOP para cancelar en cualquier momento.",
        xH: "Cerrar sesi\xf3n",
        xI: function(n) {
            return "\xbfNo tienes una membres\xeda con " + n + "?";
        },
        xJ: "Reg\xedstrate hoy",
        jw: {
            AO: "Por favor, cont\xe1ctenos e ind\xedquenos el plan al que desea inscribirse al",
            Eh: "o",
            yx: "Esta pr\xe1ctica no est\xe1 aceptando nuevos miembros en este momento"
        },
        xO: F2(function(n, r) {
            return "Reg\xedstrate con " + n + " a trav\xe9s de " + r;
        }),
        xP: function(n) {
            return "Reg\xedstrate con " + n;
        },
        xW: "Espa\xf1ol",
        x_: "SSN",
        x0: jx,
        x2: function(n) {
            return jx + " no puede ser anterior a " + n + ".";
        },
        bi: {
            zO: "datos adicionales",
            AK: "confirmaci\xf3n",
            AM: "contacto",
            A_: "detalles personalizados",
            lp: "ubicaci\xf3n",
            fm: "miembros",
            C8: "Demograf\xeda",
            Da: "membres\xeda",
            wo: "proveedor"
        },
        yd: "Por favor, ingresa un m\xe9todo de pago o nombre del titular de la cuenta v\xe1lido.",
        ye: function(n) {
            return n;
        },
        dh: {
            AA: "Recibir\xe1s una confirmaci\xf3n de compra si nos autorizaste a enviarte correos electr\xf3nicos. Si tienes alguna otra pregunta, por favor cont\xe1ctanos directamente.",
            qQ: "\xa1Error al enviar el correo!",
            qR: "\xa1Correo enviado!",
            EW: "\xa1Gracias por tu compra!",
            yx: "Gracias",
            GH: "\xa1Estamos encantados de tenerte como nuevo miembro! Espera recibir una factura una vez que se confirme tu membres\xeda."
        },
        ko: {
            Bi: "No usa tabaco",
            yx: "Uso de Tabaco",
            y3: "Usa tabaco"
        },
        yK: "Hay demasiados dependientes en esta membres\xeda.",
        yT: "Ocurri\xf3 un error, por favor int\xe9ntalo de nuevo.",
        dj: {
            rc: "El paciente no puede ser verificado",
            w7: "Reenviar c\xf3digo",
            kg: "Iniciar sesi\xf3n",
            F5: "Paciente verificado",
            yx: "Ingresa tu c\xf3digo",
            zx: "Tu c\xf3digo"
        },
        y5: "Puede tardar unos segundos en llegar y ser\xe1 v\xe1lido por 15 minutos.",
        y6: "Puede tardar unos segundos en llegar y ser\xe1 v\xe1lido por 10 minutos.",
        y7: function(n) {
            return "Ingresa el c\xf3digo que acabamos de enviar a " + n;
        },
        y8: function(n) {
            return "Ingresa el c\xf3digo que acabamos de enviar por texto a " + n;
        },
        y9: function(n) {
            return "Se ha enviado un correo electr\xf3nico con un c\xf3digo a " + n + ". Por favor, ingresa el c\xf3digo dentro de los pr\xf3ximos 15 minutos.";
        },
        za: function(n) {
            return "Se ha enviado un mensaje de texto con un c\xf3digo a " + n + ". Por favor, ingresa el c\xf3digo dentro de los pr\xf3ximos 10 minutos.";
        },
        zb: "Si tenemos una cuenta que coincide con tu correo electr\xf3nico, recibir\xe1s un correo con el c\xf3digo. Si no recibes un correo",
        zc: "Si tenemos una cuenta que coincide con tu n\xfamero de tel\xe9fono, recibir\xe1s un texto con el c\xf3digo. Si no recibes un texto",
        zg: function(n) {
            return "Ir al sitio web de " + n;
        },
        Y: {
            n$: "IMC",
            qc: "Diast\xf3lica (mmHg)",
            B2: "Per\xedmetro cef\xe1lico (pulg)",
            B3: "Per\xedmetro cef\xe1lico (cm)",
            B5: "Altura (pulg)",
            B6: "Altura (cm)",
            EV: "Pulso (ppm)",
            xa: "Frecuencia Respiratoria (ppm)",
            xY: "SpO2 (%)",
            yn: "Sist\xf3lica (mmHg)",
            F8: "Temp (\xb0F)",
            F9: "Temp (\xb0C)",
            GF: "Peso (libras)",
            GG: "Peso (kg)",
            GI: "Cu\xe1ndo"
        },
        t: {
            m3: "\xa1Te has unido a la lista de espera!",
            m4: "Te notificaremos cuando haya un lugar disponible con",
            nH: "Lleno - Unirse a lista de espera",
            qO: "Correo electr\xf3nico",
            qP: "maria@ejemplo.com",
            q3: "# Personas a inscribir",
            rB: "Nombre",
            rC: "Mar\xeda",
            sy: "Completa tu registro a continuaci\xf3n para unirte a",
            sz: "\xa1Has sido invitado de la lista de espera!",
            CJ: "Unirse a la lista de espera",
            sP: "Uni\xe9ndose a la",
            sQ: "lista de espera...",
            sW: "Apellido",
            sX: "Garc\xeda",
            vd: "\xdanete a la lista de espera",
            vP: "Tel\xe9fono",
            wr: "Proveedor",
            xm: "Selecciona un proveedor",
            yf: "Algo sali\xf3 mal. Por favor, int\xe9ntalo de nuevo.",
            yl: "Te contactaremos cuando haya un lugar disponible con",
            eg: "\xa1Est\xe1s en la lista de espera!"
        },
        zo: function(n) {
            return "Bienvenido a " + n;
        },
        zt: "Si",
        zy: "Tus datos de contacto",
        zz: "Tu Email"
    }), Vx = F2(function(n, r) {
        return r(n ? Dx : _x);
    }), Bx = F2(function(n, r) {
        return A2(dr, n, tx(r));
    }), Gx = Bx("className"), zx = cr("div"), Sx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Tx = Sx(3), Px = wr, Zx = function(n) {
        if (1 === n.$) {
            var r = n.a;
            return A2(Fu, Px(Cu), r);
        }
        switch(n.a){
            case 0:
                return w([
                    Gx("spinner--xs")
                ]);
            case 1:
                return w([
                    Gx("spinner--sm")
                ]);
            case 3:
                return w([
                    Gx("spinner--lg")
                ]);
            default:
                return g;
        }
    }, Mx = cr("span"), Lx = function(n) {
        return A2(Mx, A2(Qt, Gx("spinner"), A2(bc, Zx, n)), w([
            A2(Mx, w([
                Gx("spinner__dot")
            ]), g),
            A2(Mx, w([
                Gx("spinner__dot")
            ]), g),
            A2(Mx, w([
                Gx("spinner__dot")
            ]), g),
            A2(Mx, w([
                Gx("spinner__dot")
            ]), g)
        ]));
    }, Nx = w([
        A2(zx, w([
            Gx("flex justify-center")
        ]), w([
            Lx(w([
                Tx
            ]))
        ]))
    ]), Hx = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ix = cr("h2"), Ox = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Qx = Ox(3), Rx = function(n) {
        switch(n){
            case 4:
                return "text-2xl sm:text-4xl";
            case 3:
                return "text-l";
            case 2:
                return "text-base";
            case 1:
                return "text-sm";
            default:
                return "text-xs";
        }
    }, Ux = function(n) {
        switch(n){
            case 0:
                return "";
            case 1:
                return "sm:";
            case 2:
                return "md:";
            case 3:
                return "lg:";
            default:
                return "xl:";
        }
    }, Kx = F2(function(n, r) {
        return w([
            Gx($(Ux(n), Rx(r)))
        ]);
    }), Wx = function(n) {
        switch(n){
            case 0:
                return "start";
            case 1:
                return "center";
            case 2:
                return "end";
            default:
                return "between";
        }
    }, Xx = function(n) {
        switch(n.$){
            case 0:
                var r = function(n) {
                    return "text-" + n;
                };
                switch(n.a){
                    case 0:
                        return r("left");
                    case 1:
                        return r("center");
                    case 2:
                        return r("right");
                    default:
                        return r("between");
                }
            case 2:
                return "justify-" + Wx(n.a);
            case 1:
                return "items-" + Wx(n.a);
            default:
                return "self-" + Wx(n.a);
        }
    }, Yx = function(n) {
        return w([
            Gx(Xx(n))
        ]);
    }, Jx = function(n) {
        var r = n.a, t = function(n) {
            if (1 === n.$) return "0";
            switch(n.a){
                case 0:
                    return "1";
                case 1:
                    return "2";
                case 2:
                    return "4";
                case 3:
                    return "8";
                default:
                    return "12";
            }
        }(n.b), e = function(n) {
            switch(n.$){
                case 0:
                    switch(n.a){
                        case 0:
                            return "t";
                        case 1:
                            return "r";
                        case 3:
                            return "b";
                        default:
                            return "l";
                    }
                case 2:
                    return "x";
                case 1:
                    return "y";
                default:
                    return "";
            }
        }(r);
        return A2(fe, "-", w([
            "m" + e,
            t
        ]));
    }, n_ = function(n) {
        return w([
            Gx(Jx(n))
        ]);
    }, r_ = F2(function(n, r) {
        return w([
            Gx($(Ux(n), Xx(r)))
        ]);
    }), t_ = F2(function(n, r) {
        return w([
            Gx($(Ux(n), Jx(r)))
        ]);
    }), e_ = function(n) {
        switch(n){
            case 0:
                return "font-thin";
            case 1:
                return "font-normal";
            case 2:
                return "font-medium";
            case 3:
                return "font-semibold";
            case 4:
                return "font-bold";
            default:
                return "font-extrabold";
        }
    }, u_ = function(n) {
        n: for(;;)switch(n.$){
            case 9:
                var r = n.a;
                if (r.a) {
                    n = r.b;
                    continue n;
                }
                return g;
            case 1:
                switch(n.a){
                    case 2:
                        return w([
                            Gx("text-danger")
                        ]);
                    case 0:
                        return w([
                            Gx("text-success")
                        ]);
                    case 3:
                        return w([
                            Gx("text-warning")
                        ]);
                    case 1:
                        return w([
                            Gx("text-support")
                        ]);
                    case 4:
                        return w([
                            Gx("text-primary")
                        ]);
                    case 5:
                        return w([
                            Gx("text-primary-500")
                        ]);
                    default:
                        return w([
                            Gx("text-light-gray")
                        ]);
                }
            case 0:
                return w([
                    Gx(Rx(n.a))
                ]);
            case 2:
                return w([
                    Gx(e_(n.a))
                ]);
            case 4:
                return w(n.a ? [
                    Gx("line-through")
                ] : [
                    Gx("underline")
                ]);
            case 5:
                return n_(n.a);
            case 6:
                return A2(t_, n.a, n.b);
            case 7:
                return $(Yx(t = n.a), t.$ ? w([
                    Gx("flex")
                ]) : g);
            case 8:
                var t;
                return A2(r_, n.a, t = n.b);
            case 3:
                return n.a;
            default:
                return A2(Kx, n.a, n.b);
        }
    }, a_ = function(n) {
        return A2(Fu, Px(Cu), vc(A2(Fu, u_, n)));
    }, i_ = F2(function(n, r) {
        return A2(Ix, a_(A2(Qt, Qx, A2(Qt, Hx(w([
            Gx("text-primary-300")
        ])), n))), r);
    }), c_ = fr, o_ = cr("p"), f_ = F2(function(n, r) {
        return A2(o_, a_(n), A2(Fu, c_(Cu), r));
    }), s_ = A2(cr("hr"), w([
        Gx("horizontal-rule")
    ]), g), l_ = A2(zx, w([
        Gx("panel w-full")
    ]), w([
        A2(i_, g, w([
            _d("Page Not Found")
        ])),
        s_,
        A2(f_, g, w([
            A2(f_, g, w([
                _d("This page doesn't exist anymore. Please check your URL for typos.")
            ])),
            A2(f_, g, w([
                _d("Feel free to contact us to let us know about any broken links.")
            ]))
        ]))
    ])), d_ = function(n) {
        return {
            Cl: F2(function(r, t) {
                var e = v(r.dV, Kw(r.g0));
                switch(e.a.$){
                    case 3:
                        return e.b ? b(Ow(t), Qp, g) : A2(dx, Rw, A2(Ww, g, A3(n.Cl, e.a.a, r, t)));
                    case 1:
                    case 0:
                        return b(Ow(t), Qp, g);
                    default:
                        return b(Qw, Qp, g);
                }
            }),
            CQ: F2(function(r, t) {
                var e = v(r.dV, t);
                n: for(; !e.b.$;)switch(e.a.$){
                    case 3:
                        var u = e.a.a, a = e.b.a;
                        if (Kw(r.g0)) return v(Ow(a), Qp);
                        var c = A3(n.Cl, u, r, a), o = c.b;
                        return v(Rw(c.a), Uu(w([
                            o,
                            sx(u)
                        ])));
                    case 2:
                        return v(Qw, Qp);
                    default:
                        break n;
                }
                if (1 === t.$) {
                    var f = t.a;
                    return A2(lx, Rw, A2(n.CQ, r, m(f, {
                        ld: i(r.ld, f.ld) ? f.ld : r.ld
                    })));
                }
                return v(t, Qp);
            }),
            Fj: F2(function(r, t) {
                return 1 === r.$ ? A2(n.Fj, r.a, t) : t;
            }),
            F4: function(r) {
                return 1 === r.$ ? n.F4(r.a) : bx;
            },
            Gv: F2(function(r, t) {
                return 1 === t.$ ? A2(dx, Rw, A2(n.Gv, r, t.a)) : b(t, Qp, g);
            }),
            GB: function(r) {
                switch(r.$){
                    case 1:
                        var t = r.a;
                        return A2(n.GB, Vx(t.ld), t);
                    case 2:
                        return {
                            g8: w([
                                l_
                            ]),
                            yx: "404"
                        };
                    default:
                        return {
                            g8: Nx,
                            yx: "Loading..."
                        };
                }
            }
        };
    }, v_ = function(n) {
        return 1 === n.a.j.$;
    }, b_ = function(n) {
        return !n.a.j.$;
    }, m_ = Xn("pushUrl", tx), p_ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), $_ = function(n) {
        return encodeURIComponent(n);
    }, g_ = F2(function(n, r) {
        return A2(p_, $_(n), $_(r));
    }), h_ = function(n) {
        return n.a + "=" + n.b;
    }, y_ = function(n) {
        return n.b ? "?" + A2(fe, "&", A2(Fu, h_, n)) : "";
    }, w_ = S, x_ = function(n) {
        var r = function() {
            switch(n.$){
                case 0:
                    return g;
                case 1:
                    return w([
                        "enroll-thanks"
                    ]);
                case 2:
                    return w([
                        "not-found"
                    ]);
                case 3:
                    return w([
                        "patient-documents"
                    ]);
                case 4:
                    return w([
                        "thanks"
                    ]);
                case 5:
                    return w([
                        "waitlist"
                    ]);
                case 6:
                    return w([
                        "account"
                    ]);
                case 7:
                    return w([
                        "booking"
                    ]);
                case 8:
                    return w([
                        "checkout"
                    ]);
                case 9:
                    return w([
                        "enroll"
                    ]);
                case 10:
                    return w([
                        "signup"
                    ]);
                case 11:
                    return w([
                        "style-guide"
                    ]);
                case 12:
                    return w([
                        "account",
                        "appointments"
                    ]);
                case 13:
                    return w([
                        "account",
                        "booking"
                    ]);
                case 14:
                    return w([
                        "account",
                        "cart"
                    ]);
                case 15:
                    return w([
                        "account",
                        "chat"
                    ]);
                case 16:
                    return w([
                        "account",
                        "documents"
                    ]);
                case 17:
                    return w([
                        "account",
                        "explore-services"
                    ]);
                case 18:
                    return w([
                        "account",
                        "forbidden"
                    ]);
                case 19:
                    return w([
                        "account",
                        "health-information"
                    ]);
                case 20:
                    return w([
                        "account",
                        "invoices"
                    ]);
                case 21:
                    return w([
                        "account",
                        "members"
                    ]);
                case 22:
                    return w([
                        "account",
                        "memberships"
                    ]);
                case 23:
                    return w([
                        "account",
                        "messaging"
                    ]);
                case 24:
                    return w([
                        "account",
                        "not-found"
                    ]);
                case 25:
                    return w([
                        "account",
                        "payment-sources"
                    ]);
                case 26:
                    return w([
                        "account",
                        "practitioner-location"
                    ]);
                case 27:
                    return w([
                        "account",
                        "session-expired"
                    ]);
                case 28:
                    return w([
                        "booking",
                        "empty"
                    ]);
                case 29:
                    return w([
                        "login",
                        "request"
                    ]);
                case 30:
                    return w([
                        "login",
                        "select-patient"
                    ]);
                case 31:
                    return w([
                        "login",
                        "verify-code"
                    ]);
                case 32:
                    return w([
                        "style-guide",
                        "action-menu"
                    ]);
                case 33:
                    return w([
                        "style-guide",
                        "activity-indicator"
                    ]);
                case 34:
                    return w([
                        "style-guide",
                        "address-input"
                    ]);
                case 35:
                    return w([
                        "style-guide",
                        "alerts"
                    ]);
                case 36:
                    return w([
                        "style-guide",
                        "api-select"
                    ]);
                case 37:
                    return w([
                        "style-guide",
                        "button"
                    ]);
                case 38:
                    return w([
                        "style-guide",
                        "card"
                    ]);
                case 39:
                    return w([
                        "style-guide",
                        "card-example"
                    ]);
                case 40:
                    return w([
                        "style-guide",
                        "cart-icon"
                    ]);
                case 41:
                    return w([
                        "style-guide",
                        "checkbox"
                    ]);
                case 42:
                    return w([
                        "style-guide",
                        "code-sent-confirmation"
                    ]);
                case 43:
                    return w([
                        "style-guide",
                        "filter-example"
                    ]);
                case 44:
                    return w([
                        "style-guide",
                        "form-example"
                    ]);
                case 45:
                    return w([
                        "style-guide",
                        "grid"
                    ]);
                case 46:
                    return w([
                        "style-guide",
                        "input"
                    ]);
                case 47:
                    return w([
                        "style-guide",
                        "insurance-info"
                    ]);
                case 48:
                    return w([
                        "style-guide",
                        "modal"
                    ]);
                case 49:
                    return w([
                        "style-guide",
                        "multi-form"
                    ]);
                case 50:
                    return w([
                        "style-guide",
                        "phone-input"
                    ]);
                case 51:
                    return w([
                        "style-guide",
                        "radio"
                    ]);
                case 52:
                    return w([
                        "style-guide",
                        "searchable-select"
                    ]);
                case 53:
                    return w([
                        "style-guide",
                        "segmented-control"
                    ]);
                case 54:
                    return w([
                        "style-guide",
                        "select"
                    ]);
                case 55:
                    return w([
                        "style-guide",
                        "table"
                    ]);
                case 56:
                    return w([
                        "style-guide",
                        "tabs"
                    ]);
                case 57:
                    return w([
                        "style-guide",
                        "tag"
                    ]);
                case 58:
                    return w([
                        "style-guide",
                        "title-band"
                    ]);
                case 59:
                    return w([
                        "style-guide",
                        "toggle"
                    ]);
                case 60:
                    return w([
                        "style-guide",
                        "tooltip"
                    ]);
                case 61:
                    return w([
                        "style-guide",
                        "typography"
                    ]);
                case 62:
                    return w([
                        "account",
                        n.a.yI
                    ]);
                case 63:
                    return w([
                        "bills",
                        n.a.yI
                    ]);
                case 64:
                    return w([
                        "checkout",
                        n.a.xQ
                    ]);
                case 65:
                    return w([
                        "signup",
                        n.a.xQ
                    ]);
                case 66:
                    return w([
                        "account",
                        "cart",
                        "confirm-pay"
                    ]);
                case 67:
                    return w([
                        "account",
                        "cart",
                        "confirmation"
                    ]);
                case 68:
                    return w([
                        "account",
                        "messaging",
                        "chat"
                    ]);
                case 69:
                    return w([
                        "appointments",
                        n.a.z1,
                        "cancellation-policy"
                    ]);
                case 70:
                    return w([
                        "signup",
                        n.a.xQ,
                        "additional-details"
                    ]);
                case 71:
                    return w([
                        "signup",
                        n.a.xQ,
                        "confirmation"
                    ]);
                case 72:
                    return w([
                        "signup",
                        n.a.xQ,
                        "contacts"
                    ]);
                case 73:
                    return w([
                        "signup",
                        n.a.xQ,
                        "custom-details"
                    ]);
                case 74:
                    return w([
                        "signup",
                        n.a.xQ,
                        "location"
                    ]);
                case 75:
                    return w([
                        "signup",
                        n.a.xQ,
                        "members"
                    ]);
                case 76:
                    return w([
                        "signup",
                        n.a.xQ,
                        "membership"
                    ]);
                case 77:
                    return w([
                        "signup",
                        n.a.xQ,
                        "provider"
                    ]);
                case 78:
                    return w([
                        "signup",
                        n.a.xQ,
                        "thanks"
                    ]);
                case 79:
                    return w([
                        "account",
                        "appointments",
                        n.a.z1
                    ]);
                case 80:
                    return w([
                        "account",
                        "health-information",
                        n.a.sl
                    ]);
                case 81:
                    return w([
                        "account",
                        "invoices",
                        n.a.sl
                    ]);
                case 82:
                    return w([
                        "account",
                        "members",
                        n.a.sl
                    ]);
                case 83:
                    return w([
                        "account",
                        "memberships",
                        n.a.sl
                    ]);
                case 84:
                    return w([
                        "account",
                        "packages",
                        n.a.sl
                    ]);
                case 85:
                    return w([
                        "account",
                        "payment-sources",
                        n.a.sl
                    ]);
                case 86:
                    return w([
                        "account",
                        "appointments",
                        n.a.z1,
                        "cancel"
                    ]);
                case 87:
                    return w([
                        "account",
                        "appointments",
                        n.a.z1,
                        "cancel-appointment"
                    ]);
                case 88:
                    return w([
                        "account",
                        "appointments",
                        n.a.z1,
                        "reschedule"
                    ]);
                case 89:
                    return w([
                        "account",
                        "invoices",
                        n.a.sl,
                        "payment"
                    ]);
                case 90:
                    return w([
                        "account",
                        "members",
                        n.a.sl,
                        "edit"
                    ]);
                case 91:
                    return w([
                        "account",
                        "members",
                        n.a.sl,
                        "emergency-contact"
                    ]);
                case 92:
                    return w([
                        "account",
                        "memberships",
                        n.a.sl,
                        "add-member"
                    ]);
                case 93:
                    return w([
                        "account",
                        "memberships",
                        n.a.sl,
                        "renew"
                    ]);
                case 94:
                    return w([
                        "account",
                        "packages",
                        n.a.sl,
                        "checkout"
                    ]);
                case 95:
                    return w([
                        "account",
                        "payment-sources",
                        n.a.sl,
                        "edit"
                    ]);
                case 96:
                    return w([
                        "account",
                        "plans",
                        n.a.sl,
                        "checkout"
                    ]);
                case 97:
                    return w([
                        "booking",
                        n.a.nv,
                        "location",
                        n.a.n3,
                        "date"
                    ]);
                case 98:
                    return w([
                        "booking",
                        n.a.nv,
                        "location",
                        n.a.n3,
                        "enter-info"
                    ]);
                case 99:
                    return w([
                        "account",
                        "booking",
                        n.a.nv,
                        "location",
                        n.a.n3,
                        "date"
                    ]);
                default:
                    return w([
                        "account",
                        "booking",
                        n.a.nv,
                        "location",
                        n.a.n3,
                        "enter-info"
                    ]);
            }
        }();
        return A2(w_, "/", A2(fe, "/", r));
    }, __ = F2(function(n, r) {
        var t = y_(A2(Fu, function(n) {
            return A2(g_, n.a, n.b);
        }, Ut(n)));
        return m_($(x_(r), t));
    }), C_ = function(n) {
        var r = function(n) {
            var r, t = Ut(A2(xc, pa, A2(Op, t$, n.EX.jb))), e = (r = n.EX.jb).$ ? n.EX.Ev : n.EX.Ev + "?" + r.a;
            return A2(__, ed(A2(Qt, v("redirectTo", e), t)), mi);
        }, t = function(n) {
            return b_(n) && !v_(n);
        }, e = d_(n);
        return m(e, {
            Cl: F2(function(n, u) {
                var a = v(n.dV, Kw(n.g0));
                return 3 !== a.a.$ || a.b || t(n.g0) ? A2(e.Cl, n, u) : b(Ow(u), r(u), g);
            }),
            CQ: F2(function(n, u) {
                var a = v(n.dV, u);
                if (3 !== a.a.$ || a.b.$) return A2(e.CQ, n, u);
                var i = a.b.a;
                return Kw(n.g0) || 2 === n.g0.a.j.$ || t(n.g0) ? A2(e.CQ, n, u) : v(Ow(i), r(i));
            })
        });
    }, A_ = {
        $: 1
    }, k_ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, E_ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, q_ = F3(function(n, r, t) {
        var e = t;
        switch(n){
            case 0:
                return A3(q_, 1, 12 * r, e);
            case 1:
                var u = Ub(e), a = 12 * (u.zq - 1) + (Pb(u.un) - 1) + r, i = Lb(A2(Qc, 12, a) + 1), c = A2(Hb, a, 12) + 1;
                return Ib(c) + A2(Ap, c, i) + A2(dm, u.pW, A2(Mb, c, i));
            case 2:
                return e + 7 * r;
            default:
                return e + r;
        }
    }), F_ = function(n) {
        return n.a.j;
    }, j_ = function(n) {
        if (n.$) return Ot;
        var r = n.a;
        return P$(r) ? L$(A2(z$, A2(Iu, "sub", M$), r)) : Ot;
    }, D_ = function(n) {
        return j_(F_(n));
    }, V_ = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), B_ = {
        $: 1
    }, G_ = {
        $: 8
    }, z_ = {
        $: 4
    }, S_ = {
        $: 3
    }, T_ = {
        $: 9
    }, P_ = {
        $: 2
    }, Z_ = {
        $: 0
    }, M_ = F2(function(n, r) {
        return A3(qu, Iu, r, n);
    }), L_ = F3(function(n, r, t) {
        return {
            $: 6,
            a: n,
            b: r,
            c: t
        };
    }), N_ = F3(function(n, r, t) {
        return A2(fe, r, A2(se, n, t));
    }), H_ = function(n) {
        switch(n.$){
            case 0:
                return qe(n);
            case 1:
                var r = n.b;
                return oe(n.a) + " -> " + H_(r);
            case 2:
                return A2(fe, "\n", A2(Fu, H_, n.a));
            default:
                var t = n.a;
                return t + "\n" + A3(N_, t, "", A3(N_, "  ", "", A3(N_, "\n", "", A3(N_, "Problem with the given value:", "", qe(n)))));
        }
    }, I_ = F3(function(n, r, t) {
        return Yt(A3(L_, H_(t), n, r));
    }), O_ = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Q_ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, R_ = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), U_ = {
        $: 2
    }, K_ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, W_ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, X_ = {
        $: 1
    }, Y_ = function(n) {
        return !n.$;
    }, J_ = Ln, nC = F2(function(n, r) {
        return A3(Pt, "", cu, A2(tu, r, n));
    }), rC = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tC = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), eC = function(n) {
        if (n.$) return rC(n.a);
        var r = n.a;
        return A2(tC, r.a, r.b);
    }, uC = function(n) {
        return Q$(w([
            A2(eu, It, n),
            au(Ot)
        ]));
    }, aC = F3(function(n, r, t) {
        return A2(nC, A2(tu, eC, r), function(r) {
            switch(r.$){
                case 0:
                    return Yt(B_);
                case 1:
                    return Yt(P_);
                case 2:
                    return Yt(S_);
                case 3:
                    var e = r.b;
                    switch((i = r.a).F_){
                        case 401:
                            return Yt(Z_);
                        case 403:
                            return Yt(G_);
                        case 404:
                            return Yt(T_);
                        case 500:
                        case 504:
                            return function(n) {
                                var r = A2(i$, A2(M_, w([
                                    "message"
                                ]), M$), n);
                                return Yt({
                                    $: 7,
                                    a: L$(r)
                                });
                            }(e);
                        case 502:
                            return Yt(z_);
                        default:
                            var u = Q$(w([
                                A2(M_, w([
                                    "error"
                                ]), uC(M$)),
                                A2(M_, w([
                                    "message"
                                ]), uC(M$))
                            ])), a = A2(i$, u, e);
                            return a.$ ? A3(I_, n, i, a.a) : Yt(A2(V_, i.F_, A2(xc, "", a.a)));
                    }
                default:
                    var i = r.a, c = mu(e = r.b) ? "{}" : e, o = A2(i$, t, c);
                    return o.$ ? A3(I_, n, i, o.a) : te(v(o.a, i.h3));
            }
        });
    }), iC = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), cC = iC, oC = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fC = F2(function(n, r) {
        return {
            wX: n,
            yh: r
        };
    }), sC = Au(A2(fC, pa, g)), lC = function(n) {
        return Cn(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(xn(0));
        });
    }, dC = Fn, vC = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var a = e.a;
                    return A2(ju, function(r) {
                        var e = a.Gp;
                        return A3(vC, n, u, 1 === e.$ ? t : A3(ia, e.a, r, t));
                    }, dC(A3(St, n, Gu(n), a)));
                }
                var i = e.a, c = A2(ra, i, t);
                if (1 === c.$) {
                    r = u;
                    continue n;
                }
                return A2(ju, function() {
                    return A3(vC, n, u, A2(va, i, t));
                }, lC(c.a));
            }
            return Au(t);
        }
    }), bC = F4(function(n, r, t, e) {
        return A2(ju, function(n) {
            return Au(A2(fC, n, t));
        }, A3(vC, n, r, e.wX));
    }), mC = F4(function(n, r, t, e) {
        var u = e.b;
        return i(r, e.a) ? It(A2(Gu, n, u(t))) : Ot;
    }), pC = F3(function(n, r, t) {
        return A2(ju, function() {
            return Au(t);
        }, Bu(A2(n$, A3(mC, n, r.a, r.b), t.yh)));
    }), $C = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return oC({
                zV: t.zV,
                g8: t.g8,
                BF: A2(Zt, n, t.BF),
                h3: t.h3,
                Dd: t.Dd,
                Gg: t.Gg,
                Gp: t.Gp,
                yZ: t.yZ
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), gC = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), hC = F2(function(n, r) {
        return A2(gC, r.a, A2(tu, r.b, n));
    });
    Tn.Http = Pn(sC, bC, pC, $C, hC);
    var yC = Nn("Http"), wC = (Nn("Http"), function(n) {
        return yC(oC({
            zV: !1,
            g8: n.g8,
            BF: n.BF,
            h3: n.h3,
            Dd: n.Dd,
            Gg: n.Gg,
            Gp: n.Gp,
            yZ: n.yZ
        }));
    }), xC = {
        $: 0
    }, _C = function(n) {
        return A2(Nt, "application/json", A2(ce, 0, n));
    }, CC = F4(function(n, r, t, e) {
        for(;;){
            var u = A2(r(n), t, e), a = u.a, i = u.b;
            if (i.$) return v(a, i.a);
            n = i.a, e = a;
        }
    }), AC = F2(function(n, r) {
        return A2(CC, n, r);
    }), kC = function(n) {
        return {
            $: 1,
            a: n
        };
    }, EC = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qC = 63, FC = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, jC = function(n) {
        if (25 >= n) return FC(65 + n);
        if (51 >= n) return FC(n - 26 + 97);
        if (61 >= n) return FC(n - 52 + 48);
        switch(n){
            case 62:
                return "+";
            case 63:
                return "/";
            default:
                return "\0";
        }
    }, DC = F2(function(n, r) {
        var t = jC(n & qC), e = jC(n >>> 6 & qC), u = jC(n >>> 12 & qC), a = jC(n >>> 18);
        switch(r){
            case 0:
                return A2(tb, a, A2(tb, u, A2(tb, e, eb(t))));
            case 1:
                return A2(tb, a, A2(tb, u, A2(tb, e, "=")));
            case 2:
                return A2(tb, a, A2(tb, u, "=="));
            default:
                return "";
        }
    }), VC = F4(function(n, r, t, e) {
        var u = jC(t >>> 6 & qC), a = jC(t >>> 12 & qC), i = jC(t >>> 18), c = jC(t & qC), o = jC(n & qC), f = jC(n >>> 6 & qC), s = jC(n >>> 12 & qC), l = jC(n >>> 18), d = jC(r & qC), v = jC(r >>> 6 & qC), b = jC(r >>> 12 & qC), m = jC(r >>> 18);
        return A2(tb, i, A2(tb, a, A2(tb, u, A2(tb, c, A2(tb, m, A2(tb, b, A2(tb, v, A2(tb, d, A2(tb, l, A2(tb, s, A2(tb, f, A2(tb, o, e))))))))))));
    }), BC = F5(function(n, r, t, e, u) {
        return A4(VC, (65535 & r) << 8 | t >>> 24, (255 & n) << 16 | r >>> 16, n >>> 8, A4(VC, (255 & e) << 16 | u, e >>> 8, 16777215 & t, ""));
    }), GC = F6(function(n, r, t, e, u, a) {
        var i = r, c = t, o = e, f = u, s = a;
        return F2(function(r, t) {
            var e = A2(i, r, t), u = e.b, a = A2(c, r, e.a), l = a.b, d = A2(o, r, a.a), b = d.b, m = A2(f, r, d.a), p = m.b, $ = A2(s, r, m.a);
            return v($.a, A5(n, u, l, b, p, $.b));
        });
    }), zC = Bt(!1), SC = Gt(!1), TC = A6(GC, BC, SC, SC, SC, SC, zC), PC = F2(function(n, r) {
        var t = r;
        return F2(function(r, e) {
            var u = A2(t, r, e);
            return v(u.a, n(u.b));
        });
    }), ZC = F3(function(n, r, t) {
        var e = r, u = t;
        return F2(function(r, t) {
            var a = A2(e, r, t), i = a.b, c = A2(u, r, a.a);
            return v(c.a, A2(n, i, c.b));
        });
    }), MC = F4(function(n, r, t, e) {
        var u = r, a = t, i = e;
        return F2(function(r, t) {
            var e = A2(u, r, t), c = e.b, o = A2(a, r, e.a), f = o.b, s = A2(i, r, o.a);
            return v(s.a, A3(n, c, f, s.b));
        });
    }), LC = Vt, NC = function(n) {
        var r, t, e = n.jf, u = n.F2;
        return 18 > e ? 3 > e ? e ? 2 === e ? (t = F2(function(n, r) {
            return kC($(u, A2(DC, n << 16 | r << 8, 1)));
        }), A3(ZC, t, LC, LC)) : A2(PC, function(n) {
            return kC($(u, A2(DC, n << 16, 2)));
        }, LC) : (r = kC(u), F2(function(n, t) {
            return v(t, r);
        })) : A4(MC, t = F3(function(n, r, t) {
            return EC({
                jf: e - 3,
                F2: $(u, A2(DC, n << 16 | r << 8 | t, 0))
            });
        }), LC, LC, LC) : A2(PC, function(n) {
            return EC({
                jf: e - 18,
                F2: $(u, n)
            });
        }, TC);
    }, HC = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), IC = function(n) {
        var r, t, e;
        return r = h$(A2(HC, function(n) {
            for(var r = 0, t = 0; n.length > t; t++){
                var e = n.charCodeAt(t);
                r += 128 > e ? 1 : 2048 > e ? 2 : 55296 > e || e > 56319 ? 3 : (t++, 4);
            }
            return r;
        }(e = n), e)), A2(g$, (t = j$(r), A2(AC, {
            jf: t,
            F2: ""
        }, NC)), r);
    }, OC = function(n) {
        switch(n.$){
            case 0:
            case 4:
                return It(n.a);
            default:
                return Ot;
        }
    }, QC = function(n) {
        return n.a.bk;
    }, RC = F2(function(n, r) {
        return v(n, r);
    }), UC = Op(RC("Hint-Version")), KC = function(n) {
        return n.a.aN;
    }, WC = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(WC, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), XC = F2(function(n, r) {
        return A3(WC, ia, r, n);
    }), YC = F2(function(n, r) {
        return A2(XC, r.h3, function(n) {
            var r;
            return ed(A2(n$, cu, w([
                KC(n) ? (r = F_(n), A2(Op, function(n) {
                    return v("Authorization", n);
                }, function(n) {
                    return A2(Op, function(n) {
                        return P$(n) ? "Bearer " + n : "Basic " + A2(xc, "", IC(A3(N_, '"', "", n) + ":"));
                    }, OC(n));
                }(r))) : Ot,
                UC(QC(n)),
                n.$ ? Ot : It(v("Hint-Lang", nb(n.a.im)))
            ])));
        }(n));
    }), JC = function(n) {
        return n.a.bL;
    }, nA = F3(function(n, r, t) {
        return n + "/" + (A2(fe, "/", r) + y_(t));
    }), rA = g_("_b"), tA = F2(function(n, r) {
        return $(r.jb, function(n) {
            return w([
                rA(n.bV)
            ]);
        }(n));
    }), eA = F2(function(n, r) {
        var t = r.yy;
        if (n.$) return e = n.a, A3(nA, JC(n), t, A2(tA, e, r));
        var e = n.a;
        return A3(nA, JC(n), t, A2(tA, e, r));
    }), uA = F5(function(n, r, t, e, u) {
        var a, i = A2(YC, r, u);
        return wC({
            g8: (a = u, A2(xc, xC, A2(Op, _C, a.g8))),
            BF: A3(aC, i, e, t),
            h3: A2(Fu, function(n) {
                return A2(cC, n.a, n.b);
            }, Ut(i)),
            Dd: n,
            Gg: Ot,
            Gp: Ot,
            yZ: A2(eA, r, u)
        });
    }), aA = uA("get"), iA = F2(function(n, r) {
        return A2(p_, $_(n), oe(r));
    }), cA = {
        hA: 1,
        ii: 10,
        my: 0
    }, oA = {
        qZ: Ot,
        lo: Ot,
        lQ: cA
    }, fA = function(n) {
        return A2(g_, n.a, n.b);
    }, sA = function(n) {
        return A2(Fu, fA, Ut(n));
    }, lA = function(n) {
        return n.ii;
    }, dA = function(n) {
        return (n.hA - 1) * n.ii;
    }, vA = function(n) {
        return ed(w([
            v("offset", oe(dA(n))),
            v("limit", oe(lA(n)))
        ]));
    }, bA = A2(tu, vA, sA), mA = F2(function(n, r) {
        var t, e = r(oA), u = (t = e.lo).$ ? bA(e.lQ) : w([
            A2(iA, "limit", t.a),
            A2(iA, "offset", 0)
        ]);
        return vc(w([
            w([
                A2(g_, "startDate", n)
            ]),
            A2(xc, g, A2(Op, function(n) {
                return w([
                    A2(g_, "endDate", n)
                ]);
            }, e.qZ)),
            u
        ]));
    }), pA = F2(function(n, r) {
        return {
            z3: r,
            Gm: n
        };
    }), $A = uu(Me), gA = F7(function(n, r, t, e, u, a, i) {
        return {
            nu: u,
            n2: a,
            sl: n,
            wo: i,
            x$: r,
            mt: t,
            yx: e
        };
    }), hA = {
        $: 3
    }, yA = {
        $: 1
    }, wA = {
        $: 2
    }, xA = {
        $: 0
    }, _A = function(n) {
        switch(n){
            case "UNCONFIRMED":
                return xA;
            case "CONFIRMED":
                return yA;
            case "DECLINED":
                return wA;
            case "CANCELLED":
                return hA;
            default:
                return {
                    $: 4,
                    a: n
                };
        }
    }, CA = A2(eu, _A, M$), AA = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kA = A2(nu, function(n) {
        switch(n){
            case "in_person":
                return au(0);
            case "virtual":
                return au(1);
            default:
                return AA("Invalid meeting type");
        }
    }, M$), EA = F5(function(n, r, t, e, u) {
        return {
            m9: t,
            nn: u,
            sl: n,
            ur: r,
            yG: e
        };
    }), qA = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), FA = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jA = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), DA = function(n) {
        var r = n;
        return function(n) {
            var t = r(n);
            return 1 === t.$ ? A2($m, !1, t.b) : A3(gm, !1, t.b, t.c);
        };
    }, VA = function(n) {
        return function(r) {
            return A3(gm, !0, n, r);
        };
    }, BA = Ym, GA = A2(BA, F2(function(n) {
        return A2(xc, 0, $u(n));
    }), Mm(_e)), zA = A2(BA, F2(function(n) {
        return A2(xc, 0, $u(n));
    }), A2(Cm, A2(Cm, Am(0), Mm(_e)), Mm(_e))), SA = A2(BA, F2(function(n) {
        return A2(xc, 0, $u(n));
    }), A2(Cm, A2(Cm, A2(Cm, Am(0), Mm(_e)), Mm(_e)), Mm(_e))), TA = op(w([
        A2(Rm, A2(Cm, Am(cu), zm("-")), op(w([
            DA(A2(ym, VA, A2(up, FA, SA))),
            A2(Rm, A2(Rm, Am(qA), zA), op(w([
                A2(Rm, A2(Cm, Am(cu), zm("-")), zA),
                Am(1)
            ]))),
            A2(Rm, A2(Rm, A2(Cm, Am(jA), zm("W")), zA), op(w([
                A2(Rm, A2(Cm, Am(cu), zm("-")), GA),
                Am(1)
            ])))
        ]))),
        DA(A2(ym, VA, A2(Rm, A2(Rm, Am(qA), zA), op(w([
            zA,
            Am(1)
        ]))))),
        A2(up, FA, SA),
        A2(Rm, A2(Rm, A2(Cm, Am(jA), zm("W")), zA), op(w([
            GA,
            Am(1)
        ]))),
        Am(FA(1))
    ])), PA = F3(function(n, r, t) {
        return 1 > s(n, t) && 1 > s(t, r);
    }), ZA = F3(function(n, r, t) {
        return A3(PA, 1, 12, r) && A3(PA, 1, A2(Mb, n, Lb(r)), t) ? te(Ib(n) + A2(Ap, n, Lb(r)) + t) : Yt("Invalid calendar date (" + oe(n) + ", " + oe(r) + ", " + oe(t) + ")");
    }), MA = F2(function(n, r) {
        return A3(PA, 1, 365, r) || 366 === r && Zb(n) ? te(Ib(n) + r) : Yt("Invalid ordinal date (" + oe(n) + ", " + oe(r) + ")");
    }), LA = function(n) {
        return Ib(n) + 1;
    }, NA = F3(function(n, r, t) {
        var e, u;
        return A3(PA, 1, 7, t) && (A3(PA, 1, 52, r) || 53 === r && (4 === (u = am(LA(e = n))) || 3 === u && Zb(e))) ? te(im(n) + 7 * (r - 1) + t) : Yt("Invalid week date (" + oe(n) + ", " + oe(r) + ", " + oe(t) + ")");
    }), HA = function(n) {
        var r = n.a, t = n.b;
        switch(t.$){
            case 0:
                return A3(ZA, r, t.a, t.b);
            case 1:
                return A3(NA, r, t.a, t.b);
            default:
                return A2(MA, r, t.a);
        }
    }, IA = A2(BA, F2(function(n) {
        return A2(xc, 0, $u(n));
    }), A2(Cm, A2(Cm, A2(Cm, A2(Cm, A2(Cm, Am(0), op(w([
        Mm(function(n) {
            return "-" === n;
        }),
        Am(0)
    ]))), Mm(_e)), Mm(_e)), Mm(_e)), Mm(_e))), OA = function(n) {
        return n.$ ? Um(n.a) : Am(n.a);
    }, QA = A2(ym, A2(tu, HA, OA), A2(Rm, A2(Rm, Am(RC), IA), TA)), RA = A2(tu, $p(A2(Rm, Am(cu), A2(Cm, QA, A2(ym, OA, op(w([
        A2(up, te, fp),
        A2(up, wm(Yt("Expected a date only, not a date and time")), Mm(Le("T"))),
        Am(Yt("Expected a date only"))
    ])))))), b$(A2(tu, mb, A2(tu, Op(function(n) {
        var r = n.wg;
        return 12 === r.$ ? r.a : "Expected a date in ISO 8601 format";
    }), xc(""))))), UA = function(n) {
        return n.$ ? AA(n.a) : au(n.a);
    }, KA = A2(nu, A2(tu, RA, UA), M$), WA = ln, XA = function(n) {
        return {
            $: 5,
            c: n
        };
    }, YA = F3(function(n, r, t) {
        return A2(nu, function(e) {
            var u = A2(WA, n, e);
            if (u.$) return au(t);
            var a = u.a, i = A2(WA, Q$(w([
                r,
                XA(t)
            ])), a);
            return i.$ ? AA(qe(i.a)) : au(i.a);
        }, G$);
    }), JA = F4(function(n, r, t, e) {
        return A2($A, A3(YA, A2(Iu, n, G$), r, t), e);
    }), nk = F3(function(n, r, t) {
        return A2($A, A2(Iu, n, r), t);
    }), rk = A4(JA, "allow_online_booking", uC(ru), Ot, A4(JA, "today", uC(KA), Ot, A4(JA, "address", uC(M$), Ot, A3(nk, "name", M$, A3(nk, "id", M$, au(EA)))))), tk = A2($A, rk, au(cu)), ek = function(n) {
        return {
            $: 3,
            b: n
        };
    }, uk = A4(JA, "contact_info_for_cancellation", uC(M$), Ot, A4(JA, "latest_cancellation_notice_time_amount", uC(O$), Ot, A4(JA, "latest_cancellation_notice_time_format", uC(M$), Ot, A4(JA, "cancellation_policy", uC(M$), Ot, A4(JA, "booking_locations", uC(ek(tk)), Ot, A3(nk, "allow_instant_book", ru, A3(nk, "allow_non_member_to_book", ru, A3(nk, "meeting_type", kA, A3(nk, "duration", O$, A3(nk, "name", M$, A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    nk: a,
                                                    nm: u,
                                                    n4: i,
                                                    oc: c,
                                                    o6: s,
                                                    qF: t,
                                                    sl: n,
                                                    sY: f,
                                                    sZ: o,
                                                    tA: e,
                                                    ur: r
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), ak = A2($A, uk, au(cu)), ik = function(n) {
        return Q$(w([
            XA(Ot),
            A2(eu, It, n)
        ]));
    }, ck = F2(function(n, r) {
        return {
            ur: n,
            y1: r
        };
    }), ok = A3(nk, "user_id", M$, A3(nk, "name", M$, au(ck))), fk = A2($A, ok, au(cu)), sk = A3(nk, "provider", ik(fk), A3(nk, "booking_location", ik(tk), A3(nk, "appointment_type", ik(ak), A3(nk, "title", ik(M$), A3(nk, "status", CA, A3(nk, "start", ik(M$), A3(nk, "id", M$, au(gA)))))))), lk = A2($A, sk, au(cu)), dk = A3(nk, "data", ek(lk), A3(nk, "total", O$, au(pA))), vk = w([
        "v1",
        "member"
    ]), bk = F2(function(n, r) {
        return $(r, n);
    }), mk = function(n) {
        return A2(bk, w([
            n
        ]), vk);
    }, pk = function(n) {
        return {
            g8: Ot,
            h3: ed(w([
                v("Accept", "application/json, text/plain, */*")
            ])),
            jb: g,
            yy: n
        };
    }, $k = F2(function(n, r) {
        return m(r, {
            jb: $(r.jb, n)
        });
    }), gk = F5(function(n, r, t, e, u) {
        return A4(aA, n, dk, u, A2($k, A2(mA, t, e), pk(function(n) {
            return A2(bk, w([
                "appointments"
            ]), mk(n));
        }(r))));
    }), hk = _p("yyyy-MM-dd"), yk = function(n) {
        var r = D_(n.AD);
        if (r.$) return Qp;
        var t = r.a, e = A2(Ep, n.f9, n.bp), u = n.dp ? v(hk(A3(q_, 0, -1, e)), It(hk(e))) : v(hk(e), Ot), a = u.b;
        return A5(gk, n.AD, t, u.a, function(r) {
            return m(r, {
                qZ: a,
                lQ: n.lQ
            });
        }, E_);
    }, wk = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xk = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _k = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ck = function(n) {
        return rt(n, function(n) {
            var r = n.getBoundingClientRect(), t = Yr.pageXOffset, e = Yr.pageYOffset;
            return {
                xh: ut(),
                eo: {
                    mF: t,
                    bj: e,
                    cv: Xr.documentElement.clientWidth,
                    r8: Xr.documentElement.clientHeight
                },
                al: {
                    mF: t + r.left,
                    bj: e + r.top,
                    cv: r.width,
                    r8: r.height
                }
            };
        });
    }, Ak = function(n) {
        return rt(n, function(n) {
            return {
                xh: {
                    cv: n.scrollWidth,
                    r8: n.scrollHeight
                },
                eo: {
                    mF: n.scrollLeft,
                    bj: n.scrollTop,
                    cv: n.clientWidth,
                    r8: n.clientHeight
                }
            };
        });
    }, kk = F2(function(n, r) {
        return Uu(w([
            A2(jc, wk, Ck(n + "-" + r)),
            A2(jc, xk, Ck(n)),
            A2(jc, _k, Ak(n))
        ]));
    }), Ek = F2(function(n, r) {
        return v({
            cx: r,
            sl: n,
            iC: 0,
            kj: 0,
            kk: 0,
            kq: 0,
            kr: 0
        }, A2(kk, n, r));
    }), qk = function(n) {
        return n ? "past" : "upcoming";
    }, Fk = F3(function(n, r, t) {
        var e = A2(Ek, "appointments-tabs", qk(0)), u = {
            dp: 0,
            z3: A_,
            AD: r.AF.Ao,
            bp: r.bp,
            ld: r.ld,
            lQ: cA,
            dV: n,
            dg: e.a,
            f9: r.f9,
            yZ: t
        };
        return v(u, Uu(w([
            A2(Wp, k_, e.b),
            yk(u)
        ])));
    }), jk = F2(function(n, r) {
        return v(r, Qp);
    }), Dk = F2(function(n, r) {
        return m(r, {
            zK: It(10)
        });
    }), Vk = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Bk = {
        $: 20
    }, Gk = {
        $: 17
    }, zk = {
        $: 16
    }, Sk = {
        $: 14
    }, Tk = function(n) {
        return n.yT;
    }, Pk = Tk, Zk = function(n) {
        return function() {
            return n;
        };
    }, Mk = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Lk = function(n) {
        return A2(Mk, 1, n);
    }, Nk = function(n) {
        var r = function() {
            switch(n.$){
                case 7:
                    return A2(xc, Pk, A2(Op, Zk, r = n.a));
                case 5:
                    var r = n.b;
                    return 500 > n.a ? Zk(r) : Pk;
                case 6:
                    return Zk(n.a);
                default:
                    return Pk;
            }
        }();
        return Lk(r);
    }, Hk = {
        $: 4
    }, Ik = F2(function(n, r) {
        return n ? function(n) {
            if (2 !== n.$) return g;
            switch(n.a.$){
                case 6:
                    var r = n.a;
                    return w([
                        A3(Vk, r.a, r.b, r.c)
                    ]);
                case 9:
                    return w([
                        Hk
                    ]);
                default:
                    var t = n.a;
                    return w(4 === t.$ ? [
                        Bk,
                        Nk(t)
                    ] : [
                        Nk(t)
                    ]);
            }
        }(r) : function(n) {
            if (2 !== n.$) return g;
            switch(n.a.$){
                case 6:
                    var r = n.a;
                    return w([
                        A3(Vk, r.a, r.b, r.c),
                        zk
                    ]);
                case 0:
                    return w([
                        Sk
                    ]);
                case 8:
                    return w([
                        Gk
                    ]);
                case 9:
                    return w([
                        zk
                    ]);
                default:
                    var t = n.a;
                    return w(4 === t.$ ? [
                        Bk,
                        Nk(t)
                    ] : [
                        Nk(t)
                    ]);
            }
        }(r);
    }), Ok = F2(function(n, r) {
        return m(r, {
            hA: n
        });
    }), Qk = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 2:
                return b((e = n.a).$ ? r : m(t, {
                    kk: e.a.eo.mF
                }), Qp, Ot);
            case 1:
                return b((e = n.a).$ ? r : m(t, {
                    kj: (u = e.a.al).mF
                }), Qp, Ot);
            case 0:
                var e, u;
                return (e = n.a).$ ? b(r, Qp, Ot) : b(m(t, {
                    kq: (u = e.a.al).mF,
                    kr: u.cv
                }), Qp, It({
                    $: 1,
                    a: t.cx
                }));
            case 3:
                var a = n.a, i = a.a, c = a.b.yB;
                return b(m(t, {
                    cx: c(i)
                }), A2(kk, t.sl, c(i)), It({
                    $: 0,
                    a: i
                }));
            case 4:
                return b(r, A2(kk, t.sl, t.cx), Ot);
            default:
                return b(r, Qp, Ot);
        }
    }), Rk = F2(function(n, r) {
        return m(r, {
            my: n
        });
    }), Uk = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? b(m(r, {
                    z3: t,
                    lQ: A2(Rk, t.a.Gm, r.lQ)
                }), Qp, g) : b(m(r, {
                    z3: t
                }), Qp, A2(Ik, 0, t));
            case 1:
                var e = A2(Qk, n.a, r.dg), u = e.a, a = e.b, i = e.c;
                return i.$ || i.a.$ ? b(m(r, {
                    dg: u
                }), A2(Wp, k_, a), g) : b(c = m(r, {
                    dp: i.a.a,
                    z3: A_,
                    lQ: cA,
                    dg: u
                }), Uu(w([
                    A2(Wp, k_, a),
                    yk(c)
                ])), g);
            case 2:
                var c;
                return b(c = m(r, {
                    lQ: A2(Ok, n.a, r.lQ)
                }), yk(c), g);
            case 3:
                var o = n.a, f = n.b, s = f.$ ? pa : ed(w([
                    v("start", f.a)
                ]));
                return b(r, A2(__, s, ha({
                    z1: o
                })), g);
            default:
                return b(r, A2(__, pa, _a), g);
        }
    }), Kk = F2(function(n, r) {
        return A2(zx, a_(n), r);
    }), Wk = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), Xk = F2(function(n, r) {
        return A2(Wk, function(r) {
            return i(r, n);
        }, r);
    }), Yk = F2(function(n, r) {
        return A2(Xk, n, r.b.rs);
    }), Jk = function(n) {
        return A2(Yk, "patient_portal_polish", n);
    }, nE = function(n) {
        return !n.b;
    }, rE = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tE = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), eE = A2(tE, rE(3), It(3)), uE = function(n) {
        return {
            $: 5,
            a: n
        };
    }, aE = function(n) {
        return w([
            A2(i_, w([
                uE(eE)
            ]), w([
                _d(n)
            ]))
        ]);
    }, iE = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), cE = function(n) {
        return {
            $: 6,
            a: n
        };
    }, oE = function(n) {
        return n.nu;
    }, fE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sE = fE(4), lE = F2(function(n, r) {
        return v(n, r);
    }), dE = F2(function(n, r) {
        return {
            $: 9,
            a: v(n, r)
        };
    }), vE = _d(""), bE = F2(function(n, r) {
        return n ? r : vE;
    }), mE = function(n) {
        return n.sl;
    }, pE = function(n) {
        return i(n, hA);
    }, $E = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gE = $E(1), hE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, yE = hE(1), wE = function(n) {
        return {
            $: 1,
            a: n
        };
    }, xE = wE(6), _E = {
        $: 11
    }, CE = function(n) {
        return n.ur;
    }, AE = function(n) {
        return n.ur;
    }, kE = sr, EE = F2(function(n, r) {
        return A2(kE, n, {
            $: 0,
            a: r
        });
    }), qE = function(n) {
        return A2(EE, "click", au(n));
    }, FE = F2(function(n, r) {
        return 1 === r.$ ? n : r;
    }), jE = function(n) {
        return n.wo;
    }, DE = function(n) {
        switch(n.$){
            case 0:
                return n.a;
            case 4:
                return n_(n.a);
            case 5:
                return A2(t_, r = n.a, n.b);
            case 6:
                return Yx(n.a);
            case 7:
                return A2(r_, r = n.a, n.b);
            case 2:
                return w([
                    Gx("md:flex-1")
                ]);
            case 3:
                return w([
                    Gx("md:w-auto")
                ]);
            case 1:
                var r = n.a, t = n.b, e = "w-" + (12 === t ? "full" : oe(t) + "/12");
                return w([
                    Gx($(Ux(r), e))
                ]);
            case 8:
                return w([
                    Gx("card")
                ]);
            case 11:
                return w([
                    Gx("card list-row")
                ]);
            case 9:
                return w([
                    Gx("card--success")
                ]);
            case 10:
                return w([
                    Gx("card--warning")
                ]);
            default:
                return w([
                    Gx("bg-primary-100")
                ]);
        }
    }, VE = function(n) {
        var r = n.a, t = n.b;
        return A2(zx, A2(Qt, Gx("column"), function(n) {
            return A2(Fu, Px(Cu), A2(bc, DE, n));
        }(r)), t);
    }, BE = F2(function(n, r) {
        return A2(zx, A2(Qt, Gx("row"), function(n) {
            return A2(Fu, Px(Cu), A2(bc, DE, n));
        }(n)), A2(Fu, VE, r));
    }), GE = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zE = GE(1), SE = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), TE = function(n) {
        return A2(SE, 0, n);
    }, PE = F2(function(n, r) {
        return A2(Mx, a_(n), A2(Fu, c_(Cu), r));
    }), ZE = function(n) {
        return n.x$;
    }, ME = function(n) {
        return n.mt;
    }, LE = {
        $: 4,
        a: 1
    }, NE = wE(7), HE = vr("class"), IE = F2(function(n, r) {
        return A2(vr, function(n) {
            return mr.test(n) ? "data-" + n : n;
        }(n), hr(r));
    }), OE = F2(function(n, r) {
        return A2(ir, n, gr(r));
    })("http://www.w3.org/2000/svg"), QE = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 17 16"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M11.8333 14.6673V12.6673H9.83333V11.334H11.8333V9.33398H13.1667V11.334H15.1667V12.6673H13.1667V14.6673H11.8333ZM3.83333 13.334C3.46667 13.334 3.15278 13.2034 2.89167 12.9423C2.63056 12.6812 2.5 12.3673 2.5 12.0007V4.00065C2.5 3.63398 2.63056 3.3201 2.89167 3.05898C3.15278 2.79787 3.46667 2.66732 3.83333 2.66732H4.5V1.33398H5.83333V2.66732H9.83333V1.33398H11.1667V2.66732H11.8333C12.2 2.66732 12.5139 2.79787 12.775 3.05898C13.0361 3.3201 13.1667 3.63398 13.1667 4.00065V8.06732C12.9444 8.03398 12.7222 8.01732 12.5 8.01732C12.2778 8.01732 12.0556 8.03398 11.8333 8.06732V6.66732H3.83333V12.0007H8.5C8.5 12.2229 8.51667 12.4451 8.55 12.6673C8.58333 12.8895 8.64444 13.1118 8.73333 13.334H3.83333ZM3.83333 5.33398H11.8333V4.00065H3.83333V5.33398Z")
            ]), g)
        ]));
    }, RE = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 12 14"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M1.33333 13.3333C0.966667 13.3333 0.652778 13.2028 0.391667 12.9417C0.130556 12.6806 0 12.3667 0 12V2.66667C0 2.3 0.130556 1.98611 0.391667 1.725C0.652778 1.46389 0.966667 1.33333 1.33333 1.33333H2V0H3.33333V1.33333H8.66667V0H10V1.33333H10.6667C11.0333 1.33333 11.3472 1.46389 11.6083 1.725C11.8694 1.98611 12 2.3 12 2.66667V12C12 12.3667 11.8694 12.6806 11.6083 12.9417C11.3472 13.2028 11.0333 13.3333 10.6667 13.3333H1.33333ZM1.33333 12H10.6667V5.33333H1.33333V12ZM1.33333 4H10.6667V2.66667H1.33333V4Z"),
                A2(IE, "fill", "currentColor")
            ]), g)
        ]));
    }, UE = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "width", "24"),
            A2(IE, "height", "24"),
            A2(IE, "viewBox", "0 0 24 24"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "g", w([
                A2(IE, "id", "icon/navigation/cancel_24px")
            ]), w([
                A3(OE, "path", w([
                    A2(IE, "id", "icon/navigation/cancel_24px_2"),
                    A2(IE, "fill-rule", "evenodd"),
                    A2(IE, "clip-rule", "evenodd"),
                    A2(IE, "d", "M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z")
                ]), g)
            ]))
        ]));
    }, KE = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "width", "16"),
            A2(IE, "height", "16"),
            A2(IE, "viewBox", "0 0 16 16"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "fill-rule", "evenodd"),
                A2(IE, "clip-rule", "evenodd"),
                A2(IE, "d", "M14.7597 2.67373C14.4519 2.39656 13.9777 2.42142 13.7005 2.72924L5.29636 12.063L2.31029 8.74663C2.03313 8.43881 1.55891 8.41395 1.25109 8.69112C0.943267 8.96828 0.918414 9.4425 1.19558 9.75032L4.72872 13.6743C4.92781 13.8954 5.22858 13.9705 5.49632 13.8925C5.63593 13.8575 5.76699 13.782 5.87054 13.667L14.8152 3.73293C15.0924 3.42511 15.0675 2.95089 14.7597 2.67373Z")
            ]), g)
        ]));
    }, WE = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "0 0 64 64")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M27.5663 46.5663L49.8913 24.2413L45.458 19.808L27.5663 37.6997L18.5413 28.6747L14.108 33.108L27.5663 46.5663ZM31.9997 63.6663C27.6191 63.6663 23.5025 62.8351 19.6497 61.1726C15.7969 59.5101 12.4455 57.2538 9.59551 54.4038C6.74551 51.5538 4.48926 48.2025 2.82676 44.3497C1.16426 40.4969 0.333008 36.3802 0.333008 31.9997C0.333008 27.6191 1.16426 23.5025 2.82676 19.6497C4.48926 15.7969 6.74551 12.4455 9.59551 9.59551C12.4455 6.74551 15.7969 4.48926 19.6497 2.82676C23.5025 1.16426 27.6191 0.333008 31.9997 0.333008C36.3802 0.333008 40.4969 1.16426 44.3497 2.82676C48.2025 4.48926 51.5538 6.74551 54.4038 9.59551C57.2538 12.4455 59.5101 15.7969 61.1726 19.6497C62.8351 23.5025 63.6663 27.6191 63.6663 31.9997C63.6663 36.3802 62.8351 40.4969 61.1726 44.3497C59.5101 48.2025 57.2538 51.5538 54.4038 54.4038C51.5538 57.2538 48.2025 59.5101 44.3497 61.1726C40.4969 62.8351 36.3802 63.6663 31.9997 63.6663ZM31.9997 57.333C39.0719 57.333 45.0622 54.8788 49.9705 49.9705C54.8788 45.0622 57.333 39.0719 57.333 31.9997C57.333 24.9275 54.8788 18.9372 49.9705 14.0288C45.0622 9.12051 39.0719 6.66634 31.9997 6.66634C24.9275 6.66634 18.9372 9.12051 14.0288 14.0288C9.12051 18.9372 6.66634 24.9275 6.66634 31.9997C6.66634 39.0719 9.12051 45.0622 14.0288 49.9705C18.9372 54.8788 24.9275 57.333 31.9997 57.333Z")
            ]), g)
        ]));
    }, XE = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 21 18"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H10V14H2V4L10 9L18 4V9H20V2C20 0.9 19.1 0 18 0ZM10 7L2 2H18L10 7ZM15.34 18L11.8 14.46L13.21 13.05L15.33 15.17L19.57 10.93L21 12.34L15.34 18Z"),
                A2(IE, "fill", "#43749F")
            ]), g)
        ]));
    }, YE = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "0 0 24 24")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M0 0h24v24H0V0z"),
                A2(IE, "fill", "none")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z")
            ]), g)
        ]));
    }, JE = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 13 16"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M1.21875 16C0.89375 16 0.609375 15.88 0.365625 15.64C0.121875 15.4 0 15.12 0 14.8V1.2C0 0.88 0.121875 0.6 0.365625 0.36C0.609375 0.12 0.89375 0 1.21875 0H8.55156L13 4.38V14.8C13 15.12 12.8781 15.4 12.6344 15.64C12.3906 15.88 12.1062 16 11.7812 16H1.21875ZM7.94219 4.92V1.2H1.21875V14.8H11.7812V4.92H7.94219Z")
            ]), g)
        ]));
    }, nq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "0 0 24 24")
        ]), n), w([
            A3(OE, "g", g, w([
                A3(OE, "path", w([
                    A2(IE, "d", "M8 18H16V16H8V18ZM8 14H16V12H8V14ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z")
                ]), g)
            ]))
        ]));
    }, rq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "0 0 24 24")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M0 0h24v24H0z"),
                A2(IE, "fill", "none")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z")
            ]), g)
        ]));
    }, tq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "width", "29"),
            A2(IE, "height", "16"),
            A2(IE, "viewBox", "0 0 29 16"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M21.0955 2.68835C21.5944 2.21659 21.5944 1.42258 21.0955 0.950811C20.6345 0.514858 19.9133 0.514858 19.4523 0.950811L13.3676 6.70512C12.8687 7.17688 12.8687 7.97089 13.3676 8.44266C13.8286 8.87861 14.5498 8.87861 15.0108 8.44266L21.0955 2.68835ZM28.0716 0.947913C27.6086 0.513167 26.8871 0.51444 26.4257 0.950816L14.6514 12.0857C14.392 12.3311 13.9862 12.3313 13.7265 12.0863L9.85215 8.4311C9.39079 7.99583 8.66991 7.99626 8.20907 8.43208C7.70993 8.90411 7.70993 9.69858 8.20907 10.1706L13.6305 15.2977C13.944 15.5941 14.4344 15.5941 14.7479 15.2977L28.0747 2.69452C28.5765 2.21993 28.5751 1.42073 28.0716 0.947913ZM1.23207 8.43004C0.728769 8.90266 0.72736 9.70153 1.22899 10.1759L6.38152 15.0487C6.84272 15.4848 7.56428 15.4848 8.02548 15.0487C8.52426 14.577 8.52462 13.7832 8.02626 13.311L2.87809 8.43368C2.41694 7.99679 1.69514 7.9952 1.23207 8.43004Z"),
                A2(IE, "fill", "#2F88E7")
            ]), g)
        ]));
    }, eq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 16 17"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M8 12.675L3.175 7.85L4.25 6.775L7.25 9.775V0.5H8.75V9.775L11.75 6.775L12.825 7.85L8 12.675ZM1.5 16.5C1.1 16.5 0.75 16.35 0.45 16.05C0.15 15.75 0 15.4 0 15V11.425H1.5V15H14.5V11.425H16V15C16 15.4 15.85 15.75 15.55 16.05C15.25 16.35 14.9 16.5 14.5 16.5H1.5Z")
            ]), g)
        ]));
    }, uq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 48 48"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "mask", w([
                A2(IE, "id", "mask0_641_312"),
                A2(IE, "style", "mask-type:alpha"),
                A2(IE, "maskUnits", "userSpaceOnUse"),
                A2(IE, "x", "0"),
                A2(IE, "y", "0"),
                A2(IE, "width", "48"),
                A2(IE, "height", "48")
            ]), w([
                A3(OE, "rect", w([
                    A2(IE, "width", "48"),
                    A2(IE, "height", "48"),
                    A2(IE, "fill", "#D9D9D9")
                ]), g)
            ])),
            A3(OE, "g", w([
                A2(IE, "mask", "url(#mask0_641_312)")
            ]), w([
                A3(OE, "path", w([
                    A2(IE, "d", "M26.0145 16.5C26.2715 16.5 26.5 16.5667 26.7 16.7C26.9 16.8333 27.0833 17 27.25 17.2L30.8 22.5H40.2065C40.4712 21.8523 40.6695 21.1952 40.8015 20.5285C40.9338 19.8618 41 19.1857 41 18.5C41 15.9333 40.1675 13.7083 38.5025 11.825C36.8378 9.94167 34.7568 9 32.2595 9C31.0865 9 29.9583 9.24167 28.875 9.725C27.7917 10.2083 26.85 10.8833 26.05 11.75L24.7 13.2C24.6 13.3 24.5 13.3833 24.4 13.45C24.3 13.5167 24.1667 13.55 24 13.55C23.8333 13.55 23.6893 13.5187 23.568 13.456C23.447 13.393 23.341 13.3077 23.25 13.2L21.9 11.75C21.091 10.8893 20.147 10.2158 19.068 9.7295C17.9893 9.24317 16.8667 9 15.7 9C13.2143 9 11.1428 9.94067 9.4855 11.822C7.8285 13.7033 7 15.9293 7 18.5C7 19.1907 7.06667 19.8717 7.2 20.543C7.33333 21.2143 7.5275 21.8667 7.7825 22.5H18C18.2527 22.5 18.4925 22.5602 18.7195 22.6805C18.9468 22.8008 19.1237 22.9573 19.25 23.15L21.55 26.65L24.55 17.55C24.6527 17.25 24.839 17 25.109 16.8C25.3787 16.6 25.6805 16.5 26.0145 16.5Z"),
                    A2(IE, "fill", "white")
                ]), g),
                A3(OE, "path", w([
                    A2(IE, "d", "M24 42C23.4 42 22.825 41.8917 22.275 41.675C21.725 41.4583 21.2333 41.1333 20.8 40.7L7.4 27.25C6.23333 26.0833 5.375 24.75 4.825 23.25C4.275 21.75 4 20.1833 4 18.55C4 15.1167 5.11667 12.1667 7.35 9.7C9.58333 7.23333 12.3667 6 15.7 6C17.3 6 18.8083 6.31667 20.225 6.95C21.6417 7.58333 22.9 8.46667 24 9.6C25.0667 8.46667 26.3083 7.58333 27.725 6.95C29.1417 6.31667 30.65 6 32.25 6C35.5833 6 38.375 7.23333 40.625 9.7C42.875 12.1667 44 15.1 44 18.5C44 20.1333 43.7167 21.7 43.15 23.2C42.5833 24.7 41.7333 26.0333 40.6 27.2L27.15 40.7C26.7167 41.1333 26.2333 41.4583 25.7 41.675C25.1667 41.8917 24.6 42 24 42ZM26.0145 16.5C26.2715 16.5 26.5 16.5667 26.7 16.7C26.9 16.8333 27.0833 17 27.25 17.2L30.8 22.5H40.2065C40.4712 21.8523 40.6695 21.1952 40.8015 20.5285C40.9338 19.8618 41 19.1857 41 18.5C41 15.9333 40.1675 13.7083 38.5025 11.825C36.8378 9.94167 34.7568 9 32.2595 9C31.0865 9 29.9583 9.24167 28.875 9.725C27.7917 10.2083 26.85 10.8833 26.05 11.75L24.7 13.2C24.6 13.3 24.5 13.3833 24.4 13.45C24.3 13.5167 24.1667 13.55 24 13.55C23.8333 13.55 23.6893 13.5187 23.568 13.456C23.447 13.393 23.341 13.3077 23.25 13.2L21.9 11.75C21.091 10.8893 20.147 10.2158 19.068 9.7295C17.9893 9.24317 16.8667 9 15.7 9C13.2143 9 11.1428 9.94067 9.4855 11.822C7.8285 13.7033 7 15.9293 7 18.5C7 19.1907 7.06667 19.8717 7.2 20.543C7.33333 21.2143 7.5275 21.8667 7.7825 22.5H18C18.2527 22.5 18.4925 22.5602 18.7195 22.6805C18.9468 22.8008 19.1237 22.9573 19.25 23.15L21.55 26.65L24.55 17.55C24.6527 17.25 24.839 17 25.109 16.8C25.3787 16.6 25.6805 16.5 26.0145 16.5ZM26.45 21.35L23.4 30.45C23.301 30.75 23.1152 31 22.8425 31.2C22.5698 31.4 22.2723 31.5 21.95 31.5C21.6833 31.5 21.45 31.4333 21.25 31.3C21.05 31.1667 20.8833 31 20.75 30.8L17.2 25.5H9.9L22.95 38.55C23.1167 38.7167 23.28 38.8333 23.44 38.9C23.6 38.9667 23.7867 39 24 39C24.2133 39 24.4 38.9667 24.56 38.9C24.72 38.8333 24.8833 38.7167 25.05 38.55L38.05 25.5H30C29.7333 25.5 29.5 25.4333 29.3 25.3C29.1 25.1667 28.9167 25 28.75 24.8L26.45 21.35Z"),
                    A2(IE, "fill", "currentColor")
                ]), g)
            ]))
        ]));
    }, aq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "height", "24px"),
            A2(IE, "viewBox", "0 -960 960 960"),
            A2(IE, "width", "24px"),
            A2(IE, "fill", "#1f1f1f")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z")
            ]), g)
        ]));
    }, iq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 48 48"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "mask", w([
                A2(IE, "id", "mask0_641_316"),
                A2(IE, "style", "mask-type:alpha"),
                A2(IE, "maskUnits", "userSpaceOnUse"),
                A2(IE, "x", "0"),
                A2(IE, "y", "0"),
                A2(IE, "width", "48"),
                A2(IE, "height", "48")
            ]), w([
                A3(OE, "rect", w([
                    A2(IE, "width", "48"),
                    A2(IE, "height", "48"),
                    A2(IE, "fill", "#D9D9D9")
                ]), g)
            ])),
            A3(OE, "g", w([
                A2(IE, "mask", "url(#mask0_641_316)")
            ]), w([
                A3(OE, "rect", w([
                    A2(IE, "x", "8"),
                    A2(IE, "y", "17"),
                    A2(IE, "width", "32"),
                    A2(IE, "height", "25"),
                    A2(IE, "fill", "white")
                ]), g),
                A3(OE, "path", w([
                    A2(IE, "d", "M29.841 37C28.4803 37 27.3333 36.5303 26.4 35.591C25.4667 34.6513 25 33.5013 25 32.141C25 30.7803 25.4697 29.6333 26.409 28.7C27.3487 27.7667 28.4987 27.3 29.859 27.3C31.2197 27.3 32.3667 27.7697 33.3 28.709C34.2333 29.6487 34.7 30.7987 34.7 32.159C34.7 33.5197 34.2303 34.6667 33.291 35.6C32.3513 36.5333 31.2013 37 29.841 37ZM9 44C8.2 44 7.5 43.7 6.9 43.1C6.3 42.5 6 41.8 6 41V10C6 9.2 6.3 8.5 6.9 7.9C7.5 7.3 8.2 7 9 7H12.25V4H15.5V7H32.5V4H35.75V7H39C39.8 7 40.5 7.3 41.1 7.9C41.7 8.5 42 9.2 42 10V41C42 41.8 41.7 42.5 41.1 43.1C40.5 43.7 39.8 44 39 44H9ZM9 41H39V19.5H9V41ZM9 16.5H39V10H9V16.5Z"),
                    A2(IE, "fill", "currentColor")
                ]), g)
            ]))
        ]));
    }, cq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "width", "24"),
            A2(IE, "height", "24"),
            A2(IE, "viewBox", "0 0 24 24"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "fill-rule", "evenodd"),
                A2(IE, "clip-rule", "evenodd"),
                A2(IE, "d", "M12 1.6875C13.3922 1.6875 14.7422 1.95938 16.0125 2.49609C17.2406 3.01641 18.3422 3.75937 19.2914 4.70625C20.2383 5.65312 20.9836 6.75703 21.5016 7.98516C22.0406 9.25781 22.3125 10.6078 22.3125 12C22.3125 13.3922 22.0406 14.7422 21.5039 16.0125C20.9836 17.2406 20.2406 18.3422 19.2938 19.2914C18.3469 20.2383 17.243 20.9836 16.0148 21.5016C14.7422 22.0406 13.3922 22.3125 12 22.3125C10.6078 22.3125 9.25781 22.0406 7.9875 21.5039C6.75938 20.9836 5.65781 20.2406 4.70859 19.2937C3.76172 18.3469 3.01641 17.243 2.49844 16.0148C1.95938 14.7422 1.6875 13.3922 1.6875 12C1.6875 10.6078 1.95938 9.25781 2.49609 7.9875C3.01641 6.75937 3.75938 5.65781 4.70625 4.70859C5.65312 3.76172 6.75703 3.01641 7.98516 2.49844C9.25781 1.95938 10.6078 1.6875 12 1.6875ZM12 0C5.37187 0 0 5.37188 0 12C0 18.6281 5.37187 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM12 15C11.482 15 11.0625 14.5805 11.0625 14.0625V5.41406C11.0625 4.89609 11.482 4.47656 12 4.47656C12.518 4.47656 12.9375 4.89609 12.9375 5.41406V14.0625C12.9375 14.5805 12.518 15 12 15ZM10.9453 17.5547C10.9453 16.9722 11.4175 16.5 12 16.5C12.5825 16.5 13.0547 16.9722 13.0547 17.5547C13.0547 18.1372 12.5825 18.6094 12 18.6094C11.4175 18.6094 10.9453 18.1372 10.9453 17.5547Z"),
                A2(IE, "fill", "#FAAD14")
            ]), g)
        ]));
    }, oq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "width", "15"),
            A2(IE, "height", "17"),
            A2(IE, "viewBox", "0 0 15 17"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M9.4 2L9.16 0.8C9.07 0.34 8.66 0 8.18 0H1C0.45 0 0 0.45 0 1V16C0 16.55 0.45 17 1 17C1.55 17 2 16.55 2 16V10H7.6L7.84 11.2C7.93 11.67 8.34 12 8.82 12H14C14.55 12 15 11.55 15 11V3C15 2.45 14.55 2 14 2H9.4Z"),
                A2(IE, "fill", "black")
            ]), g)
        ]));
    }, fq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 14 14"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M13.7031 4.42188L13 5.125L10.875 3L11.5938 2.29688C11.7812 2.09896 12.013 2 12.2891 2C12.5651 2 12.8021 2.09896 13 2.29688L13.7031 3C13.901 3.19792 14 3.4349 14 3.71094C14 3.98698 13.901 4.22396 13.7031 4.42188ZM10.2656 3.60938L12.3906 5.73438L7.96875 10.1562L7.07812 11H5V8.92188L5.84375 8.03125L10.2656 3.60938ZM10.9688 5.73438L10.2656 5.03125L6.01562 9.26562L6.73438 9.98438L10.9688 5.73438ZM3 9H4V8H3V9ZM3 7H6V6H3V7ZM7 4H3V5H7V4ZM3 11H4V10H3V11ZM11 13H1V1H8V4L10.5 1.5L9 0H1C0.71875 0 0.481771 0.0963545 0.289062 0.289062C0.0963542 0.481771 0 0.71875 0 1V13C0 13.2812 0.0963542 13.5182 0.289062 13.7109C0.481771 13.9036 0.71875 14 1 14H11C11.2812 14 11.5182 13.9036 11.7109 13.7109C11.9036 13.5182 12 13.2812 12 13V7.53125L11 8.53125V13Z")
            ]), g)
        ]));
    }, sq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 48 48"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "mask", w([
                A2(IE, "id", "mask0_641_308"),
                A2(IE, "style", "mask-type:alpha"),
                A2(IE, "maskUnits", "userSpaceOnUse"),
                A2(IE, "x", "0"),
                A2(IE, "y", "0"),
                A2(IE, "width", "48"),
                A2(IE, "height", "48")
            ]), w([
                A3(OE, "rect", w([
                    A2(IE, "width", "48"),
                    A2(IE, "height", "48"),
                    A2(IE, "fill", "#D9D9D9")
                ]), g)
            ])),
            A3(OE, "g", w([
                A2(IE, "mask", "url(#mask0_641_308)")
            ]), w([
                A3(OE, "path", w([
                    A2(IE, "d", "M6 6H32V24H11L6 29V6Z"),
                    A2(IE, "fill", "white")
                ]), g),
                A3(OE, "path", w([
                    A2(IE, "d", "M44 43.95L36.05 36H15C14.175 36 13.4688 35.7062 12.8815 35.1185C12.2938 34.5312 12 33.825 12 33V29H34C34.825 29 35.5313 28.7062 36.119 28.1185C36.7063 27.5312 37 26.825 37 26V12H41C41.825 12 42.5313 12.2937 43.119 12.881C43.7063 13.4687 44 14.175 44 15V43.95ZM7 26.75L10.75 23H31V7H7V26.75ZM4 34V7C4 6.175 4.29383 5.46867 4.8815 4.881C5.46883 4.29367 6.175 4 7 4H31C31.825 4 32.5313 4.29367 33.119 4.881C33.7063 5.46867 34 6.175 34 7V23C34 23.825 33.7063 24.5312 33.119 25.1185C32.5313 25.7062 31.825 26 31 26H12L4 34Z"),
                    A2(IE, "fill", "currentColor")
                ]), g)
            ]))
        ]));
    }, lq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "height", "24px"),
            A2(IE, "viewBox", "0 -960 960 960"),
            A2(IE, "width", "24px"),
            A2(IE, "fill", "#1f1f1f")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z")
            ]), g)
        ]));
    }, dq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "0 0 24 24")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M0 0h24v24H0z"),
                A2(IE, "fill", "none")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z")
            ]), g)
        ]));
    }, vq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 16 16"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M3.16942 16C2.5668 16 2.05458 15.7851 1.63275 15.3553C1.21092 14.9254 1 14.4035 1 13.7895V11.1579H3.62397V1C3.62397 0.447715 4.07168 0 4.62397 0H15C15.5523 0 16 0.447715 16 1V13.7895C16 14.4035 15.7891 14.9254 15.3673 15.3553C14.9454 15.7851 14.4332 16 13.8306 16H3.16942ZM13.8306 14.7368C14.1061 14.7368 14.3299 14.6491 14.5021 14.4737C14.6742 14.2982 14.7603 14.0702 14.7603 13.7895V1.26316H4.86364V11.1579H12.9008V13.7895C12.9008 14.0702 12.9869 14.2982 13.1591 14.4737C13.3313 14.6491 13.5551 14.7368 13.8306 14.7368ZM5.95868 4.58947V3.32632H10.9174V4.58947H5.95868ZM5.95868 7.41053V6.14737H10.9174V7.41053H5.95868ZM12.8388 4.58947C12.6736 4.58947 12.5289 4.52632 12.405 4.4C12.281 4.27368 12.219 4.12632 12.219 3.9579C12.219 3.78947 12.281 3.64211 12.405 3.51579C12.5289 3.38947 12.6736 3.32632 12.8388 3.32632C13.0041 3.32632 13.1488 3.38947 13.2727 3.51579C13.3967 3.64211 13.4587 3.78947 13.4587 3.9579C13.4587 4.12632 13.3967 4.27368 13.2727 4.4C13.1488 4.52632 13.0041 4.58947 12.8388 4.58947ZM12.8388 7.30526C12.6736 7.30526 12.5289 7.24211 12.405 7.11579C12.281 6.98947 12.219 6.8421 12.219 6.67368C12.219 6.50526 12.281 6.3579 12.405 6.23158C12.5289 6.10526 12.6736 6.04211 12.8388 6.04211C13.0041 6.04211 13.1488 6.10526 13.2727 6.23158C13.3967 6.3579 13.4587 6.50526 13.4587 6.67368C13.4587 6.8421 13.3967 6.98947 13.2727 7.11579C13.1488 7.24211 13.0041 7.30526 12.8388 7.30526ZM3.14876 14.7368H11.6612V12.4211H2.23967V13.7895C2.23967 14.0702 2.32679 14.2982 2.50103 14.4737C2.67528 14.6491 2.89118 14.7368 3.14876 14.7368Z")
            ]), g)
        ]));
    }, bq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 16 16"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "fill-rule", "evenodd"),
                A2(IE, "clip-rule", "evenodd"),
                A2(IE, "d", "M0.142327 15.1333C0.393436 15.7111 0.816832 16 1.41251 16H14.5875C15.1832 16 15.6066 15.7111 15.8577 15.1333C16.1088 14.5556 16.0276 14.0296 15.6141 13.5556L10.3099 7.33333V1.33333H11.4221C11.6039 1.33333 11.7563 1.27037 11.8792 1.14444C12.0022 1.01852 12.0637 0.860555 12.0637 0.670555C12.0637 0.48057 12.0022 0.321311 11.8792 0.192778C11.7563 0.064259 11.6039 0 11.4221 0H4.57793C4.39613 0 4.24374 0.062963 4.12076 0.188889C3.99778 0.314815 3.93629 0.472778 3.93629 0.662778C3.93629 0.852763 3.99778 1.01202 4.12076 1.14056C4.24374 1.26907 4.39613 1.33333 4.57793 1.33333H5.6901V7.33333L0.385893 13.5556C-0.0276069 14.0296 -0.108796 14.5556 0.142327 15.1333ZM4.55571 10.6667H11.4443L9.02662 7.82222V1.33333H6.97338V7.82222L4.55571 10.6667Z")
            ]), g)
        ]));
    }, mq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 24 24"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "fill-rule", "evenodd"),
                A2(IE, "clip-rule", "evenodd"),
                A2(IE, "d", "M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z")
            ]), g)
        ]));
    }, pq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "0 0 24 24")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M0 0h24v24H0z"),
                A2(IE, "fill", "none")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z")
            ]), g)
        ]));
    }, $q = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "version", "1.1"),
            A2(IE, "id", "Layer_1"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "x", "0px"),
            A2(IE, "y", "0px"),
            A2(IE, "viewBox", "0 -15 512 540"),
            A2(IE, "style", "enable-background:new 0 -15 512 540;"),
            A2(IE, "xml:space", "preserve")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M87.084,192c-0.456-5.272-0.688-10.6-0.688-16C86.404,78.8,162.34,0,256.004,0s169.6,78.8,169.6,176\r\n\tc0,5.392-0.232,10.728-0.688,16h0.688c0,96.184-169.6,320-169.6,320s-169.6-223.288-169.6-320H87.084z M256.004,224\r\n\tc36.392,1.024,66.744-27.608,67.84-64c-1.096-36.392-31.448-65.024-67.84-64c-36.392-1.024-66.744,27.608-67.84,64\r\n\tC189.26,196.392,219.612,225.024,256.004,224z")
            ]), g)
        ]));
    }, gq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 48 48"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M24 16c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0 4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 12c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"),
                A2(IE, "fill", "currentColor")
            ]), g)
        ]));
    }, hq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 13 16"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M11.9167 1.06667H8.37891C8.18707 0.744444 7.92752 0.486111 7.60026 0.291666C7.273 0.0972214 6.90625 0 6.5 0C6.09375 0 5.727 0.0972214 5.39974 0.291666C5.07248 0.486111 4.81293 0.744444 4.62109 1.06667H1.08333C0.778646 1.06667 0.521918 1.16944 0.313151 1.375C0.104384 1.58055 0 1.83333 0 2.13333V14.9333C0 15.2333 0.104384 15.4861 0.313151 15.6917C0.521918 15.8972 0.778646 16 1.08333 16H11.9167C12.2214 16 12.4781 15.8972 12.6868 15.6917C12.8956 15.4861 13 15.2333 13 14.9333V2.13333C13 1.83333 12.8956 1.58055 12.6868 1.375C12.4781 1.16944 12.2214 1.06667 11.9167 1.06667ZM6.5 1.06667C6.80469 1.06667 7.06141 1.16944 7.27018 1.375C7.47895 1.58055 7.58333 1.83333 7.58333 2.13333H5.41667C5.41667 1.83333 5.52105 1.58055 5.72982 1.375C5.93858 1.16944 6.19531 1.06667 6.5 1.06667ZM11.9167 14.9333H1.08333V2.13333H3.25V4.26667H9.75V2.13333H11.9167V14.9333ZM10.8333 7.46667H2.16667V6.4H10.8333V7.46667ZM10.8333 9.6H2.16667V8.53333H10.8333V9.6ZM10.8333 11.7333H2.16667V10.6667H10.8333V11.7333ZM10.8333 13.8667H2.16667V12.8H10.8333V13.8667Z")
            ]), g)
        ]));
    }, yq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 10 18"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M10 13.095C10 14.4625 9.51136 15.6218 8.53409 16.5731C7.55682 17.5244 6.37879 18 5 18C3.62121 18 2.44318 17.5312 1.46591 16.5938C0.488636 15.6562 0 14.505 0 13.14L0 3.465C0 2.51212 0.34503 1.6964 1.03509 1.01783C1.72517 0.339277 2.55471 0 3.52373 0C4.49276 0 5.32197 0.339277 6.01136 1.01783C6.70076 1.6964 7.04545 2.51212 7.04545 3.465L7.04545 12.3525C7.04545 12.9258 6.84742 13.4104 6.45134 13.8062C6.05527 14.2021 5.57042 14.4 4.9968 14.4C4.42317 14.4 3.93939 14.1937 3.54545 13.7812C3.15152 13.3687 2.95455 12.8775 2.95455 12.3075L2.95455 3.465H3.86364L3.86364 12.33C3.86364 12.645 3.97216 12.9187 4.18921 13.1512C4.40624 13.3837 4.67517 13.5 4.99602 13.5C5.31686 13.5 5.58712 13.3875 5.80682 13.1625C6.02652 12.9375 6.13636 12.6675 6.13636 12.3525L6.13636 3.465C6.13636 2.7468 5.88417 2.13975 5.3798 1.64385C4.87543 1.14795 4.25801 0.9 3.52752 0.9C2.79705 0.9 2.17803 1.14795 1.67045 1.64385C1.16288 2.13975 0.909091 2.7468 0.909091 3.465L0.909091 13.185C0.909091 14.28 1.30966 15.2062 2.1108 15.9637C2.91193 16.7212 3.875 17.1 5 17.1C6.13636 17.1 7.10227 16.7137 7.89773 15.9412C8.69318 15.1687 9.09091 14.2275 9.09091 13.1175L9.09091 3.465H10L10 13.095Z")
            ]), g)
        ]));
    }, wq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "0 0 16 16")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "clip-rule", "evenodd"),
                A2(IE, "d", "M6 0H0V16H6V0ZM16 0H10V16H16V0Z")
            ]), g)
        ]));
    }, xq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 14 14"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M7 6.5C8.38071 6.5 9.5 5.38071 9.5 4C9.5 2.61929 8.38071 1.5 7 1.5C5.61929 1.5 4.5 2.61929 4.5 4C4.5 5.38071 5.61929 6.5 7 6.5Z"),
                A2(IE, "fill", "none"),
                A2(IE, "stroke", "currentColor"),
                A2(IE, "stroke-width", "1.5")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M2 12C2 9.5 4 8 7 8C10 8 12 9.5 12 12"),
                A2(IE, "fill", "none"),
                A2(IE, "stroke", "currentColor"),
                A2(IE, "stroke-width", "1.5")
            ]), g)
        ]));
    }, _q = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "0 0 14 16")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M0 0L14 8L0 16V0Z")
            ]), g)
        ]));
    }, Cq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 16 13"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M11.424 8.39394V6.77273C11.424 6.69192 11.3973 6.62626 11.344 6.57576C11.2907 6.52525 11.2213 6.5 11.136 6.5H9.136V4.60606C9.136 4.52525 9.10933 4.4596 9.056 4.40909C9.00267 4.35859 8.93867 4.33333 8.864 4.33333H7.136C7.06133 4.33333 6.99733 4.35859 6.944 4.40909C6.89067 4.4596 6.864 4.52525 6.864 4.60606V6.5H4.864C4.77867 6.5 4.70933 6.52525 4.656 6.57576C4.60267 6.62626 4.576 6.69192 4.576 6.77273V8.39394C4.576 8.47475 4.60267 8.5404 4.656 8.59091C4.70933 8.64141 4.77867 8.66667 4.864 8.66667H6.864V10.5606C6.864 10.6414 6.89067 10.7071 6.944 10.7576C6.99733 10.8081 7.06133 10.8333 7.136 10.8333H8.864C8.93867 10.8333 9.00267 10.8081 9.056 10.7576C9.10933 10.7071 9.136 10.6414 9.136 10.5606V8.66667H11.136C11.2213 8.66667 11.2907 8.64141 11.344 8.59091C11.3973 8.5404 11.424 8.47475 11.424 8.39394ZM5.712 2.16667H10.288V1.09091H5.712V2.16667ZM2.288 2.16667V13H2C1.456 13 0.986667 12.8131 0.592 12.4394C0.197333 12.0657 0 11.6212 0 11.1061V4.06061C0 3.54545 0.197333 3.10101 0.592 2.72727C0.986667 2.35353 1.456 2.16667 2 2.16667H2.288ZM12.864 2.16667V13H3.136V2.16667H4.576V0.818181C4.576 0.59596 4.656 0.40404 4.816 0.242424C4.976 0.0808077 5.17867 0 5.424 0H10.576C10.8107 0 11.0133 0.0808077 11.184 0.242424C11.3547 0.40404 11.4347 0.59596 11.424 0.818181V2.16667H12.864ZM16 4.06061V11.1061C16 11.6212 15.8027 12.0657 15.408 12.4394C15.0133 12.8131 14.544 13 14 13H13.712V2.16667H14C14.544 2.16667 15.0133 2.35353 15.408 2.72727C15.8027 3.10101 16 3.54545 16 4.06061Z")
            ]), g)
        ]));
    }, Aq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "0 0 24 24")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M0 0h24v24H0V0z"),
                A2(IE, "fill", "none")
            ]), g),
            A3(OE, "circle", w([
                A2(IE, "cx", "12"),
                A2(IE, "cy", "19"),
                A2(IE, "r", "2")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M10 3h4v12h-4z")
            ]), g)
        ]));
    }, kq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 24 24"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "circle", w([
                A2(IE, "cx", "12"),
                A2(IE, "cy", "12"),
                A2(IE, "r", "9"),
                A2(IE, "stroke", "currentColor"),
                A2(IE, "stroke-width", "2"),
                A2(IE, "fill", "none")
            ]), g),
            A3(OE, "circle", w([
                A2(IE, "cx", "12"),
                A2(IE, "cy", "12"),
                A2(IE, "r", "5")
            ]), g)
        ]));
    }, Eq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 48 48"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "mask", w([
                A2(IE, "id", "mask0_641_320"),
                A2(IE, "style", "mask-type:alpha"),
                A2(IE, "maskUnits", "userSpaceOnUse"),
                A2(IE, "x", "0"),
                A2(IE, "y", "0"),
                A2(IE, "width", "48"),
                A2(IE, "height", "48")
            ]), w([
                A3(OE, "rect", w([
                    A2(IE, "width", "48"),
                    A2(IE, "height", "48"),
                    A2(IE, "fill", "#D9D9D9")
                ]), g)
            ])),
            A3(OE, "g", w([
                A2(IE, "mask", "url(#mask0_641_320)")
            ]), w([
                A3(OE, "path", w([
                    A2(IE, "d", "M36.9265 41.334C37.6001 41.334 38.1475 41.1235 38.5685 40.7025C38.9895 40.2815 39.2 39.7342 39.2 39.0605V9H15V32.7453H34.653V39.0605C34.653 39.7342 34.8635 40.2815 35.2846 40.7025C35.7056 41.1235 36.2529 41.334 36.9265 41.334Z"),
                    A2(IE, "fill", "white")
                ]), g),
                A3(OE, "path", w([
                    A2(IE, "d", "M11.1001 44C9.64176 44 8.40226 43.4895 7.3816 42.4685C6.3606 41.4478 5.8501 40.2083 5.8501 38.75V32.5H12.2001V4L15.1901 7L18.1801 4L21.1701 7L24.1601 4L27.1501 7L30.1501 4L33.1501 7L36.1501 4L39.1501 7L42.1501 4V38.75C42.1501 40.2083 41.6398 41.4478 40.6191 42.4685C39.5981 43.4895 38.3584 44 36.9001 44H11.1001ZM36.9001 41C37.5668 41 38.1084 40.7917 38.5251 40.375C38.9418 39.9583 39.1501 39.4167 39.1501 38.75V9H15.2001V32.5H34.6501V38.75C34.6501 39.4167 34.8584 39.9583 35.2751 40.375C35.6918 40.7917 36.2334 41 36.9001 41ZM17.8501 16.9V13.9H29.8501V16.9H17.8501ZM17.8501 23.6V20.6H29.8501V23.6H17.8501ZM34.5001 16.9C34.1001 16.9 33.7501 16.75 33.4501 16.45C33.1501 16.15 33.0001 15.8 33.0001 15.4C33.0001 15 33.1501 14.65 33.4501 14.35C33.7501 14.05 34.1001 13.9 34.5001 13.9C34.9001 13.9 35.2501 14.05 35.5501 14.35C35.8501 14.65 36.0001 15 36.0001 15.4C36.0001 15.8 35.8501 16.15 35.5501 16.45C35.2501 16.75 34.9001 16.9 34.5001 16.9ZM34.5001 23.35C34.1001 23.35 33.7501 23.2 33.4501 22.9C33.1501 22.6 33.0001 22.25 33.0001 21.85C33.0001 21.45 33.1501 21.1 33.4501 20.8C33.7501 20.5 34.1001 20.35 34.5001 20.35C34.9001 20.35 35.2501 20.5 35.5501 20.8C35.8501 21.1 36.0001 21.45 36.0001 21.85C36.0001 22.25 35.8501 22.6 35.5501 22.9C35.2501 23.2 34.9001 23.35 34.5001 23.35ZM11.0501 41H31.6501V35.5H8.8501V38.75C8.8501 39.4167 9.06093 39.9583 9.4826 40.375C9.90426 40.7917 10.4268 41 11.0501 41Z"),
                    A2(IE, "fill", "currentColor")
                ]), g)
            ]))
        ]));
    }, qq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 24 24"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "fill-rule", "evenodd"),
                A2(IE, "clip-rule", "evenodd"),
                A2(IE, "d", "M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L14.5858 12L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289Z")
            ]), g)
        ]));
    }, Fq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "fill-rule", "evenodd"),
                A2(IE, "clip-rule", "evenodd"),
                A2(IE, "d", "M5.60222 9.97513C3.15606 9.97513 1.17354 7.9902 1.17354 5.54106C1.17354 3.09193 3.15606 1.10699 5.60222 1.10699C8.04837 1.10699 10.0309 3.09193 10.0309 5.54106C10.0309 7.9902 8.04837 9.97513 5.60222 9.97513ZM9.88751 9.05021C10.6746 8.08719 11.1452 6.85569 11.1383 5.51335C11.1227 2.43721 8.62637 -0.0257772 5.55397 0.000203667C2.53347 0.0261845 0.0890486 2.47532 0.0665592 5.50122C0.0440698 8.57909 2.50406 11.0733 5.57992 11.0854C6.91718 11.0906 8.14371 10.6212 9.10384 9.83656V9.83483L13.1035 13.8376C13.3197 14.0541 13.6692 14.0541 13.8854 13.8376C14.1017 13.6211 14.1017 13.2712 13.8854 13.0547L9.88751 9.05021Z"),
                A2(IE, "fill", "#C4DCF8")
            ]), g)
        ]));
    }, jq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "0 -960 960 960")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M280-80q-33 0-56.5-23.5T200-160q0-33 23.5-56.5T280-240q33 0 56.5 23.5T360-160q0 33-23.5 56.5T280-80Zm400 0q-33 0-56.5-23.5T600-160q0-33 23.5-56.5T680-240q33 0 56.5 23.5T760-160q0 33-23.5 56.5T680-80ZM246-720l96 200h280l110-200H246Zm-38-80h590q23 0 35 20.5t1 41.5L692-482q-11 20-29.5 31T622-440H324l-44 80h480v80H280q-45 0-68-39.5t-2-78.5l54-98-144-304H40v-80h130l38 80Zm134 280h280-280Z")
            ]), g)
        ]));
    }, Dq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 12 12"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M5.99882 12C5.16604 12 4.38488 11.8428 3.65534 11.5283C2.92571 11.2138 2.29008 10.7854 1.74846 10.243C1.20675 9.70048 0.77993 9.06279 0.468017 8.32991C0.156006 7.59713 0 6.81435 0 5.98156C0 5.14622 0.156006 4.36565 0.468017 3.63985C0.77993 2.91396 1.20675 2.28059 1.74846 1.73976C2.29008 1.19893 2.92571 0.773784 3.65534 0.464329C4.38488 0.154776 5.16604 0 5.99882 0C6.83406 0 7.61586 0.154776 8.34422 0.464329C9.07257 0.773784 9.70756 1.19893 10.2492 1.73976C10.7909 2.28059 11.2181 2.91396 11.5308 3.63985C11.8436 4.36565 12 5.14622 12 5.98156C12 6.81435 11.8436 7.59713 11.5308 8.32991C11.2181 9.06279 10.7909 9.70048 10.2492 10.243C9.70756 10.7854 9.07257 11.2138 8.34422 11.5283C7.61586 11.8428 6.83406 12 5.99882 12ZM5.9941 10.896C6.3009 10.5451 6.56207 10.1543 6.77762 9.72363C6.99317 9.29293 7.17056 8.79645 7.3098 8.23418H4.6964C4.826 8.7702 4.99798 9.25847 5.21235 9.699C5.42672 10.1395 5.6873 10.5385 5.9941 10.896ZM4.65996 10.6993C4.4339 10.3467 4.2417 9.96799 4.08339 9.56315C3.92507 9.15841 3.79183 8.71542 3.68366 8.23418H1.64492C1.98358 8.86037 2.3867 9.3657 2.85427 9.75018C3.32194 10.1346 3.92384 10.451 4.65996 10.6993ZM7.3393 10.6895C7.99017 10.482 8.57441 10.1676 9.09204 9.74635C9.60957 9.32509 10.0286 8.82103 10.3492 8.23418H8.32268C8.20793 8.70884 8.07188 9.14858 7.91455 9.55342C7.75712 9.95816 7.56537 10.3368 7.3393 10.6895ZM1.28458 7.26142H3.49678C3.46728 7.01893 3.44845 6.79601 3.44029 6.59265C3.43203 6.3894 3.4279 6.1857 3.4279 5.98156C3.4279 5.74881 3.43365 5.53793 3.44515 5.34894C3.45666 5.15994 3.47716 4.95398 3.50666 4.73106H1.28458C1.22233 4.95319 1.17892 5.15733 1.15433 5.34348C1.12975 5.52952 1.11746 5.74222 1.11746 5.98156C1.11746 6.21845 1.12975 6.43547 1.15433 6.63263C1.17892 6.82979 1.22233 7.03938 1.28458 7.26142ZM4.49978 7.26142H7.50656C7.54098 6.99267 7.56315 6.76321 7.57309 6.57304C7.58302 6.38286 7.58798 6.1857 7.58798 5.98156C7.58798 5.78155 7.58302 5.59034 7.57309 5.40794C7.56315 5.22543 7.54098 4.9998 7.50656 4.73106H4.49978C4.46369 4.9998 4.43994 5.22543 4.42854 5.40794C4.41703 5.59034 4.41128 5.78155 4.41128 5.98156C4.41128 6.1857 4.41703 6.38286 4.42854 6.57304C4.43994 6.76321 4.46369 6.99267 4.49978 7.26142ZM8.4898 7.26142H10.7083C10.769 7.03938 10.812 6.82979 10.8374 6.63263C10.8628 6.43547 10.8755 6.21845 10.8755 5.98156C10.8755 5.74222 10.8628 5.52952 10.8374 5.34348C10.812 5.15733 10.769 4.95319 10.7083 4.73106H8.49968C8.52525 5.02763 8.54359 5.26678 8.5547 5.4485C8.56581 5.63012 8.57137 5.80781 8.57137 5.98156C8.57137 6.19219 8.56419 6.3926 8.54983 6.58277C8.53547 6.77305 8.51546 6.99926 8.4898 7.26142ZM8.3128 3.75476H10.3492C10.0417 3.14322 9.62919 2.62702 9.11166 2.20616C8.59413 1.78529 8.0001 1.48424 7.32956 1.30301C7.55553 1.65062 7.74724 2.02296 7.90467 2.42003C8.0621 2.8171 8.19814 3.26201 8.3128 3.75476ZM4.6964 3.75476H7.31968C7.21063 3.26781 7.03973 2.79856 6.80697 2.34702C6.57422 1.89547 6.30326 1.48852 5.9941 1.12616C5.70697 1.41801 5.46113 1.77088 5.2566 2.18477C5.05207 2.59865 4.86533 3.12198 4.6964 3.75476ZM1.64492 3.75476H3.6934C3.79507 3.28168 3.92178 2.84827 4.0735 2.45455C4.22533 2.06072 4.41752 1.68017 4.65008 1.3129C3.97797 1.49412 3.38886 1.79148 2.88274 2.20498C2.37652 2.61857 1.96391 3.13516 1.64492 3.75476Z"),
                A2(IE, "fill", "currentColor")
            ]), g)
        ]));
    }, Vq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "viewBox", "0 0 16 13"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M11.424 7.57621H14.16C14.128 7.61661 14.096 7.64691 14.064 7.66711C14.032 7.68731 14.0053 7.70751 13.984 7.72771L13.952 7.77316L8.4 12.8485C8.29333 12.9495 8.16 13 8 13C7.84 13 7.70667 12.9495 7.6 12.8485L2.032 7.75801C2 7.73781 1.94133 7.67721 1.856 7.57621H5.136C5.27467 7.57621 5.39733 7.54086 5.504 7.47016C5.61067 7.39946 5.67467 7.3035 5.696 7.1823L6.32 4.80371L8.016 10.4396C8.05867 10.5507 8.128 10.6416 8.224 10.7123C8.32 10.783 8.43733 10.8234 8.576 10.8335C8.69333 10.8335 8.80533 10.7931 8.912 10.7123C9.01867 10.6315 9.088 10.5406 9.12 10.4396L10.416 6.33389L10.928 7.28835C11.0347 7.48026 11.2 7.57621 11.424 7.57621ZM16 3.97045C16 4.77846 15.696 5.62183 15.088 6.50054H11.792L10.8 4.63706C10.7467 4.53606 10.6667 4.46031 10.56 4.40981C10.4533 4.3593 10.3467 4.33405 10.24 4.33405C9.97333 4.36436 9.808 4.49566 9.744 4.72796L8.592 8.36402L6.848 2.56147C6.80533 2.45037 6.73067 2.35442 6.624 2.27362C6.51733 2.19282 6.4 2.15747 6.272 2.16757C6.144 2.17767 6.032 2.21807 5.936 2.28877C5.84 2.35947 5.77067 2.45542 5.728 2.57662L4.704 6.50054H0.928C0.309333 5.62183 0 4.77846 0 3.97045C0 2.72813 0.378667 1.75851 1.136 1.0616C1.89333 0.364688 2.93867 0.0111818 4.272 0.00108147C4.63467 0.00108147 5.008 0.0616827 5.392 0.182884C5.776 0.304087 6.13333 0.470739 6.464 0.682843C6.79467 0.894947 7.08267 1.08685 7.328 1.25855C7.57333 1.43026 7.79733 1.62216 8 1.83426C8.21333 1.63226 8.43733 1.44036 8.672 1.25855C8.90667 1.07675 9.19467 0.884847 9.536 0.682843C9.87733 0.48084 10.2347 0.314187 10.608 0.182884C10.9813 0.0515823 11.3547 -0.0090189 11.728 0.00108147C13.0613 0.00108147 14.1067 0.354588 14.864 1.0616C15.6213 1.76861 16 2.73823 16 3.97045Z")
            ]), g)
        ]));
    }, Bq = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "xmlns", "http://www.w3.org/2000/svg"),
            A2(IE, "viewBox", "-1 -1 24 24")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M0 22L11 0L22 22H0ZM3.45 19.6842H18.55L11 4.63158L3.45 19.6842ZM11 18.5263C11.2833 18.5263 11.5208 18.4154 11.7125 18.1934C11.9042 17.9715 12 17.6965 12 17.3684C12 17.0403 11.9042 16.7654 11.7125 16.5434C11.5208 16.3215 11.2833 16.2105 11 16.2105C10.7167 16.2105 10.4792 16.3215 10.2875 16.5434C10.0958 16.7654 10 17.0403 10 17.3684C10 17.6965 10.0958 17.9715 10.2875 18.1934C10.4792 18.4154 10.7167 18.5263 11 18.5263ZM10 15.0526H12V9.26316H10V15.0526Z")
            ]), g)
        ]));
    }, Gq = function(n) {
        switch(n){
            case 1:
                return rq;
            case 0:
                return pq;
            case 2:
                return YE;
            case 3:
                return Aq;
            case 4:
                return Bq;
            case 5:
                return dq;
            case 6:
                return mq;
            case 7:
                return qq;
            case 8:
                return UE;
            case 9:
                return WE;
            case 10:
                return cq;
            case 11:
                return $q;
            case 12:
                return XE;
            case 13:
                return oq;
            case 14:
                return KE;
            case 15:
                return tq;
            case 16:
                return Fq;
            case 17:
                return eq;
            case 18:
                return vq;
            case 19:
                return yq;
            case 20:
                return JE;
            case 21:
                return nq;
            case 22:
                return hq;
            case 23:
                return Vq;
            case 24:
                return bq;
            case 25:
                return Cq;
            case 26:
                return fq;
            case 27:
                return kq;
            case 28:
                return QE;
            case 29:
                return RE;
            case 30:
                return Dq;
            case 31:
                return aq;
            case 32:
                return lq;
            case 33:
                return sq;
            case 34:
                return iq;
            case 35:
                return uq;
            case 36:
                return Eq;
            case 37:
                return _q;
            case 38:
                return wq;
            case 39:
                return xq;
            case 40:
                return jq;
            default:
                return gq;
        }
    }, zq = function(n) {
        switch(n){
            case 0:
                return "icon--xs";
            case 1:
                return "icon--sm";
            case 2:
                return "icon--md";
            case 3:
                return "icon--lg";
            default:
                return "icon--xl";
        }
    }, Sq = function(n) {
        switch(n.$){
            case 1:
                return w([
                    HE(Jx(n.a))
                ]);
            case 0:
                return w([
                    HE(zq(n.a))
                ]);
            case 2:
                return w([
                    HE(n.a)
                ]);
            default:
                return w([
                    HE("icon--square")
                ]);
        }
    }, Tq = F2(function(n, r) {
        var t = A2(bc, Sq, n);
        return A2(Gq, r, A2(Qt, HE("icon"), t));
    }), Pq = function(n) {
        switch(n){
            case 0:
                return w([
                    Gx("tag--success")
                ]);
            case 1:
                return w([
                    Gx("tag--info")
                ]);
            case 3:
                return w([
                    Gx("tag--warning")
                ]);
            case 2:
                return w([
                    Gx("tag--danger")
                ]);
            case 4:
                return w([
                    Gx("tag--primary")
                ]);
            case 5:
                return w([
                    Gx("tag--primary-500")
                ]);
            default:
                return w([
                    Gx("tag--light-gray")
                ]);
        }
    }, Zq = F2(function(n, r) {
        return A2(Mx, A2(Qt, Gx("tag"), function(n) {
            return vc(A2(Fu, Pq, n));
        }(n)), r);
    }), Mq = F3(function(n, r, t) {
        var e = function() {
            if (r) switch(t.$){
                case 3:
                    return It(v(6, Ed.x7));
                case 1:
                    return It(v(0, Ed.x8));
                default:
                    return Ot;
            }
            else switch(t.$){
                case 1:
                    return It(v(0, Ed.x9));
                case 0:
                    return It(v(3, Ed.yb));
                case 2:
                    return It(v(2, Ed.ya));
                case 3:
                    return It(v(6, Ed.x7));
                default:
                    return Ot;
            }
        }();
        if (e.$) return vE;
        var u = e.a, a = u.b;
        return A2(Zq, w([
            u.a
        ]), w([
            _d(n(a))
        ]));
    }), Lq = F3(function(n, r, t) {
        var e = A2(xc, "", ZE(t)), u = A2(xc, n(Ed.yx), A2(FE, t.yx, A2(Op, CE, oE(t)))), a = A2(xc, "", A2(Op, AE, jE(t))), i = pE(ME(t));
        return A2(zx, w([
            qE(A2(iE, mE(t), ZE(t))),
            Gx("cursor-pointer")
        ]), w([
            A2(BE, w([
                _E,
                cE(gE)
            ]), w([
                A2(lE, w([
                    TE(11)
                ]), w([
                    A2(Kk, w([
                        Hx(w([
                            Gx("flex items-center gap-2")
                        ]))
                    ]), w([
                        A2(PE, w([
                            sE
                        ]), w([
                            _d(u)
                        ])),
                        A3(Mq, n, r, ME(t))
                    ])),
                    A2(Kk, w([
                        NE,
                        A2(dE, i, LE)
                    ]), w([
                        _d(e)
                    ])),
                    A2(bE, !mu(a), A2(Kk, w([
                        xE,
                        A2(dE, i, LE)
                    ]), w([
                        _d(a)
                    ])))
                ])),
                A2(lE, w([
                    TE(1),
                    cE(yE)
                ]), w([
                    A2(Tq, w([
                        zE
                    ]), 7)
                ]))
            ]))
        ]));
    }), Nq = F3(function(n, r, t) {
        return A2(Kk, w([
            Hx(w([
                Gx("flex flex-col")
            ]))
        ]), A2(Fu, A2(Lq, n, r), t));
    }), Hq = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Iq = {
        $: 7
    }, Oq = function(n) {
        return Gx(A2(fe, " ", A2(Fu, Ue, A2(no, Oc, n))));
    }, Qq = cr("li"), Rq = {
        hA: 1,
        h6: !1,
        h7: !1,
        ii: 0,
        CR: !1,
        cf: Ot,
        FO: 0,
        my: 0
    }, Uq = Sx(1), Kq = cr("ul"), Wq = F3(function(n, r, t) {
        var e = r.$ ? g : w([
            qE((0, r.a)(t))
        ]);
        return A2(Mx, A2(Qt, Gx("clickable"), e), w([
            _d(n)
        ]));
    }), Xq = F3(function(n, r, t) {
        return A2(Qq, w([
            Oq(w([
                v("active", i(n, t))
            ]))
        ]), w([
            A3(Wq, oe(t), r, t)
        ]));
    }), Yq = F2(function(n, r) {
        var t = r;
        return function(n) {
            var r = function(n) {
                return A3(de, F2(function(n, r) {
                    switch(n.$){
                        case 0:
                            return m(r, {
                                my: n.a
                            });
                        case 1:
                            return m(r, {
                                ii: n.a
                            });
                        case 2:
                            return m(r, {
                                h7: !0
                            });
                        case 3:
                            return m(r, {
                                hA: n.a
                            });
                        case 4:
                            return m(r, {
                                cf: It(n.a)
                            });
                        case 5:
                            return m(r, {
                                FO: n.a
                            });
                        case 6:
                            return m(r, {
                                CR: n.a
                            });
                        default:
                            return m(r, {
                                h6: !0
                            });
                    }
                }), Rq, n);
            }(n), t = !(1 > s(r.my, r.ii) && r.h7 || r.h6), e = Be(r.my / r.ii), u = (r.hA - 1) * r.ii, a = A2(dm, r.hA + 2, e), c = u + 1, o = A2(Ie, r.hA - 2, 1), f = A2($e, o, a), l = c - 1 + (s(r.ii * r.hA, r.my) > 0 ? r.my - r.ii * (r.hA - 1) : r.ii);
            return A2(zx, w([
                Gx("text-center")
            ]), r.CR ? w([
                Lx(w([
                    Uq
                ]))
            ]) : vc(w([
                t && s(r.my, r.ii) > 0 ? w([
                    A2(zx, w([
                        Gx("pull-right")
                    ]), w([
                        _d("Showing " + oe(c) + " to " + oe(l) + " of " + oe(r.my))
                    ]))
                ]) : g,
                r.my && s(r.my, r.ii) > 0 ? w([
                    A2(Kq, w([
                        Gx("pagination"),
                        Gx("")
                    ]), vc(w([
                        w([
                            A2(Qq, w([
                                Oq(w([
                                    v("disabled", 1 === r.hA)
                                ]))
                            ]), w([
                                A3(Wq, "<", r.cf, r.hA - 1)
                            ]))
                        ]),
                        o > 1 ? w([
                            A2(Qq, g, w([
                                A3(Wq, "...", r.cf, o - 1)
                            ]))
                        ]) : g,
                        A2(Fu, A2(Xq, r.hA, r.cf), f),
                        0 > s(a, e) ? w([
                            A2(Qq, g, w([
                                A3(Wq, "...", r.cf, a + 1)
                            ]))
                        ]) : g,
                        w([
                            A2(Qq, w([
                                Oq(w([
                                    v("disabled", i(r.hA, e))
                                ]))
                            ]), w([
                                A3(Wq, ">", r.cf, r.hA + 1)
                            ]))
                        ])
                    ])))
                ]) : g
            ])));
        }(A2(Qt, {
            $: 0,
            a: t.my
        }, A2(Qt, function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.ii), A2(Qt, function(n) {
            return {
                $: 3,
                a: n
            };
        }(t.hA), A2(Qt, function(n) {
            return {
                $: 4,
                a: n
            };
        }(cu), n)))));
    }), Jq = A2(tE, rE(3), It(1)), nF = wE(1), rF = function(n) {
        return w([
            A2(f_, w([
                uE(Jq),
                nF
            ]), w([
                _d(n)
            ]))
        ]);
    }, tF = F2(function(n, r) {
        var t, e = r.z3;
        switch(e.$){
            case 3:
                var u = e.a;
                return nE(u.z3) ? A2(Kk, g, rF(n(r.dp ? Ed.zB : Ed.zC))) : A2(Kk, g, w([
                    A3(Nq, n, 1 === r.dp, u.z3),
                    (t = r.lQ, A2(c_, Hq, A2(Yq, w([
                        Iq
                    ]), t)))
                ]));
            case 2:
                return A2(Kk, g, aE(n(Ed.cb)));
            default:
                return A2(Kk, g, Nx);
        }
    }), eF = {
        $: 4
    }, uF = function(n) {
        return {
            $: 7,
            a: n
        };
    }, aF = A2(tE, rE(3), It(2)), iF = hE(2), cF = function(n) {
        return {
            $: 4,
            a: n
        };
    }, oF = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fF = oF(0), sF = cr("button"), lF = IE, dF = F2(function(n, r) {
        return A2(dr, n, Yw(r));
    }), vF = dF("disabled"), bF = A2(Iu, "keyCode", O$), mF = function(n) {
        return A2(EE, "keydown", A2(eu, n, bF));
    }, pF = function(n) {
        var r;
        return Q$(w([
            A2(nu, function(r) {
                return i(r, n) ? au(!0) : AA("continue");
            }, A2(Iu, "id", M$)),
            (r = function() {
                return A2(Iu, "parentNode", pF(n));
            }, A2(nu, r, au(0))),
            au(!1)
        ]));
    }, $F = F2(function(n, r) {
        return A2(nu, function(r) {
            return r ? AA("blurred inside") : au(n);
        }, A2(Iu, "relatedTarget", pF(r)));
    }), gF = F2(function(n, r) {
        return A2(EE, "blur", A2($F, n, r));
    }), hF = function(n) {
        switch(n.$){
            case 0:
                switch(n.a){
                    case 0:
                        return w([
                            Gx("button--primary")
                        ]);
                    case 1:
                        return w([
                            Gx("button--secondary")
                        ]);
                    case 2:
                        return w([
                            Gx("button--tonal")
                        ]);
                    case 8:
                        return w([
                            Gx("button--danger--filled")
                        ]);
                    case 9:
                        return w([
                            Gx("button--danger--outline")
                        ]);
                    case 3:
                        return w([
                            Gx("button--profile")
                        ]);
                    case 4:
                        return w([
                            Gx("button--link")
                        ]);
                    case 5:
                        return w([
                            Gx("button--text")
                        ]);
                    case 6:
                        return w([
                            Gx("button--round")
                        ]);
                    case 7:
                        return w([
                            Gx("button--none")
                        ]);
                    default:
                        return w([
                            Gx("button--close")
                        ]);
                }
            case 1:
                return w([
                    vF(n.a)
                ]);
            case 2:
                var r = n.a;
                return A2(Fu, Px(Cu), r);
            case 3:
                return w([
                    Oq(w([
                        v("button--loading", n.a)
                    ]))
                ]);
            case 4:
                return w([
                    qE(n.a)
                ]);
            case 5:
                return w([
                    A2(lF, "data-test", n.a)
                ]);
            case 6:
                return w([
                    Oq(w([
                        v("button--nowrap", n.a)
                    ]))
                ]);
            case 7:
                return w([
                    A2(gF, n.a, n.b)
                ]);
            case 8:
                return w([
                    mF(n.a)
                ]);
            case 9:
                return w([
                    Gx(Ux(n.a) + "hidden")
                ]);
            default:
                var t = A2(fe, " ", A2(Fu, w_(Ux(n.a)), w([
                    "pointer-events-none",
                    "pointer-none"
                ])));
                return w([
                    Gx(A2(fe, " ", w([
                        "cursor-auto pointer-events-auto",
                        t
                    ])))
                ]);
        }
    }, yF = F2(function(n, r) {
        return A2(sF, A2(Qt, Gx("button"), function(n) {
            return vc(A2(Fu, hF, n));
        }(n)), $(r, w([
            A2(Mx, w([
                Gx("button__spinner")
            ]), g)
        ])));
    }), wF = function(n) {
        return A2(Kk, w([
            Hx(w([
                Gx("flex flex-row")
            ])),
            uF(iF),
            uE(aF)
        ]), w([
            A2(yF, w([
                fF,
                cF(eF)
            ]), w([
                _d(n(Ed.n0))
            ]))
        ]));
    }, xF = cr("h1"), _F = Ox(4), CF = F2(function(n, r) {
        return A2(xF, a_(A2(Qt, _F, n)), r);
    }), AF = hE(3), kF = function(n) {
        return A2(Kk, w([
            Hx(w([
                Gx("flex flex-row")
            ])),
            uF(gE),
            uF(AF),
            uE(aF)
        ]), w([
            A2(CF, g, w([
                _d(n(Ed.yx))
            ])),
            A2(yF, w([
                fF,
                cF(eF)
            ]), w([
                _d(n(Ed.n0))
            ]))
        ]));
    }, EF = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), qF = EF, FF = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return Ot;
            var e = t.b;
            if (r(t.a)) return It(n);
            n += 1, t = e;
        }
    })(0), jF = U, DF = Bx("id"), VF = lr, BF = {
        $: 5
    }, GF = function(n) {
        return {
            $: 3,
            a: n
        };
    }, zF = F5(function(n, r, t, e, u) {
        var a = u.a, c = u.b.yD, o = n + "-" + (0, u.b.yB)(a), f = function() {
            var n = v(t, 0 > s(e, r));
            return 1 !== n.a || n.b ? GF(u) : BF;
        }();
        return (i(e, r) ? sF(w([
            DF(o),
            Gx("tabs__item tabs__item--active")
        ])) : sF(w([
            qE(f),
            DF(o),
            Gx("tabs__item"),
            Oq(w([
                v("tabs__item--previous", !i(f, BF))
            ]))
        ])))(w([
            A2(c_, Cu, c(a))
        ]));
    }), SF = F2(function(n, r) {
        var t = n.sl, e = n.kr, u = n.cx, a = n.iC, c = "translateX(" + jF(n.kq - n.kj + n.kk) + "px) scaleX(" + jF(e) + ")", o = A2(xc, -1, A2(FF, function(n) {
            return i((0, n.b.yB)(n.a), u);
        }, r));
        return A2(zx, w([
            DF(t),
            Gx("tabs"),
            Oq(w([
                v("tabs--interactive", !a)
            ]))
        ]), A2(Qt, A2(Mx, w([
            A2(VF, "transform", c),
            Gx("tabs__underline")
        ]), g), A2(ge, A3(zF, t, o, a), r)));
    }), TF = F2(function(n, r) {
        return A2(c_, k_, A2(SF, r, w([
            A2(qF, 0, {
                yB: qk,
                yD: function() {
                    return _d(n(Ed.yV));
                }
            }),
            A2(qF, 1, {
                yB: qk,
                yD: function() {
                    return _d(n(Ed.vm));
                }
            })
        ])));
    }), PF = F2(function(n, r) {
        return {
            g8: Jk(r.dV) ? w([
                wF(n),
                A2(TF, n, r.dg),
                A2(tF, n, r)
            ]) : w([
                A2(Kk, w([
                    Hx(w([
                        Gx("panel")
                    ]))
                ]), w([
                    kF(n),
                    A2(TF, n, r.dg),
                    A2(tF, n, r)
                ]))
            ]),
            yx: n(Ed.yx)
        };
    }), ZF = C_({
        Cl: Fk,
        CQ: jk,
        Fj: Dk,
        F4: function() {
            return bx;
        },
        Gv: Uk,
        GB: PF
    }), MF = {
        $: 3
    }, LF = function(n) {
        return {
            $: 1,
            a: n
        };
    }, NF = function(n) {
        return {
            $: 0,
            a: n
        };
    }, HF = F4(function(n, r, t, e) {
        var u = A2(Ep, t, e), a = hk(A3(q_, 0, -1, u)), i = hk(A3(q_, 0, 2, u));
        return A5(gk, n, r, a, function(n) {
            return m(n, {
                qZ: It(i),
                lo: It(1e3)
            });
        }, NF);
    }), IF = F2(function(n, r) {
        return A2(bk, w([
            "appointments",
            r
        ]), mk(n));
    }), OF = F2(function(n, r) {
        return A2(bk, w([
            "cancel"
        ]), A2(IF, n, r));
    }), QF = F5(function(n, r, t, e, u) {
        return {
            nu: t,
            n2: e,
            sl: n,
            wo: u,
            x3: r
        };
    }), RF = A3(nk, "provider", fk, A3(nk, "booking_location", uC(tk), A3(nk, "appointment_type", uC(ak), A3(nk, "start_display", uC(M$), A3(nk, "id", M$, au(QF)))))), UF = A2($A, RF, au(cu)), KF = F4(function(n, r, t, e) {
        return A4(aA, n, UF, e, pk(A2(OF, r, t)));
    }), WF = "modal-scroll-content", XF = Xn("setupElementScroll", tx), YF = F2(function(n, r) {
        var t = XF(WF);
        return v({
            Dy: r,
            fR: Ot,
            jk: n,
            bR: 1
        }, t);
    }), JF = function(n) {
        return 3 === n.$ ? It(n.a) : Ot;
    }, nj = F3(function(n, r, t) {
        var e = r.AF.Ao, u = t.Ep.z1, a = function() {
            var n = D_(e);
            if (n.$) return Qp;
            var t = n.a;
            return Uu(w([
                A4(HF, e, t, r.f9, r.bp),
                A4(KF, e, t, u, LF)
            ]));
        }(), i = A2(YF, 0, MF), c = i.b;
        return v({
            z1: u,
            bW: kc,
            eE: A_,
            AD: e,
            bp: r.bp,
            ld: r.ld,
            dM: A_,
            fq: i.a,
            vn: JF(r.vn),
            dV: n,
            f9: r.f9,
            yZ: t
        }, Uu(w([
            c,
            a
        ])));
    }), rj = F2(function(n, r) {
        return v(r, Qp);
    }), tj = F2(function(n, r) {
        return r;
    }), ej = function(n) {
        return {
            $: 6,
            a: n
        };
    }, uj = function(n) {
        return "Enter" === n ? 0 : "Escape" === n ? 1 : 2;
    }, aj = A2(nu, function(n) {
        return "Escape" === n ? au(uj(n)) : AA("nothing");
    }, A2(Iu, "key", M$)), ij = function(n) {
        return A2(eu, n, aj);
    }, cj = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), oj = F2(function(n, r) {
        return {
            vS: r,
            yh: n
        };
    }), fj = Au(A2(oj, g, pa)), sj = function(n) {
        return v($(n.a ? "w_" : "d_", n.b), n);
    }, lj = F6(function(n, r, t, e, u, a) {
        var i = A3(WC, F3(function(e, u, a) {
            n: for(;;){
                var i = a.a, c = a.b;
                if (i.b) {
                    var o = i.a, f = o.a, l = o.b, d = i.b;
                    if (0 > s(f, e)) {
                        a = v(d, A3(n, f, l, c));
                        continue n;
                    }
                    return s(f, e) > 0 ? v(i, A3(t, e, u, c)) : v(d, A4(r, f, l, u, c));
                }
                return v(i, A3(t, e, u, c));
            }
        }), v(Ut(e), a), u), c = i.a, o = i.b;
        return A3(de, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), o, c);
    }), dj = F2(function(n, r) {
        return {
            hS: r,
            ij: n
        };
    }), vj = F3(function(n, r, t) {
        return A2(Du, function(n) {
            return v(r, n);
        }, A3(Jr, t.a ? Yr : Xr, t.b, function(t) {
            return A2(J_, n, A2(dj, r, t));
        }));
    }), bj = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return b(e.a, e.b, A2(Qt, A3(vj, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return b(A2(Qt, r, t.a), e, u);
        }), a = F4(function(n, r, t, e) {
            var u = e.c;
            return b(e.a, A3(ia, n, r, e.b), u);
        }), i = A2(Fu, sj, r), c = A6(lj, u, a, e, t.vS, ed(i), b(g, pa, g)), o = c.b, f = c.c;
        return A2(ju, function(n) {
            return Au(A2(oj, i, A2(XC, o, ed(n))));
        }, A2(ju, function() {
            return Bu(f);
        }, Bu(A2(Fu, lC, c.a))));
    }), mj = F3(function(n, r, t) {
        var e = r.ij, u = r.hS, a = A2(n$, function(n) {
            var r = n.b.c;
            return i(n.a, e) ? A2(nt, r, u) : Ot;
        }, t.yh);
        return A2(ju, function() {
            return Au(t);
        }, Bu(A2(Fu, Gu(n), a)));
    }), pj = F2(function(n, r) {
        return A3(cj, r.a, r.b, A2(eu, n, r.c));
    });
    Tn["Browser.Events"] = Pn(fj, bj, mj, 0, pj);
    var $j, gj, hj, yj, wj, xj = Nn("Browser.Events"), _j = F3(function(n, r, t) {
        return xj(A3(cj, n, r, t));
    }), Cj = A2(_j, 0, "keydown"), Aj = function(n) {
        return n.bR ? bx : Cj(ij(function() {
            return n.Dy;
        }));
    }, kj = In, Ej = nr("onElementScroll", A2(nu, function(n) {
        return A2(nu, function(r) {
            return A2(nu, function(t) {
                return A2(nu, function(e) {
                    return A2(nu, function(u) {
                        return au({
                            nx: u,
                            nA: e,
                            AE: t,
                            Fk: r,
                            xi: n
                        });
                    }, A2(Iu, "atBottom", ru));
                }, A2(Iu, "atTop", ru));
            }, A2(Iu, "clientHeight", I$));
        }, A2(Iu, "scrollHeight", I$));
    }, A2(Iu, "scrollTop", I$))), qj = function() {
        return vx(w([
            Ej(cu)
        ]));
    }, Fj = function(n) {
        return {
            $: 5,
            a: n
        };
    }, jj = function(n) {
        return n.sl;
    }, Dj = uA("put"), Vj = F4(function(n, r, t, e) {
        return A4(Dj, n, UF, e, pk(A2(OF, r, t)));
    }), Bj = function(n) {
        return m(n, {
            bR: 1
        });
    }, Gj = function(n) {
        var r = n.dM;
        if (3 === r.$) {
            var t = A2(no, function(r) {
                return i(mE(r), n.z1);
            }, r.a.z3), e = A2(ra, "start", n.yZ.jb);
            if (e.$) return mb(t);
            var u = e.a, a = A2(no, function(n) {
                return i(ZE(n), It(u));
            }, t);
            return a.b ? It(a.a) : mb(t);
        }
        return Ot;
    }, zj = function(n) {
        return m(n, {
            bR: 0
        });
    }, Sj = F2(function(n, r) {
        return v(m(r, {
            fR: It(n)
        }), Qp);
    }), Tj = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    dM: e = n.a
                }), Qp, 3 === e.$ ? g : A2(Ik, 0, e));
            case 1:
                return b(m(r, {
                    eE: e = n.a
                }), Qp, g);
            case 2:
                return b(m(r, {
                    fq: zj(r.fq)
                }), Qp, g);
            case 3:
                return b(m(r, {
                    fq: Bj(r.fq)
                }), Qp, g);
            case 4:
                var t = (o = D_(r.AD)).$ ? Qp : A4(Vj, r.AD, o.a, r.z1, Fj);
                return b(m(r, {
                    bW: A_
                }), t, g);
            case 5:
                var e = n.a;
                n: for(;;)switch(e.$){
                    case 3:
                        return b(m(r, {
                            bW: e
                        }), Qp, g);
                    case 2:
                        if (8 === e.a.$) return b(m(r, {
                            bW: e,
                            fq: Bj(r.fq)
                        }), A2(__, r.yZ.jb, ai({
                            z1: r.z1
                        })), g);
                        break n;
                    default:
                        break n;
                }
                return b(m(r, {
                    bW: e
                }), Qp, A2(Ik, 0, e));
            case 6:
                var u = A2(Sj, n.a, r.fq), a = u.b;
                return b(m(r, {
                    fq: u.a
                }), A2(Wp, ej, a), g);
            case 7:
                return b(r, A2(__, (i = Gj(r), (c = A2(bb, oE, i)).$ ? pa : ed(w([
                    v("appointment-type", jj(c.a))
                ]))), _a), g);
            default:
                return b(r, A2(__, pa, ga), g);
        }
        var i, c, o;
    }), Pj = {
        $: 7
    }, Zj = {
        $: 4
    }, Mj = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Lj = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Nj = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Hj = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ij = function(n) {
        return 1 === n.$;
    }, Oj = function(n) {
        return 3 === n.$;
    }, Qj = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Rj = Bx("type"), Uj = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Kj = function(n) {
        return Uj(n);
    }, Wj = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Xj = GE(3), Yj = oF(7), Jj = {
        $: 3
    }, nD = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rD = nD(0), tD = Kk(w([
        uF(gE),
        uF(yE)
    ])), eD = F2(function(n, r) {
        switch(r.$){
            case 3:
                return It(A2(yF, w([
                    Yj,
                    Kj(w([
                        Gx("modal__close-full-viewport pointer-events-auto border-0 bg-transparent text-white shadow-none"),
                        Rj("button"),
                        A2(lF, "aria-label", "Close")
                    ])),
                    cF(n.Dy)
                ]), w([
                    tD(w([
                        A2(c_, Cu, A2(Tq, w([
                            Xj,
                            Jj,
                            Wj("text-white")
                        ]), 2))
                    ]))
                ])));
            case 0:
                var t = r.a;
                return It(A2(Kk, w([
                    Hx(w([
                        Gx("modal__body modal__body--full-viewport")
                    ])),
                    uF(rD)
                ]), t));
            default:
                return Ot;
        }
    }), uD = F3(function(n, r, t) {
        return A2(Kk, w([
            Hx(w([
                Gx(1 === n.$ ? "modal-wrap" : "modal-wrap " + n.a)
            ]))
        ]), w([
            A2(sF, w([
                Rj("button"),
                Gx("modal__backdrop-dismiss"),
                A2(lF, "aria-label", "Close"),
                qE(r.Dy)
            ]), g),
            A2(Kk, w([
                Hx(w([
                    Gx("modal__full-viewport-foreground")
                ]))
            ]), w([
                A2(Kk, w([
                    Hx(w([
                        Gx("modal__full-viewport-inner")
                    ]))
                ]), A2(n$, eD(r), t))
            ]))
        ]));
    }), aD = F2(function(n) {
        return "scroll-shadow-" + n;
    }), iD = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("scroll-shadow"),
            Oq(w([
                v(A2(aD, n, t), r)
            ]))
        ]), g);
    }), cD = F2(function(n, r) {
        var t = v(n, r);
        return t.a.$ ? vE : A3(iD, "bottom", !t.a.a.nx, r);
    }), oD = F2(function(n, r) {
        var t = v(n, r);
        return t.a.$ ? vE : A3(iD, "top", !t.a.a.nA, r);
    }), fD = F2(function(n, r) {
        switch(r.$){
            case 3:
                return It(A2(yF, w([
                    Yj,
                    Kj(w([
                        Gx("modal__close-button absolute top-4 right-6 z-10 h-8 w-8 cursor-pointer rounded-full border-0 bg-white p-0 shadow"),
                        Rj("button"),
                        A2(lF, "aria-label", "Close")
                    ])),
                    cF(n.Dy)
                ]), w([
                    tD(w([
                        A2(c_, Cu, A2(Tq, w([
                            zE
                        ]), 2))
                    ]))
                ])));
            case 1:
                var t = r.a;
                return It(A2(zx, w([
                    Gx("modal__header flex flex-col")
                ]), w([
                    A2(zx, w([
                        Gx("modal__header-row flex flex-row w-full")
                    ]), w([
                        A2(zx, w([
                            Gx("w-full")
                        ]), t),
                        (e = n.Dy, A2(zx, w([
                            Gx("cursor-pointer"),
                            qE(e)
                        ]), w([
                            A2(Tq, g, 2)
                        ])))
                    ])),
                    A2(zx, w([
                        Gx("modal__section-divider flex w-full px-8 mt-6 sm:mt-8 border-b border-primary-200 h-1px")
                    ]), g)
                ])));
            case 0:
                return t = r.a, It(A2(zx, w([
                    Gx("scroll-container")
                ]), w([
                    A2(oD, n.fR, n.jk),
                    A2(zx, w([
                        Gx("modal__body"),
                        DF(WF)
                    ]), t),
                    A2(cD, n.fR, n.jk)
                ])));
            default:
                return t = r.a, It(A2(zx, w([
                    Gx("modal__footer")
                ]), w([
                    A2(zx, w([
                        Gx("flex flex-col w-full")
                    ]), w([
                        A2(zx, w([
                            Gx("modal__section-divider flex w-full px-8 mb-6 sm:mb-8 border-b border-primary-200 h-1px")
                        ]), g),
                        A2(zx, w([
                            Gx("modal__footer-actions")
                        ]), t)
                    ]))
                ])));
        }
        var e;
    }), sD = F3(function(n, r, t) {
        var e = A2(zx, w([
            Gx("modal__grabber"),
            A2(lF, "aria-hidden", "true")
        ]), g), u = A2(Kk, w([
            Hx(w([
                Gx(1 === t.$ ? "modal__content" : "modal__content " + t.a)
            ]))
        ]), A2(Qt, e, A2(n$, fD(n), r)));
        return A2(Kk, w([
            Hx(w([
                Gx("modal-wrap")
            ]))
        ]), w([
            A2(sF, w([
                Rj("button"),
                Gx("modal__backdrop-dismiss"),
                A2(lF, "aria-label", "Close"),
                qE(n.Dy)
            ]), g),
            A2(Kk, w([
                Hx(w([
                    Gx("modal")
                ]))
            ]), w([
                u
            ]))
        ]));
    }), lD = F3(function(n, r, t) {
        return t.bR ? vE : 1 === n ? A3(uD, Ot, t, r) : A3(sD, t, r, Ot);
    }), dD = F2(function(n, r) {
        return A3(lD, 0, n, r);
    }), vD = F2(function(n, r) {
        var t = Ij(r.bW), e = Oj(r.bW), u = e ? Ed.od : Ed.n9, a = e ? v(w([
            A2(f_, g, w([
                _d(n(Ed.od))
            ]))
        ]), w([
            A2(yF, w([
                fF,
                cF(Pj)
            ]), w([
                _d(n(Ed.n1))
            ]))
        ])) : v(w([
            A2(f_, g, w([
                _d(n(Ed.n7))
            ]))
        ]), w([
            A2(yF, w([
                fF,
                cF(Zj),
                Qj(t),
                Lj(t)
            ]), w([
                _d(n(Ed.n8))
            ]))
        ])), i = a.a, c = a.b;
        return A2(dD, w([
            Hj(w([
                A2(PE, w([
                    sE
                ]), w([
                    _d(n(u))
                ]))
            ])),
            Mj(i),
            Nj(c)
        ]), r.fq);
    }), bD = {
        $: 8
    }, mD = oF(10), pD = GE(2), $D = function(n) {
        return A2(Kk, w([
            Hx(w([
                Gx("flex")
            ])),
            uF(iF)
        ]), w([
            A2(yF, w([
                mD,
                cF(bD),
                Kj(w([
                    A2(lF, "aria-label", n(Ed.oG))
                ]))
            ]), w([
                A2(Tq, w([
                    pD
                ]), 2)
            ]))
        ]));
    }, gD = function(n) {
        return n.m9;
    }, hD = function(n) {
        return n.qF;
    }, yD = function(n) {
        return n.tA;
    }, wD = function(n) {
        return n.ur;
    }, xD = nD(1), _D = {
        $: 2
    }, CD = oF(1), AD = A2(tE, rE(0), It(3)), kD = F2(function(n, r) {
        return A2(bE, r, A2(Kk, w([
            Hx(w([
                Gx("flex flex-col w-full")
            ])),
            uF(gE),
            uE(AD)
        ]), w([
            A2(yF, w([
                CD,
                cF(_D)
            ]), w([
                _d(n(Ed.hf))
            ]))
        ])));
    }), ED = function(n) {
        return n.oc;
    }, qD = function(n) {
        return n.o6;
    }, FD = function(n) {
        return n.sY;
    }, jD = function(n) {
        return n.sZ;
    }, DD = function(n) {
        return n.trim();
    }, VD = function(n) {
        return mu(DD(n));
    }, BD = function(n) {
        return n.O.nK;
    }, GD = function(n) {
        return n.O.O;
    }, zD = function(n) {
        return n.O.oa;
    }, SD = function(n) {
        return n.O.oc;
    }, TD = function(n) {
        return n.O.pb;
    }, PD = function(n) {
        return n.O.sh;
    }, ZD = function(n) {
        return n.O.sm;
    }, MD = function(n) {
        return n.O.um;
    }, LD = function(n) {
        return n.O.w6;
    }, ND = function(n) {
        return n.O.yz;
    }, HD = function(n) {
        return n.O.yA;
    }, ID = function(n) {
        return n.O.zv;
    }, OD = fE(5), QD = eb("\xa0"), RD = A2(Mx, g, w([
        _d(QD)
    ])), UD = cr("a"), KD = F2(function(n, r) {
        var t = v(n, r);
        if (!t.b.b) return "";
        if (!t.a.b) {
            var e = t.b;
            return f = e.b, (u = e.a).$ ? "" : $(eb(u.a), A2(KD, n, f));
        }
        var u, a = t.a, i = a.a, c = a.b, o = t.b, f = o.b;
        switch((u = o.a).$){
            case 2:
                return A2(xc, "", A2(Op, function(n) {
                    return $(oe(n), A2(KD, c, f));
                }, $u(eb(i))));
            case 1:
                return $(eb(i), A2(KD, c, f));
            default:
                return $(eb(u.a), A2(KD, n, f));
        }
    }), WD = F2(function(n, r) {
        var t = n;
        return mu(r) ? "" : A2(KD, Wm(r), t);
    }), XD = {
        $: 1
    }, YD = {
        $: 2
    }, JD = F2(function(n, r) {
        var t = n.kL;
        return i(r, n.k3) ? YD : i(r, t) ? XD : {
            $: 0,
            a: r
        };
    }), nV = F2(function(n, r) {
        return A2(Fu, JD(n), Wm(r));
    }), rV = F2(function(n, r) {
        return A2(nV, n, r);
    }), tV = rV({
        kL: "*",
        k3: "#"
    }), eV = "(###) ###-####", uV = tV(eV), aV = function(n) {
        return A2(WD, uV, n);
    }, iV = F2(function(n, r) {
        return n ? r : aV(r);
    }), cV = P, oV = function(n) {
        var r;
        return A2(Bx, "href", pr.test(r = n) ? "" : r);
    }, fV = function(n) {
        var r = A2(cV, _e, n);
        return A2(UD, w([
            oV("tel:" + r)
        ]), w([
            A2(Mx, w([
                Gx("hover:underline cursor-pointer text-info-300")
            ]), w([
                _d(A2(iV, 0, r))
            ]))
        ]));
    }, sV = F2(function(n, r) {
        if (r.$) return vE;
        var t = r.a;
        return A2(zx, g, w([
            A2(f_, w([
                OD,
                uF(rD)
            ]), w([
                _d(n(zD))
            ])),
            A2(f_, w([
                uF(rD)
            ]), w([
                _d(n(HD)),
                RD,
                fV(t)
            ]))
        ]));
    }), lV = F2(function(n) {
        return n(PD);
    }), dV = F3(function(n, r, t) {
        var e = v(r, t);
        if (e.a.$ || e.b.$) return vE;
        var u = e.a.a, a = e.b.a;
        return A2(zx, g, w([
            A2(f_, w([
                OD,
                uF(rD)
            ]), w([
                _d(n(MD))
            ])),
            A2(f_, w([
                uF(rD)
            ]), w([
                _d(oe(u)),
                RD,
                _d(A2(lV, n, a)),
                RD,
                _d(n(BD))
            ]))
        ]));
    }), vV = F2(function(n, r) {
        return A2(zx, g, w([
            A2(f_, w([
                OD,
                uF(rD)
            ]), w([
                _d(n(SD))
            ])),
            A2(f_, w([
                uF(rD)
            ]), w([
                _d(r)
            ]))
        ]));
    }), bV = function(n) {
        return n.b.vO;
    }, mV = function(n) {
        var r = bV(n);
        return r.$ ? vE : fV(r.a);
    }, pV = F2(function(n, r) {
        return A2(zx, g, w([
            A2(f_, w([
                uF(xD)
            ]), w([
                _d(n(TD)),
                RD,
                mV(r),
                RD,
                _d(n(ND))
            ]))
        ]));
    }), $V = F6(function(n, r, t, e, u, a) {
        if (r.$) return A2(pV, n, a);
        var i = r.a;
        return VD(i) ? A2(pV, n, a) : A2(zx, w([
            Gx("flex flex-col gap-4")
        ]), w([
            A2(vV, n, i),
            A3(dV, n, t, e),
            A2(sV, n, u)
        ]));
    }), gV = F3(function(n, r, t) {
        if (t.$) return vE;
        var e = t.a;
        return A6($V, n, ED(e), FD(e), jD(e), qD(e), r);
    }), hV = F2(function(n, r) {
        if (r.$) return Ot;
        var t = r.a;
        return It(A2(zx, w([
            Gx("font-extrabold")
        ]), w([
            _d(t)
        ])));
    }), yV = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wV = function(n) {
        return "https://www.google.com/maps/search/?api=1&query=" + $_(A2(xc, n.is, n.ir));
    }, xV = {
        $: 1
    }, _V = vr("rel"), CV = function(n) {
        return A2(vr, "tabIndex", oe(n));
    }, AV = Bx("target"), kV = function(n) {
        switch(n.$){
            case 0:
                return w([
                    oV(n.a)
                ]);
            case 1:
                return w([
                    AV("_blank"),
                    _V("noopener")
                ]);
            case 2:
                return w([
                    Gx("text-current")
                ]);
            case 3:
                return w([
                    Gx(n.a)
                ]);
            case 4:
                return w([
                    Gx("button button--secondary")
                ]);
            case 5:
                return w([
                    Gx("button button--tonal")
                ]);
            case 6:
                return w([
                    Gx("button button--primary text-white hover:text-white")
                ]);
            case 7:
                return w([
                    Gx("button button--profile")
                ]);
            case 8:
                return w([
                    Gx("button--round")
                ]);
            case 9:
                return w([
                    Gx("link--mobile-hidden")
                ]);
            case 10:
                return w([
                    CV(0)
                ]);
            case 11:
                return w([
                    Gx("w-full")
                ]);
            case 12:
                return w([
                    A2(lF, "data-test", n.a)
                ]);
            default:
                return w([
                    qE(n.a)
                ]);
        }
    }, EV = F2(function(n, r) {
        var t = A2(bc, kV, n);
        return A2(UD, A2(Qt, Gx("link"), t), A2(Fu, c_(Cu), r));
    }), qV = F3(function(n, r, t) {
        return n ? A2(EV, w([
            yV(wV(r)),
            xV
        ]), w([
            _d(t)
        ])) : _d(t);
    }), FV = function(n) {
        return w([
            A2(Tq, w([
                zE,
                Wj("fill-none stroke-[32px] stroke-current")
            ]), 11),
            _d(n)
        ]);
    }, jV = function(n) {
        return n ? "Virtual" : "In-person";
    }, DV = function(n) {
        var r = w([
            1
        ]);
        return A2(Xk, n, r) ? w([
            A2(Mx, w([
                Gx("mx-2")
            ]), w([
                _d("\u2022")
            ])),
            _d(jV(n))
        ]) : g;
    }, VV = F3(function(n, r, t) {
        var e = v(r, t);
        if (e.a.$ || e.b.$) return Ot;
        var u, a = e.a.a, i = e.b.a;
        return It(A2(zx, g, w([
            A2(Kk, w([
                OD
            ]), w([
                _d(a.kN)
            ])),
            A2(zx, w([
                Gx("flex items-center")
            ]), A2(Qt, A2(Mx, g, w([
                _d((u = a.kM, A2(fe, " ", w([
                    oe(u),
                    " minutes"
                ]))))
            ])), DV(a.tA))),
            A2(zx, w([
                Gx("flex items-center gap-1")
            ]), FV(i.is)),
            function() {
                var r = i.ir;
                if (r.$) return vE;
                var t = r.a;
                return A2(zx, w([
                    Gx("ml-5")
                ]), w([
                    A3(qV, n, i, t)
                ]));
            }()
        ])));
    }), BV = F2(function(n, r) {
        if (r.b) {
            var t = r.a, e = r.b, u = F2(function(r, t) {
                return A2(Qt, n, A2(Qt, r, t));
            });
            return A2(Qt, t, A3(qu, u, g, e));
        }
        return g;
    }), GV = function(n) {
        return n;
    }, zV = function(n) {
        return n.ur;
    }, SV = Gx("fs-mask"), TV = w([
        SV,
        A2(lF, "data-recording-sensitive", "")
    ]), PV = function(n) {
        return A2(Mx, TV, n);
    }, ZV = function(n) {
        return PV(w([
            _d(n)
        ]));
    }, MV = F2(function(n, r) {
        return A2(Op, function(r) {
            var t, e;
            return A2(zx, w([
                Gx("font-extrabold")
            ]), $(n ? w([
                _d("Book for ")
            ]) : g, w([
                ZV(zV(r)),
                ZV((e = r, t = e.qj, t.$ ? "" : f$(w([
                    " (",
                    A2(_p, "MM/dd/yyyy", t.a),
                    ")"
                ]))))
            ])));
        }, r);
    }), LV = F2(function(n, r) {
        if (r.$) return Ot;
        var t = r.a;
        return It(A2(zx, w([
            Gx("font-extrabold")
        ]), w([
            _d(t)
        ])));
    }), NV = F2(function(n, r) {
        var t, e = r.nt, u = r.tb, a = r.l4, i = r.ex, c = r.s7;
        return t = A2(n$, cu, w([
            A2(MV, r.xz, r.vn),
            A3(VV, c, e, u),
            A2(LV, n, a),
            A2(hV, n, i)
        ])), nE(t) ? vE : A2(zx, w([
            Gx("flex flex-col border border-info-200 bg-info-100 rounded p-4")
        ]), A2(BV, s_, t));
    }), HV = F3(function(n, r, t) {
        var e, u = oE(t), a = pE(ME(t)), i = function(n) {
            return Oj(n.eE);
        }(r);
        return A2(Kk, g, w([
            A2(Kk, w([
                uF(xD),
                uE(eE)
            ]), w([
                A2(CF, g, w([
                    _d(n(Ed.qa))
                ]))
            ])),
            A2(bE, a, A2(Kk, w([
                Hx(w([
                    Gx("flex")
                ])),
                uF(yE),
                uE(aF)
            ]), w([
                A2(Zq, w([
                    6
                ]), w([
                    _d(n(Ed.x7))
                ]))
            ]))),
            A2(Kk, w([
                uE(aF)
            ]), w([
                A2(NV, !1, {
                    ex: ZE(t),
                    nt: A2(Op, function(n) {
                        return {
                            kM: hD(n),
                            kN: CE(n),
                            tA: yD(n)
                        };
                    }, u),
                    s7: !0,
                    tb: A2(Op, function(n) {
                        return {
                            ir: gD(n),
                            is: wD(n)
                        };
                    }, (e = t, e.n2)),
                    vn: r.vn,
                    l4: A2(Op, AE, jE(t)),
                    xz: !1
                })
            ])),
            A2(bE, !(i || a), A3(gV, n, r.dV, u)),
            A2(kD, n, i)
        ]));
    }), IV = function(n) {
        return A2(Kk, w([
            uF(xD)
        ]), w([
            A2(f_, g, w([
                _d(n(Ed.qb))
            ]))
        ]));
    }, OV = F2(function(n, r) {
        switch(r.dM.$){
            case 3:
                if (function(n) {
                    return !Ij(n.eE);
                }(r)) {
                    var t = Gj(r);
                    return t.$ ? IV(n) : A3(HV, n, r, t.a);
                }
                return A2(Kk, g, Nx);
            case 2:
                return IV(n);
            default:
                return A2(Kk, g, Nx);
        }
    }), QV = F2(function(n, r) {
        return {
            g8: w([
                A2(Kk, w([
                    Hx(w([
                        Gx("panel w-full")
                    ]))
                ]), w([
                    $D(n),
                    A2(OV, n, r),
                    A2(vD, n, r)
                ]))
            ]),
            yx: n(Ed.qa)
        };
    }), RV = C_({
        Cl: nj,
        CQ: rj,
        Fj: tj,
        F4: function(n) {
            return vx(w([
                A2(kj, ej, qj()),
                Aj(n.fq)
            ]));
        },
        Gv: Tj,
        GB: QV
    }), UV = F3(function(n, r, t) {
        return {
            nu: r,
            sl: n,
            sF: t
        };
    }), KV = A3(nk, "is_cancellable", ru, A3(nk, "appointment_type", uC(ak), A3(nk, "id", M$, au(UV)))), WV = A2($A, KV, au(cu)), XV = function(n) {
        return w([
            "v1",
            "public",
            n
        ]);
    }, YV = F2(function(n, r) {
        return A2(bk, w([
            "appointments",
            r
        ]), XV(n));
    }), JV = F4(function(n, r, t, e) {
        return A4(aA, n, WV, e, pk(A2(YV, r, t)));
    }), nB = Q, rB = function(n) {
        var r = A2(se, ".", n);
        return ve(r) > 2 ? mb(r) : Ot;
    }, tB = function(n) {
        var r = A2(ra, "subdomain", e$(n));
        return r.$ ? A2(ra, "practice", e$(n)) : It(r.a);
    }, eB = F3(function(n, r, t) {
        var e = {
            g2: kc,
            z1: t.Ep.z1,
            kT: r.AF.EU,
            ld: r.ld,
            vn: Ot,
            dV: n,
            yZ: t
        }, u = A2(xc, Qp, A2(Op, function(n) {
            return A4(JV, e.kT, n, e.z1, cu);
        }, function(n) {
            var r, t = n.EX;
            return A2(Y$, A2(nB, ".hint.com", r = t.Cc) ? rB(r) : Ot, tB(t.jb));
        }(t)));
        return v(e, u);
    }), uB = F2(function(n, r) {
        return v(r, Qp);
    }), aB = F2(function(n, r) {
        return r;
    }), iB = F2(function(n, r) {
        var t = n;
        if (3 === t.$) {
            var e = t.a;
            return b(m(r, {
                g2: t
            }), A2(__, r.yZ.jb, e.sF ? wa({
                z1: r.z1
            }) : ai({
                z1: r.z1
            })), g);
        }
        return b(m(r, {
            g2: kc
        }), Qp, A2(Ik, 0, t));
    }), cB = F2(function(n) {
        return {
            g8: g,
            yx: n(GD)
        };
    }), oB = d_({
        Cl: eB,
        CQ: uB,
        Fj: aB,
        F4: function() {
            return bx;
        },
        Gv: iB,
        GB: cB
    }), fB = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sB = F3(function(n, r, t) {
        var e, u = {
            g2: kc,
            z1: t.Ep.z1,
            eO: r.AF.Ao,
            ld: r.ld,
            vn: JF(r.vn),
            dV: n,
            yZ: t
        };
        return v(u, (e = D_(u.eO)).$ ? Qp : A4(KF, u.eO, e.a, u.z1, fB));
    }), lB = F2(function(n, r) {
        return v(r, Qp);
    }), dB = F2(function(n, r) {
        return r;
    }), vB = function(n) {
        return {
            $: 2,
            a: n
        };
    }, bB = function(n) {
        return n.nn;
    }, mB = function(n) {
        return n.nu;
    }, pB = function(n) {
        return n.n2;
    }, $B = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                n: for(;;)switch(t.$){
                    case 3:
                        return b(m(r, {
                            g2: t
                        }), Qp, g);
                    case 2:
                        if (8 === t.a.$) return b(m(r, {
                            g2: kc
                        }), A2(__, r.yZ.jb, ai({
                            z1: r.z1
                        })), g);
                        break n;
                    default:
                        break n;
                }
                return b(m(r, {
                    g2: kc
                }), Qp, A2(Ik, 0, t));
            case 1:
                return b(r, (c = D_(r.eO)).$ ? Qp : A4(Vj, r.eO, c.a, r.z1, vB), g);
            default:
                t = n.a;
                n: for(;;)switch(t.$){
                    case 3:
                        var e = t.a, u = mB(e), a = (i = v(A2(xc, !1, A2(bb, bB, pB(e))), u)).a && !i.b.$ ? ed(w([
                            v("appointment-type", jj(i.b.a))
                        ])) : pa;
                        return b(m(r, {
                            g2: t
                        }), A2(__, a, xa({
                            z1: r.z1
                        })), g);
                    case 2:
                        if (8 === t.a.$) return b(m(r, {
                            g2: kc
                        }), A2(__, r.yZ.jb, ai({
                            z1: r.z1
                        })), g);
                        break n;
                    default:
                        break n;
                }
                return b(m(r, {
                    g2: kc
                }), Qp, A2(Ik, 0, t));
        }
        var i, c;
    }), gB = {
        $: 1
    }, hB = function(n) {
        return n.x3;
    }, yB = F3(function(n, r, t) {
        return A6($V, n, ED(r), FD(r), jD(r), qD(r), t);
    }), wB = F4(function(n, r, t, e) {
        var u = v(r, t);
        if (3 !== u.a.$ || u.b.$) return A2(zx, g, Nx);
        var a = u.a.a, i = u.b.a, c = function(n) {
            return n.wo;
        }(a), o = pB(a), f = v(mB(a), o);
        if (f.a.$ || f.b.$) return A2(zx, g, Nx);
        var s = f.a.a, l = f.b.a;
        return A2(zx, g, w([
            A2(zx, w([
                Gx("text-center mb-8")
            ]), w([
                A2(CF, g, w([
                    _d(n(GD))
                ]))
            ])),
            A2(zx, w([
                Gx("mb-6")
            ]), w([
                A2(NV, !1, {
                    ex: hB(a),
                    nt: It({
                        kM: hD(s),
                        kN: CE(s),
                        tA: yD(s)
                    }),
                    s7: !1,
                    tb: It({
                        ir: gD(l),
                        is: wD(l)
                    }),
                    vn: It(i),
                    l4: It(AE(c)),
                    xz: !0
                })
            ])),
            A2(zx, w([
                Gx("flex w-full mb-6")
            ]), w([
                A2(yF, w([
                    fF,
                    Kj(w([
                        Gx("ml-auto mr-auto")
                    ])),
                    cF(gB)
                ]), w([
                    _d(n(GD))
                ]))
            ])),
            A3(yB, n, s, e)
        ]));
    }), xB = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel w-full")
                ]), w([
                    A4(wB, n, r.g2, r.vn, r.dV)
                ]))
            ]),
            yx: n(GD)
        };
    }), _B = C_({
        Cl: sB,
        CQ: lB,
        Fj: dB,
        F4: function() {
            return bx;
        },
        Gv: $B,
        GB: xB
    }), CB = F3(function(n, r, t) {
        return v({
            z1: t.Ep.z1,
            ld: r.ld,
            dV: n,
            yZ: t
        }, Qp);
    }), AB = F2(function(n, r) {
        return v(r, Qp);
    }), kB = F2(function(n, r) {
        return r;
    }), EB = function(n) {
        return A2(ra, "appointment-type", n);
    }, qB = F2(function(n, r) {
        var t, e = (t = EB(r.yZ.jb)).$ ? pa : ed(w([
            v("appointment-type", t.a)
        ]));
        return b(r, A2(__, e, _a), g);
    }), FB = F2(function(n) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel w-full")
                ]), w([
                    A2(zx, w([
                        Gx("text-center mb-8")
                    ]), w([
                        A2(CF, g, w([
                            _d(n(ID))
                        ]))
                    ])),
                    A2(zx, w([
                        Gx("mb-6")
                    ]), w([
                        _d(n(ZD))
                    ])),
                    A2(zx, w([
                        Gx("flex w-full mb-6")
                    ]), w([
                        A2(yF, w([
                            fF,
                            Kj(w([
                                Gx("ml-auto mr-auto")
                            ])),
                            cF(0)
                        ]), w([
                            _d("Reschedule")
                        ]))
                    ]))
                ]))
            ]),
            yx: n(LD)
        };
    }), jB = C_({
        Cl: CB,
        CQ: AB,
        Fj: kB,
        F4: function() {
            return bx;
        },
        Gv: qB,
        GB: FB
    }), DB = function(n) {
        return function(n) {
            return A2(Yk, "clinical_calendar_migration", n);
        }(n) || function(n) {
            return A2(Yk, "new_calendar", n);
        }(n);
    }, VB = function(n) {
        return {
            $: 0,
            a: n
        };
    }, BB = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), GB = A3(nk, "appointment_types", ek(ak), au(function(n) {
        return {
            nw: n
        };
    })), zB = A2(tu, au, $A), SB = A2(zB, 0, A2($A, GB, au(BB))), TB = w([
        "v1",
        "booking"
    ]), PB = A2(bk, w([
        "appointment-types"
    ]), TB), ZB = PB, MB = F2(function(n, r) {
        return A4(aA, n, SB, r, pk(ZB));
    }), LB = {
        $: 0
    }, NB = function(n) {
        return n.cc.z$;
    }, HB = function(n) {
        return n.cc.p8;
    }, IB = function(n) {
        return n.cc.Cr;
    }, OB = function(n) {
        return n.cc.sT;
    }, QB = function(n) {
        return n.cc.EC;
    }, RB = function(n) {
        return n.cc.wZ;
    }, UB = function(n) {
        return n.cc.fW;
    }, KB = F2(function(n, r) {
        return r.$ ? r.a.ur : n(NB);
    }), WB = {
        fW: Cd({
            sl: "booking-location-filter",
            Gj: KB,
            Gk: function(n) {
                return n.$ ? It(n.a.sl) : Ot;
            }
        }),
        d9: LB
    }, XB = A2(__, pa, Ku), YB = F3(function(n, r, t) {
        var e = {
            g9: kc,
            eO: r.AF.Ao,
            ld: r.ld,
            lq: WB,
            vn: JF(r.vn),
            dV: n,
            yZ: t
        }, u = DB(n) ? function(n) {
            return A2(MB, n.eO, VB);
        }(e) : XB;
        return v(e, u);
    }), JB = F2(function(n, r) {
        return v(r, Qp);
    }), nG = F2(function(n, r) {
        return m(r, {
            zK: It(9)
        });
    }), rG = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tG = function(n) {
        return n.a.nw;
    }, eG = F2(function(n, r) {
        if (n.$) return r;
        var t = n.a;
        return A2(no, function(n) {
            return i(jj(n), t);
        }, r);
    }), uG = function(n) {
        return n.sl;
    }, aG = {
        $: 2
    }, iG = {
        $: 1
    }, cG = function(n) {
        return {
            $: 0,
            a: n
        };
    }, oG = function(n) {
        return m(n, {
            Eg: !1
        });
    }, fG = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), sG = et("focus"), lG = function(n) {
        return A2(jc, fG(n), sG(n));
    }, dG = F2(function(n, r) {
        switch(n.$){
            case 3:
                return b(r, 1 === (e = v(n.b, i(n.a, r.sl + "-item-active"))).a.$ && e.b ? lG(r.sl + "-item") : Qp, Ot);
            case 0:
                return b(m(r, {
                    Eg: !r.Eg
                }), lG(r.sl + "-input"), It(iG));
            case 1:
            case 5:
                return b(oG(r), Qp, It(aG));
            case 2:
                switch(n.a){
                    case 27:
                    case 38:
                        return b(oG(r), Qp, Ot);
                    case 40:
                        return b(function(n) {
                            return m(n, {
                                Eg: !0
                            });
                        }(r), lG(r.sl + "-item-active"), Ot);
                    default:
                        return b(r, Qp, Ot);
                }
            case 6:
                var t = n.a;
                switch(n.b){
                    case 27:
                        return b(oG(r), lG(r.sl + "-input"), Ot);
                    case 13:
                        return b(oG(r), lG(r.sl + "-input"), It(cG(t)));
                    default:
                        return b(r, Qp, Ot);
                }
            default:
                return t = n.a, b(oG(r), lG(r.sl + "-input"), It(cG(t)));
        }
        var e;
    }), vG = F2(function(n, r) {
        var t = A2(dG, n, r.fW), e = t.b, u = t.c;
        return v(m(r, {
            fW: t.a,
            d9: u.$ || u.a.$ || u.a.a.$ ? r.d9 : u.a.a.a
        }), A2(Wp, cu, e));
    }), bG = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    g9: t
                });
                if (3 === t.$) {
                    var u = t.a, a = A2(eG, EB(e.yZ.jb), tG(u));
                    return b(e, nE(a) ? A2(__, pa, fi) : Qp, g);
                }
                return b(e, Qp, A2(Ik, 0, t));
            case 1:
                var i = n.a, c = i.b;
                return b(r, A2(__, r.yZ.jb, Ca({
                    nv: jj(i.a),
                    n3: uG(c)
                })), g);
            default:
                var o = A2(vG, n.a, r.lq), f = o.b;
                return b(m(r, {
                    lq: o.a
                }), A2(Wp, rG, f), g);
        }
    }), mG = F4(function(n, r, t, e) {
        var u = t.$ ? "Please contact" : t.a + ", please contact", a = function() {
            var n = v(r, e);
            if (n.a.$) return _d(n.b.$ ? "" : u = n.b.a);
            if (n.b.$) return t = n.a.a, A2(Mx, g, w([
                _d("at "),
                A2(UD, w([
                    oV("tel:" + t)
                ]), w([
                    A2(Mx, w([
                        Gx("hover:underline cursor-pointer text-info-300")
                    ]), w([
                        _d(A2(iV, 0, t))
                    ]))
                ])),
                _d(".")
            ]));
            var t = n.a.a, u = n.b.a;
            return A2(Mx, g, w([
                _d("at "),
                A2(UD, w([
                    oV("tel:" + t)
                ]), w([
                    A2(Mx, w([
                        Gx("hover:underline cursor-pointer text-info-300")
                    ]), w([
                        _d(A2(iV, 0, t))
                    ]))
                ])),
                _d(" " + u)
            ]));
        }();
        return A2(Mx, g, w([
            _d(u),
            _d(" "),
            _d(n),
            _d(" "),
            a
        ]));
    }), pG = function(n) {
        return A2(zx, w([
            Gx("flex flex-col")
        ]), w([
            A2(zx, g, w([
                _d("Can't find a service that suits your needs?")
            ])),
            A2(zx, g, w([
                A4(mG, ax(n), bV(n), Ot, Ot)
            ]))
        ]));
    }, $G = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gG = function(n) {
        return n.nm;
    }, hG = F2(function(n, r) {
        var t = F2(function(r, t) {
            var e = t.a, u = t.b;
            return n(r) ? v(A2(Qt, r, e), u) : v(e, A2(Qt, r, u));
        });
        return A3(qu, t, v(g, g), r);
    }), yG = function(n) {
        return n.n4;
    }, wG = function(n) {
        return A2(xc, g, A2(Op, Fu(function(r) {
            return v(n, r);
        }), yG(n)));
    }, xG = F2(function(n, r) {
        var t = function(n) {
            var r = n.d9;
            return r.$ ? It(r.a.sl) : Ot;
        }(n);
        if (t.$) return r;
        var e = t.a;
        return A2(no, function(n) {
            return i(uG(n.b), e);
        }, r);
    }), _G = F2(function(n, r) {
        return A2(na, CE(n), CE(r));
    }), CG = F2(function(n, r) {
        return A2(na, wD(n), wD(r));
    }), AG = F2(function(n, r) {
        var t = n.a, e = r.a, u = A2(CG, n.b, r.b);
        return 1 === u ? A2(_G, t, e) : u;
    }), kG = A, EG = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), qG = Ox(2), FG = function(n) {
        return {
            $: 3,
            a: n
        };
    }, jG = FG(1), DG = function(n) {
        return !gG(n);
    }, VG = Ox(1), BG = function(n) {
        return DG(n) ? A2(Kk, w([
            VG,
            uF(jG),
            Hx(w([
                Gx("text-secondary")
            ]))
        ]), w([
            A2(zx, w([
                Gx("px-3 py-1")
            ]), w([
                _d("Member-only")
            ]))
        ])) : vE;
    }, GG = F2(function(n, r) {
        var t = yD(n);
        return A2(zx, w([
            Gx("flex flex-row cursor-pointer border border-info-200 rounded px-4 py-2 text-primary-500 gap-1 justify-between"),
            qE(A2(EG, n, r))
        ]), w([
            A2(zx, w([
                Gx("flex flex-col gap-1")
            ]), w([
                A2(Kk, w([
                    OD,
                    qG,
                    Hx(w([
                        Gx("text-black")
                    ]))
                ]), w([
                    _d(CE(n))
                ])),
                A2(zx, w([
                    Gx("flex items-center")
                ]), A2(Qt, A2(Mx, g, w([
                    _d(oe(hD(n)) + " minutes")
                ])), DV(t))),
                A2(zx, w([
                    Gx("flex items-center gap-1")
                ]), FV(wD(r)))
            ])),
            BG(n)
        ]));
    }), zG = F2(function(n, r) {
        return A2(zx, w([
            Gx("flex flex-col gap-4")
        ]), A2(Fu, function(n) {
            return A2(GG, n.a, n.b);
        }, A2(kG, AG, A2(xG, n, A2(bc, wG, r)))));
    }), SG = {
        $: 4
    }, TG = function(n) {
        return {
            $: 1,
            a: n
        };
    }, PG = TG({
        $: 0
    }), ZG = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), MG = F2(function(n, r) {
        return A2(ZG, n, r);
    }), LG = function(n) {
        return {
            $: 1,
            a: {
                sl: uG(n),
                ur: wD(n)
            }
        };
    }, NG = function(n) {
        return A2(Qt, A2(MG, g, LB), A2(Qt, PG, A2(Fu, A2(tu, LG, MG(g)), n)));
    }, HG = function(n) {
        return {
            $: 1,
            a: n
        };
    }, IG = function(n) {
        return A2(xc, g, yG(n));
    }, OG = pa, QG = F2(function(n, r) {
        return A3(ia, n, 0, r);
    }), RG = F2(function(n, r) {
        return !A2(ra, n, r).$;
    }), UG = F2(function(n, r) {
        return A2(RG, n, r);
    }), KG = F4(function(n, r, t, e) {
        for(;;){
            if (!t.b) return Ae(e);
            var u = t.a, a = t.b, i = n(u);
            A2(UG, i, r) ? t = a : (r = A2(QG, i, r), t = a, e = A2(Qt, u, e));
        }
    }), WG = F2(function(n, r) {
        return A4(KG, n, OG, r, g);
    }), XG = function(n) {
        return {
            $: 0,
            a: n
        };
    }, YG = {
        $: 1
    }, JG = {
        $: 0
    }, nz = function(n) {
        return {
            $: 2,
            a: n
        };
    }, rz = {
        $: 5
    }, tz = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ez = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), uz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, az = F3(function(n, r, t) {
        return n ? $(t, w([
            r
        ])) : t;
    }), iz = A2(Mx, w([
        Gx("select__arrow")
    ]), g), cz = cr("label"), oz = Bx("value"), fz = F2(function(n, r) {
        return n.$ ? r : A2(Qt, oz(n.a), r);
    }), sz = cr("input"), lz = function(n) {
        return w([
            Gx("select__item__input"),
            Rj("radio"),
            vF(n.Bb)
        ]);
    }, dz = Bx("name"), vz = function(n) {
        return A2(EE, "mousedown", au(n));
    }, bz = {
        Bb: !1,
        ij: Ot
    }, mz = F2(function(n, r) {
        return m(r, {
            Bb: n
        });
    }), pz = F2(function(n, r) {
        var t = n.Gk, e = n.Gj, u = n.jo, a = n.Fr, c = n.Du, o = n.DX, f = n.DN, s = r.a, l = r.b, d = t(l), b = A3(de, mz, bz, s), m = b.Bb ? g : w([
            vz(o(It(l)))
        ]), p = A2(xc, A2(xc, "", d), b.ij), h = A2(xc, !1, A2(Op, function(n) {
            return i(t(n), t(l));
        }, u)), y = $(a, h ? "-item-active" : "-item"), x = A2(fz, d, w([
            mF(f(It(l))),
            A2(gF, c, a),
            DF(y),
            dz(a)
        ]));
        return v(p, A2(cz, A2(Qt, Gx("select__item"), A2(Qt, A2(lF, "role", "option"), A2(Qt, Oq(w([
            v("select__item--active", h),
            v("select__item--disabled", b.Bb)
        ])), m))), w([
            A2(sz, $(lz(b), x), g),
            A2(Mx, g, w([
                A2(c_, Cu, e(l))
            ]))
        ])));
    }), $z = F2(function(n, r) {
        if (1 === r.$) {
            var t = r.a;
            if (t.$) {
                var e = t.a;
                return v("0", A2(cz, w([
                    Gx("select__item select__item--disabled")
                ]), w([
                    _d(e)
                ])));
            }
            return v("0", A2(cz, w([
                Gx("select__item--divider")
            ]), g));
        }
        return A2(pz, n, v(r.a, r.b));
    }), gz = function(n) {
        return or(gr(n));
    }, hz = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), yz = F2(function(n, r) {
        return A2(hz, n, r);
    }), wz = {
        $: 0
    }, xz = {
        kO: g,
        hJ: 1,
        Bb: !1,
        e1: !1,
        Cr: !1,
        ih: !0,
        i$: !1,
        EC: "Pick an item",
        ee: wz,
        y4: Ot
    }, _z = F2(function(n, r) {
        switch(n.$){
            case 2:
                return m(r, {
                    Bb: n.a
                });
            case 0:
                return m(r, {
                    y4: n.a
                });
            case 1:
                return m(r, {
                    EC: n.a
                });
            case 3:
                return m(r, {
                    Cr: n.a
                });
            case 5:
                return m(r, {
                    i$: n.a
                });
            case 4:
                return m(r, {
                    e1: !0
                });
            case 6:
                return m(r, {
                    ee: n.a
                });
            case 7:
                return m(r, {
                    ih: n.a
                });
            default:
                return m(r, {
                    hJ: n.a
                });
        }
    }), Cz = function(n) {
        return 1 !== n.$;
    }, Az = oF(3), kz = oF(6), Ez = function(n) {
        var r = i(n.ee, wz), t = Cz(n.y4), e = i(n.ee, uz(1)) ? w([
            kz,
            Az
        ]) : w([
            CD
        ]);
        return A2(Qt, Kj($(n.kO, w([
            Oq(w([
                v("select--invalid", n.Cr),
                v("select__input", r),
                v("select__input--selected", t && r)
            ]))
        ]))), A2(Qt, Lj(n.Bb), e));
    }, qz = F4(function(n, r, t, e) {
        var u, a, c, o = A3(de, _z, xz, r), f = A2(xc, _d(o.EC), A2(Op, e.dJ(n), o.y4)), s = {
            Du: rz,
            DN: ez,
            DX: tz,
            Fr: e.sl,
            jo: o.y4,
            Gj: e.dJ(n),
            Gk: e.ln
        }, l = i(o.ee, uz(1));
        return A2(zx, $(o.i$ ? TV : g, w([
            Gx("select"),
            Oq(w([
                v("select--open", e.Eg),
                v("w-full", o.e1)
            ])),
            DF(e.sl)
        ])), w([
            A2(yF, A2(Qt, Kj(w([
                Oq(w([
                    v("w-full", !l)
                ])),
                DF(e.sl + "-input")
            ])), A2(Qt, cF(JG), A2(Qt, A2(yz, YG, e.sl), A2(Qt, (a = nz, c = a, {
                $: 8,
                a: c
            }), A2(Qt, Kj(w([
                Rj("button")
            ])), Ez(o)))))), A3(az, !l, iz, w([
                A2(c_, Cu, f)
            ]))),
            !o.Bb && e.Eg ? A3(gz, "div", w([
                Gx("select__items"),
                Oq(w([
                    v("select__items--nowrap", !o.ih)
                ])),
                (u = o.hJ, Gx(function() {
                    switch(u){
                        case 2:
                            return "select__items--right";
                        case 0:
                            return "select__items--top";
                        default:
                            return "";
                    }
                }()))
            ]), A2(Fu, $z(s), t)) : vE
        ]));
    }), Fz = F3(function(n, r, t) {
        var e = function(n) {
            return A2(kG, CG, A2(WG, uG, A2(bc, IG, n)));
        }(r);
        return ve(e) > 1 ? A2(zx, w([
            Gx("flex flex-col gap-2")
        ]), w([
            A2(f_, w([
                sE
            ]), w([
                _d(n(OB))
            ])),
            A2(c_, cu, A4(qz, n, w([
                XG(It(t.d9)),
                SG,
                HG(n(QB))
            ]), NG(e), t.fW))
        ])) : vE;
    }), jz = F4(function(n, r, t, e) {
        var u = A2(eG, EB(r.jb), tG(e)), a = A2(hG, gG, u), i = a.a, c = a.b;
        return w([
            A2(c_, rG, A3(Fz, n, u, t)),
            A2(c_, $G, A2(zG, t, c)),
            A2(c_, $G, A2(zG, t, i))
        ]);
    }), Dz = function(n) {
        return n.a.tA;
    }, Vz = function(n) {
        return n.a.ur;
    }, Bz = function(n) {
        var r;
        return {
            kM: (r = n, r.a.qF),
            kN: Vz(n),
            tA: Dz(n)
        };
    }, Gz = function(n) {
        return {
            ir: gD(n),
            is: wD(n)
        };
    }, zz = F2(function(n, r) {
        var t = r.vn, e = r.n2, u = r.l4;
        return A2(NV, n, {
            ex: r.ex,
            nt: A2(Op, Bz, r.z2),
            s7: !1,
            tb: A2(Op, Gz, e),
            vn: t,
            l4: u,
            xz: !0
        });
    }), Sz = F2(function(n, r) {
        var t = r.g9;
        if (3 === t.$) {
            var e = t.a;
            return A2(zx, w([
                Gx("flex flex-col gap-4")
            ]), A2(Qt, A2(zz, !1, {
                ex: Ot,
                z2: Ot,
                n2: Ot,
                vn: r.vn,
                l4: Ot
            }), $(A4(jz, n, r.yZ, r.lq, e), w([
                pG(r.dV)
            ]))));
        }
        return A2(zx, g, Nx);
    }), Tz = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("flex flex-col gap-4")
                ]), w([
                    A2(Sz, n, r)
                ]))
            ]),
            yx: n(Ed.Aj)
        };
    }), Pz = C_({
        Cl: YB,
        CQ: JB,
        Fj: nG,
        F4: function() {
            return bx;
        },
        Gv: bG,
        GB: Tz
    }), Zz = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Mz = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Lz = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Nz = A4(JA, "redirect_button_text", uC(M$), Ot, A4(JA, "redirect_url", uC(M$), Ot, A4(JA, "notes_custom_question", uC(M$), Ot, A4(JA, "notes_required", ru, !1, A3(nk, "allow_instant_book", ru, A3(nk, "require_provider_selection", ru, A3(nk, "booking_location", tk, A3(nk, "meeting_type", kA, A3(nk, "duration", O$, A3(nk, "name", M$, A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    nk: i,
                                                    n2: u,
                                                    qF: t,
                                                    sl: n,
                                                    tA: e,
                                                    ur: r,
                                                    uJ: o,
                                                    uK: c,
                                                    wI: s,
                                                    wJ: f,
                                                    wY: a
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), Hz = A2(zB, 0, A2($A, Nz, au(Lz))), Iz = F2(function(n, r) {
        return A2(bk, w([
            n,
            "location",
            r
        ]), PB);
    }), Oz = F2(function(n, r) {
        return A2(Iz, n, r);
    }), Qz = F4(function(n, r, t, e) {
        return A4(aA, n, Hz, e, pk(A2(Oz, r, t)));
    }), Rz = F3(function(n, r, t) {
        return A4(Qz, n, r, t, Mz);
    }), Uz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Kz = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wz = A3(kp, 1992, 4, 31), Xz = Cn(function(n) {
        n(xn(A2(Nc, -(new Date).getTimezoneOffset(), g)));
    }), Yz = ($j = Xp, Cn(function(n) {
        n(xn($j(Date.now())));
    })), Jz = A3(Vu, Ep, Xz, Yz), nS = v({
        b5: It(Wz),
        fD: 0,
        yG: Wz
    }, A2(Nu, Kz, Jz)), rS = v({
        nu: Ot,
        cC: Ot,
        b0: nS.a,
        at: Ot,
        a$: Ot
    }, A2(Wp, Uz, nS.b)), tS = function(n) {
        return n.v4;
    }, eS = function(n) {
        return A2(bb, tS, JF(n));
    }, uS = F3(function(n, r, t) {
        var e = rS.a, u = rS.b, a = {
            cA: kc,
            nv: t.Ep.nv,
            cB: kc,
            cD: Ot,
            n3: t.Ep.n3,
            eO: r.AF.Ao,
            ld: r.ld,
            vn: JF(r.vn),
            iX: eS(r.vu),
            dV: n,
            ah: e,
            yZ: t
        }, i = DB(n) ? A3(Rz, a.eO, a.nv, a.n3) : XB;
        return v(a, Uu(w([
            i,
            A2(Wp, Zz, u)
        ])));
    }), aS = F2(function(n, r) {
        return v(m(r, {
            iX: eS(n.vu)
        }), Qp);
    }), iS = F2(function(n, r) {
        return m(r, {
            zK: It(9)
        });
    }), cS = function(n) {
        return {
            $: 2,
            a: n
        };
    }, oS = function(n) {
        return {
            $: 3,
            a: n
        };
    }, fS = nr("gotItemPort", A2(nu, function(n) {
        return A2(nu, function(r) {
            return A2(nu, function(t) {
                return au({
                    zL: t,
                    CI: r,
                    y4: n
                });
            }, A2(Iu, "action", M$));
        }, A2(Iu, "itemType", M$));
    }, A2(Iu, "value", Q$(w([
        XA(Ot),
        A2(eu, It, M$)
    ]))))), sS = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), lS = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), dS = function(n) {
        switch(n){
            case "OnlineEnrollment":
                return 0;
            case "PageAbandoned":
                return 1;
            case "Booking":
                return 4;
            default:
                return 2;
        }
    }, vS = F2(function(n, r) {
        var t = r.y4, e = r.CI, u = r.zL;
        switch(u){
            case "set":
                return n(te({
                    $: 0,
                    a: dS(e)
                }));
            case "get":
                return n(te(A2(sS, dS(e), t)));
            case "remove":
                return n(te(A2(lS, dS(e), !1)));
            case "removeAndRedirect":
                return n(te(A2(lS, dS(e), !0)));
            default:
                return n(Yt("Action " + u + " not supported"));
        }
    }), bS = function(n) {
        return fS(vS(n));
    }, mS = nr("removedItemPort", A2(nu, function(n) {
        return A2(nu, function(r) {
            return A2(nu, function(t) {
                return au({
                    zL: t,
                    CI: r,
                    y4: n
                });
            }, A2(Iu, "action", M$));
        }, A2(Iu, "itemType", M$));
    }, A2(Iu, "value", Q$(w([
        XA(Ot),
        A2(eu, It, M$)
    ]))))), pS = function(n) {
        return mS(vS(n));
    }, $S = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), gS = "bookingForm", hS = {
        ew: Ot,
        ex: Ot,
        ey: Ot,
        qj: Ot,
        qN: Ot,
        rA: Ot,
        sV: Ot,
        ft: Ot,
        vO: Ot,
        fK: Ot,
        l4: Ot
    }, yS = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), wS = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), xS = F3(function(n, r, t) {
        return {
            nF: r,
            pV: n,
            y2: t
        };
    }), _S = F2(function(n, r) {
        return {
            pS: n,
            yw: r
        };
    }), CS = F5(function(n, r, t, e, u) {
        return {
            q_: e,
            xv: u,
            x$: n,
            x4: t,
            y1: r
        };
    }), AS = A3(nk, "short_tz_display_text", M$, A3(nk, "end_display_text", M$, A3(nk, "start_display_text", M$, A3(nk, "user_id", M$, A3(nk, "start", M$, au(CS)))))), kS = A2($A, AS, au(cu)), ES = A3(nk, "time_slots", ek(kS), A3(nk, "date", KA, au(_S))), qS = A2($A, ES, au(cu)), FS = A3(nk, "users", ek(fk), A3(nk, "availabilities_date", KA, A3(nk, "availabilities", ek(qS), au(xS)))), jS = A2(zB, 0, A2($A, FS, au(wS))), DS = {
        x0: Ot
    }, VS = function(n) {
        var r, t = n(DS);
        return vc(w([
            (r = t.x0, r.$ ? g : w([
                A2(g_, "startDate", r.a)
            ]))
        ]));
    }, BS = F2(function(n, r) {
        return A2(bk, w([
            "availability"
        ]), A2(Iz, n, r));
    }), GS = F5(function(n, r, t, e, u) {
        return A4(aA, n, jS, u, A2($k, VS(r), pk(A2(BS, t, e))));
    }), zS = F5(function(n, r, t, e, u) {
        return A5(GS, n, function(n) {
            return m(n, {
                x0: It(e)
            });
        }, r, t, yS(u));
    }), SS = F2(function(n, r) {
        for(;;){
            if (!r.b) return Ot;
            var t = r.a, e = r.b;
            if (n(t)) return It(t);
            r = e;
        }
    }), TS = F2(function(n, r) {
        return A2(SS, function(n) {
            return i(AE(n), r);
        }, n);
    }), PS = function(n) {
        var r = Qb(n), t = Yb(n);
        return A3(kp, r, t, 1);
    }, ZS = function(n) {
        return n.ew;
    }, MS = function(n) {
        return n.a.n2;
    }, LS = F2(function(n, r) {
        return {
            b5: r,
            fD: 0,
            yG: n
        };
    }), NS = function(n) {
        return A2(_p, "yyyy-MM-dd", n);
    }, HS = function(n) {
        return n.yG;
    }, IS = F2(function(n, r) {
        var t = r.nu;
        if (t.$) return Ot;
        var e = HS(MS(t.a)), u = A2(Op, NS, e), a = A2(Y$, A2(Op, hk, A2(Op, PS, A2(bb, L$, A2(Op, RA, A2(bb, ZS, n))))), u);
        if (a.$) return Ot;
        var i = a.a, c = v(e, RA(i));
        return c.a.$ || c.b.$ ? Ot : It(v(m(r, {
            b0: A2(LS, c.a.a, It(c.b.a))
        }), i));
    }), OS = function(n) {
        return 1 === n.$;
    }, QS = function(n) {
        return n.ur;
    }, RS = Xn("getItemPort", function(n) {
        return rx(w([
            v("action", tx(n.zL)),
            v("itemType", tx(n.CI)),
            v("key", tx(n.ij)),
            v("value", tx(n.y4))
        ]));
    }), US = function(n) {
        switch(n){
            case 0:
                return "OnlineEnrollment";
            case 1:
                return "PageAbandoned";
            case 2:
                return "Practice";
            case 3:
                return "Language";
            default:
                return "Booking";
        }
    }, KS = Xn("removeItemPort", function(n) {
        return rx(w([
            v("action", tx(n.zL)),
            v("itemType", tx(n.CI)),
            v("key", tx(n.ij)),
            v("value", tx(n.y4))
        ]));
    }), WS = Xn("setItemPort", function(n) {
        return rx(w([
            v("action", tx(n.zL)),
            v("itemType", tx(n.CI)),
            v("key", tx(n.ij)),
            v("value", tx(n.y4))
        ]));
    }), XS = function(n) {
        switch(n.$){
            case 0:
                var r = n.b, t = n.c;
                return WS({
                    zL: "set",
                    CI: US(n.a),
                    ij: r,
                    y4: t
                });
            case 1:
                return r = n.b, RS({
                    zL: "get",
                    CI: US(n.a),
                    ij: r,
                    y4: ""
                });
            case 2:
                return r = n.b, KS({
                    zL: "remove",
                    CI: US(n.a),
                    ij: r,
                    y4: ""
                });
            default:
                return r = n.b, KS({
                    zL: "removeAndRedirect",
                    CI: US(n.a),
                    ij: r,
                    y4: ""
                });
        }
    }, YS = function(n) {
        return n.a.wY;
    }, JS = function(n) {
        return n.at;
    }, nT = function(n) {
        return n.a$;
    }, rT = function(n) {
        return n.xv;
    }, tT = function(n) {
        return n.x4;
    }, eT = F2(function(n, r) {
        return m(r, {
            ex: n
        });
    }), uT = F2(function(n, r) {
        return A2(eT, It(n), r);
    }), aT = F3(function(n, r, t) {
        var e, u = A2(fe, " ", w([
            tT(n),
            "-",
            (e = n, e.q_),
            rT(n)
        ])), a = A2(fe, ", ", w([
            A2(_p, "MMMM d, y", r),
            u
        ]));
        return A2(uT, a, t);
    }), iT = function(n) {
        return n.ey;
    }, cT = function(n) {
        return n.fK;
    }, oT = function(n) {
        return n.pS;
    }, fT = function(n) {
        return n.a.pV;
    }, sT = function(n) {
        return n.yw;
    }, lT = function(n) {
        return A2(bc, function(n) {
            return A2(Fu, function(r) {
                return v(oT(n), r);
            }, sT(n));
        }, fT(n));
    }, dT = function(n) {
        return n.y1;
    }, vT = function(n) {
        return n.y1;
    }, bT = F2(function(n, r) {
        return A2(no, function(r) {
            return i(dT(r.b), vT(n));
        }, lT(r));
    }), mT = function(n) {
        return A2(xc, !0, A2(Op, YS, n));
    }, pT = function(n) {
        return n.a.y2;
    }, $T = function(n) {
        var r = n.cC;
        if (r.$) return n;
        var t = r.a, e = v(mT(n.nu), n.a$);
        if (e.a && !e.b.$) return m(n, {
            at: A2(Op, Ue, mb(A2(bT, e.b.a, t)))
        });
        var u = mb(lT(t));
        if (u.$) return m(n, {
            at: Ot,
            a$: Ot
        });
        var a = u.a, c = a.a, o = a.b, f = A2(SS, function(n) {
            return i(vT(n), dT(o));
        }, pT(t));
        return m(n, {
            at: It(c),
            a$: f
        });
    }, gT = function(n) {
        return n.x$;
    }, hT = F3(function(n, r, t) {
        var e = v(n, r);
        if (e.a.$ || e.b.$) return t;
        var u = e.a.a, a = e.b.a, c = A2(no, function(n) {
            var r = n.b;
            return i(n.a, u) && i(gT(r), a);
        }, t);
        return nE(c) ? t : c;
    }), yT = F2(function(n, r) {
        return A2(SS, function(n) {
            return i(vT(n), dT(r));
        }, n);
    }), wT = F2(function(n, r) {
        return v(A2(bb, yT(n), A2(Op, Oc, r)), A2(Op, Ue, r));
    }), xT = F4(function(n, r, t, e) {
        var u = e.cC;
        if (u.$) return e;
        var a = u.a, c = lT(a), o = A3(hT, r, n, c), f = function() {
            if (mT(e.nu)) {
                var n = pT(a), r = function() {
                    if (t.$) return mb(o);
                    var n = t.a;
                    return A2(Y$, A2(SS, function(r) {
                        return i(dT(r.b), n);
                    }, o), mb(o));
                }();
                return A2(wT, n, r);
            }
            var u = A2(Op, Ue, mb(o));
            return v(Ot, u);
        }();
        return m(e, {
            at: f.b,
            a$: f.a
        });
    }), _T = F6(function(n, r, t, e, u, a) {
        var i = e.a.nF, c = HS(MS(t)), o = c.$ ? a.b0 : A2(LS, c.a, It(i)), f = m(a, {
            cC: It(e),
            b0: o
        });
        if (n) {
            var s = A2(bb, cT, r);
            return A4(xT, A2(bb, iT, r), A2(bb, L$, A2(Op, RA, A2(bb, ZS, r))), A2(Y$, s, u), f);
        }
        return $T(f);
    }), CT = F2(function(n, r) {
        return m(r, {
            ew: n
        });
    }), AT = F2(function(n, r) {
        return A2(CT, It(n), r);
    }), kT = F2(function(n, r) {
        return m(r, {
            ey: n
        });
    }), ET = F2(function(n, r) {
        return A2(kT, It(n), r);
    }), qT = F3(function(n, r, t) {
        return A2(AT, NS(r), A2(ET, n, t));
    }), FT = F2(function(n, r) {
        return m(r, {
            fK: n
        });
    }), jT = F2(function(n, r) {
        return A2(FT, It(n), r);
    }), DT = F2(function(n, r) {
        return m(r, {
            l4: n
        });
    }), VT = F2(function(n, r) {
        return A2(DT, It(n), r);
    }), BT = F3(function(n, r, t) {
        var e = v(n, r);
        if (e.a && !e.b.$) {
            var u = e.b.a;
            return A2(VT, AE(u), A2(jT, vT(u), t));
        }
        return t;
    }), GT = "appointment_date", zT = "appointment_display", ST = "appointment_start", TT = "email", PT = F2(function(n, r) {
        return A2(Op, function(r) {
            return v(n, tx(r));
        }, r);
    }), ZT = "first_name", MT = "last_name", LT = "notes", NT = "phone", HT = "provider_id", IT = "provider_name", OT = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), QT = function(n) {
        var r;
        return r = function(n) {
            var r;
            return A2(ce, 2, rx(A2(n$, cu, w([
                A2(PT, HT, (r = n).fK),
                A2(PT, IT, r.l4),
                A2(PT, GT, r.ew),
                A2(PT, ST, r.ey),
                A2(PT, zT, r.ex),
                A2(PT, ZT, r.rA),
                A2(PT, MT, r.sV),
                A2(PT, "dob", r.qj),
                A2(PT, TT, r.qN),
                A2(PT, NT, r.vO),
                A2(PT, LT, r.ft)
            ]))));
        }(n), XS(A3(OT, 4, gS, r));
    }, RT = A4(JA, LT, uC(M$), Ot, A4(JA, NT, uC(M$), Ot, A4(JA, TT, uC(M$), Ot, A4(JA, "dob", uC(M$), Ot, A4(JA, MT, uC(M$), Ot, A4(JA, ZT, uC(M$), Ot, A4(JA, zT, uC(M$), Ot, A4(JA, ST, uC(M$), Ot, A4(JA, GT, uC(M$), Ot, A4(JA, IT, uC(M$), Ot, A4(JA, HT, uC(M$), Ot, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    ew: t,
                                                    ex: u,
                                                    ey: e,
                                                    qj: c,
                                                    qN: o,
                                                    rA: a,
                                                    sV: i,
                                                    ft: s,
                                                    vO: f,
                                                    fK: n,
                                                    l4: r
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), UT = A2($A, RT, au(cu)), KT = function(n) {
        var r = A2(i$, UT, n);
        return r.$ ? Ot : It(r.a);
    }, WT = {
        kQ: function(n) {
            return _d(n);
        },
        on: {
            $: 0
        },
        eM: "calendar-datepicker--",
        kV: g,
        A4: function(n) {
            switch(n){
                case 0:
                    return "Mo";
                case 1:
                    return "Tu";
                case 2:
                    return "We";
                case 3:
                    return "Th";
                case 4:
                    return "Fr";
                case 5:
                    return "Sa";
                default:
                    return "Su";
            }
        },
        Br: Ot,
        hZ: 6,
        Cw: wm(!1),
        lB: function(n) {
            switch(n){
                case 0:
                    return "January";
                case 1:
                    return "February";
                case 2:
                    return "March";
                case 3:
                    return "April";
                case 4:
                    return "May";
                case 5:
                    return "June";
                case 6:
                    return "July";
                case 7:
                    return "August";
                case 8:
                    return "September";
                case 9:
                    return "October";
                case 10:
                    return "November";
                default:
                    return "December";
            }
        },
        zr: oe
    }, XT = function(n) {
        switch(n){
            case 0:
                return "M";
            case 1:
            case 3:
                return "T";
            case 2:
                return "W";
            case 4:
                return "F";
            default:
                return "S";
        }
    }, YT = function(n) {
        return A2(xc, g, A2(Op, fT, n.cC));
    }, JT = F3(function(n, r, t) {
        if (n) {
            if (r.$) return g;
            var e = r.a;
            return A2(no, function(n) {
                return i(dT(n), vT(e));
            }, t);
        }
        return t;
    }), nP = F2(function(n, r) {
        return mb(A2(no, function(r) {
            return i(oT(r), n);
        }, r));
    }), rP = F2(function(n, r) {
        var t = YT(n), e = v(n.nu, nE(t));
        if (e.a.$ || e.b) return !0;
        var u = e.a.a, a = A2(nP, r, t);
        if (a.$) return !0;
        var i = sT(a.a), c = A3(JT, mT(It(u)), n.a$, i);
        return nE(c);
    }), tP = function(n) {
        return m(WT, {
            A4: XT,
            Br: A2(bb, HS, A2(Op, MS, n.nu)),
            Cw: rP(n)
        });
    }, eP = {
        $: 0
    }, uP = F3(function(n, r, t) {
        var e = t;
        switch(r.$){
            case 0:
                return v(m(e, {
                    b5: It(u = r.a),
                    yG: u
                }), eP);
            case 1:
                return v(m(e, {
                    b5: It(u = r.a)
                }), {
                    $: 2,
                    a: u
                });
            default:
                var u = r.a;
                return v(m(e, {
                    b5: Ot
                }), function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(u));
        }
    }), aP = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = m(r, {
                    a$: It(n.a)
                });
                return b(Cz(r.at) ? t : $T(t), Qp, Ot);
            case 1:
                var e = n.a, u = A3(uP, tP(r), e, r.b0), a = u.b, i = m(r, {
                    b0: u.a
                });
                switch(a.$){
                    case 1:
                        return b(m(i, {
                            at: It(a.a)
                        }), Qp, Ot);
                    case 2:
                        var c = a.a;
                        return b(m(i, {
                            at: Ot
                        }), Qp, It({
                            $: 0,
                            a: c
                        }));
                    default:
                        return b(i, Qp, Ot);
                }
            default:
                return b(r, Qp, It(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(n.a)));
        }
    }), iP = F2(function(n, r) {
        return m(r, {
            nu: It(n)
        });
    }), cP = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? b(m(r, {
                    cB: t,
                    ah: A2(iP, i = t.a, r.ah)
                }), XS(A2($S, 4, gS)), g) : b(m(r, {
                    cB: kc
                }), Qp, A2(Ik, 0, t));
            case 1:
                var e = n.a, u = n.b, a = v(r.cB, u);
                if (3 === a.a.$ && 3 === a.b.$) {
                    var i = a.a.a, c = a.b.a, o = pT(c), f = YS(i), s = m(r, {
                        cA: u
                    });
                    if (f && nE(o)) return b(s, A2(__, pa, fi), g);
                    var l = A2(Op, vT, A2(bb, TS(o), A2(Op, QS, r.iX)));
                    return b(m(s, {
                        ah: h = A6(_T, e, r.cD, i, c, l, r.ah)
                    }), Qp, g);
                }
                return b(m(r, {
                    cA: kc
                }), Qp, A2(Ik, 0, u));
            case 2:
                if ((x = n.a).$) return b(m(r, {
                    cD: Ot
                }), Qp, g);
                if (1 === (_ = x.a).$ && 4 === _.a) {
                    var d = A2(bb, KT, _.b), p = A2(IS, d, r.ah);
                    if (p.$) return b(r, Qp, g);
                    var $ = p.a, h = $.a, y = A5(zS, r.eO, r.nv, r.n3, $.b, !0);
                    return b(m(r, {
                        cD: d,
                        ah: h
                    }), y, g);
                }
                return b(r, Qp, g);
            case 3:
                var x, _;
                return (x = n.a).$ ? b(r, Qp, g) : 2 === (_ = x.a).$ && 4 === _.a ? b(m(r, {
                    cD: Ot
                }), Qp, g) : b(r, Qp, g);
            default:
                var C = A2(aP, n.a, r.ah), A = C.b, k = C.c, E = m(r, {
                    ah: h = C.a
                }), q = A2(Wp, Zz, A);
                if (k.$) return b(E, q, g);
                var F = k.a;
                if (F.$) {
                    var j = F.a, D = v(E.cB, JS(r.ah));
                    if (3 !== D.a.$ || D.b.$) return b(E, q, g);
                    i = D.a.a;
                    var V = D.b.a, B = nT(r.ah);
                    if ((f = YS(i)) && OS(B)) return b(E, q, g);
                    var G = A3(aT, j, V, A3(BT, f, B, A3(qT, gT(j), V, A2(xc, hS, E.cD)))), z = E.yZ.jb;
                    return b(E, Uu(w([
                        QT(G),
                        A2(__, z, Aa({
                            nv: r.nv,
                            n3: r.n3
                        }))
                    ])), g);
                }
                var S = PS(F.a);
                return b(m(E, {
                    cA: A_
                }), Uu(w([
                    q,
                    A5(zS, r.eO, r.nv, r.n3, NS(S), !1)
                ])), g);
        }
    }), oP = function(n) {
        return A2(zx, w([
            Gx("my-4")
        ]), w([
            pG(n)
        ]));
    }, fP = function(n) {
        return {
            $: 1,
            a: n
        };
    }, sP = F2(function(n, r) {
        return r.$ ? n : r;
    }), lP = F2(function(n, r) {
        return Gx($(n.eM, r));
    }), dP = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    }, vP = F2(function(n, r) {
        return A2(Qc, 7, am(r) + 7 - dP(n));
    }), bP = F2(function(n, r) {
        return Ib(n) + A2(Ap, n, r) + 1;
    }), mP = F2(function(n, r) {
        var t, e = r;
        switch(n){
            case 0:
                return LA(Qb(r));
            case 1:
                return A2(bP, Qb(r), (t = um(r), Lb(3 * t - 2)));
            case 2:
                return A2(bP, Qb(r), Yb(r));
            case 3:
            case 4:
                return e - A2(vP, 0, r);
            case 5:
                return e - A2(vP, 1, r);
            case 6:
                return e - A2(vP, 2, r);
            case 7:
                return e - A2(vP, 3, r);
            case 8:
                return e - A2(vP, 4, r);
            case 9:
                return e - A2(vP, 5, r);
            case 10:
                return e - A2(vP, 6, r);
            default:
                return r;
        }
    }), pP = function(n) {
        switch(n){
            case 0:
                return v(1, 0);
            case 1:
                return v(3, 1);
            case 2:
                return v(1, 1);
            case 11:
                return v(1, 3);
            default:
                return v(1, 2);
        }
    }, $P = F2(function(n, r) {
        var t = A2(mP, n, r);
        if (i(r, t)) return r;
        var e = pP(n);
        return A3(q_, e.b, e.a, t);
    }), gP = F5(function(n, r, t, e, u) {
        for(;;){
            if (s(u, t) >= 0) return Ae(e);
            var a = A3(q_, n, r, u);
            e = A2(Qt, u, e), u = a;
        }
    }), hP = F4(function(n, r, t, e) {
        var u = t, a = e, i = pP(n), c = i.a, o = i.b, f = A2($P, n, u);
        return 0 > s(f, a) ? A5(gP, o, A2(Ie, 1, r) * c, a, g, f) : g;
    }), yP = F2(function(n, r) {
        var t = function(n) {
            switch(n){
                case 0:
                    return 4;
                case 1:
                    return 5;
                case 2:
                    return 6;
                case 3:
                    return 7;
                case 4:
                    return 8;
                case 5:
                    return 9;
                default:
                    return 10;
            }
        }(r), e = A2(mP, t, A3(kp, Qb(n), Yb(n), 1)), u = A3(kp, Qb(n), Yb(n), 1);
        return {
            pJ: A4(hP, 11, 1, e, A2($P, t, A3(q_, 1, 1, u))),
            pL: n
        };
    }), wP = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(Qt, t, n), r -= 1;
        }
    }), xP = F2(function(n, r) {
        return A3(wP, g, n, r);
    }), _P = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(Qt, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), CP = F2(function(n, r) {
        return Ae(A3(_P, n, r, g));
    }), AP = F3(function(n, r, t) {
        if (r > 0) {
            var e = v(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return w([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, i = a.b;
                                return w([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var c = e.b, o = c.b, f = o.b, s = f.b, l = s.b;
                                return A2(Qt, c.a, A2(Qt, o.a, A2(Qt, f.a, A2(Qt, s.a, n > 1e3 ? A2(CP, r - 4, l) : A3(AP, n + 1, r - 4, l)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return w([
                e.b.a
            ]);
        }
        return g;
    }), kP = F2(function(n, r) {
        return A3(AP, 0, n, r);
    }), EP = F2(function(n, r) {
        var t = n.eM;
        return Oq(A2(Fu, function(n) {
            var r = n.b;
            return v($(t, n.a), r);
        }, r));
    }), qP = F5(function(n, r, t, e, u) {
        var a, i = n.Cw(u), c = i ? g : w([
            qE((a = u, {
                $: 2,
                a: a
            }))
        ]), o = EP(n);
        return A2(zx, A2(Qt, o(w([
            v("day", !0),
            v("disabled", i),
            v("picked", r(u)),
            v("today", e(u)),
            v("other-month", t(u))
        ])), c), w([
            n.kQ(oe(Xb(u)))
        ]));
    }), FP = F3(function(n, r, t) {
        var e, u, a = t.b5, c = t.yG, o = function(r) {
            return A2(xc, !1, A2(Op, function(n) {
                return i(n, r);
            }, n));
        }, f = function(n) {
            return i(n, c);
        }, s = dP(r.hZ) - 1, l = lP(r), d = A2(xc, c, A2(sP, n, a)), v = function(n) {
            return !i(Yb(d), Yb(n));
        }, b = F3(function(n, r, t) {
            if (r) return vE;
            var e = function() {
                switch(n){
                    case "prev":
                    default:
                        return 6;
                    case "next":
                        return 7;
                }
            }();
            return A2(sF, w([
                l(n),
                qE(t),
                CV(-1),
                Rj("button")
            ]), w([
                A2(Tq, w([
                    pD,
                    Wj("fill-primary-300"),
                    zE
                ]), e)
            ]));
        }), m = A2(yP, d, r.hZ), p = m.pL, $ = m.pJ, h = A2(Fu, A4(qP, r, o, v, f), vc((e = $, u = F4(function(n, r, t, e) {
            for(;;){
                if (!r.b) return Ae(e);
                var u = r.a, a = r.b;
                if (6 !== n) n = i = n + 1, r = c = a, t = o = A2(Qt, u, t), e = f = e;
                else {
                    var i = 0, c = a, o = g, f = A2(Qt, Ae(A2(Qt, u, t)), e);
                    n = i, r = c, t = o, e = f;
                }
            }
        }), A4(u, 0, e, g, g)))), y = function() {
            var n = r.Br;
            if (n.$) return !1;
            var t = n.a;
            return i(Yb(t), Yb(p)) && i(Qb(t), Qb(p));
        }();
        return A2(zx, w([
            l("picker")
        ]), w([
            A2(zx, w([
                l("picker-header")
            ]), w([
                A2(zx, w([
                    l("month-container")
                ]), w([
                    _d(r.lB(Yb(p)) + " " + oe(Qb(p)))
                ])),
                A2(zx, w([
                    l("arrows-container")
                ]), w([
                    A3(b, "prev", y, fP(A3(q_, 1, -1, d))),
                    A3(b, "next", !1, fP(A3(q_, 1, 1, d)))
                ]))
            ])),
            A2(zx, w([
                l("calendar-grid")
            ]), vc(w([
                A2(Fu, function(n) {
                    return A2(zx, w([
                        l("dow")
                    ]), w([
                        _d(r.A4(n))
                    ]));
                }, A2(kP, 7, A2(Yp, s, vc(A2(xP, 2, w([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ])))))),
                h
            ])))
        ]));
    }), jP = F3(function(n, r, t) {
        var e = t, u = A2(Qt, v(r.eM + "container", !0), r.kV);
        return A2(zx, w([
            Oq(u)
        ]), w([
            A3(FP, n, r, e)
        ]));
    }), DP = F2(function(n, r) {
        var t;
        return A2(zx, w([
            Gx("grid gap-4")
        ]), w([
            A2(zx, w([
                Gx("font-extrabold")
            ]), w([
                _d("Select a date & time")
            ])),
            A2(zx, w([
                Gx("justify-items-left")
            ]), w([
                A2(c_, Uz, A3(jP, n, tP(r), r.b0))
            ])),
            A2(zx, w([
                Gx("font-extrabold")
            ]), w([
                _d((t = n, A2(xc, "", A2(Op, _p("EEEE, MMMM d"), t))))
            ]))
        ]));
    }), VP = F2(function(n, r) {
        return !n.$ && i(vT(n.a), vT(r));
    }), BP = F2(function(n, r) {
        return A2(na, AE(n), AE(r));
    }), GP = F2(function(n, r) {
        var t, e = n ? "text-info-300 fill-info-300" : "text-info-200 fill-transparent";
        return A2(zx, w([
            Gx("flex items-center border border-info-200 rounded p-4 cursor-pointer gap-4"),
            qE((t = r, {
                $: 0,
                a: t
            })),
            Oq(w([
                v("bg-info-100 text-info-300", n)
            ]))
        ]), w([
            A2(Tq, w([
                Wj(e)
            ]), 27),
            _d(AE(r))
        ]));
    }), zP = function(n) {
        var r = A2(xc, g, A2(Op, pT, n.cC));
        return mT(n.nu) && ve(r) > 1 ? A2(zx, w([
            Gx("flex flex-col gap-2")
        ]), A2(Qt, A2(zx, w([
            Gx("mb-2 font-extrabold")
        ]), w([
            _d("Select a provider")
        ])), A2(Fu, function(r) {
            return A2(GP, A2(VP, n.a$, r), r);
        }, A2(kG, BP, r)))) : vE;
    }, SP = F2(function(n, r) {
        return n.$ ? g : A2(xc, g, A2(Op, sT, A2(nP, n.a, r)));
    }), TP = function(n) {
        var r;
        return A2(zx, w([
            Gx("border border-info-200 hover:border-primary-300 hover:text-primary-300 rounded p-4 cursor-pointer text-center"),
            qE((r = n, {
                $: 2,
                a: r
            }))
        ]), w([
            _d(A2(fe, " ", w([
                tT(n),
                rT(n)
            ])))
        ]));
    }, PP = function(n) {
        var r = A2(SP, n.at, YT(n)), t = A3(JT, mT(n.nu), n.a$, r);
        return A2(zx, w([
            Gx("flex flex-col gap-2")
        ]), nE(r) ? w([
            _d("There are no available appointment times for the current month.")
        ]) : nE(t) ? w(n.at.$ ? [
            _d("Select a day to display available appointment times.")
        ] : [
            _d("There are no available appointment times for the selected day.")
        ]) : A2(Fu, TP, t));
    }, ZP = F2(function(n, r) {
        return A2(zx, w([
            Gx("flex flex-col gap-4")
        ]), w([
            zP(r),
            A2(DP, r.at, r),
            PP(r),
            oP(n)
        ]));
    }), MP = function(n) {
        return 3 === n.cA.$ ? A2(c_, Zz, A2(ZP, n.dV, n.ah)) : A2(zx, g, Nx);
    }, LP = function(n) {
        var r, t = n.cB;
        if (3 === t.$) {
            var e = t.a, u = 3 === (r = n.cA).$ ? pT(r.a) : g, a = YS(e) && 1 === ve(u) ? A2(Op, AE, nT(n.ah)) : Ot, i = MS(e);
            return A2(zx, w([
                Gx("flex flex-col gap-4")
            ]), w([
                A2(zz, !1, {
                    ex: Ot,
                    z2: It(e),
                    n2: It(i),
                    vn: n.vn,
                    l4: a
                }),
                MP(n)
            ]));
        }
        return A2(zx, g, Nx);
    }, NP = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("flex flex-col gap-4")
                ]), w([
                    LP(r)
                ]))
            ]),
            yx: n(Ed.Aj)
        };
    }), HP = C_({
        Cl: uS,
        CQ: aS,
        Fj: iS,
        F4: function() {
            return vx(w([
                bS(cS),
                pS(oS)
            ]));
        },
        Gv: cP,
        GB: NP
    }), IP = function(n) {
        return {
            $: 0,
            a: n
        };
    }, OP = function(n) {
        return 3 === n.a.j.$;
    }, QP = function(n) {
        return n.sg;
    }, RP = {
        $: 9
    }, UP = {
        $: 0
    }, KP = F6(function(n, r, t, e, u, a) {
        return {
            sl: r,
            EB: n,
            i0: u,
            i2: t,
            Fs: a,
            d8: e
        };
    }), WP = F2(function(n, r) {
        return r ? "Int'l" : "US";
    }), XP = function(n) {
        return It(n ? "International" : "US");
    }, YP = function(n) {
        return n.Ei;
    }, JP = function(n) {
        return n.c4.mS;
    }, nZ = function(n) {
        return n.c4.Cb;
    }, rZ = function(n) {
        return n.c4.sT;
    }, tZ = function(n) {
        return n.c4.Df;
    }, eZ = function(n) {
        return n.c4.Do;
    }, uZ = function(n) {
        return n.c4.E3;
    }, aZ = function(n) {
        switch(n.$){
            case 0:
                return tZ;
            case 1:
                return nZ;
            case 2:
                return eZ;
            default:
                return YP;
        }
    }, iZ = function(n) {
        switch(n.$){
            case 0:
                return It("mobile");
            case 1:
                return It("home");
            case 2:
                return It("office");
            default:
                return It(n.a);
        }
    }, cZ = F2(function(n, r) {
        var t = Cd({
            sl: n + "-type",
            Gj: F2(function(n, r) {
                return n(aZ(r));
            }),
            Gk: iZ
        }), e = Cd({
            sl: n + "-region" + n,
            Gj: WP,
            Gk: XP
        });
        return A6(KP, r.EB, n, t, r.i1, e, r.ig ? 0 : 1);
    }), oZ = function(n) {
        return {
            bq: n,
            qN: "",
            rA: "",
            sV: "",
            ft: "",
            vO: A2(cZ, "enter-info-phone", {
                ig: !0,
                EB: "",
                i1: UP
            })
        };
    }, fZ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), sZ = function(n) {
        return A2(fZ, 0, n);
    }, lZ = function(n) {
        return {
            pS: Ot,
            cI: "",
            bs: sZ("/"),
            eZ: g,
            sl: n,
            dI: !1,
            wZ: !1,
            dm: !1
        };
    }, dZ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), vZ = function(n) {
        return A2(dZ, n, g);
    }, bZ = {
        dI: !1,
        dm: !1
    }, mZ = F2(function(n, r) {
        return v(r(n), bZ);
    }), pZ = F2(function(n, r) {
        return {
            x6: ed(A2(Fu, function(n) {
                return A2(mZ, n, r);
            }, n)),
            ei: r
        };
    }), $Z = w([
        0,
        1,
        2,
        3,
        4,
        5
    ]), gZ = function(n) {
        switch(n){
            case 0:
                return "First Name";
            case 1:
                return "Last Name";
            case 2:
                return "Date of Birth";
            case 3:
                return "Email";
            case 4:
                return "Phone";
            default:
                return "Notes";
        }
    }, hZ = F2(function(n, r) {
        return m(r, {
            wZ: n
        });
    }), yZ = F6(function(n, r, t, e, u, a) {
        var i = A2(hZ, !0, lZ("dob"));
        return {
            es: !1,
            g0: n,
            hz: t,
            cQ: !1,
            am: A2(YF, 0, RP).a,
            aR: e,
            le: vZ(oZ(i)),
            h1: a,
            id: u,
            uK: !1,
            EH: r,
            A: A2(pZ, $Z, gZ)
        };
    }), wZ = F3(function(n, r, t) {
        var e = ux(n), u = A2(Ep, r.f9, r.bp), a = !OP(r.g0), i = A2(xc, !1, A2(Op, QP, JF(r.vn))), c = {
            nv: t.Ep.nv,
            cB: kc,
            cD: Ot,
            n3: t.Ep.n3,
            eO: r.AF.Ao,
            hx: r.g0,
            ld: r.ld,
            vn: JF(r.vn),
            aX: A6(yZ, r.g0, e, u, !0, a, i),
            dV: n,
            mv: kc,
            yZ: t
        };
        return v(c, DB(n) ? A4(Qz, c.eO, c.nv, c.n3, IP) : XB);
    }), xZ = F2(function(n, r) {
        return v(r, Qp);
    }), _Z = F2(function(n, r) {
        return m(r, {
            zK: It(9)
        });
    }), CZ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, AZ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, kZ = function(n) {
        return {
            $: 11,
            a: n
        };
    }, EZ = function() {
        return A2(kj, kZ, qj());
    }, qZ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, FZ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jZ = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), DZ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), VZ = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return Ot;
        var r = +n;
        return r == r ? It(r) : Ot;
    }, BZ = A2(ym, function(n) {
        if (lu(n) > 9) return Um("Expected at most 9 digits, but got " + oe(lu(n)));
        var r = VZ("0." + n);
        return r.$ ? Um('Invalid float: "' + n + '"') : Am(Sp(1e3 * r.a));
    }, Jm(Im(_e))), GZ = F6(function(n, r, t, e, u, a) {
        return Xp(n + 60 * r * 60000 + 60 * (t - a) * 1e3 + 1e3 * e + u);
    }), zZ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, SZ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, TZ = F4(function(n, r, t, e) {
        for(;;){
            var u = t(r)(e);
            if (u.$) return a = u.a, A2($m, n || a, u.b);
            var a = u.a, i = u.b, c = u.c;
            if (i.$) return A3(gm, n || a, i.a, c);
            n = n || a, r = i.a, e = c;
        }
    }), PZ = F2(function(n, r) {
        return function(t) {
            return A4(TZ, !1, n, r, t);
        };
    }), ZZ = function(n) {
        return n.$ ? {
            $: 1,
            a: n.a
        } : function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a);
    }, MZ = F2(function(n, r) {
        return A2(PZ, n, function(n) {
            return A2(up, ZZ, r(n));
        });
    }), LZ = function(n) {
        return A2(MZ, "", function(r) {
            if (i(lu(r), n)) {
                var t = $u(r);
                return t.$ ? Um('Invalid integer: "' + r + '"') : A2(up, zZ, Am(t.a));
            }
            return A2(up, function(n) {
                return SZ(A2(w_, r, n));
            }, Jm(Mm(_e)));
        });
    }, NZ = Gm, HZ = function(n) {
        return NZ(A2(km, n, {
            $: 8,
            a: n
        }));
    }, IZ = function(n) {
        return Um("Invalid day: " + oe(n));
    }, OZ = function(n) {
        return !(A2(Qc, 4, n) || !A2(Qc, 100, n) && A2(Qc, 400, n));
    }, QZ = function(n) {
        var r = n - 1;
        return (r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0);
    }, RZ = function(n) {
        var r = n.a, t = n.b, e = n.c;
        if (0 > e) return IZ(e);
        var u = function(n) {
            var u = 31536e6 * (r - 1970), a = 864e5 * ((3 > t || !OZ(r) ? e - 1 : e) + (QZ(r) - QZ(1970)));
            return Am(n + u + a);
        };
        switch(t){
            case 1:
                return e > 31 ? IZ(e) : u(0);
            case 2:
                return e > 29 || 29 === e && !OZ(r) ? IZ(e) : u(26784e5);
            case 3:
                return e > 31 ? IZ(e) : u(50976e5);
            case 4:
                return e > 30 ? IZ(e) : u(7776e6);
            case 5:
                return e > 31 ? IZ(e) : u(10368e6);
            case 6:
                return e > 30 ? IZ(e) : u(130464e5);
            case 7:
                return e > 31 ? IZ(e) : u(156384e5);
            case 8:
                return e > 31 ? IZ(e) : u(183168e5);
            case 9:
                return e > 30 ? IZ(e) : u(209952e5);
            case 10:
                return e > 31 ? IZ(e) : u(235872e5);
            case 11:
                return e > 30 ? IZ(e) : u(262656e5);
            case 12:
                return e > 31 ? IZ(e) : u(288576e5);
            default:
                return Um('Invalid month: "' + oe(t) + '"');
        }
    }, UZ = A2(ym, RZ, A2(Rm, A2(Rm, A2(Rm, Am(F3(function(n, r, t) {
        return b(n, r, t);
    })), LZ(4)), op(w([
        A2(Rm, A2(Cm, Am(cu), HZ("-")), LZ(2)),
        LZ(2)
    ]))), op(w([
        A2(Rm, A2(Cm, Am(cu), HZ("-")), LZ(2)),
        LZ(2)
    ])))), KZ = (gj = F3(function(n, r, t) {
        return n * (60 * r) + t;
    }), A2(Rm, Am(cu), op(w([
        A2(up, function() {
            return 0;
        }, HZ("Z")),
        A2(Rm, A2(Rm, A2(Rm, Am(gj), op(w([
            A2(up, function() {
                return 1;
            }, HZ("+")),
            A2(up, function() {
                return -1;
            }, HZ("-"))
        ]))), LZ(2)), op(w([
            A2(Rm, A2(Cm, Am(cu), HZ(":")), LZ(2)),
            LZ(2),
            Am(0)
        ]))),
        A2(Cm, Am(0), fp)
    ])))), WZ = A2(ym, function(n) {
        return op(w([
            A2(Rm, A2(Rm, A2(Rm, A2(Rm, A2(Rm, A2(Cm, Am(GZ(n)), HZ("T")), LZ(2)), op(w([
                A2(Rm, A2(Cm, Am(cu), HZ(":")), LZ(2)),
                LZ(2)
            ]))), op(w([
                A2(Rm, A2(Cm, Am(cu), HZ(":")), LZ(2)),
                LZ(2)
            ]))), op(w([
                A2(Rm, A2(Cm, Am(cu), HZ(".")), BZ),
                Am(0)
            ]))), A2(Cm, KZ, fp)),
            A2(Cm, Am(A6(GZ, n, 0, 0, 0, 0, 0)), fp)
        ]));
    }, UZ), XZ = A2(nu, function(n) {
        var r = A2($p, WZ, n);
        return r.$ ? AA("Expecting an ISO-8601 formatted date+time string") : au(r.a);
    }, M$), YZ = function(n) {
        switch(n){
            case "accepted":
                return au(0);
            case "not_accepted":
                return au(1);
            case "accepted_and_outdated":
                return au(2);
            default:
                return AA("Unsupported patient document status: " + n);
        }
    }, JZ = function(n) {
        switch(n){
            case "click_box":
                return au(0);
            case "type_name":
                return au(1);
            default:
                return AA("Unsupported patient document acceptance type: " + n);
        }
    }, nM = A3(nk, "name", A2(eu, GV, M$), au(function(n) {
        return {
            ur: n
        };
    })), rM = A2($A, nM, au(cu)), tM = F5(function(n, r, t, e, u) {
        return {
            pd: r,
            qr: t,
            sl: n,
            s8: e,
            zd: u
        };
    }), eM = function(n) {
        switch(n){
            case "text":
                return au(0);
            case "file":
                return au(1);
            case "link":
                return au(2);
            default:
                return AA("Unsupported document version type: " + n);
        }
    }, uM = A3(nk, "version_number", O$, A3(nk, "link_url", ik(M$), A3(nk, "document_version_type", A2(nu, eM, M$), A3(nk, "content", uC(M$), A3(nk, "id", M$, au(tM)))))), aM = A2($A, A2(eu, cu, uM), au(cu)), iM = A3(nk, "signed_document_version", uC(aM), A3(nk, "current_document_version", aM, A3(nk, "signed_at", uC(XZ), A3(nk, "signee", rM, A3(nk, "status", A2(nu, YZ, M$), A3(nk, "required", ru, A3(nk, "name", M$, A3(nk, "document_type", M$, A3(nk, "active", ru, A3(nk, "acceptance_type", A2(nu, JZ, M$), A3(nk, "acceptance_text", M$, A3(nk, "document_id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        mH: r,
                                                        mI: t,
                                                        mR: e,
                                                        pK: s,
                                                        qp: n,
                                                        Bh: u,
                                                        ur: a,
                                                        wZ: i,
                                                        xL: f,
                                                        xM: l,
                                                        xN: o,
                                                        mt: c
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), cM = A2(zB, 0, A2($A, iM, au(DZ))), oM = w([
        "member"
    ]), fM = function(n) {
        return A2(bk, w([
            "practices",
            n
        ]), oM);
    }, sM = function(n) {
        return A2(bk, w([
            "patient_documents"
        ]), fM(n));
    }, lM = uA("post"), dM = F2(function(n, r) {
        return m(r, {
            g8: It(n)
        });
    }), vM = F5(function(n, r, t, e, u) {
        var a = rx(w([
            v("document", e)
        ]));
        return A4(lM, n, cM, u, A2(dM, a, pk(A2(bk, w([
            t,
            "accept"
        ]), sM(r)))));
    }), bM = function(n) {
        return n.ex;
    }, mM = F2(function(n, r) {
        if (n) {
            var t = cT(r), e = cT(r);
            return OS(e) || OS(t);
        }
        return !1;
    }), pM = F2(function(n, r) {
        if (r.$) return !0;
        var t = r.a;
        return A2(mM, n, t) || function(n) {
            var r = iT(n), t = bM(n), e = ZS(n);
            return OS(e) || OS(t) || OS(r);
        }(t);
    }), $M = F3(function(n, r, t) {
        return {
            rY: n,
            tz: t,
            u7: r
        };
    }), gM = A3(nk, "meet_url", M$, A3(nk, "outlook_link", M$, A3(nk, "google_link", M$, au($M)))), hM = A2($A, gM, au(cu)), yM = function(n) {
        return n.ft;
    }, wM = F2(function(n, r) {
        return A2(xc, nx, A2(Op, n, r));
    }), xM = F2(function(n, r) {
        return w([
            v("provider_id", A2(wM, tx, cT(r))),
            v("booking_location_id", tx(n)),
            v("date", A2(wM, tx, iT(r))),
            v("notes", A2(wM, tx, yM(r)))
        ]);
    }), _M = F3(function(n, r, t) {
        return rx(A2(Qt, v("patient_id", tx(n)), A2(xM, r, t)));
    }), CM = F6(function(n, r, t, e, u, a) {
        return A4(lM, n, hM, a, A2(dM, A3(_M, r, e, u), pk(function(n) {
            return A2(bk, w([
                n
            ]), PB);
        }(t))));
    }), AM = function(n) {
        return n.a.sl;
    }, kM = function(n) {
        return n.sl;
    }, EM = function(n) {
        return n.qj;
    }, qM = function(n) {
        return n.qN;
    }, FM = function(n) {
        return n.a;
    }, jM = function(n) {
        return n.rA;
    }, DM = function(n) {
        return n.sV;
    }, VM = function(n) {
        return n.vO;
    }, BM = function(n) {
        var r = eb(n.b);
        return A2(fe, r, w([
            "MM",
            "dd",
            "yyyy"
        ]));
    }, GM = function(n) {
        return Db(BM(n));
    }, zM = function(n) {
        var r = n.b;
        return tV(A2(V$, function(n) {
            return i(n, r) ? n : "#";
        }, GM(A2(fZ, n.a, r))));
    }, SM = F2(function(n, r) {
        return A2(_p, BM(n), r);
    }), TM = F2(function(n, r) {
        n: for(;;){
            var t = v(n, r);
            r: for(;;){
                if (!t.a.b) {
                    if (t.b.b) return "";
                    break r;
                }
                if (!t.b.b) break r;
                var e = t.a, u = e.a, a = e.b, c = t.b, o = c.a, f = c.b;
                switch(o.$){
                    case 2:
                        return A2(xc, "", A2(Op, function(n) {
                            return $(oe(n), A2(TM, a, f));
                        }, $u(eb(u))));
                    case 1:
                        return $(eb(u), A2(TM, a, f));
                    default:
                        if (i(o.a, u)) {
                            n = a, r = f;
                            continue n;
                        }
                        return "";
                }
            }
            return "";
        }
    }), PM = F2(function(n, r) {
        var t = n;
        return mu(r) ? "" : A2(TM, Wm(r), t);
    }), ZM = F2(function(n, r) {
        var t = function() {
            if (n.$) return "";
            var t = n.a;
            return A2(PM, zM(r.bs), A2(SM, r.bs, t));
        }();
        return m(r, {
            pS: n,
            cI: t
        });
    }), MM = F2(function(n, r) {
        var t = A2(xc, "", yM(n)), e = m(FM(r.le), {
            ft: t
        });
        if (r.aR) return e;
        var u = A2(xc, "", VM(n)), a = A2(bb, L$, A2(Op, RA, EM(n))), i = A2(ZM, a, e.bq), c = A2(xc, "", DM(n)), o = A2(xc, "", jM(n));
        return m(e, {
            bq: i,
            qN: A2(xc, "", qM(n)),
            rA: o,
            sV: c,
            vO: A2(cZ, "enter-info-phone", {
                ig: !0,
                EB: u,
                i1: UP
            })
        });
    }), LM = F2(function(n, r) {
        return n.$ ? r : m(r, {
            le: vZ(A2(MM, n.a, r))
        });
    }), NM = function(n) {
        return n.a.uK;
    }, HM = F7(function(n, r, t, e, u, a, i) {
        var c = A2(hZ, !0, lZ("dob"));
        return {
            es: !1,
            g0: n,
            hz: t,
            cQ: !1,
            am: A2(YF, 0, RP).a,
            aR: e,
            le: vZ(oZ(c)),
            h1: a,
            id: u,
            uK: NM(i),
            EH: r,
            A: A2(pZ, $Z, gZ)
        };
    }), IM = function(n) {
        return {
            $: 1,
            a: n
        };
    }, OM = function(n) {
        return {
            $: 0,
            a: n
        };
    }, QM = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), RM = function(n) {
        return {
            $: 4,
            a: n
        };
    }, UM = function(n) {
        return {
            $: 4,
            a: n
        };
    }, KM = function(n) {
        return n.pS;
    }, WM = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    rA: n.a
                });
            case 1:
                return m(r, {
                    sV: n.a
                });
            case 2:
                return m(r, {
                    bq: n.a
                });
            case 3:
                return m(r, {
                    qN: n.a
                });
            case 4:
                return m(r, {
                    vO: n.a
                });
            default:
                return m(r, {
                    ft: n.a
                });
        }
    }), XM = function(n) {
        return function(r) {
            return A3(de, F2(function(n, t) {
                return $(t, n(r));
            }), g, n);
        };
    }, YM = F2(function(n, r) {
        return function(t) {
            var e;
            return e = r(t), A2(n, e, t);
        };
    }), JM = function(n) {
        return n.bq;
    }, nL = function(n) {
        return v(1, n);
    }, rL = F2(function(n, r) {
        return r.w$(n);
    }), tL = function(n) {
        return n.bq.pS.$ ? w([
            v(2, nL(A2(YM, rL, JM)))
        ]) : g;
    }, eL = function(n) {
        return n.qN;
    }, uL = F2(function(n, r) {
        return r.su(n);
    }), aL = A2(tu, lb, xc(db)), iL = function(n) {
        return A2(S$, aL("^\\s*$"), n);
    }, cL = A2(xc, db, A2(sb, {
        At: !0,
        Dg: !1
    }, "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$")), oL = function(n) {
        return A2(S$, cL, n);
    }, fL = function(n) {
        return v(0, n);
    }, sL = function(n) {
        var r = n.qN;
        return iL(r) ? w([
            v(3, nL(A2(YM, rL, eL)))
        ]) : oL(r) ? g : w([
            v(3, fL(A2(YM, uL, eL)))
        ]);
    }, lL = function(n) {
        return n.c$.rA;
    }, dL = function(n) {
        return n.c$.sV;
    }, vL = function(n) {
        return n.c$.ue;
    }, bL = function(n) {
        return n.c$.ym;
    }, mL = function(n) {
        return n.c$.yx;
    }, pL = function(n) {
        return n.c$.Gh;
    }, $L = function(n) {
        return iL(n.rA) ? w([
            v(0, nL(A2(YM, rL, lL)))
        ]) : g;
    }, gL = function(n) {
        return iL(n.sV) ? w([
            v(1, nL(A2(YM, rL, dL)))
        ]) : g;
    }, hL = F2(function(n, r) {
        return n && iL(r.ft) ? w([
            v(5, nL(Zk("The above field is required")))
        ]) : g;
    }), yL = F2(function(n, r) {
        if (r) return !1;
        var t = aV(n);
        return lu(t) > 0 && !i(lu(eV), lu(t));
    }), wL = function(n) {
        var r = n.vO;
        return iL(r.EB) || A2(yL, r.EB, r.Fs) ? w([
            v(4, nL(A2(YM, rL, rZ)))
        ]) : g;
    }, xL = F2(function(n, r) {
        return XM(n ? r ? w([
            hL(r)
        ]) : g : w(r ? [
            $L,
            gL,
            tL,
            sL,
            wL,
            hL(r)
        ] : [
            $L,
            gL,
            tL,
            sL,
            wL
        ]));
    }), _L = F2(function(n, r) {
        var t = n(r);
        return t.b ? Yt(t) : te(r);
    }), CL = F2(function(n, r) {
        var t = r.a, e = A2(_L, n, t);
        if (e.$) return Yt(A2(dZ, t, e.a));
        var u = e.a;
        return te(v(A2(dZ, t, g), u));
    }), AL = function(n) {
        var r = A2(CL, A2(xL, n.aR, n.uK), n.le);
        return r.$ ? v(r.a, !1) : v(r.a.a, !0);
    }, kL = function(n) {
        return AL(n).b;
    }, EL = F2(function(n, r) {
        var t = r.x6, e = A2(ra, (0, r.ei)(n), t);
        return !e.$ && e.a.dI;
    }), qL = F3(function(n, r, t) {
        var e, u = t.ei(r);
        return m(t, {
            x6: (e = A2(ra, u, t.x6), e.$ ? t.x6 : A3(ia, u, {
                dI: e.a.dI,
                dm: n
            }, t.x6))
        });
    }), FL = F2(function(n, r) {
        return {
            dI: n,
            dm: r
        };
    }), jL = F2(function(n, r) {
        if (-2 === r.$) return ea;
        var t = r.b, e = r.d, u = r.e;
        return A5(ta, r.a, t, A2(n, t, r.c), A2(jL, n, e), A2(jL, n, u));
    }), DL = function(n) {
        return m(n, {
            x6: A2(jL, wm(function() {
                return A2(FL, !0, !0);
            }), n.x6)
        });
    }, VL = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A;
        return m(r, {
            le: AL(r).a,
            A: t
        });
    }), BL = function(n) {
        switch(n.$){
            case 0:
                return It(0);
            case 1:
                return It(1);
            case 2:
                return It(2);
            case 3:
                return It(3);
            case 4:
                return It(4);
            default:
                return It(5);
        }
    }, GL = F2(function(n, r) {
        var t = BL(n);
        if (t.$) return r;
        var e = t.a;
        return A2(EL, e, r.A) ? m(A2(VL, !1, r), {
            A: A3(qL, !0, e, r.A)
        }) : r;
    }), zL = function(n) {
        return n.EB;
    }, SL = {
        $: 2
    }, TL = {
        $: 1
    }, PL = F3(function(n, r, t) {
        for(;;){
            var e = A2(Qe, je, n), u = e.a, a = e.b;
            if (0 > s(He(u), je)) return A2(We, !0, {
                M: r,
                F: t,
                J: u
            });
            n = a, r = A2(Qt, Pe(u), r), t += 1;
        }
    }), ZL = 4294967295 >>> 32 - ze, ML = u, LL = F3(function(n, r, t) {
        for(;;){
            var e = A2(ML, ZL & r >>> n, t);
            if (e.$) return A2(ML, ZL & r, e.a);
            n -= ze, t = e.a;
        }
    }), NL = F2(function(n, r) {
        var t = r.a, e = r.b, u = r.c, a = r.d;
        return 0 > n || s(n, t) > -1 ? Ot : s(n, function(n) {
            return n >>> 5 << 5;
        }(t)) > -1 ? It(A2(ML, ZL & n, a)) : It(A3(LL, e, n, u));
    }), HL = w([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ]), IL = function(n) {
        var r;
        return A2(NL, n - 1, (r = HL).b ? A3(PL, r, g, 0) : Se);
    }, OL = F3(function(n, r, t) {
        return {
            pW: r,
            un: n,
            zq: t
        };
    }), QL = F2(function(n, r) {
        return i(lu(r), n) ? Am(r) : Um("Date part is invalid.");
    }), RL = function(n) {
        return A2(ym, QL(n), Jm(Im(_e)));
    }, UL = F2(function(n, r) {
        var t, e = (t = eb(n.b), A2(Rm, A2(Rm, A2(Rm, Am(OL), A2(Cm, RL(2), HZ(t))), A2(Cm, RL(2), HZ(t))), A2(Cm, RL(4), fp))), u = A2($p, e, r);
        if (u.$) return Yt("Invalid Date");
        var a = u.a;
        return function(n) {
            var r = n.uq, t = n.p_, e = $u(n.zs), u = A2(bb, IL, $u(r)), a = b($u(t), u, e);
            return a.a.$ || a.b.$ || a.c.$ ? Yt("Invalid Date") : te(A3(kp, a.c.a, a.b.a, a.a.a));
        }({
            p_: a.pW,
            uq: a.un,
            zs: a.zq
        });
    }), KL = function(n) {
        return n.pS;
    }, WL = function(n) {
        return nL(A2(YM, rL, n));
    }, XL = function(n) {
        return fL(A2(YM, uL, n));
    }, YL = function(n) {
        return n.pS.$ && n.wZ ? iL(n.cI) ? w([
            WL(KL)
        ]) : w([
            XL(KL)
        ]) : g;
    }, JL = F2(function(n, r) {
        return m(r, {
            eZ: YL(r),
            dI: r.dI || n,
            dm: r.dm || n
        });
    }), nN = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = L$(A2(UL, r.bs, A2(WD, zM(r.bs), t))), u = function(n) {
                    return n.dm ? A2(JL, !0, n) : m(n, {
                        dI: !0
                    });
                }(m(r, {
                    pS: e,
                    cI: t
                })), a = A2(xc, "", A2(Op, hk, e)), c = i(a, A2(xc, "", A2(Op, hk, r.pS))) ? Ot : It({
                    $: 0,
                    a: a
                });
                return b(u, Qp, c);
            case 1:
                return b(u = r.dI ? A2(JL, !0, r) : r, Qp, It(SL));
            default:
                return b(r, Qp, It(TL));
        }
    }), rN = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, eN = lu(A2(cV, function(n) {
        return "#" === n;
    }, eV)), uN = F2(function(n, r) {
        return !r && s(lu(n), eN) > 0 ? A2(pu, eN, n) : n;
    }), aN = UP, iN = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(m(r, {
                    EB: n.a
                }), Qp);
            case 1:
                var t = A2(dG, n.a, r.i2), e = t.b;
                return v(m(r, {
                    i2: i = t.a,
                    d8: c = (u = t.c).$ || u.a.$ ? r.d8 : A2(xc, aN, u.a.a)
                }), A2(Wp, tN, e));
            case 2:
                var u, a = A2(dG, n.a, r.i0), i = a.a, c = (e = a.b, (u = a.c).$ || u.a.$ ? r.Fs : A2(xc, 0, u.a.a));
                return v(m(r, {
                    EB: A2(uN, r.EB, r.Fs),
                    i0: i,
                    Fs: c
                }), A2(Wp, rN, e));
            default:
                return v(r, Qp);
        }
    }), cN = F3(function(n, r, t) {
        var e = t.b;
        return A2(dZ, A2(n, r, t.a), e);
    }), oN = F2(function(n, r) {
        var t = r.x6, e = A2(ra, (0, r.ei)(n), t);
        return !e.$ && e.a.dm;
    }), fN = F3(function(n, r, t) {
        var e, u = t.ei(r);
        return m(t, {
            x6: (e = A2(ra, u, t.x6), e.$ ? t.x6 : A3(ia, u, {
                dI: n,
                dm: e.a.dm
            }, t.x6))
        });
    }), sN = F2(function(n, r) {
        var t = BL(n);
        if (t.$) return r;
        var e = t.a, u = A3(fN, !0, e, r.A), a = m(r, {
            A: u
        });
        return A2(oN, e, u) ? m(a, {
            le: AL(r).a
        }) : a;
    }), lN = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(c = A2(sN, t = n.a, m(r, {
                    le: A3(cN, WM, t, r.le)
                })), Qp, Ot);
            case 1:
                var t;
                return b(A2(GL, t = n.a, r), Qp, Ot);
            case 2:
                return b(r, Qp, Ot);
            case 3:
                var e = n.a, u = FM(r.le), a = A2(nN, e, u.bq), i = a.c, c = m(r, {
                    le: A3(cN, WM, (y = a.a, {
                        $: 2,
                        a: y
                    }), r.le)
                });
                return b($ = i.$ || 2 !== i.a.$ ? c : A2(VL, !1, c), Qp, Ot);
            case 4:
                var o = n.a, f = FM(r.le), s = A2(iN, o, f.vO), l = s.a, d = s.b, v = (c = m(r, {
                    le: A3(cN, WM, RM(l), r.le)
                }), RM(l)), p = function() {
                    switch(o.$){
                        case 0:
                            return A2(Nu, cu, Au(OM(v)));
                        case 3:
                            return A2(Nu, cu, Au(IM(v)));
                        default:
                            return Qp;
                    }
                }();
                return b(c, Uu(w([
                    A2(Wp, UM, d),
                    p
                ])), Ot);
            case 5:
                var $ = A2(VL, !0, r);
                return i = function() {
                    if (kL($)) {
                        var n = FM(r.le), t = {
                            qj: Ot,
                            qN: Ot,
                            rA: Ot,
                            sV: Ot,
                            ft: It(n.ft),
                            vO: Ot
                        }, e = function() {
                            if (r.aR) return t;
                            var n = FM(r.le), e = n.rA, u = n.sV, a = n.qN, i = n.vO, c = KM(n.bq), o = zL(i);
                            return m(t, {
                                qj: c,
                                qN: It(a),
                                rA: It(e),
                                sV: It(u),
                                vO: It(o)
                            });
                        }();
                        return It(A2(QM, e, r.cQ));
                    }
                    return Ot;
                }(), b(r, Qp, i);
            case 6:
                return b(m(r, {
                    es: n.a
                }), Qp, Ot);
            case 7:
                return b(m(r, {
                    cQ: n.a
                }), Qp, Ot);
            case 8:
                return b(m(r, {
                    am: zj(r.am)
                }), Qp, Ot);
            case 9:
                return b(m(r, {
                    am: Bj(r.am)
                }), Qp, Ot);
            case 10:
                return b(m(r, {
                    cQ: !0,
                    am: Bj(r.am)
                }), Qp, Ot);
            default:
                var g = A2(Sj, n.a, r.am), h = g.b;
                return b(m(r, {
                    am: g.a
                }), A2(Wp, kZ, h), Ot);
        }
        var y;
    }), dN = F2(function(n, r) {
        return m(r, {
            qj: n
        });
    }), vN = F2(function(n, r) {
        return m(r, {
            qN: n
        });
    }), bN = F2(function(n, r) {
        return m(r, {
            rA: n
        });
    }), mN = F2(function(n, r) {
        return m(r, {
            sV: n
        });
    }), pN = F2(function(n, r) {
        return m(r, {
            ft: n
        });
    }), $N = F2(function(n, r) {
        return m(r, {
            vO: n
        });
    }), gN = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    cB: t
                });
                return 3 === t.$ ? b(e, XS(A2($S, 4, gS)), g) : b(r, Qp, A2(Ik, 0, t));
            case 1:
                var u = n.a;
                if (u.$) return b(m(r, {
                    cD: Ot
                }), Qp, g);
                var a = u.a;
                if (1 === a.$ && 4 === a.a) {
                    var i = a.b, c = r.cB;
                    if (3 === c.$) {
                        var o = YS(E = c.a), f = A2(bb, KT, i), s = A2(LM, f, A7(HM, r.hx, ux(r.dV), r.aX.hz, r.aX.aR, r.aX.id, r.aX.h1, E)), l = function() {
                            if (A2(pM, o, f)) {
                                var n = uG(MS(E)), t = AM(E);
                                return A2(__, r.yZ.jb, ci({
                                    nv: t,
                                    n3: n
                                }));
                            }
                            return Qp;
                        }();
                        return b(m(r, {
                            cD: f,
                            aX: s
                        }), l, g);
                    }
                    return b(r, Qp, g);
                }
                return b(r, Qp, g);
            case 3:
                var d = A2(lN, n.a, r.aX), p = d.b, $ = d.c, h = (e = m(r, {
                    aX: s = d.a
                }), A2(Wp, AZ, p));
                if ($.$) return b(e, h, g);
                var y = $.a, x = y.a, _ = y.b, C = It(A2(pN, x.ft, A2($N, x.vO, A2(vN, x.qN, A2(dN, A2(Op, NS, x.qj), A2(mN, x.sV, A2(bN, x.rA, A2(xc, hS, r.cD)))))))), A = b(C, r.cB, r.vn);
                if (A.a.$ || 3 !== A.b.$ || A.c.$) return b(e, h, g);
                var k = A.a.a, E = A.b.a, q = A.c.a, F = function() {
                    if (_) {
                        var n = rx(w([
                            v("signature", tx("")),
                            v("acceptance_type", tx("checkbox")),
                            v("accepted", Yw(!0))
                        ]));
                        return A5(vM, r.hx, ux(r.dV), "ephi_waiver", n, qZ);
                    }
                    return Qp;
                }(), j = uG(MS(E)), D = AM(E), V = A6(CM, r.eO, kM(q), D, j, k, FZ);
                return b(m(r, {
                    cD: C,
                    mv: A_
                }), Uu(w([
                    h,
                    QT(k),
                    V,
                    F
                ])), g);
            case 2:
                var B = n.a;
                switch(e = m(r, {
                    mv: B
                }), B.$){
                    case 3:
                        return b(e, XS(A2(jZ, 4, gS)), g);
                    case 2:
                        var G = B.a;
                        return b(e, Qp, 5 === G.$ && 400 === G.a ? g : w([
                            A2(Mk, 1, Tk)
                        ]));
                    default:
                        return b(e, Qp, g);
                }
            default:
                return b(r, Qp, g);
        }
    }), hN = function(n) {
        return n.a.nk;
    }, yN = function(n) {
        return n.rY;
    }, wN = function(n) {
        return n.u7;
    }, xN = function(n) {
        return {
            $: 4,
            a: n
        };
    }, _N = {
        $: 4
    }, CN = F2(function(n, r) {
        return mu(n) ? vE : A2(EV, w([
            _N,
            yV(n),
            xV
        ]), w([
            A2(Tq, w([
                zE,
                Wj("text-primary-500")
            ]), 28),
            A2(Mx, g, w([
                _d(r)
            ]))
        ]));
    }), AN = F4(function(n, r, t, e) {
        return $(A3(du, 0, r, e), $(n, A3(du, t, lu(e), e)));
    }), kN = F2(function(n, r) {
        var t = A2(xc, !0, A2(Op, mu, A2(bb, function(n) {
            return n.jb;
        }, _u(n))));
        return $(n, A4(AN, t ? "?" : "&", 0, 1, y_(r)));
    }), EN = F2(function(n, r) {
        return A2(kN, r, sA(n));
    }), qN = {
        $: 6
    }, FN = F3(function(n, r, t) {
        return A2(EV, w([
            qN,
            yV(A2(EN, n, r)),
            xV
        ]), w([
            _d(t)
        ]));
    }), jN = F3(function(n, r, t) {
        var e = A2(Op, function(n) {
            return A2(xu, "http://", n) || A2(xu, "https://", n) ? n : "https://" + n;
        }, t.a.wJ), u = function(n) {
            return n.a.wI;
        }(t), a = function() {
            var r = v(e, u);
            if (r.a.$ || r.b.$) return g;
            var t = r.a.a, a = r.b.a;
            return w([
                A2(lE, w([
                    cE(xD),
                    xN(aF)
                ]), w([
                    A3(FN, n, t, a)
                ]))
            ]);
        }(), i = hN(t) ? w([
            A2(lE, w([
                cE(xD),
                xN(aF)
            ]), w([
                A2(CN, yN(r), "Add to Google Calendar")
            ])),
            A2(lE, w([
                cE(xD),
                xN(aF)
            ]), w([
                A2(CN, wN(r), "Add to Outlook Calendar")
            ]))
        ]) : g;
        return A2(BE, g, $(a, i));
    }), DN = function(n) {
        return {
            $: 0,
            a: n
        };
    }, VN = function(n) {
        return DN(n);
    }, BN = cr("h3"), GN = fE(2), zN = F2(function(n, r) {
        return A2(BN, a_(A2(Qt, qG, A2(Qt, GN, n))), r);
    }), SN = function(n) {
        var r = Vz(n);
        return A2(BE, g, w([
            A2(lE, w([
                VN(w([
                    Gx("flex flex-col gap-2")
                ]))
            ]), w([
                A2(zN, g, w([
                    _d("Appointment")
                ])),
                A2(f_, g, w([
                    _d(r)
                ]))
            ]))
        ]));
    }, TN = function(n) {
        var r = A2(xc, "", bM(n));
        return A2(BE, g, w([
            A2(lE, w([
                VN(w([
                    Gx("flex flex-col gap-2")
                ]))
            ]), w([
                A2(zN, g, w([
                    _d("Date & Time")
                ])),
                A2(f_, g, w([
                    _d(r)
                ]))
            ]))
        ]));
    }, PN = {
        $: 2
    }, ZN = A2(tE, PN, Ot), MN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, LN = A2(BE, w([
        VN(w([
            Gx("mt-6")
        ]))
    ]), w([
        A2(lE, w([
            cE(xD)
        ]), w([
            A2(Tq, w([
                Xj,
                Wj("fill-primary-300 scale-[2.66]"),
                MN(ZN)
            ]), 9)
        ]))
    ])), NN = F2(function(n, r) {
        var t = n.tz;
        if (mu(t)) {
            var e = A2(xc, "", gD(MS(r)));
            return A2(f_, g, w([
                _d(e)
            ]));
        }
        return A2(EV, w([
            yV(t),
            xV
        ]), w([
            _d(t)
        ]));
    }), HN = F2(function(n, r) {
        return A2(BE, g, w([
            A2(lE, w([
                VN(w([
                    Gx("flex flex-col gap-2")
                ]))
            ]), w([
                A2(zN, g, w([
                    _d("Location")
                ])),
                A2(NN, n, r)
            ]))
        ]));
    }), IN = function(n) {
        var r = A2(xc, "", yM(n));
        return mu(r) ? vE : A2(BE, g, w([
            A2(lE, w([
                VN(w([
                    Gx("flex flex-col gap-2")
                ]))
            ]), w([
                A2(zN, g, w([
                    _d("Notes")
                ])),
                A2(f_, g, w([
                    _d(r)
                ]))
            ]))
        ]));
    }, ON = function(n) {
        return n.l4;
    }, QN = F2(function(n, r) {
        var t = n ? A2(xc, "", ON(r)) : "A provider with availability will be assigned";
        return A2(BE, g, w([
            A2(lE, w([
                VN(w([
                    Gx("flex flex-col gap-2")
                ]))
            ]), w([
                A2(zN, g, w([
                    _d("Provider")
                ])),
                A2(f_, g, w([
                    _d(t)
                ]))
            ]))
        ]));
    }), RN = function(n) {
        return hN(n) ? "An email with appointment details has been sent to you." : "You\u2019ll receive an email when your appointment is confirmed.";
    }, UN = function(n) {
        return hN(n) ? "Your appointment is confirmed." : "Your request was submitted.";
    }, KN = function(n) {
        return A2(BE, w([
            VN(w([
                Gx("flex flex-col gap-4 mb-1")
            ]))
        ]), w([
            A2(lE, w([
                cE(xD)
            ]), w([
                A2(f_, w([
                    Qx
                ]), w([
                    _d(UN(n))
                ]))
            ])),
            A2(lE, g, w([
                A2(f_, w([
                    nF
                ]), w([
                    _d(RN(n))
                ]))
            ]))
        ]));
    }, WN = function(n) {
        if (n.$) return vE;
        var r = zV(n.a);
        return A2(BE, g, w([
            A2(lE, w([
                VN(w([
                    Gx("flex flex-col gap-2")
                ]))
            ]), w([
                A2(zN, g, w([
                    _d("Member")
                ])),
                A2(f_, g, w([
                    ZV(r)
                ]))
            ]))
        ]));
    }, XN = F5(function(n, r, t, e, u) {
        var a = YS(n);
        return A2(zx, w([
            Gx("flex flex-col gap-4")
        ]), w([
            LN,
            KN(n),
            WN(e),
            TN(r),
            A2(HN, t, n),
            SN(n),
            A2(QN, a, r),
            IN(r),
            A3(jN, u, t, n)
        ]));
    }), YN = F2(function(n, r) {
        return A2(xu, n, x_(r));
    }), JN = function(n) {
        return A2(YN, "/booking", n);
    }, nH = F2(function(n, r) {
        return $(A2(fe, "/", n), y_(r));
    }), rH = F3(function(n, r, t) {
        var e = _c(r), u = uG(MS(n)), a = AM(n), i = JN(e) ? ci({
            nv: a,
            n3: u
        }) : Ca({
            nv: a,
            n3: u
        }), c = A2(nH, w([
            x_(i)
        ]), sA(t));
        return A2(zx, w([
            Gx("booking-appointment-not-available")
        ]), w([
            A2(zx, w([
                Gx("relative bg-white rounded top-1/4 mx-8 p-5 opacity-100")
            ]), w([
                A2(BE, w([
                    cE(xD)
                ]), w([
                    A2(lE, g, w([
                        A2(CF, g, w([
                            _d("Time slot unavailable")
                        ])),
                        A2(f_, w([
                            qG,
                            uE(aF)
                        ]), w([
                            _d("The selected time slot is no longer available. Please choose a different time or check for the latest availability and try again.")
                        ])),
                        A2(EV, w([
                            _N,
                            yV(c)
                        ]), w([
                            _d("Select time")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), tH = F3(function(n, r, t) {
        return 2 === n.$ && 5 === n.a.$ && 400 === n.a.a ? A3(rH, t, r.EX, r.jb) : vE;
    }), eH = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uH = function(n) {
        return {
            $: 5,
            a: n
        };
    }, aH = F2(function(n, r) {
        var t = r.b;
        return i(n, r.a) ? It(t) : Ot;
    }), iH = F2(function(n, r) {
        var t = r.b;
        return A2(n$, aH(n), t);
    }), cH = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), oH = "patient-details-form", fH = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sH = function(n) {
        return {
            $: 6,
            a: n
        };
    }, lH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dH = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vH = A2(tu, dH, lH), bH = function(n) {
        return {
            $: 3,
            a: n
        };
    }, mH = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pH = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $H = function(n) {
        return {
            $: 7,
            a: n
        };
    }, gH = function(n) {
        return {
            $: 2,
            a: n
        };
    }, hH = function(n) {
        return {
            $: 11,
            a: n
        };
    }, yH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wH = F2(function(n, r) {
        return !nE(A2(iH, n, r));
    }), xH = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), _H = function(n) {
        return {
            $: 5,
            a: n
        };
    }, CH = Bx("htmlFor"), AH = F2(function(n, r) {
        return A2(cz, a_(A2(Qt, GN, n)), A2(Fu, c_(Cu), r));
    }), kH = F3(function(n, r, t) {
        if (n.$) return vE;
        var e = n.a, u = e.$ ? ZV(e.a) : _d(e.a), a = t.$ ? g : w([
            CH(t.a)
        ]);
        return A2(AH, w([
            Hx(A2(Qt, Gx("form-group__label"), A2(Qt, Oq(w([
                v("form-group__label--required", r)
            ])), a)))
        ]), w([
            u
        ]));
    }), EH = F2(function(n, r) {
        var t = function(n) {
            var r = {
                eN: g,
                p8: Ot,
                h$: Ot,
                sT: Ot,
                wZ: !1
            };
            return A3(de, F2(function(n, r) {
                switch(n.$){
                    case 0:
                        return m(r, {
                            p8: It(n.a)
                        });
                    case 1:
                        return m(r, {
                            sT: It(n.a)
                        });
                    case 2:
                        return m(r, {
                            wZ: n.a
                        });
                    case 3:
                        return m(r, {
                            eN: $(r.eN, w([
                                "h-full"
                            ]))
                        });
                    default:
                        return m(r, {
                            h$: It(n.a)
                        });
                }
            }), r, n);
        }(n), e = A2(fe, " ", t.eN);
        return A2(zx, w([
            Gx("form-group"),
            Gx(e)
        ]), A2(Qt, A2(zx, w([
            Gx("flex justify-between"),
            Oq(w([
                v("mb-2 md:mb-3", Cz(t.sT))
            ]))
        ]), w([
            A3(kH, t.sT, t.wZ, t.h$)
        ])), A2(Qt, function(n) {
            if (n.$) return vE;
            var r = n.a;
            return A2(f_, w([
                nF,
                Hx(w([
                    Gx("-mt-1 mb-2 md:mb-3")
                ]))
            ]), w([
                _d(r)
            ]));
        }(t.p8), r)));
    }), qH = w([
        A2(lF, "data-gramm_editor", "false"),
        A2(lF, "data-gramm", "false"),
        A2(lF, "data-enable-grammarly", "false")
    ]), FH = {
        kO: qH,
        eZ: g,
        Cr: !1,
        mE: g
    }, jH = w([
        SV,
        A2(lF, "data-recording-ignore", "mask")
    ]), DH = function(n) {
        return A2(EE, "blur", au(n));
    }, VH = function(n) {
        return A2(EE, "focus", au(n));
    }, BH = function(n) {
        return v(n, !0);
    }, GH = F2(function(n, r) {
        return A2(kE, n, {
            $: 1,
            a: r
        });
    }), zH = A2(M_, w([
        "target",
        "value"
    ]), M$), SH = function(n) {
        return A2(GH, "input", A2(eu, BH, A2(eu, n, zH)));
    }, TH = Bx("placeholder"), PH = function(n) {
        switch(n){
            case 0:
                return "resize-none";
            case 1:
                return "resize-x";
            case 2:
                return "resize-y";
            default:
                return "resize";
        }
    }, ZH = function(n) {
        return A2(vr, "rows", oe(n));
    }, MH = cr("textarea"), LH = function(n) {
        var r = function(n) {
            return A3(de, F2(function(n, r) {
                switch(n.$){
                    case 0:
                        return m(r, {
                            kO: A2(Qt, DF(n.a), r.kO)
                        });
                    case 1:
                        return m(r, {
                            kO: A2(Qt, ZH(n.a), r.kO)
                        });
                    case 2:
                        return m(r, {
                            kO: A2(Qt, SH(n.a), r.kO)
                        });
                    case 3:
                        return m(r, {
                            kO: A2(Qt, DH(n.a), r.kO)
                        });
                    case 4:
                        return m(r, {
                            kO: A2(Qt, VH(n.a), r.kO)
                        });
                    case 5:
                        return m(r, {
                            kO: A2(Qt, oz(n.a), r.kO)
                        });
                    case 6:
                        return m(r, {
                            kO: A2(Qt, Oq(w([
                                v("feedback-errored", t = n.a)
                            ])), r.kO),
                            Cr: t
                        });
                    case 7:
                        return m(r, {
                            kO: A2(Qt, TH(n.a), r.kO)
                        });
                    case 8:
                        return m(r, {
                            kO: A2(Qt, vF(t = n.a), A2(Qt, Oq(w([
                                v("disabled", t)
                            ])), r.kO))
                        });
                    case 9:
                        return m(r, {
                            kO: A2(Qt, A2(lF, "data-test", n.a), r.kO)
                        });
                    case 10:
                        return m(r, {
                            kO: A2(Qt, A2(VF, "min-height", n.a), r.kO)
                        });
                    case 11:
                        return m(r, {
                            kO: A2(Qt, Gx(PH(n.a)), r.kO)
                        });
                    default:
                        var t;
                        return m(r, {
                            kO: $((t = n.a) ? jH : g, r.kO)
                        });
                }
            }), FH, n);
        }(n);
        return A2(zx, r.mE, w([
            A2(MH, A2(Qt, Gx("textarea"), r.kO), g)
        ]));
    }, NH = F2(function(n, r) {
        return n(r.b);
    }), HH = A2(Rm, A2(Cm, Am(cu), Im(function(n) {
        return "[" !== n;
    })), A2(Cm, Jm(Im(function(n) {
        return ")" !== n;
    })), HZ(")"))), IH = F2(function(n, r) {
        return {
            yu: n,
            yZ: r
        };
    }), OH = Hm(function(n) {
        return " " === n || "\n" === n || "\r" === n;
    }), QH = OH, RH = A2(Rm, A2(Rm, A2(Cm, A2(Cm, Am(IH), HZ("[")), QH), A2(Cm, A2(Cm, A2(Cm, Jm(Im(function(n) {
        return "]" !== n;
    })), HZ("]")), QH), HZ("("))), A2(Cm, Jm(Im(function(n) {
        return ")" !== n;
    })), HZ(")"))), UH = F5(function(n, r, t, e, u) {
        var a = e + lu(t), i = A2(yb, lu(n) - a, n), c = e > 0 ? $(r, w([
            _d(A2(pu, e, n))
        ])) : r;
        return v(i, $(c, w([
            A2(EV, w([
                yV(u.yZ),
                xV
            ]), w([
                _d(u.yu)
            ]))
        ])));
    }), KH = F2(function(n, r) {
        return A2(xc, $(r, w([
            _d(n)
        ])), A2(Op, function(t) {
            var e = A5(UH, n, r, t.a, t.b, t.c);
            return A2(KH, e.a, e.b);
        }, function(n) {
            var r = A2($p, HH, n);
            if (r.$) return Ot;
            var t = r.a + ")", e = A2($p, RH, t);
            if (e.$) return Ot;
            var u = e.a;
            return A2(bb, function(n) {
                return It(b(t, n, u));
            }, mb(A2(bu, t, n)));
        }(n)));
    }), WH = function(n) {
        return A2(KH, n, g);
    }, XH = F2(function(n, r) {
        return A2(Qq, g, WH(A2(NH, n, r)));
    }), YH = F2(function(n, r) {
        return nE(r) ? vE : A2(Kq, w([
            Gx("form-error")
        ]), A2(Fu, XH(n), r));
    }), JH = F4(function(n, r, t, e) {
        var u, a = NM(n), i = function(n) {
            return n.a.uJ;
        }(n), c = A2(xc, "Additional Notes", i), o = i.$ ? "Anything else you want to share to help prepare our meeting." : "", f = FM(e.le).ft;
        return A2(BE, g, w([
            A2(lE, g, w([
                A2(EH, w([
                    vH(c),
                    gH(a)
                ]), w([
                    A2(Kk, g, w([
                        LH(w([
                            fH(A2(fe, "-", w([
                                oH,
                                "additional-notes"
                            ]))),
                            _H(f),
                            pH(A2(qc, OM, uH)),
                            (u = r, {
                                $: 8,
                                a: u
                            }),
                            bH(IM(uH(f))),
                            mH(eH(uH(f))),
                            hH(0),
                            yH(3),
                            {
                                $: 12,
                                a: !0
                            },
                            $H(o),
                            sH(a && A3(xH, e.le, e.A, 5))
                        ]))
                    ])),
                    a ? A2(YH, t, A3(cH, e.le, e.A, 5)) : vE
                ]))
            ]))
        ]));
    }), nI = function(n) {
        return {
            $: 6,
            a: n
        };
    }, rI = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, eI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uI = dF("checked"), aI = A2(M_, w([
        "target",
        "checked"
    ]), ru), iI = function(n) {
        switch(n.$){
            case 0:
                return w([
                    uI(n.a)
                ]);
            case 2:
                return w([
                    vF(n.a)
                ]);
            case 1:
                return w([
                    (r = n.a, A2(EE, "change", A2(eu, r, aI)))
                ]);
            case 3:
                return w([
                    Oq(w([
                        v("checkbox__input--indeterminate", n.a)
                    ]))
                ]);
            case 5:
                return w([
                    Oq(w([
                        v("checkbox__input--invalid", n.a)
                    ]))
                ]);
            case 6:
                return w([
                    A2(lF, "data-test", n.a)
                ]);
            default:
                return g;
        }
        var r;
    }, cI = function(n) {
        switch(n.$){
            case 0:
            case 1:
            default:
                return g;
            case 2:
                return w([
                    Oq(w([
                        v("checkbox--disabled", n.a)
                    ]))
                ]);
            case 3:
                return w([
                    Oq(w([
                        v("checkbox--ideterminate", n.a)
                    ]))
                ]);
            case 5:
                return w([
                    Oq(w([
                        v("checkbox--invalid", n.a)
                    ]))
                ]);
            case 4:
                var r = n.a;
                return A2(Fu, Px(Cu), r);
            case 6:
                return w([
                    A2(lF, "data-test", "label-" + n.a)
                ]);
        }
    }, oI = function(n) {
        switch(n.$){
            case 0:
            case 2:
            case 1:
            case 3:
            case 5:
                return g;
            case 4:
                var r = n.a;
                return A2(Fu, Px(Cu), r);
            case 6:
                return w([
                    A2(lF, "data-test", "text-" + n.a)
                ]);
            default:
                return w([
                    Oq(w([
                        v("checkbox__text--required", n.a)
                    ]))
                ]);
        }
    }, fI = F2(function(n, r) {
        return A2(cz, A2(Qt, Gx("checkbox"), A2(bc, cI, n)), w([
            A2(zx, w([
                Gx("flex")
            ]), w([
                A2(zx, g, w([
                    A2(sz, A2(Qt, Rj("checkbox"), A2(Qt, Gx("checkbox__input"), A2(bc, iI, n))), g),
                    A2(Mx, w([
                        Gx("checkbox__icon")
                    ]), g)
                ])),
                A2(zx, A2(Qt, Gx("checkbox__text flex-grow"), A2(bc, oI, n)), r)
            ]))
        ]));
    }), sI = F4(function(n, r, t, e) {
        return A2(BE, g, w([
            A2(lE, g, w([
                A2(EH, w([
                    gH(!1)
                ]), w([
                    A2(Kk, g, w([
                        A2(fI, w([
                            eI(e.es),
                            tI(nI),
                            {
                                $: 7,
                                a: !1
                            },
                            rI(r)
                        ]), w([
                            _d("By checking this box, you agree to receive SMS notifications about appointment confirmations, cancellations and reminders from " + ax(n) + " Powered by Hint. Message frequency varies. Message & data rates may apply. You can reply STOP to opt out at any time. Text HELP for help. View our "),
                            A2(UD, w([
                                oV("https://www.hint.com/privacy"),
                                AV("_blank")
                            ]), w([
                                _d("Privacy Policy")
                            ])),
                            _d(" and "),
                            A2(UD, w([
                                oV("https://www.hint.com/terms-feb-2025"),
                                AV("_blank")
                            ]), w([
                                _d("Terms and Conditions")
                            ])),
                            _d(".")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), lI = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dI = cu, vI = {
        $: 1
    }, bI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mI = {
        $: 2
    }, pI = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $I = function(n) {
        return n.dm ? YL(n) : g;
    }, gI = function(n) {
        return !nE(n.eZ);
    }, hI = function(n) {
        return {
            $: 5,
            a: n
        };
    }, yI = function(n) {
        return {
            $: 6,
            a: n
        };
    }, wI = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), xI = wI, _I = function(n) {
        return {
            $: 11,
            a: n
        };
    }, CI = function(n) {
        return {
            $: 17,
            a: n
        };
    }, AI = F3(function(n, r, t) {
        return {
            $: 9,
            a: n,
            b: r,
            c: t
        };
    }), kI = AI, EI = {
        Bb: !1
    }, qI = F2(function(n, r) {
        return m(r, {
            Bb: n
        });
    }), FI = function(n) {
        return {
            $: 7,
            a: n
        };
    }, jI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, DI = dF("autofocus"), VI = F2(function(n, r) {
        return 1 > n ? r : A3(du, 0, -n, r);
    }), BI = F2(function(n, r) {
        return mu(r) ? oz("") : oz(A2(WD, n, r));
    }), GI = F3(function(n, r, t) {
        if (mu(t)) return "";
        if (mu(r)) return A2(PM, n, A2(WD, n, t));
        if (s(A2(WD, n, r), t) > 0) {
            var e = A2(PM, n, t);
            return s(r, e) > 0 ? e : A2(VI, 1, r);
        }
        return A2(PM, n, t);
    }), zI = F3(function(n, r, t) {
        return SH(A2(tu, A2(GI, n, r), t));
    }), SI = function(n) {
        switch(n.$){
            case 0:
                return w([
                    TH(n.a)
                ]);
            case 1:
                return w([
                    SH(u = n.a)
                ]);
            case 11:
                return w([
                    DH(u = n.a)
                ]);
            case 12:
                return w([
                    qE(u = n.a)
                ]);
            case 13:
                return w([
                    mF(u = n.a)
                ]);
            case 2:
                return w([
                    oz(n.a)
                ]);
            case 8:
                return w([
                    A2(BI, t = n.a, n.b)
                ]);
            case 9:
                return w([
                    A3(zI, t = n.a, n.b, u = n.c)
                ]);
            case 10:
                var r = n.a, t = n.b, e = n.c, u = n.d;
                return w([
                    SH(function(n) {
                        var a = r(n), c = A2(PM, t, A2(WD, t, a)), o = i(c, e) && 0 > s(lu(n), lu(A2(WD, t, e)));
                        return mu(a) ? u("") : u(o ? A2(VI, 1, e) : c);
                    })
                ]);
            case 3:
                return w([
                    vF(n.a)
                ]);
            case 4:
                return w([
                    Rj((o = n.a, o ? "tel" : "password"))
                ]);
            case 5:
                return w([
                    A2(lF, "inputmode", (c = n.a, c ? "email" : "numeric"))
                ]);
            case 6:
                return w([
                    Oq(w([
                        v("input--invalid", n.a)
                    ]))
                ]);
            case 7:
                return jH;
            case 14:
                return w([
                    DF(n.a)
                ]);
            case 15:
                return w([
                    A2(lF, "data-test", n.a)
                ]);
            case 16:
                return w([
                    DI(n.a)
                ]);
            case 17:
                return w([
                    VH(u = n.a)
                ]);
            case 18:
                return w([
                    Gx("input-with-icon")
                ]);
            case 19:
                return w([
                    (a = n.a, A2(Bx, "autocomplete", a ? "on" : "off"))
                ]);
            case 20:
                return w([
                    A2(lF, "autocomplete", n.a)
                ]);
            default:
                return w([
                    dz(n.a)
                ]);
        }
        var a, c, o;
    }, TI = function(n) {
        return A2(sz, A2(Qt, Gx("input"), A2(Qt, Rj("text"), A2(bc, SI, n))), g);
    }, PI = function(n) {
        var r = mb(A2(n$, function(n) {
            return 18 === n.$ ? It(n.a) : Ot;
        }, n));
        if (r.$) return TI(n);
        var t = r.a;
        return A2(zx, g, w([
            TI(n),
            A2(Tq, w([
                Wj("input-icon")
            ]), t)
        ]));
    }, ZI = F3(function(n, r, t) {
        var e = A3(de, qI, EI, r);
        return A2(zx, w([
            Gx("date-input"),
            DF(t.sl)
        ]), w([
            PI(w([
                A2(xI, zM(t.bs), t.cI),
                A3(kI, zM(t.bs), t.cI, bI),
                jI(GM(t.bs)),
                yI(t.dm && gI(t)),
                pI(e.Bb),
                FI(!0),
                _I(vI),
                CI(mI),
                hI(0)
            ])),
            A2(YH, n, $I(t))
        ]));
    }), MI = F3(function(n, r, t) {
        if (t.aR) return vE;
        var e = FM(t.le), u = A3(cH, t.le, t.A, 2);
        return A2(BE, g, w([
            A2(lE, g, w([
                A2(EH, w([
                    vH(r(JM)),
                    gH(!0)
                ]), w([
                    A2(zx, w([
                        Gx("enter-info-date-of-birth"),
                        Oq(w([
                            v("field--invalid", !nE(u))
                        ]))
                    ]), w([
                        A2(c_, lI, A3(ZI, r, w([
                            dI(n)
                        ]), e.bq))
                    ])),
                    A2(YH, r, u)
                ]))
            ]))
        ]));
    }), LI = function(n) {
        return {
            $: 3,
            a: n
        };
    }, NI = function(n) {
        return {
            $: 14,
            a: n
        };
    }, HI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, II = function(n) {
        switch(n){
            case 0:
                return oH + "-first-name";
            case 1:
                return oH + "-last-name";
            case 2:
                return oH + "-dob";
            case 3:
                return oH + "-email";
            case 4:
                return oH + "-phone";
            default:
                return oH + "-notes";
        }
    }, OI = function(n) {
        return {
            $: 2,
            a: n
        };
    }, QI = F3(function(n, r, t) {
        if (t.aR) return vE;
        var e = FM(t.le).qN;
        return A2(BE, g, w([
            A2(lE, g, w([
                A2(EH, w([
                    vH(r(eL)),
                    gH(!0)
                ]), w([
                    PI(w([
                        NI(II(3)),
                        OI(e),
                        HI(A2(qc, OM, LI)),
                        yI(A3(xH, t.le, t.A, 3)),
                        pI(n),
                        FI(!0),
                        _I(IM(LI(e))),
                        CI(eH(LI(e))),
                        hI(1)
                    ])),
                    A2(YH, r, A3(cH, t.le, t.A, 3))
                ]))
            ]))
        ]));
    }), RI = function(n) {
        return {
            $: 7,
            a: n
        };
    }, UI = {
        $: 8
    }, KI = function(n) {
        return n.s0;
    }, WI = F4(function(n, r, t, e) {
        return A2(BE, g, w([
            A2(lE, g, w([
                A2(EH, g, w([
                    A2(zx, w([
                        Gx("flex items-start gap-2")
                    ]), w([
                        A2(fI, w([
                            eI(e.cQ),
                            tI(RI),
                            rI(r)
                        ]), w([
                            _d("I authorize " + ax(n) + " to send email or text which may include unencrypted protected health information. "),
                            A2(Mx, w([
                                qE(UI),
                                Gx("cursor-pointer underline text-primary hover:text-primary-400")
                            ]), w([
                                _d(t(KI))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), XI = {
        $: 10
    }, YI = F2(function(n, r) {
        return A2(dD, w([
            Hj(w([
                A2(PE, w([
                    qG,
                    nF
                ]), w([
                    _d("ePHI Waiver")
                ]))
            ])),
            Mj(w([
                A2(zx, w([
                    Gx("flex flex-col gap-4")
                ]), w([
                    A2(f_, g, w([
                        _d("Providing us with authorization to email and text you will allow "),
                        _d(ax(n)),
                        _d(" to exchange information with you more efficiently and will benefit you as a member. At the same time, we recognize that email and text messaging are not a completely secure means of communication.")
                    ])),
                    A2(f_, g, w([
                        _d("You are not required to authorize the use of email and text messages and a decision to not authorize electronic communication will not affect your health care in any way.")
                    ])),
                    A2(f_, g, w([
                        _d("We have taken considerable effort to protect the personal health information of our members, and recommend that all members provide us with this authorization so that we can more efficiently communicate with them.")
                    ]))
                ]))
            ])),
            Nj(w([
                A2(yF, w([
                    fF,
                    cF(XI)
                ]), w([
                    _d("Accept")
                ])),
                A2(yF, w([
                    CD,
                    cF(RP)
                ]), w([
                    _d("No Thanks")
                ]))
            ]))
        ]), r.am);
    }), JI = A2(tE, rE(3), Ot), nO = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), rO = nO, tO = function(n) {
        return A2(SE, 1, n);
    }, eO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uO = F3(function(n, r, t) {
        var e = FM(t.le).rA;
        return A2(EH, w([
            vH(r(lL)),
            gH(!0)
        ]), w([
            A2(Kk, g, w([
                PI(w([
                    NI(II(0)),
                    OI(e),
                    HI(A2(qc, OM, eO)),
                    yI(A3(xH, t.le, t.A, 0)),
                    pI(n),
                    _I(IM(eO(e))),
                    CI(eH(eO(e))),
                    FI(!0)
                ]))
            ])),
            A2(YH, r, A3(cH, t.le, t.A, 0))
        ]));
    }), aO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, iO = F3(function(n, r, t) {
        var e = FM(t.le).sV;
        return A2(EH, w([
            vH(r(dL)),
            gH(!0)
        ]), w([
            A2(Kk, g, w([
                PI(w([
                    NI(II(1)),
                    OI(e),
                    HI(A2(qc, OM, aO)),
                    yI(A3(xH, t.le, t.A, 1)),
                    pI(n),
                    _I(IM(aO(e))),
                    CI(eH(aO(e))),
                    FI(!0)
                ]))
            ])),
            A2(YH, r, A3(cH, t.le, t.A, 1))
        ]));
    }), cO = F3(function(n, r, t) {
        return t.aR ? vE : A2(BE, g, w([
            A2(lE, w([
                TE(12),
                tO(6),
                xN(aF),
                A2(rO, 1, JI)
            ]), w([
                A3(uO, n, r, t)
            ])),
            A2(lE, w([
                TE(12),
                tO(6)
            ]), w([
                A3(iO, n, r, t)
            ]))
        ]));
    }), oO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fO = function(n) {
        return {
            $: 3,
            a: n
        };
    }, sO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lO = {
        Bb: !1,
        dH: !1,
        h8: !1,
        Cr: !1
    }, dO = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    Bb: n.a
                });
            case 1:
                return m(r, {
                    Cr: n.a
                });
            case 2:
                return m(r, {
                    dH: n.a
                });
            default:
                return m(r, {
                    h8: n.a
                });
        }
    }), vO = {
        $: 3
    }, bO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mO = {
        $: 4
    }, pO = function(n) {
        return {
            $: 20,
            a: n
        };
    }, $O = function(n) {
        return {
            $: 21,
            a: n
        };
    }, gO = F4(function(n, r, t, e) {
        return {
            $: 10,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), hO = gO, yO = A3(N_, "#", "_", eV), wO = function(n) {
        var r = A2(cV, _e, n);
        return lu(r) >= 11 && A2(xu, "1", r) ? A2(vu, 1, r) : r;
    }, xO = function(n) {
        return {
            $: 15,
            a: n
        };
    }, _O = F5(function(n, r, t, e, u) {
        return PI(w(r ? [
            NI(u),
            OI(n),
            HI(bO),
            pI(t),
            yI(e),
            _I(vO),
            xO(u),
            FI(!0),
            $O("tel"),
            pO("tel"),
            CI(mO)
        ] : [
            NI(u),
            A2(xI, uV, n),
            jI(yO),
            A4(hO, wO, uV, n, bO),
            pI(t),
            yI(e),
            _I(vO),
            xO(u),
            FI(!0),
            CI(mO),
            hI(0),
            $O("tel-national"),
            pO("tel-national")
        ]));
    }), CO = function(n) {
        return {
            $: 2,
            a: n
        };
    }, AO = w([
        0,
        1
    ]), kO = F4(function(n, r, t, e) {
        return A2(c_, rN, A4(qz, n, w([
            XG(It(r)),
            CO(e)
        ]), A2(Fu, function(n) {
            return A2(MG, g, n);
        }, AO), t));
    }), EO = {
        $: 1
    }, qO = {
        $: 2
    }, FO = w([
        UP,
        EO,
        qO
    ]), jO = F4(function(n, r, t, e) {
        return A2(c_, tN, A4(qz, n, w([
            XG(It(r)),
            HG("<Phone Type>"),
            CO(e)
        ]), A2(Fu, function(n) {
            return A2(MG, g, n);
        }, FO), t));
    }), DO = F3(function(n, r, t) {
        var e = A3(de, dO, lO, r), u = e.dH ? 0 : 2, a = e.dH ? 0 : 3;
        return A2(zx, w([
            Gx("phone-input"),
            DF(t.sl)
        ]), w([
            A2(BE, w([
                xN(JI)
            ]), w([
                A2(lE, w([
                    TE(12),
                    tO(12 - u - a),
                    xN(Jq),
                    A2(rO, 1, JI)
                ]), w([
                    A5(_O, t.EB, t.Fs, e.Bb, e.Cr, t.sl)
                ])),
                A2(lE, w([
                    TE(12),
                    tO(u)
                ]), w([
                    A2(bE, !e.dH, A4(kO, n, t.Fs, t.i0, e.Bb))
                ])),
                A2(lE, w([
                    TE(12),
                    tO(a)
                ]), w([
                    A2(bE, !e.h8, A4(jO, n, t.d8, t.i2, e.Bb))
                ]))
            ]))
        ]));
    }), VO = F3(function(n, r, t) {
        if (t.aR) return vE;
        var e, u = FM(t.le).vO;
        return A2(BE, g, w([
            A2(lE, g, w([
                A2(EH, w([
                    vH(r(rZ)),
                    gH(!0)
                ]), w([
                    A2(zx, w([
                        Gx("mx-1")
                    ]), w([
                        A2(c_, UM, A3(DO, r, w([
                            sO(A3(xH, t.le, t.A, 4)),
                            (e = !0, {
                                $: 2,
                                a: e
                            }),
                            fO(!0),
                            oO(n)
                        ]), u))
                    ])),
                    A2(YH, r, A3(cH, t.le, t.A, 4))
                ]))
            ]))
        ]));
    }), BO = {
        $: 5
    }, GO = F4(function(n, r, t, e) {
        var u = !kL(e), a = hN(n) ? "Confirm" : "Request";
        return A2(BE, g, w([
            A2(lE, w([
                cE(xD)
            ]), w([
                A2(yF, w([
                    fF,
                    cF(BO),
                    Lj(u || r)
                ]), w([
                    _d(a)
                ]))
            ]))
        ]));
    }), zO = F5(function(n, r, t, e, u) {
        return A2(zx, g, w([
            A2(YI, r, u),
            A2(zx, w([
                Gx("booking-enter-info-form")
            ]), w([
                u.aR ? vE : A2(zx, w([
                    Gx("text-base font-extrabold mb-4")
                ]), w([
                    _d("Attendee information")
                ])),
                A2(zx, w([
                    Gx("ml-1")
                ]), w([
                    A3(cO, t, e, u),
                    A3(MI, t, e, u),
                    A3(QI, t, e, u),
                    A3(VO, t, e, u),
                    A4(sI, r, t, e, u),
                    u.id && !u.h1 ? A4(WI, r, t, e, u) : vE,
                    A4(JH, n, t, e, u),
                    A4(GO, n, t, e, u)
                ]))
            ]))
        ]));
    }), SO = F2(function(n, r) {
        var t = r.cB;
        if (3 === t.$) {
            var e = t.a, u = A2(bb, ON, r.cD), a = A2(bb, bM, r.cD), i = Ij(r.mv), c = MS(e);
            return A2(zx, w([
                Gx("flex flex-col gap-4")
            ]), w([
                A2(zz, i, {
                    ex: a,
                    z2: It(e),
                    n2: It(c),
                    vn: r.vn,
                    l4: u
                }),
                A2(c_, AZ, A5(zO, e, r.dV, i, n, r.aX))
            ]));
        }
        return A2(zx, g, Nx);
    }), TO = F2(function(n, r) {
        return {
            g8: w([
                function() {
                    var t, e = r.mv;
                    if (3 === e.$) {
                        var u = e.a, a = v(r.cB, r.cD);
                        if (3 !== a.a.$ || a.b.$) return vE;
                        var i = a.a.a, c = a.b.a;
                        return A2(zx, w([
                            Gx("mt-12")
                        ]), w([
                            A5(XN, i, c, u, r.vn, r.yZ.jb)
                        ]));
                    }
                    return A2(zx, w([
                        Gx("flex flex-col gap-4")
                    ]), 3 === (t = r.cB).$ ? w([
                        A3(tH, r.mv, r.yZ, t.a),
                        A2(SO, n, r)
                    ]) : Nx);
                }()
            ]),
            yx: n(Ed.Aj)
        };
    }), PO = C_({
        Cl: wZ,
        CQ: xZ,
        Fj: _Z,
        F4: function() {
            return vx(w([
                bS(CZ),
                A2(kj, AZ, EZ())
            ]));
        },
        Gv: gN,
        GB: TO
    }), ZO = {
        $: 16
    }, MO = function(n) {
        return {
            $: 14,
            a: n
        };
    }, LO = function(n) {
        return {
            $: 4,
            a: n
        };
    }, NO = function(n) {
        return {
            $: 6,
            a: n
        };
    }, HO = function(n) {
        return {
            $: 5,
            a: n
        };
    }, IO = function(n) {
        return {
            $: 7,
            a: n
        };
    }, OO = {
        qD: 0,
        wH: g
    }, QO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, RO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, UO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, KO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, WO = A3(kp, 1992, 4, 31), XO = v({
        b5: It(WO),
        b6: !1,
        aU: Ot,
        Eg: !1,
        fD: 0,
        yG: WO
    }, A2(Nu, KO, Jz)), YO = function(n) {
        var r = XO.b;
        return v({
            hz: Ot,
            pS: Ot,
            b0: XO.a,
            A7: !1,
            sl: n,
            Cw: wm(!0)
        }, Uu(w([
            A2(Wp, RO, r),
            A2(Nu, UO, Jz)
        ])));
    }, JO = (hj = YO("configure-start-date"), yj = hj.b, v(m(hj.a, {
        A7: !0
    }), yj)), nQ = F2(function(n, r) {
        return m(r, {
            hv: n
        });
    }), rQ = function(n) {
        return n.sl;
    }, tQ = function(n) {
        return A2(nQ, F2(function(n, r) {
            return i(rQ(n), rQ(r));
        }), Cd({
            sl: "member-provider-selector-" + oe(n),
            Gj: F2(function(n, r) {
                return QS(r);
            }),
            Gk: function(n) {
                return It(rQ(n));
            }
        }));
    }, eQ = function(n) {
        return n.a.sl;
    }, uQ = function(n) {
        return {
            hv: Le,
            sl: n.sl,
            dJ: n.Gj,
            ln: n.Gk,
            Eg: !1
        };
    }, aQ = function(n) {
        return n.a.ur;
    }, iQ = function(n) {
        return A2(nQ, F2(function(n, r) {
            return i(eQ(n), eQ(r));
        }), uQ({
            sl: "member-selector-" + oe(n),
            Gj: F2(function(n, r) {
                return ZV(aQ(r));
            }),
            Gk: function(n) {
                return It(eQ(n));
            }
        }));
    }, cQ = function(n) {
        var r = A2(Ie, 0, n);
        return {
            cS: Ot,
            dR: r,
            be: A2(Fu, tQ, A2($e, 0, r - 1)),
            bh: A2(Fu, iQ, A2($e, 0, r - 1))
        };
    }, oQ = {
        sI: !1,
        fX: A2(nQ, F2(function(n, r) {
            return i(eQ(n), eQ(r));
        }), uQ({
            sl: "member-selector",
            Gj: F2(function(n, r) {
                return ZV(aQ(r));
            }),
            Gk: function(n) {
                return It(eQ(n));
            }
        }))
    }, fQ = function() {
        var n = JO.b;
        return v({
            b0: JO.a,
            dN: cQ(0),
            cZ: oQ,
            d9: Ot
        }, A2(Wp, QO, n));
    }(), sQ = function(n) {
        return A2(bk, w([
            "catalog"
        ]), fM(n));
    }, lQ = F7(function(n, r, t, e, u, a, i) {
        return {
            sH: t,
            vM: n,
            vN: r,
            l1: i,
            jd: e,
            je: u,
            mz: a
        };
    }), dQ = function(n) {
        switch(n){
            case "month":
                return It(0);
            case "quarter":
                return It(1);
            case "semi_annual":
                return It(2);
            case "annual":
                return It(3);
            default:
                return Ot;
        }
    }, vQ = function(n) {
        var r = dQ(n);
        return r.$ ? AA("Unsupported period name: " + n) : au(r.a);
    }, bQ = A4(JA, "price", ik(O$), Ot, A3(nk, "total_in_cents", O$, A4(JA, "registration_fee_in_cents", ik(O$), Ot, A4(JA, "recurring_amount_in_cents", ik(O$), Ot, A3(nk, "is_default", ru, A3(nk, "period_in_months", O$, A3(nk, "period", A2(nu, vQ, M$), au(lQ)))))))), mQ = Q$(w([
        ek(bQ),
        XA(g)
    ])), pQ = ik(A2(nu, vQ, M$)), $Q = A2(nu, function(n) {
        switch(n){
            case "plan":
                return au(0);
            case "package":
                return au(1);
            default:
                return AA("Unknown catalog type: " + n);
        }
    }, M$), gQ = A2(eu, cu, A3(nk, "total_in_cents", O$, A3(nk, "tax_in_cents", O$, A4(JA, "available_billing_periods", mQ, g, A4(JA, "expiration_copy", ik(M$), Ot, A4(JA, "billing_period", pQ, Ot, A4(JA, "recurring_amount_in_cents", ik(O$), Ot, A4(JA, "registration_fee_in_cents", ik(O$), Ot, A4(JA, "default_period_in_months", ik(O$), Ot, A3(nk, "price", ik(O$), A4(JA, "thumbnail_image_url", ik(M$), Ot, A4(JA, "cover_image_url", ik(M$), Ot, A4(JA, "description", ik(M$), Ot, A4(JA, "name", ik(M$), Ot, A3(nk, "type", $Q, A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return function(b) {
                                                                return {
                                                                    nG: d,
                                                                    Ag: s,
                                                                    pv: u,
                                                                    p3: c,
                                                                    p8: e,
                                                                    rk: l,
                                                                    sl: n,
                                                                    ur: t,
                                                                    l1: i,
                                                                    jd: f,
                                                                    je: o,
                                                                    mw: v,
                                                                    yv: a,
                                                                    mz: b,
                                                                    yS: r
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))), hQ = F3(function(n, r, t) {
        return A4(aA, n, ek(gQ), t, pk(sQ(r)));
    }), yQ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), wQ = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            ng: t,
            qj: e,
            sl: n,
            sL: o,
            sR: u,
            lz: c,
            ur: r,
            v4: i,
            y3: a
        };
    }), xQ = F2(function(n, r) {
        return {
            sl: n,
            ur: r
        };
    }), _Q = A3(nk, "name", M$, A3(nk, "id", M$, au(xQ))), CQ = A2($A, _Q, au(cu)), AQ = F2(function(n, r) {
        return {
            w1: r,
            w4: n
        };
    }), kQ = A3(nk, "requires_location_selection", ru, A3(nk, "requires_practitioner_selection", ru, au(AQ))), EQ = A2($A, kQ, au(cu)), qQ = F2(function(n, r) {
        return {
            sl: n,
            ur: r
        };
    }), FQ = A3(nk, "name", M$, A3(nk, "id", M$, au(qQ))), jQ = A2($A, FQ, au(cu)), DQ = A3(nk, "member_type", A2(nu, function(n) {
        return au(!n.$ && "Primary Member" === n.a);
    }, uC(M$)), A3(nk, "meta", EQ, A4(JA, "practitioner", uC(jQ), Ot, A3(nk, "uses_tobacco", uC(ru), A4(JA, "known_practice", uC(CQ), Ot, A3(nk, "dob", uC(KA), A3(nk, "age", uC(O$), A3(nk, "name", A2(eu, GV, M$), A3(nk, "id", M$, au(wQ)))))))))), VQ = A2(zB, 0, A2($A, DQ, au(yQ))), BQ = F3(function(n, r, t) {
        return A4(aA, n, ek(VQ), t, pk(function(n) {
            return A2(bk, w([
                "patients"
            ]), fM(n));
        }(r)));
    }), GQ = function(n) {
        return 1 === n.$ ? Bc(m(n.a, {
            aN: !1
        })) : Dc(m(n.a, {
            aN: !1
        }));
    }, zQ = function(n) {
        return A2(bb, function(n) {
            return mu(n) ? Ot : It(n);
        }, n);
    }, SQ = F2(function(n, r) {
        return {
            qh: r,
            sl: n
        };
    }), TQ = A3(nk, "distance", uC(I$), A3(nk, "id", M$, au(SQ))), PQ = A2($A, TQ, au(cu)), ZQ = A3(nk, "status", M$, A3(nk, "panel_size", O$, A3(nk, "max_patient_age", ik(O$), A3(nk, "min_patient_age", ik(O$), A3(nk, "education", ik(ek(M$)), A3(nk, "specialties", ek(M$), A3(nk, "locations", ek(PQ), A3(nk, "photo", A2(eu, zQ, ik(M$)), A3(nk, "bio", ik(M$), A3(nk, "name", M$, A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    n_: t,
                                                    qM: i,
                                                    sl: n,
                                                    it: u,
                                                    tv: o,
                                                    uj: c,
                                                    ur: r,
                                                    vf: f,
                                                    vR: e,
                                                    xX: a,
                                                    mt: s
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), MQ = A2($A, ZQ, au(cu)), LQ = function(n) {
        return A2(ce, 0, Yw(n));
    }, NQ = yn, HQ = F2(function(n, r) {
        return rx(w([
            v("zip", tx(n)),
            v("distance", A2(xc, nx, A2(Op, NQ, r)))
        ]));
    }), IQ = {
        kA: Ot,
        kB: Ot,
        k5: Ot,
        lo: 10,
        lq: Ot,
        ur: Ot,
        iH: 0,
        lQ: cA,
        mp: Ot,
        mD: Ot,
        zF: Ot
    }, OQ = function(n) {
        return A2(bk, w([
            "practitioners"
        ]), fM(n));
    }, QQ = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), ek(MQ), e, A2($k, function(n) {
            var r, t, e, u, a, i, c = n(IQ);
            return $(function() {
                var n = c.ur;
                return n.$ ? g : w([
                    A2(g_, "name", n.a)
                ]);
            }(), $((a = c.mp).$ ? g : w([
                A2(g_, "signup_page", a.a)
            ]), $((u = c.kA).$ ? g : w([
                A2(g_, "accepts_enrollments_from_employer", LQ(u.a))
            ]), $((e = c.kB).$ ? g : w([
                A2(g_, "accepts_enrollments_from_retail", LQ(e.a))
            ]), $((i = v(c.zF, c.k5)).a.$ ? g : w(i.b.$ ? [
                A2(g_, "near", A2(ce, 0, A2(HQ, i.a.a, Ot)))
            ] : [
                A2(g_, "near", A2(ce, 0, A2(HQ, i.a.a, It(i.b.a))))
            ]), $((t = c.lq).$ ? g : w([
                A2(g_, "location", t.a)
            ]), $(!(r = c.mD).$ && r.a ? w([
                A2(g_, "with_waitlist", "true")
            ]) : g, w([
                A2(iA, "offset", c.iH),
                A2(iA, "limit", c.lo)
            ]))))))));
        }(t), pk(OQ(r))));
    }), RQ = Yk("multiple_providers"), UQ = function(n) {
        var r = n.vn;
        return 3 === r.$ ? It(kM(r.a)) : Ot;
    }, KQ = F2(function(n, r) {
        return {
            sO: n,
            Go: r
        };
    }), WQ = A2(nu, vQ, M$), XQ = A2(nu, function(n) {
        switch(n){
            case "plan":
                return au(0);
            case "package":
                return au(1);
            default:
                return AA("Unknown catalog type: " + n);
        }
    }, M$), YQ = F3(function(n, r, t) {
        return {
            sl: n,
            jd: r,
            je: t
        };
    }), JQ = on, nR = A4(JQ, YQ, A2(Iu, "id", M$), A2(Iu, "recurring_amount_in_cents", O$), A2(Iu, "registration_fee_in_cents", O$)), rR = F2(function(n, r) {
        return {
            fy: n,
            EJ: r
        };
    }), tR = A4(JA, "practitioner_id", ik(M$), Ot, A3(nk, "patient_id", M$, au(rR))), eR = A2(eu, cu, A4(JA, "registration_fee_per_member", ru, !1, A4(JA, "member_breakdown", ek(nR), g, A4(JA, "billing_period", ik(WQ), Ot, A3(nk, "price_in_cents", O$, A3(nk, "tax_in_cents", O$, A3(nk, "registration_fee_in_cents", O$, A3(nk, "recurring_amount_in_cents", O$, A4(JA, "start_date", ik(M$), Ot, A4(JA, "period_in_months", ik(O$), Ot, A4(JA, "membership_patients", ek(tR), g, A4(JA, "owner", ik(M$), Ot, A3(nk, "type", XQ, A3(nk, "name", A2(eu, xc(""), ik(M$)), A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return {
                                                                Ag: l,
                                                                CI: t,
                                                                lt: d,
                                                                tL: u,
                                                                ur: r,
                                                                iO: e,
                                                                vN: a,
                                                                l2: s,
                                                                jd: c,
                                                                je: o,
                                                                l9: v,
                                                                f3: n,
                                                                x0: i,
                                                                mw: f
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))), uR = F2(function(n, r) {
        return {
            qD: n,
            wH: r
        };
    }), aR = F3(function(n, r, t) {
        return {
            zZ: r,
            Ag: n,
            FX: t
        };
    }), iR = A2(nu, vQ, M$), cR = A4(JA, "starts_on", ik(M$), Ot, A3(nk, "amount_in_cents", O$, A3(nk, "billing_period", iR, au(aR)))), oR = A4(JA, "recurring_groups", ek(cR), g, A3(nk, "due_today_in_cents", O$, au(uR))), fR = A3(nk, "totals", oR, A3(nk, "items", ek(eR), au(KQ))), sR = F3(function(n, r, t) {
        return A4(aA, n, fR, t, pk(A2(bk, w([
            "cart"
        ]), fM(r))));
    }), lR = F3(function(n, r) {
        var t = A2(YF, 0, ZO), e = t.b, u = fQ.b;
        return v({
            g0: r.g0,
            Z: r.Z,
            hj: kc,
            R: fQ.a,
            k7: !1,
            b3: Ot,
            rh: OG,
            ld: r.ld,
            bE: !1,
            fm: kc,
            fq: t.a,
            u3: Ot,
            dV: n,
            bK: g,
            cl: Ot,
            Go: OO,
            gg: UQ(r)
        }, Uu(w([
            A3(sR, r.g0, ux(n), LO),
            A3(BQ, r.g0, ux(n), HO),
            A3(hQ, r.g0, ux(n), NO),
            RQ(n) ? A4(QQ, r.g0, ux(n), function(n) {
                return m(n, {
                    lo: 100
                });
            }, IO) : Qp,
            e,
            A2(Wp, MO, u)
        ])));
    }), dR = F2(function(n, r) {
        return v(m(r, {
            Z: n.Z
        }), Qp);
    }), vR = F2(function(n, r) {
        return m(r, {
            zK: Ot
        });
    }), bR = {
        $: 9
    }, mR = function(n) {
        return {
            $: 17,
            a: n
        };
    }, pR = nr("onDropdownEscapeKeyPressed", M$), $R = function(n) {
        return pR(wm(n));
    }, gR = nr("onDropdownOutsideClick", M$), hR = function(n) {
        return gR(wm(n));
    }, yR = function(n) {
        return {
            $: 15,
            a: n
        };
    }, wR = function(n) {
        return {
            $: 11,
            a: n
        };
    }, xR = function(n) {
        return {
            $: 23,
            a: n
        };
    }, _R = function(n) {
        return n.cG.ph;
    }, CR = function(n) {
        return n.cG.qT;
    }, AR = function(n) {
        return n.cG.qW;
    }, kR = function(n) {
        return n.cG.dB;
    }, ER = function(n) {
        return n.cG.yx;
    }, qR = function(n) {
        return n.cG.yX;
    }, FR = function(n) {
        return A2(Op, function(n) {
            return n.ao;
        }, n.d9);
    }, jR = function(n) {
        return n.Ag;
    }, DR = function(n) {
        return n.nG;
    }, VR = function(n) {
        return A2(Op, function(n) {
            return n.vM;
        }, mb(A2(no, function(n) {
            return n.sH;
        }, DR(n))));
    }, BR = function(n) {
        return A2(Fu, function(n) {
            return n.fy;
        }, n.tL);
    }, GR = function(n) {
        return n.iO;
    }, zR = F2(function(n, r) {
        var t = function() {
            var r = GR(n);
            return r.$ ? BR(n) : A2(Qt, r.a, BR(n));
        }();
        return A2(n$, function(n) {
            return A2(SS, function(r) {
                return i(eQ(r), n);
            }, r);
        }, t);
    }), SR = function(n) {
        return n.sl;
    }, TR = function(n) {
        return n.tL;
    }, PR = F2(function(n, r) {
        return 1 === r.$ ? n(0) : r;
    }), ZR = function(n) {
        return n.f3;
    }, MR = function(n) {
        return n.x0;
    }, LR = F4(function(n, r, t, e) {
        return A2(Op, function(n) {
            return {
                ao: n,
                tL: TR(e),
                bK: t,
                s: A2(zR, e, r),
                cn: A2(PR, function() {
                    return VR(n);
                }, jR(e)),
                x0: A2(bb, A2(tu, RA, L$), MR(e))
            };
        }, A2(SS, function(n) {
            return i(SR(n), ZR(e));
        }, n));
    }), NR = F2(function(n, r) {
        return 0 > n ? Ot : mb(A2(Yp, n, r));
    }), HR = function(n) {
        return JF(n.fm);
    }, IR = F2(function(n, r) {
        var t = v(r.hj, HR(r));
        return 3 !== t.a.$ || t.b.$ ? Ot : A2(bb, A3(LR, t.a.a, t.b.a, r.bK), A2(NR, n, r.Z));
    }), OR = function(n) {
        return A3(de, QG, OG, n);
    }, QR = function(n) {
        return {
            g4: OR(A2(Fu, rQ, n)),
            k1: A2(Op, rQ, mb(n))
        };
    }, RR = F2(function(n, r) {
        var t = A2(Op, n, r);
        return !t.$ && t.a ? r : Ot;
    }), UR = function(n) {
        return n.sl;
    }, KR = F2(function(n, r) {
        return A2(RR, function(r) {
            return A2(UG, r, n.g4);
        }, A2(Op, UR, function(n) {
            return n.a.v4;
        }(r)));
    }), WR = F3(function(n, r, t) {
        return A2(PR, function() {
            return n.k1;
        }, A2(PR, function() {
            return mb(A2(n$, function(n) {
                return n.fK;
            }, r));
        }, A2(KR, n, t)));
    }), XR = F3(function(n, r, t) {
        return {
            vn: t,
            fK: A2(PR, function() {
                return A3(WR, r, g, t);
            }, A2(RR, function(n) {
                return A2(UG, n, r.g4);
            }, A2(bb, function(n) {
                return n.EJ;
            }, A2(SS, function(n) {
                return i(n.fy, eQ(t));
            }, n.tL))))
        };
    }), YR = F2(function(n, r) {
        return m(r, {
            pS: It(n)
        });
    }), JR = F2(function(n, r) {
        var t, e = QR(n.bK), u = JO.a, a = JO.b;
        return v(m(r, {
            b0: (t = n.x0).$ ? u : A2(YR, t.a, u),
            dN: cQ(ve(n.s)),
            cZ: oQ,
            d9: It({
                ao: n.ao,
                bK: n.bK,
                s: A2(Fu, A2(XR, n, e), n.s),
                cn: n.cn
            })
        }), A2(Wp, QO, a));
    }), nU = F2(function(n, r) {
        return A2(va, n, r);
    }), rU = F2(function(n, r) {
        return A2(Fu, Oc, A2(no, function(r) {
            return !i(r.a, n);
        }, A2(ge, RC, r)));
    }), tU = function(n) {
        return m(n, {
            d9: Ot
        });
    }, eU = F3(function(n, r, t) {
        if (0 > n) return t;
        var e = A2(Yp, n, t);
        if (e.b) {
            var u = e.b;
            return $(A2(kP, n, t), A2(Qt, r(e.a), u));
        }
        return t;
    }), uU = F2(function(n, r) {
        return A2(eU, n, wm(r));
    }), aU = function(n) {
        return {
            $: 1,
            a: n
        };
    }, iU = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cU = {
        $: 0
    }, oU = function(n) {
        return n.ur;
    }, fU = function(n) {
        return {
            Ag: Ot,
            CI: n.CI,
            lt: g,
            tL: n.tL,
            ur: n.ur,
            iO: n.iO,
            vN: n.vN,
            l2: 0,
            jd: 0,
            je: 0,
            l9: !1,
            f3: n.f3,
            x0: n.x0,
            mw: 0
        };
    }, sU = function(n) {
        return {
            fy: eQ(n.vn),
            EJ: n.fK
        };
    }, lU = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 3;
            case 2:
                return 6;
            default:
                return 12;
        }
    }, dU = function(n) {
        return n.yS;
    }, vU = F2(function(n, r) {
        var t = dU(n.ao), e = 1 === t ? v(A2(Op, A2(tu, function(n) {
            return n.vn;
        }, eQ), mb(n.s)), g) : v(Ot, A2(Fu, sU, n.s)), u = e.a;
        return fU({
            CI: t,
            tL: e.b,
            ur: A2(xc, "", oU(n.ao)),
            iO: u,
            vN: A2(Op, lU, n.cn),
            f3: SR(n.ao),
            x0: t ? Ot : A2(Op, hk, r.pS)
        });
    }), bU = function(n) {
        return n.a.qj;
    }, mU = function(n) {
        return !i(bU(n), Ot);
    }, pU = F2(function(n, r) {
        return A2(na, n, r);
    }), $U = F2(function(n, r) {
        return !A2(pU, r, n);
    }), gU = F3(function(n, r, t) {
        return {
            vn: t,
            fK: A3(WR, QR(n.bK), r, t)
        };
    }), hU = F2(function(n, r) {
        return mb(A2(no, function(n) {
            return !A2(Wk, function(r) {
                return i(eQ(r.vn), eQ(n));
            }, r);
        }, n));
    }), yU = F2(function(n, r) {
        return A2(Fu, Oc, A2(no, function(r) {
            return !i(r.a, n);
        }, A2(ge, RC, r)));
    }), wU = {
        $: 1
    }, xU = F2(function(n, r) {
        return i(n.pS, r) ? Ot : It({
            $: 0,
            a: r
        });
    }), _U = {
        $: 0
    }, CU = _U, AU = dF("required"), kU = {
        kQ: function(n) {
            return _d(n);
        },
        on: CU,
        eM: "elm-datepicker--",
        kV: g,
        A1: _p("yyyy-MM-dd"),
        A4: function(n) {
            switch(n){
                case 0:
                    return "Mo";
                case 1:
                    return "Tu";
                case 2:
                    return "We";
                case 3:
                    return "Th";
                case 4:
                    return "Fr";
                case 5:
                    return "Sa";
                default:
                    return "Su";
            }
        },
        hZ: 6,
        Cn: w([
            AU(!1)
        ]),
        Co: g,
        li: Ot,
        lj: Ot,
        Cw: wm(!1),
        lB: function(n) {
            switch(n){
                case 0:
                    return "January";
                case 1:
                    return "February";
                case 2:
                    return "March";
                case 3:
                    return "April";
                case 4:
                    return "May";
                case 5:
                    return "June";
                case 6:
                    return "July";
                case 7:
                    return "August";
                case 8:
                    return "September";
                case 9:
                    return "October";
                case 10:
                    return "November";
                default:
                    return "December";
            }
        },
        Er: RA,
        EC: "Please pick a date...",
        zr: oe
    }, EU = function(n) {
        switch(n){
            case 0:
                return "Mon";
            case 1:
                return "Tue";
            case 2:
                return "Wed";
            case 3:
                return "Thu";
            case 4:
                return "Fri";
            case 5:
                return "Sat";
            default:
                return "Sun";
        }
    }, qU = function(n) {
        var r = A2(WD, zM(sZ("/")), n), t = A2(UL, sZ("/"), n);
        return t.$ ? A2(UL, sZ("/"), r) : te(t.a);
    }, FU = function(n) {
        return m(kU, {
            A1: _p("MM/dd/yyyy"),
            A4: EU,
            Cn: w([
                AU(!0)
            ]),
            Co: w([
                v("input", !0)
            ]),
            Cw: n,
            Er: qU,
            EC: "mm/dd/yyyy"
        });
    }, jU = {
        $: 1
    }, DU = function(n) {
        return {
            $: 1,
            a: n
        };
    }, VU = {
        $: 0
    }, BU = function(n) {
        return {
            $: 2,
            a: n
        };
    }, GU = F3(function(n, r, t) {
        var e = t, u = e.b6;
        switch(r.$){
            case 0:
                return v(m(e, {
                    b5: It(i = r.a),
                    yG: i
                }), VU);
            case 1:
                return v(m(e, {
                    b5: It(i = r.a)
                }), VU);
            case 10:
                var a = r.b;
                return v(m(e, {
                    b5: It(i = r.a),
                    fD: a
                }), VU);
            case 9:
                return v(m(e, {
                    fD: a = r.a
                }), VU);
            case 2:
                var i = r.a;
                return v(m(e, {
                    b5: Ot,
                    aU: Ot,
                    Eg: !1
                }), BU(i));
            case 3:
                var c = r.a, o = n.Er(c);
                return o.$ ? v(m(e, {
                    aU: It(c),
                    Eg: !0
                }), VU) : v(m(e, {
                    b5: It(i = o.a),
                    aU: It(c),
                    Eg: !0
                }), BU(i));
            case 4:
                if (u) return v(e, VU);
                var f = function() {
                    var r = e.aU;
                    if (1 === r.$) return DU(jU);
                    if ("" === r.a) return DU(jU);
                    var t = n.Er(r.a);
                    if (t.$) return DU({
                        $: 0,
                        a: t.a
                    });
                    var u = t.a;
                    return n.Cw(u) ? DU(function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(u)) : BU(u);
                }();
                return v(m(e, {
                    b5: 2 === f.$ ? It(f.a) : e.b5,
                    aU: 2 === f.$ ? Ot : e.aU
                }), f);
            case 5:
                return v(m(e, {
                    b6: !1,
                    Eg: !0
                }), VU);
            case 6:
                return v(m(e, {
                    Eg: u
                }), VU);
            case 7:
                return v(m(e, {
                    b6: !0
                }), VU);
            case 8:
                return v(m(e, {
                    b6: !1
                }), VU);
            default:
                return v(27 === r.a ? m(e, {
                    Eg: !1
                }) : e, VU);
        }
    }), zU = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    hz: It(t)
                });
                return r.A7 ? b(m(e, {
                    pS: It(A2(xc, t, r.pS))
                }), Qp, It({
                    $: 2,
                    a: t
                })) : b(e, Qp, Ot);
            case 1:
                var u = n.a, a = A3(GU, FU(r.Cw), u, r.b0), i = a.a, c = a.b, o = function() {
                    switch(c.$){
                        case 2:
                            return It(c.a);
                        case 1:
                            return 2 === c.a.$ ? It(c.a.a) : Ot;
                        default:
                            return r.pS;
                    }
                }();
                return b(m(r, {
                    pS: o,
                    b0: i
                }), Qp, A2(xU, r, o));
            case 2:
                return b(r, Qp, It(wU));
            default:
                return b(r, Qp, Ot);
        }
    }), SU = {
        $: 1
    }, TU = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), PU = {
        $: 0
    }, ZU = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), MU = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), LU = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), NU = F2(function(n, r) {
        return A2(Fu, Oc, A2(no, function(r) {
            return !i(r.a, n);
        }, A2(ge, RC, r)));
    }), HU = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 0:
                return b(m(t, {
                    cS: It(l = n.a)
                }), Qp, PU);
            case 1:
                return b(m(t, {
                    dR: t.dR + 1,
                    be: $(t.be, w([
                        tQ(t.dR)
                    ])),
                    bh: $(t.bh, w([
                        iQ(t.dR)
                    ]))
                }), Qp, SU);
            case 2:
                return b(m(t, {
                    cS: Ot,
                    be: A2(NU, l = n.a, t.be),
                    bh: A2(NU, l, t.bh)
                }), Qp, {
                    $: 2,
                    a: l
                });
            case 3:
                var e = n.b, u = A2(NR, l = n.a, t.bh);
                if (u.$) return b(t, Qp, PU);
                var a = A2(dG, e, u.a), i = a.b, c = a.c, o = A3(uU, l, a.a, t.bh), f = c.$ || c.a.$ || c.a.a.$ ? v(t.cS, PU) : v(Ot, A2(TU, l, c.a.a.a)), s = f.b;
                return b(m(t, {
                    cS: f.a,
                    bh: o
                }), A2(Wp, LU(l), i), s);
            default:
                e = n.b;
                var l, d = A2(NR, l = n.a, t.be);
                if (d.$) return b(t, Qp, PU);
                var p = A2(dG, e, d.a), g = (i = p.b, c = p.c, A3(uU, l, p.a, t.be));
                return s = c.$ || c.a.$ || c.a.a.$ ? PU : A2(ZU, l, c.a.a.a), b(m(t, {
                    be: g
                }), A2(Wp, MU(l), i), s);
        }
    }), IU = function(n) {
        return {
            $: 1,
            a: n
        };
    }, OU = F2(function(n, r) {
        var t = r;
        if (n.$) {
            var e = A2(dG, n.a, t.fX), u = e.a, a = e.b, i = e.c;
            if (i.$ || i.a.$ || i.a.a.$) return b(m(t, {
                fX: u
            }), A2(Wp, IU, a), Ot);
            var c = i.a.a.a;
            return b(m(t, {
                sI: !1,
                fX: u
            }), A2(Wp, IU, a), It(c));
        }
        return b(m(t, {
            sI: !0
        }), Qp, Ot);
    }), QU = F2(function(n, r) {
        return m(r, {
            Cw: n
        });
    }), RU = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                var e = A2(zU, n.a, t.b0), u = e.a, a = e.b, i = e.c, c = i.$ || 2 !== i.a.$ ? u : A2(QU, $U(i.a.a), u);
                return b(m(t, {
                    b0: c
                }), A2(Wp, QO, a), cU);
            case 1:
                var o = A2(HU, n.a, t.dN), f = o.a, s = o.b, l = o.c, d = function() {
                    var n = v(l, t.d9);
                    n: for(; !n.b.$;)switch(n.a.$){
                        case 1:
                            var e = n.b.a, u = A2(hU, A2(no, mU, r), e.s);
                            return It(u.$ ? e : m(e, {
                                s: $(e.s, w([
                                    A3(gU, e, e.s, u.a)
                                ]))
                            }));
                        case 2:
                            return It(m(e = n.b.a, {
                                s: A2(yU, c = n.a.a, e.s)
                            }));
                        case 3:
                            var a = n.a, i = a.b;
                            return It(m(e = n.b.a, {
                                s: A3(uU, c = a.a, A3(gU, e, A2(yU, c, e.s), i), e.s)
                            }));
                        case 4:
                            var c, o = n.a, f = o.b;
                            return It(m(e = n.b.a, {
                                s: A3(eU, c = o.a, function(n) {
                                    return m(n, {
                                        fK: It(rQ(f))
                                    });
                                }, e.s)
                            }));
                        default:
                            break n;
                    }
                    return t.d9;
                }();
                return b(m(t, {
                    dN: f,
                    d9: d
                }), A2(Wp, aU, s), cU);
            case 2:
                var p = A2(OU, n.a, t.cZ), g = p.a, h = p.b;
                return d = (_ = v(p.c, t.d9)).a.$ || _.b.$ ? t.d9 : It(m(_.b.a, {
                    s: w([
                        {
                            vn: _.a.a,
                            fK: Ot
                        }
                    ])
                })), b(m(t, {
                    cZ: g,
                    d9: d
                }), A2(Wp, iU, h), cU);
            case 3:
                var y = t.d9;
                return b(y.$ ? t : m(t, {
                    d9: It(m(y.a, {
                        cn: It(n.a)
                    }))
                }), Qp, cU);
            case 4:
                var x = t.d9;
                return b(t, Qp, x.$ ? cU : {
                    $: 1,
                    a: A2(vU, x.a, t.b0)
                });
            default:
                return b(t, Qp, cU);
        }
        var _;
    }), UU = F3(function(n, r, t) {
        return t.$ ? g : w([
            v(n, r(t.a))
        ]);
    }), KU = function(n) {
        return rx(A2(Qt, v("patient_id", tx(n.fy)), A3(UU, "practitioner_id", tx, n.EJ)));
    }, WU = F2(function(n, r) {
        return A3(de, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), XU = function(n) {
        var r = n;
        return rx(A2(Qt, v("id", tx(r.f3)), A2(Qt, v("type", tx(r.CI ? "package" : "plan")), A2(Qt, v("name", tx(r.ur)), $(function(n) {
            return n.CI ? A3(UU, "owner", tx, n.iO) : w([
                v("membership_patients", A2(WU, KU, n.tL))
            ]);
        }(r), $(A3(UU, "period_in_months", NQ, r.vN), A3(UU, "start_date", tx, r.x0)))))));
    }, YU = F4(function(n, r, t, e) {
        var u = rx(w([
            v("items", A2(WU, XU, t))
        ]));
        return A4(Dj, n, fR, e, A2(dM, u, pk(A2(bk, w([
            "cart"
        ]), fM(r)))));
    }), JU = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(r, A2(__, pa, Da), g);
            case 1:
                return b(r, A2(__, pa, Ea), g);
            case 2:
                return b(m(r, {
                    k7: !r.k7
                }), Qp, g);
            case 3:
                var t = n.a;
                return b(m(r, {
                    rh: A2(A2(UG, t, r.rh) ? nU : QG, t, r.rh)
                }), Qp, g);
            case 4:
                return 3 === (p = n.a).$ ? b(m(r, {
                    Z: ($ = p.a).sO,
                    Go: $.Go
                }), Qp, w([
                    xR($.sO)
                ])) : b(r, Qp, g);
            case 5:
                return b(m(r, {
                    fm: p = n.a
                }), Qp, g);
            case 6:
                return b(m(r, {
                    hj: p = n.a
                }), Qp, g);
            case 7:
                return b(3 === (p = n.a).$ ? m(r, {
                    bK: p.a
                }) : r, Qp, g);
            case 8:
                return b(m(r, {
                    u3: i(r.u3, It(e = n.a)) ? Ot : It(e)
                }), Qp, g);
            case 9:
                return b(m(r, {
                    u3: Ot
                }), Qp, g);
            case 10:
                var e = n.a;
                if (r.bE) return b(r, Qp, g);
                var u = A2(rU, e, r.Z);
                return b(m(r, {
                    bE: !0,
                    u3: Ot
                }), A4(YU, r.g0, ux(r.dV), u, wR), g);
            case 11:
                return 3 === (p = n.a).$ ? b(m(r, {
                    Z: ($ = p.a).sO,
                    bE: !1,
                    Go: $.Go
                }), Qp, w([
                    xR($.sO)
                ])) : b(m(r, {
                    bE: !1
                }), Qp, g);
            case 12:
                var a = A2(IR, e = n.a, r);
                if (a.$) return b(m(r, {
                    u3: Ot
                }), Qp, g);
                var c = A2(JR, a.a, r.R), o = c.b;
                return b(m(r, {
                    R: s = c.a,
                    b3: It(e),
                    fq: zj(r.fq),
                    u3: Ot,
                    cl: Ot
                }), A2(Wp, MO, o), g);
            case 13:
                return b(m(r, {
                    R: tU(r.R),
                    cl: FR(r.R)
                }), Qp, g);
            case 14:
                var f = A3(RU, n.a, A2(xc, g, HR(r)), r.R), s = f.a, l = (o = f.b, f.c);
                if (1 === l.$) {
                    var d = l.a, v = r.b3;
                    return v.$ ? b(m(r, {
                        R: tU(s),
                        fq: Bj(r.fq),
                        cl: Ot
                    }), Qp, g) : (e = v.a, b(m(r, {
                        R: tU(s),
                        bE: !0,
                        fq: Bj(r.fq),
                        cl: Ot
                    }), A4(YU, r.g0, ux(r.dV), A3(uU, e, d, r.Z), yR), g));
                }
                return b(m(r, {
                    R: s
                }), A2(Wp, MO, o), g);
            case 15:
                var p, $;
                return 3 === (p = n.a).$ ? b(m(r, {
                    Z: ($ = p.a).sO,
                    b3: Ot,
                    bE: !1,
                    Go: $.Go
                }), Qp, w([
                    xR($.sO)
                ])) : b(m(r, {
                    b3: Ot,
                    bE: !1
                }), Qp, A2(Qt, Lk(qR), A2(Ik, 0, p)));
            case 16:
                return b(m(r, {
                    R: tU(r.R),
                    b3: Ot,
                    fq: Bj(r.fq),
                    cl: Ot
                }), Qp, g);
            default:
                var h = A2(Sj, n.a, r.fq), y = h.b;
                return b(m(r, {
                    fq: h.a
                }), A2(Wp, mR, y), g);
        }
    }), nK = {
        $: 0
    }, rK = function(n) {
        var r = n.yx, t = n.Dy, e = n.AG;
        return A2(zx, w([
            Gx("flex justify-between items-center mb-4")
        ]), w([
            e ? A2(xF, w([
                Gx("text-2xl")
            ]), w([
                _d(r)
            ])) : A2(CF, g, w([
                _d(r)
            ])),
            A2(zx, w([
                Gx("cursor-pointer"),
                qE(t)
            ]), w([
                A2(c_, Cu, A2(Tq, w([
                    pD,
                    Wj("text-text-secondary")
                ]), 2))
            ]))
        ]));
    }, tK = function(n) {
        return rK({
            AG: !0,
            Dy: nK,
            yx: n(ER)
        });
    }, eK = {
        $: 1
    }, uK = {
        $: 2
    }, aK = function(n) {
        return {
            $: 3,
            a: n
        };
    }, iK = Uj(w([
        Gx("w-full")
    ])), cK = function(n) {
        return A2(yF, w([
            fF,
            iK,
            Kj(w([
                Gx("checkout-cta")
            ])),
            cF(n.uS),
            Lj(n.pF),
            Qj(n.pH)
        ]), w([
            _d(n.pG)
        ]));
    }, oK = Ox(0), fK = function(n) {
        var r = n.kf.$ ? "items-center" : "items-start", t = w(n.kS ? [
            Gx("flex justify-between " + r + " cursor-pointer py-1"),
            qE(n.lL)
        ] : [
            Gx("flex justify-between " + r + " py-1")
        ]), e = w(n.sL ? [
            VG,
            GN
        ] : [
            VG,
            GN,
            Hx(w([
                Gx("text-text-secondary")
            ]))
        ]), u = n.la ? "-rotate-90" : "rotate-90", a = n.sL ? "text-primary-500" : "text-text-secondary";
        return A2(zx, g, w([
            A2(zx, t, w([
                A2(zx, w([
                    Gx("flex flex-col")
                ]), w([
                    A2(f_, e, w([
                        _d(n.sT)
                    ])),
                    function() {
                        var r = n.kf;
                        if (r.$) return _d("");
                        var t = r.a;
                        return A2(PE, w([
                            nF,
                            oK
                        ]), w([
                            _d(t)
                        ]));
                    }()
                ])),
                A2(zx, w([
                    Gx("flex items-center gap-2")
                ]), w([
                    n.kJ,
                    A2(Tq, w([
                        zE,
                        Wj("transform " + u + " " + a)
                    ]), 7)
                ]))
            ]))
        ]));
    }, sK = function(n) {
        return n.aw.A0;
    }, lK = function(n) {
        return n.aw.Bl;
    }, dK = function(n) {
        return n.aw.Bm;
    }, vK = function(n) {
        return n.aw.Bn;
    }, bK = function(n) {
        return n.aw.Bo;
    }, mK = function(n) {
        return n.aw.Bp;
    }, pK = function(n) {
        return n.aw.Dj;
    }, $K = function(n) {
        return n.aw.E1;
    }, gK = function(n) {
        return n.aw.FV;
    }, hK = function(n) {
        return n.aw.ms;
    }, yK = F2(function(n, r) {
        if (1 === r.$) return Ot;
        var t = RA(r.a);
        if (t.$) return Ot;
        var e = t.a;
        return It(A3(N_, "{ $date }", A2(_p, n(sK), e), n(pK)));
    }), wK = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xK = F5(function(n, r, t, e, u) {
        return {
            A5: t,
            st: r,
            u5: n,
            i8: e,
            ym: u
        };
    }), _K = function(n) {
        return w([
            n
        ]);
    }, CK = F2(function(n, r) {
        var t = lu(r), e = 0 > s(t, n) ? rm(n - t) : 0;
        return $(r, A2(ab, e, "0"));
    }), AK = function(n) {
        return "0" !== A2(yb, 1, n) ? n : AK(A2(VI, 1, n));
    }, kK = F2(function(n, r) {
        var t = n.A5;
        switch(t.$){
            case 1:
                return AK(r);
            case 2:
                return r;
            default:
                return A2(CK, t.a, r);
        }
    }), EK = F2(function(n, r) {
        var t = A2(Wk, function(n) {
            return "0" !== n && "." !== n;
        }, Wm(r));
        return $(n && t ? "-" : "", r);
    }), qK = function(n) {
        var r = n.a, t = n.b;
        if ("9" === r) {
            var e = ke(t);
            return 1 === e.$ ? "01" : A2(tb, "0", qK(e.a));
        }
        var u = he(r);
        return u >= 48 && 57 > u ? A2(tb, FC(u + 1), t) : "0";
    }, FK = G, jK = F3(function(n, r, t) {
        return $(t, A2(ab, n - lu(t), eb(r)));
    }), DK = function(n) {
        for(var r = n.length, t = Array(r), e = 0; r > e;){
            var u = n.charCodeAt(e);
            55296 > u || u > 56319 ? (t[r - e] = n[e], e++) : (t[r - e] = n[e + 1], t[r - ++e] = n[e - 1], e++);
        }
        return t.join("");
    }, VK = function(n) {
        var r = A2(se, ".", n);
        return r.b ? v(r.a, r.b.b ? r.b.a : "0") : v("0", "0");
    }, BK = F3(function(n, r, t) {
        if ((e = t) === 1 / 0 || e === -1 / 0 || FK(t)) return jF(t);
        var e, u = 0 > t, a = VK(function(n) {
            var r = A2(se, "e", jF(rm(n)));
            if (r.b) {
                if (r.b.b) {
                    var t = r.a, e = r.b.a, u = A2(xc, 0, $u(A2(xu, "+", e) ? A2(vu, 1, e) : e)), a = VK(t), i = $(a.a, a.b), c = 0 > u ? A2(xc, "0", A2(Op, function(n) {
                        return n.a + "." + n.b;
                    }, A2(Op, lx(eb), ke($(A2(ab, rm(u), "0"), i))))) : A3(jK, u + 1, "0", i);
                    return $(0 > n ? "-" : "", c);
                }
                return $(0 > n ? "-" : "", t = r.a);
            }
            return "";
        }(rm(t))), i = a.a, c = a.b, o = lu(i) + r, f = $(A2(ab, 1 - o, "0"), A3(jK, o, "0", $(i, c))), l = lu(f), d = A2(Ie, 1, o), v = A2(n, u, A3(du, d, l, f)), b = A3(du, 0, d, f), m = v ? DK(A2(xc, "1", A2(Op, qK, ke(DK(b))))) : b, p = lu(m), g = "0" === m ? m : r > 0 ? 0 > s(r, lu(c)) ? A3(du, 0, p - r, m) + "." + A3(du, p - r, p, m) : $(i + ".", A3(jK, r, "0", c)) : $(m, A2(ab, rm(r), "0"));
        return A2(EK, u, g);
    }), GK = BK(F2(function(n, r) {
        var t, e = ke(r);
        return 1 !== e.$ && ("5" === e.a.a ? "" !== e.a.b || !n : (t = he(e.a.a)) > 53 && n || t >= 53 && !n);
    })), zK = function(n) {
        return n.b ? It(n.b) : Ot;
    }, SK = F2(function(n, r) {
        var t = function() {
            var r = n.A5;
            switch(r.$){
                case 1:
                default:
                    return GK(r.a);
                case 0:
                    return jF;
            }
        }(), e = A2(se, ".", t(r)), u = function() {
            var n = zK(e);
            return n.$ ? "" : A2(xc, "", mb(n.a));
        }();
        return v(A2(xc, "", mb(e)), u);
    }), TK = F2(function(n, r) {
        var t, e = A2(SK, n, r), u = function(n) {
            var r = function(n) {
                return lu(n) > 3 ? A2(Qt, A2(yb, 3, n), r(A2(VI, 3, n))) : w([
                    n
                ]);
            };
            return Ae(r(n));
        }(A2(cV, _e, e.a)), a = A5(xK, r, u, A2(kK, n, e.b), "", "");
        switch(A2(ae, function(n) {
            return "0" === n;
        }, f$(A2(dc, (t = a).st, _K(t.A5)))) ? 1 : 0 > t.u5 ? 2 : 0){
            case 2:
                return m(a, {
                    i8: n.iD,
                    ym: n.lD
                });
            case 0:
                return m(a, {
                    i8: n.v$,
                    ym: n.v0
                });
            default:
                return m(a, {
                    i8: n.zA,
                    ym: n.zE
                });
        }
    }), PK = F2(function(n, r) {
        return "" === r ? "" : $(n.cJ, r);
    }), ZK = F2(function(n, r) {
        var t = PK(n), e = A2(fe, n.di, r.st), u = t(r.A5);
        return f$(w([
            r.i8,
            e,
            u,
            r.ym
        ]));
    }), MK = F2(function(n, r) {
        return A2(ZK, n, A2(TK, n, r));
    }), LK = {
        cJ: ".",
        A5: {
            $: 0,
            a: 0
        },
        iD: "\u2212",
        lD: "",
        v$: "",
        v0: "",
        di: "",
        zA: "",
        zE: ""
    }, NK = m(LK, {
        A5: wK(2),
        di: ","
    }), HK = F3(function(n, r, t) {
        var e = rm(t), u = r ? "$" : "", a = 0 > t ? "-" : "", i = n ? m(NK, {
            A5: wK(0)
        }) : NK;
        return $(a, $(u, A2(MK, i, e)));
    }), IK = F3(function(n, r, t) {
        return A3(HK, n, r, .01 * t);
    }), OK = function(n) {
        return A3(IK, !1, !0, n);
    }, QK = F2(function(n, r) {
        return A2(zx, w([
            Gx("flex items-baseline shrink-0 text-support")
        ]), A2(Qt, A2(PE, w([
            Hx(w([
                Gx("cart-summary__price-sign self-start")
            ]))
        ]), w([
            _d("$")
        ])), A2(Qt, A2(PE, g, w([
            _d(A2(vu, 1, OK(n)))
        ])), function() {
            if (r.$) return g;
            var n = r.a;
            return w([
                A2(PE, w([
                    Hx(w([
                        Gx("cart-summary__price-suffix")
                    ]))
                ]), w([
                    _d(n)
                ]))
            ]);
        }())));
    }), RK = function(n) {
        return mu(n) ? Ot : It(n);
    }, UK = F4(function(n, r, t, e) {
        return A2(zx, w([
            Gx("flex flex-col")
        ]), w([
            A2(zx, w([
                Gx("flex justify-between items-start gap-2 text-sm")
            ]), w([
                A2(PE, w([
                    nF,
                    Hx(w([
                        Gx("min-w-0 break-words")
                    ]))
                ]), w([
                    _d(n)
                ])),
                A2(QK, r, RK(t))
            ])),
            A2(PE, w([
                nF,
                oK
            ]), w([
                _d(e)
            ]))
        ]));
    }), KK = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("flex justify-between items-start gap-2 text-sm")
        ]), w([
            A2(PE, w([
                nF,
                Hx(w([
                    Gx("min-w-0 break-words")
                ]))
            ]), w([
                _d(n)
            ])),
            A2(QK, r, RK(t))
        ]));
    }), WK = F2(function(n, r) {
        var t = jR(r);
        if (t.$) return !1;
        var e = t.a, u = v(A2(bb, function(n) {
            return n.FX;
        }, mb(A2(no, function(n) {
            return i(n.Ag, e);
        }, n.Go.wH))), MR(r));
        return !u.a.$ && !u.b.$ && s(u.b.a, u.a.a) > -1;
    }), XK = F3(function(n, r, t) {
        if (A2(WK, r, t)) {
            var e = MR(t);
            if (e.$) return n(hK);
            var u = RA(e.a);
            if (u.$) return n(hK);
            var a = u.a;
            return A3(N_, "{ $date }", A2(_p, n(sK), a), n(gK));
        }
        return n(hK);
    }), YK = function(n) {
        return n.CI;
    }, JK = function(n) {
        return n.fC.kK;
    }, nW = function(n) {
        return n.fC.lC;
    }, rW = function(n) {
        return n.fC.l6;
    }, tW = function(n) {
        return n.fC.mk;
    }, eW = F2(function(n, r) {
        return n(function() {
            switch(r){
                case 0:
                    return nW;
                case 1:
                    return rW;
                case 2:
                    return tW;
                default:
                    return JK;
            }
        }());
    }), uW = function(n) {
        return n.ur;
    }, aW = function(n) {
        return n.jd;
    }, iW = F2(function(n, r) {
        for(;;){
            if (-2 === r.$) return n;
            var t = r.d;
            n = A2(iW, n + 1, r.e), r = t;
        }
    }), cW = F2(function(n, r) {
        var t = A2(eW, n.mA, r.Ag), e = A2(no, function(n) {
            return i(jR(n), It(r.Ag));
        }, A2(no, function(n) {
            return aW(n) > 0;
        }, A2(no, function(n) {
            return !YK(n);
        }, n.sO))), u = function(n) {
            return A2(iW, 0, n);
        }(OR(A2(n$, MR, e))) > 1, a = A2(Fu, function(r) {
            return u ? A4(UK, uW(r), aW(r), t, A3(XK, n.mA, n, r)) : A3(KK, uW(r), aW(r), t);
        }, e);
        return A2(zx, w([
            Gx("cart-summary__breakdown pl-3 pr-8 mt-1 mb-2 flex flex-col gap-1")
        ]), a);
    }), oW = F2(function(n, r) {
        switch(lU(r)){
            case 3:
                return n(dK);
            case 6:
                return n(bK);
            case 12:
                return n(lK);
            default:
                return n(vK);
        }
    }), fW = function(n) {
        switch(n){
            case 0:
                return "month";
            case 1:
                return "quarter";
            case 2:
                return "semi_annual";
            default:
                return "annual";
        }
    }, sW = FG(2), lW = FG(0), dW = GE(0), vW = function(n) {
        return n.fB.kK;
    }, bW = function(n) {
        return n.fB.lC;
    }, mW = function(n) {
        return n.fB.l6;
    }, pW = function(n) {
        return n.fB.mk;
    }, $W = F2(function(n, r) {
        return n(function() {
            switch(r){
                case 0:
                    return bW;
                case 1:
                    return mW;
                case 2:
                    return pW;
                default:
                    return vW;
            }
        }());
    }), gW = fE(0), hW = F2(function(n, r) {
        return A2(zx, w([
            Gx("tooltip")
        ]), w([
            A2(Mx, w([
                Gx("tooltip__text")
            ]), w([
                _d(n)
            ])),
            r
        ]));
    }), yW = F8(function(n, r, t, e, u, a, i, c) {
        var o = e ? i_ : f_, f = i ? w([
            LE
        ]) : g, s = n ? eW(r) : $W(r), l = e && i ? w([
            Gx("text-primary-500")
        ]) : g, d = c ? A2(zx, g, w([
            A2(hW, r(Zd), A2(zx, g, w([
                _d(" + " + r(Bd)),
                A2(Tq, w([
                    dW
                ]), 5)
            ])))
        ])) : vE;
        return A2(zx, A2(Qt, Gx("flex "), Yx(a)), function() {
            var n, r = (n = A2(se, ".", A3(IK, !1, !1, t))).b && n.b.b && !n.b.b.b ? It(v(n.a, n.b.a)) : Ot;
            if (r.$) return w([
                vE
            ]);
            var e = r.a, a = e.a, i = e.b;
            return w([
                A2(o, w([
                    uF(lW),
                    Hx(A2(Qt, Gx("quote-info__rate--sign"), l)),
                    gW
                ]), w([
                    _d("$")
                ])),
                A2(o, A2(Qt, Hx(A2(Qt, Gx("quote-info__rate--dollars"), l)), A2(Qt, gW, f)), w([
                    _d(a)
                ])),
                A2(o, w([
                    uF(lW),
                    Hx(A2(Qt, Gx("quote-info__rate--cents"), l)),
                    gW
                ]), w([
                    _d("." + i)
                ])),
                function() {
                    if (u.$) return vE;
                    var n = u.a;
                    return A2(f_, w([
                        uF(sW),
                        Hx(w([
                            Gx("quote-info__rate--period")
                        ])),
                        gW
                    ]), w([
                        _d(s(n)),
                        d
                    ]));
                }()
            ]);
        }());
    }), wW = yW(!0), xW = F2(function(n, r) {
        var t = A2(yK, n.mA, r.FX), e = fW(r.Ag), u = A2(UG, e, n.rh), a = A2(zx, w([
            Gx("quote-info__rate--muted")
        ]), w([
            A2(c_, Cu, A7(wW, n.mA, r.zZ, !0, It(r.Ag), yE, !1, !1))
        ]));
        return A2(zx, g, w([
            fK({
                kJ: a,
                kS: !0,
                la: u,
                sL: !1,
                sT: A2(oW, n.mA, r.Ag),
                lL: n.u0(e),
                kf: t,
                mA: n.mA
            }),
            u ? A2(cW, n, r) : _d("")
        ]));
    }), _W = function(n) {
        return A2(Fu, function(r) {
            return A2(xW, n, r);
        }, n.Go.wH);
    }, CW = function(n) {
        return A3(de, ue, 0, n);
    }, AW = F2(function(n, r) {
        return A2(zx, w([
            Gx("flex justify-between items-start gap-2 text-sm")
        ]), w([
            A2(PE, w([
                nF,
                Hx(w([
                    Gx("min-w-0 break-words")
                ]))
            ]), w([
                _d(n)
            ])),
            A2(QK, r, Ot)
        ]));
    }), kW = function(n) {
        return n.je;
    }, EW = function(n) {
        return n.mw;
    }, qW = function(n) {
        return n.l2;
    }, FW = F2(function(n, r) {
        if (YK(r)) {
            var t = qW(r);
            return t > 0 ? It(A2(AW, uW(r), t)) : Ot;
        }
        if (A2(WK, n, r)) return Ot;
        var e = aW(r);
        return e > 0 ? It(A2(AW, uW(r), e)) : Ot;
    }), jW = function(n) {
        var r = CW(A2(Fu, EW, n.sO)), t = r > 0 ? w([
            A2(AW, n.mA(rv), r)
        ]) : g, e = CW(A2(Fu, kW, n.sO)), u = e > 0 ? w([
            A2(AW, n.mA($K), e)
        ]) : g, a = A2(n$, FW(n), n.sO), i = function() {
            var r = n.kX;
            if (r.$) return g;
            var t = r.a;
            return t > 0 ? w([
                A2(AW, n.mA(Td), t)
            ]) : g;
        }(), c = $(u, $(a, $(t, i)));
        return A2(zx, w([
            Gx("cart-summary__breakdown pl-3 pr-8 mt-1 mb-2 flex flex-col gap-1")
        ]), c);
    }, DW = yW(!1), VW = function(n) {
        return A2(zx, g, w([
            fK({
                kJ: A2(c_, Cu, A7(DW, n.mA, n.Go.qD + A2(xc, 0, n.kX), !1, Ot, yE, !1, !1)),
                kS: !0,
                la: n.k7,
                sL: !0,
                sT: n.mA(mK),
                lL: n.uZ,
                kf: Ot,
                mA: n.mA
            }),
            n.k7 ? jW(n) : _d("")
        ]));
    }, BW = function(n) {
        return A2(zx, w([
            Gx("flex flex-col gap-3")
        ]), $(function(n) {
            var r = CW(A2(Fu, function(n) {
                return n.zZ;
            }, n.Go.wH)), t = n.Go.qD;
            return t || r ? t ? r ? i(t, r) && 1 === ve(n.Go.wH) ? _W(n) : A2(Qt, VW(n), _W(n)) : w([
                VW(n)
            ]) : _W(n) : g;
        }(n), w([
            cK(n)
        ])));
    }, GW = function(n) {
        var r = n.CX, t = n.Ba;
        return A2(zx, w([
            Gx("flex w-full")
        ]), w([
            A2(zx, w([
                Gx("flex-1")
            ]), r),
            A2(zx, w([
                Gx("hidden md:block")
            ]), w([
                t
            ]))
        ]));
    }, zW = function(n) {
        return {
            $: 12,
            a: n
        };
    }, SW = function(n) {
        return {
            $: 8,
            a: n
        };
    }, TW = function(n) {
        return n.aO.Bq;
    }, PW = function(n) {
        return n.aO.Bs;
    }, ZW = function(n) {
        return n.aO.CH;
    }, MW = function(n) {
        return n.aO.tK;
    }, LW = function(n) {
        return n.aO.Ed;
    }, NW = function(n) {
        return n.aO.Ef;
    }, HW = function(n) {
        return n.aO.EZ;
    }, IW = function(n) {
        return n.aO.E3;
    }, OW = function(n) {
        return n.aO.Gu;
    }, QW = F3(function(n, r, t) {
        var e = n(OW);
        return 3 === r.$ ? A2(xc, e, A2(ra, t, ed(A2(Fu, function(n) {
            return v(eQ(n), aQ(n));
        }, r.a)))) : e;
    }), RW = function(n) {
        return A2(zx, w([
            Gx("cart-item-card__member-row")
        ]), w([
            A2(Tq, w([
                zE,
                Wj("text-text-secondary")
            ]), 39),
            A2(PE, w([
                VG,
                Hx(w([
                    Gx("text-primary-600")
                ]))
            ]), w([
                _d(n)
            ]))
        ]));
    }, UW = F3(function(n, r, t) {
        var e = r.b ? A2(Fu, n.lv, r) : w([
            n.mA(OW)
        ]);
        return A2(zx, w([
            Gx("cart-item-card__member-section")
        ]), $(A2(Fu, RW, e), t));
    }), KW = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("cart-item-card__price-row")
        ]), w([
            A2(PE, w([
                nF
            ]), w([
                _d(n)
            ])),
            A2(PE, w([
                VG,
                Hx(w([
                    Gx("text-primary-600")
                ]))
            ]), w([
                _d($(OK(r), A2(xc, "", t)))
            ]))
        ]));
    }), WW = function(n) {
        return n.mA(NW) + " " + n.mA(TW);
    }, XW = F3(function(n, r, t) {
        var e = kW(r) > 0 ? w([
            A3(KW, WW(n), kW(r), Ot)
        ]) : g, u = A3(KW, n.mA(MW), aW(r), t);
        return A3(UW, n, BR(r), A2(Qt, u, e));
    }), YW = F3(function(n, r, t) {
        var e = r.kU;
        return A2(zx, w([
            Oq(w([
                v("cart-item-card", !0),
                v("cart-item-card--compact", e),
                v("dropdown", !0),
                v("dropdown--open", n.ie)
            ]))
        ]), t);
    }), JW = function(n) {
        return A2(zx, w([
            Gx("cart-item-card__menu"),
            A2(lF, "role", "menu")
        ]), w([
            A2(sF, w([
                Rj("button"),
                Gx("cart-item-card__menu-item"),
                A2(lF, "role", "menuitem"),
                qE(n.uV)
            ]), w([
                A2(PE, g, w([
                    _d(n.mA(PW))
                ]))
            ])),
            A2(sF, w([
                Rj("button"),
                Gx("cart-item-card__menu-item"),
                A2(lF, "role", "menuitem"),
                qE(n.uX)
            ]), w([
                A2(PE, g, w([
                    _d(n.mA(IW))
                ]))
            ]))
        ]));
    }, nX = function(n) {
        return A2(zx, w([
            Gx("cart-item-card__menu-anchor")
        ]), w([
            A2(sF, w([
                Rj("button"),
                Gx("cart-item-card__actions-button dropdown-toggle"),
                A2(lF, "aria-label", n.mA(ZW)),
                A2(lF, "aria-haspopup", "menu"),
                A2(lF, "aria-expanded", n.ie ? "true" : "false"),
                qE(n.u_)
            ]), w([
                A2(Tq, w([
                    Xj
                ]), 41)
            ])),
            n.ie ? JW(n) : _d("")
        ]));
    }, rX = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("cart-item-card__header")
        ]), w([
            A2(zx, w([
                Gx("cart-item-card__heading")
            ]), w([
                A2(f_, w([
                    qG,
                    Hx(w([
                        Gx("text-primary-600")
                    ]))
                ]), w([
                    _d(r)
                ])),
                function() {
                    if (t.$) return _d("");
                    var n = t.a;
                    return A2(PE, w([
                        nF
                    ]), w([
                        _d(n)
                    ]));
                }()
            ])),
            nX(n)
        ]));
    }), tX = F2(function(n, r) {
        return r.om(n);
    }), eX = F2(function(n, r) {
        return A2(Op, _p(n(sK)), L$(RA(r)));
    }), uX = F2(function(n, r) {
        return A2(xc, n.mA(HW), A2(Op, A2(tu, tX, n.mA), A2(bb, eX(n.mA), r)));
    }), aX = A2(zx, w([
        Gx("cart-item-card__divider")
    ]), g), iX = F4(function(n, r, t, e) {
        var u = function(n) {
            return n.l9;
        }(r), a = function(r) {
            return A2(zx, w([
                Gx("cart-item-card__member-block")
            ]), A2(Qt, RW(n.lv(r.sl)), A2(Qt, A3(KW, n.mA(MW), r.jd, e), u && r.je > 0 ? w([
                A3(KW, WW(n), r.je, Ot)
            ]) : g)));
        }, i = !u && kW(r) > 0 ? w([
            aX,
            A3(KW, WW(n), kW(r), Ot)
        ]) : g;
        return A2(zx, w([
            Gx("cart-item-card__member-section")
        ]), $(A2(BV, aX, A2(Fu, a, t)), i));
    }), cX = F2(function(n, r) {
        var t = A2(uX, n, MR(r)), e = A2(Op, eW(n.mA), jR(r));
        return A3(YW, n, {
            kU: !1
        }, w([
            A3(rX, n, uW(r), It(t)),
            function() {
                var t = function(n) {
                    return n.lt;
                }(r);
                return t.b ? A4(iX, n, r, t, e) : A3(XW, n, r, e);
            }()
        ]));
    }), oX = F2(function(n, r) {
        return A3(YW, n, {
            kU: !0
        }, w([
            A3(rX, n, uW(r), Ot),
            A3(UW, n, A2(xc, g, A2(Op, _K, GR(r))), w([
                A3(KW, n.mA(LW), qW(r), Ot)
            ]))
        ]));
    }), fX = F2(function(n, r) {
        return A2(1 === YK(r) ? oX : cX, n, r);
    }), sX = F2(function(n, r) {
        var t = A2(QW, n, r.fm), e = F2(function(e, u) {
            var a;
            return A2(fX, {
                ie: i(r.u3, It(e)),
                lv: t,
                uV: zW(e),
                uX: (a = e, {
                    $: 10,
                    a: a
                }),
                u_: SW(e),
                mA: n
            }, u);
        });
        return A2(zx, w([
            Gx("flex flex-col gap-3 mb-4 md:mb-0")
        ]), A2(ge, e, r.Z));
    }), lX = function(n) {
        return A2(zx, w([
            Gx("md:hidden mt-auto sticky bottom-0")
        ]), w([
            n
        ]));
    }, dX = F2(function(n, r) {
        var t = {
            kX: Ot,
            pF: nE(r.Z),
            pG: n(_R),
            pH: !1,
            k7: r.k7,
            rh: r.rh,
            sO: r.Z,
            uS: eK,
            uZ: uK,
            u0: aK,
            Go: r.Go,
            mA: n
        };
        return w([
            GW({
                Ba: A2(zx, w([
                    Gx("sidebar-wrap")
                ]), w([
                    BW(t)
                ])),
                CX: w([
                    A2(sX, n, r)
                ])
            }),
            lX(A2(zx, w([
                Gx("sidebar-wrap -mx-6 sm:-mx-8 sm:px-8")
            ]), w([
                BW(t)
            ])))
        ]);
    }), vX = function(n) {
        return A2(zx, w([
            Gx("checkout-container flex flex-col")
        ]), w([
            A2(zx, w([
                Gx("panel flex-1 flex flex-col")
            ]), n)
        ]));
    }, bX = {
        $: 3
    }, mX = {
        zM: function(n) {
            return n.o.zM;
        },
        m$: function(n) {
            return n.o.m$;
        },
        m2: function(n) {
            return n.o.m2;
        },
        ni: function(n) {
            return n.o.ni;
        },
        Ae: function(n) {
            return n.o.Ae;
        },
        Aw: function(n) {
            return n.o.Aw;
        },
        AI: function(n) {
            return n.o.AI;
        },
        AJ: function(n) {
            return n.o.AJ;
        },
        AN: function(n) {
            return n.o.AN;
        },
        qK: function(n) {
            return n.o.qK;
        },
        hP: function(n) {
            return n.o.hP;
        },
        dB: function(n) {
            return n.o.dB;
        },
        C4: function(n) {
            return n.o.C4;
        },
        C7: function(n) {
            return n.o.C7;
        },
        Db: function(n) {
            return n.o.Db;
        },
        ad: function(n) {
            return n.o.ad;
        },
        iQ: function(n) {
            return n.o.iQ;
        },
        wo: function(n) {
            return n.o.wo;
        },
        EW: function(n) {
            return n.o.EW;
        },
        E4: function(n) {
            return n.o.E4;
        },
        yW: function(n) {
            return n.o.yW;
        },
        ze: function(n) {
            return n.o.ze;
        },
        GO: function(n) {
            return n.o.GO;
        }
    }, pX = F2(function(n, r) {
        return {
            fm: A2(xc, g, HR(r)),
            yg: n(mX.yW),
            mA: n,
            gg: r.gg
        };
    }), $X = function(n) {
        return !n.d9.$;
    }, gX = F2(function(n, r) {
        return n(dU(r) ? mX.AJ : mX.AI);
    }), hX = function(n) {
        return n.sI && n.fX.Eg;
    }, yX = function(n) {
        return function(n) {
            return n.Eg;
        }(n.b0);
    }, wX = cr("strong"), xX = F2(function(n, r) {
        return A2(wX, a_(n), A2(Fu, c_(Cu), r));
    }), _X = F2(function(n, r) {
        return $(A3(IK, !1, !0, A2(xc, r.mz, r.jd)), A2(eW, n, r.vM));
    }), CX = {
        $: 4
    }, AX = cr("fieldset"), kX = function(n) {
        return 2 === n.$ ? {
            $: 6,
            a: Le(n.a)
        } : n;
    }, EX = {
        hm: Ot,
        iS: Ot,
        y4: Ot
    }, qX = function(n) {
        return {
            $: 3,
            a: n
        };
    }, FX = F2(function(n, r) {
        return function(n) {
            var r = n.hm;
            if (r.$) {
                var t = v(n.y4, n.iS);
                return t.a.$ || t.b.$ ? g : w([
                    qX((0, t.b.a)(t.a.a))
                ]);
            }
            return w([
                qX(r.a)
            ]);
        }(A3(de, F2(function(n, r) {
            switch(n.$){
                case 2:
                    return m(r, {
                        y4: It(n.a)
                    });
                case 3:
                    return m(r, {
                        hm: It(n.a)
                    });
                case 6:
                    return m(r, {
                        iS: It(n.a)
                    });
                default:
                    return r;
            }
        }), r, n));
    }), jX = function(n) {
        switch(n.$){
            case 2:
                return w([
                    oz(n.a)
                ]);
            case 0:
                return w([
                    vF(n.a)
                ]);
            case 1:
                return w([
                    SH(n.a)
                ]);
            case 3:
                return w([
                    uI(n.a)
                ]);
            case 4:
            case 7:
            case 6:
            case 5:
            default:
                return g;
            case 8:
                return w([
                    A2(lF, "data-test", n.a)
                ]);
        }
    }, DX = function(n) {
        switch(n.$){
            case 2:
            case 1:
            case 6:
            default:
                return g;
            case 0:
                return w([
                    Oq(w([
                        v("radio--disabled", n.a)
                    ]))
                ]);
            case 3:
                return w([
                    Oq(w([
                        v("radio--checked", n.a)
                    ]))
                ]);
            case 7:
                var r = n.a;
                return A2(Fu, Px(Cu), r);
            case 4:
                return w([
                    Gx("radio--card")
                ]);
            case 5:
                return w([
                    Gx("radio--icon-hidden")
                ]);
            case 8:
                return w([
                    A2(lF, "data-test", n.a)
                ]);
        }
    }, VX = F2(function(n, r) {
        var t = A2(FX, n, EX);
        return A2(cz, A2(Qt, Gx("flex items-center radio"), A2(bc, DX, $(t, n))), w([
            A2(sz, A2(Qt, Rj("radio"), A2(Qt, Gx("radio__input"), A2(bc, jX, $(n, t)))), g),
            A2(Mx, w([
                Gx("radio__icon flex-none")
            ]), g),
            A2(zx, w([
                Gx("radio__text flex-auto")
            ]), A2(Fu, c_(Cu), r))
        ]));
    }), BX = F2(function(n, r) {
        var t = A2(Fu, kX, A2(no, function(n) {
            return 9 !== n.$;
        }, n)), e = A2(Wk, function(n) {
            return 9 === n.$;
        }, n);
        return A2(AX, w([
            Oq(w([
                v("radio-group", !0),
                v("radio-group--spaced", e),
                v("radio-group--cards-" + oe(ve(r)), e)
            ]))
        ]), A2(Fu, function(n) {
            var r = n.b;
            return A2(VX, $(n.a, t), r);
        }, r));
    }), GX = F2(function(n, r) {
        return v(n, r);
    }), zX = fE(1), SX = function(n) {
        return {
            $: 1,
            a: n
        };
    }, TX = function(n) {
        return {
            $: 3,
            a: n
        };
    }, PX = {
        $: 5
    }, ZX = function(n) {
        return A2(xc, PX, A2(Op, TX, dQ(n)));
    }, MX = {
        $: 9
    }, LX = function(n) {
        return n.Ag.kK;
    }, NX = function(n) {
        return n.Ag.lC;
    }, HX = function(n) {
        return n.Ag.l6;
    }, IX = function(n) {
        return n.Ag.mk;
    }, OX = F2(function(n, r) {
        return n(function() {
            switch(r){
                case 0:
                    return NX;
                case 1:
                    return HX;
                case 2:
                    return IX;
                default:
                    return LX;
            }
        }());
    }), QX = function(n) {
        return {
            $: 2,
            a: n
        };
    }, RX = F2(function(n, r) {
        return A2(PE, w([
            VG,
            zX,
            Hx(w([
                Gx("block mb-2 text-text-secondary")
            ]))
        ]), w([
            _d(n(r))
        ]));
    }), UX = F2(function(n, r) {
        var t = DR(r.ao);
        if (t.b) {
            var e = t;
            return A2(zx, g, w([
                A2(RX, n, mX.Ae),
                A2(BX, w([
                    QX(A2(xc, "", A2(Op, fW, r.cn))),
                    SX(ZX),
                    MX
                ]), A2(Fu, function(r) {
                    return A2(GX, w([
                        CX,
                        QX(fW(r.vM))
                    ]), w([
                        A2(PE, w([
                            zX,
                            Hx(w([
                                Gx("block text-current text-base")
                            ]))
                        ]), w([
                            _d(A2(OX, n, r.vM))
                        ])),
                        A2(PE, w([
                            VG,
                            zX,
                            Hx(w([
                                Gx("block text-text-secondary")
                            ]))
                        ]), w([
                            _d(A2(_X, n, r))
                        ]))
                    ]));
                }, e))
            ]));
        }
        return vE;
    }), KX = {
        $: 1
    }, WX = oF(5), XX = function(n) {
        return s(ve(n.jo), ve(n.fm)) > -1 ? _d("") : A2(zx, w([
            Gx("flex")
        ]), w([
            A2(yF, w([
                WX,
                cF(KX)
            ]), w([
                _d(n.mA(mX.zM))
            ]))
        ]));
    }, YX = F2(function(n, r) {
        var t;
        return A2(yF, w([
            WX,
            cF((t = r, {
                $: 2,
                a: t
            }))
        ]), w([
            A2(c_, Cu, A2(Tq, w([
                zE
            ]), 2)),
            _d(n.mA(mX.E4))
        ]));
    }), JX = function(n) {
        return n.a.sL;
    }, nY = F2(function(n, r) {
        if (n.$) return JX(r);
        var t = n.a;
        return i(eQ(r), t);
    }), rY = function(n) {
        return n.tC;
    }, tY = wE(5), eY = F2(function(n, r) {
        var t = A2(nY, n.gg, r) ? mX.C7 : rY;
        return A2(PE, w([
            oK,
            tY,
            zX,
            Hx(w([
                Gx("block")
            ]))
        ]), w([
            _d(n.mA(t))
        ]));
    }), uY = F3(function(n, r, t) {
        var e, u = r > 0, a = ve(n.fm) > 1;
        return A2(zx, w([
            Gx("flex items-center justify-between gap-2")
        ]), w([
            A2(zx, w([
                Gx("flex items-center gap-2 min-w-0")
            ]), w([
                A2(c_, Cu, A2(Tq, w([
                    zE,
                    Wj("flex-shrink-0 text-text-secondary")
                ]), 39)),
                A2(zx, w([
                    Gx("min-w-0")
                ]), w([
                    A2(PE, w([
                        VG,
                        zX,
                        Hx(w([
                            Gx("block text-current truncate")
                        ]))
                    ]), w([
                        ZV(aQ(t))
                    ])),
                    A2(eY, n, t)
                ]))
            ])),
            A2(zx, w([
                Gx("flex items-center gap-3")
            ]), w([
                a ? A2(yF, w([
                    Kj(w([
                        Gx("button--secondary-solid")
                    ])),
                    cF((e = r, {
                        $: 0,
                        a: e
                    }))
                ]), w([
                    _d(n.mA(mX.Aw))
                ])) : _d(""),
                u ? A2(YX, n, r) : _d("")
            ]))
        ]));
    }), aY = F2(function(n, r) {
        var t = A2(n$, cu, A2(ge, F2(function(r, t) {
            return i(r, n) ? Ot : It(t);
        }), r.jo)), e = A2(NR, n, r.jo);
        return A2(no, function(n) {
            var r = A2(Wk, function(r) {
                return i(eQ(r), eQ(n));
            }, t);
            return function() {
                if (e.$) return !1;
                var r = e.a;
                return i(eQ(n), eQ(r));
            }() || !r;
        }, r.fm);
    }), iY = function(n) {
        return {
            $: 5,
            a: n
        };
    }, cY = F3(function(n, r, t) {
        var e = A2(NR, r, n.jo), u = A2(aY, r, n);
        return A2(zx, g, w([
            A2(zx, w([
                Gx("flex items-center justify-between mb-2")
            ]), w([
                A2(PE, w([
                    VG,
                    tY,
                    zX
                ]), w([
                    _d(n.mA(mX.C4))
                ])),
                r > 0 ? A2(YX, n, r) : _d("")
            ])),
            A2(c_, LU(r), A4(qz, n.mA, w([
                XG(e),
                SG,
                iY(!0)
            ]), A2(Fu, MG(g), u), t))
        ]));
    }), oY = F3(function(n, r, t) {
        var e = A2(bb, function(r) {
            return A2(SS, function(n) {
                return i(rQ(n), r);
            }, n.bK);
        }, A2(bb, cu, A2(NR, r, n.Ft))), u = A2(PE, w([
            VG,
            tY,
            zX,
            Hx(w([
                Gx("block mb-2")
            ]))
        ]), w([
            _d(n.mA(mX.wo))
        ])), a = n.bK;
        if (a.b) {
            if (a.b.b) {
                var c = a;
                return A2(zx, w([
                    Gx("mt-4")
                ]), w([
                    u,
                    A2(c_, MU(r), A4(qz, n.mA, w([
                        XG(e),
                        SG
                    ]), A2(Fu, MG(g), c), t))
                ]));
            }
            var o = a.a;
            return A2(zx, w([
                Gx("mt-4")
            ]), w([
                u,
                A2(PE, w([
                    VG,
                    zX,
                    Hx(w([
                        Gx("block text-current")
                    ]))
                ]), w([
                    _d(QS(o))
                ]))
            ]));
        }
        return vE;
    }), fY = F5(function(n, r, t, e, u) {
        var a = A2(NR, r, n.jo), c = !r, o = i(u, It(r)) || !c;
        return A2(zx, w([
            Gx("rounded border border-divider p-4")
        ]), w([
            o || a.$ ? A3(cY, n, r, t) : A3(uY, n, r, a.a),
            A3(oY, n, r, e)
        ]));
    }), sY = F2(function(n, r) {
        var t = r;
        return A2(zx, w([
            Gx("flex flex-col gap-3")
        ]), $(A2(ge, F2(function(r, e) {
            return A5(fY, n, r, e.a, e.b, t.cS);
        }), A3(be, RC, t.bh, t.be)), w([
            XX(n)
        ])));
    }), lY = {
        $: 0
    }, dY = F2(function(n, r) {
        if (n.$) return JX(r);
        var t = n.a;
        return i(eQ(r), t);
    }), vY = F3(function(n, r, t) {
        var e = A2(dY, r, t) ? mX.C7 : rY;
        return A2(PE, w([
            oK,
            tY,
            zX,
            Hx(w([
                Gx("block")
            ]))
        ]), w([
            _d(n(e))
        ]));
    }), bY = F2(function(n, r) {
        return A2(zx, g, w([
            A2(PE, w([
                VG,
                tY,
                zX,
                Hx(w([
                    Gx("block mb-2")
                ]))
            ]), w([
                _d(n.mA(mX.C4))
            ])),
            A2(c_, IU, A4(qz, n.mA, w([
                XG(n.jo),
                SG,
                iY(!0)
            ]), A2(Fu, MG(g), n.fm), r))
        ]));
    }), mY = F2(function(n, r) {
        return r.sI ? A2(bY, n, r.fX) : function(n) {
            var r = ve(n.fm) > 1, t = n.jo;
            if (1 === t.$) return _d("");
            var e = t.a;
            return A2(zx, w([
                Gx("flex items-center justify-between gap-2")
            ]), w([
                A2(zx, w([
                    Gx("flex items-center gap-2 min-w-0")
                ]), w([
                    A2(c_, Cu, A2(Tq, w([
                        zE,
                        Wj("flex-shrink-0 text-text-secondary")
                    ]), 39)),
                    A2(zx, w([
                        Gx("min-w-0")
                    ]), w([
                        A2(PE, w([
                            VG,
                            zX,
                            Hx(w([
                                Gx("block text-current truncate")
                            ]))
                        ]), w([
                            ZV(aQ(e))
                        ])),
                        A3(vY, n.mA, n.gg, e)
                    ]))
                ])),
                r ? A2(yF, w([
                    Kj(w([
                        Gx("button--secondary-solid")
                    ])),
                    cF(lY)
                ]), w([
                    _d(n.mA(mX.Aw))
                ])) : _d("")
            ]));
        }(n);
    }), pY = F3(function(n, r, t) {
        return dU(r.ao) ? A2(c_, iU, A2(mY, {
            fm: n.fm,
            jo: A2(Op, function(n) {
                return n.vn;
            }, mb(r.s)),
            mA: n.mA,
            gg: n.gg
        }, t.cZ)) : A2(c_, aU, A2(sY, {
            fm: A2(no, mU, n.fm),
            bK: r.bK,
            jo: A2(Fu, function(n) {
                return n.vn;
            }, r.s),
            Ft: A2(Fu, function(n) {
                return n.fK;
            }, r.s),
            mA: n.mA,
            gg: n.gg
        }, t.dN));
    }), $Y = {
        $: 3
    }, gY = {
        $: 2
    }, hY = {
        Bb: !1
    }, yY = F2(function(n, r) {
        return m(r, {
            Bb: n
        });
    }), wY = {
        $: 6
    }, xY = {
        $: 5
    }, _Y = function(n) {
        return {
            $: 11,
            a: n
        };
    }, CY = {
        $: 4
    }, AY = function(n) {
        return {
            $: 3,
            a: n
        };
    }, kY = function(n) {
        return {
            $: 1,
            a: n
        };
    }, EY = function(n) {
        return {
            $: 9,
            a: n
        };
    }, qY = {
        $: 7
    }, FY = {
        $: 8
    }, jY = F2(function(n, r) {
        var t = $u(r);
        return t.$ ? n : A3(kp, t.a, Yb(n), Xb(n));
    }), DY = F2(function(n, r) {
        return r.$ ? n : r;
    }), VY = F2(function(n, r) {
        return Gx($(n.eM, r));
    }), BY = F2(function(n, r) {
        var t = A2(kP, n, r);
        return t.b ? A2(Qt, t, A2(BY, n, A2(Yp, n, r))) : g;
    }), GY = cr("tr"), zY = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), SY = F2(function(n, r) {
        var t = n.eM;
        return Oq(A2(Fu, function(n) {
            var r = n.b;
            return v($(t, n.a), r);
        }, r));
    }), TY = cr("td"), PY = F3(function(n, r, t) {
        var e = Qb(n), u = Xb(n);
        return A2(TY, w([
            A2(SY, r, w([
                v("day", !0)
            ])),
            qE(A2(zY, A3(kp, e, t, u), 0))
        ]), w([
            r.kQ(r.lB(t))
        ]));
    }), ZY = F2(function(n, r) {
        var t = w([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ]);
        return A2(Fu, function(t) {
            return A2(GY, g, A2(Fu, A2(PY, n, r), t));
        }, A2(BY, 3, t));
    }), MY = cr("option"), LY = F2(function(n, r) {
        var t = function(n) {
            switch(n){
                case 0:
                    return 4;
                case 1:
                    return 5;
                case 2:
                    return 6;
                case 3:
                    return 7;
                case 4:
                    return 8;
                case 5:
                    return 9;
                default:
                    return 10;
            }
        }(r), e = A2(mP, t, A3(kp, Qb(n), Yb(n), 1)), u = A3(kp, Qb(n), Yb(n), 1);
        return {
            pJ: A4(hP, 11, 1, e, A2($P, t, A3(q_, 1, 1, u))),
            pL: n
        };
    }), NY = dF("selected"), HY = cr("table"), IY = cr("tbody"), OY = cr("thead"), QY = F5(function(n, r, t, e, u) {
        var a, i = n.Cw(u), c = i ? g : w([
            qE((a = u, {
                $: 2,
                a: a
            }))
        ]), o = SY(n);
        return A2(TY, A2(Qt, o(w([
            v("day", !0),
            v("disabled", i),
            v("picked", r(u)),
            v("today", e(u)),
            v("other-month", t(u))
        ])), c), w([
            n.kQ(oe(Xb(u)))
        ]));
    }), RY = F3(function(n, r, t) {
        var e = Yb(n), u = Xb(n);
        return A2(TY, w([
            A2(SY, r, w([
                v("day", !0)
            ])),
            qE(A2(zY, A3(kp, t, e, u), 1))
        ]), w([
            r.kQ(r.zr(t))
        ]));
    }), UY = F2(function(n, r) {
        var t = Qb(n);
        return A2(Fu, function(t) {
            return A2(GY, g, A2(Fu, A2(RY, n, r), t));
        }, A2(BY, 3, A2($e, t - 1, t + 10)));
    }), KY = F2(function(n, r) {
        var t = n.pL, e = n.yG;
        switch(r.$){
            case 1:
                var u = r.a;
                return A2($e, Qb(t) - u, Qb(t) + u);
            case 2:
                return A2($e, r.a, r.b);
            case 3:
                return A2($e, a = r.a, Qb(e));
            case 4:
                var a = r.a;
                return A2($e, Qb(e), a);
            default:
                return g;
        }
    }), WY = function(n) {
        return !i(n, _U);
    }, XY = F3(function(n, r, t) {
        var e, u, a, c = t.b5, o = t.yG, f = t.fD, s = function(r) {
            return A2(xc, !1, A2(Op, function(n) {
                return i(n, r);
            }, n));
        }, l = function(n) {
            return i(n, o);
        }, d = dP(r.hZ) - 1, b = VY(r), m = A2(xc, o, A2(DY, n, c)), p = function(n) {
            return !i(Yb(m), Yb(n));
        }, $ = F2(function(n, r) {
            return A2(sF, w([
                b(n),
                qE(r),
                CV(-1),
                Rj("button")
            ]), g);
        }), h = A2(LY, m, r.hZ), y = h.pL, x = A2(Fu, function(n) {
            return A2(GY, w([
                b("row")
            ]), A2(Fu, A4(QY, r, s, p, l), n));
        }, (e = h.pJ, u = F4(function(n, r, t, e) {
            for(;;){
                if (!r.b) return Ae(e);
                var u = r.a, a = r.b;
                if (6 !== n) n = i = n + 1, r = c = a, t = o = A2(Qt, u, t), e = f = e;
                else {
                    var i = 0, c = a, o = g, f = A2(Qt, Ae(A2(Qt, u, t)), e);
                    n = i, r = c, t = o, e = f;
                }
            }
        }), A4(u, 0, e, g, g))), _ = function(n) {
            return i(Qb(y), n);
        }, C = F2(function(n, r) {
            return v(oe(n), A2(MY, w([
                oz(oe(r)),
                NY(_(r))
            ]), w([
                _d(oe(r))
            ])));
        }), A = function() {
            var n = function(n) {
                return A2($e, Qb(y), n);
            }, t = function(n) {
                return A2($e, n, Qb(y));
            }, e = r.on;
            switch(e.$){
                case 3:
                    return v(n(e.a - 1), t(Qb(o) + 1));
                case 4:
                    var u = e.a;
                    return v(n(Qb(o) - 1), t(u + 1));
                case 2:
                    return u = e.b, v(n(e.a - 1), t(u + 1));
                default:
                    return v(g, g);
            }
        }(), k = A.a, E = A.b, q = A3(gz, "select", w([
            (a = A2(tu, jY(m), kY), A2(EE, "change", A2(eu, a, zH))),
            b("year-menu")
        ]), A2(ge, C, vc(w([
            k,
            A2(KY, {
                pL: y,
                yG: o
            }, r.on),
            E
        ]))));
        return A2(zx, w([
            b("picker"),
            A2(GH, "mousedown", au(v(qY, !0))),
            A2(GH, "mouseup", au(v(FY, !0)))
        ]), function() {
            switch(f){
                case 0:
                    return w([
                        A2(zx, w([
                            b("picker-header")
                        ]), w([
                            A2(zx, w([
                                b("prev-container")
                            ]), w([
                                A2($, "prev", kY(A3(q_, 1, -1, m)))
                            ])),
                            A2(zx, w([
                                b("month-container")
                            ]), w([
                                A2(sF, w([
                                    b("month"),
                                    Rj("button"),
                                    qE(EY(1))
                                ]), w([
                                    _d(r.lB(Yb(y)))
                                ])),
                                A2(sF, w([
                                    b("year"),
                                    Rj("button"),
                                    qE(EY(2))
                                ]), w([
                                    WY(r.on) ? A3(gz, "span", g, w([
                                        v(oe(Qb(y)), q)
                                    ])) : _d(r.zr(Qb(y)))
                                ]))
                            ])),
                            A2(zx, w([
                                b("next-container")
                            ]), w([
                                A2($, "next", kY(A3(q_, 1, 1, m)))
                            ]))
                        ])),
                        A2(HY, w([
                            b("table")
                        ]), w([
                            A2(OY, w([
                                b("weekdays")
                            ]), w([
                                A2(GY, g, A2(Fu, function(n) {
                                    return A2(TY, w([
                                        b("dow")
                                    ]), w([
                                        _d(r.A4(n))
                                    ]));
                                }, A2(kP, 7, A2(Yp, d, vc(A2(xP, 2, w([
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6
                                ])))))))
                            ])),
                            A2(IY, w([
                                b("days")
                            ]), x)
                        ]))
                    ]);
                case 1:
                    return w([
                        A2(zx, w([
                            b("picker-header")
                        ]), w([
                            A2(zx, w([
                                b("prev-container")
                            ]), w([
                                A2($, "prev", kY(A3(q_, 0, -1, m)))
                            ])),
                            A2(zx, w([
                                b("month-container")
                            ]), w([
                                A2(sF, w([
                                    b("year"),
                                    Rj("button"),
                                    qE(EY(2))
                                ]), w([
                                    WY(r.on) ? A3(gz, "span", g, w([
                                        v(oe(Qb(y)), q)
                                    ])) : _d(r.zr(Qb(y)))
                                ]))
                            ])),
                            A2(zx, w([
                                b("next-container")
                            ]), w([
                                A2($, "next", kY(A3(q_, 0, 1, m)))
                            ]))
                        ])),
                        A2(HY, w([
                            b("table")
                        ]), w([
                            A2(IY, w([
                                b("months")
                            ]), A2(ZY, m, r))
                        ]))
                    ]);
                default:
                    return w([
                        A2(zx, w([
                            b("picker-header")
                        ]), w([
                            A2(zx, w([
                                b("prev-container")
                            ]), w([
                                A2($, "prev", kY(A3(q_, 0, -12, m)))
                            ])),
                            A2(zx, w([
                                b("month-container")
                            ]), w([
                                A2(Mx, w([
                                    b("year")
                                ]), w([
                                    WY(r.on) ? A3(gz, "span", g, w([
                                        v(oe(Qb(y)), q)
                                    ])) : _d(r.zr(Qb(y)))
                                ]))
                            ])),
                            A2(zx, w([
                                b("next-container")
                            ]), w([
                                A2($, "next", kY(A3(q_, 0, 12, m)))
                            ]))
                        ])),
                        A2(HY, w([
                            b("table")
                        ]), w([
                            A2(IY, w([
                                b("years")
                            ]), A2(UY, m, r))
                        ]))
                    ]);
            }
        }());
    }), YY = F3(function(n, r, t) {
        var e, u = t, a = A3(tu, _K, n$(cu), A2(Op, DF, r.li)), i = A2(Qt, v(r.eM + "input", !0), r.Co), c = (e = w([
            TH(r.EC),
            oz(A2(xc, A2(xc, "", A2(Op, r.A1, n)), u.aU))
        ]), A2(sz, $(w([
            Oq(i),
            dz(A2(xc, "", r.lj)),
            Rj("text"),
            A2(EE, "change", au(CY)),
            SH(AY),
            DH(wY),
            qE(xY),
            VH(xY),
            A2(EE, "keydown", A2(eu, _Y, bF))
        ]), $(r.Cn, $(a, e))), g)), o = A2(Qt, v(r.eM + "container", !0), r.kV);
        return A2(zx, w([
            Oq(o)
        ]), w([
            c,
            u.Eg ? A3(XY, n, r, u) : _d("")
        ]));
    }), JY = F2(function(n, r) {
        return A3(de, yY, hY, n).Bb ? function(n) {
            var r = FU(n.Cw), t = function() {
                var r = n.pS;
                if (r.$) return "";
                var t = r.a;
                return A2(SM, sZ("/"), t);
            }();
            return A2(zx, g, w([
                PI(w([
                    OI(t),
                    pI(!0),
                    jI(r.EC)
                ]))
            ]));
        }(r) : A2(zx, w([
            qE(gY),
            DF(r.sl),
            CV(0),
            A2(gF, $Y, r.sl)
        ]), w([
            A2(c_, RO, A3(YY, r.pS, FU(r.Cw), r.b0))
        ]));
    }), nJ = F2(function(n, r) {
        return A2(zx, g, w([
            A2(RX, n, mX.Db),
            A2(zx, w([
                Gx("input-group")
            ]), w([
                A2(Mx, w([
                    Gx("input-addon"),
                    A2(VF, "border-right-width", "1px")
                ]), w([
                    A2(c_, Cu, A2(Tq, w([
                        zE,
                        Wj("text-text-secondary")
                    ]), 29))
                ])),
                A2(zx, w([
                    Gx("flex-1")
                ]), w([
                    A2(c_, QO, A2(JY, g, r))
                ]))
            ]))
        ]));
    }), rJ = F2(function(n, r) {
        var t = r.d9;
        if (t.$) return g;
        var e = t.a;
        return w([
            A2(xX, w([
                Hx(w([
                    Gx("block text-current")
                ]))
            ]), w([
                _d(A2(gX, n.mA, e.ao))
            ])),
            A2(zx, w([
                Gx("mt-6"),
                Oq(w([
                    v("pb-80", yX(r.b0) || hX(r.cZ))
                ]))
            ]), w([
                A2(zx, w([
                    Gx("mb-6")
                ]), w([
                    A3(pY, n, e, r)
                ])),
                dU(e.ao) ? vE : A2(nJ, n.mA, r.b0),
                A2(zx, w([
                    Gx("mt-6")
                ]), w([
                    A2(UX, n.mA, e)
                ]))
            ]))
        ]);
    }), tJ = Bx("alt"), eJ = function(n) {
        return n.p8;
    }, uJ = cr("img"), aJ = function(n) {
        return n.l1;
    }, iJ = function(n) {
        return A2(Bx, "src", hr(n));
    }, cJ = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), oJ = function(n) {
        return A2(Cm, Mm(n), Im(n));
    }, fJ = function(n) {
        return " " === n || "\t" === n || "\n" === n || "\r" === n || "\f" === n || "\xa0" === n;
    }, sJ = function(n) {
        return n.toLowerCase();
    }, lJ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, dJ = ht, vJ = F4(function(n, r, t, e) {
        return A2(qm, jm, A4(Fm, n, r, t, e));
    }), bJ = function(n) {
        return function(n) {
            var r = n.a, t = n.b;
            return function(n) {
                var e = A5(dJ, r, n.iH, n.xd, n.oL, n.d), u = e.a, a = e.b, c = e.c;
                return i(u, -1) ? A2($m, !1, A4(vJ, a, c, t, n.f)) : A3(gm, 0 > s(n.iH, u), 0, {
                    oL: c,
                    f: n.f,
                    n: n.n,
                    iH: u,
                    xd: a,
                    d: n.d
                });
            };
        }(Em(n));
    }, mJ = A2(Rm, A2(Cm, A2(Cm, Am(cu), zm("<!")), zm("--")), A2(Cm, Jm(bJ("--\x3e")), zm("--\x3e"))), pJ = A2(up, lJ, mJ), $J = w([
        "area",
        "base",
        "br",
        "col",
        "embed",
        "hr",
        "img",
        "input",
        "link",
        "meta",
        "param",
        "source",
        "track",
        "wbr"
    ]), gJ = function(n) {
        return A2(MZ, g, function(r) {
            return op(w([
                A2(up, function(n) {
                    return SZ(A2(Qt, n, r));
                }, n),
                Am(zZ(Ae(r)))
            ]));
        });
    }, hJ = A2(up, sJ, Jm(oJ(function(n) {
        return !fJ(n) && '"' !== n && "'" !== n && ">" !== n && "/" !== n && "=" !== n;
    }))), yJ = Mm(Le(";")), wJ = ed(w([
        v("Aacute", "\xc1"),
        v("aacute", "\xe1"),
        v("Abreve", "\u0102"),
        v("abreve", "\u0103"),
        v("ac", "\u223E"),
        v("acd", "\u223F"),
        v("acE", "\u223E\u0333"),
        v("Acirc", "\xc2"),
        v("acirc", "\xe2"),
        v("acute", "\xb4"),
        v("Acy", "\u0410"),
        v("acy", "\u0430"),
        v("AElig", "\xc6"),
        v("aelig", "\xe6"),
        v("af", "\u2061"),
        v("Afr", "\uD835\uDD04"),
        v("afr", "\uD835\uDD1E"),
        v("Agrave", "\xc0"),
        v("agrave", "\xe0"),
        v("alefsym", "\u2135"),
        v("aleph", "\u2135"),
        v("Alpha", "\u0391"),
        v("alpha", "\u03B1"),
        v("Amacr", "\u0100"),
        v("amacr", "\u0101"),
        v("amalg", "\u2A3F"),
        v("amp", "&"),
        v("AMP", "&"),
        v("andand", "\u2A55"),
        v("And", "\u2A53"),
        v("and", "\u2227"),
        v("andd", "\u2A5C"),
        v("andslope", "\u2A58"),
        v("andv", "\u2A5A"),
        v("ang", "\u2220"),
        v("ange", "\u29A4"),
        v("angle", "\u2220"),
        v("angmsdaa", "\u29A8"),
        v("angmsdab", "\u29A9"),
        v("angmsdac", "\u29AA"),
        v("angmsdad", "\u29AB"),
        v("angmsdae", "\u29AC"),
        v("angmsdaf", "\u29AD"),
        v("angmsdag", "\u29AE"),
        v("angmsdah", "\u29AF"),
        v("angmsd", "\u2221"),
        v("angrt", "\u221F"),
        v("angrtvb", "\u22BE"),
        v("angrtvbd", "\u299D"),
        v("angsph", "\u2222"),
        v("angst", "\xc5"),
        v("angzarr", "\u237C"),
        v("Aogon", "\u0104"),
        v("aogon", "\u0105"),
        v("Aopf", "\uD835\uDD38"),
        v("aopf", "\uD835\uDD52"),
        v("apacir", "\u2A6F"),
        v("ap", "\u2248"),
        v("apE", "\u2A70"),
        v("ape", "\u224A"),
        v("apid", "\u224B"),
        v("apos", "'"),
        v("ApplyFunction", "\u2061"),
        v("approx", "\u2248"),
        v("approxeq", "\u224A"),
        v("Aring", "\xc5"),
        v("aring", "\xe5"),
        v("Ascr", "\uD835\uDC9C"),
        v("ascr", "\uD835\uDCB6"),
        v("Assign", "\u2254"),
        v("ast", "*"),
        v("asymp", "\u2248"),
        v("asympeq", "\u224D"),
        v("Atilde", "\xc3"),
        v("atilde", "\xe3"),
        v("Auml", "\xc4"),
        v("auml", "\xe4"),
        v("awconint", "\u2233"),
        v("awint", "\u2A11"),
        v("backcong", "\u224C"),
        v("backepsilon", "\u03F6"),
        v("backprime", "\u2035"),
        v("backsim", "\u223D"),
        v("backsimeq", "\u22CD"),
        v("Backslash", "\u2216"),
        v("Barv", "\u2AE7"),
        v("barvee", "\u22BD"),
        v("barwed", "\u2305"),
        v("Barwed", "\u2306"),
        v("barwedge", "\u2305"),
        v("bbrk", "\u23B5"),
        v("bbrktbrk", "\u23B6"),
        v("bcong", "\u224C"),
        v("Bcy", "\u0411"),
        v("bcy", "\u0431"),
        v("bdquo", "\u201E"),
        v("becaus", "\u2235"),
        v("because", "\u2235"),
        v("Because", "\u2235"),
        v("bemptyv", "\u29B0"),
        v("bepsi", "\u03F6"),
        v("bernou", "\u212C"),
        v("Bernoullis", "\u212C"),
        v("Beta", "\u0392"),
        v("beta", "\u03B2"),
        v("beth", "\u2136"),
        v("between", "\u226C"),
        v("Bfr", "\uD835\uDD05"),
        v("bfr", "\uD835\uDD1F"),
        v("bigcap", "\u22C2"),
        v("bigcirc", "\u25EF"),
        v("bigcup", "\u22C3"),
        v("bigodot", "\u2A00"),
        v("bigoplus", "\u2A01"),
        v("bigotimes", "\u2A02"),
        v("bigsqcup", "\u2A06"),
        v("bigstar", "\u2605"),
        v("bigtriangledown", "\u25BD"),
        v("bigtriangleup", "\u25B3"),
        v("biguplus", "\u2A04"),
        v("bigvee", "\u22C1"),
        v("bigwedge", "\u22C0"),
        v("bkarow", "\u290D"),
        v("blacklozenge", "\u29EB"),
        v("blacksquare", "\u25AA"),
        v("blacktriangle", "\u25B4"),
        v("blacktriangledown", "\u25BE"),
        v("blacktriangleleft", "\u25C2"),
        v("blacktriangleright", "\u25B8"),
        v("blank", "\u2423"),
        v("blk12", "\u2592"),
        v("blk14", "\u2591"),
        v("blk34", "\u2593"),
        v("block", "\u2588"),
        v("bne", "=\u20E5"),
        v("bnequiv", "\u2261\u20E5"),
        v("bNot", "\u2AED"),
        v("bnot", "\u2310"),
        v("Bopf", "\uD835\uDD39"),
        v("bopf", "\uD835\uDD53"),
        v("bot", "\u22A5"),
        v("bottom", "\u22A5"),
        v("bowtie", "\u22C8"),
        v("boxbox", "\u29C9"),
        v("boxdl", "\u2510"),
        v("boxdL", "\u2555"),
        v("boxDl", "\u2556"),
        v("boxDL", "\u2557"),
        v("boxdr", "\u250C"),
        v("boxdR", "\u2552"),
        v("boxDr", "\u2553"),
        v("boxDR", "\u2554"),
        v("boxh", "\u2500"),
        v("boxH", "\u2550"),
        v("boxhd", "\u252C"),
        v("boxHd", "\u2564"),
        v("boxhD", "\u2565"),
        v("boxHD", "\u2566"),
        v("boxhu", "\u2534"),
        v("boxHu", "\u2567"),
        v("boxhU", "\u2568"),
        v("boxHU", "\u2569"),
        v("boxminus", "\u229F"),
        v("boxplus", "\u229E"),
        v("boxtimes", "\u22A0"),
        v("boxul", "\u2518"),
        v("boxuL", "\u255B"),
        v("boxUl", "\u255C"),
        v("boxUL", "\u255D"),
        v("boxur", "\u2514"),
        v("boxuR", "\u2558"),
        v("boxUr", "\u2559"),
        v("boxUR", "\u255A"),
        v("boxv", "\u2502"),
        v("boxV", "\u2551"),
        v("boxvh", "\u253C"),
        v("boxvH", "\u256A"),
        v("boxVh", "\u256B"),
        v("boxVH", "\u256C"),
        v("boxvl", "\u2524"),
        v("boxvL", "\u2561"),
        v("boxVl", "\u2562"),
        v("boxVL", "\u2563"),
        v("boxvr", "\u251C"),
        v("boxvR", "\u255E"),
        v("boxVr", "\u255F"),
        v("boxVR", "\u2560"),
        v("bprime", "\u2035"),
        v("breve", "\u02D8"),
        v("Breve", "\u02D8"),
        v("brvbar", "\xa6"),
        v("bscr", "\uD835\uDCB7"),
        v("Bscr", "\u212C"),
        v("bsemi", "\u204F"),
        v("bsim", "\u223D"),
        v("bsime", "\u22CD"),
        v("bsolb", "\u29C5"),
        v("bsol", "\\"),
        v("bsolhsub", "\u27C8"),
        v("bull", "\u2022"),
        v("bullet", "\u2022"),
        v("bump", "\u224E"),
        v("bumpE", "\u2AAE"),
        v("bumpe", "\u224F"),
        v("Bumpeq", "\u224E"),
        v("bumpeq", "\u224F"),
        v("Cacute", "\u0106"),
        v("cacute", "\u0107"),
        v("capand", "\u2A44"),
        v("capbrcup", "\u2A49"),
        v("capcap", "\u2A4B"),
        v("cap", "\u2229"),
        v("Cap", "\u22D2"),
        v("capcup", "\u2A47"),
        v("capdot", "\u2A40"),
        v("CapitalDifferentialD", "\u2145"),
        v("caps", "\u2229\uFE00"),
        v("caret", "\u2041"),
        v("caron", "\u02C7"),
        v("Cayleys", "\u212D"),
        v("ccaps", "\u2A4D"),
        v("Ccaron", "\u010C"),
        v("ccaron", "\u010D"),
        v("Ccedil", "\xc7"),
        v("ccedil", "\xe7"),
        v("Ccirc", "\u0108"),
        v("ccirc", "\u0109"),
        v("Cconint", "\u2230"),
        v("ccups", "\u2A4C"),
        v("ccupssm", "\u2A50"),
        v("Cdot", "\u010A"),
        v("cdot", "\u010B"),
        v("cedil", "\xb8"),
        v("Cedilla", "\xb8"),
        v("cemptyv", "\u29B2"),
        v("cent", "\xa2"),
        v("centerdot", "\xb7"),
        v("CenterDot", "\xb7"),
        v("cfr", "\uD835\uDD20"),
        v("Cfr", "\u212D"),
        v("CHcy", "\u0427"),
        v("chcy", "\u0447"),
        v("check", "\u2713"),
        v("checkmark", "\u2713"),
        v("Chi", "\u03A7"),
        v("chi", "\u03C7"),
        v("circ", "\u02C6"),
        v("circeq", "\u2257"),
        v("circlearrowleft", "\u21BA"),
        v("circlearrowright", "\u21BB"),
        v("circledast", "\u229B"),
        v("circledcirc", "\u229A"),
        v("circleddash", "\u229D"),
        v("CircleDot", "\u2299"),
        v("circledR", "\xae"),
        v("circledS", "\u24C8"),
        v("CircleMinus", "\u2296"),
        v("CirclePlus", "\u2295"),
        v("CircleTimes", "\u2297"),
        v("cir", "\u25CB"),
        v("cirE", "\u29C3"),
        v("cire", "\u2257"),
        v("cirfnint", "\u2A10"),
        v("cirmid", "\u2AEF"),
        v("cirscir", "\u29C2"),
        v("ClockwiseContourIntegral", "\u2232"),
        v("CloseCurlyDoubleQuote", "\u201D"),
        v("CloseCurlyQuote", "\u2019"),
        v("clubs", "\u2663"),
        v("clubsuit", "\u2663"),
        v("colon", ":"),
        v("Colon", "\u2237"),
        v("Colone", "\u2A74"),
        v("colone", "\u2254"),
        v("coloneq", "\u2254"),
        v("comma", ","),
        v("commat", "@"),
        v("comp", "\u2201"),
        v("compfn", "\u2218"),
        v("complement", "\u2201"),
        v("complexes", "\u2102"),
        v("cong", "\u2245"),
        v("congdot", "\u2A6D"),
        v("Congruent", "\u2261"),
        v("conint", "\u222E"),
        v("Conint", "\u222F"),
        v("ContourIntegral", "\u222E"),
        v("copf", "\uD835\uDD54"),
        v("Copf", "\u2102"),
        v("coprod", "\u2210"),
        v("Coproduct", "\u2210"),
        v("copy", "\xa9"),
        v("COPY", "\xa9"),
        v("copysr", "\u2117"),
        v("CounterClockwiseContourIntegral", "\u2233"),
        v("crarr", "\u21B5"),
        v("cross", "\u2717"),
        v("Cross", "\u2A2F"),
        v("Cscr", "\uD835\uDC9E"),
        v("cscr", "\uD835\uDCB8"),
        v("csub", "\u2ACF"),
        v("csube", "\u2AD1"),
        v("csup", "\u2AD0"),
        v("csupe", "\u2AD2"),
        v("ctdot", "\u22EF"),
        v("cudarrl", "\u2938"),
        v("cudarrr", "\u2935"),
        v("cuepr", "\u22DE"),
        v("cuesc", "\u22DF"),
        v("cularr", "\u21B6"),
        v("cularrp", "\u293D"),
        v("cupbrcap", "\u2A48"),
        v("cupcap", "\u2A46"),
        v("CupCap", "\u224D"),
        v("cup", "\u222A"),
        v("Cup", "\u22D3"),
        v("cupcup", "\u2A4A"),
        v("cupdot", "\u228D"),
        v("cupor", "\u2A45"),
        v("cups", "\u222A\uFE00"),
        v("curarr", "\u21B7"),
        v("curarrm", "\u293C"),
        v("curlyeqprec", "\u22DE"),
        v("curlyeqsucc", "\u22DF"),
        v("curlyvee", "\u22CE"),
        v("curlywedge", "\u22CF"),
        v("curren", "\xa4"),
        v("curvearrowleft", "\u21B6"),
        v("curvearrowright", "\u21B7"),
        v("cuvee", "\u22CE"),
        v("cuwed", "\u22CF"),
        v("cwconint", "\u2232"),
        v("cwint", "\u2231"),
        v("cylcty", "\u232D"),
        v("dagger", "\u2020"),
        v("Dagger", "\u2021"),
        v("daleth", "\u2138"),
        v("darr", "\u2193"),
        v("Darr", "\u21A1"),
        v("dArr", "\u21D3"),
        v("dash", "\u2010"),
        v("Dashv", "\u2AE4"),
        v("dashv", "\u22A3"),
        v("dbkarow", "\u290F"),
        v("dblac", "\u02DD"),
        v("Dcaron", "\u010E"),
        v("dcaron", "\u010F"),
        v("Dcy", "\u0414"),
        v("dcy", "\u0434"),
        v("ddagger", "\u2021"),
        v("ddarr", "\u21CA"),
        v("DD", "\u2145"),
        v("dd", "\u2146"),
        v("DDotrahd", "\u2911"),
        v("ddotseq", "\u2A77"),
        v("deg", "\xb0"),
        v("Del", "\u2207"),
        v("Delta", "\u0394"),
        v("delta", "\u03B4"),
        v("demptyv", "\u29B1"),
        v("dfisht", "\u297F"),
        v("Dfr", "\uD835\uDD07"),
        v("dfr", "\uD835\uDD21"),
        v("dHar", "\u2965"),
        v("dharl", "\u21C3"),
        v("dharr", "\u21C2"),
        v("DiacriticalAcute", "\xb4"),
        v("DiacriticalDot", "\u02D9"),
        v("DiacriticalDoubleAcute", "\u02DD"),
        v("DiacriticalGrave", "`"),
        v("DiacriticalTilde", "\u02DC"),
        v("diam", "\u22C4"),
        v("diamond", "\u22C4"),
        v("Diamond", "\u22C4"),
        v("diamondsuit", "\u2666"),
        v("diams", "\u2666"),
        v("die", "\xa8"),
        v("DifferentialD", "\u2146"),
        v("digamma", "\u03DD"),
        v("disin", "\u22F2"),
        v("div", "\xf7"),
        v("divide", "\xf7"),
        v("divideontimes", "\u22C7"),
        v("divonx", "\u22C7"),
        v("DJcy", "\u0402"),
        v("djcy", "\u0452"),
        v("dlcorn", "\u231E"),
        v("dlcrop", "\u230D"),
        v("dollar", "$"),
        v("Dopf", "\uD835\uDD3B"),
        v("dopf", "\uD835\uDD55"),
        v("Dot", "\xa8"),
        v("dot", "\u02D9"),
        v("DotDot", "\u20DC"),
        v("doteq", "\u2250"),
        v("doteqdot", "\u2251"),
        v("DotEqual", "\u2250"),
        v("dotminus", "\u2238"),
        v("dotplus", "\u2214"),
        v("dotsquare", "\u22A1"),
        v("doublebarwedge", "\u2306"),
        v("DoubleContourIntegral", "\u222F"),
        v("DoubleDot", "\xa8"),
        v("DoubleDownArrow", "\u21D3"),
        v("DoubleLeftArrow", "\u21D0"),
        v("DoubleLeftRightArrow", "\u21D4"),
        v("DoubleLeftTee", "\u2AE4"),
        v("DoubleLongLeftArrow", "\u27F8"),
        v("DoubleLongLeftRightArrow", "\u27FA"),
        v("DoubleLongRightArrow", "\u27F9"),
        v("DoubleRightArrow", "\u21D2"),
        v("DoubleRightTee", "\u22A8"),
        v("DoubleUpArrow", "\u21D1"),
        v("DoubleUpDownArrow", "\u21D5"),
        v("DoubleVerticalBar", "\u2225"),
        v("DownArrowBar", "\u2913"),
        v("downarrow", "\u2193"),
        v("DownArrow", "\u2193"),
        v("Downarrow", "\u21D3"),
        v("DownArrowUpArrow", "\u21F5"),
        v("DownBreve", "\u0311"),
        v("downdownarrows", "\u21CA"),
        v("downharpoonleft", "\u21C3"),
        v("downharpoonright", "\u21C2"),
        v("DownLeftRightVector", "\u2950"),
        v("DownLeftTeeVector", "\u295E"),
        v("DownLeftVectorBar", "\u2956"),
        v("DownLeftVector", "\u21BD"),
        v("DownRightTeeVector", "\u295F"),
        v("DownRightVectorBar", "\u2957"),
        v("DownRightVector", "\u21C1"),
        v("DownTeeArrow", "\u21A7"),
        v("DownTee", "\u22A4"),
        v("drbkarow", "\u2910"),
        v("drcorn", "\u231F"),
        v("drcrop", "\u230C"),
        v("Dscr", "\uD835\uDC9F"),
        v("dscr", "\uD835\uDCB9"),
        v("DScy", "\u0405"),
        v("dscy", "\u0455"),
        v("dsol", "\u29F6"),
        v("Dstrok", "\u0110"),
        v("dstrok", "\u0111"),
        v("dtdot", "\u22F1"),
        v("dtri", "\u25BF"),
        v("dtrif", "\u25BE"),
        v("duarr", "\u21F5"),
        v("duhar", "\u296F"),
        v("dwangle", "\u29A6"),
        v("DZcy", "\u040F"),
        v("dzcy", "\u045F"),
        v("dzigrarr", "\u27FF"),
        v("Eacute", "\xc9"),
        v("eacute", "\xe9"),
        v("easter", "\u2A6E"),
        v("Ecaron", "\u011A"),
        v("ecaron", "\u011B"),
        v("Ecirc", "\xca"),
        v("ecirc", "\xea"),
        v("ecir", "\u2256"),
        v("ecolon", "\u2255"),
        v("Ecy", "\u042D"),
        v("ecy", "\u044D"),
        v("eDDot", "\u2A77"),
        v("Edot", "\u0116"),
        v("edot", "\u0117"),
        v("eDot", "\u2251"),
        v("ee", "\u2147"),
        v("efDot", "\u2252"),
        v("Efr", "\uD835\uDD08"),
        v("efr", "\uD835\uDD22"),
        v("eg", "\u2A9A"),
        v("Egrave", "\xc8"),
        v("egrave", "\xe8"),
        v("egs", "\u2A96"),
        v("egsdot", "\u2A98"),
        v("el", "\u2A99"),
        v("Element", "\u2208"),
        v("elinters", "\u23E7"),
        v("ell", "\u2113"),
        v("els", "\u2A95"),
        v("elsdot", "\u2A97"),
        v("Emacr", "\u0112"),
        v("emacr", "\u0113"),
        v("empty", "\u2205"),
        v("emptyset", "\u2205"),
        v("EmptySmallSquare", "\u25FB"),
        v("emptyv", "\u2205"),
        v("EmptyVerySmallSquare", "\u25AB"),
        v("emsp13", "\u2004"),
        v("emsp14", "\u2005"),
        v("emsp", "\u2003"),
        v("ENG", "\u014A"),
        v("eng", "\u014B"),
        v("ensp", "\u2002"),
        v("Eogon", "\u0118"),
        v("eogon", "\u0119"),
        v("Eopf", "\uD835\uDD3C"),
        v("eopf", "\uD835\uDD56"),
        v("epar", "\u22D5"),
        v("eparsl", "\u29E3"),
        v("eplus", "\u2A71"),
        v("epsi", "\u03B5"),
        v("Epsilon", "\u0395"),
        v("epsilon", "\u03B5"),
        v("epsiv", "\u03F5"),
        v("eqcirc", "\u2256"),
        v("eqcolon", "\u2255"),
        v("eqsim", "\u2242"),
        v("eqslantgtr", "\u2A96"),
        v("eqslantless", "\u2A95"),
        v("Equal", "\u2A75"),
        v("equals", "="),
        v("EqualTilde", "\u2242"),
        v("equest", "\u225F"),
        v("Equilibrium", "\u21CC"),
        v("equiv", "\u2261"),
        v("equivDD", "\u2A78"),
        v("eqvparsl", "\u29E5"),
        v("erarr", "\u2971"),
        v("erDot", "\u2253"),
        v("escr", "\u212F"),
        v("Escr", "\u2130"),
        v("esdot", "\u2250"),
        v("Esim", "\u2A73"),
        v("esim", "\u2242"),
        v("Eta", "\u0397"),
        v("eta", "\u03B7"),
        v("ETH", "\xd0"),
        v("eth", "\xf0"),
        v("Euml", "\xcb"),
        v("euml", "\xeb"),
        v("euro", "\u20AC"),
        v("excl", "!"),
        v("exist", "\u2203"),
        v("Exists", "\u2203"),
        v("expectation", "\u2130"),
        v("exponentiale", "\u2147"),
        v("ExponentialE", "\u2147"),
        v("fallingdotseq", "\u2252"),
        v("Fcy", "\u0424"),
        v("fcy", "\u0444"),
        v("female", "\u2640"),
        v("ffilig", "\uFB03"),
        v("fflig", "\uFB00"),
        v("ffllig", "\uFB04"),
        v("Ffr", "\uD835\uDD09"),
        v("ffr", "\uD835\uDD23"),
        v("filig", "\uFB01"),
        v("FilledSmallSquare", "\u25FC"),
        v("FilledVerySmallSquare", "\u25AA"),
        v("fjlig", "fj"),
        v("flat", "\u266D"),
        v("fllig", "\uFB02"),
        v("fltns", "\u25B1"),
        v("fnof", "\u0192"),
        v("Fopf", "\uD835\uDD3D"),
        v("fopf", "\uD835\uDD57"),
        v("forall", "\u2200"),
        v("ForAll", "\u2200"),
        v("fork", "\u22D4"),
        v("forkv", "\u2AD9"),
        v("Fouriertrf", "\u2131"),
        v("fpartint", "\u2A0D"),
        v("frac12", "\xbd"),
        v("frac13", "\u2153"),
        v("frac14", "\xbc"),
        v("frac15", "\u2155"),
        v("frac16", "\u2159"),
        v("frac18", "\u215B"),
        v("frac23", "\u2154"),
        v("frac25", "\u2156"),
        v("frac34", "\xbe"),
        v("frac35", "\u2157"),
        v("frac38", "\u215C"),
        v("frac45", "\u2158"),
        v("frac56", "\u215A"),
        v("frac58", "\u215D"),
        v("frac78", "\u215E"),
        v("frasl", "\u2044"),
        v("frown", "\u2322"),
        v("fscr", "\uD835\uDCBB"),
        v("Fscr", "\u2131"),
        v("gacute", "\u01F5"),
        v("Gamma", "\u0393"),
        v("gamma", "\u03B3"),
        v("Gammad", "\u03DC"),
        v("gammad", "\u03DD"),
        v("gap", "\u2A86"),
        v("Gbreve", "\u011E"),
        v("gbreve", "\u011F"),
        v("Gcedil", "\u0122"),
        v("Gcirc", "\u011C"),
        v("gcirc", "\u011D"),
        v("Gcy", "\u0413"),
        v("gcy", "\u0433"),
        v("Gdot", "\u0120"),
        v("gdot", "\u0121"),
        v("ge", "\u2265"),
        v("gE", "\u2267"),
        v("gEl", "\u2A8C"),
        v("gel", "\u22DB"),
        v("geq", "\u2265"),
        v("geqq", "\u2267"),
        v("geqslant", "\u2A7E"),
        v("gescc", "\u2AA9"),
        v("ges", "\u2A7E"),
        v("gesdot", "\u2A80"),
        v("gesdoto", "\u2A82"),
        v("gesdotol", "\u2A84"),
        v("gesl", "\u22DB\uFE00"),
        v("gesles", "\u2A94"),
        v("Gfr", "\uD835\uDD0A"),
        v("gfr", "\uD835\uDD24"),
        v("gg", "\u226B"),
        v("Gg", "\u22D9"),
        v("ggg", "\u22D9"),
        v("gimel", "\u2137"),
        v("GJcy", "\u0403"),
        v("gjcy", "\u0453"),
        v("gla", "\u2AA5"),
        v("gl", "\u2277"),
        v("glE", "\u2A92"),
        v("glj", "\u2AA4"),
        v("gnap", "\u2A8A"),
        v("gnapprox", "\u2A8A"),
        v("gne", "\u2A88"),
        v("gnE", "\u2269"),
        v("gneq", "\u2A88"),
        v("gneqq", "\u2269"),
        v("gnsim", "\u22E7"),
        v("Gopf", "\uD835\uDD3E"),
        v("gopf", "\uD835\uDD58"),
        v("grave", "`"),
        v("GreaterEqual", "\u2265"),
        v("GreaterEqualLess", "\u22DB"),
        v("GreaterFullEqual", "\u2267"),
        v("GreaterGreater", "\u2AA2"),
        v("GreaterLess", "\u2277"),
        v("GreaterSlantEqual", "\u2A7E"),
        v("GreaterTilde", "\u2273"),
        v("Gscr", "\uD835\uDCA2"),
        v("gscr", "\u210A"),
        v("gsim", "\u2273"),
        v("gsime", "\u2A8E"),
        v("gsiml", "\u2A90"),
        v("gtcc", "\u2AA7"),
        v("gtcir", "\u2A7A"),
        v("gt", ">"),
        v("GT", ">"),
        v("Gt", "\u226B"),
        v("gtdot", "\u22D7"),
        v("gtlPar", "\u2995"),
        v("gtquest", "\u2A7C"),
        v("gtrapprox", "\u2A86"),
        v("gtrarr", "\u2978"),
        v("gtrdot", "\u22D7"),
        v("gtreqless", "\u22DB"),
        v("gtreqqless", "\u2A8C"),
        v("gtrless", "\u2277"),
        v("gtrsim", "\u2273"),
        v("gvertneqq", "\u2269\uFE00"),
        v("gvnE", "\u2269\uFE00"),
        v("Hacek", "\u02C7"),
        v("hairsp", "\u200A"),
        v("half", "\xbd"),
        v("hamilt", "\u210B"),
        v("HARDcy", "\u042A"),
        v("hardcy", "\u044A"),
        v("harrcir", "\u2948"),
        v("harr", "\u2194"),
        v("hArr", "\u21D4"),
        v("harrw", "\u21AD"),
        v("Hat", "^"),
        v("hbar", "\u210F"),
        v("Hcirc", "\u0124"),
        v("hcirc", "\u0125"),
        v("hearts", "\u2665"),
        v("heartsuit", "\u2665"),
        v("hellip", "\u2026"),
        v("hercon", "\u22B9"),
        v("hfr", "\uD835\uDD25"),
        v("Hfr", "\u210C"),
        v("HilbertSpace", "\u210B"),
        v("hksearow", "\u2925"),
        v("hkswarow", "\u2926"),
        v("hoarr", "\u21FF"),
        v("homtht", "\u223B"),
        v("hookleftarrow", "\u21A9"),
        v("hookrightarrow", "\u21AA"),
        v("hopf", "\uD835\uDD59"),
        v("Hopf", "\u210D"),
        v("horbar", "\u2015"),
        v("HorizontalLine", "\u2500"),
        v("hscr", "\uD835\uDCBD"),
        v("Hscr", "\u210B"),
        v("hslash", "\u210F"),
        v("Hstrok", "\u0126"),
        v("hstrok", "\u0127"),
        v("HumpDownHump", "\u224E"),
        v("HumpEqual", "\u224F"),
        v("hybull", "\u2043"),
        v("hyphen", "\u2010"),
        v("Iacute", "\xcd"),
        v("iacute", "\xed"),
        v("ic", "\u2063"),
        v("Icirc", "\xce"),
        v("icirc", "\xee"),
        v("Icy", "\u0418"),
        v("icy", "\u0438"),
        v("Idot", "\u0130"),
        v("IEcy", "\u0415"),
        v("iecy", "\u0435"),
        v("iexcl", "\xa1"),
        v("iff", "\u21D4"),
        v("ifr", "\uD835\uDD26"),
        v("Ifr", "\u2111"),
        v("Igrave", "\xcc"),
        v("igrave", "\xec"),
        v("ii", "\u2148"),
        v("iiiint", "\u2A0C"),
        v("iiint", "\u222D"),
        v("iinfin", "\u29DC"),
        v("iiota", "\u2129"),
        v("IJlig", "\u0132"),
        v("ijlig", "\u0133"),
        v("Imacr", "\u012A"),
        v("imacr", "\u012B"),
        v("image", "\u2111"),
        v("ImaginaryI", "\u2148"),
        v("imagline", "\u2110"),
        v("imagpart", "\u2111"),
        v("imath", "\u0131"),
        v("Im", "\u2111"),
        v("imof", "\u22B7"),
        v("imped", "\u01B5"),
        v("Implies", "\u21D2"),
        v("incare", "\u2105"),
        v("in", "\u2208"),
        v("infin", "\u221E"),
        v("infintie", "\u29DD"),
        v("inodot", "\u0131"),
        v("intcal", "\u22BA"),
        v("int", "\u222B"),
        v("Int", "\u222C"),
        v("integers", "\u2124"),
        v("Integral", "\u222B"),
        v("intercal", "\u22BA"),
        v("Intersection", "\u22C2"),
        v("intlarhk", "\u2A17"),
        v("intprod", "\u2A3C"),
        v("InvisibleComma", "\u2063"),
        v("InvisibleTimes", "\u2062"),
        v("IOcy", "\u0401"),
        v("iocy", "\u0451"),
        v("Iogon", "\u012E"),
        v("iogon", "\u012F"),
        v("Iopf", "\uD835\uDD40"),
        v("iopf", "\uD835\uDD5A"),
        v("Iota", "\u0399"),
        v("iota", "\u03B9"),
        v("iprod", "\u2A3C"),
        v("iquest", "\xbf"),
        v("iscr", "\uD835\uDCBE"),
        v("Iscr", "\u2110"),
        v("isin", "\u2208"),
        v("isindot", "\u22F5"),
        v("isinE", "\u22F9"),
        v("isins", "\u22F4"),
        v("isinsv", "\u22F3"),
        v("isinv", "\u2208"),
        v("it", "\u2062"),
        v("Itilde", "\u0128"),
        v("itilde", "\u0129"),
        v("Iukcy", "\u0406"),
        v("iukcy", "\u0456"),
        v("Iuml", "\xcf"),
        v("iuml", "\xef"),
        v("Jcirc", "\u0134"),
        v("jcirc", "\u0135"),
        v("Jcy", "\u0419"),
        v("jcy", "\u0439"),
        v("Jfr", "\uD835\uDD0D"),
        v("jfr", "\uD835\uDD27"),
        v("jmath", "\u0237"),
        v("Jopf", "\uD835\uDD41"),
        v("jopf", "\uD835\uDD5B"),
        v("Jscr", "\uD835\uDCA5"),
        v("jscr", "\uD835\uDCBF"),
        v("Jsercy", "\u0408"),
        v("jsercy", "\u0458"),
        v("Jukcy", "\u0404"),
        v("jukcy", "\u0454"),
        v("Kappa", "\u039A"),
        v("kappa", "\u03BA"),
        v("kappav", "\u03F0"),
        v("Kcedil", "\u0136"),
        v("kcedil", "\u0137"),
        v("Kcy", "\u041A"),
        v("kcy", "\u043A"),
        v("Kfr", "\uD835\uDD0E"),
        v("kfr", "\uD835\uDD28"),
        v("kgreen", "\u0138"),
        v("KHcy", "\u0425"),
        v("khcy", "\u0445"),
        v("KJcy", "\u040C"),
        v("kjcy", "\u045C"),
        v("Kopf", "\uD835\uDD42"),
        v("kopf", "\uD835\uDD5C"),
        v("Kscr", "\uD835\uDCA6"),
        v("kscr", "\uD835\uDCC0"),
        v("lAarr", "\u21DA"),
        v("Lacute", "\u0139"),
        v("lacute", "\u013A"),
        v("laemptyv", "\u29B4"),
        v("lagran", "\u2112"),
        v("Lambda", "\u039B"),
        v("lambda", "\u03BB"),
        v("lang", "\u27E8"),
        v("Lang", "\u27EA"),
        v("langd", "\u2991"),
        v("langle", "\u27E8"),
        v("lap", "\u2A85"),
        v("Laplacetrf", "\u2112"),
        v("laquo", "\xab"),
        v("larrb", "\u21E4"),
        v("larrbfs", "\u291F"),
        v("larr", "\u2190"),
        v("Larr", "\u219E"),
        v("lArr", "\u21D0"),
        v("larrfs", "\u291D"),
        v("larrhk", "\u21A9"),
        v("larrlp", "\u21AB"),
        v("larrpl", "\u2939"),
        v("larrsim", "\u2973"),
        v("larrtl", "\u21A2"),
        v("latail", "\u2919"),
        v("lAtail", "\u291B"),
        v("lat", "\u2AAB"),
        v("late", "\u2AAD"),
        v("lates", "\u2AAD\uFE00"),
        v("lbarr", "\u290C"),
        v("lBarr", "\u290E"),
        v("lbbrk", "\u2772"),
        v("lbrace", "{"),
        v("lbrack", "["),
        v("lbrke", "\u298B"),
        v("lbrksld", "\u298F"),
        v("lbrkslu", "\u298D"),
        v("Lcaron", "\u013D"),
        v("lcaron", "\u013E"),
        v("Lcedil", "\u013B"),
        v("lcedil", "\u013C"),
        v("lceil", "\u2308"),
        v("lcub", "{"),
        v("Lcy", "\u041B"),
        v("lcy", "\u043B"),
        v("ldca", "\u2936"),
        v("ldquo", "\u201C"),
        v("ldquor", "\u201E"),
        v("ldrdhar", "\u2967"),
        v("ldrushar", "\u294B"),
        v("ldsh", "\u21B2"),
        v("le", "\u2264"),
        v("lE", "\u2266"),
        v("LeftAngleBracket", "\u27E8"),
        v("LeftArrowBar", "\u21E4"),
        v("leftarrow", "\u2190"),
        v("LeftArrow", "\u2190"),
        v("Leftarrow", "\u21D0"),
        v("LeftArrowRightArrow", "\u21C6"),
        v("leftarrowtail", "\u21A2"),
        v("LeftCeiling", "\u2308"),
        v("LeftDoubleBracket", "\u27E6"),
        v("LeftDownTeeVector", "\u2961"),
        v("LeftDownVectorBar", "\u2959"),
        v("LeftDownVector", "\u21C3"),
        v("LeftFloor", "\u230A"),
        v("leftharpoondown", "\u21BD"),
        v("leftharpoonup", "\u21BC"),
        v("leftleftarrows", "\u21C7"),
        v("leftrightarrow", "\u2194"),
        v("LeftRightArrow", "\u2194"),
        v("Leftrightarrow", "\u21D4"),
        v("leftrightarrows", "\u21C6"),
        v("leftrightharpoons", "\u21CB"),
        v("leftrightsquigarrow", "\u21AD"),
        v("LeftRightVector", "\u294E"),
        v("LeftTeeArrow", "\u21A4"),
        v("LeftTee", "\u22A3"),
        v("LeftTeeVector", "\u295A"),
        v("leftthreetimes", "\u22CB"),
        v("LeftTriangleBar", "\u29CF"),
        v("LeftTriangle", "\u22B2"),
        v("LeftTriangleEqual", "\u22B4"),
        v("LeftUpDownVector", "\u2951"),
        v("LeftUpTeeVector", "\u2960"),
        v("LeftUpVectorBar", "\u2958"),
        v("LeftUpVector", "\u21BF"),
        v("LeftVectorBar", "\u2952"),
        v("LeftVector", "\u21BC"),
        v("lEg", "\u2A8B"),
        v("leg", "\u22DA"),
        v("leq", "\u2264"),
        v("leqq", "\u2266"),
        v("leqslant", "\u2A7D"),
        v("lescc", "\u2AA8"),
        v("les", "\u2A7D"),
        v("lesdot", "\u2A7F"),
        v("lesdoto", "\u2A81"),
        v("lesdotor", "\u2A83"),
        v("lesg", "\u22DA\uFE00"),
        v("lesges", "\u2A93"),
        v("lessapprox", "\u2A85"),
        v("lessdot", "\u22D6"),
        v("lesseqgtr", "\u22DA"),
        v("lesseqqgtr", "\u2A8B"),
        v("LessEqualGreater", "\u22DA"),
        v("LessFullEqual", "\u2266"),
        v("LessGreater", "\u2276"),
        v("lessgtr", "\u2276"),
        v("LessLess", "\u2AA1"),
        v("lesssim", "\u2272"),
        v("LessSlantEqual", "\u2A7D"),
        v("LessTilde", "\u2272"),
        v("lfisht", "\u297C"),
        v("lfloor", "\u230A"),
        v("Lfr", "\uD835\uDD0F"),
        v("lfr", "\uD835\uDD29"),
        v("lg", "\u2276"),
        v("lgE", "\u2A91"),
        v("lHar", "\u2962"),
        v("lhard", "\u21BD"),
        v("lharu", "\u21BC"),
        v("lharul", "\u296A"),
        v("lhblk", "\u2584"),
        v("LJcy", "\u0409"),
        v("ljcy", "\u0459"),
        v("llarr", "\u21C7"),
        v("ll", "\u226A"),
        v("Ll", "\u22D8"),
        v("llcorner", "\u231E"),
        v("Lleftarrow", "\u21DA"),
        v("llhard", "\u296B"),
        v("lltri", "\u25FA"),
        v("Lmidot", "\u013F"),
        v("lmidot", "\u0140"),
        v("lmoustache", "\u23B0"),
        v("lmoust", "\u23B0"),
        v("lnap", "\u2A89"),
        v("lnapprox", "\u2A89"),
        v("lne", "\u2A87"),
        v("lnE", "\u2268"),
        v("lneq", "\u2A87"),
        v("lneqq", "\u2268"),
        v("lnsim", "\u22E6"),
        v("loang", "\u27EC"),
        v("loarr", "\u21FD"),
        v("lobrk", "\u27E6"),
        v("longleftarrow", "\u27F5"),
        v("LongLeftArrow", "\u27F5"),
        v("Longleftarrow", "\u27F8"),
        v("longleftrightarrow", "\u27F7"),
        v("LongLeftRightArrow", "\u27F7"),
        v("Longleftrightarrow", "\u27FA"),
        v("longmapsto", "\u27FC"),
        v("longrightarrow", "\u27F6"),
        v("LongRightArrow", "\u27F6"),
        v("Longrightarrow", "\u27F9"),
        v("looparrowleft", "\u21AB"),
        v("looparrowright", "\u21AC"),
        v("lopar", "\u2985"),
        v("Lopf", "\uD835\uDD43"),
        v("lopf", "\uD835\uDD5D"),
        v("loplus", "\u2A2D"),
        v("lotimes", "\u2A34"),
        v("lowast", "\u2217"),
        v("lowbar", "_"),
        v("LowerLeftArrow", "\u2199"),
        v("LowerRightArrow", "\u2198"),
        v("loz", "\u25CA"),
        v("lozenge", "\u25CA"),
        v("lozf", "\u29EB"),
        v("lpar", "("),
        v("lparlt", "\u2993"),
        v("lrarr", "\u21C6"),
        v("lrcorner", "\u231F"),
        v("lrhar", "\u21CB"),
        v("lrhard", "\u296D"),
        v("lrm", "\u200E"),
        v("lrtri", "\u22BF"),
        v("lsaquo", "\u2039"),
        v("lscr", "\uD835\uDCC1"),
        v("Lscr", "\u2112"),
        v("lsh", "\u21B0"),
        v("Lsh", "\u21B0"),
        v("lsim", "\u2272"),
        v("lsime", "\u2A8D"),
        v("lsimg", "\u2A8F"),
        v("lsqb", "["),
        v("lsquo", "\u2018"),
        v("lsquor", "\u201A"),
        v("Lstrok", "\u0141"),
        v("lstrok", "\u0142"),
        v("ltcc", "\u2AA6"),
        v("ltcir", "\u2A79"),
        v("lt", "<"),
        v("LT", "<"),
        v("Lt", "\u226A"),
        v("ltdot", "\u22D6"),
        v("lthree", "\u22CB"),
        v("ltimes", "\u22C9"),
        v("ltlarr", "\u2976"),
        v("ltquest", "\u2A7B"),
        v("ltri", "\u25C3"),
        v("ltrie", "\u22B4"),
        v("ltrif", "\u25C2"),
        v("ltrPar", "\u2996"),
        v("lurdshar", "\u294A"),
        v("luruhar", "\u2966"),
        v("lvertneqq", "\u2268\uFE00"),
        v("lvnE", "\u2268\uFE00"),
        v("macr", "\xaf"),
        v("male", "\u2642"),
        v("malt", "\u2720"),
        v("maltese", "\u2720"),
        v("Map", "\u2905"),
        v("map", "\u21A6"),
        v("mapsto", "\u21A6"),
        v("mapstodown", "\u21A7"),
        v("mapstoleft", "\u21A4"),
        v("mapstoup", "\u21A5"),
        v("marker", "\u25AE"),
        v("mcomma", "\u2A29"),
        v("Mcy", "\u041C"),
        v("mcy", "\u043C"),
        v("mdash", "\u2014"),
        v("mDDot", "\u223A"),
        v("measuredangle", "\u2221"),
        v("MediumSpace", "\u205F"),
        v("Mellintrf", "\u2133"),
        v("Mfr", "\uD835\uDD10"),
        v("mfr", "\uD835\uDD2A"),
        v("mho", "\u2127"),
        v("micro", "\xb5"),
        v("midast", "*"),
        v("midcir", "\u2AF0"),
        v("mid", "\u2223"),
        v("middot", "\xb7"),
        v("minusb", "\u229F"),
        v("minus", "\u2212"),
        v("minusd", "\u2238"),
        v("minusdu", "\u2A2A"),
        v("MinusPlus", "\u2213"),
        v("mlcp", "\u2ADB"),
        v("mldr", "\u2026"),
        v("mnplus", "\u2213"),
        v("models", "\u22A7"),
        v("Mopf", "\uD835\uDD44"),
        v("mopf", "\uD835\uDD5E"),
        v("mp", "\u2213"),
        v("mscr", "\uD835\uDCC2"),
        v("Mscr", "\u2133"),
        v("mstpos", "\u223E"),
        v("Mu", "\u039C"),
        v("mu", "\u03BC"),
        v("multimap", "\u22B8"),
        v("mumap", "\u22B8"),
        v("nabla", "\u2207"),
        v("Nacute", "\u0143"),
        v("nacute", "\u0144"),
        v("nang", "\u2220\u20D2"),
        v("nap", "\u2249"),
        v("napE", "\u2A70\u0338"),
        v("napid", "\u224B\u0338"),
        v("napos", "\u0149"),
        v("napprox", "\u2249"),
        v("natural", "\u266E"),
        v("naturals", "\u2115"),
        v("natur", "\u266E"),
        v("nbsp", "\xa0"),
        v("nbump", "\u224E\u0338"),
        v("nbumpe", "\u224F\u0338"),
        v("ncap", "\u2A43"),
        v("Ncaron", "\u0147"),
        v("ncaron", "\u0148"),
        v("Ncedil", "\u0145"),
        v("ncedil", "\u0146"),
        v("ncong", "\u2247"),
        v("ncongdot", "\u2A6D\u0338"),
        v("ncup", "\u2A42"),
        v("Ncy", "\u041D"),
        v("ncy", "\u043D"),
        v("ndash", "\u2013"),
        v("nearhk", "\u2924"),
        v("nearr", "\u2197"),
        v("neArr", "\u21D7"),
        v("nearrow", "\u2197"),
        v("ne", "\u2260"),
        v("nedot", "\u2250\u0338"),
        v("NegativeMediumSpace", "\u200B"),
        v("NegativeThickSpace", "\u200B"),
        v("NegativeThinSpace", "\u200B"),
        v("NegativeVeryThinSpace", "\u200B"),
        v("nequiv", "\u2262"),
        v("nesear", "\u2928"),
        v("nesim", "\u2242\u0338"),
        v("NestedGreaterGreater", "\u226B"),
        v("NestedLessLess", "\u226A"),
        v("NewLine", "\n"),
        v("nexist", "\u2204"),
        v("nexists", "\u2204"),
        v("Nfr", "\uD835\uDD11"),
        v("nfr", "\uD835\uDD2B"),
        v("ngE", "\u2267\u0338"),
        v("nge", "\u2271"),
        v("ngeq", "\u2271"),
        v("ngeqq", "\u2267\u0338"),
        v("ngeqslant", "\u2A7E\u0338"),
        v("nges", "\u2A7E\u0338"),
        v("nGg", "\u22D9\u0338"),
        v("ngsim", "\u2275"),
        v("nGt", "\u226B\u20D2"),
        v("ngt", "\u226F"),
        v("ngtr", "\u226F"),
        v("nGtv", "\u226B\u0338"),
        v("nharr", "\u21AE"),
        v("nhArr", "\u21CE"),
        v("nhpar", "\u2AF2"),
        v("ni", "\u220B"),
        v("nis", "\u22FC"),
        v("nisd", "\u22FA"),
        v("niv", "\u220B"),
        v("NJcy", "\u040A"),
        v("njcy", "\u045A"),
        v("nlarr", "\u219A"),
        v("nlArr", "\u21CD"),
        v("nldr", "\u2025"),
        v("nlE", "\u2266\u0338"),
        v("nle", "\u2270"),
        v("nleftarrow", "\u219A"),
        v("nLeftarrow", "\u21CD"),
        v("nleftrightarrow", "\u21AE"),
        v("nLeftrightarrow", "\u21CE"),
        v("nleq", "\u2270"),
        v("nleqq", "\u2266\u0338"),
        v("nleqslant", "\u2A7D\u0338"),
        v("nles", "\u2A7D\u0338"),
        v("nless", "\u226E"),
        v("nLl", "\u22D8\u0338"),
        v("nlsim", "\u2274"),
        v("nLt", "\u226A\u20D2"),
        v("nlt", "\u226E"),
        v("nltri", "\u22EA"),
        v("nltrie", "\u22EC"),
        v("nLtv", "\u226A\u0338"),
        v("nmid", "\u2224"),
        v("NoBreak", "\u2060"),
        v("NonBreakingSpace", "\xa0"),
        v("nopf", "\uD835\uDD5F"),
        v("Nopf", "\u2115"),
        v("Not", "\u2AEC"),
        v("not", "\xac"),
        v("NotCongruent", "\u2262"),
        v("NotCupCap", "\u226D"),
        v("NotDoubleVerticalBar", "\u2226"),
        v("NotElement", "\u2209"),
        v("NotEqual", "\u2260"),
        v("NotEqualTilde", "\u2242\u0338"),
        v("NotExists", "\u2204"),
        v("NotGreater", "\u226F"),
        v("NotGreaterEqual", "\u2271"),
        v("NotGreaterFullEqual", "\u2267\u0338"),
        v("NotGreaterGreater", "\u226B\u0338"),
        v("NotGreaterLess", "\u2279"),
        v("NotGreaterSlantEqual", "\u2A7E\u0338"),
        v("NotGreaterTilde", "\u2275"),
        v("NotHumpDownHump", "\u224E\u0338"),
        v("NotHumpEqual", "\u224F\u0338"),
        v("notin", "\u2209"),
        v("notindot", "\u22F5\u0338"),
        v("notinE", "\u22F9\u0338"),
        v("notinva", "\u2209"),
        v("notinvb", "\u22F7"),
        v("notinvc", "\u22F6"),
        v("NotLeftTriangleBar", "\u29CF\u0338"),
        v("NotLeftTriangle", "\u22EA"),
        v("NotLeftTriangleEqual", "\u22EC"),
        v("NotLess", "\u226E"),
        v("NotLessEqual", "\u2270"),
        v("NotLessGreater", "\u2278"),
        v("NotLessLess", "\u226A\u0338"),
        v("NotLessSlantEqual", "\u2A7D\u0338"),
        v("NotLessTilde", "\u2274"),
        v("NotNestedGreaterGreater", "\u2AA2\u0338"),
        v("NotNestedLessLess", "\u2AA1\u0338"),
        v("notni", "\u220C"),
        v("notniva", "\u220C"),
        v("notnivb", "\u22FE"),
        v("notnivc", "\u22FD"),
        v("NotPrecedes", "\u2280"),
        v("NotPrecedesEqual", "\u2AAF\u0338"),
        v("NotPrecedesSlantEqual", "\u22E0"),
        v("NotReverseElement", "\u220C"),
        v("NotRightTriangleBar", "\u29D0\u0338"),
        v("NotRightTriangle", "\u22EB"),
        v("NotRightTriangleEqual", "\u22ED"),
        v("NotSquareSubset", "\u228F\u0338"),
        v("NotSquareSubsetEqual", "\u22E2"),
        v("NotSquareSuperset", "\u2290\u0338"),
        v("NotSquareSupersetEqual", "\u22E3"),
        v("NotSubset", "\u2282\u20D2"),
        v("NotSubsetEqual", "\u2288"),
        v("NotSucceeds", "\u2281"),
        v("NotSucceedsEqual", "\u2AB0\u0338"),
        v("NotSucceedsSlantEqual", "\u22E1"),
        v("NotSucceedsTilde", "\u227F\u0338"),
        v("NotSuperset", "\u2283\u20D2"),
        v("NotSupersetEqual", "\u2289"),
        v("NotTilde", "\u2241"),
        v("NotTildeEqual", "\u2244"),
        v("NotTildeFullEqual", "\u2247"),
        v("NotTildeTilde", "\u2249"),
        v("NotVerticalBar", "\u2224"),
        v("nparallel", "\u2226"),
        v("npar", "\u2226"),
        v("nparsl", "\u2AFD\u20E5"),
        v("npart", "\u2202\u0338"),
        v("npolint", "\u2A14"),
        v("npr", "\u2280"),
        v("nprcue", "\u22E0"),
        v("nprec", "\u2280"),
        v("npreceq", "\u2AAF\u0338"),
        v("npre", "\u2AAF\u0338"),
        v("nrarrc", "\u2933\u0338"),
        v("nrarr", "\u219B"),
        v("nrArr", "\u21CF"),
        v("nrarrw", "\u219D\u0338"),
        v("nrightarrow", "\u219B"),
        v("nRightarrow", "\u21CF"),
        v("nrtri", "\u22EB"),
        v("nrtrie", "\u22ED"),
        v("nsc", "\u2281"),
        v("nsccue", "\u22E1"),
        v("nsce", "\u2AB0\u0338"),
        v("Nscr", "\uD835\uDCA9"),
        v("nscr", "\uD835\uDCC3"),
        v("nshortmid", "\u2224"),
        v("nshortparallel", "\u2226"),
        v("nsim", "\u2241"),
        v("nsime", "\u2244"),
        v("nsimeq", "\u2244"),
        v("nsmid", "\u2224"),
        v("nspar", "\u2226"),
        v("nsqsube", "\u22E2"),
        v("nsqsupe", "\u22E3"),
        v("nsub", "\u2284"),
        v("nsubE", "\u2AC5\u0338"),
        v("nsube", "\u2288"),
        v("nsubset", "\u2282\u20D2"),
        v("nsubseteq", "\u2288"),
        v("nsubseteqq", "\u2AC5\u0338"),
        v("nsucc", "\u2281"),
        v("nsucceq", "\u2AB0\u0338"),
        v("nsup", "\u2285"),
        v("nsupE", "\u2AC6\u0338"),
        v("nsupe", "\u2289"),
        v("nsupset", "\u2283\u20D2"),
        v("nsupseteq", "\u2289"),
        v("nsupseteqq", "\u2AC6\u0338"),
        v("ntgl", "\u2279"),
        v("Ntilde", "\xd1"),
        v("ntilde", "\xf1"),
        v("ntlg", "\u2278"),
        v("ntriangleleft", "\u22EA"),
        v("ntrianglelefteq", "\u22EC"),
        v("ntriangleright", "\u22EB"),
        v("ntrianglerighteq", "\u22ED"),
        v("Nu", "\u039D"),
        v("nu", "\u03BD"),
        v("num", "#"),
        v("numero", "\u2116"),
        v("numsp", "\u2007"),
        v("nvap", "\u224D\u20D2"),
        v("nvdash", "\u22AC"),
        v("nvDash", "\u22AD"),
        v("nVdash", "\u22AE"),
        v("nVDash", "\u22AF"),
        v("nvge", "\u2265\u20D2"),
        v("nvgt", ">\u20D2"),
        v("nvHarr", "\u2904"),
        v("nvinfin", "\u29DE"),
        v("nvlArr", "\u2902"),
        v("nvle", "\u2264\u20D2"),
        v("nvlt", "<\u20D2"),
        v("nvltrie", "\u22B4\u20D2"),
        v("nvrArr", "\u2903"),
        v("nvrtrie", "\u22B5\u20D2"),
        v("nvsim", "\u223C\u20D2"),
        v("nwarhk", "\u2923"),
        v("nwarr", "\u2196"),
        v("nwArr", "\u21D6"),
        v("nwarrow", "\u2196"),
        v("nwnear", "\u2927"),
        v("Oacute", "\xd3"),
        v("oacute", "\xf3"),
        v("oast", "\u229B"),
        v("Ocirc", "\xd4"),
        v("ocirc", "\xf4"),
        v("ocir", "\u229A"),
        v("Ocy", "\u041E"),
        v("ocy", "\u043E"),
        v("odash", "\u229D"),
        v("Odblac", "\u0150"),
        v("odblac", "\u0151"),
        v("odiv", "\u2A38"),
        v("odot", "\u2299"),
        v("odsold", "\u29BC"),
        v("OElig", "\u0152"),
        v("oelig", "\u0153"),
        v("ofcir", "\u29BF"),
        v("Ofr", "\uD835\uDD12"),
        v("ofr", "\uD835\uDD2C"),
        v("ogon", "\u02DB"),
        v("Ograve", "\xd2"),
        v("ograve", "\xf2"),
        v("ogt", "\u29C1"),
        v("ohbar", "\u29B5"),
        v("ohm", "\u03A9"),
        v("oint", "\u222E"),
        v("olarr", "\u21BA"),
        v("olcir", "\u29BE"),
        v("olcross", "\u29BB"),
        v("oline", "\u203E"),
        v("olt", "\u29C0"),
        v("Omacr", "\u014C"),
        v("omacr", "\u014D"),
        v("Omega", "\u03A9"),
        v("omega", "\u03C9"),
        v("Omicron", "\u039F"),
        v("omicron", "\u03BF"),
        v("omid", "\u29B6"),
        v("ominus", "\u2296"),
        v("Oopf", "\uD835\uDD46"),
        v("oopf", "\uD835\uDD60"),
        v("opar", "\u29B7"),
        v("OpenCurlyDoubleQuote", "\u201C"),
        v("OpenCurlyQuote", "\u2018"),
        v("operp", "\u29B9"),
        v("oplus", "\u2295"),
        v("orarr", "\u21BB"),
        v("Or", "\u2A54"),
        v("or", "\u2228"),
        v("ord", "\u2A5D"),
        v("order", "\u2134"),
        v("orderof", "\u2134"),
        v("ordf", "\xaa"),
        v("ordm", "\xba"),
        v("origof", "\u22B6"),
        v("oror", "\u2A56"),
        v("orslope", "\u2A57"),
        v("orv", "\u2A5B"),
        v("oS", "\u24C8"),
        v("Oscr", "\uD835\uDCAA"),
        v("oscr", "\u2134"),
        v("Oslash", "\xd8"),
        v("oslash", "\xf8"),
        v("osol", "\u2298"),
        v("Otilde", "\xd5"),
        v("otilde", "\xf5"),
        v("otimesas", "\u2A36"),
        v("Otimes", "\u2A37"),
        v("otimes", "\u2297"),
        v("Ouml", "\xd6"),
        v("ouml", "\xf6"),
        v("ovbar", "\u233D"),
        v("OverBar", "\u203E"),
        v("OverBrace", "\u23DE"),
        v("OverBracket", "\u23B4"),
        v("OverParenthesis", "\u23DC"),
        v("para", "\xb6"),
        v("parallel", "\u2225"),
        v("par", "\u2225"),
        v("parsim", "\u2AF3"),
        v("parsl", "\u2AFD"),
        v("part", "\u2202"),
        v("PartialD", "\u2202"),
        v("Pcy", "\u041F"),
        v("pcy", "\u043F"),
        v("percnt", "%"),
        v("period", "."),
        v("permil", "\u2030"),
        v("perp", "\u22A5"),
        v("pertenk", "\u2031"),
        v("Pfr", "\uD835\uDD13"),
        v("pfr", "\uD835\uDD2D"),
        v("Phi", "\u03A6"),
        v("phi", "\u03C6"),
        v("phiv", "\u03D5"),
        v("phmmat", "\u2133"),
        v("phone", "\u260E"),
        v("Pi", "\u03A0"),
        v("pi", "\u03C0"),
        v("pitchfork", "\u22D4"),
        v("piv", "\u03D6"),
        v("planck", "\u210F"),
        v("planckh", "\u210E"),
        v("plankv", "\u210F"),
        v("plusacir", "\u2A23"),
        v("plusb", "\u229E"),
        v("pluscir", "\u2A22"),
        v("plus", "+"),
        v("plusdo", "\u2214"),
        v("plusdu", "\u2A25"),
        v("pluse", "\u2A72"),
        v("PlusMinus", "\xb1"),
        v("plusmn", "\xb1"),
        v("plussim", "\u2A26"),
        v("plustwo", "\u2A27"),
        v("pm", "\xb1"),
        v("Poincareplane", "\u210C"),
        v("pointint", "\u2A15"),
        v("popf", "\uD835\uDD61"),
        v("Popf", "\u2119"),
        v("pound", "\xa3"),
        v("prap", "\u2AB7"),
        v("Pr", "\u2ABB"),
        v("pr", "\u227A"),
        v("prcue", "\u227C"),
        v("precapprox", "\u2AB7"),
        v("prec", "\u227A"),
        v("preccurlyeq", "\u227C"),
        v("Precedes", "\u227A"),
        v("PrecedesEqual", "\u2AAF"),
        v("PrecedesSlantEqual", "\u227C"),
        v("PrecedesTilde", "\u227E"),
        v("preceq", "\u2AAF"),
        v("precnapprox", "\u2AB9"),
        v("precneqq", "\u2AB5"),
        v("precnsim", "\u22E8"),
        v("pre", "\u2AAF"),
        v("prE", "\u2AB3"),
        v("precsim", "\u227E"),
        v("prime", "\u2032"),
        v("Prime", "\u2033"),
        v("primes", "\u2119"),
        v("prnap", "\u2AB9"),
        v("prnE", "\u2AB5"),
        v("prnsim", "\u22E8"),
        v("prod", "\u220F"),
        v("Product", "\u220F"),
        v("profalar", "\u232E"),
        v("profline", "\u2312"),
        v("profsurf", "\u2313"),
        v("prop", "\u221D"),
        v("Proportional", "\u221D"),
        v("Proportion", "\u2237"),
        v("propto", "\u221D"),
        v("prsim", "\u227E"),
        v("prurel", "\u22B0"),
        v("Pscr", "\uD835\uDCAB"),
        v("pscr", "\uD835\uDCC5"),
        v("Psi", "\u03A8"),
        v("psi", "\u03C8"),
        v("puncsp", "\u2008"),
        v("Qfr", "\uD835\uDD14"),
        v("qfr", "\uD835\uDD2E"),
        v("qint", "\u2A0C"),
        v("qopf", "\uD835\uDD62"),
        v("Qopf", "\u211A"),
        v("qprime", "\u2057"),
        v("Qscr", "\uD835\uDCAC"),
        v("qscr", "\uD835\uDCC6"),
        v("quaternions", "\u210D"),
        v("quatint", "\u2A16"),
        v("quest", "?"),
        v("questeq", "\u225F"),
        v("quot", '"'),
        v("QUOT", '"'),
        v("rAarr", "\u21DB"),
        v("race", "\u223D\u0331"),
        v("Racute", "\u0154"),
        v("racute", "\u0155"),
        v("radic", "\u221A"),
        v("raemptyv", "\u29B3"),
        v("rang", "\u27E9"),
        v("Rang", "\u27EB"),
        v("rangd", "\u2992"),
        v("range", "\u29A5"),
        v("rangle", "\u27E9"),
        v("raquo", "\xbb"),
        v("rarrap", "\u2975"),
        v("rarrb", "\u21E5"),
        v("rarrbfs", "\u2920"),
        v("rarrc", "\u2933"),
        v("rarr", "\u2192"),
        v("Rarr", "\u21A0"),
        v("rArr", "\u21D2"),
        v("rarrfs", "\u291E"),
        v("rarrhk", "\u21AA"),
        v("rarrlp", "\u21AC"),
        v("rarrpl", "\u2945"),
        v("rarrsim", "\u2974"),
        v("Rarrtl", "\u2916"),
        v("rarrtl", "\u21A3"),
        v("rarrw", "\u219D"),
        v("ratail", "\u291A"),
        v("rAtail", "\u291C"),
        v("ratio", "\u2236"),
        v("rationals", "\u211A"),
        v("rbarr", "\u290D"),
        v("rBarr", "\u290F"),
        v("RBarr", "\u2910"),
        v("rbbrk", "\u2773"),
        v("rbrace", "}"),
        v("rbrack", "]"),
        v("rbrke", "\u298C"),
        v("rbrksld", "\u298E"),
        v("rbrkslu", "\u2990"),
        v("Rcaron", "\u0158"),
        v("rcaron", "\u0159"),
        v("Rcedil", "\u0156"),
        v("rcedil", "\u0157"),
        v("rceil", "\u2309"),
        v("rcub", "}"),
        v("Rcy", "\u0420"),
        v("rcy", "\u0440"),
        v("rdca", "\u2937"),
        v("rdldhar", "\u2969"),
        v("rdquo", "\u201D"),
        v("rdquor", "\u201D"),
        v("rdsh", "\u21B3"),
        v("real", "\u211C"),
        v("realine", "\u211B"),
        v("realpart", "\u211C"),
        v("reals", "\u211D"),
        v("Re", "\u211C"),
        v("rect", "\u25AD"),
        v("reg", "\xae"),
        v("REG", "\xae"),
        v("ReverseElement", "\u220B"),
        v("ReverseEquilibrium", "\u21CB"),
        v("ReverseUpEquilibrium", "\u296F"),
        v("rfisht", "\u297D"),
        v("rfloor", "\u230B"),
        v("rfr", "\uD835\uDD2F"),
        v("Rfr", "\u211C"),
        v("rHar", "\u2964"),
        v("rhard", "\u21C1"),
        v("rharu", "\u21C0"),
        v("rharul", "\u296C"),
        v("Rho", "\u03A1"),
        v("rho", "\u03C1"),
        v("rhov", "\u03F1"),
        v("RightAngleBracket", "\u27E9"),
        v("RightArrowBar", "\u21E5"),
        v("rightarrow", "\u2192"),
        v("RightArrow", "\u2192"),
        v("Rightarrow", "\u21D2"),
        v("RightArrowLeftArrow", "\u21C4"),
        v("rightarrowtail", "\u21A3"),
        v("RightCeiling", "\u2309"),
        v("RightDoubleBracket", "\u27E7"),
        v("RightDownTeeVector", "\u295D"),
        v("RightDownVectorBar", "\u2955"),
        v("RightDownVector", "\u21C2"),
        v("RightFloor", "\u230B"),
        v("rightharpoondown", "\u21C1"),
        v("rightharpoonup", "\u21C0"),
        v("rightleftarrows", "\u21C4"),
        v("rightleftharpoons", "\u21CC"),
        v("rightrightarrows", "\u21C9"),
        v("rightsquigarrow", "\u219D"),
        v("RightTeeArrow", "\u21A6"),
        v("RightTee", "\u22A2"),
        v("RightTeeVector", "\u295B"),
        v("rightthreetimes", "\u22CC"),
        v("RightTriangleBar", "\u29D0"),
        v("RightTriangle", "\u22B3"),
        v("RightTriangleEqual", "\u22B5"),
        v("RightUpDownVector", "\u294F"),
        v("RightUpTeeVector", "\u295C"),
        v("RightUpVectorBar", "\u2954"),
        v("RightUpVector", "\u21BE"),
        v("RightVectorBar", "\u2953"),
        v("RightVector", "\u21C0"),
        v("ring", "\u02DA"),
        v("risingdotseq", "\u2253"),
        v("rlarr", "\u21C4"),
        v("rlhar", "\u21CC"),
        v("rlm", "\u200F"),
        v("rmoustache", "\u23B1"),
        v("rmoust", "\u23B1"),
        v("rnmid", "\u2AEE"),
        v("roang", "\u27ED"),
        v("roarr", "\u21FE"),
        v("robrk", "\u27E7"),
        v("ropar", "\u2986"),
        v("ropf", "\uD835\uDD63"),
        v("Ropf", "\u211D"),
        v("roplus", "\u2A2E"),
        v("rotimes", "\u2A35"),
        v("RoundImplies", "\u2970"),
        v("rpar", ")"),
        v("rpargt", "\u2994"),
        v("rppolint", "\u2A12"),
        v("rrarr", "\u21C9"),
        v("Rrightarrow", "\u21DB"),
        v("rsaquo", "\u203A"),
        v("rscr", "\uD835\uDCC7"),
        v("Rscr", "\u211B"),
        v("rsh", "\u21B1"),
        v("Rsh", "\u21B1"),
        v("rsqb", "]"),
        v("rsquo", "\u2019"),
        v("rsquor", "\u2019"),
        v("rthree", "\u22CC"),
        v("rtimes", "\u22CA"),
        v("rtri", "\u25B9"),
        v("rtrie", "\u22B5"),
        v("rtrif", "\u25B8"),
        v("rtriltri", "\u29CE"),
        v("RuleDelayed", "\u29F4"),
        v("ruluhar", "\u2968"),
        v("rx", "\u211E"),
        v("Sacute", "\u015A"),
        v("sacute", "\u015B"),
        v("sbquo", "\u201A"),
        v("scap", "\u2AB8"),
        v("Scaron", "\u0160"),
        v("scaron", "\u0161"),
        v("Sc", "\u2ABC"),
        v("sc", "\u227B"),
        v("sccue", "\u227D"),
        v("sce", "\u2AB0"),
        v("scE", "\u2AB4"),
        v("Scedil", "\u015E"),
        v("scedil", "\u015F"),
        v("Scirc", "\u015C"),
        v("scirc", "\u015D"),
        v("scnap", "\u2ABA"),
        v("scnE", "\u2AB6"),
        v("scnsim", "\u22E9"),
        v("scpolint", "\u2A13"),
        v("scsim", "\u227F"),
        v("Scy", "\u0421"),
        v("scy", "\u0441"),
        v("sdotb", "\u22A1"),
        v("sdot", "\u22C5"),
        v("sdote", "\u2A66"),
        v("searhk", "\u2925"),
        v("searr", "\u2198"),
        v("seArr", "\u21D8"),
        v("searrow", "\u2198"),
        v("sect", "\xa7"),
        v("semi", ";"),
        v("seswar", "\u2929"),
        v("setminus", "\u2216"),
        v("setmn", "\u2216"),
        v("sext", "\u2736"),
        v("Sfr", "\uD835\uDD16"),
        v("sfr", "\uD835\uDD30"),
        v("sfrown", "\u2322"),
        v("sharp", "\u266F"),
        v("SHCHcy", "\u0429"),
        v("shchcy", "\u0449"),
        v("SHcy", "\u0428"),
        v("shcy", "\u0448"),
        v("ShortDownArrow", "\u2193"),
        v("ShortLeftArrow", "\u2190"),
        v("shortmid", "\u2223"),
        v("shortparallel", "\u2225"),
        v("ShortRightArrow", "\u2192"),
        v("ShortUpArrow", "\u2191"),
        v("shy", "\xad"),
        v("Sigma", "\u03A3"),
        v("sigma", "\u03C3"),
        v("sigmaf", "\u03C2"),
        v("sigmav", "\u03C2"),
        v("sim", "\u223C"),
        v("simdot", "\u2A6A"),
        v("sime", "\u2243"),
        v("simeq", "\u2243"),
        v("simg", "\u2A9E"),
        v("simgE", "\u2AA0"),
        v("siml", "\u2A9D"),
        v("simlE", "\u2A9F"),
        v("simne", "\u2246"),
        v("simplus", "\u2A24"),
        v("simrarr", "\u2972"),
        v("slarr", "\u2190"),
        v("SmallCircle", "\u2218"),
        v("smallsetminus", "\u2216"),
        v("smashp", "\u2A33"),
        v("smeparsl", "\u29E4"),
        v("smid", "\u2223"),
        v("smile", "\u2323"),
        v("smt", "\u2AAA"),
        v("smte", "\u2AAC"),
        v("smtes", "\u2AAC\uFE00"),
        v("SOFTcy", "\u042C"),
        v("softcy", "\u044C"),
        v("solbar", "\u233F"),
        v("solb", "\u29C4"),
        v("sol", "/"),
        v("Sopf", "\uD835\uDD4A"),
        v("sopf", "\uD835\uDD64"),
        v("spades", "\u2660"),
        v("spadesuit", "\u2660"),
        v("spar", "\u2225"),
        v("sqcap", "\u2293"),
        v("sqcaps", "\u2293\uFE00"),
        v("sqcup", "\u2294"),
        v("sqcups", "\u2294\uFE00"),
        v("Sqrt", "\u221A"),
        v("sqsub", "\u228F"),
        v("sqsube", "\u2291"),
        v("sqsubset", "\u228F"),
        v("sqsubseteq", "\u2291"),
        v("sqsup", "\u2290"),
        v("sqsupe", "\u2292"),
        v("sqsupset", "\u2290"),
        v("sqsupseteq", "\u2292"),
        v("square", "\u25A1"),
        v("Square", "\u25A1"),
        v("SquareIntersection", "\u2293"),
        v("SquareSubset", "\u228F"),
        v("SquareSubsetEqual", "\u2291"),
        v("SquareSuperset", "\u2290"),
        v("SquareSupersetEqual", "\u2292"),
        v("SquareUnion", "\u2294"),
        v("squarf", "\u25AA"),
        v("squ", "\u25A1"),
        v("squf", "\u25AA"),
        v("srarr", "\u2192"),
        v("Sscr", "\uD835\uDCAE"),
        v("sscr", "\uD835\uDCC8"),
        v("ssetmn", "\u2216"),
        v("ssmile", "\u2323"),
        v("sstarf", "\u22C6"),
        v("Star", "\u22C6"),
        v("star", "\u2606"),
        v("starf", "\u2605"),
        v("straightepsilon", "\u03F5"),
        v("straightphi", "\u03D5"),
        v("strns", "\xaf"),
        v("sub", "\u2282"),
        v("Sub", "\u22D0"),
        v("subdot", "\u2ABD"),
        v("subE", "\u2AC5"),
        v("sube", "\u2286"),
        v("subedot", "\u2AC3"),
        v("submult", "\u2AC1"),
        v("subnE", "\u2ACB"),
        v("subne", "\u228A"),
        v("subplus", "\u2ABF"),
        v("subrarr", "\u2979"),
        v("subset", "\u2282"),
        v("Subset", "\u22D0"),
        v("subseteq", "\u2286"),
        v("subseteqq", "\u2AC5"),
        v("SubsetEqual", "\u2286"),
        v("subsetneq", "\u228A"),
        v("subsetneqq", "\u2ACB"),
        v("subsim", "\u2AC7"),
        v("subsub", "\u2AD5"),
        v("subsup", "\u2AD3"),
        v("succapprox", "\u2AB8"),
        v("succ", "\u227B"),
        v("succcurlyeq", "\u227D"),
        v("Succeeds", "\u227B"),
        v("SucceedsEqual", "\u2AB0"),
        v("SucceedsSlantEqual", "\u227D"),
        v("SucceedsTilde", "\u227F"),
        v("succeq", "\u2AB0"),
        v("succnapprox", "\u2ABA"),
        v("succneqq", "\u2AB6"),
        v("succnsim", "\u22E9"),
        v("succsim", "\u227F"),
        v("SuchThat", "\u220B"),
        v("sum", "\u2211"),
        v("Sum", "\u2211"),
        v("sung", "\u266A"),
        v("sup1", "\xb9"),
        v("sup2", "\xb2"),
        v("sup3", "\xb3"),
        v("sup", "\u2283"),
        v("Sup", "\u22D1"),
        v("supdot", "\u2ABE"),
        v("supdsub", "\u2AD8"),
        v("supE", "\u2AC6"),
        v("supe", "\u2287"),
        v("supedot", "\u2AC4"),
        v("Superset", "\u2283"),
        v("SupersetEqual", "\u2287"),
        v("suphsol", "\u27C9"),
        v("suphsub", "\u2AD7"),
        v("suplarr", "\u297B"),
        v("supmult", "\u2AC2"),
        v("supnE", "\u2ACC"),
        v("supne", "\u228B"),
        v("supplus", "\u2AC0"),
        v("supset", "\u2283"),
        v("Supset", "\u22D1"),
        v("supseteq", "\u2287"),
        v("supseteqq", "\u2AC6"),
        v("supsetneq", "\u228B"),
        v("supsetneqq", "\u2ACC"),
        v("supsim", "\u2AC8"),
        v("supsub", "\u2AD4"),
        v("supsup", "\u2AD6"),
        v("swarhk", "\u2926"),
        v("swarr", "\u2199"),
        v("swArr", "\u21D9"),
        v("swarrow", "\u2199"),
        v("swnwar", "\u292A"),
        v("szlig", "\xdf"),
        v("Tab", "\t"),
        v("target", "\u2316"),
        v("Tau", "\u03A4"),
        v("tau", "\u03C4"),
        v("tbrk", "\u23B4"),
        v("Tcaron", "\u0164"),
        v("tcaron", "\u0165"),
        v("Tcedil", "\u0162"),
        v("tcedil", "\u0163"),
        v("Tcy", "\u0422"),
        v("tcy", "\u0442"),
        v("tdot", "\u20DB"),
        v("telrec", "\u2315"),
        v("Tfr", "\uD835\uDD17"),
        v("tfr", "\uD835\uDD31"),
        v("there4", "\u2234"),
        v("therefore", "\u2234"),
        v("Therefore", "\u2234"),
        v("Theta", "\u0398"),
        v("theta", "\u03B8"),
        v("thetasym", "\u03D1"),
        v("thetav", "\u03D1"),
        v("thickapprox", "\u2248"),
        v("thicksim", "\u223C"),
        v("ThickSpace", "\u205F\u200A"),
        v("ThinSpace", "\u2009"),
        v("thinsp", "\u2009"),
        v("thkap", "\u2248"),
        v("thksim", "\u223C"),
        v("THORN", "\xde"),
        v("thorn", "\xfe"),
        v("tilde", "\u02DC"),
        v("Tilde", "\u223C"),
        v("TildeEqual", "\u2243"),
        v("TildeFullEqual", "\u2245"),
        v("TildeTilde", "\u2248"),
        v("timesbar", "\u2A31"),
        v("timesb", "\u22A0"),
        v("times", "\xd7"),
        v("timesd", "\u2A30"),
        v("tint", "\u222D"),
        v("toea", "\u2928"),
        v("topbot", "\u2336"),
        v("topcir", "\u2AF1"),
        v("top", "\u22A4"),
        v("Topf", "\uD835\uDD4B"),
        v("topf", "\uD835\uDD65"),
        v("topfork", "\u2ADA"),
        v("tosa", "\u2929"),
        v("tprime", "\u2034"),
        v("trade", "\u2122"),
        v("TRADE", "\u2122"),
        v("triangle", "\u25B5"),
        v("triangledown", "\u25BF"),
        v("triangleleft", "\u25C3"),
        v("trianglelefteq", "\u22B4"),
        v("triangleq", "\u225C"),
        v("triangleright", "\u25B9"),
        v("trianglerighteq", "\u22B5"),
        v("tridot", "\u25EC"),
        v("trie", "\u225C"),
        v("triminus", "\u2A3A"),
        v("TripleDot", "\u20DB"),
        v("triplus", "\u2A39"),
        v("trisb", "\u29CD"),
        v("tritime", "\u2A3B"),
        v("trpezium", "\u23E2"),
        v("Tscr", "\uD835\uDCAF"),
        v("tscr", "\uD835\uDCC9"),
        v("TScy", "\u0426"),
        v("tscy", "\u0446"),
        v("TSHcy", "\u040B"),
        v("tshcy", "\u045B"),
        v("Tstrok", "\u0166"),
        v("tstrok", "\u0167"),
        v("twixt", "\u226C"),
        v("twoheadleftarrow", "\u219E"),
        v("twoheadrightarrow", "\u21A0"),
        v("Uacute", "\xda"),
        v("uacute", "\xfa"),
        v("uarr", "\u2191"),
        v("Uarr", "\u219F"),
        v("uArr", "\u21D1"),
        v("Uarrocir", "\u2949"),
        v("Ubrcy", "\u040E"),
        v("ubrcy", "\u045E"),
        v("Ubreve", "\u016C"),
        v("ubreve", "\u016D"),
        v("Ucirc", "\xdb"),
        v("ucirc", "\xfb"),
        v("Ucy", "\u0423"),
        v("ucy", "\u0443"),
        v("udarr", "\u21C5"),
        v("Udblac", "\u0170"),
        v("udblac", "\u0171"),
        v("udhar", "\u296E"),
        v("ufisht", "\u297E"),
        v("Ufr", "\uD835\uDD18"),
        v("ufr", "\uD835\uDD32"),
        v("Ugrave", "\xd9"),
        v("ugrave", "\xf9"),
        v("uHar", "\u2963"),
        v("uharl", "\u21BF"),
        v("uharr", "\u21BE"),
        v("uhblk", "\u2580"),
        v("ulcorn", "\u231C"),
        v("ulcorner", "\u231C"),
        v("ulcrop", "\u230F"),
        v("ultri", "\u25F8"),
        v("Umacr", "\u016A"),
        v("umacr", "\u016B"),
        v("uml", "\xa8"),
        v("UnderBar", "_"),
        v("UnderBrace", "\u23DF"),
        v("UnderBracket", "\u23B5"),
        v("UnderParenthesis", "\u23DD"),
        v("Union", "\u22C3"),
        v("UnionPlus", "\u228E"),
        v("Uogon", "\u0172"),
        v("uogon", "\u0173"),
        v("Uopf", "\uD835\uDD4C"),
        v("uopf", "\uD835\uDD66"),
        v("UpArrowBar", "\u2912"),
        v("uparrow", "\u2191"),
        v("UpArrow", "\u2191"),
        v("Uparrow", "\u21D1"),
        v("UpArrowDownArrow", "\u21C5"),
        v("updownarrow", "\u2195"),
        v("UpDownArrow", "\u2195"),
        v("Updownarrow", "\u21D5"),
        v("UpEquilibrium", "\u296E"),
        v("upharpoonleft", "\u21BF"),
        v("upharpoonright", "\u21BE"),
        v("uplus", "\u228E"),
        v("UpperLeftArrow", "\u2196"),
        v("UpperRightArrow", "\u2197"),
        v("upsi", "\u03C5"),
        v("Upsi", "\u03D2"),
        v("upsih", "\u03D2"),
        v("Upsilon", "\u03A5"),
        v("upsilon", "\u03C5"),
        v("UpTeeArrow", "\u21A5"),
        v("UpTee", "\u22A5"),
        v("upuparrows", "\u21C8"),
        v("urcorn", "\u231D"),
        v("urcorner", "\u231D"),
        v("urcrop", "\u230E"),
        v("Uring", "\u016E"),
        v("uring", "\u016F"),
        v("urtri", "\u25F9"),
        v("Uscr", "\uD835\uDCB0"),
        v("uscr", "\uD835\uDCCA"),
        v("utdot", "\u22F0"),
        v("Utilde", "\u0168"),
        v("utilde", "\u0169"),
        v("utri", "\u25B5"),
        v("utrif", "\u25B4"),
        v("uuarr", "\u21C8"),
        v("Uuml", "\xdc"),
        v("uuml", "\xfc"),
        v("uwangle", "\u29A7"),
        v("vangrt", "\u299C"),
        v("varepsilon", "\u03F5"),
        v("varkappa", "\u03F0"),
        v("varnothing", "\u2205"),
        v("varphi", "\u03D5"),
        v("varpi", "\u03D6"),
        v("varpropto", "\u221D"),
        v("varr", "\u2195"),
        v("vArr", "\u21D5"),
        v("varrho", "\u03F1"),
        v("varsigma", "\u03C2"),
        v("varsubsetneq", "\u228A\uFE00"),
        v("varsubsetneqq", "\u2ACB\uFE00"),
        v("varsupsetneq", "\u228B\uFE00"),
        v("varsupsetneqq", "\u2ACC\uFE00"),
        v("vartheta", "\u03D1"),
        v("vartriangleleft", "\u22B2"),
        v("vartriangleright", "\u22B3"),
        v("vBar", "\u2AE8"),
        v("Vbar", "\u2AEB"),
        v("vBarv", "\u2AE9"),
        v("Vcy", "\u0412"),
        v("vcy", "\u0432"),
        v("vdash", "\u22A2"),
        v("vDash", "\u22A8"),
        v("Vdash", "\u22A9"),
        v("VDash", "\u22AB"),
        v("Vdashl", "\u2AE6"),
        v("veebar", "\u22BB"),
        v("vee", "\u2228"),
        v("Vee", "\u22C1"),
        v("veeeq", "\u225A"),
        v("vellip", "\u22EE"),
        v("verbar", "|"),
        v("Verbar", "\u2016"),
        v("vert", "|"),
        v("Vert", "\u2016"),
        v("VerticalBar", "\u2223"),
        v("VerticalLine", "|"),
        v("VerticalSeparator", "\u2758"),
        v("VerticalTilde", "\u2240"),
        v("VeryThinSpace", "\u200A"),
        v("Vfr", "\uD835\uDD19"),
        v("vfr", "\uD835\uDD33"),
        v("vltri", "\u22B2"),
        v("vnsub", "\u2282\u20D2"),
        v("vnsup", "\u2283\u20D2"),
        v("Vopf", "\uD835\uDD4D"),
        v("vopf", "\uD835\uDD67"),
        v("vprop", "\u221D"),
        v("vrtri", "\u22B3"),
        v("Vscr", "\uD835\uDCB1"),
        v("vscr", "\uD835\uDCCB"),
        v("vsubnE", "\u2ACB\uFE00"),
        v("vsubne", "\u228A\uFE00"),
        v("vsupnE", "\u2ACC\uFE00"),
        v("vsupne", "\u228B\uFE00"),
        v("Vvdash", "\u22AA"),
        v("vzigzag", "\u299A"),
        v("Wcirc", "\u0174"),
        v("wcirc", "\u0175"),
        v("wedbar", "\u2A5F"),
        v("wedge", "\u2227"),
        v("Wedge", "\u22C0"),
        v("wedgeq", "\u2259"),
        v("weierp", "\u2118"),
        v("Wfr", "\uD835\uDD1A"),
        v("wfr", "\uD835\uDD34"),
        v("Wopf", "\uD835\uDD4E"),
        v("wopf", "\uD835\uDD68"),
        v("wp", "\u2118"),
        v("wr", "\u2240"),
        v("wreath", "\u2240"),
        v("Wscr", "\uD835\uDCB2"),
        v("wscr", "\uD835\uDCCC"),
        v("xcap", "\u22C2"),
        v("xcirc", "\u25EF"),
        v("xcup", "\u22C3"),
        v("xdtri", "\u25BD"),
        v("Xfr", "\uD835\uDD1B"),
        v("xfr", "\uD835\uDD35"),
        v("xharr", "\u27F7"),
        v("xhArr", "\u27FA"),
        v("Xi", "\u039E"),
        v("xi", "\u03BE"),
        v("xlarr", "\u27F5"),
        v("xlArr", "\u27F8"),
        v("xmap", "\u27FC"),
        v("xnis", "\u22FB"),
        v("xodot", "\u2A00"),
        v("Xopf", "\uD835\uDD4F"),
        v("xopf", "\uD835\uDD69"),
        v("xoplus", "\u2A01"),
        v("xotime", "\u2A02"),
        v("xrarr", "\u27F6"),
        v("xrArr", "\u27F9"),
        v("Xscr", "\uD835\uDCB3"),
        v("xscr", "\uD835\uDCCD"),
        v("xsqcup", "\u2A06"),
        v("xuplus", "\u2A04"),
        v("xutri", "\u25B3"),
        v("xvee", "\u22C1"),
        v("xwedge", "\u22C0"),
        v("Yacute", "\xdd"),
        v("yacute", "\xfd"),
        v("YAcy", "\u042F"),
        v("yacy", "\u044F"),
        v("Ycirc", "\u0176"),
        v("ycirc", "\u0177"),
        v("Ycy", "\u042B"),
        v("ycy", "\u044B"),
        v("yen", "\xa5"),
        v("Yfr", "\uD835\uDD1C"),
        v("yfr", "\uD835\uDD36"),
        v("YIcy", "\u0407"),
        v("yicy", "\u0457"),
        v("Yopf", "\uD835\uDD50"),
        v("yopf", "\uD835\uDD6A"),
        v("Yscr", "\uD835\uDCB4"),
        v("yscr", "\uD835\uDCCE"),
        v("YUcy", "\u042E"),
        v("yucy", "\u044E"),
        v("yuml", "\xff"),
        v("Yuml", "\u0178"),
        v("Zacute", "\u0179"),
        v("zacute", "\u017A"),
        v("Zcaron", "\u017D"),
        v("zcaron", "\u017E"),
        v("Zcy", "\u0417"),
        v("zcy", "\u0437"),
        v("Zdot", "\u017B"),
        v("zdot", "\u017C"),
        v("zeetrf", "\u2128"),
        v("ZeroWidthSpace", "\u200B"),
        v("Zeta", "\u0396"),
        v("zeta", "\u03B6"),
        v("zfr", "\uD835\uDD37"),
        v("Zfr", "\u2128"),
        v("ZHcy", "\u0416"),
        v("zhcy", "\u0436"),
        v("zigrarr", "\u21DD"),
        v("zopf", "\uD835\uDD6B"),
        v("Zopf", "\u2124"),
        v("Zscr", "\uD835\uDCB5"),
        v("zscr", "\uD835\uDCCF"),
        v("zwj", "\u200D"),
        v("zwnj", "\u200C")
    ])), xJ = A2(up, function(n) {
        return A2(xc, "&" + n + ";", A2(ra, n, wJ));
    }, Jm(oJ(xe))), _J = q, CJ = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return te(t);
            var e = r.a, u = r.b;
            switch(e){
                case "0":
                    n = a = n - 1, r = i = u, t = c = t;
                    continue n;
                case "1":
                    var a = n - 1, i = u, c = t + A2(_J, 16, n);
                    n = a, r = i, t = c;
                    continue n;
                case "2":
                    a = n - 1, i = u, c = t + 2 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "3":
                    a = n - 1, i = u, c = t + 3 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "4":
                    a = n - 1, i = u, c = t + 4 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "5":
                    a = n - 1, i = u, c = t + 5 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "6":
                    a = n - 1, i = u, c = t + 6 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "7":
                    a = n - 1, i = u, c = t + 7 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "8":
                    a = n - 1, i = u, c = t + 8 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "9":
                    a = n - 1, i = u, c = t + 9 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "a":
                    a = n - 1, i = u, c = t + 10 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "b":
                    a = n - 1, i = u, c = t + 11 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "c":
                    a = n - 1, i = u, c = t + 12 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "d":
                    a = n - 1, i = u, c = t + 13 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "e":
                    a = n - 1, i = u, c = t + 14 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                case "f":
                    a = n - 1, i = u, c = t + 15 * A2(_J, 16, n), n = a, r = i, t = c;
                    continue n;
                default:
                    return Yt(eb(e) + " is not a valid hexadecimal character.");
            }
        }
    }), AJ = A2(ym, function(n) {
        var r = function(n) {
            if (mu(n)) return Yt("Empty strings are not valid hexadecimal strings.");
            var r = function() {
                if (A2(xu, "-", n)) {
                    var r = A2(xc, g, zK(Wm(n)));
                    return A2(d$, bo, A3(CJ, ve(r) - 1, r, 0));
                }
                return A3(CJ, lu(n) - 1, Wm(n), 0);
            }();
            return A2(b$, function(r) {
                return A2(fe, " ", w([
                    '"' + n + '"',
                    "is not a valid hexadecimal string because",
                    r
                ]));
            }, r);
        }(sJ(n));
        return r.$ ? Um(r.a) : Am(r.a);
    }, Jm(oJ(function(n) {
        var r = he(n);
        return r >= 48 && 57 >= r || r >= 65 && 70 >= r || r >= 97 && 102 >= r;
    }))), kJ = {
        $: 1
    }, EJ = $t, qJ = gt, FJ = F2(function(n, r) {
        return {
            oL: r.oL + (n - r.iH),
            f: r.f,
            n: r.n,
            iH: n,
            xd: r.xd,
            d: r.d
        };
    }), jJ = pt, DJ = mt, VJ = F2(function(n, r) {
        if (A3(DJ, 101, n, r) || A3(DJ, 69, n, r)) {
            var t = n + 1, e = A3(DJ, 43, t, r) || A3(DJ, 45, t, r) ? t + 1 : t, u = A2(jJ, e, r);
            return i(e, u) ? -u : u;
        }
        return n;
    }), BJ = F2(function(n, r) {
        return A2(VJ, A3(DJ, 46, n, r) ? A2(jJ, n + 1, r) : n, r);
    }), GJ = F5(function(n, r, t, e, u) {
        var a = e.a, c = e.b;
        if (1 === r.$) return A2($m, !0, A2(Dm, u, r.a));
        var o = r.a;
        return i(t, a) ? A2($m, 0 > s(u.iH, t), A2(Dm, u, n)) : A3(gm, !0, o(c), A2(FJ, a, u));
    }), zJ = F6(function(n, r, t, e, u, a) {
        var c = u.a, o = A2(BJ, c, a.d);
        if (0 > o) return A2($m, !0, A4(vJ, a.xd, a.oL - (o + a.iH), n, a.f));
        if (i(a.iH, o)) return A2($m, !1, A2(Dm, a, r));
        if (i(c, o)) return A5(GJ, n, t, a.iH, u, a);
        if (1 === e.$) return A2($m, !0, A2(Dm, a, n));
        var f = e.a, s = VZ(A3(du, a.iH, o, a.d));
        return 1 === s.$ ? A2($m, !0, A2(Dm, a, n)) : A3(gm, !0, f(s.a), A2(FJ, o, a));
    }), SJ = A2(F2(function(n, r) {
        var t;
        return t = {
            nZ: Yt(r),
            rj: n,
            rD: Yt(r),
            sd: Yt(r),
            ss: te(cu),
            Cr: r,
            uP: Yt(r)
        }, function(n) {
            if (A3(DJ, 48, n.iH, n.d)) {
                var r = n.iH + 1, e = r + 1;
                return A3(DJ, 120, r, n.d) ? A5(GJ, t.Cr, t.sd, e, A2(qJ, e, n.d), n) : A3(DJ, 111, r, n.d) ? A5(GJ, t.Cr, t.uP, e, A3(EJ, 8, e, n.d), n) : A3(DJ, 98, r, n.d) ? A5(GJ, t.Cr, t.nZ, e, A3(EJ, 2, e, n.d), n) : A6(zJ, t.Cr, t.rj, t.ss, t.rD, v(r, 0), n);
            }
            return A6(zJ, t.Cr, t.rj, t.ss, t.rD, A3(EJ, 10, n.iH, n.d), n);
        };
    }), kJ, kJ), TJ = (wj = op(w([
        A2(Rm, A2(Cm, Am(cu), Mm(function(n) {
            return "x" === n || "X" === n;
        })), AJ),
        A2(Rm, A2(Cm, Am(cu), Im(Le("0"))), SJ)
    ])), A2(Rm, A2(Cm, Am(cu), Mm(Le("#"))), A2(up, A2(tu, FC, eb), wj))), PJ = A2(Rm, A2(Cm, Am(cu), Mm(Le("&"))), op(w([
        A2(Cm, DA(xJ), yJ),
        A2(Cm, DA(TJ), yJ),
        Am("&")
    ]))), ZJ = function(n) {
        return A2(Rm, A2(Cm, Am(cu), Mm(Le(n))), A2(Cm, A2(up, fe(""), gJ(op(w([
            Jm(oJ(function(r) {
                return !i(r, n) && "&" !== r;
            })),
            PJ
        ])))), Mm(Le(n))));
    }, MJ = F2(function(n, r) {
        return A2(MZ, g, function(t) {
            return op(w([
                A2(up, function(n) {
                    return SZ(A2(Qt, n, t));
                }, r),
                nE(t) ? Um("expecting at least one " + n) : Am(zZ(Ae(t)))
            ]));
        });
    }), LJ = A2(up, fe(""), A2(MJ, "attribute value", op(w([
        Jm(oJ(function(n) {
            return !fJ(n) && '"' !== n && "'" !== n && "=" !== n && "<" !== n && ">" !== n && "`" !== n && "&" !== n;
        })),
        PJ
    ])))), NJ = op(w([
        A2(Rm, A2(Cm, A2(Cm, Am(cu), Mm(Le("="))), Im(fJ)), op(w([
            LJ,
            ZJ('"'),
            ZJ("'")
        ]))),
        Am("")
    ])), HJ = A2(Rm, A2(Rm, Am(RC), A2(Cm, hJ, Im(fJ))), A2(Cm, NJ, Im(fJ))), IJ = gJ(HJ), OJ = A2(up, sJ, Jm(A2(Cm, Mm(Ce), Im(function(n) {
        return Ce(n) || "-" === n;
    })))), QJ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, RJ = A2(up, A2(tu, fe(""), QJ), A2(MJ, "text element", op(w([
        Jm(oJ(function(n) {
            return "<" !== n && "&" !== n;
        })),
        PJ
    ]))));
    function UJ() {
        return op(w([
            RJ,
            pJ,
            KJ()
        ]));
    }
    function KJ() {
        return A2(ym, function(n) {
            var r = n.a, t = n.b;
            return function(n) {
                return A2(Xk, n, $J);
            }(r) ? A2(Cm, A2(Cm, Am(A3(cJ, r, t, g)), op(w([
                Mm(Le("/")),
                Am(0)
            ]))), Mm(Le(">"))) : A2(Rm, A2(Cm, Am(A2(cJ, r, t)), Mm(Le(">"))), A2(Cm, gJ(DA(UJ())), function(n) {
                var r = A2(ym, function(r) {
                    return i(sJ(r), n) ? Am(0) : Um("closing tag does not match opening tag: " + n);
                }, Jm(oJ(function(n) {
                    return !fJ(n) && ">" !== n;
                })));
                return A2(Cm, A2(Cm, A2(Cm, A2(Cm, Mm(Le("<")), Mm(Le("/"))), r), Im(fJ)), Mm(Le(">")));
            }(r)));
        }, A2(Rm, A2(Rm, A2(Cm, Am(RC), Mm(Le("<"))), A2(Cm, OJ, Im(fJ))), IJ));
    }
    var WJ = UJ();
    UJ = function() {
        return WJ;
    };
    var XJ = KJ();
    KJ = function() {
        return XJ;
    };
    var YJ, JJ, n0 = function(n) {
        return mu(n) ? te(g) : A2($p, A2(MJ, "node", WJ), n);
    }, r0 = function(n) {
        return cr(gr(n));
    }, t0 = function(n) {
        return A2(lF, n.a, n.b);
    }, e0 = function(n) {
        return A2(Fu, u0, n);
    }, u0 = function(n) {
        switch(n.$){
            case 1:
                var r = n.c;
                return A3(r0, n.a, A2(Fu, t0, n.b), e0(r));
            case 0:
                return _d(n.a);
            default:
                return _d("");
        }
    }, a0 = function(n) {
        var r = n0(n);
        return r.$ ? g : e0(r.a);
    }, i0 = function(n) {
        var r = v(dU(n), function(n) {
            return n.rk;
        }(n));
        if (1 !== r.a || r.b.$) return vE;
        var t = r.b.a;
        return A2(PE, w([
            VG,
            nF,
            zX,
            Hx(w([
                Gx("block mt-1")
            ]))
        ]), w([
            _d(t)
        ]));
    }, c0 = function(n) {
        return n.p3;
    }, o0 = function(n) {
        switch(n){
            case 1:
                return It(0);
            case 3:
                return It(1);
            case 6:
                return It(2);
            case 12:
                return It(3);
            default:
                return Ot;
        }
    }, f0 = F2(function(n, r) {
        return A2(xc, n(nW), A2(Op, eW(n), A2(bb, o0, r)));
    }), s0 = F2(function(n, r) {
        var t = aJ(r);
        if (t.$) return w([
            _d(n(mX.AN))
        ]);
        var e = A3(IK, !1, !0, t.a);
        return w(dU(r) ? [
            _d(e)
        ] : [
            _d(e),
            A2(PE, w([
                VG
            ]), w([
                _d(A2(f0, n, c0(r)))
            ]))
        ]);
    }), l0 = F2(function(n, r) {
        var t = aJ(r).$ ? VG : Qx;
        return w([
            A2(zx, w([
                Gx("mb-4 relative")
            ]), w([
                function() {
                    var n = function(n) {
                        return n.pv;
                    }(r);
                    return n.$ ? vE : A2(uJ, w([
                        iJ(n.a),
                        tJ(""),
                        Gx("w-full h-48 object-cover rounded")
                    ]), g);
                }()
            ])),
            function() {
                var n = oU(r);
                if (n.$) return vE;
                var t = n.a;
                return A2(xX, w([
                    Hx(w([
                        Gx("block text-current")
                    ]))
                ]), w([
                    _d(t)
                ]));
            }(),
            A2(PE, w([
                t,
                tY,
                zX,
                Hx(w([
                    Gx("block mt-1")
                ]))
            ]), A2(s0, n, r)),
            i0(r),
            function() {
                var n = eJ(r);
                if (n.$) return vE;
                var t = n.a;
                return A2(zx, w([
                    Gx("mt-2 text-sm rich-text")
                ]), A2(Fu, c_(Cu), a0(t)));
            }()
        ]);
    }), d0 = {
        $: 13
    }, v0 = F2(function(n, r) {
        return A2(yF, w([
            WX,
            cF(n)
        ]), w([
            A2(c_, Cu, A2(Tq, w([
                zE
            ]), 6)),
            _d(r)
        ]));
    }), b0 = function(n) {
        var r = A2(bb, oU, n);
        return r.$ ? g : w([
            A2(v0, d0, r.a)
        ]);
    }, m0 = {
        $: 4
    }, p0 = function(n) {
        return A2(yF, w([
            fF,
            iK,
            cF(m0)
        ]), w([
            _d(n.yg)
        ]));
    }, $0 = F3(function(n, r, t) {
        var e;
        return t.bR ? vE : A3(sD, t, r, (e = DD(n), mu(e) ? Ot : It(e)));
    }), g0 = F2(function(n, r) {
        if ($X(r.R)) {
            var t = A2(pX, n, r);
            return A3($0, "modal__content--configure-item", w([
                Hj(b0(FR(r.R))),
                Mj(A2(Fu, c_(MO), A2(rJ, t, r.R))),
                Nj(w([
                    A2(c_, MO, p0(t))
                ]))
            ]), r.fq);
        }
        var e = v(r.cl, r.b3);
        if (e.a.$ || e.b.$) return vE;
        var u = e.b.a;
        return A3($0, "modal__content--configure-item modal__content--detail", w([
            bX,
            Mj(A2(l0, n, e.a.a)),
            Nj(w([
                A2(yF, w([
                    fF,
                    iK,
                    cF(zW(u))
                ]), w([
                    _d(n(mX.qK))
                ]))
            ]))
        ]), r.fq);
    }), h0 = function(n) {
        return A2(zx, w([
            Gx("flex flex-col items-center justify-center flex-1 gap-6 px-8 py-16")
        ]), w([
            A2(c_, Cu, A2(Tq, w([
                Wj("size-18 text-text-secondary")
            ]), 40)),
            A2(zx, w([
                Gx("flex flex-col items-center gap-2 text-center")
            ]), w([
                A2(f_, w([
                    uF(xD),
                    Hx(w([
                        Gx("text-lg leading-6 text-primary-600")
                    ]))
                ]), w([
                    _d(n(AR))
                ])),
                A2(f_, w([
                    uF(xD),
                    nF
                ]), w([
                    _d(n(CR))
                ]))
            ])),
            A2(yF, w([
                fF,
                cF(nK),
                Kj(w([
                    Gx("cart-empty-cta")
                ]))
            ]), w([
                _d(n(kR))
            ]))
        ]));
    }, y0 = F2(function(n, r) {
        return {
            g8: w([
                vX(A2(Qt, tK(n), nE(r.Z) ? w([
                    h0(n)
                ]) : A2(dX, n, r))),
                A2(g0, n, r)
            ]),
            yx: n(ER)
        };
    }), w0 = C_({
        Cl: lR,
        CQ: dR,
        Fj: vR,
        F4: function(n) {
            return vx(w([
                A2(kj, mR, qj()),
                Aj(n.fq),
                n.u3.$ ? bx : vx(w([
                    hR(bR),
                    $R(bR)
                ]))
            ]));
        },
        Gv: JU,
        GB: y0
    }), x0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _0 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, C0 = function(n) {
        return {
            $: 15,
            a: n
        };
    }, A0 = function(n) {
        return m(n, {
            h5: !0
        });
    }, k0 = {
        $: 0
    }, E0 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, q0 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), F0 = A2(q0, 1, g), j0 = F3(function(n, r, t) {
        return v({
            g0: r,
            hz: Ot,
            hC: Ot,
            ay: k0,
            aa: F0,
            h5: !1,
            sG: n,
            iE: !1,
            i4: pa,
            EH: t,
            jh: !1,
            yx: Ot
        }, A2(Nu, E0, Jz));
    }), D0 = function(n) {
        return n.a.sl;
    }, V0 = function(n) {
        return n.nI;
    }, B0 = function(n) {
        return n.hg;
    }, G0 = F2(function(n, r) {
        return A2(xc, "", A2(Op, function(r) {
            var t = r.b;
            return A2(tb, n(r.a), t);
        }, ke(r)));
    }), z0 = function(n) {
        return n.toUpperCase();
    }, S0 = function(n) {
        return A2(G0, z0, n);
    }, T0 = F2(function(n, r) {
        var t = r;
        if (t.$) {
            var e = t.a;
            return A2(xc, n(V0), e.nJ) + " * " + A2(xc, "", e.io);
        }
        var u = t.a;
        return S0(A2(xc, n(B0), u.oh)) + " *" + A2(xc, "", u.io);
    }), P0 = function(n) {
        return n.a.hI;
    }, Z0 = function(n) {
        return n.fo.hI;
    }, M0 = function(n) {
        return n.fo.sT;
    }, L0 = function(n) {
        return n.fo.kt;
    }, N0 = function(n) {
        return n.fo.yY;
    }, H0 = F2(function(n, r) {
        if (r.$) return A2(Mx, w([
            Gx("inline-block my-1")
        ]), w([
            _d(n(Av))
        ]));
        var t = r.a;
        return A2(Mx, g, w([
            _d(A2(T0, n, t)),
            P0(t) ? A2(Zq, w([
                1
            ]), w([
                _d(n(Z0))
            ])) : _d("")
        ]));
    }), I0 = function(n) {
        return uQ({
            sl: n,
            Gj: H0,
            Gk: function(n) {
                return n.$ ? Ot : It(D0(n.a));
            }
        });
    }, O0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Q0 = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            nJ: t,
            AT: i,
            hI: c,
            ri: r,
            sl: n,
            io: e,
            dT: o,
            FT: a,
            mt: u
        };
    }), R0 = function(n) {
        switch(n){
            case "processing":
                return au(0);
            case "invalid":
                return au(1);
            case "new_payment_source":
                return au(2);
            case "confirmed":
                return au(3);
            case "expiring":
                return au(4);
            case "warning":
                return au(5);
            case "failed":
                return au(6);
            case "blocked":
                return au(7);
            default:
                return AA("Unsupported Payment Method status: " + n);
        }
    }, U0 = A4(JA, "one_time_use", uC(ru), Ot, A3(nk, "default", ru, A3(nk, "created_at", XZ, A3(nk, "type", M$, A3(nk, "status", A2(nu, R0, M$), A3(nk, "last_four", uC(M$), A3(nk, "bank_name", uC(M$), A3(nk, "expected_to_succeed", ru, A3(nk, "id", M$, au(Q0)))))))))), K0 = A2($A, A2(eu, O0, U0), au(cu)), W0 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, X0 = A4(JA, "one_time_use", uC(ru), Ot, A3(nk, "funding", uC(M$), A3(nk, "zip", uC(M$), A3(nk, "default", ru, A3(nk, "exp_year", uC(O$), A3(nk, "exp_month", uC(O$), A3(nk, "created_at", XZ, A3(nk, "type", M$, A3(nk, "status", A2(nu, R0, M$), A3(nk, "last_four", uC(M$), A3(nk, "card_type", uC(M$), A3(nk, "expected_to_succeed", ru, A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            oh: t,
                                                            AT: i,
                                                            hI: f,
                                                            hT: c,
                                                            hU: o,
                                                            ri: r,
                                                            rS: l,
                                                            sl: n,
                                                            io: e,
                                                            dT: d,
                                                            FT: a,
                                                            mt: u,
                                                            zF: s
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), Y0 = A2($A, A2(eu, W0, X0), au(cu)), J0 = Q$(w([
        Y0,
        K0
    ])), n1 = function(n) {
        return A2(bk, w([
            "payment_sources"
        ]), fM(n));
    }, r1 = F3(function(n, r, t) {
        return A4(aA, n, ek(J0), t, pk(n1(r)));
    }), t1 = F2(function(n, r) {
        return {
            $: 13,
            a: n,
            b: r
        };
    }), e1 = function(n) {
        return {
            $: 14,
            a: n
        };
    }, u1 = A2(zB, 0, A2($A, iM, au(DZ))), a1 = F3(function(n, r, t) {
        return A4(aA, n, ek(u1), t, pk(sM(r)));
    }), i1 = F3(function(n, r, t) {
        return nE(r) ? t : $(t, w([
            A2(g_, n, A2(fe, ",", r))
        ]));
    }), c1 = F3(function(n, r, t) {
        return r.$ ? t : $(t, w([
            A2(g_, n, r.a)
        ]));
    }), o1 = F3(function(n, r, t) {
        return A3(i1, "locations", t, A3(c1, "plan_id", r, w([
            A2(g_, "owner_id", n)
        ])));
    }), f1 = F7(function(n, r, t, e, u, a, i) {
        return {
            mH: r,
            mI: t,
            pK: e,
            sl: n,
            ur: u,
            vn: a,
            wZ: i
        };
    }), s1 = F2(function(n, r) {
        return {
            sl: n,
            ur: r
        };
    }), l1 = A3(nk, "name", A2(eu, GV, M$), A3(nk, "id", M$, au(s1))), d1 = A2($A, l1, au(cu)), v1 = A3(nk, "required", ru, A3(nk, "patient", d1, A3(nk, "name", M$, A3(nk, "current_document_version", aM, A3(nk, "acceptance_type", A2(nu, JZ, M$), A3(nk, "acceptance_text", M$, A3(nk, "id", M$, au(f1)))))))), b1 = A2($A, v1, au(cu)), m1 = F4(function(n, r, t, e) {
        return A4(aA, n, ek(b1), e, A2($k, t, pk(function(n) {
            return A2(bk, w([
                "documents"
            ]), fM(n));
        }(r))));
    }), p1 = F7(function(n, r, t, e, u, a, i) {
        var c = a ? A3(c1, "only_signup", It("true"), A3(o1, e, t, u)) : A3(o1, e, t, u);
        return A4(m1, n, r, c, i);
    }), $1 = function(n) {
        var r = A2(no, function(n) {
            return !YK(n);
        }, n.Z), t = b(n.hM, n.fy, r);
        if (t.a || t.b.$ || !t.c.b) return v(n, Qp);
        var e = t.b.a, u = ux(n.dV), a = A2(Fu, function(r) {
            return A7(p1, n.g0, u, It(ZR(r)), e, g, !0, t1(ZR(r)));
        }, r), i = ed(A2(Fu, function(n) {
            return v(ZR(n), A_);
        }, r));
        return v(m(n, {
            cM: i,
            hM: !0,
            fx: A_
        }), Uu(A2(Qt, A3(a1, n.g0, u, e1), a)));
    }, g1 = function(n) {
        return n.fA.Ds;
    }, h1 = function(n) {
        return n.fA.uR;
    }, y1 = function(n) {
        return n.fA.Dt;
    }, w1 = function(n) {
        return n.fA.i_;
    }, x1 = F2(function(n, r) {
        return m(r, {
            hC: It(n),
            jh: !0
        });
    }), _1 = F3(function(n, r) {
        var t = ux(n), e = A2(lx, A0, A2(lx, x1(y1), A3(j0, !0, r.g0, t))), u = e.a, a = e.b, i = {
            g0: r.g0,
            bT: !1,
            Z: r.Z,
            os: r.os,
            bn: !1,
            cM: pa,
            hM: !1,
            k7: !1,
            rh: OG,
            ld: r.ld,
            bG: kc,
            aq: Ot,
            fw: kc,
            fx: kc,
            fy: UQ(r),
            lV: I0("confirm-pay-payment-source-select"),
            lW: A_,
            as: u,
            dV: n,
            mi: Ot,
            dc: !1,
            Gl: hk(A2(Ep, r.f9, r.bp)),
            Go: OO
        }, c = $1(i), o = c.b;
        return v(c.a, Uu(w([
            A3(sR, r.g0, t, x0),
            A3(r1, r.g0, t, _0),
            A2(Wp, C0, a),
            o
        ])));
    }), C1 = F2(function(n, r) {
        return $1(m(r, {
            Z: n.Z,
            fy: UQ(n)
        }));
    }), A1 = F2(function(n, r) {
        return m(r, {
            zK: Ot
        });
    }), k1 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, E1 = nr("stripePortOnSetupIntentChange", M$), q1 = F3(function(n, r, t) {
        return {
            rc: t,
            cg: r,
            f$: n
        };
    }), F1 = F2(function(n, r) {
        return {
            hg: r,
            sl: n
        };
    }), j1 = F4(function(n, r, t, e) {
        return {
            oh: r,
            hT: t,
            hU: e,
            io: n
        };
    }), D1 = A3(nk, "exp_year", O$, A3(nk, "exp_month", O$, A3(nk, "brand", M$, A3(nk, "last4", M$, au(j1))))), V1 = A4(JA, "card", ik(D1), Ot, A3(nk, "payment_method", M$, au(F1))), B1 = A3(nk, "error", uC(M$), A3(nk, "setup_intent", ik(V1), A3(nk, "selector", M$, au(q1)))), G1 = F2(function(n, r) {
        var t = A2(WA, B1, r);
        if (t.$) return n(Yt(H_(t.a)));
        var e = t.a, u = e.cg;
        if (1 === u.$) {
            var a = e.rc;
            return n(Yt(1 === a.$ ? "" : a.a));
        }
        return n(te(u.a));
    }), z1 = nr("stripePortOnSetupIntentConfirmed", G$), S1 = vx(w([
        (JJ = function(n) {
            return {
                $: 1,
                a: n
            };
        }, z1(G1(JJ))),
        (YJ = function(n) {
            return {
                $: 2,
                a: n
            };
        }, E1(YJ))
    ])), T1 = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), P1 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Z1 = A2(nu, function(n) {
        return "Enter" === n || "Escape" === n ? au(uj(n)) : AA("nothing");
    }, A2(Iu, "key", M$)), M1 = function(n) {
        return A2(eu, n, Z1);
    }, L1 = function(n) {
        var r = n.ay;
        if (r.$) {
            var t = r.b;
            return vx(w([
                Cj(M1(T1(v(t.a, t.b)))),
                A2(kj, P1, qj())
            ]));
        }
        return bx;
    }, N1 = function(n) {
        return {
            $: 12,
            a: n
        };
    }, H1 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, I1 = F2(function(n, r) {
        return r.ol(n);
    }), O1 = F4(function(n, r, t, e) {
        return {
            rc: e,
            sl: n,
            CI: r,
            mt: t
        };
    }), Q1 = A4(JA, "error", A2(eu, It, M$), Ot, A3(nk, "status", M$, A3(nk, "type", M$, A3(nk, "id", M$, au(O1))))), R1 = A4(JA, "results", ek(Q1), g, au(function(n) {
        return {
            md: n
        };
    })), U1 = F4(function(n, r, t, e) {
        return A4(lM, n, R1, e, A2(dM, t, pk(A2(bk, w([
            "cart",
            "checkout"
        ]), fM(r)))));
    }), K1 = function(n) {
        if (n.$) {
            var r = n.a;
            return rx(w([
                v("id", tx(r.sl)),
                v("type", tx("plan")),
                v("owner", tx(r.iO)),
                v("membership_patients", A2(WU, KU, r.tL)),
                v("period_in_months", NQ(r.vN)),
                v("start_date", tx(r.x0)),
                v("accepted_documents", r.kz)
            ]));
        }
        var t = n.a;
        return rx(w([
            v("id", tx(t.sl)),
            v("type", tx("package")),
            v("owner", tx(t.iO))
        ]));
    }, W1 = F4(function(n, r, t, e) {
        var u = rx(w([
            v("cart", A2(WU, K1, t.sO)),
            v("payment_method", tx(t.Ex))
        ]));
        return A4(U1, n, r, u, e);
    }), X1 = function(n) {
        return A2(Wk, function(n) {
            return "ok" !== n.mt;
        }, n.md);
    }, Y1 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, J1 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, n2 = function(n) {
        return n.vN;
    }, r2 = F2(function(n, r) {
        if (1 === YK(r)) return Y1({
            sl: ZR(r),
            iO: A2(xc, n.fy, GR(r))
        });
        var t, e = (t = TR(r)).b ? t : w([
            {
                fy: n.fy,
                EJ: Ot
            }
        ]), u = A2(xc, n.fy, A2(Op, function(n) {
            return n.fy;
        }, mb(e)));
        return J1({
            kz: n.kz,
            sl: ZR(r),
            tL: e,
            iO: u,
            vN: A2(xc, 1, n2(r)),
            x0: A2(xc, n.Gl, MR(r))
        });
    }), t2 = F5(function(n, r, t, e, u) {
        return rx(w([
            v(n.$ ? "rainforest_id" : "stripe_id", tx(n.a)),
            v("shared", Yw(!0)),
            v("one_time_use", Yw(r)),
            v("replaces_payment_method_id", A2(wM, tx, e)),
            v("process_outstanding", Yw(t)),
            v("set_as_default", Yw(u))
        ]));
    }), e2 = A2(bk, w([
        "payment_methods"
    ]), oM), u2 = F4(function(n, r, t, e) {
        var u = rx(w([
            v("payment_method", A5(t2, r, t.dT, t.wi, t.wW, t.xq))
        ]));
        return A4(lM, n, J0, e, A2(dM, u, pk(e2)));
    }), a2 = function(n) {
        return A2(FE, mb(n), mb(A2(no, P0, n)));
    }, i2 = function(n) {
        return n.aP.qp;
    }, c2 = function(n) {
        return n.zd;
    }, o2 = F2(function(n, r) {
        var t = r.aP.eV, e = FM(r.le), u = w([
            v("signature", tx(e.ec)),
            v("version_number", NQ(c2(t)))
        ]);
        return rx(n ? A2(Qt, v("id", tx(i2(r))), u) : u);
    }), f2 = F2(function(n, r) {
        return A2(WU, n, r.b);
    }), s2 = F2(function(n, r) {
        return A2(q0, r.a, A2(no, n, r.b));
    }), l2 = function(n) {
        return 1 === n.$7;
    }, d2 = function(n) {
        return A2(f2, function(n) {
            return A2(o2, !0, n.b);
        }, A2(s2, function(n) {
            return l2(n.b);
        }, n.aa));
    }, v2 = function(n) {
        return A2(no, function(n) {
            return "ok" !== n.mt;
        }, n.md);
    }, b2 = F2(function(n, r) {
        var t = A2(xc, r.sl, A2(Op, uW, mb(A2(no, function(n) {
            return i(ZR(n), r.sl) && i(1 === YK(n) ? "package" : "plan", r.CI);
        }, n)))), e = r.rc;
        return e.$ ? t : t + " (" + e.a + ")";
    }), m2 = F2(function(n, r) {
        return A2(fe, ", ", A2(Fu, b2(r), v2(n)));
    }), p2 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, $2 = F2(function(n, r) {
        return A2(bk, w([
            "payment_methods",
            r,
            "cart_passthrough"
        ]), fM(n));
    }), g2 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), h2 = F2(function(n, r) {
        return {
            vi: n,
            mz: r
        };
    }), y2 = A3(nk, "total_in_cents", O$, A3(nk, "passthrough_fees_in_cents", O$, au(h2))), w2 = A2($A, y2, au(cu)), x2 = au({}), _2 = A2($A, x2, A2($A, w2, au(g2))), C2 = F4(function(n, r, t, e) {
        return A4(aA, n, _2, e, pk(A2($2, r, t)));
    }), k2 = function(n) {
        return !n.$;
    }, E2 = A2(tu, Op(k2), xc(!1)), q2 = F2(function(n, r) {
        return n && E2(r);
    }), j2 = function(n) {
        return function(n) {
            var r = n.g0, t = n.EH, e = n.xT, u = n.yC;
            if (A2(q2, n.os, e)) {
                var a = A2(Op, D0, e);
                return a.$ ? Qp : A4(C2, r, t, a.a, u);
            }
            return Qp;
        }({
            g0: n.g0,
            os: n.os,
            EH: ux(n.dV),
            xT: n.mi,
            yC: p2
        });
    }, D2 = {
        $: 0
    }, V2 = A2(Nu, cu, Au(D2)), B2 = function(n) {
        return A2(Wk, function(n) {
            return !YK(n);
        }, n);
    }, G2 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, z2 = {
        $: 0
    }, S2 = {
        hh: ""
    }, T2 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, P2 = F3(function(n, r, t) {
        return {
            zX: t,
            Ew: r,
            Fy: n
        };
    }), Z2 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, M2 = Q$(w([
        A2(nu, function(n) {
            switch(n){
                case "stripe":
                    return A2(eu, Z2, A2(M_, w([
                        "stripe_client_secret"
                    ]), M$));
                case "rainforest":
                    return A2(eu, T2, A4(JQ, P2, A2(M_, w([
                        "session_key"
                    ]), M$), A2(M_, w([
                        "payment_method_config_id"
                    ]), M$), A2(M_, w([
                        "allowed_methods"
                    ]), M$)));
                default:
                    return AA("Unsupported processor " + n);
            }
        }, A2(M_, w([
            "payment_processor"
        ]), M$)),
        A2(eu, Z2, A2(M_, w([
            "stripe_client_secret"
        ]), M$))
    ])), L2 = F3(function(n, r, t) {
        return A4(lM, n, M2, t, pk(A2(bk, w([
            "setup"
        ]), function(n) {
            return A2(bk, w([
                "payment_methods"
            ]), fM(n));
        }(r))));
    }), N2 = F6(function(n, r, t, e, u, a) {
        var i = A3(L2, a, ux(t), G2);
        return v({
            cE: !1,
            os: e,
            lb: u,
            ld: r,
            le: vZ(S2),
            sG: n,
            dV: t,
            v: z2,
            d7: 1,
            ky: !1
        }, i);
    }), H2 = function(n) {
        return 1 === n.$7 || !n.aP.e7;
    }, I2 = function(n) {
        return ve(n.b);
    }, O2 = function(n) {
        return !I2(A2(s2, function(n) {
            return !H2(n.b);
        }, n.aa));
    }, Q2 = function(n) {
        var r = n.a;
        return !!r.mR && !!r.mt;
    }, R2 = function(n) {
        return A2(no, Q2, n);
    }, U2 = F2(function(n, r) {
        return A2(Wk, function(n) {
            return !i(It(n), r);
        }, A2(bc, BR, A2(no, function(n) {
            return !YK(n);
        }, n)));
    }), K2 = function(n) {
        return n.a.qp;
    }, W2 = function(n) {
        return n.sl;
    }, X2 = function(n) {
        return n.a.mt;
    }, Y2 = F2(function(n, r) {
        var t = r.a;
        return A2(q0, t + 1, $(r.b, w([
            v(t, n)
        ])));
    }), J2 = function(n) {
        return A3(de, F2(function(n, r) {
            return A2(Y2, n, r);
        }), F0, n);
    }, n3 = function(n) {
        return n.a.mH;
    }, r3 = function(n) {
        return n.a.mI;
    }, t3 = function(n) {
        return n.a.pK;
    }, e3 = function(n) {
        return {
            mI: n.mI,
            lT: n.lT,
            ec: ""
        };
    }, u3 = F3(function(n, r, t) {
        return {
            $7: 0,
            g0: n,
            br: Ot,
            aP: t,
            cL: Ot,
            le: vZ(e3(t)),
            fa: Ot,
            EH: r
        };
    }), a3 = function(n) {
        return n.a.wZ;
    }, i3 = function(n) {
        return n.a.ur;
    }, c3 = function(n) {
        return function(n) {
            return n.ur;
        }(n.a.xN);
    }, o3 = F3(function(n, r, t) {
        var e = {
            mH: n3(t),
            mI: r3(t),
            qp: K2(t),
            eV: t3(t),
            e7: a3(t),
            ur: i3(t),
            lT: c3(t)
        };
        return A3(u3, n, r, e);
    }), f3 = function(n) {
        return n.mH;
    }, s3 = function(n) {
        return n.mI;
    }, l3 = function(n) {
        return n.pK;
    }, d3 = function(n) {
        return n.ur;
    }, v3 = function(n) {
        return n.ur;
    }, b3 = function(n) {
        return n.wZ;
    }, m3 = F3(function(n, r, t) {
        var e = d3(function(n) {
            return n.vn;
        }(t)), u = {
            mH: f3(t),
            mI: s3(t),
            qp: W2(t),
            eV: l3(t),
            e7: b3(t),
            ur: v3(t),
            lT: e
        };
        return A3(u3, n, r, u);
    }), p3 = F3(function(n, r, t) {
        var e = A2(Fu, A2(m3, t.g0, t.EH), n), u = A2(Fu, i2, e);
        return m(t, {
            aa: J2($(e, A2(no, function(n) {
                return !A2(Xk, i2(n), u);
            }, A2(Fu, A2(o3, t.g0, t.EH), r))))
        });
    }), $3 = F2(function(n, r) {
        return m(r, {
            i4: n
        });
    }), g3 = F5(function(n, r, t, e, u) {
        var a = 3 === e.$ ? R2(e.a) : g, c = ed(A2(Fu, function(n) {
            return v(ZR(n), uW(n));
        }, A2(no, function(n) {
            return !YK(n);
        }, n))), o = A2(bc, function(n) {
            var r = n.b;
            if (3 === r.$) {
                var t = r.a, e = A2(xc, "", A2(ra, n.a, c));
                return A2(Fu, function(n) {
                    return v(n, e);
                }, t);
            }
            return g;
        }, Ut(t)), f = A3(de, F2(function(n, r) {
            var t = n.b, e = W2(n.a), u = A2(xc, g, A2(ra, e, r));
            return mu(t) || A2(Xk, t, u) ? r : A3(ia, e, $(u, w([
                t
            ])), r);
        }), pa, o), s = A3(de, F2(function(n, r) {
            var t = n.a;
            return A2(Wk, function(n) {
                return i(W2(n), W2(t));
            }, r) ? r : $(r, w([
                t
            ]));
        }), g, o), l = 3 === e.$ ? OR(A2(Fu, K2, A2(no, function(n) {
            return !X2(n);
        }, e.a))) : OG, d = function() {
            switch(e.$){
                case 3:
                    return A2(U2, n, r) ? s : A2(no, function(n) {
                        return !A2(UG, W2(n), l);
                    }, s);
                case 2:
                    return s;
                default:
                    return g;
            }
        }();
        return A2($3, f, A3(p3, d, a, u));
    }), h3 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, y3 = {
        $: 3
    }, w3 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, x3 = {
        $: 2
    }, _3 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, C3 = {
        $: 0
    }, k3 = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), E3 = function(n) {
        return b(n, Qp, Ot);
    }, q3 = F8(function(n, r, t, e, u, a, i, c) {
        return {
            oe: e,
            of: t,
            og: r,
            s9: c,
            lN: a,
            v1: u,
            f$: n,
            xr: i
        };
    }), j3 = Xn("stripePortBuildAndMountElementWithSetupIntent", function(n) {
        return rx(w([
            v("cardCvcSelector", tx(n.oe)),
            v("cardExpirySelector", tx(n.of)),
            v("cardNumberSelector", tx(n.og)),
            v("locale", tx(n.s9)),
            v("options", function(n) {
                return rx(w([
                    v("encourageAch", Yw(n.qX)),
                    v("rejectAmex", Yw(n.ma))
                ]));
            }(n.lN)),
            v("postalCodeSelector", tx(n.v1)),
            v("selector", tx(n.f$)),
            v("setupIntentSecret", tx(n.xr))
        ]));
    }), D3 = F9(function(n, r, t, e, u, a, i, c, o) {
        var f = A8(q3, r, t, e, u, a, {
            qX: c,
            ma: i
        }, o, nb(n));
        return j3(f);
    }), V3 = "card-element", B3 = F4(function(n, r, t, e) {
        return A9(D3, n, "#" + V3, "#card-number", "#card-expiry", "#card-cvc", "#postal-code", r, t, e);
    }), G3 = Xn("stripePortConfirmSetupIntent", function(n) {
        return rx(w([
            v("options", function(n) {
                return rx(w([
                    v("billingOptions", function(n) {
                        return A3(Jw, nx, function(n) {
                            return rx(w([
                                v("name", tx(n.ur))
                            ]));
                        }, n);
                    }(n.Af))
                ]));
            }(n.lN)),
            v("selector", tx(n.f$))
        ]));
    }), z3 = F2(function(n, r) {
        return G3({
            lN: r,
            f$: n
        });
    }), S3 = Xn("rainforestSubmitPaymentMethod", function() {
        return nx;
    }), T3 = S3(0), P3 = function(n) {
        return n.b.qX;
    }, Z3 = function(n) {
        return n.c2.zY;
    }, M3 = function(n) {
        return n.c2.rT;
    }, L3 = function(n) {
        return n.c2.sT;
    }, N3 = function(n) {
        return n.c2.Fd;
    }, H3 = function(n) {
        return n.c2.Fj;
    }, I3 = F3(function(n, r, t) {
        var e = b(n, r, t.hh);
        return 2 === e.a.$ && e.b && "AMERICAN_EXPRESS" === e.c ? w([
            v(0, fL(Z3))
        ]) : g;
    }), O3 = F2(function(n) {
        return 2 === n.$ ? n.a.e8 ? g : w([
            v(0, fL(N3))
        ]) : g;
    }), Q3 = F2(function(n, r) {
        return XM(w([
            A2(I3, n, r),
            O3(n)
        ]));
    }), R3 = function(n) {
        return !function(n) {
            return n.b.mK;
        }(n);
    }, U3 = function(n) {
        return n.yd;
    }, K3 = F2(function(n, r) {
        return m(r, {
            hh: n
        });
    }), W3 = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                var e = It(w3({
                    $: 1,
                    a: n.a
                }));
                return b(t, Qp, e);
            case 1:
                return b(m(t, {
                    v: _3(m(r, {
                        e8: n.a
                    }))
                }), Qp, Ot);
            case 2:
                return b(m(t, {
                    v: _3(m(r, {
                        CC: !1
                    }))
                }), Qp, Ot);
            case 3:
                return b(m(t, {
                    d7: "ACH" === n.a ? 0 : 1
                }), Qp, Ot);
            default:
                return b(m(t, {
                    le: A3(cN, K3, n.a, t.le)
                }), Qp, Ot);
        }
    }), X3 = F2(function(n, r) {
        switch(n.$){
            case 3:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = e.$ ? _3({
                        zX: e.a.zX,
                        CC: !0,
                        e8: !1,
                        Ew: e.a.Ew,
                        Fy: e.a.Fy
                    }) : A2(k3, e.a, C3), a = function() {
                        if (e.$) return Qp;
                        var n = e.a;
                        return A4(B3, r.ld, R3(r.dV), P3(r.dV), n);
                    }();
                    return b(m(r, {
                        v: u
                    }), a, Ot);
                }
                return E3(m(r, {
                    v: y3
                }));
            case 4:
                var i = r.v;
                return 2 === i.$ ? A3(W3, n.a, i.a, r) : E3(r);
            case 2:
                return 1 === r.v.$ ? b(m(r, {
                    d7: "us_bank_account" === n.a ? 0 : 1
                }), Qp, Ot) : E3(r);
            case 0:
                u = 1 === (p = r.v).$ ? A2(k3, p.a, C3) : r.v;
                var c = A2(CL, A2(Q3, r.v, R3(r.dV)), r.le);
                return c.$ ? b(m(r, {
                    cE: !1,
                    le: c.a,
                    v: u
                }), Qp, Ot) : b(m(r, {
                    cE: !0,
                    le: c.a.a,
                    v: u
                }), function(n) {
                    switch(n.v.$){
                        case 1:
                            return A2(z3, "#" + V3, {
                                Af: Ot
                            });
                        case 2:
                            return T3;
                        default:
                            return Qp;
                    }
                }(r), It(x3));
            default:
                var o = n.a, f = r.v;
                if (1 === f.$) {
                    var s = f.a;
                    if (o.$) {
                        var l = o.a, d = A2(su, "billing_details[name]", l) ? U3 : Zk(A3(N_, "postal code", "ZIP code", l));
                        return v = mu(l) ? Ot : It({
                            $: 0,
                            a: d
                        }), b(m(r, {
                            cE: !1,
                            v: A2(k3, s, h3(d))
                        }), Qp, v);
                    }
                    var v = It(w3(function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(o.a.sl)));
                    return b(m(r, {
                        v: A2(k3, s, C3)
                    }), Qp, v);
                }
                return E3(r);
        }
        var p;
    }), Y3 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, J3 = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), n9 = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), r9 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, t9 = {
        $: 1
    }, e9 = function(n) {
        return A2(fe, "-", w([
            "document-input",
            i2(n)
        ]));
    }, u9 = Xn("scrollIdToBottom", tx), a9 = F3(function(n, r, t) {
        return A2(Fu, function(t) {
            return n(t) ? r(t) : t;
        }, t);
    }), i9 = F3(function(n, r, t) {
        return A3(a9, n, wm(r), t);
    }), c9 = F3(function(n, r, t) {
        var e = t.b;
        return A2(q0, t.a, A3(i9, function(n) {
            return i(r, n.a);
        }, v(r, n), e));
    }), o9 = {
        $: 0
    }, f9 = {
        $: 1
    }, s9 = {
        $: 2
    }, l9 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, d9 = function(n) {
        return i(n.fa, It(f9));
    }, v9 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), b9 = function(n) {
        return n.qr;
    }, m9 = function(n) {
        return n.sl;
    }, p9 = function(n) {
        return n.s8;
    }, $9 = Xn("openInNewWindow", tx), g9 = function(n) {
        if (2 === n.$ && 6 === n.a.$) {
            var r = n.a;
            return w([
                A3(Vk, r.a, r.b, r.c)
            ]);
        }
        return g;
    }, h9 = F2(function(n, r) {
        return A2(bk, w([
            "documents",
            r
        ]), fM(n));
    }), y9 = F3(function(n, r, t) {
        return A2(bk, w([
            "document_versions",
            t
        ]), A2(h9, n, r));
    }), w9 = A2(Iu, "url", M$), x9 = F5(function(n, r, t, e, u) {
        return A4(aA, GQ(n), w9, u, pk(A2(bk, w([
            "signed_file_url"
        ]), A3(y9, r, t, e))));
    }), _9 = F2(function(n, r) {
        if (n.$) return b(r, function() {
            switch(b9(r.eV)){
                case 0:
                    return Qp;
                case 2:
                    return $9(A2(xc, "", p9(r.eV)));
                default:
                    return A5(x9, r.g0, r.EH, r.lS, m9(r.eV), v9(!0));
            }
        }(), Ot);
        var t, e = n.a, u = n.b, a = JF(u);
        return b(m(r, {
            ju: u
        }), (t = v(e, a)).a && !t.b.$ ? $9(t.b.a) : Qp, function() {
            if (2 === u.$) {
                var n = u.a;
                return It($(g9(u), w([
                    Nk(n)
                ])));
            }
            return Ot;
        }());
    }), C9 = F2(function(n, r) {
        return m(r, {
            ec: n
        });
    }), k9 = F2(function(n, r) {
        return A3(cN, C9, n, r);
    }), E9 = function(n) {
        return n.T.zI;
    }, q9 = function(n) {
        return n.T.A6;
    }, j9 = function(n) {
        return n.T.k2;
    }, D9 = function(n) {
        return n.T.A9;
    }, V9 = function(n) {
        return n.T.Cs;
    }, B9 = function(n) {
        return n.T.Ct;
    }, G9 = function(n) {
        return n.T.C6;
    }, z9 = function(n) {
        return n.T.lu;
    }, S9 = function(n) {
        return n.T.Di;
    }, T9 = function(n) {
        return n.T.EP;
    }, P9 = function(n) {
        return n.T.EQ;
    }, Z9 = function(n) {
        return n.T.ER;
    }, M9 = function(n) {
        return n.T.Fd;
    }, L9 = function(n) {
        return n.T.xK;
    }, N9 = function(n) {
        return n.T.yU;
    }, H9 = function(n) {
        return n.$ ? B9 : V9;
    }, I9 = function(n) {
        return 1 === n;
    }, O9 = function(n) {
        return DD(A3(Sb, aL("\\s\\s+"), wm(" "), n));
    }, Q9 = F2(function(n, r) {
        var t = r;
        return i(sJ(O9(n)), sJ(O9(t)));
    }), R9 = F2(function(n, r) {
        return !r.$ && A2(Q9, n, r.a);
    }), U9 = F2(function(n, r) {
        return A2(Q9, n, r);
    }), K9 = F2(function(n, r) {
        var t = r.lT, e = r.ec;
        if (I9(r.mI)) {
            var u = e;
            return !(A2(U9, u, t) || A2(R9, u, n));
        }
        return !1;
    }), W9 = F2(function(n, r) {
        return A2(K9, n, r) ? w([
            v(0, fL(H9(n)))
        ]) : g;
    }), X9 = F2(function(n, r) {
        var t = A2(CL, function(n) {
            return XM(w([
                W9(n)
            ]));
        }(n), r);
        return t.$ ? v(t.a, !1) : v(t.a.a, !0);
    }), Y9 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = (l = A2(k9, n.a, r.le), d9(r) ? A2(X9, r.br, l).a : l);
                return b(m(r, {
                    le: t
                }), Qp, Ot);
            case 1:
                var e = A2(X9, r.br, r.le), u = (t = e.a, e.b ? v(1, o9) : v(0, f9)), a = u.b;
                return b(m(r, {
                    $7: u.a,
                    le: t,
                    fa: It(a)
                }), Qp, It(a));
            case 2:
                return b(m(r, {
                    $7: 0,
                    le: A2(k9, "", r.le),
                    fa: It(s9)
                }), Qp, It(s9));
            default:
                var i = n.a, c = r.cL;
                if (c.$) return b(r, Qp, Ot);
                var o = A2(_9, i, c.a), f = o.b, s = o.c;
                return b(m(r, {
                    cL: It(o.a)
                }), A2(Wp, l9, f), A2(bb, function(n) {
                    return It({
                        $: 3,
                        a: n
                    });
                }, s));
        }
        var l;
    }), J9 = F3(function(n, r, t) {
        var e = r.a, u = A2(Y9, t, r.b), a = u.a, i = u.b, c = u.c, o = A2(YF, 0, r9(v(e, a))), f = o.b, s = m(n, {
            ay: A2(n9, o.a, v(e, a)),
            aa: A3(c9, a, e, n.aa)
        });
        if (c.$) return b(s, Uu(w([
            u9(e9(a)),
            A2(Wp, J3(v(e, a)), i)
        ])), Ot);
        switch(c.a.$){
            case 0:
                return b(m(s, {
                    ay: k0
                }), Uu(w([
                    f,
                    A2(Wp, J3(v(e, a)), i)
                ])), It({
                    $: 0,
                    a: v(e, a)
                }));
            case 2:
                return b(m(s, {
                    ay: k0
                }), Qp, It(Y3(v(e, a))));
            case 1:
                return b(s, Uu(w([
                    u9(e9(a)),
                    A2(Wp, J3(v(e, a)), i)
                ])), It(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(v(e, a))));
            default:
                var l = c.a.a;
                return b(s, Uu(w([
                    u9(e9(a)),
                    A2(Wp, J3(v(e, a)), i)
                ])), It(function(n) {
                    return {
                        $: 4,
                        a: n
                    };
                }(l)));
        }
    }), n6 = F5(function(n, r, t, e, u) {
        return v({
            g0: n,
            eV: u,
            lS: t,
            iU: e,
            EH: r,
            ju: kc
        }, 1 === b9(u) ? A5(x9, n, r, t, m9(u), v9(!1)) : Qp);
    }), r6 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = t.a, u = t.b;
                return b(m(r, {
                    ay: k0
                }), Qp, It(Y3(v(e, u))));
            case 1:
                var a = n.a, i = (e = a.a, function(n) {
                    var r = A5(n6, n.g0, n.EH, n.aP.qp, n.aP.ur, n.aP.eV), t = r.b;
                    return v(m(n, {
                        cL: It(r.a)
                    }), A2(Wp, l9, t));
                }(u = a.b)), c = i.a, o = i.b, f = A2(YF, 0, r9(v(e, c))), s = f.b;
                return b(m(r, {
                    ay: A2(n9, f.a, v(e, c))
                }), Uu(w([
                    s,
                    A2(Wp, J3(v(e, c)), o)
                ])), It({
                    $: 1,
                    a: v(e, u)
                }));
            case 5:
                var l = n.a, d = r.ay;
                if (d.$) {
                    var p = d.b, $ = (e = p.a, u = p.b, A2(Sj, l, d.a)), g = $.b;
                    return b(m(r, {
                        ay: A2(n9, $.a, v(e, u))
                    }), A2(Wp, P1, g), Ot);
                }
                return b(r, Qp, Ot);
            case 3:
                var h = n.a;
                switch(e = h.a, u = h.b, n.b){
                    case 0:
                        return A3(J9, r, v(e, u), t9);
                    case 1:
                        return b(m(r, {
                            ay: k0
                        }), Qp, It(Y3(v(e, u))));
                    default:
                        return b(r, Qp, Ot);
                }
            case 2:
                var y = n.a;
                return l = n.b, A3(J9, r, v(e = y.a, u = y.b), l);
            default:
                return b(m(r, {
                    hz: It(n.a)
                }), Qp, Ot);
        }
    }), t6 = F3(function(n, r, t) {
        var e = A2(dG, n, r), u = e.a, a = e.c;
        return a.$ || a.a.$ || a.a.a.$ ? b(u, t, !1) : a.a.a.a.$ ? b(u, Ot, !0) : b(u, It(a.a.a.a.a), !1);
    }), e6 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(r, A2(__, pa, Da), g);
            case 1:
                if (3 === (P = n.a).$) {
                    var t = P.a;
                    if (r.bT) return b(m(r, {
                        bT: !1,
                        Z: t.sO,
                        Go: t.Go
                    }), A2(__, pa, qa), w([
                        xR(t.sO)
                    ]));
                    var e = $1(m(r, {
                        Z: t.sO,
                        Go: t.Go
                    })), u = e.b;
                    return b(A = e.a, Uu(w([
                        j2(A),
                        u
                    ])), w([
                        xR(t.sO)
                    ]));
                }
                return r.bT ? b(m(r, {
                    bT: !1
                }), A2(__, pa, qa), A2(Ik, 0, P)) : b(r, Qp, A2(Ik, 0, P));
            case 2:
                return b(m(r, {
                    k7: !r.k7
                }), Qp, g);
            case 3:
                var a = n.a;
                return b(m(r, {
                    rh: A2(A2(UG, a, r.rh) ? nU : QG, a, r.rh)
                }), Qp, g);
            case 4:
                return 3 === (P = n.a).$ ? b(A = m(r, {
                    lW: P,
                    mi: a2(P.a)
                }), j2(A), g) : b(m(r, {
                    lW: P
                }), Qp, A2(Ik, 0, P));
            case 5:
                var c = A3(t6, n.a, r.lV, r.mi), o = c.a, f = c.b, s = c.c, l = !i(A2(Op, D0, f), A2(Op, D0, r.mi)), d = function() {
                    if (s) {
                        var n = A6(N2, !1, r.ld, r.dV, r.os, Ot, r.g0), t = n.b;
                        return v(It(n.a), A2(Wp, k1, t));
                    }
                    return v(l ? Ot : r.aq, Qp);
                }(), p = d.b;
                return b(A = m(r, {
                    bG: kc,
                    aq: d.a,
                    fw: l ? kc : r.fw,
                    lV: o,
                    mi: f
                }), l ? Uu(w([
                    p,
                    j2(A)
                ])) : p, g);
            case 6:
                var h = n.a, y = r.aq;
                if (1 === y.$) return b(r, Qp, g);
                var x = A2(X3, h, y.a), _ = x.b, C = x.c, A = m(r, {
                    aq: It(x.a)
                }), k = A2(Wp, k1, _);
                n: for(; !C.$;)switch(C.a.$){
                    case 1:
                        var E = C.a.a, q = 3 !== (I = r.lW).$ || !nE(I.a);
                        return b(m(A, {
                            bG: A_
                        }), Uu(w([
                            A4(u2, r.g0, E, {
                                dT: !1,
                                wi: !1,
                                wW: Ot,
                                xq: !q
                            }, H1),
                            k
                        ])), g);
                    case 0:
                        var F = C.a.a;
                        return b(m(A, {
                            bG: kc
                        }), k, w([
                            Lk(F)
                        ]));
                    default:
                        break n;
                }
                return b(A, k, g);
            case 7:
                if (3 === (P = n.a).$) {
                    var j = P.a, D = function() {
                        var n = r.lW;
                        if (3 === n.$) {
                            var t = n.b;
                            return A2(tC, $(n.a, w([
                                j
                            ])), t);
                        }
                        return n;
                    }();
                    return b(A = m(r, {
                        bG: P,
                        aq: Ot,
                        fw: kc,
                        lW: D,
                        mi: It(j)
                    }), j2(A), g);
                }
                return b(m(r, {
                    bG: P
                }), Qp, A2(Ik, 0, P));
            case 8:
                return b(m(r, {
                    fw: P = n.a
                }), Qp, g);
            case 9:
                return b(m(r, {
                    bG: kc,
                    aq: Ot
                }), Qp, g);
            case 10:
                return b(r, 1 === r.aq.$ ? Qp : A2(Wp, k1, V2), g);
            case 11:
                if (!B2(r.Z) || O2(r.as)) {
                    var V = v(r.fy, r.mi);
                    if (V.a.$ || V.b.$) return b(r, Qp, g);
                    var B = V.a.a, G = V.b.a;
                    if (nE(r.Z) || r.bn) return b(r, Qp, g);
                    var z = A2(Fu, r2({
                        kz: d2(r.as),
                        fy: B,
                        Gl: r.Gl
                    }), r.Z);
                    return b(m(r, {
                        bn: !0
                    }), A4(W1, r.g0, ux(r.dV), {
                        sO: z,
                        Ex: D0(G)
                    }, N1), g);
                }
                return b(m(r, {
                    dc: !0
                }), Qp, g);
            case 12:
                var S = n.a;
                return 3 === S.$ ? X1(t = S.a) ? b(m(r, {
                    bn: !1
                }), A2(__, pa, ka), w([
                    A2(Mk, 2, I1(A2(m2, t, r.Z)))
                ])) : b(m(r, {
                    bT: !0,
                    bn: !1
                }), A3(sR, r.g0, ux(r.dV), x0), g) : b(m(r, {
                    bn: !1
                }), Qp, A2(Ik, 0, S));
            case 13:
                var T = A3(ia, n.a, P = n.b, r.cM);
                return b(m(r, {
                    cM: T,
                    as: M = A5(g3, r.Z, r.fy, T, r.fx, r.as)
                }), Qp, A2(Ik, 0, P));
            case 14:
                var P;
                return b(m(r, {
                    fx: P = n.a,
                    as: M = A5(g3, r.Z, r.fy, r.cM, P, r.as)
                }), Qp, A2(Ik, 0, P));
            default:
                var Z = A2(r6, h = n.a, r.as), M = Z.a, L = Z.b, N = Z.c, H = N.$ || N.a.$ ? r.dc : r.dc && !O2(M);
                return b(m(r, {
                    as: M,
                    dc: H
                }), A2(Wp, C0, L), g);
        }
        var I;
    }), u6 = {
        $: 0
    }, a6 = function(n) {
        return n.cF.o4;
    }, i6 = function(n) {
        return n.cF.qI;
    }, c6 = function(n) {
        return n.cF.dS;
    }, o6 = function(n) {
        return n.cF.cg;
    }, f6 = function(n) {
        return n.cF.yx;
    }, s6 = function(n) {
        return n.cF.zw;
    }, l6 = function(n) {
        switch(n.$){
            case 3:
            case 0:
                return !1;
            default:
                return !0;
        }
    }, d6 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, v6 = {
        $: 1
    }, b6 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, m6 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, p6 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $6 = function(n) {
        return nE(n.b);
    }, g6 = function(n) {
        return $6(n.aa);
    }, h6 = F2(function(n, r) {
        return A2(Fu, n, r.b);
    }), y6 = {
        Bb: !1,
        iR: !1,
        jt: !1
    }, w6 = F2(function(n, r) {
        switch(n.$){
            case 1:
                return m(r, {
                    Bb: n.a
                });
            case 2:
                return m(r, {
                    jt: n.a
                });
            default:
                return m(r, {
                    iR: !0
                });
        }
    }), x6 = wE(2), _6 = A2(tE, rE(2), It(0)), C6 = F3(function(n, r, t) {
        var e = t ? w([
            A2(PE, w([
                x6,
                uE(_6)
            ]), w([
                _d("*")
            ]))
        ]) : g;
        return A2(AH, w([
            nF,
            VG,
            Hx(w([
                Gx("block mb-2")
            ]))
        ]), A2(Qt, _d(n(r)), e));
    }), k6 = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), E6 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, q6 = function(n) {
        return n.aP.e7;
    }, j6 = oF(4), D6 = function(n) {
        return n.vJ;
    }, V6 = F2(function(n, r) {
        return r.vK(n);
    }), B6 = function(n) {
        return _d(n.aP.ur);
    }, G6 = F4(function(n, r, t, e) {
        var u, a, i = e.a, c = e.b, o = A2(xc, g, A2(ra, i2(c), t)), f = nE(o) ? D6 : V6(A2(fe, ", ", o)), s = A2(f_, w([
            VG,
            nF,
            Hx(w([
                Gx("ml-6")
            ])),
            uE(Jq)
        ]), w([
            _d(n(f))
        ]));
        return A2(zx, w([
            Gx("px-1"),
            DF((a = i, "pending-document-" + oe(a)))
        ]), w([
            A2(BE, w([
                VN(w([
                    Gx("mb-2 md:mb-3")
                ]))
            ]), w([
                A2(lE, g, w([
                    A2(fI, w([
                        eI(l2(c)),
                        tI(k6(v(i, c))),
                        E6(r.jt && !H2(c)),
                        rI(r.Bb)
                    ]), w([
                        (u = c, _d(u.aP.mH)),
                        A2(Mx, w([
                            Gx("pl-2"),
                            Oq(w([
                                v("-mr-1", q6(c))
                            ]))
                        ]), w([
                            A2(yF, w([
                                j6,
                                cF(A2(k6, v(i, c), !0)),
                                Lj(r.Bb)
                            ]), w([
                                B6(c)
                            ]))
                        ])),
                        A2(Mx, w([
                            Gx("form-group__label ml-1"),
                            Oq(w([
                                v("form-group__label--required", q6(c))
                            ]))
                        ]), g)
                    ])),
                    s
                ]))
            ]))
        ]));
    }), z6 = F2(function(n, r) {
        var t = v(n, r);
        return t.a ? h1 : t.b ? g1 : y1;
    }), S6 = F3(function(n, r, t) {
        var e = A3(de, w6, y6, r), u = t.yx, a = t.aa, i = t.iE, c = t.sG, o = A2(h6, A3(G6, n, e, t.i4), a), f = t.h5 ? o : A2(Qt, s_, o), s = function() {
            if (u.$) return vE;
            var r = u.a;
            return A2(i_, w([
                uE(eE)
            ]), w([
                _d(n(r))
            ]));
        }(), l = function() {
            var r = t.hC;
            if (r.$) {
                var e = w([
                    vH(n(A2(z6, c, i)))
                ]);
                return w([
                    s,
                    A2(EH, e, w([
                        A2(zx, w([
                            Gx("-mt-2 md:-mt-3")
                        ]), f)
                    ]))
                ]);
            }
            return w([
                s,
                A3(C6, n, r.a, t.jh),
                A2(zx, g, f)
            ]);
        }();
        return A2(BE, w([
            VN(w([
                Oq(w([
                    v("panel", e.iR)
                ]))
            ]))
        ]), w([
            A2(lE, g, l)
        ]));
    }), T6 = {
        $: 2
    }, P6 = function(n) {
        return A2(yF, w([
            CD,
            cF(T6)
        ]), w([
            _d(n(q9))
        ]));
    }, Z6 = function(n) {
        return A2(yF, w([
            fF,
            cF(t9)
        ]), w([
            _d(n(E9))
        ]));
    }, M6 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, L6 = A2(tE, rE(3), It(0)), N6 = {
        $: 1
    }, H6 = cr("em"), I6 = function(n) {
        return n ? "embed-responsive--large" : "embed-responsive--small";
    }, O6 = cr("iframe"), Q6 = F2(function(n, r) {
        return A2(dr, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), function(n) {
            return "string" == typeof n && $r.test(n) ? "" : n;
        }(r));
    }), R6 = Bx("title"), U6 = F4(function(n, r, t, e) {
        return A2(zx, g, w([
            function() {
                if (t.$) return A2(zx, w([
                    Gx("flex justify-center my-12")
                ]), w([
                    Lx(g)
                ]));
                var u = t.a, a = e ? "https://docs.google.com/gview?url=" + $_(u) + "&embedded=true" : u;
                return A2(zx, w([
                    Gx("embed-responsive"),
                    Gx(I6(n))
                ]), w([
                    A2(O6, w([
                        iJ(a),
                        R6(r),
                        A2(lF, "sandbox", "allow-scripts allow-same-origin"),
                        A2(Q6, "frameborder", tx("0")),
                        A2(Q6, "allowfullscreen", tx("false")),
                        Gx("embed-responsive__item mb-2")
                    ]), g)
                ]));
            }(),
            A2(H6, g, w([
                _d("If you do not see the document above, please click "),
                A2(yF, w([
                    j6,
                    cF(N6)
                ]), w([
                    _d("here")
                ]))
            ]))
        ]));
    }), K6 = F2(function(n, r) {
        switch(b9(r.eV)){
            case 0:
                return A2(zx, g, A2(Fu, c_(Cu), a0(A2(xc, "", function(n) {
                    return n.pd;
                }(r.eV)))));
            case 2:
                return A4(U6, n, r.iU, p9(r.eV), !1);
            default:
                return A4(U6, n, r.iU, JF(r.ju), !0);
        }
    }), W6 = F2(function(n, r) {
        if (r.$) return vE;
        var t = r.a;
        return A2(BE, w([
            xN(JI),
            VN(w([
                Gx("-mx-1")
            ]))
        ]), w([
            A2(lE, g, w([
                A2(EH, w([
                    vH(n(KL))
                ]), w([
                    _d(A2(SM, sZ("/"), t))
                ]))
            ]))
        ]));
    }), X6 = F3(function(n, r, t) {
        return A2(BE, w([
            VN(w([
                Gx("-mx-1 mb-6 md:mb-8")
            ]))
        ]), w([
            A2(lE, g, w([
                A2(EH, w([
                    vH(n(r))
                ]), w([
                    ZV(t)
                ]))
            ]))
        ]));
    }), Y6 = F3(function(n, r, t) {
        var e = v(t, n);
        return e.a.$ ? vE : A3(X6, r, e.b ? z9 : S9, e.a.a);
    }), J6 = F4(function(n, r, t, e) {
        var u = function() {
            var r = v(t, n);
            return r.a.$ ? r.b ? z9 : G9 : r.b ? z9 : T9;
        }();
        return A3(X6, r, u, e);
    }), n4 = F3(function(n, r, t) {
        var e = A2(iH, 0, t);
        return nE(e) ? A2(Kq, w([
            Gx("mt-2 md:mt-3 text-sm text-info-400")
        ]), w([
            _d(n(H9(r)))
        ])) : A2(YH, n, e);
    }), r4 = F4(function(n, r, t, e) {
        var u, a = (u = v(e.br, n)).a.$ ? v(u.b ? L9 : D9, j9) : u.b ? v(L9, j9) : v(Z9, P9), i = a.a, c = a.b, o = FM(e.le), f = o.lT, s = o.ec;
        if (I9(o.mI)) return A2(zx, w([
            DF(e9(e))
        ]), w([
            (l = e.cL, l.$ ? vE : A2(c_, l9, A2(K6, 0, l.a))),
            A2(zx, w([
                A2(VF, "margin-left", "-1.5rem"),
                A2(VF, "margin-right", "-1.5rem")
            ]), w([
                s_
            ])),
            A2(BE, w([
                xN(L6),
                VN(w([
                    Gx("mt-5")
                ]))
            ]), w([
                A2(lE, g, w([
                    A3(Y6, n, r, e.br),
                    A4(J6, n, r, e.br, f),
                    A2(BE, w([
                        VN(w([
                            Gx("-mx-1 mb-6 md:mb-8")
                        ]))
                    ]), w([
                        A2(lE, g, w([
                            A2(EH, w([
                                vH(r(i)),
                                gH(!0)
                            ]), w([
                                PI(w([
                                    OI(s),
                                    HI(A2(qc, M6, cu)),
                                    FI(!0),
                                    jI(r(c)),
                                    yI(A2(wH, 0, e.le))
                                ])),
                                A3(n4, r, e.br, e.le)
                            ]))
                        ]))
                    ])),
                    A2(W6, r, t)
                ]))
            ]))
        ]));
        var l, d = e.cL;
        return d.$ ? vE : A2(c_, l9, A2(K6, 0, d.a));
    }), t4 = F4(function(n, r, t, e) {
        if (1 === e.$) {
            var u = e.a, a = e.b, i = a.a, c = a.b;
            return A2(dD, w([
                Hj(w([
                    A2(PE, w([
                        qG,
                        nF
                    ]), w([
                        A2(c_, Cu, B6(c))
                    ]))
                ])),
                Mj(w([
                    A2(c_, J3(v(i, c)), A4(r4, n, r, t, c))
                ])),
                Nj(w([
                    A2(c_, J3(v(i, c)), Z6(r)),
                    A2(c_, J3(v(i, c)), P6(r))
                ]))
            ]), zj(u));
        }
        return vE;
    }), e4 = F3(function(n, r, t) {
        return g6(t) ? vE : A2(zx, g, w([
            A4(t4, t.sG, n, t.hz, t.ay),
            A3(S6, n, r, t)
        ]));
    }), u4 = F2(function(n, r) {
        return A2(c_, C0, A3(e4, Vx(r.ld), w([
            p6(r.dc),
            m6(n)
        ]), r.as));
    }), a4 = {
        $: 9
    }, i4 = {
        $: 10
    }, c4 = function(n) {
        var r = n.v;
        switch(r.$){
            case 3:
                return !1;
            case 2:
                return r.a.e8;
            default:
                return !0;
        }
    }, o4 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, f4 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, s4 = {
        $: 2
    }, l4 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, d4 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, v4 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, b4 = wE(3), m4 = F3(function(n, r, t) {
        var e = v(r, t);
        return e.a && e.b ? A2(BE, w([
            VN(w([
                Gx("ach-text-fade-in")
            ]))
        ]), w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(Kk, w([
                    Hx(w([
                        Gx("hidden sm:block")
                    ]))
                ]), w([
                    A2(f_, w([
                        b4,
                        VG
                    ]), w([
                        _d(n(Pd))
                    ]))
                ])),
                A2(Kk, w([
                    Hx(w([
                        Gx("block sm:hidden")
                    ]))
                ]), w([
                    A2(f_, w([
                        b4,
                        VG
                    ]), w([
                        _d(n(Pd))
                    ]))
                ]))
            ]))
        ])) : vE;
    }), p4 = F3(function(n, r, t) {
        return A2(t.mO, n, r);
    }), $4 = F2(function(n, r) {
        return r.mP(n);
    }), g4 = F3(function(n, r, t) {
        var e = b(t, r, n);
        return !!e.a && !(e.b && !e.c);
    }), h4 = F7(function(n, r, t, e, u, a, i) {
        var c = function() {
            var t, a = v(u, n);
            return r(a.a.$ ? a.b ? $4(e) : A2(p4, e, "2%") : a.b ? $4(e) : (t = OK(a.a.a), A2(p4, e, t)));
        }();
        return A3(g4, i, a, t) ? A2(BE, w([
            VN(w([
                Gx(a ? "ach-text-fade-in" : "")
            ]))
        ]), w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(f_, w([
                    b4,
                    VG
                ]), w([
                    _d(c)
                ]))
            ]))
        ])) : vE;
    }), y4 = F7(function(n, r, t, e, u, a, i) {
        return n ? A3(m4, t, e, i) : A7(h4, r, t, e, u, a, !0, i);
    }), w4 = dF("hidden"), x4 = F2(function(n, r) {
        return r.vB(n);
    }), _4 = tn, C4 = A2(M_, w([
        "detail"
    ]), A2(_4, 0, A2(M_, w([
        "data",
        "payment_method_id"
    ]), M$))), k4 = A2(M_, w([
        "detail"
    ]), A2(_4, 0, M$)), E4 = A2(M_, w([
        "detail"
    ]), A2(_4, 0, M$)), q4 = F2(function(n, r) {
        var t = n.Dp, e = n.DM, u = n.Ea, a = n.DO, i = n.DT, c = n.Dx;
        return A3(r0, "rainforest-payment", w([
            A2(lF, "session-key", r.Fy),
            A2(lF, "payment-method-config-id", r.Ew),
            A2(lF, "allowed-methods", r.zX),
            r.B8 ? A2(lF, "hide-card-brand-logos", "true") : Oq(g),
            A2(lF, "hide-button", ""),
            A2(EE, "approved", A2(eu, t, C4)),
            A2(EE, "valid", au(u)),
            A2(EE, "invalid", au(e)),
            A2(EE, "loaded", au(a)),
            A2(EE, "method-updated", A2(eu, i, E4)),
            A2(EE, "card-brand-updated", A2(eu, c, k4)),
            Gx("mb-4")
        ]), g);
    }), j4 = F4(function(n, r, t, e) {
        return r ? A2(BE, g, w([
            A2(lE, w([
                TE(5)
            ]), w([
                A2(yF, w([
                    fF,
                    cF(D2),
                    Qj(t),
                    Lj(t || !e)
                ]), w([
                    _d(n(H3))
                ]))
            ]))
        ])) : vE;
    }), D4 = function(n) {
        var r = Vx(n.ld), t = function() {
            var r = n.v;
            switch(r.$){
                case 0:
                    return !0;
                case 1:
                default:
                    return !1;
                case 2:
                    return r.a.CC;
            }
        }(), e = c4(n), u = P3(n.dV), a = n.os;
        return w([
            A2(zx, g, w([
                A2(zx, w([
                    w4(t),
                    Gx("stripe-card")
                ]), w([
                    vE,
                    function() {
                        var t = n.v;
                        switch(t.$){
                            case 3:
                                return A2(zx, w([
                                    Gx("mt-4 mb-4")
                                ]), w([
                                    A2(f_, w([
                                        x6
                                    ]), w([
                                        _d(r(x4(ax(n.dV))))
                                    ]))
                                ]));
                            case 2:
                                var e = t.a, u = e.Fy, a = e.Ew, i = e.zX;
                                return A2(zx, g, w([
                                    A2(q4, {
                                        Dp: A2(tu, o4, d4),
                                        Dx: A2(tu, f4, d4),
                                        DM: d4(v4(!1)),
                                        DO: d4(s4),
                                        DT: A2(tu, l4, d4),
                                        Ea: d4(v4(!0))
                                    }, {
                                        zX: i,
                                        B8: R3(n.dV),
                                        Ew: a,
                                        Fy: u
                                    }),
                                    A2(YH, r, A2(iH, 0, n.le))
                                ]));
                            default:
                                return A2(zx, w([
                                    DF(V3),
                                    Gx("mb-4")
                                ]), g);
                        }
                    }(),
                    A2(zx, w([
                        w4(t)
                    ]), w([
                        A7(y4, a, n.sG, r, u, ax(n.dV), n.lb, n.d7)
                    ])),
                    A4(j4, r, n.ky, n.cE, e)
                ])),
                t ? A2(zx, w([
                    Gx("flex justify-center my-12")
                ]), w([
                    Lx(w([
                        Tx
                    ]))
                ])) : vE
            ]))
        ]);
    }, V4 = function(n) {
        return n.hf;
    }, B4 = function(n) {
        var r = n.mA, t = n.Cx, e = n.CC, u = n.Dv, a = n.DA;
        return A2(zx, w([
            Gx("flex gap-2 mt-4")
        ]), w([
            A2(yF, w([
                CD,
                cF(u)
            ]), w([
                _d(r(V4))
            ])),
            A2(yF, w([
                fF,
                cF(a),
                Lj(!t),
                Qj(e)
            ]), w([
                _d(r(Av))
            ]))
        ]));
    }, G4 = F2(function(n, r) {
        var t = r.aq;
        if (t.$) return vE;
        var e = t.a, u = 1 === r.bG.$;
        return A2(zx, w([
            Gx("mb-6")
        ]), $(A2(Fu, c_(k1), D4(e)), w([
            B4({
                Cx: c4(e),
                CC: u,
                Dv: a4,
                DA: i4,
                mA: n
            })
        ])));
    }), z4 = function(n) {
        return n.fW;
    }, S4 = function(n) {
        var r, t = n.lW;
        switch(t.$){
            case 3:
                var e = t.a;
                return A2(zx, w([
                    Gx("mb-6")
                ]), w([
                    A2(f_, w([
                        A2(dE, n.ib, nF),
                        A2(dE, n.ib, VG),
                        uE(Jq)
                    ]), w([
                        n.ib ? A2(PE, w([
                            GN
                        ]), w([
                            _d(n.iZ)
                        ])) : A2(xX, g, w([
                            _d(n.iZ)
                        ])),
                        A2(Mx, w([
                            Gx("text-danger")
                        ]), w([
                            _d(" *")
                        ]))
                    ])),
                    A2(c_, n.lK, A4(qz, n.mA, w([
                        XG(n.mi),
                        HG(n.mA(z4)),
                        SG
                    ]), (r = A2(Fu, function(n) {
                        return A2(MG, g, d6(n));
                    }, e), nE(r) ? w([
                        A2(MG, g, v6)
                    ]) : A2(Qt, A2(MG, g, v6), A2(Qt, PG, r))), n.lV))
                ]));
            case 1:
                return A2(zx, w([
                    Gx("mb-6")
                ]), Nx);
            default:
                return A2(zx, w([
                    Gx("mb-6")
                ]), w([
                    A2(f_, w([
                        nF
                    ]), w([
                        _d(n.lE)
                    ]))
                ]));
        }
    }, T4 = {
        $: 11
    }, P4 = {
        $: 2
    }, Z4 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, M4 = function(n) {
        return function(n) {
            return n.vi;
        }(n.a);
    }, L4 = F2(function(n, r) {
        var t, e = !i(r.mi, Ot) && i(r.aq, Ot) && !nE(r.Z) && !i(r.fy, Ot) && !r.bn && (!B2(r.Z) || O2(r.as));
        return {
            kX: (t = r.fw, A2(Op, M4, JF(t))),
            pF: !e,
            pG: n(a6),
            pH: r.bn || r.bT,
            k7: r.k7,
            rh: r.rh,
            sO: r.Z,
            uS: T4,
            uZ: P4,
            u0: Z4,
            Go: r.Go,
            mA: n
        };
    }), N4 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, H4 = F2(function(n, r) {
        return A2(zx, w([
            Gx("mb-6")
        ]), w([
            A2(Kk, w([
                nF,
                VG,
                uE(Jq),
                uF(AF),
                uF(gE)
            ]), w([
                A2(PE, w([
                    GN
                ]), w([
                    _d(n(s6))
                ])),
                A2(EV, w([
                    yV(x_(ka)),
                    N4("no-underline font-medium")
                ]), w([
                    _d(n(i6))
                ]))
            ])),
            A2(zx, w([
                Gx("flex flex-col gap-2")
            ]), A2(Fu, function(n) {
                return A2(f_, w([
                    nF,
                    VG
                ]), w([
                    _d(uW(n))
                ]));
            }, r.Z))
        ]));
    }), I4 = F3(function(n, r, t) {
        var e = A2(L4, n, t);
        return w([
            GW({
                Ba: A2(zx, w([
                    Gx("sidebar-wrap")
                ]), w([
                    BW(e)
                ])),
                CX: w([
                    A2(H4, n, t),
                    S4({
                        ib: !0,
                        lE: n(c6),
                        lK: b6,
                        iZ: n(o6),
                        lV: t.lV,
                        lW: t.lW,
                        mi: i(t.aq, Ot) ? A2(Op, d6, t.mi) : It(v6),
                        mA: n
                    }),
                    A2(G4, n, t),
                    B2(t.Z) ? A2(u4, r, t) : _d("")
                ])
            }),
            lX(A2(zx, w([
                Gx("sidebar-wrap -mx-6 sm:-mx-8 sm:px-8")
            ]), w([
                BW(e)
            ])))
        ]);
    }), O4 = F2(function(n, r) {
        var t, e = n(f6), u = l6(r.fx) || A2(Wk, l6, (t = r.cM, A3(Rt, F3(function(n, r, t) {
            return A2(Qt, r, t);
        }), g, t)));
        return {
            g8: w([
                vX(A2(Qt, rK({
                    AG: !0,
                    Dy: u6,
                    yx: e
                }), A3(I4, n, u, r)))
            ]),
            yx: e
        };
    }), Q4 = C_({
        Cl: _1,
        CQ: C1,
        Fj: A1,
        F4: function(n) {
            return vx(w([
                n.aq.$ ? bx : A2(kj, k1, S1),
                A2(kj, C0, L1(n.as))
            ]));
        },
        Gv: e6,
        GB: O4
    }), R4 = F3(function(n, r) {
        return v({
            ld: r.ld,
            dV: n
        }, Qp);
    }), U4 = F2(function(n, r) {
        return v(r, Qp);
    }), K4 = F2(function(n, r) {
        return r;
    }), W4 = F2(function(n, r) {
        return b(r, A2(__, pa, Da), g);
    }), X4 = function(n) {
        return n.hi.g8;
    }, Y4 = function(n) {
        return n.hi.qs;
    }, J4 = function(n) {
        return n.hi.yx;
    }, n8 = function(n) {
        return A2(zx, w([
            Gx("flex flex-col items-center justify-center flex-1 py-12")
        ]), w([
            A2(zx, w([
                Gx("flex flex-col items-center gap-8 w-full max-w-sm mx-auto")
            ]), w([
                A2(c_, Cu, A2(Tq, w([
                    Wj("size-16 text-primary")
                ]), 9)),
                A2(zx, w([
                    Gx("flex flex-col items-center gap-3")
                ]), w([
                    A2(CF, w([
                        uF(xD)
                    ]), w([
                        _d(n(J4))
                    ])),
                    A2(f_, w([
                        uF(xD),
                        nF,
                        Hx(w([
                            Gx("max-w-3xs")
                        ]))
                    ]), w([
                        _d(n(X4))
                    ]))
                ])),
                A2(yF, w([
                    fF,
                    iK,
                    Kj(w([
                        Gx("checkout-cta")
                    ])),
                    cF(0)
                ]), w([
                    _d(n(Y4))
                ]))
            ]))
        ]));
    }, r8 = F2(function(n) {
        return {
            g8: w([
                vX(w([
                    n8(n)
                ]))
            ]),
            yx: n(J4)
        };
    }), t8 = C_({
        Cl: R4,
        CQ: U4,
        Fj: K4,
        F4: function() {
            return bx;
        },
        Gv: W4,
        GB: r8
    }), e8 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, u8 = tt(function() {
        return {
            xh: ut(),
            eo: {
                mF: Yr.pageXOffset,
                bj: Yr.pageYOffset,
                cv: Xr.documentElement.clientWidth,
                r8: Xr.documentElement.clientHeight
            }
        };
    }), a8 = function(n) {
        return n.tE;
    }, i8 = function(n) {
        if (1 === D_(n.AF.E).$) return !0;
        var r = n.fF;
        switch(r.$){
            case 3:
                return !a8(r.a);
            case 2:
                return !0;
            default:
                return !1;
        }
    }, c8 = F3(function(n, r, t) {
        var e = i8(r) ? A2(__, t.jb, ui) : Qp, u = {
            g_: !1,
            _: Ot,
            eO: r.AF.Ao,
            k: r.AF.E,
            S: kc,
            dw: 0,
            bp: r.bp,
            ld: r.ld,
            bB: !1,
            bF: Ot,
            vn: r.vn,
            dV: n,
            bg: Ot,
            f9: r.f9,
            yZ: t,
            ep: 0
        }, a = A2(Nu, function(n) {
            return e8(Sp(n.eo.cv));
        }, u8);
        return v(u, Uu(w([
            e,
            a
        ])));
    }), o8 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), f8 = function(n) {
        return j_(F_(n));
    }, s8 = F2(function(n, r) {
        return {
            Ep: n,
            jb: A2(xc, pa, A2(Op, t$, r.jb)),
            EX: r
        };
    }), l8 = F4(function(n, r, t, e) {
        return {
            rb: r,
            lo: t,
            iH: e,
            Gm: n
        };
    }), d8 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), v8 = F8(function(n, r, t, e, u, a, i, c) {
        return {
            ps: n,
            AT: i,
            Cu: a,
            sN: u,
            sU: r,
            vh: t,
            Eu: e,
            Gw: c
        };
    }), b8 = A3(nk, "sentAt", XZ, A3(nk, "snippet", M$, A3(nk, "id", M$, au(F3(function(n, r, t) {
        return {
            sl: n,
            Fv: t,
            FR: r
        };
    }))))), m8 = F5(function(n, r, t, e, u) {
        return {
            Bd: r,
            sl: n,
            fy: t,
            EB: u,
            y1: e
        };
    }), p8 = A4(JA, "phoneNumber", uC(M$), Ot, A4(JA, "userId", uC(M$), Ot, A4(JA, "patientId", uC(M$), Ot, A4(JA, "displayName", uC(M$), Ot, A3(nk, "id", M$, au(m8)))))), $8 = A3(nk, "updatedAt", XZ, A3(nk, "createdAt", XZ, A3(nk, "isArchived", ru, A3(nk, "isUnread", ru, A3(nk, "participantsCount", O$, A3(nk, "participants", ek(p8), A4(JA, "lastMessage", uC(b8), Ot, A3(nk, "ident", M$, au(v8))))))))), g8 = A2(zB, 0, A2($A, $8, au(d8))), h8 = A3(nk, "offset", O$, A3(nk, "limit", O$, A3(nk, "entities", ek(g8), A3(nk, "total", O$, au(l8))))), y8 = {
        lo: It(10),
        iH: 0,
        mq: Ot
    }, w8 = F2(function(n, r) {
        return A3(ib, n, "0", oe(r));
    }), x8 = A2(Lc, 0, g), _8 = function(n) {
        var r;
        return A2(w8, 4, A2(Bb, x8, r = n)) + "-" + A2(w8, 2, function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                case 6:
                    return 7;
                case 7:
                    return 8;
                case 8:
                    return 9;
                case 9:
                    return 10;
                case 10:
                    return 11;
                default:
                    return 12;
            }
        }(A2(Fb, x8, r))) + "-" + A2(w8, 2, A2(Ab, x8, r)) + "T" + A2(w8, 2, A2(kb, x8, r)) + ":" + A2(w8, 2, A2(qb, x8, r)) + ":" + A2(w8, 2, A2(jb, x8, r)) + "." + A2(w8, 3, A2(Eb, x8, r)) + "Z";
    }, C8 = F4(function(n, r, t, e) {
        return A4(aA, n, h8, e, A2($k, function(n) {
            var r, t = n(y8), e = (r = t.mq).$ ? g : w([
                A2(g_, "timestamp", _8(r.a))
            ]), u = function() {
                var n = t.lo;
                return n.$ ? g : w([
                    A2(iA, "limit", n.a)
                ]);
            }();
            return A2(Qt, A2(iA, "offset", t.iH), $(u, e));
        }(t), pk(function(n) {
            return A2(bk, w([
                "conversations"
            ]), mk(n));
        }(r))));
    }), k8 = F2(function(n, r) {
        var t, e = m(r, {
            _: A2(Op, function(r) {
                return m(r, {
                    hB: n.vn
                });
            }, r._),
            eO: n.AF.Ao,
            k: n.AF.E,
            vn: n.vn,
            yZ: A2(s8, 0, n.yZ)
        }), u = i8(n) ? A2(__, r.yZ.jb, ui) : Qp;
        if (i8(n)) return v(e, u);
        if (0 === e.S.$) {
            var a = (t = f8(n.AF.E)).$ ? Qp : A4(C8, n.AF.E, t.a, function(n) {
                return m(n, {
                    lo: It(10),
                    iH: 0
                });
            }, o8(0));
            return v(m(e, {
                S: A_
            }), a);
        }
        return v(e, Qp);
    }), E8 = F2(function(n, r) {
        return m(r, {
            zK: It(8)
        });
    }), q8 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, j8 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, D8 = function(n) {
        return {
            $: 9,
            a: n
        };
    }, V8 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), B8 = F2(function(n, r) {
        return {
            wj: r,
            yo: n
        };
    }), G8 = Au(A2(B8, pa, pa)), z8 = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(ra, t, r);
        return A3(ia, t, 1 === u.$ ? w([
            e
        ]) : A2(Qt, e, u.a), r);
    }), S8 = ct, T8 = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = dC(A2(S8, e, A2(J_, n, e)));
            return A2(ju, function(r) {
                return A3(T8, n, u, A3(ia, e, r, t));
            }, a);
        }
        return Au(t);
    }), P8 = F3(function(n, r, t) {
        var e = t.wj, u = F3(function(n, r, t) {
            var e = t.c;
            return b(t.a, t.b, A2(ju, function() {
                return e;
            }, lC(r)));
        }), a = A3(de, z8, pa, r), i = A6(lj, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return b(A2(Qt, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return b(e.a, A3(ia, n, t, e.b), u);
        }), u, a, e, b(g, pa, Au(0))), c = i.a, o = i.b;
        return A2(ju, function(n) {
            return Au(A2(B8, a, n));
        }, A2(ju, function() {
            return A3(T8, n, c, o);
        }, i.c));
    }), Z8 = F3(function(n, r, t) {
        var e = A2(ra, r, t.yo);
        if (1 === e.$) return Au(t);
        var u = e.a;
        return A2(ju, function() {
            return Au(t);
        }, A2(ju, function(r) {
            return Bu(A2(Fu, function(t) {
                return A2(Gu, n, t(r));
            }, u));
        }, Yz));
    }), M8 = F2(function(n, r) {
        return A2(V8, r.a, A2(qc, n, r.b));
    });
    Tn.Time = Pn(G8, P8, Z8, 0, M8);
    var L8, N8, H8, I8, O8, Q8, R8, U8, K8, W8 = Nn("Time"), X8 = F2(function(n, r) {
        return W8(A2(V8, n, r));
    }), Y8 = function(n) {
        return A3(_j, 1, "resize", A2(Iu, "target", A3(uu, n, A2(Iu, "innerWidth", O$), A2(Iu, "innerHeight", O$))));
    }, J8 = nr("onScroll", A2(nu, function(n) {
        return A2(nu, function(r) {
            return A2(nu, function(t) {
                return A2(nu, function(e) {
                    return A2(nu, function(u) {
                        return au({
                            AE: u,
                            pc: e,
                            Fk: t,
                            mF: r,
                            bj: n
                        });
                    }, A2(Iu, "clientHeight", I$));
                }, A2(Iu, "containerId", M$));
            }, A2(Iu, "scrollHeight", I$));
        }, A2(Iu, "x", I$));
    }, A2(Iu, "y", I$))), n5 = F2(function(n, r) {
        return {
            $: 22,
            a: n,
            b: r
        };
    }), r5 = {
        $: 33
    }, t5 = function(n) {
        return {
            $: 29,
            a: n
        };
    }, e5 = function(n) {
        return {
            $: 30,
            a: n
        };
    }, u5 = function(n) {
        return {
            $: 31,
            a: n
        };
    }, a5 = function(n) {
        return {
            $: 24,
            a: n
        };
    }, i5 = function(n) {
        return {
            $: 18,
            a: n
        };
    }, c5 = {
        $: 2
    }, o5 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, f5 = function(n) {
        return {
            $: 21,
            a: n
        };
    }, s5 = function(n) {
        return {
            $: 27,
            a: n
        };
    }, l5 = function(n) {
        return {
            $: 15,
            a: n
        };
    }, d5 = nr("fileUploadResult", G$), v5 = F5(function(n, r, t, e, u) {
        return {
            rc: u,
            rw: n,
            rx: t,
            ry: e,
            F5: r
        };
    }), b5 = fn, m5 = A6(b5, v5, A2(Iu, "fileIndex", O$), A2(Iu, "success", ru), A2(Iu, "filePath", M$), A2(Iu, "filename", M$), uC(A2(Iu, "error", M$))), p5 = nr("heicPreviewResult", G$), $5 = F3(function(n, r, t) {
        return {
            ur: n,
            FO: r,
            yS: t
        };
    }), g5 = A4(JQ, $5, A2(Iu, "name", M$), A2(Iu, "size", O$), A2(Iu, "type", M$)), h5 = function(n) {
        var r = A2(WA, ek(g5), n);
        return r.$ ? g : r.a;
    }, y5 = nr("onFileSelectedPort", G$), w5 = nr("previewLayoutSized", G$), x5 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _5 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, C5 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, k5 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, E5 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, q5 = nr("docxPreviewHtmlResult", G$), j5 = function(n) {
        return !n.bR;
    }, D5 = w([
        "pdf",
        "csv",
        "xlsx",
        "docx",
        "xml",
        "ics"
    ]), V5 = function(n) {
        var r;
        return r = sJ(n), A2(xu, ".", r) ? A2(vu, 1, r) : r;
    }, B5 = function(n) {
        return v(sJ(A2(xc, "", mb(Ae(A2(se, ".", n.ai))))), function(n) {
            return V5(n.BI);
        }(n));
    }, G5 = function(n) {
        var r, t = B5(n), e = t.b, u = V5(t.a);
        return ve(r = A2(se, ".", n.ai)) > 1 && function() {
            var n = mb(Ae(r));
            return !n.$ && "" !== n.a;
        }() && "" !== u || A2(Xk, u, D5) ? u : e;
    }, z5 = function(n) {
        return "docx" === G5(n);
    }, S5 = function(n) {
        return z5(n.c) && !n.i;
    }, T5 = function(n) {
        return j5(n.b) && S5(n) ? q5(A2(tu, cu, E5)) : bx;
    }, P5 = function(n) {
        return "pdf" === G5(n);
    }, Z5 = A2(nu, function(n) {
        switch(n){
            case "error":
                return A3(uu, F2(function(n, r) {
                    return function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }({
                        rc: r,
                        ur: n
                    });
                }), A2(Iu, "name", M$), A2(Iu, "error", M$));
            case "loaded":
                return A3(uu, F2(function(n, r) {
                    return function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }({
                        ur: n,
                        En: r
                    });
                }), A2(Iu, "name", M$), A2(Iu, "pageCount", O$));
            default:
                return AA("unknown websocketmsg type: " + n);
        }
    }, A2(Iu, "msg", M$)), M5 = nr("receivePdfMsg", G$), L5 = function(n) {
        var r;
        return M5((r = n, function(n) {
            return r(A2(WA, Z5, n));
        }));
    }, N5 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, H5 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, I5 = function(n) {
        return "csv" === G5(n);
    }, O5 = function(n) {
        return "xlsx" === G5(n);
    }, Q5 = nr("spreadsheetPreviewResult", G$), R5 = function(n) {
        return j5(n.b) && function(n) {
            return (I5(n.c) || O5(n.c)) && !n.i;
        }(n) ? Q5(A2(tu, N5, H5)) : bx;
    }, U5 = function(n) {
        return n.dD > 0 && 1024 > n.dD;
    }, K5 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, W5 = function(n) {
        return "xml" === G5(n);
    }, X5 = nr("xmlPreviewResult", G$), Y5 = function(n) {
        return j5(n.b) && W5(n.c) && !n.i ? X5(A2(tu, cu, K5)) : bx;
    }, J5 = nr("onElementMeasured", A2(nu, function(n) {
        return A2(nu, function(r) {
            return A2(nu, function(t) {
                return A2(nu, function(e) {
                    return A2(nu, function(u) {
                        return au({
                            AE: u,
                            b4: e,
                            BC: t,
                            s6: r,
                            Fk: n
                        });
                    }, A2(Iu, "clientHeight", I$));
                }, A2(Iu, "elementId", M$));
            }, A2(Iu, "exceedsMaxLines", ru));
        }, A2(Iu, "lineHeight", I$));
    }, A2(Iu, "scrollHeight", I$))), n7 = J5(cu), r7 = {
        $: 3
    }, t7 = function(n) {
        return n.bO ? vx(w([
            hR(r7),
            $R(r7)
        ])) : bx;
    }, e7 = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), u7 = {
        $: 4
    }, a7 = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), i7 = "conversation", c7 = F2(function(n, r) {
        var t = function() {
            if (n.$) return A2(va, i7, r);
            var t = n.a;
            return mu(t) ? A2(va, i7, r) : A3(ia, i7, t, r);
        }();
        return i(t, r) ? Qp : A2(__, t, Fa);
    }), o7 = function(n) {
        return n.a.ps;
    }, f7 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, s7 = F2(function(n, r) {
        return v(Uu(A2(Fu, function(r) {
            switch(r.$){
                case 21:
                    var t = 3 === (e = n.vn).$ ? It(kM(e.a)) : Ot;
                    return t.$ ? Qp : A4(C8, n.k, t.a, function(n) {
                        return m(n, {
                            lo: It(10),
                            iH: 0
                        });
                    }, o8(0));
                case 22:
                    return A2(Nu, f7, Au(r.a));
                default:
                    return Qp;
            }
            var e;
        }, r)), g);
    }), l7 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, d7 = F2(function(n, r) {
        return {
            ur: r,
            y1: n
        };
    }), v7 = A3(uu, d7, A2(Iu, "userId", M$), A2(Iu, "name", M$)), b7 = F3(function(n, r, t) {
        return A4(aA, n, A2(Iu, "users", ek(v7)), t, pk(A2(bk, w([
            "practice-users"
        ]), mk(r))));
    }), m7 = {
        EI: kc,
        xo: g,
        bO: !1
    }, p7 = {
        bz: g,
        fj: !1
    }, $7 = F9(function(n, r, t, e, u, a, i, c, o) {
        var f = m(m7, {
            EI: A_
        }), s = j_(F_(t));
        return v({
            dq: kc,
            eu: !0,
            K: pa,
            a1: pa,
            eO: e,
            k: t,
            dv: kc,
            ps: "",
            hy: t,
            dw: 0,
            hB: c,
            bp: i,
            bw: OG,
            dD: 0,
            ld: r,
            dG: !1,
            e5: !0,
            V: "",
            bA: !1,
            bB: !1,
            cV: !0,
            bC: !1,
            cW: !1,
            ca: !1,
            aF: !1,
            bD: !1,
            bF: Ot,
            dL: Ot,
            aH: Ot,
            ly: "",
            aV: kc,
            bI: Ot,
            dV: n,
            dY: Ot,
            bM: f,
            aZ: Ot,
            c8: p7,
            X: g,
            a_: Ot,
            db: !1,
            f9: a,
            ej: It(0),
            em: g,
            yZ: u,
            gf: o
        }, s.$ ? A2(Nu, function(n) {
            return u5(Sp(n.eo.cv));
        }, u8) : Uu(w([
            A3(b7, t, s.a, A2(tu, l7, l5)),
            A2(Nu, function(n) {
                return u5(Sp(n.eo.cv));
            }, u8)
        ])));
    }), g7 = F2(function(n, r) {
        return {
            sl: n,
            sN: r
        };
    }), h7 = A3(uu, g7, A2(Iu, "id", M$), A2(Iu, "isUnread", ru)), y7 = F4(function(n, r, t, e) {
        return A4(Dj, n, h7, e, pk(A2(bk, w([
            "conversations",
            t,
            "mark-as-read"
        ]), mk(r))));
    }), w7 = 992, x7 = function(n) {
        return {
            $: 40,
            a: n
        };
    }, _7 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, C7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, k7 = {
        $: 11
    }, E7 = F2(function(n, r) {
        return {
            tO: r,
            xy: n
        };
    }), q7 = A2(Iu, "afterHoursMessage", A2(eu, cu, A3(nk, "message", ik(M$), A3(nk, "show", ru, au(E7))))), j7 = F3(function(n, r, t) {
        return A4(aA, n, q7, t, pk(A2(bk, w([
            "after-hours-message"
        ]), mk(r))));
    }), D7 = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            AT: c,
            Cf: r,
            Cu: i,
            sN: a,
            sU: t,
            vh: u,
            Eu: e,
            EH: n,
            Gw: o
        };
    }), V7 = F3(function(n, r, t) {
        return {
            sl: n,
            Fv: t,
            FR: r
        };
    }), B7 = A3(nk, "sentAt", XZ, A3(nk, "snippet", M$, A3(nk, "id", M$, au(V7)))), G7 = A4(JA, "phoneNumber", uC(M$), Ot, A4(JA, "userId", uC(M$), Ot, A4(JA, "patientId", uC(M$), Ot, A4(JA, "displayName", uC(M$), Ot, A3(nk, "id", M$, au(F5(function(n, r, t, e, u) {
        return {
            Bd: r,
            sl: n,
            fy: t,
            EB: u,
            y1: e
        };
    }))))))), z7 = A3(nk, "updatedAt", XZ, A3(nk, "createdAt", XZ, A3(nk, "isArchived", ru, A3(nk, "isUnread", ru, A3(nk, "participants", ek(G7), A3(nk, "participantsCount", O$, A4(JA, "lastMessage", uC(B7), Ot, A3(nk, "ident", M$, A3(nk, "practiceId", M$, au(D7)))))))))), S7 = F2(function(n, r) {
        return A2(bk, w([
            "conversations",
            r
        ]), mk(n));
    }), T7 = F4(function(n, r, t, e) {
        return A4(aA, n, z7, e, pk(A2(S7, r, t)));
    }), P7 = F4(function(n, r, t, e) {
        return {
            rb: r,
            lo: t,
            iH: e,
            Gm: n
        };
    }), Z7 = F4(function(n, r, t, e) {
        return {
            nC: r,
            sl: n,
            FR: t,
            yu: e
        };
    }), M7 = A4(JA, "text", uC(M$), Ot, A3(nk, "snippet", M$, A3(nk, "author", G7, A3(nk, "id", M$, au(Z7))))), L7 = F2(function(n, r) {
        return {
            zL: r,
            Es: n
        };
    }), N7 = A2(nu, function(n) {
        switch(n){
            case "ADDED":
                return au(0);
            case "REMOVED":
                return au(1);
            default:
                return AA("Unknown participantHistory.action: " + n);
        }
    }, M$), H7 = A3(nk, "action", N7, A3(nk, "participant", G7, au(L7))), I7 = A4(JA, "parent", uC(M7), Ot, A4(JA, "participantHistory", ik(H7), Ot, A4(JA, "deletedAt", uC(XZ), Ot, A3(nk, "updatedAt", XZ, A3(nk, "createdAt", XZ, A3(nk, "sentAt", XZ, A3(nk, "author", G7, A4(JA, "files", ek(M$), g, A4(JA, "richText", uC(M$), Ot, A4(JA, "text", uC(M$), Ot, A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    nC: u,
                                                    AT: i,
                                                    A8: o,
                                                    BT: e,
                                                    sl: n,
                                                    Eq: s,
                                                    Et: f,
                                                    Fg: t,
                                                    Fv: a,
                                                    yu: r,
                                                    Gw: c
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), O7 = A3(nk, "offset", O$, A3(nk, "limit", O$, A3(nk, "entities", ek(I7), A3(nk, "total", O$, au(P7))))), Q7 = F3(function(n, r, t) {
        var e = t.$ ? g : w([
            A2(g_, "timestamp", _8(t.a))
        ]), u = r.$ ? g : w([
            A2(iA, "limit", r.a)
        ]);
        return A2(Qt, A2(iA, "offset", n), $(u, e));
    }), R7 = F2(function(n, r) {
        return A2(bk, w([
            "conversations",
            r,
            "messages"
        ]), mk(n));
    }), U7 = F7(function(n, r, t, e, u, a, i) {
        return A4(aA, n, O7, i, A2($k, A3(Q7, e, u, a), pk(A2(R7, r, t))));
    }), K7 = function(n) {
        return j_(F_(n));
    }, W7 = F2(function(n, r) {
        var t, e = 0 > s(r.ep, w7) ? 0 : 1, u = (t = r.dV, function(n) {
            return function(r) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            var s, l;
                                            return v({
                                                dq: A_,
                                                eu: !1,
                                                K: pa,
                                                a1: pa,
                                                eO: e,
                                                k: r,
                                                dv: A_,
                                                ps: a,
                                                hy: r,
                                                dw: 0,
                                                hB: o,
                                                bp: c,
                                                bw: OG,
                                                dD: 0,
                                                ld: n,
                                                dG: !1,
                                                e5: !1,
                                                V: "",
                                                bA: !1,
                                                bB: !1,
                                                cV: !1,
                                                bC: !1,
                                                cW: !1,
                                                ca: !1,
                                                aF: !1,
                                                bD: !1,
                                                bF: Ot,
                                                dL: Ot,
                                                aH: Ot,
                                                ly: "",
                                                aV: A_,
                                                bI: Ot,
                                                dV: t,
                                                dY: Ot,
                                                bM: m7,
                                                aZ: Ot,
                                                c8: p7,
                                                X: g,
                                                a_: Ot,
                                                db: !1,
                                                f9: i,
                                                ej: Ot,
                                                em: g,
                                                yZ: u,
                                                gf: f
                                            }, Uu(w([
                                                function() {
                                                    var n = K7(r);
                                                    return n.$ ? Qp : A4(T7, r, n.a, a, _7);
                                                }(),
                                                (l = K7(r), l.$ ? Qp : A7(U7, r, l.a, a, 0, It(10), Ot, C7)),
                                                (s = K7(e), s.$ ? Qp : A3(j7, e, s.a, x7)),
                                                A2(Nu, function() {
                                                    return k7;
                                                }, Au(0)),
                                                A2(Nu, function(n) {
                                                    return u5(Sp(n.eo.cv));
                                                }, u8)
                                            ])));
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        })(r.ld)(r.k)(r.eO)(r.yZ)(n)(r.f9)(r.bp)(r.vn)(e), a = u.b;
        return b(m(r, {
            _: It(u.a),
            bg: It(n)
        }), Uu(w([
            A2(Wp, q8, a),
            A2(Nu, f7, Au(n))
        ])), g);
    }), X7 = Xn("setupScrollDetection", function(n) {
        return rx(w([
            v("containerId", tx(n.pc))
        ]));
    }), Y7 = function(n) {
        return {
            $: 37,
            a: n
        };
    }, J7 = function(n) {
        return {
            $: 25,
            a: n
        };
    }, nnn = {
        $: 26
    }, rnn = F2(function(n, r) {
        return {
            $: 28,
            a: n,
            b: r
        };
    }), tnn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, enn = function(n) {
        return {
            $: 22,
            a: n
        };
    }, unn = function(n) {
        return {
            $: 16,
            a: n
        };
    }, ann = function(n) {
        return {
            $: 23,
            a: n
        };
    }, inn = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), cnn = {
        $: 21
    }, onn = function(n) {
        return {
            $: 39,
            a: n
        };
    }, fnn = {
        $: 9
    }, snn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, lnn = {
        $: 12
    }, dnn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, vnn = {
        $: 10
    }, bnn = A2(fe, ",", w([
        ".jpeg",
        ".jpg",
        ".gif",
        ".png",
        ".mp4",
        ".mp3",
        ".oga",
        ".weba",
        ".mpeg",
        ".webm",
        ".bmp",
        ".tif",
        ".tiff",
        ".csv",
        ".ics",
        ".pdf",
        ".heic"
    ])), mnn = Xn("autoResize", tx), pnn = Xn("copyToClipboard", tx), $nn = function(n) {
        return rx(w([
            v("userId", tx(n.y1))
        ]));
    }, gnn = F4(function(n, r, t, e) {
        return A4(lM, n, z7, e, A2(dM, function(n) {
            return rx(w([
                v("participants", A2(WU, $nn, n.vh))
            ]));
        }(t), pk(function(n) {
            return A2(bk, w([
                "conversations"
            ]), mk(n));
        }(r))));
    }), hnn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ynn = function(n) {
        return A2(Nu, hnn, Au(n));
    }, wnn = {
        al: {
            r8: 0,
            cv: 0,
            mF: 0,
            bj: 0
        },
        xh: {
            r8: 0,
            cv: 0
        },
        eo: {
            r8: 0,
            cv: 0,
            mF: 0,
            bj: 0
        }
    }, xnn = A3(uu, F2(function(n, r) {
        return {
            tx: r,
            jg: n
        };
    }), A2(Iu, "requestId", M$), A2(Iu, "url", ik(M$))), _nn = {
        $: 6
    }, Cnn = {
        $: 0
    }, Ann = {
        $: 0
    }, knn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Enn = {
        $: 0
    }, qnn = {
        $: 0
    }, Fnn = function(n) {
        var r = mb(Ae(A2(se, ".", n)));
        return 1 === r.$ ? "" : "." + r.a;
    }, jnn = function(n) {
        var r, t = function(n) {
            var r = A2(se, "_", n);
            if (r.b) {
                var t = r.a, e = r.b;
                return A2(ae, _e, t) && lu(t) >= 13 ? A2(fe, "_", e) : n;
            }
            return n;
        }(A2(xc, r = n, mb(Ae(A2(se, "/", r))))), e = Fnn(t);
        if (A2(su, "__keenhp-file__", t)) return A2(xc, t, mb(A2(se, "__keenhp-file__", t)));
        var u = A2(su, ".", t) ? A2(fe, ".", Ae(A2(Yp, 1, Ae(A2(se, ".", t))))) : t, a = A2(se, "_", u), i = function() {
            var n = Ae(a);
            if (n.b && n.b.b) {
                var r = n.a, t = n.b, e = t.b;
                return A2(ae, _e, t.a) && A2(ae, _e, r) ? Ae(e) : a;
            }
            return a;
        }();
        return $(A2(fe, "_", i), e);
    }, Dnn = F2(function(n, r) {
        return {
            Bd: r,
            BI: Fnn(r),
            ai: n
        };
    }), Vnn = w([
        "wav",
        "mp3",
        "weba",
        "oga",
        "ogg",
        "m4a",
        "aac",
        "flac",
        "opus"
    ]), Bnn = w([
        "jpeg",
        "jpg",
        "gif",
        "png",
        "bmp",
        "webp",
        "tif",
        "tiff"
    ]), Gnn = w([
        "mp4",
        "webm",
        "mpeg",
        "mpg",
        "ogv"
    ]), znn = function(n) {
        var r, t = (r = sJ(n), A2(xu, ".", r) ? A2(vu, 1, r) : r);
        return A2(Xk, t, Bnn) || "heic" === t ? 0 : A2(Xk, t, Gnn) ? 1 : A2(Xk, t, Vnn) ? 2 : A2(Xk, t, D5) ? 3 : 4;
    }, Snn = function(n) {
        var r = B5(n), t = r.a, e = znn(r.b), u = znn(t);
        return 4 !== u ? u : e;
    }, Tnn = F2(function(n, r) {
        return A2(bk, w([
            "conversations",
            r,
            "files"
        ]), mk(n));
    }), Pnn = A3(nk, "fileUrl", M$, au(cu)), Znn = F5(function(n, r, t, e, u) {
        return A4(aA, n, Pnn, u, A2($k, w([
            A2(g_, "filename", e)
        ]), pk(A2(Tnn, r, t))));
    }), Mnn = function(n) {
        switch(n){
            case 0:
            case 1:
            case 2:
                return !0;
            default:
                return !1;
        }
    }, Lnn = F6(function(n, r, t, e, u, a) {
        var i, c, o = a.$ ? (c = Fnn(i = u), {
            Bd: jnn(i),
            BI: c,
            ai: i
        }) : A2(Dnn, u, a.a), f = Snn(o), s = Mnn(f) ? A_ : kc, l = Mnn(f) ? A5(Znn, n, r, t, o.ai, A2(tu, knn, x5)) : Qp, d = A2(YF, 0, x5(_nn));
        return v({
            c: o,
            l: e,
            m: {
                bp: 0,
                qF: 0,
                b9: !1,
                c_: !1,
                cs: 0
            },
            AD: n,
            ps: t,
            dD: 0,
            g: {
                by: !1,
                aS: Ot,
                L: Ot,
                H: Ot
            },
            ap: !1,
            fy: r,
            ck: {
                r8: Ot,
                cv: Ot
            },
            b: d.a,
            x: Cnn,
            D: Ann,
            r: Enn,
            i: !1,
            p: Ot,
            y: qnn,
            u: 0,
            z: 0,
            de: s,
            B: {
                b1: 0,
                L: Ot,
                H: Ot,
                ch: !1,
                dZ: !1,
                fI: !1
            }
        }, Uu(w([
            l,
            d.b
        ])));
    }), Nnn = F7(function(n, r, t, e, u, a, i) {
        var c = A2(Fu, function(e) {
            var u, c = (u = mb(A2(bu, "_", e))).$ ? e : A2(vu, u.a + 1, e), o = A6(Lnn, n, r, t, e, c, A2(bb, function(n) {
                return mu(n) ? Ot : It(n);
            }, A2(ra, c, a))), f = o.b;
            return b(e, o.a, A2(Wp, i(e), f));
        }, A2(no, function(n) {
            return !A2(RG, n, u);
        }, A2(bc, function(n) {
            return A2(Fu, function(r) {
                return n.sl + "_" + r;
            }, n.BT);
        }, e))), o = A2(Fu, function(n) {
            return n.c;
        }, c), f = A3(de, F2(function(n, r) {
            return A3(ia, n.a, n.b, r);
        }), u, c);
        return v(f, o);
    }), Hnn = it, Inn = A2(jc, function() {
        return c5;
    }, A2(ju, function(n) {
        return A3(Hnn, "messages-container", 0, n.xh.r8);
    }, Ak("messages-container"))), Onn = Xn("measureElement", function(n) {
        return rx(w([
            v("elementId", tx(n.b4)),
            v("maxLines", NQ(n.C$))
        ]));
    }), Qnn = Onn({
        b4: "participant-header-text",
        C$: 2
    }), Rnn = Xn("openFileDialogPort", tx), Unn = A4(JQ, F3(function(n, r, t) {
        return {
            r8: t,
            jg: n,
            cv: r
        };
    }), A2(Iu, "requestId", M$), A2(Iu, "width", I$), A2(Iu, "height", I$)), Knn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wnn = F2(function(n, r) {
        return A2(Nu, function() {
            return r;
        }, Up(n));
    }), Xnn = F3(function(n, r, t) {
        var e = t, u = m(e, {
            bz: A2(Qt, r, e.bz)
        }), a = function() {
            var r = n.F1;
            switch(r.$){
                case 0:
                    var t = r.a;
                    return e.fj ? Qp : A2(Wnn, t, Knn(Ot));
                case 1:
                    t = r.a;
                    var a = r.b;
                    return e.fj ? Qp : A2(Wnn, t, Knn(It(a)));
                default:
                    return A2(Wnn, a = r.a, function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(function(n) {
                        return ve(n.bz);
                    }(u)));
            }
        }();
        return v(u, A2(Wp, n.Gs, a));
    }), Ynn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Jnn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nrn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rrn = function(n) {
        var r = A2(Du, function() {
            return 0;
        }, Ck(n));
        return A2(jc, A2(tu, nrn, Jnn), A2(Fc, function() {
            return A2(ju, function() {
                return r;
            }, Up(64));
        }, A2(Fc, function() {
            return A2(ju, function() {
                return r;
            }, Up(32));
        }, A2(Fc, function() {
            return A2(ju, function() {
                return r;
            }, Up(16));
        }, r))));
    }, trn = V$(function(n) {
        return Ce(n) ? n : "_";
    }), ern = function(n) {
        return "fp-audio-" + trn(n);
    }, urn = Xn("mediaPlay", function(n) {
        return rx(w([
            v("elementId", tx(n.b4))
        ]));
    }), arn = yn, irn = Xn("mediaSetCurrentTime", function(n) {
        return rx(w([
            v("elementId", tx(n.b4)),
            v("seconds", arn(n.Fp))
        ]));
    }), crn = Xn("mediaTogglePlayPause", function(n) {
        return rx(w([
            v("elementId", tx(n.b4))
        ]));
    }), orn = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r.m.c_ ? v(r, crn({
                    b4: ern(r.l)
                })) : v(m(r, {
                    m: m(u = r.m, {
                        c_: !0
                    })
                }), rrn(ern(r.l)));
            case 1:
                return v(r, n.a.$ ? Qp : urn({
                    b4: ern(r.l)
                }));
            case 2:
                return v(m(r, {
                    m: m(u = r.m, {
                        b9: !0
                    })
                }), Qp);
            case 3:
                return v(m(r, {
                    m: m(u = r.m, {
                        b9: !1
                    })
                }), Qp);
            case 4:
                return v(m(r, {
                    m: m(u = r.m, {
                        bp: n.a,
                        qF: t = n.b
                    })
                }), Qp);
            case 5:
                var t;
                return v(m(r, {
                    m: m(u = r.m, {
                        qF: t = n.a,
                        cs: t > 0 ? 0 : u.cs
                    })
                }), Qp);
            case 9:
                return 1 > (u = r.m).cs ? v(m(r, {
                    m: m(u, {
                        cs: u.cs + 1
                    })
                }), A5(Znn, r.AD, r.fy, r.ps, r.c.ai, A2(tu, knn, x5))) : v(m(r, {
                    ap: !0
                }), Qp);
            case 6:
                return v(m(r, {
                    m: m(u = r.m, {
                        bp: 0,
                        b9: !1
                    })
                }), Qp);
            case 7:
                var e = A2(Ie, 0, A2(dm, 1, n.a)) * (a = (u = r.m).qF);
                return a > 0 ? v(m(r, {
                    m: m(u, {
                        bp: e
                    })
                }), irn({
                    b4: ern(r.l),
                    Fp: e
                })) : v(r, Qp);
            default:
                var u, a;
                n = Ynn(((a = (u = r.m).qF) > 0 ? u.bp / a : 0) + n.a);
                continue n;
        }
    }), frn = {
        $: 1
    }, srn = {
        $: 1
    }, lrn = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), drn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, vrn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, brn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mrn = {
        $: 4
    }, prn = {
        $: 2
    }, $rn = {
        $: 1
    }, grn = {
        $: 1
    }, hrn = {
        $: 1
    }, yrn = F3(function(n, r, t) {
        var e;
        return A2(Nu, Cu, A3(Ht, n, r, (e = t, new Uint8Array(e.buffer, e.byteOffset, e.byteLength))));
    }), wrn = Xn("convertDocxFromUrl", function(n) {
        return rx(w([
            v("requestId", tx(n.jg)),
            v("url", tx(n.yZ))
        ]));
    }), xrn = Xn("convertHeicFromUrl", function(n) {
        return rx(w([
            v("requestId", tx(n.jg)),
            v("url", tx(n.yZ))
        ]));
    }), _rn = Xn("clearDocxMount", tx), Crn = function(n) {
        return "fp-docx-lightbox-" + trn(n.l);
    }, Arn = function(n) {
        return z5(n.c) ? _rn(Crn(n)) : Qp;
    }, krn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ern = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qrn = {
        $: 2
    }, Frn = {
        $: 1
    }, jrn = F2(function(n, r) {
        return A3(Pt, "arraybuffer", Mt, A2(tu, r, n));
    }), Drn = function(n) {
        return wC({
            g8: xC,
            BF: n.BF,
            h3: g,
            Dd: "GET",
            Gg: Ot,
            Gp: Ot,
            yZ: n.yZ
        });
    }, Vrn = F2(function(n, r) {
        return Drn({
            BF: A2(jrn, r, function(n) {
                switch(n.$){
                    case 0:
                        return Yt(Ern(n.a));
                    case 1:
                        return Yt(Frn);
                    case 2:
                        return Yt(qrn);
                    case 3:
                        return Yt(krn(n.a.F_));
                    default:
                        return te(n.b);
                }
            }),
            yZ: n
        });
    }), Brn = function(n) {
        var r = B5(n);
        return "heic" === r.a || "heic" === r.b;
    }, Grn = function(n) {
        return "fp-pdf-lightbox-" + trn(n.l);
    }, zrn = "0.1.4", Srn = F2(function(n, r) {
        return n(function(n) {
            switch(n.$){
                case 0:
                    var r = n.a;
                    return rx(w([
                        v("cmd", tx("openurl")),
                        v("name", tx(r.ur)),
                        v("url", tx(r.yZ)),
                        v("version", tx(zrn))
                    ]));
                case 1:
                    return r = n.a, rx(w([
                        v("cmd", tx("openstring")),
                        v("name", tx(r.ur)),
                        v("string", tx(r.F2)),
                        v("version", tx(zrn))
                    ]));
                default:
                    return r = n.a, rx(w([
                        v("cmd", tx("close")),
                        v("name", tx(r.ur))
                    ]));
            }
        }(r));
    }), Trn = Xn("sendPdfCommand", cu), Prn = function(n) {
        return A2(Srn, Trn, {
            $: 2,
            a: {
                ur: n
            }
        });
    }, Zrn = function(n) {
        return P5(n.c) ? Prn(Grn(n)) : Qp;
    }, Mrn = Xn("requestSpreadsheetPreview", function(n) {
        return rx(w([
            v("kind", tx(n.ik)),
            v("requestId", tx(n.jg)),
            v("url", tx(n.yZ))
        ]));
    }), Lrn = Xn("requestXmlPreview", function(n) {
        return rx(w([
            v("elementId", tx(n.b4)),
            v("requestId", tx(n.jg)),
            v("url", tx(n.yZ))
        ]));
    }), Nrn = Xn("revokePreviewObjectUrl", tx), Hrn = function(n) {
        if (n.$) return Qp;
        var r = n.a;
        return A2(xu, "blob:", r) ? Nrn(r) : Qp;
    }, Irn = F2(function(n, r) {
        return A2(Srn, Trn, {
            $: 0,
            a: {
                ur: n,
                yZ: r
            }
        });
    }), Orn = Xn("clearXmlMount", tx), Qrn = function(n) {
        return "fp-xml-lightbox-" + trn(n.l);
    }, Rrn = function(n) {
        return W5(n.c) ? Orn(Qrn(n)) : Qp;
    }, Urn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = function(n) {
                    var r = n.B;
                    return m(n, {
                        g: m(n.g, {
                            L: Ot,
                            H: Ot
                        }),
                        ck: {
                            r8: Ot,
                            cv: Ot
                        },
                        B: m(r, {
                            L: Ot,
                            H: Ot
                        })
                    });
                }(m(r, {
                    m: {
                        bp: 0,
                        qF: 0,
                        b9: !1,
                        c_: !1,
                        cs: 0
                    },
                    g: {
                        by: !1,
                        aS: Ot,
                        L: r.g.L,
                        H: r.g.H
                    },
                    ap: !1,
                    b: Bj(r.b),
                    x: Cnn,
                    D: Ann,
                    r: Enn,
                    i: !1,
                    p: Ot,
                    y: qnn,
                    u: 0,
                    z: 0,
                    de: t,
                    B: {
                        b1: 0,
                        L: Ot,
                        H: Ot,
                        ch: !1,
                        dZ: !1,
                        fI: !1
                    }
                }));
                if (3 === t.$) {
                    var u = t.a, a = Hrn(r.g.aS), i = Brn(r.c), c = !(f = Snn(r.c)) && !i || 1 === f ? A2(Nu, function() {
                        return tnn(grn);
                    }, Up(50)) : Qp, o = i ? v(m(e, {
                        g: m(e.g, {
                            by: !0,
                            aS: Ot,
                            L: Ot,
                            H: Ot
                        })
                    }), Uu(w([
                        a,
                        xrn({
                            jg: r.l,
                            yZ: u
                        })
                    ]))) : v(e, a);
                    return v(o.a, Uu(w([
                        o.b,
                        c
                    ])));
                }
                return v(e, Hrn(r.g.aS));
            case 1:
                var f, s = m(r, {
                    dD: n.a
                });
                switch(f = Snn(s.c)){
                    case 0:
                        return Brn(s.c) ? v(m(s, {
                            b: zj(s.b),
                            x: Cnn,
                            D: Ann,
                            r: Enn,
                            i: !1,
                            y: qnn,
                            u: 0,
                            z: 0
                        }), Qp) : v(m(s, {
                            x: Cnn,
                            D: Ann,
                            r: Enn,
                            i: !1,
                            y: qnn,
                            u: 0,
                            z: 0
                        }), A5(Znn, s.AD, s.fy, s.ps, s.c.ai, A2(tu, brn, x5)));
                    case 3:
                        return z5(s.c) ? v(m(s, {
                            b: zj(s.b),
                            x: Cnn,
                            D: srn,
                            r: Enn,
                            i: !1,
                            p: Ot,
                            y: qnn,
                            u: 0,
                            z: 0
                        }), Uu(w([
                            Arn(s),
                            Zrn(s),
                            A5(Znn, s.AD, s.fy, s.ps, s.c.ai, A2(tu, brn, x5))
                        ]))) : P5(s.c) ? v(m(s, {
                            b: zj(s.b),
                            x: Cnn,
                            D: Ann,
                            r: $rn,
                            i: !1,
                            p: Ot,
                            y: qnn,
                            u: 0,
                            z: 0
                        }), A5(Znn, s.AD, s.fy, s.ps, s.c.ai, A2(tu, brn, x5))) : I5(s.c) ? v(m(s, {
                            b: zj(s.b),
                            x: frn,
                            D: Ann,
                            r: Enn,
                            i: !1,
                            p: Ot,
                            y: qnn,
                            u: 0,
                            z: 0
                        }), Uu(w([
                            Arn(s),
                            Zrn(s),
                            A5(Znn, s.AD, s.fy, s.ps, s.c.ai, A2(tu, brn, x5))
                        ]))) : O5(s.c) ? v(m(s, {
                            b: zj(s.b),
                            x: Cnn,
                            D: Ann,
                            r: Enn,
                            i: !1,
                            p: Ot,
                            y: hrn,
                            u: 0,
                            z: 0
                        }), Uu(w([
                            Arn(s),
                            Zrn(s),
                            A5(Znn, s.AD, s.fy, s.ps, s.c.ai, A2(tu, brn, x5))
                        ]))) : W5(s.c) ? v(m(s, {
                            b: zj(s.b),
                            x: Cnn,
                            D: Ann,
                            r: Enn,
                            i: !1,
                            p: Ot,
                            y: qnn,
                            u: 0,
                            z: 1
                        }), Uu(w([
                            Arn(s),
                            Zrn(s),
                            A5(Znn, s.AD, s.fy, s.ps, s.c.ai, A2(tu, brn, x5))
                        ]))) : v(m(s, {
                            b: zj(s.b),
                            x: Cnn,
                            D: Ann,
                            r: Enn,
                            i: !0,
                            p: Ot,
                            y: qnn,
                            u: 0,
                            z: 0
                        }), A5(Znn, s.AD, s.fy, s.ps, s.c.ai, A2(tu, drn, x5)));
                    default:
                        return v(m(s, {
                            b: zj(s.b),
                            x: Cnn,
                            D: Ann,
                            r: Enn,
                            i: !0,
                            p: Ot,
                            y: qnn,
                            u: 0,
                            z: 0
                        }), A5(Znn, s.AD, s.fy, s.ps, s.c.ai, A2(tu, drn, x5)));
                }
            case 3:
                return v(3 === (t = n.a).$ ? m(r, {
                    de: A2(tC, u = t.a, t.b)
                }) : r, Qp);
            case 2:
                switch((t = n.a).$){
                    case 3:
                        if (u = t.a, Brn(r.c)) return v(r, Qp);
                        if (z5(r.c)) return v(m(r, {
                            p: It(u)
                        }), wrn({
                            jg: r.l,
                            yZ: u
                        }));
                        if (P5(r.c)) {
                            var l = U5(r) ? prn : mrn, d = Grn(r), b = U5(r) ? A2(Irn, d, u) : Prn(d);
                            return v(m(r, {
                                b: zj(r.b),
                                r: l,
                                i: !1,
                                p: It(u)
                            }), b);
                        }
                        return I5(r.c) ? v(m(r, {
                            b: zj(r.b),
                            i: !1,
                            p: It(u)
                        }), Mrn({
                            ik: "csv",
                            jg: r.l,
                            yZ: u
                        })) : O5(r.c) ? v(m(r, {
                            b: zj(r.b),
                            i: !1,
                            p: It(u)
                        }), Mrn({
                            ik: "xlsx",
                            jg: r.l,
                            yZ: u
                        })) : W5(r.c) ? v(m(r, {
                            b: zj(r.b),
                            i: !1,
                            p: It(u)
                        }), Lrn({
                            b4: Qrn(r),
                            jg: r.l,
                            yZ: u
                        })) : v(m(r, {
                            b: zj(r.b),
                            i: !1,
                            p: It(u)
                        }), Qp);
                    case 2:
                        return v(m(r, {
                            b: Bj(r.b),
                            x: Cnn,
                            D: Ann,
                            r: Enn,
                            y: qnn,
                            u: 0,
                            z: 0
                        }), Uu(w([
                            Arn(r),
                            Zrn(r),
                            Rrn(r)
                        ])));
                    default:
                        return v(r, Qp);
                }
            case 6:
                return v(m(r, {
                    b: Bj(r.b),
                    x: Cnn,
                    D: Ann,
                    r: Enn,
                    i: !1,
                    p: Ot,
                    y: qnn,
                    u: 0,
                    z: 0
                }), Uu(w([
                    Arn(r),
                    Zrn(r),
                    Rrn(r)
                ])));
            case 7:
                return v(r, A5(Znn, r.AD, r.fy, r.ps, r.c.ai, A2(tu, vrn, x5)));
            case 4:
                return 3 === (t = n.a).$ ? (u = t.a, v(m(r, {
                    b: Bj(r.b),
                    x: Cnn,
                    D: Ann,
                    r: Enn,
                    i: !1,
                    p: Ot,
                    y: qnn,
                    u: 0,
                    z: 0,
                    de: kc
                }), Uu(w([
                    A2(Vrn, u, A2(tu, lrn({
                        Bd: r.c.Bd,
                        rp: u
                    }), x5)),
                    Arn(r),
                    Zrn(r),
                    Rrn(r)
                ])))) : v(r, Qp);
            case 5:
                var p = n.a, $ = n.b;
                return v(r, $.$ ? $9(p.rp) : A3(yrn, p.Bd, "application/octet-stream", $.a));
            case 8:
                var g = A2(Sj, n.a, r.b), h = g.b;
                return v(m(r, {
                    b: g.a
                }), A2(Wp, A2(qc, x5, k5), h));
            case 10:
                var y = r.g;
                return v(m(r, {
                    g: m(y, {
                        aS: Ot
                    }),
                    ap: !0,
                    b: Bj(r.b),
                    x: Cnn,
                    D: Ann,
                    r: Enn,
                    i: !1,
                    p: Ot,
                    y: qnn,
                    u: 0,
                    z: 0
                }), Uu(w([
                    Hrn(y.aS),
                    Arn(r),
                    Zrn(r),
                    Rrn(r)
                ])));
            case 9:
                return v(m(r, {
                    dD: x = n.a
                }), Qp);
            default:
                var x = n.a;
                return v(m(r, {
                    ck: m(r.ck, {
                        r8: It(n.b),
                        cv: It(x)
                    })
                }), Qp);
        }
    }), Krn = Xn("mountDocxHtml", function(n) {
        return rx(w([
            v("elementId", tx(n.b4)),
            v("html", tx(n.si))
        ]));
    }), Wrn = F2(function(n, r) {
        return Krn({
            b4: Crn(n),
            si: r
        });
    }), Xrn = {
        $: 3
    }, Yrn = function(n) {
        return v(m(n, {
            b: Bj(n.b),
            x: Cnn,
            D: Xrn,
            r: Enn,
            p: Ot,
            y: qnn,
            u: 0,
            z: 0
        }), Uu(w([
            Arn(n),
            Zrn(n),
            Rrn(n)
        ])));
    }, Jrn = A4(JQ, F3(function(n, r, t) {
        return {
            si: t,
            lI: r,
            jg: n
        };
    }), A2(Iu, "requestId", M$), A2(Iu, "ok", ru), A2(Iu, "html", ik(M$))), ntn = F2(function(n, r) {
        var t = A2(WA, Jrn, n);
        if (t.$) return Yrn(r);
        var e, u = t.a.lI, a = t.a.si;
        if (i(t.a.jg, r.l) && j5(r.b)) {
            if (u) {
                if (a.$) return Yrn(r);
                var c = a.a;
                return mu(c) ? Yrn(r) : v(m(r, {
                    D: (e = c, {
                        $: 2,
                        a: e
                    })
                }), A2(Wrn, r, c));
            }
            return Yrn(r);
        }
        return v(r, Qp);
    }), rtn = {
        $: 2
    }, ttn = Xn("observePreviewLayout", function(n) {
        return rx(w([
            v("elementId", tx(n.b4)),
            v("requestId", tx(n.jg))
        ]));
    }), etn = function(n) {
        return "fp-box-" + trn(n);
    }, utn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return Brn(r.c) ? t.$ ? v(m(r, {
                    g: m(r.g, {
                        by: !1
                    }),
                    ap: !0
                }), Qp) : v(m(r, {
                    g: m(r.g, {
                        by: !1,
                        aS: It(t.a)
                    }),
                    ap: !1
                }), A2(Nu, function() {
                    return tnn(grn);
                }, Up(50))) : v(r, Qp);
            case 1:
                return v(r, A2(Nu, function() {
                    return tnn(rtn);
                }, Up(50)));
            case 2:
                return v(r, ttn({
                    b4: etn(r.l),
                    jg: r.l
                }));
            default:
                var e = n.a;
                return v(m(r, {
                    g: m(r.g, {
                        L: It(n.b),
                        H: It(e)
                    })
                }), Qp);
        }
    }), atn = {
        $: 5
    }, itn = function(n) {
        return v(m(n, {
            b: Bj(n.b),
            x: Cnn,
            r: Enn,
            p: Ot,
            y: qnn,
            u: 0,
            z: 0
        }), Uu(w([
            Zrn(n),
            Rrn(n)
        ])));
    }, ctn = F2(function(n, r) {
        if (n.$) return P5(r.c) && j5(r.b) ? v(m(r, {
            r: atn
        }), Qp) : v(r, Qp);
        var t, e = n.a;
        if (e.$) return itn(r);
        if (1 === e.a.$) {
            var u = e.a.a.En;
            return i(e.a.a.ur, Grn(r)) && j5(r.b) && P5(r.c) ? v(m(r, {
                r: (t = u, {
                    $: 3,
                    a: t
                })
            }), Qp) : v(r, Qp);
        }
        return itn(r);
    }), otn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ftn = {
        $: 3
    }, stn = {
        $: 3
    }, ltn = function(n) {
        return v(m(n, {
            b: Bj(n.b),
            x: ftn,
            D: Ann,
            r: Enn,
            p: Ot,
            y: stn,
            u: 0,
            z: 3
        }), Uu(w([
            Arn(n),
            Zrn(n),
            Rrn(n)
        ])));
    }, dtn = F5(function(n, r, t, e, u) {
        return {
            B_: e,
            ik: t,
            lI: r,
            jg: n,
            FC: u
        };
    }), vtn = A3(uu, F2(function(n, r) {
        return {
            h3: n,
            jj: r
        };
    }), A2(Iu, "headers", ek(M$)), A2(Iu, "rows", ek(ek(M$)))), btn = A4(JQ, F3(function(n, r, t) {
        return {
            h3: r,
            ur: n,
            jj: t
        };
    }), A2(Iu, "name", M$), A2(Iu, "headers", ek(M$)), A2(Iu, "rows", ek(ek(M$)))), mtn = A6(b5, dtn, A2(Iu, "requestId", M$), A2(Iu, "ok", ru), A2(Iu, "kind", M$), uC(A2(Iu, "grid", vtn)), uC(A2(Iu, "sheets", ek(btn)))), ptn = F2(function(n, r) {
        if (n.$) return v(m(r, {
            u: n.a
        }), Qp);
        var t = A2(WA, mtn, n.a);
        if (t.$) return ltn(r);
        var e, u = t.a;
        if (i(u.jg, r.l) && j5(r.b)) {
            if (u.lI) {
                if ("csv" === u.ik) {
                    var a = u.B_;
                    return a.$ ? ltn(r) : v(m(r, {
                        x: (e = a.a, {
                            $: 2,
                            a: e
                        })
                    }), Qp);
                }
                if ("xlsx" === u.ik) {
                    var c = u.FC;
                    return c.$ ? ltn(r) : v(m(r, {
                        y: otn(c.a),
                        u: 0
                    }), Qp);
                }
                return ltn(r);
            }
            return ltn(r);
        }
        return v(r, Qp);
    }), $tn = function(n) {
        return "fp-video-" + trn(n);
    }, gtn = Xn("videoSeekPreview", function(n) {
        return rx(w([
            v("videoElementId", tx(n.Gz))
        ]));
    }), htn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(m(r, {
                    B: m(t = r.B, {
                        ch: !t.ch
                    })
                }), crn({
                    b4: $tn(r.l)
                }));
            case 1:
                return 1 > (t = r.B).b1 ? v(m(r, {
                    B: m(t, {
                        b1: t.b1 + 1
                    })
                }), A5(Znn, r.AD, r.fy, r.ps, r.c.ai, A2(tu, knn, x5))) : v(m(r, {
                    ap: !0
                }), Qp);
            case 2:
                return (t = r.B).ch || t.fI ? v(m(r, {
                    B: m(t, {
                        b1: 0,
                        dZ: !0
                    })
                }), Qp) : v(m(r, {
                    B: m(t, {
                        b1: 0,
                        dZ: !0,
                        fI: !0
                    })
                }), gtn({
                    Gz: $tn(r.l)
                }));
            default:
                var t, e = n.a;
                return v(m(r, {
                    B: m(t = r.B, {
                        L: It(n.b),
                        H: It(e)
                    })
                }), Qp);
        }
    }), ytn = F2(function(n, r) {
        return {
            lI: r,
            jg: n
        };
    }), wtn = A3(uu, ytn, A2(Iu, "requestId", M$), A2(Iu, "ok", ru)), xtn = F2(function(n, r) {
        var t = A2(WA, wtn, n);
        if (t.$) return ltn(r);
        var e = t.a;
        return i(e.jg, r.l) && j5(r.b) ? e.lI ? v(m(r, {
            z: 2
        }), Qp) : ltn(r) : v(r, Qp);
    }), _tn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(Urn, n.a, r);
            case 1:
                return A2(utn, n.a, r);
            case 2:
                return A2(htn, n.a, r);
            case 3:
                return A2(orn, n.a, r);
            case 4:
                return A2(ntn, n.a, r);
            case 5:
                return A2(ctn, n.a, r);
            case 6:
                return A2(ptn, n.a, r);
            default:
                return A2(xtn, n.a, r);
        }
    }), Ctn = F3(function(n, r, t) {
        var e = A2(ra, r, n.K);
        if (e.$) return b(n, Qp, g);
        var u = A2(_tn, t, e.a), a = u.b;
        return b(m(n, {
            K: A3(ia, r, u.a, n.K)
        }), A2(Wp, n5(r), a), g);
    }), Atn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ktn = {
        F1: Atn(200),
        Gs: function(n) {
            return {
                $: 5,
                a: n
            };
        }
    }, Etn = F2(function(n, r) {
        return A2(bk, w([
            "conversations",
            r,
            "messages"
        ]), mk(n));
    }), qtn = F2(function(n, r) {
        return {
            sl: n,
            Fv: r
        };
    }), Ftn = A3(nk, "sentAt", XZ, A3(nk, "id", M$, au(qtn))), jtn = F5(function(n, r, t, e, u) {
        return A4(lM, n, Ftn, u, A2(dM, function(n) {
            var r, t = w([
                v("files", A2(WU, tx, n.BT))
            ]), e = (r = n.yu).$ ? t : A2(Qt, v("text", tx(r.a)), t), u = function() {
                var r = n.vg;
                return r.$ ? e : A2(Qt, v("parentId", tx(r.a)), e);
            }();
            return rx(u);
        }(e), pk(A2(Etn, r, t))));
    }), Dtn = F3(function(n, r) {
        return v(g, n(r));
    }), Vtn = F2(function(n, r) {
        return v({
            sI: !!r.sJ && r.sI,
            sJ: !0,
            xx: n.BC
        }, Qp);
    }), Btn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(m(r, {
                    EI: n.a
                }), Qp);
            case 1:
                return v(m(r, {
                    bO: !r.bO
                }), Qp);
            case 2:
                var t = n.a;
                return v(m(r, {
                    xo: A2(Xk, t, r.xo) ? A2(no, function(n) {
                        return !i(n, t);
                    }, r.xo) : A2(Qt, t, r.xo)
                }), Qp);
            default:
                return v(m(r, {
                    bO: !1
                }), Qp);
        }
    }), Gtn = F4(function(n, r, t, e) {
        var u = e;
        switch(t.$){
            case 0:
                return v(u, Qp);
            case 1:
                var a = t.a, i = u.bz;
                if (i.b) {
                    var c = i.a, o = i.b, f = function() {
                        if (a.$) return Qp;
                        var n = a.a;
                        return A2(Wnn, n, Knn(It(n)));
                    }(), l = A2(r, c, o), d = l.b;
                    return v(m(u, {
                        bz: l.a,
                        fj: !0
                    }), Uu(w([
                        d,
                        A2(Wp, n.Gs, f)
                    ])));
                }
                return v(m(u, {
                    fj: !1
                }), Qp);
            default:
                var b = t.a, p = v(1 > s(ve(u.bz), b), u.bz);
                if (p.a && p.b.b) {
                    var $ = p.b, g = A2(r, c = $.a, o = $.b), h = g.b;
                    return v(m(u, {
                        bz: g.a
                    }), h);
                }
                return v(u, Qp);
        }
    }), ztn = Xn("uploadFileToApi", function(n) {
        return rx(w([
            v("request", function(n) {
                return rx(w([
                    v("authToken", tx(n.z8)),
                    v("conversationId", tx(n.ps)),
                    v("fileIndex", NQ(n.rw)),
                    v("patientId", tx(n.fy))
                ]));
            }(n.E9)),
            v("url", tx(n.yZ))
        ]));
    }), Stn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return b(m(r, {
                    dv: t,
                    ps: 3 === t.$ ? t.a.Cf : r.ps
                }), Qnn, g);
            case 3:
            case 2:
                return b(r, Qp, g);
            case 40:
                return b(m(r, {
                    dq: n.a
                }), Qp, g);
            case 1:
                if (3 === (xn = n.a).$) {
                    var e = xn.a, u = e.iH ? r.ej : It(e.Gm), a = function() {
                        if (e.iH) {
                            var n = r.aV;
                            if (3 === n.$) {
                                var t = m(e, {
                                    rb: $(e.rb, n.a.rb),
                                    Gm: e.Gm
                                });
                                return A2(tC, t, pa);
                            }
                            return xn;
                        }
                        return xn;
                    }(), c = e.iH ? A2(Nu, function() {
                        return fnn;
                    }, Au(0)) : Uu(w([
                        A2(Nu, function() {
                            return k7;
                        }, Au(0)),
                        Inn,
                        Qnn
                    ])), o = e.iH + e.lo, f = 3 === a.$ ? ve(a.a.rb) : 0, l = function() {
                        if (u.$) return 0 > s(ve(e.rb), e.lo);
                        var n = u.a;
                        return s(f, n) > -1 || s(o, n) > -1;
                    }(), d = (Hn = K7(r.k)).$ ? v(r.K, g) : A7(Nnn, r.k, Hn.a, r.ps, e.rb, r.K, r.a1, n5), p = d.b;
                    return b(m(r, {
                        eu: l,
                        K: d.a,
                        dw: o,
                        dG: !1,
                        e5: !0,
                        bB: !1,
                        bF: e.iH ? r.bF : It(r.bp),
                        dL: It(e.iH),
                        aV: a,
                        ej: u
                    }), Uu(A2(Qt, c, p)), g);
                }
                return b(m(r, {
                    dG: !0,
                    bB: !1,
                    dL: Ot,
                    aV: xn
                }), Qp, g);
            case 4:
                if ("messages-container" === n.a.pc) {
                    var h = jF(n.a.bj), y = A3(Xnn, ktn, h, r.c8), x = y.b;
                    return b(m(r, {
                        c8: y.a
                    }), x, g);
                }
                return b(r, Qp, g);
            case 5:
                var _ = n.a, C = A4(Gtn, ktn, Dtn(ynn), _, r.c8);
                return x = C.b, b(m(r, {
                    c8: C.a
                }), x, g);
            case 6:
                var A = A2(xc, 0, VZ(h = n.a)), k = r.dw, E = 100 > A, q = !(Nn = r.dL).$ && i(Nn.a, k), F = !(Ln = r.ej).$ && s(k, Ln.a) > -1;
                return !E || r.bB || r.eu || r.dG || F || q || !r.e5 ? b(r, Qp, g) : b(m(r, {
                    bB: !0
                }), A2(jc, A2(tu, gp(wnn), dnn), Ck("messages-content")), g);
            case 7:
                return k = r.dw, b(m(r, {
                    ca: !0,
                    dY: It(n.a.al.r8)
                }), (Mn = K7(r.k)).$ ? Qp : A7(U7, r.k, Mn.a, r.ps, k, It(10), Ot, C7), g);
            case 9:
                return b(r, A2(jc, A2(tu, gp(wnn), snn), Ck("messages-content")), g);
            case 8:
                var j = n.a, D = r.dY;
                if (D.$) return b(m(r, {
                    ca: !1
                }), Qp, g);
                var V = j.al.r8 - D.a;
                return b(m(r, {
                    dY: Ot
                }), A2(jc, function() {
                    return vnn;
                }, A3(Hnn, "messages-container", 0, V)), g);
            case 10:
                return b(m(r, {
                    ca: !1
                }), Qp, g);
            case 11:
                return b(r, A2(jc, function(n) {
                    return n.$ ? k7 : lnn;
                }, Ck("messages-container")), g);
            case 12:
                return b(r, X7({
                    pc: "messages-container"
                }), g);
            case 13:
                return b(m(r, {
                    V: n.a
                }), mnn("chat-input-textarea"), g);
            case 14:
                var B = !mu(DD(r.V)), G = !nE(r.X);
                if (B || G) {
                    if (G) return b(m(r, {
                        aF: !0,
                        bD: !0
                    }), A2(Nu, ann, Au(r.X)), g);
                    if (r.cV && !nE(r.bM.xo)) {
                        var z = {
                            BT: g,
                            vg: A2(Op, function(n) {
                                return n.sl;
                            }, r.aZ),
                            yu: mu(DD(r.V)) ? Ot : It(r.V)
                        };
                        return b(m(r, {
                            V: "",
                            bA: !0,
                            bI: It(z),
                            X: g
                        }), Uu(w([
                            A2(Nu, function() {
                                return nnn;
                            }, Au(0)),
                            mnn("chat-input-textarea")
                        ])), g);
                    }
                    var S = K7(r.k);
                    if (S.$) return b(r, Qp, g);
                    var T = S.a;
                    return z = {
                        BT: g,
                        vg: A2(Op, function(n) {
                            return n.sl;
                        }, r.aZ),
                        yu: mu(DD(r.V)) ? Ot : It(r.V)
                    }, b(m(r, {
                        V: "",
                        aF: !0,
                        X: g
                    }), Uu(w([
                        A5(jtn, r.k, T, r.ps, z, unn),
                        mnn("chat-input-textarea")
                    ])), g);
                }
                return b(r, Qp, g);
            case 16:
                return 3 === (pn = n.a).$ ? b(m(r, {
                    bA: !1,
                    aF: !1,
                    aZ: Ot
                }), Uu(w([
                    (Zn = K7(r.k), Zn.$ ? Qp : A7(U7, r.k, Zn.a, r.ps, 0, It(10), Ot, C7)),
                    (Pn = K7(r.eO), Pn.$ ? Qp : A3(j7, r.eO, Pn.a, x7))
                ])), w([
                    cnn
                ])) : b(m(r, {
                    aF: !1
                }), Qp, g);
            case 17:
                return b(r, Rnn(bnn), g);
            case 18:
                return b(m(r, {
                    X: $(r.X, n.a)
                }), Qp, g);
            case 19:
                var P = n.a;
                return b(m(r, {
                    X: A2(Fu, Oc, A2(no, function(n) {
                        return !i(n.a, P);
                    }, A2(ge, F2(function(n, r) {
                        return v(n, r);
                    }), r.X)))
                }), Qp, g);
            case 15:
                var Z = A2(Btn, n.a, r.bM), M = Z.b;
                return b(m(r, {
                    bM: Z.a
                }), A2(Wp, l5, M), g);
            case 20:
                return b(m(r, {
                    bC: !r.bC
                }), Qp, g);
            case 21:
                var L = A2(Vtn, n.a, {
                    sI: r.bC,
                    sJ: r.cW,
                    xx: r.db
                }).a;
                return b(m(r, {
                    bC: L.sI,
                    cW: L.sJ,
                    db: L.xx
                }), Qp, g);
            case 23:
                var N = n.a, H = b(K7(r.k), OC(F_(r.k)), It(JC(r.k)));
                if (H.a.$ || H.b.$ || H.c.$) return b(m(r, {
                    aF: !1,
                    bD: !1
                }), Qp, g);
                T = H.a.a;
                var I = H.b.a, O = H.c.a, Q = A2(ge, F2(function(n) {
                    return ztn({
                        E9: {
                            z8: I,
                            ps: r.ps,
                            rw: n,
                            fy: T
                        },
                        yZ: O + "/v1/member/" + T + "/conversations/" + r.ps + "/files"
                    });
                }), N);
                return b(r, Uu(Q), g);
            case 24:
                if ((pn = n.a).F5) {
                    var R = $(r.em, w([
                        pn.rx
                    ])), U = mu(pn.ry) ? A2(bb, function(n) {
                        return mu(n) ? Ot : It(n);
                    }, A2(Op, function(n) {
                        return n.ur;
                    }, mb(A2(Yp, pn.rw, r.X)))) : It(pn.ry), K = U.$ ? r.a1 : A3(ia, pn.rx, U.a, r.a1);
                    if (s(ve(R), ve(r.X)) > -1) {
                        var W = K7(r.k);
                        return W.$ ? b(m(r, {
                            a1: K,
                            aF: !1,
                            bD: !1
                        }), Qp, g) : (T = W.a, z = {
                            BT: R,
                            vg: A2(Op, function(n) {
                                return n.sl;
                            }, r.aZ),
                            yu: mu(DD(r.V)) ? Ot : It(r.V)
                        }, b(m(r, {
                            a1: K,
                            V: "",
                            bD: !1,
                            X: g,
                            em: g
                        }), A5(jtn, r.k, T, r.ps, z, unn), g));
                    }
                    return b(m(r, {
                        a1: K,
                        em: R
                    }), Qp, g);
                }
                return b(m(r, {
                    aF: !1,
                    bD: !1
                }), Qp, g);
            case 22:
                return A3(Ctn, r, n.a, n.b);
            case 29:
                var X = A2(WA, xnn, n.a);
                return X.$ ? b(r, Qp, g) : A3(Ctn, r, X.a.jg, tnn({
                    $: 0,
                    a: X.a.tx
                }));
            case 30:
                var Y = A2(WA, Unn, n.a);
                return Y.$ ? b(r, Qp, g) : A3(Ctn, r, Y.a.jg, x5(A2(inn, Y.a.cv, Y.a.r8)));
            case 31:
                var J = n.a, nn = A2(jL, F2(function(n, r) {
                    return A2(_tn, x5(function(n) {
                        return {
                            $: 9,
                            a: n
                        };
                    }(J)), r).a;
                }), r.K);
                return b(m(r, {
                    K: nn,
                    dD: J
                }), Qp, g);
            case 32:
                return i(r.a_, It(on = n.a)) ? b(m(r, {
                    aH: Ot,
                    a_: Ot
                }), Qp, g) : b(m(r, {
                    aH: Ot,
                    a_: It(on)
                }), A2(jc, Y7, A3(Vu, RC, Ck("msg-bubble-" + on), Ck("messages-container"))), g);
            case 33:
                return b(m(r, {
                    aH: Ot,
                    a_: Ot
                }), Qp, g);
            case 34:
                return b(m(r, {
                    aH: Ot,
                    aZ: It(n.a),
                    a_: Ot
                }), Qp, g);
            case 35:
                var rn = n.a;
                return b(m(r, {
                    aH: Ot,
                    a_: Ot
                }), pnn(rn), g);
            case 36:
                return b(m(r, {
                    aZ: Ot
                }), Qp, g);
            case 37:
                if (n.a.$) return b(m(r, {
                    aH: It(0)
                }), Qp, g);
                var tn = n.a.a, en = tn.a, un = (ln = tn.b).al.bj + ln.al.r8 - (en.al.bj + en.al.r8), an = en.al.bj - ln.al.bj, cn = s(an, 100) > -1 ? 0 : s(un, 100) > -1 ? 1 : s(an, un) > -1 ? 0 : 1;
                return b(m(r, {
                    aH: It(cn)
                }), Qp, g);
            case 38:
                var on, fn = !A2(UG, on = n.a, r.bw), sn = fn ? A2(jc, onn, A3(Vu, RC, Ck("reply-snippet-" + on), Ck("messages-container"))) : Qp;
                return b(m(r, {
                    bw: A2(fn ? QG : nU, on, r.bw)
                }), sn, g);
            case 39:
                if (n.a.$) return b(r, Qp, g);
                var ln, dn = n.a.a, vn = dn.a, bn = vn.al.bj + vn.al.r8 - ((ln = dn.b).al.bj + ln.al.r8);
                return c = bn > 0 ? A2(jc, function() {
                    return c5;
                }, A2(ju, function(n) {
                    return A3(Hnn, "messages-container", n.eo.mF, n.eo.bj + bn + 16);
                }, Ak("messages-container"))) : Qp, b(r, c, g);
            case 26:
                var mn = K7(r.k);
                return mn.$ ? b(m(r, {
                    bA: !1,
                    bI: Ot
                }), Qp, g) : b(r, A4(gnn, r.k, T = mn.a, z = {
                    vh: A2(Fu, function(n) {
                        return {
                            y1: n
                        };
                    }, r.bM.xo)
                }, J7), g);
            case 25:
                var pn;
                if (3 === (pn = n.a).$) {
                    var $n = pn.a, gn = r.bI;
                    if (gn.$) return b(m(r, {
                        bA: !1,
                        bI: Ot
                    }), Qp, g);
                    var hn = gn.a;
                    return b(m(r, {
                        dv: A2(tC, $n, pa),
                        ps: $n.Cf,
                        cV: !1,
                        aF: !0,
                        bI: Ot
                    }), (Tn = K7(r.k)).$ ? Qp : A5(jtn, r.k, Tn.a, $n.Cf, hn, unn), g);
                }
                return b(m(r, {
                    bA: !1,
                    bI: Ot
                }), Qp, g);
            case 27:
                var yn = n.a;
                if (3 === r.aV.$) {
                    var wn = function() {
                        if (mu(r.ps)) return Qp;
                        var n = K7(r.k);
                        return n.$ ? Qp : A7(U7, r.k, n.a, r.ps, 0, Ot, r.bF, function(n) {
                            return A2(rnn, n, g);
                        });
                    }();
                    return b(m(r, {
                        bp: yn
                    }), wn, g);
                }
                return b(r, Qp, g);
            default:
                var xn;
                if (3 === (xn = n.a).$) {
                    var _n = xn.a, Cn = $(n.b, _n.rb), An = ve(Cn);
                    if (s(_n.Gm, An) > 0 && i(ve(_n.rb), 20)) return k = An, wn = (Sn = K7(r.k)).$ ? Qp : A7(U7, r.k, Sn.a, r.ps, k, Ot, r.bF, function(n) {
                        return A2(rnn, n, Cn);
                    }), b(r, wn, g);
                    var kn = m(_n, {
                        rb: Cn
                    }), En = r.aV;
                    if (3 === En.$) {
                        var qn = En.a, Fn = OR(A2(Fu, function(n) {
                            return n.sl;
                        }, kn.rb)), jn = $(kn.rb, A2(no, function(n) {
                            return !A2(UG, n.sl, Fn);
                        }, qn.rb)), Dn = (a = A2(tC, m(kn, {
                            rb: jn,
                            Gm: kn.Gm
                        }), pa), OR(A2(Fu, function(n) {
                            return n.sl;
                        }, qn.rb))), Vn = A2(no, function(n) {
                            return !A2(UG, n.sl, Dn);
                        }, kn.rb), Bn = nE(Vn) || mu(r.ps) ? g : w([
                            enn(r.ps)
                        ]), Gn = (zn = K7(r.k)).$ ? v(r.K, g) : A7(Nnn, r.k, zn.a, r.ps, Vn, r.K, r.a1, n5);
                        return p = Gn.b, b(m(r, {
                            K: Gn.a,
                            bF: It(r.bp),
                            aV: a
                        }), Uu(A2(Qt, A2(Nu, function() {
                            return k7;
                        }, Au(0)), p)), Bn);
                    }
                    return b(m(r, {
                        bF: It(r.bp)
                    }), A2(Nu, function() {
                        return k7;
                    }, Au(0)), g);
                }
                return b(r, Qp, g);
        }
        var zn, Sn, Tn, Pn, Zn, Mn, Ln, Nn, Hn;
    }), Ttn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === (L = n.b).$) {
                    var e = L.a;
                    if (t) {
                        var u = r.S;
                        if (3 === u.$) {
                            var a = ve((U = u.a).rb) + ve(e.rb), c = m(U, {
                                rb: $(U.rb, e.rb)
                            }), o = A2(tC, c, pa), f = s(a, e.Gm) > -1;
                            return b(m(r, {
                                g_: f,
                                S: o,
                                dw: r.dw + 10,
                                bB: !1
                            }), Qp, g);
                        }
                        return b(m(r, {
                            S: L,
                            dw: 10
                        }), X7({
                            pc: "conversation-list-container"
                        }), g);
                    }
                    var l = function(n) {
                        var r = A2(bb, function(n) {
                            return mu(n) ? Ot : It(n);
                        }, A2(ra, i7, n.yZ.jb));
                        if (1 === r.$) return b(n, Qp, g);
                        var t = r.a;
                        return !i(n._, Ot) || i(n.bg, It(t)) ? b(n, Qp, g) : A2(W7, t, n);
                    }(m(r, {
                        S: L,
                        dw: 10,
                        bF: It(r.bp)
                    })), d = l.b, p = l.c;
                    return b(l.a, Uu(w([
                        X7({
                            pc: "conversation-list-container"
                        }),
                        d
                    ])), p);
                }
                return b(t ? m(r, {
                    bB: !1
                }) : r, Qp, A2(Ik, 0, L));
            case 1:
                var h = A2(c7, It(z = n.a), r.yZ.jb), y = A2(W7, z, r), x = y.c;
                return b(y.a, Uu(w([
                    y.b,
                    h
                ])), x);
            case 2:
                var _ = n.a;
                if (3 === _.$) return h = A2(c7, Ot, r.yZ.jb), b(m(r, {
                    _: Ot,
                    bg: Ot
                }), h, g);
                var C = r._;
                if (C.$) return b(r, Qp, g);
                var A = A2(Stn, _, T = C.a), k = A.a, E = A.b, q = A2(s7, r, x = A.c), F = q.a, j = q.b, D = 1 === r.bg.$ ? !T.cV || k.cV || mu(k.ps) ? v(m(r, {
                    _: It(k)
                }), Qp) : v(m(r, {
                    _: It(k),
                    bg: It(k.ps)
                }), A2(c7, It(k.ps), r.yZ.jb)) : v(m(r, {
                    _: It(k)
                }), Qp), V = D.b;
                return b(D.a, Uu(w([
                    A2(Wp, q8, E),
                    F,
                    V
                ])), j);
            case 3:
                return "conversation-list-container" !== n.a.pc || .8 >= n.a.bj / (n.a.Fk - n.a.AE) || r.bB || r.g_ ? b(r, Qp, g) : b(m(r, {
                    bB: !0
                }), A2(Nu, function() {
                    return u7;
                }, Au(0)), g);
            case 4:
                var B = 3 === (J = r.vn).$ ? It(kM(J.a)) : Ot, G = B.$ ? Qp : A4(C8, r.k, B.a, function(n) {
                    return m(n, {
                        lo: It(10),
                        iH: r.dw
                    });
                }, o8(r.dw));
                return b(r, G, g);
            case 5:
                var z = n.a;
                return G = (Y = f8(r.k)).$ ? Qp : A4(y7, r.k, Y.a, z, a7(z)), b(r, G, g);
            case 6:
                if (3 === n.b.$) {
                    var S = function() {
                        var n = v(f8(r.k), r.S);
                        if (n.a.$ || 3 !== n.b.$) return Qp;
                        var t = n.a.a, e = ve(n.b.a.rb);
                        return A4(C8, r.k, t, function(n) {
                            return m(n, {
                                lo: It(e),
                                iH: 0
                            });
                        }, o8(0));
                    }();
                    return b(r, S, g);
                }
                return b(r, Qp, g);
            case 7:
                var T, P = 0 > s(r.ep, w7) ? 0 : 1, Z = A9($7, r.dV, r.ld, r.k, r.eO, r.yZ, r.f9, r.bp, r.vn, P);
                return E = Z.b, b(m(r, {
                    _: It(T = Z.a),
                    bg: Ot
                }), A2(Wp, q8, E), g);
            case 8:
                return b(m(r, {
                    ep: n.a
                }), Qp, g);
            case 9:
                var M = n.a;
                return 3 === r.S.$ ? (G = function() {
                    var n = r.vn;
                    if (3 === n.$) {
                        var t = n.a, e = r.bF;
                        if (e.$) return A4(C8, r.k, kM(t), function(n) {
                            return m(n, {
                                lo: Ot,
                                iH: 0,
                                mq: Ot
                            });
                        }, function(n) {
                            return A2(e7, n, g);
                        });
                        var u = e.a;
                        return A4(C8, r.k, kM(t), function(n) {
                            return m(n, {
                                lo: Ot,
                                iH: 0,
                                mq: It(u)
                            });
                        }, function(n) {
                            return A2(e7, n, g);
                        });
                    }
                    return Qp;
                }(), b(m(r, {
                    bp: M
                }), G, g)) : b(r, Qp, g);
            default:
                var L;
                if (3 === (L = n.a).$) {
                    var N = L.a, H = $(n.b, N.rb), I = ve(H);
                    if (s(N.Gm, I) > 0 && i(ve(N.rb), 10)) {
                        var O = I;
                        return G = function() {
                            var n = r.vn;
                            if (3 === n.$) {
                                var t = n.a, e = r.bF;
                                if (e.$) return A4(C8, r.k, kM(t), function(n) {
                                    return m(n, {
                                        lo: Ot,
                                        iH: O,
                                        mq: Ot
                                    });
                                }, function(n) {
                                    return A2(e7, n, H);
                                });
                                var u = e.a;
                                return A4(C8, r.k, kM(t), function(n) {
                                    return m(n, {
                                        lo: Ot,
                                        iH: O,
                                        mq: It(u)
                                    });
                                }, function(n) {
                                    return A2(e7, n, H);
                                });
                            }
                            return Qp;
                        }(), b(r, G, g);
                    }
                    var Q = m(N, {
                        rb: H
                    }), R = r.S;
                    if (3 === R.$) {
                        var U, K = R.a, W = OR(A2(Fu, o7, Q.rb)), X = m(Q, {
                            rb: $(Q.rb, U = A2(no, function(n) {
                                return !A2(UG, o7(n), W);
                            }, K.rb))
                        });
                        return b(m(r, {
                            S: A2(tC, X, pa),
                            bF: It(r.bp)
                        }), X7({
                            pc: "conversation-list-container"
                        }), g);
                    }
                    return b(m(r, {
                        S: A2(tC, Q, pa),
                        bF: It(r.bp)
                    }), X7({
                        pc: "conversation-list-container"
                    }), g);
                }
                return b(r, Qp, g);
        }
        var Y, J;
    }), Ptn = function(n) {
        return n.rb;
    }, Ztn = F2(function() {
        return _d("");
    }), Mtn = {
        $: 3
    }, Ltn = {
        $: 20
    }, Ntn = {
        $: 17
    }, Htn = {
        $: 36
    }, Itn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Otn = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Qtn = {
        $: 14
    }, Rtn = F2(function(n, r) {
        return {
            dq: function() {
                var n = r.dq;
                if (3 === n.$) {
                    var t = n.a;
                    return function(n) {
                        return n.xy;
                    }(t) ? function(n) {
                        return n.tO;
                    }(t) : Ot;
                }
                return Ot;
            }(),
            Bb: r.aF || r.bD || r.bA,
            V: r.V,
            CB: !i(r.aZ, Ot),
            Dq: Ntn,
            Dw: Htn,
            DJ: c5,
            DL: Itn,
            D_: Otn,
            D3: Qtn,
            EC: "",
            X: r.X,
            mA: n
        };
    }), Utn = function(n) {
        var r = n.hB;
        return 3 === r.$ ? It(kM(r.a)) : K7(n.k);
    }, Ktn = function(n) {
        return {
            $: 35,
            a: n
        };
    }, Wtn = function(n) {
        return {
            $: 34,
            a: n
        };
    }, Xtn = function(n) {
        return {
            $: 32,
            a: n
        };
    }, Ytn = function(n) {
        return {
            $: 38,
            a: n
        };
    }, Jtn = F2(function(n, r) {
        return {
            K: r.K,
            AD: r.hy,
            bw: r.bw,
            dD: r.dD,
            aH: r.aH,
            Dr: n5,
            DB: Ktn,
            DS: Xtn,
            D$: Wtn,
            D7: Ytn,
            E8: A2(Op, function(n) {
                return n.sl;
            }, r.aZ),
            a_: r.a_,
            mA: n
        };
    }), nen = function(n) {
        var r = n.dv;
        return 3 === r.$ ? r.a.vh : g;
    }, ren = function(n) {
        var r = n.dq;
        if (r.$) return _d("");
        var t = r.a;
        return A2(zx, w([
            Gx("w-full px-4 py-2 bg-warning-surface text-warning-strong")
        ]), w([
            _d(t)
        ]));
    }, ten = F2(function(n, r) {
        return A2(kE, n, {
            $: 3,
            a: r
        });
    }), een = F2(function(n, r) {
        return A2(nu, function(t) {
            return "Enter" === t ? A2(eu, function(t) {
                return t ? {
                    tO: r,
                    wd: !1,
                    yc: !1
                } : {
                    tO: n,
                    wd: !0,
                    yc: !1
                };
            }, A2(Iu, "shiftKey", ru)) : AA("not enter key");
        }, A2(Iu, "key", M$));
    }), uen = function(n) {
        return n.CB ? A2(zx, w([
            Gx("flex items-center justify-between bg-control-secondary px-3 py-1 text-md text-control-primary")
        ]), w([
            A2(Mx, g, w([
                _d(n.mA(_v))
            ])),
            A2(yF, w([
                Yj,
                Kj(w([
                    Gx("text-control-primary")
                ])),
                cF(n.Dw)
            ]), w([
                YE(w([
                    HE("w-3 h-3")
                ]))
            ]))
        ])) : _d("");
    }, aen = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "width", "19"),
            A2(IE, "height", "16"),
            A2(IE, "viewBox", "0 0 19 16"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "path", w([
                A2(IE, "d", "M0 16V0L19 8L0 16ZM2 13L13.85 8L2 3V6.5L8 8L2 9.5V13Z"),
                A2(IE, "fill", "currentColor")
            ]), g)
        ]));
    }, ien = F3(function(n, r, t) {
        var e;
        return A2(zx, w([
            Gx("flex items-center justify-between bg-gray-100 rounded-lg p-2")
        ]), w([
            A2(zx, w([
                Gx("flex items-center space-x-2")
            ]), w([
                JE(w([
                    HE("w-4 h-4 text-gray-600")
                ])),
                A2(zx, g, w([
                    A2(zx, w([
                        Gx("text-sm font-medium text-gray-900")
                    ]), w([
                        _d(t.ur)
                    ])),
                    A2(zx, w([
                        Gx("text-xs text-gray-500")
                    ]), w([
                        _d((e = t.FO, 1024 > e ? oe(e) + " B" : 0 > s(e, 1048576) ? jF(e / 1024) + " KB" : jF(e / 1048576) + " MB"))
                    ]))
                ]))
            ])),
            A2(yF, w([
                Yj,
                Kj(w([
                    Gx("text-gray-400 hover:text-gray-600")
                ])),
                cF(n(r))
            ]), w([
                YE(w([
                    HE("w-4 h-4")
                ]))
            ]))
        ]));
    }), cen = function(n) {
        var r, t = "" === DD(n.V), e = !nE(n.X), u = nE(n.X) ? _d("") : A2(zx, w([
            Gx("mb-2 px-2 space-y-2")
        ]), A2(ge, ien(n.D_), n.X)), a = !t || e, i = a ? "text-primary-300" : "text-primary-200";
        return A2(zx, g, w([
            ren(n),
            uen(n),
            A2(zx, w([
                Gx("bg-white px-4 py-3")
            ]), w([
                u,
                A2(zx, w([
                    Gx("flex items-center space-x-2")
                ]), w([
                    A2(yF, w([
                        Yj,
                        Kj(w([
                            Gx("text-primary-300 flex-shrink-0")
                        ])),
                        cF(n.Dq)
                    ]), w([
                        (r = w([
                            HE("w-4 h-4")
                        ]), A3(OE, "svg", $(w([
                            A2(IE, "width", "19"),
                            A2(IE, "height", "19"),
                            A2(IE, "viewBox", "0 0 19 19"),
                            A2(IE, "fill", "none"),
                            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
                        ]), r), w([
                            A3(OE, "path", w([
                                A2(IE, "d", "M8.01995 18.0449V10.0249H0V8.01995H8.01995V0H10.0249V8.01995H18.0449V10.0249H10.0249V18.0449H8.01995Z"),
                                A2(IE, "fill", "#006CD1")
                            ]), g)
                        ])))
                    ])),
                    A2(MH, w([
                        DF("chat-input-textarea"),
                        Gx("flex-1 rounded-lg py-2 px-4 text-base bg-surface-background-blue resize-none overflow-y-auto min-h-0"),
                        TH(n.EC),
                        oz(n.V),
                        vF(n.Bb),
                        ZH(1),
                        SH(n.DL),
                        A2(ten, "keydown", A2(een, n.D3, n.DJ))
                    ]), g),
                    A2(yF, w([
                        Lj(!a),
                        Yj,
                        Kj(w([
                            Gx(i + " flex-shrink-0")
                        ])),
                        cF(n.D3)
                    ]), w([
                        aen(w([
                            HE("w-4 h-4")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }, oen = $E(0), fen = wE(4), sen = function(n) {
        return n.kR.FH;
    }, len = function(n) {
        return n.kR.FJ;
    }, den = F2(function(n, r) {
        if (r.$) return n;
        var t = r.a;
        return A2(no, function(n) {
            return !i(n.fy, It(t));
        }, n);
    }), ven = fE(3), ben = function(n) {
        var r = n.sI ? "w-full max-w-md" : "w-full max-w-md overflow-hidden", t = Oq(w([
            v("text-primary-600", !0),
            v("leading-relaxed", !0),
            v("overflow-hidden", !n.sI && n.xx)
        ])), e = !n.sI && n.xx ? w([
            A2(VF, "display", "-webkit-box"),
            A2(VF, "-webkit-line-clamp", "2"),
            A2(VF, "-webkit-box-orient", "vertical"),
            A2(VF, "overflow", "hidden"),
            A2(VF, "word-break", "break-word"),
            A2(VF, "white-space", "normal")
        ]) : g, u = A2(den, n.vh, n.AW), a = A2(Fu, A2(tu, function(n) {
            return n.Bd;
        }, xc("Unknown")), u), i = a.b ? a.b.b ? A2(fe, ", ", a) + " " : a.a : "", c = g;
        return A2(Kk, w([
            uF(yE),
            uF(gE),
            Hx(w([
                Gx("flex-1 flex-col px-4")
            ]))
        ]), w([
            A2(zx, A2(Qt, Gx(r), c), w([
                A2(Kk, w([
                    qG,
                    ven,
                    fen,
                    uF(xD),
                    Hx(A2(Qt, t, A2(Qt, DF("participant-header-text"), e)))
                ]), w([
                    _d(i)
                ]))
            ])),
            n.xx && n.sJ ? A2(Kk, w([
                uF(xD),
                Hx(w([
                    Gx("mt-1")
                ]))
            ]), w([
                A2(sF, w([
                    Gx("text-xs text-primary-400 bg-transparent"),
                    qE(n.D5)
                ]), w([
                    _d(n.mA(n.sI ? sen : len))
                ]))
            ])) : _d("")
        ]));
    }, men = {
        $: 1
    }, pen = function(n) {
        return "border border-primary-200 rounded px-2 py-2 cursor-pointer " + (nE(n.xo) ? "bg-white" : "bg-info-300");
    }, $en = F3(function(n, r, t) {
        return nE(r) ? n(sv) : A2(fe, ", ", A2(Fu, function(n) {
            return n.ur;
        }, A2(no, function(n) {
            return A2(Xk, n.y1, r);
        }, t)));
    }), gen = function(n) {
        return nE(n.xo) ? "text-primary-500" : "text-white";
    }, hen = F2(function(n, r) {
        var t, e = A2(Xk, r.y1, n);
        return A2(zx, A2(Qt, Gx("flex space-x-2 p-2 hover:bg-gray-50 cursor-pointer rounded"), $(Yx(gE), w([
            qE((t = r.y1, {
                $: 2,
                a: t
            }))
        ]))), w([
            A2(sz, w([
                Gx("rounded border border-gray-300"),
                Rj("checkbox"),
                uI(e)
            ]), g),
            A2(f_, w([
                VG
            ]), w([
                _d(r.ur)
            ]))
        ]));
    }), yen = F2(function(n, r) {
        return A2(Kk, w([
            Hx(w([
                Gx("absolute top-full left-0 right-0 bg-white border border-primary-200 rounded mt-1 shadow-lg z-10 max-h-60 overflow-y-auto")
            ]))
        ]), w([
            function() {
                var t = r.EI;
                switch(t.$){
                    case 1:
                        return _d("");
                    case 3:
                        var e = t.a;
                        return A2(Kk, w([
                            Hx(w([
                                Gx("p-2")
                            ]))
                        ]), A2(Fu, hen(r.xo), e));
                    case 2:
                        return A2(Kk, w([
                            Hx(w([
                                Gx("flex py-4")
                            ])),
                            Hx(Yx(yE))
                        ]), w([
                            A2(f_, w([
                                VG,
                                x6,
                                Hx(w([
                                    Gx("text-danger-400")
                                ]))
                            ]), w([
                                _d(n($v))
                            ]))
                        ]));
                    default:
                        return A2(Kk, w([
                            Hx(w([
                                Gx("flex py-4")
                            ])),
                            Hx(Yx(yE))
                        ]), w([
                            A2(f_, w([
                                VG,
                                Hx(w([
                                    Gx("text-primary-300")
                                ]))
                            ]), w([
                                _d(n(lv))
                            ]))
                        ]));
                }
            }()
        ]));
    }), wen = F2(function(n, r) {
        var t, e;
        return A2(Kk, w([
            Hx(w([
                Gx("flex-1 relative dropdown" + (r.bO ? " dropdown--open" : ""))
            ]))
        ]), w([
            A2(zx, w([
                Gx(pen(r) + " dropdown-toggle"),
                qE(men)
            ]), w([
                A2(Kk, w([
                    Hx(w([
                        Gx("flex max-w-full space-x-1")
                    ])),
                    Hx(Yx(gE)),
                    Hx(Yx(AF))
                ]), w([
                    A2(f_, w([
                        VG,
                        Hx(w([
                            Gx(gen(r) + " truncate w-0 flex-1")
                        ]))
                    ]), w([
                        _d(A3($en, n, r.xo, (e = r.EI, 3 === e.$ ? e.a : g)))
                    ])),
                    A2(Kk, w([
                        Hx(w([
                            Gx(gen(r))
                        ]))
                    ]), w([
                        _d((t = r.bO, t ? "\u25B2" : "\u25BC"))
                    ]))
                ]))
            ])),
            r.bO ? A2(yen, n, r) : _d("")
        ]));
    }), xen = F2(function(n, r) {
        return n.cV ? A2(Kk, w([
            Hx(w([
                Gx("bg-white border-b border-primary-200 px-4 py-3 flex relative")
            ])),
            Hx(Yx(gE)),
            Hx(Yx(AF))
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("flex-1 mr-2")
                ]))
            ]), w([
                A2(c_, n.DZ, A2(wen, n.mA, n.ET))
            ])),
            function() {
                var r = n.Dz;
                if (r.$) return A2(Kk, w([
                    fen,
                    Hx(w([
                        Gx("cursor-pointer")
                    ]))
                ]), w([
                    A2(Tq, w([
                        Xj
                    ]), 2)
                ]));
                var t = r.a;
                return A2(zx, w([
                    Gx("text-primary-300 cursor-pointer"),
                    qE(t)
                ]), w([
                    A2(Tq, w([
                        Xj
                    ]), 2)
                ]));
            }()
        ])) : A2(Kk, w([
            Hx(w([
                Gx("bg-white border-b border-primary-200 py-3 flex min-h-[60px] flex-shrink-0")
            ])),
            Hx(Yx(oen)),
            Hx(Yx(AF))
        ]), w([
            ben({
                AW: n.AW,
                sI: n.bC,
                sJ: n.cW,
                D5: n.D6,
                vh: n.vh,
                xx: n.db,
                mA: n.mA
            }),
            function() {
                var t = v(n.Dz, r);
                if (t.a.$) return A2(Kk, w(t.b ? [
                    fen,
                    Hx(w([
                        Gx("cursor-pointer")
                    ]))
                ] : [
                    fen,
                    _F,
                    Hx(w([
                        Gx("cursor-pointer px-4")
                    ]))
                ]), w([
                    A2(Tq, w([
                        Xj
                    ]), 2)
                ]));
                if (t.b) {
                    var e = t.a.a;
                    return A2(zx, w([
                        Gx("text-primary-300 text-xl cursor-pointer px-4"),
                        qE(e)
                    ]), w([
                        A2(Tq, w([
                            Xj
                        ]), 2)
                    ]));
                }
                return e = t.a.a, A2(zx, w([
                    Gx("text-primary-300 cursor-pointer"),
                    qE(e)
                ]), w([
                    A2(Tq, w([
                        Xj
                    ]), 2)
                ]));
            }()
        ]));
    }), _en = F3(function(n, r, t) {
        return A2(A2(Hp, n, r), 3, t);
    }), Cen = F3(function(n, r, t) {
        var e = A2(uo, function(n) {
            return n.Fv;
        }, t);
        return Ae(A3(de, F2(function(t, e) {
            if (e.b) {
                var u = 1 !== A2(pU, A2(Ep, n, e.a.tO.Fv), A2(Ep, n, t.Fv));
                return A2(Qt, {
                    tO: t,
                    Fx: u ? A3(_en, n, r, t.Fv) : "",
                    FF: u
                }, e);
            }
            return w([
                {
                    tO: t,
                    Fx: A3(_en, n, r, t.Fv),
                    FF: !0
                }
            ]);
        }), g, e));
    }), Aen = F2(function(n, r) {
        var t = A2(uo, function(n) {
            return n.Fv;
        }, r);
        return function(r) {
            if (r.b) {
                if (r.b.b) {
                    var t = r.a, e = r.b, u = A3(de, F2(function(r, t) {
                        var e = t.a, u = t.b, a = i(e.tO.nC.sl, r.tO.nC.sl), c = A2(Ep, n, e.tO.Fv), o = i(r.tO.Et, Ot) && i(e.tO.Et, Ot) && a && 1 === A2(pU, c, A2(Ep, n, r.tO.Fv)) ? e : m(e, {
                            FE: !0
                        });
                        return v(r, A2(Qt, o, u));
                    }), v(t, g), e), a = u.b, c = m(u.a, {
                        FE: !0
                    });
                    return Ae(A2(Qt, c, a));
                }
                return w([
                    m(r.a, {
                        FE: !0
                    })
                ]);
            }
            return g;
        }(Ae(A3(de, F2(function(r, t) {
            if (t.b) {
                var e = t.a, u = t.b, a = i(e.tO.nC.sl, r.nC.sl), c = A2(Ep, n, e.tO.Fv), o = !i(r.Et, Ot) || !i(e.tO.Et, Ot);
                return A2(Qt, {
                    Aa: r.nC.Bd,
                    tO: r,
                    FD: o || !a || !(1 === A2(pU, c, A2(Ep, n, r.Fv))),
                    FE: !1
                }, A2(Qt, e, u));
            }
            return w([
                {
                    Aa: r.nC.Bd,
                    tO: r,
                    FD: !0,
                    FE: !1
                }
            ]);
        }), g, t)));
    }), ken = F2(function(n, r) {
        if (n.$) return !1;
        var t = r.nC.fy;
        return !t.$ && i(t.a, n.a);
    }), Een = F2(function(n, r) {
        return r.ua(n);
    }), qen = F2(function(n, r) {
        return r.ub(n);
    }), Fen = function(n) {
        return A2(zx, A2(Qt, Gx("flex py-4"), $(Yx(gE), Yx(yE))), w([
            A2(Kk, w([
                VG,
                xE
            ]), w([
                _d(n)
            ]))
        ]));
    }, jen = F2(function(n, r) {
        var t = r.Es.Bd;
        if (1 === t.$) return g;
        var e = t.a, u = n(r.zL ? qen(e) : Een(e));
        return w([
            Fen(u)
        ]);
    }), Den = hE(0), Ven = F2(function(n, r) {
        var t = r ? v(iF, "") : v(Den, "ml-12"), e = t.a;
        return A2(zx, A2(Qt, Gx("flex my-1 " + t.b), Yx(e)), w([
            A2(Kk, w([
                oK,
                xE
            ]), w([
                _d(n)
            ]))
        ]));
    }), Ben = function(n) {
        return n ? "rounded-tl-[0.7em] rounded-tr-[0.7em] rounded-br-none rounded-bl-[0.7em]" : "rounded-tl-[0.7em] rounded-tr-[0.7em] rounded-br-[0.7em] rounded-bl-none";
    }, Gen = F3(function(n, r, t) {
        return A2(A2(Hp, n, r), 4, t);
    }), zen = function(n) {
        return mu(DD(n)) ? Ot : It(n);
    }, Sen = {
        $: 2
    }, Ten = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return A2(EV, w(n ? [
                yV(t.Cd),
                xV
            ] : [
                yV(t.Cd),
                xV,
                Sen,
                N4("hover:text-white focus:text-white")
            ]), w([
                _d(t.qf)
            ]));
        }
        return A2(Mx, g, w([
            _d(r.a)
        ]));
    }), Pen = st(dt), Zen = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Men = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = {
                $: 1,
                a: {
                    qf: e.lr,
                    Cd: (f = e.lr, A2(xu, "http://", f) || A2(xu, "https://", f) ? f : "https://" + f)
                }
            }, i = A3(du, t, e.lh, n), c = mu(i) ? w([
                a
            ]) : w([
                Zen(i),
                a
            ]), o = e.lh + lu(e.lr);
            return $(c, A3(Men, n, u, o));
        }
        var f, s = A2(vu, t, n);
        return mu(s) ? g : w([
            Zen(s)
        ]);
    }), Len = A2(xc, db, lb("(?:https?://)?(?:www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&/=]*)|https?://[^\\s]+")), Nen = F2(function(n, r) {
        var t, e = A3(Men, t = r, A2(Pen, Len, t), 0);
        return A2(Fu, Ten(n), e);
    }), Hen = F2(function(n, r) {
        return r.uc(n);
    }), Ien = function(n) {
        return n.ud;
    }, Oen = function(n) {
        return A2(sF, w([
            Rj("button"),
            Gx("w-full cursor-pointer border-0 bg-transparent px-3 py-2 text-left text-md text-primary-600 hover:bg-info-100"),
            A2(GH, "click", au(v(n.uY, !0)))
        ]), w([
            _d(n.sT)
        ]));
    }, Qen = F2(function(n, r) {
        return A2(zx, w([
            Gx("absolute z-20 min-w-[110px] rounded-md border border-solid border-info-100 bg-white py-1 shadow-md " + (n.zT ? "right-0" : "left-0") + " " + (n.ED ? "top-full mt-1" : "bottom-full mb-1"))
        ]), A2(Fu, Oen, r));
    }), Ren = F2(function(n, r) {
        return A3(r0, "safe-html", A2(Qt, A2(lF, "content", r), n), g);
    }), Uen = F2(function(n, r) {
        return 1 === r.$ ? "" : "overflow-hidden " + Ben(n);
    }), Ken = {
        $: 0,
        a: 2
    }, Wen = {
        kO: g,
        i3: 0
    }, Xen = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return m(r, {
                kO: $(r.kO, A2(Fu, Px(Cu), t))
            });
        }
        return m(r, {
            i3: n.a
        });
    }), Yen = F2(function(n, r) {
        var t = A3(de, Xen, Wen, n), e = function() {
            switch(t.i3){
                case 0:
                case 1:
                    return "bg-gray-100";
                default:
                    return "bg-red-50";
            }
        }();
        return A2(zx, A2(Qt, Gx("flex items-center space-x-2 p-2 rounded-lg " + e), t.kO), r);
    }), Jen = {
        $: 9
    }, nun = {
        $: 6
    }, run = function(n) {
        return {
            $: 5,
            a: n
        };
    }, tun = {
        $: 3
    }, eun = {
        $: 2
    }, uun = function(n) {
        return {
            $: 8,
            a: n
        };
    }, aun = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), iun = {
        $: 0
    }, cun = {
        $: 7
    }, oun = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), fun = {
        $: 10
    }, sun = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lun = {
        $: 1
    }, dun = function(n) {
        return {
            $: 2,
            a: n
        };
    }, vun = {
        $: 1
    }, bun = {
        $: 2
    }, mun = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), pun = {
        $: 0
    }, $un = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gun = jnn, hun = F2(function(n, r) {
        var t = n.g.aS;
        return t.$ ? Brn(n.c) ? "" : r : t.a;
    }), yun = F4(function(n, r, t, e) {
        if (n > 0 && r > 0 && t > 0) {
            var u = function(n) {
                return s(n, w7) > -1 ? 400 : 320;
            }(e), a = r / n * t;
            return s(a, u) > 0 || 0 > s(a, 120);
        }
        return !1;
    }), wun = F4(function(n, r, t, e) {
        var u = b(n, r, t);
        return !!(u.a.$ || u.b.$ || u.c.$) || A4(yun, u.a.a, u.b.a, u.c.a, e);
    }), xun = F2(function(n, r) {
        return A4(wun, r.g.H, r.g.L, r.ck.cv, n);
    }), _un = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? Ot : It(A2(n, r.a, t.a));
    }), Cun = F4(function(n, r, t, e) {
        var u = b(n, r, t);
        if (u.a.$ || u.b.$ || u.c.$) return !1;
        var a = u.a.a, i = u.b.a, c = u.c.a;
        return a > 0 && i > 0 && c > 0 && A4(yun, a, i, c, e);
    }), Aun = F2(function(n, r) {
        return Brn(n.c) ? A2(hun, n, r) : A2(xc, r, n.p);
    }), kun = F2(function(n, r) {
        return A4(wun, r.B.H, r.B.L, r.ck.cv, n);
    }), Eun = $E(2), qun = F2(function(n, r) {
        return r.tR(n);
    }), Fun = FG(0), jun = FG(2), Dun = cr("audio"), Vun = function(n) {
        if (FK(n) || 0 >= n) return "0:00";
        var r = Ne(n), t = A2(Qc, 60, r);
        return oe(r / 60 | 0) + ":" + A3(ib, 2, "0", oe(t));
    }, Bun = function(n) {
        return n.tP;
    }, Gun = function(n) {
        return n.tQ;
    }, zun = Hx(w([
        Gx("text-white")
    ])), Sun = Sx(0), Tun = function(n) {
        var r, t = n.DC ? "flex h-2.5 w-full shrink-0 overflow-hidden rounded-full bg-white/25 pointer-events-none" : "flex h-2.5 w-full shrink-0 overflow-hidden rounded-full bg-divider pointer-events-none", e = w(n.DC ? [
            oK,
            Hx(w([
                Gx("shrink-0 tabular-nums text-white/70")
            ]))
        ] : [
            oK,
            xE,
            Hx(w([
                Gx("shrink-0 tabular-nums")
            ]))
        ]), u = n.qF > 0 && !FK(n.bp) ? A3(Cp, 0, 100, n.bp / A2(Ie, n.qF, 1) * 100) : 0, a = n.qF > 0, i = A3(uu, F2(function(r, t) {
            return n.D1(r / A2(Ie, t, 1));
        }), A2(Iu, "offsetX", I$), A2(M_, w([
            "currentTarget",
            "clientWidth"
        ]), I$)), c = n.mA(n.b9 ? Bun : Gun), o = n.DC ? "relative flex w-full flex-col gap-3 bg-white/10 py-2 px-1" : "relative flex w-full flex-col gap-3 bg-white py-2", f = w(n.DC ? [
            VG,
            GN,
            zun,
            Hx(w([
                Gx("truncate")
            ]))
        ] : [
            VG,
            GN,
            Hx(w([
                Gx("truncate text-primary-600")
            ]))
        ]), s = w(n.DC ? [
            oK,
            Hx(w([
                Gx("text-white/70")
            ]))
        ] : [
            oK,
            Hx(w([
                Gx("text-gray-500")
            ]))
        ]), l = A2(nu, function(r) {
            switch(r){
                case "ArrowLeft":
                    return au(n.D0(-0.05));
                case "ArrowRight":
                    return au(n.D0(.05));
                case "Home":
                    return au(n.D1(0));
                case "End":
                    return au(n.D1(1));
                case " ":
                case "Enter":
                    return au(n.D1(n.bp / A2(Ie, n.qF, 1)));
                default:
                    return AA("ignore");
            }
        }, A2(Iu, "key", M$)), d = n.z7 && !a, b = (r = "h-full min-h-0 rounded-full transition-all duration-100 pointer-events-none", n.DC ? r + " bg-white" : r + " bg-primary"), m = d;
        return A2(Kk, w([
            Hx(w([
                Gx(o),
                A2(lF, "aria-busy", m ? "true" : "false")
            ]))
        ]), w([
            A2(Kk, w([
                Hx(A2(Qt, Gx("flex gap-3 px-1"), Yx(gE)))
            ]), w([
                A2(Kk, w([
                    Hx(A2(Qt, Gx("relative flex h-10 w-10 shrink-0"), $(Yx(gE), Yx(yE))))
                ]), w([
                    A2(yF, w([
                        fF,
                        kz,
                        cF(n.u$),
                        Lj(d),
                        Kj(A2(Qt, Rj("button"), A2(Qt, A2(lF, "aria-label", c), A2(Qt, Gx("h-10 w-10 min-h-0 min-w-0 shrink-0 !p-0"), $(Yx(gE), Yx(yE))))))
                    ]), w([
                        d ? _d("") : A2(Tq, w([
                            zE,
                            Jj,
                            Wj("fill-white size-4")
                        ]), n.b9 ? 38 : 37)
                    ])),
                    d ? A2(Mx, A2(Qt, Gx("pointer-events-none absolute inset-0 flex [&_.spinner__dot]:bg-white"), A2(Qt, A2(lF, "aria-hidden", "true"), $(Yx(gE), Yx(yE)))), w([
                        Lx(w([
                            Sun
                        ]))
                    ])) : _d("")
                ])),
                A2(Kk, w([
                    Hx(w([
                        Gx("flex min-w-0 flex-1 flex-col")
                    ]))
                ]), w([
                    A2(PE, f, w([
                        _d(n.lc)
                    ])),
                    A2(PE, s, w([
                        _d(Vun(n.qF))
                    ]))
                ]))
            ])),
            A2(Kk, w([
                Hx(A2(Qt, Gx("flex w-full gap-2 px-1"), Yx(gE)))
            ]), w([
                A2(PE, e, w([
                    _d(Vun(n.bp))
                ])),
                A2(zx, w([
                    Gx("min-w-0 flex-1 rounded-sm py-1 outline-none"),
                    Oq(w([
                        v("cursor-pointer focus-visible:ring-2 focus-visible:ring-primary-200 focus-visible:ring-offset-2", a),
                        v("pointer-events-none opacity-50", !a)
                    ])),
                    CV(a ? 0 : -1),
                    A2(lF, "role", "slider"),
                    A2(lF, "aria-valuemin", "0"),
                    A2(lF, "aria-valuemax", "100"),
                    A2(lF, "aria-valuenow", oe(Sp(u))),
                    A2(EE, "click", i),
                    A2(EE, "keydown", l)
                ]), w([
                    A2(Kk, w([
                        Hx(w([
                            Gx(t)
                        ]))
                    ]), w([
                        A2(Kk, w([
                            Hx(w([
                                Gx(b),
                                A2(VF, "width", jF(u) + "%")
                            ]))
                        ]), g)
                    ]))
                ])),
                A2(PE, e, w([
                    _d(Vun(n.qF))
                ]))
            ])),
            n.z7 ? A2(Dun, w([
                DF(n.z6),
                iJ(n.de),
                A2(lF, "preload", "none"),
                Gx("pointer-events-none absolute left-0 top-0 h-px w-px overflow-hidden border-0 p-0 opacity-0"),
                A2(EE, "play", au(n.DY)),
                A2(EE, "pause", au(n.DW)),
                A2(EE, "ended", au(n.DI)),
                A2(EE, "error", au(n.uU)),
                A2(EE, "timeupdate", A3(uu, n.D4, A2(M_, w([
                    "target",
                    "currentTime"
                ]), I$), A2(M_, w([
                    "target",
                    "duration"
                ]), I$))),
                A2(EE, "loadedmetadata", A2(eu, n.DQ, A2(M_, w([
                    "target",
                    "duration"
                ]), I$)))
            ]), g) : _d("")
        ]));
    }, Pun = function(n) {
        return n.tS;
    }, Zun = function(n) {
        var r = function() {
            var r = n.C0;
            return r.$ ? g : w([
                A2(lF, "aria-label", r.a)
            ]);
        }(), t = n.Em ? "pointer-events-none absolute inset-0 z-[5] min-h-0 min-w-full animate-opacity-pulse bg-black/30" : "block w-full min-w-full max-w-full animate-opacity-pulse bg-chat-gray", e = A2(fe, " ", A2(no, A2(qc, Bm, mu), w([
            t,
            n.BK
        ])));
        return A2(Kk, w([
            Hx(A2(Qt, A2(lF, "role", "status"), A2(Qt, Gx(e), A2(Qt, A2(lF, "aria-busy", n.z5 ? "true" : "false"), r))))
        ]), g);
    }, Mun = function(n) {
        var r = 1 !== n.EK.$ && n.FK, t = 1 !== n.EK.$ && n.FG, e = A3(uu, n.uW, A2(M_, w([
            "target",
            "naturalWidth"
        ]), I$), A2(M_, w([
            "target",
            "naturalHeight"
        ]), I$)), u = function() {
            var r = n.EK;
            if (1 === r.$) return v("object-contain", "");
            var t = r.a.uN;
            return v(t ? "object-cover" : "object-contain", t ? "" : r.a.Cy ? "object-right" : "object-left");
        }(), a = u.a, i = u.b;
        return A2(Kk, w([
            Hx(w([
                Gx("relative flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden")
            ]))
        ]), w([
            n.by ? Zun({
                z5: !0,
                BK: "",
                C0: Ot,
                Em: !0
            }) : A2(uJ, w([
                iJ(n.Be),
                tJ(n.lc),
                Gx(A2(fe, " ", A2(no, A2(qc, Bm, mu), w([
                    "h-full w-full min-h-0 min-w-0",
                    a,
                    i
                ])))),
                A2(EE, "error", au(n.DK)),
                A2(EE, "load", e)
            ]), g),
            t && !n.by ? Zun({
                z5: !0,
                BK: "",
                C0: Ot,
                Em: !0
            }) : _d(""),
            !r || n.by || t ? _d("") : A2(Kk, w([
                Hx(w([
                    Gx("pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/50 to-transparent")
                ]))
            ]), g),
            !r || n.by || t ? _d("") : A2(Kk, w([
                Hx(A2(Qt, Gx("pointer-events-none absolute inset-x-0 bottom-2 flex"), Yx(yE)))
            ]), w([
                A2(Kk, w([
                    oK,
                    GN,
                    Hx(w([
                        Gx("rounded-full bg-black/40 px-3 py-1 text-white backdrop-blur-sm")
                    ]))
                ]), w([
                    _d(n.mA(Pun))
                ]))
            ]))
        ]));
    }, Lun = cr("video"), Nun = function(n) {
        var r = n.GA ? "h-full min-h-0 w-full object-cover" : "max-h-full min-h-0 w-full object-contain", t = n.CE ? _d("") : A2(sF, vc(w([
            w([
                Rj("button"),
                Gx("absolute inset-0 z-10 flex cursor-pointer border-none bg-black/30 p-0"),
                qE(n.u$)
            ]),
            Yx(gE),
            Yx(yE)
        ])), w([
            A2(Kk, w([
                Hx(A2(Qt, Gx("pointer-events-none flex h-12 w-12 shrink-0 rounded-full bg-white p-0 shadow-md ring-1 ring-white"), $(Yx(gE), Yx(yE))))
            ]), w([
                A2(Tq, w([
                    Xj,
                    Wj("ml-0.5 fill-gray-800")
                ]), 37)
            ]))
        ])), e = A3(uu, n.Ec, A2(M_, w([
            "target",
            "videoWidth"
        ]), I$), A2(M_, w([
            "target",
            "videoHeight"
        ]), I$)), u = n.CE ? g : w([
            A2(lF, "muted", "")
        ]), a = n.CE ? w([
            A2(lF, "controls", "")
        ]) : g;
        return A2(Kk, w([
            Hx(w([
                Gx("relative flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden"),
                Oq(w([
                    v("cursor-pointer", !n.CE)
                ]))
            ]))
        ]), w([
            A2(Lun, vc(w([
                w([
                    DF(n.Gz),
                    iJ(n.de),
                    Gx("block min-h-0 w-full flex-1 " + r),
                    A2(lF, "playsinline", ""),
                    A2(lF, "preload", "metadata"),
                    A2(EE, "loadedmetadata", e),
                    A2(EE, "loadeddata", au(n.DP)),
                    A2(EE, "error", au(n.Eb))
                ]),
                u,
                a
            ])), g),
            n.FL ? Zun({
                z5: !0,
                BK: "",
                C0: Ot,
                Em: !0
            }) : _d(""),
            t
        ]));
    }, Hun = function(n) {
        var r = n.Fz, t = $(Yx(gE), Yx(rD)), e = r.Cy ? "flex w-full cursor-pointer gap-3 border border-gray-200 bg-white px-3 py-2" : "flex w-full cursor-pointer gap-3 border border-white/30 bg-white/10 px-3 py-2 text-white", u = gun(r.BR), a = $(Yx(r.Cy ? Eun : oen), Yx(rD)), i = r.Ad, c = r.ap && Mnn(i) ? 4 : i, o = 3 === c || 4 === c, f = !c || 1 === c, s = function() {
            switch(c){
                case 0:
                    return function(n) {
                        var r, t = function() {
                            var r = n.qg;
                            if (r.$) return g;
                            var t = r.a, e = t.a, u = t.b;
                            return e > 0 && u > 0 ? w([
                                A2(VF, "aspect-ratio", jF(e) + " / " + jF(u))
                            ]) : g;
                        }();
                        return A2(Kk, w([
                            Hx(vc(w([
                                w([
                                    DF(n.we),
                                    Gx("relative flex min-h-0 w-full min-w-0 max-w-full flex-col overflow-hidden bg-chat-gray min-h-file-preview-image max-h-file-preview-mobile md:max-h-file-preview-desktop")
                                ]),
                                t
                            ])))
                        ]), w([
                            A2(Kk, w([
                                Hx(w([
                                    Gx("flex min-h-0 min-w-0 flex-1 flex-col")
                                ]))
                            ]), w([
                                Mun({
                                    Be: n.Be,
                                    lc: n.lc,
                                    by: n.by,
                                    DK: n.DK,
                                    uW: n.uW,
                                    EK: (r = {
                                        Cy: n.Cy,
                                        uN: n.uN
                                    }, {
                                        $: 0,
                                        a: r
                                    }),
                                    FG: n.FG,
                                    FK: n.FK,
                                    mA: n.mA
                                })
                            ]))
                        ]));
                    }({
                        qg: n.g.qg,
                        Be: n.g.Be,
                        lc: u,
                        by: n.g.by,
                        Cy: r.Cy,
                        uN: n.g.uN,
                        DK: r.DR,
                        uW: n.g.DU,
                        we: r.C2,
                        FG: n.g.xB,
                        FK: n.g.FK,
                        mA: r.mA
                    });
                case 1:
                    return function(n) {
                        var r = function() {
                            var r = n.qg;
                            if (r.$) return g;
                            var t = r.a, e = t.a, u = t.b;
                            return e > 0 && u > 0 ? w([
                                A2(VF, "aspect-ratio", jF(e) + " / " + jF(u))
                            ]) : g;
                        }();
                        return A2(Kk, w([
                            Hx(vc(w([
                                w([
                                    DF(n.we),
                                    Gx("relative flex min-h-0 w-full min-w-0 max-w-full flex-col overflow-hidden bg-gray-100 min-h-file-preview-image max-h-file-preview-mobile md:max-h-file-preview-desktop")
                                ]),
                                r
                            ])))
                        ]), w([
                            A2(Kk, w([
                                Hx(w([
                                    Gx("flex min-h-0 min-w-0 flex-1 flex-col")
                                ]))
                            ]), w([
                                Nun({
                                    CE: n.CE,
                                    DP: n.DP,
                                    u$: n.u$,
                                    Eb: n.Eb,
                                    Ec: n.Ec,
                                    FL: n.FL,
                                    de: n.de,
                                    Gz: n.Gz,
                                    GA: n.GA
                                })
                            ]))
                        ]));
                    }({
                        qg: n.B.qg,
                        CE: n.B.ch,
                        DP: n.B.DP,
                        u$: n.B.u$,
                        Eb: n.B.uU,
                        Ec: n.B.uW,
                        we: r.C2,
                        FL: n.B.xB,
                        de: r.de,
                        Gz: n.B.EL,
                        GA: n.B.uN
                    });
                case 2:
                    return function(n) {
                        var r = Yx(n.Cy ? jun : Fun);
                        return A2(Kk, w([
                            Hx(A2(Qt, Gx("flex w-full min-w-0 max-w-full flex-col"), r))
                        ]), w([
                            Tun({
                                z6: n.z6,
                                z7: n.z7,
                                bp: n.bp,
                                qF: n.qF,
                                lc: n.lc,
                                b9: n.b9,
                                DC: n.DC,
                                uU: n.uU,
                                DI: n.DI,
                                DQ: n.DQ,
                                DW: n.DW,
                                DY: n.DY,
                                D0: n.D0,
                                D1: n.D1,
                                D4: n.D4,
                                u$: n.u$,
                                de: n.de,
                                mA: n.mA
                            })
                        ]));
                    }({
                        z6: n.m.b4,
                        z7: n.m.c_,
                        bp: n.m.bp,
                        qF: n.m.qF,
                        lc: u,
                        Cy: r.Cy,
                        b9: n.m.b9,
                        DC: !1,
                        uU: n.m.uU,
                        DI: n.m.DI,
                        DQ: n.m.DQ,
                        DW: n.m.DW,
                        DY: n.m.DY,
                        D0: n.m.D0,
                        D1: n.m.D1,
                        D4: n.m.D4,
                        u$: n.m.u$,
                        de: r.de,
                        mA: r.mA
                    });
                default:
                    return function(n) {
                        return A2(Kk, w([
                            Hx(A2(Qt, Gx("flex w-full min-w-0 gap-3 text-primary-600"), Yx(gE)))
                        ]), w([
                            A2(Kk, w([
                                Hx(A2(Qt, Gx("flex h-12 w-12 shrink-0 rounded-lg bg-primary-100"), $(Yx(gE), Yx(yE))))
                            ]), w([
                                A2(Tq, w([
                                    Xj,
                                    Jj,
                                    Wj("fill-primary-300")
                                ]), 21)
                            ])),
                            A2(Kk, w([
                                Hx(A2(Qt, Gx("flex min-w-0 flex-1 flex-col"), $(Yx(oen), Yx(yE))))
                            ]), w([
                                A2(PE, w([
                                    VG,
                                    GN,
                                    Hx(w([
                                        Gx("w-full truncate text-primary-600")
                                    ])),
                                    Hx(Yx(rD))
                                ]), w([
                                    _d(n.lc)
                                ]))
                            ]))
                        ]));
                    }({
                        lc: u
                    });
            }
        }(), l = f || 2 === c ? a : t, d = f ? "relative flex w-full min-w-[240px] max-w-full flex-col cursor-pointer overflow-hidden border-none bg-transparent p-0" : 2 === c ? "flex w-full min-w-[240px] max-w-full flex-col cursor-pointer bg-white px-3 py-2" : o ? "flex w-full min-w-[240px] max-w-full cursor-pointer gap-3 bg-white px-3 py-3 text-primary-600" : e, v = A2(fe, " ", A2(no, A2(qc, Bm, mu), w([
            d,
            r.GN
        ]))), b = r.mA(qun(u));
        return 1 === c || 2 === c ? A2(Kk, w([
            Hx(A2(Qt, Gx(v), l))
        ]), w([
            s
        ])) : A2(sF, A2(Qt, Rj("button"), A2(Qt, Gx(v), A2(Qt, qE(r.DV(r.dD)), A2(Qt, A2(lF, "aria-label", b), l)))), w([
            s
        ]));
    }, Iun = function(n) {
        return n.qu;
    }, Oun = function(n) {
        return n.tT;
    }, Qun = function(n) {
        return n.t2;
    }, Run = F3(function(n, r, t) {
        return t.bR ? vE : A3(uD, It(n), t, r);
    }), Uun = {
        $: 1
    }, Kun = function(n) {
        return n.tU;
    }, Wun = F2(function(n, r) {
        return r.tV(n);
    }), Xun = function(n) {
        return n.t0;
    }, Yun = F2(function(n, r) {
        return v(n, r);
    }), Jun = F2(function(n, r) {
        return v(n, r);
    }), nan = F2(function(n, r) {
        return r.t$(n);
    }), ran = function(n) {
        return n.t1;
    }, tan = F3(function(n, r, t) {
        var e = function() {
            var n, r = (n = A2(Fu, ve, t)).b ? It(A3(de, Ie, n.a, n.b)) : Ot;
            return r.$ ? 0 : r.a;
        }(), u = A2(Ie, A2(Ie, ve(r), e), 0);
        if (u) {
            var a = function(n) {
                var r = A2(kP, u, n);
                return $(r, A2(xP, u - ve(r), ""));
            }, i = A2(kP, u, $(r, A2(xP, u, "")));
            return {
                h3: A2(ge, F2(function(r, t) {
                    var e = DD(t);
                    return mu(e) ? n(r + 1) : e;
                }), i),
                jj: A2(Fu, a, t)
            };
        }
        return {
            h3: g,
            jj: g
        };
    }), ean = F2(function(n, r) {
        return v(n, r);
    }), uan = cr("caption"), aan = function(n) {
        return n.$ ? Yx(n.a) : n.a;
    }, ian = function(n) {
        return A2(Fu, Px(Cu), A2(bc, aan, n));
    }, can = cr("th"), oan = function(n) {
        var r = n.a, t = n.b;
        return A2(can, A2(Qt, Gx("c-table__header"), ian(r)), w([
            _d(t)
        ]));
    }, fan = function(n) {
        var r = n.a, t = n.b;
        return A2(TY, A2(Qt, Gx("c-table__cell"), ian(r)), t);
    }, san = function(n) {
        var r = n.a, t = n.b;
        return A2(GY, A2(Qt, Gx("c-table__row"), ian(r)), A2(Fu, fan, t));
    }, lan = F3(function(n, r, t) {
        return A2(HY, w([
            Gx("c-table")
        ]), $(function() {
            if (n.$) return g;
            var r = n.a;
            return w([
                A2(uan, w([
                    Gx("sr-only")
                ]), w([
                    _d(r)
                ]))
            ]);
        }(), w([
            A2(OY, g, w([
                A2(GY, g, A2(Fu, oan, r))
            ])),
            A2(IY, g, A2(Fu, san, t))
        ])));
    }), dan = F3(function(n, r, t) {
        var e = A3(tan, function(r) {
            return n(nan(oe(r)));
        }, t.h3, t.jj), u = A2(Kk, w([
            Hx(w([
                Gx("flex min-h-0 min-w-0 flex-1 items-center justify-center px-3 py-4 text-xs text-primary-500 sm:px-4 sm:py-8 sm:text-sm")
            ]))
        ]), w([
            _d(n(ran))
        ]));
        return nE(e.h3) && nE(e.jj) ? u : A2(Kk, w([
            Hx(A2(Qt, Gx("flex min-h-0 min-w-0 flex-1 flex-col bg-white"), Yx(rD)))
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("relative max-h-full min-h-0 min-w-0 flex-1 overflow-auto")
                ]))
            ]), w([
                A3(lan, r, A2(Fu, function(n) {
                    return A2(Jun, g, n);
                }, e.h3), A2(Fu, function(n) {
                    return A2(ean, g, A2(Fu, function(n) {
                        return A2(Yun, g, w([
                            _d(n)
                        ]));
                    }, n));
                }, e.jj))
            ]))
        ]));
    }), van = F3(function(n, r, t) {
        return n ? w([
            A2(lF, "aria-busy", "true"),
            A2(lF, "aria-label", r(t))
        ]) : g;
    }), ban = function(n) {
        return A2(Kk, w([
            Hx(A2(Qt, Gx(n.El), A3(van, n.FI, n.mA, n.CS)))
        ]), w([
            n.pd,
            n.FI ? Zun({
                z5: !0,
                BK: "",
                C0: It(n.mA(n.CT)),
                Em: !0
            }) : _d("")
        ]));
    }, man = function(n) {
        return n.tW;
    }, pan = function(n) {
        return n.tX;
    }, $an = F2(function(n, r) {
        return r.tY(n);
    }), gan = function(n) {
        return n.tZ;
    }, han = function(n) {
        return n.t_;
    }, yan = function(n) {
        switch(n.$){
            case 0:
                return w([
                    A2(lF, "scale", jF(n.a))
                ]);
            case 1:
                return w([
                    A2(lF, "width", oe(n.a))
                ]);
            case 2:
                return w([
                    A2(lF, "height", oe(r = n.a))
                ]);
            default:
                var r = n.b;
                return w([
                    A2(lF, "width", oe(n.a)),
                    A2(lF, "height", oe(r))
                ]);
        }
    }, wan = function(n) {
        switch(n.$){
            case 0:
                return "Scale" + jF(n.a);
            case 1:
                return "Width" + oe(n.a);
            case 2:
                return "Height" + oe(r = n.a);
            default:
                var r = n.b;
                return "WidthHeight" + oe(n.a) + "," + oe(r);
        }
    }, xan = F3(function(n, r, t) {
        return A3(gz, "span", g, w([
            v($(n, $(oe(r), wan(t))), A3(r0, "pdf-element", $(w([
                A2(lF, "name", n),
                A2(lF, "page", oe(r))
            ]), yan(t)), g))
        ]));
    }), _an = function(n) {
        return A2(f_, w([
            VG,
            NE,
            Hx(w([
                Gx("leading-5")
            ]))
        ]), w([
            _d(n.mA(Qun))
        ]));
    }, Can = function(n) {
        return n.t3;
    }, Aan = function(n) {
        return n.t4;
    }, kan = F3(function(n, r, t) {
        return A2(t.t5, n, r);
    }), Ean = F2(function(n, r) {
        return r.t6(n);
    }), qan = F2(function(n, r) {
        return 1 > n ? 0 : A2(dm, A2(Ie, 0, r), n - 1);
    }), Fan = function(n) {
        return n.t7;
    }, jan = function(n) {
        return n.t8;
    }, Dan = F2(function(n, r) {
        return r.t9(n);
    }), Van = function(n) {
        var r = A2(Kk, w([
            Hx(w([
                Gx("flex min-h-0 min-w-0 max-w-full flex-1 flex-col")
            ]))
        ]), w([
            _an({
                mA: n.mA
            })
        ]));
        switch(sJ(n.Bg.BI)){
            case "docx":
                return function(n) {
                    if (3 === n.pd.$) return _d("");
                    var r, t = function(n) {
                        switch(n.$){
                            case 2:
                                return mu(n.a);
                            case 1:
                            case 0:
                                return !0;
                            default:
                                return !1;
                        }
                    }(n.pd), e = 2 === (r = n.pd).$ ? mu(r.a) ? _d("") : A2(Kk, w([
                        Hx(w([
                            DF(n.dP),
                            Gx("document-container"),
                            A2(lF, "aria-label", n.mA($an(n.lc)))
                        ]))
                    ]), g) : _d("");
                    return ban({
                        pd: A2(Kk, w([
                            Hx(A2(Qt, Gx("min-h-0 flex-1"), Yx(rD)))
                        ]), w([
                            e
                        ])),
                        CS: man,
                        CT: pan,
                        El: "pg-viewer-wrapper relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col overflow-y-auto overflow-x-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                        FI: t,
                        mA: n.mA
                    });
                }({
                    pd: n.Bg.eW,
                    lc: n.lc,
                    dP: n.Bg.dP,
                    mA: n.mA
                });
            case "pdf":
                var t = n.Bg.fz;
                return t.$ ? r : function(n) {
                    if (n.Ey.$) {
                        var r = i(n.EN, Ot) || function(n) {
                            switch(n.Ey.$){
                                case 0:
                                case 3:
                                case 5:
                                    return !1;
                                default:
                                    return !0;
                            }
                        }(n), t = function() {
                            var r = v(n.EN, n.Ey);
                            if (r.a.$ || 3 !== r.b.$) return A2(Kk, w([
                                Hx(w([
                                    Gx("min-h-0 min-w-0 w-full flex-1 overflow-y-auto overflow-x-hidden bg-white")
                                ]))
                            ]), g);
                            var t = r.b.a;
                            return 1 > t || 1 > n.Ez ? _d("") : A2(Kk, w([
                                Hx(w([
                                    Gx("min-h-0 min-w-0 w-full flex-1 overflow-y-auto overflow-x-hidden bg-white")
                                ]))
                            ]), A2(Fu, function(r) {
                                var e;
                                return A2(Kk, w([
                                    Hx(w([
                                        Gx(A2(fe, " ", w([
                                            "flex w-full justify-center border-b border-primary-200 py-3",
                                            i(r, t) ? "last:border-b-0 last:pb-6" : ""
                                        ])))
                                    ]))
                                ]), w([
                                    A3(xan, n.Bf, r, (e = n.Ez, {
                                        $: 1,
                                        a: e
                                    }))
                                ]));
                            }, A2($e, 1, t)));
                        }(), e = function() {
                            var r = n.EN;
                            if (r.$) return _d("");
                            var t = r.a, e = i(n.Ey, atn) ? "" : "opacity-0";
                            return A2(Kk, w([
                                Hx(w([
                                    Gx("flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden")
                                ]))
                            ]), w([
                                A2(O6, w([
                                    iJ(t + "#zoom=FitH"),
                                    Gx("h-full min-h-0 w-full min-w-0 flex-1 border-0 " + e),
                                    A2(EE, "load", au(n.DE)),
                                    A2(EE, "error", au(n.DD))
                                ]), g)
                            ]));
                        }();
                        return ban({
                            pd: A2(Kk, w([
                                Hx(w([
                                    Gx("flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden")
                                ]))
                            ]), w([
                                n.Gx ? t : e
                            ])),
                            CS: han,
                            CT: gan,
                            El: "file-viewer-pdf-lightbox relative flex h-full min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                            FI: r,
                            mA: n.mA
                        });
                    }
                    return _d("");
                }(t.a);
            case "csv":
                var e = n.Bg.eS;
                if (e.$) return r;
                var u = e.a;
                return function(n) {
                    switch(n.pd.$){
                        case 3:
                        case 0:
                            return _d("");
                        default:
                            var r = function() {
                                var r = n.pd;
                                if (2 === r.$) {
                                    var t = r.a;
                                    return A3(dan, n.mA, It(n.mA(Wun(n.lc))), t);
                                }
                                return _d("");
                            }(), t = function(n) {
                                switch(n.$){
                                    case 2:
                                    case 3:
                                        return !1;
                                    default:
                                        return !0;
                                }
                            }(n.pd);
                            return ban({
                                pd: A2(Kk, w([
                                    Hx(w([
                                        Gx("flex min-h-0 min-w-0 w-full flex-1 flex-col gap-2")
                                    ]))
                                ]), w([
                                    r
                                ])),
                                CS: Xun,
                                CT: Kun,
                                El: "relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col gap-2 overflow-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                                FI: t,
                                mA: n.mA
                            });
                    }
                }({
                    pd: u.pd,
                    lc: u.lc,
                    mA: n.mA
                });
            case "xlsx":
                var a = n.Bg.gh;
                if (a.$) return r;
                var c = a.a;
                return function(n) {
                    switch(n.pd.$){
                        case 3:
                        case 0:
                            return _d("");
                        default:
                            var r = function(n) {
                                switch(n.$){
                                    case 2:
                                    case 3:
                                        return !1;
                                    default:
                                        return !0;
                                }
                            }(n.pd), t = function() {
                                var r = n.pd;
                                if (2 === r.$) {
                                    var t = r.a, e = A2(qan, ve(t), n.FB), u = ve(t) > 1 ? A2(Kk, w([
                                        Hx(w([
                                            Gx("sheet-names flex w-full flex-col items-start gap-1 px-3 pt-2 sm:flex-row sm:flex-wrap sm:items-start")
                                        ]))
                                    ]), A2(ge, F2(function(r, t) {
                                        return A2(yF, w([
                                            Yj,
                                            cF(n.D2(r)),
                                            Kj(w([
                                                Gx("w-full justify-start text-left !ml-0 rounded-none sm:w-auto"),
                                                Oq(w([
                                                    v("font-semibold", i(r, e)),
                                                    v("opacity-80 hover:bg-gray-50 hover:opacity-100", !i(r, e))
                                                ]))
                                            ]))
                                        ]), w([
                                            _d(t.ur)
                                        ]));
                                    }), t)) : _d(""), a = nE(t) ? A2(Kk, w([
                                        Hx(w([
                                            Gx("flex items-center justify-center px-4 py-8 text-sm text-primary-500")
                                        ]))
                                    ]), w([
                                        _d(n.mA(Can))
                                    ])) : _d(""), c = mb(A2(Yp, e, t));
                                    return b(u, a, function() {
                                        if (c.$) return _d("");
                                        var r = c.a, t = {
                                            h3: r.h3,
                                            jj: r.jj
                                        }, e = mu(DD(r.ur)) ? n.mA(Ean(n.lc)) : n.mA(A2(kan, n.lc, r.ur));
                                        return A3(dan, n.mA, It(e), t);
                                    }());
                                }
                                return b(_d(""), _d(""), _d(""));
                            }(), e = t.a, u = t.b, a = t.c;
                            return ban({
                                pd: A2(Kk, w([
                                    Hx(w([
                                        Gx("flex min-h-0 min-w-0 w-full flex-1 flex-col gap-2")
                                    ]))
                                ]), w([
                                    e,
                                    u,
                                    A2(Kk, w([
                                        Hx(w([
                                            Gx("min-h-0 min-w-0 w-full flex-1")
                                        ]))
                                    ]), w([
                                        a
                                    ]))
                                ])),
                                CS: Xun,
                                CT: Aan,
                                El: A2(fe, " ", w([
                                    "spreadsheet-viewer relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col gap-2 overflow-hidden rounded-lg shadow-2xl pointer-events-auto",
                                    r ? "" : "bg-white"
                                ])),
                                FI: r,
                                mA: n.mA
                            });
                    }
                }({
                    pd: c.pd,
                    lc: c.lc,
                    D2: c.D2,
                    FB: c.FB,
                    mA: n.mA
                });
            case "xml":
                var o = n.Bg.gi;
                if (o.$) return r;
                var f = o.a;
                return function(n) {
                    switch(n.pd){
                        case 3:
                        case 0:
                            return _d("");
                        default:
                            var r = function(n) {
                                switch(n){
                                    case 2:
                                    case 3:
                                        return !1;
                                    default:
                                        return !0;
                                }
                            }(n.pd), t = n.mA(Dan(n.lc)), e = vc(w([
                                w([
                                    Oq(w([
                                        v("xml-preview min-h-0 w-full flex-1 overflow-auto p-3 text-sm text-primary-dark", !0),
                                        v("bg-white", !r),
                                        v("px-4 py-8", r)
                                    ])),
                                    DF(n.dP)
                                ]),
                                r ? g : w([
                                    A2(lF, "aria-label", t)
                                ])
                            ]));
                            return ban({
                                pd: A2(Kk, w([
                                    Hx(w([
                                        Gx("flex min-h-0 min-w-0 w-full flex-1 flex-col")
                                    ])),
                                    uF(rD)
                                ]), w([
                                    A2(Kk, w([
                                        Hx(e)
                                    ]), g)
                                ])),
                                CS: jan,
                                CT: Fan,
                                El: "relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col gap-2 overflow-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                                FI: r,
                                mA: n.mA
                            });
                    }
                }({
                    pd: f.pd,
                    lc: f.lc,
                    dP: f.dP,
                    mA: n.mA
                });
            default:
                return r;
        }
    }, Ban = function(n) {
        switch(n.Au){
            case 0:
                return Mun({
                    Be: n.Cg,
                    lc: n.lc,
                    by: n.by,
                    DK: n.DK,
                    uW: n.uW,
                    EK: Uun,
                    FG: !1,
                    FK: !1,
                    mA: n.mA
                });
            case 3:
                var r = n.Bg;
                return r.$ ? _an({
                    mA: n.mA
                }) : Van({
                    Bg: r.a,
                    lc: n.lc,
                    mA: n.mA
                });
            default:
                return _an({
                    mA: n.mA
                });
        }
    }, Gan = function(n) {
        if (n.i) return function(n) {
            return A3($0, "modal__content--file-viewer-unsupported", w([
                Hj(w([
                    A2(Kk, w([
                        sE,
                        qG,
                        Hx(w([
                            Gx("text-black pr-2 leading-6")
                        ]))
                    ]), w([
                        _d(n.mA(Oun))
                    ]))
                ])),
                Mj(w([
                    A2(f_, w([
                        VG,
                        NE,
                        Hx(w([
                            Gx("leading-5")
                        ]))
                    ]), w([
                        _d(n.mA(Qun))
                    ]))
                ])),
                Nj(w([
                    A2(yF, w([
                        fF,
                        cF(n.DG)
                    ]), w([
                        _d(n.mA(Iun))
                    ])),
                    A2(yF, w([
                        CD,
                        cF(n.Dy)
                    ]), w([
                        _d(n.mA(V4))
                    ]))
                ]))
            ]), n.fq);
        }({
            fq: n.fq,
            Dy: n.Dy,
            DG: n.DH,
            mA: n.mA
        });
        var r = function() {
            var r = v(n.Au, n.Bg);
            return 3 === r.a && !r.b.$;
        }();
        return A2(r ? Run("modal-wrap--file-viewer") : lD(1), w([
            bX,
            Mj(w([
                A2(Kk, w([
                    Hx(w([
                        Gx(r ? "p-5 sm:p-8 md:p-12 flex h-full min-h-0 w-full min-w-0 flex-1 flex-col items-stretch justify-start overflow-hidden pointer-events-none" : "flex h-full min-h-0 w-full min-w-0 flex-1 flex-col items-center justify-center pointer-events-none")
                    ]))
                ]), w([
                    Ban({
                        Au: n.Au,
                        Bg: n.Bg,
                        lc: n.EM,
                        by: n.by,
                        Cg: n.Ch,
                        DK: n.DK,
                        uW: n.uW,
                        mA: n.mA
                    })
                ]))
            ]))
        ]), n.fq);
    }, zan = F6(function(n, r, t, e, u, a) {
        var c = A2(kun, e, a), o = gun(a.c.ai), f = Brn(a.c), s = A4(Cun, a.g.H, a.g.L, a.ck.cv, e), l = !a.ap && f && (a.g.by || i(a.g.aS, Ot)), d = A2(xun, e, a), v = a.dD > 0 ? a.dD : e, b = A2(Ie, 1, v - 32), m = v > 0 && 1024 > v, p = Snn(a.c), $ = !p && !a.ap && !l && i(a.g.H, Ot), h = 1 === p && !a.ap && !a.B.dZ;
        return A2(Kk, g, w([
            Hun({
                m: {
                    bp: a.m.bp,
                    qF: a.m.qF,
                    b4: ern(a.l),
                    b9: a.m.b9,
                    c_: a.m.c_,
                    uU: Jnn(Jen),
                    DI: Jnn(nun),
                    DQ: A2(qc, Jnn, run),
                    DW: Jnn(tun),
                    DY: Jnn(eun),
                    D0: A2(qc, Jnn, uun),
                    D1: A2(qc, Jnn, Ynn),
                    D4: F2(function(n, r) {
                        return Jnn(A2(aun, n, r));
                    }),
                    u$: Jnn(iun)
                },
                g: {
                    qg: A3(_un, RC, a.g.H, a.g.L),
                    Be: A2(hun, a, u),
                    by: l,
                    uN: d,
                    DU: F2(function(n, r) {
                        return tnn(A2(oun, n, r));
                    }),
                    xB: $,
                    FK: s && !p
                },
                Fz: {
                    l: a.l,
                    Ad: p,
                    BR: a.c.ai,
                    dD: e,
                    Cy: r,
                    ap: a.ap,
                    C2: etn(a.l),
                    DR: x5(fun),
                    DV: A2(qc, x5, sun),
                    de: u,
                    mA: n,
                    GN: A2(Uen, r, t)
                },
                B: {
                    qg: A3(_un, RC, a.B.H, a.B.L),
                    uN: c,
                    uU: dun(vun),
                    DP: dun(bun),
                    uW: F2(function(n, r) {
                        return dun(A2(mun, n, r));
                    }),
                    u$: dun(pun),
                    ch: a.B.ch,
                    EL: $tn(a.l),
                    xB: h
                }
            }),
            Gan({
                Au: p,
                Bg: S5(a) ? It({
                    eS: Ot,
                    eW: a.D,
                    BI: G5(a.c),
                    dP: Crn(a),
                    fz: Ot,
                    gh: Ot,
                    gi: Ot
                }) : P5(a.c) && !a.i ? It({
                    eS: Ot,
                    eW: Ann,
                    BI: G5(a.c),
                    dP: "",
                    fz: It({
                        Bf: Grn(a),
                        DD: x5(fun),
                        DE: C5(lun),
                        Ey: a.r,
                        Ez: b,
                        EN: a.p,
                        mA: n,
                        Gx: m
                    }),
                    gh: Ot,
                    gi: Ot
                }) : I5(a.c) && !a.i ? It({
                    eS: It({
                        pd: a.x,
                        lc: o
                    }),
                    eW: Ann,
                    BI: G5(a.c),
                    dP: "",
                    fz: Ot,
                    gh: Ot,
                    gi: Ot
                }) : O5(a.c) && !a.i ? It({
                    eS: Ot,
                    eW: Ann,
                    BI: G5(a.c),
                    dP: "",
                    fz: Ot,
                    gh: It({
                        pd: a.y,
                        lc: o,
                        D2: A2(qc, H5, $un),
                        FB: a.u
                    }),
                    gi: Ot
                }) : W5(a.c) && !a.i ? It({
                    eS: Ot,
                    eW: Ann,
                    BI: G5(a.c),
                    dP: "",
                    fz: Ot,
                    gh: Ot,
                    gi: It({
                        pd: a.z,
                        lc: o,
                        dP: Qrn(a)
                    })
                }) : Ot,
                by: l,
                Ch: A2(Aun, a, u),
                fq: a.b,
                Dy: x5(_nn),
                DH: x5(cun),
                DK: x5(fun),
                uW: F2(function(n, r) {
                    return tnn(A2(oun, n, r));
                }),
                EM: o,
                i: a.i,
                mA: n
            })
        ]));
    }), San = F5(function(n, r, t, e, u) {
        var a = u.de;
        switch(a.$){
            case 3:
                return A6(zan, n, r, t, e, a.a, u);
            case 0:
                return A6(zan, n, r, t, e, "", u);
            case 1:
                return A2(zx, w([
                    Gx(A2(fe, " ", A2(no, A2(qc, Bm, mu), w([
                        "h-24 w-full min-w-[240px] max-w-xs animate-opacity-pulse bg-chat-gray",
                        A2(Uen, r, t)
                    ])))),
                    A2(lF, "role", "status")
                ]), g);
            default:
                var i = Snn(u.c);
                return A2(zx, w([
                    Gx(A2(fe, " ", A2(no, A2(qc, Bm, mu), w([
                        "w-full",
                        A2(Uen, r, t)
                    ]))))
                ]), w([
                    A2(Yen, w([
                        Ken
                    ]), w([
                        A2(Tq, w([
                            zE,
                            Wj("text-red-600")
                        ]), 10),
                        A2(PE, w([
                            VG,
                            x6
                        ]), w([
                            _d(n(i ? bv : mv))
                        ]))
                    ]))
                ]));
        }
    }), Tan = F5(function(n, r, t, e, u) {
        var a = t + "_" + u, i = A2(ra, a, n.K);
        if (i.$) return _d("");
        var c = i.a;
        return A2(c_, n.Dr(a), A5(San, n.mA, r, e, n.dD, c));
    }), Pan = F5(function(n, r, t, e, u) {
        var a;
        return nE(u.BT) ? _d("") : A2(zx, w([
            Gx(A2(fe, " ", A2(no, A2(qc, Bm, mu), w([
                "w-full min-w-0 max-w-message-attachments",
                "bg-transparent",
                "space-y-2",
                r ? "ml-auto" : "",
                t && !e ? "mt-2" : ""
            ]))))
        ]), (a = ve(u.BT), A2(ge, F2(function(t, e) {
            return A5(Tan, n, r, u.sl, It({
                lh: t,
                Gm: a
            }), e);
        }), u.BT)));
    }), Zan = F6(function(n, r, t, e, u, a) {
        var c, o, f, s, l = a.$ ? "" : "ml-12", d = A2(bb, zen, u.yu), b = A2(Qt, {
            sT: n.mA(_v),
            uY: n.D$(u)
        }, function() {
            if (d.$) return g;
            var r = d.a;
            return w([
                {
                    sT: n.mA(dv),
                    uY: n.DB(r)
                }
            ]);
        }()), m = i(n.a_, It(u.sl)), p = i(n.E8, It(u.sl)), h = !i(n.E8, Ot), y = A2(ken, e, u), x = y ? iF : Den, _ = function() {
            var n = u.Fg;
            if (n.$) {
                var r = u.yu;
                if (1 === r.$) return _d("");
                var t = r.a;
                return mu(DD(t)) ? _d("") : A2(Kk, w([
                    qG,
                    Hx(w([
                        Gx("whitespace-pre-line")
                    ]))
                ]), A2(Nen, y, t));
            }
            var e = n.a;
            return mu(DD(e)) ? _d("") : A2(Kk, w([
                qG,
                Hx(w([
                    Gx("[&_p]:m-0")
                ]))
            ]), w([
                A2(Ren, g, e)
            ]));
        }(), C = y ? "bg-info-200 text-primary-600 " : "bg-primary-500 text-white ", A = function() {
            var r = u.Eq;
            if (r.$) return _d("");
            var t = r.a, a = !i(t.nC.fy, Ot) && i(t.nC.fy, e);
            return function(n) {
                var r = i(n.Eq.yu, Ot) ? "" : "cursor-pointer", t = n.la ? A2(xc, n.Eq.FR, n.Eq.yu) : n.Eq.FR, e = n.la ? "" : "truncate", u = n.mA(n.CG ? Ien : Hen(A2(xc, "", n.Eq.nC.Bd)));
                return A2(zx, w([
                    Gx("mb-2 max-w-[200px] border-0 border-l-2 border-solid pl-2 text-md " + (n.Cz ? "border-primary-600 text-primary-600" : "border-white text-white") + " " + r),
                    DF(n.b4),
                    A2(GH, "click", au(v(n.lL, !0)))
                ]), w([
                    A2(zx, w([
                        Gx("truncate font-bold")
                    ]), w([
                        _d(u)
                    ])),
                    A2(zx, w([
                        Gx(e)
                    ]), w([
                        _d(t)
                    ]))
                ]));
            }({
                b4: "reply-snippet-" + u.sl,
                la: A2(UG, u.sl, n.bw),
                Cz: y,
                CG: a,
                lL: n.D7(u.sl),
                Eq: t,
                mA: n.mA
            });
        }(), k = y ? iF : Den, E = A2(zx, A2(Qt, Gx("flex opacity-70 mb-2 " + l), Yx(k)), w([
            A2(Kk, w([
                oK,
                xE
            ]), w([
                _d(A3(Gen, r, t, u.Fv))
            ]))
        ])), q = h && !p, F = (c = function(n) {
            return !i(A2(bb, zen, n), Ot);
        })(u.yu) || c(u.Fg), j = 1 !== (o = u.yu).$ && !mu(DD(o.a)), D = 1 !== (f = u.Fg).$ && !mu(DD(f.a)), V = !nE(u.BT), B = D || j, G = q ? " blur-sm pointer-events-none" : "", z = a.$ ? "flex mb-1" : "flex mb-1 items-end space-x-2", S = "w-fit max-w-lg flex flex-col overflow-hidden p-2 " + $(C, Ben(y)), T = (s = v(F && m && !h, n.aH)).a && !s.b.$ ? A2(Qen, {
            zT: y,
            ED: s.b.a
        }, b) : _d(""), P = function(r) {
            return F ? A2(zx, w([
                Gx("dropdown relative"),
                DF("msg-bubble-" + u.sl),
                qE(n.DS(u.sl))
            ]), w([
                r,
                T
            ])) : r;
        }, Z = function() {
            if (B && V) {
                var r = "flex w-full " + (y ? "justify-end" : "justify-start");
                return A2(zx, w([
                    Gx(A2(fe, " ", A2(no, A2(qc, Bm, mu), w([
                        "flex w-full min-w-0 max-w-lg flex-col gap-4",
                        y ? "ml-auto" : ""
                    ]))))
                ]), w([
                    A2(zx, w([
                        Gx(r)
                    ]), w([
                        P(A2(zx, w([
                            Gx(S)
                        ]), w([
                            A,
                            _
                        ])))
                    ])),
                    A2(zx, w([
                        Gx(r)
                    ]), w([
                        A5(Pan, n, y, !1, !0, u)
                    ]))
                ]));
            }
            return B || V ? V ? A2(zx, w([
                Gx("flex w-full min-w-0 max-w-lg flex-col bg-transparent p-0")
            ]), w([
                A5(Pan, n, y, !1, !1, u)
            ])) : P(A2(zx, w([
                Gx(S)
            ]), w([
                A,
                _
            ]))) : _d("");
        }();
        return A2(zx, w([
            Gx("flex flex-col" + G)
        ]), w([
            A2(zx, A2(Qt, Gx(z), Yx(x)), w(a.$ ? [
                Z
            ] : [
                a.a,
                Z
            ])),
            E
        ]));
    }), Man = F5(function(n, r, t, e, u) {
        return A6(Zan, n, r, t, e, u, Ot);
    }), Lan = function(n) {
        return w(n.trim().split(/\s+/g));
    }, Nan = function(n) {
        var r = A2(xc, "text-primary-600", n.Gb), t = function() {
            var r = n.Ak;
            return r.$ ? "" : "border " + r.a;
        }(), e = A2(fe, " ", w([
            "w-10 h-10 rounded-full flex",
            A2(xc, "bg-info-200", n.Ac),
            t
        ])), u = $(Yx(gE), Yx(yE));
        return A2(zx, A2(Qt, Gx(e), u), w([
            n.CA ? A2(Tq, w([
                Wj("text-white")
            ]), 32) : A2(Kk, w([
                VG,
                GN,
                Hx(w([
                    Gx(r)
                ]))
            ]), w([
                _d(n.Cm)
            ]))
        ]));
    }, Han = F2(function(n, r) {
        var t = !A2(ken, n, r.tO) && r.FE, e = function(n) {
            if (n.$) return "?";
            var r, t = n.a;
            return r = A2(fe, "", A2(Fu, A2(tu, pu(1), Db), A2(kP, 2, Lan(t)))), mu(r) ? "?" : r;
        }(r.tO.nC.Bd);
        return A2(zx, w([
            Gx("flex-shrink-0 w-10 flex items-end")
        ]), w([
            t ? Nan({
                Ac: It("bg-light-divider"),
                Ak: It("border-light-divider"),
                Cm: e,
                CA: !1,
                Gb: It("text-gray-600")
            }) : A2(zx, w([
                Gx("w-10 h-10")
            ]), g)
        ]));
    }), Ian = F5(function(n, r, t, e, u) {
        var a = A2(ken, e, u.tO) ? Ot : It(A2(Han, e, u));
        return A6(Zan, n, r, t, e, u.tO, a);
    }), Oan = F6(function(n, r, t, e, u, a) {
        var c = a.FF ? w([
            Fen(a.Fx)
        ]) : g, o = a.tO, f = o.Et;
        if (f.$) {
            var s = mb(A2(no, function(n) {
                return i(n.tO.sl, o.sl);
            }, u)), l = function() {
                if (s.$) return w([
                    A5(Man, n, r, t, e, o)
                ]);
                var u = s.a, a = w([
                    A5(Ian, n, r, t, e, u)
                ]);
                return $(u.FD && !A2(ken, e, u.tO) ? w([
                    A2(Ven, A2(xc, "", u.Aa), A2(ken, e, u.tO))
                ]) : g, a);
            }();
            return $(c, l);
        }
        return $(c, A2(jen, n.mA, f.a));
    }), Qan = F5(function(n, r, t, e, u) {
        var a = A3(Cen, r, t, u.rb), i = A2(Aen, r, u.rb);
        return A2(zx, w([
            DF("messages-content"),
            Gx("flex flex-col")
        ]), A2(bc, A5(Oan, n, r, t, e, i), a));
    }), Ran = function(n) {
        var r = "relative flex-1 " + (i(n.Dc.E8, Ot) ? "overflow-y-auto" : "overflow-hidden") + " bg-surface-background-blue p-4 space-y-4 min-h-0";
        return A2(Kk, w([
            Hx(w([
                Gx(n.ca ? r + " overflow-hidden invisible pointer-events-none " : r),
                DF("messages-container")
            ]))
        ]), w([
            function() {
                var r = n.aV;
                switch(r.$){
                    case 1:
                    default:
                        return _d("");
                    case 3:
                        return A5(Qan, n.Dc, n.f9, n.bp, n.AW, r.a);
                    case 2:
                        return A2(Kk, w([
                            Hx(w([
                                Gx("flex justify-center py-2")
                            ]))
                        ]), w([
                            A2(f_, w([
                                VG,
                                x6
                            ]), w([
                                _d(n.mA(pv))
                            ]))
                        ]));
                }
            }()
        ]));
    }, Uan = function(n) {
        var r = "relative flex-1 " + (i(n.Dc.E8, Ot) ? "overflow-y-auto" : "overflow-hidden") + " bg-surface-background-blue p-4 space-y-4 min-h-0";
        return A2(Kk, w([
            Hx(w([
                Gx(n.ca ? r + " overflow-hidden invisible pointer-events-none " : r),
                DF("messages-container")
            ]))
        ]), w([
            function() {
                var r = n.aV;
                switch(r.$){
                    case 1:
                    default:
                        return _d("");
                    case 3:
                        return A5(Qan, n.Dc, n.f9, n.bp, n.AW, r.a);
                    case 2:
                        return A2(Kk, w([
                            Hx(w([
                                Gx("flex py-2")
                            ])),
                            Hx(Yx(yE))
                        ]), w([
                            A2(f_, w([
                                VG,
                                x6
                            ]), w([
                                _d(n.mA(pv))
                            ]))
                        ]));
                }
            }()
        ]));
    }, Kan = F4(function(n, r, t, e) {
        var u;
        return (u = {
            Az: A2(Rtn, n, r),
            AW: Utn(r),
            bp: r.bp,
            bB: r.bB,
            cV: r.cV,
            bC: r.bC,
            cW: r.cW,
            ca: r.ca,
            Dc: A2(Jtn, n, r),
            aV: r.aV,
            Dz: t,
            DZ: l5,
            D6: Ltn,
            vh: nen(r),
            ET: r.bM,
            db: r.db,
            f9: r.f9,
            mA: n,
            gf: e
        }).gf ? function(n) {
            return A2(Kk, w([
                Hx(w([
                    Gx("h-full bg-divider flex flex-col")
                ]))
            ]), w([
                A2(xen, n, !0),
                Ran(n),
                cen(n.Az)
            ]));
        }(u) : function(n) {
            var r = !i(n.Dz, Ot);
            return A2(Kk, w([
                Hx(w([
                    Gx("w-full h-full flex flex-col relative")
                ]))
            ]), w([
                A2(Kk, w([
                    Hx(w([
                        Gx("flex-shrink-0 z-10 bg-white")
                    ]))
                ]), w([
                    A2(xen, n, r)
                ])),
                Uan(n),
                A2(Kk, w([
                    Hx(w([
                        Gx("flex-shrink-0 z-10 bg-white border-t border-primary-200")
                    ]))
                ]), w([
                    cen(n.Az)
                ]))
            ]));
        }(u);
    }), Wan = F2(function(n, r) {
        return A2(Kk, w([
            Hx(w([
                Gx("h-full bg-white flex flex-col")
            ]))
        ]), w([
            A4(Kan, n, r, It(Mtn), r.gf)
        ]));
    }), Xan = function(n) {
        return A2(Kk, w([
            Hx(w([
                Gx("flex p-8")
            ])),
            Hx(Yx(gE)),
            Hx(Yx(yE))
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("space-y-2")
                ])),
                Hx(Yx(xD))
            ]), w([
                A2(f_, w([
                    qG,
                    ven
                ]), w([
                    _d(n(wv))
                ])),
                A2(f_, w([
                    VG,
                    tY
                ]), w([
                    _d(n(xv))
                ]))
            ]))
        ]));
    }, Yan = F2(function(n, r) {
        return A2(lE, w([
            TE(8)
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("bg-white rounded-md h-[60vh] min-h-96 overflow-hidden")
                ]))
            ]), w([
                function() {
                    var t = b(r.S, r.bg, r._);
                    if (3 === t.a.$) {
                        if (t.b.$) return t.c.$ ? (u = Ptn(t.a.a), nE(u) ? A2(Kk, w([
                            Hx(w([
                                Gx("h-full flex")
                            ])),
                            Hx(Yx(gE)),
                            Hx(Yx(yE))
                        ]), w([
                            Xan(n)
                        ])) : function(n) {
                            return A2(Kk, w([
                                Hx(w([
                                    Gx("flex h-full p-8")
                                ])),
                                Hx(Yx(gE)),
                                Hx(Yx(yE))
                            ]), w([
                                A2(Kk, w([
                                    Hx(w([
                                        Gx("space-y-2")
                                    ])),
                                    Hx(Yx(xD))
                                ]), w([
                                    A2(f_, w([
                                        qG,
                                        ven
                                    ]), w([
                                        _d(n(gv))
                                    ])),
                                    A2(f_, w([
                                        VG,
                                        tY
                                    ]), w([
                                        _d(n(hv))
                                    ]))
                                ]))
                            ]));
                        }(n)) : A2(c_, q8, A2(Wan, n, t.c.a));
                        if (t.c.$) {
                            var e = t.b.a, u = Ptn(t.a.a);
                            return nE(u) ? Xan(n) : A2(Ztn, n, e);
                        }
                        return A2(c_, q8, A2(Wan, n, t.c.a));
                    }
                    return A2(Kk, w([
                        Hx(w([
                            Gx("h-full flex")
                        ])),
                        Hx(Yx(gE)),
                        Hx(Yx(yE))
                    ]), w([
                        Xan(n)
                    ]));
                }()
            ]))
        ]));
    }), Jan = {
        $: 7
    }, nin = function(n) {
        return A2(Kk, w([
            Hx(w([
                Gx("px-2 pb-8 flex w-full")
            ])),
            Hx(Yx(gE)),
            Hx(Yx(AF))
        ]), w([
            A2(Kk, g, g),
            A2(CF, w([
                Qx
            ]), w([
                _d(n(Cv))
            ])),
            A2(zx, w([
                Gx("text-primary-300 cursor-pointer"),
                qE(Jan)
            ]), w([
                A2(Kk, w([
                    fen
                ]), w([
                    A2(Tq, w([
                        Xj
                    ]), 31)
                ]))
            ]))
        ]));
    }, rin = F3(function(n, r, t) {
        return A2(A2(Hp, n, r), 2, t);
    }), tin = F4(function(n, r, t, e) {
        var u, a = function(n) {
            return n.a.vh;
        }(e), i = function(n) {
            return n.a.sU;
        }(e), c = i.$ ? "" : i.a.FR, o = i.$ ? "" : A3(rin, n, r, i.a.Fv), f = function(n) {
            return n.a.sN;
        }(e), s = 3 === t.$ ? It(kM(t.a)) : Ot, l = A2(den, a, s), d = A2(fe, ", ", A2(n$, cu, A2(Fu, function(n) {
            return n.Bd;
        }, l))), v = ve(l) > 1, b = o7(e), m = function() {
            if (v) return "";
            var n = mb(l);
            if (n.$) return "?";
            var r = n.a.Bd;
            return r.$ ? "?" : A2(pu, 1, r.a);
        }();
        return A2(zx, w([
            Gx("p-4 cursor-pointer bg-white md:bg-transparent"),
            qE((u = b, {
                $: 1,
                a: u
            }))
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("flex space-x-3")
                ])),
                Hx(Yx(gE))
            ]), w([
                A2(Kk, w([
                    Hx(w([
                        Gx("flex space-x-2")
                    ])),
                    Hx(Yx(gE))
                ]), w([
                    A2(Kk, w([
                        Hx(w([
                            Gx("w-3 flex-shrink-0")
                        ]))
                    ]), w([
                        f ? A2(Kk, w([
                            Hx(w([
                                Gx("w-3 h-3 bg-primary-300 rounded-full")
                            ]))
                        ]), g) : _d("")
                    ])),
                    Nan({
                        Ac: Ot,
                        Ak: Ot,
                        Cm: m,
                        CA: v,
                        Gb: Ot
                    })
                ])),
                A2(Kk, w([
                    Hx(w([
                        Gx("flex-1 min-w-0")
                    ]))
                ]), w([
                    A2(Kk, w([
                        Hx(w([
                            Gx("flex mb-1")
                        ])),
                        Hx(Yx(AF)),
                        Hx(Yx(gE))
                    ]), w([
                        A2(Kk, w([
                            VG,
                            ven,
                            Hx(w([
                                Gx("truncate")
                            ]))
                        ]), w([
                            _d(d)
                        ])),
                        A2(Kk, w([
                            oK,
                            xE,
                            Hx(w([
                                Gx("ml-2 flex-shrink-0")
                            ]))
                        ]), w([
                            _d(o)
                        ]))
                    ])),
                    A2(Kk, w([
                        VG,
                        xE,
                        Hx(w([
                            Gx("line-clamp-2")
                        ]))
                    ]), w([
                        _d(c)
                    ]))
                ]))
            ]))
        ]));
    }), ein = function(n) {
        return A2(Kk, w([
            Hx(w([
                Gx("text-center p-8")
            ]))
        ]), w([
            A2(f_, w([
                qG,
                ven,
                Hx(w([
                    Gx("mb-2")
                ]))
            ]), w([
                _d(n(yv))
            ]))
        ]));
    }, uin = function(n) {
        return A2(Kk, w([
            Hx(w([
                Gx("flex py-8")
            ])),
            Hx(Yx(yE))
        ]), aE(n(vv)));
    }, ain = F3(function(n, r, t) {
        var e = t.S;
        switch(e.$){
            case 1:
                return _d("");
            case 3:
                var u = Ptn(e.a);
                return nE(u) ? A2(Kk, w([
                    Hx(w([
                        Gx("h-full flex flex-col bg-white")
                    ])),
                    Hx(Yx(gE)),
                    Hx(Yx(yE))
                ]), w([
                    ein(n)
                ])) : A2(Kk, A2(Qt, Hx(w([
                    Gx("h-full overflow-y-auto")
                ])), r ? w([
                    Hx(w([
                        DF("conversation-list-container")
                    ]))
                ]) : g), A2(Fu, A3(tin, t.f9, t.bp, t.vn), u));
            case 2:
                return A2(Kk, w([
                    Hx(w([
                        Gx("h-full flex flex-col")
                    ])),
                    Hx(Yx(gE)),
                    Hx(Yx(yE))
                ]), w([
                    uin(n)
                ]));
            default:
                return A2(Kk, w([
                    Hx(w([
                        Gx("h-full flex flex-col")
                    ])),
                    Hx(Yx(gE)),
                    Hx(Yx(yE))
                ]), w([
                    _d("")
                ]));
        }
    }), iin = F2(function(n, r) {
        return A2(lE, w([
            TE(4)
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("bg-white rounded-md h-[60vh] min-h-96 overflow-y-auto")
                ]))
            ]), w([
                A3(ain, n, !0, r)
            ]))
        ]));
    }), cin = F2(function(n, r) {
        return A2(Kk, w([
            Hx(w([
                Gx("flex flex-col max-h-[calc(100vh-12rem)] w-full")
            ]))
        ]), w([
            nin(n),
            A2(Kk, w([
                Hx(w([
                    Gx("w-full flex-1 flex")
                ]))
            ]), w([
                A2(BE, w([
                    VN(w([
                        Gx("w-full")
                    ]))
                ]), w([
                    A2(iin, n, r),
                    A2(Yan, n, r)
                ]))
            ]))
        ]));
    }), oin = F2(function(n, r) {
        return A2(Kk, w([
            Hx(w([
                Gx("fixed inset-0 z-50 bg-divider flex flex-col overflow-hidden")
            ]))
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("flex-1 min-h-0")
                ]))
            ]), w([
                A2(c_, q8, A2(Wan, n, r))
            ]))
        ]));
    }), fin = F2(function() {
        return _d("");
    }), sin = function(n) {
        return A2(Kk, w([
            Hx(w([
                Gx("px-4 pb-4 flex")
            ])),
            Hx(Yx(gE)),
            Hx(Yx(AF))
        ]), w([
            A2(Kk, w([
                Hx(g)
            ]), g),
            A2(CF, w([
                Qx
            ]), w([
                _d(n(Cv))
            ])),
            A2(zx, w([
                Gx("text-primary-300 cursor-pointer"),
                qE(Jan)
            ]), w([
                A2(Kk, w([
                    fen
                ]), w([
                    A2(Tq, w([
                        Xj
                    ]), 31)
                ]))
            ]))
        ]));
    }, lin = F2(function(n, r) {
        var t = function() {
            var n = r.S;
            return 3 === n.$ && nE(Ptn(n.a));
        }();
        return t ? A2(Kk, w([
            Hx(w([
                Gx("w-full h-screen flex flex-col")
            ]))
        ]), w([
            sin(n),
            A2(Kk, w([
                Hx(w([
                    Gx("flex-1 flex bg-white")
                ])),
                Hx(Yx(gE)),
                Hx(Yx(yE))
            ]), w([
                ein(n)
            ]))
        ])) : A2(Kk, w([
            Hx(w([
                Gx("w-full h-full flex flex-col")
            ]))
        ]), w([
            sin(n),
            A2(Kk, w([
                Hx(w([
                    Gx("max-h-[calc(100vh-12rem)] min-h-96 overflow-y-auto"),
                    DF("conversation-list-container")
                ]))
            ]), w([
                A3(ain, n, !1, r)
            ]))
        ]));
    }), din = F2(function(n, r) {
        return A2(Kk, g, w([
            function() {
                var t = v(r.bg, r._);
                return 1 === t.a.$ ? 1 === t.b.$ ? A2(lin, n, r) : A2(oin, n, t.b.a) : t.b.$ ? A2(fin, n, t.a.a) : A2(oin, n, t.b.a);
            }()
        ]));
    }), vin = F2(function(n, r) {
        var t = 0 > s(r.ep, w7);
        return {
            g8: w([
                A2(Kk, w([
                    Hx(w([
                        Gx("bg-gray-100 w-full")
                    ]))
                ]), w([
                    A2(t ? din : cin, n, r)
                ]))
            ]),
            yx: n(Cv)
        };
    }), bin = C_({
        Cl: c8,
        CQ: k8,
        Fj: E8,
        F4: function(n) {
            var r = Y8(F2(function(n) {
                return e8(n);
            })), t = A2(X8, 1e4, D8), e = J8(j8), u = function() {
                var r = n._;
                return r.$ ? bx : A2(kj, q8, function(n) {
                    var r, t = A2(X8, 1e4, s5), e = vx(A2(Fu, function(n) {
                        var r = n.b;
                        return A2(kj, n5(n.a), function(n) {
                            return vx(w([
                                A2(kj, A2(qc, x5, k5), qj()),
                                T5(n),
                                R5(n),
                                Y5(n),
                                j5(n.b) && P5(n.c) && !n.i && U5(n) ? L5(A2(tu, _5, C5)) : bx
                            ]));
                        }(r));
                    }, Ut(n.K)));
                    return vx(w([
                        J8(o5),
                        (r = i5, y5(A2(tu, h5, r))),
                        A2(kj, f5, n7),
                        d5(A2(tu, WA(m5), A2(tu, d$(a5), gp(c5)))),
                        A2(kj, l5, t7(n.bM)),
                        p5(t5),
                        w5(e5),
                        Y8(F2(function(n) {
                            return u5(n);
                        })),
                        hR(r5),
                        $R(r5),
                        t,
                        e
                    ]));
                }(r.a));
            }();
            return vx(w([
                e,
                u,
                r,
                t
            ]));
        },
        Gv: Ttn,
        GB: vin
    }), min = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pin = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $in = {
        $: 0
    }, gin = F3(function(n, r, t) {
        return {
            g0: n,
            aK: $in,
            fx: g,
            EH: t,
            kn: r
        };
    }), hin = F2(function(n, r) {
        return m(r, {
            yx: It(n)
        });
    }), yin = F4(function(n, r, t, e) {
        return {
            kz: A3(gin, r.g0, r.kn, ux(n)),
            g0: r.g0,
            hE: 0,
            ld: r.ld,
            as: A2(hin, w1, e),
            dV: n,
            kn: r.kn,
            yZ: t
        };
    }), win = F3(function(n, r, t) {
        var e = A3(j0, !1, r.g0, ux(n)), u = e.b;
        return v(A4(yin, n, r, t, e.a), Uu(w([
            A3(a1, r.g0, ux(n), min),
            A2(Wp, pin, u)
        ])));
    }), xin = F2(function(n, r) {
        return v(r, Qp);
    }), _in = F2(function(n, r) {
        return m(r, {
            zK: It(4)
        });
    }), Cin = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ain = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kin = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ein = function(n) {
        return n.aK.$ ? vx(w([
            Cj(ij(Ain)),
            A2(kj, kin, qj())
        ])) : bx;
    }, qin = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Fin = F3(function(n, r, t) {
        var e = ux(t), u = i2(r);
        return A5(vM, n, e, u, A2(o2, !1, r), qin);
    }), jin = F2(function(n, r) {
        return r.qo(n);
    }), Din = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Vin = {
        $: 0
    }, Bin = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), Gin = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    aK: $in
                }), Qp, Ot);
            case 1:
                var t = i3(d = n.a), e = K2(d), u = function(n) {
                    return n.a.xM;
                }(d), a = A2(YF, 0, Vin), i = a.a, c = a.b, o = u.$ ? v(Ot, Qp) : A2(lx, It, A5(n6, r.g0, r.EH, e, t, u.a)), f = o.b;
                return b(m(r, {
                    aK: A3(Bin, i, d, x = o.a)
                }), Uu(w([
                    c,
                    A2(Wp, Din, f)
                ])), Ot);
            case 2:
                return b(1 === n.a ? m(r, {
                    aK: $in
                }) : r, Qp, Ot);
            case 4:
                var s = n.a, l = r.aK;
                if (l.$) {
                    i = l.a;
                    var d = l.b, p = l.c;
                    if (p.$) return b(r, Qp, Ot);
                    var $ = A2(_9, s, x = p.a), g = $.b, h = $.c;
                    return b(m(r, {
                        aK: A3(Bin, i, d, It($.a))
                    }), A2(Wp, Din, g), A2(bb, function(n) {
                        return It(n);
                    }, h));
                }
                return b(r, Qp, Ot);
            default:
                s = n.a;
                var y = r.aK;
                if (y.$) {
                    d = y.b;
                    var x = y.c, _ = A2(Sj, s, i = y.a);
                    return c = _.b, b(m(r, {
                        aK: A3(Bin, _.a, d, x)
                    }), A2(Wp, kin, c), Ot);
                }
                return b(r, Qp, Ot);
        }
    }), zin = function(n) {
        return 1 !== X2(n);
    }, Sin = F4(function(n, r, t, e) {
        return {
            g0: n,
            aK: $in,
            fx: r,
            EH: e,
            kn: t
        };
    }), Tin = F2(function(n, r) {
        return m(r, {
            aa: J2(A2(Fu, A2(o3, r.g0, r.EH), n))
        });
    }), Pin = F2(function(n, r) {
        var t = A2(Tin, R2(n), r.as), e = A4(Sin, r.g0, function(n) {
            return A2(no, zin, n);
        }(n), r.kn, ux(r.dV));
        return m(r, {
            kz: e,
            hE: 1,
            as: t
        });
    }), Zin = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? b(A2(Pin, t.a, r), Qp, g) : b(r, Qp, A2(Ik, 0, t));
            case 1:
                var e = n.a;
                if (3 === e.$) {
                    var u = e.a;
                    return b(r, A3(a1, r.g0, ux(r.dV), min), w([
                        A2(Mk, 3, jin(i3(u)))
                    ]));
                }
                return b(r, Qp, A2(Ik, 0, e));
            case 2:
                var a = A2(r6, n.a, r.as), i = a.a, c = (s = a.c).$ || s.a.$ ? A2(Wp, pin, a.b) : A3(Fin, r.g0, s.a.a.b, r.dV);
                return b(m(r, {
                    as: i
                }), c, g);
            default:
                var o = A2(Gin, n.a, r.kz), f = o.b, s = o.c;
                return b(m(r, {
                    kz: o.a
                }), A2(Wp, Cin, f), A2(xc, g, A2(Op, function(n) {
                    return n;
                }, s)));
        }
    }), Min = function(n) {
        return nE(n.fx);
    }, Lin = {
        $: 0
    }, Nin = function(n) {
        return n.a.xL;
    }, Hin = F2(function(n, r) {
        var t = Nin(r);
        return t.$ ? " " : A2(n, 1, t.a);
    }), Iin = F2(function(n, r) {
        var t = Nin(r);
        return t.$ ? " " : A2(n, 4, t.a);
    }), Oin = F2(function(n, r) {
        var t;
        return A2(BE, g, w([
            A2(lE, g, w([
                _d("Accepted "),
                A2(yF, w([
                    j6,
                    cF((t = r, {
                        $: 1,
                        a: t
                    }))
                ]), w([
                    _d(i3(r))
                ])),
                _d(" on " + A2(Hin, n, r) + " at " + A2(Iin, n, r))
            ]))
        ]));
    }), Qin = F3(function(n, r, t) {
        return A2(BE, w([
            VN(w([
                Gx("panel")
            ]))
        ]), w([
            A2(lE, g, w([
                A2(i_, w([
                    uE(eE)
                ]), w([
                    _d(n)
                ])),
                A2(EH, g, A2(Fu, Oin(t), r))
            ]))
        ]));
    }), Rin = function(n) {
        if (1 === n.$) {
            var r = n.a, t = n.c, e = i3(n.b);
            if (t.$) return vE;
            var u = t.a;
            return A2(dD, w([
                Hj(w([
                    A2(PE, w([
                        qG,
                        nF
                    ]), w([
                        _d(e)
                    ]))
                ])),
                Mj(w([
                    A2(c_, Din, A2(K6, 1, u))
                ])),
                Nj(g)
            ]), zj(r));
        }
        return vE;
    }, Uin = F2(function(n, r) {
        return Min(r) ? vE : A2(zx, g, w([
            Rin(r.aK),
            A3(Qin, n, r.fx, r.kn)
        ]));
    }), Kin = F3(function(n, r, t) {
        var e = g6(r) ? "All Agreements Accepted" : "Already Accepted";
        return w([
            A2(c_, pin, A3(e4, n, w([
                Lin
            ]), r)),
            A2(c_, Cin, A2(Uin, e, t))
        ]);
    }), Win = F4(function(n, r, t, e) {
        return g6(t) && Min(e) ? w([
            A2(BE, w([
                VN(w([
                    Gx("panel")
                ]))
            ]), w([
                A2(lE, g, w([
                    A2(i_, w([
                        uE(eE)
                    ]), w([
                        _d(ax(r) + " Agreements")
                    ])),
                    _d("You do not have any accepted or pending Agreement")
                ]))
            ]))
        ]) : A3(Kin, n, t, e);
    }), Xin = F2(function(n, r) {
        return {
            g8: r.hE ? A4(Win, n, r.dV, r.as, r.kz) : Nx,
            yx: ax(r.dV)
        };
    }), Yin = C_({
        Cl: win,
        CQ: xin,
        Fj: _in,
        F4: function(n) {
            return vx(w([
                A2(kj, pin, L1(n.as)),
                A2(kj, Cin, Ein(n.kz))
            ]));
        },
        Gv: Zin,
        GB: Xin
    }), Jin = {
        $: 14
    }, ncn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, rcn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, tcn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ecn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ucn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, acn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, icn = function(n) {
        switch(n){
            case 0:
                return "all";
            case 1:
                return "memberships";
            default:
                return "packages";
        }
    }, ccn = F3(function(n, r) {
        var t = RQ(n) ? A4(QQ, r.g0, ux(n), function(n) {
            return m(n, {
                lo: 100
            });
        }, ucn) : Qp, e = A2(Ek, "explore-services-tabs", icn(0)), u = e.a, a = e.b, i = A2(YF, 0, Jin), c = i.b, o = fQ.b;
        return v({
            dp: 0,
            g0: r.g0,
            Z: r.Z,
            hj: A_,
            R: fQ.a,
            bv: Ot,
            ld: r.ld,
            dK: Ot,
            fm: A_,
            fq: i.a,
            c3: Ot,
            dV: n,
            bK: g,
            cl: Ot,
            dg: u,
            gg: UQ(r)
        }, Uu(w([
            A3(hQ, r.g0, ux(n), tcn),
            A3(BQ, r.g0, ux(n), ecn),
            A3(sR, r.g0, ux(n), rcn),
            t,
            A2(Wp, acn, a),
            c,
            A2(Wp, ncn, o)
        ])));
    }), ocn = F2(function(n, r) {
        return v(m(r, {
            Z: n.Z,
            gg: UQ(n)
        }), Qp);
    }), fcn = F2(function(n, r) {
        return m(r, {
            zK: It(5)
        });
    }), scn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, lcn = {
        $: 4
    }, dcn = {
        $: 12
    }, vcn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, bcn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, mcn = F2(function(n, r) {
        return A2(Op, function(n) {
            return A2(Nu, cu, Au(GF(n)));
        }, A2(SS, function(r) {
            return i((0, r.b.yB)(r.a), n);
        }, r));
    }), pcn = F2(function(n, r) {
        return nE(r) ? Qp : A2(xc, Qp, A2(Op, Wp(acn), A2(mcn, icn(n), w([
            A2(qF, 0, {
                yB: icn,
                yD: function() {
                    return _d("");
                }
            }),
            A2(qF, 1, {
                yB: icn,
                yD: function() {
                    return _d("");
                }
            }),
            A2(qF, 2, {
                yB: icn,
                yD: function() {
                    return _d("");
                }
            })
        ]))));
    }), $cn = function(n) {
        return JF(n.fm);
    }, gcn = function(n) {
        return A2(bb, function(r) {
            var t = function() {
                var t = n.gg;
                if (t.$) return Ot;
                var e = t.a;
                return mb(A2(no, function(n) {
                    return i(eQ(n), e);
                }, r));
            }();
            return A2(PR, function() {
                return mb(r);
            }, A2(PR, function() {
                return mb(A2(no, JX, r));
            }, t));
        }, $cn(n));
    }, hcn = F2(function(n, r) {
        return {
            ao: n,
            tL: g,
            bK: r.bK,
            s: A2(xc, g, A2(Op, _K, gcn(r))),
            cn: VR(n),
            x0: Ot
        };
    }), ycn = F2(function(n, r) {
        var t = v(r.hj, $cn(r));
        return 3 !== t.a.$ || t.b.$ ? Ot : A2(bb, A3(LR, t.a.a, t.b.a, r.bK), A2(NR, n, r.Z));
    }), wcn = function(n) {
        return A2(Yk, "self_buy_2", n);
    }, xcn = F2(function(n, r) {
        switch(n.$){
            case 0:
                switch((e = n.a).$){
                    case 3:
                        var t = e.a;
                        return b(m(r, {
                            hj: e
                        }), A2(pcn, r.dp, t), g);
                    case 2:
                        switch(e.a.$){
                            case 9:
                            case 6:
                                return b(m(r, {
                                    hj: e
                                }), Qp, g);
                            default:
                                return b(m(r, {
                                    hj: e
                                }), Qp, A2(Ik, 0, e));
                        }
                    default:
                        return b(m(r, {
                            hj: e
                        }), Qp, g);
                }
            case 1:
                var e = n.a, u = function() {
                    if (2 !== e.$) return g;
                    switch(e.a.$){
                        case 9:
                        case 6:
                            return g;
                        default:
                            return A2(Ik, 0, e);
                    }
                }();
                return b(m(r, {
                    fm: e
                }), Qp, u);
            case 2:
                return b(3 === (e = n.a).$ ? m(r, {
                    bK: e.a
                }) : r, Qp, g);
            case 3:
                return 3 === (e = n.a).$ ? b(m(r, {
                    Z: (F = e.a).sO
                }), Qp, w([
                    xR(F.sO)
                ])) : b(r, Qp, g);
            case 4:
                return 3 === (e = n.a).$ ? b(m(r, {
                    Z: (F = e.a).sO,
                    dK: r.c3,
                    c3: Ot
                }), A2(Nu, function() {
                    return dcn;
                }, Up(5e3)), w([
                    xR(F.sO)
                ])) : b(m(r, {
                    c3: Ot
                }), Qp, A2(Ik, 0, e));
            case 6:
                var a = A2(Qk, n.a, r.dg), i = a.a, c = a.b, o = a.c;
                return b(m(r, o.$ || o.a.$ ? {
                    dg: i
                } : {
                    dp: o.a.a,
                    dg: i
                }), A2(Wp, acn, c), g);
            case 7:
                var f = n.a;
                return b(m(r, {
                    fq: zj(r.fq),
                    cl: It(f)
                }), Qp, g);
            case 8:
                if (f = n.a, wcn(r.dV)) {
                    var s = v(dU(f), A2(xc, g, $cn(r)));
                    if (1 === s.a && s.b.b && !s.b.b.b) {
                        var l = s.b.a, d = fU({
                            CI: 1,
                            tL: g,
                            ur: A2(xc, "", oU(f)),
                            iO: It(eQ(l)),
                            vN: A2(Op, lU, VR(f)),
                            f3: SR(f),
                            x0: Ot
                        });
                        return b(m(r, {
                            fq: Bj(r.fq),
                            c3: It(uW(d)),
                            cl: Ot
                        }), A4(YU, r.g0, ux(r.dV), $(r.Z, w([
                            d
                        ])), vcn), g);
                    }
                    var p = A2(JR, A2(hcn, f, r), r.R), h = p.b;
                    return b(m(r, {
                        R: A = p.a,
                        bv: Ot,
                        fq: zj(r.fq),
                        cl: Ot
                    }), A2(Wp, ncn, h), g);
                }
                var y = dU(f);
                return b(m(r, {
                    fq: Bj(r.fq),
                    cl: Ot
                }), A2(__, pa, 1 === y ? Wa({
                    sl: SR(f)
                }) : ni({
                    sl: SR(f)
                })), g);
            case 9:
                var x = A2(ycn, q = n.a, r);
                if (x.$) return b(r, Qp, g);
                var _ = A2(JR, x.a, r.R);
                return h = _.b, b(m(r, {
                    R: A = _.a,
                    bv: It(q),
                    fq: zj(r.fq),
                    cl: Ot
                }), A2(Wp, ncn, h), g);
            case 10:
                return b(m(r, {
                    R: tU(r.R),
                    cl: FR(r.R)
                }), Qp, g);
            case 11:
                var C = A3(RU, n.a, A2(xc, g, $cn(r)), r.R), A = C.a, k = (h = C.b, C.c);
                if (1 === k.$) {
                    d = k.a;
                    var E = r.bv;
                    if (E.$) return b(m(r, {
                        R: tU(A),
                        fq: Bj(r.fq),
                        c3: It(uW(d)),
                        cl: Ot
                    }), A4(YU, r.g0, ux(r.dV), $(r.Z, w([
                        d
                    ])), vcn), g);
                    var q = E.a;
                    return b(m(r, {
                        R: tU(A),
                        fq: Bj(r.fq),
                        cl: Ot
                    }), A4(YU, r.g0, ux(r.dV), A3(uU, q, d, r.Z), bcn), g);
                }
                return b(m(r, {
                    R: A
                }), A2(Wp, ncn, h), g);
            case 5:
                var F;
                return 3 === (e = n.a).$ ? b(m(r, {
                    Z: (F = e.a).sO,
                    bv: Ot
                }), A2(__, pa, ka), w([
                    xR(F.sO)
                ])) : b(m(r, {
                    bv: Ot
                }), Qp, A2(Qt, Lk(qR), A2(Ik, 0, e)));
            case 12:
                return b(m(r, {
                    dK: Ot
                }), Qp, g);
            case 13:
                return b(m(r, {
                    dK: Ot
                }), A2(__, pa, ka), g);
            case 14:
                return b(m(r, {
                    R: tU(r.R),
                    bv: Ot,
                    fq: Bj(r.fq),
                    cl: Ot
                }), Qp, g);
            default:
                var j = A2(Sj, n.a, r.fq), D = j.b;
                return b(m(r, {
                    fq: j.a
                }), A2(Wp, scn, D), g);
        }
    }), _cn = {
        $: 13
    }, Ccn = F2(function(n, r) {
        var t = r.dK;
        if (t.$) return vE;
        var e = t.a;
        return A2(zx, w([
            Gx("cart-banner")
        ]), w([
            A2(Mx, g, w([
                _d(e + " " + n(mX.m2))
            ])),
            A2(sF, w([
                Gx("cart-banner__action"),
                qE(_cn)
            ]), w([
                _d(n(mX.ze))
            ]))
        ]));
    }), Acn = function(n) {
        return n.yv;
    }, kcn = function(n) {
        return i(Acn(n), Ot) && i(eJ(n), Ot);
    }, Ecn = function(n) {
        return kcn(n) ? "catalog-grid__item catalog-grid__item--compact" : "catalog-grid__item";
    }, qcn = F2(function(n, r) {
        switch(n){
            case 0:
                return r;
            case 1:
                return A2(no, function(n) {
                    return !dU(n);
                }, r);
            default:
                return A2(no, function(n) {
                    return 1 === dU(n);
                }, r);
        }
    }), Fcn = F2(function(n, r) {
        var t = aJ(r);
        if (t.$) return n(mX.AN);
        var e = A3(IK, !1, !0, t.a);
        return dU(r) ? e : $(e, A2(f0, n, c0(r)));
    }), jcn = F3(function(n, r, t) {
        var e, u = function() {
            var n = oU(t);
            if (n.$) return vE;
            var r = n.a;
            return A2(xX, w([
                Hx(w([
                    Gx("block text-current")
                ]))
            ]), w([
                _d(r)
            ]));
        }(), a = function() {
            var n = eJ(t);
            if (n.$) return vE;
            var r = n.a;
            return A2(zx, w([
                Gx("catalog-card__description rich-text")
            ]), A2(Fu, c_(Cu), a0(r)));
        }(), c = !i(Acn(t), Ot), o = kcn(t) ? " catalog-card--compact" : "", f = c ? "" : " catalog-card--no-image";
        return A2(zx, w([
            qE((e = t, {
                $: 7,
                a: e
            })),
            Gx("catalog-card block rounded-lg border border-primary-200 bg-white p-4 hover:bg-gray-50 sm:p-0 sm:overflow-hidden cursor-pointer h-full" + (f + o))
        ]), w([
            A2(zx, w([
                Gx("catalog-card__content flex gap-4 items-start sm:flex-col sm:gap-0")
            ]), w([
                function() {
                    var n = Acn(t);
                    return n.$ ? vE : A2(uJ, w([
                        iJ(n.a),
                        tJ(""),
                        Gx("w-24 h-24 object-cover rounded flex-shrink-0 order-1 sm:order-none sm:w-full sm:h-32 sm:rounded-none")
                    ]), g);
                }(),
                A2(zx, w([
                    Gx("catalog-card__body flex-1 min-w-0 sm:p-4 order-0 sm:order-none")
                ]), w([
                    u,
                    A2(PE, w([
                        VG,
                        nF,
                        zX,
                        Hx(w([
                            Gx("catalog-card__price block mt-1")
                        ]))
                    ]), w([
                        _d(A2(Fcn, n, t))
                    ])),
                    a
                ])),
                r ? vE : A2(c_, Cu, A2(Tq, w([
                    pD,
                    Wj("flex-shrink-0 text-gray-400 self-center order-2 sm:hidden")
                ]), 7))
            ]))
        ]));
    }), Dcn = F2(function(n, r) {
        var t = r.hj;
        switch(t.$){
            case 1:
                return A2(zx, g, Nx);
            case 3:
                var e = A2(qcn, r.dp, t.a);
                if (nE(e)) return A2(zx, w([
                    Gx("py-12 text-center")
                ]), rF(n(mX.GO)));
                var u = wcn(r.dV);
                return A2(Kq, w([
                    Gx("catalog-grid")
                ]), A2(Fu, function(r) {
                    return A2(Qq, w([
                        Gx(Ecn(r))
                    ]), w([
                        A3(jcn, n, u, r)
                    ]));
                }, e));
            default:
                return vE;
        }
    }), Vcn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Bcn = F2(function(n, r) {
        return n(dU(r) ? mX.EW : mX.hP);
    }), Gcn = F2(function(n, r) {
        return {
            fm: A2(xc, g, $cn(r)),
            yg: n(r.bv.$ ? mX.m$ : mX.yW),
            mA: n,
            gg: r.gg
        };
    }), zcn = F2(function(n, r) {
        return dU(r) ? Ot : A2(FF, function(n) {
            return i(ZR(n), SR(r));
        }, n.Z);
    }), Scn = {
        $: 10
    }, Tcn = function(n) {
        var r = A2(bb, oU, n);
        return r.$ ? g : w([
            A2(v0, Scn, r.a)
        ]);
    }, Pcn = F2(function(n, r) {
        if ($X(r.R)) {
            var t = A2(Gcn, n, r);
            return A3($0, "modal__content--configure-item", w([
                Hj(Tcn(FR(r.R))),
                Mj(A2(Fu, c_(ncn), A2(rJ, t, r.R))),
                Nj(w([
                    A2(c_, ncn, p0(t))
                ]))
            ]), r.fq);
        }
        var e = r.cl;
        if (e.$) return vE;
        var u = e.a, a = !Cz(aJ(u)), i = function() {
            if (wcn(r.dV)) {
                var t = A2(zcn, r, u);
                if (t.$) return b(n(mX.m$), Vcn(u), a);
                var e = t.a;
                return b(n(mX.qK), {
                    $: 9,
                    a: e
                }, !1);
            }
            return b(A2(Bcn, n, u), Vcn(u), a);
        }(), c = i.a, o = i.b, f = i.c;
        return A3($0, "modal__content--configure-item modal__content--detail", w([
            bX,
            Mj(A2(l0, n, u)),
            Nj(w([
                A2(yF, w([
                    fF,
                    iK,
                    cF(o),
                    Lj(f)
                ]), w([
                    _d(c)
                ]))
            ]))
        ]), r.fq);
    }), Zcn = F2(function(n, r) {
        switch(r){
            case 0:
                return n(mX.ni);
            case 1:
                return n(mX.ad);
            default:
                return n(mX.iQ);
        }
    }), Mcn = F2(function(n, r) {
        var t = w([
            A2(qF, 0, {
                yB: icn,
                yD: function(r) {
                    return _d(A2(Zcn, n, r));
                }
            }),
            A2(qF, 1, {
                yB: icn,
                yD: function(r) {
                    return _d(A2(Zcn, n, r));
                }
            }),
            A2(qF, 2, {
                yB: icn,
                yD: function(r) {
                    return _d(A2(Zcn, n, r));
                }
            })
        ]);
        return A2(c_, acn, A2(SF, r.dg, t));
    }), Lcn = F2(function(n, r) {
        var t = wcn(r.dV), e = t ? A2(zx, w([
            Gx("explore-services-catalog-band")
        ]), w([
            A2(Ccn, n, r),
            A2(Dcn, n, r)
        ])) : A2(Dcn, n, r), u = function(n) {
            var r = n.hj;
            if (3 === r.$) {
                var t = r.a;
                return A2(Wk, function(n) {
                    return !dU(n);
                }, t) && A2(Wk, function(n) {
                    return 1 === dU(n);
                }, t);
            }
            return !1;
        }(r) ? w(t ? [
            A2(Mcn, n, r),
            e
        ] : [
            A2(Mcn, n, r),
            A2(Ccn, n, r),
            e
        ]) : w([
            e
        ]);
        return {
            g8: w([
                A2(zx, w([
                    Gx(t ? "explore-services-content" : "panel")
                ]), u),
                A2(Pcn, n, r)
            ]),
            yx: n(Fd)
        };
    }), Ncn = C_({
        Cl: ccn,
        CQ: ocn,
        Fj: fcn,
        F4: function(n) {
            return vx(w([
                A2(kj, scn, qj()),
                Aj(n.fq),
                A2(kj, acn, Y8(F2(function() {
                    return lcn;
                })))
            ]));
        },
        Gv: xcn,
        GB: Lcn
    }), Hcn = F3(function(n, r, t) {
        return v({
            ld: r.ld,
            dV: n,
            yZ: t.EX
        }, Qp);
    }), Icn = F2(function(n, r) {
        return v(r, Qp);
    }), Ocn = F2(function(n, r) {
        return r;
    }), Qcn = F2(function(n, r) {
        return b(r, Qp, g);
    }), Rcn = cr("br"), Ucn = function(n) {
        return n.e0.oF;
    }, Kcn = function(n) {
        return n.e0.sa;
    }, Wcn = function(n) {
        return n.e0.sb;
    }, Xcn = function(n) {
        return n.e0.yx;
    }, Ycn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), w([
                    A2(Kk, w([
                        Qx,
                        uF(xD)
                    ]), w([
                        _d(n(Xcn))
                    ])),
                    A2(Rcn, g, g),
                    A2(Mx, g, w([
                        _d(n(Kcn))
                    ])),
                    _d(" "),
                    A2(Mx, w([
                        Gx("text-support")
                    ]), w([
                        A2(UD, w([
                            Gx("link"),
                            oV(x_(ui))
                        ]), w([
                            _d(n(Ucn))
                        ]))
                    ])),
                    _d(" "),
                    A2(Mx, g, w([
                        _d(n(Wcn))
                    ])),
                    A2(Mx, g, w([
                        A4(mG, ax(r.dV), bV(r.dV), It("If you believe you received this message in error"), Ot)
                    ]))
                ]))
            ]),
            yx: n(Xcn)
        };
    }), Jcn = d_({
        Cl: Hcn,
        CQ: Icn,
        Fj: Ocn,
        F4: function() {
            return bx;
        },
        Gv: Qcn,
        GB: Ycn
    }), non = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ron = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ton = F6(function(n, r, t, e, u, a) {
        return {
            nC: e,
            rg: t,
            rv: a,
            uH: n,
            uI: r,
            yu: u
        };
    }), eon = function(n) {
        switch(n){
            case "DOCUMENT":
                return au(0);
            case "NOTE":
                return au(1);
            case "VITALS":
                return au(2);
            case "LAB":
                return au(3);
            case "RX":
                return au(4);
            case "RX_VERADIGM":
            case "RX_DOSESPOT":
                return au(5);
            case "FORM":
                return au(6);
            case "FAX":
                return au(7);
            default:
                return AA("Unsupported clinical note type: " + n);
        }
    }, uon = A3(nk, "fileCount", O$, A3(nk, "text", M$, A3(nk, "author", uC(M$), A3(nk, "eventTimestamp", uC(XZ), A3(nk, "noteType", A2(nu, eon, M$), A3(nk, "noteId", M$, au(ton))))))), aon = A2(zB, 0, A2($A, uon, au(ron))), ion = {
        lQ: cA
    }, con = F4(function(n, r, t, e) {
        return A4(aA, n, ek(aon), e, A2($k, function(n) {
            var r = n(ion);
            return vc(w([
                bA(r.lQ)
            ]));
        }(t), pk(function(n) {
            return A2(bk, w([
                "notes"
            ]), mk(n));
        }(r))));
    }), oon = A2(__, pa, Va), fon = function(n) {
        var r = j_(F_(n.hq));
        return r.$ ? oon : A4(con, n.hq, r.a, function(r) {
            return m(r, {
                lQ: n.lQ
            });
        }, non);
    }, son = F3(function(n, r) {
        var t = {
            eP: kc,
            hq: r.AF.ft,
            ld: r.ld,
            lQ: cA,
            kn: r.kn
        };
        return v(t, fon(t));
    }), lon = F2(function(n, r) {
        return v(r, Qp);
    }), don = F2(function(n, r) {
        return m(r, {
            zK: It(7)
        });
    }), von = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? b(m(r, {
                    eP: t,
                    lQ: A2(Rk, A2(xc, 0, A2(bb, $u, A2(ra, "x-total-count", t.b))), r.lQ)
                }), Qp, g) : b(m(r, {
                    eP: kc
                }), Qp, A2(Ik, 0, t));
            case 1:
                var e = m(r, {
                    lQ: A2(Ok, n.a, r.lQ)
                });
                return b(e, fon(e), g);
            default:
                return b(r, A2(__, pa, Ga({
                    sl: n.a
                })), g);
        }
    }), bon = F2(function(n, r) {
        return r.nD(n);
    }), mon = function(n) {
        return iL(n) ? Ot : It(n);
    }, pon = F4(function(n, r, t, e) {
        var u = A2(Op, r(0), t);
        return mon(A2(fe, " - ", A2(n$, cu, w([
            u,
            A2(Op, n, A2(Op, function(n) {
                return bon(n);
            }, e))
        ]))));
    }), $on = function(n) {
        var r = w([
            zE,
            Jj
        ]);
        switch(n){
            case 0:
            default:
                return A2(Tq, r, 20);
            case 1:
                return A2(Tq, r, 22);
            case 2:
                return A2(Tq, r, 23);
            case 3:
                return A2(Tq, r, 24);
            case 4:
            case 5:
                return A2(Tq, r, 25);
            case 6:
                return A2(Tq, r, 26);
        }
    }, gon = function(n) {
        return n.a.uH;
    }, hon = function(n) {
        return n.a.uI;
    }, yon = function(n) {
        return n.uI.aP;
    }, won = function(n) {
        return n.uI.qH;
    }, xon = function(n) {
        return n.uI.rq;
    }, _on = function(n) {
        return n.uI.le;
    }, Con = function(n) {
        return n.uI.sn;
    }, Aon = function(n) {
        return n.uI.sS;
    }, kon = function(n) {
        return n.uI.uG;
    }, Eon = function(n) {
        return n.uI.zh;
    }, qon = function(n) {
        switch(n){
            case 0:
                return yon;
            case 1:
                return kon;
            case 2:
                return Eon;
            case 3:
                return Aon;
            case 4:
                return Con;
            case 5:
                return won;
            case 6:
                return _on;
            default:
                return xon;
        }
    }, Fon = function(n) {
        return n.a.yu;
    }, jon = F3(function(n, r, t) {
        return 1 === t ? "1 " + n : oe(t) + " " + r;
    }), Don = F2(function(n, r) {
        var t = function() {
            switch(n){
                case "child":
                    return "children";
                case "category":
                    return "categories";
                default:
                    return n + "s";
            }
        }();
        return A3(jon, n, t, r);
    }), Von = A2(tE, rE(0), It(0)), Bon = function(n) {
        var r = function(n) {
            return n.a.rv;
        }(n);
        return r > 0 ? A2(zx, w([
            Gx("flex flex-row")
        ]), w([
            A2(Tq, w([
                zE,
                MN(Von),
                Wj("text-primary-500")
            ]), 19),
            A2(Mx, w([
                Gx("ml-0.5")
            ]), w([
                _d(A2(Don, "attachment", r))
            ]))
        ])) : vE;
    }, Gon = F3(function(n, r, t) {
        var e, u = A4(pon, n, r, function(n) {
            return n.a.rg;
        }(t), function(n) {
            return n.a.nC;
        }(t));
        return A2(zx, w([
            qE((e = gon(t), {
                $: 2,
                a: e
            })),
            Gx("flex flex-row space-x-2 cursor-pointer w-full")
        ]), w([
            A2(zx, w([
                Gx("flex flex-col mt-1")
            ]), w([
                $on(hon(t))
            ])),
            A2(zx, w([
                Gx("flex flex-col grow gap-1 text-nowrap truncate")
            ]), w([
                A2(zx, w([
                    Gx("flex flex-row")
                ]), w([
                    A2(f_, w([
                        sE
                    ]), w([
                        _d(n(qon(hon(t))))
                    ]))
                ])),
                function() {
                    if (u.$) return vE;
                    var n = u.a;
                    return A2(zx, w([
                        Gx("flex flex-row text-primary-500")
                    ]), w([
                        _d(n)
                    ]));
                }(),
                A2(zx, w([
                    Gx("flex flex-row")
                ]), w([
                    _d(Fon(t))
                ])),
                Bon(t)
            ])),
            A2(zx, w([
                Gx("flex flex-col justify-center text-primary-300 shrink-0")
            ]), w([
                A2(Tq, w([
                    zE
                ]), 7)
            ]))
        ]));
    }), zon = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("invoices-list")
        ]), A2(BV, s_, A2(Fu, A2(Gon, n, r), t)));
    }), Son = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ton = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t, e = r.eP;
                    switch(e.$){
                        case 3:
                            var u = e.a;
                            return w([
                                A2(zx, g, nE(u) ? rF(n(jd)) : w([
                                    A3(zon, n, r.kn, u),
                                    (t = r.lQ, A2(c_, Son, A2(Yq, w([
                                        Iq
                                    ]), t)))
                                ]))
                            ]);
                        case 2:
                            return aE(n(Dd));
                        default:
                            return Nx;
                    }
                }())
            ]),
            yx: n(Qv(7))
        };
    }), Pon = C_({
        Cl: son,
        CQ: lon,
        Fj: don,
        F4: function() {
            return bx;
        },
        Gv: von,
        GB: Ton
    }), Zon = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Mon = F2(function(n, r) {
        return A2(bk, w([
            r
        ]), function(n) {
            return A2(bk, w([
                "notes"
            ]), mk(n));
        }(n));
    }), Lon = F8(function(n, r, t, e, u, a, i, c) {
        return {
            nC: u,
            pQ: c,
            rg: e,
            BT: i,
            uH: n,
            uI: r,
            mt: t,
            yu: a
        };
    }), Non = F2(function(n, r) {
        return {
            sl: n,
            ur: r
        };
    }), Hon = A3(nk, "name", M$, A3(nk, "id", M$, au(Non))), Ion = A2($A, Hon, au(cu)), Oon = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Qon = A3(nk, "formattedText", M$, au(function(n) {
        return {
            rM: n
        };
    })), Ron = A2($A, Qon, au(cu)), Uon = A2($A, A2(eu, Oon, Ron), au(cu)), Kon = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Won = A3(nk, "text", uC(M$), A3(nk, "address", uC(M$), A3(nk, "location", uC(M$), A3(nk, "daysOfTreatment", uC(O$), A3(nk, "numberOfRefills", uC(O$), A3(nk, "quantityPrescribed", uC(O$), A3(nk, "instructions", uC(M$), A3(nk, "medicationName", uC(M$), A3(nk, "prescriber", uC(M$), A3(nk, "useByDate", uC(XZ), A3(nk, "datePrescribed", uC(XZ), A3(nk, "routeOfAdministration", uC(M$), A3(nk, "form", uC(M$), A3(nk, "strength", uC(M$), au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return {
                                                                m9: d,
                                                                k_: e,
                                                                k0: s,
                                                                le: r,
                                                                lk: c,
                                                                lp: l,
                                                                ls: i,
                                                                lH: f,
                                                                l0: a,
                                                                l5: o,
                                                                me: t,
                                                                mu: n,
                                                                yu: v,
                                                                mB: u
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), Xon = A2($A, Won, au(cu)), Yon = A2($A, A2(eu, Kon, Xon), au(cu)), Jon = function(n) {
        return {
            $: 7,
            a: n
        };
    }, nfn = A3(nk, "formattedText", M$, au(function(n) {
        return {
            rM: n
        };
    })), rfn = A2($A, nfn, au(cu)), tfn = A2($A, A2(eu, Jon, rfn), au(cu)), efn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ufn = F4(function(n, r, t, e) {
        return {
            px: r,
            rJ: n,
            mv: e,
            yy: t
        };
    }), afn = F2(function(n, r) {
        return {
            pU: n,
            wB: r
        };
    }), ifn = A3(nk, "questionCount", O$, A3(nk, "dateSubmitted", uC(XZ), au(afn))), cfn = A3(nk, "submissionData", ifn, A3(nk, "to", M$, A3(nk, "created", uC(XZ), A3(nk, "formName", M$, au(ufn))))), ofn = A2($A, cfn, au(cu)), ffn = A2($A, A2(eu, efn, ofn), au(cu)), sfn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lfn = F2(function(n, r) {
        return {
            mQ: n,
            u4: r
        };
    }), dfn = F3(function(n, r, t) {
        return {
            Ax: t,
            qf: n,
            E$: r
        };
    }), vfn = A4(JA, "chargeId", uC(M$), Ot, A4(JA, "reference", uC(M$), Ot, A3(nk, "display", uC(M$), au(dfn)))), bfn = A3(nk, "orderedFrom", uC(M$), A3(nk, "actions", ek(vfn), au(lfn))), mfn = A2($A, bfn, au(cu)), pfn = A2($A, A2(eu, sfn, mfn), au(cu)), $fn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gfn = A3(nk, "formattedText", M$, au(function(n) {
        return {
            rM: n
        };
    })), hfn = A2($A, gfn, au(cu)), yfn = A2($A, A2(eu, $fn, hfn), au(cu)), wfn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, xfn = F8(function(n, r, t, e, u, a, i, c) {
        return {
            pT: r,
            k0: c,
            rO: n,
            lk: u,
            ls: e,
            lH: i,
            wf: t,
            l5: a
        };
    }), _fn = A3(nk, "daysOfTreatment", uC(O$), A3(nk, "numberOfRefills", uC(O$), A3(nk, "quantityPrescribed", uC(O$), A3(nk, "instructions", uC(M$), A3(nk, "medicationName", uC(M$), A3(nk, "priceForPatient", uC(I$), A3(nk, "dateFulfilled", uC(KA), A3(nk, "frequency", uC(M$), au(xfn))))))))), Cfn = A2($A, _fn, au(cu)), Afn = A2($A, A2(eu, wfn, Cfn), au(cu)), kfn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Efn = A2(eu, function(n) {
        return "CM" === n ? 1 : 0;
    }, M$), qfn = A2(eu, function(n) {
        return "C" === n ? 1 : 0;
    }, M$), Ffn = A2(eu, function(n) {
        return "KILOS" === n ? 1 : 0;
    }, M$), jfn = A4(JA, "headCircumferenceUnit", Efn, 0, A4(JA, "headCircumference", ik(I$), Ot, A4(JA, "heightUnit", Efn, 0, A3(nk, "height", uC(I$), A3(nk, "bmi", uC(I$), A4(JA, "weightUnit", Ffn, 0, A3(nk, "weight", uC(I$), A3(nk, "spo2", uC(I$), A3(nk, "respiratoryRate", uC(I$), A3(nk, "heartRate", uC(I$), A3(nk, "diastolic", uC(I$), A3(nk, "systolic", uC(I$), A4(JA, "tempUnit", qfn, 0, A3(nk, "temp", uC(I$), au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return {
                                                                n$: f,
                                                                qc: e,
                                                                r0: d,
                                                                r1: v,
                                                                r7: u,
                                                                r8: s,
                                                                r9: l,
                                                                xa: a,
                                                                xY: i,
                                                                yn: t,
                                                                ys: n,
                                                                yt: r,
                                                                zl: c,
                                                                zm: o
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), Dfn = A2($A, jfn, au(cu)), Vfn = A2($A, A2(eu, kfn, Dfn), au(cu)), Bfn = Q$(w([
        Vfn,
        yfn,
        Uon,
        ffn,
        pfn,
        Afn,
        Yon,
        tfn
    ])), Gfn = A3(nk, "data", Bfn, A3(nk, "files", ek(Ion), A4(JA, "text", A2(eu, xc(""), ik(M$)), "", A3(nk, "author", uC(M$), A3(nk, "eventTimestamp", uC(XZ), A3(nk, "status", M$, A3(nk, "noteType", A2(nu, eon, M$), A3(nk, "noteId", M$, au(Lon))))))))), zfn = A2($A, Gfn, au(cu)), Sfn = F4(function(n, r, t, e) {
        return A4(aA, n, zfn, e, pk(A2(Mon, r, t)));
    }), Tfn = F3(function(n, r, t) {
        var e = {
            hq: r.AF.ft,
            ld: r.ld,
            sl: t.Ep.sl,
            fg: Ot,
            uG: kc,
            dV: n,
            kn: r.kn,
            yZ: t
        };
        return v(e, function(n) {
            var r = j_(F_(n.hq));
            if (r.$) return Qp;
            var t = r.a;
            return A4(Sfn, n.hq, t, n.sl, Zon(t));
        }(e));
    }), Pfn = F2(function(n, r) {
        return v(r, Qp);
    }), Zfn = F2(function(n, r) {
        return m(r, {
            zK: It(7)
        });
    }), Mfn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Lfn = F3(function(n, r, t) {
        return {
            sl: n,
            ur: r,
            yZ: t
        };
    }), Nfn = A3(nk, "url", M$, A3(nk, "name", M$, A3(nk, "id", M$, au(Lfn)))), Hfn = A2($A, Nfn, au(cu)), Ifn = F3(function(n, r, t) {
        return A2(bk, w([
            t
        ]), A2(bk, w([
            "file"
        ]), A2(Mon, n, r)));
    }), Ofn = F5(function(n, r, t, e, u) {
        return A4(aA, n, Hfn, u, pk(A3(Ifn, r, t, e)));
    }), Qfn = "Patient Portal", Rfn = F3(function(n, r, t) {
        return A3(WC, F3(function(t, e, u) {
            return A3(wn, n(t), r(e), u);
        }), {}, t);
    }), Ufn = F2(function(n, r) {
        return rx(w([
            v("type", tx(n)),
            v("payload", r)
        ]));
    }), Kfn = F2(function(n, r) {
        return A2(Ufn, n, A3(Rfn, cu, tx, ed(r)));
    }), Wfn = Xn("fullStoryPortLogEvent", cu), Xfn = F2(function(n, r) {
        return Wfn(A2(Kfn, n, r));
    }), Yfn = function(n) {
        return v(n.a, n.b);
    }, Jfn = F2(function(n, r) {
        return A2(Xfn, n, A2(Fu, Yfn, r));
    }), nsn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), rsn = F2(function(n, r) {
        return A2(nsn, n, r);
    }), tsn = function(n) {
        return A2(rsn, "Patient ID", n);
    }, esn = function(n) {
        return A2(rsn, "User Flow", n);
    }, usn = F3(function(n, r, t) {
        return A2(Jfn, "Clinical Data Opened", w([
            esn(Qfn),
            tsn(n),
            A2(rsn, "interaction ID", r),
            A2(rsn, "interaction type", t)
        ]));
    }), asn = function(n) {
        return n.uI;
    }, isn = Xn("printWindow", function() {
        return nx;
    }), csn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.b;
                if (3 === t.$) {
                    var e = A3(usn, n.a, r.sl, A2(Vx, 0, qon(asn(t.a))));
                    return b(m(r, {
                        uG: t
                    }), Uu(w([
                        e
                    ])), g);
                }
                return b(m(r, {
                    uG: kc
                }), Qp, A2(Ik, 0, t));
            case 1:
                var u = n.a, a = j_(F_(r.hq)), i = a.$ ? Qp : A5(Ofn, r.hq, a.a, r.sl, u, Mfn);
                return b(m(r, {
                    fg: It(u)
                }), i, g);
            case 2:
                var c = n.a, o = m(r, {
                    fg: Ot
                });
                return 3 === c.$ ? b(o, $9(function(n) {
                    return n.yZ;
                }(c.a)), g) : b(o, Qp, A2(Ik, 0, c));
            default:
                return b(r, 3 === r.uG.$ ? isn(0) : Qp, g);
        }
    }), osn = function(n) {
        return n.rg;
    }, fsn = function(n) {
        return n.BT;
    }, ssn = {
        $: 3
    }, lsn = function(n) {
        return A2(Mx, w([
            Gx("text-support")
        ]), w([
            A2(EV, w([
                Sen,
                yV(x_(Ba))
            ]), w([
                _d(n(Qv(7)))
            ]))
        ]));
    }, dsn = function(n) {
        return H$(n.a.j);
    }, vsn = function(n) {
        return !dsn(n);
    }, bsn = F3(function(n, r, t) {
        return vsn(r) ? vE : A2(zx, w([
            Gx("note-breadcrumbs")
        ]), w([
            A2(BE, w([
                xN(JI)
            ]), w([
                A2(lE, w([
                    cE(rD),
                    VN(w([
                        Gx("flex")
                    ]))
                ]), w([
                    lsn(n),
                    A2(Mx, w([
                        Gx("mx-3 text-support")
                    ]), w([
                        _d("/")
                    ])),
                    _d(n(qon(asn(t)))),
                    A2(Mx, w([
                        Gx("text-primary-300 ml-auto text-right")
                    ]), w([
                        A2(zx, w([
                            Gx("cursor-pointer"),
                            qE(ssn)
                        ]), w([
                            A2(Tq, g, 17)
                        ]))
                    ]))
                ]))
            ])),
            A2(BE, w([
                xN(JI)
            ]), w([
                A2(lE, g, w([
                    s_
                ]))
            ]))
        ]));
    }), msn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, psn = function(n) {
        return n.ur;
    }, $sn = A2(tE, rE(1), It(1)), gsn = F2(function(n, r) {
        var t, e = function(n) {
            return n.sl;
        }(r), u = A2(Op, function(n) {
            return i(n, e);
        }, n), a = !u.$ && u.a ? Lx(w([
            Sun,
            msn(w([
                Gx("mr-3")
            ]))
        ])) : A2(Tq, w([
            MN($sn)
        ]), 20);
        return A2(zx, w([
            Gx("file-button")
        ]), w([
            A2(yF, w([
                cF((t = e, {
                    $: 1,
                    a: t
                })),
                Lj(Cz(u))
            ]), w([
                A2(Mx, g, w([
                    a,
                    _d(psn(r))
                ]))
            ]))
        ]));
    }), hsn = F2(function(n, r) {
        return nE(r) ? vE : A2(BE, w([
            xN(JI)
        ]), w([
            A2(lE, g, w([
                A2(zx, w([
                    Gx("clinical-note-files")
                ]), A2(Fu, gsn(n), r))
            ]))
        ]));
    }), ysn = F3(function(n, r, t) {
        var e = A4(pon, n, r, osn(t), function(n) {
            return n.nC;
        }(t));
        if (e.$) return vE;
        var u = e.a;
        return A2(zx, w([
            Gx("flex flex-row text-sm text-primary-500 mb-4")
        ]), w([
            _d(u)
        ]));
    }), wsn = function(n) {
        return n.dE.A2;
    }, xsn = function(n) {
        return n.dE.pU;
    }, _sn = function(n) {
        return n.dE.Dn;
    }, Csn = function(n) {
        return n.dE.Fw;
    }, Asn = function(n) {
        return n.dE.mt;
    }, ksn = function(n) {
        return n.rJ;
    }, Esn = F2(function(n, r) {
        return v(n, r);
    }), qsn = function(n) {
        return n.mv.wB;
    }, Fsn = function(n) {
        return n.yy;
    }, jsn = function(n) {
        return n.pR.uC;
    }, Dsn = F2(function(n, r) {
        var t = r.a, e = r.b;
        return A2(GY, w([
            Gx("data-display__row")
        ]), w([
            A2(TY, w([
                Gx("data-display__label")
            ]), w([
                _d(n(t))
            ])),
            A2(TY, w([
                Gx("data-display__value")
            ]), w([
                _d(A2(xc, n(jsn), e))
            ]))
        ]));
    }), Vsn = F2(function(n, r) {
        return A2(zx, w([
            Gx("data-display")
        ]), w([
            A2(HY, w([
                Gx("data-display__table")
            ]), w([
                A2(IY, g, A2(Fu, Dsn(n), r))
            ]))
        ]));
    }), Bsn = F2(function(n, r) {
        return A2(Op, function(r) {
            return A2(fe, " ", w([
                A2(n, 1, r),
                A2(n, 4, r),
                "(" + A2(n, 6, r) + ")"
            ]));
        }, r);
    }), Gsn = F4(function(n, r, t, e) {
        var u = "FULFILLED" === t || "ADDENDED" === t ? "Completed" : "Pending Submission", a = A2(Bsn, r, function(n) {
            return n.mv.pU;
        }(e)), i = A2(Bsn, r, function(n) {
            return n.px;
        }(e));
        return A2(zx, w([
            Gx("w-full md:w-1/2")
        ]), w([
            A2(zx, w([
                Gx("mb-4")
            ]), w([
                _d(ksn(e))
            ])),
            A2(Vsn, n, w([
                A2(Esn, Asn, It(u)),
                A2(Esn, wsn, i),
                A2(Esn, Csn, It(Fsn(e))),
                A2(Esn, xsn, a),
                A2(Esn, _sn, It(oe(qsn(e))))
            ]))
        ]));
    }), zsn = function(n) {
        return A2(n$, cu, A2(Fu, function(n) {
            return n.qf;
        }, n.mQ));
    }, Ssn = function(n) {
        return n.u4;
    }, Tsn = function(n) {
        return mu(n) ? vE : A2(zx, w([
            Gx("note-text")
        ]), w([
            _d(n)
        ]));
    }, Psn = function(n) {
        if (n.$) return vE;
        var r = n.a;
        return A2(zx, w([
            Gx("mb-4")
        ]), w([
            _d("Lab Facility: " + r)
        ]));
    }, Zsn = F2(function(n, r) {
        var t;
        return A2(zx, w([
            Gx("w-full md:w-1/2")
        ]), w([
            Tsn(n),
            Psn(Ssn(r)),
            (t = zsn(r), A2(zx, g, w([
                _d("Ordered tests:"),
                A2(zx, w([
                    Gx("ml-4")
                ]), w([
                    A2(Kq, w([
                        Gx("list-disc ml-2")
                    ]), A2(Fu, function(n) {
                        return A2(Qq, g, w([
                            _d(n)
                        ]));
                    }, t))
                ]))
            ])))
        ]));
    }), Msn = function(n) {
        return n.m9;
    }, Lsn = function(n) {
        return n.lp;
    }, Nsn = F2(function(n, r) {
        return A2(zx, g, w([
            _d(A2(fe, ": ", w([
                n,
                A2(xc, "no data", r)
            ])))
        ]));
    }), Hsn = function(n) {
        return n.k_;
    }, Isn = function(n) {
        return n.k0;
    }, Osn = function(n) {
        return n.le;
    }, Qsn = function(n) {
        return n.lk;
    }, Rsn = function(n) {
        return n.ls;
    }, Usn = function(n) {
        return n.lH;
    }, Ksn = function(n) {
        return n.l0;
    }, Wsn = function(n) {
        return n.ae.A$;
    }, Xsn = function(n) {
        return n.ae.k_;
    }, Ysn = function(n) {
        return n.ae.k0;
    }, Jsn = function(n) {
        return n.ae.le;
    }, nln = function(n) {
        return n.ae.rO;
    }, rln = function(n) {
        return n.ae.lk;
    }, tln = function(n) {
        return n.ae.C3;
    }, eln = function(n) {
        return n.ae.l0;
    }, uln = function(n) {
        return n.ae.l1;
    }, aln = function(n) {
        return n.ae.wx;
    }, iln = function(n) {
        return n.ae.E0;
    }, cln = function(n) {
        return n.ae.me;
    }, oln = function(n) {
        return n.ae.mu;
    }, fln = function(n) {
        return n.ae.mB;
    }, sln = function(n) {
        return n.l5;
    }, lln = function(n) {
        return n.me;
    }, dln = function(n) {
        return n.mu;
    }, vln = function(n) {
        return n.yu;
    }, bln = function(n) {
        return n.mB;
    }, mln = F3(function(n, r, t) {
        return function(n) {
            var r = n;
            return A2(Wk, cu, w([
                Cz(r.mu),
                Cz(r.le),
                Cz(r.me),
                Cz(r.k_),
                Cz(r.mB),
                Cz(r.l0),
                Cz(r.ls),
                Cz(r.lk),
                Cz(r.l5),
                Cz(r.lH),
                Cz(r.k0),
                Cz(r.lp),
                Cz(r.m9)
            ]));
        }(t) ? A2(Vsn, n, w([
            A2(Esn, tln, Rsn(t)),
            A2(Esn, oln, dln(t)),
            A2(Esn, Jsn, Osn(t)),
            A2(Esn, rln, Qsn(t)),
            A2(Esn, aln, A2(Op, oe, sln(t))),
            A2(Esn, cln, lln(t)),
            A2(Esn, iln, A2(Op, oe, Usn(t))),
            A2(Esn, Ysn, A2(Op, oe, Isn(t))),
            A2(Esn, Xsn, A2(Op, r(0), Hsn(t))),
            A2(Esn, fln, A2(Op, r(0), bln(t))),
            A2(Esn, eln, Ksn(t))
        ])) : A2(zx, g, w([
            _d(A2(xc, "Prescription details are missing.", vln(t)))
        ]));
    }), pln = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("w-full md:w-1/2")
        ]), w([
            A2(zx, w([
                Gx("mb-4")
            ]), w([
                A2(Nsn, "Location", Lsn(t)),
                A2(Nsn, "Address", Msn(t))
            ])),
            A3(mln, n, r, t)
        ]));
    }), $ln = function(n) {
        return n.b.m9;
    }, gln = function(n) {
        return n.oE;
    }, hln = A2(Mx, g, w([
        _d("," + QD)
    ])), yln = function(n) {
        return iL(n);
    }, wln = function(n) {
        return n.s4;
    }, xln = function(n) {
        return n.s5;
    }, _ln = function(n) {
        return n.x6;
    }, Cln = function(n) {
        return n.zF;
    }, Aln = function(n) {
        var r = ZV(Cln(n)), t = mu(_ln(n)) ? Ot : It(A2(Mx, g, w([
            _d(_ln(n))
        ]))), e = yln(xln(n)) ? Ot : It(ZV(xln(n))), u = yln(wln(n)) ? Ot : It(ZV(wln(n))), a = mu(gln(n)) ? Ot : It(A2(Mx, g, w([
            _d(gln(n))
        ]))), i = A2(BV, hln, A2(n$, cu, w([
            u,
            e,
            a,
            t
        ]))), c = function() {
            var r = v(nE(i), yln(Cln(n)));
            return r.a || r.b ? vE : RD;
        }();
        return $(i, w([
            c,
            r
        ]));
    }, kln = function(n) {
        var r = $ln(n);
        if (r.$) return vE;
        var t = r.a;
        return A2(zx, g, w([
            A2(Mx, g, w([
                _d("Address: ")
            ])),
            A2(Mx, g, Aln(t))
        ]));
    }, Eln = function(n) {
        return A2(zx, g, w([
            _d("Location: " + ax(n))
        ]));
    }, qln = function(n) {
        return n.pT;
    }, Fln = function(n) {
        return n.k0;
    }, jln = function(n) {
        return n.rO;
    }, Dln = function(n) {
        return n.lk;
    }, Vln = function(n) {
        return n.ls;
    }, Bln = function(n) {
        return n.lH;
    }, Gln = function(n) {
        return n.wf;
    }, zln = function(n) {
        return n.l5;
    }, Sln = F2(function(n, r) {
        return A2(Vsn, n, w([
            A2(Esn, tln, Vln(r)),
            A2(Esn, rln, Dln(r)),
            A2(Esn, nln, jln(r)),
            A2(Esn, Ysn, A2(Op, oe, Fln(r))),
            A2(Esn, aln, A2(Op, oe, zln(r))),
            A2(Esn, iln, A2(Op, oe, Bln(r))),
            A2(Esn, Wsn, A2(Op, SM(sZ("/")), qln(r))),
            A2(Esn, uln, A2(Op, A2(HK, !1, !0), Gln(r)))
        ]));
    }), Tln = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("w-full md:w-1/2")
        ]), w([
            A2(zx, w([
                Gx("mb-4")
            ]), w([
                Eln(r),
                kln(r)
            ])),
            A2(Sln, n, t)
        ]));
    }), Pln = function(n) {
        return n.n$;
    }, Zln = function(n) {
        return n.qc;
    }, Mln = F3(function(n, r, t) {
        return A2(xc, NaN, VZ(A2(n, r, t)));
    }), Lln = Mln(GK), Nln = function(n) {
        return jF(A2(Lln, 1, n));
    }, Hln = function(n) {
        return n.r7;
    }, Iln = function(n) {
        return n.r8;
    }, Oln = function(n) {
        return n.xa;
    }, Qln = function(n) {
        return n.xY;
    }, Rln = function(n) {
        return n.yn;
    }, Uln = function(n) {
        return n.ys;
    }, Kln = function(n) {
        return n.Y.n$;
    }, Wln = function(n) {
        return n.Y.qc;
    }, Xln = function(n) {
        return n.Y.B2;
    }, Yln = function(n) {
        return n.Y.B3;
    }, Jln = function(n) {
        return n.Y.B5;
    }, ndn = function(n) {
        return n.Y.B6;
    }, rdn = function(n) {
        return n.Y.EV;
    }, tdn = function(n) {
        return n.Y.xa;
    }, edn = function(n) {
        return n.Y.xY;
    }, udn = function(n) {
        return n.Y.yn;
    }, adn = function(n) {
        return n.Y.F8;
    }, idn = function(n) {
        return n.Y.F9;
    }, cdn = function(n) {
        return n.Y.GF;
    }, odn = function(n) {
        return n.Y.GG;
    }, fdn = function(n) {
        return n.Y.GI;
    }, sdn = function(n) {
        return n.zl;
    }, ldn = F4(function(n, r, t, e) {
        var u, a, i, c, o = (u = function(n) {
            return n.zm;
        }(e), 1 === u ? odn : cdn), f = (a = function(n) {
            return n.yt;
        }(e), 1 === a ? idn : adn), s = A2(Op, function(n) {
            return A2(fe, ", ", w([
                A2(r, 0, n),
                A2(r, 5, n)
            ]));
        }, t), l = (i = function(n) {
            return n.r9;
        }(e), 1 === i ? ndn : Jln), d = (c = function(n) {
            return n.r1;
        }(e), 1 === c ? Yln : Xln), v = function() {
            var n = function(n) {
                return n.r0;
            }(e);
            return n.$ ? g : w([
                A2(Esn, d, It(Nln(n.a)))
            ]);
        }();
        return A2(zx, w([
            Gx("w-full md:w-1/2")
        ]), w([
            A2(Vsn, n, vc(w([
                w([
                    A2(Esn, fdn, s),
                    A2(Esn, udn, A2(Op, Nln, Rln(e))),
                    A2(Esn, Wln, A2(Op, Nln, Zln(e))),
                    A2(Esn, rdn, A2(Op, Nln, Hln(e))),
                    A2(Esn, edn, A2(Op, Nln, Qln(e))),
                    A2(Esn, f, A2(Op, Nln, Uln(e))),
                    A2(Esn, tdn, A2(Op, Nln, Oln(e))),
                    A2(Esn, l, A2(Op, Nln, Iln(e))),
                    A2(Esn, o, A2(Op, Nln, sdn(e)))
                ]),
                v,
                w([
                    A2(Esn, Kln, A2(Op, Nln, Pln(e)))
                ])
            ])))
        ]));
    }), ddn = F4(function(n, r, t, e) {
        var u = function(n) {
            return n.pQ;
        }(e);
        switch(u.$){
            case 0:
                var a = u.a;
                return A4(ldn, n, t, osn(e), a);
            case 1:
                return function(n) {
                    var r = n0(function(n) {
                        return n.rM;
                    }(n));
                    if (r.$) return vE;
                    var t = r.a;
                    return A2(zx, w([
                        Gx("formatted-text-data")
                    ]), e0(t));
                }(u.a);
            case 2:
                return function(n) {
                    var r = n0(function(n) {
                        return n.rM;
                    }(n));
                    if (r.$) return vE;
                    var t = r.a;
                    return A2(zx, w([
                        Gx("formatted-text-data")
                    ]), e0(t));
                }(u.a);
            case 3:
                var i = u.a;
                return A4(Gsn, n, t, function(n) {
                    return n.mt;
                }(e), i);
            case 4:
                var c = u.a;
                return A2(Zsn, function(n) {
                    return n.yu;
                }(e), c);
            case 5:
                return A3(Tln, n, r, u.a);
            case 6:
                return A3(pln, n, t, u.a);
            default:
                return function(n) {
                    var r = n0(function(n) {
                        return n.rM;
                    }(n));
                    if (r.$) return vE;
                    var t = r.a;
                    return A2(zx, w([
                        Gx("formatted-text-data")
                    ]), e0(t));
                }(u.a);
        }
    }), vdn = F4(function(n, r, t, e) {
        return A2(zx, g, w([
            A2(BE, w([
                xN(JI)
            ]), w([
                A2(lE, g, w([
                    A2(c_, Cu, A3(ysn, n, t, e)),
                    A2(c_, Cu, A4(ddn, n, r, t, e))
                ]))
            ]))
        ]));
    }), bdn = F2(function(n, r) {
        var t = function() {
            var t = r.uG;
            if (3 === t.$) {
                var e = t.a, u = It(n(qon(asn(e)))), a = A2(Op, r.kn(0), osn(e));
                return A2(fe, "_", A2(n$, cu, w([
                    u,
                    a
                ])));
            }
            return n(Qv(7));
        }();
        return {
            g8: w([
                A2(zx, g, w([
                    A2(zx, w([
                        Gx("panel clinical-note")
                    ]), function() {
                        var t = r.uG;
                        if (3 === t.$) {
                            var e = t.a;
                            return w([
                                A3(bsn, n, r.hq, e),
                                A4(vdn, n, r.dV, r.kn, e),
                                A2(hsn, r.fg, fsn(e))
                            ]);
                        }
                        return Nx;
                    }())
                ]))
            ]),
            yx: t
        };
    }), mdn = C_({
        Cl: Tfn,
        CQ: Pfn,
        Fj: Zfn,
        F4: function() {
            return bx;
        },
        Gv: csn,
        GB: bdn
    }), pdn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $dn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gdn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), hdn = F5(function(n, r, t, e, u) {
        return {
            pS: r,
            qq: t,
            qx: u,
            qy: e,
            sl: n
        };
    }), ydn = function(n) {
        switch(n){
            case "paid":
                return au(0);
            case "void":
                return au(1);
            case "due":
                return au(2);
            default:
                return AA("Unsupported document status: " + n);
        }
    }, wdn = A3(nk, "due_date", KA, A3(nk, "due_in_cents", O$, A3(nk, "document_status", A2(nu, ydn, M$), A3(nk, "date", KA, A3(nk, "id", M$, au(hdn)))))), xdn = A2(zB, 0, A2($A, wdn, au(gdn))), _dn = {
        lQ: cA
    }, Cdn = F4(function(n, r, t, e) {
        return A4(aA, n, ek(xdn), e, A2($k, function(n) {
            var r = n(_dn);
            return vc(w([
                bA(r.lQ)
            ]));
        }(t), pk(function(n) {
            return A2(bk, w([
                "customer_invoices"
            ]), fM(n));
        }(r))));
    }), Adn = function(n) {
        var r = function(r) {
            return m(r, {
                lQ: n.lQ
            });
        };
        return A4(Cdn, n.g0, ux(n.dV), r, $dn);
    }, kdn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Edn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qdn = {
        $: 3
    }, Fdn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, jdn = function(n) {
        return n.bu.zU;
    }, Ddn = function(n) {
        return n.bu.AX;
    }, Vdn = function(n) {
        return n.bu.AZ;
    }, Bdn = function(n) {
        return n.bu.qZ;
    }, Gdn = function(n) {
        return n.bu.Cj;
    }, zdn = function(n) {
        return n.bu.Ck;
    }, Sdn = function(n) {
        return n.bu.CM;
    }, Tdn = function(n) {
        return n.bu.x0;
    }, Pdn = function(n) {
        switch(n){
            case 0:
                return jdn;
            case 1:
                return Ddn;
            case 2:
                return Sdn;
            default:
                return Vdn;
        }
    }, Zdn = function(n) {
        switch(n){
            case 0:
                return It("all_time");
            case 1:
                return It("current_year");
            case 2:
                return It("last_year");
            default:
                return It("custom");
        }
    }, Mdn = F4(function(n, r, t, e) {
        var u = YO("statement-start-date"), a = u.a, i = u.b, c = A2(QU, wm(!1), a), o = A2(YF, 0, qdn), f = o.a, s = o.b, l = YO("statement-end-date"), d = l.a, b = l.b, m = A2(QU, wm(!1), d);
        return v({
            g0: t,
            hz: Ot,
            cP: m,
            hW: kc,
            $8: !1,
            vn: r,
            dV: n,
            af: f,
            fZ: Ot,
            df: c,
            f4: Cd({
                sl: "statement-download",
                Gj: function(n) {
                    return A2(qc, n, Pdn);
                },
                Gk: Zdn
            }),
            yZ: e
        }, Uu(w([
            A2(Nu, Edn, Jz),
            s,
            A2(Wp, Fdn, i),
            A2(Wp, kdn, b)
        ])));
    }), Ldn = F3(function(n, r, t) {
        var e = A4(Mdn, n, r.vn, r.g0, t), u = e.b, a = {
            g0: r.g0,
            dz: e.a,
            ld: r.ld,
            h: kc,
            lQ: cA,
            vn: r.vn,
            dV: n
        };
        return v(a, Uu(w([
            Adn(a),
            A2(Wp, pdn, u)
        ])));
    }), Ndn = F2(function(n, r) {
        return v(r, Qp);
    }), Hdn = F2(function(n, r) {
        return m(r, {
            zK: It(0)
        });
    }), Idn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Odn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Qdn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Rdn = {
        $: 6
    }, Udn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Kdn = function(n) {
        return tx(hk(n));
    }, Wdn = function(n) {
        return A2(bk, w([
            "files"
        ]), fM(n));
    }, Xdn = F6(function(n, r, t, e, u, a) {
        return {
            BI: n,
            BS: r,
            wk: a,
            yI: e,
            yS: u,
            yZ: t
        };
    }), Ydn = A2(nu, function(n) {
        return au(n);
    }, M$), Jdn = A3(nk, "processing", ru, A3(nk, "type", M$, A3(nk, "token", Ydn, A3(nk, "url", ik(M$), A3(nk, "file_name", M$, A3(nk, "extension", M$, au(Xdn))))))), nvn = A2($A, A2(eu, cu, Jdn), au(cu)), rvn = F4(function(n, r, t, e) {
        return A4(lM, n, nvn, e, A2(dM, function(n) {
            return rx(w([
                v("type", tx("account_statement")),
                v("options", rx(w([
                    v("date", rx(function() {
                        var r = n.pS;
                        if (r.$) return g;
                        var t = r.a.CW;
                        return w([
                            v("gte", Kdn(r.a.B$)),
                            v("lte", Kdn(t))
                        ]);
                    }()))
                ])))
            ]));
        }(t), pk(Wdn(r))));
    }), tvn = F2(function(n, r) {
        return A2(bk, w([
            r
        ]), Wdn(n));
    }), evn = F4(function(n, r, t, e) {
        return A4(Dj, n, nvn, e, pk(A2(bk, w([
            "generate"
        ]), A2(tvn, r, t))));
    }), uvn = function(n) {
        return n.wk;
    }, avn = function(n) {
        return A2(rsn, "fromState", n);
    }, ivn = F3(function(n, r, t) {
        var e = A2(xc, "", A2(Op, kM, JF(n))), u = A2(xc, Ku, wc(r.EX));
        return A2(Jfn, "Data Export Complete", w([
            avn(x_(u)),
            A2(rsn, "Format", "PDF"),
            A2(rsn, "Scope", A2(Vx, 0, Pdn(t))),
            tsn(e)
        ]));
    }), cvn = F2(function(n, r) {
        var t = function(n) {
            return A3(kp, n, 11, 31);
        }, e = function(n) {
            return A3(kp, n, 0, 1);
        }, u = Qb(r);
        switch(n){
            case 0:
            default:
                return {
                    pS: Ot,
                    yS: 0
                };
            case 1:
                return {
                    pS: It({
                        B$: e(u),
                        CW: t(u)
                    }),
                    yS: 0
                };
            case 2:
                return {
                    pS: It({
                        B$: e(u - 1),
                        CW: t(u - 1)
                    }),
                    yS: 0
                };
        }
    }), ovn = function(n) {
        return n.yI;
    }, fvn = function(n) {
        return n.yZ;
    }, svn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(dG, n.a, r.f4), e = t.a, u = t.b, a = t.c, i = function() {
                    var n = v(a, r.hz);
                    if (n.a.$ || n.a.a.$ || n.a.a.a.$ || n.b.$) return v(r.fZ, g);
                    var t = n.a.a.a.a, e = n.b.a;
                    return v(It(t), 3 === t ? g : w([
                        A4(rvn, r.g0, ux(r.dV), A2(cvn, t, e), Odn),
                        A3(ivn, r.vn, r.yZ, t)
                    ]));
                }(), c = i.b;
                return v(m(r, {
                    fZ: i.a,
                    f4: e
                }), Uu(A2(Qt, A2(Wp, Udn, u), c)));
            case 1:
                return v(m(r, {
                    hz: It(n.a)
                }), Qp);
            case 2:
                var o = n.a, f = function() {
                    if (3 === o.$) {
                        var n = o.a;
                        return v(A4(evn, r.g0, ux(r.dV), ovn(n), Qdn), zj(r.af));
                    }
                    return v(Qp, r.af);
                }(), s = f.a;
                return v(m(r, {
                    hW: o,
                    af: f.b
                }), s);
            case 3:
                return v(m(r, {
                    af: Bj(r.af)
                }), Qp);
            case 4:
                var l = A2(Sj, n.a, r.af), d = l.b;
                return v(m(r, {
                    af: l.a
                }), A2(Wp, Idn, d));
            case 5:
                var p = n.a, $ = function() {
                    if (3 === p.$) {
                        var n = p.a;
                        return uvn(n) ? b(r.af, !0, A2(Nu, wm(Rdn), Up(2e3))) : b(Bj(r.af), !1, A2(xc, Qp, A2(Op, $9, fvn(n))));
                    }
                    return b(r.af, !1, Qp);
                }();
                return d = $.c, v(m(r, {
                    $8: $.b,
                    af: $.a
                }), d);
            case 6:
                var h = function() {
                    var n = r.hW;
                    if (3 === n.$) {
                        var t = n.a;
                        return A4(evn, r.g0, ux(r.dV), ovn(t), Qdn);
                    }
                    return Qp;
                }();
                return v(r, h);
            case 7:
                var y = A2(zU, n.a, r.df);
                return h = y.b, v(m(r, {
                    df: y.a
                }), A2(Wp, Fdn, h));
            case 8:
                var x = A2(zU, n.a, r.cP);
                return h = x.b, v(m(r, {
                    cP: x.a
                }), A2(Wp, kdn, h));
            default:
                return c = function() {
                    var n = v(r.df.pS, r.cP.pS);
                    if (n.a.$ || n.b.$) return g;
                    var t = n.a.a, e = n.b.a;
                    return w([
                        A4(rvn, r.g0, ux(r.dV), {
                            pS: It({
                                B$: t,
                                CW: e
                            }),
                            yS: 0
                        }, Odn),
                        A3(ivn, r.vn, r.yZ, 3)
                    ]);
                }(), v(m(r, {
                    $8: !0
                }), Uu(c));
        }
    }), lvn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? b(m(r, {
                    h: t,
                    lQ: A2(Rk, A2(xc, 0, A2(bb, $u, A2(ra, "x-total-count", t.b))), r.lQ)
                }), Qp, g) : b(m(r, {
                    h: kc
                }), Qp, A2(Ik, 0, t));
            case 1:
                var e = m(r, {
                    lQ: A2(Ok, n.a, r.lQ)
                });
                return b(e, Adn(e), g);
            case 2:
                var u = A2(svn, n.a, r.dz), a = u.b;
                return b(m(r, {
                    dz: u.a
                }), A2(Wp, pdn, a), g);
            default:
                return b(r, A2(__, pa, Sa({
                    sl: n.a
                })), g);
        }
    }), dvn = function(n) {
        return n.a.pS;
    }, vvn = function(n) {
        return A2(SM, sZ("/"), n);
    }, bvn = function(n) {
        return n.a.qq;
    }, mvn = function(n) {
        return n.a.qx;
    }, pvn = function(n) {
        return n.a.qy;
    }, $vn = function(n) {
        return n.a.sl;
    }, gvn = F2(function(n, r) {
        return r.sA(n);
    }), hvn = F2(function(n, r) {
        return r.sB(n);
    }), yvn = A2(tE, rE(1), It(0)), wvn = function(n) {
        return n.qq.Bk;
    }, xvn = function(n) {
        return n.qq.Eo;
    }, _vn = function(n) {
        return n.qq.GC;
    }, Cvn = F2(function(n, r) {
        return function(r) {
            var t = r.b;
            return A2(Zq, w([
                r.a
            ]), w([
                _d(n(t))
            ]));
        }(function() {
            switch(r){
                case 2:
                    return v(2, wvn);
                case 1:
                    return v(1, _vn);
                default:
                    return v(0, xvn);
            }
        }());
    }), Avn = F2(function(n, r) {
        var t, e;
        return A2(zx, w([
            qE((t = $vn(r), {
                $: 3,
                a: t
            })),
            Gx("flex flex-row space-x-2 cursor-pointer")
        ]), w([
            A2(zx, w([
                Gx("flex flex-col mt-2")
            ]), w([
                A2(Tq, w([
                    zE
                ]), 18)
            ])),
            A2(zx, w([
                Gx("flex flex-col grow")
            ]), w([
                A2(zx, w([
                    Gx("flex flex-row items-center")
                ]), w([
                    A2(PE, w([
                        sE,
                        uE($sn)
                    ]), w([
                        _d(n(gvn(vvn(dvn(r)))))
                    ])),
                    A2(c_, Cu, A2(Cvn, n, bvn(r)))
                ])),
                A2(zx, w([
                    Gx("flex flex-row text-primary-500")
                ]), w([
                    A2(PE, g, w([
                        _d(n(hvn(vvn(mvn(r)))))
                    ]))
                ])),
                A2(zx, w([
                    Gx("flex flex-row mt-1")
                ]), w([
                    A2(PE, w([
                        uE(yvn)
                    ]), w([
                        _d((e = n(Gd), e + ":"))
                    ])),
                    A2(PE, w([
                        sE
                    ]), w([
                        _d(OK(pvn(r)))
                    ]))
                ]))
            ])),
            A2(zx, w([
                Gx("flex flex-col justify-center text-primary-300")
            ]), w([
                A2(Tq, w([
                    zE
                ]), 7)
            ]))
        ]));
    }), kvn = F2(function(n, r) {
        return A2(zx, w([
            Gx("invoices-list")
        ]), A2(BV, s_, A2(Fu, Avn(n), r)));
    }), Evn = {
        $: 9
    }, qvn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Fvn = qvn(uz(0)), jvn = A2(tE, rE(0), It(2)), Dvn = F2(function(n, r) {
        return A2(dD, w([
            Hj(w([
                _d(n(Gdn))
            ])),
            Mj(w([
                A2(Mx, g, w([
                    _d(n(zdn))
                ])),
                A2(zx, w([
                    Gx("flex justify-center my-12")
                ]), w([
                    Lx(w([
                        Uq
                    ]))
                ]))
            ]))
        ]), r);
    }), Vvn = F2(function(n, r) {
        var t = A2(Fu, function(n) {
            return A2(MG, g, n);
        }, w([
            0,
            1,
            2,
            3
        ])), e = function() {
            var t = r.fZ;
            return t.$ || 3 !== t.a ? g : w([
                A2(zx, n_(jvn), w([
                    A2(EH, w([
                        vH(n(Tdn))
                    ]), w([
                        A2(c_, Fdn, A2(JY, g, r.df))
                    ]))
                ])),
                A2(zx, n_(jvn), w([
                    A2(EH, w([
                        vH(n(Bdn))
                    ]), w([
                        A2(c_, kdn, A2(JY, g, r.cP))
                    ]))
                ])),
                A2(zx, n_(jvn), w([
                    A2(yF, w([
                        fF,
                        cF(Evn),
                        Lj(i(r.df.pS, Ot) || i(r.cP.pS, Ot))
                    ]), w([
                        _d(n(Iun))
                    ]))
                ]))
            ]);
        }();
        return A2(Qt, A2(c_, Udn, A4(qz, n, w([
            Fvn,
            HG(n(Iun))
        ]), t, r.f4)), $(e, w([
            A2(Dvn, n, r.af)
        ])));
    }), Bvn = F2(function(n, r) {
        return A2(c_, pdn, A2(BE, g, w([
            A2(lE, w([
                TE(4)
            ]), A2(Vvn, n, r))
        ])));
    }), Gvn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zvn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t, e = r.h;
                    switch(e.$){
                        case 3:
                            var u = e.a;
                            return w([
                                A2(zx, g, nE(u) ? rF(n(cv)) : w([
                                    A2(Bvn, n, r.dz),
                                    A2(kvn, n, u),
                                    (t = r.lQ, A2(c_, Gvn, A2(Yq, w([
                                        Iq
                                    ]), t)))
                                ]))
                            ]);
                        case 2:
                            return aE(n(Rd));
                        default:
                            return Nx;
                    }
                }())
            ]),
            yx: n(tv)
        };
    }), Svn = C_({
        Cl: Ldn,
        CQ: Ndn,
        Fj: Hdn,
        F4: function() {
            return A2(kj, pdn, vx(w([
                A2(kj, Idn, qj())
            ])));
        },
        Gv: lvn,
        GB: zvn
    }), Tvn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Pvn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Zvn = function(n) {
        return A3(r1, n.g0, ux(n.dV), Pvn);
    }, Mvn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Lvn = F6(function(n, r, t, e, u, a) {
        return {
            oE: t,
            rQ: a,
            s4: n,
            s5: r,
            x6: e,
            zF: u
        };
    }), Nvn = A4(JA, "full_address", M$, "", A3(nk, "zip", A2(eu, GV, M$), A3(nk, "state", M$, A3(nk, "city", M$, A3(nk, "line2", Q$(w([
        A2(eu, GV, M$),
        au("")
    ])), A3(nk, "line1", A2(eu, GV, M$), au(Lvn))))))), Hvn = A2($A, Nvn, au(cu)), Ivn = F7(function(n, r, t, e, u, a, i) {
        return {
            m9: r,
            qh: i,
            rR: t,
            sl: u,
            ur: e,
            EB: n,
            zf: a
        };
    }), Ovn = A3(nk, "distance", uC(I$), A3(nk, "virtual", ru, A3(nk, "id", M$, A3(nk, "name", M$, A3(nk, "full_name", M$, A3(nk, "address", uC(Hvn), A3(nk, "phone_number", uC(M$), au(Ivn)))))))), Qvn = A2($A, Ovn, au(cu)), Rvn = F4(function(n, r, t, e) {
        return {
            p6: t,
            ur: n,
            EB: r,
            xU: e
        };
    }), Uvn = A3(nk, "sources", ek(J0), A3(nk, "default_source", uC(J0), A3(nk, "phone_number", uC(A2(eu, GV, M$)), A3(nk, "name", A2(eu, GV, M$), au(Rvn))))), Kvn = A2($A, Uvn, au(cu)), Wvn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Xvn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Yvn = A3(nk, "code", uC(M$), A3(nk, "code_type", uC(M$), A3(nk, "practitioner", uC(jQ), A3(nk, "patient", uC(d1), A3(nk, "quantity", O$, A3(nk, "end_date", uC(KA), A3(nk, "date", KA, A3(nk, "taxable", ru, A3(nk, "discount_in_cents", uC(O$), A3(nk, "subtotal_in_cents", O$, A3(nk, "description", uC(A2(eu, GV, M$)), A3(nk, "name", A2(eu, GV, M$), au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        oI: s,
                                                        oJ: l,
                                                        pS: a,
                                                        p8: r,
                                                        qe: e,
                                                        qZ: i,
                                                        ur: n,
                                                        vn: o,
                                                        v4: f,
                                                        wx: c,
                                                        yk: t,
                                                        yr: u
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), Jvn = A2(zB, 0, A2($A, Yvn, au(Xvn))), nbn = A3(nk, "rate_charge", Jvn, au(function(n) {
        return {
            wD: n
        };
    })), rbn = F3(function(n, r, t) {
        return {
            zZ: r,
            p8: t,
            ur: n
        };
    }), tbn = A3(nk, "description", uC(A2(eu, GV, M$)), A3(nk, "amount_in_cents", O$, A3(nk, "name", A2(eu, GV, M$), au(rbn)))), ebn = A2($A, A2(eu, cu, nbn), A2($A, tbn, au(Wvn))), ubn = F3(function(n, r, t) {
        return {
            zZ: t,
            FS: r,
            FT: n
        };
    }), abn = A3(nk, "amount_in_cents", O$, A4(JA, "source_name", uC(M$), Ot, A3(nk, "source_type", M$, au(ubn)))), ibn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), cbn = F2(function(n, r) {
        return {
            ur: r,
            wC: n
        };
    }), obn = A3(nk, "name", M$, A3(nk, "rate", I$, au(cbn))), fbn = A2(zB, 0, A2($A, obn, au(ibn))), sbn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), lbn = F5(function(n, r, t, e, u) {
        return {
            zZ: t,
            nB: r,
            pS: n,
            xS: e,
            mt: u
        };
    }), dbn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vbn = F2(function(n, r) {
        return {
            BJ: r,
            ur: n
        };
    }), bbn = A3(nk, "external", ru, A3(nk, "name", M$, au(vbn))), mbn = A2($A, A2(eu, dbn, bbn), au(cu)), pbn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $bn = F2(function(n, r) {
        return {
            io: r,
            ur: n
        };
    }), gbn = A3(nk, "last_four", uC(M$), A3(nk, "name", M$, au($bn))), hbn = A2($A, A2(eu, pbn, gbn), au(cu)), ybn = Q$(w([
        hbn,
        mbn
    ])), wbn = A3(nk, "status", M$, A3(nk, "source", ybn, A3(nk, "amount_in_cents", O$, A3(nk, "attempted_in_cents", O$, A3(nk, "date", KA, au(lbn)))))), xbn = A3(nk, "refunded_in_cents", O$, au(function(n) {
        return {
            wN: n
        };
    })), _bn = A2($A, A2(eu, cu, xbn), A2($A, wbn, au(sbn))), Cbn = A3(nk, "payments", ek(_bn), A3(nk, "tax_profile", uC(fbn), A3(nk, "charge_group", uC(ebn), A3(nk, "charges", ek(Jvn), A3(nk, "billing_address", uC(Hvn), A3(nk, "location", uC(Qvn), A3(nk, "owner", Kvn, A3(nk, "secure_pdf_printable_token", uC(Ydn), A3(nk, "secure_pdf_inline_token", uC(Ydn), A4(JA, "savings_items", ek(abn), g, A3(nk, "discount_savings_in_cents", O$, A3(nk, "due_in_cents", O$, A4(JA, "passthrough_fees_in_cents", O$, 0, A3(nk, "paid_in_cents", O$, A3(nk, "credit_in_cents", O$, A3(nk, "transferred_to_credit_in_cents", O$, A3(nk, "subtotal_in_cents", O$, A3(nk, "tax_in_cents", O$, A3(nk, "revision_number", O$, A3(nk, "invoice_number", O$, A3(nk, "total_in_cents", O$, A3(nk, "document_status", A2(nu, ydn, M$), A3(nk, "date", KA, A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return function(b) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(y) {
                                                                                        return function(w) {
                                                                                            return function(x) {
                                                                                                return function(_) {
                                                                                                    return {
                                                                                                        nN: h,
                                                                                                        oq: w,
                                                                                                        ou: y,
                                                                                                        pE: f,
                                                                                                        pS: r,
                                                                                                        Bc: v,
                                                                                                        qq: t,
                                                                                                        qy: d,
                                                                                                        sl: n,
                                                                                                        sD: u,
                                                                                                        lp: g,
                                                                                                        iO: $,
                                                                                                        ve: s,
                                                                                                        vl: l,
                                                                                                        vI: _,
                                                                                                        xc: a,
                                                                                                        xg: b,
                                                                                                        xj: m,
                                                                                                        Fq: p,
                                                                                                        yk: c,
                                                                                                        mw: i,
                                                                                                        yq: x,
                                                                                                        mz: e,
                                                                                                        yP: o
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))), Abn = A2(zB, 0, A2($A, Cbn, au(Mvn))), kbn = F2(function(n, r) {
        return A2(bk, w([
            "customer_invoices",
            r
        ]), fM(n));
    }), Ebn = F4(function(n, r, t, e) {
        return A4(aA, n, Abn, e, pk(A2(kbn, r, t)));
    }), qbn = F3(function(n, r, t) {
        var e = {
            g0: r.g0,
            os: r.os,
            dy: kc,
            dC: Ot,
            ld: r.ld,
            sl: t.Ep.sl,
            fw: kc,
            vn: r.vu,
            dV: n,
            xU: kc,
            yZ: t
        };
        return v(e, Uu(w([
            A4(Ebn, r.g0, ux(n), t.Ep.sl, Tvn),
            Zvn(e)
        ])));
    }), Fbn = function(n) {
        return n.p6;
    }, jbn = function(n) {
        return n.a.qy;
    }, Dbn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Vbn = F3(function(n, r, t) {
        return A2(bk, w([
            "payment_methods",
            r,
            "passthroughs",
            oe(t)
        ]), fM(n));
    }), Bbn = F5(function(n, r, t, e, u) {
        return A4(aA, n, _2, u, pk(A3(Vbn, r, t, e)));
    }), Gbn = function(n) {
        return A2(xc, !1, A2(Op, k2, n));
    }, zbn = F3(function(n, r, t) {
        var e = n.dV, u = n.g0;
        if (n.os && Gbn(t)) {
            var a = A2(Op, D0, t);
            if (a.$) return Qp;
            var i = a.a;
            return A5(Bbn, u, ux(e), i, r, Dbn);
        }
        return Qp;
    }), Sbn = function(n) {
        return n.a.iO;
    }, Tbn = F2(function(n, r) {
        var t = m(r, {
            os: n.os,
            vn: n.vu
        }), e = v(r.dy, n.vu);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.a.a;
            return v(t, A3(zbn, t, jbn(u), Fbn(Sbn(u))));
        }
        return v(t, Qp);
    }), Pbn = F2(function(n, r) {
        return m(r, {
            zK: It(0)
        });
    }), Zbn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Mbn = F3(function(n, r, t) {
        return {
            AD: n,
            EH: r,
            yI: t
        };
    }), Lbn = {
        $: 2
    }, Nbn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Hbn = F2(function(n, r) {
        switch(r.$){
            case 0:
            default:
                return b(n, function(n) {
                    return A4(evn, n.AD, n.EH, n.yI, Nbn);
                }(n), g);
            case 1:
                var t = r.a;
                if (3 === t.$) {
                    var e = t.a;
                    return uvn(e) ? b(n, A2(Nu, function() {
                        return Lbn;
                    }, Up(2e3)), g) : b(n, A2(xc, Qp, A2(Op, $9, fvn(e))), g);
                }
                return b(n, Qp, A2(Ik, 0, t));
        }
    }), Ibn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = A2(bb, function(n) {
                        return It(A3(Mbn, r.g0, ux(r.dV), n));
                    }, function(n) {
                        return n.a.xj;
                    }(t.a));
                    return b(m(r, {
                        dy: t,
                        dC: e
                    }), Qp, A2(Ik, 0, t));
                }
                return b(m(r, {
                    dy: t
                }), Qp, A2(Ik, 0, t));
            case 1:
                var u = n.a, a = r.dC;
                if (a.$) return b(r, Qp, g);
                var i = A2(Hbn, e = a.a, u), c = i.b, o = i.c;
                return b(m(r, {
                    dC: It(i.a)
                }), A2(Wp, Zbn, c), o);
            case 2:
                var f = n.a;
                return 3 === f.$ ? b(m(r, {
                    xU: f
                }), Qp, g) : b(m(r, {
                    xU: kc
                }), Qp, A2(Ik, 0, f));
            default:
                return b(m(r, {
                    fw: n.a
                }), Qp, g);
        }
    }), Obn = {
        $: 11
    }, Qbn = function(n) {
        return n.a.pS;
    }, Rbn = function(n) {
        return A2(SM, sZ("/"), n);
    }, Ubn = function(n) {
        return A2(Mx, w([
            Gx("text-support")
        ]), w([
            A2(EV, w([
                Sen,
                yV(x_(za))
            ]), w([
                _d(n(tv))
            ]))
        ]));
    }, Kbn = {
        $: 0
    }, Wbn = F3(function(n, r, t) {
        var e, u = r.g0, a = r.dC.$ ? vE : A2(c_, Zbn, (e = w([
            A2(Tq, g, 17)
        ]), A2(yF, w([
            j6,
            Kj(w([
                Gx("mr-3")
            ])),
            cF(Kbn)
        ]), e))), i = vsn(u) ? g : w([
            Ubn(n),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            _d(Rbn(Qbn(t)))
        ]);
        return A2(zx, g, w([
            A2(BE, w([
                xN(JI)
            ]), w([
                A2(lE, w([
                    cE(rD),
                    VN(w([
                        Gx("flex")
                    ]))
                ]), $(i, w([
                    A2(Mx, w([
                        Gx("text-primary-300 grow text-right")
                    ]), w([
                        a
                    ]))
                ])))
            ])),
            A2(BE, w([
                xN(JI)
            ]), w([
                A2(lE, g, w([
                    s_
                ]))
            ]))
        ]));
    }), Xbn = function(n) {
        return n.a.qq;
    }, Ybn = A2(tE, PN, It(0)), Jbn = function(n) {
        return n.a.xc;
    }, nmn = function(n) {
        return "#" + oe(function(n) {
            return n.a.sD;
        }(n)) + (Jbn(n) ? "(rev. " + oe(Jbn(n)) + ")" : "");
    }, rmn = function(n) {
        return n.ur;
    }, tmn = function(n) {
        return A2(Yk, "passthrough_credit_card_fees", n);
    }, emn = function(n) {
        return function(n) {
            return n.mz;
        }(n.a);
    }, umn = function(n) {
        return 3 === n.$ ? emn(n.a) : 0;
    }, amn = function(n) {
        return n.a.vI;
    }, imn = function(n) {
        return n.a.xg;
    }, cmn = function(n) {
        return A2(SE, 2, n);
    }, omn = nD(2), fmn = A2(tE, rE(0), Ot), smn = F2(function(n, r) {
        return PV(w([
            _d(n(r))
        ]));
    }), lmn = function(n) {
        var r = function() {
            var r, t = Cln(n), e = function(n) {
                var r = _ln(n), t = gln(n), e = v(iL(t), iL(r));
                return e.a && e.b ? "" : A2(fe, ", ", A2(no, function(n) {
                    return !iL(n);
                }, w([
                    t,
                    r
                ])));
            }(n), u = (r = v(iL(e), yln(t))).a || r.b ? vE : RD, a = v(iL(e), yln(t));
            return a.a && a.b ? Ot : It(w([
                _d(e),
                u,
                ZV(t),
                A2(Rcn, g, g)
            ]));
        }(), t = yln(xln(n)) ? Ot : It(w([
            ZV(xln(n)),
            A2(Rcn, g, g)
        ])), e = yln(wln(n)) ? Ot : It(w([
            ZV(wln(n)),
            A2(Rcn, g, g)
        ]));
        return A3(qu, ie, g, A2(n$, cu, w([
            e,
            t,
            r
        ])));
    }, dmn = function(n) {
        var r = function(n) {
            return n.EB;
        }(Sbn(n)), t = function(n) {
            return n.a.nN;
        }(n), e = v(t, r);
        return e.a.$ ? e.b.$ ? g : w([
            A2(smn, aV, e.b.a)
        ]) : vc(w([
            lmn(e.a.a),
            A2(xc, g, A2(Op, A2(tu, smn(aV), _K), r))
        ]));
    }, vmn = function(n) {
        return n.m9;
    }, bmn = function(n) {
        return n.EB;
    }, mmn = function(n) {
        return A2(xc, g, A2(Op, A2(tu, _d, _K), A2(Op, aV, n)));
    }, pmn = F2(function(n, r) {
        var t = function(n) {
            return n.a.lp;
        }(r), e = A2(bb, vmn, t);
        return A2(f_, g, function() {
            var r = v(e, $ln(n));
            return r.a.$ ? r.b.$ ? g : vc(w([
                lmn(r.b.a),
                mmn(bV(n))
            ])) : vc(w([
                lmn(r.a.a),
                mmn(A2(bb, bmn, t))
            ]));
        }());
    }), $mn = function(n) {
        return n.a.oq;
    }, gmn = function(n) {
        return n.a.zZ;
    }, hmn = function(n) {
        return n.a.pS;
    }, ymn = function(n) {
        return n.a.qZ;
    }, wmn = function(n) {
        return n.sl;
    }, xmn = function(n) {
        return n.a.vn;
    }, _mn = function(n) {
        return n.a.wx;
    }, Cmn = function(n) {
        return n.a.yr;
    }, Amn = F2(function(n, r) {
        var t = function(n) {
            return n.b.wD;
        }(r), e = function(n) {
            return n.a.ur;
        }(r);
        return vc(w([
            w([
                _d("Charge group")
            ]),
            function() {
                var n = xmn(t);
                if (n.$) return g;
                var r = n.a;
                return w([
                    A2(zx, g, w([
                        ZV(d3(r)),
                        _d("(" + wmn(r) + ")")
                    ]))
                ]);
            }(),
            w([
                A2(zx, g, w([
                    _d(Rbn(hmn(t)))
                ]))
            ]),
            w([
                _d(A2(xc, "", A2(Op, Rbn, ymn(t))))
            ]),
            _mn(t) > 1 ? w([
                A2(zx, g, w([
                    _d(oe(_mn(t)) + " x "),
                    ZV(e)
                ]))
            ]) : w([
                A2(zx, g, w([
                    ZV(e)
                ]))
            ]),
            function() {
                var n = function(n) {
                    return n.a.p8;
                }(r);
                if (n.$) return g;
                var t = n.a;
                return yln(t) ? g : w([
                    A2(zx, g, w([
                        _d("Note: "),
                        ZV(t)
                    ]))
                ]);
            }(),
            w([
                A2(zx, g, w([
                    _d(OK(gmn(r))),
                    Cmn(t) ? _d(n(Jd)) : vE
                ]))
            ])
        ]));
    }), kmn = F2(function(n, r) {
        var t = $mn(r);
        return t.$ ? vE : A2(zx, g, A2(Amn, n, t.a));
    }), Emn = function(n) {
        return n.kJ;
    }, qmn = function(n) {
        return n.a.ou;
    }, Fmn = function(n) {
        return n.ur;
    }, jmn = function(n) {
        return n.a.yk;
    }, Dmn = function(n) {
        var r = function() {
            var r = v(function(n) {
                return n.a.qe;
            }(n), jmn(n));
            if (r.a.$) return 0;
            var t = r.a.a;
            return t > 0 ? t + r.b : 0;
        }(), t = Cmn(n), e = OK(jmn(n)), u = oe(_mn(n)), a = A2(Op, Fmn, function(n) {
            return n.a.v4;
        }(n)), i = function(n) {
            var r = function() {
                var r = v(function(n) {
                    return n.a.oI;
                }(n), function(n) {
                    return n.a.oJ;
                }(n));
                if (r.a.$ || r.b.$) return "";
                var t = r.b.a;
                return " (" + Db(r.a.a) + ": " + t + ")";
            }(), t = function(n) {
                return n.a.ur;
            }(n);
            return $(t, r);
        }(n), c = A2(Op, d3, xmn(n)), o = A2(xc, vE, A2(Op, ZV, c)), f = function() {
            var n = v(a, c);
            return n.a.$ || n.b.$ ? "" : " with " + n.a.a;
        }(), s = A2(xc, vE, A2(Op, ZV, function(n) {
            return n.a.p8;
        }(n))), l = function(n) {
            var r = ymn(n);
            if (r.$) return Rbn(hmn(n));
            var t = r.a;
            return Rbn(hmn(n)) + " - " + Rbn(t);
        }(n);
        return {
            pS: l,
            p8: s,
            ur: i,
            lT: o,
            dW: a,
            l$: f,
            wx: u,
            yj: e,
            yr: t,
            gc: r
        };
    }, Vmn = function(n) {
        return n.ao;
    }, Bmn = function(n) {
        return n.vn;
    }, Gmn = function(n) {
        return n.wy;
    }, zmn = (K8 = omn, {
        $: 1,
        a: K8
    }), Smn = F2(function(n, r) {
        return A3(lan, Ot, n, r);
    }), Tmn = function(n) {
        return n.gc > 0 ? A2(f_, w([
            LE,
            nF
        ]), w([
            _d(OK(n.gc))
        ])) : vE;
    }, Pmn = F2(function(n, r) {
        return A2(ean, g, w([
            A2(Yun, g, w([
                A2(Mx, g, w([
                    A2(xX, g, w([
                        r.lT
                    ])),
                    A2(PE, g, w([
                        _d(r.l$)
                    ]))
                ]))
            ])),
            A2(Yun, g, w([
                _d(r.pS)
            ])),
            A2(Yun, g, w([
                ZV(r.ur),
                A2(f_, g, w([
                    r.p8
                ]))
            ])),
            A2(Yun, g, w([
                _d(r.wx)
            ])),
            A2(Yun, w([
                zmn
            ]), w([
                A2(Mx, w([
                    Gx("inline-flex items-center gap-2")
                ]), w([
                    Tmn(r),
                    _d(r.yj)
                ])),
                r.yr ? _d(n(Jd)) : vE
            ]))
        ]));
    }), Zmn = F2(function(n, r) {
        return r.uT(n);
    }), Mmn = F2(function(n, r) {
        var t = r.gc > 0, e = t ? 12 : 3, u = t ? 12 : 9;
        return A2(BE, w([
            _E,
            TE(12)
        ]), w([
            A2(lE, w([
                TE(u)
            ]), w([
                A2(xX, g, w([
                    r.lT
                ])),
                A2(f_, g, w([
                    ZV(r.ur)
                ])),
                A2(f_, w([
                    nF
                ]), w([
                    _d(r.wx + " x " + r.yj + " "),
                    _d(n(Zmn(r.pS)))
                ]))
            ])),
            A2(lE, w([
                VN(w([
                    Gx("mb-8 invoice-row-price")
                ])),
                TE(e),
                cE(omn)
            ]), w([
                A2(Mx, w([
                    Gx("inline-flex items-center gap-1")
                ]), w([
                    Tmn(r),
                    A2(xX, g, w([
                        _d(r.yj)
                    ]))
                ])),
                r.yr ? A2(f_, w([
                    nF
                ]), w([
                    _d(n(Jd))
                ])) : vE
            ]))
        ]));
    }), Lmn = F2(function(n, r) {
        return A2(BE, w([
            xN(JI)
        ]), w([
            A2(lE, g, w([
                A2(f_, w([
                    nF,
                    uE(aF),
                    uF(rD)
                ]), w([
                    _d(n(zd)),
                    _d(":")
                ])),
                A2(zx, w([
                    Gx("hidden sm:block")
                ]), w([
                    A2(BE, g, w([
                        A2(lE, w([
                            TE(12)
                        ]), w([
                            A2(Smn, w([
                                A2(Jun, g, n(Bmn)),
                                A2(Jun, g, n(KL)),
                                A2(Jun, g, n(Vmn)),
                                A2(Jun, g, n(Gmn)),
                                A2(Jun, w([
                                    zmn
                                ]), n(Emn))
                            ]), A2(Fu, Pmn(n), A2(Fu, Dmn, qmn(r))))
                        ]))
                    ]))
                ])),
                A2(zx, w([
                    Gx("sm:hidden mb-4")
                ]), A2(Fu, Mmn(n), A2(Fu, Dmn, qmn(r))))
            ]))
        ]));
    }), Nmn = function(n) {
        return n.b.mJ;
    }, Hmn = function(n) {
        return n.b.mM;
    }, Imn = F3(function(n, r, t) {
        var e = ve(t) > 0 || Nmn(r) || Hmn(r);
        return jbn(n) > 0 && e;
    }), Omn = function(n) {
        return n.a.sl;
    }, Qmn = F5(function(n, r, t, e, u) {
        var a = x_(Ta({
            sl: Omn(t)
        })), i = A2(dc, w([
            qN,
            yV(a)
        ]), u);
        return A3(Imn, t, r, e) ? A2(EV, i, w([
            _d(n(Wd))
        ])) : vE;
    }), Rmn = {
        $: 2
    }, Umn = function(n) {
        return n.a.zZ;
    }, Kmn = function(n) {
        return n.a.pS;
    }, Wmn = cu, Xmn = A2(tE, rE(1), It(2)), Ymn = function(n) {
        return n.a.ur;
    }, Jmn = function(n) {
        return A2(xX, g, function() {
            var r = function(n) {
                return n.$ ? Ot : n.a.io;
            }(n);
            if (r.$) return w([
                _d(Ymn(n))
            ]);
            var t = r.a;
            return w([
                _d(Ymn(n) + " *" + t)
            ]);
        }());
    }, npn = F2(function(n, r) {
        var t = function(n) {
            return n.a.xS;
        }(r), e = function(n) {
            return n.b.wN;
        }(r) > 0, u = e ? 12 : 8, a = function(n) {
            return n.a.nB;
        }(r), i = e ? 12 : 4;
        return Wmn(w([
            A2(BE, w([
                xN(JI)
            ]), w([
                A2(lE, w([
                    TE(12),
                    tO(2)
                ]), w([
                    Jmn(t)
                ])),
                A2(lE, w([
                    TE(u),
                    tO(7)
                ]), w([
                    A2(f_, w([
                        nF
                    ]), w([
                        _d(n(Zmn(Rbn(Kmn(r)))))
                    ]))
                ])),
                A2(lE, w([
                    TE(i),
                    tO(3),
                    cE(omn),
                    VN(w([
                        Gx("invoice-row-price")
                    ]))
                ]), w([
                    e ? A2(PE, w([
                        LE,
                        uE(Xmn)
                    ]), w([
                        _d(OK(a))
                    ])) : vE,
                    _d(OK(Umn(r)))
                ]))
            ]))
        ]));
    }), rpn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, tpn = function(n) {
        return "w-1/" + oe(n);
    }, epn = function(n) {
        switch(n.$){
            case 0:
                return w([
                    Gx(tpn(r = n.a))
                ]);
            case 1:
                var r = n.b;
                return w([
                    Gx($(Ux(n.a), tpn(r)))
                ]);
            default:
                return g;
        }
    }, upn = function(n) {
        switch(n.$){
            case 2:
                return w([
                    Gx("list--bordered")
                ]);
            case 3:
                return w([
                    Gx("list--bulleted")
                ]);
            case 4:
                return n_(n.a);
            default:
                return g;
        }
    }, apn = F2(function(n, r) {
        var t = r;
        return A2(Qq, A2(Qt, Gx("list__item"), n), t);
    }), ipn = F2(function(n, r) {
        var t = A2(bc, upn, n), e = A2(bc, epn, n);
        return A2(Kq, A2(Qt, Gx("list"), t), A2(Fu, apn(e), r));
    }), cpn = F2(function(n, r) {
        return nE(r) ? vE : A2(zx, g, w([
            A2(f_, w([
                nF,
                uE(aF),
                uF(rD)
            ]), w([
                _d(n(Yd)),
                _d(":")
            ])),
            A2(ipn, w([
                Rmn,
                rpn(eE)
            ]), A2(Fu, npn(n), r))
        ]));
    }), opn = F2(function(n, r) {
        var t = OK(r.zZ), e = n(iv) + " " + t, u = function() {
            var t = v(r.FT, r.FS);
            n: for(;;)if (t.b.$) switch(t.a){
                case "package":
                    return e + " " + n(Od);
                case "membership":
                    return e + " " + n(Id);
                default:
                    break n;
            }
            else switch(t.a){
                case "package":
                    var u = t.b.a;
                    return e + " " + n(Hd) + " " + u;
                case "membership":
                    return u = t.b.a, e + " " + n(Hd) + " " + u;
                default:
                    break n;
            }
            return e;
        }();
        return A2(BE, w([
            VN(w([
                Gx("mx-3")
            ]))
        ]), w([
            A2(lE, w([
                TE(12),
                cE(omn)
            ]), w([
                A2(Mx, w([
                    Gx("ribbon")
                ]), w([
                    _d(u)
                ]))
            ]))
        ]));
    }), fpn = function(n) {
        return n.a.pE;
    }, spn = function(n) {
        return v(A2(Qt, DN(w([
            Gx("column--offset")
        ])), n), g);
    }, lpn = function(n) {
        return n.a.ve;
    }, dpn = function(n) {
        return n.a.vl;
    }, vpn = function(n) {
        return n.a.yk;
    }, bpn = function(n) {
        return n.a.mw;
    }, mpn = function(n) {
        return n.a.ur;
    }, ppn = function(n) {
        return n.a.yq;
    }, $pn = function(n) {
        return n.$ ? "" : jF(function(n) {
            return n.a.wC;
        }(n.a)) + "%";
    }, gpn = function(n) {
        return n.a.mz;
    }, hpn = function(n) {
        return n.a.yP;
    }, ypn = F3(function(n, r, t) {
        return A2(BE, w([
            xN(Jq)
        ]), w([
            A2(lE, w([
                TE(8)
            ]), w([
                A2(f_, w([
                    nF
                ]), w([
                    _d(n)
                ]))
            ])),
            A2(lE, w([
                TE(4),
                cE(omn)
            ]), w(t ? [
                A2(xX, w([
                    qG
                ]), w([
                    _d(OK(r))
                ]))
            ] : [
                A2(f_, g, w([
                    _d(OK(r))
                ]))
            ]))
        ]));
    }), wpn = F3(function(n, r, t) {
        return r > 0 ? A3(ypn, n, r, t) : vE;
    }), xpn = F2(function(n, r) {
        return A2(BE, w([
            xN(Jq)
        ]), w([
            A2(lE, w([
                TE(6)
            ]), w([
                A2(f_, w([
                    nF
                ]), w([
                    _d(n)
                ]))
            ])),
            A2(lE, w([
                TE(6),
                cE(omn)
            ]), w([
                A2(xX, w([
                    Qx
                ]), w([
                    _d(OK(r))
                ]))
            ]))
        ]));
    }), _pn = F5(function(n, r, t, e, u) {
        var a, i, c = Fbn(Sbn(r)), o = e && Gbn(c) && jbn(r) > 0;
        return tmn(t) ? A2(BE, w([
            VN(w([
                Gx("mx-3")
            ]))
        ]), w([
            spn(w([
                TE(3),
                tO(7),
                cmn(6)
            ])),
            A2(lE, w([
                TE(9),
                tO(5),
                cmn(6)
            ]), w([
                bpn(r) > 0 ? A3(ypn, Db(n(nv)), vpn(r), !1) : vE,
                A3(wpn, Db(n(rv)) + " (" + Db((i = ppn(r), A2(xc, "", A2(Op, mpn, i)))) + " " + $pn(ppn(r)) + ")", bpn(r), !1),
                A3(wpn, Db(n(Qd)), gpn(r), !0),
                A3(wpn, Db(n(av)), hpn(r), !1),
                fpn(r) > 0 || lpn(r) > 0 ? s_ : vE,
                fpn(r) > 0 ? A3(ypn, Db(n(Sd)), -1 * fpn(r), !1) : vE,
                lpn(r) > 0 ? A3(ypn, Db(n(Kd)), -1 * lpn(r), !1) : vE,
                dpn(r) > 0 ? A3(ypn, Db(n(Ld)), -1 * dpn(r), !1) : vE,
                s_,
                o ? A3(wpn, Db(n(Td)), (a = u, 3 === a.$ ? M4(a.a) : 0), !1) : vE,
                A2(xpn, Db(n(Nd)), o ? umn(u) : jbn(r))
            ]))
        ])) : A2(BE, w([
            VN(w([
                Gx("mx-3")
            ]))
        ]), w([
            spn(w([
                TE(3),
                tO(7),
                cmn(8)
            ])),
            A2(lE, w([
                TE(9),
                tO(5),
                cmn(4),
                cE(omn)
            ]), w([
                bpn(r) > 0 ? A3(ypn, n(nv), vpn(r), !1) : vE,
                A3(wpn, $pn(ppn(r)) + " " + n(rv), bpn(r), !1),
                A3(wpn, n(ev) + ":", gpn(r), !0),
                A3(wpn, n(av), hpn(r), !1),
                A3(wpn, n(Sd), fpn(r), !1),
                A3(wpn, n(Kd), lpn(r), !1),
                s_,
                A3(ypn, n(Nd) + ":", jbn(r), !1)
            ]))
        ]));
    }), Cpn = F4(function(n, r, t, e) {
        var u, a, i, c = r.dV, o = r.os, f = r.fw;
        return A2(zx, w([
            Gx("text-left")
        ]), w([
            A2(BE, w([
                cE(gE),
                cE(yE),
                xN(JI)
            ]), w([
                A2(lE, w([
                    TE(6),
                    cmn(4),
                    cE(gE),
                    VN(w([
                        Gx("flex")
                    ]))
                ]), w([
                    A2(zN, w([
                        Hx(w([
                            Gx("text-primary-300 sm:text-xl")
                        ])),
                        uF(gE)
                    ]), w([
                        _d(Rbn(Qbn(t)))
                    ])),
                    A2(Mx, g, w([
                        A2(c_, Cu, A2(Cvn, n, Xbn(t)))
                    ]))
                ])),
                A2(lE, w([
                    TE(6),
                    cmn(8),
                    cE(omn)
                ]), w([
                    A5(Qmn, n, c, t, e, g)
                ]))
            ])),
            A2(BE, w([
                xN(AD),
                xN(L6),
                A2(rO, 2, aF)
            ]), w([
                A2(lE, w([
                    cmn(4)
                ]), w([
                    A2(xX, g, w([
                        _d(ax(c))
                    ])),
                    A2(pmn, c, t)
                ])),
                A2(lE, w([
                    VN(w([
                        Gx("hidden md:block")
                    ])),
                    cmn(4)
                ]), w([
                    A2(xX, g, w([
                        ZV(rmn(Sbn(t)))
                    ])),
                    A2(zx, g, dmn(t))
                ])),
                A2(lE, w([
                    cmn(4),
                    xN(Ybn),
                    A2(rO, 2, ZN)
                ]), w([
                    A2(BE, w([
                        xN(Jq),
                        xN(jvn),
                        A2(rO, 2, fmn)
                    ]), w([
                        A2(lE, w([
                            TE(6)
                        ]), w([
                            A2(f_, w([
                                nF
                            ]), w([
                                _d(n(Ud)),
                                _d(": ")
                            ]))
                        ])),
                        A2(lE, w([
                            TE(6)
                        ]), w([
                            A2(f_, w([
                                uF(omn)
                            ]), w([
                                _d(nmn(t))
                            ]))
                        ]))
                    ])),
                    A2(BE, w([
                        xN(Jq)
                    ]), w([
                        A2(lE, w([
                            TE(6)
                        ]), w([
                            A2(f_, w([
                                nF
                            ]), w([
                                _d(n(uv)),
                                _d(": ")
                            ]))
                        ])),
                        (u = Fbn(Sbn(t)), a = o && Gbn(u), i = v(tmn(c), a), A2(lE, w([
                            TE(6)
                        ]), w(i.a && i.b ? [
                            A2(f_, w([
                                uF(omn)
                            ]), w([
                                _d(OK(umn(f)))
                            ]))
                        ] : [
                            A2(f_, w([
                                uF(omn)
                            ]), w([
                                _d(OK(jbn(t)))
                            ]))
                        ])))
                    ]))
                ]))
            ])),
            A2(cpn, n, amn(t)),
            A2(Lmn, n, t),
            A2(kmn, n, t),
            A5(_pn, n, t, c, o, f),
            A2(zx, w([
                Gx("flex flex-col gap-2")
            ]), A2(Fu, opn(n), imn(t)))
        ]));
    }), Apn = F3(function(n, r, t) {
        var e = function() {
            var n = r.xU;
            return 3 === n.$ ? n.a : g;
        }();
        return w([
            A2(zx, w([
                Gx("panel")
            ]), w([
                A3(Wbn, n, r, t),
                A4(Cpn, n, r, t, e),
                A2(zx, w([
                    Gx("md:hidden")
                ]), w([
                    A5(Qmn, n, r.dV, t, e, w([
                        Obn
                    ]))
                ]))
            ]))
        ]);
    }), kpn = function(n) {
        return A2(EV, w([
            yV("mailto:" + n),
            Sen
        ]), w([
            _d(n)
        ]));
    }, Epn = function(n) {
        return A2(EV, w([
            yV("tel:" + n),
            Sen
        ]), w([
            _d(n)
        ]));
    }, qpn = function(n) {
        var r = v(bV(n), Xw(n));
        if (r.a.$) return r.b.$ ? g : (e = r.b.a, w([
            _d(" at "),
            kpn(e)
        ]));
        if (r.b.$) return t = r.a.a, w([
            _d(" at "),
            Epn(t)
        ]);
        var t = r.a.a, e = r.b.a;
        return w([
            _d(" at "),
            Epn(t),
            _d(" or "),
            kpn(e)
        ]);
    }, Fpn = function(n) {
        return A2(zx, w([
            Gx("panel")
        ]), w([
            A2(i_, w([
                uE(eE)
            ]), w([
                _d("There was an error loading your bill")
            ])),
            A2(f_, w([
                nF
            ]), vc(w([
                w([
                    _d("Please contact " + ax(n))
                ]),
                qpn(n),
                w([
                    _d("to request an updated bill.")
                ])
            ])))
        ]));
    }, jpn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, g, function() {
                    var t = v(r.dy, r.vn);
                    n: for(;;)switch(t.a.$){
                        case 3:
                            if (3 === t.b.$) return A3(Apn, n, r, t.a.a);
                            break n;
                        case 2:
                            return w([
                                A2(c_, Cu, Fpn(r.dV))
                            ]);
                        default:
                            break n;
                    }
                    return Nx;
                }())
            ]),
            yx: ax(r.dV)
        };
    }), Dpn = C_({
        Cl: qbn,
        CQ: Tbn,
        Fj: Pbn,
        F4: function() {
            return bx;
        },
        Gv: Ibn,
        GB: jpn
    }), Vpn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Bpn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Gpn = function(n) {
        var r = n.vu;
        return 3 === r.$ && function(n) {
            return n.nE;
        }(r.a);
    }, zpn = function(n) {
        return jF(n / 100);
    }, Spn = F2(function(n, r) {
        var t;
        return {
            kJ: (t = n, A2(Op, zpn, t)),
            fs: !1,
            wi: !1,
            xS: r
        };
    }), Tpn = function(n) {
        return n.a.mt;
    }, Ppn = function(n) {
        return n.bH.Ai;
    }, Zpn = function(n) {
        return n.bH.AL;
    }, Mpn = function(n) {
        return n.bH.BG;
    }, Lpn = function(n) {
        return n.bH.BL;
    }, Npn = function(n) {
        return n.bH.Cr;
    }, Hpn = function(n) {
        return n.bH.Dh;
    }, Ipn = function(n) {
        return n.bH.wk;
    }, Opn = function(n) {
        return n.bH.GD;
    }, Qpn = F2(function(n, r) {
        return function(r) {
            var t = r.b;
            return A2(Zq, w([
                r.a
            ]), w([
                _d(n(t))
            ]));
        }(function() {
            switch(r){
                case 1:
                    return v(2, Npn);
                case 6:
                    return v(2, Lpn);
                case 5:
                    return v(3, Opn);
                case 4:
                    return v(3, Mpn);
                case 0:
                    return v(1, Ipn);
                case 2:
                    return v(1, Hpn);
                case 3:
                    return v(0, Zpn);
                default:
                    return v(2, Ppn);
            }
        }());
    }), Rpn = F2(function(n, r) {
        if (r.$) return A2(Mx, w([
            Gx("inline-block my-1")
        ]), w([
            _d(n(Av))
        ]));
        var t = r.a;
        return A2(Mx, g, w([
            A2(Mx, g, w([
                _d(A2(T0, n, t))
            ])),
            A2(Qpn, n, Tpn(t))
        ]));
    }), Upn = function(n) {
        return n.$ ? Ot : It(D0(n.a));
    }, Kpn = F3(function(n, r, t) {
        var e, u = vZ(A2(Spn, Ot, Ot)), a = v((e = A6(N2, !1, r.ld, n, r.os, Ot, r.g0)).a, A2(Wp, Bpn, e.b)), i = a.b;
        return v({
            g0: r.g0,
            dr: g,
            os: r.os,
            dy: kc,
            ld: r.ld,
            sl: t.Ep.sl,
            bG: kc,
            aq: a.a,
            fw: kc,
            vn: r.vu,
            iV: Gpn(r),
            vz: kc,
            w: u,
            lV: uQ({
                sl: "payment-source-select",
                Gj: Rpn,
                Gk: Upn
            }),
            dV: n,
            yj: 0,
            yZ: t
        }, Uu(w([
            A4(Ebn, r.g0, ux(n), t.Ep.sl, Vpn),
            i
        ])));
    }), Wpn = F2(function(n, r) {
        return v(m(r, {
            os: n.os,
            iV: Gpn(n)
        }), Qp);
    }), Xpn = F2(function(n, r) {
        return m(r, {
            zK: It(0)
        });
    }), Ypn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Jpn = {
        $: 1
    }, n$n = {
        $: 5
    }, r$n = function(n) {
        var r = n;
        return A2(Op, Sp, A2(Op, Oe(100), VZ(r)));
    }, t$n = function(n) {
        return A2(xc, 0, r$n(A2(xc, "0", n.kJ)));
    }, e$n = function(n) {
        return {
            $: 8,
            a: n
        };
    }, u$n = function(n) {
        return !n.$ && !n.a.$ && k2(n.a.a);
    }, a$n = F3(function(n, r, t) {
        var e, u = v(n.os, u$n(t));
        if (u.a && u.b) {
            var a = (e = t).$ || e.a.$ ? Ot : It(D0(e.a.a));
            if (a.$) return Qp;
            var i = a.a;
            return A5(Bbn, n.g0, ux(n.dV), i, r, e$n);
        }
        return Qp;
    }), i$n = F2(function(n, r) {
        var t = r$n(r);
        if (t.$) return !1;
        var e = t.a, u = v(n.ug, n.tt);
        if (u.a.$) return !!u.b.$ || 1 > s(e, a = u.b.a);
        if (u.b.$) return s(e, u.a.a) > -1;
        var a = u.b.a;
        return !(0 > s(e, u.a.a) || s(e, a) > 0);
    }), c$n = F2(function(n, r) {
        return r.$ ? !n.zW : !A2(i$n, {
            tt: n.tt,
            ug: n.ug
        }, r.a);
    }), o$n = XM(w([
        function(n) {
            var r = n.kJ;
            return A2(c$n, {
                zW: !0,
                tt: Ot,
                ug: It(50)
            }, r) ? w([
                v(0, fL(A2(YM, uL, Emn)))
            ]) : g;
        }
    ])), f$n = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (t.$) return m(r, {
                    kJ: t
                });
                var e = t.a, u = A2(i$n, {
                    tt: Ot,
                    ug: It(0)
                }, e), a = v(r$n(e), u);
                n: for(; !a.a.$;){
                    if (a.a.a) {
                        if (a.b) return m(r, {
                            kJ: It(e)
                        });
                        break n;
                    }
                    return m(r, {
                        kJ: It(e)
                    });
                }
                return r;
            case 1:
                return m(r, {
                    xS: n.a
                });
            case 2:
                var i = n.a;
                return m(r, {
                    fs: i,
                    wi: !i && r.wi
                });
            default:
                return m(r, {
                    wi: n.a
                });
        }
    }), s$n = function(n) {
        return n.vI.vA;
    }, l$n = F2(function(n, r) {
        switch(r.$){
            case 2:
                return b(m(n, {
                    bG: kc,
                    aq: n.aq,
                    vz: kc
                }), Qp, g);
            case 3:
                var t = r.a, e = A2(Op, Ypn, It(t)), u = $(n.dr, w([
                    t
                ])), a = t$n(FM(n.w)), i = A3(a$n, n, a, e), c = vZ(A2(Spn, It(a), e));
                return b(m(n, {
                    dr: u,
                    bG: r,
                    vz: kc,
                    w: c
                }), i, g);
            default:
                return b(m(n, {
                    bG: r
                }), Qp, A2(Ik, 0, r));
        }
    }), d$n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, v$n = A2(zB, 0, A2($A, wbn, au(sbn))), b$n = function(n) {
        return n.a.FT;
    }, m$n = F7(function(n, r, t, e, u, a, i) {
        var c = rx(w([
            v("payment", rx(w([
                v("amount_in_cents", NQ(e)),
                v("source", rx(w([
                    v("id", tx(D0(u))),
                    v("type", tx(b$n(u)))
                ])))
            ]))),
            v("process_outstanding", Yw(a))
        ]));
        return A4(lM, n, v$n, i, A2(dM, c, pk(A2(bk, w([
            "payments"
        ]), A2(kbn, r, t)))));
    }), p$n = F4(function(n, r, t, e) {
        var u = e.xS, a = e.wi, i = A2(xc, 0, r$n(A2(xc, "0", e.kJ)));
        return u.$ ? Qp : u.a.$ ? A2(Wp, Bpn, V2) : A7(m$n, n, r, t, i, u.a.a, a, d$n);
    }), $$n = function(n) {
        return {
            $: 7,
            a: n
        };
    }, g$n = F2(function(n, r) {
        var t = A2(X3, r, n.aq), e = t.b, u = t.c, a = m(n, {
            aq: t.a
        }), i = w([
            A2(Wp, Bpn, e)
        ]);
        n: for(; !u.$;)switch(u.a.$){
            case 1:
                var c = u.a.a, o = FM(n.w), f = o.fs, s = o.wi, l = f ? "Payment Method Added" : "Default Payment Method Changed", d = f ? "True" : "False";
                return b(m(a, {
                    bG: A_
                }), Uu(A2(Qt, A4(u2, n.g0, c, {
                    dT: f,
                    wi: s,
                    wW: Ot,
                    xq: !f
                }, $$n), $(i, w([
                    A2(Jfn, l, w([
                        A2(rsn, "One-Time Payment Method", d)
                    ]))
                ])))), g);
            case 0:
                var v = u.a.a;
                return b(m(a, {
                    bG: kc,
                    vz: kc
                }), Uu(i), w([
                    Lk(v)
                ]));
            default:
                break n;
        }
        return b(a, Uu(i), g);
    }), h$n = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = jbn(e), a = Fbn(Sbn(e)), c = A2(Op, Ypn, a), o = A3(a$n, r, u, c), f = vZ(A2(Spn, It(u), c)), s = function(n) {
                        return A2(no, function(n) {
                            return !A2(xc, !1, function(n) {
                                return n.a.dT;
                            }(n));
                        }, function(n) {
                            return n.xU;
                        }(Sbn(n)));
                    }(e);
                    return b(m(r, {
                        dr: s,
                        dy: t,
                        w: f,
                        yj: u
                    }), o, g);
                }
                return b(m(r, {
                    dy: t
                }), Qp, A2(Ik, 0, t));
            case 2:
                return b(m(r, {
                    w: A3(cN, f$n, n.a, r.w)
                }), Qp, g);
            case 4:
                var l = A2(dG, n.a, r.lV), d = l.a, p = l.c, h = function() {
                    if (p.$ || p.a.$) return v(r.w, Qp);
                    var n = p.a.a, t = Nmn(r.dV) && !i(n, It(Jpn)) ? Qp : A2(Nu, cu, Au(n$n)), e = t$n(FM(r.w)), u = A3(a$n, r, e, n);
                    return v(A3(cN, f$n, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n), r.w), Uu(w([
                        t,
                        u
                    ])));
                }(), y = h.b;
                return b(m(r, {
                    w: h.a,
                    lV: d
                }), y, g);
            case 5:
                var x = A6(N2, !1, r.ld, r.dV, r.os, Ot, r.g0), _ = x.b;
                return b(m(r, {
                    aq: x.a
                }), A2(Wp, Bpn, _), g);
            case 6:
                return A2(g$n, r, n.a);
            case 7:
                return A2(l$n, r, n.a);
            case 1:
                var C = A2(CL, o$n, r.w);
                if (C.$) return b(m(r, {
                    w: C.a
                }), Qp, g);
                var A = C.a, k = A.b;
                return b(m(r, {
                    vz: A_,
                    w: A.a
                }), A4(p$n, r.g0, ux(r.dV), r.sl, k), g);
            case 3:
                var E = n.a, q = function() {
                    var n, t = v(r.dy, E);
                    if (3 === t.a.$ && 3 === t.b.$) {
                        var e = t.a.a, u = t.b.a;
                        return v(Uu(w([
                            A2(Jfn, "Invoice Paid", g),
                            A2(__, pa, Sa({
                                sl: Omn(e)
                            }))
                        ])), (n = function(n) {
                            return n.a.mt;
                        }(u), "failed" === n ? w([
                            A2(Mk, 1, s$n)
                        ]) : g));
                    }
                    return v(Qp, g);
                }(), F = q.a, j = q.b;
                return b(m(r, {
                    vz: E
                }), F, $(j, A2(Ik, 0, E)));
            case 8:
                return b(m(r, {
                    fw: n.a
                }), Qp, g);
            default:
                var D = t$n(FM(r.w)), V = (o = A3(a$n, r, D, FM(r.w).xS), A2(CL, o$n, r.w));
                return b(m(r, V.$ ? {
                    w: V.a,
                    yj: D
                } : {
                    w: V.a.a,
                    yj: D
                }), o, g);
        }
    }), y$n = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), w$n = y$n, x$n = function(n) {
        return n.e6.vz;
    }, _$n = function(n) {
        return n.e6.xS;
    }, C$n = function(n) {
        return n.e6.kg;
    }, A$n = function(n) {
        return n.e6.yx;
    }, k$n = function(n) {
        return x_(Sa({
            sl: Omn(n)
        }));
    }, E$n = function(n) {
        return A2(EV, w([
            yV(x_(za))
        ]), w([
            _d(n(tv))
        ]));
    }, q$n = F3(function(n, r, t) {
        return vsn(r) ? vE : A2(BE, w([
            cE(gE),
            xN(JI)
        ]), w([
            A2(lE, w([
                cmn(8),
                A2(w$n, 2, rD)
            ]), w([
                E$n(n),
                _d(" / "),
                A2(EV, w([
                    yV(k$n(t))
                ]), w([
                    _d(A2(SM, sZ("/"), Qbn(t)))
                ])),
                _d(" / "),
                _d(n(A$n)),
                s_
            ]))
        ]));
    }), F$n = {
        $: 1
    }, j$n = function(n) {
        switch(n.$){
            case 0:
                return "Unauthorized";
            case 1:
                return "BadUrl";
            case 2:
                return "Timeout";
            case 3:
                return "Network";
            case 4:
                return "Server Error";
            case 7:
                return A2(xc, "Internal Server Error", n.a);
            case 5:
                return n.b;
            case 8:
                return "Forbidden";
            case 9:
                return "Not Found";
            default:
                return "Decoder error! " + n.a;
        }
    }, D$n = F2(function(n, r) {
        return r.xk(n);
    }), V$n = F2(function(n, r) {
        return r.xl(n);
    }), B$n = F3(function(n, r, t) {
        return A2(f_, w([
            VG,
            nF
        ]), w([
            _d(r(n ? V$n(t) : D$n(t)))
        ]));
    }), G$n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, z$n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, S$n = F3(function(n, r, t) {
        return A2(BE, w([
            xN(ZN)
        ]), w([
            A2(lE, g, w([
                A2(fI, w([
                    eI(r),
                    tI(A2(qc, z$n, G$n)),
                    rI(t)
                ]), w([
                    _d(n(Fv))
                ]))
            ]))
        ]));
    }), T$n = function(n) {
        return A2(BE, w([
            xN(ZN),
            xN(JI)
        ]), w([
            A2(lE, w([
                xN(JI)
            ]), A2(Fu, c_(Bpn), D4(n)))
        ]));
    }, P$n = function(n) {
        var r = v(g, w([
            T$n(n)
        ]));
        return A2(EH, r.a, r.b);
    }, Z$n = F2(function(n, r) {
        return r.uQ(n);
    }), M$n = {
        $: 9
    }, L$n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, N$n = function(n) {
        return {
            $: 9,
            a: n
        };
    }, H$n = function(n) {
        return A2(Mx, w([
            Gx("input-addon")
        ]), n);
    }, I$n = function(n) {
        return A2(zx, w([
            Gx("input-group")
        ]), n);
    }, O$n = {
        eZ: g,
        ac: g,
        Cr: !1,
        i6: Ot,
        i8: !0,
        y4: Ot
    }, Q$n = cu, R$n = function(n) {
        return VD(n) ? Ot : It(n);
    }, U$n = function(n) {
        return A2(tu, R$n, A2(tu, Op(Q$n), n));
    }, K$n = function(n) {
        return n;
    }, W$n = F2(function(n, r) {
        var t, e, u, a, i, c, o = FM(r);
        return w([
            (a = w([
                (u = o.kJ, function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(u)),
                (e = A2(qc, z$n, L$n), function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(e)),
                (t = A2(wH, 0, r), function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(t)),
                N$n(M$n)
            ]), i = function(n) {
                return A3(de, F2(function(n, r) {
                    switch(n.$){
                        case 0:
                            return m(r, {
                                ac: A2(Qt, HI(U$n(n.a)), r.ac)
                            });
                        case 9:
                            return m(r, {
                                ac: A2(Qt, _I(n.a), r.ac)
                            });
                        case 1:
                            var t = n.a;
                            return m(r, {
                                ac: A2(Qt, OI((e = t, A2(xc, "", A2(Op, K$n, e)))), r.ac),
                                y4: t
                            });
                        case 2:
                            return m(r, {
                                Cr: n.a
                            });
                        case 3:
                            return m(r, {
                                eZ: n.a
                            });
                        case 4:
                            return m(r, {
                                ac: A2(Qt, jI(n.a), r.ac)
                            });
                        case 5:
                            return m(r, {
                                ac: A2(Qt, pI(n.a), r.ac)
                            });
                        case 6:
                            return m(r, {
                                i6: It(n.a)
                            });
                        case 7:
                            return m(r, {
                                i8: !1
                            });
                        default:
                            return m(r, {
                                ac: A2(Qt, xO(n.a), r.ac)
                            });
                    }
                    var e;
                }), O$n, n);
            }(a), c = i.i8 ? H$n(w([
                _d("$")
            ])) : vE, I$n(A2(Qt, c, A2(Qt, PI(A2(Qt, yI(i.Cr), i.ac)), function() {
                var n = i.i6;
                return n.$ ? g : w([
                    H$n(w([
                        _d(n.a)
                    ]))
                ]);
            }())))),
            A2(YH, n, A2(iH, 0, r))
        ]);
    }), X$n = F5(function(n, r, t, e, u) {
        var a, i = !((a = v(t, u)).a.$ || !a.b) && M4(a.a.a) > 0;
        return A2(EH, w([
            vH(n(x$n)),
            gH(!0)
        ]), vc(w([
            $mn(r).$ ? A2(W$n, n, e) : function(n) {
                return w([
                    A2(f_, w([
                        nF
                    ]), w([
                        _d(OK(jbn(n)))
                    ]))
                ]);
            }(r),
            w([
                A2(f_, w([
                    nF,
                    uE(jvn)
                ]), w([
                    _d(n(Z$n(OK(jbn(r))))),
                    _d(" "),
                    i ? _d("(+ " + sJ(n(Md)) + " )") : vE
                ]))
            ])
        ])));
    }), Y$n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, J$n = F5(function(n, r, t, e, u) {
        var a = A2(Fu, function(n) {
            return A2(MG, g, Ypn(n));
        }, t), i = Nmn(r) || Hmn(r) ? nE(a) ? w([
            A2(MG, g, Jpn)
        ]) : A2(Qt, A2(MG, g, Jpn), A2(Qt, PG, a)) : a;
        return A2(EH, w([
            vH(n(_$n))
        ]), w([
            A2(c_, Y$n, A4(qz, n, w([
                XG(e),
                HG(n(z4)),
                SG
            ]), i, u))
        ]));
    }), ngn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, rgn = F5(function(n, r, t, e, u) {
        return u && r ? A2(BE, w([
            xN(ZN)
        ]), w([
            A2(lE, g, w([
                A2(fI, w([
                    eI(t),
                    tI(A2(qc, z$n, ngn)),
                    rI(e)
                ]), w([
                    _d(n(Sv))
                ]))
            ]))
        ])) : vE;
    }), tgn = {
        $: 10
    }, egn = function(n) {
        return n.d4.AH;
    }, ugn = function(n) {
        return n.d4.BY;
    }, agn = function(n) {
        return n.d4.Ek;
    }, ign = function(n) {
        return n.d4.EE;
    }, cgn = function(n) {
        return n.d4.F7;
    }, ogn = function(n) {
        return A2(BE, w([
            VN(w([
                Gx("px-1")
            ])),
            xN(jvn)
        ]), w([
            A2(lE, w([
                cmn(9),
                tO(8)
            ]), w([
                A2(f_, w([
                    VG,
                    nF
                ]), w([
                    _d(n(agn)),
                    _d(" "),
                    A2(EV, w([
                        yV("http://www.hint.com"),
                        xV,
                        tgn,
                        Sen
                    ]), w([
                        _d(n(ign))
                    ])),
                    _d(" "),
                    _d(n(cgn)),
                    _d(" "),
                    A2(EV, w([
                        yV("http://www.hint.com/security"),
                        xV,
                        tgn,
                        Sen
                    ]), w([
                        _d(n(egn))
                    ])),
                    _d(" "),
                    _d(n(ugn))
                ]))
            ])),
            A2(lE, w([
                cmn(3),
                tO(4),
                A2(w$n, 1, omn),
                xN(jvn),
                A2(rO, 1, fmn)
            ]), w([
                A2(uJ, w([
                    Gx("inline"),
                    iJ("https://cdn2.hubspot.net/hubfs/2562809/production-app/pci_dss_compliant.png")
                ]), g),
                A2(uJ, w([
                    Gx("inline ml-6"),
                    iJ("https://cdn2.hubspot.net/hubfs/2562809/production-app/hipaa_compliant.png")
                ]), g)
            ]))
        ]));
    }, fgn = F3(function(n, r, t) {
        return A2(BE, w([
            xN(Jq)
        ]), w([
            A2(lE, w([
                TE(6)
            ]), w([
                A2(f_, w([
                    nF
                ]), w([
                    _d(n)
                ]))
            ])),
            A2(lE, w([
                TE(6),
                cE(omn)
            ]), w(t ? [
                A2(xX, w([
                    qG
                ]), w([
                    _d(OK(r))
                ]))
            ] : [
                A2(f_, g, w([
                    _d(OK(r))
                ]))
            ]))
        ]));
    }), sgn = F3(function(n, r, t) {
        return A2(zx, g, w([
            A2(BE, g, w([
                A2(lE, w([
                    TE(12),
                    cE(xD)
                ]), w([
                    A2(AH, w([
                        uE(Jq),
                        zX,
                        Qx
                    ]), w([
                        _d(n(Xd))
                    ]))
                ]))
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    TE(12),
                    cE(rD)
                ]), w([
                    A3(fgn, Db(n(nv)), t, !1),
                    M4(r) > 0 ? A3(fgn, Db(n(Td)), M4(r), !1) : vE,
                    s_,
                    A3(fgn, Db(n(ev)), emn(r), !0)
                ]))
            ]))
        ]));
    }), lgn = F4(function(n, r, t, e) {
        var u, a, c = e.dV, o = e.w, f = e.vz, s = e.lV, l = e.aq, d = e.bG, b = e.iV, m = e.yj, p = e.dr, $ = e.os && u$n(FM(o).xS), h = !(a = FM(o).xS).$ && 1 === a.a.$, y = FM(o), x = y.xS, _ = y.fs, C = y.wi, A = n(x.$ || 1 !== x.a.$ ? C$n : Av);
        return w([
            A2(BE, g, w([
                A2(lE, w([
                    TE(12),
                    cE(rD)
                ]), w([
                    A2(i_, w([
                        uE(Jq)
                    ]), w([
                        _d(n(A$n))
                    ]))
                ]))
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    TE(12),
                    cE(rD)
                ]), w([
                    A5(J$n, n, c, p, x, s)
                ]))
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    TE(12),
                    cE(rD)
                ]), w([
                    A5(X$n, n, r, t, o, $)
                ]))
            ])),
            (u = v($, t), u.a && !u.b.$ ? A3(sgn, n, u.b.a, m) : A2(BE, g, g)),
            x.$ || 1 !== x.a.$ ? vE : A2(BE, g, w([
                A2(lE, w([
                    TE(12),
                    cE(rD)
                ]), w([
                    A3(S$n, n, _, Oj(d)),
                    A5(rgn, n, b, C, Oj(d), !_),
                    P$n(l),
                    s_,
                    A3(B$n, !1, n, ax(c))
                ]))
            ])),
            ogn(n),
            s_,
            A2(BE, g, w([
                A2(lE, w([
                    TE(12),
                    cE(rD)
                ]), w([
                    A2(EV, w([
                        _N,
                        yV(k$n(r))
                    ]), w([
                        _d(n(V4))
                    ])),
                    A2(yF, w([
                        fF,
                        Lj(i(f, A_) || !m),
                        Qj(i(f, A_)),
                        cF(F$n),
                        Lj(h && !c4(l))
                    ]), w([
                        _d(A)
                    ]))
                ]))
            ])),
            function() {
                if (2 === f.$) {
                    var n = f.a;
                    return A2(Mx, w([
                        A2(VF, "color", "red")
                    ]), w([
                        _d(j$n(n))
                    ]));
                }
                return vE;
            }()
        ]);
    }), dgn = F4(function(n, r, t, e) {
        return A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), A4(lgn, n, r, t, e))
        ]));
    }), vgn = F4(function(n, r, t, e) {
        return w([
            A2(zx, w([
                Gx("panel")
            ]), w([
                A3(q$n, n, r.g0, t),
                A4(dgn, Vx(r.ld), t, e, r)
            ]))
        ]);
    }), bgn = F2(function(n, r) {
        return {
            g8: function() {
                var t = r.dy;
                switch(t.$){
                    case 3:
                        var e = t.a, u = r.fw;
                        switch(u.$){
                            case 3:
                                return A4(vgn, n, r, e, It(u.a));
                            case 2:
                                return w([
                                    A2(c_, Cu, Fpn(r.dV))
                                ]);
                            default:
                                return A4(vgn, n, r, e, Ot);
                        }
                    case 2:
                        return w([
                            A2(c_, Cu, Fpn(r.dV))
                        ]);
                    default:
                        return Nx;
                }
            }(),
            yx: "Account.Invoices.Payments.Create"
        };
    }), mgn = C_({
        Cl: Kpn,
        CQ: Wpn,
        Fj: Xpn,
        F4: function() {
            return vx(w([
                A2(kj, Bpn, S1),
                bx
            ]));
        },
        Gv: h$n,
        GB: bgn
    }), pgn = {
        $: 0
    }, $gn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ggn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hgn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ygn = F8(function(n, r, t, e, u, a, i, c) {
        return {
            pi: a,
            q1: u,
            q9: r,
            sl: n,
            uv: i,
            vN: t,
            vW: e,
            xZ: c
        };
    }), wgn = function(n) {
        switch(n){
            case "active":
                return au(2);
            case "inactive":
                return au(3);
            case "unconfirmed":
                return au(0);
            case "pending":
                return au(1);
            default:
                return AA("Unsupported membership enrollment status: " + n);
        }
    }, xgn = function(n) {
        var r = o0(n);
        return r.$ ? AA("Unsupported period code: " + oe(n)) : au(r.a);
    }, _gn = F2(function(n, r) {
        return {
            zZ: n,
            pS: r
        };
    }), Cgn = A3(nk, "date", KA, A3(nk, "amount_in_cents", O$, au(_gn))), Agn = A2($A, Cgn, au(cu)), kgn = A3(nk, "sponsored", ru, A3(nk, "next_future_unpaid_bill", Agn, A3(nk, "contract_auto_renew", ru, A3(nk, "ending_contract_end_date", uC(XZ), A3(nk, "plan_name", M$, A3(nk, "period_in_months", A2(nu, xgn, O$), A3(nk, "enrollment_status", A2(nu, wgn, M$), A3(nk, "id", M$, au(ygn))))))))), Egn = A2(zB, 0, A2($A, kgn, au(hgn))), qgn = F3(function(n, r, t) {
        return A4(aA, n, ek(Egn), t, pk(function(n) {
            return A2(bk, w([
                "memberships"
            ]), fM(n));
        }(r)));
    }), Fgn = F3(function(n, r) {
        return v({
            g0: r.g0,
            ld: r.ld,
            aG: pgn,
            ad: g,
            lU: kc,
            dV: n
        }, Uu(w([
            A3(BQ, r.g0, ux(n), ggn),
            A3(qgn, r.g0, ux(n), $gn)
        ])));
    }), jgn = F2(function(n, r) {
        return v(r, Qp);
    }), Dgn = F2(function(n, r) {
        return m(r, {
            zK: It(1)
        });
    }), Vgn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Bgn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ggn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), zgn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Sgn = {
        $: 3
    }, Tgn = function(n) {
        return n.a.q9;
    }, Pgn = F2(function(n, r) {
        return A2(no, function(r) {
            return A2(Xk, Tgn(r), n);
        }, r);
    }), Zgn = function(n) {
        return n.a.sl;
    }, Mgn = function(n) {
        return A2(__, pa, Ia({
            sl: Zgn(n)
        }));
    }, Lgn = function(n) {
        return n.a.vW;
    }, Ngn = F2(function(n, r) {
        return $(Lgn(r), 1 === Tgn(r) ? " (Pending)" : "");
    }), Hgn = function(n) {
        return n.a.xZ;
    }, Ign = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? b(m(r, {
                    lU: t
                }), Qp, g) : b(m(r, {
                    lU: kc
                }), Qp, A2(Ik, 0, t));
            case 1:
                var e = n.a;
                if (3 === e.$) {
                    var u = e.a;
                    return b(m(r, {
                        ad: A2(no, function(n) {
                            return !Hgn(n);
                        }, A2(Pgn, w([
                            2,
                            1
                        ]), u))
                    }), Qp, g);
                }
                return b(r, Qp, A2(Ik, 0, e));
            case 2:
                var a = mb(r.ad);
                if (a.$) return b(r, Qp, g);
                var i = a.a, c = function() {
                    if (1 === ve(r.ad)) return v(r, Mgn(i));
                    var n = Cd({
                        sl: "membership-select",
                        Gj: Ngn,
                        Gk: function(n) {
                            return It(Lgn(n));
                        }
                    }), t = A2(YF, 0, Sgn), e = t.b, u = A3(Ggn, t.a, n, It(i));
                    return v(m(r, {
                        aG: u
                    }), e);
                }();
                return b(c.a, c.b, g);
            case 3:
                return b(m(r, {
                    aG: pgn
                }), Qp, g);
            case 4:
                var o = r.aG;
                if (1 === o.$) {
                    var f = o.b, s = o.c, l = A2(Sj, n.a, $ = o.a), d = l.b;
                    return b(m(r, {
                        aG: A3(Ggn, l.a, f, s)
                    }), A2(Wp, Bgn, d), g);
                }
                return b(r, Qp, g);
            case 5:
                return b(1 === n.a ? m(r, {
                    aG: pgn
                }) : r, Qp, g);
            case 6:
                var p = r.aG;
                if (p.$) {
                    var $ = p.a, h = (s = p.c, A2(dG, n.a, f = p.b)), y = h.a, x = h.b;
                    return b(A2(xc, r, A2(Op, function(n) {
                        return m(r, n.$ ? {
                            aG: A3(Ggn, $, y, s)
                        } : {
                            aG: A3(Ggn, $, y, n.a)
                        });
                    }, h.c)), A2(Wp, zgn, x), g);
                }
                return b(r, Qp, g);
            default:
                return b(r, Mgn(s = n.a), g);
        }
    }), Ogn = {
        $: 2
    }, Qgn = F3(function(n, r, t) {
        return !nE(t) && function(n) {
            return A2(Yk, "self_serve_add_member", n);
        }(r) ? A2(zx, w([
            Gx("mt-8")
        ]), w([
            A2(yF, w([
                CD,
                cF(Ogn)
            ]), w([
                _d(n(ov.mY))
            ]))
        ])) : vE;
    }), Rgn = function(n) {
        return n.a.ng;
    }, Ugn = F2(function(n, r) {
        return r.tB(n);
    }), Kgn = function(n) {
        return n.tF;
    }, Wgn = F2(function(n, r) {
        return A2(EV, w([
            yV(x_(Za({
                sl: r
            })))
        ]), w([
            _d(n(ov.ts))
        ]));
    }), Xgn = F2(function(n, r) {
        var t = JX(r) ? It(n(Kgn)) : Ot, e = A2(Op, A2(tu, oe, A2(tu, Ugn, n)), Rgn(r)), u = A2(fe, ", ", A2(n$, cu, w([
            t,
            e
        ])));
        return A2(BE, w([
            _E,
            TE(12)
        ]), w([
            A2(lE, w([
                VN(w([
                    Gx("flex justify-between items-center")
                ]))
            ]), w([
                A2(zx, w([
                    Gx("grid text-left ml-2")
                ]), w([
                    A2(xX, w([
                        Hx(w([
                            Gx("mb-1")
                        ]))
                    ]), w([
                        ZV(aQ(r))
                    ])),
                    A2(f_, w([
                        nF
                    ]), w([
                        _d(u)
                    ]))
                ])),
                A2(zx, g, w([
                    A2(Wgn, n, eQ(r))
                ]))
            ]))
        ]));
    }), Ygn = F2(function(n, r) {
        return A2(Fu, Xgn(n), r);
    }), Jgn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, nhn = function(n) {
        return n.o3;
    }, rhn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, thn = F4(function(n, r, t, e) {
        return A2(zx, g, w([
            A2(f_, w([
                nF,
                uE(eE)
            ]), w([
                _d("You\u2019re about to add a new member to one of your membership plans. Please, select the membership plan\n                that you want to update.")
            ])),
            A2(zx, w([
                Gx("mb-12")
            ]), w([
                A2(EH, w([
                    vH("Membership"),
                    gH(!0)
                ]), w([
                    A2(c_, zgn, A4(qz, n, w([
                        XG(e),
                        HG("Select membership")
                    ]), A2(Fu, function(n) {
                        return A2(MG, g, n);
                    }, r), t))
                ]))
            ])),
            s_,
            A2(zx, w([
                Gx("mt-4"),
                A2(VF, "text-align", "right")
            ]), w([
                A2(yF, w([
                    CD,
                    rhn(!0),
                    cF(Sgn)
                ]), w([
                    _d(n(V4))
                ])),
                function() {
                    if (e.$) return vE;
                    var r = e.a;
                    return A2(yF, w([
                        fF,
                        rhn(!0),
                        cF(Jgn(r))
                    ]), w([
                        _d(n(nhn))
                    ]));
                }()
            ]))
        ]));
    }), ehn = A2(f_, g, w([
        _d("Select Membership Plan")
    ])), uhn = F3(function(n, r, t) {
        if (1 === t.$) {
            var e = t.a, u = t.b, a = t.c, i = w([
                Hj(w([
                    ehn
                ])),
                Mj(w([
                    A4(thn, n, r, u, a)
                ]))
            ]);
            return A2(dD, i, zj(e));
        }
        return vE;
    }), ahn = F5(function(n, r, t, e, u) {
        return A2(Qt, A3(uhn, n, e, u), $(A2(Ygn, n, r), w([
            A3(Qgn, n, t, e)
        ])));
    }), ihn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t = r.lU;
                    switch(t.$){
                        case 3:
                            var e = t.a;
                            return nE(e) ? rF(n(ov.GO)) : A5(ahn, n, e, r.dV, r.ad, r.aG);
                        case 2:
                            return aE(n(ov.cb));
                        default:
                            return Nx;
                    }
                }())
            ]),
            yx: n(ov.yx)
        };
    }), chn = C_({
        Cl: Fgn,
        CQ: jgn,
        Fj: Dgn,
        F4: function(n) {
            return n.aG.$ ? vx(w([
                Cj(M1(Vgn)),
                A2(kj, Bgn, qj())
            ])) : bx;
        },
        Gv: Ign,
        GB: ihn
    }), ohn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fhn = A2(nu, function(n) {
        switch(n){
            case "en":
                return au(0);
            case "es":
                return au(1);
            default:
                return AA("Invalid language");
        }
    }, M$), shn = function(n) {
        if (n.$) return au(Ot);
        var r = n.a;
        switch(r){
            case "female":
                return au(It(0));
            case "male":
                return au(It(1));
            case "other":
                return au(It(2));
            case "":
                return au(Ot);
            default:
                return AA("Unsupported Gender: " + r);
        }
    }, lhn = function(n) {
        if (n.$) return au(Ot);
        var r = n.a;
        switch(r){
            case "man":
                return au(It(0));
            case "woman":
                return au(It(1));
            case "non-binary":
                return au(It(2));
            case "trans man":
                return au(It(3));
            case "trans woman":
                return au(It(4));
            case "not listed":
                return au(It(5));
            case "":
                return au(Ot);
            default:
                return AA("Unsupported Gender identity: " + r);
        }
    }, dhn = function(n) {
        if (n.$) return au(Ot);
        var r = n.a;
        switch(r){
            case "He/Him/His":
                return au(It(0));
            case "She/Her/Hers":
                return au(It(1));
            case "They/Them/Theirs":
                return au(It(2));
            case "Other":
                return au(It(3));
            case "":
                return au(Ot);
            default:
                return AA("Unsupported Pronouns: " + r);
        }
    }, vhn = function(n) {
        if (n.$) return au(Ot);
        var r = n.a;
        switch(r){
            case "female":
                return au(It(0));
            case "male":
                return au(It(1));
            case "intersex":
                return au(It(2));
            case "":
                return au(Ot);
            default:
                return AA("Unsupported Sex: " + r);
        }
    }, bhn = function(n) {
        if (n.$) return au(Ot);
        var r = n.a;
        switch(DD(r)){
            case "Ms.":
            case "Ms":
                return au(It(0));
            case "Mrs.":
            case "Mrs":
                return au(It(1));
            case "Miss.":
            case "Miss":
                return au(It(2));
            case "Mr.":
            case "Mr":
                return au(It(3));
            case "Dr.":
            case "Dr":
                return au(It(4));
            case "Mx.":
            case "Mx":
                return au(It(5));
            case "":
                return au(Ot);
            default:
                return AA("Unsupported Title: " + r);
        }
    }, mhn = A3(nk, "id", M$, au(function(n) {
        return {
            sl: n
        };
    })), phn = A2($A, mhn, au(cu)), $hn = F8(function(n, r, t, e, u, a, i, c) {
        return {
            qN: u,
            rA: a,
            sl: n,
            sV: i,
            ur: r,
            vO: c,
            wQ: t,
            wR: e
        };
    }), ghn = F3(function(n, r, t) {
        return {
            ig: t,
            EB: n,
            i1: r
        };
    }), hhn = A2(nu, function(n) {
        switch(n){
            case "mobile":
                return au(UP);
            case "home":
                return au(EO);
            case "office":
                return au(qO);
            default:
                return au(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(n));
        }
    }, M$), yhn = A3(nk, "us_formattable", ru, A3(nk, "type", hhn, A3(nk, "number", M$, au(ghn)))), whn = A2($A, A2(eu, cu, yhn), au(cu)), xhn = A3(nk, "phone", ik(whn), A3(nk, "last_name", ik(M$), A3(nk, "first_name", ik(M$), A3(nk, "email", ik(M$), A3(nk, "relationship_other", ik(M$), A3(nk, "relationship", ik(M$), A3(nk, "name", M$, A3(nk, "id", M$, au($hn))))))))), _hn = A2($A, xhn, au(cu)), Chn = F6(function(n, r, t, e, u, a) {
        return {
            oj: u,
            rZ: r,
            sf: e,
            sl: n,
            tD: t,
            vy: a
        };
    }), Ahn = F2(function(n, r) {
        return {
            r3: r,
            ur: n
        };
    }), khn = F4(function(n, r, t, e) {
        return {
            oP: r,
            oQ: e,
            oU: t,
            sl: n
        };
    }), Ehn = A3(nk, "collect_high_deductible", ru, A3(nk, "collect_member_id", ru, A3(nk, "collect_group_id", ru, A3(nk, "id", M$, au(khn))))), qhn = A2($A, Ehn, au(cu)), Fhn = A3(nk, "carrier", qhn, A3(nk, "name", M$, au(Ahn))), jhn = A2($A, Fhn, au(cu)), Dhn = A3(nk, "payer_name", uC(M$), A3(nk, "carrier_alias", uC(jhn), A3(nk, "high_deductible", uC(ru), A3(nk, "member_id", uC(M$), A3(nk, "group_id", uC(M$), A3(nk, "id", M$, au(Chn))))))), Vhn = A2($A, Dhn, au(cu)), Bhn = A3(nk, "number", M$, au(function(n) {
        return {
            uM: n
        };
    })), Ghn = A2($A, A2(eu, cu, Bhn), au(cu)), zhn = A3(nk, "should_charge_credit_card_fees", ru, A3(nk, "emergency_contact", uC(_hn), A3(nk, "autopay", ru, A3(nk, "preferred_language", fhn, A3(nk, "location", uC(Qvn), A3(nk, "practitioner", uC(MQ), A3(nk, "company", uC(phn), A3(nk, "title", A2(nu, bhn, uC(M$)), A3(nk, "ssn", uC(Ghn), A3(nk, "sex", A2(nu, vhn, uC(M$)), A3(nk, "pronoun_other", uC(M$), A3(nk, "pronouns", A2(nu, dhn, uC(M$)), A3(nk, "phones", uC(ek(whn)), A3(nk, "name", A2(eu, GV, M$), A3(nk, "middle_name", uC(M$), A3(nk, "suffix", uC(M$), A3(nk, "last_name", M$, A3(nk, "id", M$, A3(nk, "health_insurance", uC(Vhn), A3(nk, "gender_identity", A2(nu, lhn, uC(M$)), A3(nk, "gender", A2(nu, shn, uC(M$)), A3(nk, "first_name", M$, A3(nk, "email", uC(M$), A3(nk, "dob", uC(KA), A3(nk, "chosen_suffix", uC(M$), A3(nk, "chosen_title", A2(nu, bhn, uC(M$)), A3(nk, "chosen_middle_name", uC(M$), A3(nk, "chosen_last_name", uC(M$), A3(nk, "chosen_first_name", uC(M$), A3(nk, "address_zip", uC(M$), A3(nk, "address_state", uC(M$), A3(nk, "address_line2", uC(M$), A3(nk, "address_line1", uC(M$), A3(nk, "address_country", uC(M$), A3(nk, "address_city", uC(M$), au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return function(b) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(y) {
                                                                                        return function(w) {
                                                                                            return function(x) {
                                                                                                return function(_) {
                                                                                                    return function(C) {
                                                                                                        return function(A) {
                                                                                                            return function(k) {
                                                                                                                return function(E) {
                                                                                                                    return function(q) {
                                                                                                                        return function(F) {
                                                                                                                            return function(j) {
                                                                                                                                return function(D) {
                                                                                                                                    return function(V) {
                                                                                                                                        return function(B) {
                                                                                                                                            return function(G) {
                                                                                                                                                return {
                                                                                                                                                    na: n,
                                                                                                                                                    nb: r,
                                                                                                                                                    nc: t,
                                                                                                                                                    nd: e,
                                                                                                                                                    ne: u,
                                                                                                                                                    nf: a,
                                                                                                                                                    nE: V,
                                                                                                                                                    oz: i,
                                                                                                                                                    oA: c,
                                                                                                                                                    oB: o,
                                                                                                                                                    oC: s,
                                                                                                                                                    oD: f,
                                                                                                                                                    o$: q,
                                                                                                                                                    qj: l,
                                                                                                                                                    qN: d,
                                                                                                                                                    rA: v,
                                                                                                                                                    rU: b,
                                                                                                                                                    rV: m,
                                                                                                                                                    r2: p,
                                                                                                                                                    sl: $,
                                                                                                                                                    sV: g,
                                                                                                                                                    lp: j,
                                                                                                                                                    ue: y,
                                                                                                                                                    ur: w,
                                                                                                                                                    vQ: x,
                                                                                                                                                    v4: F,
                                                                                                                                                    v9: D,
                                                                                                                                                    wl: C,
                                                                                                                                                    wm: _,
                                                                                                                                                    xt: A,
                                                                                                                                                    xw: G,
                                                                                                                                                    x_: k,
                                                                                                                                                    ym: h,
                                                                                                                                                    yx: E,
                                                                                                                                                    y0: B
                                                                                                                                                };
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))))))))))))))), Shn = A2($A, zhn, au(cu)), Thn = F2(function(n, r) {
        return A2(bk, w([
            "patients",
            r
        ]), fM(n));
    }), Phn = F4(function(n, r, t, e) {
        return A4(aA, n, Shn, e, pk(A2(Thn, r, t)));
    }), Zhn = F3(function(n, r, t) {
        var e = t.Ep;
        return v({
            g0: r.g0,
            ld: r.ld,
            vn: Ot,
            dV: n,
            bJ: Ot
        }, A4(Phn, r.g0, ux(n), e.sl, ohn));
    }), Mhn = F2(function(n, r) {
        return v(r, Qp);
    }), Lhn = F2(function(n, r) {
        return m(r, {
            zK: It(1),
            g0: n.g0
        });
    }), Nhn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Hhn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ihn = {
        $: 1
    }, Ohn = function(n) {
        var r = A2(YF, 0, Ihn);
        return v({
            fq: r.a,
            v4: n
        }, r.b);
    }, Qhn = F2(function(n, r) {
        return v(r.a, n(r.b));
    }), Rhn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Uhn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(Sj, n.a, r.fq), e = t.b;
                return b(m(r, {
                    fq: t.a
                }), A2(Wp, Rhn, e), 0);
            case 1:
                return b(r, Qp, 1);
            default:
                return b(r, Qp, 2);
        }
    }), Khn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return b(m(r, {
                    vn: JF(t)
                }), Qp, A2(Ik, 0, t));
            case 1:
                var e = A2(xc, v(Ot, Qp), A2(Op, A2(tu, Ohn, A2(tu, lx(It), Qhn(Wp(Hhn)))), A2(bb, tS, r.vn))), u = e.b;
                return b(m(r, {
                    bJ: e.a
                }), u, g);
            case 2:
                var a = n.a, i = r.bJ;
                if (i.$) return b(r, Qp, g);
                var c = A2(Uhn, a, i.a), o = c.a, f = c.b, s = c.c ? v(Ot, Qp) : v(It(o), f), l = s.b;
                return b(m(r, {
                    bJ: s.a
                }), A2(Wp, Hhn, l), g);
            default:
                return b(1 === n.a ? m(r, {
                    bJ: Ot
                }) : r, Qp, g);
        }
    }), Whn = function(n) {
        return n.ur;
    }, Xhn = F2(function(n, r) {
        return A2(zx, g, w([
            A2(Mx, w([
                Gx("text-support")
            ]), w([
                A2(UD, w([
                    Gx("link text-current"),
                    oV(x_(Pa))
                ]), w([
                    _d(n(ov.yx))
                ]))
            ])),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            r
        ]));
    }), Yhn = function(n) {
        return n;
    }, Jhn = A2(tu, Yhn, function(n) {
        return n.wQ;
    }), nyn = A2(tu, Yhn, function(n) {
        return n.wR;
    }), ryn = A2(tu, Yhn, function(n) {
        return n.qN;
    }), tyn = function(n) {
        return n.y0;
    }, eyn = function(n) {
        return n.sl;
    }, uyn = A2(tu, Yhn, function(n) {
        return n.ur;
    }), ayn = A2(tu, Yhn, function(n) {
        return n.vO;
    }), iyn = function(n) {
        return {
            ig: n.ig,
            EB: n.EB,
            i1: n.i1
        };
    }, cyn = F2(function(n, r) {
        return A2(zx, w([
            Gx("mb-5")
        ]), w([
            A2(zx, w([
                Gx("flex justify-between items-center")
            ]), w([
                A2(f_, w([
                    uE(aF),
                    qG,
                    sE
                ]), w([
                    _d(n(ov.qS))
                ])),
                A2(PE, w([
                    uE(aF),
                    qG
                ]), w([
                    A2(EV, w([
                        yV(x_(La({
                            sl: eyn(r)
                        })))
                    ]), w([
                        _d(n(1 === tyn(r).$ ? ov.mV : ov.qJ))
                    ]))
                ]))
            ])),
            function() {
                var n = tyn(r);
                if (n.$) return _d("");
                var t, e, u, a, i, c = n.a;
                return A2(BE, w([
                    _E,
                    TE(12)
                ]), w([
                    A2(lE, w([
                        TE(12)
                    ]), w([
                        (i = uyn(c), "" === i ? _d("") : A2(zx, g, w([
                            _d(i)
                        ]))),
                        (a = function(n) {
                            var r = Jhn(n);
                            return r.$ || "other" !== r.a ? r : nyn(n);
                        }(c), 1 === a.$ ? _d("") : A2(zx, g, w([
                            _d(a.a)
                        ]))),
                        A2(Rcn, g, g),
                        (u = ryn(c), 1 === u.$ ? _d("") : A2(zx, g, w([
                            _d(u.a)
                        ]))),
                        (e = ayn(c), 1 === e.$ ? _d("") : A2(zx, g, w([
                            _d((t = iyn(e.a), A2(iV, t.ig ? 0 : 1, t.EB)))
                        ])))
                    ]))
                ]));
            }()
        ]));
    }), oyn = function(n) {
        return n.ur;
    }, fyn = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), syn = fyn, lyn = function(n) {
        return n.qh;
    }, dyn = F2(function(n, r) {
        return r.uf(n);
    }), vyn = F2(function(n, r) {
        return n(dyn(A2(GK, 100 > r ? 1 : 0, r)));
    }), byn = F3(function(n, r, t) {
        var e = w(r ? [
            qG
        ] : [
            VG,
            A2(syn, 1, 2)
        ]), u = lyn(t);
        if (u.$) return vE;
        var a = u.a;
        return A2(zx, w([
            Gx("flex items-center")
        ]), w([
            A2(Mx, w([
                Gx("mr-1 -mt-1")
            ]), w([
                A2(Tq, w([
                    zE,
                    Wj("fill-gray")
                ]), 11)
            ])),
            A2(f_, A2(Qt, nF, e), w([
                _d(A2(vyn, n, a))
            ]))
        ]));
    }), myn = function(n) {
        return A2(fe, ", ", A2(se, ",", n.rQ));
    }, pyn = F2(function(n, r) {
        return n.$ ? r : A2(Qt, n.a, r);
    }), $yn = A2(qu, pyn, g), gyn = function(n) {
        var r = $yn(w([
            A2(Op, aV, bmn(n)),
            A2(Op, myn, vmn(n))
        ]));
        return A2(zx, w([
            Gx("flex flex-col flex-grow")
        ]), A2(Fu, function(n) {
            return A2(zx, w([
                Gx("signup__subtitle")
            ]), w([
                A2(PE, w([
                    VG,
                    A2(syn, 1, 2),
                    nF
                ]), w([
                    _d(n)
                ]))
            ]));
        }, r));
    }, hyn = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("flex flex-row w-full")
            ]), w([
                A2(f_, w([
                    ven,
                    VG,
                    A2(syn, 1, 2)
                ]), w([
                    _d(oyn(r))
                ])),
                A3(byn, n, !1, r)
            ])),
            gyn(r)
        ]);
    }), yyn = F2(function(n, r) {
        var t = function(n) {
            return n.lp;
        }(r);
        if (t.$) return vE;
        var e = t.a;
        return A2(zx, w([
            Gx("mb-5")
        ]), w([
            A2(f_, w([
                uE(aF),
                qG,
                sE
            ]), w([
                _d("Location")
            ])),
            A2(BE, w([
                _E,
                TE(12)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), A2(hyn, n, e))
            ]))
        ]));
    }), wyn = function(n) {
        return {
            zQ: n.nc,
            zR: n.nd,
            oE: n.na,
            AS: n.nb,
            x6: n.ne,
            zF: n.nf
        };
    }, xyn = function(n) {
        return n.qj;
    }, _yn = function(n) {
        return n.qN;
    }, Cyn = function(n) {
        return n.rZ;
    }, Ayn = function(n) {
        return n.r2;
    }, kyn = function(n) {
        return n.oj;
    }, Eyn = function(n) {
        return n.tD;
    }, qyn = function(n) {
        return n.ur;
    }, Fyn = function(n) {
        return n.vy;
    }, jyn = F2(function(n, r) {
        var t = Ayn(r);
        if (1 === t.$) return g;
        var e, u = t.a, a = (e = kyn(u)).$ ? Fyn(u) : It(qyn(e.a));
        return w([
            A2(Op, function(r) {
                return n(ov.r3) + ": " + r;
            }, a),
            A2(Op, function(r) {
                return n(ov.r4) + ": " + r;
            }, Cyn(u)),
            A2(Op, function(r) {
                return n(ov.r5) + ": " + r;
            }, Eyn(u))
        ]);
    }), Dyn = F2(function(n, r) {
        switch(r){
            case 0:
                return "Ms.";
            case 1:
                return "Mrs.";
            case 2:
                return "Miss";
            case 3:
                return "Mr.";
            case 4:
                return "Dr.";
            default:
                return "Mx.";
        }
    }), Vyn = function(n) {
        return n.yx;
    }, Byn = F2(function(n, r) {
        return mon(A2(fe, " ", $yn(w([
            A2(Op, Dyn(n), Vyn(r)),
            It(Whn(r))
        ]))));
    }), Gyn = function(n) {
        return n.vQ;
    }, zyn = function(n) {
        return n.rV;
    }, Syn = function(n) {
        return 3 === n;
    }, Tyn = {
        sT: function(n) {
            return n.rV.sT;
        },
        CZ: function(n) {
            return n.rV.CZ;
        },
        Dk: function(n) {
            return n.rV.Dk;
        },
        Dm: function(n) {
            return n.rV.Dm;
        },
        EC: function(n) {
            return n.rV.EC;
        },
        Gq: function(n) {
            return n.rV.Gq;
        },
        Gr: function(n) {
            return n.rV.Gr;
        },
        GL: function(n) {
            return n.rV.GL;
        }
    }, Pyn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.CZ;
                    };
                case 1:
                    return function(n) {
                        return n.GL;
                    };
                case 2:
                    return function(n) {
                        return n.Dk;
                    };
                case 3:
                    return function(n) {
                        return n.Gq;
                    };
                case 4:
                    return function(n) {
                        return n.Gr;
                    };
                default:
                    return function(n) {
                        return n.Dm;
                    };
            }
        })()(Tyn));
    }), Zyn = {
        B1: function(n) {
            return n.wm.B1;
        },
        sT: function(n) {
            return n.wm.sT;
        },
        Dm: function(n) {
            return n.wm.Dm;
        },
        EC: function(n) {
            return n.wm.EC;
        },
        FA: function(n) {
            return n.wm.FA;
        },
        Gd: function(n) {
            return n.wm.Gd;
        }
    }, Myn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.B1;
                    };
                case 1:
                    return function(n) {
                        return n.FA;
                    };
                case 2:
                    return function(n) {
                        return n.Gd;
                    };
                default:
                    return function(n) {
                        return n.Dm;
                    };
            }
        })()(Zyn));
    }), Lyn = {
        BP: function(n) {
            return n.xt.BP;
        },
        Cq: function(n) {
            return n.xt.Cq;
        },
        sT: function(n) {
            return n.xt.sT;
        },
        CY: function(n) {
            return n.xt.CY;
        },
        EC: function(n) {
            return n.xt.EC;
        }
    }, Nyn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.BP;
                    };
                case 1:
                    return function(n) {
                        return n.CY;
                    };
                default:
                    return function(n) {
                        return n.Cq;
                    };
            }
        })()(Lyn));
    }), Hyn = function(n) {
        return n.wm;
    }, Iyn = function(n) {
        return n.xt;
    }, Oyn = F2(function(n, r) {
        return mon(A2(fe, ", ", $yn(w([
            A2(Op, Nyn(n), Iyn(r)),
            A2(Op, Pyn(n), zyn(r)),
            A2(bb, function(t) {
                return Syn(t) ? function(n) {
                    return n.wl;
                }(r) : It(A2(Myn, n, t));
            }, Hyn(r))
        ]))));
    }), Qyn = F2(function(n, r) {
        var t = A2(jyn, n, r), e = A2(Qt, A2(Byn, n, r), A2(Qt, A2(Op, SM(sZ("/")), xyn(r)), A2(Qt, A2(Oyn, Vx(0), r), A2(Fu, A2(tu, iyn, A2(tu, function(n) {
            return n.EB;
        }, A2(tu, aV, It))), A2(xc, g, Gyn(r)))))), u = wyn(r), a = w([
            u.zQ,
            u.zR,
            mon(A2(fe, ", ", $yn(w([
                u.oE,
                u.x6,
                u.zF,
                u.AS
            ]))))
        ]), i = A2(no, A2(qc, Bm, nE), A2(Fu, $yn, w([
            e,
            w([
                _yn(r)
            ]),
            a,
            t
        ])));
        return A2(zx, A2(Qt, Gx("flex flex-col flex-grow"), TV), A2(Fu, function(n) {
            return A2(zx, w([
                Gx("mb-3")
            ]), A2(Fu, function(n) {
                return A2(zx, w([
                    Gx("mt-1")
                ]), w([
                    A2(PE, w([
                        VG,
                        A2(syn, 1, 2)
                    ]), w([
                        _d(n)
                    ]))
                ]));
            }, n));
        }, i));
    }), Ryn = F2(function(n, r) {
        return A2(zx, w([
            Gx("mb-5")
        ]), w([
            A2(zx, w([
                Gx("flex justify-between items-center")
            ]), w([
                A2(f_, w([
                    uE(aF),
                    qG,
                    sE
                ]), w([
                    _d(n(ov.sp))
                ])),
                A2(PE, w([
                    uE(aF),
                    qG
                ]), w([
                    A2(EV, w([
                        yV(x_(Ma({
                            sl: eyn(r)
                        })))
                    ]), w([
                        _d(n(ov.sq))
                    ]))
                ]))
            ])),
            A2(BE, w([
                _E,
                TE(12)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(Qyn, n, r)
                ]))
            ]))
        ]));
    }), Uyn = function(n) {
        return n.wo;
    }, Kyn = {
        $: 1
    }, Wyn = function(n) {
        return n.n_;
    }, Xyn = function(n) {
        var r;
        return A2(xc, vE, A2(Op, function(n) {
            return A2(zx, w([
                Gx("signup__subtitle text-ellipsis")
            ]), w([
                A2(PE, w([
                    VG,
                    A2(syn, 1, 2)
                ]), w([
                    _d(n)
                ]))
            ]));
        }, (r = Wyn(n), A2(bb, mon, r))));
    }, Yyn = function(n) {
        return A3(OE, "svg", $(w([
            A2(IE, "width", "109"),
            A2(IE, "height", "109"),
            A2(IE, "viewBox", "0 0 109 109"),
            A2(IE, "fill", "none"),
            A2(IE, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), w([
            A3(OE, "rect", w([
                A2(IE, "x", "1.25"),
                A2(IE, "y", "1.25"),
                A2(IE, "width", "106.5"),
                A2(IE, "height", "106.5"),
                A2(IE, "rx", "1.75"),
                A2(IE, "fill", "#F1F6FC"),
                A2(IE, "stroke", "#C4DCF8"),
                A2(IE, "stroke-width", "2.5")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M17.3269 97C17.3269 77.8506 32.8506 62.3269 52 62.3269H58C77.1494 62.3269 92.6731 77.8506 92.6731 97V107.673H17.3269V97Z"),
                A2(IE, "fill", "#F1F6FC"),
                A2(IE, "stroke", "#C4DCF8"),
                A2(IE, "stroke-width", "2.65385")
            ]), g),
            A3(OE, "circle", w([
                A2(IE, "cx", "38.5"),
                A2(IE, "cy", "87.5"),
                A2(IE, "r", "6.17308"),
                A2(IE, "stroke", "#C4DCF8"),
                A2(IE, "stroke-width", "2.65385")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M59.2251 90.388L56.3816 87.6739L60.3789 83.4861C62.5996 81.1596 68.4627 77.8636 74.1497 83.2918C79.8366 88.7201 76.807 94.4243 74.5813 96.5979L70.2161 101.171L67.7833 98.8893"),
                A2(IE, "stroke", "#C4DCF8"),
                A2(IE, "stroke-width", "2.65385")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M74.5 84.2308C76.5641 83.3461 80.3385 79.1885 82.4615 73.1731"),
                A2(IE, "stroke", "#C4DCF8"),
                A2(IE, "stroke-width", "2.65385")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M34.6924 84.2308C32.6283 83.3461 28.8539 79.1885 26.7308 73.1731"),
                A2(IE, "stroke", "#C4DCF8"),
                A2(IE, "stroke-width", "2.65385")
            ]), g),
            A3(OE, "mask", w([
                A2(IE, "id", "path-7-inside-1"),
                A2(IE, "fill", "white")
            ]), w([
                A3(OE, "path", w([
                    A2(IE, "d", "M75 44.0226C75 58.3171 68.6756 74.8824 55 74.8824C41.3244 74.8824 35 58.3171 35 44.0226C35 29.7282 44.0476 23.1176 55 23.1176C65.9524 23.1176 75 29.7282 75 44.0226Z")
                ]), g)
            ])),
            A3(OE, "path", w([
                A2(IE, "d", "M75 44.0226C75 58.3171 68.6756 74.8824 55 74.8824C41.3244 74.8824 35 58.3171 35 44.0226C35 29.7282 44.0476 23.1176 55 23.1176C65.9524 23.1176 75 29.7282 75 44.0226Z"),
                A2(IE, "fill", "#F1F6FC")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M72.3462 44.0226C72.3462 50.8382 70.8285 58.0833 67.808 63.5249C64.8092 68.9275 60.5583 72.2285 55 72.2285V77.5362C63.1173 77.5362 68.8665 72.5545 72.4487 66.1009C76.0093 59.6863 77.6538 51.5015 77.6538 44.0226H72.3462ZM55 72.2285C49.4417 72.2285 45.1908 68.9275 42.192 63.5249C39.1715 58.0833 37.6538 50.8382 37.6538 44.0226H32.3462C32.3462 51.5015 33.9907 59.6863 37.5513 66.1009C41.1335 72.5545 46.8827 77.5362 55 77.5362V72.2285ZM37.6538 44.0226C37.6538 37.4578 39.7137 32.9822 42.7179 30.1364C45.7514 27.263 50.0436 25.7715 55 25.7715V20.4638C49.004 20.4638 43.2963 22.2776 39.0678 26.283C34.8101 30.3162 32.3462 36.293 32.3462 44.0226H37.6538ZM55 25.7715C59.9564 25.7715 64.2486 27.263 67.2821 30.1364C70.2863 32.9822 72.3462 37.4578 72.3462 44.0226H77.6538C77.6538 36.293 75.1899 30.3162 70.9322 26.283C66.7037 22.2776 60.996 20.4638 55 20.4638V25.7715Z"),
                A2(IE, "fill", "#C4DCF8"),
                A2(IE, "mask", "url(#path-7-inside-1)")
            ]), g),
            A3(OE, "path", w([
                A2(IE, "d", "M72.4707 46.0588C65.4119 46.0588 62.4707 39 61.8825 35.4706C62.0785 39 57.2942 46.0588 36.5883 46.0588"),
                A2(IE, "stroke", "#C4DCF8"),
                A2(IE, "stroke-width", "2.65385")
            ]), g)
        ]));
    }, Jyn = function() {
        return Yyn;
    }, nwn = function(n) {
        switch(n.$){
            case 0:
                return w([
                    HE(Jx(n.a))
                ]);
            case 1:
                return w([
                    A2(VF, "width", oe(n.a))
                ]);
            default:
                return w([
                    A2(VF, "height", oe(n.a))
                ]);
        }
    }, rwn = F2(function(n, r) {
        var t = A2(bc, nwn, n);
        return A2(Jyn, r, A2(Qt, HE("inline-block"), t));
    }), twn = F2(function(n, r) {
        var t = n ? w([
            v("image-portrait--modal", n)
        ]) : g, e = "flex items-center justify-center overflow-hidden image-portrait", u = function(n) {
            return n.vR;
        }(r);
        if (u.$) {
            var a = A2(rwn, g, 0);
            return A2(zx, g, w([
                A2(zx, w([
                    Gx(e),
                    Oq(t)
                ]), w([
                    a
                ]))
            ]));
        }
        var i = u.a;
        return A2(zx, w([
            Gx(e),
            Oq(t)
        ]), w([
            A2(uJ, w([
                iJ(i)
            ]), g)
        ]));
    }), ewn = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("flex flex-col mr-4")
            ]), w([
                A2(twn, !1, r)
            ])),
            A2(zx, w([
                Gx("flex flex-col flex-grow")
            ]), w([
                A2(f_, w([
                    ven,
                    VG,
                    A2(syn, 1, 2)
                ]), w([
                    _d(QS(r))
                ])),
                Xyn(r)
            ])),
            A2(zx, w([
                Gx("flex flex-col justify-center ml-4 mr-2")
            ]), w([
                A2(yF, w([
                    CD,
                    cF(Kyn),
                    rhn(!0)
                ]), w([
                    _d(n(KI))
                ]))
            ]))
        ]);
    }), uwn = F2(function(n, r) {
        var t = tS(r);
        if (t.$) return vE;
        var e, u, a = t.a;
        return A2(zx, w([
            Gx("mb-5")
        ]), w([
            A2(f_, w([
                uE(aF),
                qG,
                sE
            ]), w([
                _d((e = n(Uyn), u = A2(Sb, aL("\\w+"), A2(tu, function(n) {
                    return n.lr;
                }, S0)), A3(Sb, aL("^([a-z])|\\s+([a-z])"), A2(tu, function(n) {
                    return n.lr;
                }, u), e)))
            ])),
            A2(BE, w([
                _E,
                TE(12)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(zx, w([
                        Gx("flex flex-row w-full")
                    ]), A2(ewn, n, a))
                ]))
            ]))
        ]));
    }), awn = F2(function(n, r) {
        var t = ZV(Whn(r));
        return A2(zx, w([
            Gx("text-left")
        ]), w([
            A2(Xhn, n, t),
            s_,
            A2(i_, w([
                Hx(w([
                    Gx("mt-8 mb-8")
                ]))
            ]), w([
                t
            ])),
            A2(Ryn, n, r),
            A2(cyn, n, r),
            A2(uwn, n, r),
            A2(yyn, n, r)
        ]));
    }), iwn = A2(tE, rE(0), It(1)), cwn = F2(function(n, r) {
        return nE(r) ? vE : A2(zx, w([
            Gx("mb-4")
        ]), w([
            A2(xX, w([
                qG
            ]), w([
                _d(n)
            ])),
            A2(f_, w([
                nF,
                qG,
                uE(iwn)
            ]), w([
                _d(A2(fe, ", ", r))
            ]))
        ]));
    }), own = F3(function(n, r, t) {
        var e = nE(t) && nE(r) ? 12 : 7;
        return A2(BE, w([
            VN(w([
                Gx("row--tweak")
            ])),
            xN(JI)
        ]), w([
            A2(lE, w([
                TE(12),
                tO(e),
                xN(aF),
                A2(rO, 1, JI)
            ]), w([
                function() {
                    if (n.$) return vE;
                    var r = n.a;
                    return A2(zx, w([
                        Gx("sm:pr-2")
                    ]), w([
                        _d(r)
                    ]));
                }()
            ])),
            A2(lE, w([
                TE(12),
                tO(5)
            ]), w([
                A2(cwn, "Specialties", t),
                A2(cwn, "Education", r)
            ]))
        ]));
    }), fwn = {
        $: 2
    }, swn = function(n) {
        return n.qm;
    }, lwn = function(n) {
        return A2(yF, w([
            CD,
            iK,
            cF(fwn)
        ]), w([
            _d(n(swn))
        ]));
    }, dwn = function(n) {
        return n.rR;
    }, vwn = function(n) {
        return n.tv;
    }, bwn = function(n) {
        return n.uj;
    }, mwn = F3(function(n, r, t) {
        var e = n.$ ? "" : "from " + oe(n.a) + " ", u = r.$ ? "" : "to " + oe(r.a);
        return mu(e) && mu(u) ? "" : (t ? "Only treats" : "Treats") + " ages " + (e + u);
    }), pwn = F3(function(n, r, t) {
        var e = r.lp;
        return A2(zx, w([
            Gx("flex flex-col sm:flex-row w-full")
        ]), w([
            A2(zx, w([
                Gx("flex flex-col mr-4")
            ]), w([
                A2(twn, !0, t)
            ])),
            A2(zx, w([
                Gx("flex flex-col")
            ]), w([
                A2(zx, w([
                    Gx("mt-4 sm:mt-0")
                ]), w([
                    A2(PE, w([
                        Qx
                    ]), w([
                        _d(QS(t))
                    ]))
                ])),
                A2(f_, w([
                    qG
                ]), w([
                    _d(A3(mwn, bwn(t), vwn(t), !1))
                ])),
                function() {
                    if (e.$) return vE;
                    var n = e.a;
                    return A2(zx, w([
                        Gx("mt-1 sm:mt-0")
                    ]), w([
                        A2(f_, w([
                            nF,
                            qG
                        ]), w([
                            _d(dwn(n))
                        ]))
                    ]));
                }(),
                A2(zx, w([
                    Gx("mt-1")
                ]), _K(A2(xc, vE, A2(Op, A2(byn, n, !0), e))))
            ]))
        ]));
    }), $wn = F3(function(n, r, t) {
        var e, u = t.v4, a = t.fq, i = function(n) {
            return n.xX;
        }(u), c = function(n) {
            return A2(xc, g, n.qM);
        }(u), o = Wyn(u), f = A2(n$, cu, w([
            It(Hj(w([
                A3(pwn, n, r, u)
            ]))),
            (e = b(o, nE(c), nE(i)), 1 === e.a.$ && e.b && e.c ? Ot : It(Mj(w([
                A3(own, o, c, i)
            ])))),
            r.zp ? It(Nj(w([
                lwn(n)
            ]))) : Ot
        ]));
        return A2(dD, f, zj(a));
    }), gwn = F2(function(n, r) {
        return A2(c_, Hhn, A2(xc, vE, A2(Op, A2($wn, n, {
            lp: Ot,
            zp: !1
        }), r)));
    }), hwn = F2(function(n, r) {
        return {
            g8: w([
                A2(gwn, n, r.bJ),
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t = r.vn;
                    return t.$ ? Nx : w([
                        A2(awn, n, t.a)
                    ]);
                }())
            ]),
            yx: n(ov.yx)
        };
    }), ywn = C_({
        Cl: Zhn,
        CQ: Mhn,
        Fj: Lhn,
        F4: function() {
            return Cj(M1(Nhn));
        },
        Gv: Khn,
        GB: hwn
    }), wwn = function(n) {
        return {
            $: 17,
            a: n
        };
    }, xwn = function(n) {
        switch(n){
            case "no":
                return au(0);
            case "yes":
                return au(1);
            case "optional":
                return au(2);
            case "require":
                return au(3);
            case "default":
                return au(4);
            default:
                return AA("Unsupported collection option: " + n);
        }
    }, _wn = F2(function(n, r) {
        return {
            rI: r,
            sl: n
        };
    }), Cwn = F6(function(n, r, t, e, u, a) {
        return {
            p8: e,
            sc: u,
            sl: n,
            CI: t,
            wZ: a,
            yx: r
        };
    }), Awn = function(n) {
        switch(n){
            case "string":
                return au(0);
            case "multiple_strings":
                return au(1);
            case "boolean":
                return au(2);
            default:
                return AA("Unsupported item type: " + n);
        }
    }, kwn = A3(nk, "required", ru, A3(nk, "help_text", uC(M$), A3(nk, "description", uC(M$), A3(nk, "item_type", A2(nu, Awn, M$), A3(nk, "title", M$, A3(nk, "id", M$, au(Cwn))))))), Ewn = A2($A, kwn, au(cu)), qwn = A3(nk, "form_items", ek(Ewn), A3(nk, "id", M$, au(_wn))), Fwn = A2($A, qwn, au(cu)), jwn = A3(nk, "allowed_zip_codes_on_signup", ek(M$), A3(nk, "restrict_zip_codes_on_signup", ru, A3(nk, "forms", ek(Fwn), A3(nk, "collect_tobacco_use", ru, A3(nk, "post_signup_button_label", uC(M$), A3(nk, "show_post_signup_footer_button", ru, A3(nk, "post_signup_message", uC(M$), A3(nk, "post_signup_redirect_url", uC(M$), A3(nk, "collect_address_on_signup", A2(nu, xwn, M$), A3(nk, "collect_ssn_on_signup", A2(nu, xwn, M$), A3(nk, "collect_location_on_signup", A2(nu, xwn, M$), A3(nk, "collect_practitioner_on_signup", A2(nu, xwn, M$), au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        no: l,
                                                        oM: e,
                                                        oT: r,
                                                        oW: n,
                                                        oY: t,
                                                        o_: o,
                                                        rN: f,
                                                        lY: c,
                                                        lZ: a,
                                                        l_: u,
                                                        xb: s,
                                                        mo: i
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), Dwn = A2($A, jwn, au(cu)), Vwn = F3(function(n, r, t) {
        return A4(aA, GQ(n), Dwn, t, pk(function(n) {
            return A2(bk, w([
                "signup_setting"
            ]), fM(n));
        }(r)));
    }), Bwn = F2(function(n, r) {
        return A3(Vwn, n, ux(r), wwn);
    }), Gwn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, zwn = function(n) {
        return n.b.p2;
    }, Swn = {
        BP: function(n) {
            return n.rU.BP;
        },
        sT: function(n) {
            return n.rU.sT;
        },
        CY: function(n) {
            return n.rU.CY;
        },
        Ei: function(n) {
            return n.rU.Ei;
        }
    }, Twn = {
        zQ: "",
        zR: "",
        oE: "",
        AS: "United States",
        x6: "",
        zF: ""
    }, Pwn = {
        $: 0
    }, Zwn = w([
        0,
        1,
        2,
        3,
        4
    ]), Mwn = function(n) {
        switch(n){
            case 0:
                return "Address Line 1";
            case 1:
                return "City";
            case 2:
                return "State";
            case 3:
                return "Zip";
            default:
                return "Country";
        }
    }, Lwn = F2(function(n, r) {
        return {
            cy: p7,
            cO: Pwn,
            le: vZ(r),
            sl: n,
            wZ: !1,
            jp: Ot,
            cq: !1,
            bP: g,
            A: A2(pZ, Zwn, Mwn)
        };
    }), Nwn = function(n) {
        return A2(Lwn, n, Twn);
    }, Hwn = F2(function(n, r) {
        return r.$ ? n(YP) : qyn(r.a);
    }), Iwn = function(n) {
        return n.r3;
    }, Own = function(n) {
        return n.sl;
    }, Qwn = function(n) {
        return It(n.$ ? "other" : Own(Iwn(n.a)));
    }, Rwn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Uwn = {
        lo: 10,
        ur: Ot
    }, Kwn = A2(bk, w([
        "health_insurance_carrier_aliases"
    ]), oM), Wwn = F3(function(n, r, t) {
        return A4(aA, GQ(n), ek(jhn), t, A2($k, function(n) {
            var r = n(Uwn);
            return $(function() {
                var n = r.ur;
                return n.$ ? g : w([
                    A2(g_, "name", n.a)
                ]);
            }(), w([
                A2(iA, "limit", r.lo)
            ]));
        }(r), pk(Kwn)));
    }), Xwn = F2(function(n, r) {
        return A3(Wwn, n, function(n) {
            return m(n, {
                ur: r
            });
        }, Rwn);
    }), Ywn = function(n) {
        return {
            ak: Ot,
            bX: "",
            ab: n,
            b7: "",
            sf: !0,
            cd: "",
            iz: !1
        };
    }, Jwn = function(n) {
        return {
            hG: p7,
            sl: n.sl,
            dJ: n.Gj,
            ln: n.Gk,
            Eg: !1,
            yu: ""
        };
    }, nxn = w([
        0,
        1,
        2,
        3
    ]), rxn = function(n) {
        switch(n){
            case 0:
                return "Carrier";
            case 1:
                return "CarrierAliasOther";
            case 2:
                return "GroupID";
            default:
                return "MemberID";
        }
    }, txn = F2(function(n, r) {
        return v({
            g0: n,
            eF: Jwn({
                sl: "carrier-select",
                Gj: Hwn,
                Gk: Qwn
            }),
            eG: A_,
            le: vZ(Ywn(r)),
            fT: !1,
            A: A2(pZ, nxn, rxn)
        }, A2(Xwn, n, Ot));
    }), exn = function(n) {
        return A2(cZ, n, {
            ig: !0,
            EB: "",
            i1: aN
        });
    }, uxn = function(n) {
        return n.a;
    }, axn = F2(function(n, r) {
        var t = r.$ ? 1 : uxn(r.a);
        return n + "-phone-" + oe(t);
    }), ixn = function(n) {
        return n.sl;
    }, cxn = function(n) {
        var r = exn(A2(axn, n, Ot));
        return {
            sl: n,
            vQ: A2(Y2, r, F0),
            wZ: !1,
            d3: Ot,
            N: A2(pZ, w([
                r
            ]), ixn)
        };
    }, oxn = {
        xt: Ot
    }, fxn = w([
        0
    ]), sxn = function() {
        return "Sex";
    }, lxn = function(n) {
        return It(sJ(A2(Nyn, Vx(0), n)));
    }, dxn = function(n) {
        return {
            le: vZ(oxn),
            sl: n,
            wZ: !1,
            f0: Cd({
                sl: n + "-select",
                Gj: Nyn,
                Gk: lxn
            }),
            A: A2(pZ, fxn, sxn)
        };
    }, vxn = {
        yx: Ot
    }, bxn = w([
        0
    ]), mxn = function() {
        return "Title";
    }, pxn = function(n) {
        return It(A2(Dyn, Vx(0), n));
    }, $xn = function(n) {
        return {
            le: vZ(vxn),
            sl: n,
            wZ: !1,
            gb: Cd({
                sl: n + "-select",
                Gj: Dyn,
                Gk: pxn
            }),
            A: A2(pZ, bxn, mxn)
        };
    }, gxn = {
        dU: "",
        fZ: Ot
    }, hxn = w([
        0,
        1
    ]), yxn = function(n) {
        return n ? "FieldOther" : "Field";
    }, wxn = function(n) {
        var r = n.Gj, t = n.Gk, e = n.sl, u = n.CD;
        return {
            BQ: n.BQ,
            le: vZ(gxn),
            sl: e,
            CD: u,
            wZ: !1,
            mg: r,
            gd: Cd({
                sl: e + "-select",
                Gj: r,
                Gk: t
            }),
            A: A2(pZ, hxn, yxn)
        };
    }, xxn = function(n) {
        return 2 === n;
    }, _xn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.BP;
                    };
                case 1:
                    return function(n) {
                        return n.CY;
                    };
                default:
                    return function(n) {
                        return n.Ei;
                    };
            }
        })()(Swn));
    }), Cxn = function(n) {
        return It(function() {
            switch(n){
                case 0:
                    return "female";
                case 1:
                    return "male";
                default:
                    return "other";
            }
        }());
    }, Axn = F2(function(n, r) {
        return wxn({
            BQ: r,
            sl: n,
            CD: xxn,
            Gj: _xn,
            Gk: Cxn
        });
    }), kxn = function(n) {
        return 5 === n;
    }, Exn = function(n) {
        return It(sJ(function() {
            switch(n){
                case 0:
                    return "Man";
                case 1:
                    return "Woman";
                case 2:
                    return "Non-binary";
                case 3:
                    return "Trans Man";
                case 4:
                    return "Trans Woman";
                default:
                    return "Not Listed";
            }
        }()));
    }, qxn = F2(function(n, r) {
        return wxn({
            BQ: r,
            sl: n,
            CD: kxn,
            Gj: Pyn,
            Gk: Exn
        });
    }), Fxn = function(n) {
        switch(n){
            case 0:
                return It("He/Him/His");
            case 1:
                return It("She/Her/Hers");
            case 2:
                return It("They/Them/Theirs");
            default:
                return It("Not Listed");
        }
    }, jxn = F2(function(n, r) {
        return wxn({
            BQ: r,
            sl: n,
            CD: Syn,
            Gj: Myn,
            Gk: Fxn
        });
    }), Dxn = function(n) {
        return n.b.w3;
    }, Vxn = F2(function(n, r) {
        return m(r, {
            d3: It(n)
        });
    }), Bxn = F2(function(n, r) {
        return Dxn(n) ? A2(Vxn, UP, r) : r;
    }), Gxn = F2(function(n, r) {
        return m(r, {
            wZ: n
        });
    }), zxn = F2(function(n, r) {
        return m(r, {
            wZ: n
        });
    }), Sxn = F2(function(n, r) {
        var t = A2(txn, n, !1), e = t.a, u = t.b;
        return v({
            m9: A2(Gxn, !1, Nwn("main-address")),
            oz: "",
            oA: "",
            oB: "",
            oC: "",
            oD: $xn("chosen-title"),
            bq: lZ("dob"),
            qN: "",
            rA: "",
            rU: A2(Axn, "gender", Swn.sT),
            rV: A2(qxn, "gender-identity", Tyn.sT),
            an: !1,
            a8: e,
            sV: "",
            ue: "",
            vQ: A2(Bxn, r, A2(zxn, !0, cxn("phones"))),
            v9: A2(eg, zwn(r), rb("preferred-language")),
            wm: A2(jxn, "pronouns", Zyn.sT),
            xt: dxn("sex"),
            x_: "",
            ym: "",
            yx: $xn("title")
        }, A2(Wp, Gwn, u));
    }), Txn = w([
        0,
        2
    ]), Pxn = function(n) {
        switch(n){
            case 0:
                return "Email";
            case 1:
                return "Phone";
            default:
                return "Address";
        }
    }, Zxn = F3(function(n, r, t) {
        var e = t.Ep, u = A2(Sxn, r.g0, n), a = u.b, i = vZ(u.a);
        return v({
            g0: r.g0,
            ld: r.ld,
            le: i,
            vn: Ot,
            fy: e.sl,
            dV: n,
            f2: Ot,
            A: A2(pZ, Txn, Pxn)
        }, Uu(w([
            A2(Bwn, r.g0, n),
            a
        ])));
    }), Mxn = F2(function(n, r) {
        return v(r, Qp);
    }), Lxn = F2(function(n, r) {
        return m(r, {
            zK: It(1),
            g0: n.g0
        });
    }), Nxn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hxn = nr("googlePlacesAddressDetails", A2(nu, function(n) {
        return A2(nu, function(r) {
            return au({
                m9: r,
                sl: n
            });
        }, A2(Iu, "address", M$));
    }, A2(Iu, "id", M$))), Ixn = nr("googlePlacesAddressSuggestions", A2(nu, function(n) {
        return A2(nu, function(r) {
            return au({
                sl: r,
                bP: n
            });
        }, A2(Iu, "id", M$));
    }, A2(Iu, "suggestions", G$))), Oxn = vx(w([
        (N8 = function(n) {
            return {
                $: 3,
                a: n
            };
        }, Ixn(N8)),
        (L8 = function(n) {
            return {
                $: 4,
                a: n
            };
        }, Hxn(L8))
    ])), Qxn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Rxn = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Uxn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Kxn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Wxn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Xxn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Yxn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Jxn = function(n) {
        return n.oM;
    }, n_n = function(n) {
        return 3 === n;
    }, r_n = function(n) {
        return n_n(Jxn(n));
    }, t_n = function(n) {
        return n.oz;
    }, e_n = function(n) {
        return n.oA;
    }, u_n = function(n) {
        return n.oB;
    }, a_n = function(n) {
        return n.oC;
    }, i_n = function(n) {
        return n.oD;
    }, c_n = function(n) {
        return n.rA;
    }, o_n = function(n) {
        return n.rU;
    }, f_n = function(n) {
        return {
            zQ: A2(xc, "", n.zQ),
            zR: A2(xc, "", n.zR),
            oE: A2(xc, "", n.oE),
            AS: A2(xc, "United States", n.AS),
            x6: A2(xc, "", n.x6),
            zF: A2(xc, "", n.zF)
        };
    }, s_n = F2(function(n, r) {
        return {
            cy: p7,
            cO: Pwn,
            le: vZ(f_n(r)),
            sl: n,
            wZ: !1,
            jp: Ot,
            cq: !1,
            bP: g,
            A: A2(pZ, Zwn, Mwn)
        };
    }), l_n = function(n) {
        var r = n.oA;
        return iL(n.oz) && iL(r);
    }, d_n = function(n) {
        return n.sV;
    }, v_n = function(n) {
        return n.ue;
    }, b_n = function(n) {
        return n.uM;
    }, m_n = function(n) {
        return n.v9;
    }, p_n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $_n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    ab: n.a
                });
            case 1:
                return m(r, {
                    ak: n.a
                });
            case 2:
                return m(r, {
                    bX: n.a
                });
            case 3:
                return m(r, {
                    b7: n.a
                });
            case 4:
                return m(r, {
                    cd: n.a
                });
            default:
                return m(r, {
                    sf: n.a
                });
        }
    }), g_n = F2(function(n, r) {
        return m(r, {
            le: A3(cN, $_n, p_n(n), r.le)
        });
    }), h_n = function(n) {
        return n.x_;
    }, y_n = function(n) {
        return n.ym;
    }, w_n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, x_n = {
        $: 1
    }, __n = function(n) {
        return n.sf;
    }, C_n = function(n) {
        var r = Fyn(n), t = kyn(n), e = t.$ ? v(It(x_n), r) : v(A2(Op, function(n) {
            return w_n(n);
        }, t), Ot);
        return {
            ak: e.a,
            bX: A2(xc, "", e.b),
            ab: !0,
            b7: A2(xc, "", Cyn(n)),
            sf: A2(xc, !1, __n(n)),
            cd: A2(xc, "", Eyn(n)),
            iz: OS(t)
        };
    }, A_n = F2(function(n, r) {
        return m(r, {
            le: vZ(C_n(n))
        });
    }), k_n = F3(function(n, r, t) {
        return m(t, {
            x6: A3(ia, r(n), bZ, t.x6)
        });
    }), E_n = F2(function(n, r) {
        var t = A2(axn, r.sl, It(r.vQ)), e = n.$ ? exn(t) : A2(cZ, t, n.a);
        return v(t, m(r, {
            vQ: A2(Y2, e, r.vQ),
            N: A3(k_n, e, ixn, r.N)
        }));
    }), q_n = F2(function(n, r) {
        for(;;){
            if (!n.b) return r;
            var t = n.a;
            n = n.b, r = A2(E_n, It(t), r).b;
        }
    }), F_n = function(n) {
        return mb(n.b);
    }, j_n = function(n) {
        return A2(bb, function(n) {
            return It(n.b);
        }, F_n(n));
    }, D_n = F2(function(n, r) {
        return A2(q0, r.a, A2(no, function(r) {
            return !i(r.a, n);
        }, r.b));
    }), V_n = F3(function(n, r, t) {
        return m(t, {
            x6: A2(va, r(n), t.x6)
        });
    }), B_n = F3(function(n, r, t) {
        var e = A3(V_n, t, ixn, n.N);
        return m(n, {
            vQ: A2(D_n, r, n.vQ),
            N: e
        });
    }), G_n = F2(function(n, r) {
        if (nE(n)) return r;
        var t = A2(q_n, n, r);
        if (I2(t.vQ) > 1) {
            var e = j_n(t.vQ);
            return e.$ ? t : A3(B_n, t, 1, e.a);
        }
        return t;
    }), z_n = F2(function(n, r) {
        return n.$ ? r : A2(G_n, A2(Fu, iyn, n.a), r);
    }), S_n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, T_n = F2(function(n, r) {
        return m(r, n.$ ? {
            dU: n.a
        } : {
            fZ: n.a
        });
    }), P_n = F2(function(n, r) {
        return m(r, {
            le: A3(cN, T_n, S_n(It(n)), r.le)
        });
    }), Z_n = F2(function(n, r) {
        return n.$ ? r : A2(P_n, n.a, r);
    }), M_n = F2(function(n, r) {
        return m(r, {
            xt: n
        });
    }), L_n = F2(function(n, r) {
        return m(r, {
            le: A3(cN, M_n, It(n), r.le)
        });
    }), N_n = F2(function(n, r) {
        return n.$ ? r : A2(L_n, n.a, r);
    }), H_n = F2(function(n, r) {
        return m(r, {
            yx: n
        });
    }), I_n = F2(function(n, r) {
        return m(r, {
            le: A3(cN, H_n, It(n), r.le)
        });
    }), O_n = F2(function(n, r) {
        return n.$ ? r : A2(I_n, n.a, r);
    }), Q_n = F4(function(n, r, t, e) {
        var u = A2(Bxn, r, A2(z_n, Gyn(n), A2(zxn, !0, cxn("phones")))), a = function() {
            var r = Ayn(n);
            return r.$ ? A2(g_n, !1, e.a8) : A2(A_n, r.a, A2(g_n, !0, e.a8));
        }(), i = A2(xc, "", e_n(n)), c = A2(xc, "", t_n(n));
        return {
            m9: A2(Gxn, r_n(t), A2(s_n, "main-address", wyn(n))),
            oz: c,
            oA: i,
            oB: A2(xc, "", u_n(n)),
            oC: A2(xc, "", a_n(n)),
            oD: A2(O_n, i_n(n), $xn("chosen-title")),
            bq: A2(ZM, xyn(n), lZ("date-of-birth")),
            qN: A2(xc, "", _yn(n)),
            rA: c_n(n),
            rU: A2(Z_n, o_n(n), A2(Axn, "gender", Swn.sT)),
            rV: A2(Z_n, zyn(n), A2(qxn, "gender-identity", Tyn.sT)),
            an: !l_n({
                oz: c,
                oA: i
            }),
            a8: a,
            sV: d_n(n),
            ue: A2(xc, "", v_n(n)),
            vQ: u,
            v9: A2(eg, m_n(n), rb("preferred-language")),
            wm: A2(Z_n, Hyn(n), A2(jxn, "pronouns", Zyn.sT)),
            xt: A2(N_n, Iyn(n), dxn("sex")),
            x_: A2(xc, "", A2(Op, b_n, h_n(n))),
            ym: A2(xc, "", y_n(n)),
            yx: A2(O_n, Vyn(n), $xn("title"))
        };
    }), R_n = F2(function(n, r) {
        switch(n.$){
            case 1:
                return m(r, {
                    qN: n.a
                });
            case 2:
                return m(r, {
                    vQ: n.a
                });
            case 0:
                return m(r, {
                    m9: n.a
                });
            case 3:
                return m(r, {
                    a8: n.a
                });
            default:
                return m(r, {
                    v9: n.a
                });
        }
    }), U_n = function(n) {
        return {
            $: 14,
            a: n
        };
    }, K_n = function(n) {
        return iL(n) ? nx : tx(DD(n));
    }, W_n = function(n) {
        var r = FM(n.le);
        return w([
            v("address_city", K_n(r.oE)),
            v("address_country", K_n(r.AS)),
            v("address_line1", K_n(r.zQ)),
            v("address_line2", K_n(r.zR)),
            v("address_state", K_n(r.x6)),
            v("address_zip", K_n(r.zF))
        ]);
    }, X_n = function(n) {
        switch(n.$){
            case 0:
                return tx("mobile");
            case 1:
                return tx("home");
            case 2:
                return tx("office");
            default:
                return tx(n.a);
        }
    }, Y_n = function(n) {
        return iL(n.EB) ? nx : rx(w([
            v("number", K_n(n.EB)),
            v("type", X_n(n.d8)),
            v("us_formattable", Yw(!n.Fs))
        ]));
    }, J_n = function(n) {
        return A2(f2, function(n) {
            return Y_n(n.b);
        }, n);
    }, nCn = function(n) {
        return tx(nb(n.CK));
    }, rCn = function(n) {
        var r = FM(n.le), t = r.ak;
        return r.ab ? t.$ || t.a.$ ? Ot : It(Own(Iwn(t.a.a))) : Ot;
    }, tCn = function(n) {
        var r = FM(n.le), t = r.bX;
        return r.ab ? A2(Op, function(n) {
            return n.$ ? t : qyn(n.a);
        }, r.ak) : Ot;
    }, eCn = function(n) {
        return iL(n) ? nx : tx(n);
    }, uCn = function(n) {
        return FM(n.le).b7;
    }, aCn = function(n) {
        return FM(n.le).ab;
    }, iCn = function(n) {
        return FM(n.le).sf;
    }, cCn = F5(function(n, r, t, e, u) {
        return A4(Dj, n, Shn, u, A2(dM, rx(w([
            e
        ])), pk(A2(Thn, r, t))));
    }), oCn = function(n) {
        var r, t = ux(n.dV), e = function() {
            var r = n.vn;
            return r.$ ? "" : eyn(r.a);
        }(), u = (r = FM(n.le), v("patient", rx(function(n) {
            var r, t;
            return A2(Qt, v("email", tx(n.qN)), A2(Qt, v("phones", J_n(n.vQ.vQ)), A2(Qt, v("preferred_language", nCn(n.v9)), $(aCn(r = n.a8) ? w([
                v("health_insurance_payer_name", eCn(A2(xc, "", tCn(r)))),
                v("health_insurance_carrier", A2(xc, nx, A2(Op, function(n) {
                    return rx(w([
                        v("id", tx(n))
                    ]));
                }, rCn(r)))),
                v("health_insurance_member_id", eCn((t = r, FM(t.le).cd))),
                v("health_insurance_group_id", eCn(uCn(r))),
                v("health_insurance_high_deductible", Yw(iCn(r)))
            ]) : w([
                v("health_insurance_payer_name", nx),
                v("health_insurance_carrier", nx),
                v("health_insurance_member_id", nx),
                v("health_insurance_group_id", nx),
                v("health_insurance_high_deductible", nx)
            ]), W_n(n.m9)))));
        }(r))));
        return A5(cCn, n.g0, t, e, u, U_n);
    }, fCn = F2(function(n, r) {
        return {
            m9: n,
            sl: r
        };
    }), sCn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lCn = function(n) {
        return m(n, {
            cq: !1
        });
    }, dCn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, vCn = function(n) {
        return A2(Nu, dCn, Au(n));
    }, bCn = {
        F1: Atn(300),
        Gs: function(n) {
            return {
                $: 6,
                a: n
            };
        }
    }, mCn = F3(function(n, r, t) {
        return {
            p8: n,
            vT: r,
            Gt: t
        };
    }), pCn = A3(nk, "types", ek(M$), A3(nk, "place_id", M$, A3(nk, "description", M$, au(mCn)))), $Cn = ek(pCn), gCn = F5(function(n, r, t, e, u) {
        return {
            kE: n,
            BW: r,
            ur: t,
            vT: e,
            Gt: u
        };
    }), hCn = F3(function(n, r, t) {
        return {
            tn: n,
            xu: r,
            Gt: t
        };
    }), yCn = w([
        v("street_address", 0),
        v("route", 1),
        v("intersection", 2),
        v("political", 3),
        v("country", 4),
        v("administrative_area_level_1", 5),
        v("administrative_area_level_2", 6),
        v("administrative_area_level_3", 7),
        v("administrative_area_level_4", 8),
        v("administrative_area_level_5", 9),
        v("colloquial_area", 10),
        v("locality", 11),
        v("sublocality", 12),
        v("sublocality_level_1", 13),
        v("sublocality_level_2", 14),
        v("sublocality_level_3", 15),
        v("sublocality_level_4", 16),
        v("sublocality_level_5", 17),
        v("neighborhood", 18),
        v("premise", 19),
        v("subpremise", 20),
        v("postal_code", 21),
        v("natural_feature", 22),
        v("airport", 23),
        v("park", 24),
        v("post_box", 25),
        v("street_number", 26),
        v("floor", 27),
        v("room", 28),
        v("establishment", 29),
        v("point_of_interest", 30),
        v("parking", 31),
        v("postal_town", 32),
        v("bus_station", 33),
        v("train_station", 34),
        v("transit_station", 35),
        v("postal_code_suffix", 36)
    ]), wCn = ed(yCn), xCn = function(n) {
        return A2(xc, 37, A2(ra, n, wCn));
    }, _Cn = A2(qc, au, xCn), CCn = A2(nu, _Cn, M$), ACn = ek(CCn), kCn = A3(nk, "types", ACn, A3(nk, "short_name", M$, A3(nk, "long_name", M$, au(hCn)))), ECn = A3(nk, "types", ek(M$), A3(nk, "place_id", M$, A3(nk, "name", M$, A3(nk, "formatted_address", M$, A3(nk, "address_components", ek(kCn), au(gCn)))))), qCn = function(n) {
        switch(n.$){
            case 0:
                return Mwn(0);
            case 1:
                return "Address Line 2";
            case 2:
                return Mwn(1);
            case 3:
                return Mwn(2);
            case 4:
                return Mwn(3);
            default:
                return Mwn(4);
        }
    }, FCn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    zQ: n.a
                });
            case 1:
                return m(r, {
                    zR: n.a
                });
            case 2:
                return m(r, {
                    oE: n.a
                });
            case 3:
                return m(r, {
                    x6: n.a
                });
            case 4:
                return m(r, {
                    zF: n.a
                });
            default:
                return m(r, {
                    AS: n.a
                });
        }
    }), jCn = function(n) {
        return m(n, {
            cq: !0
        });
    }, DCn = Xn("googlePlacesPredictAddress", function(n) {
        return rx(w([
            v("address", tx(n.m9)),
            v("id", tx(n.sl))
        ]));
    }), VCn = F2(function(n, r) {
        return {
            sl: r,
            vT: n
        };
    }), BCn = function(n) {
        return n.vT;
    }, GCn = Xn("googlePlacesPredictionDetails", function(n) {
        return rx(w([
            v("id", tx(n.sl)),
            v("placeId", tx(n.vT))
        ]));
    }), zCn = F2(function(n, r) {
        var t, e = r.$ ? Qp : (t = A2(VCn, BCn(r.a), n.sl), GCn(t));
        return v(m(n, {
            cq: !1
        }), e);
    }), SCn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, TCn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, PCn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ZCn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, MCn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, LCn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, NCn = F2(function(n, r) {
        return A2(Op, function(n) {
            return n.tn;
        }, mb(A2(no, function(n) {
            return A2(Xk, r, n.Gt);
        }, n.kE)));
    }), HCn = F2(function(n, r) {
        return iL(r) ? n : r;
    }), ICn = F2(function(n, r) {
        return A2(Op, function(n) {
            return n.xu;
        }, mb(A2(no, function(n) {
            return A2(Xk, r, n.Gt);
        }, n.kE)));
    }), OCn = F2(function(n, r) {
        return A3(cN, FCn, ZCn(function(n) {
            return A2(xc, "", A2(NCn, n, 4));
        }(n)), A3(cN, FCn, LCn(function(n) {
            return A2(xc, "", A2(NCn, n, 21));
        }(n)), A3(cN, FCn, MCn(function(n) {
            return A2(xc, "", A2(ICn, n, 5));
        }(n)), A3(cN, FCn, PCn(function(n) {
            return A2(HCn, A2(xc, "", A2(NCn, n, 12)), A2(xc, "", A2(NCn, n, 11)));
        }(n)), A3(cN, FCn, TCn(""), A3(cN, FCn, SCn(n.ur), r))))));
    }), QCn = function(n) {
        return n.m9.nM;
    }, RCn = function(n) {
        return n.m9.nV;
    }, UCn = function(n) {
        return n.m9.oE;
    }, KCn = function(n) {
        return n.m9.AS;
    }, WCn = function(n) {
        return n.m9.s4;
    }, XCn = function(n) {
        return n.m9.CO;
    }, YCn = function(n) {
        return n.m9.s5;
    }, JCn = function(n) {
        return n.m9.CP;
    }, nAn = function(n) {
        return n.m9.tp;
    }, rAn = function(n) {
        return n.m9.tq;
    }, tAn = function(n) {
        return n.m9.ur;
    }, eAn = function(n) {
        return n.m9.Ff;
    }, uAn = function(n) {
        return n.m9.x6;
    }, aAn = function(n) {
        return n.m9.FY;
    }, iAn = function(n) {
        return n.m9.FZ;
    }, cAn = function(n) {
        return n.m9.zF;
    }, oAn = function(n) {
        return n.m9.zG;
    }, fAn = function(n) {
        return n.m9.GP;
    }, sAn = F2(function(n, r) {
        return n && iL(r.zQ) ? w([
            v(0, nL(A2(YM, rL, tAn)))
        ]) : g;
    }), lAn = F2(function(n, r) {
        return n && iL(r.oE) ? w([
            v(1, nL(A2(YM, rL, UCn)))
        ]) : g;
    }), dAn = F2(function(n, r) {
        return n && iL(r.AS) ? w([
            v(4, nL(A2(YM, rL, KCn)))
        ]) : g;
    }), vAn = function(n) {
        return 2 === lu(n) ? Am(n) : Um("State abbreviation is invalid.");
    }, bAn = A2(Cm, A2(Cm, Am(!0), A2(ym, vAn, Jm(Im(xe)))), fp), mAn = F2(function(n, r) {
        var t = r.x6;
        return iL(t) ? n ? w([
            v(2, nL(A2(YM, rL, uAn)))
        ]) : g : function(n) {
            return !A2($p, bAn, n).$;
        }(t) ? g : w([
            v(2, fL(aAn)),
            v(2, fL(iAn))
        ]);
    }), pAn = F2(function(n, r) {
        return i(lu(r), n) ? Am(r) : Um("ZIP code is invalid.");
    }), $An = function(n) {
        return A2(ym, pAn(n), Jm(Im(_e)));
    }, gAn = A2(Cm, A2(Cm, A2(Cm, A2(Cm, Am(!0), $An(5)), HZ("-")), $An(4)), fp), hAn = A2(Cm, A2(Cm, Am(!0), $An(5)), fp), yAn = function(n) {
        return !A2($p, hAn, n).$ || !A2($p, gAn, n).$;
    }, wAn = F2(function(n, r) {
        return nE(r) || A2(Xk, A2(pu, 5, n), r);
    }), xAn = F2(function(n, r) {
        return !mu(n) && yAn(n) && !A2(wAn, n, r);
    }), _An = F3(function(n, r, t) {
        var e = t.zF;
        return iL(e) ? r ? w([
            v(3, nL(A2(YM, rL, cAn)))
        ]) : g : yAn(e) ? n.$ && A2(xAn, e, n.a) ? w([
            v(3, fL(oAn))
        ]) : g : w([
            v(3, fL(fAn))
        ]);
    }), CAn = F2(function(n, r) {
        return XM(w([
            sAn(n),
            lAn(n),
            mAn(n),
            A2(_An, r, n),
            dAn(n)
        ]));
    }), AAn = function(n) {
        var r = A2(CL, A2(CAn, n.wZ, n.cO), n.le);
        return r.$ ? v(r.a, !1) : v(r.a.a, !0);
    }, kAn = function(n) {
        switch(n.$){
            case 0:
                return It(0);
            case 1:
                return Ot;
            case 2:
                return It(1);
            case 3:
                return It(2);
            case 4:
                return It(3);
            default:
                return It(4);
        }
    }, EAn = F2(function(n, r) {
        var t = kAn(n);
        if (t.$) return r;
        var e = t.a, u = A3(fN, !0, e, r.A), a = m(r, {
            A: u
        });
        return A2(oN, e, u) ? m(a, {
            le: AAn(r).a
        }) : a;
    }), qAn = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A;
        return m(r, {
            le: AAn(r).a,
            A: t
        });
    }), FAn = F2(function(n, r) {
        var t = kAn(n);
        if (t.$) return r;
        var e = t.a;
        if (A2(EL, e, r.A)) {
            var u = A3(qL, !0, e, r.A);
            return m(r, {
                le: AAn(r).a,
                A: u
            });
        }
        return r;
    }), jAn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(EAn, p = n.a, m(r, {
                    le: A3(cN, FCn, p, r.le)
                })), e = It(sCn(qCn(p))), u = function() {
                    switch(p.$){
                        case 0:
                            var n = p.a, r = iL(n) ? v(!1, g) : v(!0, t.bP), e = r.a, u = r.b, a = A3(Xnn, bCn, n, t.cy), i = a.b;
                            return v(m(t, {
                                cy: a.a,
                                cq: e,
                                bP: u
                            }), i);
                        case 4:
                            return v(A2(FAn, p, t), Qp);
                        default:
                            return v(t, Qp);
                    }
                }();
                return b(o = u.a, w = u.b, e);
            case 2:
                return b(jCn(r), Qp, Ot);
            case 4:
                var a = n.a.m9;
                if (i(n.a.sl, r.sl)) {
                    if ((f = A2(i$, ECn, a)).$) return b(r, Qp, Ot);
                    var c = f.a, o = A2(qAn, !0, m(r, {
                        le: A2(OCn, c, r.le)
                    }));
                    return b(m(o, {
                        jp: It(c)
                    }), Qp, Ot);
                }
                return b(r, Qp, Ot);
            case 3:
                var f, s = n.a.bP;
                return i(n.a.sl, r.sl) ? b(m(r, (f = A2(WA, $Cn, s)).$ ? {
                    bP: g
                } : {
                    bP: f.a
                }), Qp, Ot) : b(r, Qp, Ot);
            case 1:
                var l = n.a;
                return b(o = function() {
                    switch(l){
                        case 27:
                        case 38:
                        case 13:
                            return lCn(r);
                        case 40:
                            return jCn(r);
                        default:
                            return r;
                    }
                }(), Qp, Ot);
            case 5:
                var d = A2(zCn, r, n.a);
                return b(o = d.a, w = d.b, It(sCn("Address")));
            case 8:
                var p = n.a, $ = (o = lCn(r), It(function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(qCn(p))));
                return b(4 === p.$ ? A2(FAn, p, o) : o, Qp, $);
            case 9:
                return b(r, Qp, It(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(qCn(p = n.a))));
            case 6:
                var h = n.a, y = A4(Gtn, bCn, Dtn(vCn), h, r.cy), w = y.b;
                return b(m(r, {
                    cy: y.a
                }), w, Ot);
            default:
                return b(r, DCn(A2(fCn, n.a, r.sl)), Ot);
        }
    }), DAn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, VAn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, BAn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, GAn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zAn = function(n) {
        switch(n.$){
            case 0:
                return "Existing Coverage";
            case 1:
                return "Carrier";
            case 2:
                return "Carrier Alias Other";
            case 3:
                return "Group ID";
            case 4:
                return "Member ID";
            default:
                return "High Deductible";
        }
    }, SAn = function(n) {
        return n.aE.oi;
    }, TAn = function(n) {
        return n.aE.Ar;
    }, PAn = function(n) {
        return n.aE.ok;
    }, ZAn = function(n) {
        return n.aE.As;
    }, MAn = function(n) {
        return n.aE.ab;
    }, LAn = function(n) {
        return n.aE.BD;
    }, NAn = function(n) {
        return n.aE.rZ;
    }, HAn = function(n) {
        return n.aE.sf;
    }, IAn = function(n) {
        return n.aE.B9;
    }, OAn = function(n) {
        return n.aE.tD;
    }, QAn = function(n) {
        return n.aE.Fm;
    }, RAn = function(n) {
        return A2(bb, function(n) {
            return n.$ ? Ot : It(Iwn(n.a));
        }, n);
    }, UAn = function(n) {
        return n.oP;
    }, KAn = function(n) {
        return n.oU;
    }, WAn = XM(w([
        function(n) {
            var r = n.iz;
            return n.ab && OS(n.ak) && !r ? w([
                v(0, WL(SAn))
            ]) : g;
        },
        function(n) {
            var r = n.b7, t = n.ab, e = RAn(n.ak);
            if (e.$) return t && mu(r) ? w([
                v(2, WL(NAn))
            ]) : g;
            var u = e.a;
            return t && mu(r) && UAn(u) ? w([
                v(2, WL(NAn))
            ]) : g;
        },
        function(n) {
            var r = n.cd, t = n.ab, e = RAn(n.ak);
            if (e.$) return t && mu(r) ? w([
                v(3, WL(OAn))
            ]) : g;
            var u = e.a;
            return t && mu(r) && KAn(u) ? w([
                v(3, WL(OAn))
            ]) : g;
        },
        function(n) {
            var r = n.bX, t = n.ab;
            return RAn(n.ak).$ && t && mu(r) ? w([
                v(1, WL(PAn))
            ]) : g;
        }
    ])), XAn = function(n) {
        var r = A2(CL, WAn, n);
        return r.$ ? v(r.a, !1) : v(r.a.a, !0);
    }, YAn = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A, e = XAn(r.le), u = e.b;
        return v(m(r, {
            le: e.a,
            A: t
        }), u);
    }), JAn = function(n) {
        switch(n.$){
            case 0:
            default:
                return Ot;
            case 1:
                return It(0);
            case 2:
                return It(1);
            case 3:
                return It(2);
            case 4:
                return It(3);
        }
    }, nkn = F2(function(n, r) {
        var t = JAn(n);
        if (t.$) return r;
        var e = t.a;
        return A2(EL, e, r.A) ? m(A2(YAn, !1, r).a, {
            A: A3(qL, !0, e, r.A)
        }) : r;
    }), rkn = function(n) {
        return function(n) {
            return A2(Xk, sJ(n), w([
                "true",
                "t"
            ]));
        }(n) ? It(!0) : function(n) {
            return A2(Xk, sJ(n), w([
                "false",
                "f"
            ]));
        }(n) ? It(!1) : Ot;
    }, tkn = {
        F1: Atn(300),
        Gs: function(n) {
            return {
                $: 8,
                a: n
            };
        }
    }, ekn = function(n) {
        if (mu(n.yu)) return b(n, Qp, Ot);
        var r = A3(Xnn, tkn, "", n.hG), t = r.b;
        return b(m(n, {
            hG: r.a,
            Eg: !1,
            yu: ""
        }), t, Ot);
    }, ukn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, akn = function(n) {
        return A2(Nu, ukn, Au(n));
    }, ikn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ckn = function(n) {
        return A2(jc, ikn(n), sG(n));
    }, okn = F2(function(n, r) {
        var t = ekn(r), e = t.b;
        return b(m(t.a, {
            yu: A2(xc, "", A2(Op, r.dJ(Vx(0)), n))
        }), Uu(w([
            e,
            ckn(r.sl + "-input")
        ])), It(function(n) {
            return {
                $: 0,
                a: n
            };
        }(n)));
    }), fkn = F2(function(n, r) {
        switch(n.$){
            case 3:
                return b(r, 1 === (y = v(n.b, i(n.a, r.sl + "-item-active"))).a.$ && y.b ? ckn(r.sl + "-item") : Qp, Ot);
            case 0:
                return b(m(r, {
                    Eg: !r.Eg
                }), Qp, Ot);
            case 1:
            case 5:
                return ekn(r);
            case 2:
                switch(t = n.a){
                    case 27:
                    case 38:
                        return ekn(r);
                    case 40:
                        return b(function(n) {
                            return m(n, {
                                Eg: !0
                            });
                        }(r), ckn(r.sl + "-item-active"), Ot);
                    default:
                        return b(r, Qp, Ot);
                }
            case 6:
                var t, e = n.a;
                switch(t = n.b){
                    case 27:
                        var u = ekn(r), a = u.c;
                        return b(u.a, Uu(w([
                            u.b,
                            ckn(r.sl + "-input")
                        ])), a);
                    case 13:
                        return A2(okn, e, r);
                    default:
                        var c = FC(t);
                        return Ce(c) ? b(m(r, {
                            yu: eb((g = c, g.toLowerCase()))
                        }), ckn(r.sl + "-input"), Ot) : b(r, Qp, Ot);
                }
            case 4:
                return A2(okn, e = n.a, r);
            case 7:
                var o = n.b, f = (h = v(n.a, r.Eg)).a.$ || h.b ? o : s(lu(h.a.a), lu(o)) > 0 ? "" : A2(yb, 1, o), l = A3(Xnn, tkn, f, r.hG), d = l.b;
                return b(m(r, {
                    hG: l.a,
                    Eg: !0,
                    yu: f
                }), d, Ot);
            case 8:
                var p = n.a, $ = A4(Gtn, tkn, Dtn(akn), p, r.hG);
                return d = $.b, b(m(r, {
                    hG: $.a
                }), d, Ot);
            default:
                return b(r, Qp, It(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(o = n.a)));
        }
        var g, h, y;
    }), skn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = rkn(n.a);
                if (t.$) return b(r, Qp, g);
                var e = p_n(t.a);
                return b(m(r, {
                    le: A3(cN, $_n, e, r.le)
                }), Qp, w([
                    BAn(zAn(e))
                ]));
            case 1:
                var u = A2(fkn, n.a, r.eF), a = u.a, i = u.b, c = u.c, o = function() {
                    if (c.$) return b(r, Qp, g);
                    if (c.a.$) {
                        var n = c.a.a;
                        return b(m(r, {
                            fT: !0
                        }), A2(Xwn, r.g0, It(n)), g);
                    }
                    var t = function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(c.a.a);
                    return b(A2(YAn, !1, m(r, {
                        le: A3(cN, $_n, t, r.le)
                    })).a, Qp, w([
                        BAn(zAn(t))
                    ]));
                }(), f = o.b, s = o.c;
                return b(m(o.a, {
                    eF: a
                }), Uu(w([
                    A2(Wp, DAn, i),
                    f
                ])), s);
            case 2:
                return b(m(r, {
                    eG: n.a,
                    fT: !1
                }), Qp, g);
            case 3:
                var l = A3(cN, $_n, y = n.a, r.le), d = (c = BAn(zAn(y)), JAn(y));
                if (d.$) return b(m(r, {
                    le: l
                }), Qp, w([
                    c
                ]));
                var v = d.a, p = A3(fN, !0, v, r.A), $ = A2(oN, v, p) ? XAn(l).a : l;
                return b(m(r, {
                    le: $,
                    A: p
                }), Qp, w([
                    c
                ]));
            case 4:
                var h = rkn(n.a);
                return h.$ ? b(r, Qp, g) : (e = function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(h.a), b(m(r, {
                    le: A3(cN, $_n, e, r.le)
                }), Qp, w([
                    BAn(zAn(e))
                ])));
            case 6:
                return b(A2(nkn, y = n.a, r), Qp, w([
                    VAn(zAn(y))
                ]));
            default:
                var y;
                return b(r, Qp, w([
                    GAn(zAn(y = n.a))
                ]));
        }
    }), lkn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dkn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, vkn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), bkn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), mkn = function(n) {
        return n.sl;
    }, pkn = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), $kn = F4(function(n, r, t, e) {
        var u = A2(iN, e, t), a = u.a, i = u.b;
        return v(m(n, {
            vQ: A3(c9, a, r, n.vQ),
            N: A3(fN, !0, t, n.N)
        }), A2(Wp, A2(pkn, r, a), i));
    }), gkn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = n.c, u = mkn(f = n.b), a = function() {
                    switch(e.$){
                        case 0:
                            return v(A4($kn, r, t, f, e), function(n) {
                                return {
                                    $: 0,
                                    a: n
                                };
                            }(u));
                        case 1:
                            return v(A4($kn, r, t, f, e), function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(u));
                        case 2:
                            return v(A4($kn, r, t, f, e), function(n) {
                                return {
                                    $: 2,
                                    a: n
                                };
                            }(u));
                        case 3:
                            return v(v(r, A2(Nu, cu, Au(A2(vkn, t, f)))), lkn(u));
                        default:
                            return v(v(r, A2(Nu, cu, Au(A2(bkn, t, f)))), dkn(u));
                    }
                }(), i = a.a;
                return b(i.a, i.b, It(o = a.b));
            case 1:
                var c = function(n) {
                    return A2(E_n, Ot, n);
                }(r);
                return b(c.b, Qp, It(function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(c.a)));
            case 2:
                return t = n.a, u = mkn(f = n.b), b(A3(B_n, r, t, f), Qp, It(function(n) {
                    return {
                        $: 6,
                        a: n
                    };
                }(u)));
            case 3:
                var o = It(lkn(mkn(f = n.b)));
                return b(A2(EL, f, r.N) ? m(r, {
                    N: A3(qL, !0, f, r.N)
                }) : r, Qp, o);
            default:
                var f;
                return b(r, Qp, It(dkn(mkn(f = n.b))));
        }
    }), hkn = {
        $: 2
    }, ykn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wkn = {
        $: 1
    }, xkn = F2(function(n, r) {
        var t = A2(dG, n, r.fW), e = t.a, u = t.b, a = t.c, i = function() {
            if (a.$) return v(r.CK, Ot);
            switch(a.a.$){
                case 0:
                    var n = a.a.a;
                    return v(A2(xc, r.CK, n), A2(Op, ykn, n));
                case 1:
                    return v(r.CK, It(wkn));
                default:
                    return v(r.CK, It(hkn));
            }
        }(), c = i.b;
        return b(m(r, {
            CK: i.a,
            fW: e
        }), A2(Wp, cu, u), c);
    }), _kn = F2(function(n, r) {
        return A2(Op, function(n) {
            return v(Mwn(r), n);
        }, mb(A2(iH, r, n.le)));
    }), Ckn = function(n) {
        return A2(n$, function(r) {
            return A2(_kn, n, r);
        }, Zwn);
    }, Akn = function(n) {
        return A2(Fu, function(n) {
            return v(2, n.b);
        }, Ckn(n.m9));
    }, kkn = F2(function(n, r) {
        var t = r.qN;
        return iL(t) && n ? w([
            v(0, nL(A2(YM, rL, eL)))
        ]) : iL(t) || oL(t) ? g : w([
            v(0, fL(A2(YM, rL, eL)))
        ]);
    }), Ekn = F2(function(n, r) {
        return !A2(Wk, A2(qc, Bm, n), r);
    }), qkn = F2(function(n, r) {
        var t = j_n(n);
        return !t.$ && i(t.a, r);
    }), Fkn = F2(function(n, r) {
        return iL(r.EB) && n.wZ && A2(qkn, n.vQ, r) ? w([
            WL(rZ)
        ]) : A2(yL, r.EB, r.Fs) ? w([
            XL(rZ)
        ]) : g;
    }), jkn = F2(function(n, r) {
        return ve(A2(Fkn, n, r)) > 0;
    }), Dkn = F2(function(n, r) {
        return !A2(jkn, n, r.b);
    }), Vkn = F2(function(n, r) {
        return !$6(A2(s2, function(r) {
            return i(r.b.d8, n);
        }, r));
    }), Bkn = F2(function(n, r) {
        return r.sx(n);
    }), Gkn = function(n) {
        return A2(YM, Bkn, aZ(n));
    }, zkn = F2(function(n, r) {
        if (n.$) return g;
        var t = n.a;
        return A2(Vkn, t, r) ? g : w([
            nL(Gkn(t))
        ]);
    }), Skn = function(n) {
        return A2(s2, Dkn(n), A2(s2, function(n) {
            return !iL(zL(n.b));
        }, n.vQ));
    }, Tkn = function(n) {
        return n.wZ || Cz(n.d3) ? $6(n.vQ) ? w([
            WL(rZ)
        ]) : A2(zkn, n.d3, Skn(n)) : g;
    }, Pkn = function(n) {
        var r = A2(Qt, function(n) {
            return nE(Tkn(n));
        }(n), A2(h6, Dkn(n), n.vQ));
        return A2(Ekn, cu, r);
    }, Zkn = function(n) {
        return Pkn(n.vQ) ? g : w([
            v(1, nL(A2(YM, rL, eL)))
        ]);
    }, Mkn = function(n) {
        return n.b.w2;
    }, Lkn = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, R_n, Qxn(A2(qAn, n, t.m9)), r);
    }), Nkn = F2(function(n, r) {
        return m(r, {
            N: n ? DL(r.N) : r.N
        });
    }), Hkn = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, R_n, Kxn(A2(Nkn, n, t.vQ)), r);
    }), Ikn = F2(function(n, r) {
        var t = A2(Lkn, n, A2(Hkn, n, r.le)), e = FM(t), u = A2(YAn, n, e.a8), a = u.b, i = A3(cN, R_n, Uxn(u.a), t), c = A2(CL, function(n) {
            var r = Mkn(n.dV);
            return XM(w([
                kkn(r),
                Akn,
                Zkn
            ]));
        }(r), i);
        return c.$ ? v(c.a, !1) : v(c.a.a, a);
    }), Okn = F2(function(n, r) {
        var t = function(n) {
            switch(n.$){
                case 1:
                    return It(0);
                case 2:
                    return It(1);
                case 0:
                    return It(2);
                default:
                    return Ot;
            }
        }(n);
        if (t.$) return r;
        var e = t.a, u = A3(fN, !0, e, r.A), a = m(r, {
            A: u
        });
        return A2(oN, e, u) ? m(a, {
            le: A2(Ikn, !1, r).a
        }) : a;
    }), Qkn = F2(function(n, r) {
        return A2(Okn, n, m(r, {
            le: A3(cN, R_n, n, r.le)
        }));
    }), Rkn = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A, e = A2(Ikn, n, r), u = e.b;
        return v(m(r, {
            le: e.a,
            A: t
        }), u);
    }), Ukn = F2(function(n, r) {
        switch(n.$){
            case 17:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = ux(r.dV);
                    return b(d = m(r, {
                        f2: It(e)
                    }), A4(Phn, r.g0, u, r.fy, Rxn), g);
                }
                return b(r, Qp, A2(Ik, 0, t));
            case 16:
                var a = n.a, i = v(a, r.f2);
                if (3 !== i.a.$ || i.b.$) return b(r, Qp, A2(Ik, 0, a));
                var c = i.a.a, o = (e = i.b.a, FM(r.le));
                return b(d = m(r, {
                    le: vZ(A4(Q_n, c, r.dV, e, o)),
                    vn: It(c)
                }), Qp, g);
            case 15:
                return b(A2(Qkn, n.a, r), Qp, g);
            case 12:
                var f = A2(Rkn, !0, r);
                return b(d = f.a, f.b ? oCn(d) : Qp, g);
            case 13:
                return b(r, A2(__, pa, Pa), g);
            case 14:
                var s = n.a;
                return 3 === s.$ ? b(m(r, {
                    vn: It(c = s.a)
                }), A2(__, pa, Pa), g) : b(r, Qp, A2(Ik, 0, s));
            case 11:
                var l = n.a;
                if (A2(EL, l, r.A)) {
                    var d, p = A3(qL, !0, l, r.A);
                    return b(m(d = A2(Rkn, !1, r).a, {
                        A: p
                    }), Qp, g);
                }
                return b(r, Qp, g);
            case 6:
                var $ = n.a, h = FM(r.le), y = A2(gkn, $, h.vQ), w = y.b;
                return b(m(r, {
                    le: A3(cN, R_n, Kxn(y.a), r.le)
                }), A2(Wp, Wxn, w), g);
            case 0:
                var x = n.a, _ = FM(r.le), C = A2(jAn, x, _.m9), A = C.b;
                return b(m(r, {
                    le: A3(cN, R_n, Qxn(C.a), r.le)
                }), A2(Wp, Nxn, A), g);
            case 5:
                x = n.a;
                var k = FM(r.le), E = A2(skn, x, k.a8), q = E.b;
                return b(m(r, {
                    le: A3(cN, R_n, Uxn(E.a), r.le)
                }), A2(Wp, Gwn, q), g);
            case 10:
            case 1:
            case 2:
            case 3:
            case 4:
            case 7:
            default:
                return b(r, Qp, g);
            case 8:
                x = n.a;
                var F = FM(r.le), j = A2(xkn, x, F.v9), D = j.b;
                return b(m(r, {
                    le: A3(cN, R_n, Xxn(j.a), r.le)
                }), A2(Wp, Yxn, D), g);
        }
    }), Kkn = {
        $: 12
    }, Wkn = {
        $: 13
    }, Xkn = function(n) {
        return n.Fj;
    }, Ykn = F2(function(n, r) {
        var t = ZV(Whn(r));
        return A2(zx, g, w([
            A2(Mx, w([
                Gx("text-support")
            ]), w([
                A2(UD, w([
                    Gx("link text-current"),
                    oV(x_(Pa))
                ]), w([
                    _d(n(ov.yx))
                ]))
            ])),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            A2(Mx, w([
                Gx("text-support")
            ]), w([
                A2(UD, w([
                    Gx("link text-current"),
                    oV(x_(Za({
                        sl: eyn(r)
                    })))
                ]), w([
                    t
                ]))
            ])),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            _d(n(ov.sq))
        ]));
    }), Jkn = cu, nEn = function(n) {
        return !n;
    }, rEn = {
        $: 2
    }, tEn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, eEn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, uEn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, aEn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, iEn = function(n) {
        return {
            $: 19,
            a: n
        };
    }, cEn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, oEn = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), fEn = function(n) {
        return function(n) {
            return {
                $: 12,
                a: n
            };
        }(n);
    }, sEn = function(n) {
        return function(n) {
            return {
                $: 13,
                a: n
            };
        }(n);
    }, lEn = {
        Bb: !1
    }, dEn = F2(function(n, r) {
        return m(r, {
            Bb: n
        });
    }), vEn = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), bEn = F2(function(n, r) {
        switch(r){
            case 0:
                return n + "-address";
            case 1:
                return n + "-city";
            case 2:
                return n + "-state";
            case 3:
                return n + "-zip";
            default:
                return n + "-country";
        }
    }), mEn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pEn = F3(function(n, r, t) {
        return t + ", please contact " + n + (r.$ ? "." : " or " + r.a + ".");
    }), $En = A2(tE, rE(2), Ot), gEn = function(n) {
        switch(n){
            case 0:
                return "message-box--error";
            case 1:
                return "message-box--info";
            default:
                return "message-box--warning";
        }
    }, hEn = function(n) {
        switch(n){
            case 0:
                return 8;
            case 1:
                return 5;
            default:
                return 4;
        }
    }, yEn = {
        eA: 0,
        Dy: Ot
    }, wEn = F2(function(n, r) {
        return m(r, n.$ ? {
            Dy: It(n.a)
        } : {
            eA: n.a
        });
    }), xEn = function(n) {
        return "[" + n + "](mailto:" + n + ")";
    }, _En = F2(function(n, r) {
        for(;;){
            var t = mb(n);
            if (t.$) return r;
            var e = t.a, u = A3(N_, e, xEn(e), r), a = zK(n);
            if (a.$) return u;
            n = a.a, r = u;
        }
    }), CEn = function(n) {
        if (n.$) return vE;
        var r = n.a;
        return A2(yF, w([
            Yj,
            Kj(w([
                Gx("flex message-box__close"),
                Rj("button")
            ])),
            cF(r)
        ]), w([
            A2(Tq, w([
                Xj
            ]), 2)
        ]));
    }, AEn = F3(function(n, r, t) {
        var e = A2(xc, w([
            vE
        ]), A2(Op, function(n) {
            var r, t;
            return WH((t = A2(no, oL, Lan(r = n)), A2(_En, A4(KG, cu, OG, t, g), r)));
        }, r)), u = A3(de, wEn, yEn, n);
        return A2(Kk, w([
            Hx(w([
                Gx("message-box w-full flex mb-4 " + gEn(u.eA))
            ]))
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("flex")
                ]))
            ]), w([
                A2(Tq, w([
                    Xj,
                    MN($En),
                    MN(Xmn)
                ]), hEn(u.eA))
            ])),
            A2(Kk, w([
                Hx(w([
                    Gx("flex flex-shrink flex-col")
                ]))
            ]), w([
                A2(f_, w([
                    Hx(w([
                        Gx("message-box__title")
                    ]))
                ]), e),
                A2(Kk, w([
                    Hx(w([
                        Gx("message-box__content")
                    ])),
                    nF
                ]), w([
                    t
                ]))
            ])),
            CEn(u.Dy)
        ]));
    }), kEn = F3(function(n, r, t) {
        if (t.$) {
            var e = t.b, u = t.c;
            if (A2(xAn, r, t.a)) {
                var a = n(oAn), i = w([
                    mEn(0)
                ]), c = A3(pEn, e, u, "We're sorry but we do not have coverage in your area yet. To get more information");
                return A2(Kk, w([
                    uE(jvn)
                ]), w([
                    A3(AEn, i, It(a), A2(Kk, g, w([
                        _d(c)
                    ])))
                ]));
            }
            return vE;
        }
        return vE;
    }), EEn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, qEn = function(n) {
        return v(BCn(n), A2(cz, $(TV, w([
            Gx("select__item"),
            A2(lF, "role", "option"),
            vz(EEn(It(n)))
        ])), w([
            A2(Tq, w([
                zE,
                Wj("fill-gray")
            ]), 11),
            _d(n.p8)
        ])));
    }, FEn = F2(function(n, r) {
        return A2(bE, n && !nE(r), A3(gz, "div", w([
            Gx("select__items")
        ]), A2(Fu, qEn, r)));
    }), jEn = F3(function(n, r, t) {
        var e = A3(de, dEn, lEn, r), u = FM(t.le), a = u.zQ, i = u.zR, c = u.oE, o = u.x6, f = u.zF, s = u.AS;
        return A2(Kk, w([
            Hx(w([
                Gx("address-input"),
                DF(t.sl)
            ]))
        ]), w([
            A2(BE, w([
                VN(w([
                    Gx("-mx-1")
                ]))
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(EH, w([
                        vH(n(WCn)),
                        gH(t.wZ),
                        cEn(n(XCn))
                    ]), w([
                        A2(Kk, w([
                            Hx(w([
                                Gx("select")
                            ]))
                        ]), w([
                            PI(w([
                                NI(A2(bEn, t.sl, 0)),
                                OI(a),
                                iEn(!1),
                                HI(A2(qc, uEn, SCn)),
                                fEn(rEn),
                                yI(A3(vEn, t.le, t.A, 0)),
                                pI(e.Bb),
                                _I(eEn(SCn(a))),
                                CI(aEn(SCn(a))),
                                sEn(tEn),
                                FI(!0)
                            ])),
                            A2(FEn, t.cq, t.bP)
                        ])),
                        A2(YH, n, A3(oEn, t.le, t.A, 0))
                    ]))
                ]))
            ])),
            A2(BE, w([
                VN(w([
                    Gx("-mx-1")
                ]))
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(EH, w([
                        vH(n(YCn)),
                        cEn(n(JCn))
                    ]), w([
                        PI(w([
                            OI(i),
                            $O("address-line2"),
                            pO("address-line2"),
                            HI(A2(qc, uEn, TCn)),
                            pI(e.Bb),
                            FI(!0),
                            _I(eEn(TCn(i))),
                            CI(aEn(TCn(i)))
                        ]))
                    ]))
                ]))
            ])),
            A2(BE, w([
                VN(w([
                    Gx("-mx-1")
                ])),
                xN(JI)
            ]), w([
                A2(lE, w([
                    TE(4),
                    VN(w([
                        Gx("flex")
                    ]))
                ]), w([
                    A2(EH, w([
                        vH(n(UCn)),
                        gH(t.wZ)
                    ]), g)
                ])),
                A2(lE, w([
                    TE(4),
                    VN(w([
                        Gx("flex")
                    ]))
                ]), w([
                    A2(EH, w([
                        vH(n(uAn)),
                        gH(t.wZ)
                    ]), g)
                ])),
                A2(lE, w([
                    TE(4),
                    VN(w([
                        Gx("flex")
                    ]))
                ]), w([
                    A2(EH, w([
                        vH(n(cAn)),
                        gH(t.wZ)
                    ]), g)
                ]))
            ])),
            A2(BE, w([
                VN(w([
                    Gx("-mx-1")
                ]))
            ]), w([
                A2(lE, w([
                    TE(4)
                ]), w([
                    PI(w([
                        NI(A2(bEn, t.sl, 1)),
                        OI(c),
                        $O("address-level2"),
                        pO("address-level2"),
                        HI(A2(qc, uEn, PCn)),
                        yI(A3(vEn, t.le, t.A, 1)),
                        pI(e.Bb),
                        FI(!0),
                        _I(eEn(PCn(c))),
                        CI(aEn(PCn(c)))
                    ]))
                ])),
                A2(lE, w([
                    TE(4)
                ]), w([
                    PI(w([
                        NI(A2(bEn, t.sl, 2)),
                        OI(o),
                        $O("address-level1"),
                        pO("address-level1"),
                        HI(A2(qc, uEn, MCn)),
                        yI(A3(vEn, t.le, t.A, 2)),
                        pI(e.Bb),
                        FI(!0),
                        _I(eEn(MCn(o))),
                        CI(aEn(MCn(o)))
                    ]))
                ])),
                A2(lE, w([
                    TE(4)
                ]), w([
                    PI(w([
                        NI(A2(bEn, t.sl, 3)),
                        OI(f),
                        $O("postal-code"),
                        pO("postal-code"),
                        HI(A2(qc, uEn, LCn)),
                        yI(A3(vEn, t.le, t.A, 3)),
                        pI(e.Bb),
                        FI(!0),
                        _I(eEn(LCn(f))),
                        CI(aEn(LCn(f)))
                    ]))
                ])),
                A2(lE, w([
                    TE(4)
                ]), w([
                    A2(YH, n, A3(oEn, t.le, t.A, 1))
                ])),
                A2(lE, w([
                    TE(4)
                ]), w([
                    A2(YH, n, A3(oEn, t.le, t.A, 2))
                ])),
                A2(lE, w([
                    TE(4)
                ]), w([
                    A2(YH, n, A3(oEn, t.le, t.A, 3))
                ]))
            ])),
            A2(BE, w([
                VN(w([
                    Gx("-mx-1")
                ])),
                xN(JI)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(EH, w([
                        vH(n(KCn)),
                        gH(t.wZ)
                    ]), w([
                        PI(w([
                            NI(A2(bEn, t.sl, 4)),
                            OI(s),
                            $O("country-name"),
                            pO("country-name"),
                            HI(A2(qc, uEn, ZCn)),
                            yI(A3(vEn, t.le, t.A, 4)),
                            pI(e.Bb),
                            FI(!0),
                            _I(eEn(ZCn(s))),
                            CI(aEn(ZCn(s)))
                        ])),
                        A2(YH, n, A3(oEn, t.le, t.A, 4)),
                        A3(kEn, n, f, t.cO)
                    ]))
                ]))
            ]))
        ]));
    }), DEn = F3(function(n, r, t) {
        var e = FM(t.le).m9, u = t.f2;
        return u.$ || nEn(Jxn(u.a)) ? vE : A2(zx, w([
            Gx("mb-6")
        ]), w([
            A2(c_, Nxn, A3(jEn, n, w([
                Jkn(r)
            ]), e))
        ]));
    }), VEn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, BEn = function(n) {
        return n.cH.rA;
    }, GEn = function(n) {
        return n.cH.Cv;
    }, zEn = function(n) {
        return n.cH.sV;
    }, SEn = function(n) {
        return n.cH.ue;
    }, TEn = function(n) {
        return n.cH.ym;
    }, PEn = function(n) {
        return n.cH.yx;
    }, ZEn = cu, MEn = ov.Bb, LEn = {
        $: 3
    }, NEn = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), HEn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, IEn = w([
        0,
        1,
        2,
        3,
        4,
        5
    ]), OEn = {
        Bb: !1
    }, QEn = F2(function(n, r) {
        return m(r, {
            Bb: n
        });
    }), REn = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), UEn = F3(function(n, r, t) {
        var e = A3(de, QEn, OEn, r), u = FM(t.le).yx;
        return A2(zx, w([
            Gx("title-input"),
            DF(t.sl)
        ]), w([
            A2(zx, w([
                Gx("select")
            ]), w([
                A2(c_, cu, A4(qz, n, w([
                    XG(u),
                    HG(n(pL)),
                    SG,
                    CO(e.Bb),
                    HEn(A3(REn, t.le, t.A, 0))
                ]), A2(Fu, function(n) {
                    return A2(MG, g, n);
                }, IEn), t.gb))
            ])),
            A2(YH, n, A3(NEn, t.le, t.A, 0))
        ]));
    }), KEn = F3(function(n, r, t) {
        var e = FM(t.le), u = e.an, a = e.oD, i = e.oz, c = e.oB, o = e.oA, f = e.oC;
        return A2(zx, g, w([
            A2(BE, w([
                xN(aF)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(hW, n(MEn), A2(fI, w([
                        eI(u),
                        rI(r)
                    ]), w([
                        _d(n(GEn))
                    ])))
                ]))
            ])),
            A2(bE, u, A2(BE, g, w([
                A2(lE, w([
                    tO(2),
                    VN(w([
                        Gx("mb-4 sm:mb-0")
                    ]))
                ]), w([
                    A2(EH, w([
                        vH(n(PEn)),
                        LEn
                    ]), w([
                        A2(hW, n(MEn), A2(c_, VEn, A3(UEn, n, w([
                            ZEn(r)
                        ]), a)))
                    ]))
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(EH, w([
                        vH(n(BEn)),
                        LEn
                    ]), w([
                        A2(hW, n(MEn), PI(w([
                            OI(i),
                            pI(r),
                            FI(!0)
                        ])))
                    ]))
                ])),
                A2(lE, w([
                    TE(3),
                    tO(2)
                ]), w([
                    A2(EH, w([
                        vH(n(SEn)),
                        LEn
                    ]), w([
                        A2(hW, n(MEn), PI(w([
                            OI(c),
                            pI(r),
                            FI(!0)
                        ])))
                    ]))
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(EH, w([
                        vH(n(zEn)),
                        LEn
                    ]), w([
                        A2(hW, n(MEn), PI(w([
                            OI(o),
                            pI(r),
                            FI(!0)
                        ])))
                    ]))
                ])),
                A2(lE, w([
                    TE(3),
                    tO(2)
                ]), w([
                    A2(EH, w([
                        vH(n(TEn)),
                        LEn
                    ]), w([
                        A2(hW, n(MEn), PI(w([
                            OI(f),
                            pI(r),
                            FI(!0)
                        ])))
                    ]))
                ]))
            ])))
        ]));
    }), WEn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, XEn = F3(function(n, r, t) {
        var e = FM(t.le).bq;
        return A2(zx, g, w([
            A2(BE, g, w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(EH, w([
                        vH(n(JM))
                    ]), w([
                        A2(hW, n(MEn), A2(c_, WEn, A3(ZI, n, w([
                            dI(r)
                        ]), e)))
                    ]))
                ]))
            ]))
        ]));
    }), YEn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, JEn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, nqn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, rqn = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), tqn = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), eqn = F3(function(n, r, t) {
        var e = FM(t.le).qN;
        return A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(eL)),
                    gH(Mkn(t.dV))
                ]), w([
                    PI(w([
                        NI("Email"),
                        OI(e),
                        HI(A2(qc, nqn, YEn)),
                        yI(A3(tqn, t.le, t.A, 0)),
                        pI(r),
                        _I(JEn(0)),
                        FI(!0)
                    ])),
                    A2(YH, n, A3(rqn, t.le, t.A, 0))
                ]))
            ]))
        ]));
    }), uqn = function(n) {
        return n.b.yN;
    }, aqn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, iqn = cu, cqn = w([
        0,
        1,
        2
    ]), oqn = {
        $: 2
    }, fqn = {
        $: 3
    }, sqn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lqn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dqn = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), vqn = F2(function(n, r) {
        return !r.$ && n(r.a);
    }), bqn = {
        Bb: !1,
        EC: z4
    }, mqn = F2(function(n, r) {
        return m(r, {
            Bb: n
        });
    }), pqn = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), $qn = F4(function(n, r, t, e) {
        var u = A3(de, mqn, bqn, r), a = A2(Fu, function(n) {
            return A2(MG, g, n);
        }, t), i = FM(e.le), c = i.fZ, o = i.dU;
        return A2(zx, w([
            Gx("gender-input"),
            DF(e.sl)
        ]), w([
            A2(zx, w([
                Gx("select"),
                Oq(w([
                    v("mb-4", A2(vqn, e.CD, c))
                ]))
            ]), w([
                A2(c_, lqn, A4(qz, n, w([
                    XG(c),
                    HG(n(u.EC)),
                    SG,
                    CO(u.Bb),
                    HEn(A3(pqn, e.le, e.A, 0)),
                    iY(!0)
                ]), a, e.gd)),
                A2(YH, n, A3(dqn, e.le, e.A, 0))
            ])),
            A2(bE, A2(vqn, e.CD, c), A2(zx, g, w([
                PI(w([
                    OI(o),
                    HI(sqn),
                    yI(A3(pqn, e.le, e.A, 1)),
                    pI(u.Bb),
                    _I(oqn),
                    CI(fqn),
                    FI(!0)
                ])),
                A2(YH, n, A3(dqn, e.le, e.A, 1))
            ])))
        ]));
    }), gqn = F3(function(n, r, t) {
        var e = FM(t.le).rU;
        return A2(BE, w([
            xN(JI)
        ]), w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(Swn.sT))
                ]), w([
                    A2(c_, aqn, A4($qn, n, w([
                        iqn(r)
                    ]), cqn, e))
                ]))
            ]))
        ]));
    }), hqn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, yqn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, wqn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, xqn = cu, _qn = w([
        1,
        0,
        2,
        3,
        4,
        5
    ]), Cqn = w([
        1,
        0,
        2,
        3
    ]), Aqn = w([
        0,
        1,
        2
    ]), kqn = {
        Bb: !1
    }, Eqn = F2(function(n, r) {
        return m(r, {
            Bb: n
        });
    }), qqn = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), Fqn = F3(function(n, r, t) {
        var e = A3(de, Eqn, kqn, r), u = FM(t.le).xt;
        return A2(zx, w([
            Gx("select")
        ]), w([
            A2(c_, cu, A4(qz, n, w([
                XG(u),
                HG(n(z4)),
                SG,
                CO(e.Bb),
                HEn(A3(qqn, t.le, t.A, 0)),
                iY(!0)
            ]), A2(Fu, function(n) {
                return A2(MG, g, n);
            }, Aqn), t.f0))
        ]));
    }), jqn = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), Dqn = F2(function(n, r) {
        return A2(YH, n, A3(jqn, r.le, r.A, 0));
    }), Vqn = F3(function(n, r, t) {
        var e = FM(t.le), u = e.xt, a = e.rV, i = e.wm;
        return A2(BE, w([
            xN(JI)
        ]), w([
            A2(lE, w([
                TE(4)
            ]), w([
                A2(EH, w([
                    vH(n(Lyn.sT))
                ]), w([
                    A2(hW, n(MEn), A2(c_, wqn, A3(Fqn, n, w([
                        xqn(r)
                    ]), u)))
                ])),
                A2(Dqn, n, u)
            ])),
            A2(lE, w([
                TE(4)
            ]), w([
                A2(EH, w([
                    vH(n(Tyn.sT))
                ]), w([
                    A2(hW, n(MEn), A2(c_, hqn, A4($qn, n, w([
                        iqn(r)
                    ]), _qn, a)))
                ]))
            ])),
            A2(lE, w([
                TE(4)
            ]), w([
                A2(EH, w([
                    vH(n(Zyn.sT))
                ]), w([
                    A2(hW, n(MEn), A2(c_, yqn, A4($qn, n, w([
                        iqn(r)
                    ]), Cqn, i)))
                ]))
            ]))
        ]));
    }), Bqn = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("mb-6")
        ]), w([
            uqn(t.dV) ? A3(Vqn, n, r, t) : A3(gqn, n, r, t)
        ]));
    }), Gqn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zqn = function(n) {
        return qX(n);
    }, Sqn = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, Tqn = function(n) {
        return n.ux;
    }, Pqn = function(n) {
        return n ? "True" : "False";
    }, Zqn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Mqn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Lqn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Nqn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Hqn = A2(qc, TG, Nqn), Iqn = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), Oqn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Qqn = {
        $: 1
    }, Rqn = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), Uqn = {
        $: 0
    }, Kqn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Wqn = {
        $: 5
    }, Xqn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Yqn = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Jqn = A2(Mx, w([
        Gx("select__arrow")
    ]), g), nFn = function(n) {
        if (1 === n.$) {
            var r = n.a;
            return A2(PE, w([
                sE
            ]), w([
                _d(r)
            ]));
        }
        return A2(PE, g, w([
            _d(r = n.a)
        ]));
    }, rFn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tFn = F4(function(n, r, t, e) {
        if (r.b) {
            var u = r.a, a = r.b;
            return A2(Qt, rFn(A3(du, n, u, e)), A2(Qt, function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(A3(du, u, u + t, e)), A4(tFn, u + t, a, t, e)));
        }
        return w([
            rFn(A3(du, n, lu(e), e))
        ]);
    }), eFn = F3(function(n, r, t) {
        return A2(Mx, g, A2(Fu, nFn, A4(tFn, 0, r, lu(n), t)));
    }), uFn = F2(function(n, r) {
        var t = A2(bu, sJ(n), sJ(r));
        return A3(eFn, n, t, r);
    }), aFn = F3(function(n, r, t) {
        return A2(uFn, n, r(t));
    }), iFn = {
        Bb: !1,
        e1: !1,
        Cr: !1,
        CR: !1,
        EC: "Pick an item",
        y4: Ot
    }, cFn = F2(function(n, r) {
        switch(n.$){
            case 2:
                return m(r, {
                    Bb: n.a
                });
            case 0:
                return m(r, {
                    y4: n.a
                });
            case 1:
                return m(r, {
                    EC: n.a
                });
            case 3:
                return m(r, {
                    Cr: n.a
                });
            case 4:
                return m(r, {
                    CR: n.a
                });
            default:
                return m(r, {
                    e1: !0
                });
        }
    }), oFn = function(n) {
        return w([
            vF(n.Bb),
            Oq(w([
                v("select--invalid", n.Cr),
                v("w-full", n.e1)
            ]))
        ]);
    }, fFn = F4(function(n, r, t, e) {
        var u = A3(de, cFn, iFn, r), a = A2(Op, e.dJ(n), u.y4), i = {
            Du: Wqn,
            DN: Yqn,
            DX: Xqn,
            Fr: e.sl,
            jo: u.y4,
            Gj: A2(aFn, e.yu, e.dJ(n)),
            Gk: e.ln
        };
        return A2(zx, w([
            Gx("select select--searchable"),
            Oq(w([
                v("select--open", e.Eg),
                v("select--loading", u.CR),
                v("w-full", u.e1)
            ])),
            DF(e.sl)
        ]), w([
            A2(sz, A2(Qt, Gx("select__input"), A2(Qt, qE(Uqn), A2(Qt, A2(gF, Qqn, e.sl), A2(Qt, mF(Kqn), A2(Qt, DF(e.sl + "-input"), A2(Qt, TH(A2(xc, u.EC, a)), A2(Qt, oz(function() {
                var r = v(u.y4, e.Eg);
                return r.a.$ || r.b ? e.yu : A2(e.dJ, n, r.a.a);
            }()), A2(Qt, SH(Rqn(a)), oFn(u))))))))), g),
            u.CR ? A2(Mx, w([
                Gx("select__spinner")
            ]), g) : Jqn,
            !u.Bb && e.Eg ? A3(gz, "div", w([
                Gx("select__items")
            ]), A2(Fu, $z(i), t)) : vE
        ]));
    }), sFn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, lFn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, dFn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, vFn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bFn = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), mFn = F2(function(n, r) {
        var t = FM(r.le).bX;
        return A2(BE, w([
            VN(w([
                Gx("-mx-1")
            ]))
        ]), w([
            A2(lE, g, w([
                A2(EH, w([
                    vH(n(PAn)),
                    gH(!0)
                ]), w([
                    PI(w([
                        OI(t),
                        HI(A2(qc, vFn, sFn)),
                        yI(A3(Iqn, r.le, r.A, 1)),
                        _I(lFn(sFn(t))),
                        CI(dFn(sFn(t)))
                    ]))
                ])),
                A2(YH, n, A3(bFn, r.le, r.A, 1))
            ]))
        ]));
    }), pFn = F2(function(n, r) {
        return A3(bFn, n.le, n.A, r);
    }), $Fn = F2(function(n, r) {
        var t, e = FM(r.le).ak, u = function() {
            var t = r.eG;
            if (3 === t.$) {
                var u = t.a, a = A2(Qt, Oqn(e), A2(Qt, Zqn(A3(Iqn, r.le, r.A, 0)), A2(Qt, Lqn(n(ZAn)), r.fT ? w([
                    Mqn(!0)
                ]) : g))), i = $(A2(Fu, function(n) {
                    return A2(MG, g, w_n(n));
                }, u), w([
                    A2(MG, g, x_n)
                ])), c = n(QAn);
                return v(a, $(i, w([
                    Hqn(c)
                ])));
            }
            return v(w([
                Lqn("Loading carriers..."),
                Mqn(!0)
            ]), g);
        }(), a = u.a, i = u.b;
        return A2(zx, g, w([
            A2(EH, w([
                vH(n(SAn)),
                gH(!0),
                vH(n(TAn))
            ]), w([
                A2(BE, w([
                    VN(w([
                        Gx("-mx-1")
                    ]))
                ]), w([
                    A2(lE, g, w([
                        A2(c_, DAn, A4(fFn, n, a, i, r.eF)),
                        A2(YH, n, A2(pFn, r, 0))
                    ]))
                ]))
            ])),
            A2(bE, (t = e, !t.$ && !!t.a.$), A2(mFn, n, r))
        ]));
    }), gFn = function(n) {
        return n.oQ;
    }, hFn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, yFn = F3(function(n, r, t) {
        var e = FM(t.le).b7;
        return A2(BE, w([
            VN(w([
                Gx("-mx-1")
            ]))
        ]), w([
            A2(lE, g, w([
                A2(EH, w([
                    vH(n(NAn)),
                    gH(!0)
                ]), w([
                    PI(w([
                        OI(e),
                        jI("321555 --- 000"),
                        HI(A2(qc, vFn, hFn)),
                        yI(A3(Iqn, t.le, t.A, 2)),
                        pI(r),
                        CI(dFn(hFn(e))),
                        _I(lFn(hFn(e)))
                    ]))
                ])),
                A2(YH, n, A2(pFn, t, 2))
            ]))
        ]));
    }), wFn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, xFn = function(n) {
        return n.zt;
    }, _Fn = F3(function(n, r, t) {
        var e = FM(t.le).sf;
        return A2(zx, g, w([
            A2(EH, w([
                vH(n(HAn)),
                gH(!0),
                cEn(n(IAn))
            ]), w([
                A2(BE, w([
                    VN(w([
                        Gx("-mx-1")
                    ]))
                ]), w([
                    A2(lE, w([
                        TE(6)
                    ]), w([
                        A2(VX, w([
                            CX,
                            zqn(e),
                            SX(wFn),
                            QX(Pqn(!0)),
                            Sqn(r)
                        ]), w([
                            _d(n(xFn))
                        ]))
                    ])),
                    A2(lE, w([
                        TE(6)
                    ]), w([
                        A2(VX, w([
                            CX,
                            zqn(!e),
                            SX(wFn),
                            QX(Pqn(!1)),
                            Sqn(r)
                        ]), w([
                            _d(n(Tqn))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), CFn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, AFn = F3(function(n, r, t) {
        var e = FM(t.le).cd;
        return A2(BE, w([
            VN(w([
                Gx("-mx-1")
            ]))
        ]), w([
            A2(lE, g, w([
                A2(EH, w([
                    vH(n(OAn)),
                    gH(!0)
                ]), w([
                    PI(w([
                        OI(e),
                        jI("EXF000099900"),
                        HI(A2(qc, vFn, CFn)),
                        yI(A3(Iqn, t.le, t.A, 3)),
                        pI(r),
                        CI(dFn(CFn(e))),
                        _I(lFn(CFn(e)))
                    ]))
                ])),
                A2(YH, n, A2(pFn, t, 3))
            ]))
        ]));
    }), kFn = F3(function(n, r, t) {
        var e = FM(t.le).ak, u = RAn(e), a = function() {
            var n = v(e, u);
            n: for(; !n.a.$;){
                if (1 === n.a.a.$) return b(!0, !0, !0);
                if (n.b.$) break n;
                var r = n.b.a;
                return b(UAn(r), KAn(r), gFn(r));
            }
            return b(!1, !1, !1);
        }(), i = a.b, c = a.c;
        return A2(zx, g, w([
            A2(bE, a.a, A3(yFn, n, r, t)),
            A2(bE, i, A3(AFn, n, r, t)),
            A2(bE, c, A3(_Fn, n, r, t))
        ]));
    }), EFn = F3(function(n, r, t) {
        return A2(zx, g, 3 === t.eG.$ ? w([
            A2($Fn, n, t),
            A3(kFn, n, r, t)
        ]) : Nx);
    }), qFn = F3(function(n, r, t) {
        var e = FM(t.le).ab;
        return A2(zx, g, w([
            A2(EH, w([
                vH(n(MAn)),
                gH(!0),
                cEn(n(LAn))
            ]), w([
                A2(BE, w([
                    VN(w([
                        Gx("-mx-1")
                    ]))
                ]), w([
                    A2(lE, w([
                        TE(6)
                    ]), w([
                        A2(VX, w([
                            CX,
                            zqn(e),
                            SX(Gqn),
                            QX(Pqn(!0)),
                            Sqn(r)
                        ]), w([
                            _d(n(xFn))
                        ]))
                    ])),
                    A2(lE, w([
                        TE(6)
                    ]), w([
                        A2(VX, w([
                            CX,
                            zqn(!e),
                            SX(Gqn),
                            QX(Pqn(!1)),
                            Sqn(r)
                        ]), w([
                            _d(n(Tqn))
                        ]))
                    ]))
                ]))
            ])),
            A2(bE, e, A3(EFn, n, r, t))
        ]));
    }), FFn = F3(function(n, r, t) {
        return A2(zx, g, w([
            A3(qFn, n, r, t)
        ]));
    }), jFn = F3(function(n, r, t) {
        var e = FM(t.le).a8;
        return A2(zx, w([
            Gx("mb-6")
        ]), w([
            A2(f_, w([
                uE(aF),
                qG,
                sE
            ]), w([
                _d(n(ov.r2))
            ])),
            A2(c_, Gwn, A3(FFn, n, r, e))
        ]));
    }), DFn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, VFn = F3(function(n, r, t) {
        var e = FM(t.le), u = e.yx, a = e.rA, i = e.ue, c = e.sV, o = e.ym;
        return A2(BE, g, w([
            A2(lE, w([
                tO(2),
                VN(w([
                    Gx("mb-4 sm:mb-0")
                ]))
            ]), w([
                A2(EH, w([
                    vH(n(mL))
                ]), w([
                    A2(hW, n(MEn), A2(c_, DFn, A3(UEn, n, w([
                        ZEn(r)
                    ]), u)))
                ]))
            ])),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(EH, w([
                    vH(n(lL))
                ]), w([
                    A2(hW, n(MEn), PI(w([
                        OI(a),
                        pI(r),
                        FI(!0)
                    ])))
                ]))
            ])),
            A2(lE, w([
                TE(3),
                tO(2)
            ]), w([
                A2(EH, w([
                    vH(n(vL))
                ]), w([
                    A2(hW, n(MEn), PI(w([
                        OI(i),
                        pI(r),
                        FI(!0)
                    ])))
                ]))
            ])),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(EH, w([
                    vH(n(dL))
                ]), w([
                    A2(hW, n(MEn), PI(w([
                        OI(c),
                        pI(r),
                        FI(!0)
                    ])))
                ]))
            ])),
            A2(lE, w([
                TE(3),
                tO(2)
            ]), w([
                A2(EH, w([
                    vH(n(bL)),
                    LEn
                ]), w([
                    A2(hW, n(MEn), PI(w([
                        OI(o),
                        pI(r),
                        FI(!0)
                    ])))
                ]))
            ]))
        ]));
    }), BFn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, GFn = {
        $: 1
    }, zFn = F2(function(n, r) {
        var t = A2(Wk, cu, A2(h6, function(n) {
            return A2(oN, n.b, r.N);
        }, r.vQ)), e = t ? Tkn(r) : g;
        if (t && ve(e) > 0) return A2(zx, w([
            Gx("mb-4 -mt-2 md:-mt-3")
        ]), w([
            A2(YH, n, e)
        ]));
        var u = v(t, r.d3);
        if (u.a || u.b.$) return vE;
        var a = u.b.a;
        return A2(zx, w([
            Gx("mb-4 -mt-2 md:-mt-3")
        ]), w([
            A2(f_, w([
                nF,
                VG
            ]), w([
                _d(n(Gkn(a)))
            ]))
        ]));
    }), SFn = {
        Bb: !1,
        jK: !1
    }, TFn = F2(function(n, r) {
        return m(r, n.$ ? {
            jK: n.a
        } : {
            Bb: n.a
        });
    }), PFn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ZFn = F2(function(n, r) {
        return A2(oN, r, n.N) ? A2(Fkn, n, r) : g;
    }), MFn = F2(function(n, r) {
        return A2(oN, r, n.N) && A2(jkn, n, r);
    }), LFn = F4(function(n, r, t, e) {
        var u = e.a, a = e.b;
        return v(a.sl, A2(zx, w([
            Gx("flex flex-col mb-4")
        ]), w([
            A2(c_, A2(pkn, u, a), A3(DO, n, w([
                oO(r),
                sO(A2(MFn, t, a))
            ]), a)),
            A2(zx, w([
                Gx("-mx-1")
            ]), w([
                A2(YH, n, A2(ZFn, t, a))
            ])),
            A2(bE, !A2(qkn, t.vQ, a), A2(yF, w([
                Yj,
                Kj(w([
                    Gx("text-primary-300 text-left p-0")
                ])),
                cF(A2(PFn, u, a))
            ]), w([
                _d("- "),
                _d(n(uZ))
            ])))
        ])));
    }), NFn = F3(function(n, r, t) {
        var e = A3(de, TFn, SFn, r);
        return A2(zx, w([
            Gx("phones-input"),
            DF(t.sl)
        ]), w([
            A3(gz, "div", g, A2(h6, A3(LFn, n, e.Bb, t), t.vQ)),
            A2(BE, w([
                xN(JI)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(zFn, n, t)
                ]))
            ])),
            e.jK ? vE : A2(BE, w([
                xN(JI)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(yF, w([
                        CD,
                        Lj(e.Bb),
                        Qj(e.Bb),
                        cF(GFn)
                    ]), w([
                        A2(Mx, g, w([
                            _d(n(JP))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), HFn = F3(function(n, r, t) {
        var e = FM(t.le).vQ;
        return A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(rZ)),
                    gH(e.wZ)
                ]), w([
                    A2(zx, w([
                        Gx("mx-1")
                    ]), w([
                        A2(c_, Wxn, A3(NFn, n, w([
                            BFn(r)
                        ]), e))
                    ]))
                ]))
            ]))
        ]));
    }), IFn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, OFn = function(n) {
        return n.v9;
    }, QFn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, RFn = QFn(0), UFn = F3(function(n, r, t) {
        var e = A3(de, F2(function(n, r) {
            return m(r, n.$ ? {
                mx: !0
            } : {
                Bb: n.a
            });
        }), {
            Bb: !1,
            mx: !1
        }, r);
        return A2(zx, w([
            DF(t.sl)
        ]), w([
            A2(c_, cu, A4(qz, n, A2(Qt, XG(It(t.CK)), A2(Qt, SG, A2(Qt, CO(e.Bb), e.mx ? w([
                RFn
            ]) : g))), A2(Fu, MG(g), w([
                0,
                1
            ])), t.fW))
        ]));
    }), KFn = F3(function(n, r, t) {
        var e = FM(t.le).v9;
        return A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(OFn))
                ]), w([
                    A2(c_, Yxn, A3(UFn, n, w([
                        IFn(r)
                    ]), e))
                ]))
            ]))
        ]));
    }), WFn = function(n) {
        return iL(n) ? "" : "***-**-" + A2(yb, 4, n);
    }, XFn = function(n) {
        return n.x_;
    }, YFn = F3(function(n, r, t) {
        var e = FM(t.le).x_;
        return A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(XFn))
                ]), w([
                    A2(hW, n(MEn), PI(w([
                        OI(WFn(e)),
                        pI(r)
                    ])))
                ]))
            ]))
        ]));
    }), JFn = F3(function(n, r, t) {
        return A2(zx, g, w([
            A3(VFn, n, !0, t),
            A3(KEn, n, !0, t),
            A3(XEn, n, !0, t),
            A3(Bqn, n, !0, t),
            A3(KFn, n, r, t),
            A3(YFn, n, !0, t),
            A3(eqn, n, r, t),
            A3(HFn, n, r, t),
            A3(DEn, n, r, t),
            A3(jFn, n, r, t)
        ]));
    }), njn = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("text-left")
        ]), w([
            A2(Ykn, n, t),
            s_,
            A2(i_, w([
                Hx(w([
                    Gx("mt-8 mb-8")
                ]))
            ]), w([
                _d(n(ov.sq))
            ])),
            A3(JFn, n, !1, r),
            A2(zx, g, w([
                A2(BE, g, w([
                    A2(lE, w([
                        TE(12),
                        tO(2),
                        VN(w([
                            Gx("mt-1")
                        ]))
                    ]), w([
                        A2(yF, w([
                            fF,
                            iK,
                            cF(Kkn)
                        ]), w([
                            _d(n(Xkn))
                        ]))
                    ])),
                    A2(lE, w([
                        TE(12),
                        tO(2),
                        VN(w([
                            Gx("mt-1")
                        ]))
                    ]), w([
                        A2(yF, w([
                            CD,
                            iK,
                            cF(Wkn)
                        ]), w([
                            _d(n(V4))
                        ]))
                    ])),
                    spn(w([
                        TE(12),
                        tO(8)
                    ]))
                ]))
            ]))
        ]));
    }), rjn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t = r.vn;
                    return t.$ ? Nx : w([
                        A3(njn, n, r, t.a)
                    ]);
                }())
            ]),
            yx: n(ov.yx)
        };
    }), tjn = C_({
        Cl: Zxn,
        CQ: Mxn,
        Fj: Lxn,
        F4: function() {
            return vx(w([
                A2(kj, Nxn, Oxn)
            ]));
        },
        Gv: Ukn,
        GB: rjn
    }), ejn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ujn = F3(function(n, r, t) {
        var e = t.Ep;
        return v({
            g0: r.g0,
            ld: r.ld,
            le: Ot,
            vn: Ot,
            dV: n,
            bJ: Ot
        }, A4(Phn, r.g0, ux(n), e.sl, ejn));
    }), ajn = F2(function(n, r) {
        return v(r, Qp);
    }), ijn = F2(function(n, r) {
        return r;
    }), cjn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ojn = function(n) {
        return {
            qS: n
        };
    }, fjn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sjn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ljn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, djn = {
        AB: function(n) {
            return n.a5.AB;
        },
        BZ: function(n) {
            return n.a5.BZ;
        },
        B0: function(n) {
            return n.a5.B0;
        },
        Dl: function(n) {
            return n.a5.Dl;
        },
        Ei: function(n) {
            return n.a5.Ei;
        },
        Eq: function(n) {
            return n.a5.Eq;
        },
        fW: function(n) {
            return n.a5.fW;
        },
        FM: function(n) {
            return n.a5.FM;
        },
        FU: function(n) {
            return n.a5.FU;
        }
    }, vjn = function(n) {
        switch(n.$){
            case 0:
                return "spouse";
            case 1:
                return "parent";
            case 2:
                return "child";
            case 3:
                return "sibling";
            case 4:
                return "grandparent";
            case 5:
                return "guardian";
            default:
                return "other";
        }
    }, bjn = function(n) {
        return Cd({
            sl: "emergency_contact-" + n + "relationship",
            Gj: F2(function(n, r) {
                return n(function(n) {
                    return (function() {
                        if (1 === n.$) return function(n) {
                            return n.Dl;
                        };
                        switch(n.a.$){
                            case 0:
                                return function(n) {
                                    return n.FU;
                                };
                            case 1:
                                return function(n) {
                                    return n.Eq;
                                };
                            case 2:
                                return function(n) {
                                    return n.AB;
                                };
                            case 3:
                                return function(n) {
                                    return n.FM;
                                };
                            case 4:
                                return function(n) {
                                    return n.BZ;
                                };
                            case 5:
                                return function(n) {
                                    return n.B0;
                                };
                            default:
                                return function(n) {
                                    return n.Ei;
                                };
                        }
                    })()(djn);
                }(r));
            }),
            Gk: Op(vjn)
        });
    }, mjn = function(n) {
        var r = exn(n);
        return A2(sjn, n, fjn(vZ({
            qN: "",
            rA: "",
            sV: "",
            ur: "",
            vO: r,
            wQ: Ot,
            d1: bjn(n)
        })));
    }, pjn = A2(tu, Yhn, function(n) {
        return n.rA;
    }), $jn = A2(tu, Yhn, function(n) {
        return n.sV;
    }), gjn = {
        $: 2
    }, hjn = {
        $: 4
    }, yjn = {
        $: 5
    }, wjn = {
        $: 1
    }, xjn = {
        $: 3
    }, _jn = {
        $: 0
    }, Cjn = F2(function(n, r) {
        if (r.$) return mjn(n);
        var t, e = r.a;
        return A2(sjn, n, fjn(vZ({
            qN: A2(xc, "", ryn(e)),
            rA: A2(xc, "", pjn(e)),
            sV: A2(xc, "", $jn(e)),
            ur: uyn(e),
            vO: (t = ayn(e), t.$ ? exn(n) : A2(cZ, n, iyn(t.a))),
            wQ: A2(Op, function(n) {
                var r = function(n) {
                    switch(n){
                        case "spouse":
                            return _jn;
                        case "parent":
                            return wjn;
                        case "child":
                            return gjn;
                        case "sibling":
                            return xjn;
                        case "grandparent":
                            return hjn;
                        case "guardian":
                            return yjn;
                        default:
                            return ljn(n);
                    }
                }(n);
                return 6 === r.$ ? ljn(A2(xc, n, nyn(e))) : r;
            }, Jhn(e)),
            d1: bjn(n)
        })));
    }), Ajn = {
        $: 1
    }, kjn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ejn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, qjn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Fjn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(RC, m(r, {
                    rA: n.a
                }), Qp);
            case 1:
                return A2(RC, m(r, {
                    sV: n.a
                }), Qp);
            case 2:
                var t = A2(dG, n.a, r.d1), e = t.b, u = t.c;
                return A2(RC, m(r, {
                    wQ: u.$ || u.a.$ || u.a.a.$ ? r.wQ : u.a.a.a,
                    d1: t.a
                }), A2(Wp, A2(tu, qjn, kjn), e));
            case 3:
                return v(m(r, {
                    wQ: It(ljn(n.a))
                }), Qp);
            case 4:
                return A2(RC, m(r, {
                    qN: n.a
                }), Qp);
            default:
                var a = A2(iN, n.a, r.vO), i = a.b;
                return v(m(r, {
                    vO: a.a
                }), A2(Wp, A2(qc, kjn, Ejn), i));
        }
    }), jjn = F3(function(n, r, t) {
        var e = t.b, u = A2(n, r, t.a), a = u.b;
        return v(A2(dZ, u.a, e), a);
    }), Djn = F2(function(n, r) {
        var t = r.a, e = r.b;
        if (1 === n.$) return v(n.a ? A2(sjn, t, Ajn) : mjn(t), Qp);
        var u = n.a;
        if (e.$) return v(A2(sjn, t, e), Qp);
        var a = e.a;
        return A2(lx, A2(tu, fjn, sjn(t)), A3(jjn, Fjn, u, a));
    }), Vjn = F2(function(n, r) {
        return m(r, {
            qS: n
        });
    }), Bjn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Gjn = function(n) {
        var r = n.b;
        if (1 === r.$) return v("use_primary_member_as_emergency_contact", Yw(!0));
        var t, e, u = function(n) {
            return A2(xc, nx, A2(Op, tx, mu(n) ? Ot : It(n)));
        }, a = FM(r.a);
        return v("emergency_contact", rx(w([
            v("first_name", u(a.rA)),
            v("last_name", u(a.sV)),
            v("relationship", A2(xc, nx, A2(Op, A2(tu, vjn, tx), a.wQ))),
            v("relationship_other", (e = a.wQ, e.$ || 6 !== e.a.$ ? nx : tx(e.a.a))),
            v("email", A2(xc, nx, A2(Op, tx, (t = a.qN, mu(t) ? Ot : It(t))))),
            v("phone", Y_n(a.vO))
        ])));
    }, zjn = F4(function(n, r, t, e) {
        var u = ux(r), a = FM(e), i = v("patient", rx(_K(Gjn(a.qS))));
        return A5(cCn, n, u, t, i, Bjn);
    }), Sjn = function(n) {
        var r = n.b;
        if (1 === r.$) return g;
        var t = r.a;
        return vc(A2(Fu, function(n) {
            return A2(iH, n, t);
        }, w([
            1,
            0,
            2,
            3
        ])));
    }, Tjn = XM(w([
        function(n) {
            var r = n.qS;
            return A2(Fu, RC(0), Sjn(r));
        }
    ])), Pjn = function(n) {
        return n.aQ.qN;
    }, Zjn = function(n) {
        return n.aQ.rA;
    }, Mjn = function(n) {
        return n.aQ.sV;
    }, Ljn = function(n) {
        return n.aQ.vO;
    }, Njn = function(n) {
        return n.aQ.wQ;
    }, Hjn = function(n) {
        return n.aQ.Fb;
    }, Ijn = function(n) {
        return n.aQ.Fc;
    }, Ojn = function(n) {
        return n.aQ.FP;
    }, Qjn = function(n) {
        return n.aQ.yx;
    }, Rjn = F2(function(n, r) {
        return function(t) {
            return n(t) ? g : w([
                r
            ]);
        };
    }), Ujn = XM(w([
        function(n) {
            var r, t = n.qN, e = n.vO, u = 1 === n.wQ.$, a = A2(Ekn, mu, w([
                n.rA,
                n.sV
            ])), i = "" === (r = v(zL(e), t)).a && "" === r.b, c = v(a && u, i);
            return c.a ? c.b ? g : w([
                v(3, nL(Ijn))
            ]) : c.b ? w([
                v(2, nL(Hjn))
            ]) : g;
        },
        function(n) {
            var r = n.vO;
            return A2(Fu, RC(0), function(n) {
                return A2(yL, n.EB, n.Fs) ? w([
                    XL(rZ)
                ]) : g;
            }(r));
        },
        function(n) {
            var r = n.qN;
            return mu(r) || oL(r) ? g : w([
                v(1, fL(A2(YM, uL, eL)))
            ]);
        },
        A2(Rjn, function(n) {
            var r = n.wQ;
            return !(!r.$ && 6 === r.a.$ && "" === r.a.a);
        }, v(4, nL(A2(YM, rL, Njn))))
    ])), Kjn = function(n) {
        var r = n.b;
        return A2(sjn, n.a, 1 === r.$ ? r : fjn(function(n) {
            var r = A2(CL, Ujn, n);
            return r.$ ? v(r.a, !1) : v(r.a.a, !0);
        }(r.a).a));
    }, Wjn = F2(function(n, r) {
        switch(n.$){
            case 3:
                var t = v(r.vn, r.le);
                if (t.a.$ || t.b.$) return b(r, Qp, g);
                var e = t.a.a, u = function(n) {
                    var r = A2(CL, Tjn, function(n) {
                        var r = FM(n), t = Kjn(r.qS);
                        return A3(cN, Vjn, t, n);
                    }(n));
                    return r.$ ? v(!1, r.a) : v(!0, r.a.a);
                }(l = t.b.a), a = u.a, i = u.b;
                return b(m(r, {
                    le: It(i)
                }), a ? A4(zjn, r.g0, r.dV, eyn(e), i) : Qp, g);
            case 0:
                var c = n.a;
                return e = JF(c), b(m(r, {
                    le: A2(Op, vZ, A2(Op, ojn, A2(Op, Cjn("emergency-contact-input"), A2(Op, tyn, e)))),
                    vn: e
                }), Qp, A2(Ik, 0, c));
            case 2:
                var o = n.a;
                return 3 === o.$ ? b(m(r, {
                    vn: It(e = o.a)
                }), A2(__, pa, Za({
                    sl: eyn(e)
                })), g) : b(r, Qp, A2(Ik, 0, o));
            default:
                var f = n.a, s = r.le;
                if (s.$) return b(r, Qp, g);
                var l, d = FM(l = s.a), p = A2(Djn, f, d.qS), $ = p.b;
                return b(m(r, {
                    le: It(A3(cN, Vjn, p.a, l))
                }), A2(Wp, cjn, $), g);
        }
    }), Xjn = {
        $: 3
    }, Yjn = cr("form"), Jjn = function(n) {
        return v(n, !0);
    }, nDn = F2(function(n, r) {
        return A2(kE, n, function(n) {
            return {
                $: 2,
                a: n
            };
        }(r));
    }), rDn = function(n) {
        return A2(nDn, "submit", A2(eu, Jjn, au(n)));
    }, tDn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, eDn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, uDn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, aDn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, iDn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, cDn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oDn = F3(function(n, r, t) {
        var e = t.b, u = w([
            Ot,
            It(_jn),
            It(wjn),
            It(gjn),
            It(hjn),
            It(xjn),
            It(yjn),
            It(ljn(""))
        ]), a = A3(de, F2(function(n, r) {
            return m(r, n.$ ? {
                wZ: n.a
            } : {
                Bb: n.a
            });
        }), {
            Bb: !1,
            wZ: !1
        }, r);
        return A2(zx, g, w([
            function() {
                if (1 === e.$) return _d("");
                var r = e.a, t = FM(r);
                return A2(zx, g, w([
                    s_,
                    A2(BE, w([
                        xN(JI)
                    ]), w([
                        A2(lE, g, w([
                            A2(zN, w([
                                uE(aF),
                                fen
                            ]), w([
                                _d(n(Qjn))
                            ]))
                        ]))
                    ])),
                    A2(BE, g, w([
                        A2(lE, w([
                            cmn(4)
                        ]), w([
                            A2(EH, w([
                                vH(n(Zjn))
                            ]), w([
                                PI(w([
                                    HI(A2(qc, kjn, uDn)),
                                    OI(t.rA),
                                    pI(a.Bb)
                                ]))
                            ]))
                        ])),
                        A2(lE, w([
                            cmn(4)
                        ]), w([
                            A2(EH, w([
                                vH(n(Mjn))
                            ]), w([
                                PI(w([
                                    HI(A2(qc, kjn, aDn)),
                                    OI(t.sV),
                                    pI(a.Bb)
                                ]))
                            ]))
                        ])),
                        A2(lE, w([
                            cmn(4)
                        ]), w([
                            A2(EH, w([
                                vH(n(Njn)),
                                LEn
                            ]), w([
                                A2(c_, A2(qc, kjn, qjn), A4(qz, n, w([
                                    XG(It(t.wQ))
                                ]), A2(Fu, function(n) {
                                    return A2(MG, g, n);
                                }, u), t.d1))
                            ]))
                        ])),
                        A2(lE, w([
                            cmn(12)
                        ]), w([
                            A2(YH, n, A2(iH, 3, r))
                        ]))
                    ])),
                    function() {
                        var e = t.wQ;
                        if (e.$ || 6 !== e.a.$) return _d("");
                        var u = e.a.a;
                        return A2(BE, g, w([
                            A2(lE, w([
                                cmn(12)
                            ]), w([
                                PI(w([
                                    jI(n(Njn)),
                                    HI(A2(qc, kjn, iDn)),
                                    OI(u),
                                    yI(A2(wH, 4, r))
                                ])),
                                A2(YH, n, A2(iH, 4, r))
                            ]))
                        ]));
                    }(),
                    A2(BE, g, w([
                        A2(lE, w([
                            cmn(12)
                        ]), w([
                            A2(EH, w([
                                vH(n(Ljn))
                            ]), w([
                                A2(c_, A2(qc, kjn, Ejn), A3(DO, n, w([
                                    oO(a.Bb),
                                    sO(A2(wH, 0, r) || A2(wH, 2, r))
                                ]), t.vO))
                            ])),
                            A2(YH, n, A2(iH, 0, r))
                        ]))
                    ])),
                    A2(BE, g, w([
                        A2(lE, w([
                            cmn(12)
                        ]), w([
                            A2(EH, w([
                                vH(n(Pjn))
                            ]), w([
                                PI(w([
                                    FI(!0),
                                    OI(t.qN),
                                    HI(A2(qc, kjn, eDn)),
                                    yI(A2(wH, 2, r) || A2(wH, 1, r)),
                                    pI(a.Bb)
                                ]))
                            ])),
                            A2(YH, n, A2(iH, 1, r))
                        ])),
                        A2(lE, w([
                            cmn(12)
                        ]), w([
                            A2(YH, n, A2(iH, 2, r))
                        ]))
                    ]))
                ]));
            }(),
            a.wZ ? _d("") : A2(BE, g, w([
                A2(lE, g, w([
                    A2(fI, w([
                        tI(cDn),
                        eI(1 === e.$)
                    ]), w([
                        _d(n(Ojn))
                    ]))
                ]))
            ]))
        ]));
    }), fDn = F2(function(n, r) {
        var t = ZV(Whn(r)), e = eyn(r);
        return A2(zx, g, w([
            A2(Mx, w([
                Gx("text-support")
            ]), w([
                A2(UD, w([
                    Gx("link text-current"),
                    oV(x_(Pa))
                ]), w([
                    _d(n(ov.yx))
                ]))
            ])),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            A2(UD, w([
                Gx("link text-current"),
                oV(x_(Za({
                    sl: e
                })))
            ]), w([
                t
            ])),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            A2(Mx, g, w([
                _d(n(ov.qS))
            ]))
        ]));
    }), sDn = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("text-left")
        ]), w([
            A2(fDn, n, r),
            function() {
                if (t.$) return _d("");
                var e = FM(t.a).qS;
                return A2(Yjn, w([
                    rDn(Xjn)
                ]), w([
                    A2(c_, cjn, A3(oDn, n, w([
                        tDn(!0)
                    ]), e)),
                    A2(zx, g, w([
                        A2(yF, w([
                            fF
                        ]), w([
                            _d(n(Xkn))
                        ])),
                        A2(EV, w([
                            yV(x_(Za({
                                sl: eyn(r)
                            }))),
                            _N
                        ]), w([
                            _d(n(V4))
                        ]))
                    ]))
                ]));
            }()
        ]));
    }), lDn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t = r.vn;
                    return t.$ ? Nx : w([
                        A3(sDn, n, t.a, r.le)
                    ]);
                }())
            ]),
            yx: n(ov.yx)
        };
    }), dDn = C_({
        Cl: ujn,
        CQ: ajn,
        Fj: ijn,
        F4: function() {
            return bx;
        },
        Gv: Wjn,
        GB: lDn
    }), vDn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bDn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mDn = F6(function(n, r, t, e, u, a) {
        return {
            rl: a,
            sl: n,
            vc: r,
            wa: e,
            l2: u,
            mt: t
        };
    }), pDn = F5(function(n, r, t, e, u) {
        return {
            or: r,
            o5: u,
            sl: n,
            u6: t,
            wS: e
        };
    }), $Dn = F4(function(n, r, t, e) {
        return {
            Ay: t,
            sC: e,
            uO: n,
            wx: r
        };
    }), gDn = A2(eu, cu, A3(nk, "invoice_id", ik(M$), A3(nk, "charge_item_name", M$, A3(nk, "quantity", O$, A3(nk, "occurred_at", KA, au($Dn)))))), hDn = F2(function(n, r) {
        return {
            sl: n,
            ur: r
        };
    }), yDn = A3(nk, "name", M$, A3(nk, "id", M$, au(hDn))), wDn = A2($A, yDn, au(cu)), xDn = A2(eu, cu, A3(nk, "consumption_events", ek(gDn), A3(nk, "remaining_quantity", O$, A3(nk, "original_quantity", O$, A3(nk, "charge_item", wDn, A3(nk, "id", M$, au(pDn))))))), _Dn = A2(eu, cu, A4(JA, "expires_at", ik(KA), Ot, A3(nk, "price_in_cents", ik(I$), A3(nk, "prepaid_charges", ek(xDn), A3(nk, "status", M$, A3(nk, "package_name", M$, A3(nk, "id", M$, au(mDn)))))))), CDn = ek(_Dn), ADn = F3(function(n, r, t) {
        return A4(aA, n, CDn, t, pk(function(n) {
            return A2(bk, w([
                "patient_packages"
            ]), fM(n));
        }(r)));
    }), kDn = F2(function(n, r) {
        return A2(SS, function(r) {
            return i(n, function(n) {
                return n.ht;
            }(r));
        }, r);
    }), EDn = F2(function(n, r) {
        return !A2(kDn, n, function(n) {
            return n.b.rr;
        }(r)).$;
    }), qDn = function(n) {
        return A2(EDn, 1, n);
    }, FDn = F3(function(n, r, t) {
        var e = A2(ra, "renewedMembershipId", t.jb), u = qDn(n), a = u ? A3(ADn, r.g0, ux(n), bDn) : Qp;
        return v({
            g0: r.g0,
            ld: r.ld,
            ad: kc,
            iQ: u ? A_ : kc,
            vn: r.vn,
            dV: n,
            mb: e,
            kn: r.kn
        }, Uu(w([
            A3(qgn, r.g0, ux(n), vDn),
            a
        ])));
    }), jDn = F2(function(n, r) {
        return v(r, Qp);
    }), DDn = F2(function(n, r) {
        return m(r, {
            zK: It(2)
        });
    }), VDn = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            switch(t.$){
                case 3:
                    return b(m(r, {
                        iQ: t
                    }), Qp, g);
                case 2:
                    return b(m(r, {
                        iQ: kc
                    }), Qp, A2(Ik, 0, t));
                default:
                    return b(r, Qp, g);
            }
        } else {
            var e = n.a;
            switch(e.$){
                case 3:
                    return b(m(r, {
                        ad: e
                    }), Qp, g);
                case 2:
                    return b(m(r, {
                        ad: kc
                    }), Qp, A2(Ik, 0, e));
                default:
                    return b(r, Qp, g);
            }
        }
    }), BDn = function(n) {
        return n.mt;
    }, GDn = function(n) {
        return n.zZ;
    }, zDn = {
        $: 8
    }, SDn = function(n) {
        return n.a.q1;
    }, TDn = F2(function(n, r) {
        return r.tJ(n);
    }), PDn = function(n) {
        return n.vX;
    }, ZDn = {
        $: 10
    }, MDn = F3(function(n, r, t) {
        return A2(BE, w([
            ZDn
        ]), w([
            A2(lE, w([
                TE(1)
            ]), w([
                A2(f_, w([
                    uF(xD)
                ]), w([
                    A2(Tq, w([
                        Xj
                    ]), 10)
                ]))
            ])),
            A2(lE, w([
                TE(11)
            ]), w([
                _d(n(TDn(t))),
                A2(f_, w([
                    VG,
                    Hx(w([
                        Gx("mt-1")
                    ]))
                ]), w([
                    A2(PE, w([
                        VG,
                        nF
                    ]), w([
                        _d(n(PDn))
                    ])),
                    _d(" "),
                    A2(EV, w([
                        yV(x_(Oa({
                            sl: r
                        })))
                    ]), w([
                        _d(n(fv.wV))
                    ]))
                ]))
            ]))
        ]));
    }), LDn = function(n) {
        return n.tM;
    }, NDn = F2(function(n, r) {
        return r.tN(n);
    }), HDn = {
        $: 9
    }, IDn = F2(function(n, r) {
        var t = mu(r) ? LDn : NDn(r);
        return A2(BE, w([
            HDn
        ]), w([
            A2(lE, w([
                TE(1)
            ]), w([
                A2(f_, w([
                    uF(xD)
                ]), w([
                    A2(Tq, w([
                        Xj,
                        Wj("fill-success-300")
                    ]), 9)
                ]))
            ])),
            A2(lE, w([
                TE(11)
            ]), w([
                A2(f_, w([
                    VG,
                    nF,
                    Hx(w([
                        Gx("mt-1")
                    ]))
                ]), w([
                    _d(n(t))
                ]))
            ]))
        ]));
    }), ODn = F5(function(n, r, t, e, u) {
        var a = sJ(A2(OX, n, function(n) {
            return n.a.vN;
        }(u))), c = OK(GDn(function(n) {
            return n.a.uv;
        }(u))), o = Lgn(u), f = Hgn(u) ? vE : A2(PE, w([
            VG,
            nF
        ]), w([
            _d(c + "/" + a)
        ])), s = Zgn(u), l = !t.$ && i(t.a, s);
        return A2(BE, w([
            zDn,
            TE(12),
            VN(w([
                Gx("card")
            ]))
        ]), w([
            A2(lE, w([
                VN(w([
                    Gx("flex justify-between items-center gap-x-3")
                ]))
            ]), w([
                A2(zx, w([
                    Gx("text-left ml-2 min-w-0 flex flex-col sm:flex-row sm:items-baseline sm:gap-x-3")
                ]), w([
                    A2(PE, g, w([
                        A2(xX, g, w([
                            _d(o)
                        ]))
                    ])),
                    f
                ])),
                A2(zx, w([
                    Gx("w-min sm:w-auto text-right")
                ]), w([
                    A2(EV, w([
                        yV(x_(Ha({
                            sl: s
                        })))
                    ]), w([
                        _d(n(fv.xy))
                    ]))
                ]))
            ])),
            A2(lE, g, w([
                function() {
                    if (e) {
                        var t = v(SDn(u), function(n) {
                            return n.a.pi;
                        }(u));
                        return t.a.$ || t.b ? vE : A3(MDn, n, s, A2(r, 0, t.a.a));
                    }
                    return vE;
                }()
            ])),
            A2(lE, g, w([
                function() {
                    if (l) {
                        var t = SDn(u);
                        return A2(IDn, n, t.$ ? "" : A2(r, 0, t.a));
                    }
                    return vE;
                }()
            ]))
        ]));
    }), QDn = F2(function(n, r) {
        return r.u9(n);
    }), RDn = function(n) {
        return n.iQ.xy;
    }, UDn = function(n) {
        return n.or;
    }, KDn = function(n) {
        return n.ur;
    }, WDn = function(n) {
        return n.u6;
    }, XDn = function(n) {
        return n.wS;
    }, YDn = function(n) {
        var r = XDn(n), t = WDn(n), e = KDn(UDn(n));
        return A2(zx, w([
            Gx("text-support")
        ]), w([
            _d(oe(t) + " " + e + " "),
            A2(wX, g, w([
                _d("(" + oe(r) + " remaining)")
            ]))
        ]));
    }, JDn = F2(function(n, r) {
        var t = function(n) {
            return n.vc;
        }(r), e = function(n) {
            return n.sl;
        }(r), u = function() {
            var t = function(n) {
                return n.rl;
            }(r);
            return t.$ ? "" : n(QDn(A2(_p, "MM/dd/yyyy", t.a)));
        }(), a = function(n) {
            return n.wa;
        }(r);
        return A2(BE, w([
            zDn,
            TE(12),
            VN(w([
                Gx("card")
            ]))
        ]), w([
            A2(lE, w([
                VN(w([
                    Gx("text-left")
                ]))
            ]), w([
                A2(zx, w([
                    Gx("flex justify-between items-center gap-x-3")
                ]), w([
                    A2(zx, w([
                        Gx("min-w-0 flex flex-col sm:flex-row sm:items-baseline sm:gap-x-2")
                    ]), w([
                        A2(PE, g, w([
                            A2(xX, g, w([
                                _d(t)
                            ]))
                        ])),
                        mu(u) ? vE : A2(PE, w([
                            VG,
                            nF,
                            zX
                        ]), w([
                            _d(u)
                        ]))
                    ])),
                    A2(zx, w([
                        Gx("w-min sm:w-auto text-right")
                    ]), w([
                        A2(EV, w([
                            yV(x_(Ka({
                                sl: e
                            })))
                        ]), w([
                            _d(n(RDn))
                        ]))
                    ]))
                ])),
                nE(a) ? vE : A2(zx, w([
                    Gx("mt-4 space-y-4")
                ]), A2(Fu, YDn, a))
            ]))
        ]));
    }), nVn = F2(function(n, r) {
        return nE(r) ? vE : A2(zx, w([
            Gx("mt-4 space-y-4")
        ]), A2(Fu, JDn(n), r));
    }), rVn = F6(function(n, r, t, e, u, a) {
        var i = function(n) {
            return A2(Pgn, w([
                1
            ]), n);
        }(t), c = qDn(r), o = c ? fv.q0 : fv.q$, f = function(n) {
            return A2(Pgn, w([
                3
            ]), n);
        }(t), s = c ? fv.pN : fv.pI, l = c && 3 === e.$ ? e.a : g, d = A2(no, function(n) {
            return "ended" === BDn(n);
        }, l), v = A2(no, function(n) {
            return "active" === BDn(n);
        }, l), b = function(n) {
            return A2(Pgn, w([
                2
            ]), n);
        }(t);
        return w([
            A2(zx, w([
                Gx("space-y-6")
            ]), w([
                nE(i) ? vE : A2(zx, g, w([
                    A2(i_, g, w([
                        _d(n(fv.i_))
                    ])),
                    A2(zx, w([
                        Gx("mt-4")
                    ]), A2(Fu, A4(ODn, n, u, a, !0), i))
                ])),
                nE(b) && nE(v) ? vE : A2(zx, g, w([
                    A2(i_, g, w([
                        _d(n(s))
                    ])),
                    A2(zx, w([
                        Gx("mt-4")
                    ]), A2(Fu, A4(ODn, n, u, a, !0), b)),
                    A2(nVn, n, v)
                ])),
                nE(f) && nE(d) ? vE : A2(zx, g, w([
                    A2(i_, g, w([
                        _d(n(o))
                    ])),
                    A2(zx, w([
                        Gx("mt-4")
                    ]), A2(Fu, A4(ODn, n, u, a, !1), f)),
                    A2(nVn, n, d)
                ]))
            ]))
        ]);
    }), tVn = F2(function(n, r) {
        var t = qDn(r.dV), e = n(t ? fv.Gi : fv.yx), u = n(t ? fv.zD : fv.GO);
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t, e = r.ad;
                    if (3 === e.$) {
                        var a = e.a;
                        return nE(a) && (3 !== (t = r.iQ).$ || nE(t.a)) ? rF(u) : A6(rVn, n, r.dV, a, r.iQ, r.kn, r.mb);
                    }
                    return Nx;
                }())
            ]),
            yx: e
        };
    }), eVn = C_({
        Cl: FDn,
        CQ: jDn,
        Fj: DDn,
        F4: function() {
            return bx;
        },
        Gv: VDn,
        GB: tVn
    }), uVn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, aVn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, iVn = F2(function(n, r) {
        return {
            ob: n,
            vC: r
        };
    }), cVn = F2(function(n, r) {
        return {
            k8: n,
            y4: r
        };
    }), oVn = A3(nk, "value", ik(KA), A3(nk, "editable", ru, au(cVn))), fVn = A3(nk, "editable", ru, au(function(n) {
        return {
            k8: n
        };
    })), sVn = A3(nk, "payment_source", fVn, A3(nk, "cancellation_date", oVn, au(iVn))), lVn = A2($A, sVn, au(cu)), dVn = F7(function(n, r, t, e, u, a, i) {
        return {
            q5: t,
            q9: e,
            sl: n,
            vn: u,
            v4: i,
            wQ: a,
            x0: r
        };
    }), vVn = function(n) {
        switch(n){
            case "owner":
                return au(0);
            case "spouse":
                return au(1);
            case "child":
                return au(2);
            case "other":
                return au(3);
            default:
                return AA("Unsupported relationship: " + n);
        }
    }, bVn = A4(JA, "practitioner", uC(jQ), Ot, A3(nk, "relationship", A2(nu, vVn, M$), A3(nk, "patient", VQ, A3(nk, "enrollment_status", M$, A3(nk, "effective_end_date", uC(KA), A3(nk, "start_date", uC(KA), A3(nk, "id", M$, au(dVn)))))))), mVn = A2($A, bVn, au(cu)), pVn = A4(JA, "source", ik(J0), Ot, A3(nk, "meta", lVn, A3(nk, "tobacco_surcharge_enabled", ru, A3(nk, "owner", VQ, A3(nk, "dpc_discount", ru, A3(nk, "sponsored", ru, A3(nk, "billed_through_date", uC(KA), A3(nk, "children_age_limit", uC(O$), A3(nk, "maximum_age", uC(O$), A3(nk, "minimum_age", uC(O$), A3(nk, "plan_name", M$, A3(nk, "plan_id", M$, A3(nk, "membership_patients", ek(mVn), A3(nk, "is_cancellable", ru, A3(nk, "enrollment_status", A2(nu, wgn, M$), A3(nk, "period_in_months", A2(nu, xgn, O$), A3(nk, "contract_period_in_months", uC(KA), A3(nk, "contract_end_date", uC(KA), A3(nk, "contract_start_date", uC(KA), A3(nk, "next_future_unpaid_bill", Agn, A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return function(b) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(y) {
                                                                                        return {
                                                                                            nL: b,
                                                                                            ox: v,
                                                                                            pj: e,
                                                                                            pn: u,
                                                                                            pp: t,
                                                                                            qv: p,
                                                                                            q9: i,
                                                                                            sl: n,
                                                                                            sF: c,
                                                                                            tw: d,
                                                                                            tL: o,
                                                                                            lz: h,
                                                                                            ul: l,
                                                                                            uv: r,
                                                                                            iO: $,
                                                                                            vN: a,
                                                                                            vV: f,
                                                                                            vW: s,
                                                                                            xS: y,
                                                                                            xZ: m,
                                                                                            yE: g
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))), $Vn = A2($A, pVn, au(cu)), gVn = F2(function(n, r) {
        return A2(bk, w([
            "memberships",
            r
        ]), fM(n));
    }), hVn = F4(function(n, r, t, e) {
        return A4(aA, n, $Vn, e, pk(A2(gVn, r, t)));
    }), yVn = function(n) {
        return A4(hVn, n.g0, n.EH, n.iy, aVn);
    }, wVn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, xVn = function(n) {
        return A3(r1, n.g0, n.EH, wVn);
    }, _Vn = {
        fk: !1
    }, CVn = F2(function(n, r) {
        return A2(Mx, g, w([
            _d(A2(T0, n, r)),
            A2(Qpn, n, Tpn(r)),
            P0(r) ? A2(Zq, w([
                1
            ]), w([
                _d(n(Z0))
            ])) : _d("")
        ]));
    }), AVn = uQ({
        sl: "payment-source-select",
        Gj: CVn,
        Gk: function(n) {
            return It(D0(n));
        }
    }), kVn = F3(function(n, r, t) {
        var e = t.Ep, u = ux(n), a = {
            g0: r.g0,
            dt: Ot,
            hz: Ot,
            ld: r.ld,
            fn: _Vn,
            Da: Ot,
            iy: e.sl,
            fy: UQ(r),
            lV: AVn,
            lW: kc,
            dV: n,
            EH: u,
            el: !1
        };
        return v(a, Uu(w([
            A2(Nu, uVn, Yz),
            yVn(a),
            xVn(a)
        ])));
    }), EVn = F2(function(n, r) {
        return v(r, Qp);
    }), qVn = F2(function(n, r) {
        return m(r, {
            zK: It(2)
        });
    }), FVn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, jVn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, DVn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, VVn = function(n) {
        return n.sl;
    }, BVn = {
        $: 0
    }, GVn = {
        Aq: ""
    }, zVn = function(n) {
        return n.tL;
    }, SVn = w([
        0
    ]), TVn = function() {
        return "Cancellation Reason";
    }, PVn = F3(function(n, r, t) {
        var e = GVn, u = A2(YF, 0, BVn), a = u.a, i = u.b;
        return v({
            eD: kc,
            le: vZ(e),
            Da: n,
            lx: t,
            tL: zVn(n),
            fq: a,
            dV: r,
            A: A2(pZ, SVn, TVn)
        }, i);
    }), ZVn = F2(function(n, r) {
        return v(n.$ ? r : m(r, {
            fk: n.a
        }), Qp);
    }), MVn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, LVn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, NVn = {
        $: 1
    }, HVn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, IVn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, OVn = {
        $: 0
    }, QVn = F5(function(n, r, t, e, u) {
        var a = rx(w([
            v("membership", rx(w([
                v("end_date", A2(wM, Kdn, e.qZ)),
                v("cancellation_reason_other", tx(e.Aq)),
                v("ended_by", tx("Patient"))
            ])))
        ]));
        return A4(lM, n, $Vn, u, A2(dM, a, pk(A2(bk, w([
            "cancel"
        ]), A2(gVn, r, t)))));
    }), RVn = F3(function(n, r, t) {
        return A2(bk, w([
            "members",
            t
        ]), A2(bk, w([
            "memberships",
            r
        ]), fM(n)));
    }), UVn = F6(function(n, r, t, e, u, a) {
        var i = rx(w([
            v("member", rx(w([
                v("end_date", A2(wM, Kdn, u.qZ)),
                v("cancellation_reason_other", tx(u.Aq))
            ])))
        ]));
        return A4(lM, n, mVn, a, A2(dM, i, pk(A2(bk, w([
            "cancel"
        ]), A3(RVn, r, t, e)))));
    }), KVn = function(n) {
        return n.bl.An;
    }, WVn = function(n) {
        return n.bl.Ap;
    }, XVn = function(n) {
        return n.bl.C9;
    }, YVn = function(n) {
        return n.bl.E4;
    }, JVn = function(n) {
        return n.bl.E5;
    }, nBn = function(n) {
        return n.bl.Fa;
    }, rBn = function(n) {
        return n.bl.Fi;
    }, tBn = function(n) {
        return n.bl.F5;
    }, eBn = F2(function(n, r) {
        return m(r, {
            Aq: n
        });
    }), uBn = XM(w([
        function(n) {
            return iL(n.Aq) ? w([
                v(0, fL(nBn))
            ]) : g;
        }
    ])), aBn = function(n) {
        return n.lz;
    }, iBn = function(n) {
        return n.ob.y4;
    }, cBn = F3(function(n, r, t) {
        var e = t;
        switch(r.$){
            case 0:
                return {
                    hs: Qp,
                    hS: NVn,
                    iA: m(e, {
                        fq: Bj(e.fq)
                    }),
                    iM: g
                };
            case 1:
                return {
                    hs: Qp,
                    hS: OVn,
                    iA: m(e, {
                        le: i = A3(cN, eBn, r.a, e.le)
                    }),
                    iM: g
                };
            case 2:
                var u = A2(CL, uBn, e.le);
                if (u.$) return {
                    hs: Qp,
                    hS: OVn,
                    iA: m(e, {
                        le: i = u.a
                    }),
                    iM: g
                };
                var a = u.a, i = a.a, c = {
                    Aq: a.b.Aq,
                    qZ: iBn(aBn(e.Da))
                }, o = function() {
                    var r = e.lx;
                    if (r.$) return A5(QVn, n, ux(e.dV), VVn(e.Da), c, IVn);
                    var t = r.a;
                    return A6(UVn, n, ux(e.dV), VVn(e.Da), function(n) {
                        return n.sl;
                    }(t), c, HVn);
                }();
                return {
                    hs: o,
                    hS: OVn,
                    iA: m(e, {
                        eD: A_,
                        le: i
                    }),
                    iM: g
                };
            case 3:
                if (3 === (s = r.a).$) {
                    var f = s.a;
                    return {
                        hs: Qp,
                        hS: MVn(f),
                        iA: m(e, {
                            Da: f
                        }),
                        iM: w([
                            A2(Mk, 3, tBn)
                        ])
                    };
                }
                return {
                    hs: Qp,
                    hS: OVn,
                    iA: m(e, {
                        eD: kc
                    }),
                    iM: A2(Ik, 0, s)
                };
            default:
                var s;
                if (3 === (s = r.a).$) {
                    var l = s.a;
                    return {
                        hs: Qp,
                        hS: LVn(l),
                        iA: m(e, {
                            lx: It(l)
                        }),
                        iM: w([
                            A2(Mk, 3, JVn)
                        ])
                    };
                }
                return {
                    hs: Qp,
                    hS: OVn,
                    iA: m(e, {
                        eD: kc
                    }),
                    iM: A2(Ik, 0, s)
                };
        }
    }), oBn = F5(function(n, r, t, e, u) {
        var a = rx(w([
            v("membership", rx(w([
                v("payment_source", rx(w([
                    v("id", tx(e))
                ])))
            ])))
        ]));
        return A4(Dj, n, $Vn, u, A2(dM, a, pk(A2(gVn, r, t))));
    }), fBn = F2(function(n, r) {
        switch(n.$){
            case 1:
                return 3 === (A = n.a).$ ? b(m(r, {
                    Da: It(A.a)
                }), Qp, g) : b(r, Qp, A2(Ik, 0, A));
            case 2:
                return b(m(r, {
                    hz: It(A2(Ep, x8, n.a))
                }), Qp, g);
            case 3:
                var t = (k = r.Da).$ ? Qp : A2(__, pa, Ia({
                    sl: VVn(k.a)
                }));
                return b(r, t, g);
            case 4:
                var e = n.a, u = A2(xc, v(Ot, Qp), A2(Op, function(n) {
                    return A2(Qhn, Wp(FVn), A2(lx, It, A3(PVn, n, r.dV, e)));
                }, r.Da)), a = u.b;
                return b(m(r, {
                    dt: u.a
                }), a, g);
            case 5:
                var i = n.a, c = r.dt;
                if (c.$) return b(r, Qp, g);
                var o = A3(cBn, r.g0, i, c.a), f = function() {
                    switch(o.hS.$){
                        case 0:
                            return b(It(o.iA), o.hs, g);
                        case 2:
                            return b(It(o.iA), A2(__, pa, Na), o.iM);
                        default:
                            return b(Ot, o.hs, o.iM);
                    }
                }(), s = f.a, l = f.b, d = f.c;
                return t = 3 === o.hS.$ ? Uu(w([
                    A2(Wp, FVn, l),
                    yVn(r)
                ])) : A2(Wp, FVn, l), b(m(r, {
                    dt: s
                }), t, d);
            case 0:
                var p = n.a;
                if (1 === p.$) {
                    var $ = A2(fBn, DVn(It(e = p.a)), r);
                    return b($.a, $.b, g);
                }
                return b(m(r, {
                    fn: A2(ZVn, p, r.fn).a
                }), Qp, g);
            case 6:
                var h = n.a;
                return b(m(r, 3 === h.$ ? {
                    lW: A2(tC, h.a, pa)
                } : {
                    lW: h
                }), Qp, g);
            case 7:
                var y = A2(dG, n.a, r.lV), x = y.a, _ = y.c, C = function() {
                    if (_.$ || _.a.$ || _.a.a.$) return v(m(r, {
                        lV: x
                    }), Qp);
                    var n = _.a.a.a;
                    return v(m(r, {
                        lV: x,
                        el: !0
                    }), A5(oBn, r.g0, r.EH, r.iy, D0(n), jVn));
                }();
                return b(C.a, t = C.b, g);
            default:
                var A;
                return 3 === (A = n.a).$ ? b(m(r, {
                    Da: It(A.a),
                    el: !1
                }), Qp, w([
                    A2(Mk, 3, L0)
                ])) : b(m(r, {
                    el: !1
                }), Qp, A2(Ik, 0, A));
        }
        var k;
    }), sBn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lBn = function(n) {
        return n.pS;
    }, dBn = function(n) {
        return n.uv;
    }, vBn = function(n) {
        return n.vN;
    }, bBn = function(n) {
        return n.vW;
    }, mBn = function(n) {
        return A2(SM, sZ("/"), n);
    }, pBn = F2(function(n, r) {
        return A2(zx, w([
            Gx("text-left")
        ]), w([
            A2(xX, w([
                Hx(w([
                    Gx("mb-5")
                ]))
            ]), w([
                _d(n(fv.pm))
            ])),
            A2(f_, w([
                nF,
                Hx(w([
                    Gx("mt-1 mb-8 mr-2")
                ]))
            ]), w([
                _d(r.kW)
            ]))
        ]));
    }), $Bn = F2(function(n, r) {
        return function(n) {
            return n.pn;
        }(r).$ ? vE : A2(pBn, n, function(n) {
            var r, t = (r = function(n) {
                return n.pp;
            }(n), r.$ ? "" : mBn(r.a)), e = function() {
                var r = function(n) {
                    return n.pj;
                }(n);
                return r.$ ? "" : " - " + mBn(r.a);
            }();
            return {
                kW: $(t, e)
            };
        }(r));
    }), gBn = function(n) {
        return n.xZ;
    }, hBn = function(n) {
        return A2(de, F2(function(r, t) {
            return n(r) ? t + 1 : t;
        }), 0);
    }, yBn = function(n) {
        return n.eY.nU;
    }, wBn = function(n) {
        return n.eY.EO;
    }, xBn = function(n) {
        return n.eY.yx;
    }, _Bn = function(n) {
        return n.eY.GO;
    }, CBn = function(n) {
        return n.q5;
    }, ABn = function(n) {
        return A2(SM, sZ("/"), n);
    }, kBn = F2(function(n, r) {
        return r.q6(n);
    }), EBn = F2(function(n, r) {
        return r.q7(n);
    }), qBn = F2(function(n, r) {
        return r.q8(n);
    }), FBn = F2(function(n, r) {
        return !A2(pU, r, n);
    }), jBn = F5(function(n, r, t, e, u) {
        var a = v(t, e);
        if (a.a.$) return a.b.$ ? "" : ABn(c = a.b.a);
        if (a.b.$) return A2(fe, ", ", w([
            n(qBn(ABn(i = a.a.a))),
            u
        ]));
        var i = a.a.a, c = a.b.a, o = r.$ ? kBn(ABn(c)) : A2(FBn, c, r.a) ? EBn(ABn(c)) : kBn(ABn(c));
        return A2(fe, ", ", w([
            n(qBn(ABn(i))),
            n(o),
            u
        ]));
    }), DBn = F2(function(n, r) {
        return r.tG(n);
    }), VBn = function(n) {
        return n.vn;
    }, BBn = function(n) {
        return n.v4;
    }, GBn = F3(function(n, r, t) {
        var e = function(n) {
            return n.x0;
        }(t), u = VBn(t), a = ZV(aQ(u)), i = JX(u) ? A2(Zq, w([
            1
        ]), w([
            _d(n(wBn))
        ])) : vE, c = function(n) {
            return n.q9;
        }(t), o = CBn(t), f = A5(jBn, n, r, e, o, c), s = function() {
            var r = Rgn(u);
            return r.$ ? "" : n(Ugn(oe(r.a)));
        }();
        return {
            ng: s,
            k9: f,
            q5: o,
            q9: c,
            lw: i,
            lx: t,
            lT: a,
            l4: A2(Op, A2(tu, Fmn, A2(tu, DBn, n)), BBn(t))
        };
    }), zBn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, SBn = F3(function(n, r, t) {
        return t ? A2(yF, w([
            CD,
            cF(zBn(!0)),
            Lj(r)
        ]), w([
            _d(n(ov.C_))
        ])) : vE;
    }), TBn = function(n) {
        var r = n.l4;
        if (r.$) return vE;
        var t = r.a;
        return A2(f_, w([
            nF
        ]), w([
            _d(t)
        ]));
    }, PBn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ZBn = F4(function(n, r, t, e) {
        return r && i(e.q5, Ot) ? A2(zx, w([
            Gx("grid text-right mr-2")
        ]), w([
            A2(yF, w([
                j6,
                cF(PBn(e.lx)),
                Kj(w([
                    Gx("text-right")
                ])),
                Lj(t)
            ]), w([
                A2(Tq, g, 8),
                A2(PE, g, w([
                    _d(n(YVn))
                ]))
            ]))
        ])) : vE;
    }), MBn = F4(function(n, r, t, e) {
        return A2(BE, w([
            _E,
            TE(12)
        ]), w([
            A2(lE, w([
                TE(8),
                VN(w([
                    Gx("flex justify-between items-center")
                ]))
            ]), w([
                A2(zx, w([
                    Gx("text-left ml-2")
                ]), w([
                    A2(zx, w([
                        Gx("flex items-center")
                    ]), w([
                        A2(xX, w([
                            Hx(w([
                                Gx("mr-1")
                            ]))
                        ]), w([
                            e.lT
                        ])),
                        e.lw
                    ])),
                    A2(f_, w([
                        nF
                    ]), w([
                        _d(e.k9)
                    ])),
                    TBn(e)
                ]))
            ])),
            spn(w([
                TE(1)
            ])),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(zx, w([
                    Gx("grid text-right mr-2")
                ]), w([
                    _d(e.ng)
                ])),
                A4(ZBn, n, r, t, e)
            ]))
        ]));
    }), LBn = F5(function(n, r, t, e, u) {
        return A2(zx, w([
            Gx("mb-5")
        ]), A2(Qt, A2(zx, w([
            Gx("flex justify-between items-center mb-4")
        ]), w([
            A2(f_, g, w([
                A2(xX, g, w([
                    _d(t(xBn))
                ]))
            ])),
            A3(SBn, t, r.fk, n)
        ])), nE(e) ? rF(t(_Bn)) : A2(Fu, A3(MBn, t, r.fk, 1 === A2(hBn, function(n) {
            return i(n, Ot);
        }, A2(Fu, CBn, e))), A2(Fu, A2(GBn, t, u), e))));
    }), NBn = F2(function(n, r) {
        return r.qz(n);
    }), HBn = function(n) {
        return n.uu;
    }, IBn = F3(function(n, r, t) {
        var e = OK(t);
        if (r.$) return vE;
        var u, a = r.a;
        return A2(zx, w([
            Gx("mb-5")
        ]), w([
            A2(f_, w([
                uE(aF)
            ]), w([
                A2(xX, g, w([
                    _d(n(HBn))
                ]))
            ])),
            A2(BE, w([
                _E,
                TE(12)
            ]), w([
                A2(lE, w([
                    TE(6),
                    VN(w([
                        Gx("flex justify-between items-center")
                    ]))
                ]), w([
                    A2(zx, w([
                        Gx("text-left ml-2")
                    ]), w([
                        A2(f_, w([
                            Hx(w([
                                Gx("mb-1 mr-2")
                            ]))
                        ]), w([
                            _d(n(NBn((u = a, A2(SM, sZ("/"), u)))))
                        ]))
                    ]))
                ])),
                spn(w([
                    TE(3)
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(zx, w([
                        Gx("grid text-right mr-2")
                    ]), w([
                        A2(f_, g, w([
                            _d(e)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), OBn = {
        $: 3
    }, QBn = F2(function(n, r) {
        return A2(zx, w([
            Gx("mb-4")
        ]), w([
            r ? A2(yF, w([
                CD,
                cF(OBn)
            ]), w([
                _d(n(ov.mY))
            ])) : vE
        ]));
    }), RBn = F3(function(n, r, t) {
        return gBn(t) ? vE : A2(zx, w([
            Gx("mb-4")
        ]), w([
            A2(f_, w([
                uE(Jq)
            ]), w([
                A2(xX, g, w([
                    _d(n(yBn))
                ]))
            ])),
            A2(f_, w([
                nF
            ]), w([
                _d(r)
            ]))
        ]));
    }), UBn = F2(function(n, r) {
        return A2(zx, g, w([
            A2(Mx, w([
                Gx("text-support")
            ]), w([
                A2(UD, w([
                    Gx("link text-current"),
                    oV(x_(Na))
                ]), w([
                    _d(n(fv.Gi))
                ]))
            ])),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            _d(r)
        ]));
    }), KBn = {
        $: 2
    }, WBn = oF(8), XBn = function(n) {
        return n.o7;
    }, YBn = F2(function(n, r) {
        return r.o8(n);
    }), JBn = F2(function(n, r) {
        return r.o9(n);
    }), nGn = F3(function(n, r, t) {
        return A2(t.pa, n, r);
    }), rGn = function(n) {
        var r = v(A2(Op, iV(0), bV(n)), A2(Op, xEn, Xw(n)));
        return r.a.$ ? r.b.$ ? XBn : YBn(r.b.a) : r.b.$ ? JBn(r.a.a) : A2(nGn, r.a.a, r.b.a);
    }, tGn = function(n) {
        if (1 === n.$) return "today";
        var r = n.a;
        return A2(SM, sZ("/"), r);
    }, eGn = F2(function(n, r) {
        return r.p9(n);
    }), uGn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, aGn = F3(function(n, r, t) {
        return A2(oN, t, r) || A2(wH, t, n);
    }), iGn = F3(function(n, r, t) {
        return A3(aGn, n, r, t) ? A2(iH, t, n) : g;
    }), cGn = F3(function(n, r, t) {
        var e = r, u = FM(e.le).Aq;
        return A2(EH, w([
            vH(n(WVn)),
            gH(!0)
        ]), w([
            LH(w([
                fH("cancel-membership-form-cancellation-reason"),
                hH(0),
                _H(u),
                pH(A2(qc, uGn, cu)),
                sH(t),
                yH(3)
            ])),
            A2(YH, n, A3(iGn, e.le, e.A, 0))
        ]));
    }), oGn = {
        $: 3
    }, fGn = function(n) {
        return w([
            ZV(aQ(VBn(n)))
        ]);
    }, sGn = F3(function(n, r, t) {
        var e, u = function() {
            var n = r.lx;
            return n.$ ? r.tL : w([
                n.a
            ]);
        }();
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(f_, g, w([
                    _d(n(rBn))
                ])),
                RD,
                A2(f_, g, w([
                    _d(n(eGn(tGn(iBn(aBn(r.Da))))))
                ])),
                RD,
                A2(f_, g, w([
                    _d(n(rGn(r.dV)))
                ])),
                RD,
                A2(zx, g, w([
                    A2(f_, w([
                        sE
                    ]), w([
                        _d(n(XVn))
                    ]))
                ])),
                RD,
                A2(zx, g, w([
                    (e = u, A2(ipn, w([
                        oGn
                    ]), A2(Fu, A2(qc, Wmn, fGn), e)))
                ])),
                RD,
                A3(cGn, n, r, t)
            ]))
        ]);
    }), lGn = F2(function(n, r) {
        var t = r, e = n(A2(xc, KVn, A2(Op, function() {
            return YVn;
        }, t.lx))), u = A2(wH, 0, t.le);
        return A2(dD, w([
            Hj(w([
                A2(PE, w([
                    Qx
                ]), w([
                    _d(e)
                ]))
            ])),
            Mj(A3(sGn, n, t, u)),
            Nj(w([
                A2(yF, w([
                    WBn,
                    cF(KBn)
                ]), w([
                    _d(e)
                ]))
            ]))
        ]), zj(t.fq));
    }), dGn = F2(function(n, r) {
        return A2(c_, FVn, A2(xc, vE, A2(Op, lGn(n), r)));
    }), vGn = oF(9), bGn = F2(function(n, r) {
        return A2(zx, w([
            Gx("mt-4 mb-4")
        ]), w([
            r ? A2(yF, w([
                vGn,
                cF(DVn(Ot))
            ]), w([
                _d(n(KVn))
            ])) : A2(zx, g, g)
        ]));
    }), mGn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, pGn = function(n) {
        return n.q9;
    }, $Gn = function(n) {
        return n.xS;
    }, gGn = F3(function(n, r, t) {
        if (gBn(r) || !function(n) {
            return function(n) {
                return n.vC.k8;
            }(n.lz);
        }(r)) return vE;
        var e = 3 === pGn(r), u = t.el || e, a = t.lW;
        if (3 === a.$) {
            var i = a.a;
            return A2(zx, w([
                Gx("mb-4")
            ]), w([
                A2(f_, w([
                    uE(Jq)
                ]), w([
                    A2(xX, g, w([
                        _d(n(M0))
                    ]))
                ])),
                A2(c_, mGn, A4(qz, n, w([
                    XG($Gn(r)),
                    HG(n(z4)),
                    SG,
                    CO(u)
                ]), A2(Fu, function(n) {
                    return A2(MG, g, n);
                }, i), t.lV)),
                A2(f_, w([
                    b4,
                    VG,
                    uE(iwn)
                ]), w([
                    _d(n(N0))
                ]))
            ]));
        }
        return vE;
    }), hGn = F3(function(n, r, t) {
        var e = function(n) {
            return n.b.tI;
        }(t.dV), u = lBn(dBn(r)), a = GDn(dBn(r)), i = bBn(r), c = zVn(r), o = function(n) {
            return n.sF;
        }(r) && !gBn(r) && e, f = t.fn, s = f.fk, l = A2(OX, n, vBn(r));
        return A2(zx, w([
            Gx("text-left mb-5")
        ]), w([
            A2(UBn, n, i),
            s_,
            A2(i_, w([
                Hx(w([
                    Gx("mt-8 mb-8")
                ]))
            ]), w([
                _d(i)
            ])),
            A2($Bn, n, r),
            A2(c_, sBn, A5(LBn, o, f, n, c, t.hz)),
            A2(QBn, n, s),
            gBn(r) ? vE : A3(IBn, n, It(u), a),
            A3(RBn, n, l, r),
            A3(gGn, n, r, t),
            A2(bGn, n, s),
            A2(dGn, n, t.dt)
        ]));
    }), yGn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t = r.Da;
                    return t.$ ? Nx : w([
                        A3(hGn, n, t.a, r)
                    ]);
                }())
            ]),
            yx: n(fv.yx)
        };
    }), wGn = C_({
        Cl: kVn,
        CQ: EVn,
        Fj: qVn,
        F4: function() {
            return bx;
        },
        Gv: fBn,
        GB: yGn
    }), xGn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, _Gn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, CGn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, AGn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, kGn = function() {
        return "Forms";
    }, EGn = {
        cT: g,
        A: A2(pZ, w([
            0
        ]), kGn)
    }, qGn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, FGn = {
        ur: Ot
    }, jGn = A2(bk, w([
        "known_practices"
    ]), oM), DGn = F3(function(n, r, t) {
        return A4(aA, GQ(n), ek(CQ), t, A2($k, function(n) {
            var r = n(FGn).ur;
            return r.$ ? g : w([
                A2(g_, "name", r.a)
            ]);
        }(r), pk(jGn)));
    }), VGn = F2(function(n, r) {
        return A3(DGn, n, function(n) {
            return m(n, {
                ur: r
            });
        }, qGn);
    }), BGn = {
        b2: Ot
    }, GGn = function(n) {
        return n.ur;
    }, zGn = F2(function(n, r) {
        return r.$ ? n(YP) : GGn(r.a);
    }), SGn = function(n) {
        return n.sl;
    }, TGn = function(n) {
        return It(n.$ ? "Other" : SGn(n.a));
    }, PGn = "known-practices", ZGn = w([
        1,
        0
    ]), MGn = function(n) {
        return 1 === n ? "DpcPractice" : "DpcPracticeOther";
    }, LGn = function(n) {
        return v({
            g0: n.g0,
            rc: 0,
            le: vZ(BGn),
            e9: Jwn({
                sl: PGn + "-select",
                Gj: zGn,
                Gk: TGn
            }),
            il: kc,
            fU: !1,
            A: A2(pZ, ZGn, MGn)
        }, A2(VGn, n.g0, Ot));
    }, NGn = {
        kF: !1,
        no: g,
        oM: 0,
        oY: 0,
        hF: !0,
        lX: !1,
        jq: !1
    }, HGn = function(n) {
        return !n;
    }, IGn = function(n) {
        return n.wQ;
    }, OGn = function(n) {
        return n.y$;
    }, QGn = F2(function(n, r) {
        switch(r){
            case 0:
                return n + "-first-name";
            case 1:
                return n + "-last-name";
            case 2:
                return n + "-relationship";
            case 3:
                return n + "-chosen-first-name";
            case 4:
                return n + "-chosen-last-name";
            case 5:
                return n + "-dob";
            case 6:
                return n + "-ssn";
            case 7:
                return n + "-email";
            case 8:
                return n + "-phones";
            case 9:
                return n + "-address";
            case 10:
                return n + "-gender";
            case 11:
                return n + "-gender-identity";
            case 12:
                return n + "-pronouns";
            case 13:
                return n + "-title";
            case 14:
                return n + "-chosen-title";
            case 15:
                return n + "-sex";
            default:
                return n + "-emergency-contact";
        }
    }), RGn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), UGn = F4(function(n, r, t, e) {
        return nE(n) ? e : m(e, {
            cO: A3(RGn, n, r, t)
        });
    }), KGn = F4(function(n, r, t, e) {
        return A4(UGn, t.no, ax(r), Xw(r), A2(Gxn, t.kF, A2(xc, Nwn(A2(QGn, n, 9)), A2(Op, s_n(A2(QGn, n, 9)), function(n) {
            return A2(bb, function(n) {
                return OGn(n) && !HGn(IGn(n)) ? Ot : It(function(n) {
                    return {
                        zQ: n.nc,
                        zR: n.nd,
                        oE: n.na,
                        AS: n.nb,
                        x6: n.ne,
                        zF: n.nf
                    };
                }(n));
            }, n);
        }(e)))));
    }), WGn = function(n) {
        return n.oz;
    }, XGn = function(n) {
        return A2(xc, "", A2(bb, WGn, n));
    }, YGn = function(n) {
        return n.oA;
    }, JGn = function(n) {
        return A2(xc, "", A2(bb, YGn, n));
    }, nzn = function(n) {
        return n.oB;
    }, rzn = function(n) {
        return A2(xc, "", A2(bb, nzn, n));
    }, tzn = A2(tu, bb(function(n) {
        return n.oC;
    }), xc("")), ezn = function(n) {
        return n.oD;
    }, uzn = F2(function(n, r) {
        var t = !mu(A2(xc, "", A2(bb, YGn, r)));
        return v(A2(O_n, A2(bb, ezn, r), $xn(A2(QGn, n, 14))), t);
    }), azn = function(n) {
        return n.qj;
    }, izn = F3(function(n, r, t) {
        return A2(ZM, A2(bb, azn, t), A2(hZ, r.hF, lZ(A2(QGn, n, 5))));
    }), czn = function(n) {
        return n.qN;
    }, ozn = function(n) {
        return A2(xc, "", A2(bb, czn, n));
    }, fzn = function(n) {
        return A2(sjn, n, Ajn);
    }, szn = F2(function(n, r) {
        if (r.$) return fzn(n);
        var t = r.a, e = HGn(IGn(t)), u = function(n) {
            return n.qS;
        }(t);
        return u.$ ? e ? mjn(n) : fzn(n) : function(n) {
            return n.y0;
        }(t) ? fzn(n) : A2(Cjn, n, u);
    }), lzn = function(n) {
        return n.rA;
    }, dzn = function(n) {
        return A2(xc, "", A2(Op, lzn, n));
    }, vzn = function(n) {
        return n.rV;
    }, bzn = function(n) {
        return n.rW;
    }, mzn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pzn = F2(function(n, r) {
        return m(r, {
            le: A3(cN, T_n, mzn(n), r.le)
        });
    }), $zn = F2(function(n, r) {
        return A2(pzn, A2(xc, "", A2(bb, bzn, r)), A2(Z_n, A2(bb, vzn, r), A2(qxn, A2(QGn, n, 11), Tyn.sT)));
    }), gzn = function(n) {
        return n.rU;
    }, hzn = function(n) {
        return n.rX;
    }, yzn = F2(function(n, r) {
        return m(r, {
            wZ: n
        });
    }), wzn = F3(function(n, r, t) {
        return A2(pzn, A2(xc, "", A2(bb, hzn, t)), A2(Z_n, A2(bb, gzn, t), A2(yzn, r.jq, A2(Axn, A2(QGn, n, 10), Swn.sT))));
    }), xzn = function(n) {
        return n.sV;
    }, _zn = function(n) {
        return A2(xc, "", A2(Op, xzn, n));
    }, Czn = function(n) {
        return n.ue;
    }, Azn = function(n) {
        return A2(xc, "", A2(bb, Czn, n));
    }, kzn = function(n) {
        return n.vQ;
    }, Ezn = F4(function(n, r, t, e) {
        var u = Dxn(r), a = A2(bb, kzn, e);
        return (u ? Vxn(UP) : cu)(A2(z_n, a, A2(zxn, t.lX, cxn(A2(QGn, n, 8)))));
    }), qzn = F2(function(n, r) {
        var t;
        return t = rb(n), r.$ ? t : A2(eg, function(n) {
            return n.v9;
        }(r.a), t);
    }), Fzn = function(n) {
        return n.wl;
    }, jzn = function(n) {
        return n.wm;
    }, Dzn = F2(function(n, r) {
        var t = A2(bb, jzn, r);
        return A2(pzn, A2(xc, "", A2(bb, Fzn, r)), A2(Z_n, t, A2(jxn, A2(QGn, n, 12), Zyn.sT)));
    }), Vzn = function(n) {
        return A2(Op, IGn, n);
    }, Bzn = function(n) {
        return n.xt;
    }, Gzn = F2(function(n, r) {
        return m(r, {
            wZ: n
        });
    }), zzn = F3(function(n, r, t) {
        return A2(N_n, A2(bb, Bzn, t), A2(Gzn, r.jq, dxn(A2(QGn, n, 15))));
    }), Szn = function(n) {
        return n.x_;
    }, Tzn = function(n) {
        return A2(xc, "", A2(bb, Szn, n));
    }, Pzn = A2(tu, bb(function(n) {
        return n.ym;
    }), xc("")), Zzn = function(n) {
        return n.yx;
    }, Mzn = F2(function(n, r) {
        return A2(O_n, A2(bb, Zzn, r), $xn(A2(QGn, n, 13)));
    }), Lzn = function(n) {
        return A2(xc, !0, A2(Op, OGn, n));
    }, Nzn = F4(function(n, r, t, e) {
        var u = A2(uzn, n, e), a = u.a, i = u.b;
        return {
            m9: A4(KGn, n, r, t, e),
            oz: XGn(e),
            oA: JGn(e),
            oB: rzn(e),
            oC: tzn(e),
            oD: a,
            bq: A3(izn, n, t, e),
            qN: ozn(e),
            qS: A2(szn, n, e),
            rA: dzn(e),
            rU: A3(wzn, n, t, e),
            rV: A2($zn, n, e),
            an: i,
            sV: _zn(e),
            ue: Azn(e),
            vQ: A4(Ezn, n, r, t, e),
            v9: A2(qzn, n, e),
            wm: A2(Dzn, n, e),
            wQ: Vzn(e),
            xt: A3(zzn, n, t, e),
            x_: Tzn(e),
            ym: Pzn(e),
            yx: A2(Mzn, n, e),
            y$: Lzn(e)
        };
    }), Hzn = w([
        13,
        0,
        1,
        2,
        14,
        3,
        4,
        5,
        15,
        10,
        11,
        12,
        6,
        7,
        8,
        9
    ]), Izn = function(n) {
        switch(n){
            case 0:
                return "First Name";
            case 1:
                return "Last Name";
            case 2:
                return "Relationship";
            case 3:
                return "Chosen First Name";
            case 4:
                return "Chosen Last Name";
            case 5:
                return "Date Of Birth";
            case 6:
                return "SSN";
            case 7:
                return "Email";
            case 8:
                return "Phone";
            case 9:
                return "Address";
            case 10:
                return "Gender";
            case 11:
                return "Gender Identity";
            case 12:
                return "Pronouns";
            case 13:
                return "Title";
            case 14:
                return "Chosen Title";
            case 15:
                return "Sex";
            default:
                return "Emergency Contact";
        }
    }, Ozn = F3(function(n, r, t) {
        var e = t(NGn);
        return {
            ox: Ot,
            a6: e,
            le: vZ(A4(Nzn, n, r, e, Ot)),
            sl: n,
            dV: r,
            d0: p7,
            A: A2(pZ, Hzn, Izn)
        };
    }), Qzn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Rzn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Uzn = {
        $: 1
    }, Kzn = {
        $: 2
    }, Wzn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xzn = function(n) {
        return n_n(n);
    }, Yzn = function(n) {
        return 2 === n;
    }, Jzn = function(n) {
        var r = n;
        return Yzn(r) || n_n(r);
    }, nSn = function(n) {
        return n.eT.z$;
    }, rSn = function(n) {
        return n.eT.Dl;
    }, tSn = function(n) {
        return n.eT.EC;
    }, eSn = F2(function(n, r) {
        if (1 === r.$) return n(tSn);
        var t = r.a;
        switch(t.$){
            case 0:
                return "< " + oe(t.a) + " mi";
            case 1:
                return n(nSn);
            default:
                return n(rSn);
        }
    }), uSn = Cd({
        sl: "filter-select",
        Gj: eSn,
        Gk: function(n) {
            return It(function() {
                if (1 === n.$) return "Filter by distance";
                var r = n.a;
                switch(r.$){
                    case 0:
                        return "< " + oe(r.a) + " mi";
                    case 1:
                        return "Any distance";
                    default:
                        return "No Filter";
                }
            }());
        }
    }), aSn = {
        aC: Ot,
        fX: uSn,
        zF: ""
    }, iSn = F3(function(n, r, t) {
        return 1 === t.$ ? r(t.a) : n(t.a);
    }), cSn = F2(function(n, r) {
        return 1 === r.$ ? It(n(r.a)) : Ot;
    }), oSn = Cd({
        sl: "locations-select",
        Gj: function(n) {
            return A2(iSn, n, function(n) {
                return n.ur;
            });
        },
        Gk: cSn(function(n) {
            return n.sl;
        })
    }), fSn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sSn = QB, lSn = fSn(sSn), dSn = function(n) {
        return {
            k5: aSn,
            e3: !1,
            e4: !1,
            lp: lSn,
            fi: oSn,
            dV: n,
            dW: ""
        };
    }, vSn = {
        $: 0
    }, bSn = function(n) {
        return n.sl;
    }, mSn = function(n) {
        var r = myn(n);
        return iL(r) ? Ot : It(r);
    }, pSn = function(n) {
        return n.zf;
    }, $Sn = F2(function(n, r) {
        var t = pSn(r) ? " (Virtual Location)" : "", e = oyn(r), u = A2(bb, mSn, vmn(r));
        return u.$ ? $(e, t) : e + " (" + u.a + ")" + t;
    }), gSn = Cd({
        sl: "practitioner-locations-select",
        Gj: $Sn,
        Gk: function(n) {
            return It(bSn(n));
        }
    }), hSn = F3(function(n, r, t) {
        return {
            kI: t,
            dV: n,
            bJ: vSn,
            fG: gSn,
            y_: r
        };
    }), ySn = function(n) {
        return n.mh;
    }, wSn = function(n) {
        return n.$ ? Ot : It(n.a);
    }, xSn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), _Sn = {
        $: 0
    }, CSn = function(n) {
        return A2(xc, _Sn, A2(Op, function(r) {
            return A2(xSn, r, n.zF);
        }, n.aC));
    }, ASn = F4(function(n, r, t, e) {
        var u = function() {
            var n = CSn(t.k5);
            if (1 === n.$) {
                var r = n.a, e = n.b;
                return iL(e) ? v(Ot, Ot) : v(wSn(r), It(e));
            }
            return v(Ot, Ot);
        }();
        return m(e, {
            k5: u.a,
            lo: n,
            iH: 0,
            mp: r,
            zF: u.b
        });
    }), kSn = function(n) {
        return n.mj;
    }, ESn = {
        lo: 250,
        mp: Ot,
        zF: Ot
    }, qSn = function(n) {
        return A2(bk, w([
            "locations"
        ]), fM(n));
    }, FSn = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), ek(Qvn), e, A2($k, function(n) {
            var r, t = n(ESn);
            return vc(w([
                function() {
                    var n = t.mp;
                    return n.$ ? g : w([
                        A2(g_, "signup_page", n.a)
                    ]);
                }(),
                w([
                    A2(iA, "limit", t.lo)
                ]),
                (r = t.zF, r.$ ? g : w([
                    A2(g_, "zip", r.a)
                ]))
            ]));
        }(t), pk(qSn(r))));
    }), jSn = F3(function(n, r, t) {
        return m(t, {
            mp: n,
            zF: r
        });
    }), DSn = {
        P: 0,
        Q: 0,
        bx: Ot,
        hY: Ot,
        mh: Ot,
        mj: Ot
    }, VSn = function(n) {
        return Yzn(n);
    }, BSn = F2(function(n, r) {
        return m(r, {
            k5: n
        });
    }), GSn = F2(function(n, r) {
        return m(r, {
            e3: !n
        });
    }), zSn = F2(function(n, r) {
        return m(r, {
            e4: !n
        });
    }), SSn = {
        $: 1
    }, TSn = F2(function(n, r) {
        return m(r, {
            aC: It(SSn),
            zF: n
        });
    }), PSn = F4(function(n, r, t, e) {
        var u, a = cA, i = e(DSn), c = ((u = i.hY).$ ? cu : TSn(u.a))(aSn), o = lA(a), f = v(A4(FSn, n, ux(t), A2(jSn, i.bx, i.hY), Qzn), A_), s = f.a, l = f.b, d = Jzn(i.Q) ? b(Wzn(A3(hSn, t, !0, VSn(i.Q))), !0, Xzn(i.P)) : Xzn(i.P) ? b(Uzn, !1, !1) : b(Kzn, !1, !1), m = d.a, p = A2(zSn, d.b, A2(GSn, d.c, A2(BSn, c, dSn(t)))), $ = Jzn(i.Q) ? v(A4(QQ, n, ux(t), A3(ASn, o, i.bx, p), Rzn), A_) : v(Qp, kc), h = $.a;
        return v({
            g0: n,
            P: i.P,
            Q: i.Q,
            eZ: g,
            aC: p,
            bx: i.bx,
            it: l,
            lQ: a,
            dV: t,
            bK: $.b,
            mh: ySn(i),
            mj: kSn(i),
            f$: m,
            mA: r
        }, w([
            h,
            s
        ]));
    }), ZSn = {
        y3: !1
    }, MSn = "member-input", LSn = F3(function(n, r, t) {
        var e, u = ux(n), a = A4(PSn, r.g0, Vx(r.ld), n, cu).a, i = LGn(r), c = i.a, o = i.b, f = A3(j0, !1, r.g0, ux(n)), s = f.a, l = f.b;
        return v({
            g0: r.g0,
            hz: Ot,
            kY: Ot,
            b$: vZ(EGn),
            aa: A_,
            a4: (e = s, m(e, {
                iE: !0
            })),
            az: c,
            eZ: g,
            ld: r.ld,
            h2: !1,
            ia: !1,
            ic: Ot,
            W: A3(Ozn, MSn, n, cu),
            Da: Ot,
            dV: n,
            aL: a,
            wk: !1,
            fL: Ot,
            f2: Ot,
            bQ: ZSn,
            mA: Vx(r.ld),
            yZ: t
        }, Uu(w([
            A4(hVn, r.g0, u, t.Ep.sl, CGn),
            A2(Nu, AGn, Yz),
            A2(Wp, _Gn, o),
            A2(Wp, xGn, l)
        ])));
    }), NSn = F2(function(n, r) {
        return v(r, Qp);
    }), HSn = F2(function(n, r) {
        return m(r, {
            zK: It(2)
        });
    }), ISn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, OSn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, QSn = vx(w([
        A2(kj, OSn, Oxn)
    ])), RSn = F2(function(n, r) {
        return {
            $: 14,
            a: n,
            b: r
        };
    }), USn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, KSn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, WSn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, XSn = F3(function(n, r, t) {
        return {
            sl: n,
            lh: r,
            sT: t
        };
    }), YSn = function(n) {
        return FF(Le(n));
    }, JSn = function(n) {
        return n.rN;
    }, nTn = function(n) {
        return !nE(JSn(n));
    }, rTn = function(n) {
        return n.sK;
    }, tTn = function(n) {
        return rTn(n.a);
    }, eTn = F2(function(n, r) {
        if (r.$) return !1;
        var t = r.a;
        return tTn(n) && function(n) {
            return n.qv;
        }(t);
    }), uTn = function(n) {
        return n.o_;
    }, aTn = F2(function(n, r) {
        if (r.$) return !1;
        var t = r.a;
        return uTn(n) && function(n) {
            return n.yE;
        }(t);
    }), iTn = F3(function(n, r, t) {
        return A2(eTn, n, r) || A2(aTn, t, r) || nTn(t);
    }), cTn = F3(function(n, r, t) {
        return A3(iTn, n, r, t) ? It(1) : Ot;
    }), oTn = function(n) {
        return n.oT;
    }, fTn = function(n) {
        return n.oW;
    }, sTn = function(n) {
        return function(n) {
            return Yzn(fTn(n));
        }(n) || function(n) {
            return n_n(fTn(n));
        }(n);
    }, lTn = function(n) {
        return sTn(n) || function(n) {
            return n_n(oTn(n));
        }(n) ? It(2) : Ot;
    }, dTn = F3(function(n, r, t) {
        if (n.$) return g;
        var e = n.a;
        return A2(n$, cu, w([
            It(0),
            A3(cTn, r, t, e),
            lTn(e),
            It(3)
        ]));
    }), vTn = F4(function(n, r, t, e) {
        return A2(xc, -1, A2(YSn, e, A3(dTn, n, r, t)));
    }), bTn = F2(function(n, r) {
        if (n.$) return "";
        var t = n.a;
        switch(r){
            case 0:
                return "Member Information";
            case 1:
                return "Custom Details";
            case 2:
                return sTn(t) ? "Provider" : "Location";
            default:
                return "Confirmation";
        }
    }), mTn = F4(function(n, r, t, e) {
        return A3(XSn, e, A4(vTn, n, r, t, e), A2(bTn, n, e));
    }), pTn = F3(function(n, r, t) {
        return A2(Fu, A3(mTn, n, r, t), A3(dTn, n, r, t));
    }), $Tn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, gTn = F5(function(n, r, t, e, u) {
        var a = A2(xc, g, A2(Op, function(n) {
            return w([
                n
            ]);
        }, u));
        return A7(p1, n, r, It(t), e, a, !1, $Tn);
    }), hTn = function(n) {
        var r = FM(n.le);
        return r.an && !function(n) {
            var r = n.oA;
            return iL(n.oz) && iL(r);
        }({
            oz: r.oz,
            oA: r.oA
        }) ? A2(fe, " ", w([
            r.oz,
            r.oB,
            r.oA
        ])) : A2(fe, " ", w([
            r.rA,
            r.ue,
            r.sV
        ]));
    }, yTn = function(n) {
        var r = FM(n.le).bq;
        return !iL(hTn(n)) && Cz(KM(r));
    }, wTn = {
        $: 0
    }, xTn = F2(function(n, r) {
        if (A2(pU, r, n)) return Ot;
        var t = Qb(n) - Qb(r);
        return It(2 === A2(pU, A3(q_, 0, t, r), n) ? t - 1 : t);
    }), _Tn = F2(function(n, r) {
        var t = A2(xTn, n, r);
        return t.$ ? wTn : function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.a);
    }), CTn = function(n) {
        var r = FM(n.le);
        return KM(r.bq);
    }, ATn = F2(function(n, r) {
        return A2(Op, _Tn(n), CTn(r));
    }), kTn = function(n) {
        return 1 === n.$ ? It(n.a) : Ot;
    }, ETn = F2(function(n, r) {
        return r.oy(n);
    }), qTn = function(n) {
        return 2 === n;
    }, FTn = function(n) {
        return A2(xc, !1, A2(Op, qTn, n));
    }, jTn = function(n) {
        var r = FM(n.le);
        return FTn(r.wQ);
    }, DTn = F2(function(n, r) {
        return function(t) {
            return A2(fe, eb(n), A2(Fu, function(n) {
                return n(t);
            }, r));
        };
    }), VTn = F2(function(n, r) {
        return n.$ ? r : A2(DTn, " ", w([
            r,
            rGn(n.a)
        ]));
    }), BTn = F3(function(n, r, t) {
        return jTn(t) ? A2(bb, function(r) {
            return s(r, n) > 0 ? It(A2(VTn, It(t.dV), ETn(oe(n)))) : Ot;
        }, A2(bb, kTn, A2(ATn, r, t))) : Ot;
    }), GTn = function(n) {
        return n.qk;
    }, zTn = function(n) {
        return !n.$;
    }, STn = F2(function(n, r) {
        return A2(bb, function(n) {
            return n ? It(GTn) : Ot;
        }, A2(Op, zTn, A2(ATn, n, r)));
    }), TTn = F2(function(n, r) {
        return r.tu(n);
    }), PTn = function(n) {
        return TTn(oe(n));
    }, ZTn = F3(function(n, r, t) {
        return A2(bb, function(r) {
            return s(r, n) > 0 ? It(A2(VTn, It(t.dV), PTn(n))) : Ot;
        }, A2(bb, kTn, A2(ATn, r, t)));
    }), MTn = F2(function(n, r) {
        return r.uh(n);
    }), LTn = function(n) {
        return MTn(oe(n));
    }, NTn = F3(function(n, r, t) {
        return A2(bb, function(r) {
            return 0 > s(r, n) ? It(A2(VTn, It(t.dV), LTn(n))) : Ot;
        }, A2(bb, kTn, A2(ATn, r, t)));
    }), HTn = F3(function(n, r, t) {
        var e = v(n, r);
        if (e.a.$ || e.b.$) return g;
        var u = e.a.a, a = e.b.a, i = A2(bb, function(n) {
            return A3(NTn, n, u, t);
        }, function(n) {
            return n.ul;
        }(a)), c = A2(bb, function(n) {
            return A3(ZTn, n, u, t);
        }, function(n) {
            return n.tw;
        }(a)), o = A2(STn, u, t), f = A2(bb, function(n) {
            return A3(BTn, n, u, t);
        }, function(n) {
            return n.ox;
        }(a));
        return A2(n$, cu, w([
            o,
            i,
            c,
            f
        ]));
    }), ITn = F3(function(n, r, t) {
        var e = A3(HTn, n, r, t);
        return yTn(t) && nE(e);
    }), OTn = function(n) {
        switch(n){
            case 0:
                return K_n("owner");
            case 1:
                return K_n("spouse");
            case 2:
                return K_n("child");
            default:
                return K_n("other");
        }
    }, QTn = function(n) {
        return n.$ ? nx : K_n(n.a);
    }, RTn = function(n) {
        return QTn(A2(Op, NS, n));
    }, UTn = F4(function(n, r, t, e) {
        var u = e.$ ? g : w([
            v("uses_tobacco", Yw(e.a))
        ]);
        return A2(Qt, v("name", K_n(n)), A2(Qt, v("dob", RTn(r)), A2(Qt, v("relationship", OTn(t)), u)));
    }), KTn = function(n) {
        return n.y3;
    }, WTn = F5(function(n, r, t, e, u) {
        if (A3(ITn, n, r, t)) {
            var a = A2(aTn, u, r) ? It(KTn(e)) : Ot, i = jTn(t) ? 2 : 1, c = hTn(t), o = CTn(t);
            return It(A4(UTn, c, o, i, a));
        }
        return Ot;
    }), XTn = F3(function(n, r, t) {
        var e = aQ(VBn(t)), u = bU(VBn(t));
        if (!iL(e) && Cz(u)) {
            var a = A2(aTn, n, It(r)) ? function(n) {
                return n.a.y3;
            }(VBn(t)) : Ot, i = function(n) {
                return n.wQ;
            }(t);
            return It(A4(UTn, e, u, i, a));
        }
        return Ot;
    }), YTn = function(n) {
        return n.vV;
    }, JTn = F6(function(n, r, t, e, u, a) {
        return {
            zZ: u,
            g1: a,
            ht: r,
            qG: t,
            sl: n,
            vL: e
        };
    }), nPn = F5(function(n, r, t, e, u) {
        return {
            g1: e,
            ht: r,
            qd: u,
            qF: t,
            sl: n
        };
    }), rPn = {
        $: 0
    }, tPn = F2(function(n, r) {
        var t = v(n, r);
        return t.a.$ ? t.b.$ ? AA("Either percent_off or amount_off_in_cents is required") : au(function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.b.a)) : au(function(n) {
            return {
                $: 0,
                a: n
            };
        }(t.a.a));
    }), ePn = {
        $: 1
    }, uPn = function(n) {
        return au(n > 1 ? function(n) {
            return {
                $: 2,
                a: n
            };
        }(n) : ePn);
    }, aPn = A2(nu, function(n) {
        return A3(nk, "percent_off", A2(tPn, n.vL, n.zZ), A2(zB, n.g1, A2(zB, n.qG, A2(zB, n.ht, A2(zB, n.sl, au(nPn))))));
    }, A3(nk, "apply_to_each_patient", ru, A3(nk, "amount_off_in_cents", uC(O$), A3(nk, "percent_off", uC(I$), A4(JA, "duration_in_months", A2(nu, uPn, O$), rPn, A3(nk, "code", M$, A3(nk, "id", M$, au(JTn)))))))), iPn = A2($A, aPn, au(cu)), cPn = F3(function(n, r, t) {
        return {
            ng: t,
            ur: n,
            wE: r
        };
    }), oPn = A3(nk, "age", O$, A3(nk, "rate_in_cents", O$, A3(nk, "name", A2(eu, GV, M$), au(cPn)))), fPn = A2($A, A2(eu, cu, oPn), au(cu)), sPn = A3(nk, "mce", ru, A3(nk, "contract_final_billing_end_date", uC(KA), A3(nk, "coupon", uC(iPn), A3(nk, "start_date", KA, A3(nk, "coupon_discount_in_cents", uC(O$), A3(nk, "recurring_amount_in_cents", O$, A3(nk, "ongoing_amount_in_cents", O$, A3(nk, "registration_fee_in_cents", O$, A3(nk, "billing_period", A2(nu, vQ, M$), A3(nk, "members", ek(fPn), au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                Ag: r,
                                                pl: o,
                                                pt: c,
                                                pu: a,
                                                ty: f,
                                                fm: n,
                                                lM: e,
                                                jd: u,
                                                je: t,
                                                x0: i
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))), lPn = A2($A, sPn, au(cu)), dPn = F4(function(n, r, t, e) {
        return A4(lM, GQ(n), lPn, e, A2(dM, rx(w([
            v("quote", t)
        ])), pk(function(n) {
            return A2(bk, w([
                "quotes"
            ]), fM(n));
        }(r))));
    }), vPn = F8(function(n, r, t, e, u, a, i, c) {
        var o, f = v(Cz(t), e);
        if (f.a && !f.b.$) {
            var s = f.b.a, l = v("plan", (o = It(YTn(s))).$ ? nx : rx(w([
                v("id", tx(o.a))
            ]))), d = A2(Fu, A2(XTn, i, s), zVn(s)), b = v("period_in_months", NQ(lU(vBn(s)))), m = A2(n$, cu, $(d, w([
                A5(WTn, t, e, u, a, i)
            ]))), p = w([
                l,
                b,
                v("members", A2(WU, function(n) {
                    return rx(n);
                }, m))
            ]);
            return A4(dPn, n, ux(r), rx(p), c);
        }
        return Qp;
    }), bPn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mPn = function(n) {
        return n.sl;
    }, pPn = F2(function(n, r) {
        return {
            aj: r,
            U: g,
            sl: n
        };
    }), $Pn = function(n) {
        return A2(Fu, function(n) {
            var r = mPn(n);
            return A2(pPn, "input-" + r, n);
        }, n);
    }, gPn = F2(function(n, r) {
        var t = m(r, {
            A: A3(fN, !0, 0, r.A)
        });
        return m(t, {
            cT: n
        });
    }), hPn = function(n) {
        return n.iO;
    }, yPn = function(n) {
        return n.sl;
    }, wPn = F2(function(n, r) {
        var t;
        return A2(Jfn, "Dependent Added", w([
            esn(Qfn),
            (t = n, A2(rsn, "Membership ID", t)),
            tsn(r)
        ]));
    }), xPn = function(n) {
        return n.xb ? n.no : g;
    }, _Pn = function(n) {
        return n.oY;
    }, CPn = F2(function(n, r) {
        return m(r, {
            no: xPn(n),
            oM: Jxn(n),
            oY: _Pn(n)
        });
    }), APn = function(n) {
        return A2(__, pa, Ha({
            sl: VVn(n)
        }));
    }, kPn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, EPn = A3(nk, "use_primary_member_as_emergency_contact", ru, A3(nk, "emergency_contact", uC(_hn), A3(nk, "use_primary_address", ru, A3(nk, "title", A2(nu, bhn, uC(M$)), A3(nk, "ssn", uC(M$), A3(nk, "sex", A2(nu, vhn, uC(M$)), A3(nk, "relationship", A2(nu, vVn, M$), A3(nk, "pronoun_other", uC(M$), A3(nk, "pronouns", A2(nu, dhn, uC(M$)), A3(nk, "phones", uC(ek(whn)), A3(nk, "suffix", uC(M$), A3(nk, "middle_name", uC(M$), A3(nk, "last_name", M$, A3(nk, "preferred_language", fhn, A3(nk, "gender_other", uC(M$), A3(nk, "gender_identity_other", uC(M$), A3(nk, "gender_identity", A2(nu, lhn, uC(M$)), A3(nk, "gender", A2(nu, shn, uC(M$)), A3(nk, "first_name", M$, A3(nk, "email", uC(M$), A3(nk, "dob", uC(KA), A3(nk, "chosen_suffix", uC(M$), A3(nk, "chosen_title", A2(nu, bhn, uC(M$)), A3(nk, "chosen_middle_name", uC(M$), A3(nk, "chosen_last_name", uC(M$), A3(nk, "chosen_first_name", uC(M$), A3(nk, "address_zip", uC(M$), A3(nk, "address_state", uC(M$), A3(nk, "address_line2", uC(M$), A3(nk, "address_line1", uC(M$), A3(nk, "address_country", uC(M$), A3(nk, "address_city", uC(M$), A3(nk, "patient_id", uC(M$), A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return function(b) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(y) {
                                                                                        return function(w) {
                                                                                            return function(x) {
                                                                                                return function(_) {
                                                                                                    return function(C) {
                                                                                                        return function(A) {
                                                                                                            return function(k) {
                                                                                                                return function(E) {
                                                                                                                    return function(q) {
                                                                                                                        return function(F) {
                                                                                                                            return function(j) {
                                                                                                                                return function(D) {
                                                                                                                                    return function(V) {
                                                                                                                                        return function(B) {
                                                                                                                                            return {
                                                                                                                                                na: t,
                                                                                                                                                nb: e,
                                                                                                                                                nc: u,
                                                                                                                                                nd: a,
                                                                                                                                                ne: i,
                                                                                                                                                nf: c,
                                                                                                                                                oz: o,
                                                                                                                                                oA: f,
                                                                                                                                                oB: s,
                                                                                                                                                oC: d,
                                                                                                                                                oD: l,
                                                                                                                                                qj: v,
                                                                                                                                                qN: b,
                                                                                                                                                qS: V,
                                                                                                                                                rA: m,
                                                                                                                                                rU: p,
                                                                                                                                                rV: $,
                                                                                                                                                rW: g,
                                                                                                                                                rX: h,
                                                                                                                                                sl: n,
                                                                                                                                                sV: w,
                                                                                                                                                ue: x,
                                                                                                                                                fy: r,
                                                                                                                                                vQ: C,
                                                                                                                                                v9: y,
                                                                                                                                                wl: k,
                                                                                                                                                wm: A,
                                                                                                                                                wQ: E,
                                                                                                                                                xt: q,
                                                                                                                                                x_: F,
                                                                                                                                                ym: _,
                                                                                                                                                yx: j,
                                                                                                                                                y$: D,
                                                                                                                                                y0: B
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))))))))), qPn = A2($A, EPn, au(cu)), FPn = function(n) {
        return rx(n);
    }, jPn = F2(function(n, r) {
        return A2(bk, w([
            "memberships",
            r,
            "members"
        ]), fM(n));
    }), DPn = F5(function(n, r, t, e, u) {
        return A4(lM, n, qPn, u, A2(dM, function(n) {
            return rx(w([
                v("member", FPn(n))
            ]));
        }(e), pk(A2(jPn, r, t))));
    }), VPn = F2(function(n, r) {
        var t, e, u = FM(r.le);
        return v(n, (t = u.yx).$ ? nx : (e = t.a, K_n(A2(Dyn, Vx(0), e))));
    }), BPn = Yk("multi_language"), GPn = F3(function(n, r, t) {
        return BPn(n) ? A2(Qt, v("preferred_language", nCn(r)), t) : t;
    }), zPn = F2(function(n, r) {
        var t;
        return w([
            v("gender", (t = n, t.$ ? nx : function(n) {
                switch(n){
                    case 0:
                        return K_n("female");
                    case 1:
                        return K_n("male");
                    default:
                        return K_n("other");
                }
            }(t.a))),
            v("gender_other", K_n(r))
        ]);
    }), SPn = function(n) {
        var r = FM(n.le);
        return v(r.fZ, r.dU);
    }, TPn = F2(function(n, r) {
        var t;
        return w([
            v("gender_identity", (t = n, t.$ ? nx : function(n) {
                switch(n){
                    case 0:
                        return K_n("man");
                    case 1:
                        return K_n("woman");
                    case 2:
                        return K_n("non-binary");
                    case 3:
                        return K_n("trans man");
                    case 4:
                        return K_n("trans woman");
                    default:
                        return K_n("not listed");
                }
            }(t.a))),
            v("gender_identity_other", K_n(r))
        ]);
    }), PPn = F2(function(n, r) {
        var t;
        return w([
            v("pronouns", (t = n, t.$ ? nx : function(n) {
                switch(n){
                    case 0:
                        return K_n("He/Him/His");
                    case 1:
                        return K_n("She/Her/Hers");
                    case 2:
                        return K_n("They/Them/Theirs");
                    default:
                        return K_n("other");
                }
            }(t.a))),
            v("pronoun_other", K_n(r))
        ]);
    }), ZPn = function(n) {
        return nEn(n);
    }, MPn = F3(function(n, r, t) {
        var e = K_n(r.x_);
        return ZPn(n) || i(e, nx) ? t : A2(Qt, v("ssn", rx(w([
            v("number", e)
        ]))), t);
    }), LPn = function(n) {
        return J_n(Skn(n));
    }, NPn = xc(1), HPn = function(n) {
        var r = FM(n.le), t = A2(Qt, A2(VPn, "title", r.yx), A2(Qt, v("first_name", K_n(r.rA)), A2(Qt, v("middle_name", K_n(r.ue)), A2(Qt, v("last_name", K_n(r.sV)), A2(Qt, v("suffix", K_n(r.ym)), A2(Qt, v("email", K_n(r.qN)), A2(Qt, v("dob", RTn(KM(r.bq))), A2(Qt, v("relationship", OTn(NPn(r.wQ))), A2(Qt, v("use_primary_address", Yw(r.y$)), A2(Qt, v("phones", LPn(r.vQ)), A2(Qt, Gjn(r.qS), A2(Qt, function(n) {
            var r, t = FM(n.le);
            return v("sex", (r = t.xt).$ ? nx : function(n) {
                switch(n){
                    case 0:
                        return K_n("female");
                    case 1:
                        return K_n("male");
                    default:
                        return K_n("intersex");
                }
            }(r.a));
        }(r.xt), $(function(n) {
            var r = SPn(n);
            return A2(zPn, r.a, r.b);
        }(r.rU), $(function(n) {
            var r = SPn(n);
            return A2(TPn, r.a, r.b);
        }(r.rV), $(function(n) {
            var r = SPn(n);
            return A2(PPn, r.a, r.b);
        }(r.wm), $(W_n(r.m9), function(n) {
            return w(n.an ? [
                A2(VPn, "chosen_title", n.yx),
                v("chosen_first_name", K_n(n.oz)),
                v("chosen_middle_name", K_n(n.oB)),
                v("chosen_last_name", K_n(n.oA)),
                v("chosen_suffix", K_n(n.oC))
            ] : [
                v("chosen_title", nx),
                v("chosen_first_name", nx),
                v("chosen_middle_name", nx),
                v("chosen_last_name", nx),
                v("chosen_suffix", nx)
            ]);
        }(r)))))))))))))))));
        return A3(GPn, n.dV, r.v9, A3(MPn, n.a6.oY, r, t));
    }, IPn = F2(function(n, r) {
        return A2(Qt, v("accepted_documents", d2(n)), r);
    }), OPn = function(n) {
        return v("name", A2(xc, nx, A2(Op, function(n) {
            return K_n(n);
        }, n)));
    }, QPn = F2(function(n, r) {
        var t, e = A2(Op, GGn, n), u = e.$ ? r : It(e.a);
        return v("known_practice", rx(w([
            (t = A2(Op, SGn, n), v("id", A2(xc, nx, A2(Op, function(n) {
                return K_n(n);
            }, t)))),
            OPn(u)
        ])));
    }), RPn = function(n) {
        return FM(n.le).b2;
    }, UPn = function(n) {
        var r = RPn(n);
        if (r.$) return v("known_practice", nx);
        var t = r.a;
        return t.$ ? A2(QPn, Ot, It(t.a)) : A2(QPn, It(t.a), Ot);
    }, KPn = F2(function(n, r) {
        return RPn(n).$ ? r : A2(Qt, UPn(n), r);
    }), WPn = function(n) {
        var r = n.b;
        return rx(w([
            v("form_item", rx(w([
                v("id", K_n(n.a))
            ]))),
            v("answer", tx(r))
        ]));
    }, XPn = function(n) {
        return sJ(Pqn(n));
    }, YPn = function(n) {
        var r = function() {
            var r = n.nr;
            switch(r.$){
                case 0:
                    return w([
                        XPn(r.a)
                    ]);
                case 1:
                    return w([
                        r.a
                    ]);
                default:
                    return r.a;
            }
        }();
        return A2(Fu, function(r) {
            return v(n.dF, r);
        }, r);
    }, JPn = function(n) {
        var r, t, e;
        return rx(w([
            (e = n.aj, v("form", rx(w([
                v("id", K_n(mPn(e)))
            ])))),
            (r = n.U, t = vc(A2(Fu, YPn, r)), v("form_response_items", A2(WU, WPn, t)))
        ]));
    }, nZn = F2(function(n, r) {
        var t = n.f2;
        if (t.$) return r;
        if (nTn(t.a)) {
            var e = FM(n.b$);
            return A2(Qt, v("form_responses", A2(WU, JPn, e.cT)), r);
        }
        return r;
    }), rZn = F2(function(n, r) {
        return n.$ ? r : A2(Qt, v("location", rx(w([
            v("id", K_n(bSn(n.a)))
        ]))), r);
    }), tZn = F2(function(n, r) {
        return n.$ ? r : A2(Qt, v("practitioner", rx(w([
            v("id", K_n(rQ(n.a)))
        ]))), r);
    }), eZn = F4(function(n, r, t, e) {
        return r.$ ? e : A2(aTn, r.a, t) ? A2(Qt, v("uses_tobacco", Yw(n)), e) : e;
    }), uZn = function(n) {
        var r = v(n.it, n.mh);
        if (3 !== r.a.$ || r.b.$) return Ot;
        var t = r.b.a;
        return A2(SS, function(n) {
            return i(bSn(n), t);
        }, r.a.a);
    }, aZn = F2(function(n, r) {
        return A2(SS, function(n) {
            return i(rQ(n), r);
        }, n);
    }), iZn = function(n) {
        var r = v(n.bK, n.mj);
        return 3 !== r.a.$ || r.b.$ ? Ot : A2(aZn, r.a.a, r.b.a);
    }, cZn = Xn("scrollTopAndIntoView", tx), oZn = F2(function(n, r) {
        return m(r, {
            P: oTn(n),
            Q: fTn(n)
        });
    }), fZn = "add-member-top", sZn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lZn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dZn = F2(function(n, r) {
        return m(r, {
            b2: n
        });
    }), vZn = function(n) {
        return n.cN.sT;
    }, bZn = function(n) {
        return n.cN.CR;
    }, mZn = function(n) {
        return n.cN.Ei;
    }, pZn = function(n) {
        return n.cN.Ej;
    }, $Zn = function(n) {
        return n.cN.EC;
    }, gZn = function(n) {
        return n.cN.GO;
    }, hZn = XM(w([
        function(n) {
            var r = n.b2;
            if (r.$) return g;
            var t = r.a;
            return t.$ && mu(t.a) ? w([
                v(0, nL(A2(YM, rL, mZn)))
            ]) : g;
        }
    ])), yZn = function(n) {
        var r = A2(CL, hZn, n);
        return r.$ ? v(r.a, !1) : v(r.a.a, !0);
    }, wZn = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A, e = yZn(r.le), u = e.b;
        return v(m(r, {
            le: e.a,
            A: t
        }), u);
    }), xZn = function() {
        return It(1);
    }, _Zn = F2(function(n, r) {
        var t = xZn();
        if (t.$) return r;
        var e = t.a;
        return A2(EL, e, r.A) ? m(A2(wZn, !1, r).a, {
            A: A3(qL, !0, e, r.A)
        }) : r;
    }), CZn = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = A2(fkn, n.a, r.e9), e = t.b, u = t.c, a = m(r, {
                    e9: t.a
                }), i = function() {
                    if (u.$) return b(a, Qp, Ot);
                    if (u.a.$) {
                        var n = u.a.a;
                        return b(m(a, {
                            fU: !0
                        }), A2(VGn, a.g0, It(n)), Ot);
                    }
                    return b(A2(wZn, !1, m(a, {
                        rc: 0,
                        le: A3(cN, dZn, u.a.a, a.le)
                    })).a, Qp, Ot);
                }(), c = i.b, o = i.c;
                return b(i.a, Uu(w([
                    A2(Wp, sZn, e),
                    c
                ])), o);
            case 0:
                var f = n.a, s = m(r, {
                    il: f,
                    fU: !1
                });
                switch(f.$){
                    case 2:
                        return b(s, Qp, It(function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(Nk(f.a))));
                    case 3:
                        return b(s, Qp, Ot);
                    default:
                        return b(r, Qp, Ot);
                }
            case 3:
                return b(A2(_Zn, n.a, r), Qp, It({
                    $: 2,
                    a: "DPC Practice Option"
                }));
            case 2:
                return b(r, Qp, It({
                    $: 1,
                    a: "DPC Practice Option"
                }));
            default:
                var l = n.a, d = FM(r.le).b2;
                if (d.$) return b(r, Qp, Ot);
                if (d.a.$) {
                    var v = It(lZn(l)), p = A3(cN, dZn, v, r.le), $ = xZn();
                    if ($.$) return b(m(r, {
                        le: p
                    }), Qp, Ot);
                    var g = $.a, h = A3(fN, !0, g, r.A);
                    return b(m(r, {
                        le: A2(oN, g, h) ? yZn(p).a : p,
                        A: h
                    }), Qp, Ot);
                }
                return b(r, Qp, Ot);
        }
    }), AZn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kZn = function(n) {
        return n.sl;
    }, EZn = F2(function(n, r) {
        return i(kZn(n), r.dF);
    }), qZn = F2(function(n, r) {
        return mb(A2(no, EZn(r), n));
    }), FZn = F4(function(n, r, t, e) {
        return A2(qZn, e, r).$ ? A2(Qt, {
            nr: t,
            lf: n,
            dF: kZn(r),
            lg: Ot
        }, e) : A3(a9, EZn(r), function(n) {
            return m(n, {
                nr: t
            });
        }, e);
    }), jZn = F3(function(n, r, t) {
        var e = function() {
            var n = A2(qZn, t, r);
            if (n.$) return w([
                ""
            ]);
            var e = n.a.nr;
            return 2 === e.$ ? $(e.a, w([
                ""
            ])) : w([
                ""
            ]);
        }();
        return A4(FZn, n, r, AZn(e), t);
    }), DZn = F3(function(n, r, t) {
        var e = function() {
            var n = A2(qZn, t, r);
            if (n.$) return w([
                ""
            ]);
            var e = n.a.nr;
            if (2 === e.$) {
                var u = e.a;
                return A2(kP, ve(u) - 1, u);
            }
            return w([
                ""
            ]);
        }();
        return A4(FZn, n, r, AZn(e), t);
    }), VZn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, BZn = F4(function(n, r, t, e) {
        return A4(FZn, n, r, VZn(t), e);
    }), GZn = F5(function(n, r, t, e, u) {
        var a = function() {
            var n = A2(qZn, u, r);
            if (n.$) return w([
                t
            ]);
            var a = n.a.nr;
            return 2 === a.$ ? A3(eU, e, function() {
                return t;
            }, a.a) : w([
                t
            ]);
        }();
        return A4(FZn, n, r, AZn(a), u);
    }), zZn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, SZn = F4(function(n, r, t, e) {
        return A4(FZn, n, r, zZn(t), e);
    }), TZn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = n.b;
                return b(m(r, {
                    U: A4(SZn, mPn(r.aj), t, e, r.U)
                }), Qp, It(0));
            case 1:
                t = n.a;
                var u = n.b;
                return e = n.c, b(m(r, {
                    U: A5(GZn, mPn(r.aj), t, e, u, r.U)
                }), Qp, It(0));
            case 5:
                return t = n.a, b(m(r, {
                    U: A3(jZn, mPn(r.aj), t, r.U)
                }), Qp, It(0));
            case 6:
                return t = n.a, b(m(r, {
                    U: A3(DZn, mPn(r.aj), t, r.U)
                }), Qp, It(0));
            case 2:
                return b(r, Qp, It(2));
            case 3:
                return b(r, Qp, It(1));
            default:
                return t = n.a, e = n.b, b(m(r, {
                    U: A4(BZn, mPn(r.aj), t, e, r.U)
                }), Qp, It(0));
        }
    }), PZn = function(n) {
        return {
            $: 22,
            a: n
        };
    }, ZZn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, MZn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, LZn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, NZn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, HZn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, IZn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, OZn = function(n) {
        return {
            $: 23,
            a: n
        };
    }, QZn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, RZn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, UZn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, KZn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, WZn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, XZn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, YZn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, JZn = function(n) {
        return {
            $: 20,
            a: n
        };
    }, nMn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, rMn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, tMn = function(n) {
        return {
            $: 16,
            a: n
        };
    }, eMn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, uMn = {
        $: 3
    }, aMn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, iMn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, cMn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, oMn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, fMn = function(n) {
        return {
            $: 17,
            a: n
        };
    }, sMn = function(n) {
        return A2(Nu, fMn, Au(n));
    }, lMn = function(n) {
        switch(n.$){
            case 0:
                return "Title";
            case 1:
                return Izn(0);
            case 2:
                return "Middle Name";
            case 3:
                return Izn(1);
            case 4:
                return "Suffix";
            case 5:
                return "Has Chosen Name";
            case 6:
                return "Chosen Title";
            case 7:
                return Izn(3);
            case 8:
                return "Chosen Middle Name";
            case 9:
                return Izn(4);
            case 10:
                return "Chosen Suffix";
            case 11:
                return Izn(5);
            case 12:
                return "Relationship";
            case 13:
                return Izn(15);
            case 14:
                return Izn(10);
            case 15:
                return Izn(11);
            case 16:
                return Izn(12);
            case 17:
                return "Preferred Language";
            case 18:
                return Izn(6);
            case 19:
                return Izn(7);
            case 20:
                return Izn(8);
            case 21:
                return "Use Primary Address";
            case 22:
                return Izn(9);
            default:
                return Izn(16);
        }
    }, dMn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    yx: n.a
                });
            case 1:
                return m(r, {
                    rA: n.a
                });
            case 2:
                return m(r, {
                    ue: n.a
                });
            case 3:
                return m(r, {
                    sV: n.a
                });
            case 4:
                return m(r, {
                    ym: n.a
                });
            case 5:
                return m(r, {
                    an: n.a
                });
            case 6:
                return m(r, {
                    oD: n.a
                });
            case 7:
                return m(r, {
                    oz: n.a
                });
            case 8:
                return m(r, {
                    oB: n.a
                });
            case 9:
                return m(r, {
                    oA: n.a
                });
            case 10:
                return m(r, {
                    oC: n.a
                });
            case 11:
                return m(r, {
                    bq: n.a
                });
            case 12:
                return m(r, {
                    wQ: It(n.a)
                });
            case 13:
                return m(r, {
                    xt: n.a
                });
            case 14:
                return m(r, {
                    rU: n.a
                });
            case 15:
                return m(r, {
                    rV: n.a
                });
            case 16:
                return m(r, {
                    wm: n.a
                });
            case 17:
                return m(r, {
                    v9: n.a
                });
            case 18:
                return m(r, {
                    x_: n.a
                });
            case 19:
                return m(r, {
                    qN: n.a
                });
            case 20:
                return m(r, {
                    vQ: n.a
                });
            case 21:
                return m(r, {
                    y$: n.a
                });
            case 22:
                return m(r, {
                    m9: n.a
                });
            default:
                return m(r, {
                    qS: n.a
                });
        }
    }), vMn = F3(function(n, r, t) {
        return A2(t.re, n, r);
    }), bMn = F2(function(n, r) {
        return v(r.a, A2(YM, n, r.b));
    }), mMn = function(n) {
        return A2(xc, !1, A2(Op, HGn, n));
    }, pMn = function(n) {
        var r = n.m9, t = n.y$;
        return mMn(n.wQ) || t ? g : A2(Fu, function(n) {
            var r = n.a;
            return v(9, A2(bMn, function(n) {
                return A2(vMn, r, n);
            }, n.b));
        }, Ckn(r));
    }, $Mn = function(n) {
        return n.an && iL(n.oz) ? w([
            v(3, nL(A2(YM, rL, BEn)))
        ]) : g;
    }, gMn = function(n) {
        return n.an && iL(n.oA) ? w([
            v(4, nL(A2(YM, rL, zEn)))
        ]) : g;
    }, hMn = function(n) {
        return A2(n$, function(r) {
            return mb(A2(iH, r, n.le));
        }, bxn);
    }, yMn = function(n) {
        return n.an ? A2(Fu, function(n) {
            return v(14, n);
        }, hMn(n.oD)) : g;
    }, wMn = function(n) {
        return mMn(n.wQ) || !n.an ? g : vc(w([
            yMn(n),
            $Mn(n),
            gMn(n)
        ]));
    }, xMn = function(n) {
        return n.eZ;
    }, _Mn = function(n) {
        return A2(Fu, function(n) {
            return v(5, n);
        }, xMn(n.bq));
    }, CMn = F2(function(n, r) {
        var t = r.qN, e = !mMn(r.wQ);
        return e && iL(t) && n ? w([
            v(7, nL(A2(YM, rL, eL)))
        ]) : !e || iL(t) || oL(t) ? g : w([
            v(7, fL(A2(YM, uL, eL)))
        ]);
    }), AMn = function(n) {
        var r = n.qS;
        return A2(Fu, RC(16), Sjn(r));
    }, kMn = function(n) {
        return A2(n$, function(r) {
            return mb(A2(iH, r, n.le));
        }, hxn);
    }, EMn = function(n) {
        return A2(Fu, function(n) {
            return v(11, n);
        }, kMn(n.rV));
    }, qMn = function(n) {
        return A2(Fu, function(n) {
            return v(12, n);
        }, kMn(n.wm));
    }, FMn = function(n) {
        var r;
        return A2(Fu, function(n) {
            return v(15, n);
        }, (r = n.xt, A2(n$, function(n) {
            return mb(A2(iH, n, r.le));
        }, fxn)));
    }, jMn = F2(function(n, r) {
        return n ? vc(w([
            FMn(r),
            EMn(r),
            qMn(r)
        ])) : function(n) {
            return A2(Fu, function(n) {
                return v(10, n);
            }, kMn(n.rU));
        }(r);
    }), DMn = function(n) {
        return iL(n.sV) ? w([
            v(1, nL(A2(YM, rL, dL)))
        ]) : g;
    }, VMn = function(n) {
        return A2(Fu, function(n) {
            return v(14, n);
        }, hMn(n.yx));
    }, BMn = function(n) {
        var r;
        return mMn(n.wQ) ? g : vc(w([
            VMn(n),
            (r = n, iL(r.rA) ? w([
                v(0, nL(A2(YM, rL, lL)))
            ]) : g),
            DMn(n)
        ]));
    }, GMn = F4(function(n, r, t, e) {
        return A3(e.rf, n, r, t);
    }), zMn = F2(function(n, r) {
        return A2(YSn, r, function(n) {
            return A2(Fu, Oc, n.b);
        }(n));
    }), SMn = function(n) {
        return n.vO;
    }, TMn = F2(function(n, r) {
        var t = 1 + A2(xc, 0, A2(zMn, n.vQ, r));
        return A2(Fu, function(r) {
            return I2(n.vQ) > 1 ? A2(bMn, function(n) {
                return A2(YM, function(r) {
                    return A3(GMn, r, oe(t), n);
                }, SMn);
            }, r) : r;
        }, A2(Fkn, n, r));
    }), PMn = function(n) {
        return $(Tkn(n), vc(A2(h6, function(r) {
            return A2(TMn, n, r.b);
        }, n.vQ)));
    }, ZMn = function(n) {
        var r = n.vQ;
        return mMn(n.wQ) ? g : A2(Fu, function(n) {
            return v(8, n);
        }, PMn(r));
    }, MMn = function(n) {
        return n.wQ.zS;
    }, LMn = function(n) {
        return n.wQ.AB;
    }, NMn = function(n) {
        return n.wQ.sT;
    }, HMn = function(n) {
        return n.wQ.iO;
    }, IMn = function(n) {
        var r = n.wQ;
        return 1 === r.$ ? w([
            v(2, nL(A2(YM, rL, NMn)))
        ]) : (HGn(r.a), g);
    }, OMn = tV("###-##-####"), QMn = A2(Fu, function(n) {
        return A2(WD, OMn, n);
    }, w([
        "219099999",
        "078051120",
        "123456789"
    ])), RMn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, UMn = {
        $: 0
    }, KMn = F3(function(n, r, t) {
        return {
            BU: n,
            Fn: r,
            Ge: t
        };
    }), WMn = F2(function(n, r) {
        return s(r, n.ug) > -1 && 1 > s(r, n.tt);
    }), XMn = F2(function(n, r) {
        return r.$ ? A2(WMn, r.a, n) : function(n) {
            return !(!n || 666 === n || n >= 900 && 999 >= n);
        }(n);
    }), YMn = F3(function(n, r, t) {
        if (i(lu(t), n)) {
            var e = $u(t);
            return e.$ ? Um("Ssn part is not an integer.") : A2(XMn, e.a, r) ? Am(t) : Um("Ssn part is invalid.");
        }
        return Um("Ssn part is invalid.");
    }), JMn = F2(function(n, r) {
        return A2(ym, A2(YMn, n, r), Jm(Im(_e)));
    }), nLn = A2(Rm, A2(Rm, A2(Rm, Am(KMn), A2(Cm, A2(JMn, 3, UMn), HZ("-"))), A2(Cm, A2(JMn, 2, RMn({
        tt: 99,
        ug: 1
    })), HZ("-"))), A2(Cm, A2(JMn, 4, RMn({
        tt: 9999,
        ug: 1
    })), fp)), rLn = F2(function(n, r) {
        var t, e = r.x_;
        return iL(e) ? n_n(n) ? w([
            v(6, nL(A2(YM, rL, XFn)))
        ]) : g : !A2($p, nLn, t = A2(WD, OMn, e)).$ && !A2(Xk, t, QMn) || nEn(n) ? g : w([
            v(6, fL(A2(YM, uL, XFn)))
        ]);
    }), tLn = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, dMn, PZn(A2(qAn, n, t.m9)), r);
    }), eLn = F2(function(n, r) {
        return r.w0(n);
    }), uLn = F2(function(n, r) {
        return r.yx.$ && n ? w([
            v(0, nL(A2(YM, eLn, mL)))
        ]) : g;
    }), aLn = function(n) {
        var r = A2(CL, XM(w([
            uLn(n.wZ)
        ])), n.le);
        return r.$ ? v(r.a, !1) : v(r.a.a, !0);
    }, iLn = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A;
        return m(r, {
            le: aLn(r).a,
            A: t
        });
    }), cLn = F2(function(n, r) {
        var t = FM(r);
        return t.an ? A3(cN, dMn, LZn(A2(iLn, n, t.oD)), r) : r;
    }), oLn = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, dMn, HZn(A2(JL, n, t.bq)), r);
    }), fLn = F2(function(n, r) {
        var t = FM(r), e = Kjn(t.qS);
        return A3(cN, dMn, OZn(e), r);
    }), sLn = function(n) {
        return n.w_;
    }, lLn = F2(function(n, r) {
        var t = r.fZ, e = r.dU;
        return t.$ ? g : n(t.a) && iL(e) ? w([
            v(1, nL(sLn))
        ]) : g;
    }), dLn = F3(function(n, r, t) {
        return t.fZ.$ && n ? w([
            v(0, nL(A2(YM, eLn, r)))
        ]) : g;
    }), vLn = F3(function(n, r, t) {
        return XM(w([
            A2(dLn, r, t),
            lLn(n)
        ]));
    }), bLn = function(n) {
        var r = A2(CL, A3(vLn, n.CD, n.wZ, n.BQ), n.le);
        return r.$ ? v(r.a, !1) : v(r.a.a, !0);
    }, mLn = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A;
        return m(r, {
            le: bLn(r).a,
            A: t
        });
    }), pLn = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, dMn, KZn(A2(mLn, n, t.rU)), r);
    }), $Ln = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, dMn, WZn(A2(mLn, n, t.rV)), r);
    }), gLn = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, dMn, tMn(A2(mLn, n, t.wm)), r);
    }), hLn = F2(function(n, r) {
        return r.xt.$ && n ? w([
            v(0, nL(A2(YM, eLn, Lyn.sT)))
        ]) : g;
    }), yLn = function(n) {
        var r = A2(CL, XM(w([
            hLn(n.wZ)
        ])), n.le);
        return r.$ ? v(r.a, !1) : v(r.a.a, !0);
    }, wLn = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A;
        return m(r, {
            le: yLn(r).a,
            A: t
        });
    }), xLn = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, dMn, aMn(A2(wLn, n, t.xt)), r);
    }), _Ln = F3(function(n, r, t) {
        return r ? A2(gLn, n, A2($Ln, n, A2(xLn, n, t))) : A2(pLn, n, t);
    }), CLn = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, dMn, JZn(A2(Nkn, n, t.vQ)), r);
    }), ALn = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, dMn, cMn(A2(iLn, n, t.yx)), r);
    }), kLn = F2(function(n, r) {
        var t = uqn(r.dV), e = A2(fLn, n, A2(oLn, n, A2(tLn, n, A2(CLn, n, A3(_Ln, n, t, A2(cLn, n, A2(ALn, n, r.le))))))), u = A2(CL, function(n) {
            var r = uqn(n.dV), t = Mkn(n.dV);
            return XM(w([
                BMn,
                IMn,
                wMn,
                _Mn,
                jMn(r),
                rLn(n.a6.oY),
                CMn(t),
                ZMn,
                pMn,
                AMn
            ]));
        }(r), e);
        return u.$ ? v(u.a, !1) : v(u.a.a, !0);
    }), ELn = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A;
        return m(r, {
            le: A2(kLn, n, r).a,
            A: t
        });
    }), qLn = function(n) {
        switch(n.$){
            case 0:
                return It(13);
            case 1:
                return It(0);
            case 2:
            case 4:
            case 5:
            case 8:
            case 10:
            case 17:
            case 21:
                return Ot;
            case 3:
                return It(1);
            case 6:
                return It(14);
            case 7:
                return It(3);
            case 9:
                return It(4);
            case 11:
                return It(5);
            case 12:
                return It(2);
            case 13:
                return It(15);
            case 14:
                return It(10);
            case 15:
                return It(11);
            case 16:
                return It(12);
            case 18:
                return It(6);
            case 19:
                return It(7);
            case 20:
                return It(8);
            case 22:
                return It(9);
            default:
                return It(16);
        }
    }, FLn = F2(function(n, r) {
        var t = qLn(n);
        if (t.$) return r;
        var e = t.a;
        return A2(EL, e, r.A) ? m(A2(ELn, !1, r), {
            A: A3(qL, !0, e, r.A)
        }) : r;
    }), jLn = {
        F1: Atn(1500),
        Gs: function(n) {
            return {
                $: 16,
                a: n
            };
        }
    }, DLn = {
        $: 2
    }, VLn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, BLn = {
        $: 1
    }, GLn = function(n) {
        var r = FM(n.le).fZ;
        return A2(xc, "", A2(Op, n.mg(Vx(0)), r));
    }, zLn = function(n) {
        var r = A3(fN, !0, 0, n.A), t = m(n, {
            A: r
        });
        return A2(oN, 0, r) ? m(t, {
            le: bLn(n).a
        }) : t;
    }, SLn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(dG, n.a, r.gd), e = t.a, u = t.b, a = t.c, i = A2(xc, v(r, Ot), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            var t = A3(cN, T_n, S_n(n.a), r.le), e = zLn(m(r, {
                                le: t
                            }));
                            return v(e, It(VLn(GLn(e))));
                        case 1:
                            return v(r, It(BLn));
                        default:
                            return v(r, It(DLn));
                    }
                }, a)), c = i.b;
                return b(m(i.a, {
                    gd: e
                }), A2(Wp, lqn, u), c);
            case 1:
                var o = mzn(n.a);
                return b(f = zLn(m(r, {
                    le: A3(cN, T_n, o, r.le)
                })), Qp, It(VLn(GLn(f))));
            case 2:
                var f;
                return b(f = function() {
                    if (A2(EL, 0, r.A)) {
                        var n = A3(qL, !0, 0, r.A), t = bLn(r);
                        return m(r, {
                            le: t.a,
                            A: n
                        });
                    }
                    return r;
                }(), Qp, It(DLn));
            default:
                return b(r, Qp, It(BLn));
        }
    }), TLn = {
        $: 2
    }, PLn = {
        $: 1
    }, ZLn = F2(function(n, r) {
        var t = It(0);
        if (t.$) return r;
        var e = t.a, u = A3(fN, !0, e, r.A), a = m(r, {
            A: u
        });
        return A2(oN, e, u) ? m(a, {
            le: yLn(r).a
        }) : a;
    }), MLn = F2(function(n, r) {
        var t = A2(dG, n, r.f0), e = t.a, u = t.b, a = t.c, i = A2(xc, v(r, Ot), A2(Op, function(n) {
            switch(n.$){
                case 0:
                    var t = n.a;
                    return v(A2(ZLn, t, m(r, {
                        le: A3(cN, M_n, t, r.le)
                    })), A2(bb, function(n) {
                        return It(function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(A2(xc, "", lxn(n))));
                    }, t));
                case 1:
                    return v(r, It(PLn));
                default:
                    return v(r, It(TLn));
            }
        }, a)), c = i.b;
        return b(m(i.a, {
            f0: e
        }), A2(Wp, cu, u), c);
    }), LLn = {
        $: 2
    }, NLn = {
        $: 1
    }, HLn = F2(function(n, r) {
        var t = It(0);
        if (t.$) return r;
        var e = t.a, u = A3(fN, !0, e, r.A), a = m(r, {
            A: u
        });
        return A2(oN, e, u) ? m(a, {
            le: aLn(r).a
        }) : a;
    }), ILn = F2(function(n, r) {
        var t = n, e = FM(r.le).yx, u = A2(dG, t, r.gb), a = u.a, i = u.b, c = u.c, o = function() {
            if (c.$) return v(e, Ot);
            switch(c.a.$){
                case 0:
                    var n = c.a.a, r = A2(Op, function(n) {
                        return function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(A2(Dyn, Vx(0), n));
                    }, n);
                    return v(n, r);
                case 1:
                    return v(e, It(NLn));
                default:
                    return v(e, It(LLn));
            }
        }(), f = o.a, s = o.b;
        return b(A2(HLn, f, m(r, {
            le: A3(cN, H_n, f, r.le),
            gb: a
        })), A2(Wp, cu, i), s);
    }), OLn = F2(function(n, r) {
        var t = qLn(n);
        if (t.$) return r;
        var e = t.a, u = A3(fN, !0, e, r.A), a = m(r, {
            A: u
        });
        return A2(oN, e, u) ? m(a, {
            le: A2(kLn, !1, r).a
        }) : a;
    }), QLn = F2(function(n, r) {
        return A2(OLn, n, m(r, {
            le: A3(cN, dMn, n, r.le)
        }));
    }), RLn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(A2(QLn, t = n.a, r), A2(Nu, cu, Au(RZn(t))), It(MZn(lMn(t))));
            case 15:
                var t = function(n) {
                    return {
                        $: 21,
                        a: n
                    };
                }(n.a);
                return b(m(r, {
                    le: A3(cN, dMn, t, r.le)
                }), Qp, It(MZn(lMn(t))));
            case 1:
                var e = n.a, u = FM(r.le), a = A2(jAn, e, u.m9), i = a.b, c = a.c, o = PZn(a.a), f = A2(xc, v(Ot, r), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            var t = n.a;
                            return v(It(MZn(lMn(o) + ": " + t)), r);
                        case 1:
                            return t = n.a, v(It(UZn(lMn(o) + ": " + t)), r);
                        default:
                            return t = n.a, v(It(ZZn(lMn(o) + ": " + t)), A2(FLn, o, r));
                    }
                }, c)), s = f.a;
                return b(m(f.b, {
                    le: A3(cN, dMn, o, r.le)
                }), A2(Wp, OSn, i), s);
            case 2:
                return t = function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(n.a), b(m(r, {
                    le: A3(cN, dMn, t, r.le)
                }), Qp, It(MZn(lMn(t))));
            case 5:
                if (function(n) {
                    switch(n.$){
                        case 1:
                        case 2:
                        case 3:
                        case 7:
                        case 8:
                        case 9:
                        case 11:
                        case 12:
                            return !0;
                        default:
                            return !1;
                    }
                }(t = n.a)) {
                    var l = A3(Xnn, jLn, t, r.d0), d = l.b;
                    return b(m(r, {
                        d0: l.a
                    }), d, Ot);
                }
                return b(r, Qp, Ot);
            case 3:
                return b(A2(FLn, t = n.a, r), Qp, It(ZZn(lMn(t))));
            case 4:
                return b(r, Qp, It(UZn(lMn(t = n.a))));
            case 6:
                var p = n.a, $ = FM(r.le), g = A2(ILn, p, $.yx), h = g.b, y = g.c, x = (o = cMn(g.a), A2(xc, v(Ot, r), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            return v(It(MZn(lMn(o))), r);
                        case 1:
                            return v(It(UZn(lMn(o))), r);
                        default:
                            return v(It(ZZn(lMn(o))), A2(FLn, o, r));
                    }
                }, y)));
                return s = x.a, b(m(x.b, {
                    le: A3(cN, dMn, o, r.le)
                }), A2(Wp, oMn, h), s);
            case 7:
                var _ = n.a, C = FM(r.le), A = A2(ILn, _, C.oD), k = A.b, E = A.c, q = (o = LZn(A.a), A2(xc, v(Ot, r), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            return v(It(MZn(lMn(o))), r);
                        case 1:
                            return v(It(UZn(lMn(o))), r);
                        default:
                            return v(It(ZZn(lMn(o))), A2(FLn, o, r));
                    }
                }, E)));
                return s = q.a, b(m(q.b, {
                    le: A3(cN, dMn, o, r.le)
                }), A2(Wp, NZn, k), s);
            case 8:
                var F = n.a, j = FM(r.le), D = A2(nN, F, j.bq), V = D.b, B = D.c, G = (o = HZn(D.a), A2(xc, v(Ot, r), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            return v(It(MZn(lMn(o))), r);
                        case 1:
                            return v(It(UZn(lMn(o))), r);
                        default:
                            return v(It(ZZn(lMn(o))), A2(FLn, o, r));
                    }
                }, B)));
                return s = G.a, b(m(G.b, {
                    le: A3(cN, dMn, o, r.le)
                }), Uu(w([
                    A2(Wp, IZn, V),
                    A2(Nu, cu, Au(RZn(o)))
                ])), s);
            case 9:
                var z = n.a, S = FM(r.le), T = A2(MLn, z, S.xt), P = T.b, Z = T.c, M = (o = aMn(T.a), A2(xc, v(Ot, r), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            return v(It(MZn(lMn(o))), r);
                        case 1:
                            return v(It(UZn(lMn(o))), r);
                        default:
                            return v(It(ZZn(lMn(o))), A2(FLn, o, r));
                    }
                }, Z)));
                return s = M.a, b(m(M.b, {
                    le: A3(cN, dMn, o, r.le)
                }), A2(Wp, iMn, P), s);
            case 10:
                var L = n.a, N = FM(r.le), H = A2(SLn, L, N.rU), I = H.b, O = H.c, Q = (o = KZn(H.a), A2(xc, v(Ot, r), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            return v(It(MZn(lMn(o))), r);
                        case 1:
                            return v(It(UZn(lMn(o))), r);
                        default:
                            return v(It(ZZn(lMn(o))), A2(FLn, o, r));
                    }
                }, O)));
                return s = Q.a, b(m(Q.b, {
                    le: A3(cN, dMn, o, r.le)
                }), A2(Wp, YZn, I), s);
            case 11:
                var R = n.a, U = FM(r.le), K = A2(SLn, R, U.rV), W = K.b, X = K.c, Y = (o = WZn(K.a), A2(xc, v(Ot, r), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            return v(It(MZn(lMn(o))), r);
                        case 1:
                            return v(It(UZn(lMn(o))), r);
                        default:
                            return v(It(ZZn(lMn(o))), A2(FLn, o, r));
                    }
                }, X)));
                return s = Y.a, b(m(Y.b, {
                    le: A3(cN, dMn, o, r.le)
                }), A2(Wp, XZn, W), s);
            case 12:
                var J = n.a, nn = FM(r.le), rn = A2(SLn, J, nn.wm), tn = rn.b, en = rn.c, un = (o = tMn(rn.a), A2(xc, v(Ot, r), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            return v(It(MZn(lMn(o))), r);
                        case 1:
                            return v(It(UZn(lMn(o))), r);
                        default:
                            return v(It(ZZn(lMn(o))), A2(FLn, o, r));
                    }
                }, en)));
                return s = un.a, b(m(un.b, {
                    le: A3(cN, dMn, o, r.le)
                }), A2(Wp, eMn, tn), s);
            case 13:
                var an = n.a, cn = FM(r.le), on = A2(xkn, an, cn.v9), fn = on.b, sn = on.c, ln = (o = function(n) {
                    return {
                        $: 17,
                        a: n
                    };
                }(on.a), A2(xc, v(Ot, r), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            return v(It(MZn(lMn(o))), r);
                        case 1:
                            return v(It(UZn(lMn(o))), r);
                        default:
                            return v(It(ZZn(lMn(o))), A2(FLn, o, r));
                    }
                }, sn)));
                return s = ln.a, b(m(ln.b, {
                    le: A3(cN, dMn, o, r.le)
                }), A2(Wp, rMn, fn), s);
            case 14:
                var dn = n.a, vn = FM(r.le), bn = A2(gkn, dn, vn.vQ), mn = bn.a, pn = bn.b, $n = bn.c, gn = (o = JZn(mn), A2(xc, v(Ot, r), A2(Op, function(n) {
                    switch(n.$){
                        case 3:
                            return v(It(ZZn(lMn(o))), A2(FLn, o, r));
                        case 4:
                            return v(It(UZn(lMn(o))), r);
                        default:
                            return v(It(MZn(lMn(o))), r);
                    }
                }, $n)));
                return s = gn.a, b(m(gn.b, {
                    le: A3(cN, dMn, JZn(mn), r.le)
                }), A2(Wp, nMn, pn), s);
            case 16:
                var hn = n.a, yn = A4(Gtn, jLn, Dtn(sMn), hn, r.d0);
                return d = yn.b, b(m(r, {
                    d0: yn.a
                }), d, Ot);
            case 17:
                return b(r, Qp, It(uMn));
            default:
                var wn = n.a, xn = FM(r.le), _n = A2(Djn, wn, xn.qS), Cn = _n.b;
                return b(m(r, {
                    le: A3(cN, dMn, OZn(_n.a), r.le)
                }), A2(Wp, QZn, Cn), Ot);
        }
    }), ULn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, KLn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, WLn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, XLn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, YLn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, JLn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), nNn = function(n) {
        var r = n.it;
        return 3 === r.$ ? r.a : g;
    }, rNn = function(n) {
        return n.e4 ? Ot : It(n.dW);
    }, tNn = function(n) {
        var r = n.lp;
        return 1 === r.$ ? It(r.a.sl) : Ot;
    }, eNn = F2(function(n, r) {
        var t = n.bx, e = dA(n.lQ), u = lA(n.lQ), a = n.aC, i = tNn(a), c = rNn(a), o = function() {
            var n = CSn(a.k5);
            if (1 === n.$) {
                var r = n.a, t = n.b;
                return iL(t) ? v(Ot, Ot) : v(wSn(r), It(t));
            }
            return v(Ot, Ot);
        }();
        return m(r, {
            k5: o.a,
            lo: u,
            lq: i,
            ur: c,
            iH: e,
            mp: t,
            zF: o.b
        });
    }), uNn = function(n) {
        var r = eNn(n);
        return A4(QQ, n.g0, ux(n.dV), r, Rzn);
    }, aNn = F2(function(n, r) {
        var t = v(lyn(n), lyn(r));
        return 1 === t.a.$ ? t.b.$ ? 1 : 2 : 1 === t.b.$ ? 0 : A2(na, t.a.a, t.b.a);
    }), iNn = F2(function(n, r) {
        return A2(xc, !0, A2(Op, function(n) {
            return !!n.$ || s(n.a, r) > 0;
        }, n.aC));
    }), cNn = F2(function(n, r) {
        var t = lyn(r);
        return !!t.$ || A2(iNn, n, t.a);
    }), oNn = F2(function(n, r) {
        return A2(kG, aNn, A2(no, cNn(n.k5), r));
    }), fNn = F2(function(n, r) {
        return A2(SS, function(n) {
            return i(bSn(n), r);
        }, n);
    }), sNn = function(n) {
        var r = n.lp;
        return r.$ ? It(r.a.sl) : Ot;
    }, lNn = function(n) {
        var r = v(n.it, n_n(n.P));
        if (3 === r.a.$ && r.b) {
            var t = r.a.a, e = sNn(n.aC);
            return e.$ ? A2(oNn, n.aC, t) : A2(n$, cu, w([
                A2(fNn, t, e.a)
            ]));
        }
        return g;
    }, dNn = function(n) {
        return n.sl;
    }, vNn = F2(function(n, r) {
        return A2(no, function(r) {
            return Cz(A2(SS, function(n) {
                return i(dNn(n), bSn(r));
            }, n));
        }, r);
    }), bNn = function(n) {
        return n.it;
    }, mNn = F2(function(n, r) {
        return A2(xc, r, A2(bb, function(n) {
            return nE(n) ? Ot : It(A2(vNn, n, r));
        }, A2(Op, function(n) {
            return bNn(n.v4);
        }, n)));
    }), pNn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), $Nn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gNn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), hNn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, yNn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), wNn = function(n) {
        return m(n, {
            aC: Ot
        });
    }, xNn = function(n) {
        return !!n.$ || 2 === n.a.$;
    }, _Nn = function(n) {
        return !xNn(n.aC);
    }, CNn = NB, ANn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), kNn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ENn = F2(function(n, r) {
        return !i(n, r);
    }), qNn = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return r.aC.$ ? b(r, Qp, Ot) : b(m(r, {
                zF: t
            }), Qp, It(function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(t)));
        }
        var e = A2(dG, n.a, r.fX), u = e.b, a = e.c, i = m(r, {
            fX: e.a
        }), c = function() {
            if (a.$ || a.a.$ || a.a.a.$) return v(i, Ot);
            var n = a.a.a.a, r = A2(ENn, i.aC, n), t = xNn(n) ? Ot : n, e = m(i, {
                aC: t
            });
            return v(e, It(A2(ANn, CSn(e), r)));
        }(), o = c.b;
        return b(c.a, A2(Wp, kNn, u), o);
    }), FNn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return b(m(r, {
                    dW: t
                }), Qp, It(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(t)));
            case 1:
                var e = A2(qNn, n.a, r.k5), u = e.b, a = e.c, c = m(r, {
                    k5: e.a
                }), o = function() {
                    if (a.$) return v(c, Ot);
                    if (a.a.$) {
                        var n = a.a.a;
                        return v(c, It(A2(yNn, n, yAn(n))));
                    }
                    var t = a.a, e = t.a, u = t.b, o = function() {
                        var n = r.lp;
                        if (1 === n.$) return !0;
                        var t = n.a, e = Vx(0);
                        return i(e(CNn), e(t));
                    }();
                    return v(m(c, {
                        lp: lSn
                    }), It(A2(pNn, e, u || o)));
                }(), f = o.b;
                return b(o.a, A2(Wp, $Nn, u), f);
            default:
                var s = A2(dG, n.a, r.fi), l = s.b, d = s.c, p = m(r, {
                    fi: s.a
                }), $ = function() {
                    if (d.$ || d.a.$ || d.a.a.$) return v(p, Ot);
                    var n = d.a.a.a, t = _Nn(r.k5);
                    return v(m(p, {
                        k5: wNn(r.k5),
                        lp: n
                    }), It(A2(gNn, n, t)));
                }(), g = $.b;
                return b($.a, A2(Wp, hNn, l), g);
        }
    }), jNn = function(n) {
        return v(Qp, It(n));
    }, DNn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, VNn = {
        $: 1
    }, BNn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), GNn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zNn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, SNn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = It(t.$ ? VNn : zNn(t.a));
                return b(m(r, {
                    bJ: vSn
                }), Qp, e);
            case 1:
                var u = Ohn((c = n.a).v4), a = u.b;
                return b(m(r, {
                    bJ: A2(BNn, u.a, c)
                }), A2(Wp, GNn, a), Ot);
            case 2:
                a = n.a;
                var i = r.bJ;
                if (1 === i.$) {
                    var c = i.b, o = A2(Uhn, a, i.a), f = o.a, s = o.b, l = o.c, d = function() {
                        switch(l){
                            case 1:
                                return v(vSn, Ot);
                            case 2:
                                return v(vSn, It(zNn(c)));
                            default:
                                return v(A2(BNn, f, c), Ot);
                        }
                    }(), p = d.b;
                    return b(m(r, {
                        bJ: d.a
                    }), A2(Wp, GNn, s), p);
                }
                return b(r, Qp, Ot);
            case 3:
                var $ = A2(dG, n.a, r.fG), g = $.a, h = $.b, y = $.c;
                return e = y.$ || y.a.$ ? Ot : A2(Op, function(n) {
                    return function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(n);
                }, y.a.a), b(m(r, {
                    fG: g
                }), A2(Wp, DNn, h), e);
            case 4:
                return b(1 === n.a ? m(r, {
                    bJ: vSn
                }) : r, Qp, Ot);
            default:
                return b(r, Qp, It(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(n.a)));
        }
    }), TNn = function(n) {
        var r = ux(n.dV), t = n.aC, e = function() {
            var n = CSn(t.k5);
            if (1 === n.$) {
                var r = n.b;
                return iL(r) ? Ot : It(r);
            }
            return Ot;
        }();
        return A4(FSn, n.g0, r, A2(jSn, n.bx, e), Qzn);
    }, PNn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    bK: t
                });
                switch(t.$){
                    case 3:
                        var u = t.a, a = A2(xc, 0, A2(bb, $u, A2(ra, "x-total-count", t.b))), i = n_n(r.Q) && 1 === ve(u) && OS(r.mj) ? A2(Op, rQ, mb(u)) : r.mj;
                        return b(m(r, {
                            lQ: A2(Rk, a, r.lQ),
                            bK: t,
                            mj: i
                        }), Qp, Ot);
                    case 2:
                        return b(e, Qp, It(ULn(Nk(t.a))));
                    default:
                        return b(e, Qp, Ot);
                }
            case 1:
                return b(k = m(r, {
                    lQ: A2(Ok, f = n.a, r.lQ)
                }), uNn(k), Ot);
            case 2:
                var c = n.a;
                switch(e = m(r, {
                    it: c
                }), c.$){
                    case 3:
                        var o = c.a;
                        return b(m(e, {
                            mh: Xzn(r.P) && 1 === ve(o) && OS(r.mh) ? A2(Op, bSn, mb(o)) : r.mh
                        }), Qp, Ot);
                    case 2:
                        return b(e, Qp, It(ULn(Nk(c.a))));
                    default:
                        return b(e, Qp, Ot);
                }
            case 3:
                var f = n.a, s = r.f$;
                if (s.$) return b(r, Qp, Ot);
                var l = A2(SNn, f, s.a), d = l.b, p = l.c, $ = m(r, {
                    eZ: g,
                    f$: Wzn(l.a)
                }), h = function() {
                    if (p.$) return v($, Ot);
                    switch(p.a.$){
                        case 0:
                            var n = p.a.a, t = function() {
                                if (n_n(r.P)) {
                                    var t = sNn(r.aC);
                                    if (t.$) {
                                        var e = A2(mNn, It(n), lNn(r));
                                        return 1 === ve(e) ? mb(e) : Ot;
                                    }
                                    var u = t.a;
                                    return A2(fNn, nNn(r), u);
                                }
                                return Ot;
                            }();
                            return v(m($, {
                                eZ: g,
                                mh: A2(Op, bSn, t),
                                mj: It(rQ(n.v4))
                            }), It(A2(JLn, n.v4, t)));
                        case 1:
                            return t = function() {
                                if (n_n(r.P)) {
                                    var n = lNn(r);
                                    return 1 === ve(n) ? mb(n) : Ot;
                                }
                                return Ot;
                            }(), v(m($, {
                                eZ: g,
                                mh: A2(Op, bSn, t),
                                mj: Ot
                            }), It(function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(t)));
                        case 2:
                            return v(m($, {
                                eZ: g,
                                mh: It(bSn(t = p.a.a))
                            }), It(XLn(t)));
                        default:
                            return v($, Ot);
                    }
                }(), y = h.b;
                return b(h.a, A2(Wp, YLn, d), y);
            case 5:
                var x = jNn(f = n.a), _ = x.a, C = x.b, A = function() {
                    if (C.$) return v(r.mh, Ot);
                    var n = C.a;
                    return v(It(bSn(n)), It(XLn(n)));
                }();
                return y = A.b, b(m(r, {
                    eZ: g,
                    mh: A.a
                }), A2(Wp, WLn, _), y);
            default:
                var k, E = A2(FNn, f = n.a, r.aC), q = E.b, F = E.c, j = m(r, {
                    aC: E.a
                }), D = function() {
                    if (F.$) return v(j, Qp);
                    var n = F.a;
                    switch(n.$){
                        case 1:
                        default:
                            return v(r = m(j, {
                                lQ: cA
                            }), uNn(r));
                        case 2:
                            return n.b ? v(r = m(j, {
                                lQ: cA
                            }), uNn(r)) : v(j, Qp);
                        case 3:
                            var r;
                            return n.b ? v(r = m(j, {
                                lQ: cA
                            }), Uu(w([
                                uNn(r),
                                TNn(r)
                            ]))) : v(j, Qp);
                    }
                }(), V = D.b;
                return b(k = D.a, Uu(w([
                    A2(Wp, KLn, q),
                    V
                ])), Ot);
        }
    }), ZNn = F2(function(n, r) {
        var t = n;
        return b(m(r, {
            y3: t
        }), Qp, It(t));
    }), MNn = Xn("scrollIdIntoView", tx), LNn = F2(function(n, r) {
        return ve(A2(iH, r, n)) > 0;
    }), NNn = F2(function(n, r) {
        return It(A2(QGn, n, r));
    }), HNn = function(n) {
        var r = A2(kLn, !1, n);
        if (r.b) return Ot;
        var t = r.a;
        return A2(bb, NNn(n.sl), mb(A2(no, LNn(t), Hzn)));
    }, INn = function(n) {
        return A2(kLn, !1, n).b;
    }, ONn = F3(function(n, r, t) {
        return A2(t.z_, n, r);
    }), QNn = F2(function(n, r) {
        return _Nn(n) ? A2(no, function(r) {
            var t = A2(bb, lyn, r.lp);
            return !!t.$ || A2(iNn, n, t.a);
        }, r) : r;
    }), RNn = F2(function(n, r) {
        return A2(na, QS(n.v4), QS(r.v4));
    }), UNn = function(n) {
        return n.vf;
    }, KNn = function(n) {
        return n.mt;
    }, WNn = F2(function(n, r) {
        var t = function(n) {
            return "full_waitlisting" === n ? 1 : 0;
        }, e = A2(na, t(KNn(n.v4)), t(KNn(r.v4)));
        if (1 === e) {
            var u = A2(na, UNn(n.v4), UNn(r.v4));
            return 1 === u ? A2(RNn, n, r) : u;
        }
        return e;
    }), XNn = F3(function(n, r, t) {
        var e = bNn(t), u = nE(e) ? A2(Fu, bSn, r) : A2(Fu, dNn, e);
        return Cz(A2(SS, function(r) {
            return i(r, n);
        }, u));
    }), YNn = F3(function(n, r, t) {
        if (1 === r.$) {
            var e = r.a;
            return A2(kG, WNn, A2(no, function(r) {
                return A3(XNn, e.sl, n, r.v4);
            }, t));
        }
        return t;
    }), JNn = F2(function(n, r) {
        return A2(su, sJ(n), sJ(r));
    }), nHn = F2(function(n, r) {
        return iL(n) ? r : A2(no, function(r) {
            return A2(JNn, n, QS(r));
        }, r);
    }), rHn = F2(function(n, r) {
        return nE(n) ? r : A2(no, function(r) {
            var t = bNn(r);
            return 0 >= ve(t) || !nE(A2(vNn, t, n));
        }, r);
    }), tHn = F2(function(n, r) {
        return mb(A2(kG, aNn, A2(no, function(t) {
            return A3(XNn, bSn(t), n, r);
        }, n)));
    }), eHn = F3(function(n, r, t) {
        var e = function() {
            if (_Nn(n.k5)) return A2(tHn, r, t);
            var e = n.lp;
            if (1 === e.$) {
                var u = e.a;
                return A2(SS, function(n) {
                    return i(bSn(n), u.sl);
                }, r);
            }
            return Ot;
        }();
        return {
            lp: e,
            v4: t
        };
    }), uHn = F3(function(n, r, t) {
        return A3(YNn, r, n.lp, A2(QNn, n.k5, A2(Fu, A2(eHn, n, r), A2(nHn, n.dW, A2(rHn, r, t)))));
    }), aHn = function(n) {
        var r, t = n.bK;
        if (3 === t.$) {
            var e = t.a, u = n.Q;
            if (Yzn(u) || n_n(u)) {
                var a = 3 === (r = n.it).$ ? r.a : g;
                return A3(uHn, n.aC, a, e);
            }
            return g;
        }
        return g;
    }, iHn = F2(function(n, r) {
        return A2(SS, function(n) {
            return i(rQ(n.v4), r);
        }, n);
    }), cHn = F2(function(n, r) {
        switch(r.sl){
            case 0:
                return function(n) {
                    var r, t = A2(ELn, !0, n.W), e = m(n, {
                        eZ: A3(HTn, n.hz, n.Da, n.W),
                        h2: !0,
                        W: t
                    });
                    return INn(t) && nE(e.eZ) ? b(e, Qp, !0) : b(e, (r = HNn(t)).$ ? Qp : MNn(r.a), !1);
                }(n);
            case 1:
                return function(n) {
                    var r = A2(eTn, n.dV, n.Da) ? A2(wZn, !0, n.az) : v(n.az, !0), t = r.b;
                    return b(m(n, {
                        az: r.a
                    }), Qp, t);
                }(n);
            case 2:
                return function(n) {
                    var r = function(n) {
                        var r, t = m(n, {
                            mh: (r = b(VSn(n.Q), OS(n.mj), sNn(n.aC))).a && r.b && !r.c.$ ? It(r.c.a) : n.mh
                        }), e = function() {
                            var n = v(function(n) {
                                if (Jzn(n.Q)) {
                                    var r = n.mj;
                                    if (r.$) return VSn(n.Q);
                                    var t = r.a;
                                    return Cz(A2(iHn, aHn(n), t));
                                }
                                return !0;
                            }(t), function(n) {
                                if (Xzn(n.P)) {
                                    var r = n.mh;
                                    if (r.$) return !1;
                                    var t = r.a;
                                    return Cz(A2(fNn, lNn(n), t));
                                }
                                return !0;
                            }(t));
                            return n.a ? n.b ? g : w([
                                A2(YM, rL, OB)
                            ]) : w(n.b ? [
                                A2(YM, rL, Uyn)
                            ] : [
                                A2(YM, function(n) {
                                    return A2(YM, function(r) {
                                        return A2(YM, rL, A2(ONn, n, r));
                                    }, OB);
                                }, Uyn)
                            ]);
                        }();
                        return v(m(t, {
                            eZ: e
                        }), e);
                    }(n.aL), t = r.b;
                    return b(m(n, {
                        eZ: t,
                        aL: r.a
                    }), Qp, nE(t));
                }(n);
            default:
                return function(n) {
                    return b(m(n, {
                        ia: !0
                    }), Qp, O2(n.a4));
                }(n);
        }
    }), oHn = F2(function(n, r) {
        return A2(q0, r.a, A2(Fu, function(r) {
            return v(r.a, n(r.b));
        }, r.b));
    }), fHn = F2(function(n, r) {
        return m(r, {
            br: It(n)
        });
    }), sHn = F2(function(n, r) {
        var t = n;
        return m(r, {
            aa: A2(oHn, function(n) {
                return A2(fHn, t, n);
            }, r.aa)
        });
    }), lHn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dHn = F2(function(n, r) {
        var t = It(lHn(r));
        return m(n, {
            le: A3(cN, dZn, t, n.le)
        });
    }), vHn = F2(function(n, r) {
        return m(r, {
            aa: J2(A2(Fu, A2(m3, r.g0, r.EH), n))
        });
    }), bHn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a;
                    if (function(n) {
                        return (function(n) {
                            return 2 === pGn(n);
                        }(n) || function(n) {
                            return 1 === pGn(n);
                        }(n)) && !gBn(n);
                    }(e)) {
                        var u = (tn = function(n) {
                            return function(n) {
                                return n.a.sR;
                            }(hPn(n));
                        }(e), tn.$ ? r.az : A2(dHn, r.az, tn.a));
                        return b(l = m(r, {
                            az: u,
                            Da: It(e)
                        }), function(n) {
                            return A3(Vwn, n.g0, ux(n.dV), bPn);
                        }(l), g);
                    }
                    return b(r, APn(e), g);
                }
                return b(r, Qp, A2(Ik, 0, t));
            case 1:
                var a = n.a;
                if (3 === a.$) {
                    var c = function(n) {
                        return {
                            cT: $Pn(n),
                            A: A2(pZ, w([
                                0
                            ]), kGn)
                        };
                    }(JSn(T = a.a)), o = A4(PSn, r.g0, Vx(r.ld), r.dV, oZn(T)), f = o.a, s = o.b, l = m(r, {
                        kY: It(A4(mTn, It(T), r.dV, r.Da, 0)),
                        b$: vZ(c),
                        W: A3(Ozn, MSn, r.dV, CPn(T)),
                        aL: f,
                        f2: It(T),
                        bQ: ZSn
                    }), d = A8(vPn, l.g0, l.dV, l.hz, l.Da, l.W, l.bQ, T, USn);
                    return b(l, Uu($(A2(Fu, Wp(KSn), s), w([
                        d
                    ]))), g);
                }
                return b(r, Qp, A2(Ik, 0, a));
            case 2:
                var p = A2(RLn, n.a, r.W), h = p.a, y = p.b, x = (J = v(r.h2, p.c)).a && !J.b.$ && 3 === J.b.a.$ ? A3(HTn, r.hz, r.Da, r.W) : r.eZ;
                return b(l = m(r, {
                    eZ: x,
                    W: h
                }), A2(Wp, ISn, y), g);
            case 9:
                var _ = A2(PNn, n.a, r.aL), C = _.b;
                return b(m(r, {
                    aL: _.a
                }), A2(Wp, KSn, C), g);
            case 3:
                var A = (rn = r.Da).$ ? Qp : APn(rn.a);
                return b(r, A, g);
            case 4:
                return b(l = m(r, {
                    hz: It(A2(Ep, x8, n.a))
                }), Qp, g);
            case 5:
                var k = n.a;
                if (3 === k.$) {
                    var E = k.a, q = w([
                        A2(Mk, 3, ov.mZ)
                    ]), F = A2(xc, "", function(n) {
                        return n.fy;
                    }(E)), j = A2(__, pa, (nn = r.Da).$ ? Na : Ha({
                        sl: VVn(nn.a)
                    }));
                    return b(r, Uu(w([
                        j,
                        A2(wPn, A2(xc, "", A2(Op, VVn, r.Da)), F)
                    ])), q);
                }
                return b(m(r, {
                    wk: !1
                }), Qp, A2(Ik, 0, k));
            case 6:
                var D = n.a;
                return 3 === D.$ ? b(m(r, {
                    ic: It(D.a)
                }), Qp, g) : b(r, Qp, A2(Ik, 0, D));
            case 7:
                var V = A2(NR, n.a.lh, A3(pTn, r.f2, r.dV, r.Da));
                return b(V.$ ? r : m(r, {
                    kY: It(V.a),
                    eZ: g
                }), Qp, g);
            case 8:
                var B = function(n) {
                    var r = n.kY;
                    return r.$ ? b(n, Qp, !1) : A2(cHn, n, r.a);
                }(r), G = B.a, z = B.b, S = b(B.c, G.f2, G.kY);
                if (!S.a || S.b.$ || S.c.$) return b(G, z, g);
                var T = S.b.a, P = S.c.a.lh + 1;
                if (i(P, ve(A3(dTn, G.f2, G.dV, G.Da)))) return function(n) {
                    var r = n.Da;
                    if (r.$) return b(n, Qp, g);
                    var t = r.a, e = ux(n.dV), u = VVn(t), a = A2(nZn, n, A2(IPn, n.a4, A4(eZn, KTn(n.bQ), n.f2, n.Da, A2(KPn, n.az, A2(tZn, iZn(n.aL), A2(rZn, uZn(n.aL), HPn(n.W)))))));
                    return b(m(n, {
                        wk: !0
                    }), A5(DPn, n.g0, e, u, a, kPn), g);
                }(G);
                var Z = A2(NR, P, A3(pTn, G.f2, G.dV, G.Da));
                if (Z.$) return b(G, Qp, g);
                var M = Z.a, L = (l = m(G, {
                    kY: It(M),
                    eZ: g
                }), function() {
                    var n = v(M.sl, r.Da);
                    if (3 !== n.a || n.b.$) return Qp;
                    var t = n.b.a, e = eQ(hPn(t)), u = A2(Op, bSn, uZn(r.aL));
                    return A5(gTn, l.g0, ux(l.dV), YTn(t), e, u);
                }());
                return b(l, Uu(w([
                    cZn(fZn),
                    A8(vPn, l.g0, l.dV, l.hz, l.Da, l.W, l.bQ, T, USn),
                    L
                ])), g);
            case 10:
                var N = A2(CZn, n.a, r.az);
                return C = N.b, b(m(r, {
                    az: N.a
                }), A2(Wp, _Gn, C), g);
            case 11:
                var H = A2(ZNn, n.a, r.bQ);
                return C = H.b, b(m(r, {
                    bQ: H.a
                }), A2(Wp, WSn, C), g);
            case 12:
                var I = n.a;
                if (l = m(r, {
                    aa: I
                }), 3 === I.$) {
                    var O = I.a;
                    return b(m(l, {
                        a4: A2(sHn, hTn(r.W), A2(vHn, O, l.a4))
                    }), Qp, g);
                }
                return b(l, Qp, A2(Ik, 0, I));
            case 13:
                var Q = A2(r6, n.a, r.a4);
                return L = Q.b, b(m(r, {
                    a4: Q.a
                }), A2(Wp, xGn, L), g);
            default:
                var R = n.a, U = n.b, K = FM(r.b$).cT, W = A2(TZn, U, R), X = W.a, Y = W.b;
                return b(l = m(r, {
                    b$: A3(cN, gPn, A3(a9, function(n) {
                        return i(yPn(n), yPn(X));
                    }, function() {
                        return X;
                    }, K), r.b$)
                }), A2(Wp, RSn(X), Y), g);
        }
        var J, nn, rn, tn;
    }), mHn = F2(function(n, r) {
        return A2(zx, g, w([
            A2(Mx, w([
                Gx("text-support")
            ]), w([
                A2(UD, w([
                    Gx("link"),
                    oV(x_(Na))
                ]), w([
                    _d(n(fv.Gi))
                ]))
            ])),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            A2(Mx, w([
                Gx("text-support")
            ]), w([
                A2(UD, w([
                    Gx("link text-current"),
                    oV(x_(Ha({
                        sl: VVn(r)
                    })))
                ]), w([
                    _d(bBn(r))
                ]))
            ])),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            _d(n(ov.mX))
        ]));
    }), pHn = {
        $: 3
    }, $Hn = {
        $: 8
    }, gHn = F2(function(n, r) {
        return A2(zx, w([
            Gx("mx-1 mt-8")
        ]), w([
            A2(c_, xGn, A3(e4, n, w([
                m6(r.wk),
                p6(r.ia)
            ]), r.a4))
        ]));
    }), hHn = function(n) {
        return n.Ag;
    }, yHn = function(n) {
        return n.lM;
    }, wHn = A2(tE, rE(1), It(3)), xHn = F2(function(n, r) {
        if (r.$) return vE;
        var t = r.a, e = It(hHn(t)), u = yHn(t);
        return A2(zx, A2(Qt, Gx("flex flex-col"), n_(wHn)), w([
            A2(f_, w([
                GN,
                uE(Jq)
            ]), w([
                _d("New Recurring Bill")
            ])),
            A7(DW, n, u, !0, e, Den, !1, !1)
        ]));
    }), _Hn = A2(tE, rE(1), It(4)), CHn = F5(function(n, r, t, e, u) {
        var a = v(r, A3(ITn, t, e, u));
        if (!a.a.$ && a.b) {
            var i = a.a.a, c = It(hHn(i)), o = yHn(i);
            return A2(zx, A2(Qt, Gx("flex flex-col"), n_(_Hn)), w([
                A2(f_, w([
                    GN,
                    uE(Jq)
                ]), w([
                    _d("New recurring bill")
                ])),
                A7(DW, n, o, !1, c, Den, !1, !1)
            ]));
        }
        return vE;
    }), AHn = function(n) {
        return n.nL;
    }, kHn = function(n) {
        var r = A2(bb, AHn, n);
        if (r.$) return vE;
        var t = r.a;
        return A2(hW, "Please contact the practice to start this patient sooner", A2(zx, A2(Qt, Gx("flex flex-col"), n_(_Hn)), w([
            A2(f_, w([
                GN,
                uE(Jq)
            ]), w([
                _d("Start Date")
            ])),
            _d(A2(SM, sZ("/"), t))
        ])));
    }, EHn = F2(function(n, r) {
        return A2(zx, A2(Qt, Gx("flex"), n_(jvn)), w([
            A2(xHn, n, r.ic),
            A5(CHn, n, r.fL, r.hz, r.Da, r.W),
            kHn(r.Da)
        ]));
    }), qHn = F2(function(n, r) {
        return A2(zx, g, 3 === r.aa.$ ? w([
            A2(c_, Cu, A2(EHn, n, r)),
            A2(gHn, n, r),
            A2(zx, w([
                Gx("text-right mt-6")
            ]), w([
                A2(yF, w([
                    CD,
                    rhn(!0),
                    cF(pHn),
                    Lj(r.wk)
                ]), w([
                    _d(n(V4))
                ])),
                A2(yF, w([
                    fF,
                    rhn(!0),
                    cF($Hn),
                    Lj(r.wk)
                ]), w([
                    _d(n(ov.mX))
                ]))
            ]))
        ]) : Nx);
    }), FHn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, jHn = function(n) {
        return n.rI;
    }, DHn = {
        Bb: !1,
        jt: !1
    }, VHn = F2(function(n, r) {
        return m(r, n.$ ? {
            jt: n.a
        } : {
            Bb: n.a
        });
    }), BHn = function(n) {
        return n.wZ;
    }, GHn = function(n) {
        return n.CI;
    }, zHn = function(n) {
        return A2(xc, g, A2(bb, function(n) {
            return 2 === n.$ ? It(n.a) : Ot;
        }, n));
    }, SHn = function(n) {
        return n.yx;
    }, THn = function(n) {
        return nL(rL(SHn(n)));
    }, PHn = function(n) {
        return A2(xc, "", A2(bb, function(n) {
            return 1 === n.$ ? It(n.a) : Ot;
        }, n));
    }, ZHn = F2(function(n, r) {
        if (!BHn(r)) return Ot;
        var t = A2(qZn, n, r);
        switch(GHn(r)){
            case 2:
                return Ot;
            case 0:
                return t.$ || mu(PHn(It(t.a.nr))) ? It(THn(r)) : Ot;
            default:
                if (t.$) return It(THn(r));
                var e = zHn(It(t.a.nr)), u = A2(Ekn, function(n) {
                    return iL(n);
                }, e);
                return nE(e) || u ? It(THn(r)) : Ot;
        }
    }), MHn = function(n) {
        var r = function(n) {
            return n.p8;
        }(n);
        if (r.$) return vE;
        var t = r.a;
        return A2(f_, w([
            uE(Jq)
        ]), w([
            _d(t)
        ]));
    }, LHn = function(n) {
        var r = function(n) {
            return n.sc;
        }(n);
        if (r.$) return vE;
        var t = r.a;
        return A2(f_, w([
            VG,
            nF,
            uE(iwn)
        ]), w([
            _d(t)
        ]));
    }, NHn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), HHn = F3(function(n, r, t) {
        var e = function(n) {
            return A2(xc, !1, A2(bb, function(n) {
                return n.$ ? Ot : It(n.a);
            }, n));
        }(r);
        return A2(BE, w([
            xN(JI),
            VN(w([
                Gx("row--tweak")
            ]))
        ]), w([
            A2(lE, w([
                TE(6),
                xN($En)
            ]), w([
                A2(VX, w([
                    CX,
                    SX(A2(qc, NHn(t), wm(!1))),
                    zqn(!e),
                    QX(XPn(!e)),
                    Sqn(n)
                ]), w([
                    _d("No")
                ]))
            ])),
            A2(lE, w([
                TE(6)
            ]), w([
                A2(VX, w([
                    CX,
                    SX(A2(qc, NHn(t), wm(!0))),
                    zqn(e),
                    QX(XPn(e)),
                    Sqn(n)
                ]), w([
                    _d("Yes")
                ]))
            ]))
        ]));
    }), IHn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, OHn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, QHn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, RHn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, UHn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), KHn = F4(function(n, r, t, e) {
        var u = kZn(e) + "-" + oe(t);
        return A2(zx, w([
            Gx("mb-2 sm:mb-3")
        ]), w([
            PI(w([
                NI(u),
                OI(r),
                HI(A2(UHn, e, t)),
                pI(n),
                _I(QHn(e)),
                CI(RHn(e))
            ]))
        ]));
    }), WHn = F3(function(n, r, t) {
        var e = zHn(r);
        return A2(zx, g, $(A2(ge, F2(function(r, e) {
            return A4(KHn, n, e, r, t);
        }), e), w([
            A2(yF, w([
                fF,
                cF(IHn(t))
            ]), w([
                _d("Add condition")
            ])),
            A2(yF, w([
                CD,
                cF(OHn(t))
            ]), w([
                _d("Remove condition")
            ]))
        ])));
    }), XHn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), YHn = F3(function(n, r, t) {
        return PI(w([
            NI(kZn(t)),
            OI(PHn(r)),
            HI(XHn(t)),
            pI(n),
            _I(QHn(t)),
            CI(RHn(t))
        ]));
    }), JHn = F3(function(n, r, t) {
        var e = A2(Op, function(n) {
            return n.nr;
        }, mb(A2(no, function(n) {
            return i(n.dF, kZn(t));
        }, r)));
        switch(GHn(t)){
            case 2:
                return A3(HHn, n, e, t);
            case 0:
                return A3(YHn, n, e, t);
            default:
                return A3(WHn, n, e, t);
        }
    }), nIn = F5(function(n, r, t, e, u) {
        var a = function() {
            var n = v(t, A2(ZHn, e, u));
            return n.a && !n.b.$ ? w([
                n.b.a
            ]) : g;
        }();
        return A2(zx, w([
            Gx("mb-6")
        ]), w([
            A2(EH, w([
                vH(SHn(u)),
                gH(BHn(u))
            ]), w([
                MHn(u),
                A3(JHn, r, e, u),
                LHn(u),
                A2(YH, n, a)
            ]))
        ]));
    }), rIn = F3(function(n, r, t) {
        var e = A3(de, VHn, DHn, r);
        return A2(zx, w([
            DF(mPn(t.aj)),
            Gx("form-input w-full mb-4 md:mb-6")
        ]), w([
            A2(zx, g, A2(Fu, A4(nIn, n, e.Bb, e.jt, t.U), jHn(t.aj)))
        ]));
    }), tIn = F3(function(n, r, t) {
        return v(yPn(t), A2(c_, RSn(t), A3(rIn, n, w([
            FHn(r)
        ]), t)));
    }), eIn = F2(function(n, r) {
        var t = r.f2;
        if (t.$) return vE;
        if (nTn(t.a)) {
            var e = FM(r.b$), u = e.cT, a = A2(oN, 0, e.A);
            return A3(gz, "div", w([
                DF("custom-forms"),
                Gx("mt-6")
            ]), A2(Fu, A2(tIn, n, a), u));
        }
        return vE;
    }), uIn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, aIn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, iIn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, cIn = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), oIn = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), fIn = F2(function(n, r) {
        var t = FM(r.le).b2;
        if (t.$) return vE;
        var e = t.a;
        if (e.$) {
            var u = e.a;
            return A2(BE, w([
                VN(w([
                    Gx("-mx-1")
                ]))
            ]), w([
                A2(lE, g, w([
                    A2(EH, w([
                        vH(n(pZn))
                    ]), w([
                        PI(w([
                            OI(u),
                            HI(iIn),
                            yI(A3(oIn, r.le, r.A, 0)),
                            _I(uIn(t)),
                            CI(aIn(t))
                        ]))
                    ])),
                    A2(YH, n, A3(cIn, r.le, r.A, 0))
                ]))
            ]));
        }
        return vE;
    }), sIn = F2(function(n, r) {
        return A3(cIn, n.le, n.A, r);
    }), lIn = F2(function(n, r) {
        var t = function() {
            var t = r.il;
            if (3 === t.$) {
                var e = $(A2(Fu, function(n) {
                    return A2(MG, g, lHn(n));
                }, t.a), w([
                    A2(MG, g, lZn(""))
                ])), u = n($Zn), a = A2(Qt, Oqn(RPn(r)), A2(Qt, Zqn(A3(oIn, r.le, r.A, 1)), A2(Qt, function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(!1), A2(Qt, Lqn(u), r.fU ? w([
                    Mqn(!0)
                ]) : g)))), i = nE(e) ? n(gZn) : u;
                return v(a, $(e, w([
                    Hqn(i)
                ])));
            }
            return v(w([
                Lqn(n(bZn)),
                Mqn(!0)
            ]), g);
        }(), e = t.a, u = t.b;
        return A2(zx, w([
            Gx("mb-6")
        ]), w([
            A2(c_, sZn, A4(fFn, n, e, u, r.e9)),
            A2(YH, n, A2(sIn, r, 1))
        ]));
    }), dIn = F2(function(n, r) {
        var t, e = FM(r.le).b2;
        return A2(zx, w([
            DF(PGn)
        ]), w([
            A2(EH, w([
                vH(n(vZn))
            ]), w([
                A2(f_, w([
                    uE(Jq),
                    nF
                ]), w([
                    _d(n($Zn))
                ])),
                A2(lIn, n, r),
                A2(bE, (t = e, !t.$ && !!t.a.$), A2(fIn, n, r))
            ]))
        ]));
    }), vIn = F2(function(n, r) {
        return A2(eTn, r.dV, r.Da) ? A2(zx, w([
            Gx("mt-6")
        ]), w([
            A2(c_, _Gn, A2(dIn, n, r.az))
        ])) : vE;
    }), bIn = function(n) {
        return n.uw;
    }, mIn = F2(function(n, r) {
        return A2(zx, w([
            Gx("text-right mt-6")
        ]), w([
            A2(yF, w([
                CD,
                rhn(!0),
                cF(pHn),
                Lj(r.wk)
            ]), w([
                _d(n(V4))
            ])),
            A2(yF, w([
                fF,
                rhn(!0),
                cF($Hn),
                Lj(r.wk)
            ]), w([
                _d(n(bIn))
            ]))
        ]));
    }), pIn = function(n) {
        return n.ko.Bi;
    }, $In = function(n) {
        return n.ko.yx;
    }, gIn = function(n) {
        return n.ko.y3;
    }, hIn = F3(function(n, r, t) {
        return A2(zx, w([
            DF("tobacco-use")
        ]), w([
            A2(EH, w([
                vH(n($In)),
                gH(!0)
            ]), w([
                A2(BE, w([
                    xN(JI),
                    VN(w([
                        Gx("row--tweak")
                    ]))
                ]), w([
                    A2(lE, w([
                        TE(6),
                        xN($En)
                    ]), w([
                        A2(VX, w([
                            CX,
                            SX(A2(qc, cu, wm(!1))),
                            zqn(!t.y3),
                            QX(XPn(!t.y3)),
                            Sqn(r)
                        ]), w([
                            _d(n(pIn))
                        ]))
                    ])),
                    A2(lE, w([
                        TE(6)
                    ]), w([
                        A2(VX, w([
                            CX,
                            SX(A2(qc, cu, wm(!0))),
                            zqn(t.y3),
                            QX(XPn(t.y3)),
                            Sqn(r)
                        ]), w([
                            _d(n(gIn))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), yIn = F2(function(n, r) {
        var t = r.f2;
        return t.$ ? vE : uTn(t.a) ? A2(zx, g, w([
            A2(zx, g, w([
                A2(c_, WSn, A3(hIn, n, r.wk, r.bQ))
            ]))
        ])) : vE;
    }), wIn = F2(function(n, r) {
        return A2(zx, w([
            Gx("custom-details")
        ]), w([
            A2(vIn, n, r),
            A2(yIn, n, r),
            A2(eIn, n, r),
            A2(mIn, n, r)
        ]));
    }), xIn = F2(function(n, r) {
        return nE(r.eZ) ? vE : A2(zx, n_(jvn), w([
            A2(YH, n, A2(Fu, function(n) {
                return nL(n);
            }, r.eZ))
        ]));
    }), _In = function(n) {
        return {
            $: 0,
            a: n
        };
    }, CIn = {
        Bb: !1,
        wL: !1
    }, AIn = F2(function(n, r) {
        return m(r, n.$ ? {
            wL: n.a
        } : {
            Bb: n.a
        });
    }), kIn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, EIn = function(n) {
        return !nEn(n);
    }, qIn = F3(function(n, r, t) {
        var e = FM(t.le);
        if (mMn(e.wQ) || !EIn(t.a6.oM)) return vE;
        var u = FM(t.le), a = u.m9, i = u.y$;
        return A2(zx, g, w([
            A2(BE, w([
                xN(JI)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(fI, w([
                        eI(i),
                        tI(kIn),
                        rI(r)
                    ]), w([
                        _d(n(eAn))
                    ]))
                ]))
            ])),
            A2(bE, !i, A2(zx, w([
                Gx("mt-4")
            ]), w([
                A2(c_, OSn, A3(jEn, n, w([
                    Jkn(r)
                ]), a))
            ])))
        ]));
    }), FIn = F4(function(n, r, t, e) {
        var u = FM(e.le).bq;
        return A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(JM)),
                    gH(e.a6.hF)
                ]), w([
                    A2(c_, IZn, A3(ZI, n, w([
                        dI(r || t)
                    ]), u))
                ]))
            ]))
        ]));
    }), jIn = function(n) {
        return {
            $: 19,
            a: n
        };
    }, DIn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, VIn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, BIn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, GIn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, zIn = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), SIn = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), TIn = F3(function(n, r, t) {
        var e = FM(t.le), u = e.qN, a = e.wQ;
        return mMn(a) ? vE : A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH("Email"),
                    gH(mMn(a) || Mkn(t.dV)),
                    GIn(A2(QGn, t.sl, 7))
                ]), w([
                    PI(w([
                        NI(A2(QGn, t.sl, 7)),
                        OI(u),
                        jI("me@example.com"),
                        HI(A2(qc, BIn, jIn)),
                        yI(A3(zIn, t.le, t.A, 7)),
                        pI(r),
                        FI(!0),
                        $O("email"),
                        pO("email"),
                        _I(DIn(jIn(u))),
                        CI(VIn(jIn(u))),
                        hI(1)
                    ])),
                    A2(YH, n, A3(SIn, t.le, t.A, 7))
                ]))
            ]))
        ]));
    }), PIn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ZIn = F3(function(n, r, t) {
        var e = FM(t.le), u = e.qS, a = mMn(e.wQ);
        return A2(c_, QZn, A3(oDn, n, w([
            PIn(r),
            tDn(a)
        ]), u));
    }), MIn = function(n) {
        return n.wZ;
    }, LIn = F3(function(n, r, t) {
        var e = FM(t.le).rU;
        return w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(Swn.sT)),
                    gH(MIn(e))
                ]), w([
                    A2(c_, YZn, A4($qn, n, w([
                        iqn(r)
                    ]), cqn, e))
                ]))
            ]))
        ]);
    }), NIn = function(n) {
        return n.wZ;
    }, HIn = F3(function(n, r, t) {
        var e = FM(t.le), u = e.xt, a = e.rV, i = e.wm;
        return w([
            A2(lE, w([
                TE(12),
                xN(aF),
                cmn(4),
                A2(rO, 2, JI)
            ]), w([
                A2(EH, w([
                    vH(n(Lyn.sT)),
                    gH(NIn(u))
                ]), w([
                    A2(c_, iMn, A3(Fqn, n, w([
                        xqn(r)
                    ]), u))
                ])),
                A2(Dqn, n, u)
            ])),
            A2(lE, w([
                TE(12),
                xN(aF),
                cmn(4),
                A2(rO, 2, JI)
            ]), w([
                A2(EH, w([
                    vH(n(Tyn.sT)),
                    gH(MIn(a))
                ]), w([
                    A2(c_, XZn, A4($qn, n, w([
                        iqn(r)
                    ]), _qn, a))
                ]))
            ])),
            A2(lE, w([
                TE(12),
                cmn(4)
            ]), w([
                A2(EH, w([
                    vH(n(Zyn.sT)),
                    gH(MIn(i))
                ]), w([
                    A2(c_, eMn, A4($qn, n, w([
                        iqn(r)
                    ]), Cqn, i))
                ]))
            ]))
        ]);
    }), IIn = F3(function(n, r, t) {
        return A2(BE, g, uqn(t.dV) ? A3(HIn, n, r, t) : A3(LIn, n, r, t));
    }), OIn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, QIn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, RIn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, UIn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, KIn = function(n) {
        return n.wZ;
    }, WIn = F4(function(n, r, t, e) {
        var u = FM(e.le);
        return A2(BE, g, w([
            A2(lE, w([
                tO(2),
                xN(aF),
                A2(rO, 1, JI)
            ]), w([
                A2(EH, w([
                    vH(n(mL)),
                    gH(KIn(u.yx)),
                    LEn
                ]), w([
                    A2(c_, oMn, A3(UEn, n, w([
                        ZEn(r)
                    ]), u.yx))
                ]))
            ])),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(EH, w([
                    vH(n(lL)),
                    gH(!0),
                    LEn,
                    GIn(A2(QGn, e.sl, 0))
                ]), w([
                    PI(w([
                        NI(A2(QGn, e.sl, 0)),
                        OI(u.rA),
                        jI("First"),
                        HI(A2(qc, BIn, OIn)),
                        yI(A3(zIn, e.le, e.A, 0)),
                        pI(r || t),
                        xO("additional-first-name"),
                        FI(!0),
                        $O("given-name"),
                        pO("given-name"),
                        _I(DIn(OIn(u.rA))),
                        CI(VIn(OIn(u.rA)))
                    ]))
                ]))
            ])),
            A2(lE, w([
                TE(3),
                tO(2)
            ]), w([
                A2(EH, w([
                    vH(n(vL)),
                    LEn,
                    GIn(e.sl + "-middle-name")
                ]), w([
                    PI(w([
                        NI(e.sl + "-middle-name"),
                        OI(u.ue),
                        jI("Middle"),
                        HI(A2(qc, BIn, RIn)),
                        pI(r),
                        xO("additional-middle-name"),
                        $O("additional-name"),
                        pO("additional-name"),
                        FI(!0),
                        _I(DIn(RIn(u.ue))),
                        CI(VIn(RIn(u.ue)))
                    ]))
                ]))
            ])),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(EH, w([
                    vH(n(dL)),
                    gH(!0),
                    LEn,
                    GIn(A2(QGn, e.sl, 1))
                ]), w([
                    PI(w([
                        NI(A2(QGn, e.sl, 1)),
                        OI(u.sV),
                        jI("Last"),
                        HI(A2(qc, BIn, QIn)),
                        yI(A3(zIn, e.le, e.A, 1)),
                        pI(r || t),
                        xO("additional-last-name"),
                        FI(!0),
                        $O("family-name"),
                        pO("family-name"),
                        _I(DIn(QIn(u.sV))),
                        CI(VIn(QIn(u.sV)))
                    ]))
                ]))
            ])),
            A2(lE, w([
                TE(3),
                tO(2)
            ]), w([
                A2(EH, w([
                    vH(n(bL)),
                    LEn,
                    GIn(e.sl + "-suffix")
                ]), w([
                    PI(w([
                        NI(e.sl + "-suffix"),
                        OI(u.ym),
                        HI(A2(qc, BIn, UIn)),
                        pI(r),
                        xO("additional-suffix-name"),
                        $O("honorific-suffix"),
                        pO("honorific-suffix"),
                        FI(!0),
                        _I(DIn(UIn(u.ym))),
                        CI(VIn(UIn(u.ym)))
                    ]))
                ]))
            ])),
            A2(lE, w([
                tO(2)
            ]), g),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(YH, n, A3(SIn, e.le, e.A, 0))
            ])),
            A2(lE, w([
                TE(3),
                tO(2)
            ]), g),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(YH, n, A3(SIn, e.le, e.A, 1))
            ])),
            A2(lE, w([
                TE(3),
                tO(2)
            ]), g)
        ]));
    }), XIn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, YIn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, JIn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, nOn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, rOn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tOn = F3(function(n, r, t) {
        var e = FM(t.le), u = e.an, a = e.oD, i = e.oz, c = e.oB, o = e.oA, f = e.oC;
        return A2(zx, g, w([
            A2(BE, w([
                xN(aF)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(fI, w([
                        eI(u),
                        tI(rOn),
                        rI(r)
                    ]), w([
                        _d(n(GEn))
                    ]))
                ]))
            ])),
            A2(bE, u, A2(BE, g, w([
                A2(lE, w([
                    tO(2),
                    xN(aF),
                    A2(rO, 2, JI)
                ]), w([
                    A2(EH, w([
                        vH(n(PEn)),
                        gH(KIn(a)),
                        LEn
                    ]), w([
                        A2(c_, NZn, A3(UEn, n, w([
                            ZEn(r)
                        ]), a))
                    ]))
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(EH, w([
                        vH(n(BEn)),
                        gH(!0),
                        LEn,
                        GIn(A2(QGn, t.sl, 3))
                    ]), w([
                        PI(w([
                            NI(A2(QGn, t.sl, 3)),
                            OI(i),
                            jI("First"),
                            HI(A2(qc, BIn, XIn)),
                            yI(A3(zIn, t.le, t.A, 3)),
                            pI(r),
                            xO("choosen-first-name"),
                            FI(!0),
                            $O("given-name"),
                            pO("given-name"),
                            _I(DIn(XIn(i))),
                            CI(VIn(XIn(i)))
                        ]))
                    ]))
                ])),
                A2(lE, w([
                    TE(3),
                    tO(2)
                ]), w([
                    A2(EH, w([
                        vH(n(SEn)),
                        LEn,
                        GIn(t.sl + "-chosen-middle-name")
                    ]), w([
                        PI(w([
                            NI(t.sl + "-chosen-middle-name"),
                            OI(c),
                            jI("Middle"),
                            HI(A2(qc, BIn, JIn)),
                            pI(r),
                            xO("choosen-middle-name"),
                            FI(!0),
                            $O("additional-name"),
                            pO("additional-name"),
                            _I(DIn(JIn(c))),
                            CI(VIn(JIn(c)))
                        ]))
                    ]))
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(EH, w([
                        vH(n(zEn)),
                        gH(!0),
                        LEn,
                        GIn(A2(QGn, t.sl, 4))
                    ]), w([
                        PI(w([
                            NI(A2(QGn, t.sl, 4)),
                            OI(o),
                            jI("Last"),
                            HI(A2(qc, BIn, YIn)),
                            yI(A3(zIn, t.le, t.A, 4)),
                            pI(r),
                            xO("choosen-last-name"),
                            FI(!0),
                            $O("family-name"),
                            pO("family-name"),
                            _I(DIn(YIn(o))),
                            CI(VIn(YIn(o)))
                        ]))
                    ]))
                ])),
                A2(lE, w([
                    TE(3),
                    tO(2)
                ]), w([
                    A2(EH, w([
                        vH(n(TEn)),
                        LEn,
                        GIn(t.sl + "-chosen-suffix")
                    ]), w([
                        PI(w([
                            NI(t.sl + "-chosen-suffix"),
                            OI(f),
                            HI(A2(qc, BIn, nOn)),
                            pI(r),
                            xO("choosen-suffix"),
                            $O("honorific-suffix"),
                            pO("honorific-suffix"),
                            FI(!0),
                            _I(DIn(nOn(f))),
                            CI(VIn(nOn(f)))
                        ]))
                    ]))
                ])),
                A2(lE, w([
                    TE(12),
                    tO(3)
                ]), g),
                A2(lE, w([
                    TE(4),
                    tO(3)
                ]), w([
                    A2(YH, n, A3(SIn, t.le, t.A, 3))
                ])),
                A2(lE, w([
                    TE(4),
                    tO(3)
                ]), g),
                A2(lE, w([
                    TE(4),
                    tO(3)
                ]), w([
                    A2(YH, n, A3(SIn, t.le, t.A, 4))
                ]))
            ])))
        ]));
    }), eOn = F4(function(n, r, t, e) {
        return A2(zx, g, w([
            A4(WIn, n, r, t, e),
            A3(tOn, n, r, e)
        ]));
    }), uOn = F4(function(n, r, t, e) {
        var u = FM(e.le);
        return mMn(u.wQ) ? vE : A4(eOn, n, r, t, e);
    }), aOn = F3(function(n, r, t) {
        var e = EIn(t.a6.oM) ? g : w([
            xN(JI)
        ]), u = Dxn(t.dV), a = FM(t.le), i = a.vQ;
        return mMn(a.wQ) ? vE : A2(BE, e, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(rZ)),
                    gH(i.wZ || u)
                ]), w([
                    A2(zx, w([
                        Gx("mx-1")
                    ]), w([
                        A2(c_, nMn, A3(NFn, n, w([
                            BFn(r)
                        ]), i))
                    ]))
                ]))
            ]))
        ]));
    }), iOn = F3(function(n, r, t) {
        if (BPn(t.dV)) {
            var e = FM(t.le);
            return A2(BE, g, w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(EH, w([
                        vH(n(OFn))
                    ]), w([
                        A2(c_, rMn, A3(UFn, n, w([
                            IFn(r)
                        ]), e.v9))
                    ]))
                ]))
            ]));
        }
        return vE;
    }), cOn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, oOn = F2(function(n, r) {
        switch(r){
            case 0:
                return n(HMn);
            case 1:
                return n(MMn);
            case 2:
                return n(LMn);
            default:
                return n(YP);
        }
    }), fOn = function(n) {
        return 1 === n;
    }, sOn = function(n) {
        switch(n){
            case 0:
                return "owner";
            case 1:
                return "spouse";
            case 2:
                return "child";
            default:
                return "other";
        }
    }, lOn = F3(function(n, r, t) {
        var e, u = FM(t.le).wQ;
        return mMn(u) ? vE : A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(NMn)),
                    gH(!0)
                ]), w([
                    A2(BE, w([
                        xN(JI),
                        VN(w([
                            Gx("row--tweak")
                        ]))
                    ]), w([
                        A2(lE, w([
                            TE(6),
                            xN($En)
                        ]), w([
                            A2(VX, w([
                                CX,
                                SX(A2(qc, A2(qc, BIn, cOn), wm(1))),
                                zqn((e = u, A2(xc, !1, A2(Op, fOn, e)))),
                                QX(sOn(1)),
                                Sqn(r)
                            ]), w([
                                _d(A2(oOn, n, 1))
                            ]))
                        ])),
                        A2(lE, w([
                            TE(6)
                        ]), w([
                            A2(VX, w([
                                CX,
                                SX(A2(qc, A2(qc, BIn, cOn), wm(2))),
                                zqn(FTn(u)),
                                QX(sOn(2)),
                                Sqn(r)
                            ]), w([
                                _d(A2(oOn, n, 2))
                            ]))
                        ]))
                    ])),
                    A2(YH, n, A3(SIn, t.le, t.A, 2))
                ]))
            ]))
        ]));
    }), dOn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, vOn = tV("###-##-####"), bOn = F3(function(n, r, t) {
        if (ZPn(t.a6.oY)) return vE;
        var e, u = FM(t.le).x_;
        return A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH("SSN"),
                    gH((e = t.a6.oY, n_n(e)))
                ]), w([
                    PI(w([
                        NI(A2(QGn, t.sl, 6)),
                        A2(xI, vOn, u),
                        A3(kI, vOn, u, A2(qc, BIn, dOn)),
                        jI("123-12-1234"),
                        yI(A3(zIn, t.le, t.A, 6)),
                        pI(r),
                        _I(DIn(dOn(u))),
                        CI(VIn(dOn(u))),
                        FI(!0),
                        hI(0)
                    ])),
                    A2(YH, n, A3(SIn, t.le, t.A, 6))
                ]))
            ]))
        ]));
    }), mOn = F3(function(n, r, t) {
        var e = A3(de, AIn, CIn, r), u = e.Bb, a = e.wL;
        return A2(zx, w([
            Gx("member-input w-full space-y-6")
        ]), w([
            A4(uOn, n, u, a, t),
            A4(FIn, n, u, a, t),
            A3(lOn, n, u, t),
            A3(IIn, n, u, t),
            A3(iOn, n, u, t),
            A3(bOn, n, u, t),
            A3(TIn, n, u, t),
            A3(aOn, n, u, t),
            A3(qIn, n, u, t),
            A3(ZIn, n, u, t)
        ]));
    }), pOn = F2(function(n, r) {
        return A2(zx, w([
            Gx("mx-1")
        ]), w([
            A2(c_, ISn, A3(mOn, n, w([
                _In(r.wk)
            ]), r.W))
        ]));
    }), $On = F2(function(n, r) {
        return A2(zx, g, w([
            A2(pOn, n, r),
            A2(xIn, n, r),
            A2(mIn, n, r)
        ]));
    }), gOn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hOn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yOn = function(n) {
        var r = Jzn(n.Q) && !Oj(n.bK), t = Xzn(n.P) && !Oj(n.it);
        return !(r || t);
    }, wOn = F2(function(n, r) {
        return {
            lp: r,
            v4: n
        };
    }), xOn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _On = function(n) {
        return {
            $: 0,
            a: n
        };
    }, COn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, AOn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, kOn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, EOn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, qOn = {
        Bb: !1,
        k4: !1,
        Cr: !1,
        iT: Ot
    }, FOn = F2(function(n, r) {
        return m(r, n.$ ? {
            iT: n.a
        } : {
            Bb: n.a
        });
    }), jOn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, DOn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, VOn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, BOn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, GOn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zOn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, SOn = {
        Bb: !1,
        it: g,
        y4: Ot
    }, TOn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    Bb: n.a
                });
            case 1:
                return m(r, {
                    y4: n.a
                });
            default:
                return m(r, {
                    it: n.a
                });
        }
    }), POn = function(n) {
        var r, t, e, u = (r = Cln(n), t = gln(n) + ", " + _ln(n), e = function() {
            var n = v(mu(t), yln(r));
            return n.a || n.b ? vE : RD;
        }(), A2(zx, g, w([
            A2(Mx, g, w([
                _d(t)
            ])),
            e,
            ZV(r)
        ]))), a = yln(xln(n)) ? vE : A2(zx, g, w([
            ZV(xln(n))
        ])), i = yln(wln(n)) ? vE : A2(zx, g, w([
            ZV(wln(n))
        ]));
        return w([
            A2(zx, g, w([
                i,
                a,
                u
            ]))
        ]);
    }, ZOn = function(n) {
        if (pSn(n)) return A2(zx, w([
            Gx("radio-card__row signup__subtitle")
        ]), w([
            A2(f_, w([
                nF,
                VG,
                A2(syn, 1, 2)
            ]), w([
                _d("Virtual Location")
            ]))
        ]));
        var r = vmn(n);
        if (r.$) return vE;
        var t = r.a;
        return A2(zx, w([
            Gx("radio-card__row signup__subtitle")
        ]), w([
            A2(f_, w([
                nF,
                VG,
                A2(syn, 1, 2)
            ]), w([
                A2(zx, w([
                    Gx("lg:hidden")
                ]), POn(t)),
                A2(zx, w([
                    Gx("hidden lg:flex")
                ]), w([
                    _d(myn(t))
                ]))
            ]))
        ]));
    }, MOn = F2(function(n, r) {
        var t = lyn(r);
        if (t.$) return vE;
        var e = t.a;
        return A2(zx, w([
            Gx("flex items-center")
        ]), w([
            A2(Tq, w([
                zE,
                Wj("fill-gray")
            ]), 11),
            A2(f_, w([
                nF,
                zX
            ]), w([
                _d(A2(vyn, n, e))
            ]))
        ]));
    }), LOn = F2(function(n, r) {
        return A2(zx, w([
            Gx("radio-card__row")
        ]), w([
            A2(zx, w([
                Gx("lg:flex")
            ]), w([
                A2(f_, w([
                    ven,
                    VG,
                    A2(syn, 1, 2)
                ]), w([
                    _d(oyn(r))
                ])),
                A2(zx, w([
                    Gx("lg:ml-2")
                ]), w([
                    A2(MOn, n, r)
                ]))
            ]))
        ]));
    }), NOn = F3(function(n, r, t) {
        var e = function() {
            var n = r.y4;
            return !n.$ && i(bSn(n.a), bSn(t));
        }();
        return A2(zx, w([
            Gx("radio-card"),
            Oq(w([
                v("radio-card--selected", e),
                v("radio-card--disabled", r.Bb)
            ])),
            qE(t)
        ]), w([
            A2(zx, w([
                Gx("radio-card__radio")
            ]), w([
                A2(VX, w([
                    zqn(e),
                    SX(A2(qc, cu, wm(t))),
                    Sqn(r.Bb)
                ]), g)
            ])),
            A2(zx, w([
                Gx("radio-card__content")
            ]), w([
                A2(LOn, n, t),
                ZOn(t)
            ]))
        ]));
    }), HOn = F2(function(n, r) {
        var t = A3(de, TOn, SOn, r);
        return A2(zx, g, A2(Fu, A2(NOn, n, t), t.it));
    }), IOn = {
        Bb: !1,
        k4: !1,
        h9: !1,
        Cr: !1,
        it: g,
        iT: Ot,
        bK: g,
        d6: Ot,
        mh: Ot,
        da: Ot
    }, OOn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    Bb: n.a
                });
            case 1:
                return m(r, {
                    da: n.a
                });
            case 2:
                return m(r, {
                    bK: n.a
                });
            case 3:
                return m(r, {
                    d6: n.a
                });
            case 4:
                return m(r, {
                    mh: n.a
                });
            case 5:
                return m(r, {
                    it: n.a
                });
            case 6:
                return m(r, {
                    Cr: n.a
                });
            case 7:
                return m(r, {
                    k4: n.a
                });
            case 8:
                return m(r, {
                    iT: n.a
                });
            default:
                return m(r, {
                    h9: n.a
                });
        }
    }), QOn = F2(function(n, r) {
        var t = v(n, r);
        n: for(;;){
            if (t.a.$) {
                if (1 === t.b.$) return !0;
                break n;
            }
            if (t.b.$) break n;
            var e = t.b.a;
            return i(rQ(t.a.a.v4), rQ(e.v4));
        }
        return !1;
    }), ROn = function(n) {
        n: for(;;){
            if (n.b) {
                if (1 === n.a.$) {
                    n = n.b;
                    continue n;
                }
                return It(n.a.a);
            }
            return Ot;
        }
    }, UOn = F2(function(n, r) {
        return A2(bb, mb, A2(Op, function(r) {
            return A2(no, function(n) {
                return i(bSn(n), r);
            }, n);
        }, A2(Op, dNn, function(n) {
            return mb(n.it);
        }(r.v4))));
    }), KOn = F4(function(n, r, t, e) {
        return ROn(w([
            n ? r : Ot,
            e.lp,
            mb(t),
            A2(UOn, t, e)
        ]));
    }), WOn = F3(function(n, r, t) {
        if (1 === t.$) {
            var e = t.a, u = t.b, a = A2(mNn, It(u), r.it), i = A2(QOn, r.da, It(u));
            return A2(c_, GNn, A3($wn, n, {
                lp: A4(KOn, i, r.d6, a, u),
                zp: !0
            }, e));
        }
        return vE;
    }), XOn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, YOn = function(n) {
        var r = n.$ ? "no-preference" : rQ(n.a);
        return A2(fe, "-", w([
            "practitioner-card",
            r
        ]));
    }, JOn = F2(function(n, r) {
        var t = v(n, r);
        if (t.a.$ || t.b.$) return !1;
        var e, u, a = t.a.a, i = t.b.a, c = !(u = bwn(a)).$ && 0 > s(i, u.a), o = !(e = vwn(a)).$ && s(i, e.a) > 0;
        return c || o;
    }), nQn = F4(function(n, r, t, e) {
        var u = A2(Fu, function(n) {
            return A2(MG, g, n);
        }, A2(mNn, e, r.it));
        return ve(u) > 1 ? A2(zx, w([
            Gx("card card--selected card--slide-down flex -mt-4 mb-4 py-6 rounded-t-none border-t-0")
        ]), w([
            A2(zx, w([
                Gx("flex flex-col flex-grow ml-8 mr-2")
            ]), w([
                A2(EH, w([
                    vH(n(OB)),
                    gH(!0),
                    cEn(n(HB))
                ]), w([
                    A2(c_, DNn, A4(qz, n, w([
                        XG(r.d6),
                        HG(n(UB)),
                        CO(r.Bb),
                        HEn(r.Cr)
                    ]), u, t))
                ]))
            ]))
        ])) : vE;
    }), rQn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, tQn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, eQn = F2(function(n, r) {
        return r.tc(n);
    }), uQn = F2(function(n, r) {
        return r > 1 ? A2(zx, w([
            Gx("tag tag--subdued tag--small")
        ]), w([
            A2(f_, w([
                nF,
                VG,
                A2(syn, 1, 2)
            ]), w([
                _d(n(eQn(oe(r - 1))))
            ]))
        ])) : vE;
    }), aQn = F5(function(n, r, t, e, u) {
        return A2(xc, vE, A2(Op, function(e) {
            return A2(zx, w([
                Gx("radio-card__row signup__subtitle")
            ]), w([
                A2(zx, w([
                    Gx("flex")
                ]), w([
                    A2(zx, w([
                        Gx("flex flex-grow")
                    ]), w([
                        A2(f_, w([
                            nF,
                            VG,
                            A2(syn, 1, 2)
                        ]), w([
                            _d(A2($Sn, n, e))
                        ]))
                    ])),
                    A2(zx, w([
                        Oq(w([
                            v("hidden", r)
                        ]))
                    ]), w([
                        A2(uQn, n, ve(t))
                    ]))
                ]))
            ]));
        }, ROn(w([
            e,
            u.lp,
            A2(UOn, t, u)
        ]))));
    }), iQn = function(n) {
        return n.qh;
    }, cQn = F2(function(n, r) {
        var t = v(iQn(n), iQn(r));
        return 1 === t.a.$ ? t.b.$ ? 1 : 2 : 1 === t.b.$ ? 0 : A2(na, t.a.a, t.b.a);
    }), oQn = F2(function(n, r) {
        if (r.$) return function(n) {
            return A2(xc, Ot, A2(Op, iQn, mb(A2(kG, cQn, bNn(n)))));
        }(n);
        var t = r.a;
        return A2(xc, Ot, A2(Op, iQn, mb(A2(no, function(n) {
            return i(dNn(n), t);
        }, bNn(n)))));
    }), fQn = F4(function(n, r, t, e) {
        var u = w(r ? [
            qG
        ] : [
            VG,
            A2(syn, 1, 2)
        ]), a = A2(oQn, e, t);
        if (a.$) return vE;
        var i = a.a;
        return A2(zx, w([
            Gx("flex items-center")
        ]), w([
            A2(Mx, w([
                Gx("mr-1 -mt-1")
            ]), w([
                A2(Tq, w([
                    zE,
                    Wj("fill-gray")
                ]), 11)
            ])),
            A2(f_, A2(Qt, nF, u), w([
                _d(A2(vyn, n, i))
            ]))
        ]));
    }), sQn = F5(function(n, r, t, e, u) {
        var a = A2(Op, function(n) {
            return n.v4;
        }, e), i = A2(xc, "No preference", A2(Op, QS, a)), c = A2(Op, A3(fQn, n, !1, r ? t.mh : Ot), a);
        return A2(zx, g, w([
            A2(zx, w([
                Gx("radio-card__row")
            ]), w([
                A2(zx, w([
                    Gx("lg:flex")
                ]), w([
                    A2(f_, w([
                        ven,
                        VG,
                        A2(syn, 1, 2)
                    ]), w([
                        _d(i)
                    ])),
                    A2(zx, w([
                        Gx("lg:ml-2")
                    ]), w([
                        A2(xc, vE, c)
                    ]))
                ]))
            ])),
            function() {
                var n = v(a, u);
                if (!n.a.$ && n.b) {
                    var r = n.a.a;
                    return A2(f_, w([
                        nF,
                        VG
                    ]), w([
                        _d(A3(mwn, bwn(r), vwn(r), !0))
                    ]));
                }
                return vE;
            }()
        ]));
    }), lQn = F5(function(n, r, t, e, u) {
        return A2(zx, w([
            qE(u)
        ]), w([
            A5(sQn, n, r, t, e, !1),
            A2(zx, w([
                Gx("radio-card__row signup__subtitle")
            ]), w([
                A2(f_, w([
                    nF,
                    VG,
                    A2(syn, 1, 2)
                ]), w([
                    _d("No provider will be assigned at this time")
                ]))
            ]))
        ]));
    }), dQn = function(n) {
        return n.t.m3;
    }, vQn = function(n) {
        return n.t.m4;
    }, bQn = function(n) {
        return n.t.qO;
    }, mQn = function(n) {
        return n.t.qP;
    }, pQn = function(n) {
        return n.t.q3;
    }, $Qn = function(n) {
        return n.t.rB;
    }, gQn = function(n) {
        return n.t.rC;
    }, hQn = function(n) {
        return n.t.sy;
    }, yQn = function(n) {
        return n.t.sz;
    }, wQn = function(n) {
        return n.t.CJ;
    }, xQn = function(n) {
        return n.t.sP;
    }, _Qn = function(n) {
        return n.t.sQ;
    }, CQn = function(n) {
        return n.t.sW;
    }, AQn = function(n) {
        return n.t.sX;
    }, kQn = function(n) {
        return n.t.vd;
    }, EQn = function(n) {
        return n.t.vP;
    }, qQn = function(n) {
        return n.t.wr;
    }, FQn = function(n) {
        return n.t.xm;
    }, jQn = function(n) {
        return n.t.yf;
    }, DQn = function(n) {
        return n.t.yl;
    }, VQn = function(n) {
        return n.t.eg;
    }, BQn = F7(function(n, r, t, e, u, a, i) {
        var c = XOn(a);
        if (a.$) return A5(lQn, n, t, r, a, c);
        var o = a.a;
        return A2(zx, w([
            Gx("flex flex-row w-full")
        ]), w([
            A2(zx, w([
                Gx("flex flex-col mr-4"),
                qE(c)
            ]), w([
                A2(twn, !1, o.v4)
            ])),
            A2(zx, w([
                Gx("flex flex-col flex-grow"),
                qE(c)
            ]), w([
                A5(sQn, n, t, r, a, i),
                Xyn(o.v4),
                A5(aQn, n, t, e, u, o)
            ])),
            i ? vE : A2(zx, w([
                Gx("flex flex-col justify-center ml-4 mr-2 gap-2")
            ]), A2(Qt, A2(yF, w([
                CD,
                cF(tQn(o)),
                rhn(!0)
            ]), w([
                _d(n(KI))
            ])), r.h9 || "full_waitlisting" !== KNn(o.v4) ? g : w([
                A2(yF, w([
                    fF,
                    cF(rQn(o.v4)),
                    rhn(!0)
                ]), w([
                    _d(n(wQn))
                ]))
            ])))
        ]));
    }), GQn = F7(function(n, r, t, e, u, a, i) {
        var c = XOn(a);
        if (a.$) return A5(lQn, n, t, r, a, c);
        var o = a.a;
        return A2(zx, g, w([
            A2(zx, w([
                Gx("flex flex-row mb-6"),
                qE(c)
            ]), w([
                A2(zx, w([
                    Gx("flex flex-shrink-0 mr-4")
                ]), w([
                    A2(twn, !1, o.v4)
                ])),
                A2(zx, w([
                    Gx("flex flex-col flex-grow")
                ]), w([
                    A5(sQn, n, t, r, a, i)
                ]))
            ])),
            A2(zx, w([
                Gx("mb-4")
            ]), w([
                s_
            ])),
            A2(zx, w([
                Gx("flex flex-col pr-2"),
                qE(c)
            ]), w([
                Xyn(o.v4),
                A5(aQn, n, t, e, u, o)
            ])),
            A2(zx, w([
                Gx("mt-4")
            ]), w([
                A2(yF, w([
                    CD,
                    cF(tQn(o))
                ]), w([
                    _d(n(KI))
                ]))
            ]))
        ]));
    }), zQn = F7(function(n, r, t, e, u, a, i) {
        return A2(zx, w([
            Gx("radio-card__content")
        ]), w([
            A2(zx, w([
                Gx("lg:hidden")
            ]), w([
                A7(GQn, n, r, t, e, u, a, i)
            ])),
            A2(zx, w([
                Gx("hidden lg:flex")
            ]), w([
                A7(BQn, n, r, t, e, u, a, i)
            ]))
        ]));
    }), SQn = F4(function(n, r, t, e) {
        var u = t.fG, a = A2(Op, function(n) {
            return n.v4;
        }, e), i = A2(mNn, e, r.it), c = A2(QOn, r.da, e), o = ve(i) > 1 && c, f = A2(bb, A3(KOn, c, r.d6, i), e), s = A2(JOn, a, r.iT);
        return A2(zx, w([
            DF(YOn(a))
        ]), w([
            A2(zx, w([
                Gx("radio-card"),
                Oq(w([
                    v("radio-card--selected", c),
                    v("radio-card--disabled", r.Bb || s),
                    v("radio-card--top", o)
                ]))
            ]), w([
                A2(zx, w([
                    Gx("radio-card__radio")
                ]), w([
                    A2(VX, w([
                        zqn(c),
                        SX(A2(qc, XOn, wm(e))),
                        Sqn(r.Bb || s)
                    ]), g)
                ])),
                A7(zQn, n, r, c, i, f, e, s)
            ])),
            o && !s ? A4(nQn, n, r, u, e) : vE
        ]));
    }), TQn = F3(function(n, r, t) {
        var e = function() {
            var n = v(r.k4, r.da);
            if (n.a && !n.b.$) {
                var t = n.b.a;
                return v(A2(no, function(n) {
                    return !i(rQ(n.v4), rQ(t.v4));
                }, r.bK), w([
                    r.da
                ]));
            }
            return v(r.bK, g);
        }(), u = e.a, a = e.b, c = $(t.kI ? w([
            Ot
        ]) : g, A2(Fu, function(n) {
            return It(n);
        }, u));
        return A2(Fu, A3(SQn, n, r, t), $(a, c));
    }), PQn = F3(function(n, r, t) {
        var e = A3(de, OOn, IOn, r);
        return A2(zx, g, A2(Qt, A3(WOn, n, e, t.bJ), A3(TQn, n, e, t)));
    }), ZQn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, MQn = {
        $: 12
    }, LQn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, NQn = function(n) {
        return n.wt.Fl;
    }, HQn = {
        $: 2
    }, IQn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, OQn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, QQn = w([
        OQn(1),
        OQn(5),
        OQn(10),
        OQn(20)
    ]), RQn = A2(Qt, A2(MG, g, It({
        $: 2
    })), A2(Qt, A2(MG, g, It(SSn)), A2(Qt, PG, A2(Fu, function(n) {
        return A2(MG, g, It(n));
    }, QQn)))), UQn = F4(function(n, r, t, e) {
        return A2(BE, w([
            xN(JI),
            VN(w([
                Gx("row--tweak")
            ]))
        ]), w([
            A2(lE, w([
                tO(6)
            ]), w([
                A2(c_, kNn, A4(qz, n, w([
                    XG(It(e.aC)),
                    SG,
                    HG("Filter by distance"),
                    CO(t)
                ]), RQn, e.fX))
            ])),
            A2(lE, w([
                tO(6)
            ]), w([
                function() {
                    if (e.aC.$) return vE;
                    var n = r || !yAn(e.zF);
                    return A2(zx, w([
                        Gx("sm:mt-0 mt-2")
                    ]), w([
                        I$n(w([
                            H$n(w([
                                _d("ZIP:")
                            ])),
                            PI(w([
                                OI(e.zF),
                                HI(IQn),
                                yI(n)
                            ]))
                        ]))
                    ]));
                }()
            ]))
        ]));
    }), KQn = F4(function(n, r, t, e) {
        var u = A2(Qt, A2(MG, g, fSn(CNn)), A2(Qt, PG, A2(Fu, MG(g), A2(Fu, function(n) {
            return function(n) {
                return {
                    $: 1,
                    a: n
                };
            }({
                sl: bSn(n),
                ur: oyn(n)
            });
        }, r))));
        return A2(c_, hNn, A4(qz, n, w([
            XG(It(t)),
            SG,
            HG(n(sSn))
        ]), u, e));
    }), WQn = F4(function(n, r, t, e) {
        var u = e.fi, a = e.lp, i = e.k5, c = e.dW, o = e.e3, f = e.e4, s = ve(t) > 1, l = !o && s, d = l || s ? aF : JI, b = l ? 8 : 12;
        return A2(BE, w([
            zDn,
            MQn,
            VN(w([
                Gx("mx-0")
            ]))
        ]), w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(BE, w([
                    xN(JI)
                ]), w([
                    A2(lE, w([
                        HQn
                    ]), w([
                        A2(BE, w([
                            xN(d),
                            VN(w([
                                Oq(w([
                                    v("hidden", f)
                                ]))
                            ]))
                        ]), w([
                            A2(lE, w([
                                TE(12)
                            ]), w([
                                PI(w([
                                    jI(n(NQn)),
                                    OI(c),
                                    HI(ZQn),
                                    LQn(16)
                                ]))
                            ]))
                        ])),
                        A2(BE, w([
                            xN(JI)
                        ]), w([
                            A2(lE, w([
                                cmn(4),
                                xN(aF),
                                A2(rO, 2, JI),
                                VN(w([
                                    Oq(w([
                                        v("hidden", !l)
                                    ]))
                                ]))
                            ]), w([
                                A4(KQn, n, t, a, u)
                            ])),
                            A2(lE, w([
                                cmn(b),
                                VN(w([
                                    Oq(w([
                                        v("hidden", !s)
                                    ]))
                                ]))
                            ]), w([
                                A2(c_, $Nn, A4(UQn, n, !1, r, i))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), XQn = F4(function(n, r, t, e) {
        return A2(c_, KLn, A4(WQn, n, r, t, e));
    }), YQn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, JQn = F3(function(n, r, t) {
        if (yOn(t)) {
            var e = aHn(t), u = iZn(t), a = A3(de, FOn, qOn, r), i = lNn(t), c = uZn(t), o = a.Bb || !yOn(t);
            return A2(zx, g, w([
                A4(XQn, n, o, nNn(t), t.aC),
                function() {
                    var r, f = t.f$;
                    switch(f.$){
                        case 0:
                            var s = f.a;
                            if (nE(e) && !VSn(t.Q)) return A2(f_, g, w([
                                _d("No providers found")
                            ]));
                            var l = A2(Op, function(n) {
                                return A2(wOn, n, Ot);
                            }, u);
                            return A2(zx, g, w([
                                A2(c_, YLn, A3(PQn, n, w([
                                    _On(o),
                                    GOn(l),
                                    DOn(e),
                                    VOn(c),
                                    BOn(t.mh),
                                    EOn(i),
                                    AOn(a.Cr || !nE(t.eZ)),
                                    COn(a.k4),
                                    jOn(a.iT)
                                ]), s)),
                                (r = t.lQ, A2(c_, YQn, A2(Yq, g, r)))
                            ]));
                        case 1:
                            return nE(i) && Xzn(t.P) ? A2(f_, g, w([
                                _d("No locations found")
                            ])) : A2(c_, WLn, A2(HOn, n, w([
                                xOn(o),
                                kOn(i),
                                zOn(c)
                            ])));
                        default:
                            return vE;
                    }
                }()
            ]));
        }
        return A2(zx, g, Nx);
    }), nRn = F2(function(n, r) {
        var t = A2(bb, kTn, A2(bb, function(n) {
            return A2(ATn, n, r.W);
        }, r.hz));
        return yOn(r.aL) ? A2(zx, w([
            Gx("mt-6")
        ]), w([
            A2(c_, KSn, A3(JQn, n, w([
                gOn(r.wk),
                hOn(t)
            ]), r.aL)),
            A2(xIn, n, r),
            A2(mIn, n, r)
        ])) : A2(zx, g, Nx);
    }), rRn = F2(function(n, r) {
        var t = A2(Op, function(n) {
            return n.sl;
        }, r.kY);
        if (t.$) return A2(zx, g, Nx);
        switch(t.a){
            case 0:
                return A2($On, n, r);
            case 1:
                return A2(wIn, n, r);
            case 2:
                return A2(nRn, n, r);
            default:
                return A2(qHn, n, r);
        }
    }), tRn = function(n) {
        var r = n.kY;
        if (r.$) return vE;
        var t = r.a;
        return A2(i_, w([
            uE(eE),
            uE(AD)
        ]), w([
            _d(A2(bTn, n.f2, t.sl))
        ]));
    }, eRn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, uRn = F3(function(n, r, t) {
        return {
            Bb: t,
            lh: r,
            sT: n
        };
    }), aRn = F3(function(n, r, t) {
        return A2(Fu, function(n) {
            return A3(uRn, n.sT, n.lh, !1);
        }, A3(pTn, n, r, t));
    }), iRn = F3(function(n, r, t) {
        var e = n.a2, u = n.bb, a = oe(t.lh + 1), c = t.Bb ? {
            eL: A2(Mx, w([
                Gx("stepper__circle")
            ]), w([
                _d(a)
            ])),
            f5: "disabled",
            f6: _d(t.sT)
        } : i(t.lh, e) ? {
            eL: A2(Mx, w([
                Gx("stepper__circle")
            ]), w([
                _d(a)
            ])),
            f5: "current",
            f6: _d(t.sT)
        } : 0 > s(t.lh, e) ? {
            eL: A2(UD, w([
                Gx("stepper__circle"),
                r
            ]), w([
                A2(Tq, g, 14)
            ])),
            f5: "previous",
            f6: A2(UD, w([
                r
            ]), w([
                _d(t.sT)
            ]))
        } : {
            eL: A2(Mx, w([
                Gx("stepper__circle")
            ]), w([
                _d(a)
            ])),
            f5: "next",
            f6: _d(t.sT)
        };
        return A2(zx, w([
            Gx("stepper__step stepper__step--" + c.f5)
        ]), w([
            c.eL,
            A2(Mx, w([
                Gx("stepper__text")
            ]), w([
                c.f6
            ])),
            A2(bE, 0 > s(t.lh + 1, u), A2(Mx, w([
                Gx("stepper__line")
            ]), w([
                s_
            ])))
        ]));
    }), cRn = F3(function(n, r, t) {
        return A3(iRn, {
            a2: n.a2,
            bb: n.bb
        }, qE(r(t)), t);
    }), oRn = F2(function(n, r) {
        var t = n.C1, e = n.F0;
        if (nE(e)) return vE;
        if (t.$) return vE;
        var u = t.a;
        return A2(zx, w([
            Gx("stepper")
        ]), A2(Fu, A2(cRn, {
            a2: u,
            bb: ve(e)
        }, r), e));
    }), fRn = F4(function(n, r, t, e) {
        return n.$ ? vE : A2(oRn, {
            C1: It(n.a.lh),
            F0: A3(aRn, r, t, e)
        }, eRn);
    }), sRn = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("text-left"),
            DF(fZn)
        ]), w([
            A2(mHn, n, t),
            s_,
            A4(fRn, r.kY, r.f2, r.dV, r.Da),
            A2(c_, Cu, tRn(r)),
            A2(rRn, n, r)
        ]));
    }), lRn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t = r.Da;
                    return t.$ ? Nx : w([
                        A3(sRn, n, r, t.a)
                    ]);
                }())
            ]),
            yx: n(ov.yx)
        };
    }), dRn = C_({
        Cl: LSn,
        CQ: NSn,
        Fj: HSn,
        F4: function(n) {
            return vx(w([
                A2(kj, ISn, QSn),
                A2(kj, xGn, L1(n.a4))
            ]));
        },
        Gv: bHn,
        GB: lRn
    }), vRn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bRn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, mRn = F5(function(n, r, t, e, u) {
        return {
            pj: n,
            rz: t,
            tL: e,
            uv: u,
            vU: r
        };
    }), pRn = A3(nk, "name", M$, au(function(n) {
        return {
            ur: n
        };
    })), $Rn = A2($A, pRn, au(cu)), gRn = A3(nk, "next_future_unpaid_bill", Agn, A3(nk, "membership_patients", ek(mVn), A3(nk, "first_bill", Agn, A3(nk, "plan", $Rn, A3(nk, "contract_end_date", uC(KA), au(mRn)))))), hRn = A2($A, gRn, au(cu)), yRn = F2(function(n, r) {
        return A2(bk, w([
            "contracts",
            r
        ]), fM(n));
    }), wRn = F4(function(n, r, t, e) {
        return A4(aA, n, hRn, e, pk(A2(yRn, r, t)));
    }), xRn = F3(function(n, r, t) {
        return v({
            g0: r.g0,
            eR: kc,
            hz: Ot,
            ld: r.ld,
            fn: _Vn,
            dV: n,
            yI: t.Ep.sl,
            yZ: t
        }, Uu(w([
            A2(Nu, bRn, Yz),
            A4(wRn, r.g0, ux(n), t.Ep.sl, vRn)
        ])));
    }), _Rn = F2(function(n, r) {
        return v(r, Qp);
    }), CRn = F2(function(n, r) {
        return m(r, {
            zK: It(2),
            g0: n.g0
        });
    }), ARn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kRn = F4(function(n, r, t, e) {
        return A4(lM, n, hRn, e, pk(A2(bk, w([
            "renew"
        ]), A2(yRn, r, t))));
    }), ERn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 2 === t.$ && 5 === t.a.$ && 400 === t.a.a ? b(r, A2(__, pa, Na), g) : b(m(r, {
                    eR: t
                }), Qp, A2(Ik, 0, t));
            case 1:
                return b(r, 3 === r.eR.$ ? A4(kRn, r.g0, ux(r.dV), r.yI, ARn) : Qp, g);
            case 2:
                var e = n.a, u = ed(w([
                    v("renewedMembershipId", r.yI)
                ]));
                return b(r, A2(__, u, Na), A2(Ik, 0, e));
            case 3:
                return b(m(r, {
                    hz: It(A2(Ep, x8, n.a))
                }), Qp, g);
            default:
                return b(r, Qp, g);
        }
    }), qRn = {
        $: 1
    }, FRn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, jRn = function(n) {
        return n.pj;
    }, DRn = function(n) {
        return A2(SM, sZ("/"), n);
    }, VRn = function(n) {
        return n.ur;
    }, BRn = function(n) {
        return n.vU;
    }, GRn = function(n) {
        return A2(zx, g, w([
            A2(Mx, w([
                Gx("text-support")
            ]), w([
                A2(UD, w([
                    Gx("link text-current"),
                    oV(x_(Na))
                ]), w([
                    _d(n(fv.Gi))
                ]))
            ])),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            _d("Renew membership")
        ]));
    }, zRn = F3(function(n, r, t) {
        var e = lBn(function(n) {
            return n.uv;
        }(t)), u = function(n) {
            return n.tL;
        }(t), a = GDn(function(n) {
            return n.rz;
        }(t));
        return A2(zx, w([
            Gx("text-left mb-5")
        ]), w([
            GRn(r),
            s_,
            A2(i_, w([
                uE(eE)
            ]), w([
                _d("Renew your membership")
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(f_, w([
                        uE(L6)
                    ]), w([
                        A2(xX, g, w([
                            _d("Plan Name")
                        ]))
                    ])),
                    A2(f_, w([
                        nF
                    ]), w([
                        _d(VRn(BRn(t)))
                    ]))
                ]))
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(f_, w([
                        uE(L6)
                    ]), w([
                        A2(xX, g, w([
                            _d("Membership ending")
                        ]))
                    ])),
                    A2(f_, w([
                        nF
                    ]), w([
                        _d(A2(xc, "N/A", A2(Op, DRn, jRn(t))))
                    ]))
                ]))
            ])),
            A2(c_, FRn, A5(LBn, !1, n.fn, r, u, n.hz)),
            A3(IBn, r, It(e), a),
            A2(yF, w([
                fF,
                cF(qRn)
            ]), w([
                _d(r(fv.wV))
            ]))
        ]));
    }), SRn = F2(function(n, r) {
        return {
            g8: function() {
                var t = r.eR;
                if (3 === t.$) {
                    var e = t.a;
                    return w([
                        A2(zx, w([
                            Gx("panel")
                        ]), w([
                            A3(zRn, r, n, e)
                        ]))
                    ]);
                }
                return Nx;
            }(),
            yx: ax(r.dV)
        };
    }), TRn = C_({
        Cl: xRn,
        CQ: _Rn,
        Fj: CRn,
        F4: function() {
            return bx;
        },
        Gv: ERn,
        GB: SRn
    }), PRn = F2(function(n, r) {
        return i8(n) ? A2(__, r.jb, ui) : A2(__, r.jb, Fa);
    }), ZRn = F3(function(n, r, t) {
        return v({
            ld: r.ld,
            vn: r.vn,
            dV: n,
            yZ: t.EX
        }, A2(PRn, r, t));
    }), MRn = F2(function(n, r) {
        return v(r, Qp);
    }), LRn = F2(function(n, r) {
        return r;
    }), NRn = F2(function(n, r) {
        return b(r, Qp, g);
    }), HRn = F2(function(n, r) {
        return {
            g8: Nx,
            yx: ax(r.dV)
        };
    }), IRn = C_({
        Cl: ZRn,
        CQ: MRn,
        Fj: LRn,
        F4: function() {
            return bx;
        },
        Gv: NRn,
        GB: HRn
    }), ORn = F2(function(n, r) {
        return i8(n) ? A2(__, r.jb, ui) : A2(__, r.jb, Fa);
    }), QRn = F3(function(n, r, t) {
        return v({
            ld: r.ld,
            vn: r.vn,
            dV: n,
            yZ: t.EX
        }, A2(ORn, r, t));
    }), RRn = F2(function(n, r) {
        return v(r, Qp);
    }), URn = F2(function(n, r) {
        return r;
    }), KRn = F2(function(n, r) {
        return b(r, Qp, g);
    }), WRn = F2(function(n, r) {
        return {
            g8: Nx,
            yx: ax(r.dV)
        };
    }), XRn = C_({
        Cl: QRn,
        CQ: RRn,
        Fj: URn,
        F4: function() {
            return bx;
        },
        Gv: KRn,
        GB: WRn
    }), YRn = function(n) {
        return v(n, Qp);
    }, JRn = function(n) {
        return {
            Cl: F2(function(n, r) {
                return b(r, Qp, g);
            }),
            CQ: wm(A2(tu, cu, YRn)),
            Fj: wm(cu),
            F4: function() {
                return bx;
            },
            Gv: F2(function(n, r) {
                return b(r, Qp, g);
            }),
            GB: n.GB
        };
    }, nUn = JRn({
        GB: function() {
            return {
                g8: w([
                    A2(zx, w([
                        Gx("panel")
                    ]), w([
                        A2(i_, w([
                            uE(eE)
                        ]), w([
                            _d("Page Not Found")
                        ])),
                        A2(Mx, w([
                            Gx("text-support")
                        ]), w([
                            A2(UD, w([
                                Gx("link"),
                                oV(x_(ui))
                            ]), w([
                                _d("Click here")
                            ]))
                        ])),
                        A2(Mx, g, w([
                            _d(" to go to your member portal home page.")
                        ]))
                    ]))
                ]),
                yx: "404"
            };
        }
    }), rUn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tUn = F5(function(n, r, t, e, u) {
        return {
            rl: u,
            vc: n,
            vn: t,
            wa: e,
            mt: r
        };
    }), eUn = A2(eu, cu, A3(nk, "name", M$, au(function(n) {
        return {
            ur: n
        };
    }))), uUn = A2(eu, cu, A4(JA, "expires_at", ik(KA), Ot, A3(nk, "prepaid_charges", ek(xDn), A3(nk, "patient", eUn, A3(nk, "status", M$, A3(nk, "package_name", M$, au(tUn))))))), aUn = F2(function(n, r) {
        return A2(bk, w([
            "patient_packages",
            r
        ]), fM(n));
    }), iUn = F4(function(n, r, t, e) {
        return A4(aA, n, uUn, e, pk(A2(aUn, r, t)));
    }), cUn = F3(function(n, r, t) {
        var e = t.Ep, u = ux(n), a = {
            g0: r.g0,
            cR: OG,
            ld: r.ld,
            lP: e.sl,
            iW: Ot,
            dV: n,
            EH: u
        };
        return v(a, function(n) {
            return A4(iUn, n.g0, n.EH, n.lP, rUn);
        }(a));
    }), oUn = F2(function(n, r) {
        return v(r, Qp);
    }), fUn = F2(function(n, r) {
        return m(r, {
            zK: It(2)
        });
    }), sUn = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return b(m(r, {
                cR: A2(A2(UG, t, r.cR) ? nU : QG, t, r.cR)
            }), Qp, g);
        }
        var e = n.a;
        return 3 === e.$ ? b(m(r, {
            iW: It(e.a)
        }), Qp, g) : b(r, Qp, A2(Ik, 0, e));
    }), lUn = F2(function(n, r) {
        return A2(zx, g, w([
            A2(Mx, w([
                Gx("text-support")
            ]), w([
                A2(UD, w([
                    Gx("link text-current"),
                    oV(x_(Na))
                ]), w([
                    _d(n(fv.Gi))
                ]))
            ])),
            A2(Mx, w([
                Gx("mx-3 text-support")
            ]), w([
                _d("/")
            ])),
            _d(r)
        ]));
    }), dUn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vUn = F2(function(n, r) {
        return r.va(n);
    }), bUn = F3(function(n, r, t) {
        var e = oe(function(n) {
            return n.wx;
        }(t)), u = "  " + n(vUn(e)), a = function(n) {
            return n.sC;
        }(t), i = A2(_p, "MM/dd/yyyy", function(n) {
            return n.uO;
        }(t));
        return A2(zx, w([
            Gx("text-support mt-2"),
            A2(VF, "display", "flex"),
            A2(VF, "align-items", "flex-start")
        ]), w([
            A2(zx, w([
                A2(VF, "display", "flex"),
                A2(VF, "flex-direction", "column"),
                A2(VF, "align-items", "center"),
                A2(VF, "margin-right", "10px"),
                A2(VF, "padding-top", "6px")
            ]), w([
                A2(zx, w([
                    A2(VF, "width", "6px"),
                    A2(VF, "height", "6px"),
                    A2(VF, "border-radius", "50%"),
                    A2(VF, "background-color", "currentColor"),
                    A2(VF, "opacity", "0.4"),
                    A2(VF, "flex-shrink", "0")
                ]), g),
                r ? A2(zx, w([
                    A2(VF, "width", "1px"),
                    A2(VF, "flex", "1"),
                    A2(VF, "background-color", "currentColor"),
                    A2(VF, "opacity", "0.3"),
                    A2(VF, "margin-bottom", "-30px")
                ]), g) : vE
            ])),
            A2(Mx, g, w([
                a.$ ? _d(i) : A2(UD, w([
                    oV(x_(Sa({
                        sl: a.a
                    }))),
                    Gx("link"),
                    A2(VF, "text-decoration", "underline")
                ]), w([
                    _d(i)
                ])),
                _d(u)
            ]))
        ]));
    }), mUn = F2(function(n, r) {
        var t = ve(r), e = A2(ge, F2(function(n, r) {
            return v(n, r);
        }), r);
        return A2(zx, w([
            A2(VF, "padding-left", "16px")
        ]), A2(Fu, function(r) {
            var e = r.b;
            return A3(bUn, n, 0 > s(r.a, t - 1), e);
        }, e));
    }), pUn = F3(function(n, r, t) {
        var e = XDn(t), u = WDn(t), a = KDn(UDn(t)), i = function(n) {
            return n.o5;
        }(t), c = !nE(i), o = function(n) {
            return n.sl;
        }(t), f = A2(UG, o, r);
        return A2(zx, g, w([
            A2(zx, w([
                Gx("text-support")
            ]), w([
                _d(oe(u) + " " + a + " "),
                c ? A2(Mx, w([
                    qE(dUn(o)),
                    A2(lF, "role", "button"),
                    CV(0),
                    A2(lF, "aria-expanded", f ? "true" : "false"),
                    A2(VF, "cursor", "pointer"),
                    Gx("link text-primary"),
                    A2(VF, "text-decoration", "none")
                ]), w([
                    A2(wX, g, w([
                        _d("(" + oe(e) + " remaining)")
                    ])),
                    f ? A2(Mx, w([
                        Gx("text-support"),
                        A2(VF, "font-size", "30px"),
                        A2(VF, "margin-left", "4px"),
                        A2(VF, "display", "inline-flex"),
                        A2(VF, "align-items", "center"),
                        A2(VF, "vertical-align", "middle")
                    ]), w([
                        _d("\u25B4")
                    ])) : vE
                ])) : A2(wX, g, w([
                    _d("(" + oe(e) + " remaining)")
                ]))
            ])),
            f && c ? A2(mUn, n, i) : vE
        ]));
    }), $Un = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("mb-5")
        ]), w([
            A2(f_, w([
                Hx(w([
                    Gx("mb-4")
                ]))
            ]), w([
                A2(xX, g, w([
                    _d("Includes")
                ]))
            ])),
            A2(BE, w([
                _E,
                TE(12)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(zx, w([
                        Gx("space-y-4")
                    ]), A2(Fu, A2(pUn, n, r), t))
                ]))
            ]))
        ]));
    }), gUn = F4(function(n, r, t, e) {
        var u = function(n) {
            return n.ur;
        }(r), a = $(t.$ ? "" : n(QDn(A2(_p, "MM/dd/yyyy", t.a))) + ", ", function(n) {
            var r = ke(n);
            if (r.$) return n;
            var t = r.a, e = t.b;
            return $(eb(z0(t.a)), e);
        }(e));
        return A2(zx, w([
            Gx("mb-5")
        ]), w([
            A2(f_, w([
                Hx(w([
                    Gx("mb-4")
                ]))
            ]), w([
                A2(xX, g, w([
                    _d("Patient")
                ]))
            ])),
            A2(BE, w([
                _E,
                TE(12)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(xX, g, w([
                        _d(u)
                    ])),
                    A2(f_, w([
                        nF
                    ]), w([
                        _d(a)
                    ]))
                ]))
            ]))
        ]));
    }), hUn = F3(function(n, r, t) {
        var e = function(n) {
            return n.mt;
        }(t), u = function(n) {
            return n.vn;
        }(t), a = function(n) {
            return n.wa;
        }(t), i = function(n) {
            return n.vc;
        }(t), c = function(n) {
            return n.rl;
        }(t);
        return A2(zx, w([
            Gx("text-left mb-5")
        ]), w([
            A2(lUn, n, i),
            s_,
            A2(i_, w([
                Hx(w([
                    Gx("mt-8 mb-8")
                ]))
            ]), w([
                _d(i)
            ])),
            A4(gUn, n, u, c, e),
            nE(a) ? vE : A3($Un, n, r.cR, a)
        ]));
    }), yUn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t = r.iW;
                    return t.$ ? Nx : w([
                        A3(hUn, n, r, t.a)
                    ]);
                }())
            ]),
            yx: n(fv.Gi)
        };
    }), wUn = C_({
        Cl: cUn,
        CQ: oUn,
        Fj: fUn,
        F4: function() {
            return bx;
        },
        Gv: sUn,
        GB: yUn
    }), xUn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _Un = function(n) {
        return {
            $: 1,
            a: n
        };
    }, CUn = F4(function(n, r, t, e) {
        return A4(aA, n, gQ, e, pk(A2(bk, w([
            t
        ]), sQ(r))));
    }), AUn = F3(function(n, r, t) {
        var e = t.Ep, u = ux(n), a = function() {
            var n = r.vn;
            if (3 === n.$) {
                var t = n.a;
                return v(It(kM(t)), zV(t));
            }
            return v(Ot, "");
        }();
        return v({
            g0: r.g0,
            eH: Ot,
            os: r.os,
            bn: !1,
            hn: !1,
            ld: r.ld,
            lm: e.sl,
            bG: kc,
            aq: Ot,
            fw: kc,
            fy: a.a,
            lT: a.b,
            lV: I0("checkout-payment-source-select"),
            lW: A_,
            dV: n,
            EH: u,
            d_: !1,
            mi: Ot
        }, Uu(w([
            A4(CUn, r.g0, u, e.sl, xUn),
            A3(r1, r.g0, u, _Un)
        ])));
    }), kUn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, EUn = function(n) {
        var r = n.g0, t = n.EH, e = n.xT, u = n.zZ, a = n.yC;
        if (A2(q2, n.os, e) && u > 0) {
            var i = A2(Op, D0, e);
            return i.$ ? Qp : A5(Bbn, r, t, i.a, u, a);
        }
        return Qp;
    }, qUn = function(n) {
        return n.mz;
    }, FUn = function(n) {
        return A2(xc, 0, A2(Op, qUn, n.eH));
    }, jUn = F2(function(n, r) {
        return EUn({
            zZ: FUn(n),
            g0: n.g0,
            os: n.os,
            EH: ux(n.dV),
            xT: r,
            yC: kUn
        });
    }), DUn = F2(function(n, r) {
        var t = !i(n.os, r.os), e = m(r, {
            os: n.os,
            fw: t ? kc : r.fw
        });
        return v(e, t ? A2(jUn, e, r.mi) : Qp);
    }), VUn = F2(function(n, r) {
        return m(r, {
            zK: Ot
        });
    }), BUn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, GUn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, zUn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, SUn = function(n) {
        return A2(bb, function(n) {
            return n.rc;
        }, mb(v2(n)));
    }, TUn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return 3 === (q = n.a).$ ? b(l = m(r, {
                    eH: It(q.a)
                }), A2(jUn, l, l.mi), g) : b(r, Qp, A2(Ik, 0, q));
            case 1:
                if (3 === (q = n.a).$) {
                    var t = a2(q.a);
                    return b(l = m(r, {
                        lW: q,
                        mi: t
                    }), A2(jUn, l, t), g);
                }
                return b(m(r, {
                    lW: q
                }), Qp, A2(Ik, 0, q));
            case 2:
                return b(m(r, {
                    fw: n.a
                }), Qp, g);
            case 3:
                var e = A3(t6, n.a, r.lV, r.mi), u = e.a, a = e.b, c = e.c, o = !i(A2(Op, D0, a), A2(Op, D0, r.mi)), f = function() {
                    if (c) {
                        var n = A6(N2, !1, r.ld, r.dV, r.os, Ot, r.g0), t = n.b;
                        return v(It(n.a), A2(Wp, BUn, t));
                    }
                    return v(o ? Ot : r.aq, Qp);
                }(), s = f.b, l = m(r, {
                    bG: kc,
                    aq: f.a,
                    lV: u,
                    mi: a
                });
                return c ? b(l, s, g) : o ? b(m(l, {
                    fw: kc
                }), A2(jUn, l, a), g) : b(l, Qp, g);
            case 4:
                var d = n.a, p = r.aq;
                if (1 === p.$) return b(r, Qp, g);
                var h = A2(X3, d, p.a), y = h.b, x = h.c, _ = m(r, {
                    aq: It(h.a)
                }), C = w([
                    A2(Wp, BUn, y)
                ]);
                n: for(; !x.$;)switch(x.a.$){
                    case 1:
                        var A = x.a.a, k = 3 !== (S = r.lW).$ || !nE(S.a);
                        return b(m(_, {
                            bG: A_
                        }), Uu(A2(Qt, A4(u2, r.g0, A, {
                            dT: !1,
                            wi: !1,
                            wW: Ot,
                            xq: !k
                        }, zUn), C)), g);
                    case 0:
                        var E = x.a.a;
                        return b(m(_, {
                            bG: kc
                        }), Uu(C), w([
                            Lk(E)
                        ]));
                    default:
                        break n;
                }
                return b(_, Uu(C), g);
            case 5:
                var q;
                if (3 === (q = n.a).$) {
                    var F = q.a, j = function() {
                        var n = r.lW;
                        if (3 === n.$) {
                            var t = n.b;
                            return A2(tC, $(n.a, w([
                                F
                            ])), t);
                        }
                        return n;
                    }();
                    return b(l = m(r, {
                        bG: q,
                        aq: Ot,
                        fw: kc,
                        lW: j,
                        mi: It(F)
                    }), A2(jUn, l, It(F)), g);
                }
                return b(m(r, {
                    bG: q
                }), Qp, A2(Ik, 0, q));
            case 6:
                return b(m(r, {
                    bG: kc,
                    aq: Ot
                }), Qp, g);
            case 7:
                return b(r, 1 === r.aq.$ ? Qp : A2(Wp, BUn, V2), g);
            case 8:
                var D = v(r.fy, r.mi);
                if (D.a.$ || D.b.$) return b(r, Qp, g);
                var V = D.a.a, B = D.b.a;
                return b(m(r, {
                    bn: !0
                }), A4(W1, r.g0, r.EH, {
                    sO: w([
                        Y1({
                            sl: r.lm,
                            iO: V
                        })
                    ]),
                    Ex: D0(B)
                }, GUn), g);
            case 9:
                var G = n.a;
                if (3 === G.$) {
                    var z = G.a;
                    return X1(z) ? b(m(r, {
                        bn: !1
                    }), Qp, w([
                        A2(Mk, 1, A2(xc, Tk, A2(Op, Zk, SUn(z))))
                    ])) : b(m(r, {
                        bn: !1,
                        hn: !0
                    }), Qp, g);
                }
                return b(m(r, {
                    bn: !1
                }), Qp, A2(Ik, 0, G));
            case 10:
                return b(m(r, {
                    d_: !r.d_
                }), Qp, g);
            default:
                return b(r, A2(__, pa, Da), g);
        }
        var S;
    }), PUn = {
        $: 11
    }, ZUn = function(n) {
        return n.aJ.o2;
    }, MUn = function(n) {
        return n.aJ.hN;
    }, LUn = function(n) {
        return n.aJ.Bp;
    }, NUn = function(n) {
        return n.aJ.C4;
    }, HUn = function(n) {
        return n.aJ.dS;
    }, IUn = function(n) {
        return n.aJ.cg;
    }, OUn = function(n) {
        return n.aJ.i9;
    }, QUn = function(n) {
        return n.aJ.ki;
    }, RUn = function(n) {
        return n.aJ.eg;
    }, UUn = function(n) {
        return n.aJ.yx;
    }, KUn = function(n) {
        return A2(zx, w([
            Gx("flex flex-col items-center justify-center px-6"),
            A2(VF, "min-height", "calc(100vh - 12rem)")
        ]), w([
            A2(zx, w([
                Gx("flex flex-col items-center")
            ]), w([
                A2(Tq, w([
                    Xj,
                    Wj("fill-primary-300 scale-[2.66]"),
                    MN(ZN)
                ]), 9),
                A2(zx, w([
                    Gx("mt-14")
                ]), w([
                    A2(CF, w([
                        gW,
                        uF(xD),
                        uE(Jq)
                    ]), w([
                        _d(n.yx)
                    ])),
                    A2(zx, w([
                        Gx("max-w-[14rem] mx-auto")
                    ]), w([
                        A2(f_, w([
                            nF,
                            uF(xD)
                        ]), w([
                            _d(n.g8)
                        ]))
                    ]))
                ]))
            ])),
            A2(zx, w([
                Gx("w-64 mt-16 [&_.button]:py-3")
            ]), w([
                A2(yF, w([
                    fF,
                    iK,
                    cF(n.DF)
                ]), w([
                    _d(n.Am)
                ]))
            ]))
        ]));
    }, WUn = {
        $: 6
    }, XUn = {
        $: 12
    }, YUn = {
        $: 7
    }, JUn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nKn = function(n) {
        return A2(zx, w([
            Gx("md:hidden mt-auto")
        ]), w([
            n
        ]));
    }, rKn = {
        $: 8
    }, tKn = function(n) {
        return n.mw;
    }, eKn = function(n) {
        var r = A2(xc, 0, A2(Op, M4, n));
        return r > 0 ? A2(zx, g, w([
            A2(f_, w([
                nF
            ]), w([
                A2(zx, w([
                    Gx("flex justify-between w-full")
                ]), w([
                    A2(zx, w([
                        Gx("flex")
                    ]), w([
                        _d("Credit card fee")
                    ])),
                    A2(zx, w([
                        Gx("flex")
                    ]), w([
                        _d(OK(r))
                    ]))
                ]))
            ]))
        ])) : vE;
    }, uKn = {
        $: 10
    }, aKn = F2(function(n, r) {
        return A2(zx, w([
            Gx("flex justify-between w-full mt-2 text-sm md:text-base")
        ]), w([
            A2(zx, w([
                Gx("flex")
            ]), w([
                A2(f_, g, w([
                    _d(n)
                ]))
            ])),
            A2(zx, g, w([
                A2(f_, w([
                    nF
                ]), w([
                    _d(OK(r))
                ]))
            ]))
        ]));
    }), iKn = F3(function(n, r, t) {
        var e = r.d_ ? "text-gray-400 transform rotate-90" : "text-gray-400";
        return A2(zx, w([
            Gx("mb-4")
        ]), w([
            A2(zx, w([
                Gx("flex justify-between items-center cursor-pointer py-2"),
                qE(uKn)
            ]), w([
                A2(f_, w([
                    nF
                ]), w([
                    _d(n(OUn))
                ])),
                A2(c_, Cu, A2(Tq, w([
                    zE,
                    Wj(e)
                ]), 7))
            ])),
            r.d_ ? A2(zx, w([
                Gx("mt-2")
            ]), w([
                A2(c_, Cu, A2(aKn, A2(xc, "", oU(t)), A2(xc, 0, aJ(t))))
            ])) : vE
        ]));
    }), cKn = F2(function(n, r) {
        return r > 0 ? A2(zx, g, w([
            A2(f_, w([
                nF
            ]), w([
                A2(zx, w([
                    Gx("flex justify-between w-full")
                ]), w([
                    A2(zx, w([
                        Gx("flex")
                    ]), w([
                        _d(n(rv))
                    ])),
                    A2(zx, w([
                        Gx("flex")
                    ]), w([
                        _d(OK(r))
                    ]))
                ]))
            ]))
        ])) : vE;
    }), oKn = F3(function(n, r, t) {
        var e = JF(r.fw), u = qUn(t), a = A2(xc, u, A2(Op, emn, e)), c = !i(r.mi, Ot) && !r.bn;
        return A2(zx, w([
            Gx("sidebar-wrap -mx-6 sm:-mx-8 sm:px-8")
        ]), w([
            A2(zx, w([
                Gx("flex justify-between items-center mb-2")
            ]), w([
                A2(f_, w([
                    ven
                ]), w([
                    _d(n(LUn))
                ])),
                A2(c_, Cu, A7(DW, n, a, !1, Ot, yE, !1, !1))
            ])),
            s_,
            A2(c_, Cu, A2(cKn, n, tKn(t))),
            A2(c_, Cu, eKn(e)),
            A3(iKn, n, r, t),
            A2(yF, w([
                fF,
                iK,
                cF(rKn),
                Lj(!c),
                Qj(r.bn)
            ]), w([
                _d(n(ZUn))
            ]))
        ]));
    }), fKn = F2(function(n, r) {
        return A2(zx, w([
            Gx("mb-6 mt-4")
        ]), w([
            A2(f_, w([
                uE(Jq)
            ]), w([
                A2(xX, g, w([
                    _d(n)
                ]))
            ])),
            A2(f_, w([
                nF
            ]), w([
                _d(r)
            ]))
        ]));
    }), sKn = function(n) {
        return A2(zx, g, w([
            A2(fKn, n.C5, n.lT),
            S4({
                ib: !1,
                lE: n.lE,
                lK: n.lK,
                iZ: n.iZ,
                lV: n.lV,
                lW: n.lW,
                mi: n.mi,
                mA: n.mA
            })
        ]));
    }, lKn = F3(function(n, r, t) {
        var e = JF(r.fw), u = qUn(t), a = A2(xc, u, A2(Op, emn, e)), c = !i(r.mi, Ot) && !r.bn;
        return A2(zx, w([
            Gx("sidebar-wrap")
        ]), w([
            A2(zx, w([
                Gx("flex justify-between items-center mb-2")
            ]), w([
                A2(f_, w([
                    ven
                ]), w([
                    _d(n(LUn))
                ])),
                A2(c_, Cu, A7(DW, n, a, !1, Ot, yE, !1, !1))
            ])),
            A2(c_, Cu, A2(cKn, n, tKn(t))),
            A2(c_, Cu, eKn(e)),
            A3(iKn, n, r, t),
            A2(yF, w([
                fF,
                iK,
                cF(rKn),
                Lj(!c),
                Qj(r.bn)
            ]), w([
                _d(n(ZUn))
            ]))
        ]));
    }), dKn = F3(function(n, r, t) {
        return vX(w([
            rK({
                AG: !1,
                Dy: XUn,
                yx: n(UUn)
            }),
            s_,
            GW({
                Ba: A3(lKn, n, r, t),
                CX: w([
                    sKn({
                        C5: n(NUn),
                        lE: n(HUn),
                        lK: JUn,
                        lT: r.lT,
                        iZ: n(IUn),
                        lV: r.lV,
                        lW: r.lW,
                        mi: i(r.aq, Ot) ? A2(Op, d6, r.mi) : It(v6),
                        mA: n
                    }),
                    function() {
                        var t = r.aq;
                        if (t.$) return vE;
                        var e = t.a, u = 1 === r.bG.$;
                        return A2(zx, w([
                            Gx("mb-6")
                        ]), $(A2(Fu, c_(BUn), D4(e)), w([
                            B4({
                                Cx: c4(e),
                                CC: u,
                                Dv: WUn,
                                DA: YUn,
                                mA: n
                            })
                        ])));
                    }()
                ])
            }),
            nKn(A3(oKn, n, r, t))
        ]));
    }), vKn = F2(function(n, r) {
        return {
            g8: w([
                function() {
                    if (r.hn) return KUn({
                        g8: n(QUn),
                        Am: n(MUn),
                        DF: PUn,
                        yx: n(RUn)
                    });
                    var t = r.eH;
                    return t.$ ? A2(zx, w([
                        Gx("panel")
                    ]), Nx) : A3(dKn, n, r, t.a);
                }()
            ]),
            yx: n(UUn)
        };
    }), bKn = C_({
        Cl: AUn,
        CQ: DUn,
        Fj: VUn,
        F4: function(n) {
            return n.aq.$ ? bx : A2(kj, BUn, S1);
        },
        Gv: TUn,
        GB: vKn
    }), mKn = {
        $: 0
    }, pKn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $Kn = function(n) {
        return A3(r1, n.g0, ux(n.dV), pKn);
    }, gKn = F3(function(n, r) {
        var t = {
            cw: mKn,
            g0: r.g0,
            ld: r.ld,
            dV: n,
            xU: kc,
            kn: r.kn
        };
        return v(t, $Kn(t));
    }), hKn = F2(function(n, r) {
        return v(r, Qp);
    }), yKn = F2(function(n, r) {
        return m(r, {
            zK: It(3)
        });
    }), wKn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), xKn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _Kn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, CKn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), AKn = au(0), kKn = F4(function(n, r, t, e) {
        return A4(Dj, n, AKn, e, pk(A2(bk, w([
            D0(t),
            "default"
        ]), n1(r))));
    }), EKn = F2(function(n, r) {
        return r.vD(n);
    }), qKn = F2(function(n, r) {
        return r.vE(n);
    }), FKn = uA("delete"), jKn = F4(function(n, r, t, e) {
        return A4(FKn, n, AKn, e, pk(A2(bk, w([
            D0(t)
        ]), n1(r))));
    }), DKn = F6(function(n, r, t, e, u, a) {
        return 3 === e.$ ? b(m(n, {
            xU: A_
        }), Uu(w([
            $Kn(n),
            A2(Jfn, a, g)
        ])), w([
            A2(Mk, 3, u(A2(T0, r, t)))
        ])) : b(n, Qp, A2(Ik, 0, e));
    }), VKn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? b(m(r, {
                    cw: mKn,
                    xU: t
                }), Qp, g) : b(m(r, {
                    cw: mKn,
                    xU: kc
                }), Qp, A2(Ik, 0, t));
            case 1:
                return b(m(r, {
                    cw: _Kn(D0(e = n.a))
                }), A4(jKn, r.g0, ux(r.dV), e, CKn(e)), g);
            case 2:
                var e = n.a, u = n.b;
                return A6(DKn, r, Vx(r.ld), e, u, qKn, "Payment Method Removed");
            case 3:
                return b(m(r, {
                    cw: xKn(D0(e = n.a))
                }), A4(kKn, r.g0, ux(r.dV), e, wKn(e)), g);
            default:
                return e = n.a, u = n.b, A6(DKn, r, Vx(r.ld), e, u, EKn, "Default Payment Method Changed");
        }
    }), BKn = function(n) {
        return function(n) {
            return {
                $: 12,
                a: n
            };
        }(n);
    }, GKn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, zKn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, SKn = function(n) {
        return n.E3;
    }, TKn = function(n) {
        return n.Bs;
    }, PKn = function(n) {
        return x_(Ya({
            sl: D0(n) + "/edit"
        }));
    }, ZKn = F2(function(n, r) {
        return k2(r) ? A2(Mx, w([
            Gx("button button--link ml-4 mr-4")
        ]), w([
            A2(EV, w([
                yV(PKn(r)),
                BKn("editPaymentMethod")
            ]), w([
                _d(n(TKn))
            ]))
        ])) : vE;
    }), MKn = F3(function(n, r, t) {
        return P0(t) ? A2(zx, w([
            Gx("float-right mt-3 ml-0 md:ml-8")
        ]), w([
            A2(Mx, g, w([
                A2(Tq, w([
                    zE
                ]), 13),
                A2(PE, w([
                    VG
                ]), w([
                    _d(n(Bv))
                ]))
            ])),
            A2(ZKn, n, t)
        ])) : A2(zx, w([
            Gx("float-right mt-3")
        ]), w([
            A2(yF, w([
                j6,
                cF(GKn(t)),
                Kj(w([
                    Gx("ml-0 mr-4 md:ml-6")
                ])),
                Qj(i(r, xKn(D0(t)))),
                Lj(!i(r, mKn))
            ]), w([
                _d(n(zv))
            ])),
            A2(ZKn, n, t),
            A2(yF, w([
                j6,
                cF(zKn(t)),
                Qj(i(r, _Kn(D0(t)))),
                Lj(!i(r, mKn))
            ]), w([
                _d(n(SKn))
            ]))
        ]));
    }), LKn = F2(function(n, r) {
        return r.m1(n);
    }), NKn = function(n) {
        return n.a.AT;
    }, HKn = F3(function(n, r, t) {
        return A2(t.rm, n, r);
    }), IKn = F2(function(n, r) {
        return A2(Op, function(t) {
            var e = t.a, u = t.b;
            return A2(PE, 4 === Tpn(r) ? w([
                x6
            ]) : g, A3(tu, _d, _K, n(A2(HKn, oe(e), oe(u)))));
        }, function(n) {
            if (n.$) return Ot;
            var r = n.a;
            return A3(_un, RC, r.hT, r.hU);
        }(r));
    }), OKn = function(n) {
        return n.$ ? Ot : n.a.zF;
    }, QKn = F2(function(n, r) {
        return A2(Op, function(r) {
            return _d(n(Nv) + " " + r);
        }, OKn(r));
    }), RKn = F3(function(n, r, t) {
        return A2(zx, g, w([
            A2(zx, w([
                Gx("text-left")
            ]), w([
                A2(PE, g, w([
                    _d(A2(T0, n, t))
                ])),
                A2(c_, Cu, A2(Qpn, n, Tpn(t)))
            ])),
            A2(zx, w([
                Gx("text-left")
            ]), A2(BV, _d(", "), A2(n$, cu, w([
                It(_d(n(LKn(A2(r, 0, NKn(t)))))),
                A2(IKn, n, t),
                A2(QKn, n, t)
            ]))))
        ]));
    }), UKn = F4(function(n, r, t, e) {
        return A2(BE, w([
            zDn,
            xN(JI)
        ]), w([
            A2(lE, w([
                TE(12),
                tO(7)
            ]), w([
                A3(RKn, n, r, e)
            ])),
            spn(w([
                TE(12),
                tO(1)
            ])),
            A2(lE, w([
                TE(12),
                tO(4)
            ]), w([
                A3(MKn, n, t, e)
            ]))
        ]));
    }), KKn = F4(function(n, r, t, e) {
        return A2(Fu, A3(UKn, n, r, t), e);
    }), WKn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), function() {
                    var t = r.xU;
                    switch(t.$){
                        case 3:
                            var e = t.a;
                            return w([
                                A2(BE, g, w([
                                    A2(lE, w([
                                        TE(12)
                                    ]), nE(e) ? rF(n(Lv)) : A4(KKn, n, r.kn, r.cw, e))
                                ])),
                                A2(BE, g, w([
                                    A2(lE, w([
                                        TE(12),
                                        tO(4)
                                    ]), w([
                                        A2(EV, w([
                                            yV(x_(Ya({
                                                sl: "new"
                                            }))),
                                            BKn("addPaymentMethod"),
                                            _N,
                                            Obn
                                        ]), w([
                                            _d(n(Av))
                                        ]))
                                    ]))
                                ]))
                            ]);
                        case 2:
                            return aE(n(Gv));
                        default:
                            return Nx;
                    }
                }())
            ]),
            yx: n(Pv)
        };
    }), XKn = C_({
        Cl: gKn,
        CQ: hKn,
        Fj: yKn,
        F4: function() {
            return bx;
        },
        Gv: VKn,
        GB: WKn
    }), YKn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, JKn = F3(function(n, r, t) {
        var e = t.EX, u = A2(ra, "replaces_payment_method", t.jb), a = A6(N2, !1, r.ld, n, r.os, Ot, r.g0), i = v(a.a, A2(Wp, YKn, a.b)), c = i.a, o = i.b;
        return v({
            g0: r.g0,
            os: r.os,
            ld: r.ld,
            aI: kc,
            vo: r.vu,
            iV: Gpn(r),
            c2: c,
            dV: n,
            wi: !1,
            wW: u,
            yZ: e
        }, o);
    }), nWn = F2(function(n, r) {
        return v(m(r, {
            os: n.os,
            iV: Gpn(n)
        }), Qp);
    }), rWn = F2(function(n, r) {
        return m(r, {
            zK: It(3)
        });
    }), tWn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eWn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                switch(t.$){
                    case 2:
                        var e = A6(N2, !1, r.ld, r.dV, r.os, Ot, r.g0), u = e.b;
                        return b(m(r, {
                            aI: t,
                            c2: e.a
                        }), A2(Wp, YKn, u), A2(Ik, 0, t));
                    case 3:
                        var a = t.a;
                        return b(m(r, {
                            aI: t
                        }), Uu(w([
                            A2(__, pa, Xa),
                            A2(Jfn, "Payment Method Added", g),
                            P0(a) ? A2(Jfn, "Default Payment Method Changed", g) : Qp
                        ])), w([
                            A2(Mk, 3, qv)
                        ]));
                    default:
                        return b(m(r, {
                            aI: t
                        }), Qp, A2(Ik, 0, t));
                }
            case 2:
                var i = A2(X3, n.a, r.c2), c = i.b, o = i.c, f = m(r, {
                    c2: i.a
                }), s = w([
                    A2(Wp, YKn, c)
                ]);
                n: for(; !o.$;)switch(o.a.$){
                    case 1:
                        var l = o.a.a;
                        return b(m(f, {
                            aI: A_
                        }), Uu(A2(Qt, A4(u2, r.g0, l, {
                            dT: !1,
                            wi: r.wi,
                            wW: r.wW,
                            xq: !0
                        }, tWn), s)), g);
                    case 0:
                        var d = o.a.a;
                        return b(m(f, {
                            aI: kc
                        }), Uu(s), w([
                            Lk(d)
                        ]));
                    default:
                        break n;
                }
                return b(f, Uu(s), g);
            case 1:
                return b(m(r, {
                    aI: A_
                }), A2(Wp, YKn, V2), g);
            default:
                return b(m(r, {
                    wi: n.a
                }), Qp, g);
        }
    }), uWn = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("panel")
            ]), w([
                A2(i_, w([
                    uE(eE)
                ]), w([
                    _d(n(Zv))
                ])),
                A2(f_, w([
                    nF
                ]), w([
                    A4(mG, ax(r), bV(r), It("This link is invalid, you may have already used it. If you need to update your payment information again"), It("to request a new link."))
                ]))
            ]))
        ]);
    }), aWn = wE(0), iWn = function(n) {
        return A2(SE, 3, n);
    }, cWn = {
        $: 1
    }, oWn = F2(function(n, r) {
        return A2(yF, w([
            fF,
            iK,
            Qj(i(r.aI, A_)),
            Lj(i(r.aI, A_) || !c4(r.c2)),
            cF(cWn)
        ]), w([
            _d(n(Tv))
        ]));
    }), fWn = F3(function(n, r, t) {
        return A2(zx, g, w([
            A3(B$n, n, r, t),
            ogn(r)
        ]));
    }), sWn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, lWn = F4(function(n, r, t, e) {
        return r ? A2(BE, w([
            xN(ZN)
        ]), w([
            A2(lE, g, w([
                A2(fI, w([
                    eI(t),
                    tI(sWn),
                    rI(e)
                ]), w([
                    _d(n(Sv))
                ]))
            ]))
        ])) : vE;
    }), dWn = F2(function(n, r) {
        return w([
            A2(zx, g, w([
                A2(i_, w([
                    uE(eE)
                ]), w([
                    _d(n(kv))
                ]))
            ])),
            A2(BE, w([
                xN(jvn),
                xN(JI)
            ]), w([
                A2(lE, w([
                    xN(JI)
                ]), A2(Fu, c_(YKn), D4(r.c2)))
            ])),
            A4(lWn, n, r.iV, r.wi, i(r.aI, A_)),
            s_,
            A3(fWn, !1, n, ax(r.dV)),
            s_,
            A2(BE, w([
                xN(jvn),
                xN(JI)
            ]), w([
                spn(w([
                    TE(0),
                    cmn(3),
                    iWn(4)
                ])),
                A2(lE, w([
                    cmn(6),
                    iWn(4)
                ]), w([
                    A2(oWn, n, r)
                ]))
            ]))
        ]);
    }), vWn = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("panel panel-success")
            ]), 3 === r.aI.$ ? w([
                A2(BE, w([
                    cE(xD)
                ]), w([
                    A2(lE, w([
                        TE(12)
                    ]), w([
                        A2(zN, w([
                            aWn
                        ]), w([
                            _d(n(Mv))
                        ]))
                    ]))
                ]))
            ]) : A2(dWn, n, r))
        ]);
    }), bWn = F2(function(n, r) {
        return {
            g8: b_(r.g0) ? A2(vWn, n, r) : A2(uWn, n, r.dV),
            yx: ax(r.dV)
        };
    }), mWn = C_({
        Cl: JKn,
        CQ: nWn,
        Fj: rWn,
        F4: function() {
            return vx(w([
                A2(kj, YKn, S1),
                bx
            ]));
        },
        Gv: eWn,
        GB: bWn
    }), pWn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $Wn = {
        $: 0
    }, gWn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, hWn = {
        hT: Ot,
        hU: Ot,
        zF: ""
    }, yWn = function(n) {
        return A2(bk, w([
            "cards"
        ]), fM(n));
    }, wWn = F4(function(n, r, t, e) {
        return A4(aA, n, J0, e, pk(A2(bk, w([
            t
        ]), yWn(r))));
    }), xWn = function(n) {
        return A2(xc, "", A2(NR, 2, A2(no, function(n) {
            return "" !== n;
        }, A2(se, "/", n.Ev))));
    }, _Wn = w([
        0,
        1
    ]), CWn = function(n) {
        return n ? "ExpDate" : "Zip";
    }, AWn = F3(function(n, r, t) {
        var e = t.EX;
        return v({
            g0: r.g0,
            hg: kc,
            hz: Ot,
            ld: r.ld,
            le: vZ(hWn),
            fr: Cd({
                sl: "month",
                Gj: F2(function(n, r) {
                    return r;
                }),
                Gk: function(n) {
                    return It(n);
                }
            }),
            aI: kc,
            dV: n,
            mt: $Wn,
            yZ: e,
            A: A2(pZ, _Wn, CWn),
            gj: Cd({
                sl: "year",
                Gj: F2(function(n, r) {
                    return oe(r);
                }),
                Gk: function(n) {
                    return It(oe(n));
                }
            })
        }, Uu(w([
            A2(Nu, gWn, Jz),
            A4(wWn, r.g0, ux(n), xWn(e), pWn)
        ])));
    }), kWn = F2(function(n, r) {
        return v(r, Qp);
    }), EWn = F2(function(n, r) {
        return m(r, {
            zK: It(3)
        });
    }), qWn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, FWn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jWn = {
        $: 1
    }, DWn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, VWn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, BWn = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), GWn = F5(function(n, r, t, e, u) {
        return A4(Dj, n, AKn, u, A2(dM, function(n) {
            return rx(w([
                v("card", rx(w([
                    v("exp_month", A2(wM, NQ, n.hT)),
                    v("exp_year", A2(wM, NQ, n.hU)),
                    v("zip", A2(wM, tx, n.zF))
                ])))
            ]));
        }(e), pk(A2(bk, w([
            t
        ]), yWn(r)))));
    }), zWn = F4(function(n, r, t, e) {
        var u = FM(n.le), a = {
            hT: u.hT,
            hU: u.hU,
            zF: It(u.zF)
        };
        return A5(GWn, n.g0, r, xWn(t), a, BWn(e));
    }), SWn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    zF: n.a
                });
            case 1:
                return m(r, {
                    hT: $u(n.a)
                });
            default:
                return m(r, {
                    hU: $u(n.a)
                });
        }
    }), TWn = F2(function(n, r) {
        var t = v(1, nL(A2(YM, rL, M3))), e = v(r.hU, r.hT);
        if (e.a.$ || e.b.$) return w([
            t
        ]);
        var u = e.a.a, a = e.b.a, c = A2(xc, 0, A2(Op, Qb, n)), o = A2(xc, 0, A2(Op, Jb, n));
        return i(c, u) && 0 > s(a, o) ? w([
            t
        ]) : g;
    }), PWn = function(n) {
        var r = n.zF;
        return iL(r) ? w([
            v(0, nL(A2(YM, rL, cAn)))
        ]) : yAn(r) ? g : w([
            v(0, fL(fAn))
        ]);
    }, ZWn = F2(function(n, r) {
        var t = n.le, e = A2(xc, "", OKn(r)), u = FM(t), a = function(n) {
            return n.$ ? Ot : n.a.hU;
        }(r), i = function(n) {
            return n.$ ? Ot : n.a.hT;
        }(r);
        return m(u, {
            hT: i,
            hU: a,
            zF: e
        });
    }), MWn = F2(function(n, r) {
        return A2(dZ, n, r.b);
    }), LWn = F3(function(n, r, t) {
        switch(r.$){
            case 3:
                return b(m(n, {
                    hg: A_
                }), A2(__, pa, Xa), w([
                    A2(Mk, 3, t)
                ]));
            case 2:
                return b(m(n, {
                    mt: FWn(j$n(r.a))
                }), Qp, A2(Ik, 0, r));
            default:
                return b(n, Qp, A2(Ik, 0, r));
        }
    }), NWn = F2(function(n, r) {
        switch(n.$){
            case 4:
                var t = n.a, e = Qb(t);
                return b(m(r, {
                    hz: It(t),
                    le: A3(cN, SWn, qWn(oe(e)), r.le)
                }), Qp, g);
            case 3:
                switch((x = n.a).$){
                    case 3:
                        return b(m(r, {
                            hg: x,
                            le: s = A2(MWn, A2(ZWn, r, x.a), r.le),
                            mt: jWn
                        }), Qp, g);
                    case 2:
                        return b(m(r, {
                            hg: kc,
                            mt: FWn(j$n(h = x.a))
                        }), Qp, A2(Ik, 0, x));
                    default:
                        return b(m(r, {
                            hg: kc
                        }), Qp, A2(Ik, 0, x));
                }
            case 0:
                var u = n.a, a = FM(r.le).hT, i = A2(dG, u, r.fr), c = i.a, o = i.b, f = (l = i.c).$ || l.a.$ ? oe(A2(xc, 1, a)) : A2(xc, "1", l.a.a), s = A3(cN, SWn, function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(f), r.le);
                return b(m(r, {
                    le: s,
                    fr: c
                }), A2(Wp, DWn, o), g);
            case 1:
                u = n.a;
                var l, d = FM(r.le).hU, v = A2(dG, u, r.gj);
                return c = v.a, o = v.b, b(m(r, {
                    le: s = A3(cN, SWn, qWn(oe(A2(xc, 0, f = (l = v.c).$ || l.a.$ ? d : l.a.a))), r.le),
                    gj: c
                }), A2(Wp, VWn, o), g);
            case 2:
                var p = n.a, $ = r.mt;
                switch($.$){
                    case 1:
                        return b(m(r, {
                            le: A3(cN, SWn, p, r.le)
                        }), Qp, g);
                    case 2:
                        var h = $.a;
                        return b(m(r, {
                            le: A3(cN, SWn, p, r.le),
                            mt: FWn(h)
                        }), Qp, g);
                    default:
                        return b(r, Qp, g);
                }
            case 5:
                var y = n.a;
                if (3 === y.$) {
                    var x = y.a, _ = XM(w([
                        TWn(r.hz),
                        PWn
                    ])), C = A2(CL, _, r.le);
                    return C.$ ? b(m(r, {
                        le: C.a
                    }), Qp, g) : b(r, A4(zWn, r, ux(r.dV), r.yZ, x), g);
                }
                return b(r, Qp, g);
            default:
                return A3(LWn, r, n.b, Mv);
        }
    }), HWn = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("panel")
            ]), w([
                A2(i_, w([
                    uE(eE)
                ]), w([
                    _d(n(Zv))
                ])),
                A2(f_, w([
                    nF
                ]), w([
                    A4(mG, ax(r), bV(r), It("This link is invalid, you may have already used it. If you need to update your payment information again"), It("to request a new link."))
                ]))
            ]))
        ]);
    }), IWn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, OWn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, QWn = F2(function(n, r) {
        return !nE(A2(iH, r, n.le));
    }), RWn = w([
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ]), UWn = function(n) {
        return A2(EV, w([
            _N,
            Obn,
            yV(x_(Xa))
        ]), w([
            _d(n(V4))
        ]));
    }, KWn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, WWn = F2(function(n, r) {
        return A2(yF, w([
            fF,
            iK,
            Qj(i(r.aI, A_)),
            Lj(i(r.aI, A_)),
            cF(KWn(r.hg))
        ]), w([
            _d(n(Xkn))
        ]));
    }), XWn = function(n) {
        var r = n.hz, t = function() {
            if (r.$) return g;
            var n = Qb(r.a);
            return A2($e, n, n + 10);
        }();
        return A2(Fu, function(n) {
            return A2(MG, g, n);
        }, t);
    }, YWn = F2(function(n, r) {
        var t = FM(r.le), e = t.zF, u = t.hT, a = t.hU;
        return w([
            A2(zx, g, w([
                A2(i_, w([
                    uE(eE)
                ]), w([
                    _d(n(jv))
                ]))
            ])),
            A2(zx, g, w([
                function() {
                    var t = r.hg;
                    if (3 === t.$) {
                        var i = t.a;
                        return A2(zx, g, w([
                            A2(BE, g, w([
                                A2(lE, w([
                                    TE(12)
                                ]), w([
                                    A2(EH, w([
                                        vH(n(Ev))
                                    ]), w([
                                        _d(A2(T0, n, i))
                                    ]))
                                ]))
                            ])),
                            A2(BE, g, w([
                                A2(lE, w([
                                    cmn(6)
                                ]), w([
                                    A2(EH, w([
                                        vH(n(Dv)),
                                        gH(!0)
                                    ]), w([
                                        A2(c_, DWn, A4(qz, n, w([
                                            XG(A2(Op, oe, u))
                                        ]), A2(Fu, function(n) {
                                            return A2(MG, g, n);
                                        }, RWn), r.fr))
                                    ])),
                                    A2(YH, n, A2(iH, 1, r.le))
                                ])),
                                A2(lE, w([
                                    cmn(6)
                                ]), w([
                                    A2(EH, w([
                                        vH(n(Vv)),
                                        gH(!0)
                                    ]), w([
                                        A2(c_, VWn, A4(qz, n, w([
                                            XG(a)
                                        ]), XWn(r), r.gj))
                                    ]))
                                ]))
                            ])),
                            A2(BE, g, w([
                                A2(lE, w([
                                    TE(12)
                                ]), w([
                                    A2(EH, w([
                                        vH(n(Nv)),
                                        gH(!0)
                                    ]), w([
                                        PI(w([
                                            OI(e),
                                            jI(n(Hv)),
                                            HI(A2(qc, IWn, OWn)),
                                            yI(A2(QWn, r, 0)),
                                            xO("zipCode")
                                        ])),
                                        A2(YH, n, A2(iH, 0, r.le))
                                    ]))
                                ]))
                            ])),
                            A2(BE, w([
                                xN(jvn),
                                xN(JI)
                            ]), w([
                                A2(lE, w([
                                    tO(2)
                                ]), w([
                                    A2(WWn, n, r)
                                ])),
                                A2(lE, w([
                                    tO(2)
                                ]), w([
                                    UWn(n)
                                ]))
                            ]))
                        ]));
                    }
                    return vE;
                }()
            ]))
        ]);
    }), JWn = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("panel panel-success")
            ]), 3 === r.aI.$ ? w([
                A2(BE, w([
                    cE(xD)
                ]), w([
                    A2(lE, w([
                        TE(12)
                    ]), w([
                        A2(zN, w([
                            aWn
                        ]), w([
                            _d(n(Mv))
                        ]))
                    ]))
                ]))
            ]) : A2(YWn, n, r))
        ]);
    }), nXn = F2(function(n, r) {
        return {
            g8: b_(r.g0) ? A2(JWn, n, r) : A2(HWn, n, r.dV),
            yx: n(jv)
        };
    }), rXn = C_({
        Cl: AWn,
        CQ: kWn,
        Fj: EWn,
        F4: function() {
            return bx;
        },
        Gv: NWn,
        GB: nXn
    }), tXn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, eXn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uXn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, aXn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, iXn = F3(function(n, r, t) {
        var e = t.Ep, u = hk(A2(Ep, r.f9, r.bp)), a = ux(n), i = function() {
            var n = r.vn;
            if (3 === n.$) {
                var t = n.a;
                return v(It(kM(t)), zV(t));
            }
            return v(Ot, "");
        }(), c = i.a, o = i.b, f = function() {
            if (c.$) return Qp;
            var n = c.a;
            return A7(p1, r.g0, a, It(e.sl), n, g, !1, uXn);
        }(), s = A2(lx, hin(qd), A3(j0, !0, r.g0, a)), l = s.b;
        return v({
            g0: r.g0,
            eH: Ot,
            os: r.os,
            bn: !1,
            hn: !1,
            hL: A_,
            a4: s.a,
            ld: r.ld,
            bG: kc,
            aq: Ot,
            fw: kc,
            fy: c,
            lT: o,
            lV: I0("plan-checkout-payment-source-select"),
            lW: A_,
            vV: e.sl,
            dV: n,
            mi: Ot,
            dc: !1,
            Gl: u
        }, Uu(w([
            A4(CUn, r.g0, a, e.sl, eXn),
            f,
            A2(Wp, tXn, l),
            A3(r1, r.g0, a, aXn)
        ])));
    }), cXn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, oXn = function(n) {
        return n.jd;
    }, fXn = function(n) {
        return n.je;
    }, sXn = function(n) {
        var r = n.eH;
        if (r.$) return 0;
        var t = r.a;
        return A2(xc, 0, fXn(t)) + A2(xc, 0, A2(FE, aJ(t), oXn(t))) + tKn(t);
    }, lXn = F2(function(n, r) {
        return EUn({
            zZ: sXn(n),
            g0: n.g0,
            os: n.os,
            EH: ux(n.dV),
            xT: r,
            yC: cXn
        });
    }), dXn = F2(function(n, r) {
        var t = !i(n.os, r.os), e = m(r, {
            os: n.os,
            fw: t ? kc : r.fw
        });
        return v(e, t ? A2(lXn, e, r.mi) : Qp);
    }), vXn = F2(function(n, r) {
        return m(r, {
            zK: Ot
        });
    }), bXn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, mXn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, pXn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, $Xn = function(n) {
        return n.Ag;
    }, gXn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return 3 === (B = n.a).$ ? b(x = m(r, {
                    eH: It(T = B.a)
                }), A2(lXn, x, x.mi), g) : b(r, Qp, A2(Ik, 0, B));
            case 1:
                return 3 === (B = n.a).$ ? b(m(r, {
                    hL: B,
                    a4: e = A2(vHn, B.a, r.a4)
                }), Qp, g) : b(m(r, {
                    hL: B
                }), Qp, A2(Ik, 0, B));
            case 2:
                var t = A2(r6, _ = n.a, r.a4), e = t.a, u = t.b, a = t.c, c = a.$ || a.a.$ ? r.dc : r.dc && !O2(e);
                return b(m(r, {
                    a4: e,
                    dc: c
                }), A2(Wp, tXn, u), g);
            case 3:
                if (3 === (B = n.a).$) {
                    var o = a2(B.a);
                    return b(x = m(r, {
                        lW: B,
                        mi: o
                    }), A2(lXn, x, o), g);
                }
                return b(m(r, {
                    lW: B
                }), Qp, A2(Ik, 0, B));
            case 4:
                return b(m(r, {
                    fw: n.a
                }), Qp, g);
            case 5:
                var f = A3(t6, n.a, r.lV, r.mi), s = f.a, l = f.b, d = f.c, p = !i(A2(Op, D0, l), A2(Op, D0, r.mi)), h = function() {
                    if (d) {
                        var n = A6(N2, !1, r.ld, r.dV, r.os, Ot, r.g0), t = n.b;
                        return v(It(n.a), A2(Wp, bXn, t));
                    }
                    return v(p ? Ot : r.aq, Qp);
                }(), y = h.b, x = m(r, {
                    bG: kc,
                    aq: h.a,
                    lV: s,
                    mi: l
                });
                return d ? b(x, y, g) : p ? b(m(x, {
                    fw: kc
                }), A2(lXn, x, l), g) : b(x, Qp, g);
            case 6:
                var _ = n.a, C = r.aq;
                if (1 === C.$) return b(r, Qp, g);
                var A = A2(X3, _, C.a), k = A.b, E = A.c, q = m(r, {
                    aq: It(A.a)
                }), F = w([
                    A2(Wp, bXn, k)
                ]);
                n: for(; !E.$;)switch(E.a.$){
                    case 1:
                        var j = E.a.a, D = 3 !== (H = r.lW).$ || !nE(H.a);
                        return b(m(q, {
                            bG: A_
                        }), Uu(A2(Qt, A4(u2, r.g0, j, {
                            dT: !1,
                            wi: !1,
                            wW: Ot,
                            xq: !D
                        }, pXn), F)), g);
                    case 0:
                        var V = E.a.a;
                        return b(m(q, {
                            bG: kc
                        }), Uu(F), w([
                            Lk(V)
                        ]));
                    default:
                        break n;
                }
                return b(q, Uu(F), g);
            case 7:
                var B;
                if (3 === (B = n.a).$) {
                    var G = B.a, z = function() {
                        var n = r.lW;
                        if (3 === n.$) {
                            var t = n.b;
                            return A2(tC, $(n.a, w([
                                G
                            ])), t);
                        }
                        return n;
                    }();
                    return b(x = m(r, {
                        bG: B,
                        aq: Ot,
                        fw: kc,
                        lW: z,
                        mi: It(G)
                    }), A2(lXn, x, It(G)), g);
                }
                return b(m(r, {
                    bG: B
                }), Qp, A2(Ik, 0, B));
            case 8:
                return b(m(r, {
                    bG: kc,
                    aq: Ot
                }), Qp, g);
            case 9:
                return b(r, 1 === r.aq.$ ? Qp : A2(Wp, bXn, V2), g);
            case 10:
                if (O2(r.a4)) {
                    var S = b(r.fy, r.mi, r.eH);
                    if (S.a.$ || S.b.$ || S.c.$) return b(r, Qp, g);
                    var T, P = S.a.a, Z = S.b.a, M = A2(xc, 1, A2(FE, c0(T = S.c.a), A2(Op, lU, $Xn(T))));
                    return b(m(r, {
                        bn: !0,
                        dc: !1
                    }), A4(W1, r.g0, ux(r.dV), {
                        sO: w([
                            J1({
                                kz: d2(r.a4),
                                sl: r.vV,
                                tL: w([
                                    {
                                        fy: P,
                                        EJ: Ot
                                    }
                                ]),
                                iO: P,
                                vN: M,
                                x0: r.Gl
                            })
                        ]),
                        Ex: D0(Z)
                    }, mXn), g);
                }
                return b(m(r, {
                    dc: !0
                }), Qp, g);
            case 11:
                var L = n.a;
                if (3 === L.$) {
                    var N = L.a;
                    return X1(N) ? b(m(r, {
                        bn: !1
                    }), Qp, w([
                        A2(Mk, 1, A2(xc, Tk, A2(Op, Zk, SUn(N))))
                    ])) : b(m(r, {
                        bn: !1,
                        hn: !0
                    }), Qp, g);
                }
                return b(m(r, {
                    bn: !1
                }), Qp, A2(Ik, 0, L));
            default:
                return b(r, A2(__, pa, Da), g);
        }
        var H;
    }), hXn = {
        $: 12
    }, yXn = function(n) {
        return n.I.o1;
    }, wXn = function(n) {
        return n.I.hN;
    }, xXn = function(n) {
        return n.I.Bp;
    }, _Xn = function(n) {
        return n.I.C4;
    }, CXn = function(n) {
        return n.I.Db;
    }, AXn = function(n) {
        return n.I.dS;
    }, kXn = function(n) {
        return n.I.u1;
    }, EXn = function(n) {
        return n.I.cg;
    }, qXn = function(n) {
        return n.I.EZ;
    }, FXn = function(n) {
        return n.I.x5;
    }, jXn = function(n) {
        return n.I.ki;
    }, DXn = function(n) {
        return n.I.eg;
    }, VXn = function(n) {
        return n.I.yx;
    }, BXn = {
        $: 8
    }, GXn = {
        $: 13
    }, zXn = {
        $: 9
    }, SXn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, TXn = F2(function(n, r) {
        return A2(c_, tXn, A3(e4, n, w([
            p6(r.dc),
            m6(r.bn)
        ]), r.a4));
    }), PXn = {
        $: 10
    }, ZXn = F2(function(n, r) {
        var t = r.eH;
        if (t.$) return vE;
        var e = t.a, u = tKn(e), a = A2(xc, 0, fXn(e)), i = A2(xc, 0, A2(FE, aJ(e), oXn(e))), c = A2(FE, A2(bb, o0, c0(e)), $Xn(e)), o = JF(r.fw), f = A2(xc, a + i + u, A2(Op, emn, o));
        return A2(Kk, w([
            uE(aF)
        ]), w([
            a > 0 ? A2(Kk, w([
                uE(Jq),
                uF(AF),
                uF(gE)
            ]), w([
                A2(f_, w([
                    nF
                ]), w([
                    _d(n(kXn))
                ])),
                A2(c_, Cu, A7(DW, n, a, !1, Ot, yE, !1, !1))
            ])) : vE,
            A2(Kk, w([
                uE(Jq),
                uF(AF),
                uF(gE)
            ]), w([
                A2(f_, w([
                    nF
                ]), w([
                    _d(n(qXn))
                ])),
                A2(c_, Cu, A7(DW, n, i, !1, c, yE, !1, !1))
            ])),
            A2(c_, Cu, A2(cKn, n, u)),
            A2(c_, Cu, eKn(o)),
            s_,
            A2(Kk, w([
                uE(aF),
                uF(AF),
                uF(gE)
            ]), w([
                A2(f_, w([
                    ven
                ]), w([
                    _d(n(xXn))
                ])),
                A2(c_, Cu, A7(DW, n, f, !1, Ot, yE, !1, !1))
            ]))
        ]));
    }), MXn = F2(function(n, r) {
        var t = !i(r.mi, Ot) && O2(r.a4) && !r.bn;
        return A2(zx, w([
            Gx("sidebar-wrap -mx-6 sm:-mx-8 sm:px-8")
        ]), w([
            A2(ZXn, n, r),
            A2(yF, w([
                fF,
                iK,
                cF(PXn),
                Lj(!t),
                Qj(r.bn)
            ]), w([
                _d(n(yXn))
            ]))
        ]));
    }), LXn = F2(function(n, r) {
        var t = !i(r.mi, Ot) && O2(r.a4) && !r.bn;
        return A2(zx, w([
            Gx("sidebar-wrap")
        ]), w([
            A2(ZXn, n, r),
            A2(yF, w([
                fF,
                iK,
                cF(PXn),
                Lj(!t),
                Qj(r.bn)
            ]), w([
                _d(n(yXn))
            ]))
        ]));
    }), NXn = function(n) {
        return A2(zx, w([
            Gx("mb-6")
        ]), w([
            A2(f_, w([
                uE(Jq)
            ]), w([
                A2(xX, g, w([
                    _d(n(CXn))
                ]))
            ])),
            A2(f_, w([
                nF
            ]), w([
                _d(n(FXn))
            ]))
        ]));
    }, HXn = F2(function(n, r) {
        return vX(w([
            rK({
                AG: !1,
                Dy: GXn,
                yx: n(VXn)
            }),
            s_,
            GW({
                Ba: A2(LXn, n, r),
                CX: w([
                    sKn({
                        C5: n(_Xn),
                        lE: n(AXn),
                        lK: SXn,
                        lT: r.lT,
                        iZ: n(EXn),
                        lV: r.lV,
                        lW: r.lW,
                        mi: i(r.aq, Ot) ? A2(Op, d6, r.mi) : It(v6),
                        mA: n
                    }),
                    function() {
                        var t = r.aq;
                        if (t.$) return vE;
                        var e = t.a, u = 1 === r.bG.$;
                        return A2(zx, w([
                            Gx("mb-6")
                        ]), $(A2(Fu, c_(bXn), D4(e)), w([
                            B4({
                                Cx: c4(e),
                                CC: u,
                                Dv: BXn,
                                DA: zXn,
                                mA: n
                            })
                        ])));
                    }(),
                    NXn(n),
                    A2(TXn, n, r)
                ])
            }),
            nKn(A2(MXn, n, r))
        ]));
    }), IXn = F2(function(n, r) {
        return {
            g8: w([
                r.hn ? KUn({
                    g8: n(jXn),
                    Am: n(wXn),
                    DF: hXn,
                    yx: n(DXn)
                }) : r.eH.$ ? A2(zx, w([
                    Gx("panel")
                ]), Nx) : A2(HXn, n, r)
            ]),
            yx: n(VXn)
        };
    }), OXn = C_({
        Cl: iXn,
        CQ: dXn,
        Fj: vXn,
        F4: function(n) {
            var r = n.aq.$ ? bx : A2(kj, bXn, S1);
            return vx(w([
                A2(kj, tXn, L1(n.a4)),
                r
            ]));
        },
        Gv: gXn,
        GB: IXn
    }), QXn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, RXn = F3(function(n, r) {
        var t = {
            g0: r.g0,
            hz: A2(Ep, r.f9, r.bp),
            dx: 0,
            ld: r.ld,
            iH: 0,
            vn: Ot,
            lR: r.vn,
            iY: Ot,
            lU: g,
            dV: n,
            fO: "content-container",
            fQ: !1,
            fW: Ot,
            f_: Ot,
            f2: kc,
            jL: Ot,
            kn: r.kn
        };
        return v(t, function(n) {
            return A3(BQ, n.g0, ux(n.dV), QXn);
        }(t));
    }), UXn = F2(function(n, r) {
        return v(r, Qp);
    }), KXn = F2(function(n, r) {
        return m(r, {
            zK: It(6)
        });
    }), WXn = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), XXn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, YXn = nr("onWindowScroll", A2(nu, function(n) {
        return A2(nu, function(r) {
            return au({
                mF: r,
                bj: n
            });
        }, A2(Iu, "x", I$));
    }, A2(Iu, "y", I$))), JXn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, nYn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, rYn = function(n) {
        return n.w1;
    }, tYn = function(n) {
        return n.w4;
    }, eYn = function(n) {
        var r = function(n) {
            return n.a.lz;
        }(n);
        return tYn(r) || rYn(r);
    }, uYn = F2(function(n, r) {
        var t, e = n.lR;
        if (3 === e.$) {
            var u = e.a;
            return t = function(n) {
                return n.lz;
            }(u), tYn(t) || rYn(t) ? It(kM(u)) : function(n) {
                return A2(Op, eQ, mb(A2(no, eYn, n)));
            }(r);
        }
        return Ot;
    }), aYn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, iYn = F2(function(n, r) {
        return A4(Phn, n.g0, ux(n.dV), r, aYn);
    }), cYn = F2(function(n, r) {
        return A2(Op, eQ, A2(NR, n, r));
    }), oYn = function(n) {
        return JX(n);
    }, fYn = function(n) {
        var r = v(A2(cYn, n.dx, n.lU), function(n) {
            return A2(Op, eQ, mb(A2(no, oYn, n.lU)));
        }(n));
        return r.a.$ ? r.b.$ ? "" : r.b.a : r.b.$ ? r.a.a : r.b.a;
    }, sYn = F2(function(n, r) {
        var t = A2(no, eYn, n.lU), e = ve(t);
        return 1 === r.hS ? v(e > 1 && !i(n.dx + 1, e) ? A2(iYn, n, A2(xc, "", A2(cYn, n.dx + 1, t))) : A2(__, pa, Za({
            sl: fYn(n)
        })), w([
            A2(Mk, 3, Iv)
        ])) : v(Qp, r.iM);
    }), lYn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, dYn = A3(nk, "id", M$, au(function(n) {
        return {
            sl: n
        };
    })), vYn = A2($A, dYn, au(cu)), bYn = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            o0: o,
            sl: n,
            sG: c,
            sM: i,
            s1: a,
            s2: e,
            s3: u,
            xQ: r,
            yZ: t
        };
    }), mYn = A3(nk, "company_name", uC(M$), A3(nk, "is_checkout_page", ru, A3(nk, "is_retail_page", ru, A3(nk, "limit_available_location_groups", ru, A3(nk, "limit_available_practitioners", ru, A3(nk, "limit_available_locations", ru, A3(nk, "url", uC(M$), A3(nk, "slug", M$, A3(nk, "id", M$, au(bYn)))))))))), pYn = A2(eu, cu, mYn), $Yn = A3(nk, "prepay_first_payment_on_signup", ru, A3(nk, "dependent_limit", uC(O$), A3(nk, "collect_rate_schedule_on_signup", ru, A3(nk, "collect_start_date_on_signup", ru, A3(nk, "allow_coupons", ru, A3(nk, "accepts_new_signup", ru, A3(nk, "default_location", uC(vYn), A3(nk, "default_practitioner", uC(jQ), A3(nk, "allowed_zip_codes_on_signup", ek(M$), A3(nk, "restrict_zip_codes_on_signup", ru, A3(nk, "collect_tobacco_use", ru, A3(nk, "allows_payer_on_behalf_on_signup", A2(nu, xwn, M$), A3(nk, "signup_page", pYn, A3(nk, "post_signup_button_label", uC(M$), A3(nk, "show_post_signup_footer_button", ru, A3(nk, "post_signup_message", uC(M$), A3(nk, "post_signup_redirect_url", uC(M$), A3(nk, "redirects_post_signup", ru, A3(nk, "min_enroll_age", uC(O$), A3(nk, "collect_ssn_on_signup", A2(nu, xwn, M$), A3(nk, "collect_broker_on_signup", A2(nu, xwn, M$), A3(nk, "collect_lead_source_on_signup", A2(nu, xwn, M$), A3(nk, "collect_payment_source_on_signup", A2(nu, xwn, M$), A3(nk, "collect_insurance_on_signup", A2(nu, xwn, M$), A3(nk, "collect_location_on_signup", A2(nu, xwn, M$), A3(nk, "collect_practitioner_on_signup", A2(nu, xwn, M$), A3(nk, "collect_address_on_signup", A2(nu, xwn, M$), A3(nk, "collect_billing_address_on_signup", A2(nu, xwn, M$), au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return function(b) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(y) {
                                                                                        return function(w) {
                                                                                            return function(x) {
                                                                                                return function(_) {
                                                                                                    return function(C) {
                                                                                                        return function(A) {
                                                                                                            return function(k) {
                                                                                                                return function(E) {
                                                                                                                    return {
                                                                                                                        mN: x,
                                                                                                                        nj: _,
                                                                                                                        nl: p,
                                                                                                                        no: h,
                                                                                                                        oM: r,
                                                                                                                        oN: n,
                                                                                                                        oO: c,
                                                                                                                        oR: u,
                                                                                                                        oS: i,
                                                                                                                        oT: e,
                                                                                                                        oV: a,
                                                                                                                        oW: t,
                                                                                                                        oX: A,
                                                                                                                        oY: o,
                                                                                                                        oZ: C,
                                                                                                                        o_: $,
                                                                                                                        p0: w,
                                                                                                                        p4: y,
                                                                                                                        p7: k,
                                                                                                                        ui: f,
                                                                                                                        lY: b,
                                                                                                                        lZ: d,
                                                                                                                        l_: l,
                                                                                                                        wb: E,
                                                                                                                        wK: s,
                                                                                                                        xb: g,
                                                                                                                        mo: v,
                                                                                                                        mp: m
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))), gYn = A2($A, $Yn, au(cu)), hYn = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), gYn, t, A2($k, function(n) {
            return mu(n) ? g : w([
                A2(g_, "signup_page_id", n)
            ]);
        }(r), pk(e)));
    }), yYn = F4(function(n, r, t, e) {
        return A4(hYn, n, t, e, A2(bk, w([
            "signup_page_setting"
        ]), fM(r)));
    }), wYn = F5(function(n, r, t, e, u) {
        return A4(hYn, n, e, u, A2(bk, w([
            "signup_setting"
        ]), A2(bk, w([
            "companies",
            t
        ]), fM(r))));
    }), xYn = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), _Yn = F3(function(n, r, t) {
        return {
            sl: n,
            lh: r,
            sT: t
        };
    }), CYn = function(n) {
        return A2(xc, "", It(aQ(n)));
    }, AYn = F2(function(n, r) {
        return A2(xc, "", A2(NR, n, function(n) {
            return A2(Fu, CYn, n);
        }(r)));
    }), kYn = function(n) {
        return A2(Fu, eQ, n);
    }, EYn = F2(function(n, r) {
        return A2(xc, -1, A2(YSn, n, r));
    }), qYn = F2(function(n, r) {
        var t = A2(EYn, r, kYn(n));
        return A3(_Yn, r, t, A2(AYn, t, n));
    }), FYn = F2(function(n, r) {
        return {
            kY: A2(qYn, n, r),
            lU: n
        };
    }), jYn = F5(function(n, r, t, e, u) {
        return v({
            g0: u,
            vn: t,
            dV: e,
            fQ: !1,
            mh: r,
            mj: n
        }, Qp);
    }), DYn = function(n) {
        return n.oT;
    }, VYn = function(n) {
        return n.oW;
    }, BYn = function(n) {
        return n.sl;
    }, GYn = function(n) {
        return n.mp;
    }, zYn = F3(function(n, r, t) {
        return m(t, {
            P: DYn(r),
            Q: VYn(r),
            bx: It(BYn(GYn(r))),
            hY: n.iY
        });
    }), SYn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, TYn = function(n) {
        return rx(w([
            v("id", tx(n))
        ]));
    }, PYn = function(n) {
        var r = ux(n.dV), t = function() {
            var r = n.vn;
            return r.$ ? "" : eyn(r.a);
        }(), e = w([
            v("practitioner", A2(wM, TYn, n.mj)),
            v("location", A2(wM, TYn, n.mh))
        ]), u = v("patient", rx(e));
        return A5(cCn, n.g0, r, t, u, SYn);
    }, ZYn = F2(function(n, r) {
        if (1 === n.$) return {
            hs: PYn(r),
            hS: 0,
            iA: m(r, {
                fQ: !0
            }),
            iM: g
        };
        var t = n.a;
        return 3 === t.$ ? {
            hs: Qp,
            hS: 1,
            iA: m(r, {
                vn: It(t.a),
                fQ: !1
            }),
            iM: g
        } : {
            hs: Qp,
            hS: 0,
            iA: m(r, {
                fQ: !1
            }),
            iM: A2(Ik, 0, t)
        };
    }), MYn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = r.fW;
                if (e.$) return b(r, Qp, g);
                var u = A2(PNn, t, e.a), a = u.a, c = u.b, o = A5(jYn, a.mj, a.mh, r.vn, r.dV, r.g0), f = o.b;
                return b(m(r, {
                    fQ: (l = o.a).fQ,
                    fW: It(a),
                    f_: It(l)
                }), Uu(w([
                    A2(Wp, JXn, c),
                    A2(Wp, nYn, f)
                ])), g);
            case 3:
                return b(r, A2(Nu, cu, Au(nYn(t = n.a))), g);
            case 4:
                t = n.a;
                var s = r.f_;
                if (s.$) return b(r, Qp, g);
                var l, d = A2(ZYn, t, l = s.a), p = A2(sYn, r, d), $ = p.a, h = p.b;
                return b(m(r, {
                    fQ: d.iA.fQ,
                    f_: It(d.iA)
                }), Uu(w([
                    $,
                    A2(Wp, nYn, d.hs)
                ])), h);
            case 1:
                var y = n.a;
                if (3 === y.$) {
                    var x = y.a, _ = A2(no, eYn, r.lU), C = function() {
                        if (ve(_) > 1) {
                            var n = A2(FYn, _, eyn(x));
                            return m(r, {
                                dx: n.kY.lh,
                                vn: It(x),
                                jL: It(n)
                            });
                        }
                        var t = wyn(x).zF;
                        return m(r, {
                            vn: It(x),
                            iY: t
                        });
                    }();
                    return b(C, function(n) {
                        var r = n.vn;
                        if (r.$) return Qp;
                        var t = function(n) {
                            return n.o$;
                        }(r.a);
                        if (t.$) return A4(yYn, n.g0, ux(n.dV), "", lYn);
                        var e = t.a;
                        return A5(wYn, n.g0, ux(n.dV), function(n) {
                            return n.sl;
                        }(e), "", lYn);
                    }(C), g);
                }
                return b(r, Qp, A2(Ik, 0, y));
            case 2:
                var A = n.a;
                if (3 === A.$) {
                    var k = A.a, E = (S = r.fW).$ ? A4(PSn, r.g0, Vx(r.ld), r.dV, A2(zYn, r, k)) : v(S.a, g), q = E.b;
                    return b(m(r, {
                        fW: It(E.a),
                        f2: A
                    }), Uu(A2(Fu, Wp(JXn), q)), g);
                }
                return b(r, Qp, A2(Ik, 0, A));
            case 5:
                var F = n.a;
                if (3 === F.$) {
                    var j = F.a, D = (z = A2(uYn, r, j)).$ ? A2(__, pa, ui) : A2(iYn, r, z.a);
                    return b(m(r, {
                        lU: j
                    }), D, g);
                }
                return b(m(r, {
                    lU: g
                }), Qp, A2(Ik, 0, F));
            case 6:
            case 7:
                return b(r, function(n) {
                    return A2(jc, xYn(n), Ck(n));
                }(r.fO), g);
            default:
                var V = n.a, B = n.b;
                if (B.$) return b(r, Qp, g);
                var G = B.a;
                return i(V, r.fO) ? b(m(r, {
                    iH: A2(Ie, 0, 24 - (G.al.bj - G.eo.bj))
                }), Qp, g) : b(r, Qp, g);
        }
        var z, S;
    }), LYn = F2(function(n, r) {
        return A3(iRn, {
            a2: n.a2,
            bb: n.bb
        }, Gx("label"), r);
    }), NYn = F2(function(n, r) {
        if (nE(r)) return vE;
        if (n.$) return vE;
        var t = n.a;
        return A2(zx, w([
            Gx("provider-selection-stepper")
        ]), A2(Fu, function(n) {
            return A2(LYn, {
                a2: t,
                bb: ve(r)
            }, n);
        }, r));
    }), HYn = function(n) {
        return A2(NYn, It(n.kY.lh), A2(Fu, function(n) {
            return A3(uRn, n.sT, n.lh, !1);
        }, function(n) {
            return A2(Fu, qYn(n), kYn(n));
        }(n.lU)));
    }, IYn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, OYn = {
        $: 1
    }, QYn = F3(function(n, r, t) {
        return w([
            A2(f_, w([
                uF(xD),
                uE(Jq)
            ]), w([
                t
            ])),
            A2(yF, w([
                fF,
                iK,
                Qj(n),
                Lj(!r),
                cF(IYn(OYn))
            ]), w([
                _d("Save")
            ]))
        ]);
    }), RYn = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("hidden md:block sidebar-wrap"),
            A2(VF, "margin-top", jF(n.iH) + "px"),
            DF("sidebar-element")
        ]), A3(QYn, n.fQ, r, t));
    }), UYn = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("md:hidden sidebar-mobile")
        ]), w([
            A2(zx, w([
                Gx("sidebar-wrap")
            ]), A3(QYn, n.fQ, r, t))
        ]));
    }), KYn = F2(function(n, r) {
        return {
            g8: function() {
                var t = r.fW;
                if (t.$) return w([
                    vE
                ]);
                var e = t.a;
                if (yOn(e)) {
                    var u = function(n) {
                        return !n.mj.$;
                    }(e), a = function() {
                        var n = r.vn;
                        if (n.$) return vE;
                        var t = n.a;
                        return A2(zx, g, w([
                            _d("Are you done selecting provider & location for "),
                            ZV(Whn(t)),
                            _d("?")
                        ]));
                    }(), i = function(n) {
                        return A2(bb, kTn, A2(Op, _Tn(n.hz), A2(bb, xyn, n.vn)));
                    }(r);
                    return w([
                        A2(BE, w([
                            xN(JI)
                        ]), w([
                            A2(lE, w([
                                TE(12),
                                tO(8)
                            ]), w([
                                A2(zx, w([
                                    DF("content-container"),
                                    Gx("panel")
                                ]), w([
                                    function() {
                                        var n = r.jL;
                                        if (n.$) return vE;
                                        var t = n.a;
                                        return A2(zx, w([
                                            Gx("mb-6")
                                        ]), w([
                                            HYn(t)
                                        ]));
                                    }(),
                                    A2(c_, JXn, A3(JQn, n, w([
                                        hOn(i)
                                    ]), e))
                                ]))
                            ])),
                            A2(lE, w([
                                tO(4),
                                VN(w([
                                    Gx("hidden md:block")
                                ]))
                            ]), w([
                                A3(RYn, r, u, a)
                            ]))
                        ])),
                        A3(UYn, r, u, a)
                    ]);
                }
                return w([
                    A2(zx, g, Nx)
                ]);
            }(),
            yx: "Select Provider & Location"
        };
    }), WYn = C_({
        Cl: RXn,
        CQ: UXn,
        Fj: KXn,
        F4: function() {
            return vx(w([
                YXn(XXn),
                Y8(WXn)
            ]));
        },
        Gv: MYn,
        GB: KYn
    }), XYn = F3(function(n, r, t) {
        return v({
            ld: r.ld,
            dV: n,
            yZ: t.EX
        }, Qp);
    }), YYn = F2(function(n, r) {
        return v(r, Qp);
    }), JYn = F2(function(n, r) {
        return r;
    }), nJn = F2(function(n, r) {
        return b(r, Qp, g);
    }), rJn = function(n) {
        return n.ml.p8;
    }, tJn = function(n) {
        return n.ml.yx;
    }, eJn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel")
                ]), w([
                    A2(Kk, w([
                        Qx,
                        uF(xD)
                    ]), w([
                        _d("Session expired")
                    ])),
                    A2(Rcn, g, g),
                    A2(Mx, g, w([
                        _d("The link you used expired after 30 days and is no longer valid. ")
                    ])),
                    A2(Mx, g, w([
                        _d("For continued access to this data, please sign in to our ")
                    ])),
                    A2(Mx, w([
                        Gx("text-support")
                    ]), w([
                        A2(UD, w([
                            Gx("link"),
                            oV(x_(mi))
                        ]), w([
                            _d("patient portal")
                        ]))
                    ])),
                    A2(Mx, g, w([
                        A4(mG, ax(r.dV), bV(r.dV), It(". If you have any questions or concerns"), Ot)
                    ]))
                ]))
            ]),
            yx: n(tJn)
        };
    }), uJn = d_({
        Cl: XYn,
        CQ: YYn,
        Fj: JYn,
        F4: function() {
            return bx;
        },
        Gv: nJn,
        GB: eJn
    }), aJn = F2(function(n, r) {
        return {
            wA: r,
            Fh: n
        };
    }), iJn = function(n) {
        return {
            Cl: F2(function(r, t) {
                var e = n.Cl(t);
                return b(e, A2(__, e.wA, e.Fh), g);
            }),
            CQ: wm(A2(tu, cu, YRn)),
            Fj: wm(cu),
            F4: function() {
                return bx;
            },
            Gv: F2(function(n, r) {
                return b(r, Qp, g);
            }),
            GB: function() {
                return {
                    g8: Nx,
                    yx: "Loading..."
                };
            }
        };
    }, cJn = iJn({
        Cl: function(n) {
            var r = Ya({
                sl: n.Ep.yI
            });
            return A2(aJn, r, pa);
        }
    }), oJn = function(n) {
        return n.b.r_;
    }, fJn = F3(function(n, r, t) {
        var e = function(n) {
            return function(n) {
                return oJn(n);
            }(n) && Jk(n);
        }(n);
        return v({
            ld: r.ld,
            vn: r.vn,
            vu: r.vu,
            dV: n,
            mn: e,
            yZ: t.EX
        }, e ? Qp : function(n) {
            return A2(__, pa, n.bY ? Ba : za);
        }(r));
    }), sJn = F2(function(n, r) {
        return v(m(r, {
            vn: n.vn,
            vu: n.vu
        }), Qp);
    }), lJn = F2(function(n, r) {
        return m(r, {
            zK: Ot
        });
    }), dJn = F2(function(n, r) {
        return b(r, Qp, g);
    }), vJn = function(n) {
        return n.kZ.z3;
    }, bJn = function(n) {
        return n.kZ.zn;
    }, mJn = F2(function(n, r) {
        return A2(zx, w([
            Gx("dashboard__hero")
        ]), w([
            A2(Kk, w([
                qG,
                NE
            ]), w([
                _d(n(bJn))
            ])),
            A2(Kk, w([
                Qx
            ]), w([
                _d(r)
            ]))
        ]));
    }), pJn = GE(4), $Jn = F3(function(n, r, t) {
        return A2(UD, w([
            Gx("dashboard__widget"),
            oV(n)
        ]), w([
            A2(zx, w([
                Gx("dashboard__widget-icon")
            ]), w([
                A2(Tq, w([
                    pJn
                ]), r)
            ])),
            A2(Kk, w([
                sE,
                qG
            ]), w([
                _d(t)
            ]))
        ]));
    }), gJn = function(n) {
        return A2(zx, w([
            Gx("dashboard__grid")
        ]), w([
            A3($Jn, x_(Qa), 33, n(Cv)),
            A3($Jn, x_(ga), 34, n(vJn)),
            A3($Jn, x_(Ba), 35, n(Vd)),
            A3($Jn, x_(za), 36, n(tv))
        ]));
    }, hJn = F2(function(n, r) {
        var t = function() {
            var n = r.vu;
            return 3 === n.$ ? c_n(n.a) : "";
        }();
        return w([
            A2(zx, w([
                Gx("dashboard")
            ]), w([
                A2(mJn, n, t),
                gJn(n)
            ]))
        ]);
    }), yJn = F2(function(n, r) {
        return r.mn ? {
            g8: A2(hJn, n, r),
            yx: ax(r.dV)
        } : {
            g8: Nx,
            yx: ax(r.dV)
        };
    }), wJn = C_({
        Cl: fJn,
        CQ: sJn,
        Fj: lJn,
        F4: function() {
            return bx;
        },
        Gv: dJn,
        GB: yJn
    }), xJn = F3(function(n, r, t) {
        var e = ux(n), u = {
            g2: kc,
            z1: t.Ep.z1,
            kT: r.AF.EU,
            ld: r.ld,
            dV: n,
            yZ: t
        };
        return v(u, A4(JV, u.kT, e, u.z1, cu));
    }), _Jn = F2(function(n, r) {
        return v(r, Qp);
    }), CJn = F2(function(n, r) {
        return r;
    }), AJn = F2(function(n, r) {
        var t = n;
        return 3 === t.$ ? b(m(r, {
            g2: t
        }), Qp, g) : b(m(r, {
            g2: kc
        }), Qp, A2(Ik, 0, t));
    }), kJn = function(n) {
        return n.nu;
    }, EJn = F3(function(n, r, t) {
        return A2(xc, vE, A2(Op, function(r) {
            return A6($V, n, ED(r), FD(r), jD(r), qD(r), t);
        }, A2(bb, kJn, JF(r))));
    }), qJn = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("panel w-full")
                ]), w([
                    A2(zx, w([
                        Gx("text-center mb-6")
                    ]), w([
                        A2(CF, g, w([
                            _d(n(SD))
                        ]))
                    ])),
                    A3(EJn, n, r.g2, r.dV)
                ]))
            ]),
            yx: n(SD)
        };
    }), FJn = d_({
        Cl: xJn,
        CQ: _Jn,
        Fj: CJn,
        F4: function() {
            return bx;
        },
        Gv: AJn,
        GB: qJn
    }), jJn = iJn({
        Cl: function(n) {
            var r = Sa({
                sl: n.Ep.yI
            });
            return A2(aJn, r, n.jb);
        }
    }), DJn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, VJn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, BJn = function(n) {
        return A2(bk, w([
            "appointment-types"
        ]), function(n) {
            return A2(bk, w([
                "booking"
            ]), XV(n));
        }(n));
    }, GJn = F3(function(n, r, t) {
        return A2(bk, w([
            r,
            "location",
            t
        ]), BJn(n));
    }), zJn = F3(function(n, r, t) {
        return A3(GJn, n, r, t);
    }), SJn = F5(function(n, r, t, e, u) {
        return A4(aA, n, Hz, u, pk(A3(zJn, r, t, e)));
    }), TJn = F4(function(n, r, t, e) {
        return A5(SJn, n, r, t, e, VJn);
    }), PJn = F3(function(n, r, t) {
        var e = ux(n), u = rS.b, a = {
            cA: kc,
            nv: t.Ep.nv,
            cB: kc,
            cD: Ot,
            n3: t.Ep.n3,
            kT: r.AF.EU,
            ld: r.ld,
            dV: n,
            ah: rS.a,
            yZ: t
        }, i = DB(n) ? A4(TJn, a.kT, e, a.nv, a.n3) : XB;
        return v(a, Uu(w([
            i,
            A2(Wp, DJn, u)
        ])));
    }), ZJn = F2(function(n, r) {
        return v(r, Qp);
    }), MJn = F2(function(n, r) {
        return r;
    }), LJn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, NJn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, HJn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), IJn = F3(function(n, r, t) {
        return A2(bk, w([
            "availability"
        ]), A3(GJn, n, r, t));
    }), OJn = F6(function(n, r, t, e, u, a) {
        return A4(aA, n, jS, a, A2($k, VS(r), pk(A3(IJn, t, e, u))));
    }), QJn = F6(function(n, r, t, e, u, a) {
        return A6(OJn, n, function(n) {
            return m(n, {
                x0: It(u)
            });
        }, r, t, e, HJn(a));
    }), RJn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? b(m(r, {
                    cB: t,
                    ah: A2(iP, i = t.a, r.ah)
                }), XS(A2($S, 4, gS)), g) : b(m(r, {
                    cB: kc
                }), Qp, A2(Ik, 0, t));
            case 1:
                var e = n.a, u = n.b, a = v(r.cB, u);
                if (3 === a.a.$ && 3 === a.b.$) {
                    var i = a.a.a, c = a.b.a, o = pT(c), f = YS(i), s = m(r, {
                        cA: u
                    });
                    return f && nE(o) ? b(s, A2(__, pa, fi), g) : b(m(s, {
                        ah: $ = A6(_T, e, r.cD, i, c, Ot, r.ah)
                    }), Qp, g);
                }
                return b(m(r, {
                    cA: kc
                }), Qp, A2(Ik, 0, u));
            case 2:
                if ((_ = n.a).$) return b(m(r, {
                    cD: Ot
                }), Qp, g);
                if (1 === (C = _.a).$ && 4 === C.a) {
                    var l = A2(bb, KT, C.b), d = A2(IS, l, r.ah);
                    if (d.$) return b(r, Qp, g);
                    var p = d.a, $ = p.a, h = p.b, y = ux(r.dV), x = A6(QJn, r.kT, y, r.nv, r.n3, h, !0);
                    return b(m(r, {
                        cD: l,
                        ah: $
                    }), x, g);
                }
                return b(r, Qp, g);
            case 3:
                var _, C;
                return (_ = n.a).$ ? b(r, Qp, g) : 2 === (C = _.a).$ && 4 === C.a ? b(m(r, {
                    cD: Ot
                }), Qp, g) : b(r, Qp, g);
            default:
                var A = A2(aP, n.a, r.ah), k = A.b, E = A.c, q = m(r, {
                    ah: $ = A.a
                }), F = A2(Wp, DJn, k);
                if (E.$) return b(q, F, g);
                var j = E.a;
                if (j.$) {
                    var D = j.a, V = v(q.cB, JS(r.ah));
                    if (3 !== V.a.$ || V.b.$) return b(q, F, g);
                    i = V.a.a;
                    var B = V.b.a, G = nT(r.ah);
                    if ((f = YS(i)) && OS(G)) return b(q, F, g);
                    var z = A3(aT, D, B, A3(BT, f, G, A3(qT, gT(D), B, A2(xc, hS, q.cD)))), S = q.yZ.jb;
                    return b(q, Uu(w([
                        QT(z),
                        A2(__, S, oi({
                            nv: r.nv,
                            n3: r.n3
                        }))
                    ])), g);
                }
                var T = PS(j.a);
                return y = ux(r.dV), b(m(q, {
                    cA: A_
                }), Uu(w([
                    F,
                    A6(QJn, r.kT, y, r.nv, r.n3, NS(T), !1)
                ])), g);
        }
    }), UJn = function(n) {
        return 3 === n.cA.$ ? A2(c_, DJn, A2(ZP, n.dV, n.ah)) : A2(zx, g, Nx);
    }, KJn = function(n) {
        var r, t = n.cB;
        if (3 === t.$) {
            var e = t.a, u = 3 === (r = n.cA).$ ? pT(r.a) : g, a = YS(e) && 1 === ve(u) ? A2(Op, AE, nT(n.ah)) : Ot, i = MS(e);
            return A2(zx, w([
                Gx("flex flex-col gap-4")
            ]), w([
                A2(zz, !1, {
                    ex: Ot,
                    z2: It(e),
                    n2: It(i),
                    vn: Ot,
                    l4: a
                }),
                UJn(n)
            ]));
        }
        return A2(zx, g, Nx);
    }, WJn = function(n) {
        var r;
        return r = function(n) {
            return n ? "Book an appointment" : "Request an appointment";
        }(n), A2(CF, w([
            uF(yE),
            zX
        ]), w([
            _d(r)
        ]));
    }, XJn = F2(function(n, r) {
        var t;
        return {
            g8: w([
                A2(zx, w([
                    Gx("flex flex-col gap-4")
                ]), w([
                    (t = r.cB, 3 === t.$ ? WJn(hN(t.a)) : vE),
                    KJn(r)
                ]))
            ]),
            yx: "Booking"
        };
    }), YJn = d_({
        Cl: PJn,
        CQ: ZJn,
        Fj: MJn,
        F4: function() {
            return vx(w([
                bS(LJn),
                pS(NJn)
            ]));
        },
        Gv: RJn,
        GB: XJn
    }), JJn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, n0n = F3(function(n, r, t) {
        var e = ux(n), u = ux(n), a = A2(Ep, r.f9, r.bp), i = !OP(r.g0), c = {
            nv: t.Ep.nv,
            cB: kc,
            cD: Ot,
            n3: t.Ep.n3,
            kT: r.AF.EU,
            hx: r.g0,
            ld: r.ld,
            aX: A6(yZ, r.g0, u, a, !1, i, !1),
            dV: n,
            mv: kc,
            yZ: t
        };
        return v(c, DB(n) ? A5(SJn, c.kT, e, c.nv, c.n3, JJn) : XB);
    }), r0n = F2(function(n, r) {
        return v(r, Qp);
    }), t0n = F2(function(n, r) {
        return r;
    }), e0n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, u0n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, a0n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, i0n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, c0n = F2(function(n, r) {
        if (n) {
            var t = cT(r), e = cT(r);
            return OS(e) || OS(t);
        }
        return !1;
    }), o0n = F2(function(n, r) {
        if (r.$) return !0;
        var t = r.a;
        return A2(c0n, n, t) || function(n) {
            var r = iT(n), t = bM(n), e = ZS(n);
            return OS(e) || OS(t) || OS(r);
        }(t);
    }), f0n = F2(function(n, r) {
        return rx($(A2(xM, n, r), w([
            v("first_name", A2(wM, tx, jM(r))),
            v("last_name", A2(wM, tx, DM(r))),
            v("dob", A2(wM, tx, EM(r))),
            v("email", A2(wM, tx, qM(r))),
            v("phone", A2(wM, tx, VM(r)))
        ])));
    }), s0n = F2(function(n, r) {
        return A2(bk, w([
            r
        ]), BJn(n));
    }), l0n = F6(function(n, r, t, e, u, a) {
        return A4(lM, n, hM, a, A2(dM, A2(f0n, e, u), pk(A2(s0n, r, t))));
    }), d0n = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? b(m(r, {
                    cB: t
                }), XS(A2($S, 4, gS)), g) : b(m(r, {
                    cB: kc
                }), Qp, A2(Ik, 0, t));
            case 1:
                var e = n.a;
                if (e.$) return b(m(r, {
                    cD: Ot
                }), Qp, g);
                var u = e.a;
                if (1 === u.$ && 4 === u.a) {
                    var a = u.b, i = r.cB;
                    if (3 === i.$) {
                        var c = YS(E = i.a), o = A2(bb, KT, a), f = A2(LM, o, A7(HM, r.hx, ux(r.dV), r.aX.hz, r.aX.aR, r.aX.id, r.aX.h1, E)), s = function() {
                            if (A2(o0n, c, o)) {
                                var n = uG(MS(E)), t = AM(E);
                                return A2(__, r.yZ.jb, ci({
                                    nv: t,
                                    n3: n
                                }));
                            }
                            return Qp;
                        }();
                        return b(m(r, {
                            cD: o,
                            aX: f
                        }), s, g);
                    }
                    return b(r, Qp, g);
                }
                return b(r, Qp, g);
            case 3:
                var l = A2(lN, n.a, r.aX), d = l.b, p = l.c, $ = m(r, {
                    aX: f = l.a
                }), h = A2(Wp, u0n, d);
                if (p.$) return b($, h, g);
                var y = p.a, x = y.a, _ = y.b, C = It(A2(pN, x.ft, A2($N, x.vO, A2(vN, x.qN, A2(dN, A2(Op, NS, x.qj), A2(mN, x.sV, A2(bN, x.rA, A2(xc, hS, r.cD)))))))), A = v(C, r.cB);
                if (A.a.$ || 3 !== A.b.$) return b($, h, g);
                var k = A.a.a, E = A.b.a, q = ux(r.dV), F = function() {
                    if (_) {
                        var n = rx(w([
                            v("signature", tx("")),
                            v("acceptance_type", tx("checkbox")),
                            v("accepted", Yw(!0))
                        ]));
                        return A5(vM, r.hx, q, "ephi_waiver", n, a0n);
                    }
                    return Qp;
                }(), j = uG(MS(E)), D = AM(E), V = A6(l0n, r.kT, q, D, j, k, i0n);
                return b(m(r, {
                    cD: C,
                    mv: A_
                }), Uu(w([
                    h,
                    QT(k),
                    V,
                    F
                ])), g);
            case 2:
                var B = n.a;
                switch($ = m(r, {
                    mv: B
                }), B.$){
                    case 3:
                        return b($, XS(A2(jZ, 4, gS)), g);
                    case 2:
                        var G = B.a;
                        return b($, Qp, 5 === G.$ && 400 === G.a ? g : w([
                            A2(Mk, 1, Tk)
                        ]));
                    default:
                        return b($, Qp, g);
                }
            default:
                return b(r, Qp, g);
        }
    }), v0n = F3(function(n, r, t) {
        return 2 === n.$ && 5 === n.a.$ && 400 === n.a.a ? A3(rH, t, r.EX, r.jb) : vE;
    }), b0n = F2(function(n, r) {
        var t = r.cB;
        if (3 === t.$) {
            var e = t.a, u = A2(bb, ON, r.cD), a = A2(bb, bM, r.cD), i = Ij(r.mv), c = MS(e);
            return A2(zx, w([
                Gx("flex flex-col gap-4")
            ]), w([
                A2(zz, i, {
                    ex: a,
                    z2: It(e),
                    n2: It(c),
                    vn: Ot,
                    l4: u
                }),
                A2(c_, u0n, A5(zO, e, r.dV, i, n, r.aX))
            ]));
        }
        return A2(zx, g, Nx);
    }), m0n = F2(function(n, r) {
        return {
            g8: w([
                function() {
                    var t, e, u = r.mv;
                    if (3 === u.$) {
                        var a = u.a, i = v(r.cB, r.cD);
                        if (3 !== i.a.$ || i.b.$) return vE;
                        var c = i.a.a, o = i.b.a;
                        return A2(zx, w([
                            Gx("mt-12")
                        ]), w([
                            A5(XN, c, o, a, Ot, r.yZ.jb)
                        ]));
                    }
                    return A2(zx, w([
                        Gx("flex flex-col gap-4")
                    ]), 3 === (e = r.cB).$ ? w([
                        A3(v0n, r.mv, r.yZ, e.a),
                        (t = r.cB, 3 === t.$ ? WJn(hN(t.a)) : vE),
                        A2(b0n, n, r)
                    ]) : Nx);
                }()
            ]),
            yx: "Booking"
        };
    }), p0n = d_({
        Cl: n0n,
        CQ: r0n,
        Fj: t0n,
        F4: function() {
            return vx(w([
                bS(e0n),
                A2(kj, u0n, EZ())
            ]));
        },
        Gv: d0n,
        GB: m0n
    }), $0n = F3(function(n, r, t) {
        var e = DB(n) ? Qp : XB;
        return v({
            ld: r.ld,
            dV: n,
            yZ: t
        }, e);
    }), g0n = F2(function(n, r) {
        return v(r, Qp);
    }), h0n = F2(function(n, r) {
        return r;
    }), y0n = F2(function(n, r) {
        return b(r, Qp, g);
    }), w0n = function(n) {
        return A4(mG, ax(n), bV(n), It("For new patients"), It("for information on how to sign up."));
    }, x0n = F2(function(n, r) {
        var t = r.dV;
        return {
            g8: w([
                A2(zx, g, w([
                    A2(CF, w([
                        uF(yE),
                        zX
                    ]), w([
                        _d("Book an appointment")
                    ])),
                    A2(Kk, w([
                        uF(yE),
                        uE(jvn)
                    ]), w([
                        w0n(t)
                    ]))
                ]))
            ]),
            yx: "Booking"
        };
    }), _0n = d_({
        Cl: $0n,
        CQ: g0n,
        Fj: h0n,
        F4: function() {
            return bx;
        },
        Gv: y0n,
        GB: x0n
    }), C0n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, A0n = F3(function(n, r, t) {
        return A4(aA, n, SB, t, pk(function(n) {
            return BJn(n);
        }(r)));
    }), k0n = F2(function(n, r) {
        return A3(A0n, n.kT, r, C0n);
    }), E0n = F3(function(n, r, t) {
        var e = {
            g9: kc,
            kT: r.AF.EU,
            ld: r.ld,
            lq: WB,
            dV: n,
            yZ: t
        };
        return v(e, DB(n) ? A2(k0n, e, ux(n)) : XB);
    }), q0n = F2(function(n, r) {
        return v(r, Qp);
    }), F0n = F2(function(n, r) {
        return r;
    }), j0n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, D0n = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = A2(eG, EB(r.yZ.jb), tG(e)), a = nE(u) ? A2(__, pa, fi) : Qp;
                    return b(m(r, {
                        g9: t
                    }), a, g);
                }
                return b(m(r, {
                    g9: kc
                }), Qp, A2(Ik, 0, t));
            case 1:
                var i = n.a, c = i.a, o = i.b, f = r.yZ.jb;
                return DG(c) ? b(r, A2(__, f, Ca({
                    nv: jj(c),
                    n3: uG(o)
                })), g) : b(r, A2(__, f, ci({
                    nv: jj(c),
                    n3: uG(o)
                })), g);
            default:
                var s = A2(vG, n.a, r.lq), l = s.b;
                return b(m(r, {
                    lq: s.a
                }), A2(Wp, j0n, l), g);
        }
    }), V0n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, B0n = F4(function(n, r, t, e) {
        var u, a = r.EX, i = A2(eG, EB(r.jb), tG(e)), c = A2(hG, gG, i), o = c.a, f = c.b;
        return A2(Qt, A2(c_, j0n, A3(Fz, n, i, t)), A2(Qt, A2(c_, V0n, A2(zG, t, f)), nE(o) ? g : w([
            A2(zx, w([
                Gx("flex flex-col gap-2")
            ]), w([
                (u = a, JN(_c(u)) ? A2(f_, w([
                    sE
                ]), w([
                    _d("Continue as guest")
                ])) : vE),
                A2(c_, V0n, A2(zG, t, o))
            ]))
        ])));
    }), G0n = F2(function(n, r) {
        var t = r.g9;
        if (3 === t.$) {
            var e = t.a;
            return A2(zx, w([
                Gx("flex flex-col gap-4")
            ]), $(A4(B0n, n, r.yZ, r.lq, e), w([
                pG(r.dV)
            ])));
        }
        return A2(zx, g, Nx);
    }), z0n = F2(function(n, r) {
        if (3 === r.$) {
            var t = r.a, e = EB(n.jb);
            if (e.$) return WJn(!0);
            var u = e.a, a = A2(SS, function(n) {
                return i(jj(n), u);
            }, tG(t));
            return WJn(!!a.$ || function(n) {
                return n.nk;
            }(a.a));
        }
        return WJn(!0);
    }), S0n = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("flex flex-col gap-4")
                ]), w([
                    A2(z0n, r.yZ, r.g9),
                    A2(G0n, n, r)
                ]))
            ]),
            yx: "Booking"
        };
    }), T0n = d_({
        Cl: E0n,
        CQ: q0n,
        Fj: F0n,
        F4: function() {
            return bx;
        },
        Gv: D0n,
        GB: S0n
    }), P0n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Z0n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, M0n = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), L0n = {
        $: 2
    }, N0n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, H0n = function(n) {
        return n.mN;
    }, I0n = Xn("fullStoryPortIdentifySignup", tx), O0n = function(n) {
        return function(n) {
            return I0n(n);
        }(n);
    }, Q0n = function(n) {
        return n.jw.AO;
    }, R0n = function(n) {
        return n.jw.Eh;
    }, U0n = function(n) {
        return n.jw.yx;
    }, K0n = F3(function(n, r, t) {
        if (r.$) return vE;
        var e = r.a, u = A2(EV, w([
            xV,
            yV("mailto:" + e)
        ]), w([
            _d(e)
        ]));
        return t.$ ? u : A2(PE, g, w([
            _d(" " + n + " "),
            u
        ]));
    }), W0n = function(n) {
        if (n.$) return vE;
        var r = n.a;
        return A2(EV, w([
            xV,
            yV("tel:" + r)
        ]), w([
            _d(aV(r))
        ]));
    }, X0n = F2(function(n, r) {
        return A2(zx, w([
            Gx("panel w-full")
        ]), w([
            A2(i_, g, w([
                _d(n(U0n))
            ])),
            s_,
            A2(f_, g, w([
                _d(n(Q0n) + " "),
                W0n(bV(r)),
                A3(K0n, n(R0n), Xw(r), bV(r))
            ]))
        ]));
    }), Y0n = function(n) {
        return A2(zx, w([
            Gx("panel w-full")
        ]), w([
            A2(i_, g, w([
                _d("We can't find the signup page you were looking for")
            ])),
            s_,
            A2(f_, g, w([
                _d("Please contact us and let us know the plan you would like to sign up for at "),
                W0n(bV(n)),
                A3(K0n, "or", Xw(n), bV(n))
            ]))
        ]));
    }, J0n = function(n) {
        return {
            Cl: F2(function(r, t) {
                var e = b(r.dV, r.f2, r.fu);
                n: for(;;)switch(e.a.$){
                    case 2:
                        return b(L0n, Qp, g);
                    case 3:
                        switch(e.b.$){
                            case 3:
                                if (!e.c.$) {
                                    var u = e.a.a;
                                    return H0n(a = e.b.a) ? b(Z0n(t), Qp, g) : b(A2(M0n, u, r.ld), Qp, g);
                                }
                                var a;
                                if (u = e.a.a, !H0n(a = e.b.a)) return b(A2(M0n, u, r.ld), Qp, g);
                                if (r.c1) return b(A2(M0n, u, r.ld), Qp, g);
                                switch(r.FN.$){
                                    case 3:
                                        return A2(dx, P0n, A2(Ww, g, A4(n.Cl, u, a, r, t)));
                                    case 2:
                                        return b(N0n(u), Qp, g);
                                    default:
                                        return b(Z0n(t), Qp, g);
                                }
                            case 2:
                                return b(N0n(u = e.a.a), Qp, g);
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                return b(Z0n(t), Qp, g);
            }),
            CQ: F2(function(r, t) {
                var e = b(r.dV, r.f2, t);
                n: for(; !e.c.$;)switch(e.a.$){
                    case 2:
                        return v(L0n, Qp);
                    case 3:
                        switch(e.b.$){
                            case 3:
                                var u = e.b.a, a = e.c.a, c = A4(n.Cl, d = e.a.a, u, r, a), o = c.a, f = c.b;
                                if (H0n(u)) {
                                    if (r.c1) return v(A2(M0n, d, r.ld), Qp);
                                    var s = v(r.fu, r.FN);
                                    r: for(;;)switch(s.b.$){
                                        case 3:
                                            switch(s.a.$){
                                                case 2:
                                                    var l = s.a.a;
                                                    return v(P0n(o), Uu(w([
                                                        f,
                                                        O0n(l)
                                                    ])));
                                                case 1:
                                                    return v(P0n(o), Uu(w([
                                                        f,
                                                        sx(d)
                                                    ])));
                                                default:
                                                    break r;
                                            }
                                        case 2:
                                            return v(N0n(d), Qp);
                                        default:
                                            break r;
                                    }
                                    return v(Z0n(a), Qp);
                                }
                                return v(A2(M0n, d, r.ld), Qp);
                            case 2:
                                return v(N0n(d = e.a.a), Qp);
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                if (r.c1) {
                    var d, p = r.dV;
                    return v(3 === p.$ ? A2(M0n, d = p.a, r.ld) : t, Qp);
                }
                if (1 === t.$) {
                    var $ = t.a;
                    return A2(lx, P0n, A2(n.CQ, r, m($, {
                        ld: i(r.ld, $.ld) ? $.ld : r.ld
                    })));
                }
                return v(t, Qp);
            }),
            Fj: F2(function(r, t) {
                return 1 === r.$ ? A2(n.Fj, r.a, t) : t;
            }),
            F4: function(r) {
                return 1 === r.$ ? n.F4(r.a) : bx;
            },
            Gv: F2(function(r, t) {
                return 1 === t.$ ? A2(dx, P0n, A2(n.Gv, r, t.a)) : b(t, Qp, g);
            }),
            GB: function(r) {
                switch(r.$){
                    case 1:
                        var t = r.a;
                        return A2(n.GB, Vx(t.ld), t);
                    case 2:
                        return {
                            g8: w([
                                l_
                            ]),
                            yx: "404"
                        };
                    case 3:
                        return {
                            g8: w([
                                Y0n(e = r.a)
                            ]),
                            yx: "404"
                        };
                    case 4:
                        var e = r.a;
                        return {
                            g8: w([
                                A2(X0n, Vx(r.b), e)
                            ]),
                            yx: "404"
                        };
                    default:
                        return {
                            g8: Nx,
                            yx: "Loading..."
                        };
                }
            }
        };
    }, n1n = F4(function(n, r, t, e) {
        return {
            ld: e,
            dV: n,
            mp: r,
            yZ: t
        };
    }), r1n = function(n) {
        return n.mR;
    }, t1n = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), e1n = function(n) {
        return A2(ge, F2(function(n, r) {
            return A2(t1n, r, n);
        }), n);
    }, u1n = function(n) {
        return e1n(A2(no, function(n) {
            return r1n(n);
        }, n));
    }, a1n = function(n) {
        return n.xQ;
    }, i1n = F2(function(n, r) {
        var t = n, e = a1n(r);
        switch(t.ur){
            case 0:
                return wi({
                    xQ: e
                });
            case 1:
                return hi({
                    xQ: e
                });
            case 2:
                return Ci({
                    xQ: e
                });
            case 3:
                return Ai({
                    xQ: e
                });
            case 4:
                return xi({
                    xQ: e
                });
            case 5:
                return _i({
                    xQ: e
                });
            case 6:
                return ki({
                    xQ: e
                });
            default:
                return yi({
                    xQ: e
                });
        }
    }), c1n = F3(function(n, r, t) {
        var e = mb(u1n(r));
        return e.$ ? XB : A2(__, t, A2(i1n, e.a.a, n));
    }), o1n = F4(function(n, r, t, e) {
        var u = function() {
            var n = t.FN;
            return 3 === n.$ ? n.a : g;
        }(), a = GYn(r);
        return v(A4(n1n, n, a, e, t.ld), A3(c1n, a, u, e.jb));
    }), f1n = F2(function(n, r) {
        return v(r, Qp);
    }), s1n = F2(function(n, r) {
        return r;
    }), l1n = F2(function(n, r) {
        return b(r, Qp, g);
    }), d1n = F2(function(n, r) {
        var t = r.dV;
        return {
            g8: w([
                vE
            ]),
            yx: ax(t)
        };
    }), v1n = J0n({
        Cl: o1n,
        CQ: f1n,
        Fj: s1n,
        F4: function() {
            return bx;
        },
        Gv: l1n,
        GB: d1n
    }), b1n = F3(function(n, r, t) {
        return v({
            ld: r.ld,
            dV: n,
            f2: A_,
            yZ: t
        }, A2(__, t.jb, Fi));
    }), m1n = F2(function(n, r) {
        return v(r, Qp);
    }), p1n = F2(function(n, r) {
        return r;
    }), $1n = F2(function(n, r) {
        return b(r, Qp, g);
    }), g1n = function(n) {
        return n.AA.yx;
    }, h1n = F2(function(n) {
        return {
            g8: w([
                vE
            ]),
            yx: n(g1n)
        };
    }), y1n = d_({
        Cl: b1n,
        CQ: m1n,
        Fj: p1n,
        F4: function() {
            return bx;
        },
        Gv: $1n,
        GB: h1n
    }), w1n = F3(function(n, r, t) {
        var e = A2(ra, "company", t.jb), u = function() {
            if (e.$) return v(A2(__, t.jb, Fi), t);
            var n = e.a, r = A2(va, "company", t.jb);
            return v(A2(__, r, qi({
                xQ: sJ(n)
            })), m(t, {
                jb: r
            }));
        }();
        return v({
            ld: r.ld,
            dV: n,
            f2: A_,
            yZ: u.b
        }, u.a);
    }), x1n = F2(function(n, r) {
        return v(r, Qp);
    }), _1n = F2(function(n, r) {
        return r;
    }), C1n = F2(function(n, r) {
        return b(r, Qp, g);
    }), A1n = F2(function() {
        return {
            g8: w([
                vE
            ]),
            yx: "Enroll"
        };
    }), k1n = d_({
        Cl: w1n,
        CQ: x1n,
        Fj: _1n,
        F4: function() {
            return bx;
        },
        Gv: C1n,
        GB: A1n
    }), E1n = F3(function(n, r, t) {
        return v({
            ld: r.ld,
            dV: n,
            f2: A_,
            yZ: t
        }, A2(__, t.jb, cc));
    }), q1n = F2(function(n, r) {
        return v(r, Qp);
    }), F1n = F2(function(n, r) {
        return r;
    }), j1n = F2(function(n, r) {
        return b(r, Qp, g);
    }), D1n = function(n) {
        return n.dh.qQ;
    }, V1n = function(n) {
        return n.dh.qR;
    }, B1n = function(n) {
        return n.dh.EW;
    }, G1n = function(n) {
        return n.dh.yx;
    }, z1n = F2(function(n) {
        return {
            g8: w([
                vE
            ]),
            yx: n(G1n)
        };
    }), S1n = d_({
        Cl: E1n,
        CQ: q1n,
        Fj: F1n,
        F4: function() {
            return bx;
        },
        Gv: j1n,
        GB: z1n
    }), T1n = function(n) {
        return function(n) {
            return function(n) {
                return n.b.xR;
            }(n);
        }(n);
    }, P1n = F2(function(n, r) {
        return Cz(r) ? 0 : T1n(n) ? 1 : 0;
    }), Z1n = F2(function(n, r) {
        return {
            qN: r,
            Dd: n,
            vO: ""
        };
    }), M1n = Xn("initializeRecaptchaPort", function() {
        return nx;
    }), L1n = function(n) {
        return A2(Jfn, n, g);
    }, N1n = Xn("removeTokenPort", function(n) {
        return rx(w([
            v("key", tx(n.ij))
        ]));
    }), H1n = N1n({
        ij: "accountToken"
    }), I1n = w([
        0,
        1
    ]), O1n = function(n) {
        return n ? "Phone" : "Email";
    }, Q1n = F3(function(n, r, t) {
        var e, u = A2(ra, "patient", t.jb), a = A2(ra, "email", t.jb), i = A2(P1n, n, a), c = Cz(a) ? "automatic" : "manual", o = L1n("Authentication - Email Prompted"), f = (e = v(b_(r.g0) && !r.Ab, Cz(a))).a ? vsn(r.g0) ? v(H1n, !1) : v(A2(__, pa, ui), !1) : v(Qp, !!e.b), s = f.a, l = f.b;
        return v({
            g$: c,
            g0: r.g0,
            e: vZ(A2(Z1n, i, A2(xc, "", a))),
            hO: l,
            ld: r.ld,
            fy: u,
            dV: n,
            wk: l,
            yZ: t,
            A: A2(pZ, I1n, O1n)
        }, Uu(w([
            s,
            o,
            M1n(0)
        ])));
    }), R1n = F2(function(n, r) {
        return v(r, Qp);
    }), U1n = F2(function(n, r) {
        return r;
    }), K1n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, W1n = {
        $: 1
    }, X1n = nr("gotRecaptchaInitializedPort", M$), Y1n = F2(function(n) {
        return n;
    }), J1n = function(n) {
        return X1n(Y1n(n));
    }, n2n = nr("gotRecaptchaTokenPort", A2(nu, function(n) {
        return A2(nu, function(r) {
            return au({
                mc: r,
                yI: n
            });
        }, A2(Iu, "result", M$));
    }, A2(Iu, "token", M$))), r2n = F2(function(n, r) {
        var t = r.yI;
        switch(r.mc){
            case "ok":
                return n(te(t));
            case "recaptcha-not-defined":
                return n(Yt(0));
            default:
                return n(Yt(1));
        }
    }), t2n = function(n) {
        return n2n(r2n(n));
    }, e2n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, u2n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, a2n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, i2n = F2(function(n, r) {
        return {
            $: 24,
            a: n,
            b: r
        };
    }), c2n = {
        $: 0
    }, o2n = function(n) {
        return 1 === n.Dd ? n.vO : n.qN;
    }, f2n = function(n) {
        for(;;){
            var r = ke(n);
            if (r.$) return !0;
            var t = r.a;
            if (" " !== (e = t.a) && "\n" !== e && "\t" !== e && "\r" !== e) return !1;
            n = t.b;
        }
        var e;
    }, s2n = XM(w([
        function(n) {
            return 1 === n.Dd ? function(n) {
                var r = n.vO;
                return f2n(r) || 10 === lu(r) ? g : w([
                    v(1, nL(A2(YM, rL, SMn)))
                ]);
            }(n) : function(n) {
                var r = A3(N_, " ", "", n.qN);
                return f2n(r) || oL(r) ? g : w([
                    v(0, nL(A2(YM, rL, eL)))
                ]);
            }(n);
        }
    ])), l2n = Xn("getRecaptchaTokenPort", tx), d2n = function(n) {
        return l2n(function(n) {
            return n ? "selfserve" : "signup";
        }(n));
    }, v2n = function(n) {
        return 1 === n ? "phone" : "email";
    }, b2n = function(n) {
        return v(v2n(n.Dd), o2n(n));
    }, m2n = F2(function(n, r) {
        return A2(nsn, n, function(n) {
            return n ? "True" : "False";
        }(r));
    }), p2n = F3(function(n, r, t) {
        return A2(Jfn, r, A2(Qt, A2(m2n, "input_valid", n), t));
    }), $2n = F3(function(n, r, t) {
        return A3(p2n, t, function(n) {
            return 1 === n ? "Authentication - SMS Submitted" : "Authentication - Email Submitted";
        }(n), w([
            A2(rsn, "method", r)
        ]));
    }), g2n = function(n) {
        var r = A2(CL, s2n, n.e);
        return r.$ ? v(r.a, !1) : v(r.a.a, !0);
    }, h2n = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A;
        return m(r, {
            e: g2n(r).a,
            A: t
        });
    }), y2n = function(n) {
        switch(n.$){
            case 0:
                return It(0);
            case 1:
                return It(1);
            default:
                return Ot;
        }
    }, w2n = F2(function(n, r) {
        var t = y2n(n);
        if (t.$) return r;
        var e = t.a;
        return A2(EL, e, r.A) ? m(A2(h2n, !1, r), {
            A: A3(qL, !0, e, r.A)
        }) : r;
    }), x2n = A2(Iu, "salt", M$), _2n = F2(function(n, r) {
        return v(v2n(n), tx(r));
    }), C2n = function(n) {
        return n ? "sms" : "email";
    }, A2n = F6(function(n, r, t, e, u, a) {
        var i = rx(w([
            v("auth_channel", tx(C2n(r))),
            A2(_2n, r, t),
            v("practice_id", tx(e)),
            v("google_recaptcha_token", A2(wM, tx, u))
        ]));
        return A4(lM, GQ(n), x2n, a, A2(dM, i, pk(A2(bk, w([
            "auth",
            "request_code"
        ]), fM(e)))));
    }), k2n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    qN: n.a
                });
            case 1:
                return m(r, {
                    vO: n.a
                });
            default:
                return m(r, {
                    Dd: n.a
                });
        }
    }), E2n = F2(function(n, r) {
        var t = y2n(n);
        return t.$ ? r : m(r, {
            A: A3(fN, !0, t.a, r.A)
        });
    }), q2n = F2(function(n, r) {
        return A2(E2n, n, m(r, {
            e: A3(cN, k2n, n, r.e)
        }));
    }), F2n = F2(function(n, r) {
        switch(n.$){
            case 6:
                return b(A2(q2n, n.a, r), Qp, g);
            case 0:
                return b(m(r, {
                    wk: !0
                }), d2n(1), g);
            case 4:
                var t = FM(r.e);
                return b(A2(w2n, e2n(t.qN), r), Qp, g);
            case 5:
                var e = FM(r.e);
                return b(A2(w2n, a2n(e.vO), r), Qp, g);
            case 1:
                var u = r.hO ? A2(Nu, cu, Au(c2n)) : Qp;
                return b(m(r, {
                    hO: !1
                }), u, g);
            case 2:
                var a = L$(n.a), i = FM(r.e), c = (u = A6(A2n, r.g0, i.Dd, o2n(i), ux(r.dV), a, u2n), A2(CL, s2n, r.e));
                return c.$ ? b(m(r, {
                    e: c.a,
                    wk: !1
                }), Qp, g) : b(m(r, {
                    e: c.a.a
                }), u, g);
            default:
                var o = n.a, f = m(r, {
                    wk: !1
                });
                if (3 === o.$) {
                    var s = o.a, l = (C = A2(ra, "redirectTo", r.yZ.jb)).$ ? g : w([
                        v("redirectTo", C.a)
                    ]), d = 1 === (i = FM(r.e)).Dd ? g : w([
                        b2n(i)
                    ]), p = 1 === i.Dd ? w([
                        v("method", C2n(i.Dd))
                    ]) : g, h = 1 === i.Dd ? w([
                        A2(i2n, 1, i.vO)
                    ]) : g, y = $(p, $(d, w([
                        v("salt", s)
                    ]))), x = $(y, (_ = r.fy).$ ? l : $(l, w([
                        v("patient", _.a)
                    ])));
                    return b(f, Uu(w([
                        A2(__, ed(x), $i),
                        A3($2n, i.Dd, r.g$, !0)
                    ])), h);
                }
                return b(f, A3($2n, FM(r.e).Dd, r.g$, !1), A2(Ik, 0, o));
        }
        var _, C;
    }), j2n = function(n) {
        return n.pP;
    }, D2n = function(n) {
        return j2n(n.a);
    }, V2n = function(n) {
        var r = A2(xc, "", D2n(n));
        return A2(uJ, w([
            iJ(r),
            tJ(ax(n)),
            Gx("mx-auto w-3/12 mb-10")
        ]), g);
    }, B2n = function(n) {
        return n.iu.ht;
    }, G2n = function(n) {
        return n.iu.rF;
    }, z2n = F2(function(n, r) {
        return r.td(n);
    }), S2n = F2(function(n, r) {
        return r.te(n);
    }), T2n = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), P2n = function(n) {
        var r = FM(n.e).Dd;
        return A3(T2n, n.e, n.A, 1 === r ? 1 : 0);
    }, Z2n = "https://www.ftc.gov/enforcement/rules/rulemaking-regulatory-reform-proceedings/childrens-online-privacy-protection-rule", M2n = F2(function(n, r) {
        return r.tk(n);
    }), L2n = F2(function(n, r) {
        return r.xD(n);
    }), N2n = function(n) {
        return n.xE;
    }, H2n = function(n) {
        return n.xF;
    }, I2n = function(n) {
        var r = FM(n.e);
        return 1 === r.Dd && 10 !== lu(r.vO);
    }, O2n = {
        $: 4
    }, Q2n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, R2n = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), U2n = function(n) {
        return n.zz;
    }, K2n = F2(function(n, r) {
        var t = A3(T2n, r.e, r.A, 0), e = FM(r.e).qN;
        return A2(EH, w([
            vH(n(U2n)),
            gH(!0)
        ]), w([
            PI(w([
                jI("e.g. name@example.com"),
                HI(A2(qc, Q2n, e2n)),
                yI(t),
                OI(e),
                _I(O2n)
            ])),
            A2(YH, n, A3(R2n, r.e, r.A, 0))
        ]));
    }), W2n = {
        $: 5
    }, X2n = function(n) {
        return function(n) {
            return {
                $: 4,
                a: n
            };
        }(n);
    }, Y2n = function(n) {
        return n.ti;
    }, J2n = F2(function(n, r) {
        var t = A3(T2n, r.e, r.A, 1), e = FM(r.e).vO;
        return A2(EH, w([
            vH(n(Y2n)),
            gH(!0)
        ]), w([
            PI(w([
                jI(yO),
                A4(hO, wO, uV, e, A2(qc, Q2n, a2n)),
                yI(t),
                A2(xI, uV, e),
                _I(W2n),
                X2n(1)
            ])),
            A2(YH, n, A3(R2n, r.e, r.A, 1))
        ]));
    }), n3n = F2(function(n, r) {
        return A2(1 === FM(r.e).Dd ? J2n : K2n, n, r);
    }), r3n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, t3n = function(n) {
        return n.tf;
    }, e3n = function(n) {
        return n.tj;
    }, u3n = F2(function(n, r) {
        var t = r.a, e = r.b, u = i(t, n.jo);
        return A2(sF, w([
            Rj("button"),
            A2(lF, "aria-pressed", u ? "true" : "false"),
            Oq(w([
                v("segmented-control__segment", !0),
                v("segmented-control__segment--active", u)
            ])),
            qE(n.uY(t))
        ]), w([
            _d(e)
        ]));
    }), a3n = function(n) {
        return A2(zx, w([
            Gx("segmented-control")
        ]), A2(Fu, u3n(n), n.lN));
    }, i3n = F2(function(n, r) {
        return T1n(r.dV) ? A2(zx, n_(Jq), w([
            a3n({
                uY: A2(qc, Q2n, r3n),
                lN: w([
                    v(1, n(e3n)),
                    v(0, n(t3n))
                ]),
                jo: FM(r.e).Dd
            })
        ])) : vE;
    }), c3n = function(n) {
        return n.xG;
    }, o3n = F2(function(n, r) {
        return 1 === r ? A2(f_, w([
            VG,
            nF,
            uF(xD)
        ]), w([
            _d(n(c3n))
        ])) : vE;
    }), f3n = F2(function(n, r) {
        var t = P2n(r) || r.wk || I2n(r), e = FM(r.e);
        return A2(Yjn, w([
            rDn(c2n)
        ]), w([
            A2(i3n, n, r),
            A2(n3n, n, r),
            A2(Rcn, g, g),
            A2(yF, w([
                fF,
                iK,
                Lj(t),
                Qj(r.wk)
            ]), w([
                _d(n(A2(YM, M2n, B2n)))
            ])),
            A2(Rcn, g, g),
            A2(o3n, n, e.Dd),
            A2(Rcn, g, g),
            A2(f_, w([
                VG,
                uF(xD)
            ]), w([
                A2(Mx, g, w([
                    _d(n(A2(YM, L2n, A2(YM, M2n, B2n)))),
                    _d(" ")
                ])),
                A2(EV, w([
                    yV(Z2n),
                    xV
                ]), w([
                    _d(n(N2n))
                ])),
                A2(Mx, g, w([
                    _d(" "),
                    _d(n(H2n))
                ]))
            ]))
        ]));
    }), s3n = F2(function(n, r) {
        var t = w([
            mEn(1)
        ]), e = rJn;
        return v_(r) ? A3(AEn, t, Ot, _d(n(e))) : vE;
    }), l3n = F2(function(n, r) {
        var t = FM(r.e), e = A2(YM, 1 === t.Dd ? S2n : z2n, B2n);
        return A2(BE, w([
            VN(w([
                Gx("panel")
            ]))
        ]), w([
            A2(lE, g, w([
                A2(CF, w([
                    uE(L6),
                    uF(xD)
                ]), w([
                    _d(n(G2n))
                ])),
                A2(f_, w([
                    uF(xD)
                ]), w([
                    _d(n(e))
                ])),
                A2(Rcn, g, g),
                A2(s3n, n, r.g0),
                A2(f3n, n, r)
            ]))
        ]));
    }), d3n = F2(function(n, r) {
        return {
            g8: w([
                A2(BE, g, w([
                    spn(w([
                        cmn(2),
                        tO(0)
                    ])),
                    A2(lE, w([
                        cmn(8),
                        tO(12)
                    ]), w([
                        V2n(r.dV),
                        A2(l3n, n, r)
                    ]))
                ]))
            ]),
            yx: ax(r.dV)
        };
    }), v3n = function(n) {
        var r = ax(n);
        return A2(zx, w([
            Gx("mx-auto mb-6 flex items-center justify-center border border-primary-600 rounded p-6 w-8/12 sm:w-5/12")
        ]), w([
            function() {
                var t = D2n(n);
                return t.$ ? _d(r) : A2(uJ, w([
                    iJ(t.a),
                    tJ(r),
                    Gx("max-w-full")
                ]), g);
            }()
        ]));
    }, b3n = function(n) {
        return n.tg;
    }, m3n = function(n) {
        return n.th;
    }, p3n = F2(function(n, r) {
        var t = P2n(r) || r.wk || I2n(r), e = FM(r.e), u = 1 === e.Dd ? m3n : b3n, a = A3(T2n, r.e, r.A, 0), i = 1 === e.Dd ? A2(J2n, n, r) : A2(zx, g, w([
            A2(cz, g, w([
                A2(Mx, w([
                    Gx("sr-only")
                ]), w([
                    _d(n(U2n))
                ])),
                PI(w([
                    jI("name@example.com"),
                    HI(A2(qc, Q2n, e2n)),
                    yI(a),
                    OI(e.qN),
                    _I(O2n)
                ]))
            ])),
            A2(YH, n, A3(R2n, r.e, r.A, 0))
        ]));
        return A2(Yjn, w([
            rDn(c2n)
        ]), w([
            A2(f_, w([
                GN,
                uF(xD)
            ]), w([
                _d(n(u))
            ])),
            A2(Rcn, g, g),
            A2(i3n, n, r),
            i,
            A2(zx, w([
                Gx("mt-4")
            ]), w([
                A2(yF, w([
                    fF,
                    iK,
                    Lj(t),
                    Qj(r.wk)
                ]), w([
                    _d(n(A2(YM, M2n, B2n)))
                ]))
            ])),
            A2(Rcn, g, g),
            A2(o3n, n, e.Dd),
            A2(Rcn, g, g),
            A2(f_, w([
                VG,
                nF,
                uF(xD)
            ]), w([
                A2(Mx, g, w([
                    _d(n(A2(YM, L2n, A2(YM, M2n, B2n)))),
                    _d(" ")
                ])),
                A2(EV, w([
                    yV(Z2n),
                    xV
                ]), w([
                    _d(n(N2n))
                ])),
                A2(Mx, g, w([
                    _d(" "),
                    _d(n(H2n))
                ]))
            ]))
        ]));
    }), $3n = F2(function(n, r) {
        return A2(zx, g, w([
            A2(CF, w([
                uE(L6),
                uF(xD)
            ]), w([
                _d(ax(r.dV))
            ])),
            A2(s3n, n, r.g0),
            A2(p3n, n, r)
        ]));
    }), g3n = F2(function(n, r) {
        return {
            g8: w([
                A2(BE, w([
                    VN(w([
                        Gx("px-4 sm:px-0")
                    ]))
                ]), w([
                    spn(w([
                        cmn(2),
                        tO(0)
                    ])),
                    A2(lE, w([
                        cmn(8),
                        tO(12)
                    ]), w([
                        v3n(r.dV),
                        A2($3n, n, r)
                    ]))
                ]))
            ]),
            yx: ax(r.dV)
        };
    }), h3n = F2(function(n, r) {
        return Jk(r.dV) ? A2(g3n, n, r) : A2(d3n, n, r);
    }), y3n = d_({
        Cl: Q1n,
        CQ: R1n,
        Fj: U1n,
        F4: function() {
            return vx(w([
                t2n(K1n),
                J1n(W1n)
            ]));
        },
        Gv: F2n,
        GB: h3n
    }), w3n = function() {
        return "DateOfBirth";
    }, x3n = F3(function(n, r, t) {
        var e = vZ({
            bq: lZ("dob")
        });
        return v({
            g0: r.g0,
            hE: 0,
            cK: 0,
            ld: r.ld,
            le: e,
            vn: kc,
            dV: n,
            yZ: t.EX,
            A: A2(pZ, w([
                0
            ]), w3n),
            ku: !1
        }, L1n("Authentication - DOB Requested"));
    }), _3n = F2(function(n, r) {
        return v(r, Qp);
    }), C3n = F2(function(n, r) {
        return m(r, {
            g0: n.g0,
            vn: n.vn
        });
    }), A3n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, k3n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, E3n = F2(function(n, r) {
        return m(r, {
            bq: n
        });
    }), q3n = F2(function(n, r) {
        return A2(nsn, n, oe(r));
    }), F3n = F2(function(n, r) {
        return A3(p2n, r, "Authentication - DOB Submitted", w([
            A2(q3n, "attempts", n)
        ]));
    }), j3n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, D3n = F2(function(n, r) {
        return v(n, RTn(r.pS));
    }), V3n = function(n) {
        return au(ng(n));
    }, B3n = A2(nu, V3n, A2(Iu, "token", M$)), G3n = F4(function(n, r, t, e) {
        var u = rx(w([
            t
        ]));
        return A4(lM, n, B3n, e, A2(dM, u, pk(A2(bk, w([
            "auth",
            "switch_patient"
        ]), fM(r)))));
    }), z3n = F2(function(n, r) {
        return v(r.a, n);
    }), S3n = XM(w([
        function(n) {
            var r = mb(xMn(n.bq));
            if (r.$) return g;
            var t, e = r.a;
            return w([
                v(0, (t = A2(YM, rL, JM), A2(z3n, t, e)))
            ]);
        }
    ])), T3n = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, E3n, A2(JL, n, t.bq), r);
    }), P3n = F2(function(n, r) {
        var t = A2(CL, S3n, A2(T3n, n, r.le));
        return t.$ ? v(t.a, !1) : v(t.a.a, !0);
    }), Z3n = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A, e = A2(P3n, n, r), u = e.b;
        return v(m(r, {
            le: e.a,
            A: t
        }), u);
    }), M3n = function(n) {
        return n.dj.rc;
    }, L3n = function(n) {
        return n.dj.w7;
    }, N3n = function(n) {
        return n.dj.kg;
    }, H3n = function(n) {
        return n.dj.F5;
    }, I3n = function(n) {
        return n.dj.yx;
    }, O3n = function(n) {
        return n.dj.zx;
    }, Q3n = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = A2(Z3n, !0, r), e = t.a;
                return t.b ? b(m(e, {
                    cK: r.cK + 1
                }), function(n) {
                    var r = ux(n.dV), t = FM(n.le);
                    return A4(G3n, n.g0, r, A2(D3n, "dob", t.bq), j3n);
                }(e), g) : b(e, Qp, g);
            case 0:
                var u = n.a;
                switch(u.$){
                    case 3:
                        var a = u.a;
                        return b(m(r, {
                            hE: 3,
                            ku: !0
                        }), A2(F3n, r.cK, !0), w([
                            A2(Mk, 3, H3n),
                            A3n(a)
                        ]));
                    case 2:
                        return u.a.$ ? b(m(r, {
                            hE: 2
                        }), A2(F3n, r.cK, !1), A2(Qt, A2(Mk, 1, M3n), A2(Ik, 0, u))) : b(m(r, {
                            hE: 1
                        }), A2(F3n, r.cK, !1), g);
                    default:
                        return b(r, Qp, g);
                }
            default:
                var i = n.a, c = FM(r.le), o = A2(nN, i, c.bq), f = o.b;
                return b(m(r, {
                    le: A3(cN, E3n, o.a, r.le)
                }), A2(Wp, k3n, f), g);
        }
    }), R3n = {
        $: 1
    }, U3n = F2(function(n, r) {
        return A2(xc, "", r) + "Please contact " + n + " for more information";
    }), K3n = A3(AEn, w([
        mEn(0)
    ]), It("No matching date of birth found."), vE), W3n = F3(function(n, r, t) {
        var e = FM(t.le).bq;
        return A2(BE, g, w([
            A2(lE, w([
                cmn(12)
            ]), w([
                A2(EH, w([
                    vH("Date of birth"),
                    gH(!0)
                ]), w([
                    A2(c_, k3n, A3(ZI, n, w([
                        dI(r)
                    ]), e))
                ])),
                A2(Rcn, g, g),
                function() {
                    var n;
                    switch(t.hE){
                        case 1:
                            return K3n;
                        case 2:
                            return n = t.dV, A3(AEn, w([
                                mEn(0)
                            ]), It(A2(U3n, ax(n), Ot)), vE);
                        default:
                            return A2(zx, g, g);
                    }
                }(),
                A2(Rcn, g, g),
                A2(yF, w([
                    fF,
                    iK,
                    Lj(r),
                    cF(R3n)
                ]), w([
                    _d("Sign in")
                ])),
                A2(Rcn, g, g),
                A2(Rcn, g, g)
            ]))
        ]));
    }), X3n = A2(BE, w([
        VN(g)
    ]), w([
        A2(lE, w([
            TE(12)
        ]), w([
            A2(zx, w([
                Gx("text-center")
            ]), w([
                Lx(w([
                    Uq
                ]))
            ]))
        ]))
    ])), Y3n = F2(function(n, r) {
        return A2(BE, w([
            VN(w([
                Gx("panel")
            ]))
        ]), w([
            A2(lE, g, w([
                A2(CF, w([
                    uE(L6),
                    uF(xD)
                ]), w([
                    _d("Provide date of birth")
                ])),
                A2(f_, w([
                    uF(xD)
                ]), w([
                    _d("To ensure you access the correct account, please provide the date of birth as your email is linked to multiple members.")
                ])),
                A2(Rcn, g, g),
                r.ku ? X3n : A3(W3n, n, !1, r)
            ]))
        ]));
    }), J3n = F2(function(n, r) {
        return {
            g8: w([
                A2(BE, g, w([
                    spn(w([
                        cmn(2),
                        tO(0)
                    ])),
                    A2(lE, w([
                        cmn(8),
                        tO(12)
                    ]), w([
                        V2n(r.dV),
                        A2(Y3n, n, r)
                    ]))
                ]))
            ]),
            yx: "Provide date of birth"
        };
    }), n9n = d_({
        Cl: x3n,
        CQ: _3n,
        Fj: C3n,
        F4: function() {
            return bx;
        },
        Gv: Q3n,
        GB: J3n
    }), r9n = {
        ht: ""
    }, t9n = Xn("replaceUrl", tx), e9n = w([
        0
    ]), u9n = function() {
        return "Code";
    }, a9n = F3(function(n, r, t) {
        var e, u = A2(ra, "salt", t.jb), a = (e = A2(ra, "method", t.jb)).$ || "sms" !== e.a ? 0 : 1, i = A2(ra, "patient", t.jb), c = function() {
            if (1 === a) {
                var n = r.EA;
                if (n.$) return Ot;
                var e = n.a;
                return 1 === e.Dd ? It(e.b8) : Ot;
            }
            return A2(ra, v2n(a), t.jb);
        }(), o = OS(u) || OS(c), f = L1n("Authentication - Code Prompted"), s = b_(r.g0) && !r.Ab, l = function() {
            var n = v(s, o);
            return n.a ? A2(__, pa, ui) : n.b ? A2(__, pa, mi) : t9n(A2(nH, w([
                t.EX.Ev
            ]), g));
        }();
        return v({
            g0: r.g0,
            ht: "",
            G: vZ(r9n),
            eQ: 0,
            b_: 0,
            ld: r.ld,
            b8: c,
            Dd: a,
            fy: i,
            dV: n,
            wk: !1,
            l8: A2(ra, "redirectTo", t.jb),
            fP: u,
            co: Ot,
            eb: !1,
            yZ: t,
            A: A2(pZ, e9n, u9n)
        }, Uu(w([
            l,
            f
        ])));
    }), i9n = F2(function(n, r) {
        return v(r, Qp);
    }), c9n = F2(function(n, r) {
        return r;
    }), o9n = function(n) {
        return {
            $: 19,
            a: n
        };
    }, f9n = function(n) {
        return {
            aV: n,
            yx: Ot
        };
    }, s9n = F2(function(n, r) {
        return A3(p2n, r, "Authentication - Code Submitted", w([
            A2(q3n, "attempts", n)
        ]));
    }), l9n = function(n) {
        return n.oK.sv;
    }, d9n = XM(w([
        function(n) {
            var r = n.ht;
            return 1 === $u(r).$ || 6 !== lu(r) ? w([
                v(0, nL(l9n))
            ]) : g;
        }
    ])), v9n = function(n) {
        var r = A2(CL, d9n, n.G);
        return r.$ ? v(r.a, !1) : v(r.a.a, !0);
    }, b9n = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A;
        return m(r, {
            G: v9n(r).a,
            A: t
        });
    }), m9n = function() {
        return It(0);
    }, p9n = F2(function(n, r) {
        var t = m9n();
        if (t.$) return r;
        var e = t.a;
        return A2(EL, e, r.A) ? m(A2(b9n, !1, r), {
            A: A3(qL, !0, e, r.A)
        }) : r;
    }), $9n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, g9n = F2(function(n, r) {
        var t = n.b8;
        return t.$ ? Qp : A6(A2n, n.g0, n.Dd, t.a, ux(n.dV), r, $9n);
    }), h9n = F2(function(n, r) {
        return OS(r) && function(n) {
            if (n.$) return !1;
            var r = n.a;
            if (P$(r)) {
                var t = ek(M$);
                return A2(xc, !1, A2(Op, function(n) {
                    return n > 1;
                }, L$(A2(d$, function(n) {
                    return ve(n);
                }, A2(z$, A2(Iu, "patients", t), r)))));
            }
            return !1;
        }(n);
    }), y9n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, w9n = F9(function(n, r, t, e, u, a, i, c, o) {
        var f = rx(w([
            v("auth_channel", tx(C2n(r))),
            A2(_2n, r, t),
            v("code", tx(u)),
            v("salt", tx(e)),
            v("practice_id", tx(a)),
            v("google_recaptcha_token", A2(wM, tx, i)),
            v("patient_id", A2(wM, tx, c))
        ]));
        return A4(lM, GQ(n), B3n, o, A2(dM, f, pk(A2(bk, w([
            "auth"
        ]), fM(a)))));
    }), x9n = F2(function(n, r) {
        var t = FM(n.G).ht, e = v(n.b8, n.fP);
        return e.a.$ || e.b.$ ? Qp : A9(w9n, n.g0, n.Dd, e.a.a, e.b.a, t, ux(n.dV), r, n.fy, y9n);
    }), _9n = function(n) {
        var r = A2(CL, d9n, n.G);
        return r.$ ? b(m(n, {
            G: r.a,
            wk: !1,
            A: DL(n.A)
        }), Qp, g) : b(m(n, {
            G: r.a.a,
            b_: n.b_ + 1,
            wk: !0,
            co: Ot
        }), A2(x9n, n, Ot), g);
    }, C9n = F2(function(n, r) {
        return m(r, {
            ht: n
        });
    }), A9n = F2(function(n, r) {
        var t = m9n();
        return t.$ ? r : m(r, {
            A: A3(fN, !0, t.a, r.A)
        });
    }), k9n = F2(function(n, r) {
        return A2(A9n, n, m(r, {
            G: A3(cN, C9n, n, r.G)
        }));
    }), E9n = F2(function(n, r) {
        switch(n.$){
            case 6:
                var t = FM((a = A2(k9n, n.a, r)).G).ht;
                return Jk(r.dV) && 6 === lu(t) && !r.wk ? _9n(a) : b(a, Qp, g);
            case 0:
                return _9n(r);
            case 5:
                var e = FM(r.G);
                return b(A2(p9n, t = e.ht, r), Qp, g);
            case 1:
                return b(m(r, {
                    ht: "",
                    G: vZ(r9n),
                    eQ: r.eQ + 1,
                    b_: 0,
                    wk: !0,
                    co: Ot,
                    A: A2(pZ, e9n, u9n)
                }), A2(g9n, r, Ot), g);
            case 2:
                var u = n.a, a = m(r, {
                    wk: !1
                });
                n: for(;;)switch(u.$){
                    case 3:
                        var i = u.a, c = function() {
                            if (A2(h9n, i, r.fy)) {
                                var n = (t = r.l8).$ ? pa : ed(w([
                                    v("redirectTo", t.a)
                                ]));
                                return v(A2(__, n, pi), w([
                                    o9n(i)
                                ]));
                            }
                            var t;
                            return v(Qp, w([
                                A3n(i)
                            ]));
                        }(), o = c.b;
                        return b(r, Uu(w([
                            c.a,
                            A2(s9n, r.b_, !0)
                        ])), o);
                    case 2:
                        if (5 === u.a.$) {
                            var f = u.a.b;
                            return b(m(a, {
                                co: lu(f) > 0 ? It(f9n(w([
                                    Zk(f)
                                ]))) : Ot
                            }), A2(s9n, r.b_, !1), g);
                        }
                        break n;
                    default:
                        break n;
                }
                return b(a, A2(s9n, r.b_, !1), A2(Ik, 0, u));
            case 3:
                var s = n.a;
                return a = m(r, {
                    wk: !1,
                    co: Ot,
                    eb: !0
                }), 3 === s.$ ? b(m(a, {
                    fP: It(s.a)
                }), A2(Jfn, "Authentication - Code Resent", w([
                    A2(q3n, "quantity", r.eQ)
                ])), g) : b(a, Qp, A2(Ik, 0, s));
            default:
                return b(m(r, {
                    eb: !1
                }), Qp, g);
        }
    }), q9n = {
        $: 1
    }, F9n = F2(function(n, r) {
        return 1 === n ? A2(iV, 0, r) : r;
    }), j9n = F2(function(n, r) {
        return r.y9(n);
    }), D9n = F2(function(n, r) {
        return r.za(n);
    }), V9n = F2(function(n, r) {
        return 1 === n ? D9n(A2(F9n, n, r)) : j9n(r);
    }), B9n = {
        $: 5
    }, G9n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, z9n = {
        $: 0
    }, S9n = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), T9n = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), P9n = function(n) {
        return n.aV;
    }, Z9n = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), M9n = Z9n, L9n = F2(function(n, r) {
        return ve(r) ? A2(ipn, w([
            A2(M9n, 2, 1),
            A2(M9n, 3, 1)
        ]), A2(Fu, function(r) {
            return Wmn(WH(n(r)));
        }, r)) : vE;
    }), N9n = function(n) {
        return n.yx;
    }, H9n = F2(function(n, r) {
        var t = w([
            mEn(0)
        ]);
        if (r.$) return vE;
        var e = r.a;
        return A2(zx, n_(jvn), w([
            A3(AEn, t, N9n(e), A2(L9n, n, P9n(e)))
        ]));
    }), I9n = F2(function(n, r) {
        var t = A3(S9n, r.G, r.A, 0), e = FM(r.G).ht;
        return A2(Yjn, w([
            rDn(z9n)
        ]), w([
            A2(EH, w([
                vH(n(O3n)),
                gH(!0)
            ]), w([
                PI(w([
                    jI("e.g. 123456"),
                    HI(A2(qc, G9n, cu)),
                    yI(t),
                    _I(B9n),
                    OI(e),
                    X2n(1),
                    pO("one-time-code")
                ])),
                A2(YH, n, A3(T9n, r.G, r.A, 0))
            ])),
            A2(Rcn, g, g),
            A2(yF, w([
                fF,
                iK,
                Lj(t || r.wk)
            ]), w([
                _d(n(N3n))
            ])),
            A2(Rcn, g, g),
            A2(Rcn, g, g),
            A2(H9n, n, r.co),
            A2(f_, w([
                VG,
                uF(xD)
            ]), w([
                A2(Mx, g, w([
                    _d(n(A2(YM, L2n, N3n))),
                    _d(" ")
                ])),
                A2(EV, w([
                    yV("https://www.ftc.gov/enforcement/rules/rulemaking-regulatory-reform-proceedings/childrens-online-privacy-protection-rule"),
                    xV
                ]), w([
                    _d(n(N2n))
                ])),
                A2(Mx, g, w([
                    _d(" "),
                    _d(n(H2n))
                ]))
            ]))
        ]));
    }), O9n = {
        $: 4
    }, Q9n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, R9n = function(n) {
        return n.zb;
    }, U9n = function(n) {
        return n.zc;
    }, K9n = F4(function(n, r, t, e) {
        var u = It("Code has been resent"), a = w([
            mEn(1),
            Q9n(O9n)
        ]), i = n(function(n) {
            return 1 === n ? U9n : R9n;
        }(r));
        return t ? A2(zx, n_(jvn), w([
            A3(AEn, a, u, A4(mG, ax(e), bV(e), It(i), Ot))
        ])) : vE;
    }), W9n = F2(function(n, r) {
        return A2(BE, w([
            VN(w([
                Gx("panel")
            ]))
        ]), w([
            A2(lE, g, w([
                A2(CF, w([
                    uE(L6),
                    uF(xD)
                ]), w([
                    _d(n(I3n))
                ])),
                A2(f_, w([
                    uF(xD)
                ]), w([
                    _d(n(A2(V9n, r.Dd, A2(xc, "", r.b8))))
                ])),
                A2(Kk, w([
                    uF(xD),
                    uE(iwn)
                ]), w([
                    A2(yF, w([
                        j6,
                        cF(q9n)
                    ]), w([
                        _d(n(L3n))
                    ]))
                ])),
                A2(Rcn, g, g),
                A4(K9n, n, r.Dd, r.eb, r.dV),
                A2(Rcn, g, g),
                A2(I9n, n, r)
            ]))
        ]));
    }), X9n = F2(function(n, r) {
        return w([
            A2(BE, g, w([
                spn(w([
                    cmn(2),
                    tO(0)
                ])),
                A2(lE, w([
                    cmn(8),
                    tO(12)
                ]), w([
                    V2n(r.dV),
                    A2(W9n, n, r)
                ]))
            ]))
        ]);
    }), Y9n = function(n) {
        return function(n) {
            return {
                $: 5,
                a: n
            };
        }(n);
    }, J9n = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, n6n = function(n) {
        return n.y5;
    }, r6n = function(n) {
        return n.y6;
    }, t6n = F2(function(n, r) {
        return r.y7(n);
    }), e6n = F2(function(n, r) {
        return r.y8(n);
    }), u6n = F2(function(n, r) {
        return 1 === n ? e6n(A2(F9n, n, r)) : t6n(r);
    }), a6n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    fe: n.a
                });
            case 1:
                return m(r, {
                    iJ: It(n.a)
                });
            case 2:
                return m(r, {
                    iI: It(n.a)
                });
            case 3:
                return m(r, {
                    y4: n.a
                });
            case 4:
                return m(r, {
                    Bb: n.a
                });
            default:
                return m(r, {
                    ez: n.a
                });
        }
    }), i6n = {
        ez: "",
        Bb: !1,
        fe: 6,
        iI: Ot,
        iJ: Ot,
        y4: ""
    }, c6n = F2(function(n, r) {
        var t = i(lu(n), r), e = A3(du, r, r + 1, n), u = !mu(e);
        return A2(zx, w([
            Oq(w([
                v("code-input__box", !0),
                v("code-input__box--active", t),
                v("code-input__box--empty", !t && !u),
                v("code-input__box--filled", u && !t)
            ]))
        ]), w([
            _d(e)
        ]));
    }), o6n = function(n) {
        var r, t, e = A3(de, a6n, i6n, n), u = (r = e.iI).$ ? g : w([
            DH(r.a)
        ]), a = function() {
            var n = e.iJ;
            return n.$ ? g : w([
                SH(n.a)
            ]);
        }(), i = mu(e.ez) ? g : w([
            A2(lF, "aria-label", e.ez)
        ]), c = vc(w([
            w([
                Gx("code-input__field"),
                Rj("tel"),
                (t = e.fe, A2(vr, "maxlength", oe(t))),
                A2(lF, "autocomplete", "one-time-code"),
                A2(lF, "inputmode", "numeric"),
                oz(e.y4),
                vF(e.Bb),
                DI(!0)
            ]),
            i,
            a,
            u
        ]));
        return A2(zx, w([
            Gx("code-input")
        ]), w([
            A2(sz, c, g),
            A2(zx, w([
                Gx("code-input__boxes")
            ]), A2(Fu, c6n(e.y4), A2($e, 0, e.fe - 1)))
        ]));
    }, f6n = F2(function(n, r) {
        var t, e, u, a, i = FM(r.G).ht;
        return A2(Yjn, w([
            rDn(z9n)
        ]), w([
            A2(f_, w([
                sE,
                uE(Jq),
                uF(xD)
            ]), w([
                _d(n(A2(u6n, r.Dd, A2(xc, "", r.b8))))
            ])),
            A2(f_, w([
                uF(xD)
            ]), w([
                _d(n((a = r.Dd, 1 === a ? r6n : n6n)))
            ])),
            A2(zx, w([
                Gx("mt-8")
            ]), w([
                o6n(w([
                    {
                        $: 0,
                        a: 6
                    },
                    (u = i, function(n) {
                        return {
                            $: 3,
                            a: n
                        };
                    }(u)),
                    J9n(A2(qc, G9n, cu)),
                    (e = B9n, function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(e)),
                    (t = r.wk, function(n) {
                        return {
                            $: 4,
                            a: n
                        };
                    }(t)),
                    Y9n(n(O3n))
                ]))
            ])),
            A2(H9n, n, r.co),
            A4(K9n, n, r.Dd, r.eb, r.dV),
            A2(Kk, w([
                uF(xD),
                uE(jvn)
            ]), w([
                A2(yF, w([
                    j6,
                    cF(q9n),
                    Lj(r.wk),
                    Kj(w([
                        Rj("button")
                    ]))
                ]), w([
                    _d(n(L3n))
                ]))
            ])),
            A2(YH, n, A3(T9n, r.G, r.A, 0))
        ]));
    }), s6n = F2(function(n, r) {
        return w([
            A2(BE, w([
                VN(w([
                    Gx("px-4 sm:px-0")
                ]))
            ]), w([
                spn(w([
                    cmn(3),
                    tO(0)
                ])),
                A2(lE, w([
                    cmn(6),
                    tO(12)
                ]), w([
                    v3n(r.dV),
                    A2(CF, w([
                        uE(L6),
                        uF(xD)
                    ]), w([
                        _d(ax(r.dV))
                    ])),
                    A2(f6n, n, r)
                ]))
            ]))
        ]);
    }), l6n = F2(function(n, r) {
        return {
            g8: function() {
                var t = v(r.b8, r.fP);
                return t.a.$ || t.b.$ ? Nx : Jk(r.dV) ? A2(s6n, n, r) : A2(X9n, n, r);
            }(),
            yx: ax(r.dV)
        };
    }), d6n = d_({
        Cl: a9n,
        CQ: i9n,
        Fj: c9n,
        F4: function() {
            return bx;
        },
        Gv: E9n,
        GB: l6n
    }), v6n = JRn({
        GB: function() {
            return {
                g8: w([
                    l_
                ]),
                yx: "404"
            };
        }
    }), b6n = iJn({
        Cl: function(n) {
            return A2(aJn, ja, n.jb);
        }
    }), m6n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, p6n = function(n) {
        return 2 === n.$ ? It(n.a) : Ot;
    }, $6n = function(n) {
        return p6n(n.gk);
    }, g6n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, h6n = function(n) {
        return n.oM;
    }, y6n = function(n) {
        return n_n(h6n(n));
    }, w6n = function(n) {
        return n.xb ? n.no : g;
    }, x6n = function(n) {
        return n.oN;
    }, _6n = function(n) {
        return n_n(x6n(n));
    }, C6n = function(n) {
        switch(n){
            case 0:
                return "Mailing Address";
            case 1:
                return "Billing Address";
            case 2:
                return "Addresses Are The Same";
            case 3:
                return "Insurance";
            default:
                return "Enrollment Status";
        }
    }, A6n = function(n) {
        return "field-" + C6n(n);
    }, k6n = F3(function(n, r, t) {
        return A4(UGn, w6n(r), ax(n), Xw(n), t ? A2(Gxn, _6n(r), Nwn(A6n(1))) : A2(Gxn, y6n(r), Nwn(A6n(0))));
    }), E6n = F4(function(n, r, t, e) {
        var u = A2(txn, n, r), a = u.a, i = u.b;
        return v({
            m9: A3(k6n, t, e, 0),
            a0: !0,
            nN: A3(k6n, t, e, 1),
            q4: !0,
            a8: a
        }, w([
            A2(Wp, g6n, i)
        ]));
    }), q6n = A3(nk, "billing_address_zip", uC(M$), A3(nk, "billing_address_state", uC(M$), A3(nk, "billing_address_line2", uC(M$), A3(nk, "billing_address_line1", uC(M$), A3(nk, "billing_address_country", uC(M$), A3(nk, "billing_address_city", uC(M$), A3(nk, "owner_pays_on_behalf", uC(ru), A3(nk, "health_insurance", uC(Vhn), A3(nk, "address_zip", uC(M$), A3(nk, "address_state", uC(M$), A3(nk, "address_line2", uC(M$), A3(nk, "address_line1", uC(M$), A3(nk, "address_country", uC(M$), A3(nk, "address_city", uC(M$), au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return {
                                                                na: n,
                                                                nb: r,
                                                                nc: t,
                                                                nd: e,
                                                                ne: u,
                                                                nf: a,
                                                                nO: o,
                                                                nP: f,
                                                                nQ: s,
                                                                nR: l,
                                                                nS: d,
                                                                nT: v,
                                                                r2: i,
                                                                u8: c
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), F6n = A2($A, q6n, au(cu)), j6n = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments",
            r,
            "additional_details"
        ]), fM(n));
    }), D6n = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), F6n, e, pk(A2(j6n, r, t)));
    }), V6n = function(n) {
        return p6n(n.fu);
    }, B6n = w([
        0,
        1,
        3,
        4
    ]), G6n = F4(function(n, r, t, e) {
        var u = A4(E6n, t.g0, !1, n, r), a = u.a, i = u.b, c = function() {
            var r = v(V6n(t), t.FN);
            if (3 === r.b.$) {
                if (r.a.$) return b(i, kc, u = r.b.a);
                var e = r.a.a, u = r.b.a;
                return b(A2(Qt, A4(D6n, t.g0, ux(n), e, m6n), i), A_, u);
            }
            return b(i, kc, g);
        }(), o = c.a, f = c.b, s = c.c;
        return v({
            gk: $6n(t),
            zO: Ot,
            g0: t.g0,
            g7: p7,
            hH: t.hH,
            ld: t.ld,
            le: vZ(a),
            fu: t.fu,
            iK: f,
            dV: n,
            wk: !1,
            c7: f,
            c8: p7,
            jv: Ot,
            mp: GYn(r),
            f2: r,
            FN: s,
            yZ: e,
            A: A2(pZ, B6n, C6n)
        }, Uu(o));
    }), z6n = F2(function(n, r) {
        return v(r, Qp);
    }), S6n = F2(function(n, r) {
        return r;
    }), T6n = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), P6n = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Z6n = nr("onUrlChange", M$), M6n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, L6n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, N6n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, H6n = {
        $: 8
    }, I6n = {
        $: 7
    }, O6n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Q6n = function(n) {
        return {
            $: 9,
            a: n
        };
    }, R6n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, U6n = {
        $: 15
    }, K6n = function(n) {
        return {
            $: 11,
            a: n
        };
    }, W6n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, X6n = function(n) {
        return n.nl;
    }, Y6n = F2(function(n, r) {
        return A2(iH, r, n);
    }), J6n = F2(function(n, r) {
        return A2(Fu, function(n) {
            return v(r, n);
        }, A2(Y6n, n, r));
    }), n4n = function(n) {
        return A2(rsn, "Error Description", n);
    }, r4n = function(n) {
        return A2(rsn, "Error Name", n);
    }, t4n = function(n) {
        return A2(rsn, "Field Name", n);
    }, e4n = function(n) {
        return n.a ? "required" : "validation";
    }, u4n = function(n) {
        return A2(xc, " ", A2(Op, e4n, n));
    }, a4n = F2(function(n, r) {
        var t = r.ru, e = r.eZ;
        return A2(Jfn, "Form Field Errored", w([
            esn(n),
            t4n(t),
            r4n(u4n(mb(e))),
            n4n(A2(fe, ", ", A2(Fu, NH(Vx(0)), e)))
        ]));
    }), i4n = "Member Signup 2.0", c4n = function(n) {
        return A2(a4n, i4n, n);
    }, o4n = F2(function(n, r) {
        var t = mb(A2(bu, n, r));
        if (t.$) return v("", r);
        var e = t.a;
        return v(A2(pu, e, r), A2(yb, lu(r) - e - lu(n), r));
    }), f4n = F2(function(n, r) {
        var t = A2(o4n, ": ", r), e = t.a, u = t.b;
        return lu(e) > 0 ? v($(C6n(n), $(": ", e)), u) : v(C6n(n), r);
    }), s4n = function(n) {
        return A2(Fu, function(n) {
            var r = n.a, t = n.b, e = A2(NH, Vx(0), t), u = function() {
                switch(r){
                    case 0:
                    case 1:
                        return A2(f4n, 0, e);
                    default:
                        return v(C6n(r), e);
                }
            }().a;
            return c4n({
                eZ: w([
                    t
                ]),
                ru: u
            });
        }, function(n) {
            return vc(A2(Fu, J6n(n), B6n));
        }(n));
    }, l4n = {
        F1: Atn(100),
        Gs: function(n) {
            return {
                $: 5,
                a: n
            };
        }
    }, d4n = function(n) {
        return n.oR;
    }, v4n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, b4n = function(n) {
        return A2(Nu, v4n, Au(n));
    }, m4n = function(n) {
        return {
            $: 8,
            a: n
        };
    }, p4n = function(n) {
        return A2(Nu, m4n, Au(n));
    }, $4n = function(n) {
        return function(n) {
            return n.p$;
        }(n.f1);
    }, g4n = function(n) {
        return !nEn(x6n(n));
    }, h4n = function(n) {
        return function(n) {
            return Yzn(h6n(n));
        }(n) && _6n(n) ? 1 : function(n) {
            return !nEn(h6n(n));
        }(n) ? g4n(n) ? 0 : 2 : g4n(n) ? 3 : 4;
    }, y4n = F2(function(n, r) {
        switch(h4n(n)){
            case 0:
            case 2:
                return !0;
            case 1:
                return !r.a0;
            default:
                return !1;
        }
    }), w4n = F2(function(n, r) {
        return A2(y4n, n, r) ? A2(Fu, function(n) {
            var r = n.b;
            return v(0, A2(bMn, vMn(n.a), r));
        }, Ckn(r.m9)) : g;
    }), x4n = F2(function(n, r) {
        switch(h4n(n)){
            case 0:
                return !r.a0;
            case 1:
            case 3:
                return !0;
            default:
                return !1;
        }
    }), _4n = F2(function(n, r) {
        return A2(x4n, n, r) ? A2(Fu, function(n) {
            var r = n.b;
            return v(1, A2(bMn, vMn(n.a), r));
        }, Ckn(r.nN)) : g;
    }), C4n = function(n) {
        return !nEn(d4n(n));
    }, A4n = F2(function(n, r) {
        return A2(Op, function(n) {
            return v(rxn(r), n);
        }, mb(A2(iH, r, n.le)));
    }), k4n = F2(function(n, r) {
        var t, e = r.a8;
        return C4n(n) ? A2(Fu, function(n) {
            var r = n.b;
            return v(3, A2(bMn, vMn(n.a), r));
        }, (t = e, A2(n$, function(n) {
            return A2(A4n, t, n);
        }, nxn))) : g;
    }), E4n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    m9: n.a
                });
            case 1:
                return m(r, {
                    nN: n.a
                });
            case 2:
                return m(r, {
                    a0: n.a
                });
            case 3:
                return m(r, {
                    a8: n.a
                });
            default:
                return m(r, {
                    q4: n.a
                });
        }
    }), q4n = F3(function(n, r, t) {
        if (A2(y4n, n, FM(t))) {
            var e = FM(t);
            return A3(cN, E4n, M6n(A2(qAn, r, e.m9)), t);
        }
        return t;
    }), F4n = F3(function(n, r, t) {
        if (A2(x4n, n, FM(t))) {
            var e = FM(t);
            return A3(cN, E4n, N6n(A2(qAn, r, e.nN)), t);
        }
        return t;
    }), j4n = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, E4n, R6n(A2(YAn, n, t.a8).a), r);
    }), D4n = F3(function(n, r, t) {
        var e = A2(j4n, r, A3(F4n, n, r, A3(q4n, n, r, t))), u = A2(CL, function(n) {
            return XM(w([
                w4n(n),
                _4n(n),
                k4n(n)
            ]));
        }(n), e);
        return u.$ ? v(u.a, !1) : v(u.a.a, !0);
    }), V4n = F2(function(n, r) {
        return !nE(A2(Y6n, n, r));
    }), B4n = F2(function(n, r) {
        var t = A3(D4n, n, !1, r);
        return t.b ? Ot : A2(bb, function(n) {
            return It(A6n(n));
        }, mb(A2(no, V4n(t.a), B6n)));
    }), G4n = F2(function(n, r) {
        var t = FM(n.le), e = FM(r.le);
        return i(e.oE, t.oE) && i(e.AS, t.AS) && i(e.zQ, t.zQ) && i(e.zR, t.zR) && i(e.x6, t.x6) && i(e.zF, t.zF);
    }), z4n = F6(function(n, r, t, e, u, a) {
        var i, c = A4(UGn, w6n(e), ax(t), Xw(t), A2(Gxn, _6n(e), A2(s_n, A6n(1), function(n) {
            return {
                zQ: n.nQ,
                zR: n.nR,
                oE: n.nO,
                AS: n.nP,
                x6: n.nS,
                zF: n.nT
            };
        }(a)))), o = A4(UGn, w6n(e), ax(t), Xw(t), A2(Gxn, y6n(e), A2(s_n, A6n(0), function(n) {
            return {
                zQ: n.nc,
                zR: n.nd,
                oE: n.na,
                AS: n.nb,
                x6: n.ne,
                zF: n.nf
            };
        }(a)))), f = FM(u).a8, s = (i = function(n) {
            return n.r2;
        }(a), i.$ ? A2(g_n, n, f) : A2(A_n, i.a, f));
        return {
            m9: o,
            a0: A2(G4n, c, o),
            nN: c,
            q4: r,
            a8: s
        };
    }), S4n = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            nX: o,
            sl: n,
            it: c,
            fm: a,
            iO: i,
            u8: e,
            wL: u,
            f1: t,
            jy: r
        };
    }), T4n = F5(function(n, r, t, e, u) {
        return {
            CI: e,
            ur: n,
            vb: u,
            l2: r,
            wz: t
        };
    }), P4n = F3(function(n, r, t) {
        return {
            Ay: t,
            l2: r,
            wx: n
        };
    }), Z4n = A3(nk, "charge_item", A2(Iu, "name", M$), A3(nk, "price_in_cents", O$, A3(nk, "quantity", O$, au(P4n)))), M4n = A4(JA, "package_items", ek(Z4n), g, A4(JA, "item_type", M$, "", A4(JA, "quantity_in_stock", uC(O$), Ot, A3(nk, "price_in_cents", O$, A3(nk, "name", M$, au(T4n)))))), L4n = A2($A, M4n, au(cu)), N4n = F6(function(n, r, t, e, u, a) {
        return {
            ng: a,
            qj: r,
            sl: n,
            ur: t,
            wQ: e,
            y3: u
        };
    }), H4n = A3(nk, "age", uC(O$), A3(nk, "uses_tobacco", ru, A3(nk, "relationship", A2(nu, vVn, M$), A3(nk, "name", M$, A3(nk, "dob", uC(KA), A3(nk, "id", M$, au(N4n))))))), I4n = A2($A, H4n, au(cu)), O4n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Q4n = F2(function(n, r) {
        var t = v(n, r);
        return t.a.$ ? t.b.$ ? AA("Either Plan or Charge item is required.") : au(function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.b.a)) : au(O4n(t.a.a));
    }), R4n = function(n) {
        if (n.$) return au(Ot);
        var r = n.a;
        switch(r){
            case "terminate":
                return au(It(0));
            case "auto-renew":
                return au(It(1));
            default:
                return AA("Unsupported Contract type: " + r);
        }
    }, U4n = A4(JA, "description", uC(M$), Ot, A3(nk, "registration_fee_name", M$, A3(nk, "tobacco_surcharge_type", uC(M$), A3(nk, "dpc_discount", ru, A3(nk, "contract_type", A2(nu, R4n, uC(M$)), A3(nk, "contract_period_in_months", uC(A2(nu, xgn, O$)), A3(nk, "contract_expires", ru, A3(nk, "bills_at_end_of_period", ru, A3(nk, "children_age_limit", uC(O$), A3(nk, "maximum_age", uC(O$), A3(nk, "minimum_age", uC(O$), A3(nk, "name", M$, A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            nY: a,
                                                            ox: u,
                                                            pk: i,
                                                            pn: c,
                                                            pr: o,
                                                            p8: d,
                                                            qv: f,
                                                            sl: n,
                                                            tw: e,
                                                            ul: t,
                                                            ur: r,
                                                            wO: l,
                                                            yF: s
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), K4n = A2($A, U4n, au(cu)), W4n = F2(function(n, r) {
        return {
            p$: r,
            sl: n
        };
    }), X4n = A3(nk, "debug", ru, A3(nk, "id", M$, au(W4n))), Y4n = A2($A, X4n, au(cu)), J4n = F3(function(n, r, t) {
        return {
            mR: r,
            ur: n,
            yH: t
        };
    }), n8n = function(n) {
        switch(n){
            case "owner_info":
                return au(0);
            case "additional_details":
                return au(1);
            case "members":
                return au(2);
            case "plan":
                return au(3);
            case "custom_details":
                return au(4);
            case "location":
                return au(5);
            case "practitioner":
                return au(6);
            case "confirmation":
                return au(7);
            default:
                return AA("Unsupported Signup step name: " + n);
        }
    }, r8n = A3(nk, "toggleable", ru, A3(nk, "active", ru, A3(nk, "name", A2(nu, n8n, M$), au(J4n)))), t8n = A2($A, r8n, au(cu)), e8n = A2(nu, function(n) {
        return A2($A, A2(Q4n, n.vU, n.or), A2(zB, n.it, A2(zB, n.iO, A2(zB, n.fm, A2(zB, n.wL, A2(zB, n.u8, A2(zB, n.f1, A2(zB, n.jy, A2(zB, n.sl, au(S4n))))))))));
    }, A3(nk, "charge_item", uC(L4n), A3(nk, "locations", ek(vYn), A3(nk, "owner", d1, A3(nk, "members", ek(I4n), A3(nk, "referred", ru, A3(nk, "owner_pays_on_behalf", ru, A3(nk, "signup_attempt", Y4n, A3(nk, "plan", uC(K4n), A3(nk, "signup_step", t8n, A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                or: f,
                                                sl: n,
                                                it: o,
                                                fm: i,
                                                iO: c,
                                                u8: u,
                                                vU: t,
                                                wL: a,
                                                f1: e,
                                                jy: r
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), u8n = A2($A, e8n, au(cu)), a8n = F2(function(n, r) {
        return A2(bk, w([
            "signup_pages",
            r
        ]), fM(n));
    }), i8n = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments"
        ]), A2(a8n, n, r));
    }), c8n = F5(function(n, r, t, e, u) {
        return A4(aA, GQ(n), u8n, u, pk(A2(bk, w([
            e,
            "step"
        ]), A2(i8n, r, t))));
    }), o8n = function(n) {
        return 4 === n;
    }, f8n = F3(function(n, r, t) {
        var e = u1n(r);
        return A2(SS, function(r) {
            return i(A2(i1n, r.a, n), t);
        }, e);
    }), s8n = F4(function(n, r, t, e) {
        var u = v(A3(f8n, n, r, t), A3(f8n, n, r, e));
        return !u.a.$ && !u.b.$ && 0 > s(u.b.a.b, u.a.a.b);
    }), l8n = function(n) {
        return 1 === n;
    }, d8n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, v8n = F2(function(n, r) {
        var t = A2(qAn, !1, r);
        return A2(bb, function(n) {
            return mb(A2(iH, n, t.le));
        }, mb(A2(no, function(r) {
            return i(Mwn(r), n);
        }, Zwn)));
    }), b8n = F2(function(n, r) {
        var t = A2(YAn, !1, r).a;
        return A2(bb, function(n) {
            return mb(A2(iH, n, t.le));
        }, mb(A2(no, function(r) {
            return i(rxn(r), n);
        }, nxn)));
    }), m8n = F2(function(n, r) {
        switch(r.$){
            case 0:
            case 1:
                return A2(v8n, n, r.a);
            case 2:
            default:
                return Ot;
            case 3:
                return A2(b8n, n, r.a);
        }
    }), p8n = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            default:
                return 4;
        }
    }, $8n = function(n) {
        return C6n(p8n(n));
    }, g8n = F2(function(n, r) {
        return mb(A2(Y6n, n.le, p8n(r)));
    }), h8n = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A, e = A3(D4n, r.f2, n, r.le), u = e.b;
        return v(m(r, {
            le: e.a,
            A: t
        }), u);
    }), y8n = F3(function(n, r, t) {
        var e = _c(n.yZ.EX), u = A2(h8n, !1, n).a, a = function() {
            if (t.$) return v($8n(r), A2(g8n, u, r));
            var n = t.a;
            return v($8n(r) + ": " + n, A2(m8n, n, r));
        }(), i = a.a;
        return d8n(It({
            eZ: A2(xc, g, A2(Op, _K, a.b)),
            ru: i,
            Fh: e
        }));
    }), w8n = F2(function(n, r) {
        return A2(nsn, n, function(n) {
            return n ? "Yes" : "No";
        }(r));
    }), x8n = function(n) {
        return A2(w8n, "Existing Coverage", n);
    }, _8n = function(n) {
        return n.sG;
    }, C8n = function(n) {
        return n.sM;
    }, A8n = function(n) {
        return A2(rsn, "Signup Flow", C8n(n) ? _8n(n) ? "Checkout" : "Retail" : "Employee");
    }, k8n = function(n) {
        return n.nj;
    }, E8n = function(n) {
        return n.oO;
    }, q8n = function(n) {
        return n.oS;
    }, F8n = F2(function(n, r) {
        return A2(nsn, n, function(n) {
            switch(n){
                case 0:
                    return "No";
                case 1:
                    return "Yes";
                case 2:
                    return "Optional";
                case 3:
                    return "Require";
                default:
                    return "Default";
            }
        }(r));
    }), j8n = function(n) {
        return n.oV;
    }, D8n = function(n) {
        return n.oX;
    }, V8n = function(n) {
        return n.oY;
    }, B8n = function(n) {
        return n.oZ;
    }, G8n = function(n) {
        return n.o_;
    }, z8n = function(n) {
        return n.sl;
    }, S8n = function(n) {
        return A2(bb, function(n) {
            return It(z8n(n));
        }, n.p0);
    }, T8n = function(n) {
        return A2(bb, function(n) {
            return It(UR(n));
        }, n.p4);
    }, P8n = function(n) {
        return n.p7;
    }, Z8n = function(n) {
        return n.ui;
    }, M8n = function(n) {
        return A2(bb, mon, n.l_);
    }, L8n = function(n) {
        return n.wK;
    }, N8n = F2(function(n, r) {
        var t = function(n) {
            switch(n){
                case 0:
                    return "Collect Billing Address";
                case 1:
                    return "Collect Address";
                case 2:
                    return "Collect Practitioner";
                case 3:
                    return "Collect Location";
                case 4:
                    return "Collect Insurance";
                case 5:
                    return "Collect Payment Source";
                case 6:
                    return "Collect Lead Source";
                case 7:
                    return "Collect Broker";
                case 8:
                    return "Collect SSN";
                case 9:
                    return "Minimum Enroll Age";
                case 10:
                    return "Redirects Post Signup";
                case 11:
                    return "Post Signup Redirect Url";
                case 12:
                    return "Post Signup Message";
                case 13:
                    return "Show Post Signup Footer Button";
                case 14:
                    return "Signup Page";
                case 15:
                    return "Allow Non-Member Payer";
                case 16:
                    return "Collect Tobacco Use";
                case 17:
                    return "Restrict Zip Codes";
                case 18:
                    return "Allowed Zip Codes";
                case 19:
                    return "Default Practitioner";
                case 20:
                    return "Default Location";
                case 21:
                    return "Accepts New Signup";
                case 22:
                    return "Allow Coupons";
                case 23:
                    return "Collect Start Date";
                case 24:
                    return "Collect Rate Schedule";
                default:
                    return "Dependent Limit";
            }
        }(r);
        switch(r){
            case 0:
                return A2(F8n, t, x6n(n));
            case 1:
                return A2(F8n, t, h6n(n));
            case 2:
                return A2(F8n, t, VYn(n));
            case 3:
                return A2(F8n, t, DYn(n));
            case 4:
                return A2(F8n, t, d4n(n));
            case 5:
                return A2(F8n, t, j8n(n));
            case 6:
                return A2(F8n, t, q8n(n));
            case 7:
                return A2(F8n, t, E8n(n));
            case 8:
                return A2(F8n, t, V8n(n));
            case 9:
                return A2(rsn, t, A2(xc, "", A2(Op, oe, Z8n(n))));
            case 10:
                return A2(m2n, t, L8n(n));
            case 11:
                return A2(rsn, t, A2(xc, "", M8n(n)));
            case 12:
                return A2(rsn, t, A2(xc, "", function(n) {
                    return A2(bb, mon, n.lZ);
                }(n)));
            case 13:
                return A2(m2n, t, function(n) {
                    return n.mo;
                }(n));
            case 14:
                return A2(rsn, t, BYn(GYn(n)));
            case 15:
                return A2(F8n, t, X6n(n));
            case 16:
                return A2(m2n, t, G8n(n));
            case 17:
                return A2(m2n, t, function(n) {
                    return n.xb;
                }(n));
            case 18:
                return A2(rsn, t, A2(fe, ", ", w6n(n)));
            case 19:
                return A2(rsn, t, A2(xc, "", T8n(n)));
            case 20:
                return A2(rsn, t, A2(xc, "", S8n(n)));
            case 21:
                return A2(m2n, t, H0n(n));
            case 22:
                return A2(m2n, t, k8n(n));
            case 23:
                return A2(m2n, t, B8n(n));
            case 24:
                return A2(m2n, t, D8n(n));
            default:
                return A2(rsn, t, A2(xc, "", A2(Op, oe, P8n(n))));
        }
    }), H8n = w([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25
    ]), I8n = function(n) {
        return A2(Fu, N8n(n), H8n);
    }, O8n = function(n) {
        return n.ur;
    }, Q8n = function(n) {
        return n.a;
    }, R8n = function(n) {
        return A2(q3n, "Step Count", ve(n));
    }, U8n = function(n) {
        return n.b;
    }, K8n = function(n) {
        return A2(rsn, "Step Index", A2(xc, "", A2(Op, oe, A2(Op, function(n) {
            return n + 1;
        }, A2(Op, U8n, n)))));
    }, W8n = {
        zO: function(n) {
            return n.bi.zO;
        },
        AK: function(n) {
            return n.bi.AK;
        },
        AM: function(n) {
            return n.bi.AM;
        },
        A_: function(n) {
            return n.bi.A_;
        },
        lp: function(n) {
            return n.bi.lp;
        },
        fm: function(n) {
            return n.bi.fm;
        },
        C8: function(n) {
            return n.bi.C8;
        },
        Da: function(n) {
            return n.bi.Da;
        },
        wo: function(n) {
            return n.bi.wo;
        }
    }, X8n = F3(function(n, r, t) {
        return r((function() {
            switch(t){
                case 0:
                    return function(n) {
                        return n.AM;
                    };
                case 1:
                    return function(n) {
                        return n.zO;
                    };
                case 2:
                    return n ? function(n) {
                        return n.C8;
                    } : function(n) {
                        return n.fm;
                    };
                case 3:
                    return function(n) {
                        return n.Da;
                    };
                case 4:
                    return function(n) {
                        return n.A_;
                    };
                case 5:
                    return function(n) {
                        return n.lp;
                    };
                case 6:
                    return function(n) {
                        return n.wo;
                    };
                default:
                    return function(n) {
                        return n.AK;
                    };
            }
        })()(W8n));
    }), Y8n = F3(function(n, r, t) {
        return A3(X8n, n, r, t.ur);
    }), J8n = function(n) {
        var r = A2(fe, ", ", A2(Fu, A2(Y8n, !1, Vx(0)), A2(Fu, Q8n, n)));
        return A2(rsn, "Steps", r);
    }, n5n = function(n) {
        return n.yH;
    }, r5n = function(n) {
        return e1n(A2(no, function(n) {
            return r1n(n) || n5n(n);
        }, n));
    }, t5n = F2(function(n, r) {
        var t, e, u = r5n(r), a = A2(SS, function(r) {
            return i(n, O8n(Q8n(r)));
        }, u);
        return w([
            (t = a, e = A2(xc, "", A2(Op, A2(Y8n, !1, Vx(0)), A2(Op, Q8n, t))), A2(rsn, "Step Name", e)),
            K8n(a),
            R8n(u),
            J8n(u)
        ]);
    }), e5n = F4(function(n, r, t, e) {
        return A2(Jfn, "Signup Page Completed", A2(Qt, A8n(GYn(t)), $(A2(t5n, n, r), $(I8n(t), e))));
    }), u5n = F3(function(n, r, t) {
        return A4(e5n, 1, n, r, w([
            x8n(t.ab),
            A2(rsn, "Insurance Carrier", t.Cp)
        ]));
    }), a5n = F4(function(n, r, t, e) {
        return A2(Jfn, "Signup Page Loaded", A2(Qt, A8n(GYn(t)), $(A2(t5n, n, r), $(I8n(t), e))));
    }), i5n = F3(function(n, r, t) {
        return A4(a5n, 1, n, r, w([
            x8n(t.ab)
        ]));
    }), c5n = function(n) {
        return A2(rsn, "toState", n);
    }, o5n = function(n) {
        return A2(Jfn, "Signup Step Resumed", w([
            esn(i4n),
            c5n(n)
        ]));
    }, f5n = F2(function(n, r) {
        return A2(Jfn, "Signup Step Repeated", w([
            esn(i4n),
            c5n(x_(r)),
            avn(x_(n))
        ]));
    }), s5n = F2(function(n, r) {
        return A2(xc, n, function(n) {
            return n.u8;
        }(r));
    }), l5n = F3(function(n, r, t) {
        return A2(bk, w([
            "attempts",
            t
        ]), A2(bk, w([
            "signup_pages",
            r
        ]), fM(n)));
    }), d5n = F6(function(n, r, t, e, u, a) {
        return A4(Dj, GQ(n), Y4n, a, A2(dM, function(n) {
            return rx(w([
                v("attempt", rx(w([
                    v("zip_ineligible", Yw(n))
                ])))
            ]));
        }(u), pk(A3(l5n, r, t, e))));
    }), v5n = F2(function(n, r) {
        var t = u1n(n);
        return A2(SS, function(n) {
            return i(n.a, r);
        }, t);
    }), b5n = F3(function(n, r, t) {
        return A2(bb, function(r) {
            var e = Q8n(r), u = v(A2(v5n, n, e), A2(v5n, n, t));
            return u.a.$ || u.b.$ ? Ot : It(u.b.a.b - u.a.a.b);
        }, r);
    }), m5n = F3(function(n, r, t) {
        return A3(f8n, n, r, _c(t));
    }), p5n = F4(function(n, r, t, e) {
        var u = A3(b5n, r, A3(m5n, n, r, e), t);
        return !u.$ && u.a >= 0;
    }), $5n = {
        F1: Atn(300),
        Gs: function(n) {
            return {
                $: 7,
                a: n
            };
        }
    }, g5n = function(n) {
        return function(n) {
            return n.sl;
        }(n.f1);
    }, h5n = function(n) {
        return n.jy;
    }, y5n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, w5n = function(n) {
        return n.$ ? nx : rx(w([
            v("id", tx(Own(n.a)))
        ]));
    }, x5n = F2(function(n, r) {
        var t = A2(bb, function(n) {
            return n.$ ? Ot : It(n.a);
        }, n), e = A2(Op, Iwn, t);
        return v("carrier_alias", r ? t.$ ? nx : rx(w([
            v("name", tx(qyn(t.a))),
            v("carrier", w5n(e))
        ])) : nx);
    }), _5n = F3(function(n, r, t) {
        if (r) {
            if (t.$) return nx;
            if (1 === t.a.$) return K_n(n);
            var e = Iwn(t.a.a);
            return UAn(e) ? K_n(n) : nx;
        }
        return nx;
    }), C5n = F3(function(n, r, t) {
        if (r) {
            if (t.$) return nx;
            if (1 === t.a.$) return Yw(n);
            var e = Iwn(t.a.a);
            return gFn(e) ? Yw(n) : nx;
        }
        return nx;
    }), A5n = F3(function(n, r, t) {
        if (r) {
            if (t.$) return nx;
            if (1 === t.a.$) return K_n(n);
            var e = Iwn(t.a.a);
            return KAn(e) ? K_n(n) : nx;
        }
        return nx;
    }), k5n = F3(function(n, r, t) {
        return r ? t.$ ? nx : K_n(1 === t.a.$ ? n : qyn(t.a.a)) : nx;
    }), E5n = function(n) {
        var r = n.ak, t = n.ab, e = n.cd, u = n.bX;
        return rx(w([
            v("group_id", A3(_5n, n.b7, t, r)),
            v("member_id", A3(A5n, e, t, r)),
            v("high_deductible", A3(C5n, n.sf, t, r)),
            A2(x5n, r, t),
            v("payer_name", A3(k5n, u, t, r))
        ]));
    }, q5n = w([
        v("address_city", nx),
        v("address_country", nx),
        v("address_line1", nx),
        v("address_line2", nx),
        v("address_state", nx),
        v("address_zip", nx)
    ]), F5n = F2(function(n, r) {
        return (iL(n) ? cu : Fu(function(r) {
            var t = r.a, e = r.b;
            return v(A2(fe, "_", w([
                DD(n),
                t
            ])), e);
        }))(r);
    }), j5n = F2(function(n, r) {
        return A2(F5n, n, W_n(r));
    }), D5n = function(n) {
        return AAn(n).b;
    }, V5n = F2(function(n, r) {
        var t = function() {
            switch(h4n(n)){
                case 0:
                    var t = r.a0 ? r.m9 : r.nN;
                    return b(It(r.m9), It(t), r.a0 || D5n(r.nN));
                case 1:
                    return b(It(r.a0 ? r.nN : r.m9), It(r.nN), !0);
                case 2:
                    return b(It(r.m9), Ot, !1);
                case 3:
                    return b(Ot, It(r.nN), D5n(r.nN));
                default:
                    return b(Ot, Ot, !1);
            }
        }(), e = t.a, u = t.b, a = t.c, i = A2(xc, A2(F5n, "billing", q5n), A2(Op, j5n("billing"), u)), c = A2(xc, q5n, A2(Op, W_n, e));
        return $(function(n) {
            var r = FM(n.le);
            return w([
                v("health_insurance", E5n(r)),
                v("existing_coverage", Yw(r.ab))
            ]);
        }(r.a8), $(c, $(i, w([
            v("uses_billing_address", Yw(a)),
            v("owner_pays_on_behalf", Yw(!r.q4))
        ]))));
    }), B5n = F5(function(n, r, t, e, u) {
        return A4(Dj, GQ(n), F6n, u, A2(dM, function(n) {
            return rx(w([
                v("online_enrollment", rx(n))
            ]));
        }(e), pk(A2(j6n, r, t))));
    }), G5n = F2(function(n, r) {
        switch(n.$){
            case 9:
                var t = n.a, e = m(r, {
                    iK: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (J = r.gk).$ ? Qp : o5n(J.a), i = function() {
                        var n = r.zO;
                        if (n.$) return r.le;
                        var t, e = n.a, a = A4(p5n, r.mp, r.FN, h5n(u), r.yZ.EX), i = !((t = v(a, !nEn(d4n(r.f2)))).a || !t.b), c = X6n(r.f2), o = FM(r.le), f = a ? o.q4 : !n_n(c) && !o8n(c);
                        return vZ(A6(z4n, i, f, r.dV, r.f2, r.le, e));
                    }(), c = $4n(u), o = w(c ? [
                        I6n,
                        W6n(h5n(u)),
                        H6n
                    ] : [
                        W6n(h5n(u)),
                        H6n
                    ]), f = FM(i), s = A3(i5n, e.FN, e.f2, {
                        ab: aCn(T = f.a8)
                    });
                    return b(m(e, {
                        gk: Ot,
                        hH: c,
                        le: i,
                        jv: It(g5n(u))
                    }), Uu(w([
                        a,
                        s
                    ])), o);
                }
                return b(e, Qp, A2(Ik, 1, t));
            case 2:
                var l = n.a;
                n: for(;;)switch(l.$){
                    case 2:
                        if (9 === l.a.$) return b(m(r, {
                            c7: kc
                        }), Qp, A2(Ik, 1, l));
                        break n;
                    case 3:
                        var d = l.a, p = function() {
                            var n = r.fu;
                            if (2 === n.$) {
                                var t = n.a;
                                return A5(c8n, r.g0, ux(r.dV), a1n(r.mp), t, Q6n);
                            }
                            return Qp;
                        }(), $ = X6n(r.f2), h = !(n_n($) || (l8n($) ? A2(s5n, !1, d) : o8n($) && A2(s5n, !0, d)));
                        return i = A3(cN, E4n, O6n(h), r.le), b(m(r, {
                            zO: It(d),
                            le: i,
                            c7: l
                        }), p, g);
                    default:
                        break n;
                }
                return b(m(r, {
                    c7: l
                }), Qp, A2(Ik, 1, l));
            case 0:
                var y = A2(h8n, !0, r);
                if (e = y.a, y.b) return b(m(e, {
                    wk: !0
                }), function(n) {
                    var r = ux(n.dV), t = FM(n.le), e = n.fu;
                    return 2 === e.$ ? A5(B5n, n.g0, r, e.a, A2(V5n, n.f2, t), y5n) : Qp;
                }(e), g);
                var x = A2(B4n, e.f2, e.le);
                if (x.$) return b(e, Uu(s4n(e.le)), g);
                var _ = A3(Xnn, $5n, x.a, e.c8), C = _.b;
                return b(m(e, {
                    c8: _.a
                }), Uu(A2(Qt, C, s4n(e.le))), g);
            case 1:
                if (l = n.a, e = m(r, {
                    wk: !1
                }), 3 === l.$) {
                    var A = FM(e.le), k = A3(u5n, e.FN, e.f2, {
                        ab: aCn(T = A.a8),
                        Cp: A2(xc, "", tCn(T))
                    });
                    return b(e, k, w([
                        U6n
                    ]));
                }
                return b(e, Qp, A2(Ik, 1, l));
            case 3:
                var E = n.a, q = n.b, F = FM(r.le), j = E ? F.nN : F.m9, D = A2(jAn, q, j), V = D.a, B = D.b, G = D.c, z = E ? N6n(V) : M6n(V), S = (e = m(r, {
                    le: A3(cN, E4n, z, r.le)
                }), A2(xc, v(g, Qp), A2(Op, function(n) {
                    switch(n.$){
                        case 1:
                            return v(w([
                                A3(y8n, e, z, It(n.a))
                            ]), Qp);
                        case 2:
                            if ("Zip" === n.a) {
                                var t = r.jv;
                                if (t.$) return v(g, Qp);
                                var u = t.a;
                                return v(g, A6(d5n, r.g0, ux(r.dV), a1n(r.mp), u, function(n) {
                                    var r = n.cO;
                                    if (r.$) {
                                        var t = r.a, e = function(n) {
                                            return FM(n.le).zF;
                                        }(n);
                                        return A2(xAn, e, t);
                                    }
                                    return !1;
                                }(j), K6n));
                            }
                            return v(g, Qp);
                        default:
                            return v(g, Qp);
                    }
                }, G)));
                return o = S.a, C = S.b, b(e, Uu(w([
                    A2(Wp, T6n(E), B),
                    C
                ])), o);
            case 4:
                q = n.a;
                var T, P = FM(r.le), Z = A2(skn, q, T = P.a8), M = Z.b, L = Z.c, N = R6n(Z.a);
                return e = m(r, {
                    le: A3(cN, E4n, N, r.le)
                }), o = A2(Fu, function(n) {
                    return A3(y8n, e, N, It(n.a));
                }, L), b(e, A2(Wp, g6n, M), o);
            case 5:
                var H = n.a, I = A4(Gtn, l4n, Dtn(b4n), H, r.g7), O = I.b;
                return b(m(r, {
                    g7: I.a
                }), O, g);
            case 6:
                var Q = n.a;
                if (A2(EL, Q, r.A)) {
                    var R = A3(qL, !0, Q, r.A);
                    return b(m(e = A2(h8n, !1, r).a, {
                        A: R
                    }), Qp, g);
                }
                return b(r, Qp, g);
            case 7:
                H = n.a;
                var U = A4(Gtn, $5n, Dtn(p4n), H, r.c8);
                return O = U.b, b(m(r, {
                    c8: U.a
                }), O, g);
            case 8:
                return b(r, MNn(n.a), g);
            case 10:
                var K = A2(xc, Ku, A2(bb, function(n) {
                    return wc(n);
                }, _u(n.a))), W = A2(xc, Ku, wc(r.yZ.EX));
                return b(r, A4(s8n, r.mp, r.FN, W, K) ? A2(f5n, W, K) : Qp, g);
            case 11:
                return b(r, Qp, g);
            case 12:
                var X = rkn(n.a);
                if (X.$) return b(r, Qp, g);
                var Y = O6n(X.a);
                return b(m(r, {
                    le: i = A3(cN, E4n, Y, r.le)
                }), Qp, g);
            default:
                return b(m(r, {
                    le: A3(cN, E4n, L6n(n.a), r.le)
                }), Qp, g);
        }
        var J;
    }), z5n = {
        $: 0
    }, S5n = function(n) {
        return n.m6;
    }, T5n = function(n) {
        return n.m7;
    }, P5n = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), Z5n = P5n, M5n = A2(tE, rE(3), It(4)), L5n = function(n) {
        return n.pe;
    }, N5n = F2(function(n, r) {
        return r.pf(n);
    }), H5n = function(n) {
        return n.pg;
    }, I5n = F3(function(n, r, t) {
        var e = u1n(A2(no, function(n) {
            return r1n(n);
        }, r));
        return A2(bb, function(n) {
            return A2(NR, n.b + 1, e);
        }, A3(m5n, n, r, t));
    }), O5n = YM(F2(function(n) {
        return S0(n);
    })), Q5n = F4(function(n, r, t, e) {
        var u = _8n(r);
        return n(function() {
            var a = v(A3(I5n, r, t, e), u);
            if (a.b) return O5n(H5n);
            if (a.a.$) return L5n;
            var i = Q8n(a.a.a);
            return O5n(N5n(A3(Y8n, u, n, i)));
        }());
    }), R5n = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), U5n = R5n, K5n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, W5n = function(n) {
        return function(n) {
            return {
                $: 6,
                a: n
            };
        }(n);
    }, X5n = F5(function(n, r, t, e, u) {
        var a = FM(t), i = a.m9, c = a.nN, o = a.a0, f = !Cz(u) || !o, s = e ? v(c, n(QCn)) : v(i, n(nAn)), l = s.a, d = s.b;
        return A2(zx, w([
            Gx("mb-6")
        ]), w([
            function() {
                if (u.$) return vE;
                var n = u.a;
                return A2(zx, w([
                    Gx("mt-2 sm:mt-3")
                ]), w([
                    A2(fI, w([
                        eI(o),
                        tI(K5n),
                        rI(r),
                        W5n("addresses-are-the-same-checkbox")
                    ]), w([
                        _d(n)
                    ]))
                ]));
            }(),
            A2(bE, f, A2(i_, w([
                uE(jvn),
                uE(aF)
            ]), w([
                _d(d)
            ]))),
            A2(bE, f, A2(c_, T6n(e), A3(jEn, n, w([
                Jkn(r)
            ]), l)))
        ]));
    }), Y5n = F4(function(n, r, t, e) {
        var u = function() {
            switch(h4n(e)){
                case 0:
                    return v(A5(X5n, n, r, t, 0, Ot), A5(X5n, n, r, t, 1, A3(tu, n, It, RCn)));
                case 1:
                    return v(A5(X5n, n, r, t, 1, Ot), A5(X5n, n, r, t, 0, A3(tu, n, It, rAn)));
                case 2:
                    return v(A5(X5n, n, r, t, 0, Ot), vE);
                case 3:
                    return v(A5(X5n, n, r, t, 1, Ot), vE);
                default:
                    return v(vE, vE);
            }
        }(), a = u.a, i = u.b;
        return A2(zx, w([
            Gx("addresses")
        ]), w([
            a,
            i
        ]));
    }), J5n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, n7n = function(n) {
        return n.q9.qi;
    }, r7n = function(n) {
        return n.q9.q4;
    }, t7n = function(n) {
        return n.q9.ur;
    }, e7n = function(n) {
        return n.q9.Ds;
    }, u7n = F5(function(n, r, t, e, u) {
        var a = FM(t).q4, i = v(l8n(e) || o8n(e), Oj(u));
        return i.a && i.b ? A2(zx, g, w([
            A2(EH, w([
                vH(n(t7n)),
                gH(!0),
                cEn(n(e7n))
            ]), w([
                A2(BE, w([
                    VN(w([
                        Gx("-mx-1")
                    ]))
                ]), w([
                    A2(lE, w([
                        TE(6)
                    ]), w([
                        A2(VX, w([
                            CX,
                            zqn(a),
                            SX(J5n),
                            QX(Pqn(!0)),
                            Sqn(r)
                        ]), w([
                            _d(n(r7n))
                        ]))
                    ])),
                    A2(lE, w([
                        TE(6)
                    ]), w([
                        A2(VX, w([
                            CX,
                            zqn(!a),
                            SX(J5n),
                            QX(Pqn(!1)),
                            Sqn(r)
                        ]), w([
                            _d(n(n7n))
                        ]))
                    ]))
                ]))
            ]))
        ])) : vE;
    }), a7n = function(n) {
        return n.r6;
    }, i7n = F4(function(n, r, t, e) {
        var u = FM(t).a8;
        return C4n(e) ? A2(zx, w([
            Gx("mb-6")
        ]), w([
            A2(i_, w([
                uE(aF)
            ]), w([
                _d(n(a7n))
            ])),
            A2(c_, g6n, A3(FFn, n, r, u))
        ])) : vE;
    }), c7n = function(n) {
        var r = n.wk, t = n.le, e = n.f2, u = Vx(n.ld);
        return A2(zx, w([
            Gx("mx-1 sm:mx-0")
        ]), w([
            A4(Y5n, u, r, t, e),
            A4(i7n, u, r, t, e),
            A5(u7n, u, r, t, X6n(e), n.c7)
        ]));
    }, o7n = A2(tE, rE(2), It(1)), f7n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, s7n = F4(function(n, r, t, e) {
        return A2(yF, w([
            fF,
            Lj(t || r),
            Qj(r),
            cF(e),
            iK,
            f7n("next-step-button"),
            Kj(w([
                Rj("button")
            ]))
        ]), w([
            A2(Mx, g, w([
                _d(n),
                A2(Tq, w([
                    dW,
                    MN(o7n)
                ]), 7)
            ]))
        ]));
    }), l7n = F2(function(n, r) {
        var t = A4(Q5n, n, r.mp, r.FN, r.yZ.EX);
        return w([
            A2(zx, w([
                Gx("flex justify-center w-full")
            ]), w([
                A2(zx, w([
                    Gx("flex-col w-full sm:w-4/5 lg:w-3/5")
                ]), w([
                    A2(CF, w([
                        gW,
                        uE(eE),
                        A2(U5n, 1, M5n),
                        uF(rD),
                        A2(Z5n, 1, xD)
                    ]), w([
                        _8n(r.mp) ? _d(n(O5n(S5n))) : _d(n(O5n(T5n)))
                    ])),
                    c7n(r),
                    A4(s7n, t, r.wk, !1, z5n)
                ]))
            ]))
        ]);
    }), d7n = F2(function(n, r) {
        return {
            g8: function() {
                var t = v(r.c7, r.iK);
                return 2 === t.a.$ ? A2(l7n, n, r) : 1 === t.b.$ ? Nx : A2(l7n, n, r);
            }(),
            yx: ax(r.dV)
        };
    }), v7n = J0n({
        Cl: G6n,
        CQ: z6n,
        Fj: S6n,
        F4: function() {
            return vx(w([
                A2(kj, T6n(0), Oxn),
                A2(kj, T6n(1), Oxn),
                Z6n(P6n)
            ]));
        },
        Gv: G5n,
        GB: d7n
    }), b7n = function(n) {
        return {
            $: 7,
            a: n
        };
    }, m7n = {
        $: 10
    }, p7n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, $7n = function(n) {
        return {
            $: 14,
            a: n
        };
    }, g7n = function(n) {
        return {
            $: 23,
            a: n
        };
    }, h7n = "content-container", y7n = function(n) {
        return {
            $: 15,
            a: n
        };
    }, w7n = function(n) {
        var r = j8n(n);
        return !nEn(r);
    }, x7n = function(n) {
        return m(n, {
            ky: !0
        });
    }, _7n = F6(function(n, r, t, e, u, a) {
        var i = A6(N2, n, r, t, u, Ot, a), c = i.b, o = x7n(i.a);
        return w7n(e) ? v(It(o), A2(Wp, y7n, c)) : v(Ot, Qp);
    }), C7n = F2(function(n, r) {
        return A2(ra, n, r);
    }), A7n = function(n) {
        return A2(C7n, "coupon", n);
    }, k7n = F4(function(n, r, t, e) {
        return {
            ax: v(A2(xc, "", e), !0),
            aa: t,
            ar: r,
            cj: Ot,
            x0: n
        };
    }), E7n = F2(function(n, r) {
        return A2(bk, w([
            "payment_source"
        ]), A2(bk, w([
            r
        ]), A2(bk, w([
            "online_enrollments"
        ]), fM(n))));
    }), q7n = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), J0, e, pk(A2(E7n, r, t)));
    }), F7n = YO("date-picker-input"), j7n = F3(function(n, r, t) {
        return {
            iH: 0,
            aM: !0,
            wP: t,
            fO: r,
            mA: n
        };
    }), D7n = function(n) {
        return n.pn;
    }, V7n = F2(function(n, r) {
        return n + " - " + OK(r);
    }), B7n = F3(function(n, r, t) {
        var e = t, u = A2(V7n, A2(OX, r, e.vN), e.lM), a = n.$ ? u : i(n.a, e.vN) ? A2(V7n, "All upfront", e.lM) : u, c = A2(V7n, A2(OX, r, e.p3), e.wF);
        return i(e.vN, e.p3) ? a : a + " (Equal to " + c + ")";
    }), G7n = function(n) {
        var r = n;
        return A2(OX, Vx(0), r.vN);
    }, z7n = function(n) {
        return Cd({
            sl: "rate-schedule-select",
            Gj: B7n(A2(bb, D7n, n)),
            Gk: function(n) {
                return It(G7n(n));
            }
        });
    }, S7n = function(n) {
        return A2(Yk, "custom_registration_fee_name", n);
    }, T7n = w([
        3,
        0,
        2,
        1,
        4
    ]), P7n = function(n) {
        switch(n){
            case 0:
                return "Prepay Option";
            case 1:
                return "Start Date";
            case 2:
                return "Discount Code";
            case 3:
                return "Payment Source";
            default:
                return "Documents";
        }
    }, Z7n = F4(function(n, r, t, e) {
        var u = GYn(r), a = _8n(u), i = A7n(e.jb), c = Cz(i), o = c ? A2(Nu, cu, Au(m7n)) : Qp, f = A6(_7n, a, t.ld, n, r, t.os, t.g0), s = f.a, l = f.b, d = A3(j0, a, t.g0, ux(n)), b = d.a, m = d.b, p = function() {
            var r = v(V6n(t), t.FN);
            if (3 === r.b.$) {
                if (r.a.$) return v(g, a = r.b.a);
                var e = r.a.a, a = r.b.a;
                return v(w([
                    A5(c8n, t.g0, ux(n), a1n(u), e, $7n),
                    A2(Wp, p7n, m),
                    l,
                    o,
                    A4(q7n, t.g0, ux(n), e, g7n)
                ]), a);
            }
            return v(g, g);
        }(), $ = p.a, h = p.b, y = F7n.b, x = F7n.a;
        return v({
            gk: $6n(t),
            g0: t.g0,
            nX: Ot,
            os: t.os,
            pt: kc,
            hz: Ot,
            hH: t.hH,
            aa: A_,
            ld: t.ld,
            le: vZ(A4(k7n, x, s, b, i)),
            h0: Ot,
            fm: kc,
            u2: A_,
            fu: t.fu,
            aW: A_,
            fw: kc,
            cg: A_,
            dV: n,
            c5: z7n(Ot),
            wk: !1,
            aY: !1,
            fL: Ot,
            cp: Ot,
            js: c,
            ea: !1,
            dd: A3(j7n, Vx(t.ld), h7n, S7n(n)),
            mp: u,
            f2: r,
            FN: h,
            yZ: e,
            A: A2(pZ, T7n, P7n)
        }, Uu(A2(Qt, A2(Wp, b7n, y), $)));
    }), M7n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, L7n = F2(function(n, r) {
        if (i(r.ld, n)) return v(r, Qp);
        var t = r.v;
        if (1 === t.$) {
            var e = t.a;
            return v(m(r, {
                ld: n
            }), A4(B3, n, R3(r.dV), P3(r.dV), e));
        }
        return v(r, Qp);
    }), N7n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    cj: n.a
                });
            case 1:
                return m(r, {
                    x0: n.a
                });
            case 2:
                return m(r, {
                    ax: v(n.b, n.a)
                });
            case 3:
                return m(r, {
                    aa: n.a
                });
            default:
                return m(r, {
                    ar: n.a
                });
        }
    }), H7n = F2(function(n, r) {
        return m(r, {
            le: A3(cN, N7n, n, r.le)
        });
    }), I7n = F2(function(n, r) {
        var t = A2(Ep, n.f9, n.bp), e = FM(r.le).ar, u = function() {
            if (e.$) return v(Ot, Qp);
            var r = e.a;
            return A2(Qhn, Wp(y7n), A2(lx, It, A2(L7n, n.ld, r)));
        }(), a = u.b;
        return v(A2(H7n, M7n(u.a), m(r, {
            os: n.os,
            hz: It(t)
        })), a);
    }), O7n = F2(function(n, r) {
        return r;
    }), Q7n = function(n) {
        return {
            $: 19,
            a: n
        };
    }, R7n = function(n) {
        return {
            $: 18,
            a: n
        };
    }, U7n = function(n) {
        return {
            $: 20,
            a: n
        };
    }, K7n = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), W7n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, X7n = function() {
        return vx(w([
            YXn(W7n),
            Y8(K7n)
        ]));
    }, Y7n = {
        $: 0
    }, J7n = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), nnr = function(n) {
        return {
            $: 12,
            a: n
        };
    }, rnr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, tnr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, enr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, unr = {
        $: 3
    }, anr = function(n) {
        return {
            $: 17,
            a: n
        };
    }, inr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, cnr = function(n) {
        return n.nX;
    }, onr = function(n) {
        return n.je;
    }, fnr = function(n) {
        if (n.$) return Ot;
        var r = n.a, t = lU(hHn(r));
        if (t > 0) {
            var e = onr(r), u = 12 * yHn(r) / t | 0;
            return It(Sp(.02 * (u + e)));
        }
        return Ot;
    }, snr = function(n) {
        return {
            $: 21,
            a: n
        };
    }, lnr = F2(function(n, r) {
        return A2(bk, w([
            "payment_methods"
        ]), A2(bk, w([
            r
        ]), A2(bk, w([
            "online_enrollments"
        ]), fM(n))));
    }), dnr = F5(function(n, r, t, e, u) {
        return A4(lM, GQ(n), J0, u, A2(dM, e, pk(A2(lnr, r, t))));
    }), vnr = F5(function(n, r, t, e, u) {
        return v("payment_method", A5(t2, n, r, t, e, u));
    }), bnr = F5(function(n, r, t, e, u) {
        var a = rx(w([
            A5(vnr, e, !1, !1, Ot, !0)
        ]));
        return A5(dnr, n, r, t, a, u);
    }), mnr = F4(function(n, r, t, e) {
        if (2 === t.$) {
            var u = t.a;
            return A5(bnr, n, ux(r), u, e, snr);
        }
        return Qp;
    }), pnr = F2(function(n, r) {
        return function(t) {
            return n(t) ? w([
                r
            ]) : g;
        };
    }), $nr = F2(function(n, r) {
        return A2(pnr, function(r) {
            return i(n(r), Ot);
        }, r);
    }), gnr = function(n) {
        return n.l7.sT;
    }, hnr = function(n) {
        return n.l7.EC;
    }, ynr = function(n) {
        return n.hK.r$;
    }, wnr = function(n) {
        return n.hK.Cr;
    }, xnr = function(n) {
        return n.hK.sT;
    }, _nr = function(n) {
        return n.ax.b ? g : w([
            v(2, fL(wnr))
        ]);
    }, Cnr = function(n) {
        return d9(n) ? fL(N9) : fL(M9);
    }, Anr = function(n) {
        return A2(s2, function(n) {
            return !H2(n.b);
        }, n.aa);
    }, knr = function(n) {
        return A2(h6, function(n) {
            return v(4, Cnr(n.b));
        }, Anr(n.aa));
    }, Enr = function(n) {
        var r, t = n.v;
        if (1 === t.$) {
            var e = t.b;
            return 1 === e.$ ? (r = w([
                e.a
            ]), A2(Fu, fL, r)) : g;
        }
        return g;
    }, qnr = F2(function(n, r) {
        var t = v(n, r.ar);
        if (3 === t.a.$) return g;
        if (t.b.$) return g;
        var e = mb(Enr(t.b.a));
        return w(e.$ ? [
            v(3, nL(N3))
        ] : [
            v(3, e.a)
        ]);
    }), Fnr = F2(function(n, r) {
        return !A2(pU, r, n);
    }), jnr = function(n) {
        return n.x0;
    }, Dnr = F2(function(n, r) {
        return r.x2(n);
    }), Vnr = F2(function(n, r) {
        var t = r.x0.pS;
        if (t.$) return w([
            v(1, nL(A2(YM, rL, jnr)))
        ]);
        var e = t.a;
        if (n.$) return g;
        var u = n.a, a = A2(SM, sZ("/"), u);
        return A2(Fnr, u, e) ? w([
            v(1, fL(Dnr(a)))
        ]) : g;
    }), Bnr = F4(function(n, r, t, e) {
        var u = _8n(r) ? g : w([
            Vnr(t),
            _nr,
            A2($nr, function(n) {
                return n.cj;
            }, v(0, nL(A2(YM, rL, gnr))))
        ]);
        return XM(A3(az, !n, knr, A3(az, !n, qnr(e), u)));
    }), Gnr = function(n) {
        return n.uk;
    }, znr = F5(function(n, r, t, e, u) {
        var a = 3 === t.$ ? It(Gnr(t.a)) : Ot, i = A2(CL, A4(Bnr, n, r, a, e), u);
        return i.$ ? v(i.a, !1) : v(i.a.a, !0);
    }), Snr = function(n) {
        switch(n.$){
            case 0:
                return It(0);
            case 1:
                return It(1);
            case 2:
                return It(2);
            case 3:
                return It(4);
            default:
                return It(3);
        }
    }, Tnr = F2(function(n, r) {
        var t = Snr(n);
        if (t.$) return r;
        var e = t.a, u = A3(fN, !0, e, r.A), a = m(r, {
            A: u
        });
        return A2(oN, e, u) ? m(a, {
            le: A5(znr, !1, r.mp, r.aW, r.cg, r.le).a
        }) : a;
    }), Pnr = function(n) {
        switch(n.$){
            case 0:
                return P7n(0);
            case 1:
                return P7n(1);
            case 2:
                return P7n(2);
            case 3:
                return P7n(4);
            default:
                return P7n(3);
        }
    }, Znr = F3(function(n, r, t) {
        var e = A2(fe, ": ", w([
            Pnr(r),
            t
        ])), u = FM(n.le).aa, a = A2(bb, cu, A2(Op, function(r) {
            return A2(oN, r, n.A) ? j_n(A2(s2, function(n) {
                return i(i2(n.b), t);
            }, Anr(u))) : Ot;
        }, Snr(r))), c = j_n(A2(s2, function(n) {
            return i(i2(n.b), t);
        }, function(n) {
            return A2(s2, function(n) {
                return d9(n.b);
            }, n.aa);
        }(u)));
        return v(e, A2(Op, Cnr, A2(Y$, a, c)));
    }), Mnr = F3(function(n, r, t) {
        var e = _c(n);
        return d8n(It({
            eZ: A2(xc, g, A2(Op, _K, t)),
            ru: r,
            Fh: e
        }));
    }), Lnr = function(n) {
        var r = A5(znr, !1, n.mp, n.aW, n.cg, n.le), t = r.b;
        return v(m(n, {
            le: r.a
        }), t);
    }, Nnr = F3(function(n, r, t) {
        var e = Lnr(n).a, u = A3(Znr, n, r, t);
        return A3(Mnr, e.yZ.EX, u.a, u.b);
    }), Hnr = function(n) {
        return {
            $: 25,
            a: n
        };
    }, Inr = F4(function(n, r, t, e) {
        return A2(bk, w([
            "passthroughs",
            oe(e)
        ]), A2(bk, w([
            "payment_sources",
            t
        ]), A2(bk, w([
            "online_enrollments",
            r
        ]), fM(n))));
    }), Onr = F6(function(n, r, t, e, u, a) {
        return A4(aA, GQ(n), _2, a, pk(A4(Inr, r, t, e, u)));
    }), Qnr = function(n) {
        return n.sl;
    }, Rnr = function(n) {
        return n.l2;
    }, Unr = function(n) {
        return n.jd;
    }, Knr = function(n) {
        var r = function() {
            var r = v(n.fL, n.nX);
            if (r.a.$) return r.b.$ || 1 !== r.b.a.$ ? Ot : It(Rnr(r.b.a.a));
            var t = r.a.a;
            return It(Unr(t) + onr(t));
        }(), t = b(n.u2, n.cg, r);
        if (3 !== t.a.$ || 3 !== t.b.$ || t.c.$) return Qp;
        var e = t.a.a, u = t.b.a, a = t.c.a;
        return n.os && k2(u) ? A6(Onr, n.g0, ux(n.dV), Qnr(e), D0(u), a, Hnr) : Qp;
    }, Wnr = function(n) {
        return A3(N_, "-", "_", sJ(G7n(n)));
    }, Xnr = F4(function(n, r, t, e) {
        var u = A2(C7n, n, r);
        if (u.$) return Ot;
        var a = u.a;
        return mb(A2(no, function(n) {
            return i(e(n), a);
        }, t));
    }), Ynr = F2(function(n, r) {
        return A4(Xnr, "billing_period", r, n, Wnr);
    }), Jnr = function(n) {
        return n.wc;
    }, nrr = F3(function(n, r, t) {
        var e = Jnr(r), u = A2(Y$, A2(Ynr, e, t), mb(Jnr(r))), a = Gnr(r), i = n.x0;
        return m(n, {
            cj: u,
            x0: A2(QU, Fnr(a), A2(YR, a, i))
        });
    }), rrr = F2(function(n, r) {
        return m(n, {
            aa: A2(vHn, r, n.aa)
        });
    }), trr = F2(function(n, r) {
        return A2(bk, w([
            "coupons",
            r
        ]), fM(n));
    }), err = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), iPn, e, pk(A2(trr, r, t)));
    }), urr = F3(function(n, r, t) {
        return A2(kN, t, sA(A2(va, "practice", r.$ ? n : A3(ia, "hint_membership_id", function(n) {
            return n.sl;
        }(r.a), n))));
    }), arr = F2(function(n, r) {
        if (n.$) return r;
        var t = function(n) {
            return n.wM;
        }(n.a);
        return A3(ia, "referred_token", t, r);
    }), irr = function(n) {
        return A2(Nu, Cu, Cn(function() {
            try {
                Yr.location = n;
            } catch (n) {
                er.location.reload(!1);
            }
        }));
    }, crr = F4(function(n, r, t, e) {
        if (L8n(r)) {
            var u = M8n(r);
            return u.$ ? XB : irr(A3(urr, e.jb, n, u.a));
        }
        var a = a1n(t);
        return A2(__, A2(arr, n, e.jb), Ei({
            xQ: a
        }));
    }), orr = F2(function(n, r) {
        return A2(Jfn, "Form Submission Errored", w([
            esn(n),
            n4n(r)
        ]));
    }), frr = function(n) {
        return A2(orr, i4n, n);
    }, srr = F2(function(n, r) {
        return b(m(r, {
            cp: nE(n) ? Ot : It(f9n(n))
        }), frr(A2(fe, ", ", A2(Fu, Vx(0), n))), g);
    }), lrr = F2(function(n, r) {
        return A2(iH, r, n);
    }), drr = F2(function(n, r) {
        return mb(A2(oN, r, n.A) ? A2(lrr, n.le, r) : g);
    }), vrr = F2(function(n, r) {
        return A2(bb, drr(n), Snr(r));
    }), brr = F2(function(n, r) {
        return A2(fe, ": ", A2(Qt, Pnr(r), n));
    }), mrr = F3(function(n, r, t) {
        var e = A2(brr, t, r), u = Lnr(n).a;
        return A3(Mnr, u.yZ.EX, e, A2(vrr, u, r));
    }), prr = (H8 = i4n, A2(Jfn, "Form Submission Completed", w([
        esn(H8)
    ]))), $rr = F2(function(n, r) {
        var t = A2(drr, r, n);
        if (t.$) return g;
        var e = t.a;
        return w([
            v(P7n(n), e)
        ]);
    }), grr = "discount-code", hrr = "pending-documents", yrr = "payment-source", wrr = "start-date", xrr = F2(function(n, r) {
        return nE(A2(iH, r, n.le)) ? Ot : It(function() {
            switch(r){
                case 0:
                    return "rate-schedule";
                case 1:
                    return wrr;
                case 2:
                    return grr;
                case 3:
                    return yrr;
                default:
                    return hrr;
            }
        }());
    }), _rr = function(n) {
        var r = function(n) {
            var r = A2(n$, xrr(n), T7n), t = mb(r);
            return t.$ ? Qp : MNn(t.a);
        }(n);
        return Uu(A2(Qt, r, function(n) {
            var r = Lnr(n).a;
            return A2(Fu, function(n) {
                var r = n.a;
                return c4n({
                    eZ: w([
                        n.b
                    ]),
                    ru: r
                });
            }, vc(A2(Fu, function(n) {
                switch(n){
                    case 3:
                        return function(n) {
                            var r = FM(n.le).ar;
                            return r.$ ? g : A2(Fu, function(n) {
                                return v("Payment Method", n);
                            }, Enr(r.a));
                        }(r);
                    case 4:
                        return function(n) {
                            var r = FM(n.le).aa, t = rnr(r);
                            return A2(n$, function(n) {
                                var r = n.a;
                                return A2(Op, function(n) {
                                    return v(r, n);
                                }, n.b);
                            }, A2(h6, function(r) {
                                return A3(Znr, n, t, i2(r.b));
                            }, Anr(r)));
                        }(r);
                    default:
                        return A2($rr, n, r);
                }
            }, T7n)));
        }(n)));
    }, Crr = function(n) {
        return A2(su, "dob", n) ? "All Membership members must have date of birth" : n;
    }, Arr = F2(function(n, r) {
        return 4 === r.$ ? r.a.$ ? v(Pnr(r), Ot) : v("Payment", A2(vrr, n, r)) : v(Pnr(r), Ot);
    }), krr = F2(function(n, r) {
        var t = Lnr(n).a, e = A2(Arr, n, r);
        return A3(Mnr, t.yZ.EX, e.a, e.b);
    }), Err = function(n) {
        return n.$ ? Ot : It(n.a);
    }, qrr = function(n) {
        return n.sl;
    }, Frr = function(n) {
        return n.$ ? Ot : It(qrr(n.a));
    }, jrr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Drr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vrr = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments",
            r,
            "confirm"
        ]), fM(n));
    }), Brr = F2(function(n, r) {
        return {
            sl: n,
            wM: r
        };
    }), Grr = A3(nk, "referred_token", M$, A3(nk, "id", M$, au(Brr))), zrr = A2($A, Grr, au(cu)), Srr = function(n) {
        return rx(w([
            v("online_enrollment", n)
        ]));
    }, Trr = F5(function(n, r, t, e, u) {
        return A4(lM, GQ(n), zrr, u, A2(dM, Srr(e), pk(A2(Vrr, r, t))));
    }), Prr = F5(function(n, r, t, e, u) {
        return A4(lM, GQ(n), AKn, u, A2(dM, Srr(e), pk(A2(bk, w([
            "checkout"
        ]), A2(Vrr, r, t)))));
    }), Zrr = F5(function(n, r, t, e, u) {
        return A4(lM, GQ(n), AKn, u, A2(dM, Srr(e), pk(A2(bk, w([
            "sponsor"
        ]), A2(Vrr, r, t)))));
    }), Mrr = F3(function(n, r, t) {
        return k8n(n) ? A2(Qt, v("coupon_code", K_n(r)), t) : t;
    }), Lrr = function(n) {
        return v("period_in_months", n.$ ? nx : NQ(lU(function(n) {
            return n.vN;
        }(n.a))));
    }, Nrr = function(n) {
        var r = n.pS;
        return v("start_date", r.$ ? nx : K_n(NS(r.a)));
    }, Hrr = F2(function(n, r) {
        return {
            sl: n,
            uL: r
        };
    }), Irr = Jm(bJ("_")), Orr = function(n) {
        return 1 === n || 2 === n || 3 === n ? Am(n) : Um("Notification number is invalid.");
    }, Qrr = A2(ym, Orr, SJ), Rrr = A2(Rm, A2(Rm, Am(Hrr), A2(Cm, Irr, HZ("_"))), A2(Cm, Qrr, fp)), Urr = function(n) {
        var r = ux(n.dV), t = C8n(n.mp), e = _8n(n.mp), u = v("google_recaptcha_token", QTn(n.h0)), a = function(n) {
            if (n.$) return v("follow_up_attempt", nx);
            var r = n.a;
            return v("follow_up_attempt", rx(w([
                v("id", tx(r.sl)),
                v("notification_number", NQ(r.uL))
            ])));
        }(function(n) {
            if (n.$) return Yt("Param missing");
            var r = A2($p, Rrr, n.a);
            return r.$ ? Yt("Invalid FollowUp param") : te(r.a);
        }(A2(C7n, "link_source", n.yZ.jb))), i = FM(n.le), c = i.x0, o = i.cj, f = i.ax, s = v("accepted_documents", d2(i.aa)), l = Lrr(o), d = Nrr(c), b = t ? A3(Mrr, n.f2, f.a, w([
            d,
            l,
            s,
            a,
            u
        ])) : w([
            s,
            u
        ]), m = v(n.fu, n.wk);
        if (2 === m.a.$ && m.b) {
            var p = m.a.a;
            return e ? A5(Prr, n.g0, r, p, rx(b), jrr) : t ? A5(Trr, n.g0, r, p, rx(b), Drr) : A5(Zrr, n.g0, r, p, rx(b), jrr);
        }
        return Qp;
    }, Krr = F4(function(n, r, t, e) {
        return A4(FKn, GQ(n), AKn, e, pk(A2(E7n, r, t)));
    }), Wrr = F3(function(n, r, t) {
        return {
            uk: n,
            wc: t,
            x1: r
        };
    }), Xrr = F4(function(n, r, t, e) {
        return {
            p3: e,
            lM: n,
            vN: t,
            wF: r
        };
    }), Yrr = A3(nk, "default_period_in_months", A2(nu, xgn, O$), A3(nk, "period_in_months", A2(nu, xgn, O$), A3(nk, "rate_in_cents_per_default_period", O$, A3(nk, "ongoing_amount_in_cents", O$, au(Xrr))))), Jrr = A2($A, Yrr, au(cu)), ntr = A3(nk, "prepay_options", ek(Jrr), A3(nk, "start_date_editable", ru, A3(nk, "min_start_date", KA, au(Wrr)))), rtr = A2($A, ntr, au(cu)), ttr = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments",
            r,
            "setting"
        ]), fM(n));
    }), etr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), rtr, e, pk(A2(ttr, r, t)));
    }), utr = function(n) {
        return A2(Fu, Zk, A2(Fu, DD, A2(se, ",", n)));
    }, atr = function(n) {
        return m(n, {
            x6: A2(jL, function() {
                return function(n) {
                    return A2(FL, n.dI, !0);
                };
            }, n.x6)
        });
    }, itr = F2(function(n, r) {
        var t = Snr(n);
        if (t.$) return r;
        var e = t.a;
        return A2(EL, e, r.A) ? m(Lnr(r).a, {
            A: A3(qL, !0, e, r.A)
        }) : r;
    }), ctr = function(n) {
        return m(n, {
            cE: !1
        });
    }, otr = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), ftr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    aM: n.a
                }), Qp, Ot);
            case 1:
                return b(r, Qp, It(0));
            case 2:
                return b(r, Qp, It(1));
            case 3:
            case 4:
                return b(r, function(n) {
                    return A2(jc, otr(n), Ck(n));
                }(r.fO), Ot);
            default:
                var t = n.a, e = n.b;
                if (e.$) return b(r, Qp, Ot);
                var u = e.a;
                return i(t, r.fO) ? b(m(r, {
                    iH: A2(Ie, 0, 24 - (u.al.bj - u.eo.bj))
                }), Qp, Ot) : b(r, Qp, Ot);
        }
    }), str = F2(function(n, r) {
        var t = FM(r.le), e = A2(J7n, n, t.ax.a);
        return A2(itr, e, A2(Tnr, e, A2(H7n, e, r)));
    }), ltr = function(n) {
        return {
            $: 24,
            a: n
        };
    }, dtr = function(n) {
        return C8n(n) && !_8n(n);
    }, vtr = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments",
            r,
            "members",
            "min"
        ]), fM(n));
    }), btr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), ek(I4n), e, pk(A2(vtr, r, t)));
    }), mtr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ptr = function(n) {
        return v("plan", n.$ ? nx : TYn(qrr(n.a)));
    }, $tr = F3(function(n, r, t) {
        var e = A2(SS, function(r) {
            return i(r.a, n);
        }, t);
        return e.$ ? v(n, r) : e.a;
    }), gtr = F3(function(n, r, t) {
        var e = n;
        return rx(A2(Qt, A3($tr, "name", K_n(e.ur), r), A2(Qt, A3($tr, "dob", RTn(e.qj), r), A2(Qt, A3($tr, "relationship", OTn(e.wQ), r), A2(Qt, A3($tr, "uses_tobacco", Yw(e.y3), r), t)))));
    }), htr = function(n) {
        return n.wQ;
    }, ytr = function(n) {
        var r = n;
        return r.u8 ? A2(no, function(n) {
            return !HGn(htr(n));
        }, r.fm) : r.fm;
    }, wtr = F2(function(n, r) {
        var t = r.nX;
        if (t.$) return Qp;
        var e = ptr(t.a), u = FM(r.le), a = u.x0, i = u.ax, c = Lrr(u.cj), o = Nrr(a), f = v("members", A2(WU, function(n) {
            return A3(gtr, n, g, w([
                o
            ]));
        }, ytr(n))), s = A3(Mrr, r.f2, i.a, w([
            o,
            c,
            e,
            f
        ])), l = rx(s);
        return function(n) {
            var r = A5(znr, !0, n.mp, n.aW, n.cg, n.le), t = r.b;
            return v(m(n, {
                le: r.a
            }), t);
        }(r).b ? A4(dPn, r.g0, ux(r.dV), l, mtr) : Qp;
    }), xtr = function(n) {
        var r = n.u2;
        if (3 === r.$) {
            var t = r.a;
            return dtr(n.mp) ? A2(wtr, t, n) : n.fm.$ ? Qp : A4(btr, n.g0, ux(n.dV), Qnr(t), ltr);
        }
        return Qp;
    }, _tr = F2(function(n, r) {
        switch(n.$){
            case 14:
                var t = n.a, e = m(r, {
                    u2: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (Hn = e.gk).$ ? Qp : o5n(Hn.a), i = $4n(u), c = w(i ? [
                        W6n(h5n(u)),
                        I6n,
                        H6n
                    ] : [
                        W6n(h5n(u)),
                        H6n
                    ]), o = A7(p1, r.g0, ux(e.dV), Frr(cnr(u)), function(n) {
                        return wmn(n.iO);
                    }(u), function(n) {
                        return A2(Fu, z8n, n.it);
                    }(u), !0, tnr), f = cnr(u), s = _8n(r.mp) ? v(Qp, kc) : v(A4(etr, r.g0, ux(r.dV), Qnr(u), enr), A_), l = s.a, d = s.b;
                    return b(h = m(e, {
                        gk: Ot,
                        nX: It(f),
                        hH: i,
                        aW: d,
                        c5: z7n(Err(f))
                    }), Uu(w([
                        l,
                        a,
                        o,
                        A4(a5n, 7, h.FN, h.f2, g),
                        Knr(h)
                    ])), c);
                }
                return b(e, Qp, A2(Ik, 1, t));
            case 19:
                var p = n.a, h = p.$ ? r : m(r, {
                    h0: It(p.a)
                });
                return r.hH ? b(h, A4(crr, Ot, r.f2, r.mp, r.yZ), w([
                    unr
                ])) : b(h, Urr(h), g);
            case 0:
                if (r.hH) return b(r, A4(crr, Ot, r.f2, r.mp, r.yZ), w([
                    unr
                ]));
                var y = FM(r.le), x = M7n(Bn = y.ar);
                if (h = function(n) {
                    return m(n, {
                        A: atr(n.A)
                    });
                }(A2(itr, x, A2(Tnr, x, A2(H7n, x, m(r, {
                    wk: !0,
                    cp: Ot,
                    ea: !0
                }))))), 1 === Bn.$) {
                    var _ = Lnr(h), C = _.a;
                    return (rn = _.b) ? b(C, d2n(0), g) : b(m(C, {
                        wk: !1
                    }), _rr(C), g);
                }
                if (Oj(r.cg)) {
                    var A = Lnr(h);
                    return C = A.a, (rn = A.b) ? b(C, d2n(0), g) : b(Sn = m(C, {
                        wk: !1
                    }), _rr(Sn), g);
                }
                return b(h, A2(Wp, y7n, V2), g);
            case 1:
                var k = n.a;
                h = m(r, {
                    wk: !1,
                    aY: !1,
                    ea: !1
                });
                n: for(;;)switch(k.$){
                    case 3:
                        var E = k.a, q = w([
                            d8n(Ot),
                            unr
                        ]);
                        return b(h, Uu(w([
                            A4(crr, It(E), r.f2, r.mp, r.yZ),
                            prr,
                            A4(e5n, 7, r.FN, r.f2, g)
                        ])), q);
                    case 2:
                        if (5 === k.a.$) return A2(srr, utr(Mn = k.a.b), h);
                        break n;
                    default:
                        break n;
                }
                return b(h, Qp, A2(Ik, 1, k));
            case 2:
                k = n.a, h = m(r, {
                    wk: !1,
                    aY: !1,
                    ea: !1
                });
                n: for(;;)switch(k.$){
                    case 3:
                        return c = w([
                            d8n(Ot),
                            unr
                        ]), b(h, Uu(w([
                            A4(crr, Ot, r.f2, r.mp, r.yZ),
                            prr
                        ])), c);
                    case 2:
                        if (5 === k.a.$) return A2(srr, utr(Mn = k.a.b), h);
                        break n;
                    default:
                        break n;
                }
                return b(h, Qp, A2(Ik, 1, k));
            case 3:
                var F = n.a, j = (h = m(r, {
                    aa: F
                }), FM(h.le));
                return 3 === F.$ ? b(m(h, {
                    le: vZ(A2(rrr, j, F.a))
                }), Qp, g) : b(h, Qp, A2(Ik, 1, F));
            case 4:
                var D = n.a;
                n: for(;;)switch(D.$){
                    case 3:
                        h = m(r, {
                            fL: It(D.a)
                        });
                        var V = Knr(h);
                        return b(h, V, g);
                    case 2:
                        if (5 === D.a.$) {
                            var B = It(f9n(w([
                                Zk(Crr(Mn = D.a.b))
                            ])));
                            return b(m(r, {
                                cp: B
                            }), frr(Mn), A2(Ik, 1, D));
                        }
                        break n;
                    default:
                        break n;
                }
                return b(r, Qp, A2(Ik, 1, D));
            case 5:
                var G = n.a, z = m(r, {
                    aW: G
                }), S = d8n(Ot);
                return 3 === G.$ ? (d = G.a, 2 === r.fu.$ ? (j = FM(z.le), b(h = m(z, {
                    le: vZ(A3(nrr, j, d, z.yZ.jb))
                }), xtr(h), g)) : b(z, Qp, g)) : b(z, Qp, A2(Qt, S, A2(Ik, 1, G)));
            case 6:
                return b(A2(Tnr, on = n.a, A2(H7n, on, r)), Qp, g);
            case 8:
                var T = A2(dG, n.a, r.c5), P = T.a, Z = T.b, M = T.c;
                if (M.$ || M.a.$) return b(m(r, {
                    c5: P
                }), A2(Wp, inr, Z), g);
                var L = M.a.a, N = 1 === (Nn = A2(Op, G7n, L)).$ ? g : w([
                    Nn.a
                ]), H = function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(L), I = (h = A2(itr, H, A2(Tnr, H, A2(H7n, H, m(r, {
                    c5: P
                })))), A3(mrr, h, H, N));
                return b(h, Uu(w([
                    A2(Wp, inr, Z),
                    xtr(h)
                ])), w([
                    I
                ]));
            case 7:
                var O = n.a, Q = FM(r.le).x0, R = A2(zU, O, Q), U = R.a, K = R.c, W = A2(Wp, b7n, R.b), X = function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(function() {
                    if (K.$ || 2 !== K.a.$) return U;
                    var n = K.a.a;
                    return A2(QU, Fnr(n), A2(YR, n, U));
                }()), Y = (h = A2(H7n, X, r), function() {
                    n: for(; !K.$;)switch(K.a.$){
                        case 0:
                            return b(A2(itr, X, A2(Tnr, X, h)), g, xtr(h));
                        case 1:
                            return b(h, w([
                                A3(mrr, h, X, g)
                            ]), Qp);
                        default:
                            break n;
                    }
                    var n = Cz(Q.pS) ? g : w([
                        A3(mrr, h, X, g)
                    ]);
                    return b(h, n, Qp);
                }());
                return q = Y.b, b(C = Y.a, Uu(w([
                    W,
                    Y.c
                ])), q);
            case 9:
                h = m(r, {
                    js: !0
                });
                var J = FM(r.le);
                return b(h, Qp, w([
                    A3(mrr, r, on = A2(J7n, (un = J.ax).b, un.a), w([
                        "Show"
                    ]))
                ]));
            case 10:
                var nn = (un = FM(r.le).ax).a, rn = un.b, tn = (h = (iL(nn) ? str(!0) : str(rn))(m(r, {
                    pt: kc
                })), iL(nn) ? xtr(h) : A4(err, r.g0, ux(r.dV), nn, nnr));
                return b(h, tn, w([
                    A3(mrr, h, on = A2(J7n, un.b, un.a), g)
                ]));
            case 11:
                var en = FM(r.le);
                return b(r, Qp, w([
                    A3(mrr, r, on = A2(J7n, (un = en.ax).b, un.a), g)
                ]));
            case 12:
                var un, an = n.a, cn = (h = m(r, {
                    pt: an
                }), FM(r.le)), on = A2(J7n, (un = cn.ax).b, un.a);
                switch(an.$){
                    case 3:
                        return b(fn = A2(str, !0, h), xtr(fn), w([
                            A3(mrr, fn, on, g)
                        ]));
                    case 2:
                        switch(an.a.$){
                            case 5:
                                return b(fn = A2(str, !1, h), Qp, w([
                                    A3(mrr, fn, on, g)
                                ]));
                            case 9:
                                var fn;
                                return b(fn = A2(str, !1, h), Qp, w([
                                    A3(mrr, fn, on, g)
                                ]));
                            default:
                                return b(m(r, {
                                    pt: kc
                                }), Qp, A2(Ik, 1, an));
                        }
                    default:
                        return b(h, Qp, A2(Ik, 1, an));
                }
            case 13:
                var sn = n.a, ln = FM(r.le), dn = A2(r6, sn, ln.aa), vn = (o = dn.b, dn.c), bn = rnr(dn.a), mn = A2(xc, v(h = A2(H7n, bn, r), g), A2(Op, function(n) {
                    switch(n.$){
                        case 1:
                        case 2:
                            return v(h, w([
                                A3(Nnr, h, bn, i2(r = n.a.b))
                            ]));
                        case 0:
                            var r = n.a.b, t = A2(itr, bn, A2(Tnr, bn, h));
                            return v(t, w([
                                A3(Nnr, t, bn, i2(r))
                            ]));
                        case 3:
                            return v(h, g);
                        default:
                            return v(h, n.a);
                    }
                }, vn));
                return q = mn.b, b(C = mn.a, yn = A2(xc, A2(Wp, p7n, o), A2(Op, function(n) {
                    if (3 === n.$) {
                        var r = A3(Znr, h, bn, i2(n.a.b)), t = r.a;
                        return Uu(w([
                            c4n({
                                eZ: A2(xc, g, A2(Op, _K, r.b)),
                                ru: t
                            }),
                            A2(Wp, p7n, o)
                        ]));
                    }
                    return A2(Wp, p7n, o);
                }, vn)), q);
            case 15:
                if (sn = n.a, (Bn = FM(r.le).ar).$) return b(r, Qp, g);
                var pn = A2(X3, sn, Bn.a), $n = pn.b, gn = pn.c, hn = (x = M7n(It(pn.a)), A2(H7n, x, r)), yn = w([
                    A2(Wp, y7n, $n)
                ]);
                if (gn.$) return b(h = A2(Tnr, x, hn), Uu(yn), w([
                    A2(krr, h, x)
                ]));
                switch(gn.a.$){
                    case 2:
                        return b(m(hn, {
                            aY: !0
                        }), Uu(yn), g);
                    case 1:
                        return b(hn, Uu(A2(Qt, A4(mnr, r.g0, r.dV, r.fu, gn.a.a), yn)), w([
                            A2(krr, hn, x)
                        ]));
                    default:
                        return h = A2(srr, w([
                            gn.a.a
                        ]), A2(itr, x, A2(Tnr, x, m(hn, {
                            wk: !1,
                            aY: !1
                        }))));
                }
            case 16:
                var wn = n.a, xn = function() {
                    if (wn) return b(Ot, Qp, "Skip Payment");
                    var n = _8n(r.mp), t = A6(N2, n, r.ld, r.dV, r.os, fnr(r.fL), r.g0), e = t.b, u = x7n(t.a), a = A2(Wp, y7n, e);
                    return b(It(u), a, "Payment Method");
                }(), _n = ($n = xn.b, xn.c);
                return x = M7n(xn.a), b(h = A2(H7n, x, r), $n, w([
                    A3(mrr, h, x, w([
                        _n
                    ]))
                ]));
            case 17:
                var Cn = n.a;
                h = m(r, {
                    fw: kc,
                    cg: kc,
                    aY: !1
                });
                n: for(;;)switch(Cn.$){
                    case 3:
                        var An = _8n(r.mp), kn = A6(_7n, An, r.ld, r.dV, r.f2, r.os, r.g0);
                        return tn = kn.b, x = M7n(Bn = kn.a), b(hn = A2(H7n, x, h), tn, A2(Ik, 1, Cn));
                    case 2:
                        if (5 === Cn.a.$) return A2(srr, utr(Mn = Cn.a.b), h);
                        break n;
                    default:
                        break n;
                }
                return b(h, Qp, A2(Ik, 1, Cn));
            case 18:
                var En = A2(ftr, sn = n.a, r.dd), qn = En.a, Fn = En.b, jn = En.c;
                return tn = jn.$ || jn.a ? Qp : A2(Nu, cu, Au(Y7n)), b(m(r, {
                    dd: qn
                }), Uu(w([
                    A2(Wp, R7n, Fn),
                    tn
                ])), g);
            case 20:
                var Dn = A2(xc, Ku, A2(bb, function(n) {
                    return wc(n);
                }, _u(n.a))), Vn = A2(xc, Ku, wc(r.yZ.EX));
                return b(r, A4(s8n, r.mp, r.FN, Vn, Dn) ? A2(f5n, Vn, Dn) : Qp, g);
            case 21:
                h = m(r, {
                    cg: Cn = n.a
                });
                n: for(;;)switch(Cn.$){
                    case 3:
                        V = Knr(h);
                        var Bn, Gn = FM(r.le), zn = (x = M7n(A2(bb, function(n) {
                            return It(ctr(n));
                        }, Bn = Gn.ar)), Lnr(A2(H7n, x, h)));
                        if (C = zn.a, (rn = zn.b) && r.wk) return b(m(C, {
                            cp: Ot
                        }), Uu(w([
                            d2n(0),
                            V
                        ])), g);
                        var Sn = m(h, {
                            wk: !1,
                            aY: !1
                        });
                        return b(m(Sn, {
                            cp: Ot
                        }), V, g);
                    case 2:
                        if (5 === Cn.a.$) return A2(srr, utr(Mn = Cn.a.b), m(h, {
                            wk: !1,
                            aY: !1
                        }));
                        break n;
                    default:
                        break n;
                }
                return b(m(h, {
                    wk: !1,
                    aY: !1
                }), Qp, A2(Ik, 1, Cn));
            case 22:
                var Tn = v(r.cg, r.fu);
                if (3 === Tn.a.$ && 2 === Tn.b.$) {
                    var Pn = Tn.b.a;
                    return b(m(r, {
                        aY: !0
                    }), A4(Krr, r.g0, ux(r.dV), Pn, anr), g);
                }
                return b(r, Qp, g);
            case 23:
                switch((Cn = n.a).$){
                    case 3:
                        var Zn = function() {
                            var n = _8n(r.mp), t = A6(N2, n, r.ld, r.dV, r.os, fnr(r.fL), r.g0), e = t.b, u = x7n(t.a);
                            return v(It(u), A2(Wp, y7n, e));
                        }();
                        return $n = Zn.b, b(h = A2(H7n, M7n(Zn.a), m(r, {
                            cg: Cn
                        })), Uu(w([
                            $n,
                            Knr(h)
                        ])), g);
                    case 2:
                        switch(Cn.a.$){
                            case 9:
                                return b(m(r, {
                                    cg: kc
                                }), Qp, g);
                            case 5:
                                var Mn = Cn.a.b;
                                return h = m(r, {
                                    cg: kc
                                }), A2(srr, utr(Mn), h);
                            default:
                                var Ln = Cn.a;
                                return b(m(r, {
                                    cg: kc
                                }), Qp, $(g9(Cn), w([
                                    Nk(Ln)
                                ])));
                        }
                    default:
                        return b(m(r, {
                            cg: kc
                        }), Qp, A2(Ik, 1, Cn));
                }
            case 24:
                return b(m(r, {
                    fm: n.a
                }), Qp, g);
            default:
                return b(m(r, {
                    fw: n.a
                }), Qp, g);
        }
        var Nn, Hn;
    }), Ctr = F2(function(n, r) {
        var t = FM(r.le).aa;
        return A2(zx, w([
            DF(hrr),
            Gx("mx-1")
        ]), w([
            A2(c_, p7n, A3(e4, n, w([
                m6(r.wk),
                p6(r.ea)
            ]), t))
        ]));
    }), Atr = F4(function(n, r, t, e) {
        return w7n(e) ? A2(zx, g, w([
            s_,
            A3(fWn, n, r, ax(t))
        ])) : vE;
    }), ktr = F2(function(n, r) {
        if (3 === r.$) {
            var t = A2(xc, "", A2(Op, function(n) {
                return " (" + sJ(n) + ")";
            }, function(n) {
                return n.$ ? Ot : n.a.rS;
            }(r.a)));
            return $(n(L3), t);
        }
        return n(L3);
    }), Etr = function(n) {
        return n.cg;
    }, qtr = function(n) {
        return n.AK.mW;
    }, Ftr = function(n) {
        return n.AK.oo;
    }, jtr = function(n) {
        return n.AK.pC;
    }, Dtr = function(n) {
        return n.AK.pD;
    }, Vtr = function(n) {
        return n.AK.xs;
    }, Btr = function(n) {
        var r = j8n(n);
        return Yzn(r);
    }, Gtr = function(n) {
        return {
            $: 16,
            a: n
        };
    }, ztr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Str = F5(function(n, r, t, e, u) {
        if (t) return A2(VX, w([
            CX,
            QX("skip"),
            zqn(OS(r)),
            SX(wm(Gtr(1))),
            Sqn(e),
            ztr(w([
                Gx("h-full")
            ]))
        ]), w([
            _d(n(qtr))
        ]));
        var a = n(u ? Dtr : jtr);
        return A2(VX, w([
            CX,
            QX("card"),
            zqn(Cz(r)),
            SX(wm(Gtr(0))),
            Sqn(e),
            ztr(w([
                Gx("h-full")
            ]))
        ]), w([
            _d(a)
        ]));
    }), Ttr = F6(function(n, r, t, e, u, a) {
        return A2(BE, w([
            VN(w([
                Gx("px-1")
            ]))
        ]), A2(Fu, function(e) {
            return A2(lE, w([
                cmn(r),
                VN(w([
                    Gx("column--topSpaceMd")
                ]))
            ]), w([
                A5(Str, n, t, e, u, a)
            ]));
        }, e));
    }), Ptr = F7(function(n, r, t, e, u, a, i) {
        var c, o = Btr(t) && !_8n(e), f = (c = v(Nmn(u) || Hmn(u), o)).a && c.b ? v(w([
            0,
            1
        ]), 4) : v(g, 12), s = f.a, l = f.b;
        if (!ve(s)) return vE;
        switch(r.$){
            case 3:
            case 1:
                return vE;
            default:
                var d = Nmn(u);
                return A2(EH, w([
                    vH(n(Vtr))
                ]), w([
                    A6(Ttr, n, l, a, s, i, d)
                ]));
        }
    }), Ztr = {
        $: 22
    }, Mtr = F3(function(n, r, t) {
        return A2(BE, w([
            VN(w([
                Gx("px-1")
            ]))
        ]), w([
            A2(lE, w([
                TE(6)
            ]), w([
                A2(PE, w([
                    sE
                ]), w([
                    _d(A2(T0, n, r))
                ]))
            ])),
            A2(lE, w([
                TE(6),
                cE(omn)
            ]), w([
                A2(bE, !t, A2(yF, w([
                    j6,
                    cF(Ztr)
                ]), w([
                    _d(n(Ftr))
                ])))
            ]))
        ]));
    }), Ltr = F4(function(n, r, t, e) {
        switch(t.$){
            case 3:
                return A3(Mtr, n, t.a, e);
            case 1:
                return A2(zx, g, Nx);
            default:
                return function(n) {
                    var r = FM(n).ar;
                    return A2(zx, w([
                        DF(yrr)
                    ]), function() {
                        if (r.$) return g;
                        var n = r.a;
                        return A2(Fu, c_(y7n), D4(n));
                    }());
                }(r);
        }
    }), Ntr = F2(function(n, r) {
        if (w7n(r.f2)) {
            var t = FM(r.le).ar;
            return A2(zx, g, w([
                A2(i_, w([
                    uE(aF)
                ]), w([
                    _d(n(Etr))
                ])),
                A7(Ptr, n, r.cg, r.f2, r.mp, r.dV, t, r.wk),
                t.$ ? vE : A2(f_, w([
                    uE(Jq)
                ]), w([
                    A2(xX, g, w([
                        _d(A2(ktr, n, r.cg))
                    ]))
                ])),
                A4(Ltr, n, r.le, r.cg, r.wk)
            ]));
        }
        return vE;
    }), Htr = function(n) {
        return n.vG;
    }, Itr = {
        $: 9
    }, Otr = {
        $: 11
    }, Qtr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Rtr = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), Utr = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), Ktr = function(n) {
        return n.qd;
    }, Wtr = function(n) {
        return n.qF;
    }, Xtr = function(n) {
        return function(n) {
            var r = Ktr(n);
            return r.$ ? OK(r.a) : jF(r.a) + "%";
        }(n) + " off " + (function(n) {
            var r = Wtr(n);
            switch(r.$){
                case 0:
                    return "for unlimited time";
                case 1:
                    return "for one month";
                default:
                    return "for " + oe(r.a) + " months";
            }
        }(n) + function(n) {
            var r = v(Ktr(n), function(n) {
                return n.g1;
            }(n));
            return 1 === r.a.$ && r.b ? " on each member" : "";
        }(n));
    }, Ytr = function(n) {
        if (3 === n.$) {
            var r = n.a;
            return A2(PE, w([
                nF,
                VG
            ]), w([
                _d(Xtr(r))
            ]));
        }
        return _d("");
    }, Jtr = F2(function(n, r) {
        var t, e = FM(r.le).ax, u = e.a, a = e.b;
        return A2(zx, w([
            Gx("mb-4 md:mb-6"),
            DF(grr)
        ]), w([
            A2(EH, w([
                vH(n(xnr))
            ]), w([
                PI(w([
                    OI(u),
                    HI(A2(qc, Qtr, J7n(a))),
                    yI(A3(Utr, r.le, r.A, 2)),
                    pI(r.wk || (t = r.yZ, Cz(A7n(t.jb)))),
                    _I(m7n),
                    CI(Otr)
                ])),
                A2(YH, n, A3(Rtr, r.le, r.A, 2)),
                Ytr(r.pt)
            ]))
        ]));
    }), ner = F2(function(n, r) {
        return k8n(r.f2) ? r.js ? A2(Jtr, n, r) : A2(zx, w([
            Gx("mb-4 md:mb-6 -mt-2 md:-mt-4")
        ]), w([
            A2(yF, w([
                j6,
                cF(Itr)
            ]), w([
                _d(n(ynr))
            ]))
        ])) : vE;
    }), rer = F2(function(n, r) {
        if (3 === n.$) {
            var t = Jnr(n.a);
            return Cz(A2(Ynr, t, r));
        }
        return !1;
    }), ter = F2(function(n, r) {
        var t, e = 3 === (t = r.aW).$ ? Jnr(t.a) : g, u = D8n(r.f2), a = FM(r.le).cj;
        return nE(e) || !u ? vE : A2(zx, w([
            Gx("mb-4 md:mb-6")
        ]), w([
            A2(EH, w([
                vH(n(gnr)),
                gH(!0)
            ]), w([
                A2(c_, inr, A4(qz, n, w([
                    XG(a),
                    HG(n(hnr)),
                    SG,
                    CO(r.wk || A2(rer, r.aW, r.yZ.jb)),
                    HEn(A3(Utr, r.le, r.A, 0))
                ]), A2(Fu, function(n) {
                    return A2(MG, g, n);
                }, e), r.c5))
            ])),
            A2(YH, n, A3(Rtr, r.le, r.A, 0))
        ]));
    }), eer = cu, uer = function(n) {
        return n.Db.sT;
    }, aer = F2(function(n, r) {
        return r.po(n);
    }), ier = F2(function(n, r) {
        return r.pq(n);
    }), cer = F3(function(n, r, t) {
        var e = A2(SM, sZ("/"), t);
        return function(n) {
            return 1 === n;
        }(r) ? A2(PE, w([
            nF,
            VG
        ]), w([
            _d(n(aer(e)))
        ])) : A2(PE, w([
            nF,
            VG
        ]), w([
            _d(n(ier(e)))
        ]));
    }), oer = F3(function(n, r, t) {
        var e = v(r, t);
        if (e.a.$ || e.b.$) return vE;
        var u = e.a.a, a = e.b.a, i = b(function(n) {
            return n.pk;
        }(u), function(n) {
            return n.pr;
        }(u), function(n) {
            return n.pl;
        }(a));
        return !i.a || i.b.$ || i.c.$ ? vE : A3(cer, n, i.b.a, i.c.a);
    }), fer = F3(function(n, r, t) {
        var e = FM(t.le).x0;
        return A2(zx, w([
            Gx("mb-4 md:mb-6"),
            DF(wrr)
        ]), w([
            A2(EH, w([
                vH(n(uer)),
                gH(!0)
            ]), w([
                A2(c_, b7n, A2(JY, w([
                    eer(r)
                ]), e)),
                A3(oer, n, A2(bb, Err, t.nX), t.fL),
                A2(YH, n, A3(Rtr, t.le, t.A, 1))
            ]))
        ]));
    }), ser = F2(function(n, r) {
        if (B8n(r.f2)) {
            var t = r.aW;
            return 3 === t.$ ? A3(fer, n, r.wk || !function(n) {
                return n.x1;
            }(t.a), r) : vE;
        }
        return vE;
    }), ler = F2(function(n, r) {
        var t;
        return D8n(t = r.f2) || k8n(t) || B8n(t) ? A2(BE, w([
            VN(w([
                Gx("px-1"),
                Gx("-my-1")
            ]))
        ]), w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(i_, w([
                    uE(aF)
                ]), w([
                    _d(n(Htr))
                ])),
                A2(ter, n, r),
                A2(ner, n, r),
                A2(ser, n, r)
            ]))
        ])) : vE;
    }), der = F2(function(n, r) {
        var t = _8n(r.mp);
        return A2(zx, w([
            DF(h7n)
        ]), w([
            A2(Ntr, n, r),
            A2(ler, n, r),
            A2(Ctr, n, r),
            A4(Atr, t, n, r.dV, r.f2)
        ]));
    }), ver = F2(function(n, r) {
        return A2(Qt, function(n) {
            return {
                $: 12,
                a: n
            };
        }(n), r);
    }), ber = function(n) {
        var r = n.cg;
        if (3 === r.$) {
            var t = v(k2(r.a), JF(n.fw));
            return !t.a || !t.b.$;
        }
        return !1;
    }, mer = function(n) {
        return n.ng;
    }, per = function(n) {
        return n.ur;
    }, $er = function(n) {
        return A2(Fu, function(n) {
            return function(n) {
                return {
                    ng: mer(n),
                    ll: HGn(htr(n)),
                    ur: per(n)
                };
            }(n);
        }, n);
    }, ger = function(n) {
        return 3 === n.$ ? n.a : g;
    }, her = F2(function(n, r) {
        return A2(Qt, function(n) {
            return {
                $: 10,
                a: n
            };
        }(n), r);
    }), yer = F2(function(n, r) {
        return A2(Qt, function(n) {
            return {
                $: 1,
                a: n
            };
        }(n), r);
    }), wer = F2(function(n, r) {
        return n.$ ? r : A2(Qt, function(n) {
            return {
                $: 6,
                a: n
            };
        }(n.a), r);
    }), xer = function(n) {
        return {
            $: 5,
            a: n
        };
    }, _er = F2(function(n, r) {
        return A2(Qt, xer(function(n) {
            return {
                $: 1,
                a: n
            };
        }(n)), r);
    }), Cer = F2(function(n, r) {
        return A2(Qt, function(n) {
            return {
                $: 11,
                a: n
            };
        }(n), r);
    }), Aer = F2(function(n, r) {
        return A2(Qt, function(n) {
            return {
                $: 0,
                a: n
            };
        }(n), r);
    }), ker = F2(function(n, r) {
        return n.$ ? r : A2(Qt, function(n) {
            return {
                $: 9,
                a: n
            };
        }(n.a), r);
    }), Eer = F2(function(n, r) {
        return n.$ ? r : A2(Qt, xer(function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a)), r);
    }), qer = F2(function(n, r) {
        return A2(Qt, function(n) {
            return {
                $: 7,
                a: n
            };
        }(n), r);
    }), Fer = F2(function(n, r) {
        var t = function() {
            var n = b(r.fw, r.os, function(n) {
                var r, t = 3 === (r = n.cg).$ && k2(r.a), e = FM(n.le).ar, u = !e.$ && function(n) {
                    return 1 === n.d7;
                }(e.a);
                return u || t;
            }(r));
            return !(3 !== n.a.$ || !n.b || !n.c) && M4(n.a.a) > 0;
        }();
        return A2(ver, function(n) {
            return n.wb;
        }(r.f2), A2(Cer, JF(r.fw), A3(Ze, her, t, (C8n(r.mp) ? Eer(r.fL) : _er($er(ger(r.fm))))(A2(yer, r.wk || function(n) {
            if (n.os) {
                if (t = j8n(n.f2), nEn(t)) return !1;
                if (Btr(n.f2)) {
                    var r = FM(n.le);
                    return !!Cz(r.ar) && !ber(n);
                }
                return !ber(n);
            }
            var t;
            return !1;
        }(r), A2(qer, !0, A2(wer, r.cp, A2(ker, r.nX, A2(Aer, n(nhn), g)))))))));
    }), jer = {
        nX: Ot,
        ds: Ot,
        hu: !1,
        hw: {
            $: 2
        },
        Bb: !1,
        rc: Ot,
        CR: !1,
        Df: !1,
        fw: Ot,
        ja: "Continue to next step",
        jl: Ot,
        jr: !1,
        kv: !1
    }, Der = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    ja: n.a
                });
            case 1:
                return m(r, {
                    Bb: n.a
                });
            case 2:
                return m(r, {
                    CR: n.a
                });
            case 3:
                return m(r, {
                    ds: It(n.a)
                });
            case 4:
                return m(r, {
                    jl: It(n.a)
                });
            case 9:
                return m(r, {
                    nX: It(n.a)
                });
            case 5:
                return m(r, {
                    hw: n.a
                });
            case 6:
                return m(r, {
                    rc: It(n.a)
                });
            case 7:
                return m(r, {
                    kv: n.a
                });
            case 8:
                return m(r, {
                    Df: n.a
                });
            case 10:
                return m(r, {
                    jr: n.a
                });
            case 11:
                return m(r, {
                    fw: n.a
                });
            default:
                return m(r, {
                    hu: n.a
                });
        }
    }), Ver = {
        $: 1
    }, Ber = {
        $: 2
    }, Ger = F4(function(n, r, t, e) {
        return A2(yF, w([
            CD,
            Lj(t || r),
            Qj(r),
            cF(e),
            Kj(w([
                Gx("w-full mb-2")
            ]))
        ]), w([
            A2(Mx, g, w([
                _d(n)
            ]))
        ]));
    }), zer = function(n) {
        var r;
        return A2(zx, g, w([
            function() {
                var r = n.ds;
                if (r.$) return vE;
                var t = r.a;
                return A2(f_, w([
                    nF,
                    uF(xD),
                    uE(aF)
                ]), w([
                    _d(t)
                ]));
            }(),
            (r = n.jl, r.$ ? vE : A2(zx, g, w([
                A4(Ger, r.a, n.CR, n.Bb, Ber)
            ]))),
            A2(zx, g, w([
                A4(s7n, n.ja, n.CR, n.Bb, Ver)
            ]))
        ]));
    }, Ser = F3(function(n, r, t) {
        return 1 === t.$ ? n : r(t.a);
    }), Ter = function(n) {
        return n.ur;
    }, Per = F3(function(n, r, t) {
        var e = Rnr(t), u = A2(xc, 0, A2(Op, M4, r)), a = e + u;
        return A2(zx, w([
            Gx("quote-info")
        ]), w([
            A2(zx, w([
                Gx("w-full text-center")
            ]), w([
                A2(zx, w([
                    Gx("hidden md:inline-flex md:flex-col")
                ]), w([
                    A2(c_, Cu, A7(DW, n, a, !1, Ot, Den, !1, !1)),
                    u > 0 ? A2(zx, w([
                        Gx("quote-info__bill")
                    ]), w([
                        A2(f_, w([
                            GN,
                            uF(yE)
                        ]), w([
                            _d("Total amount")
                        ]))
                    ])) : vE
                ])),
                s_
            ])),
            A2(c_, Cu, A2(aKn, Ter(t), e)),
            A2(bE, Cz(r), s_),
            A2(c_, Cu, eKn(r))
        ]));
    }), Zer = function(n) {
        return n.ur;
    }, Mer = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ler = function(n) {
        return n.aM ? "collapser-closed" : "collapser-open";
    }, Ner = function(n) {
        var r = n.ll ? "primary" : "dependent", t = A2(fe, ", ", A2(n$, cu, w([
            A2(Op, function(n) {
                return oe(n) + " y/o";
            }, n.ng),
            It(r)
        ])));
        return A2(zx, w([
            Gx("flex justify-between w-full mt-2 text-sm md:text-base")
        ]), w([
            A2(zx, w([
                Gx("flex")
            ]), w([
                A2(f_, g, w([
                    _d(n.ur)
                ]))
            ])),
            A2(zx, w([
                Gx("flex")
            ]), w([
                A2(f_, w([
                    nF
                ]), w([
                    _d(t)
                ]))
            ]))
        ]));
    }, Her = function(n) {
        return A2(zx, w([
            Gx("mt-2 md:mt-6")
        ]), A2(Fu, Ner, n));
    }, Ier = function(n) {
        return lu(n) > 0 ? A2(f_, w([
            ven,
            uE(JI),
            uE(fmn),
            A2(U5n, 2, aF),
            A2(U5n, 2, jvn),
            uF(xD)
        ]), w([
            _d(n)
        ])) : vE;
    }, Oer = F3(function(n, r, t) {
        return A2(zx, g, w([
            A2(zx, w([
                Gx("flex w-full")
            ]), w([
                A2(zx, w([
                    Gx("flex-grow")
                ]), w([
                    Ier(Zer(n))
                ])),
                A2(zx, w([
                    Gx("flex-shrink flex -mt-1"),
                    Oq(w([
                        v("mb-2", !t.aM)
                    ]))
                ]), w([
                    A2(zx, w([
                        Gx("collapser")
                    ]), w([
                        A2(zx, w([
                            Gx(Ler(t))
                        ]), w([
                            A2(yF, w([
                                Yj,
                                cF(Mer(!t.aM))
                            ]), w([
                                A2(Tq, g, 7)
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2(c_, Cu, A2(bE, !t.aM, A2(zx, g, w([
                Her(r)
            ]))))
        ]));
    }), Qer = F5(function(n, r, t, e, u) {
        var a = ve(r) > 0;
        return e ? A2(zx, w([
            Gx("quote-info")
        ]), w([
            A2(bE, a, A3(Oer, n, r, u)),
            A2(bE, Cz(t) && !u.aM, s_)
        ])) : A2(c_, Cu, A2(zx, w([
            Gx("quote-info")
        ]), w([
            A2(bE, a, Ier(Zer(n))),
            A2(bE, a, s_),
            Her(r),
            A2(bE, a && Cz(t), s_)
        ])));
    }), Rer = function(n) {
        return n.wO;
    }, Uer = function(n) {
        return n.fm;
    }, Ker = function(n) {
        return n.ur;
    }, Wer = function(n) {
        return n.wE;
    }, Xer = F2(function(n, r) {
        return A2(zx, w([
            Gx("flex justify-between w-full mt-2 text-sm md:text-base")
        ]), w([
            A2(zx, w([
                Gx("flex")
            ]), w([
                A2(f_, g, w([
                    ZV(Ker(r))
                ]))
            ])),
            A2(bE, !n, A2(zx, w([
                Gx("flex")
            ]), w([
                A2(f_, w([
                    nF
                ]), w([
                    _d(OK(Wer(r)))
                ]))
            ])))
        ]));
    }), Yer = function(n) {
        var r = Uer(n), t = function(n) {
            return n.ty;
        }(n);
        return A2(zx, w([
            Gx("mt-2 md:mt-6")
        ]), A2(Fu, Xer(t), r));
    }, Jer = function(n) {
        return n.fL.k6;
    }, nur = function(n) {
        return n.fL.rz;
    }, rur = function(n) {
        return n.fL.Ee;
    }, tur = function(n) {
        return n.fL.EZ;
    }, eur = function(n) {
        return n.fL.E_;
    }, uur = function(n) {
        return n.fL.Fo;
    }, aur = function(n) {
        return n.fL.Gn;
    }, iur = F3(function(n, r, t) {
        if (onr(r) > 0) {
            var e = "Registration Fee" === t ? n(rur) : t;
            return A2(zx, g, w([
                A2(f_, w([
                    nF
                ]), w([
                    A2(zx, w([
                        Gx("flex justify-between w-full")
                    ]), w([
                        A2(zx, w([
                            Gx("flex pr-8")
                        ]), w([
                            _d(e)
                        ])),
                        A2(zx, w([
                            Gx("flex")
                        ]), w([
                            _d(OK(onr(r)))
                        ]))
                    ]))
                ]))
            ]));
        }
        return vE;
    }), cur = F4(function(n, r, t, e) {
        return A2(zx, g, w([
            A2(zx, w([
                Gx("flex w-full")
            ]), w([
                A2(zx, w([
                    Gx("flex-grow")
                ]), w([
                    A2(f_, w([
                        nF
                    ]), w([
                        _d("Pricing Breakdown")
                    ]))
                ])),
                A2(zx, w([
                    Gx("flex-shrink flex -mt-1"),
                    Oq(w([
                        v("mb-2", !e.aM)
                    ]))
                ]), w([
                    A2(zx, w([
                        Gx("collapser")
                    ]), w([
                        A2(zx, w([
                            Gx(Ler(e))
                        ]), w([
                            A2(yF, w([
                                Yj,
                                cF(Mer(!e.aM))
                            ]), w([
                                A2(Tq, g, 7)
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2(c_, Cu, A2(bE, !e.aM, A2(zx, g, w([
                Yer(r),
                A2(zx, w([
                    Gx("mb-2")
                ]), g),
                A3(iur, n, r, Rer(t))
            ]))))
        ]));
    }), our = function(n) {
        return "with " + OK(n) + " discount";
    }, fur = F2(function(n, r) {
        var t = Ktr(n);
        return t.$ ? A2(Op, our, r) : It("with " + jF(t.a) + "% discount");
    }), sur = F4(function(n, r, t, e) {
        var u = v(t, Wtr(n));
        if (!u.a) return A2(fur, n, e);
        switch(u.b.$){
            case 1:
                return Ot;
            case 0:
                return A2(fur, n, e);
            default:
                return s(u.b.a, lU(r)) > 0 ? A2(fur, n, e) : Ot;
        }
    }), lur = F2(function(n, r) {
        var t = function(n) {
            return n.pt;
        }(n);
        if (t.$) return vE;
        var e = t.a, u = function(n) {
            return n.pu;
        }(n), a = hHn(n), i = A4(sur, e, a, r, u);
        if (i.$) return vE;
        var c = i.a;
        return A2(PE, w([
            nF,
            oK,
            Hx(w([
                Gx("badge")
            ]))
        ]), w([
            _d(c)
        ]));
    }), dur = F4(function(n, r, t, e) {
        var u = It(hHn(t)), a = yHn(t);
        return A2(zx, w([
            Gx("w-full text-center")
        ]), w([
            A2(zx, w([
                Gx("hidden md:inline-flex md:flex-col")
            ]), w([
                A7(DW, n, a, e, u, yE, !1, !1),
                A2(lur, t, !0),
                Ier(r)
            ])),
            s_,
            A2(zx, w([
                Gx("md:hidden")
            ]), w([
                A2(zx, w([
                    Gx("flex justify-between")
                ]), w([
                    Ier(r),
                    A2(lur, t, !0),
                    A2(zx, g, w([
                        A7(DW, n, a, e, u, yE, !1, !1)
                    ]))
                ])),
                s_
            ]))
        ]));
    }), vur = F2(function(n, r) {
        var t = D7n(n);
        return !t.$ && i(t.a, hHn(r));
    }), bur = function(n) {
        return n.nY;
    }, mur = function(n) {
        return n.x0;
    }, pur = F2(function(n, r) {
        if (bur(r)) {
            var t = lU(hHn(n));
            return {
                zZ: yHn(n),
                pS: A3(q_, 1, t, mur(n))
            };
        }
        return {
            zZ: yHn(n) + onr(n),
            pS: mur(n)
        };
    }), $ur = F2(function(n, r) {
        var t = lU(hHn(n)), e = A3(q_, 1, t, mur(n));
        return bur(r) ? {
            zZ: Unr(n),
            pS: A3(q_, 1, t, e)
        } : {
            zZ: Unr(n),
            pS: e
        };
    }), gur = F2(function(n, r) {
        var t = A2($ur, r, n);
        return i(A2(pur, r, n).zZ, t.zZ);
    }), hur = F2(function(n, r) {
        var t = A2($ur, r, n), e = A2(pur, r, n);
        return A2(gur, n, r) ? A2(vur, n, r) ? v(It(e), Ot) : v(Ot, It(t)) : v(It(e), It(t));
    }), yur = F2(function(n, r) {
        var t = v(bur(r), onr(n) > 0);
        if (t.a && t.b) {
            var e = {
                zZ: onr(n),
                pS: mur(n)
            };
            return It(e);
        }
        return Ot;
    }), wur = F3(function(n, r, t) {
        return 1 === A2(yur, t, r).$ ? A2(vur, r, t) ? v(It(n(aur)), Ot) : v(It(n(nur)), It(n(eur))) : v(It(n(uur)), It(n(tur)));
    }), xur = F2(function(n, r) {
        var t = A2($ur, r, n), e = A2(pur, r, n);
        return A2(gur, n, r) && !A2(vur, n, r) ? e.pS : t.pS;
    }), _ur = function(n) {
        return A2(SM, sZ("/"), n);
    }, Cur = F6(function(n, r, t, e, u, a) {
        var i = v(r, t);
        if (i.a.$ || i.b.$) return vE;
        var c = i.a.a, o = i.b.a, f = a ? n(Jer) : _ur(c.pS), s = A2(xc, c.zZ, A2(Op, emn, u));
        return A2(zx, g, w([
            A2(zx, w([
                Gx("flex-auto hidden md:block text-center")
            ]), w([
                A7(DW, n, s, !1, Ot, yE, !1, !1),
                A2(zx, w([
                    Gx("quote-info__bill")
                ]), w([
                    A2(f_, w([
                        GN,
                        uF(yE)
                    ]), w([
                        _d(o)
                    ])),
                    A2(PE, w([
                        nF,
                        uF(yE)
                    ]), w([
                        _d(f)
                    ]))
                ])),
                A2(lur, e, !1)
            ])),
            A2(zx, w([
                Gx("md:hidden")
            ]), w([
                A2(zx, w([
                    Gx("flex")
                ]), w([
                    A2(zx, w([
                        Gx("flex quote-info__bill")
                    ]), w([
                        A2(f_, w([
                            GN,
                            uF(jG),
                            VG
                        ]), w([
                            _d(o)
                        ])),
                        A2(PE, w([
                            nF,
                            uF(jG),
                            uE(o7n)
                        ]), w([
                            _d(f)
                        ]))
                    ])),
                    A2(zx, w([
                        Gx("ml-auto")
                    ]), w([
                        A7(DW, n, s, !1, Ot, yE, !1, !1)
                    ]))
                ])),
                A2(lur, e, !1),
                s_
            ]))
        ]));
    }), Aur = F7(function(n, r, t, e, u, a, i) {
        var c = v(r, t);
        if (c.a.$ || c.b.$) return vE;
        var o = c.a.a, f = c.b.a, s = i ? n(Jer) : _ur(e);
        return A2(zx, g, w([
            A2(zx, w([
                Gx("flex-auto hidden md:block text-center")
            ]), w([
                A2(zx, w([
                    Gx("flex justify-center")
                ]), w([
                    A7(DW, n, o.zZ, !0, It(hHn(u)), yE, !1, a)
                ])),
                A2(zx, w([
                    Gx("quote-info__bill")
                ]), w([
                    A2(f_, w([
                        GN,
                        uF(yE)
                    ]), w([
                        _d(f)
                    ])),
                    A2(PE, w([
                        nF,
                        uF(yE)
                    ]), w([
                        _d(s)
                    ]))
                ])),
                A2(lur, u, !0)
            ])),
            A2(zx, w([
                Gx("md:hidden")
            ]), w([
                A2(zx, w([
                    Gx("flex")
                ]), w([
                    A2(zx, w([
                        Gx("flex quote-info__bill")
                    ]), w([
                        A2(f_, w([
                            GN,
                            uF(jG),
                            VG
                        ]), w([
                            _d(f)
                        ])),
                        A2(PE, w([
                            nF,
                            uF(jG),
                            uE(o7n)
                        ]), w([
                            _d(s)
                        ]))
                    ])),
                    A2(zx, w([
                        Gx("ml-auto")
                    ]), w([
                        A7(DW, n, o.zZ, !0, It(hHn(u)), yE, !1, a)
                    ]))
                ])),
                A2(lur, u, !0),
                s_
            ]))
        ]));
    }), kur = F3(function(n, r, t) {
        if (r.$) return vE;
        var e = r.a, u = t ? n(Jer) : _ur(e.pS);
        return A2(zx, g, w([
            A2(zx, w([
                Gx("flex-auto hidden md:block text-center")
            ]), w([
                A7(DW, n, e.zZ, !1, Ot, yE, !1, !1),
                A2(zx, w([
                    Gx("quote-info__bill")
                ]), w([
                    A2(f_, w([
                        GN,
                        uF(yE)
                    ]), w([
                        _d("First bill")
                    ])),
                    A2(PE, w([
                        nF,
                        uF(yE)
                    ]), w([
                        _d(u)
                    ]))
                ]))
            ])),
            A2(zx, w([
                Gx("md:hidden")
            ]), w([
                A2(zx, w([
                    Gx("flex")
                ]), w([
                    A2(zx, w([
                        Gx("flex quote-info__bill")
                    ]), w([
                        A2(f_, w([
                            GN,
                            uF(jG),
                            VG
                        ]), w([
                            _d("First bill")
                        ])),
                        A2(PE, w([
                            nF,
                            uF(jG),
                            uE(o7n)
                        ]), w([
                            _d(u)
                        ]))
                    ])),
                    A2(zx, w([
                        Gx("ml-auto")
                    ]), w([
                        A7(DW, n, e.zZ, !1, Ot, yE, !1, !1)
                    ]))
                ])),
                s_
            ]))
        ]));
    }), Eur = F6(function(n, r, t, e, u, a) {
        var i, c = A2(xur, r, t), o = A2(yur, t, r), f = A3(wur, n, r, t), s = f.a, l = f.b, d = A2(hur, r, t), b = d.a, m = d.b, p = !!(i = v(b, a)).a.$ && !!i.b;
        return A2(zx, w([
            Gx("w-full")
        ]), w([
            A2(zx, w([
                Gx("hidden md:block")
            ]), w([
                A2(zx, w([
                    Gx("flex justify-evenly space-x-4")
                ]), w([
                    A3(kur, n, o, a),
                    A6(Cur, n, b, s, t, e, a),
                    A7(Aur, n, m, l, c, t, u, p)
                ])),
                Ier(Zer(r)),
                s_
            ])),
            A2(zx, w([
                Gx("md:hidden")
            ]), w([
                A3(kur, n, o, a),
                A6(Cur, n, b, s, t, e, a),
                A7(Aur, n, m, l, c, t, u, p),
                Ier(Zer(r))
            ]))
        ]));
    }), qur = F3(function(n, r, t) {
        return A3(Ser, vE, function(e) {
            var u = v(e, r.hw);
            if (u.a.$) return A3(Per, n, r.fw, u.a.a);
            switch(u.b.$){
                case 0:
                    var a = u.a.a, i = u.b.a;
                    return (function(n) {
                        return function(r) {
                            return function(t) {
                                return function(e) {
                                    return function(u) {
                                        return function(a) {
                                            return function(i) {
                                                return function(c) {
                                                    return function(o) {
                                                        return function(f) {
                                                            return i ? A2(zx, w([
                                                                Gx("quote-info")
                                                            ]), w([
                                                                A2(c_, Cu, a ? A6(Eur, n, r, t, u, c, o) : A4(dur, n, Zer(r), t, !0)),
                                                                A4(cur, n, t, r, f),
                                                                A2(bE, Cz(e) && !f.aM, s_)
                                                            ])) : A2(c_, Cu, A2(zx, w([
                                                                Gx("quote-info")
                                                            ]), w([
                                                                a ? A6(Eur, n, r, t, u, c, o) : A4(dur, n, Zer(r), t, !0),
                                                                Yer(t),
                                                                A2(bE, onr(t) > 0, s_),
                                                                A3(iur, n, t, Rer(r)),
                                                                eKn(u),
                                                                A2(bE, Cz(e), s_)
                                                            ])));
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    })(n)(a)(i)(r.ds)(r.fw)(r.kv)(r.Df)(r.jr)(r.hu)(t);
                case 1:
                    return A5(Qer, a = u.a.a, u.b.a, r.ds, r.Df, t);
                default:
                    return vE;
            }
        }, r.nX);
    }), Fur = F2(function(n, r) {
        var t = w([
            mEn(0)
        ]);
        if (r.$) return vE;
        var e = r.a;
        return A3(AEn, t, N9n(e), A2(L9n, n, P9n(e)));
    }), jur = F2(function(n, r) {
        return A2(zx, w([
            Gx("md:hidden sidebar-mobile")
        ]), w([
            A2(zx, w([
                Gx("sidebar-wrap")
            ]), r)
        ]));
    }), Dur = F2(function(n, r) {
        return A2(zx, w([
            Gx("sidebar-wrap"),
            A2(VF, "margin-top", jF(n.iH) + "px"),
            DF("sidebar-element")
        ]), r);
    }), Vur = F3(function(n, r, t) {
        var e = A3(de, Der, jer, r);
        return (e.Df ? jur(t) : Dur(t))(w([
            A3(qur, n, e, t),
            A2(Fur, n, e.rc),
            zer(e)
        ]));
    }), Bur = F2(function(n, r) {
        return A2(zx, w([
            Gx("hidden md:block")
        ]), w([
            A2(c_, R7n, A3(Vur, n, A2(Fer, n, r), r.dd))
        ]));
    }), Gur = function(n) {
        return A2(Qt, function(n) {
            return {
                $: 8,
                a: n
            };
        }(!0), n);
    }, zur = F2(function(n, r) {
        return A2(c_, R7n, A3(Vur, n, Gur(A2(Fer, n, r)), r.dd));
    }), Sur = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("signup__body--contents")
            ]), w([
                A2(CF, w([
                    gW,
                    uE(eE),
                    A2(U5n, 1, M5n),
                    uF(rD)
                ]), w([
                    _d(n(nhn))
                ])),
                A2(zx, w([
                    Gx("flex w-full")
                ]), w([
                    A2(der, n, r),
                    A2(Bur, n, r)
                ])),
                A2(zur, n, r)
            ]))
        ]);
    }), Tur = function(n) {
        return A2(zx, w([
            Gx("panel w-full")
        ]), w([
            A2(i_, g, w([
                _d("There was a problem!")
            ])),
            s_,
            A2(f_, g, w([
                _d("An error has been registered. Please contact us to complete enrollment at "),
                W0n(bV(n)),
                A3(K0n, "or", Xw(n), bV(n)),
                _d(". Or try again tomorrow.")
            ]))
        ]));
    }, Pur = F2(function(n, r) {
        return {
            g8: function() {
                var t = v(r.aW, r.u2);
                n: for(;;){
                    r: for(;;)switch(t.a.$){
                        case 1:
                            return Nx;
                        case 2:
                            if (1 === t.b.$) break n;
                            break r;
                        default:
                            switch(t.b.$){
                                case 1:
                                    break n;
                                case 2:
                                    return w([
                                        Tur(r.dV)
                                    ]);
                                default:
                                    return A2(Sur, n, r);
                            }
                    }
                    return w([
                        Tur(r.dV)
                    ]);
                }
                return Nx;
            }(),
            yx: ax(r.dV)
        };
    }), Zur = J0n({
        Cl: Z7n,
        CQ: I7n,
        Fj: O7n,
        F4: function(n) {
            var r = FM(n.le).aa;
            return vx(w([
                A2(kj, y7n, S1),
                A2(kj, p7n, L1(r)),
                A2(kj, R7n, X7n()),
                t2n(Q7n),
                Z6n(U7n)
            ]));
        },
        Gv: _tr,
        GB: Pur
    }), Mur = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Lur = function(n) {
        return {
            $: 26,
            a: n
        };
    }, Nur = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Hur = function(n) {
        return {
            $: 27,
            a: n
        };
    }, Iur = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Our = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Qur = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Rur = F2(function(n, r) {
        return function(n) {
            return n.a.ur;
        }(r);
    }), Uur = function(n) {
        return It(A2(Rur, Vx(0), n));
    }, Kur = F2(function(n, r) {
        return Dxn(n) ? A2(Vxn, UP, r) : r;
    }), Wur = function(n) {
        switch(n){
            case 0:
                return "field-first-name";
            case 1:
                return "field-last-name";
            case 2:
                return "field-chosen-first-name";
            case 3:
                return "field-chosen-last-name";
            case 4:
                return "field-email";
            case 5:
                return "field-phone";
            case 6:
                return "field-lead-source";
            case 7:
                return "field-lead-source-other";
            default:
                return "field-broker";
        }
    }, Xur = function(n) {
        return {
            n6: Ot,
            oz: "",
            oA: "",
            oB: "",
            oC: "",
            oD: $xn("chosen-title"),
            qN: "",
            rA: "",
            an: !1,
            sV: "",
            s_: Ot,
            s$: "",
            ue: "",
            vQ: A2(Kur, n, A2(zxn, !0, cxn(Wur(5)))),
            ym: "",
            yx: $xn("title")
        };
    }, Yur = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Jur = F2(function(n, r) {
        return {
            sl: n,
            ur: r
        };
    }), nar = A3(nk, "name", M$, A3(nk, "id", M$, au(Jur))), rar = A2(zB, 0, A2($A, nar, au(Yur))), tar = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ear = F2(function(n, r) {
        return {
            sl: n,
            ur: r
        };
    }), uar = A3(nk, "name", M$, A3(nk, "id", M$, au(ear))), aar = A2(zB, 0, A2($A, uar, au(tar))), iar = A3(nk, "debug", ru, A3(nk, "referred", ru, A3(nk, "broker", uC(rar), A3(nk, "lead_source", uC(aar), A3(nk, "title", A2(nu, bhn, uC(M$)), A3(nk, "phones", uC(ek(whn)), A3(nk, "lead_source_other", uC(M$), A3(nk, "middle_name", uC(M$), A3(nk, "suffix", uC(M$), A3(nk, "last_name", M$, A3(nk, "first_name", M$, A3(nk, "email", uC(M$), A3(nk, "chosen_suffix", uC(M$), A3(nk, "chosen_title", A2(nu, bhn, uC(M$)), A3(nk, "chosen_middle_name", uC(M$), A3(nk, "chosen_last_name", uC(M$), A3(nk, "chosen_first_name", uC(M$), A3(nk, "id", M$, au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return function(b) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return {
                                                                                n6: m,
                                                                                oz: r,
                                                                                oA: t,
                                                                                oB: e,
                                                                                oC: a,
                                                                                oD: u,
                                                                                p$: $,
                                                                                qN: i,
                                                                                rA: c,
                                                                                sl: n,
                                                                                sV: o,
                                                                                s_: b,
                                                                                s$: l,
                                                                                ue: s,
                                                                                vQ: d,
                                                                                wL: p,
                                                                                ym: f,
                                                                                yx: v
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), car = A2($A, iar, au(cu)), oar = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments"
        ]), A2(a8n, n, r));
    }), far = F5(function(n, r, t, e, u) {
        var a = rx(w([
            v("referred_token", tx(e))
        ]));
        return A4(lM, GQ(n), car, u, A2(dM, a, pk(A2(bk, w([
            "from_referred_token"
        ]), A2(oar, r, t)))));
    }), sar = F5(function(n, r, t, e, u) {
        return A4(aA, GQ(n), car, u, pk(A2(bk, w([
            e
        ]), A2(oar, r, t))));
    }), lar = A3(nk, "id", M$, au(function(n) {
        return {
            sl: n
        };
    })), dar = A2($A, lar, au(cu)), bar = F2(function(n, r) {
        return A2(bk, w([
            "new"
        ]), A2(bk, w([
            "online_enrollments"
        ]), A2(a8n, n, r)));
    }), mar = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), dar, e, pk(A2(bar, r, t)));
    }), par = function(n) {
        return n.a.ur;
    }, $ar = F2(function(n, r) {
        return par(r);
    }), gar = function(n) {
        return It(A2($ar, Vx(0), n));
    }, har = F3(function(n, r, t) {
        return A4(aA, GQ(n), ek(rar), t, pk(function(n) {
            return A2(bk, w([
                "brokers"
            ]), fM(n));
        }(r)));
    }), yar = F3(function(n, r, t) {
        return A4(aA, GQ(n), ek(aar), t, pk(function(n) {
            return A2(bk, w([
                "lead_sources"
            ]), fM(n));
        }(r)));
    }), war = A2(Jfn, "Member Onboarding: Start", w([
        esn(i4n)
    ])), xar = F2(function(n, r) {
        return A2(bk, w([
            "signup_pages",
            r,
            "charge_item"
        ]), fM(n));
    }), _ar = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), L4n, e, pk(A2(xar, r, t)));
    }), Car = F6(function(n, r, t, e, u, a) {
        return {
            qN: t,
            rA: n,
            sV: r,
            u2: a,
            vO: e,
            v4: u
        };
    }), Aar = A3(nk, "id", M$, au(function(n) {
        return {
            sl: n
        };
    })), kar = A2($A, Aar, au(cu)), Ear = A3(nk, "online_enrollment", ik(kar), A3(nk, "practitioner", jQ, A3(nk, "phone", M$, A3(nk, "email", M$, A3(nk, "last_name", M$, A3(nk, "first_name", M$, au(Car))))))), qar = A2($A, Ear, au(cu)), Far = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), qar, e, pk(A2(bk, w([
            "waitlist_tokens",
            t
        ]), fM(r))));
    }), jar = w([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]), Dar = function(n) {
        switch(n){
            case 0:
                return "First Name";
            case 1:
                return "Last Name";
            case 2:
                return "Chosen First Name";
            case 3:
                return "Chosen Last Name";
            case 4:
                return "Email";
            case 5:
                return "Phone";
            case 6:
                return "Lead Source";
            case 7:
                return "Lead Source Other";
            default:
                return "Broker";
        }
    }, Var = function(n) {
        return A2(C7n, "waitlist_token", n);
    }, Bar = F4(function(n, r, t, e) {
        var u, a = 3 === (u = t.FN).$ ? u.a : g, i = GYn(r), c = _8n(i) ? A4(_ar, t.g0, ux(n), a1n(i), Lur) : Qp, o = function() {
            var r = V6n(t);
            if (r.$) {
                var u = A2(C7n, "token", e.jb);
                if (u.$) {
                    var a = function() {
                        var r = Var(e.jb);
                        if (r.$) return Qp;
                        var u = r.a;
                        return A4(Far, t.g0, ux(n), u, Hur);
                    }();
                    return b(Uu(w([
                        A4(mar, t.g0, ux(n), a1n(i), Qur),
                        war,
                        a
                    ])), kc, A_);
                }
                var c = u.a;
                return b(Uu(w([
                    A5(far, t.g0, ux(n), a1n(i), c, Iur),
                    war
                ])), A_, kc);
            }
            var o = r.a;
            return b(A5(sar, t.g0, ux(n), a1n(i), o, Our), A_, kc);
        }(), f = o.a, s = o.b, l = o.c;
        return v({
            gk: $6n(t),
            g0: t.g0,
            g7: p7,
            eB: Cd({
                sl: "broker-select",
                Gj: Rur,
                Gk: Uur
            }),
            bU: kc,
            du: p7,
            or: Ot,
            hH: t.hH,
            ld: t.ld,
            le: vZ(Xur(n)),
            h0: Ot,
            fc: Cd({
                sl: "lead-source-select",
                Gj: $ar,
                Gk: gar
            }),
            fd: kc,
            c0: l,
            fu: t.fu,
            dV: n,
            wk: !1,
            fJ: !1,
            wL: !1,
            c7: s,
            c8: p7,
            mp: i,
            f2: r,
            FN: a,
            yZ: e,
            A: A2(pZ, jar, Dar)
        }, Uu(w([
            f,
            A4(a5n, 0, a, r, g),
            A3(yar, t.g0, ux(n), Nur),
            A3(har, t.g0, ux(n), Mur),
            c
        ])));
    }), Gar = F2(function(n, r) {
        return v(r, Qp);
    }), zar = F2(function(n, r) {
        return r;
    }), Sar = function(n) {
        return {
            $: 25,
            a: n
        };
    }, Tar = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Par = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Zar = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Mar = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Lar = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Nar = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Har = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Iar = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Oar = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Qar = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Rar = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Uar = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Kar = function(n) {
        return {
            $: 2,
            a: n
        };
    }, War = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Xar = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Yar = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Jar = function(n) {
        return {
            $: 0,
            a: n
        };
    }, nir = function(n) {
        return {
            $: 8,
            a: n
        };
    }, rir = function(n) {
        return {
            $: 12,
            a: n
        };
    }, tir = F2(function(n, r) {
        return mb(A2(iH, r, n));
    }), eir = F2(function(n, r) {
        return A2(bb, function(n) {
            return It(v(r, n));
        }, A2(tir, n, r));
    }), uir = function(n) {
        return A2(Fu, function(n) {
            var r = n.a;
            return c4n({
                eZ: w([
                    n.b
                ]),
                ru: Dar(r)
            });
        }, function(n) {
            return A2(n$, eir(n), jar);
        }(n));
    }, air = {
        F1: Atn(100),
        Gs: function(n) {
            return {
                $: 19,
                a: n
            };
        }
    }, iir = function(n) {
        return n.a.sl;
    }, cir = F2(function(n, r) {
        return A4(Xnr, "broker", r, n, iir);
    }), oir = {
        F1: Atn(1500),
        Gs: function(n) {
            return {
                $: 23,
                a: n
            };
        }
    }, fir = function(n) {
        return {
            $: 20,
            a: n
        };
    }, sir = function(n) {
        return A2(Nu, fir, Au(n));
    }, lir = function(n) {
        return {
            $: 24,
            a: n
        };
    }, dir = function(n) {
        return A2(Nu, lir, Au(n));
    }, vir = function(n) {
        return {
            $: 22,
            a: n
        };
    }, bir = function(n) {
        return A2(Nu, vir, Au(n));
    }, mir = function(n) {
        return n.p$;
    }, pir = function(n) {
        return n.qN;
    }, $ir = function(n) {
        return n.a.sl;
    }, gir = function(n) {
        return A2(bb, function(n) {
            return mu(n) ? Ot : It(n);
        }, A2(C7n, "lead", n));
    }, hir = F2(function(n, r) {
        var t = gir(r);
        return v("lead_source", t.$ ? n.$ ? nx : rx(w([
            v("id", K_n($ir(n.a)))
        ])) : rx(w([
            v("id", K_n(t.a))
        ])));
    }), yir = F3(function(n, r, t) {
        var e;
        return A2(Qt, A2(VPn, "title", n.yx), A2(Qt, v("first_name", K_n(n.rA)), A2(Qt, v("middle_name", K_n(n.ue)), A2(Qt, v("last_name", K_n(n.sV)), A2(Qt, v("suffix", K_n(n.ym)), A2(Qt, v("email", K_n(n.qN)), A2(Qt, v("phones", LPn(n.vQ)), A2(Qt, v("lead_source_other", K_n(n.s$)), A2(Qt, v("google_recaptcha_token", QTn(r)), A2(Qt, A2(hir, n.s_, t), A2(Qt, v("broker", (e = n.n6).$ ? nx : rx(w([
            v("id", K_n(iir(e.a)))
        ]))), function(n) {
            return w(n.an ? [
                A2(VPn, "chosen_title", n.yx),
                v("chosen_first_name", K_n(n.oz)),
                v("chosen_middle_name", K_n(n.oB)),
                v("chosen_last_name", K_n(n.oA)),
                v("chosen_suffix", K_n(n.oC))
            ] : [
                v("chosen_title", nx),
                v("chosen_first_name", nx),
                v("chosen_middle_name", nx),
                v("chosen_last_name", nx),
                v("chosen_suffix", nx)
            ]);
        }(n))))))))))));
    }), wir = function(n) {
        return n.he.n6;
    }, xir = function(n) {
        return n.he.sT;
    }, _ir = function(n) {
        return n.he.EC;
    }, Cir = function(n) {
        return 3 === n.$ ? n.a : g;
    }, Air = function(n) {
        return nE(Cir(n));
    }, kir = function(n) {
        return nL(A2(YM, eLn, n));
    }, Eir = F3(function(n, r, t) {
        var e = t.n6;
        return n_n(E8n(n)) && i(e, Ot) && !Air(r) ? w([
            v(8, kir(wir))
        ]) : g;
    }), qir = F2(function(n, r) {
        return A2(Eir, n, r);
    }), Fir = function(n) {
        return n.an && mu(n.oz) ? w([
            v(2, WL(BEn))
        ]) : g;
    }, jir = function(n) {
        return n.an && mu(n.oA) ? w([
            v(3, WL(zEn))
        ]) : g;
    }, Dir = function(n) {
        return vc(w([
            Fir(n),
            jir(n)
        ]));
    }, Vir = F2(function(n, r) {
        for(;;){
            if (!n.b) return g;
            var t = n.b, e = (0, n.a)(r);
            if (e.b) return e;
            n = t;
        }
    }), Bir = F2(function(n, r) {
        return A2(pnr, function(r) {
            return f2n(n(r));
        }, r);
    }), Gir = F2(function(n, r) {
        return function(t) {
            var e = n(t);
            return oL(e) ? g : w([
                r(e)
            ]);
        };
    }), zir = (I8 = w([
        A2(Bir, function(n) {
            return n.qN;
        }, v(4, WL(eL))),
        A2(Gir, function(n) {
            return n.qN;
        }, function() {
            return v(4, XL(eL));
        })
    ]), function(n) {
        return A2(Vir, I8, n);
    }), Sir = A2(Bir, function(n) {
        return n.rA;
    }, v(0, nL(A2(YM, eLn, lL)))), Tir = A2(Bir, function(n) {
        return n.sV;
    }, v(1, nL(A2(YM, rL, dL)))), Pir = function(n) {
        return !n.$ && "Other" === par(n.a);
    }, Zir = function(n) {
        return n.ip.sT;
    }, Mir = function(n) {
        return n.ip.s_;
    }, Lir = function(n) {
        return n.ip.EC;
    }, Nir = F2(function(n, r) {
        var t = r.s_, e = r.s$;
        return !nEn(q8n(n)) && Pir(t) && iL(e) ? w([
            v(7, WL(Mir))
        ]) : g;
    }), Hir = function(n) {
        return Nir(n);
    }, Iir = F3(function(n, r, t) {
        var e, u = t.s_, a = 1 === (e = v(gir(r), u)).a.$ && 1 === e.b.$;
        return n_n(q8n(n)) && a ? w([
            v(6, kir(Mir))
        ]) : g;
    }), Oir = F2(function(n, r) {
        return A2(Iir, n, r);
    }), Qir = function(n) {
        return A2(Fu, function(n) {
            return v(5, n);
        }, PMn(n.vQ));
    }, Rir = F3(function(n, r, t) {
        return XM(w([
            Sir,
            Tir,
            Dir,
            zir,
            Qir,
            A2(qir, n, r),
            A2(Oir, n, t),
            Hir(n)
        ]));
    }), Uir = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    yx: n.a
                });
            case 1:
                return m(r, {
                    rA: n.a
                });
            case 2:
                return m(r, {
                    ue: n.a
                });
            case 3:
                return m(r, {
                    sV: n.a
                });
            case 4:
                return m(r, {
                    ym: n.a
                });
            case 5:
                return m(r, {
                    an: n.a
                });
            case 6:
                return m(r, {
                    oD: n.a
                });
            case 7:
                return m(r, {
                    oz: n.a
                });
            case 8:
                return m(r, {
                    oB: n.a
                });
            case 9:
                return m(r, {
                    oA: n.a
                });
            case 10:
                return m(r, {
                    oC: n.a
                });
            case 11:
                return m(r, {
                    qN: n.a
                });
            case 12:
                return m(r, {
                    vQ: n.a
                });
            case 13:
                return m(r, {
                    s_: n.a
                });
            case 14:
                return m(r, {
                    s$: n.a
                });
            default:
                return m(r, {
                    n6: n.a
                });
        }
    }), Kir = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, Uir, Zar(A2(iLn, n, t.oD)), r);
    }), Wir = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, Uir, Xar(A2(Nkn, n, t.vQ)), r);
    }), Xir = F2(function(n, r) {
        var t = FM(r);
        return A3(cN, Uir, Jar(A2(iLn, n, t.yx)), r);
    }), Yir = F5(function(n, r, t, e, u) {
        var a = A2(Wir, n, A2(Kir, n, A2(Xir, n, u))), i = A2(CL, A3(Rir, r, t, e), a);
        return i.$ ? v(i.a, !1) : v(i.a.a, !0);
    }), Jir = F2(function(n, r) {
        return Cz(A2(tir, n, r));
    }), ncr = F4(function(n, r, t, e) {
        var u = A5(Yir, !1, n, r, t, e);
        return u.b ? Ot : A2(bb, function(n) {
            return It(Wur(n));
        }, mb(A2(no, Jir(u.a), jar)));
    }), rcr = function(n) {
        return n.rA;
    }, tcr = function(n) {
        return n.oz;
    }, ecr = function(n) {
        return n.oA;
    }, ucr = function(n) {
        return n.oB;
    }, acr = function(n) {
        return n.oC;
    }, icr = function(n) {
        return n.qN;
    }, ccr = function(n) {
        return n.rA;
    }, ocr = function(n) {
        return n.sV;
    }, fcr = function(n) {
        return n.ue;
    }, scr = function(n) {
        return n.ym;
    }, lcr = F3(function(n, r, t) {
        var e, u = 1 !== (e = ecr(r)).$ && !mu(e.a), a = A2(O_n, function(n) {
            return n.yx;
        }(r), $xn("title")), i = A2(Kur, n, A2(z_n, function(n) {
            return n.vQ;
        }(r), A2(zxn, !0, cxn(Wur(5))))), c = A2(O_n, function(n) {
            return n.oD;
        }(r), $xn("chosen-title")), o = FM(t), f = o.s_, s = o.s$, l = o.n6, d = l.$ ? function(n) {
            return n.n6;
        }(r) : l, b = f.$ ? v(function(n) {
            return n.s_;
        }(r), A2(xc, "", function(n) {
            return n.s$;
        }(r))) : v(f, s), m = b.a, p = b.b;
        return {
            n6: d,
            oz: A2(xc, "", tcr(r)),
            oA: A2(xc, "", ecr(r)),
            oB: A2(xc, "", ucr(r)),
            oC: A2(xc, "", acr(r)),
            oD: c,
            qN: A2(xc, "", icr(r)),
            rA: ccr(r),
            an: u,
            sV: ocr(r),
            s_: m,
            s$: p,
            ue: A2(xc, "", fcr(r)),
            vQ: i,
            ym: A2(xc, "", scr(r)),
            yx: a
        };
    }), dcr = function(n) {
        return n.sl;
    }, vcr = function(n) {
        return n.sl;
    }, bcr = function(n) {
        return n.sl;
    }, mcr = F2(function(n, r) {
        var t = n ? DL(r.A) : r.A, e = A5(Yir, n, r.f2, r.bU, r.yZ.jb, r.le), u = e.b;
        return v(m(r, {
            le: e.a,
            A: t
        }), u);
    }), pcr = function(n) {
        switch(n.$){
            case 0:
            case 2:
            case 4:
            case 5:
            case 6:
            case 8:
            case 10:
                return Ot;
            case 1:
                return It(0);
            case 3:
                return It(1);
            case 7:
                return It(2);
            case 9:
                return It(3);
            case 11:
                return It(4);
            case 12:
                return It(5);
            case 13:
                return It(6);
            case 14:
                return It(7);
            default:
                return It(8);
        }
    }, $cr = F2(function(n, r) {
        var t = _c(n.yZ.EX), e = function(n) {
            switch(n.$){
                case 0:
                    return "Title";
                case 1:
                    return Dar(0);
                case 2:
                    return "Middle Name";
                case 3:
                    return Dar(1);
                case 4:
                    return "Suffix";
                case 5:
                    return "Has Chosen Name";
                case 6:
                    return "Chosen Title";
                case 7:
                    return Dar(2);
                case 8:
                    return "Chosen Middle Name";
                case 9:
                    return Dar(3);
                case 10:
                    return "Chosen Suffix";
                case 11:
                    return Dar(4);
                case 12:
                    return Dar(5);
                case 13:
                    return Dar(6);
                case 14:
                    return Dar(7);
                default:
                    return Dar(8);
            }
        }(r), u = A2(mcr, !1, n).a, a = A2(bb, function(n) {
            return A2(tir, u.le, n);
        }, A2(bb, pcr, It(r)));
        return d8n(It({
            eZ: A2(xc, g, A2(Op, _K, a)),
            ru: e,
            Fh: t
        }));
    }), gcr = function(n) {
        return n.sV;
    }, hcr = function(n) {
        return n.u2;
    }, ycr = function(n) {
        return n.wL;
    }, wcr = A2(Nu, Cu, Cn(function() {
        er.location.reload(false);
    })), xcr = {
        F1: Atn(300),
        Gs: function(n) {
            return {
                $: 21,
                a: n
            };
        }
    }, _cr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ccr = function(n) {
        return rx(w([
            v("online_enrollment", rx(n))
        ]));
    }, Acr = F6(function(n, r, t, e, u, a) {
        return A4(lM, GQ(n), car, a, A2(dM, Ccr(u), pk(A2(bk, w([
            "confirm"
        ]), A2(bk, w([
            e
        ]), A2(oar, r, t))))));
    }), kcr = function(n) {
        var r, t = 2 === (r = v(n.fu, n.c0)).a.$ ? It(r.a.a) : 3 === r.b.$ ? It(bcr(r.b.a)) : Ot;
        if (t.$) return Qp;
        var e = t.a, u = a1n(n.mp), a = ux(n.dV), i = FM(n.le);
        return A6(Acr, n.g0, a, u, e, A3(yir, i, n.h0, n.yZ.jb), _cr);
    }, Ecr = F6(function(n, r, t, e, u, a) {
        return A4(Dj, GQ(n), car, a, A2(dM, Ccr(u), pk(A2(bk, w([
            e
        ]), A2(oar, r, t)))));
    }), qcr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Fcr = F4(function(n, r, t, e) {
        return A4(lM, GQ(n), car, e, pk(A2(bk, w([
            "create_debug"
        ]), A2(oar, r, t))));
    }), jcr = F2(function(n, r) {
        return 2 === n.$ && i(n.a, "hintos") ? v(m(r, {
            hH: !0,
            wk: !0
        }), A4(Fcr, r.g0, ux(r.dV), a1n(r.mp), qcr)) : v(r, Qp);
    }), Dcr = F2(function(n, r) {
        switch(n.$){
            case 4:
                var t = n.a;
                n: for(;;)switch(t.$){
                    case 2:
                        if (9 === t.a.$) return b(m(r, {
                            c7: kc
                        }), Qp, A2(Ik, 1, t));
                        break n;
                    case 3:
                        var e = t.a, u = (jn = r.gk).$ ? Qp : o5n(jn.a), a = mir(e), i = w(a ? [
                            I6n,
                            H6n
                        ] : [
                            H6n
                        ]);
                        return b(m(r, {
                            gk: Ot,
                            hH: a,
                            le: vZ(A3(lcr, r.dV, e, r.le)),
                            wL: ycr(e),
                            c7: t
                        }), u, i);
                    default:
                        break n;
                }
                return b(m(r, {
                    c7: t
                }), Qp, A2(Ik, 1, t));
            case 5:
                t = n.a;
                n: for(;;)switch(t.$){
                    case 2:
                        if (t.a.$) break n;
                        return b(m(r, {
                            c0: A_,
                            c7: kc
                        }), A4(mar, r.g0, ux(r.dV), a1n(r.mp), Qur), A2(Ik, 1, t));
                    case 3:
                        var c = dcr(e = t.a);
                        return b(m(r, {
                            le: vZ(A3(lcr, r.dV, e, r.le)),
                            fu: Lar(c),
                            wL: ycr(e),
                            c7: t
                        }), O0n(c), w([
                            rir(c)
                        ]));
                    default:
                        break n;
                }
                return b(m(r, {
                    c7: t
                }), Qp, A2(Ik, 1, t));
            case 0:
                return b(m(r, {
                    le: A3(cN, Uir, hn = n.a, r.le)
                }), A2(Nu, cu, Au(Har(hn))), g);
            case 25:
                var o = n.a;
                return b(y = o.$ ? r : m(r, {
                    h0: It(o.a)
                }), Uu(w([
                    kcr(y),
                    A4(e5n, 0, y.FN, y.f2, g)
                ])), g);
            case 26:
                var f = n.a;
                return b(3 === f.$ ? m(r, {
                    or: It(f.a)
                }) : r, Qp, g);
            case 27:
                var s = n.a;
                if (3 === s.$) {
                    var l = s.a, d = A2(Op, vcr, hcr(l));
                    if (d.$) {
                        var p = m(An = FM(r.le), {
                            qN: pir(l),
                            rA: rcr(l),
                            sV: gcr(l)
                        });
                        return b(m(r, {
                            le: vZ(p)
                        }), Qp, g);
                    }
                    var $ = d.a;
                    return b(m(r, {
                        fu: Lar($),
                        c7: A_
                    }), A5(sar, r.g0, ux(r.dV), a1n(r.mp), $, Our), w([
                        rir($)
                    ]));
                }
                return b(r, Qp, g);
            case 1:
                var h = A2(mcr, !0, r), y = h.a;
                if (h.b) return b(m(y, {
                    wk: !0
                }), d2n(0), g);
                var x = A4(ncr, y.f2, y.bU, y.yZ.jb, y.le);
                if (x.$) return b(y, Uu(uir(y.le)), g);
                var _ = A3(Xnn, xcr, x.a, y.c8), C = _.b, A = m(y, {
                    c8: _.a
                });
                return b(A, Uu(A2(Qt, C, uir(A.le))), g);
            case 2:
                t = n.a, y = m(r, {
                    wk: !1
                });
                n: for(;;)switch(t.$){
                    case 3:
                        return b(y, Qp, w([
                            Kar(dcr(t.a))
                        ]));
                    case 2:
                        if (9 === t.a.$) return b(y, wcr, A2(Ik, 1, t));
                        break n;
                    default:
                        break n;
                }
                return b(y, Qp, A2(Ik, 1, t));
            case 3:
                if (t = n.a, y = m(r, {
                    fJ: !1
                }), 3 === t.$) {
                    var k = function() {
                        var n = v(y.c0, y.fu);
                        if (3 === n.a.$ && 1 === n.b.$) {
                            var r = bcr(n.a.a);
                            return v(m(y, {
                                fu: Lar(r)
                            }), w([
                                rir(r)
                            ]));
                        }
                        return v(y, g);
                    }();
                    return b(k.a, Qp, G = k.b);
                }
                return b(y, Qp, A2(Ik, 1, t));
            case 6:
                return 3 === (t = n.a).$ ? (c = dcr(e = t.a), b(m(r, {
                    le: vZ(A3(lcr, r.dV, e, r.le)),
                    fu: Lar(c),
                    wk: !1,
                    wL: ycr(e),
                    c7: t
                }), Qp, w([
                    Kar(c),
                    I6n
                ]))) : b(m(r, {
                    c7: t
                }), Qp, A2(Ik, 1, t));
            case 18:
                var E = n.a, q = FM(r.le), F = A2(gkn, E, q.vQ), j = F.b, D = F.c, V = Xar(F.a), B = (y = m(r, {
                    le: A3(cN, Uir, V, r.le)
                }), A2(xc, v(Qp, g), A2(Op, function(n) {
                    switch(n.$){
                        case 3:
                            return v(A2(Nu, cu, Au(Nar(V))), w([
                                A2($cr, y, V)
                            ]));
                        case 4:
                            return v(A2(Nu, cu, Au(Iar(V))), w([
                                A2($cr, y, V)
                            ]));
                        default:
                            return v(A2(Nu, cu, Au(Har(V))), g);
                    }
                }, D))), G = (C = B.a, B.b);
                return b(y, Uu(w([
                    A2(Wp, Yar, j),
                    C
                ])), G);
            case 8:
                var z = n.a, S = FM(r.le), T = A2(ILn, z, S.yx), P = T.b, Z = T.c, M = Jar(T.a);
                return C = function() {
                    if (Z.$) return Qp;
                    switch(Z.a.$){
                        case 0:
                            return A2(Nu, cu, Au(Har(M)));
                        case 1:
                            return A2(Nu, cu, Au(Iar(M)));
                        default:
                            return A2(Nu, cu, Au(Nar(M)));
                    }
                }(), b(y = m(r, {
                    le: A3(cN, Uir, M, r.le)
                }), Uu(w([
                    A2(Wp, nir, P),
                    C
                ])), w([
                    A2($cr, y, M)
                ]));
            case 9:
                return b(m(r, {
                    le: A3(cN, Uir, Oar(n.a), r.le)
                }), Qp, g);
            case 10:
                var L = n.a, N = FM(r.le), H = A2(ILn, L, N.oD), I = H.b, O = H.c, Q = Zar(H.a);
                return C = function() {
                    if (O.$) return Qp;
                    switch(O.a.$){
                        case 0:
                            return A2(Nu, cu, Au(Har(Q)));
                        case 1:
                            return A2(Nu, cu, Au(Iar(Q)));
                        default:
                            return A2(Nu, cu, Au(Nar(Q)));
                    }
                }(), b(y = m(r, {
                    le: A3(cN, Uir, Q, r.le)
                }), Uu(w([
                    A2(Wp, Mar, I),
                    C
                ])), w([
                    A2($cr, y, Q)
                ]));
            case 11:
                var R = A2(dG, n.a, r.fc), U = R.a, K = R.b, W = R.c, X = FM(r.le).s_, Y = A2(xc, b(r, Qp, g), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            var t = Qar(n.a), e = A3(cN, Uir, Uar(""), A3(cN, Uir, t, r.le)), u = m(r, {
                                le: e
                            });
                            return b(u, A2(Nu, cu, Au(Har(t))), w([
                                A2($cr, u, t)
                            ]));
                        case 1:
                            return t = Qar(X), b(r, A2(Nu, cu, Au(Iar(t))), w([
                                A2($cr, r, t)
                            ]));
                        default:
                            return t = Qar(X), b(r, A2(Nu, cu, Au(Nar(t))), w([
                                A2($cr, r, t)
                            ]));
                    }
                }, W));
                return C = Y.b, G = Y.c, b(m(y = Y.a, {
                    fc: U
                }), Uu(w([
                    A2(Wp, Rar, K),
                    C
                ])), G);
            case 12:
                var J = A2(dG, n.a, r.eB), nn = (U = J.a, K = J.b, W = J.c, FM(r.le).n6), rn = A2(xc, b(r, Qp, g), A2(Op, function(n) {
                    switch(n.$){
                        case 0:
                            var t = Tar(n.a), e = m(r, {
                                le: A3(cN, Uir, t, r.le)
                            });
                            return b(e, A2(Nu, cu, Au(Har(t))), w([
                                A2($cr, e, t)
                            ]));
                        case 1:
                            return t = Tar(nn), b(r, A2(Nu, cu, Au(Iar(t))), w([
                                A2($cr, r, t)
                            ]));
                        default:
                            return t = Tar(nn), b(r, A2(Nu, cu, Au(Nar(t))), w([
                                A2($cr, r, t)
                            ]));
                    }
                }, W));
                return C = rn.b, G = rn.c, b(m(y = rn.a, {
                    eB: U
                }), Uu(w([
                    A2(Wp, Par, K),
                    C
                ])), G);
            case 13:
                var tn = n.a;
                return b(m(r, {
                    fd: tn
                }), Qp, A2(Ik, 1, tn));
            case 14:
                var en = n.a, un = 3 === en.$ ? A2(cir, en.a, r.yZ.jb) : Ot, an = un.$ ? r.le : A3(cN, Uir, Tar(un), r.le);
                return b(m(r, {
                    bU: en,
                    le: an
                }), Qp, A2(Ik, 1, en));
            case 15:
                var cn = A3(Xnn, oir, hn = n.a, r.du), on = cn.b, fn = m(r, {
                    du: cn.a
                });
                return b(y = (Fn = pcr(hn)).$ ? fn : m(fn, {
                    A: A3(fN, !0, Fn.a, fn.A)
                }), on, g);
            case 16:
                var sn = A3(Xnn, air, hn = n.a, r.g7), ln = (C = sn.b, A2(jcr, hn, m(r, {
                    g7: sn.a
                })));
                return b(y = ln.a, Uu(w([
                    ln.b,
                    C
                ])), w([
                    A2($cr, r, hn)
                ]));
            case 17:
                return b(r, Qp, w([
                    A2($cr, r, hn = n.a)
                ]));
            case 19:
                var dn = n.a, vn = A4(Gtn, air, Dtn(sir), dn, r.g7);
                return on = vn.b, b(m(r, {
                    g7: vn.a
                }), on, g);
            case 20:
                var bn = pcr(hn = n.a);
                if (bn.$) return b(r, Qp, g);
                var mn = bn.a;
                if (A2(EL, mn, r.A)) {
                    var pn = A3(qL, !0, mn, r.A);
                    return b(m(y = A2(mcr, !1, r).a, {
                        A: pn
                    }), Qp, g);
                }
                return b(r, Qp, g);
            case 21:
                dn = n.a;
                var $n = A4(Gtn, xcr, Dtn(bir), dn, r.c8);
                return on = $n.b, b(m(r, {
                    c8: $n.a
                }), on, g);
            case 22:
                return b(r, MNn(n.a), g);
            case 23:
                dn = n.a;
                var gn = A4(Gtn, oir, Dtn(dir), dn, r.du);
                return on = gn.b, b(m(r, {
                    du: gn.a
                }), on, g);
            case 24:
                var hn = n.a, yn = function() {
                    var n = v(r.fu, r.c0);
                    n: for(;;)switch(n.a.$){
                        case 2:
                            return n.a.a;
                        case 1:
                            if (3 === n.b.$) return bcr(n.b.a);
                            break n;
                        default:
                            break n;
                    }
                    return "";
                }(), wn = !mu(yn) && function(n) {
                    var r = FM(n), t = !A2(_L, zir, r).$, e = !A2(_L, Sir, r).$, u = !A2(_L, Tir, r).$, a = !$6(Skn(r.vQ));
                    return e && u && (a || t);
                }(r.le) && !r.wk, xn = v(wn, r.fJ);
                if (xn.a) {
                    if (xn.b) return b(r, A2(Nu, cu, Au(Har(hn))), g);
                    var _n = a1n(r.mp), Cn = ux(r.dV), An = FM(r.le), kn = A3(yir, An, r.h0, r.yZ.jb);
                    return b(m(r, {
                        fJ: !0
                    }), A6(Ecr, r.g0, Cn, _n, yn, kn, War), g);
                }
                return b(r, Qp, g);
            default:
                var En = n.a;
                if (3 === En.$) {
                    var qn = En.a;
                    return b(m(r, {
                        c0: En
                    }), O0n(bcr(qn)), g);
                }
                return b(r, Qp, A2(Ik, 1, En));
        }
        var Fn, jn;
    }), Vcr = function(n) {
        return n.wz;
    }, Bcr = function(n) {
        return _8n(n.mp) && A2(xc, !1, A3(_un, me, A2(bb, Vcr, n.or), It(0)));
    }, Gcr = function(n) {
        if (_8n(n.mp)) {
            var r = n.or;
            if (1 === r.$) return vE;
            var t = r.a;
            return A2(zx, w([
                Gx("checkout-item-wrap")
            ]), A2(Qt, A2(zx, w([
                Gx("flex justify-between")
            ]), w([
                A2(PE, w([
                    uF(oen),
                    Qx,
                    sE
                ]), w([
                    _d(Ter(t))
                ])),
                A2(PE, w([
                    uF(Eun),
                    Qx
                ]), w([
                    _d(OK(Rnr(t)))
                ]))
            ])), function(n) {
                if (function(n) {
                    return "package" === n.CI;
                }(n)) {
                    var r = A2(fe, ", ", A2(Fu, function(n) {
                        return oe(n.wx) + " " + n.Ay;
                    }, function(n) {
                        return n.vb;
                    }(n)));
                    return w([
                        A2(zx, w([
                            Gx("package-item")
                        ]), w([
                            A2(PE, w([
                                uF(oen)
                            ]), w([
                                _d("Includes: " + r)
                            ]))
                        ]))
                    ]);
                }
                return g;
            }(t)));
        }
        return vE;
    }, zcr = {
        $: 1
    }, Scr = dF("noValidate"), Tcr = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), Pcr = F2(function(n, r) {
        return 3 === n.$ && Cz(A2(cir, n.a, r));
    }), Zcr = F2(function(n, r) {
        if (nEn(E8n(r.f2)) || Air(r.bU) || A2(Pcr, r.bU, r.yZ.jb)) return vE;
        var t, e = FM(r.le).n6;
        return A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(xir)),
                    gH((t = r.f2, n_n(E8n(t))))
                ]), w([
                    A2(c_, Par, A4(qz, n, w([
                        XG(e),
                        HG(n(_ir)),
                        CO(r.wk)
                    ]), A2(Fu, function(n) {
                        return A2(MG, g, n);
                    }, Cir(r.bU)), r.eB))
                ])),
                A2(YH, n, A3(Tcr, r.le, r.A, 8))
            ]))
        ]));
    }), Mcr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Lcr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Ncr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Hcr = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Icr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ocr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Qcr = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), Rcr = F4(function(n, r, t, e) {
        var u = FM(t), a = u.an, i = u.oD, c = u.oz, o = u.oB, f = u.oA, s = u.oC;
        return A2(zx, w([
            Gx("mb-5 md:mb-6")
        ]), w([
            A2(BE, w([
                xN(aF)
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(fI, w([
                        eI(a),
                        tI(Ocr),
                        rI(r),
                        W5n("chosen-name-checkbox")
                    ]), w([
                        _d(n(GEn))
                    ]))
                ]))
            ])),
            A2(bE, a, A2(BE, g, w([
                A2(lE, w([
                    tO(2),
                    VN(w([
                        Gx("mb-4 sm:mb-0")
                    ]))
                ]), w([
                    A2(EH, w([
                        vH(n(PEn)),
                        gH(KIn(i)),
                        LEn
                    ]), w([
                        A2(c_, Mar, A3(UEn, n, w([
                            ZEn(r)
                        ]), i))
                    ]))
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(EH, w([
                        vH(n(BEn)),
                        gH(!0),
                        LEn,
                        GIn(Wur(2))
                    ]), w([
                        PI(w([
                            NI(Wur(2)),
                            OI(c),
                            HI(A2(qc, Icr, Mcr)),
                            yI(A3(Qcr, t, e, 2)),
                            pI(r),
                            xO("choosen-first-name"),
                            FI(!0),
                            $O("given-name"),
                            pO("given-name"),
                            _I(Nar(Mcr(c))),
                            CI(Iar(Mcr(c)))
                        ]))
                    ]))
                ])),
                A2(lE, w([
                    TE(3),
                    tO(2)
                ]), w([
                    A2(EH, w([
                        vH(n(SEn)),
                        LEn,
                        GIn("field-chosen-middle-name")
                    ]), w([
                        PI(w([
                            NI("field-chosen-middle-name"),
                            OI(o),
                            HI(A2(qc, Icr, Ncr)),
                            pI(r),
                            xO("choosen-middle-name"),
                            FI(!0),
                            $O("additional-name"),
                            pO("additional-name"),
                            _I(Nar(Ncr(o))),
                            CI(Iar(Ncr(o)))
                        ]))
                    ]))
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(EH, w([
                        vH(n(zEn)),
                        gH(!0),
                        LEn,
                        GIn(Wur(3))
                    ]), w([
                        PI(w([
                            NI(Wur(3)),
                            OI(f),
                            HI(A2(qc, Icr, Lcr)),
                            yI(A3(Qcr, t, e, 3)),
                            pI(r),
                            xO("choosen-last-name"),
                            FI(!0),
                            $O("family-name"),
                            pO("family-name"),
                            _I(Nar(Lcr(f))),
                            CI(Iar(Lcr(f)))
                        ]))
                    ]))
                ])),
                A2(lE, w([
                    TE(3),
                    tO(2)
                ]), w([
                    A2(EH, w([
                        vH(n(TEn)),
                        LEn,
                        GIn("field-chosen-suffix")
                    ]), w([
                        PI(w([
                            NI("field-chosen-suffix"),
                            OI(s),
                            HI(A2(qc, Icr, Hcr)),
                            pI(r),
                            xO("chosen-suffix"),
                            FI(!0),
                            $O("honorific-suffix"),
                            pO("honorific-suffix"),
                            _I(Nar(Hcr(s))),
                            CI(Iar(Hcr(s)))
                        ]))
                    ]))
                ])),
                A2(lE, w([
                    tO(3)
                ]), g),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(YH, n, A3(Tcr, t, e, 2))
                ])),
                A2(lE, w([
                    TE(3),
                    tO(2)
                ]), g),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(YH, n, A3(Tcr, t, e, 3))
                ])),
                A2(lE, w([
                    TE(3),
                    tO(2)
                ]), g)
            ])))
        ]));
    }), Ucr = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Kcr = F4(function(n, r, t, e) {
        var u = FM(t).qN;
        return A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH("Email"),
                    gH(!0),
                    GIn(Wur(4))
                ]), w([
                    PI(w([
                        NI(Wur(4)),
                        OI(u),
                        jI("me@example.com"),
                        HI(A2(qc, Icr, Ucr)),
                        yI(A3(Qcr, t, e, 4)),
                        pI(r),
                        xO("email"),
                        FI(!0),
                        $O("email"),
                        pO("email"),
                        _I(Nar(Ucr(u))),
                        CI(Iar(Ucr(u))),
                        hI(1)
                    ])),
                    A2(YH, n, A3(Tcr, t, e, 4))
                ]))
            ]))
        ]));
    }), Wcr = function(n) {
        return 3 === n.$ ? n.a : g;
    }, Xcr = F2(function(n, r) {
        var t = FM(r.le), e = t.s_, u = t.s$, a = Pir(e);
        if (nEn(q8n(r.f2)) || nE(Wcr(r.fd)) || Cz(gir(r.yZ.jb))) return vE;
        var i, c = a ? w([
            xN(aF)
        ]) : g;
        return A2(zx, g, w([
            A2(BE, c, w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(EH, w([
                        vH(n(Zir)),
                        gH((i = r.f2, n_n(q8n(i))))
                    ]), w([
                        A2(c_, Rar, A4(qz, n, w([
                            XG(e),
                            HG(n(Lir)),
                            CO(r.wk)
                        ]), A2(Fu, function(n) {
                            return A2(MG, g, n);
                        }, Wcr(r.fd)), r.fc))
                    ])),
                    A2(YH, n, A3(Tcr, r.le, r.A, 6))
                ]))
            ])),
            A2(bE, a, A2(BE, g, w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    PI(w([
                        NI(Wur(7)),
                        OI(u),
                        HI(A2(qc, Icr, Uar)),
                        yI(A3(Qcr, r.le, r.A, 7)),
                        pI(r.wk),
                        FI(!0),
                        _I(Nar(Uar(u))),
                        CI(Iar(Uar(u)))
                    ])),
                    A2(YH, n, A3(Tcr, r.le, r.A, 7))
                ]))
            ])))
        ]));
    }), Ycr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Jcr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nor = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ror = function(n) {
        return {
            $: 4,
            a: n
        };
    }, tor = F5(function(n, r, t, e, u) {
        var a = FM(e), i = a.yx, c = a.rA, o = a.ue, f = a.sV, s = a.ym;
        return A2(BE, w([
            VN(w([
                Gx("mb-3 md:mb-4")
            ]))
        ]), w([
            A2(lE, w([
                tO(2),
                VN(w([
                    Gx("mb-4 sm:mb-0")
                ]))
            ]), w([
                A2(EH, w([
                    vH(n(mL)),
                    gH(KIn(i)),
                    LEn
                ]), w([
                    A2(c_, nir, A3(UEn, n, w([
                        ZEn(r)
                    ]), i))
                ]))
            ])),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(EH, w([
                    vH(n(lL)),
                    gH(!0),
                    LEn,
                    GIn(Wur(0))
                ]), w([
                    PI(w([
                        NI(Wur(0)),
                        OI(c),
                        HI(A2(qc, Icr, Ycr)),
                        yI(A3(Qcr, e, u, 0)),
                        pI(r || t),
                        xO("first-name"),
                        FI(!0),
                        {
                            $: 16,
                            a: !0
                        },
                        $O("given-name"),
                        pO("given-name"),
                        _I(Nar(Ycr(c))),
                        CI(Iar(Ycr(c)))
                    ]))
                ]))
            ])),
            A2(lE, w([
                TE(3),
                tO(2)
            ]), w([
                A2(EH, w([
                    vH(n(vL)),
                    LEn,
                    GIn("field-middle-name")
                ]), w([
                    PI(w([
                        NI("field-middle-name"),
                        OI(o),
                        HI(A2(qc, Icr, nor)),
                        pI(r),
                        xO("middle-name"),
                        FI(!0),
                        $O("additional-name"),
                        pO("additional-name"),
                        _I(Nar(nor(o))),
                        CI(Iar(nor(o)))
                    ]))
                ]))
            ])),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(EH, w([
                    vH(n(dL)),
                    gH(!0),
                    LEn,
                    GIn(Wur(1))
                ]), w([
                    PI(w([
                        NI(Wur(1)),
                        OI(f),
                        HI(A2(qc, Icr, Jcr)),
                        yI(A3(Qcr, e, u, 1)),
                        pI(r || t),
                        xO("last-name"),
                        FI(!0),
                        $O("family-name"),
                        pO("family-name"),
                        _I(Nar(Jcr(f))),
                        CI(Iar(Jcr(f)))
                    ]))
                ]))
            ])),
            A2(lE, w([
                TE(3),
                tO(2)
            ]), w([
                A2(EH, w([
                    vH(n(bL)),
                    LEn,
                    GIn("field-suffix")
                ]), w([
                    PI(w([
                        NI("field-suffix"),
                        OI(s),
                        HI(A2(qc, Icr, ror)),
                        pI(r || t),
                        xO("suffix"),
                        FI(!0),
                        $O("honorific-suffix"),
                        pO("honorific-suffix"),
                        _I(Nar(ror(s))),
                        CI(Iar(ror(s)))
                    ]))
                ]))
            ])),
            A2(lE, w([
                tO(2)
            ]), g),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(YH, n, A3(Tcr, e, u, 0))
            ])),
            A2(lE, w([
                TE(3),
                tO(2)
            ]), g),
            A2(lE, w([
                TE(3)
            ]), w([
                A2(YH, n, A3(Tcr, e, u, 1))
            ])),
            A2(lE, w([
                TE(3),
                tO(2)
            ]), g)
        ]));
    }), eor = F3(function(n, r, t) {
        var e = FM(t).vQ;
        return A2(BE, g, w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(EH, w([
                    vH(n(rZ)),
                    gH(e.wZ)
                ]), w([
                    A2(c_, Yar, A3(NFn, n, w([
                        BFn(r)
                    ]), e))
                ]))
            ]))
        ]));
    }), uor = F2(function(n, r) {
        var t = A4(Q5n, n, r.mp, r.FN, r.yZ.EX), e = 2 !== r.fu.$;
        return A2(Yjn, w([
            Gx("mx-1"),
            Scr(!0),
            rDn(zcr)
        ]), w([
            A5(tor, n, r.wk, r.wL, r.le, r.A),
            A4(Rcr, n, r.wk, r.le, r.A),
            A4(Kcr, n, r.wk, r.le, r.A),
            A3(eor, n, r.wk, r.le),
            A2(Xcr, n, r),
            A2(Zcr, n, r),
            A4(s7n, t, r.wk, e, zcr)
        ]));
    }), aor = function(n) {
        return n.zy;
    }, ior = F2(function(n, r) {
        return _8n(r.mp) ? A2(i_, w([
            uE(AD),
            uE(aF)
        ]), w([
            _d(n(aor))
        ])) : vE;
    }), cor = F2(function(n, r) {
        return r.EW(n);
    }), oor = F3(function(n, r, t) {
        return A2(t.xO, n, r);
    }), sor = F2(function(n, r) {
        return r.xP(n);
    }), lor = F2(function(n, r) {
        if (_8n(r.mp)) {
            var t = r.or;
            return 1 === t.$ ? vE : _d(n(cor(Ter(t.a))));
        }
        return _d(n(function() {
            var n = function(n) {
                return n.o0;
            }(r.mp);
            if (n.$) return sor(ax(r.dV));
            var t = n.a;
            return A2(oor, ax(r.dV), t);
        }()));
    }), dor = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("flex justify-center w-full")
            ]), w([
                A2(zx, w([
                    Gx("flex-col w-full md:w-4/5 lg:w-3/5")
                ]), w([
                    A2(CF, w([
                        gW,
                        uE(eE),
                        A2(U5n, 1, M5n),
                        uF(rD),
                        A2(Z5n, 1, xD)
                    ]), w([
                        A2(lor, n, r)
                    ])),
                    Gcr(r),
                    A2(ior, n, r),
                    A2(uor, n, r)
                ]))
            ]))
        ]);
    }), vor = F2(function(n, r) {
        return {
            g8: function() {
                var t;
                switch(r.c7.$){
                    case 1:
                        return Nx;
                    case 2:
                        return w([
                            Tur(r.dV)
                        ]);
                    default:
                        return Bcr(r) ? w([
                            (t = r.dV, A2(zx, w([
                                Gx("panel w-full signup-out-of-stock-error")
                            ]), w([
                                A2(i_, g, w([
                                    _d("This item is not currently available for sale")
                                ])),
                                s_,
                                A2(f_, g, w([
                                    _d("Please contact us and let us know the item you would like to purchase at "),
                                    W0n(bV(t)),
                                    A3(K0n, "or", Xw(t), bV(t))
                                ]))
                            ])))
                        ]) : A2(dor, n, r);
                }
            }(),
            yx: Bcr(r) ? "Out of Stock" : ax(r.dV)
        };
    }), bor = J0n({
        Cl: Bar,
        CQ: Gar,
        Fj: zar,
        F4: function() {
            return t2n(Sar);
        },
        Gv: Dcr,
        GB: vor
    }), mor = function(n) {
        return {
            $: 13,
            a: n
        };
    }, por = function(n) {
        return {
            $: 14,
            a: n
        };
    }, $or = function(n) {
        return {
            $: 7,
            a: n
        };
    }, gor = "custom-details-container", hor = w([
        0,
        1
    ]), yor = function(n) {
        return n ? "Uses Tobacco" : "Forms";
    }, wor = {
        ng: Ot,
        cT: g,
        tD: Ot,
        ur: Ot,
        y3: !1,
        A: A2(pZ, hor, yor)
    }, xor = F4(function(n, r, t, e) {
        var u = GYn(r), a = V6n(t), i = function() {
            var r = A7n(e.jb);
            if (r.$) return Qp;
            var u = r.a;
            return A4(err, t.g0, ux(n), u, mor);
        }(), c = LGn(t), o = c.a, f = c.b, s = function() {
            var r = v(a, t.FN);
            if (3 === r.b.$) {
                if (r.a.$) return b(g, kc, c = r.b.a);
                var e = r.a.a, c = r.b.a;
                return b(w([
                    A5(c8n, t.g0, ux(n), a1n(u), e, $or),
                    i,
                    A2(Wp, por, f)
                ]), A_, c);
            }
            return b(g, kc, g);
        }(), l = s.a, d = s.b, m = s.c;
        return v({
            gk: $6n(t),
            g0: t.g0,
            nX: Ot,
            pt: Ot,
            hG: p7,
            hH: t.hH,
            az: o,
            ld: t.ld,
            le: vZ(wor),
            fm: A_,
            fu: a,
            iK: A_,
            dV: n,
            wk: !1,
            fL: Ot,
            fM: Ot,
            c7: d,
            dd: A3(j7n, Vx(t.ld), gor, S7n(n)),
            mp: u,
            cr: kc,
            f2: r,
            FN: m,
            bQ: ZSn,
            yZ: e
        }, Uu(l));
    }), _or = F2(function(n, r) {
        return v(r, Qp);
    }), Cor = F2(function(n, r) {
        return r;
    }), Aor = function(n) {
        return {
            $: 8,
            a: n
        };
    }, kor = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Eor = function(n) {
        return {
            $: 9,
            a: n
        };
    }, qor = nr("onTabSelected", M$), For = {
        $: 10
    }, jor = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Dor = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Vor = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), Bor = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Gor = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zor = F3(function(n, r, t) {
        return {
            $: 9,
            a: n,
            b: r,
            c: t
        };
    }), Sor = {
        $: 0
    }, Tor = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Por = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Zor = {
        F1: Atn(300),
        Gs: function(n) {
            return {
                $: 4,
                a: n
            };
        }
    }, Mor = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Lor = function(n) {
        return A2(Nu, Mor, Au(n));
    }, Nor = function(n) {
        return n.sl;
    }, Hor = F2(function(n, r) {
        var t = n.c7;
        return 3 === t.$ ? mb(A2(no, function(n) {
            return i(Nor(n), r);
        }, t.a)) : Ot;
    }), Ior = function(n) {
        var r = v(tTn(n.dV), A2(bb, Err, n.nX));
        return !(!r.a || r.b.$) && function(n) {
            return n.qv;
        }(r.b.a);
    }, Oor = function(n) {
        return n.sR;
    }, Qor = function(n) {
        var r = n.cr;
        return 3 === r.$ && !nE(r.a);
    }, Ror = function(n) {
        return function(n) {
            return n.sl;
        }(n.le);
    }, Uor = function(n) {
        return n.rL;
    }, Kor = F2(function(n, r) {
        return mb(A2(no, function(n) {
            return i(Ror(n), mPn(r));
        }, Uor(n)));
    }), Wor = function(n) {
        return function(n) {
            return n.sl;
        }(n.rH);
    }, Xor = function(n) {
        return n.rK;
    }, Yor = F2(function(n, r) {
        return A2(no, function(r) {
            return i(Wor(r), kZn(n));
        }, Xor(r));
    }), Jor = F3(function(n, r, t) {
        var e = A2(xc, g, A2(Op, Yor(t), A2(Kor, n, r)));
        return BHn(t) && nE(e);
    }), nfr = F2(function(n, r) {
        return A2(no, A2(Jor, n, r), jHn(r));
    }), rfr = F2(function(n, r) {
        var t = n.cr;
        if (3 === t.$) {
            var e = t.a;
            return Qor(n) && !nE(vc(A2(Fu, nfr(r), e)));
        }
        return !1;
    }), tfr = F2(function(n, r) {
        return A2(FF, function(n) {
            return i(Nor(n), r);
        }, n);
    }), efr = F2(function(n, r) {
        return 3 === n.$ && i(A2(tfr, n.a, r), It(0));
    }), ufr = function(n) {
        return n.u8;
    }, afr = function(n) {
        var r = n.iK;
        return 3 === r.$ && ufr(r.a);
    }, ifr = F2(function(n, r) {
        if (afr(n) && A2(efr, n.c7, Nor(r))) return !1;
        var t = Oor(r);
        return Ior(n) && function(n) {
            return OS(n);
        }(t) || A2(rfr, n, r);
    }), cfr = F2(function(n, r) {
        return mb(A2(no, ifr(n), r));
    }), ofr = function(n) {
        return n.ng;
    }, ffr = function(n) {
        return n.nr;
    }, sfr = function(n) {
        return n.n5;
    }, lfr = function(n) {
        return n.sl;
    }, dfr = F2(function(n, r) {
        return A2(Fu, function(t) {
            var e = A2(Op, lfr, r), u = kZn(t), a = A2(no, function(n) {
                return i(Wor(n), u);
            }, A2(xc, g, A2(Op, Xor, r))), c = mPn(n);
            return {
                nr: function() {
                    var n;
                    switch(GHn(t)){
                        case 2:
                            return n = A2(xc, !1, A2(bb, sfr, mb(a))), VZn(n);
                        case 0:
                            return function(n) {
                                return zZn(n);
                            }(A2(xc, "", A2(bb, ffr, mb(a))));
                        default:
                            return AZn(A2(n$, ffr, a));
                    }
                }(),
                lf: c,
                dF: u,
                lg: e
            };
        }, jHn(n));
    }), vfr = F2(function(n, r) {
        var t = mb(A2(no, function(n) {
            return i(Ror(n), mPn(r.aj));
        }, n));
        return m(r, {
            U: A2(dfr, r.aj, t)
        });
    }), bfr = F2(function(n, r) {
        return A2(Fu, function(n) {
            var t = "input-" + mPn(n);
            return A2(vfr, Uor(r), A2(pPn, t, n));
        }, n);
    }), mfr = function(n) {
        return n.ur;
    }, pfr = function(n) {
        return n.y3;
    }, $fr = F2(function(n, r) {
        return {
            ng: ofr(r),
            cT: A2(bfr, n, r),
            tD: It(Nor(r)),
            ur: mfr(r),
            y3: pfr(r),
            A: A2(pZ, hor, yor)
        };
    }), gfr = F2(function(n, r) {
        return A2(xc, wor, A2(Op, $fr(n), r));
    }), hfr = function(n) {
        return n.$ ? 1 : 0;
    }, yfr = F2(function(n, r) {
        var t = hfr(n), e = m(r, {
            A: A3(fN, !0, t, r.A)
        });
        return m(e, n.$ ? {
            y3: n.a
        } : {
            cT: n.a
        });
    }), wfr = F2(function(n, r) {
        var t = mb(Ae(n));
        return !t.$ && i(Nor(t.a), r);
    }), xfr = F3(function(n, r, t) {
        return A2(bb, function(t) {
            return A2(NR, t + r, n);
        }, A2(tfr, n, t));
    }), _fr = F2(function(n, r) {
        return A3(xfr, n, 1, r);
    }), Cfr = F2(function(n, r) {
        var t = A2(Hor, r, n);
        if (t.$) return b(r, Qp, g);
        var e, u = t.a, a = 3 === (e = r.cr).$ ? e.a : g;
        return b(m(r, {
            le: vZ(A2($fr, a, u))
        }), cZn(Nor(u)), g);
    }), Afr = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), kfr = F3(function(n, r, t) {
        return A2(Fu, function(n) {
            return v(t, n);
        }, A3(Afr, n, r, t));
    }), Efr = function(n) {
        var r = FM(n);
        return vc(A2(Fu, A2(kfr, n, r.A), hor));
    }, qfr = F3(function(n, r, t) {
        return A2(bb, function(n) {
            return It(A2(fe, ": ", w([
                n ? "Dependent " + oe(n) : "Owner",
                r
            ])));
        }, A2(tfr, t, n));
    }), Ffr = F2(function(n, r) {
        var t = FM(n.le), e = v(n.c7, t.tD);
        if (3 !== e.a.$ || e.b.$) return g;
        var u = e.a.a;
        return A2(xc, g, A2(Op, function(r) {
            var t = _c(n.yZ.EX), e = A2(Op, Oc, mb(Efr(n.le)));
            return w([
                d8n(It({
                    eZ: A2(xc, g, A2(Op, _K, e)),
                    ru: r,
                    Fh: t
                }))
            ]);
        }, A3(qfr, e.b.a, function(n) {
            return yor(hfr(n));
        }(r), u)));
    }), jfr = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments",
            r,
            "forms"
        ]), fM(n));
    }), Dfr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), ek(Fwn), e, pk(A2(jfr, r, t)));
    }), Vfr = F6(function(n, r, t, e, u, a) {
        return {
            ng: t,
            rL: u,
            sl: n,
            sR: e,
            ur: r,
            y3: a
        };
    }), Bfr = F3(function(n, r, t) {
        return {
            le: r,
            rK: t,
            sl: n
        };
    }), Gfr = F3(function(n, r, t) {
        return {
            nr: r,
            n5: t,
            rH: n
        };
    }), zfr = A3(nk, "id", M$, au(function(n) {
        return {
            sl: n
        };
    })), Sfr = A2($A, zfr, au(cu)), Tfr = A3(nk, "boolean_answer", uC(ru), A3(nk, "answer", uC(M$), A3(nk, "form_item", Sfr, au(Gfr)))), Pfr = A2($A, Tfr, au(cu)), Zfr = A3(nk, "id", M$, au(function(n) {
        return {
            sl: n
        };
    })), Mfr = A2($A, Zfr, au(cu)), Lfr = A3(nk, "form_response_items", ek(Pfr), A3(nk, "form", Mfr, A3(nk, "id", M$, au(Bfr)))), Nfr = A2($A, Lfr, au(cu)), Hfr = A3(nk, "uses_tobacco", ru, A3(nk, "form_responses", ek(Nfr), A3(nk, "known_practice", uC(CQ), A3(nk, "age", uC(O$), A3(nk, "name", uC(M$), A3(nk, "id", M$, au(Vfr))))))), Ifr = A2($A, Hfr, au(cu)), Ofr = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments",
            r,
            "custom_details"
        ]), fM(n));
    }), Qfr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), ek(Ifr), e, pk(A2(Ofr, r, t)));
    }), Rfr = F2(function(n, r) {
        return {
            pd: r,
            sl: n
        };
    }), Ufr = function(n) {
        return A2(xc, vE, A2(Op, function(n) {
            return A2(PE, w([
                Hx(w([
                    Gx("tabs-member-age")
                ]))
            ]), w([
                _d(" (" + oe(n) + "y/o)")
            ]));
        }, n));
    }, Kfr = function(n) {
        return A2(xc, vE, A2(Op, function(n) {
            return A2(PE, w([
                Hx(w([
                    Gx("tabs-member-name")
                ]))
            ]), w([
                _d(n)
            ]));
        }, n));
    }, Wfr = F2(function(n, r) {
        return A2(zx, g, w([
            Kfr(n),
            Ufr(r)
        ]));
    }), Xfr = F3(function(n, r, t) {
        return A2(qF, A2(Rfr, n, A2(Wfr, r, t)), {
            yB: function(n) {
                return n.sl;
            },
            yD: function(n) {
                return n.pd;
            }
        });
    }), Yfr = function(n) {
        return A3(Xfr, Nor(n), mfr(n), ofr(n));
    }, Jfr = function(n) {
        var r = A2(bb, Err, n.nX);
        if (r.$) return !1;
        var t = r.a;
        return G8n(n.f2) && Cz(function(n) {
            return n.yF;
        }(t));
    }, nsr = function(n) {
        if (Qor(n)) {
            var r = FM(n.le);
            return w([
                v("form_responses", A2(WU, JPn, r.cT))
            ]);
        }
        return g;
    }, rsr = function(n) {
        return Ior(n) ? w([
            UPn(n.az)
        ]) : g;
    }, tsr = function(n) {
        if (Jfr(n)) {
            var r = KTn(n.bQ);
            return w([
                v("uses_tobacco", Yw(r))
            ]);
        }
        return g;
    }, esr = function(n) {
        return vc(w([
            rsr(n),
            nsr(n),
            tsr(n)
        ]));
    }, usr = "custom-forms", asr = function(n) {
        return MNn(n ? "tobacco-use" : usr);
    }, isr = F6(function(n, r, t, e, u, a) {
        return A4(Dj, GQ(n), Ifr, a, A2(dM, function(n) {
            return rx(w([
                v("member", rx(n))
            ]));
        }(u), pk(A2(bk, w([
            e
        ]), A2(Ofr, r, t)))));
    }), csr = function(n) {
        return n.rG.so;
    }, osr = F2(function(n, r) {
        var t = A2(Ekn, function(n) {
            return function(n) {
                return nE(function(n) {
                    return A2(n$, ZHn(n.U), jHn(n.aj));
                }(n));
            }(n);
        }, r.cT);
        return Qor(n) && !t ? w([
            v(0, nL(csr))
        ]) : g;
    }), fsr = F2(function(n, r) {
        if (Ior(r)) {
            var t = A2(wZn, n, r.az);
            return v(t.a, t.b);
        }
        return v(r.az, !0);
    }), ssr = F2(function(n, r) {
        var t = FM(r.le), e = function() {
            if (n) {
                var e = m(t, {
                    A: n ? DL(t.A) : t.A
                });
                return m(r, {
                    le: A2(MWn, e, r.le)
                });
            }
            return r;
        }(), u = function(n) {
            var r = A2(CL, function(n) {
                return XM(w([
                    osr(n)
                ]));
            }(n), n.le);
            return r.$ ? v(r.a, !1) : v(r.a.a, !0);
        }(e), a = u.a, i = u.b, c = A2(fsr, n, r), o = c.b;
        return v(m(e, {
            az: c.a,
            le: a
        }), i && o);
    }), lsr = F5(function(n, r, t, e, u) {
        if (afr(u) && A2(efr, u.c7, r)) return b(!1, u, w([
            A2(Nu, cu, Au(Gor(e)))
        ]));
        if (c = FM(u.le).A, A2(Wk, function(n) {
            return A2(EL, n, c);
        }, hor) || OS(e)) {
            var a = A2(ssr, !0, u), i = a.a;
            return a.b ? b(!1, m(i, {
                wk: !0
            }), w([
                A6(isr, i.g0, ux(i.dV), n, r, esr(i), t(e))
            ])) : b(!0, i, A2(Qt, A2(xc, Qp, A2(Op, asr, function(n) {
                return A2(Op, Ue, mb(Efr(n)));
            }(i.le))), function(n) {
                var r = v(FM(n.le).tD, n.c7);
                if (r.a.$ || 3 !== r.b.$) return g;
                var t = r.a.a, e = r.b.a;
                return A2(Fu, function(n) {
                    var r = n.b, u = A3(qfr, t, yor(n.a), e);
                    if (u.$) return Qp;
                    var a = u.a;
                    return c4n({
                        eZ: w([
                            r
                        ]),
                        ru: a
                    });
                }, Efr(n.le));
            }(i)));
        }
        var c;
        return b(!1, u, w([
            A2(Nu, cu, Au(Gor(e)))
        ]));
    }), dsr = function(n) {
        return {
            $: 16,
            a: n
        };
    }, vsr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, bsr = function(n) {
        return A2(C7n, "billing_period", n);
    }, msr = function(n) {
        return n.ht;
    }, psr = F3(function(n, r, t) {
        return t.$ ? g : w([
            v(n, r(t.a))
        ]);
    }), $sr = function(n) {
        var r = A2(Qt, v("members", n.Bz), A2(xc, g, A2(Op, function(n) {
            return w([
                ptr(n)
            ]);
        }, n.nX))), t = A2(bb, function(n) {
            var r = A2(i$, function(n) {
                switch(n){
                    case "monthly":
                        return au(0);
                    case "quarterly":
                        return au(1);
                    case "semi_annually":
                        return au(2);
                    case "annually":
                        return au(3);
                    default:
                        return AA("Unsupported period name: " + n);
                }
            }(n), "{}");
            return r.$ ? Ot : It(r.a);
        }, n.Ah), e = $(A3(psr, "coupon_code", function(n) {
            return K_n(msr(n));
        }, n.pt), A3(psr, "period_in_months", function(n) {
            return NQ(lU(n));
        }, t));
        return rx($(r, e));
    }, gsr = function(n) {
        var r = n;
        return rx(w([
            v("name", K_n(r.ur)),
            v("dob", RTn(r.qj)),
            v("relationship", OTn(r.wQ)),
            v("uses_tobacco", Yw(r.y3))
        ]));
    }, hsr = function(n) {
        return n.sl;
    }, ysr = F3(function(n, r, t) {
        var e = KTn(t.bQ), u = FM(t.le).tD;
        if (i(It(hsr(n)), u)) return A3(gtr, n, w([
            v("uses_tobacco", Yw(e))
        ]), g);
        var a = A2(SS, function(r) {
            return i(Nor(r), hsr(n));
        }, r);
        return a.$ ? gsr(n) : A3(gtr, n, w([
            v("uses_tobacco", Yw(pfr(a.a)))
        ]), g);
    }), wsr = F2(function(n, r) {
        var t = b(r.c7, r.nX, dtr(r.mp));
        if (3 === t.a.$ && !t.b.$ && t.c) {
            var e = t.a.a, u = t.b.a, a = A2(WU, function(n) {
                return A3(ysr, n, e, r);
            }, ytr(n)), i = $sr({
                Ah: bsr(r.yZ.jb),
                nX: It(u),
                pt: r.pt,
                Bz: a
            });
            return A4(dPn, r.g0, ux(r.dV), i, vsr);
        }
        return Qp;
    }), xsr = function(n) {
        var r = n.iK;
        if (3 === r.$) {
            var t = r.a;
            return C8n(n.mp) ? A2(wsr, t, n) : A4(btr, n.g0, ux(n.dV), Qnr(t), dsr);
        }
        return Qp;
    }, _sr = F2(function(n, r) {
        return m(n, {
            y3: r
        });
    }), Csr = F2(function(n, r) {
        switch(n.$){
            case 7:
                var t = n.a, e = m(r, {
                    iK: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (gn = r.gk).$ ? Qp : o5n(gn.a), c = ux(r.dV), o = Qnr(u), f = $4n(u), s = w(f ? [
                        W6n(h5n(u)),
                        I6n,
                        H6n
                    ] : [
                        W6n(h5n(u)),
                        H6n
                    ]);
                    return b(m(e, {
                        gk: Ot,
                        nX: It(cnr(u)),
                        hH: f
                    }), Uu(w([
                        A4(Qfr, r.g0, c, o, jor),
                        A4(Dfr, r.g0, c, o, Bor),
                        a
                    ])), s);
                }
                return b(e, Qp, A2(Ik, 1, t));
            case 3:
                if (e = m(r, {
                    c7: A = n.a
                }), 3 === A.$) {
                    var l = A.a, d = A2(_sr, r.bQ, function(n) {
                        var r = v(Jfr(n), n.c7);
                        if (r.a && 3 === r.b.$) {
                            var t = mb(r.b.a);
                            return !t.$ && pfr(t.a);
                        }
                        return !1;
                    }(e)), p = function(n) {
                        var r = v(Ior(n), n.c7);
                        return r.a && 3 === r.b.$ ? A2(bb, Oor, mb(r.b.a)) : Ot;
                    }(e), $ = p.$ ? r.az : A2(dHn, r.az, p.a), h = 3 === ($n = r.iK).$ && A4(p5n, r.mp, r.FN, h5n($n.a), r.yZ.EX), y = 3 === (pn = e.cr).$ ? pn.a : g, x = h ? A2(Y$, A2(cfr, e, l), function(n) {
                        return mb(Ae(n));
                    }(l)) : mb(l), _ = ve(l) > 1 ? w([
                        A3(zor, A2(Fu, Yfr, l), A2(xc, "", A2(Op, Nor, x)), !0)
                    ]) : g;
                    return b(m(e, {
                        az: $,
                        le: vZ(A2(gfr, y, x)),
                        bQ: d
                    }), Uu(w([
                        xsr(e),
                        A4(a5n, 4, e.FN, e.f2, g)
                    ])), _);
                }
                return b(r, Qp, A2(Ik, 1, A));
            case 1:
                var C = n.a, A = n.b;
                if (e = m(r, {
                    wk: !1
                }), 3 === A.$) {
                    var k = A.a, E = function() {
                        var n = r.c7;
                        if (3 === n.$) {
                            var t = n.b;
                            return A2(tC, A2(Fu, function(n) {
                                return i(Nor(n), Nor(k)) ? k : n;
                            }, n.a), t);
                        }
                        return r.c7;
                    }();
                    return b(m(e, {
                        c7: E
                    }), A2(Nu, cu, Au(Gor(C))), g);
                }
                return b(e, Qp, A2(Ik, 1, A));
            case 0:
                var q = FM(r.le), F = v(r.fu, q.tD);
                if (F.a.$ || F.b.$) return b(r, Qp, g);
                var j = A5(lsr, o = F.a.a, Q = F.b.a, Dor, Ot, r);
                return b(U = j.b, Uu(K = j.c), g);
            case 4:
                var D = n.a, V = A4(Gtn, Zor, Dtn(Lor), D, r.hG), B = V.b;
                return b(m(r, {
                    hG: V.a
                }), B, g);
            case 5:
                return b(r, MNn(n.a), g);
            case 6:
                var G = n.a;
                n: for(;;)switch(G.$){
                    case 3:
                        return b(m(r, {
                            fL: It(G.a),
                            fM: Ot
                        }), Qp, g);
                    case 2:
                        if (5 === G.a.$) {
                            var z = It(f9n(w([
                                Zk(Crr(G.a.b))
                            ])));
                            return b(m(r, {
                                fM: z
                            }), Qp, g);
                        }
                        break n;
                    default:
                        break n;
                }
                return b(r, Qp, A2(Ik, 1, G));
            case 8:
                var S = A2(ftr, n.a, r.dd), T = S.a, P = S.b, Z = S.c, M = Z.$ || Z.a ? Qp : A2(Nu, cu, Au(Sor));
                return b(m(r, {
                    dd: T
                }), Uu(w([
                    A2(Wp, Aor, P),
                    M
                ])), g);
            case 9:
                var L = A2(xc, Ku, A2(bb, function(n) {
                    return wc(n);
                }, _u(n.a))), N = A2(xc, Ku, wc(r.yZ.EX));
                return b(r, A4(s8n, r.mp, r.FN, N, L) ? A2(f5n, N, L) : Qp, w([
                    For
                ]));
            case 10:
                var H = n.a, I = FM(r.le), O = v(r.fu, I.tD);
                if (O.a.$ || O.b.$) return b(r, Qp, g);
                var Q, R = A5(lsr, o = O.a.a, Q = O.b.a, Dor, It(H), r), U = R.b, K = R.c;
                return _ = R.a ? w([
                    Tor(Q)
                ]) : g, b(U, Uu(K), _);
            case 11:
                var W = n.a;
                if (e = m(r, {
                    cr: W
                }), 3 === W.$) {
                    var X = W.a, Y = FM(r.le);
                    return b(m(e, {
                        le: vZ(A2(gfr, X, x = A2(Hor, r, A2(xc, "", Y.tD))))
                    }), Qp, g);
                }
                return b(r, Qp, A2(Ik, 1, W));
            case 12:
                var J = n.a, nn = n.b, rn = FM(r.le).cT, tn = A2(TZn, nn, J), en = tn.a, un = tn.b, an = function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(A3(a9, function(n) {
                    return i(yPn(n), yPn(en));
                }, function() {
                    return en;
                }, rn));
                return b(e = m(r, {
                    le: A3(cN, yfr, an, r.le)
                }), A2(Wp, Vor(en), un), A2(Ffr, e, an));
            case 2:
                var cn = n.a;
                return cn.$ ? function(n) {
                    var r = b(FM(n.le).tD, n.c7, n.cr);
                    if (r.a.$ || 3 !== r.b.$ || 3 !== r.c.$) return b(n, Qp, g);
                    var t = r.a.a, e = r.b.a, u = r.c.a;
                    if (A2(wfr, e, t)) return b(n, A4(e5n, 4, n.FN, n.f2, g), w([
                        U6n
                    ]));
                    var a = A2(_fr, e, t);
                    if (a.$) return b(n, Qp, g);
                    var i = a.a;
                    return b(m(n, {
                        le: vZ(A2($fr, u, i))
                    }), cZn(Nor(i)), w([
                        Tor(Nor(i))
                    ]));
                }(r) : A2(Cfr, cn.a, r);
            case 13:
                var on = n.a;
                return 3 === on.$ ? b(e = m(r, {
                    pt: It(on.a)
                }), xsr(e), g) : b(r, Qp, A2(Ik, 1, on));
            case 14:
                var fn = A2(CZn, n.a, r.az), sn = fn.b;
                return b(m(r, {
                    az: fn.a
                }), A2(Wp, por, sn), g);
            case 15:
                var ln = A2(ZNn, n.a, r.bQ), dn = (sn = ln.b, ln.c), vn = (e = m(r, {
                    bQ: ln.a
                }), function() {
                    if (dn.$) return v(Qp, g);
                    var n = dn.a;
                    return v(xsr(e), A2(Ffr, e, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }()), bn = vn.a, mn = vn.b;
                return b(e, Uu(w([
                    A2(Wp, Por, sn),
                    bn
                ])), mn);
            default:
                return b(m(r, {
                    fm: n.a
                }), Qp, g);
        }
        var pn, $n, gn;
    }), Asr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ksr = F4(function(n, r, t, e) {
        return v(yPn(e), A2(c_, Vor(e), A3(rIn, n, w([
            Asr(r),
            FHn(t)
        ]), e)));
    }), Esr = F3(function(n, r, t) {
        if (Qor(t)) {
            var e = FM(t.le), u = e.cT, a = A2(oN, 0, e.A);
            return A3(gz, "div", w([
                DF(usr)
            ]), A2(Fu, A3(ksr, n, r, a), u));
        }
        return vE;
    }), qsr = F2(function(n, r) {
        return Ior(r) ? A2(zx, g, w([
            A2(c_, por, A2(dIn, n, r.az))
        ])) : vE;
    }), Fsr = F3(function(n, r, t) {
        return Jfr(t) ? A2(zx, g, w([
            A2(zx, g, w([
                A2(c_, Por, A3(hIn, n, r, t.bQ))
            ]))
        ])) : vE;
    }), jsr = F3(function(n, r, t) {
        if (afr(t) && function(n) {
            var r = FM(n.le).tD;
            return !r.$ && A2(efr, n.c7, r.a);
        }(t)) {
            var e = FM(t.le).ur;
            return A2(f_, g, w([
                _d("No details need to be completed" + (e.$ ? "" : " for " + e.a) + ".")
            ]));
        }
        return A2(zx, w([
            Gx("custom-details")
        ]), w([
            A2(qsr, n, t),
            A3(Esr, n, r, t),
            A3(Fsr, n, r, t)
        ]));
    }), Dsr = F3(function(n, r, t) {
        return A2(zx, w([
            DF(gor),
            Gx("flex-grow")
        ]), w([
            A3(jsr, n, r, t)
        ]));
    }), Vsr = F5(function(n, r, t, e, u) {
        return r ? A4(Q5n, n, t, e, u) : "Update next member";
    }), Bsr = F3(function(n, r, t) {
        var e = v(FM(r.le).tD, r.c7);
        if (e.a.$ || 3 !== e.b.$) return t;
        var u = e.a.a, a = A2(xc, !1, A2(Op, function(n) {
            return i(Nor(n), u);
        }, mb(Ae(e.b.a))));
        return A2(Aer, A5(Vsr, n, a, r.mp, r.FN, r.yZ.EX), t);
    }), Gsr = F2(function(n, r) {
        return A2(Qt, function(n) {
            return {
                $: 2,
                a: n
            };
        }(n), r);
    }), zsr = F2(function(n, r) {
        return (dtr(r.mp) ? Eer(r.fL) : _er($er(ger(r.fm))))(A2(wer, r.fM, A2(ker, r.nX, A2(yer, r.wk, A2(Gsr, r.wk, A3(Bsr, n, r, g))))));
    }), Ssr = F2(function(n, r) {
        return A2(zx, w([
            Gx("hidden md:block")
        ]), w([
            A2(c_, Aor, A3(Vur, n, A2(zsr, n, r), r.dd))
        ]));
    }), Tsr = F2(function(n, r) {
        return A2(c_, Aor, A3(Vur, n, Gur(A2(zsr, n, r)), r.dd));
    }), Psr = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("signup__body--contents")
            ]), w([
                A2(CF, w([
                    gW,
                    uE(eE),
                    A2(U5n, 1, M5n),
                    uF(rD)
                ]), w([
                    _d("Custom details")
                ])),
                A2(zx, w([
                    Gx("flex flex-grow w-full")
                ]), w([
                    A3(Dsr, n, r.wk, r),
                    A2(Ssr, n, r)
                ])),
                A2(Tsr, n, r)
            ]))
        ]);
    }), Zsr = F2(function(n, r) {
        return {
            g8: function() {
                var t = v(r.c7, r.iK);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;)switch(t.b.$){
                                case 1:
                                    if (1 === t.a.$) break n;
                                    break r;
                                case 0:
                                    if (1 === t.a.$) break n;
                                    break t;
                                case 2:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return w([
                                                Tur(r.dV)
                                            ]);
                                    }
                                default:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return A2(Psr, n, r);
                                    }
                            }
                            return w([
                                Tur(r.dV)
                            ]);
                        }
                        return Nx;
                    }
                    return Nx;
                }
                return Nx;
            }(),
            yx: ax(r.dV)
        };
    }), Msr = J0n({
        Cl: xor,
        CQ: _or,
        Fj: Cor,
        F4: function() {
            return vx(w([
                A2(kj, Aor, X7n()),
                Z6n(Eor),
                qor(kor)
            ]));
        },
        Gv: Csr,
        GB: Zsr
    }), Lsr = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Nsr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Hsr = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Isr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Osr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Qsr = "content-container", Rsr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), Qvn, e, pk(A2(bk, w([
            t
        ]), qSn(r))));
    }), Usr = function(n) {
        return n.s2;
    }, Ksr = function(n) {
        return A2(C7n, "location", n);
    }, Wsr = F3(function(n, r, t) {
        return m(t, {
            mp: A2(Op, BYn, n),
            zF: r
        });
    }), Xsr = F2(function(n, r) {
        return A2(Nu, function() {
            return r(A2(tC, n, pa));
        }, Up(500));
    }), Ysr = F2(function(n, r) {
        return A2(Xsr, n, r);
    }), Jsr = {
        ng: Ot,
        sl: "mock-ident",
        lp: Ot,
        ur: It("John Doe"),
        v4: Ot,
        zF: It("94103")
    }, nlr = F4(function(n, r, t, e) {
        var u = GYn(r), a = Usr(u) ? It(u) : Ot, i = V6n(t), c = function() {
            var r = A7n(e.jb);
            if (r.$) return Qp;
            var u = r.a;
            return A4(err, t.g0, ux(n), u, Lsr);
        }(), o = function() {
            var r = Ksr(e.jb);
            if (r.$) return v(Qp, kc);
            var u = r.a;
            return mu(u) ? v(Qp, kc) : v(A4(Rsr, t.g0, ux(n), u, Hsr), A_);
        }(), f = o.a, s = o.b, l = function() {
            var r, e = b(i, t.hH, t.FN);
            n: for(;;){
                if (e.b) {
                    if (3 === e.c.$) return s = e.c.a, b(w([
                        f,
                        (r = Osr, A2(Ysr, w([
                            Jsr
                        ]), r)),
                        c
                    ]), A_, s);
                    break n;
                }
                if (e.a.$ || 3 !== e.c.$) break n;
                var o = e.a.a, s = e.c.a;
                return b(w([
                    A5(c8n, t.g0, ux(n), a1n(u), o, Nsr),
                    f,
                    A4(FSn, t.g0, ux(n), A2(Wsr, a, Ot), Isr),
                    c
                ]), A_, s);
            }
            return b(g, kc, g);
        }(), d = l.a, m = l.b, p = l.c;
        return v({
            gk: $6n(t),
            av: Ot,
            g0: t.g0,
            nX: Ot,
            pt: Ot,
            hH: t.hH,
            bt: !1,
            k5: aSn,
            rc: Ot,
            ld: t.ld,
            cX: s,
            it: m,
            a9: g,
            fl: m,
            fm: m,
            fu: i,
            iK: m,
            dV: n,
            wk: !1,
            fL: Ot,
            fM: Ot,
            d6: Ot,
            dd: A3(j7n, Vx(t.ld), Qsr, S7n(n)),
            mp: u,
            f2: r,
            FN: p,
            yZ: e
        }, Uu(d));
    }), rlr = F2(function(n, r) {
        return v(r, Qp);
    }), tlr = F2(function(n, r) {
        return r;
    }), elr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ulr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, alr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ilr = function(n) {
        return {
            $: 12,
            a: n
        };
    }, clr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, olr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, flr = {
        $: 0
    }, slr = function(n) {
        return m(n, {
            rc: Ot
        });
    }, llr = F2(function(n, r) {
        var t = n.cX;
        return 3 === t.$ ? w([
            t.a
        ]) : r;
    }), dlr = function(n) {
        var r = n.it;
        if (3 === r.$) {
            var t = r.a;
            return A2(kG, aNn, A2(no, cNn(n.k5), A2(llr, n, t)));
        }
        return g;
    }, vlr = F2(function(n, r) {
        return Cz(A2(SS, function(r) {
            return i(bSn(r), bSn(n));
        }, r));
    }), blr = F2(function(n, r) {
        return A2(vlr, r, dlr(n));
    }), mlr = F2(function(n, r) {
        return m(r, {
            qh: n
        });
    }), plr = function(n) {
        return A2(Fu, function(n) {
            return A2(mlr, Ot, n);
        }, n);
    }, $lr = F2(function(n, r) {
        var t = r.$ ? nx : K_n(r.a);
        return v(n, rx(w([
            v("id", t)
        ])));
    }), glr = function(n) {
        return A2($lr, "location", A2(Op, bSn, n));
    }, hlr = function(n) {
        return n.sl;
    }, ylr = F2(function(n, r) {
        return i(It(r), mb(Ae(n)));
    }), wlr = function(n) {
        return n.lp;
    }, xlr = function(n) {
        var r = A2(xc, "", A2(Op, function(n) {
            return A2(fe, " from zip ", w([
                n.a,
                n.b
            ]));
        }, n));
        return A2(rsn, "Filtering by Distance", r);
    }, _lr = F2(function(n, r) {
        return function(r) {
            if (1 === r.$) {
                var t = r.b;
                return It(v(A2(eSn, n, It(r.a)), t));
            }
            return Ot;
        }(CSn(r));
    }), Clr = F4(function(n, r, t, e) {
        return A2(Jfn, "Member Preference Saved", A2(Qt, function(n) {
            return A2(rsn, "Member ID", n);
        }(n), $(A2(t5n, r, t), e)));
    }), Alr = function(n) {
        return A2(rsn, "Location", A2(xc, "", A2(Op, oyn, n)));
    }, klr = F3(function(n, r, t) {
        return A4(Clr, hlr(n), 5, r, w([
            Alr(wlr(n)),
            xlr(A2(_lr, Vx(0), t))
        ]));
    }), Elr = F2(function(n, r) {
        return A2(FF, function(n) {
            return i(n, r);
        }, n);
    }), qlr = F3(function(n, r, t) {
        return A2(bb, function(t) {
            return A2(NR, t + r, n);
        }, A2(Elr, n, t));
    }), Flr = F2(function(n, r) {
        return A3(qlr, n, 1, r);
    }), jlr = F2(function(n, r) {
        var t = v(n, wlr(r));
        if (3 !== t.a.$ || t.b.$) return !0;
        var e = t.b.a;
        return OS(A2(SS, function(n) {
            return i(bSn(n), bSn(e));
        }, t.a.a));
    }), Dlr = F6(function(n, r, t, e, u, a) {
        return {
            ng: t,
            sl: n,
            lp: u,
            ur: r,
            v4: a,
            zF: e
        };
    }), Vlr = A3(nk, "practitioner", uC(MQ), A3(nk, "location", uC(Qvn), A3(nk, "zip", uC(M$), A3(nk, "age", uC(O$), A3(nk, "name", uC(M$), A3(nk, "id", M$, au(Dlr))))))), Blr = A2($A, Vlr, au(cu)), Glr = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments",
            r,
            "member_providers"
        ]), fM(n));
    }), zlr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), ek(Blr), e, pk(A2(Glr, r, t)));
    }), Slr = F2(function(n, r) {
        return A2(SS, function(n) {
            return i(bSn(n), r);
        }, n);
    }), Tlr = F2(function(n, r) {
        return A2(bb, Slr(n), r);
    }), Plr = "Location", Zlr = IB, Mlr = function(n) {
        var r = n.av;
        if (r.$) return b(n, Qp, g);
        var t = r.a, e = A2(xc, Plr, A2(Op, function(n) {
            return A2(fe, ": ", w([
                n ? "Dependent " + oe(n) : "Owner",
                Plr
            ]));
        }, A2(FF, function(n) {
            return i(n, t);
        }, n.a9)));
        return b(m(n, {
            rc: It(Zlr)
        }), c4n({
            eZ: w([
                nL(Zlr)
            ]),
            ru: e
        }), g);
    }, Llr = function(n) {
        return n.ng;
    }, Nlr = function(n) {
        return n.ur;
    }, Hlr = function(n) {
        return A3(Xfr, hlr(n), Nlr(n), Llr(n));
    }, Ilr = F2(function(n, r) {
        return 1 === n.$ ? r(0) : n;
    }), Olr = F2(function(n, r) {
        return A3(qlr, n, -1, r);
    }), Qlr = F6(function(n, r, t, e, u, a) {
        return A4(Dj, GQ(n), Blr, a, A2(dM, u, pk(A2(bk, w([
            e
        ]), A2(Glr, r, t)))));
    }), Rlr = F2(function(n, r) {
        var t = mb(A2(no, function(n) {
            return i(dNn(n), bSn(r));
        }, n));
        return t.$ ? r : A2(mlr, iQn(t.a), r);
    }), Ulr = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Klr = {
        lo: 250,
        mp: Ot,
        zF: Ot
    }, Wlr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), ek(PQ), e, A2($k, function(n) {
            var r, t = n(Klr);
            return vc(w([
                function() {
                    var n = t.mp;
                    return n.$ ? g : w([
                        A2(g_, "signup_page", n.a)
                    ]);
                }(),
                w([
                    A2(iA, "limit", t.lo)
                ]),
                (r = t.zF, r.$ ? g : w([
                    A2(g_, "zip", r.a)
                ]))
            ]));
        }(t), pk(function(n) {
            return A2(bk, w([
                "location_distances"
            ]), fM(n));
        }(r))));
    }), Xlr = function(n) {
        var r = function() {
            var r = CSn(n.k5);
            return 1 === r.$ ? It(r.b) : Ot;
        }(), t = ux(n.dV), e = Usr(n.mp) ? It(n.mp) : Ot;
        return v(n, A4(Wlr, n.g0, t, A2(Wsr, e, r), Ulr));
    }, Ylr = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Jlr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ndr = function(n) {
        var r = v(n.iK, n.nX);
        if (3 !== r.a.$ || r.b.$) return Qp;
        var t = r.a.a, e = r.b.a, u = A2(WU, function(n) {
            return gsr(n);
        }, ytr(t)), a = $sr({
            Ah: bsr(n.yZ.jb),
            nX: It(e),
            pt: n.pt,
            Bz: u
        });
        return dtr(n.mp) ? A4(dPn, n.g0, ux(n.dV), a, Jlr) : A4(btr, n.g0, ux(n.dV), Qnr(t), Ylr);
    }, rdr = function(n) {
        return n.zF;
    }, tdr = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = n.a, e = m(r, {
                    iK: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (ln = r.gk).$ ? Qp : o5n(ln.a), c = w([
                        W6n(h5n(u)),
                        H6n
                    ]), o = m(e, {
                        gk: Ot,
                        nX: It(cnr(u))
                    });
                    return b(o, Uu(w([
                        a,
                        ndr(o)
                    ])), c);
                }
                return b(e, Qp, A2(Ik, 1, t));
            case 0:
                var f = b(r.av, r.fu, r.hH);
                if (f.c) return b(r, Qp, w([
                    U6n
                ]));
                if (f.a.$ || f.b.$) return b(r, Qp, g);
                var s = f.a.a, l = f.b.a, d = r.d6;
                return d.$ ? Mlr(r) : A2(blr, r, D = d.a) ? b(e = slr(m(r, {
                    bt: !1,
                    wk: !0
                })), A6(Qlr, r.g0, ux(e.dV), l, hlr(s), rx(w([
                    glr(It(D))
                ])), olr), g) : Mlr(r);
            case 2:
                var p = A2(ftr, n.a, r.dd), $ = p.a, h = p.b, y = p.c, x = y.$ || y.a ? Qp : A2(Nu, cu, Au(flr));
                return b(m(r, {
                    dd: $
                }), Uu(w([
                    A2(Wp, elr, h),
                    x
                ])), g);
            case 3:
                var _ = A2(xc, Ku, A2(bb, function(n) {
                    return wc(n);
                }, _u(n.a))), C = A2(xc, Ku, wc(r.yZ.EX));
                return b(r, A4(s8n, r.mp, r.FN, C, _) ? A2(f5n, C, _) : Qp, w([
                    For
                ]));
            case 4:
                var A = n.a, k = m(r, {
                    fl: A
                });
                if (3 === A.$) {
                    var E = A.a, q = A2(xc, "", A2(bb, rdr, mb(E))), F = mu(q) ? r.k5 : A2(TSn, q, aSn), j = A2(FE, mb(Ae(E)), mb(A2(no, jlr(r.it), E))), D = k.cX.$ ? JF(k.cX) : A2(FE, k.d6, A2(bb, wlr, A2(bb, function(n) {
                        return A2(jlr, r.it, n) ? A2(Olr, E, n) : It(n);
                    }, j))), V = ve(E) > 1 ? w([
                        A3(zor, A2(Fu, Hlr, E), A2(xc, "", A2(Op, hlr, j)), !0)
                    ]) : g, B = m(k, {
                        av: j,
                        bt: 3 === (sn = r.iK).$ && A4(p5n, r.mp, r.FN, h5n(sn.a), r.yZ.EX),
                        k5: F,
                        a9: E,
                        d6: D
                    }), G = Xlr(B);
                    return b(H = G.a, Uu(w([
                        G.b,
                        A4(a5n, 5, H.FN, H.f2, g)
                    ])), V);
                }
                return b(k, Qp, A2(Ik, 1, A));
            case 5:
                var z = n.a;
                n: for(;;)switch(z.$){
                    case 3:
                        return b(m(r, {
                            fL: It(z.a),
                            fM: Ot
                        }), Qp, g);
                    case 2:
                        if (5 === z.a.$) {
                            var S = It(f9n(w([
                                Zk(Crr(z.a.b))
                            ])));
                            return b(m(r, {
                                fM: S
                            }), Qp, g);
                        }
                        break n;
                    default:
                        break n;
                }
                return b(r, Qp, A2(Ik, 1, z));
            case 6:
                var T = n.a;
                return ve(r.a9) > 0 ? (s = mb(A2(no, function(n) {
                    return i(hlr(n), T);
                }, r.a9)), b(m(r, {
                    av: s,
                    bt: Cz(D = A2(bb, wlr, s)),
                    rc: Ot,
                    d6: D
                }), Qp, g)) : b(r, Qp, g);
            case 7:
                var P = jNn(n.a), Z = P.a, M = P.b, L = M.$ ? v(r.d6, r.bt) : v(It(M.a), !1);
                return b(m(r, {
                    bt: L.b,
                    rc: Ot,
                    d6: D = L.a
                }), A2(Wp, clr, Z), g);
            case 8:
                var N = n.a;
                if (e = m(r, {
                    wk: !1
                }), 3 === N.$) {
                    var H, I = N.a, O = A2(Fu, function(n) {
                        return i(hlr(n), hlr(I)) ? I : n;
                    }, e.a9), Q = function(n) {
                        var r = n.av;
                        if (r.$) return b(n, Qp, g);
                        var t = r.a;
                        if (A2(ylr, n.a9, t)) return b(n, Uu(w([
                            A4(e5n, 5, n.FN, n.f2, g),
                            A3(klr, t, n.FN, n.k5)
                        ])), w([
                            U6n
                        ]));
                        var e = A2(Flr, n.a9, t);
                        if (e.$) return b(n, Qp, g);
                        var u = e.a, a = A2(Y$, wlr(u), wlr(t));
                        return b(m(n, {
                            av: It(u),
                            bt: Cz(a),
                            d6: a
                        }), Uu(w([
                            cZn(hlr(u)),
                            A3(klr, t, n.FN, n.k5)
                        ])), w([
                            Tor(hlr(u))
                        ]));
                    }(m(e, {
                        av: It(I),
                        a9: O
                    }));
                    return b(H = Q.a, Q.b, Q.c);
                }
                return b(e, Qp, A2(Ik, 1, N));
            case 9:
                var R = n.a;
                if (e = m(r, {
                    it: R
                }), 3 === R.$) {
                    var U = R.a, K = (D = A2(Ilr, r.d6, function() {
                        return A2(Tlr, U, S8n(r.f2));
                    }), function() {
                        var n = r.fu;
                        if (n.$) return Qp;
                        var t = n.a;
                        return A4(zlr, r.g0, ux(r.dV), t, Osr);
                    }());
                    return b(m(e, {
                        d6: D
                    }), K, g);
                }
                return b(e, Qp, A2(Ik, 1, R));
            case 10:
                var W = n.a, X = v(r.it, W);
                n: for(;;)switch(X.b.$){
                    case 3:
                        if (3 === X.a.$) {
                            var Y = X.a, J = (U = Y.a, Y.b), nn = A2(Fu, Rlr(X.b.a), U);
                            return b(m(r, {
                                it: A2(tC, nn, J)
                            }), Qp, A2(Ik, 1, W));
                        }
                        break n;
                    case 2:
                        if (9 === X.b.a.$) return b(r, Qp, g);
                        break n;
                    default:
                        break n;
                }
                return b(r, Qp, A2(Ik, 1, W));
            case 11:
                var rn = n.a;
                return e = m(r, {
                    cX: rn
                }), 3 === rn.$ ? b(m(e, {
                    d6: It(rn.a)
                }), Qp, g) : b(e, Qp, A2(Ik, 1, rn));
            case 12:
                var tn = A2(qNn, n.a, r.k5), en = tn.a, un = tn.b, an = tn.c, cn = m(r, {
                    k5: en
                }), on = function() {
                    if (an.$) return v(cn, Qp);
                    if (an.a.$) {
                        var n = yAn(an.a.a) ? Xlr(cn) : v(cn, Qp);
                        return v(n.a, n.b);
                    }
                    var r = an.a.b ? _Nn(en) ? Xlr(cn) : v(function(n) {
                        var r = n.it;
                        if (3 === r.$) {
                            var t = r.b;
                            return m(n, {
                                it: A2(tC, plr(r.a), t)
                            });
                        }
                        return n;
                    }(cn), Qp) : v(cn, Qp), t = r.b;
                    return v(function(n) {
                        var r = n.d6;
                        return r.$ ? n : A2(blr, n, r.a) ? slr(n) : n;
                    }(r.a), t);
                }();
                return x = on.b, b(e = on.a, Uu(w([
                    A2(Wp, ilr, un),
                    x
                ])), g);
            case 13:
                var fn = n.a;
                return 3 === fn.$ ? b(e = m(r, {
                    pt: It(fn.a)
                }), ndr(e), g) : b(r, Qp, A2(Ik, 1, fn));
            default:
                return b(m(r, {
                    fm: n.a
                }), Qp, g);
        }
        var sn, ln;
    }), edr = function(n) {
        return A2(no, function(n) {
            return Cz(lyn(n));
        }, n);
    }, udr = F2(function(n, r) {
        var t = CSn(r);
        if (1 === t.$) {
            var e = t.b;
            return nE(edr(n)) && yAn(e);
        }
        return !1;
    }), adr = F2(function(n, r) {
        var t = v(r.cX, r.it);
        if (t.a.$ || 3 !== t.b.$) return vE;
        var e = A2(udr, t.b.a, r.k5);
        return A2(BE, w([
            zDn,
            MQn,
            xN(ZN)
        ]), w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(c_, ilr, A4(UQn, n, e, r.wk, r.k5))
            ]))
        ]));
    }), idr = function(n) {
        if (n.$) return vE;
        var r = n.a;
        return A2(zx, w([
            Gx("form-error mb-3 mt-0")
        ]), w([
            _d(r)
        ]));
    }, cdr = F2(function(n, r) {
        var t = v(A2(bb, wlr, n.av), n.bt);
        if (!t.a.$ && t.b) {
            var e = t.a.a, u = A2(vlr, e, r) ? g : w([
                e
            ]);
            return A2(Qt, e, A2(no, function(n) {
                return !i(bSn(n), bSn(e));
            }, $(u, r)));
        }
        return r;
    }), odr = F2(function(n, r) {
        var t = A2(cdr, r, dlr(r));
        return A2(zx, w([
            Gx("mb-8")
        ]), w([
            nE(t) ? A2(f_, g, w([
                _d("No locations found")
            ])) : A2(c_, clr, A2(HOn, n, w([
                xOn(r.wk),
                kOn(t),
                zOn(r.d6)
            ])))
        ]));
    }), fdr = F2(function(n, r) {
        return A2(zx, w([
            DF(Qsr)
        ]), w([
            A2(adr, n, r),
            idr(A2(Op, n, r.rc)),
            A2(odr, n, r)
        ]));
    }), sdr = F3(function(n, r, t) {
        var e = v(r.fl, r.av);
        return 3 !== e.a.$ || e.b.$ ? t : A2(Aer, A5(Vsr, n, A2(ylr, e.a.a, e.b.a), r.mp, r.FN, r.yZ.EX), t);
    }), ldr = F2(function(n, r) {
        return (function() {
            if (dtr(r.mp)) return Eer(r.fL);
            var n = function() {
                var n = r.fm;
                return 3 === n.$ ? n.a : g;
            }();
            return _er($er(n));
        })()(A2(wer, r.fM, A2(ker, r.nX, A2(yer, r.wk, A2(Gsr, r.wk, A3(sdr, n, r, g))))));
    }), ddr = F2(function(n, r) {
        return A2(zx, w([
            Gx("hidden md:block")
        ]), w([
            A2(c_, elr, A3(Vur, n, A2(ldr, n, r), r.dd))
        ]));
    }), vdr = F2(function(n, r) {
        return A2(c_, elr, A3(Vur, n, Gur(A2(ldr, n, r)), r.dd));
    }), bdr = F2(function(n, r) {
        var t, e;
        return w([
            A2(zx, w([
                Gx("signup__body--contents")
            ]), w([
                A2(CF, w([
                    gW,
                    uE(M5n),
                    uF(rD)
                ]), (t = r.av, e = "Select location", A2(xc, w([
                    _d(e)
                ]), A2(Op, function(n) {
                    return w([
                        _d(e + " for "),
                        ZV(n)
                    ]);
                }, A2(bb, Nlr, t))))),
                A2(BE, w([
                    xN(JI)
                ]), w([
                    A2(lE, w([
                        TE(12),
                        tO(8)
                    ]), w([
                        A2(fdr, n, r)
                    ])),
                    A2(lE, w([
                        tO(4),
                        VN(w([
                            Gx("hidden md:block")
                        ]))
                    ]), w([
                        A2(ddr, n, r)
                    ]))
                ])),
                A2(vdr, n, r)
            ]))
        ]);
    }), mdr = F2(function(n, r) {
        return {
            g8: function() {
                var t = b(r.iK, r.it, r.fl);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;){
                                u: for(;;)switch(t.a.$){
                                    case 1:
                                        return Nx;
                                    case 0:
                                        if (1 === t.b.$) break n;
                                        if (1 === t.c.$) break r;
                                        break t;
                                    case 2:
                                        if (1 === t.b.$) break n;
                                        if (1 === t.c.$) break r;
                                        break e;
                                    default:
                                        switch(t.b.$){
                                            case 1:
                                                break n;
                                            case 2:
                                                if (1 === t.c.$) break r;
                                                break u;
                                            default:
                                                switch(t.c.$){
                                                    case 1:
                                                        break r;
                                                    case 2:
                                                        return w([
                                                            Tur(r.dV)
                                                        ]);
                                                    default:
                                                        return A2(bdr, n, r);
                                                }
                                        }
                                }
                                return w([
                                    Tur(r.dV)
                                ]);
                            }
                            return w([
                                Tur(r.dV)
                            ]);
                        }
                        return Nx;
                    }
                    return Nx;
                }
                return Nx;
            }(),
            yx: ax(r.dV)
        };
    }), pdr = J0n({
        Cl: nlr,
        CQ: rlr,
        Fj: tlr,
        F4: function() {
            return vx(w([
                A2(kj, elr, X7n()),
                Z6n(alr),
                qor(ulr)
            ]));
        },
        Gv: tdr,
        GB: mdr
    }), $dr = function(n) {
        return {
            $: 18,
            a: n
        };
    }, gdr = function(n) {
        return {
            $: 15,
            a: n
        };
    }, hdr = function(n) {
        return {
            $: 13,
            a: n
        };
    }, ydr = F3(function(n, r, t) {
        return m(t, {
            no: w6n(n),
            oM: h6n(n),
            oY: V8n(n),
            hF: !0,
            lX: r,
            jq: !0
        });
    }), wdr = F2(function(n, r) {
        return m(r, {
            ox: n
        });
    }), xdr = F5(function(n, r, t, e, u) {
        return A2(wdr, u, A3(Ozn, n, r, A2(ydr, t, e)));
    }), _dr = "members-container", Cdr = function(n) {
        return "member-" + oe(n);
    }, Adr = function(n) {
        var r = n.$ ? 1 : uxn(n.a);
        return Cdr(r);
    }, kdr = F2(function(n, r) {
        var t = FM(r.le);
        return m(r, {
            le: vZ(m(t, {
                v9: A2(eg, n, t.v9)
            }))
        });
    }), Edr = F4(function(n, r, t, e) {
        var u, a, i, c, o = GYn(r), f = A2(kdr, A2(xc, zwn(n), t.Gy), (u = A5(xdr, Adr(Ot), n, r, !0, Ot), a = FM(u.le), i = vZ(m(a, {
            wQ: It(0)
        })), m(u, {
            le: i
        }))), s = ux(n), l = (c = A7n(e.jb)).$ ? Qp : A4(err, t.g0, s, c.a, $dr), d = function() {
            var n = v(V6n(t), t.FN);
            if (3 === n.b.$) {
                if (n.a.$) return e = n.b.a, b(w([
                    l
                ]), kc, e);
                var r = n.a.a, e = n.b.a;
                return b(w([
                    A5(c8n, t.g0, s, a1n(o), r, gdr),
                    l
                ]), A_, e);
            }
            return b(w([
                l
            ]), kc, g);
        }(), p = d.a, $ = d.b, h = d.c;
        return v({
            gk: $6n(t),
            g0: t.g0,
            nX: Ot,
            pt: Ot,
            hz: Ot,
            hG: p7,
            hH: t.hH,
            ld: t.ld,
            fm: A2(Y2, {
                q: g,
                bo: !1,
                dI: !0,
                cY: Ot,
                iA: f,
                wU: !1,
                bf: hTn(f)
            }, F0),
            fp: Z8n(r),
            fu: t.fu,
            iK: A_,
            iP: Ot,
            fv: g,
            dV: n,
            wk: !1,
            fL: Ot,
            fM: Ot,
            wL: !1,
            c7: $,
            dd: A3(j7n, Vx(t.ld), _dr, S7n(n)),
            mp: o,
            f2: r,
            FN: h,
            yZ: e
        }, Uu(A2(Qt, A2(Nu, hdr, Yz), p)));
    }), qdr = F2(function(n, r) {
        var t = n.ld;
        return i(t, r.ld) ? v(r, Qp) : v(m(r, {
            ld: t
        }), Qp);
    }), Fdr = F2(function(n, r) {
        return r;
    }), jdr = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Ddr = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Vdr = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Bdr = function(n) {
        return A2(kj, Vdr(n.a), QSn);
    }, Gdr = {
        $: 3
    }, zdr = {
        $: 0
    }, Sdr = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Tdr = function(n) {
        return INn(n.iA) && nE(n.q);
    }, Pdr = F2(function(n, r) {
        return m(r, {
            bo: n
        });
    }), Zdr = function(n) {
        return A2(oHn, function(n) {
            return Tdr(n) ? A2(Pdr, !0, n) : n;
        }, n);
    }, Mdr = function(n) {
        return A2(oHn, function(n) {
            return Tdr(n) ? n : A2(Pdr, !1, n);
        }, n);
    }, Ldr = function(n) {
        return j_n(A2(s2, function(n) {
            var r = n.b;
            return !nE(r.q) || !Tdr(r);
        }, n));
    }, Ndr = function(n) {
        return !Ldr(n).$;
    }, Hdr = function(n) {
        var r = FM(n.le);
        return r.an ? r.oA : r.sV;
    }, Idr = F2(function(n, r) {
        var t = FM(r.le);
        return m(r, {
            le: vZ(m(t, {
                sV: n
            }))
        });
    }), Odr = F5(function(n, r, t, e, u) {
        return (function() {
            if (r.$) return cu;
            var n = r.a, t = FM(n.iA.le).v9.CK, e = Hdr(n.iA);
            return A2(tu, Idr(e), kdr(t));
        })()(A5(xdr, n, t, e, !1, u));
    }), Qdr = F5(function(n, r, t, e, u) {
        return {
            q: g,
            bo: !1,
            dI: !0,
            cY: Ot,
            iA: A5(Odr, n, r, t, e, u),
            wU: !1,
            bf: ""
        };
    }), Rdr = F4(function(n, r, t, e) {
        if (Ndr(e)) return v(Mdr(e), !1);
        var u = Adr(It(e));
        return v(A2(Y2, A5(Qdr, u, j_n(e), n, r, t), Zdr(e)), !0);
    }), Udr = F3(function(n, r, t) {
        return A2(bb, function(n) {
            return It(A2(fe, ": ", w([
                n ? "Dependent " + oe(n) : "Owner",
                r
            ])));
        }, A2(zMn, t, n));
    }), Kdr = F2(function(n, r) {
        var t = v(A3(Udr, n, "Date Of Birth", r), ve(n.q) > 0);
        if (!t.a.$ && t.b) {
            var e = t.a.a;
            return c4n({
                eZ: A2(Fu, fL, n.q),
                ru: e
            });
        }
        return Qp;
    }), Wdr = function(n) {
        return A2(h6, function(r) {
            return A2(Kdr, r.b, n);
        }, n);
    }, Xdr = F2(function(n, r) {
        return r.ye(n);
    }), Ydr = F2(function(n, r) {
        if (9 === n) {
            var t = A2(NH, Vx(0), r), e = A2(o4n, ": ", t), u = e.a, a = e.b, i = lu(u) > 0 ? v($(Izn(n), $(": ", u)), a) : v(Izn(n), t);
            return v(i.a, A2(z3n, Xdr(i.b), r));
        }
        return v(Izn(n), r);
    }), Jdr = function(n) {
        return A2(Fu, function(r) {
            var t = r.c, e = A3(Udr, r.a, r.b, n);
            if (e.$) return Qp;
            var u = e.a;
            return c4n({
                eZ: w([
                    t
                ]),
                ru: u
            });
        }, function(n) {
            return vc(A2(h6, function(n) {
                var r, t = n.b;
                return A2(Fu, function(n) {
                    return b(t, n.a, n.b);
                }, (r = A2(ELn, !1, t.iA), vc(A2(Fu, function(n) {
                    return A2(Fu, Ydr(n), A2(iH, n, r.le));
                }, Hzn))));
            }, n));
        }(n));
    }, nvr = function(n) {
        return n.ox;
    }, rvr = F6(function(n, r, t, e, u, a) {
        var i = v(t, Oj(e));
        if (3 === i.a.$ && i.b) {
            var c = h5n(i.a.a);
            return A4(p5n, n, r, c, u.EX) ? Zdr(a) : a;
        }
        return a;
    }), tvr = {
        F1: Atn(300),
        Gs: function(n) {
            return {
                $: 11,
                a: n
            };
        }
    }, evr = function(n) {
        return {
            $: 12,
            a: n
        };
    }, uvr = function(n) {
        return A2(Nu, evr, Au(n));
    }, avr = function(n) {
        return n.sl;
    }, ivr = function(n) {
        return avr(n.iA) + "-age-errors";
    }, cvr = function(n) {
        return It(A2(xc, ivr(n), HNn(n.iA)));
    }, ovr = function(n) {
        var r = function(n) {
            return A2(bb, cvr, Ldr(n));
        }(n);
        return r.$ ? Qp : MNn(r.a);
    }, fvr = F2(function(n, r) {
        var t = mb(A2(no, function(r) {
            return i(n, r.a);
        }, r.b));
        return t.$ ? Ot : It(t.a.b);
    }), svr = function(n) {
        return n.sl;
    }, lvr = F2(function(n, r) {
        return m(r, {
            le: vZ(A4(Nzn, r.sl, r.dV, r.a6, It(n)))
        });
    }), dvr = F5(function(n, r, t, e, u) {
        var a = HGn(IGn(u)), i = A2(wdr, e, A2(lvr, u, A5(xdr, Cdr(n + 1), r, t, a, e)));
        return {
            q: g,
            bo: !1,
            dI: !1,
            cY: It(svr(u)),
            iA: i,
            wU: !1,
            bf: hTn(i)
        };
    }), vvr = F4(function(n, r, t, e) {
        return J2(A2(ge, F2(function(n, u) {
            return A5(dvr, n, r, t, e, u);
        }), n));
    }), bvr = function(n) {
        return i(Izn(5), n);
    }, mvr = function(n) {
        var r = FM(n.le);
        return mMn(r.wQ);
    }, pvr = F3(function(n, r, t) {
        var e, u = A2(ELn, !1, t);
        return A2(xc, g, A2(Op, function(n) {
            var e = v(n, r);
            if (9 !== e.a || e.b.$) return A2(iH, n, u.le);
            var a = e.b.a, i = FM(t.le), c = A2(v8n, a, i.m9);
            return c.$ ? g : w([
                c.a
            ]);
        }, (e = n, mb(A2(no, function(n) {
            return i(Izn(n), e);
        }, Hzn)))));
    }), $vr = F3(function(n, r, t) {
        var e = A2(o4n, ": ", t), u = e.a, a = e.b, i = lu(u) > 0 ? v(u, It(a)) : v(a, Ot), c = i.a, o = i.b;
        return A2(xc, g, A2(Op, function(e) {
            var u, a = _c(n.yZ.EX), i = (u = v(bvr(t), nE(r.q))).a && !u.b ? A2(Fu, fL, r.q) : A3(pvr, c, o, r.iA);
            return w([
                d8n(It({
                    eZ: i,
                    ru: e,
                    Fh: a
                }))
            ]);
        }, A3(Udr, r, t, n.fm)));
    }), gvr = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments",
            r,
            "members"
        ]), fM(n));
    }), hvr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), ek(qPn), e, pk(A2(gvr, r, t)));
    }), yvr = F2(function(n, r) {
        return A2(bb, zMn(n), A2(fvr, r, n));
    }), wvr = F2(function(n, r) {
        var t, e = A2(yvr, n, r);
        return e.$ ? Qp : (t = oe(e.a), A2(Jfn, "Dependent Removed", w([
            esn(i4n),
            tsn(t)
        ])));
    }), xvr = {
        $: 1
    }, _vr = F2(function(n, r) {
        return !function(n) {
            var r = function(n) {
                return j_n(A2(s2, function(n) {
                    return n.b.dI;
                }, n));
            }(n);
            return !r.$;
        }(n) && r ? A2(Nu, cu, Au(xvr)) : Qp;
    }), Cvr = F2(function(n, r) {
        var t = v(n, Oj(r));
        return !(3 !== t.a.$ || !t.b) && ufr(t.a.a);
    }), Avr = function(n) {
        var r = FM(n.le);
        return r.an ? r.oz : r.rA;
    }, kvr = F2(function(n, r) {
        var t = sJ(Hdr(n)), e = sJ(Avr(n)), u = CTn(n), a = sJ(Hdr(r)), c = sJ(Avr(r)), o = CTn(r);
        return i(c, e) && i(a, t) && i(o, u);
    }), Evr = F2(function(n, r) {
        var t = r.b;
        return A2(Xk, !0, A2(h6, function(n) {
            var r = n.b;
            return !i(r, t) && A2(kvr, r.iA, t.iA);
        }, n));
    }), qvr = function(n) {
        return n.ny;
    }, Fvr = function(n) {
        return n.nz;
    }, jvr = function(n) {
        return n.qE;
    }, Dvr = function(n) {
        return I2(A2(s2, function(n) {
            return !mvr(n.b.iA);
        }, n));
    }, Vvr = F2(function(n, r) {
        if (n.$) return !1;
        var t = n.a;
        return s(Dvr(r), t) > 0;
    }), Bvr = function(n) {
        return n.yK;
    }, Gvr = F5(function(n, r, t, e, u) {
        return $6(u) && r ? w([
            A2(Cvr, t, e) ? qvr : Fvr
        ]) : A2(Vvr, n, u) ? w([
            Bvr
        ]) : function(n) {
            return A2(Xk, !0, A2(h6, Evr(n), n));
        }(u) ? w([
            jvr
        ]) : g;
    }), zvr = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), Svr = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), Tvr = function(n) {
        return rx(w([
            v("member", FPn(n))
        ]));
    }, Pvr = F5(function(n, r, t, e, u) {
        return A4(lM, GQ(n), qPn, u, A2(dM, Tvr(e), pk(A2(gvr, r, t))));
    }), Zvr = F6(function(n, r, t, e, u, a) {
        return A4(Dj, GQ(n), qPn, a, A2(dM, Tvr(u), pk(A2(bk, w([
            e
        ]), A2(gvr, r, t)))));
    }), Mvr = F4(function(n, r, t, e) {
        var u = e.a, a = e.b, i = HPn(a.iA);
        if (Tdr(a) && a.dI) {
            var c = a.cY;
            return c.$ ? A5(Pvr, n, t, r, i, zvr(u)) : A6(Zvr, n, t, r, c.a, i, Svr(u));
        }
        return Qp;
    }), Lvr = function(n) {
        var r = n.fu;
        return 2 === r.$ ? Uu(A2(h6, A3(Mvr, n.g0, r.a, ux(n.dV)), n.fm)) : Qp;
    }, Nvr = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), Hvr = F5(function(n, r, t, e, u) {
        return A4(FKn, GQ(n), AKn, u, pk(A2(bk, w([
            e
        ]), A2(gvr, r, t))));
    }), Ivr = F5(function(n, r, t, e, u) {
        if (2 === e.$) {
            var a = e.a;
            return A5(Hvr, n, ux(u), a, t, Nvr(r));
        }
        return Qp;
    }), Ovr = function(n) {
        return m(n, {
            dI: !1
        });
    }, Qvr = F2(function(n, r) {
        return m(r, {
            wU: n
        });
    }), Rvr = function(n) {
        var r = mb(n);
        return r.$ ? g : w([
            A2(Mk, 1, r.a)
        ]);
    }, Uvr = F3(function(n, r, t) {
        return A2(q0, t.a, A2(Fu, function(t) {
            var e = t.a, u = t.b;
            return v(e, i(e, r) ? n(u) : u);
        }, t.b));
    }), Kvr = F2(function(n, r) {
        return m(r, {
            cY: It(n)
        });
    }), Wvr = function(n) {
        return m(n, {
            bf: hTn(n.iA)
        });
    }, Xvr = F2(function(n, r) {
        return A2(xc, !1, A2(Op, r1n, A2(SS, function(r) {
            return i(O8n(r), n);
        }, r)));
    }), Yvr = function(n) {
        return A2(Xvr, 3, n);
    }, Jvr = F3(function(n, r, t) {
        if (n.$) return t;
        var e = A3(BTn, n.a, r, t.iA);
        return e.$ ? t : m(t, {
            q: A2(Qt, e.a, t.q)
        });
    }), nbr = F2(function(n, r) {
        return r.uy(n);
    }), rbr = function(n) {
        return nbr(oe(n));
    }, tbr = F3(function(n, r, t) {
        if (n.$) return !0;
        var e = n.a;
        return !$6(A2(s2, function(n) {
            var t = n.b, u = A3(NTn, e, r, t.iA);
            return INn(t.iA) && OS(u);
        }, t));
    }), ebr = F3(function(n, r, t) {
        var e = v(n, A3(tbr, n, r, t));
        if (e.a.$ || e.b) return t;
        var u = e.a.a;
        return A2(oHn, function(n) {
            return INn(n.iA) ? m(n, {
                q: $(n.q, w([
                    rbr(u)
                ]))
            }) : n;
        }, t);
    }), ubr = F2(function(n, r) {
        var t = A2(STn, n, r.iA);
        return t.$ ? r : m(r, {
            q: $(r.q, w([
                t.a
            ]))
        });
    }), abr = function(n) {
        return n.tw;
    }, ibr = function(n) {
        return n.ul;
    }, cbr = F3(function(n, r, t) {
        return m(t, {
            q: $(t.q, A2(xc, g, A2(Op, function(n) {
                return A2(Qt, n, t.q);
            }, A2(bb, function(n) {
                return A3(ZTn, n, r, t.iA);
            }, n))))
        });
    }), obr = F3(function(n, r, t) {
        return m(t, {
            q: A2(xc, g, A2(Op, function(n) {
                return A2(Qt, n, t.q);
            }, A2(bb, function(n) {
                return A3(NTn, n, r, t.iA);
            }, n)))
        });
    }), fbr = F3(function(n, r, t) {
        return It(A3(cbr, abr(t), r, A3(obr, ibr(t), r, n)));
    }), sbr = F3(function(n, r, t) {
        return n.$ ? t : A2(xc, t, A3(fbr, t, r, n.a));
    }), lbr = F6(function(n, r, t, e, u, a) {
        var i = A2(oHn, function(n) {
            return m(n, {
                q: g
            });
        }, a);
        if (r.$) return i;
        var c = r.a;
        return A3(ebr, t, c, A2(oHn, A2(Jvr, e, c), (Yvr(n) ? cu : oHn(A2(sbr, u, c)))(A2(oHn, ubr(c), i))));
    }), dbr = F4(function(n, r, t, e) {
        var u = (function() {
            var r = v(n, yln(t.bf));
            if (r.a.$ || r.a.a.$ || r.b) return cu;
            if (bvr(r.a.a.a)) {
                var u = A2(bb, Err, e.nX);
                return A5(lbr, e.FN, e.hz, e.fp, A2(bb, nvr, u), u);
            }
            return cu;
        })()(A3(c9, t, r, e.fm));
        return m(e, {
            fm: u
        });
    }), vbr = function(n) {
        return {
            $: 14,
            a: n
        };
    }, bbr = F4(function(n, r, t, e) {
        var u = Yvr(n) ? w([
            A2(bb, function(n) {
                return A3(NTn, n, r, e.iA);
            }, ibr(t)),
            A2(bb, function(n) {
                return A3(ZTn, n, r, e.iA);
            }, abr(t)),
            A2(bb, function(n) {
                return A3(BTn, n, r, e.iA);
            }, nvr(t))
        ]) : g;
        return A2(n$, cu, A2(Qt, A2(STn, r, e.iA), u));
    }), mbr = function(n) {
        return dtr(n.mp) ? function(n) {
            var r = b(i(I2(n.fm), I2(A2(s2, function(n) {
                return yTn(n.b.iA);
            }, n.fm))), n.nX, dtr(n.mp));
            if (r.a && !r.b.$ && r.c) {
                var t = r.b.a, e = Err(t), u = function() {
                    var r = v(n.hz, e);
                    if (r.a.$ || r.b.$) return n.fm;
                    var t = r.a.a, u = r.b.a;
                    return A2(s2, function(r) {
                        return nE(A4(bbr, n.FN, t, u, r.b));
                    }, n.fm);
                }(), a = A2(f2, function(n) {
                    return rx(function(n) {
                        var r = FM(n.le);
                        return w([
                            v("name", K_n(hTn(n))),
                            v("dob", RTn(KM(r.bq))),
                            v("relationship", OTn(NPn(r.wQ)))
                        ]);
                    }(n.b.iA));
                }, u), c = $sr({
                    Ah: bsr(n.yZ.jb),
                    nX: It(t),
                    pt: n.pt,
                    Bz: a
                });
                return A4(dPn, n.g0, ux(n.dV), c, vbr);
            }
            return Qp;
        }(n) : Qp;
    }, pbr = function(n) {
        var r = A2(ELn, !0, n.iA);
        return m(n, {
            iA: r,
            bf: INn(r) ? hTn(r) : n.bf
        });
    }, $br = F2(function(n, r) {
        switch(n.$){
            case 15:
                var t = n.a, e = m(r, {
                    iK: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (fn = r.gk).$ ? Qp : o5n(fn.a), c = function(n) {
                        return n.wL;
                    }(u), o = ux(r.dV), f = Qnr(u), s = $4n(u), l = w(s ? [
                        W6n(h5n(u)),
                        I6n,
                        H6n
                    ] : [
                        W6n(h5n(u)),
                        H6n
                    ]);
                    return b(m(e, {
                        gk: Ot,
                        nX: It(cnr(u)),
                        hH: s,
                        wL: c
                    }), Uu(w([
                        A4(hvr, r.g0, o, f, Sdr),
                        a
                    ])), l);
                }
                return b(e, Qp, A2(Ik, 1, t));
            case 10:
                var d = n.a;
                if (3 === d.$) {
                    var p = A4(vvr, d.a, r.dV, r.f2, P = A2(bb, nvr, A2(bb, Err, r.nX))), h = n_n(X6n(r.f2)) || A2(Cvr, r.iK, d), y = function() {
                        if (h) {
                            var n = A2(Op, function(n) {
                                return v(n.a, A2(Pdr, !0, n.b));
                            }, F_n(A2(s2, function(n) {
                                return mvr(n.b.iA);
                            }, p)));
                            return v(n, function(t) {
                                if ($6(t)) {
                                    var e = A2(Op, function(n) {
                                        return n.b;
                                    }, n), u = Adr(It(p));
                                    return A2(Y2, A5(Qdr, u, e, r.dV, r.f2, P), t);
                                }
                                return A6(rvr, r.mp, r.FN, r.iK, d, r.yZ, t);
                            }(A2(s2, function(n) {
                                return !mvr(n.b.iA);
                            }, p)));
                        }
                        return v(Ot, A6(rvr, r.mp, r.FN, r.iK, d, r.yZ, p));
                    }();
                    return b(e = m(r, {
                        fm: y.b,
                        iP: y.a,
                        c7: d
                    }), Uu(w([
                        mbr(e),
                        A4(a5n, 2, e.FN, e.f2, g)
                    ])), g);
                }
                return b(m(r, {
                    c7: d
                }), Qp, A2(Ik, 1, d));
            case 9:
                var x = n.a, _ = n.b;
                if (e = m(r, {
                    wk: !1
                }), 3 === _.$) {
                    var C = A3(Uvr, Ovr, x, A3(Uvr, Wvr, x, Zdr(r.fm)));
                    return b(m(e, {
                        fm: C
                    }), Uu(w([
                        A2(_vr, C, r.wk)
                    ])), g);
                }
                return b(e, Qp, A2(Ik, 1, _));
            case 8:
                x = n.a;
                var A = n.b;
                if (3 === A.$) {
                    var k = svr(A.a);
                    return C = A3(Uvr, Ovr, x, A3(Uvr, Wvr, x, A3(Uvr, Kvr(k), x, Zdr(r.fm)))), b(m(r, {
                        fm: C
                    }), A2(_vr, C, r.wk), g);
                }
                return b(m(r, {
                    wk: !1
                }), Qp, A2(Ik, 1, A));
            case 0:
                var E = A2(bb, Err, r.nX), q = (C = Zdr(Mdr(A6(lbr, r.FN, r.hz, r.fp, P = A2(bb, nvr, A2(bb, Err, r.nX)), E, A2(oHn, pbr, r.fm)))), A5(Gvr, P8n(r.f2), C8n(r.mp), r.iK, r.c7, C));
                return e = m(r, {
                    fm: C,
                    fv: q
                }), Ndr(C) || !nE(q) ? b(e, Uu(A2(dc, Wdr(C), A2(Qt, ovr(C), Jdr(C)))), Rvr(q)) : b(m(e, {
                    wk: !0
                }), Uu(w([
                    Lvr(e),
                    A2(_vr, C, !0)
                ])), Rvr(q));
            case 1:
                return b(m(r, {
                    wk: !1
                }), A4(e5n, 2, r.FN, r.f2, g), w([
                    U6n
                ]));
            case 2:
                var F = n.b, j = A2(fvr, x = n.a, r.fm);
                if (j.$) return b(r, Qp, g);
                var D = A2(RLn, F, (K = j.a).iA), V = D.a, B = D.b, G = D.c, z = A2(xc, Qp, A2(Op, function(n) {
                    return 2 === n.$ && bvr(n.a) ? A2(Kdr, K, r.fm) : Qp;
                }, G)), S = m(K, {
                    dI: !0,
                    iA: V
                }), T = (e = A4(dbr, G, x, S, r), function() {
                    if (i(G, It(uMn))) return mbr(e);
                    if (G.$) return Qp;
                    var n = G.a;
                    return 2 === n.$ && bvr(n.a) ? mbr(e) : Qp;
                }());
                return l = A2(xc, g, A2(Op, function(n) {
                    return 1 === n.$ ? A3($vr, e, S, n.a) : g;
                }, G)), b(e, Uu(w([
                    A2(Wp, Vdr(x), B),
                    z,
                    T
                ])), l);
            case 3:
                var P, Z = A4(Rdr, r.dV, r.f2, P = A2(bb, nvr, E = A2(bb, Err, r.nX)), A6(lbr, r.FN, r.hz, r.fp, P, E, A2(oHn, pbr, r.fm))), M = (C = Z.a, Z.b), L = (q = A5(Gvr, P8n(r.f2), C8n(r.mp), r.iK, r.c7, C), e = m(r, {
                    fm: C,
                    fv: q
                }), v(M, A2(Op, function(n) {
                    return avr(n.iA);
                }, function(n) {
                    return A2(bb, function(n) {
                        return It(n.b);
                    }, mb(Ae(n.b)));
                }(C))));
                if (L.a && !L.b.$) {
                    var N = A3(Xnn, tvr, L.b.a, e.hG), H = N.b, I = m(e, {
                        hG: N.a
                    });
                    return b(I, Uu(w([
                        H,
                        Lvr(I),
                        (cn = I2(C) - 1, on = oe(cn), A2(Jfn, "Dependent Added", w([
                            esn(i4n),
                            tsn(on)
                        ]))),
                        mbr(I)
                    ])), Rvr(q));
                }
                return b(e, Uu(A2(dc, Wdr(C), A2(Qt, ovr(C), $(Jdr(C), w([
                    mbr(e)
                ]))))), Rvr(q));
            case 11:
                var O = n.a, Q = A4(Gtn, tvr, Dtn(uvr), O, r.hG);
                return H = Q.b, b(m(r, {
                    hG: Q.a
                }), H, g);
            case 12:
                return b(r, MNn(n.a), g);
            case 4:
                x = n.a;
                var R = n.b;
                return b(e = m(r, {
                    fm: A3(Uvr, Qvr(!0), x, r.fm)
                }), Uu(w([
                    A2(wvr, r.fm, x),
                    A5(Ivr, r.g0, x, R, r.fu, r.dV)
                ])), g);
            case 5:
                x = n.a;
                var U = n.b;
                return 3 === U.$ ? b(e = m(r, {
                    fm: A2(D_n, x, r.fm)
                }), mbr(e), g) : b(m(r, {
                    fm: A3(Uvr, Qvr(!1), x, r.fm)
                }), Qp, A2(Ik, 1, U));
            case 6:
                return b(m(r, {
                    fm: A2(D_n, x = n.a, r.fm)
                }), A2(wvr, r.fm, x), g);
            case 7:
                var K;
                return x = n.a, b(e = m(r, {
                    fm: A3(Uvr, Pdr(!(K = n.b).bo), x, Zdr(r.fm))
                }), Lvr(e), g);
            case 13:
                return b(m(r, {
                    hz: It(A2(Ep, x8, n.a))
                }), Qp, g);
            case 14:
                var W = n.a;
                n: for(;;)switch(W.$){
                    case 3:
                        return b(m(r, {
                            fL: It(W.a),
                            fM: Ot
                        }), Qp, g);
                    case 2:
                        if (5 === W.a.$) {
                            var X = It(f9n(w([
                                Zk(Crr(W.a.b))
                            ])));
                            return b(m(r, {
                                fM: X
                            }), Qp, g);
                        }
                        break n;
                    default:
                        break n;
                }
                return b(r, Qp, A2(Ik, 1, W));
            case 16:
                var Y = A2(ftr, F = n.a, r.dd), J = Y.a, nn = Y.b, rn = Y.c, tn = rn.$ ? Qp : A2(Nu, cu, Au(rn.a ? Gdr : zdr));
                return b(m(r, {
                    dd: J
                }), Uu(w([
                    A2(Wp, jdr, nn),
                    tn
                ])), g);
            case 17:
                var en = A2(xc, Ku, A2(bb, function(n) {
                    return wc(n);
                }, _u(n.a))), un = A2(xc, Ku, wc(r.yZ.EX));
                return b(r, A4(s8n, r.mp, r.FN, un, en) ? A2(f5n, un, en) : Qp, g);
            default:
                var an = n.a;
                return 3 === an.$ ? b(e = m(r, {
                    pt: It(an.a)
                }), mbr(e), g) : b(r, Qp, A2(Ik, 1, an));
        }
        var cn, on, fn;
    }), gbr = F2(function(n, r) {
        var t = r.b;
        return A2(q0, r.a + 1, A2(Qt, v(n.a, n.b), t));
    }), hbr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ybr = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), wbr = function(n) {
        return n.bo ? "collapser-closed" : "collapser-open";
    }, xbr = F2(function(n, r) {
        return n ? Zk(" ") : mvr(r) ? Kgn : rY;
    }), _br = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Cbr = function(n) {
        return n.wU;
    }, Abr = F3(function(n, r, t) {
        var e, u = t.a, a = t.b, i = (e = a.cY).$ ? function(n) {
            return {
                $: 6,
                a: n
            };
        }(u) : A2(_br, u, e.a);
        return A2(zx, w([
            Gx("member-wrap--remove")
        ]), w(a.wU ? [
            A2(yF, w([
                j6,
                Lj(!0),
                Qj(!0)
            ]), w([
                _d(n(Cbr))
            ]))
        ] : [
            A2(yF, w([
                Kj(w([
                    Gx("w-8 text-primary-500")
                ])),
                Lj(r),
                cF(i)
            ]), w([
                A2(Tq, w([
                    MN(o7n)
                ]), 8)
            ])),
            A2(yF, w([
                j6,
                Lj(r),
                cF(i),
                Kj(w([
                    Gx("ml-2 hidden md:inline-block")
                ]))
            ]), w([
                _d(n(SKn))
            ]))
        ]));
    }), kbr = F6(function(n, r, t, e, u, a) {
        var i = a.a, c = a.b, o = A2(Fu, fL, c.q);
        return A2(zx, w([
            Gx("member-title")
        ]), w([
            A2(zx, w([
                Gx("flex")
            ]), w([
                A2(zx, w([
                    Gx("flex flex-grow items-center flex-wrap md:flex-nowrap")
                ]), w([
                    A2(zx, w([
                        Gx("flex w-full md:w-auto")
                    ]), w([
                        A2(Mx, w([
                            Gx("member-label")
                        ]), w([
                            A2(i_, g, w([
                                _d(r(A2(xbr, n, c.iA)))
                            ]))
                        ]))
                    ])),
                    A2(zx, w([
                        Gx("flex flex-grow-0 md:flex-grow")
                    ]), w([
                        A2(bE, !yln(c.bf), A2(Mx, w([
                            Gx("member-name md:ml-4")
                        ]), w([
                            ZV(c.bf)
                        ])))
                    ]))
                ])),
                A2(zx, w([
                    Gx("flex items-center")
                ]), w([
                    A2(zx, w([
                        Gx("flex")
                    ]), w([
                        A2(bE, !mvr(c.iA) && !u, A3(Abr, r, e, v(i, c)))
                    ])),
                    A2(bE, !t, A2(zx, w([
                        Gx("flex")
                    ]), w([
                        A2(zx, w([
                            Gx("collapser")
                        ]), w([
                            A2(zx, w([
                                Gx(wbr(c))
                            ]), w([
                                A2(yF, w([
                                    Yj,
                                    Lj(e || !Tdr(c) && !c.bo),
                                    cF(A2(ybr, i, c))
                                ]), w([
                                    A2(Tq, g, 7)
                                ]))
                            ]))
                        ]))
                    ])))
                ]))
            ])),
            A2(zx, w([
                DF(ivr(c))
            ]), w([
                A2(YH, r, o)
            ]))
        ]));
    }), Ebr = F6(function(n, r, t, e, u, a) {
        var i = a.a, c = a.b, o = t && mvr(c.iA);
        return v(c.iA.sl, A2(zx, w([
            Gx("member-wrap"),
            DF(c.iA.sl)
        ]), w([
            A6(kbr, n, r, o, e, u, v(i, c)),
            A2(bE, !c.bo, A2(zx, g, w([
                s_,
                A2(BE, w([
                    xN(JI)
                ]), w([
                    A2(lE, w([
                        TE(12),
                        VN(w([
                            Gx("p-3")
                        ]))
                    ]), w([
                        A2(c_, Vdr(i), A3(mOn, r, w([
                            _In(e),
                            hbr(u)
                        ]), c.iA))
                    ]))
                ]))
            ])))
        ])));
    }), qbr = F2(function(n, r) {
        var t = function() {
            var n = r.iP;
            return n.$ ? r.fm : A2(gbr, n.a, r.fm);
        }(), e = _8n(r.mp);
        return A2(zx, w([
            DF(_dr)
        ]), w([
            A3(gz, "div", g, A2(h6, A5(Ebr, e, n, A2(Cvr, r.iK, r.c7), r.wk, r.wL), t))
        ]));
    }), Fbr = F2(function(n, r) {
        return nE(r) ? vE : A2(zx, w([
            Gx("mt-4")
        ]), w([
            A2(YH, n, A2(Fu, function(n) {
                return nL(n);
            }, r))
        ]));
    }), jbr = F2(function(n, r) {
        return A2(zx, w([
            Gx("flex-grow")
        ]), w([
            A2(qbr, n, r),
            A2(Fbr, n, r.fv)
        ]));
    }), Dbr = F2(function(n, r) {
        return r.tH(n);
    }), Vbr = F2(function(n, r) {
        return A2(Qt, function(n) {
            return {
                $: 3,
                a: n
            };
        }(n), r);
    }), Bbr = F3(function(n, r, t) {
        if (_8n(GYn(r))) return t;
        var e = function() {
            var n = P8n(r);
            if (n.$) return ov.m5;
            var t = n.a;
            return t > 0 ? Dbr(oe(t)) : ov.uF;
        }();
        return A2(Vbr, n(e), t);
    }), Gbr = F2(function(n, r) {
        if (n.$) return !0;
        var t = n.a;
        return 0 > s(Dvr(r), t);
    }), zbr = F2(function(n, r) {
        return A2(Qt, function(n) {
            return {
                $: 4,
                a: n
            };
        }(n), r);
    }), Sbr = F5(function(n, r, t, e, u) {
        return (e || !A2(Gbr, r, t) ? cu : zbr(n(ov.mT)))(u);
    }), Tbr = F2(function(n, r) {
        var t = A2(Xvr, 3, r.FN);
        return (C8n(r.mp) && !t ? Eer(r.fL) : _er(g))(A2(wer, r.fM, A2(ker, r.nX, A5(Sbr, n, P8n(r.f2), r.fm, r.wL, A3(Bbr, n, r.f2, A2(yer, r.wk, A2(Gsr, r.wk, A2(Aer, A4(Q5n, n, r.mp, r.FN, r.yZ.EX), g))))))));
    }), Pbr = F2(function(n, r) {
        return A2(zx, w([
            Gx("hidden md:block")
        ]), w([
            A2(c_, jdr, A3(Vur, n, A2(Tbr, n, r), r.dd))
        ]));
    }), Zbr = F2(function(n, r) {
        return A2(c_, jdr, A3(Vur, n, Gur(A2(Tbr, n, r)), r.dd));
    }), Mbr = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("signup__body--contents")
            ]), w([
                A2(CF, w([
                    gW,
                    uE(eE),
                    A2(U5n, 1, M5n),
                    uF(rD)
                ]), w([
                    _8n(r.mp) ? _d(n(ov.mU)) : _d(n(ov.mS))
                ])),
                A2(zx, w([
                    Gx("flex flex-grow w-full")
                ]), w([
                    A2(jbr, n, r),
                    A2(Pbr, n, r)
                ])),
                A2(Zbr, n, r)
            ]))
        ]);
    }), Lbr = F2(function(n, r) {
        return {
            g8: function() {
                var t = v(r.c7, r.iK);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;)switch(t.b.$){
                                case 1:
                                    if (1 === t.a.$) break n;
                                    break r;
                                case 0:
                                    if (1 === t.a.$) break n;
                                    break t;
                                case 2:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return w([
                                                Tur(r.dV)
                                            ]);
                                    }
                                default:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return A2(Mbr, n, r);
                                    }
                            }
                            return w([
                                Tur(r.dV)
                            ]);
                        }
                        return Nx;
                    }
                    return Nx;
                }
                return Nx;
            }(),
            yx: ax(r.dV)
        };
    }), Nbr = J0n({
        Cl: Edr,
        CQ: qdr,
        Fj: Fdr,
        F4: function(n) {
            return vx(A2(Qt, A2(kj, jdr, X7n()), A2(Qt, Z6n(Ddr), A2(h6, Bdr, n.fm))));
        },
        Gv: $br,
        GB: Lbr
    }), Hbr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Ibr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Obr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Qbr = "content-container", Rbr = F4(function(n, r, t, e) {
        var u = GYn(r), a = function() {
            var r = A7n(e.jb);
            if (r.$) return Qp;
            var u = r.a;
            return A4(err, t.g0, ux(n), u, Hbr);
        }(), i = function() {
            var r = v(V6n(t), t.FN);
            if (3 === r.b.$) {
                if (r.a.$) return b(g, kc, i = r.b.a);
                var e = r.a.a, i = r.b.a;
                return b(w([
                    A5(c8n, t.g0, ux(n), a1n(u), e, Ibr),
                    a
                ]), A_, i);
            }
            return b(g, kc, g);
        }(), c = i.a, o = i.b, f = i.c;
        return v({
            gk: $6n(t),
            g0: t.g0,
            pt: Ot,
            hz: Ot,
            hH: t.hH,
            hV: OG,
            ld: t.ld,
            fm: o,
            fu: t.fu,
            iK: o,
            iN: OG,
            ag: g,
            dV: n,
            wk: !1,
            fM: Ot,
            bN: Ot,
            dd: A3(j7n, Vx(t.ld), Qbr, S7n(n)),
            mp: u,
            jx: A_,
            f2: r,
            FN: f,
            yZ: e
        }, Uu(A2(Qt, A2(Nu, Obr, Yz), c)));
    }), Ubr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Kbr = A3(nk, "plan", uC(K4n), au(function(n) {
        return {
            vU: n
        };
    })), Wbr = A2($A, Kbr, au(cu)), Xbr = F2(function(n, r) {
        return A2(bk, w([
            "signup_page_plans"
        ]), A2(a8n, n, r));
    }), Ybr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), ek(Wbr), e, pk(A2(Xbr, r, t)));
    }), Jbr = F2(function(n, r) {
        return i(r.g0, n.g0) ? v(r, Qp) : v(m(r, {
            g0: n.g0,
            ld: n.ld,
            jx: A_
        }), A4(Ybr, n.g0, ux(r.dV), a1n(r.mp), Ubr));
    }), nmr = F2(function(n, r) {
        return r;
    }), rmr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tmr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, emr = {
        $: 0
    }, umr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, amr = F2(function(n, r) {
        return {
            vU: n,
            fL: r
        };
    }), imr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, cmr = function(n) {
        return n.ng;
    }, omr = F2(function(n, r) {
        var t = A2(hG, function(r) {
            return 0 > s(cmr(r), n);
        }, Uer(r)), e = t.a;
        return ve(t.b) > 0 ? g : e;
    }), fmr = F2(function(n, r) {
        var t, e = !(t = ibr(r)).$ && 0 > s(n, t.a), u = function() {
            var t = abr(r);
            return !t.$ && s(n, t.a) > 0;
        }();
        return !(e || u);
    }), smr = function(n) {
        return A2(xc, g, A2(Op, function(r) {
            return A2(no, function(r) {
                return !A2(fmr, cmr(r), n.vU);
            }, Uer(r));
        }, n.fL));
    }, lmr = F2(function(n, r) {
        var t = !nE(smr(r)), e = function() {
            var t = v(n, r.fL);
            return !t.a.$ && !t.b.$ && !nE(A2(omr, t.a.a, t.b.a));
        }();
        return e || t;
    }), dmr = F2(function(n, r) {
        var t = Z8n(n);
        return A2(Ekn, lmr(t), r);
    }), vmr = function(n) {
        return ve(A2(no, function(n) {
            return OS(n.fL);
        }, n));
    }, bmr = function(n) {
        return !vmr(n);
    }, mmr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), pmr = function(n) {
        var r = "plan-description-" + n;
        return A2(jc, mmr(n), Ak(r));
    }, $mr = function(n) {
        return n.vU;
    }, gmr = F2(function(n, r) {
        return A2(lmr, n, r) ? Ot : It(r);
    }), hmr = function(n) {
        var r = Z8n(n.f2), t = function() {
            var t = n.iK;
            if (3 === t.$) {
                var e = t.a, u = h5n(e), a = Frr(cnr(e));
                return A4(p5n, n.mp, n.FN, u, n.yZ.EX) ? A2(bb, gmr(r), mb(A2(no, function(n) {
                    return i(qrr(n.vU), A2(xc, "", a));
                }, n.ag))) : Ot;
            }
            return Ot;
        }(), e = mb(A2(n$, gmr(r), n.ag));
        return m(n, {
            bN: ROn(w([
                t,
                e
            ]))
        });
    }, ymr = F2(function(n, r) {
        var t = r.ru, e = r.BB, u = r.BA;
        return A2(Jfn, "Form Field Errored", w([
            esn(n),
            t4n(t),
            r4n(e),
            n4n(u)
        ]));
    }), wmr = (O8 = {
        BA: "One or more members violate the age validation for every plan option.",
        BB: "Signup Disqualified",
        ru: "Invalid Plan Options"
    }, A2(ymr, i4n, O8)), xmr = F2(function(n, r) {
        return A2(bk, w([
            "online_enrollments",
            r,
            "plan"
        ]), fM(n));
    }), _mr = F5(function(n, r, t, e, u) {
        return A4(Dj, GQ(n), K4n, u, A2(dM, function(n) {
            var r;
            return rx(w([
                (r = It(n), v("plan", r.$ ? nx : rx(w([
                    v("id", tx(r.a))
                ]))))
            ]));
        }(e), pk(A2(xmr, r, t))));
    }), Cmr = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Amr = F3(function(n, r, t) {
        return A2(Fu, function(t) {
            return i(qrr(t.vU), qrr(n)) ? A2(amr, t.vU, It(r)) : t;
        }, t);
    }), kmr = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Emr = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), qmr = F4(function(n, r, t, e) {
        var u, a = rx((u = e, A2(Qt, v("plan", TYn(qrr(t))), u)));
        return A4(dPn, n, r, a, Emr(t));
    }), Fmr = function(n) {
        var r, t = n.iK;
        if (3 === t.$) {
            var e = t.a;
            if (C8n(n.mp)) {
                var u = ux(n.dV), a = A2(WU, function(n) {
                    return gsr(n);
                }, ytr(e)), i = (r = A3(psr, "coupon_code", function(n) {
                    return K_n(msr(n));
                }, n.pt), A2(Qt, v("members", a), r));
                return Uu(A2(Fu, function(r) {
                    return A4(qmr, n.g0, u, r.vU, i);
                }, n.ag));
            }
            return A4(btr, n.g0, ux(n.dV), Qnr(e), kmr);
        }
        return Qp;
    }, jmr = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = n.a, e = m(r, {
                    iK: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (L = r.gk).$ ? Qp : o5n(L.a), i = $4n(u), c = w(i ? [
                        W6n(h5n(u)),
                        I6n,
                        H6n
                    ] : [
                        W6n(h5n(u)),
                        H6n
                    ]);
                    return b(m(e, {
                        gk: Ot,
                        hH: i
                    }), Uu(w([
                        a,
                        A4(Ybr, r.g0, ux(r.dV), a1n(r.mp), Ubr)
                    ])), c);
                }
                return b(e, Qp, A2(Ik, 1, t));
            case 8:
                var o = n.a;
                if (e = m(r, {
                    jx: o
                }), 3 === o.$) {
                    var f = A2(Fu, function(n) {
                        return A2(amr, n, Ot);
                    }, $yn(A2(Fu, function(n) {
                        return function(n) {
                            return n.vU;
                        }(n);
                    }, o.a))), l = m(e, {
                        ag: f
                    });
                    return b(l, Fmr(l), g);
                }
                return b(e, Qp, A2(Ik, 1, o));
            case 0:
                var d = r.iK;
                if (3 === d.$) {
                    u = d.a;
                    var p = r.bN;
                    if (p.$) return b(r, Qp, w([
                        A2(Mk, 1, A2(YM, eLn, $mr))
                    ]));
                    var $ = p.a, h = ux(r.dV), y = qrr($.vU), x = Qnr(u);
                    return b(m(r, {
                        wk: !0
                    }), A5(_mr, r.g0, h, x, y, umr), g);
                }
                return b(r, Qp, g);
            case 7:
                var _ = n.a;
                return e = m(r, {
                    wk: !1
                }), 3 === _.$ ? b(e, A4(e5n, 3, r.FN, r.f2, g), w([
                    U6n
                ])) : b(e, Qp, A2(Ik, 1, _));
            case 2:
                var C = A2(ftr, n.a, r.dd), A = C.a, k = C.b, E = C.c, q = E.$ || E.a ? Qp : A2(Nu, cu, Au(emr));
                return b(m(r, {
                    dd: A
                }), Uu(w([
                    A2(Wp, rmr, k),
                    q
                ])), g);
            case 3:
                var F = A2(xc, Ku, A2(bb, function(n) {
                    return wc(n);
                }, _u(n.a))), j = A2(xc, Ku, wc(r.yZ.EX));
                return b(r, A4(s8n, r.mp, r.FN, j, F) ? A2(f5n, j, F) : Qp, g);
            case 4:
                var D = n.a, V = n.b;
                n: for(;;)switch(V.$){
                    case 3:
                        var B = m(r, {
                            ag: A3(Amr, D, V.a, r.ag),
                            fM: Ot
                        }), G = function() {
                            if (bmr(B.ag)) {
                                var n = Uu(A2(Fu, Wp(imr), A2(Fu, pmr, A2(Fu, function(n) {
                                    return qrr(n.vU);
                                }, B.ag))));
                                return b(hmr(B), Uu(w([
                                    A4(a5n, 3, B.FN, B.f2, g),
                                    n
                                ])), A2(dmr, B.f2, B.ag) ? wmr : Qp);
                            }
                            return b(B, Qp, Qp);
                        }();
                        return b(G.a, Uu(w([
                            G.c,
                            G.b
                        ])), g);
                    case 2:
                        if (5 === V.a.$) {
                            var z = It(f9n(w([
                                Zk(Crr(V.a.b))
                            ])));
                            return b(m(r, {
                                fM: z
                            }), Qp, g);
                        }
                        break n;
                    default:
                        break n;
                }
                return b(r, Qp, A2(Ik, 1, V));
            case 5:
                var S = function(n) {
                    switch(n.$){
                        case 0:
                        case 1:
                            return v(Qp, It(function(n) {
                                return {
                                    $: 0,
                                    a: n
                                };
                            }(n.a)));
                        case 2:
                            return v(Qp, It(function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(r = n.a)));
                        case 3:
                            var r = n.a, t = n.b;
                            if (t.$) return v(Qp, Ot);
                            var e = t.a, u = s(e.xh.r8, e.eo.r8 + 1) > 0;
                            return v(Qp, It(A2(Cmr, r, u)));
                        default:
                            return v(Qp, Ot);
                    }
                }(n.a), T = S.a, P = S.b, Z = function() {
                    if (P.$) return v(r, Qp);
                    switch(P.a.$){
                        case 0:
                            return v(m(r, {
                                bN: It(P.a.a)
                            }), Qp);
                        case 1:
                            return v(m(r, {
                                hV: A2(A2(UG, n = P.a.a, r.hV) ? nU : QG, n, r.hV)
                            }), Qp);
                        default:
                            var n, t = P.a, e = t.b, u = A2(e ? QG : nU, n = t.a, r.iN);
                            return v(m(r, {
                                hV: e ? r.hV : A2(QG, n, r.hV),
                                iN: u
                            }), Qp);
                    }
                }();
                return q = Z.b, b(e = Z.a, Uu(w([
                    A2(Wp, imr, T),
                    q
                ])), g);
            case 6:
                return b(m(r, {
                    hz: It(A2(Ep, x8, n.a))
                }), Qp, g);
            case 9:
                var M = n.a;
                return 3 === M.$ ? b(e = m(r, {
                    pt: It(M.a)
                }), Fmr(e), g) : b(r, Qp, A2(Ik, 1, M));
            default:
                return b(m(r, {
                    fm: n.a
                }), Qp, g);
        }
        var L;
    }), Dmr = function(n) {
        var r = A2(n$, cu, A2(Fu, mon, A2(se, "=", n)));
        return r.b && r.b.b && !r.b.b.b ? It(A2(g_, r.a, r.b.a)) : Ot;
    }, Vmr = function(n) {
        var r = n.jb;
        return r.$ ? g : A2(n$, Dmr, A2(se, "&", r.a));
    }, Bmr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Gmr = {
        Bb: !1,
        hV: OG,
        fp: Ot,
        iN: OG,
        i5: g,
        dV: Ot,
        ks: Ot,
        y4: Ot
    }, zmr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    Bb: n.a
                });
            case 1:
                return m(r, {
                    i5: n.a
                });
            case 2:
                return m(r, {
                    y4: n.a
                });
            case 3:
                return m(r, {
                    fp: It(n.a)
                });
            case 4:
                return m(r, {
                    ks: It(n.a)
                });
            case 5:
                return m(r, {
                    dV: It(n.a)
                });
            case 6:
                return m(r, {
                    hV: n.a
                });
            default:
                return m(r, {
                    iN: n.a
                });
        }
    }), Smr = {
        $: 4
    }, Tmr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Pmr = function(n) {
        return n.p8;
    }, Zmr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Mmr = F4(function(n, r, t, e) {
        var u = A2(UG, n, r), a = !u, i = A2(UG, n, t), c = "plan-description-" + n;
        if (e.$) return vE;
        var o = e.a;
        return A2(zx, w([
            Gx("plan-quote__description-wrapper")
        ]), w([
            A2(zx, w([
                DF(c),
                Gx("plan-quote__description rich-text"),
                Oq(w([
                    v("plan-quote__description--collapsed", a)
                ]))
            ]), A2(Fu, c_(Cu), a0(o))),
            i ? A2(cz, w([
                Gx("plan-quote__description-toggle"),
                qE(Zmr(n))
            ]), w([
                A2(Mx, w([
                    Gx("plan-quote__description-toggle-text")
                ]), w(u ? [
                    _d("See Less "),
                    A2(Tq, w([
                        zE,
                        Wj("plan-quote__description-toggle-icon plan-quote__description-toggle-icon--up")
                    ]), 7)
                ] : [
                    _d("See More "),
                    A2(Tq, w([
                        zE,
                        Wj("plan-quote__description-toggle-icon plan-quote__description-toggle-icon--down")
                    ]), 7)
                ]))
            ])) : vE
        ]));
    }), Lmr = F2(function(n, r) {
        var t = n.$ ? vE : A2(EV, w([
            yV(n.a)
        ]), w([
            _d("Update added members")
        ]));
        return A2(zx, g, w([
            A2(PE, w([
                nF,
                Hx(w([
                    Gx("message-box__content mr-1")
                ]))
            ]), w([
                ZV(Ker(r)),
                _d(" cannot be enrolled.")
            ])),
            t
        ]));
    }), Nmr = F2(function(n, r) {
        return r.v3(n);
    }), Hmr = F3(function(n, r, t) {
        var e = A2(omr, r, t);
        return ve(e) > 0 ? It(v(Nmr(oe(r)), A2(zx, g, A2(Fu, function(r) {
            return A2(Lmr, n, r);
        }, e)))) : Ot;
    }), Imr = F3(function(n, r, t) {
        return A2(t.nh, n, r);
    }), Omr = F2(function(n, r) {
        return A2(Imr, oe(n), oe(r));
    }), Qmr = F3(function(n, r, t) {
        var e = v(A2(bb, function(n) {
            return 1 > n ? Ot : It(n);
        }, r), t);
        return e.a.$ ? e.b.$ ? Ot : It(A2(VTn, n, PTn(e.b.a))) : It(A2(VTn, n, e.b.$ ? LTn(e.a.a) : A2(Omr, e.a.a, e.b.a)));
    }), Rmr = F3(function(n, r, t) {
        var e = smr(t);
        return ve(e) > 0 ? A2(Op, function(n) {
            return v(n, A2(zx, g, A2(Fu, function(n) {
                return A2(Lmr, r, n);
            }, e)));
        }, A3(Qmr, n, ibr(t.vU), abr(t.vU))) : Ot;
    }), Umr = F5(function(n, r, t, e, u) {
        var a, i = w([
            mEn(0)
        ]), c = A3(Rmr, r, e, u), o = (a = v(t, u.fL)).a.$ || a.b.$ ? Ot : A3(Hmr, e, a.a.a, a.b.a), f = A2(Y$, o, c);
        if (f.$) return vE;
        var s = f.a, l = s.a, d = s.b;
        return A2(zx, w([
            Gx("radio-card__row")
        ]), w([
            A2(c_, Cu, A3(AEn, i, It(n(l)), d))
        ]));
    }), Kmr = F2(function(n, r) {
        var t = r.fL;
        if (t.$) return vE;
        var e = t.a, u = It(hHn(e)), a = yHn(e);
        return A2(zx, w([
            Gx("plan-quote__amount")
        ]), w([
            A2(c_, Cu, A7(DW, n, a, !1, u, yE, !1, !1))
        ]));
    }), Wmr = F3(function(n, r, t) {
        var e = !A2(lmr, r.fp, t), u = function() {
            var n = r.y4;
            return !n.$ && i(qrr(n.a.vU), qrr(t.vU));
        }(), a = e ? function(n) {
            return {
                $: 0,
                a: n
            };
        }(t) : Smr;
        return A2(zx, w([
            Gx("radio-card plan-quote"),
            Oq(w([
                v("radio-card--selected", u),
                v("radio-card--disabled", !e)
            ])),
            qE(a)
        ]), w([
            A2(zx, w([
                Gx("radio-card__radio")
            ]), w([
                A2(VX, w([
                    zqn(u),
                    SX(A2(qc, Tmr, wm(t))),
                    Sqn(r.Bb || !e)
                ]), g)
            ])),
            A2(zx, w([
                Gx("radio-card__content")
            ]), w([
                A2(zx, w([
                    Gx("radio-card__row")
                ]), w([
                    A2(zx, w([
                        Gx("plan-quote__name")
                    ]), w([
                        A2(PE, w([
                            GN
                        ]), w([
                            _d(Zer(t.vU))
                        ]))
                    ])),
                    A2(Kmr, n, t)
                ])),
                A4(Mmr, qrr(t.vU), r.hV, r.iN, Pmr(t.vU)),
                A5(Umr, n, r.dV, r.fp, r.ks, t)
            ]))
        ]));
    }), Xmr = F2(function(n, r) {
        var t = A3(de, zmr, Gmr, r);
        return A2(zx, w([
            Gx("mb-4")
        ]), A2(Fu, A2(Wmr, n, t), t.i5));
    }), Ymr = F2(function(n, r) {
        var t = A2(nH, w([
            x_(Ci({
                xQ: a1n(r.mp)
            }))
        ]), Vmr(r.yZ.EX)), e = A2(Qt, function(n) {
            return {
                $: 1,
                a: n
            };
        }(r.ag), A2(Qt, function(n) {
            return {
                $: 2,
                a: n
            };
        }(r.bN), A2(Qt, function(n) {
            return {
                $: 0,
                a: n
            };
        }(r.wk), A2(Qt, function(n) {
            return {
                $: 4,
                a: n
            };
        }(t), A2(Qt, function(n) {
            return {
                $: 5,
                a: n
            };
        }(r.dV), A2(Qt, function(n) {
            return {
                $: 6,
                a: n
            };
        }(r.hV), A2(Qt, function(n) {
            return {
                $: 7,
                a: n
            };
        }(r.iN), function() {
            var n = Z8n(r.f2);
            return n.$ ? g : w([
                Bmr(n.a)
            ]);
        }())))))));
        return A2(zx, w([
            Gx("flex flex-col flex-grow w-full"),
            DF(Qbr)
        ]), w([
            A2(c_, imr, A2(Xmr, n, e))
        ]));
    }), Jmr = function(n) {
        return O4n(n);
    }, npr = F2(function(n, r) {
        var t = C8n(r.mp) && (1 >= ve(r.ag) || Cz(r.bN)), e = A2(Op, Jmr, A2(Op, function(n) {
            return n.vU;
        }, r.bN));
        return (t ? Eer(A2(bb, function(n) {
            return n.fL;
        }, r.bN)) : _er($er(ger(r.fm))))(A2(wer, r.fM, A2(ker, e, A2(yer, r.wk, A2(Gsr, r.wk, A2(Aer, A4(Q5n, n, r.mp, r.FN, r.yZ.EX), g))))));
    }), rpr = F2(function(n, r) {
        return A2(zx, w([
            Gx("hidden md:block")
        ]), w([
            A2(c_, rmr, A3(Vur, n, A2(npr, n, r), r.dd))
        ]));
    }), tpr = F2(function(n, r) {
        return A2(c_, rmr, A3(Vur, n, Gur(A2(npr, n, r)), r.dd));
    }), epr = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("signup__body--contents")
            ]), w([
                A2(CF, w([
                    gW,
                    uE(M5n),
                    uF(rD)
                ]), w([
                    _d("Select your membership")
                ])),
                A2(BE, w([
                    xN(JI)
                ]), w([
                    A2(lE, w([
                        TE(12),
                        tO(8)
                    ]), w([
                        A2(Ymr, n, r)
                    ])),
                    A2(lE, w([
                        tO(4),
                        VN(w([
                            Gx("hidden md:block")
                        ]))
                    ]), w([
                        A2(rpr, n, r)
                    ]))
                ])),
                A2(tpr, n, r)
            ]))
        ]);
    }), upr = F2(function(n, r) {
        return {
            g8: function() {
                var t = v(r.iK, vmr(r.ag));
                switch(t.a.$){
                    case 1:
                    default:
                        return Nx;
                    case 2:
                        return w([
                            Tur(r.dV)
                        ]);
                    case 3:
                        return t.b ? r.fM.$ ? A2(epr, n, r) : Nx : A2(epr, n, r);
                }
            }(),
            yx: ax(r.dV)
        };
    }), apr = J0n({
        Cl: Rbr,
        CQ: Jbr,
        Fj: nmr,
        F4: function() {
            return vx(w([
                A2(kj, rmr, X7n()),
                Z6n(tmr)
            ]));
        },
        Gv: jmr,
        GB: upr
    }), ipr = function(n) {
        return {
            $: 14,
            a: n
        };
    }, cpr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, opr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, fpr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, spr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, lpr = function(n) {
        return {
            $: 18,
            a: n
        };
    }, dpr = function(n) {
        return Yzn(VYn(n));
    }, vpr = F2(function(n, r) {
        return dpr(n) && !r.$;
    }), bpr = "content-container", mpr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ppr = function(n) {
        return n.s1;
    }, $pr = F2(function(n, r) {
        var t = n.mp, e = function(n) {
            return n.s3;
        }(t) || ppr(t) || Usr(t) ? It(BYn(t)) : Ot, u = dA(n.lQ), a = lA(n.lQ), i = n.C, c = tNn(i), o = rNn(i), f = function() {
            var n = CSn(i.k5);
            if (1 === n.$) {
                var r = n.a, t = n.b;
                return iL(t) ? v(Ot, Ot) : v(wSn(r), It(t));
            }
            return v(Ot, Ot);
        }(), s = f.a, l = f.b, d = C8n(t) ? v(Ot, It(!0)) : v(It(!0), Ot);
        return m(r, {
            kA: d.a,
            kB: d.b,
            k5: s,
            lo: a,
            lq: c,
            ur: o,
            iH: u,
            mp: e,
            zF: l
        });
    }), gpr = function(n) {
        var r = $pr(n);
        return A4(QQ, n.g0, ux(n.dV), r, mpr);
    }, hpr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), MQ, e, pk(A2(bk, w([
            t
        ]), OQ(r))));
    }), ypr = F3(function(n, r, t) {
        return m(t, {
            mp: A2(Op, BYn, n),
            zF: r
        });
    }), wpr = function(n) {
        return A2(C7n, "practitioner", n);
    }, xpr = F4(function(n, r, t, e) {
        var u = Var(e.jb), a = function() {
            if (u.$) return Qp;
            var r = u.a;
            return A4(Far, t.g0, ux(n), r, lpr);
        }(), c = GYn(r), o = cA, f = V6n(t), s = A4(FSn, t.g0, ux(n), A2(ypr, It(c), Ot), fpr), l = function() {
            var r = A7n(e.jb);
            if (r.$) return Qp;
            var u = r.a;
            return A4(err, t.g0, ux(n), u, ipr);
        }(), d = function() {
            if (i(u, Ot)) {
                var r = wpr(e.jb);
                if (r.$) return v(Qp, kc);
                var a = r.a;
                return mu(a) ? v(Qp, kc) : v(A4(hpr, t.g0, ux(n), a, spr), A_);
            }
            return v(Qp, A_);
        }(), m = d.a, p = d.b, h = function() {
            var r = Ksr(e.jb);
            if (r.$) return v(Qp, kc);
            var u = r.a;
            return mu(u) ? v(Qp, kc) : v(A4(Rsr, t.g0, ux(n), u, opr), A_);
        }(), y = h.b, x = w([
            m,
            h.a,
            l,
            a
        ]), _ = function() {
            var r = v(f, t.FN);
            if (3 === r.b.$) {
                if (r.a.$) return b(g, kc, u = r.b.a);
                var e = r.a.a, u = r.b.a;
                return b(A2(Qt, A5(c8n, t.g0, ux(n), a1n(c), e, cpr), x), A_, u);
            }
            return b(g, kc, g);
        }(), C = _.a, A = _.b, k = _.c, E = {
            gk: $6n(t),
            av: Ot,
            g0: t.g0,
            nX: Ot,
            pt: Ot,
            hH: t.hH,
            a3: !1,
            rc: Ot,
            C: A2(GSn, i(y, kc) && n_n(DYn(r)), dSn(n)),
            ld: t.ld,
            cX: y,
            it: A,
            a9: g,
            fl: A,
            fm: A,
            fu: f,
            iK: A,
            lQ: o,
            dV: n,
            bd: p,
            dX: A3(hSn, n, !0, A2(vpr, r, p)),
            bK: A,
            v6: 0,
            wk: !1,
            fL: Ot,
            fM: Ot,
            d6: Ot,
            mh: Ot,
            da: Ot,
            dd: A3(j7n, Vx(t.ld), bpr, S7n(n)),
            mp: c,
            f2: r,
            FN: k,
            yZ: e,
            dl: Ot,
            kx: !1,
            eq: !1,
            zi: u
        };
        return v(E, Uu(A2(Qt, gpr(E), $(C, w([
            s
        ])))));
    }), _pr = F2(function(n, r) {
        return v(r, Qp);
    }), Cpr = F2(function(n, r) {
        return r;
    }), Apr = function(n) {
        return {
            $: 12,
            a: n
        };
    }, kpr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Epr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, qpr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Fpr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, jpr = function(n) {
        return n.bJ.$ ? vx(w([
            Cj(M1(Fpr)),
            A2(kj, GNn, vx(w([
                A2(kj, Rhn, qj())
            ])))
        ])) : bx;
    }, Dpr = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Vpr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Bpr = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Gpr = {
        $: 10
    }, zpr = function(n) {
        return A2($lr, "practitioner", A2(Op, rQ, n));
    }, Spr = F2(function(n, r) {
        return rx(w([
            zpr(n),
            glr(r)
        ]));
    }), Tpr = F2(function(n, r) {
        return function(n) {
            return n_n(DYn(n));
        }(n) || Oj(r);
    }), Ppr = F4(function(n, r, t, e) {
        if (A2(Tpr, n, t)) {
            var u = v(A2(bb, function(n) {
                return A2(SS, function(r) {
                    return i(bSn(r), n);
                }, e);
            }, tNn(r)), t);
            return 3 === u.b.$ ? w([
                u.b.a
            ]) : u.a.$ ? e : w([
                u.a.a
            ]);
        }
        return g;
    }), Zpr = F2(function(n, r) {
        if (n.$) return !1;
        var t = n.a;
        return Cz(A2(SS, function(n) {
            return i(bSn(n), bSn(t));
        }, r));
    }), Mpr = F2(function(n, r) {
        return A2(Zpr, r, A4(Ppr, n.f2, n.C, n.cX, ger(n.it)));
    }), Lpr = function(n) {
        return n.v4;
    }, Npr = F2(function(n, r) {
        var t = A2(vNn, bNn(n), r);
        return nE(t) ? r : t;
    }), Hpr = F2(function(n, r) {
        var t = v(n.cX, n.it);
        if (3 === t.a.$ && 3 === t.b.$) {
            var e = t.a.a, u = t.b.a;
            return A2(no, function(n) {
                return Cz(A2(SS, function(n) {
                    return i(bSn(e), bSn(n));
                }, A2(Npr, n, u)));
            }, r);
        }
        return r;
    }), Ipr = F2(function(n, r) {
        var t = n.bd;
        return 3 === t.$ ? w([
            t.a
        ]) : r;
    }), Opr = F2(function(n, r) {
        var t = function() {
            var r = n.it;
            return 3 === r.$ ? r.a : g;
        }();
        return A3(uHn, n.C, t, A2(Hpr, n, A2(Ipr, n, r)));
    }), Qpr = F2(function(n, r) {
        if (n.$) return !1;
        var t = n.a;
        return Cz(A2(SS, function(n) {
            return i(rQ(n), rQ(t));
        }, r));
    }), Rpr = F2(function(n, r) {
        return A2(Qpr, r, A2(Fu, function(n) {
            return n.v4;
        }, A2(Opr, n, ger(n.bK))));
    }), Upr = function(n) {
        return n.wq;
    }, Kpr = function(n) {
        return n.ws;
    }, Wpr = F2(function(n, r) {
        return i(It(r), mb(Ae(n)));
    }), Xpr = F2(function(n, r) {
        return A2(_lr, n, r.k5);
    }), Ypr = function(n) {
        if (n.e3) return Ot;
        var r = n.lp;
        return 1 === r.$ ? It(r.a.ur) : Ot;
    }, Jpr = F3(function(n, r, t) {
        var e, u, a, i;
        return A4(Clr, hlr(n), 6, r, A2(Qt, (i = Lpr(n), A2(rsn, "Practitioner", A2(xc, "No Preference", A2(Op, QS, i)))), A2(Qt, Alr(wlr(n)), w([
            (a = rNn(e = t), A2(rsn, "Filtering by Name", A2(xc, "", a))),
            (u = Ypr(e), A2(rsn, "Filtering by Location", A2(xc, "", u))),
            xlr(A2(Xpr, Vx(0), e))
        ]))));
    }), n$r = F2(function(n, r) {
        return A2(FF, function(n) {
            return i(n, r);
        }, n);
    }), r$r = F3(function(n, r, t) {
        return A2(bb, function(t) {
            return A2(NR, t + r, n);
        }, A2(n$r, n, t));
    }), t$r = F2(function(n, r) {
        return A3(r$r, n, 1, r);
    }), e$r = F6(function(n, r, t, e, u, a) {
        if (3 === n.$) {
            var c = n.a, o = Lpr(a);
            if (o.$) {
                if (3 === e.$) {
                    var f = e.a;
                    return !A4(p5n, GYn(r), t, h5n(f), u.EX) || n_n(VYn(r));
                }
                return !0;
            }
            var s = o.a;
            return OS(A2(SS, function(n) {
                return i(rQ(n), rQ(s));
            }, c));
        }
        return !0;
    }), u$r = function(n) {
        return {
            $: 17,
            a: n
        };
    }, a$r = F2(function(n, r) {
        var t = n.fu;
        if (t.$) return Qp;
        var e = t.a, u = rx(w([
            v("online_enrollment_id", tx(e)),
            v("practitioner_id", tx(rQ(r)))
        ]));
        return A4(lM, GQ(n.g0), G$, u$r, A2(dM, u, pk(A2(bk, w([
            "signup_pages",
            a1n(n.mp),
            "online_enrollments",
            e,
            "join_waitlist"
        ]), fM(ux(n.dV))))));
    }), i$r = F3(function(n, r, t) {
        if (n.$) return Qp;
        var e = n.a, u = Vx(0), a = A2(su, "provider", u(e)) ? "Provider" : "Location", c = A2(xc, a, A2(Op, function(n) {
            return A2(fe, ": ", w([
                n ? "Dependent " + oe(n) : "Owner",
                a
            ]));
        }, A2(FF, function(n) {
            return i(n, r);
        }, t)));
        return c4n({
            eZ: w([
                nL(e)
            ]),
            ru: c
        });
    }), c$r = function(n) {
        return A3(Xfr, hlr(n), Nlr(n), Llr(n));
    }, o$r = function(n) {
        return n.v4;
    }, f$r = F2(function(n, r) {
        return A2(bb, function(n) {
            return A2(SS, function(r) {
                return i(rQ(r), n);
            }, r);
        }, n);
    }), s$r = F2(function(n, r) {
        return A3(r$r, n, -1, r);
    }), l$r = F3(function(n, r, t) {
        return A2(Tpr, n, r) && 1 === ve(t) ? mb(t) : Ot;
    }), d$r = function(n) {
        var r = ux(n.dV), t = Usr(n.mp) || ppr(n.mp) ? It(n.mp) : Ot, e = n.C, u = function() {
            var n = CSn(e.k5);
            return 1 === n.$ ? It(n.b) : Ot;
        }();
        return A4(FSn, n.g0, r, A2(ypr, t, u), fpr);
    }, v$r = function(n) {
        return {
            $: 16,
            a: n
        };
    }, b$r = function(n) {
        return {
            $: 13,
            a: n
        };
    }, m$r = function(n) {
        var r = v(n.iK, n.nX);
        if (3 !== r.a.$ || r.b.$) return Qp;
        var t = r.a.a, e = r.b.a, u = A2(WU, function(n) {
            return gsr(n);
        }, ytr(t)), a = $sr({
            Ah: bsr(n.yZ.jb),
            nX: It(e),
            pt: n.pt,
            Bz: u
        });
        return dtr(n.mp) ? A4(dPn, n.g0, ux(n.dV), a, b$r) : A4(btr, n.g0, ux(n.dV), Qnr(t), v$r);
    }, p$r = F2(function(n, r) {
        switch(n.$){
            case 5:
                var t = n.a, e = m(r, {
                    iK: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (Cn = r.gk).$ ? Qp : o5n(Cn.a), c = $4n(u), o = m(e, {
                        gk: Ot,
                        nX: It(cnr(u)),
                        hH: c
                    }), f = w(c ? [
                        W6n(h5n(u)),
                        I6n,
                        H6n
                    ] : [
                        W6n(h5n(u)),
                        H6n
                    ]);
                    return b(o, Uu(w([
                        a,
                        m$r(o)
                    ])), f);
                }
                return b(e, Qp, A2(Ik, 1, t));
            case 0:
                var s = n.a;
                if (3 === s.$) {
                    var l = A2(xc, 0, A2(bb, $u, A2(ra, "x-total-count", s.b))), d = A2(Ilr, r.da, function() {
                        return A2(f$r, T8n(r.f2), ger(s));
                    }), p = A2(Rk, l, r.lQ), $ = function() {
                        var n = v(r.fu, r.bK);
                        if (n.a.$ || 1 !== n.b.$) return Qp;
                        var t = n.a.a;
                        return A4(zlr, r.g0, ux(r.dV), t, Vpr);
                    }();
                    return b(m(r, {
                        lQ: p,
                        bK: s,
                        da: d
                    }), $, g);
                }
                return b(r, Qp, A2(Ik, 1, s));
            case 1:
                return b(e = m(r, {
                    lQ: p = A2(Ok, n.a, r.lQ)
                }), gpr(e), g);
            case 2:
                var h = n.a;
                return e = m(r, {
                    bd: h
                }), 3 === h.$ ? b(m(e, {
                    da: It(h.a)
                }), Qp, g) : b(e, Qp, A2(Ik, 1, h));
            case 3:
                var y = n.a;
                if (e = m(r, {
                    it: y
                }), 3 === y.$) {
                    var x = edr(y.a);
                    return b(m(e, {
                        d6: W = A2(Ilr, r.d6, function() {
                            return A2(Tlr, x, S8n(r.f2));
                        }),
                        mh: A2(Op, bSn, W)
                    }), Qp, g);
                }
                return b(e, Qp, A2(Ik, 1, y));
            case 4:
                var _ = n.a;
                if (e = m(r, {
                    cX: _
                }), 3 === _.$) {
                    var C = _.a;
                    return b(m(e, {
                        d6: It(C),
                        mh: It(bSn(C))
                    }), Qp, g);
                }
                return b(e, Qp, A2(Ik, 1, _));
            case 6:
                var A = A2(ftr, n.a, r.dd), k = A.a, E = A.b, q = A.c, F = q.$ || q.a ? Qp : A2(Nu, cu, Au(Gpr));
                return b(m(r, {
                    dd: k
                }), Uu(w([
                    A2(Wp, kpr, E),
                    F
                ])), g);
            case 10:
                var j = v(r.av, r.fu);
                if (j.a.$ || j.b.$) return b(r, Qp, g);
                var D = j.a.a, V = j.b.a, B = 3 === (_n = r.it).$ ? m(r, {
                    d6: A2(Y$, r.d6, A3(l$r, r.f2, r.cX, A4(Ppr, r.f2, r.C, r.cX, _n.a)))
                }) : r, G = function(n) {
                    var r = A2(bb, Lpr, n.av), t = function() {
                        var t = b(r, n.da, n.bK);
                        if (t.a.$ || t.b.$ || 3 !== t.c.$) return !1;
                        var e = t.b.a, u = t.c.a;
                        return i(rQ(t.a.a), rQ(e)) && A2(Qpr, r, u);
                    }(), e = OS(n.da) ? dpr(n.f2) ? Ot : It(Kpr) : A2(Rpr, n, n.da) || t || Oj(n.bd) && Oj(n.cX) ? Ot : It(Upr), u = A2(bb, wlr, n.av), a = function() {
                        var r = b(u, n.d6, n.it);
                        if (r.a.$ || r.b.$ || 3 !== r.c.$) return !1;
                        var t = r.b.a, e = r.c.a;
                        return i(bSn(r.a.a), bSn(t)) && A2(Zpr, u, e);
                    }(), c = A2(Tpr, n.f2, n.cX) ? OS(n.d6) ? It(RB) : A2(Mpr, n, n.d6) || a ? Ot : It(IB) : Ot;
                    return A2(Y$, e, c);
                }(B);
                if (OS(G)) return b(e = m(B, {
                    a3: !1,
                    rc: G,
                    wk: !0
                }), A6(Qlr, r.g0, ux(e.dV), V, hlr(D), A2(Spr, e.da, e.d6), Dpr), g);
                var z = MNn(A2(xc, bpr, It(YOn(r.da))));
                return b(m(r, {
                    rc: G
                }), Uu(w([
                    z,
                    A3(i$r, G, D, r.a9)
                ])), g);
            case 11:
                var S = n.a;
                if (e = m(r, {
                    wk: !1
                }), 3 === S.$) {
                    var T = S.a, P = A2(Fu, function(n) {
                        return i(hlr(n), hlr(T)) ? T : n;
                    }, e.a9), Z = function(n) {
                        var r = n.av;
                        if (r.$) return b(n, Qp, g);
                        var t = r.a;
                        if (A2(Wpr, n.a9, t)) return b(n, Uu(w([
                            A4(e5n, 6, n.FN, n.f2, g),
                            A3(Jpr, t, n.FN, n.C)
                        ])), w([
                            U6n
                        ]));
                        var e = A2(t$r, n.a9, t);
                        if (e.$) return b(n, Qp, g);
                        var u = e.a, a = function() {
                            var r = n.iK;
                            if (3 === r.$) {
                                var e = A4(p5n, n.mp, n.FN, h5n(r.a), n.yZ.EX);
                                return v(e && dpr(n.f2) ? Lpr(u) : A2(Y$, Lpr(u), Lpr(t)), A2(Tpr, n.f2, n.cX) ? e ? wlr(u) : A2(Y$, wlr(u), wlr(t)) : Ot);
                            }
                            return v(Ot, Ot);
                        }(), i = a.a, c = a.b;
                        return b(m(n, {
                            av: It(u),
                            a3: Cz(Lpr(u)),
                            d6: c,
                            mh: A2(Op, bSn, c),
                            da: i
                        }), Uu(w([
                            cZn(hlr(u)),
                            A3(Jpr, t, n.FN, n.C)
                        ])), w([
                            Tor(hlr(u))
                        ]));
                    }(m(e, {
                        av: It(T),
                        a9: P
                    }));
                    return b(cn = Z.a, Z.b, f = Z.c);
                }
                return b(e, Qp, A2(Ik, 1, S));
            case 7:
                var M = A2(xc, Ku, A2(bb, function(n) {
                    return wc(n);
                }, _u(n.a))), L = A2(xc, Ku, wc(r.yZ.EX));
                return b(r, A4(s8n, r.mp, r.FN, L, M) ? A2(f5n, L, M) : Qp, w([
                    For
                ]));
            case 8:
                var N = n.a, H = m(r, {
                    fl: N
                });
                if (3 === N.$) {
                    var I = N.a, O = A2(bb, rdr, mb(I)), Q = A5(e$r, r.bK, r.f2, r.FN, r.iK, r.yZ), R = Usr(r.mp) || ppr(r.mp) ? It(r.mp) : Ot, U = (wn = b(r.cX, r.bd, O)).a.$ || wn.b.$ || wn.c.$ ? r.C : A2(BSn, A2(TSn, wn.c.a, aSn), r.C), K = A2(FE, mb(Ae(I)), mb(A2(no, Q, I))), W = A2(Tpr, r.f2, r.cX) ? H.cX.$ ? JF(H.cX) : A2(FE, H.d6, A2(bb, wlr, A2(bb, function(n) {
                        return Q(n) ? A2(s$r, I, n) : It(n);
                    }, K))) : Ot, X = (d = H.bd.$ ? JF(H.bd) : A2(FE, H.da, A2(bb, Lpr, A2(bb, function(n) {
                        return Q(n) ? A2(s$r, I, n) : It(n);
                    }, K))), A4(FSn, r.g0, ux(r.dV), A2(ypr, R, O), fpr)), Y = ve(I) > 1 ? w([
                        A3(zor, A2(Fu, c$r, I), A2(xc, "", A2(Op, hlr, K)), !0)
                    ]) : g, J = m(H, {
                        av: K,
                        a3: 3 === (xn = r.iK).$ && A4(p5n, r.mp, r.FN, h5n(xn.a), r.yZ.EX),
                        C: U,
                        a9: I,
                        d6: W,
                        mh: A2(Op, bSn, W),
                        da: d
                    }), nn = gpr(J);
                    return b(J, Uu(w([
                        A4(a5n, 6, J.FN, J.f2, g),
                        X,
                        nn
                    ])), Y);
                }
                return b(H, Qp, A2(Ik, 1, N));
            case 9:
                var rn = n.a;
                return ve(r.a9) > 0 ? (D = mb(A2(no, function(n) {
                    return i(hlr(n), rn);
                }, r.a9)), W = A2(Tpr, r.f2, r.cX) ? A2(bb, wlr, D) : Ot, b(m(r, {
                    av: D,
                    a3: Cz(d = A2(bb, Lpr, D)),
                    rc: Ot,
                    d6: W,
                    mh: A2(Op, bSn, W),
                    da: d
                }), Qp, g)) : b(r, Qp, g);
            case 12:
                var tn = A2(SNn, n.a, r.dX), en = tn.b, un = tn.c, an = m(r, {
                    rc: Ot,
                    dX: tn.a
                }), cn = function() {
                    if (un.$) return an;
                    switch(un.a.$){
                        case 0:
                            var n = un.a.a, t = function() {
                                var t = v(r.it, A2(Tpr, r.f2, r.cX));
                                if (3 === t.a.$ && t.b) {
                                    var e = t.a.a, u = A2(mNn, It(n), A4(Ppr, r.f2, r.C, r.cX, e)), a = _Nn(r.C.k5) ? n.lp : Ot;
                                    return A2(Y$, a, A3(l$r, r.f2, r.cX, u));
                                }
                                return Ot;
                            }();
                            return m(an, {
                                a3: !1,
                                d6: t,
                                mh: A2(Op, bSn, t),
                                da: It(n.v4)
                            });
                        case 1:
                            return t = 3 === (u = v(r.it, A2(Tpr, r.f2, r.cX))).a.$ && u.b ? A3(l$r, r.f2, r.cX, A4(Ppr, r.f2, r.C, r.cX, u.a.a)) : Ot, m(an, {
                                a3: !1,
                                d6: t,
                                mh: A2(Op, bSn, t),
                                da: Ot
                            });
                        case 2:
                            var e = un.a.a;
                            return m(an, {
                                d6: It(e),
                                mh: It(bSn(e))
                            });
                        default:
                            return m(an, {
                                eq: !0
                            });
                    }
                    var u;
                }(), on = un.$ || 3 !== un.a.$ ? Qp : A2(a$r, cn, un.a.a);
                return b(cn, Uu(w([
                    A2(Wp, Apr, en),
                    on
                ])), g);
            case 13:
                var fn = n.a;
                n: for(;;)switch(fn.$){
                    case 3:
                        return b(m(r, {
                            fL: It(fn.a),
                            fM: Ot
                        }), Qp, A2(Ik, 1, fn));
                    case 2:
                        if (5 === fn.a.$) {
                            var sn = It(f9n(w([
                                Zk(Crr(fn.a.b))
                            ])));
                            return b(m(r, {
                                fM: sn
                            }), Qp, g);
                        }
                        break n;
                    default:
                        break n;
                }
                return b(r, Qp, A2(Ik, 1, fn));
            case 14:
                var ln = n.a;
                return 3 === ln.$ ? b(e = m(r, {
                    pt: It(ln.a)
                }), m$r(e), g) : b(r, Qp, A2(Ik, 1, ln));
            case 15:
                var dn = A2(FNn, n.a, r.C), vn = dn.b, bn = dn.c, mn = m(r, {
                    C: dn.a
                }), pn = function() {
                    if (bn.$) return v(mn, Qp);
                    var n = bn.a, r = m(mn, {
                        a3: !1
                    });
                    switch(n.$){
                        case 1:
                            var t = n.b, e = m(r, {
                                lQ: cA
                            });
                            return v(t ? function(n) {
                                var r = n.it;
                                if (3 === r.$) {
                                    var t = r.b;
                                    return m(n, {
                                        it: A2(tC, plr(r.a), t)
                                    });
                                }
                                return n;
                            }(r) : r, gpr(e));
                        case 2:
                            return (t = n.b) ? v(e = m(r, {
                                lQ: cA
                            }), gpr(e)) : v(r, Qp);
                        case 3:
                            return n.b ? v(e = m(r, {
                                lQ: cA
                            }), Uu(w([
                                gpr(e),
                                d$r(e)
                            ]))) : v(r, Qp);
                        default:
                            return v(e = m(r, {
                                lQ: cA
                            }), gpr(e));
                    }
                }();
                return F = pn.b, b(e = pn.a, Uu(w([
                    A2(Wp, Bpr, vn),
                    F
                ])), g);
            case 16:
                return b(m(r, {
                    fm: n.a
                }), Qp, g);
            case 17:
                return b(m(r, 3 === ($n = n.a).$ ? {
                    kx: !0,
                    eq: !1
                } : {
                    eq: !1
                }), Qp, g);
            default:
                var $n;
                if (3 === ($n = n.a).$) {
                    var gn = $n.a, hn = A2(Op, vcr, hcr(gn));
                    if (hn.$) return b(m(r, {
                        dl: It(gn)
                    }), A4(hpr, r.g0, ux(r.dV), UR(o$r(gn)), spr), g);
                    var yn = hn.a;
                    return b(m(r, {
                        dl: It(gn)
                    }), Uu(w([
                        A4(hpr, r.g0, ux(r.dV), UR(o$r(gn)), spr),
                        A5(c8n, r.g0, ux(r.dV), a1n(r.mp), yn, cpr)
                    ])), w([
                        rir(yn)
                    ]));
                }
                return b(m(r, {
                    bd: kc
                }), Qp, g);
        }
        var wn, xn, _n, Cn;
    }), $$r = function(n) {
        return n.rE;
    }, g$r = function(n) {
        return n.wp;
    }, h$r = function(n) {
        return n.wu;
    }, y$r = F3(function(n, r, t) {
        var e = n_n(DYn(r)) ? n(g$r) : n(h$r);
        return A2(xc, w([
            _d(e)
        ]), A2(Op, function(r) {
            return w([
                _d(e + " " + n($$r) + " "),
                ZV(r)
            ]);
        }, A2(bb, Nlr, t)));
    }), w$r = F2(function(n, r) {
        if (r.$) return vE;
        var t = r.a;
        return A2(zx, w([
            Gx("form-error mb-3 mt-0")
        ]), w([
            _d(n(t))
        ]));
    }), x$r = F2(function(n, r) {
        var t = r.wk, e = r.cX, u = r.C;
        if (r.bd.$) return vE;
        var a = function() {
            var n = r.it;
            if (3 === n.$) {
                var t = n.a;
                return 3 === e.$ ? w([
                    e.a
                ]) : t;
            }
            return g;
        }();
        return A2(c_, Bpr, A4(WQn, n, t, a, u));
    }), _$r = function(n) {
        return {
            $: 9,
            a: n
        };
    }, C$r = F4(function(n, r, t, e) {
        var u = A2(Op, A2(eHn, e.C, t), e.da), a = A2(Opr, e, r), c = A4(Ppr, e.f2, e.C, e.cX, t), o = nE(c) ? Ot : e.d6;
        return A2(zx, w([
            Gx("mb-8")
        ]), w([
            nE(a) && !dpr(e.f2) ? A2(f_, g, w([
                _d("No providers found")
            ])) : A2(c_, Apr, A3(PQn, n, w([
                _On(e.wk),
                GOn(u),
                DOn(a),
                VOn(o),
                BOn(e.mh),
                EOn(c),
                AOn(Cz(e.rc)),
                COn(e.a3),
                jOn(A2(bb, Llr, e.av)),
                _$r(!i(e.dl, Ot))
            ]), e.dX))
        ]));
    }), A$r = function(n) {
        var r = Vx(n.ld), t = A2(xc, "this provider", A2(Op, QS, n.da)), e = n.dl;
        if (e.$) return n.eq ? A2(zx, w([
            Gx("bg-blue-50 border border-blue-200 text-blue-800 rounded-md p-4 mb-4")
        ]), w([
            A2(f_, g, w([
                _d(r(xQn) + " " + t + " " + r(_Qn))
            ]))
        ])) : n.kx ? A2(zx, w([
            Gx("bg-green-50 border border-green-200 text-green-800 rounded-md p-4 mb-4")
        ]), w([
            A2(f_, w([
                ven
            ]), w([
                _d(r(dQn))
            ])),
            A2(f_, g, w([
                _d(r(vQn) + " " + t + ".")
            ]))
        ])) : vE;
        var u = e.a;
        return A2(zx, w([
            Gx("bg-green-50 border border-green-200 text-green-800 rounded-md p-4 mb-4")
        ]), w([
            A2(f_, w([
                ven
            ]), w([
                _d(r(yQn))
            ])),
            A2(f_, g, w([
                _d(r(hQn) + " " + Fmn(o$r(u)) + ".")
            ]))
        ]));
    }, k$r = F2(function(n, r) {
        var t = v(r.bK, r.it);
        if (3 === t.a.$ && 3 === t.b.$) {
            var e = t.a.a, u = t.b.a;
            return A2(zx, w([
                DF(bpr)
            ]), w([
                A2(x$r, n, r),
                A2(w$r, n, r.rc),
                A$r(r),
                A4(C$r, n, e, u, r)
            ]));
        }
        return A2(zx, g, Nx);
    }), E$r = function(n) {
        return {
            $: 1,
            a: n
        };
    }, q$r = F3(function(n, r, t) {
        var e = v(r.fl, r.av);
        return 3 !== e.a.$ || e.b.$ ? t : A2(Aer, A5(Vsr, n, A2(Wpr, e.a.a, e.b.a), r.mp, r.FN, r.yZ.EX), t);
    }), F$r = F2(function(n, r) {
        return (function() {
            if (dtr(r.mp)) return Eer(r.fL);
            var n = function() {
                var n = r.fm;
                return 3 === n.$ ? n.a : g;
            }();
            return _er($er(n));
        })()(A2(wer, r.fM, A2(ker, r.nX, A2(yer, r.wk || function(n) {
            return !!i(n.dl, Ot) && A2(xc, !1, A2(Op, function(n) {
                return "full_waitlisting" === KNn(n);
            }, n.da));
        }(r), A2(Gsr, r.wk, A3(q$r, n, r, g))))));
    }), j$r = F2(function(n, r) {
        return A2(zx, w([
            Gx("hidden md:block")
        ]), w([
            A2(c_, kpr, A3(Vur, n, A2(F$r, n, r), r.dd))
        ]));
    }), D$r = F2(function(n, r) {
        return A2(c_, kpr, A3(Vur, n, Gur(A2(F$r, n, r)), r.dd));
    }), V$r = F2(function(n, r) {
        var t;
        return w([
            A2(zx, w([
                Gx("signup__body--contents")
            ]), w([
                A2(CF, w([
                    gW,
                    uE(M5n),
                    uF(rD)
                ]), A3(y$r, n, r.f2, r.av)),
                A2(BE, w([
                    xN(JI)
                ]), w([
                    A2(lE, w([
                        TE(12),
                        tO(8)
                    ]), w([
                        A2(k$r, n, r),
                        (t = r.lQ, A2(c_, E$r, A2(Yq, g, t)))
                    ])),
                    A2(lE, w([
                        tO(4),
                        VN(w([
                            Gx("hidden md:block")
                        ]))
                    ]), w([
                        A2(j$r, n, r)
                    ]))
                ])),
                A2(D$r, n, r)
            ]))
        ]);
    }), B$r = F2(function(n, r) {
        return {
            g8: function() {
                var t = v(r.bK, r.iK);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;)switch(t.b.$){
                                case 1:
                                    if (1 === t.a.$) break n;
                                    break r;
                                case 0:
                                    if (1 === t.a.$) break n;
                                    break t;
                                case 2:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return w([
                                                Tur(r.dV)
                                            ]);
                                    }
                                default:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return A2(V$r, n, r);
                                    }
                            }
                            return w([
                                Tur(r.dV)
                            ]);
                        }
                        return Nx;
                    }
                    return Nx;
                }
                return Nx;
            }(),
            yx: ax(r.dV)
        };
    }), G$r = J0n({
        Cl: xpr,
        CQ: _pr,
        Fj: Cpr,
        F4: function(n) {
            return vx(w([
                A2(kj, kpr, X7n()),
                Z6n(qpr),
                qor(Epr),
                A2(kj, Apr, jpr(n.dX))
            ]));
        },
        Gv: p$r,
        GB: B$r
    }), z$r = function(n) {
        return {
            $: 6,
            a: n
        };
    }, S$r = F2(function(n, r) {
        return {
            fE: r,
            dV: n,
            wk: !1
        };
    }), T$r = F6(function(n, r, t, e, u, a) {
        return {
            m8: a,
            p8: t,
            sl: n,
            ur: r,
            yi: u,
            yx: e
        };
    }), P$r = F6(function(n, r, t, e, u, a) {
        return {
            kC: a,
            sl: n,
            ur: r,
            xA: t,
            yp: e,
            yZ: u
        };
    }), Z$r = function(n) {
        return {
            $: 1,
            a: n
        };
    }, M$r = function(n) {
        return {
            $: 0,
            a: n
        };
    }, L$r = F6(function(n, r, t, e, u, a) {
        return {
            pP: u,
            p1: a,
            sl: n,
            sK: t,
            ur: r,
            xe: e
        };
    }), N$r = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), H$r = A3(nk, "url", M$, au(function(n) {
        return {
            yZ: n
        };
    })), I$r = A2(zB, 0, A2($A, H$r, au(N$r))), O$r = A3(nk, "default_mce_signup_page", uC(I$r), A3(nk, "custom_logo_url", uC(M$), A3(nk, "sandbox", ru, A3(nk, "is_mce", ru, A3(nk, "name", M$, A3(nk, "id", M$, au(L$r))))))), Q$r = A2($A, O$r, au(cu)), R$r = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), U$r = A3(nk, "logo_url", uC(M$), au(function(n) {
        return {
            tm: n
        };
    })), K$r = A2(zB, 0, A2($A, U$r, au(R$r))), W$r = Q$(w([
        A2(eu, M$r, Q$r),
        A2(eu, Z$r, K$r)
    ])), X$r = A2($A, W$r, au(cu)), Y$r = A3(nk, "addable", X$r, A3(nk, "url", uC(M$), A3(nk, "tagline", uC(M$), A3(nk, "show_email_button", ru, A3(nk, "name", M$, A3(nk, "id", M$, au(P$r))))))), J$r = A2($A, Y$r, au(cu)), ngr = A3(nk, "addons", ek(J$r), A3(nk, "subtitle", M$, A3(nk, "title", M$, A3(nk, "description", M$, A3(nk, "name", M$, A3(nk, "id", M$, au(T$r))))))), rgr = A2($A, ngr, au(cu)), tgr = F2(function(n, r) {
        return A2(bk, w([
            "addon_categories"
        ]), A2(a8n, n, r));
    }), egr = F4(function(n, r, t, e) {
        return A4(aA, GQ(n), ek(rgr), e, pk(A2(tgr, r, t)));
    }), ugr = function(n) {
        return {
            lY: n.lY,
            lZ: n.lZ,
            l_: n.l_,
            mo: n.mo
        };
    }, agr = F4(function(n, r, t, e) {
        var u, a = GYn(r);
        return v({
            er: A_,
            g0: t.g0,
            ld: t.ld,
            fu: t.fu,
            dV: n,
            wk: !1,
            wM: (u = e.jb, A2(C7n, "referred_token", u)),
            c9: Ot,
            mp: a,
            f2: r,
            f8: A2(S$r, n, ugr(r)),
            yZ: e
        }, A4(egr, t.g0, ux(n), a1n(a), z$r));
    }), igr = F2(function(n, r) {
        return v(r, Qp);
    }), cgr = F2(function(n, r) {
        return r;
    }), ogr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fgr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, sgr = F2(function(n, r) {
        return $(function(n) {
            return A2(su, "authorization is required", n) ? "Email cannot be sent because you did not accept the ePHI waiver. Please contact practice at " : "Email cannot be sent. Please contact practice at ";
        }(r), $(function(n) {
            var r = bV(n);
            return r.$ ? "" : aV(r.a);
        }(n), function(n) {
            var r = Xw(n);
            if (r.$) return "";
            var t = r.a;
            return bV(n).$ ? t : " or " + t;
        }(n)));
    }), lgr = function(n) {
        return n.p1;
    }, dgr = F3(function(n, r, t) {
        return A2(bk, w([
            "online_enrollments",
            r,
            "addons",
            t,
            "notify"
        ]), fM(n));
    }), vgr = F5(function(n, r, t, e, u) {
        return A4(lM, GQ(n), AKn, u, pk(A3(dgr, r, t, e)));
    }), bgr = A2(Mk, 1, D1n), mgr = A2(Mk, 3, V1n), pgr = function(n) {
        return A2(bb, mon, n.b.yZ);
    }, $gr = F2(function(n, r) {
        if (r.$) {
            var t = pgr(n);
            return t.$ ? XB : irr(t.a);
        }
        return irr(r.a);
    }), ggr = F2(function(n, r) {
        return A2($gr, n, r.l_);
    }), hgr = F2(function(n, r) {
        return v(m(r, {
            wk: !0
        }), A2(ggr, r.dV, r.fE));
    }), ygr = function(n) {
        return n.a.yZ;
    }, wgr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = function(n) {
                    return n.yZ;
                }(a = n.a), e = function(n) {
                    return n.kC;
                }(a), u = function(n) {
                    return !n.$ && rTn(n.a);
                }(e) && OS(t) ? A2(Op, function(n) {
                    var t = r.wM;
                    return t.$ ? n : A2(kN, n, w([
                        A2(g_, "token", t.a)
                    ]));
                }, A2(Op, ygr, A2(bb, lgr, function(n) {
                    return n.$ ? Ot : It(n.a);
                }(e)))) : t;
                return b(r, u.$ ? Qp : irr(u.a), g);
            case 1:
                var a = n.a, i = function() {
                    var n = r.fu;
                    if (2 === n.$) {
                        var t = n.a;
                        return A5(vgr, r.g0, ux(r.dV), t, function(n) {
                            return n.sl;
                        }(a), ogr);
                    }
                    return Qp;
                }();
                return b(r, i, g);
            case 2:
                var c = n.a;
                switch(c.$){
                    case 3:
                        return b(r, Qp, w([
                            mgr
                        ]));
                    case 2:
                        return b(r, Qp, w(5 === c.a.$ ? [
                            A2(Mk, 1, Zk(A2(sgr, r.dV, c.a.b)))
                        ] : [
                            bgr
                        ]));
                    default:
                        return b(r, Qp, A2(Ik, 1, c));
                }
            case 3:
                return b(m(r, {
                    c9: It(n.a)
                }), Qp, g);
            case 4:
                return b(r, Qp, g);
            case 5:
                var o = A2(hgr, n.a, r.f8);
                return i = o.b, b(m(r, {
                    f8: o.a
                }), A2(Wp, fgr, i), g);
            default:
                var f = n.a, s = m(r, {
                    er: f
                });
                return 3 === f.$ ? b(m(s, {
                    c9: mb(f.a)
                }), Qp, g) : b(s, Qp, A2(Ik, 1, f));
        }
    }), xgr = function(n) {
        return n.dh.AA;
    }, _gr = function(n) {
        return n.dh.GH;
    }, Cgr = F2(function(n, r) {
        return A2(HCn, n, A2(xc, n, r));
    }), Agr = F3(function(n, r, t) {
        return A2(Cgr, n(t ? xgr : _gr), r.lZ);
    }), kgr = F3(function(n, r, t) {
        var e;
        return e = A3(Agr, n, r, t), A2(f_, w([
            uF(xD),
            uE(eE)
        ]), w([
            _d(e)
        ]));
    }), Egr = F2(function(n, r) {
        return r.zg(n);
    }), qgr = F3(function(n, r, t) {
        return A2(Cgr, n(function(n) {
            return Egr(ax(n));
        }(r)), t.lY);
    }), Fgr = F2(function(n, r) {
        return A2(yF, w([
            fF,
            Lj(r),
            Qj(r),
            cF(0)
        ]), w([
            A2(Mx, g, w([
                _d(n)
            ]))
        ]));
    }), jgr = F4(function(n, r, t, e) {
        return A2(bE, t.mo, A2(Fgr, A3(qgr, n, r, t), e));
    }), Dgr = F2(function(n, r) {
        return r.zo(n);
    }), Vgr = F3(function(n, r, t) {
        return A2(zx, g, w([
            A2(CF, w([
                gW,
                uE(Jq),
                uE(AD),
                uF(xD)
            ]), w([
                _d(n(Dgr(ax(r))))
            ])),
            A2(bE, t, A2(i_, w([
                uE(Jq),
                uF(xD)
            ]), w([
                _d(n(B1n))
            ])))
        ]));
    }), Bgr = F3(function(n, r, t) {
        var e = !t.$ && _8n(t.a);
        return A2(BE, g, w([
            spn(w([
                cmn(2),
                tO(1),
                TE(0)
            ])),
            A2(lE, w([
                cE(xD),
                cmn(8),
                tO(10),
                TE(12)
            ]), w([
                A2(zx, w([
                    Gx("white-circle")
                ]), w([
                    A2(Tq, g, 15)
                ])),
                A3(Vgr, n, r.dV, e),
                A3(kgr, n, r.fE, e),
                A4(jgr, n, r.dV, r.fE, r.wk)
            ]))
        ]));
    }), Ggr = {
        $: 4
    }, zgr = function(n) {
        return n.p8;
    }, Sgr = function(n) {
        return n.ur;
    }, Tgr = F2(function(n, r) {
        var t = !n.$ && i(n.a, r), e = t ? Ggr : function(n) {
            return {
                $: 3,
                a: n
            };
        }(r);
        return A2(zx, w([
            Gx("addon-category"),
            Oq(w([
                v("addon-category--selected", t)
            ])),
            qE(e)
        ]), w([
            A2(f_, w([
                uE(L6),
                GN
            ]), w([
                _d(Sgr(r))
            ])),
            A2(f_, w([
                VG
            ]), w([
                _d(zgr(r))
            ]))
        ]));
    }), Pgr = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return ve(t) > 1 ? A2(zx, w([
                Gx("flex flex-col relative")
            ]), A2(Fu, Tgr(r), t)) : vE;
        }
        return vE;
    }), Zgr = function(n) {
        return function(n) {
            var r = n;
            if (r.$) {
                var t = function(n) {
                    return n.a.tm;
                }(r.a);
                return t.$ ? "" : t.a;
            }
            var e = j2n(r.a);
            return e.$ ? "" : e.a;
        }(n.kC);
    }, Mgr = function(n) {
        return n.ur;
    }, Lgr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ngr = function(n) {
        return n.kD.qN;
    }, Hgr = function(n) {
        return n.kD.hP;
    }, Igr = F3(function(n, r, t) {
        return function(n) {
            return n.xA;
        }(t) ? A2(zx, g, w([
            A2(yF, w([
                j6,
                Lj(r),
                cF(Lgr(t)),
                Kj(w([
                    Gx("mt-3")
                ]))
            ]), w([
                _d(n(Ngr))
            ]))
        ])) : vE;
    }), Ogr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Qgr = F3(function(n, r, t) {
        return A2(yF, w([
            CD,
            Lj(r),
            cF(Ogr(t))
        ]), w([
            _d(n(Hgr))
        ]));
    }), Rgr = F3(function(n, r, t) {
        var e = A2(xc, "", function(n) {
            return n.yp;
        }(t));
        return A2(zx, w([
            Gx("addon-category__addon")
        ]), w([
            A2(BE, w([
                xN(JI),
                cE(gE)
            ]), w([
                A2(lE, w([
                    TE(3),
                    VN(w([
                        Gx("pr-8")
                    ]))
                ]), w([
                    A2(uJ, w([
                        Gx("inline"),
                        iJ(Zgr(t))
                    ]), g)
                ])),
                A2(lE, w([
                    TE(5)
                ]), w([
                    A2(f_, w([
                        uE(L6),
                        ven
                    ]), w([
                        _d(Mgr(t))
                    ])),
                    A2(f_, w([
                        VG,
                        nF
                    ]), w([
                        _d(e)
                    ]))
                ])),
                A2(lE, w([
                    TE(4),
                    VN(w([
                        Gx("pl-8 flex flex-col items-center")
                    ]))
                ]), w([
                    A3(Qgr, n, r, t),
                    A3(Igr, n, r, t)
                ]))
            ]))
        ]));
    }), Ugr = F2(function(n, r) {
        var t = r.c9;
        if (t.$) return vE;
        var e = function(n) {
            return n.m8;
        }(t.a);
        return A2(zx, w([
            Gx("flex w-full flex-col")
        ]), A2(Fu, A2(Rgr, n, r.wk), e));
    }), Kgr = function(n) {
        return n.yi;
    }, Wgr = function(n) {
        return n.yx;
    }, Xgr = F2(function(n, r) {
        var t = r.c9;
        if (t.$) return vE;
        var e, u = t.a;
        return A2(zx, w([
            Gx("addons-container")
        ]), w([
            (e = u, A2(zx, g, w([
                A2(i_, w([
                    gW,
                    uE(L6),
                    uF(xD)
                ]), w([
                    _d(Wgr(e))
                ])),
                A2(f_, w([
                    Hx(w([
                        Gx("addon-category__description")
                    ])),
                    gW,
                    nF,
                    uE(eE),
                    uF(xD)
                ]), w([
                    _d(Kgr(e))
                ]))
            ]))),
            A2(zx, w([
                Gx("flex w-full")
            ]), w([
                A2(Pgr, r.er, r.c9),
                A2(Ugr, n, r)
            ]))
        ]));
    }), Ygr = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("signup__body--contents")
            ]), w([
                A2(c_, fgr, A3(Bgr, n, r.f8, It(r.mp))),
                A2(Xgr, n, r)
            ]))
        ]);
    }), Jgr = F2(function(n, r) {
        return {
            g8: 1 === r.er.$ ? Nx : A2(Ygr, n, r),
            yx: n(G1n)
        };
    }), nhr = J0n({
        Cl: agr,
        CQ: igr,
        Fj: cgr,
        F4: function() {
            return bx;
        },
        Gv: wgr,
        GB: Jgr
    }), rhr = F4(function(n, r, t, e) {
        return {
            ld: e,
            dV: n,
            mp: r,
            yZ: t
        };
    }), thr = F4(function(n, r, t, e) {
        var u = function() {
            var n = t.FN;
            return 3 === n.$ ? n.a : g;
        }(), a = GYn(r);
        return v(A4(rhr, n, a, e, t.ld), A3(c1n, a, u, e.jb));
    }), ehr = F2(function(n, r) {
        return v(r, Qp);
    }), uhr = F2(function(n, r) {
        return r;
    }), ahr = F2(function(n, r) {
        return b(r, Qp, g);
    }), ihr = F2(function(n, r) {
        var t = r.dV;
        return {
            g8: w([
                vE
            ]),
            yx: ax(t)
        };
    }), chr = J0n({
        Cl: thr,
        CQ: ehr,
        Fj: uhr,
        F4: function() {
            return bx;
        },
        Gv: ahr,
        GB: ihr
    }), ohr = F4(function(n, r, t, e) {
        return {
            ld: e,
            dV: n,
            mp: r,
            yZ: t
        };
    }), fhr = F4(function(n, r, t, e) {
        var u = function() {
            var n = t.FN;
            return 3 === n.$ ? n.a : g;
        }(), a = GYn(r);
        return v(A4(ohr, n, a, e, t.ld), A3(c1n, a, u, e.jb));
    }), shr = F2(function(n, r) {
        return v(r, Qp);
    }), lhr = F2(function(n, r) {
        return r;
    }), dhr = F2(function(n, r) {
        return b(r, Qp, g);
    }), vhr = F2(function() {
        return {
            g8: w([
                vE
            ]),
            yx: "Signup"
        };
    }), bhr = J0n({
        Cl: fhr,
        CQ: shr,
        Fj: lhr,
        F4: function() {
            return bx;
        },
        Gv: dhr,
        GB: vhr
    }), mhr = function(n) {
        return {
            Cl: F2(function(r, t) {
                return b(n.Cl(t), Qp, g);
            }),
            CQ: wm(A2(tu, cu, YRn)),
            Fj: wm(cu),
            F4: function() {
                return bx;
            },
            Gv: F2(function(r, t) {
                return b(A2(n.Gv, r, t), Qp, g);
            }),
            GB: n.GB
        };
    }, phr = F2(function(n, r) {
        return r;
    }), $hr = function(n) {
        return A2(zx, w([
            Gx("relative inline-block w-32 rounded-md bg-info-200 px-3 py-2 text-md")
        ]), w([
            _d("Anchor element"),
            n
        ]));
    }, ghr = w([
        {
            sT: "Reply",
            uY: 0
        },
        {
            sT: "Copy",
            uY: 0
        }
    ]), hhr = F2(function(n, r) {
        return A2(zx, w([
            Gx("flex flex-col space-y-2")
        ]), w([
            A2(Kk, w([
                VG,
                xE
            ]), w([
                _d(n)
            ])),
            r
        ]));
    }), yhr = A2(zx, w([
        Gx("flex flex-col space-y-8 p-4")
    ]), w([
        A2(hhr, "Anchored above, left-aligned (incoming-message style)", $hr(A2(Qen, {
            zT: !1,
            ED: 0
        }, ghr))),
        A2(hhr, "Anchored above, right-aligned (outgoing-message style)", $hr(A2(Qen, {
            zT: !0,
            ED: 0
        }, ghr))),
        A2(hhr, "Anchored below, left-aligned (used when there's no space above)", $hr(A2(Qen, {
            zT: !1,
            ED: 1
        }, ghr)))
    ])), whr = mhr({
        Cl: function() {
            return 0;
        },
        Gv: phr,
        GB: function() {
            return {
                g8: w([
                    yhr
                ]),
                yx: "StyleGuide.ActionMenu"
            };
        }
    }), xhr = w([
        A2(zx, g, w([
            Lx(w([
                Uq,
                msn(w([
                    Gx("mr-8")
                ]))
            ])),
            Lx(w([
                msn(w([
                    Gx("mr-8")
                ]))
            ])),
            Lx(w([
                Tx,
                msn(w([
                    Gx("mr-8")
                ]))
            ]))
        ]))
    ]), _hr = JRn({
        GB: function() {
            return {
                g8: xhr,
                yx: "Spinner"
            };
        }
    }), Chr = function(n) {
        return {
            Cl: F2(function(r, t) {
                var e = n.Cl(t);
                return b(e.a, e.b, g);
            }),
            CQ: wm(A2(tu, cu, YRn)),
            Fj: wm(cu),
            F4: n.F4,
            Gv: F2(function(r, t) {
                var e = A2(n.Gv, r, t);
                return b(e.a, e.b, g);
            }),
            GB: n.GB
        };
    }, Ahr = F2(function(n, r) {
        var t = A2(jAn, n, r.m9), e = t.b;
        return v(m(r, {
            m9: t.a
        }), A2(Wp, cu, e));
    }), khr = function(n) {
        var r = n.m9;
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Address Input")
                ])),
                A2(c_, cu, A3(jEn, Vx(0), g, r))
            ]))
        ]);
    }, Ehr = Chr({
        Cl: function() {
            return v({
                m9: Nwn("main-address")
            }, Qp);
        },
        F4: function() {
            return vx(w([
                A2(kj, cu, Oxn)
            ]));
        },
        Gv: Ahr,
        GB: function(n) {
            return {
                g8: khr(n),
                yx: "Address Input"
            };
        }
    }), qhr = F2(function() {
        return b({}, Qp, g);
    }), Fhr = F2(function(n, r) {
        return v(r, Qp);
    }), jhr = F2(function(n, r) {
        return r;
    }), Dhr = F2(function(n, r) {
        return b(r, Qp, w([
            A2(Mk, n.a, Zk(n.b))
        ]));
    }), Vhr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Bhr = w([
        A2(zx, w([
            Gx("mb-4")
        ]), w([
            A2(yF, w([
                fF,
                cF(A2(Vhr, 0, "Lots of info"))
            ]), w([
                _d("Info")
            ]))
        ])),
        A2(zx, w([
            Gx("mb-4")
        ]), w([
            A2(yF, w([
                CD,
                cF(A2(Vhr, 3, "Wohoo"))
            ]), w([
                _d("Success")
            ]))
        ])),
        A2(zx, w([
            Gx("mb-4")
        ]), w([
            A2(yF, w([
                CD,
                cF(A2(Vhr, 1, "Oopsie Daisy!"))
            ]), w([
                _d("Error")
            ]))
        ])),
        A2(zx, w([
            Gx("mb-4")
        ]), w([
            A2(yF, w([
                CD,
                cF(A2(Vhr, 2, "Halt!"))
            ]), w([
                _d("Warning")
            ]))
        ])),
        A2(zx, w([
            Gx("mt-8 mb-4")
        ]), w([
            _d("Message boxes (inline)")
        ])),
        A2(zx, w([
            Gx("mb-4")
        ]), w([
            A3(AEn, w([
                mEn(1)
            ]), Ot, _d("Informational message."))
        ])),
        A2(zx, w([
            Gx("mb-4")
        ]), w([
            A3(AEn, w([
                mEn(0)
            ]), Ot, _d("Something went wrong."))
        ])),
        A2(zx, w([
            Gx("mb-4")
        ]), w([
            A3(AEn, w([
                mEn(2)
            ]), Ot, _d("Prices in your cart may have changed. Review your totals before continuing to payment."))
        ]))
    ]), Ghr = {
        Cl: qhr,
        CQ: Fhr,
        Fj: jhr,
        F4: function() {
            return bx;
        },
        Gv: Dhr,
        GB: function() {
            return {
                g8: Bhr,
                yx: "Alerts"
            };
        }
    }, zhr = {
        $: 2
    }, Shr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Thr = w([
        A2(Shr, {
            sl: "pct-FDrfQFrCr9Ev-1",
            ur: "Affiliate Doctor"
        }, 0),
        A2(Shr, {
            sl: "pct-B3cB7yLItKyF",
            ur: "Alek Rabiner2"
        }, 0),
        A2(Shr, {
            sl: "pct-Y94f3tsrFmA2-1",
            ur: "Allison Gapinski, FNP-C"
        }, 0),
        A2(Shr, {
            sl: "pct-pL6TRfjALmTV-1",
            ur: "Amanda Hayes, FNP-C"
        }, 0),
        A2(Shr, {
            sl: "pct-KhfOqVFSKPWi-1",
            ur: "Amanda Thompson, FNP-C"
        }, 0),
        A2(Shr, {
            sl: "pct-rg3CPavMEcR4-1",
            ur: "Anais Lauren K. Joines, FNP-C"
        }, 0),
        A2(Shr, {
            sl: "pct-mR0b2TFfodQQ-1",
            ur: "Ayesha Nasir, MD"
        }, 0),
        A2(Shr, {
            sl: "pct-raXYk919T8Nf",
            ur: "Bailee Aff Demo"
        }, 0),
        A2(Shr, {
            sl: "pct-gkfcJ545oFdG-1",
            ur: "Beena Patel, DO"
        }, 0),
        A2(Shr, {
            sl: "pct-byZhy2hrTf7k-1",
            ur: "Beth Bethany"
        }, 0),
        A2(Shr, {
            sl: "pct-3wEr5WuC6CoW-1",
            ur: "Daniel McKearney, PA-C"
        }, 0),
        A2(Shr, {
            sl: "pct-zVBTNmQYmXyZ-1",
            ur: "Dr Ashley Doctor"
        }, 0),
        A2(Shr, {
            sl: "pct-rtJiHD8xo3c7",
            ur: "Dr Bart II"
        }, 0),
        A2(Shr, {
            sl: "pct-2PREw4FNWDRR",
            ur: "Dr Lisa Affiliate at DPC"
        }, 0),
        A2(Shr, {
            sl: "pct-j89hrSCDZAgt-1",
            ur: "Dr Lovely Affiliate"
        }, 0),
        A2(Shr, {
            sl: "pct-0e6lXqNGgVeI-1",
            ur: "Dr Maicol"
        }, 0),
        A2(Shr, {
            sl: "pct-RRo6HPhQI1H8",
            ur: "Dr Nina Affiliate at Nina's Affiliate"
        }, 0),
        A2(Shr, {
            sl: "pct-RFA6H9L7QaE3",
            ur: "Dr Nina Doc"
        }, 0),
        A2(Shr, {
            sl: "pct-G81Otf86rzCw-1",
            ur: "Dr Nina Mae"
        }, 0),
        A2(Shr, {
            sl: "pct-hB2EvKS9u9T3",
            ur: "Dr Steve at DPC"
        }, 0),
        A2(Shr, {
            sl: "pct-M9DdDRA6Xak5-1",
            ur: "Dr Tasha"
        }, 0),
        A2(Shr, {
            sl: "pct-IDkC9B4DBojo",
            ur: "Dr Unlinked to Affiliate For Now"
        }, 0),
        A2(Shr, {
            sl: "pct-4H0vTuTD9qT2",
            ur: "Dr. Aaron Cho"
        }, 0),
        A2(Shr, {
            sl: "pct-ad0cH9Cu7p51-1",
            ur: "Dr. Brave"
        }, 0)
    ]), Phr = function(n) {
        return n.a.ur;
    }, Zhr = {
        lo: 10,
        ur: Ot
    }, Mhr = F2(function(n, r) {
        var t = n(Zhr);
        return A2(Nu, function() {
            var n, e;
            return r((n = t.ur, e = function() {
                if (n.$) return Thr;
                var r = n.a;
                return A2(no, function(n) {
                    return A2(su, sJ(r), sJ(Phr(n)));
                }, Thr);
            }(), A2(tC, e, pa)));
        }, Up(500));
    }), Lhr = F3(function(n, r, t) {
        return A2(Mhr, function(r) {
            return m(r, {
                lo: n,
                ur: t
            });
        }, r);
    }), Nhr = function(n) {
        return n.a.sl;
    }, Hhr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ihr = F4(function(n, r, t, e) {
        switch(e.$){
            case 1:
                return n;
            case 2:
                return r;
            default:
                return t(e.a);
        }
    }), Ohr = F4(function(n, r, t, e) {
        switch(e.$){
            case 1:
                return n;
            case 2:
                return r;
            default:
                return It(t(e.a));
        }
    }), Qhr = {
        kG: "All",
        kH: It(""),
        lo: 10,
        lF: "None",
        lG: Ot
    }, Rhr = F2(function(n, r) {
        var t = n.sl, e = n.rt, u = n.Gk, a = n.Gj, i = r(Qhr), c = A2(e, i.lo, Hhr);
        return v({
            hD: A_,
            lN: i,
            mf: c,
            fS: !1,
            fW: Jwn({
                sl: t,
                Gj: function() {
                    return A3(Ihr, i.kG, i.lF, a);
                },
                Gk: A3(Ohr, i.kH, i.lG, u)
            }),
            jo: It(zhr)
        }, c(Ot));
    }), Uhr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Khr = F2(function(n, r) {
        if (n.$) return b(m(r, {
            hD: n.a,
            fS: !1
        }), Qp, Ot);
        var t = A2(fkn, n.a, r.fW), e = t.a, u = t.b, a = t.c, i = function() {
            if (a.$) return b(r, Qp, Ot);
            if (a.a.$) {
                var n = a.a.a;
                return b(m(r, {
                    fS: !0
                }), r.mf(It(n)), Ot);
            }
            var t = a.a.a;
            return b(m(r, {
                jo: t
            }), Qp, It(A2(xc, zhr, t)));
        }(), c = i.b, o = i.c;
        return b(m(i.a, {
            fW: e
        }), Uu(w([
            A2(Wp, Uhr, u),
            c
        ])), o);
    }), Whr = F2(function(n, r) {
        var t = A2(Khr, n, r.ev), e = t.a, u = t.b, a = t.c, i = a.$ ? r : m(r, {
            da: a.a
        });
        return v(m(i, {
            ev: e
        }), A2(Wp, cu, u));
    }), Xhr = {
        $: 1
    }, Yhr = F3(function(n, r, t) {
        if (nE(n)) return w([
            Hqn("No results found")
        ]);
        var e = function(n) {
            return A2(xc, Ot, A2(Op, $u, A2(ra, "x-total-count", n)));
        }(r);
        if (e.$) return g;
        var u = e.a;
        return s(u, t) > 0 ? w([
            Hqn("Search for " + oe(u - t) + " more results")
        ]) : g;
    }), Jhr = F2(function(n, r) {
        var t = function() {
            var n = r.hD;
            if (3 === n.$) {
                var t = n.a, e = n.b, u = A2(Qt, Oqn(r.jo), r.fS ? w([
                    Mqn(!0)
                ]) : g), a = A2(Fu, function(n) {
                    return A2(MG, g, function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(n));
                }, t), i = $(A2(Fu, function(n) {
                    return A2(MG, g, n);
                }, w([
                    Xhr,
                    zhr
                ])), w([
                    PG
                ]));
                return v(u, $(i, $(a, A3(Yhr, t, e, r.lN.lo))));
            }
            return v(w([
                Lqn("Loading..."),
                Mqn(!0)
            ]), g);
        }();
        return A2(c_, Uhr, A4(fFn, n, t.a, t.b, r.fW));
    }), nyr = function(n) {
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Api Select")
                ])),
                A2(zx, w([
                    Gx("mt-4")
                ]), w([
                    A2(c_, cu, A2(Jhr, Vx(0), n.ev))
                ])),
                A2(zx, w([
                    Gx("mt-4")
                ]), w([
                    A2(EH, w([
                        vH("Selected")
                    ]), w([
                        A2(f_, w([
                            nF
                        ]), w([
                            function() {
                                var r = n.da;
                                switch(r.$){
                                    case 0:
                                        return _d(Phr(r.a));
                                    case 1:
                                        return _d("All");
                                    default:
                                        return _d("None");
                                }
                            }()
                        ]))
                    ]))
                ]))
            ]))
        ]);
    }, ryr = Chr({
        Cl: function() {
            var n = A2(Rhr, {
                rt: Lhr,
                sl: "practitioners",
                Gj: Phr,
                Gk: Nhr
            }, function(n) {
                return m(n, {
                    kG: "All Practitioners",
                    lo: 5
                });
            });
            return v({
                ev: n.a,
                da: zhr
            }, A2(Wp, cu, n.b));
        },
        F4: function() {
            return bx;
        },
        Gv: Whr,
        GB: function(n) {
            return {
                g8: nyr(n),
                yx: "Api Select"
            };
        }
    }), tyr = F2(function(n, r) {
        return m(r, {
            eC: !r.eC
        });
    }), eyr = oF(2), uyr = function(n) {
        var r = n.eC;
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Buttons")
                ])),
                A2(zx, g, w([
                    A2(yF, w([
                        fF
                    ]), w([
                        _d("Primary")
                    ])),
                    A2(yF, w([
                        CD
                    ]), w([
                        _d("Secondary")
                    ])),
                    A2(yF, w([
                        eyr
                    ]), w([
                        _d("Tonal")
                    ])),
                    A2(yF, w([
                        j6
                    ]), w([
                        _d("This is a link")
                    ])),
                    A2(yF, w([
                        WX
                    ]), w([
                        _d("Text label")
                    ])),
                    A2(yF, w([
                        WX
                    ]), w([
                        A2(Tq, w([
                            zE
                        ]), 2),
                        A2(Mx, g, w([
                            _d("with leading icon")
                        ]))
                    ]))
                ])),
                A2(zx, w([
                    Gx("mt-4")
                ]), w([
                    A2(yF, w([
                        fF,
                        Lj(!0)
                    ]), w([
                        _d("Primary Disabled")
                    ])),
                    A2(yF, w([
                        CD,
                        Lj(!0)
                    ]), w([
                        _d("Secondary Disabled")
                    ])),
                    A2(yF, w([
                        eyr,
                        Lj(!0)
                    ]), w([
                        _d("Tonal Disabled")
                    ]))
                ])),
                A2(zx, w([
                    Gx("mt-4")
                ]), w([
                    A2(yF, w([
                        fF,
                        Qj(r),
                        cF(0)
                    ]), w([
                        _d("Primary Loading")
                    ])),
                    A2(yF, w([
                        CD,
                        Qj(r),
                        cF(0)
                    ]), w([
                        _d("Secondary Loading")
                    ])),
                    A2(yF, w([
                        eyr,
                        Qj(r),
                        cF(0)
                    ]), w([
                        _d("Tonal Loading")
                    ]))
                ])),
                A2(zx, w([
                    Gx("mt-4")
                ]), w([
                    A2(yF, w([
                        fF
                    ]), w([
                        A2(Tq, g, 1),
                        A2(Mx, g, w([
                            _d("with Icon")
                        ]))
                    ])),
                    A2(yF, w([
                        fF
                    ]), w([
                        A2(Mx, g, w([
                            _d("with Icon")
                        ])),
                        A2(Tq, g, 0)
                    ])),
                    A2(yF, w([
                        fF
                    ]), w([
                        A2(Mx, g, w([
                            _d("Play icon")
                        ])),
                        A2(Tq, g, 37)
                    ]))
                ]))
            ])),
            A2(zx, w([
                Gx("section mt-4")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Links")
                ])),
                A2(zx, g, w([
                    A2(EV, g, w([
                        _d("Regular link")
                    ]))
                ])),
                A2(zx, w([
                    Gx("mt-4")
                ]), w([
                    A2(EV, w([
                        _N
                    ]), w([
                        _d("Link in disguise")
                    ]))
                ]))
            ]))
        ]);
    }, ayr = mhr({
        Cl: function() {
            return {
                eC: !1
            };
        },
        Gv: tyr,
        GB: function(n) {
            return {
                g8: uyr(n),
                yx: "Button"
            };
        }
    }), iyr = F2(function(n, r) {
        return r;
    }), cyr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oyr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fyr = A2(de, F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    e$: !0
                });
            case 1:
                return m(r, {
                    sk: It(n.a)
                });
            case 2:
                return m(r, {
                    yx: It(n.a)
                });
            case 3:
                return m(r, {
                    zL: It(n.a)
                });
            default:
                return m(r, {
                    h_: It(n.a)
                });
        }
    }), {
        zL: Ot,
        e$: !1,
        h_: Ot,
        sk: Ot,
        yx: Ot
    }), syr = function(n) {
        if (n.$) return g;
        var r = n.a;
        return w([
            A2(Tq, w([
                zE
            ]), r)
        ]);
    }, lyr = F2(function(n, r) {
        var t, e, u, a = fyr(n);
        return A2(zx, w([
            Gx((t = a.e$, e = w(t ? [
                "bg-primary-500",
                "text-white"
            ] : [
                "bg-white",
                "border",
                "border-primary-100"
            ]), u = w([
                "rounded-lg",
                "p-6",
                "mb-6",
                "shadow"
            ]), A2(fe, " ", $(u, e))))
        ]), A2(Qt, function(n) {
            var r = b(n.yx, n.sk, n.zL);
            if (1 === r.a.$ && 1 === r.b.$ && 1 === r.c.$) return _d("");
            var t, e = w(n.e$ ? [
                ven,
                Qx,
                zun
            ] : [
                ven,
                Qx
            ]), u = (t = n.yx).$ ? g : w([
                A2(PE, e, w([
                    _d(t.a)
                ]))
            ]);
            return A2(zx, A2(Qt, Gx("flex mb-4"), $(Yx(gE), Yx(AF))), w([
                A2(zx, A2(Qt, Gx("flex gap-2"), Yx(gE)), $(syr(n.sk), u)),
                A2(xc, _d(""), n.zL)
            ]));
        }(a), $(r, function(n) {
            var r = n.h_;
            if (r.$) return g;
            var t = r.a;
            return w([
                A2(zx, A2(Qt, Gx("mt-4"), Yx(xD)), w([
                    t
                ]))
            ]);
        }(a))));
    }), dyr = w([
        A2(lyr, w([
            cyr(34),
            oyr("Upcoming appointments"),
            function(n) {
                return {
                    $: 3,
                    a: n
                };
            }(A2(EV, w([
                yV("#")
            ]), w([
                _d("Book new")
            ]))),
            function(n) {
                return {
                    $: 4,
                    a: n
                };
            }(A2(EV, w([
                yV("#")
            ]), w([
                _d("View all \u2192")
            ])))
        ]), w([
            A2(f_, w([
                nF
            ]), w([
                _d("The section composes its own body content here.")
            ]))
        ])),
        A2(lyr, w([
            {
                $: 0
            },
            cyr(9),
            oyr("Active membership")
        ]), w([
            A2(f_, w([
                zun
            ]), w([
                _d("Featured (brand-blue) variant for the highlighted card.")
            ]))
        ]))
    ]), vyr = mhr({
        Cl: function() {
            return {};
        },
        Gv: iyr,
        GB: function() {
            return {
                g8: dyr,
                yx: "Card"
            };
        }
    }), byr = F2(function(n, r) {
        return r;
    }), myr = w([
        "Unlimited telemedicine 24/7",
        "Unrushed visits",
        "Wholesale pricing on supplies",
        "And more"
    ]), pyr = function(n) {
        return w([
            A2(Tq, w([
                MN(Xmn)
            ]), 1),
            _d(n)
        ]);
    }, $yr = w([
        A2(BE, w([
            zDn
        ]), w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(BE, w([
                    cE(gE),
                    xN(JI)
                ]), w([
                    A2(lE, w([
                        cmn(8)
                    ]), w([
                        A2(zN, g, w([
                            _d("Virtual DPC")
                        ])),
                        A2(f_, w([
                            nF
                        ]), w([
                            _d("Basic plan that enables direct primary care for its members")
                        ]))
                    ])),
                    A2(lE, w([
                        cmn(4),
                        A2(w$n, 2, omn)
                    ]), w([
                        A2(PE, w([
                            Qx
                        ]), w([
                            _d("$30")
                        ])),
                        A2(PE, w([
                            nF
                        ]), w([
                            _d("/m")
                        ]))
                    ]))
                ])),
                s_,
                A2(ipn, w([
                    A2(M9n, 2, 2),
                    A2(M9n, 3, 3)
                ]), A2(Fu, A2(qc, Wmn, pyr), myr))
            ]))
        ]))
    ]), gyr = mhr({
        Cl: function() {
            return {};
        },
        Gv: byr,
        GB: function() {
            return {
                g8: $yr,
                yx: "Card Example"
            };
        }
    }), hyr = function(n) {
        return n.us;
    }, yyr = function(n) {
        return n > 0 ? A2(Mx, w([
            Gx("cart-icon__count")
        ]), w([
            _d(oe(n))
        ])) : vE;
    }, wyr = function(n) {
        var r = n.mA, t = n.AR, e = n.Cd;
        return A2(UD, w([
            Gx("cart-icon"),
            oV(e),
            A2(lF, "aria-label", r(hyr))
        ]), w([
            A2(Tq, w([
                Xj,
                Jj,
                Wj("cart-icon__icon")
            ]), 40),
            yyr(t)
        ]));
    }, xyr = F3(function(n, r, t) {
        return A2(zx, w([
            Gx("flex flex-col items-center gap-2")
        ]), w([
            wyr({
                AR: t,
                Cd: "#",
                mA: n
            }),
            A2(f_, g, w([
                _d(r)
            ]))
        ]));
    }), _yr = (Q8 = Vx(0), w([
        A2(zx, w([
            Gx("section")
        ]), w([
            A2(i_, w([
                Hx(w([
                    Gx("underline mb-2")
                ]))
            ]), w([
                _d("Cart Icon")
            ])),
            A2(zx, w([
                Gx("flex items-center gap-8")
            ]), w([
                A3(xyr, Q8, "Empty cart", 0),
                A3(xyr, Q8, "Single item", 1),
                A3(xyr, Q8, "Few items", 2),
                A3(xyr, Q8, "Many items", 99)
            ]))
        ]))
    ])), Cyr = JRn({
        GB: function() {
            return {
                g8: _yr,
                yx: "Cart Icon"
            };
        }
    }), Ayr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    hk: t = n.a
                });
            case 1:
                return m(r, {
                    hl: t = n.a
                });
            case 2:
                return m(r, {
                    eI: t = n.a
                });
            case 3:
                return m(r, {
                    eJ: t = n.a
                });
            case 4:
                return m(r, {
                    eK: t = n.a
                });
            default:
                var t;
                return m(r, {
                    eI: t = n.a,
                    eJ: t,
                    eK: t
                });
        }
    }), kyr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Eyr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qyr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Fyr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, jyr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Dyr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Vyr = function(n) {
        var r, t = n.hk, e = n.hl, u = n.eI, a = n.eJ, c = n.eK, o = !(i(u, a) && i(a, c)), f = u && a && c;
        return A2(zx, w([
            Gx("section")
        ]), w([
            A2(i_, w([
                Hx(w([
                    Gx("underline mb-2")
                ]))
            ]), w([
                _d("Checkboxes")
            ])),
            A2(zx, w([
                Gx("mb-4")
            ]), w([
                A2(fI, w([
                    eI(t),
                    tI(kyr)
                ]), w([
                    _d("Checkbox")
                ]))
            ])),
            A2(zx, w([
                Gx("mb-4")
            ]), w([
                A2(fI, w([
                    eI(e),
                    tI(Eyr)
                ]), w([
                    A2(o_, g, w([
                        _d("Checkbox")
                    ])),
                    A2(o_, g, w([
                        _d("With multiple lines")
                    ]))
                ]))
            ])),
            A2(zx, w([
                Gx("mb-4")
            ]), w([
                A2(fI, w([
                    eI(!1),
                    rI(!0)
                ]), w([
                    _d("Disabled Checkbox")
                ])),
                A2(fI, w([
                    eI(!0),
                    rI(!0)
                ]), w([
                    _d("Disabled Checkbox")
                ]))
            ])),
            A2(zx, w([
                Gx("mb-4")
            ]), w([
                A2(fI, w([
                    eI(!1),
                    E6(!0)
                ]), w([
                    _d("Invalid Checkbox")
                ]))
            ])),
            A2(zx, w([
                Gx("mb-4")
            ]), w([
                A2(fI, w([
                    eI(f),
                    (r = o, function(n) {
                        return {
                            $: 3,
                            a: n
                        };
                    }(r)),
                    tI(Dyr)
                ]), w([
                    _d("Check All")
                ])),
                A2(fI, w([
                    eI(u),
                    tI(qyr)
                ]), w([
                    _d("A")
                ])),
                A2(fI, w([
                    eI(a),
                    tI(Fyr)
                ]), w([
                    _d("B")
                ])),
                A2(fI, w([
                    eI(c),
                    tI(jyr)
                ]), w([
                    _d("C")
                ]))
            ]))
        ]));
    }, Byr = mhr({
        Cl: function() {
            return {
                hk: !1,
                hl: !0,
                eI: !1,
                eJ: !1,
                eK: !1
            };
        },
        Gv: Ayr,
        GB: function(n) {
            return {
                g8: w([
                    Vyr(n)
                ]),
                yx: "Checkbox"
            };
        }
    }), Gyr = function(n) {
        var r = n.sk, t = n.yx, e = n.g8;
        return A2(BE, w([
            VN(w([
                Gx("code-sent-confirmation")
            ]))
        ]), w([
            A2(lE, w([
                TE(12)
            ]), w([
                A2(zx, w([
                    Gx("code-sent-confirmation__logo")
                ]), w([
                    A2(PE, w([
                        nF
                    ]), w([
                        A2(Tq, w([
                            Xj
                        ]), r)
                    ]))
                ]))
            ])),
            A2(lE, w([
                TE(12)
            ]), w([
                A2(f_, w([
                    Qx,
                    uF(xD),
                    GN
                ]), w([
                    _d(t)
                ])),
                A2(f_, w([
                    nF,
                    uF(xD)
                ]), w([
                    _d(e)
                ]))
            ]))
        ]));
    }, zyr = JRn({
        GB: function() {
            return {
                g8: w([
                    A2(zx, w([
                        Gx("section")
                    ]), w([
                        Gyr({
                            g8: "We sent an email to you at name@example.com with a code that will sign you in.",
                            sk: 12,
                            yx: "Check your email"
                        })
                    ])),
                    A2(zx, w([
                        Gx("section")
                    ]), w([
                        Gyr({
                            g8: "We sent a text to (555) 123-4567 with a code that will sign you in.",
                            sk: 33,
                            yx: "Check your text messages"
                        })
                    ]))
                ]),
                yx: "Code Sent Confirmation"
            };
        }
    }), Syr = {
        $: 0
    }, Tyr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Pyr = F2(function(n, r) {
        return {
            sl: n,
            ur: r
        };
    }), Zyr = w([
        A2(Pyr, "loc-1234", "Tatooine"),
        A2(Pyr, "loc-2345", "Kashyyyk"),
        A2(Pyr, "loc-3456", "Mandalore")
    ]), Myr = function(n) {
        return A2(Nu, function() {
            return function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(A2(no, function(r) {
                return A2(su, n, r.ur);
            }, Zyr)));
        }, Up(3e3));
    }, Lyr = F2(function(n, r) {
        return 1 === r.$ ? n(r.a) : r.a;
    }), Nyr = F2(function(n, r) {
        return 1 === r.$ ? It(n(r.a)) : r.b;
    }), Hyr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Iyr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Oyr = F2(function(n, r) {
        switch(n.$){
            case 1:
                return v(m(r, {
                    fh: n.a
                }), Qp);
            case 0:
                return v(m(r, {
                    kw: n.a
                }), Qp);
            case 3:
                var t = A2(dG, n.a, r.eU), e = t.b;
                return v(m(r, {
                    eU: a = t.a,
                    d5: (i = t.c).$ || i.a.$ || i.a.a.$ ? r.d5 : i.a.a.a
                }), A2(Wp, Hyr, e));
            default:
                var u = A2(fkn, n.a, r.fi), a = u.a, i = (e = u.b, u.c), c = function() {
                    n: for(; !i.$;){
                        if (i.a.$) {
                            var n = i.a.a;
                            return v(m(r, {
                                fh: Syr
                            }), Myr(n));
                        }
                        if (i.a.a.$) break n;
                        return v(m(r, {
                            d6: i.a.a.a
                        }), Qp);
                    }
                    return v(r, Qp);
                }(), o = c.b;
                return v(m(c.a, {
                    fi: a
                }), Uu(w([
                    o,
                    A2(Wp, Iyr, e)
                ])));
        }
    }), Qyr = F3(function(n, r, t) {
        return 1 === t.$ ? w([
            A2(r, n, t.a)
        ]) : 1 === t.b.$ ? g : w([
            A2(g_, n, t.b.a)
        ]);
    }), Ryr = function(n) {
        var r = n.d5, t = n.d6;
        return y_(A2(dc, A3(Qyr, "location", F2(function(n, r) {
            return A2(g_, n, r.sl);
        }), t), A3(Qyr, "distance", iA, r)));
    }, Uyr = {
        $: 3
    }, Kyr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wyr = w([
        5,
        10,
        20
    ]), Xyr = F2(function(n, r) {
        var t = A2(Fu, MG(g), A2(Qt, A2(Tyr, "Any Distance", Ot), A2(Fu, Kyr, Wyr)));
        return w([
            A2(c_, Hyr, A4(qz, Vx(0), w([
                XG(It(n)),
                SG,
                HG("Any Distance")
            ]), t, r))
        ]);
    }), Yyr = {
        $: 5
    }, Jyr = F3(function(n, r, t) {
        var e, u = 1 === (e = n).$ ? It(e.a) : Ot, a = A2(xc, !0, A2(Op, wm(!1), u)), i = function() {
            if (1 === u.$) return g;
            var n = u.a;
            return A2(Fu, MG(g), A2(Qt, A2(Tyr, "Any Location", Ot), A2(Fu, Kyr, n)));
        }();
        return w([
            A2(c_, Iyr, A4(fFn, Vx(0), w([
                Oqn(It(r)),
                Mqn(a),
                Yyr,
                Lqn("Any Location")
            ]), i, t))
        ]);
    }), nwr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rwr = {
        $: 5
    }, twr = function(n) {
        return n ? "map" : "list";
    }, ewr = function(n) {
        return w([
            A2(BX, w([
                QX(twr(n))
            ]), w([
                A2(GX, w([
                    CX,
                    rwr,
                    SX(A2(qc, nwr, wm(0))),
                    QX(twr(0))
                ]), w([
                    _d("List")
                ])),
                A2(GX, w([
                    CX,
                    rwr,
                    SX(A2(qc, nwr, wm(1))),
                    QX(twr(1))
                ]), w([
                    _d("Map")
                ]))
            ]))
        ]);
    }, uwr = function(n) {
        var r = n.fh, t = n.fi, e = n.d6, u = n.kw, a = n.d5, i = n.eU;
        return w([
            A2(BE, w([
                zDn,
                MQn
            ]), w([
                A2(lE, w([
                    TE(12)
                ]), w([
                    A2(BE, w([
                        xN(JI)
                    ]), w([
                        A2(lE, w([
                            HQn
                        ]), w([
                            A2(BE, w([
                                xN(aF)
                            ]), w([
                                A2(lE, w([
                                    TE(12)
                                ]), w([
                                    PI(w([
                                        jI("Search by name")
                                    ]))
                                ]))
                            ])),
                            A2(BE, w([
                                xN(JI)
                            ]), w([
                                A2(lE, w([
                                    cmn(4)
                                ]), A3(Jyr, r, e, t)),
                                A2(lE, w([
                                    cmn(4)
                                ]), w([
                                    PI(g)
                                ])),
                                A2(lE, w([
                                    cmn(4)
                                ]), A2(Xyr, a, i))
                            ]))
                        ])),
                        A2(lE, w([
                            Uyr
                        ]), w([
                            A2(BE, w([
                                xN(aF)
                            ]), w([
                                A2(lE, g, ewr(u))
                            ])),
                            A2(BE, w([
                                xN(JI)
                            ]), w([
                                A2(lE, g, w([
                                    PI(g)
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            _d("Query: " + Ryr(n))
        ]);
    }, awr = Chr({
        Cl: function() {
            return v({
                eU: Cd({
                    sl: "distances-select",
                    Gj: function() {
                        return Lyr(function(n) {
                            return oe(n) + " miles";
                        });
                    },
                    Gk: Nyr(oe)
                }),
                fh: Syr,
                fi: Jwn({
                    sl: "locations-select",
                    Gj: function() {
                        return Lyr(function(n) {
                            return n.ur;
                        });
                    },
                    Gk: Nyr(function(n) {
                        return n.sl;
                    })
                }),
                d5: A2(Tyr, "Distance", Ot),
                d6: A2(Tyr, "Location", Ot),
                kw: 0
            }, Myr(""));
        },
        F4: function() {
            return bx;
        },
        Gv: Oyr,
        GB: function(n) {
            return {
                g8: uwr(n),
                yx: "Filters"
            };
        }
    }), iwr = {
        ng: Ot,
        rA: "",
        rU: 1,
        sV: "",
        vO: A2(cZ, "cool-phone", {
            ig: !0,
            EB: "6668675309",
            i1: qO
        }),
        ko: !1
    }, cwr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, owr = F2(function(n, r) {
        switch(n.$){
            case 2:
                return m(r, {
                    rA: n.a
                });
            case 3:
                return m(r, {
                    sV: n.a
                });
            case 0:
                return m(r, {
                    rU: n.a
                });
            case 1:
                return m(r, {
                    ng: n.a
                });
            default:
                return m(r, {
                    vO: n.a
                });
        }
    }), fwr = XM(w([
        A2(Bir, function(n) {
            return n.rA;
        }, v(0, WL(lL))),
        A2(Bir, function(n) {
            return n.sV;
        }, v(1, WL(dL))),
        function() {
            return g;
        },
        function(n) {
            var r = n.vO;
            return A2(yL, r.EB, r.Fs) || mu(r.EB), g;
        }
    ])), swr = {
        $: 2
    }, lwr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(m(r, {
                    le: A3(cN, owr, n.a, r.le)
                }), Qp);
            case 1:
                var t = A2(CL, fwr, r.le);
                return t.$ ? v(m(r, {
                    le: t.a
                }), Qp) : v(m(r, {
                    le: t.a.a,
                    wk: !0
                }), A2(Nu, function() {
                    return swr;
                }, Up(3e3)));
            case 2:
                return v(m(r, {
                    wk: !1
                }), Qp);
            default:
                var e = n.a, u = FM(r.le), a = A2(iN, e, u.vO), i = a.b, c = A3(cN, owr, function(n) {
                    return {
                        $: 4,
                        a: n
                    };
                }(a.a), r.le);
                return v(m(r, {
                    le: c
                }), A2(Wp, cwr, i));
        }
    }), dwr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vwr = {
        $: 1
    }, bwr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mwr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pwr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $wr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, gwr = function(n) {
        return n ? "female" : "male";
    }, hwr = F2(function(n, r) {
        var t = $u(r);
        return 1 === t.$ ? "" === r ? Ot : n : It(t.a);
    }), ywr = F2(function(n, r) {
        var t, e = Vx(0), u = FM(r), a = u.rA, i = u.sV, c = u.ng, o = u.rU, f = u.vO;
        return A2(zx, g, w([
            A2(BE, g, w([
                A2(lE, w([
                    TE(6)
                ]), w([
                    A2(EH, w([
                        vH("First Name"),
                        gH(!0)
                    ]), w([
                        PI(w([
                            OI(a),
                            jI("Jane"),
                            HI(A2(qc, mwr, bwr)),
                            yI(A2(wH, 0, r))
                        ])),
                        A2(YH, e, A2(iH, 0, r))
                    ]))
                ])),
                A2(lE, w([
                    TE(6)
                ]), w([
                    A2(EH, w([
                        vH("Last Name"),
                        gH(!0)
                    ]), w([
                        PI(w([
                            OI(i),
                            jI("Doe"),
                            HI(A2(qc, mwr, $wr)),
                            yI(A2(wH, 1, r))
                        ])),
                        A2(YH, e, A2(iH, 1, r))
                    ]))
                ]))
            ])),
            A2(EH, w([
                vH("Gender"),
                gH(!0)
            ]), w([
                A2(BE, g, w([
                    A2(lE, w([
                        TE(6)
                    ]), w([
                        A2(VX, w([
                            CX,
                            SX(A2(qc, A2(qc, mwr, pwr), wm(0))),
                            zqn(!o),
                            QX(gwr(0))
                        ]), w([
                            _d("Male")
                        ]))
                    ])),
                    A2(lE, w([
                        TE(6)
                    ]), w([
                        A2(VX, w([
                            CX,
                            SX(A2(qc, A2(qc, mwr, pwr), wm(1))),
                            zqn(1 === o),
                            QX(gwr(1))
                        ]), w([
                            _d("Female")
                        ]))
                    ]))
                ]))
            ])),
            A2(EH, w([
                vH("Age")
            ]), w([
                A2(BE, g, w([
                    A2(lE, w([
                        TE(12)
                    ]), w([
                        PI(w([
                            OI((t = c, A2(xc, "", A2(Op, oe, t)))),
                            jI("e.g 30"),
                            HI(A2(qc, A2(qc, mwr, dwr), hwr(c))),
                            yI(A2(wH, 2, r))
                        ])),
                        A2(YH, e, A2(iH, 2, r))
                    ]))
                ]))
            ])),
            A2(EH, w([
                vH("Phone Number"),
                gH(!0)
            ]), w([
                A2(BE, g, w([
                    A2(lE, w([
                        TE(12)
                    ]), w([
                        A2(c_, cwr, A3(DO, e, w([
                            sO(A2(wH, 3, r))
                        ]), f)),
                        A2(YH, e, A2(iH, 3, r))
                    ]))
                ]))
            ])),
            A2(EH, w([
                vH("Tobacco use"),
                cEn("Do you currently use, or have used tobacco products in the last twelve months?")
            ]), w([
                A2(BE, g, g)
            ])),
            A2(yF, w([
                fF,
                Lj(n),
                Qj(n),
                cF(vwr)
            ]), w([
                _d("Submit")
            ]))
        ]));
    }), wwr = Chr({
        Cl: function() {
            return v({
                le: vZ(iwr),
                wk: !1
            }, Qp);
        },
        F4: function() {
            return bx;
        },
        Gv: lwr,
        GB: function(n) {
            return {
                g8: w([
                    A2(ywr, n.wk, n.le)
                ]),
                yx: "Form Example"
            };
        }
    }), xwr = w([
        A2(zx, w([
            Gx("section")
        ]), w([
            A2(i_, w([
                Hx(w([
                    Gx("underline mb-2")
                ]))
            ]), w([
                _d("Grid")
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-100 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                A2(lE, w([
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                A2(lE, w([
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                A2(lE, w([
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-400 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ]))
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    cmn(6)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 6")
                    ]))
                ])),
                A2(lE, w([
                    TE(6),
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                A2(lE, w([
                    TE(6),
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ]))
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    cmn(2),
                    TE(4)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 2")
                    ]))
                ])),
                A2(lE, w([
                    cmn(2),
                    TE(4)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 2")
                    ]))
                ])),
                A2(lE, w([
                    cmn(2),
                    TE(4)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 2")
                    ]))
                ])),
                A2(lE, w([
                    cmn(6)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 6")
                    ]))
                ]))
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    TE(6)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Row.noGutter Col 6")
                    ]))
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Row.noGutter Col 3")
                    ]))
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Row.noGutter Col 3")
                    ]))
                ]))
            ])),
            A2(BE, g, w([
                spn(w([
                    TE(6)
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ]))
            ])),
            A2(BE, g, w([
                spn(w([
                    TE(3)
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                A2(lE, w([
                    TE(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                spn(w([
                    TE(3)
                ]))
            ]))
        ]))
    ]), _wr = JRn({
        GB: function() {
            return {
                g8: xwr,
                yx: "Grid"
            };
        }
    }), Cwr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    g5: n.a
                });
            case 1:
                return m(r, {
                    jm: n.a
                });
            default:
                return m(r, {
                    ji: n.a
                });
        }
    }), Awr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kwr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ewr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qwr = function(n) {
        var r = n.g5, t = n.jm, e = n.ji;
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Inputs")
                ])),
                A2(zx, w([
                    Gx("mb-4")
                ]), w([
                    PI(w([
                        OI(r),
                        HI(Awr)
                    ]))
                ])),
                A2(zx, w([
                    Gx("mb-4")
                ]), w([
                    PI(w([
                        jI("Disabled"),
                        pI(!0)
                    ]))
                ])),
                A2(zx, w([
                    Gx("mb-4")
                ]), w([
                    PI(w([
                        jI("Secret"),
                        X2n(0),
                        HI(Ewr),
                        OI(t)
                    ]))
                ])),
                A2(zx, w([
                    Gx("mb-4")
                ]), w([
                    PI(w([
                        jI("This is required"),
                        OI(e),
                        yI(mu(e)),
                        HI(kwr)
                    ]))
                ])),
                A2(zx, w([
                    Gx("mb-4")
                ]), w([
                    I$n(w([
                        H$n(w([
                            _d("$")
                        ])),
                        PI(w([
                            OI("1.000,00")
                        ]))
                    ]))
                ]))
            ]))
        ]);
    }, Fwr = mhr({
        Cl: function() {
            return {
                g5: "Some initial text",
                ji: "",
                jm: ""
            };
        },
        Gv: Cwr,
        GB: function(n) {
            return {
                g8: qwr(n),
                yx: "Input"
            };
        }
    }), jwr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Dwr = F2(function(n) {
        var r = A2(txn, n.g0, !0);
        return b({
            aE: r.a
        }, A2(Wp, jwr, r.b), g);
    }), Vwr = F2(function(n, r) {
        return v(r, Qp);
    }), Bwr = F2(function(n, r) {
        return r;
    }), Gwr = F2(function(n, r) {
        if (n.$) {
            var t = A2(YAn, !0, r.aE), e = (u = t.a, w(t.b ? [
                A2(Mk, 3, Zk("Insurance info is valid!"))
            ] : [
                A2(Mk, 1, Zk("Insurance info is invalid!"))
            ]));
            return b(m(r, {
                aE: u
            }), Qp, e);
        }
        var u, a = A2(skn, n.a, r.aE), i = a.b;
        return b(m(r, {
            aE: u = a.a
        }), A2(Wp, jwr, i), g);
    }), zwr = {
        $: 1
    }, Swr = function(n) {
        var r = n.aE;
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Phone Input")
                ])),
                A2(c_, jwr, A3(FFn, Vx(0), !1, r)),
                A2(yF, w([
                    fF,
                    cF(zwr),
                    Kj(w([
                        Gx("mt-6")
                    ]))
                ]), w([
                    A2(Mx, g, w([
                        _d("Validate")
                    ]))
                ]))
            ]))
        ]);
    }, Twr = {
        Cl: Dwr,
        CQ: Vwr,
        Fj: Bwr,
        F4: function() {
            return bx;
        },
        Gv: Gwr,
        GB: function(n) {
            return {
                g8: Swr(n),
                yx: "Phone Input"
            };
        }
    }, Pwr = {
        $: 3
    }, Zwr = {
        $: 2
    }, Mwr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Lwr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Nwr = F2(function(n, r) {
        switch(n.$){
            case 2:
                return v(m(r, {
                    fq: Bj(r.fq),
                    dO: !1
                }), Qp);
            case 3:
                return v(m(r, {
                    a7: Bj(r.a7)
                }), Qp);
            case 0:
                return v(m(r, {
                    fq: zj(r.fq),
                    dO: !1
                }), Qp);
            case 1:
                return v(m(r, {
                    a7: zj(r.a7)
                }), Qp);
            case 4:
                return v(m(r, {
                    fq: Bj(r.fq),
                    dO: !0
                }), Qp);
            case 5:
                var t = A2(Sj, n.a, r.fq), e = t.b;
                return v(m(r, {
                    fq: t.a
                }), A2(Wp, Lwr, e));
            default:
                var u = A2(Sj, n.a, r.a7);
                return e = u.b, v(m(r, {
                    a7: u.a
                }), A2(Wp, Mwr, e));
        }
    }), Hwr = {
        $: 0
    }, Iwr = {
        $: 1
    }, Owr = {
        $: 4
    }, Qwr = w([
        A2(zx, w([
            Gx("section")
        ]), w([
            A2(i_, w([
                Hx(w([
                    Gx("underline mb-2")
                ]))
            ]), w([
                _d("Modal Content!")
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                A2(lE, w([
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                A2(lE, w([
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                A2(lE, w([
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ]))
            ])),
            A2(BE, g, w([
                A2(lE, w([
                    cmn(6)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 6")
                    ]))
                ])),
                A2(lE, w([
                    TE(6),
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ])),
                A2(lE, w([
                    TE(6),
                    cmn(3)
                ]), w([
                    A2(zx, w([
                        Gx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), w([
                        _d("Col 3")
                    ]))
                ]))
            ]))
        ]))
    ]), Rwr = function(n) {
        return A2(zx, g, n.dO ? w([
            A2(CF, g, w([
                _d("Modal Submitted")
            ]))
        ]) : g);
    }, Uwr = function(n) {
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Modal")
                ])),
                A2(f_, g, w([
                    _d("Standard modals render as a centered dialog on desktop and as a bottom sheet on mobile automatically. Full-viewport modals (e.g. file/media viewers) always fill the screen and are never turned into a sheet.")
                ])),
                A2(zx, w([
                    Gx("mt-4 flex flex-wrap gap-3")
                ]), w([
                    A2(yF, w([
                        fF,
                        cF(Hwr)
                    ]), w([
                        _d("Show Modal (bottom sheet on mobile)")
                    ])),
                    A2(yF, w([
                        fF,
                        cF(Iwr)
                    ]), w([
                        _d("Show full-viewport modal")
                    ]))
                ])),
                A2(dD, w([
                    Hj(w([
                        _d("This is a Title for the Modal")
                    ])),
                    Mj(Qwr),
                    Nj(w([
                        A2(yF, w([
                            fF,
                            cF(Owr)
                        ]), w([
                            _d("Submit")
                        ])),
                        A2(yF, w([
                            CD,
                            cF(Zwr),
                            Kj(w([
                                Gx("button--hidden-on-sheet")
                            ]))
                        ]), w([
                            _d("Cancel")
                        ]))
                    ]))
                ]), n.fq),
                A3(lD, 1, w([
                    bX,
                    Mj(w([
                        A2(zx, w([
                            Gx("flex h-full min-h-0 w-full flex-1 items-center justify-center rounded-md bg-primary-100")
                        ]), w([
                            _d("Content fills available space (e.g. image preview).")
                        ]))
                    ]))
                ]), n.a7),
                Rwr(n)
            ]))
        ]);
    }, Kwr = Chr({
        Cl: function() {
            var n = A2(YF, 0, Zwr), r = n.a, t = n.b, e = A2(YF, 0, Pwr);
            return v({
                a7: e.a,
                fq: r,
                dO: !1
            }, Uu(w([
                t,
                e.b
            ])));
        },
        F4: function() {
            return vx(w([
                A2(kj, Lwr, qj()),
                A2(kj, Mwr, qj())
            ]));
        },
        Gv: Nwr,
        GB: function(n) {
            return {
                g8: Uwr(n),
                yx: "StyleGuide.Modal"
            };
        }
    }), Wwr = {
        ur: "",
        l2: 0,
        wx: It(1)
    }, Xwr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    ur: n.a
                });
            case 1:
                return m(r, {
                    l2: n.a
                });
            default:
                return m(r, {
                    wx: n.a
                });
        }
    }), Ywr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return v(m(r, {
                    bm: A3(Uvr, Xwr(n.b), t, r.bm)
                }), Qp);
            case 1:
                return v(m(r, {
                    bm: A2(Y2, Wwr, r.bm)
                }), Qp);
            default:
                return v(m(r, {
                    bm: A2(D_n, t = n.a, r.bm)
                }), Qp);
        }
    }), Jwr = {
        $: 1
    }, nxr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), rxr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, txr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, exr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uxr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, axr = F2(function(n, r) {
        return A2(xc, n, $u(r));
    }), ixr = F2(function(n, r) {
        var t = $u(r);
        return 1 === t.$ ? "" === r ? Ot : n : It(t.a);
    }), cxr = function(n) {
        var r, t = n.a, e = n.b.ur, u = n.b.l2, a = n.b.wx;
        return v(oe(t), A2(BE, g, w([
            A2(lE, w([
                cmn(6)
            ]), w([
                A2(EH, w([
                    vH("Item")
                ]), w([
                    PI(w([
                        OI(e),
                        HI(A2(qc, nxr(t), rxr))
                    ]))
                ]))
            ])),
            A2(lE, w([
                cmn(3),
                TE(6)
            ]), w([
                A2(EH, w([
                    vH("Quantiy")
                ]), w([
                    PI(w([
                        OI((r = a, A2(xc, "", A2(Op, oe, r)))),
                        HI(A2(qc, A2(qc, nxr(t), exr), ixr(a)))
                    ]))
                ]))
            ])),
            A2(lE, w([
                cmn(3),
                TE(6)
            ]), w([
                A2(EH, w([
                    vH("Price")
                ]), w([
                    PI(w([
                        OI(oe(u)),
                        HI(A2(qc, A2(qc, nxr(t), txr), axr(u)))
                    ])),
                    A2(yF, w([
                        j6,
                        cF(uxr(t))
                    ]), w([
                        _d("Remove")
                    ]))
                ]))
            ]))
        ])));
    }, oxr = Chr({
        Cl: function() {
            return v({
                bm: A2(Y2, Wwr, F0)
            }, Qp);
        },
        F4: function() {
            return bx;
        },
        Gv: Ywr,
        GB: function(n) {
            return {
                g8: w([
                    A2(zx, g, w([
                        A3(gz, "div", g, A2(h6, cxr, n.bm)),
                        A2(yF, w([
                            fF,
                            cF(Jwr)
                        ]), w([
                            _d("Add charge")
                        ]))
                    ]))
                ]),
                yx: "MultiForm"
            };
        }
    }), fxr = F2(function(n, r) {
        var t = A2(iN, n, r.vO), e = t.b;
        return v(m(r, {
            vO: t.a
        }), A2(Wp, cu, e));
    }), sxr = function(n) {
        var r = n.vO;
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Phone Input")
                ])),
                A2(c_, cu, A3(DO, Vx(0), g, r))
            ]))
        ]);
    }, lxr = Chr({
        Cl: function() {
            return v({
                vO: exn("cool-phone")
            }, Qp);
        },
        F4: function() {
            return bx;
        },
        Gv: fxr,
        GB: function(n) {
            return {
                g8: sxr(n),
                yx: "Phone Input"
            };
        }
    }), dxr = F2(function(n, r) {
        return m(r, n.$ ? {
            iL: n.a
        } : {
            jc: n.a
        });
    }), vxr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bxr = w([
        0,
        1,
        2
    ]), mxr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pxr = function(n) {
        switch(n){
            case 0:
                return "Kripton";
            case 1:
                return "Gotham";
            default:
                return "Central City";
        }
    }, $xr = function(n) {
        switch(n){
            case 0:
                return "kripton";
            case 1:
                return "gotham";
            default:
                return "central-city";
        }
    }, gxr = F2(function(n, r) {
        return A2(VX, w([
            CX,
            SX(A2(qc, mxr, wm(r))),
            zqn(i(n, r)),
            QX($xr(r)),
            ztr(w([
                Gx("mr-2")
            ]))
        ]), w([
            A3(qc, _d, pxr, r)
        ]));
    }), hxr = function(n) {
        var r = n.jc, t = n.iL;
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Radio Buttons")
                ])),
                A2(zx, w([
                    Gx("mb-4")
                ]), w([
                    A2(VX, w([
                        QX("batman"),
                        zqn("batman" === r),
                        SX(vxr)
                    ]), w([
                        _d("Batman")
                    ])),
                    A2(VX, w([
                        QX("flash"),
                        zqn("flash" === r),
                        SX(vxr)
                    ]), w([
                        _d("The Flash")
                    ])),
                    A2(VX, w([
                        QX("superman"),
                        zqn("superman" === r),
                        SX(vxr),
                        Sqn(!0)
                    ]), w([
                        _d("Superman")
                    ]))
                ])),
                A2(zx, w([
                    Gx("mb-4")
                ]), w([
                    A2(VX, w([
                        CX,
                        QX("batman"),
                        zqn("batman" === r),
                        SX(vxr),
                        ztr(w([
                            Gx("mr-2")
                        ]))
                    ]), w([
                        _d("Batman")
                    ])),
                    A2(VX, w([
                        CX,
                        QX("flash"),
                        zqn("flash" === r),
                        SX(vxr),
                        ztr(w([
                            Gx("mr-2")
                        ]))
                    ]), w([
                        _d("The Flash")
                    ])),
                    A2(VX, w([
                        CX,
                        QX("superman"),
                        zqn("superman" === r),
                        SX(vxr),
                        ztr(w([
                            Gx("mr-2")
                        ])),
                        Sqn(!0)
                    ]), w([
                        _d("Superman")
                    ]))
                ])),
                A2(zx, g, w([
                    A2(BX, w([
                        QX(r),
                        SX(vxr)
                    ]), w([
                        A2(GX, w([
                            CX,
                            QX("batman")
                        ]), w([
                            _d("Batman")
                        ])),
                        A2(GX, w([
                            CX,
                            QX("flash")
                        ]), w([
                            _d("The Flash")
                        ])),
                        A2(GX, w([
                            CX,
                            QX("superman"),
                            Sqn(!0)
                        ]), w([
                            _d("Superman")
                        ]))
                    ]))
                ])),
                A2(zx, w([
                    Gx("mt-4")
                ]), w([
                    A2(BX, w([
                        QX(r),
                        SX(vxr),
                        MX
                    ]), w([
                        A2(GX, w([
                            CX,
                            QX("batman")
                        ]), w([
                            _d("Batman")
                        ])),
                        A2(GX, w([
                            CX,
                            QX("flash")
                        ]), w([
                            _d("The Flash")
                        ])),
                        A2(GX, w([
                            CX,
                            QX("superman")
                        ]), w([
                            _d("Superman")
                        ])),
                        A2(GX, w([
                            CX,
                            QX("wonder-woman")
                        ]), w([
                            _d("Wonder Woman")
                        ]))
                    ]))
                ]))
            ])),
            A2(zx, w([
                Gx("section mt-4")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("With an elm type")
                ])),
                A2(zx, w([
                    Gx("mt-4")
                ]), A2(Fu, gxr(t), bxr))
            ]))
        ]);
    }, yxr = mhr({
        Cl: function() {
            return {
                iL: 1,
                jc: "batman"
            };
        },
        Gv: dxr,
        GB: function(n) {
            return {
                g8: hxr(n),
                yx: "Radio"
            };
        }
    }), wxr = {
        $: 2
    }, xxr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _xr = F2(function(n, r) {
        return A4(QQ, n, "dpc-network", function(n) {
            return m(n, {
                ur: r
            });
        }, xxr);
    }), Cxr = function(n) {
        switch(n.$){
            case 1:
                return "All Practitioners";
            case 2:
                return "None";
            default:
                return QS(n.a);
        }
    }, Axr = function(n) {
        switch(n.$){
            case 1:
                return It("");
            case 2:
                return Ot;
            default:
                return It(rQ(n.a));
        }
    }, kxr = F2(function(n) {
        return b({
            g0: n.g0,
            v4: It(wxr),
            v5: "",
            bK: A_,
            fH: Jwn({
                sl: "practitioners",
                Gj: function() {
                    return Cxr;
                },
                Gk: Axr
            }),
            fV: !1
        }, A2(_xr, n.g0, Ot), g);
    }), Exr = F2(function(n, r) {
        return v(r, Qp);
    }), qxr = F2(function(n, r) {
        return r;
    }), Fxr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, jxr = F2(function(n, r) {
        if (n.$) return b(m(r, {
            bK: n.a,
            fV: !1
        }), Qp, g);
        var t = A2(fkn, n.a, r.fH), e = t.a, u = t.b, a = t.c, i = function() {
            if (a.$) return v(r, Qp);
            if (a.a.$) {
                var n = a.a.a;
                return v(m(r, {
                    fV: !0
                }), A2(_xr, r.g0, It(n)));
            }
            return v(m(r, {
                v4: a.a.a
            }), Qp);
        }(), c = i.b;
        return b(m(i.a, {
            fH: e
        }), Uu(w([
            A2(Wp, Fxr, u),
            c
        ])), g);
    }), Dxr = {
        $: 1
    }, Vxr = F4(function(n, r, t, e) {
        var u = function() {
            if (3 === n.$) {
                var e = A2(Fu, function(n) {
                    return A2(MG, g, function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(n));
                }, n.a), u = A2(Qt, Oqn(t), r ? w([
                    Mqn(!0)
                ]) : g), a = nE(e) ? "No providers found" : "Search to filter...", i = $(A2(Fu, function(n) {
                    return A2(MG, g, n);
                }, w([
                    Dxr,
                    wxr
                ])), w([
                    PG
                ]));
                return v(u, $(i, $(e, w([
                    Hqn(a)
                ]))));
            }
            return v(w([
                Lqn("Loading practitioners..."),
                Mqn(!0)
            ]), g);
        }(), a = u.a, i = u.b;
        return A2(zx, w([
            Gx("mb-4")
        ]), w([
            A2(c_, Fxr, A4(fFn, Vx(0), a, i, e))
        ]));
    }), Bxr = function(n) {
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Searchable Select")
                ])),
                A2(zx, w([
                    Gx("mt-4")
                ]), w([
                    A4(Vxr, n.bK, n.fV, n.v4, n.fH)
                ]))
            ]))
        ]);
    }, Gxr = {
        Cl: kxr,
        CQ: Exr,
        Fj: qxr,
        F4: function() {
            return bx;
        },
        Gv: jxr,
        GB: function(n) {
            return {
                g8: Bxr(n),
                yx: "SearchableSelect"
            };
        }
    }, zxr = F2(function(n, r) {
        return m(r, {
            jo: n
        });
    }), Sxr = mhr({
        Cl: function() {
            return {
                jo: 0
            };
        },
        Gv: zxr,
        GB: function(n) {
            return {
                g8: w([
                    A2(zx, w([
                        Gx("section")
                    ]), w([
                        a3n({
                            uY: cu,
                            lN: w([
                                v(0, "Text me"),
                                v(1, "Email me")
                            ]),
                            jo: n.jo
                        })
                    ]))
                ]),
                yx: "Segmented Control"
            };
        }
    }), Txr = function(n) {
        switch(n.$){
            case 0:
                return n.a.ur;
            case 1:
                return "All :)";
            default:
                return "None :(";
        }
    }, Pxr = function(n) {
        switch(n.$){
            case 0:
                return It(n.a.sl);
            case 1:
                return It("");
            default:
                return Ot;
        }
    }, Zxr = F2(function(n, r) {
        var t = A2(dG, n, r.e2), e = t.b, u = t.c;
        return v(m(r, {
            e2: t.a,
            fY: u.$ || u.a.$ ? r.fY : u.a.a
        }), A2(Wp, cu, e));
    }), Mxr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Lxr = w([
        {
            $: 1
        },
        {
            $: 2
        },
        Mxr({
            sl: "1",
            ur: "Batman"
        }),
        Mxr({
            sl: "spidey",
            ur: "Spiderman"
        }),
        Mxr({
            sl: "drstrange",
            ur: "Dr Strange"
        }),
        Mxr({
            sl: "2",
            ur: "The Flash"
        })
    ]), Nxr = function(n) {
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Select")
                ])),
                A2(zx, w([
                    Gx("mt-4")
                ]), w([
                    A2(c_, cu, A4(qz, Vx(0), w([
                        XG(n.fY),
                        HG("Pick your favorite hero")
                    ]), A2(Fu, function(n) {
                        return A2(MG, g, n);
                    }, Lxr), n.e2))
                ]))
            ]))
        ]);
    }, Hxr = Chr({
        Cl: function() {
            return v({
                e2: Cd({
                    sl: "heroes",
                    Gj: function() {
                        return Txr;
                    },
                    Gk: Pxr
                }),
                fY: Ot
            }, Qp);
        },
        F4: function() {
            return bx;
        },
        Gv: Zxr,
        GB: function(n) {
            return {
                g8: Nxr(n),
                yx: "Select"
            };
        }
    }), Ixr = w([
        A2(Smn, w([
            A2(Jun, g, "First Name"),
            A2(Jun, g, "Last Name"),
            A2(Jun, g, "Gender")
        ]), w([
            A2(ean, g, w([
                A2(Yun, g, w([
                    A2(AH, g, w([
                        _d("Jhon")
                    ]))
                ])),
                A2(Yun, g, w([
                    _d("Doe")
                ])),
                A2(Yun, g, w([
                    _d("Male")
                ]))
            ])),
            A2(ean, g, w([
                A2(Yun, g, w([
                    A2(AH, g, w([
                        _d("Jane")
                    ]))
                ])),
                A2(Yun, g, w([
                    _d("Doe")
                ])),
                A2(Yun, g, w([
                    _d("Female")
                ]))
            ]))
        ])),
        A3(lan, It("Example roster for screen readers"), w([
            A2(Jun, g, "Role"),
            A2(Jun, g, "Name")
        ]), w([
            A2(ean, g, w([
                A2(Yun, g, w([
                    _d("Admin")
                ])),
                A2(Yun, g, w([
                    _d("Alex")
                ]))
            ]))
        ]))
    ]), Oxr = JRn({
        GB: function() {
            return {
                g8: Ixr,
                yx: "Table"
            };
        }
    }), Qxr = F2(function(n, r) {
        var t = A2(Qk, n, r.dg), e = t.b;
        return v(m(r, {
            dg: t.a
        }), A2(Wp, cu, e));
    }), Rxr = F3(function(n, r, t) {
        var e = r.cx;
        return A2(xc, _d("Tab NotFound"), A2(Op, function(r) {
            return n(r.a);
        }, mb(A2(no, function(n) {
            return i((0, n.b.yB)(n.a), e);
        }, t))));
    }), Uxr = function(n) {
        var r = n.ur, t = n.ng;
        return A2(zx, g, w([
            A2(Mx, w([
                Gx("text-current"),
                Gx("mr-2")
            ]), w([
                _d(r)
            ])),
            A2(Mx, w([
                Gx("text-black")
            ]), w([
                _d("(" + oe(t) + " y/o)")
            ]))
        ]));
    }, Kxr = function(n) {
        return A2(qF, n, {
            yB: function(n) {
                return n.sl;
            },
            yD: Uxr
        });
    }, Wxr = w([
        {
            ng: 30,
            sl: "pat-1",
            ur: "Brandon"
        },
        {
            ng: 31,
            sl: "pat-2",
            ur: "Jessy"
        },
        {
            ng: 10,
            sl: "pat-3",
            ur: "Philip"
        },
        {
            ng: 7,
            sl: "pat-4",
            ur: "Sofia"
        }
    ]), Xxr = function(n) {
        var r = n.ur, t = n.ng;
        return A2(zx, g, w([
            A2(zx, g, w([
                _d("id: " + n.sl)
            ])),
            A2(zx, g, w([
                _d("name: " + r)
            ])),
            A2(zx, g, w([
                _d("age: " + oe(t))
            ]))
        ]));
    }, Yxr = function(n) {
        var r = n.dg, t = A2(Fu, Kxr, Wxr);
        return w([
            A2(c_, cu, A2(SF, r, t)),
            A3(Rxr, Xxr, r, t)
        ]);
    }, Jxr = Chr({
        Cl: function() {
            var n = A2(Ek, "tabs", "pat-1");
            return v({
                dg: n.a
            }, A2(Wp, cu, n.b));
        },
        F4: function() {
            return bx;
        },
        Gv: Qxr,
        GB: function(n) {
            return {
                g8: Yxr(n),
                yx: "Tabs"
            };
        }
    }), n_r = w([
        A2(zx, w([
            Gx("section")
        ]), w([
            A2(i_, w([
                Hx(w([
                    Gx("underline mb-2")
                ]))
            ]), w([
                _d("Tags")
            ])),
            A2(zx, g, w([
                A2(Zq, g, w([
                    _d("Default Tag")
                ])),
                A2(Zq, w([
                    0
                ]), w([
                    _d("Success Tag")
                ])),
                A2(Zq, w([
                    1
                ]), w([
                    _d("Info Tag")
                ])),
                A2(Zq, w([
                    3
                ]), w([
                    _d("Warning Tag")
                ])),
                A2(Zq, w([
                    2
                ]), w([
                    _d("Danger Tag")
                ]))
            ]))
        ]))
    ]), r_r = JRn({
        GB: function() {
            return {
                g8: n_r,
                yx: "Tag"
            };
        }
    }), t_r = F2(function(n, r) {
        return r;
    }), e_r = function(n) {
        return {
            $: 0,
            a: n
        };
    }, u_r = A2(de, F2(function(n, r) {
        return m(r, n.$ ? {
            zL: It(n.a)
        } : {
            yx: It(n.a)
        });
    }), {
        zL: Ot,
        yx: Ot
    }), a_r = F2(function(n, r) {
        var t = u_r(n);
        return w([
            A2(zx, w([
                Gx("relative account-page__title-band py-4 text-center md:py-6")
            ]), A2(n$, cu, w([
                A2(Op, function(n) {
                    return A2(CF, w([
                        Hx(w([
                            Gx("text-2xl")
                        ]))
                    ]), w([
                        _d(n)
                    ]));
                }, t.yx),
                t.zL
            ]))),
            A2(zx, w([
                Gx("account-page__content rounded bg-white p-4 shadow-sm md:p-8")
            ]), r)
        ]);
    }), i_r = $(A2(a_r, w([
        e_r("Health"),
        function(n) {
            return {
                $: 1,
                a: n
            };
        }(A2(EV, w([
            yV("#")
        ]), w([
            _d("Action")
        ])))
    ]), w([
        A2(f_, w([
            nF
        ]), w([
            _d("The account-page chrome: a centered title band (with an optional action slot, e.g. the cart icon) followed by the white content card. The shaded band background comes from the surrounding layout--app page background.")
        ]))
    ])), A2(a_r, w([
        e_r("Without an action")
    ]), w([
        A2(f_, w([
            nF
        ]), w([
            _d("Band with only a title; the page body composes its own content inside the card.")
        ]))
    ]))), c_r = mhr({
        Cl: function() {
            return {};
        },
        Gv: t_r,
        GB: function() {
            return {
                g8: i_r,
                yx: "Title Band"
            };
        }
    }), o_r = F2(function(n, r) {
        return m(r, {
            kp: n
        });
    }), f_r = {
        $: 3
    }, s_r = function(n) {
        return function(n) {
            return {
                $: 2,
                a: n
            };
        }(n);
    }, l_r = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, d_r = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, v_r = function(n) {
        switch(n.$){
            case 1:
                return w([
                    oz(n.a)
                ]);
            case 0:
                return w([
                    SH(n.a)
                ]);
            case 2:
                return w([
                    uI(n.a)
                ]);
            default:
                return g;
        }
    }, b_r = function(n) {
        return vc(A2(Fu, v_r, n));
    }, m_r = function(n) {
        switch(n.$){
            case 1:
            case 0:
                return g;
            case 2:
                return w([
                    Oq(w([
                        v("toggle--checked", n.a)
                    ]))
                ]);
            case 4:
                var r = n.a;
                return A2(Fu, Px(Cu), r);
            default:
                return w([
                    Gx("toggle--card")
                ]);
        }
    }, p_r = F2(function(n, r) {
        return A2(cz, A2(Qt, Gx("toggle"), function(n) {
            return vc(A2(Fu, m_r, n));
        }(n)), w([
            A2(sz, A2(Qt, Rj("radio"), A2(Qt, Gx("toggle__input"), b_r(n))), g),
            A2(zx, w([
                Gx("toggle__text")
            ]), A2(Fu, c_(Cu), r))
        ]));
    }), $_r = function(n) {
        var r = n.kp;
        return w([
            A2(zx, w([
                Gx("section")
            ]), w([
                A2(i_, w([
                    Hx(w([
                        Gx("underline mb-2")
                    ]))
                ]), w([
                    _d("Yes No Toggle")
                ])),
                A2(zx, w([
                    Gx("mb-4")
                ]), w([
                    A2(p_r, w([
                        f_r,
                        d_r("yes"),
                        s_r("yes" === r),
                        l_r(cu)
                    ]), w([
                        _d("Yes")
                    ])),
                    A2(p_r, w([
                        f_r,
                        d_r("no"),
                        s_r("no" === r),
                        l_r(cu)
                    ]), w([
                        _d("No")
                    ]))
                ]))
            ]))
        ]);
    }, g_r = mhr({
        Cl: function() {
            return {
                kp: "yes"
            };
        },
        Gv: o_r,
        GB: function(n) {
            return {
                g8: $_r(n),
                yx: "Toggle"
            };
        }
    }), h_r = A2(BE, g, w([
        A2(lE, w([
            TE(3)
        ]), w([
            A2(EH, w([
                vH("First Name")
            ]), w([
                A2(hW, "Showing over disabled input!", PI(w([
                    OI("Hover me!"),
                    pI(!0)
                ])))
            ]))
        ]))
    ])), y_r = A2(BE, g, w([
        A2(lE, w([
            TE(3)
        ]), w([
            A2(EH, w([
                vH("First Name")
            ]), w([
                A2(hW, "Showing over input!", PI(w([
                    OI("Hover me!")
                ])))
            ]))
        ]))
    ])), w_r = A2(hW, "Showing over text!", A2(Mx, g, w([
        _d("Hover me!")
    ]))), x_r = A2(zx, w([
        Gx("flex flex-col space-y-6")
    ]), w([
        w_r,
        y_r,
        h_r
    ])), __r = JRn({
        GB: function() {
            return {
                g8: w([
                    x_r
                ]),
                yx: "StyleGuide.Tooltip"
            };
        }
    }), C_r = JRn({
        GB: function() {
            return {
                g8: w([
                    _d("Homepage")
                ]),
                yx: "Homepage"
            };
        }
    }), A_r = w([
        A2(zx, w([
            Gx("section")
        ]), w([
            A2(i_, w([
                Hx(w([
                    Gx("underline mb-2")
                ]))
            ]), w([
                _d("Titles")
            ])),
            A2(zx, g, w([
                A2(CF, g, w([
                    _d("Huge Title")
                ])),
                A2(i_, g, w([
                    _d("Big Title")
                ])),
                A2(zN, g, w([
                    _d("Base Title")
                ]))
            ]))
        ])),
        A2(zx, w([
            Gx("section")
        ]), w([
            A2(i_, w([
                Hx(w([
                    Gx("underline mb-2")
                ]))
            ]), w([
                _d("Type")
            ])),
            A2(zx, w([
                Gx("mt-4")
            ]), w([
                A2(f_, g, w([
                    _d("Normal text")
                ])),
                A2(f_, w([
                    nF
                ]), w([
                    _d("Support text")
                ])),
                A2(f_, w([
                    x6
                ]), w([
                    _d("Danger text")
                ])),
                A2(f_, w([
                    aWn
                ]), w([
                    _d("Success text")
                ])),
                A2(f_, w([
                    b4
                ]), w([
                    _d("Warning text")
                ])),
                A2(f_, w([
                    xE
                ]), w([
                    _d("Light gray text")
                ])),
                A2(f_, w([
                    _F
                ]), w([
                    _d("Huge text")
                ])),
                A2(f_, w([
                    Qx
                ]), w([
                    _d("Big text")
                ])),
                A2(f_, w([
                    qG
                ]), w([
                    _d("Medium text")
                ])),
                A2(f_, w([
                    VG
                ]), w([
                    _d("Small text")
                ])),
                A2(f_, w([
                    oK
                ]), w([
                    _d("Extra small text")
                ]))
            ]))
        ]))
    ]), k_r = JRn({
        GB: function() {
            return {
                g8: A_r,
                yx: "Typography"
            };
        }
    }), E_r = function(n) {
        return {
            $: 0,
            a: n
        };
    }, q_r = F3(function(n, r, t) {
        return v({
            ld: r.ld,
            dV: n,
            f2: A_,
            f8: Ot,
            yZ: t
        }, A3(Vwn, r.g0, ux(n), E_r));
    }), F_r = F2(function(n, r) {
        return v(r, Qp);
    }), j_r = F2(function(n, r) {
        return r;
    }), D_r = function(n) {
        return {
            $: 1,
            a: n
        };
    }, V_r = function(n) {
        return {
            lY: n.lY,
            lZ: n.lZ,
            l_: n.l_,
            mo: n.mo
        };
    }, B_r = F2(function(n, r) {
        if (n.$) {
            var t = n.a, e = r.f8;
            if (e.$) return b(r, Qp, g);
            var u = A2(hgr, t, e.a), a = u.b;
            return b(m(r, {
                f8: It(u.a)
            }), A2(Wp, D_r, a), g);
        }
        var i = n.a, c = m(r, {
            f2: i
        });
        switch(i.$){
            case 2:
                return b(c, Qp, w([
                    Nk(i.a)
                ]));
            case 3:
                return b(m(c, {
                    f8: It(A2(S$r, r.dV, V_r(i.a)))
                }), Qp, g);
            default:
                return b(c, Qp, g);
        }
    }), G_r = F2(function(n, r) {
        return w([
            A2(zx, w([
                Gx("signup__body--contents")
            ]), w([
                A2(c_, D_r, A3(Bgr, n, r, Ot))
            ]))
        ]);
    }), z_r = F2(function(n, r) {
        return {
            g8: function() {
                var t = v(r.f2, r.f8);
                n: for(;;)switch(t.a.$){
                    case 3:
                        if (t.b.$) break n;
                        return A2(G_r, n, t.b.a);
                    case 2:
                        return w([
                            Tur(r.dV)
                        ]);
                    default:
                        break n;
                }
                return Nx;
            }(),
            yx: n(G1n)
        };
    }), S_r = d_({
        Cl: q_r,
        CQ: F_r,
        Fj: j_r,
        F4: function() {
            return bx;
        },
        Gv: B_r,
        GB: z_r
    }), T_r = Xn("fullStoryPortStopCapturing", function() {
        return nx;
    }), P_r = T_r(0), Z_r = P_r, M_r = F2(function() {
        return b({}, Z_r, g);
    }), L_r = F2(function(n, r) {
        return v(r, Qp);
    }), N_r = F2(function(n, r) {
        return r;
    }), H_r = F2(function(n, r) {
        return b(r, Qp, g);
    }), I_r = {
        Cl: M_r,
        CQ: L_r,
        Fj: N_r,
        F4: function() {
            return bx;
        },
        Gv: H_r,
        GB: function() {
            return {
                g8: w([
                    _d("Homepage")
                ]),
                yx: "Homepage"
            };
        }
    }, O_r = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Q_r = {
        qN: "",
        eX: 1,
        rA: "",
        sV: ""
    }, R_r = function(n) {
        switch(n){
            case 0:
                return "firstName";
            case 1:
                return "lastName";
            case 2:
                return "email";
            default:
                return "provider";
        }
    }, U_r = F3(function(n, r, t) {
        var e = A2(ra, "practitioner", t.jb);
        return v({
            g0: r.g0,
            ld: r.ld,
            le: vZ(Q_r),
            vQ: cxn("waitlist-phone"),
            dV: n,
            bd: !i(e, Ot),
            bK: A_,
            cm: !1,
            da: e,
            yf: Ot,
            kh: !1,
            ef: !1,
            A: A2(pZ, w([
                0,
                1,
                2,
                3
            ]), R_r)
        }, A4(QQ, r.g0, ux(n), function(n) {
            return m(n, {
                lo: 100,
                mD: It(!0)
            });
        }, O_r));
    }), K_r = F2(function(n, r) {
        return v(r, Qp);
    }), W_r = F2(function(n, r) {
        return r;
    }), X_r = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Y_r = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    rA: n.a
                });
            case 1:
                return m(r, {
                    sV: n.a
                });
            case 2:
                return m(r, {
                    qN: n.a
                });
            default:
                return m(r, {
                    eX: A2(xc, 1, $u(n.a))
                });
        }
    }), J_r = XM(w([
        A2(Bir, function(n) {
            return n.rA;
        }, v(0, nL(rL("First Name")))),
        A2(Bir, function(n) {
            return n.sV;
        }, v(1, nL(rL("Last Name"))))
    ])), nCr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, rCr = F2(function(n, r) {
        var t = FM(n.le), e = rx(w([
            v("waitlist_entry", rx(vc(w([
                w([
                    v("practitioner_id", tx(r)),
                    v("first_name", tx(t.rA)),
                    v("last_name", tx(t.sV)),
                    v("enroll_count", NQ(t.eX))
                ]),
                mu(t.qN) ? g : w([
                    v("email", tx(t.qN))
                ]),
                w([
                    v("phone", LPn(n.vQ))
                ])
            ]))))
        ]));
        return A4(lM, GQ(n.g0), G$, nCr, A2(dM, e, pk(A2(bk, w([
            "waitlist_entries"
        ]), fM(ux(n.dV))))));
    }), tCr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = F2(function(n, r) {
                    return A2(Wk, function(r) {
                        return i(rQ(r), n);
                    }, r);
                }), u = function() {
                    if (r.bd) {
                        var n = v(r.da, t);
                        if (n.a.$ || 3 !== n.b.$) return v(r.da, !1);
                        var u = n.a.a;
                        return A2(e, u, n.b.a) ? v(It(u), !1) : v(Ot, !0);
                    }
                    return v(3 === t.$ && t.a.b && !t.a.b.b ? It(rQ(t.a.a)) : r.da, !1);
                }();
                return b(m(r, {
                    bd: r.bd && !u.b,
                    bK: t,
                    da: u.a
                }), Qp, g);
            case 1:
                var a = n.a;
                return b(m(r, {
                    cm: !1,
                    da: mu(a) ? Ot : It(a)
                }), Qp, g);
            case 2:
                return b(m(r, {
                    le: A3(cN, Y_r, c = n.a, r.le)
                }), Qp, g);
            case 3:
                var c, o = function(n) {
                    switch(n.$){
                        case 0:
                            return 0;
                        case 1:
                            return 1;
                        default:
                            return 2;
                    }
                }(c = n.a), f = A3(qL, !0, o, r.A), s = (A = A2(CL, J_r, A3(cN, Y_r, c, r.le))).$ ? A.a : A.a.a;
                return b(m(r, {
                    le: s,
                    A: f
                }), Qp, g);
            case 4:
                var l = A2(gkn, n.a, r.vQ), d = l.b;
                return b(m(r, {
                    vQ: l.a
                }), A2(Wp, X_r, d), g);
            case 5:
                var p = A2(Nkn, !0, r.vQ), $ = A2(CL, J_r, r.le), h = Pkn(p), y = i(r.da, Ot) && !r.bd, w = atr(r.A), x = $.$ ? $.a : $.a.a;
                if (!$.$ && !y && h) {
                    var _ = r.da;
                    if (_.$) return b(m(r, {
                        le: x,
                        vQ: p,
                        cm: !0,
                        A: w
                    }), Qp, g);
                    var C = _.a;
                    return b(m(r, {
                        le: x,
                        vQ: p,
                        cm: !1,
                        yf: Ot,
                        ef: !0,
                        A: w
                    }), A2(rCr, r, C), g);
                }
                return b(m(r, {
                    le: x,
                    vQ: p,
                    cm: y,
                    A: w
                }), Qp, g);
            default:
                return b(m(r, 3 === (t = n.a).$ ? {
                    kh: !0,
                    ef: !1
                } : {
                    yf: It(A2(Vx, r.ld, jQn)),
                    ef: !1
                }), Qp, g);
        }
        var A;
    }), eCr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uCr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, aCr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, iCr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cCr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, oCr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fCr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, sCr = {
        $: 5
    }, lCr = cr("select"), dCr = F3(function(n, r, t) {
        return A2(oN, t, r) && A2(wH, t, n);
    }), vCr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bCr = F3(function(n, r, t) {
        return A2(oN, t, r) ? A2(iH, t, n) : g;
    }), mCr = F2(function(n, r) {
        var t, e = 3 === (t = r.bK).$ ? t.a : g, u = FM(r.le);
        return A2(zx, g, w([
            function() {
                var n = r.yf;
                if (n.$) return vE;
                var t = n.a;
                return A2(zx, w([
                    Gx("message-box message-box--error mb-4")
                ]), w([
                    _d(t)
                ]));
            }(),
            r.bd || nE(e) ? vE : A2(zx, g, w([
                A2(EH, w([
                    vH(n(qQn)),
                    gH(!0)
                ]), w([
                    A2(lCr, w([
                        Gx(r.cm ? "input input--invalid" : "input"),
                        SH(fCr)
                    ]), A2(Qt, A2(MY, w([
                        oz("")
                    ]), w([
                        _d(n(FQn))
                    ])), A2(Fu, function(n) {
                        return A2(MY, w([
                            oz(rQ(n)),
                            NY(i(r.da, It(rQ(n))))
                        ]), w([
                            _d(QS(n))
                        ]));
                    }, e)))
                ])),
                r.cm ? A2(YH, n, w([
                    nL(eLn("Provider"))
                ])) : vE
            ])),
            A2(EH, w([
                vH(n($Qn)),
                gH(!0)
            ]), w([
                PI(w([
                    OI(u.rA),
                    HI(A2(qc, cCr, iCr)),
                    _I(aCr(iCr(u.rA))),
                    yI(A3(dCr, r.le, r.A, 0)),
                    jI(n(gQn))
                ])),
                A2(YH, n, A3(bCr, r.le, r.A, 0))
            ])),
            A2(EH, w([
                vH(n(CQn)),
                gH(!0)
            ]), w([
                PI(w([
                    OI(u.sV),
                    HI(A2(qc, cCr, oCr)),
                    _I(aCr(oCr(u.sV))),
                    yI(A3(dCr, r.le, r.A, 1)),
                    jI(n(AQn))
                ])),
                A2(YH, n, A3(bCr, r.le, r.A, 1))
            ])),
            A2(EH, w([
                vH(n(bQn))
            ]), w([
                PI(w([
                    OI(u.qN),
                    HI(A2(qc, cCr, eCr)),
                    _I(aCr(eCr(u.qN))),
                    jI(n(mQn))
                ]))
            ])),
            A2(EH, w([
                vH(n(EQn))
            ]), w([
                A2(c_, X_r, A3(NFn, n, w([
                    vCr(!0)
                ]), r.vQ))
            ])),
            A2(EH, w([
                vH(n(pQn))
            ]), w([
                PI(w([
                    OI(oe(u.eX)),
                    hI(0),
                    HI(A2(qc, cCr, uCr))
                ]))
            ])),
            A2(zx, w([
                Gx("mt-6 flex justify-center")
            ]), w([
                A2(yF, w([
                    fF,
                    Qj(r.ef),
                    cF(sCr)
                ]), w([
                    _d(n(wQn))
                ]))
            ]))
        ]));
    }), pCr = function(n) {
        var r = function() {
            var r = v(n.da, n.bK);
            if (r.a.$ || 3 !== r.b.$) return ax(n.dV);
            var t = r.a.a, e = r.b.a;
            return A2(xc, ax(n.dV), A2(Op, QS, mb(A2(no, function(n) {
                return i(rQ(n), t);
            }, e))));
        }();
        return A2(zx, w([
            Gx("text-center py-8")
        ]), w([
            A2(i_, w([
                uE(eE)
            ]), w([
                _d(A2(Vx, n.ld, VQn))
            ])),
            A2(f_, g, w([
                _d(A2(Vx, n.ld, DQn) + " " + r + ".")
            ]))
        ]));
    }, $Cr = F2(function(n, r) {
        return {
            g8: w([
                A2(zx, w([
                    Gx("signup__body bg-white")
                ]), w([
                    A2(zx, w([
                        Gx("signup__page-border")
                    ]), g),
                    A2(zx, w([
                        Gx("signup__page-center")
                    ]), w([
                        A2(zx, w([
                            Gx("flex-col w-full")
                        ]), w([
                            A2(CF, w([
                                gW,
                                uE(eE),
                                A2(U5n, 1, M5n),
                                uF(rD),
                                A2(Z5n, 1, xD)
                            ]), w([
                                _d(n(kQn) + " \u2014 " + ax(r.dV))
                            ])),
                            r.kh ? pCr(r) : A2(mCr, n, r)
                        ]))
                    ])),
                    A2(zx, w([
                        Gx("signup__page-border")
                    ]), g)
                ]))
            ]),
            yx: n(kQn) + " \u2014 " + ax(r.dV)
        };
    }), gCr = d_({
        Cl: U_r,
        CQ: K_r,
        Fj: W_r,
        F4: function() {
            return bx;
        },
        Gv: tCr,
        GB: $Cr
    }), hCr = F2(function(n, r) {
        return {
            g8: A2(Fu, c_(n), r.g8),
            yx: r.yx
        };
    }), yCr = F3(function(n, r, t) {
        var e = t.b, u = t.c;
        return b(n(t.a), r(e), u);
    }), wCr = F3(function(n, r, t) {
        var e = F2(function(e, u) {
            return A3(yCr, n, Wp(r), A2(t.Gv, e, u));
        }), u = F2(function(e, u) {
            return A3(r$, n, Wp(r), A2(t.CQ, u, e));
        }), a = F2(function(e, u) {
            return A3(yCr, n, Wp(r), A2(t.Cl, u, A2(s8, e, u.yZ)));
        });
        return {
            a: function(n) {
                return {
                    CQ: function() {
                        return u(n);
                    },
                    Fj: function() {
                        return t.Fj(n);
                    },
                    F4: function() {
                        return A2(kj, r, t.F4(n));
                    },
                    GB: function() {
                        return A2(hCr, r, t.GB(n));
                    }
                };
            },
            Cl: a,
            Gv: e
        };
    }), xCr = {
        gl: A3(wCr, vg, bg, ZF),
        gm: A3(wCr, fg, sg, RV),
        gn: A3(wCr, cg, og, oB),
        go: A3(wCr, ag, ig, _B),
        gp: A3(wCr, lg, dg, jB),
        gq: A3(wCr, hg, yg, Pz),
        gr: A3(wCr, mg, pg, HP),
        gs: A3(wCr, $g, gg, PO),
        gt: A3(wCr, Ag, kg, w0),
        gu: A3(wCr, wg, xg, Q4),
        gv: A3(wCr, _g, Cg, t8),
        gw: A3(wCr, Eg, qg, bin),
        gx: A3(wCr, Fg, jg, Yin),
        gy: A3(wCr, Dg, Vg, Ncn),
        gz: A3(wCr, Bg, Gg, Jcn),
        gA: A3(wCr, Tg, Pg, Pon),
        gB: A3(wCr, zg, Sg, mdn),
        gC: A3(wCr, Hg, Ig, Svn),
        gD: A3(wCr, Zg, Mg, Dpn),
        gE: A3(wCr, Lg, Ng, mgn),
        gF: A3(wCr, Xg, Yg, chn),
        gG: A3(wCr, Kg, Wg, ywn),
        gH: A3(wCr, Og, Qg, tjn),
        gI: A3(wCr, Rg, Ug, dDn),
        gJ: A3(wCr, ah, ih, eVn),
        gK: A3(wCr, rh, th, wGn),
        gL: A3(wCr, Jg, nh, dRn),
        gM: A3(wCr, eh, uh, TRn),
        gN: A3(wCr, fh, sh, IRn),
        gO: A3(wCr, ch, oh, XRn),
        gP: A3(wCr, lh, dh, nUn),
        gQ: A3(wCr, mh, ph, wUn),
        gR: A3(wCr, vh, bh, bKn),
        gS: A3(wCr, wh, xh, XKn),
        gT: A3(wCr, hh, yh, mWn),
        gU: A3(wCr, $h, gh, rXn),
        gV: A3(wCr, _h, Ch, OXn),
        gW: A3(wCr, Ah, kh, WYn),
        gX: A3(wCr, Eh, qh, uJn),
        gY: A3(wCr, Fh, jh, cJn),
        gZ: A3(wCr, Dh, Vh, wJn),
        g3: A3(wCr, Bh, Gh, FJn),
        g6: A3(wCr, zh, Sh, jJn),
        ha: A3(wCr, Th, Ph, YJn),
        hb: A3(wCr, Zh, Mh, p0n),
        hc: A3(wCr, Lh, Nh, _0n),
        hd: A3(wCr, Hh, Ih, T0n),
        ho: A3(wCr, Oh, Qh, v1n),
        hp: A3(wCr, Rh, Uh, y1n),
        hQ: A3(wCr, Kh, Wh, S1n),
        hR: A3(wCr, Xh, Yh, k1n),
        iv: A3(wCr, Jh, ny, y3n),
        iw: A3(wCr, ry, ty, n9n),
        ix: A3(wCr, ey, uy, d6n),
        iG: A3(wCr, ay, iy, v6n),
        fx: A3(wCr, cy, oy, b6n),
        jz: A3(wCr, fy, sy, v7n),
        jA: A3(wCr, ly, dy, Zur),
        jB: A3(wCr, vy, by, bor),
        jC: A3(wCr, my, py, Msr),
        jD: A3(wCr, $y, gy, pdr),
        jE: A3(wCr, hy, yy, Nbr),
        jF: A3(wCr, wy, xy, apr),
        jG: A3(wCr, _y, Cy, G$r),
        jH: A3(wCr, Ay, ky, nhr),
        jI: A3(wCr, Ey, qy, chr),
        jJ: A3(wCr, Fy, jy, bhr),
        jM: A3(wCr, Dy, Vy, whr),
        jN: A3(wCr, By, Gy, _hr),
        jO: A3(wCr, zy, Sy, Ehr),
        jP: A3(wCr, Ty, Py, Ghr),
        jQ: A3(wCr, Zy, My, ryr),
        jR: A3(wCr, Ly, Ny, ayr),
        jS: A3(wCr, Oy, Qy, vyr),
        jT: A3(wCr, Hy, Iy, gyr),
        jU: A3(wCr, Ry, Uy, Cyr),
        jV: A3(wCr, Ky, Wy, Byr),
        jW: A3(wCr, Xy, Yy, zyr),
        jX: A3(wCr, Jy, nw, awr),
        jY: A3(wCr, rw, tw, wwr),
        jZ: A3(wCr, ew, uw, _wr),
        j_: A3(wCr, aw, iw, Fwr),
        j$: A3(wCr, cw, ow, Twr),
        j0: A3(wCr, fw, sw, Kwr),
        j1: A3(wCr, lw, dw, oxr),
        j2: A3(wCr, vw, bw, lxr),
        j3: A3(wCr, mw, pw, yxr),
        j4: A3(wCr, $w, gw, Gxr),
        j5: A3(wCr, hw, yw, Sxr),
        j6: A3(wCr, ww, xw, Hxr),
        j7: A3(wCr, _w, Cw, Oxr),
        j8: A3(wCr, Aw, kw, Jxr),
        j9: A3(wCr, Ew, qw, r_r),
        ka: A3(wCr, Fw, jw, c_r),
        kb: A3(wCr, Dw, Vw, g_r),
        kc: A3(wCr, Bw, Gw, __r),
        kd: A3(wCr, zw, Sw, C_r),
        ke: A3(wCr, Tw, Pw, k_r),
        km: A3(wCr, Zw, Mw, S_r),
        mx: A3(wCr, Lw, Nw, I_r),
        t: A3(wCr, Hw, Iw, gCr)
    }, _Cr = function(n) {
        switch(n.$){
            case 0:
                return xCr.mx.Cl(0);
            case 1:
                return xCr.hQ.Cl(0);
            case 2:
                return xCr.iG.Cl(0);
            case 3:
                return xCr.fx.Cl(0);
            case 4:
                return xCr.km.Cl(0);
            case 5:
                return xCr.t.Cl(0);
            case 6:
                return xCr.gZ.Cl(0);
            case 7:
                return xCr.hd.Cl(0);
            case 8:
                return xCr.hp.Cl(0);
            case 9:
                return xCr.hR.Cl(0);
            case 10:
                return xCr.jJ.Cl(0);
            case 11:
                return xCr.kd.Cl(0);
            case 12:
                return xCr.gl.Cl(0);
            case 13:
                return xCr.gq.Cl(0);
            case 14:
                return xCr.gt.Cl(0);
            case 15:
                return xCr.gw.Cl(0);
            case 16:
                return xCr.gx.Cl(0);
            case 17:
                return xCr.gy.Cl(0);
            case 18:
                return xCr.gz.Cl(0);
            case 19:
                return xCr.gA.Cl(0);
            case 20:
                return xCr.gC.Cl(0);
            case 21:
                return xCr.gF.Cl(0);
            case 22:
                return xCr.gJ.Cl(0);
            case 23:
                return xCr.gN.Cl(0);
            case 24:
                return xCr.gP.Cl(0);
            case 25:
                return xCr.gS.Cl(0);
            case 26:
                return xCr.gW.Cl(0);
            case 27:
                return xCr.gX.Cl(0);
            case 28:
                return xCr.hc.Cl(0);
            case 29:
                return xCr.iv.Cl(0);
            case 30:
                return xCr.iw.Cl(0);
            case 31:
                return xCr.ix.Cl(0);
            case 32:
                return xCr.jM.Cl(0);
            case 33:
                return xCr.jN.Cl(0);
            case 34:
                return xCr.jO.Cl(0);
            case 35:
                return xCr.jP.Cl(0);
            case 36:
                return xCr.jQ.Cl(0);
            case 37:
                return xCr.jR.Cl(0);
            case 38:
                return xCr.jS.Cl(0);
            case 39:
                return xCr.jT.Cl(0);
            case 40:
                return xCr.jU.Cl(0);
            case 41:
                return xCr.jV.Cl(0);
            case 42:
                return xCr.jW.Cl(0);
            case 43:
                return xCr.jX.Cl(0);
            case 44:
                return xCr.jY.Cl(0);
            case 45:
                return xCr.jZ.Cl(0);
            case 46:
                return xCr.j_.Cl(0);
            case 47:
                return xCr.j$.Cl(0);
            case 48:
                return xCr.j0.Cl(0);
            case 49:
                return xCr.j1.Cl(0);
            case 50:
                return xCr.j2.Cl(0);
            case 51:
                return xCr.j3.Cl(0);
            case 52:
                return xCr.j4.Cl(0);
            case 53:
                return xCr.j5.Cl(0);
            case 54:
                return xCr.j6.Cl(0);
            case 55:
                return xCr.j7.Cl(0);
            case 56:
                return xCr.j8.Cl(0);
            case 57:
                return xCr.j9.Cl(0);
            case 58:
                return xCr.ka.Cl(0);
            case 59:
                return xCr.kb.Cl(0);
            case 60:
                return xCr.kc.Cl(0);
            case 61:
                return xCr.ke.Cl(0);
            case 62:
                return xCr.gY.Cl(n.a);
            case 63:
                return xCr.g6.Cl(n.a);
            case 64:
                return xCr.ho.Cl(n.a);
            case 65:
                return xCr.jI.Cl(n.a);
            case 66:
                return xCr.gu.Cl(0);
            case 67:
                return xCr.gv.Cl(0);
            case 68:
                return xCr.gO.Cl(0);
            case 69:
                return xCr.g3.Cl(n.a);
            case 70:
                return xCr.jz.Cl(n.a);
            case 71:
                return xCr.jA.Cl(n.a);
            case 72:
                return xCr.jB.Cl(n.a);
            case 73:
                return xCr.jC.Cl(n.a);
            case 74:
                return xCr.jD.Cl(n.a);
            case 75:
                return xCr.jE.Cl(n.a);
            case 76:
                return xCr.jF.Cl(n.a);
            case 77:
                return xCr.jG.Cl(n.a);
            case 78:
                return xCr.jH.Cl(n.a);
            case 79:
                return xCr.gm.Cl(n.a);
            case 80:
                return xCr.gB.Cl(n.a);
            case 81:
                return xCr.gD.Cl(n.a);
            case 82:
                return xCr.gG.Cl(n.a);
            case 83:
                return xCr.gK.Cl(n.a);
            case 84:
                return xCr.gQ.Cl(n.a);
            case 85:
                return xCr.gT.Cl(n.a);
            case 86:
                return xCr.gn.Cl(n.a);
            case 87:
                return xCr.go.Cl(n.a);
            case 88:
                return xCr.gp.Cl(n.a);
            case 89:
                return xCr.gE.Cl(n.a);
            case 90:
                return xCr.gH.Cl(n.a);
            case 91:
                return xCr.gI.Cl(n.a);
            case 92:
                return xCr.gL.Cl(n.a);
            case 93:
                return xCr.gM.Cl(n.a);
            case 94:
                return xCr.gR.Cl(n.a);
            case 95:
                return xCr.gU.Cl(n.a);
            case 96:
                return xCr.gV.Cl(n.a);
            case 97:
                return xCr.ha.Cl(n.a);
            case 98:
                return xCr.hb.Cl(n.a);
            case 99:
                return xCr.gr.Cl(n.a);
            default:
                return xCr.gs.Cl(n.a);
        }
    }, CCr = function(n) {
        return A2(YN, "/account/messaging", n) || A2(YN, "/account/chat", n);
    }, ACr = function(n) {
        return A2(YN, "/account", n);
    }, kCr = function(n) {
        return A2(YN, "/login", n);
    }, ECr = function(n) {
        return A2(YN, "/appointments", n);
    }, qCr = function(n) {
        return A2(YN, "/signup", n) || A2(YN, "/enroll", n) || A2(YN, "/checkout", n);
    }, FCr = function(n) {
        return function(n) {
            return A2(YN, "/style-guide", n);
        }(n) ? 1 : qCr(n) ? 0 : kCr(n) ? 2 : JN(n) || function(n) {
            return A2(YN, "/account/booking", n);
        }(n) ? 4 : ECr(n) || function(n) {
            return A2(YN, "/account/appointments", n);
        }(n) ? 5 : CCr(n) ? 6 : ACr(n) ? 3 : 7;
    }, jCr = function(n) {
        return FCr(n);
    }, DCr = Xn("sentryPortCaptureErrorMessage", function(n) {
        var r = n.b;
        return A2(WU, cu, w([
            tx(n.a),
            r
        ]));
    }), VCr = F2(function(n, r) {
        return DCr(v(n, A3(Rfn, cu, cu, r)));
    }), BCr = A6(fu, 0, "localhost", Ot, "", Ot, Ot), GCr = function(n) {
        var r = _u(n);
        return r.$ ? v(BCr, A2(VCr, "Url.fromString Failed: " + n, pa)) : v(r.a, Qp);
    }, zCr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, SCr = {
        $: 29
    }, TCr = function(n) {
        return {
            $: 18,
            a: n
        };
    }, PCr = function(n) {
        return {
            $: 22,
            a: n
        };
    }, ZCr = function(n) {
        return {
            $: 24,
            a: n
        };
    }, MCr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, LCr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, NCr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, HCr = {
        $: 23
    }, ICr = function(n) {
        return {
            $: 28,
            a: n
        };
    }, OCr = nr("accountTokenRemovedPort", XA(0)), QCr = OCr, RCr = nr("idleUser", ru), UCr = nr("onBeforeUnload", ru), KCr = function(n) {
        switch(n.$){
            case 0:
                return xCr.mx.a(n.a);
            case 1:
                return xCr.hQ.a(n.a);
            case 2:
                return xCr.iG.a(n.a);
            case 3:
                return xCr.fx.a(n.a);
            case 4:
                return xCr.km.a(n.a);
            case 5:
                return xCr.t.a(n.a);
            case 6:
                return xCr.gZ.a(n.a);
            case 7:
                return xCr.hd.a(n.a);
            case 8:
                return xCr.hp.a(n.a);
            case 9:
                return xCr.hR.a(n.a);
            case 10:
                return xCr.jJ.a(n.a);
            case 11:
                return xCr.kd.a(n.a);
            case 12:
                return xCr.gl.a(n.a);
            case 13:
                return xCr.gq.a(n.a);
            case 14:
                return xCr.gt.a(n.a);
            case 15:
                return xCr.gw.a(n.a);
            case 16:
                return xCr.gx.a(n.a);
            case 17:
                return xCr.gy.a(n.a);
            case 18:
                return xCr.gz.a(n.a);
            case 19:
                return xCr.gA.a(n.a);
            case 20:
                return xCr.gC.a(n.a);
            case 21:
                return xCr.gF.a(n.a);
            case 22:
                return xCr.gJ.a(n.a);
            case 23:
                return xCr.gN.a(n.a);
            case 24:
                return xCr.gP.a(n.a);
            case 25:
                return xCr.gS.a(n.a);
            case 26:
                return xCr.gW.a(n.a);
            case 27:
                return xCr.gX.a(n.a);
            case 28:
                return xCr.hc.a(n.a);
            case 29:
                return xCr.iv.a(n.a);
            case 30:
                return xCr.iw.a(n.a);
            case 31:
                return xCr.ix.a(n.a);
            case 32:
                return xCr.jM.a(n.a);
            case 33:
                return xCr.jN.a(n.a);
            case 34:
                return xCr.jO.a(n.a);
            case 35:
                return xCr.jP.a(n.a);
            case 36:
                return xCr.jQ.a(n.a);
            case 37:
                return xCr.jR.a(n.a);
            case 38:
                return xCr.jS.a(n.a);
            case 39:
                return xCr.jT.a(n.a);
            case 40:
                return xCr.jU.a(n.a);
            case 41:
                return xCr.jV.a(n.a);
            case 42:
                return xCr.jW.a(n.a);
            case 43:
                return xCr.jX.a(n.a);
            case 44:
                return xCr.jY.a(n.a);
            case 45:
                return xCr.jZ.a(n.a);
            case 46:
                return xCr.j_.a(n.a);
            case 47:
                return xCr.j$.a(n.a);
            case 48:
                return xCr.j0.a(n.a);
            case 49:
                return xCr.j1.a(n.a);
            case 50:
                return xCr.j2.a(n.a);
            case 51:
                return xCr.j3.a(n.a);
            case 52:
                return xCr.j4.a(n.a);
            case 53:
                return xCr.j5.a(n.a);
            case 54:
                return xCr.j6.a(n.a);
            case 55:
                return xCr.j7.a(n.a);
            case 56:
                return xCr.j8.a(n.a);
            case 57:
                return xCr.j9.a(n.a);
            case 58:
                return xCr.ka.a(n.a);
            case 59:
                return xCr.kb.a(n.a);
            case 60:
                return xCr.kc.a(n.a);
            case 61:
                return xCr.ke.a(n.a);
            case 62:
                return xCr.gY.a(n.a);
            case 63:
                return xCr.g6.a(n.a);
            case 64:
                return xCr.ho.a(n.a);
            case 65:
                return xCr.jI.a(n.a);
            case 66:
                return xCr.gu.a(n.a);
            case 67:
                return xCr.gv.a(n.a);
            case 68:
                return xCr.gO.a(n.a);
            case 69:
                return xCr.g3.a(n.a);
            case 70:
                return xCr.jz.a(n.a);
            case 71:
                return xCr.jA.a(n.a);
            case 72:
                return xCr.jB.a(n.a);
            case 73:
                return xCr.jC.a(n.a);
            case 74:
                return xCr.jD.a(n.a);
            case 75:
                return xCr.jE.a(n.a);
            case 76:
                return xCr.jF.a(n.a);
            case 77:
                return xCr.jG.a(n.a);
            case 78:
                return xCr.jH.a(n.a);
            case 79:
                return xCr.gm.a(n.a);
            case 80:
                return xCr.gB.a(n.a);
            case 81:
                return xCr.gD.a(n.a);
            case 82:
                return xCr.gG.a(n.a);
            case 83:
                return xCr.gK.a(n.a);
            case 84:
                return xCr.gQ.a(n.a);
            case 85:
                return xCr.gT.a(n.a);
            case 86:
                return xCr.gn.a(n.a);
            case 87:
                return xCr.go.a(n.a);
            case 88:
                return xCr.gp.a(n.a);
            case 89:
                return xCr.gE.a(n.a);
            case 90:
                return xCr.gH.a(n.a);
            case 91:
                return xCr.gI.a(n.a);
            case 92:
                return xCr.gL.a(n.a);
            case 93:
                return xCr.gM.a(n.a);
            case 94:
                return xCr.gR.a(n.a);
            case 95:
                return xCr.gU.a(n.a);
            case 96:
                return xCr.gV.a(n.a);
            case 97:
                return xCr.ha.a(n.a);
            case 98:
                return xCr.hb.a(n.a);
            case 99:
                return xCr.gr.a(n.a);
            default:
                return xCr.gs.a(n.a);
        }
    }, WCr = function(n) {
        return KCr(n).F4(0);
    }, XCr = function(n) {
        return A2(zx, g, n.g8);
    }, YCr = {
        $: 1
    }, JCr = function(n) {
        return KCr(n).CQ(0);
    }, nAr = function(n) {
        return KCr(n).Fj(0);
    }, rAr = at, tAr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, eAr = {
        $: 1
    }, uAr = function(n) {
        return {
            $: 21,
            a: n
        };
    }, aAr = function(n) {
        return {
            $: 17,
            a: n
        };
    }, iAr = function(n) {
        return {
            $: 25,
            a: n
        };
    }, cAr = function(n) {
        return {
            $: 30,
            a: n
        };
    }, oAr = function(n) {
        return {
            $: 19,
            a: n
        };
    }, fAr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), sAr = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), lAr = Xn("fullStoryPortIdentifyPatientPortal", cu), dAr = F2(function(n, r) {
        return lAr(rx(w([
            v("scope", A2(xc, nx, A2(Op, tx, n))),
            v("userId", A2(xc, nx, A2(Op, tx, r)))
        ])));
    }), vAr = F2(function(n, r) {
        return ox(rx(w([
            v("scope", A2(xc, nx, A2(Op, tx, n))),
            v("userId", A2(xc, nx, A2(Op, tx, r)))
        ])));
    }), bAr = F2(function(n, r) {
        return Uu(w([
            A2(dAr, n, r),
            A2(vAr, n, r)
        ]));
    }), mAr = F2(function(n, r) {
        return A2(bAr, n, r);
    }), pAr = F2(function(n, r) {
        return r.$ ? r : Dc(m(r.a, {
            im: n
        }));
    }), $Ar = cu, gAr = function(n) {
        var r = n.a, t = n.b, e = r.dV;
        if (3 === e.$) {
            var u = BPn(e.a) ? A2(xc, r.ld, A2(Op, $Ar, r.Gy)) : r.ld;
            return v(m(r, {
                g0: A2(pAr, u, r.g0),
                ld: u,
                CL: A2(eg, u, r.CL)
            }), t);
        }
        return v(r, t);
    }, hAr = function(n) {
        return n.b.ot;
    }, yAr = F2(function(n, r) {
        return !!A2(pU, r, n);
    }), wAr = F3(function(n, r, t) {
        switch(n.$){
            case 3:
                return function(n) {
                    return n.xw;
                }(n.a);
            case 0:
                if (hAr(r)) {
                    var e = function(n) {
                        return n.b.vk;
                    }(r), u = function(n) {
                        return n.b.vj;
                    }(r), a = v(e, u);
                    return a.a && !a.b.$ ? A2(yAr, a.b.a, t) : hAr(r);
                }
                return !1;
            default:
                return !1;
        }
    }), xAr = F4(function(n, r, t, e) {
        return 3 === n.$ && A3(wAr, r, n.a, A2(Ep, t, e));
    }), _Ar = function(n) {
        return 1 === n.$ ? Bc(m(n.a, {
            j: X$
        })) : Dc(m(n.a, {
            j: X$
        }));
    }, CAr = function(n) {
        return N$(n.a.j) ? "limited_access" : "full_access";
    }, AAr = function(n) {
        return A2(Yk, "member_clinical_data_share", n);
    }, kAr = F3(function(n, r, t) {
        var e = rx(w([
            v("statusCode", NQ(t.F_)),
            v("headers", A3(Rfn, cu, tx, t.h3))
        ])), u = rx(w([
            v("url", tx(t.yZ)),
            v("headers", A3(Rfn, cu, tx, r))
        ])), a = ed(w([
            v("request", u),
            v("response", e)
        ]));
        return A2(VCr, "Decoder Failed: " + n, a);
    }), EAr = F3(function(n, r, t) {
        return A4(FKn, n, AKn, t, pk(A2(bk, w([
            "auth"
        ]), fM(r))));
    }), qAr = F4(function(n, r, t, e) {
        var u = rx(w([
            v("google_recaptcha_token", A2(wM, tx, t))
        ]));
        return A4(lM, n, B3n, e, A2(dM, u, pk(A2(bk, w([
            "auth",
            "exchange_token"
        ]), fM(r)))));
    }), FAr = Xn("fetchCustomJsFile", tx), jAr = function(n) {
        return A2(xc, "", A2(NR, 1, A2(no, function(n) {
            return "" !== n;
        }, A2(se, "/", n.Ev))));
    }, DAr = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a, e = jAr(r), u = ux(t);
            return It(r.Cc + "-" + u + "-" + e);
        }
        return Ot;
    }), VAr = function(n) {
        var r = A2(DAr, n.dV, n.yZ);
        return r.$ ? Qp : XS(A2($S, 0, r.a));
    }, BAr = "pageAbandoned", GAr = XS(A2($S, 1, BAr)), zAr = function(n) {
        var r, t = n.dV;
        if (3 === t.$) {
            var e = (r = function(n) {
                return n.b.pO;
            }(t.a), r.$ ? Qp : FAr(r.a));
            return qCr(_c(n.yZ)) ? v(n, Uu(w([
                GAr,
                VAr(n),
                e
            ]))) : v(n, e);
        }
        return v(n, Qp);
    }, SAr = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), TAr = F5(function(n, r, t, e, u) {
        return {
            qj: u,
            sg: r,
            sl: n,
            lz: t,
            ur: e
        };
    }), PAr = A3(nk, "dob", uC(KA), A3(nk, "name", M$, A3(nk, "meta", EQ, A3(nk, "hipaa_authorization_accepted", ru, A3(nk, "id", M$, au(TAr)))))), ZAr = A2($A, PAr, au(cu)), MAr = A2(bk, w([
        "account"
    ]), oM), LAr = F2(function(n, r) {
        return A4(aA, n, ZAr, r, pk(MAr));
    }), NAr = F2(function(n, r) {
        var t = b_(n), e = _c(r);
        return t && (ACr(e) || kCr(e)) ? A2(LAr, n, SAr(n)) : Qp;
    }), HAr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, IAr = F3(function(n, r, t) {
        var e = v(r, t);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.b.a;
            return A4(Phn, n, ux(e.a.a), kM(u), HAr);
        }
        return Qp;
    }), OAr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, QAr = function(n) {
        return {
            $: 20,
            a: n
        };
    }, RAr = F2(function(n, r) {
        var t = r.zJ;
        return t.$ ? rB(n.Cc) : It(t.a);
    }), UAr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), KAr = F2(function(n, r) {
        return {
            ht: n,
            FW: r
        };
    }), WAr = function(n) {
        switch(n){
            case "patient_portal":
                return au(0);
            case "packages":
                return au(1);
            default:
                return au(2);
        }
    }, XAr = function(n) {
        switch(n){
            case "startup":
                return au(0);
            case "growth":
                return au(1);
            case "enterprise":
                return au(2);
            case "call_us":
                return au(3);
            default:
                return au(4);
        }
    }, YAr = A3(nk, "starting_tier", A2(nu, XAr, M$), A3(nk, "code", A2(nu, WAr, M$), au(KAr))), JAr = A2($A, A2(eu, cu, YAr), au(cu)), nkr = A4(JA, "sms_login_available", ru, !1, A3(nk, "passthrough_fees_cutoff_enabled", ru, A3(nk, "passthrough_fees_cutoff_date", ik(KA), A3(nk, "membership_cancellation_enabled", ru, A3(nk, "charge_patients_credit_card_fees", ru, A3(nk, "default_patients_preferred_language", fhn, A3(nk, "has_clinical_account", ru, A3(nk, "features", ek(M$), A3(nk, "feature_gates", ek(JAr), A3(nk, "address", uC(Hvn), A3(nk, "phone", uC(M$), A3(nk, "custom_javascript", uC(M$), A3(nk, "encourage_ach", ru, A3(nk, "accepts_apple_pay", ru, A3(nk, "accepts_cards", ru, A3(nk, "accepts_ach", ru, A3(nk, "accepts_amex", ru, A3(nk, "requires_patient_mobile", ru, A3(nk, "requires_patient_email", ru, A3(nk, "trans_inclusivity", ru, A3(nk, "default_signup_page", uC(I$r), A3(nk, "email", uC(M$), A3(nk, "url", uC(M$), au(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(v) {
                                                            return function(b) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(y) {
                                                                                        return function(w) {
                                                                                            return function(x) {
                                                                                                return {
                                                                                                    mJ: c,
                                                                                                    mK: i,
                                                                                                    mL: f,
                                                                                                    mM: o,
                                                                                                    m9: v,
                                                                                                    ot: g,
                                                                                                    pO: l,
                                                                                                    p2: $,
                                                                                                    p5: t,
                                                                                                    qN: r,
                                                                                                    qX: s,
                                                                                                    rr: b,
                                                                                                    rs: m,
                                                                                                    r_: p,
                                                                                                    tI: h,
                                                                                                    vj: y,
                                                                                                    vk: w,
                                                                                                    vO: d,
                                                                                                    w2: u,
                                                                                                    w3: a,
                                                                                                    xR: x,
                                                                                                    yN: e,
                                                                                                    yZ: n
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))), rkr = A2($A, nkr, A2($A, Q$r, au(UAr))), tkr = F3(function(n, r, t) {
        return A4(aA, GQ(n), rkr, t, pk(fM(r)));
    }), ekr = F7(function(n, r, t, e, u, a, i) {
        return {
            Al: n,
            se: i,
            vp: a,
            vq: e,
            vr: u,
            vs: t,
            vt: r
        };
    }), ukr = A3(nk, "hide_powered_by_hint", ru, A3(nk, "patient_facing_favicon_apple_url", ik(M$), A3(nk, "patient_facing_favicon_png_url", ik(M$), A3(nk, "patient_facing_favicon_ico_url", ik(M$), A3(nk, "patient_facing_logo_alt_text", M$, A3(nk, "patient_facing_logo_url", ik(M$), A3(nk, "brand_name", M$, au(ekr)))))))), akr = A2($A, ukr, au(cu)), ikr = F3(function(n, r, t) {
        return A4(aA, GQ(n), akr, t, pk(function(n) {
            return A2(bk, w([
                "whitelabel_settings"
            ]), fM(n));
        }(r)));
    }), ckr = F2(function(n, r) {
        var t = tB(n.jb);
        if (t.$) {
            var e = A2(RAr, n, r);
            if (e.$) return v(m(r, {
                dV: rC(B_)
            }), Qp);
            var u = e.a;
            return v(m(r, {
                dV: A_
            }), Uu(w([
                A3(tkr, r.g0, u, OAr),
                A3(ikr, r.g0, u, QAr)
            ])));
        }
        var a = t.a;
        return v(m(r, {
            dV: A_
        }), Uu(w([
            A3(tkr, r.g0, a, OAr),
            XS(A3(OT, 2, "accountPracticeId", a)),
            A3(ikr, r.g0, a, QAr)
        ])));
    }), okr = function(n) {
        return {
            $: 27,
            a: n
        };
    }, fkr = A2(eu, cu, A3(nk, "memberMessagingEnabled", ru, au(function(n) {
        return {
            tE: n
        };
    }))), skr = F3(function(n, r, t) {
        return A4(aA, n, fkr, t, pk(A2(bk, w([
            "practice-conversations-settings"
        ]), mk(r))));
    }), lkr = function(n) {
        var r = D_(n);
        return r.$ ? Qp : A3(skr, n, r.a, okr);
    }, dkr = function(n) {
        return {
            $: 10,
            a: n
        };
    }, vkr = Xn("start", function() {
        return nx;
    }), bkr = function(n) {
        var r = n.dV;
        if (3 === r.$) {
            var t = r.a, e = vkr(0);
            if (qCr(_c(n.yZ))) {
                var u = jAr(n.yZ), a = A2(xc, "", A2(ra, "company", e$(n.yZ.jb)));
                return mu(a) ? Uu(w([
                    A4(yYn, n.g0, ux(t), u, dkr),
                    e
                ])) : Uu(w([
                    A5(wYn, n.g0, ux(t), a, u, dkr),
                    e
                ]));
            }
            return e;
        }
        return Qp;
    }, mkr = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), pkr = F2(function(n, r) {
        return A2(bk, w([
            "signup_steps"
        ]), A2(a8n, n, r));
    }), $kr = F7(function(n, r, t, e, u, a, i) {
        var c = mu(u) ? g : w([
            A2(g_, "practitioner_id", u)
        ]), o = $(mu(e) ? g : w([
            A2(g_, "online_enrollment_id", e)
        ]), $(c, mu(a) ? g : w([
            A2(g_, "location_id", a)
        ])));
        return A4(aA, GQ(n), ek(t8n), i, A2($k, o, pk(A2(pkr, r, t))));
    }), gkr = F2(function(n, r) {
        var t, e, u, a, i = r.dV;
        if (3 === i.$) {
            var c = i.a, o = 2 === (a = r.fu).$ ? a.a : "", f = 3 === (u = r.f2).$ ? a1n(GYn(u.a)) : "", s = (e = wpr(e$(r.yZ.jb))).$ ? "" : e.a, l = (t = Ksr(e$(r.yZ.jb))).$ ? "" : t.a, d = v(qCr(_c(r.yZ)), mu(f));
            return v(r, d.a ? d.b ? XB : A7($kr, r.g0, ux(c), f, o, s, l, mkr(n)) : Qp);
        }
        return v(r, Qp);
    }), hkr = F3(function(n, r, t) {
        return A2(bb, function(r) {
            return It(A2(i1n, r.a, n));
        }, A3(I5n, n, r, t));
    }), ykr = F4(function(n, r, t, e) {
        var u = A3(hkr, n, r, t);
        return u.$ ? XB : A2(__, e, u.a);
    }), wkr = {
        $: 1
    }, xkr = {
        $: 2
    }, _kr = function(n) {
        var r = Uw(F_(n)) ? xkr : wkr;
        return 1 === n.$ ? Bc(m(n.a, {
            j: r
        })) : Dc(m(n.a, {
            j: r
        }));
    }, Ckr = F2(function(n, r) {
        return A2(Jfn, n, w([
            A2(rsn, "scope", r)
        ]));
    }), Akr = A2(__, pa, ti), kkr = function(n) {
        return A2(__, A2(xc, pa, n), mi);
    }, Ekr = function(n) {
        return kkr(It(A3(ia, "redirectTo", n.Ev, A2(xc, pa, A2(Op, t$, n.jb)))));
    }, qkr = Uu(w([
        H1n,
        A2(Nu, cu, Au(SCr))
    ])), Fkr = F2(function(n, r) {
        var t = r || !OP(n.g0) && !dsn(n.g0) ? Akr : Ekr(n.yZ), e = A2(Ckr, "Authentication - Session Not Valid", CAr(n.g0));
        return v(m(n, {
            g0: _kr(n.g0),
            AF: {
                Ao: _kr(n.AF.Ao),
                E: _kr(n.AF.E),
                ft: _kr(n.AF.ft),
                EU: _kr(n.AF.EU)
            },
            ek: It(n.yZ)
        }), Uu(w([
            t,
            qkr,
            e
        ])));
    }), jkr = F2(function(n, r) {
        return 1 === r.$ ? Bc(m(r.a, {
            j: n
        })) : Dc(m(r.a, {
            j: n
        }));
    }), Dkr = function(n) {
        if (n.$) return Ot;
        var r = n.a;
        return P$(r) ? L$(R$(r)) : Ot;
    }, Vkr = {
        $: 15
    }, Bkr = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Gkr = F3(function(n, r, t) {
        return A4(lM, n, B3n, t, pk(A2(bk, w([
            "auth",
            "refresh"
        ]), fM(r))));
    }), zkr = F2(function(n, r) {
        return 3 === r.$ ? A3(Gkr, n, ux(r.a), Bkr) : Qp;
    }), Skr = F4(function(n, r, t, e) {
        var u = 12e4, a = v(n, r);
        if (a.a.$ || a.b.$) return Qp;
        var i = a.a.a, c = a.b.a;
        return s(c - i, u) > 0 ? A2(Nu, function() {
            return Vkr;
        }, Up(c - i - u)) : A2(zkr, t, e);
    }), Tkr = Xn("setTokenPort", function(n) {
        return rx(w([
            v("key", tx(n.ij)),
            v("value", tx(n.y4))
        ]));
    }), Pkr = function(n) {
        return Tkr({
            ij: "accountToken",
            y4: n
        });
    }, Zkr = function(n) {
        return A2(xc, Qp, A2(Op, Pkr, OC(F_(n))));
    }, Mkr = F2(function(n, r) {
        var t = A2(jkr, n, r.hX), e = {
            Ao: A2(jkr, n, r.AF.Ao),
            E: A2(jkr, n, r.AF.E),
            ft: A2(jkr, n, r.AF.ft),
            EU: r.AF.EU
        }, u = A2(pAr, A2(xc, 0, r.Gy), A2(jkr, n, r.g0)), a = function(n) {
            if (n.$) return Ot;
            var r = n.a;
            if (P$(r)) {
                var t = Q$(w([
                    O$,
                    A2(eu, Sp, I$)
                ]));
                return L$(A2(d$, function(n) {
                    return 1e3 * n;
                }, A2(z$, A2(Iu, "iat", t), r)));
            }
            return Ot;
        }(n), i = Dkr(n);
        return v(m(r, {
            g0: u,
            AF: e,
            hX: t
        }), Uu(w([
            Zkr(u),
            A4(Skr, a, i, r.g0, r.dV)
        ])));
    }), Lkr = F2(function(n, r) {
        switch(r.$){
            case 3:
                var t = A2(Mkr, r.a, n);
                return v(t.a, t.b);
            case 2:
                return r.a.$ ? v(m(n, {
                    vn: kc
                }), Qp) : A2(Fkr, n, !1);
            default:
                return v(n, Qp);
        }
    }), Nkr = function(n) {
        return {
            $: 26,
            a: n
        };
    }, Hkr = F2(function(n) {
        var r = v(n.g9, n.dV);
        if (r.a.$ || 3 !== r.b.$) return Qp;
        var t = r.b.a;
        return oJn(t) && DB(t) ? A3(A0n, n.AF.EU, ux(t), Nkr) : Qp;
    }), Ikr = F2(function(n, r) {
        return CCr(r) ? 3 === n.dV.$ && i8(n) ? A2(__, pa, ui) : A2(Hkr, n, r) : ACr(r) ? A2(Hkr, n, r) : Qp;
    }), Okr = function(n) {
        var r = e$(n.jb), t = function(n) {
            return !n.$ && !mu(n.a);
        };
        return t(wpr(r)) || t(Ksr(r));
    }, Qkr = function(n) {
        return Kv(Jk(n));
    }, Rkr = Xn("rainforestPortLoad", tx), Ukr = A2(tu, function(n) {
        return n ? "sandbox" : "production";
    }, Rkr), Kkr = function(n) {
        return function(n) {
            switch(n.$){
                case 0:
                    return "top";
                case 1:
                    return "enroll-thanks";
                case 2:
                    return "not-found";
                case 3:
                    return "patient-documents";
                case 4:
                    return "thanks";
                case 5:
                    return "waitlist";
                case 6:
                    return "account.top";
                case 7:
                    return "booking.top";
                case 8:
                    return "checkout.top";
                case 9:
                    return "enroll.top";
                case 10:
                    return "signup.top";
                case 11:
                    return "style-guide.top";
                case 12:
                    return "account.appointments";
                case 13:
                    return "account.booking";
                case 14:
                    return "account.cart";
                case 15:
                    return "account.chat";
                case 16:
                    return "account.documents";
                case 17:
                    return "account.explore-services";
                case 18:
                    return "account.forbidden";
                case 19:
                    return "account.health-information";
                case 20:
                    return "account.invoices";
                case 21:
                    return "account.members";
                case 22:
                    return "account.memberships";
                case 23:
                    return "account.messaging";
                case 24:
                    return "account.not-found";
                case 25:
                    return "account.payment-sources";
                case 26:
                    return "account.practitioner-location";
                case 27:
                    return "account.session-expired";
                case 28:
                    return "booking.empty";
                case 29:
                    return "login.request";
                case 30:
                    return "login.select-patient";
                case 31:
                    return "login.verify-code";
                case 32:
                    return "style-guide.action-menu";
                case 33:
                    return "style-guide.activity-indicator";
                case 34:
                    return "style-guide.address-input";
                case 35:
                    return "style-guide.alerts";
                case 36:
                    return "style-guide.api-select";
                case 37:
                    return "style-guide.button";
                case 38:
                    return "style-guide.card";
                case 39:
                    return "style-guide.card-example";
                case 40:
                    return "style-guide.cart-icon";
                case 41:
                    return "style-guide.checkbox";
                case 42:
                    return "style-guide.code-sent-confirmation";
                case 43:
                    return "style-guide.filter-example";
                case 44:
                    return "style-guide.form-example";
                case 45:
                    return "style-guide.grid";
                case 46:
                    return "style-guide.input";
                case 47:
                    return "style-guide.insurance-info";
                case 48:
                    return "style-guide.modal";
                case 49:
                    return "style-guide.multi-form";
                case 50:
                    return "style-guide.phone-input";
                case 51:
                    return "style-guide.radio";
                case 52:
                    return "style-guide.searchable-select";
                case 53:
                    return "style-guide.segmented-control";
                case 54:
                    return "style-guide.select";
                case 55:
                    return "style-guide.table";
                case 56:
                    return "style-guide.tabs";
                case 57:
                    return "style-guide.tag";
                case 58:
                    return "style-guide.title-band";
                case 59:
                    return "style-guide.toggle";
                case 60:
                    return "style-guide.tooltip";
                case 61:
                    return "style-guide.typography";
                case 62:
                    return "account.token_-string";
                case 63:
                    return "bills.token_-string";
                case 64:
                    return "checkout.slug_-string.top";
                case 65:
                    return "signup.slug_-string.top";
                case 66:
                    return "account.cart.confirm-pay";
                case 67:
                    return "account.cart.confirmation";
                case 68:
                    return "account.messaging.chat";
                case 69:
                    return "appointments.appointment-id_-string.cancellation-policy";
                case 70:
                    return "signup.slug_-string.additional-details";
                case 71:
                    return "signup.slug_-string.confirmation";
                case 72:
                    return "signup.slug_-string.contacts";
                case 73:
                    return "signup.slug_-string.custom-details";
                case 74:
                    return "signup.slug_-string.location";
                case 75:
                    return "signup.slug_-string.members";
                case 76:
                    return "signup.slug_-string.membership";
                case 77:
                    return "signup.slug_-string.provider";
                case 78:
                    return "signup.slug_-string.thanks";
                case 79:
                    return "account.appointments.appointment-id_-string";
                case 80:
                    return "account.health-information.id_-string";
                case 81:
                    return "account.invoices.id_-string";
                case 82:
                    return "account.members.id_-string";
                case 83:
                    return "account.memberships.id_-string";
                case 84:
                    return "account.packages.id_-string";
                case 85:
                    return "account.payment-sources.id_-string";
                case 86:
                    return "account.appointments.appointment-id_-string.cancel";
                case 87:
                    return "account.appointments.appointment-id_-string.cancel-appointment";
                case 88:
                    return "account.appointments.appointment-id_-string.reschedule";
                case 89:
                    return "account.invoices.id_-string.payment";
                case 90:
                    return "account.members.id_-string.edit";
                case 91:
                    return "account.members.id_-string.emergency-contact";
                case 92:
                    return "account.memberships.id_-string.add-member";
                case 93:
                    return "account.memberships.id_-string.renew";
                case 94:
                    return "account.packages.id_-string.checkout";
                case 95:
                    return "account.payment-sources.id_-string.edit";
                case 96:
                    return "account.plans.id_-string.checkout";
                case 97:
                    return "booking.appointment-type-id_-string.location.booking-location-id_-string.date";
                case 98:
                    return "booking.appointment-type-id_-string.location.booking-location-id_-string.enter-info";
                case 99:
                    return "account.booking.appointment-type-id_-string.location.booking-location-id_-string.date";
                default:
                    return "account.booking.appointment-type-id_-string.location.booking-location-id_-string.enter-info";
            }
        }(n);
    }, Wkr = F2(function(n, r) {
        var t = r.ru, e = r.eZ, u = r.x6;
        return A2(Jfn, "Final Form Field Visited", w([
            esn(n),
            t4n(t),
            r4n(u4n(mb(e))),
            n4n(A2(fe, ", ", A2(Fu, NH(Vx(0)), e))),
            c5n(u)
        ]));
    }), Xkr = function(n) {
        var r = n.Fh, t = n.ru, e = n.eZ;
        return A2(Wkr, function(n) {
            switch(FCr(n)){
                case 1:
                    return "Style Guide";
                case 0:
                    return i4n;
                case 2:
                    return "Login";
                case 4:
                    return "Booking";
                case 5:
                    return "Appointments";
                case 3:
                    return Qfn;
                case 6:
                    return "Chat";
                default:
                    return "App";
            }
        }(r), {
            eZ: e,
            ru: t,
            x6: Kkr(r)
        });
    }, Ykr = F3(function(n, r, t) {
        var e = v(r, t);
        return 3 === e.a.$ && 3 === e.b.$ ? kCr(_c(n)) ? A2(__, pa, ui) : A2(__, A2(xc, pa, A2(Op, t$, n.jb)), _c(n)) : Qp;
    }), Jkr = F3(function(n, r, t) {
        var e = mb(u1n(r));
        return !e.$ && i(t, A2(i1n, e.a.a, n));
    }), nEr = F3(function(n, r, t) {
        var e = v(r, t);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.a.a, a = e.b.a, i = wc(n);
            if (i.$) return Qp;
            var c = i.a, o = GYn(u);
            return A3(Jkr, o, a, c) ? Qp : A3(c1n, o, a, e$(n.jb));
        }
        return Qp;
    }), rEr = Xn("setFaviconPort", function(n) {
        return rx(w([
            v("appleUrl", tx(n.ns)),
            v("icoUrl", tx(n.sj)),
            v("pngUrl", tx(n.vZ))
        ]));
    }), tEr = function(n) {
        var r = A2(xc, "", function(n) {
            return n.vr;
        }(n)), t = A2(xc, "", function(n) {
            return n.vq;
        }(n)), e = A2(xc, "", function(n) {
            return n.vp;
        }(n));
        return rEr({
            ns: e,
            sj: t,
            vZ: r
        });
    }, eEr = Xn("setTheme", tx), uEr = Xn("tabSelected", tx), aEr = {
        $: 18
    }, iEr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, cEr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, oEr = function(n) {
        switch(n){
            case 0:
            case 6:
                return za;
            case 1:
                return Pa;
            case 2:
                return Na;
            case 3:
                return Xa;
            case 4:
                return ja;
            case 5:
                return Da;
            case 7:
                return Ba;
            case 8:
                return Fa;
            case 9:
                return _a;
            default:
                return ga;
        }
    }, fEr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(dG, n.a, r.d$), e = t.a, u = t.b, a = t.c, i = function() {
                    if (a.$ || a.a.$) return v(Qp, g);
                    var n = a.a.a;
                    return n.$ ? v(Qp, g) : 1 === n.a.$ ? v(Qp, w([
                        aEr
                    ])) : v(A2(__, pa, oEr(n.a.a)), g);
                }(), c = i.a, o = i.b;
                return b(m(r, {
                    d$: e
                }), Uu(w([
                    A2(Wp, cEr, u),
                    c
                ])), o);
            case 1:
                return b(r, Qp, w([
                    aEr
                ]));
            case 2:
                return b(r, kkr(Ot), g);
            case 3:
                return b(m(r, {
                    ce: !0
                }), A2(jc, iEr, sG("sidebar-polish-close")), g);
            case 4:
                return b(m(r, {
                    ce: !1
                }), A2(jc, iEr, sG("sidebar-polish-open")), g);
            default:
                return b(r, Qp, g);
        }
    }), sEr = F3(function(n, r, t) {
        var e = {
            hr: !1,
            sl: n.dR + 1,
            iq: r,
            tO: t
        };
        return v(m(n, {
            cz: A2(Qt, e, n.cz),
            dR: n.dR + 1
        }), e);
    }), lEr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dEr = F2(function(n, r) {
        return m(n, {
            cz: A2(Fu, function(n) {
                return i(n.sl, r.sl) ? m(n, {
                    hr: !0
                }) : n;
            }, n.cz)
        });
    }), vEr = F2(function(n, r) {
        return m(n, {
            cz: A2(no, function(n) {
                return !i(n.sl, r.sl);
            }, n.cz)
        });
    }), bEr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(A2(dEr, r, t = n.a), function(n) {
                    return A2(Nu, function() {
                        return function(n) {
                            return {
                                $: 2,
                                a: n
                            };
                        }(n);
                    }, Up(300));
                }(t));
            case 2:
                var t;
                return v(A2(vEr, r, t = n.a), Qp);
            default:
                var e = A3(sEr, r, n.a, n.b);
                return v(e.a, function(n) {
                    return A2(Nu, function() {
                        return lEr(n);
                    }, Up(5e3));
                }(e.b));
        }
    }), mEr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pEr = F2(function(n, r) {
        switch(r.$){
            case 0:
                return Yt(Ern(r.a));
            case 1:
                return Yt(Frn);
            case 2:
                return Yt(qrn);
            case 3:
                return Yt(krn(r.a.F_));
            default:
                return A2(b$, mEr, n(r.b));
        }
    }), $Er = Drn({
        BF: (R8 = function(n) {
            return {
                $: 0,
                a: n
            };
        }, A2(nC, R8, pEr(te))),
        yZ: "/RELEASE"
    }), gEr = A2(xc, db, lb("[a-f0-9]{40}")), hEr = F2(function(n, r) {
        var t = r;
        return A2(lx, cu, function() {
            if (n.$) return v(t, Uu(w([
                $Er,
                t.iF ? Qp : Kp
            ])));
            if (n.a.$) return v(t, Qp);
            var r = n.a.a;
            return A2(S$, gEr, r) ? v(m(t, {
                iF: !i(DD(r), t.pM)
            }), Qp) : v(t, A2(VCr, "Fetching RELEASE Failed", pa));
        }());
    }), yEr = {
        $: 14
    }, wEr = function(n) {
        return e1n(n);
    }, xEr = function(n) {
        return A2(bb, function(r) {
            var t = r.a, e = r.b;
            return r1n(t) ? It(A2(t1n, t, e)) : A2(bb, xEr, zK(n));
        }, mb(n));
    }, _Er = F2(function(n, r) {
        var t = wEr(n);
        return A2(SS, function(n) {
            return i(n.a, r);
        }, t);
    }), CEr = F5(function(n, r, t, e, u) {
        if (A2(xc, !1, A2(Op, function(n) {
            return r1n(n.a);
        }, A3(m5n, n, r, e)))) return Qp;
        var a = A2(_Er, r, t);
        if (a.$) return A3(c1n, n, r, u);
        var i = xEr(Ae(A2(kP, a.a.b + 1, wEr(r))));
        return i.$ ? A3(c1n, n, r, u) : A2(__, u, A2(i1n, i.a.a, n));
    }), AEr = A2(__, pa, Ua), kEr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), EEr = F2(function(n, r) {
        return A2(kEr, n, r);
    }), qEr = F2(function(n, r) {
        return A2(bb, function(t) {
            var e = m(r, {
                fu: Lar(n)
            });
            return It(v(e, XS(A3(OT, 0, t, n))));
        }, A2(DAr, r.dV, r.yZ));
    }), FEr = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return v(t, Uu(w([
                    e,
                    A3(kAr, n.a, n.b, n.c)
                ])));
            case 1:
                var u = n.a, a = n.b, i = Vx(t.ld), c = A2(bEr, A2(EEr, u, i(a)), t.cz), o = c.b;
                return v(m(t, {
                    cz: c.a
                }), Uu(w([
                    e,
                    A2(Wp, tAr, o)
                ])));
            case 2:
                var f = A2(qEr, n.a, t);
                if (f.$) return v(t, e);
                var s = f.a, l = s.b, d = A2(gkr, !0, M = s.a);
                return v(d.a, Uu(w([
                    e,
                    d.b,
                    l
                ])));
            case 3:
                var b = A2(DAr, t.dV, t.yZ);
                return v(t, b.$ ? e : Uu(w([
                    e,
                    XS(A2(jZ, 0, b.a))
                ])));
            case 4:
                var p = A2(DAr, t.dV, t.yZ);
                return v(t, Uu(w(p.$ ? [
                    e,
                    A3(nEr, t.yZ, t.f2, t.FN)
                ] : [
                    e,
                    XS(A2(fAr, 0, p.a))
                ])));
            case 5:
                var $ = n.a, h = v(t.f2, t.FN);
                if (3 === h.a.$ && 3 === h.b.$) {
                    var y = h.b.a, x = GYn(h.a.a), _ = e$(t.yZ.jb);
                    return v(t, Uu(w([
                        e,
                        A5(CEr, x, y, $, t.yZ, _)
                    ])));
                }
                return v(t, e);
            case 6:
                return v(m(t, {
                    $9: n.a
                }), e);
            case 7:
                return v(m(t, {
                    hH: !0
                }), e);
            case 8:
                return v(m(t, {
                    gk: eAr
                }), e);
            case 9:
                var C = n.a, A = n.b, k = n.c;
                if (nE(C)) return v(t, e);
                var E = A2(Ek, "tabs", A), q = E.a, F = E.b, j = k ? function(n) {
                    return m(n, {
                        iC: 1
                    });
                }(q) : q;
                return v(m(t, {
                    eh: C,
                    dg: It(j)
                }), Uu(w([
                    e,
                    A2(Wp, sAr(!0), F)
                ])));
            case 10:
                return v(m(t, {
                    eh: g,
                    dg: Ot
                }), e);
            case 11:
                var D = n.a, V = function() {
                    var n = v(t.dg, A2(mcn, D, t.eh));
                    if (n.a.$ || n.b.$) return Qp;
                    var r = n.b.a;
                    return A2(Wp, sAr(!1), r);
                }();
                return v(t, Uu(w([
                    e,
                    V
                ])));
            case 15:
                if (3 === t.f2.$) {
                    var B = A2(gkr, !0, t);
                    return v(M = B.a, Uu(w([
                        e,
                        B.b
                    ])));
                }
                return v(t, e);
            case 12:
                var G = A2(qEr, n.a, t);
                if (G.$) return v(t, e);
                var z = G.a;
                return v(M = z.a, Uu(w([
                    e,
                    l = z.b
                ])));
            case 13:
                var S = n.a, T = A2(mAr, It(CAr(t.g0)), j_(S)), P = A2(Ckr, "Authentication - Sign In Complete", CAr(t.g0)), Z = A2(Mkr, S, t), M = Z.a, L = Z.b, N = function() {
                    var n = A2(ra, "redirectTo", e$(t.yZ.jb));
                    if (n.$) return M;
                    var r = function(n) {
                        var r = A2(se, "?", n);
                        if (r.b && r.b.b && !r.b.b.b) {
                            var t = r.a, e = A2(va, "patient", A2(va, "email", t$(r.b.a)));
                            return v(t, -2 === e.$ ? Ot : It(A2(fe, "&", A2(Fu, function(n) {
                                return n.a + "=" + n.b;
                            }, Ut(e)))));
                        }
                        return v(n, Ot);
                    }(n.a);
                    return m(M, {
                        ek: It({
                            BX: Ot,
                            Cc: t.yZ.Cc,
                            Ev: r.a,
                            v_: t.yZ.v_,
                            wn: t.yZ.wn,
                            jb: r.b
                        })
                    });
                }();
                return v(m(N, {
                    Ab: !1,
                    EA: Ot
                }), Uu(w([
                    L,
                    e,
                    A2(NAr, N.g0, t.yZ),
                    T,
                    P
                ])));
            case 16:
                return v(t, AEr);
            case 14:
                return A2(Fkr, t, !1);
            case 17:
                return v(m(t, {
                    g0: _kr(t.g0),
                    AF: {
                        Ao: _kr(t.AF.Ao),
                        E: _kr(t.AF.E),
                        ft: _kr(t.AF.ft),
                        EU: _kr(t.AF.EU)
                    }
                }), oon);
            case 18:
                return v(t, A2(Nu, cu, Au(yEr)));
            case 19:
                return v(m(t, {
                    g0: A2(jkr, S = n.a, t.g0),
                    Ab: !0,
                    AF: {
                        Ao: A2(jkr, S, t.AF.Ao),
                        E: A2(jkr, S, t.AF.E),
                        ft: A2(jkr, S, t.AF.ft),
                        EU: A2(jkr, S, t.AF.EU)
                    }
                }), Qp);
            case 21:
            case 22:
                return v(t, Qp);
            case 20:
                return v(t, A2(VCr, "Bad Gateway error", pa));
            case 23:
                return v(m(t, {
                    Z: n.a
                }), e);
            default:
                return v(m(t, {
                    EA: It({
                        b8: n.b,
                        Dd: n.a
                    })
                }), e);
        }
    }), jEr = F2(function(n, r) {
        return A3(de, FEr, v(r, Qp), n);
    }), DEr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                n: for(;;)switch(t.$){
                    case 2:
                        if (6 === t.a.$) {
                            var e = t.a, u = e.a, a = e.b, c = e.c;
                            return v(m(r, {
                                dV: t
                            }), A3(kAr, u, a, c));
                        }
                        break n;
                    case 3:
                        var o = t.a, f = i(r.Ca, It("production")) && !ix(o) ? 0 : 1, s = oJn(o) && AAr(o), l = m(r, {
                            os: A4(xAr, t, r.vu, r.f9, r.bp),
                            bY: s,
                            dQ: Qkr(o),
                            dV: t
                        }), d = Kw(r.g0) ? M1n(0) : A2(NAr, r.g0, r.yZ);
                        return gAr(v(l, Uu(w([
                            bkr(l),
                            A2(Nu, aAr, Yz),
                            d,
                            Ukr(f)
                        ]))));
                    default:
                        break n;
                }
                return v(m(r, {
                    dV: t
                }), Qp);
            case 1:
                var p = A2(bEr, n.a, r.cz), $ = p.b;
                return v(m(r, {
                    cz: p.a
                }), A2(Wp, tAr, $));
            case 3:
                return v(r, eEr(n.a));
            case 2:
                var g = n.a;
                return A2(ckr, r.yZ, function() {
                    if (g.$) return r;
                    var n = g.a.b;
                    return m(r, {
                        kn: A2(Hp, n, r.bp),
                        f9: n
                    });
                }());
            case 10:
                var h = n.a;
                l = m(r, {
                    f2: h
                });
                n: for(;;)switch(h.$){
                    case 2:
                        if (6 === h.a.$) {
                            var y = h.a;
                            return v(l, A3(kAr, u = y.a, a = y.b, c = y.c));
                        }
                        break n;
                    case 3:
                        return zAr(l);
                    default:
                        break n;
                }
                return v(l, Qp);
            case 11:
                var x = n.a, _ = n.b, C = (l = m(r, {
                    FN: _
                }), function() {
                    var n = l.f2;
                    if (3 === n.$) {
                        var r = function(n) {
                            return n.yZ;
                        }(GYn(n.a));
                        if (r.$) return v(l, Qp);
                        var t = r.a;
                        return v(m(l, {
                            FN: A_
                        }), irr(t));
                    }
                    return v(l, Qp);
                }());
                n: for(;;)switch(_.$){
                    case 3:
                        var A = _.a;
                        return d = function() {
                            var n = b(r.fu, x, r.f2);
                            r: for(;;){
                                if (2 === n.a.$) {
                                    if (n.b) {
                                        if (3 === n.c.$) return A4(ykr, GYn(n.c.a), A, r.yZ, e$(r.yZ.jb));
                                        break r;
                                    }
                                    return Qp;
                                }
                                break r;
                            }
                            return A3(nEr, l.yZ, l.f2, _);
                        }(), v(m(l, {
                            c1: !1
                        }), d);
                    case 2:
                        switch(_.a.$){
                            case 6:
                                var k = _.a;
                                return v(l, A3(kAr, u = k.a, a = k.b, c = k.c));
                            case 5:
                                if (422 === _.a.a) return Okr(l.yZ) ? v(m(l, {
                                    c1: !0
                                }), Qp) : C;
                                break n;
                            default:
                                break n;
                        }
                    default:
                        return v(l, Qp);
                }
                return C;
            case 4:
                if ((g = n.a).$) return v(m(r, {
                    gk: eAr,
                    fu: eAr
                }), A3(nEr, r.yZ, r.f2, r.FN));
                var E = g.a;
                n: for(; 1 === E.$;)switch(E.a){
                    case 0:
                        return l = m(r, (q = E.b).$ ? {
                            fu: eAr
                        } : {
                            fu: Lar(q.a)
                        }), A2(gkr, !1, l);
                    case 1:
                        var q = E.b, F = XS(A2(jZ, 1, BAr));
                        return v(m(r, q.$ ? {
                            gk: eAr
                        } : {
                            gk: Lar(q.a)
                        }), F);
                    default:
                        break n;
                }
                return v(r, Qp);
            case 5:
                if ((g = n.a).$) return v(r, Qp);
                if (2 !== (E = g.a).$ || E.a) return v(r, Qp);
                var j = E.b;
                return v(l = m(r, {
                    fu: eAr
                }), j ? A3(nEr, l.yZ, l.f2, l.FN) : Qp);
            case 6:
                var D = n.a, V = n.b;
                n: for(;;){
                    if (2 !== V.$) {
                        var B = (En = r.ek).$ ? r.yZ : En.a, G = 3 === V.$ ? It(kM(V.a)) : Ot;
                        return v(m(r, {
                            vn: V
                        }), Uu(w([
                            Zkr(D),
                            A3(Ykr, B, V, r.dV),
                            A3(IAr, D, r.dV, V),
                            lkr(r.AF.E),
                            A2(mAr, It(CAr(D)), G)
                        ])));
                    }
                    switch(V.a.$){
                        case 6:
                            var z = V.a;
                            return u = z.a, a = z.b, c = z.c, v(m(r, {
                                vn: kc
                            }), Uu(w([
                                A3(kAr, u, a, c),
                                qkr
                            ])));
                        case 0:
                            return A2(Fkr, m(r, {
                                vn: kc
                            }), !1);
                        case 5:
                            if (409 === V.a.a) return d = ACr(_c(r.yZ)) ? Uu(w([
                                Zkr(D),
                                kkr(A2(Op, t$, r.yZ.jb))
                            ])) : Qp, v(m(r, {
                                vn: kc,
                                ek: It(r.yZ)
                            }), d);
                            break n;
                        default:
                            break n;
                    }
                }
                return v(m(r, {
                    vn: kc
                }), Qp);
            case 7:
                var S = n.a;
                return gAr(v(m(r, {
                    os: A4(xAr, r.dV, S, r.f9, r.bp),
                    vu: S,
                    Gy: 3 === S.$ ? It(m_n(S.a)) : Ot
                }), Qp));
            case 27:
                l = m(r, {
                    fF: n.a
                });
                var T = CCr(_c(r.yZ)) && i8(l) ? A2(__, pa, ui) : Qp;
                return v(l, T);
            case 8:
                var P = (kn = _c(r.yZ), XS(A3(OT, 1, BAr, x_(kn))));
                return v(r, Uu(w([
                    A2(xc, Qp, A2(Op, Xkr, r.$9)),
                    P
                ])));
            case 9:
                var Z = (An = A2(DAr, r.dV, r.yZ)).$ ? Qp : XS(A2(fAr, 0, An.a));
                return v(m(r, {
                    hH: !1
                }), Z);
            case 12:
                var M = n.a, L = n.b, N = r.dg;
                if (N.$) return v(r, Qp);
                var H = A2(Qk, L, N.a), I = H.a, O = H.b, Q = H.c, R = Q.$ ? Qp : Q.a.$ ? cZn(Q.a.a) : M ? uEr(Q.a.a.sl) : Qp;
                return v(m(r, {
                    dg: It(I)
                }), Uu(w([
                    A2(Wp, sAr(M), O),
                    R
                ])));
            case 13:
                var U = A2(hEr, n.a, r.E2), K = U.b;
                return v(m(r, {
                    E2: U.a
                }), A2(Wp, Ec, K));
            case 14:
                var W = 3 === (Cn = r.dV).$ ? A3(EAr, r.g0, ux(Cn.a), cAr) : Qp;
                return v(m(r, {
                    g0: A2(pAr, A2(xc, 0, r.Gy), _Ar(r.g0)),
                    Ab: !1,
                    AF: {
                        Ao: _Ar(r.AF.Ao),
                        E: _Ar(r.AF.E),
                        ft: _Ar(r.AF.ft),
                        EU: _Ar(r.AF.EU)
                    },
                    EA: Ot
                }), Uu(w([
                    W,
                    qkr,
                    kkr(Ot)
                ])));
            case 17:
                var X = n.a, Y = Dkr(F_(r.g0)), J = r.De || qCr(_c(r.yZ)) ? Qp : A4(Skr, It(X), Y, r.g0, r.dV);
                return v(r, J);
            case 15:
                return v(r, A2(zkr, r.g0, r.dV));
            case 16:
                var nn = n.a, rn = A2(Ckr, "Authentication - Session Refreshed", CAr(r.g0)), tn = A2(Lkr, r, nn);
                return v(l = tn.a, Uu(w([
                    d = tn.b,
                    rn
                ])));
            case 21:
                var en = A2(Lkr, r, nn = n.a);
                return d = en.b, v(m(l = en.a, {
                    e_: !1
                }), Uu(w([
                    d,
                    A2(NAr, l.g0, r.yZ)
                ])));
            case 19:
                var un = A2(fEr, n.a, r.dQ), an = un.a, cn = un.b, on = A2(jEr, un.c, r), fn = on.b;
                return v(m(l = on.a, {
                    dQ: an
                }), Uu(w([
                    A2(Wp, oAr, cn),
                    fn
                ])));
            case 20:
                var sn = n.a;
                n: for(;;)switch(sn.$){
                    case 3:
                        var ln = sn.a;
                        return v(m(r, {
                            au: sn
                        }), tEr(ln));
                    case 2:
                        if (6 === sn.a.$) {
                            var dn = sn.a;
                            return u = dn.a, a = dn.b, c = dn.c, v(m(r, {
                                au: sn
                            }), A3(kAr, u, a, c));
                        }
                        break n;
                    default:
                        break n;
                }
                return v(m(r, {
                    au: sn
                }), Qp);
            case 24:
                return ACr(_c(r.yZ)) ? A2(Fkr, r, !0) : v(r, Qp);
            case 18:
                return v(m(r, {
                    bp: X = n.a,
                    kn: A2(Hp, r.f9, X)
                }), Qp);
            case 25:
                var vn = A2(xkn, n.a, r.CL), bn = vn.a, mn = vn.b, pn = vn.c, $n = function() {
                    if (pn.$ || pn.a.$) return v(r, Qp);
                    var n = pn.a.a;
                    return v(m(r, {
                        g0: A2(pAr, n, r.g0),
                        ld: $Ar(n),
                        Gy: It(n)
                    }), XS(A3(OT, 3, "hint-language", nb(n))));
                }(), gn = $n.b;
                return v(m($n.a, {
                    CL: bn
                }), Uu(w([
                    gn,
                    A2(Wp, iAr, mn)
                ])));
            case 26:
                return v(m(r, {
                    g9: n.a
                }), Qp);
            case 28:
                var hn = (_n = B = n.a, A3(tu, Op(_c), xc(Ku), _u(_n)));
                return v(r, A2(Ikr, r, hn));
            case 29:
                var yn = _c(r.yZ);
                return d = kCr(yn) || function(n) {
                    return i(n, ti) || i(n, Va) || i(n, Ua);
                }(yn) ? Qp : Ekr(r.yZ), v(m(r, {
                    g0: _Ar(r.g0),
                    AF: {
                        Ao: _Ar(r.AF.Ao),
                        E: _Ar(r.AF.E),
                        ft: _Ar(r.AF.ft),
                        EU: _Ar(r.AF.EU)
                    }
                }), d);
            case 30:
                return v(r, Qp);
            case 22:
                if (g = n.a, Kw(r.g0) && !r.e_) {
                    if (g.$) return v(r, Qp);
                    var wn = g.a, xn = r.dV;
                    return 3 === xn.$ ? (o = xn.a, v(m(r, {
                        e_: !0
                    }), A4(qAr, r.g0, ux(o), It(wn), uAr))) : v(r, Qp);
                }
                return v(r, Qp);
            default:
                return Kw(r.g0) ? v(r, d2n(1)) : v(r, Qp);
        }
        var _n, Cn, An, kn, En;
    }), VEr = F2(function(n, r) {
        var t = v(n, r);
        n: for(;;)switch(t.a.$){
            case 0:
                if (t.b.$) break n;
                return A2(xCr.mx.Gv, t.a.a, t.b.a);
            case 1:
                if (1 === t.b.$) return A2(xCr.hQ.Gv, t.a.a, t.b.a);
                break n;
            case 2:
                if (2 === t.b.$) return A2(xCr.iG.Gv, t.a.a, t.b.a);
                break n;
            case 3:
                if (3 === t.b.$) return A2(xCr.fx.Gv, t.a.a, t.b.a);
                break n;
            case 4:
                if (4 === t.b.$) return A2(xCr.km.Gv, t.a.a, t.b.a);
                break n;
            case 5:
                if (5 === t.b.$) return A2(xCr.t.Gv, t.a.a, t.b.a);
                break n;
            case 6:
                if (6 === t.b.$) return A2(xCr.gZ.Gv, t.a.a, t.b.a);
                break n;
            case 7:
                if (7 === t.b.$) return A2(xCr.hd.Gv, t.a.a, t.b.a);
                break n;
            case 8:
                if (8 === t.b.$) return A2(xCr.hp.Gv, t.a.a, t.b.a);
                break n;
            case 9:
                if (9 === t.b.$) return A2(xCr.hR.Gv, t.a.a, t.b.a);
                break n;
            case 10:
                if (10 === t.b.$) return A2(xCr.jJ.Gv, t.a.a, t.b.a);
                break n;
            case 11:
                if (11 === t.b.$) return A2(xCr.kd.Gv, t.a.a, t.b.a);
                break n;
            case 12:
                if (12 === t.b.$) return A2(xCr.gl.Gv, t.a.a, t.b.a);
                break n;
            case 13:
                if (13 === t.b.$) return A2(xCr.gq.Gv, t.a.a, t.b.a);
                break n;
            case 14:
                if (14 === t.b.$) return A2(xCr.gt.Gv, t.a.a, t.b.a);
                break n;
            case 15:
                if (15 === t.b.$) return A2(xCr.gw.Gv, t.a.a, t.b.a);
                break n;
            case 16:
                if (16 === t.b.$) return A2(xCr.gx.Gv, t.a.a, t.b.a);
                break n;
            case 17:
                if (17 === t.b.$) return A2(xCr.gy.Gv, t.a.a, t.b.a);
                break n;
            case 18:
                if (18 === t.b.$) return A2(xCr.gz.Gv, t.a.a, t.b.a);
                break n;
            case 19:
                if (19 === t.b.$) return A2(xCr.gA.Gv, t.a.a, t.b.a);
                break n;
            case 20:
                if (20 === t.b.$) return A2(xCr.gC.Gv, t.a.a, t.b.a);
                break n;
            case 21:
                if (21 === t.b.$) return A2(xCr.gF.Gv, t.a.a, t.b.a);
                break n;
            case 22:
                if (22 === t.b.$) return A2(xCr.gJ.Gv, t.a.a, t.b.a);
                break n;
            case 23:
                if (23 === t.b.$) return A2(xCr.gN.Gv, t.a.a, t.b.a);
                break n;
            case 24:
                if (24 === t.b.$) return A2(xCr.gP.Gv, t.a.a, t.b.a);
                break n;
            case 25:
                if (25 === t.b.$) return A2(xCr.gS.Gv, t.a.a, t.b.a);
                break n;
            case 26:
                if (26 === t.b.$) return A2(xCr.gW.Gv, t.a.a, t.b.a);
                break n;
            case 27:
                if (27 === t.b.$) return A2(xCr.gX.Gv, t.a.a, t.b.a);
                break n;
            case 28:
                if (28 === t.b.$) return A2(xCr.hc.Gv, t.a.a, t.b.a);
                break n;
            case 29:
                if (29 === t.b.$) return A2(xCr.iv.Gv, t.a.a, t.b.a);
                break n;
            case 30:
                if (30 === t.b.$) return A2(xCr.iw.Gv, t.a.a, t.b.a);
                break n;
            case 31:
                if (31 === t.b.$) return A2(xCr.ix.Gv, t.a.a, t.b.a);
                break n;
            case 32:
                if (32 === t.b.$) return A2(xCr.jM.Gv, t.a.a, t.b.a);
                break n;
            case 33:
                if (33 === t.b.$) return A2(xCr.jN.Gv, t.a.a, t.b.a);
                break n;
            case 34:
                if (34 === t.b.$) return A2(xCr.jO.Gv, t.a.a, t.b.a);
                break n;
            case 35:
                if (35 === t.b.$) return A2(xCr.jP.Gv, t.a.a, t.b.a);
                break n;
            case 36:
                if (36 === t.b.$) return A2(xCr.jQ.Gv, t.a.a, t.b.a);
                break n;
            case 37:
                if (37 === t.b.$) return A2(xCr.jR.Gv, t.a.a, t.b.a);
                break n;
            case 38:
                if (38 === t.b.$) return A2(xCr.jS.Gv, t.a.a, t.b.a);
                break n;
            case 39:
                if (39 === t.b.$) return A2(xCr.jT.Gv, t.a.a, t.b.a);
                break n;
            case 40:
                if (40 === t.b.$) return A2(xCr.jU.Gv, t.a.a, t.b.a);
                break n;
            case 41:
                if (41 === t.b.$) return A2(xCr.jV.Gv, t.a.a, t.b.a);
                break n;
            case 42:
                if (42 === t.b.$) return A2(xCr.jW.Gv, t.a.a, t.b.a);
                break n;
            case 43:
                if (43 === t.b.$) return A2(xCr.jX.Gv, t.a.a, t.b.a);
                break n;
            case 44:
                if (44 === t.b.$) return A2(xCr.jY.Gv, t.a.a, t.b.a);
                break n;
            case 45:
                if (45 === t.b.$) return A2(xCr.jZ.Gv, t.a.a, t.b.a);
                break n;
            case 46:
                if (46 === t.b.$) return A2(xCr.j_.Gv, t.a.a, t.b.a);
                break n;
            case 47:
                if (47 === t.b.$) return A2(xCr.j$.Gv, t.a.a, t.b.a);
                break n;
            case 48:
                if (48 === t.b.$) return A2(xCr.j0.Gv, t.a.a, t.b.a);
                break n;
            case 49:
                if (49 === t.b.$) return A2(xCr.j1.Gv, t.a.a, t.b.a);
                break n;
            case 50:
                if (50 === t.b.$) return A2(xCr.j2.Gv, t.a.a, t.b.a);
                break n;
            case 51:
                if (51 === t.b.$) return A2(xCr.j3.Gv, t.a.a, t.b.a);
                break n;
            case 52:
                if (52 === t.b.$) return A2(xCr.j4.Gv, t.a.a, t.b.a);
                break n;
            case 53:
                if (53 === t.b.$) return A2(xCr.j5.Gv, t.a.a, t.b.a);
                break n;
            case 54:
                if (54 === t.b.$) return A2(xCr.j6.Gv, t.a.a, t.b.a);
                break n;
            case 55:
                if (55 === t.b.$) return A2(xCr.j7.Gv, t.a.a, t.b.a);
                break n;
            case 56:
                if (56 === t.b.$) return A2(xCr.j8.Gv, t.a.a, t.b.a);
                break n;
            case 57:
                if (57 === t.b.$) return A2(xCr.j9.Gv, t.a.a, t.b.a);
                break n;
            case 58:
                if (58 === t.b.$) return A2(xCr.ka.Gv, t.a.a, t.b.a);
                break n;
            case 59:
                if (59 === t.b.$) return A2(xCr.kb.Gv, t.a.a, t.b.a);
                break n;
            case 60:
                if (60 === t.b.$) return A2(xCr.kc.Gv, t.a.a, t.b.a);
                break n;
            case 61:
                if (61 === t.b.$) return A2(xCr.ke.Gv, t.a.a, t.b.a);
                break n;
            case 62:
                if (62 === t.b.$) return A2(xCr.gY.Gv, t.a.a, t.b.a);
                break n;
            case 63:
                if (63 === t.b.$) return A2(xCr.g6.Gv, t.a.a, t.b.a);
                break n;
            case 64:
                if (64 === t.b.$) return A2(xCr.ho.Gv, t.a.a, t.b.a);
                break n;
            case 65:
                if (65 === t.b.$) return A2(xCr.jI.Gv, t.a.a, t.b.a);
                break n;
            case 66:
                if (66 === t.b.$) return A2(xCr.gu.Gv, t.a.a, t.b.a);
                break n;
            case 67:
                if (67 === t.b.$) return A2(xCr.gv.Gv, t.a.a, t.b.a);
                break n;
            case 68:
                if (68 === t.b.$) return A2(xCr.gO.Gv, t.a.a, t.b.a);
                break n;
            case 69:
                if (69 === t.b.$) return A2(xCr.g3.Gv, t.a.a, t.b.a);
                break n;
            case 70:
                if (70 === t.b.$) return A2(xCr.jz.Gv, t.a.a, t.b.a);
                break n;
            case 71:
                if (71 === t.b.$) return A2(xCr.jA.Gv, t.a.a, t.b.a);
                break n;
            case 72:
                if (72 === t.b.$) return A2(xCr.jB.Gv, t.a.a, t.b.a);
                break n;
            case 73:
                if (73 === t.b.$) return A2(xCr.jC.Gv, t.a.a, t.b.a);
                break n;
            case 74:
                if (74 === t.b.$) return A2(xCr.jD.Gv, t.a.a, t.b.a);
                break n;
            case 75:
                if (75 === t.b.$) return A2(xCr.jE.Gv, t.a.a, t.b.a);
                break n;
            case 76:
                if (76 === t.b.$) return A2(xCr.jF.Gv, t.a.a, t.b.a);
                break n;
            case 77:
                if (77 === t.b.$) return A2(xCr.jG.Gv, t.a.a, t.b.a);
                break n;
            case 78:
                if (78 === t.b.$) return A2(xCr.jH.Gv, t.a.a, t.b.a);
                break n;
            case 79:
                if (79 === t.b.$) return A2(xCr.gm.Gv, t.a.a, t.b.a);
                break n;
            case 80:
                if (80 === t.b.$) return A2(xCr.gB.Gv, t.a.a, t.b.a);
                break n;
            case 81:
                if (81 === t.b.$) return A2(xCr.gD.Gv, t.a.a, t.b.a);
                break n;
            case 82:
                if (82 === t.b.$) return A2(xCr.gG.Gv, t.a.a, t.b.a);
                break n;
            case 83:
                if (83 === t.b.$) return A2(xCr.gK.Gv, t.a.a, t.b.a);
                break n;
            case 84:
                if (84 === t.b.$) return A2(xCr.gQ.Gv, t.a.a, t.b.a);
                break n;
            case 85:
                if (85 === t.b.$) return A2(xCr.gT.Gv, t.a.a, t.b.a);
                break n;
            case 86:
                if (86 === t.b.$) return A2(xCr.gn.Gv, t.a.a, t.b.a);
                break n;
            case 87:
                if (87 === t.b.$) return A2(xCr.go.Gv, t.a.a, t.b.a);
                break n;
            case 88:
                if (88 === t.b.$) return A2(xCr.gp.Gv, t.a.a, t.b.a);
                break n;
            case 89:
                if (89 === t.b.$) return A2(xCr.gE.Gv, t.a.a, t.b.a);
                break n;
            case 90:
                if (90 === t.b.$) return A2(xCr.gH.Gv, t.a.a, t.b.a);
                break n;
            case 91:
                if (91 === t.b.$) return A2(xCr.gI.Gv, t.a.a, t.b.a);
                break n;
            case 92:
                if (92 === t.b.$) return A2(xCr.gL.Gv, t.a.a, t.b.a);
                break n;
            case 93:
                if (93 === t.b.$) return A2(xCr.gM.Gv, t.a.a, t.b.a);
                break n;
            case 94:
                if (94 === t.b.$) return A2(xCr.gR.Gv, t.a.a, t.b.a);
                break n;
            case 95:
                if (95 === t.b.$) return A2(xCr.gU.Gv, t.a.a, t.b.a);
                break n;
            case 96:
                if (96 === t.b.$) return A2(xCr.gV.Gv, t.a.a, t.b.a);
                break n;
            case 97:
                if (97 === t.b.$) return A2(xCr.ha.Gv, t.a.a, t.b.a);
                break n;
            case 98:
                if (98 === t.b.$) return A2(xCr.hb.Gv, t.a.a, t.b.a);
                break n;
            case 99:
                if (99 === t.b.$) return A2(xCr.gr.Gv, t.a.a, t.b.a);
                break n;
            default:
                if (100 === t.b.$) return A2(xCr.gs.Gv, t.a.a, t.b.a);
                break n;
        }
        return b(r, Qp, g);
    }), BEr = Xn("updateTitle", tx), GEr = function(n) {
        return n.iF;
    }, zEr = F2(function(n, r) {
        var t = e$(r.yZ.jb), e = e$(n.jb), u = r.c1 && Okr(n) && i(wpr(e), wpr(t)) && i(Ksr(e), Ksr(t));
        return v(m(r, {
            c1: u,
            FN: r.c1 && !u ? kc : r.FN,
            yZ: n
        }), Uu(w([
            GEr(r.E2) ? wcr : Qp
        ])));
    }), SEr = function(n) {
        return KCr(n).GB(0);
    }, TEr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = r.Fz, u = _c(e.yZ), a = GCr(t), c = a.a, o = a.b, f = A2(zEr, c, e), s = f.a, l = f.b, d = _c(c), p = i(d, u), $ = function() {
                    if (p) return b(A2(JCr, r.bc, s), r.fb, Qp);
                    var n = A2(_Cr, d, s);
                    return b(v(n.a, n.b), jCr(d), A2(Nu, function() {
                        return YCr;
                    }, A2(rAr, 0, 0)));
                }(), g = $.a, h = g.b, y = $.b, x = $.c, _ = SEr(k = g.a).yx;
                return v(m(r, {
                    fb: y,
                    bc: k,
                    Fz: A2(nAr, k, s)
                }), Uu(w([
                    A2(Wp, Ru, l),
                    A2(Wp, Qu, h),
                    o,
                    BEr(_),
                    x
                ])));
            case 2:
                var C = A2(DEr, n.a, r.Fz), A = (l = C.b, A2(JCr, r.bc, s = C.a));
                return h = A.b, v(m(r, {
                    bc: k = A.a,
                    Fz: s
                }), Uu(w([
                    A2(Wp, Ru, l),
                    A2(Wp, Qu, h)
                ])));
            case 3:
                var k, E = A2(VEr, n.a, r.bc), q = (h = E.b, A2(jEr, E.c, A2(nAr, k = E.a, r.Fz)));
                return s = q.a, l = q.b, _ = SEr(k).yx, v(m(r, {
                    bc: k,
                    Fz: s
                }), Uu(w([
                    A2(Wp, Qu, h),
                    A2(Wp, Ru, l),
                    BEr(_)
                ])));
            default:
                return v(r, Qp);
        }
    }), PEr = function(n) {
        switch(n){
            case 0:
                return "alert--info";
            case 1:
                return "alert--error";
            case 2:
                return "alert--warning";
            default:
                return "alert--success";
        }
    }, ZEr = function(n) {
        switch(n){
            case 0:
                return 5;
            case 1:
            case 2:
                return 3;
            default:
                return 1;
        }
    }, MEr = function(n) {
        return v(oe(n.sl), A2(zx, w([
            Gx("alert"),
            Gx(PEr(n.iq)),
            Oq(w([
                v("alert--closing", n.hr)
            ]))
        ]), w([
            A2(zx, g, w([
                A2(Mx, w([
                    Gx("mr-3")
                ]), w([
                    A2(Tq, g, ZEr(n.iq))
                ])),
                _d(n.tO)
            ])),
            A2(sF, w([
                qE(lEr(n))
            ]), w([
                A2(Tq, g, 2)
            ]))
        ])));
    }, LEr = function(n) {
        var r;
        return A2(c_, tAr, (r = n, A3(gz, "div", w([
            Gx("alerts-wrapper")
        ]), A2(Fu, MEr, r.cz))));
    }, NEr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, HEr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), IEr = HEr, OEr = {
        $: 6
    }, QEr = function(n) {
        var r = A2(no, function(n) {
            return !i(n, OEr);
        }, n);
        return r.b ? r.b.b ? function(n) {
            return {
                $: 4,
                a: n
            };
        }(r) : r.a : OEr;
    }, REr = function(n) {
        return n.se;
    }, UEr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, KEr = UEr, WEr = function(n) {
        return UEr(A2(zx, w([
            Gx("footer-language-portal min-w-0")
        ]), w([
            n
        ])));
    }, XEr = function(n) {
        return n.xf.AY;
    }, YEr = F2(function(n, r) {
        return 3 === r.$ && ix(r.a) ? A2(zx, w([
            Gx("sandbox-alert")
        ]), w([
            _d(n(XEr))
        ])) : _d("");
    }), JEr = A2(de, F2(function(n, r) {
        return m(r, {
            kl: n
        });
    }), {
        kl: 0
    }), nqr = F2(function(n, r) {
        var t = "https://www.hint.com/?utm_campaign=" + r + "&utm_source=" + n + "&utm_medium=application";
        return A2(zx, g, w([
            A2(uJ, w([
                iJ("https://cdn2.hubspot.net/hubfs/2562809/production-app/web/logo-mark.svg"),
                Gx("icon -mt-1")
            ]), g),
            A2(PE, w([
                nF,
                VG
            ]), w([
                _d("Powered by "),
                A2(EV, w([
                    Sen,
                    yV(t),
                    xV
                ]), w([
                    _d("Hint")
                ]))
            ]))
        ]));
    }), rqr = A2(PE, w([
        nF,
        VG
    ]), w([
        A2(EV, w([
            Sen,
            yV("https://www.hint.com/privacy"),
            xV
        ]), w([
            _d("Privacy Policy")
        ]))
    ])), tqr = F2(function(n, r) {
        return function(t) {
            return $(r(t), eb(n));
        };
    }), eqr = F2(function(n, r) {
        return function(t) {
            return $(eb(n), r(t));
        };
    }), uqr = function(n) {
        return n.fN.z_;
    }, aqr = function(n) {
        return n.fN.CN;
    }, iqr = function(n) {
        return n.fN.ES;
    }, cqr = function(n) {
        return n.fN.Ga;
    }, oqr = function(n) {
        return n.wG;
    }, fqr = F2(function(n, r) {
        return r.xI(n);
    }), sqr = function(n) {
        return n.xJ;
    }, lqr = function(n) {
        var r = function(n) {
            return n.b.p5;
        }(n);
        return r.$ ? "" : ygr(r.a);
    }, dqr = F2(function(n, r) {
        return A2(f_, w([
            VG,
            uF(xD),
            nF
        ]), w([
            A2(Mx, g, w([
                _d(n(fqr(ax(r)))),
                _d(" ")
            ])),
            A2(EV, w([
                yV(lqr(r)),
                xV,
                Sen
            ]), w([
                _d(n(sqr))
            ]))
        ]));
    }), vqr = F2(function(n, r) {
        switch(r.$){
            case 0:
                return function(n) {
                    return A2(zx, g, _K(A2(f_, w([
                        nF,
                        VG
                    ]), w([
                        A2(PE, g, w([
                            _d(n(A2(tqr, " ", aqr)))
                        ])),
                        A2(PE, g, w([
                            A2(EV, w([
                                Sen,
                                yV("https://policies.google.com/privacy"),
                                xV
                            ]), w([
                                _d(n(iqr))
                            ]))
                        ])),
                        A2(PE, g, w([
                            _d(n(A2(tqr, " ", A2(eqr, " ", uqr))))
                        ])),
                        A2(PE, w([
                            Hx(w([
                                Gx("inline-block")
                            ]))
                        ]), w([
                            A2(EV, w([
                                Sen,
                                yV("https://policies.google.com/terms"),
                                xV
                            ]), w([
                                _d(n(cqr))
                            ]))
                        ])),
                        A2(PE, g, w([
                            _d(n(oqr))
                        ]))
                    ]))));
                }(n);
            case 1:
                return A2(nqr, r.a, r.b);
            case 2:
                return A2(dqr, n, r.a);
            case 3:
                return r.a;
            case 4:
                var t = r.a;
                return A2(zx, w([
                    Gx("flex items-center justify-between space-x-4")
                ]), A2(Fu, vqr(n), t));
            case 5:
                return rqr;
            default:
                return _d("");
        }
    }), bqr = F3(function(n, r, t) {
        var e = JEr(r);
        return A2(zx, w([
            Gx("footer"),
            Gx(1 === e.kl ? "text-center items-center" : "text-left")
        ]), A2(Fu, vqr(n), t));
    }), mqr = {
        $: 8
    }, pqr = F2(function(n, r) {
        var t = v(n, r);
        if (3 === t.a.$ && 3 === t.b.$) {
            var e = t.b.a;
            return Jk(t.a.a) || nE(tG(e)) ? vE : A2(zx, w([
                Gx("fixed right-6 bottom-24 md:bottom-8")
            ]), w([
                A2(EV, w([
                    yV(x_(_a)),
                    qN,
                    mqr
                ]), w([
                    A2(Tq, w([
                        pJn
                    ]), 28)
                ]))
            ]));
        }
        return vE;
    }), $qr = cr("header"), gqr = F3(function(n, r, t) {
        return 3 === n.$ ? A2($qr, w([
            Gx(1 === t ? "header header--app" : "header h-24")
        ]), w([
            A2(zx, w([
                Gx("header__container app-container app-account-container justify-between")
            ]), w([
                r
            ]))
        ])) : vE;
    }), hqr = F4(function(n, r, t, e) {
        var u = v(n, r);
        if (1 === u.a.$) {
            if (u.b.$) return A2(zx, w([
                Gx("header__logo")
            ]), w([
                _d(t)
            ]));
            var a = u.b.a;
            return A2(zx, w([
                Gx("header__logo")
            ]), w([
                A2(uJ, w([
                    iJ(a),
                    tJ(e)
                ]), g)
            ]));
        }
        return u.b.$ ? A2(UD, w([
            oV(u.a.a),
            Gx("header__logo")
        ]), w([
            _d(t)
        ])) : (a = u.b.a, A2(UD, w([
            oV(u.a.a),
            Gx("header__logo")
        ]), w([
            A2(uJ, w([
                iJ(a),
                tJ(e)
            ]), g)
        ])));
    }), yqr = function(n) {
        return n.vs;
    }, wqr = function(n) {
        return n.vt;
    }, xqr = F2(function(n, r) {
        var t = v(n, r);
        n: for(;;){
            r: for(;;)switch(t.a.$){
                case 3:
                    switch(t.b.$){
                        case 3:
                            var e = t.a.a, u = t.b.a;
                            return A4(hqr, pgr(e), wqr(u), ax(e), yqr(u));
                        case 1:
                            break n;
                        default:
                            break r;
                    }
                case 1:
                    return Lx(w([
                        Uq
                    ]));
                default:
                    if (1 === t.b.$) break n;
                    break r;
            }
            return A4(hqr, It("http://www.hint.com"), It("https://cdn2.hubspot.net/hubfs/2562809/production-app/web/logo-mark.svg"), "Hint Health", "Hint Health logo");
        }
        return Lx(w([
            Uq
        ]));
    }), _qr = F2(function(n, r) {
        return A2($qr, w([
            Gx("header")
        ]), w([
            A2(zx, w([
                Gx("header__container app-container")
            ]), w([
                A2(xqr, n, r)
            ]))
        ]));
    }), Cqr = F5(function(n, r, t, e, u) {
        var a = 3 === r.$ ? ux(r.a) : "", i = 3 === t.$ && REr(t.a);
        return w([
            A2(zx, w([
                Gx("layout layout--app")
            ]), w([
                A2(YEr, n, r),
                A2(_qr, r, t),
                A2(zx, w([
                    Gx("main main--app")
                ]), w([
                    A2(zx, w([
                        Gx("app-container my-8")
                    ]), u)
                ])),
                A3(bqr, n, w([
                    1
                ]), w([
                    i ? OEr : A2(IEr, a, "member_app_portal")
                ]))
            ]))
        ]);
    }), Aqr = {
        $: 5
    }, kqr = function(n) {
        var r, t = !n.CF && 1 === n.EF, e = A2(xc, !1, A2(Op, REr, JF(n.GJ))), u = function() {
            var r = v(e, JF(n.EG));
            return r.a || r.b.$ ? OEr : A2(IEr, ux(r.b.a), "member_app_portal");
        }();
        return w([
            A2(zx, w([
                Gx(t ? "layout layout--app" : "layout")
            ]), w([
                A2(YEr, n.mA, n.EG),
                n.B4,
                A2(zx, w([
                    Gx("main main--app")
                ]), w(t ? [
                    A2(zx, w([
                        Gx("app-container app-account-container mt-0 px-4 md:my-8 md:mt-8 md:px-0")
                    ]), A2(a_r, w([
                        e_r(n.yx)
                    ]), n.g8))
                ] : [
                    A2(zx, w([
                        Gx("app-container my-4 md:my-8 px-6 md:px-12")
                    ]), n.E6 && !n.CF ? A2(Qt, (r = n.yx, A2(CF, w([
                        uF(yE),
                        zX,
                        uE(aF)
                    ]), w([
                        _d(r)
                    ]))), n.g8) : n.g8)
                ])),
                A3(bqr, n.mA, w([
                    1
                ]), w([
                    QEr(w([
                        u,
                        e ? OEr : Aqr,
                        1 === n.EF ? WEr(n.CL) : KEr(n.CL)
                    ]))
                ]))
            ]))
        ]);
    }, Eqr = F2(function(n, r) {
        return 1 === n ? function(n) {
            return A2($qr, w([
                Gx("header header--app")
            ]), w([
                A2(zx, w([
                    Gx("header__container app-container app-account-container justify-between")
                ]), w([
                    n
                ]))
            ]));
        }(r) : A2($qr, w([
            Gx("header flex justify-center")
        ]), w([
            A2(zx, w([
                Gx("booking-navbar")
            ]), w([
                r
            ]))
        ]));
    }), qqr = F3(function(n, r, t) {
        return A2($qr, w([
            Gx("header bg-primary-100 border-b-0")
        ]), w([
            A2(zx, w([
                Gx("header__container app-container md:px-12")
            ]), w([
                A2(BE, w([
                    xN(JI)
                ]), A2(Qt, A2(lE, w([
                    TE(3)
                ]), g), A2(Qt, A2(lE, w([
                    TE(6)
                ]), w([
                    A2(zx, w([
                        Gx("flex justify-center")
                    ]), w([
                        A2(xqr, n, r)
                    ]))
                ])), function() {
                    if (t.$) return g;
                    var n = t.a;
                    return w([
                        A2(lE, w([
                            TE(3)
                        ]), w([
                            n
                        ]))
                    ]);
                }())))
            ]))
        ]));
    }), Fqr = F5(function(n, r, t, e, u) {
        return ECr(_c(t)) ? A3(qqr, n, r, Ot) : A2(Eqr, u, e);
    }), jqr = F8(function(n, r, t, e, u, a, i, c) {
        var o = ECr(_c(u));
        return kqr({
            g8: a,
            B4: A5(Fqr, t, e, u, i, c),
            CF: o,
            CL: r,
            EF: c,
            EG: t,
            E6: !1,
            yx: n(Ed.yx),
            mA: n,
            GJ: e
        });
    }), Dqr = F2(function(n, r) {
        return nE(A2(no, function(n) {
            return A2(xu, f$(w([
                n,
                "="
            ])), r);
        }, n));
    }), Vqr = F2(function(n, r) {
        return A2(n$, Dmr, A2(no, Dqr(n), A2(se, "&", r)));
    }), Bqr = function(n) {
        return JN(_c(n));
    }, Gqr = function(n) {
        switch(n.$){
            case 98:
                return Aa({
                    nv: n.a.nv,
                    n3: n.a.n3
                });
            case 97:
                return Ca({
                    nv: n.a.nv,
                    n3: n.a.n3
                });
            default:
                return _a;
        }
    }, zqr = F5(function(n, r, t, e, u) {
        var a = _c(t);
        if (JN(a)) {
            var i = A2(xc, g, A2(Op, Vqr(w([
                "practice"
            ])), t.jb));
            return A3(qqr, n, r, It(A2(zx, w([
                Gx("flex justify-end items-center h-full mr-1"),
                Oq(w([
                    v("hidden", !Bqr(t))
                ]))
            ]), w([
                A2(EV, w([
                    yV(A2(nH, w([
                        x_(Gqr(a))
                    ]), i)),
                    qN
                ]), w([
                    _d("Sign In")
                ]))
            ]))));
        }
        return A2(Eqr, u, e);
    }), Sqr = F8(function(n, r, t, e, u, a, i, c) {
        var o = JN(_c(u));
        return kqr({
            g8: a,
            B4: A5(zqr, t, e, u, i, c),
            CF: o,
            CL: r,
            EF: c,
            EG: t,
            E6: !0,
            yx: n(Ed.Aj),
            mA: n,
            GJ: e
        });
    }), Tqr = {
        $: 0
    }, Pqr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Zqr = F6(function(n, r, t, e, u, a) {
        var i, c = 1 === a ? "layout bg-white" : "layout layout--app", o = 3 === t.$ && REr(t.a);
        return w([
            A2(zx, w([
                Gx(c)
            ]), w([
                A2(YEr, n, u),
                A2(zx, w([
                    Gx("main main--app")
                ]), w([
                    A2(zx, w([
                        Gx("app-container my-8")
                    ]), e)
                ])),
                A3(bqr, n, w([
                    1
                ]), w([
                    1 === a ? OEr : 3 === u.$ ? Pqr(u.a) : OEr,
                    Tqr,
                    QEr(w([
                        (i = v(u, o), 3 !== i.a.$ || i.b ? OEr : A2(IEr, ux(i.a.a), "member_app_portal")),
                        1 === a ? WEr(r) : KEr(r)
                    ]))
                ]))
            ]))
        ]);
    }), Mqr = F2(function(n, r) {
        return A2(Kk, w([
            Hx(w([
                Gx(1 === r ? "header header--app" : "header h-24")
            ]))
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("header__container app-container app-account-container")
                ])),
                Hx(Yx(AF))
            ]), w([
                n
            ]))
        ]));
    }), Lqr = F7(function(n, r, t, e, u, a, i) {
        var c = 3 === r.$ ? ux(r.a) : "", o = 3 === t.$ && REr(t.a);
        return w([
            A2(Kk, w([
                Hx(w([
                    Gx("layout layout--app")
                ]))
            ]), w([
                A2(YEr, n, r),
                A2(Mqr, a, i),
                A2(Kk, w([
                    Hx(w([
                        Gx("main main--app")
                    ]))
                ]), w([
                    A2(Kk, w([
                        Hx(w([
                            Gx("app-container app-account-container md:my-8 mt-4")
                        ]))
                    ]), u)
                ])),
                A2(Kk, w([
                    Hx(w([
                        Gx("hidden md:block")
                    ]))
                ]), w([
                    A3(bqr, n, w([
                        1
                    ]), w([
                        o ? OEr : A2(IEr, c, "member_app_portal")
                    ]))
                ]))
            ]))
        ]);
    }), Nqr = F3(function(n, r, t) {
        var e = r5n(r);
        return A2(SS, function(r) {
            return i(A2(i1n, r.a, n), t);
        }, e);
    }), Hqr = F3(function(n, r, t) {
        return A3(Nqr, n, r, _c(t));
    }), Iqr = F3(function(n, r, t) {
        return A2(Op, function(n) {
            return n.b;
        }, A3(Hqr, n, r, t));
    }), Oqr = function(n) {
        return A2(zx, w([
            Gx("signup__body")
        ]), w([
            A2(zx, w([
                Gx("signup__page-border")
            ]), g),
            A2(zx, w([
                Gx("signup__page-center")
            ]), n),
            A2(zx, w([
                Gx("signup__page-border")
            ]), g)
        ]));
    }, Qqr = F5(function(n, r, t, e, u) {
        var a = b(t, e, u);
        if (3 === a.a.$ && 3 === a.b.$ && 3 === a.c.$) {
            var i = a.c.a, c = ux(a.a.a), o = REr(i);
            return A2(zx, g, w([
                A3(bqr, n, w([
                    1
                ]), w([
                    QEr(w([
                        o ? OEr : A2(IEr, c, "member_app_signup"),
                        o ? OEr : Aqr,
                        KEr(r)
                    ])),
                    Tqr
                ]))
            ]));
        }
        return vE;
    }), Rqr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Uqr = F2(function(n, r) {
        return A2(Rqr, n, r);
    }), Kqr = F4(function(n, r, t, e) {
        var u = U8n(e), a = Q8n(e), i = A2(nH, w([
            x_(A2(i1n, a, r))
        ]), t), c = _8n(r), o = n5n(a) && !r1n(a);
        return A2(Uqr, {
            Bb: o,
            lh: u,
            sT: A3(Y8n, c, n, a)
        }, i);
    }), Wqr = F3(function(n, r, t) {
        return A3(iRn, {
            a2: n.a2,
            bb: n.bb
        }, oV(r), t);
    }), Xqr = F2(function(n, r) {
        if (nE(r)) return vE;
        if (n.$) return vE;
        var t = n.a;
        return A2(zx, w([
            Gx("stepper")
        ]), A2(Fu, function(n) {
            var e = n.a, u = n.b;
            return A3(Wqr, {
                a2: t,
                bb: ve(r)
            }, u, e);
        }, r));
    }), Yqr = F5(function(n, r, t, e, u) {
        var a = r5n(t), i = v(ve(a) > 0, Cz(e));
        if (i.a && i.b) {
            var c = GYn(r);
            return A2(Xqr, e, A2(Fu, A3(Kqr, n, c, u), a));
        }
        return vE;
    }), Jqr = F8(function(n, r, t, e, u, a, i, c) {
        if (3 === e.$) {
            var o = e.a;
            return A2($qr, w([
                Gx("header")
            ]), w([
                A2(zx, w([
                    Gx("header__container")
                ]), w([
                    A2(zx, w([
                        Gx("signup__page-border")
                    ]), g),
                    A2(zx, w([
                        Gx("signup__page-center")
                    ]), w([
                        A2(zx, w([
                            Gx("flex items-center flex-wrap w-full")
                        ]), w([
                            A2(zx, w([
                                Gx("flex flex-shrink-0 mr-2 md:mr-8")
                            ]), w([
                                A2(xqr, r, t)
                            ])),
                            A2(zx, w([
                                Gx("flex justify-self-end overflow-hidden")
                            ]), w([
                                A5(Yqr, n, o, u, a, Vmr(i))
                            ]))
                        ]))
                    ])),
                    A2(zx, w([
                        Gx("signup__page-border")
                    ]), g)
                ])),
                function() {
                    if (c.$) return vE;
                    var n = c.a;
                    return A2(zx, w([
                        Gx("header__container header__container--shaded")
                    ]), w([
                        A2(zx, w([
                            Gx("signup__page-border")
                        ]), g),
                        A2(zx, w([
                            Gx("signup__page-center")
                        ]), w([
                            n
                        ])),
                        A2(zx, w([
                            Gx("signup__page-border")
                        ]), g)
                    ]));
                }()
            ]));
        }
        return vE;
    }), nFr = F9(function(n, r, t, e, u, a, i, c, o) {
        var f = nE(a) ? Ot : 3 === u.$ ? A3(Iqr, GYn(u.a), a, i) : Ot;
        return w([
            A2(zx, w([
                Gx("layout"),
                Oq(w([
                    v("signup--thanks", OS(f))
                ]))
            ]), w([
                A2(YEr, n, t),
                A8(Jqr, n, t, e, u, a, f, i, c),
                A2(zx, w([
                    Gx("main main--signup")
                ]), w([
                    Oqr(o)
                ])),
                A5(Qqr, n, r, t, u, e)
            ]))
        ]);
    }), rFr = function(n) {
        return A2(SE, 4, n);
    }, tFr = function(n) {
        return A2(zx, w([
            Gx("flex items-center")
        ]), w([
            A2(sz, w([
                Gx("input-color"),
                SH(n),
                Rj("color")
            ]), g)
        ]));
    }, eFr = function(n) {
        return A2($qr, w([
            Gx("header")
        ]), w([
            A2(zx, w([
                Gx("header__container justify-between px-6")
            ]), w([
                A2(UD, w([
                    oV(x_(ic))
                ]), w([
                    _d("Hint Legos")
                ])),
                tFr(n)
            ]))
        ]));
    }, uFr = F2(function(n, r) {
        var t = r.b, e = x_(r.a);
        return A2(UD, w([
            Gx("menu__item"),
            Oq(w([
                v("menu__item--active", i(e, n))
            ])),
            oV(e)
        ]), w([
            _d(t)
        ]));
    }), aFr = F3(function(n, r, t) {
        var e = n.Gc;
        return w([
            A2(zx, w([
                Gx("layout")
            ]), w([
                eFr(e),
                A2(zx, w([
                    Gx("main")
                ]), w([
                    A2(BE, w([
                        VN(w([
                            Gx("mx-0")
                        ]))
                    ]), w([
                        A2(lE, w([
                            TE(12),
                            tO(4),
                            cmn(3),
                            rFr(2)
                        ]), w([
                            A2(zx, w([
                                Gx("menu")
                            ]), A2(Fu, uFr(r.Ev), w([
                                v(ic, "Typography"),
                                v(Hi, "Grid"),
                                v(zi, "Button"),
                                v(Zi, "Checkbox"),
                                v(Ki, "Radio"),
                                v(Yi, "Select"),
                                v(Wi, "Searchable Select"),
                                v(Ii, "Input"),
                                v(rc, "Tag"),
                                v(Pi, "Cart Icon"),
                                v(Bi, "Alerts"),
                                v(uc, "Tooltip"),
                                v(Ji, "Table"),
                                v(nc, "Tabs"),
                                v(Xi, "Segmented Control"),
                                v(Mi, "Code Sent Confirmation"),
                                v(Di, "Activity Indicator"),
                                v(Qi, "Modal"),
                                v(Gi, "Api Select"),
                                v(Ni, "Form Example"),
                                v(Ti, "Card Example"),
                                v(Si, "Card"),
                                v(tc, "Title Band"),
                                v(Li, "Filter Example"),
                                v(Ui, "Phone Input"),
                                v(Vi, "Address Input"),
                                v(Oi, "Insurance Info"),
                                v(ji, "Action Menu")
                            ])))
                        ])),
                        A2(lE, w([
                            TE(12),
                            tO(8),
                            cmn(9),
                            rFr(10)
                        ]), w([
                            A2(zx, w([
                                Gx("pt-2 px-6")
                            ]), t)
                        ]))
                    ]))
                ]))
            ]))
        ]);
    }), iFr = {
        $: 9
    }, cFr = {
        $: 1
    }, oFr = F3(function(n, r, t) {
        var e = v(n, r);
        n: for(;;){
            r: for(;;)switch(e.a.$){
                case 3:
                    switch(e.b.$){
                        case 3:
                            var u = e.a.a, a = e.b.a;
                            return A4(hqr, t, wqr(a), ax(u), yqr(a));
                        case 1:
                            break n;
                        default:
                            break r;
                    }
                case 1:
                    return Lx(w([
                        Uq
                    ]));
                default:
                    if (1 === e.b.$) break n;
                    break r;
            }
            return A4(hqr, t, It("https://cdn2.hubspot.net/hubfs/2562809/production-app/web/logo-mark.svg"), "Hint Health", "Hint Health logo");
        }
        return Lx(w([
            Uq
        ]));
    }), fFr = {
        $: 2
    }, sFr = function(n) {
        return n.xC;
    }, lFr = function(n) {
        return A2(Kk, w([
            Hx(w([
                Gx("column")
            ])),
            Hx(Yx(omn))
        ]), w([
            A2(yF, w([
                CD,
                cF(fFr)
            ]), w([
                _d(n(sFr))
            ]))
        ]));
    }, dFr = {
        $: 1
    }, vFr = F3(function(n, r, t) {
        return r ? A2(UD, w([
            oV(""),
            Gx("account-menu__item"),
            qE(dFr)
        ]), w([
            _d(n(t ? Ad : kd))
        ])) : vE;
    }), bFr = function(n) {
        return v(oEr(n), n);
    }, mFr = function(n) {
        return A2(Yk, "self_buy", n);
    }, pFr = function(n) {
        var r = Nmn(n) || Hmn(n) ? w([
            0,
            1,
            2,
            3,
            4
        ]) : w([
            0,
            1,
            2,
            4
        ]);
        return A3(az, mFr(n), 5, r);
    }, $Fr = F3(function(n, r, t) {
        var e, u;
        return A2(Fu, bFr, (e = pFr(t), u = n ? A2(Qt, 7, e) : e, r ? A2(Qt, 8, u) : u));
    }), gFr = F2(function(n, r) {
        return 2 === r ? qDn(n) ? fv.Gi : fv.yx : Qv(r);
    }), hFr = F4(function(n, r, t, e) {
        var u = e.a, a = e.b;
        return A2(UD, w([
            Gx("account-menu__item"),
            Oq(w([
                v("account-menu__item--active", i(t, It(a)))
            ])),
            oV(x_(u))
        ]), w([
            _d(n(A2(gFr, r, a)))
        ]));
    }), yFr = F5(function(n, r, t, e, u) {
        return A2(Fu, A3(hFr, n, u, e), A3($Fr, r, t, u));
    }), wFr = F2(function(n, r) {
        var t = r.bY, e = r.tE, u = r.jn, a = r.d2, i = r.dV;
        return A2(Kk, w([
            Hx(w([
                Gx("sidebar")
            ]))
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("sidebar__burger"),
                    CV(0)
                ]))
            ]), g),
            A2(PE, g, g),
            A2(PE, g, g),
            A2(PE, g, g),
            A2(Kk, w([
                Hx(w([
                    Gx("sidebar__links")
                ]))
            ]), A2(dc, A5(yFr, n, t, e, u, i), w([
                A3(vFr, n, a, !1)
            ])))
        ]));
    }), xFr = {
        $: 1
    }, _Fr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, CFr = F2(function(n, r) {
        var t = A2(xc, n, r);
        return lu(t) > 0 ? It(Db(A2(pu, 1, t))) : Ot;
    }), AFr = function(n) {
        return A2(fe, "", A2(n$, cu, w([
            A2(CFr, c_n(n), t_n(n)),
            A2(CFr, d_n(n), e_n(n))
        ])));
    }, kFr = function(n) {
        return function(n) {
            return {
                $: 7,
                a: n
            };
        }(n);
    }, EFr = qvn(uz(1)), qFr = function(n) {
        return function(n) {
            return {
                $: 9,
                a: n
            };
        }(n);
    }, FFr = function(n) {
        return function(n) {
            return {
                $: 10,
                a: n
            };
        }(n);
    }, jFr = QFn(2), DFr = F3(function(n, r, t) {
        if (r.bY) {
            var e = w([
                _Fr(1),
                _Fr(2)
            ]), u = Nmn(r.dV) || Hmn(r.dV), a = A2(Fu, function(n) {
                return A2(MG, g, n);
            }, A3(az, r.d2, xFr, A3(az, r.tE, _Fr(8), A3(az, mFr(r.dV), _Fr(5), $(A3(az, u, _Fr(3), e), w([
                _Fr(4)
            ]))))));
            return w([
                A2(Kk, w([
                    Hx(w([
                        Gx("hidden md:inline-flex")
                    ]))
                ]), w([
                    A2(c_, cEr, A4(qz, n, w([
                        EFr,
                        HG(AFr(r.vn)),
                        jFr,
                        kFr(!1)
                    ]), a, t.d$))
                ])),
                A2(c_, Cu, A2(yF, w([
                    kz,
                    Az,
                    qFr(2),
                    FFr(2)
                ]), w([
                    _d(AFr(r.vn))
                ])))
            ]);
        }
        return w([
            vE
        ]);
    }), VFr = F3(function(n, r, t) {
        return n ? A2(Fu, bFr, w([
            7,
            0
        ])) : A3($Fr, !1, r, t);
    }), BFr = F5(function(n, r, t, e, u) {
        return A2(Fu, A3(hFr, n, u, e), A3(VFr, r, t, u));
    }), GFr = F3(function(n, r, t) {
        return A2(Kk, w([
            Hx(w([
                Gx("flex w-full gap-4")
            ])),
            Hx(Yx(gE)),
            Hx(r.bY ? Yx(yE) : g)
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("flex")
                ]))
            ]), w([
                A2(c_, Cu, r.i7)
            ])),
            A2(Kk, w([
                Hx(w([
                    Gx("flex-grow hidden md:flex h-full gap-4")
                ])),
                Hx(Yx(yE))
            ]), A3(az, !r.bY, A3(vFr, n, r.d2, !1), A5(BFr, n, r.bY, r.tE, r.jn, r.dV))),
            A2(Kk, w([
                Hx(w([
                    Gx("flex absolute left-6 md:relative md:left-0")
                ]))
            ]), A3(DFr, n, r, t))
        ]));
    }), zFr = F4(function(n, r, t, e) {
        var u, a = Nmn(e) || Hmn(e);
        return A3(az, t, xFr, A3(az, mFr(e), _Fr(5), (u = A3(az, a, _Fr(3), $(A3(az, r, _Fr(10), n ? w([
            _Fr(8)
        ]) : g), w([
            _Fr(7),
            _Fr(0),
            _Fr(1),
            _Fr(2)
        ]))), $(u, w([
            _Fr(4)
        ])))));
    }), SFr = F3(function(n, r, t) {
        if (r.bY) {
            var e = A2(Fu, function(n) {
                return A2(MG, g, n);
            }, A4(zFr, r.tE, r.kP, r.d2, r.dV));
            return w([
                A2(Kk, w([
                    Hx(w([
                        Gx("hidden md:inline-flex")
                    ]))
                ]), w([
                    A2(c_, cEr, A4(qz, n, w([
                        EFr,
                        HG(AFr(r.vn)),
                        jFr,
                        kFr(!1)
                    ]), e, t.d$))
                ])),
                A2(c_, Cu, A2(yF, w([
                    kz,
                    Az,
                    qFr(2),
                    FFr(2),
                    Kj(w([
                        Gx("navbar-app__avatar")
                    ]))
                ]), w([
                    _d(AFr(r.vn))
                ])))
            ]);
        }
        return w([
            vE
        ]);
    }), TFr = {
        $: 4
    }, PFr = {
        $: 3
    }, ZFr = function(n) {
        return n.oH;
    }, MFr = function(n) {
        return n.u3;
    }, LFr = F4(function(n, r, t, e) {
        var u = r ? w([
            8
        ]) : g, a = t ? $(u, w([
            10
        ])) : u, i = n ? $(a, w([
            7
        ])) : a;
        return A2(Fu, bFr, $(i, pFr(e)));
    }), NFr = F2(function(n, r) {
        return r ? A2(UD, w([
            oV(""),
            Gx("sidebar__link sidebar__link--logout"),
            qE(dFr)
        ]), w([
            _d(n(Ad))
        ])) : vE;
    }), HFr = F4(function(n, r, t, e) {
        var u = e.a, a = e.b;
        return A2(UD, w([
            Gx("sidebar__link"),
            Oq(w([
                v("sidebar__link--active", i(t, It(a)))
            ])),
            oV(x_(u)),
            qE(TFr)
        ]), w([
            _d(n(A2(gFr, r, a)))
        ]));
    }), IFr = F3(function(n, r, t) {
        var e = r.jn, u = r.d2, a = r.dV, i = A4(LFr, r.bY, r.tE, r.kP, a), c = A2(Fu, A3(HFr, n, a, e), i), o = A2(NFr, n, u);
        return A2(Kk, w([
            Hx(w([
                Gx("sidebar sidebar--polish")
            ]))
        ]), w([
            A2(sF, w([
                Rj("button"),
                DF("sidebar-polish-open"),
                Gx("sidebar__polish-open"),
                qE(PFr),
                A2(lF, "aria-label", n(MFr)),
                A2(lF, "aria-expanded", t.ce ? "true" : "false")
            ]), w([
                A2(Mx, w([
                    Gx("sidebar__polish-dehaze")
                ]), w([
                    A2(Mx, w([
                        Gx("sidebar__polish-dehaze-bar")
                    ]), g),
                    A2(Mx, w([
                        Gx("sidebar__polish-dehaze-bar")
                    ]), g),
                    A2(Mx, w([
                        Gx("sidebar__polish-dehaze-bar")
                    ]), g)
                ]))
            ])),
            A2(zx, A2(Qt, Oq(w([
                v("sidebar__polish-layer", !0),
                v("sidebar__polish-layer--is-open", t.ce)
            ])), A2(Qt, A2(lF, "aria-hidden", t.ce ? "false" : "true"), w(t.ce ? [
                A2(EE, "keydown", ij(wm(TFr)))
            ] : [
                A2(lF, "inert", "")
            ]))), w([
                A2(zx, w([
                    Gx("sidebar__polish-scrim"),
                    qE(TFr)
                ]), g),
                A2(zx, w([
                    Gx("sidebar__polish-panel"),
                    A2(lF, "role", "dialog"),
                    A2(lF, "aria-modal", "true")
                ]), w([
                    A2(sF, w([
                        Rj("button"),
                        DF("sidebar-polish-close"),
                        Gx("sidebar__polish-close"),
                        qE(TFr),
                        A2(lF, "aria-label", n(ZFr))
                    ]), w([
                        A2(Tq, w([
                            pD
                        ]), 2)
                    ])),
                    A2(zx, w([
                        Gx("sidebar__polish-links")
                    ]), A2(dc, c, w([
                        o
                    ])))
                ]))
            ]))
        ]));
    }), OFr = F3(function(n, r, t) {
        return A2(Kk, w([
            Hx(w([
                Gx("navbar-app__top")
            ])),
            Hx(Yx(gE))
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("navbar-app__start")
                ]))
            ]), w([
                A2(Kk, w([
                    Hx(w([
                        Gx("navbar-app__burger")
                    ]))
                ]), w([
                    A3(IFr, n, r, t)
                ]))
            ])),
            A2(Kk, w([
                Hx(w([
                    Gx("navbar-app__logo min-w-0")
                ]))
            ]), w([
                A2(c_, Cu, r.i7)
            ])),
            A2(Kk, w([
                Hx(w([
                    Gx("navbar-app__end")
                ]))
            ]), w([
                A2(Kk, w([
                    Hx(w([
                        Gx("navbar-app__profile")
                    ]))
                ]), A3(SFr, n, r, t))
            ]))
        ]));
    }), QFr = F3(function(n, r, t) {
        return r.tl ? A2(Kk, w([
            Hx(w([
                Gx("flex w-full items-center justify-between gap-4")
            ]))
        ]), w([
            A2(Kk, w([
                Hx(w([
                    Gx("flex")
                ]))
            ]), w([
                A2(c_, Cu, r.i7)
            ])),
            lFr(n)
        ])) : r.vv ? A2(Kk, w([
            Hx(w([
                Gx("navbar-app w-full")
            ]))
        ]), w([
            A3(OFr, n, r, t)
        ])) : A2(Kk, w([
            Hx(w([
                Gx("flex w-full")
            ]))
        ]), w([
            A3(GFr, n, r, t),
            A2(wFr, n, r)
        ]));
    }), RFr = F2(function(n, r) {
        var t, e, u = v(r.dV, r.vu);
        if (3 === u.a.$ && 3 === u.b.$) {
            var a = u.a.a, i = u.b.a, c = vsn(r.g0) || !A2(EDn, 0, a), o = oJn(a) && Jk(a), f = c ? Ot : It(x_(o ? ui : r.bY ? Ba : za)), s = 3 === (e = r.g9).$ && !nE(tG(e.a));
            return A2(c_, n, A2(c_, oAr, A3(QFr, Vx(r.ld), {
                kP: s,
                bY: r.bY,
                tl: c,
                tE: (t = r.fF, 3 === t.$ && a8(t.a)),
                vn: i,
                vv: Jk(a),
                dV: a,
                i7: A3(oFr, r.dV, r.au, f),
                d2: !0,
                jn: r.zK
            }, r.dQ)));
        }
        return vE;
    }), UFr = F2(function(n, r) {
        return A2(Op, function(t) {
            return A2(c_, n, A2(c_, sAr(!0), A2(SF, t, r.eh)));
        }, r.dg);
    }), KFr = F4(function(n, r, t, e) {
        var u, a, c, o = Vx(t.ld), f = 3 === (u = t.dV).$ && Jk(u.a) ? 1 : 0, s = A2(c_, n, function(n) {
            var r = n.dV, t = n.ld, e = n.CL;
            return 3 === r.$ && BPn(r.a) ? A2(Kk, w([
                Hx(w([
                    Gx("w-40 flex")
                ])),
                Hx(Yx(gE))
            ]), w([
                A2(PE, w([
                    fen,
                    Hx(w([
                        Gx("mr-2")
                    ]))
                ]), w([
                    A2(Tq, w([
                        zE
                    ]), 30)
                ])),
                A2(Mx, w([
                    Gx("flex-1")
                ]), w([
                    A2(c_, iAr, A3(UFn, Vx(t), w([
                        cFr
                    ]), e))
                ]))
            ])) : vE;
        }(t)), l = 3 === (a = t.dV).$ && wcn(a.a) && function() {
            switch(_c(t.yZ).$){
                case 17:
                case 14:
                case 66:
                case 67:
                    return !0;
                default:
                    return !1;
            }
        }();
        switch(r){
            case 0:
                var d = A2(UFr, n, t), b = 3 === (c = t.FN).$ ? c.a : g;
                return A2(Qt, A2(c_, n, t.hH ? A2(Kk, w([
                    Hx(w([
                        Gx("debug__box")
                    ]))
                ]), w([
                    A2(Kk, w([
                        Hx(w([
                            Gx("alert alert--success")
                        ]))
                    ]), w([
                        A2(PE, w([
                            Hx(w([
                                Gx("debug__text")
                            ]))
                        ]), w([
                            _d("Debug mode")
                        ])),
                        A2(yF, w([
                            cF(iFr)
                        ]), w([
                            A2(Tq, g, 2)
                        ]))
                    ]))
                ])) : vE), A9(nFr, o, s, t.dV, t.au, t.f2, b, t.yZ, d, e));
            case 1:
                return A3(aFr, {
                    Gc: A2(qc, n, NEr)
                }, t.yZ, e);
            case 4:
                return A8(Sqr, o, s, t.dV, t.au, t.yZ, e, m = A2(RFr, n, t), f);
            case 5:
                return A8(jqr, o, s, t.dV, t.au, t.yZ, e, m = A2(RFr, n, t), f);
            case 3:
                var m = A2(RFr, n, t);
                return (function(n) {
                    return function(r) {
                        return function(t) {
                            return function(e) {
                                return function(u) {
                                    return function(a) {
                                        return function(c) {
                                            return function(o) {
                                                return function(f) {
                                                    return function(s) {
                                                        return function(l) {
                                                            return function(d) {
                                                                var b, m = !(b = v(a, t)).a.$ && 5 === b.a.a && 3 === b.b.$ && wcn(b.b.a), p = 3 === t.$ ? ux(t.a) : "", $ = a.$ ? "" : 2 === a.a ? 3 === t.$ && qDn(t.a) ? n(fv.Gi) : n(fv.yx) : n(Qv(a.a)), h = d && !i(a, It(5)), y = 3 === e.$ && REr(e.a), x = function() {
                                                                    n: for(; !a.$;)switch(a.a){
                                                                        case 7:
                                                                            return "layout--healthInformation";
                                                                        case 5:
                                                                            return d ? "layout--exploreServices" : "";
                                                                        default:
                                                                            break n;
                                                                    }
                                                                    return "";
                                                                }(), _ = A2(fe, " ", w([
                                                                    "layout layout--app",
                                                                    x,
                                                                    h ? "layout--selfbuy-checkout" : ""
                                                                ])), C = m ? wyr({
                                                                    AR: o,
                                                                    Cd: x_(ka),
                                                                    mA: n
                                                                }) : vE, A = m ? A2(zx, w([
                                                                    Gx("absolute right-0 top-1/2 mr-4 -translate-y-1/2")
                                                                ]), w([
                                                                    wyr({
                                                                        AR: o,
                                                                        Cd: x_(ka),
                                                                        mA: n
                                                                    })
                                                                ])) : vE;
                                                                return w([
                                                                    A2(zx, w([
                                                                        Gx(_)
                                                                    ]), w([
                                                                        A2(YEr, n, t),
                                                                        A3(gqr, t, s, l),
                                                                        A2(zx, w([
                                                                            Gx("main main--app")
                                                                        ]), w([
                                                                            A2(zx, w([
                                                                                Gx(1 !== l || d ? h ? "app-container app-account-container md:mb-8" : "app-container app-account-container md:my-8 mt-4" : "app-container app-account-container mt-0 px-4 md:my-8 md:mt-8 md:px-0")
                                                                            ]), 1 !== l || d ? d && i(a, It(5)) ? w([
                                                                                A2(zx, w([
                                                                                    Gx("explore-services-title-band flex items-center justify-between")
                                                                                ]), w([
                                                                                    A2(CF, w([
                                                                                        Hx(w([
                                                                                            Gx("explore-services-title")
                                                                                        ]))
                                                                                    ]), w([
                                                                                        _d($)
                                                                                    ])),
                                                                                    C
                                                                                ])),
                                                                                A2(zx, w([
                                                                                    Gx("explore-services-body")
                                                                                ]), f)
                                                                            ]) : h ? f : w(3 === u.$ ? [
                                                                                A2(zx, w([
                                                                                    Gx("relative text-center mb-6")
                                                                                ]), w([
                                                                                    A2(CF, g, w([
                                                                                        _d($)
                                                                                    ])),
                                                                                    A
                                                                                ])),
                                                                                A2(zx, g, f)
                                                                            ] : [
                                                                                A2(zx, w([
                                                                                    Gx("text-center")
                                                                                ]), f)
                                                                            ]) : w([
                                                                                A2(zx, w([
                                                                                    Gx("relative account-page__title-band py-4 text-center md:py-6")
                                                                                ]), 3 === u.$ ? w([
                                                                                    A2(CF, w([
                                                                                        Hx(w([
                                                                                            Gx("text-2xl")
                                                                                        ]))
                                                                                    ]), w([
                                                                                        _d($)
                                                                                    ])),
                                                                                    A
                                                                                ]) : g),
                                                                                A2(zx, w([
                                                                                    Gx("account-page__content rounded bg-white p-4 shadow-sm md:p-8")
                                                                                ]), f)
                                                                            ])),
                                                                            A2(pqr, t, c)
                                                                        ])),
                                                                        A3(bqr, n, w([
                                                                            1
                                                                        ]), w([
                                                                            QEr(w([
                                                                                y ? OEr : A2(IEr, p, "member_app_portal"),
                                                                                1 === l ? WEr(r) : KEr(r)
                                                                            ]))
                                                                        ]))
                                                                    ]))
                                                                ]);
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                })(o)(s)(t.dV)(t.au)(t.vn)(t.zK)(t.g9)(ve(t.Z))(e)(m)(f)(l);
            case 6:
                return A7(Lqr, o, t.dV, t.au, t.vn, e, m = A2(RFr, n, t), f);
            case 7:
                return A5(Cqr, o, t.dV, t.au, t.yZ, e);
            default:
                return A6(Zqr, o, s, t.au, e, t.dV, f);
        }
    }), WFr = F2(function(n, r) {
        var t = n.bc, e = n.fb, u = n.yC;
        return {
            g8: $(A2(Qt, A2(c_, u, LEr(r.cz)), A4(KFr, u, e, r, t.g8)), g),
            yx: t.yx
        };
    }), XFr = Hu({
        Cl: function(n) {
            var r = GCr(n.ta), t = r.a, e = r.b, u = A2(ug, n, t), a = u.a, i = u.b, c = _c(t), o = A2(_Cr, c, a), f = o.a, s = o.b, l = jCr(c);
            return v(A3(Ou, a, f, l), Uu(w([
                A2(Wp, Ru, i),
                A2(Wp, Qu, s),
                e
            ])));
        },
        F4: function(n) {
            return vx(w([
                Z6n(zCr),
                A2(kj, Ru, vx(w([
                    bS(MCr),
                    UCr(NCr),
                    pS(LCr),
                    QCr(function() {
                        return SCr;
                    }),
                    RCr(ZCr),
                    A2(X8, 1e3, TCr),
                    Z6n(ICr),
                    t2n(PCr),
                    J1n(HCr)
                ]))),
                A2(kj, Qu, WCr(n.bc))
            ]));
        },
        Gv: TEr,
        GB: A2(tu, function(n) {
            return A2(WFr, {
                fb: n.fb,
                bc: A2(hCr, Qu, SEr(n.bc)),
                yC: Ru
            }, n.Fz);
        }, XCr)
    });
    U8 = {
        Main: {
            init: XFr(A2(nu, function(n) {
                return A2(nu, function(r) {
                    return A2(nu, function(t) {
                        return A2(nu, function(e) {
                            return A2(nu, function(u) {
                                return A2(nu, function(a) {
                                    return A2(nu, function(i) {
                                        return A2(nu, function(c) {
                                            return A2(nu, function(o) {
                                                return A2(nu, function(f) {
                                                    return A2(nu, function(s) {
                                                        return A2(nu, function(l) {
                                                            return A2(nu, function(d) {
                                                                return A2(nu, function(v) {
                                                                    return A2(nu, function(b) {
                                                                        return A2(nu, function(m) {
                                                                            return A2(nu, function(p) {
                                                                                return au({
                                                                                    zJ: p,
                                                                                    j: m,
                                                                                    z0: b,
                                                                                    bk: v,
                                                                                    bV: d,
                                                                                    bp: l,
                                                                                    Bt: s,
                                                                                    Bu: f,
                                                                                    Bv: o,
                                                                                    Bw: c,
                                                                                    Bx: i,
                                                                                    By: a,
                                                                                    Ca: u,
                                                                                    CK: e,
                                                                                    ta: t,
                                                                                    De: r,
                                                                                    E2: n
                                                                                });
                                                                            }, A2(Iu, "accountPracticeId", Q$(w([
                                                                                XA(Ot),
                                                                                A2(eu, It, M$)
                                                                            ]))));
                                                                        }, A2(Iu, "accountToken", Q$(w([
                                                                            XA(Ot),
                                                                            A2(eu, It, M$)
                                                                        ]))));
                                                                    }, A2(Iu, "apiUrl", M$));
                                                                }, A2(Iu, "apiVersion", Q$(w([
                                                                    XA(Ot),
                                                                    A2(eu, It, M$)
                                                                ]))));
                                                            }, A2(Iu, "bustCacheRandom", M$));
                                                        }, A2(Iu, "currentTime", O$));
                                                    }, A2(Iu, "emrCalendarsUrl", M$));
                                                }, A2(Iu, "emrCalendarsVersion", Q$(w([
                                                    XA(Ot),
                                                    A2(eu, It, M$)
                                                ]))));
                                            }, A2(Iu, "emrMessagingUrl", M$));
                                        }, A2(Iu, "emrMessagingVersion", Q$(w([
                                            XA(Ot),
                                            A2(eu, It, M$)
                                        ]))));
                                    }, A2(Iu, "emrNotesUrl", M$));
                                }, A2(Iu, "emrNotesVersion", Q$(w([
                                    XA(Ot),
                                    A2(eu, It, M$)
                                ]))));
                            }, A2(Iu, "hintEnv", Q$(w([
                                XA(Ot),
                                A2(eu, It, M$)
                            ]))));
                        }, A2(Iu, "language", M$));
                    }, A2(Iu, "locationHref", M$));
                }, A2(Iu, "meticulous", ru));
            }, A2(Iu, "release", Q$(w([
                XA(Ot),
                A2(eu, It, M$)
            ])))))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? a(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, U8) : n.Elm = U8;
}($b9e750d20bbc1f0f$exports);




/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2024 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ /**
 * pdfjsVersion = 6.0.227
 * pdfjsBuild = 241dbabbf
 */ 
var $jBmpJ = parcelRequire("jBmpJ");
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $91236539d1047655$export$a143d493d941bafc;
var $91236539d1047655$export$e4cf37d7f6fb9e0a;
var $91236539d1047655$export$f99ded8fe4b79145;
var $91236539d1047655$export$599f31c3813fae4d;
'use strict';
var $663230c064b646de$export$a48f0734ac7c2329;
var $663230c064b646de$export$d622b2ad8d90c771;
var $663230c064b646de$export$6100ba28696e12de;
'use strict';
$663230c064b646de$export$a48f0734ac7c2329 = $663230c064b646de$var$byteLength;
$663230c064b646de$export$d622b2ad8d90c771 = $663230c064b646de$var$toByteArray;
$663230c064b646de$export$6100ba28696e12de = $663230c064b646de$var$fromByteArray;
var $663230c064b646de$var$lookup = [];
var $663230c064b646de$var$revLookup = [];
var $663230c064b646de$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $663230c064b646de$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $663230c064b646de$var$i = 0, $663230c064b646de$var$len = $663230c064b646de$var$code.length; $663230c064b646de$var$i < $663230c064b646de$var$len; ++$663230c064b646de$var$i){
    $663230c064b646de$var$lookup[$663230c064b646de$var$i] = $663230c064b646de$var$code[$663230c064b646de$var$i];
    $663230c064b646de$var$revLookup[$663230c064b646de$var$code.charCodeAt($663230c064b646de$var$i)] = $663230c064b646de$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$663230c064b646de$var$revLookup['-'.charCodeAt(0)] = 62;
$663230c064b646de$var$revLookup['_'.charCodeAt(0)] = 63;
function $663230c064b646de$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $663230c064b646de$var$byteLength(b64) {
    var lens = $663230c064b646de$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $663230c064b646de$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $663230c064b646de$var$toByteArray(b64) {
    var tmp;
    var lens = $663230c064b646de$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $663230c064b646de$var$Arr($663230c064b646de$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $663230c064b646de$var$revLookup[b64.charCodeAt(i)] << 18 | $663230c064b646de$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $663230c064b646de$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $663230c064b646de$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $663230c064b646de$var$revLookup[b64.charCodeAt(i)] << 2 | $663230c064b646de$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $663230c064b646de$var$revLookup[b64.charCodeAt(i)] << 10 | $663230c064b646de$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $663230c064b646de$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $663230c064b646de$var$tripletToBase64(num) {
    return $663230c064b646de$var$lookup[num >> 18 & 0x3F] + $663230c064b646de$var$lookup[num >> 12 & 0x3F] + $663230c064b646de$var$lookup[num >> 6 & 0x3F] + $663230c064b646de$var$lookup[num & 0x3F];
}
function $663230c064b646de$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($663230c064b646de$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $663230c064b646de$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($663230c064b646de$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($663230c064b646de$var$lookup[tmp >> 2] + $663230c064b646de$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($663230c064b646de$var$lookup[tmp >> 10] + $663230c064b646de$var$lookup[tmp >> 4 & 0x3F] + $663230c064b646de$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $e6c702d92d6e52a8$export$aafa59e2e03f2942;
var $e6c702d92d6e52a8$export$68d8715fc104d294;
$e6c702d92d6e52a8$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$e6c702d92d6e52a8$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $91236539d1047655$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$91236539d1047655$export$a143d493d941bafc = $91236539d1047655$var$Buffer;
$91236539d1047655$export$e4cf37d7f6fb9e0a = $91236539d1047655$var$SlowBuffer;
$91236539d1047655$export$f99ded8fe4b79145 = 50;
var $91236539d1047655$var$K_MAX_LENGTH = 0x7fffffff;
$91236539d1047655$export$599f31c3813fae4d = $91236539d1047655$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $91236539d1047655$var$Buffer.TYPED_ARRAY_SUPPORT = $91236539d1047655$var$typedArraySupport();
if (!$91236539d1047655$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $91236539d1047655$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($91236539d1047655$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$91236539d1047655$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($91236539d1047655$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$91236539d1047655$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $91236539d1047655$var$createBuffer(length) {
    if (length > $91236539d1047655$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $91236539d1047655$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $91236539d1047655$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $91236539d1047655$var$allocUnsafe(arg);
    }
    return $91236539d1047655$var$from(arg, encodingOrOffset, length);
}
$91236539d1047655$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $91236539d1047655$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $91236539d1047655$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $91236539d1047655$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($91236539d1047655$var$isInstance(value, ArrayBuffer) || value && $91236539d1047655$var$isInstance(value.buffer, ArrayBuffer)) return $91236539d1047655$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($91236539d1047655$var$isInstance(value, SharedArrayBuffer) || value && $91236539d1047655$var$isInstance(value.buffer, SharedArrayBuffer))) return $91236539d1047655$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $91236539d1047655$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $91236539d1047655$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $91236539d1047655$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $91236539d1047655$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $91236539d1047655$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($91236539d1047655$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($91236539d1047655$var$Buffer, Uint8Array);
function $91236539d1047655$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $91236539d1047655$var$alloc(size, fill, encoding) {
    $91236539d1047655$var$assertSize(size);
    if (size <= 0) return $91236539d1047655$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $91236539d1047655$var$createBuffer(size).fill(fill, encoding) : $91236539d1047655$var$createBuffer(size).fill(fill);
    return $91236539d1047655$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $91236539d1047655$var$Buffer.alloc = function(size, fill, encoding) {
    return $91236539d1047655$var$alloc(size, fill, encoding);
};
function $91236539d1047655$var$allocUnsafe(size) {
    $91236539d1047655$var$assertSize(size);
    return $91236539d1047655$var$createBuffer(size < 0 ? 0 : $91236539d1047655$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $91236539d1047655$var$Buffer.allocUnsafe = function(size) {
    return $91236539d1047655$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $91236539d1047655$var$Buffer.allocUnsafeSlow = function(size) {
    return $91236539d1047655$var$allocUnsafe(size);
};
function $91236539d1047655$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$91236539d1047655$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $91236539d1047655$var$byteLength(string, encoding) | 0;
    var buf = $91236539d1047655$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $91236539d1047655$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $91236539d1047655$var$checked(array.length) | 0;
    var buf = $91236539d1047655$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $91236539d1047655$var$fromArrayView(arrayView) {
    if ($91236539d1047655$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $91236539d1047655$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $91236539d1047655$var$fromArrayLike(arrayView);
}
function $91236539d1047655$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $91236539d1047655$var$Buffer.prototype);
    return buf;
}
function $91236539d1047655$var$fromObject(obj) {
    if ($91236539d1047655$var$Buffer.isBuffer(obj)) {
        var len = $91236539d1047655$var$checked(obj.length) | 0;
        var buf = $91236539d1047655$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $91236539d1047655$var$numberIsNaN(obj.length)) return $91236539d1047655$var$createBuffer(0);
        return $91236539d1047655$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $91236539d1047655$var$fromArrayLike(obj.data);
}
function $91236539d1047655$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $91236539d1047655$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $91236539d1047655$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $91236539d1047655$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $91236539d1047655$var$Buffer.alloc(+length);
}
$91236539d1047655$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $91236539d1047655$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$91236539d1047655$var$Buffer.compare = function compare(a, b) {
    if ($91236539d1047655$var$isInstance(a, Uint8Array)) a = $91236539d1047655$var$Buffer.from(a, a.offset, a.byteLength);
    if ($91236539d1047655$var$isInstance(b, Uint8Array)) b = $91236539d1047655$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$91236539d1047655$var$Buffer.isBuffer(a) || !$91236539d1047655$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$91236539d1047655$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$91236539d1047655$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $91236539d1047655$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $91236539d1047655$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($91236539d1047655$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $91236539d1047655$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$91236539d1047655$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $91236539d1047655$var$byteLength(string, encoding) {
    if ($91236539d1047655$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $91236539d1047655$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $91236539d1047655$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $91236539d1047655$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $91236539d1047655$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$91236539d1047655$var$Buffer.byteLength = $91236539d1047655$var$byteLength;
function $91236539d1047655$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $91236539d1047655$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $91236539d1047655$var$utf8Slice(this, start, end);
        case 'ascii':
            return $91236539d1047655$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $91236539d1047655$var$latin1Slice(this, start, end);
        case 'base64':
            return $91236539d1047655$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $91236539d1047655$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$91236539d1047655$var$Buffer.prototype._isBuffer = true;
function $91236539d1047655$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$91236539d1047655$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$91236539d1047655$var$swap(this, i, i + 1);
    return this;
};
$91236539d1047655$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $91236539d1047655$var$swap(this, i, i + 3);
        $91236539d1047655$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$91236539d1047655$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $91236539d1047655$var$swap(this, i, i + 7);
        $91236539d1047655$var$swap(this, i + 1, i + 6);
        $91236539d1047655$var$swap(this, i + 2, i + 5);
        $91236539d1047655$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$91236539d1047655$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $91236539d1047655$var$utf8Slice(this, 0, length);
    return $91236539d1047655$var$slowToString.apply(this, arguments);
};
$91236539d1047655$var$Buffer.prototype.toLocaleString = $91236539d1047655$var$Buffer.prototype.toString;
$91236539d1047655$var$Buffer.prototype.equals = function equals(b) {
    if (!$91236539d1047655$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $91236539d1047655$var$Buffer.compare(this, b) === 0;
};
$91236539d1047655$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $91236539d1047655$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($91236539d1047655$var$customInspectSymbol) $91236539d1047655$var$Buffer.prototype[$91236539d1047655$var$customInspectSymbol] = $91236539d1047655$var$Buffer.prototype.inspect;
$91236539d1047655$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($91236539d1047655$var$isInstance(target, Uint8Array)) target = $91236539d1047655$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$91236539d1047655$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $91236539d1047655$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($91236539d1047655$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $91236539d1047655$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($91236539d1047655$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $91236539d1047655$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $91236539d1047655$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $91236539d1047655$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$91236539d1047655$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$91236539d1047655$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $91236539d1047655$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$91236539d1047655$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $91236539d1047655$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $91236539d1047655$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($91236539d1047655$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $91236539d1047655$var$utf8Write(buf, string, offset, length) {
    return $91236539d1047655$var$blitBuffer($91236539d1047655$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $91236539d1047655$var$asciiWrite(buf, string, offset, length) {
    return $91236539d1047655$var$blitBuffer($91236539d1047655$var$asciiToBytes(string), buf, offset, length);
}
function $91236539d1047655$var$base64Write(buf, string, offset, length) {
    return $91236539d1047655$var$blitBuffer($91236539d1047655$var$base64ToBytes(string), buf, offset, length);
}
function $91236539d1047655$var$ucs2Write(buf, string, offset, length) {
    return $91236539d1047655$var$blitBuffer($91236539d1047655$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$91236539d1047655$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $91236539d1047655$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $91236539d1047655$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $91236539d1047655$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $91236539d1047655$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $91236539d1047655$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$91236539d1047655$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $91236539d1047655$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $663230c064b646de$export$6100ba28696e12de(buf);
    else return $663230c064b646de$export$6100ba28696e12de(buf.slice(start, end));
}
function $91236539d1047655$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $91236539d1047655$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $91236539d1047655$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $91236539d1047655$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $91236539d1047655$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $91236539d1047655$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $91236539d1047655$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $91236539d1047655$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $91236539d1047655$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $91236539d1047655$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $91236539d1047655$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$91236539d1047655$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $91236539d1047655$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $91236539d1047655$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$91236539d1047655$var$Buffer.prototype.readUintLE = $91236539d1047655$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$91236539d1047655$var$Buffer.prototype.readUintBE = $91236539d1047655$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$91236539d1047655$var$Buffer.prototype.readUint8 = $91236539d1047655$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$91236539d1047655$var$Buffer.prototype.readUint16LE = $91236539d1047655$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$91236539d1047655$var$Buffer.prototype.readUint16BE = $91236539d1047655$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$91236539d1047655$var$Buffer.prototype.readUint32LE = $91236539d1047655$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$91236539d1047655$var$Buffer.prototype.readUint32BE = $91236539d1047655$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$91236539d1047655$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$91236539d1047655$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$91236539d1047655$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$91236539d1047655$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$91236539d1047655$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$91236539d1047655$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$91236539d1047655$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$91236539d1047655$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 4, this.length);
    return $e6c702d92d6e52a8$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$91236539d1047655$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 4, this.length);
    return $e6c702d92d6e52a8$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$91236539d1047655$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 8, this.length);
    return $e6c702d92d6e52a8$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$91236539d1047655$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkOffset(offset, 8, this.length);
    return $e6c702d92d6e52a8$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $91236539d1047655$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$91236539d1047655$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$91236539d1047655$var$Buffer.prototype.writeUintLE = $91236539d1047655$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $91236539d1047655$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$91236539d1047655$var$Buffer.prototype.writeUintBE = $91236539d1047655$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $91236539d1047655$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$91236539d1047655$var$Buffer.prototype.writeUint8 = $91236539d1047655$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$91236539d1047655$var$Buffer.prototype.writeUint16LE = $91236539d1047655$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$91236539d1047655$var$Buffer.prototype.writeUint16BE = $91236539d1047655$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$91236539d1047655$var$Buffer.prototype.writeUint32LE = $91236539d1047655$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$91236539d1047655$var$Buffer.prototype.writeUint32BE = $91236539d1047655$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$91236539d1047655$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $91236539d1047655$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$91236539d1047655$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $91236539d1047655$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$91236539d1047655$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$91236539d1047655$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$91236539d1047655$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$91236539d1047655$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$91236539d1047655$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $91236539d1047655$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $91236539d1047655$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $e6c702d92d6e52a8$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$91236539d1047655$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $91236539d1047655$var$writeFloat(this, value, offset, true, noAssert);
};
$91236539d1047655$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $91236539d1047655$var$writeFloat(this, value, offset, false, noAssert);
};
function $91236539d1047655$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91236539d1047655$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $e6c702d92d6e52a8$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$91236539d1047655$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $91236539d1047655$var$writeDouble(this, value, offset, true, noAssert);
};
$91236539d1047655$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $91236539d1047655$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$91236539d1047655$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$91236539d1047655$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$91236539d1047655$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$91236539d1047655$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $91236539d1047655$var$Buffer.isBuffer(val) ? val : $91236539d1047655$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $91236539d1047655$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $91236539d1047655$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($91236539d1047655$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $91236539d1047655$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $91236539d1047655$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $91236539d1047655$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $91236539d1047655$var$base64ToBytes(str) {
    return $663230c064b646de$export$d622b2ad8d90c771($91236539d1047655$var$base64clean(str));
}
function $91236539d1047655$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $91236539d1047655$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $91236539d1047655$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $91236539d1047655$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $a2cc6e1d6eb3861b$require$Buffer = $91236539d1047655$export$a143d493d941bafc;
const $a2cc6e1d6eb3861b$var$isNodeJS = false;
const $a2cc6e1d6eb3861b$var$BBOX_INIT = [
    Infinity,
    Infinity,
    -Infinity,
    -Infinity
];
const $a2cc6e1d6eb3861b$var$F32_BBOX_INIT = new Float32Array($a2cc6e1d6eb3861b$var$BBOX_INIT);
const $a2cc6e1d6eb3861b$var$FONT_IDENTITY_MATRIX = [
    0.001,
    0,
    0,
    0.001,
    0,
    0
];
const $a2cc6e1d6eb3861b$var$LINE_FACTOR = 1.35;
const $a2cc6e1d6eb3861b$var$LINE_DESCENT_FACTOR = 0.35;
const $a2cc6e1d6eb3861b$var$BASELINE_FACTOR = $a2cc6e1d6eb3861b$var$LINE_DESCENT_FACTOR / $a2cc6e1d6eb3861b$var$LINE_FACTOR;
const $a2cc6e1d6eb3861b$var$SVG_NS = "http://www.w3.org/2000/svg";
const $a2cc6e1d6eb3861b$var$RenderingIntentFlag = {
    ANY: 0x01,
    DISPLAY: 0x02,
    PRINT: 0x04,
    SAVE: 0x08,
    ANNOTATIONS_FORMS: 0x10,
    ANNOTATIONS_STORAGE: 0x20,
    ANNOTATIONS_DISABLE: 0x40,
    IS_EDITING: 0x80,
    OPLIST: 0x100
};
const $a2cc6e1d6eb3861b$export$5a7af0c07e33392e = {
    DISABLE: 0,
    ENABLE: 1,
    ENABLE_FORMS: 2,
    ENABLE_STORAGE: 3
};
const $a2cc6e1d6eb3861b$var$AnnotationPrefix = "pdfjs_internal_id_";
const $a2cc6e1d6eb3861b$var$AnnotationEditorPrefix = "pdfjs_internal_editor_";
const $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf = {
    DISABLE: -1,
    NONE: 0,
    FREETEXT: 3,
    HIGHLIGHT: 9,
    STAMP: 13,
    INK: 15,
    POPUP: 16,
    SIGNATURE: 101,
    COMMENT: 102
};
const $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692 = {
    RESIZE: 1,
    CREATE: 2,
    FREETEXT_SIZE: 11,
    FREETEXT_COLOR: 12,
    FREETEXT_OPACITY: 13,
    INK_COLOR: 21,
    INK_THICKNESS: 22,
    INK_OPACITY: 23,
    INK_COLOR_AND_OPACITY: 24,
    HIGHLIGHT_COLOR: 31,
    HIGHLIGHT_THICKNESS: 32,
    HIGHLIGHT_FREE: 33,
    HIGHLIGHT_SHOW_ALL: 34,
    DRAW_STEP: 41
};
const $a2cc6e1d6eb3861b$export$bb99a5b8411e07d8 = {
    PRINT: 0x04,
    MODIFY_CONTENTS: 0x08,
    COPY: 0x10,
    MODIFY_ANNOTATIONS: 0x20,
    FILL_INTERACTIVE_FORMS: 0x100,
    COPY_FOR_ACCESSIBILITY: 0x200,
    ASSEMBLE: 0x400,
    PRINT_HIGH_QUALITY: 0x800
};
const $a2cc6e1d6eb3861b$var$MeshFigureType = /* unused pure expression or super */ null;
const $a2cc6e1d6eb3861b$var$TextRenderingMode = {
    FILL: 0,
    STROKE: 1,
    FILL_STROKE: 2,
    INVISIBLE: 3,
    FILL_ADD_TO_PATH: 4,
    STROKE_ADD_TO_PATH: 5,
    FILL_STROKE_ADD_TO_PATH: 6,
    ADD_TO_PATH: 7,
    FILL_STROKE_MASK: 3,
    ADD_TO_PATH_FLAG: 4
};
const $a2cc6e1d6eb3861b$export$b890e9c15247e0b3 = {
    GRAYSCALE_1BPP: 1,
    RGB_24BPP: 2,
    RGBA_32BPP: 3
};
const $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c = {
    TEXT: 1,
    LINK: 2,
    FREETEXT: 3,
    LINE: 4,
    SQUARE: 5,
    CIRCLE: 6,
    POLYGON: 7,
    POLYLINE: 8,
    HIGHLIGHT: 9,
    UNDERLINE: 10,
    SQUIGGLY: 11,
    STRIKEOUT: 12,
    STAMP: 13,
    CARET: 14,
    INK: 15,
    POPUP: 16,
    FILEATTACHMENT: 17,
    SOUND: 18,
    MOVIE: 19,
    WIDGET: 20,
    SCREEN: 21,
    PRINTERMARK: 22,
    TRAPNET: 23,
    WATERMARK: 24,
    THREED: 25,
    REDACT: 26
};
const $a2cc6e1d6eb3861b$var$AnnotationReplyType = /* unused pure expression or super */ null;
const $a2cc6e1d6eb3861b$var$AnnotationFlag = /* unused pure expression or super */ null;
const $a2cc6e1d6eb3861b$var$AnnotationFieldFlag = /* unused pure expression or super */ null;
const $a2cc6e1d6eb3861b$var$AnnotationBorderStyleType = {
    SOLID: 1,
    DASHED: 2,
    BEVELED: 3,
    INSET: 4,
    UNDERLINE: 5
};
const $a2cc6e1d6eb3861b$var$AnnotationActionEventType = /* unused pure expression or super */ null;
const $a2cc6e1d6eb3861b$var$DocumentActionEventType = /* unused pure expression or super */ null;
const $a2cc6e1d6eb3861b$var$PageActionEventType = /* unused pure expression or super */ null;
const $a2cc6e1d6eb3861b$export$b18df09d23c244c4 = {
    ERRORS: 0,
    WARNINGS: 1,
    INFOS: 5
};
const $a2cc6e1d6eb3861b$export$3a0f7f7a8a0b306b = {
    dependency: 1,
    setLineWidth: 2,
    setLineCap: 3,
    setLineJoin: 4,
    setMiterLimit: 5,
    setDash: 6,
    setRenderingIntent: 7,
    setFlatness: 8,
    setGState: 9,
    save: 10,
    restore: 11,
    transform: 12,
    moveTo: 13,
    lineTo: 14,
    curveTo: 15,
    curveTo2: 16,
    curveTo3: 17,
    closePath: 18,
    rectangle: 19,
    stroke: 20,
    closeStroke: 21,
    fill: 22,
    eoFill: 23,
    fillStroke: 24,
    eoFillStroke: 25,
    closeFillStroke: 26,
    closeEOFillStroke: 27,
    endPath: 28,
    clip: 29,
    eoClip: 30,
    beginText: 31,
    endText: 32,
    setCharSpacing: 33,
    setWordSpacing: 34,
    setHScale: 35,
    setLeading: 36,
    setFont: 37,
    setTextRenderingMode: 38,
    setTextRise: 39,
    moveText: 40,
    setLeadingMoveText: 41,
    setTextMatrix: 42,
    nextLine: 43,
    showText: 44,
    showSpacedText: 45,
    nextLineShowText: 46,
    nextLineSetSpacingShowText: 47,
    setCharWidth: 48,
    setCharWidthAndBounds: 49,
    setStrokeColorSpace: 50,
    setFillColorSpace: 51,
    setStrokeColor: 52,
    setStrokeColorN: 53,
    setFillColor: 54,
    setFillColorN: 55,
    setStrokeGray: 56,
    setFillGray: 57,
    setStrokeRGBColor: 58,
    setFillRGBColor: 59,
    setStrokeCMYKColor: 60,
    setFillCMYKColor: 61,
    shadingFill: 62,
    beginInlineImage: 63,
    beginImageData: 64,
    endInlineImage: 65,
    paintXObject: 66,
    markPoint: 67,
    markPointProps: 68,
    beginMarkedContent: 69,
    beginMarkedContentProps: 70,
    endMarkedContent: 71,
    beginCompat: 72,
    endCompat: 73,
    paintFormXObjectBegin: 74,
    paintFormXObjectEnd: 75,
    beginGroup: 76,
    endGroup: 77,
    beginAnnotation: 80,
    endAnnotation: 81,
    paintImageMaskXObject: 83,
    paintImageMaskXObjectGroup: 84,
    paintImageXObject: 85,
    paintInlineImageXObject: 86,
    paintInlineImageXObjectGroup: 87,
    paintImageXObjectRepeat: 88,
    paintImageMaskXObjectRepeat: 89,
    paintSolidColorImageMask: 90,
    constructPath: 91,
    setStrokeTransparent: 92,
    setFillTransparent: 93,
    rawFillPath: 94
};
const $a2cc6e1d6eb3861b$var$DrawOPS = {
    moveTo: 0,
    lineTo: 1,
    curveTo: 2,
    quadraticCurveTo: 3,
    closePath: 4
};
const $a2cc6e1d6eb3861b$export$5e72215208e4d9ad = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
let $a2cc6e1d6eb3861b$var$verbosity = $a2cc6e1d6eb3861b$export$b18df09d23c244c4.WARNINGS;
function $a2cc6e1d6eb3861b$var$setVerbosityLevel(level) {
    if (Number.isInteger(level)) $a2cc6e1d6eb3861b$var$verbosity = level;
}
function $a2cc6e1d6eb3861b$var$getVerbosityLevel() {
    return $a2cc6e1d6eb3861b$var$verbosity;
}
function $a2cc6e1d6eb3861b$var$info(msg) {
    if ($a2cc6e1d6eb3861b$var$verbosity >= $a2cc6e1d6eb3861b$export$b18df09d23c244c4.INFOS) console.info(`Info: ${msg}`);
}
function $a2cc6e1d6eb3861b$var$warn(msg) {
    if ($a2cc6e1d6eb3861b$var$verbosity >= $a2cc6e1d6eb3861b$export$b18df09d23c244c4.WARNINGS) console.warn(`Warning: ${msg}`);
}
function $a2cc6e1d6eb3861b$var$unreachable(msg) {
    throw new Error(msg);
}
function $a2cc6e1d6eb3861b$var$assert(cond, msg) {
    if (!cond) $a2cc6e1d6eb3861b$var$unreachable(msg);
}
function $a2cc6e1d6eb3861b$var$_isValidProtocol(url) {
    switch(url?.protocol){
        case "http:":
        case "https:":
        case "ftp:":
        case "mailto:":
        case "tel:":
            return true;
        default:
            return false;
    }
}
function $a2cc6e1d6eb3861b$export$e076b47f5805ca0b(url, baseUrl = null, options = null) {
    if (!url) return null;
    if (options && typeof url === "string") {
        if (options.addDefaultProtocol && url.startsWith("www.")) {
            const dots = url.match(/\./g);
            if (dots?.length >= 2) url = `http://${url}`;
        }
        if (options.tryConvertEncoding) try {
            url = $a2cc6e1d6eb3861b$var$stringToUTF8String(url);
        } catch  {}
    }
    const absoluteUrl = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return $a2cc6e1d6eb3861b$var$_isValidProtocol(absoluteUrl) ? absoluteUrl : null;
}
function $a2cc6e1d6eb3861b$export$e1e4297c21ab9d13(url, hash, allowRel = false) {
    const res = URL.parse(url);
    if (res) {
        res.hash = hash;
        return res.href;
    }
    if (allowRel && $a2cc6e1d6eb3861b$export$e076b47f5805ca0b(url, "http://example.com")) return url.split("#", 1)[0] + `${hash ? `#${hash}` : ""}`;
    return "";
}
function $a2cc6e1d6eb3861b$var$stripPath(str) {
    return str.substring(str.lastIndexOf("/") + 1);
}
function $a2cc6e1d6eb3861b$export$b8972b998723d602(obj, prop, value, nonSerializable = false) {
    Object.defineProperty(obj, prop, {
        value: value,
        enumerable: !nonSerializable,
        configurable: true,
        writable: false
    });
    return value;
}
const $a2cc6e1d6eb3861b$var$BaseException = function BaseExceptionClosure() {
    function BaseException(message, name) {
        this.message = message;
        this.name = name;
    }
    BaseException.prototype = new Error();
    BaseException.constructor = BaseException;
    return BaseException;
}();
class $a2cc6e1d6eb3861b$var$PasswordException extends $a2cc6e1d6eb3861b$var$BaseException {
    constructor(msg, code){
        super(msg, "PasswordException");
        this.code = code;
    }
}
class $a2cc6e1d6eb3861b$var$UnknownErrorException extends $a2cc6e1d6eb3861b$var$BaseException {
    constructor(msg, details){
        super(msg, "UnknownErrorException");
        this.details = details;
    }
}
class $a2cc6e1d6eb3861b$export$e3d0f4ce5b91e9f1 extends $a2cc6e1d6eb3861b$var$BaseException {
    constructor(msg){
        super(msg, "InvalidPDFException");
    }
}
class $a2cc6e1d6eb3861b$export$ea8e9c34f66e603 extends $a2cc6e1d6eb3861b$var$BaseException {
    constructor(msg, status, missing){
        super(msg, "ResponseException");
        this.status = status;
        this.missing = missing;
    }
}
class $a2cc6e1d6eb3861b$var$FormatError extends $a2cc6e1d6eb3861b$var$BaseException {
    constructor(msg){
        super(msg, "FormatError");
    }
}
class $a2cc6e1d6eb3861b$export$d0e978393d193d1a extends $a2cc6e1d6eb3861b$var$BaseException {
    constructor(msg){
        super(msg, "AbortException");
    }
}
function $a2cc6e1d6eb3861b$var$bytesToString(bytes) {
    if (typeof bytes !== "object" || bytes?.length === undefined) $a2cc6e1d6eb3861b$var$unreachable("Invalid argument for bytesToString");
    const length = bytes.length;
    const MAX_ARGUMENT_COUNT = 8192;
    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
    const strBuf = [];
    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
        const chunk = bytes.subarray(i, chunkEnd);
        strBuf.push(String.fromCharCode.apply(null, chunk));
    }
    return strBuf.join("");
}
function $a2cc6e1d6eb3861b$var$stringToBytes(str) {
    if (typeof str !== "string") $a2cc6e1d6eb3861b$var$unreachable("Invalid argument for stringToBytes");
    const length = str.length;
    const bytes = new Uint8Array(length);
    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
    return bytes;
}
function $a2cc6e1d6eb3861b$var$objectSize(obj) {
    return Object.keys(obj).length;
}
class $a2cc6e1d6eb3861b$export$5fb8891d35c36978 {
    static get isLittleEndian() {
        const buffer8 = new Uint8Array(4);
        buffer8[0] = 1;
        const view32 = new Uint32Array(buffer8.buffer, 0, 1);
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isLittleEndian", view32[0] === 1);
    }
    static get isOffscreenCanvasSupported() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
    }
    static get isImageDecoderSupported() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isImageDecoderSupported", typeof ImageDecoder !== "undefined");
    }
    static get isFloat16ArraySupported() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isFloat16ArraySupported", typeof Float16Array !== "undefined");
    }
    static get isSanitizerSupported() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isSanitizerSupported", typeof Sanitizer !== "undefined");
    }
    static get platform() {
        const { platform: platform, userAgent: userAgent } = navigator;
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "platform", {
            isAndroid: userAgent.includes("Android"),
            isLinux: platform.includes("Linux"),
            isMac: platform.includes("Mac"),
            isWindows: platform.includes("Win"),
            isFirefox: userAgent.includes("Firefox")
        });
    }
    static get isCanvasFilterSupported() {
        let ctx;
        if (this.isOffscreenCanvasSupported) ctx = new OffscreenCanvas(1, 1).getContext("2d");
        else if (typeof document !== "undefined") ctx = document.createElement("canvas").getContext("2d");
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isCanvasFilterSupported", ctx?.filter !== undefined);
    }
    static get isAlphaColorInputSupported() {
        if (typeof document === "undefined") return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isAlphaColorInputSupported", false);
        const input = document.createElement("input");
        input.type = "color";
        input.setAttribute("alpha", "");
        input.value = "#ff000080";
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isAlphaColorInputSupported", input.value !== "#ff0000");
    }
}
class $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd {
    static get hexNums() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "hexNums", Array.from(Array(256).keys(), (n)=>n.toString(16).padStart(2, "0")));
    }
    static makeHexColor(r, g, b) {
        return `#${this.hexNums[r]}${this.hexNums[g]}${this.hexNums[b]}`;
    }
    static transform(m1, m2) {
        return [
            m1[0] * m2[0] + m1[2] * m2[1],
            m1[1] * m2[0] + m1[3] * m2[1],
            m1[0] * m2[2] + m1[2] * m2[3],
            m1[1] * m2[2] + m1[3] * m2[3],
            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
        ];
    }
    static multiplyByDOMMatrix(m, md) {
        return [
            m[0] * md.a + m[2] * md.b,
            m[1] * md.a + m[3] * md.b,
            m[0] * md.c + m[2] * md.d,
            m[1] * md.c + m[3] * md.d,
            m[0] * md.e + m[2] * md.f + m[4],
            m[1] * md.e + m[3] * md.f + m[5]
        ];
    }
    static applyTransform(p, m, pos = 0) {
        const p0 = p[pos];
        const p1 = p[pos + 1];
        p[pos] = p0 * m[0] + p1 * m[2] + m[4];
        p[pos + 1] = p0 * m[1] + p1 * m[3] + m[5];
    }
    static applyTransformToBezier(p, transform, pos = 0) {
        const m0 = transform[0];
        const m1 = transform[1];
        const m2 = transform[2];
        const m3 = transform[3];
        const m4 = transform[4];
        const m5 = transform[5];
        for(let i = 0; i < 6; i += 2){
            const pI = p[pos + i];
            const pI1 = p[pos + i + 1];
            p[pos + i] = pI * m0 + pI1 * m2 + m4;
            p[pos + i + 1] = pI * m1 + pI1 * m3 + m5;
        }
    }
    static applyInverseTransform(p, m) {
        const p0 = p[0];
        const p1 = p[1];
        const d = m[0] * m[3] - m[1] * m[2];
        p[0] = (p0 * m[3] - p1 * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
        p[1] = (-p0 * m[1] + p1 * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    }
    static axialAlignedBoundingBox(rect, transform, output) {
        const m0 = transform[0];
        const m1 = transform[1];
        const m2 = transform[2];
        const m3 = transform[3];
        const m4 = transform[4];
        const m5 = transform[5];
        const r0 = rect[0];
        const r1 = rect[1];
        const r2 = rect[2];
        const r3 = rect[3];
        let a0 = m0 * r0 + m4;
        let a2 = a0;
        let a1 = m0 * r2 + m4;
        let a3 = a1;
        let b0 = m3 * r1 + m5;
        let b2 = b0;
        let b1 = m3 * r3 + m5;
        let b3 = b1;
        if (m1 !== 0 || m2 !== 0) {
            const m1r0 = m1 * r0;
            const m1r2 = m1 * r2;
            const m2r1 = m2 * r1;
            const m2r3 = m2 * r3;
            a0 += m2r1;
            a3 += m2r1;
            a1 += m2r3;
            a2 += m2r3;
            b0 += m1r0;
            b3 += m1r0;
            b1 += m1r2;
            b2 += m1r2;
        }
        output[0] = Math.min(output[0], a0, a1, a2, a3);
        output[1] = Math.min(output[1], b0, b1, b2, b3);
        output[2] = Math.max(output[2], a0, a1, a2, a3);
        output[3] = Math.max(output[3], b0, b1, b2, b3);
    }
    static inverseTransform(m) {
        const d = m[0] * m[3] - m[1] * m[2];
        return [
            m[3] / d,
            -m[1] / d,
            -m[2] / d,
            m[0] / d,
            (m[2] * m[5] - m[4] * m[3]) / d,
            (m[4] * m[1] - m[5] * m[0]) / d
        ];
    }
    static singularValueDecompose2dScale(matrix, output) {
        const m0 = matrix[0];
        const m1 = matrix[1];
        const m2 = matrix[2];
        const m3 = matrix[3];
        const a = m0 ** 2 + m1 ** 2;
        const b = m0 * m2 + m1 * m3;
        const c = m2 ** 2 + m3 ** 2;
        const first = (a + c) / 2;
        const second = Math.sqrt(first ** 2 - (a * c - b ** 2));
        output[0] = Math.sqrt(first + second || 1);
        output[1] = Math.sqrt(first - second || 1);
    }
    static normalizeRect(rect) {
        const r = rect.slice(0);
        if (rect[0] > rect[2]) {
            r[0] = rect[2];
            r[2] = rect[0];
        }
        if (rect[1] > rect[3]) {
            r[1] = rect[3];
            r[3] = rect[1];
        }
        return r;
    }
    static intersect(rect1, rect2) {
        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
        if (xLow > xHigh) return null;
        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
        if (yLow > yHigh) return null;
        return [
            xLow,
            yLow,
            xHigh,
            yHigh
        ];
    }
    static pointBoundingBox(x, y, minMax) {
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static rectBoundingBox(x0, y0, x1, y1, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x1);
        minMax[1] = Math.min(minMax[1], y0, y1);
        minMax[2] = Math.max(minMax[2], x0, x1);
        minMax[3] = Math.max(minMax[3], y0, y1);
    }
    static #getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, t, minMax) {
        if (t <= 0 || t >= 1) return;
        const mt = 1 - t;
        const tt = t * t;
        const ttt = tt * t;
        const x = mt * (mt * (mt * x0 + 3 * t * x1) + 3 * tt * x2) + ttt * x3;
        const y = mt * (mt * (mt * y0 + 3 * t * y1) + 3 * tt * y2) + ttt * y3;
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static #getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, a, b, c, minMax) {
        if (Math.abs(a) < 1e-12) {
            if (Math.abs(b) >= 1e-12) this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, -c / b, minMax);
            return;
        }
        const delta = b ** 2 - 4 * c * a;
        if (delta < 0) return;
        const sqrtDelta = Math.sqrt(delta);
        const a2 = 2 * a;
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b + sqrtDelta) / a2, minMax);
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b - sqrtDelta) / a2, minMax);
    }
    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x3);
        minMax[1] = Math.min(minMax[1], y0, y3);
        minMax[2] = Math.max(minMax[2], x0, x3);
        minMax[3] = Math.max(minMax[3], y0, y3);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-x0 + 3 * (x1 - x2) + x3), 6 * (x0 - 2 * x1 + x2), 3 * (x1 - x0), minMax);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-y0 + 3 * (y1 - y2) + y3), 6 * (y0 - 2 * y1 + y2), 3 * (y1 - y0), minMax);
    }
}
function $a2cc6e1d6eb3861b$var$stringToUTF8String(str) {
    return decodeURIComponent(escape(str));
}
function $a2cc6e1d6eb3861b$var$utf8StringToString(str) {
    return unescape(encodeURIComponent(str));
}
function $a2cc6e1d6eb3861b$var$isArrayEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(let i = 0, ii = arr1.length; i < ii; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
let $a2cc6e1d6eb3861b$var$NormalizeRegex = null;
let $a2cc6e1d6eb3861b$var$NormalizationMap = null;
function $a2cc6e1d6eb3861b$export$1fa1e6b1a06bd7fa(str) {
    if (!$a2cc6e1d6eb3861b$var$NormalizeRegex) {
        $a2cc6e1d6eb3861b$var$NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
        $a2cc6e1d6eb3861b$var$NormalizationMap = new Map([
            [
                "\uFB05",
                "\u017Ft"
            ]
        ]);
    }
    return str.replaceAll($a2cc6e1d6eb3861b$var$NormalizeRegex, (_, p1, p2)=>p1 ? p1.normalize("NFKC") : $a2cc6e1d6eb3861b$var$NormalizationMap.get(p2));
}
function $a2cc6e1d6eb3861b$export$75f13a91ebdf8eb3() {
    if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
    const buf = new Uint8Array(32);
    crypto.getRandomValues(buf);
    return $a2cc6e1d6eb3861b$var$bytesToString(buf);
}
function $a2cc6e1d6eb3861b$var$_isValidExplicitDest(validRef, validName, dest) {
    if (!Array.isArray(dest) || dest.length < 2) return false;
    const [page, zoom, ...args] = dest;
    if (!validRef(page) && !Number.isInteger(page)) return false;
    if (!validName(zoom)) return false;
    const argsLen = args.length;
    let allowNull = true;
    switch(zoom.name){
        case "XYZ":
            if (argsLen < 2 || argsLen > 3) return false;
            break;
        case "Fit":
        case "FitB":
            return argsLen === 0;
        case "FitH":
        case "FitBH":
        case "FitV":
        case "FitBV":
            if (argsLen > 1) return false;
            break;
        case "FitR":
            if (argsLen !== 4) return false;
            allowNull = false;
            break;
        default:
            return false;
    }
    for (const arg of args){
        if (typeof arg === "number" || allowNull && arg === null) continue;
        return false;
    }
    return true;
}
const $a2cc6e1d6eb3861b$export$be9af9a47496243a = ()=>[];
const $a2cc6e1d6eb3861b$export$b41394a5437791c8 = ()=>new Map();
const $a2cc6e1d6eb3861b$export$5b3b706fb9845c88 = ()=>Object.create(null);
function $a2cc6e1d6eb3861b$export$b8106b171181a554(v, min, max) {
    return Math.min(Math.max(v, min), max);
}
class $a2cc6e1d6eb3861b$var$PageViewport {
    constructor({ viewBox: viewBox, userUnit: userUnit, scale: scale, rotation: rotation, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false }){
        this.viewBox = viewBox;
        this.userUnit = userUnit;
        this.scale = scale;
        this.rotation = rotation;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        scale *= userUnit;
        const centerX = (viewBox[2] + viewBox[0]) / 2;
        const centerY = (viewBox[3] + viewBox[1]) / 2;
        let rotateA, rotateB, rotateC, rotateD;
        rotation %= 360;
        if (rotation < 0) rotation += 360;
        switch(rotation){
            case 180:
                rotateA = -1;
                rotateB = 0;
                rotateC = 0;
                rotateD = 1;
                break;
            case 90:
                rotateA = 0;
                rotateB = 1;
                rotateC = 1;
                rotateD = 0;
                break;
            case 270:
                rotateA = 0;
                rotateB = -1;
                rotateC = -1;
                rotateD = 0;
                break;
            case 0:
                rotateA = 1;
                rotateB = 0;
                rotateC = 0;
                rotateD = -1;
                break;
            default:
                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
        }
        if (dontFlip) {
            rotateC = -rotateC;
            rotateD = -rotateD;
        }
        let offsetCanvasX, offsetCanvasY;
        let width, height;
        if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
            width = (viewBox[3] - viewBox[1]) * scale;
            height = (viewBox[2] - viewBox[0]) * scale;
        } else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
            width = (viewBox[2] - viewBox[0]) * scale;
            height = (viewBox[3] - viewBox[1]) * scale;
        }
        this.transform = [
            rotateA * scale,
            rotateB * scale,
            rotateC * scale,
            rotateD * scale,
            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
        ];
        this.width = width;
        this.height = height;
    }
    get rawDims() {
        const dims = this.viewBox;
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "rawDims", {
            pageWidth: dims[2] - dims[0],
            pageHeight: dims[3] - dims[1],
            pageX: dims[0],
            pageY: dims[1]
        });
    }
    clone({ scale: scale = this.scale, rotation: rotation = this.rotation, offsetX: offsetX = this.offsetX, offsetY: offsetY = this.offsetY, dontFlip: dontFlip = false } = {}) {
        return new $a2cc6e1d6eb3861b$var$PageViewport({
            viewBox: this.viewBox.slice(),
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    convertToViewportPoint(x, y) {
        const p = [
            x,
            y
        ];
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(p, this.transform);
        return p;
    }
    convertToViewportRectangle(rect) {
        const topLeft = [
            rect[0],
            rect[1]
        ];
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(topLeft, this.transform);
        const bottomRight = [
            rect[2],
            rect[3]
        ];
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(bottomRight, this.transform);
        return [
            topLeft[0],
            topLeft[1],
            bottomRight[0],
            bottomRight[1]
        ];
    }
    convertToPdfPoint(x, y) {
        const p = [
            x,
            y
        ];
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyInverseTransform(p, this.transform);
        return p;
    }
}
class $a2cc6e1d6eb3861b$var$XfaText {
    static textContent(xfa) {
        const items = [];
        const output = {
            items: items,
            styles: Object.create(null)
        };
        function walk(node) {
            if (!node) return;
            let str = null;
            const name = node.name;
            if (name === "#text") str = node.value;
            else if (!$a2cc6e1d6eb3861b$var$XfaText.shouldBuildText(name)) return;
            else if (node?.attributes?.textContent) str = node.attributes.textContent;
            else if (node.value) str = node.value;
            if (str !== null) items.push({
                str: str
            });
            if (!node.children) return;
            for (const child of node.children)walk(child);
        }
        walk(xfa);
        return output;
    }
    static shouldBuildText(name) {
        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
    }
}
class $a2cc6e1d6eb3861b$export$f6af20c312d4b9a2 {
    static setupStorage(html, id, element, storage, intent) {
        const storedData = storage.getValue(id, {
            value: null
        });
        switch(element.name){
            case "textarea":
                if (storedData.value !== null) html.textContent = storedData.value;
                if (intent === "print") break;
                html.addEventListener("input", (event)=>{
                    storage.setValue(id, {
                        value: event.target.value
                    });
                });
                break;
            case "input":
                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                    if (intent === "print") break;
                    html.addEventListener("change", (event)=>{
                        storage.setValue(id, {
                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                        });
                    });
                } else {
                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                    if (intent === "print") break;
                    html.addEventListener("input", (event)=>{
                        storage.setValue(id, {
                            value: event.target.value
                        });
                    });
                }
                break;
            case "select":
                if (storedData.value !== null) {
                    html.setAttribute("value", storedData.value);
                    for (const option of element.children){
                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                        else if (Object.hasOwn(option.attributes, "selected")) delete option.attributes.selected;
                    }
                }
                html.addEventListener("input", (event)=>{
                    const options = event.target.options;
                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                    storage.setValue(id, {
                        value: value
                    });
                });
                break;
        }
    }
    static setAttributes({ html: html, element: element, storage: storage = null, intent: intent, linkService: linkService }) {
        const { attributes: attributes } = element;
        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
        for (const [key, value] of Object.entries(attributes)){
            if (value === null || value === undefined) continue;
            switch(key){
                case "class":
                    if (value.length) html.setAttribute(key, value.join(" "));
                    break;
                case "dataId":
                    break;
                case "id":
                    html.setAttribute("data-element-id", value);
                    break;
                case "style":
                    Object.assign(html.style, value);
                    break;
                case "textContent":
                    html.textContent = value;
                    break;
                default:
                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
            }
        }
        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
    }
    static render(parameters) {
        const storage = parameters.annotationStorage;
        const linkService = parameters.linkService;
        const root = parameters.xfaHtml;
        const intent = parameters.intent || "display";
        const rootHtml = document.createElement(root.name);
        if (root.attributes) this.setAttributes({
            html: rootHtml,
            element: root,
            intent: intent,
            linkService: linkService
        });
        const isNotForRichText = intent !== "richText";
        const rootDiv = parameters.div;
        rootDiv.append(rootHtml);
        if (parameters.viewport) {
            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
            rootDiv.style.transform = transform;
        }
        if (isNotForRichText) rootDiv.setAttribute("class", "xfaLayer xfaFont");
        const textDivs = [];
        if (root.children.length === 0) {
            if (root.value) {
                const node = document.createTextNode(root.value);
                rootHtml.append(node);
                if (isNotForRichText && $a2cc6e1d6eb3861b$var$XfaText.shouldBuildText(root.name)) textDivs.push(node);
            }
            return {
                textDivs: textDivs
            };
        }
        const stack = [
            [
                root,
                -1,
                rootHtml
            ]
        ];
        while(stack.length > 0){
            const [parent, i, html] = stack.at(-1);
            if (i + 1 === parent.children.length) {
                stack.pop();
                continue;
            }
            const child = parent.children[++stack.at(-1)[1]];
            if (child === null) continue;
            const { name: name } = child;
            if (name === "#text") {
                const node = document.createTextNode(child.value);
                textDivs.push(node);
                html.append(node);
                continue;
            }
            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
            html.append(childHtml);
            if (child.attributes) this.setAttributes({
                html: childHtml,
                element: child,
                storage: storage,
                intent: intent,
                linkService: linkService
            });
            if (child.children?.length > 0) stack.push([
                child,
                -1,
                childHtml
            ]);
            else if (child.value) {
                const node = document.createTextNode(child.value);
                if (isNotForRichText && $a2cc6e1d6eb3861b$var$XfaText.shouldBuildText(name)) textDivs.push(node);
                childHtml.append(node);
            }
        }
        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
        return {
            textDivs: textDivs
        };
    }
    static update(parameters) {
        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
        parameters.div.style.transform = transform;
        parameters.div.hidden = false;
    }
    static getPageViewport(xfaPage, { scale: scale = 1, rotation: rotation = 0 }) {
        const { width: width, height: height } = xfaPage.attributes.style;
        return new $a2cc6e1d6eb3861b$var$PageViewport({
            viewBox: [
                0,
                0,
                parseInt(width, 10),
                parseInt(height, 10)
            ],
            userUnit: 1,
            scale: scale,
            rotation: rotation
        });
    }
}
class $a2cc6e1d6eb3861b$export$6ef3b6b69e65342c {
    static CSS = 96.0;
    static PDF = 72.0;
    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
}
async function $a2cc6e1d6eb3861b$export$8134c072fddab6a5(url, type = "text") {
    if ($a2cc6e1d6eb3861b$var$isValidFetchUrl(url, document.baseURI)) {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.statusText);
        switch(type){
            case "blob":
                return response.blob();
            case "bytes":
                return response.bytes();
            case "json":
                return response.json();
        }
        return response.text();
    }
    return new Promise((resolve, reject)=>{
        const request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.responseType = type === "bytes" ? "arraybuffer" : type;
        request.onreadystatechange = ()=>{
            if (request.readyState !== XMLHttpRequest.DONE) return;
            if (request.status === 200 || request.status === 0) {
                switch(type){
                    case "bytes":
                        resolve(new Uint8Array(request.response));
                        return;
                    case "blob":
                    case "json":
                        resolve(request.response);
                        return;
                }
                resolve(request.responseText);
                return;
            }
            reject(new Error(request.statusText));
        };
        request.send(null);
    });
}
class $a2cc6e1d6eb3861b$export$245847d31c09154f extends $a2cc6e1d6eb3861b$var$BaseException {
    constructor(msg, extraDelay = 0){
        super(msg, "RenderingCancelledException");
        this.extraDelay = extraDelay;
    }
}
function $a2cc6e1d6eb3861b$export$f67aae4532d8295b(url) {
    const ii = url.length;
    let i = 0;
    while(i < ii && url[i].trim() === "")i++;
    return url.substring(i, i + 5).toLowerCase() === "data:";
}
function $a2cc6e1d6eb3861b$export$61b52d3570d24719(filename) {
    return typeof filename === "string" && /\.pdf$/i.test(filename);
}
function $a2cc6e1d6eb3861b$export$b1c11df0696253ae(url) {
    [url] = url.split(/[#?]/, 1);
    return $a2cc6e1d6eb3861b$var$stripPath(url);
}
function $a2cc6e1d6eb3861b$export$9de51790aa4bc73a(url, defaultFilename = "document.pdf") {
    if (typeof url !== "string") return defaultFilename;
    if ($a2cc6e1d6eb3861b$export$f67aae4532d8295b(url)) {
        $a2cc6e1d6eb3861b$var$warn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
        return defaultFilename;
    }
    const getURL = (urlString)=>{
        try {
            return new URL(urlString);
        } catch  {}
        try {
            return new URL(decodeURIComponent(urlString));
        } catch  {}
        try {
            return new URL(urlString, "https://foo.bar");
        } catch  {}
        try {
            return new URL(decodeURIComponent(urlString), "https://foo.bar");
        } catch  {}
        return null;
    };
    const newURL = getURL(url);
    if (!newURL) return defaultFilename;
    const decode = (name)=>{
        try {
            let decoded = decodeURIComponent(name);
            if (decoded.includes("/")) {
                decoded = $a2cc6e1d6eb3861b$var$stripPath(decoded);
                if (decoded.length === 4 && pdfRegex.test(decoded)) return name;
            }
            return decoded;
        } catch  {
            return name;
        }
    };
    const pdfRegex = /\.pdf$/i;
    const filename = $a2cc6e1d6eb3861b$var$stripPath(newURL.pathname);
    if (pdfRegex.test(filename)) return decode(filename);
    if (newURL.searchParams.size > 0) {
        const getLast = (iterator)=>[
                ...iterator
            ].findLast((v)=>pdfRegex.test(v));
        const name = getLast(newURL.searchParams.values()) ?? getLast(newURL.searchParams.keys());
        if (name) return decode(name);
    }
    if (newURL.hash) {
        const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
        const hashFilename = reFilename.exec(newURL.hash);
        if (hashFilename) return decode(hashFilename[0]);
    }
    return defaultFilename;
}
class $a2cc6e1d6eb3861b$var$StatTimer {
    #started = new Map();
    times = [];
    time(name) {
        if (this.#started.has(name)) $a2cc6e1d6eb3861b$var$warn(`Timer is already running for ${name}`);
        this.#started.set(name, Date.now());
    }
    timeEnd(name) {
        if (!this.#started.has(name)) $a2cc6e1d6eb3861b$var$warn(`Timer has not been started for ${name}`);
        this.times.push({
            name: name,
            start: this.#started.get(name),
            end: Date.now()
        });
        this.#started.delete(name);
    }
    toString() {
        const longest = Math.max(...this.times.map((t)=>t.name.length));
        return this.times.map((t)=>`${t.name.padEnd(longest)} ${t.end - t.start}ms\n`).join("");
    }
}
function $a2cc6e1d6eb3861b$var$isValidFetchUrl(url, baseUrl) {
    const res = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return /https?:/.test(res?.protocol ?? "");
}
function $a2cc6e1d6eb3861b$export$455b7811f904cadc(e) {
    e.preventDefault();
}
function $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e) {
    e.preventDefault();
    e.stopPropagation();
}
function $a2cc6e1d6eb3861b$var$deprecated(details) {
    console.log("Deprecated API usage: " + details);
}
class $a2cc6e1d6eb3861b$export$66cbc314498fffc {
    static #regex;
    static toDateObject(input) {
        if (input instanceof Date) return input;
        if (!input || typeof input !== "string") return null;
        this.#regex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+\\-])?(\\d{2})?'?(\\d{2})?'?");
        const matches = this.#regex.exec(input);
        if (!matches) return null;
        const year = parseInt(matches[1], 10);
        let month = parseInt(matches[2], 10);
        month = month >= 1 && month <= 12 ? month - 1 : 0;
        let day = parseInt(matches[3], 10);
        day = day >= 1 && day <= 31 ? day : 1;
        let hour = parseInt(matches[4], 10);
        hour = hour >= 0 && hour <= 23 ? hour : 0;
        let minute = parseInt(matches[5], 10);
        minute = minute >= 0 && minute <= 59 ? minute : 0;
        let second = parseInt(matches[6], 10);
        second = second >= 0 && second <= 59 ? second : 0;
        const universalTimeRelation = matches[7] || "Z";
        let offsetHour = parseInt(matches[8], 10);
        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
        let offsetMinute = parseInt(matches[9], 10) || 0;
        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
        if (universalTimeRelation === "-") {
            hour += offsetHour;
            minute += offsetMinute;
        } else if (universalTimeRelation === "+") {
            hour -= offsetHour;
            minute -= offsetMinute;
        }
        return new Date(Date.UTC(year, month, day, hour, minute, second));
    }
}
function $a2cc6e1d6eb3861b$export$c24a0a5c5129b2e1(color) {
    if (color.startsWith("#")) {
        const hex = color.slice(1);
        return [
            parseInt(hex.slice(0, 2), 16),
            parseInt(hex.slice(2, 4), 16),
            parseInt(hex.slice(4, 6), 16),
            hex.length >= 8 ? parseInt(hex.slice(6, 8), 16) / 255 : 1
        ];
    }
    if (color.startsWith("rgb(")) {
        const [r, g, b] = color.slice(4, -1).split(",").map((x)=>parseInt(x, 10));
        return [
            r,
            g,
            b,
            1
        ];
    }
    if (color.startsWith("rgba(")) {
        const parts = color.slice(5, -1).split(",");
        return [
            parseInt(parts[0], 10),
            parseInt(parts[1], 10),
            parseInt(parts[2], 10),
            parseFloat(parts[3])
        ];
    }
    const m = color.match(/^color\(srgb\s+([\d.]+)\s+([\d.]+)\s+([\d.]+)(?:\s*\/\s*([\d.]+|none))?\)$/);
    if (m) return [
        Math.round(parseFloat(m[1]) * 255),
        Math.round(parseFloat(m[2]) * 255),
        Math.round(parseFloat(m[3]) * 255),
        m[4] !== undefined && m[4] !== "none" ? parseFloat(m[4]) : 1
    ];
    return null;
}
function $a2cc6e1d6eb3861b$export$2a2e9b507863ddda(color) {
    const rgba = $a2cc6e1d6eb3861b$export$c24a0a5c5129b2e1(color);
    if (!rgba) {
        $a2cc6e1d6eb3861b$var$warn(`Not a valid color format: "${color}"`);
        return [
            0,
            0,
            0
        ];
    }
    return rgba.slice(0, 3);
}
function $a2cc6e1d6eb3861b$var$getColorValues(colors) {
    const span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.colorScheme = "only light";
    document.body.append(span);
    for (const name of colors.keys()){
        span.style.color = name;
        const computedColor = window.getComputedStyle(span).color;
        colors.set(name, $a2cc6e1d6eb3861b$export$2a2e9b507863ddda(computedColor));
    }
    span.remove();
}
function $a2cc6e1d6eb3861b$var$getCurrentTransform(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $a2cc6e1d6eb3861b$var$getCurrentTransformInverse(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform().invertSelf();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $a2cc6e1d6eb3861b$export$af0a15a86e590226(div, viewport, mustFlip = false, mustRotate = true) {
    if (viewport instanceof $a2cc6e1d6eb3861b$var$PageViewport) {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = viewport.rawDims;
        const { style: style } = div;
        const widthStr = `round(down, var(--total-scale-factor) * ${pageWidth}px, var(--scale-round-x))`, heightStr = `round(down, var(--total-scale-factor) * ${pageHeight}px, var(--scale-round-y))`;
        if (!mustFlip || viewport.rotation % 180 === 0) {
            style.width = widthStr;
            style.height = heightStr;
        } else {
            style.width = heightStr;
            style.height = widthStr;
        }
    }
    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
}
class $a2cc6e1d6eb3861b$export$f16a99f63bccd50b {
    constructor(){
        const { pixelRatio: pixelRatio } = $a2cc6e1d6eb3861b$export$f16a99f63bccd50b;
        this.sx = pixelRatio;
        this.sy = pixelRatio;
    }
    get scaled() {
        return this.sx !== 1 || this.sy !== 1;
    }
    get symmetric() {
        return this.sx === this.sy;
    }
    limitCanvas(width, height, maxPixels, maxDim, capAreaFactor = -1) {
        let maxAreaScale = Infinity, maxWidthScale = Infinity, maxHeightScale = Infinity;
        maxPixels = $a2cc6e1d6eb3861b$export$f16a99f63bccd50b.capPixels(maxPixels, capAreaFactor);
        if (maxPixels > 0) maxAreaScale = Math.sqrt(maxPixels / (width * height));
        if (maxDim !== -1) {
            maxWidthScale = maxDim / width;
            maxHeightScale = maxDim / height;
        }
        const maxScale = Math.min(maxAreaScale, maxWidthScale, maxHeightScale);
        if (this.sx > maxScale || this.sy > maxScale) {
            this.sx = maxScale;
            this.sy = maxScale;
            return true;
        }
        return false;
    }
    static get pixelRatio() {
        return globalThis.devicePixelRatio || 1;
    }
    static capPixels(maxPixels, capAreaFactor) {
        if (capAreaFactor >= 0) {
            const winPixels = Math.ceil(window.screen.availWidth * window.screen.availHeight * this.pixelRatio ** 2 * (1 + capAreaFactor / 100));
            return maxPixels > 0 ? Math.min(maxPixels, winPixels) : winPixels;
        }
        return maxPixels;
    }
}
const $a2cc6e1d6eb3861b$export$3234c88e9de64a88 = [
    "image/apng",
    "image/avif",
    "image/bmp",
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "image/webp",
    "image/x-icon"
];
class $a2cc6e1d6eb3861b$var$ColorScheme {
    static get isDarkMode() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isDarkMode", !!window?.matchMedia?.("(prefers-color-scheme: dark)").matches);
    }
}
class $a2cc6e1d6eb3861b$export$cec677744f6a5015 {
    static get commentForegroundColor() {
        const element = document.createElement("span");
        element.classList.add("comment", "sidebar");
        const { style: style } = element;
        style.width = style.height = "0";
        style.display = "none";
        style.color = "var(--comment-fg-color)";
        document.body.append(element);
        const { color: color } = window.getComputedStyle(element);
        element.remove();
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "commentForegroundColor", $a2cc6e1d6eb3861b$export$2a2e9b507863ddda(color));
    }
}
function $a2cc6e1d6eb3861b$export$f8d1472813e87bf9(color, opacity) {
    opacity = $a2cc6e1d6eb3861b$export$b8106b171181a554(opacity ?? 1, 0, 1);
    const white = 255 * (1 - opacity);
    return color.map((c)=>Math.round(c * opacity + white));
}
function $a2cc6e1d6eb3861b$var$RGBToHSL(rgb, output) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    if (max === min) output[0] = output[1] = 0;
    else {
        const d = max - min;
        output[1] = l < 0.5 ? d / (max + min) : d / (2 - max - min);
        switch(max){
            case r:
                output[0] = ((g - b) / d + (g < b ? 6 : 0)) * 60;
                break;
            case g:
                output[0] = ((b - r) / d + 2) * 60;
                break;
            case b:
                output[0] = ((r - g) / d + 4) * 60;
                break;
        }
    }
    output[2] = l;
}
function $a2cc6e1d6eb3861b$var$HSLToRGB(hsl, output) {
    const h = hsl[0];
    const s = hsl[1];
    const l = hsl[2];
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(h / 60 % 2 - 1));
    const m = l - c / 2;
    switch(Math.floor(h / 60)){
        case 0:
            output[0] = c + m;
            output[1] = x + m;
            output[2] = m;
            break;
        case 1:
            output[0] = x + m;
            output[1] = c + m;
            output[2] = m;
            break;
        case 2:
            output[0] = m;
            output[1] = c + m;
            output[2] = x + m;
            break;
        case 3:
            output[0] = m;
            output[1] = x + m;
            output[2] = c + m;
            break;
        case 4:
            output[0] = x + m;
            output[1] = m;
            output[2] = c + m;
            break;
        case 5:
        case 6:
            output[0] = c + m;
            output[1] = m;
            output[2] = x + m;
            break;
    }
}
function $a2cc6e1d6eb3861b$var$computeLuminance(x) {
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
}
function $a2cc6e1d6eb3861b$var$contrastRatio(hsl1, hsl2, output) {
    $a2cc6e1d6eb3861b$var$HSLToRGB(hsl1, output);
    output.map($a2cc6e1d6eb3861b$var$computeLuminance);
    const lum1 = 0.2126 * output[0] + 0.7152 * output[1] + 0.0722 * output[2];
    $a2cc6e1d6eb3861b$var$HSLToRGB(hsl2, output);
    output.map($a2cc6e1d6eb3861b$var$computeLuminance);
    const lum2 = 0.2126 * output[0] + 0.7152 * output[1] + 0.0722 * output[2];
    return lum1 > lum2 ? (lum1 + 0.05) / (lum2 + 0.05) : (lum2 + 0.05) / (lum1 + 0.05);
}
const $a2cc6e1d6eb3861b$var$contrastCache = new Map();
function $a2cc6e1d6eb3861b$export$7a96203b1fdebe8d(baseColor, fixedColor) {
    const key = baseColor[0] + baseColor[1] * 0x100 + baseColor[2] * 0x10000 + fixedColor[0] * 0x1000000 + fixedColor[1] * 0x100000000 + fixedColor[2] * 0x10000000000;
    let cachedValue = $a2cc6e1d6eb3861b$var$contrastCache.get(key);
    if (cachedValue) return cachedValue;
    const array = new Float32Array(9);
    const output = array.subarray(0, 3);
    const baseHSL = array.subarray(3, 6);
    $a2cc6e1d6eb3861b$var$RGBToHSL(baseColor, baseHSL);
    const fixedHSL = array.subarray(6, 9);
    $a2cc6e1d6eb3861b$var$RGBToHSL(fixedColor, fixedHSL);
    const isFixedColorDark = fixedHSL[2] < 0.5;
    const minContrast = isFixedColorDark ? 12 : 4.5;
    baseHSL[2] = isFixedColorDark ? Math.sqrt(baseHSL[2]) : 1 - Math.sqrt(1 - baseHSL[2]);
    if ($a2cc6e1d6eb3861b$var$contrastRatio(baseHSL, fixedHSL, output) < minContrast) {
        let start, end;
        if (isFixedColorDark) {
            start = baseHSL[2];
            end = 1;
        } else {
            start = 0;
            end = baseHSL[2];
        }
        const PRECISION = 0.005;
        while(end - start > PRECISION){
            const mid = baseHSL[2] = (start + end) / 2;
            if (isFixedColorDark === $a2cc6e1d6eb3861b$var$contrastRatio(baseHSL, fixedHSL, output) < minContrast) start = mid;
            else end = mid;
        }
        baseHSL[2] = isFixedColorDark ? end : start;
    }
    $a2cc6e1d6eb3861b$var$HSLToRGB(baseHSL, output);
    cachedValue = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(Math.round(output[0] * 255), Math.round(output[1] * 255), Math.round(output[2] * 255));
    $a2cc6e1d6eb3861b$var$contrastCache.set(key, cachedValue);
    return cachedValue;
}
function $a2cc6e1d6eb3861b$export$611c480766035c4({ html: html, dir: dir, className: className }, container) {
    const fragment = document.createDocumentFragment();
    if (typeof html === "string") {
        const p = document.createElement("p");
        p.dir = dir || "auto";
        const lines = html.split(/\r\n?|\n/);
        for(let i = 0, ii = lines.length; i < ii; ++i){
            const line = lines[i];
            p.append(document.createTextNode(line));
            if (i < ii - 1) p.append(document.createElement("br"));
        }
        fragment.append(p);
    } else $a2cc6e1d6eb3861b$export$f6af20c312d4b9a2.render({
        xfaHtml: html,
        div: fragment,
        intent: "richText"
    });
    fragment.firstElementChild.classList.add("richText", className);
    container.append(fragment);
}
function $a2cc6e1d6eb3861b$var$makePathFromDrawOPS(data) {
    const path = new Path2D();
    if (!data) return path;
    for(let i = 0, ii = data.length; i < ii;)switch(data[i++]){
        case $a2cc6e1d6eb3861b$var$DrawOPS.moveTo:
            path.moveTo(data[i++], data[i++]);
            break;
        case $a2cc6e1d6eb3861b$var$DrawOPS.lineTo:
            path.lineTo(data[i++], data[i++]);
            break;
        case $a2cc6e1d6eb3861b$var$DrawOPS.curveTo:
            path.bezierCurveTo(data[i++], data[i++], data[i++], data[i++], data[i++], data[i++]);
            break;
        case $a2cc6e1d6eb3861b$var$DrawOPS.quadraticCurveTo:
            path.quadraticCurveTo(data[i++], data[i++], data[i++], data[i++]);
            break;
        case $a2cc6e1d6eb3861b$var$DrawOPS.closePath:
            path.closePath();
            break;
        default:
            $a2cc6e1d6eb3861b$var$warn(`Unrecognized drawing path operator: ${data[i - 1]}`);
            break;
    }
    return path;
}
class $a2cc6e1d6eb3861b$var$EditorToolbar {
    #toolbar = null;
    #colorPicker = null;
    #editor;
    #buttons = null;
    #altText = null;
    #comment = null;
    #commentButtonDivider = null;
    #signatureDescriptionButton = null;
    static #l10nRemove = null;
    constructor(editor){
        this.#editor = editor;
        $a2cc6e1d6eb3861b$var$EditorToolbar.#l10nRemove ||= Object.freeze({
            freetext: "pdfjs-editor-remove-freetext-button",
            highlight: "pdfjs-editor-remove-highlight-button",
            ink: "pdfjs-editor-remove-ink-button",
            stamp: "pdfjs-editor-remove-stamp-button",
            signature: "pdfjs-editor-remove-signature-button"
        });
    }
    render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.classList.add("editToolbar", "hidden");
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#editor._uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) {
            editToolbar.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
                signal: signal
            });
            editToolbar.addEventListener("pointerdown", $a2cc6e1d6eb3861b$var$EditorToolbar.#pointerDown, {
                signal: signal
            });
        }
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        const position = this.#editor.toolbarPosition;
        if (position) {
            const { style: style } = editToolbar;
            const x = this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0];
            style.insetInlineEnd = `${100 * x}%`;
            style.top = `calc(${100 * position[1]}% + var(--editor-toolbar-vert-offset))`;
        }
        return editToolbar;
    }
    get div() {
        return this.#toolbar;
    }
    static #pointerDown(e) {
        e.stopPropagation();
    }
    #focusIn(e) {
        this.#editor._focusEventsAllowed = false;
        $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e);
    }
    #focusOut(e) {
        this.#editor._focusEventsAllowed = true;
        $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e);
    }
    #addListenersToElement(element) {
        const signal = this.#editor._uiManager._signal;
        if (!(signal instanceof AbortSignal) || signal.aborted) return false;
        element.addEventListener("focusin", this.#focusIn.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("focusout", this.#focusOut.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
            signal: signal
        });
        return true;
    }
    hide() {
        this.#toolbar.classList.add("hidden");
        this.#colorPicker?.hideDropdown();
    }
    show() {
        this.#toolbar.classList.remove("hidden");
        this.#altText?.shown();
        this.#comment?.shown();
    }
    addDeleteButton() {
        const { editorType: editorType, _uiManager: _uiManager } = this.#editor;
        const button = document.createElement("button");
        button.classList.add("basic", "deleteButton");
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", $a2cc6e1d6eb3861b$var$EditorToolbar.#l10nRemove[editorType]);
        if (this.#addListenersToElement(button)) button.addEventListener("click", (e)=>{
            _uiManager.delete();
        }, {
            signal: _uiManager._signal
        });
        this.#buttons.append(button);
    }
    get #divider() {
        const divider = document.createElement("div");
        divider.className = "divider";
        return divider;
    }
    async addAltText(altText) {
        const button = await altText.render();
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
        this.#altText = altText;
    }
    addComment(comment, beforeElement = null) {
        if (this.#comment) return;
        const button = comment.renderForToolbar();
        if (!button) return;
        this.#addListenersToElement(button);
        const divider = this.#commentButtonDivider = this.#divider;
        if (!beforeElement) this.#buttons.append(button, divider);
        else {
            this.#buttons.insertBefore(button, beforeElement);
            this.#buttons.insertBefore(divider, beforeElement);
        }
        this.#comment = comment;
        comment.toolbar = this;
    }
    addColorPicker(colorPicker) {
        if (this.#colorPicker) return;
        this.#colorPicker = colorPicker;
        const button = colorPicker.renderButton();
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
    }
    async addEditSignatureButton(signatureManager) {
        const button = this.#signatureDescriptionButton = await signatureManager.renderEditButton(this.#editor);
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
    }
    removeButton(name) {
        switch(name){
            case "comment":
                this.#comment?.removeToolbarCommentButton();
                this.#comment = null;
                this.#commentButtonDivider?.remove();
                this.#commentButtonDivider = null;
                break;
        }
    }
    async addButton(name, tool) {
        switch(name){
            case "colorPicker":
                if (tool) this.addColorPicker(tool);
                break;
            case "altText":
                if (tool) await this.addAltText(tool);
                break;
            case "editSignature":
                if (tool) await this.addEditSignatureButton(tool);
                break;
            case "delete":
                this.addDeleteButton();
                break;
            case "comment":
                if (tool) this.addComment(tool);
                break;
        }
    }
    async addButtonBefore(name, tool, beforeSelector) {
        if (!tool && name === "comment") return;
        const beforeElement = this.#buttons.querySelector(beforeSelector);
        if (!beforeElement) return;
        if (name === "comment") this.addComment(tool, beforeElement);
    }
    updateEditSignatureButton(description) {
        if (this.#signatureDescriptionButton) this.#signatureDescriptionButton.title = description;
    }
    remove() {
        this.#toolbar.remove();
        this.#colorPicker?.destroy();
        this.#colorPicker = null;
    }
}
class $a2cc6e1d6eb3861b$var$FloatingToolbar {
    #buttons = null;
    #toolbar = null;
    #uiManager;
    constructor(uiManager){
        this.#uiManager = uiManager;
    }
    #render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.className = "editToolbar";
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) editToolbar.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
            signal: signal
        });
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        if (this.#uiManager.hasCommentManager()) this.#makeButton("commentButton", `pdfjs-comment-floating-button`, "pdfjs-comment-floating-button-label", ()=>{
            this.#uiManager.commentSelection("floating_button");
        });
        this.#makeButton("highlightButton", `pdfjs-highlight-floating-button1`, "pdfjs-highlight-floating-button-label", ()=>{
            this.#uiManager.highlightSelection("floating_button");
        });
        return editToolbar;
    }
    #getLastPoint(boxes, isLTR) {
        let lastY = 0;
        let lastX = 0;
        for (const box of boxes){
            const y = box.y + box.height;
            if (y < lastY) continue;
            const x = box.x + (isLTR ? box.width : 0);
            if (y > lastY) {
                lastX = x;
                lastY = y;
                continue;
            }
            if (isLTR) {
                if (x > lastX) lastX = x;
            } else if (x < lastX) lastX = x;
        }
        return [
            isLTR ? 1 - lastX : lastX,
            lastY
        ];
    }
    show(parent, boxes, isLTR) {
        const [x, y] = this.#getLastPoint(boxes, isLTR);
        const { style: style } = this.#toolbar ||= this.#render();
        parent.append(this.#toolbar);
        style.insetInlineEnd = `${100 * x}%`;
        style.top = `calc(${100 * y}% + var(--editor-toolbar-vert-offset))`;
    }
    hide() {
        this.#toolbar.remove();
    }
    #makeButton(buttonClass, l10nId, labelL10nId, clickHandler) {
        const button = document.createElement("button");
        button.classList.add("basic", buttonClass);
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", l10nId);
        const span = document.createElement("span");
        button.append(span);
        span.className = "visuallyHidden";
        span.setAttribute("data-l10n-id", labelL10nId);
        const signal = this.#uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) {
            button.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
                signal: signal
            });
            button.addEventListener("click", clickHandler, {
                signal: signal
            });
        }
        this.#buttons.append(button);
    }
}
const $a2cc6e1d6eb3861b$var$INTERNAL_EVT = "9556e50a-f4f8-4f57-9831-f9ddff0176eb";
const $a2cc6e1d6eb3861b$var$internalOpt = Object.freeze({
    internal: $a2cc6e1d6eb3861b$var$INTERNAL_EVT
});
function $a2cc6e1d6eb3861b$var$bindEvents(obj, element, names) {
    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
}
class $a2cc6e1d6eb3861b$var$CurrentPointers {
    static #pointerId = NaN;
    static #pointerIds = null;
    static #moveTimestamp = NaN;
    static #pointerType = null;
    static initializeAndAddPointerId(pointerId) {
        ($a2cc6e1d6eb3861b$var$CurrentPointers.#pointerIds ||= new Set()).add(pointerId);
    }
    static setPointer(pointerType, pointerId) {
        $a2cc6e1d6eb3861b$var$CurrentPointers.#pointerId ||= pointerId;
        $a2cc6e1d6eb3861b$var$CurrentPointers.#pointerType ??= pointerType;
    }
    static setTimeStamp(timeStamp) {
        $a2cc6e1d6eb3861b$var$CurrentPointers.#moveTimestamp = timeStamp;
    }
    static isSamePointerId(pointerId) {
        return $a2cc6e1d6eb3861b$var$CurrentPointers.#pointerId === pointerId;
    }
    static isSamePointerIdOrRemove(pointerId) {
        if ($a2cc6e1d6eb3861b$var$CurrentPointers.#pointerId === pointerId) return true;
        $a2cc6e1d6eb3861b$var$CurrentPointers.#pointerIds?.delete(pointerId);
        return false;
    }
    static isSamePointerType(pointerType) {
        return $a2cc6e1d6eb3861b$var$CurrentPointers.#pointerType === pointerType;
    }
    static isInitializedAndDifferentPointerType(pointerType) {
        return $a2cc6e1d6eb3861b$var$CurrentPointers.#pointerType !== null && !$a2cc6e1d6eb3861b$var$CurrentPointers.isSamePointerType(pointerType);
    }
    static isSameTimeStamp(timeStamp) {
        return $a2cc6e1d6eb3861b$var$CurrentPointers.#moveTimestamp === timeStamp;
    }
    static isUsingMultiplePointers() {
        return $a2cc6e1d6eb3861b$var$CurrentPointers.#pointerIds?.size >= 1;
    }
    static clearPointerType() {
        $a2cc6e1d6eb3861b$var$CurrentPointers.#pointerType = null;
    }
    static clearPointerIds() {
        $a2cc6e1d6eb3861b$var$CurrentPointers.#pointerId = NaN;
        $a2cc6e1d6eb3861b$var$CurrentPointers.#pointerIds = null;
    }
    static clearTimeStamp() {
        $a2cc6e1d6eb3861b$var$CurrentPointers.#moveTimestamp = NaN;
    }
}
class $a2cc6e1d6eb3861b$var$IdManager {
    #id = 0;
    get id() {
        return `${$a2cc6e1d6eb3861b$var$AnnotationEditorPrefix}${this.#id++}`;
    }
}
class $a2cc6e1d6eb3861b$var$ImageManager {
    #baseId = $a2cc6e1d6eb3861b$export$75f13a91ebdf8eb3();
    #id = 0;
    #cache = null;
    static get _isSVGFittingCanvas() {
        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="${$a2cc6e1d6eb3861b$var$SVG_NS}"><rect width="1" height="1" style="fill:red;"/></svg>`;
        const canvas = new OffscreenCanvas(1, 3);
        const ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        const image = new Image();
        image.src = svg;
        const promise = image.decode().then(()=>{
            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
        });
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_isSVGFittingCanvas", promise);
    }
    async #get(key, rawData) {
        this.#cache ||= new Map();
        let data = this.#cache.get(key);
        if (data === null) return null;
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        try {
            data ||= {
                bitmap: null,
                id: `image_${this.#baseId}_${this.#id++}`,
                refCounter: 0,
                isSvg: false
            };
            let image;
            if (typeof rawData === "string") {
                data.url = rawData;
                image = await $a2cc6e1d6eb3861b$export$8134c072fddab6a5(rawData, "blob");
            } else if (rawData instanceof File) image = data.file = rawData;
            else if (rawData instanceof Blob) image = rawData;
            if (image.type === "image/svg+xml") {
                const mustRemoveAspectRatioPromise = $a2cc6e1d6eb3861b$var$ImageManager._isSVGFittingCanvas;
                const fileReader = new FileReader();
                const imageElement = new Image();
                const imagePromise = new Promise((resolve, reject)=>{
                    imageElement.onload = ()=>{
                        data.bitmap = imageElement;
                        data.isSvg = true;
                        resolve();
                    };
                    fileReader.onload = async ()=>{
                        const url = data.svgUrl = fileReader.result;
                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                    };
                    imageElement.onerror = fileReader.onerror = reject;
                });
                fileReader.readAsDataURL(image);
                await imagePromise;
            } else data.bitmap = await createImageBitmap(image);
            data.refCounter = 1;
        } catch (e) {
            $a2cc6e1d6eb3861b$var$warn(e);
            data = null;
        }
        this.#cache.set(key, data);
        if (data) this.#cache.set(data.id, data);
        return data;
    }
    async getFromFile(file) {
        const { lastModified: lastModified, name: name, size: size, type: type } = file;
        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
    }
    async getFromUrl(url) {
        return this.#get(url, url);
    }
    async getFromBlob(id, blobPromise) {
        const blob = await blobPromise;
        return this.#get(id, blob);
    }
    async getFromId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return null;
        if (data.bitmap) {
            data.refCounter += 1;
            return data;
        }
        if (data.file) return this.getFromFile(data.file);
        if (data.blobPromise) {
            const { blobPromise: blobPromise } = data;
            delete data.blobPromise;
            return this.getFromBlob(data.id, blobPromise);
        }
        return this.getFromUrl(data.url);
    }
    getFromCanvas(id, canvas) {
        this.#cache ||= new Map();
        let data = this.#cache.get(id);
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        const offscreen = new OffscreenCanvas(canvas.width, canvas.height);
        const ctx = offscreen.getContext("2d");
        ctx.drawImage(canvas, 0, 0);
        data = {
            bitmap: offscreen.transferToImageBitmap(),
            id: `image_${this.#baseId}_${this.#id++}`,
            refCounter: 1,
            isSvg: false
        };
        this.#cache.set(id, data);
        this.#cache.set(data.id, data);
        return data;
    }
    getSvgUrl(id) {
        const data = this.#cache.get(id);
        if (!data?.isSvg) return null;
        return data.svgUrl;
    }
    deleteId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return;
        data.refCounter -= 1;
        if (data.refCounter !== 0) return;
        const { bitmap: bitmap } = data;
        if (!data.url && !data.file) {
            const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
            const ctx = canvas.getContext("bitmaprenderer");
            ctx.transferFromImageBitmap(bitmap);
            data.blobPromise = canvas.convertToBlob();
        }
        bitmap.close?.();
        data.bitmap = null;
    }
    isValidId(id) {
        return id.startsWith(`image_${this.#baseId}_`);
    }
}
class $a2cc6e1d6eb3861b$var$CommandManager {
    #commands = [];
    #locked = false;
    #maxSize;
    #position = -1;
    constructor(maxSize = 128){
        this.#maxSize = maxSize;
    }
    add({ cmd: cmd, undo: undo, post: post, mustExec: mustExec, type: type = NaN, overwriteIfSameType: overwriteIfSameType = false, keepUndo: keepUndo = false }) {
        if (mustExec) cmd();
        if (this.#locked) return;
        const save = {
            cmd: cmd,
            undo: undo,
            post: post,
            type: type
        };
        if (this.#position === -1) {
            if (this.#commands.length > 0) this.#commands.length = 0;
            this.#position = 0;
            this.#commands.push(save);
            return;
        }
        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
            if (keepUndo) save.undo = this.#commands[this.#position].undo;
            this.#commands[this.#position] = save;
            return;
        }
        const next = this.#position + 1;
        if (next === this.#maxSize) this.#commands.splice(0, 1);
        else {
            this.#position = next;
            if (next < this.#commands.length) this.#commands.splice(next);
        }
        this.#commands.push(save);
    }
    undo() {
        if (this.#position === -1) return;
        this.#locked = true;
        const { undo: undo, post: post } = this.#commands[this.#position];
        undo();
        post?.();
        this.#locked = false;
        this.#position -= 1;
    }
    redo() {
        if (this.#position < this.#commands.length - 1) {
            this.#position += 1;
            this.#locked = true;
            const { cmd: cmd, post: post } = this.#commands[this.#position];
            cmd();
            post?.();
            this.#locked = false;
        }
    }
    hasSomethingToUndo() {
        return this.#position !== -1;
    }
    hasSomethingToRedo() {
        return this.#position < this.#commands.length - 1;
    }
    cleanType(type) {
        if (this.#position === -1) return;
        for(let i = this.#position; i >= 0; i--)if (this.#commands[i].type !== type) {
            this.#commands.splice(i + 1, this.#position - i);
            this.#position = i;
            return;
        }
        this.#commands.length = 0;
        this.#position = -1;
    }
    destroy() {
        this.#commands = null;
    }
}
class $a2cc6e1d6eb3861b$var$KeyboardManager {
    constructor(callbacks){
        this.buffer = [];
        this.callbacks = new Map();
        this.allKeys = new Set();
        const { isMac: isMac } = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform;
        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
            const isMacKey = key.startsWith("mac+");
            if (isMac && isMacKey) {
                this.callbacks.set(key.slice(4), {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            } else if (!isMac && !isMacKey) {
                this.callbacks.set(key, {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            }
        }
    }
    #serialize(event) {
        if (event.altKey) this.buffer.push("alt");
        if (event.ctrlKey) this.buffer.push("ctrl");
        if (event.metaKey) this.buffer.push("meta");
        if (event.shiftKey) this.buffer.push("shift");
        this.buffer.push(event.key);
        const str = this.buffer.join("+");
        this.buffer.length = 0;
        return str;
    }
    exec(self, event) {
        if (!this.allKeys.has(event.key)) return;
        const info = this.callbacks.get(this.#serialize(event));
        if (!info) return;
        const { callback: callback, options: { bubbles: bubbles = false, args: args = [], checker: checker = null } } = info;
        if (checker && !checker(self, event)) return;
        callback.bind(self, ...args, event)();
        if (!bubbles) $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(event);
    }
}
class $a2cc6e1d6eb3861b$var$ColorManager {
    static _colorsMapping = new Map([
        [
            "CanvasText",
            [
                0,
                0,
                0
            ]
        ],
        [
            "Canvas",
            [
                255,
                255,
                255
            ]
        ]
    ]);
    get _colors() {
        const colors = new Map([
            [
                "CanvasText",
                null
            ],
            [
                "Canvas",
                null
            ]
        ]);
        $a2cc6e1d6eb3861b$var$getColorValues(colors);
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_colors", colors);
    }
    convert(color) {
        const rgb = $a2cc6e1d6eb3861b$export$2a2e9b507863ddda(color);
        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
        for (const [name, RGB] of this._colors){
            if (RGB.every((x, i)=>x === rgb[i])) return $a2cc6e1d6eb3861b$var$ColorManager._colorsMapping.get(name);
        }
        return rgb;
    }
    getHexCode(name) {
        const rgb = this._colors.get(name);
        if (!rgb) return name;
        return $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(...rgb);
    }
}
class $a2cc6e1d6eb3861b$export$26cb16552a82cf63 {
    #abortController = new AbortController();
    #activeEditor = null;
    #allEditableAnnotations = null;
    #allEditors = new Map();
    #allLayers = new Map();
    #savedAllLayers = null;
    #altTextManager = null;
    #annotationStorage = null;
    #changedExistingAnnotations = null;
    #commandManager = new $a2cc6e1d6eb3861b$var$CommandManager();
    #commentManager = null;
    #copyPasteAC = null;
    #currentDrawingSession = null;
    #currentPageIndex = 0;
    #deletedAnnotationsElementIds = new Set();
    #draggingEditors = null;
    #editorTypes = null;
    #editorsToRescale = new Set();
    _editorUndoBar = null;
    #enableHighlightFloatingButton = false;
    #enableUpdatedAddImage = false;
    #enableNewAltTextWhenAddingImage = false;
    #filterFactory = null;
    #focusMainContainerTimeoutId = null;
    #focusManagerAC = null;
    #highlightColors = null;
    #highlightWhenShiftUp = false;
    #floatingToolbar = null;
    #idManager = new $a2cc6e1d6eb3861b$var$IdManager();
    #isEnabled = false;
    #isPointerDown = false;
    #isWaiting = false;
    #keyboardManagerAC = null;
    #lastActiveElement = null;
    #mainHighlightColorPicker = null;
    #missingCanvases = null;
    #mlManager = null;
    #mode = $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE;
    #selectedEditors = new Set();
    #selectedTextNode = null;
    #signatureManager = null;
    #pageColors = null;
    #showAllStates = null;
    #pdfDocument = null;
    #previousStates = {
        isEditing: false,
        isEmpty: true,
        hasSomethingToUndo: false,
        hasSomethingToRedo: false,
        hasSelectedEditor: false,
        hasSelectedText: false
    };
    #translation = [
        0,
        0
    ];
    #translationTimeoutId = null;
    #container = null;
    #viewer = null;
    #viewerAlert = null;
    #updateModeCapability = null;
    static TRANSLATE_SMALL = 1;
    static TRANSLATE_BIG = 10;
    static get _keyboardManager() {
        const proto = $a2cc6e1d6eb3861b$export$26cb16552a82cf63.prototype;
        const arrowChecker = (self)=>self.#container.contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && self.hasSomethingToControl();
        const textInputChecker = (_self, { target: el })=>{
            if (el instanceof HTMLInputElement) {
                const { type: type } = el;
                return type !== "text" && type !== "number";
            }
            return true;
        };
        const small = this.TRANSLATE_SMALL;
        const big = this.TRANSLATE_BIG;
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_keyboardManager", new $a2cc6e1d6eb3861b$var$KeyboardManager([
            [
                [
                    "ctrl+a",
                    "mac+meta+a"
                ],
                proto.selectAll,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+z",
                    "mac+meta+z"
                ],
                proto.undo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+y",
                    "ctrl+shift+z",
                    "mac+meta+shift+z",
                    "ctrl+shift+Z",
                    "mac+meta+shift+Z"
                ],
                proto.redo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Backspace",
                    "alt+Backspace",
                    "ctrl+Backspace",
                    "shift+Backspace",
                    "mac+Backspace",
                    "mac+alt+Backspace",
                    "mac+ctrl+Backspace",
                    "Delete",
                    "ctrl+Delete",
                    "shift+Delete",
                    "mac+Delete"
                ],
                proto.delete,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Enter",
                    "mac+Enter"
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(el) && !self.isEnterHandled
                }
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(document.activeElement)
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                proto.unselectAll
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    constructor(container, viewer, viewerAlert, altTextManager, commentManager, signatureManager, eventBus, pdfDocument, pageColors, highlightColors, enableHighlightFloatingButton, enableUpdatedAddImage, enableNewAltTextWhenAddingImage, mlManager, editorUndoBar, supportsPinchToZoom){
        const signal = this._signal = this.#abortController.signal;
        this.#container = container;
        this.#viewer = viewer;
        this.#viewerAlert = viewerAlert;
        this.#altTextManager = altTextManager;
        this.#commentManager = commentManager;
        this.#signatureManager = signatureManager;
        this.#pdfDocument = pdfDocument;
        this._eventBus = eventBus;
        const evtOpts = {
            signal: signal,
            ...$a2cc6e1d6eb3861b$var$internalOpt
        };
        eventBus.on("editingaction", this.onEditingAction.bind(this), evtOpts);
        eventBus.on("pagechanging", this.onPageChanging.bind(this), evtOpts);
        eventBus.on("scalechanging", this.onScaleChanging.bind(this), evtOpts);
        eventBus.on("rotationchanging", this.onRotationChanging.bind(this), evtOpts);
        eventBus.on("setpreference", this.onSetPreference.bind(this), evtOpts);
        eventBus.on("switchannotationeditorparams", (evt)=>this.updateParams(evt.type, evt.value), evtOpts);
        window.addEventListener("pointerdown", ()=>{
            this.#isPointerDown = true;
        }, {
            capture: true,
            signal: signal
        });
        window.addEventListener("pointerup", ()=>{
            this.#isPointerDown = false;
        }, {
            capture: true,
            signal: signal
        });
        window.addEventListener("beforeunload", this.#beforeUnload.bind(this), {
            capture: true,
            signal: signal
        });
        this.#addSelectionListener();
        this.#addDragAndDropListeners();
        this.#addKeyboardManager();
        this.#annotationStorage = pdfDocument.annotationStorage;
        this.#filterFactory = pdfDocument.filterFactory;
        this.#pageColors = pageColors;
        this.#highlightColors = highlightColors || null;
        this.#enableHighlightFloatingButton = enableHighlightFloatingButton;
        this.#enableUpdatedAddImage = enableUpdatedAddImage;
        this.#enableNewAltTextWhenAddingImage = enableNewAltTextWhenAddingImage;
        this.#mlManager = mlManager || null;
        this.viewParameters = {
            realScale: $a2cc6e1d6eb3861b$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS,
            rotation: 0
        };
        this.isShiftKeyDown = false;
        this._editorUndoBar = editorUndoBar || null;
        this._supportsPinchToZoom = supportsPinchToZoom !== false;
        commentManager?.setSidebarUiManager(this);
    }
    destroy() {
        this.#updateModeCapability?.resolve();
        this.#updateModeCapability = null;
        this.#abortController?.abort();
        this.#abortController = null;
        this._signal = null;
        for (const layer of this.#allLayers.values())layer.destroy();
        this.#allLayers.clear();
        this.#allEditors.clear();
        this.#editorsToRescale.clear();
        this.#missingCanvases?.clear();
        this.#activeEditor = null;
        this.#selectedEditors.clear();
        this.#commandManager.destroy();
        this.#altTextManager?.destroy();
        this.#commentManager?.destroy();
        this.#signatureManager?.destroy();
        this.#floatingToolbar?.hide();
        this.#floatingToolbar = null;
        this.#mainHighlightColorPicker?.destroy();
        this.#mainHighlightColorPicker = null;
        this.#allEditableAnnotations = null;
        if (this.#focusMainContainerTimeoutId) {
            clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = null;
        }
        if (this.#translationTimeoutId) {
            clearTimeout(this.#translationTimeoutId);
            this.#translationTimeoutId = null;
        }
        this._editorUndoBar?.destroy();
        this.#pdfDocument = null;
    }
    combinedSignal(ac) {
        return AbortSignal.any([
            this._signal,
            ac.signal
        ]);
    }
    get mlManager() {
        return this.#mlManager;
    }
    get useNewAltTextFlow() {
        return this.#enableUpdatedAddImage;
    }
    get useNewAltTextWhenAddingImage() {
        return this.#enableNewAltTextWhenAddingImage;
    }
    get hcmFilter() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
    }
    get direction() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "direction", getComputedStyle(this.#container).direction);
    }
    get _highlightColors() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_highlightColors", this.#highlightColors ? new Map(this.#highlightColors.split(",").map((pair)=>{
            pair = pair.split("=").map((x)=>x.trim());
            pair[1] = pair[1].toUpperCase();
            return pair;
        })) : null);
    }
    get highlightColors() {
        const { _highlightColors: _highlightColors } = this;
        if (!_highlightColors) return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "highlightColors", null);
        const map = new Map();
        const hasHCM = !!this.#pageColors;
        for (const [name, color] of _highlightColors){
            const isNameForHCM = name.endsWith("_HCM");
            if (hasHCM && isNameForHCM) {
                map.set(name.replace("_HCM", ""), color);
                continue;
            }
            if (!hasHCM && !isNameForHCM) map.set(name, color);
        }
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "highlightColors", map);
    }
    get highlightColorNames() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, (e)=>e.reverse())) : null);
    }
    getNonHCMColor(color) {
        if (!this._highlightColors) return color;
        const colorName = this.highlightColorNames.get(color);
        return this._highlightColors.get(colorName) || color;
    }
    getNonHCMColorName(color) {
        return this.highlightColorNames.get(color) || color;
    }
    setCurrentDrawingSession(layer) {
        if (layer) {
            this.unselectAll();
            this.disableUserSelect(true);
        } else this.disableUserSelect(false);
        this.#currentDrawingSession = layer;
    }
    setMainHighlightColorPicker(colorPicker) {
        this.#mainHighlightColorPicker = colorPicker;
    }
    editAltText(editor, firstTime = false) {
        this.#altTextManager?.editAltText(this, editor, firstTime);
    }
    hasCommentManager() {
        return !!this.#commentManager;
    }
    editComment(editor, posX, posY, options) {
        this.#commentManager?.showDialog(this, editor, posX, posY, options);
    }
    selectComment(pageIndex, uid) {
        const layer = this.#allLayers.get(pageIndex);
        const editor = layer?.getEditorByUID(uid);
        editor?.toggleComment(true, true);
    }
    updateComment(editor) {
        this.#commentManager?.updateComment(editor.getData());
    }
    updatePopupColor(editor) {
        this.#commentManager?.updatePopupColor(editor);
    }
    removeComment(editor) {
        this.#commentManager?.removeComments([
            editor.uid
        ]);
    }
    deleteComment(editor, savedData) {
        const undo = ()=>{
            editor.comment = savedData;
        };
        const cmd = ()=>{
            this._editorUndoBar?.show(undo, "comment");
            this.toggleComment(null);
            editor.comment = null;
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    }
    toggleComment(editor, isSelected, visibility) {
        this.#commentManager?.toggleCommentPopup(editor, isSelected, visibility);
    }
    makeCommentColor(color, opacity) {
        return color && this.#commentManager?.makeCommentColor(color, opacity) || null;
    }
    getCommentDialogElement() {
        return this.#commentManager?.dialogElement || null;
    }
    async waitForEditorsRendered(pageNumber) {
        if (this.#allLayers.has(pageNumber - 1)) return;
        const { resolve: resolve, promise: promise } = Promise.withResolvers();
        const onEditorsRendered = (evt)=>{
            if (evt.pageNumber === pageNumber) {
                this._eventBus.off("editorsrendered", onEditorsRendered);
                resolve();
            }
        };
        this._eventBus.on("editorsrendered", onEditorsRendered);
        await promise;
    }
    getSignature(editor) {
        this.#signatureManager?.getSignature({
            uiManager: this,
            editor: editor
        });
    }
    get signatureManager() {
        return this.#signatureManager;
    }
    switchToMode(mode, callback) {
        this._eventBus.on("annotationeditormodechanged", callback, {
            once: true,
            signal: this._signal
        });
        this._eventBus.dispatch("showannotationeditorui", {
            source: this,
            mode: mode
        });
    }
    setPreference(name, value) {
        this._eventBus.dispatch("setpreference", {
            source: this,
            name: name,
            value: value
        });
    }
    onSetPreference({ name: name, value: value }) {
        switch(name){
            case "enableNewAltTextWhenAddingImage":
                this.#enableNewAltTextWhenAddingImage = value;
                break;
        }
    }
    onPageChanging({ pageNumber: pageNumber }) {
        this.#currentPageIndex = pageNumber - 1;
    }
    deletePage(id) {
        for (const editor of this.getEditors(id))editor.remove();
        this.#allLayers.delete(id);
        if (this.#currentPageIndex === id) this.#currentPageIndex = 0;
    }
    focusMainContainer() {
        this.#container.focus();
    }
    findParent(x, y) {
        for (const layer of this.#allLayers.values()){
            const { x: layerX, y: layerY, width: width, height: height } = layer.div.getBoundingClientRect();
            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
        }
        return null;
    }
    disableUserSelect(value = false) {
        this.#viewer.classList.toggle("noUserSelect", value);
    }
    addShouldRescale(editor) {
        this.#editorsToRescale.add(editor);
    }
    removeShouldRescale(editor) {
        this.#editorsToRescale.delete(editor);
    }
    onScaleChanging({ scale: scale }) {
        this.commitOrRemove();
        this.viewParameters.realScale = scale * $a2cc6e1d6eb3861b$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS;
        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
        this.#currentDrawingSession?.onScaleChanging();
    }
    onRotationChanging({ pagesRotation: pagesRotation }) {
        this.commitOrRemove();
        this.viewParameters.rotation = pagesRotation;
    }
    #getAnchorElementForSelection({ anchorNode: anchorNode }) {
        return anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentElement : anchorNode;
    }
    #getLayerForTextLayer(textLayer) {
        const { currentLayer: currentLayer } = this;
        if (currentLayer.hasTextLayer(textLayer)) return currentLayer;
        for (const layer of this.#allLayers.values()){
            if (layer.hasTextLayer(textLayer)) return layer;
        }
        return null;
    }
    highlightSelection(methodOfCreation = "", comment = false) {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = selection;
        const text = selection.toString();
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        selection.empty();
        const layer = this.#getLayerForTextLayer(textLayer);
        const isNoneMode = this.#mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE;
        const callback = ()=>{
            const editor = layer?.createAndAddNewEditor({
                x: 0,
                y: 0
            }, false, {
                methodOfCreation: methodOfCreation,
                boxes: boxes,
                anchorNode: anchorNode,
                anchorOffset: anchorOffset,
                focusNode: focusNode,
                focusOffset: focusOffset,
                text: text
            });
            if (isNoneMode) this.showAllEditors("highlight", true, true);
            if (comment) editor?.editComment();
        };
        if (isNoneMode) {
            this.switchToMode($a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT, callback);
            return;
        }
        callback();
    }
    commentSelection(methodOfCreation = "") {
        this.highlightSelection(methodOfCreation, true);
    }
    #beforeUnload(e) {
        this.commitOrRemove();
        this.currentLayer?.endDrawingSession(false);
    }
    #displayFloatingToolbar() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        this.#floatingToolbar ||= new $a2cc6e1d6eb3861b$var$FloatingToolbar(this);
        this.#floatingToolbar.show(textLayer, boxes, this.direction === "ltr");
    }
    getAndRemoveDataFromAnnotationStorage(annotationId) {
        if (!this.#annotationStorage) return null;
        const key = `${$a2cc6e1d6eb3861b$var$AnnotationEditorPrefix}${annotationId}`;
        const storedValue = this.#annotationStorage.getRawValue(key);
        if (storedValue) this.#annotationStorage.remove(key);
        return storedValue;
    }
    addToAnnotationStorage(editor) {
        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
    }
    a11yAlert(messageId, args = null) {
        const viewerAlert = this.#viewerAlert;
        if (!viewerAlert) return;
        viewerAlert.setAttribute("data-l10n-id", messageId);
        if (args) viewerAlert.setAttribute("data-l10n-args", JSON.stringify(args));
        else viewerAlert.removeAttribute("data-l10n-args");
    }
    #selectionChange() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) {
            if (this.#selectedTextNode) {
                this.#floatingToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        const { anchorNode: anchorNode } = selection;
        if (anchorNode === this.#selectedTextNode) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        if (!textLayer) {
            if (this.#selectedTextNode) {
                this.#floatingToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        this.#floatingToolbar?.hide();
        this.#selectedTextNode = anchorNode;
        this.#dispatchUpdateStates({
            hasSelectedText: true
        });
        if (this.#mode !== $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT && this.#mode !== $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE) return;
        if (this.#mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT) this.showAllEditors("highlight", true, true);
        this.#highlightWhenShiftUp = this.isShiftKeyDown;
        if (!this.isShiftKeyDown) {
            const activeLayer = this.#mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT ? this.#getLayerForTextLayer(textLayer) : null;
            activeLayer?.toggleDrawing();
            if (this.#isPointerDown) {
                const ac = new AbortController();
                const signal = this.combinedSignal(ac);
                const pointerup = (e)=>{
                    if (e.type === "pointerup" && e.button !== 0) return;
                    ac.abort();
                    activeLayer?.toggleDrawing(true);
                    if (e.type === "pointerup") this.#onSelectEnd("main_toolbar");
                };
                window.addEventListener("pointerup", pointerup, {
                    signal: signal
                });
                window.addEventListener("blur", pointerup, {
                    signal: signal
                });
            } else {
                activeLayer?.toggleDrawing(true);
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    #onSelectEnd(methodOfCreation = "") {
        if (this.#mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT) this.highlightSelection(methodOfCreation);
        else if (this.#enableHighlightFloatingButton) this.#displayFloatingToolbar();
    }
    #addSelectionListener() {
        document.addEventListener("selectionchange", this.#selectionChange.bind(this), {
            signal: this._signal
        });
    }
    #addFocusManager() {
        if (this.#focusManagerAC) return;
        this.#focusManagerAC = new AbortController();
        const signal = this.combinedSignal(this.#focusManagerAC);
        window.addEventListener("focus", this.focus.bind(this), {
            signal: signal
        });
        window.addEventListener("blur", this.blur.bind(this), {
            signal: signal
        });
    }
    #removeFocusManager() {
        this.#focusManagerAC?.abort();
        this.#focusManagerAC = null;
    }
    blur() {
        this.isShiftKeyDown = false;
        if (this.#highlightWhenShiftUp) {
            this.#highlightWhenShiftUp = false;
            this.#onSelectEnd("main_toolbar");
        }
        if (!this.hasSelection) return;
        const { activeElement: activeElement } = document;
        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
            this.#lastActiveElement = [
                editor,
                activeElement
            ];
            editor._focusEventsAllowed = false;
            break;
        }
    }
    focus() {
        if (!this.#lastActiveElement) return;
        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
        this.#lastActiveElement = null;
        lastActiveElement.addEventListener("focusin", ()=>{
            lastEditor._focusEventsAllowed = true;
        }, {
            once: true,
            signal: this._signal
        });
        lastActiveElement.focus();
    }
    #addKeyboardManager() {
        if (this.#keyboardManagerAC) return;
        this.#keyboardManagerAC = new AbortController();
        const signal = this.combinedSignal(this.#keyboardManagerAC);
        window.addEventListener("keydown", this.keydown.bind(this), {
            signal: signal
        });
        window.addEventListener("keyup", this.keyup.bind(this), {
            signal: signal
        });
    }
    #removeKeyboardManager() {
        this.#keyboardManagerAC?.abort();
        this.#keyboardManagerAC = null;
    }
    #addCopyPasteListeners() {
        if (this.#copyPasteAC) return;
        this.#copyPasteAC = new AbortController();
        const signal = this.combinedSignal(this.#copyPasteAC);
        document.addEventListener("copy", this.copy.bind(this), {
            signal: signal
        });
        document.addEventListener("cut", this.cut.bind(this), {
            signal: signal
        });
        document.addEventListener("paste", this.paste.bind(this), {
            signal: signal
        });
    }
    #removeCopyPasteListeners() {
        this.#copyPasteAC?.abort();
        this.#copyPasteAC = null;
    }
    #addDragAndDropListeners() {
        const signal = this._signal;
        document.addEventListener("dragover", this.dragOver.bind(this), {
            signal: signal
        });
        document.addEventListener("drop", this.drop.bind(this), {
            signal: signal
        });
    }
    addEditListeners() {
        this.#addKeyboardManager();
        this.setEditingState(true);
    }
    removeEditListeners() {
        this.#removeKeyboardManager();
        this.setEditingState(false);
    }
    dragOver(event) {
        for (const { type: type } of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(type)) {
                event.dataTransfer.dropEffect = "copy";
                event.preventDefault();
                return;
            }
        }
    }
    drop(event) {
        for (const item of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                event.preventDefault();
                return;
            }
        }
    }
    copy(event) {
        event.preventDefault();
        this.#activeEditor?.commitOrRemove();
        if (!this.hasSelection) return;
        const editors = [];
        for (const editor of this.#selectedEditors){
            const serialized = editor.serialize(true);
            if (serialized) editors.push(serialized);
        }
        if (editors.length === 0) return;
        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
    }
    cut(event) {
        this.copy(event);
        this.delete();
    }
    async paste(event) {
        event.preventDefault();
        const { clipboardData: clipboardData } = event;
        for (const item of clipboardData.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                return;
            }
        }
        let data = clipboardData.getData("application/pdfjs");
        if (!data) return;
        try {
            data = JSON.parse(data);
        } catch (ex) {
            $a2cc6e1d6eb3861b$var$warn(`paste: "${ex.message}".`);
            return;
        }
        if (!Array.isArray(data)) return;
        this.unselectAll();
        const layer = this.currentLayer;
        try {
            const newEditors = [];
            for (const editor of data){
                const deserializedEditor = await layer.deserialize(editor);
                if (!deserializedEditor) return;
                newEditors.push(deserializedEditor);
            }
            const cmd = ()=>{
                for (const editor of newEditors)this.#addEditorToLayer(editor);
                this.#selectEditors(newEditors);
            };
            const undo = ()=>{
                for (const editor of newEditors)editor.remove();
            };
            this.addCommands({
                cmd: cmd,
                undo: undo,
                mustExec: true
            });
        } catch (ex) {
            $a2cc6e1d6eb3861b$var$warn(`paste: "${ex.message}".`);
        }
    }
    keydown(event) {
        if (!this.isShiftKeyDown && event.key === "Shift") this.isShiftKeyDown = true;
        if (this.#mode !== $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE && !this.isEditorHandlingKeyboard) $a2cc6e1d6eb3861b$export$26cb16552a82cf63._keyboardManager.exec(this, event);
    }
    keyup(event) {
        if (this.isShiftKeyDown && event.key === "Shift") {
            this.isShiftKeyDown = false;
            if (this.#highlightWhenShiftUp) {
                this.#highlightWhenShiftUp = false;
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    onEditingAction({ name: name }) {
        switch(name){
            case "undo":
            case "redo":
            case "delete":
            case "selectAll":
                this[name]();
                break;
            case "highlightSelection":
                this.highlightSelection("context_menu");
                break;
            case "commentSelection":
                this.commentSelection("context_menu");
                break;
        }
    }
    updatePageIndex(oldPageIndex, newPageIndex) {
        for (const editor of this.getEditors(oldPageIndex))editor.pageIndex = newPageIndex;
        const layer = this.#savedAllLayers.get(oldPageIndex);
        if (layer) {
            layer.pageIndex = newPageIndex;
            this.#allLayers.set(newPageIndex, layer);
            if (this.#isEnabled) layer.enable();
            else layer.disable();
        }
    }
    startUpdatePages() {
        this.#savedAllLayers = new Map(this.#allLayers);
        this.#allLayers.clear();
    }
    endUpdatePages() {
        this.#savedAllLayers = null;
    }
    clonePage(pageIndex, newPageIndex) {
        for (const editor of this.getEditors(pageIndex)){
            const serialized = editor.serialize(editor.mode !== $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT);
            if (!serialized) continue;
            serialized.pageIndex = newPageIndex;
            serialized.id = this.getId();
            serialized.isClone = true;
            delete serialized.popupRef;
            this.#annotationStorage.setValue(serialized.id, serialized);
        }
    }
    findClonesForPage(layer) {
        const promises = [];
        const { pageIndex: pageIndex } = layer;
        for (const [id, editor] of this.#annotationStorage)if (editor.pageIndex === pageIndex && editor.isClone) {
            this.#annotationStorage.remove(id);
            promises.push(layer.deserialize(editor).then((deserializedEditor)=>{
                if (deserializedEditor) {
                    deserializedEditor.isClone = true;
                    layer.addOrRebuild(deserializedEditor);
                }
            }));
        }
        return Promise.all(promises);
    }
    #dispatchUpdateStates(details) {
        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
        if (hasChanged) {
            this._eventBus.dispatch("editingstateschanged", {
                source: this,
                details: Object.assign(this.#previousStates, details)
            });
            if (this.#mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT && details.hasSelectedEditor === false) this.#dispatchUpdateUI([
                [
                    $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_FREE,
                    true
                ]
            ]);
        }
    }
    #dispatchUpdateUI(details) {
        this._eventBus.dispatch("annotationeditorparamschanged", {
            source: this,
            details: details
        });
    }
    setEditingState(isEditing) {
        if (isEditing) {
            this.#addFocusManager();
            this.#addCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: this.#mode !== $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE,
                isEmpty: this.#isEmpty(),
                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                hasSelectedEditor: false
            });
        } else {
            this.#removeFocusManager();
            this.#removeCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: false
            });
            this.disableUserSelect(false);
        }
    }
    registerEditorTypes(types) {
        if (this.#editorTypes) return;
        this.#editorTypes = types;
        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    getId() {
        return this.#idManager.id;
    }
    get currentLayer() {
        return this.#allLayers.get(this.#currentPageIndex);
    }
    getLayer(pageIndex) {
        return this.#allLayers.get(pageIndex);
    }
    get currentPageIndex() {
        return this.#currentPageIndex;
    }
    addLayer(layer) {
        this.#allLayers.set(layer.pageIndex, layer);
        if (this.#isEnabled) layer.enable();
        else layer.disable();
    }
    removeLayer(layer) {
        this.#allLayers.delete(layer.pageIndex);
    }
    async updateMode(mode, editId = null, isFromUser = false, isFromKeyboard = false, mustEnterInEditMode = false, editComment = false) {
        if (this.#mode === mode) return;
        if (this.#updateModeCapability) {
            await this.#updateModeCapability.promise;
            if (!this.#updateModeCapability) return;
        }
        this.#updateModeCapability = Promise.withResolvers();
        this.#currentDrawingSession?.commitOrRemove();
        if (this.#mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.POPUP) this.#commentManager?.hideSidebar();
        this.#commentManager?.destroyPopup();
        this.#mode = mode;
        if (mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE) {
            this.setEditingState(false);
            this.#disableAll();
            for (const editor of this.#allEditors.values())editor.hideStandaloneCommentButton();
            this._editorUndoBar?.hide();
            this.toggleComment(null);
            this.#updateModeCapability.resolve();
            return;
        }
        for (const editor of this.#allEditors.values())editor.addStandaloneCommentButton();
        if (mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.SIGNATURE) await this.#signatureManager?.loadSignatures();
        if (isFromUser) $a2cc6e1d6eb3861b$var$CurrentPointers.clearPointerType();
        this.setEditingState(true);
        await this.#enableAll();
        this.unselectAll();
        for (const layer of this.#allLayers.values())layer.updateMode(mode);
        if (mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.POPUP) {
            this.#allEditableAnnotations ||= await this.#pdfDocument.getAnnotationsByType(new Set(this.#editorTypes.map((editorClass)=>editorClass._editorType)));
            const elementIds = new Set();
            const allComments = [];
            for (const editor of this.#allEditors.values()){
                const { annotationElementId: annotationElementId, hasComment: hasComment, deleted: deleted } = editor;
                if (annotationElementId) elementIds.add(annotationElementId);
                if (hasComment && !deleted) allComments.push(editor.getData());
            }
            for (const annotation of this.#allEditableAnnotations){
                const { id: id, popupRef: popupRef, contentsObj: contentsObj } = annotation;
                if (popupRef && contentsObj?.str && !elementIds.has(id) && !this.#deletedAnnotationsElementIds.has(id)) allComments.push(annotation);
            }
            this.#commentManager?.showSidebar(allComments);
        }
        if (!editId) {
            if (isFromKeyboard) this.addNewEditorFromKeyboard();
            this.#updateModeCapability.resolve();
            return;
        }
        for (const editor of this.#allEditors.values())if (editor.uid === editId) {
            this.setSelected(editor);
            if (editComment) editor.editComment();
            else if (mustEnterInEditMode) editor.enterInEditMode();
            else editor.focus();
        } else editor.unselect();
        this.#updateModeCapability.resolve();
    }
    addNewEditorFromKeyboard() {
        if (this.currentLayer.canCreateNewEmptyEditor()) this.currentLayer.addNewEditor();
    }
    updateToolbar(options) {
        if (options.mode === this.#mode) return;
        this._eventBus.dispatch("switchannotationeditormode", {
            source: this,
            ...options
        });
    }
    updateParams(type, value) {
        if (!this.#editorTypes) return;
        switch(type){
            case $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.CREATE:
                this.currentLayer.addNewEditor(value);
                return;
            case $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL:
                this._eventBus.dispatch("reporttelemetry", {
                    source: this,
                    details: {
                        type: "editing",
                        data: {
                            type: "highlight",
                            action: "toggle_visibility"
                        }
                    }
                });
                (this.#showAllStates ||= new Map()).set(type, value);
                this.showAllEditors("highlight", value);
                break;
        }
        if (this.hasSelection) for (const editor of this.#selectedEditors)editor.updateParams(type, value);
        else for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
    }
    showAllEditors(type, visible, updateButton = false) {
        for (const editor of this.#allEditors.values())if (editor.editorType === type) editor.show(visible);
        const state = this.#showAllStates?.get($a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL) ?? true;
        if (state !== visible) this.#dispatchUpdateUI([
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL,
                visible
            ]
        ]);
    }
    enableWaiting(mustWait = false) {
        if (this.#isWaiting === mustWait) return;
        this.#isWaiting = mustWait;
        for (const layer of this.#allLayers.values()){
            if (mustWait) layer.disableClick();
            else layer.enableClick();
            layer.div.classList.toggle("waiting", mustWait);
        }
    }
    async #enableAll() {
        if (!this.#isEnabled) {
            this.#isEnabled = true;
            const promises = [];
            for (const layer of this.#allLayers.values())promises.push(layer.enable());
            await Promise.all(promises);
            for (const editor of this.#allEditors.values())editor.enable();
        }
    }
    #disableAll() {
        this.unselectAll();
        if (this.#isEnabled) {
            this.#isEnabled = false;
            for (const layer of this.#allLayers.values())layer.disable();
            for (const editor of this.#allEditors.values())editor.disable();
        }
    }
    *getEditors(pageIndex) {
        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) yield editor;
    }
    getEditor(id) {
        return this.#allEditors.get(id);
    }
    addEditor(editor) {
        this.#allEditors.set(editor.id, editor);
    }
    removeEditor(editor) {
        if (editor.div.contains(document.activeElement)) {
            if (this.#focusMainContainerTimeoutId) clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = setTimeout(()=>{
                this.focusMainContainer();
                this.#focusMainContainerTimeoutId = null;
            }, 0);
        }
        this.#allEditors.delete(editor.id);
        if (editor.annotationElementId) this.#missingCanvases?.delete(editor.annotationElementId);
        this.unselect(editor);
        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
    }
    addDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
        this.addChangedExistingAnnotation(editor);
        editor.deleted = true;
    }
    isDeletedAnnotationElement(annotationElementId) {
        return this.#deletedAnnotationsElementIds.has(annotationElementId);
    }
    removeDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
        this.removeChangedExistingAnnotation(editor);
        editor.deleted = false;
    }
    #addEditorToLayer(editor) {
        const layer = this.#allLayers.get(editor.pageIndex);
        if (layer) layer.addOrRebuild(editor);
        else {
            this.addEditor(editor);
            this.addToAnnotationStorage(editor);
        }
    }
    setActiveEditor(editor) {
        if (this.#activeEditor === editor) return;
        this.#activeEditor = editor;
        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    get #lastSelectedEditor() {
        let ed = null;
        for (ed of this.#selectedEditors);
        return ed;
    }
    updateUI(editor) {
        if (this.#lastSelectedEditor === editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    updateUIForDefaultProperties(editorType) {
        this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    toggleSelected(editor) {
        if (this.#selectedEditors.has(editor)) {
            this.#selectedEditors.delete(editor);
            editor.unselect();
            this.#dispatchUpdateStates({
                hasSelectedEditor: this.hasSelection
            });
            return;
        }
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    setSelected(editor) {
        this.updateToolbar({
            mode: editor.mode,
            editId: editor.uid
        });
        this.#currentDrawingSession?.commitOrRemove();
        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
        this.#commentManager?.destroyPopup();
        this.#selectedEditors.clear();
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    isSelected(editor) {
        return this.#selectedEditors.has(editor);
    }
    get firstSelectedEditor() {
        return this.#selectedEditors.values().next().value;
    }
    unselect(editor) {
        editor.unselect();
        this.#selectedEditors.delete(editor);
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    get hasSelection() {
        return this.#selectedEditors.size !== 0;
    }
    get isEnterHandled() {
        return this.#selectedEditors.size === 1 && this.firstSelectedEditor.isEnterHandled;
    }
    undo() {
        this.#commandManager.undo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
            hasSomethingToRedo: true,
            isEmpty: this.#isEmpty()
        });
        this._editorUndoBar?.hide();
    }
    redo() {
        this.#commandManager.redo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
            isEmpty: this.#isEmpty()
        });
    }
    addCommands(params) {
        this.#commandManager.add(params);
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: false,
            isEmpty: this.#isEmpty()
        });
    }
    cleanUndoStack(type) {
        this.#commandManager.cleanType(type);
    }
    #isEmpty() {
        if (this.#allEditors.size === 0) return true;
        if (this.#allEditors.size === 1) {
            for (const editor of this.#allEditors.values())return editor.isEmpty();
        }
        return false;
    }
    delete() {
        this.commitOrRemove();
        const drawingEditor = this.currentLayer?.endDrawingSession(true);
        if (!this.hasSelection && !drawingEditor) return;
        const editors = drawingEditor ? [
            drawingEditor
        ] : [
            ...this.#selectedEditors
        ];
        const cmd = ()=>{
            this._editorUndoBar?.show(undo, editors.length === 1 ? editors[0].editorType : editors.length);
            for (const editor of editors)editor.remove();
        };
        const undo = ()=>{
            for (const editor of editors)this.#addEditorToLayer(editor);
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    }
    commitOrRemove() {
        this.#activeEditor?.commitOrRemove();
    }
    hasSomethingToControl() {
        return this.#activeEditor || this.hasSelection;
    }
    #selectEditors(editors) {
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        for (const editor of editors){
            if (editor.isEmpty()) continue;
            this.#selectedEditors.add(editor);
            editor.select();
        }
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    selectAll() {
        for (const editor of this.#selectedEditors)editor.commit();
        this.#selectEditors(this.#allEditors.values());
    }
    unselectAll() {
        if (this.#activeEditor) {
            this.#activeEditor.commitOrRemove();
            if (this.#mode !== $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE) return;
        }
        if (this.#currentDrawingSession?.commitOrRemove()) return;
        this.#commentManager?.destroyPopup();
        if (!this.hasSelection) return;
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        this.#dispatchUpdateStates({
            hasSelectedEditor: false
        });
    }
    translateSelectedEditors(x, y, noCommit = false) {
        if (!noCommit) this.commitOrRemove();
        if (!this.hasSelection) return;
        this.#translation[0] += x;
        this.#translation[1] += y;
        const [totalX, totalY] = this.#translation;
        const editors = [
            ...this.#selectedEditors
        ];
        const TIME_TO_WAIT = 1000;
        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
        this.#translationTimeoutId = setTimeout(()=>{
            this.#translationTimeoutId = null;
            this.#translation[0] = this.#translation[1] = 0;
            this.addCommands({
                cmd: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) {
                        editor.translateInPage(totalX, totalY);
                        editor.translationDone();
                    }
                },
                undo: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) {
                        editor.translateInPage(-totalX, -totalY);
                        editor.translationDone();
                    }
                },
                mustExec: false
            });
        }, TIME_TO_WAIT);
        for (const editor of editors){
            editor.translateInPage(x, y);
            editor.translationDone();
        }
    }
    setUpDragSession() {
        if (!this.hasSelection) return;
        this.disableUserSelect(true);
        this.#draggingEditors = new Map();
        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
            savedX: editor.x,
            savedY: editor.y,
            savedPageIndex: editor.pageIndex,
            newX: 0,
            newY: 0,
            newPageIndex: -1
        });
    }
    endDragSession() {
        if (!this.#draggingEditors) return false;
        this.disableUserSelect(false);
        const map = this.#draggingEditors;
        this.#draggingEditors = null;
        let mustBeAddedInUndoStack = false;
        for (const [{ x: x, y: y, pageIndex: pageIndex }, value] of map){
            value.newX = x;
            value.newY = y;
            value.newPageIndex = pageIndex;
            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
        }
        if (!mustBeAddedInUndoStack) return false;
        const move = (editor, x, y, pageIndex)=>{
            if (this.#allEditors.has(editor.id)) {
                const parent = this.#allLayers.get(pageIndex);
                if (parent) editor._setParentAndPosition(parent, x, y);
                else {
                    editor.pageIndex = pageIndex;
                    editor.x = x;
                    editor.y = y;
                }
            }
        };
        this.addCommands({
            cmd: ()=>{
                for (const [editor, { newX: newX, newY: newY, newPageIndex: newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
            },
            undo: ()=>{
                for (const [editor, { savedX: savedX, savedY: savedY, savedPageIndex: savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
            },
            mustExec: true
        });
        return true;
    }
    dragSelectedEditors(tx, ty) {
        if (!this.#draggingEditors) return;
        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
    }
    rebuild(editor) {
        if (editor.parent === null) {
            const parent = this.getLayer(editor.pageIndex);
            if (parent) {
                parent.changeParent(editor);
                parent.addOrRebuild(editor);
            } else {
                this.addEditor(editor);
                this.addToAnnotationStorage(editor);
                editor.rebuild();
            }
        } else editor.parent.addOrRebuild(editor);
    }
    get isEditorHandlingKeyboard() {
        return this.getActive()?.shouldGetKeyboardEvents() || this.#selectedEditors.size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
    }
    isActive(editor) {
        return this.#activeEditor === editor;
    }
    getActive() {
        return this.#activeEditor;
    }
    getMode() {
        return this.#mode;
    }
    isEditingMode() {
        return this.#mode !== $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE;
    }
    get imageManager() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "imageManager", new $a2cc6e1d6eb3861b$var$ImageManager());
    }
    getSelectionBoxes(textLayer) {
        if (!textLayer) return null;
        const selection = document.getSelection();
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            if (!textLayer.contains(selection.getRangeAt(i).commonAncestorContainer)) return null;
        }
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        let rotator;
        switch(textLayer.getAttribute("data-main-rotation")){
            case "90":
                rotator = (x, y, w, h)=>({
                        x: (y - layerY) / parentHeight,
                        y: 1 - (x + w - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            case "180":
                rotator = (x, y, w, h)=>({
                        x: 1 - (x + w - layerX) / parentWidth,
                        y: 1 - (y + h - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
            case "270":
                rotator = (x, y, w, h)=>({
                        x: 1 - (y + h - layerY) / parentHeight,
                        y: (x - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            default:
                rotator = (x, y, w, h)=>({
                        x: (x - layerX) / parentWidth,
                        y: (y - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
        }
        const boxes = [];
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            const range = selection.getRangeAt(i);
            if (range.collapsed) continue;
            for (const { x: x, y: y, width: width, height: height } of range.getClientRects()){
                if (width === 0 || height === 0) continue;
                boxes.push(rotator(x, y, width, height));
            }
        }
        return boxes.length === 0 ? null : boxes;
    }
    addChangedExistingAnnotation({ annotationElementId: annotationElementId, id: id }) {
        (this.#changedExistingAnnotations ||= new Map()).set(annotationElementId, id);
    }
    removeChangedExistingAnnotation({ annotationElementId: annotationElementId }) {
        this.#changedExistingAnnotations?.delete(annotationElementId);
    }
    renderAnnotationElement(annotation) {
        const editorId = this.#changedExistingAnnotations?.get(annotation.data.id);
        if (!editorId) return;
        const editor = this.#annotationStorage.getRawValue(editorId);
        if (!editor) return;
        if (this.#mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE && !editor.hasBeenModified) return;
        editor.renderAnnotationElement(annotation);
    }
    setMissingCanvas(annotationId, annotationElementId, canvas) {
        const editor = this.#missingCanvases?.get(annotationId);
        if (!editor) return;
        editor.setCanvas(annotationElementId, canvas);
        this.#missingCanvases.delete(annotationId);
    }
    addMissingCanvas(annotationId, editor) {
        (this.#missingCanvases ||= new Map()).set(annotationId, editor);
    }
}
class $a2cc6e1d6eb3861b$var$AltText {
    #altText = null;
    #altTextDecorative = false;
    #altTextButton = null;
    #altTextButtonLabel = null;
    #altTextTooltip = null;
    #altTextTooltipTimeout = null;
    #altTextWasFromKeyBoard = false;
    #badge = null;
    #editor = null;
    #guessedText = null;
    #textWithDisclaimer = null;
    #useNewAltTextFlow = false;
    static #l10nNewButton = null;
    static _l10n = null;
    constructor(editor){
        this.#editor = editor;
        this.#useNewAltTextFlow = editor._uiManager.useNewAltTextFlow;
        $a2cc6e1d6eb3861b$var$AltText.#l10nNewButton ||= Object.freeze({
            added: "pdfjs-editor-new-alt-text-added-button",
            "added-label": "pdfjs-editor-new-alt-text-added-button-label",
            missing: "pdfjs-editor-new-alt-text-missing-button",
            "missing-label": "pdfjs-editor-new-alt-text-missing-button-label",
            review: "pdfjs-editor-new-alt-text-to-review-button",
            "review-label": "pdfjs-editor-new-alt-text-to-review-button-label"
        });
    }
    static initialize(l10n) {
        $a2cc6e1d6eb3861b$var$AltText._l10n ??= l10n;
    }
    async render() {
        const altText = this.#altTextButton = document.createElement("button");
        altText.className = "altText";
        altText.tabIndex = "0";
        const label = this.#altTextButtonLabel = document.createElement("span");
        altText.append(label);
        if (this.#useNewAltTextFlow) {
            altText.classList.add("new");
            altText.setAttribute("data-l10n-id", $a2cc6e1d6eb3861b$var$AltText.#l10nNewButton.missing);
            label.setAttribute("data-l10n-id", $a2cc6e1d6eb3861b$var$AltText.#l10nNewButton["missing-label"]);
        } else {
            altText.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button");
            label.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button-label");
        }
        const signal = this.#editor._uiManager._signal;
        altText.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
            signal: signal
        });
        altText.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            this.#editor._uiManager.editAltText(this.#editor);
            if (this.#useNewAltTextFlow) this.#editor._reportTelemetry({
                action: "pdfjs.image.alt_text.image_status_label_clicked",
                data: {
                    label: this.#label
                }
            });
        };
        altText.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        altText.addEventListener("keydown", (event)=>{
            if (event.target === altText && event.key === "Enter") {
                this.#altTextWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        await this.#setState();
        return altText;
    }
    get #label() {
        return this.#altText && "added" || this.#altText === null && this.guessedText && "review" || "missing";
    }
    finish() {
        if (!this.#altTextButton) return;
        this.#altTextButton.focus({
            focusVisible: this.#altTextWasFromKeyBoard
        });
        this.#altTextWasFromKeyBoard = false;
    }
    isEmpty() {
        if (this.#useNewAltTextFlow) return this.#altText === null;
        return !this.#altText && !this.#altTextDecorative;
    }
    hasData() {
        if (this.#useNewAltTextFlow) return this.#altText !== null || !!this.#guessedText;
        return this.isEmpty();
    }
    get guessedText() {
        return this.#guessedText;
    }
    async setGuessedText(guessedText) {
        if (this.#altText !== null) return;
        this.#guessedText = guessedText;
        this.#textWithDisclaimer = await $a2cc6e1d6eb3861b$var$AltText._l10n.get("pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer", {
            generatedAltText: guessedText
        });
        this.#setState();
    }
    toggleAltTextBadge(visibility = false) {
        if (!this.#useNewAltTextFlow || this.#altText) {
            this.#badge?.remove();
            this.#badge = null;
            return;
        }
        if (!this.#badge) {
            const badge = this.#badge = document.createElement("div");
            badge.className = "noAltTextBadge";
            this.#editor.div.append(badge);
        }
        this.#badge.classList.toggle("hidden", !visibility);
    }
    serialize(isForCopying) {
        let altText = this.#altText;
        if (!isForCopying && this.#guessedText === altText) altText = this.#textWithDisclaimer;
        return {
            altText: altText,
            decorative: this.#altTextDecorative,
            guessedText: this.#guessedText,
            textWithDisclaimer: this.#textWithDisclaimer
        };
    }
    get data() {
        return {
            altText: this.#altText,
            decorative: this.#altTextDecorative
        };
    }
    set data({ altText: altText, decorative: decorative, guessedText: guessedText, textWithDisclaimer: textWithDisclaimer, cancel: cancel = false }) {
        if (guessedText) {
            this.#guessedText = guessedText;
            this.#textWithDisclaimer = textWithDisclaimer;
        }
        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
        if (!cancel) {
            this.#altText = altText;
            this.#altTextDecorative = decorative;
        }
        this.#setState();
    }
    toggle(enabled = false) {
        if (!this.#altTextButton) return;
        if (!enabled && this.#altTextTooltipTimeout) {
            clearTimeout(this.#altTextTooltipTimeout);
            this.#altTextTooltipTimeout = null;
        }
        this.#altTextButton.disabled = !enabled;
    }
    shown() {
        this.#editor._reportTelemetry({
            action: "pdfjs.image.alt_text.image_status_label_displayed",
            data: {
                label: this.#label
            }
        });
    }
    destroy() {
        this.#altTextButton?.remove();
        this.#altTextButton = null;
        this.#altTextButtonLabel = null;
        this.#altTextTooltip = null;
        this.#badge?.remove();
        this.#badge = null;
    }
    async #setState() {
        const button = this.#altTextButton;
        if (!button) return;
        if (this.#useNewAltTextFlow) {
            button.classList.toggle("done", !!this.#altText);
            button.setAttribute("data-l10n-id", $a2cc6e1d6eb3861b$var$AltText.#l10nNewButton[this.#label]);
            this.#altTextButtonLabel?.setAttribute("data-l10n-id", $a2cc6e1d6eb3861b$var$AltText.#l10nNewButton[`${this.#label}-label`]);
            if (!this.#altText) {
                this.#altTextTooltip?.remove();
                return;
            }
        } else {
            if (!this.#altText && !this.#altTextDecorative) {
                button.classList.remove("done");
                this.#altTextTooltip?.remove();
                return;
            }
            button.classList.add("done");
            button.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-edit-button");
        }
        let tooltip = this.#altTextTooltip;
        if (!tooltip) {
            this.#altTextTooltip = tooltip = document.createElement("span");
            tooltip.className = "tooltip";
            tooltip.setAttribute("role", "tooltip");
            tooltip.id = `alt-text-tooltip-${this.#editor.id}`;
            const DELAY_TO_SHOW_TOOLTIP = 100;
            const signal = this.#editor._uiManager._signal;
            signal.addEventListener("abort", ()=>{
                clearTimeout(this.#altTextTooltipTimeout);
                this.#altTextTooltipTimeout = null;
            }, {
                once: true
            });
            button.addEventListener("mouseenter", ()=>{
                this.#altTextTooltipTimeout = setTimeout(()=>{
                    this.#altTextTooltipTimeout = null;
                    this.#altTextTooltip.classList.add("show");
                    this.#editor._reportTelemetry({
                        action: "alt_text_tooltip"
                    });
                }, DELAY_TO_SHOW_TOOLTIP);
            }, {
                signal: signal
            });
            button.addEventListener("mouseleave", ()=>{
                if (this.#altTextTooltipTimeout) {
                    clearTimeout(this.#altTextTooltipTimeout);
                    this.#altTextTooltipTimeout = null;
                }
                this.#altTextTooltip?.classList.remove("show");
            }, {
                signal: signal
            });
        }
        if (this.#altTextDecorative) tooltip.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-decorative-tooltip");
        else {
            tooltip.removeAttribute("data-l10n-id");
            tooltip.textContent = this.#altText;
        }
        if (!tooltip.parentNode) button.append(tooltip);
        const element = this.#editor.getElementForAltText();
        element?.setAttribute("aria-describedby", tooltip.id);
    }
}
class $a2cc6e1d6eb3861b$var$Comment {
    #commentStandaloneButton = null;
    #commentToolbarButton = null;
    #commentWasFromKeyBoard = false;
    #editor = null;
    #initialText = null;
    #richText = null;
    #text = null;
    #date = null;
    #deleted = false;
    #popupPosition = null;
    constructor(editor){
        this.#editor = editor;
    }
    renderForToolbar() {
        const button = this.#commentToolbarButton = document.createElement("button");
        button.className = "comment";
        return this.#render(button, false);
    }
    renderForStandalone() {
        const button = this.#commentStandaloneButton = document.createElement("button");
        button.className = "annotationCommentButton";
        const position = this.#editor.commentButtonPosition;
        if (position) {
            const { style: style } = button;
            style.insetInlineEnd = `calc(${100 * (this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0])}% - var(--comment-button-dim))`;
            style.top = `calc(${100 * position[1]}% - var(--comment-button-dim))`;
            const color = this.#editor.commentButtonColor;
            if (color) style.backgroundColor = color;
        }
        return this.#render(button, true);
    }
    focusButton() {
        setTimeout(()=>{
            (this.#commentStandaloneButton ?? this.#commentToolbarButton)?.focus();
        }, 0);
    }
    onUpdatedColor() {
        if (!this.#commentStandaloneButton) return;
        const color = this.#editor.commentButtonColor;
        if (color) this.#commentStandaloneButton.style.backgroundColor = color;
        this.#editor._uiManager.updatePopupColor(this.#editor);
    }
    get commentButtonWidth() {
        return (this.#commentStandaloneButton?.getBoundingClientRect().width ?? 0) / this.#editor.parent.boundingClientRect.width;
    }
    get commentPopupPositionInLayer() {
        if (this.#popupPosition) return this.#popupPosition;
        if (!this.#commentStandaloneButton) return null;
        const { x: x, y: y, height: height } = this.#commentStandaloneButton.getBoundingClientRect();
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = this.#editor.parent.boundingClientRect;
        return [
            (x - parentX) / parentWidth,
            (y + height - parentY) / parentHeight
        ];
    }
    set commentPopupPositionInLayer(pos) {
        this.#popupPosition = pos;
    }
    hasDefaultPopupPosition() {
        return this.#popupPosition === null;
    }
    removeStandaloneCommentButton() {
        this.#commentStandaloneButton?.remove();
        this.#commentStandaloneButton = null;
    }
    removeToolbarCommentButton() {
        this.#commentToolbarButton?.remove();
        this.#commentToolbarButton = null;
    }
    setCommentButtonStates({ selected: selected, hasPopup: hasPopup }) {
        if (!this.#commentStandaloneButton) return;
        this.#commentStandaloneButton.classList.toggle("selected", selected);
        this.#commentStandaloneButton.ariaExpanded = hasPopup;
    }
    #render(comment, isStandalone) {
        if (!this.#editor._uiManager.hasCommentManager()) return null;
        comment.tabIndex = "0";
        comment.ariaHasPopup = "dialog";
        if (isStandalone) {
            comment.ariaControls = "commentPopup";
            comment.setAttribute("data-l10n-id", "pdfjs-show-comment-button");
        } else {
            comment.ariaControlsElements = [
                this.#editor._uiManager.getCommentDialogElement()
            ];
            comment.setAttribute("data-l10n-id", "pdfjs-editor-add-comment-button");
        }
        const signal = this.#editor._uiManager._signal;
        if (!(signal instanceof AbortSignal) || signal.aborted) return comment;
        comment.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
            signal: signal
        });
        if (isStandalone) {
            comment.addEventListener("focusin", (e)=>{
                this.#editor._focusEventsAllowed = false;
                $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e);
            }, {
                capture: true,
                signal: signal
            });
            comment.addEventListener("focusout", (e)=>{
                this.#editor._focusEventsAllowed = true;
                $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e);
            }, {
                capture: true,
                signal: signal
            });
        }
        comment.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            if (comment === this.#commentToolbarButton) this.edit();
            else this.#editor.toggleComment(true);
        };
        comment.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        comment.addEventListener("keydown", (event)=>{
            if (event.target === comment && event.key === "Enter") {
                this.#commentWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        comment.addEventListener("pointerenter", ()=>{
            this.#editor.toggleComment(false, true);
        }, {
            signal: signal
        });
        comment.addEventListener("pointerleave", ()=>{
            this.#editor.toggleComment(false, false);
        }, {
            signal: signal
        });
        return comment;
    }
    edit(options) {
        const position = this.commentPopupPositionInLayer;
        let posX, posY;
        if (position) [posX, posY] = position;
        else {
            [posX, posY] = this.#editor.commentButtonPosition;
            const { width: width, height: height, x: x, y: y } = this.#editor;
            posX = x + posX * width;
            posY = y + posY * height;
        }
        const parentDimensions = this.#editor.parent.boundingClientRect;
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = parentDimensions;
        this.#editor._uiManager.editComment(this.#editor, parentX + posX * parentWidth, parentY + posY * parentHeight, {
            ...options,
            parentDimensions: parentDimensions
        });
    }
    finish() {
        if (!this.#commentToolbarButton) return;
        this.#commentToolbarButton.focus({
            focusVisible: this.#commentWasFromKeyBoard
        });
        this.#commentWasFromKeyBoard = false;
    }
    isDeleted() {
        return this.#deleted || this.#text === "";
    }
    isEmpty() {
        return this.#text === null;
    }
    hasBeenEdited() {
        return this.isDeleted() || this.#text !== this.#initialText;
    }
    serialize() {
        return this.data;
    }
    get data() {
        return {
            text: this.#text,
            richText: this.#richText,
            date: this.#date,
            deleted: this.isDeleted()
        };
    }
    set data(text) {
        if (text !== this.#text) this.#richText = null;
        if (text === null) {
            this.#text = "";
            this.#deleted = true;
            return;
        }
        this.#text = text;
        this.#date = new Date();
        this.#deleted = false;
    }
    restoreData({ text: text, richText: richText, date: date }) {
        this.#text = text;
        this.#richText = richText;
        this.#date = date;
        this.#deleted = false;
    }
    setInitialText(text, richText = null) {
        this.#initialText = text;
        this.data = text;
        this.#date = null;
        this.#richText = richText;
    }
    shown() {}
    destroy() {
        this.#commentToolbarButton?.remove();
        this.#commentToolbarButton = null;
        this.#commentStandaloneButton?.remove();
        this.#commentStandaloneButton = null;
        this.#text = "";
        this.#richText = null;
        this.#date = null;
        this.#editor = null;
        this.#commentWasFromKeyBoard = false;
        this.#deleted = false;
    }
}
class $a2cc6e1d6eb3861b$export$9ae7542b430d543e {
    #container;
    #isPinching = false;
    #isPinchingStopped = null;
    #isPinchingDisabled;
    #onPinchStart;
    #onPinching;
    #onPinchEnd;
    #pointerDownAC = null;
    #signal;
    #touchInfo = null;
    #touchManagerAC;
    #touchMoveAC = null;
    constructor({ container: container, isPinchingDisabled: isPinchingDisabled = null, isPinchingStopped: isPinchingStopped = null, onPinchStart: onPinchStart = null, onPinching: onPinching = null, onPinchEnd: onPinchEnd = null, signal: signal }){
        this.#container = container;
        this.#isPinchingStopped = isPinchingStopped;
        this.#isPinchingDisabled = isPinchingDisabled;
        this.#onPinchStart = onPinchStart;
        this.#onPinching = onPinching;
        this.#onPinchEnd = onPinchEnd;
        this.#touchManagerAC = new AbortController();
        this.#signal = AbortSignal.any([
            signal,
            this.#touchManagerAC.signal
        ]);
        container.addEventListener("touchstart", this.#onTouchStart.bind(this), {
            passive: false,
            signal: this.#signal
        });
    }
    get MIN_TOUCH_DISTANCE_TO_PINCH() {
        return 35 / $a2cc6e1d6eb3861b$export$f16a99f63bccd50b.pixelRatio;
    }
    #onTouchStart(evt) {
        if (this.#isPinchingDisabled?.()) return;
        if (evt.touches.length === 1) {
            if (this.#pointerDownAC) return;
            const pointerDownAC = this.#pointerDownAC = new AbortController();
            const signal = AbortSignal.any([
                this.#signal,
                pointerDownAC.signal
            ]);
            const container = this.#container;
            const opts = {
                capture: true,
                signal: signal,
                passive: false
            };
            const cancelPointerDown = (e)=>{
                if (e.pointerType === "touch") {
                    this.#pointerDownAC?.abort();
                    this.#pointerDownAC = null;
                }
            };
            container.addEventListener("pointerdown", (e)=>{
                if (e.pointerType === "touch") {
                    $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e);
                    cancelPointerDown(e);
                }
            }, opts);
            container.addEventListener("pointerup", cancelPointerDown, opts);
            container.addEventListener("pointercancel", cancelPointerDown, opts);
            return;
        }
        if (!this.#touchMoveAC) {
            this.#touchMoveAC = new AbortController();
            const signal = AbortSignal.any([
                this.#signal,
                this.#touchMoveAC.signal
            ]);
            const container = this.#container;
            const opt = {
                signal: signal,
                capture: false,
                passive: false
            };
            container.addEventListener("touchmove", this.#onTouchMove.bind(this), opt);
            const onTouchEnd = this.#onTouchEnd.bind(this);
            container.addEventListener("touchend", onTouchEnd, opt);
            container.addEventListener("touchcancel", onTouchEnd, opt);
            opt.capture = true;
            container.addEventListener("pointerdown", $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointermove", $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointercancel", $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointerup", $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050, opt);
            this.#onPinchStart?.();
        }
        $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(evt);
        if (evt.touches.length !== 2 || this.#isPinchingStopped?.()) {
            this.#touchInfo = null;
            return;
        }
        let [touch0, touch1] = evt.touches;
        if (touch0.identifier > touch1.identifier) [touch0, touch1] = [
            touch1,
            touch0
        ];
        this.#touchInfo = {
            touch0X: touch0.screenX,
            touch0Y: touch0.screenY,
            touch1X: touch1.screenX,
            touch1Y: touch1.screenY
        };
    }
    #onTouchMove(evt) {
        if (!this.#touchInfo || evt.touches.length !== 2) return;
        $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(evt);
        let [touch0, touch1] = evt.touches;
        if (touch0.identifier > touch1.identifier) [touch0, touch1] = [
            touch1,
            touch0
        ];
        const { screenX: screen0X, screenY: screen0Y } = touch0;
        const { screenX: screen1X, screenY: screen1Y } = touch1;
        const touchInfo = this.#touchInfo;
        const { touch0X: pTouch0X, touch0Y: pTouch0Y, touch1X: pTouch1X, touch1Y: pTouch1Y } = touchInfo;
        const prevGapX = pTouch1X - pTouch0X;
        const prevGapY = pTouch1Y - pTouch0Y;
        const currGapX = screen1X - screen0X;
        const currGapY = screen1Y - screen0Y;
        const distance = Math.hypot(currGapX, currGapY) || 1;
        const pDistance = Math.hypot(prevGapX, prevGapY) || 1;
        if (!this.#isPinching && Math.abs(pDistance - distance) <= $a2cc6e1d6eb3861b$export$9ae7542b430d543e.MIN_TOUCH_DISTANCE_TO_PINCH) return;
        touchInfo.touch0X = screen0X;
        touchInfo.touch0Y = screen0Y;
        touchInfo.touch1X = screen1X;
        touchInfo.touch1Y = screen1Y;
        if (!this.#isPinching) {
            this.#isPinching = true;
            return;
        }
        const origin = [
            (screen0X + screen1X) / 2,
            (screen0Y + screen1Y) / 2
        ];
        this.#onPinching?.(origin, pDistance, distance);
    }
    #onTouchEnd(evt) {
        if (evt.touches.length >= 2) return;
        if (this.#touchMoveAC) {
            this.#touchMoveAC.abort();
            this.#touchMoveAC = null;
            this.#onPinchEnd?.();
        }
        if (!this.#touchInfo) return;
        $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(evt);
        this.#touchInfo = null;
        this.#isPinching = false;
    }
    destroy() {
        this.#touchManagerAC?.abort();
        this.#touchManagerAC = null;
        this.#pointerDownAC?.abort();
        this.#pointerDownAC = null;
    }
}
class $a2cc6e1d6eb3861b$var$AnnotationEditor {
    #accessibilityData = null;
    #allResizerDivs = null;
    #altText = null;
    #comment = null;
    #commentStandaloneButton = null;
    #disabled = false;
    #dragPointerId = null;
    #dragPointerType = "";
    #resizersDiv = null;
    #lastPointerCoords = null;
    #savedDimensions = null;
    #fakeAnnotation = null;
    #focusAC = null;
    #focusedResizerName = "";
    #hasBeenClicked = false;
    #initialRect = null;
    #isEditing = false;
    #isInEditMode = false;
    #isResizerEnabledForKeyboard = false;
    #moveInDOMTimeout = null;
    #prevDragX = 0;
    #prevDragY = 0;
    #telemetryTimeouts = null;
    #touchManager = null;
    isSelected = false;
    _isCopy = false;
    _editToolbar = null;
    _initialOptions = Object.create(null);
    _initialData = null;
    _isVisible = true;
    _uiManager = null;
    _focusEventsAllowed = true;
    static _l10n = null;
    static _l10nAlert = null;
    static _l10nResizer = null;
    #isDraggable = false;
    #zIndex = $a2cc6e1d6eb3861b$var$AnnotationEditor._zIndex++;
    static _borderLineWidth = -1;
    static _colorManager = new $a2cc6e1d6eb3861b$var$ColorManager();
    static _zIndex = 1;
    static _telemetryTimeout = 1000;
    static get _resizerKeyboardManager() {
        const resize = $a2cc6e1d6eb3861b$var$AnnotationEditor.prototype._resizeWithKeyboard;
        const small = $a2cc6e1d6eb3861b$export$26cb16552a82cf63.TRANSLATE_SMALL;
        const big = $a2cc6e1d6eb3861b$export$26cb16552a82cf63.TRANSLATE_BIG;
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_resizerKeyboardManager", new $a2cc6e1d6eb3861b$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                resize,
                {
                    args: [
                        small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                resize,
                {
                    args: [
                        big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -big
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        big
                    ]
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $a2cc6e1d6eb3861b$var$AnnotationEditor.prototype._stopResizingWithKeyboard
            ]
        ]));
    }
    constructor(parameters){
        this.parent = parameters.parent;
        this.id = parameters.id;
        this.width = this.height = null;
        this.pageIndex = parameters.parent.pageIndex;
        this.name = parameters.name;
        this.div = null;
        this._uiManager = parameters.uiManager;
        this.annotationElementId = null;
        this._willKeepAspectRatio = false;
        this._initialOptions.isCentered = parameters.isCentered;
        this._structTreeParentId = null;
        this.annotationElementId = parameters.annotationElementId || null;
        this.creationDate = parameters.creationDate || new Date();
        this.modificationDate = parameters.modificationDate || null;
        this.canAddComment = true;
        const { rotation: rotation, rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = this.parent.viewport;
        this.rotation = rotation;
        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
        this.pageDimensions = [
            pageWidth,
            pageHeight
        ];
        this.pageTranslation = [
            pageX,
            pageY
        ];
        const [width, height] = this.parentDimensions;
        this.x = parameters.x / width;
        this.y = parameters.y / height;
        this.isAttachedToDOM = false;
        this.deleted = false;
    }
    updatePageIndex(newPageIndex) {
        this.pageIndex = newPageIndex;
    }
    get editorType() {
        return Object.getPrototypeOf(this).constructor._type;
    }
    get mode() {
        return Object.getPrototypeOf(this).constructor._editorType;
    }
    static get isDrawer() {
        return false;
    }
    static get _defaultLineColor() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
    }
    static deleteAnnotationElement(editor) {
        const fakeEditor = new $a2cc6e1d6eb3861b$var$FakeEditor({
            id: editor._uiManager.getId(),
            parent: editor.parent,
            uiManager: editor._uiManager
        });
        fakeEditor.annotationElementId = editor.annotationElementId;
        fakeEditor.deleted = true;
        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
    }
    static initialize(l10n, _uiManager) {
        $a2cc6e1d6eb3861b$var$AnnotationEditor._l10n ??= l10n;
        $a2cc6e1d6eb3861b$var$AnnotationEditor._l10nAlert ??= Object.freeze({
            highlight: "pdfjs-editor-highlight-added-alert",
            freetext: "pdfjs-editor-freetext-added-alert",
            ink: "pdfjs-editor-ink-added-alert",
            stamp: "pdfjs-editor-stamp-added-alert",
            signature: "pdfjs-editor-signature-added-alert"
        });
        $a2cc6e1d6eb3861b$var$AnnotationEditor._l10nResizer ??= Object.freeze({
            topLeft: "pdfjs-editor-resizer-top-left",
            topMiddle: "pdfjs-editor-resizer-top-middle",
            topRight: "pdfjs-editor-resizer-top-right",
            middleRight: "pdfjs-editor-resizer-middle-right",
            bottomRight: "pdfjs-editor-resizer-bottom-right",
            bottomMiddle: "pdfjs-editor-resizer-bottom-middle",
            bottomLeft: "pdfjs-editor-resizer-bottom-left",
            middleLeft: "pdfjs-editor-resizer-middle-left"
        });
        if ($a2cc6e1d6eb3861b$var$AnnotationEditor._borderLineWidth !== -1) return;
        const style = getComputedStyle(document.documentElement);
        $a2cc6e1d6eb3861b$var$AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
    }
    static updateDefaultParams(_type, _value) {}
    static get defaultPropertiesToUpdate() {
        return [];
    }
    static isHandlingMimeForPasting(mime) {
        return false;
    }
    static paste(item, parent) {
        $a2cc6e1d6eb3861b$var$unreachable("Not implemented");
    }
    get propertiesToUpdate() {
        return [];
    }
    get _isDraggable() {
        return this.#isDraggable;
    }
    set _isDraggable(value) {
        this.#isDraggable = value;
        this.div?.classList.toggle("draggable", value);
    }
    get uid() {
        return this.annotationElementId || this.id;
    }
    get isEnterHandled() {
        return true;
    }
    center() {
        const [pageWidth, pageHeight] = this.pageDimensions;
        switch(this.parentRotation){
            case 90:
                this.x -= this.height * pageHeight / (pageWidth * 2);
                this.y += this.width * pageWidth / (pageHeight * 2);
                break;
            case 180:
                this.x += this.width / 2;
                this.y += this.height / 2;
                break;
            case 270:
                this.x += this.height * pageHeight / (pageWidth * 2);
                this.y -= this.width * pageWidth / (pageHeight * 2);
                break;
            default:
                this.x -= this.width / 2;
                this.y -= this.height / 2;
                break;
        }
        this.fixAndSetPosition();
    }
    addCommands(params) {
        this._uiManager.addCommands(params);
    }
    get currentLayer() {
        return this._uiManager.currentLayer;
    }
    setInBackground() {
        this.div.style.zIndex = 0;
    }
    setInForeground() {
        this.div.style.zIndex = this.#zIndex;
    }
    setParent(parent) {
        if (parent !== null) {
            this.pageIndex = parent.pageIndex;
            this.pageDimensions = parent.pageDimensions;
        } else {
            this.#stopResizing();
            this.#fakeAnnotation?.remove();
            this.#fakeAnnotation = null;
        }
        this.parent = parent;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.#hasBeenClicked) this.parent.setSelected(this);
        else this.#hasBeenClicked = false;
    }
    focusout(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.isAttachedToDOM) return;
        const target = event.relatedTarget;
        if (target?.closest(`#${this.id}`)) return;
        event.preventDefault();
        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
    }
    commitOrRemove() {
        if (this.isEmpty()) this.remove();
        else this.commit();
    }
    commit() {
        if (!this.isInEditMode()) return;
        this.addToAnnotationStorage();
    }
    addToAnnotationStorage() {
        this._uiManager.addToAnnotationStorage(this);
    }
    setAt(x, y, tx, ty) {
        const [width, height] = this.parentDimensions;
        [tx, ty] = this.screenToPageTranslation(tx, ty);
        this.x = (x + tx) / width;
        this.y = (y + ty) / height;
        this.fixAndSetPosition();
    }
    _moveAfterPaste(baseX, baseY) {
        if (this.isClone) {
            delete this.isClone;
            return;
        }
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
        this._onTranslated();
    }
    #translate([width, height], x, y) {
        [x, y] = this.screenToPageTranslation(x, y);
        this.x += x / width;
        this.y += y / height;
        this._onTranslating(this.x, this.y);
        this.fixAndSetPosition();
    }
    translate(x, y) {
        this.#translate(this.parentDimensions, x, y);
    }
    translateInPage(x, y) {
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        this.#translate(this.pageDimensions, x, y);
        this.div.scrollIntoView({
            block: "nearest"
        });
    }
    translationDone() {
        this._onTranslated(this.x, this.y);
    }
    drag(tx, ty) {
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        const { div: div, parentDimensions: [parentWidth, parentHeight] } = this;
        this.x += tx / parentWidth;
        this.y += ty / parentHeight;
        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
            const { x: x, y: y } = this.div.getBoundingClientRect();
            if (this.parent.findNewParent(this, x, y)) {
                this.x -= Math.floor(this.x);
                this.y -= Math.floor(this.y);
            }
        }
        let { x: x, y: y } = this;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        const { style: style } = div;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this._onTranslating(x, y);
        div.scrollIntoView({
            block: "nearest"
        });
    }
    _onTranslating(x, y) {}
    _onTranslated(x, y) {}
    get _hasBeenMoved() {
        return !!this.#initialRect && (this.#initialRect[0] !== this.x || this.#initialRect[1] !== this.y);
    }
    get _hasBeenResized() {
        return !!this.#initialRect && (this.#initialRect[2] !== this.width || this.#initialRect[3] !== this.height);
    }
    getBaseTranslation() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { _borderLineWidth: _borderLineWidth } = $a2cc6e1d6eb3861b$var$AnnotationEditor;
        const x = _borderLineWidth / parentWidth;
        const y = _borderLineWidth / parentHeight;
        switch(this.rotation){
            case 90:
                return [
                    -x,
                    y
                ];
            case 180:
                return [
                    x,
                    y
                ];
            case 270:
                return [
                    x,
                    -y
                ];
            default:
                return [
                    -x,
                    -y
                ];
        }
    }
    get _mustFixPosition() {
        return true;
    }
    fixAndSetPosition(rotation = this.rotation) {
        const { div: { style: style }, pageDimensions: [pageWidth, pageHeight] } = this;
        let { x: x, y: y, width: width, height: height } = this;
        width *= pageWidth;
        height *= pageHeight;
        x *= pageWidth;
        y *= pageHeight;
        if (this._mustFixPosition) switch(rotation){
            case 0:
                x = $a2cc6e1d6eb3861b$export$b8106b171181a554(x, 0, pageWidth - width);
                y = $a2cc6e1d6eb3861b$export$b8106b171181a554(y, 0, pageHeight - height);
                break;
            case 90:
                x = $a2cc6e1d6eb3861b$export$b8106b171181a554(x, 0, pageWidth - height);
                y = $a2cc6e1d6eb3861b$export$b8106b171181a554(y, width, pageHeight);
                break;
            case 180:
                x = $a2cc6e1d6eb3861b$export$b8106b171181a554(x, width, pageWidth);
                y = $a2cc6e1d6eb3861b$export$b8106b171181a554(y, height, pageHeight);
                break;
            case 270:
                x = $a2cc6e1d6eb3861b$export$b8106b171181a554(x, height, pageWidth);
                y = $a2cc6e1d6eb3861b$export$b8106b171181a554(y, 0, pageHeight - width);
                break;
        }
        this.x = x /= pageWidth;
        this.y = y /= pageHeight;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this.moveInDOM();
    }
    static #rotatePoint(x, y, angle) {
        switch(angle){
            case 90:
                return [
                    y,
                    -x
                ];
            case 180:
                return [
                    -x,
                    -y
                ];
            case 270:
                return [
                    -y,
                    x
                ];
            default:
                return [
                    x,
                    y
                ];
        }
    }
    screenToPageTranslation(x, y) {
        return $a2cc6e1d6eb3861b$var$AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
    }
    pageTranslationToScreen(x, y) {
        return $a2cc6e1d6eb3861b$var$AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
    }
    #getRotationMatrix(rotation) {
        switch(rotation){
            case 90:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        -pageWidth / pageHeight,
                        pageHeight / pageWidth,
                        0
                    ];
                }
            case 180:
                return [
                    -1,
                    0,
                    0,
                    -1
                ];
            case 270:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        pageWidth / pageHeight,
                        -pageHeight / pageWidth,
                        0
                    ];
                }
            default:
                return [
                    1,
                    0,
                    0,
                    1
                ];
        }
    }
    get parentScale() {
        return this._uiManager.viewParameters.realScale;
    }
    get parentRotation() {
        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
    }
    get parentDimensions() {
        const { parentScale: parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
        return [
            pageWidth * parentScale,
            pageHeight * parentScale
        ];
    }
    setDims() {
        const { div: { style: style }, width: width, height: height } = this;
        style.width = `${(100 * width).toFixed(2)}%`;
        style.height = `${(100 * height).toFixed(2)}%`;
    }
    getInitialTranslation() {
        return [
            0,
            0
        ];
    }
    #createResizers() {
        if (this.#resizersDiv) return;
        this.#resizersDiv = document.createElement("div");
        this.#resizersDiv.classList.add("resizers");
        const classes = this._willKeepAspectRatio ? [
            "topLeft",
            "topRight",
            "bottomRight",
            "bottomLeft"
        ] : [
            "topLeft",
            "topMiddle",
            "topRight",
            "middleRight",
            "bottomRight",
            "bottomMiddle",
            "bottomLeft",
            "middleLeft"
        ];
        const signal = this._uiManager._signal;
        for (const name of classes){
            const div = document.createElement("div");
            this.#resizersDiv.append(div);
            div.classList.add("resizer", name);
            div.setAttribute("data-resizer-name", name);
            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name), {
                signal: signal
            });
            div.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
                signal: signal
            });
            div.tabIndex = -1;
        }
        this.div.prepend(this.#resizersDiv);
    }
    #resizerPointerdown(name, event) {
        event.preventDefault();
        const { isMac: isMac } = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        this.#altText?.toggle(false);
        const savedDraggable = this._isDraggable;
        this._isDraggable = false;
        this.#lastPointerCoords = [
            event.screenX,
            event.screenY
        ];
        const ac = new AbortController();
        const signal = this._uiManager.combinedSignal(ac);
        this.parent.togglePointerEvents(false);
        window.addEventListener("pointermove", this.#resizerPointermove.bind(this, name), {
            passive: true,
            capture: true,
            signal: signal
        });
        window.addEventListener("touchmove", $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050, {
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
            signal: signal
        });
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const savedParentCursor = this.parent.div.style.cursor;
        const savedCursor = this.div.style.cursor;
        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
        const pointerUpCallback = ()=>{
            ac.abort();
            this.parent.togglePointerEvents(true);
            this.#altText?.toggle(true);
            this._isDraggable = savedDraggable;
            this.parent.div.style.cursor = savedParentCursor;
            this.div.style.cursor = savedCursor;
            this.#addResizeToUndoStack();
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    #resize(x, y, width, height) {
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
        this.setDims();
        this.fixAndSetPosition();
        this._onResized();
    }
    _onResized() {}
    #addResizeToUndoStack() {
        if (!this.#savedDimensions) return;
        const { savedX: savedX, savedY: savedY, savedWidth: savedWidth, savedHeight: savedHeight } = this.#savedDimensions;
        this.#savedDimensions = null;
        const newX = this.x;
        const newY = this.y;
        const newWidth = this.width;
        const newHeight = this.height;
        if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
        this.addCommands({
            cmd: this.#resize.bind(this, newX, newY, newWidth, newHeight),
            undo: this.#resize.bind(this, savedX, savedY, savedWidth, savedHeight),
            mustExec: true
        });
    }
    static _round(x) {
        return Math.round(x * 10000) / 10000;
    }
    #resizerPointermove(name, event) {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $a2cc6e1d6eb3861b$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $a2cc6e1d6eb3861b$var$AnnotationEditor.MIN_SIZE / parentHeight;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
        const invTransf = (x, y)=>[
                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                invRotationMatrix[1] * x + invRotationMatrix[3] * y
            ];
        let getPoint;
        let getOpposite;
        let isDiagonal = false;
        let isHorizontal = false;
        switch(name){
            case "topLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h
                    ];
                break;
            case "topMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        h
                    ];
                break;
            case "topRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        0
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h
                    ];
                break;
            case "middleRight":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        w,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h / 2
                    ];
                break;
            case "bottomRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        h
                    ];
                getOpposite = (w, h)=>[
                        0,
                        0
                    ];
                break;
            case "bottomMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        0
                    ];
                break;
            case "bottomLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w,
                        0
                    ];
                break;
            case "middleLeft":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        0,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h / 2
                    ];
                break;
        }
        const point = getPoint(savedWidth, savedHeight);
        const oppositePoint = getOpposite(savedWidth, savedHeight);
        let transfOppositePoint = transf(...oppositePoint);
        const oppositeX = $a2cc6e1d6eb3861b$var$AnnotationEditor._round(savedX + transfOppositePoint[0]);
        const oppositeY = $a2cc6e1d6eb3861b$var$AnnotationEditor._round(savedY + transfOppositePoint[1]);
        let ratioX = 1;
        let ratioY = 1;
        let deltaX, deltaY;
        if (!event.fromKeyboard) {
            const { screenX: screenX, screenY: screenY } = event;
            const [lastScreenX, lastScreenY] = this.#lastPointerCoords;
            [deltaX, deltaY] = this.screenToPageTranslation(screenX - lastScreenX, screenY - lastScreenY);
            this.#lastPointerCoords[0] = screenX;
            this.#lastPointerCoords[1] = screenY;
        } else ({ deltaX: deltaX, deltaY: deltaY } = event);
        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
        if (isDiagonal) {
            const oldDiag = Math.hypot(savedWidth, savedHeight);
            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        } else if (isHorizontal) ratioX = $a2cc6e1d6eb3861b$export$b8106b171181a554(Math.abs(oppositePoint[0] - point[0] - deltaX), minWidth, 1) / savedWidth;
        else ratioY = $a2cc6e1d6eb3861b$export$b8106b171181a554(Math.abs(oppositePoint[1] - point[1] - deltaY), minHeight, 1) / savedHeight;
        const newWidth = $a2cc6e1d6eb3861b$var$AnnotationEditor._round(savedWidth * ratioX);
        const newHeight = $a2cc6e1d6eb3861b$var$AnnotationEditor._round(savedHeight * ratioY);
        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
        const newX = oppositeX - transfOppositePoint[0];
        const newY = oppositeY - transfOppositePoint[1];
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        this.width = newWidth;
        this.height = newHeight;
        this.x = newX;
        this.y = newY;
        this.setDims();
        this.fixAndSetPosition();
        this._onResizing();
    }
    _onResizing() {}
    altTextFinish() {
        this.#altText?.finish();
    }
    get toolbarButtons() {
        return null;
    }
    async addEditToolbar() {
        if (this._editToolbar || this.#isInEditMode) return this._editToolbar;
        this._editToolbar = new $a2cc6e1d6eb3861b$var$EditorToolbar(this);
        this.div.append(this._editToolbar.render());
        const { toolbarButtons: toolbarButtons } = this;
        if (toolbarButtons) for (const [name, tool] of toolbarButtons)await this._editToolbar.addButton(name, tool);
        if (!this.hasComment) this._editToolbar.addButton("comment", this.addCommentButton());
        this._editToolbar.addButton("delete");
        return this._editToolbar;
    }
    addCommentButtonInToolbar() {
        this._editToolbar?.addButtonBefore("comment", this.addCommentButton(), ".deleteButton");
    }
    removeCommentButtonFromToolbar() {
        this._editToolbar?.removeButton("comment");
    }
    removeEditToolbar() {
        this._editToolbar?.remove();
        this._editToolbar = null;
        this.#altText?.destroy();
    }
    addContainer(container) {
        const editToolbarDiv = this._editToolbar?.div;
        if (editToolbarDiv) editToolbarDiv.before(container);
        else this.div.append(container);
    }
    getClientDimensions() {
        return this.div.getBoundingClientRect();
    }
    createAltText() {
        if (!this.#altText) {
            $a2cc6e1d6eb3861b$var$AltText.initialize($a2cc6e1d6eb3861b$var$AnnotationEditor._l10n);
            this.#altText = new $a2cc6e1d6eb3861b$var$AltText(this);
            if (this.#accessibilityData) {
                this.#altText.data = this.#accessibilityData;
                this.#accessibilityData = null;
            }
        }
        return this.#altText;
    }
    get altTextData() {
        return this.#altText?.data;
    }
    set altTextData(data) {
        if (!this.#altText) return;
        this.#altText.data = data;
    }
    get guessedAltText() {
        return this.#altText?.guessedText;
    }
    async setGuessedAltText(text) {
        await this.#altText?.setGuessedText(text);
    }
    serializeAltText(isForCopying) {
        return this.#altText?.serialize(isForCopying);
    }
    hasAltText() {
        return !!this.#altText && !this.#altText.isEmpty();
    }
    hasAltTextData() {
        return this.#altText?.hasData() ?? false;
    }
    focusCommentButton() {
        this.#comment?.focusButton();
    }
    addCommentButton() {
        return this.canAddComment ? this.#comment ||= new $a2cc6e1d6eb3861b$var$Comment(this) : null;
    }
    addStandaloneCommentButton() {
        if (!this._uiManager.hasCommentManager()) return;
        if (this.#commentStandaloneButton) {
            if (this._uiManager.isEditingMode()) this.#commentStandaloneButton.classList.remove("hidden");
            return;
        }
        if (!this.hasComment) return;
        this.#commentStandaloneButton = this.#comment.renderForStandalone();
        this.div.append(this.#commentStandaloneButton);
    }
    removeStandaloneCommentButton() {
        this.#comment.removeStandaloneCommentButton();
        this.#commentStandaloneButton = null;
    }
    hideStandaloneCommentButton() {
        this.#commentStandaloneButton?.classList.add("hidden");
    }
    get comment() {
        if (!this.#comment) return null;
        const { data: { richText: richText, text: text, date: date, deleted: deleted } } = this.#comment;
        return {
            text: text,
            richText: richText,
            date: date,
            deleted: deleted,
            color: this.getNonHCMColor(),
            opacity: this.opacity ?? 1
        };
    }
    set comment(value) {
        this.#comment ||= new $a2cc6e1d6eb3861b$var$Comment(this);
        if (typeof value === "object" && value !== null) this.#comment.restoreData(value);
        else this.#comment.data = value;
        if (this.hasComment) {
            this.removeCommentButtonFromToolbar();
            this.addStandaloneCommentButton();
            this._uiManager.updateComment(this);
        } else {
            this.addCommentButtonInToolbar();
            this.removeStandaloneCommentButton();
            this._uiManager.removeComment(this);
        }
    }
    setCommentData({ comment: comment, popupRef: popupRef, richText: richText }) {
        if (!popupRef) return;
        this.#comment ||= new $a2cc6e1d6eb3861b$var$Comment(this);
        this.#comment.setInitialText(comment, richText);
        if (!this.annotationElementId) return;
        const storedData = this._uiManager.getAndRemoveDataFromAnnotationStorage(this.annotationElementId);
        if (storedData) this.updateFromAnnotationLayer(storedData);
    }
    get hasEditedComment() {
        return this.#comment?.hasBeenEdited();
    }
    get hasDeletedComment() {
        return this.#comment?.isDeleted();
    }
    get hasComment() {
        return !!this.#comment && !this.#comment.isEmpty() && !this.#comment.isDeleted();
    }
    async editComment(options) {
        this.#comment ||= new $a2cc6e1d6eb3861b$var$Comment(this);
        this.#comment.edit(options);
    }
    toggleComment(isSelected, visibility) {
        if (this.hasComment) this._uiManager.toggleComment(this, isSelected, visibility);
    }
    setSelectedCommentButton(selected) {
        this.#comment.setSelectedButton(selected);
    }
    addComment(serialized) {
        if (this.hasEditedComment) {
            const DEFAULT_POPUP_WIDTH = 180;
            const DEFAULT_POPUP_HEIGHT = 100;
            const [, , , trY] = serialized.rect;
            const [pageWidth] = this.pageDimensions;
            const [pageX] = this.pageTranslation;
            const blX = pageX + pageWidth + 1;
            const blY = trY - DEFAULT_POPUP_HEIGHT;
            const trX = blX + DEFAULT_POPUP_WIDTH;
            serialized.popup = {
                contents: this.comment.text,
                deleted: this.comment.deleted,
                rect: [
                    blX,
                    blY,
                    trX,
                    trY
                ]
            };
        }
    }
    updateFromAnnotationLayer({ popup: { contents: contents, deleted: deleted } }) {
        this.#comment.data = deleted ? null : contents;
    }
    get parentBoundingClientRect() {
        return this.parent.boundingClientRect;
    }
    render() {
        const div = this.div = document.createElement("div");
        div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
        div.className = this.name;
        div.setAttribute("id", this.id);
        div.tabIndex = this.#disabled ? -1 : 0;
        div.setAttribute("role", "application");
        if (this.defaultL10nId) div.setAttribute("data-l10n-id", this.defaultL10nId);
        if (!this._isVisible) div.classList.add("hidden");
        this.setInForeground();
        this.#addFocusListeners();
        const [parentWidth, parentHeight] = this.parentDimensions;
        if (this.parentRotation % 180 !== 0) {
            div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
            div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
        }
        const [tx, ty] = this.getInitialTranslation();
        this.translate(tx, ty);
        $a2cc6e1d6eb3861b$var$bindEvents(this, div, [
            "keydown",
            "pointerdown",
            "dblclick"
        ]);
        if (this.isResizable && this._uiManager._supportsPinchToZoom) this.#touchManager ||= new $a2cc6e1d6eb3861b$export$9ae7542b430d543e({
            container: div,
            isPinchingDisabled: ()=>!this.isSelected,
            onPinchStart: this.#touchPinchStartCallback.bind(this),
            onPinching: this.#touchPinchCallback.bind(this),
            onPinchEnd: this.#touchPinchEndCallback.bind(this),
            signal: this._uiManager._signal
        });
        this.addStandaloneCommentButton();
        this._uiManager._editorUndoBar?.hide();
        return div;
    }
    #touchPinchStartCallback() {
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        this.#altText?.toggle(false);
        this.parent.togglePointerEvents(false);
    }
    #touchPinchCallback(_origin, prevDistance, distance) {
        const slowDownFactor = 0.7;
        let factor = slowDownFactor * (distance / prevDistance) + 1 - slowDownFactor;
        if (factor === 1) return;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $a2cc6e1d6eb3861b$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $a2cc6e1d6eb3861b$var$AnnotationEditor.MIN_SIZE / parentHeight;
        factor = Math.max(Math.min(factor, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        const newWidth = $a2cc6e1d6eb3861b$var$AnnotationEditor._round(savedWidth * factor);
        const newHeight = $a2cc6e1d6eb3861b$var$AnnotationEditor._round(savedHeight * factor);
        if (newWidth === savedWidth && newHeight === savedHeight) return;
        this.#initialRect ||= [
            savedX,
            savedY,
            savedWidth,
            savedHeight
        ];
        const transfCenterPoint = transf(savedWidth / 2, savedHeight / 2);
        const centerX = $a2cc6e1d6eb3861b$var$AnnotationEditor._round(savedX + transfCenterPoint[0]);
        const centerY = $a2cc6e1d6eb3861b$var$AnnotationEditor._round(savedY + transfCenterPoint[1]);
        const newTransfCenterPoint = transf(newWidth / 2, newHeight / 2);
        this.x = centerX - newTransfCenterPoint[0];
        this.y = centerY - newTransfCenterPoint[1];
        this.width = newWidth;
        this.height = newHeight;
        this.setDims();
        this.fixAndSetPosition();
        this._onResizing();
    }
    #touchPinchEndCallback() {
        this.#altText?.toggle(true);
        this.parent.togglePointerEvents(true);
        this.#addResizeToUndoStack();
    }
    pointerdown(event) {
        const { isMac: isMac } = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) {
            event.preventDefault();
            return;
        }
        this.#hasBeenClicked = true;
        if (this._isDraggable) {
            this.#setUpDragSession(event);
            return;
        }
        this.#selectOnPointerEvent(event);
    }
    #selectOnPointerEvent(event) {
        const { isMac: isMac } = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform;
        if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
        else this.parent.setSelected(this);
    }
    #setUpDragSession(event) {
        const { isSelected: isSelected } = this;
        this._uiManager.setUpDragSession();
        let hasDraggingStarted = false;
        const ac = new AbortController();
        const signal = this._uiManager.combinedSignal(ac);
        const opts = {
            capture: true,
            passive: false,
            signal: signal
        };
        const cancelDrag = (e)=>{
            ac.abort();
            this.#dragPointerId = null;
            this.#hasBeenClicked = false;
            if (!this._uiManager.endDragSession()) this.#selectOnPointerEvent(e);
            if (hasDraggingStarted) this._onStopDragging();
        };
        if (isSelected) {
            this.#prevDragX = event.clientX;
            this.#prevDragY = event.clientY;
            this.#dragPointerId = event.pointerId;
            this.#dragPointerType = event.pointerType;
            window.addEventListener("pointermove", (e)=>{
                if (!hasDraggingStarted) {
                    hasDraggingStarted = true;
                    this._uiManager.toggleComment(this, true, false);
                    this._onStartDragging();
                }
                const { clientX: x, clientY: y, pointerId: pointerId } = e;
                if (pointerId !== this.#dragPointerId) {
                    $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e);
                    return;
                }
                const [tx, ty] = this.screenToPageTranslation(x - this.#prevDragX, y - this.#prevDragY);
                this.#prevDragX = x;
                this.#prevDragY = y;
                this._uiManager.dragSelectedEditors(tx, ty);
            }, opts);
            window.addEventListener("touchmove", $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050, opts);
            window.addEventListener("pointerdown", (e)=>{
                if (e.pointerType === this.#dragPointerType) {
                    if (this.#touchManager || e.isPrimary) cancelDrag(e);
                }
                $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e);
            }, opts);
        }
        const pointerUpCallback = (e)=>{
            if (!this.#dragPointerId || this.#dragPointerId === e.pointerId) {
                cancelDrag(e);
                return;
            }
            $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e);
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    _onStartDragging() {}
    _onStopDragging() {}
    moveInDOM() {
        if (this.#moveInDOMTimeout) clearTimeout(this.#moveInDOMTimeout);
        this.#moveInDOMTimeout = setTimeout(()=>{
            this.#moveInDOMTimeout = null;
            this.parent?.moveEditorInDOM(this);
        }, 0);
    }
    _setParentAndPosition(parent, x, y) {
        parent.changeParent(this);
        this.x = x;
        this.y = y;
        this.fixAndSetPosition();
        this._onTranslated();
    }
    getRect(tx, ty, rotation = this.rotation) {
        const scale = this.parentScale;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const shiftX = tx / scale;
        const shiftY = ty / scale;
        const x = this.x * pageWidth;
        const y = this.y * pageHeight;
        const width = this.width * pageWidth;
        const height = this.height * pageHeight;
        switch(rotation){
            case 0:
                return [
                    x + shiftX + pageX,
                    pageHeight - y - shiftY - height + pageY,
                    x + shiftX + width + pageX,
                    pageHeight - y - shiftY + pageY
                ];
            case 90:
                return [
                    x + shiftY + pageX,
                    pageHeight - y + shiftX + pageY,
                    x + shiftY + height + pageX,
                    pageHeight - y + shiftX + width + pageY
                ];
            case 180:
                return [
                    x - shiftX - width + pageX,
                    pageHeight - y + shiftY + pageY,
                    x - shiftX + pageX,
                    pageHeight - y + shiftY + height + pageY
                ];
            case 270:
                return [
                    x - shiftY - height + pageX,
                    pageHeight - y - shiftX - width + pageY,
                    x - shiftY + pageX,
                    pageHeight - y - shiftX + pageY
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getRectInCurrentCoords(rect, pageHeight) {
        const [x1, y1, x2, y2] = rect;
        const width = x2 - x1;
        const height = y2 - y1;
        switch(this.rotation){
            case 0:
                return [
                    x1,
                    pageHeight - y2,
                    width,
                    height
                ];
            case 90:
                return [
                    x1,
                    pageHeight - y1,
                    height,
                    width
                ];
            case 180:
                return [
                    x2,
                    pageHeight - y1,
                    width,
                    height
                ];
            case 270:
                return [
                    x2,
                    pageHeight - y2,
                    height,
                    width
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getPDFRect() {
        return this.getRect(0, 0);
    }
    getNonHCMColor() {
        return this.color && $a2cc6e1d6eb3861b$var$AnnotationEditor._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
    }
    onUpdatedColor() {
        this.#comment?.onUpdatedColor();
    }
    getData() {
        const { comment: { text: str, color: color, date: date, opacity: opacity, deleted: deleted, richText: richText }, uid: id, pageIndex: pageIndex, creationDate: creationDate, modificationDate: modificationDate } = this;
        return {
            id: id,
            pageIndex: pageIndex,
            rect: this.getPDFRect(),
            richText: richText,
            contentsObj: {
                str: str
            },
            creationDate: creationDate,
            modificationDate: date || modificationDate,
            popupRef: !deleted,
            color: color,
            opacity: opacity
        };
    }
    onceAdded(focus) {}
    isEmpty() {
        return false;
    }
    enableEditMode() {
        if (this.isInEditMode()) return false;
        this.parent.setEditingState(false);
        this.#isInEditMode = true;
        return true;
    }
    disableEditMode() {
        if (!this.isInEditMode()) return false;
        this.parent.setEditingState(true);
        this.#isInEditMode = false;
        return true;
    }
    isInEditMode() {
        return this.#isInEditMode;
    }
    shouldGetKeyboardEvents() {
        return this.#isResizerEnabledForKeyboard;
    }
    needsToBeRebuilt() {
        return this.div && !this.isAttachedToDOM;
    }
    get isOnScreen() {
        const { top: top, left: left, bottom: bottom, right: right } = this.getClientDimensions();
        const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
        return left < innerWidth && right > 0 && top < innerHeight && bottom > 0;
    }
    #addFocusListeners() {
        if (this.#focusAC || !this.div) return;
        this.#focusAC = new AbortController();
        const signal = this._uiManager.combinedSignal(this.#focusAC);
        this.div.addEventListener("focusin", this.focusin.bind(this), {
            signal: signal
        });
        this.div.addEventListener("focusout", this.focusout.bind(this), {
            signal: signal
        });
    }
    rebuild() {
        this.#addFocusListeners();
    }
    rotate(_angle) {}
    resize() {}
    serializeDeleted() {
        return {
            id: this.annotationElementId,
            deleted: true,
            pageIndex: this.pageIndex,
            popupRef: this._initialData?.popupRef || ""
        };
    }
    serialize(isForCopying = false, context = null) {
        return {
            annotationType: this.mode,
            pageIndex: this.pageIndex,
            rect: this.getPDFRect(),
            rotation: this.rotation,
            structTreeParentId: this._structTreeParentId,
            popupRef: this._initialData?.popupRef || ""
        };
    }
    static async deserialize(data, parent, uiManager) {
        const editor = new this.prototype.constructor({
            parent: parent,
            id: uiManager.getId(),
            uiManager: uiManager,
            annotationElementId: data.annotationElementId,
            creationDate: data.creationDate,
            modificationDate: data.modificationDate
        });
        editor.rotation = data.rotation;
        editor.#accessibilityData = data.accessibilityData;
        editor._isCopy = data.isCopy || false;
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
        editor.x = x / pageWidth;
        editor.y = y / pageHeight;
        editor.width = width / pageWidth;
        editor.height = height / pageHeight;
        return editor;
    }
    get hasBeenModified() {
        return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
    }
    remove() {
        this.#focusAC?.abort();
        this.#focusAC = null;
        if (!this.isEmpty()) this.commit();
        if (this.parent) this.parent.remove(this);
        else this._uiManager.removeEditor(this);
        this.hideCommentPopup();
        if (this.#moveInDOMTimeout) {
            clearTimeout(this.#moveInDOMTimeout);
            this.#moveInDOMTimeout = null;
        }
        this.#stopResizing();
        this.removeEditToolbar();
        if (this.#telemetryTimeouts) {
            for (const timeout of this.#telemetryTimeouts.values())clearTimeout(timeout);
            this.#telemetryTimeouts = null;
        }
        this.parent = null;
        this.#touchManager?.destroy();
        this.#touchManager = null;
        this.#fakeAnnotation?.remove();
        this.#fakeAnnotation = null;
    }
    get isResizable() {
        return false;
    }
    makeResizable() {
        if (this.isResizable) {
            this.#createResizers();
            this.#resizersDiv.classList.remove("hidden");
        }
    }
    get toolbarPosition() {
        return null;
    }
    get commentButtonPosition() {
        return this._uiManager.direction === "ltr" ? [
            1,
            0
        ] : [
            0,
            0
        ];
    }
    get commentButtonPositionInPage() {
        const { commentButtonPosition: [posX, posY] } = this;
        const [blX, blY, trX, trY] = this.getPDFRect();
        return [
            $a2cc6e1d6eb3861b$var$AnnotationEditor._round(blX + (trX - blX) * posX),
            $a2cc6e1d6eb3861b$var$AnnotationEditor._round(blY + (trY - blY) * (1 - posY))
        ];
    }
    get commentButtonColor() {
        return this._uiManager.makeCommentColor(this.getNonHCMColor(), this.opacity);
    }
    get commentPopupPosition() {
        return this.#comment.commentPopupPositionInLayer;
    }
    set commentPopupPosition(pos) {
        this.#comment.commentPopupPositionInLayer = pos;
    }
    hasDefaultPopupPosition() {
        return this.#comment.hasDefaultPopupPosition();
    }
    get commentButtonWidth() {
        return this.#comment.commentButtonWidth;
    }
    get elementBeforePopup() {
        return this.div;
    }
    setCommentButtonStates(options) {
        this.#comment?.setCommentButtonStates(options);
    }
    keydown(event) {
        if (!this.isResizable || event.target !== this.div || event.key !== "Enter") return;
        this._uiManager.setSelected(this);
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const children = this.#resizersDiv.children;
        if (!this.#allResizerDivs) {
            this.#allResizerDivs = Array.from(children);
            const boundResizerKeydown = this.#resizerKeydown.bind(this);
            const boundResizerBlur = this.#resizerBlur.bind(this);
            const signal = this._uiManager._signal;
            for (const div of this.#allResizerDivs){
                const name = div.getAttribute("data-resizer-name");
                div.setAttribute("role", "spinbutton");
                div.addEventListener("keydown", boundResizerKeydown, {
                    signal: signal
                });
                div.addEventListener("blur", boundResizerBlur, {
                    signal: signal
                });
                div.addEventListener("focus", this.#resizerFocus.bind(this, name), {
                    signal: signal
                });
                div.setAttribute("data-l10n-id", $a2cc6e1d6eb3861b$var$AnnotationEditor._l10nResizer[name]);
            }
        }
        const first = this.#allResizerDivs[0];
        let firstPosition = 0;
        for (const div of children){
            if (div === first) break;
            firstPosition++;
        }
        const nextFirstPosition = (360 - this.rotation + this.parentRotation) % 360 / 90 * (this.#allResizerDivs.length / 4);
        if (nextFirstPosition !== firstPosition) {
            if (nextFirstPosition < firstPosition) for(let i = 0; i < firstPosition - nextFirstPosition; i++)this.#resizersDiv.append(this.#resizersDiv.firstElementChild);
            else if (nextFirstPosition > firstPosition) for(let i = 0; i < nextFirstPosition - firstPosition; i++)this.#resizersDiv.firstElementChild.before(this.#resizersDiv.lastElementChild);
            let i = 0;
            for (const child of children){
                const div = this.#allResizerDivs[i++];
                const name = div.getAttribute("data-resizer-name");
                child.setAttribute("data-l10n-id", $a2cc6e1d6eb3861b$var$AnnotationEditor._l10nResizer[name]);
            }
        }
        this.#setResizerTabIndex(0);
        this.#isResizerEnabledForKeyboard = true;
        this.#resizersDiv.firstElementChild.focus({
            focusVisible: true
        });
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    #resizerKeydown(event) {
        $a2cc6e1d6eb3861b$var$AnnotationEditor._resizerKeyboardManager.exec(this, event);
    }
    #resizerBlur(event) {
        if (this.#isResizerEnabledForKeyboard && event.relatedTarget?.parentNode !== this.#resizersDiv) this.#stopResizing();
    }
    #resizerFocus(name) {
        this.#focusedResizerName = this.#isResizerEnabledForKeyboard ? name : "";
    }
    #setResizerTabIndex(value) {
        if (!this.#allResizerDivs) return;
        for (const div of this.#allResizerDivs)div.tabIndex = value;
    }
    _resizeWithKeyboard(x, y) {
        if (!this.#isResizerEnabledForKeyboard) return;
        this.#resizerPointermove(this.#focusedResizerName, {
            deltaX: x,
            deltaY: y,
            fromKeyboard: true
        });
    }
    #stopResizing() {
        this.#isResizerEnabledForKeyboard = false;
        this.#setResizerTabIndex(-1);
        this.#addResizeToUndoStack();
    }
    _stopResizingWithKeyboard() {
        this.#stopResizing();
        this.div.focus();
    }
    select() {
        if (this.isSelected && this._editToolbar) {
            this._editToolbar.show();
            return;
        }
        this.isSelected = true;
        this.makeResizable();
        this.div?.classList.add("selectedEditor");
        if (!this._editToolbar) {
            this.addEditToolbar().then(()=>{
                if (this.div?.classList.contains("selectedEditor")) this._editToolbar?.show();
            });
            return;
        }
        this._editToolbar?.show();
        this.#altText?.toggleAltTextBadge(false);
    }
    focus() {
        if (this.div && !this.div.contains(document.activeElement)) setTimeout(()=>this.div?.focus({
                preventScroll: true
            }), 0);
    }
    unselect() {
        if (!this.isSelected) return;
        this.isSelected = false;
        this.#resizersDiv?.classList.add("hidden");
        this.div?.classList.remove("selectedEditor");
        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus({
            preventScroll: true
        });
        this._editToolbar?.hide();
        this.#altText?.toggleAltTextBadge(true);
        this.hideCommentPopup();
    }
    hideCommentPopup() {
        if (this.hasComment) this._uiManager.toggleComment(null);
    }
    updateParams(type, value) {}
    disableEditing() {}
    enableEditing() {}
    get canChangeContent() {
        return false;
    }
    enterInEditMode() {
        if (!this.canChangeContent) return;
        this.enableEditMode();
        this.div.focus();
    }
    dblclick(event) {
        if (event.target.nodeName === "BUTTON") return;
        this.enterInEditMode();
        this.parent.updateToolbar({
            mode: this.constructor._editorType,
            editId: this.uid
        });
    }
    getElementForAltText() {
        return this.div;
    }
    get contentDiv() {
        return this.div;
    }
    get isEditing() {
        return this.#isEditing;
    }
    set isEditing(value) {
        this.#isEditing = value;
        if (!this.parent) return;
        if (value) {
            this.parent.setSelected(this);
            this.parent.setActiveEditor(this);
        } else this.parent.setActiveEditor(null);
    }
    static get MIN_SIZE() {
        return 16;
    }
    static canCreateNewEmptyEditor() {
        return true;
    }
    get telemetryInitialData() {
        return {
            action: "added"
        };
    }
    get telemetryFinalData() {
        return null;
    }
    _reportTelemetry(data, mustWait = false) {
        if (mustWait) {
            this.#telemetryTimeouts ||= new Map();
            const { action: action } = data;
            let timeout = this.#telemetryTimeouts.get(action);
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                this._reportTelemetry(data);
                this.#telemetryTimeouts.delete(action);
                if (this.#telemetryTimeouts.size === 0) this.#telemetryTimeouts = null;
            }, $a2cc6e1d6eb3861b$var$AnnotationEditor._telemetryTimeout);
            this.#telemetryTimeouts.set(action, timeout);
            return;
        }
        data.type ||= this.editorType;
        this._uiManager._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
                type: "editing",
                data: data
            }
        });
    }
    show(visible = this._isVisible) {
        this.div.classList.toggle("hidden", !visible);
        this._isVisible = visible;
    }
    enable() {
        if (this.div) this.div.tabIndex = 0;
        this.#disabled = false;
    }
    disable() {
        if (this.div) this.div.tabIndex = -1;
        this.#disabled = true;
    }
    updateFakeAnnotationElement(annotationLayer) {
        if (!this.#fakeAnnotation && !this.deleted) {
            this.#fakeAnnotation = annotationLayer.addFakeAnnotation(this);
            return;
        }
        if (this.deleted) {
            this.#fakeAnnotation.remove();
            this.#fakeAnnotation = null;
            return;
        }
        if (this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized) this.#fakeAnnotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        let content = annotation.container.querySelector(".annotationContent");
        if (!content) {
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            annotation.container.prepend(content);
        } else if (content.nodeName === "CANVAS") {
            const canvas = content;
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            canvas.before(content);
        }
        return content;
    }
    resetAnnotationElement(annotation) {
        const { firstElementChild: firstElementChild } = annotation.container;
        if (firstElementChild?.nodeName === "DIV" && firstElementChild.classList.contains("annotationContent")) firstElementChild.remove();
    }
}
class $a2cc6e1d6eb3861b$var$FakeEditor extends $a2cc6e1d6eb3861b$var$AnnotationEditor {
    constructor(params){
        super(params);
        this.annotationElementId = params.annotationElementId;
        this.deleted = true;
    }
    serialize() {
        return this.serializeDeleted();
    }
}
const $a2cc6e1d6eb3861b$var$SEED = 0xc3d2e1f0;
const $a2cc6e1d6eb3861b$var$MASK_HIGH = 0xffff0000;
const $a2cc6e1d6eb3861b$var$MASK_LOW = 0xffff;
class $a2cc6e1d6eb3861b$var$MurmurHash3_64 {
    constructor(seed){
        this.h1 = seed ? seed & 0xffffffff : $a2cc6e1d6eb3861b$var$SEED;
        this.h2 = seed ? seed & 0xffffffff : $a2cc6e1d6eb3861b$var$SEED;
    }
    update(input) {
        let data, length;
        if (typeof input === "string") {
            data = new Uint8Array(input.length * 2);
            length = 0;
            for(let i = 0, ii = input.length; i < ii; i++){
                const code = input.charCodeAt(i);
                if (code <= 0xff) data[length++] = code;
                else {
                    data[length++] = code >>> 8;
                    data[length++] = code & 0xff;
                }
            }
        } else if (ArrayBuffer.isView(input)) {
            data = input.slice();
            length = data.byteLength;
        } else throw new Error("Invalid data format, must be a string or TypedArray.");
        const blockCounts = length >> 2;
        const tailLength = length - blockCounts * 4;
        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
        let k1 = 0, k2 = 0;
        let h1 = this.h1, h2 = this.h2;
        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
        const C1_LOW = C1 & $a2cc6e1d6eb3861b$var$MASK_LOW, C2_LOW = C2 & $a2cc6e1d6eb3861b$var$MASK_LOW;
        for(let i = 0; i < blockCounts; i++)if (i & 1) {
            k1 = dataUint32[i];
            k1 = k1 * C1 & $a2cc6e1d6eb3861b$var$MASK_HIGH | k1 * C1_LOW & $a2cc6e1d6eb3861b$var$MASK_LOW;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = k1 * C2 & $a2cc6e1d6eb3861b$var$MASK_HIGH | k1 * C2_LOW & $a2cc6e1d6eb3861b$var$MASK_LOW;
            h1 ^= k1;
            h1 = h1 << 13 | h1 >>> 19;
            h1 = h1 * 5 + 0xe6546b64;
        } else {
            k2 = dataUint32[i];
            k2 = k2 * C1 & $a2cc6e1d6eb3861b$var$MASK_HIGH | k2 * C1_LOW & $a2cc6e1d6eb3861b$var$MASK_LOW;
            k2 = k2 << 15 | k2 >>> 17;
            k2 = k2 * C2 & $a2cc6e1d6eb3861b$var$MASK_HIGH | k2 * C2_LOW & $a2cc6e1d6eb3861b$var$MASK_LOW;
            h2 ^= k2;
            h2 = h2 << 13 | h2 >>> 19;
            h2 = h2 * 5 + 0xe6546b64;
        }
        k1 = 0;
        switch(tailLength){
            case 3:
                k1 ^= data[blockCounts * 4 + 2] << 16;
            case 2:
                k1 ^= data[blockCounts * 4 + 1] << 8;
            case 1:
                k1 ^= data[blockCounts * 4];
                k1 = k1 * C1 & $a2cc6e1d6eb3861b$var$MASK_HIGH | k1 * C1_LOW & $a2cc6e1d6eb3861b$var$MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & $a2cc6e1d6eb3861b$var$MASK_HIGH | k1 * C2_LOW & $a2cc6e1d6eb3861b$var$MASK_LOW;
                if (blockCounts & 1) h1 ^= k1;
                else h2 ^= k1;
        }
        this.h1 = h1;
        this.h2 = h2;
    }
    hexdigest() {
        let h1 = this.h1, h2 = this.h2;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0xed558ccd & $a2cc6e1d6eb3861b$var$MASK_HIGH | h1 * 0x8ccd & $a2cc6e1d6eb3861b$var$MASK_LOW;
        h2 = h2 * 0xff51afd7 & $a2cc6e1d6eb3861b$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & $a2cc6e1d6eb3861b$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0x1a85ec53 & $a2cc6e1d6eb3861b$var$MASK_HIGH | h1 * 0xec53 & $a2cc6e1d6eb3861b$var$MASK_LOW;
        h2 = h2 * 0xc4ceb9fe & $a2cc6e1d6eb3861b$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & $a2cc6e1d6eb3861b$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
    }
}
const $a2cc6e1d6eb3861b$var$SerializableEmpty = Object.freeze({
    map: null,
    hash: "",
    transfer: undefined
});
class $a2cc6e1d6eb3861b$var$AnnotationStorage {
    #modified = false;
    #modifiedIds = null;
    #editorsMap = null;
    #storage = new Map();
    onSetModified = null;
    onResetModified = null;
    onAnnotationEditor = null;
    getValue(key, defaultValue) {
        const value = this.#storage.get(key);
        if (value === undefined) return defaultValue;
        return Object.assign(defaultValue, value);
    }
    getRawValue(key) {
        return this.#storage.get(key);
    }
    remove(key) {
        const storedValue = this.#storage.get(key);
        if (storedValue === undefined) return;
        if (storedValue instanceof $a2cc6e1d6eb3861b$var$AnnotationEditor) this.#editorsMap.delete(storedValue.annotationElementId);
        this.#storage.delete(key);
        if (this.#storage.size === 0) this.resetModified();
        if (this.#storage.values().some((v)=>v instanceof $a2cc6e1d6eb3861b$var$AnnotationEditor)) return;
        this.onAnnotationEditor?.(null);
    }
    setValue(key, value) {
        const obj = this.#storage.get(key);
        let modified = false;
        if (obj !== undefined) {
            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                modified = true;
                obj[entry] = val;
            }
        } else {
            modified = true;
            this.#storage.set(key, value);
        }
        if (modified) this.#setModified();
        if (value instanceof $a2cc6e1d6eb3861b$var$AnnotationEditor) {
            (this.#editorsMap ||= new Map()).set(value.annotationElementId, value);
            this.onAnnotationEditor?.(value.constructor._type);
        }
    }
    has(key) {
        return this.#storage.has(key);
    }
    get size() {
        return this.#storage.size;
    }
    #setModified() {
        if (!this.#modified) {
            this.#modified = true;
            this.onSetModified?.();
        }
    }
    resetModified() {
        if (this.#modified) {
            this.#modified = false;
            this.onResetModified?.();
        }
    }
    get print() {
        return new $a2cc6e1d6eb3861b$var$PrintAnnotationStorage(this);
    }
    get serializable() {
        if (this.#storage.size === 0) return $a2cc6e1d6eb3861b$var$SerializableEmpty;
        const map = new Map(), hash = new $a2cc6e1d6eb3861b$var$MurmurHash3_64(), transfer = [];
        const context = Object.create(null);
        let hasBitmap = false;
        for (const [key, val] of this.#storage){
            const serialized = val instanceof $a2cc6e1d6eb3861b$var$AnnotationEditor ? val.serialize(false, context) : val;
            if (val.page) {
                val.pageIndex = val.page._pageIndex;
                delete val.page;
            }
            if (serialized) {
                map.set(key, serialized);
                hash.update(`${key}:${JSON.stringify(serialized)}`);
                hasBitmap ||= !!serialized.bitmap;
            }
        }
        if (hasBitmap) {
            for (const value of map.values())if (value.bitmap) transfer.push(value.bitmap);
        }
        return map.size > 0 ? {
            map: map,
            hash: hash.hexdigest(),
            transfer: transfer
        } : $a2cc6e1d6eb3861b$var$SerializableEmpty;
    }
    get editorStats() {
        let stats = null;
        const typeToEditor = new Map();
        let numberOfEditedComments = 0;
        let numberOfDeletedComments = 0;
        for (const value of this.#storage.values()){
            if (!(value instanceof $a2cc6e1d6eb3861b$var$AnnotationEditor)) {
                if (value.popup) {
                    if (value.popup.deleted) numberOfDeletedComments += 1;
                    else numberOfEditedComments += 1;
                }
                continue;
            }
            if (value.isCommentDeleted) numberOfDeletedComments += 1;
            else if (value.hasEditedComment) numberOfEditedComments += 1;
            const editorStats = value.telemetryFinalData;
            if (!editorStats) continue;
            const { type: type } = editorStats;
            if (!typeToEditor.has(type)) typeToEditor.set(type, Object.getPrototypeOf(value).constructor);
            stats ||= Object.create(null);
            const map = stats[type] ||= new Map();
            for (const [key, val] of Object.entries(editorStats)){
                if (key === "type") continue;
                const counters = map.getOrInsertComputed(key, $a2cc6e1d6eb3861b$export$b41394a5437791c8);
                counters.set(val, (counters.get(val) ?? 0) + 1);
            }
        }
        if (numberOfDeletedComments > 0 || numberOfEditedComments > 0) {
            stats ||= Object.create(null);
            stats.comments = {
                deleted: numberOfDeletedComments,
                edited: numberOfEditedComments
            };
        }
        if (!stats) return null;
        for (const [type, editor] of typeToEditor)stats[type] = editor.computeTelemetryFinalData(stats[type]);
        return stats;
    }
    resetModifiedIds() {
        this.#modifiedIds = null;
    }
    updateEditor(annotationId, data) {
        const value = this.#editorsMap?.get(annotationId);
        if (value) {
            value.updateFromAnnotationLayer(data);
            return true;
        }
        return false;
    }
    getEditor(annotationId) {
        return this.#editorsMap?.get(annotationId) || null;
    }
    get modifiedIds() {
        if (this.#modifiedIds) return this.#modifiedIds;
        const ids = [];
        if (this.#editorsMap) for (const value of this.#editorsMap.values()){
            if (!value.serialize()) continue;
            ids.push(value.annotationElementId);
        }
        let hash = "";
        if (ids.length) {
            const h = new $a2cc6e1d6eb3861b$var$MurmurHash3_64();
            h.update(ids.join(","));
            hash = h.hexdigest();
        }
        return this.#modifiedIds = {
            ids: new Set(ids),
            hash: hash
        };
    }
    [Symbol.iterator]() {
        return this.#storage.entries();
    }
}
class $a2cc6e1d6eb3861b$var$PrintAnnotationStorage extends $a2cc6e1d6eb3861b$var$AnnotationStorage {
    #serializable = $a2cc6e1d6eb3861b$var$SerializableEmpty;
    constructor(parent){
        super();
        const { serializable: serializable } = parent;
        if (serializable === $a2cc6e1d6eb3861b$var$SerializableEmpty) return;
        const { map: map, hash: hash, transfer: transfer } = serializable;
        const clone = structuredClone(map, transfer ? {
            transfer: transfer
        } : null);
        this.#serializable = {
            map: clone,
            hash: hash,
            transfer: []
        };
    }
    get print() {
        $a2cc6e1d6eb3861b$var$unreachable("Should not call PrintAnnotationStorage.print");
    }
    get serializable() {
        return this.#serializable;
    }
    get modifiedIds() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "modifiedIds", {
            ids: new Set(),
            hash: ""
        });
    }
}
const $a2cc6e1d6eb3861b$var$FORCED_DEPENDENCY_LABEL = "__forcedDependency";
const { floor: $a2cc6e1d6eb3861b$var$floor, ceil: $a2cc6e1d6eb3861b$var$ceil } = Math;
function $a2cc6e1d6eb3861b$var$expandBBox(array, index, minX, minY, maxX, maxY) {
    array[index * 4 + 0] = Math.min(array[index * 4 + 0], minX);
    array[index * 4 + 1] = Math.min(array[index * 4 + 1], minY);
    array[index * 4 + 2] = Math.max(array[index * 4 + 2], maxX);
    array[index * 4 + 3] = Math.max(array[index * 4 + 3], maxY);
}
function $a2cc6e1d6eb3861b$var$scaleCharBBox(scaleX, scaleY, x, y, bbox) {
    let temp;
    if (scaleX) {
        if (scaleX < 0) {
            temp = bbox[0];
            bbox[0] = bbox[2];
            bbox[2] = temp;
        }
        bbox[0] *= scaleX;
        bbox[2] *= scaleX;
        if (scaleY < 0) {
            temp = bbox[1];
            bbox[1] = bbox[3];
            bbox[3] = temp;
        }
        bbox[1] *= scaleY;
        bbox[3] *= scaleY;
    } else bbox.fill(0);
    bbox[0] += x;
    bbox[1] += y;
    bbox[2] += x;
    bbox[3] += y;
}
const $a2cc6e1d6eb3861b$var$EMPTY_BBOX = new Uint32Array(new Uint8Array([
    255,
    255,
    0,
    0
]).buffer)[0];
class $a2cc6e1d6eb3861b$var$BBoxReader {
    #bboxes;
    #coords;
    constructor(bboxes, coords){
        this.#bboxes = bboxes;
        this.#coords = coords;
    }
    get length() {
        return this.#bboxes.length;
    }
    isEmpty(i) {
        return this.#bboxes[i] === $a2cc6e1d6eb3861b$var$EMPTY_BBOX;
    }
    minX(i) {
        return this.#coords[i * 4 + 0] / 256;
    }
    minY(i) {
        return this.#coords[i * 4 + 1] / 256;
    }
    maxX(i) {
        return (this.#coords[i * 4 + 2] + 1) / 256;
    }
    maxY(i) {
        return (this.#coords[i * 4 + 3] + 1) / 256;
    }
}
const $a2cc6e1d6eb3861b$var$ensureDebugMetadata = (map, key)=>map?.getOrInsertComputed(key, ()=>({
            dependencies: new Set(),
            isRenderingOperation: false
        }));
class $a2cc6e1d6eb3861b$var$CanvasBBoxTracker {
    #baseTransformStack = [
        [
            1,
            0,
            0,
            1,
            0,
            0
        ]
    ];
    #clipBox = [
        -Infinity,
        -Infinity,
        Infinity,
        Infinity
    ];
    #pendingBBox = new Float64Array($a2cc6e1d6eb3861b$var$BBOX_INIT);
    _pendingBBoxIdx = -1;
    #canvasWidth;
    #canvasHeight;
    #bboxesCoords;
    #bboxes;
    _savesStack = [];
    _markedContentStack = [];
    constructor(canvas, operationsCount){
        this.#canvasWidth = canvas.width;
        this.#canvasHeight = canvas.height;
        this.#initializeBBoxes(operationsCount);
    }
    growOperationsCount(operationsCount) {
        if (operationsCount >= this.#bboxes.length) this.#initializeBBoxes(operationsCount, this.#bboxes);
    }
    #initializeBBoxes(operationsCount, oldBBoxes) {
        const buffer = new ArrayBuffer(operationsCount * 4);
        this.#bboxesCoords = new Uint8ClampedArray(buffer);
        this.#bboxes = new Uint32Array(buffer);
        if (oldBBoxes && oldBBoxes.length > 0) {
            this.#bboxes.set(oldBBoxes);
            this.#bboxes.fill($a2cc6e1d6eb3861b$var$EMPTY_BBOX, oldBBoxes.length);
        } else this.#bboxes.fill($a2cc6e1d6eb3861b$var$EMPTY_BBOX);
    }
    get clipBox() {
        return this.#clipBox;
    }
    save(opIdx) {
        this.#clipBox = {
            __proto__: this.#clipBox
        };
        this._savesStack.push(opIdx);
        return this;
    }
    restore(opIdx, onSavePopped) {
        const previous = Object.getPrototypeOf(this.#clipBox);
        if (previous === null) return this;
        this.#clipBox = previous;
        const lastSave = this._savesStack.pop();
        if (lastSave !== undefined) {
            onSavePopped?.(lastSave, opIdx);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    recordOpenMarker(idx) {
        this._savesStack.push(idx);
        return this;
    }
    getOpenMarker() {
        if (this._savesStack.length === 0) return null;
        return this._savesStack.at(-1);
    }
    recordCloseMarker(opIdx, onSavePopped) {
        const lastSave = this._savesStack.pop();
        if (lastSave !== undefined) {
            onSavePopped?.(lastSave, opIdx);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    beginMarkedContent(opIdx) {
        this._markedContentStack.push(opIdx);
        return this;
    }
    endMarkedContent(opIdx, onSavePopped) {
        const lastSave = this._markedContentStack.pop();
        if (lastSave !== undefined) {
            onSavePopped?.(lastSave, opIdx);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    pushBaseTransform(ctx) {
        this.#baseTransformStack.push($a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform()));
        return this;
    }
    popBaseTransform() {
        if (this.#baseTransformStack.length > 1) this.#baseTransformStack.pop();
        return this;
    }
    resetBBox(idx) {
        if (this._pendingBBoxIdx !== idx) {
            this._pendingBBoxIdx = idx;
            this.#pendingBBox.set($a2cc6e1d6eb3861b$var$BBOX_INIT, 0);
        }
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        const transform = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform());
        const clipBox = $a2cc6e1d6eb3861b$var$BBOX_INIT.slice();
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            minX,
            minY,
            maxX,
            maxY
        ], transform, clipBox);
        const intersection = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.intersect(this.#clipBox, clipBox);
        if (intersection) {
            this.#clipBox[0] = intersection[0];
            this.#clipBox[1] = intersection[1];
            this.#clipBox[2] = intersection[2];
            this.#clipBox[3] = intersection[3];
        } else {
            this.#clipBox[0] = this.#clipBox[1] = Infinity;
            this.#clipBox[2] = this.#clipBox[3] = -Infinity;
        }
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        const clipBox = this.#clipBox;
        if (clipBox[0] === Infinity) return this;
        const transform = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform());
        if (clipBox[0] === -Infinity) {
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                minX,
                minY,
                maxX,
                maxY
            ], transform, this.#pendingBBox);
            return this;
        }
        const bbox = $a2cc6e1d6eb3861b$var$BBOX_INIT.slice();
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            minX,
            minY,
            maxX,
            maxY
        ], transform, bbox);
        this.#pendingBBox[0] = $a2cc6e1d6eb3861b$export$b8106b171181a554(bbox[0], clipBox[0], this.#pendingBBox[0]);
        this.#pendingBBox[1] = $a2cc6e1d6eb3861b$export$b8106b171181a554(bbox[1], clipBox[1], this.#pendingBBox[1]);
        this.#pendingBBox[2] = $a2cc6e1d6eb3861b$export$b8106b171181a554(bbox[2], this.#pendingBBox[2], clipBox[2]);
        this.#pendingBBox[3] = $a2cc6e1d6eb3861b$export$b8106b171181a554(bbox[3], this.#pendingBBox[3], clipBox[3]);
        return this;
    }
    recordFullPageBBox(idx) {
        this.#pendingBBox[0] = Math.max(0, this.#clipBox[0]);
        this.#pendingBBox[1] = Math.max(0, this.#clipBox[1]);
        this.#pendingBBox[2] = Math.min(this.#canvasWidth, this.#clipBox[2]);
        this.#pendingBBox[3] = Math.min(this.#canvasHeight, this.#clipBox[3]);
        return this;
    }
    recordOperation(idx, preserve = false, dependencyLists) {
        if (this._pendingBBoxIdx !== idx) return this;
        const minX = $a2cc6e1d6eb3861b$var$floor(this.#pendingBBox[0] * 256 / this.#canvasWidth);
        const minY = $a2cc6e1d6eb3861b$var$floor(this.#pendingBBox[1] * 256 / this.#canvasHeight);
        const maxX = $a2cc6e1d6eb3861b$var$ceil(this.#pendingBBox[2] * 256 / this.#canvasWidth);
        const maxY = $a2cc6e1d6eb3861b$var$ceil(this.#pendingBBox[3] * 256 / this.#canvasHeight);
        $a2cc6e1d6eb3861b$var$expandBBox(this.#bboxesCoords, idx, minX, minY, maxX, maxY);
        if (dependencyLists) for (const dependencies of dependencyLists){
            for (const depIdx of dependencies)if (depIdx !== idx) $a2cc6e1d6eb3861b$var$expandBBox(this.#bboxesCoords, depIdx, minX, minY, maxX, maxY);
        }
        if (!preserve) this._pendingBBoxIdx = -1;
        return this;
    }
    bboxToClipBoxDropOperation(idx) {
        if (this._pendingBBoxIdx === idx) {
            this._pendingBBoxIdx = -1;
            this.#clipBox[0] = Math.max(this.#clipBox[0], this.#pendingBBox[0]);
            this.#clipBox[1] = Math.max(this.#clipBox[1], this.#pendingBBox[1]);
            this.#clipBox[2] = Math.min(this.#clipBox[2], this.#pendingBBox[2]);
            this.#clipBox[3] = Math.min(this.#clipBox[3], this.#pendingBBox[3]);
        }
        return this;
    }
    take() {
        return new $a2cc6e1d6eb3861b$var$BBoxReader(this.#bboxes, this.#bboxesCoords);
    }
    takeDebugMetadata() {
        throw new Error("Unreachable");
    }
    recordSimpleData(name, idx) {
        return this;
    }
    recordIncrementalData(name, idx) {
        return this;
    }
    resetIncrementalData(name, idx) {
        return this;
    }
    recordNamedData(name, idx) {
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        return this;
    }
    recordFutureForcedDependency(name, idx) {
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale = 1, x = 0, y = 0, getMeasure) {
        return this;
    }
    getSimpleIndex(dependencyName) {
        return undefined;
    }
    recordDependencies(idx, dependencyNames) {
        return this;
    }
    recordNamedDependency(idx, name) {
        return this;
    }
    recordShowTextOperation(idx, preserve = false) {
        return this;
    }
}
class $a2cc6e1d6eb3861b$var$CanvasDependencyTracker {
    #simple = {
        __proto__: null
    };
    #incremental = {
        __proto__: null,
        transform: [],
        moveText: [],
        sameLineText: [],
        [$a2cc6e1d6eb3861b$var$FORCED_DEPENDENCY_LABEL]: []
    };
    #namedDependencies = new Map();
    #pendingDependencies = new Set();
    #fontBBoxTrustworthy = new Map();
    #debugMetadata;
    #recordDebugMetadataDepenencyAfterRestore;
    #bboxTracker;
    constructor(bboxTracker, recordDebugMetadata = false){
        this.#bboxTracker = bboxTracker;
        if (recordDebugMetadata) {
            this.#debugMetadata = new Map();
            this.#recordDebugMetadataDepenencyAfterRestore = (lastSave, opIdx)=>{
                $a2cc6e1d6eb3861b$var$ensureDebugMetadata(this.#debugMetadata, opIdx).dependencies.add(lastSave);
            };
        }
    }
    get clipBox() {
        return this.#bboxTracker.clipBox;
    }
    growOperationsCount(operationsCount) {
        this.#bboxTracker.growOperationsCount(operationsCount);
    }
    save(opIdx) {
        this.#simple = {
            __proto__: this.#simple
        };
        this.#incremental = {
            __proto__: this.#incremental,
            transform: {
                __proto__: this.#incremental.transform
            },
            moveText: {
                __proto__: this.#incremental.moveText
            },
            sameLineText: {
                __proto__: this.#incremental.sameLineText
            },
            [$a2cc6e1d6eb3861b$var$FORCED_DEPENDENCY_LABEL]: {
                __proto__: this.#incremental[$a2cc6e1d6eb3861b$var$FORCED_DEPENDENCY_LABEL]
            }
        };
        this.#bboxTracker.save(opIdx);
        return this;
    }
    restore(opIdx) {
        this.#bboxTracker.restore(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        const previous = Object.getPrototypeOf(this.#simple);
        if (previous === null) return this;
        this.#simple = previous;
        this.#incremental = Object.getPrototypeOf(this.#incremental);
        return this;
    }
    recordOpenMarker(opIdx) {
        this.#bboxTracker.recordOpenMarker(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        return this;
    }
    getOpenMarker() {
        return this.#bboxTracker.getOpenMarker();
    }
    recordCloseMarker(opIdx) {
        this.#bboxTracker.recordCloseMarker(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        return this;
    }
    beginMarkedContent(opIdx) {
        this.#bboxTracker.beginMarkedContent(opIdx);
        return this;
    }
    endMarkedContent(opIdx) {
        this.#bboxTracker.endMarkedContent(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        return this;
    }
    pushBaseTransform(ctx) {
        this.#bboxTracker.pushBaseTransform(ctx);
        return this;
    }
    popBaseTransform() {
        this.#bboxTracker.popBaseTransform();
        return this;
    }
    recordSimpleData(name, idx) {
        this.#simple[name] = idx;
        return this;
    }
    recordIncrementalData(name, idx) {
        this.#incremental[name].push(idx);
        return this;
    }
    resetIncrementalData(name, idx) {
        this.#incremental[name].length = 0;
        return this;
    }
    recordNamedData(name, idx) {
        this.#namedDependencies.set(name, idx);
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        this.#simple[name] = this.#namedDependencies.get(depName) ?? fallbackIdx;
    }
    recordFutureForcedDependency(name, idx) {
        this.recordIncrementalData($a2cc6e1d6eb3861b$var$FORCED_DEPENDENCY_LABEL, idx);
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        for (const name of names)if (name in this.#simple) this.recordFutureForcedDependency(name, this.#simple[name]);
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        for (const dep of this.#pendingDependencies)this.recordFutureForcedDependency($a2cc6e1d6eb3861b$var$FORCED_DEPENDENCY_LABEL, dep);
        return this;
    }
    resetBBox(idx) {
        this.#bboxTracker.resetBBox(idx);
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        this.#bboxTracker.recordClipBox(idx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        this.#bboxTracker.recordBBox(idx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale = 1, x = 0, y = 0, getMeasure) {
        const fontBBox = font.bbox;
        let isBBoxTrustworthy;
        let computedBBox;
        if (fontBBox) {
            isBBoxTrustworthy = fontBBox[2] !== fontBBox[0] && fontBBox[3] !== fontBBox[1] && this.#fontBBoxTrustworthy.get(font);
            if (isBBoxTrustworthy !== false) {
                computedBBox = [
                    0,
                    0,
                    0,
                    0
                ];
                $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(fontBBox, font.fontMatrix, computedBBox);
                if (scale !== 1 || x !== 0 || y !== 0) $a2cc6e1d6eb3861b$var$scaleCharBBox(scale, -scale, x, y, computedBBox);
                if (isBBoxTrustworthy) return this.recordBBox(idx, ctx, computedBBox[0], computedBBox[2], computedBBox[1], computedBBox[3]);
            }
        }
        if (!getMeasure) return this.recordFullPageBBox(idx);
        const measure = getMeasure();
        if (fontBBox && computedBBox && isBBoxTrustworthy === undefined) {
            isBBoxTrustworthy = computedBBox[0] <= x - measure.actualBoundingBoxLeft && computedBBox[2] >= x + measure.actualBoundingBoxRight && computedBBox[1] <= y - measure.actualBoundingBoxAscent && computedBBox[3] >= y + measure.actualBoundingBoxDescent;
            this.#fontBBoxTrustworthy.set(font, isBBoxTrustworthy);
            if (isBBoxTrustworthy) return this.recordBBox(idx, ctx, computedBBox[0], computedBBox[2], computedBBox[1], computedBBox[3]);
        }
        return this.recordBBox(idx, ctx, x - measure.actualBoundingBoxLeft, x + measure.actualBoundingBoxRight, y - measure.actualBoundingBoxAscent, y + measure.actualBoundingBoxDescent);
    }
    recordFullPageBBox(idx) {
        this.#bboxTracker.recordFullPageBBox(idx);
        return this;
    }
    getSimpleIndex(dependencyName) {
        return this.#simple[dependencyName];
    }
    recordDependencies(idx, dependencyNames) {
        const pendingDependencies = this.#pendingDependencies;
        const simple = this.#simple;
        const incremental = this.#incremental;
        for (const name of dependencyNames){
            if (name in this.#simple) pendingDependencies.add(simple[name]);
            else if (name in incremental) incremental[name].forEach(pendingDependencies.add, pendingDependencies);
        }
        return this;
    }
    recordNamedDependency(idx, name) {
        if (this.#namedDependencies.has(name)) this.#pendingDependencies.add(this.#namedDependencies.get(name));
        return this;
    }
    recordOperation(idx, preserve = false) {
        this.recordDependencies(idx, [
            $a2cc6e1d6eb3861b$var$FORCED_DEPENDENCY_LABEL
        ]);
        if (this.#debugMetadata) {
            const metadata = $a2cc6e1d6eb3861b$var$ensureDebugMetadata(this.#debugMetadata, idx);
            const { dependencies: dependencies } = metadata;
            this.#pendingDependencies.forEach(dependencies.add, dependencies);
            this.#bboxTracker._savesStack.forEach(dependencies.add, dependencies);
            this.#bboxTracker._markedContentStack.forEach(dependencies.add, dependencies);
            dependencies.delete(idx);
            metadata.isRenderingOperation = true;
        }
        const needsCleanup = !preserve && idx === this.#bboxTracker._pendingBBoxIdx;
        this.#bboxTracker.recordOperation(idx, preserve, [
            this.#pendingDependencies,
            this.#bboxTracker._savesStack,
            this.#bboxTracker._markedContentStack
        ]);
        if (needsCleanup) this.#pendingDependencies.clear();
        return this;
    }
    recordShowTextOperation(idx, preserve = false) {
        const deps = Array.from(this.#pendingDependencies);
        this.recordOperation(idx, preserve);
        this.recordIncrementalData("sameLineText", idx);
        for (const dep of deps)this.recordIncrementalData("sameLineText", dep);
        return this;
    }
    bboxToClipBoxDropOperation(idx, preserve = false) {
        const needsCleanup = !preserve && idx === this.#bboxTracker._pendingBBoxIdx;
        this.#bboxTracker.bboxToClipBoxDropOperation(idx);
        if (needsCleanup) this.#pendingDependencies.clear();
        return this;
    }
    take() {
        this.#fontBBoxTrustworthy.clear();
        return this.#bboxTracker.take();
    }
    takeDebugMetadata() {
        return this.#debugMetadata;
    }
}
class $a2cc6e1d6eb3861b$var$CanvasNestedDependencyTracker {
    #dependencyTracker;
    #opIdx;
    #ignoreBBoxes;
    #nestingLevel = 0;
    #savesLevel = 0;
    constructor(dependencyTracker, opIdx, ignoreBBoxes){
        if (dependencyTracker instanceof $a2cc6e1d6eb3861b$var$CanvasNestedDependencyTracker && dependencyTracker.#ignoreBBoxes === !!ignoreBBoxes) return dependencyTracker;
        this.#dependencyTracker = dependencyTracker;
        this.#opIdx = opIdx;
        this.#ignoreBBoxes = !!ignoreBBoxes;
    }
    get clipBox() {
        return this.#dependencyTracker.clipBox;
    }
    growOperationsCount() {
        throw new Error("Unreachable");
    }
    save(opIdx) {
        this.#savesLevel++;
        this.#dependencyTracker.save(this.#opIdx);
        return this;
    }
    restore(opIdx) {
        if (this.#savesLevel > 0) {
            this.#dependencyTracker.restore(this.#opIdx);
            this.#savesLevel--;
        }
        return this;
    }
    recordOpenMarker(idx) {
        this.#nestingLevel++;
        return this;
    }
    getOpenMarker() {
        return this.#nestingLevel > 0 ? this.#opIdx : this.#dependencyTracker.getOpenMarker();
    }
    recordCloseMarker(idx) {
        this.#nestingLevel--;
        return this;
    }
    beginMarkedContent(opIdx) {
        return this;
    }
    endMarkedContent(opIdx) {
        return this;
    }
    pushBaseTransform(ctx) {
        this.#dependencyTracker.pushBaseTransform(ctx);
        return this;
    }
    popBaseTransform() {
        this.#dependencyTracker.popBaseTransform();
        return this;
    }
    recordSimpleData(name, idx) {
        this.#dependencyTracker.recordSimpleData(name, this.#opIdx);
        return this;
    }
    recordIncrementalData(name, idx) {
        this.#dependencyTracker.recordIncrementalData(name, this.#opIdx);
        return this;
    }
    resetIncrementalData(name, idx) {
        this.#dependencyTracker.resetIncrementalData(name, this.#opIdx);
        return this;
    }
    recordNamedData(name, idx) {
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        this.#dependencyTracker.recordSimpleDataFromNamed(name, depName, this.#opIdx);
        return this;
    }
    recordFutureForcedDependency(name, idx) {
        this.#dependencyTracker.recordFutureForcedDependency(name, this.#opIdx);
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        this.#dependencyTracker.inheritSimpleDataAsFutureForcedDependencies(names);
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        this.#dependencyTracker.inheritPendingDependenciesAsFutureForcedDependencies();
        return this;
    }
    resetBBox(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.resetBBox(this.#opIdx);
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordClipBox(this.#opIdx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordBBox(this.#opIdx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale, x, y, getMeasure) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordCharacterBBox(this.#opIdx, ctx, font, scale, x, y, getMeasure);
        return this;
    }
    recordFullPageBBox(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordFullPageBBox(this.#opIdx);
        return this;
    }
    getSimpleIndex(dependencyName) {
        return this.#dependencyTracker.getSimpleIndex(dependencyName);
    }
    recordDependencies(idx, dependencyNames) {
        this.#dependencyTracker.recordDependencies(this.#opIdx, dependencyNames);
        return this;
    }
    recordNamedDependency(idx, name) {
        this.#dependencyTracker.recordNamedDependency(this.#opIdx, name);
        return this;
    }
    recordOperation(idx) {
        this.#dependencyTracker.recordOperation(this.#opIdx, true);
        return this;
    }
    recordShowTextOperation(idx) {
        this.#dependencyTracker.recordShowTextOperation(this.#opIdx, true);
        return this;
    }
    bboxToClipBoxDropOperation(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.bboxToClipBoxDropOperation(this.#opIdx, true);
        return this;
    }
    take() {
        throw new Error("Unreachable");
    }
    takeDebugMetadata() {
        throw new Error("Unreachable");
    }
}
const $a2cc6e1d6eb3861b$var$Dependencies = {
    stroke: [
        "path",
        "transform",
        "filter",
        "strokeColor",
        "strokeAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "dash"
    ],
    fill: [
        "path",
        "transform",
        "filter",
        "fillColor",
        "fillAlpha",
        "globalCompositeOperation",
        "SMask"
    ],
    imageXObject: [
        "transform",
        "SMask",
        "filter",
        "fillAlpha",
        "strokeAlpha",
        "globalCompositeOperation"
    ],
    rawFillPath: [
        "filter",
        "fillColor",
        "fillAlpha"
    ],
    showText: [
        "transform",
        "leading",
        "charSpacing",
        "wordSpacing",
        "hScale",
        "textRise",
        "moveText",
        "textMatrix",
        "font",
        "fontObj",
        "filter",
        "fillColor",
        "textRenderingMode",
        "SMask",
        "fillAlpha",
        "strokeAlpha",
        "globalCompositeOperation",
        "sameLineText"
    ],
    transform: [
        "transform"
    ],
    transformAndFill: [
        "transform",
        "fillColor"
    ]
};
class $a2cc6e1d6eb3861b$var$CanvasImagesTracker {
    #canvasWidth;
    #canvasHeight;
    #capacity = 4;
    #count = 0;
    #coords = new $a2cc6e1d6eb3861b$var$CanvasImagesTracker.#CoordsArray(this.#capacity * 6);
    static #CoordsArray = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.isFloat16ArraySupported ? Float16Array : Float32Array;
    constructor(canvas){
        this.#canvasWidth = canvas.width;
        this.#canvasHeight = canvas.height;
    }
    record(ctx, width, height, clipBox) {
        if (this.#count === this.#capacity) {
            this.#capacity *= 2;
            const newCoords = new $a2cc6e1d6eb3861b$var$CanvasImagesTracker.#CoordsArray(this.#capacity * 6);
            newCoords.set(this.#coords);
            this.#coords = newCoords;
        }
        const transform = $a2cc6e1d6eb3861b$var$getCurrentTransform(ctx);
        let coords;
        if (clipBox[0] !== Infinity) {
            const bbox = $a2cc6e1d6eb3861b$var$BBOX_INIT.slice();
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                -height,
                width,
                0
            ], transform, bbox);
            const finalBBox = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.intersect(clipBox, bbox);
            if (!finalBBox) return;
            const [minX, minY, maxX, maxY] = finalBBox;
            if (minX !== bbox[0] || minY !== bbox[1] || maxX !== bbox[2] || maxY !== bbox[3]) {
                const rotationAngle = Math.atan2(transform[1], transform[0]);
                const sin = Math.abs(Math.sin(rotationAngle));
                const cos = Math.abs(Math.cos(rotationAngle));
                if (sin < 1e-6 || cos < 1e-6 || Math.abs(sin - cos) < 1e-6) coords = [
                    minX,
                    minY,
                    minX,
                    maxY,
                    maxX,
                    minY
                ];
                else {
                    const finalBBoxWidth = maxX - minX;
                    const finalBBoxHeight = maxY - minY;
                    const sin2 = sin * sin;
                    const cos2 = cos * cos;
                    const cosSin = cos * sin;
                    const denom = cos2 - sin2;
                    const a = (finalBBoxHeight * cos2 - finalBBoxWidth * cosSin) / denom;
                    const b = (finalBBoxHeight * cosSin - finalBBoxWidth * sin2) / denom;
                    coords = [
                        minX + b,
                        minY,
                        minX,
                        minY + a,
                        maxX,
                        maxY - a
                    ];
                }
            }
        }
        if (!coords) {
            coords = [
                0,
                -height,
                0,
                0,
                width,
                -height
            ];
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(coords, transform, 0);
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(coords, transform, 2);
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(coords, transform, 4);
        }
        coords[0] /= this.#canvasWidth;
        coords[1] /= this.#canvasHeight;
        coords[2] /= this.#canvasWidth;
        coords[3] /= this.#canvasHeight;
        coords[4] /= this.#canvasWidth;
        coords[5] /= this.#canvasHeight;
        this.#coords.set(coords, this.#count * 6);
        this.#count++;
    }
    take() {
        return this.#coords.subarray(0, this.#count * 6);
    }
}
class $a2cc6e1d6eb3861b$var$FontLoader {
    #systemFonts = new Set();
    constructor({ ownerDocument: ownerDocument = globalThis.document, styleElement: styleElement = null }){
        this._document = ownerDocument;
        this.nativeFontFaces = new Set();
        this.styleElement = null;
        this.loadingRequests = [];
        this.loadTestFontId = 0;
    }
    addNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.add(nativeFontFace);
        this._document.fonts.add(nativeFontFace);
    }
    removeNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.delete(nativeFontFace);
        this._document.fonts.delete(nativeFontFace);
    }
    insertRule(rule) {
        if (!this.styleElement) {
            this.styleElement = this._document.createElement("style");
            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
        }
        const styleSheet = this.styleElement.sheet;
        styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
    clear() {
        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
        this.nativeFontFaces.clear();
        this.#systemFonts.clear();
        if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
        }
    }
    async loadSystemFont({ systemFontInfo: info, disableFontFace: disableFontFace, _inspectFont: _inspectFont }) {
        if (!info || this.#systemFonts.has(info.loadedName)) return;
        $a2cc6e1d6eb3861b$var$assert(!disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
        if (this.isFontLoadingAPISupported) {
            const { loadedName: loadedName, src: src, style: style } = info;
            const fontFace = new FontFace(loadedName, src, style);
            this.addNativeFontFace(fontFace);
            try {
                await fontFace.load();
                this.#systemFonts.add(loadedName);
                _inspectFont?.(info);
            } catch  {
                $a2cc6e1d6eb3861b$var$warn(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                this.removeNativeFontFace(fontFace);
            }
            return;
        }
        $a2cc6e1d6eb3861b$var$unreachable("Not implemented: loadSystemFont without the Font Loading API.");
    }
    async bind(font) {
        if (font.attached || font.missingFile && !font.systemFontInfo) return;
        font.attached = true;
        if (font.systemFontInfo) {
            await this.loadSystemFont(font);
            return;
        }
        if (this.isFontLoadingAPISupported) {
            const nativeFontFace = font.createNativeFontFace();
            if (nativeFontFace) {
                this.addNativeFontFace(nativeFontFace);
                try {
                    await nativeFontFace.loaded;
                } catch (ex) {
                    $a2cc6e1d6eb3861b$var$warn(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                    font.disableFontFace = true;
                    throw ex;
                }
            }
            return;
        }
        const rule = font.createFontFaceRule();
        if (rule) {
            this.insertRule(rule);
            if (this.isSyncFontLoadingSupported) return;
            await new Promise((resolve)=>{
                const request = this._queueLoadingCallback(resolve);
                this._prepareFontLoadEvent(font, request);
            });
        }
    }
    get isFontLoadingAPISupported() {
        const hasFonts = !!this._document?.fonts;
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isFontLoadingAPISupported", hasFonts);
    }
    get isSyncFontLoadingSupported() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isSyncFontLoadingSupported", $a2cc6e1d6eb3861b$var$isNodeJS || $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform.isFirefox);
    }
    _queueLoadingCallback(callback) {
        function completeRequest() {
            $a2cc6e1d6eb3861b$var$assert(!request.done, "completeRequest() cannot be called twice.");
            request.done = true;
            while(loadingRequests.length > 0 && loadingRequests[0].done){
                const otherRequest = loadingRequests.shift();
                setTimeout(otherRequest.callback, 0);
            }
        }
        const { loadingRequests: loadingRequests } = this;
        const request = {
            done: false,
            complete: completeRequest,
            callback: callback
        };
        loadingRequests.push(request);
        return request;
    }
    get _loadTestFont() {
        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_loadTestFont", testFont);
    }
    _prepareFontLoadEvent(font, request) {
        function int32(data, offset) {
            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
        }
        function string32(value) {
            return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
        }
        function spliceString(s, offset, remove, insert) {
            const chunk1 = s.substring(0, offset);
            const chunk2 = s.substring(offset + remove);
            return chunk1 + insert + chunk2;
        }
        let i, ii;
        const canvas = this._document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        const ctx = canvas.getContext("2d");
        let called = 0;
        function isFontReady(name, callback) {
            if (++called > 30) {
                $a2cc6e1d6eb3861b$var$warn("Load test font never loaded.");
                callback();
                return;
            }
            ctx.font = "30px " + name;
            ctx.fillText(".", 0, 20);
            const imageData = ctx.getImageData(0, 0, 1, 1);
            if (imageData.data[3] > 0) {
                callback();
                return;
            }
            setTimeout(isFontReady.bind(null, name, callback));
        }
        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
        let data = this._loadTestFont;
        const COMMENT_OFFSET = 976;
        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
        const CFF_CHECKSUM_OFFSET = 16;
        const XXXX_VALUE = 0x58585858;
        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, string32(checksum));
        const url = `url(data:font/opentype;base64,${btoa(data)});`;
        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
        this.insertRule(rule);
        const div = this._document.createElement("div");
        div.style.visibility = "hidden";
        div.style.width = div.style.height = "10px";
        div.style.position = "absolute";
        div.style.top = div.style.left = "0px";
        for (const name of [
            font.loadedName,
            loadTestFontId
        ]){
            const span = this._document.createElement("span");
            span.textContent = "Hi";
            span.style.fontFamily = name;
            div.append(span);
        }
        this._document.body.append(div);
        isFontReady(loadTestFontId, ()=>{
            div.remove();
            request.complete();
        });
    }
}
class $a2cc6e1d6eb3861b$var$FontFaceObject {
    compiledGlyphs = Object.create(null);
    #fontData;
    constructor(translatedData, inspectFont = null, charProcOperatorList, extra){
        this.#fontData = translatedData;
        this._inspectFont = inspectFont;
        if (charProcOperatorList) this.charProcOperatorList = charProcOperatorList;
        if (extra) Object.assign(this, extra);
    }
    createNativeFontFace() {
        if (!this.data || this.disableFontFace) return null;
        let nativeFontFace;
        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
        else {
            const css = {
                weight: this.cssFontInfo.fontWeight
            };
            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
        }
        this._inspectFont?.(this);
        return nativeFontFace;
    }
    createFontFaceRule() {
        if (!this.data || this.disableFontFace) return null;
        const url = `url(data:${this.mimetype};base64,${this.data.toBase64()});`;
        let rule;
        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
        else {
            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
        }
        this._inspectFont?.(this, url);
        return rule;
    }
    getPathGenerator(objs, character) {
        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
        const objId = this.loadedName + "_path_" + character;
        let cmds;
        try {
            cmds = objs.get(objId);
        } catch (ex) {
            $a2cc6e1d6eb3861b$var$warn(`getPathGenerator - ignoring character: "${ex}".`);
        }
        const path = $a2cc6e1d6eb3861b$var$makePathFromDrawOPS(cmds?.path);
        if (!this.fontExtraProperties) objs.delete(objId);
        return this.compiledGlyphs[character] = path;
    }
    get black() {
        return this.#fontData.black;
    }
    get bold() {
        return this.#fontData.bold;
    }
    get disableFontFace() {
        return this.#fontData.disableFontFace;
    }
    set disableFontFace(value) {
        $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "disableFontFace", !!value);
    }
    get fontExtraProperties() {
        return this.#fontData.fontExtraProperties;
    }
    get isInvalidPDFjsFont() {
        return this.#fontData.isInvalidPDFjsFont;
    }
    get isType3Font() {
        return this.#fontData.isType3Font;
    }
    get italic() {
        return this.#fontData.italic;
    }
    get missingFile() {
        return this.#fontData.missingFile;
    }
    get remeasure() {
        return this.#fontData.remeasure;
    }
    get vertical() {
        return this.#fontData.vertical;
    }
    get ascent() {
        return this.#fontData.ascent;
    }
    get defaultWidth() {
        return this.#fontData.defaultWidth;
    }
    get descent() {
        return this.#fontData.descent;
    }
    get bbox() {
        return this.#fontData.bbox;
    }
    get fontMatrix() {
        return this.#fontData.fontMatrix;
    }
    get fallbackName() {
        return this.#fontData.fallbackName;
    }
    get loadedName() {
        return this.#fontData.loadedName;
    }
    get mimetype() {
        return this.#fontData.mimetype;
    }
    get name() {
        return this.#fontData.name;
    }
    get data() {
        return this.#fontData.data;
    }
    clearData() {
        this.#fontData.clearData();
    }
    get cssFontInfo() {
        return this.#fontData.cssFontInfo;
    }
    get systemFontInfo() {
        return this.#fontData.systemFontInfo;
    }
    get defaultVMetrics() {
        return this.#fontData.defaultVMetrics;
    }
}
class $a2cc6e1d6eb3861b$var$CSS_FONT_INFO {
    static strings = [
        "fontFamily",
        "fontWeight",
        "italicAngle"
    ];
}
class $a2cc6e1d6eb3861b$var$SYSTEM_FONT_INFO {
    static strings = [
        "css",
        "loadedName",
        "baseFontName",
        "src"
    ];
}
class $a2cc6e1d6eb3861b$var$FONT_INFO {
    static bools = [
        "black",
        "bold",
        "disableFontFace",
        "fontExtraProperties",
        "isInvalidPDFjsFont",
        "isType3Font",
        "italic",
        "missingFile",
        "remeasure",
        "vertical"
    ];
    static numbers = [
        "ascent",
        "defaultWidth",
        "descent"
    ];
    static strings = [
        "fallbackName",
        "loadedName",
        "mimetype",
        "name"
    ];
    static OFFSET_NUMBERS = Math.ceil(this.bools.length * 2 / 8);
    static OFFSET_BBOX = this.OFFSET_NUMBERS + this.numbers.length * 8;
    static OFFSET_FONT_MATRIX = this.OFFSET_BBOX + 1 + 8;
    static OFFSET_DEFAULT_VMETRICS = this.OFFSET_FONT_MATRIX + 1 + 48;
    static OFFSET_STRINGS = this.OFFSET_DEFAULT_VMETRICS + 1 + 6;
}
class $a2cc6e1d6eb3861b$var$PATTERN_INFO {
    static KIND = 0;
    static HAS_BBOX = 1;
    static HAS_BACKGROUND = 2;
    static SHADING_TYPE = 3;
    static N_COORD = 4;
    static N_COLOR = 8;
    static N_STOP = 12;
    static N_FIGURES = 16;
}
class $a2cc6e1d6eb3861b$var$CssFontInfo {
    #buffer;
    #decoder = new TextDecoder();
    #view;
    constructor(buffer){
        this.#buffer = buffer;
        this.#view = new DataView(buffer);
    }
    #readString(index) {
        $a2cc6e1d6eb3861b$var$assert(index < $a2cc6e1d6eb3861b$var$CSS_FONT_INFO.strings.length, "Invalid string index");
        let offset = 0;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get fontFamily() {
        return this.#readString(0);
    }
    get fontWeight() {
        return this.#readString(1);
    }
    get italicAngle() {
        return this.#readString(2);
    }
}
class $a2cc6e1d6eb3861b$var$SystemFontInfo {
    #buffer;
    #decoder = new TextDecoder();
    #view;
    constructor(buffer){
        this.#buffer = buffer;
        this.#view = new DataView(buffer);
    }
    get guessFallback() {
        return this.#view.getUint8(0) !== 0;
    }
    #readString(index) {
        $a2cc6e1d6eb3861b$var$assert(index < $a2cc6e1d6eb3861b$var$SYSTEM_FONT_INFO.strings.length, "Invalid string index");
        let offset = 5;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get css() {
        return this.#readString(0);
    }
    get loadedName() {
        return this.#readString(1);
    }
    get baseFontName() {
        return this.#readString(2);
    }
    get src() {
        return this.#readString(3);
    }
    get style() {
        let offset = 1;
        offset += 4 + this.#view.getUint32(offset);
        const styleLength = this.#view.getUint32(offset);
        const style = this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, styleLength));
        offset += 4 + styleLength;
        const weightLength = this.#view.getUint32(offset);
        const weight = this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, weightLength));
        return {
            style: style,
            weight: weight
        };
    }
}
class $a2cc6e1d6eb3861b$var$FontInfo {
    #buffer;
    #decoder = new TextDecoder();
    #view;
    constructor({ buffer: buffer, extra: extra }){
        this.#buffer = buffer;
        this.#view = new DataView(buffer);
        if (extra) Object.assign(this, extra);
    }
    #readBoolean(index) {
        $a2cc6e1d6eb3861b$var$assert(index < $a2cc6e1d6eb3861b$var$FONT_INFO.bools.length, "Invalid boolean index");
        const byteOffset = Math.floor(index / 4);
        const bitOffset = index * 2 % 8;
        const value = this.#view.getUint8(byteOffset) >> bitOffset & 0x03;
        return value === 0x00 ? undefined : value === 0x02;
    }
    get black() {
        return this.#readBoolean(0);
    }
    get bold() {
        return this.#readBoolean(1);
    }
    get disableFontFace() {
        return this.#readBoolean(2);
    }
    get fontExtraProperties() {
        return this.#readBoolean(3);
    }
    get isInvalidPDFjsFont() {
        return this.#readBoolean(4);
    }
    get isType3Font() {
        return this.#readBoolean(5);
    }
    get italic() {
        return this.#readBoolean(6);
    }
    get missingFile() {
        return this.#readBoolean(7);
    }
    get remeasure() {
        return this.#readBoolean(8);
    }
    get vertical() {
        return this.#readBoolean(9);
    }
    #readNumber(index) {
        $a2cc6e1d6eb3861b$var$assert(index < $a2cc6e1d6eb3861b$var$FONT_INFO.numbers.length, "Invalid number index");
        return this.#view.getFloat64($a2cc6e1d6eb3861b$var$FONT_INFO.OFFSET_NUMBERS + index * 8);
    }
    get ascent() {
        return this.#readNumber(0);
    }
    get defaultWidth() {
        return this.#readNumber(1);
    }
    get descent() {
        return this.#readNumber(2);
    }
    #readArray(offset, arrLen, lookupName, increment) {
        const len = this.#view.getUint8(offset);
        if (len === 0) return undefined;
        $a2cc6e1d6eb3861b$var$assert(len === arrLen, "Invalid array length.");
        offset += 1;
        const arr = new Array(len);
        for(let i = 0; i < len; i++){
            arr[i] = this.#view[lookupName](offset, true);
            offset += increment;
        }
        return arr;
    }
    get bbox() {
        return this.#readArray($a2cc6e1d6eb3861b$var$FONT_INFO.OFFSET_BBOX, 4, "getInt16", 2);
    }
    get fontMatrix() {
        return this.#readArray($a2cc6e1d6eb3861b$var$FONT_INFO.OFFSET_FONT_MATRIX, 6, "getFloat64", 8);
    }
    get defaultVMetrics() {
        return this.#readArray($a2cc6e1d6eb3861b$var$FONT_INFO.OFFSET_DEFAULT_VMETRICS, 3, "getInt16", 2);
    }
    #readString(index) {
        $a2cc6e1d6eb3861b$var$assert(index < $a2cc6e1d6eb3861b$var$FONT_INFO.strings.length, "Invalid string index");
        let offset = $a2cc6e1d6eb3861b$var$FONT_INFO.OFFSET_STRINGS + 4;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get fallbackName() {
        return this.#readString(0);
    }
    get loadedName() {
        return this.#readString(1);
    }
    get mimetype() {
        return this.#readString(2);
    }
    get name() {
        return this.#readString(3);
    }
    #getDataOffsets() {
        let offset = $a2cc6e1d6eb3861b$var$FONT_INFO.OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + cssFontInfoLength;
        const length = this.#view.getUint32(offset);
        return {
            offset: offset,
            length: length
        };
    }
    get data() {
        const { offset: offset, length: length } = this.#getDataOffsets();
        return length === 0 ? undefined : new Uint8Array(this.#buffer, offset + 4, length);
    }
    clearData() {
        const { offset: offset, length: length } = this.#getDataOffsets();
        if (length === 0) return;
        this.#view.setUint32(offset, 0);
        this.#buffer = new Uint8Array(this.#buffer, 0, offset + 4).slice().buffer;
        this.#view = new DataView(this.#buffer);
    }
    get cssFontInfo() {
        let offset = $a2cc6e1d6eb3861b$var$FONT_INFO.OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        if (cssFontInfoLength === 0) return null;
        const cssFontInfoData = new Uint8Array(cssFontInfoLength);
        cssFontInfoData.set(new Uint8Array(this.#buffer, offset + 4, cssFontInfoLength));
        return new $a2cc6e1d6eb3861b$var$CssFontInfo(cssFontInfoData.buffer);
    }
    get systemFontInfo() {
        let offset = $a2cc6e1d6eb3861b$var$FONT_INFO.OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        if (systemFontInfoLength === 0) return null;
        const systemFontInfoData = new Uint8Array(systemFontInfoLength);
        systemFontInfoData.set(new Uint8Array(this.#buffer, offset + 4, systemFontInfoLength));
        return new $a2cc6e1d6eb3861b$var$SystemFontInfo(systemFontInfoData.buffer);
    }
}
class $a2cc6e1d6eb3861b$var$PatternInfo {
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(buffer);
        this.data = new Uint8Array(buffer);
    }
    getIR() {
        const dataView = this.view;
        const kind = this.data[$a2cc6e1d6eb3861b$var$PATTERN_INFO.KIND];
        const hasBBox = !!this.data[$a2cc6e1d6eb3861b$var$PATTERN_INFO.HAS_BBOX];
        const hasBackground = !!this.data[$a2cc6e1d6eb3861b$var$PATTERN_INFO.HAS_BACKGROUND];
        const nCoord = dataView.getUint32($a2cc6e1d6eb3861b$var$PATTERN_INFO.N_COORD, true);
        const nColor = dataView.getUint32($a2cc6e1d6eb3861b$var$PATTERN_INFO.N_COLOR, true);
        const nStop = dataView.getUint32($a2cc6e1d6eb3861b$var$PATTERN_INFO.N_STOP, true);
        let offset = 20;
        const coords = new Float32Array(this.buffer, offset, nCoord * 2);
        offset += nCoord * 8;
        const colors = new Uint8Array(this.buffer, offset, nColor * 4);
        offset += nColor * 4;
        const stops = [];
        for(let i = 0; i < nStop; ++i){
            const p = dataView.getFloat32(offset, true);
            offset += 4;
            const rgb = dataView.getUint32(offset, true);
            offset += 4;
            stops.push([
                p,
                `#${rgb.toString(16).padStart(6, "0")}`
            ]);
        }
        let bbox = null;
        if (hasBBox) {
            bbox = [];
            for(let i = 0; i < 4; ++i){
                bbox.push(dataView.getFloat32(offset, true));
                offset += 4;
            }
        }
        let background = null;
        if (hasBackground) {
            background = new Uint8Array(this.buffer, offset, 3);
            offset += 3;
        }
        if (kind === 1) return [
            "RadialAxial",
            "axial",
            bbox,
            stops,
            Array.from(coords.slice(0, 2)),
            Array.from(coords.slice(2, 4)),
            null,
            null
        ];
        if (kind === 2) return [
            "RadialAxial",
            "radial",
            bbox,
            stops,
            [
                coords[0],
                coords[1]
            ],
            [
                coords[3],
                coords[4]
            ],
            coords[2],
            coords[5]
        ];
        if (kind === 3) {
            const shadingType = this.data[$a2cc6e1d6eb3861b$var$PATTERN_INFO.SHADING_TYPE];
            let bounds = null;
            if (coords.length > 0) {
                bounds = $a2cc6e1d6eb3861b$var$BBOX_INIT.slice();
                for(let i = 0, ii = coords.length; i < ii; i += 2)$a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.pointBoundingBox(coords[i], coords[i + 1], bounds);
            }
            return [
                "Mesh",
                shadingType,
                coords,
                colors,
                nCoord,
                bounds,
                bbox,
                background
            ];
        }
        throw new Error(`Unsupported pattern kind: ${kind}`);
    }
}
class $a2cc6e1d6eb3861b$var$FontPathInfo {
    #buffer;
    constructor(buffer){
        this.#buffer = buffer;
    }
    get path() {
        if ($a2cc6e1d6eb3861b$export$5fb8891d35c36978.isFloat16ArraySupported) return new Float16Array(this.#buffer);
        return new Float32Array(this.#buffer);
    }
}
function $a2cc6e1d6eb3861b$var$getUrlProp(val) {
    if (val instanceof URL) return val;
    if (typeof val === "string") {
        if ($a2cc6e1d6eb3861b$var$isNodeJS) {
            if (/^[a-z][a-z0-9\-+.]+:/i.test(val)) return new URL(val);
            const url = $jBmpJ.getBuiltinModule("url");
            return new URL(url.pathToFileURL(val));
        }
        const url = URL.parse(val, window.location);
        if (url) return url;
    }
    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
}
function $a2cc6e1d6eb3861b$var$getDataProp(val) {
    if ($a2cc6e1d6eb3861b$var$isNodeJS && typeof $a2cc6e1d6eb3861b$require$Buffer !== "undefined" && val instanceof $a2cc6e1d6eb3861b$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
    if (typeof val === "string") return $a2cc6e1d6eb3861b$var$stringToBytes(val);
    if (val instanceof ArrayBuffer || ArrayBuffer.isView(val) || typeof val === "object" && !isNaN(val?.length)) return new Uint8Array(val);
    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
}
function $a2cc6e1d6eb3861b$var$getFactoryUrlProp(val) {
    if (typeof val !== "string") return null;
    if (val.endsWith("/")) return val;
    throw new Error(`Invalid factory url: "${val}" must include trailing slash.`);
}
const $a2cc6e1d6eb3861b$var$isRefProxy = (v)=>typeof v === "object" && Number.isInteger(v?.num) && v.num >= 0 && Number.isInteger(v?.gen) && v.gen >= 0;
const $a2cc6e1d6eb3861b$var$isNameProxy = (v)=>typeof v === "object" && typeof v?.name === "string";
const $a2cc6e1d6eb3861b$export$b5acece0a447dcdc = $a2cc6e1d6eb3861b$var$_isValidExplicitDest.bind(null, $a2cc6e1d6eb3861b$var$isRefProxy, $a2cc6e1d6eb3861b$var$isNameProxy);
class $a2cc6e1d6eb3861b$var$LoopbackPort {
    #listeners = new Map();
    #deferred = Promise.resolve();
    postMessage(obj, transfer) {
        const event = {
            data: structuredClone(obj, transfer ? {
                transfer: transfer
            } : null)
        };
        this.#deferred.then(()=>{
            for (const [listener] of this.#listeners)listener.call(this, event);
        });
    }
    addEventListener(name, listener, options = null) {
        let rmAbort = null;
        if (options?.signal instanceof AbortSignal) {
            const { signal: signal } = options;
            if (signal.aborted) {
                $a2cc6e1d6eb3861b$var$warn("LoopbackPort - cannot use an `aborted` signal.");
                return;
            }
            const onAbort = ()=>this.removeEventListener(name, listener);
            rmAbort = ()=>signal.removeEventListener("abort", onAbort);
            signal.addEventListener("abort", onAbort);
        }
        this.#listeners.set(listener, rmAbort);
    }
    removeEventListener(name, listener) {
        const rmAbort = this.#listeners.get(listener);
        rmAbort?.();
        this.#listeners.delete(listener);
    }
    terminate() {
        for (const [, rmAbort] of this.#listeners)rmAbort?.();
        this.#listeners.clear();
    }
}
const $a2cc6e1d6eb3861b$var$CallbackKind = {
    DATA: 1,
    ERROR: 2
};
const $a2cc6e1d6eb3861b$var$StreamKind = {
    CANCEL: 1,
    CANCEL_COMPLETE: 2,
    CLOSE: 3,
    ENQUEUE: 4,
    ERROR: 5,
    PULL: 6,
    PULL_COMPLETE: 7,
    START_COMPLETE: 8
};
function $a2cc6e1d6eb3861b$var$onFn() {}
function $a2cc6e1d6eb3861b$var$wrapReason(ex) {
    if (ex instanceof $a2cc6e1d6eb3861b$export$d0e978393d193d1a || ex instanceof $a2cc6e1d6eb3861b$export$e3d0f4ce5b91e9f1 || ex instanceof $a2cc6e1d6eb3861b$var$PasswordException || ex instanceof $a2cc6e1d6eb3861b$export$ea8e9c34f66e603 || ex instanceof $a2cc6e1d6eb3861b$var$UnknownErrorException) return ex;
    if (!(ex instanceof Error || typeof ex === "object" && ex !== null)) $a2cc6e1d6eb3861b$var$unreachable('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
    switch(ex.name){
        case "AbortException":
            return new $a2cc6e1d6eb3861b$export$d0e978393d193d1a(ex.message);
        case "InvalidPDFException":
            return new $a2cc6e1d6eb3861b$export$e3d0f4ce5b91e9f1(ex.message);
        case "PasswordException":
            return new $a2cc6e1d6eb3861b$var$PasswordException(ex.message, ex.code);
        case "ResponseException":
            return new $a2cc6e1d6eb3861b$export$ea8e9c34f66e603(ex.message, ex.status, ex.missing);
        case "UnknownErrorException":
            return new $a2cc6e1d6eb3861b$var$UnknownErrorException(ex.message, ex.details);
    }
    return new $a2cc6e1d6eb3861b$var$UnknownErrorException(ex.message, ex.toString());
}
class $a2cc6e1d6eb3861b$var$MessageHandler {
    #messageAC = new AbortController();
    constructor(sourceName, targetName, comObj){
        this.sourceName = sourceName;
        this.targetName = targetName;
        this.comObj = comObj;
        this.callbackId = 1;
        this.streamId = 1;
        this.streamSinks = Object.create(null);
        this.streamControllers = Object.create(null);
        this.callbackCapabilities = Object.create(null);
        this.actionHandler = Object.create(null);
        comObj.addEventListener("message", this.#onMessage.bind(this), {
            signal: this.#messageAC.signal
        });
    }
    #onMessage({ data: data }) {
        if (data.targetName !== this.sourceName) return;
        if (data.stream) {
            this.#processStreamMessage(data);
            return;
        }
        if (data.callback) {
            const callbackId = data.callbackId;
            const capability = this.callbackCapabilities[callbackId];
            if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
            delete this.callbackCapabilities[callbackId];
            if (data.callback === $a2cc6e1d6eb3861b$var$CallbackKind.DATA) capability.resolve(data.data);
            else if (data.callback === $a2cc6e1d6eb3861b$var$CallbackKind.ERROR) capability.reject($a2cc6e1d6eb3861b$var$wrapReason(data.reason));
            else throw new Error("Unexpected callback case");
            return;
        }
        const action = this.actionHandler[data.action];
        if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
        if (data.callbackId) {
            const sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
            Promise.try(action, data.data).then(function(result) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    callback: $a2cc6e1d6eb3861b$var$CallbackKind.DATA,
                    callbackId: data.callbackId,
                    data: result
                });
            }, function(reason) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    callback: $a2cc6e1d6eb3861b$var$CallbackKind.ERROR,
                    callbackId: data.callbackId,
                    reason: $a2cc6e1d6eb3861b$var$wrapReason(reason)
                });
            });
            return;
        }
        if (data.streamId) {
            this.#createStreamSink(data);
            return;
        }
        action(data.data);
    }
    on(actionName, handler) {
        const ah = this.actionHandler;
        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
        ah[actionName] = handler;
    }
    send(actionName, data, transfers) {
        this.comObj.postMessage({
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data
        }, transfers);
    }
    sendWithPromise(actionName, data, transfers) {
        const callbackId = this.callbackId++;
        const capability = Promise.withResolvers();
        this.callbackCapabilities[callbackId] = capability;
        try {
            this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: actionName,
                callbackId: callbackId,
                data: data
            }, transfers);
        } catch (ex) {
            capability.reject(ex);
        }
        return capability.promise;
    }
    sendWithStream(actionName, data, queueingStrategy, transfers) {
        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
        return new ReadableStream({
            start: (controller)=>{
                const startCapability = Promise.withResolvers();
                this.streamControllers[streamId] = {
                    controller: controller,
                    startCall: startCapability,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: false
                };
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    action: actionName,
                    streamId: streamId,
                    data: data,
                    desiredSize: controller.desiredSize
                }, transfers);
                return startCapability.promise;
            },
            pull: (controller)=>{
                const pullCapability = Promise.withResolvers();
                this.streamControllers[streamId].pullCall = pullCapability;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $a2cc6e1d6eb3861b$var$StreamKind.PULL,
                    streamId: streamId,
                    desiredSize: controller.desiredSize
                });
                return pullCapability.promise;
            },
            cancel: (reason)=>{
                $a2cc6e1d6eb3861b$var$assert(reason instanceof Error, "cancel must have a valid reason");
                const cancelCapability = Promise.withResolvers();
                this.streamControllers[streamId].cancelCall = cancelCapability;
                this.streamControllers[streamId].isClosed = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $a2cc6e1d6eb3861b$var$StreamKind.CANCEL,
                    streamId: streamId,
                    reason: $a2cc6e1d6eb3861b$var$wrapReason(reason)
                });
                return cancelCapability.promise;
            }
        }, queueingStrategy);
    }
    #createStreamSink(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const self = this, action = this.actionHandler[data.action];
        const streamSink = {
            enqueue (chunk, size = 1, transfers) {
                if (this.isCancelled) return;
                const lastDesiredSize = this.desiredSize;
                this.desiredSize -= size;
                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                    this.sinkCapability = Promise.withResolvers();
                    this.ready = this.sinkCapability.promise;
                }
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $a2cc6e1d6eb3861b$var$StreamKind.ENQUEUE,
                    streamId: streamId,
                    chunk: chunk
                }, transfers);
            },
            close () {
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $a2cc6e1d6eb3861b$var$StreamKind.CLOSE,
                    streamId: streamId
                });
                delete self.streamSinks[streamId];
            },
            error (reason) {
                $a2cc6e1d6eb3861b$var$assert(reason instanceof Error, "error must have a valid reason");
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $a2cc6e1d6eb3861b$var$StreamKind.ERROR,
                    streamId: streamId,
                    reason: $a2cc6e1d6eb3861b$var$wrapReason(reason)
                });
            },
            sinkCapability: Promise.withResolvers(),
            onPull: null,
            onCancel: null,
            isCancelled: false,
            desiredSize: data.desiredSize,
            ready: null
        };
        streamSink.sinkCapability.resolve();
        streamSink.ready = streamSink.sinkCapability.promise;
        this.streamSinks[streamId] = streamSink;
        Promise.try(action, data.data, streamSink).then(function() {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $a2cc6e1d6eb3861b$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                success: true
            });
        }, function(reason) {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $a2cc6e1d6eb3861b$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                reason: $a2cc6e1d6eb3861b$var$wrapReason(reason)
            });
        });
    }
    #processStreamMessage(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
        switch(data.stream){
            case $a2cc6e1d6eb3861b$var$StreamKind.START_COMPLETE:
                if (data.success) streamController.startCall.resolve();
                else streamController.startCall.reject($a2cc6e1d6eb3861b$var$wrapReason(data.reason));
                break;
            case $a2cc6e1d6eb3861b$var$StreamKind.PULL_COMPLETE:
                if (data.success) streamController.pullCall.resolve();
                else streamController.pullCall.reject($a2cc6e1d6eb3861b$var$wrapReason(data.reason));
                break;
            case $a2cc6e1d6eb3861b$var$StreamKind.PULL:
                if (!streamSink) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $a2cc6e1d6eb3861b$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                    break;
                }
                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                streamSink.desiredSize = data.desiredSize;
                Promise.try(streamSink.onPull || $a2cc6e1d6eb3861b$var$onFn).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $a2cc6e1d6eb3861b$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $a2cc6e1d6eb3861b$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        reason: $a2cc6e1d6eb3861b$var$wrapReason(reason)
                    });
                });
                break;
            case $a2cc6e1d6eb3861b$var$StreamKind.ENQUEUE:
                $a2cc6e1d6eb3861b$var$assert(streamController, "enqueue should have stream controller");
                if (streamController.isClosed) break;
                streamController.controller.enqueue(data.chunk);
                break;
            case $a2cc6e1d6eb3861b$var$StreamKind.CLOSE:
                $a2cc6e1d6eb3861b$var$assert(streamController, "close should have stream controller");
                if (streamController.isClosed) break;
                streamController.isClosed = true;
                streamController.controller.close();
                this.#deleteStreamController(streamController, streamId);
                break;
            case $a2cc6e1d6eb3861b$var$StreamKind.ERROR:
                $a2cc6e1d6eb3861b$var$assert(streamController, "error should have stream controller");
                streamController.controller.error($a2cc6e1d6eb3861b$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $a2cc6e1d6eb3861b$var$StreamKind.CANCEL_COMPLETE:
                if (data.success) streamController.cancelCall.resolve();
                else streamController.cancelCall.reject($a2cc6e1d6eb3861b$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $a2cc6e1d6eb3861b$var$StreamKind.CANCEL:
                if (!streamSink) break;
                const dataReason = $a2cc6e1d6eb3861b$var$wrapReason(data.reason);
                Promise.try(streamSink.onCancel || $a2cc6e1d6eb3861b$var$onFn, dataReason).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $a2cc6e1d6eb3861b$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $a2cc6e1d6eb3861b$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        reason: $a2cc6e1d6eb3861b$var$wrapReason(reason)
                    });
                });
                streamSink.sinkCapability.reject(dataReason);
                streamSink.isCancelled = true;
                delete this.streamSinks[streamId];
                break;
            default:
                throw new Error("Unexpected stream case");
        }
    }
    async #deleteStreamController(streamController, streamId) {
        await Promise.allSettled([
            streamController.startCall?.promise,
            streamController.pullCall?.promise,
            streamController.cancelCall?.promise
        ]);
        delete this.streamControllers[streamId];
    }
    destroy() {
        this.#messageAC?.abort();
        this.#messageAC = null;
    }
}
class $a2cc6e1d6eb3861b$var$BaseBinaryDataFactory {
    #errorStr = Object.freeze({
        cMapUrl: "CMap",
        standardFontDataUrl: "font",
        wasmUrl: "wasm"
    });
    constructor({ cMapUrl: cMapUrl = null, standardFontDataUrl: standardFontDataUrl = null, wasmUrl: wasmUrl = null }){
        this.cMapUrl = cMapUrl;
        this.standardFontDataUrl = standardFontDataUrl;
        this.wasmUrl = wasmUrl;
    }
    async fetch({ kind: kind, filename: filename }) {
        switch(kind){
            case "cMapUrl":
            case "standardFontDataUrl":
            case "wasmUrl":
                break;
            default:
                $a2cc6e1d6eb3861b$var$unreachable(`Not implemented: ${kind}`);
        }
        const baseUrl = this[kind];
        if (!baseUrl) throw new Error(`Ensure that the \`${kind}\` API parameter is provided.`);
        const url = `${baseUrl}${filename}`;
        return this._fetch(url, kind).catch((reason)=>{
            throw new Error(`Unable to load ${this.#errorStr[kind]} data at: ${url}`);
        });
    }
    async _fetch(url, kind) {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `_fetch` called.");
    }
}
class $a2cc6e1d6eb3861b$var$DOMBinaryDataFactory extends $a2cc6e1d6eb3861b$var$BaseBinaryDataFactory {
    async _fetch(url, kind) {
        const type = kind === "cMapUrl" && !url.endsWith(".bcmap") ? "text" : "bytes";
        const data = await $a2cc6e1d6eb3861b$export$8134c072fddab6a5(url, type);
        return data instanceof Uint8Array ? data : $a2cc6e1d6eb3861b$var$stringToBytes(data);
    }
}
class $a2cc6e1d6eb3861b$var$BaseCanvasFactory {
    #enableHWA = false;
    constructor({ enableHWA: enableHWA = false }){
        this.#enableHWA = enableHWA;
    }
    create(width, height) {
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        const canvas = this._createCanvas(width, height);
        return {
            canvas: canvas,
            context: canvas.getContext("2d", {
                willReadFrequently: !this.#enableHWA
            })
        };
    }
    reset({ canvas: canvas }, width, height) {
        if (!canvas) throw new Error("Canvas is not specified");
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        canvas.width = width;
        canvas.height = height;
    }
    destroy(canvasAndContext) {
        const { canvas: canvas } = canvasAndContext;
        if (!canvas) throw new Error("Canvas is not specified");
        canvas.width = canvas.height = 0;
        canvasAndContext.canvas = null;
        canvasAndContext.context = null;
    }
    _createCanvas(width, height) {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `_createCanvas` called.");
    }
}
class $a2cc6e1d6eb3861b$var$DOMCanvasFactory extends $a2cc6e1d6eb3861b$var$BaseCanvasFactory {
    constructor({ ownerDocument: ownerDocument = globalThis.document, enableHWA: enableHWA = false }){
        super({
            enableHWA: enableHWA
        });
        this._document = ownerDocument;
    }
    _createCanvas(width, height) {
        const canvas = this._document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
}
class $a2cc6e1d6eb3861b$var$BaseFilterFactory {
    addFilter(maps) {
        return "none";
    }
    addHCMFilter(fgColor, bgColor) {
        return "none";
    }
    addAlphaFilter(map) {
        return "none";
    }
    addLuminosityFilter(map) {
        return "none";
    }
    addKnockoutFilter(alpha = 0) {
        return "none";
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        return "none";
    }
    addSelectionHCMFilter(fgColor, bgColor) {
        return "none";
    }
    addSelectionFilter() {
        return "none";
    }
    createSelectionStyle(pageColors = null) {
        return null;
    }
    destroy(keepHCM = false) {}
}
class $a2cc6e1d6eb3861b$var$DOMFilterFactory extends $a2cc6e1d6eb3861b$var$BaseFilterFactory {
    #baseUrl;
    #_cache;
    #_defs;
    #docId;
    #document;
    #_hcmCache;
    #id = 0;
    constructor({ docId: docId, ownerDocument: ownerDocument = globalThis.document }){
        super();
        this.#docId = docId;
        this.#document = ownerDocument;
    }
    get #cache() {
        return this.#_cache ||= new Map();
    }
    get #hcmCache() {
        return this.#_hcmCache ||= new Map();
    }
    get #defs() {
        if (!this.#_defs) {
            const div = this.#document.createElement("div");
            const { style: style } = div;
            style.colorScheme = "only light";
            style.visibility = "hidden";
            style.contain = "strict";
            style.width = style.height = 0;
            style.position = "absolute";
            style.top = style.left = 0;
            style.zIndex = -1;
            const svg = this.#document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, "svg");
            svg.setAttribute("width", 0);
            svg.setAttribute("height", 0);
            this.#_defs = this.#document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, "defs");
            div.append(svg);
            svg.append(this.#_defs);
            this.#document.body.append(div);
        }
        return this.#_defs;
    }
    #createTables(maps) {
        if (maps.length === 1) {
            const mapR = maps[0];
            const buffer = new Array(256);
            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
            const table = buffer.join(",");
            return [
                table,
                table,
                table
            ];
        }
        const [mapR, mapG, mapB] = maps;
        const bufferR = new Array(256);
        const bufferG = new Array(256);
        const bufferB = new Array(256);
        for(let i = 0; i < 256; i++){
            bufferR[i] = mapR[i] / 255;
            bufferG[i] = mapG[i] / 255;
            bufferB[i] = mapB[i] / 255;
        }
        return [
            bufferR.join(","),
            bufferG.join(","),
            bufferB.join(",")
        ];
    }
    #createUrl(id) {
        if (this.#baseUrl === undefined) {
            this.#baseUrl = "";
            const url = this.#document.URL;
            if (url !== this.#document.baseURI) {
                if ($a2cc6e1d6eb3861b$export$f67aae4532d8295b(url)) $a2cc6e1d6eb3861b$var$warn('#createUrl: ignore "data:"-URL for performance reasons.');
                else this.#baseUrl = $a2cc6e1d6eb3861b$export$e1e4297c21ab9d13(url, "");
            }
        }
        return `url(${this.#baseUrl}#${id})`;
    }
    addFilter(maps) {
        if (!maps) return "none";
        let value = this.#cache.get(maps);
        if (value) return value;
        const [tableR, tableG, tableB] = this.#createTables(maps);
        const key = maps.length === 1 ? tableR : `${tableR}${tableG}${tableB}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(maps, value);
            return value;
        }
        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(maps, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
        return url;
    }
    addHCMFilter(fgColor, bgColor) {
        const key = `${fgColor}-${bgColor}`;
        const filterName = "base";
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const fgRGB = this.#getRGB(fgColor);
        fgColor = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(...fgRGB);
        const bgRGB = this.#getRGB(bgColor);
        bgColor = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(...bgRGB);
        this.#defs.style.color = "";
        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return info.url;
        const map = new Array(256);
        for(let i = 0; i <= 255; i++){
            const x = i / 255;
            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
        }
        const table = map.join(",");
        const id = `g_${this.#docId}_hcm_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addTransferMapConversion(table, table, table, filter);
        this.#addGrayConversion(filter);
        const getSteps = (c, n)=>{
            const start = fgRGB[c] / 255;
            const end = bgRGB[c] / 255;
            const arr = new Array(n + 1);
            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
            return arr.join(",");
        };
        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
        info.url = this.#createUrl(id);
        return info.url;
    }
    addSelectionHCMFilter(fgColor, bgColor) {
        return this.addHighlightHCMFilter("selection", fgColor, bgColor, "HighlightText", "Highlight");
    }
    addSelectionFilter() {
        return this.addHighlightHCMFilter("selection_default", "black", "white", "HighlightText", "Highlight");
    }
    createSelectionStyle(pageColors = null) {
        const filter = pageColors ? this.addSelectionHCMFilter(pageColors.foreground, pageColors.background) : this.addSelectionFilter();
        if (filter === "none" || !$a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform.isFirefox) return null;
        return {
            "backdrop-filter": filter,
            "background-color": "transparent"
        };
    }
    addAlphaFilter(map) {
        let value = this.#cache.get(map);
        if (value) return value;
        const [tableA] = this.#createTables([
            map
        ]);
        const key = `alpha_${tableA}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_alpha_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addLuminosityFilter(map) {
        let value = this.#cache.get(map || "luminosity");
        if (value) return value;
        let tableA, key;
        if (map) {
            [tableA] = this.#createTables([
                map
            ]);
            key = `luminosity_${tableA}`;
        } else key = "luminosity";
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_luminosity_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addLuminosityConversion(filter);
        if (map) this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addKnockoutFilter(alpha = 0) {
        const slope = alpha > 0 ? Math.min(1 / alpha, 1e6) : 1e6;
        const key = `knockout_${slope}`;
        const value = this.#cache.get(key);
        if (value) return value;
        const id = `g_${this.#docId}_knockout_filter_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        const feComponentTransfer = this.#document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        const feFuncA = this.#document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, "feFuncA");
        feFuncA.setAttribute("type", "linear");
        feFuncA.setAttribute("slope", `${slope}`);
        feFuncA.setAttribute("intercept", "0");
        feComponentTransfer.append(feFuncA);
        return url;
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const [fgRGB, bgRGB] = [
            fgColor,
            bgColor
        ].map(this.#getRGB.bind(this));
        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
        let [newFgRGB, newBgRGB] = [
            newFgColor,
            newBgColor
        ].map(this.#getOpaqueTextColor.bind(this));
        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
            bgGray,
            fgGray,
            newBgRGB,
            newFgRGB
        ];
        this.#defs.style.color = "";
        const getSteps = (fg, bg, n)=>{
            const arr = new Array(256);
            const step = (bgGray - fgGray) / n;
            const newStart = fg / 255;
            const newStep = (bg - fg) / (255 * n);
            let prev = 0;
            for(let i = 0; i <= n; i++){
                const k = Math.round(fgGray + i * step);
                const value = newStart + i * newStep;
                for(let j = prev; j <= k; j++)arr[j] = value;
                prev = k + 1;
            }
            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
            return arr.join(",");
        };
        const id = `g_${this.#docId}_hcm_${filterName}_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addGrayConversion(filter);
        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
        info.url = this.#createUrl(id);
        return info.url;
    }
    destroy(keepHCM = false) {
        if (keepHCM && this.#_hcmCache?.size) return;
        this.#_defs?.parentNode.parentNode.remove();
        this.#_defs = null;
        this.#_cache?.clear();
        this.#_cache = null;
        this.#_hcmCache?.clear();
        this.#_hcmCache = null;
        this.#id = 0;
    }
    #addLuminosityConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0");
        filter.append(feColorMatrix);
    }
    #addGrayConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
        filter.append(feColorMatrix);
    }
    #createFilter(id) {
        const filter = this.#document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, "filter");
        filter.setAttribute("color-interpolation-filters", "sRGB");
        filter.setAttribute("id", id);
        this.#defs.append(filter);
        return filter;
    }
    #appendFeFunc(feComponentTransfer, func, table) {
        const feFunc = this.#document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, func);
        feFunc.setAttribute("type", "discrete");
        feFunc.setAttribute("tableValues", table);
        feComponentTransfer.append(feFunc);
    }
    #addTransferMapConversion(rTable, gTable, bTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
    }
    #addTransferMapAlphaConversion(aTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncA", aTable);
    }
    #getRGB(color) {
        this.#defs.style.color = color;
        return $a2cc6e1d6eb3861b$export$2a2e9b507863ddda(getComputedStyle(this.#defs).getPropertyValue("color"));
    }
    #getRGBA(color) {
        this.#defs.style.color = color;
        return $a2cc6e1d6eb3861b$export$c24a0a5c5129b2e1(getComputedStyle(this.#defs).getPropertyValue("color"));
    }
    #getOpaqueTextColor(color) {
        const [r, g, b, alpha] = this.#getRGBA(color);
        if (alpha === 1) return [
            r,
            g,
            b
        ];
        const [canvasR, canvasG, canvasB] = this.#getRGB("Canvas");
        return [
            $a2cc6e1d6eb3861b$var$blend(r, canvasR, alpha),
            $a2cc6e1d6eb3861b$var$blend(g, canvasG, alpha),
            $a2cc6e1d6eb3861b$var$blend(b, canvasB, alpha)
        ];
    }
}
function $a2cc6e1d6eb3861b$var$blend(fg, bg, alpha) {
    return Math.round(alpha * fg + (1 - alpha) * bg);
}
if ($a2cc6e1d6eb3861b$var$isNodeJS) $a2cc6e1d6eb3861b$var$warn("Please use the `legacy` build in Node.js environments.");
async function $a2cc6e1d6eb3861b$var$node_utils_fetchData(url) {
    const fs = $jBmpJ.getBuiltinModule("fs/promises");
    const data = await fs.readFile(url);
    return new Uint8Array(data);
}
class $a2cc6e1d6eb3861b$var$NodeFilterFactory extends $a2cc6e1d6eb3861b$var$BaseFilterFactory {
}
class $a2cc6e1d6eb3861b$var$NodeCanvasFactory extends $a2cc6e1d6eb3861b$var$BaseCanvasFactory {
    _createCanvas(width, height) {
        const require1 = $jBmpJ.getBuiltinModule("module").createRequire("file:///node_modules/.pnpm/pdfjs-dist@6.0.227/node_modules/pdfjs-dist/build/pdf.mjs");
        const canvas = require1("@napi-rs/canvas");
        return canvas.createCanvas(width, height);
    }
}
class $a2cc6e1d6eb3861b$var$NodeBinaryDataFactory extends $a2cc6e1d6eb3861b$var$BaseBinaryDataFactory {
    async _fetch(url, kind) {
        return $a2cc6e1d6eb3861b$var$node_utils_fetchData(url);
    }
}
const $a2cc6e1d6eb3861b$var$MESH_WGSL = `
struct Uniforms {
  offsetX      : f32,
  offsetY      : f32,
  scaleX       : f32,
  scaleY       : f32,
  paddedWidth  : f32,
  paddedHeight : f32,
  borderSize   : f32,
  _pad         : f32,
};

@group(0) @binding(0) var<uniform> u : Uniforms;

struct VertexInput {
  @location(0) position : vec2<f32>,
  @location(1) color    : vec4<f32>,
};

struct VertexOutput {
  @builtin(position) position : vec4<f32>,
  @location(0)       color    : vec3<f32>,
};

@vertex
fn vs_main(in : VertexInput) -> VertexOutput {
  var out : VertexOutput;
  let cx = (in.position.x + u.offsetX) * u.scaleX;
  let cy = (in.position.y + u.offsetY) * u.scaleY;
  out.position = vec4<f32>(
    ((cx + u.borderSize) / u.paddedWidth) * 2.0 - 1.0,
    1.0 - ((cy + u.borderSize) / u.paddedHeight) * 2.0,
    0.0,
    1.0
  );
  out.color = in.color.rgb;
  return out;
}

@fragment
fn fs_main(in : VertexOutput) -> @location(0) vec4<f32> {
  return vec4<f32>(in.color, 1.0);
}
`;
class $a2cc6e1d6eb3861b$var$WebGPU {
    #initPromise = null;
    #device = null;
    #meshPipeline = null;
    #preferredFormat = null;
    async #initGPU() {
        if (!globalThis.navigator?.gpu) return false;
        try {
            const adapter = await navigator.gpu.requestAdapter();
            if (!adapter) return false;
            this.#preferredFormat = navigator.gpu.getPreferredCanvasFormat();
            this.#device = await adapter.requestDevice();
            return true;
        } catch  {
            return false;
        }
    }
    init() {
        return this.#initPromise ||= this.#initGPU();
    }
    get isReady() {
        return this.#device !== null;
    }
    loadMeshShader() {
        if (!this.#device || this.#meshPipeline) return;
        const shaderModule = this.#device.createShaderModule({
            code: $a2cc6e1d6eb3861b$var$MESH_WGSL
        });
        this.#meshPipeline = this.#device.createRenderPipeline({
            layout: "auto",
            vertex: {
                module: shaderModule,
                entryPoint: "vs_main",
                buffers: [
                    {
                        arrayStride: 8,
                        attributes: [
                            {
                                shaderLocation: 0,
                                offset: 0,
                                format: "float32x2"
                            }
                        ]
                    },
                    {
                        arrayStride: 4,
                        attributes: [
                            {
                                shaderLocation: 1,
                                offset: 0,
                                format: "unorm8x4"
                            }
                        ]
                    }
                ]
            },
            fragment: {
                module: shaderModule,
                entryPoint: "fs_main",
                targets: [
                    {
                        format: this.#preferredFormat
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            }
        });
    }
    draw(posData, colData, vertexCount, context, backgroundColor, paddedWidth, paddedHeight, borderSize) {
        this.loadMeshShader();
        const device = this.#device;
        const { offsetX: offsetX, offsetY: offsetY, scaleX: scaleX, scaleY: scaleY } = context;
        const posBuffer = device.createBuffer({
            size: Math.max(posData.byteLength, 4),
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST
        });
        if (posData.byteLength > 0) device.queue.writeBuffer(posBuffer, 0, posData);
        const colBuffer = device.createBuffer({
            size: Math.max(colData.byteLength, 4),
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST
        });
        if (colData.byteLength > 0) device.queue.writeBuffer(colBuffer, 0, colData);
        const uniformBuffer = device.createBuffer({
            size: 32,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(uniformBuffer, 0, new Float32Array([
            offsetX,
            offsetY,
            scaleX,
            scaleY,
            paddedWidth,
            paddedHeight,
            borderSize,
            0
        ]));
        const bindGroup = device.createBindGroup({
            layout: this.#meshPipeline.getBindGroupLayout(0),
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: uniformBuffer
                    }
                }
            ]
        });
        const offscreen = new OffscreenCanvas(paddedWidth, paddedHeight);
        const gpuCtx = offscreen.getContext("webgpu");
        gpuCtx.configure({
            device: device,
            format: this.#preferredFormat,
            alphaMode: backgroundColor ? "opaque" : "premultiplied"
        });
        const clearValue = backgroundColor ? {
            r: backgroundColor[0] / 255,
            g: backgroundColor[1] / 255,
            b: backgroundColor[2] / 255,
            a: 1
        } : {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        };
        const commandEncoder = device.createCommandEncoder();
        const renderPass = commandEncoder.beginRenderPass({
            colorAttachments: [
                {
                    view: gpuCtx.getCurrentTexture().createView(),
                    clearValue: clearValue,
                    loadOp: "clear",
                    storeOp: "store"
                }
            ]
        });
        if (vertexCount > 0) {
            renderPass.setPipeline(this.#meshPipeline);
            renderPass.setBindGroup(0, bindGroup);
            renderPass.setVertexBuffer(0, posBuffer);
            renderPass.setVertexBuffer(1, colBuffer);
            renderPass.draw(vertexCount);
        }
        renderPass.end();
        device.queue.submit([
            commandEncoder.finish()
        ]);
        posBuffer.destroy();
        colBuffer.destroy();
        uniformBuffer.destroy();
        return offscreen.transferToImageBitmap();
    }
}
const $a2cc6e1d6eb3861b$var$_webGPU = new $a2cc6e1d6eb3861b$var$WebGPU();
function $a2cc6e1d6eb3861b$var$initGPU() {
    return $a2cc6e1d6eb3861b$var$_webGPU.init();
}
function $a2cc6e1d6eb3861b$var$isGPUReady() {
    return $a2cc6e1d6eb3861b$var$_webGPU.isReady;
}
function $a2cc6e1d6eb3861b$var$loadMeshShader() {
    $a2cc6e1d6eb3861b$var$_webGPU.loadMeshShader();
}
function $a2cc6e1d6eb3861b$var$drawMeshWithGPU(posData, colData, vertexCount, context, backgroundColor, paddedWidth, paddedHeight, borderSize) {
    return $a2cc6e1d6eb3861b$var$_webGPU.draw(posData, colData, vertexCount, context, backgroundColor, paddedWidth, paddedHeight, borderSize);
}
const $a2cc6e1d6eb3861b$var$PathType = {
    FILL: "Fill",
    STROKE: "Stroke",
    SHADING: "Shading"
};
function $a2cc6e1d6eb3861b$var$applyBoundingBox(ctx, bbox) {
    if (!bbox) return;
    const width = bbox[2] - bbox[0];
    const height = bbox[3] - bbox[1];
    const region = new Path2D();
    region.rect(bbox[0], bbox[1], width, height);
    ctx.clip(region);
}
class $a2cc6e1d6eb3861b$var$BaseShadingPattern {
    isModifyingCurrentTransform() {
        return false;
    }
    getPattern() {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `getPattern` called.");
    }
}
class $a2cc6e1d6eb3861b$var$RadialAxialShadingPattern extends $a2cc6e1d6eb3861b$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._type = IR[1];
        this._bbox = IR[2];
        this._colorStops = IR[3];
        this._p0 = IR[4];
        this._p1 = IR[5];
        this._r0 = IR[6];
        this._r1 = IR[7];
        this.matrix = null;
    }
    isOriginBased() {
        return this._p0[0] === 0 && this._p0[1] === 0 && (!this.isRadial() || this._p1[0] === 0 && this._p1[1] === 0);
    }
    isRadial() {
        return this._type === "radial";
    }
    areConic() {
        if (!this.isRadial()) return false;
        const dist = Math.hypot(this._p0[0] - this._p1[0], this._p0[1] - this._p1[1]);
        return dist + this._r1 > this._r0 && dist + this._r0 > this._r1;
    }
    _createGradient(ctx, transform = null) {
        let grad;
        let firstPoint = this._p0;
        let secondPoint = this._p1;
        if (transform) {
            firstPoint = firstPoint.slice();
            secondPoint = secondPoint.slice();
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(firstPoint, transform);
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(secondPoint, transform);
        }
        if (this._type === "axial") grad = ctx.createLinearGradient(firstPoint[0], firstPoint[1], secondPoint[0], secondPoint[1]);
        else if (this._type === "radial") {
            let r0 = this._r0;
            let r1 = this._r1;
            if (transform) {
                const scale = new Float32Array(2);
                $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, scale);
                r0 *= scale[0];
                r1 *= scale[0];
            }
            grad = ctx.createRadialGradient(firstPoint[0], firstPoint[1], r0, secondPoint[0], secondPoint[1], r1);
        }
        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
        return grad;
    }
    _createReversedGradient(ctx, transform = null) {
        let firstPoint = this._p1;
        let secondPoint = this._p0;
        if (transform) {
            firstPoint = firstPoint.slice();
            secondPoint = secondPoint.slice();
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(firstPoint, transform);
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(secondPoint, transform);
        }
        let r0 = this._r1;
        let r1 = this._r0;
        if (transform) {
            const scale = new Float32Array(2);
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, scale);
            r0 *= scale[0];
            r1 *= scale[0];
        }
        const grad = ctx.createRadialGradient(firstPoint[0], firstPoint[1], r0, secondPoint[0], secondPoint[1], r1);
        const reversedStops = this._colorStops.map(([t, c])=>[
                1 - t,
                c
            ]).reverse();
        for (const [t, c] of reversedStops)grad.addColorStop(t, c);
        return grad;
    }
    getPattern(ctx, owner, inverse, pathType) {
        let pattern;
        if (pathType === $a2cc6e1d6eb3861b$var$PathType.STROKE || pathType === $a2cc6e1d6eb3861b$var$PathType.FILL) {
            if (this.isOriginBased()) {
                let transf = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform(inverse, owner.baseTransform);
                if (this.matrix) transf = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform(transf, this.matrix);
                const precision = 1e-3;
                const n1 = Math.hypot(transf[0], transf[1]);
                const n2 = Math.hypot(transf[2], transf[3]);
                const ps = (transf[0] * transf[2] + transf[1] * transf[3]) / (n1 * n2);
                if (Math.abs(ps) < precision) {
                    if (this.isRadial()) {
                        if (Math.abs(n1 - n2) < precision) return this._createGradient(ctx, transf);
                    } else return this._createGradient(ctx, transf);
                }
            }
            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, $a2cc6e1d6eb3861b$var$getCurrentTransform(ctx)) || [
                0,
                0,
                0,
                0
            ];
            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
            const tmpCanvas = owner.canvasFactory.create(width, height);
            const tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.beginPath();
            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
            inverse = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform(inverse, [
                1,
                0,
                0,
                1,
                ownerBBox[0],
                ownerBBox[1]
            ]);
            tmpCtx.transform(...owner.baseTransform);
            if (this.matrix) tmpCtx.transform(...this.matrix);
            $a2cc6e1d6eb3861b$var$applyBoundingBox(tmpCtx, this._bbox);
            if (this.areConic()) {
                tmpCtx.fillStyle = this._createReversedGradient(tmpCtx);
                tmpCtx.fill();
            }
            tmpCtx.fillStyle = this._createGradient(tmpCtx);
            tmpCtx.fill();
            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
            owner.canvasFactory.destroy(tmpCanvas);
            const domMatrix = new DOMMatrix(inverse);
            pattern.setTransform(domMatrix);
        } else {
            if (this.areConic()) {
                ctx.save();
                $a2cc6e1d6eb3861b$var$applyBoundingBox(ctx, this._bbox);
                ctx.fillStyle = this._createReversedGradient(ctx);
                ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                ctx.restore();
            }
            $a2cc6e1d6eb3861b$var$applyBoundingBox(ctx, this._bbox);
            pattern = this._createGradient(ctx);
        }
        return pattern;
    }
}
function $a2cc6e1d6eb3861b$var$drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    const coords = context.coords, colors = context.colors;
    const bytes = data.data, rowSize = data.width * 4;
    let tmp;
    if (coords[p1 * 2 + 1] > coords[p2 * 2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    if (coords[p2 * 2 + 1] > coords[p3 * 2 + 1]) {
        tmp = p2;
        p2 = p3;
        p3 = tmp;
        tmp = c2;
        c2 = c3;
        c3 = tmp;
    }
    if (coords[p1 * 2 + 1] > coords[p2 * 2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    const x1 = (coords[p1 * 2] + context.offsetX) * context.scaleX;
    const y1 = (coords[p1 * 2 + 1] + context.offsetY) * context.scaleY;
    const x2 = (coords[p2 * 2] + context.offsetX) * context.scaleX;
    const y2 = (coords[p2 * 2 + 1] + context.offsetY) * context.scaleY;
    const x3 = (coords[p3 * 2] + context.offsetX) * context.scaleX;
    const y3 = (coords[p3 * 2 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) return;
    const c1r = colors[c1 * 4], c1g = colors[c1 * 4 + 1], c1b = colors[c1 * 4 + 2];
    const c2r = colors[c2 * 4], c2g = colors[c2 * 4 + 1], c2b = colors[c2 * 4 + 2];
    const c3r = colors[c3 * 4], c3g = colors[c3 * 4 + 1], c3b = colors[c3 * 4 + 2];
    const minY = Math.round(y1), maxY = Math.round(y3);
    let xa, car, cag, cab;
    let xb, cbr, cbg, cbb;
    for(let y = minY; y <= maxY; y++){
        if (y < y2) {
            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
            xa = x1 - (x1 - x2) * k;
            car = c1r - (c1r - c2r) * k;
            cag = c1g - (c1g - c2g) * k;
            cab = c1b - (c1b - c2b) * k;
        } else {
            let k;
            if (y > y3) k = 1;
            else if (y2 === y3) k = 0;
            else k = (y2 - y) / (y2 - y3);
            xa = x2 - (x2 - x3) * k;
            car = c2r - (c2r - c3r) * k;
            cag = c2g - (c2g - c3g) * k;
            cab = c2b - (c2b - c3b) * k;
        }
        let k;
        if (y < y1) k = 0;
        else if (y > y3) k = 1;
        else k = (y1 - y) / (y1 - y3);
        xb = x1 - (x1 - x3) * k;
        cbr = c1r - (c1r - c3r) * k;
        cbg = c1g - (c1g - c3g) * k;
        cbb = c1b - (c1b - c3b) * k;
        const x1_ = Math.round(Math.min(xa, xb));
        const x2_ = Math.round(Math.max(xa, xb));
        let j = rowSize * y + x1_ * 4;
        for(let x = x1_; x <= x2_; x++){
            k = (xa - x) / (xa - xb);
            if (k < 0) k = 0;
            else if (k > 1) k = 1;
            bytes[j++] = car - (car - cbr) * k | 0;
            bytes[j++] = cag - (cag - cbg) * k | 0;
            bytes[j++] = cab - (cab - cbb) * k | 0;
            bytes[j++] = 255;
        }
    }
}
class $a2cc6e1d6eb3861b$var$MeshShadingPattern extends $a2cc6e1d6eb3861b$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._posData = IR[2];
        this._colData = IR[3];
        this._vertexCount = IR[4];
        this._bounds = IR[5];
        this._bbox = IR[6];
        this._background = IR[7];
        this.matrix = null;
        $a2cc6e1d6eb3861b$var$loadMeshShader();
    }
    _createMeshCanvas(combinedScale, backgroundColor, canvasFactory) {
        const EXPECTED_SCALE = 1.1;
        const MAX_PATTERN_SIZE = 3000;
        const BORDER_SIZE = 2;
        const offsetX = Math.floor(this._bounds[0]);
        const offsetY = Math.floor(this._bounds[1]);
        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE) || 1;
        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE) || 1;
        const scaleX = boundsWidth ? boundsWidth / width : 1;
        const scaleY = boundsHeight ? boundsHeight / height : 1;
        const context = {
            coords: this._posData,
            colors: this._colData,
            offsetX: -offsetX,
            offsetY: -offsetY,
            scaleX: 1 / scaleX,
            scaleY: 1 / scaleY
        };
        const paddedWidth = width + BORDER_SIZE * 2;
        const paddedHeight = height + BORDER_SIZE * 2;
        const tmpCanvas = canvasFactory.create(paddedWidth, paddedHeight);
        if ($a2cc6e1d6eb3861b$var$isGPUReady() && this._vertexCount > 48) tmpCanvas.context.drawImage($a2cc6e1d6eb3861b$var$drawMeshWithGPU(this._posData, this._colData, this._vertexCount, context, backgroundColor, paddedWidth, paddedHeight, BORDER_SIZE), 0, 0);
        else {
            const data = tmpCanvas.context.createImageData(width, height);
            if (backgroundColor) {
                const bytes = data.data;
                for(let i = 0, ii = bytes.length; i < ii; i += 4){
                    bytes[i] = backgroundColor[0];
                    bytes[i + 1] = backgroundColor[1];
                    bytes[i + 2] = backgroundColor[2];
                    bytes[i + 3] = 255;
                }
            }
            for(let i = 0, ii = this._vertexCount; i < ii; i += 3)$a2cc6e1d6eb3861b$var$drawTriangle(data, context, i, i + 1, i + 2, i, i + 1, i + 2);
            tmpCanvas.context.putImageData(data, BORDER_SIZE, BORDER_SIZE);
        }
        return {
            canvas: tmpCanvas.canvas,
            offsetX: offsetX - BORDER_SIZE * scaleX,
            offsetY: offsetY - BORDER_SIZE * scaleY,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    isModifyingCurrentTransform() {
        return true;
    }
    getPattern(ctx, owner, inverse, pathType) {
        $a2cc6e1d6eb3861b$var$applyBoundingBox(ctx, this._bbox);
        const scale = new Float32Array(2);
        if (pathType === $a2cc6e1d6eb3861b$var$PathType.SHADING) $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale($a2cc6e1d6eb3861b$var$getCurrentTransform(ctx), scale);
        else if (this.matrix) {
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.matrix, scale);
            const [matrixScaleX, matrixScaleY] = scale;
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(owner.baseTransform, scale);
            scale[0] *= matrixScaleX;
            scale[1] *= matrixScaleY;
        } else $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(owner.baseTransform, scale);
        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === $a2cc6e1d6eb3861b$var$PathType.SHADING ? null : this._background, owner.canvasFactory);
        if (pathType !== $a2cc6e1d6eb3861b$var$PathType.SHADING) {
            ctx.setTransform(...owner.baseTransform);
            if (this.matrix) ctx.transform(...this.matrix);
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
        owner.canvasFactory.destroy(temporaryPatternCanvas);
        return pattern;
    }
}
class $a2cc6e1d6eb3861b$var$DummyShadingPattern extends $a2cc6e1d6eb3861b$var$BaseShadingPattern {
    getPattern() {
        return "hotpink";
    }
}
function $a2cc6e1d6eb3861b$var$getShadingPattern(IR) {
    switch(IR[0]){
        case "RadialAxial":
            return new $a2cc6e1d6eb3861b$var$RadialAxialShadingPattern(IR);
        case "Mesh":
            return new $a2cc6e1d6eb3861b$var$MeshShadingPattern(IR);
        case "Dummy":
            return new $a2cc6e1d6eb3861b$var$DummyShadingPattern();
    }
    throw new Error(`Unknown IR type: ${IR[0]}`);
}
const $a2cc6e1d6eb3861b$var$PaintType = {
    COLORED: 1,
    UNCOLORED: 2
};
class $a2cc6e1d6eb3861b$var$TilingPattern {
    static MAX_PATTERN_SIZE = 3000;
    constructor(IR, ctx, canvasGraphicsFactory, baseTransform){
        this.color = IR[1];
        this.operatorList = IR[2];
        this.matrix = IR[3];
        this.bbox = IR[4];
        this.xstep = IR[5];
        this.ystep = IR[6];
        this.paintType = IR[7];
        this.tilingType = IR[8];
        this.needsIsolation = IR[9] ?? true;
        this.ctx = ctx;
        this.canvasGraphicsFactory = canvasGraphicsFactory;
        this.baseTransform = baseTransform;
        this.patternBaseMatrix = this.matrix ? $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform(baseTransform, this.matrix) : baseTransform;
    }
    canSkipPatternCanvas([width, height, offsetX, offsetY]) {
        const [x0, y0, x1, y1] = this.bbox;
        const absXStep = Math.abs(this.xstep);
        const absYStep = Math.abs(this.ystep);
        if (width > absXStep + 1e-6 || height > absYStep + 1e-6) return null;
        const nXFirst = Math.floor((offsetX - x1) / absXStep) + 1;
        const nXLast = Math.ceil((offsetX + width - x0) / absXStep) - 1;
        const nYFirst = Math.floor((offsetY - y1) / absYStep) + 1;
        const nYLast = Math.ceil((offsetY + height - y0) / absYStep) - 1;
        return nXLast <= nXFirst && nYLast <= nYFirst ? [
            nXFirst,
            nYFirst
        ] : null;
    }
    updatePatternDims(clippedBBox, dims) {
        const inv = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.inverseTransform(this.patternBaseMatrix);
        const c1 = [
            clippedBBox[0],
            clippedBBox[1]
        ];
        const c2 = [
            clippedBBox[2],
            clippedBBox[3]
        ];
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(c1, inv);
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(c2, inv);
        dims[0] = Math.abs(c2[0] - c1[0]);
        dims[1] = Math.abs(c2[1] - c1[1]);
        dims[2] = Math.min(c1[0], c2[0]);
        dims[3] = Math.min(c1[1], c2[1]);
    }
    _renderTileCanvas(owner, opIdx, dimx, dimy) {
        const [x0, y0, x1, y1] = this.bbox;
        const tmpCanvas = owner.canvasFactory.create(dimx.size, dimy.size);
        const tmpCtx = tmpCanvas.context;
        const graphics = this.canvasGraphicsFactory.createCanvasGraphics(tmpCtx, opIdx);
        graphics.groupLevel = owner.groupLevel;
        this.setFillAndStrokeStyleToContext(graphics, this.paintType, this.color);
        tmpCtx.translate(-dimx.scale * x0, -dimy.scale * y0);
        graphics.transform(0, dimx.scale, 0, 0, dimy.scale, 0, 0);
        tmpCtx.save();
        graphics.dependencyTracker?.save();
        this.clipBbox(graphics, x0, y0, x1, y1);
        graphics.baseTransform = $a2cc6e1d6eb3861b$var$getCurrentTransform(graphics.ctx);
        graphics.executeOperatorList(this.operatorList);
        graphics.endDrawing();
        graphics.dependencyTracker?.restore();
        tmpCtx.restore();
        return tmpCanvas;
    }
    _getCombinedScales() {
        const scale = new Float32Array(2);
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.matrix, scale);
        const [matrixScaleX, matrixScaleY] = scale;
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.baseTransform, scale);
        return [
            matrixScaleX * scale[0],
            matrixScaleY * scale[1]
        ];
    }
    drawPattern(owner, path, useEOFill = false, [n, m], opIdx) {
        const [x0, y0, x1, y1] = this.bbox;
        const dependencyTracker = owner.dependencyTracker;
        if (dependencyTracker) owner.dependencyTracker = new $a2cc6e1d6eb3861b$var$CanvasNestedDependencyTracker(dependencyTracker, opIdx);
        owner.save();
        if (useEOFill) owner.ctx.clip(path, "evenodd");
        else owner.ctx.clip(path);
        owner.ctx.setTransform(...this.patternBaseMatrix);
        owner.ctx.translate(n * this.xstep, m * this.ystep);
        if (this.needsIsolation || owner.ctx.globalAlpha !== 1 || owner.ctx.globalCompositeOperation !== "source-over" || owner.inSMaskMode) {
            const bboxWidth = x1 - x0;
            const bboxHeight = y1 - y0;
            const [combinedScaleX, combinedScaleY] = this._getCombinedScales();
            const dimx = this.getSizeAndScale(bboxWidth, this.ctx.canvas.width, combinedScaleX);
            const dimy = this.getSizeAndScale(bboxHeight, this.ctx.canvas.height, combinedScaleY);
            const tmpCanvas = this._renderTileCanvas(owner, opIdx, dimx, dimy);
            owner.ctx.drawImage(tmpCanvas.canvas, x0, y0, bboxWidth, bboxHeight);
            owner.canvasFactory.destroy(tmpCanvas);
        } else {
            this.setFillAndStrokeStyleToContext(owner, this.paintType, this.color);
            this.clipBbox(owner, x0, y0, x1, y1);
            owner.baseTransformStack.push(owner.baseTransform);
            owner.baseTransform = $a2cc6e1d6eb3861b$var$getCurrentTransform(owner.ctx);
            owner.executeOperatorList(this.operatorList);
            owner.baseTransform = owner.baseTransformStack.pop();
        }
        owner.restore();
        if (dependencyTracker) owner.dependencyTracker = dependencyTracker;
    }
    createPatternCanvas(owner, opIdx) {
        const [x0, y0, x1, y1] = this.bbox;
        const width = x1 - x0;
        const height = y1 - y0;
        let { xstep: xstep, ystep: ystep } = this;
        xstep = Math.abs(xstep);
        ystep = Math.abs(ystep);
        $a2cc6e1d6eb3861b$var$info("TilingType: " + this.tilingType);
        const [combinedScaleX, combinedScaleY] = this._getCombinedScales();
        let canvasWidth = width, canvasHeight = height, redrawHorizontally = false, redrawVertically = false;
        if (Math.ceil(xstep * combinedScaleX) >= Math.ceil(width * combinedScaleX)) canvasWidth = xstep;
        else redrawHorizontally = true;
        if (Math.ceil(ystep * combinedScaleY) >= Math.ceil(height * combinedScaleY)) canvasHeight = ystep;
        else redrawVertically = true;
        const dimx = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
        const dimy = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
        const tmpCanvas = this._renderTileCanvas(owner, opIdx, dimx, dimy);
        if (redrawHorizontally || redrawVertically) {
            const image = tmpCanvas.canvas;
            if (redrawHorizontally) canvasWidth = xstep;
            if (redrawVertically) canvasHeight = ystep;
            const dimx2 = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
            const dimy2 = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
            const xSize = dimx2.size;
            const ySize = dimy2.size;
            const tmpCanvas2 = owner.canvasFactory.create(xSize, ySize);
            const tmpCtx2 = tmpCanvas2.context;
            const ii = redrawHorizontally ? Math.floor(width / xstep) : 0;
            const jj = redrawVertically ? Math.floor(height / ystep) : 0;
            for(let i = 0; i <= ii; i++)for(let j = 0; j <= jj; j++)tmpCtx2.drawImage(image, xSize * i, ySize * j, xSize, ySize, 0, 0, xSize, ySize);
            owner.canvasFactory.destroy(tmpCanvas);
            return {
                canvas: tmpCanvas2.canvas,
                canvasEntry: tmpCanvas2,
                scaleX: dimx2.scale,
                scaleY: dimy2.scale,
                offsetX: x0,
                offsetY: y0
            };
        }
        return {
            canvas: tmpCanvas.canvas,
            canvasEntry: tmpCanvas,
            scaleX: dimx.scale,
            scaleY: dimy.scale,
            offsetX: x0,
            offsetY: y0
        };
    }
    getSizeAndScale(step, realOutputSize, scale) {
        const maxSize = Math.max($a2cc6e1d6eb3861b$var$TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
        let size = Math.ceil(step * scale);
        if (size >= maxSize) size = maxSize;
        else scale = size / step;
        return {
            scale: scale,
            size: size
        };
    }
    clipBbox(graphics, x0, y0, x1, y1) {
        const bboxWidth = x1 - x0;
        const bboxHeight = y1 - y0;
        const clip = new Path2D();
        clip.rect(x0, y0, bboxWidth, bboxHeight);
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            x0,
            y0,
            x1,
            y1
        ], $a2cc6e1d6eb3861b$var$getCurrentTransform(graphics.ctx), graphics.current.minMax);
        graphics.ctx.clip(clip);
        graphics.current.updateClipFromPath();
    }
    setFillAndStrokeStyleToContext(graphics, paintType, color) {
        const context = graphics.ctx, current = graphics.current;
        current.patternFill = current.patternStroke = false;
        switch(paintType){
            case $a2cc6e1d6eb3861b$var$PaintType.COLORED:
                const { fillStyle: fillStyle, strokeStyle: strokeStyle } = this.ctx;
                context.fillStyle = current.fillColor = fillStyle;
                context.strokeStyle = current.strokeColor = strokeStyle;
                break;
            case $a2cc6e1d6eb3861b$var$PaintType.UNCOLORED:
                context.fillStyle = context.strokeStyle = color;
                current.fillColor = current.strokeColor = color;
                break;
            default:
                throw new $a2cc6e1d6eb3861b$var$FormatError(`Unsupported paint type: ${paintType}`);
        }
    }
    isModifyingCurrentTransform() {
        return false;
    }
    getPattern(ctx, owner, inverse, pathType, opIdx) {
        const matrix = pathType !== $a2cc6e1d6eb3861b$var$PathType.SHADING ? $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform(inverse, this.patternBaseMatrix) : inverse;
        const temporaryPatternCanvas = this.createPatternCanvas(owner, opIdx);
        let domMatrix = new DOMMatrix(matrix);
        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
        owner.canvasFactory.destroy(temporaryPatternCanvas.canvasEntry);
        pattern.setTransform(domMatrix);
        return pattern;
    }
}
/* unused harmony import specifier */ var $a2cc6e1d6eb3861b$var$image_utils_ImageKind;
/* unused harmony import specifier */ var $a2cc6e1d6eb3861b$var$image_utils_FeatureTest;
function $a2cc6e1d6eb3861b$var$convertToRGBA(params) {
    switch(params.kind){
        case $a2cc6e1d6eb3861b$var$image_utils_ImageKind.GRAYSCALE_1BPP:
            return $a2cc6e1d6eb3861b$var$convertBlackAndWhiteToRGBA(params);
        case $a2cc6e1d6eb3861b$var$image_utils_ImageKind.RGB_24BPP:
            return $a2cc6e1d6eb3861b$var$convertRGBToRGBA(params);
    }
    return null;
}
function $a2cc6e1d6eb3861b$var$convertBlackAndWhiteToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, width: width, height: height, nonBlackColor: nonBlackColor = 0xffffffff, inverseDecode: inverseDecode = false }) {
    const black = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.isLittleEndian ? 0xff000000 : 0x000000ff;
    const [zeroMapping, oneMapping] = inverseDecode ? [
        nonBlackColor,
        black
    ] : [
        black,
        nonBlackColor
    ];
    const widthInSource = width >> 3;
    const widthRemainder = width & 7;
    const xorMask = zeroMapping ^ oneMapping;
    const srcLength = src.length;
    dest = new Uint32Array(dest.buffer);
    let destPos = 0;
    for(let i = 0; i < height; ++i){
        for(const max = srcPos + widthInSource; srcPos < max; ++srcPos, destPos += 8){
            const elem = src[srcPos];
            dest[destPos] = zeroMapping ^ -(elem >> 7 & 1) & xorMask;
            dest[destPos + 1] = zeroMapping ^ -(elem >> 6 & 1) & xorMask;
            dest[destPos + 2] = zeroMapping ^ -(elem >> 5 & 1) & xorMask;
            dest[destPos + 3] = zeroMapping ^ -(elem >> 4 & 1) & xorMask;
            dest[destPos + 4] = zeroMapping ^ -(elem >> 3 & 1) & xorMask;
            dest[destPos + 5] = zeroMapping ^ -(elem >> 2 & 1) & xorMask;
            dest[destPos + 6] = zeroMapping ^ -(elem >> 1 & 1) & xorMask;
            dest[destPos + 7] = zeroMapping ^ -(elem & 1) & xorMask;
        }
        if (widthRemainder === 0) continue;
        const elem = srcPos < srcLength ? src[srcPos++] : 255;
        for(let j = 0; j < widthRemainder; ++j, ++destPos)dest[destPos] = zeroMapping ^ -(elem >> 7 - j & 1) & xorMask;
    }
    return {
        srcPos: srcPos,
        destPos: destPos
    };
}
function $a2cc6e1d6eb3861b$var$convertRGBToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, destPos: destPos = 0, width: width, height: height }) {
    let i = 0;
    const len = width * height * 3;
    const len32 = len >> 2;
    const src32 = new Uint32Array(src.buffer, srcPos, len32);
    const alphaMask = $a2cc6e1d6eb3861b$var$image_utils_FeatureTest.isLittleEndian ? 0xff000000 : 0xff;
    if ($a2cc6e1d6eb3861b$var$image_utils_FeatureTest.isLittleEndian) {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i], s2 = src32[i + 1], s3 = src32[i + 2];
            dest[destPos] = s1 | alphaMask;
            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | alphaMask;
            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | alphaMask;
            dest[destPos + 3] = s3 >>> 8 | alphaMask;
        }
        for(let j = i * 4, jj = srcPos + len; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | alphaMask;
    } else {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i], s2 = src32[i + 1], s3 = src32[i + 2];
            dest[destPos] = s1 | alphaMask;
            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | alphaMask;
            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | alphaMask;
            dest[destPos + 3] = s3 << 8 | alphaMask;
        }
        for(let j = i * 4, jj = srcPos + len; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | alphaMask;
    }
    return {
        srcPos: srcPos + len,
        destPos: destPos
    };
}
function $a2cc6e1d6eb3861b$var$grayToRGBA(src, dest) {
    if ($a2cc6e1d6eb3861b$var$image_utils_FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
}
const $a2cc6e1d6eb3861b$var$MIN_FONT_SIZE = 16;
const $a2cc6e1d6eb3861b$var$MAX_FONT_SIZE = 100;
const $a2cc6e1d6eb3861b$var$EXECUTION_TIME = 15;
const $a2cc6e1d6eb3861b$var$EXECUTION_STEPS = 10;
const $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT = 16;
const $a2cc6e1d6eb3861b$var$SCALE_MATRIX = new DOMMatrix();
const $a2cc6e1d6eb3861b$var$XY = new Float32Array(2);
function $a2cc6e1d6eb3861b$var$mirrorContextOperations(ctx, destCtx) {
    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
    const originalMethods = new Map();
    for (const name of [
        "save",
        "restore",
        "rotate",
        "scale",
        "translate",
        "transform",
        "setTransform",
        "resetTransform",
        "clip",
        "moveTo",
        "lineTo",
        "bezierCurveTo",
        "quadraticCurveTo",
        "arc",
        "arcTo",
        "ellipse",
        "rect",
        "roundRect",
        "closePath",
        "beginPath"
    ]){
        const original = ctx[name];
        if (typeof original !== "function" || typeof destCtx[name] !== "function") continue;
        originalMethods.set(name, original);
        ctx[name] = function(...args) {
            destCtx[name](...args);
            return original.apply(this, args);
        };
    }
    ctx._removeMirroring = ()=>{
        for (const [name, original] of originalMethods)ctx[name] = original;
        delete ctx._removeMirroring;
    };
}
function $a2cc6e1d6eb3861b$var$drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
    const [a, b, c, d, tx, ty] = $a2cc6e1d6eb3861b$var$getCurrentTransform(ctx);
    if (b === 0 && c === 0) {
        const tlX = destX * a + tx;
        const rTlX = Math.round(tlX);
        const tlY = destY * d + ty;
        const rTlY = Math.round(tlY);
        const brX = (destX + destW) * a + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destY + destH) * d + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rWidth,
            rHeight
        ];
    }
    if (a === 0 && d === 0) {
        const tlX = destY * c + tx;
        const rTlX = Math.round(tlX);
        const tlY = destX * b + ty;
        const rTlY = Math.round(tlY);
        const brX = (destY + destH) * c + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destX + destW) * b + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rHeight,
            rWidth
        ];
    }
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
    const scaleX = Math.hypot(a, b);
    const scaleY = Math.hypot(c, d);
    return [
        scaleX * destW,
        scaleY * destH
    ];
}
class $a2cc6e1d6eb3861b$var$CanvasExtraState {
    alphaIsShape = false;
    fontSize = 0;
    fontSizeScale = 1;
    textMatrix = null;
    textMatrixScale = 1;
    fontMatrix = $a2cc6e1d6eb3861b$var$FONT_IDENTITY_MATRIX;
    leading = 0;
    x = 0;
    y = 0;
    lineX = 0;
    lineY = 0;
    charSpacing = 0;
    wordSpacing = 0;
    textHScale = 1;
    textRenderingMode = $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL;
    textRise = 0;
    fillColor = "#000000";
    strokeColor = "#000000";
    tilingPatternDims = null;
    patternFill = false;
    patternStroke = false;
    fillAlpha = 1;
    strokeAlpha = 1;
    lineWidth = 1;
    activeSMask = null;
    transferMaps = "none";
    minMax = $a2cc6e1d6eb3861b$var$F32_BBOX_INIT.slice();
    constructor(width, height){
        this.clipBox = new Float32Array([
            0,
            0,
            width,
            height
        ]);
    }
    clone() {
        const clone = Object.create(this);
        clone.clipBox = this.clipBox.slice();
        clone.minMax = this.minMax.slice();
        clone.tilingPatternDims = this.tilingPatternDims?.slice();
        return clone;
    }
    getPathBoundingBox(pathType = $a2cc6e1d6eb3861b$var$PathType.FILL, transform = null) {
        const box = this.minMax.slice();
        if (pathType === $a2cc6e1d6eb3861b$var$PathType.STROKE) {
            if (!transform) $a2cc6e1d6eb3861b$var$unreachable("Stroke bounding box must include transform.");
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, $a2cc6e1d6eb3861b$var$XY);
            const xStrokePad = $a2cc6e1d6eb3861b$var$XY[0] * this.lineWidth / 2;
            const yStrokePad = $a2cc6e1d6eb3861b$var$XY[1] * this.lineWidth / 2;
            box[0] -= xStrokePad;
            box[1] -= yStrokePad;
            box[2] += xStrokePad;
            box[3] += yStrokePad;
        }
        return box;
    }
    updateClipFromPath() {
        const intersect = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.intersect(this.clipBox, this.getPathBoundingBox());
        this.startNewPathAndClipBox(intersect || [
            0,
            0,
            0,
            0
        ]);
    }
    isEmptyClip() {
        return this.minMax[0] === Infinity;
    }
    startNewPathAndClipBox(box) {
        this.clipBox.set(box, 0);
        this.minMax.set($a2cc6e1d6eb3861b$var$F32_BBOX_INIT, 0);
    }
    getClippedPathBoundingBox(pathType = $a2cc6e1d6eb3861b$var$PathType.FILL, transform = null) {
        return $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
    }
}
function $a2cc6e1d6eb3861b$var$putBinaryImageData(ctx, imgData) {
    if (imgData instanceof ImageData) {
        ctx.putImageData(imgData, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0, destPos;
    const src = imgData.data;
    const dest = chunkImgData.data;
    let i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === $a2cc6e1d6eb3861b$export$b890e9c15247e0b3.GRAYSCALE_1BPP) {
        const srcLength = src.byteLength;
        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
        const dest32DataLength = dest32.length;
        const fullSrcDiff = width + 7 >> 3;
        const white = 0xffffffff;
        const black = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.isLittleEndian ? 0xff000000 : 0x000000ff;
        for(i = 0; i < totalChunks; i++){
            thisChunkHeight = i < fullChunks ? $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
            destPos = 0;
            for(j = 0; j < thisChunkHeight; j++){
                const srcDiff = srcLength - srcPos;
                let k = 0;
                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                const kEndUnrolled = kEnd & -8;
                let mask = 0;
                let srcByte = 0;
                for(; k < kEndUnrolled; k += 8){
                    srcByte = src[srcPos++];
                    dest32[destPos++] = srcByte & 128 ? white : black;
                    dest32[destPos++] = srcByte & 64 ? white : black;
                    dest32[destPos++] = srcByte & 32 ? white : black;
                    dest32[destPos++] = srcByte & 16 ? white : black;
                    dest32[destPos++] = srcByte & 8 ? white : black;
                    dest32[destPos++] = srcByte & 4 ? white : black;
                    dest32[destPos++] = srcByte & 2 ? white : black;
                    dest32[destPos++] = srcByte & 1 ? white : black;
                }
                for(; k < kEnd; k++){
                    if (mask === 0) {
                        srcByte = src[srcPos++];
                        mask = 128;
                    }
                    dest32[destPos++] = srcByte & mask ? white : black;
                    mask >>= 1;
                }
            }
            while(destPos < dest32DataLength)dest32[destPos++] = 0;
            ctx.putImageData(chunkImgData, 0, i * $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT);
        }
    } else if (imgData.kind === $a2cc6e1d6eb3861b$export$b890e9c15247e0b3.RGBA_32BPP) {
        j = 0;
        elemsInThisChunk = width * $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT * 4;
        for(i = 0; i < fullChunks; i++){
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            srcPos += elemsInThisChunk;
            ctx.putImageData(chunkImgData, 0, j);
            j += $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT;
        }
        if (i < totalChunks) {
            elemsInThisChunk = width * partialChunkHeight * 4;
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            ctx.putImageData(chunkImgData, 0, j);
        }
    } else if (imgData.kind === $a2cc6e1d6eb3861b$export$b890e9c15247e0b3.RGB_24BPP) {
        thisChunkHeight = $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT;
        elemsInThisChunk = width * thisChunkHeight;
        for(i = 0; i < totalChunks; i++){
            if (i >= fullChunks) {
                thisChunkHeight = partialChunkHeight;
                elemsInThisChunk = width * thisChunkHeight;
            }
            destPos = 0;
            for(j = elemsInThisChunk; j--;){
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = 255;
            }
            ctx.putImageData(chunkImgData, 0, i * $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT);
        }
    } else throw new Error(`bad image kind: ${imgData.kind}`);
}
function $a2cc6e1d6eb3861b$var$putBinaryImageMask(ctx, imgData) {
    if (imgData.bitmap) {
        ctx.drawImage(imgData.bitmap, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0;
    const src = imgData.data;
    const dest = chunkImgData.data;
    for(let i = 0; i < totalChunks; i++){
        const thisChunkHeight = i < fullChunks ? $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
        ({ srcPos: srcPos } = $a2cc6e1d6eb3861b$var$convertBlackAndWhiteToRGBA({
            src: src,
            srcPos: srcPos,
            dest: dest,
            width: width,
            height: thisChunkHeight,
            nonBlackColor: 0
        }));
        ctx.putImageData(chunkImgData, 0, i * $a2cc6e1d6eb3861b$var$FULL_CHUNK_HEIGHT);
    }
}
function $a2cc6e1d6eb3861b$var$copyCtxState(sourceCtx, destCtx) {
    const properties = [
        "strokeStyle",
        "fillStyle",
        "fillRule",
        "globalAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "globalCompositeOperation",
        "font",
        "filter"
    ];
    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
    if (sourceCtx.setLineDash !== undefined) {
        destCtx.setLineDash(sourceCtx.getLineDash());
        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
}
function $a2cc6e1d6eb3861b$var$resetCtxToDefault(ctx) {
    ctx.strokeStyle = ctx.fillStyle = "#000000";
    ctx.fillRule = "nonzero";
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = "butt";
    ctx.lineJoin = "miter";
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = "source-over";
    ctx.font = "10px sans-serif";
    if (ctx.setLineDash !== undefined) {
        ctx.setLineDash([]);
        ctx.lineDashOffset = 0;
    }
    const { filter: filter } = ctx;
    if (filter !== "none" && filter !== "") ctx.filter = "none";
}
function $a2cc6e1d6eb3861b$var$getImageSmoothingEnabled(transform, interpolate) {
    if (interpolate) return true;
    $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, $a2cc6e1d6eb3861b$var$XY);
    const actualScale = Math.fround($a2cc6e1d6eb3861b$export$f16a99f63bccd50b.pixelRatio * $a2cc6e1d6eb3861b$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
    return $a2cc6e1d6eb3861b$var$XY[0] <= actualScale && $a2cc6e1d6eb3861b$var$XY[1] <= actualScale;
}
const $a2cc6e1d6eb3861b$var$LINE_CAP_STYLES = [
    "butt",
    "round",
    "square"
];
const $a2cc6e1d6eb3861b$var$LINE_JOIN_STYLES = [
    "miter",
    "round",
    "bevel"
];
const $a2cc6e1d6eb3861b$var$NORMAL_CLIP = {};
const $a2cc6e1d6eb3861b$var$EO_CLIP = {};
class $a2cc6e1d6eb3861b$var$CanvasGraphics {
    #knockoutGroupLevel = 0;
    #knockoutElementDepth = 0;
    #knockoutTempCanvasEntry = null;
    #knockoutSavedCtx = null;
    #knockoutSavedSMaskCtx = null;
    #knockoutSavedGCO = null;
    #knockoutElementAlpha = 1;
    #knockoutFilterCache;
    #knockoutElementGroupMeta = null;
    #groupStackMeta = [];
    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig: optionalContentConfig, markedContentStack: markedContentStack = null }, annotationCanvasMap, pageColors, dependencyTracker, imagesTracker){
        this.ctx = canvasCtx;
        this.current = new $a2cc6e1d6eb3861b$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.stateStack = [];
        this.pendingClip = null;
        this.pendingEOFill = false;
        this.commonObjs = commonObjs;
        this.objs = objs;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this.groupStack = [];
        this.baseTransform = null;
        this.baseTransformStack = [];
        this.groupLevel = 0;
        this.smaskStack = [];
        this.tempSMask = null;
        this.smaskGroupCanvases = [];
        this.smaskPreparedEntry = null;
        this.smaskPreparedFor = null;
        this.smaskPreparedOffsetX = 0;
        this.smaskPreparedOffsetY = 0;
        this.smaskPreparedOOBAlpha = null;
        this.suspendedCtx = null;
        this.contentVisible = true;
        this.markedContentStack = markedContentStack || [];
        this.optionalContentConfig = optionalContentConfig;
        this.cachedPatterns = new Map();
        this.annotationCanvasMap = annotationCanvasMap;
        this.viewportScale = 1;
        this.outputScaleX = 1;
        this.outputScaleY = 1;
        this.pageColors = pageColors;
        this._cachedScaleForStroking = [
            -1,
            0
        ];
        this._cachedGetSinglePixelWidth = null;
        this._cachedBitmapsMap = new Map();
        this.dependencyTracker = dependencyTracker ?? null;
        this.imagesTracker = imagesTracker ?? null;
    }
    getObject(opIdx, data, fallback = null) {
        if (typeof data === "string") {
            this.dependencyTracker?.recordNamedDependency(opIdx, data);
            return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
        }
        return fallback;
    }
    beginDrawing({ transform: transform, viewport: viewport, transparency: transparency = false, background: background = null }) {
        const width = this.ctx.canvas.width;
        const height = this.ctx.canvas.height;
        const savedFillStyle = this.ctx.fillStyle;
        this.ctx.fillStyle = background || "#ffffff";
        this.ctx.fillRect(0, 0, width, height);
        this.ctx.fillStyle = savedFillStyle;
        if (transparency) {
            const transparentCanvas = this.transparentCanvasEntry = this.canvasFactory.create(width, height);
            this.compositeCtx = this.ctx;
            ({ canvas: this.transparentCanvas, context: this.ctx } = transparentCanvas);
            this.ctx.save();
            this.ctx.transform(...$a2cc6e1d6eb3861b$var$getCurrentTransform(this.compositeCtx));
        }
        this.ctx.save();
        $a2cc6e1d6eb3861b$var$resetCtxToDefault(this.ctx);
        if (transform) {
            this.ctx.transform(...transform);
            this.outputScaleX = transform[0];
            this.outputScaleY = transform[3];
        }
        this.ctx.transform(...viewport.transform);
        this.viewportScale = viewport.scale;
        this.baseTransform = $a2cc6e1d6eb3861b$var$getCurrentTransform(this.ctx);
    }
    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper, operationsFilter) {
        const argsArray = operatorList.argsArray;
        const fnArray = operatorList.fnArray;
        let i = executionStartIdx || 0;
        const argsArrayLen = argsArray.length;
        if (argsArrayLen === i) return i;
        const chunkOperations = argsArrayLen - i > $a2cc6e1d6eb3861b$var$EXECUTION_STEPS && typeof continueCallback === "function";
        const endTime = chunkOperations ? Date.now() + $a2cc6e1d6eb3861b$var$EXECUTION_TIME : 0;
        let steps = 0;
        const commonObjs = this.commonObjs;
        const objs = this.objs;
        let fnId, fnArgs;
        while(true){
            if (stepper !== undefined) {
                if (i === stepper.nextBreakPoint) {
                    stepper.breakIt(i, continueCallback);
                    return i;
                }
                if (stepper.shouldSkip(i)) {
                    if (++i === argsArrayLen) return i;
                    continue;
                }
            }
            if (!operationsFilter || operationsFilter(i)) {
                fnId = fnArray[i];
                fnArgs = argsArray[i] ?? null;
                if (fnId !== $a2cc6e1d6eb3861b$export$3a0f7f7a8a0b306b.dependency) {
                    if (fnArgs === null) this[fnId](i);
                    else this[fnId](i, ...fnArgs);
                } else for (const depObjId of fnArgs){
                    this.dependencyTracker?.recordNamedData(depObjId, i);
                    const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                    if (!objsPool.has(depObjId)) {
                        objsPool.get(depObjId, continueCallback);
                        return i;
                    }
                }
            }
            i++;
            if (i === argsArrayLen) return i;
            if (chunkOperations && ++steps > $a2cc6e1d6eb3861b$var$EXECUTION_STEPS) {
                if (Date.now() > endTime) {
                    continueCallback();
                    return i;
                }
                steps = 0;
            }
        }
    }
    #restoreInitialState() {
        while(this.stateStack.length || this.inSMaskMode)this.restore();
        this.current.activeSMask = null;
        this.ctx.restore();
        if (this.transparentCanvas) {
            this.ctx = this.compositeCtx;
            this.ctx.save();
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
            this.ctx.drawImage(this.transparentCanvas, 0, 0);
            this.ctx.restore();
            this.canvasFactory.destroy(this.transparentCanvasEntry);
            this.transparentCanvas = null;
            this.transparentCanvasEntry = null;
        }
    }
    endDrawing() {
        this.#restoreInitialState();
        for (const canvas of this.smaskGroupCanvases)this.canvasFactory.destroy(canvas);
        this.smaskGroupCanvases.length = 0;
        this._clearPreparedSMask();
        this.tempSMask = null;
        this.smaskStack.length = 0;
        for (const meta of this.#groupStackMeta)this.#destroyKnockoutPools(meta);
        this.#groupStackMeta.length = 0;
        this.#knockoutTempCanvasEntry = null;
        this.#knockoutSavedCtx = null;
        this.#knockoutSavedSMaskCtx = null;
        this.#knockoutSavedGCO = null;
        this.#knockoutElementAlpha = 1;
        this.#knockoutElementGroupMeta = null;
        this.#knockoutElementDepth = 0;
        this.#knockoutGroupLevel = 0;
        this.cachedPatterns.clear();
        for (const cache of this._cachedBitmapsMap.values()){
            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
            cache.clear();
        }
        this._cachedBitmapsMap.clear();
        this.#drawFilter();
    }
    #drawFilter() {
        if (this.pageColors) {
            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
            if (hcmFilterId !== "none") {
                const savedFilter = this.ctx.filter;
                this.ctx.filter = hcmFilterId;
                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                this.ctx.filter = savedFilter;
            }
        }
    }
    _scaleImage(img, inverseTransform) {
        const width = img.width ?? img.displayWidth;
        const height = img.height ?? img.displayHeight;
        const widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
        const heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
        const scaleSteps = [];
        let ws = widthScale, hs = heightScale, pw = width, ph = height;
        while(ws > 2 && pw > 1 || hs > 2 && ph > 1){
            let nw = pw, nh = ph;
            if (ws > 2 && pw > 1) {
                nw = Math.ceil(pw / 2);
                ws /= pw / nw;
            }
            if (hs > 2 && ph > 1) {
                nh = Math.ceil(ph / 2);
                hs /= ph / nh;
            }
            scaleSteps.push({
                newWidth: nw,
                newHeight: nh
            });
            pw = nw;
            ph = nh;
        }
        if (scaleSteps.length === 0) return {
            img: img,
            paintWidth: width,
            paintHeight: height,
            tmpCanvas: null
        };
        if (scaleSteps.length === 1) {
            const { newWidth: newWidth, newHeight: newHeight } = scaleSteps[0];
            const tmpCanvas = this.canvasFactory.create(newWidth, newHeight);
            tmpCanvas.context.drawImage(img, 0, 0, width, height, 0, 0, newWidth, newHeight);
            return {
                img: tmpCanvas.canvas,
                paintWidth: newWidth,
                paintHeight: newHeight,
                tmpCanvas: tmpCanvas
            };
        }
        let readEntry = this.canvasFactory.create(1, 1);
        let writeEntry = this.canvasFactory.create(1, 1);
        let paintWidth = width, paintHeight = height;
        let source = img;
        for (const { newWidth: newWidth, newHeight: newHeight } of scaleSteps){
            this.canvasFactory.reset(writeEntry, newWidth, newHeight);
            writeEntry.context.drawImage(source, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
            [readEntry, writeEntry] = [
                writeEntry,
                readEntry
            ];
            source = readEntry.canvas;
            paintWidth = newWidth;
            paintHeight = newHeight;
        }
        this.canvasFactory.destroy(writeEntry);
        return {
            img: readEntry.canvas,
            paintWidth: paintWidth,
            paintHeight: paintHeight,
            tmpCanvas: readEntry
        };
    }
    _createMaskCanvas(opIdx, img) {
        const ctx = this.ctx;
        const { width: width, height: height } = img;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        const currentTransform = $a2cc6e1d6eb3861b$var$getCurrentTransform(ctx);
        let cache, cacheKey, scaled, maskCanvas;
        if ((img.bitmap || img.data) && img.count > 1) {
            const mainKey = img.bitmap || img.data.buffer;
            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                currentTransform.slice(0, 4),
                fillColor
            ]);
            cache = this._cachedBitmapsMap.getOrInsertComputed(mainKey, $a2cc6e1d6eb3861b$export$b41394a5437791c8);
            const cachedImage = cache.get(cacheKey);
            if (cachedImage && !isPatternFill) {
                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                this.dependencyTracker?.recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.transformAndFill);
                return {
                    canvas: cachedImage,
                    offsetX: offsetX,
                    offsetY: offsetY
                };
            }
            scaled = cachedImage;
        }
        if (!scaled) {
            maskCanvas = this.canvasFactory.create(width, height);
            $a2cc6e1d6eb3861b$var$putBinaryImageMask(maskCanvas.context, img);
        }
        let maskToCanvas = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform(currentTransform, [
            1 / width,
            0,
            0,
            -1 / height,
            0,
            0
        ]);
        maskToCanvas = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform(maskToCanvas, [
            1,
            0,
            0,
            1,
            0,
            -height
        ]);
        const minMax = $a2cc6e1d6eb3861b$var$F32_BBOX_INIT.slice();
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            0,
            0,
            width,
            height
        ], maskToCanvas, minMax);
        const [minX, minY, maxX, maxY] = minMax;
        const drawnWidth = Math.round(maxX - minX) || 1;
        const drawnHeight = Math.round(maxY - minY) || 1;
        const fillCanvas = this.canvasFactory.create(drawnWidth, drawnHeight);
        const fillCtx = fillCanvas.context;
        const offsetX = minX;
        const offsetY = minY;
        fillCtx.translate(-offsetX, -offsetY);
        fillCtx.transform(...maskToCanvas);
        let scaledEntry = null;
        if (!scaled) {
            const scaleResult = this._scaleImage(maskCanvas.canvas, $a2cc6e1d6eb3861b$var$getCurrentTransformInverse(fillCtx));
            scaled = scaleResult.img;
            scaledEntry = scaleResult.tmpCanvas;
            if (scaled !== maskCanvas.canvas) {
                this.canvasFactory.destroy(maskCanvas);
                maskCanvas = null;
            }
            if (cache && isPatternFill) {
                cache.set(cacheKey, scaled);
                scaledEntry = null;
                maskCanvas = null;
            }
        }
        fillCtx.imageSmoothingEnabled = $a2cc6e1d6eb3861b$var$getImageSmoothingEnabled($a2cc6e1d6eb3861b$var$getCurrentTransform(fillCtx), img.interpolate);
        $a2cc6e1d6eb3861b$var$drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
        if (scaledEntry) this.canvasFactory.destroy(scaledEntry);
        if (maskCanvas) this.canvasFactory.destroy(maskCanvas);
        fillCtx.globalCompositeOperation = "source-in";
        const inverse = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform($a2cc6e1d6eb3861b$var$getCurrentTransformInverse(fillCtx), [
            1,
            0,
            0,
            1,
            -offsetX,
            -offsetY
        ]);
        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, $a2cc6e1d6eb3861b$var$PathType.FILL, opIdx) : fillColor;
        fillCtx.fillRect(0, 0, width, height);
        if (cache && !isPatternFill) cache.set(cacheKey, fillCanvas.canvas);
        this.dependencyTracker?.recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.transformAndFill);
        return {
            canvas: fillCanvas.canvas,
            canvasEntry: cache && !isPatternFill ? null : fillCanvas,
            offsetX: Math.round(offsetX),
            offsetY: Math.round(offsetY)
        };
    }
    setLineWidth(opIdx, width) {
        this.dependencyTracker?.recordSimpleData("lineWidth", opIdx);
        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
        this.current.lineWidth = width;
        this.ctx.lineWidth = width;
    }
    setLineCap(opIdx, style) {
        this.dependencyTracker?.recordSimpleData("lineCap", opIdx);
        this.ctx.lineCap = $a2cc6e1d6eb3861b$var$LINE_CAP_STYLES[style];
    }
    setLineJoin(opIdx, style) {
        this.dependencyTracker?.recordSimpleData("lineJoin", opIdx);
        this.ctx.lineJoin = $a2cc6e1d6eb3861b$var$LINE_JOIN_STYLES[style];
    }
    setMiterLimit(opIdx, limit) {
        this.dependencyTracker?.recordSimpleData("miterLimit", opIdx);
        this.ctx.miterLimit = limit;
    }
    setDash(opIdx, dashArray, dashPhase) {
        this.dependencyTracker?.recordSimpleData("dash", opIdx);
        const ctx = this.ctx;
        if (ctx.setLineDash !== undefined) {
            ctx.setLineDash(dashArray);
            ctx.lineDashOffset = dashPhase;
        }
    }
    setRenderingIntent(opIdx, intent) {}
    setFlatness(opIdx, flatness) {}
    setGState(opIdx, states) {
        for (const [key, value] of states)switch(key){
            case "LW":
                this.setLineWidth(opIdx, value);
                break;
            case "LC":
                this.setLineCap(opIdx, value);
                break;
            case "LJ":
                this.setLineJoin(opIdx, value);
                break;
            case "ML":
                this.setMiterLimit(opIdx, value);
                break;
            case "D":
                this.setDash(opIdx, value[0], value[1]);
                break;
            case "RI":
                this.setRenderingIntent(opIdx, value);
                break;
            case "FL":
                this.setFlatness(opIdx, value);
                break;
            case "Font":
                this.setFont(opIdx, value[0], value[1]);
                break;
            case "CA":
                this.dependencyTracker?.recordSimpleData("strokeAlpha", opIdx);
                this.current.strokeAlpha = value;
                break;
            case "ca":
                this.dependencyTracker?.recordSimpleData("fillAlpha", opIdx);
                this.ctx.globalAlpha = this.current.fillAlpha = value;
                break;
            case "BM":
                this.dependencyTracker?.recordSimpleData("globalCompositeOperation", opIdx);
                this.ctx.globalCompositeOperation = value;
                break;
            case "SMask":
                this.dependencyTracker?.recordSimpleData("SMask", opIdx);
                this.current.activeSMask = value ? this.tempSMask : null;
                if (this.current.activeSMask) this.current.activeSMask.blendMode = this.ctx.globalCompositeOperation;
                this.tempSMask = null;
                this.checkSMaskState(opIdx);
                break;
            case "TR":
                this.dependencyTracker?.recordSimpleData("filter", opIdx);
                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                break;
        }
    }
    get inSMaskMode() {
        return !!this.suspendedCtx;
    }
    _clearPreparedSMask() {
        if (this.smaskPreparedEntry) {
            this.canvasFactory.destroy(this.smaskPreparedEntry);
            this.smaskPreparedEntry = null;
        }
        this.smaskPreparedFor = null;
        this.smaskPreparedOffsetX = 0;
        this.smaskPreparedOffsetY = 0;
        this.smaskPreparedOOBAlpha = null;
    }
    _ensurePreparedSMask(smask) {
        if (smask === this.smaskPreparedFor) return;
        this._clearPreparedSMask();
        this._prepareSMaskCanvas(smask);
    }
    checkSMaskState(opIdx) {
        const inSMaskMode = this.inSMaskMode;
        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode(opIdx);
        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
        else if (this.current.activeSMask && inSMaskMode) this._ensurePreparedSMask(this.current.activeSMask);
    }
    _prepareSMaskCanvas(smask) {
        const { canvas: maskCanvas, subtype: subtype, backdrop: backdrop, transferMap: transferMap } = smask;
        const hasFilter = subtype === "Luminosity" || subtype === "Alpha" && transferMap;
        if (!hasFilter && !(subtype === "Luminosity" && backdrop)) {
            this.smaskPreparedFor = smask;
            return;
        }
        let filteredOOBAlpha;
        if (subtype === "Luminosity" && backdrop) {
            const [r, g, b] = $a2cc6e1d6eb3861b$export$c24a0a5c5129b2e1(backdrop);
            const inputAlpha = Math.round(0.3 * r + 0.59 * g + 0.11 * b);
            filteredOOBAlpha = transferMap?.[inputAlpha] ?? inputAlpha;
        } else filteredOOBAlpha = transferMap?.[0] ?? 0;
        const SMASK_LAYER_TO_MASK_AREA_RATIO = 4;
        const { width: layerW, height: layerH } = this.ctx.canvas;
        const maskArea = maskCanvas.width * maskCanvas.height;
        const useLayerSize = layerW * layerH < SMASK_LAYER_TO_MASK_AREA_RATIO * maskArea;
        const filterSpec = hasFilter ? {
            url: subtype === "Alpha" ? this.filterFactory.addAlphaFilter(transferMap) : this.filterFactory.addLuminosityFilter(transferMap),
            subtype: subtype,
            transferMap: transferMap
        } : null;
        const bakedBackdrop = subtype === "Luminosity" ? backdrop : null;
        let preparedEntry, offsetX, offsetY;
        if (useLayerSize) {
            preparedEntry = this._bakeSMaskCanvas(maskCanvas, smask.offsetX, smask.offsetY, layerW, layerH, bakedBackdrop, filterSpec);
            offsetX = 0;
            offsetY = 0;
        } else {
            preparedEntry = this._bakeSMaskCanvas(maskCanvas, 0, 0, maskCanvas.width, maskCanvas.height, bakedBackdrop, filterSpec);
            offsetX = smask.offsetX;
            offsetY = smask.offsetY;
        }
        this.smaskPreparedEntry = preparedEntry;
        this.smaskPreparedFor = smask;
        this.smaskPreparedOffsetX = offsetX;
        this.smaskPreparedOffsetY = offsetY;
        this.smaskPreparedOOBAlpha = !useLayerSize && filteredOOBAlpha !== 0 ? filteredOOBAlpha : null;
    }
    _bakeSMaskCanvas(maskCanvas, drawX, drawY, w, h, backdrop, filterSpec) {
        if (!backdrop && !filterSpec) $a2cc6e1d6eb3861b$var$unreachable("_bakeSMaskCanvas with neither backdrop nor filter");
        const srcEntry = this.canvasFactory.create(w, h);
        const sCtx = srcEntry.context;
        sCtx.drawImage(maskCanvas, drawX, drawY);
        if (backdrop) {
            sCtx.globalCompositeOperation = "destination-atop";
            sCtx.fillStyle = backdrop;
            sCtx.fillRect(0, 0, w, h);
        }
        if (!filterSpec) return srcEntry;
        const preparedEntry = this.canvasFactory.create(w, h);
        const pCtx = preparedEntry.context;
        pCtx.filter = filterSpec.url;
        const filterApplied = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.isCanvasFilterSupported && pCtx.filter !== "none" && pCtx.filter !== "";
        pCtx.drawImage(srcEntry.canvas, 0, 0);
        if ($a2cc6e1d6eb3861b$export$5fb8891d35c36978.isCanvasFilterSupported) pCtx.filter = "none";
        if (!filterApplied) {
            const img = pCtx.getImageData(0, 0, w, h);
            const { data: data } = img;
            const { transferMap: transferMap } = filterSpec;
            if (filterSpec.subtype === "Luminosity") for(let i = 0, ii = data.length; i < ii; i += 4){
                const a = 0.3 * data[i] + 0.59 * data[i + 1] + 0.11 * data[i + 2] + 0.5 | 0;
                data[i] = data[i + 1] = data[i + 2] = 0;
                data[i + 3] = transferMap?.[a] ?? a;
            }
            else for(let i = 3, ii = data.length; i < ii; i += 4)data[i] = transferMap[data[i]];
            pCtx.putImageData(img, 0, 0);
        }
        this.canvasFactory.destroy(srcEntry);
        return preparedEntry;
    }
    beginSMaskMode(opIdx) {
        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
        const { width: drawnWidth, height: drawnHeight } = this.ctx.canvas;
        const scratchCanvas = this.canvasFactory.create(drawnWidth, drawnHeight);
        this.smaskScratchCanvas = scratchCanvas;
        this.suspendedCtx = this.ctx;
        const ctx = this.ctx = scratchCanvas.context;
        ctx.setTransform(this.suspendedCtx.getTransform());
        $a2cc6e1d6eb3861b$var$copyCtxState(this.suspendedCtx, ctx);
        $a2cc6e1d6eb3861b$var$mirrorContextOperations(ctx, this.suspendedCtx);
        this._ensurePreparedSMask(this.current.activeSMask);
        this.setGState(opIdx, [
            [
                "BM",
                "source-over"
            ]
        ]);
    }
    endSMaskMode() {
        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
        this.ctx._removeMirroring();
        $a2cc6e1d6eb3861b$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx = this.suspendedCtx;
        this.suspendedCtx = null;
        this.canvasFactory.destroy(this.smaskScratchCanvas);
        this.smaskScratchCanvas = null;
        this._clearPreparedSMask();
    }
    #createKnockoutMaskCanvas(sourceCanvas, reuseEntry = null, alpha = 1) {
        const { width: width, height: height } = sourceCanvas;
        const maskEntry = reuseEntry ?? this.canvasFactory.create(width, height);
        const maskCtx = maskEntry.context;
        alpha = Math.round(alpha * 255) / 255;
        const needsAlphaScaling = alpha < 1;
        if (needsAlphaScaling && this.#knockoutFilterCache === undefined) this.#knockoutFilterCache = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.isCanvasFilterSupported ? new Map() : "none";
        let knockoutFilter = "none";
        if (needsAlphaScaling && this.#knockoutFilterCache instanceof Map) {
            knockoutFilter = this.#knockoutFilterCache.get(alpha);
            if (!knockoutFilter) {
                knockoutFilter = this.filterFactory.addKnockoutFilter(alpha);
                this.#knockoutFilterCache.set(alpha, knockoutFilter);
            }
        }
        if (!needsAlphaScaling || knockoutFilter !== "none") {
            if (reuseEntry) {
                maskCtx.save();
                maskCtx.setTransform(1, 0, 0, 1, 0, 0);
                maskCtx.clearRect(0, 0, width, height);
                maskCtx.restore();
            }
            maskCtx.filter = knockoutFilter;
            maskCtx.drawImage(sourceCanvas, 0, 0);
            maskCtx.filter = "none";
            return maskEntry;
        }
        const sourceData = sourceCanvas.getContext("2d", {
            willReadFrequently: true
        }).getImageData(0, 0, width, height);
        const maskData = maskCtx.createImageData(width, height);
        const sourcePixels = sourceData.data, maskPixels = maskData.data;
        const alphaScale = alpha > 0 ? 1 / alpha : 1e6;
        for(let i = 3, ii = sourcePixels.length; i < ii; i += 4)maskPixels[i] = Math.min(Math.round(sourcePixels[i] * alphaScale), 255);
        maskCtx.putImageData(maskData, 0, 0);
        return maskEntry;
    }
    #getOrCreatePooledEntry(meta, key, width, height) {
        let entry = meta?.[key] ?? null;
        if (entry && (entry.canvas.width !== width || entry.canvas.height !== height)) {
            this.canvasFactory.destroy(entry);
            entry = null;
        }
        if (!entry) {
            entry = this.canvasFactory.create(width, height);
            if (meta) meta[key] = entry;
            return entry;
        }
        const ctx = entry.context;
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, width, height);
        ctx.restore();
        return entry;
    }
    #compositeKnockoutSurface(destCtx, surfaceCanvas, options = {}) {
        const { backdropCanvas: backdropCanvas = null, destTransform: destTransform = [
            1,
            0,
            0,
            1,
            0,
            0
        ], backdropOffset: backdropOffset = [
            0,
            0
        ], reuseMaskEntry: reuseMaskEntry = null, poolMeta: poolMeta = null, sourceAlpha: sourceAlpha = 1, sourceFilter: sourceFilter = "none", knockoutAlpha: knockoutAlpha = 1 } = options;
        const { width: width, height: height } = surfaceCanvas;
        const knockoutMaskEntry = this.#createKnockoutMaskCanvas(surfaceCanvas, reuseMaskEntry, knockoutAlpha);
        const sourceCompositeOperation = destCtx.globalCompositeOperation;
        destCtx.save();
        destCtx.setTransform(...destTransform);
        destCtx.globalAlpha = 1;
        if ($a2cc6e1d6eb3861b$export$5fb8891d35c36978.isCanvasFilterSupported) destCtx.filter = "none";
        destCtx.globalCompositeOperation = "destination-out";
        destCtx.drawImage(knockoutMaskEntry.canvas, 0, 0);
        if (backdropCanvas) {
            const [bx, by] = backdropOffset;
            const backdropEntry = this.#getOrCreatePooledEntry(poolMeta, "knockoutBackdropEntry", width, height);
            const backdropCtx = backdropEntry.context;
            backdropCtx.drawImage(backdropCanvas, bx, by, width, height, 0, 0, width, height);
            backdropCtx.globalCompositeOperation = "destination-in";
            backdropCtx.drawImage(knockoutMaskEntry.canvas, 0, 0);
            backdropCtx.globalCompositeOperation = "source-over";
            destCtx.globalCompositeOperation = "destination-over";
            destCtx.drawImage(backdropEntry.canvas, 0, 0);
            if (!poolMeta) this.canvasFactory.destroy(backdropEntry);
        }
        destCtx.globalCompositeOperation = sourceCompositeOperation;
        destCtx.globalAlpha = sourceAlpha;
        if ($a2cc6e1d6eb3861b$export$5fb8891d35c36978.isCanvasFilterSupported) destCtx.filter = sourceFilter ?? "none";
        destCtx.drawImage(surfaceCanvas, 0, 0);
        destCtx.restore();
        if (!reuseMaskEntry) this.canvasFactory.destroy(knockoutMaskEntry);
    }
    #beginKnockoutElement(alpha = 1) {
        if (this.#knockoutGroupLevel === 0 || this.#knockoutElementDepth > 0 || !this.contentVisible) return false;
        this.#knockoutElementDepth++;
        this.#knockoutElementAlpha = alpha;
        const groupMeta = this.#groupStackMeta.at(-1);
        const { canvas: canvas } = this.ctx;
        const tempEntry = this.#getOrCreatePooledEntry(groupMeta, "knockoutTempEntry", canvas.width, canvas.height);
        this.#knockoutTempCanvasEntry = tempEntry;
        const tempCtx = tempEntry.context;
        tempCtx.save();
        tempCtx.setTransform(this.ctx.getTransform());
        $a2cc6e1d6eb3861b$var$copyCtxState(this.ctx, tempCtx);
        this.#knockoutSavedGCO = tempCtx.globalCompositeOperation;
        tempCtx.globalCompositeOperation = "source-over";
        $a2cc6e1d6eb3861b$var$mirrorContextOperations(tempCtx, this.ctx);
        this.#knockoutElementGroupMeta = groupMeta;
        this.#knockoutSavedCtx = this.ctx;
        this.#knockoutSavedSMaskCtx = this.suspendedCtx;
        this.ctx = tempCtx;
        if (this.inSMaskMode) this.suspendedCtx = tempCtx;
        return true;
    }
    #endKnockoutElement(started) {
        if (!started) return;
        const tempEntry = this.#knockoutTempCanvasEntry;
        const savedCtx = this.#knockoutSavedCtx;
        const savedSMaskCtx = this.#knockoutSavedSMaskCtx;
        const tempCtx = tempEntry.context;
        this.#knockoutTempCanvasEntry = null;
        this.#knockoutSavedCtx = null;
        this.#knockoutSavedSMaskCtx = null;
        if (this.inSMaskMode && this.suspendedCtx === tempCtx && this.ctx !== tempCtx) this.endSMaskMode();
        if (this.inSMaskMode) this.suspendedCtx = savedSMaskCtx;
        this.ctx._removeMirroring();
        this.ctx.globalCompositeOperation = this.#knockoutSavedGCO;
        this.#knockoutSavedGCO = null;
        $a2cc6e1d6eb3861b$var$copyCtxState(this.ctx, savedCtx);
        this.ctx = savedCtx;
        const groupMeta = this.#knockoutElementGroupMeta;
        this.#knockoutElementGroupMeta = null;
        const knockoutAlpha = this.#knockoutElementAlpha;
        this.#knockoutElementAlpha = 1;
        try {
            this.#compositeKnockoutSurface(savedSMaskCtx ?? savedCtx, tempEntry.canvas, {
                backdropCanvas: groupMeta?.backdropCtx?.canvas ?? null,
                backdropOffset: groupMeta?.backdropCtx ? [
                    groupMeta.offsetX,
                    groupMeta.offsetY
                ] : [
                    0,
                    0
                ],
                reuseMaskEntry: groupMeta?.knockoutMaskEntry ?? null,
                poolMeta: groupMeta,
                knockoutAlpha: knockoutAlpha
            });
        } finally{
            tempCtx.restore();
            this.#knockoutElementDepth--;
            if (!groupMeta) this.canvasFactory.destroy(tempEntry);
        }
    }
    compose(dirtyBox) {
        if (!this.current.activeSMask) return;
        dirtyBox = dirtyBox ? [
            Math.floor(dirtyBox[0]),
            Math.floor(dirtyBox[1]),
            Math.ceil(dirtyBox[2]),
            Math.ceil(dirtyBox[3])
        ] : [
            0,
            0,
            this.ctx.canvas.width,
            this.ctx.canvas.height
        ];
        const smask = this.current.activeSMask;
        const suspendedCtx = this.suspendedCtx;
        const applySMaskInPlace = this.#knockoutElementDepth > 0 && suspendedCtx === this.ctx;
        this.composeSMask(applySMaskInPlace ? null : suspendedCtx, smask, this.ctx, dirtyBox);
        if (applySMaskInPlace) return;
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        this.ctx.restore();
    }
    composeSMask(ctx, smask, layerCtx, layerBox) {
        const layerOffsetX = layerBox[0];
        const layerOffsetY = layerBox[1];
        const layerWidth = layerBox[2] - layerOffsetX;
        const layerHeight = layerBox[3] - layerOffsetY;
        if (layerWidth === 0 || layerHeight === 0) return;
        const preparedEntry = this.smaskPreparedEntry;
        if (preparedEntry) {
            let clipX = layerOffsetX;
            let clipY = layerOffsetY;
            let clipW = layerWidth;
            let clipH = layerHeight;
            const oobAlpha = this.smaskPreparedOOBAlpha;
            const hasOOBAlpha = oobAlpha !== null;
            if (hasOOBAlpha) {
                clipX = Math.max(layerOffsetX, smask.offsetX);
                clipY = Math.max(layerOffsetY, smask.offsetY);
                const x1 = Math.min(layerOffsetX + layerWidth, smask.offsetX + smask.canvas.width);
                const y1 = Math.min(layerOffsetY + layerHeight, smask.offsetY + smask.canvas.height);
                clipW = x1 - clipX;
                clipH = y1 - clipY;
            }
            if (clipW > 0 && clipH > 0) {
                const srcX = clipX - this.smaskPreparedOffsetX;
                const srcY = clipY - this.smaskPreparedOffsetY;
                layerCtx.save();
                layerCtx.globalAlpha = 1;
                layerCtx.setTransform(1, 0, 0, 1, 0, 0);
                const clip = new Path2D();
                clip.rect(clipX, clipY, clipW, clipH);
                layerCtx.clip(clip);
                layerCtx.globalCompositeOperation = "destination-in";
                layerCtx.drawImage(preparedEntry.canvas, srcX, srcY, clipW, clipH, clipX, clipY, clipW, clipH);
                layerCtx.restore();
            }
            if (hasOOBAlpha && oobAlpha < 255) this._applySMaskOOBAlpha(layerCtx, layerOffsetX, layerOffsetY, layerWidth, layerHeight, clipX, clipY, clipX + clipW, clipY + clipH, oobAlpha);
        } else this.genericComposeSMask(smask, layerCtx, layerWidth, layerHeight, layerOffsetX, layerOffsetY);
        if (!ctx) return;
        ctx.save();
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = smask.blendMode || "source-over";
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(layerCtx.canvas, layerOffsetX, layerOffsetY, layerWidth, layerHeight, layerOffsetX, layerOffsetY, layerWidth, layerHeight);
        ctx.restore();
    }
    _applySMaskOOBAlpha(layerCtx, layerOffsetX, layerOffsetY, layerWidth, layerHeight, maskX0, maskY0, maskX1, maskY1, alpha) {
        const hasInnerCutout = maskX0 < maskX1 && maskY0 < maskY1;
        if (hasInnerCutout && maskX0 === layerOffsetX && maskY0 === layerOffsetY && maskX1 === layerOffsetX + layerWidth && maskY1 === layerOffsetY + layerHeight) return;
        const path = new Path2D();
        path.rect(layerOffsetX, layerOffsetY, layerWidth, layerHeight);
        if (hasInnerCutout) path.rect(maskX0, maskY0, maskX1 - maskX0, maskY1 - maskY0);
        layerCtx.save();
        layerCtx.globalAlpha = alpha / 255;
        layerCtx.setTransform(1, 0, 0, 1, 0, 0);
        layerCtx.clip(path, "evenodd");
        layerCtx.globalCompositeOperation = "destination-in";
        layerCtx.fillStyle = "#000000";
        layerCtx.fillRect(layerOffsetX, layerOffsetY, layerWidth, layerHeight);
        layerCtx.restore();
    }
    genericComposeSMask(smask, layerCtx, width, height, layerOffsetX, layerOffsetY) {
        const { context: maskCtx, offsetX: maskOffsetX, offsetY: maskOffsetY } = smask;
        layerCtx.save();
        layerCtx.globalAlpha = 1;
        layerCtx.setTransform(1, 0, 0, 1, 0, 0);
        const clip = new Path2D();
        clip.rect(layerOffsetX, layerOffsetY, width, height);
        layerCtx.clip(clip);
        layerCtx.globalCompositeOperation = "destination-in";
        layerCtx.drawImage(maskCtx.canvas, layerOffsetX - maskOffsetX, layerOffsetY - maskOffsetY, width, height, layerOffsetX, layerOffsetY, width, height);
        layerCtx.restore();
    }
    save(opIdx) {
        if (this.inSMaskMode) $a2cc6e1d6eb3861b$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx.save();
        const old = this.current;
        this.stateStack.push(old);
        this.current = old.clone();
        this.dependencyTracker?.save(opIdx);
    }
    restore(opIdx) {
        this.dependencyTracker?.restore(opIdx);
        if (this.stateStack.length === 0) {
            if (this.inSMaskMode) this.endSMaskMode();
            return;
        }
        this.current = this.stateStack.pop();
        this.ctx.restore();
        if (this.inSMaskMode) {
            $a2cc6e1d6eb3861b$var$copyCtxState(this.suspendedCtx, this.ctx);
            this.ctx.setTransform(this.suspendedCtx.getTransform());
        }
        this.checkSMaskState(opIdx);
        this.pendingClip = null;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    transform(opIdx, a, b, c, d, e, f) {
        this.dependencyTracker?.recordIncrementalData("transform", opIdx);
        this.ctx.transform(a, b, c, d, e, f);
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    constructPath(opIdx, op, data, minMax) {
        let [path] = data;
        if (!minMax) {
            path ||= data[0] = new Path2D();
            if (op !== $a2cc6e1d6eb3861b$export$3a0f7f7a8a0b306b.stroke && op !== $a2cc6e1d6eb3861b$export$3a0f7f7a8a0b306b.closeStroke) this.current.tilingPatternDims = null;
            this[op](opIdx, path);
            return;
        }
        if (this.dependencyTracker !== null) {
            const outerExtraSize = op === $a2cc6e1d6eb3861b$export$3a0f7f7a8a0b306b.stroke ? this.current.lineWidth / 2 : 0;
            this.dependencyTracker.resetBBox(opIdx).recordBBox(opIdx, this.ctx, minMax[0] - outerExtraSize, minMax[2] + outerExtraSize, minMax[1] - outerExtraSize, minMax[3] + outerExtraSize).recordDependencies(opIdx, [
                "transform"
            ]);
        }
        if (!(path instanceof Path2D)) path = data[0] = $a2cc6e1d6eb3861b$var$makePathFromDrawOPS(path);
        $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(minMax, $a2cc6e1d6eb3861b$var$getCurrentTransform(this.ctx), this.current.minMax);
        const tilingDims = this.current.tilingPatternDims;
        if (tilingDims && op !== $a2cc6e1d6eb3861b$export$3a0f7f7a8a0b306b.stroke && op !== $a2cc6e1d6eb3861b$export$3a0f7f7a8a0b306b.closeStroke && this.current.fillColor instanceof $a2cc6e1d6eb3861b$var$TilingPattern) {
            const clippedBBox = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.intersect(this.current.clipBox, this.current.minMax);
            if (!clippedBBox) this.current.tilingPatternDims = null;
            else this.current.fillColor.updatePatternDims(clippedBBox, tilingDims);
        }
        this[op](opIdx, path);
        this._pathStartIdx = opIdx;
    }
    closePath(opIdx) {
        this.ctx.closePath();
    }
    stroke(opIdx, path, consumePath = true) {
        const started = consumePath && this.#beginKnockoutElement(this.current.strokeAlpha);
        const ctx = this.ctx;
        const strokeColor = this.current.strokeColor;
        ctx.globalAlpha = this.current.strokeAlpha;
        if (this.contentVisible) {
            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                const baseTransform = strokeColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
                ctx.save();
                ctx.strokeStyle = strokeColor.getPattern(ctx, this, $a2cc6e1d6eb3861b$var$getCurrentTransformInverse(ctx), $a2cc6e1d6eb3861b$var$PathType.STROKE, opIdx);
                if (baseTransform) {
                    const newPath = new Path2D();
                    newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                    path = newPath;
                }
                this.rescaleAndStroke(path, false);
                ctx.restore();
            } else this.rescaleAndStroke(path, true);
        }
        this.dependencyTracker?.recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.stroke);
        if (consumePath) this.consumePath(opIdx, path, this.current.getClippedPathBoundingBox($a2cc6e1d6eb3861b$var$PathType.STROKE, $a2cc6e1d6eb3861b$var$getCurrentTransform(this.ctx)));
        ctx.globalAlpha = this.current.fillAlpha;
        this.#endKnockoutElement(started);
    }
    closeStroke(opIdx, path) {
        this.stroke(opIdx, path);
    }
    fill(opIdx, path, consumePath = true) {
        const started = consumePath && this.#beginKnockoutElement(this.current.fillAlpha);
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        let needRestore = false;
        const intersect = this.current.getClippedPathBoundingBox();
        this.dependencyTracker?.recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.fill);
        if (isPatternFill) {
            const dims = this.current.tilingPatternDims;
            const tileIdx = dims && fillColor.canSkipPatternCanvas(dims);
            if (tileIdx) {
                fillColor.drawPattern(this, path, this.pendingEOFill, tileIdx, opIdx);
                this.pendingEOFill = false;
                if (consumePath) this.consumePath(opIdx, path, intersect);
                this.current.tilingPatternDims = null;
                this.#endKnockoutElement(started);
                return;
            }
            const baseTransform = fillColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
            this.dependencyTracker?.save(opIdx);
            ctx.save();
            ctx.fillStyle = fillColor.getPattern(ctx, this, $a2cc6e1d6eb3861b$var$getCurrentTransformInverse(ctx), $a2cc6e1d6eb3861b$var$PathType.FILL, opIdx);
            if (baseTransform) {
                const newPath = new Path2D();
                newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                path = newPath;
            }
            needRestore = true;
        }
        if (this.contentVisible && intersect !== null) {
            if (this.pendingEOFill) {
                ctx.fill(path, "evenodd");
                this.pendingEOFill = false;
            } else ctx.fill(path);
        }
        if (needRestore) {
            ctx.restore();
            this.dependencyTracker?.restore(opIdx);
        }
        if (consumePath) this.consumePath(opIdx, path, intersect);
        this.#endKnockoutElement(started);
    }
    eoFill(opIdx, path) {
        this.pendingEOFill = true;
        this.fill(opIdx, path);
    }
    fillStroke(opIdx, path) {
        const started = this.#beginKnockoutElement(Math.min(this.current.fillAlpha, this.current.strokeAlpha));
        this.fill(opIdx, path, false);
        this.stroke(opIdx, path, false);
        this.consumePath(opIdx, path);
        this.#endKnockoutElement(started);
    }
    eoFillStroke(opIdx, path) {
        this.pendingEOFill = true;
        this.fillStroke(opIdx, path);
    }
    closeFillStroke(opIdx, path) {
        this.fillStroke(opIdx, path);
    }
    closeEOFillStroke(opIdx, path) {
        this.pendingEOFill = true;
        this.fillStroke(opIdx, path);
    }
    endPath(opIdx, path) {
        this.consumePath(opIdx, path);
    }
    rawFillPath(opIdx, path) {
        const started = this.#beginKnockoutElement(this.current.fillAlpha);
        this.ctx.fill(path);
        this.dependencyTracker?.recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.rawFillPath).recordOperation(opIdx);
        this.#endKnockoutElement(started);
    }
    clip(opIdx) {
        this.dependencyTracker?.recordFutureForcedDependency("clipMode", opIdx);
        this.pendingClip = $a2cc6e1d6eb3861b$var$NORMAL_CLIP;
    }
    eoClip(opIdx) {
        this.dependencyTracker?.recordFutureForcedDependency("clipMode", opIdx);
        this.pendingClip = $a2cc6e1d6eb3861b$var$EO_CLIP;
    }
    beginText(opIdx) {
        this.current.textMatrix = null;
        this.current.textMatrixScale = 1;
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        this.dependencyTracker?.recordOpenMarker(opIdx).resetIncrementalData("sameLineText").resetIncrementalData("moveText", opIdx);
    }
    endText(opIdx) {
        const paths = this.pendingTextPaths;
        const ctx = this.ctx;
        if (this.dependencyTracker) {
            const { dependencyTracker: dependencyTracker } = this;
            if (paths !== undefined) dependencyTracker.recordFutureForcedDependency("textClip", dependencyTracker.getOpenMarker()).recordFutureForcedDependency("textClip", opIdx);
            dependencyTracker.recordCloseMarker(opIdx);
        }
        if (paths !== undefined) {
            const newPath = new Path2D();
            const invTransf = ctx.getTransform().invertSelf();
            for (const { transform: transform, x: x, y: y, fontSize: fontSize, path: path } of paths){
                if (!path) continue;
                newPath.addPath(path, new DOMMatrix(transform).preMultiplySelf(invTransf).translate(x, y).scale(fontSize, -fontSize));
            }
            ctx.clip(newPath);
        }
        delete this.pendingTextPaths;
    }
    setCharSpacing(opIdx, spacing) {
        this.dependencyTracker?.recordSimpleData("charSpacing", opIdx);
        this.current.charSpacing = spacing;
    }
    setWordSpacing(opIdx, spacing) {
        this.dependencyTracker?.recordSimpleData("wordSpacing", opIdx);
        this.current.wordSpacing = spacing;
    }
    setHScale(opIdx, scale) {
        this.dependencyTracker?.recordSimpleData("hScale", opIdx);
        this.current.textHScale = scale / 100;
    }
    setLeading(opIdx, leading) {
        this.dependencyTracker?.recordSimpleData("leading", opIdx);
        this.current.leading = -leading;
    }
    setFont(opIdx, fontRefName, size) {
        this.dependencyTracker?.recordSimpleData("font", opIdx).recordSimpleDataFromNamed("fontObj", fontRefName, opIdx);
        const fontObj = this.commonObjs.get(fontRefName);
        const current = this.current;
        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
        current.fontMatrix = fontObj.fontMatrix || $a2cc6e1d6eb3861b$var$FONT_IDENTITY_MATRIX;
        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) $a2cc6e1d6eb3861b$var$warn("Invalid font matrix for font " + fontRefName);
        if (size < 0) {
            size = -size;
            current.fontDirection = -1;
        } else current.fontDirection = 1;
        this.current.font = fontObj;
        this.current.fontSize = size;
        if (fontObj.isType3Font) return;
        const name = fontObj.loadedName || "sans-serif";
        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
        let bold = "normal";
        if (fontObj.black) bold = "900";
        else if (fontObj.bold) bold = "bold";
        const italic = fontObj.italic ? "italic" : "normal";
        let browserFontSize = size;
        if (size < $a2cc6e1d6eb3861b$var$MIN_FONT_SIZE) browserFontSize = $a2cc6e1d6eb3861b$var$MIN_FONT_SIZE;
        else if (size > $a2cc6e1d6eb3861b$var$MAX_FONT_SIZE) browserFontSize = $a2cc6e1d6eb3861b$var$MAX_FONT_SIZE;
        this.current.fontSizeScale = size / browserFontSize;
        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
    }
    setTextRenderingMode(opIdx, mode) {
        this.dependencyTracker?.recordSimpleData("textRenderingMode", opIdx);
        this.current.textRenderingMode = mode;
    }
    setTextRise(opIdx, rise) {
        this.dependencyTracker?.recordSimpleData("textRise", opIdx);
        this.current.textRise = rise;
    }
    moveText(opIdx, x, y) {
        this.dependencyTracker?.resetIncrementalData("sameLineText").recordIncrementalData("moveText", opIdx);
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
    }
    setLeadingMoveText(opIdx, x, y) {
        this.setLeading(opIdx, -y);
        this.moveText(opIdx, x, y);
    }
    setTextMatrix(opIdx, matrix) {
        this.dependencyTracker?.resetIncrementalData("sameLineText").recordSimpleData("textMatrix", opIdx);
        const { current: current } = this;
        current.textMatrix = matrix;
        current.textMatrixScale = Math.hypot(matrix[0], matrix[1]);
        current.x = current.lineX = 0;
        current.y = current.lineY = 0;
    }
    nextLine(opIdx) {
        this.moveText(opIdx, 0, this.current.leading);
        this.dependencyTracker?.recordIncrementalData("moveText", this.dependencyTracker.getSimpleIndex("leading") ?? opIdx);
    }
    #getScaledPath(path, currentTransform, transform) {
        const newPath = new Path2D();
        newPath.addPath(path, new DOMMatrix(transform).invertSelf().multiplySelf(currentTransform));
        return newPath;
    }
    paintChar(opIdx, character, x, y, patternFillTransform, patternStrokeTransform) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const textRenderingMode = current.textRenderingMode;
        const fontSize = current.fontSize / current.fontSizeScale;
        const fillStrokeMode = textRenderingMode & $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL_STROKE_MASK;
        const isAddToPathSet = !!(textRenderingMode & $a2cc6e1d6eb3861b$var$TextRenderingMode.ADD_TO_PATH_FLAG);
        const patternFill = current.patternFill && !font.missingFile;
        const patternStroke = current.patternStroke && !font.missingFile;
        let path;
        if ((font.disableFontFace || isAddToPathSet || patternFill || patternStroke) && !font.missingFile) path = font.getPathGenerator(this.commonObjs, character);
        if (path && (font.disableFontFace || patternFill || patternStroke)) {
            ctx.save();
            ctx.translate(x, y);
            ctx.scale(fontSize, -fontSize);
            this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font);
            let currentTransform;
            if (fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL || fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL_STROKE) {
                if (patternFillTransform) {
                    currentTransform = ctx.getTransform();
                    ctx.setTransform(...patternFillTransform);
                    const scaledPath = this.#getScaledPath(path, currentTransform, patternFillTransform);
                    ctx.fill(scaledPath);
                } else ctx.fill(path);
            }
            if (fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.STROKE || fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL_STROKE) {
                if (patternStrokeTransform) {
                    currentTransform ||= ctx.getTransform();
                    ctx.setTransform(...patternStrokeTransform);
                    const { a: a, b: b, c: c, d: d } = currentTransform;
                    const invPatternTransform = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.inverseTransform(patternStrokeTransform);
                    const transf = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform([
                        a,
                        b,
                        c,
                        d,
                        0,
                        0
                    ], invPatternTransform);
                    $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transf, $a2cc6e1d6eb3861b$var$XY);
                    ctx.lineWidth *= Math.max($a2cc6e1d6eb3861b$var$XY[0], $a2cc6e1d6eb3861b$var$XY[1]) / fontSize;
                    ctx.stroke(this.#getScaledPath(path, currentTransform, patternStrokeTransform));
                } else {
                    ctx.lineWidth /= fontSize;
                    ctx.stroke(path);
                }
            }
            ctx.restore();
        } else {
            if (fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL || fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL_STROKE) {
                ctx.fillText(character, x, y);
                this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y, ()=>ctx.measureText(character));
            }
            if (fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.STROKE || fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL_STROKE) {
                if (this.dependencyTracker) this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y, ()=>ctx.measureText(character)).recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.stroke);
                ctx.strokeText(character, x, y);
            }
        }
        if (isAddToPathSet) {
            const paths = this.pendingTextPaths ||= [];
            paths.push({
                transform: $a2cc6e1d6eb3861b$var$getCurrentTransform(ctx),
                x: x,
                y: y,
                fontSize: fontSize,
                path: path
            });
            this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y);
        }
    }
    get isFontSubpixelAAEnabled() {
        const tmpCanvas = this.canvasFactory.create(10, 10);
        const ctx = tmpCanvas.context;
        ctx.scale(1.5, 1);
        ctx.fillText("I", 0, 10);
        const data = ctx.getImageData(0, 0, 10, 10).data;
        this.canvasFactory.destroy(tmpCanvas);
        let enabled = false;
        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
            enabled = true;
            break;
        }
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isFontSubpixelAAEnabled", enabled);
    }
    showText(opIdx, glyphs) {
        if (this.dependencyTracker) {
            this.dependencyTracker.recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.showText).resetBBox(opIdx);
            if (this.current.textRenderingMode & $a2cc6e1d6eb3861b$var$TextRenderingMode.ADD_TO_PATH_FLAG) this.dependencyTracker.recordFutureForcedDependency("textClip", opIdx).inheritPendingDependenciesAsFutureForcedDependencies();
        }
        const current = this.current;
        const font = current.font;
        if (font.isType3Font) {
            const started = this.#beginKnockoutElement(current.fillAlpha);
            this.showType3Text(opIdx, glyphs);
            this.dependencyTracker?.recordShowTextOperation(opIdx);
            this.#endKnockoutElement(started);
            return undefined;
        }
        const fontSize = current.fontSize;
        if (fontSize === 0) {
            this.dependencyTracker?.recordOperation(opIdx);
            return undefined;
        }
        const started = this.#beginKnockoutElement(current.fillAlpha);
        const ctx = this.ctx;
        const fontSizeScale = current.fontSizeScale;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const fontDirection = current.fontDirection;
        const textHScale = current.textHScale * fontDirection;
        const glyphsLength = glyphs.length;
        const vertical = font.vertical;
        const spacingDir = vertical ? 1 : -1;
        const defaultVMetrics = font.defaultVMetrics;
        const widthAdvanceScale = fontSize * current.fontMatrix[0];
        const simpleFillText = current.textRenderingMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
        ctx.save();
        if (current.textMatrix) ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        if (fontDirection > 0) ctx.scale(textHScale, -1);
        else ctx.scale(textHScale, 1);
        let patternFillTransform, patternStrokeTransform;
        const fillStrokeMode = current.textRenderingMode & $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL_STROKE_MASK;
        const needsFill = fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL || fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL_STROKE;
        const needsStroke = fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.STROKE || fillStrokeMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.FILL_STROKE;
        let lineWidth = current.lineWidth;
        const scale = current.textMatrixScale;
        if (scale === 0 || lineWidth === 0) {
            if (needsStroke) lineWidth = this.getSinglePixelWidth();
        } else lineWidth /= scale;
        if (fontSizeScale !== 1.0) {
            ctx.scale(fontSizeScale, fontSizeScale);
            lineWidth /= fontSizeScale;
        }
        ctx.lineWidth = lineWidth;
        if (needsFill && current.patternFill) {
            ctx.save();
            const pattern = current.fillColor.getPattern(ctx, this, $a2cc6e1d6eb3861b$var$getCurrentTransformInverse(ctx), $a2cc6e1d6eb3861b$var$PathType.FILL, opIdx);
            patternFillTransform = $a2cc6e1d6eb3861b$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.fillStyle = pattern;
        }
        if (needsStroke && current.patternStroke) {
            ctx.save();
            const pattern = current.strokeColor.getPattern(ctx, this, $a2cc6e1d6eb3861b$var$getCurrentTransformInverse(ctx), $a2cc6e1d6eb3861b$var$PathType.STROKE, opIdx);
            patternStrokeTransform = $a2cc6e1d6eb3861b$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.strokeStyle = pattern;
        }
        if (font.isInvalidPDFjsFont) {
            const chars = [];
            let width = 0;
            for (const glyph of glyphs){
                chars.push(glyph.unicode);
                width += glyph.width;
            }
            const joinedChars = chars.join("");
            ctx.fillText(joinedChars, 0, 0);
            if (this.dependencyTracker !== null) {
                const measure = ctx.measureText(joinedChars);
                this.dependencyTracker.recordBBox(opIdx, this.ctx, -measure.actualBoundingBoxLeft, measure.actualBoundingBoxRight, -measure.actualBoundingBoxAscent, measure.actualBoundingBoxDescent).recordShowTextOperation(opIdx);
            }
            current.x += width * widthAdvanceScale * textHScale;
            ctx.restore();
            this.compose();
            this.#endKnockoutElement(started);
            return undefined;
        }
        let x = 0, i;
        for(i = 0; i < glyphsLength; ++i){
            const glyph = glyphs[i];
            if (typeof glyph === "number") {
                x += spacingDir * glyph * fontSize / 1000;
                continue;
            }
            let restoreNeeded = false;
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const character = glyph.fontChar;
            const accent = glyph.accent;
            let scaledX, scaledY;
            let width = glyph.width;
            if (vertical) {
                const vmetric = glyph.vmetric || defaultVMetrics;
                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                const vy = vmetric[2] * widthAdvanceScale;
                width = vmetric ? -vmetric[0] : width;
                scaledX = vx / fontSizeScale;
                scaledY = (x + vy) / fontSizeScale;
            } else {
                scaledX = x / fontSizeScale;
                scaledY = 0;
            }
            let measure;
            if (font.remeasure && width > 0) {
                measure = ctx.measureText(character);
                const measuredWidth = measure.width * 1000 / fontSize * fontSizeScale;
                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                    const characterScaleX = width / measuredWidth;
                    restoreNeeded = true;
                    ctx.save();
                    ctx.scale(characterScaleX, 1);
                    scaledX /= characterScaleX;
                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
            }
            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                if (simpleFillText && !accent) {
                    ctx.fillText(character, scaledX, scaledY);
                    this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, measure ? {
                        bbox: null
                    } : font, fontSize / fontSizeScale, scaledX, scaledY, ()=>measure ?? ctx.measureText(character));
                } else {
                    this.paintChar(opIdx, character, scaledX, scaledY, patternFillTransform, patternStrokeTransform);
                    if (accent) {
                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                        this.paintChar(opIdx, accent.fontChar, scaledAccentX, scaledAccentY, patternFillTransform, patternStrokeTransform);
                    }
                }
            }
            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
            x += charWidth;
            if (restoreNeeded) ctx.restore();
        }
        if (vertical) current.y -= x;
        else current.x += x * textHScale;
        ctx.restore();
        this.compose();
        this.dependencyTracker?.recordShowTextOperation(opIdx);
        this.#endKnockoutElement(started);
        return undefined;
    }
    showType3Text(opIdx, glyphs) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const fontSize = current.fontSize;
        const fontDirection = current.fontDirection;
        const spacingDir = font.vertical ? 1 : -1;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const textHScale = current.textHScale * fontDirection;
        const fontMatrix = current.fontMatrix || $a2cc6e1d6eb3861b$var$FONT_IDENTITY_MATRIX;
        const glyphsLength = glyphs.length;
        const isTextInvisible = current.textRenderingMode === $a2cc6e1d6eb3861b$var$TextRenderingMode.INVISIBLE;
        let i, glyph, width, spacingLength;
        if (isTextInvisible || fontSize === 0) return;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
        ctx.save();
        if (current.textMatrix) ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        ctx.scale(textHScale, fontDirection);
        const dependencyTracker = this.dependencyTracker;
        this.dependencyTracker = dependencyTracker ? new $a2cc6e1d6eb3861b$var$CanvasNestedDependencyTracker(dependencyTracker, opIdx) : null;
        for(i = 0; i < glyphsLength; ++i){
            glyph = glyphs[i];
            if (typeof glyph === "number") {
                spacingLength = spacingDir * glyph * fontSize / 1000;
                this.ctx.translate(spacingLength, 0);
                current.x += spacingLength * textHScale;
                continue;
            }
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const operatorList = font.charProcOperatorList[glyph.operatorListId];
            if (!operatorList) $a2cc6e1d6eb3861b$var$warn(`Type3 character "${glyph.operatorListId}" is not available.`);
            else if (this.contentVisible) {
                this.save();
                ctx.scale(fontSize, fontSize);
                ctx.transform(...fontMatrix);
                this.executeOperatorList(operatorList);
                this.restore();
            }
            const p = [
                glyph.width,
                0
            ];
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.applyTransform(p, fontMatrix);
            width = p[0] * fontSize + spacing;
            ctx.translate(width, 0);
            current.x += width * textHScale;
        }
        ctx.restore();
        if (dependencyTracker) this.dependencyTracker = dependencyTracker;
    }
    setCharWidth(opIdx, xWidth, yWidth) {}
    setCharWidthAndBounds(opIdx, xWidth, yWidth, llx, lly, urx, ury) {
        const clip = new Path2D();
        clip.rect(llx, lly, urx - llx, ury - lly);
        this.ctx.clip(clip);
        this.dependencyTracker?.recordBBox(opIdx, this.ctx, llx, urx, lly, ury).recordClipBox(opIdx, this.ctx, llx, urx, lly, ury);
        this.endPath(opIdx);
    }
    getColorN_Pattern(opIdx, IR) {
        let pattern;
        if (IR[0] === "TilingPattern") {
            const baseTransform = this.baseTransform || $a2cc6e1d6eb3861b$var$getCurrentTransform(this.ctx);
            const canvasGraphicsFactory = {
                createCanvasGraphics: (ctx, renderingOpIdx)=>new $a2cc6e1d6eb3861b$var$CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                        optionalContentConfig: this.optionalContentConfig,
                        markedContentStack: this.markedContentStack
                    }, undefined, undefined, this.dependencyTracker ? new $a2cc6e1d6eb3861b$var$CanvasNestedDependencyTracker(this.dependencyTracker, renderingOpIdx, true) : null)
            };
            pattern = new $a2cc6e1d6eb3861b$var$TilingPattern(IR, this.ctx, canvasGraphicsFactory, baseTransform);
        } else pattern = this._getPattern(opIdx, IR[1], IR[2]);
        return pattern;
    }
    setStrokeColorN(opIdx, ...args) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.current.strokeColor = this.getColorN_Pattern(opIdx, args);
        this.current.patternStroke = true;
    }
    setFillColorN(opIdx, ...args) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        const pattern = this.current.fillColor = this.getColorN_Pattern(opIdx, args);
        this.current.patternFill = true;
        this.current.tilingPatternDims = pattern instanceof $a2cc6e1d6eb3861b$var$TilingPattern ? [
            0,
            0,
            0,
            0
        ] : null;
    }
    setStrokeRGBColor(opIdx, color) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.ctx.strokeStyle = this.current.strokeColor = color;
        this.current.patternStroke = false;
    }
    setStrokeTransparent(opIdx) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.ctx.strokeStyle = this.current.strokeColor = "transparent";
        this.current.patternStroke = false;
    }
    setFillRGBColor(opIdx, color) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.ctx.fillStyle = this.current.fillColor = color;
        this.current.patternFill = false;
        this.current.tilingPatternDims = null;
    }
    setFillTransparent(opIdx) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.ctx.fillStyle = this.current.fillColor = "transparent";
        this.current.patternFill = false;
        this.current.tilingPatternDims = null;
    }
    _getPattern(opIdx, objId, matrix = null) {
        let pattern;
        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
        else {
            pattern = $a2cc6e1d6eb3861b$var$getShadingPattern(this.getObject(opIdx, objId));
            this.cachedPatterns.set(objId, pattern);
        }
        if (matrix) pattern.matrix = matrix;
        return pattern;
    }
    shadingFill(opIdx, objId) {
        if (!this.contentVisible) return;
        const started = this.#beginKnockoutElement(this.current.fillAlpha);
        const ctx = this.ctx;
        this.save(opIdx);
        const pattern = this._getPattern(opIdx, objId);
        ctx.fillStyle = pattern.getPattern(ctx, this, $a2cc6e1d6eb3861b$var$getCurrentTransformInverse(ctx), $a2cc6e1d6eb3861b$var$PathType.SHADING, opIdx);
        const inv = $a2cc6e1d6eb3861b$var$getCurrentTransformInverse(ctx);
        if (inv) {
            const { width: width, height: height } = ctx.canvas;
            const minMax = $a2cc6e1d6eb3861b$var$F32_BBOX_INIT.slice();
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                0,
                width,
                height
            ], inv, minMax);
            const [x0, y0, x1, y1] = minMax;
            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
        this.dependencyTracker?.resetBBox(opIdx).recordFullPageBBox(opIdx).recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.transform).recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.fill).recordOperation(opIdx);
        this.compose(this.current.getClippedPathBoundingBox());
        this.restore(opIdx);
        this.#endKnockoutElement(started);
    }
    beginInlineImage() {
        $a2cc6e1d6eb3861b$var$unreachable("Should not call beginInlineImage");
    }
    beginImageData() {
        $a2cc6e1d6eb3861b$var$unreachable("Should not call beginImageData");
    }
    paintFormXObjectBegin(opIdx, matrix, bbox) {
        if (!this.contentVisible) return;
        this.save(opIdx);
        this.baseTransformStack.push(this.baseTransform);
        if (matrix) this.transform(opIdx, ...matrix);
        this.baseTransform = $a2cc6e1d6eb3861b$var$getCurrentTransform(this.ctx);
        if (bbox) {
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(bbox, this.baseTransform, this.current.minMax);
            const [x0, y0, x1, y1] = bbox;
            const clip = new Path2D();
            clip.rect(x0, y0, x1 - x0, y1 - y0);
            this.ctx.clip(clip);
            this.dependencyTracker?.recordClipBox(opIdx, this.ctx, x0, x1, y0, y1);
            this.endPath(opIdx);
        }
    }
    paintFormXObjectEnd(opIdx) {
        if (!this.contentVisible) return;
        this.restore(opIdx);
        this.baseTransform = this.baseTransformStack.pop();
    }
    beginGroup(opIdx, group) {
        if (!this.contentVisible) return;
        this.save(opIdx);
        const { inSMaskMode: inSMaskMode } = this;
        if (inSMaskMode) {
            this.endSMaskMode();
            this.current.activeSMask = null;
        }
        const currentCtx = this.ctx;
        if (!group.isolated && !group.knockout && this.#knockoutGroupLevel === 0) $a2cc6e1d6eb3861b$var$info("TODO: Fully support non-isolated non-knockout groups.");
        if (!group.needsIsolation && !group.knockout && this.#knockoutGroupLevel === 0 && currentCtx.globalAlpha === 1 && currentCtx.globalCompositeOperation === "source-over" && !inSMaskMode) {
            if (group.bbox) {
                let clip = new Path2D();
                const [x0, y0, x1, y1] = group.bbox;
                clip.rect(x0, y0, x1 - x0, y1 - y0);
                if (group.matrix) {
                    const path = new Path2D();
                    path.addPath(clip, new DOMMatrix(group.matrix));
                    clip = path;
                }
                currentCtx.clip(clip);
            }
            this.groupStack.push(null);
            this.#groupStackMeta.push(null);
            this.groupLevel++;
            return;
        }
        const currentTransform = $a2cc6e1d6eb3861b$var$getCurrentTransform(currentCtx);
        if (group.matrix) currentCtx.transform(...group.matrix);
        const canvasBounds = [
            0,
            0,
            currentCtx.canvas.width,
            currentCtx.canvas.height
        ];
        let bounds;
        if (group.bbox) {
            bounds = $a2cc6e1d6eb3861b$var$F32_BBOX_INIT.slice();
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(group.bbox, $a2cc6e1d6eb3861b$var$getCurrentTransform(currentCtx), bounds);
            bounds = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.intersect(bounds, canvasBounds) || [
                0,
                0,
                0,
                0
            ];
        } else bounds = canvasBounds;
        const offsetX = Math.floor(bounds[0]);
        const offsetY = Math.floor(bounds[1]);
        const drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
        const drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
        this.current.startNewPathAndClipBox([
            0,
            0,
            drawnWidth,
            drawnHeight
        ]);
        const scratchCanvas = this.canvasFactory.create(drawnWidth, drawnHeight);
        if (group.smask) this.smaskGroupCanvases.push(scratchCanvas);
        const groupCtx = scratchCanvas.context;
        const backdropCtx = group.knockout && !group.isolated ? currentCtx : null;
        const hasInnerBackdrop = !group.isolated && !group.knockout && !group.smask && group.needsIsolation && this.#knockoutGroupLevel > 0;
        const knockoutMaskEntry = group.knockout ? this.canvasFactory.create(drawnWidth, drawnHeight) : null;
        const savedKnockoutLevel = this.#knockoutGroupLevel;
        if (group.knockout) this.#knockoutGroupLevel++;
        else this.#knockoutGroupLevel = 0;
        groupCtx.translate(-offsetX, -offsetY);
        groupCtx.transform(...currentTransform);
        if (!group.isolated && !group.smask && inSMaskMode && group.needsIsolation) {
            groupCtx.save();
            groupCtx.setTransform(1, 0, 0, 1, 0, 0);
            groupCtx.drawImage(currentCtx.canvas, -offsetX, -offsetY);
            groupCtx.restore();
        }
        if (group.bbox) {
            let clip = new Path2D();
            const [x0, y0, x1, y1] = group.bbox;
            clip.rect(x0, y0, x1 - x0, y1 - y0);
            if (group.matrix) {
                const path = new Path2D();
                path.addPath(clip, new DOMMatrix(group.matrix));
                clip = path;
            }
            groupCtx.clip(clip);
        }
        if (group.smask) this.smaskStack.push({
            canvas: scratchCanvas.canvas,
            context: groupCtx,
            offsetX: offsetX,
            offsetY: offsetY,
            subtype: group.smask.subtype,
            backdrop: group.smask.backdrop,
            transferMap: group.smask.transferMap || null
        });
        if (!group.smask || this.dependencyTracker) {
            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
            currentCtx.translate(offsetX, offsetY);
            currentCtx.save();
        }
        $a2cc6e1d6eb3861b$var$copyCtxState(currentCtx, groupCtx);
        this.ctx = groupCtx;
        this.dependencyTracker?.inheritSimpleDataAsFutureForcedDependencies([
            "fillAlpha",
            "strokeAlpha",
            "globalCompositeOperation"
        ]).pushBaseTransform(currentCtx);
        this.setGState(opIdx, [
            [
                "BM",
                "source-over"
            ],
            [
                "ca",
                1
            ],
            [
                "CA",
                1
            ],
            [
                "TR",
                null
            ]
        ]);
        this.groupStack.push(currentCtx);
        this.#groupStackMeta.push({
            backdropCtx: backdropCtx,
            savedKnockoutLevel: savedKnockoutLevel,
            offsetX: offsetX,
            offsetY: offsetY,
            hasInnerBackdrop: hasInnerBackdrop,
            knockoutMaskEntry: knockoutMaskEntry,
            knockoutTempEntry: null,
            knockoutBackdropEntry: null
        });
        this.groupLevel++;
    }
    endGroup(opIdx, group) {
        if (!this.contentVisible) return;
        this.groupLevel--;
        const groupCtx = this.ctx;
        const ctx = this.groupStack.pop();
        const groupMeta = this.#groupStackMeta.pop();
        if (groupMeta) this.#knockoutGroupLevel = groupMeta.savedKnockoutLevel;
        if (ctx === null) {
            this.restore(opIdx);
            return;
        }
        this.ctx = ctx;
        this.ctx.imageSmoothingEnabled = false;
        this.dependencyTracker?.popBaseTransform();
        if (group.smask) {
            this.tempSMask = this.smaskStack.pop();
            this.restore(opIdx);
            if (this.dependencyTracker) {
                this.ctx.restore();
                if (this.inSMaskMode) this.ctx.setTransform(this.suspendedCtx.getTransform());
            }
            this.#destroyKnockoutPools(groupMeta);
        } else {
            this.ctx.restore();
            const currentMtx = $a2cc6e1d6eb3861b$var$getCurrentTransform(this.ctx);
            this.restore(opIdx);
            this.ctx.save();
            this.ctx.setTransform(...currentMtx);
            const dirtyBox = $a2cc6e1d6eb3861b$var$F32_BBOX_INIT.slice();
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                0,
                groupCtx.canvas.width,
                groupCtx.canvas.height
            ], currentMtx, dirtyBox);
            const parentGroupMeta = this.#groupStackMeta.at(-1);
            if (this.#knockoutGroupLevel > 0) {
                if (groupMeta.hasInnerBackdrop) {
                    const { width: width, height: height } = groupCtx.canvas;
                    const colorEntry = this.canvasFactory.create(width, height);
                    const colorCtx = colorEntry.context;
                    colorCtx.drawImage(ctx.canvas, groupMeta.offsetX, groupMeta.offsetY, width, height, 0, 0, width, height);
                    colorCtx.globalCompositeOperation = "source-over";
                    colorCtx.drawImage(groupCtx.canvas, 0, 0);
                    const shapeMaskEntry = this.#createKnockoutMaskCanvas(groupCtx.canvas);
                    colorCtx.globalCompositeOperation = "destination-in";
                    colorCtx.drawImage(shapeMaskEntry.canvas, 0, 0);
                    const sourceCompositeOperation = this.ctx.globalCompositeOperation;
                    const sourceAlpha = this.ctx.globalAlpha;
                    const sourceFilter = this.ctx.filter;
                    this.ctx.save();
                    this.ctx.setTransform(...currentMtx);
                    this.ctx.globalAlpha = 1;
                    if ($a2cc6e1d6eb3861b$export$5fb8891d35c36978.isCanvasFilterSupported) this.ctx.filter = "none";
                    this.ctx.globalCompositeOperation = "destination-out";
                    this.ctx.drawImage(shapeMaskEntry.canvas, 0, 0);
                    this.ctx.globalCompositeOperation = sourceCompositeOperation;
                    this.ctx.globalAlpha = sourceAlpha;
                    if ($a2cc6e1d6eb3861b$export$5fb8891d35c36978.isCanvasFilterSupported) this.ctx.filter = sourceFilter ?? "none";
                    this.ctx.drawImage(colorEntry.canvas, 0, 0);
                    this.ctx.restore();
                    this.canvasFactory.destroy(shapeMaskEntry);
                    this.canvasFactory.destroy(colorEntry);
                } else {
                    const backdropCtx = parentGroupMeta?.backdropCtx ?? null;
                    this.#compositeKnockoutSurface(this.ctx, groupCtx.canvas, {
                        backdropCanvas: backdropCtx?.canvas ?? null,
                        destTransform: currentMtx,
                        backdropOffset: backdropCtx ? [
                            parentGroupMeta.offsetX + groupMeta.offsetX,
                            parentGroupMeta.offsetY + groupMeta.offsetY
                        ] : [
                            0,
                            0
                        ],
                        sourceAlpha: this.ctx.globalAlpha,
                        sourceFilter: this.ctx.filter
                    });
                }
            } else this.ctx.drawImage(groupCtx.canvas, 0, 0);
            this.ctx.restore();
            this.canvasFactory.destroy({
                canvas: groupCtx.canvas,
                context: groupCtx
            });
            this.#destroyKnockoutPools(groupMeta);
            this.compose(dirtyBox);
        }
    }
    #destroyKnockoutPools(groupMeta) {
        if (!groupMeta) return;
        if (groupMeta.knockoutMaskEntry) {
            this.canvasFactory.destroy(groupMeta.knockoutMaskEntry);
            groupMeta.knockoutMaskEntry = null;
        }
        if (groupMeta.knockoutTempEntry) {
            this.canvasFactory.destroy(groupMeta.knockoutTempEntry);
            groupMeta.knockoutTempEntry = null;
        }
        if (groupMeta.knockoutBackdropEntry) {
            this.canvasFactory.destroy(groupMeta.knockoutBackdropEntry);
            groupMeta.knockoutBackdropEntry = null;
        }
    }
    beginAnnotation(opIdx, id, rect, transform, matrix, hasOwnCanvas) {
        this.#restoreInitialState();
        $a2cc6e1d6eb3861b$var$resetCtxToDefault(this.ctx);
        this.ctx.save();
        this.save(opIdx);
        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
        if (rect) {
            const width = rect[2] - rect[0];
            const height = rect[3] - rect[1];
            if (hasOwnCanvas && this.annotationCanvasMap) {
                transform = transform.slice();
                transform[4] -= rect[0];
                transform[5] -= rect[1];
                rect = rect.slice();
                rect[0] = rect[1] = 0;
                rect[2] = width;
                rect[3] = height;
                $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.singularValueDecompose2dScale($a2cc6e1d6eb3861b$var$getCurrentTransform(this.ctx), $a2cc6e1d6eb3861b$var$XY);
                const { viewportScale: viewportScale } = this;
                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                const { canvas: canvas, context: context } = this.annotationCanvas;
                this.annotationCanvasMap.set(id, canvas);
                this.annotationCanvas.savedCtx = this.ctx;
                this.ctx = context;
                this.ctx.save();
                this.ctx.setTransform($a2cc6e1d6eb3861b$var$XY[0], 0, 0, -$a2cc6e1d6eb3861b$var$XY[1], 0, height * $a2cc6e1d6eb3861b$var$XY[1]);
                $a2cc6e1d6eb3861b$var$resetCtxToDefault(this.ctx);
            } else {
                $a2cc6e1d6eb3861b$var$resetCtxToDefault(this.ctx);
                this.endPath(opIdx);
                const clip = new Path2D();
                clip.rect(rect[0], rect[1], width, height);
                this.ctx.clip(clip);
            }
        }
        this.current = new $a2cc6e1d6eb3861b$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.baseTransformStack.push(this.baseTransform);
        this.transform(opIdx, ...transform);
        this.transform(opIdx, ...matrix);
        this.baseTransform = $a2cc6e1d6eb3861b$var$getCurrentTransform(this.ctx);
    }
    endAnnotation(opIdx) {
        if (this.annotationCanvas) {
            this.ctx.restore();
            this.#drawFilter();
            this.ctx = this.annotationCanvas.savedCtx;
            delete this.annotationCanvas.savedCtx;
            delete this.annotationCanvas;
        }
        this.baseTransform = this.baseTransformStack.pop();
    }
    paintImageMaskXObject(opIdx, img) {
        if (!this.contentVisible) return;
        const count = img.count;
        img = this.getObject(opIdx, img.data, img);
        img.count = count;
        const started = this.#beginKnockoutElement(this.current.fillAlpha);
        const ctx = this.ctx;
        const mask = this._createMaskCanvas(opIdx, img);
        const maskCanvas = mask.canvas;
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, this.ctx, mask.offsetX, mask.offsetX + maskCanvas.width, mask.offsetY, mask.offsetY + maskCanvas.height).recordOperation(opIdx);
        ctx.restore();
        if (mask.canvasEntry) this.canvasFactory.destroy(mask.canvasEntry);
        this.compose();
        this.#endKnockoutElement(started);
    }
    paintImageMaskXObjectRepeat(opIdx, img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
        if (!this.contentVisible) return;
        img = this.getObject(opIdx, img.data, img);
        const started = this.#beginKnockoutElement(this.current.fillAlpha);
        const ctx = this.ctx;
        ctx.save();
        const currentTransform = $a2cc6e1d6eb3861b$var$getCurrentTransform(ctx);
        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
        const mask = this._createMaskCanvas(opIdx, img);
        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
        this.dependencyTracker?.resetBBox(opIdx);
        for(let i = 0, ii = positions.length; i < ii; i += 2){
            const trans = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform(currentTransform, [
                scaleX,
                skewX,
                skewY,
                scaleY,
                positions[i],
                positions[i + 1]
            ]);
            ctx.drawImage(mask.canvas, trans[4], trans[5]);
            this.dependencyTracker?.recordBBox(opIdx, this.ctx, trans[4], trans[4] + mask.canvas.width, trans[5], trans[5] + mask.canvas.height);
        }
        ctx.restore();
        if (mask.canvasEntry) this.canvasFactory.destroy(mask.canvasEntry);
        this.compose();
        this.dependencyTracker?.recordOperation(opIdx);
        this.#endKnockoutElement(started);
    }
    paintImageMaskXObjectGroup(opIdx, images) {
        if (!this.contentVisible) return;
        const started = this.#beginKnockoutElement(this.current.fillAlpha);
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        this.dependencyTracker?.resetBBox(opIdx).recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.transformAndFill);
        for (const image of images){
            const { data: data, width: width, height: height, transform: transform } = image;
            const maskCanvas = this.canvasFactory.create(width, height);
            const maskCtx = maskCanvas.context;
            maskCtx.save();
            const img = this.getObject(opIdx, data, image);
            $a2cc6e1d6eb3861b$var$putBinaryImageMask(maskCtx, img);
            maskCtx.globalCompositeOperation = "source-in";
            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, $a2cc6e1d6eb3861b$var$getCurrentTransformInverse(ctx), $a2cc6e1d6eb3861b$var$PathType.FILL, opIdx) : fillColor;
            maskCtx.fillRect(0, 0, width, height);
            maskCtx.restore();
            ctx.save();
            ctx.transform(...transform);
            ctx.scale(1, -1);
            $a2cc6e1d6eb3861b$var$drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
            this.canvasFactory.destroy(maskCanvas);
            this.dependencyTracker?.recordBBox(opIdx, ctx, 0, width, 0, height);
            ctx.restore();
        }
        this.compose();
        this.dependencyTracker?.recordOperation(opIdx);
        this.#endKnockoutElement(started);
    }
    paintImageXObject(opIdx, objId) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(opIdx, objId);
        if (!imgData) {
            $a2cc6e1d6eb3861b$var$warn("Dependent image isn't ready yet");
            return;
        }
        this.paintInlineImageXObject(opIdx, imgData);
    }
    paintImageXObjectRepeat(opIdx, objId, scaleX, scaleY, positions) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(opIdx, objId);
        if (!imgData) {
            $a2cc6e1d6eb3861b$var$warn("Dependent image isn't ready yet");
            return;
        }
        const width = imgData.width;
        const height = imgData.height;
        const map = [];
        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
            transform: [
                scaleX,
                0,
                0,
                scaleY,
                positions[i],
                positions[i + 1]
            ],
            x: 0,
            y: 0,
            w: width,
            h: height
        });
        this.paintInlineImageXObjectGroup(opIdx, imgData, map);
    }
    applyTransferMapsToCanvas(ctx) {
        if (this.current.transferMaps !== "none") {
            ctx.filter = this.current.transferMaps;
            ctx.drawImage(ctx.canvas, 0, 0);
            ctx.filter = "none";
        }
        return ctx.canvas;
    }
    applyTransferMapsToBitmap(imgData) {
        if (this.current.transferMaps === "none") return {
            img: imgData.bitmap,
            canvasEntry: null
        };
        const { bitmap: bitmap, width: width, height: height } = imgData;
        const tmpCanvas = this.canvasFactory.create(width, height);
        const tmpCtx = tmpCanvas.context;
        tmpCtx.filter = this.current.transferMaps;
        tmpCtx.drawImage(bitmap, 0, 0);
        tmpCtx.filter = "none";
        return {
            img: tmpCanvas.canvas,
            canvasEntry: tmpCanvas
        };
    }
    paintInlineImageXObject(opIdx, imgData) {
        if (!this.contentVisible) return;
        const width = imgData.width;
        const height = imgData.height;
        const started = this.#beginKnockoutElement(this.current.fillAlpha);
        const ctx = this.ctx;
        this.save(opIdx);
        const { filter: filter } = ctx;
        if (filter !== "none" && filter !== "") ctx.filter = "none";
        ctx.scale(1 / width, -1 / height);
        let imgToPaint;
        let inlineImgCanvas = null;
        if (imgData.bitmap) {
            const result = this.applyTransferMapsToBitmap(imgData);
            imgToPaint = result.img;
            inlineImgCanvas = result.canvasEntry;
        } else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
        else {
            const tmpCanvas = this.canvasFactory.create(width, height);
            $a2cc6e1d6eb3861b$var$putBinaryImageData(tmpCanvas.context, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCanvas.context);
            inlineImgCanvas = tmpCanvas;
        }
        const scaled = this._scaleImage(imgToPaint, $a2cc6e1d6eb3861b$var$getCurrentTransformInverse(ctx));
        ctx.imageSmoothingEnabled = $a2cc6e1d6eb3861b$var$getImageSmoothingEnabled($a2cc6e1d6eb3861b$var$getCurrentTransform(ctx), imgData.interpolate);
        if (this.dependencyTracker) {
            this.dependencyTracker.resetBBox(opIdx).recordBBox(opIdx, ctx, 0, width, -height, 0).recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.imageXObject).recordOperation(opIdx);
            this.imagesTracker?.record(ctx, width, height, this.dependencyTracker.clipBox);
        }
        $a2cc6e1d6eb3861b$var$drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
        if (scaled.tmpCanvas) this.canvasFactory.destroy(scaled.tmpCanvas);
        if (inlineImgCanvas) this.canvasFactory.destroy(inlineImgCanvas);
        this.compose();
        this.restore(opIdx);
        this.#endKnockoutElement(started);
    }
    paintInlineImageXObjectGroup(opIdx, imgData, map) {
        if (!this.contentVisible) return;
        const started = this.#beginKnockoutElement(this.current.fillAlpha);
        const ctx = this.ctx;
        let imgToPaint;
        let inlineImgCanvas = null;
        if (imgData.bitmap) imgToPaint = imgData.bitmap;
        else {
            const w = imgData.width;
            const h = imgData.height;
            const tmpCanvas = this.canvasFactory.create(w, h);
            $a2cc6e1d6eb3861b$var$putBinaryImageData(tmpCanvas.context, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCanvas.context);
            inlineImgCanvas = tmpCanvas;
        }
        this.dependencyTracker?.resetBBox(opIdx);
        for (const entry of map){
            ctx.save();
            ctx.transform(...entry.transform);
            ctx.scale(1, -1);
            $a2cc6e1d6eb3861b$var$drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
            this.dependencyTracker?.recordBBox(opIdx, ctx, 0, 1, -1, 0);
            ctx.restore();
        }
        if (inlineImgCanvas) this.canvasFactory.destroy(inlineImgCanvas);
        this.dependencyTracker?.recordOperation(opIdx);
        this.compose();
        this.#endKnockoutElement(started);
    }
    paintSolidColorImageMask(opIdx) {
        if (!this.contentVisible) return;
        const started = this.#beginKnockoutElement(this.current.fillAlpha);
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, this.ctx, 0, 1, 0, 1).recordDependencies(opIdx, $a2cc6e1d6eb3861b$var$Dependencies.fill).recordOperation(opIdx);
        this.ctx.fillRect(0, 0, 1, 1);
        this.compose();
        this.#endKnockoutElement(started);
    }
    markPoint(opIdx, tag) {}
    markPointProps(opIdx, tag, properties) {}
    beginMarkedContent(opIdx, tag) {
        this.dependencyTracker?.beginMarkedContent(opIdx);
        this.markedContentStack.push({
            visible: true
        });
    }
    beginMarkedContentProps(opIdx, tag, properties) {
        this.dependencyTracker?.beginMarkedContent(opIdx);
        if (tag === "OC") this.markedContentStack.push({
            visible: this.optionalContentConfig.isVisible(properties)
        });
        else this.markedContentStack.push({
            visible: true
        });
        this.contentVisible = this.isContentVisible();
    }
    endMarkedContent(opIdx) {
        this.dependencyTracker?.endMarkedContent(opIdx);
        this.markedContentStack.pop();
        this.contentVisible = this.isContentVisible();
    }
    beginCompat(opIdx) {}
    endCompat(opIdx) {}
    consumePath(opIdx, path, clipBox) {
        const isEmpty = this.current.isEmptyClip();
        if (this.pendingClip) this.current.updateClipFromPath();
        if (!this.pendingClip) this.compose(clipBox);
        const ctx = this.ctx;
        if (this.pendingClip) {
            if (!isEmpty) {
                if (this.pendingClip === $a2cc6e1d6eb3861b$var$EO_CLIP) ctx.clip(path, "evenodd");
                else ctx.clip(path);
            }
            this.pendingClip = null;
            this.dependencyTracker?.bboxToClipBoxDropOperation(opIdx).recordFutureForcedDependency("clipPath", opIdx);
        } else this.dependencyTracker?.recordOperation(opIdx);
        this.current.startNewPathAndClipBox(this.current.clipBox);
    }
    getSinglePixelWidth() {
        if (!this._cachedGetSinglePixelWidth) {
            const m = $a2cc6e1d6eb3861b$var$getCurrentTransform(this.ctx);
            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
            else {
                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                const normX = Math.hypot(m[0], m[2]);
                const normY = Math.hypot(m[1], m[3]);
                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
            }
        }
        return this._cachedGetSinglePixelWidth;
    }
    getScaleForStroking() {
        if (this._cachedScaleForStroking[0] === -1) {
            const { lineWidth: lineWidth } = this.current;
            const { a: a, b: b, c: c, d: d } = this.ctx.getTransform();
            let scaleX, scaleY;
            if (b === 0 && c === 0) {
                const normX = Math.abs(a);
                const normY = Math.abs(d);
                if (normX === normY) {
                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                    else {
                        const scaledLineWidth = normX * lineWidth;
                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                    }
                } else if (lineWidth === 0) {
                    scaleX = 1 / normX;
                    scaleY = 1 / normY;
                } else {
                    const scaledXLineWidth = normX * lineWidth;
                    const scaledYLineWidth = normY * lineWidth;
                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                }
            } else {
                const absDet = Math.abs(a * d - b * c);
                const normX = Math.hypot(a, b);
                const normY = Math.hypot(c, d);
                if (lineWidth === 0) {
                    scaleX = normY / absDet;
                    scaleY = normX / absDet;
                } else {
                    const baseArea = lineWidth * absDet;
                    scaleX = normY > baseArea ? normY / baseArea : 1;
                    scaleY = normX > baseArea ? normX / baseArea : 1;
                }
            }
            this._cachedScaleForStroking[0] = scaleX;
            this._cachedScaleForStroking[1] = scaleY;
        }
        return this._cachedScaleForStroking;
    }
    rescaleAndStroke(path, saveRestore) {
        const { ctx: ctx, current: { lineWidth: lineWidth } } = this;
        const [scaleX, scaleY] = this.getScaleForStroking();
        if (scaleX === scaleY) {
            ctx.lineWidth = (lineWidth || 1) * scaleX;
            ctx.stroke(path);
            return;
        }
        const dashes = ctx.getLineDash();
        if (saveRestore) ctx.save();
        ctx.scale(scaleX, scaleY);
        $a2cc6e1d6eb3861b$var$SCALE_MATRIX.a = 1 / scaleX;
        $a2cc6e1d6eb3861b$var$SCALE_MATRIX.d = 1 / scaleY;
        const newPath = new Path2D();
        newPath.addPath(path, $a2cc6e1d6eb3861b$var$SCALE_MATRIX);
        if (dashes.length > 0) {
            const scale = Math.max(scaleX, scaleY);
            ctx.setLineDash(dashes.map((x)=>x / scale));
            ctx.lineDashOffset /= scale;
        }
        ctx.lineWidth = lineWidth || 1;
        ctx.stroke(newPath);
        if (saveRestore) ctx.restore();
    }
    isContentVisible() {
        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
            if (!this.markedContentStack[i].visible) return false;
        }
        return true;
    }
}
for(const op in $a2cc6e1d6eb3861b$export$3a0f7f7a8a0b306b)if ($a2cc6e1d6eb3861b$var$CanvasGraphics.prototype[op] !== undefined) $a2cc6e1d6eb3861b$var$CanvasGraphics.prototype[$a2cc6e1d6eb3861b$export$3a0f7f7a8a0b306b[op]] = $a2cc6e1d6eb3861b$var$CanvasGraphics.prototype[op];
class $a2cc6e1d6eb3861b$var$BasePDFStream {
    #PDFStreamReader = null;
    #PDFStreamRangeReader = null;
    _fullReader = null;
    _rangeReaders = new Set();
    _source = null;
    constructor(source, PDFStreamReader, PDFStreamRangeReader){
        this._source = source;
        this.#PDFStreamReader = PDFStreamReader;
        this.#PDFStreamRangeReader = PDFStreamRangeReader;
    }
    get _progressiveDataLength() {
        return this._fullReader?._loaded ?? 0;
    }
    getFullReader() {
        $a2cc6e1d6eb3861b$var$assert(!this._fullReader, "BasePDFStream.getFullReader can only be called once.");
        return this._fullReader = new this.#PDFStreamReader(this);
    }
    getRangeReader(begin, end) {
        if (end <= this._progressiveDataLength) return null;
        const reader = new this.#PDFStreamRangeReader(this, begin, end);
        this._rangeReaders.add(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullReader?.cancel(reason);
        for (const reader of new Set(this._rangeReaders))reader.cancel(reason);
    }
}
class $a2cc6e1d6eb3861b$var$BasePDFStreamReader {
    onProgress = null;
    _contentLength = 0;
    _filename = null;
    _headersCapability = Promise.withResolvers();
    _isRangeSupported = false;
    _isStreamingSupported = false;
    _loaded = 0;
    _stream = null;
    constructor(stream){
        this._stream = stream;
    }
    _callOnProgress() {
        this.onProgress?.({
            loaded: this._loaded,
            total: this._contentLength
        });
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    get filename() {
        return this._filename;
    }
    get contentLength() {
        return this._contentLength;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `read` called");
    }
    cancel(reason) {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `cancel` called");
    }
}
class $a2cc6e1d6eb3861b$var$BasePDFStreamRangeReader {
    _stream = null;
    constructor(stream, begin, end){
        this._stream = stream;
    }
    async read() {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `read` called");
    }
    cancel(reason) {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `cancel` called");
    }
}
function $a2cc6e1d6eb3861b$var$getFilenameFromContentDispositionHeader(contentDisposition) {
    let needsEncodingFixup = true;
    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = unescape(filename);
        filename = rfc5987decode(filename);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    tmp = rfc2231getparam(contentDisposition);
    if (tmp) {
        const filename = rfc2047decode(tmp);
        return fixupEncoding(filename);
    }
    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    function toParamRegExp(attributePattern, flags) {
        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
    }
    function textdecode(encoding, value) {
        if (encoding) {
            if (!/^[\x00-\xFF]+$/.test(value)) return value;
            try {
                const decoder = new TextDecoder(encoding, {
                    fatal: true
                });
                const buffer = $a2cc6e1d6eb3861b$var$stringToBytes(value);
                value = decoder.decode(buffer);
                needsEncodingFixup = false;
            } catch  {}
        }
        return value;
    }
    function fixupEncoding(value) {
        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
            value = textdecode("utf-8", value);
            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
        }
        return value;
    }
    function rfc2231getparam(contentDispositionStr) {
        const matches = [];
        let match;
        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
        while((match = iter.exec(contentDispositionStr)) !== null){
            let [, n, quot, part] = match;
            n = parseInt(n, 10);
            if (n in matches) {
                if (n === 0) break;
                continue;
            }
            matches[n] = [
                quot,
                part
            ];
        }
        const parts = [];
        for(let n = 0; n < matches.length; ++n){
            if (!(n in matches)) break;
            let [quot, part] = matches[n];
            part = rfc2616unquote(part);
            if (quot) {
                part = unescape(part);
                if (n === 0) part = rfc5987decode(part);
            }
            parts.push(part);
        }
        return parts.join("");
    }
    function rfc2616unquote(value) {
        if (value.startsWith('"')) {
            const parts = value.slice(1).split('\\"');
            for(let i = 0; i < parts.length; ++i){
                const quotindex = parts[i].indexOf('"');
                if (quotindex !== -1) {
                    parts[i] = parts[i].slice(0, quotindex);
                    parts.length = i + 1;
                }
                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
            }
            value = parts.join('"');
        }
        return value;
    }
    function rfc5987decode(extvalue) {
        const encodingend = extvalue.indexOf("'");
        if (encodingend === -1) return extvalue;
        const encoding = extvalue.slice(0, encodingend);
        const langvalue = extvalue.slice(encodingend + 1);
        const value = langvalue.replace(/^[^']*'/, "");
        return textdecode(encoding, value);
    }
    function rfc2047decode(value) {
        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
        return value.replaceAll(/=\?([\w-]*)\?([QB])\?((?:[^?]|\?(?!=))*)\?=/gi, function(matches, charset, encoding, text) {
            if (encoding === "q" || encoding === "Q") {
                text = text.replaceAll("_", " ");
                text = text.replaceAll(/=([0-9a-f]{2})/gi, function(match, hex) {
                    return String.fromCharCode(parseInt(hex, 16));
                });
                return textdecode(charset, text);
            }
            try {
                text = atob(text);
            } catch  {}
            return textdecode(charset, text);
        });
    }
    return "";
}
function $a2cc6e1d6eb3861b$var$createHeaders(isHttp, httpHeaders) {
    const headers = new Headers();
    if (!isHttp || !httpHeaders || typeof httpHeaders !== "object") return headers;
    for(const key in httpHeaders){
        const val = httpHeaders[key];
        if (val !== undefined) headers.append(key, val);
    }
    return headers;
}
function $a2cc6e1d6eb3861b$var$getResponseOrigin(url) {
    return URL.parse(url)?.origin ?? null;
}
function $a2cc6e1d6eb3861b$var$validateRangeRequestCapabilities({ responseHeaders: responseHeaders, isHttp: isHttp, rangeChunkSize: rangeChunkSize, disableRange: disableRange }) {
    const rv = {
        contentLength: 0,
        isRangeSupported: false
    };
    const length = parseInt(responseHeaders.get("Content-Length"), 10);
    if (!Number.isInteger(length)) return rv;
    rv.contentLength = length;
    if (length <= 2 * rangeChunkSize) return rv;
    if (disableRange || !isHttp) return rv;
    if (responseHeaders.get("Accept-Ranges") !== "bytes") return rv;
    const contentEncoding = responseHeaders.get("Content-Encoding") || "identity";
    if (contentEncoding === "identity") rv.isRangeSupported = true;
    return rv;
}
function $a2cc6e1d6eb3861b$var$extractFilenameFromHeader(responseHeaders) {
    const contentDisposition = responseHeaders.get("Content-Disposition");
    if (contentDisposition) {
        let filename = $a2cc6e1d6eb3861b$var$getFilenameFromContentDispositionHeader(contentDisposition);
        if (filename.includes("%")) try {
            filename = decodeURIComponent(filename);
        } catch  {}
        if ($a2cc6e1d6eb3861b$export$61b52d3570d24719(filename)) return filename;
    }
    return null;
}
function $a2cc6e1d6eb3861b$var$createResponseError(status, url) {
    return new $a2cc6e1d6eb3861b$export$ea8e9c34f66e603(`Unexpected server response (${status}) while retrieving PDF "${url.href}".`, status, status === 404 || status === 0 && url.protocol === "file:");
}
function $a2cc6e1d6eb3861b$var$ensureResponseOrigin(rangeOrigin, origin) {
    if (rangeOrigin !== origin) throw new Error(`Expected range response-origin "${rangeOrigin}" to match "${origin}".`);
}
function $a2cc6e1d6eb3861b$var$fetchUrl(url, headers, withCredentials, abortController) {
    return fetch(url, {
        method: "GET",
        headers: headers,
        signal: abortController.signal,
        mode: "cors",
        credentials: withCredentials ? "include" : "same-origin",
        redirect: "follow"
    });
}
function $a2cc6e1d6eb3861b$var$ensureResponseStatus(status, url) {
    if (status !== 200 && status !== 206) throw $a2cc6e1d6eb3861b$var$createResponseError(status, url);
}
function $a2cc6e1d6eb3861b$var$getArrayBuffer(val) {
    if (val instanceof Uint8Array) return val.buffer;
    if (val instanceof ArrayBuffer) return val;
    throw new Error(`getArrayBuffer - unexpected data: ${val}`);
}
class $a2cc6e1d6eb3861b$var$PDFFetchStream extends $a2cc6e1d6eb3861b$var$BasePDFStream {
    _responseOrigin = null;
    constructor(source){
        super(source, $a2cc6e1d6eb3861b$var$PDFFetchStreamReader, $a2cc6e1d6eb3861b$var$PDFFetchStreamRangeReader);
        const { httpHeaders: httpHeaders, url: url } = source;
        $a2cc6e1d6eb3861b$var$assert(/https?:/.test(url.protocol), "PDFFetchStream only supports http(s):// URLs.");
        this.headers = $a2cc6e1d6eb3861b$var$createHeaders(true, httpHeaders);
    }
}
class $a2cc6e1d6eb3861b$var$PDFFetchStreamReader extends $a2cc6e1d6eb3861b$var$BasePDFStreamReader {
    _abortController = new AbortController();
    _reader = null;
    constructor(stream){
        super(stream);
        const { disableRange: disableRange, disableStream: disableStream, rangeChunkSize: rangeChunkSize, url: url, withCredentials: withCredentials } = stream._source;
        this._isStreamingSupported = !disableStream;
        const headers = new Headers(stream.headers);
        $a2cc6e1d6eb3861b$var$fetchUrl(url, headers, withCredentials, this._abortController).then((response)=>{
            stream._responseOrigin = $a2cc6e1d6eb3861b$var$getResponseOrigin(response.url);
            $a2cc6e1d6eb3861b$var$ensureResponseStatus(response.status, url);
            this._reader = response.body.getReader();
            const responseHeaders = response.headers;
            const { contentLength: contentLength, isRangeSupported: isRangeSupported } = $a2cc6e1d6eb3861b$var$validateRangeRequestCapabilities({
                responseHeaders: responseHeaders,
                isHttp: true,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange
            });
            this._contentLength = contentLength;
            this._isRangeSupported = isRangeSupported;
            this._filename = $a2cc6e1d6eb3861b$var$extractFilenameFromHeader(responseHeaders);
            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new $a2cc6e1d6eb3861b$export$d0e978393d193d1a("Streaming is disabled."));
            this._headersCapability.resolve();
        }).catch(this._headersCapability.reject);
    }
    async read() {
        await this._headersCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this._callOnProgress();
        return {
            value: $a2cc6e1d6eb3861b$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
class $a2cc6e1d6eb3861b$var$PDFFetchStreamRangeReader extends $a2cc6e1d6eb3861b$var$BasePDFStreamRangeReader {
    _abortController = new AbortController();
    _readCapability = Promise.withResolvers();
    _reader = null;
    constructor(stream, begin, end){
        super(stream, begin, end);
        const { url: url, withCredentials: withCredentials } = stream._source;
        const headers = new Headers(stream.headers);
        headers.append("Range", `bytes=${begin}-${end - 1}`);
        $a2cc6e1d6eb3861b$var$fetchUrl(url, headers, withCredentials, this._abortController).then((response)=>{
            const responseOrigin = $a2cc6e1d6eb3861b$var$getResponseOrigin(response.url);
            $a2cc6e1d6eb3861b$var$ensureResponseOrigin(responseOrigin, stream._responseOrigin);
            $a2cc6e1d6eb3861b$var$ensureResponseStatus(response.status, url);
            this._reader = response.body.getReader();
            this._readCapability.resolve();
        }).catch(this._readCapability.reject);
    }
    async read() {
        await this._readCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        return {
            value: $a2cc6e1d6eb3861b$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
function $a2cc6e1d6eb3861b$var$transport_stream_getArrayBuffer(val) {
    return val instanceof Uint8Array && val.byteLength === val.buffer.byteLength ? val.buffer : new Uint8Array(val).buffer;
}
function $a2cc6e1d6eb3861b$var$endRequests() {
    for (const capability of this._requests)capability.resolve({
        value: undefined,
        done: true
    });
    this._requests.length = 0;
}
class $a2cc6e1d6eb3861b$var$PDFDataTransportStream extends $a2cc6e1d6eb3861b$var$BasePDFStream {
    _progressiveDone = false;
    _queuedChunks = [];
    constructor(source){
        super(source, $a2cc6e1d6eb3861b$var$PDFDataTransportStreamReader, $a2cc6e1d6eb3861b$var$PDFDataTransportStreamRangeReader);
        const { pdfDataRangeTransport: pdfDataRangeTransport } = source;
        const { initialData: initialData, progressiveDone: progressiveDone } = pdfDataRangeTransport;
        if (initialData?.length > 0) {
            const buffer = $a2cc6e1d6eb3861b$var$transport_stream_getArrayBuffer(initialData);
            this._queuedChunks.push(buffer);
        }
        this._progressiveDone = progressiveDone;
        const listener = (args)=>{
            switch(args.type){
                case "range":
                case "progressiveRead":
                    this.#onReceiveData(args.begin, args.chunk);
                    break;
                case "progressiveDone":
                    this._fullReader?.progressiveDone();
                    this._progressiveDone = true;
                    break;
            }
        };
        pdfDataRangeTransport.transportReady(listener);
    }
    #onReceiveData(begin, chunk) {
        const buffer = $a2cc6e1d6eb3861b$var$transport_stream_getArrayBuffer(chunk);
        if (begin === undefined) {
            if (this._fullReader) this._fullReader._enqueue(buffer);
            else this._queuedChunks.push(buffer);
        } else {
            const rangeReader = this._rangeReaders.keys().find((r)=>r._begin === begin);
            $a2cc6e1d6eb3861b$var$assert(rangeReader, "#onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
            rangeReader._enqueue(buffer);
        }
    }
    getFullReader() {
        const reader = super.getFullReader();
        this._queuedChunks = null;
        return reader;
    }
    getRangeReader(begin, end) {
        const reader = super.getRangeReader(begin, end);
        if (reader) {
            reader.onDone = ()=>this._rangeReaders.delete(reader);
            this._source.pdfDataRangeTransport.requestDataRange(begin, end);
        }
        return reader;
    }
    cancelAllRequests(reason) {
        super.cancelAllRequests(reason);
        this._source.pdfDataRangeTransport.abort();
    }
}
class $a2cc6e1d6eb3861b$var$PDFDataTransportStreamReader extends $a2cc6e1d6eb3861b$var$BasePDFStreamReader {
    #endRequests = $a2cc6e1d6eb3861b$var$endRequests.bind(this);
    _done = false;
    _queuedChunks = null;
    _requests = [];
    constructor(stream){
        super(stream);
        const { pdfDataRangeTransport: pdfDataRangeTransport, disableRange: disableRange, disableStream: disableStream } = stream._source;
        const { length: length, contentDispositionFilename: contentDispositionFilename } = pdfDataRangeTransport;
        this._queuedChunks = stream._queuedChunks || [];
        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
        this._done = stream._progressiveDone;
        this._contentLength = length;
        this._isStreamingSupported = !disableStream;
        this._isRangeSupported = !disableRange;
        if ($a2cc6e1d6eb3861b$export$61b52d3570d24719(contentDispositionFilename)) this._filename = contentDispositionFilename;
        this._headersCapability.resolve();
        const loaded = this._loaded;
        Promise.resolve().then(()=>{
            if (loaded > 0 && this._loaded === loaded) this._callOnProgress();
        });
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length > 0) {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunks.push(chunk);
        this._loaded += chunk.byteLength;
        this._callOnProgress();
    }
    async read() {
        if (this._queuedChunks.length > 0) {
            const chunk = this._queuedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this.#endRequests();
    }
    progressiveDone() {
        this._done ||= true;
        if (this._queuedChunks.length === 0) this.#endRequests();
    }
}
class $a2cc6e1d6eb3861b$var$PDFDataTransportStreamRangeReader extends $a2cc6e1d6eb3861b$var$BasePDFStreamRangeReader {
    #endRequests = $a2cc6e1d6eb3861b$var$endRequests.bind(this);
    onDone = null;
    _begin = -1;
    _done = false;
    _queuedChunk = null;
    _requests = [];
    constructor(stream, begin, end){
        super(stream, begin, end);
        this._begin = begin;
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length === 0) this._queuedChunk = chunk;
        else {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
            this.#endRequests();
        }
        this._done = true;
        this.onDone?.();
    }
    async read() {
        if (this._queuedChunk) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this.#endRequests();
        this.onDone?.();
    }
}
const $a2cc6e1d6eb3861b$var$OK_RESPONSE = 200;
const $a2cc6e1d6eb3861b$var$PARTIAL_CONTENT_RESPONSE = 206;
function $a2cc6e1d6eb3861b$var$network_getArrayBuffer(val) {
    return typeof val !== "string" ? val : $a2cc6e1d6eb3861b$var$stringToBytes(val).buffer;
}
class $a2cc6e1d6eb3861b$var$PDFNetworkStream extends $a2cc6e1d6eb3861b$var$BasePDFStream {
    #pendingRequests = new WeakMap();
    _responseOrigin = null;
    constructor(source){
        super(source, $a2cc6e1d6eb3861b$var$PDFNetworkStreamReader, $a2cc6e1d6eb3861b$var$PDFNetworkStreamRangeReader);
        const { httpHeaders: httpHeaders, url: url } = source;
        this.url = url;
        this.isHttp = /https?:/.test(url.protocol);
        this.headers = $a2cc6e1d6eb3861b$var$createHeaders(this.isHttp, httpHeaders);
    }
    _request(args) {
        const xhr = new XMLHttpRequest();
        const pendingRequest = {
            validateStatus: null,
            onHeadersReceived: args.onHeadersReceived,
            onDone: args.onDone,
            onError: args.onError,
            onProgress: args.onProgress
        };
        this.#pendingRequests.set(xhr, pendingRequest);
        xhr.open("GET", this.url);
        xhr.withCredentials = this._source.withCredentials;
        for (const [key, val] of this.headers)xhr.setRequestHeader(key, val);
        if (this.isHttp && "begin" in args && "end" in args) {
            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
            pendingRequest.validateStatus = (status)=>status === $a2cc6e1d6eb3861b$var$PARTIAL_CONTENT_RESPONSE || status === $a2cc6e1d6eb3861b$var$OK_RESPONSE;
        } else pendingRequest.validateStatus = (status)=>status === $a2cc6e1d6eb3861b$var$OK_RESPONSE;
        xhr.responseType = "arraybuffer";
        $a2cc6e1d6eb3861b$var$assert(args.onError, "Expected `onError` callback to be provided.");
        xhr.onerror = ()=>args.onError(xhr.status);
        xhr.onreadystatechange = this.#onStateChange.bind(this, xhr);
        xhr.onprogress = this.#onProgress.bind(this, xhr);
        xhr.send(null);
        return xhr;
    }
    #onProgress(xhr, evt) {
        const pendingRequest = this.#pendingRequests.get(xhr);
        pendingRequest?.onProgress?.(evt);
    }
    #onStateChange(xhr, evt) {
        const pendingRequest = this.#pendingRequests.get(xhr);
        if (!pendingRequest) return;
        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
            pendingRequest.onHeadersReceived();
            delete pendingRequest.onHeadersReceived;
        }
        if (xhr.readyState !== 4) return;
        if (!this.#pendingRequests.has(xhr)) return;
        this.#pendingRequests.delete(xhr);
        if (xhr.status === 0 && this.isHttp) {
            pendingRequest.onError(xhr.status);
            return;
        }
        const xhrStatus = xhr.status || $a2cc6e1d6eb3861b$var$OK_RESPONSE;
        if (!pendingRequest.validateStatus(xhrStatus)) {
            pendingRequest.onError(xhr.status);
            return;
        }
        const chunk = $a2cc6e1d6eb3861b$var$network_getArrayBuffer(xhr.response);
        if (xhrStatus === $a2cc6e1d6eb3861b$var$PARTIAL_CONTENT_RESPONSE) {
            const rangeHeader = xhr.getResponseHeader("Content-Range");
            if (/bytes \d+-\d+\/\d+/.test(rangeHeader)) pendingRequest.onDone(chunk);
            else {
                $a2cc6e1d6eb3861b$var$warn(`Missing or invalid "Content-Range" header.`);
                pendingRequest.onError(0);
            }
        } else if (chunk) pendingRequest.onDone(chunk);
        else pendingRequest.onError(xhr.status);
    }
    _abortRequest(xhr) {
        if (this.#pendingRequests.has(xhr)) {
            this.#pendingRequests.delete(xhr);
            xhr.abort();
        }
    }
    getRangeReader(begin, end) {
        const reader = super.getRangeReader(begin, end);
        if (reader) reader.onClosed = ()=>this._rangeReaders.delete(reader);
        return reader;
    }
}
class $a2cc6e1d6eb3861b$var$PDFNetworkStreamReader extends $a2cc6e1d6eb3861b$var$BasePDFStreamReader {
    #endRequests = $a2cc6e1d6eb3861b$var$endRequests.bind(this);
    _cachedChunks = [];
    _done = false;
    _requests = [];
    _storedError = null;
    constructor(stream){
        super(stream);
        this._fullRequestXhr = stream._request({
            onHeadersReceived: this.#onHeadersReceived.bind(this),
            onDone: this.#onDone.bind(this),
            onError: this.#onError.bind(this),
            onProgress: this.#onProgress.bind(this)
        });
    }
    #onHeadersReceived() {
        const stream = this._stream;
        const { disableRange: disableRange, rangeChunkSize: rangeChunkSize } = stream._source;
        const fullRequestXhr = this._fullRequestXhr;
        stream._responseOrigin = $a2cc6e1d6eb3861b$var$getResponseOrigin(fullRequestXhr.responseURL);
        const rawResponseHeaders = fullRequestXhr.getAllResponseHeaders();
        const responseHeaders = new Headers(rawResponseHeaders ? rawResponseHeaders.trimStart().replace(/[^\S ]+$/, "").split(/[\r\n]+/).map((x)=>{
            const [key, ...val] = x.split(": ");
            return [
                key,
                val.join(": ")
            ];
        }) : []);
        const { contentLength: contentLength, isRangeSupported: isRangeSupported } = $a2cc6e1d6eb3861b$var$validateRangeRequestCapabilities({
            responseHeaders: responseHeaders,
            isHttp: stream.isHttp,
            rangeChunkSize: rangeChunkSize,
            disableRange: disableRange
        });
        this._contentLength = contentLength;
        this._isRangeSupported = isRangeSupported;
        this._filename = $a2cc6e1d6eb3861b$var$extractFilenameFromHeader(responseHeaders);
        if (this._isRangeSupported) stream._abortRequest(fullRequestXhr);
        this._headersCapability.resolve();
    }
    #onDone(chunk) {
        if (this._requests.length > 0) {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
        } else this._cachedChunks.push(chunk);
        this._done = true;
        if (this._cachedChunks.length === 0) this.#endRequests();
    }
    #onError(status) {
        this._storedError = $a2cc6e1d6eb3861b$var$createResponseError(status, this._stream.url);
        this._headersCapability.reject(this._storedError);
        for (const capability of this._requests)capability.reject(this._storedError);
        this._requests.length = 0;
        this._cachedChunks.length = 0;
    }
    #onProgress(evt) {
        this.onProgress?.({
            loaded: evt.loaded,
            total: evt.lengthComputable ? evt.total : this._contentLength
        });
    }
    async read() {
        await this._headersCapability.promise;
        if (this._storedError) throw this._storedError;
        if (this._cachedChunks.length > 0) {
            const chunk = this._cachedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this._headersCapability.reject(reason);
        this.#endRequests();
        this._stream._abortRequest(this._fullRequestXhr);
        this._fullRequestXhr = null;
    }
}
class $a2cc6e1d6eb3861b$var$PDFNetworkStreamRangeReader extends $a2cc6e1d6eb3861b$var$BasePDFStreamRangeReader {
    #endRequests = $a2cc6e1d6eb3861b$var$endRequests.bind(this);
    onClosed = null;
    _done = false;
    _queuedChunk = null;
    _requests = [];
    _storedError = null;
    constructor(stream, begin, end){
        super(stream, begin, end);
        this._requestXhr = stream._request({
            begin: begin,
            end: end,
            onHeadersReceived: this.#onHeadersReceived.bind(this),
            onDone: this.#onDone.bind(this),
            onError: this.#onError.bind(this),
            onProgress: null
        });
    }
    #onHeadersReceived() {
        const responseOrigin = $a2cc6e1d6eb3861b$var$getResponseOrigin(this._requestXhr?.responseURL);
        try {
            $a2cc6e1d6eb3861b$var$ensureResponseOrigin(responseOrigin, this._stream._responseOrigin);
        } catch (ex) {
            this._storedError = ex;
            this.#onError(0);
        }
    }
    #onDone(chunk) {
        if (this._requests.length > 0) {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunk = chunk;
        this._done = true;
        this.#endRequests();
        this.onClosed?.();
    }
    #onError(status) {
        this._storedError ??= $a2cc6e1d6eb3861b$var$createResponseError(status, this._stream.url);
        for (const capability of this._requests)capability.reject(this._storedError);
        this._requests.length = 0;
        this._queuedChunk = null;
    }
    async read() {
        if (this._storedError) throw this._storedError;
        if (this._queuedChunk !== null) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this.#endRequests();
        this._stream._abortRequest(this._requestXhr);
        this.onClosed?.();
    }
}
function $a2cc6e1d6eb3861b$var$getReadableStream(url, opts = null) {
    const fs = $jBmpJ.getBuiltinModule("fs");
    const { Readable: Readable } = $jBmpJ.getBuiltinModule("stream");
    const readStream = fs.createReadStream(url, opts);
    return Readable.toWeb(readStream);
}
class $a2cc6e1d6eb3861b$var$PDFNodeStream extends $a2cc6e1d6eb3861b$var$BasePDFStream {
    constructor(source){
        super(source, $a2cc6e1d6eb3861b$var$PDFNodeStreamReader, $a2cc6e1d6eb3861b$var$PDFNodeStreamRangeReader);
        const { url: url } = source;
        $a2cc6e1d6eb3861b$var$assert(url.protocol === "file:", "PDFNodeStream only supports file:// URLs.");
    }
}
class $a2cc6e1d6eb3861b$var$PDFNodeStreamReader extends $a2cc6e1d6eb3861b$var$BasePDFStreamReader {
    _reader = null;
    constructor(stream){
        super(stream);
        const { disableRange: disableRange, disableStream: disableStream, rangeChunkSize: rangeChunkSize, url: url } = stream._source;
        this._isStreamingSupported = !disableStream;
        const fs = $jBmpJ.getBuiltinModule("fs/promises");
        fs.lstat(url).then((stat)=>{
            const readableStream = $a2cc6e1d6eb3861b$var$getReadableStream(url);
            this._reader = readableStream.getReader();
            const { size: size } = stat;
            this._contentLength = size;
            this._isRangeSupported = !disableRange && size > 2 * rangeChunkSize;
            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new $a2cc6e1d6eb3861b$export$d0e978393d193d1a("Streaming is disabled."));
            this._headersCapability.resolve();
        }).catch((error)=>{
            if (error.code === "ENOENT") error = $a2cc6e1d6eb3861b$var$createResponseError(0, url);
            this._headersCapability.reject(error);
        });
    }
    async read() {
        await this._headersCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this._callOnProgress();
        return {
            value: $a2cc6e1d6eb3861b$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
    }
}
class $a2cc6e1d6eb3861b$var$PDFNodeStreamRangeReader extends $a2cc6e1d6eb3861b$var$BasePDFStreamRangeReader {
    _readCapability = Promise.withResolvers();
    _reader = null;
    constructor(stream, begin, end){
        super(stream, begin, end);
        const { url: url } = stream._source;
        try {
            const readableStream = $a2cc6e1d6eb3861b$var$getReadableStream(url, {
                start: begin,
                end: end - 1
            });
            this._reader = readableStream.getReader();
            this._readCapability.resolve();
        } catch (error) {
            this._readCapability.reject(error);
        }
    }
    async read() {
        await this._readCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        return {
            value: $a2cc6e1d6eb3861b$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
    }
}
function $a2cc6e1d6eb3861b$var$getNetworkStream(url) {
    return $a2cc6e1d6eb3861b$var$isValidFetchUrl(url) ? $a2cc6e1d6eb3861b$var$PDFFetchStream : $a2cc6e1d6eb3861b$var$isNodeJS ? $a2cc6e1d6eb3861b$var$PDFNodeStream : $a2cc6e1d6eb3861b$var$PDFNetworkStream;
}
class $a2cc6e1d6eb3861b$export$edf38ba293eb934 {
    static #port = null;
    static #src = "";
    static get workerPort() {
        return this.#port;
    }
    static set workerPort(val) {
        if (!(typeof Worker !== "undefined" && val instanceof Worker) && val !== null) throw new Error("Invalid `workerPort` type.");
        this.#port = val;
    }
    static get workerSrc() {
        return this.#src;
    }
    static set workerSrc(val) {
        if (typeof val !== "string") throw new Error("Invalid `workerSrc` type.");
        this.#src = val;
    }
}
class $a2cc6e1d6eb3861b$var$Metadata {
    #map;
    #data;
    constructor({ parsedData: parsedData, rawData: rawData }){
        this.#map = parsedData;
        this.#data = rawData;
    }
    getRaw() {
        return this.#data;
    }
    get(name) {
        return this.#map.get(name) ?? null;
    }
    [Symbol.iterator]() {
        return this.#map.entries();
    }
}
const $a2cc6e1d6eb3861b$var$INTERNAL = Symbol("INTERNAL");
class $a2cc6e1d6eb3861b$var$OptionalContentGroup {
    #isDisplay = false;
    #isPrint = false;
    #userSet = false;
    #visible = true;
    constructor(renderingIntent, { name: name, intent: intent, usage: usage, rbGroups: rbGroups }){
        this.#isDisplay = !!(renderingIntent & $a2cc6e1d6eb3861b$var$RenderingIntentFlag.DISPLAY);
        this.#isPrint = !!(renderingIntent & $a2cc6e1d6eb3861b$var$RenderingIntentFlag.PRINT);
        this.name = name;
        this.intent = intent;
        this.usage = usage;
        this.rbGroups = rbGroups;
    }
    get visible() {
        if (this.#userSet) return this.#visible;
        if (!this.#visible) return false;
        const { print: print, view: view } = this.usage;
        if (this.#isDisplay) return view?.viewState !== "OFF";
        else if (this.#isPrint) return print?.printState !== "OFF";
        return true;
    }
    _setVisible(internal, visible, userSet = false) {
        if (internal !== $a2cc6e1d6eb3861b$var$INTERNAL) $a2cc6e1d6eb3861b$var$unreachable("Internal method `_setVisible` called.");
        this.#userSet = userSet;
        this.#visible = visible;
    }
}
class $a2cc6e1d6eb3861b$var$OptionalContentConfig {
    #cachedGetHash = null;
    #groups = new Map();
    #initialHash = null;
    #order = null;
    constructor(data, renderingIntent = $a2cc6e1d6eb3861b$var$RenderingIntentFlag.DISPLAY){
        this.renderingIntent = renderingIntent;
        this.name = null;
        this.creator = null;
        if (data === null) return;
        this.name = data.name;
        this.creator = data.creator;
        this.#order = data.order;
        for (const group of data.groups)this.#groups.set(group.id, new $a2cc6e1d6eb3861b$var$OptionalContentGroup(renderingIntent, group));
        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible($a2cc6e1d6eb3861b$var$INTERNAL, false);
        for (const on of data.on)this.#groups.get(on)._setVisible($a2cc6e1d6eb3861b$var$INTERNAL, true);
        for (const off of data.off)this.#groups.get(off)._setVisible($a2cc6e1d6eb3861b$var$INTERNAL, false);
        this.#initialHash = this.getHash();
    }
    #evaluateVisibilityExpression(array) {
        const length = array.length;
        if (length < 2) return true;
        const operator = array[0];
        for(let i = 1; i < length; i++){
            const element = array[i];
            let state;
            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
            else {
                $a2cc6e1d6eb3861b$var$warn(`Optional content group not found: ${element}`);
                return true;
            }
            switch(operator){
                case "And":
                    if (!state) return false;
                    break;
                case "Or":
                    if (state) return true;
                    break;
                case "Not":
                    return !state;
                default:
                    return true;
            }
        }
        return operator === "And";
    }
    isVisible(group) {
        if (this.#groups.size === 0) return true;
        if (!group) {
            $a2cc6e1d6eb3861b$var$info("Optional content group not defined.");
            return true;
        }
        if (group.type === "OCG") {
            if (!this.#groups.has(group.id)) {
                $a2cc6e1d6eb3861b$var$warn(`Optional content group not found: ${group.id}`);
                return true;
            }
            return this.#groups.get(group.id).visible;
        } else if (group.type === "OCMD") {
            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
            if (!group.policy || group.policy === "AnyOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $a2cc6e1d6eb3861b$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $a2cc6e1d6eb3861b$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return false;
                }
                return true;
            } else if (group.policy === "AnyOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $a2cc6e1d6eb3861b$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $a2cc6e1d6eb3861b$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return false;
                }
                return true;
            }
            $a2cc6e1d6eb3861b$var$warn(`Unknown optional content policy ${group.policy}.`);
            return true;
        }
        $a2cc6e1d6eb3861b$var$warn(`Unknown group type ${group.type}.`);
        return true;
    }
    setVisibility(id, visible = true, preserveRB = true) {
        const group = this.#groups.get(id);
        if (!group) {
            $a2cc6e1d6eb3861b$var$warn(`Optional content group not found: ${id}`);
            return;
        }
        if (preserveRB && visible && group.rbGroups.length) for (const rbGroup of group.rbGroups){
            for (const otherId of rbGroup)if (otherId !== id) this.#groups.get(otherId)?._setVisible($a2cc6e1d6eb3861b$var$INTERNAL, false, true);
        }
        group._setVisible($a2cc6e1d6eb3861b$var$INTERNAL, !!visible, true);
        this.#cachedGetHash = null;
    }
    setOCGState({ state: state, preserveRB: preserveRB }) {
        let operator;
        for (const elem of state){
            switch(elem){
                case "ON":
                case "OFF":
                case "Toggle":
                    operator = elem;
                    continue;
            }
            const group = this.#groups.get(elem);
            if (!group) continue;
            switch(operator){
                case "ON":
                    this.setVisibility(elem, true, preserveRB);
                    break;
                case "OFF":
                    this.setVisibility(elem, false, preserveRB);
                    break;
                case "Toggle":
                    this.setVisibility(elem, !group.visible, preserveRB);
                    break;
            }
        }
        this.#cachedGetHash = null;
    }
    get hasInitialVisibility() {
        return this.#initialHash === null || this.getHash() === this.#initialHash;
    }
    getOrder() {
        if (!this.#groups.size) return null;
        if (this.#order) return this.#order.slice();
        return [
            ...this.#groups.keys()
        ];
    }
    getGroup(id) {
        return this.#groups.get(id) || null;
    }
    getHash() {
        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
        const hash = new $a2cc6e1d6eb3861b$var$MurmurHash3_64();
        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
        return this.#cachedGetHash = hash.hexdigest();
    }
    [Symbol.iterator]() {
        return this.#groups.entries();
    }
}
class $a2cc6e1d6eb3861b$var$PagesMapper {
    #pageNumberToId = null;
    #prevPageNumbers = null;
    #pagesNumber = 0;
    #clipboard = null;
    #savedData = null;
    get pagesNumber() {
        return this.#pagesNumber;
    }
    set pagesNumber(n) {
        if (this.#pagesNumber === n) return;
        this.#pagesNumber = n;
        this.#pageNumberToId = null;
        this.#prevPageNumbers = null;
    }
    #ensureInit() {
        if (this.#pageNumberToId) return;
        const n = this.#pagesNumber;
        const pageNumberToId = this.#pageNumberToId = new Uint32Array(n);
        for(let i = 0; i < n; i++)pageNumberToId[i] = i + 1;
        this.#prevPageNumbers = new Int32Array(pageNumberToId);
    }
    #buildIdToPageNumber() {
        const idToPageNumber = new Map();
        const pageNumberToId = this.#pageNumberToId;
        for(let i = 0, ii = this.#pagesNumber; i < ii; i++){
            const id = pageNumberToId[i];
            const pageNumbers = idToPageNumber.get(id);
            if (pageNumbers) pageNumbers.push(i + 1);
            else idToPageNumber.set(id, [
                i + 1
            ]);
        }
        return idToPageNumber;
    }
    movePages(selectedPages, pagesToMove, index) {
        this.#ensureInit();
        const pageNumberToId = this.#pageNumberToId;
        const prevIdToPageNumber = this.#buildIdToPageNumber();
        const movedCount = pagesToMove.length;
        const mappedPagesToMove = new Uint32Array(movedCount);
        let removedBeforeTarget = 0;
        for(let i = 0; i < movedCount; i++){
            const pageIndex = pagesToMove[i] - 1;
            mappedPagesToMove[i] = pageNumberToId[pageIndex];
            if (pageIndex < index) removedBeforeTarget++;
        }
        const pagesNumber = this.#pagesNumber;
        const remainingLen = pagesNumber - movedCount;
        const adjustedTarget = $a2cc6e1d6eb3861b$export$b8106b171181a554(index - removedBeforeTarget, 0, remainingLen);
        for(let i = 0, r = 0; i < pagesNumber; i++)if (!selectedPages.has(i + 1)) pageNumberToId[r++] = pageNumberToId[i];
        pageNumberToId.copyWithin(adjustedTarget + movedCount, adjustedTarget, remainingLen);
        pageNumberToId.set(mappedPagesToMove, adjustedTarget);
        this.#updatePrevPageNumbers(prevIdToPageNumber);
        if (pageNumberToId.every((id, i)=>id === i + 1)) this.#pageNumberToId = null;
    }
    deletePages(pagesToDelete) {
        this.#ensureInit();
        const pageNumberToId = this.#pageNumberToId;
        const prevIdToPageNumber = this.#buildIdToPageNumber();
        this.#savedData = {
            pageNumberToId: pageNumberToId.slice(),
            pagesNumber: this.#pagesNumber,
            prevPageNumbers: this.#prevPageNumbers.slice()
        };
        const newN = this.#pagesNumber - pagesToDelete.length;
        this.#pagesNumber = newN;
        const newPageNumberToId = this.#pageNumberToId = new Uint32Array(newN);
        this.#prevPageNumbers = new Int32Array(newN);
        let sourceIndex = 0;
        let destIndex = 0;
        for (const pageNumber of pagesToDelete){
            const pageIndex = pageNumber - 1;
            if (pageIndex !== sourceIndex) {
                newPageNumberToId.set(pageNumberToId.subarray(sourceIndex, pageIndex), destIndex);
                destIndex += pageIndex - sourceIndex;
            }
            sourceIndex = pageIndex + 1;
        }
        if (sourceIndex < pageNumberToId.length) newPageNumberToId.set(pageNumberToId.subarray(sourceIndex), destIndex);
        this.#updatePrevPageNumbers(prevIdToPageNumber, new Set(pagesToDelete));
    }
    cancelDelete() {
        if (this.#savedData) {
            this.#pageNumberToId = this.#savedData.pageNumberToId;
            this.#pagesNumber = this.#savedData.pagesNumber;
            this.#prevPageNumbers = this.#savedData.prevPageNumbers;
            this.#savedData = null;
        }
    }
    cleanSavedData() {
        this.#savedData = null;
    }
    copyPages(pagesToCopy) {
        this.#ensureInit();
        this.#clipboard = {
            pageNumbers: pagesToCopy,
            pageIds: pagesToCopy.map((n)=>this.#pageNumberToId[n - 1])
        };
    }
    cancelCopy() {
        this.#clipboard = null;
    }
    pastePages(index) {
        this.#ensureInit();
        const pageNumberToId = this.#pageNumberToId;
        const prevIdToPageNumber = this.#buildIdToPageNumber();
        const { pageNumbers: copiedPageNumbers, pageIds: copiedPageIds } = this.#clipboard;
        const newN = this.#pagesNumber + copiedPageNumbers.length;
        this.#pagesNumber = newN;
        const newPageNumberToId = this.#pageNumberToId = new Uint32Array(newN);
        this.#prevPageNumbers = new Int32Array(newN);
        newPageNumberToId.set(pageNumberToId.subarray(0, index), 0);
        newPageNumberToId.set(copiedPageIds, index);
        newPageNumberToId.set(pageNumberToId.subarray(index), index + copiedPageNumbers.length);
        this.#updatePrevPageNumbers(prevIdToPageNumber, null, index, copiedPageNumbers);
        this.#clipboard = null;
    }
    #updatePrevPageNumbers(prevIdToPageNumber, deletedPageNumbers = null, pasteIndex = -1, copiedPageNumbers = null) {
        const prevPageNumbers = this.#prevPageNumbers;
        const newPageNumberToId = this.#pageNumberToId;
        const pasteEnd = pasteIndex + (copiedPageNumbers?.length ?? 0);
        const idsIndices = new Map();
        for(let i = 0, ii = this.#pagesNumber; i < ii; i++){
            if (i >= pasteIndex && i < pasteEnd) {
                prevPageNumbers[i] = -copiedPageNumbers[i - pasteIndex];
                continue;
            }
            const id = newPageNumberToId[i];
            const oldPositions = prevIdToPageNumber.get(id);
            let j = idsIndices.get(id) || 0;
            if (deletedPageNumbers && oldPositions) while(j < oldPositions.length && deletedPageNumbers.has(oldPositions[j]))j++;
            prevPageNumbers[i] = oldPositions?.[j];
            idsIndices.set(id, j + 1);
        }
    }
    hasBeenAltered() {
        return this.#pageNumberToId !== null;
    }
    getPageMappingForSaving(idToPageNumber = null) {
        idToPageNumber ??= this.#buildIdToPageNumber();
        let nCopy = 0;
        for (const pageNumbers of idToPageNumber.values())nCopy = Math.max(nCopy, pageNumbers.length);
        const extractParams = new Array(nCopy);
        for(let i = 0; i < nCopy; i++)extractParams[i] = {
            document: null,
            pageIndices: [],
            includePages: []
        };
        for (const [id, pageNumbers] of idToPageNumber)for(let i = 0, ii = pageNumbers.length; i < ii; i++)extractParams[i].includePages.push([
            id - 1,
            pageNumbers[i] - 1
        ]);
        for (const { includePages: includePages, pageIndices: pageIndices } of extractParams){
            includePages.sort((a, b)=>a[0] - b[0]);
            for(let i = 0, ii = includePages.length; i < ii; i++){
                pageIndices.push(includePages[i][1]);
                includePages[i] = includePages[i][0];
            }
        }
        return extractParams;
    }
    extractPages(extractedPageNumbers) {
        extractedPageNumbers = Array.from(extractedPageNumbers).sort((a, b)=>a - b);
        const usedIds = new Map();
        for(let i = 0, ii = extractedPageNumbers.length; i < ii; i++){
            const id = this.getPageId(extractedPageNumbers[i]);
            const usedPageNumbers = usedIds.getOrInsertComputed(id, $a2cc6e1d6eb3861b$export$be9af9a47496243a);
            usedPageNumbers.push(i + 1);
        }
        return this.getPageMappingForSaving(usedIds);
    }
    getPrevPageNumber(pageNumber) {
        return this.#prevPageNumbers?.[pageNumber - 1] ?? 0;
    }
    getPageNumber(id) {
        if (!this.#pageNumberToId) return id;
        const pageNumberToId = this.#pageNumberToId;
        for(let i = 0, ii = this.#pagesNumber; i < ii; i++){
            if (pageNumberToId[i] === id) return i + 1;
        }
        return 0;
    }
    getPageId(pageNumber) {
        return this.#pageNumberToId?.[pageNumber - 1] ?? pageNumber;
    }
    getMapping() {
        return this.#pageNumberToId?.subarray(0, this.pagesNumber);
    }
}
const $a2cc6e1d6eb3861b$var$INITIAL_DATA = Symbol("INITIAL_DATA");
const $a2cc6e1d6eb3861b$var$dataObj = ()=>({
        ...Promise.withResolvers(),
        data: $a2cc6e1d6eb3861b$var$INITIAL_DATA
    });
class $a2cc6e1d6eb3861b$var$PDFObjects {
    #objs = new Map();
    get(objId, callback = null) {
        if (callback) {
            const obj = this.#objs.getOrInsertComputed(objId, $a2cc6e1d6eb3861b$var$dataObj);
            obj.promise.then(()=>callback(obj.data));
            return null;
        }
        const obj = this.#objs.get(objId);
        if (!obj || obj.data === $a2cc6e1d6eb3861b$var$INITIAL_DATA) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
        return obj.data;
    }
    has(objId) {
        const obj = this.#objs.get(objId);
        return !!obj && obj.data !== $a2cc6e1d6eb3861b$var$INITIAL_DATA;
    }
    delete(objId) {
        const obj = this.#objs.get(objId);
        if (!obj || obj.data === $a2cc6e1d6eb3861b$var$INITIAL_DATA) return false;
        this.#objs.delete(objId);
        return true;
    }
    resolve(objId, data = null) {
        const obj = this.#objs.getOrInsertComputed(objId, $a2cc6e1d6eb3861b$var$dataObj);
        if (obj.data !== $a2cc6e1d6eb3861b$var$INITIAL_DATA) throw new Error(`Object already resolved ${objId}.`);
        obj.data = data;
        obj.resolve();
    }
    clear() {
        for (const { data: data } of this.#objs.values())data?.bitmap?.close();
        this.#objs.clear();
    }
    *[Symbol.iterator]() {
        for (const [objId, { data: data }] of this.#objs)if (data !== $a2cc6e1d6eb3861b$var$INITIAL_DATA) yield [
            objId,
            data
        ];
    }
}
const $a2cc6e1d6eb3861b$var$MAX_TEXT_DIVS_TO_RENDER = 100000;
const $a2cc6e1d6eb3861b$var$DEFAULT_FONT_SIZE = 30;
class $a2cc6e1d6eb3861b$export$fdbdc423a78c5262 {
    #capability = Promise.withResolvers();
    #container = null;
    #disableProcessItems = false;
    #fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
    #imagesHandler = null;
    #lang = null;
    #layoutTextParams = null;
    #pageHeight = 0;
    #pageWidth = 0;
    #reader = null;
    #rootContainer = null;
    #rotation = 0;
    #scale = 0;
    #styleCache = Object.create(null);
    #textContentItemsStr = [];
    #textContentSource = null;
    #textDivs = [];
    #textDivProperties = new WeakMap();
    #transform = null;
    static #ascentCache = new Map();
    static #canvasContexts = new Map();
    static #canvasCtxFonts = new WeakMap();
    static #minFontSize = null;
    static #pendingTextLayers = new Set();
    constructor({ textContentSource: textContentSource, images: images, container: container, viewport: viewport }){
        if (textContentSource instanceof ReadableStream) this.#textContentSource = textContentSource;
        else if (typeof textContentSource === "object") this.#textContentSource = new ReadableStream({
            start (controller) {
                controller.enqueue(textContentSource);
                controller.close();
            }
        });
        else throw new Error('No "textContentSource" parameter specified.');
        this.#container = this.#rootContainer = container;
        this.#imagesHandler = images;
        this.#scale = viewport.scale * $a2cc6e1d6eb3861b$export$f16a99f63bccd50b.pixelRatio;
        this.#rotation = viewport.rotation;
        this.#layoutTextParams = {
            div: null,
            properties: null,
            ctx: null
        };
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        this.#transform = [
            1,
            0,
            0,
            -1,
            -pageX,
            pageY + pageHeight
        ];
        this.#pageWidth = pageWidth;
        this.#pageHeight = pageHeight;
        $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.#ensureMinFontSizeComputed();
        container.style.setProperty("--min-font-size", $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.#minFontSize);
        $a2cc6e1d6eb3861b$export$af0a15a86e590226(container, viewport);
        this.#capability.promise.finally(()=>{
            $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.#pendingTextLayers.delete(this);
            this.#layoutTextParams = null;
            this.#styleCache = null;
        }).catch(()=>{});
    }
    static get fontFamilyMap() {
        const { isWindows: isWindows, isFirefox: isFirefox } = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform;
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "fontFamilyMap", new Map([
            [
                "sans-serif",
                `${isWindows && isFirefox ? "Calibri, " : ""}sans-serif`
            ],
            [
                "monospace",
                `${isWindows && isFirefox ? "Lucida Console, " : ""}monospace`
            ]
        ]));
    }
    render() {
        if (this.#imagesHandler) this.#container.append(this.#imagesHandler.render());
        const pump = ()=>{
            this.#reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    this.#capability.resolve();
                    return;
                }
                this.#lang ??= value.lang;
                Object.assign(this.#styleCache, value.styles);
                this.#processItems(value.items);
                pump();
            }, this.#capability.reject);
        };
        this.#reader = this.#textContentSource.getReader();
        $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.#pendingTextLayers.add(this);
        pump();
        return this.#capability.promise;
    }
    update({ viewport: viewport, onBefore: onBefore = null }) {
        const scale = viewport.scale * $a2cc6e1d6eb3861b$export$f16a99f63bccd50b.pixelRatio;
        const rotation = viewport.rotation;
        if (rotation !== this.#rotation) {
            onBefore?.();
            this.#rotation = rotation;
            $a2cc6e1d6eb3861b$export$af0a15a86e590226(this.#rootContainer, {
                rotation: rotation
            });
        }
        if (scale !== this.#scale) {
            onBefore?.();
            this.#scale = scale;
            const params = {
                div: null,
                properties: null,
                ctx: $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.#getCtx(this.#lang)
            };
            for (const div of this.#textDivs){
                params.properties = this.#textDivProperties.get(div);
                params.div = div;
                this.#layout(params);
            }
        }
    }
    cancel() {
        const abortEx = new $a2cc6e1d6eb3861b$export$d0e978393d193d1a("TextLayer task cancelled.");
        this.#reader?.cancel(abortEx).catch(()=>{});
        this.#reader = null;
        this.#capability.reject(abortEx);
    }
    get textDivs() {
        return this.#textDivs;
    }
    get textContentItemsStr() {
        return this.#textContentItemsStr;
    }
    #processItems(items) {
        if (this.#disableProcessItems) return;
        this.#layoutTextParams.ctx ??= $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.#getCtx(this.#lang);
        const textDivs = this.#textDivs, textContentItemsStr = this.#textContentItemsStr;
        for (const item of items){
            if (textDivs.length > $a2cc6e1d6eb3861b$var$MAX_TEXT_DIVS_TO_RENDER) {
                $a2cc6e1d6eb3861b$var$warn("Ignoring additional textDivs for performance reasons.");
                this.#disableProcessItems = true;
                return;
            }
            if (item.str === undefined) {
                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                    const parent = this.#container;
                    this.#container = document.createElement("span");
                    this.#container.classList.add("markedContent");
                    if (item.id) this.#container.setAttribute("id", `${item.id}`);
                    if (item.tag === "Artifact") this.#container.ariaHidden = true;
                    parent.append(this.#container);
                } else if (item.type === "endMarkedContent") this.#container = this.#container.parentNode;
                continue;
            }
            textContentItemsStr.push(item.str);
            this.#appendText(item);
        }
    }
    #appendText(geom) {
        const textDiv = document.createElement("span");
        const textDivProperties = {
            angle: 0,
            canvasWidth: 0,
            hasText: geom.str !== "",
            hasEOL: geom.hasEOL,
            fontSize: 0
        };
        this.#textDivs.push(textDiv);
        const tx = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.transform(this.#transform, geom.transform);
        let angle = Math.atan2(tx[1], tx[0]);
        const style = this.#styleCache[geom.fontName];
        if (style.vertical) angle += Math.PI / 2;
        let fontFamily = this.#fontInspectorEnabled && style.fontSubstitution || style.fontFamily;
        fontFamily = $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.fontFamilyMap.get(fontFamily) || fontFamily;
        const fontHeight = Math.hypot(tx[2], tx[3]);
        const fontAscent = fontHeight * $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.#getAscent(fontFamily, style, this.#lang);
        let left, top;
        if (angle === 0) {
            left = tx[4];
            top = tx[5] - fontAscent;
        } else {
            left = tx[4] + fontAscent * Math.sin(angle);
            top = tx[5] - fontAscent * Math.cos(angle);
        }
        const divStyle = textDiv.style;
        divStyle.left = `${(100 * left / this.#pageWidth).toFixed(2)}%`;
        divStyle.top = `${(100 * top / this.#pageHeight).toFixed(2)}%`;
        divStyle.setProperty("--font-height", `${fontHeight.toFixed(2)}px`);
        divStyle.fontFamily = fontFamily;
        textDivProperties.fontSize = fontHeight;
        textDiv.setAttribute("role", "presentation");
        textDiv.textContent = geom.str;
        textDiv.dir = geom.dir;
        if (this.#fontInspectorEnabled) textDiv.dataset.fontName = style.fontSubstitutionLoadedName || geom.fontName;
        if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
        let shouldScaleText = false;
        if (geom.str.length > 1) shouldScaleText = true;
        else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
            const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
            if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
        }
        if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
        this.#textDivProperties.set(textDiv, textDivProperties);
        this.#layoutTextParams.div = textDiv;
        this.#layoutTextParams.properties = textDivProperties;
        this.#layout(this.#layoutTextParams);
        if (textDivProperties.hasText) this.#container.append(textDiv);
        if (textDivProperties.hasEOL) {
            const br = document.createElement("br");
            br.setAttribute("role", "presentation");
            this.#container.append(br);
        }
    }
    #layout(params) {
        const { div: div, properties: properties, ctx: ctx } = params;
        const { style: style } = div;
        if (properties.canvasWidth !== 0 && properties.hasText) {
            const { fontFamily: fontFamily } = style;
            const { canvasWidth: canvasWidth, fontSize: fontSize } = properties;
            $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.#ensureCtxFont(ctx, fontSize * this.#scale, fontFamily);
            const { width: width } = ctx.measureText(div.textContent);
            if (width > 0) style.setProperty("--scale-x", canvasWidth * this.#scale / width);
        }
        if (properties.angle !== 0) style.setProperty("--rotate", `${properties.angle}deg`);
    }
    static cleanup() {
        if (this.#pendingTextLayers.size > 0) return;
        this.#ascentCache.clear();
        for (const { canvas: canvas } of this.#canvasContexts.values())canvas.remove();
        this.#canvasContexts.clear();
    }
    static #getCtx(lang = null) {
        let ctx = this.#canvasContexts.get(lang ||= "");
        if (!ctx) {
            const canvas = document.createElement("canvas");
            canvas.style.cssText = "position:absolute;top:0;left:0;width:0;height:0;display:none;letter-spacing:normal;word-spacing:normal";
            canvas.lang = lang;
            document.body.append(canvas);
            ctx = canvas.getContext("2d", {
                alpha: false,
                willReadFrequently: true
            });
            this.#canvasContexts.set(lang, ctx);
            this.#canvasCtxFonts.set(ctx, {
                size: 0,
                family: ""
            });
        }
        return ctx;
    }
    static #ensureCtxFont(ctx, size, family) {
        const cached = this.#canvasCtxFonts.get(ctx);
        if (size === cached.size && family === cached.family) return;
        ctx.font = `${size}px ${family}`;
        cached.size = size;
        cached.family = family;
    }
    static #ensureMinFontSizeComputed() {
        if (this.#minFontSize !== null) return;
        const div = document.createElement("div");
        div.style.opacity = 0;
        div.style.lineHeight = 1;
        div.style.fontSize = "1px";
        div.style.position = "absolute";
        div.textContent = "X";
        document.body.append(div);
        this.#minFontSize = div.getBoundingClientRect().height;
        div.remove();
    }
    static #getAscent(fontFamily, style, lang) {
        const cachedAscent = this.#ascentCache.get(fontFamily);
        if (cachedAscent) return cachedAscent;
        const ctx = this.#getCtx(lang);
        ctx.canvas.width = ctx.canvas.height = $a2cc6e1d6eb3861b$var$DEFAULT_FONT_SIZE;
        this.#ensureCtxFont(ctx, $a2cc6e1d6eb3861b$var$DEFAULT_FONT_SIZE, fontFamily);
        const metrics = ctx.measureText("");
        const ascent = metrics.fontBoundingBoxAscent;
        const descent = Math.abs(metrics.fontBoundingBoxDescent);
        ctx.canvas.width = ctx.canvas.height = 0;
        let ratio = 0.8;
        if (ascent) ratio = ascent / (ascent + descent);
        else {
            if ($a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform.isFirefox) $a2cc6e1d6eb3861b$var$warn("Enable the `dom.textMetrics.fontBoundingBox.enabled` preference in `about:config` to improve TextLayer rendering.");
            if (style.ascent) ratio = style.ascent;
            else if (style.descent) ratio = 1 + style.descent;
        }
        this.#ascentCache.set(fontFamily, ratio);
        return ratio;
    }
}
const $a2cc6e1d6eb3861b$var$RENDERING_CANCELLED_TIMEOUT = 100;
function $a2cc6e1d6eb3861b$export$f65ca476c09acec0(src = {}) {
    const task = new $a2cc6e1d6eb3861b$var$PDFDocumentLoadingTask();
    const { docId: docId } = task;
    const url = src.url ? $a2cc6e1d6eb3861b$var$getUrlProp(src.url) : null;
    const data = src.data ? $a2cc6e1d6eb3861b$var$getDataProp(src.data) : null;
    const httpHeaders = src.httpHeaders || null;
    const withCredentials = src.withCredentials === true;
    const password = src.password ?? null;
    const rangeTransport = src.range instanceof $a2cc6e1d6eb3861b$export$c06899d9d7bce9ab ? src.range : null;
    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : 2 ** 16;
    let worker = src.worker instanceof $a2cc6e1d6eb3861b$export$84e2e9f37426b265 ? src.worker : null;
    const verbosity = src.verbosity;
    const docBaseUrl = typeof src.docBaseUrl === "string" && !$a2cc6e1d6eb3861b$export$f67aae4532d8295b(src.docBaseUrl) ? src.docBaseUrl : null;
    const cMapUrl = $a2cc6e1d6eb3861b$var$getFactoryUrlProp(src.cMapUrl);
    const cMapPacked = src.cMapPacked !== false;
    const iccUrl = $a2cc6e1d6eb3861b$var$getFactoryUrlProp(src.iccUrl);
    const standardFontDataUrl = $a2cc6e1d6eb3861b$var$getFactoryUrlProp(src.standardFontDataUrl);
    const wasmUrl = $a2cc6e1d6eb3861b$var$getFactoryUrlProp(src.wasmUrl);
    const ignoreErrors = src.stopAtErrors !== true;
    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !$a2cc6e1d6eb3861b$var$isNodeJS;
    const isImageDecoderSupported = typeof src.isImageDecoderSupported === "boolean" ? src.isImageDecoderSupported : !$a2cc6e1d6eb3861b$var$isNodeJS;
    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : $a2cc6e1d6eb3861b$var$isNodeJS;
    const fontExtraProperties = src.fontExtraProperties === true;
    const enableXfa = src.enableXfa === true;
    const ownerDocument = src.ownerDocument || globalThis.document;
    const disableRange = src.disableRange === true;
    const disableStream = src.disableStream === true;
    const disableAutoFetch = src.disableAutoFetch === true;
    const pdfBug = src.pdfBug === true;
    const CanvasFactory = src.CanvasFactory || ($a2cc6e1d6eb3861b$var$isNodeJS ? $a2cc6e1d6eb3861b$var$NodeCanvasFactory : $a2cc6e1d6eb3861b$var$DOMCanvasFactory);
    const FilterFactory = src.FilterFactory || ($a2cc6e1d6eb3861b$var$isNodeJS ? $a2cc6e1d6eb3861b$var$NodeFilterFactory : $a2cc6e1d6eb3861b$var$DOMFilterFactory);
    const BinaryDataFactory = src.BinaryDataFactory || ($a2cc6e1d6eb3861b$var$isNodeJS ? $a2cc6e1d6eb3861b$var$NodeBinaryDataFactory : $a2cc6e1d6eb3861b$var$DOMBinaryDataFactory);
    const enableHWA = src.enableHWA === true;
    const enableWebGPU = src.enableWebGPU === true;
    const gpuPromise = enableWebGPU ? $a2cc6e1d6eb3861b$var$initGPU() : Promise.resolve(false);
    const useWasm = src.useWasm !== false;
    const pagesMapper = src.pagesMapper || new $a2cc6e1d6eb3861b$var$PagesMapper();
    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !$a2cc6e1d6eb3861b$var$isNodeJS && !disableFontFace;
    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : !!(BinaryDataFactory === $a2cc6e1d6eb3861b$var$DOMBinaryDataFactory && cMapUrl && cMapPacked && standardFontDataUrl && wasmUrl && $a2cc6e1d6eb3861b$var$isValidFetchUrl(cMapUrl, document.baseURI) && $a2cc6e1d6eb3861b$var$isValidFetchUrl(standardFontDataUrl, document.baseURI) && $a2cc6e1d6eb3861b$var$isValidFetchUrl(wasmUrl, document.baseURI));
    const styleElement = null;
    $a2cc6e1d6eb3861b$var$setVerbosityLevel(verbosity);
    const transportFactory = {
        canvasFactory: new CanvasFactory({
            ownerDocument: ownerDocument,
            enableHWA: enableHWA
        }),
        filterFactory: new FilterFactory({
            docId: docId,
            ownerDocument: ownerDocument
        }),
        binaryDataFactory: useWorkerFetch ? null : new BinaryDataFactory({
            cMapUrl: cMapUrl,
            standardFontDataUrl: standardFontDataUrl,
            wasmUrl: wasmUrl
        })
    };
    if (!worker) {
        worker = $a2cc6e1d6eb3861b$export$84e2e9f37426b265.create({
            verbosity: verbosity,
            port: $a2cc6e1d6eb3861b$export$edf38ba293eb934.workerPort
        });
        task._worker = worker;
    }
    const docParams = {
        docId: docId,
        apiVersion: "6.0.227",
        data: data,
        password: password,
        disableAutoFetch: disableAutoFetch,
        rangeChunkSize: rangeChunkSize,
        docBaseUrl: docBaseUrl,
        enableXfa: enableXfa,
        evaluatorOptions: {
            maxImageSize: maxImageSize,
            disableFontFace: disableFontFace,
            ignoreErrors: ignoreErrors,
            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
            isImageDecoderSupported: isImageDecoderSupported,
            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
            fontExtraProperties: fontExtraProperties,
            useSystemFonts: useSystemFonts,
            useWasm: useWasm,
            useWorkerFetch: useWorkerFetch,
            cMapUrl: cMapUrl,
            cMapPacked: cMapPacked,
            iccUrl: iccUrl,
            standardFontDataUrl: standardFontDataUrl,
            wasmUrl: wasmUrl,
            hasGPU: false
        }
    };
    const transportParams = {
        ownerDocument: ownerDocument,
        pdfBug: pdfBug,
        styleElement: styleElement,
        enableHWA: enableHWA,
        loadingParams: {
            disableAutoFetch: disableAutoFetch,
            enableXfa: enableXfa
        }
    };
    Promise.all([
        worker.promise,
        gpuPromise
    ]).then(function([, hasGPU]) {
        if (worker.destroyed) throw new Error("Worker was destroyed");
        docParams.evaluatorOptions.hasGPU = hasGPU;
        const workerIdPromise = worker.messageHandler.sendWithPromise("GetDocRequest", docParams, data ? [
            data.buffer
        ] : null);
        let networkStream;
        if (data) ;
        else if (rangeTransport) networkStream = new $a2cc6e1d6eb3861b$var$PDFDataTransportStream({
            pdfDataRangeTransport: rangeTransport,
            disableRange: disableRange,
            disableStream: disableStream
        });
        else if (url) {
            const NetworkStream = $a2cc6e1d6eb3861b$var$getNetworkStream(url);
            networkStream = new NetworkStream({
                url: url,
                httpHeaders: httpHeaders,
                withCredentials: withCredentials,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange,
                disableStream: disableStream
            });
        } else throw new Error("getDocument - expected either `data`, `range`, or `url` parameter.");
        return workerIdPromise.then((workerId)=>{
            if (worker.destroyed) throw new Error("Worker was destroyed");
            const messageHandler = new $a2cc6e1d6eb3861b$var$MessageHandler(docId, workerId, worker.port);
            const transport = new $a2cc6e1d6eb3861b$var$WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory, pagesMapper);
            task._transport = transport;
            if (task.destroyed) throw new Error("Loading aborted");
            messageHandler.send("Ready", null);
        });
    }).catch(task._capability.reject).finally(task._setupCapability.resolve);
    return task;
}
class $a2cc6e1d6eb3861b$var$PDFDocumentLoadingTask {
    static #docId = 0;
    _capability = Promise.withResolvers();
    _setupCapability = Promise.withResolvers();
    _transport = null;
    _worker = null;
    docId = `d${$a2cc6e1d6eb3861b$var$PDFDocumentLoadingTask.#docId++}`;
    destroyed = false;
    onPassword = null;
    onProgress = null;
    get promise() {
        return this._capability.promise;
    }
    async destroy() {
        this.destroyed = true;
        this._capability.promise.catch(()=>{});
        try {
            if (this._worker?.port) this._worker._pendingDestroy = true;
            await this._setupCapability.promise;
            await this._transport?.destroy();
        } catch (ex) {
            if (this._worker?.port) delete this._worker._pendingDestroy;
            throw ex;
        }
        this._transport = null;
        this._worker?.destroy();
        this._worker = null;
    }
    async getData() {
        return this._transport.getData();
    }
}
class $a2cc6e1d6eb3861b$export$c06899d9d7bce9ab {
    #capability = Promise.withResolvers();
    #listener = null;
    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
        this.length = length;
        this.initialData = initialData;
        this.progressiveDone = progressiveDone;
        this.contentDispositionFilename = contentDispositionFilename;
    }
    onDataRange(begin, chunk) {
        this.#listener({
            type: "range",
            begin: begin,
            chunk: chunk
        });
    }
    onDataProgressiveRead(chunk) {
        this.#capability.promise.then(()=>{
            this.#listener({
                type: "progressiveRead",
                chunk: chunk
            });
        });
    }
    onDataProgressiveDone() {
        this.#capability.promise.then(()=>{
            this.#listener({
                type: "progressiveDone"
            });
        });
    }
    transportReady(listener) {
        this.#listener = listener;
        this.#capability.resolve();
    }
    requestDataRange(begin, end) {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method PDFDataRangeTransport.requestDataRange");
    }
    abort() {}
}
class $a2cc6e1d6eb3861b$var$PDFDocumentProxy {
    constructor(pdfInfo, transport){
        this._pdfInfo = pdfInfo;
        this._transport = transport;
    }
    get pagesMapper() {
        return this._transport.pagesMapper;
    }
    get annotationStorage() {
        return this._transport.annotationStorage;
    }
    get canvasFactory() {
        return this._transport.canvasFactory;
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get numPages() {
        return this._pdfInfo.numPages;
    }
    get fingerprints() {
        return this._pdfInfo.fingerprints;
    }
    get isPureXfa() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    get allXfaHtml() {
        return this._transport._htmlForXfa;
    }
    getPage(pageNumber) {
        return this._transport.getPage(pageNumber);
    }
    getPageIndex(ref) {
        return this._transport.getPageIndex(ref);
    }
    getDestinations() {
        return this._transport.getDestinations();
    }
    getDestination(id) {
        return this._transport.getDestination(id);
    }
    getPageLabels() {
        return this._transport.getPageLabels();
    }
    getPageLayout() {
        return this._transport.getPageLayout();
    }
    getPageMode() {
        return this._transport.getPageMode();
    }
    getViewerPreferences() {
        return this._transport.getViewerPreferences();
    }
    getOpenAction() {
        return this._transport.getOpenAction();
    }
    getAttachments() {
        return this._transport.getAttachments();
    }
    getAnnotationsByType(types, pageIndexesToSkip) {
        return this._transport.getAnnotationsByType(types, pageIndexesToSkip);
    }
    getJSActions() {
        return this._transport.getDocJSActions();
    }
    getOutline() {
        return this._transport.getOutline();
    }
    getOptionalContentConfig({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getOptionalContentConfig(renderingIntent);
    }
    getPermissions() {
        return this._transport.getPermissions();
    }
    getMetadata() {
        return this._transport.getMetadata();
    }
    getMarkInfo() {
        return this._transport.getMarkInfo();
    }
    getData() {
        return this._transport.getData();
    }
    saveDocument() {
        return this._transport.saveDocument();
    }
    extractPages(pageInfos) {
        return this._transport.extractPages(pageInfos);
    }
    getDownloadInfo() {
        return this._transport.downloadInfoCapability.promise;
    }
    getRawData(data) {
        return this._transport.getRawData(data);
    }
    cleanup(keepLoadedFonts = false) {
        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
    }
    cachedPageNumber(ref) {
        return this._transport.cachedPageNumber(ref);
    }
    get loadingParams() {
        return this._transport.loadingParams;
    }
    get loadingTask() {
        return this._transport.loadingTask;
    }
    getFieldObjects() {
        return this._transport.getFieldObjects();
    }
    hasJSActions() {
        return this._transport.hasJSActions();
    }
    getCalculationOrderIds() {
        return this._transport.getCalculationOrderIds();
    }
}
class $a2cc6e1d6eb3861b$var$PDFPageProxy {
    #pendingCleanup = false;
    #pagesMapper = null;
    constructor(pageIndex, pageInfo, transport, pagesMapper, pdfBug = false){
        this._pageIndex = pageIndex;
        this._pageInfo = pageInfo;
        this._transport = transport;
        this._stats = pdfBug ? new $a2cc6e1d6eb3861b$var$StatTimer() : null;
        this._pdfBug = pdfBug;
        this.commonObjs = transport.commonObjs;
        this.objs = new $a2cc6e1d6eb3861b$var$PDFObjects();
        this._intentStates = new Map();
        this.destroyed = false;
        this.recordedBBoxes = null;
        this.#pagesMapper = pagesMapper;
        this.imageCoordinates = null;
    }
    clone(id) {
        const clone = new $a2cc6e1d6eb3861b$var$PDFPageProxy(id, this._pageInfo, this._transport, this.#pagesMapper, this._pdfBug);
        clone.clonedFromIndex = this.clonedFromIndex ?? this._pageIndex;
        this._transport.updatePage(clone);
        return clone;
    }
    get pageNumber() {
        return this._pageIndex + 1;
    }
    set pageNumber(value) {
        this._pageIndex = value - 1;
        this._transport.updatePage(this);
    }
    get rotate() {
        return this._pageInfo.rotate;
    }
    get ref() {
        return this._pageInfo.ref;
    }
    get userUnit() {
        return this._pageInfo.userUnit;
    }
    get view() {
        return this._pageInfo.view;
    }
    getViewport({ scale: scale, rotation: rotation = this.rotate, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false } = {}) {
        return new $a2cc6e1d6eb3861b$var$PageViewport({
            viewBox: this.view,
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    getAnnotations({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getAnnotations(this._pageIndex, renderingIntent);
    }
    getJSActions() {
        return this._transport.getPageJSActions(this._pageIndex);
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get isPureXfa() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    async getXfa() {
        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
    }
    render({ canvasContext: canvasContext, canvas: canvas = canvasContext.canvas, viewport: viewport, intent: intent = "display", annotationMode: annotationMode = $a2cc6e1d6eb3861b$export$5a7af0c07e33392e.ENABLE, transform: transform = null, background: background = null, optionalContentConfigPromise: optionalContentConfigPromise = null, annotationCanvasMap: annotationCanvasMap = null, pageColors: pageColors = null, printAnnotationStorage: printAnnotationStorage = null, isEditing: isEditing = false, recordImages: recordImages = false, recordOperations: recordOperations = false, operationsFilter: operationsFilter = null }) {
        this._stats?.time("Overall");
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing);
        const { renderingIntent: renderingIntent, cacheKey: cacheKey } = intentArgs;
        this.#pendingCleanup = false;
        optionalContentConfigPromise ||= this._transport.getOptionalContentConfig(renderingIntent);
        const intentState = this._intentStates.getOrInsertComputed(cacheKey, $a2cc6e1d6eb3861b$export$5b3b706fb9845c88);
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        const intentPrint = !!(renderingIntent & $a2cc6e1d6eb3861b$var$RenderingIntentFlag.PRINT);
        if (!intentState.displayReadyCapability) {
            intentState.displayReadyCapability = Promise.withResolvers();
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        const recordForDebugger = !!(this._pdfBug && globalThis.StepperManager?.enabled);
        const shouldRecordOperations = !!canvas && !this.recordedBBoxes && (recordOperations || recordForDebugger);
        const shouldRecordImages = !!canvas && !this.imageCoordinates && recordImages;
        const complete = (error)=>{
            intentState.renderTasks.delete(internalRenderTask);
            if (shouldRecordOperations) {
                const recordedBBoxes = internalRenderTask.gfx?.dependencyTracker.take();
                if (recordedBBoxes) {
                    internalRenderTask.stepper?.setOperatorBBoxes(recordedBBoxes, internalRenderTask.gfx.dependencyTracker.takeDebugMetadata());
                    if (recordOperations) this.recordedBBoxes = recordedBBoxes;
                }
            }
            if (shouldRecordImages && !error) this.imageCoordinates = internalRenderTask.gfx?.imagesTracker.take();
            if (intentPrint) this.#pendingCleanup = true;
            this.#tryCleanup();
            if (error) {
                internalRenderTask.capability.reject(error);
                this._abortOperatorList({
                    intentState: intentState,
                    reason: error instanceof Error ? error : new Error(error)
                });
            } else internalRenderTask.capability.resolve();
            if (this._stats) {
                this._stats.timeEnd("Rendering");
                this._stats.timeEnd("Overall");
                if (globalThis.Stats?.enabled) globalThis.Stats.add(this.pageNumber, this._stats);
            }
        };
        let dependencyTracker = null;
        let bboxTracker = null;
        if (shouldRecordOperations || shouldRecordImages) bboxTracker = new $a2cc6e1d6eb3861b$var$CanvasBBoxTracker(canvas, intentState.operatorList.length);
        if (shouldRecordOperations) dependencyTracker = new $a2cc6e1d6eb3861b$var$CanvasDependencyTracker(bboxTracker, recordForDebugger);
        const internalRenderTask = new $a2cc6e1d6eb3861b$var$InternalRenderTask({
            callback: complete,
            params: {
                canvas: canvas,
                canvasContext: canvasContext,
                dependencyTracker: dependencyTracker ?? bboxTracker,
                imagesTracker: shouldRecordImages ? new $a2cc6e1d6eb3861b$var$CanvasImagesTracker(canvas) : null,
                viewport: viewport,
                transform: transform,
                background: background
            },
            objs: this.objs,
            commonObjs: this.commonObjs,
            annotationCanvasMap: annotationCanvasMap,
            operatorList: intentState.operatorList,
            pageIndex: this._pageIndex,
            canvasFactory: this._transport.canvasFactory,
            filterFactory: this._transport.filterFactory,
            useRequestAnimationFrame: !intentPrint,
            pdfBug: this._pdfBug,
            pageColors: pageColors,
            enableHWA: this._transport.enableHWA,
            operationsFilter: operationsFilter
        });
        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
        const renderTask = internalRenderTask.task;
        Promise.all([
            intentState.displayReadyCapability.promise,
            optionalContentConfigPromise
        ]).then(([transparency, optionalContentConfig])=>{
            if (this.destroyed) {
                complete();
                return;
            }
            this._stats?.time("Rendering");
            if (!(optionalContentConfig.renderingIntent & renderingIntent)) throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.");
            internalRenderTask.initializeGraphics({
                transparency: transparency,
                optionalContentConfig: optionalContentConfig
            });
            internalRenderTask.operatorListChanged();
        }).catch(complete);
        return renderTask;
    }
    getOperatorList({ intent: intent = "display", annotationMode: annotationMode = $a2cc6e1d6eb3861b$export$5a7af0c07e33392e.ENABLE, printAnnotationStorage: printAnnotationStorage = null, isEditing: isEditing = false } = {}) {
        function operatorListChanged() {
            if (intentState.operatorList.lastChunk) {
                intentState.opListReadCapability.resolve(intentState.operatorList);
                intentState.renderTasks.delete(opListTask);
            }
        }
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing, true);
        const intentState = this._intentStates.getOrInsertComputed(intentArgs.cacheKey, $a2cc6e1d6eb3861b$export$5b3b706fb9845c88);
        let opListTask;
        if (!intentState.opListReadCapability) {
            opListTask = Object.create(null);
            opListTask.operatorListChanged = operatorListChanged;
            intentState.opListReadCapability = Promise.withResolvers();
            (intentState.renderTasks ||= new Set()).add(opListTask);
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        return intentState.opListReadCapability.promise;
    }
    streamTextContent({ includeMarkedContent: includeMarkedContent = false, disableNormalization: disableNormalization = false } = {}) {
        const TEXT_CONTENT_CHUNK_SIZE = 100;
        return this._transport.messageHandler.sendWithStream("GetTextContent", {
            pageId: this.#pagesMapper.getPageId(this._pageIndex + 1) - 1,
            pageIndex: this._pageIndex,
            includeMarkedContent: includeMarkedContent === true,
            disableNormalization: disableNormalization === true
        }, {
            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
            size (textContent) {
                return textContent.items.length;
            }
        });
    }
    async getTextContent(params = {}) {
        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>$a2cc6e1d6eb3861b$var$XfaText.textContent(xfa));
        const readableStream = this.streamTextContent(params);
        const textContent = {
            items: [],
            styles: Object.create(null),
            lang: null
        };
        for await (const value of readableStream){
            textContent.lang ??= value.lang;
            Object.assign(textContent.styles, value.styles);
            textContent.items.push(...value.items);
        }
        return textContent;
    }
    getStructTree() {
        return this._transport.getStructTree(this._pageIndex);
    }
    _destroy() {
        this.destroyed = true;
        const waitOn = [];
        for (const intentState of this._intentStates.values()){
            this._abortOperatorList({
                intentState: intentState,
                reason: new Error("Page was destroyed."),
                force: true
            });
            if (intentState.opListReadCapability) continue;
            for (const internalRenderTask of intentState.renderTasks){
                waitOn.push(internalRenderTask.completed);
                internalRenderTask.cancel();
            }
        }
        this.objs.clear();
        this.#pendingCleanup = false;
        return Promise.all(waitOn);
    }
    cleanup(resetStats = false) {
        this.#pendingCleanup = true;
        const success = this.#tryCleanup();
        if (resetStats && success) this._stats &&= new $a2cc6e1d6eb3861b$var$StatTimer();
        return success;
    }
    #tryCleanup() {
        if (!this.#pendingCleanup || this.destroyed) return false;
        for (const { renderTasks: renderTasks, operatorList: operatorList } of this._intentStates.values()){
            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
        }
        this._intentStates.clear();
        this.objs.clear();
        this.#pendingCleanup = false;
        return true;
    }
    _startRenderPage(transparency, cacheKey) {
        const intentState = this._intentStates.get(cacheKey);
        if (!intentState) return;
        this._stats?.timeEnd("Page Request");
        intentState.displayReadyCapability?.resolve(transparency);
    }
    _renderPageChunk(operatorListChunk, intentState) {
        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
        }
        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
        if (operatorListChunk.lastChunk) this.#tryCleanup();
    }
    _pumpOperatorList({ renderingIntent: renderingIntent, cacheKey: cacheKey, annotationStorageSerializable: annotationStorageSerializable, modifiedIds: modifiedIds }) {
        const { map: map, transfer: transfer } = annotationStorageSerializable;
        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
            pageId: this.#pagesMapper.getPageId(this._pageIndex + 1) - 1,
            pageIndex: this._pageIndex,
            intent: renderingIntent,
            cacheKey: cacheKey,
            annotationStorage: map,
            modifiedIds: modifiedIds
        }, undefined, transfer);
        const reader = readableStream.getReader();
        const intentState = this._intentStates.get(cacheKey);
        intentState.streamReader = reader;
        const pump = ()=>{
            reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    intentState.streamReader = null;
                    return;
                }
                if (this._transport.destroyed) return;
                this._renderPageChunk(value, intentState);
                pump();
            }, (reason)=>{
                intentState.streamReader = null;
                if (this._transport.destroyed) return;
                if (intentState.operatorList) {
                    intentState.operatorList.lastChunk = true;
                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                    this.#tryCleanup();
                }
                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                else throw reason;
            });
        };
        pump();
    }
    _abortOperatorList({ intentState: intentState, reason: reason, force: force = false }) {
        if (!intentState.streamReader) return;
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        if (!force) {
            if (intentState.renderTasks.size > 0) return;
            if (reason instanceof $a2cc6e1d6eb3861b$export$245847d31c09154f) {
                let delay = $a2cc6e1d6eb3861b$var$RENDERING_CANCELLED_TIMEOUT;
                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                    intentState.streamReaderCancelTimeout = null;
                    this._abortOperatorList({
                        intentState: intentState,
                        reason: reason,
                        force: true
                    });
                }, delay);
                return;
            }
        }
        intentState.streamReader.cancel(new $a2cc6e1d6eb3861b$export$d0e978393d193d1a(reason.message)).catch(()=>{});
        intentState.streamReader = null;
        if (this._transport.destroyed) return;
        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
            this._intentStates.delete(curCacheKey);
            break;
        }
        this.cleanup();
    }
    get stats() {
        return this._stats;
    }
}
class $a2cc6e1d6eb3861b$export$84e2e9f37426b265 {
    #capability = Promise.withResolvers();
    #messageHandler = null;
    #port = null;
    #webWorker = null;
    static #fakeWorkerId = 0;
    static #isWorkerDisabled = false;
    static #workerPorts = new WeakMap();
    static{
        if ($a2cc6e1d6eb3861b$var$isNodeJS) {
            this.#isWorkerDisabled = true;
            $a2cc6e1d6eb3861b$export$edf38ba293eb934.workerSrc ||= "./pdf.worker.mjs";
        }
        this._isSameOrigin = (baseUrl, otherUrl)=>{
            const base = URL.parse(baseUrl);
            if (!base?.origin || base.origin === "null") return false;
            const other = new URL(otherUrl, base);
            return base.origin === other.origin;
        };
        this._createCDNWrapper = (url)=>{
            const wrapper = `await import("${url}");`;
            return URL.createObjectURL(new Blob([
                wrapper
            ], {
                type: "text/javascript"
            }));
        };
    }
    constructor({ name: name = null, port: port = null, verbosity: verbosity = $a2cc6e1d6eb3861b$var$getVerbosityLevel() } = {}){
        this.name = name;
        this.destroyed = false;
        this.verbosity = verbosity;
        if (port) {
            if ($a2cc6e1d6eb3861b$export$84e2e9f37426b265.#workerPorts.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
            $a2cc6e1d6eb3861b$export$84e2e9f37426b265.#workerPorts.set(port, this);
            this.#initializeFromPort(port);
        } else this.#initialize();
    }
    get promise() {
        return this.#capability.promise;
    }
    #resolve() {
        this.#capability.resolve();
        this.#messageHandler.send("configure", {
            verbosity: this.verbosity
        });
    }
    get port() {
        return this.#port;
    }
    get messageHandler() {
        return this.#messageHandler;
    }
    #initializeFromPort(port) {
        this.#port = port;
        this.#messageHandler = new $a2cc6e1d6eb3861b$var$MessageHandler("main", "worker", port);
        this.#messageHandler.on("ready", ()=>{});
        this.#resolve();
    }
    #initialize() {
        if ($a2cc6e1d6eb3861b$export$84e2e9f37426b265.#isWorkerDisabled || $a2cc6e1d6eb3861b$export$84e2e9f37426b265.#mainThreadWorkerMessageHandler) {
            this.#setupFakeWorker();
            return;
        }
        let { workerSrc: workerSrc } = $a2cc6e1d6eb3861b$export$84e2e9f37426b265;
        try {
            if (!$a2cc6e1d6eb3861b$export$84e2e9f37426b265._isSameOrigin(window.location, workerSrc)) workerSrc = $a2cc6e1d6eb3861b$export$84e2e9f37426b265._createCDNWrapper(new URL(workerSrc, window.location).href);
            const worker = new Worker(workerSrc, {
                type: "module"
            });
            const messageHandler = new $a2cc6e1d6eb3861b$var$MessageHandler("main", "worker", worker);
            const terminateEarly = ()=>{
                ac.abort();
                messageHandler.destroy();
                worker.terminate();
                if (this.destroyed) this.#capability.reject(new Error("Worker was destroyed"));
                else this.#setupFakeWorker();
            };
            const ac = new AbortController();
            worker.addEventListener("error", ()=>{
                if (!this.#webWorker) terminateEarly();
            }, {
                signal: ac.signal
            });
            messageHandler.on("test", (data)=>{
                ac.abort();
                if (this.destroyed || !data) {
                    terminateEarly();
                    return;
                }
                this.#messageHandler = messageHandler;
                this.#port = worker;
                this.#webWorker = worker;
                this.#resolve();
            });
            messageHandler.on("ready", (data)=>{
                ac.abort();
                if (this.destroyed) {
                    terminateEarly();
                    return;
                }
                try {
                    sendTest();
                } catch  {
                    this.#setupFakeWorker();
                }
            });
            const sendTest = ()=>{
                const testObj = new Uint8Array();
                messageHandler.send("test", testObj, [
                    testObj.buffer
                ]);
            };
            sendTest();
            return;
        } catch  {
            $a2cc6e1d6eb3861b$var$info("The worker has been disabled.");
        }
        this.#setupFakeWorker();
    }
    #setupFakeWorker() {
        if (!$a2cc6e1d6eb3861b$export$84e2e9f37426b265.#isWorkerDisabled) {
            $a2cc6e1d6eb3861b$var$warn("Setting up fake worker.");
            $a2cc6e1d6eb3861b$export$84e2e9f37426b265.#isWorkerDisabled = true;
        }
        $a2cc6e1d6eb3861b$export$84e2e9f37426b265._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
            if (this.destroyed) {
                this.#capability.reject(new Error("Worker was destroyed"));
                return;
            }
            const port = new $a2cc6e1d6eb3861b$var$LoopbackPort();
            this.#port = port;
            const id = `fake${$a2cc6e1d6eb3861b$export$84e2e9f37426b265.#fakeWorkerId++}`;
            const workerHandler = new $a2cc6e1d6eb3861b$var$MessageHandler(id + "_worker", id, port);
            WorkerMessageHandler.setup(workerHandler, port);
            this.#messageHandler = new $a2cc6e1d6eb3861b$var$MessageHandler(id, id + "_worker", port);
            this.#resolve();
        }).catch((reason)=>{
            this.#capability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
        });
    }
    destroy() {
        this.destroyed = true;
        this.#webWorker?.terminate();
        this.#webWorker = null;
        $a2cc6e1d6eb3861b$export$84e2e9f37426b265.#workerPorts.delete(this.#port);
        this.#port = null;
        this.#messageHandler?.destroy();
        this.#messageHandler = null;
    }
    static create(params) {
        const cachedPort = this.#workerPorts.get(params?.port);
        if (cachedPort) {
            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.create - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
            return cachedPort;
        }
        return new $a2cc6e1d6eb3861b$export$84e2e9f37426b265(params);
    }
    static get workerSrc() {
        if ($a2cc6e1d6eb3861b$export$edf38ba293eb934.workerSrc) return $a2cc6e1d6eb3861b$export$edf38ba293eb934.workerSrc;
        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
    }
    static get #mainThreadWorkerMessageHandler() {
        try {
            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
        } catch  {
            return null;
        }
    }
    static get _setupFakeWorkerGlobal() {
        const loader = async ()=>{
            if (this.#mainThreadWorkerMessageHandler) return this.#mainThreadWorkerMessageHandler;
            const worker = await import(/*webpackIgnore: true*/ /*@vite-ignore*/ this.workerSrc);
            return worker.WorkerMessageHandler;
        };
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_setupFakeWorkerGlobal", loader());
    }
}
class $a2cc6e1d6eb3861b$var$WorkerTransport {
    downloadInfoCapability = Promise.withResolvers();
    #fullReader = null;
    #methodPromises = new Map();
    #networkStream = null;
    #pageCache = new Map();
    #pagePromises = new Map();
    #pageRefCache = new Map();
    #passwordCapability = null;
    constructor(messageHandler, loadingTask, networkStream, params, factory, pagesMapper){
        this.messageHandler = messageHandler;
        this.loadingTask = loadingTask;
        this.#networkStream = networkStream;
        this.commonObjs = new $a2cc6e1d6eb3861b$var$PDFObjects();
        this.fontLoader = new $a2cc6e1d6eb3861b$var$FontLoader({
            ownerDocument: params.ownerDocument,
            styleElement: params.styleElement
        });
        this.enableHWA = params.enableHWA;
        this.loadingParams = params.loadingParams;
        this._params = params;
        this.canvasFactory = factory.canvasFactory;
        this.filterFactory = factory.filterFactory;
        this.binaryDataFactory = factory.binaryDataFactory;
        this.pagesMapper = pagesMapper;
        this.destroyed = false;
        this.destroyCapability = null;
        this.setupMessageHandler();
    }
    updatePage(page) {
        const { _pageIndex: _pageIndex } = page;
        this.#pageCache.set(_pageIndex, page);
        this.#pagePromises.set(_pageIndex, Promise.resolve(page));
    }
    #cacheSimpleMethod(name, data = null) {
        return this.#methodPromises.getOrInsertComputed(name, ()=>this.messageHandler.sendWithPromise(name, data));
    }
    #onProgress({ loaded: loaded, total: total }) {
        this.loadingTask.onProgress?.({
            loaded: loaded,
            total: total,
            percent: total ? $a2cc6e1d6eb3861b$export$b8106b171181a554(Math.round(loaded / total * 100), 0, 100) : NaN
        });
    }
    get annotationStorage() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "annotationStorage", new $a2cc6e1d6eb3861b$var$AnnotationStorage());
    }
    getRenderingIntent(intent, annotationMode = $a2cc6e1d6eb3861b$export$5a7af0c07e33392e.ENABLE, printAnnotationStorage = null, isEditing = false, isOpList = false) {
        let renderingIntent = $a2cc6e1d6eb3861b$var$RenderingIntentFlag.DISPLAY;
        let annotationStorageSerializable = $a2cc6e1d6eb3861b$var$SerializableEmpty;
        switch(intent){
            case "any":
                renderingIntent = $a2cc6e1d6eb3861b$var$RenderingIntentFlag.ANY;
                break;
            case "display":
                break;
            case "print":
                renderingIntent = $a2cc6e1d6eb3861b$var$RenderingIntentFlag.PRINT;
                break;
            default:
                $a2cc6e1d6eb3861b$var$warn(`getRenderingIntent - invalid intent: ${intent}`);
        }
        const annotationStorage = renderingIntent & $a2cc6e1d6eb3861b$var$RenderingIntentFlag.PRINT && printAnnotationStorage instanceof $a2cc6e1d6eb3861b$var$PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
        switch(annotationMode){
            case $a2cc6e1d6eb3861b$export$5a7af0c07e33392e.DISABLE:
                renderingIntent += $a2cc6e1d6eb3861b$var$RenderingIntentFlag.ANNOTATIONS_DISABLE;
                break;
            case $a2cc6e1d6eb3861b$export$5a7af0c07e33392e.ENABLE:
                break;
            case $a2cc6e1d6eb3861b$export$5a7af0c07e33392e.ENABLE_FORMS:
                renderingIntent += $a2cc6e1d6eb3861b$var$RenderingIntentFlag.ANNOTATIONS_FORMS;
                break;
            case $a2cc6e1d6eb3861b$export$5a7af0c07e33392e.ENABLE_STORAGE:
                renderingIntent += $a2cc6e1d6eb3861b$var$RenderingIntentFlag.ANNOTATIONS_STORAGE;
                annotationStorageSerializable = annotationStorage.serializable;
                break;
            default:
                $a2cc6e1d6eb3861b$var$warn(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
        }
        if (isEditing) renderingIntent += $a2cc6e1d6eb3861b$var$RenderingIntentFlag.IS_EDITING;
        if (isOpList) renderingIntent += $a2cc6e1d6eb3861b$var$RenderingIntentFlag.OPLIST;
        const { ids: modifiedIds, hash: modifiedIdsHash } = annotationStorage.modifiedIds;
        const cacheKeyBuf = [
            renderingIntent,
            annotationStorageSerializable.hash,
            modifiedIdsHash
        ];
        return {
            renderingIntent: renderingIntent,
            cacheKey: cacheKeyBuf.join("_"),
            annotationStorageSerializable: annotationStorageSerializable,
            modifiedIds: modifiedIds
        };
    }
    destroy() {
        if (this.destroyCapability) return this.destroyCapability.promise;
        this.destroyed = true;
        this.destroyCapability = Promise.withResolvers();
        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
        const waitOn = [];
        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
        this.#pageCache.clear();
        this.#pagePromises.clear();
        this.#pageRefCache.clear();
        if (Object.hasOwn(this, "annotationStorage")) this.annotationStorage.resetModified();
        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
        waitOn.push(terminated);
        Promise.all(waitOn).then(()=>{
            this.commonObjs.clear();
            this.fontLoader.clear();
            this.#methodPromises.clear();
            this.filterFactory.destroy();
            $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.cleanup();
            this.#networkStream?.cancelAllRequests(new $a2cc6e1d6eb3861b$export$d0e978393d193d1a("Worker was terminated."));
            this.messageHandler?.destroy();
            this.messageHandler = null;
            this.destroyCapability.resolve();
        }, this.destroyCapability.reject);
        return this.destroyCapability.promise;
    }
    setupMessageHandler() {
        const { messageHandler: messageHandler, loadingTask: loadingTask } = this;
        messageHandler.on("GetReader", (data, sink)=>{
            $a2cc6e1d6eb3861b$var$assert(this.#networkStream, "GetReader - no `BasePDFStream` instance available.");
            this.#fullReader = this.#networkStream.getFullReader();
            this.#fullReader.onProgress = (evt)=>this.#onProgress(evt);
            sink.onPull = ()=>{
                this.#fullReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $a2cc6e1d6eb3861b$var$assert(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                this.#fullReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("ReaderHeadersReady", async (data)=>{
            await this.#fullReader.headersReady;
            const { isStreamingSupported: isStreamingSupported, isRangeSupported: isRangeSupported, contentLength: contentLength } = this.#fullReader;
            if (isStreamingSupported && isRangeSupported) this.#fullReader.onProgress = null;
            return {
                isStreamingSupported: isStreamingSupported,
                isRangeSupported: isRangeSupported,
                contentLength: contentLength
            };
        });
        messageHandler.on("GetRangeReader", (data, sink)=>{
            $a2cc6e1d6eb3861b$var$assert(this.#networkStream, "GetRangeReader - no `BasePDFStream` instance available.");
            const rangeReader = this.#networkStream.getRangeReader(data.begin, data.end);
            if (!rangeReader) {
                sink.close();
                return;
            }
            sink.onPull = ()=>{
                rangeReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $a2cc6e1d6eb3861b$var$assert(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                rangeReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("GetDoc", ({ pdfInfo: pdfInfo })=>{
            this.pagesMapper.pagesNumber = pdfInfo.numPages;
            this._numPages = pdfInfo.numPages;
            this._htmlForXfa = pdfInfo.htmlForXfa;
            delete pdfInfo.htmlForXfa;
            loadingTask._capability.resolve(new $a2cc6e1d6eb3861b$var$PDFDocumentProxy(pdfInfo, this));
        });
        messageHandler.on("DocException", (ex)=>{
            loadingTask._capability.reject($a2cc6e1d6eb3861b$var$wrapReason(ex));
        });
        messageHandler.on("PasswordRequest", (ex)=>{
            this.#passwordCapability = Promise.withResolvers();
            try {
                if (!loadingTask.onPassword) throw $a2cc6e1d6eb3861b$var$wrapReason(ex);
                const updatePassword = (password)=>{
                    if (password instanceof Error) this.#passwordCapability.reject(password);
                    else this.#passwordCapability.resolve({
                        password: password
                    });
                };
                loadingTask.onPassword(updatePassword, ex.code);
            } catch (err) {
                this.#passwordCapability.reject(err);
            }
            return this.#passwordCapability.promise;
        });
        messageHandler.on("DataLoaded", (data)=>{
            this.#onProgress({
                loaded: data.length,
                total: data.length
            });
            this.downloadInfoCapability.resolve(data);
        });
        messageHandler.on("StartRenderPage", (data)=>{
            if (this.destroyed) return;
            const page = this.#pageCache.get(data.pageIndex);
            page._startRenderPage(data.transparency, data.cacheKey);
        });
        messageHandler.on("commonobj", ([id, type, exportedData])=>{
            if (this.destroyed) return null;
            if (this.commonObjs.has(id)) return null;
            switch(type){
                case "Font":
                    if ("error" in exportedData) {
                        const exportedError = exportedData.error;
                        $a2cc6e1d6eb3861b$var$warn(`Error during font loading: ${exportedError}`);
                        this.commonObjs.resolve(id, exportedError);
                        break;
                    }
                    const fontData = new $a2cc6e1d6eb3861b$var$FontInfo(exportedData);
                    const inspectFont = this._params.pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                    const font = new $a2cc6e1d6eb3861b$var$FontFaceObject(fontData, inspectFont, exportedData.charProcOperatorList, exportedData.extra);
                    this.fontLoader.bind(font).catch(()=>messageHandler.sendWithPromise("FontFallback", {
                            id: id
                        })).finally(()=>{
                        if (!font.fontExtraProperties) font.clearData();
                        this.commonObjs.resolve(id, font);
                    });
                    break;
                case "CopyLocalImage":
                    const { imageRef: imageRef } = exportedData;
                    $a2cc6e1d6eb3861b$var$assert(imageRef, "The imageRef must be defined.");
                    for (const pageProxy of this.#pageCache.values())for (const [, data] of pageProxy.objs){
                        if (data?.ref !== imageRef) continue;
                        if (!data.dataLen) return null;
                        const copy = structuredClone(data);
                        this.commonObjs.resolve(id, copy);
                        return data.dataLen;
                    }
                    break;
                case "FontPath":
                    this.commonObjs.resolve(id, new $a2cc6e1d6eb3861b$var$FontPathInfo(exportedData));
                    break;
                case "Image":
                    this.commonObjs.resolve(id, exportedData);
                    break;
                case "Pattern":
                    const pattern = new $a2cc6e1d6eb3861b$var$PatternInfo(exportedData);
                    this.commonObjs.resolve(id, pattern.getIR());
                    break;
                default:
                    throw new Error(`Got unknown common object type ${type}`);
            }
            return null;
        });
        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
            if (this.destroyed) return;
            const pageProxy = this.#pageCache.get(pageIndex);
            if (pageProxy.objs.has(id)) return;
            if (pageProxy._intentStates.size === 0) {
                imageData?.bitmap?.close();
                return;
            }
            switch(type){
                case "Image":
                case "Pattern":
                    pageProxy.objs.resolve(id, imageData);
                    break;
                default:
                    throw new Error(`Got unknown object type ${type}`);
            }
        });
        messageHandler.on("DocProgress", (data)=>{
            if (this.destroyed) return;
            this.#onProgress(data);
        });
        messageHandler.on("FetchBinaryData", async (data)=>{
            if (this.destroyed) throw new Error("Worker was destroyed.");
            if (!this.binaryDataFactory) throw new Error("`BinaryDataFactory` not initialized, see the `useWorkerFetch` parameter.");
            return this.binaryDataFactory.fetch(data);
        });
    }
    getData() {
        return this.messageHandler.sendWithPromise("GetData", null);
    }
    saveDocument() {
        if (this.annotationStorage.size <= 0) $a2cc6e1d6eb3861b$var$warn("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
        const { map: map, transfer: transfer } = this.annotationStorage.serializable;
        return this.messageHandler.sendWithPromise("SaveDocument", {
            isPureXfa: !!this._htmlForXfa,
            numPages: this._numPages,
            annotationStorage: map,
            filename: this.#fullReader?.filename ?? null
        }, transfer).finally(()=>{
            this.annotationStorage.resetModified();
        });
    }
    extractPages(pageInfos) {
        const params = {
            pageInfos: pageInfos
        };
        let transfer;
        const ImageBitmapCtor = globalThis.ImageBitmap;
        if (typeof ImageBitmapCtor === "function") {
            const infos = Array.isArray(pageInfos) ? pageInfos : [
                pageInfos
            ];
            for (const pageInfo of infos)if (pageInfo?.image instanceof ImageBitmapCtor) (transfer ||= []).push(pageInfo.image);
        }
        if (this.annotationStorage.size > 0) {
            const serialized = this.annotationStorage.serializable;
            let { map: map } = serialized;
            if (serialized.transfer?.length) {
                if (transfer) transfer.push(...serialized.transfer);
                else transfer = serialized.transfer;
            }
            const mapping = this.pagesMapper.getMapping();
            if (mapping) {
                const remapped = new Map();
                for (const [k, v] of map){
                    if (v?.pageIndex !== undefined && v.pageIndex >= 0 && v.pageIndex < mapping.length) {
                        const sourceIdx = mapping[v.pageIndex] - 1;
                        if (sourceIdx !== v.pageIndex) {
                            remapped.set(k, {
                                ...v,
                                pageIndex: sourceIdx
                            });
                            continue;
                        }
                    }
                    remapped.set(k, v);
                }
                map = remapped;
            }
            params.annotationStorage = map;
        }
        return this.messageHandler.sendWithPromise("ExtractPages", params, transfer).finally(()=>{
            this.annotationStorage.resetModified();
        });
    }
    getPage(pageNumber) {
        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.pagesMapper.pagesNumber) return Promise.reject(new Error("Invalid page request."));
        const pageIndex = pageNumber - 1;
        const newPageIndex = this.pagesMapper.getPageId(pageNumber) - 1;
        const cachedPromise = this.#pagePromises.get(pageIndex);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise("GetPage", {
            pageIndex: newPageIndex
        }).then((pageInfo)=>{
            if (this.destroyed) throw new Error("Transport destroyed");
            if (pageInfo.refStr) this.#pageRefCache.set(pageInfo.refStr, newPageIndex);
            const page = new $a2cc6e1d6eb3861b$var$PDFPageProxy(pageIndex, pageInfo, this, this.pagesMapper, this._params.pdfBug);
            this.#pageCache.set(pageIndex, page);
            return page;
        });
        this.#pagePromises.set(pageIndex, promise);
        return promise;
    }
    async getPageIndex(ref) {
        if (!$a2cc6e1d6eb3861b$var$isRefProxy(ref)) throw new Error("Invalid pageIndex request.");
        const index = await this.messageHandler.sendWithPromise("GetPageIndex", {
            num: ref.num,
            gen: ref.gen
        });
        const pageNumber = this.pagesMapper.getPageNumber(index + 1);
        if (pageNumber === 0) throw new Error("GetPageIndex: page has been removed.");
        return pageNumber - 1;
    }
    getAnnotations(pageIndex, intent) {
        return this.messageHandler.sendWithPromise("GetAnnotations", {
            pageIndex: this.pagesMapper.getPageId(pageIndex + 1) - 1,
            intent: intent
        });
    }
    getFieldObjects() {
        return this.#cacheSimpleMethod("GetFieldObjects");
    }
    hasJSActions() {
        return this.#cacheSimpleMethod("HasJSActions");
    }
    getCalculationOrderIds() {
        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
    }
    getDestinations() {
        return this.messageHandler.sendWithPromise("GetDestinations", null);
    }
    getDestination(id) {
        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
        return this.messageHandler.sendWithPromise("GetDestination", {
            id: id
        });
    }
    getPageLabels() {
        return this.messageHandler.sendWithPromise("GetPageLabels", null);
    }
    getPageLayout() {
        return this.messageHandler.sendWithPromise("GetPageLayout", null);
    }
    getPageMode() {
        return this.messageHandler.sendWithPromise("GetPageMode", null);
    }
    getViewerPreferences() {
        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
    }
    getOpenAction() {
        return this.messageHandler.sendWithPromise("GetOpenAction", null);
    }
    getAttachments() {
        return this.messageHandler.sendWithPromise("GetAttachments", null);
    }
    getAnnotationsByType(types, pageIndexesToSkip) {
        return this.messageHandler.sendWithPromise("GetAnnotationsByType", {
            types: types,
            pageIndexesToSkip: pageIndexesToSkip
        });
    }
    getDocJSActions() {
        return this.#cacheSimpleMethod("GetDocJSActions");
    }
    getPageJSActions(pageIndex) {
        return this.messageHandler.sendWithPromise("GetPageJSActions", {
            pageIndex: this.pagesMapper.getPageId(pageIndex + 1) - 1
        });
    }
    getStructTree(pageIndex) {
        return this.messageHandler.sendWithPromise("GetStructTree", {
            pageIndex: this.pagesMapper.getPageId(pageIndex + 1) - 1
        });
    }
    getOutline() {
        return this.messageHandler.sendWithPromise("GetOutline", null);
    }
    getOptionalContentConfig(renderingIntent) {
        return this.#cacheSimpleMethod("GetOptionalContentConfig").then((data)=>new $a2cc6e1d6eb3861b$var$OptionalContentConfig(data, renderingIntent));
    }
    getPermissions() {
        return this.messageHandler.sendWithPromise("GetPermissions", null);
    }
    getMetadata() {
        const name = "GetMetadata";
        return this.#methodPromises.getOrInsertComputed(name, ()=>this.messageHandler.sendWithPromise(name, null).then((results)=>({
                    info: results[0],
                    metadata: results[1] ? new $a2cc6e1d6eb3861b$var$Metadata(results[1]) : null,
                    contentDispositionFilename: this.#fullReader?.filename ?? null,
                    contentLength: this.#fullReader?.contentLength ?? null,
                    hasStructTree: results[2]
                })));
    }
    getMarkInfo() {
        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
    }
    getRawData(data) {
        return this.messageHandler.sendWithPromise("GetRawData", data);
    }
    async startCleanup(keepLoadedFonts = false) {
        if (this.destroyed) return;
        await this.messageHandler.sendWithPromise("Cleanup", null);
        for (const page of this.#pageCache.values()){
            const cleanupSuccessful = page.cleanup();
            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
        }
        this.commonObjs.clear();
        if (!keepLoadedFonts) this.fontLoader.clear();
        this.#methodPromises.clear();
        this.filterFactory.destroy(true);
        $a2cc6e1d6eb3861b$export$fdbdc423a78c5262.cleanup();
    }
    cachedPageNumber(ref) {
        if (!$a2cc6e1d6eb3861b$var$isRefProxy(ref)) return null;
        const refStr = ref.gen === 0 ? `${ref.num}R` : `${ref.num}R${ref.gen}`;
        const pageIndex = this.#pageRefCache.get(refStr);
        if (pageIndex >= 0) {
            const pageNumber = this.pagesMapper.getPageNumber(pageIndex + 1);
            if (pageNumber !== 0) return pageNumber;
        }
        return null;
    }
}
class $a2cc6e1d6eb3861b$var$RenderTask {
    _internalRenderTask = null;
    onContinue = null;
    onError = null;
    constructor(internalRenderTask){
        this._internalRenderTask = internalRenderTask;
    }
    get promise() {
        return this._internalRenderTask.capability.promise;
    }
    cancel(extraDelay = 0) {
        this._internalRenderTask.cancel(null, extraDelay);
    }
    get separateAnnots() {
        const { separateAnnots: separateAnnots } = this._internalRenderTask.operatorList;
        if (!separateAnnots) return false;
        const { annotationCanvasMap: annotationCanvasMap } = this._internalRenderTask;
        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
    }
    get imageCoordinates() {
        return this._internalRenderTask.imageCoordinates || null;
    }
}
class $a2cc6e1d6eb3861b$var$InternalRenderTask {
    #rAF = null;
    static #canvasInUse = new WeakSet();
    constructor({ callback: callback, params: params, objs: objs, commonObjs: commonObjs, annotationCanvasMap: annotationCanvasMap, operatorList: operatorList, pageIndex: pageIndex, canvasFactory: canvasFactory, filterFactory: filterFactory, useRequestAnimationFrame: useRequestAnimationFrame = false, pdfBug: pdfBug = false, pageColors: pageColors = null, enableHWA: enableHWA = false, operationsFilter: operationsFilter = null }){
        this.callback = callback;
        this.params = params;
        this.objs = objs;
        this.commonObjs = commonObjs;
        this.annotationCanvasMap = annotationCanvasMap;
        this.operatorListIdx = null;
        this.operatorList = operatorList;
        this._pageIndex = pageIndex;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this._pdfBug = pdfBug;
        this.pageColors = pageColors;
        this.running = false;
        this.graphicsReadyCallback = null;
        this.graphicsReady = false;
        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
        this.cancelled = false;
        this.capability = Promise.withResolvers();
        this.task = new $a2cc6e1d6eb3861b$var$RenderTask(this);
        this._cancelBound = this.cancel.bind(this);
        this._continueBound = this._continue.bind(this);
        this._scheduleNextBound = this._scheduleNext.bind(this);
        this._nextBound = this._next.bind(this);
        this._canvas = params.canvas;
        this._canvasContext = params.canvas ? null : params.canvasContext;
        this._enableHWA = enableHWA;
        this._dependencyTracker = params.dependencyTracker;
        this._imagesTracker = params.imagesTracker;
        this._operationsFilter = operationsFilter;
    }
    get completed() {
        return this.capability.promise.catch(function() {});
    }
    initializeGraphics({ transparency: transparency = false, optionalContentConfig: optionalContentConfig }) {
        if (this.cancelled) return;
        if (this._canvas) {
            if ($a2cc6e1d6eb3861b$var$InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
            $a2cc6e1d6eb3861b$var$InternalRenderTask.#canvasInUse.add(this._canvas);
        }
        if (this._pdfBug && globalThis.StepperManager?.enabled) {
            this.stepper = globalThis.StepperManager.create(this._pageIndex);
            this.stepper.init(this.operatorList);
            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
        }
        const { viewport: viewport, transform: transform, background: background, dependencyTracker: dependencyTracker, imagesTracker: imagesTracker } = this.params;
        const canvasContext = this._canvasContext || this._canvas.getContext("2d", {
            alpha: false,
            willReadFrequently: !this._enableHWA
        });
        this.gfx = new $a2cc6e1d6eb3861b$var$CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
            optionalContentConfig: optionalContentConfig
        }, this.annotationCanvasMap, this.pageColors, dependencyTracker, imagesTracker);
        this.gfx.beginDrawing({
            transform: transform,
            viewport: viewport,
            transparency: transparency,
            background: background
        });
        this.operatorListIdx = 0;
        this.graphicsReady = true;
        this.graphicsReadyCallback?.();
    }
    cancel(error = null, extraDelay = 0) {
        this.running = false;
        this.cancelled = true;
        this.gfx?.endDrawing();
        if (this.#rAF) {
            window.cancelAnimationFrame(this.#rAF);
            this.#rAF = null;
        }
        $a2cc6e1d6eb3861b$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
        error ||= new $a2cc6e1d6eb3861b$export$245847d31c09154f(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay);
        this.callback(error);
        this.task.onError?.(error);
    }
    operatorListChanged() {
        if (!this.graphicsReady) {
            this.graphicsReadyCallback ||= this._continueBound;
            return;
        }
        this.gfx.dependencyTracker?.growOperationsCount(this.operatorList.fnArray.length);
        this.stepper?.updateOperatorList(this.operatorList);
        if (this.running) return;
        this._continue();
    }
    _continue() {
        this.running = true;
        if (this.cancelled) return;
        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
        else this._scheduleNext();
    }
    _scheduleNext() {
        if (this._useRequestAnimationFrame) this.#rAF = window.requestAnimationFrame(()=>{
            this.#rAF = null;
            this._nextBound().catch(this._cancelBound);
        });
        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
    }
    async _next() {
        if (this.cancelled) return;
        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper, this._operationsFilter);
        if (this.operatorListIdx === this.operatorList.argsArray.length) {
            this.running = false;
            if (this.operatorList.lastChunk) {
                this.gfx.endDrawing();
                $a2cc6e1d6eb3861b$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
                this.callback();
            }
        }
    }
}
const $a2cc6e1d6eb3861b$export$83d89fbfd8236492 = "6.0.227";
const $a2cc6e1d6eb3861b$export$3f8fe6489e95757d = "241dbabbf";
class $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3 {
    #button = null;
    #buttonSwatch = null;
    #defaultColor;
    #dropdown = null;
    #dropdownWasFromKeyboard = false;
    #isMainColorPicker = false;
    #editor = null;
    #eventBus;
    #openDropdownAC = null;
    #uiManager = null;
    static #l10nColor = null;
    static get _keyboardManager() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_keyboardManager", new $a2cc6e1d6eb3861b$var$KeyboardManager([
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3.prototype._hideDropdownFromKeyboard
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3.prototype._colorSelectFromKeyboard
            ],
            [
                [
                    "ArrowDown",
                    "ArrowRight",
                    "mac+ArrowDown",
                    "mac+ArrowRight"
                ],
                $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3.prototype._moveToNext
            ],
            [
                [
                    "ArrowUp",
                    "ArrowLeft",
                    "mac+ArrowUp",
                    "mac+ArrowLeft"
                ],
                $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3.prototype._moveToPrevious
            ],
            [
                [
                    "Home",
                    "mac+Home"
                ],
                $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3.prototype._moveToBeginning
            ],
            [
                [
                    "End",
                    "mac+End"
                ],
                $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3.prototype._moveToEnd
            ]
        ]));
    }
    constructor({ editor: editor = null, uiManager: uiManager = null }){
        if (editor) {
            this.#isMainColorPicker = false;
            this.#editor = editor;
        } else this.#isMainColorPicker = true;
        this.#uiManager = editor?._uiManager || uiManager;
        this.#eventBus = this.#uiManager._eventBus;
        this.#defaultColor = editor?.color?.toUpperCase() || this.#uiManager?.highlightColors.values().next().value || "#FFFF98";
        $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3.#l10nColor ||= Object.freeze({
            blue: "pdfjs-editor-colorpicker-blue",
            green: "pdfjs-editor-colorpicker-green",
            pink: "pdfjs-editor-colorpicker-pink",
            red: "pdfjs-editor-colorpicker-red",
            yellow: "pdfjs-editor-colorpicker-yellow"
        });
    }
    renderButton() {
        const button = this.#button = document.createElement("button");
        button.className = "colorPicker";
        button.tabIndex = "0";
        button.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button");
        button.ariaHasPopup = "true";
        if (this.#editor) button.ariaControls = `${this.#editor.id}_colorpicker_dropdown`;
        const signal = this.#uiManager._signal;
        button.addEventListener("click", this.#openDropdown.bind(this), {
            signal: signal
        });
        button.addEventListener("keydown", this.#keyDown.bind(this), {
            signal: signal
        });
        const swatch = this.#buttonSwatch = document.createElement("span");
        swatch.className = "swatch";
        swatch.ariaHidden = "true";
        swatch.style.backgroundColor = this.#defaultColor;
        button.append(swatch);
        return button;
    }
    renderMainDropdown() {
        const dropdown = this.#dropdown = this.#getDropdownRoot();
        dropdown.ariaOrientation = "horizontal";
        dropdown.ariaLabelledBy = "highlightColorPickerLabel";
        return dropdown;
    }
    #getDropdownRoot() {
        const div = document.createElement("div");
        const signal = this.#uiManager._signal;
        div.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
            signal: signal
        });
        div.className = "dropdown";
        div.role = "listbox";
        div.ariaMultiSelectable = "false";
        div.ariaOrientation = "vertical";
        div.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown");
        if (this.#editor) div.id = `${this.#editor.id}_colorpicker_dropdown`;
        for (const [name, color] of this.#uiManager.highlightColors){
            const button = document.createElement("button");
            button.tabIndex = "0";
            button.role = "option";
            button.setAttribute("data-color", color);
            button.title = name;
            button.setAttribute("data-l10n-id", $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3.#l10nColor[name]);
            const swatch = document.createElement("span");
            button.append(swatch);
            swatch.className = "swatch";
            swatch.style.backgroundColor = color;
            button.ariaSelected = color === this.#defaultColor;
            button.addEventListener("click", this.#colorSelect.bind(this, color), {
                signal: signal
            });
            div.append(button);
        }
        div.addEventListener("keydown", this.#keyDown.bind(this), {
            signal: signal
        });
        return div;
    }
    #colorSelect(color, event) {
        event.stopPropagation();
        this.#eventBus.dispatch("switchannotationeditorparams", {
            source: this,
            type: $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
            value: color
        });
        this.updateColor(color);
    }
    _colorSelectFromKeyboard(event) {
        if (event.target === this.#button) {
            this.#openDropdown(event);
            return;
        }
        const color = event.target.getAttribute("data-color");
        if (!color) return;
        this.#colorSelect(color, event);
    }
    _moveToNext(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        if (event.target === this.#button) {
            this.#dropdown.firstElementChild?.focus();
            return;
        }
        event.target.nextSibling?.focus();
    }
    _moveToPrevious(event) {
        if (event.target === this.#dropdown?.firstElementChild || event.target === this.#button) {
            if (this.#isDropdownVisible) this._hideDropdownFromKeyboard();
            return;
        }
        if (!this.#isDropdownVisible) this.#openDropdown(event);
        event.target.previousSibling?.focus();
    }
    _moveToBeginning(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.firstElementChild?.focus();
    }
    _moveToEnd(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.lastElementChild?.focus();
    }
    #keyDown(event) {
        $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3._keyboardManager.exec(this, event);
    }
    #openDropdown(event) {
        if (this.#isDropdownVisible) {
            this.hideDropdown();
            return;
        }
        this.#dropdownWasFromKeyboard = event.detail === 0;
        if (!this.#openDropdownAC) {
            this.#openDropdownAC = new AbortController();
            window.addEventListener("pointerdown", this.#pointerDown.bind(this), {
                signal: this.#uiManager.combinedSignal(this.#openDropdownAC)
            });
        }
        this.#button.ariaExpanded = "true";
        if (this.#dropdown) {
            this.#dropdown.classList.remove("hidden");
            return;
        }
        const root = this.#dropdown = this.#getDropdownRoot();
        this.#button.append(root);
    }
    #pointerDown(event) {
        if (this.#dropdown?.contains(event.target)) return;
        this.hideDropdown();
    }
    hideDropdown() {
        this.#dropdown?.classList.add("hidden");
        this.#button.ariaExpanded = "false";
        this.#openDropdownAC?.abort();
        this.#openDropdownAC = null;
    }
    get #isDropdownVisible() {
        return this.#dropdown && !this.#dropdown.classList.contains("hidden");
    }
    _hideDropdownFromKeyboard() {
        if (this.#isMainColorPicker) return;
        if (!this.#isDropdownVisible) {
            this.#editor?.unselect();
            return;
        }
        this.hideDropdown();
        this.#button.focus({
            preventScroll: true,
            focusVisible: this.#dropdownWasFromKeyboard
        });
    }
    updateColor(color) {
        if (this.#buttonSwatch) this.#buttonSwatch.style.backgroundColor = color;
        if (!this.#dropdown) return;
        const i = this.#uiManager.highlightColors.values();
        for (const child of this.#dropdown.children)child.ariaSelected = i.next().value === color.toUpperCase();
    }
    destroy() {
        this.#button?.remove();
        this.#button = null;
        this.#buttonSwatch = null;
        this.#dropdown?.remove();
        this.#dropdown = null;
    }
}
class $a2cc6e1d6eb3861b$var$BasicColorPicker {
    #input = null;
    #hasAlpha = false;
    #editor = null;
    #uiManager = null;
    static #l10nColor = null;
    constructor(editor){
        this.#editor = editor;
        this.#uiManager = editor._uiManager;
        $a2cc6e1d6eb3861b$var$BasicColorPicker.#l10nColor ||= Object.freeze({
            freetext: "pdfjs-editor-color-picker-free-text-input",
            ink: "pdfjs-editor-color-picker-ink-input"
        });
    }
    renderButton() {
        if (this.#input) return this.#input;
        const { editorType: editorType, colorType: colorType, colorAndOpacityType: colorAndOpacityType, opacityType: opacityType, color: color, opacity: opacity } = this.#editor;
        const hasAlpha = this.#hasAlpha = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.isAlphaColorInputSupported && opacityType !== undefined;
        const input = this.#input = document.createElement("input");
        input.type = "color";
        if (hasAlpha) {
            input.setAttribute("alpha", "");
            const alphaHex = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.hexNums[Math.round((opacity ?? 1) * 255)];
            input.value = (color || "#000000") + alphaHex;
        } else input.value = color || "#000000";
        input.className = "basicColorPicker";
        input.tabIndex = 0;
        input.setAttribute("data-l10n-id", $a2cc6e1d6eb3861b$var$BasicColorPicker.#l10nColor[editorType]);
        input.addEventListener("input", ()=>{
            if (hasAlpha) {
                const rgba = $a2cc6e1d6eb3861b$export$c24a0a5c5129b2e1(input.value);
                if (!rgba) return;
                const [r, g, b, op] = rgba;
                const hex = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(r, g, b);
                if (colorAndOpacityType !== undefined) this.#uiManager.updateParams(colorAndOpacityType, {
                    color: hex,
                    opacity: op
                });
                else {
                    this.#uiManager.updateParams(colorType, hex);
                    this.#uiManager.updateParams(opacityType, op);
                }
            } else this.#uiManager.updateParams(colorType, input.value);
        }, {
            signal: this.#uiManager._signal
        });
        return input;
    }
    update(value) {
        if (!this.#input) return;
        if (this.#hasAlpha) {
            const alphaHex = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.hexNums[Math.round(this.#editor.opacity * 255)];
            this.#input.value = value + alphaHex;
        } else this.#input.value = value;
    }
    updateOpacity(value) {
        if (!this.#input || !this.#hasAlpha) return;
        const alphaHex = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.hexNums[Math.round(value * 255)];
        this.#input.value = this.#editor.color + alphaHex;
    }
    destroy() {
        this.#input?.remove();
        this.#input = null;
    }
    hideDropdown() {}
}
function $a2cc6e1d6eb3861b$var$makeColorComp(n) {
    return Math.floor($a2cc6e1d6eb3861b$export$b8106b171181a554(n, 0, 1) * 255).toString(16).padStart(2, "0");
}
function $a2cc6e1d6eb3861b$var$scaleAndClamp(x) {
    return $a2cc6e1d6eb3861b$export$b8106b171181a554(x, 0, 1) * 255;
}
class $a2cc6e1d6eb3861b$var$ColorConverters {
    static CMYK_G([c, y, m, k]) {
        return [
            "G",
            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
        ];
    }
    static G_CMYK([g]) {
        return [
            "CMYK",
            0,
            0,
            0,
            1 - g
        ];
    }
    static G_RGB([g]) {
        return [
            "RGB",
            g,
            g,
            g
        ];
    }
    static G_rgb([g]) {
        g = $a2cc6e1d6eb3861b$var$scaleAndClamp(g);
        return [
            g,
            g,
            g
        ];
    }
    static G_HTML([g]) {
        const G = $a2cc6e1d6eb3861b$var$makeColorComp(g);
        return `#${G}${G}${G}`;
    }
    static RGB_G([r, g, b]) {
        return [
            "G",
            0.3 * r + 0.59 * g + 0.11 * b
        ];
    }
    static RGB_rgb(color) {
        return color.map($a2cc6e1d6eb3861b$var$scaleAndClamp);
    }
    static RGB_HTML(color) {
        return `#${color.map($a2cc6e1d6eb3861b$var$makeColorComp).join("")}`;
    }
    static T_HTML() {
        return "#00000000";
    }
    static T_rgb() {
        return [
            null
        ];
    }
    static CMYK_RGB([c, y, m, k]) {
        return [
            "RGB",
            1 - Math.min(1, c + k),
            1 - Math.min(1, m + k),
            1 - Math.min(1, y + k)
        ];
    }
    static CMYK_rgb([c, y, m, k]) {
        return [
            $a2cc6e1d6eb3861b$var$scaleAndClamp(1 - Math.min(1, c + k)),
            $a2cc6e1d6eb3861b$var$scaleAndClamp(1 - Math.min(1, m + k)),
            $a2cc6e1d6eb3861b$var$scaleAndClamp(1 - Math.min(1, y + k))
        ];
    }
    static CMYK_HTML(components) {
        const rgb = this.CMYK_RGB(components).slice(1);
        return this.RGB_HTML(rgb);
    }
    static RGB_CMYK([r, g, b]) {
        const c = 1 - r;
        const m = 1 - g;
        const y = 1 - b;
        const k = Math.min(c, m, y);
        return [
            "CMYK",
            c,
            m,
            y,
            k
        ];
    }
}
const $a2cc6e1d6eb3861b$var$DateFormats = /* unused pure expression or super */ null;
const $a2cc6e1d6eb3861b$var$TimeFormats = /* unused pure expression or super */ null;
class $a2cc6e1d6eb3861b$var$BaseSVGFactory {
    create(width, height, skipDimensions = false) {
        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
        const svg = this._createSVG("svg:svg");
        svg.setAttribute("version", "1.1");
        if (!skipDimensions) {
            svg.setAttribute("width", `${width}px`);
            svg.setAttribute("height", `${height}px`);
        }
        svg.setAttribute("preserveAspectRatio", "none");
        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
        return svg;
    }
    createElement(type) {
        if (typeof type !== "string") throw new Error("Invalid SVG element type");
        return this._createSVG(type);
    }
    _createSVG(type) {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `_createSVG` called.");
    }
}
class $a2cc6e1d6eb3861b$export$425e69f00724e63a extends $a2cc6e1d6eb3861b$var$BaseSVGFactory {
    _createSVG(type) {
        return document.createElementNS($a2cc6e1d6eb3861b$var$SVG_NS, type);
    }
}
const $a2cc6e1d6eb3861b$var$annotation_layer_DEFAULT_FONT_SIZE = 9;
const $a2cc6e1d6eb3861b$var$GetElementsByNameSet = new WeakSet();
const $a2cc6e1d6eb3861b$var$TIMEZONE_OFFSET = new Date().getTimezoneOffset() * 60000;
class $a2cc6e1d6eb3861b$var$AnnotationElementFactory {
    static create(parameters) {
        const subtype = parameters.data.annotationType;
        switch(subtype){
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.LINK:
                return new $a2cc6e1d6eb3861b$var$LinkAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.TEXT:
                return new $a2cc6e1d6eb3861b$var$TextAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.WIDGET:
                const fieldType = parameters.data.fieldType;
                switch(fieldType){
                    case "Tx":
                        return new $a2cc6e1d6eb3861b$var$TextWidgetAnnotationElement(parameters);
                    case "Btn":
                        if (parameters.data.radioButton) return new $a2cc6e1d6eb3861b$var$RadioButtonWidgetAnnotationElement(parameters);
                        else if (parameters.data.checkBox) return new $a2cc6e1d6eb3861b$var$CheckboxWidgetAnnotationElement(parameters);
                        return new $a2cc6e1d6eb3861b$var$PushButtonWidgetAnnotationElement(parameters);
                    case "Ch":
                        return new $a2cc6e1d6eb3861b$var$ChoiceWidgetAnnotationElement(parameters);
                    case "Sig":
                        return new $a2cc6e1d6eb3861b$var$SignatureWidgetAnnotationElement(parameters);
                }
                return new $a2cc6e1d6eb3861b$var$WidgetAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.POPUP:
                return new $a2cc6e1d6eb3861b$var$PopupAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.FREETEXT:
                return new $a2cc6e1d6eb3861b$var$FreeTextAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.LINE:
                return new $a2cc6e1d6eb3861b$var$LineAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.SQUARE:
                return new $a2cc6e1d6eb3861b$var$SquareAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.CIRCLE:
                return new $a2cc6e1d6eb3861b$var$CircleAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.POLYLINE:
                return new $a2cc6e1d6eb3861b$var$PolylineAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.CARET:
                return new $a2cc6e1d6eb3861b$var$CaretAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.INK:
                return new $a2cc6e1d6eb3861b$var$InkAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.POLYGON:
                return new $a2cc6e1d6eb3861b$var$PolygonAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.HIGHLIGHT:
                return new $a2cc6e1d6eb3861b$var$HighlightAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.UNDERLINE:
                return new $a2cc6e1d6eb3861b$var$UnderlineAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.SQUIGGLY:
                return new $a2cc6e1d6eb3861b$var$SquigglyAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.STRIKEOUT:
                return new $a2cc6e1d6eb3861b$var$StrikeOutAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.STAMP:
                return new $a2cc6e1d6eb3861b$var$StampAnnotationElement(parameters);
            case $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.FILEATTACHMENT:
                return new $a2cc6e1d6eb3861b$var$FileAttachmentAnnotationElement(parameters);
            default:
                return new $a2cc6e1d6eb3861b$var$AnnotationElement(parameters);
        }
    }
}
class $a2cc6e1d6eb3861b$var$AnnotationElement {
    #updates = null;
    #hasBorder = false;
    #popupElement = null;
    constructor(parameters, { isRenderable: isRenderable = false, ignoreBorder: ignoreBorder = false, createQuadrilaterals: createQuadrilaterals = false } = {}){
        this.isRenderable = isRenderable;
        this.data = parameters.data;
        this.layer = parameters.layer;
        this.linkService = parameters.linkService;
        this.downloadManager = parameters.downloadManager;
        this.imageResourcesPath = parameters.imageResourcesPath;
        this.renderForms = parameters.renderForms;
        this.svgFactory = parameters.svgFactory;
        this.annotationStorage = parameters.annotationStorage;
        this.enableComment = parameters.enableComment;
        this.enableScripting = parameters.enableScripting;
        this.hasJSActions = parameters.hasJSActions;
        this._fieldObjects = parameters.fieldObjects;
        this.parent = parameters.parent;
        this.hasOwnCommentButton = false;
        if (isRenderable) this.contentElement = this.container = this._createContainer(ignoreBorder);
        if (createQuadrilaterals) this._createQuadrilaterals();
    }
    static _hasPopupData({ contentsObj: contentsObj, richText: richText }) {
        return !!(contentsObj?.str || richText?.str);
    }
    get _isEditable() {
        return this.data.isEditable;
    }
    get hasPopupData() {
        return $a2cc6e1d6eb3861b$var$AnnotationElement._hasPopupData(this.data) || this.enableComment && !!this.commentText;
    }
    get commentData() {
        const { data: data } = this;
        const editor = this.annotationStorage?.getEditor(data.id);
        if (editor) return editor.getData();
        return data;
    }
    get hasCommentButton() {
        return this.enableComment && this.hasPopupElement;
    }
    get commentButtonPosition() {
        const editor = this.annotationStorage?.getEditor(this.data.id);
        if (editor) return editor.commentButtonPositionInPage;
        const { quadPoints: quadPoints, inkLists: inkLists, rect: rect } = this.data;
        let maxX = -Infinity;
        let maxY = -Infinity;
        if (quadPoints?.length >= 8) {
            for(let i = 0; i < quadPoints.length; i += 8){
                if (quadPoints[i + 1] > maxY) {
                    maxY = quadPoints[i + 1];
                    maxX = quadPoints[i + 2];
                } else if (quadPoints[i + 1] === maxY) maxX = Math.max(maxX, quadPoints[i + 2]);
            }
            return [
                maxX,
                maxY
            ];
        }
        if (inkLists?.length >= 1) {
            for (const inkList of inkLists)for(let i = 0, ii = inkList.length; i < ii; i += 2){
                if (inkList[i + 1] > maxY) {
                    maxY = inkList[i + 1];
                    maxX = inkList[i];
                } else if (inkList[i + 1] === maxY) maxX = Math.max(maxX, inkList[i]);
            }
            if (maxX !== Infinity) return [
                maxX,
                maxY
            ];
        }
        if (rect) return [
            rect[2],
            rect[3]
        ];
        return null;
    }
    _normalizePoint(point) {
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.parent;
        point[1] = view[3] - point[1] + view[1];
        point[0] = 100 * (point[0] - pageX) / pageWidth;
        point[1] = 100 * (point[1] - pageY) / pageHeight;
        return point;
    }
    get commentText() {
        const { data: data } = this;
        return this.annotationStorage.getRawValue(`${$a2cc6e1d6eb3861b$var$AnnotationEditorPrefix}${data.id}`)?.popup?.contents || data.contentsObj?.str || "";
    }
    set commentText(text) {
        const { data: data } = this;
        const popup = {
            deleted: !text,
            contents: text || ""
        };
        if (!this.annotationStorage.updateEditor(data.id, {
            popup: popup
        })) this.annotationStorage.setValue(`${$a2cc6e1d6eb3861b$var$AnnotationEditorPrefix}${data.id}`, {
            id: data.id,
            annotationType: data.annotationType,
            page: this.parent.page,
            popup: popup,
            popupRef: data.popupRef,
            modificationDate: new Date()
        });
        if (!text) this.removePopup();
    }
    removePopup() {
        (this.#popupElement?.popup || this.popup)?.remove();
        this.#popupElement = this.popup = null;
    }
    updateEdited(params) {
        if (!this.container) return;
        if (params.rect) this.#updates ||= {
            rect: this.data.rect.slice(0)
        };
        const { rect: rect, popup: newPopup } = params;
        if (rect) this.#setRectEdited(rect);
        let popup = this.#popupElement?.popup || this.popup;
        if (!popup && newPopup?.text) {
            this._createPopup(newPopup);
            popup = this.#popupElement.popup;
        }
        if (!popup) return;
        popup.updateEdited(params);
        if (newPopup?.deleted) {
            popup.remove();
            this.#popupElement = null;
            this.popup = null;
        }
    }
    resetEdited() {
        if (!this.#updates) return;
        this.#setRectEdited(this.#updates.rect);
        this.#popupElement?.popup.resetEdited();
        this.#updates = null;
    }
    #setRectEdited(rect) {
        const { container: { style: style }, data: { rect: currentRect, rotation: rotation }, parent: { viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } } = this;
        currentRect?.splice(0, 4, ...rect);
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (pageHeight - rect[3] + pageY) / pageHeight}%`;
        if (rotation === 0) {
            style.width = `${100 * (rect[2] - rect[0]) / pageWidth}%`;
            style.height = `${100 * (rect[3] - rect[1]) / pageHeight}%`;
        } else this.setRotation(rotation);
    }
    _createContainer(ignoreBorder) {
        const { data: data, parent: { page: page, viewport: viewport } } = this;
        const container = document.createElement("section");
        container.setAttribute("data-annotation-id", data.id);
        if (!(this instanceof $a2cc6e1d6eb3861b$var$WidgetAnnotationElement) && !(this instanceof $a2cc6e1d6eb3861b$var$LinkAnnotationElement)) container.tabIndex = 0;
        const { style: style } = container;
        style.zIndex = this.parent.zIndex;
        this.parent.zIndex += 2;
        if (data.alternativeText) container.title = data.alternativeText;
        if (data.noRotate) container.classList.add("norotate");
        if (!data.rect || this instanceof $a2cc6e1d6eb3861b$var$PopupAnnotationElement) {
            const { rotation: rotation } = data;
            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
            return container;
        }
        const { width: width, height: height } = this;
        if (!ignoreBorder && data.borderStyle.width > 0) {
            style.borderWidth = `${data.borderStyle.width}px`;
            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
            const verticalRadius = data.borderStyle.verticalCornerRadius;
            if (horizontalRadius > 0 || verticalRadius > 0) {
                const radius = `calc(${horizontalRadius}px * var(--total-scale-factor)) / calc(${verticalRadius}px * var(--total-scale-factor))`;
                style.borderRadius = radius;
            } else if (this instanceof $a2cc6e1d6eb3861b$var$RadioButtonWidgetAnnotationElement) {
                const radius = `calc(${width}px * var(--total-scale-factor)) / calc(${height}px * var(--total-scale-factor))`;
                style.borderRadius = radius;
            }
            switch(data.borderStyle.style){
                case $a2cc6e1d6eb3861b$var$AnnotationBorderStyleType.SOLID:
                    style.borderStyle = "solid";
                    break;
                case $a2cc6e1d6eb3861b$var$AnnotationBorderStyleType.DASHED:
                    style.borderStyle = "dashed";
                    break;
                case $a2cc6e1d6eb3861b$var$AnnotationBorderStyleType.BEVELED:
                    $a2cc6e1d6eb3861b$var$warn("Unimplemented border style: beveled");
                    break;
                case $a2cc6e1d6eb3861b$var$AnnotationBorderStyleType.INSET:
                    $a2cc6e1d6eb3861b$var$warn("Unimplemented border style: inset");
                    break;
                case $a2cc6e1d6eb3861b$var$AnnotationBorderStyleType.UNDERLINE:
                    style.borderBottomStyle = "solid";
                    break;
                default:
                    break;
            }
            const borderColor = data.borderColor || null;
            if (borderColor) {
                this.#hasBorder = true;
                style.borderColor = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(...borderColor);
            } else style.borderWidth = 0;
        }
        const rect = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.normalizeRect([
            data.rect[0],
            page.view[3] - data.rect[1] + page.view[1],
            data.rect[2],
            page.view[3] - data.rect[3] + page.view[1]
        ]);
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
        const { rotation: rotation } = data;
        if (data.hasOwnCanvas || rotation === 0) {
            style.width = `${100 * width / pageWidth}%`;
            style.height = `${100 * height / pageHeight}%`;
        } else this.setRotation(rotation, container);
        return container;
    }
    setRotation(angle, container = this.container) {
        if (!this.data.rect) return;
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.parent.viewport.rawDims;
        let { width: width, height: height } = this;
        if (angle % 180 !== 0) [width, height] = [
            height,
            width
        ];
        container.style.width = `${100 * width / pageWidth}%`;
        container.style.height = `${100 * height / pageHeight}%`;
        container.setAttribute("data-main-rotation", (360 - angle) % 360);
    }
    get _commonActions() {
        const setColor = (jsName, styleName, event)=>{
            const color = event.detail[jsName];
            const colorType = color[0];
            const colorArray = color.slice(1);
            event.target.style[styleName] = $a2cc6e1d6eb3861b$var$ColorConverters[`${colorType}_HTML`](colorArray);
            this.annotationStorage.setValue(this.data.id, {
                [styleName]: $a2cc6e1d6eb3861b$var$ColorConverters[`${colorType}_rgb`](colorArray)
            });
        };
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_commonActions", {
            display: (event)=>{
                const { display: display } = event.detail;
                const hidden = display % 2 === 1;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noView: hidden,
                    noPrint: display === 1 || display === 2
                });
            },
            print: (event)=>{
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: !event.detail.print
                });
            },
            hidden: (event)=>{
                const { hidden: hidden } = event.detail;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: hidden,
                    noView: hidden
                });
            },
            focus: (event)=>{
                setTimeout(()=>event.target.focus({
                        preventScroll: false
                    }), 0);
            },
            userName: (event)=>{
                event.target.title = event.detail.userName;
            },
            readonly: (event)=>{
                event.target.disabled = event.detail.readonly;
            },
            required: (event)=>{
                this._setRequired(event.target, event.detail.required);
            },
            bgColor: (event)=>{
                setColor("bgColor", "backgroundColor", event);
            },
            fillColor: (event)=>{
                setColor("fillColor", "backgroundColor", event);
            },
            fgColor: (event)=>{
                setColor("fgColor", "color", event);
            },
            textColor: (event)=>{
                setColor("textColor", "color", event);
            },
            borderColor: (event)=>{
                setColor("borderColor", "borderColor", event);
            },
            strokeColor: (event)=>{
                setColor("strokeColor", "borderColor", event);
            },
            rotation: (event)=>{
                const angle = event.detail.rotation;
                this.setRotation(angle);
                this.annotationStorage.setValue(this.data.id, {
                    rotation: angle
                });
            }
        });
    }
    _dispatchEventFromSandbox(actions, jsEvent) {
        const commonActions = this._commonActions;
        for (const name of Object.keys(jsEvent.detail)){
            const action = actions[name] || commonActions[name];
            action?.(jsEvent);
        }
    }
    _setDefaultPropertiesFromJS(element) {
        if (!this.enableScripting) return;
        const storedData = this.annotationStorage.getRawValue(this.data.id);
        if (!storedData) return;
        const commonActions = this._commonActions;
        for (const [actionName, detail] of Object.entries(storedData)){
            const action = commonActions[actionName];
            if (action) {
                const eventProxy = {
                    detail: {
                        [actionName]: detail
                    },
                    target: element
                };
                action(eventProxy);
                delete storedData[actionName];
            }
        }
    }
    _createQuadrilaterals() {
        if (!this.container) return;
        const { quadPoints: quadPoints } = this.data;
        if (!quadPoints) return;
        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect.map((x)=>Math.fround(x));
        if (quadPoints.length === 8) {
            const [trX, trY, blX, blY] = quadPoints.subarray(2, 6);
            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
        }
        const { style: style } = this.container;
        let svgBuffer;
        if (this.#hasBorder) {
            const { borderColor: borderColor, borderWidth: borderWidth } = style;
            style.borderWidth = 0;
            svgBuffer = [
                "url('data:image/svg+xml;utf8,",
                `<svg xmlns="${$a2cc6e1d6eb3861b$var$SVG_NS}" preserveAspectRatio="none" viewBox="0 0 1 1">`,
                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
            ];
            this.container.classList.add("hasBorder");
        }
        const width = rectTrX - rectBlX;
        const height = rectTrY - rectBlY;
        const { svgFactory: svgFactory } = this;
        const svg = svgFactory.createElement("svg");
        svg.classList.add("quadrilateralsContainer");
        svg.setAttribute("width", 0);
        svg.setAttribute("height", 0);
        svg.role = "none";
        const defs = svgFactory.createElement("defs");
        svg.append(defs);
        const clipPath = svgFactory.createElement("clipPath");
        const id = `clippath_${this.data.id}`;
        clipPath.setAttribute("id", id);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        defs.append(clipPath);
        for(let i = 2, ii = quadPoints.length; i < ii; i += 8){
            const trX = quadPoints[i];
            const trY = quadPoints[i + 1];
            const blX = quadPoints[i + 2];
            const blY = quadPoints[i + 3];
            const rect = svgFactory.createElement("rect");
            const x = (blX - rectBlX) / width;
            const y = (rectTrY - trY) / height;
            const rectWidth = (trX - blX) / width;
            const rectHeight = (trY - blY) / height;
            rect.setAttribute("x", x);
            rect.setAttribute("y", y);
            rect.setAttribute("width", rectWidth);
            rect.setAttribute("height", rectHeight);
            clipPath.append(rect);
            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
        }
        if (this.#hasBorder) {
            svgBuffer.push(`</g></svg>')`);
            style.backgroundImage = svgBuffer.join("");
        }
        this.container.append(svg);
        this.container.style.clipPath = `url(#${id})`;
    }
    _createPopup(popupData = null) {
        const { data: data } = this;
        let contentsObj, modificationDate;
        if (popupData) {
            contentsObj = {
                str: popupData.text
            };
            modificationDate = popupData.date;
        } else {
            contentsObj = data.contentsObj;
            modificationDate = data.modificationDate;
        }
        this.#popupElement = new $a2cc6e1d6eb3861b$var$PopupAnnotationElement({
            data: {
                color: data.color,
                titleObj: data.titleObj,
                modificationDate: modificationDate,
                contentsObj: contentsObj,
                richText: data.richText,
                parentRect: data.rect,
                borderStyle: 0,
                id: `popup_${data.id}`,
                rotation: data.rotation,
                noRotate: true
            },
            linkService: this.linkService,
            parent: this.parent,
            elements: [
                this
            ]
        });
    }
    get hasPopupElement() {
        return !!(this.#popupElement || this.popup || this.data.popupRef);
    }
    get extraPopupElement() {
        return this.#popupElement;
    }
    render() {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `AnnotationElement.render` called");
    }
    _getElementsByName(name, skipId = null) {
        const fields = [];
        if (this._fieldObjects) {
            const fieldObj = this._fieldObjects[name];
            if (fieldObj) for (const { page: page, id: id, exportValues: exportValues } of fieldObj){
                if (page === -1) continue;
                if (id === skipId) continue;
                const exportValue = typeof exportValues === "string" ? exportValues : null;
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (domElement && !$a2cc6e1d6eb3861b$var$GetElementsByNameSet.has(domElement)) {
                    $a2cc6e1d6eb3861b$var$warn(`_getElementsByName - element not allowed: ${id}`);
                    continue;
                }
                fields.push({
                    id: id,
                    exportValue: exportValue,
                    domElement: domElement
                });
            }
            return fields;
        }
        for (const domElement of document.getElementsByName(name)){
            const { exportValue: exportValue } = domElement;
            const id = domElement.getAttribute("data-element-id");
            if (id === skipId) continue;
            if (!$a2cc6e1d6eb3861b$var$GetElementsByNameSet.has(domElement)) continue;
            fields.push({
                id: id,
                exportValue: exportValue,
                domElement: domElement
            });
        }
        return fields;
    }
    show() {
        if (this.container) this.container.hidden = false;
        this.popup?.maybeShow();
    }
    hide() {
        if (this.container) this.container.hidden = true;
        this.popup?.forceHide();
    }
    getElementsToTriggerPopup() {
        return this.container;
    }
    addHighlightArea() {
        const triggers = this.getElementsToTriggerPopup();
        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
        else triggers.classList.add("highlightArea");
    }
    _editOnDoubleClick() {
        if (!this._isEditable) return;
        const { annotationEditorType: mode, data: { id: editId } } = this;
        this.container.addEventListener("dblclick", ()=>{
            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                source: this,
                mode: mode,
                editId: editId,
                mustEnterInEditMode: true
            });
        });
    }
    updateOC(optionalContentConfig) {
        if (!this.data.oc || !optionalContentConfig) return;
        const isVisible = optionalContentConfig.isVisible(this.data.oc);
        if (isVisible) this.show();
        else this.hide();
    }
    get width() {
        return this.data.rect[2] - this.data.rect[0];
    }
    get height() {
        return this.data.rect[3] - this.data.rect[1];
    }
}
class $a2cc6e1d6eb3861b$var$EditorAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.editor = parameters.editor;
    }
    render() {
        this.container.className = "editorAnnotation";
        return this.container;
    }
    createOrUpdatePopup() {
        const { editor: editor } = this;
        if (!editor.hasComment) return;
        this._createPopup(editor.comment);
    }
    get hasCommentButton() {
        return this.enableComment && this.editor.hasComment;
    }
    get commentButtonPosition() {
        return this.editor.commentButtonPositionInPage;
    }
    get commentText() {
        return this.editor.comment.text;
    }
    set commentText(text) {
        this.editor.comment = text;
        if (!text) this.removePopup();
    }
    get commentData() {
        return this.editor.getData();
    }
    remove() {
        this.parent.removeAnnotation(this.data.id);
        this.container.remove();
        this.container = null;
        this.removePopup();
    }
}
class $a2cc6e1d6eb3861b$var$LinkAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters, options = null){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: !!options?.ignoreBorder,
            createQuadrilaterals: true
        });
        this.isTooltipOnly = parameters.data.isTooltipOnly;
    }
    render() {
        const { data: data, linkService: linkService } = this;
        const link = document.createElement("a");
        link.setAttribute("data-element-id", data.id);
        let isBound = false;
        if (data.url) {
            linkService.addLinkAttributes(link, data.url, data.newWindow);
            isBound = true;
        } else if (data.action) {
            this._bindNamedAction(link, data.action, data.overlaidText);
            isBound = true;
        } else if (data.attachment) {
            this.#bindAttachment(link, data.attachment, data.overlaidText, data.attachmentDest);
            isBound = true;
        } else if (data.setOCGState) {
            this.#bindSetOCGState(link, data.setOCGState, data.overlaidText);
            isBound = true;
        } else if (data.dest) {
            this._bindLink(link, data.dest, data.overlaidText);
            isBound = true;
        } else {
            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                this._bindJSAction(link, data);
                isBound = true;
            }
            if (data.resetForm) {
                this._bindResetFormAction(link, data.resetForm);
                isBound = true;
            } else if (this.isTooltipOnly && !isBound) {
                this._bindLink(link, "");
                isBound = true;
            }
        }
        this.container.classList.add("linkAnnotation");
        if (isBound) {
            this.contentElement = link;
            this.container.append(link);
        }
        return this.container;
    }
    #setInternalLink() {
        this.container.setAttribute("data-internal-link", "");
    }
    _bindLink(link, destination, overlaidText = "") {
        link.href = this.linkService.getDestinationHash(destination);
        link.onclick = ()=>{
            if (destination) this.linkService.goToDestination(destination);
            return false;
        };
        if (destination || destination === "") this.#setInternalLink();
        if (overlaidText) link.title = overlaidText;
    }
    _bindNamedAction(link, action, overlaidText = "") {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeNamedAction(action);
            return false;
        };
        if (overlaidText) link.title = overlaidText;
        this.#setInternalLink();
    }
    #bindAttachment(link, attachment, overlaidText = "", dest = null) {
        link.href = this.linkService.getAnchorUrl("");
        if (attachment.description) link.title = attachment.description;
        else if (overlaidText) link.title = overlaidText;
        link.onclick = ()=>{
            this.downloadManager?.openOrDownloadData(attachment.content, attachment.filename, dest);
            return false;
        };
        this.#setInternalLink();
    }
    #bindSetOCGState(link, action, overlaidText = "") {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeSetOCGState(action);
            return false;
        };
        if (overlaidText) link.title = overlaidText;
        this.#setInternalLink();
    }
    _bindJSAction(link, data) {
        link.href = this.linkService.getAnchorUrl("");
        const map = new Map([
            [
                "Action",
                "onclick"
            ],
            [
                "Mouse Up",
                "onmouseup"
            ],
            [
                "Mouse Down",
                "onmousedown"
            ]
        ]);
        for (const name of Object.keys(data.actions)){
            const jsName = map.get(name);
            if (!jsName) continue;
            link[jsName] = ()=>{
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: data.id,
                        name: name
                    }
                });
                return false;
            };
        }
        if (data.overlaidText) link.title = data.overlaidText;
        if (!link.onclick) link.onclick = ()=>false;
        this.#setInternalLink();
    }
    _bindResetFormAction(link, resetForm) {
        const otherClickAction = link.onclick;
        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
        this.#setInternalLink();
        if (!this._fieldObjects) {
            $a2cc6e1d6eb3861b$var$warn(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
            if (!otherClickAction) link.onclick = ()=>false;
            return;
        }
        link.onclick = ()=>{
            otherClickAction?.();
            const { fields: resetFormFields, refs: resetFormRefs, include: include } = resetForm;
            const allFields = [];
            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                const fieldIds = new Set(resetFormRefs);
                for (const fieldName of resetFormFields){
                    const fields = this._fieldObjects[fieldName] || [];
                    for (const { id: id } of fields)fieldIds.add(id);
                }
                for (const fields of Object.values(this._fieldObjects)){
                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                }
            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
            const storage = this.annotationStorage;
            const allIds = [];
            for (const field of allFields){
                const { id: id } = field;
                allIds.push(id);
                switch(field.type){
                    case "text":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "checkbox":
                    case "radiobutton":
                        {
                            const value = field.defaultValue === field.exportValues;
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "combobox":
                    case "listbox":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    default:
                        continue;
                }
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (!domElement) continue;
                else if (!$a2cc6e1d6eb3861b$var$GetElementsByNameSet.has(domElement)) {
                    $a2cc6e1d6eb3861b$var$warn(`_bindResetFormAction - element not allowed: ${id}`);
                    continue;
                }
                domElement.dispatchEvent(new Event("resetform"));
            }
            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: "app",
                    ids: allIds,
                    name: "ResetForm"
                }
            });
            return false;
        };
    }
}
class $a2cc6e1d6eb3861b$var$TextAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
    }
    render() {
        this.container.classList.add("textAnnotation");
        const image = document.createElement("img");
        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
        image.setAttribute("data-l10n-id", "pdfjs-text-annotation-type");
        image.setAttribute("data-l10n-args", JSON.stringify({
            type: this.data.name
        }));
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.append(image);
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$WidgetAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    render() {
        return this.container;
    }
    showElementAndHideCanvas(element) {
        if (this.data.hasOwnCanvas) {
            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
            element.hidden = false;
        }
    }
    _getKeyModifier(event) {
        return $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform.isMac ? event.metaKey : event.ctrlKey;
    }
    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event),
                    shift: event.shiftKey,
                    modifier: this._getKeyModifier(event)
                }
            });
        });
        else element.addEventListener(baseName, (event)=>{
            if (baseName === "blur") {
                if (!elementData.focused || !event.relatedTarget) return;
                elementData.focused = false;
            } else if (baseName === "focus") {
                if (elementData.focused) return;
                elementData.focused = true;
            }
            if (!valueGetter) return;
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event)
                }
            });
        });
    }
    _setEventListeners(element, elementData, names, getter) {
        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                focused: false
            };
            this._setEventListener(element, elementData, baseName, eventName, getter);
            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
        }
    }
    _setBackgroundColor(element) {
        const color = this.data.backgroundColor || null;
        element.style.backgroundColor = color === null ? "transparent" : $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(...color);
    }
    _setTextStyle(element) {
        const TEXT_ALIGNMENT = [
            "left",
            "center",
            "right"
        ];
        const { fontColor: fontColor } = this.data.defaultAppearanceData;
        const fontSize = this.data.defaultAppearanceData.fontSize || $a2cc6e1d6eb3861b$var$annotation_layer_DEFAULT_FONT_SIZE;
        const style = element.style;
        let computedFontSize;
        const BORDER_SIZE = 2;
        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
        if (this.data.multiLine) {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            const numberOfLines = Math.round(height / ($a2cc6e1d6eb3861b$var$LINE_FACTOR * fontSize)) || 1;
            const lineHeight = height / numberOfLines;
            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / $a2cc6e1d6eb3861b$var$LINE_FACTOR));
        } else {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / $a2cc6e1d6eb3861b$var$LINE_FACTOR));
        }
        style.fontSize = `calc(${computedFontSize}px * var(--total-scale-factor))`;
        style.color = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(...fontColor);
        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
    }
    _setRequired(element, isRequired) {
        if (isRequired) element.setAttribute("required", true);
        else element.removeAttribute("required");
        element.setAttribute("aria-required", isRequired);
    }
}
class $a2cc6e1d6eb3861b$var$TextWidgetAnnotationElement extends $a2cc6e1d6eb3861b$var$WidgetAnnotationElement {
    constructor(parameters){
        const isRenderable = parameters.renderForms || parameters.data.hasOwnCanvas || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
        super(parameters, {
            isRenderable: isRenderable
        });
    }
    setPropertyOnSiblings(base, key, value, keyInStorage) {
        const storage = this.annotationStorage;
        for (const element of this._getElementsByName(base.name, base.id)){
            if (element.domElement) element.domElement[key] = value;
            storage.setValue(element.id, {
                [keyInStorage]: value
            });
        }
    }
    render() {
        const storage = this.annotationStorage;
        const id = this.data.id;
        this.container.classList.add("textWidgetAnnotation");
        let element = null;
        if (this.renderForms) {
            const storedData = storage.getValue(id, {
                value: this.data.fieldValue
            });
            let textContent = storedData.value || "";
            const maxLen = storage.getValue(id, {
                charLimit: this.data.maxLen
            }).charLimit;
            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
            const elementData = {
                userValue: textContent,
                formattedValue: fieldFormattedValues,
                lastCommittedValue: null,
                commitKey: 1,
                focused: false
            };
            if (this.data.multiLine) {
                element = document.createElement("textarea");
                element.textContent = fieldFormattedValues ?? textContent;
                if (this.data.doNotScroll) element.style.overflowY = "hidden";
            } else {
                element = document.createElement("input");
                element.type = this.data.password ? "password" : "text";
                element.setAttribute("value", fieldFormattedValues ?? textContent);
                if (this.data.doNotScroll) element.style.overflowX = "hidden";
            }
            if (this.data.hasOwnCanvas) element.hidden = true;
            $a2cc6e1d6eb3861b$var$GetElementsByNameSet.add(element);
            this.contentElement = element;
            element.setAttribute("data-element-id", id);
            element.disabled = this.data.readOnly;
            element.name = this.data.fieldName;
            element.tabIndex = 0;
            const { datetimeFormat: datetimeFormat, datetimeType: datetimeType, timeStep: timeStep } = this.data;
            const hasDateOrTime = !!datetimeType && this.enableScripting;
            if (datetimeFormat) element.title = datetimeFormat;
            this._setRequired(element, this.data.required);
            if (maxLen) element.maxLength = maxLen;
            element.addEventListener("input", (event)=>{
                storage.setValue(id, {
                    value: event.target.value
                });
                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                elementData.formattedValue = null;
            });
            element.addEventListener("resetform", (event)=>{
                const defaultValue = this.data.defaultFieldValue ?? "";
                element.value = elementData.userValue = defaultValue;
                elementData.formattedValue = null;
            });
            let blurListener = (event)=>{
                const { formattedValue: formattedValue } = elementData;
                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                event.target.scrollLeft = 0;
            };
            if (this.enableScripting && this.hasJSActions) {
                element.addEventListener("focus", (event)=>{
                    if (elementData.focused) return;
                    const { target: target } = event;
                    if (hasDateOrTime) {
                        target.type = datetimeType;
                        if (timeStep) target.step = timeStep;
                    }
                    if (elementData.userValue) {
                        const value = elementData.userValue;
                        if (hasDateOrTime) {
                            if (datetimeType === "time") {
                                const date = new Date(value);
                                const parts = [
                                    date.getHours(),
                                    date.getMinutes(),
                                    date.getSeconds()
                                ];
                                target.value = parts.map((v)=>v.toString().padStart(2, "0")).join(":");
                            } else target.value = new Date(value - $a2cc6e1d6eb3861b$var$TIMEZONE_OFFSET).toISOString().split(datetimeType === "date" ? "T" : ".", 1)[0];
                        } else target.value = value;
                    }
                    elementData.lastCommittedValue = target.value;
                    elementData.commitKey = 1;
                    if (!this.data.actions?.Focus) elementData.focused = true;
                });
                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                    this.showElementAndHideCanvas(jsEvent.target);
                    const actions = {
                        value (event) {
                            elementData.userValue = event.detail.value ?? "";
                            if (!hasDateOrTime) storage.setValue(id, {
                                value: elementData.userValue.toString()
                            });
                            event.target.value = elementData.userValue;
                        },
                        formattedValue (event) {
                            const { formattedValue: formattedValue } = event.detail;
                            elementData.formattedValue = formattedValue;
                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                            const data = {
                                formattedValue: formattedValue
                            };
                            if (hasDateOrTime) data.value = formattedValue;
                            storage.setValue(id, data);
                        },
                        selRange (event) {
                            event.target.setSelectionRange(...event.detail.selRange);
                        },
                        charLimit: (event)=>{
                            const { charLimit: charLimit } = event.detail;
                            const { target: target } = event;
                            if (charLimit === 0) {
                                target.removeAttribute("maxLength");
                                return;
                            }
                            target.setAttribute("maxLength", charLimit);
                            let value = elementData.userValue;
                            if (!value || value.length <= charLimit) return;
                            value = value.slice(0, charLimit);
                            target.value = elementData.userValue = value;
                            storage.setValue(id, {
                                value: value
                            });
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: id,
                                    name: "Keystroke",
                                    value: value,
                                    willCommit: true,
                                    commitKey: 1,
                                    selStart: target.selectionStart,
                                    selEnd: target.selectionEnd
                                }
                            });
                        }
                    };
                    this._dispatchEventFromSandbox(actions, jsEvent);
                });
                element.addEventListener("keydown", (event)=>{
                    elementData.commitKey = 1;
                    let commitKey = -1;
                    if (event.key === "Escape") commitKey = 0;
                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                    else if (event.key === "Tab") elementData.commitKey = 3;
                    if (commitKey === -1) return;
                    const { value: value } = event.target;
                    if (elementData.lastCommittedValue === value) return;
                    elementData.lastCommittedValue = value;
                    elementData.userValue = value;
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                });
                const _blurListener = blurListener;
                blurListener = null;
                element.addEventListener("blur", (event)=>{
                    if (!elementData.focused || !event.relatedTarget) return;
                    if (!this.data.actions?.Blur) elementData.focused = false;
                    const { target: target } = event;
                    let { value: value } = target;
                    if (hasDateOrTime) {
                        if (value && datetimeType === "time") {
                            const parts = value.split(":").map((v)=>parseInt(v, 10));
                            value = new Date(2000, 0, 1, parts[0], parts[1], parts[2] || 0).valueOf();
                            target.step = "";
                        } else {
                            if (!value.includes("T")) value = `${value}T00:00`;
                            value = new Date(value).valueOf();
                        }
                        target.type = "text";
                    }
                    elementData.userValue = value;
                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: elementData.commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                    _blurListener(event);
                });
                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                    elementData.lastCommittedValue = null;
                    const { data: data, target: target } = event;
                    const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = target;
                    let selStart = selectionStart, selEnd = selectionEnd;
                    switch(event.inputType){
                        case "deleteWordBackward":
                            {
                                const match = value.substring(0, selectionStart).match(/\w*\W*$/);
                                if (match) selStart -= match[0].length;
                                break;
                            }
                        case "deleteWordForward":
                            {
                                const match = value.substring(selectionStart).match(/^\W*\w*/);
                                if (match) selEnd += match[0].length;
                                break;
                            }
                        case "deleteContentBackward":
                            if (selectionStart === selectionEnd) selStart -= 1;
                            break;
                        case "deleteContentForward":
                            if (selectionStart === selectionEnd) selEnd += 1;
                            break;
                    }
                    event.preventDefault();
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            change: data || "",
                            willCommit: false,
                            selStart: selStart,
                            selEnd: selEnd
                        }
                    });
                });
                this._setEventListeners(element, elementData, [
                    [
                        "focus",
                        "Focus"
                    ],
                    [
                        "blur",
                        "Blur"
                    ],
                    [
                        "mousedown",
                        "Mouse Down"
                    ],
                    [
                        "mouseenter",
                        "Mouse Enter"
                    ],
                    [
                        "mouseleave",
                        "Mouse Exit"
                    ],
                    [
                        "mouseup",
                        "Mouse Up"
                    ]
                ], (event)=>event.target.value);
            }
            if (blurListener) element.addEventListener("blur", blurListener);
            if (this.data.comb) {
                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                const combWidth = fieldWidth / maxLen;
                element.classList.add("comb");
                element.style.letterSpacing = `calc(${combWidth}px * var(--total-scale-factor) - 1ch)`;
            }
        } else {
            element = document.createElement("div");
            element.textContent = this.data.fieldValue;
            element.style.verticalAlign = "middle";
            element.style.display = "table-cell";
            if (this.data.hasOwnCanvas) element.hidden = true;
        }
        this._setTextStyle(element);
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$SignatureWidgetAnnotationElement extends $a2cc6e1d6eb3861b$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: !!parameters.data.hasOwnCanvas
        });
    }
}
class $a2cc6e1d6eb3861b$var$CheckboxWidgetAnnotationElement extends $a2cc6e1d6eb3861b$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.exportValue === data.fieldValue
        }).value;
        if (typeof value === "string") {
            value = value !== "Off";
            storage.setValue(id, {
                value: value
            });
        }
        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
        const element = document.createElement("input");
        $a2cc6e1d6eb3861b$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "checkbox";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.setAttribute("exportValue", data.exportValue);
        element.tabIndex = 0;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const checkbox of this._getElementsByName(name, id)){
                const curChecked = checked && checkbox.exportValue === data.exportValue;
                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                storage.setValue(checkbox.id, {
                    value: curChecked
                });
            }
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue || "Off";
            event.target.checked = defaultValue === data.exportValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        event.target.checked = event.detail.value !== "Off";
                        storage.setValue(id, {
                            value: event.target.checked
                        });
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$RadioButtonWidgetAnnotationElement extends $a2cc6e1d6eb3861b$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.fieldValue === data.buttonValue
        }).value;
        if (typeof value === "string") {
            value = value !== data.buttonValue;
            storage.setValue(id, {
                value: value
            });
        }
        if (value) for (const radio of this._getElementsByName(data.fieldName, id))storage.setValue(radio.id, {
            value: false
        });
        const element = document.createElement("input");
        $a2cc6e1d6eb3861b$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "radio";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.tabIndex = 0;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                value: false
            });
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue;
            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            const pdfButtonValue = data.buttonValue;
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value: (event)=>{
                        const checked = pdfButtonValue === event.detail.value;
                        for (const radio of this._getElementsByName(event.target.name)){
                            const curChecked = checked && radio.id === id;
                            if (radio.domElement) radio.domElement.checked = curChecked;
                            storage.setValue(radio.id, {
                                value: curChecked
                            });
                        }
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$PushButtonWidgetAnnotationElement extends $a2cc6e1d6eb3861b$var$LinkAnnotationElement {
    constructor(parameters){
        super(parameters, {
            ignoreBorder: parameters.data.hasAppearance
        });
    }
    render() {
        const container = super.render();
        container.classList.add("buttonWidgetAnnotation", "pushButton");
        const linkElement = container.lastChild;
        if (this.enableScripting && this.hasJSActions && linkElement) {
            this._setDefaultPropertiesFromJS(linkElement);
            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                this._dispatchEventFromSandbox({}, jsEvent);
            });
        }
        return container;
    }
}
class $a2cc6e1d6eb3861b$var$ChoiceWidgetAnnotationElement extends $a2cc6e1d6eb3861b$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("choiceWidgetAnnotation");
        const storage = this.annotationStorage;
        const id = this.data.id;
        const storedData = storage.getValue(id, {
            value: this.data.fieldValue
        });
        const selectElement = document.createElement("select");
        $a2cc6e1d6eb3861b$var$GetElementsByNameSet.add(selectElement);
        selectElement.setAttribute("data-element-id", id);
        selectElement.disabled = this.data.readOnly;
        this._setRequired(selectElement, this.data.required);
        selectElement.name = this.data.fieldName;
        selectElement.tabIndex = 0;
        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
        if (!this.data.combo) {
            selectElement.size = this.data.options.length;
            if (this.data.multiSelect) selectElement.multiple = true;
        }
        selectElement.addEventListener("resetform", (event)=>{
            const defaultValue = this.data.defaultFieldValue;
            for (const option of selectElement.options)option.selected = option.value === defaultValue;
        });
        const fixDisplayValue = (option, value)=>{
            const newValue = value.replaceAll(" ", "\u00A0");
            option.textContent = newValue;
            if (newValue !== value) option.setAttribute("display-value", value);
        };
        for (const option of this.data.options){
            const optionElement = document.createElement("option");
            fixDisplayValue(optionElement, option.displayValue);
            optionElement.value = option.exportValue;
            if (storedData.value.includes(option.exportValue)) {
                optionElement.setAttribute("selected", true);
                addAnEmptyEntry = false;
            }
            selectElement.append(optionElement);
        }
        let removeEmptyEntry = null;
        if (addAnEmptyEntry) {
            const noneOptionElement = document.createElement("option");
            noneOptionElement.value = " ";
            noneOptionElement.setAttribute("hidden", true);
            noneOptionElement.setAttribute("selected", true);
            selectElement.prepend(noneOptionElement);
            removeEmptyEntry = ()=>{
                noneOptionElement.remove();
                selectElement.removeEventListener("input", removeEmptyEntry);
                removeEmptyEntry = null;
            };
            selectElement.addEventListener("input", removeEmptyEntry);
        }
        const getValue = (isExport)=>{
            const name = isExport ? "value" : "textContent";
            const { options: options, multiple: multiple } = selectElement;
            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
        };
        let selectedValues = getValue(false);
        const getItems = (event)=>{
            const options = event.target.options;
            return Array.prototype.map.call(options, (option)=>({
                    displayValue: option.getAttribute("display-value") || option.textContent,
                    exportValue: option.value
                }));
        };
        if (this.enableScripting && this.hasJSActions) {
            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        removeEmptyEntry?.();
                        const value = event.detail.value;
                        const values = new Set(Array.isArray(value) ? value : [
                            value
                        ]);
                        for (const option of selectElement.options)option.selected = values.has(option.value);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    multipleSelection (event) {
                        selectElement.multiple = true;
                    },
                    remove (event) {
                        const options = selectElement.options;
                        const index = event.detail.remove;
                        options[index].selected = false;
                        selectElement.remove(index);
                        if (options.length > 0) {
                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                            if (i === -1) options[0].selected = true;
                        }
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    clear (event) {
                        while(selectElement.length !== 0)selectElement.remove(0);
                        storage.setValue(id, {
                            value: null,
                            items: []
                        });
                        selectedValues = getValue(false);
                    },
                    insert (event) {
                        const { index: index, displayValue: displayValue, exportValue: exportValue } = event.detail.insert;
                        const selectChild = selectElement.children[index];
                        const optionElement = document.createElement("option");
                        fixDisplayValue(optionElement, displayValue);
                        optionElement.value = exportValue;
                        if (selectChild) selectChild.before(optionElement);
                        else selectElement.append(optionElement);
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    items (event) {
                        const { items: items } = event.detail;
                        while(selectElement.length !== 0)selectElement.remove(0);
                        for (const item of items){
                            const { displayValue: displayValue, exportValue: exportValue } = item;
                            const optionElement = document.createElement("option");
                            fixDisplayValue(optionElement, displayValue);
                            optionElement.value = exportValue;
                            selectElement.append(optionElement);
                        }
                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    indices (event) {
                        const indices = new Set(event.detail.indices);
                        for (const option of event.target.options)option.selected = indices.has(option.index);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    editable (event) {
                        event.target.disabled = !event.detail.editable;
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            selectElement.addEventListener("input", (event)=>{
                const exportValue = getValue(true);
                const change = getValue(false);
                storage.setValue(id, {
                    value: exportValue
                });
                event.preventDefault();
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: id,
                        name: "Keystroke",
                        value: selectedValues,
                        change: change,
                        changeEx: exportValue,
                        willCommit: false,
                        commitKey: 1,
                        keyDown: false
                    }
                });
            });
            this._setEventListeners(selectElement, null, [
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ],
                [
                    "input",
                    "Action"
                ],
                [
                    "input",
                    "Validate"
                ]
            ], (event)=>event.target.value);
        } else selectElement.addEventListener("input", function(event) {
            storage.setValue(id, {
                value: getValue(true)
            });
        });
        if (this.data.combo) this._setTextStyle(selectElement);
        this._setBackgroundColor(selectElement);
        this._setDefaultPropertiesFromJS(selectElement);
        this.container.append(selectElement);
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$PopupAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters){
        const { data: data, elements: elements, parent: parent } = parameters;
        const hasCommentManager = !!parent._commentManager;
        super(parameters, {
            isRenderable: !hasCommentManager && $a2cc6e1d6eb3861b$var$AnnotationElement._hasPopupData(data)
        });
        this.elements = elements;
        if (hasCommentManager && $a2cc6e1d6eb3861b$var$AnnotationElement._hasPopupData(data)) {
            const popup = this.popup = this.#createPopup();
            for (const element of elements)element.popup = popup;
        } else this.popup = null;
    }
    #createPopup() {
        return new $a2cc6e1d6eb3861b$var$PopupElement({
            container: this.container,
            color: this.data.color,
            titleObj: this.data.titleObj,
            modificationDate: this.data.modificationDate || this.data.creationDate,
            contentsObj: this.data.contentsObj,
            richText: this.data.richText,
            rect: this.data.rect,
            parentRect: this.data.parentRect || null,
            parent: this.parent,
            elements: this.elements,
            open: this.data.open,
            commentManager: this.parent._commentManager
        });
    }
    render() {
        const { container: container } = this;
        container.classList.add("popupAnnotation");
        container.role = "comment";
        const popup = this.popup = this.#createPopup();
        const elementIds = [];
        for (const element of this.elements){
            element.popup = popup;
            element.container.ariaHasPopup = "dialog";
            elementIds.push(element.data.id);
            element.addHighlightArea();
        }
        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${$a2cc6e1d6eb3861b$var$AnnotationPrefix}${id}`).join(","));
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$PopupElement {
    #commentManager = null;
    #boundKeyDown = this.#keyDown.bind(this);
    #boundHide = this.#hide.bind(this);
    #boundShow = this.#show.bind(this);
    #boundToggle = this.#toggle.bind(this);
    #color = null;
    #container = null;
    #contentsObj = null;
    #dateObj = null;
    #elements = null;
    #parent = null;
    #parentRect = null;
    #pinned = false;
    #popup = null;
    #popupAbortController = null;
    #position = null;
    #commentButton = null;
    #commentButtonPosition = null;
    #popupPosition = null;
    #rect = null;
    #richText = null;
    #titleObj = null;
    #updates = null;
    #wasVisible = false;
    #firstElement = null;
    #commentText = null;
    constructor({ container: container, color: color, elements: elements, titleObj: titleObj, modificationDate: modificationDate, contentsObj: contentsObj, richText: richText, parent: parent, rect: rect, parentRect: parentRect, open: open, commentManager: commentManager = null }){
        this.#container = container;
        this.#titleObj = titleObj;
        this.#contentsObj = contentsObj;
        this.#richText = richText;
        this.#parent = parent;
        this.#color = color;
        this.#rect = rect;
        this.#parentRect = parentRect;
        this.#elements = elements;
        this.#commentManager = commentManager;
        this.#firstElement = elements[0];
        this.#dateObj = $a2cc6e1d6eb3861b$export$66cbc314498fffc.toDateObject(modificationDate);
        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
        if (!commentManager) {
            this.#addEventListeners();
            this.#container.hidden = true;
            if (open) this.#toggle();
        }
    }
    #addEventListeners() {
        if (this.#popupAbortController) return;
        this.#popupAbortController = new AbortController();
        const { signal: signal } = this.#popupAbortController;
        for (const element of this.trigger){
            element.addEventListener("click", this.#boundToggle, {
                signal: signal
            });
            element.addEventListener("pointerenter", this.#boundShow, {
                signal: signal
            });
            element.addEventListener("pointerleave", this.#boundHide, {
                signal: signal
            });
            element.classList.add("popupTriggerArea");
        }
        for (const element of this.#elements)element.container?.addEventListener("keydown", this.#boundKeyDown, {
            signal: signal
        });
    }
    #setCommentButtonPosition() {
        const element = this.#elements.find((e)=>e.hasCommentButton);
        if (!element) return;
        this.#commentButtonPosition = element._normalizePoint(element.commentButtonPosition);
    }
    renderCommentButton() {
        if (this.#commentButton) {
            if (!this.#commentButton.parentNode) this.#firstElement.container.after(this.#commentButton);
            return;
        }
        if (!this.#commentButtonPosition) this.#setCommentButtonPosition();
        if (!this.#commentButtonPosition) return;
        const { signal: signal } = this.#popupAbortController = new AbortController();
        const hasOwnButton = this.#firstElement.hasOwnCommentButton;
        const togglePopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, true, undefined, !hasOwnButton);
        };
        const showPopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, false, true, !hasOwnButton);
        };
        const hidePopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, false, false);
        };
        if (!hasOwnButton) {
            const button = this.#commentButton = document.createElement("button");
            button.className = "annotationCommentButton";
            const parentContainer = this.#firstElement.container;
            button.style.zIndex = parseInt(parentContainer.style.zIndex, 10) + 1;
            button.tabIndex = 0;
            button.ariaHasPopup = "dialog";
            button.ariaControls = "commentPopup";
            button.setAttribute("data-l10n-id", "pdfjs-show-comment-button");
            this.#updateColor();
            this.#updateCommentButtonPosition();
            button.addEventListener("keydown", this.#boundKeyDown, {
                signal: signal
            });
            button.addEventListener("click", togglePopup, {
                signal: signal
            });
            button.addEventListener("pointerenter", showPopup, {
                signal: signal
            });
            button.addEventListener("pointerleave", hidePopup, {
                signal: signal
            });
            parentContainer.after(button);
        } else {
            this.#commentButton = this.#firstElement.container;
            for (const element of this.trigger){
                element.ariaHasPopup = "dialog";
                element.ariaControls = "commentPopup";
                element.addEventListener("keydown", this.#boundKeyDown, {
                    signal: signal
                });
                element.addEventListener("click", togglePopup, {
                    signal: signal
                });
                element.addEventListener("pointerenter", showPopup, {
                    signal: signal
                });
                element.addEventListener("pointerleave", hidePopup, {
                    signal: signal
                });
                element.classList.add("popupTriggerArea");
            }
        }
    }
    #updateCommentButtonPosition() {
        if (this.#firstElement.extraPopupElement && !this.#firstElement.editor) return;
        if (!this.#commentButton) this.renderCommentButton();
        const [x, y] = this.#commentButtonPosition;
        const { style: style } = this.#commentButton;
        style.left = `calc(${x}%)`;
        style.top = `calc(${y}% - var(--comment-button-dim))`;
    }
    #updateColor() {
        if (this.#firstElement.extraPopupElement) return;
        if (!this.#commentButton) this.renderCommentButton();
        this.#commentButton.style.backgroundColor = this.commentButtonColor || "";
    }
    get commentButtonColor() {
        const { color: color, opacity: opacity } = this.#firstElement.commentData;
        if (!color) return null;
        return this.#parent._commentManager.makeCommentColor(color, opacity);
    }
    focusCommentButton() {
        setTimeout(()=>{
            this.#commentButton?.focus();
        }, 0);
    }
    getData() {
        const { richText: richText, color: color, opacity: opacity, creationDate: creationDate, modificationDate: modificationDate } = this.#firstElement.commentData;
        return {
            contentsObj: {
                str: this.comment
            },
            richText: richText,
            color: color,
            opacity: opacity,
            creationDate: creationDate,
            modificationDate: modificationDate
        };
    }
    get elementBeforePopup() {
        return this.#commentButton;
    }
    get comment() {
        this.#commentText ||= this.#firstElement.commentText;
        return this.#commentText;
    }
    set comment(text) {
        if (text === this.comment) return;
        this.#firstElement.commentText = this.#commentText = text;
    }
    focus() {
        this.#firstElement.container?.focus();
    }
    get parentBoundingClientRect() {
        return this.#firstElement.layer.getBoundingClientRect();
    }
    setCommentButtonStates({ selected: selected, hasPopup: hasPopup }) {
        if (!this.#commentButton) return;
        this.#commentButton.classList.toggle("selected", selected);
        this.#commentButton.ariaExpanded = hasPopup;
    }
    setSelectedCommentButton(selected) {
        this.#commentButton.classList.toggle("selected", selected);
    }
    get commentPopupPosition() {
        if (this.#popupPosition) return this.#popupPosition;
        const { x: x, y: y, height: height } = this.#commentButton.getBoundingClientRect();
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = this.#firstElement.layer.getBoundingClientRect();
        return [
            (x - parentX) / parentWidth,
            (y + height - parentY) / parentHeight
        ];
    }
    set commentPopupPosition(pos) {
        this.#popupPosition = pos;
    }
    hasDefaultPopupPosition() {
        return this.#popupPosition === null;
    }
    get commentButtonPosition() {
        return this.#commentButtonPosition;
    }
    get commentButtonWidth() {
        return this.#commentButton.getBoundingClientRect().width / this.parentBoundingClientRect.width;
    }
    editComment(options) {
        const [posX, posY] = this.#popupPosition || this.commentButtonPosition.map((x)=>x / 100);
        const parentDimensions = this.parentBoundingClientRect;
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = parentDimensions;
        this.#commentManager.showDialog(null, this, parentX + posX * parentWidth, parentY + posY * parentHeight, {
            ...options,
            parentDimensions: parentDimensions
        });
    }
    render() {
        if (this.#popup) return;
        const popup = this.#popup = document.createElement("div");
        popup.className = "popup";
        if (this.#color) {
            const baseColor = popup.style.outlineColor = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(...this.#color);
            popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
        }
        const header = document.createElement("span");
        header.className = "header";
        if (this.#titleObj?.str) {
            const title = document.createElement("span");
            title.className = "title";
            header.append(title);
            ({ dir: title.dir, str: title.textContent } = this.#titleObj);
        }
        popup.append(header);
        if (this.#dateObj) {
            const modificationDate = document.createElement("time");
            modificationDate.className = "popupDate";
            modificationDate.setAttribute("data-l10n-id", "pdfjs-annotation-date-time-string");
            modificationDate.setAttribute("data-l10n-args", JSON.stringify({
                dateObj: this.#dateObj.valueOf()
            }));
            modificationDate.dateTime = this.#dateObj.toISOString();
            header.append(modificationDate);
        }
        $a2cc6e1d6eb3861b$export$611c480766035c4({
            html: this.#html || this.#contentsObj.str,
            dir: this.#contentsObj?.dir,
            className: "popupContent"
        }, popup);
        this.#container.append(popup);
    }
    get #html() {
        const richText = this.#richText;
        const contentsObj = this.#contentsObj;
        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) return this.#richText.html || null;
        return null;
    }
    get #fontSize() {
        return this.#html?.attributes?.style?.fontSize || 0;
    }
    get #fontColor() {
        return this.#html?.attributes?.style?.color || null;
    }
    #makePopupContent(text) {
        const popupLines = [];
        const popupContent = {
            str: text,
            html: {
                name: "div",
                attributes: {
                    dir: "auto"
                },
                children: [
                    {
                        name: "p",
                        children: popupLines
                    }
                ]
            }
        };
        const lineAttributes = {
            style: {
                color: this.#fontColor,
                fontSize: this.#fontSize ? `calc(${this.#fontSize}px * var(--total-scale-factor))` : ""
            }
        };
        for (const line of text.split("\n"))popupLines.push({
            name: "span",
            value: line,
            attributes: lineAttributes
        });
        return popupContent;
    }
    #keyDown(event) {
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
    }
    updateEdited({ rect: rect, popup: popup, deleted: deleted }) {
        if (this.#commentManager) {
            if (deleted) {
                this.remove();
                this.#commentText = null;
            } else if (popup) {
                if (popup.deleted) this.remove();
                else {
                    this.#updateColor();
                    this.#commentText = popup.text;
                }
            }
            if (rect) {
                this.#commentButtonPosition = null;
                this.#setCommentButtonPosition();
                this.#updateCommentButtonPosition();
            }
            return;
        }
        if (deleted || popup?.deleted) {
            this.remove();
            return;
        }
        this.#addEventListeners();
        this.#updates ||= {
            contentsObj: this.#contentsObj,
            richText: this.#richText
        };
        if (rect) this.#position = null;
        if (popup && popup.text) {
            this.#richText = this.#makePopupContent(popup.text);
            this.#dateObj = $a2cc6e1d6eb3861b$export$66cbc314498fffc.toDateObject(popup.date);
            this.#contentsObj = null;
        }
        this.#popup?.remove();
        this.#popup = null;
    }
    resetEdited() {
        if (!this.#updates) return;
        ({ contentsObj: this.#contentsObj, richText: this.#richText } = this.#updates);
        this.#updates = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#position = null;
    }
    remove() {
        this.#popupAbortController?.abort();
        this.#popupAbortController = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#wasVisible = false;
        this.#pinned = false;
        this.#commentButton?.remove();
        this.#commentButton = null;
        if (this.trigger) for (const element of this.trigger)element.classList.remove("popupTriggerArea");
    }
    #setPosition() {
        if (this.#position !== null) return;
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.#parent;
        let useParentRect = !!this.#parentRect;
        let rect = useParentRect ? this.#parentRect : this.#rect;
        for (const element of this.#elements)if (!rect || $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.intersect(element.data.rect, rect) !== null) {
            rect = element.data.rect;
            useParentRect = true;
            break;
        }
        const normalizedRect = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.normalizeRect([
            rect[0],
            view[3] - rect[1] + view[1],
            rect[2],
            view[3] - rect[3] + view[1]
        ]);
        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
        const popupLeft = normalizedRect[0] + parentWidth;
        const popupTop = normalizedRect[1];
        this.#position = [
            100 * (popupLeft - pageX) / pageWidth,
            100 * (popupTop - pageY) / pageHeight
        ];
        const { style: style } = this.#container;
        style.left = `${this.#position[0]}%`;
        style.top = `${this.#position[1]}%`;
    }
    #toggle() {
        if (this.#commentManager) {
            this.#commentManager.toggleCommentPopup(this, false);
            return;
        }
        this.#pinned = !this.#pinned;
        if (this.#pinned) {
            this.#show();
            this.#container.addEventListener("click", this.#boundToggle);
            this.#container.addEventListener("keydown", this.#boundKeyDown);
        } else {
            this.#hide();
            this.#container.removeEventListener("click", this.#boundToggle);
            this.#container.removeEventListener("keydown", this.#boundKeyDown);
        }
    }
    #show() {
        if (!this.#popup) this.render();
        if (!this.isVisible) {
            this.#setPosition();
            this.#container.hidden = false;
            this.#container.style.zIndex = parseInt(this.#container.style.zIndex, 10) + 1000;
        } else if (this.#pinned) this.#container.classList.add("focused");
    }
    #hide() {
        this.#container.classList.remove("focused");
        if (this.#pinned || !this.isVisible) return;
        this.#container.hidden = true;
        this.#container.style.zIndex = parseInt(this.#container.style.zIndex, 10) - 1000;
    }
    forceHide() {
        this.#wasVisible = this.isVisible;
        if (!this.#wasVisible) return;
        this.#container.hidden = true;
    }
    maybeShow() {
        if (this.#commentManager) return;
        this.#addEventListeners();
        if (!this.#wasVisible) return;
        if (!this.#popup) this.#show();
        this.#wasVisible = false;
        this.#container.hidden = false;
    }
    get isVisible() {
        if (this.#commentManager) return false;
        return this.#container.hidden === false;
    }
}
class $a2cc6e1d6eb3861b$var$FreeTextAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.textContent = parameters.data.textContent;
        this.textPosition = parameters.data.textPosition;
        this.annotationEditorType = $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.FREETEXT;
    }
    render() {
        this.container.classList.add("freeTextAnnotation");
        if (this.textContent) {
            const content = this.contentElement = document.createElement("div");
            content.classList.add("annotationTextContent");
            content.setAttribute("role", "comment");
            for (const line of this.textContent){
                const lineSpan = document.createElement("span");
                lineSpan.textContent = line;
                content.append(lineSpan);
            }
            this.container.append(content);
        }
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this._editOnDoubleClick();
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$LineAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    #line = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("lineAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const line = this.#line = this.svgFactory.createElement("svg:line");
        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
        line.setAttribute("stroke-width", data.borderStyle.width || 1);
        line.setAttribute("stroke", "transparent");
        line.setAttribute("fill", "transparent");
        svg.append(line);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#line;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $a2cc6e1d6eb3861b$var$SquareAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    #square = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("squareAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const square = this.#square = this.svgFactory.createElement("svg:rect");
        square.setAttribute("x", borderWidth / 2);
        square.setAttribute("y", borderWidth / 2);
        square.setAttribute("width", width - borderWidth);
        square.setAttribute("height", height - borderWidth);
        square.setAttribute("stroke-width", borderWidth || 1);
        square.setAttribute("stroke", "transparent");
        square.setAttribute("fill", "transparent");
        svg.append(square);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#square;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $a2cc6e1d6eb3861b$var$CircleAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    #circle = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("circleAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
        circle.setAttribute("cx", width / 2);
        circle.setAttribute("cy", height / 2);
        circle.setAttribute("rx", width / 2 - borderWidth / 2);
        circle.setAttribute("ry", height / 2 - borderWidth / 2);
        circle.setAttribute("stroke-width", borderWidth || 1);
        circle.setAttribute("stroke", "transparent");
        circle.setAttribute("fill", "transparent");
        svg.append(circle);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#circle;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $a2cc6e1d6eb3861b$var$PolylineAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    #polyline = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "polylineAnnotation";
        this.svgElementName = "svg:polyline";
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, vertices: vertices, borderStyle: borderStyle, popupRef: popupRef }, width: width, height: height } = this;
        if (!vertices) return this.container;
        const svg = this.svgFactory.create(width, height, true);
        let points = [];
        for(let i = 0, ii = vertices.length; i < ii; i += 2){
            const x = vertices[i] - rect[0];
            const y = rect[3] - vertices[i + 1];
            points.push(`${x},${y}`);
        }
        points = points.join(" ");
        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
        polyline.setAttribute("points", points);
        polyline.setAttribute("stroke-width", borderStyle.width || 1);
        polyline.setAttribute("stroke", "transparent");
        polyline.setAttribute("fill", "transparent");
        svg.append(polyline);
        this.container.append(svg);
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#polyline;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $a2cc6e1d6eb3861b$var$PolygonAnnotationElement extends $a2cc6e1d6eb3861b$var$PolylineAnnotationElement {
    constructor(parameters){
        super(parameters);
        this.containerClassName = "polygonAnnotation";
        this.svgElementName = "svg:polygon";
    }
}
class $a2cc6e1d6eb3861b$var$CaretAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("caretAnnotation");
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$InkAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    #polylinesGroupElement = null;
    #polylines = [];
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "inkAnnotation";
        this.svgElementName = "svg:polyline";
        this.annotationEditorType = this.data.it === "InkHighlight" ? $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT : $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.INK;
    }
    #getTransform(rotation, rect) {
        switch(rotation){
            case 90:
                return {
                    transform: `rotate(90) translate(${-rect[0]},${rect[1]}) scale(1,-1)`,
                    width: rect[3] - rect[1],
                    height: rect[2] - rect[0]
                };
            case 180:
                return {
                    transform: `rotate(180) translate(${-rect[2]},${rect[1]}) scale(1,-1)`,
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
            case 270:
                return {
                    transform: `rotate(270) translate(${-rect[2]},${rect[3]}) scale(1,-1)`,
                    width: rect[3] - rect[1],
                    height: rect[2] - rect[0]
                };
            default:
                return {
                    transform: `translate(${-rect[0]},${rect[3]}) scale(1,-1)`,
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
        }
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, rotation: rotation, inkLists: inkLists, borderStyle: borderStyle, popupRef: popupRef } } = this;
        const { transform: transform, width: width, height: height } = this.#getTransform(rotation, rect);
        const svg = this.svgFactory.create(width, height, true);
        const g = this.#polylinesGroupElement = this.svgFactory.createElement("svg:g");
        svg.append(g);
        g.setAttribute("stroke-width", borderStyle.width || 1);
        g.setAttribute("stroke-linecap", "round");
        g.setAttribute("stroke-linejoin", "round");
        g.setAttribute("stroke-miterlimit", 10);
        g.setAttribute("stroke", "transparent");
        g.setAttribute("fill", "transparent");
        g.setAttribute("transform", transform);
        for(let i = 0, ii = inkLists.length; i < ii; i++){
            const polyline = this.svgFactory.createElement(this.svgElementName);
            this.#polylines.push(polyline);
            polyline.setAttribute("points", inkLists[i].join(","));
            g.append(polyline);
        }
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.append(svg);
        this._editOnDoubleClick();
        return this.container;
    }
    updateEdited(params) {
        super.updateEdited(params);
        const { thickness: thickness, points: points, rect: rect } = params;
        const g = this.#polylinesGroupElement;
        if (thickness >= 0) g.setAttribute("stroke-width", thickness || 1);
        if (points) for(let i = 0, ii = this.#polylines.length; i < ii; i++)this.#polylines[i].setAttribute("points", points[i].join(","));
        if (rect) {
            const { transform: transform, width: width, height: height } = this.#getTransform(this.data.rotation, rect);
            const root = g.parentElement;
            root.setAttribute("viewBox", `0 0 ${width} ${height}`);
            g.setAttribute("transform", transform);
        }
    }
    getElementsToTriggerPopup() {
        return this.#polylines;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $a2cc6e1d6eb3861b$var$HighlightAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
        this.annotationEditorType = $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT;
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("highlightAnnotation");
        this._editOnDoubleClick();
        if (overlaidText) {
            const mark = document.createElement("mark");
            mark.classList.add("overlaidText");
            mark.textContent = overlaidText;
            this.container.append(mark);
        }
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$UnderlineAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("underlineAnnotation");
        if (overlaidText) {
            const underline = document.createElement("u");
            underline.classList.add("overlaidText");
            underline.textContent = overlaidText;
            this.container.append(underline);
        }
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$SquigglyAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("squigglyAnnotation");
        if (overlaidText) {
            const underline = document.createElement("u");
            underline.classList.add("overlaidText");
            underline.textContent = overlaidText;
            this.container.append(underline);
        }
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$StrikeOutAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("strikeoutAnnotation");
        if (overlaidText) {
            const strikeout = document.createElement("s");
            strikeout.classList.add("overlaidText");
            strikeout.textContent = overlaidText;
            this.container.append(strikeout);
        }
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$StampAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.annotationEditorType = $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.STAMP;
    }
    render() {
        this.container.classList.add("stampAnnotation");
        this.container.setAttribute("role", "img");
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this._editOnDoubleClick();
        return this.container;
    }
}
class $a2cc6e1d6eb3861b$var$FileAttachmentAnnotationElement extends $a2cc6e1d6eb3861b$var$AnnotationElement {
    #trigger = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
        const { file: file } = this.data;
        this.filename = file.filename;
        this.content = file.content;
        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
            source: this,
            ...file
        });
    }
    render() {
        this.container.classList.add("fileAttachmentAnnotation");
        const { container: container, data: data } = this;
        let trigger;
        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
        else {
            trigger = document.createElement("img");
            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
        }
        trigger.addEventListener("dblclick", this.#download.bind(this));
        this.#trigger = trigger;
        const { isMac: isMac } = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform;
        container.addEventListener("keydown", (evt)=>{
            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
        });
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        } else trigger.classList.add("popupTriggerArea");
        container.append(trigger);
        return container;
    }
    getElementsToTriggerPopup() {
        return this.#trigger;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
    #download() {
        this.downloadManager?.openOrDownloadData(this.content, this.filename);
    }
}
class $a2cc6e1d6eb3861b$export$3e7f45c326d9366c {
    #accessibilityManager = null;
    #annotationCanvasMap = null;
    #annotationStorage = null;
    #editableAnnotations = new Map();
    #structTreeLayer = null;
    #linkService = null;
    #elements = [];
    #hasAriaAttributesFromStructTree = false;
    zIndex = 0;
    constructor({ div: div, accessibilityManager: accessibilityManager, annotationCanvasMap: annotationCanvasMap, annotationEditorUIManager: annotationEditorUIManager, page: page, viewport: viewport, structTreeLayer: structTreeLayer, commentManager: commentManager, linkService: linkService, annotationStorage: annotationStorage }){
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationCanvasMap = annotationCanvasMap;
        this.#structTreeLayer = structTreeLayer || null;
        this.#linkService = linkService || null;
        this.#annotationStorage = annotationStorage || new $a2cc6e1d6eb3861b$var$AnnotationStorage();
        this.page = page;
        this.viewport = viewport;
        this._annotationEditorUIManager = annotationEditorUIManager;
        this._commentManager = commentManager || null;
    }
    hasEditableAnnotations() {
        return this.#editableAnnotations.size > 0;
    }
    async render(params) {
        const { annotations: annotations, optionalContentConfig: optionalContentConfig } = params;
        const layer = this.div;
        $a2cc6e1d6eb3861b$export$af0a15a86e590226(layer, this.viewport);
        const popupToElements = new Map();
        const popupAnnotations = [];
        const elementParams = {
            data: null,
            layer: layer,
            linkService: this.#linkService,
            downloadManager: params.downloadManager,
            imageResourcesPath: params.imageResourcesPath || "",
            renderForms: params.renderForms !== false,
            svgFactory: new $a2cc6e1d6eb3861b$export$425e69f00724e63a(),
            annotationStorage: this.#annotationStorage,
            enableComment: params.enableComment === true,
            enableScripting: params.enableScripting === true,
            hasJSActions: params.hasJSActions,
            fieldObjects: params.fieldObjects,
            parent: this,
            elements: null
        };
        for (const data of annotations){
            if (data.noHTML) continue;
            const isPopupAnnotation = data.annotationType === $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c.POPUP;
            if (!isPopupAnnotation) {
                if (data.rect[2] === data.rect[0] || data.rect[3] === data.rect[1]) continue;
            } else {
                const elements = popupToElements.get(data.id);
                if (!elements) continue;
                if (!this._commentManager) {
                    popupAnnotations.push(data);
                    continue;
                }
                elementParams.elements = elements;
            }
            elementParams.data = data;
            const element = $a2cc6e1d6eb3861b$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            if (!isPopupAnnotation) {
                this.#elements.push(element);
                if (data.popupRef) popupToElements.getOrInsertComputed(data.popupRef, $a2cc6e1d6eb3861b$export$be9af9a47496243a).push(element);
            }
            const rendered = element.render();
            if (data.hidden) rendered.style.visibility = "hidden";
            element.updateOC(optionalContentConfig);
            if (element._isEditable) {
                this.#editableAnnotations.set(element.data.id, element);
                this._annotationEditorUIManager?.renderAnnotationElement(element);
            }
        }
        await this.#addElementsToDOM();
        for (const data of popupAnnotations){
            const elements = elementParams.elements = popupToElements.get(data.id);
            elementParams.data = data;
            const element = $a2cc6e1d6eb3861b$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            const rendered = element.render();
            element.contentElement.id = `${$a2cc6e1d6eb3861b$var$AnnotationPrefix}${data.id}`;
            if (data.hidden) rendered.style.visibility = "hidden";
            elements.at(-1).container.after(rendered);
        }
        this.#setAnnotationCanvasMap();
    }
    async #addElementsToDOM() {
        if (this.#elements.length === 0) return;
        this.div.replaceChildren();
        const promises = [];
        if (!this.#hasAriaAttributesFromStructTree) {
            this.#hasAriaAttributesFromStructTree = true;
            for (const { contentElement: contentElement, data: { id: id } } of this.#elements){
                const annotationId = contentElement.id = `${$a2cc6e1d6eb3861b$var$AnnotationPrefix}${id}`;
                promises.push(this.#structTreeLayer?.getAriaAttributes(annotationId).then((ariaAttributes)=>{
                    if (ariaAttributes) for (const [key, value] of ariaAttributes)contentElement.setAttribute(key, value);
                }));
            }
        }
        this.#elements.sort(({ data: { rect: [a0, a1, a2, a3] } }, { data: { rect: [b0, b1, b2, b3] } })=>{
            if (a0 === a2 && a1 === a3) return 1;
            if (b0 === b2 && b1 === b3) return -1;
            const top1 = a3;
            const bot1 = a1;
            const mid1 = (a1 + a3) / 2;
            const top2 = b3;
            const bot2 = b1;
            const mid2 = (b1 + b3) / 2;
            if (mid1 >= top2 && mid2 <= bot1) return -1;
            if (mid2 >= top1 && mid1 <= bot2) return 1;
            const centerX1 = (a0 + a2) / 2;
            const centerX2 = (b0 + b2) / 2;
            return centerX1 - centerX2;
        });
        const fragment = document.createDocumentFragment();
        for (const element of this.#elements){
            fragment.append(element.container);
            if (this._commentManager) (element.extraPopupElement?.popup || element.popup)?.renderCommentButton();
            else if (element.extraPopupElement) fragment.append(element.extraPopupElement.render());
        }
        this.div.append(fragment);
        await Promise.all(promises);
        if (this.#accessibilityManager) for (const element of this.#elements)this.#accessibilityManager.addPointerInTextLayer(element.contentElement, false);
    }
    async addLinkAnnotations(annotations) {
        const elementParams = {
            data: null,
            layer: this.div,
            linkService: this.#linkService,
            svgFactory: new $a2cc6e1d6eb3861b$export$425e69f00724e63a(),
            parent: this
        };
        for (const data of annotations){
            data.borderStyle ||= $a2cc6e1d6eb3861b$export$3e7f45c326d9366c._defaultBorderStyle;
            elementParams.data = data;
            const element = $a2cc6e1d6eb3861b$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            element.render();
            element.contentElement.id = `${$a2cc6e1d6eb3861b$var$AnnotationPrefix}${data.id}`;
            this.#elements.push(element);
        }
        await this.#addElementsToDOM();
    }
    update({ viewport: viewport, optionalContentConfig: optionalContentConfig }) {
        const layer = this.div;
        this.viewport = viewport;
        $a2cc6e1d6eb3861b$export$af0a15a86e590226(layer, {
            rotation: viewport.rotation
        });
        for (const element of this.#elements)element.updateOC(optionalContentConfig);
        this.#setAnnotationCanvasMap();
        layer.hidden = false;
    }
    #setAnnotationCanvasMap() {
        if (!this.#annotationCanvasMap) return;
        const layer = this.div;
        for (const [id, canvas] of this.#annotationCanvasMap){
            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
            if (!element) continue;
            canvas.className = "annotationContent";
            const { firstChild: firstChild } = element;
            if (!firstChild) element.append(canvas);
            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
            else if (!firstChild.classList.contains("annotationContent")) firstChild.before(canvas);
            else firstChild.after(canvas);
            const editableAnnotation = this.#editableAnnotations.get(id);
            if (!editableAnnotation) continue;
            if (editableAnnotation._hasNoCanvas) {
                this._annotationEditorUIManager?.setMissingCanvas(id, element.id, canvas);
                editableAnnotation._hasNoCanvas = false;
            } else editableAnnotation.canvas = canvas;
        }
        this.#annotationCanvasMap.clear();
    }
    getEditableAnnotations() {
        return this.#editableAnnotations.values();
    }
    getEditableAnnotation(id) {
        return this.#editableAnnotations.get(id);
    }
    addFakeAnnotation(editor) {
        const { div: div } = this;
        const { id: id, rotation: rotation } = editor;
        const element = new $a2cc6e1d6eb3861b$var$EditorAnnotationElement({
            data: {
                id: id,
                rect: editor.getPDFRect(),
                rotation: rotation
            },
            editor: editor,
            layer: div,
            parent: this,
            enableComment: !!this._commentManager,
            linkService: this.#linkService,
            annotationStorage: this.#annotationStorage
        });
        element.render();
        element.contentElement.id = `${$a2cc6e1d6eb3861b$var$AnnotationPrefix}${id}`;
        element.createOrUpdatePopup();
        this.#elements.push(element);
        return element;
    }
    removeAnnotation(id) {
        const index = this.#elements.findIndex((el)=>el.data.id === id);
        if (index < 0) return;
        const [element] = this.#elements.splice(index, 1);
        this.#accessibilityManager?.removePointerInTextLayer(element.contentElement);
    }
    updateFakeAnnotations(editors) {
        if (editors.length === 0) return;
        for (const editor of editors)editor.updateFakeAnnotationElement(this);
        this.#addElementsToDOM();
    }
    togglePointerEvents(enabled = false) {
        this.div.classList.toggle("disabled", !enabled);
    }
    static get _defaultBorderStyle() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_defaultBorderStyle", Object.freeze({
            width: 1,
            rawWidth: 1,
            style: $a2cc6e1d6eb3861b$var$AnnotationBorderStyleType.SOLID,
            dashArray: [
                3
            ],
            horizontalCornerRadius: 0,
            verticalCornerRadius: 0
        }));
    }
}
const $a2cc6e1d6eb3861b$var$EOL_PATTERN = /\r\n?|\n/g;
class $a2cc6e1d6eb3861b$var$FreeTextEditor extends $a2cc6e1d6eb3861b$var$AnnotationEditor {
    #content = "";
    #editorDivId = `${this.id}-editor`;
    #editModeAC = null;
    #fontSize;
    _colorPicker = null;
    static _freeTextDefaultContent = "";
    static _internalPadding = 0;
    static _defaultColor = null;
    static _defaultFontSize = 10;
    static get _keyboardManager() {
        const proto = $a2cc6e1d6eb3861b$var$FreeTextEditor.prototype;
        const arrowChecker = (self)=>self.isEmpty();
        const small = $a2cc6e1d6eb3861b$export$26cb16552a82cf63.TRANSLATE_SMALL;
        const big = $a2cc6e1d6eb3861b$export$26cb16552a82cf63.TRANSLATE_BIG;
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_keyboardManager", new $a2cc6e1d6eb3861b$var$KeyboardManager([
            [
                [
                    "ctrl+s",
                    "mac+meta+s",
                    "ctrl+p",
                    "mac+meta+p"
                ],
                proto.commitOrRemove,
                {
                    bubbles: true
                }
            ],
            [
                [
                    "ctrl+Enter",
                    "mac+meta+Enter",
                    "Escape",
                    "mac+Escape"
                ],
                proto.commitOrRemove
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    static _type = "freetext";
    static _editorType = $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.FREETEXT;
    constructor(params){
        super({
            ...params,
            name: "freeTextEditor"
        });
        this.color = params.color || $a2cc6e1d6eb3861b$var$FreeTextEditor._defaultColor || $a2cc6e1d6eb3861b$var$AnnotationEditor._defaultLineColor;
        this.#fontSize = params.fontSize || $a2cc6e1d6eb3861b$var$FreeTextEditor._defaultFontSize;
        if (!this.annotationElementId) this._uiManager.a11yAlert($a2cc6e1d6eb3861b$var$AnnotationEditor._l10nAlert.freetext);
        this.canAddComment = false;
    }
    static initialize(l10n, uiManager) {
        $a2cc6e1d6eb3861b$var$AnnotationEditor.initialize(l10n, uiManager);
        const style = getComputedStyle(document.documentElement);
        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_SIZE:
                $a2cc6e1d6eb3861b$var$FreeTextEditor._defaultFontSize = value;
                break;
            case $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_COLOR:
                $a2cc6e1d6eb3861b$var$FreeTextEditor._defaultColor = value;
                break;
        }
    }
    updateParams(type, value) {
        switch(type){
            case $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_SIZE:
                this.#updateFontSize(value);
                break;
            case $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_COLOR:
                this.#updateColor(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_SIZE,
                $a2cc6e1d6eb3861b$var$FreeTextEditor._defaultFontSize
            ],
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_COLOR,
                $a2cc6e1d6eb3861b$var$FreeTextEditor._defaultColor || $a2cc6e1d6eb3861b$var$AnnotationEditor._defaultLineColor
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_SIZE,
                this.#fontSize
            ],
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_COLOR,
                this.color
            ]
        ];
    }
    get toolbarButtons() {
        this._colorPicker ||= new $a2cc6e1d6eb3861b$var$BasicColorPicker(this);
        return [
            [
                "colorPicker",
                this._colorPicker
            ]
        ];
    }
    get colorType() {
        return $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_COLOR;
    }
    #updateFontSize(fontSize) {
        const setFontsize = (size)=>{
            this.editorDiv.style.fontSize = `calc(${size}px * var(--total-scale-factor))`;
            this.translate(0, -(size - this.#fontSize) * this.parentScale);
            this.#fontSize = size;
            this.#setEditorDimensions();
        };
        const savedFontsize = this.#fontSize;
        this.addCommands({
            cmd: setFontsize.bind(this, fontSize),
            undo: setFontsize.bind(this, savedFontsize),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_SIZE,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    onUpdatedColor() {
        this.editorDiv.style.color = this.color;
        this._colorPicker?.update(this.color);
        super.onUpdatedColor();
    }
    #updateColor(color) {
        const setColor = (col)=>{
            this.color = col;
            this.onUpdatedColor();
        };
        const savedColor = this.color;
        this.addCommands({
            cmd: setColor.bind(this, color),
            undo: setColor.bind(this, savedColor),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.FREETEXT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _translateEmpty(x, y) {
        this._uiManager.translateSelectedEditors(x, y, true);
    }
    getInitialTranslation() {
        const scale = this.parentScale;
        return [
            -$a2cc6e1d6eb3861b$var$FreeTextEditor._internalPadding * scale,
            -($a2cc6e1d6eb3861b$var$FreeTextEditor._internalPadding + this.#fontSize) * scale
        ];
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    enableEditMode() {
        if (!super.enableEditMode()) return false;
        this.overlayDiv.classList.remove("enabled");
        this.editorDiv.contentEditable = true;
        this._isDraggable = false;
        this.div.removeAttribute("aria-activedescendant");
        this.#editModeAC = new AbortController();
        const signal = this._uiManager.combinedSignal(this.#editModeAC);
        this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
            signal: signal
        });
        return true;
    }
    disableEditMode() {
        if (!super.disableEditMode()) return false;
        this.overlayDiv.classList.add("enabled");
        this.editorDiv.contentEditable = false;
        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
        this._isDraggable = true;
        this.#editModeAC?.abort();
        this.#editModeAC = null;
        this.div.focus({
            preventScroll: true
        });
        this.isEditing = false;
        this.parent.div.classList.add("freetextEditing");
        return true;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        super.focusin(event);
        if (event.target !== this.editorDiv) this.editorDiv.focus();
    }
    onceAdded(focus) {
        if (this.width) return;
        this.enableEditMode();
        if (focus) this.editorDiv.focus();
        if (this._initialOptions?.isCentered) this.center();
        this._initialOptions = null;
    }
    isEmpty() {
        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
    }
    remove() {
        this.isEditing = false;
        if (this.parent) {
            this.parent.setEditingState(true);
            this.parent.div.classList.add("freetextEditing");
        }
        super.remove();
    }
    #extractText() {
        const buffer = [];
        this.editorDiv.normalize();
        let prevChild = null;
        for (const child of this.editorDiv.childNodes){
            if (prevChild?.nodeType === Node.TEXT_NODE && child.nodeName === "BR") continue;
            buffer.push($a2cc6e1d6eb3861b$var$FreeTextEditor.#getNodeContent(child));
            prevChild = child;
        }
        return buffer.join("\n");
    }
    #setEditorDimensions() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        let rect;
        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
        else {
            const { currentLayer: currentLayer, div: div } = this;
            const savedDisplay = div.style.display;
            const savedVisibility = div.classList.contains("hidden");
            div.classList.remove("hidden");
            div.style.display = "hidden";
            currentLayer.div.append(this.div);
            rect = div.getBoundingClientRect();
            div.remove();
            div.style.display = savedDisplay;
            div.classList.toggle("hidden", savedVisibility);
        }
        if (this.rotation % 180 === this.parentRotation % 180) {
            this.width = rect.width / parentWidth;
            this.height = rect.height / parentHeight;
        } else {
            this.width = rect.height / parentWidth;
            this.height = rect.width / parentHeight;
        }
        this.fixAndSetPosition();
    }
    commit() {
        if (!this.isInEditMode()) return;
        super.commit();
        this.disableEditMode();
        const savedText = this.#content;
        const newText = this.#content = this.#extractText().trimEnd();
        if (savedText === newText) return;
        const setText = (text)=>{
            this.#content = text;
            if (!text) {
                this.remove();
                return;
            }
            this.#setContent();
            this._uiManager.rebuild(this);
            this.#setEditorDimensions();
        };
        this.addCommands({
            cmd: ()=>{
                setText(newText);
            },
            undo: ()=>{
                setText(savedText);
            },
            mustExec: false
        });
        this.#setEditorDimensions();
    }
    shouldGetKeyboardEvents() {
        return this.isInEditMode();
    }
    enterInEditMode() {
        this.enableEditMode();
        this.editorDiv.focus();
    }
    keydown(event) {
        if (event.target === this.div && event.key === "Enter") {
            this.enterInEditMode();
            event.preventDefault();
        }
    }
    editorDivKeydown(event) {
        $a2cc6e1d6eb3861b$var$FreeTextEditor._keyboardManager.exec(this, event);
    }
    editorDivFocus(event) {
        this.isEditing = true;
    }
    editorDivBlur(event) {
        this.isEditing = false;
    }
    editorDivInput(event) {
        this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
    }
    disableEditing() {
        this.editorDiv.setAttribute("role", "comment");
        this.editorDiv.removeAttribute("aria-multiline");
    }
    enableEditing() {
        this.editorDiv.setAttribute("role", "textbox");
        this.editorDiv.setAttribute("aria-multiline", true);
    }
    get canChangeContent() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy || this.annotationElementId) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.editorDiv = document.createElement("div");
        this.editorDiv.className = "internal";
        this.editorDiv.setAttribute("id", this.#editorDivId);
        this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text2");
        this.editorDiv.setAttribute("data-l10n-attrs", "default-content");
        this.enableEditing();
        this.editorDiv.contentEditable = true;
        const { style: style } = this.editorDiv;
        style.fontSize = `calc(${this.#fontSize}px * var(--total-scale-factor))`;
        style.color = this.color;
        this.div.append(this.editorDiv);
        this.overlayDiv = document.createElement("div");
        this.overlayDiv.classList.add("overlay", "enabled");
        this.div.append(this.overlayDiv);
        if (this._isCopy || this.annotationElementId) {
            const [parentWidth, parentHeight] = this.parentDimensions;
            if (this.annotationElementId) {
                const { position: position } = this._initialData;
                let [tx, ty] = this.getInitialTranslation();
                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                const [pageWidth, pageHeight] = this.pageDimensions;
                const [pageX, pageY] = this.pageTranslation;
                let posX, posY;
                switch(this.rotation){
                    case 0:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                        break;
                    case 90:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            ty,
                            -tx
                        ];
                        break;
                    case 180:
                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            -tx,
                            -ty
                        ];
                        break;
                    case 270:
                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                        [tx, ty] = [
                            -ty,
                            tx
                        ];
                        break;
                }
                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
            } else this._moveAfterPaste(baseX, baseY);
            this.#setContent();
            this._isDraggable = true;
            this.editorDiv.contentEditable = false;
        } else {
            this._isDraggable = false;
            this.editorDiv.contentEditable = true;
        }
        return this.div;
    }
    static #getNodeContent(node) {
        return (node.nodeType === Node.TEXT_NODE ? node.nodeValue : node.innerText).replaceAll($a2cc6e1d6eb3861b$var$EOL_PATTERN, "");
    }
    editorDivPaste(event) {
        const clipboardData = event.clipboardData || window.clipboardData;
        const { types: types } = clipboardData;
        if (types.length === 1 && types[0] === "text/plain") return;
        event.preventDefault();
        const paste = $a2cc6e1d6eb3861b$var$FreeTextEditor.#deserializeContent(clipboardData.getData("text") || "").replaceAll($a2cc6e1d6eb3861b$var$EOL_PATTERN, "\n");
        if (!paste) return;
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        this.editorDiv.normalize();
        selection.deleteFromDocument();
        const range = selection.getRangeAt(0);
        if (!paste.includes("\n")) {
            range.insertNode(document.createTextNode(paste));
            this.editorDiv.normalize();
            selection.collapseToStart();
            return;
        }
        const { startContainer: startContainer, startOffset: startOffset } = range;
        const bufferBefore = [];
        const bufferAfter = [];
        if (startContainer.nodeType === Node.TEXT_NODE) {
            const parent = startContainer.parentElement;
            bufferAfter.push(startContainer.nodeValue.slice(startOffset).replaceAll($a2cc6e1d6eb3861b$var$EOL_PATTERN, ""));
            if (parent !== this.editorDiv) {
                let buffer = bufferBefore;
                for (const child of this.editorDiv.childNodes){
                    if (child === parent) {
                        buffer = bufferAfter;
                        continue;
                    }
                    buffer.push($a2cc6e1d6eb3861b$var$FreeTextEditor.#getNodeContent(child));
                }
            }
            bufferBefore.push(startContainer.nodeValue.slice(0, startOffset).replaceAll($a2cc6e1d6eb3861b$var$EOL_PATTERN, ""));
        } else if (startContainer === this.editorDiv) {
            let buffer = bufferBefore;
            let i = 0;
            for (const child of this.editorDiv.childNodes){
                if (i++ === startOffset) buffer = bufferAfter;
                buffer.push($a2cc6e1d6eb3861b$var$FreeTextEditor.#getNodeContent(child));
            }
        }
        this.#content = `${bufferBefore.join("\n")}${paste}${bufferAfter.join("\n")}`;
        this.#setContent();
        const newRange = new Range();
        let beforeLength = Math.sumPrecise(bufferBefore.map((line)=>line.length));
        for (const { firstChild: firstChild } of this.editorDiv.childNodes)if (firstChild.nodeType === Node.TEXT_NODE) {
            const length = firstChild.nodeValue.length;
            if (beforeLength <= length) {
                newRange.setStart(firstChild, beforeLength);
                newRange.setEnd(firstChild, beforeLength);
                break;
            }
            beforeLength -= length;
        }
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
    #setContent() {
        this.editorDiv.replaceChildren();
        if (!this.#content) return;
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            this.editorDiv.append(div);
        }
    }
    #serializeContent() {
        return this.#content.replaceAll("\xa0", " ");
    }
    static #deserializeContent(content) {
        return content.replaceAll(" ", "\xa0");
    }
    get contentDiv() {
        return this.editorDiv;
    }
    getPDFRect() {
        const padding = $a2cc6e1d6eb3861b$var$FreeTextEditor._internalPadding * this.parentScale;
        return this.getRect(padding, padding);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $a2cc6e1d6eb3861b$var$FreeTextAnnotationElement) {
            const { data: { defaultAppearanceData: { fontSize: fontSize, fontColor: fontColor }, rect: rect, rotation: rotation, id: id, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, textContent: textContent, textPosition: textPosition, parent: { page: { pageNumber: pageNumber } } } = data;
            if (!textContent || textContent.length === 0) return null;
            initialData = data = {
                annotationType: $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.FREETEXT,
                color: Array.from(fontColor),
                fontSize: fontSize,
                value: textContent.join("\n"),
                position: textPosition,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                comment: contentsObj?.str || null,
                richText: richText,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        editor.#fontSize = data.fontSize;
        editor.color = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(...data.color);
        editor.#content = $a2cc6e1d6eb3861b$var$FreeTextEditor.#deserializeContent(data.value);
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const color = $a2cc6e1d6eb3861b$var$AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.color);
        const serialized = Object.assign(super.serialize(isForCopying), {
            color: color,
            fontSize: this.#fontSize,
            value: this.#serializeContent()
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { value: value, fontSize: fontSize, color: color, pageIndex: pageIndex } = this._initialData;
        return this.hasEditedComment || this._hasBeenMoved || serialized.value !== value || serialized.fontSize !== fontSize || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        const content = super.renderAnnotationElement(annotation);
        if (!content) return null;
        const { style: style } = content;
        style.fontSize = `calc(${this.#fontSize}px * var(--total-scale-factor))`;
        style.color = this.color;
        content.replaceChildren();
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            content.append(div);
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this._uiManager.hasCommentManager() || this.hasEditedComment ? this.comment : {
                text: this.#content
            }
        });
        return content;
    }
    resetAnnotationElement(annotation) {
        super.resetAnnotationElement(annotation);
        annotation.resetEdited();
    }
}
class $a2cc6e1d6eb3861b$var$Outline {
    static PRECISION = 1e-4;
    toSVGPath() {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `toSVGPath` must be implemented.");
    }
    get box() {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract getter `box` must be implemented.");
    }
    serialize(_bbox, _rotation) {
        $a2cc6e1d6eb3861b$var$unreachable("Abstract method `serialize` must be implemented.");
    }
    static _rescale(src, tx, ty, sx, sy, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i] * sx;
            dest[i + 1] = ty + src[i + 1] * sy;
        }
        return dest;
    }
    static _rescaleAndSwap(src, tx, ty, sx, sy, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i + 1] * sx;
            dest[i + 1] = ty + src[i] * sy;
        }
        return dest;
    }
    static _translate(src, tx, ty, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i];
            dest[i + 1] = ty + src[i + 1];
        }
        return dest;
    }
    static svgRound(x) {
        return Math.round(x * 10000);
    }
    static _normalizePoint(x, y, parentWidth, parentHeight, rotation) {
        switch(rotation){
            case 90:
                return [
                    1 - y / parentWidth,
                    x / parentHeight
                ];
            case 180:
                return [
                    1 - x / parentWidth,
                    1 - y / parentHeight
                ];
            case 270:
                return [
                    y / parentWidth,
                    1 - x / parentHeight
                ];
            default:
                return [
                    x / parentWidth,
                    y / parentHeight
                ];
        }
    }
    static createBezierPoints(x1, y1, x2, y2, x3, y3) {
        return [
            (x1 + 5 * x2) / 6,
            (y1 + 5 * y2) / 6,
            (5 * x2 + x3) / 6,
            (5 * y2 + y3) / 6,
            (x2 + x3) / 2,
            (y2 + y3) / 2
        ];
    }
}
class $a2cc6e1d6eb3861b$var$FreeDrawOutliner {
    #box;
    #bottom = [];
    #innerMargin;
    #isLTR;
    #top = [];
    #last = new Float32Array(18);
    #lastX;
    #lastY;
    #min;
    #min_dist;
    #scaleFactor;
    #thickness;
    #points = [];
    static #MIN_DIST = 8;
    static #MIN_DIFF = 2;
    static #MIN = $a2cc6e1d6eb3861b$var$FreeDrawOutliner.#MIN_DIST + $a2cc6e1d6eb3861b$var$FreeDrawOutliner.#MIN_DIFF;
    constructor({ x: x, y: y }, box, scaleFactor, thickness, isLTR, innerMargin = 0){
        this.#box = box;
        this.#thickness = thickness * scaleFactor;
        this.#isLTR = isLTR;
        this.#last.set([
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ], 6);
        this.#innerMargin = innerMargin;
        this.#min_dist = $a2cc6e1d6eb3861b$var$FreeDrawOutliner.#MIN_DIST * scaleFactor;
        this.#min = $a2cc6e1d6eb3861b$var$FreeDrawOutliner.#MIN * scaleFactor;
        this.#scaleFactor = scaleFactor;
        this.#points.push(x, y);
    }
    isEmpty() {
        return isNaN(this.#last[8]);
    }
    #getLastCoords() {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [x, y, width, height] = this.#box;
        return [
            (this.#lastX + (lastTop[0] - lastBottom[0]) / 2 - x) / width,
            (this.#lastY + (lastTop[1] - lastBottom[1]) / 2 - y) / height,
            (this.#lastX + (lastBottom[0] - lastTop[0]) / 2 - x) / width,
            (this.#lastY + (lastBottom[1] - lastTop[1]) / 2 - y) / height
        ];
    }
    add({ x: x, y: y }) {
        this.#lastX = x;
        this.#lastY = y;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        let [x1, y1, x2, y2] = this.#last.subarray(8, 12);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(diffX, diffY);
        if (d < this.#min) return false;
        const diffD = d - this.#min_dist;
        const K = diffD / d;
        const shiftX = K * diffX;
        const shiftY = K * diffY;
        let x0 = x1;
        let y0 = y1;
        x1 = x2;
        y1 = y2;
        x2 += shiftX;
        y2 += shiftY;
        this.#points?.push(x, y);
        const nX = -shiftY / diffD;
        const nY = shiftX / diffD;
        const thX = nX * this.#thickness;
        const thY = nY * this.#thickness;
        this.#last.set(this.#last.subarray(2, 8), 0);
        this.#last.set([
            x2 + thX,
            y2 + thY
        ], 4);
        this.#last.set(this.#last.subarray(14, 18), 12);
        this.#last.set([
            x2 - thX,
            y2 - thY
        ], 16);
        if (isNaN(this.#last[6])) {
            if (this.#top.length === 0) {
                this.#last.set([
                    x1 + thX,
                    y1 + thY
                ], 2);
                this.#top.push(NaN, NaN, NaN, NaN, (x1 + thX - layerX) / layerWidth, (y1 + thY - layerY) / layerHeight);
                this.#last.set([
                    x1 - thX,
                    y1 - thY
                ], 14);
                this.#bottom.push(NaN, NaN, NaN, NaN, (x1 - thX - layerX) / layerWidth, (y1 - thY - layerY) / layerHeight);
            }
            this.#last.set([
                x0,
                y0,
                x1,
                y1,
                x2,
                y2
            ], 6);
            return !this.isEmpty();
        }
        this.#last.set([
            x0,
            y0,
            x1,
            y1,
            x2,
            y2
        ], 6);
        const angle = Math.abs(Math.atan2(y0 - y1, x0 - x1) - Math.atan2(shiftY, shiftX));
        if (angle < Math.PI / 2) {
            [x1, y1, x2, y2] = this.#last.subarray(2, 6);
            this.#top.push(NaN, NaN, NaN, NaN, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
            [x1, y1, x0, y0] = this.#last.subarray(14, 18);
            this.#bottom.push(NaN, NaN, NaN, NaN, ((x0 + x1) / 2 - layerX) / layerWidth, ((y0 + y1) / 2 - layerY) / layerHeight);
            return true;
        }
        [x0, y0, x1, y1, x2, y2] = this.#last.subarray(0, 6);
        this.#top.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        [x2, y2, x1, y1, x0, y0] = this.#last.subarray(12, 18);
        this.#bottom.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        return true;
    }
    toSVGPath() {
        if (this.isEmpty()) return "";
        const top = this.#top;
        const bottom = this.#bottom;
        if (isNaN(this.#last[6]) && !this.isEmpty()) return this.#toSVGPathTwoPoints();
        const buffer = [];
        buffer.push(`M${top[4]} ${top[5]}`);
        for(let i = 6; i < top.length; i += 6)if (isNaN(top[i])) buffer.push(`L${top[i + 4]} ${top[i + 5]}`);
        else buffer.push(`C${top[i]} ${top[i + 1]} ${top[i + 2]} ${top[i + 3]} ${top[i + 4]} ${top[i + 5]}`);
        this.#toSVGPathEnd(buffer);
        for(let i = bottom.length - 6; i >= 6; i -= 6)if (isNaN(bottom[i])) buffer.push(`L${bottom[i + 4]} ${bottom[i + 5]}`);
        else buffer.push(`C${bottom[i]} ${bottom[i + 1]} ${bottom[i + 2]} ${bottom[i + 3]} ${bottom[i + 4]} ${bottom[i + 5]}`);
        this.#toSVGPathStart(buffer);
        return buffer.join(" ");
    }
    #toSVGPathTwoPoints() {
        const [x, y, width, height] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        return `M${(this.#last[2] - x) / width} ${(this.#last[3] - y) / height} L${(this.#last[4] - x) / width} ${(this.#last[5] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(this.#last[16] - x) / width} ${(this.#last[17] - y) / height} L${(this.#last[14] - x) / width} ${(this.#last[15] - y) / height} Z`;
    }
    #toSVGPathStart(buffer) {
        const bottom = this.#bottom;
        buffer.push(`L${bottom[4]} ${bottom[5]} Z`);
    }
    #toSVGPathEnd(buffer) {
        const [x, y, width, height] = this.#box;
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        buffer.push(`L${(lastTop[0] - x) / width} ${(lastTop[1] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(lastBottom[0] - x) / width} ${(lastBottom[1] - y) / height}`);
    }
    newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new $a2cc6e1d6eb3861b$var$FreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
    getOutlines() {
        const top = this.#top;
        const bottom = this.#bottom;
        const last = this.#last;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const points = new Float32Array((this.#points?.length ?? 0) + 2);
        for(let i = 0, ii = points.length - 2; i < ii; i += 2){
            points[i] = (this.#points[i] - layerX) / layerWidth;
            points[i + 1] = (this.#points[i + 1] - layerY) / layerHeight;
        }
        points[points.length - 2] = (this.#lastX - layerX) / layerWidth;
        points[points.length - 1] = (this.#lastY - layerY) / layerHeight;
        if (isNaN(last[6]) && !this.isEmpty()) return this.#getOutlineTwoPoints(points);
        const outline = new Float32Array(this.#top.length + 24 + this.#bottom.length);
        let N = top.length;
        for(let i = 0; i < N; i += 2){
            if (isNaN(top[i])) {
                outline[i] = outline[i + 1] = NaN;
                continue;
            }
            outline[i] = top[i];
            outline[i + 1] = top[i + 1];
        }
        N = this.#getOutlineEnd(outline, N);
        for(let i = bottom.length - 6; i >= 6; i -= 6)for(let j = 0; j < 6; j += 2){
            if (isNaN(bottom[i + j])) {
                outline[N] = outline[N + 1] = NaN;
                N += 2;
                continue;
            }
            outline[N] = bottom[i + j];
            outline[N + 1] = bottom[i + j + 1];
            N += 2;
        }
        this.#getOutlineStart(outline, N);
        return this.newFreeDrawOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
    #getOutlineTwoPoints(points) {
        const last = this.#last;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        const outline = new Float32Array(36);
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (last[2] - layerX) / layerWidth,
            (last[3] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[4] - layerX) / layerWidth,
            (last[5] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[16] - layerX) / layerWidth,
            (last[17] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[14] - layerX) / layerWidth,
            (last[15] - layerY) / layerHeight
        ], 0);
        return this.newFreeDrawOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
    #getOutlineStart(outline, pos) {
        const bottom = this.#bottom;
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            bottom[4],
            bottom[5]
        ], pos);
        return pos += 6;
    }
    #getOutlineEnd(outline, pos) {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (lastTop[0] - layerX) / layerWidth,
            (lastTop[1] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (lastBottom[0] - layerX) / layerWidth,
            (lastBottom[1] - layerY) / layerHeight
        ], pos);
        return pos += 24;
    }
}
class $a2cc6e1d6eb3861b$var$FreeDrawOutline extends $a2cc6e1d6eb3861b$var$Outline {
    #box;
    #bbox = new Float32Array(4);
    #innerMargin;
    #isLTR;
    #points;
    #scaleFactor;
    #outline;
    constructor(outline, points, box, scaleFactor, innerMargin, isLTR){
        super();
        this.#outline = outline;
        this.#points = points;
        this.#box = box;
        this.#scaleFactor = scaleFactor;
        this.#innerMargin = innerMargin;
        this.#isLTR = isLTR;
        this.firstPoint = [
            NaN,
            NaN
        ];
        this.lastPoint = [
            NaN,
            NaN
        ];
        this.#computeMinMax(isLTR);
        const [x, y, width, height] = this.#bbox;
        for(let i = 0, ii = outline.length; i < ii; i += 2){
            outline[i] = (outline[i] - x) / width;
            outline[i + 1] = (outline[i + 1] - y) / height;
        }
        for(let i = 0, ii = points.length; i < ii; i += 2){
            points[i] = (points[i] - x) / width;
            points[i + 1] = (points[i + 1] - y) / height;
        }
    }
    toSVGPath() {
        const buffer = [
            `M${this.#outline[4]} ${this.#outline[5]}`
        ];
        for(let i = 6, ii = this.#outline.length; i < ii; i += 6){
            if (isNaN(this.#outline[i])) {
                buffer.push(`L${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
                continue;
            }
            buffer.push(`C${this.#outline[i]} ${this.#outline[i + 1]} ${this.#outline[i + 2]} ${this.#outline[i + 3]} ${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
        }
        buffer.push("Z");
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], rotation) {
        const width = trX - blX;
        const height = trY - blY;
        let outline;
        let points;
        switch(rotation){
            case 0:
                outline = $a2cc6e1d6eb3861b$var$Outline._rescale(this.#outline, blX, trY, width, -height);
                points = $a2cc6e1d6eb3861b$var$Outline._rescale(this.#points, blX, trY, width, -height);
                break;
            case 90:
                outline = $a2cc6e1d6eb3861b$var$Outline._rescaleAndSwap(this.#outline, blX, blY, width, height);
                points = $a2cc6e1d6eb3861b$var$Outline._rescaleAndSwap(this.#points, blX, blY, width, height);
                break;
            case 180:
                outline = $a2cc6e1d6eb3861b$var$Outline._rescale(this.#outline, trX, blY, -width, height);
                points = $a2cc6e1d6eb3861b$var$Outline._rescale(this.#points, trX, blY, -width, height);
                break;
            case 270:
                outline = $a2cc6e1d6eb3861b$var$Outline._rescaleAndSwap(this.#outline, trX, trY, -width, -height);
                points = $a2cc6e1d6eb3861b$var$Outline._rescaleAndSwap(this.#points, trX, trY, -width, -height);
                break;
        }
        return {
            outline: Array.from(outline),
            points: [
                Array.from(points)
            ]
        };
    }
    #computeMinMax(isLTR) {
        const outline = this.#outline;
        let lastX = outline[4];
        let lastY = outline[5];
        const minMax = [
            lastX,
            lastY,
            lastX,
            lastY
        ];
        let firstPointX = lastX;
        let firstPointY = lastY;
        let lastPointX = lastX;
        let lastPointY = lastY;
        const ltrCallback = isLTR ? Math.max : Math.min;
        const bezierBbox = new Float32Array(4);
        for(let i = 6, ii = outline.length; i < ii; i += 6){
            const x = outline[i + 4], y = outline[i + 5];
            if (isNaN(outline[i])) {
                $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.pointBoundingBox(x, y, minMax);
                if (firstPointY > y) {
                    firstPointX = x;
                    firstPointY = y;
                } else if (firstPointY === y) firstPointX = ltrCallback(firstPointX, x);
                if (lastPointY < y) {
                    lastPointX = x;
                    lastPointY = y;
                } else if (lastPointY === y) lastPointX = ltrCallback(lastPointX, x);
            } else {
                bezierBbox.set($a2cc6e1d6eb3861b$var$BBOX_INIT, 0);
                $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.bezierBoundingBox(lastX, lastY, ...outline.slice(i, i + 6), bezierBbox);
                $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.rectBoundingBox(...bezierBbox, minMax);
                if (firstPointY > bezierBbox[1]) {
                    firstPointX = bezierBbox[0];
                    firstPointY = bezierBbox[1];
                } else if (firstPointY === bezierBbox[1]) firstPointX = ltrCallback(firstPointX, bezierBbox[0]);
                if (lastPointY < bezierBbox[3]) {
                    lastPointX = bezierBbox[2];
                    lastPointY = bezierBbox[3];
                } else if (lastPointY === bezierBbox[3]) lastPointX = ltrCallback(lastPointX, bezierBbox[2]);
            }
            lastX = x;
            lastY = y;
        }
        const bbox = this.#bbox;
        bbox[0] = minMax[0] - this.#innerMargin;
        bbox[1] = minMax[1] - this.#innerMargin;
        bbox[2] = minMax[2] - minMax[0] + 2 * this.#innerMargin;
        bbox[3] = minMax[3] - minMax[1] + 2 * this.#innerMargin;
        this.firstPoint = [
            firstPointX,
            firstPointY
        ];
        this.lastPoint = [
            lastPointX,
            lastPointY
        ];
    }
    get box() {
        return this.#bbox;
    }
    newOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
        return new $a2cc6e1d6eb3861b$var$FreeDrawOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
    getNewOutline(thickness, innerMargin) {
        const [x, y, width, height] = this.#bbox;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const sx = width * layerWidth;
        const sy = height * layerHeight;
        const tx = x * layerWidth + layerX;
        const ty = y * layerHeight + layerY;
        const outliner = this.newOutliner({
            x: this.#points[0] * sx + tx,
            y: this.#points[1] * sy + ty
        }, this.#box, this.#scaleFactor, thickness, this.#isLTR, innerMargin ?? this.#innerMargin);
        for(let i = 2; i < this.#points.length; i += 2)outliner.add({
            x: this.#points[i] * sx + tx,
            y: this.#points[i + 1] * sy + ty
        });
        return outliner.getOutlines();
    }
}
class $a2cc6e1d6eb3861b$var$HighlightOutliner {
    #box;
    #firstPoint;
    #lastPoint;
    #verticalEdges = [];
    #intervals = [];
    constructor(boxes, borderWidth = 0, innerMargin = 0, isLTR = true){
        const minMax = $a2cc6e1d6eb3861b$var$BBOX_INIT.slice();
        const NUMBER_OF_DIGITS = 4;
        const EPSILON = 10 ** -NUMBER_OF_DIGITS;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const x1 = Math.floor((x - borderWidth) / EPSILON) * EPSILON;
            const x2 = Math.ceil((x + width + borderWidth) / EPSILON) * EPSILON;
            const y1 = Math.floor((y - borderWidth) / EPSILON) * EPSILON;
            const y2 = Math.ceil((y + height + borderWidth) / EPSILON) * EPSILON;
            const left = [
                x1,
                y1,
                y2,
                true
            ];
            const right = [
                x2,
                y1,
                y2,
                false
            ];
            this.#verticalEdges.push(left, right);
            $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.rectBoundingBox(x1, y1, x2, y2, minMax);
        }
        const bboxWidth = minMax[2] - minMax[0] + 2 * innerMargin;
        const bboxHeight = minMax[3] - minMax[1] + 2 * innerMargin;
        const shiftedMinX = minMax[0] - innerMargin;
        const shiftedMinY = minMax[1] - innerMargin;
        let firstPointX = isLTR ? -Infinity : Infinity;
        let firstPointY = Infinity;
        const lastEdge = this.#verticalEdges.at(isLTR ? -1 : -2);
        const lastPoint = [
            lastEdge[0],
            lastEdge[2]
        ];
        for (const edge of this.#verticalEdges){
            const [x, y1, y2, left] = edge;
            if (!left && isLTR) {
                if (y1 < firstPointY) {
                    firstPointY = y1;
                    firstPointX = x;
                } else if (y1 === firstPointY) firstPointX = Math.max(firstPointX, x);
            } else if (left && !isLTR) {
                if (y1 < firstPointY) {
                    firstPointY = y1;
                    firstPointX = x;
                } else if (y1 === firstPointY) firstPointX = Math.min(firstPointX, x);
            }
            edge[0] = (x - shiftedMinX) / bboxWidth;
            edge[1] = (y1 - shiftedMinY) / bboxHeight;
            edge[2] = (y2 - shiftedMinY) / bboxHeight;
        }
        this.#box = new Float32Array([
            shiftedMinX,
            shiftedMinY,
            bboxWidth,
            bboxHeight
        ]);
        this.#firstPoint = [
            firstPointX,
            firstPointY
        ];
        this.#lastPoint = lastPoint;
    }
    getOutlines() {
        this.#verticalEdges.sort((a, b)=>a[0] - b[0] || a[1] - b[1] || a[2] - b[2]);
        const outlineVerticalEdges = [];
        for (const edge of this.#verticalEdges)if (edge[3]) {
            outlineVerticalEdges.push(...this.#breakEdge(edge));
            this.#insert(edge);
        } else {
            this.#remove(edge);
            outlineVerticalEdges.push(...this.#breakEdge(edge));
        }
        return this.#getOutlines(outlineVerticalEdges);
    }
    #getOutlines(outlineVerticalEdges) {
        const edges = [];
        const allEdges = new Set();
        for (const edge of outlineVerticalEdges){
            const [x, y1, y2] = edge;
            edges.push([
                x,
                y1,
                edge
            ], [
                x,
                y2,
                edge
            ]);
        }
        edges.sort((a, b)=>a[1] - b[1] || a[0] - b[0]);
        for(let i = 0, ii = edges.length; i < ii; i += 2){
            const edge1 = edges[i][2];
            const edge2 = edges[i + 1][2];
            edge1.push(edge2);
            edge2.push(edge1);
            allEdges.add(edge1);
            allEdges.add(edge2);
        }
        const outlines = [];
        let outline;
        while(allEdges.size > 0){
            const edge = allEdges.values().next().value;
            let [x, y1, y2, edge1, edge2] = edge;
            allEdges.delete(edge);
            let lastPointX = x;
            let lastPointY = y1;
            outline = [
                x,
                y2
            ];
            outlines.push(outline);
            while(true){
                let e;
                if (allEdges.has(edge1)) e = edge1;
                else if (allEdges.has(edge2)) e = edge2;
                else break;
                allEdges.delete(e);
                [x, y1, y2, edge1, edge2] = e;
                if (lastPointX !== x) {
                    outline.push(lastPointX, lastPointY, x, lastPointY === y1 ? y1 : y2);
                    lastPointX = x;
                }
                lastPointY = lastPointY === y1 ? y2 : y1;
            }
            outline.push(lastPointX, lastPointY);
        }
        return new $a2cc6e1d6eb3861b$var$HighlightOutline(outlines, this.#box, this.#firstPoint, this.#lastPoint);
    }
    #binarySearch(y) {
        const array = this.#intervals;
        let start = 0;
        let end = array.length - 1;
        while(start <= end){
            const middle = start + end >> 1;
            const y1 = array[middle][0];
            if (y1 === y) return middle;
            if (y1 < y) start = middle + 1;
            else end = middle - 1;
        }
        return end + 1;
    }
    #insert([, y1, y2]) {
        const index = this.#binarySearch(y1);
        this.#intervals.splice(index, 0, [
            y1,
            y2
        ]);
    }
    #remove([, y1, y2]) {
        const index = this.#binarySearch(y1);
        for(let i = index; i < this.#intervals.length; i++){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
        for(let i = index - 1; i >= 0; i--){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
    }
    #breakEdge(edge) {
        const [x, y1, y2] = edge;
        const results = [
            [
                x,
                y1,
                y2
            ]
        ];
        const index = this.#binarySearch(y2);
        for(let i = 0; i < index; i++){
            const [start, end] = this.#intervals[i];
            for(let j = 0, jj = results.length; j < jj; j++){
                const [, y3, y4] = results[j];
                if (end <= y3 || y4 <= start) continue;
                if (y3 >= start) {
                    if (y4 > end) results[j][1] = end;
                    else {
                        if (jj === 1) return [];
                        results.splice(j, 1);
                        j--;
                        jj--;
                    }
                    continue;
                }
                results[j][2] = start;
                if (y4 > end) results.push([
                    x,
                    end,
                    y4
                ]);
            }
        }
        return results;
    }
}
class $a2cc6e1d6eb3861b$var$HighlightOutline extends $a2cc6e1d6eb3861b$var$Outline {
    #box;
    #outlines;
    constructor(outlines, box, firstPoint, lastPoint){
        super();
        this.#outlines = outlines;
        this.#box = box;
        this.firstPoint = firstPoint;
        this.lastPoint = lastPoint;
    }
    toSVGPath() {
        const buffer = [];
        for (const polygon of this.#outlines){
            let [prevX, prevY] = polygon;
            buffer.push(`M${prevX} ${prevY}`);
            for(let i = 2; i < polygon.length; i += 2){
                const x = polygon[i];
                const y = polygon[i + 1];
                if (x === prevX) {
                    buffer.push(`V${y}`);
                    prevY = y;
                } else if (y === prevY) {
                    buffer.push(`H${x}`);
                    prevX = x;
                }
            }
            buffer.push("Z");
        }
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], _rotation) {
        const outlines = [];
        const width = trX - blX;
        const height = trY - blY;
        for (const outline of this.#outlines){
            const points = new Array(outline.length);
            for(let i = 0; i < outline.length; i += 2){
                points[i] = blX + outline[i] * width;
                points[i + 1] = trY - outline[i + 1] * height;
            }
            outlines.push(points);
        }
        return outlines;
    }
    get box() {
        return this.#box;
    }
    get classNamesForOutlining() {
        return [
            "highlightOutline"
        ];
    }
}
class $a2cc6e1d6eb3861b$var$FreeHighlightOutliner extends $a2cc6e1d6eb3861b$var$FreeDrawOutliner {
    newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new $a2cc6e1d6eb3861b$var$FreeHighlightOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
}
class $a2cc6e1d6eb3861b$var$FreeHighlightOutline extends $a2cc6e1d6eb3861b$var$FreeDrawOutline {
    newOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
        return new $a2cc6e1d6eb3861b$var$FreeHighlightOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
}
class $a2cc6e1d6eb3861b$var$HighlightEditor extends $a2cc6e1d6eb3861b$var$AnnotationEditor {
    #anchorNode = null;
    #anchorOffset = 0;
    #boxes;
    #clipPathId = null;
    #colorPicker = null;
    #focusOutlines = null;
    #focusNode = null;
    #focusOffset = 0;
    #highlightDiv = null;
    #highlightOutlines = null;
    #id = null;
    #isFreeHighlight = false;
    #firstPoint = null;
    #lastPoint = null;
    #outlineId = null;
    #text = "";
    #thickness;
    #methodOfCreation = "";
    static _defaultColor = null;
    static _defaultOpacity = 1;
    static _defaultThickness = 12;
    static _type = "highlight";
    static _editorType = $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT;
    static _freeHighlightId = -1;
    static _freeHighlight = null;
    static _freeHighlightClipId = "";
    static get _keyboardManager() {
        const proto = $a2cc6e1d6eb3861b$var$HighlightEditor.prototype;
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_keyboardManager", new $a2cc6e1d6eb3861b$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._moveCaret,
                {
                    args: [
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._moveCaret,
                {
                    args: [
                        1
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._moveCaret,
                {
                    args: [
                        2
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._moveCaret,
                {
                    args: [
                        3
                    ]
                }
            ]
        ]));
    }
    constructor(params){
        super({
            ...params,
            name: "highlightEditor"
        });
        this.color = params.color || $a2cc6e1d6eb3861b$var$HighlightEditor._defaultColor;
        this.#thickness = params.thickness || $a2cc6e1d6eb3861b$var$HighlightEditor._defaultThickness;
        this.opacity = params.opacity || $a2cc6e1d6eb3861b$var$HighlightEditor._defaultOpacity;
        this.#boxes = params.boxes || null;
        this.#methodOfCreation = params.methodOfCreation || "";
        this.#text = params.text || "";
        this._isDraggable = false;
        this.defaultL10nId = "pdfjs-editor-highlight-editor";
        if (params.highlightId > -1) {
            this.#isFreeHighlight = true;
            this.#createFreeOutlines(params);
            this.#addToDrawLayer();
        } else if (this.#boxes) {
            this.#anchorNode = params.anchorNode;
            this.#anchorOffset = params.anchorOffset;
            this.#focusNode = params.focusNode;
            this.#focusOffset = params.focusOffset;
            this.#createOutlines();
            this.#addToDrawLayer();
            this.rotate(this.rotation);
        }
        if (!this.annotationElementId) this._uiManager.a11yAlert($a2cc6e1d6eb3861b$var$AnnotationEditor._l10nAlert.highlight);
    }
    get telemetryInitialData() {
        return {
            action: "added",
            type: this.#isFreeHighlight ? "free_highlight" : "highlight",
            color: this._uiManager.getNonHCMColorName(this.color),
            thickness: this.#thickness,
            methodOfCreation: this.#methodOfCreation
        };
    }
    get telemetryFinalData() {
        return {
            type: "highlight",
            color: this._uiManager.getNonHCMColorName(this.color)
        };
    }
    static computeTelemetryFinalData(data) {
        return {
            numberOfColors: data.get("color").size
        };
    }
    #createOutlines() {
        const outliner = new $a2cc6e1d6eb3861b$var$HighlightOutliner(this.#boxes, 0.001);
        this.#highlightOutlines = outliner.getOutlines();
        [this.x, this.y, this.width, this.height] = this.#highlightOutlines.box;
        const outlinerForOutline = new $a2cc6e1d6eb3861b$var$HighlightOutliner(this.#boxes, 0.0025, 0.001, this._uiManager.direction === "ltr");
        this.#focusOutlines = outlinerForOutline.getOutlines();
        const { firstPoint: firstPoint } = this.#highlightOutlines;
        this.#firstPoint = [
            (firstPoint[0] - this.x) / this.width,
            (firstPoint[1] - this.y) / this.height
        ];
        const { lastPoint: lastPoint } = this.#focusOutlines;
        this.#lastPoint = [
            (lastPoint[0] - this.x) / this.width,
            (lastPoint[1] - this.y) / this.height
        ];
    }
    #createFreeOutlines({ highlightOutlines: highlightOutlines, highlightId: highlightId, clipPathId: clipPathId }) {
        this.#highlightOutlines = highlightOutlines;
        const extraThickness = 1.5;
        this.#focusOutlines = highlightOutlines.getNewOutline(this.#thickness / 2 + extraThickness, 0.0025);
        if (highlightId >= 0) {
            this.#id = highlightId;
            this.#clipPathId = clipPathId;
            this.parent.drawLayer.finalizeDraw(highlightId, {
                bbox: highlightOutlines.box,
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.#outlineId = this.parent.drawLayer.drawOutline({
                rootClass: {
                    highlightOutline: true,
                    free: true
                },
                bbox: this.#focusOutlines.box,
                path: {
                    d: this.#focusOutlines.toSVGPath()
                }
            }, true);
        } else if (this.parent) {
            const angle = this.parent.viewport.rotation;
            this.parent.drawLayer.updateProperties(this.#id, {
                bbox: $a2cc6e1d6eb3861b$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, (angle - this.rotation + 360) % 360),
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.parent.drawLayer.updateProperties(this.#outlineId, {
                bbox: $a2cc6e1d6eb3861b$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle),
                path: {
                    d: this.#focusOutlines.toSVGPath()
                }
            });
        }
        const [x, y, width, height] = highlightOutlines.box;
        switch(this.rotation){
            case 0:
                this.x = x;
                this.y = y;
                this.width = width;
                this.height = height;
                break;
            case 90:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = y;
                    this.y = 1 - x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
            case 180:
                this.x = 1 - x;
                this.y = 1 - y;
                this.width = width;
                this.height = height;
                break;
            case 270:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = 1 - y;
                    this.y = x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
        }
        const { firstPoint: firstPoint } = highlightOutlines;
        this.#firstPoint = [
            (firstPoint[0] - x) / width,
            (firstPoint[1] - y) / height
        ];
        const { lastPoint: lastPoint } = this.#focusOutlines;
        this.#lastPoint = [
            (lastPoint[0] - x) / width,
            (lastPoint[1] - y) / height
        ];
    }
    static initialize(l10n, uiManager) {
        $a2cc6e1d6eb3861b$var$AnnotationEditor.initialize(l10n, uiManager);
        $a2cc6e1d6eb3861b$var$HighlightEditor._defaultColor ||= uiManager.highlightColors?.values().next().value || "#fff066";
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR:
                $a2cc6e1d6eb3861b$var$HighlightEditor._defaultColor = value;
                break;
            case $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS:
                $a2cc6e1d6eb3861b$var$HighlightEditor._defaultThickness = value;
                break;
        }
    }
    translateInPage(x, y) {}
    get toolbarPosition() {
        return this.#lastPoint;
    }
    get commentButtonPosition() {
        return this.#firstPoint;
    }
    updateParams(type, value) {
        switch(type){
            case $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR:
                this.#updateColor(value);
                break;
            case $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS:
                this.#updateThickness(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
                $a2cc6e1d6eb3861b$var$HighlightEditor._defaultColor
            ],
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS,
                $a2cc6e1d6eb3861b$var$HighlightEditor._defaultThickness
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
                this.color || $a2cc6e1d6eb3861b$var$HighlightEditor._defaultColor
            ],
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS,
                this.#thickness || $a2cc6e1d6eb3861b$var$HighlightEditor._defaultThickness
            ],
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_FREE,
                this.#isFreeHighlight
            ]
        ];
    }
    onUpdatedColor() {
        this.parent?.drawLayer.updateProperties(this.#id, {
            root: {
                fill: this.color,
                "fill-opacity": this.opacity
            }
        });
        this.#colorPicker?.updateColor(this.color);
        super.onUpdatedColor();
    }
    #updateColor(color) {
        const setColorAndOpacity = (col, opa)=>{
            this.color = col;
            this.opacity = opa;
            this.onUpdatedColor();
        };
        const savedColor = this.color;
        const savedOpacity = this.opacity;
        this.addCommands({
            cmd: setColorAndOpacity.bind(this, color, $a2cc6e1d6eb3861b$var$HighlightEditor._defaultOpacity),
            undo: setColorAndOpacity.bind(this, savedColor, savedOpacity),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "color_changed",
            color: this._uiManager.getNonHCMColorName(color)
        }, true);
    }
    #updateThickness(thickness) {
        const savedThickness = this.#thickness;
        const setThickness = (th)=>{
            this.#thickness = th;
            this.#changeThickness(th);
        };
        this.addCommands({
            cmd: setThickness.bind(this, thickness),
            undo: setThickness.bind(this, savedThickness),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_THICKNESS,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "thickness_changed",
            thickness: thickness
        }, true);
    }
    get toolbarButtons() {
        if (this._uiManager.highlightColors) {
            const colorPicker = this.#colorPicker = new $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3({
                editor: this
            });
            return [
                [
                    "colorPicker",
                    colorPicker
                ]
            ];
        }
        return super.toolbarButtons;
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    fixAndSetPosition() {
        return super.fixAndSetPosition(this.#getRotation());
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    getRect(tx, ty) {
        return super.getRect(tx, ty, this.#getRotation());
    }
    onceAdded(focus) {
        if (!this.annotationElementId) this.parent.addUndoableEditor(this);
        if (focus) this.div.focus();
    }
    remove() {
        this.#cleanDrawLayer();
        this._reportTelemetry({
            action: "deleted"
        });
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) this.#cleanDrawLayer();
        else if (parent) {
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        this.show(this._isVisible);
        if (mustBeSelected) this.select();
    }
    #changeThickness(thickness) {
        if (!this.#isFreeHighlight) return;
        this.#createFreeOutlines({
            highlightOutlines: this.#highlightOutlines.getNewOutline(thickness / 2)
        });
        this.fixAndSetPosition();
        this.setDims();
    }
    #cleanDrawLayer() {
        if (this.#id === null || !this.parent) return;
        this.parent.drawLayer.remove(this.#id);
        this.#id = null;
        this.parent.drawLayer.remove(this.#outlineId);
        this.#outlineId = null;
    }
    #addToDrawLayer(parent = this.parent) {
        if (this.#id !== null) return;
        ({ id: this.#id, clipPathId: this.#clipPathId } = parent.drawLayer.draw({
            bbox: this.#highlightOutlines.box,
            root: {
                viewBox: "0 0 1 1",
                fill: this.color,
                "fill-opacity": this.opacity
            },
            rootClass: {
                highlight: true,
                free: this.#isFreeHighlight
            },
            path: {
                d: this.#highlightOutlines.toSVGPath()
            }
        }, false, true));
        this.#outlineId = parent.drawLayer.drawOutline({
            rootClass: {
                highlightOutline: true,
                free: this.#isFreeHighlight
            },
            bbox: this.#focusOutlines.box,
            path: {
                d: this.#focusOutlines.toSVGPath()
            }
        }, this.#isFreeHighlight);
        if (this.#highlightDiv) this.#highlightDiv.style.clipPath = this.#clipPathId;
    }
    static #rotateBbox([x, y, width, height], angle) {
        switch(angle){
            case 90:
                return [
                    1 - y - height,
                    x,
                    height,
                    width
                ];
            case 180:
                return [
                    1 - x - width,
                    1 - y - height,
                    width,
                    height
                ];
            case 270:
                return [
                    y,
                    1 - x - width,
                    height,
                    width
                ];
        }
        return [
            x,
            y,
            width,
            height
        ];
    }
    rotate(angle) {
        const { drawLayer: drawLayer } = this.parent;
        let box;
        if (this.#isFreeHighlight) {
            angle = (angle - this.rotation + 360) % 360;
            box = $a2cc6e1d6eb3861b$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, angle);
        } else box = $a2cc6e1d6eb3861b$var$HighlightEditor.#rotateBbox([
            this.x,
            this.y,
            this.width,
            this.height
        ], angle);
        drawLayer.updateProperties(this.#id, {
            bbox: box,
            root: {
                "data-main-rotation": angle
            }
        });
        drawLayer.updateProperties(this.#outlineId, {
            bbox: $a2cc6e1d6eb3861b$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle),
            root: {
                "data-main-rotation": angle
            }
        });
    }
    render() {
        if (this.div) return this.div;
        const div = super.render();
        if (this.#text) {
            div.setAttribute("aria-label", this.#text);
            div.setAttribute("role", "mark");
        }
        if (this.#isFreeHighlight) div.classList.add("free");
        else this.div.addEventListener("keydown", this.#keydown.bind(this), {
            signal: this._uiManager._signal
        });
        const highlightDiv = this.#highlightDiv = document.createElement("div");
        div.append(highlightDiv);
        highlightDiv.setAttribute("aria-hidden", "true");
        highlightDiv.className = "internal";
        highlightDiv.style.clipPath = this.#clipPathId;
        this.setDims();
        $a2cc6e1d6eb3861b$var$bindEvents(this, this.#highlightDiv, [
            "pointerover",
            "pointerleave"
        ]);
        this.enableEditing();
        return div;
    }
    pointerover() {
        if (!this.isSelected) this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: true
            }
        });
    }
    pointerleave() {
        if (!this.isSelected) this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: false
            }
        });
    }
    #keydown(event) {
        $a2cc6e1d6eb3861b$var$HighlightEditor._keyboardManager.exec(this, event);
    }
    _moveCaret(direction) {
        this.parent.unselect(this);
        switch(direction){
            case 0:
            case 2:
                this.#setCaret(true);
                break;
            case 1:
            case 3:
                this.#setCaret(false);
                break;
        }
    }
    #setCaret(start) {
        if (!this.#anchorNode) return;
        const selection = window.getSelection();
        if (start) selection.setPosition(this.#anchorNode, this.#anchorOffset);
        else selection.setPosition(this.#focusNode, this.#focusOffset);
    }
    select() {
        super.select();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: false,
                selected: true
            }
        });
    }
    unselect() {
        super.unselect();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                selected: false
            }
        });
        if (!this.#isFreeHighlight) this.#setCaret(false);
    }
    get _mustFixPosition() {
        return !this.#isFreeHighlight;
    }
    show(visible = this._isVisible) {
        super.show(visible);
        if (this.parent) {
            this.parent.drawLayer.updateProperties(this.#id, {
                rootClass: {
                    hidden: !visible
                }
            });
            this.parent.drawLayer.updateProperties(this.#outlineId, {
                rootClass: {
                    hidden: !visible
                }
            });
        }
    }
    #getRotation() {
        return this.#isFreeHighlight ? this.rotation : 0;
    }
    #serializeBoxes() {
        if (this.#isFreeHighlight) return null;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const boxes = this.#boxes;
        const quadPoints = new Float32Array(boxes.length * 8);
        let i = 0;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const sx = x * pageWidth + pageX;
            const sy = (1 - y) * pageHeight + pageY;
            quadPoints[i] = quadPoints[i + 4] = sx;
            quadPoints[i + 1] = quadPoints[i + 3] = sy;
            quadPoints[i + 2] = quadPoints[i + 6] = sx + width * pageWidth;
            quadPoints[i + 5] = quadPoints[i + 7] = sy - height * pageHeight;
            i += 8;
        }
        return quadPoints;
    }
    #serializeOutlines(rect) {
        return this.#highlightOutlines.serialize(rect, this.#getRotation());
    }
    static startHighlighting(parent, isLTR, { target: textLayer, x: x, y: y }) {
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        const ac = new AbortController();
        const signal = parent.combinedSignal(ac);
        const pointerUpCallback = (e)=>{
            ac.abort();
            this.#endHighlight(parent, e);
        };
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerdown", $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
            signal: signal
        });
        textLayer.addEventListener("pointermove", this.#highlightMove.bind(this, parent), {
            signal: signal
        });
        this._freeHighlight = new $a2cc6e1d6eb3861b$var$FreeHighlightOutliner({
            x: x,
            y: y
        }, [
            layerX,
            layerY,
            parentWidth,
            parentHeight
        ], parent.scale, this._defaultThickness / 2, isLTR, 0.001);
        ({ id: this._freeHighlightId, clipPathId: this._freeHighlightClipId } = parent.drawLayer.draw({
            bbox: [
                0,
                0,
                1,
                1
            ],
            root: {
                viewBox: "0 0 1 1",
                fill: this._defaultColor,
                "fill-opacity": this._defaultOpacity
            },
            rootClass: {
                highlight: true,
                free: true
            },
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        }, true, true));
    }
    static #highlightMove(parent, event) {
        if (this._freeHighlight.add(event)) parent.drawLayer.updateProperties(this._freeHighlightId, {
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        });
    }
    static #endHighlight(parent, event) {
        if (!this._freeHighlight.isEmpty()) parent.createAndAddNewEditor(event, false, {
            highlightId: this._freeHighlightId,
            highlightOutlines: this._freeHighlight.getOutlines(),
            clipPathId: this._freeHighlightClipId,
            methodOfCreation: "main_toolbar"
        });
        else parent.drawLayer.remove(this._freeHighlightId);
        this._freeHighlightId = -1;
        this._freeHighlight = null;
        this._freeHighlightClipId = "";
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $a2cc6e1d6eb3861b$var$HighlightAnnotationElement) {
            const { data: { quadPoints: quadPoints, rect: rect, rotation: rotation, id: id, color: color, opacity: opacity, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT,
                color: Array.from(color),
                opacity: opacity,
                quadPoints: quadPoints,
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        } else if (data instanceof $a2cc6e1d6eb3861b$var$InkAnnotationElement) {
            const { data: { inkLists: inkLists, rect: rect, rotation: rotation, id: id, color: color, borderStyle: { rawWidth: thickness }, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT,
                color: Array.from(color),
                thickness: thickness,
                inkLists: inkLists,
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const { color: color, quadPoints: quadPoints, inkLists: inkLists, outlines: outlines, opacity: opacity } = data;
        const editor = await super.deserialize(data, parent, uiManager);
        editor.color = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(...color);
        editor.opacity = opacity || 1;
        if (inkLists) editor.#thickness = data.thickness;
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [pageX, pageY] = editor.pageTranslation;
        if (quadPoints) {
            const boxes = editor.#boxes = [];
            for(let i = 0; i < quadPoints.length; i += 8)boxes.push({
                x: (quadPoints[i] - pageX) / pageWidth,
                y: 1 - (quadPoints[i + 1] - pageY) / pageHeight,
                width: (quadPoints[i + 2] - quadPoints[i]) / pageWidth,
                height: (quadPoints[i + 1] - quadPoints[i + 5]) / pageHeight
            });
            editor.#createOutlines();
            editor.#addToDrawLayer();
            editor.rotate(editor.rotation);
        } else if (inkLists || outlines) {
            editor.#isFreeHighlight = true;
            const points = (inkLists || outlines.points)[0];
            const point = {
                x: points[0] - pageX,
                y: pageHeight - (points[1] - pageY)
            };
            const outliner = new $a2cc6e1d6eb3861b$var$FreeHighlightOutliner(point, [
                0,
                0,
                pageWidth,
                pageHeight
            ], 1, editor.#thickness / 2, true, 0.001);
            for(let i = 0, ii = points.length; i < ii; i += 2){
                point.x = points[i] - pageX;
                point.y = pageHeight - (points[i + 1] - pageY);
                outliner.add(point);
            }
            const { id: id, clipPathId: clipPathId } = parent.drawLayer.draw({
                bbox: [
                    0,
                    0,
                    1,
                    1
                ],
                root: {
                    viewBox: "0 0 1 1",
                    fill: editor.color,
                    "fill-opacity": editor._defaultOpacity
                },
                rootClass: {
                    highlight: true,
                    free: true
                },
                path: {
                    d: outliner.toSVGPath()
                }
            }, true, true);
            editor.#createFreeOutlines({
                highlightOutlines: outliner.getOutlines(),
                highlightId: id,
                clipPathId: clipPathId
            });
            editor.#addToDrawLayer();
            editor.rotate(editor.parentRotation);
        }
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty() || isForCopying) return null;
        if (this.deleted) return this.serializeDeleted();
        const color = $a2cc6e1d6eb3861b$var$AnnotationEditor._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
        const serialized = super.serialize(isForCopying);
        Object.assign(serialized, {
            color: color,
            opacity: this.opacity,
            thickness: this.#thickness,
            quadPoints: this.#serializeBoxes(),
            outlines: this.#serializeOutlines(serialized.rect)
        });
        this.addComment(serialized);
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { color: color } = this._initialData;
        return this.hasEditedComment || serialized.color.some((c, i)=>c !== color[i]);
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
        return null;
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $a2cc6e1d6eb3861b$var$DrawingOptions {
    #svgProperties = Object.create(null);
    updateProperty(name, value) {
        this[name] = value;
        this.updateSVGProperty(name, value);
    }
    updateProperties(properties) {
        if (!properties) return;
        for (const [name, value] of Object.entries(properties))if (!name.startsWith("_")) this.updateProperty(name, value);
    }
    updateSVGProperty(name, value) {
        this.#svgProperties[name] = value;
    }
    toSVGProperties() {
        const root = this.#svgProperties;
        this.#svgProperties = Object.create(null);
        return {
            root: root
        };
    }
    reset() {
        this.#svgProperties = Object.create(null);
    }
    updateAll(options = this) {
        this.updateProperties(options);
    }
    clone() {
        $a2cc6e1d6eb3861b$var$unreachable("Not implemented");
    }
}
class $a2cc6e1d6eb3861b$var$DrawingEditor extends $a2cc6e1d6eb3861b$var$AnnotationEditor {
    #drawOutlines = null;
    #mustBeCommitted;
    _colorPicker = null;
    _drawId = null;
    static _currentDrawId = -1;
    static _currentParent = null;
    static #currentDraw = null;
    static #currentDrawingAC = null;
    static #currentDrawingOptions = null;
    static _INNER_MARGIN = 3;
    constructor(params){
        super(params);
        this.#mustBeCommitted = params.mustBeCommitted || false;
        this._addOutlines(params);
    }
    onUpdatedColor() {
        this._colorPicker?.update(this.color);
        super.onUpdatedColor();
    }
    onUpdatedOpacity() {
        this._colorPicker?.updateOpacity?.(this.opacity);
    }
    _addOutlines(params) {
        if (params.drawOutlines) {
            this.#createDrawOutlines(params);
            this.#addToDrawLayer();
        }
    }
    #createDrawOutlines({ drawOutlines: drawOutlines, drawId: drawId, drawingOptions: drawingOptions }) {
        this.#drawOutlines = drawOutlines;
        this._drawingOptions ||= drawingOptions;
        if (!this.annotationElementId) this._uiManager.a11yAlert($a2cc6e1d6eb3861b$var$AnnotationEditor._l10nAlert[this.editorType]);
        if (drawId >= 0) {
            this._drawId = drawId;
            this.parent.drawLayer.finalizeDraw(drawId, drawOutlines.defaultProperties);
        } else this._drawId = this.#createDrawing(drawOutlines, this.parent);
        this.#updateBbox(drawOutlines.box);
    }
    #createDrawing(drawOutlines, parent) {
        const { id: id } = parent.drawLayer.draw($a2cc6e1d6eb3861b$var$DrawingEditor._mergeSVGProperties(this._drawingOptions.toSVGProperties(), drawOutlines.defaultSVGProperties), false, false);
        return id;
    }
    static _mergeSVGProperties(p1, p2) {
        const p1Keys = new Set(Object.keys(p1));
        for (const [key, value] of Object.entries(p2))if (p1Keys.has(key)) Object.assign(p1[key], value);
        else p1[key] = value;
        return p1;
    }
    static getDefaultDrawingOptions(_options) {
        $a2cc6e1d6eb3861b$var$unreachable("Not implemented");
    }
    static get typesMap() {
        $a2cc6e1d6eb3861b$var$unreachable("Not implemented");
    }
    static get isDrawer() {
        return true;
    }
    static get supportMultipleDrawings() {
        return false;
    }
    static updateDefaultParams(type, value) {
        const propertyName = this.typesMap.get(type);
        if (propertyName) this._defaultDrawingOptions.updateProperty(propertyName, value);
        if (this._currentParent) {
            $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw.updateProperty(propertyName, value);
            this._currentParent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
        }
    }
    updateParams(type, value) {
        const propertyName = this.constructor.typesMap.get(type);
        if (propertyName) this._updateProperty(type, propertyName, value);
    }
    static get defaultPropertiesToUpdate() {
        const properties = [];
        const options = this._defaultDrawingOptions;
        for (const [type, name] of this.typesMap)properties.push([
            type,
            options[name]
        ]);
        return properties;
    }
    get propertiesToUpdate() {
        const properties = [];
        const { _drawingOptions: _drawingOptions } = this;
        for (const [type, name] of this.constructor.typesMap)properties.push([
            type,
            _drawingOptions[name]
        ]);
        return properties;
    }
    _updateProperty(type, name, value) {
        const options = this._drawingOptions;
        const savedValue = options[name];
        const setter = (val)=>{
            options.updateProperty(name, val);
            const bbox = this.#drawOutlines.updateProperty(name, val);
            if (bbox) this.#updateBbox(bbox);
            this.parent?.drawLayer.updateProperties(this._drawId, options.toSVGProperties());
            if (type === this.colorType) this.onUpdatedColor();
            else if (type === this.opacityType) this.onUpdatedOpacity();
        };
        this.addCommands({
            cmd: setter.bind(this, value),
            undo: setter.bind(this, savedValue),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: type,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _updateColorAndOpacity(color, opacity) {
        const colorName = this.constructor.typesMap.get(this.colorType);
        const opacityName = this.constructor.typesMap.get(this.opacityType);
        const options = this._drawingOptions;
        const savedColor = options[colorName];
        const savedOpacity = options[opacityName];
        const setter = (c, op)=>{
            options.updateProperty(colorName, c);
            options.updateProperty(opacityName, op);
            this.#drawOutlines.updateProperty(colorName, c);
            this.#drawOutlines.updateProperty(opacityName, op);
            this.parent?.drawLayer.updateProperties(this._drawId, options.toSVGProperties());
            this.onUpdatedColor();
            this.onUpdatedOpacity();
        };
        this.addCommands({
            cmd: setter.bind(this, color, opacity),
            undo: setter.bind(this, savedColor, savedOpacity),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_COLOR_AND_OPACITY,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _onResizing() {
        this.parent?.drawLayer.updateProperties(this._drawId, $a2cc6e1d6eb3861b$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathResizingSVGProperties(this.#convertToDrawSpace()), {
            bbox: this.#rotateBox()
        }));
    }
    _onResized() {
        this.parent?.drawLayer.updateProperties(this._drawId, $a2cc6e1d6eb3861b$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathResizedSVGProperties(this.#convertToDrawSpace()), {
            bbox: this.#rotateBox()
        }));
    }
    _onTranslating(_x, _y) {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            bbox: this.#rotateBox()
        });
    }
    _onTranslated() {
        this.parent?.drawLayer.updateProperties(this._drawId, $a2cc6e1d6eb3861b$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathTranslatedSVGProperties(this.#convertToDrawSpace(), this.parentDimensions), {
            bbox: this.#rotateBox()
        }));
    }
    _onStartDragging() {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: true
            }
        });
    }
    _onStopDragging() {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: false
            }
        });
    }
    commit() {
        super.commit();
        this.disableEditMode();
        this.disableEditing();
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    get isResizable() {
        return true;
    }
    onceAdded(focus) {
        if (!this.annotationElementId) this.parent.addUndoableEditor(this);
        this._isDraggable = true;
        if (this.#mustBeCommitted) {
            this.#mustBeCommitted = false;
            this.commit();
            this.parent.setSelected(this);
            if (focus && this.isOnScreen) this.div.focus();
        }
    }
    remove() {
        this.#cleanDrawLayer();
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        this.#updateBbox(this.#drawOutlines.box);
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) {
            this._uiManager.removeShouldRescale(this);
            this.#cleanDrawLayer();
        } else if (parent) {
            this._uiManager.addShouldRescale(this);
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        if (mustBeSelected) this.select();
    }
    #cleanDrawLayer() {
        if (this._drawId === null || !this.parent) return;
        this.parent.drawLayer.remove(this._drawId);
        this._drawId = null;
        this._drawingOptions.reset();
    }
    #addToDrawLayer(parent = this.parent) {
        if (this._drawId !== null && this.parent === parent) return;
        if (this._drawId !== null) {
            this.parent.drawLayer.updateParent(this._drawId, parent.drawLayer);
            return;
        }
        this._drawingOptions.updateAll();
        this._drawId = this.#createDrawing(this.#drawOutlines, parent);
    }
    #convertToParentSpace([x, y, width, height]) {
        const { parentDimensions: [pW, pH], rotation: rotation } = this;
        switch(rotation){
            case 90:
                return [
                    y,
                    1 - x,
                    width * (pH / pW),
                    height * (pW / pH)
                ];
            case 180:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 270:
                return [
                    1 - y,
                    x,
                    width * (pH / pW),
                    height * (pW / pH)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    #convertToDrawSpace() {
        const { x: x, y: y, width: width, height: height, parentDimensions: [pW, pH], rotation: rotation } = this;
        switch(rotation){
            case 90:
                return [
                    1 - y,
                    x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 180:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 270:
                return [
                    y,
                    1 - x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    #updateBbox(bbox) {
        [this.x, this.y, this.width, this.height] = this.#convertToParentSpace(bbox);
        if (this.div) {
            this.fixAndSetPosition();
            this.setDims();
        }
        this._onResized();
    }
    #rotateBox() {
        const { x: x, y: y, width: width, height: height, rotation: rotation, parentRotation: parentRotation, parentDimensions: [pW, pH] } = this;
        switch((rotation * 4 + parentRotation) / 90){
            case 1:
                return [
                    1 - y - height,
                    x,
                    height,
                    width
                ];
            case 2:
                return [
                    1 - x - width,
                    1 - y - height,
                    width,
                    height
                ];
            case 3:
                return [
                    y,
                    1 - x - width,
                    height,
                    width
                ];
            case 4:
                return [
                    x,
                    y - width * (pW / pH),
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 5:
                return [
                    1 - y,
                    x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 6:
                return [
                    1 - x - height * (pH / pW),
                    1 - y,
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 7:
                return [
                    y - width * (pW / pH),
                    1 - x - height * (pH / pW),
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 8:
                return [
                    x - width,
                    y - height,
                    width,
                    height
                ];
            case 9:
                return [
                    1 - y,
                    x - width,
                    height,
                    width
                ];
            case 10:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 11:
                return [
                    y - height,
                    1 - x,
                    height,
                    width
                ];
            case 12:
                return [
                    x - height * (pH / pW),
                    y,
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 13:
                return [
                    1 - y - width * (pW / pH),
                    x - height * (pH / pW),
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 14:
                return [
                    1 - x,
                    1 - y - width * (pW / pH),
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 15:
                return [
                    y,
                    1 - x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    rotate() {
        if (!this.parent) return;
        this.parent.drawLayer.updateProperties(this._drawId, $a2cc6e1d6eb3861b$var$DrawingEditor._mergeSVGProperties({
            bbox: this.#rotateBox()
        }, this.#drawOutlines.updateRotation((this.parentRotation - this.rotation + 360) % 360)));
    }
    onScaleChanging() {
        if (!this.parent) return;
        this.#updateBbox(this.#drawOutlines.updateParentDimensions(this.parentDimensions, this.parent.scale));
    }
    static onScaleChangingWhenDrawing() {}
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        const div = super.render();
        div.classList.add("draw");
        const drawDiv = document.createElement("div");
        div.append(drawDiv);
        drawDiv.setAttribute("aria-hidden", "true");
        drawDiv.className = "internal";
        this.setDims();
        this._uiManager.addShouldRescale(this);
        this.disableEditing();
        if (this._isCopy) this._moveAfterPaste(baseX, baseY);
        return div;
    }
    static createDrawerInstance(_x, _y, _parentWidth, _parentHeight, _rotation) {
        $a2cc6e1d6eb3861b$var$unreachable("Not implemented");
    }
    static startDrawing(parent, uiManager, _isLTR, event) {
        const { target: target, offsetX: x, offsetY: y, pointerId: pointerId, pointerType: pointerType } = event;
        if ($a2cc6e1d6eb3861b$var$CurrentPointers.isInitializedAndDifferentPointerType(pointerType)) return;
        const { viewport: { rotation: rotation } } = parent;
        const { width: parentWidth, height: parentHeight } = target.getBoundingClientRect();
        const ac = $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDrawingAC = new AbortController();
        const signal = parent.combinedSignal(ac);
        $a2cc6e1d6eb3861b$var$CurrentPointers.setPointer(pointerType, pointerId);
        window.addEventListener("pointerup", (e)=>{
            if ($a2cc6e1d6eb3861b$var$CurrentPointers.isSamePointerIdOrRemove(e.pointerId)) this._endDraw(e);
        }, {
            signal: signal
        });
        window.addEventListener("pointercancel", (e)=>{
            if ($a2cc6e1d6eb3861b$var$CurrentPointers.isSamePointerIdOrRemove(e.pointerId)) this._currentParent.endDrawingSession();
        }, {
            signal: signal
        });
        window.addEventListener("pointerdown", (e)=>{
            if (!$a2cc6e1d6eb3861b$var$CurrentPointers.isSamePointerType(e.pointerType)) return;
            $a2cc6e1d6eb3861b$var$CurrentPointers.initializeAndAddPointerId(e.pointerId);
            if ($a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw.isCancellable()) {
                $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw.removeLastElement();
                if ($a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw.isEmpty()) this._currentParent.endDrawingSession(true);
                else this._endDraw(null);
            }
        }, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $a2cc6e1d6eb3861b$export$455b7811f904cadc, {
            signal: signal
        });
        target.addEventListener("pointermove", this._drawMove.bind(this), {
            signal: signal
        });
        target.addEventListener("touchmove", (e)=>{
            if ($a2cc6e1d6eb3861b$var$CurrentPointers.isSameTimeStamp(e.timeStamp)) $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e);
        }, {
            signal: signal
        });
        parent.toggleDrawing();
        uiManager._editorUndoBar?.hide();
        if ($a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw) {
            parent.drawLayer.updateProperties(this._currentDrawId, $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw.startNew(x, y, parentWidth, parentHeight, rotation));
            return;
        }
        uiManager.updateUIForDefaultProperties(this);
        $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw = this.createDrawerInstance(x, y, parentWidth, parentHeight, rotation);
        $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDrawingOptions = this.getDefaultDrawingOptions();
        this._currentParent = parent;
        ({ id: this._currentDrawId } = parent.drawLayer.draw(this._mergeSVGProperties($a2cc6e1d6eb3861b$var$DrawingEditor.#currentDrawingOptions.toSVGProperties(), $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw.defaultSVGProperties), true, false));
    }
    static _drawMove(event) {
        $a2cc6e1d6eb3861b$var$CurrentPointers.isSameTimeStamp(event.timeStamp);
        if (!$a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw) return;
        const { offsetX: offsetX, offsetY: offsetY, pointerId: pointerId } = event;
        if (!$a2cc6e1d6eb3861b$var$CurrentPointers.isSamePointerId(pointerId)) return;
        if ($a2cc6e1d6eb3861b$var$CurrentPointers.isUsingMultiplePointers()) {
            this._endDraw(event);
            return;
        }
        this._currentParent.drawLayer.updateProperties(this._currentDrawId, $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw.add(offsetX, offsetY));
        $a2cc6e1d6eb3861b$var$CurrentPointers.setTimeStamp(event.timeStamp);
        $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(event);
    }
    static _cleanup(all) {
        if (all) {
            this._currentDrawId = -1;
            this._currentParent = null;
            $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw = null;
            $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDrawingOptions = null;
            $a2cc6e1d6eb3861b$var$CurrentPointers.clearTimeStamp();
        }
        if ($a2cc6e1d6eb3861b$var$DrawingEditor.#currentDrawingAC) {
            $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDrawingAC.abort();
            $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDrawingAC = null;
            $a2cc6e1d6eb3861b$var$CurrentPointers.clearPointerIds();
        }
    }
    static _endDraw(event) {
        const parent = this._currentParent;
        if (!parent) return;
        parent.toggleDrawing(true);
        this._cleanup(false);
        if (event?.target === parent.div) parent.drawLayer.updateProperties(this._currentDrawId, $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw.end(event.offsetX, event.offsetY));
        if (this.supportMultipleDrawings) {
            const draw = $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw;
            const drawId = this._currentDrawId;
            const lastElement = draw.getLastElement();
            parent.addCommands({
                cmd: ()=>{
                    parent.drawLayer.updateProperties(drawId, draw.setLastElement(lastElement));
                },
                undo: ()=>{
                    parent.drawLayer.updateProperties(drawId, draw.removeLastElement());
                },
                mustExec: false,
                type: $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.DRAW_STEP
            });
            return;
        }
        this.endDrawing(false);
    }
    static endDrawing(isAborted) {
        const parent = this._currentParent;
        if (!parent) return null;
        parent.toggleDrawing(true);
        parent.cleanUndoStack($a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.DRAW_STEP);
        if (!$a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw.isEmpty()) {
            const { pageDimensions: [pageWidth, pageHeight], scale: scale } = parent;
            const editor = parent.createAndAddNewEditor({
                offsetX: 0,
                offsetY: 0
            }, false, {
                drawId: this._currentDrawId,
                drawOutlines: $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDraw.getOutlines(pageWidth * scale, pageHeight * scale, scale, this._INNER_MARGIN),
                drawingOptions: $a2cc6e1d6eb3861b$var$DrawingEditor.#currentDrawingOptions,
                mustBeCommitted: !isAborted
            });
            this._cleanup(true);
            return editor;
        }
        parent.drawLayer.remove(this._currentDrawId);
        this._cleanup(true);
        return null;
    }
    createDrawingOptions(_data) {}
    static deserializeDraw(_pageX, _pageY, _pageWidth, _pageHeight, _innerWidth, _data) {
        $a2cc6e1d6eb3861b$var$unreachable("Not implemented");
    }
    static async deserialize(data, parent, uiManager) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = parent.viewport;
        const drawOutlines = this.deserializeDraw(pageX, pageY, pageWidth, pageHeight, this._INNER_MARGIN, data);
        const editor = await super.deserialize(data, parent, uiManager);
        editor.createDrawingOptions(data);
        editor.#createDrawOutlines({
            drawOutlines: drawOutlines
        });
        editor.#addToDrawLayer();
        editor.onScaleChanging();
        editor.rotate();
        return editor;
    }
    serializeDraw(isForCopying) {
        const [pageX, pageY] = this.pageTranslation;
        const [pageWidth, pageHeight] = this.pageDimensions;
        return this.#drawOutlines.serialize([
            pageX,
            pageY,
            pageWidth,
            pageHeight
        ], isForCopying);
    }
    renderAnnotationElement(annotation) {
        annotation.updateEdited({
            rect: this.getPDFRect()
        });
        return null;
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $a2cc6e1d6eb3861b$var$InkDrawOutliner {
    #last = new Float64Array(6);
    #line;
    #lines;
    #rotation;
    #thickness;
    #points;
    #lastSVGPath = "";
    #lastIndex = 0;
    #outlines = new $a2cc6e1d6eb3861b$var$InkDrawOutline();
    #parentWidth;
    #parentHeight;
    constructor(x, y, parentWidth, parentHeight, rotation, thickness){
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#rotation = rotation;
        this.#thickness = thickness;
        [x, y] = this.#normalizePoint(x, y);
        const line = this.#line = [
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ];
        this.#points = [
            x,
            y
        ];
        this.#lines = [
            {
                line: line,
                points: this.#points
            }
        ];
        this.#last.set(line, 0);
    }
    updateProperty(name, value) {
        if (name === "stroke-width") this.#thickness = value;
    }
    #normalizePoint(x, y) {
        return $a2cc6e1d6eb3861b$var$Outline._normalizePoint(x, y, this.#parentWidth, this.#parentHeight, this.#rotation);
    }
    isEmpty() {
        return !this.#lines || this.#lines.length === 0;
    }
    isCancellable() {
        return this.#points.length <= 10;
    }
    add(x, y) {
        [x, y] = this.#normalizePoint(x, y);
        const [x1, y1, x2, y2] = this.#last.subarray(2, 6);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(this.#parentWidth * diffX, this.#parentHeight * diffY);
        if (d <= 2) return null;
        this.#points.push(x, y);
        if (isNaN(x1)) {
            this.#last.set([
                x2,
                y2,
                x,
                y
            ], 2);
            this.#line.push(NaN, NaN, NaN, NaN, x, y);
            return {
                path: {
                    d: this.toSVGPath()
                }
            };
        }
        if (isNaN(this.#last[0])) this.#line.splice(6, 6);
        this.#last.set([
            x1,
            y1,
            x2,
            y2,
            x,
            y
        ], 0);
        this.#line.push(...$a2cc6e1d6eb3861b$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y));
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    end(x, y) {
        const change = this.add(x, y);
        if (change) return change;
        if (this.#points.length === 2) return {
            path: {
                d: this.toSVGPath()
            }
        };
        return null;
    }
    startNew(x, y, parentWidth, parentHeight, rotation) {
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#rotation = rotation;
        [x, y] = this.#normalizePoint(x, y);
        const line = this.#line = [
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ];
        this.#points = [
            x,
            y
        ];
        const last = this.#lines.at(-1);
        if (last) {
            last.line = new Float32Array(last.line);
            last.points = new Float32Array(last.points);
        }
        this.#lines.push({
            line: line,
            points: this.#points
        });
        this.#last.set(line, 0);
        this.#lastIndex = 0;
        this.toSVGPath();
        return null;
    }
    getLastElement() {
        return this.#lines.at(-1);
    }
    setLastElement(element) {
        if (!this.#lines) return this.#outlines.setLastElement(element);
        this.#lines.push(element);
        this.#line = element.line;
        this.#points = element.points;
        this.#lastIndex = 0;
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    removeLastElement() {
        if (!this.#lines) return this.#outlines.removeLastElement();
        this.#lines.pop();
        this.#lastSVGPath = "";
        for(let i = 0, ii = this.#lines.length; i < ii; i++){
            const { line: line, points: points } = this.#lines[i];
            this.#line = line;
            this.#points = points;
            this.#lastIndex = 0;
            this.toSVGPath();
        }
        return {
            path: {
                d: this.#lastSVGPath
            }
        };
    }
    toSVGPath() {
        const firstX = $a2cc6e1d6eb3861b$var$Outline.svgRound(this.#line[4]);
        const firstY = $a2cc6e1d6eb3861b$var$Outline.svgRound(this.#line[5]);
        if (this.#points.length === 2) {
            this.#lastSVGPath = `${this.#lastSVGPath} M ${firstX} ${firstY} Z`;
            return this.#lastSVGPath;
        }
        if (this.#points.length <= 6) {
            const i = this.#lastSVGPath.lastIndexOf("M");
            this.#lastSVGPath = `${this.#lastSVGPath.slice(0, i)} M ${firstX} ${firstY}`;
            this.#lastIndex = 6;
        }
        if (this.#points.length === 4) {
            const secondX = $a2cc6e1d6eb3861b$var$Outline.svgRound(this.#line[10]);
            const secondY = $a2cc6e1d6eb3861b$var$Outline.svgRound(this.#line[11]);
            this.#lastSVGPath = `${this.#lastSVGPath} L ${secondX} ${secondY}`;
            this.#lastIndex = 12;
            return this.#lastSVGPath;
        }
        const buffer = [];
        if (this.#lastIndex === 0) {
            buffer.push(`M ${firstX} ${firstY}`);
            this.#lastIndex = 6;
        }
        for(let i = this.#lastIndex, ii = this.#line.length; i < ii; i += 6){
            const [c1x, c1y, c2x, c2y, x, y] = this.#line.slice(i, i + 6).map($a2cc6e1d6eb3861b$var$Outline.svgRound);
            buffer.push(`C${c1x} ${c1y} ${c2x} ${c2y} ${x} ${y}`);
        }
        this.#lastSVGPath += buffer.join(" ");
        this.#lastIndex = this.#line.length;
        return this.#lastSVGPath;
    }
    getOutlines(parentWidth, parentHeight, scale, innerMargin) {
        const last = this.#lines.at(-1);
        last.line = new Float32Array(last.line);
        last.points = new Float32Array(last.points);
        this.#outlines.build(this.#lines, parentWidth, parentHeight, scale, this.#rotation, this.#thickness, innerMargin);
        this.#last = null;
        this.#line = null;
        this.#lines = null;
        this.#lastSVGPath = null;
        return this.#outlines;
    }
    get defaultSVGProperties() {
        return {
            root: {
                viewBox: "0 0 10000 10000"
            },
            rootClass: {
                draw: true
            },
            bbox: [
                0,
                0,
                1,
                1
            ]
        };
    }
}
class $a2cc6e1d6eb3861b$var$InkDrawOutline extends $a2cc6e1d6eb3861b$var$Outline {
    #bbox;
    #currentRotation = 0;
    #innerMargin;
    #lines;
    #parentWidth;
    #parentHeight;
    #parentScale;
    #rotation;
    #thickness;
    build(lines, parentWidth, parentHeight, parentScale, rotation, thickness, innerMargin) {
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#parentScale = parentScale;
        this.#rotation = rotation;
        this.#thickness = thickness;
        this.#innerMargin = innerMargin ?? 0;
        this.#lines = lines;
        this.#computeBbox();
    }
    get thickness() {
        return this.#thickness;
    }
    setLastElement(element) {
        this.#lines.push(element);
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    removeLastElement() {
        this.#lines.pop();
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    toSVGPath() {
        const buffer = [];
        for (const { line: line } of this.#lines){
            buffer.push(`M${$a2cc6e1d6eb3861b$var$Outline.svgRound(line[4])} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(line[5])}`);
            if (line.length === 6) {
                buffer.push("Z");
                continue;
            }
            if (line.length === 12 && isNaN(line[6])) {
                buffer.push(`L${$a2cc6e1d6eb3861b$var$Outline.svgRound(line[10])} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(line[11])}`);
                continue;
            }
            for(let i = 6, ii = line.length; i < ii; i += 6){
                const [c1x, c1y, c2x, c2y, x, y] = line.subarray(i, i + 6).map($a2cc6e1d6eb3861b$var$Outline.svgRound);
                buffer.push(`C${c1x} ${c1y} ${c2x} ${c2y} ${x} ${y}`);
            }
        }
        return buffer.join("");
    }
    serialize([pageX, pageY, pageWidth, pageHeight], isForCopying) {
        const serializedLines = [];
        const serializedPoints = [];
        const [x, y, width, height] = this.#getBBoxWithNoMargin();
        let tx, ty, sx, sy, x1, y1, x2, y2, rescaleFn;
        switch(this.#rotation){
            case 0:
                rescaleFn = $a2cc6e1d6eb3861b$var$Outline._rescale;
                tx = pageX;
                ty = pageY + pageHeight;
                sx = pageWidth;
                sy = -pageHeight;
                x1 = pageX + x * pageWidth;
                y1 = pageY + (1 - y - height) * pageHeight;
                x2 = pageX + (x + width) * pageWidth;
                y2 = pageY + (1 - y) * pageHeight;
                break;
            case 90:
                rescaleFn = $a2cc6e1d6eb3861b$var$Outline._rescaleAndSwap;
                tx = pageX;
                ty = pageY;
                sx = pageWidth;
                sy = pageHeight;
                x1 = pageX + y * pageWidth;
                y1 = pageY + x * pageHeight;
                x2 = pageX + (y + height) * pageWidth;
                y2 = pageY + (x + width) * pageHeight;
                break;
            case 180:
                rescaleFn = $a2cc6e1d6eb3861b$var$Outline._rescale;
                tx = pageX + pageWidth;
                ty = pageY;
                sx = -pageWidth;
                sy = pageHeight;
                x1 = pageX + (1 - x - width) * pageWidth;
                y1 = pageY + y * pageHeight;
                x2 = pageX + (1 - x) * pageWidth;
                y2 = pageY + (y + height) * pageHeight;
                break;
            case 270:
                rescaleFn = $a2cc6e1d6eb3861b$var$Outline._rescaleAndSwap;
                tx = pageX + pageWidth;
                ty = pageY + pageHeight;
                sx = -pageWidth;
                sy = -pageHeight;
                x1 = pageX + (1 - y - height) * pageWidth;
                y1 = pageY + (1 - x - width) * pageHeight;
                x2 = pageX + (1 - y) * pageWidth;
                y2 = pageY + (1 - x) * pageHeight;
                break;
        }
        for (const { line: line, points: points } of this.#lines){
            serializedLines.push(rescaleFn(line, tx, ty, sx, sy, isForCopying ? new Array(line.length) : null));
            serializedPoints.push(rescaleFn(points, tx, ty, sx, sy, isForCopying ? new Array(points.length) : null));
        }
        return {
            lines: serializedLines,
            points: serializedPoints,
            rect: [
                x1,
                y1,
                x2,
                y2
            ]
        };
    }
    static deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, { paths: { lines: lines, points: points }, rotation: rotation, thickness: thickness }) {
        const newLines = [];
        let tx, ty, sx, sy, rescaleFn;
        switch(rotation){
            case 0:
                rescaleFn = $a2cc6e1d6eb3861b$var$Outline._rescale;
                tx = -pageX / pageWidth;
                ty = pageY / pageHeight + 1;
                sx = 1 / pageWidth;
                sy = -1 / pageHeight;
                break;
            case 90:
                rescaleFn = $a2cc6e1d6eb3861b$var$Outline._rescaleAndSwap;
                tx = -pageY / pageHeight;
                ty = -pageX / pageWidth;
                sx = 1 / pageHeight;
                sy = 1 / pageWidth;
                break;
            case 180:
                rescaleFn = $a2cc6e1d6eb3861b$var$Outline._rescale;
                tx = pageX / pageWidth + 1;
                ty = -pageY / pageHeight;
                sx = -1 / pageWidth;
                sy = 1 / pageHeight;
                break;
            case 270:
                rescaleFn = $a2cc6e1d6eb3861b$var$Outline._rescaleAndSwap;
                tx = pageY / pageHeight + 1;
                ty = pageX / pageWidth + 1;
                sx = -1 / pageHeight;
                sy = -1 / pageWidth;
                break;
        }
        if (!lines) {
            lines = [];
            for (const point of points){
                const len = point.length;
                if (len === 2) {
                    lines.push(new Float32Array([
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[0],
                        point[1]
                    ]));
                    continue;
                }
                if (len === 4) {
                    lines.push(new Float32Array([
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[0],
                        point[1],
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[2],
                        point[3]
                    ]));
                    continue;
                }
                const line = new Float32Array(3 * (len - 2));
                lines.push(line);
                let [x1, y1, x2, y2] = point.subarray(0, 4);
                line.set([
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    x1,
                    y1
                ], 0);
                for(let i = 4; i < len; i += 2){
                    const x = point[i];
                    const y = point[i + 1];
                    line.set($a2cc6e1d6eb3861b$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                    [x1, y1, x2, y2] = [
                        x2,
                        y2,
                        x,
                        y
                    ];
                }
            }
        }
        for(let i = 0, ii = lines.length; i < ii; i++)newLines.push({
            line: rescaleFn(lines[i].map((x)=>x ?? NaN), tx, ty, sx, sy),
            points: rescaleFn(points[i].map((x)=>x ?? NaN), tx, ty, sx, sy)
        });
        const outlines = new this.prototype.constructor();
        outlines.build(newLines, pageWidth, pageHeight, 1, rotation, thickness, innerMargin);
        return outlines;
    }
    #getMarginComponents(thickness = this.#thickness) {
        const margin = this.#innerMargin + thickness / 2 * this.#parentScale;
        return this.#rotation % 180 === 0 ? [
            margin / this.#parentWidth,
            margin / this.#parentHeight
        ] : [
            margin / this.#parentHeight,
            margin / this.#parentWidth
        ];
    }
    #getBBoxWithNoMargin() {
        const [x, y, width, height] = this.#bbox;
        const [marginX, marginY] = this.#getMarginComponents(0);
        return [
            x + marginX,
            y + marginY,
            width - 2 * marginX,
            height - 2 * marginY
        ];
    }
    #computeBbox() {
        const bbox = this.#bbox = $a2cc6e1d6eb3861b$var$F32_BBOX_INIT.slice();
        for (const { line: line } of this.#lines){
            if (line.length <= 12) {
                for(let i = 4, ii = line.length; i < ii; i += 6)$a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.pointBoundingBox(line[i], line[i + 1], bbox);
                continue;
            }
            let lastX = line[4], lastY = line[5];
            for(let i = 6, ii = line.length; i < ii; i += 6){
                const [c1x, c1y, c2x, c2y, x, y] = line.subarray(i, i + 6);
                $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.bezierBoundingBox(lastX, lastY, c1x, c1y, c2x, c2y, x, y, bbox);
                lastX = x;
                lastY = y;
            }
        }
        const [marginX, marginY] = this.#getMarginComponents();
        bbox[0] = $a2cc6e1d6eb3861b$export$b8106b171181a554(bbox[0] - marginX, 0, 1);
        bbox[1] = $a2cc6e1d6eb3861b$export$b8106b171181a554(bbox[1] - marginY, 0, 1);
        bbox[2] = $a2cc6e1d6eb3861b$export$b8106b171181a554(bbox[2] + marginX, 0, 1);
        bbox[3] = $a2cc6e1d6eb3861b$export$b8106b171181a554(bbox[3] + marginY, 0, 1);
        bbox[2] -= bbox[0];
        bbox[3] -= bbox[1];
    }
    get box() {
        return this.#bbox;
    }
    updateProperty(name, value) {
        if (name === "stroke-width") return this.#updateThickness(value);
        return null;
    }
    #updateThickness(thickness) {
        const [oldMarginX, oldMarginY] = this.#getMarginComponents();
        this.#thickness = thickness;
        const [newMarginX, newMarginY] = this.#getMarginComponents();
        const [diffMarginX, diffMarginY] = [
            newMarginX - oldMarginX,
            newMarginY - oldMarginY
        ];
        const bbox = this.#bbox;
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    }
    updateParentDimensions([width, height], scale) {
        const [oldMarginX, oldMarginY] = this.#getMarginComponents();
        this.#parentWidth = width;
        this.#parentHeight = height;
        this.#parentScale = scale;
        const [newMarginX, newMarginY] = this.#getMarginComponents();
        const diffMarginX = newMarginX - oldMarginX;
        const diffMarginY = newMarginY - oldMarginY;
        const bbox = this.#bbox;
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    }
    updateRotation(rotation) {
        this.#currentRotation = rotation;
        return {
            path: {
                transform: this.rotationTransform
            }
        };
    }
    get viewBox() {
        return this.#bbox.map($a2cc6e1d6eb3861b$var$Outline.svgRound).join(" ");
    }
    get defaultProperties() {
        const [x, y] = this.#bbox;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": `${$a2cc6e1d6eb3861b$var$Outline.svgRound(x)} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(y)}`
            }
        };
    }
    get rotationTransform() {
        const [, , width, height] = this.#bbox;
        let a = 0, b = 0, c = 0, d = 0, e = 0, f = 0;
        switch(this.#currentRotation){
            case 90:
                b = height / width;
                c = -width / height;
                e = width;
                break;
            case 180:
                a = -1;
                d = -1;
                e = width;
                f = height;
                break;
            case 270:
                b = -height / width;
                c = width / height;
                f = height;
                break;
            default:
                return "";
        }
        return `matrix(${a} ${b} ${c} ${d} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(e)} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(f)})`;
    }
    getPathResizingSVGProperties([newX, newY, newWidth, newHeight]) {
        const [marginX, marginY] = this.#getMarginComponents();
        const [x, y, width, height] = this.#bbox;
        if (Math.abs(width - marginX) <= $a2cc6e1d6eb3861b$var$Outline.PRECISION || Math.abs(height - marginY) <= $a2cc6e1d6eb3861b$var$Outline.PRECISION) {
            const tx = newX + newWidth / 2 - (x + width / 2);
            const ty = newY + newHeight / 2 - (y + height / 2);
            return {
                path: {
                    "transform-origin": `${$a2cc6e1d6eb3861b$var$Outline.svgRound(newX)} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(newY)}`,
                    transform: `${this.rotationTransform} translate(${tx} ${ty})`
                }
            };
        }
        const s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        const s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        const s2x = width / newWidth;
        const s2y = height / newHeight;
        return {
            path: {
                "transform-origin": `${$a2cc6e1d6eb3861b$var$Outline.svgRound(x)} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(y)}`,
                transform: `${this.rotationTransform} scale(${s2x} ${s2y}) ` + `translate(${$a2cc6e1d6eb3861b$var$Outline.svgRound(marginX)} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(marginY)}) scale(${s1x} ${s1y}) ` + `translate(${$a2cc6e1d6eb3861b$var$Outline.svgRound(-marginX)} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(-marginY)})`
            }
        };
    }
    getPathResizedSVGProperties([newX, newY, newWidth, newHeight]) {
        const [marginX, marginY] = this.#getMarginComponents();
        const bbox = this.#bbox;
        const [x, y, width, height] = bbox;
        bbox[0] = newX;
        bbox[1] = newY;
        bbox[2] = newWidth;
        bbox[3] = newHeight;
        if (Math.abs(width - marginX) <= $a2cc6e1d6eb3861b$var$Outline.PRECISION || Math.abs(height - marginY) <= $a2cc6e1d6eb3861b$var$Outline.PRECISION) {
            const tx = newX + newWidth / 2 - (x + width / 2);
            const ty = newY + newHeight / 2 - (y + height / 2);
            for (const { line: line, points: points } of this.#lines){
                $a2cc6e1d6eb3861b$var$Outline._translate(line, tx, ty, line);
                $a2cc6e1d6eb3861b$var$Outline._translate(points, tx, ty, points);
            }
            return {
                root: {
                    viewBox: this.viewBox
                },
                path: {
                    "transform-origin": `${$a2cc6e1d6eb3861b$var$Outline.svgRound(newX)} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(newY)}`,
                    transform: this.rotationTransform || null,
                    d: this.toSVGPath()
                }
            };
        }
        const s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        const s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        const tx = -s1x * (x + marginX) + newX + marginX;
        const ty = -s1y * (y + marginY) + newY + marginY;
        if (s1x !== 1 || s1y !== 1 || tx !== 0 || ty !== 0) for (const { line: line, points: points } of this.#lines){
            $a2cc6e1d6eb3861b$var$Outline._rescale(line, tx, ty, s1x, s1y, line);
            $a2cc6e1d6eb3861b$var$Outline._rescale(points, tx, ty, s1x, s1y, points);
        }
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": `${$a2cc6e1d6eb3861b$var$Outline.svgRound(newX)} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(newY)}`,
                transform: this.rotationTransform || null,
                d: this.toSVGPath()
            }
        };
    }
    getPathTranslatedSVGProperties([newX, newY], parentDimensions) {
        const [newParentWidth, newParentHeight] = parentDimensions;
        const bbox = this.#bbox;
        const tx = newX - bbox[0];
        const ty = newY - bbox[1];
        if (this.#parentWidth === newParentWidth && this.#parentHeight === newParentHeight) for (const { line: line, points: points } of this.#lines){
            $a2cc6e1d6eb3861b$var$Outline._translate(line, tx, ty, line);
            $a2cc6e1d6eb3861b$var$Outline._translate(points, tx, ty, points);
        }
        else {
            const sx = this.#parentWidth / newParentWidth;
            const sy = this.#parentHeight / newParentHeight;
            this.#parentWidth = newParentWidth;
            this.#parentHeight = newParentHeight;
            for (const { line: line, points: points } of this.#lines){
                $a2cc6e1d6eb3861b$var$Outline._rescale(line, tx, ty, sx, sy, line);
                $a2cc6e1d6eb3861b$var$Outline._rescale(points, tx, ty, sx, sy, points);
            }
            bbox[2] *= sx;
            bbox[3] *= sy;
        }
        bbox[0] = newX;
        bbox[1] = newY;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": `${$a2cc6e1d6eb3861b$var$Outline.svgRound(newX)} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(newY)}`
            }
        };
    }
    get defaultSVGProperties() {
        const bbox = this.#bbox;
        return {
            root: {
                viewBox: this.viewBox
            },
            rootClass: {
                draw: true
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": `${$a2cc6e1d6eb3861b$var$Outline.svgRound(bbox[0])} ${$a2cc6e1d6eb3861b$var$Outline.svgRound(bbox[1])}`,
                transform: this.rotationTransform || null
            },
            bbox: bbox
        };
    }
}
class $a2cc6e1d6eb3861b$var$InkDrawingOptions extends $a2cc6e1d6eb3861b$var$DrawingOptions {
    constructor(viewerParameters){
        super();
        this._viewParameters = viewerParameters;
        super.updateProperties({
            fill: "none",
            stroke: $a2cc6e1d6eb3861b$var$AnnotationEditor._defaultLineColor,
            "stroke-opacity": 1,
            "stroke-width": 1,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-miterlimit": 10
        });
    }
    updateSVGProperty(name, value) {
        if (name === "stroke-width") {
            value ??= this["stroke-width"];
            value *= this._viewParameters.realScale;
        }
        super.updateSVGProperty(name, value);
    }
    clone() {
        const clone = new $a2cc6e1d6eb3861b$var$InkDrawingOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    }
}
class $a2cc6e1d6eb3861b$var$InkEditor extends $a2cc6e1d6eb3861b$var$DrawingEditor {
    static _type = "ink";
    static _editorType = $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.INK;
    static _defaultDrawingOptions = null;
    constructor(params){
        super({
            ...params,
            name: "inkEditor"
        });
        this._willKeepAspectRatio = true;
        this.defaultL10nId = "pdfjs-editor-ink-editor";
    }
    static initialize(l10n, uiManager) {
        $a2cc6e1d6eb3861b$var$AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new $a2cc6e1d6eb3861b$var$InkDrawingOptions(uiManager.viewParameters);
    }
    static getDefaultDrawingOptions(options) {
        const clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    }
    static get supportMultipleDrawings() {
        return true;
    }
    static get typesMap() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "typesMap", new Map([
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_THICKNESS,
                "stroke-width"
            ],
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_COLOR,
                "stroke"
            ],
            [
                $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_OPACITY,
                "stroke-opacity"
            ]
        ]));
    }
    static createDrawerInstance(x, y, parentWidth, parentHeight, rotation) {
        return new $a2cc6e1d6eb3861b$var$InkDrawOutliner(x, y, parentWidth, parentHeight, rotation, this._defaultDrawingOptions["stroke-width"]);
    }
    static deserializeDraw(pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        return $a2cc6e1d6eb3861b$var$InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $a2cc6e1d6eb3861b$var$InkAnnotationElement) {
            const { data: { inkLists: inkLists, rect: rect, rotation: rotation, id: id, color: color, opacity: opacity, borderStyle: { rawWidth: thickness }, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.INK,
                color: Array.from(color),
                thickness: thickness,
                opacity: opacity,
                paths: {
                    points: inkLists
                },
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        return editor;
    }
    get toolbarButtons() {
        this._colorPicker ||= new $a2cc6e1d6eb3861b$var$BasicColorPicker(this);
        return [
            [
                "colorPicker",
                this._colorPicker
            ]
        ];
    }
    get colorType() {
        return $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_COLOR;
    }
    get colorAndOpacityType() {
        return $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_COLOR_AND_OPACITY;
    }
    get opacityType() {
        return $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_OPACITY;
    }
    updateParams(type, value) {
        if (type === $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_COLOR_AND_OPACITY) {
            this._updateColorAndOpacity(value.color, value.opacity);
            return;
        }
        super.updateParams(type, value);
    }
    static updateDefaultParams(type, value) {
        if (type === $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_COLOR_AND_OPACITY) {
            super.updateDefaultParams($a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_COLOR, value.color);
            super.updateDefaultParams($a2cc6e1d6eb3861b$export$cf3df2a6ecc26692.INK_OPACITY, value.opacity);
            return;
        }
        super.updateDefaultParams(type, value);
    }
    get color() {
        return this._drawingOptions.stroke;
    }
    get opacity() {
        return this._drawingOptions["stroke-opacity"];
    }
    onScaleChanging() {
        if (!this.parent) return;
        super.onScaleChanging();
        const { _drawId: _drawId, _drawingOptions: _drawingOptions, parent: parent } = this;
        _drawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(_drawId, _drawingOptions.toSVGProperties());
    }
    static onScaleChangingWhenDrawing() {
        const parent = this._currentParent;
        if (!parent) return;
        super.onScaleChangingWhenDrawing();
        this._defaultDrawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
    }
    createDrawingOptions({ color: color, thickness: thickness, opacity: opacity }) {
        this._drawingOptions = $a2cc6e1d6eb3861b$var$InkEditor.getDefaultDrawingOptions({
            stroke: $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.makeHexColor(...color),
            "stroke-width": thickness,
            "stroke-opacity": opacity
        });
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const { lines: lines, points: points } = this.serializeDraw(isForCopying);
        const { _drawingOptions: { stroke: stroke, "stroke-opacity": opacity, "stroke-width": thickness } } = this;
        const serialized = Object.assign(super.serialize(isForCopying), {
            color: $a2cc6e1d6eb3861b$var$AnnotationEditor._colorManager.convert(stroke),
            opacity: opacity,
            thickness: thickness,
            paths: {
                lines: lines,
                points: points
            }
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { color: color, thickness: thickness, opacity: opacity, pageIndex: pageIndex } = this._initialData;
        return this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized || serialized.color.some((c, i)=>c !== color[i]) || serialized.thickness !== thickness || serialized.opacity !== opacity || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        const { points: points, rect: rect } = this.serializeDraw(false);
        annotation.updateEdited({
            rect: rect,
            thickness: this._drawingOptions["stroke-width"],
            points: points,
            popup: this.comment
        });
        return null;
    }
}
class $a2cc6e1d6eb3861b$var$ContourDrawOutline extends $a2cc6e1d6eb3861b$var$InkDrawOutline {
    toSVGPath() {
        let path = super.toSVGPath();
        if (!path.endsWith("Z")) path += "Z";
        return path;
    }
}
const $a2cc6e1d6eb3861b$var$BASE_HEADER_LENGTH = 8;
const $a2cc6e1d6eb3861b$var$POINTS_PROPERTIES_NUMBER = 3;
class $a2cc6e1d6eb3861b$export$cc4fe8633f466b4a {
    static #PARAMETERS = {
        maxDim: 512,
        sigmaSFactor: 0.02,
        sigmaR: 25,
        kernelSize: 16
    };
    static #neighborIndexToId(i0, j0, i, j) {
        i -= i0;
        j -= j0;
        if (i === 0) return j > 0 ? 0 : 4;
        if (i === 1) return j + 6;
        return 2 - j;
    }
    static #neighborIdToIndex = new Int32Array([
        0,
        1,
        -1,
        1,
        -1,
        0,
        -1,
        -1,
        0,
        -1,
        1,
        -1,
        1,
        0,
        1,
        1
    ]);
    static #clockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        const id = this.#neighborIndexToId(i0, j0, i, j);
        for(let k = 0; k < 8; k++){
            const kk = (-k + id - offset + 16) % 8;
            const shiftI = this.#neighborIdToIndex[2 * kk];
            const shiftJ = this.#neighborIdToIndex[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) return kk;
        }
        return -1;
    }
    static #counterClockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        const id = this.#neighborIndexToId(i0, j0, i, j);
        for(let k = 0; k < 8; k++){
            const kk = (k + id + offset + 16) % 8;
            const shiftI = this.#neighborIdToIndex[2 * kk];
            const shiftJ = this.#neighborIdToIndex[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) return kk;
        }
        return -1;
    }
    static #findContours(buf, width, height, threshold) {
        const N = buf.length;
        const types = new Int32Array(N);
        for(let i = 0; i < N; i++)types[i] = buf[i] <= threshold ? 1 : 0;
        for(let i = 1; i < height - 1; i++)types[i * width] = types[i * width + width - 1] = 0;
        for(let i = 0; i < width; i++)types[i] = types[width * height - 1 - i] = 0;
        let nbd = 1;
        let lnbd;
        const contours = [];
        for(let i = 1; i < height - 1; i++){
            lnbd = 1;
            for(let j = 1; j < width - 1; j++){
                const ij = i * width + j;
                const pix = types[ij];
                if (pix === 0) continue;
                let i2 = i;
                let j2 = j;
                if (pix === 1 && types[ij - 1] === 0) {
                    nbd += 1;
                    j2 -= 1;
                } else if (pix >= 1 && types[ij + 1] === 0) {
                    nbd += 1;
                    j2 += 1;
                    if (pix > 1) lnbd = pix;
                } else {
                    if (pix !== 1) lnbd = Math.abs(pix);
                    continue;
                }
                const points = [
                    j,
                    i
                ];
                const isHole = j2 === j + 1;
                const contour = {
                    isHole: isHole,
                    points: points,
                    id: nbd,
                    parent: 0
                };
                contours.push(contour);
                let contour0;
                for (const c of contours)if (c.id === lnbd) {
                    contour0 = c;
                    break;
                }
                if (!contour0) contour.parent = isHole ? lnbd : 0;
                else if (contour0.isHole) contour.parent = isHole ? contour0.parent : lnbd;
                else contour.parent = isHole ? lnbd : contour0.parent;
                const k = this.#clockwiseNonZero(types, width, i, j, i2, j2, 0);
                if (k === -1) {
                    types[ij] = -nbd;
                    if (types[ij] !== 1) lnbd = Math.abs(types[ij]);
                    continue;
                }
                let shiftI = this.#neighborIdToIndex[2 * k];
                let shiftJ = this.#neighborIdToIndex[2 * k + 1];
                const i1 = i + shiftI;
                const j1 = j + shiftJ;
                i2 = i1;
                j2 = j1;
                let i3 = i;
                let j3 = j;
                while(true){
                    const kk = this.#counterClockwiseNonZero(types, width, i3, j3, i2, j2, 1);
                    shiftI = this.#neighborIdToIndex[2 * kk];
                    shiftJ = this.#neighborIdToIndex[2 * kk + 1];
                    const i4 = i3 + shiftI;
                    const j4 = j3 + shiftJ;
                    points.push(j4, i4);
                    const ij3 = i3 * width + j3;
                    if (types[ij3 + 1] === 0) types[ij3] = -nbd;
                    else if (types[ij3] === 1) types[ij3] = nbd;
                    if (i4 === i && j4 === j && i3 === i1 && j3 === j1) {
                        if (types[ij] !== 1) lnbd = Math.abs(types[ij]);
                        break;
                    } else {
                        i2 = i3;
                        j2 = j3;
                        i3 = i4;
                        j3 = j4;
                    }
                }
            }
        }
        return contours;
    }
    static #douglasPeuckerHelper(points, start, end, output) {
        if (end - start <= 4) {
            for(let i = start; i < end - 2; i += 2)output.push(points[i], points[i + 1]);
            return;
        }
        const ax = points[start];
        const ay = points[start + 1];
        const abx = points[end - 4] - ax;
        const aby = points[end - 3] - ay;
        const dist = Math.hypot(abx, aby);
        const nabx = abx / dist;
        const naby = aby / dist;
        const aa = nabx * ay - naby * ax;
        const m = aby / abx;
        const invS = 1 / dist;
        const phi = Math.atan(m);
        const cosPhi = Math.cos(phi);
        const sinPhi = Math.sin(phi);
        const tmax = invS * (Math.abs(cosPhi) + Math.abs(sinPhi));
        const poly = invS * (1 - tmax + tmax ** 2);
        const partialPhi = Math.max(Math.atan(Math.abs(sinPhi + cosPhi) * poly), Math.atan(Math.abs(sinPhi - cosPhi) * poly));
        let dmax = 0;
        let index = start;
        for(let i = start + 2; i < end - 2; i += 2){
            const d = Math.abs(aa - nabx * points[i + 1] + naby * points[i]);
            if (d > dmax) {
                index = i;
                dmax = d;
            }
        }
        if (dmax > (dist * partialPhi) ** 2) {
            this.#douglasPeuckerHelper(points, start, index + 2, output);
            this.#douglasPeuckerHelper(points, index, end, output);
        } else output.push(ax, ay);
    }
    static #douglasPeucker(points) {
        const output = [];
        const len = points.length;
        this.#douglasPeuckerHelper(points, 0, len, output);
        output.push(points[len - 2], points[len - 1]);
        return output.length <= 4 ? null : output;
    }
    static #bilateralFilter(buf, width, height, sigmaS, sigmaR, kernelSize) {
        const kernel = new Float32Array(kernelSize ** 2);
        const sigmaS2 = -2 * sigmaS ** 2;
        const halfSize = kernelSize >> 1;
        for(let i = 0; i < kernelSize; i++){
            const x = (i - halfSize) ** 2;
            for(let j = 0; j < kernelSize; j++)kernel[i * kernelSize + j] = Math.exp((x + (j - halfSize) ** 2) / sigmaS2);
        }
        const rangeValues = new Float32Array(256);
        const sigmaR2 = -2 * sigmaR ** 2;
        for(let i = 0; i < 256; i++)rangeValues[i] = Math.exp(i ** 2 / sigmaR2);
        const N = buf.length;
        const out = new Uint8Array(N);
        const histogram = new Uint32Array(256);
        for(let i = 0; i < height; i++)for(let j = 0; j < width; j++){
            const ij = i * width + j;
            const center = buf[ij];
            let sum = 0;
            let norm = 0;
            for(let k = 0; k < kernelSize; k++){
                const y = i + k - halfSize;
                if (y < 0 || y >= height) continue;
                for(let l = 0; l < kernelSize; l++){
                    const x = j + l - halfSize;
                    if (x < 0 || x >= width) continue;
                    const neighbour = buf[y * width + x];
                    const w = kernel[k * kernelSize + l] * rangeValues[Math.abs(neighbour - center)];
                    sum += neighbour * w;
                    norm += w;
                }
            }
            const pix = out[ij] = Math.round(sum / norm);
            histogram[pix]++;
        }
        return [
            out,
            histogram
        ];
    }
    static #getHistogram(buf) {
        const histogram = new Uint32Array(256);
        for (const g of buf)histogram[g]++;
        return histogram;
    }
    static #toUint8(buf) {
        const N = buf.length;
        const out = new Uint8ClampedArray(N >> 2);
        let max = -Infinity;
        let min = Infinity;
        for(let i = 0, ii = out.length; i < ii; i++){
            const pix = out[i] = buf[i << 2];
            max = Math.max(max, pix);
            min = Math.min(min, pix);
        }
        const ratio = 255 / (max - min);
        for(let i = 0, ii = out.length; i < ii; i++)out[i] = (out[i] - min) * ratio;
        return out;
    }
    static #guessThreshold(histogram) {
        let i;
        let M = -Infinity;
        let L = -Infinity;
        const min = histogram.findIndex((v)=>v !== 0);
        let pos = min;
        let spos = min;
        for(i = min; i < 256; i++){
            const v = histogram[i];
            if (v > M) {
                if (i - pos > L) {
                    L = i - pos;
                    spos = i - 1;
                }
                M = v;
                pos = i;
            }
        }
        for(i = spos - 1; i >= 0; i--){
            if (histogram[i] > histogram[i + 1]) break;
        }
        return i;
    }
    static #getGrayPixels(bitmap) {
        const originalBitmap = bitmap;
        const { width: width, height: height } = bitmap;
        const { maxDim: maxDim } = this.#PARAMETERS;
        let newWidth = width;
        let newHeight = height;
        if (width > maxDim || height > maxDim) {
            let prevWidth = width;
            let prevHeight = height;
            let steps = Math.log2(Math.max(width, height) / maxDim);
            const isteps = Math.floor(steps);
            steps = steps === isteps ? isteps - 1 : isteps;
            for(let i = 0; i < steps; i++){
                newWidth = Math.ceil(prevWidth / 2);
                newHeight = Math.ceil(prevHeight / 2);
                const offscreen = new OffscreenCanvas(newWidth, newHeight);
                const ctx = offscreen.getContext("2d");
                ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                prevWidth = newWidth;
                prevHeight = newHeight;
                if (bitmap !== originalBitmap) bitmap.close();
                bitmap = offscreen.transferToImageBitmap();
            }
            const ratio = Math.min(maxDim / newWidth, maxDim / newHeight);
            newWidth = Math.round(newWidth * ratio);
            newHeight = Math.round(newHeight * ratio);
        }
        const offscreen = new OffscreenCanvas(newWidth, newHeight);
        const ctx = offscreen.getContext("2d", {
            willReadFrequently: true
        });
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, newWidth, newHeight);
        ctx.filter = "grayscale(1)";
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, newWidth, newHeight);
        const grayImage = ctx.getImageData(0, 0, newWidth, newHeight).data;
        const uint8Buf = this.#toUint8(grayImage);
        return [
            uint8Buf,
            newWidth,
            newHeight
        ];
    }
    static extractContoursFromText(text, { fontFamily: fontFamily, fontStyle: fontStyle, fontWeight: fontWeight }, pageWidth, pageHeight, rotation, innerMargin) {
        let canvas = new OffscreenCanvas(1, 1);
        let ctx = canvas.getContext("2d", {
            alpha: false
        });
        const fontSize = 200;
        const font = ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
        const { actualBoundingBoxLeft: actualBoundingBoxLeft, actualBoundingBoxRight: actualBoundingBoxRight, actualBoundingBoxAscent: actualBoundingBoxAscent, actualBoundingBoxDescent: actualBoundingBoxDescent, fontBoundingBoxAscent: fontBoundingBoxAscent, fontBoundingBoxDescent: fontBoundingBoxDescent, width: width } = ctx.measureText(text);
        const SCALE = 1.5;
        const canvasWidth = Math.ceil(Math.max(Math.abs(actualBoundingBoxLeft) + Math.abs(actualBoundingBoxRight) || 0, width) * SCALE);
        const canvasHeight = Math.ceil(Math.max(Math.abs(actualBoundingBoxAscent) + Math.abs(actualBoundingBoxDescent) || fontSize, Math.abs(fontBoundingBoxAscent) + Math.abs(fontBoundingBoxDescent) || fontSize) * SCALE);
        canvas = new OffscreenCanvas(canvasWidth, canvasHeight);
        ctx = canvas.getContext("2d", {
            alpha: true,
            willReadFrequently: true
        });
        ctx.font = font;
        ctx.filter = "grayscale(1)";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        ctx.fillStyle = "black";
        ctx.fillText(text, canvasWidth * (SCALE - 1) / 2, canvasHeight * (3 - SCALE) / 2);
        const uint8Buf = this.#toUint8(ctx.getImageData(0, 0, canvasWidth, canvasHeight).data);
        const histogram = this.#getHistogram(uint8Buf);
        const threshold = this.#guessThreshold(histogram);
        const contourList = this.#findContours(uint8Buf, canvasWidth, canvasHeight, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: canvasWidth,
                height: canvasHeight
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    }
    static process(bitmap, pageWidth, pageHeight, rotation, innerMargin) {
        const [uint8Buf, width, height] = this.#getGrayPixels(bitmap);
        const [buffer, histogram] = this.#bilateralFilter(uint8Buf, width, height, Math.hypot(width, height) * this.#PARAMETERS.sigmaSFactor, this.#PARAMETERS.sigmaR, this.#PARAMETERS.kernelSize);
        const threshold = this.#guessThreshold(histogram);
        const contourList = this.#findContours(buffer, width, height, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: width,
                height: height
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    }
    static processDrawnLines({ lines: lines, pageWidth: pageWidth, pageHeight: pageHeight, rotation: rotation, innerMargin: innerMargin, mustSmooth: mustSmooth, areContours: areContours }) {
        if (rotation % 180 !== 0) [pageWidth, pageHeight] = [
            pageHeight,
            pageWidth
        ];
        const { curves: curves, width: width, height: height } = lines;
        const thickness = lines.thickness ?? 0;
        const linesAndPoints = [];
        const ratio = Math.min(pageWidth / width, pageHeight / height);
        const xScale = ratio / pageWidth;
        const yScale = ratio / pageHeight;
        const newCurves = [];
        for (const { points: points } of curves){
            const reducedPoints = mustSmooth ? this.#douglasPeucker(points) : points;
            if (!reducedPoints) continue;
            newCurves.push(reducedPoints);
            const len = reducedPoints.length;
            const newPoints = new Float32Array(len);
            const line = new Float32Array(3 * (len === 2 ? 2 : len - 2));
            linesAndPoints.push({
                line: line,
                points: newPoints
            });
            if (len === 2) {
                newPoints[0] = reducedPoints[0] * xScale;
                newPoints[1] = reducedPoints[1] * yScale;
                line.set([
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    newPoints[0],
                    newPoints[1]
                ], 0);
                continue;
            }
            let [x1, y1, x2, y2] = reducedPoints;
            x1 *= xScale;
            y1 *= yScale;
            x2 *= xScale;
            y2 *= yScale;
            newPoints.set([
                x1,
                y1,
                x2,
                y2
            ], 0);
            line.set([
                NaN,
                NaN,
                NaN,
                NaN,
                x1,
                y1
            ], 0);
            for(let i = 4; i < len; i += 2){
                const x = newPoints[i] = reducedPoints[i] * xScale;
                const y = newPoints[i + 1] = reducedPoints[i + 1] * yScale;
                line.set($a2cc6e1d6eb3861b$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                [x1, y1, x2, y2] = [
                    x2,
                    y2,
                    x,
                    y
                ];
            }
        }
        if (linesAndPoints.length === 0) return null;
        const outline = areContours ? new $a2cc6e1d6eb3861b$var$ContourDrawOutline() : new $a2cc6e1d6eb3861b$var$InkDrawOutline();
        outline.build(linesAndPoints, pageWidth, pageHeight, 1, rotation, areContours ? 0 : thickness, innerMargin);
        return {
            outline: outline,
            newCurves: newCurves,
            areContours: areContours,
            thickness: thickness,
            width: width,
            height: height
        };
    }
    static async compressSignature({ outlines: outlines, areContours: areContours, thickness: thickness, width: width, height: height }) {
        let minDiff = Infinity;
        let maxDiff = -Infinity;
        let outlinesLength = 0;
        for (const points of outlines){
            outlinesLength += points.length;
            for(let i = 2, ii = points.length; i < ii; i++){
                const dx = points[i] - points[i - 2];
                minDiff = Math.min(minDiff, dx);
                maxDiff = Math.max(maxDiff, dx);
            }
        }
        let bufferType;
        if (minDiff >= -128 && maxDiff <= 127) bufferType = Int8Array;
        else if (minDiff >= -32768 && maxDiff <= 32767) bufferType = Int16Array;
        else bufferType = Int32Array;
        const len = outlines.length;
        const headerLength = $a2cc6e1d6eb3861b$var$BASE_HEADER_LENGTH + $a2cc6e1d6eb3861b$var$POINTS_PROPERTIES_NUMBER * len;
        const header = new Uint32Array(headerLength);
        let offset = 0;
        header[offset++] = headerLength * Uint32Array.BYTES_PER_ELEMENT + (outlinesLength - 2 * len) * bufferType.BYTES_PER_ELEMENT;
        header[offset++] = 0;
        header[offset++] = width;
        header[offset++] = height;
        header[offset++] = areContours ? 0 : 1;
        header[offset++] = Math.max(0, Math.floor(thickness ?? 0));
        header[offset++] = len;
        header[offset++] = bufferType.BYTES_PER_ELEMENT;
        for (const points of outlines){
            header[offset++] = points.length - 2;
            header[offset++] = points[0];
            header[offset++] = points[1];
        }
        const cs = new CompressionStream("deflate-raw");
        const writer = cs.writable.getWriter();
        await writer.ready;
        writer.write(header);
        const BufferCtor = bufferType.prototype.constructor;
        for (const points of outlines){
            const diffs = new BufferCtor(points.length - 2);
            for(let i = 2, ii = points.length; i < ii; i++)diffs[i - 2] = points[i] - points[i - 2];
            writer.write(diffs);
        }
        writer.close();
        const bytes = await new Response(cs.readable).bytes();
        return bytes.toBase64();
    }
    static async decompressSignature(signatureData) {
        try {
            const bytes = Uint8Array.fromBase64(signatureData);
            const { readable: readable, writable: writable } = new DecompressionStream("deflate-raw");
            const writer = writable.getWriter();
            await writer.ready;
            writer.write(bytes).then(async ()=>{
                await writer.ready;
                await writer.close();
            }).catch(()=>{});
            let data = null;
            let offset = 0;
            for await (const chunk of readable){
                data ||= new Uint8Array(new Uint32Array(chunk.buffer, 0, 4)[0]);
                data.set(chunk, offset);
                offset += chunk.length;
            }
            const header = new Uint32Array(data.buffer, 0, data.length >> 2);
            const version = header[1];
            if (version !== 0) throw new Error(`Invalid version: ${version}`);
            const width = header[2];
            const height = header[3];
            const areContours = header[4] === 0;
            const thickness = header[5];
            const numberOfDrawings = header[6];
            const bufferType = header[7];
            const outlines = [];
            const diffsOffset = ($a2cc6e1d6eb3861b$var$BASE_HEADER_LENGTH + $a2cc6e1d6eb3861b$var$POINTS_PROPERTIES_NUMBER * numberOfDrawings) * Uint32Array.BYTES_PER_ELEMENT;
            let diffs;
            switch(bufferType){
                case Int8Array.BYTES_PER_ELEMENT:
                    diffs = new Int8Array(data.buffer, diffsOffset);
                    break;
                case Int16Array.BYTES_PER_ELEMENT:
                    diffs = new Int16Array(data.buffer, diffsOffset);
                    break;
                case Int32Array.BYTES_PER_ELEMENT:
                    diffs = new Int32Array(data.buffer, diffsOffset);
                    break;
            }
            offset = 0;
            for(let i = 0; i < numberOfDrawings; i++){
                const len = header[$a2cc6e1d6eb3861b$var$POINTS_PROPERTIES_NUMBER * i + $a2cc6e1d6eb3861b$var$BASE_HEADER_LENGTH];
                const points = new Float32Array(len + 2);
                outlines.push(points);
                for(let j = 0; j < $a2cc6e1d6eb3861b$var$POINTS_PROPERTIES_NUMBER - 1; j++)points[j] = header[$a2cc6e1d6eb3861b$var$POINTS_PROPERTIES_NUMBER * i + $a2cc6e1d6eb3861b$var$BASE_HEADER_LENGTH + j + 1];
                for(let j = 0; j < len; j++)points[j + 2] = points[j] + diffs[offset++];
            }
            return {
                areContours: areContours,
                thickness: thickness,
                outlines: outlines,
                width: width,
                height: height
            };
        } catch (e) {
            $a2cc6e1d6eb3861b$var$warn(`decompressSignature: ${e}`);
            return null;
        }
    }
}
class $a2cc6e1d6eb3861b$var$SignatureOptions extends $a2cc6e1d6eb3861b$var$DrawingOptions {
    constructor(){
        super();
        super.updateProperties({
            fill: $a2cc6e1d6eb3861b$var$AnnotationEditor._defaultLineColor,
            "stroke-width": 0
        });
    }
    clone() {
        const clone = new $a2cc6e1d6eb3861b$var$SignatureOptions();
        clone.updateAll(this);
        return clone;
    }
}
class $a2cc6e1d6eb3861b$var$DrawnSignatureOptions extends $a2cc6e1d6eb3861b$var$InkDrawingOptions {
    constructor(viewerParameters){
        super(viewerParameters);
        super.updateProperties({
            stroke: $a2cc6e1d6eb3861b$var$AnnotationEditor._defaultLineColor,
            "stroke-width": 1
        });
    }
    clone() {
        const clone = new $a2cc6e1d6eb3861b$var$DrawnSignatureOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    }
}
class $a2cc6e1d6eb3861b$var$SignatureEditor extends $a2cc6e1d6eb3861b$var$DrawingEditor {
    #isExtracted = false;
    #description = null;
    #signatureData = null;
    #signatureUUID = null;
    static _type = "signature";
    static _editorType = $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.SIGNATURE;
    static _defaultDrawingOptions = null;
    constructor(params){
        super({
            ...params,
            mustBeCommitted: true,
            name: "signatureEditor"
        });
        this._willKeepAspectRatio = true;
        this.#signatureData = params.signatureData || null;
        this.#description = null;
        this.defaultL10nId = "pdfjs-editor-signature-editor1";
    }
    static initialize(l10n, uiManager) {
        $a2cc6e1d6eb3861b$var$AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new $a2cc6e1d6eb3861b$var$SignatureOptions();
        this._defaultDrawnSignatureOptions = new $a2cc6e1d6eb3861b$var$DrawnSignatureOptions(uiManager.viewParameters);
    }
    static getDefaultDrawingOptions(options) {
        const clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    }
    static get supportMultipleDrawings() {
        return false;
    }
    static get typesMap() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "typesMap", new Map());
    }
    static get isDrawer() {
        return false;
    }
    get telemetryFinalData() {
        return {
            type: "signature",
            hasDescription: !!this.#description
        };
    }
    static computeTelemetryFinalData(data) {
        const hasDescriptionStats = data.get("hasDescription");
        return {
            hasAltText: hasDescriptionStats.get(true) ?? 0,
            hasNoAltText: hasDescriptionStats.get(false) ?? 0
        };
    }
    get isResizable() {
        return true;
    }
    onScaleChanging() {
        if (this._drawId === null) return;
        super.onScaleChanging();
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        const { _isCopy: _isCopy } = this;
        if (_isCopy) {
            this._isCopy = false;
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        if (this._drawId === null) {
            if (this.#signatureData) {
                const { lines: lines, mustSmooth: mustSmooth, areContours: areContours, description: description, uuid: uuid, heightInPage: heightInPage } = this.#signatureData;
                const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
                const outline = $a2cc6e1d6eb3861b$export$cc4fe8633f466b4a.processDrawnLines({
                    lines: lines,
                    pageWidth: pageWidth,
                    pageHeight: pageHeight,
                    rotation: rotation,
                    innerMargin: $a2cc6e1d6eb3861b$var$SignatureEditor._INNER_MARGIN,
                    mustSmooth: mustSmooth,
                    areContours: areContours
                });
                this.addSignature(outline, heightInPage, description, uuid);
            } else {
                this.div.setAttribute("data-l10n-args", JSON.stringify({
                    description: ""
                }));
                this.div.hidden = true;
                this._uiManager.getSignature(this);
            }
        } else this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: this.#description || ""
        }));
        if (_isCopy) {
            this._isCopy = true;
            this._moveAfterPaste(baseX, baseY);
        }
        return this.div;
    }
    setUuid(uuid) {
        this.#signatureUUID = uuid;
        this.addEditToolbar();
    }
    getUuid() {
        return this.#signatureUUID;
    }
    get description() {
        return this.#description;
    }
    set description(description) {
        this.#description = description;
        if (!this.div) return;
        this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: description
        }));
        super.addEditToolbar().then((toolbar)=>{
            toolbar?.updateEditSignatureButton(description);
        });
    }
    getSignaturePreview() {
        const { newCurves: newCurves, areContours: areContours, thickness: thickness, width: width, height: height } = this.#signatureData;
        const maxDim = Math.max(width, height);
        const outlineData = $a2cc6e1d6eb3861b$export$cc4fe8633f466b4a.processDrawnLines({
            lines: {
                curves: newCurves.map((points)=>({
                        points: points
                    })),
                thickness: thickness,
                width: width,
                height: height
            },
            pageWidth: maxDim,
            pageHeight: maxDim,
            rotation: 0,
            innerMargin: 0,
            mustSmooth: false,
            areContours: areContours
        });
        return {
            areContours: areContours,
            outline: outlineData.outline
        };
    }
    get toolbarButtons() {
        if (this._uiManager.signatureManager) return [
            [
                "editSignature",
                this._uiManager.signatureManager
            ]
        ];
        return super.toolbarButtons;
    }
    addSignature(data, heightInPage, description, uuid) {
        const { x: savedX, y: savedY } = this;
        const { outline: outline } = this.#signatureData = data;
        this.#isExtracted = outline instanceof $a2cc6e1d6eb3861b$var$ContourDrawOutline;
        this.description = description;
        let drawingOptions;
        if (this.#isExtracted) drawingOptions = $a2cc6e1d6eb3861b$var$SignatureEditor.getDefaultDrawingOptions();
        else {
            drawingOptions = $a2cc6e1d6eb3861b$var$SignatureEditor._defaultDrawnSignatureOptions.clone();
            drawingOptions.updateProperties({
                "stroke-width": outline.thickness
            });
        }
        this._addOutlines({
            drawOutlines: outline,
            drawingOptions: drawingOptions
        });
        const [, pageHeight] = this.pageDimensions;
        let newHeight = heightInPage / pageHeight;
        newHeight = newHeight >= 1 ? 0.5 : newHeight;
        this.width *= newHeight / this.height;
        if (this.width >= 1) {
            newHeight *= 0.9 / this.width;
            this.width = 0.9;
        }
        this.height = newHeight;
        this.setDims();
        this.x = savedX;
        this.y = savedY;
        this.center();
        this._onResized();
        this.onScaleChanging();
        this.rotate();
        this._uiManager.addToAnnotationStorage(this);
        this.setUuid(uuid);
        this._reportTelemetry({
            action: "pdfjs.signature.inserted",
            data: {
                hasBeenSaved: !!uuid,
                hasDescription: !!description
            }
        });
        this.div.hidden = false;
    }
    getFromImage(bitmap) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $a2cc6e1d6eb3861b$export$cc4fe8633f466b4a.process(bitmap, pageWidth, pageHeight, rotation, $a2cc6e1d6eb3861b$var$SignatureEditor._INNER_MARGIN);
    }
    getFromText(text, fontInfo) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $a2cc6e1d6eb3861b$export$cc4fe8633f466b4a.extractContoursFromText(text, fontInfo, pageWidth, pageHeight, rotation, $a2cc6e1d6eb3861b$var$SignatureEditor._INNER_MARGIN);
    }
    getDrawnSignature(curves) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $a2cc6e1d6eb3861b$export$cc4fe8633f466b4a.processDrawnLines({
            lines: curves,
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: $a2cc6e1d6eb3861b$var$SignatureEditor._INNER_MARGIN,
            mustSmooth: false,
            areContours: false
        });
    }
    createDrawingOptions({ areContours: areContours, thickness: thickness }) {
        if (areContours) this._drawingOptions = $a2cc6e1d6eb3861b$var$SignatureEditor.getDefaultDrawingOptions();
        else {
            this._drawingOptions = $a2cc6e1d6eb3861b$var$SignatureEditor._defaultDrawnSignatureOptions.clone();
            this._drawingOptions.updateProperties({
                "stroke-width": thickness
            });
        }
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        const { lines: lines, points: points } = this.serializeDraw(isForCopying);
        const { _drawingOptions: { "stroke-width": thickness } } = this;
        const serialized = Object.assign(super.serialize(isForCopying), {
            isSignature: true,
            areContours: this.#isExtracted,
            color: [
                0,
                0,
                0
            ],
            thickness: this.#isExtracted ? 0 : thickness
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.paths = {
                lines: lines,
                points: points
            };
            serialized.uuid = this.#signatureUUID;
            serialized.isCopy = true;
        } else serialized.lines = lines;
        if (this.#description) serialized.accessibilityData = {
            type: "Figure",
            alt: this.#description
        };
        return serialized;
    }
    static deserializeDraw(pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        if (data.areContours) return $a2cc6e1d6eb3861b$var$ContourDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
        return $a2cc6e1d6eb3861b$var$InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    }
    static async deserialize(data, parent, uiManager) {
        const editor = await super.deserialize(data, parent, uiManager);
        editor.#isExtracted = data.areContours;
        editor.description = data.accessibilityData?.alt || "";
        editor.#signatureUUID = data.uuid;
        return editor;
    }
}
class $a2cc6e1d6eb3861b$var$StampEditor extends $a2cc6e1d6eb3861b$var$AnnotationEditor {
    #bitmap = null;
    #bitmapId = null;
    #bitmapPromise = null;
    #bitmapUrl = null;
    #bitmapFile = null;
    #bitmapFileName = "";
    #canvas = null;
    #missingCanvas = false;
    #resizeTimeoutId = null;
    #isSvg = false;
    #hasBeenAddedInUndoStack = false;
    static _type = "stamp";
    static _editorType = $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.STAMP;
    constructor(params){
        super({
            ...params,
            name: "stampEditor"
        });
        this.#bitmapUrl = params.bitmapUrl;
        this.#bitmapFile = params.bitmapFile;
        this.defaultL10nId = "pdfjs-editor-stamp-editor";
    }
    static initialize(l10n, uiManager) {
        $a2cc6e1d6eb3861b$var$AnnotationEditor.initialize(l10n, uiManager);
    }
    static isHandlingMimeForPasting(mime) {
        return $a2cc6e1d6eb3861b$export$3234c88e9de64a88.includes(mime);
    }
    static paste(item, parent) {
        parent.pasteEditor({
            mode: $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.STAMP
        }, {
            bitmapFile: item.getAsFile()
        });
    }
    altTextFinish() {
        if (this._uiManager.useNewAltTextFlow) this.div.hidden = false;
        super.altTextFinish();
    }
    get telemetryFinalData() {
        return {
            type: "stamp",
            hasAltText: !!this.altTextData?.altText
        };
    }
    static computeTelemetryFinalData(data) {
        const hasAltTextStats = data.get("hasAltText");
        return {
            hasAltText: hasAltTextStats.get(true) ?? 0,
            hasNoAltText: hasAltTextStats.get(false) ?? 0
        };
    }
    #getBitmapFetched(data, fromId = false) {
        if (!data) {
            this.remove();
            return;
        }
        this.#bitmap = data.bitmap;
        if (!fromId) {
            this.#bitmapId = data.id;
            this.#isSvg = data.isSvg;
        }
        if (data.file) this.#bitmapFileName = data.file.name;
        this.#createCanvas();
    }
    #getBitmapDone() {
        this.#bitmapPromise = null;
        this._uiManager.enableWaiting(false);
        if (!this.#canvas) return;
        if (this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.#bitmap) {
            this.addEditToolbar().then(()=>{
                this._editToolbar.hide();
                this._uiManager.editAltText(this, true);
            });
            return;
        }
        if (!this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.#bitmap) {
            this._reportTelemetry({
                action: "pdfjs.image.image_added",
                data: {
                    alt_text_modal: false,
                    alt_text_type: "empty"
                }
            });
            try {
                this.mlGuessAltText();
            } catch  {}
        }
        this.div.focus();
    }
    async mlGuessAltText(imageData = null, updateAltTextData = true) {
        if (this.hasAltTextData()) return null;
        const { mlManager: mlManager } = this._uiManager;
        if (!mlManager) throw new Error("No ML.");
        if (!await mlManager.isEnabledFor("altText")) throw new Error("ML isn't enabled for alt text.");
        const { data: data, width: width, height: height } = imageData || this.copyCanvas(null, null, true).imageData;
        const response = await mlManager.guess({
            name: "altText",
            request: {
                data: data,
                width: width,
                height: height,
                channels: data.length / (width * height)
            }
        });
        if (!response) throw new Error("No response from the AI service.");
        if (response.error) throw new Error("Error from the AI service.");
        if (response.cancel) return null;
        if (!response.output) throw new Error("No valid response from the AI service.");
        const altText = response.output;
        await this.setGuessedAltText(altText);
        if (updateAltTextData && !this.hasAltTextData()) this.altTextData = {
            alt: altText,
            decorative: false
        };
        return altText;
    }
    #getBitmap() {
        if (this.#bitmapId) {
            this._uiManager.enableWaiting(true);
            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapUrl) {
            const url = this.#bitmapUrl;
            this.#bitmapUrl = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapFile) {
            const file = this.#bitmapFile;
            this.#bitmapFile = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        const input = document.createElement("input");
        input.type = "file";
        input.accept = $a2cc6e1d6eb3861b$export$3234c88e9de64a88.join(",");
        const signal = this._uiManager._signal;
        this.#bitmapPromise = new Promise((resolve)=>{
            input.addEventListener("change", async ()=>{
                if (!input.files || input.files.length === 0) this.remove();
                else {
                    this._uiManager.enableWaiting(true);
                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                    this._reportTelemetry({
                        action: "pdfjs.image.image_selected",
                        data: {
                            alt_text_modal: this._uiManager.useNewAltTextFlow
                        }
                    });
                    this.#getBitmapFetched(data);
                }
                resolve();
            }, {
                signal: signal
            });
            input.addEventListener("cancel", ()=>{
                this.remove();
                resolve();
            }, {
                signal: signal
            });
        }).finally(()=>this.#getBitmapDone());
        input.click();
    }
    remove() {
        if (this.#bitmapId) {
            this.#bitmap = null;
            this._uiManager.imageManager.deleteId(this.#bitmapId);
            this.#canvas?.remove();
            this.#canvas = null;
            if (this.#resizeTimeoutId) {
                clearTimeout(this.#resizeTimeoutId);
                this.#resizeTimeoutId = null;
            }
        }
        super.remove();
    }
    rebuild() {
        if (!this.parent) {
            if (this.#bitmapId) this.#getBitmap();
            return;
        }
        super.rebuild();
        if (this.div === null) return;
        if (this.#bitmapId && this.#canvas === null) this.#getBitmap();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    onceAdded(focus) {
        this._isDraggable = true;
        if (focus) this.div.focus();
    }
    isEmpty() {
        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile || this.#bitmapId || this.#missingCanvas);
    }
    get toolbarButtons() {
        return [
            [
                "altText",
                this.createAltText()
            ]
        ];
    }
    get isResizable() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.div.hidden = true;
        this.createAltText();
        if (!this.#missingCanvas) {
            if (this.#bitmap) this.#createCanvas();
            else this.#getBitmap();
        }
        if (this._isCopy) this._moveAfterPaste(baseX, baseY);
        this._uiManager.addShouldRescale(this);
        return this.div;
    }
    setCanvas(annotationElementId, canvas) {
        const { id: bitmapId, bitmap: bitmap } = this._uiManager.imageManager.getFromCanvas(annotationElementId, canvas);
        canvas.remove();
        if (bitmapId && this._uiManager.imageManager.isValidId(bitmapId)) {
            this.#bitmapId = bitmapId;
            if (bitmap) this.#bitmap = bitmap;
            this.#missingCanvas = false;
            this.#createCanvas();
        }
    }
    _onResized() {
        this.onScaleChanging();
    }
    onScaleChanging() {
        if (!this.parent) return;
        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
        const TIME_TO_WAIT = 200;
        this.#resizeTimeoutId = setTimeout(()=>{
            this.#resizeTimeoutId = null;
            this.#drawBitmap();
        }, TIME_TO_WAIT);
    }
    #createCanvas() {
        const { div: div } = this;
        let { width: width, height: height } = this.#bitmap;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const MAX_RATIO = 0.75;
        if (this.width) {
            width = this.width * pageWidth;
            height = this.height * pageHeight;
        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
            width *= factor;
            height *= factor;
        }
        this._uiManager.enableWaiting(false);
        const canvas = this.#canvas = document.createElement("canvas");
        canvas.setAttribute("role", "img");
        this.addContainer(canvas);
        this.width = width / pageWidth;
        this.height = height / pageHeight;
        this.setDims();
        if (this._initialOptions?.isCentered) this.center();
        else this.fixAndSetPosition();
        this._initialOptions = null;
        if (!this._uiManager.useNewAltTextWhenAddingImage || !this._uiManager.useNewAltTextFlow || this.annotationElementId) div.hidden = false;
        this.#drawBitmap();
        if (!this.#hasBeenAddedInUndoStack) {
            this.parent.addUndoableEditor(this);
            this.#hasBeenAddedInUndoStack = true;
        }
        this._reportTelemetry({
            action: "inserted_image"
        });
        if (this.#bitmapFileName) this.div.setAttribute("aria-description", this.#bitmapFileName);
        if (!this.annotationElementId) this._uiManager.a11yAlert($a2cc6e1d6eb3861b$var$AnnotationEditor._l10nAlert.stamp);
    }
    copyCanvas(maxDataDimension, maxPreviewDimension, createImageData = false) {
        if (!maxDataDimension) maxDataDimension = 224;
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        const outputScale = new $a2cc6e1d6eb3861b$export$f16a99f63bccd50b();
        let bitmap = this.#bitmap;
        let width = bitmapWidth, height = bitmapHeight;
        let canvas = null;
        if (maxPreviewDimension) {
            if (bitmapWidth > maxPreviewDimension || bitmapHeight > maxPreviewDimension) {
                const ratio = Math.min(maxPreviewDimension / bitmapWidth, maxPreviewDimension / bitmapHeight);
                width = Math.floor(bitmapWidth * ratio);
                height = Math.floor(bitmapHeight * ratio);
            }
            canvas = document.createElement("canvas");
            const scaledWidth = canvas.width = Math.ceil(width * outputScale.sx);
            const scaledHeight = canvas.height = Math.ceil(height * outputScale.sy);
            if (!this.#isSvg) bitmap = this.#scaleBitmap(scaledWidth, scaledHeight);
            const ctx = canvas.getContext("2d");
            ctx.filter = this._uiManager.hcmFilter;
            let white = "white", black = "#cfcfd8";
            if (this._uiManager.hcmFilter !== "none") black = "black";
            else if ($a2cc6e1d6eb3861b$var$ColorScheme.isDarkMode) {
                white = "#8f8f9d";
                black = "#42414d";
            }
            const boxDim = 15;
            const boxDimWidth = boxDim * outputScale.sx;
            const boxDimHeight = boxDim * outputScale.sy;
            const pattern = new OffscreenCanvas(boxDimWidth * 2, boxDimHeight * 2);
            const patternCtx = pattern.getContext("2d");
            patternCtx.fillStyle = white;
            patternCtx.fillRect(0, 0, boxDimWidth * 2, boxDimHeight * 2);
            patternCtx.fillStyle = black;
            patternCtx.fillRect(0, 0, boxDimWidth, boxDimHeight);
            patternCtx.fillRect(boxDimWidth, boxDimHeight, boxDimWidth, boxDimHeight);
            ctx.fillStyle = ctx.createPattern(pattern, "repeat");
            ctx.fillRect(0, 0, scaledWidth, scaledHeight);
            ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
        }
        let imageData = null;
        if (createImageData) {
            let dataWidth, dataHeight;
            if (outputScale.symmetric && bitmap.width < maxDataDimension && bitmap.height < maxDataDimension) {
                dataWidth = bitmap.width;
                dataHeight = bitmap.height;
            } else {
                bitmap = this.#bitmap;
                if (bitmapWidth > maxDataDimension || bitmapHeight > maxDataDimension) {
                    const ratio = Math.min(maxDataDimension / bitmapWidth, maxDataDimension / bitmapHeight);
                    dataWidth = Math.floor(bitmapWidth * ratio);
                    dataHeight = Math.floor(bitmapHeight * ratio);
                    if (!this.#isSvg) bitmap = this.#scaleBitmap(dataWidth, dataHeight);
                }
            }
            const offscreen = new OffscreenCanvas(dataWidth, dataHeight);
            const offscreenCtx = offscreen.getContext("2d", {
                willReadFrequently: true
            });
            offscreenCtx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, dataWidth, dataHeight);
            imageData = {
                width: dataWidth,
                height: dataHeight,
                data: offscreenCtx.getImageData(0, 0, dataWidth, dataHeight).data
            };
        }
        return {
            canvas: canvas,
            width: width,
            height: height,
            imageData: imageData
        };
    }
    #scaleBitmap(width, height) {
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        let newWidth = bitmapWidth;
        let newHeight = bitmapHeight;
        let bitmap = this.#bitmap;
        while(newWidth > 2 * width || newHeight > 2 * height){
            const prevWidth = newWidth;
            const prevHeight = newHeight;
            if (newWidth > 2 * width) newWidth = Math.ceil(newWidth / 2);
            if (newHeight > 2 * height) newHeight = Math.ceil(newHeight / 2);
            const offscreen = new OffscreenCanvas(newWidth, newHeight);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
            bitmap = offscreen.transferToImageBitmap();
        }
        return bitmap;
    }
    #drawBitmap() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { width: width, height: height } = this;
        const outputScale = new $a2cc6e1d6eb3861b$export$f16a99f63bccd50b();
        const scaledWidth = Math.ceil(width * parentWidth * outputScale.sx);
        const scaledHeight = Math.ceil(height * parentHeight * outputScale.sy);
        const canvas = this.#canvas;
        if (!canvas || canvas.width === scaledWidth && canvas.height === scaledHeight) return;
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(scaledWidth, scaledHeight);
        const ctx = canvas.getContext("2d");
        ctx.filter = this._uiManager.hcmFilter;
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
    }
    #serializeBitmap(toUrl) {
        if (toUrl) {
            if (this.#isSvg) {
                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                if (url) return url;
            }
            const canvas = document.createElement("canvas");
            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
            const ctx = canvas.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0);
            return canvas.toDataURL();
        }
        if (this.#isSvg) {
            const [pageWidth, pageHeight] = this.pageDimensions;
            const width = Math.round(this.width * pageWidth * $a2cc6e1d6eb3861b$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
            const height = Math.round(this.height * pageHeight * $a2cc6e1d6eb3861b$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
            const offscreen = new OffscreenCanvas(width, height);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
            return offscreen.transferToImageBitmap();
        }
        return structuredClone(this.#bitmap);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        let missingCanvas = false;
        if (data instanceof $a2cc6e1d6eb3861b$var$StampAnnotationElement) {
            const { data: { rect: rect, rotation: rotation, id: id, structParent: structParent, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, container: container, parent: { page: { pageNumber: pageNumber } }, canvas: canvas } = data;
            let bitmapId, bitmap;
            if (canvas) {
                delete data.canvas;
                ({ id: bitmapId, bitmap: bitmap } = uiManager.imageManager.getFromCanvas(container.id, canvas));
                canvas.remove();
            } else {
                missingCanvas = true;
                data._hasNoCanvas = true;
            }
            const altText = (await parent._structTree.getAriaAttributes(`${$a2cc6e1d6eb3861b$var$AnnotationPrefix}${id}`))?.get("aria-label") || "";
            initialData = data = {
                annotationType: $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.STAMP,
                bitmapId: bitmapId,
                bitmap: bitmap,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                accessibilityData: {
                    decorative: false,
                    altText: altText
                },
                isSvg: false,
                structParent: structParent,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        const { rect: rect, bitmap: bitmap, bitmapUrl: bitmapUrl, bitmapId: bitmapId, isSvg: isSvg, accessibilityData: accessibilityData } = data;
        if (missingCanvas) {
            uiManager.addMissingCanvas(data.id, editor);
            editor.#missingCanvas = true;
        } else if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) {
            editor.#bitmapId = bitmapId;
            if (bitmap) editor.#bitmap = bitmap;
        } else editor.#bitmapUrl = bitmapUrl;
        editor.#isSvg = isSvg;
        const [parentWidth, parentHeight] = editor.pageDimensions;
        editor.width = (rect[2] - rect[0]) / parentWidth;
        editor.height = (rect[3] - rect[1]) / parentHeight;
        if (accessibilityData) editor.altTextData = accessibilityData;
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        editor.#hasBeenAddedInUndoStack = !!initialData;
        return editor;
    }
    serialize(isForCopying = false, context = null) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const serialized = Object.assign(super.serialize(isForCopying), {
            bitmapId: this.#bitmapId,
            isSvg: this.#isSvg
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.bitmapUrl = this.#serializeBitmap(true);
            serialized.accessibilityData = this.serializeAltText(true);
            serialized.isCopy = true;
            return serialized;
        }
        const { decorative: decorative, altText: altText } = this.serializeAltText(false);
        if (!decorative && altText) serialized.accessibilityData = {
            type: "Figure",
            alt: altText
        };
        if (this.annotationElementId) {
            const changes = this.#hasElementChanged(serialized);
            if (changes.isSame) return null;
            if (changes.isSameAltText) delete serialized.accessibilityData;
            else serialized.accessibilityData.structParent = this._initialData.structParent ?? -1;
            serialized.id = this.annotationElementId;
            delete serialized.bitmapId;
            return serialized;
        }
        if (context === null) return serialized;
        context.stamps ||= new Map();
        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
        if (!context.stamps.has(this.#bitmapId)) {
            context.stamps.set(this.#bitmapId, {
                area: area,
                serialized: serialized
            });
            serialized.bitmap = this.#serializeBitmap(false);
        } else if (this.#isSvg) {
            const prevData = context.stamps.get(this.#bitmapId);
            if (area > prevData.area) {
                prevData.area = area;
                prevData.serialized.bitmap.close();
                prevData.serialized.bitmap = this.#serializeBitmap(false);
            }
        }
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { pageIndex: pageIndex, accessibilityData: { altText: altText } } = this._initialData;
        const isSamePageIndex = serialized.pageIndex === pageIndex;
        const isSameAltText = (serialized.accessibilityData?.alt || "") === altText;
        return {
            isSame: !this.hasEditedComment && !this._hasBeenMoved && !this._hasBeenResized && isSamePageIndex && isSameAltText,
            isSameAltText: isSameAltText
        };
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
        return null;
    }
}
class $a2cc6e1d6eb3861b$export$47948c9fe1adbf1b {
    #accessibilityManager;
    #allowClick = false;
    #annotationLayer = null;
    #clickAC = null;
    #editorFocusTimeoutId = null;
    #editors = new Map();
    #hadPointerDown = false;
    #isDisabling = false;
    #isEnabling = false;
    #drawingAC = null;
    #focusedElement = null;
    #textLayer = null;
    #textSelectionAC = null;
    #textLayerDblClickAC = null;
    #lastPointerDownTimestamp = -1;
    #uiManager;
    static _initialized = false;
    static #editorTypes = new Map([
        $a2cc6e1d6eb3861b$var$FreeTextEditor,
        $a2cc6e1d6eb3861b$var$InkEditor,
        $a2cc6e1d6eb3861b$var$StampEditor,
        $a2cc6e1d6eb3861b$var$HighlightEditor,
        $a2cc6e1d6eb3861b$var$SignatureEditor
    ].map((type)=>[
            type._editorType,
            type
        ]));
    constructor({ uiManager: uiManager, pageIndex: pageIndex, div: div, structTreeLayer: structTreeLayer, accessibilityManager: accessibilityManager, annotationLayer: annotationLayer, drawLayer: drawLayer, textLayer: textLayer, viewport: viewport, l10n: l10n }){
        const editorTypes = [
            ...$a2cc6e1d6eb3861b$export$47948c9fe1adbf1b.#editorTypes.values()
        ];
        if (!$a2cc6e1d6eb3861b$export$47948c9fe1adbf1b._initialized) {
            $a2cc6e1d6eb3861b$export$47948c9fe1adbf1b._initialized = true;
            for (const editorType of editorTypes)editorType.initialize(l10n, uiManager);
        }
        uiManager.registerEditorTypes(editorTypes);
        this.#uiManager = uiManager;
        this.pageIndex = pageIndex;
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationLayer = annotationLayer;
        this.viewport = viewport;
        this.#textLayer = textLayer;
        this.drawLayer = drawLayer;
        this._structTree = structTreeLayer;
        this.#uiManager.addLayer(this);
    }
    get isEmpty() {
        return this.#editors.size === 0;
    }
    get isInvisible() {
        return this.isEmpty && this.#uiManager.getMode() === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE;
    }
    updateToolbar(options) {
        this.#uiManager.updateToolbar(options);
    }
    updateMode(mode = this.#uiManager.getMode()) {
        this.#cleanup();
        switch(mode){
            case $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.NONE:
                this.div.classList.toggle("nonEditing", true);
                this.disableTextSelection();
                this.togglePointerEvents(false);
                this.toggleAnnotationLayerPointerEvents(true);
                this.disableClick();
                return;
            case $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.INK:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
                break;
            case $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT:
                this.enableTextSelection();
                this.togglePointerEvents(false);
                this.disableClick();
                break;
            default:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
        }
        this.toggleAnnotationLayerPointerEvents(false);
        const { classList: classList } = this.div;
        classList.toggle("nonEditing", false);
        if (mode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.POPUP) classList.toggle("commentEditing", true);
        else {
            classList.toggle("commentEditing", false);
            for (const editorType of $a2cc6e1d6eb3861b$export$47948c9fe1adbf1b.#editorTypes.values())classList.toggle(`${editorType._type}Editing`, mode === editorType._editorType);
        }
        this.div.hidden = false;
    }
    hasTextLayer(textLayer) {
        return textLayer === this.#textLayer?.div;
    }
    setEditingState(isEditing) {
        this.#uiManager.setEditingState(isEditing);
    }
    addCommands(params) {
        this.#uiManager.addCommands(params);
    }
    cleanUndoStack(type) {
        this.#uiManager.cleanUndoStack(type);
    }
    toggleDrawing(enabled = false) {
        this.div.classList.toggle("drawing", !enabled);
    }
    togglePointerEvents(enabled = false) {
        this.div.classList.toggle("disabled", !enabled);
    }
    toggleAnnotationLayerPointerEvents(enabled = false) {
        this.#annotationLayer?.togglePointerEvents(enabled);
    }
    get #allEditorsIterator() {
        return this.#editors.size !== 0 ? this.#editors.values() : this.#uiManager.getEditors(this.pageIndex);
    }
    async enable() {
        this.#isEnabling = true;
        this.div.tabIndex = 0;
        this.togglePointerEvents(true);
        this.div.classList.toggle("nonEditing", false);
        this.#textLayerDblClickAC?.abort();
        this.#textLayerDblClickAC = null;
        const annotationElementIds = new Set();
        for (const editor of this.#allEditorsIterator){
            editor.enableEditing();
            editor.show(true);
            if (editor.annotationElementId) {
                this.#uiManager.removeChangedExistingAnnotation(editor);
                annotationElementIds.add(editor.annotationElementId);
            }
        }
        const annotationLayer = this.#annotationLayer;
        if (annotationLayer) for (const editable of annotationLayer.getEditableAnnotations()){
            editable.hide();
            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
            if (annotationElementIds.has(editable.data.id)) continue;
            const editor = await this.deserialize(editable);
            if (!editor) continue;
            this.addOrRebuild(editor);
            editor.enableEditing();
        }
        this.#isEnabling = false;
        this.#uiManager._eventBus.dispatch("editorsrendered", {
            source: this,
            pageNumber: this.pageIndex + 1
        });
    }
    disable() {
        this.#isDisabling = true;
        this.div.tabIndex = -1;
        this.togglePointerEvents(false);
        this.div.classList.toggle("nonEditing", true);
        if (this.#textLayer && !this.#textLayerDblClickAC) {
            this.#textLayerDblClickAC = new AbortController();
            const signal = this.#uiManager.combinedSignal(this.#textLayerDblClickAC);
            this.#textLayer.div.addEventListener("pointerdown", (e)=>{
                const DBL_CLICK_THRESHOLD = 500;
                const { clientX: clientX, clientY: clientY, timeStamp: timeStamp } = e;
                const lastPointerDownTimestamp = this.#lastPointerDownTimestamp;
                if (timeStamp - lastPointerDownTimestamp > DBL_CLICK_THRESHOLD) {
                    this.#lastPointerDownTimestamp = timeStamp;
                    return;
                }
                this.#lastPointerDownTimestamp = -1;
                const { classList: classList } = this.div;
                classList.toggle("getElements", true);
                const elements = document.elementsFromPoint(clientX, clientY);
                classList.toggle("getElements", false);
                if (!this.div.contains(elements[0])) return;
                let id;
                const regex = new RegExp(`^${$a2cc6e1d6eb3861b$var$AnnotationEditorPrefix}[0-9]+$`);
                for (const element of elements)if (regex.test(element.id)) {
                    id = element.id;
                    break;
                }
                if (!id) return;
                const editor = this.#editors.get(id);
                if (editor?.annotationElementId === null) {
                    $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050(e);
                    editor.dblclick(e);
                }
            }, {
                signal: signal,
                capture: true
            });
        }
        const annotationLayer = this.#annotationLayer;
        const needFakeAnnotation = [];
        if (annotationLayer) {
            const changedAnnotations = new Map();
            const resetAnnotations = new Map();
            for (const editor of this.#allEditorsIterator){
                editor.disableEditing();
                if (!editor.annotationElementId) {
                    needFakeAnnotation.push(editor);
                    continue;
                }
                if (editor.serialize() !== null) {
                    changedAnnotations.set(editor.annotationElementId, editor);
                    continue;
                } else resetAnnotations.set(editor.annotationElementId, editor);
                this.getEditableAnnotation(editor.annotationElementId)?.show();
                editor.remove();
            }
            for (const editable of annotationLayer.getEditableAnnotations()){
                const { id: id } = editable.data;
                if (this.#uiManager.isDeletedAnnotationElement(id)) {
                    editable.updateEdited({
                        deleted: true
                    });
                    continue;
                }
                let editor = resetAnnotations.get(id);
                if (editor) {
                    editor.resetAnnotationElement(editable);
                    editor.show(false);
                    editable.show();
                    continue;
                }
                editor = changedAnnotations.get(id);
                if (editor) {
                    this.#uiManager.addChangedExistingAnnotation(editor);
                    if (editor.renderAnnotationElement(editable)) editor.show(false);
                }
                editable.show();
            }
        }
        this.#cleanup();
        if (this.isEmpty) this.div.hidden = true;
        const { classList: classList } = this.div;
        for (const editorType of $a2cc6e1d6eb3861b$export$47948c9fe1adbf1b.#editorTypes.values())classList.remove(`${editorType._type}Editing`);
        this.disableTextSelection();
        this.toggleAnnotationLayerPointerEvents(true);
        annotationLayer?.updateFakeAnnotations(needFakeAnnotation);
        this.#isDisabling = false;
    }
    getEditableAnnotation(id) {
        return this.#annotationLayer?.getEditableAnnotation(id) || null;
    }
    setActiveEditor(editor) {
        const currentActive = this.#uiManager.getActive();
        if (currentActive === editor) return;
        this.#uiManager.setActiveEditor(editor);
    }
    enableTextSelection() {
        this.div.tabIndex = -1;
        if (this.#textLayer?.div && !this.#textSelectionAC) {
            this.#textSelectionAC = new AbortController();
            const signal = this.#uiManager.combinedSignal(this.#textSelectionAC);
            this.#textLayer.div.addEventListener("pointerdown", this.#textLayerPointerDown.bind(this), {
                signal: signal
            });
            this.#textLayer.div.classList.add("highlighting");
        }
    }
    disableTextSelection() {
        this.div.tabIndex = 0;
        if (this.#textLayer?.div && this.#textSelectionAC) {
            this.#textSelectionAC.abort();
            this.#textSelectionAC = null;
            this.#textLayer.div.classList.remove("highlighting");
        }
    }
    #textLayerPointerDown(event) {
        this.#uiManager.unselectAll();
        const { target: target } = event;
        if (target === this.#textLayer.div || (target.getAttribute("role") === "img" || target.classList.contains("endOfContent") || target.classList.contains("textLayerImages") || target.classList.contains("textLayerImagePlaceholder")) && this.#textLayer.div.contains(target)) {
            const { isMac: isMac } = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform;
            if (event.button !== 0 || event.ctrlKey && isMac) return;
            this.#uiManager.showAllEditors("highlight", true, true);
            this.#textLayer.div.classList.add("free");
            this.toggleDrawing();
            $a2cc6e1d6eb3861b$var$HighlightEditor.startHighlighting(this, this.#uiManager.direction === "ltr", {
                target: this.#textLayer.div,
                x: event.x,
                y: event.y
            });
            this.#textLayer.div.addEventListener("pointerup", ()=>{
                this.#textLayer.div.classList.remove("free");
                this.toggleDrawing(true);
            }, {
                once: true,
                signal: this.#uiManager._signal
            });
            event.preventDefault();
        }
    }
    enableClick() {
        if (this.#clickAC) return;
        this.#clickAC = new AbortController();
        const signal = this.#uiManager.combinedSignal(this.#clickAC);
        this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
            signal: signal
        });
        const pointerup = this.pointerup.bind(this);
        this.div.addEventListener("pointerup", pointerup, {
            signal: signal
        });
        this.div.addEventListener("pointercancel", pointerup, {
            signal: signal
        });
    }
    disableClick() {
        this.#clickAC?.abort();
        this.#clickAC = null;
    }
    attach(editor) {
        this.#editors.set(editor.id, editor);
        const { annotationElementId: annotationElementId } = editor;
        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
    }
    detach(editor) {
        this.#editors.delete(editor.id);
        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
    }
    remove(editor) {
        this.detach(editor);
        this.#uiManager.removeEditor(editor);
        editor.div.remove();
        editor.isAttachedToDOM = false;
    }
    changeParent(editor) {
        if (editor.parent === this) return;
        if (editor.parent && editor.annotationElementId) {
            this.#uiManager.addDeletedAnnotationElement(editor);
            $a2cc6e1d6eb3861b$var$AnnotationEditor.deleteAnnotationElement(editor);
            editor.annotationElementId = null;
        }
        this.attach(editor);
        editor.parent?.detach(editor);
        editor.setParent(this);
        if (editor.div && editor.isAttachedToDOM) {
            editor.div.remove();
            this.div.append(editor.div);
        }
    }
    add(editor) {
        if (editor.parent === this && editor.isAttachedToDOM) return;
        this.changeParent(editor);
        this.#uiManager.addEditor(editor);
        this.attach(editor);
        if (!editor.isAttachedToDOM) {
            const div = editor.render();
            this.div.append(div);
            editor.isAttachedToDOM = true;
        }
        editor.fixAndSetPosition();
        editor.onceAdded(!this.#isEnabling);
        this.#uiManager.addToAnnotationStorage(editor);
        editor._reportTelemetry(editor.telemetryInitialData);
    }
    moveEditorInDOM(editor) {
        if (!editor.isAttachedToDOM) return;
        const { activeElement: activeElement } = document;
        if (editor.div.contains(activeElement) && !this.#editorFocusTimeoutId) {
            editor._focusEventsAllowed = false;
            this.#editorFocusTimeoutId = setTimeout(()=>{
                this.#editorFocusTimeoutId = null;
                if (!editor.div.contains(document.activeElement)) {
                    editor.div.addEventListener("focusin", ()=>{
                        editor._focusEventsAllowed = true;
                    }, {
                        once: true,
                        signal: this.#uiManager._signal
                    });
                    activeElement.focus();
                } else editor._focusEventsAllowed = true;
            }, 0);
        }
        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
    }
    addOrRebuild(editor) {
        if (editor.needsToBeRebuilt()) {
            editor.parent ||= this;
            editor.rebuild();
            editor.show();
        } else this.add(editor);
    }
    addUndoableEditor(editor) {
        const cmd = ()=>editor._uiManager.rebuild(editor);
        const undo = ()=>{
            editor.remove();
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: false
        });
    }
    getEditorByUID(uid) {
        for (const editor of this.#editors.values()){
            if (editor.uid === uid) return editor;
        }
        return null;
    }
    get #currentEditorType() {
        return $a2cc6e1d6eb3861b$export$47948c9fe1adbf1b.#editorTypes.get(this.#uiManager.getMode());
    }
    combinedSignal(ac) {
        return this.#uiManager.combinedSignal(ac);
    }
    #createNewEditor(params) {
        const editorType = this.#currentEditorType;
        return editorType ? new editorType.prototype.constructor(params) : null;
    }
    canCreateNewEmptyEditor() {
        return this.#currentEditorType?.canCreateNewEmptyEditor();
    }
    async pasteEditor(options, params) {
        this.updateToolbar(options);
        await this.#uiManager.updateMode(options.mode);
        const { offsetX: offsetX, offsetY: offsetY } = this.#getCenterPoint();
        const id = this.#uiManager.getId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: offsetX,
            y: offsetY,
            uiManager: this.#uiManager,
            isCentered: true,
            ...params
        });
        if (editor) this.add(editor);
    }
    async deserialize(data) {
        return await $a2cc6e1d6eb3861b$export$47948c9fe1adbf1b.#editorTypes.get(data.annotationType ?? data.annotationEditorType)?.deserialize(data, this, this.#uiManager) || null;
    }
    createAndAddNewEditor(event, isCentered, data = {}) {
        const id = this.#uiManager.getId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: event.offsetX,
            y: event.offsetY,
            uiManager: this.#uiManager,
            isCentered: isCentered,
            ...data
        });
        if (editor) this.add(editor);
        return editor;
    }
    get boundingClientRect() {
        return this.div.getBoundingClientRect();
    }
    #getCenterPoint() {
        const { x: x, y: y, width: width, height: height } = this.boundingClientRect;
        const tlX = Math.max(0, x);
        const tlY = Math.max(0, y);
        const brX = Math.min(window.innerWidth, x + width);
        const brY = Math.min(window.innerHeight, y + height);
        const centerX = (tlX + brX) / 2 - x;
        const centerY = (tlY + brY) / 2 - y;
        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
            centerX,
            centerY
        ] : [
            centerY,
            centerX
        ];
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    addNewEditor(data = {}) {
        this.createAndAddNewEditor(this.#getCenterPoint(), true, data);
    }
    setSelected(editor) {
        this.#uiManager.setSelected(editor);
    }
    toggleSelected(editor) {
        this.#uiManager.toggleSelected(editor);
    }
    unselect(editor) {
        this.#uiManager.unselect(editor);
    }
    pointerup(event) {
        const { isMac: isMac } = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        if (!this.#hadPointerDown) return;
        this.#hadPointerDown = false;
        if (this.#currentEditorType?.isDrawer && this.#currentEditorType.supportMultipleDrawings) return;
        if (!this.#allowClick) {
            this.#allowClick = true;
            return;
        }
        const currentMode = this.#uiManager.getMode();
        if (currentMode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.STAMP || currentMode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.POPUP || currentMode === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.SIGNATURE) {
            this.#uiManager.unselectAll();
            return;
        }
        this.createAndAddNewEditor(event, false);
    }
    pointerdown(event) {
        if (this.#uiManager.getMode() === $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf.HIGHLIGHT) this.enableTextSelection();
        if (this.#hadPointerDown) {
            this.#hadPointerDown = false;
            return;
        }
        const { isMac: isMac } = $a2cc6e1d6eb3861b$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        this.#hadPointerDown = true;
        if (this.#currentEditorType?.isDrawer) {
            this.startDrawingSession(event);
            return;
        }
        const editor = this.#uiManager.getActive();
        this.#allowClick = !editor || editor.isEmpty();
    }
    startDrawingSession(event) {
        this.div.focus({
            preventScroll: true
        });
        if (this.#drawingAC) {
            this.#currentEditorType.startDrawing(this, this.#uiManager, false, event);
            return;
        }
        this.#uiManager.setCurrentDrawingSession(this);
        this.#drawingAC = new AbortController();
        const signal = this.#uiManager.combinedSignal(this.#drawingAC);
        this.div.addEventListener("blur", ({ relatedTarget: relatedTarget })=>{
            if (relatedTarget && !this.div.contains(relatedTarget)) {
                this.#focusedElement = null;
                this.commitOrRemove();
            }
        }, {
            signal: signal
        });
        this.#currentEditorType.startDrawing(this, this.#uiManager, false, event);
    }
    pause(on) {
        if (on) {
            const { activeElement: activeElement } = document;
            if (this.div.contains(activeElement)) this.#focusedElement = activeElement;
            return;
        }
        if (this.#focusedElement) setTimeout(()=>{
            this.#focusedElement?.focus();
            this.#focusedElement = null;
        }, 0);
    }
    endDrawingSession(isAborted = false) {
        if (!this.#drawingAC) return null;
        this.#uiManager.setCurrentDrawingSession(null);
        this.#drawingAC.abort();
        this.#drawingAC = null;
        this.#focusedElement = null;
        return this.#currentEditorType.endDrawing(isAborted);
    }
    findNewParent(editor, x, y) {
        const layer = this.#uiManager.findParent(x, y);
        if (layer === null || layer === this) return false;
        layer.changeParent(editor);
        return true;
    }
    commitOrRemove() {
        if (this.#drawingAC) {
            this.endDrawingSession();
            return true;
        }
        return false;
    }
    onScaleChanging() {
        if (!this.#drawingAC) return;
        this.#currentEditorType.onScaleChangingWhenDrawing(this);
    }
    destroy() {
        this.commitOrRemove();
        if (this.#uiManager.getActive()?.parent === this) {
            this.#uiManager.commitOrRemove();
            this.#uiManager.setActiveEditor(null);
        }
        if (this.#editorFocusTimeoutId) {
            clearTimeout(this.#editorFocusTimeoutId);
            this.#editorFocusTimeoutId = null;
        }
        for (const editor of this.#editors.values()){
            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
            editor.setParent(null);
            editor.isAttachedToDOM = false;
            editor.div.remove();
        }
        this.div = null;
        this.#editors.clear();
        this.#uiManager.removeLayer(this);
    }
    #cleanup() {
        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
    }
    async render({ viewport: viewport }) {
        this.viewport = viewport;
        $a2cc6e1d6eb3861b$export$af0a15a86e590226(this.div, viewport);
        for (const editor of this.#uiManager.getEditors(this.pageIndex)){
            this.add(editor);
            editor.rebuild();
        }
        await this.#uiManager.findClonesForPage(this);
        this.div.hidden = this.isEmpty;
        this.updateMode();
    }
    update({ viewport: viewport }) {
        this.#uiManager.commitOrRemove();
        this.#cleanup();
        const oldRotation = this.viewport.rotation;
        const rotation = viewport.rotation;
        this.viewport = viewport;
        $a2cc6e1d6eb3861b$export$af0a15a86e590226(this.div, {
            rotation: rotation
        });
        if (oldRotation !== rotation) for (const editor of this.#editors.values())editor.rotate(rotation);
    }
    get pageDimensions() {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.viewport.rawDims;
        return [
            pageWidth,
            pageHeight
        ];
    }
    get scale() {
        return this.#uiManager.viewParameters.realScale;
    }
}
function $a2cc6e1d6eb3861b$var$compareTextLayers(a, b) {
    if (a === b) return 0;
    return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
}
function $a2cc6e1d6eb3861b$var$getTextLayer(node) {
    if (!node) return null;
    if (node.nodeType === Node.ELEMENT_NODE) return node.closest(".textLayer");
    return node.parentElement?.closest(".textLayer") || null;
}
function $a2cc6e1d6eb3861b$var$isPointBefore(nodeA, offsetA, nodeB, offsetB) {
    if (nodeA === nodeB) return offsetA <= offsetB;
    const relation = nodeA.compareDocumentPosition(nodeB);
    if (relation & Node.DOCUMENT_POSITION_FOLLOWING) return true;
    if (relation & Node.DOCUMENT_POSITION_PRECEDING) return false;
    return null;
}
function $a2cc6e1d6eb3861b$var$normalizeEdgeBoundary(container, offset, textLayer) {
    if (container.nodeType !== Node.ELEMENT_NODE || !container.classList.contains("textLayer") || offset !== container.childNodes.length) return {
        container: container,
        offset: offset
    };
    let lastNode = container.lastChild;
    if (lastNode?.nodeType === Node.ELEMENT_NODE && lastNode.classList.contains("endOfContent")) lastNode = lastNode.previousSibling;
    if (!lastNode || !textLayer.contains(lastNode)) return null;
    if (lastNode.nodeType === Node.TEXT_NODE) return {
        container: lastNode,
        offset: lastNode.textContent.length
    };
    return {
        container: lastNode,
        offset: lastNode.childNodes.length
    };
}
class $a2cc6e1d6eb3861b$export$3eb4521511f02450 {
    #parent = null;
    #mapping = new Map();
    #textLayer = null;
    #filterFactory = null;
    #pageColors = null;
    #textLayerObserver = null;
    #toUpdate = new Map();
    static #id = 0;
    static #selectionId = 0;
    static #selectionChangeAC = null;
    static #selections = new Set();
    static #isSelecting = false;
    static #textLayerSet = new Set();
    static #textLayers = new WeakMap();
    constructor({ filterFactory: filterFactory = null, pageColors: pageColors = null, pageIndex: pageIndex, textLayer: textLayer = null }){
        this.pageIndex = pageIndex;
        this.#filterFactory = filterFactory;
        this.#pageColors = pageColors;
        if (textLayer) {
            const previousData = $a2cc6e1d6eb3861b$export$3eb4521511f02450.#textLayers.get(textLayer);
            if (previousData?.selectionDiv) {
                previousData.selectionDiv.remove();
                $a2cc6e1d6eb3861b$export$3eb4521511f02450.#selections.delete(previousData.selectionDiv);
            }
            $a2cc6e1d6eb3861b$export$3eb4521511f02450.#textLayers.set(textLayer, {
                drawLayer: this
            });
            $a2cc6e1d6eb3861b$export$3eb4521511f02450.#textLayerSet.add(textLayer);
            this.#textLayer = textLayer;
            this.#textLayerObserver = new MutationObserver((records)=>{
                if (!this.#parent || !this.#textLayer?.isConnected || !$a2cc6e1d6eb3861b$export$3eb4521511f02450.#hasSelection()) return;
                for (const { addedNodes: addedNodes } of records){
                    for (const node of addedNodes)if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains("endOfContent")) {
                        $a2cc6e1d6eb3861b$export$3eb4521511f02450.#selectionChange();
                        return;
                    }
                }
            });
            this.#textLayerObserver.observe(textLayer, {
                childList: true
            });
            if ($a2cc6e1d6eb3861b$export$3eb4521511f02450.#selectionChangeAC === null) {
                $a2cc6e1d6eb3861b$export$3eb4521511f02450.#selectionChangeAC = new AbortController();
                const { signal: signal } = $a2cc6e1d6eb3861b$export$3eb4521511f02450.#selectionChangeAC;
                document.addEventListener("selectionchange", $a2cc6e1d6eb3861b$export$3eb4521511f02450.#selectionChange.bind($a2cc6e1d6eb3861b$export$3eb4521511f02450), {
                    signal: signal
                });
                document.addEventListener("pointerdown", ()=>{
                    $a2cc6e1d6eb3861b$export$3eb4521511f02450.#isSelecting = true;
                }, {
                    signal: signal
                });
                document.addEventListener("pointerup", ()=>{
                    $a2cc6e1d6eb3861b$export$3eb4521511f02450.#isSelecting = false;
                }, {
                    signal: signal
                });
                window.addEventListener("blur", ()=>{
                    $a2cc6e1d6eb3861b$export$3eb4521511f02450.#isSelecting = false;
                }, {
                    signal: signal
                });
            }
        }
    }
    setParent(parent) {
        if (!this.#parent) {
            this.#parent = parent;
            if (this.#textLayer?.isConnected && $a2cc6e1d6eb3861b$export$3eb4521511f02450.#hasSelection()) $a2cc6e1d6eb3861b$export$3eb4521511f02450.#selectionChange();
            return;
        }
        if (this.#parent !== parent) {
            if (this.#mapping.size > 0) for (const root of this.#mapping.values()){
                root.remove();
                parent.append(root);
            }
            this.#parent = parent;
        }
    }
    static #cleanupTextLayerSelection(textLayer) {
        const textLayerData = this.#textLayers.get(textLayer);
        if (!textLayerData?.selectionDiv) return;
        textLayerData.selectionDiv.remove();
        this.#selections.delete(textLayerData.selectionDiv);
        textLayerData.selectionDiv = null;
        textLayerData.path = null;
    }
    static #hasSelection() {
        const selection = document.getSelection();
        return !!selection && !selection.isCollapsed;
    }
    static #getOrderedTextLayers() {
        return [
            ...this.#textLayerSet
        ].filter((textLayer)=>textLayer.isConnected).sort($a2cc6e1d6eb3861b$var$compareTextLayers);
    }
    static #selectionChange() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) {
            for (const root of this.#selections)root.remove();
            this.#selections.clear();
            return;
        }
        const rotators = new WeakMap();
        const orderedTextLayers = this.#getOrderedTextLayers();
        const ranges = [];
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            const range = selection.getRangeAt(i);
            if (range.collapsed) continue;
            let { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            let startTextLayer = $a2cc6e1d6eb3861b$var$getTextLayer(startContainer);
            let endTextLayer = $a2cc6e1d6eb3861b$var$getTextLayer(endContainer);
            const startMissing = startTextLayer === null;
            const endMissing = endTextLayer === null;
            if (this.#isSelecting && startMissing !== endMissing) return;
            if (selection.rangeCount === 1) {
                const { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = selection;
                const anchorLayer = $a2cc6e1d6eb3861b$var$getTextLayer(anchorNode);
                const focusLayer = $a2cc6e1d6eb3861b$var$getTextLayer(focusNode);
                const anchorBeforeFocus = $a2cc6e1d6eb3861b$var$isPointBefore(anchorNode, anchorOffset, focusNode, focusOffset);
                if (anchorLayer && focusLayer && anchorBeforeFocus !== null) {
                    if (anchorBeforeFocus) {
                        startContainer = anchorNode;
                        startOffset = anchorOffset;
                        startTextLayer = anchorLayer;
                        endContainer = focusNode;
                        endOffset = focusOffset;
                        endTextLayer = focusLayer;
                    } else {
                        startContainer = focusNode;
                        startOffset = focusOffset;
                        startTextLayer = focusLayer;
                        endContainer = anchorNode;
                        endOffset = anchorOffset;
                        endTextLayer = anchorLayer;
                    }
                }
            }
            const activeTextLayers = orderedTextLayers.filter((textLayer)=>range.intersectsNode(textLayer));
            if (activeTextLayers.length === 0) continue;
            let boundarySubstituted = false;
            if (!startTextLayer) {
                startTextLayer = activeTextLayers[0];
                startContainer = startTextLayer;
                startOffset = 0;
                boundarySubstituted = true;
            }
            if (!endTextLayer) {
                endTextLayer = activeTextLayers.at(-1);
                endContainer = endTextLayer;
                endOffset = endTextLayer.childNodes.length;
                boundarySubstituted = true;
            }
            if (endContainer.nodeType === Node.ELEMENT_NODE) {
                if (endContainer.classList.contains("endOfContent")) {
                    const previousNode = endContainer.previousSibling;
                    if (!previousNode) continue;
                    endContainer = previousNode;
                    endOffset = previousNode.nodeType === Node.TEXT_NODE ? previousNode.textContent.length : previousNode.childNodes.length;
                } else if (endContainer.classList.contains("textLayer") && endContainer.childNodes.length === endOffset) {
                    const normalizedEnd = $a2cc6e1d6eb3861b$var$normalizeEdgeBoundary(endContainer, endOffset, endTextLayer);
                    if (!normalizedEnd) continue;
                    endContainer = normalizedEnd.container;
                    endOffset = normalizedEnd.offset;
                }
            }
            if (startContainer.nodeType === Node.ELEMENT_NODE) {
                const normalizedStart = $a2cc6e1d6eb3861b$var$normalizeEdgeBoundary(startContainer, startOffset, startTextLayer);
                if (!normalizedStart) continue;
                startContainer = normalizedStart.container;
                startOffset = normalizedStart.offset;
            }
            if (startTextLayer === endTextLayer && !boundarySubstituted && activeTextLayers.includes(startTextLayer)) {
                ranges.push([
                    range,
                    startTextLayer
                ]);
                continue;
            }
            for (const textLayer of activeTextLayers){
                const firstNode = textLayer.firstChild;
                if (!firstNode) continue;
                const subRange = document.createRange();
                if (textLayer === startTextLayer) subRange.setStart(startContainer, startOffset);
                else subRange.setStartBefore(firstNode);
                if (textLayer === endTextLayer) subRange.setEnd(endContainer, endOffset);
                else {
                    const lastNode = textLayer.lastChild;
                    if (!lastNode) continue;
                    if (lastNode.nodeType === Node.ELEMENT_NODE && lastNode.classList.contains("endOfContent")) {
                        const lastTextNode = lastNode.previousSibling;
                        if (!lastTextNode) continue;
                        subRange.setEndAfter(lastTextNode);
                    } else subRange.setEndAfter(lastNode);
                }
                if (!subRange.collapsed) ranges.push([
                    subRange,
                    textLayer
                ]);
            }
        }
        const selectedTextLayers = new Set(ranges.map((range)=>range[1]));
        for (const textLayer of this.#textLayerSet)if (!selectedTextLayers.has(textLayer)) this.#cleanupTextLayerSelection(textLayer);
        for (const [range, textLayer] of ranges){
            const textLayerData = $a2cc6e1d6eb3861b$export$3eb4521511f02450.#textLayers.get(textLayer);
            if (!textLayerData) continue;
            let rotator = rotators.get(textLayer);
            if (!rotator) {
                const clientRect = textLayer.getBoundingClientRect();
                rotator = (x, y, w, h)=>({
                        x: (x - clientRect.x) / clientRect.width,
                        y: (y - clientRect.y) / clientRect.height,
                        width: w / clientRect.width,
                        height: h / clientRect.height
                    });
                rotators.set(textLayer, rotator);
            }
            const boxes = [];
            for (let { x: x, y: y, width: width, height: height } of range.getClientRects()){
                if (width === 0 || height === 0) continue;
                ({ x: x, y: y, width: width, height: height } = rotator(x, y, width, height));
                if (width === 1 && height === 1) continue;
                boxes.push(`M${x} ${y} h${width} v${height} h-${width} Z`);
            }
            if (boxes.length === 0) continue;
            const drawLayer = textLayerData.drawLayer;
            let div = textLayerData.selectionDiv;
            let path = textLayerData.path;
            if (!div) {
                const clipPathId = `clip_selection_${$a2cc6e1d6eb3861b$export$3eb4521511f02450.#selectionId++}`;
                div = document.createElement("div");
                div.className = "selection";
                div.style.clipPath = `url(#${clipPathId})`;
                const selectionStyle = drawLayer.#filterFactory?.createSelectionStyle(drawLayer.#pageColors);
                if (selectionStyle) for (const [name, value] of Object.entries(selectionStyle))div.style.setProperty(name, value);
                const svg = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.create(1, 1, true);
                svg.setAttribute("aria-hidden", "true");
                svg.setAttribute("width", "100%");
                svg.setAttribute("height", "100%");
                const clipPath = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("clipPath");
                clipPath.setAttribute("id", clipPathId);
                clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
                path = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("path");
                clipPath.append(path);
                svg.append(clipPath);
                div.append(svg);
                textLayerData.path = path;
                textLayerData.selectionDiv = div;
            }
            if (!div.parentNode && drawLayer.#parent) {
                drawLayer.#parent.append(div);
                this.#selections.add(div);
            }
            path.setAttribute("d", boxes.join(" "));
        }
    }
    static get _svgFactory() {
        return $a2cc6e1d6eb3861b$export$b8972b998723d602(this, "_svgFactory", new $a2cc6e1d6eb3861b$export$425e69f00724e63a());
    }
    static #setBox(element, [x, y, width, height]) {
        const { style: style } = element;
        style.top = `${100 * y}%`;
        style.left = `${100 * x}%`;
        style.width = `${100 * width}%`;
        style.height = `${100 * height}%`;
    }
    #createSVG() {
        const svg = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.create(1, 1, true);
        this.#parent.append(svg);
        svg.setAttribute("aria-hidden", "true");
        return svg;
    }
    #createClipPath(defs, pathId) {
        const clipPath = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("clipPath");
        defs.append(clipPath);
        const clipPathId = `clip_${pathId}`;
        clipPath.setAttribute("id", clipPathId);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        const clipPathUse = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("use");
        clipPath.append(clipPathUse);
        clipPathUse.setAttribute("href", `#${pathId}`);
        clipPathUse.classList.add("clip");
        return clipPathId;
    }
    #updateProperties(element, properties) {
        for (const [key, value] of Object.entries(properties))if (value === null) element.removeAttribute(key);
        else element.setAttribute(key, value);
    }
    draw(properties, isPathUpdatable = false, hasClip = false) {
        const id = $a2cc6e1d6eb3861b$export$3eb4521511f02450.#id++;
        const root = this.#createSVG();
        const defs = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("defs");
        root.append(defs);
        const path = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        if (isPathUpdatable) this.#toUpdate.set(id, path);
        const clipPathId = hasClip ? this.#createClipPath(defs, pathId) : null;
        const use = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("use");
        root.append(use);
        use.setAttribute("href", `#${pathId}`);
        this.updateProperties(root, properties);
        this.#mapping.set(id, root);
        return {
            id: id,
            clipPathId: `url(#${clipPathId})`
        };
    }
    drawOutline(properties, mustRemoveSelfIntersections) {
        const id = $a2cc6e1d6eb3861b$export$3eb4521511f02450.#id++;
        const root = this.#createSVG();
        const defs = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("defs");
        root.append(defs);
        const path = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        let maskId;
        if (mustRemoveSelfIntersections) {
            const mask = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("mask");
            defs.append(mask);
            maskId = `mask_${id}`;
            mask.setAttribute("id", maskId);
            mask.setAttribute("maskUnits", "objectBoundingBox");
            const rect = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("rect");
            mask.append(rect);
            rect.setAttribute("width", "1");
            rect.setAttribute("height", "1");
            rect.setAttribute("fill", "white");
            const use = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("use");
            mask.append(use);
            use.setAttribute("href", `#${pathId}`);
            use.setAttribute("stroke", "none");
            use.setAttribute("fill", "black");
            use.setAttribute("fill-rule", "nonzero");
            use.classList.add("mask");
        }
        const use1 = $a2cc6e1d6eb3861b$export$3eb4521511f02450._svgFactory.createElement("use");
        root.append(use1);
        use1.setAttribute("href", `#${pathId}`);
        if (maskId) use1.setAttribute("mask", `url(#${maskId})`);
        const use2 = use1.cloneNode();
        root.append(use2);
        use1.classList.add("mainOutline");
        use2.classList.add("secondaryOutline");
        this.updateProperties(root, properties);
        this.#mapping.set(id, root);
        return id;
    }
    finalizeDraw(id, properties) {
        this.#toUpdate.delete(id);
        this.updateProperties(id, properties);
    }
    updateProperties(elementOrId, properties) {
        if (!properties) return;
        const { root: root, bbox: bbox, rootClass: rootClass, path: path } = properties;
        const element = typeof elementOrId === "number" ? this.#mapping.get(elementOrId) : elementOrId;
        if (!element) return;
        if (root) this.#updateProperties(element, root);
        if (bbox) $a2cc6e1d6eb3861b$export$3eb4521511f02450.#setBox(element, bbox);
        if (rootClass) {
            const { classList: classList } = element;
            for (const [className, value] of Object.entries(rootClass))classList.toggle(className, value);
        }
        if (path) {
            const defs = element.firstElementChild;
            const pathElement = defs.firstElementChild;
            this.#updateProperties(pathElement, path);
        }
    }
    updateParent(id, layer) {
        if (layer === this) return;
        const root = this.#mapping.get(id);
        if (!root) return;
        layer.#parent.append(root);
        this.#mapping.delete(id);
        layer.#mapping.set(id, root);
    }
    remove(id) {
        this.#toUpdate.delete(id);
        if (this.#parent === null) return;
        this.#mapping.get(id).remove();
        this.#mapping.delete(id);
    }
    destroy() {
        this.#parent = null;
        for (const root of this.#mapping.values())root.remove();
        this.#mapping.clear();
        this.#toUpdate.clear();
        this.#textLayerObserver?.disconnect();
        this.#textLayerObserver = null;
        if (this.#textLayer) {
            const data = $a2cc6e1d6eb3861b$export$3eb4521511f02450.#textLayers.get(this.#textLayer);
            if (data?.drawLayer === this) {
                $a2cc6e1d6eb3861b$export$3eb4521511f02450.#cleanupTextLayerSelection(this.#textLayer);
                $a2cc6e1d6eb3861b$export$3eb4521511f02450.#textLayers.delete(this.#textLayer);
                $a2cc6e1d6eb3861b$export$3eb4521511f02450.#textLayerSet.delete(this.#textLayer);
                if ($a2cc6e1d6eb3861b$export$3eb4521511f02450.#textLayerSet.size === 0) {
                    $a2cc6e1d6eb3861b$export$3eb4521511f02450.#selectionChangeAC?.abort();
                    $a2cc6e1d6eb3861b$export$3eb4521511f02450.#selectionChangeAC = null;
                    $a2cc6e1d6eb3861b$export$3eb4521511f02450.#isSelecting = false;
                }
            }
            this.#textLayer = null;
        }
    }
}
function $a2cc6e1d6eb3861b$var$percentage(value) {
    return `${(value * 100).toFixed(2)}%`;
}
class $a2cc6e1d6eb3861b$export$f44e3dd51af47bcc {
    #coordinates = [];
    #coordinatesByElement = new Map();
    #getPageCanvas = null;
    #minSize = 0;
    #pageWidth = 0;
    #pageHeight = 0;
    static #activeImage = null;
    constructor(minSize, coordinates, viewport, getPageCanvas){
        this.#minSize = minSize;
        this.#coordinates = coordinates;
        this.#pageWidth = viewport.rawDims.pageWidth;
        this.#pageHeight = viewport.rawDims.pageHeight;
        this.#getPageCanvas = getPageCanvas;
    }
    render() {
        const container = document.createElement("div");
        container.className = "textLayerImages";
        for(let i = 0; i < this.#coordinates.length; i += 6){
            const el = this.#createImagePlaceholder(this.#coordinates.subarray(i, i + 6));
            if (el) container.append(el);
        }
        container.addEventListener("contextmenu", (event)=>{
            if (!(event.target instanceof HTMLCanvasElement)) return;
            const imgElement = event.target;
            const coords = this.#coordinatesByElement.get(imgElement);
            if (!coords) return;
            const activeImage = $a2cc6e1d6eb3861b$export$f44e3dd51af47bcc.#activeImage?.deref();
            if (activeImage === imgElement) return;
            if (activeImage) {
                activeImage.width = 0;
                activeImage.height = 0;
            }
            $a2cc6e1d6eb3861b$export$f44e3dd51af47bcc.#activeImage = new WeakRef(imgElement);
            const { inverseTransform: inverseTransform, x1: x1, y1: y1, width: width, height: height } = coords;
            const pageCanvas = this.#getPageCanvas();
            const imageX1 = Math.ceil(x1 * pageCanvas.width);
            const imageY1 = Math.ceil(y1 * pageCanvas.height);
            const imageX2 = Math.floor((x1 + width / this.#pageWidth) * pageCanvas.width);
            const imageY2 = Math.floor((y1 + height / this.#pageHeight) * pageCanvas.height);
            imgElement.width = imageX2 - imageX1;
            imgElement.height = imageY2 - imageY1;
            const ctx = imgElement.getContext("2d");
            ctx.setTransform(...inverseTransform);
            ctx.translate(-imageX1, -imageY1);
            ctx.drawImage(pageCanvas, 0, 0);
        });
        return container;
    }
    #createImagePlaceholder([x1, y1, x2, y2, x3, y3]) {
        const width = Math.hypot((x3 - x1) * this.#pageWidth, (y3 - y1) * this.#pageHeight);
        const height = Math.hypot((x2 - x1) * this.#pageWidth, (y2 - y1) * this.#pageHeight);
        if (width < this.#minSize || height < this.#minSize) return null;
        const transform = [
            (x3 - x1) * this.#pageWidth / width,
            (y3 - y1) * this.#pageHeight / width,
            (x2 - x1) * this.#pageWidth / height,
            (y2 - y1) * this.#pageHeight / height,
            0,
            0
        ];
        const inverseTransform = $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd.inverseTransform(transform);
        const imgElement = document.createElement("canvas");
        imgElement.className = "textLayerImagePlaceholder";
        imgElement.width = 0;
        imgElement.height = 0;
        Object.assign(imgElement.style, {
            opacity: 0,
            position: "absolute",
            left: $a2cc6e1d6eb3861b$var$percentage(x1),
            top: $a2cc6e1d6eb3861b$var$percentage(y1),
            width: $a2cc6e1d6eb3861b$var$percentage(width / this.#pageWidth),
            height: $a2cc6e1d6eb3861b$var$percentage(height / this.#pageHeight),
            transformOrigin: "0% 0%",
            transform: `matrix(${transform.join(",")})`
        });
        this.#coordinatesByElement.set(imgElement, {
            inverseTransform: inverseTransform,
            width: width,
            height: height,
            x1: x1,
            y1: y1
        });
        return imgElement;
    }
}
globalThis._pdfjsTestingUtils = {
    HighlightOutliner: $a2cc6e1d6eb3861b$var$HighlightOutliner
};
globalThis.pdfjsLib = {
    AbortException: $a2cc6e1d6eb3861b$export$d0e978393d193d1a,
    AnnotationEditorLayer: $a2cc6e1d6eb3861b$export$47948c9fe1adbf1b,
    AnnotationEditorParamsType: $a2cc6e1d6eb3861b$export$cf3df2a6ecc26692,
    AnnotationEditorType: $a2cc6e1d6eb3861b$export$72ea3bfdd9a725bf,
    AnnotationEditorUIManager: $a2cc6e1d6eb3861b$export$26cb16552a82cf63,
    AnnotationLayer: $a2cc6e1d6eb3861b$export$3e7f45c326d9366c,
    AnnotationMode: $a2cc6e1d6eb3861b$export$5a7af0c07e33392e,
    AnnotationType: $a2cc6e1d6eb3861b$export$f50c3066a53a6f2c,
    applyOpacity: $a2cc6e1d6eb3861b$export$f8d1472813e87bf9,
    build: $a2cc6e1d6eb3861b$export$3f8fe6489e95757d,
    ColorPicker: $a2cc6e1d6eb3861b$export$9feb1bc2e5f1ccb3,
    createValidAbsoluteUrl: $a2cc6e1d6eb3861b$export$e076b47f5805ca0b,
    CSSConstants: $a2cc6e1d6eb3861b$export$cec677744f6a5015,
    DOMSVGFactory: $a2cc6e1d6eb3861b$export$425e69f00724e63a,
    DrawLayer: $a2cc6e1d6eb3861b$export$3eb4521511f02450,
    FeatureTest: $a2cc6e1d6eb3861b$export$5fb8891d35c36978,
    fetchData: $a2cc6e1d6eb3861b$export$8134c072fddab6a5,
    findContrastColor: $a2cc6e1d6eb3861b$export$7a96203b1fdebe8d,
    getDocument: $a2cc6e1d6eb3861b$export$f65ca476c09acec0,
    getFilenameFromUrl: $a2cc6e1d6eb3861b$export$b1c11df0696253ae,
    getPdfFilenameFromUrl: $a2cc6e1d6eb3861b$export$9de51790aa4bc73a,
    getRGB: $a2cc6e1d6eb3861b$export$2a2e9b507863ddda,
    getRGBA: $a2cc6e1d6eb3861b$export$c24a0a5c5129b2e1,
    getUuid: $a2cc6e1d6eb3861b$export$75f13a91ebdf8eb3,
    GlobalWorkerOptions: $a2cc6e1d6eb3861b$export$edf38ba293eb934,
    ImageKind: $a2cc6e1d6eb3861b$export$b890e9c15247e0b3,
    InvalidPDFException: $a2cc6e1d6eb3861b$export$e3d0f4ce5b91e9f1,
    isDataScheme: $a2cc6e1d6eb3861b$export$f67aae4532d8295b,
    isPdfFile: $a2cc6e1d6eb3861b$export$61b52d3570d24719,
    isValidExplicitDest: $a2cc6e1d6eb3861b$export$b5acece0a447dcdc,
    makeArr: $a2cc6e1d6eb3861b$export$be9af9a47496243a,
    makeMap: $a2cc6e1d6eb3861b$export$b41394a5437791c8,
    makeObj: $a2cc6e1d6eb3861b$export$5b3b706fb9845c88,
    MathClamp: $a2cc6e1d6eb3861b$export$b8106b171181a554,
    noContextMenu: $a2cc6e1d6eb3861b$export$455b7811f904cadc,
    normalizeUnicode: $a2cc6e1d6eb3861b$export$1fa1e6b1a06bd7fa,
    OPS: $a2cc6e1d6eb3861b$export$3a0f7f7a8a0b306b,
    OutputScale: $a2cc6e1d6eb3861b$export$f16a99f63bccd50b,
    PasswordResponses: $a2cc6e1d6eb3861b$export$5e72215208e4d9ad,
    PDFDataRangeTransport: $a2cc6e1d6eb3861b$export$c06899d9d7bce9ab,
    PDFDateString: $a2cc6e1d6eb3861b$export$66cbc314498fffc,
    PDFWorker: $a2cc6e1d6eb3861b$export$84e2e9f37426b265,
    PermissionFlag: $a2cc6e1d6eb3861b$export$bb99a5b8411e07d8,
    PixelsPerInch: $a2cc6e1d6eb3861b$export$6ef3b6b69e65342c,
    RenderingCancelledException: $a2cc6e1d6eb3861b$export$245847d31c09154f,
    renderRichText: $a2cc6e1d6eb3861b$export$611c480766035c4,
    ResponseException: $a2cc6e1d6eb3861b$export$ea8e9c34f66e603,
    setLayerDimensions: $a2cc6e1d6eb3861b$export$af0a15a86e590226,
    shadow: $a2cc6e1d6eb3861b$export$b8972b998723d602,
    SignatureExtractor: $a2cc6e1d6eb3861b$export$cc4fe8633f466b4a,
    stopEvent: $a2cc6e1d6eb3861b$export$7ae4cd3a66c1e050,
    SupportedImageMimeTypes: $a2cc6e1d6eb3861b$export$3234c88e9de64a88,
    TextLayer: $a2cc6e1d6eb3861b$export$fdbdc423a78c5262,
    TextLayerImages: $a2cc6e1d6eb3861b$export$f44e3dd51af47bcc,
    TouchManager: $a2cc6e1d6eb3861b$export$9ae7542b430d543e,
    updateUrlHash: $a2cc6e1d6eb3861b$export$e1e4297c21ab9d13,
    Util: $a2cc6e1d6eb3861b$export$f8f26dd395d7e1bd,
    VerbosityLevel: $a2cc6e1d6eb3861b$export$b18df09d23c244c4,
    version: $a2cc6e1d6eb3861b$export$83d89fbfd8236492,
    XfaLayer: $a2cc6e1d6eb3861b$export$f6af20c312d4b9a2
};


var $d84863177503422d$exports = {};
$d84863177503422d$exports = $parcel$resolve("kinXO");


let $b25dfe2ee2c25921$var$workerReadyPromise = null;
function $b25dfe2ee2c25921$var$ensurePdfWorker() {
    if (!$b25dfe2ee2c25921$var$workerReadyPromise) {
        $a2cc6e1d6eb3861b$export$edf38ba293eb934.workerSrc = (0, (/*@__PURE__*/$parcel$interopDefault($d84863177503422d$exports)));
        $b25dfe2ee2c25921$var$workerReadyPromise = Promise.resolve();
    }
    return $b25dfe2ee2c25921$var$workerReadyPromise;
}
const $b25dfe2ee2c25921$var$myPdfs = {};
function $b25dfe2ee2c25921$var$renderPdf(pdfs, canvas, pageno, scale, width) {
    const pdf = pdfs.pdf;
    pdf.getPage(pageno).then(function(page) {
        let viewport = page.getViewport({
            scale: scale
        });
        if (width) {
            const wscale = width / viewport.width;
            const newScale = wscale * scale;
            const height = wscale * viewport.height;
            viewport = page.getViewport({
                scale: newScale
            });
            viewport.width = width;
            viewport.height = height;
        }
        const context = canvas.getContext("2d", {
            alpha: false
        });
        const outputScale = $b25dfe2ee2c25921$var$getOutputScale(context);
        canvas.width = viewport.width * outputScale.sx | 0;
        canvas.height = viewport.height * outputScale.sy | 0;
        canvas.style.height = viewport.height + "px";
        canvas.style.width = viewport.width + "px";
        context.scale(outputScale.sx, outputScale.sy);
        pdfs.prevHeight = viewport.height;
        pdfs.prevWidth = viewport.width;
        const renderContext = {
            canvasContext: context,
            viewport: viewport
        };
        page.render(renderContext);
    });
}
function $b25dfe2ee2c25921$var$getOutputScale(ctx) {
    const devicePixelRatio = window.devicePixelRatio || 1;
    const backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
    const pixelRatio = devicePixelRatio / backingStoreRatio;
    return {
        sx: pixelRatio,
        sy: pixelRatio,
        scaled: pixelRatio !== 1
    };
}
class $b25dfe2ee2c25921$var$PdfViewerCustomElement extends HTMLElement {
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: "open"
        });
        this.canvas = document.createElement("canvas");
        shadow.appendChild(this.canvas);
    }
    connectedCallback() {
        const name = this.getAttribute("name");
        const page = parseInt(this.getAttribute("page"), 10);
        const widthRaw = Number.parseFloat(this.getAttribute("width"));
        const width = Number.isFinite(widthRaw) ? widthRaw : undefined;
        const pdf = $b25dfe2ee2c25921$var$myPdfs[name];
        if (pdf) {
            if (width) this.canvas.width = width;
            else if (pdf.prevWidth) this.canvas.width = pdf.prevWidth;
            if (pdf.prevHeight) this.canvas.height = pdf.prevHeight;
            $b25dfe2ee2c25921$var$renderPdf(pdf, this.canvas, page, 1, width);
        }
    }
}
function $b25dfe2ee2c25921$var$formatPdfError(reason) {
    if (reason == null) return "unknown error";
    if (typeof reason === "string") return reason;
    if (typeof reason === "object" && reason.message) return String(reason.message);
    return String(reason);
}
function $b25dfe2ee2c25921$var$pdfCommandHandler(app, cmd) {
    if (!app.ports.receivePdfMsg) return;
    if (cmd.cmd === "openurl") $a2cc6e1d6eb3861b$export$f65ca476c09acec0({
        url: cmd.url
    }).promise.then(function(pdf) {
        $b25dfe2ee2c25921$var$myPdfs[cmd.name] = {
            pdf: pdf
        };
        app.ports.receivePdfMsg.send({
            msg: "loaded",
            name: cmd.name,
            pageCount: pdf.numPages
        });
    }, function(reason) {
        app.ports.receivePdfMsg.send({
            msg: "error",
            name: cmd.name,
            error: $b25dfe2ee2c25921$var$formatPdfError(reason)
        });
    });
    else if (cmd.cmd === "openstring") {
        const buff = Uint8Array.from(atob(cmd.string), (c)=>c.charCodeAt(0));
        $a2cc6e1d6eb3861b$export$f65ca476c09acec0({
            data: buff
        }).promise.then(function(pdf) {
            $b25dfe2ee2c25921$var$myPdfs[cmd.name] = {
                pdf: pdf
            };
            app.ports.receivePdfMsg.send({
                msg: "loaded",
                name: cmd.name,
                pageCount: pdf.numPages
            });
        }, function(reason) {
            app.ports.receivePdfMsg.send({
                msg: "error",
                name: cmd.name,
                error: $b25dfe2ee2c25921$var$formatPdfError(reason)
            });
        });
    } else if (cmd.cmd === "close") {
        const entry = $b25dfe2ee2c25921$var$myPdfs[cmd.name];
        delete $b25dfe2ee2c25921$var$myPdfs[cmd.name];
        if (entry && entry.pdf) entry.pdf.loadingTask.destroy().catch(function() {});
    } else app.ports.receivePdfMsg.send({
        msg: "error",
        name: typeof cmd.name === "string" ? cmd.name : "",
        error: "invalid command to pdf-element: " + cmd.cmd
    });
}
const $b25dfe2ee2c25921$var$PdfPreviewPort = {
    add: function(app) {
        if (typeof customElements !== "undefined" && !customElements.get("pdf-element")) customElements.define("pdf-element", $b25dfe2ee2c25921$var$PdfViewerCustomElement);
        if (app.ports.sendPdfCommand) app.ports.sendPdfCommand.subscribe(function(cmd) {
            $b25dfe2ee2c25921$var$ensurePdfWorker().then(function() {
                $b25dfe2ee2c25921$var$pdfCommandHandler(app, cmd);
            }).catch(function(err) {
                if (app.ports.receivePdfMsg) app.ports.receivePdfMsg.send({
                    msg: "error",
                    name: typeof cmd.name === "string" ? cmd.name : "",
                    error: $b25dfe2ee2c25921$var$formatPdfError(err)
                });
            });
        });
    }
};
var $b25dfe2ee2c25921$export$2e2bcd8739ae039 = $b25dfe2ee2c25921$var$PdfPreviewPort;


var $507e5696cf16a143$exports = {};
$507e5696cf16a143$exports = $parcel$resolve("hW73M");


function $5b09ccb12fff0951$var$appendPreFallback(el, xmlText) {
    const pre = document.createElement("pre");
    pre.className = "whitespace-pre-wrap break-words rounded-md bg-gray-50 p-3 text-xs text-gray-800";
    pre.textContent = xmlText;
    el.appendChild(pre);
}
function $5b09ccb12fff0951$var$hasXmlParserError(doc) {
    return doc.getElementsByTagName("parsererror").length > 0;
}
let $5b09ccb12fff0951$var$xslCachePromise = null;
function $5b09ccb12fff0951$var$loadXslText() {
    if (!$5b09ccb12fff0951$var$xslCachePromise) $5b09ccb12fff0951$var$xslCachePromise = fetch((0, (/*@__PURE__*/$parcel$interopDefault($507e5696cf16a143$exports)))).then((res)=>{
        if (!res.ok) throw new Error("xsl fetch failed");
        return res.text();
    });
    return $5b09ccb12fff0951$var$xslCachePromise;
}
const $5b09ccb12fff0951$var$XmlPreviewPort = {
    add (app) {
        if (!app.ports.requestXmlPreview || !app.ports.xmlPreviewResult) return;
        app.ports.requestXmlPreview.subscribe(async ({ requestId: requestId, url: url, elementId: elementId })=>{
            const sendFail = ()=>{
                app.ports.xmlPreviewResult.send({
                    requestId: requestId,
                    ok: false
                });
            };
            try {
                const el = document.getElementById(elementId);
                if (!el) {
                    sendFail();
                    return;
                }
                const res = await fetch(url);
                if (!res.ok) {
                    sendFail();
                    return;
                }
                const xmlText = await res.text();
                el.replaceChildren();
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xmlText, "application/xml");
                if ($5b09ccb12fff0951$var$hasXmlParserError(xmlDoc)) {
                    $5b09ccb12fff0951$var$appendPreFallback(el, xmlText);
                    app.ports.xmlPreviewResult.send({
                        requestId: requestId,
                        ok: true
                    });
                    return;
                }
                try {
                    const xslText = await $5b09ccb12fff0951$var$loadXslText();
                    const xsltProcessor = new XSLTProcessor();
                    const xslDoc = parser.parseFromString(xslText, "application/xml");
                    if ($5b09ccb12fff0951$var$hasXmlParserError(xslDoc)) throw new Error("Invalid XSL");
                    xsltProcessor.importStylesheet(xslDoc);
                    const fragment = xsltProcessor.transformToFragment(xmlDoc, document);
                    el.appendChild(fragment);
                } catch  {
                    $5b09ccb12fff0951$var$appendPreFallback(el, xmlText);
                }
                app.ports.xmlPreviewResult.send({
                    requestId: requestId,
                    ok: true
                });
            } catch  {
                sendFail();
            }
        });
        if (app.ports.clearXmlMount) app.ports.clearXmlMount.subscribe((elementId)=>{
            if (!elementId) return;
            const mount = document.getElementById(elementId);
            if (mount) mount.replaceChildren();
        });
    }
};
var $5b09ccb12fff0951$export$2e2bcd8739ae039 = $5b09ccb12fff0951$var$XmlPreviewPort;


// Meticulous replays serve the raw dist, where the release-tag placeholder
// is never substituted, so release-tagged assets live under /c1611b73759069af84fe508b2934a3ed5c535559/.
if (window.Meticulous?.isRunningAsTest) CONFIGURATION.release = "c1611b73759069af84fe508b2934a3ed5c535559";
var $397bcf58b99e38b9$exports = {};
const $397bcf58b99e38b9$var$WindowPort = {
    add: function(app) {
        const isInView = function(element) {
            if (!element) return false;
            const rect = element.getBoundingClientRect();
            return rect.top >= 0 && rect.bottom <= window.innerHeight && rect.left >= 0 && rect.right <= window.innerWidth;
        };
        app.ports.scrollTopAndIntoView.subscribe(function(elementId) {
            var element = document.getElementById(elementId);
            if (!element) return;
            // don't scroll if already visible
            if (isInView(element)) return;
            var scrollTimeout;
            var handleScroll = function() {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(function() {
                    removeEventListener("scroll", handleScroll, true);
                    setTimeout(function() {
                        window.scroll({
                            top: 0,
                            behavior: "smooth"
                        });
                    }, 250);
                }, 100);
            };
            addEventListener("scroll", handleScroll, true);
            element.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
        });
        app.ports.scrollIdIntoView.subscribe(function(elementId) {
            var element = document.getElementById(elementId);
            if (!element) return;
            // don't scroll if already visible
            if (isInView(element)) return;
            element.scrollIntoView({
                behavior: "smooth"
            });
        });
        app.ports.scrollIdToBottom.subscribe(function(elementId) {
            var element = document.getElementById(elementId);
            if (!element) return;
            element.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
        });
        var scrollTimer = null;
        var lastScrollFireTime = 0;
        var minScrollTime = 100;
        window.addEventListener("scroll", ()=>{
            if (!scrollTimer) {
                var now = new Date().getTime();
                if (now - lastScrollFireTime > minScrollTime) {
                    app.ports.onWindowScroll.send({
                        x: window.scrollX,
                        y: window.scrollY
                    });
                    lastScrollFireTime = now;
                }
                scrollTimer = setTimeout(function() {
                    scrollTimer = null;
                    lastScrollFireTime = new Date().getTime();
                    app.ports.onWindowScroll.send({
                        x: window.scrollX,
                        y: window.scrollY
                    });
                }, minScrollTime);
            }
        });
        app.ports.printWindow.subscribe(function() {
            window.print();
        });
    }
};
$397bcf58b99e38b9$exports = $397bcf58b99e38b9$var$WindowPort;


var $0d34a6c94bf1f37e$exports = {};
/* global google */ var $1f8aac6bc784b2a4$exports = {};
!function(o, e) {
    e($1f8aac6bc784b2a4$exports);
}($1f8aac6bc784b2a4$exports, function(o) {
    "use strict";
    const e = (o)=>{
        var e, n, r, t = "The Google Maps JavaScript API", a = "google", i = "importLibrary", s = "__ib__", p = document, c = window, l = c[a] || (c[a] = {}), d = l.maps || (l.maps = {}), m = new Set, g = new URLSearchParams;
        d[i] ? console.warn(t + " only loads once. Ignoring:", o) : d[i] = (c, ...l)=>m.add(c) && (e || (e = new Promise(async (i, c)=>{
                for(r in await (n = p.createElement("script")), g.set("libraries", [
                    ...m
                ] + ""), o)g.set(r.replace(/[A-Z]/g, (o)=>"_" + o[0].toLowerCase()), o[r]);
                g.set("callback", a + ".maps." + s), function(o, e) {
                    o.src = e;
                }(n, "https://maps.googleapis.com/maps/api/js?" + g), d[s] = i, n.onerror = ()=>e = c(Error(t + " could not load.")), n.nonce = p.querySelector("script[nonce]")?.nonce || "", p.head.append(n);
            }))).then(()=>d[i](c, ...l));
    };
    "staging";
    "staging";
    let n = !1;
    o.Loader = class {
        constructor(...o){
            throw new Error("[@googlemaps/js-api-loader]: The Loader class is no longer available in this version.\nPlease use the new functional API: setOptions() and importLibrary().\nFor more information, see the updated documentation at: https://github.com/googlemaps/js-api-loader/blob/main/README.md");
        }
    }, o.importLibrary = async function(o) {
        if (!window?.google?.maps?.importLibrary) throw new Error("google.maps.importLibrary is not installed.");
        return await google.maps.importLibrary(o);
    }, o.setOptions = function(o) {
        n ? ((o)=>{
            JSON.stringify(o);
        })(o) : (!function(o) {
            const n = Boolean(window.google?.maps?.importLibrary);
            n && ((o)=>{
                JSON.stringify(o);
            })(o);
            n || e(o);
        }(o), n = !0);
    };
}); //# sourceMappingURL=index.cjs.map


const $0d34a6c94bf1f37e$var$GooglePlacesPort = {
    add: function(app, googleMapsKey) {
        if (!googleMapsKey) throw new Error("Google Maps Key is not configured.");
        let places;
        (0, $1f8aac6bc784b2a4$exports.setOptions)({
            key: googleMapsKey
        });
        const fetchAutocompleteSuggestions = (id, request, callback)=>{
            places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request).then(({ suggestions: suggestions })=>{
                const formattedSuggestions = suggestions.map((s)=>{
                    const p = s.placePrediction;
                    return {
                        description: p.text.text,
                        place_id: p.placeId,
                        types: p.types
                    };
                });
                callback({
                    suggestions: formattedSuggestions,
                    id: id
                });
            }).catch((error)=>{
                console.log(error);
            });
        };
        (0, $1f8aac6bc784b2a4$exports.importLibrary)("places").then((imported)=>{
            places = imported;
            app.ports.googlePlacesPredictAddress.subscribe(function({ address: address, id: id }) {
                if (!address) return;
                let sessionToken = new places.AutocompleteSessionToken();
                let request = {
                    input: address,
                    sessionToken: sessionToken
                };
                navigator.geolocation.getCurrentPosition(({ coords: { latitude: latitude, longitude: longitude } })=>{
                    fetchAutocompleteSuggestions(id, {
                        ...request,
                        locationBias: {
                            radius: 5000,
                            center: {
                                lat: latitude,
                                lng: longitude
                            }
                        }
                    }, app.ports.googlePlacesAddressSuggestions.send);
                }, ()=>{
                    fetchAutocompleteSuggestions(id, request, app.ports.googlePlacesAddressSuggestions.send);
                });
            });
            app.ports.googlePlacesPredictionDetails.subscribe(function({ placeId: placeId, id: id }) {
                const place = new google.maps.places.Place({
                    id: placeId
                });
                place.fetchFields({
                    fields: [
                        "addressComponents",
                        "formattedAddress",
                        "displayName",
                        "id",
                        "types"
                    ]
                }).then((response)=>{
                    const transformedPlace = {
                        address_components: (response.place.addressComponents || []).map((component)=>({
                                long_name: component.longText,
                                short_name: component.shortText,
                                types: component.types
                            })),
                        formatted_address: response.place.formattedAddress,
                        name: response.place.displayName,
                        place_id: response.place.id,
                        types: response.place.types
                    };
                    const address = JSON.stringify(transformedPlace);
                    app.ports.googlePlacesAddressDetails.send({
                        address: address,
                        id: id
                    });
                }).catch((error)=>{
                    console.log("Error fetching place details:", error);
                    app.ports.googlePlacesAddressDetails.send({
                        address: null,
                        id: id
                    });
                });
            });
        }).catch((error)=>console.log(error));
    }
};
$0d34a6c94bf1f37e$exports = $0d34a6c94bf1f37e$var$GooglePlacesPort;


var $44d2ba25a7bfecb2$exports = {};
/* global CONFIGURATION, grecaptcha */ const $44d2ba25a7bfecb2$var$setup = function() {
    function loadRecaptchaAPI() {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://www.google.com/recaptcha/api.js?render=" + CONFIGURATION.googleRecaptchaSiteKey + "&onload=recaptchaOnLoadfunction";
        document.body.appendChild(script);
    }
    if (CONFIGURATION.googleRecaptchaSiteKey) window.addEventListener("load", loadRecaptchaAPI, false);
};
window.recaptchaLoaded = false;
function $44d2ba25a7bfecb2$var$notifyRecaptchaLoaded(app) {
    setTimeout(function() {
        app.ports.gotRecaptchaInitializedPort.send("Ok");
    }, 0);
}
const $44d2ba25a7bfecb2$var$GoogleRecaptchaPort = {
    add: function(app) {
        window.recaptchaOnLoadfunction = function() {
            window.recaptchaLoaded = true;
            $44d2ba25a7bfecb2$var$notifyRecaptchaLoaded(app);
        };
        app.ports.initializeRecaptchaPort.subscribe(function() {
            if (window.recaptchaLoaded) $44d2ba25a7bfecb2$var$notifyRecaptchaLoaded(app);
        });
        $44d2ba25a7bfecb2$var$setup();
        app.ports.getRecaptchaTokenPort.subscribe(function(action) {
            if (typeof grecaptcha !== "undefined") grecaptcha.ready(function() {
                grecaptcha.execute(CONFIGURATION.googleRecaptchaSiteKey, {
                    action: action
                }).then(function(token) {
                    app.ports.gotRecaptchaTokenPort.send({
                        token: token,
                        result: "ok"
                    });
                }).catch(()=>app.ports.gotRecaptchaTokenPort.send({
                        token: "",
                        result: "remote-error"
                    }));
            });
            else app.ports.gotRecaptchaTokenPort.send({
                token: "",
                result: "recaptcha-not-defined"
            });
        });
    }
};
$44d2ba25a7bfecb2$exports = $44d2ba25a7bfecb2$var$GoogleRecaptchaPort;


var $f2086779cc7dd10e$exports = {};
var $e8379647cdfd5908$exports = {};
"use strict";
Object.defineProperty($e8379647cdfd5908$exports, "__esModule", {
    value: true
});
$e8379647cdfd5908$exports.storageFactory = void 0;
function $e8379647cdfd5908$var$storageFactory(getStorage) {
    var inMemoryStorage = {};
    function isSupported() {
        try {
            var testKey = "__some_random_key_you_are_not_going_to_use__";
            getStorage().setItem(testKey, testKey);
            getStorage().removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
    function clear() {
        if (isSupported()) getStorage().clear();
        else inMemoryStorage = {};
    }
    function getItem(name) {
        if (isSupported()) return getStorage().getItem(name);
        if (inMemoryStorage.hasOwnProperty(name)) return inMemoryStorage[name];
        return null;
    }
    function key(index) {
        if (isSupported()) return getStorage().key(index);
        else return Object.keys(inMemoryStorage)[index] || null;
    }
    function removeItem(name) {
        if (isSupported()) getStorage().removeItem(name);
        else delete inMemoryStorage[name];
    }
    function setItem(name, value) {
        if (isSupported()) getStorage().setItem(name, value);
        else inMemoryStorage[name] = String(value);
    }
    function length() {
        if (isSupported()) return getStorage().length;
        else return Object.keys(inMemoryStorage).length;
    }
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
        key: key,
        get length () {
            return length();
        }
    };
}
$e8379647cdfd5908$exports.storageFactory = $e8379647cdfd5908$var$storageFactory;


const $f2086779cc7dd10e$var$storage = (0, $e8379647cdfd5908$exports.storageFactory)(()=>localStorage);
const $f2086779cc7dd10e$var$LocalStoragePort = {
    getItem: $f2086779cc7dd10e$var$storage.getItem,
    add: (app)=>{
        app.ports.setItemPort.subscribe((object)=>{
            $f2086779cc7dd10e$var$storage.setItem(object.key, object.value);
        // Uncomment if you want a SetItem callback
        // app.ports.setItemPortCompleted.send({ value: object.value, itemType: object.itemType, action: object.action });
        });
        app.ports.getItemPort.subscribe(function(object) {
            const value = $f2086779cc7dd10e$var$storage.getItem(object.key);
            app.ports.gotItemPort.send({
                value: value,
                itemType: object.itemType,
                action: object.action
            });
        });
        app.ports.removeItemPort.subscribe(function(object) {
            $f2086779cc7dd10e$var$storage.removeItem(object.key);
            app.ports.removedItemPort.send({
                value: "",
                itemType: object.itemType,
                action: object.action
            });
        });
        window.addEventListener("storage", function(event) {
            if (event.key === "accountToken" && event.newValue === null) app.ports.removedItemPort.send({
                value: "",
                itemType: "AccountToken",
                action: "remove"
            });
        });
    }
};
$f2086779cc7dd10e$exports = $f2086779cc7dd10e$var$LocalStoragePort;


var $36331f456e6baed0$exports = {};
var $602195b98aff1e07$exports = {};
/* global CONFIGURATION */ "use strict";
var $53450d6a32d1b4a0$exports = {};
/*! js-cookie v3.0.8 | MIT */ (function(global, factory) {
    $53450d6a32d1b4a0$exports = factory();
})($53450d6a32d1b4a0$exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});


const $602195b98aff1e07$var$isSafari = window.safari !== undefined;
const $602195b98aff1e07$var$cookieOptions = {
    sameSite: "strict",
    secure: true,
    path: "/"
};
if ($602195b98aff1e07$var$isSafari && CONFIGURATION && CONFIGURATION.debugOrTest) delete $602195b98aff1e07$var$cookieOptions["secure"];
const $602195b98aff1e07$var$SECURE_KEY_NAME = "__Host-hint.account_token";
const $602195b98aff1e07$var$INSECURE_KEY_NAME = "hint.account_token";
const $602195b98aff1e07$var$keyName = window.location.protocol === "https:" ? $602195b98aff1e07$var$SECURE_KEY_NAME : $602195b98aff1e07$var$INSECURE_KEY_NAME;
// Sessions are recorded over https, where the token is stored under the
// __Host- prefixed name, but replayed over http, where only the bare name is
// read. A replay therefore has to look under the other name too.
const $602195b98aff1e07$var$isReplayingRecordedSession = ()=>Boolean(window.Meticulous);
const $602195b98aff1e07$var$alternateKeyName = $602195b98aff1e07$var$keyName === $602195b98aff1e07$var$SECURE_KEY_NAME ? $602195b98aff1e07$var$INSECURE_KEY_NAME : $602195b98aff1e07$var$SECURE_KEY_NAME;
$602195b98aff1e07$exports = {
    set: function(value) {
        return $53450d6a32d1b4a0$exports.set($602195b98aff1e07$var$keyName, value, $602195b98aff1e07$var$cookieOptions);
    },
    get: function() {
        if ($602195b98aff1e07$var$isReplayingRecordedSession()) return $53450d6a32d1b4a0$exports.get($602195b98aff1e07$var$keyName) || $53450d6a32d1b4a0$exports.get($602195b98aff1e07$var$alternateKeyName);
        return $53450d6a32d1b4a0$exports.get($602195b98aff1e07$var$keyName);
    },
    remove: function() {
        $53450d6a32d1b4a0$exports.remove($602195b98aff1e07$var$keyName, $602195b98aff1e07$var$cookieOptions);
        if ($602195b98aff1e07$var$isReplayingRecordedSession()) $53450d6a32d1b4a0$exports.remove($602195b98aff1e07$var$alternateKeyName, $602195b98aff1e07$var$cookieOptions);
    }
};


const $36331f456e6baed0$var$logoutChannel = new BroadcastChannel("account-token-channel");
const $36331f456e6baed0$var$AccountTokenStoragePort = {
    getItem: function(_key) {
        return $602195b98aff1e07$exports.get();
    },
    add: (app)=>{
        app.ports.setTokenPort.subscribe((object)=>{
            $602195b98aff1e07$exports.set(object.value);
        });
        app.ports.removeTokenPort.subscribe(()=>{
            $602195b98aff1e07$exports.remove();
            $36331f456e6baed0$var$logoutChannel.postMessage("logout");
            app.ports.accountTokenRemovedPort.send(null);
        });
        $36331f456e6baed0$var$logoutChannel.onmessage = (event)=>{
            if (event.data === "logout") app.ports.accountTokenRemovedPort.send(null);
        };
    }
};
$36331f456e6baed0$exports = $36331f456e6baed0$var$AccountTokenStoragePort;


var $1e586fe0a96f962b$exports = {};
const $1e586fe0a96f962b$var$NavigationPort = {
    add: function(app) {
        // Inform app of browser navigation (the BACK and FORWARD buttons)
        window.addEventListener("popstate", function() {
            app.ports.onUrlChange.send(location.href);
        });
        // Change the URL upon request, inform app of the change.
        app.ports.pushUrl.subscribe(function(url) {
            history.pushState({}, "", url);
            app.ports.onUrlChange.send(location.href);
        });
        // Intercept link clicks to change the location without refreshing the page
        document.addEventListener("click", function(event) {
            const { target: target } = event;
            if (event.ctrlKey || event.metaKey) return;
            const isLocalHref = (targetA)=>{
                return targetA.host == location.host;
            };
            const linkElement = target.localName == "a" ? target : target.closest("a");
            if (linkElement && linkElement.href && isLocalHref(linkElement) && linkElement.target !== "_blank") {
                event.preventDefault();
                history.pushState({}, "", linkElement.href);
                app.ports.onUrlChange.send(linkElement.href);
            }
        });
        if (app.ports.openInNewWindow) app.ports.openInNewWindow.subscribe((url)=>{
            const newPage = window.open(url, "_blank");
            if (!newPage) console.warn("Failed to open new window - pop-up may be blocked");
        });
        if (app.ports.replaceUrl) app.ports.replaceUrl.subscribe((url)=>{
            history.replaceState({}, "", url);
        });
    }
};
$1e586fe0a96f962b$exports = $1e586fe0a96f962b$var$NavigationPort;


var $3cef90824005e2d6$exports = {};

const $3cef90824005e2d6$var$SentryPort = {
    add: function(app, env) {
        app.ports.sentryPortCaptureErrorMessage.subscribe(function(messageAndContext) {
            const message = messageAndContext[0];
            const context = messageAndContext[1];
            if (![
                "feature",
                "staging",
                "production"
            ].includes(env)) console.error(message, context);
            $b073bf4933b0a980$exports.withScope(function(scope) {
                Object.keys(context || {}).forEach(function(contextKey) {
                    scope.setContext(contextKey, context[contextKey]);
                });
                $b073bf4933b0a980$exports.captureMessage(message, "info");
            });
        });
    }
};
$3cef90824005e2d6$exports = $3cef90824005e2d6$var$SentryPort;


var $d5d5137484b98c41$exports = {};
/* global Stripe */ const $d5d5137484b98c41$var$StripePort = {
    add: function(app, publishableKey) {
        if (!window.Stripe) return;
        let stripeElements = {};
        // Cross browser support
        const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        const mountAttemptsMax = 20;
        let mountAttempts = 0;
        let elements;
        function buildAndMountElementWithSetupIntent(stripeClient, params) {
            const cardElement = document.querySelector(params.selector);
            elements = stripeClient.elements({
                clientSecret: params.setupIntentSecret,
                fonts: [
                    {
                        cssSrc: "https://fonts.googleapis.com/css2?family=Wix+Madefor+Text:ital,wght@0,400..800;1,400..800&display=swap"
                    }
                ],
                appearance: {
                    theme: "flat",
                    variables: {
                        borderRadius: "3px",
                        border: "1px solid #C4DCF8",
                        boxShadow: "none",
                        colorPrimary: "#006CD1",
                        colorText: "#1D2334",
                        colorTextPlaceholder: "#497AA5",
                        colorTextSecondary: "#497AA5",
                        fontFamily: "Wix Madefor Text",
                        fontLineHeight: "21px",
                        colorBackground: "#FFFFFF",
                        fontSize: "1rem",
                        colorIconTabSelected: "#0056A6",
                        colorIconTabHover: "#0056A6"
                    },
                    rules: {
                        ".DropdownItem--highlight": {
                            backgroundColor: "#F1F6FC",
                            border: "1px solid #81AFE4"
                        },
                        ".Tab--selected, .Tab--selected:hover": {
                            borderColor: "#0056A6",
                            color: "#0056A6",
                            backgroundColor: "#f1f6fc"
                        },
                        ".Tab, .Input, .PickerItem": {
                            border: "1px solid #c4dcf8",
                            boxShadow: "none"
                        },
                        ".Input": {
                            padding: "10px",
                            fontSize: "1rem"
                        },
                        ".Label": {
                            fontWeight: "850",
                            fontSize: "1rem",
                            fontLineHeight: "21px",
                            marginBottom: "10px"
                        },
                        ".PickerItem": {
                            color: "#497aa4",
                            textTransform: "uppercase",
                            lineHeight: "25px"
                        },
                        ".PickerItem:hover": {
                            backgroundColor: "#FFFFFF"
                        },
                        ".Tab:hover, .Input:hover, .PickerItem:hover": {
                            borderColor: "#81AFE4",
                            color: "#0056A6"
                        }
                    }
                }
            });
            const disallowedBrands = params.options.rejectAmex ? [
                "amex"
            ] : [];
            const paymentMethodOrder = params.options.encourageAch ? [
                "us_bank_account",
                "card"
            ] : [];
            const paymentElement = elements.create("payment", {
                paymentMethodOrder: paymentMethodOrder,
                terms: {
                    card: "never",
                    usBankAccount: "never"
                },
                disallowedCardBrands: disallowedBrands,
                wallets: {
                    applePay: "never",
                    googlePay: "never"
                }
            });
            paymentElement.mount(cardElement);
            paymentElement.on("change", function(element) {
                const type = element && element.value && element.value.type || "";
                app.ports.stripePortOnSetupIntentChange.send(type);
            });
            return {
                stripeClient: stripeClient,
                elements: elements,
                paymentElement: paymentElement,
                options: params.options
            };
        }
        function tryBuildAndMountElementWithSetupIntent(params) {
            const stripeClient = Stripe(publishableKey, {
                betas: [
                    "blocked_card_brands_beta_1"
                ],
                apiVersion: "2019-12-03",
                locale: params.locale
            });
            const cardElement = document.querySelector(params.selector);
            if (cardElement) requestAnimationFrame(function() {
                stripeElements[params.selector] = buildAndMountElementWithSetupIntent(stripeClient, params);
            });
            else if (mountAttempts <= mountAttemptsMax) {
                mountAttempts += 1;
                setTimeout(function() {
                    tryBuildAndMountElementWithSetupIntent(params);
                }, 100);
            }
        }
        app.ports.stripePortBuildAndMountElementWithSetupIntent.subscribe(tryBuildAndMountElementWithSetupIntent);
        app.ports.stripePortConfirmSetupIntent.subscribe(function(params) {
            const stripeElement = stripeElements[params.selector];
            const billingDetails = params.options && params.options.billingOptions ? {
                billing_details: {
                    name: params.options.billingOptions.name
                }
            } : {};
            stripeElement.stripeClient.confirmSetup({
                elements: elements,
                confirmParams: {
                    return_url: window.location.href,
                    payment_method_data: billingDetails
                },
                redirect: "if_required"
            }).then(({ error: error, setupIntent: setupIntent })=>{
                if (error) app.ports.stripePortOnSetupIntentConfirmed.send({
                    selector: params.selector,
                    setup_intent: null,
                    error: error.message
                });
                else app.ports.stripePortOnSetupIntentConfirmed.send({
                    selector: params.selector,
                    setup_intent: setupIntent,
                    error: null
                });
            });
        });
    }
};
$d5d5137484b98c41$exports = $d5d5137484b98c41$var$StripePort;


var $b78de99e3cb6b90b$exports = {};
function $b78de99e3cb6b90b$var$hexToHsl(hex) {
    // Convert hex to RGB first
    let r = 0, g = 0, b = 0;
    if (hex.length == 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length == 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin;
    let h, s, l;
    if (delta == 0) h = 0;
    else if (cmax == r) h = (g - b) / delta % 6;
    else if (cmax == g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return {
        h: h,
        s: s,
        l: l
    };
}
function $b78de99e3cb6b90b$var$toHsl({ h: h, s: s, l: l }) {
    return "hsl(" + h + "," + s + "%," + l + "%)";
}
function $b78de99e3cb6b90b$var$setTheme(hex) {
    const root = document.documentElement;
    const { h: h, s: s, l: l } = $b78de99e3cb6b90b$var$hexToHsl(hex);
    $b78de99e3cb6b90b$var$setProperty(root, "500", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 8,
        l: 40
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "400", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: s,
        l: l - 10
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "300", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: s,
        l: l
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "200", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 79,
        l: 87
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "250", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 65,
        l: 70
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "100", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 65,
        l: 97
    }));
}
function $b78de99e3cb6b90b$var$setProperty(root, scale, color) {
    root.style.setProperty(`--custom-color-primary-${scale}`, color);
}
const $b78de99e3cb6b90b$var$ThemePort = {
    add: (app)=>{
        app.ports.setTheme.subscribe($b78de99e3cb6b90b$var$setTheme);
    }
};
$b78de99e3cb6b90b$exports = $b78de99e3cb6b90b$var$ThemePort;


var $72eb1b7e8424fce8$exports = {};
const $72eb1b7e8424fce8$var$CustomJavascriptPort = {
    add: function(app) {
        app.ports.fetchCustomJsFile.subscribe(function(customJavascriptFileUrl) {
            var script = document.createElement("script");
            script.src = customJavascriptFileUrl;
            document.head.appendChild(script);
        });
    }
};
$72eb1b7e8424fce8$exports = $72eb1b7e8424fce8$var$CustomJavascriptPort;


var $f4b7f13ee09e6363$exports = {};
const $f4b7f13ee09e6363$var$PageTitlePort = {
    add: function(app) {
        app.ports.updateTitle.subscribe((newText)=>{
            document.getElementsByTagName("title")[0].innerHTML = newText;
        });
    }
};
$f4b7f13ee09e6363$exports = $f4b7f13ee09e6363$var$PageTitlePort;


var $53030c4d0d659628$exports = {};
"use strict";
const $53030c4d0d659628$var$RainforestPort = {
    add: function(app) {
        const insertScriptTag = (rainforestEnv)=>{
            const paymentScript = document.createElement("script");
            if (rainforestEnv === "production") paymentScript.src = "https://static.rainforestpay.com/payment.js";
            else paymentScript.src = "https://static.rainforestpay.com/sandbox.payment.js";
            document.body.appendChild(paymentScript);
        };
        const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        app.ports.rainforestPortLoad.subscribe(function(rainforestEnv) {
            requestAnimationFrame(function() {
                insertScriptTag(rainforestEnv);
            });
        });
        app.ports.rainforestSubmitPaymentMethod.subscribe(function() {
            const component = document.getElementsByTagName("rainforest-payment")[0];
            if (!component) return;
            component.submit();
        });
    }
};
$53030c4d0d659628$exports = $53030c4d0d659628$var$RainforestPort;


var $88841e90a30ba512$exports = {};
const $88841e90a30ba512$var$OnBeforeUnloadPort = {
    add: function(app) {
        window.addEventListener("beforeunload", ()=>{
            app.ports.onBeforeUnload.send(true);
        });
    }
};
$88841e90a30ba512$exports = $88841e90a30ba512$var$OnBeforeUnloadPort;


var $13a1730e1cbf1cc4$exports = {};
const $13a1730e1cbf1cc4$var$OnElementScrollPort = {
    add: function(app) {
        var sendElementScroll = function(element) {
            var scrollInfo = {
                scrollTop: element.scrollTop,
                scrollHeight: element.scrollHeight,
                clientHeight: element.clientHeight,
                atTop: element.scrollTop <= 0,
                atBottom: element.scrollHeight - element.scrollTop - element.clientHeight <= 1
            };
            app.ports.onElementScroll.send(scrollInfo);
        };
        app.ports.setupElementScroll.subscribe((elementId)=>{
            // wait for element creation, if it doesn't exist yet
            var waitTimer = null;
            var waitInterval = 100;
            var waitForElementCreation = function() {
                var element = document.getElementById(elementId);
                if (element) {
                    clearTimeout(waitTimer);
                    listenToElementScroll(element);
                } else waitTimer = setTimeout(function() {
                    clearTimeout(waitTimer);
                    waitForElementCreation();
                }, waitInterval);
            };
            var scrollTimer = null;
            var lastScrollFireTime = 0;
            var minScrollTime = 100;
            var listenToElementScroll = function(element) {
                if (element) {
                    // send scroll event for initial position
                    sendElementScroll(element);
                    element.addEventListener("scroll", ()=>{
                        if (!scrollTimer) {
                            var now = new Date().getTime();
                            if (now - lastScrollFireTime > minScrollTime) {
                                sendElementScroll(element);
                                lastScrollFireTime = now;
                            }
                            scrollTimer = setTimeout(function() {
                                scrollTimer = null;
                                lastScrollFireTime = new Date().getTime();
                                sendElementScroll(element);
                            }, minScrollTime);
                        }
                    });
                }
            };
            waitForElementCreation();
        });
    }
};
$13a1730e1cbf1cc4$exports = $13a1730e1cbf1cc4$var$OnElementScrollPort;


var $b28e419d9143a3c3$exports = {};
const $b28e419d9143a3c3$var$OnTabSelectPort = {
    add: function(app) {
        app.ports.tabSelected.subscribe((tabId)=>{
            app.ports.onTabSelected.send(tabId);
        });
    }
};
$b28e419d9143a3c3$exports = $b28e419d9143a3c3$var$OnTabSelectPort;


var $f2c7c3c854a3894f$exports = {};
const $f2c7c3c854a3894f$var$IntercomPort = {
    add: function(app, key) {
        window.setupIntercom(key);
        app.ports.start.subscribe(function() {
            if (!window.Intercom) return;
            window.Intercom("boot");
        });
    }
};
$f2c7c3c854a3894f$exports = $f2c7c3c854a3894f$var$IntercomPort;


var $085e3b96bb7da772$exports = {};
// @ts-nocheck
var $20afccfd6e25de31$var$SnippetSrcV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function p(b){var h,d=[];function j(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],j())}}return b(r(0),r(1)),{\nthen:function(b,h){return p((function(r,i){d.push([b,h,r,i]),j()}))}}}a&&(g=m[e]=function(){var b=function(b,d,j,r){function i(i,c){\nh(b,d,j,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):p(i)):h(b,d,j,c,c,r)}\n;function h(h,d,j,r,i,c){return b._api?b._api(h,d,j,r,i,c):(b.q&&b.q.push([h,d,j,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){\n\"function\"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var j=0;j<d.length;j++)h(d[j]);d.length=0,d.push=h}},function(){\n(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",o.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)}\n;var b=n.getElementsByTagName(t)[0];b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}(),function(){function b(){}\nfunction h(b,h,d){g(b,h,d,1)}function d(b,d,j){h(\"setProperties\",{type:b,properties:d},j)}function j(b,h){d(\"user\",b,h)}function r(b,h,d){j({\nuid:b},d),h&&j(h,d)}g.identify=r,g.setUserVars=j,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,j){h(\"trackEvent\",{\nname:b,properties:d},j)},g.anonymize=function(){r(!1)},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},\ng.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){h(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")\n}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var $20afccfd6e25de31$var$SnippetSrcV2Delayed = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(d){\nreturn!(d in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function p(b){var d,h=[];function k(){d&&(h.forEach((function(b){var h;try{h=b[d[0]]&&b[d[0]](d[1])}catch(d){return void(b[3]&&b[3](d))}\nh&&h.then?h.then(b[2],b[3]):b[2]&&b[2](h)})),h.length=0)}function r(b){return function(h){d||(d=[b,h],k())}}return b(r(0),r(1)),{\nthen:function(b,d){return p((function(r,i){h.push([b,d,r,i]),k()}))}}}function j(){(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",\no.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)};var b=n.getElementsByTagName(t)[0]\n;b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}a&&(g=m[e]=function(){var b=function(b,h,k,r){function i(i,c){\nd(b,h,k,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):p(i)):d(b,h,k,c,c,r)}\n;function d(d,h,k,r,i,c){return b._api?b._api(d,h,k,r,i,c):(b.q&&b.q.push([d,h,k,r,i,c]),null)}return b.q=[],b}(),y=function(b){function d(d){\n\"function\"==typeof d[4]&&d[4](new Error(b))}var h=g.q;if(h){for(var k=0;k<h.length;k++)d(h[k]);h.length=0,h.push=d}},function(){try{\nvar b=!1,d=\"paint\";if(void 0!==window.PerformanceObserver&&PerformanceObserver.supportedEntryTypes.indexOf(d)>-1){\nvar h=new PerformanceObserver((function(d){for(var k=d.getEntriesByName(\"first-contentful-paint\"),r=0;r<k.length;r++)k[r]&&(h.disconnect(),\nb||(b=!0,j()))}));h.observe({buffered:!0,type:d}),setTimeout((function(){b||(b=!0,j())}),1e3)}else j()}catch(b){}}(),function(){function b(){}\nfunction d(b,d,h){g(b,d,h,1)}function h(b,h,k){d(\"setProperties\",{type:b,properties:h},k)}function k(b,d){h(\"user\",b,d)}function r(b,d,h){k({\nuid:b},h),d&&k(d,h)}g.identify=r,g.setUserVars=k,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=h,g.event=function(b,h,k){d(\"trackEvent\",{\nname:b,properties:h},k)},g.anonymize=function(){r(!1)},g.shutdown=function(){d(\"shutdown\")},g.restart=function(){d(\"restart\")},\ng.log=function(b,h){d(\"log\",{level:b,msg:h})},g.consent=function(b){d(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0.delayed\")\n}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var $20afccfd6e25de31$var$mockSnippetV1 = "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"1.3.0\";\n})(window,document,window['_fs_namespace'],'script','user');";
var $20afccfd6e25de31$var$mockSnippetV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function j(b){var h,d=[];function k(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function i(b){return function(d){h||(h=[b,d],k())}}return b(i(0),i(1)),{\nthen:function(b,h){return j((function(i,c){d.push([b,h,i,c]),k()}))}}}a&&(g=m[e]=function(){var b=function(b,d,k,i){function c(c,r){\nh(b,d,k,c,r,i)}i=i||2;var r,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(c):j(c)):h(b,d,k,r,r,i)}\n;function h(h,d,k,i,c,r){return b._api?b._api(h,d,k,i,c,r):(b.q&&b.q.push([h,d,k,i,c,r]),null)}return b.q=[],b}(),function(){function b(){}\nfunction h(b,h,d){g(b,h,d,1)}function d(b,d,k){h(\"setProperties\",{type:b,properties:d},k)}function k(b,h){d(\"user\",b,h)}function i(b,h,d){k({\nuid:b},d),h&&k(h,d)}g.identify=i,g.setUserVars=k,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,k){h(\"trackEvent\",{\nname:b,properties:d},k)},g.anonymize=function(){i(!1)},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},\ng.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){h(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")\n}(window,document,window._fs_namespace,0,window._fs_script);";
var $20afccfd6e25de31$var$executeSnippet = function executeSnippet() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$wnd = _ref.wnd, wnd = _ref$wnd === void 0 ? window : _ref$wnd, _ref$injectedNamespac = _ref.injectedNamespace, injectedNamespace = _ref$injectedNamespac === void 0 ? wnd['_fs_namespace'] : _ref$injectedNamespac, _ref$injectedScript = _ref.injectedScript, injectedScript = _ref$injectedScript === void 0 ? wnd['_fs_script'] : _ref$injectedScript;
    (function(win, doc, fsNamespace, tagName, fsScript, script, api, rejector) {
        var valid = function checkNamespace(fsNamespace) {
            if (!(fsNamespace in win)) return true;
            if (win.console && win.console.log) win.console.log("FullStory namespace conflict. Please set window[\"_fs_namespace\"].");
            return false;
        }(fsNamespace);
        if (!valid) return;
        function makeThenable(callback) {
            var waiters = [];
            var resolution;
            function flush() {
                if (!resolution) return;
                waiters.forEach(function(waiter) {
                    var result;
                    try {
                        result = waiter[resolution[0]] && waiter[resolution[0]](resolution[1]);
                    } catch (error) {
                        waiter[3] && waiter[3](error);
                        return;
                    }
                    if (result && result.then) result.then(waiter[2], waiter[3]);
                    else waiter[2] && waiter[2](result);
                });
                waiters.length = 0;
            }
            function makeHandler(which) {
                return function(value) {
                    if (resolution) return;
                    resolution = [
                        which,
                        value
                    ];
                    flush();
                };
            }
            callback(makeHandler(0), makeHandler(1));
            function _then(onFulfilled, onRejected) {
                return makeThenable(function(nextResolve, nextReject) {
                    waiters.push([
                        onFulfilled,
                        onRejected,
                        nextResolve,
                        nextReject
                    ]);
                    flush();
                });
            }
            return {
                then: _then
            };
        }
        api = win[fsNamespace] = function createV2API() {
            var FS = function FS(action, options, source, apiVersion) {
                apiVersion = apiVersion || 2;
                function setResolve(resolve, reject) {
                    api(action, options, source, resolve, reject, apiVersion);
                }
                var re = /Async$/;
                if (re.test(action)) {
                    action = action.replace(re, '');
                    // @ts-ignore
                    if (typeof Promise === 'function') // @ts-ignore
                    return new Promise(setResolve);
                    return makeThenable(setResolve);
                }
                var _undefined;
                return api(action, options, source, _undefined, _undefined, apiVersion);
            };
            function api(op, args, source, resolve, reject, apiVersion) {
                // Once fs.js is bootstrapped, we have access to ._api which
                //   handles pushing deferred methods into the queue internally.
                if (FS._api) return FS._api(op, args, source, resolve, reject, apiVersion);
                if (FS.q) FS.q.push([
                    op,
                    args,
                    source,
                    resolve,
                    reject,
                    apiVersion
                ]);
                return null;
            }
            FS.q = [];
            return FS;
        }();
        rejector = function createRejector() {
            // Returns a function called on the error handler of the fs.js script tag.
            // Its purpose is to reject all pending and future asynchronous api calls.
            // The 4th argument to any api operation is always the reject function if it
            // has been called with the "Async" modifier.
            return function(reason) {
                function doReject(operation) {
                    if (typeof operation[4] === 'function') operation[4](new Error(reason));
                }
                var q = api.q;
                if (q) {
                    for(var i = 0; i < q.length; i++)doReject(q[i]);
                    q.length = 0;
                    q.push = doReject;
                }
            };
        }();
        (function insertScript() {
            script = doc.createElement(tagName);
            script.async = true;
            script.crossOrigin = 'anonymous';
            script.src = 'https://' + fsScript;
            script.onerror = function() {
                rejector('Error loading ' + fsScript);
            };
            var firstScript = doc.getElementsByTagName(tagName)[0];
            if (firstScript && firstScript.parentNode) firstScript.parentNode.insertBefore(script, firstScript);
            else doc.head.appendChild(script);
        })();
        (function translateV1API() {
            function noop() {}
            function callAPI(action, option, source) {
                api(action, option, source, 1);
            }
            function setProperties(scope, props, source) {
                callAPI('setProperties', {
                    type: scope,
                    properties: props
                }, source);
            }
            function setUserProperties(props, source) {
                setProperties('user', props, source);
            }
            function identify(uid, customVars, source) {
                setUserProperties({
                    uid: uid
                }, source);
                if (customVars) setUserProperties(customVars, source);
            }
            api.identify = identify;
            api.setUserVars = setUserProperties;
            api.identifyAccount = noop;
            api.clearUserCookie = noop;
            api.setVars = setProperties;
            api.event = function(eventName, eventProps, source) {
                callAPI('trackEvent', {
                    name: eventName,
                    properties: eventProps
                }, source);
            };
            api.anonymize = function() {
                identify(false);
            };
            api.shutdown = function() {
                callAPI('shutdown');
            };
            api.restart = function() {
                callAPI('restart');
            };
            api.log = function(level, msg) {
                callAPI('log', {
                    level: level,
                    msg: msg
                });
            };
            api.consent = function(userConsents) {
                callAPI('setIdentity', {
                    consent: !arguments.length || userConsents
                });
            };
        })();
        (function snapshotGlobals() {
            var f = 'fetch';
            var xhr = 'XMLHttpRequest';
            api._w = {};
            api._w[xhr] = win[xhr];
            api._w[f] = win[f];
            if (win[f]) win[f] = function() {
                return api._w[f].apply(this, arguments);
            };
        })();
        api._v = "2.0.0";
    })(wnd, wnd.document, injectedNamespace, 'script', injectedScript);
};
var $20afccfd6e25de31$var$executeSnippetV1 = function executeSnippetV1() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$wnd = _ref2.wnd, wnd = _ref2$wnd === void 0 ? window : _ref2$wnd, _ref2$injectedNamespa = _ref2.injectedNamespace, injectedNamespace = _ref2$injectedNamespa === void 0 ? wnd['_fs_namespace'] : _ref2$injectedNamespa;
    (function(m, n, e, t, l, o, g, y) {
        if (e in m) {
            if (m.console && m.console.log) m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
            return;
        }
        g = m[e] = function(a, b, s) {
            g.q ? g.q.push([
                a,
                b,
                s
            ]) : g._api(a, b, s);
        };
        g.q = [];
        o = n.createElement(t);
        o.async = 1;
        o.crossOrigin = 'anonymous';
        o.src = 'https://' + _fs_script;
        y = n.getElementsByTagName(t)[0];
        y.parentNode.insertBefore(o, y);
        g.identify = function(i, v, s) {
            g(l, {
                uid: i
            }, s);
            if (v) g(l, v, s);
        };
        g.setUserVars = function(v, s) {
            g(l, v, s);
        };
        g.event = function(i, v, s) {
            g('event', {
                n: i,
                p: v
            }, s);
        };
        g.anonymize = function() {
            g.identify(false);
        };
        g.shutdown = function() {
            g("rec", !1);
        };
        g.restart = function() {
            g("rec", !0);
        };
        g.log = function(a, b) {
            g("log", [
                a,
                b
            ]);
        };
        g.consent = function(a) {
            g("consent", !arguments.length || a);
        };
        g.identifyAccount = function(i, v) {
            o = 'account';
            v = v || {};
            v.acctId = i;
            g(o, v);
        };
        g.clearUserCookie = function() {};
        g.setVars = function(n, p) {
            g('setVars', [
                n,
                p
            ]);
        };
        g._w = {};
        y = 'XMLHttpRequest';
        g._w[y] = m[y];
        y = 'fetch';
        g._w[y] = m[y];
        if (m[y]) m[y] = function() {
            return g._w[y].apply(this, arguments);
        };
        g._v = "1.3.0";
    })(wnd, wnd.document, injectedNamespace, 'script', 'user');
};
var $20afccfd6e25de31$var$getDocumentVar = function getDocumentVar(globalVar) {
    return globalVar === 'window' ? 'document' : "".concat(globalVar, ".document");
};
var $20afccfd6e25de31$var$toV1String = function toV1String() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$shouldInsertScr = _ref3.shouldInsertScript, shouldInsertScript = _ref3$shouldInsertScr === void 0 ? true : _ref3$shouldInsertScr, _ref3$globalVar = _ref3.globalVar, globalVar = _ref3$globalVar === void 0 ? 'window' : _ref3$globalVar, _ref3$globalNamespace = _ref3.globalNamespace, globalNamespace = _ref3$globalNamespace === void 0 ? "".concat(globalVar, "['_fs_namespace']") : _ref3$globalNamespace, _ref3$apiVersion = _ref3.apiVersion, apiVersion = _ref3$apiVersion === void 0 ? '1.3.0' : _ref3$apiVersion;
    return "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];".concat(shouldInsertScript ? "\n    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;\n    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);" : '', "\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"").concat(apiVersion, "\";\n})(").concat(globalVar, ",").concat($20afccfd6e25de31$var$getDocumentVar(globalVar), ",").concat(globalNamespace, ",'script','user');");
};
var $20afccfd6e25de31$export$52a15e44b483bf1c = function initFS(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    window['_fs_host'] = host;
    window['_fs_script'] = script;
    window['_fs_org'] = orgId;
    window['_fs_namespace'] = namespace;
    $20afccfd6e25de31$var$executeSnippet();
};
var $20afccfd6e25de31$export$26bbcb54e60c59be = function initFSV1(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    window['_fs_host'] = host;
    window['_fs_script'] = script;
    window['_fs_org'] = orgId;
    window['_fs_namespace'] = namespace;
    $20afccfd6e25de31$var$executeSnippetV1();
};
var $20afccfd6e25de31$export$41ad23cd2470a6dd = $20afccfd6e25de31$var$SnippetSrcV2;
var $20afccfd6e25de31$export$56870719feaa6534 = $20afccfd6e25de31$var$SnippetSrcV2Delayed;
var $20afccfd6e25de31$export$7ab8f32ee68a385 = $20afccfd6e25de31$var$toV1String();
var $20afccfd6e25de31$export$e843673607dd064a = function generateSnippetText(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat($20afccfd6e25de31$export$41ad23cd2470a6dd, "\n");
};
var $20afccfd6e25de31$export$449f4f90c1f01cdf = function generateSnippetTextV1(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat($20afccfd6e25de31$export$7ab8f32ee68a385, "\n");
};
var $20afccfd6e25de31$export$a91c1a98ec2aac0d = $20afccfd6e25de31$var$mockSnippetV2;
var $20afccfd6e25de31$export$f721247e8e626cdb = $20afccfd6e25de31$var$mockSnippetV1;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $11b7a16c9faddb45$var$__assign = function() {
    $11b7a16c9faddb45$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $11b7a16c9faddb45$var$__assign.apply(this, arguments);
};
var $11b7a16c9faddb45$var$getFullStory = function() {
    if (window._fs_namespace) return window[window._fs_namespace];
    return undefined;
};
var $11b7a16c9faddb45$var$ensureSnippetLoaded = function() {
    var fs = $11b7a16c9faddb45$var$getFullStory();
    if (!fs) throw Error('FullStory is not loaded, please ensure the init function is invoked before calling FullStory API functions');
    return fs;
};
var $11b7a16c9faddb45$var$_init = function(inputOptions, readyCallback) {
    // Make a copy so we can modify `options` if desired.
    var options = $11b7a16c9faddb45$var$__assign({}, inputOptions);
    if ($11b7a16c9faddb45$var$getFullStory()) {
        console.warn('The FullStory snippet has already been defined elsewhere (likely in the <head> element)');
        return;
    }
    // see README for details on the recordCrossDomainIFrames option
    if (options.recordCrossDomainIFrames) window._fs_run_in_iframe = true;
    if (options.appHost) window._fs_app_host = options.appHost;
    if (options.assetMapId) window._fs_asset_map_id = options.assetMapId;
    if (options.startCaptureManually) window._fs_capture_on_startup = false;
    // record the contents of this iFrame when embedded in a parent site
    if (options.recordOnlyThisIFrame) window._fs_is_outer_script = true;
    // Set cookie domain if it was specified.
    if (options.cookieDomain) window._fs_cookie_domain = options.cookieDomain;
    if (options.debug === true) {
        if (!options.script) options.script = 'edge.fullstory.com/s/fs-debug.js';
        else console.warn('Ignoring `debug = true` because `script` is set');
    }
    (0, $20afccfd6e25de31$export$52a15e44b483bf1c)(options);
    var fs = $11b7a16c9faddb45$var$getFullStory();
    if (!fs) {
        console.warn('Failed to initialize FS snippet');
        return;
    }
    if (options.sessionUid) fs('init', {
        env: {
            sessionUid: options.sessionUid
        }
    });
    if (readyCallback) fs('observe', {
        type: 'start',
        callback: readyCallback
    });
    if (options.devMode === true) {
        var message = 'FullStory was initialized in devMode and will stop recording';
        fs('trackEvent', {
            name: 'FullStory Dev Mode',
            properties: {
                message: message
            }
        });
        fs('shutdown');
        window._fs_dev_mode = true;
        console.warn(message);
    }
};
var $11b7a16c9faddb45$var$initOnce = function(message) {
    return function(inputOptions, readyCallback) {
        if (window._fs_initialized) {
            if (message) console.warn(message);
            return;
        }
        $11b7a16c9faddb45$var$_init(inputOptions, readyCallback);
        window._fs_initialized = true;
    };
};
var $11b7a16c9faddb45$export$2cd8252107eb640b = $11b7a16c9faddb45$var$initOnce('FullStory init has already been called once, additional invocations are ignored');
// normalize undefined into boolean
var $11b7a16c9faddb45$export$3f95c6f800b78024 = function() {
    return !!window._fs_initialized;
};
var $11b7a16c9faddb45$var$hasFullStoryWithFunction = function() {
    var testNames = [];
    for(var _i = 0; _i < arguments.length; _i++)testNames[_i] = arguments[_i];
    var fs = $11b7a16c9faddb45$var$ensureSnippetLoaded();
    return testNames.every(function(current) {
        return fs[current];
    });
};
var $11b7a16c9faddb45$var$guard = function(name) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (window._fs_dev_mode) {
            var message = "FullStory is in dev mode and is not capturing: ".concat(name, " method not executed");
            console.warn(message);
            return message;
        }
        var fs = $11b7a16c9faddb45$var$getFullStory();
        if ($11b7a16c9faddb45$var$hasFullStoryWithFunction(name) && fs) return fs[name].apply(fs, args);
        console.warn("FS.".concat(name, " not ready"));
        return null;
    };
};
var $11b7a16c9faddb45$var$buildFullStoryShim = function() {
    var FS = function(operation, options, source) {
        var fs = $11b7a16c9faddb45$var$ensureSnippetLoaded();
        if (window._fs_dev_mode) {
            var message = "FullStory is in dev mode and is not capturing: ".concat(operation, " not executed");
            console.warn(message);
            return undefined;
        }
        return fs(operation, options, source);
    };
    FS.anonymize = $11b7a16c9faddb45$var$guard('anonymize');
    FS.consent = $11b7a16c9faddb45$var$guard('consent');
    FS.disableConsole = $11b7a16c9faddb45$var$guard('disableConsole');
    FS.enableConsole = $11b7a16c9faddb45$var$guard('enableConsole');
    FS.event = $11b7a16c9faddb45$var$guard('event');
    FS.getCurrentSessionURL = $11b7a16c9faddb45$var$guard('getCurrentSessionURL');
    FS.identify = $11b7a16c9faddb45$var$guard('identify');
    FS.log = $11b7a16c9faddb45$var$guard('log');
    FS.restart = $11b7a16c9faddb45$var$guard('restart');
    FS.setUserVars = $11b7a16c9faddb45$var$guard('setUserVars');
    FS.setVars = $11b7a16c9faddb45$var$guard('setVars');
    FS.shutdown = $11b7a16c9faddb45$var$guard('shutdown');
    return FS;
};
var $11b7a16c9faddb45$export$d55ddad8cc9093bd = $11b7a16c9faddb45$var$buildFullStoryShim();


"use strict";
const $085e3b96bb7da772$var$FullStoryPort = {
    add: function(app, orgId) {
        if (orgId) {
            (0, $11b7a16c9faddb45$export$2cd8252107eb640b)({
                orgId: orgId
            });
            app.ports.fullStoryPortInit.subscribe(function(practice) {
                (0, $11b7a16c9faddb45$export$d55ddad8cc9093bd)("setIdentity", {
                    anonymous: true,
                    properties: {
                        practice_id: practice.id,
                        practice_name: practice.name,
                        practice_email: practice.email,
                        sandbox: practice.sandbox
                    }
                });
            });
            app.ports.fullStoryPortIdentifySignup.subscribe(function(onlineEnrollmentId) {
                (0, $11b7a16c9faddb45$export$d55ddad8cc9093bd)("setIdentity", {
                    uid: onlineEnrollmentId,
                    properties: {
                        online_enrollment_id: onlineEnrollmentId
                    }
                });
            });
            app.ports.fullStoryPortIdentifyPatientPortal.subscribe(function(event) {
                (0, $11b7a16c9faddb45$export$d55ddad8cc9093bd)("setIdentity", {
                    uid: event.userId,
                    properties: {
                        scope: event.scope
                    }
                });
            });
            app.ports.fullStoryPortStopCapturing.subscribe(function() {
                (0, $11b7a16c9faddb45$export$d55ddad8cc9093bd)("shutdown");
            });
            app.ports.fullStoryPortLogEvent.subscribe(function(event) {
                const options = Object.assign(event.payload, {
                    app: "member"
                });
                (0, $11b7a16c9faddb45$export$d55ddad8cc9093bd)("trackEvent", {
                    name: event.type,
                    properties: options
                });
            });
        }
    }
};
$085e3b96bb7da772$exports = $085e3b96bb7da772$var$FullStoryPort;


var $15ca76013f461cc0$exports = {};
"use strict";
const $15ca76013f461cc0$var$FaviconPort = {
    add: function(app) {
        if (app.ports.setFaviconPort) app.ports.setFaviconPort.subscribe((favicons)=>{
            let icoLink = document.getElementById("faviconIco");
            let pngLink = document.getElementById("faviconPng");
            let appleLink = document.getElementById("faviconApple");
            icoLink.setAttribute("href", favicons.icoUrl);
            pngLink.setAttribute("href", favicons.pngUrl);
            appleLink.setAttribute("href", favicons.appleUrl);
        });
    }
};
$15ca76013f461cc0$exports = $15ca76013f461cc0$var$FaviconPort;


var $d13a3aa875c41ca7$exports = {};

const $d13a3aa875c41ca7$var$storage = (0, $e8379647cdfd5908$exports.storageFactory)(()=>localStorage);
const $d13a3aa875c41ca7$var$IdleTimePort = {
    add: (app)=>{
        const storageKey = "lastActivityAt";
        const oneMinMs = 60000;
        const halfMinMs = 30000;
        const sessionInactivityThreshold = 60; // matches JWT expiration
        const idleThresholdMs = sessionInactivityThreshold * oneMinMs;
        function throttle(func, timeFrame) {
            var lastTime = 0;
            return function() {
                var now = Date.now();
                if (now - lastTime >= timeFrame) {
                    func();
                    lastTime = now;
                }
            };
        }
        function checkIdleTimeAndlogout() {
            const lastActivityAt = parseInt($d13a3aa875c41ca7$var$storage.getItem(storageKey));
            const now = Date.now();
            if (lastActivityAt && now - lastActivityAt > idleThresholdMs) app.ports.idleUser.send(true);
        }
        const trackLastActivity = ()=>{
            $d13a3aa875c41ca7$var$storage.setItem(storageKey, Date.now());
        };
        setInterval(checkIdleTimeAndlogout, oneMinMs);
        window.addEventListener("mousemove", throttle(trackLastActivity, halfMinMs));
        window.addEventListener("keypress", throttle(trackLastActivity, halfMinMs));
    }
};
$d13a3aa875c41ca7$exports = $d13a3aa875c41ca7$var$IdleTimePort;


var $d2be32b72d8b955d$exports = {};
"use strict";
const $d2be32b72d8b955d$var$ScrollDetectionPort = {
    add: function(app) {
        if (app.ports.setupScrollDetection) app.ports.setupScrollDetection.subscribe(({ containerId: containerId })=>{
            // Find the visible container (not hidden by CSS)
            const allContainers = document.querySelectorAll(`#${containerId}`);
            let targetContainer = null;
            for (let container of allContainers){
                const style = getComputedStyle(container);
                if (style.display !== "none" && style.visibility !== "hidden" && container.offsetParent !== null) {
                    targetContainer = container;
                    break;
                }
            }
            if (targetContainer) {
                targetContainer.removeEventListener("scroll", handleScroll);
                targetContainer.addEventListener("scroll", handleScroll, {
                    passive: true
                });
            } else console.warn(`Container with id "${containerId}" not found when trying to setup scroll detection`);
        });
        const handleScroll = (event)=>{
            const container = event.target;
            const containerId = container.id;
            const scrollInfo = {
                containerId: containerId,
                x: container.scrollLeft,
                y: container.scrollTop,
                scrollHeight: container.scrollHeight,
                clientHeight: container.clientHeight
            };
            app.ports.onScroll.send(scrollInfo);
        };
    }
};
$d2be32b72d8b955d$exports = $d2be32b72d8b955d$var$ScrollDetectionPort;


var $a8ede6276a337434$exports = {};
let $a8ede6276a337434$var$selectedFiles = [];
function $a8ede6276a337434$var$initFileSelection(app) {
    if (!app.ports.openFileDialogPort || !app.ports.onFileSelectedPort) return;
    app.ports.openFileDialogPort.subscribe((acceptedTypes)=>{
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.style.display = "none";
        fileInput.accept = acceptedTypes || "*/*";
        fileInput.multiple = true;
        fileInput.addEventListener("change", (event)=>{
            const files = Array.from(event.target.files);
            if (files.length > 0) {
                $a8ede6276a337434$var$selectedFiles = files;
                const fileInfos = files.map((file)=>({
                        name: file.name,
                        size: file.size,
                        type: file.type || "application/octet-stream"
                    }));
                app.ports.onFileSelectedPort.send(fileInfos);
            } else {
                $a8ede6276a337434$var$selectedFiles = [];
                app.ports.onFileSelectedPort.send([]);
            }
            document.body.removeChild(fileInput);
        });
        document.body.appendChild(fileInput);
        fileInput.click();
    });
}
function $a8ede6276a337434$var$getSelectedFile(index) {
    return $a8ede6276a337434$var$selectedFiles[index] || null;
}
$a8ede6276a337434$exports = {
    initFileSelection: $a8ede6276a337434$var$initFileSelection,
    getSelectedFile: $a8ede6276a337434$var$getSelectedFile
};


var $70bed06a98643566$exports = {};
/**
 * File Upload Port Handler
 * Handles file uploads to API via multipart/form-data
 */ 
var $70bed06a98643566$require$getSelectedFile = $a8ede6276a337434$exports.getSelectedFile;
const $70bed06a98643566$var$FileUploadPort = {
    add: function(app) {
        if (app.ports && app.ports.uploadFileToApi) app.ports.uploadFileToApi.subscribe(async ({ request: request, url: url })=>{
            try {
                const file = $70bed06a98643566$require$getSelectedFile(request.fileIndex);
                if (!file) throw new Error("File not found at index " + request.fileIndex);
                const formData = new FormData();
                formData.append("file", file);
                const response = await fetch(url, {
                    method: "POST",
                    body: formData,
                    headers: {
                        Authorization: `Bearer ${request.authToken}`
                    }
                });
                if (response.ok) {
                    const result = await response.json();
                    if (app.ports.fileUploadResult) app.ports.fileUploadResult.send({
                        fileIndex: request.fileIndex,
                        success: true,
                        filePath: result.filePath,
                        filename: result.filename
                    });
                } else {
                    const errorText = await response.text();
                    throw new Error(`Upload failed with status: ${response.status} - ${errorText}`);
                }
            } catch (error) {
                console.error("FileUpload: Upload failed", error);
                if (app.ports.fileUploadResult) app.ports.fileUploadResult.send({
                    fileIndex: request.fileIndex,
                    success: false,
                    filePath: "",
                    filename: "",
                    error: error.message
                });
            }
        });
    }
};
$70bed06a98643566$exports = $70bed06a98643566$var$FileUploadPort;


var $ba7a6a20ab3b4d24$exports = {};
const $ba7a6a20ab3b4d24$var$ElementMeasurementPort = {
    add: function(app) {
        const observers = new Map();
        const resizeObserver = new ResizeObserver((entries)=>{
            entries.forEach((entry)=>{
                const elementId = entry.target.id;
                const config = observers.get(elementId);
                if (config) measureElement(entry.target, config, app);
            });
        });
        const measureElement = (element, config, app)=>{
            const { elementId: elementId, maxLines: maxLines } = config;
            const computedStyle = window.getComputedStyle(element);
            let lineHeight = parseFloat(computedStyle.lineHeight);
            if (isNaN(lineHeight) || lineHeight === 0) {
                const fontSize = parseFloat(computedStyle.fontSize);
                lineHeight = fontSize * 1.5;
            }
            const scrollHeight = element.scrollHeight;
            const maxHeight = lineHeight * maxLines;
            const tolerance = 2;
            const exceedsMaxLines = scrollHeight > maxHeight + tolerance;
            app.ports.onElementMeasured.send({
                elementId: elementId,
                scrollHeight: scrollHeight,
                clientHeight: element.clientHeight,
                lineHeight: lineHeight,
                exceedsMaxLines: exceedsMaxLines
            });
        };
        const setupObserver = (element, config, app)=>{
            const mutationObserver = new MutationObserver((mutations)=>{
                let shouldMeasure = false;
                mutations.forEach((mutation)=>{
                    if (mutation.type === "childList" || mutation.type === "characterData" || mutation.type === "attributes" && (mutation.attributeName === "style" || mutation.attributeName === "class")) shouldMeasure = true;
                });
                if (shouldMeasure) requestAnimationFrame(()=>measureElement(element, config, app));
            });
            mutationObserver.observe(element, {
                childList: true,
                subtree: true,
                characterData: true,
                attributes: true,
                attributeFilter: [
                    "style",
                    "class"
                ]
            });
            resizeObserver.observe(element);
            return mutationObserver;
        };
        app.ports.measureElement.subscribe(function(config) {
            const { elementId: elementId } = config;
            const element = document.getElementById(elementId);
            if (!element) {
                console.warn(`Element with id "${elementId}" not found for measurement`);
                return;
            }
            if (observers.has(elementId)) {
                const existingObserver = observers.get(elementId).observer;
                existingObserver.disconnect();
                resizeObserver.unobserve(element);
            }
            const observer = setupObserver(element, config, app);
            observers.set(elementId, {
                ...config,
                observer: observer
            });
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>measureElement(element, config, app));
            });
        });
        return function cleanup() {
            observers.forEach(({ observer: observer }, elementId)=>{
                observer.disconnect();
                const element = document.getElementById(elementId);
                if (element) resizeObserver.unobserve(element);
            });
            observers.clear();
            resizeObserver.disconnect();
        };
    }
};
$ba7a6a20ab3b4d24$exports = $ba7a6a20ab3b4d24$var$ElementMeasurementPort;


var $3b9526d384f0dd3d$exports = {};
"use strict";
const $3b9526d384f0dd3d$var$DropdownPort = {
    add: function(app) {
        // Handle outside click to close dropdown
        document.addEventListener("click", (event)=>{
            const dropdown = event.target.closest(".dropdown");
            if (!dropdown) {
                if (app.ports.onDropdownOutsideClick) app.ports.onDropdownOutsideClick.send("");
                return;
            }
            // Clicked inside a dropdown, check if it's the toggle button
            const toggleButton = dropdown.querySelector(".dropdown-toggle");
            if (toggleButton && toggleButton.contains(event.target)) // Toggle button clicked, let Elm handle it
            return;
        // Clicked inside dropdown but not on toggle, don't close
        // (This allows clicking on dropdown items without closing)
        });
        // Handle escape key to close dropdown
        document.addEventListener("keydown", function(event) {
            if (event.key === "Escape") {
                const dropdown = document.querySelector(".dropdown--open");
                if (dropdown) {
                    event.stopPropagation();
                    if (app.ports.onDropdownEscapeKeyPressed) app.ports.onDropdownEscapeKeyPressed.send("");
                }
            }
        }, {
            capture: true
        });
    }
};
$3b9526d384f0dd3d$exports = $3b9526d384f0dd3d$var$DropdownPort;


var $8e7e1145409c40a4$exports = {};
const $8e7e1145409c40a4$var$TextareaAutoResizePort = {
    add: function(app) {
        const elements = new Map();
        const getMaxHeight = ()=>{
            const viewportHeight = window.visualViewport?.height || window.innerHeight;
            return Math.min(viewportHeight * 0.4, 300);
        };
        const resizeTextarea = (element)=>{
            element.style.height = "auto";
            const scrollHeight = element.scrollHeight;
            const maxHeight = getMaxHeight();
            element.style.height = Math.min(scrollHeight, maxHeight) + "px";
            element.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
        };
        const setupElement = (elementId)=>{
            if (elements.has(elementId)) return;
            const element = document.getElementById(elementId);
            if (!element) return;
            const handleResize = ()=>{
                resizeTextarea(element);
            };
            element.addEventListener("input", handleResize);
            window.addEventListener("resize", handleResize);
            const visualViewport = window.visualViewport;
            if (visualViewport) visualViewport.addEventListener("resize", handleResize);
            elements.set(elementId, {
                element: element,
                handleResize: handleResize
            });
            resizeTextarea(element);
        };
        app.ports.autoResize.subscribe(function(elementId) {
            setupElement(elementId);
            const elementData = elements.get(elementId);
            if (elementData) setTimeout(()=>resizeTextarea(elementData.element), 0);
        });
    }
};
$8e7e1145409c40a4$exports = $8e7e1145409c40a4$var$TextareaAutoResizePort;


var $5ce5aeca99e3b2a2$exports = {};
var $dec4823f049ade19$var$d = (r, t, e)=>new Promise((c, f)=>{
        var o = (s)=>{
            try {
                a(e.next(s));
            } catch (u) {
                f(u);
            }
        }, n = (s)=>{
            try {
                a(e.throw(s));
            } catch (u) {
                f(u);
            }
        }, a = (s)=>s.done ? c(s.value) : Promise.resolve(s.value).then(o, n);
        a((e = e.apply(r, t)).next());
    });
var $dec4823f049ade19$export$cf709db89eaa620b = (r)=>$dec4823f049ade19$var$d(null, null, function*() {
        let e = (yield r.arrayBuffer()).slice(8, 12);
        switch(new TextDecoder("utf-8").decode(e).replace("\0", " ").trim()){
            case "mif1":
                return !0;
            case "msf1":
                return !0;
            case "heic":
            case "heix":
                return !0;
            case "hevc":
            case "hevx":
                return !0;
        }
        return !1;
    }), $dec4823f049ade19$var$i, $dec4823f049ade19$var$g = ()=>{
    if (!$dec4823f049ade19$var$i) {
        let r = '(()=>{var IK=Object.defineProperty;var QK=(H1,I1,D1)=>I1 in H1?IK(H1,I1,{enumerable:!0,configurable:!0,writable:!0,value:D1}):H1[I1]=D1;var Uk=(H1=>typeof require!="undefined"?require:typeof Proxy!="undefined"?new Proxy(H1,{get:(I1,D1)=>(typeof require!="undefined"?require:I1)[D1]}):H1)(function(H1){if(typeof require!="undefined")return require.apply(this,arguments);throw Error(\'Dynamic require of "\'+H1+\'" is not supported\')});var VK=(H1,I1)=>()=>(H1&&(I1=H1(H1=0)),I1);var pK=(H1,I1)=>()=>(I1||H1((I1={exports:{}}).exports,I1),I1.exports);var y8=(H1,I1,D1)=>QK(H1,typeof I1!="symbol"?I1+"":I1,D1);var D6=(H1,I1,D1)=>new Promise((_8,L)=>{var U6=x4=>{try{oe(D1.next(x4))}catch(E8){L(E8)}},M6=x4=>{try{oe(D1.throw(x4))}catch(E8){L(E8)}},oe=x4=>x4.done?_8(x4.value):Promise.resolve(x4.value).then(U6,M6);oe((D1=D1.apply(H1,I1)).next())});var FK,Qw,Vw=VK(()=>{FK=(()=>{var I1;var H1=typeof document!="undefined"?(I1=document.currentScript)==null?void 0:I1.src:void 0;return(function(D1={}){var _8,L=D1,U6,M6,oe=new Promise((J,H)=>{U6=J,M6=H}),x4=typeof window=="object",E8=typeof WorkerGlobalScope!="undefined",H6=typeof process=="object"&&typeof process.versions=="object"&&typeof process.versions.node=="string"&&process.type!="renderer",Hk=[],Ef="./this.program",Fw=(J,H)=>{throw H};typeof __filename!="undefined"?H1=__filename:E8&&(H1=self.location.href);var Ir="";function Cw(J){return L.locateFile?L.locateFile(J,Ir):Ir+J}var Rf,le;if(H6){var Jf=Uk("fs"),yK=Uk("path");Ir=__dirname+"/",le=J=>{J=Nf(J)?new URL(J):J;var H=Jf.readFileSync(J);return H},Rf=(J,H=!0)=>D6(null,null,function*(){J=Nf(J)?new URL(J):J;var P=Jf.readFileSync(J,H?void 0:"utf8");return P}),process.argv.length>1&&(Ef=process.argv[1].replace(/\\\\/g,"/")),Hk=process.argv.slice(2),Fw=(J,H)=>{throw process.exitCode=J,H}}else if(x4||E8){try{Ir=new URL(".",H1).href}catch(J){}E8&&(le=J=>{var H=new XMLHttpRequest;return H.open("GET",J,!1),H.responseType="arraybuffer",H.send(null),new Uint8Array(H.response)}),Rf=J=>D6(null,null,function*(){if(Nf(J))return new Promise((P,K)=>{var e0=new XMLHttpRequest;e0.open("GET",J,!0),e0.responseType="arraybuffer",e0.onload=()=>{if(e0.status==200||e0.status==0&&e0.response){P(e0.response);return}K(e0.status)},e0.onerror=K,e0.send(null)});var H=yield fetch(J,{credentials:"same-origin"});if(H.ok)return H.arrayBuffer();throw new Error(H.status+" : "+H.url)})}var Qr=console.log.bind(console),ue=console.error.bind(console),Vr,wi={Memory:function(J){this.buffer=new ArrayBuffer(J.initial*65536)},Module:function(J){},Instance:function(J,H){this.exports=(function(K){function e0(V1){return V1.set=function(E1,t){this[E1]=t},V1.get=function(E1){return this[E1]},V1}for(var b,v0=new Uint8Array(123),W0=25;W0>=0;--W0)v0[48+W0]=52+W0,v0[65+W0]=W0,v0[97+W0]=26+W0;v0[43]=62,v0[47]=63;function m0(V1,E1,t){for(var X,i,u=0,p=E1,o0=t.length,E0=E1+(o0*3>>2)-(t[o0-2]=="=")-(t[o0-1]=="=");u<o0;u+=4)X=v0[t.charCodeAt(u+1)],i=v0[t.charCodeAt(u+2)],V1[p++]=v0[t.charCodeAt(u)]<<2|X>>4,p<E0&&(V1[p++]=X<<4|i>>2),p<E0&&(V1[p++]=i<<6|v0[t.charCodeAt(u+3)]);return V1}function d0(V1){m0(b,1024,"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"),m0(b,52422,"AQ=="),m0(b,52439,"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"),m0(b,55102,"AQ=="),m0(b,55119,"QDE1TWRhdERhdGFfTWVtb3J5ADhNZGF0RGF0YQADAAAAAAAAAAoAAAALAAAADAAAAA0AAAAOAAAADwAAADE0SGVpZlBpeGVsSW1hZ2UATlN0M19fMjIzZW5hYmxlX3NoYXJlZF9mcm9tX3RoaXNJMTRIZWlmUGl4ZWxJbWFnZUVFADExRXJyb3JCdWZmZXIAMTZJbWFnZURlc2NyaXB0aW9uAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE4Y29sb3JfcHJvZmlsZV9uY2x4TlNfOWFsbG9jYXRvcklTMV9FRUVF"),m0(b,55364,"AQAAAAIAAAADAAAABAAAAAUAAAAGAAAADAAAAA0AAAD//wAACwAAADE3Y29sb3JfcHJvZmlsZV9yYXcAMThjb2xvcl9wcm9maWxlX25jbHgAOEJveF9jb2xyAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE3Y29sb3JfcHJvZmlsZV9yYXdOU185YWxsb2NhdG9ySVMxX0VFRUUAAACamZk+AAAAAAAAAAA9Clc+4XqUPlK4nj5SuJ4+/tR4PnsULj4AAAAAFK6HPhSuhz4="),m0(b,55612,"PQqXPpqZGT8AAAAAAAAAAI/CNT+amRk/7FEYP+xRGD/pJjE/MQhMPwAAgD/XozA/16MwPw=="),m0(b,55700,"SOEaP5qZGT4AAAAAAAAAAClcDz6amRk+UrgePlK4Hj7hehQ+3SQGPgAAAACamRk+mpkZPg=="),m0(b,55788,"UrgePo/CdT0AAAAAAAAAAArXoz2PwnU9KVyPPSlcjz05tEg9f2o8PQAAAACPwnU9j8J1PQ=="),m0(b,55876,"LbKdPQrXIz8AAAAAAAAAAB+FKz8K1yM/rkchP65HIT8EVi4/fT81PwAAgD97FC4/exQuPw=="),m0(b,55964,"rkchP8P1qD4AAAAAAAAAAMP1qD7D9ag+exSuPnsUrj74U6M+BoGVPgAAAAAK16M+CtejPg=="),m0(b,56052,"exSuPjcaoD4AAAAAAAAAAFK4nj43GqA+NxqgPjcaoD5SuJ4+NxqgPp+qqj6cxKA+NxqgPg=="),m0(b,56140,"NxqgPrByqD4AAAAAAAAAAMHKoT6wcqg+sHKoPrByqD7ByqE+sHKoPjuqqj5GtrM+sHKoPg=="),m0(b,56228,"sHKoPkAAAAAQAAAAEAAAAIAAAACAAAAAAAAAAEA="),m0(b,56268,"QAAAAAEAAAACAAAAAgAAAAEAAAABAAAAAgAAAAEAAAABAAAAMjBSZWdpb25HZW9tZXRyeV9Qb2ludAAyNFJlZ2lvbkdlb21ldHJ5X1JlY3RhbmdsZQAyMlJlZ2lvbkdlb21ldHJ5X0VsbGlwc2UAMjlSZWdpb25HZW9tZXRyeV9SZWZlcmVuY2VkTWFzawAyMlJlZ2lvbkdlb21ldHJ5X1BvbHlnb24AMjVSZWdpb25HZW9tZXRyeV9JbmxpbmVNYXNrAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTIwUmVnaW9uR2VvbWV0cnlfUG9pbnROU185YWxsb2NhdG9ySVMxX0VFRUUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMjRSZWdpb25HZW9tZXRyeV9SZWN0YW5nbGVOU185YWxsb2NhdG9ySVMxX0VFRUUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMjJSZWdpb25HZW9tZXRyeV9FbGxpcHNlTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTIyUmVnaW9uR2VvbWV0cnlfUG9seWdvbk5TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkyOVJlZ2lvbkdlb21ldHJ5X1JlZmVyZW5jZWRNYXNrTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTI1UmVnaW9uR2VvbWV0cnlfSW5saW5lTWFza05TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMTJiYXNpY19zdHJpbmdJY05TXzExY2hhcl90cmFpdHNJY0VFTlNfOWFsbG9jYXRvckljRUVFRQBwcAAxMGhlaWZfZXJyb3IAUDEyaGVpZl9jb250ZXh0ADEyaGVpZl9jb250ZXh0AHBwcHAAMjBoZWlmX2ZpbGV0eXBlX3Jlc3VsdABpcHAATjEwZW1zY3JpcHRlbjN2YWxFAHBwcABwcHBpAFAxN2hlaWZfaW1hZ2VfaGFuZGxlADE3aGVpZl9pbWFnZV9oYW5kbGUAMTVoZWlmX2NvbG9yc3BhY2UAMTFoZWlmX2Nocm9tYQBwcHBpaQAAAAAAAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAoAAABQMTBoZWlmX2ltYWdlADEwaGVpZl9pbWFnZQAxMmhlaWZfY2hhbm5lbABOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0loRUUAaXAAdnBwAFBLMTdoZWlmX2ltYWdlX2hhbmRsZQBQSzEwaGVpZl9pbWFnZQBQSzEyaGVpZl9jb250ZXh0AGlwcGkAMTVoZWlmX2Vycm9yX2NvZGUAMThoZWlmX3N1YmVycm9yX2NvZGUAMjNoZWlmX2NvbXByZXNzaW9uX2Zvcm1hdAAzNGhlaWZfY2hyb21hX2Rvd25zYW1wbGluZ19hbGdvcml0aG0AMzJoZWlmX2Nocm9tYV91cHNhbXBsaW5nX2FsZ29yaXRobQB2AHZwAHAAdnBwaQB2cHBwAAAAAAEAAAACAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAAFgAAAAEAAAACAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAAAAAAAEAAAACAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAABmaXZhY2llaHhpZWhpazJqZ2VwamZhaW0xZmltMmZpbTNmaW0xZnNtbW9zaTE0cG0yNHBt"),m0(b,57744,"AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAACAAAAAQAAAAQAAAADAAAACAAAAAcAAAAGAAAABQAAAAMAAAAEAAAAAQAAAAIAAAAHAAAACAAAAAUAAAAGAAAABAAAAAMAAAACAAAAAQAAAAYAAAAFAAAACAAAAAcAAAAFAAAABgAAAAcAAAAIAAAAAQAAAAIAAAADAAAABAAAAAYAAAAFAAAACAAAAAcAAAAEAAAAAwAAAAIAAAABAAAABwAAAAgAAAAFAAAABgAAAAMAAAAEAAAAAQAAAAIAAAAIAAAABwAAAAYAAAAFAAAAAgAAAAEAAAAEAAAAAwAAAAEAAAAEAAAAAwAAAAcAAAAKAAAABQAAAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTExSGVpZkNvbnRleHROU185YWxsb2NhdG9ySVMxX0VFRUUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTdTdHJlYW1SZWFkZXJfQ0FwaU5TXzlhbGxvY2F0b3JJUzFfRUVFRQA3RGVjb2RlcgBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxMkRlY29kZXJfSEVWQ05TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxMkRlY29kZXJfQVZJRk5TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxMURlY29kZXJfQVZDTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE2RGVjb2Rlcl9KUEVHMjAwME5TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxMURlY29kZXJfVlZDTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTEyRGVjb2Rlcl9KUEVHTlNfOWFsbG9jYXRvcklTMV9FRUVFADE0SW1hZ2VJdGVtX0hFVkMATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTJFbmNvZGVyX0hFVkNOU185YWxsb2NhdG9ySVMxX0VFRUUAOEJveF9odmNDAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTM2U0VJTWVzc2FnZV9kZXB0aF9yZXByZXNlbnRhdGlvbl9pbmZvTlNfOWFsbG9jYXRvcklTMV9FRUVFADEyRGVjb2Rlcl9IRVZDADEyRW5jb2Rlcl9IRVZDADdFbmNvZGVyADE0SW1hZ2VJdGVtX0FWSUYATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTJFbmNvZGVyX0FWSUZOU185YWxsb2NhdG9ySVMxX0VFRUUAMTJFbmNvZGVyX0FWSUYAMTJEZWNvZGVyX0FWSUYAOEJveF9hdjFDADhCb3hfYTFvcAA4Qm94X2ExbHgAMTRJbWFnZUl0ZW1fSlBFRwBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxMkVuY29kZXJfSlBFR05TXzlhbGxvY2F0b3JJUzFfRUVFRQA4Qm94X2pwZ0M="),m0(b,59040,"AQEBAQABAQEAAQEBAAEBATEyRGVjb2Rlcl9KUEVHADEyRW5jb2Rlcl9KUEVHADE4SW1hZ2VJdGVtX0pQRUcyMDAwAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE2RW5jb2Rlcl9KUEVHMjAwME5TXzlhbGxvY2F0b3JJUzFfRUVFRQAxNkRlY29kZXJfSlBFRzIwMDAAMTZFbmNvZGVyX0pQRUcyMDAwADEzRW5jb2Rlcl9IVEoySwA4Qm94X2NkZWYAOEJveF9jbWFwADhCb3hfcGNscgA4Qm94X2oya0wAOEJveF9qMmtIADEzSW1hZ2VJdGVtX1ZWQwBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxMUVuY29kZXJfVlZDTlNfOWFsbG9jYXRvcklTMV9FRUVFADExRGVjb2Rlcl9WVkMAMTFFbmNvZGVyX1ZWQwA4Qm94X3Z2Y0MAMTNJbWFnZUl0ZW1fQVZDAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTExRW5jb2Rlcl9BVkNOU185YWxsb2NhdG9ySVMxX0VFRUUAAAAAZAAAAG4AAAB6AAAA9AAAACwAAABTAAAAVgAAADhCb3hfYXZjQwAxMURlY29kZXJfQVZDADExRW5jb2Rlcl9BVkMAOEJveF9tc2tDADE0SW1hZ2VJdGVtX21hc2sAOUltYWdlSXRlbQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxNEltYWdlSXRlbV9KUEVHTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE0SW1hZ2VJdGVtX0hFVkNOU185YWxsb2NhdG9ySVMxX0VFRUUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTRJbWFnZUl0ZW1fQVZJRk5TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxM0ltYWdlSXRlbV9WVkNOU185YWxsb2NhdG9ySVMxX0VFRUUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTNJbWFnZUl0ZW1fQVZDTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE4SW1hZ2VJdGVtX0pQRUcyMDAwTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE0SW1hZ2VJdGVtX21hc2tOU185YWxsb2NhdG9ySVMxX0VFRUUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTRJbWFnZUl0ZW1fR3JpZE5TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxN0ltYWdlSXRlbV9PdmVybGF5TlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE0SW1hZ2VJdGVtX2lkZW5OU185YWxsb2NhdG9ySVMxX0VFRUUAAAAAAAAAAAMAAAAAAAAAMTRJbWFnZUl0ZW1fR3JpZABOU3QzX18yMjBfX3NoYXJlZF9wdHJfcG9pbnRlcklQTlNfNnZlY3Rvckk1RXJyb3JOU185YWxsb2NhdG9ySVMyX0VFRUVOU18xMHNoYXJlZF9wdHJJUzVfRTI3X19zaGFyZWRfcHRyX2RlZmF1bHRfZGVsZXRlSVM1X1M1X0VFTlMzX0lTNV9FRUVFAE5TdDNfXzIxMHNoYXJlZF9wdHJJTlNfNnZlY3Rvckk1RXJyb3JOU185YWxsb2NhdG9ySVMyX0VFRUVFMjdfX3NoYXJlZF9wdHJfZGVmYXVsdF9kZWxldGVJUzVfUzVfRUUAMTdJbWFnZUl0ZW1fT3ZlcmxheQAxNEltYWdlSXRlbV9pZGVuADhCb3hfdGlsQwAxNUltYWdlSXRlbV9UaWxlZABOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxOE9wX1JHQl90b19SR0IyNF8zMk5TXzlhbGxvY2F0b3JJUzFfRUVFRQAyNENvbG9yQ29udmVyc2lvbk9wZXJhdGlvbgBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxOE9wX1JHQjI0XzMyX3RvX1JHQk5TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxNU9wX1lDYkNyX3RvX1JHQkl0RU5TXzlhbGxvY2F0b3JJUzJfRUVFRQAxNU9wX1lDYkNyX3RvX1JHQkl0RQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxNU9wX1lDYkNyX3RvX1JHQkloRU5TXzlhbGxvY2F0b3JJUzJfRUVFRQAxNU9wX1lDYkNyX3RvX1JHQkloRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkyME9wX1lDYkNyNDIwX3RvX1JHQjI0TlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTIwT3BfWUNiQ3I0MjBfdG9fUkdCMzJOU185YWxsb2NhdG9ySVMxX0VFRUUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMjNPcF9ZQ2JDcjQyMF90b19SUkdHQkJhYU5TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkyNU9wX1JHQl9IRFJfdG9fUlJHR0JCYWFfQkVOU185YWxsb2NhdG9ySVMxX0VFRUUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMjFPcF9SR0JfdG9fUlJHR0JCYWFfQkVOU185YWxsb2NhdG9ySVMxX0VFRUUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTlPcF9tb25vX3RvX1lDYkNyNDIwTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE5T3BfbW9ub190b19SR0IyNF8zMk5TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkyOU9wX2JheWVyX2JpbGluZWFyX3RvX1JHQjI0XzMyTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTI3T3BfUlJHR0JCYWFfc3dhcF9lbmRpYW5uZXNzTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTI1T3BfUlJHR0JCYWFfQkVfdG9fUkdCX0hEUk5TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkyME9wX1JHQjI0XzMyX3RvX1lDYkNyTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE1T3BfUkdCX3RvX1lDYkNySWhFTlNfOWFsbG9jYXRvcklTMl9FRUVFADE1T3BfUkdCX3RvX1lDYkNySWhFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE1T3BfUkdCX3RvX1lDYkNySXRFTlNfOWFsbG9jYXRvcklTMl9FRUVFADE1T3BfUkdCX3RvX1lDYkNySXRFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTI3T3BfUlJHR0JCeHhfSERSX3RvX1lDYkNyNDIwTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTI3T3BfUkdCMjRfMzJfdG9fWUNiQ3I0NDRfR0JSTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE5T3BfZHJvcF9hbHBoYV9wbGFuZU5TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkyMk9wX2ZsYXR0ZW5fYWxwaGFfcGxhbmVJaEVOU185YWxsb2NhdG9ySVMyX0VFRUUAMjJPcF9mbGF0dGVuX2FscGhhX3BsYW5lSWhFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTIyT3BfZmxhdHRlbl9hbHBoYV9wbGFuZUl0RU5TXzlhbGxvY2F0b3JJUzJfRUVFRQAyMk9wX2ZsYXR0ZW5fYWxwaGFfcGxhbmVJdEUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMjVPcF9hZGp1c3RfYWxwaGFfYml0X2RlcHRoTlNfOWFsbG9jYXRvcklTMV9FRUVFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE2T3BfdG9faGRyX3BsYW5lc05TXzlhbGxvY2F0b3JJUzFfRUVFRQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxNk9wX3RvX3Nkcl9wbGFuZXNOU185YWxsb2NhdG9ySVMxX0VFRUUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMzJPcF9ZQ2JDcjQyMF9iaWxpbmVhcl90b19ZQ2JDcjQ0NEloRU5TXzlhbGxvY2F0b3JJUzJfRUVFRQAzMk9wX1lDYkNyNDIwX2JpbGluZWFyX3RvX1lDYkNyNDQ0SWhFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTMyT3BfWUNiQ3I0MjBfYmlsaW5lYXJfdG9fWUNiQ3I0NDRJdEVOU185YWxsb2NhdG9ySVMyX0VFRUUAMzJPcF9ZQ2JDcjQyMF9iaWxpbmVhcl90b19ZQ2JDcjQ0NEl0RQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkzMk9wX1lDYkNyNDIyX2JpbGluZWFyX3RvX1lDYkNyNDQ0SWhFTlNfOWFsbG9jYXRvcklTMl9FRUVFADMyT3BfWUNiQ3I0MjJfYmlsaW5lYXJfdG9fWUNiQ3I0NDRJaEUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMzJPcF9ZQ2JDcjQyMl9iaWxpbmVhcl90b19ZQ2JDcjQ0NEl0RU5TXzlhbGxvY2F0b3JJUzJfRUVFRQAzMk9wX1lDYkNyNDIyX2JpbGluZWFyX3RvX1lDYkNyNDQ0SXRFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTMxT3BfWUNiQ3I0NDRfdG9fWUNiQ3I0MjBfYXZlcmFnZUloRU5TXzlhbGxvY2F0b3JJUzJfRUVFRQAzMU9wX1lDYkNyNDQ0X3RvX1lDYkNyNDIwX2F2ZXJhZ2VJaEUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMzFPcF9ZQ2JDcjQ0NF90b19ZQ2JDcjQyMF9hdmVyYWdlSXRFTlNfOWFsbG9jYXRvcklTMl9FRUVFADMxT3BfWUNiQ3I0NDRfdG9fWUNiQ3I0MjBfYXZlcmFnZUl0RQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkzMU9wX1lDYkNyNDQ0X3RvX1lDYkNyNDIyX2F2ZXJhZ2VJaEVOU185YWxsb2NhdG9ySVMyX0VFRUUAMzFPcF9ZQ2JDcjQ0NF90b19ZQ2JDcjQyMl9hdmVyYWdlSWhFAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTMxT3BfWUNiQ3I0NDRfdG9fWUNiQ3I0MjJfYXZlcmFnZUl0RU5TXzlhbGxvY2F0b3JJUzJfRUVFRQAzMU9wX1lDYkNyNDQ0X3RvX1lDYkNyNDIyX2F2ZXJhZ2VJdEUATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMjlPcF9BbnlfUkdCX3RvX1lDYkNyXzQyMF9TaGFycE5TXzlhbGxvY2F0b3JJUzFfRUVFRQAyN09wX1JSR0dCQnh4X0hEUl90b19ZQ2JDcjQyMAAyME9wX1JHQjI0XzMyX3RvX1lDYkNyADI3T3BfUkdCMjRfMzJfdG9fWUNiQ3I0NDRfR0JSADI5T3BfQW55X1JHQl90b19ZQ2JDcl80MjBfU2hhcnAAMjBPcF9ZQ2JDcjQyMF90b19SR0IyNAAyME9wX1lDYkNyNDIwX3RvX1JHQjMyADIzT3BfWUNiQ3I0MjBfdG9fUlJHR0JCYWEAMThPcF9SR0JfdG9fUkdCMjRfMzIAMjVPcF9SR0JfSERSX3RvX1JSR0dCQmFhX0JFADIxT3BfUkdCX3RvX1JSR0dCQmFhX0JFADI1T3BfUlJHR0JCYWFfQkVfdG9fUkdCX0hEUgAxOE9wX1JHQjI0XzMyX3RvX1JHQgAyN09wX1JSR0dCQmFhX3N3YXBfZW5kaWFubmVzcwAADgAAAA8AAAAMAAAADQAAADE5T3BfbW9ub190b19ZQ2JDcjQyMAAxOU9wX21vbm9fdG9fUkdCMjRfMzIAAAAAAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAADE2T3BfdG9faGRyX3BsYW5lcwAxNk9wX3RvX3Nkcl9wbGFuZXMAMTlPcF9kcm9wX2FscGhhX3BsYW5lADI1T3BfYWRqdXN0X2FscGhhX2JpdF9kZXB0aAAyOU9wX2JheWVyX2JpbGluZWFyX3RvX1JHQjI0XzMyADEzQm94X2NvbnRhaW5lcgA4Qm94X212aGQAOEJveF90a2hkADhCb3hfbWRoZAA4Qm94X3ZtaGQAOEJveF9ubWhkADhCb3hfc3RzZAA4Qm94X3N0dHMAOEJveF9jdHRzADhCb3hfc3RzYwA4Qm94X3N0Y28AOEJveF9zdHN6ADhCb3hfc3RzcwA4Qm94X2Njc3QAOEJveF9hdXhpADIxQm94X1Zpc3VhbFNhbXBsZUVudHJ5ADIyQm94X1VSSU1ldGFTYW1wbGVFbnRyeQA3Qm94X3VyaQA4Qm94X3NiZ3AAMjFTYW1wbGVHcm91cEVudHJ5X3JlZnMAMTZTYW1wbGVHcm91cEVudHJ5ADhCb3hfc2dwZAA4Qm94X2J0cnQAOEJveF9zYWl6ADhCb3hfc2FpbwA4Qm94X3NkdHAAOEJveF90cmVmADhCb3hfZWxzdABOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkyMVNhbXBsZUdyb3VwRW50cnlfcmVmc05TXzlhbGxvY2F0b3JJUzFfRUVFRQA1Q2h1bmsATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTNFbmNvZGVyX0hUSjJLTlNfOWFsbG9jYXRvcklTMV9FRUVFADVUcmFjawBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUk1Q2h1bmtOU185YWxsb2NhdG9ySVMxX0VFRUUAAAAAAQ=="),m0(b,64870,"AQ=="),m0(b,64887,"QDEyVHJhY2tfVmlzdWFsADE0VHJhY2tfTWV0YWRhdGEAU3VjY2Vzcw=="),m0(b,64936,"AQAAAAIAAABkZWZsYXRlADhCb3hfbWluaQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUk4Qm94X2NjbHZOU185YWxsb2NhdG9ySVMxX0VFRUUAAAEAAAAAAAAAAg=="),m0(b,65048,"AwAAADhCb3hfcHJmcgAAAEwAAABUAAAAVAAAAFAAAABYAAAAWAAAAMBBAADIQQAAyEEAAAAAAADFAAAAuQAAAMkAAADFAAAAuQAAAMkAAACVAAAAhgAAAG4AAACaAAAAegAAAIkAAACMAAAAxgAAAKkAAADGAAAAiwAAAI0AAACdAAAAawAAAIsAAAB+AAAAawAAAIsAAAB+"),m0(b,65216,"uAAAAJoAAACLAAAAmgAAAJoAAACaAAAAiwAAAJoAAACaAAAAuAAAAJoAAAC3AAAAPwAAAJgAAACYAAAAAAAAAG8AAACNAAAAmQAAAG8AAABeAAAAigAAALYAAACaAAAAlQAAAGsAAACnAAAAmgAAAJUAAABcAAAApwAAAJoAAACZAAAAigAAAIoAAAB8AAAAigAAAF4AAADgAAAApwAAAHo="),m0(b,65392,"bgAAAG4AAAB8AAAAfQAAAIwAAACZAAAAfQAAAH8AAACMAAAAbQAAAG8AAACPAAAAfwAAAG8AAABPAAAAbAAAAHsAAAA/AAAAfQAAAG4AAABeAAAAbgAAAF8AAABPAAAAfQAAAG8AAABuAAAATgAAAG4AAABvAAAAbwAAAF8AAABeAAAAbAAAAHsAAABsAAAAfQAAAG4AAAB8AAAAbgAAAF8AAABeAAAAfQAAAG8AAABvAAAATwAAAH0AAAB+AAAAbwAAAG8AAABPAAAAbAAAAHsAAABd"),m0(b,65616,"WwAAAKsAAACGAAAAjQAAAHkAAACMAAAAPQAAAJoAAAB5AAAAjAAAAD0AAACaAAAAbwAAAG8AAAB9AAAAbgAAAG4AAABeAAAAfAAAAGwAAAB8AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAjAAAAIsAAAC2AAAAtgAAAJgAAACIAAAAmAAAAIgAAACZAAAAiAAAAIsAAABvAAAAiAAAAIsAAABvAAAAmwAAAJoAAACLAAAAmQAAAIsAAAB7AAAAewAAAD8AAACZAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAAqgAAAJkAAAB7AAAAewAAAGsAAAB5AAAAawAAAHkAAACnAAAAlwAAALcAAACMAAAAlwAAALcAAACMAAAAqgAAAJoAAACLAAAAmQAAAIsAAAB7AAAAewAAAD8AAAB8AAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAAqgAAAJkAAACKAAAAigAAAHoAAAB5AAAAegAAAHkAAACnAAAAlwAAALcAAACMAAAAlwAAALcAAACM"),m0(b,66176,"jQAAAG8AAACMAAAAjAAAAIwAAACM"),m0(b,66208,"jAAAAFwAAACJAAAAigAAAIwAAACYAAAAigAAAIsAAACZAAAASgAAAJUAAABcAAAAiwAAAGsAAAB6AAAAmAAAAIwAAACzAAAApgAAALYAAACMAAAA4wAAAHoAAADFAAAAmgAAAMQAAADEAAAApwAAAJoAAACYAAAApwAAALYAAAC2AAAAhgAAAJUAAACIAAAAmQAAAHkAAACIAAAAiQAAAKkAAADCAAAApgAAAKcAAACaAAAApwAAAIkAAAC2AAAAmgAAAMQAAACnAAAApwAAAJoAAACYAAAApwAAALYAAAC2AAAAhgAAAJUAAACIAAAAmQAAAHkAAACIAAAAegAAAKkAAADQAAAApgAAAKcAAACaAAAAmAAAAKcAAAC2AAAAigAAAJkAAACIAAAApwAAAJgAAACYAAAAawAAAKcAAABbAAAAegAAAGsAAACnAAAAawAAAKcAAABbAAAAawAAAGsAAACnAAAAyAAAALkAAACgAAAAAAAAACwEAQBaBwAAWwcAAFwHAABdBwAAVGYBADgEAQBYBAEAMjZ0aHJlYWRfdGFza19kZWJsb2NrX0NUQlJvdwAAAAAsZgEAYAQBADExdGhyZWFkX3Rhc2s="),m0(b,66688,"BgcICQoLDA0ODxAREhQWGBocHiAiJCYoKiwuMDI0Njg6PD5A"),m0(b,66754,"AQEBAQEBAQEBAgICAgMDAwMEBAQFBQYGBwgJCgsNDhASFBYY"),m0(b,66800,"gLDQ8ICnxeOAnrvYe5ayzXSOqcNvh6C5aYCYr2R6kKZfdImeWm6CllVoe45RY3WHTV5vgElZaXpFVWR0QlBfbj5MWmg7SFZjOEVRXjVBTVkzPklVMDtFUC44QkwrNT9IKTI7RScwOEElLTY+IyszOyEpMDggJy41HiUrMh0jKTAbISctGh8lKxgeIykXHCEnFhsgJRUaHiMUGB0hExcbHxIWGh4RFRkcEBQXGw8TFhkOEhUYDhEUFw0QExYMDxIVDA4RFAsOEBMLDQ8SCgwPEQoMDhAJCw0PCQsMDggKDA4ICQsNBwkLDAcJCgwHCAoLBggJCwYHCQoGBwgJAgICAgECAwQFBgcICQoLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIjJCUmJygpKissLS4vMDEyMzQ1Njc4OTo7PD0+Pj8GBQQEAwMDAwICAgICAgICAQEBAQEBAQEBAQEBAQEBAQAAAQICBAQFBgcICQkLCwwNDQ8PEBASEhMTFRUWFhcYGBkaGhsbHB0dHh4eHyAgISEhIiIjIyMkJCQlJSUmJj8AAAAA4AYBAF4HAABfBwAAHgAAAB4AAAAAAAAAwAYBAGAHAABhBwAAYgcAAGMHAABUZgEAzAYBAOAGAQAxNWRlY29kZXJfY29udGV4dAAAALBmAQD4BgEAAAAAAAEAAAAIBwEAAgQAADEyYmFzZV9jb250ZXh0AAAsZgEAEAcBADExZXJyb3JfcXVldWUAAAAAAAAAPAcBAGQHAABlBwAAZgcAADIBAABnBwAAVGYBAEgHAQDwYgEATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTl2aWRlb19wYXJhbWV0ZXJfc2V0TlNfOWFsbG9jYXRvcklTMV9FRUVFAAAAAAAAAACwBwEAaAcAAGkHAABqBwAAMgEAAGsHAABUZgEAvAcBAPBiAQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxN3NlcV9wYXJhbWV0ZXJfc2V0TlNfOWFsbG9jYXRvcklTMV9FRUVFAAAAAAAAIAgBAGwHAABtBwAAbgcAADIBAABvBwAAVGYBACwIAQDwYgEATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTdwaWNfcGFyYW1ldGVyX3NldE5TXzlhbGxvY2F0b3JJUzFfRUVFRQ=="),m0(b,67712,"QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBaWlhVUk5JQz02LiYfFg0E/PPq4drSysO9t7Kuq6implpXUEY5KxkJ9+fVx7qwqaamqbC6x9Xn9wkZKzlGUFdaWlJDLhb84cq3q6aossPa8w0mPU5YWlVJNh8E6tK9rqZZSzIS7s61p6e1zu4SMktZWUsyEu7Otaentc7uEjJLWVhDH/PKrqay0vwmSVpVPRbqw6umt9oELk5aUjYN4b2oVzkJ1bCmuucZRlpQK/fHqanH9ytQWkYZ57qmsNUJOVdVLvO9prfqJlJYNvzDprLhH05aPQTKqK7aFklaQw3Sq1Mk3K2t3CRTUyTcra3cJFNTJNytrdwkU1Mk3K2t3CRTUhbKpsMNTlUf0qa9BElYJtqot/xDWi7hq7LzPVo26q5QCbqp5zlaK9WmxxlXRvewsPdGVxnHptUrWjnnqboJUE78rrcNVUPqqMMfWjbaptIuWibKpuE9WBa9q/NJUgSyS+6nzjJZErW1ElkyzqfuS0vup84yWRK1tRJZMs6n7ktJ4abqTkPapvNSPdKo/FU2yqsEWC7Drg1aJr2yFloft0bVqQlaGbDHOVDnpvdXK7q6K1f3pudQOcewGVoJqdVGQ8qyJlXqpgRaDajhUi63wz1J0q4fWPOm/FoWq9pONr1AwMBAQMDAQEDAwEBAwMBAQMDAQEDAwEBAwMBAQMDAQD230lIfqPNa/KYWVdqyNkO9yk4mq+paBKYNWOGuLknDObDnWvepK0a61VcJphlQx8dQGaYJV9W6Riup91rnsDk2q/xY0sNSDaYmQ7LqWuG3SR+mFk692lrzrj0uqARVyjKnEku17lnOzlnutUsSpzIypxJLte5Zzs5Z7rVLEqcyLqYmNqYfPagWQ6sNSa4ETrL8UrfzVb3qWMPhWsraWtIrpjkZqUYJsFD3ulfnx1rV1VrH51e691CwCUapGTmmKyaoSfy9WtLhVbINPaY2Fq5S6spaw/NOqx8upkMEt1jaJK1T3NxTrSQkrVPc3FOtJCStU9zcU60kJK1T3NxTrSQfslrDBDaoUtrqSaZD89JVqy4NvVq3FiauWMr8PaZO4Rm6WrArCcdXqTn31VCmRufnRqZQ1fc5qVfHCSuwWroZFsNVpkna/C6yWq428+FDqFi9Hw3KUqZO0gQmt1qrPeoSzkunWbUy7u4ytVmnS84SEs5Lp1m1Mu7uMrVZp0vOEg3aPbJYplW3NuEEFtJDrlqmUr0u6vwfykmrWqhOwybzCecrx0awV6ZaqVC6OdUZ9/cZ1Tm6UKlaplewRscr5wkE8xbhJtI2w0O3Tq5VqFqmWqZYq1KySb09yi7aH+oN/AAAAAADAAAAAwAAAAIAAAAAAAAAAwAAAAQAAAAEAAAAAAAAALgMAQBaBwAAwwcAAMQHAADFBwAAVGYBAMQMAQBYBAEAMTV0aHJlYWRfdGFza19zYW8AAAABAAAAAAAAAAEAAAD//////////wAAAAD/////AQAAAAAAAAABAAAAAQAAAAEAAAAAAAAA////////////////AAAAAAAAAAC0xAEAtsQBAMDEAQDgxAEAYMUBAGDHAQ=="),m0(b,68928,"tMQBAGDPAQBwzwEAkM8BABDQAQAQ0gE="),m0(b,68960,"tMQBABDaAQAg2gEAQNoBAMDaAQDA3AE="),m0(b,69e3,"wOQBAODkAQBg5QEAYOcB"),m0(b,69024,"YO8BAIDvAQAA8AEAAPIB"),m0(b,69049,"+gEAIPoBAKD6AQCg/AEAIA0BAEANAQBgDQE="),m0(b,69096,"IAAAABoAAAAVAAAAEQAAAA0AAAAJAAAABQAAAAIAAAAAAAAA/v////v////3////8////+/////r////5v///+D////m////6////+/////z////9/////v////+////AAAAAAIAAAAFAAAACQAAAA0AAAARAAAAFQAAABoAAAAgAAAAAAAAAADw//+a+f//cvz//4r9//8e/v//ev7//8X+//8A////xf7//3r+//8e/v//iv3//3L8//+a+f//APD//wAAAAAAAAAAAQAAAAAAAAACAAAAAQAAAAIAAAAAAAAAAwAAAAEAAAADAAAAAgAAAAMAAAABAAAAAAAAAAIAAAAAAAAAAgAAAAEAAAADAAAAAAAAAAMAAAABAAAAAwAAAAIAAAAAAAAAIA8BAMYHAADHBwAAVGYBACwPAQBQDwEAMzBNb3Rpb25WZWN0b3JBY2Nlc3NfZGUyNjVfaW1hZ2UAAAAALGYBAFgPAQAxOE1vdGlvblZlY3RvckFjY2VzcwAAAAAAAAAAAwAAAAMAAAACAAAAAAAAAAMAAAAEAAAABAAAAAABBAUCAwQFBgYICAcHCGMAAAAAGgAAAAoAAAABAAAAAAECAgICAwUHCAoMDQ8REhMUFRYXFxgYGRkaGxscHB0dHh8AAAAAAOwPAQBaBwAAyAcAAMkHAADKBwAAVGYBAPgPAQBYBAEAMjV0aHJlYWRfdGFza19zbGljZV9zZWdtZW50AAAAAAAsEAEAWgcAAMsHAADMBwAAzQcAAFRmAQA4EAEAWAQBADE5dGhyZWFkX3Rhc2tfY3RiX3JvdwAAAAEAAAACAAAAAgAAAAEAAAABAAAAAgAAAAEAAAABAAAAajcAACBdAABQWwAAAAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIQAAACIAAAAiAAAAIwAAACMAAAAkAAAAJAAAACU="),m0(b,69824,"KAAAAC0AAAAzAAAAOQAAAEAAAABIAAAADCcAADZdAACxNAAA4hQ="),m0(b,69876,"AQABAAwACwAKAAsAEAALACgAIQAYAAsAFAALACAACwBQACEAEgALAA8ACwBAACEAoABjAAQAAwADAAIAAgABAAAAAACiDwAA81IAANxUAAB1UgAA4VQAACxmAQBUEQEATlN0M19fMjEyYmFzaWNfc3RyaW5nSXdOU18xMWNoYXJfdHJhaXRzSXdFRU5TXzlhbGxvY2F0b3JJd0VFRUUAACxmAQCcEQEATlN0M19fMjEyYmFzaWNfc3RyaW5nSURzTlNfMTFjaGFyX3RyYWl0c0lEc0VFTlNfOWFsbG9jYXRvcklEc0VFRUUAAAAsZgEA6BEBAE5TdDNfXzIxMmJhc2ljX3N0cmluZ0lEaU5TXzExY2hhcl90cmFpdHNJRGlFRU5TXzlhbGxvY2F0b3JJRGlFRUVFAAAALGYBADQSAQBOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0ljRUUAACxmAQBcEgEATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJYUVFAAAsZgEAhBIBAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SXNFRQAALGYBAKwSAQBOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0l0RUUAACxmAQDUEgEATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJaUVFAAAsZgEA/BIBAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SWpFRQAALGYBACQTAQBOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0lsRUUAACxmAQBMEwEATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJbUVFAAAsZgEAdBMBAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SXhFRQAALGYBAJwTAQBOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0l5RUUAACxmAQDEEwEATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJZkVFAAAsZgEA7BMBAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SWRFRQAAAAAAAAMAAAAEAAAABAAAAAYAAACD+aIARE5uAPwpFQDRVycA3TT1AGLbwAA8mZUAQZBDAGNR/gC73qsAt2HFADpuJADSTUIASQbgAAnqLgAcktEA6x3+ACmxHADoPqcA9TWCAES7LgCc6YQAtCZwAEF+XwDWkTkAU4M5AJz0OQCLX4QAKPm9APgfOwDe/5cAD5gFABEv7wAKWosAbR9tAM9+NgAJyycARk+3AJ5mPwAt6l8Auid1AOXrxwA9e/EA9zkHAJJSigD7a+oAH7FfAAhdjQAwA1YAe/xGAPCrawAgvM8ANvSaAOOpHQBeYZEACBvmAIWZZQCgFF8AjUBoAIDY/wAnc00ABgYxAMpWFQDJqHMAe+JgAGuMwAAZxEcAzWfDAAno3ABZgyoAi3bEAKYclgBEr90AGVfRAKU+BQAFB/8AM34/AMIy6ACYT94Au30yACY9wwAea+8An/heADUfOgB/8soA8YcdAHyQIQBqJHwA1W76ADAtdwAVO0MAtRTGAMMZnQCtxMIALE1BAAwAXQCGfUYA43EtAJvGmgAzYgAAtNJ8ALSnlwA3VdUA1z72AKMQGABNdvwAZJ0qAHDXqwBjfPgAerBXABcV5wDASVYAO9bZAKeEOAAkI8sA1op3AFpUIwAAH7kA8QobABnO3wCfMf8AZh5qAJlXYQCs+0cAfn/YACJltwAy6IkA5r9gAO/EzQBsNgkAXT/UABbe1wBYO94A3puSANIiKAAohugA4lhNAMbKMgAI4xYA4H3LABfAUADzHacAGOBbAC4TNACDEmIAg0gBAPWOWwCtsH8AHunyAEhKQwAQZ9MAqt3YAK5fQgBqYc4ACiikANOZtAAGpvIAXHd/AKPCgwBhPIgAinN4AK+MWgBv170ALaZjAPS/ywCNge8AJsFnAFXKRQDK2TYAKKjSAMJhjQASyXcABCYUABJGmwDEWcQAyMVEAE2ykQAAF/MA1EOtAClJ5QD91RAAAL78AB6UzABwzu4AEz71AOzxgACz58MAx/goAJMFlADBcT4ALgmzAAtF8wCIEpwAqyB7AC61nwBHksIAezIvAAxVbQByp5AAa+cfADHLlgB5FkoAQXniAPTfiQDolJcA4uaEAJkxlwCI7WsAX182ALv9DgBImrQAZ6RsAHFyQgCNXTIAnxW4ALzlCQCNMSUA93Q5ADAFHAANDAEASwhoACzuWABHqpAAdOcCAL3WJAD3faYAbkhyAJ8W7wCOlKYAtJH2ANFTUQDPCvIAIJgzAPVLfgCyY2gA3T5fAEBdAwCFiX8AVVIpADdkwABt2BAAMkgyAFtMdQBOcdQARVRuAAsJwQAq9WkAFGbVACcHnQBdBFAAtDvbAOp2xQCH+RcASWt9AB0nugCWaSkAxsysAK0UVACQ4moAiNmJACxyUAAEpL4AdweUAPMwcAAA/CcA6nGoAGbCSQBk4D0Al92DAKM/lwBDlP0ADYaMADFB3gCSOZ0A3XCMABe35wAI3zsAFTcrAFyAoABagJMAEBGSAA/o2ABsgK8A2/9LADiQDwBZGHYAYqUVAGHLuwDHibkAEEC9ANLyBABJdScA67b2ANsiuwAKFKoAiSYvAGSDdgAJOzMADpQaAFE6qgAdo8IAr+2uAFwmEgBtwk0ALXqcAMBWlwADP4MACfD2ACtAjABtMZkAObQHAAwgFQDYw1sA9ZLEAMatSwBOyqUApzfNAOapNgCrkpQA3UJoABlj3gB2jO8AaItSAPzbNwCuoasA3xUxAACuoQAM+9oAZE1mAO0FtwApZTAAV1a/AEf/OgBq+bkAdb7zACiT3wCrgDAAZoz2AATLFQD6IgYA2eQdAD2zpABXG48ANs0JAE5C6QATvqQAMyO1APCqGgBPZagA0sGlAAs/DwBbeM0AI/l2AHuLBACJF3IAxqZTAG9u4gDv6wAAm0pYAMTatwCqZroAds/PANECHQCx8S0AjJnBAMOtdwCGSNoA912gAMaA9ACs8C8A3eyaAD9cvADQ3m0AkMcfACrbtgCjJToAAK+aAK1TkwC2VwQAKS20AEuAfgDaB6cAdqoOAHtZoQAWEioA3LctAPrl/QCJ2/4Aib79AOR2bAAGqfwAPoBwAIVuFQD9h/8AKD4HAGFnMwAqGIYATb3qALPnrwCPbW4AlWc5ADG/WwCE10gAMN8WAMctQwAlYTUAyXDOADDLuAC/bP0ApACiAAVs5ABa3aAAIW9HAGIS0gC5XIQAcGFJAGtW4ACZUgEAUFU3AB7VtwAz8cQAE25fAF0w5ACFLqkAHbLDAKEyNgAIt6QA6rHUABb3IQCPaeQAJ/93AAwDgACNQC0AT82gACClmQCzotMAL10KALT5QgAR2ssAfb7QAJvbwQCrF70AyqKBAAhqXAAuVRcAJwBVAH8U8ADhB4YAFAtkAJZBjQCHvt4A2v0qAGsltgB7iTQABfP+ALm/ngBoak8ASiqoAE/EWgAt+LwA11qYAPTHlQANTY0AIDqmAKRXXwAUP7EAgDiVAMwgAQBx3YYAyd62AL9g9QBNZREAAQdrAIywrACywNAAUVVIAB77DgCVcsMAowY7AMBANQAG3HsA4EXMAE4p+gDWysgA6PNBAHxk3gCbZNgA2b4xAKSXwwB3WNQAaePFAPDaEwC6OjwARhhGAFV1XwDSvfUAbpLGAKwuXQAORO0AHD5CAGHEhwAp/ekA59bzACJ8ygBvkTUACODFAP/XjQBuauIAsP3GAJMIwQB8XXQAa62yAM1unQA+cnsAxhFqAPfPqQApc98Atcm6ALcAUQDisg0AdLokAOV9YAB02IoADRUsAIEYDAB+ZpQAASkWAJ96dgD9/b4AVkXvANl+NgDs2RMAi7q5AMSX/AAxqCcA8W7DAJTFNgDYqFYAtKi1AM/MDgASiS0Ab1c0ACxWiQCZzuMA1iC5AGteqgA+KpwAEV/MAP0LSgDh9PsAjjttAOKGLADp1IQA/LSpAO/u0QAuNckALzlhADghRAAb2cgAgfwKAPtKagAvHNgAU7SEAE6ZjABUIswAKlXcAMDG1gALGZYAGnC4AGmVZAAmWmAAP1LuAH8RDwD0tREA/Mv1ADS8LQA0vO4A6F3MAN1eYABnjpsAkjPvAMkXuABhWJsA4Ve8AFGDxgDYPhAA3XFIAC0c3QCvGKEAISxGAFnz1wDZepgAnlTAAE+G+gBWBvwA5XmuAIkiNgA4rSIAZ5PcAFXoqgCCJjgAyuebAFENpACZM7EAqdcOAGkFSABlsvAAf4inAIhMlwD50TYAIZKzAHuCSgCYzyEAQJ/cANxHVQDhdDoAZ+tCAP6d3wBe1F8Ae2ekALqsegBV9qIAK4gjAEG6VQBZbggAISqGADlHgwCJ4+YA5Z7UAEn7QAD/VukAHA/KAMVZigCU+isA08HFAA/FzwDbWq4AR8WGAIVDYgAhhjsALHmUABBhhwAqTHsAgCwaAEO/EgCIJpAAeDyJAKjE5ADl23sAxDrCACb06gD3Z4oADZK/AGWjKwA9k7EAvXwLAKRR3AAn3WMAaeHdAJqUGQCoKZUAaM4oAAnttABEnyAATpjKAHCCYwB+fCMAD7kyAKf1jgAUVucAIfEIALWdKgBvfk0ApRlRALX5qwCC39YAlt1hABY2AgDEOp8Ag6KhAHLtbQA5jXoAgripAGsyXABGJ1sAADTtANIAdwD89FUAAVlNAOBxgA=="),m0(b,73459,"QPsh+T8AAAAALUR0PgAAAICYRvg8AAAAYFHMeDsAAACAgxvwOQAAAEAgJXo4AAAAgCKC4zYAAAAAHfNpNQi/AQCgvwEATm8gZXJyb3IgaW5mb3JtYXRpb24ASWxsZWdhbCBieXRlIHNlcXVlbmNlAERvbWFpbiBlcnJvcgBSZXN1bHQgbm90IHJlcHJlc2VudGFibGUATm90IGEgdHR5AFBlcm1pc3Npb24gZGVuaWVkAE9wZXJhdGlvbiBub3QgcGVybWl0dGVkAE5vIHN1Y2ggZmlsZSBvciBkaXJlY3RvcnkATm8gc3VjaCBwcm9jZXNzAEZpbGUgZXhpc3RzAFZhbHVlIHRvbyBsYXJnZSBmb3IgZGF0YSB0eXBlAE5vIHNwYWNlIGxlZnQgb24gZGV2aWNlAE91dCBvZiBtZW1vcnkAUmVzb3VyY2UgYnVzeQBJbnRlcnJ1cHRlZCBzeXN0ZW0gY2FsbABSZXNvdXJjZSB0ZW1wb3JhcmlseSB1bmF2YWlsYWJsZQBJbnZhbGlkIHNlZWsAQ3Jvc3MtZGV2aWNlIGxpbmsAUmVhZC1vbmx5IGZpbGUgc3lzdGVtAERpcmVjdG9yeSBub3QgZW1wdHkAQ29ubmVjdGlvbiByZXNldCBieSBwZWVyAE9wZXJhdGlvbiB0aW1lZCBvdXQAQ29ubmVjdGlvbiByZWZ1c2VkAEhvc3QgaXMgZG93bgBIb3N0IGlzIHVucmVhY2hhYmxlAEFkZHJlc3MgaW4gdXNlAEJyb2tlbiBwaXBlAEkvTyBlcnJvcgBObyBzdWNoIGRldmljZSBvciBhZGRyZXNzAEJsb2NrIGRldmljZSByZXF1aXJlZABObyBzdWNoIGRldmljZQBOb3QgYSBkaXJlY3RvcnkASXMgYSBkaXJlY3RvcnkAVGV4dCBmaWxlIGJ1c3kARXhlYyBmb3JtYXQgZXJyb3IASW52YWxpZCBhcmd1bWVudABBcmd1bWVudCBsaXN0IHRvbyBsb25nAFN5bWJvbGljIGxpbmsgbG9vcABGaWxlbmFtZSB0b28gbG9uZwBUb28gbWFueSBvcGVuIGZpbGVzIGluIHN5c3RlbQBObyBmaWxlIGRlc2NyaXB0b3JzIGF2YWlsYWJsZQBCYWQgZmlsZSBkZXNjcmlwdG9yAE5vIGNoaWxkIHByb2Nlc3MAQmFkIGFkZHJlc3MARmlsZSB0b28gbGFyZ2UAVG9vIG1hbnkgbGlua3MATm8gbG9ja3MgYXZhaWxhYmxlAFJlc291cmNlIGRlYWRsb2NrIHdvdWxkIG9jY3VyAFN0YXRlIG5vdCByZWNvdmVyYWJsZQBQcmV2aW91cyBvd25lciBkaWVkAE9wZXJhdGlvbiBjYW5jZWxlZABGdW5jdGlvbiBub3QgaW1wbGVtZW50ZWQATm8gbWVzc2FnZSBvZiBkZXNpcmVkIHR5cGUASWRlbnRpZmllciByZW1vdmVkAERldmljZSBub3QgYSBzdHJlYW0ATm8gZGF0YSBhdmFpbGFibGUARGV2aWNlIHRpbWVvdXQAT3V0IG9mIHN0cmVhbXMgcmVzb3VyY2VzAExpbmsgaGFzIGJlZW4gc2V2ZXJlZABQcm90b2NvbCBlcnJvcgBCYWQgbWVzc2FnZQBGaWxlIGRlc2NyaXB0b3IgaW4gYmFkIHN0YXRlAE5vdCBhIHNvY2tldABEZXN0aW5hdGlvbiBhZGRyZXNzIHJlcXVpcmVkAE1lc3NhZ2UgdG9vIGxhcmdlAFByb3RvY29sIHdyb25nIHR5cGUgZm9yIHNvY2tldABQcm90b2NvbCBub3QgYXZhaWxhYmxlAFByb3RvY29sIG5vdCBzdXBwb3J0ZWQAU29ja2V0IHR5cGUgbm90IHN1cHBvcnRlZABOb3Qgc3VwcG9ydGVkAFByb3RvY29sIGZhbWlseSBub3Qgc3VwcG9ydGVkAEFkZHJlc3MgZmFtaWx5IG5vdCBzdXBwb3J0ZWQgYnkgcHJvdG9jb2wAQWRkcmVzcyBub3QgYXZhaWxhYmxlAE5ldHdvcmsgaXMgZG93bgBOZXR3b3JrIHVucmVhY2hhYmxlAENvbm5lY3Rpb24gcmVzZXQgYnkgbmV0d29yawBDb25uZWN0aW9uIGFib3J0ZWQATm8gYnVmZmVyIHNwYWNlIGF2YWlsYWJsZQBTb2NrZXQgaXMgY29ubmVjdGVkAFNvY2tldCBub3QgY29ubmVjdGVkAENhbm5vdCBzZW5kIGFmdGVyIHNvY2tldCBzaHV0ZG93bgBPcGVyYXRpb24gYWxyZWFkeSBpbiBwcm9ncmVzcwBPcGVyYXRpb24gaW4gcHJvZ3Jlc3MAU3RhbGUgZmlsZSBoYW5kbGUAUmVtb3RlIEkvTyBlcnJvcgBRdW90YSBleGNlZWRlZABObyBtZWRpdW0gZm91bmQAV3JvbmcgbWVkaXVtIHR5cGUATXVsdGlob3AgYXR0ZW1wdGVkAFJlcXVpcmVkIGtleSBub3QgYXZhaWxhYmxlAEtleSBoYXMgZXhwaXJlZABLZXkgaGFzIGJlZW4gcmV2b2tlZABLZXkgd2FzIHJlamVjdGVkIGJ5IHNlcnZpY2U="),m0(b,75458,"pQJbAPABtQWMBSUBgwYdA5QE/wDHAzEDCwa8AY8BfwPKBCsA2gavAEIDTgPcAQ4EFQChBg0BlAILAjgGZAK8Av8CXQPnBAsHzwLLBe8F2wXhAh4GRQKFAIICbANvBPEA8wMYBdkA2gNMBlQCewGdA70EAABRABUCuwCzA20A/wGFBC8F+QQ4AGUBRgGfALcGqAFzAlMB"),m0(b,75656,"IQQAAAAAAAAAAC8C"),m0(b,75688,"NQRHBFYE"),m0(b,75710,"oAQ="),m0(b,75730,"RgVgBW4FYQYAAM8BAAAAAAAAAADJBukG+QYeBzkHSQdeBw=="),m0(b,75776,"GQALABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZAAoKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="),m0(b,75857,"DgAAAAAAAAAAGQALDRkZGQANAAACAAkOAAAACQAOAAAO"),m0(b,75915,"DA=="),m0(b,75927,"EwAAAAATAAAAAAkMAAAAAAAMAAAM"),m0(b,75973,"EA=="),m0(b,75985,"DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"),m0(b,76031,"Eg=="),m0(b,76043,"EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"),m0(b,76098,"GgAAABoaGgAAAAAAAAk="),m0(b,76147,"FA=="),m0(b,76159,"FwAAAAAXAAAAAAkUAAAAAAAUAAAU"),m0(b,76205,"Fg=="),m0(b,76217,"FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVG"),m0(b,76292,"1gc="),m0(b,76332,"//////////8="),m0(b,76404,"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"),m0(b,79296,"hDUB"),m0(b,79328,"AgAAwAMAAMAEAADABQAAwAYAAMAHAADACAAAwAkAAMAKAADACwAAwAwAAMANAADADgAAwA8AAMAQAADAEQAAwBIAAMATAADAFAAAwBUAAMAWAADAFwAAwBgAAMAZAADAGgAAwBsAAMAcAADAHQAAwB4AAMAfAADAAAAAswEAAMMCAADDAwAAwwQAAMMFAADDBgAAwwcAAMMIAADDCQAAwwoAAMMLAADDDAAAww0AANMOAADDDwAAwwAADLsBAAzDAgAMwwMADMMEAAzbAAAAAOw2AQDZBwAAOQgAADoIAADcBwAA3QcAAN4HAADfBwAA4AcAAOEHAAA7CAAAPAgAAD0IAADlBwAA5gcAAFRmAQD4NgEAUC4BAE5TdDNfXzIxMF9fc3RkaW5idWZJY0VFAAAAAABQNwEA2QcAAD4IAAA/CAAA3AcAAN0HAADeBwAAQAgAAOAHAADhBwAA4gcAAOMHAADkBwAAQQgAAEIIAABUZgEAXDcBAFAuAQBOU3QzX18yMTFfX3N0ZG91dGJ1ZkljRUUAAAAAAAAAALg3AQD1BwAAQwgAAEQIAAD4BwAA+QcAAPoHAAD7BwAA/AcAAP0HAABFCAAARggAAEcIAAABCAAAAggAAFRmAQDENwEABDABAE5TdDNfXzIxMF9fc3RkaW5idWZJd0VFAAAAAAAcOAEA9QcAAEgIAABJCAAA+AcAAPkHAAD6BwAASggAAPwHAAD9BwAA/gcAAP8HAAAACAAASwgAAEwIAABUZgEAKDgBAAQwAQBOU3QzX18yMTFfX3N0ZG91dGJ1Zkl3RUU="),m0(b,79952,"0XSeAFedvSqAcFIP//8+JwoAAABkAAAA6AMAABAnAACghgEAQEIPAICWmAAA4fUFGAAAADUAAABxAAAAa////877//+Sv///AAAAAAAAAAD/////////////////////////////////////////////////////////////////AAECAwQFBgcICf////////8KCwwNDg8QERITFBUWFxgZGhscHR4fICEiI////////woLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIj/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////wABAgQHAwYFAAAAAAAAAExDX0NUWVBFAAAAAExDX05VTUVSSUMAAExDX1RJTUUAAAAAAExDX0NPTExBVEUAAExDX01PTkVUQVJZAExDX01FU1NBR0VT"),m0(b,80388,"gN4oAIDITQAAp3YAADSeAIASxwCAn+4AAH4XAYBcQAGA6WcBAMiQAQBVuAEu"),m0(b,80448,"U3VuAE1vbgBUdWUAV2VkAFRodQBGcmkAU2F0AFN1bmRheQBNb25kYXkAVHVlc2RheQBXZWRuZXNkYXkAVGh1cnNkYXkARnJpZGF5AFNhdHVyZGF5AEphbgBGZWIATWFyAEFwcgBNYXkASnVuAEp1bABBdWcAU2VwAE9jdABOb3YARGVjAEphbnVhcnkARmVicnVhcnkATWFyY2gAQXByaWwATWF5AEp1bmUASnVseQBBdWd1c3QAU2VwdGVtYmVyAE9jdG9iZXIATm92ZW1iZXIARGVjZW1iZXIAQU0AUE0AJWEgJWIgJWUgJVQgJVkAJW0vJWQvJXkAJUg6JU06JVMAJUk6JU06JVMgJXAAAAAlbS8lZC8leQAwMTIzNDU2Nzg5ACVhICViICVlICVUICVZACVIOiVNOiVTAAAAAABeW3lZXQBeW25OXQB5ZXMAbm8AAKA9AQ=="),m0(b,81316,"AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAEEAAABCAAAAQwAAAEQAAABFAAAARgAAAEcAAABIAAAASQAAAEoAAABLAAAATAAAAE0AAABOAAAATwAAAFAAAABRAAAAUgAAAFMAAABUAAAAVQAAAFYAAABXAAAAWAAAAFkAAABaAAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAQQAAAEIAAABDAAAARAAAAEUAAABGAAAARwAAAEgAAABJAAAASgAAAEsAAABMAAAATQAAAE4AAABPAAAAUAAAAFEAAABSAAAAUwAAAFQAAABVAAAAVgAAAFcAAABYAAAAWQAAAFoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="),m0(b,82336,"sEMB"),m0(b,82868,"AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAGEAAABiAAAAYwAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGoAAABrAAAAbAAAAG0AAABuAAAAbwAAAHAAAABxAAAAcgAAAHMAAAB0AAAAdQAAAHYAAAB3AAAAeAAAAHkAAAB6AAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAYQAAAGIAAABjAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAagAAAGsAAABsAAAAbQAAAG4AAABvAAAAcAAAAHEAAAByAAAAcwAAAHQAAAB1AAAAdgAAAHcAAAB4AAAAeQAAAHoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="),m0(b,83888,"MDEyMzQ1Njc4OWFiY2RlZkFCQ0RFRnhYKy1wUGlJbk4AJUk6JU06JVMgJXAlSDolTQ=="),m0(b,83952,"JQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAlAAAAWQAAAC0AAAAlAAAAbQAAAC0AAAAlAAAAZAAAACUAAABJAAAAOgAAACUAAABNAAAAOgAAACUAAABTAAAAIAAAACUAAABwAAAAAAAAACUAAABIAAAAOgAAACUAAABN"),m0(b,84096,"JQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAA4FEBAF8IAABgCAAAYQgAAAAAAABEUgEAYggAAGMIAABhCAAAZAgAAGUIAABmCAAAZwgAAGgIAABpCAAAaggAAGsI"),m0(b,84208,"BAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABQIAAAUAAAAFAAAABQAAAAUAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAADAgAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAAAqAQAAKgEAACoBAAAqAQAAKgEAACoBAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAADIBAAAyAQAAMgEAADIBAAAyAQAAMgEAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAggAAAIIAAACCAAAAggAAAAQ="),m0(b,85236,"nFEBAGwIAABtCAAAYQgAAG4IAABvCAAAcAgAAHEIAAByCAAAcwgAAHQIAAAAAAAAeFIBAHUIAAB2CAAAYQgAAHcIAAB4CAAAeQgAAHoIAAB7CAAAAAAAAJxSAQB8CAAAfQgAAGEIAAB+CAAAfwgAAIAIAACBCAAAgggAAHQAAAByAAAAdQAAAGUAAAAAAAAAZgAAAGEAAABsAAAAcwAAAGUAAAAAAAAAJQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAAAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAJQAAAGEAAAAgAAAAJQAAAGIAAAAgAAAAJQAAAGQAAAAgAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAFkAAAAAAAAAJQAAAEkAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAHA="),m0(b,85612,"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"),m0(b,90740,"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"),m0(b,92276,"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"),m0(b,101987,"QAAAAAAAAAABAAAAAAABAADoAwAAAABABgAAAAAAAAAAAQAAAAABAAAgAAAAQAAAAGQAAAAAAAAAAQAAAAAEAAAABAAAgKgSAegDAADoAwAAAAE="),m0(b,102080,"BA=="),m0(b,102184,"BAAAAAAAAADJRQAAAAAAAFSPAQBTAwAAVAMAAFUDAABWAwAAVwMAAFgDAABUZgEA8NsAAPiKAQAAAAAAgI8BAFMDAABZAwAAWgMAAFsDAABcAwAAXQMAAFRmAQAH3AAA+IoBAAAAAACsjwEAUwMAAF4DAABfAwAAYAMAAGEDAABiAwAAVGYBACLcAAD4igEAAAAAANiPAQBTAwAAYwMAAGQDAABlAwAAZgMAAGcDAABUZgEAO9wAAPiKAQAAAAAABJABAGgDAABpAwAAagMAAGsDAABsAwAAbQMAAFRmAQBb3AAA+IoBAAAAAAAwkAEAbgMAAG8DAABwAwAAcQMAAGYDAAByAwAAVGYBAHTcAAD4igEAAAAAAFiQAQBzAwAAdAMAAHUDAAAyAQAAdgMAAFRmAQCQ3AAA8GIBAAAAAACAkAEAdwMAAHgDAAB5AwAAMgEAAHoDAABUZgEA2twAAPBiAQAAAAAAqJABAHsDAAB8AwAAfQMAADIBAAB+AwAAVGYBACjdAADwYgEAAAAAANCQAQB/AwAAgAMAAIEDAAAyAQAAggMAAFRmAQB03QAA8GIBAAAAAAD4kAEAgwMAAIQDAACFAwAAMgEAAIYDAABUZgEAwN0AAPBiAQAAAAAAIJEBAIcDAACIAwAAiQMAADIBAACKAwAAVGYBABPeAADwYgEAAAAAAIsDAACMAw=="),m0(b,102720,"u9MAAEiRAQAsZgEAYt4AAFyRAQBkkQEASJEBACxmAQCk3gAADGcBALHeAAAAAAAAdJEBACxmAQDB3gAAhJEBAEiRAQDgZQEA1d4AAJSRAQBkkQEALGYBAPDeAACUkQEAZJEBAIRlAQAMZwEADN8AAAAAAAC4kQEALGYBACHfAACUkQEAqJEBANCRAQDYkQEA4GUBADXfAADgZQEAR98AAAxnAQB83wAAAAAAAPCRAQAsZgEAit8AAOBlAQCX3wAALGYBAKbfAAAYZQEAlJEBAIRlAQBkkQEAGGUBAGSRAQB4ZQEAZJEBABhlAQAwkgEADGcBAMzfAAABAAAAuJEBAHhlAQAwkgEAGGUBAFCSAQAMZwEA4t8AAAEAAADwkQEAlJEBAGySAQCEZQEADGcBAPHfAAABAAAAdJEBAHhlAQBskgEAeGUBAGySAQCEZQEA4GUBAAfgAADgZQEAGeAAAOBlAQAu4AAA4GUBAEjgAADgZQEAbeAAAAUAAADTBwAAJCUAAAAAAADCAgAAwwIAAAUAAAAAAAAA6HIAAAAAAADLAwAAzAM="),m0(b,103152,"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"),m0(b,113924,"mP0AAAMAAAAJAAAABysAADwAAAABAAAAAQAAADQHAAA1BwAANgcAADcHAAA4BwAAOQcAADoHAAA7BwAAPAcAAD0HAAA+BwAAPwcAAEAHAABBBwAAQgcAAEMHAABEBwAARQcAAEYHAABHBwAASAcAAEkH"),m0(b,114072,"2L0BAEoHAABLBwAAIwAAAEwHAAAlAAAATQcAADoAAAAtAAAALgAAAC8AAAAwAAAAMQAAAE4HAAA9AAAAPgAAAFRmAQC4/QAAeGoBAAAAAAAAvgEATwcAAFAHAABRBwAAMgEAAFIHAABUZgEAwv0AAPBiAQAAAAAAUL4BADUAAABTBwAAVAcAAFUHAAAqAAAAVgcAAGcAAAAtAAAALgAAAFcHAAAwAAAAMQAAAFgHAAAzAAAANAAAAFRmAQAc/gAAmGoBAAAAAADBBwAAwgc="),m0(b,114288,"EBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAREBEQERIREhIREhUTFBUUExUYFhYYGBYWGBkZGx4bGRkdHyMjHx0kKSwpJC82Ni9BRkFYWHMQEBAQEBAQEBAQERERERESEhISEhIUFBQUFBQUGBgYGBgYGBgZGRkZGRkZHBwcHBwcISEhISEpKSkpNjY2R0dbACAAAAAAAAAF"),m0(b,114452,"zwc="),m0(b,114476,"0AcAANEHAACUBgI="),m0(b,114500,"Ag=="),m0(b,114516,"//////////8="),m0(b,114584,"CL8BAAAAAAAF"),m0(b,114604,"0gc="),m0(b,114628,"0AcAANMHAACoBgIAAAQ="),m0(b,114652,"AQ=="),m0(b,114668,"/////wo="),m0(b,114736,"oL8BAEAdAwAJ"),m0(b,114756,"zwc="),m0(b,114776,"1wcAAAAAAADRBwAAqAwCAAAE"),m0(b,114820,"/////w=="),m0(b,114888,"JW0vJWQvJXkAAAAIJUg6JU06JVMAAAAI")}var b0=new ArrayBuffer(16),I2=new Int32Array(b0),Y2=new Float32Array(b0),G2=new Float64Array(b0);function o2(V1){return I2[V1]}function T2(V1,E1){I2[V1]=E1}function s1(){return G2[0]}function j2(V1){G2[0]=V1}function l0(V1,E1,t){if(V1=V1>>>0,t=t>>>0,V1+t>b.length)throw"trap: invalid memory.fill";b.fill(E1,V1,V1+t)}function M(){throw new Error("abort")}function z(V1,E1,t){b.copyWithin(V1,E1,E1+t)}function P1(V1){Y2[2]=V1}function t8(){return Y2[2]}function b1(V1){var E1=new ArrayBuffer(17039360),t=new Int8Array(E1),X=new Int16Array(E1),i=new Int32Array(E1),u=new Uint8Array(E1),p=new Uint16Array(E1),o0=new Uint32Array(E1),E0=new Float32Array(E1),u0=new Float64Array(E1),g=Math.imul,D=Math.fround,B2=Math.abs,_1=Math.clz32,D80=Math.min,U80=Math.max,HB=Math.floor,v9=Math.ceil,M80=Math.trunc,zB=Math.sqrt,L2=V1.a,N0=L2.a,U0=L2.b,g1=L2.c,F1=L2.d,T1=L2.e,s4=L2.f,q4=L2.g,B8=L2.h,d8=L2.i,b8=L2.j,Ze=L2.k,zr=L2.l,df=L2.m,bf=L2.n,cf=L2.o,iA=L2.p,eA=L2.q,m9=L2.r,Z9=L2.s,g9=L2.t,G9=L2.u,xB=L2.v,TB=L2.w,jB=L2.x,SB=L2.y,OB=L2.z,PB=L2.A,LB=L2.B,qB=L2.C,aB=L2.D,KB=L2.E,$B=L2.F,dB=L2.G,bB=L2.H,cB=L2.I,iv=L2.J,ev=L2.K,rv=L2.L,fv=L2.M,Av=L2.N,kv=L2.O,v=204096,T6=0,j6=0,h0=0;function rA(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0;f=i[e+48>>2];i:{if(!i[f+44>>2]||(f=i[f+36>>2],!f))break i;r=i[f+108>>2]==1885954932}i:{e:{r:{if(!r)break r;if(n=v-432|0,v=n,hr(e+16|0,i[e+20>>2]),Y=e+20|0,i[e+16>>2]=Y,i[e+20>>2]=0,i[e+24>>2]=0,r=i[e+32>>2],o=i[e+28>>2],(r|0)!=(o|0))for(;;){f=i[r-4>>2];f:{if(!f||(l=i[f+4>>2],i[f+4>>2]=l-1,l))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=r-8|0,(o|0)==(r|0))break}i[e+32>>2]=o,r=i[e+44>>2],i[e+40>>2]=0,i[e+44>>2]=0;f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(Me(n+380|0,i[e+48>>2]),h=i[n+380>>2],V=i[n+384>>2],(h|0)!=(V|0))for(G=e+28|0,s=n+176|0;;){B=i[h>>2],j1(n+344|0,i[e+48>>2],B);f:{A:{if(i[n+344>>2]){f=v-192|0,v=f,i[f+188>>2]=e,o=i[n+344>>2],r=i[o+112>>2],i[f+184>>2]=r,l=i[o+104>>2],i[f+180>>2]=l;k:{n:{t:{o:{l:{u:{s:{h:{if((r|0)<=1781689136){if((r|0)<=1752589104){if((r|0)==1635135537)break s;if((r|0)==1635148593)break u;if((r|0)!=1735551332)break n;l=C(600),r=l,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107928,r=a4(r+16|0,i[f+188>>2],i[f+180>>2]),i[r+552>>2]=0,i[r+556>>2]=0,i[r+576>>2]=1,i[r+580>>2]=0,i[r>>2]=108048,i[r+560>>2]=0,i[r+564>>2]=0,i[r+568>>2]=0,i[r+572>>2]=0,Z2=r,X2=Li(),i[Z2+580>>2]=X2,o=f+32|0,i[o+4>>2]=l,i[o>>2]=r,i[n+76>>2]=i[f+32>>2],i[n+80>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,g2(o);break k}if((r|0)==1752589105)break h;if((r|0)==1768187246)break t;if((r|0)!=1768912492)break n;l=C(616),r=l,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107968,r=a4(r+16|0,i[f+188>>2],i[f+180>>2]),i[r+552>>2]=0,i[r+556>>2]=0,i[r+564>>2]=0,i[r+568>>2]=0,i[r>>2]=108312,X[r+560>>1]=0,i[r+572>>2]=0,i[r+576>>2]=0,i[r+580>>2]=0,i[r+584>>2]=0,i[r+588>>2]=0,i[r+592>>2]=0,o=f+32|0,i[o+4>>2]=l,i[o>>2]=r,i[n+76>>2]=i[f+32>>2],i[n+80>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,g2(o);break k}w:{if((r|0)<=1835625828){if((r|0)==1781689137)break o;if((r|0)==1785750887)break w;if((r|0)!=1818785329)break n;k=V2(f+12|0,4510),o=a(f+32|0,4,3001,k),m=C(592),r=m,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100816,w=i[o+12>>2],l=i[o+8>>2],I=i[f+184>>2],Q=i[f+180>>2],i[o+8>>2]=0,i[o+12>>2]=0,_=i[o+16>>2],i[o+16>>2]=0,E=i[o>>2],N=i[o+4>>2],r=r+16|0,i[r+64>>2]=0,i[r+68>>2]=0,t[r+60|0]=0,t[r+36|0]=0,i[r+32>>2]=0,i[r+24>>2]=1,i[r+28>>2]=1,i[r+16>>2]=0,i[r+20>>2]=0,t[r+12|0]=1,X[r+10>>1]=2,X[r+6>>1]=2,X[r+8>>1]=2,t[r+4|0]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+156>>2]=0,t[r+112|0]=0,t[r+96|0]=0,i[r+88>>2]=0,i[r+92>>2]=1,i[r+116>>2]=0,i[r+120>>2]=0,i[r+124>>2]=0,i[r+128>>2]=0,i[r+132>>2]=0,i[r+136>>2]=0,i[r+140>>2]=0,i[r+144>>2]=0,X[r+146>>1]=0,X[r+148>>1]=0,X[r+150>>1]=0,X[r+152>>1]=0,i[r+164>>2]=0,i[r+168>>2]=0,i[r+160>>2]=255,i[r+172>>2]=0,i[r+176>>2]=5186,t[r+312|0]=0,i[r+212>>2]=0,i[r+216>>2]=0,X[r+218>>1]=0,X[r+220>>1]=0,X[r+222>>1]=0,X[r+224>>1]=0,i[r+228>>2]=0,i[r+232>>2]=0,t[r+236|0]=0,i[r+240>>2]=0,i[r+244>>2]=0,t[r+248|0]=0,i[r+316>>2]=0,i[r+320>>2]=0,i[r+324>>2]=0,i[r+328>>2]=0,i[r+332>>2]=0,i[r+336>>2]=0,i[r+340>>2]=0,i[r+344>>2]=0,i[r+348>>2]=0,i[r+180>>2]=0,i[r+184>>2]=0,i[r+188>>2]=0,i[r+192>>2]=0,i[r+196>>2]=0,i[r+200>>2]=0,X[r+202>>1]=0,X[r+204>>1]=0,X[r+206>>1]=0,X[r+208>>1]=0,i[r+432>>2]=0,i[r+424>>2]=0,i[r+428>>2]=0,t[r+352|0]=1,t[r+361|0]=0,t[r+362|0]=0,t[r+363|0]=0,t[r+364|0]=0,t[r+365|0]=0,t[r+366|0]=0,t[r+367|0]=0,t[r+368|0]=0,i[r+356>>2]=0,i[r+360>>2]=0,t[r+416|0]=0,i[r+408>>2]=0,i[r+412>>2]=0,i[r+400>>2]=0,i[r+404>>2]=0,i[r+392>>2]=0,i[r+396>>2]=0,i[r+384>>2]=0,i[r+388>>2]=0,i[r+376>>2]=0,i[r+380>>2]=0,i[r+456>>2]=0,i[r+460>>2]=0,X[r+436>>1]=1,i[r+448>>2]=0,i[r+452>>2]=0,i[r+440>>2]=0,i[r+444>>2]=0,i[r+464>>2]=0,i[r+468>>2]=1072693248,i[r+304>>2]=0,i[r+308>>2]=0,i[r+296>>2]=0,i[r+300>>2]=0,i[r+288>>2]=0,i[r+292>>2]=0,i[r+280>>2]=0,i[r+284>>2]=0,i[r+272>>2]=0,i[r+276>>2]=0,i[r+264>>2]=0,i[r+268>>2]=0,i[r+256>>2]=0,i[r+260>>2]=0,i[r+496>>2]=0,i[r+488>>2]=0,i[r+492>>2]=0,i[r+480>>2]=0,i[r+484>>2]=0,i[r+472>>2]=0,i[r+476>>2]=0,i[r+544>>2]=0,i[r+548>>2]=0,i[r+536>>2]=0,i[r+540>>2]=0,i[r+528>>2]=0,i[r+532>>2]=0,i[r+520>>2]=0,i[r+524>>2]=0,i[r+512>>2]=0,i[r+516>>2]=0,i[r+504>>2]=0,i[r+508>>2]=0,i[r+196>>2]=Q,i[r+556>>2]=E,i[r+560>>2]=N,i[r+552>>2]=I,i[r>>2]=100856;_:{if((_|0)>=0){i[r+572>>2]=_,i[r+568>>2]=w,i[r+564>>2]=l;break _}T(r+564|0,l,w),Z(l)}if(i[f+4>>2]=m,i[f>>2]=r,i[n+76>>2]=i[f>>2],i[n+80>>2]=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,g2(f),t[o+19|0]<0&&Z(i[o+8>>2]),t[k+11|0]>=0)break k;Z(i[k>>2]);break k}_:{if((r|0)<=1970168680){if((r|0)==1835625829)break _;if((r|0)!=1836280681)break n;r=C(568),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107888,o=i[f+180>>2],l=i[f+188>>2],i[r+80>>2]=0,i[r+84>>2]=0,t[r+76|0]=0,t[r+52|0]=0,i[r+48>>2]=0,i[r+40>>2]=1,i[r+44>>2]=1,i[r+32>>2]=0,i[r+36>>2]=0,t[r+28|0]=1,X[r+26>>1]=2,X[r+22>>1]=2,X[r+24>>1]=2,t[r+20|0]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+172>>2]=0,t[r+128|0]=0,t[r+112|0]=0,i[r+104>>2]=0,i[r+108>>2]=1,i[r+132>>2]=0,i[r+136>>2]=0,i[r+140>>2]=0,i[r+144>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+156>>2]=0,i[r+160>>2]=0,X[r+162>>1]=0,X[r+164>>1]=0,X[r+166>>1]=0,X[r+168>>1]=0,i[r+180>>2]=0,i[r+184>>2]=0,i[r+176>>2]=255,i[r+188>>2]=0,i[r+192>>2]=5186,i[r+196>>2]=l,t[r+328|0]=0,i[r+200>>2]=0,i[r+204>>2]=0,i[r+208>>2]=0,i[r+212>>2]=0,i[r+216>>2]=0,i[r+220>>2]=0,X[r+224>>1]=0,i[r+228>>2]=0,i[r+232>>2]=0,X[r+234>>1]=0,X[r+236>>1]=0,X[r+238>>1]=0,X[r+240>>1]=0,i[r+244>>2]=0,i[r+248>>2]=0,t[r+252|0]=0,i[r+256>>2]=0,i[r+260>>2]=0,t[r+264|0]=0,i[r+364>>2]=0,i[r+356>>2]=0,i[r+360>>2]=0,i[r+348>>2]=0,i[r+352>>2]=0,i[r+340>>2]=0,i[r+344>>2]=0,i[r+332>>2]=0,i[r+336>>2]=0,i[r+448>>2]=0,i[r+440>>2]=0,i[r+444>>2]=0,t[r+368|0]=1,t[r+377|0]=0,t[r+378|0]=0,t[r+379|0]=0,t[r+380|0]=0,t[r+381|0]=0,t[r+382|0]=0,t[r+383|0]=0,t[r+384|0]=0,i[r+372>>2]=0,i[r+376>>2]=0,t[r+432|0]=0,i[r+424>>2]=0,i[r+428>>2]=0,i[r+416>>2]=0,i[r+420>>2]=0,i[r+408>>2]=0,i[r+412>>2]=0,i[r+400>>2]=0,i[r+404>>2]=0,i[r+392>>2]=0,i[r+396>>2]=0,i[r+472>>2]=0,i[r+476>>2]=0,X[r+452>>1]=1,i[r+464>>2]=0,i[r+468>>2]=0,i[r+456>>2]=0,i[r+460>>2]=0,i[r+480>>2]=0,i[r+484>>2]=1072693248,i[r+320>>2]=0,i[r+324>>2]=0,i[r+312>>2]=0,i[r+316>>2]=0,i[r+304>>2]=0,i[r+308>>2]=0,i[r+296>>2]=0,i[r+300>>2]=0,i[r+288>>2]=0,i[r+292>>2]=0,i[r+280>>2]=0,i[r+284>>2]=0,i[r+272>>2]=0,i[r+276>>2]=0,i[r+512>>2]=0,i[r+504>>2]=0,i[r+508>>2]=0,i[r+496>>2]=0,i[r+500>>2]=0,i[r+488>>2]=0,i[r+492>>2]=0,i[r+560>>2]=0,i[r+564>>2]=0,i[r+552>>2]=0,i[r+556>>2]=0,i[r+544>>2]=0,i[r+548>>2]=0,i[r+536>>2]=0,i[r+540>>2]=0,i[r+528>>2]=0,i[r+532>>2]=0,i[r+520>>2]=0,i[r+524>>2]=0,i[r+212>>2]=o,i[r+16>>2]=107208,o=f+32|0,i[o+4>>2]=r,i[o>>2]=r+16,i[n+76>>2]=i[f+32>>2],i[n+80>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,g2(o);break k}if((r|0)==1970168681)break l;if((r|0)!=1987470129)break n;k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107768,o=a4(r+16|0,e,l),i[o+552>>2]=0,i[o+556>>2]=0,i[o>>2]=106216,i[o+560>>2]=0,i[o+564>>2]=0,r=C(96),i[r>>2]=106404,i[r+4>>2]=0,i[r+8>>2]=0,l0(r+20|0,0,76),i[r+16>>2]=0,i[r+12>>2]=106512,t[r+20|0]=0,i[r+24>>2]=0,i[r+28>>2]=0,t[r+32|0]=0,i[o+564>>2]=r,i[o+560>>2]=r+12,i[n+80>>2]=k,i[n+76>>2]=o;break k}if(k=t[o+139|0],r=(k|0)<0,((r?i[o+132>>2]:k)|0)!=10||N2(r?i[o+128>>2]:o+128|0,12325,10))break n}k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107648,o=a4(r+16|0,e,l),i[o+552>>2]=0,i[o+556>>2]=0,i[o>>2]=104940,i[o+560>>2]=0,i[o+564>>2]=0,r=C(64),i[r+16>>2]=0,i[r+20>>2]=0,i[r>>2]=105128,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=105328,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[o+564>>2]=r,i[o+560>>2]=r+12,i[n+80>>2]=k,i[n+76>>2]=o;break k}k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107688,o=a4(r+16|0,e,l),i[o+552>>2]=0,i[o+556>>2]=0,i[o>>2]=103840,i[o+560>>2]=0,i[o+564>>2]=0,r=C(92),i[r>>2]=104028,i[r+4>>2]=0,i[r+8>>2]=0,l0(r+20|0,0,72),i[r+16>>2]=0,i[r+12>>2]=104284,t[r+20|0]=0,i[r+24>>2]=0,i[r+28>>2]=0,t[r+32|0]=0,i[r+36>>2]=0,i[r+40>>2]=0,t[r+44|0]=0,i[o+564>>2]=r,i[o+560>>2]=r+12,i[n+80>>2]=k,i[n+76>>2]=o;break k}k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107728,o=a4(r+16|0,e,l),i[o+552>>2]=0,i[o+556>>2]=0,i[o>>2]=104348,i[o+560>>2]=0,i[o+564>>2]=0,r=C(84),i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=104536,i[r+4>>2]=0,i[r+8>>2]=0,t[r+19|0]=0,t[r+20|0]=0,t[r+21|0]=0,t[r+22|0]=0,t[r+23|0]=0,t[r+24|0]=0,t[r+25|0]=0,t[r+26|0]=0,t[r+18|0]=1,X[r+16>>1]=0,i[r+12>>2]=104576,t[r+27|0]=0,t[r+28|0]=0,t[r+29|0]=0,t[r+30|0]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+80>>2]=0,i[o+564>>2]=r,i[o+560>>2]=r+12,i[n+80>>2]=k,i[n+76>>2]=o;break k}k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107808,o=a4(r+16|0,e,l),i[o+552>>2]=0,i[o+556>>2]=0,i[o>>2]=106696,i[o+560>>2]=0,i[o+564>>2]=0,r=C(92),i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r>>2]=106884,i[r+4>>2]=0,i[r+8>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+12>>2]=107072,t[r+21|0]=0,t[r+22|0]=0,t[r+23|0]=0,t[r+24|0]=0,t[r+25|0]=0,t[r+26|0]=0,t[r+27|0]=0,t[r+28|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+88>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,t[r+40|0]=0,i[o+564>>2]=r,i[o+560>>2]=r+12,i[n+80>>2]=k,i[n+76>>2]=o;break k}_=ri(f+32|0),r=F(_+8|0,30804,20),o=f+12|0,z1(o,i[f+184>>2]),k=r,l=o,r=t[f+23|0],o=(r|0)<0,F(F(k,o?i[f+12>>2]:l,o?i[f+16>>2]:r),28753,19),t[f+23|0]<0&&Z(i[f+12>>2]),ki(f,_),k=a(f+12|0,4,3001,f),t[f+11|0]<0&&Z(i[f>>2]),I=C(592),r=I,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100816,r=r+16|0,o=v-32|0,v=o,Q=i[f+180>>2],E=i[f+184>>2],m=i[k+4>>2],l=i[k>>2],i[o+8>>2]=l,i[o+12>>2]=m,w=o+16|0;l:{if(t[k+19|0]>=0){N=i[k+12>>2],i[w>>2]=i[k+8>>2],i[w+4>>2]=N,i[w+8>>2]=i[k+16>>2];break l}T(w,i[k+8>>2],i[k+12>>2]),l=i[o+8>>2],m=i[o+12>>2]}i[r+64>>2]=0,i[r+68>>2]=0,t[r+60|0]=0,t[r+36|0]=0,i[r+32>>2]=0,i[r+24>>2]=1,i[r+28>>2]=1,i[r+16>>2]=0,i[r+20>>2]=0,t[r+12|0]=1,X[r+10>>1]=2,X[r+6>>1]=2,X[r+8>>1]=2,t[r+4|0]=0,i[r+156>>2]=0,t[r+112|0]=0,t[r+96|0]=0,i[r+116>>2]=0,i[r+120>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+88>>2]=0,i[r+92>>2]=1,i[r+124>>2]=0,i[r+128>>2]=0,i[r+132>>2]=0,i[r+136>>2]=0,i[r+140>>2]=0,i[r+144>>2]=0,X[r+146>>1]=0,X[r+148>>1]=0,X[r+150>>1]=0,X[r+152>>1]=0,i[r+164>>2]=0,i[r+168>>2]=0,i[r+160>>2]=255,i[r+172>>2]=0,i[r+176>>2]=5186,t[r+312|0]=0,i[r+212>>2]=0,i[r+216>>2]=0,X[r+218>>1]=0,X[r+220>>1]=0,X[r+222>>1]=0,X[r+224>>1]=0,i[r+228>>2]=0,i[r+232>>2]=0,t[r+236|0]=0,i[r+240>>2]=0,i[r+244>>2]=0,t[r+248|0]=0,i[r+316>>2]=0,i[r+320>>2]=0,i[r+324>>2]=0,i[r+328>>2]=0,i[r+332>>2]=0,i[r+336>>2]=0,i[r+340>>2]=0,i[r+344>>2]=0,i[r+348>>2]=0,i[r+180>>2]=0,i[r+184>>2]=0,i[r+188>>2]=0,i[r+192>>2]=0,i[r+196>>2]=0,i[r+200>>2]=0,X[r+202>>1]=0,X[r+204>>1]=0,X[r+206>>1]=0,X[r+208>>1]=0,i[r+432>>2]=0,i[r+424>>2]=0,i[r+428>>2]=0,t[r+352|0]=1,t[r+361|0]=0,t[r+362|0]=0,t[r+363|0]=0,t[r+364|0]=0,t[r+365|0]=0,t[r+366|0]=0,t[r+367|0]=0,t[r+368|0]=0,i[r+356>>2]=0,i[r+360>>2]=0,t[r+416|0]=0,i[r+408>>2]=0,i[r+412>>2]=0,i[r+400>>2]=0,i[r+404>>2]=0,i[r+392>>2]=0,i[r+396>>2]=0,i[r+384>>2]=0,i[r+388>>2]=0,i[r+376>>2]=0,i[r+380>>2]=0,i[r+456>>2]=0,i[r+460>>2]=0,X[r+436>>1]=1,i[r+448>>2]=0,i[r+452>>2]=0,i[r+440>>2]=0,i[r+444>>2]=0,i[r+464>>2]=0,i[r+468>>2]=1072693248,i[r+304>>2]=0,i[r+308>>2]=0,i[r+296>>2]=0,i[r+300>>2]=0,i[r+288>>2]=0,i[r+292>>2]=0,i[r+280>>2]=0,i[r+284>>2]=0,i[r+272>>2]=0,i[r+276>>2]=0,i[r+264>>2]=0,i[r+268>>2]=0,i[r+256>>2]=0,i[r+260>>2]=0,i[r+496>>2]=0,i[r+488>>2]=0,i[r+492>>2]=0,i[r+480>>2]=0,i[r+484>>2]=0,i[r+472>>2]=0,i[r+476>>2]=0,i[r+544>>2]=0,i[r+548>>2]=0,i[r+536>>2]=0,i[r+540>>2]=0,i[r+528>>2]=0,i[r+532>>2]=0,i[r+520>>2]=0,i[r+524>>2]=0,i[r+512>>2]=0,i[r+516>>2]=0,i[r+504>>2]=0,i[r+508>>2]=0,i[r+196>>2]=Q,i[r+556>>2]=l,i[r+560>>2]=m,i[r+552>>2]=E,i[r>>2]=100856,l=r+564|0;l:{if(t[o+27|0]>=0){m=i[w+4>>2],i[l>>2]=i[w>>2],i[l+4>>2]=m,i[l+8>>2]=i[w+8>>2];break l}if(T(l,i[o+16>>2],i[o+20>>2]),t[o+27|0]>=0)break l;Z(i[o+16>>2])}v=o+32|0,i[f+4>>2]=I,i[f>>2]=r,i[n+76>>2]=i[f>>2],i[n+80>>2]=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,g2(f),t[k+19|0]<0&&Z(i[k+8>>2]),F8(_);break k}l=C(584),r=l,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107848,o=a4(r+16|0,i[f+188>>2],i[f+180>>2]),i[o+552>>2]=0,i[o+556>>2]=0,i[o>>2]=105392,i[o+560>>2]=0,i[o+564>>2]=0,r=C(64),i[r+16>>2]=0,i[r+20>>2]=0,i[r>>2]=105580,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=105696,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[o+564>>2]=r,i[o+560>>2]=r+12,r=f+32|0,i[r+4>>2]=l,i[r>>2]=o,i[n+76>>2]=i[f+32>>2],i[n+80>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,g2(r);break k}r=C(568),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=108008,l=a4(r+16|0,i[f+188>>2],i[f+180>>2]),i[l>>2]=108528,o=f+32|0,i[o+4>>2]=r,i[o>>2]=l,i[n+76>>2]=i[f+32>>2],i[n+80>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,g2(o);break k}i[n+76>>2]=0,i[n+80>>2]=0}v=f+192|0;k:{if(!i[n+76>>2])break k;i[n+328>>2]=0,i[n+320>>2]=0,i[n+324>>2]=0,L1(n+392|0,i[e+48>>2],B,n+320|0);n:{if(!i[n+392>>2])break n;r=i[n+76>>2],f=W[i[i[r>>2]+76>>2]](r)|0,r=C(592),i[r>>2]=100816,i[r+4>>2]=0,i[r+8>>2]=0,o=i[n+396>>2],i[n+168>>2]=i[n+392>>2],i[n+172>>2]=o,o=r+16|0;t:{if(t[n+411|0]>=0){l=i[n+404>>2],i[s>>2]=i[n+400>>2],i[s+4>>2]=l,i[s+8>>2]=i[n+408>>2];break t}T(s,i[n+400>>2],i[n+404>>2])}o=a4(o,0,B),i[o>>2]=100856,i[r+568>>2]=f,f=i[n+172>>2],i[r+572>>2]=i[n+168>>2],i[r+576>>2]=f,f=r+580|0;t:{if(t[n+187|0]>=0){l=i[s+4>>2],i[f>>2]=i[s>>2],i[f+4>>2]=l,i[f+8>>2]=i[s+8>>2];break t}if(T(f,i[n+176>>2],i[n+180>>2]),t[n+187|0]>=0)break t;Z(i[n+176>>2])}if(i[n+76>>2]=o,f=i[n+80>>2],i[n+80>>2]=r,!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break n;W[i[i[f>>2]+8>>2]](f),y(f)}if(f=0,i[n+376>>2]=0,i[n+368>>2]=0,i[n+372>>2]=0,w=i[n+76>>2],r=0,l=0,o=i[n+320>>2],m=i[n+324>>2],(o|0)!=(m|0)){if(r=m-o|0,(r|0)<0)break i;for(l=C(r),i[n+368>>2]=l,f=r+l|0,i[n+376>>2]=f,r=l;i[r>>2]=i[o>>2],k=i[o+4>>2],i[r+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+8|0,o=o+8|0,(m|0)!=(o|0););i[n+372>>2]=r}if(m=i[w+184>>2],m){if(k=m,o=i[w+188>>2],(k|0)!=(o|0)){for(;;){r=i[o-4>>2];n:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break n;W[i[i[r>>2]+8>>2]](r),y(r)}if(o=o-8|0,(m|0)==(o|0))break}k=i[w+184>>2],f=i[n+376>>2],l=i[n+368>>2],r=i[n+372>>2]}i[w+188>>2]=m,Z(k)}i[w+192>>2]=f,i[w+188>>2]=r,i[w+184>>2]=l,i[n+376>>2]=0,i[n+368>>2]=0,i[n+372>>2]=0,W[i[i[w>>2]+100>>2]](w),r=i[n+76>>2],W[i[i[r>>2]+132>>2]](n+168|0,r),f=i[n+172>>2],r=i[n+168>>2],i[n+392>>2]=r,i[n+396>>2]=f,t[n+411|0]<0&&(Z(i[n+400>>2]),r=i[n+392>>2]),f=i[s+4>>2],i[n+400>>2]=i[s>>2],i[n+404>>2]=f,i[n+408>>2]=i[s+8>>2],f=i[n+76>>2],o=i[f>>2];n:{if(r){f=W[i[o+76>>2]](f)|0,r=C(592),i[r>>2]=100816,i[r+4>>2]=0,i[r+8>>2]=0,o=i[n+396>>2],i[n+168>>2]=i[n+392>>2],i[n+172>>2]=o,o=r+16|0;t:{if(t[n+411|0]>=0){l=i[n+404>>2],i[s>>2]=i[n+400>>2],i[s+4>>2]=l,i[s+8>>2]=i[n+408>>2];break t}T(s,i[n+400>>2],i[n+404>>2])}o=a4(o,0,B),i[o>>2]=100856,i[r+568>>2]=f,f=i[n+172>>2],i[r+572>>2]=i[n+168>>2],i[r+576>>2]=f,f=r+580|0;t:{if(t[n+187|0]>=0){l=i[s+4>>2],i[f>>2]=i[s>>2],i[f+4>>2]=l,i[f+8>>2]=i[s+8>>2];break t}if(T(f,i[n+176>>2],i[n+180>>2]),t[n+187|0]>=0)break t;Z(i[n+176>>2])}i[n+76>>2]=o,f=i[n+80>>2],i[n+80>>2]=r;t:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break t;W[i[i[f>>2]+8>>2]](f),y(f)}if(f=0,i[n+364>>2]=0,i[n+356>>2]=0,i[n+360>>2]=0,w=i[n+76>>2],r=0,l=0,o=i[n+320>>2],m=i[n+324>>2],(o|0)!=(m|0)){if(r=m-o|0,(r|0)<0)break i;for(l=C(r),i[n+356>>2]=l,f=r+l|0,i[n+364>>2]=f,r=l;i[r>>2]=i[o>>2],k=i[o+4>>2],i[r+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+8|0,o=o+8|0,(m|0)!=(o|0););i[n+360>>2]=r}if(m=i[w+184>>2],m){if(k=m,o=i[w+188>>2],(k|0)!=(o|0)){for(;;){r=i[o-4>>2];t:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break t;W[i[i[r>>2]+8>>2]](r),y(r)}if(o=o-8|0,(m|0)==(o|0))break}k=i[w+184>>2],f=i[n+364>>2],l=i[n+356>>2],r=i[n+360>>2]}i[w+188>>2]=m,Z(k)}i[w+192>>2]=f,i[w+188>>2]=r,i[w+184>>2]=l,i[n+364>>2]=0,i[n+356>>2]=0,i[n+360>>2]=0;break n}W[i[o+136>>2]](f),w=i[n+76>>2]}W[i[i[w>>2]+100>>2]](w),l=i[n+76>>2],f=i[n+80>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);n:{t:{k=Y,r=k,o=i[r>>2];o:{if(!o)break o;for(;;){if(r=o,o=i[r+16>>2],o>>>0>B>>>0){if(k=r,o=i[r>>2],o)continue;break o}if(o>>>0>=B>>>0)break t;if(o=i[r+4>>2],!o)break}k=r+4|0}o=C(28),i[o+24>>2]=f,i[o+20>>2]=l,i[o+16>>2]=B,i[o+8>>2]=r,i[o>>2]=0,i[o+4>>2]=0,i[k>>2]=o,r=i[i[e+16>>2]>>2],r&&(i[e+16>>2]=r),G1(i[e+20>>2],o),i[e+24>>2]=i[e+24>>2]+1;break n}if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break n;W[i[i[f>>2]+8>>2]](f),y(f)}if(!u[i[n+344>>2]+164|0]){r=i[i[e+48>>2]+104>>2],r?r=i[r+104>>2]:r=0;n:{if((r|0)!=(B|0)||(r=i[n+76>>2],t[r+208|0]=1,f=i[n+80>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+40>>2]=r,r=i[e+44>>2],i[e+44>>2]=f,!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break n;W[i[i[r>>2]+8>>2]](r),y(r)}P0(G,n+76|0)}if(t[n+411|0]<0&&Z(i[n+400>>2]),f=i[n+320>>2],!f)break k;if(r=i[n+324>>2],o=f,(r|0)!=(f|0)){for(;;){o=i[r-4>>2];n:{if(!o||(l=i[o+4>>2],i[o+4>>2]=l-1,l))break n;W[i[i[o>>2]+8>>2]](o),y(o)}if(r=r-8|0,(f|0)==(r|0))break}o=i[n+320>>2]}i[n+324>>2]=f,Z(o)}r=i[n+80>>2];k:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break k;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=i[n+348>>2],!r)break f;if(f=i[r+4>>2],i[r+4>>2]=f-1,!f)break A;break f}if(r=i[n+348>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f}W[i[i[r>>2]+8>>2]](r),y(r)}if(h=h+4|0,(V|0)==(h|0))break}f:{A:{k:{if(!i[e+40>>2]){if(r=C(64),i[n+168>>2]=r,i[n+172>>2]=58,i[n+176>>2]=-2147483584,f=u[15762]|u[15763]<<8|(u[15764]<<16|u[15765]<<24),o=u[15758]|u[15759]<<8|(u[15760]<<16|u[15761]<<24),t[r|0]=o,t[r+1|0]=o>>>8,t[r+2|0]=o>>>16,t[r+3|0]=o>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+58|0]=0,f=u[15814]|u[15815]<<8,t[r+56|0]=f,t[r+57|0]=f>>>8,f=u[15810]|u[15811]<<8|(u[15812]<<16|u[15813]<<24),o=u[15806]|u[15807]<<8|(u[15808]<<16|u[15809]<<24),t[r+48|0]=o,t[r+49|0]=o>>>8,t[r+50|0]=o>>>16,t[r+51|0]=o>>>24,t[r+52|0]=f,t[r+53|0]=f>>>8,t[r+54|0]=f>>>16,t[r+55|0]=f>>>24,f=u[15802]|u[15803]<<8|(u[15804]<<16|u[15805]<<24),o=u[15798]|u[15799]<<8|(u[15800]<<16|u[15801]<<24),t[r+40|0]=o,t[r+41|0]=o>>>8,t[r+42|0]=o>>>16,t[r+43|0]=o>>>24,t[r+44|0]=f,t[r+45|0]=f>>>8,t[r+46|0]=f>>>16,t[r+47|0]=f>>>24,f=u[15794]|u[15795]<<8|(u[15796]<<16|u[15797]<<24),o=u[15790]|u[15791]<<8|(u[15792]<<16|u[15793]<<24),t[r+32|0]=o,t[r+33|0]=o>>>8,t[r+34|0]=o>>>16,t[r+35|0]=o>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[15786]|u[15787]<<8|(u[15788]<<16|u[15789]<<24),o=u[15782]|u[15783]<<8|(u[15784]<<16|u[15785]<<24),t[r+24|0]=o,t[r+25|0]=o>>>8,t[r+26|0]=o>>>16,t[r+27|0]=o>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[15778]|u[15779]<<8|(u[15780]<<16|u[15781]<<24),o=u[15774]|u[15775]<<8|(u[15776]<<16|u[15777]<<24),t[r+16|0]=o,t[r+17|0]=o>>>8,t[r+18|0]=o>>>16,t[r+19|0]=o>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[15770]|u[15771]<<8|(u[15772]<<16|u[15773]<<24),o=u[15766]|u[15767]<<8|(u[15768]<<16|u[15769]<<24),t[r+8|0]=o,t[r+9|0]=o>>>8,t[r+10|0]=o>>>16,t[r+11|0]=o>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,2e3,n+168|0),t[n+179|0]>=0)break k;Z(i[n+168>>2]);break k}if(o=i[e+16>>2],(Y|0)!=(o|0))for(U=A+8|0,_0=i[19543],r0=_0-12|0,g0=i[19544],f0=g0-12|0,X0=i[19547],M0=X0-12|0,V0=i[19545],z0=V0-12|0,N=n+152|0,j0=i[19552],S0=i[19551],I=n+188|0,Q=n+200|0,q0=i[19549],r2=i[19548],f2=i[19546],c=n+180|0,S=n+176|0,A2=n+232|0;;){r=i[o+20>>2],W[i[i[r>>2]+88>>2]](n+168|0,r),r=i[n+168>>2],t[n+187|0]<0&&Z(i[n+176>>2]);n:{if(r)break n;i[n+352>>2]=0,i[n+344>>2]=0,i[n+348>>2]=0,L1(n+320|0,i[e+48>>2],i[o+16>>2],n+344|0);t:{if(i[n+320>>2]){r=i[n+324>>2],i[A>>2]=i[n+320>>2],i[A+4>>2]=r,i[U+8>>2]=i[n+336>>2],r=i[n+332>>2],i[U>>2]=i[n+328>>2],i[U+4>>2]=r,i[n+328>>2]=0,i[n+332>>2]=0,i[n+336>>2]=0,w=1;break t}o:{l:{u:{s:{h:{r=i[n+344>>2],B=i[n+348>>2];w:{_:{if((r|0)==(B|0))break _;for(;;){v:{if(f=i[r>>2],!f||!Z0(f,92792,92996))break v;l=i[r+4>>2],l&&(i[l+4>>2]=i[l+4>>2]+1),f=i[e+48>>2],k=i[e+52>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),w=i[f+120>>2],m=i[f+124>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),_=i[o+16>>2],i[n+168>>2]=i[r>>2],f=i[r+4>>2],i[n+172>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[e+48>>2],s=i[e+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),i[n+392>>2]=i[f+128>>2],f=i[f+132>>2],i[n+396>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[w+36>>2],w=i[w+40>>2]-f>>3;B:{if((w|0)>0)m:for(V=i[n+168>>2],h=0;;){if((V|0)==i[f+(h<<3)>>2]){if(f=i[n+392>>2],w=i[f+104>>2],f=i[f+108>>2],(w|0)==(f|0))break m;for(V=h+1|0;;){g:{Z:{if((_|0)!=i[w>>2]||(h=i[w+4>>2],G=i[w+8>>2],(h|0)==(G|0)))break Z;for(;;){if((V|0)==p[h+2>>1])break g;if(h=h+4|0,(G|0)==(h|0))break}}if(w=w+16|0,(f|0)!=(w|0))continue;break m}break}f=t[h|0]&1;break B}if(h=h+1|0,(w|0)==(h|0))break}f=0}w=i[n+396>>2];B:{if(!w||(h=i[w+4>>2],i[w+4>>2]=h-1,h))break B;W[i[i[w>>2]+8>>2]](w),y(w)}B:{if(!s||(w=i[s+4>>2],i[s+4>>2]=w-1,w))break B;W[i[i[s>>2]+8>>2]](s),y(s)}w=i[n+172>>2];B:{if(!w||(s=i[w+4>>2],i[w+4>>2]=s-1,s))break B;W[i[i[w>>2]+8>>2]](w),y(w)}B:{if(!m||(w=i[m+4>>2],i[m+4>>2]=w-1,w))break B;W[i[i[m>>2]+8>>2]](m),y(m)}B:{if(!k||(m=i[k+4>>2],i[k+4>>2]=m-1,m))break B;W[i[i[k>>2]+8>>2]](k),y(k)}B:{if(!l||(k=i[l+4>>2],i[l+4>>2]=k-1,k))break B;W[i[i[l>>2]+8>>2]](l),y(l)}if(!f)break v;i[n+260>>2]=0,i[n+168>>2]=V0,i[n+232>>2]=78164,i[n+176>>2]=78144,f=n+168|0,i[f+i[z0>>2]>>2]=f2,i[n+172>>2]=0,l=f+i[i[n+168>>2]-12>>2]|0,J0(l,c),t[l+80|0]=0,i[l+72>>2]=0,i[n+176>>2]=X0,i[S+i[M0>>2]>>2]=r2,i[n+168>>2]=g0,i[f+i[f0>>2]>>2]=q0,i[n+232>>2]=78164,i[n+168>>2]=78124,i[n+176>>2]=78144,l=R0(c),i[l>>2]=77200,i[n+220>>2]=0,i[n+224>>2]=0,i[n+212>>2]=0,i[n+216>>2]=0,i[n+228>>2]=24,f=F(S,30705,31),k=n+392|0,Ce(k,i[r>>2]),h=f,r=t[n+403|0],f=(r|0)<0,F(F(h,f?i[n+392>>2]:k,f?i[n+396>>2]:r),30823,1),t[n+403|0]<0&&Z(i[n+392>>2]),r=i[n+228>>2];B:{if(r&16){if(r=Q,s=i[n+224>>2],f=i[n+204>>2],s>>>0>=f>>>0)break B;i[n+224>>2]=f,s=f;break B}if(!(r&8)){r=0,t[n+403|0]=0,s=n+392|0;break o}s=i[n+196>>2],r=I}if(f=i[r>>2],r=s-f|0,r>>>0>=2147483640)break h;if(r>>>0>=11){k=r|7,s=C(k+1|0),i[n+400>>2]=k-2147483647,i[n+392>>2]=s,i[n+396>>2]=r;break l}if(t[n+403|0]=r,s=n+392|0,r)break l;r=0;break o}if(r=r+8|0,(B|0)==(r|0))break}if(r=i[n+344>>2],f=i[n+348>>2],(r|0)!=(f|0)){for(;;){l=i[r>>2];v:{if(!l||(l=Z0(l,92792,93076),!l))break v;if(k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),(W[i[i[l>>2]+36>>2]](l)|0)!=2)break u;m=i[o+20>>2],w=i[l+108>>2],i[n+144>>2]=i[l+104>>2],i[n+148>>2]=w;B:{if(t[l+123|0]>=0){w=i[l+116>>2],i[N>>2]=i[l+112>>2],i[N+4>>2]=w,i[N+8>>2]=i[l+120>>2];break B}T(N,i[l+112>>2],i[l+116>>2])}l=i[m+508>>2];B:{if(l>>>0<o0[m+512>>2]){w=i[n+148>>2],i[l>>2]=i[n+144>>2],i[l+4>>2]=w,i[l+16>>2]=i[N+8>>2],w=i[N+4>>2],i[l+8>>2]=i[N>>2],i[l+12>>2]=w,i[N>>2]=0,i[N+4>>2]=0,i[N+8>>2]=0,i[m+508>>2]=l+20;break B}if(l=Je(m+504|0,n+144|0),w=t[n+163|0],i[m+508>>2]=l,(w|0)>=0)break B;Z(i[n+152>>2])}if(!k||(l=i[k+4>>2],i[k+4>>2]=l-1,l))break v;W[i[i[k>>2]+8>>2]](k),y(k)}if(r=r+8|0,(f|0)==(r|0))break}f=i[n+348>>2],r=i[n+344>>2]}if(l=0,(r|0)==(f|0))break _;for(;;){v:{if(k=i[r>>2],!k||(k=Z0(k,92792,92812),!k))break v;m=i[r+4>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),w=i[k+104>>2],k=i[k+108>>2],B=(w|0)!=0&(k|0)!=0;B:{if(!B){if(k=C(32),i[n+168>>2]=k,i[n+172>>2]=26,i[n+176>>2]=-2147483616,w=u[4378]|u[4379]<<8|(u[4380]<<16|u[4381]<<24),s=u[4374]|u[4375]<<8|(u[4376]<<16|u[4377]<<24),t[k|0]=s,t[k+1|0]=s>>>8,t[k+2|0]=s>>>16,t[k+3|0]=s>>>24,t[k+4|0]=w,t[k+5|0]=w>>>8,t[k+6|0]=w>>>16,t[k+7|0]=w>>>24,t[k+26|0]=0,w=u[4398]|u[4399]<<8,t[k+24|0]=w,t[k+25|0]=w>>>8,w=u[4394]|u[4395]<<8|(u[4396]<<16|u[4397]<<24),s=u[4390]|u[4391]<<8|(u[4392]<<16|u[4393]<<24),t[k+16|0]=s,t[k+17|0]=s>>>8,t[k+18|0]=s>>>16,t[k+19|0]=s>>>24,t[k+20|0]=w,t[k+21|0]=w>>>8,t[k+22|0]=w>>>16,t[k+23|0]=w>>>24,w=u[4386]|u[4387]<<8|(u[4388]<<16|u[4389]<<24),s=u[4382]|u[4383]<<8|(u[4384]<<16|u[4385]<<24),t[k+8|0]=s,t[k+9|0]=s>>>8,t[k+10|0]=s>>>16,t[k+11|0]=s>>>24,t[k+12|0]=w,t[k+13|0]=w>>>8,t[k+14|0]=w>>>16,t[k+15|0]=w>>>24,a(A,2,129,n+168|0),t[n+179|0]>=0)break B;Z(i[n+168>>2]);break B}l=i[o+20>>2],i[l+204>>2]=k,i[l+200>>2]=w,l=1}B:{if(!m||(k=i[m+4>>2],i[m+4>>2]=k-1,k))break B;if(W[i[i[m>>2]+8>>2]](m),y(m),B)break v;w=1;break t}if(B)break v;w=1;break t}if(r=r+8|0,(f|0)==(r|0))break}if(V=1,l&1)break w}f=i[o+20>>2],t[n+168|0]=0,t[n+179|0]=0,l=a(n+120|0,2,137,n+168|0),r=i[f+508>>2];_:{if(r>>>0<o0[f+512>>2]){k=i[l+4>>2],i[r>>2]=i[l>>2],i[r+4>>2]=k,i[r+16>>2]=i[n+136>>2],l=i[n+132>>2],i[r+8>>2]=i[n+128>>2],i[r+12>>2]=l,i[n+128>>2]=0,i[n+132>>2]=0,i[n+136>>2]=0,i[f+508>>2]=r+20;break _}if(r=Je(f+504|0,l),l=t[n+139|0],i[f+508>>2]=r,(l|0)>=0)break _;Z(i[n+128>>2])}t[n+179|0]<0&&Z(i[n+168>>2]),V=0}r=i[n+344>>2],m=i[n+348>>2];w:{if((r|0)==(m|0))break w;for(;;){k=i[r>>2];_:{if(!k)break _;if(l=Z0(k,92792,101920),l){f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[n+168>>2]=i[l+100>>2],l=i[l+104>>2],i[n+172>>2]=l,l&&(i[l+4>>2]=i[l+4>>2]+1),Zo(i[o+20>>2],n+168|0),l=i[n+172>>2];v:{if(!l||(k=i[l+4>>2],i[l+4>>2]=k-1,k))break v;W[i[i[l>>2]+8>>2]](l),y(l)}if(!f||(l=i[f+4>>2],i[f+4>>2]=l-1,l))break _;W[i[i[f>>2]+8>>2]](f),y(f);break _}w=0,s=0;v:{B:{if(f=Z0(k,92792,95420),!f)break B;if(s=i[r+4>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),!V){t[n+168|0]=0,t[n+179|0]=0,a(A,2,137,n+168|0),t[n+179|0]<0&&Z(i[n+168>>2]),w=1,h=0;break v}if(l=i[o+20>>2],k=i[f+148>>2],i[n+208>>2]=i[f+144>>2],i[n+212>>2]=k,k=i[f+140>>2],i[n+200>>2]=i[f+136>>2],i[n+204>>2]=k,k=i[f+132>>2],i[n+192>>2]=i[f+128>>2],i[n+196>>2]=k,k=i[f+124>>2],i[n+184>>2]=i[f+120>>2],i[n+188>>2]=k,k=i[f+116>>2],i[S>>2]=i[f+112>>2],i[S+4>>2]=k,k=i[f+108>>2],i[n+168>>2]=i[f+104>>2],i[n+172>>2]=k,h=1,t[l+368|0]=1,f=$e(l),k=Ke(l),x=+(f|0),d=u0[n+168>>3]*x,u0[n+392>>3]=d,s2=+(k|0),u0[n+400>>3]=u[n+192|0]?u0[n+200>>3]*s2:d,u0[n+408>>3]=u0[n+176>>3]*x,u0[n+416>>3]=u0[n+184>>3]*s2,u0[n+424>>3]=u0[n+208>>3],f=i[n+428>>2],i[l+408>>2]=i[n+424>>2],i[l+412>>2]=f,f=i[n+420>>2],i[l+400>>2]=i[n+416>>2],i[l+404>>2]=f,f=i[n+412>>2],i[l+392>>2]=i[n+408>>2],i[l+396>>2]=f,f=i[n+404>>2],i[l+384>>2]=i[n+400>>2],i[l+388>>2]=f,f=i[n+396>>2],i[l+376>>2]=i[n+392>>2],i[l+380>>2]=f,k=i[r>>2],k)break B;break v}if(k=Z0(k,92792,95500),!k){h=1;break v}if(f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),l=i[o+20>>2],B=n+168|0,z(B,k+104|0,80),h=1,t[l+416|0]=1,z(l+424|0,B,76),!f||(l=i[f+4>>2],i[f+4>>2]=l-1,l))break v;W[i[i[f>>2]+8>>2]](f),y(f)}v:{if(!s||(f=i[s+4>>2],i[s+4>>2]=f-1,f))break v;W[i[i[s>>2]+8>>2]](s),y(s)}if(!h)break t}if(r=r+8|0,(m|0)==(r|0))break}if(r=i[n+344>>2],C0=i[n+348>>2],(r|0)==(C0|0))break w;for(;;){f=i[r>>2];_:{if(!f)break _;s=0,k=0,E=Z0(f,92792,94264);v:{if(E){if(k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),m=i[E+100>>2],f=i[E+104>>2],w=(f|0)/2|0,l=m+w|0,_=(m>>31)+(w>>31)|0,f=p2(l,l>>>0<w>>>0?_+1|0:_,f,f>>31),B=i[E+108>>2],l=i[E+112>>2],h=(l|0)/2|0,m=B+h|0,G=(B>>31)+(h>>31)|0,w=i[o+20>>2],Z2=w,X2=p2(m,h>>>0>m>>>0?G+1|0:G,l,l>>31),i[Z2+204>>2]=X2,i[w+200>>2]=f,j=i[o+20>>2],u[j+368|0]==1){O=i[j+204>>2],f=i[j+200>>2],l=f-1|0,f=f+65535>>>0<131073,_=f?l:(l|0)/2|0,l=i[E+116>>2],w=l>>31,h=f?2:1,m=i[E+120>>2];B:{if((h|0)==(m|0)){if(B=(_>>31)+w|0,w=l+_|0,B=w>>>0<_>>>0?B+1|0:B,f=B,!(w- -2147483648>>>0<2147483648?f+1|0:f))break B;B=f>>31,_=B,l=w+(_|1)|0,G=f+_|0,w=p2(l,l>>>0<w>>>0?G+1|0:G,2,0),h=1;break B}if(G=m>>31,B=L0(m,G,_,_>>31),A0=h0,h=f,q=B,R=l,B=f&31,(f&63)>>>0>=32?(_=l<<B,f=0):(_=(1<<B)-1&R>>>32-B|w<<B,f=R<<B),w=q+f|0,B=_+A0|0,f=f>>>0>w>>>0?B+1|0:B,R=0-(f+(w>>>0>2147483647)|0)|0,B=m,l=h&31,(h&63)>>>0>=32?(_=B<<l,l=0):(_=(1<<l)-1&B>>>32-l|G<<l,l=B<<l),m=_,B=0-(_+(l>>>0>2147483647)|0)|R,(B|0)==1|B>>>0>1)for(;B=m>>31,h=l+(B|1)|0,G=B+m|0,l=p2(h,l>>>0>h>>>0?G+1|0:G,2,0),m=h0,B=f>>31,h=w+(B|1)|0,B=f+B|0,w=p2(h,h>>>0<w>>>0?B+1|0:B,2,0),f=h0,(f-(w>>>0<2147483648)|0)!=-1;);h=l}if(m=i[E+100>>2],B=m,l=i[E+104>>2],f=B-l|0,m=l>>31,B=(B>>31)-(m+(l>>>0>B>>>0)|0)|0,_=0-(B+(f>>>0>2147483647)|0)|0-((l>>>0>2147483647)+m|0),(_|0)==1|_>>>0>1){for(;_=m>>31,R=l+(_|1)|0,_=m+_|0,l=p2(R,l>>>0>R>>>0?_+1|0:_,2,0),m=h0,_=B>>31,G=_,_=f+(_|1)|0,B=B+G|0,f=p2(_,f>>>0>_>>>0?B+1|0:B,2,0),B=h0,(B-(f>>>0<2147483648)|0)!=-1;);m=l>>31}B=m<<1|l>>>31,l=l<<1,G=f>>31,_=0-((l>>>0>2147483646)+B|0)|0-(G+(f>>>0>2147483647)|0),(_|0)==1|_>>>0>1&&(_=m>>31,m=l+(_|1)|0,B=_+B|0,l=p2(m,l>>>0>m>>>0?B+1|0:B,2,0),B=G>>31,_=B,m=f+(_|1)|0,B=_+G|0,f=p2(m,f>>>0>m>>>0?B+1|0:B,2,0)),m=w>>31;B:{if((l|0)==(h|0)){if(m=m-((f>>31)+(f>>>0>w>>>0)|0)|0,l=w-f|0,f=h,B=f>>31,!(0-(m+(l>>>0>2147483647)|0)|0-(B+(f>>>0>2147483647)|0)))break B;for(;h=B>>31,w=f+(h|1)|0,_=B+h|0,f=p2(w,f>>>0>w>>>0?_+1|0:_,2,0),B=h0,h=m>>31,w=l+(h|1)|0,h=m+h|0,l=p2(w,l>>>0>w>>>0?h+1|0:h,2,0),m=h0,(m-(l>>>0<2147483648)|0)!=-1;);h=f;break B}if(B=l>>31,m=L0(l,B,w,m),_=h0,G=h>>31,f=L0(h,G,f,f>>31),w=m-f|0,m=_-(h0+(f>>>0>m>>>0)|0)|0,f=L0(l,B,h,G),l=w,B=h0,w=0-((l>>>0>2147483647)+m|0)|0-(B+(f>>>0>2147483647)|0),(w|0)==1|w>>>0>1)for(;h=B>>31,w=f+(h|1)|0,B=h+B|0,f=p2(w,f>>>0>w>>>0?B+1|0:B,2,0),B=h0,_=B-(f>>>0<2147483648)|0,h=m>>31,w=l+(h|1)|0,h=h+m|0,l=p2(w,l>>>0>w>>>0?h+1|0:h,2,0),m=h0,(m-(l>>>0<2147483648)&_)!=-1;);h=f}u0[j+392>>3]=u0[j+392>>3]-+(l|0)/+(h|0),f=O-1|0,l=f,h=(f|0)/2|0,f=O+65535>>>0<131073,h=f?l:h,l=i[E+124>>2],w=l>>31,_=f?2:1,m=i[E+128>>2];B:{if((_|0)==(m|0)){if(B=(h>>31)+w|0,w=l+h|0,B=w>>>0<h>>>0?B+1|0:B,f=B,!(w- -2147483648>>>0<2147483648?f+1|0:f))break B;B=f>>31,h=B,l=w+(h|1)|0,G=f+h|0,w=p2(l,l>>>0<w>>>0?G+1|0:G,2,0),_=1;break B}if(_=m,G=_>>31,B=L0(_,G,h,h>>31),R=h0,m=f,q=B,O=l,B=f&31,(f&63)>>>0>=32?(h=l<<B,f=0):(h=(1<<B)-1&O>>>32-B|w<<B,f=O<<B),w=q+f|0,B=h+R|0,f=f>>>0>w>>>0?B+1|0:B,O=0-(f+(w>>>0>2147483647)|0)|0,B=_,l=m&31,(m&63)>>>0>=32?(h=_<<l,l=0):(h=(1<<l)-1&B>>>32-l|G<<l,l=B<<l),m=h,B=0-(h+(l>>>0>2147483647)|0)|O,(B|0)==1|B>>>0>1)for(;B=m>>31,h=l+(B|1)|0,G=B+m|0,l=p2(h,l>>>0>h>>>0?G+1|0:G,2,0),m=h0,B=f>>31,h=w+(B|1)|0,B=f+B|0,w=p2(h,h>>>0<w>>>0?B+1|0:B,2,0),f=h0,(f-(w>>>0<2147483648)|0)!=-1;);_=l}if(m=i[E+108>>2],B=m,l=i[E+112>>2],f=B-l|0,m=l>>31,B=(B>>31)-(m+(l>>>0>B>>>0)|0)|0,h=0-(B+(f>>>0>2147483647)|0)|0-((l>>>0>2147483647)+m|0),(h|0)==1|h>>>0>1){for(;h=m>>31,E=l+(h|1)|0,h=m+h|0,l=p2(E,l>>>0>E>>>0?h+1|0:h,2,0),m=h0,h=B>>31,G=h,h=f+(h|1)|0,B=B+G|0,f=p2(h,f>>>0>h>>>0?B+1|0:B,2,0),B=h0,(B-(f>>>0<2147483648)|0)!=-1;);m=l>>31}B=m<<1|l>>>31,l=l<<1,G=f>>31,h=0-((l>>>0>2147483646)+B|0)|0-(G+(f>>>0>2147483647)|0),(h|0)==1|h>>>0>1&&(h=m>>31,m=l+(h|1)|0,B=h+B|0,l=p2(m,l>>>0>m>>>0?B+1|0:B,2,0),B=G>>31,h=B,m=f+(h|1)|0,B=h+G|0,f=p2(m,f>>>0>m>>>0?B+1|0:B,2,0)),m=w>>31;B:{if((l|0)==(_|0)){if(m=m-((f>>31)+(f>>>0>w>>>0)|0)|0,l=w-f|0,f=_,B=f>>31,!(0-(m+(l>>>0>2147483647)|0)|0-(B+(f>>>0>2147483647)|0)))break B;for(;h=B>>31,w=f+(h|1)|0,h=B+h|0,f=p2(w,f>>>0>w>>>0?h+1|0:h,2,0),B=h0,h=m>>31,w=l+(h|1)|0,h=m+h|0,l=p2(w,l>>>0>w>>>0?h+1|0:h,2,0),m=h0,(m-(l>>>0<2147483648)|0)!=-1;);_=f;break B}if(B=l>>31,m=L0(l,B,w,m),h=h0,G=_>>31,f=L0(_,G,f,f>>31),w=m-f|0,m=h-(h0+(f>>>0>m>>>0)|0)|0,f=L0(l,B,_,G),l=w,B=h0,w=0-((l>>>0>2147483647)+m|0)|0-(B+(f>>>0>2147483647)|0),(w|0)==1|w>>>0>1)for(;h=B>>31,w=f+(h|1)|0,B=h+B|0,f=p2(w,f>>>0>w>>>0?B+1|0:B,2,0),B=h0,G=B-(f>>>0<2147483648)|0,h=m>>31,w=l+(h|1)|0,h=h+m|0,l=p2(w,l>>>0>w>>>0?h+1|0:h,2,0),m=h0,(m-(l>>>0<2147483648)&G)!=-1;);_=f}u0[j+400>>3]=u0[j+400>>3]-+(l|0)/+(_|0)}if(f=i[r>>2],!f)break v}m=Z0(f,92792,94184);B:{if(!m)break B;if(s=i[r+4>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),!V){t[n+168|0]=0,t[n+179|0]=0,a(A,2,137,n+168|0),t[n+179|0]<0&&Z(i[n+168>>2]);m:{if(!s||(r=i[s+4>>2],i[s+4>>2]=r-1,r))break m;W[i[i[s>>2]+8>>2]](s),y(s)}if(w=1,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break t;W[i[i[k>>2]+8>>2]](k),y(k);break t}f=i[o+20>>2],l=i[f+204>>2],w=24,_=8;m:switch(i[m+100>>2]){case 1:u0[f+376>>3]=-u0[f+376>>3],l=i[f+200>>2],w=16,_=32;break;case 0:break m;default:break B}f=f+376|0,m=f+_|0,u0[m>>3]=-u0[m>>3],f=f+w|0,u0[f>>3]=+(l-1>>>0)-u0[f>>3]}f=i[r>>2];B:{if(!f||(l=Z0(f,92792,94104),!l))break B;if(f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),l=i[l+100>>2],!((l|0)!=270&(l|0)!=90)){if(!V){t[n+168|0]=0,t[n+179|0]=0,a(A,2,137,n+168|0),t[n+179|0]<0&&Z(i[n+168>>2]);m:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break m;W[i[i[f>>2]+8>>2]](f),y(f)}m:{if(!s||(r=i[s+4>>2],i[s+4>>2]=r-1,r))break m;W[i[i[s>>2]+8>>2]](s),y(s)}if(w=1,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break t;W[i[i[k>>2]+8>>2]](k),y(k);break t}l=i[o+20>>2],m=i[l+204>>2],i[l+204>>2]=i[l+200>>2],i[l+200>>2]=m}if(!f||(l=i[f+4>>2],i[f+4>>2]=l-1,l))break B;W[i[i[f>>2]+8>>2]](f),y(f)}if(!s||(f=i[s+4>>2],i[s+4>>2]=f-1,f))break v;W[i[i[s>>2]+8>>2]](s),y(s)}if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break _;W[i[i[k>>2]+8>>2]](k),y(k)}if(r=r+8|0,(C0|0)==(r|0))break}}if(w=i[o+20>>2],r=i[w+184>>2],l=i[w+188>>2],(r|0)==(l|0))break s;for(;;){w:{if(f=i[r>>2],!f||(f=Z0(f,92792,95796),!f))break w;r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1,w=i[o+20>>2]);_:{if(t[f+111|0]>=0){i[n+112>>2]=i[f+108>>2],l=i[f+104>>2],i[n+104>>2]=i[f+100>>2],i[n+108>>2]=l;break _}T(n+104|0,i[f+100>>2],i[f+104>>2])}if(W[i[i[w>>2]+36>>2]](w,n+104|0),t[n+115|0]<0&&Z(i[n+104>>2]),!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break s;W[i[i[r>>2]+8>>2]](r),y(r);break s}if(r=r+8|0,(l|0)==(r|0))break}break s}I0(),M()}if(w=0,f=i[o+20>>2],r=i[f+184>>2],k=i[f+188>>2],(r|0)==(k|0))break t;for(;;){s:{h:{if(l=i[r>>2],!l||(l=Z0(l,92792,114256),!l))break h;if(r=i[r+4>>2],r)break s;i[f+160>>2]=i[l+104>>2];break t}if(r=r+8|0,(k|0)!=(r|0))continue;break t}break}if(i[r+4>>2]=i[r+4>>2]+1,i[i[o+20>>2]+160>>2]=i[l+104>>2],f=i[r+4>>2],i[r+4>>2]=f-1,f)break t;W[i[i[r>>2]+8>>2]](r),y(r);break t}r=i[l+108>>2],i[A>>2]=i[l+104>>2],i[A+4>>2]=r;u:{if(t[l+123|0]>=0){r=i[l+116>>2],i[U>>2]=i[l+112>>2],i[U+4>>2]=r,i[U+8>>2]=i[l+120>>2];break u}T(U,i[l+112>>2],i[l+116>>2])}if(w=1,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break t;W[i[i[k>>2]+8>>2]](k),y(k);break t}if(!r)break o;z(s,f,r)}t[r+s|0]=0,a(A,4,3007,n+392|0),t[n+403|0]<0&&Z(i[n+392>>2]),i[n+168>>2]=_0,i[i[r0>>2]+(n+168|0)>>2]=S0,i[n+176>>2]=j0,i[l>>2]=77200,t[n+223|0]<0&&Z(i[n+212>>2]),y0(l),Y0(A2),w=1}if(t[n+339|0]<0&&Z(i[n+328>>2]),f=i[n+344>>2],f){if(r=i[n+348>>2],k=f,(r|0)!=(f|0)){for(;;){l=i[r-4>>2];t:{if(!l||(k=i[l+4>>2],i[l+4>>2]=k-1,k))break t;W[i[i[l>>2]+8>>2]](l),y(l)}if(r=r-8|0,(f|0)==(r|0))break}k=i[n+344>>2]}i[n+348>>2]=f,Z(k)}switch(w|0){case 0:case 5:break n;default:break k}}k=i[o+4>>2];n:{if(k){for(;;)if(r=k,k=i[r>>2],!k)break n}for(;r=i[o+8>>2],f=i[r>>2]!=(o|0),o=r,!!f;);}if(o=r,(r|0)==(Y|0))break}r=i[e+48>>2],E=i[r+80>>2],N=i[r+84>>2],N&&(i[N+4>>2]=i[N+4>>2]+1),o=i[e+16>>2];n:{if(!(!E|(Y|0)==(o|0))){for(_0=i[19543],r0=_0-12|0,g0=i[19544],f0=g0-12|0,X0=i[19547],M0=X0-12|0,V0=i[19545],z0=V0-12|0,j0=i[19552],S0=i[19551],m=n+188|0,V=n+200|0,q0=i[19549],r2=i[19548],f2=i[19546],S=n+180|0,c=n+176|0,A2=n+232|0;;){j3(n+392|0,E,i[i[o+20>>2]+196>>2]),w=i[n+392>>2],C0=i[n+396>>2];t:{if((w|0)==(C0|0)){f=18;break t}Q=o+20|0;o:{l:{u:{s:{for(;;){h:{w:{_:{v:{B:{m:{g:{if(r=i[w+16>>2],(r|0)!=1635088492){if((r|0)!=1953000802)break h;if(i[n+176>>2]=0,i[n+168>>2]=0,i[n+172>>2]=0,r=i[w+48>>2],l=i[w+44>>2],(r|0)==(l|0))break g;if(r=r-l|0,(r|0)<0)break i;for(f=C(r),i[n+168>>2]=f,G=r+f|0,i[n+176>>2]=G,r&&z(f,l,r),i[n+172>>2]=G,h=f;;){l=i[h>>2],s=i[Q>>2],t[s+209|0]=1;Z:{k=Y,r=i[k>>2];W:{if(!r)break W;for(;B=l>>>0>o0[r+16>>2],k=B?k:r,r=i[(B?4:0)+r>>2],!!r;);if((k|0)==(Y|0))break W;if(l>>>0>=o0[k+16>>2])break Z}if(r=C(48),i[n+320>>2]=r,i[n+324>>2]=41,i[n+328>>2]=-2147483600,l=u[15988]|u[15989]<<8|(u[15990]<<16|u[15991]<<24),k=u[15984]|u[15985]<<8|(u[15986]<<16|u[15987]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=l,t[r+5|0]=l>>>8,t[r+6|0]=l>>>16,t[r+7|0]=l>>>24,t[r+41|0]=0,t[r+40|0]=u[16024],l=u[16020]|u[16021]<<8|(u[16022]<<16|u[16023]<<24),k=u[16016]|u[16017]<<8|(u[16018]<<16|u[16019]<<24),t[r+32|0]=k,t[r+33|0]=k>>>8,t[r+34|0]=k>>>16,t[r+35|0]=k>>>24,t[r+36|0]=l,t[r+37|0]=l>>>8,t[r+38|0]=l>>>16,t[r+39|0]=l>>>24,l=u[16012]|u[16013]<<8|(u[16014]<<16|u[16015]<<24),k=u[16008]|u[16009]<<8|(u[16010]<<16|u[16011]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=l,t[r+29|0]=l>>>8,t[r+30|0]=l>>>16,t[r+31|0]=l>>>24,l=u[16004]|u[16005]<<8|(u[16006]<<16|u[16007]<<24),k=u[16e3]|u[16001]<<8|(u[16002]<<16|u[16003]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=l,t[r+21|0]=l>>>8,t[r+22|0]=l>>>16,t[r+23|0]=l>>>24,l=u[15996]|u[15997]<<8|(u[15998]<<16|u[15999]<<24),k=u[15992]|u[15993]<<8|(u[15994]<<16|u[15995]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=l,t[r+13|0]=l>>>8,t[r+14|0]=l>>>16,t[r+15|0]=l>>>24,a(A,2,2e3,n+320|0),t[n+331|0]>=0)break l;Z(i[n+320>>2]);break l}if(B=i[k+20>>2],u[B+209|0]==1){if(r=C(40),i[n+320>>2]=r,i[n+324>>2]=38,i[n+328>>2]=-2147483608,l=u[10705]|u[10706]<<8|(u[10707]<<16|u[10708]<<24),k=u[10701]|u[10702]<<8|(u[10703]<<16|u[10704]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=l,t[r+5|0]=l>>>8,t[r+6|0]=l>>>16,t[r+7|0]=l>>>24,t[r+38|0]=0,l=u[10735]|u[10736]<<8|(u[10737]<<16|u[10738]<<24),k=u[10731]|u[10732]<<8|(u[10733]<<16|u[10734]<<24),t[r+30|0]=k,t[r+31|0]=k>>>8,t[r+32|0]=k>>>16,t[r+33|0]=k>>>24,t[r+34|0]=l,t[r+35|0]=l>>>8,t[r+36|0]=l>>>16,t[r+37|0]=l>>>24,l=u[10729]|u[10730]<<8|(u[10731]<<16|u[10732]<<24),k=u[10725]|u[10726]<<8|(u[10727]<<16|u[10728]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=l,t[r+29|0]=l>>>8,t[r+30|0]=l>>>16,t[r+31|0]=l>>>24,l=u[10721]|u[10722]<<8|(u[10723]<<16|u[10724]<<24),k=u[10717]|u[10718]<<8|(u[10719]<<16|u[10720]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=l,t[r+21|0]=l>>>8,t[r+22|0]=l>>>16,t[r+23|0]=l>>>24,l=u[10713]|u[10714]<<8|(u[10715]<<16|u[10716]<<24),k=u[10709]|u[10710]<<8|(u[10711]<<16|u[10712]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=l,t[r+13|0]=l>>>8,t[r+14|0]=l>>>16,t[r+15|0]=l>>>24,a(A,2,2e3,n+320|0),t[n+331|0]>=0)break l;Z(i[n+320>>2]);break l}if((s|0)==(B|0)){if(r=C(40),i[n+320>>2]=r,i[n+324>>2]=34,i[n+328>>2]=-2147483608,l=u[18214]|u[18215]<<8|(u[18216]<<16|u[18217]<<24),k=u[18210]|u[18211]<<8|(u[18212]<<16|u[18213]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=l,t[r+5|0]=l>>>8,t[r+6|0]=l>>>16,t[r+7|0]=l>>>24,t[r+34|0]=0,l=u[18242]|u[18243]<<8,t[r+32|0]=l,t[r+33|0]=l>>>8,l=u[18238]|u[18239]<<8|(u[18240]<<16|u[18241]<<24),k=u[18234]|u[18235]<<8|(u[18236]<<16|u[18237]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=l,t[r+29|0]=l>>>8,t[r+30|0]=l>>>16,t[r+31|0]=l>>>24,l=u[18230]|u[18231]<<8|(u[18232]<<16|u[18233]<<24),k=u[18226]|u[18227]<<8|(u[18228]<<16|u[18229]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=l,t[r+21|0]=l>>>8,t[r+22|0]=l>>>16,t[r+23|0]=l>>>24,l=u[18222]|u[18223]<<8|(u[18224]<<16|u[18225]<<24),k=u[18218]|u[18219]<<8|(u[18220]<<16|u[18221]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=l,t[r+13|0]=l>>>8,t[r+14|0]=l>>>16,t[r+15|0]=l>>>24,a(A,2,2e3,n+320|0),t[n+331|0]>=0)break l;Z(i[n+320>>2]);break l}r=i[B+216>>2],_=i[B+220>>2];Z:{if(r>>>0<_>>>0){i[r>>2]=s,l=i[o+24>>2],i[r+4>>2]=l,l&&(i[l+4>>2]=i[l+4>>2]+1),k=r+8|0;break Z}if(s=i[B+212>>2],k=r-s|0,l=k>>3,r=l+1|0,r>>>0>=536870912)break i;if(_=_-s|0,I=_>>2,r=_>>>0>=2147483640?536870911:r>>>0<I>>>0?I:r,r>>>0>=536870912)break m;if(I=r<<3,U=C(I),r=U+k|0,i[r>>2]=i[o+20>>2],_=i[o+24>>2],i[r+4>>2]=_,_&&(i[_+4>>2]=i[_+4>>2]+1,s=i[B+212>>2],k=i[B+216>>2]-s|0,l=k>>3),l=r-(l<<3)|0,k&&z(l,s,k),i[B+220>>2]=I+U,k=r+8|0,i[B+216>>2]=k,i[B+212>>2]=l,!s)break Z;Z(s)}if(i[B+216>>2]=k,h=h+4|0,(G|0)==(h|0))break}F3(e,Q),Z(f);break h}Z:{W:{X:{V:{I:{if(f=i[Q>>2],r=i[f+184>>2],f=i[f+188>>2],(r|0)!=(f|0))for(;;){F:{if(l=i[r>>2],!l||(G=Z0(l,92792,94024),!G))break F;if(U=i[r+4>>2],U&&(i[U+4>>2]=i[U+4>>2]+1),f=0,i[n+176>>2]=0,i[n+168>>2]=0,i[n+172>>2]=0,l=0,r=i[w+48>>2],k=i[w+44>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break i;l=C(r),i[n+168>>2]=l,f=r+l|0,i[n+176>>2]=f,r&&z(l,k,r),i[n+172>>2]=f}switch(I=G+104|0,r=t[G+115|0],s=(r|0)<0,k=i[G+108>>2],B=s?k:r,B-25|0){case 0:break I;case 1:break V;case 18:break X;default:break Z}}if(r=r+8|0,(f|0)==(r|0))break}i[n+260>>2]=0,i[n+168>>2]=V0,i[n+232>>2]=78164,i[n+176>>2]=78144,r=n+168|0,i[r+i[z0>>2]>>2]=f2,i[n+172>>2]=0,f=r+i[i[n+168>>2]-12>>2]|0,J0(f,S),t[f+80|0]=0,i[f+72>>2]=0,i[n+176>>2]=X0,i[c+i[M0>>2]>>2]=r2,i[n+168>>2]=g0,i[r+i[f0>>2]>>2]=q0,i[n+232>>2]=78164,i[n+168>>2]=78124,i[n+176>>2]=78144,l=R0(S),i[l>>2]=77200,i[n+220>>2]=0,i[n+224>>2]=0,i[n+212>>2]=0,i[n+216>>2]=0,i[n+228>>2]=24,B0(F(c,32397,27),i[i[Q>>2]+196>>2]),r=i[n+228>>2];F:{if(r&16){if(r=V,s=i[n+224>>2],f=i[n+204>>2],s>>>0>=f>>>0)break F;i[n+224>>2]=f,s=f;break F}if(!(r&8)){r=0,t[n+331|0]=0,s=n+320|0;break u}s=i[n+196>>2],r=m}if(f=i[r>>2],r=s-f|0,r>>>0>=2147483640)break B;if(r>>>0>=11){k=r|7,s=C(k+1|0),i[n+328>>2]=k-2147483647,i[n+320>>2]=s,i[n+324>>2]=r;break s}if(t[n+331|0]=r,s=n+320|0,r)break s;r=0;break u}if(N2(s?i[I>>2]:I,23638,25))break Z;if((f|0)!=(l|0))break W;break Z}if(N2(s?i[I>>2]:I,23611,B))break Z;if((f|0)!=(l|0))break W;break Z}if(N2(s?i[I>>2]:I,20706,B)|(f|0)==(l|0))break Z}for(;;){s=i[l>>2];W:{X:{k=Y,r=i[k>>2];V:{if(!r)break V;for(;B=s>>>0>o0[r+16>>2],k=B?k:r,r=i[(B?4:0)+r>>2],!!r;);if((k|0)==(Y|0))break V;if(s>>>0>=o0[k+16>>2])break X}if(H3(i[e+48>>2],s))break W;r=C(40),i[n+320>>2]=r,i[n+324>>2]=35,i[n+328>>2]=-2147483608,f=u[19411]|u[19412]<<8|(u[19413]<<16|u[19414]<<24),l=u[19407]|u[19408]<<8|(u[19409]<<16|u[19410]<<24),t[r|0]=l,t[r+1|0]=l>>>8,t[r+2|0]=l>>>16,t[r+3|0]=l>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+35|0]=0,f=u[19438]|u[19439]<<8|(u[19440]<<16|u[19441]<<24),t[r+31|0]=f,t[r+32|0]=f>>>8,t[r+33|0]=f>>>16,t[r+34|0]=f>>>24,f=u[19435]|u[19436]<<8|(u[19437]<<16|u[19438]<<24),l=u[19431]|u[19432]<<8|(u[19433]<<16|u[19434]<<24),t[r+24|0]=l,t[r+25|0]=l>>>8,t[r+26|0]=l>>>16,t[r+27|0]=l>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[19427]|u[19428]<<8|(u[19429]<<16|u[19430]<<24),l=u[19423]|u[19424]<<8|(u[19425]<<16|u[19426]<<24),t[r+16|0]=l,t[r+17|0]=l>>>8,t[r+18|0]=l>>>16,t[r+19|0]=l>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[19419]|u[19420]<<8|(u[19421]<<16|u[19422]<<24),l=u[19415]|u[19416]<<8|(u[19417]<<16|u[19418]<<24),t[r+8|0]=l,t[r+9|0]=l>>>8,t[r+10|0]=l>>>16,t[r+11|0]=l>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,2e3,n+320|0),t[n+331|0]<0&&Z(i[n+320>>2]),r=0;break _}s=i[k+20>>2],B=i[k+24>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),_=i[Q>>2];X:{if((_|0)==(s|0)){if(r=C(32),i[n+320>>2]=r,i[n+324>>2]=30,i[n+328>>2]=-2147483616,k=u[18280]|u[18281]<<8|(u[18282]<<16|u[18283]<<24),h=u[18276]|u[18277]<<8|(u[18278]<<16|u[18279]<<24),t[r|0]=h,t[r+1|0]=h>>>8,t[r+2|0]=h>>>16,t[r+3|0]=h>>>24,t[r+4|0]=k,t[r+5|0]=k>>>8,t[r+6|0]=k>>>16,t[r+7|0]=k>>>24,t[r+30|0]=0,k=u[18302]|u[18303]<<8|(u[18304]<<16|u[18305]<<24),h=u[18298]|u[18299]<<8|(u[18300]<<16|u[18301]<<24),t[r+22|0]=h,t[r+23|0]=h>>>8,t[r+24|0]=h>>>16,t[r+25|0]=h>>>24,t[r+26|0]=k,t[r+27|0]=k>>>8,t[r+28|0]=k>>>16,t[r+29|0]=k>>>24,k=u[18296]|u[18297]<<8|(u[18298]<<16|u[18299]<<24),h=u[18292]|u[18293]<<8|(u[18294]<<16|u[18295]<<24),t[r+16|0]=h,t[r+17|0]=h>>>8,t[r+18|0]=h>>>16,t[r+19|0]=h>>>24,t[r+20|0]=k,t[r+21|0]=k>>>8,t[r+22|0]=k>>>16,t[r+23|0]=k>>>24,k=u[18288]|u[18289]<<8|(u[18290]<<16|u[18291]<<24),h=u[18284]|u[18285]<<8|(u[18286]<<16|u[18287]<<24),t[r+8|0]=h,t[r+9|0]=h>>>8,t[r+10|0]=h>>>16,t[r+11|0]=h>>>24,t[r+12|0]=k,t[r+13|0]=k>>>8,t[r+14|0]=k>>>16,t[r+15|0]=k>>>24,a(A,2,2e3,n+320|0),t[n+331|0]>=0)break X;Z(i[n+320>>2]);break X}t[_+224|0]=1,i[n+96>>2]=_,r=i[o+24>>2],i[n+100>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[n+100>>2],i[n+16>>2]=i[n+96>>2],i[n+20>>2]=r,r=v-48|0,v=r,j=i[n+20>>2],k=i[n+16>>2],i[n+16>>2]=0,i[n+20>>2]=0,i[s+228>>2]=k,h=i[s+232>>2],i[s+232>>2]=j,h&&(k=i[h+4>>2],i[h+4>>2]=k-1,k||(W[i[i[h>>2]+8>>2]](h),y(h)),k=i[s+228>>2]);V:{if(!k)break V;if(h=i[s+80>>2],j=i[s+84>>2],(h|0)!=(j|0))for(;;){if(i[h+4>>2]==6)break V;if(h=h+44|0,(j|0)==(h|0))break}O=W[i[i[k>>2]+104>>2]](k)|0,A0=i[s+92>>2],i[s+92>>2]=A0+1,t0=(O|0)<=0,k=0,j=0,h=i[s+184>>2],q=i[s+188>>2];I:{if((h|0)==(q|0))break I;F:{for(;;){Q:{if(R=i[h>>2],!R||(R=Z0(R,92792,92812),!R))break Q;if(h=i[h+4>>2],h)break F;j=i[R+104>>2];break I}if(h=h+8|0,(q|0)==(h|0))break}break I}if(q=i[h+4>>2],v2=q+1|0,i[h+4>>2]=v2,j=i[R+104>>2],i[h+4>>2]=q,v2)break I;W[i[i[h>>2]+8>>2]](h),y(h)}R=t0?8:O,h=i[s+184>>2],t0=i[s+188>>2];I:{if((h|0)==(t0|0))break I;F:{for(;;){Q:{if(O=i[h>>2],!O||(O=Z0(O,92792,92812),!O))break Q;if(h=i[h+4>>2],h)break F;k=i[O+108>>2];break I}if(h=h+8|0,(t0|0)==(h|0))break}break I}if(t0=i[h+4>>2],q=t0+1|0,i[h+4>>2]=q,k=i[O+108>>2],i[h+4>>2]=t0,q)break I;W[i[i[h>>2]+8>>2]](h),y(h)}if(i[r+44>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,t[r+32|0]=1,i[r+28>>2]=k,i[r+24>>2]=j,X[r+20>>1]=R,i[r+16>>2]=0,X[r+12>>1]=7,i[r+8>>2]=6,i[r+4>>2]=A0,k=i[s+84>>2],k>>>0<o0[s+88>>2]){h=i[r+8>>2],i[k>>2]=i[r+4>>2],i[k+4>>2]=h,h=u[r+29|0]|u[r+30|0]<<8|(u[r+31|0]<<16|u[r+32|0]<<24),j=u[r+25|0]|u[r+26|0]<<8|(u[r+27|0]<<16|u[r+28|0]<<24),t[k+21|0]=j,t[k+22|0]=j>>>8,t[k+23|0]=j>>>16,t[k+24|0]=j>>>24,t[k+25|0]=h,t[k+26|0]=h>>>8,t[k+27|0]=h>>>16,t[k+28|0]=h>>>24,h=i[r+24>>2],i[k+16>>2]=i[r+20>>2],i[k+20>>2]=h,h=i[r+16>>2],i[k+8>>2]=i[r+12>>2],i[k+12>>2]=h,i[k+40>>2]=i[r+44>>2],h=i[r+40>>2],i[k+32>>2]=i[r+36>>2],i[k+36>>2]=h,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[s+84>>2]=k+44;break V}if(k=U8(s+80|0,r+4|0),h=t[r+47|0],i[s+84>>2]=k,(h|0)>=0)break V;Z(i[r+36>>2])}k=i[n+20>>2];V:{if(!k||(h=i[k+4>>2],i[k+4>>2]=h-1,h))break V;W[i[i[k>>2]+8>>2]](k),y(k)}v=r+48|0}X:{if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break X;W[i[i[B>>2]+8>>2]](B),y(B)}if((s|0)!=(_|0))break W;r=0;break _}if(l=l+4|0,(l|0)==(f|0))break}r=u[G+115|0],k=i[G+108>>2]}Z:{W:{if(f=r,r=r<<24>>24<0,f=(r?k:f)-26|0,f){if((f|0)==17)break W;break v}if(!N2(r?i[I>>2]:I,23344,26))break Z;break v}if(N2(r?i[I>>2]:I,11693,43))break v}if(t[i[Q>>2]+236|0]=1,l=i[n+168>>2],j=i[n+172>>2],(l|0)==(j|0))break v;for(;;){Z:{f=i[l>>2];W:{X:{k=Y,r=i[k>>2];V:{if(!r)break V;for(;s=f>>>0>o0[r+16>>2],k=s?k:r,r=i[(s?4:0)+r>>2],!!r;);if((k|0)==(Y|0))break V;if(f>>>0>=o0[k+16>>2])break X}if(H3(i[e+48>>2],f))break W;r=C(40),i[n+320>>2]=r,i[n+324>>2]=35,i[n+328>>2]=-2147483608,f=u[19341]|u[19342]<<8|(u[19343]<<16|u[19344]<<24),l=u[19337]|u[19338]<<8|(u[19339]<<16|u[19340]<<24),t[r|0]=l,t[r+1|0]=l>>>8,t[r+2|0]=l>>>16,t[r+3|0]=l>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+35|0]=0,f=u[19368]|u[19369]<<8|(u[19370]<<16|u[19371]<<24),t[r+31|0]=f,t[r+32|0]=f>>>8,t[r+33|0]=f>>>16,t[r+34|0]=f>>>24,f=u[19365]|u[19366]<<8|(u[19367]<<16|u[19368]<<24),l=u[19361]|u[19362]<<8|(u[19363]<<16|u[19364]<<24),t[r+24|0]=l,t[r+25|0]=l>>>8,t[r+26|0]=l>>>16,t[r+27|0]=l>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[19357]|u[19358]<<8|(u[19359]<<16|u[19360]<<24),l=u[19353]|u[19354]<<8|(u[19355]<<16|u[19356]<<24),t[r+16|0]=l,t[r+17|0]=l>>>8,t[r+18|0]=l>>>16,t[r+19|0]=l>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[19349]|u[19350]<<8|(u[19351]<<16|u[19352]<<24),l=u[19345]|u[19346]<<8|(u[19347]<<16|u[19348]<<24),t[r+8|0]=l,t[r+9|0]=l>>>8,t[r+10|0]=l>>>16,t[r+11|0]=l>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,2e3,n+320|0),t[n+331|0]<0&&Z(i[n+320>>2]),r=0;break _}if(r=i[Q>>2],f=i[k+20>>2],(r|0)==(f|0)){r=C(32),i[n+320>>2]=r,i[n+324>>2]=30,i[n+328>>2]=-2147483616,f=u[18249]|u[18250]<<8|(u[18251]<<16|u[18252]<<24),l=u[18245]|u[18246]<<8|(u[18247]<<16|u[18248]<<24),t[r|0]=l,t[r+1|0]=l>>>8,t[r+2|0]=l>>>16,t[r+3|0]=l>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+30|0]=0,f=u[18271]|u[18272]<<8|(u[18273]<<16|u[18274]<<24),l=u[18267]|u[18268]<<8|(u[18269]<<16|u[18270]<<24),t[r+22|0]=l,t[r+23|0]=l>>>8,t[r+24|0]=l>>>16,t[r+25|0]=l>>>24,t[r+26|0]=f,t[r+27|0]=f>>>8,t[r+28|0]=f>>>16,t[r+29|0]=f>>>24,f=u[18265]|u[18266]<<8|(u[18267]<<16|u[18268]<<24),l=u[18261]|u[18262]<<8|(u[18263]<<16|u[18264]<<24),t[r+16|0]=l,t[r+17|0]=l>>>8,t[r+18|0]=l>>>16,t[r+19|0]=l>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[18257]|u[18258]<<8|(u[18259]<<16|u[18260]<<24),l=u[18253]|u[18254]<<8|(u[18255]<<16|u[18256]<<24),t[r+8|0]=l,t[r+9|0]=l>>>8,t[r+10|0]=l>>>16,t[r+11|0]=l>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,2e3,n+320|0),t[n+331|0]<0&&Z(i[n+320>>2]),r=0;break _}k=i[o+24>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[f+240>>2]=r,r=i[f+244>>2],i[f+244>>2]=k;X:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break X;W[i[i[r>>2]+8>>2]](r),y(r)}if(i[G+116>>2]==i[G+120>>2])break W;i[n+328>>2]=0,i[n+320>>2]=0,i[n+324>>2]=0,O=n+320|0,k=v-112|0,v=k,r=i[G+116>>2],f=K6(k- -64|0,r,i[G+120>>2]-r|0),r=i[f+12>>2],h=r>>31<<3|r>>>29,s=i[f+24>>2],r=s+(r<<3)|0,B=(s>>31)+h|0;X:{V:{B=r>>>0<s>>>0?B+1|0:B;I:{if((B|0)<=0&r>>>0<=31|(B|0)<0){if(r=C(24),i[k+32>>2]=r,i[k+36>>2]=22,i[k+40>>2]=-2147483624,f=u[3955]|u[3956]<<8|(u[3957]<<16|u[3958]<<24),s=u[3951]|u[3952]<<8|(u[3953]<<16|u[3954]<<24),t[r|0]=s,t[r+1|0]=s>>>8,t[r+2|0]=s>>>16,t[r+3|0]=s>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+22|0]=0,f=u[3969]|u[3970]<<8|(u[3971]<<16|u[3972]<<24),s=u[3965]|u[3966]<<8|(u[3967]<<16|u[3968]<<24),t[r+14|0]=s,t[r+15|0]=s>>>8,t[r+16|0]=s>>>16,t[r+17|0]=s>>>24,t[r+18|0]=f,t[r+19|0]=f>>>8,t[r+20|0]=f>>>16,t[r+21|0]=f>>>24,f=u[3963]|u[3964]<<8|(u[3965]<<16|u[3966]<<24),s=u[3959]|u[3960]<<8|(u[3961]<<16|u[3962]<<24),t[r+8|0]=s,t[r+9|0]=s>>>8,t[r+10|0]=s>>>16,t[r+11|0]=s>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,100,k+32|0),t[k+43|0]>=0)break I;Z(i[k+32>>2]);break I}h=T0(f,32),r=(i[f+8>>2]-i[f+12>>2]|0)+(i[f+24>>2]/-8|0)|0;F:{if((h|0)<=(r|0))break F;if(r=r+i[G+116>>2]|0,s=K6(k+32|0,r,i[G+120>>2]-r|0),r=i[s+12>>2],B=r>>31<<3|r>>>29,f=i[s+24>>2],r=f+(r<<3)|0,_=(f>>31)+B|0,_=r>>>0<f>>>0?_+1|0:_,(_|0)<=0&r>>>0<=39|(_|0)<0){if(r=C(24),i[k+8>>2]=r,i[k+12>>2]=22,i[k+16>>2]=-2147483624,f=u[3955]|u[3956]<<8|(u[3957]<<16|u[3958]<<24),s=u[3951]|u[3952]<<8|(u[3953]<<16|u[3954]<<24),t[r|0]=s,t[r+1|0]=s>>>8,t[r+2|0]=s>>>16,t[r+3|0]=s>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+22|0]=0,f=u[3969]|u[3970]<<8|(u[3971]<<16|u[3972]<<24),s=u[3965]|u[3966]<<8|(u[3967]<<16|u[3968]<<24),t[r+14|0]=s,t[r+15|0]=s>>>8,t[r+16|0]=s>>>16,t[r+17|0]=s>>>24,t[r+18|0]=f,t[r+19|0]=f>>>8,t[r+20|0]=f>>>16,t[r+21|0]=f>>>24,f=u[3963]|u[3964]<<8|(u[3965]<<16|u[3966]<<24),s=u[3959]|u[3960]<<8|(u[3961]<<16|u[3962]<<24),t[r+8|0]=s,t[r+9|0]=s>>>8,t[r+10|0]=s>>>16,t[r+11|0]=s>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,100,k+8|0),t[k+19|0]>=0)break I;Z(i[k+8>>2]);break I}if(T0(s,32),r=O2(s,8),m2(s,8),((r>>>1|0)-39&255)>>>0>1)break F;if(r=i[s+24>>2],f=r,B=r>>31,r=i[s+12>>2],h=r>>31<<3|r>>>29,_=f,f=r<<3,r=_+f|0,h=h+B|0,h=r>>>0<f>>>0?h+1|0:h,(h|0)<=0&r>>>0<=15|(h|0)<0){if(r=C(24),i[k+8>>2]=r,i[k+12>>2]=22,i[k+16>>2]=-2147483624,f=u[3955]|u[3956]<<8|(u[3957]<<16|u[3958]<<24),s=u[3951]|u[3952]<<8|(u[3953]<<16|u[3954]<<24),t[r|0]=s,t[r+1|0]=s>>>8,t[r+2|0]=s>>>16,t[r+3|0]=s>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+22|0]=0,f=u[3969]|u[3970]<<8|(u[3971]<<16|u[3972]<<24),s=u[3965]|u[3966]<<8|(u[3967]<<16|u[3968]<<24),t[r+14|0]=s,t[r+15|0]=s>>>8,t[r+16|0]=s>>>16,t[r+17|0]=s>>>24,t[r+18|0]=f,t[r+19|0]=f>>>8,t[r+20|0]=f>>>16,t[r+21|0]=f>>>24,f=u[3963]|u[3964]<<8|(u[3965]<<16|u[3966]<<24),s=u[3959]|u[3960]<<8|(u[3961]<<16|u[3962]<<24),t[r+8|0]=s,t[r+9|0]=s>>>8,t[r+10|0]=s>>>16,t[r+11|0]=s>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,100,k+8|0),t[k+19|0]>=0)break I;Z(i[k+8>>2]);break I}if(r=O2(s,8),O2(s,8),(r|0)!=177)break F;h=k+8|0,B=v-48|0,v=B,r=C(80),i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r>>2]=104148,i[r+16>>2]=104188,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,f=r- -64|0,i[f>>2]=0,i[f+4>>2]=0,t[r+24|0]=1,f=T0(s,1),t[r+25|0]=f,Z2=r,X2=T0(s,1),t[Z2+26|0]=X2,_=T0(s,1),t[r+27|0]=_,R=T0(s,1),t[r+28|0]=R;Q:{if(!A1(s,B+44|0)){f=C(48),i[B+12>>2]=f,i[B+16>>2]=42,i[B+20>>2]=-2147483600,s=u[3571]|u[3572]<<8,t[f+40|0]=s,t[f+41|0]=s>>>8,s=u[3567]|u[3568]<<8|(u[3569]<<16|u[3570]<<24),_=u[3563]|u[3564]<<8|(u[3565]<<16|u[3566]<<24),t[f+32|0]=_,t[f+33|0]=_>>>8,t[f+34|0]=_>>>16,t[f+35|0]=_>>>24,t[f+36|0]=s,t[f+37|0]=s>>>8,t[f+38|0]=s>>>16,t[f+39|0]=s>>>24,s=u[3559]|u[3560]<<8|(u[3561]<<16|u[3562]<<24),_=u[3555]|u[3556]<<8|(u[3557]<<16|u[3558]<<24),t[f+24|0]=_,t[f+25|0]=_>>>8,t[f+26|0]=_>>>16,t[f+27|0]=_>>>24,t[f+28|0]=s,t[f+29|0]=s>>>8,t[f+30|0]=s>>>16,t[f+31|0]=s>>>24,s=u[3551]|u[3552]<<8|(u[3553]<<16|u[3554]<<24),_=u[3547]|u[3548]<<8|(u[3549]<<16|u[3550]<<24),t[f+16|0]=_,t[f+17|0]=_>>>8,t[f+18|0]=_>>>16,t[f+19|0]=_>>>24,t[f+20|0]=s,t[f+21|0]=s>>>8,t[f+22|0]=s>>>16,t[f+23|0]=s>>>24,s=u[3543]|u[3544]<<8|(u[3545]<<16|u[3546]<<24),_=u[3539]|u[3540]<<8|(u[3541]<<16|u[3542]<<24),t[f+8|0]=_,t[f+9|0]=_>>>8,t[f+10|0]=_>>>16,t[f+11|0]=_>>>24,t[f+12|0]=s,t[f+13|0]=s>>>8,t[f+14|0]=s>>>16,t[f+15|0]=s>>>24,s=u[3535]|u[3536]<<8|(u[3537]<<16|u[3538]<<24),_=u[3531]|u[3532]<<8|(u[3533]<<16|u[3534]<<24),t[f|0]=_,t[f+1|0]=_>>>8,t[f+2|0]=_>>>16,t[f+3|0]=_>>>24,t[f+4|0]=s,t[f+5|0]=s>>>8,t[f+6|0]=s>>>16,t[f+7|0]=s>>>24,t[f+42|0]=0,f=a(B+24|0,2,2006,B+12|0),s=i[f+4>>2],i[h>>2]=i[f>>2],i[h+4>>2]=s,s=h+8|0;p:{if(t[f+19|0]>=0){_=i[f+12>>2],i[s>>2]=i[f+8>>2],i[s+4>>2]=_,i[s+8>>2]=i[f+16>>2],t[h+20|0]=1;break p}if(T(s,i[f+8>>2],i[f+12>>2]),s=t[f+19|0],t[h+20|0]=1,(s|0)>=0)break p;Z(i[f+8>>2])}if(t[B+23|0]>=0)break Q;Z(i[B+12>>2]);break Q}if(A0=i[B+44>>2],A0>>>0>=4){f=C(48),i[B+12>>2]=f,i[B+16>>2]=44,i[B+20>>2]=-2147483600,s=u[15279]|u[15280]<<8|(u[15281]<<16|u[15282]<<24),t[f+40|0]=s,t[f+41|0]=s>>>8,t[f+42|0]=s>>>16,t[f+43|0]=s>>>24,s=u[15275]|u[15276]<<8|(u[15277]<<16|u[15278]<<24),_=u[15271]|u[15272]<<8|(u[15273]<<16|u[15274]<<24),t[f+32|0]=_,t[f+33|0]=_>>>8,t[f+34|0]=_>>>16,t[f+35|0]=_>>>24,t[f+36|0]=s,t[f+37|0]=s>>>8,t[f+38|0]=s>>>16,t[f+39|0]=s>>>24,s=u[15267]|u[15268]<<8|(u[15269]<<16|u[15270]<<24),_=u[15263]|u[15264]<<8|(u[15265]<<16|u[15266]<<24),t[f+24|0]=_,t[f+25|0]=_>>>8,t[f+26|0]=_>>>16,t[f+27|0]=_>>>24,t[f+28|0]=s,t[f+29|0]=s>>>8,t[f+30|0]=s>>>16,t[f+31|0]=s>>>24,s=u[15259]|u[15260]<<8|(u[15261]<<16|u[15262]<<24),_=u[15255]|u[15256]<<8|(u[15257]<<16|u[15258]<<24),t[f+16|0]=_,t[f+17|0]=_>>>8,t[f+18|0]=_>>>16,t[f+19|0]=_>>>24,t[f+20|0]=s,t[f+21|0]=s>>>8,t[f+22|0]=s>>>16,t[f+23|0]=s>>>24,s=u[15251]|u[15252]<<8|(u[15253]<<16|u[15254]<<24),_=u[15247]|u[15248]<<8|(u[15249]<<16|u[15250]<<24),t[f+8|0]=_,t[f+9|0]=_>>>8,t[f+10|0]=_>>>16,t[f+11|0]=_>>>24,t[f+12|0]=s,t[f+13|0]=s>>>8,t[f+14|0]=s>>>16,t[f+15|0]=s>>>24,s=u[15243]|u[15244]<<8|(u[15245]<<16|u[15246]<<24),_=u[15239]|u[15240]<<8|(u[15241]<<16|u[15242]<<24),t[f|0]=_,t[f+1|0]=_>>>8,t[f+2|0]=_>>>16,t[f+3|0]=_>>>24,t[f+4|0]=s,t[f+5|0]=s>>>8,t[f+6|0]=s>>>16,t[f+7|0]=s>>>24,t[f+44|0]=0,f=a(B+24|0,2,2006,B+12|0),s=i[f+4>>2],i[h>>2]=i[f>>2],i[h+4>>2]=s,s=h+8|0;p:{if(t[f+19|0]>=0){_=i[f+12>>2],i[s>>2]=i[f+8>>2],i[s+4>>2]=_,i[s+8>>2]=i[f+16>>2],t[h+20|0]=1;break p}if(T(s,i[f+8>>2],i[f+12>>2]),s=t[f+19|0],t[h+20|0]=1,(s|0)>=0)break p;Z(i[f+8>>2])}if(t[B+23|0]>=0)break Q;Z(i[B+12>>2]);break Q}if(i[r+64>>2]=A0,(_|R)&255){if(!A1(s,B+8|0)){f=C(48),i[B+12>>2]=f,i[B+16>>2]=41,i[B+20>>2]=-2147483600,t[f+40|0]=u[3529],s=u[3525]|u[3526]<<8|(u[3527]<<16|u[3528]<<24),_=u[3521]|u[3522]<<8|(u[3523]<<16|u[3524]<<24),t[f+32|0]=_,t[f+33|0]=_>>>8,t[f+34|0]=_>>>16,t[f+35|0]=_>>>24,t[f+36|0]=s,t[f+37|0]=s>>>8,t[f+38|0]=s>>>16,t[f+39|0]=s>>>24,s=u[3517]|u[3518]<<8|(u[3519]<<16|u[3520]<<24),_=u[3513]|u[3514]<<8|(u[3515]<<16|u[3516]<<24),t[f+24|0]=_,t[f+25|0]=_>>>8,t[f+26|0]=_>>>16,t[f+27|0]=_>>>24,t[f+28|0]=s,t[f+29|0]=s>>>8,t[f+30|0]=s>>>16,t[f+31|0]=s>>>24,s=u[3509]|u[3510]<<8|(u[3511]<<16|u[3512]<<24),_=u[3505]|u[3506]<<8|(u[3507]<<16|u[3508]<<24),t[f+16|0]=_,t[f+17|0]=_>>>8,t[f+18|0]=_>>>16,t[f+19|0]=_>>>24,t[f+20|0]=s,t[f+21|0]=s>>>8,t[f+22|0]=s>>>16,t[f+23|0]=s>>>24,s=u[3501]|u[3502]<<8|(u[3503]<<16|u[3504]<<24),_=u[3497]|u[3498]<<8|(u[3499]<<16|u[3500]<<24),t[f+8|0]=_,t[f+9|0]=_>>>8,t[f+10|0]=_>>>16,t[f+11|0]=_>>>24,t[f+12|0]=s,t[f+13|0]=s>>>8,t[f+14|0]=s>>>16,t[f+15|0]=s>>>24,s=u[3493]|u[3494]<<8|(u[3495]<<16|u[3496]<<24),_=u[3489]|u[3490]<<8|(u[3491]<<16|u[3492]<<24),t[f|0]=_,t[f+1|0]=_>>>8,t[f+2|0]=_>>>16,t[f+3|0]=_>>>24,t[f+4|0]=s,t[f+5|0]=s>>>8,t[f+6|0]=s>>>16,t[f+7|0]=s>>>24,t[f+41|0]=0,f=a(B+24|0,2,2006,B+12|0),s=i[f+4>>2],i[h>>2]=i[f>>2],i[h+4>>2]=s,s=h+8|0;p:{if(t[f+19|0]>=0){_=i[f+12>>2],i[s>>2]=i[f+8>>2],i[s+4>>2]=_,i[s+8>>2]=i[f+16>>2],t[h+20|0]=1;break p}if(T(s,i[f+8>>2],i[f+12>>2]),s=t[f+19|0],t[h+20|0]=1,(s|0)>=0)break p;Z(i[f+8>>2])}if(t[B+23|0]>=0)break Q;Z(i[B+12>>2]);break Q}i[r+68>>2]=i[B+8>>2],f=u[r+25|0]}if(f&255){R=O2(s,1),f=T0(s,7),_=O2(s,5)+1&255,x=+(T0(s,_)>>>0);p:{if((f|0)>0){d=_4(1,_),x=_4(1,f-31|0)*(x/d+1);break p}x=_4(1,-30-_|0)*x}u0[r+32>>3]=R?-x:x}if(u[r+26|0]){R=O2(s,1),f=T0(s,7),_=O2(s,5)+1&255,x=+(T0(s,_)>>>0);p:{if((f|0)>0){d=_4(1,_),x=_4(1,f-31|0)*(x/d+1);break p}x=_4(1,-30-_|0)*x}u0[r+40>>3]=R?-x:x}if(u[r+27|0]){R=O2(s,1),f=T0(s,7),_=O2(s,5)+1&255,x=+(T0(s,_)>>>0);p:{if((f|0)>0){d=_4(1,_),x=_4(1,f-31|0)*(x/d+1);break p}x=_4(1,-30-_|0)*x}u0[r+48>>3]=R?-x:x}if(u[r+28|0]){_=O2(s,1),f=T0(s,7),R=s,s=O2(s,5)+1&255,x=+(T0(R,s)>>>0);p:{if((f|0)>0){d=_4(1,s),x=_4(1,f-31|0)*(x/d+1);break p}x=_4(1,-30-s|0)*x}u0[r+56>>3]=_?-x:x}i[r+4>>2]=i[r+4>>2]+1,t[h+20|0]=0,i[h+4>>2]=r,i[h>>2]=r+16}f=i[r+4>>2],i[r+4>>2]=f-1,f||(W[i[i[r>>2]+8>>2]](r),y(r)),v=B+48|0,r=u[k+28|0];Q:{if(r){if((r|0)!=1)break V;Z8(A,h);break Q}P0(O,k+8|0)}if(f=u[k+28|0],(f|0)!=255&&(s=i[26051],i[k+104>>2]=i[26050],i[k+108>>2]=s,W[i[(k+104|0)+(f<<2)>>2]](k+103|0,k+8|0)),r)break I}if(r=i[28729],i[A>>2]=i[28728],i[A+4>>2]=r,r=A+8|0,t[114931]>=0){f=i[28731],i[r>>2]=i[28730],i[r+4>>2]=f,i[r+8>>2]=i[28732];break I}T(r,i[28730],i[28731])}v=k+112|0;break X}e2(),M()}if(r=i[n+320>>2],i[A>>2])break Z;if(B=i[n+324>>2],(B|0)!=(r|0))for(;;){f=i[r>>2];X:{if(!f||(f=Z0(f,101024,101032),!f))break X;if(s=i[r+4>>2],!s){k=i[Q>>2],t[k+248|0]=1,s=i[f+12>>2],i[k+256>>2]=i[f+8>>2],i[k+260>>2]=s,s=i[f+20>>2],i[k+264>>2]=i[f+16>>2],i[k+268>>2]=s,s=i[f+28>>2],i[k+272>>2]=i[f+24>>2],i[k+276>>2]=s,s=i[f+36>>2],i[k+280>>2]=i[f+32>>2],i[k+284>>2]=s,s=i[f+44>>2],i[k+288>>2]=i[f+40>>2],i[k+292>>2]=s,s=i[f+52>>2],i[k+296>>2]=i[f+48>>2],i[k+300>>2]=s,s=i[f+60>>2],i[k+304>>2]=i[f+56>>2],i[k+308>>2]=s;break X}if(i[s+4>>2]=i[s+4>>2]+1,k=i[Q>>2],t[k+248|0]=1,h=i[f+12>>2],i[k+256>>2]=i[f+8>>2],i[k+260>>2]=h,h=i[f+20>>2],i[k+264>>2]=i[f+16>>2],i[k+268>>2]=h,h=i[f+28>>2],i[k+272>>2]=i[f+24>>2],i[k+276>>2]=h,h=i[f+36>>2],i[k+280>>2]=i[f+32>>2],i[k+284>>2]=h,h=i[f+44>>2],i[k+288>>2]=i[f+40>>2],i[k+292>>2]=h,h=i[f+52>>2],i[k+296>>2]=i[f+48>>2],i[k+300>>2]=h,h=i[f+60>>2],i[k+304>>2]=i[f+56>>2],i[k+308>>2]=h,f=i[s+4>>2],i[s+4>>2]=f-1,f)break X;W[i[i[s>>2]+8>>2]](s),y(s)}if(r=r+8|0,(B|0)==(r|0))break}if(t[A+19|0]<0&&Z(i[A+8>>2]),f=i[n+320>>2],!f)break W;if(r=i[n+324>>2],k=f,(r|0)!=(f|0)){for(;;){k=i[r-4>>2];X:{if(!k||(s=i[k+4>>2],i[k+4>>2]=s-1,s))break X;W[i[i[k>>2]+8>>2]](k),y(k)}if(r=r-8|0,(f|0)==(r|0))break}k=i[n+320>>2]}i[n+324>>2]=f,Z(k)}if(l=l+4|0,(j|0)!=(l|0))continue;break v}break}if(r){if(s=r,k=i[n+324>>2],(k|0)!=(r|0)){for(;;){f=i[k-4>>2];Z:{if(!f||(l=i[f+4>>2],i[f+4>>2]=l-1,l))break Z;W[i[i[f>>2]+8>>2]](f),y(f)}if(k=k-8|0,(k|0)==(r|0))break}s=i[n+320>>2]}i[n+324>>2]=r,Z(s)}r=0;break _}F3(e,Q);break h}x0(),M()}I0(),M()}l=i[Q>>2],t[l+312|0]=1,r=l+316|0;v:{if((r|0)==(I|0))break v;if(f=t[G+115|0],t[l+327|0]>=0){if((f|0)>=0){f=i[I+4>>2],i[r>>2]=i[I>>2],i[r+4>>2]=f,i[r+8>>2]=i[I+8>>2];break v}m1(r,i[G+104>>2],i[G+108>>2]);break v}k=r,r=(f|0)<0,R1(k,r?i[G+104>>2]:I,r?i[G+108>>2]:f)}if(h=i[n+168>>2],G=i[n+172>>2],(h|0)==(G|0)){r=1;break w}for(;;){f=i[h>>2];v:{B:{k=Y,r=i[k>>2];m:{if(!r)break m;for(;l=f>>>0>o0[r+16>>2],k=l?k:r,r=i[(l?4:0)+r>>2],!!r;);if((k|0)==(Y|0))break m;if(f>>>0>=o0[k+16>>2])break B}if(H3(i[e+48>>2],f))break v;r=C(40),i[n+320>>2]=r,i[n+324>>2]=33,i[n+328>>2]=-2147483608,f=u[19307]|u[19308]<<8|(u[19309]<<16|u[19310]<<24),l=u[19303]|u[19304]<<8|(u[19305]<<16|u[19306]<<24),t[r|0]=l,t[r+1|0]=l>>>8,t[r+2|0]=l>>>16,t[r+3|0]=l>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+33|0]=0,t[r+32|0]=u[19335],f=u[19331]|u[19332]<<8|(u[19333]<<16|u[19334]<<24),l=u[19327]|u[19328]<<8|(u[19329]<<16|u[19330]<<24),t[r+24|0]=l,t[r+25|0]=l>>>8,t[r+26|0]=l>>>16,t[r+27|0]=l>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[19323]|u[19324]<<8|(u[19325]<<16|u[19326]<<24),l=u[19319]|u[19320]<<8|(u[19321]<<16|u[19322]<<24),t[r+16|0]=l,t[r+17|0]=l>>>8,t[r+18|0]=l>>>16,t[r+19|0]=l>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[19315]|u[19316]<<8|(u[19317]<<16|u[19318]<<24),l=u[19311]|u[19312]<<8|(u[19313]<<16|u[19314]<<24),t[r+8|0]=l,t[r+9|0]=l>>>8,t[r+10|0]=l>>>16,t[r+11|0]=l>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,2e3,n+320|0),t[n+331|0]<0&&Z(i[n+320>>2]),r=0;break _}if(r=i[Q>>2],l=i[k+20>>2],(r|0)==(l|0)){r=C(32),i[n+320>>2]=r,i[n+324>>2]=28,i[n+328>>2]=-2147483616,f=u[18185]|u[18186]<<8|(u[18187]<<16|u[18188]<<24),l=u[18181]|u[18182]<<8|(u[18183]<<16|u[18184]<<24),t[r|0]=l,t[r+1|0]=l>>>8,t[r+2|0]=l>>>16,t[r+3|0]=l>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+28|0]=0,f=u[18205]|u[18206]<<8|(u[18207]<<16|u[18208]<<24),t[r+24|0]=f,t[r+25|0]=f>>>8,t[r+26|0]=f>>>16,t[r+27|0]=f>>>24,f=u[18201]|u[18202]<<8|(u[18203]<<16|u[18204]<<24),l=u[18197]|u[18198]<<8|(u[18199]<<16|u[18200]<<24),t[r+16|0]=l,t[r+17|0]=l>>>8,t[r+18|0]=l>>>16,t[r+19|0]=l>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[18193]|u[18194]<<8|(u[18195]<<16|u[18196]<<24),l=u[18189]|u[18190]<<8|(u[18191]<<16|u[18192]<<24),t[r+8|0]=l,t[r+9|0]=l>>>8,t[r+10|0]=l>>>16,t[r+11|0]=l>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,2e3,n+320|0),t[n+331|0]<0&&Z(i[n+320>>2]),r=0;break _}i[n+88>>2]=r,r=i[o+24>>2],i[n+92>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[n+92>>2],i[n+8>>2]=i[n+88>>2],i[n+12>>2]=r;B:{if(r=i[l+332>>2],s=i[l+336>>2],r>>>0<s>>>0){i[r>>2]=i[n+8>>2],i[r+4>>2]=i[n+12>>2],i[l+332>>2]=r+8;break B}m:{if(k=i[l+328>>2],r=r-k|0,_=r>>3,f=_+1|0,f>>>0<536870912){if(s=s-k|0,B=s>>2,s=s>>>0>=2147483640?536870911:f>>>0<B>>>0?B:f,s){if(s>>>0>=536870912)break m;f=C(s<<3)}else f=0;B=f+r|0,i[B>>2]=i[n+8>>2],i[B+4>>2]=i[n+12>>2],_=B-(_<<3)|0,r&&z(_,k,r),i[l+336>>2]=f+(s<<3),r=B+8|0,i[l+332>>2]=r,i[l+328>>2]=_,k&&Z(k),i[l+332>>2]=r;break B}s0(),M()}x0(),M()}F3(e,Q)}if(h=h+4|0,(G|0)==(h|0))break}r=1}h=i[n+168>>2]}h&&(i[n+172>>2]=h,Z(h));w:{if(!U||(f=i[U+4>>2],i[U+4>>2]=f-1,f))break w;W[i[i[U>>2]+8>>2]](U),y(U)}if(r)break h;f=1;break o}if(w=w+56|0,(C0|0)==(w|0))break}f=18;break o}if(!r)break u;z(s,f,r)}t[r+s|0]=0,a(A,2,123,n+320|0),t[n+331|0]<0&&Z(i[n+320>>2]),i[n+168>>2]=_0,i[i[r0>>2]+(n+168|0)>>2]=S0,i[n+176>>2]=j0,i[l>>2]=77200,t[n+223|0]<0&&Z(i[n+212>>2]),y0(l),Y0(A2),f=1;break o}Z(f),f=1}w=i[n+392>>2]}if(w){if(r=i[n+396>>2],k=w,(r|0)!=(k|0)){for(;l=i[r-12>>2],l&&(i[r-8>>2]=l,Z(l)),l=r-56|0,i[l>>2]=92500,k=i[r-36>>2],k&&(i[r-32>>2]=k,Z(k)),r=l,(w|0)!=(r|0););k=i[n+392>>2]}i[n+396>>2]=w,Z(k)}t:{if((f|0)!=18){if((f|0)==16)break t;break n}k=o,r=i[k+4>>2];o:{if(r){for(;;)if(o=r,r=i[r>>2],!r)break o}for(;o=i[k+8>>2],r=i[o>>2]!=(k|0),k=o,!!r;);}if((o|0)!=(Y|0))continue}break}o=i[e+16>>2]}if((o|0)!=(Y|0)){for(;;){if(r=i[o+20>>2],W[i[i[r>>2]+88>>2]](n+168|0,r),r=i[n+168>>2],t[n+187|0]<0&&Z(i[n+176>>2]),!r){j1(n+392|0,i[e+48>>2],i[i[o+20>>2]+196>>2]),r=i[i[n+392>>2]+112>>2];t:{if((r|0)==1752589105){r=i[e+48>>2],i[n+320>>2]=i[r+128>>2],f=i[r+132>>2],i[n+324>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1,r=i[e+48>>2]),l=i[r+120>>2],f=i[r+124>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),To(n+168|0,l,i[i[o+20>>2]+196>>2],n+320|0,1752589123),l=i[n+168>>2],r=i[n+172>>2];o:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break o;W[i[i[r>>2]+8>>2]](r),y(r)}if(!l){r=C(40),i[n+168>>2]=r,i[n+172>>2]=35,i[n+176>>2]=-2147483608,l=u[16066]|u[16067]<<8|(u[16068]<<16|u[16069]<<24),k=u[16062]|u[16063]<<8|(u[16064]<<16|u[16065]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=l,t[r+5|0]=l>>>8,t[r+6|0]=l>>>16,t[r+7|0]=l>>>24,t[r+35|0]=0,l=u[16093]|u[16094]<<8|(u[16095]<<16|u[16096]<<24),t[r+31|0]=l,t[r+32|0]=l>>>8,t[r+33|0]=l>>>16,t[r+34|0]=l>>>24,l=u[16090]|u[16091]<<8|(u[16092]<<16|u[16093]<<24),k=u[16086]|u[16087]<<8|(u[16088]<<16|u[16089]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=l,t[r+29|0]=l>>>8,t[r+30|0]=l>>>16,t[r+31|0]=l>>>24,l=u[16082]|u[16083]<<8|(u[16084]<<16|u[16085]<<24),k=u[16078]|u[16079]<<8|(u[16080]<<16|u[16081]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=l,t[r+21|0]=l>>>8,t[r+22|0]=l>>>16,t[r+23|0]=l>>>24,l=u[16074]|u[16075]<<8|(u[16076]<<16|u[16077]<<24),k=u[16070]|u[16071]<<8|(u[16072]<<16|u[16073]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=l,t[r+13|0]=l>>>8,t[r+14|0]=l>>>16,t[r+15|0]=l>>>24,a(A,2,106,n+168|0),t[n+179|0]<0&&Z(i[n+168>>2]);o:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break o;W[i[i[f>>2]+8>>2]](f),y(f)}r=i[n+324>>2];o:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break o;W[i[i[r>>2]+8>>2]](r),y(r)}k=0;break t}o:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break o;W[i[i[f>>2]+8>>2]](f),y(f)}r=i[n+324>>2];o:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break o;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[i[n+392>>2]+112>>2]}if(k=1,(r|0)!=1987470129)break t;r=i[e+48>>2],i[n+320>>2]=i[r+128>>2],f=i[r+132>>2],i[n+324>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1,r=i[e+48>>2]),l=i[r+120>>2],f=i[r+124>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),To(n+168|0,l,i[i[o+20>>2]+196>>2],n+320|0,1987470147),l=i[n+168>>2],r=i[n+172>>2];o:{if(!r||(m=i[r+4>>2],i[r+4>>2]=m-1,m))break o;W[i[i[r>>2]+8>>2]](r),y(r)}if(!l){r=C(40),i[n+168>>2]=r,i[n+172>>2]=35,i[n+176>>2]=-2147483608,l=u[16030]|u[16031]<<8|(u[16032]<<16|u[16033]<<24),k=u[16026]|u[16027]<<8|(u[16028]<<16|u[16029]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=l,t[r+5|0]=l>>>8,t[r+6|0]=l>>>16,t[r+7|0]=l>>>24,t[r+35|0]=0,l=u[16057]|u[16058]<<8|(u[16059]<<16|u[16060]<<24),t[r+31|0]=l,t[r+32|0]=l>>>8,t[r+33|0]=l>>>16,t[r+34|0]=l>>>24,l=u[16054]|u[16055]<<8|(u[16056]<<16|u[16057]<<24),k=u[16050]|u[16051]<<8|(u[16052]<<16|u[16053]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=l,t[r+29|0]=l>>>8,t[r+30|0]=l>>>16,t[r+31|0]=l>>>24,l=u[16046]|u[16047]<<8|(u[16048]<<16|u[16049]<<24),k=u[16042]|u[16043]<<8|(u[16044]<<16|u[16045]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=l,t[r+21|0]=l>>>8,t[r+22|0]=l>>>16,t[r+23|0]=l>>>24,l=u[16038]|u[16039]<<8|(u[16040]<<16|u[16041]<<24),k=u[16034]|u[16035]<<8|(u[16036]<<16|u[16037]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=l,t[r+13|0]=l>>>8,t[r+14|0]=l>>>16,t[r+15|0]=l>>>24,a(A,2,141,n+168|0),t[n+179|0]<0&&Z(i[n+168>>2]);o:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break o;W[i[i[f>>2]+8>>2]](f),y(f)}r=i[n+324>>2];o:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break o;W[i[i[r>>2]+8>>2]](r),y(r)}k=0;break t}o:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break o;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=i[n+324>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break t;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[n+396>>2];t:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break t;W[i[i[r>>2]+8>>2]](r),y(r)}if(!k)break n}k=i[o+4>>2];t:{if(k){for(;;)if(r=k,k=i[r>>2],!k)break t}for(;r=i[o+8>>2],f=i[r>>2]!=(o|0),o=r,!!f;);}if(o=r,(r|0)==(Y|0))break}o=i[e+16>>2]}t:{if((o|0)==(Y|0))break t;for(;;){r=i[o+16>>2],f=i[o+20>>2],W[i[i[f>>2]+88>>2]](n+168|0,f),f=i[n+168>>2],t[n+187|0]<0&&Z(i[n+176>>2]);o:{if(f)break o;j1(n+392|0,i[e+48>>2],r),l=i[n+392>>2],f=l?32:33;l:{if(!E|!l)break l;if(i[l+112>>2]==1735551332){d4(n+168|0,E,r,1684630887),k=i[n+168>>2];u:{if((k|0)==i[n+172>>2]){f=33;break u}f=33,r=i[Y>>2];s:{if(!r)break s;for(l=i[k>>2],k=Y;m=l>>>0>o0[r+16>>2],k=m?k:r,r=i[(m?4:0)+r>>2],!!r;);if((k|0)==(Y|0)|l>>>0<o0[k+16>>2])break s;f=i[k+20>>2],r=i[k+24>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),k=i[o+20>>2];h:{if(i[k+16>>2]||(l=i[f+16>>2],!l))break h;i[n+320>>2]=l,l=i[f+20>>2],i[n+324>>2]=l,l&&(i[l+4>>2]=i[l+4>>2]+1),l=n+320|0,Zo(k,l),g2(l),k=i[o+20>>2]}h:{if(r8(k)||!r8(f))break h;l=i[o+20>>2],k=p[f+10>>1]|p[f+12>>1]<<16,i[n+320>>2]=p[f+6>>1]|p[f+8>>1]<<16,i[n+324>>2]=k,W[i[i[l>>2]+8>>2]](l,n+320|0)}if(f=0,!r||(l=i[r+4>>2],i[r+4>>2]=l-1,l))break s;W[i[i[r>>2]+8>>2]](r),y(r)}k=i[n+168>>2]}if(k&&(i[n+172>>2]=k,Z(k)),f)break l}f=0}r=i[n+396>>2];l:{if(!r||(l=i[r+4>>2],i[r+4>>2]=l-1,l))break l;W[i[i[r>>2]+8>>2]](r),y(r)}if((f|0)==33)break o;if(f)break t}k=i[o+4>>2];o:{if(k){for(;;)if(r=k,k=i[r>>2],!k)break o}for(;r=i[o+8>>2],f=i[r>>2]!=(o|0),o=r,!!f;);}if(o=r,(r|0)==(Y|0))break}}f=i[n+380>>2],G=i[n+384>>2];t:{if((f|0)==(G|0))break t;for(B=A+8|0,l=i[25168],I=i[25169];;){w=i[f>>2],r=X8(i[e+48>>2],w),k=n+392|0,h=0;o:{l:{o=i[e+48>>2],s=i[o+140>>2];u:{if(!s)break u;for(o=o+140|0,m=o;_=w>>>0>o0[s+16>>2],m=_?m:s,s=i[(_?4:0)+s>>2],!!s;);if((o|0)==(m|0)|w>>>0<o0[m+16>>2])break u;if(o=i[m+20>>2],h=i[m+24>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),o)break l}t[k|0]=0,t[k+11|0]=0;break o}if(t[o+139|0]>=0){m=i[o+132>>2],i[k>>2]=i[o+128>>2],i[k+4>>2]=m,i[k+8>>2]=i[o+136>>2];break o}T(k,i[o+128>>2],i[o+132>>2])}o:{if(!h||(o=i[h+4>>2],i[h+4>>2]=o-1,o))break o;W[i[i[h>>2]+8>>2]](h),y(h)}o:{l:{if((r|0)<=1785750886){if((r|0)<=1752589104){if(o=35,(r|0)==1635135537|(r|0)==1635148593)break o;if((r|0)!=1735551332)break l;break o}if((r|0)<=1768912491){if(o=35,(r|0)==1752589105)break o;if((r|0)!=1768187246)break l;break o}if(o=35,(r|0)==1768912492)break o;if((r|0)!=1781689137)break l;break o}u:{if((r|0)<=1919377773){if(o=35,(r|0)==1785750887)break o;if((r|0)==1835625829)break u;if((r|0)!=1836280681)break l;break o}if((r|0)<=1970168680){if(o=35,(r|0)==1919377774)break o;if((r|0)!=1953066089)break l;break o}if(o=35,(r|0)==1970168681)break o;if((r|0)!=1987470129)break l;break o}if(m=t[n+403|0],k=(m|0)<0,((k?i[n+396>>2]:m)|0)!=10)break l;if(!N2(k?i[n+392>>2]:n+392|0,12325,10))break o}k=n+320|0,h=0;l:{u:{o=i[e+48>>2],s=i[o+140>>2];s:{if(!s)break s;for(o=o+140|0,m=o;_=w>>>0>o0[s+16>>2],m=_?m:s,s=i[(_?4:0)+s>>2],!!s;);if((o|0)==(m|0)|w>>>0<o0[m+16>>2])break s;if(o=i[m+20>>2],h=i[m+24>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),o)break u}t[k|0]=0,t[k+11|0]=0;break l}if(t[o+163|0]>=0){m=i[o+156>>2],i[k>>2]=i[o+152>>2],i[k+4>>2]=m,i[k+8>>2]=i[o+160>>2];break l}T(k,i[o+152>>2],i[o+156>>2])}l:{if(!h||(o=i[h+4>>2],i[h+4>>2]=o-1,o))break l;W[i[i[h>>2]+8>>2]](h),y(h)}k=C(64),i[k+16>>2]=0,i[k+20>>2]=0,i[k>>2]=101080,i[k+4>>2]=0,i[k+8>>2]=0,i[k+12>>2]=w,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,z1(n+168|0,r),t[k+27|0]<0&&Z(i[k+16>>2]),o=i[n+172>>2],i[k+16>>2]=i[n+168>>2],i[k+20>>2]=o,i[k+24>>2]=i[n+176>>2],o=k+28|0,m=t[n+403|0];l:{if(t[k+39|0]>=0){if((m|0)>=0){m=i[n+396>>2],i[o>>2]=i[n+392>>2],i[o+4>>2]=m,i[o+8>>2]=i[n+400>>2];break l}m1(o,i[n+392>>2],i[n+396>>2]);break l}h=o,o=(m|0)<0,R1(h,o?i[n+392>>2]:n+392|0,o?i[n+396>>2]:m)}t[k+51|0]<0&&Z(i[k+40>>2]),o=i[n+324>>2],i[k+40>>2]=i[n+320>>2],i[k+44>>2]=o,i[k+48>>2]=i[n+328>>2],t[n+331|0]=0,t[n+320|0]=0,W6(n+168|0,i[e+48>>2],w),s=u[n+188|0];l:{u:{if(s){if((r|0)!=1835625829&&(o=35,(r|0)!=1165519206))break l;if((s|0)!=1)break A;if(r=i[n+172>>2],i[A>>2]=i[n+168>>2],i[A+4>>2]=r,t[n+187|0]>=0){r=i[n+180>>2],i[B>>2]=i[n+176>>2],i[B+4>>2]=r,i[B+8>>2]=i[n+184>>2],o=1;break u}T(B,i[n+176>>2],i[n+180>>2]),o=1;break u}if(r=i[n+168>>2],o=i[n+172>>2],$4(k+52|0,r,o,o-r|0),E){d4(n+344|0,E,w,1667527523),h=i[n+344>>2],Q=i[n+348>>2];s:{if((h|0)!=(Q|0)){U=k+12|0;h:{for(;;){m=i[h>>2];w:{_:{o=Y,r=i[o>>2];v:{if(!r)break v;for(;w=m>>>0>o0[r+16>>2],o=w?o:r,r=i[(w?4:0)+r>>2],!!r;);if((o|0)==(Y|0))break v;if(m>>>0>=o0[o+16>>2])break _}if(H3(i[e+48>>2],m))break w;r=C(40),i[n+76>>2]=r,i[n+80>>2]=39,i[n+84>>2]=-2147483608,o=u[15948]|u[15949]<<8|(u[15950]<<16|u[15951]<<24),m=u[15944]|u[15945]<<8|(u[15946]<<16|u[15947]<<24),t[r|0]=m,t[r+1|0]=m>>>8,t[r+2|0]=m>>>16,t[r+3|0]=m>>>24,t[r+4|0]=o,t[r+5|0]=o>>>8,t[r+6|0]=o>>>16,t[r+7|0]=o>>>24,t[r+39|0]=0,o=u[15979]|u[15980]<<8|(u[15981]<<16|u[15982]<<24),m=u[15975]|u[15976]<<8|(u[15977]<<16|u[15978]<<24),t[r+31|0]=m,t[r+32|0]=m>>>8,t[r+33|0]=m>>>16,t[r+34|0]=m>>>24,t[r+35|0]=o,t[r+36|0]=o>>>8,t[r+37|0]=o>>>16,t[r+38|0]=o>>>24,o=u[15972]|u[15973]<<8|(u[15974]<<16|u[15975]<<24),m=u[15968]|u[15969]<<8|(u[15970]<<16|u[15971]<<24),t[r+24|0]=m,t[r+25|0]=m>>>8,t[r+26|0]=m>>>16,t[r+27|0]=m>>>24,t[r+28|0]=o,t[r+29|0]=o>>>8,t[r+30|0]=o>>>16,t[r+31|0]=o>>>24,o=u[15964]|u[15965]<<8|(u[15966]<<16|u[15967]<<24),m=u[15960]|u[15961]<<8|(u[15962]<<16|u[15963]<<24),t[r+16|0]=m,t[r+17|0]=m>>>8,t[r+18|0]=m>>>16,t[r+19|0]=m>>>24,t[r+20|0]=o,t[r+21|0]=o>>>8,t[r+22|0]=o>>>16,t[r+23|0]=o>>>24,o=u[15956]|u[15957]<<8|(u[15958]<<16|u[15959]<<24),m=u[15952]|u[15953]<<8|(u[15954]<<16|u[15955]<<24),t[r+8|0]=m,t[r+9|0]=m>>>8,t[r+10|0]=m>>>16,t[r+11|0]=m>>>24,t[r+12|0]=o,t[r+13|0]=o>>>8,t[r+14|0]=o>>>16,t[r+15|0]=o>>>24,a(A,2,2e3,n+76|0),t[n+87|0]<0&&Z(i[n+76>>2]),r=0;break h}m=i[o+20>>2],i[n+72>>2]=k,i[n+68>>2]=U,i[k+4>>2]=i[k+4>>2]+1,r=i[n+72>>2],i[n>>2]=i[n+68>>2],i[n+4>>2]=r;_:{if(r=i[m+344>>2],s=i[m+348>>2],r>>>0<s>>>0){i[r>>2]=i[n>>2],i[r+4>>2]=i[n+4>>2],i[m+344>>2]=r+8;break _}v:{if(w=i[m+340>>2],r=r-w|0,V=r>>3,o=V+1|0,o>>>0<536870912){if(s=s-w|0,_=s>>2,s=s>>>0>=2147483640?536870911:o>>>0<_>>>0?_:o,s){if(s>>>0>=536870912)break v;o=C(s<<3)}else o=0;_=o+r|0,i[_>>2]=i[n>>2],i[_+4>>2]=i[n+4>>2],V=_-(V<<3)|0,r&&z(V,w,r),i[m+348>>2]=o+(s<<3),r=_+8|0,i[m+344>>2]=r,i[m+340>>2]=V,w&&Z(w),i[m+344>>2]=r;break _}s0(),M()}x0(),M()}}if(h=h+4|0,(Q|0)==(h|0))break}r=1}h=i[n+344>>2];break s}r=1}if(h&&(i[n+348>>2]=h,Z(h)),o=1,!r)break u}o=0}s=u[n+188|0]}if(r=s&255,(r|0)!=255&&(i[n+344>>2]=l,i[n+348>>2]=I,W[i[(n+344|0)+(r<<2)>>2]](n+76|0,n+168|0)),r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),t[n+331|0]>=0)break o;Z(i[n+320>>2])}if(t[n+403|0]<0&&Z(i[n+392>>2]),o&&(o|0)!=35)break n;if(f=f+4|0,(G|0)==(f|0))break}if(w=i[n+380>>2],V=i[n+384>>2],!(!E|(w|0)==(V|0))){for(;;){k=i[w>>2],d4(n+168|0,E,k,1886545261),m=i[n+168>>2],s=i[n+172>>2];o:{if((m|0)==(s|0)){r=1;break o}f=m;l:{if(l=i[Y>>2],!l)break l;for(;;){for(o=Y,r=l;B=k>>>0>o0[r+16>>2],o=B?o:r,r=i[(B?4:0)+r>>2],!!r;);if((o|0)==(Y|0)|k>>>0<o0[o+16>>2])break l;if(r=1,t[i[o+20>>2]+225|0]=1,f=f+4|0,(s|0)==(f|0))break}break o}r=C(48),i[n+392>>2]=r,i[n+396>>2]=42,i[n+400>>2]=-2147483600,f=u[15905]|u[15906]<<8|(u[15907]<<16|u[15908]<<24),o=u[15901]|u[15902]<<8|(u[15903]<<16|u[15904]<<24),t[r|0]=o,t[r+1|0]=o>>>8,t[r+2|0]=o>>>16,t[r+3|0]=o>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+42|0]=0,f=u[15941]|u[15942]<<8,t[r+40|0]=f,t[r+41|0]=f>>>8,f=u[15937]|u[15938]<<8|(u[15939]<<16|u[15940]<<24),o=u[15933]|u[15934]<<8|(u[15935]<<16|u[15936]<<24),t[r+32|0]=o,t[r+33|0]=o>>>8,t[r+34|0]=o>>>16,t[r+35|0]=o>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[15929]|u[15930]<<8|(u[15931]<<16|u[15932]<<24),o=u[15925]|u[15926]<<8|(u[15927]<<16|u[15928]<<24),t[r+24|0]=o,t[r+25|0]=o>>>8,t[r+26|0]=o>>>16,t[r+27|0]=o>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[15921]|u[15922]<<8|(u[15923]<<16|u[15924]<<24),o=u[15917]|u[15918]<<8|(u[15919]<<16|u[15920]<<24),t[r+16|0]=o,t[r+17|0]=o>>>8,t[r+18|0]=o>>>16,t[r+19|0]=o>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[15913]|u[15914]<<8|(u[15915]<<16|u[15916]<<24),o=u[15909]|u[15910]<<8|(u[15911]<<16|u[15912]<<24),t[r+8|0]=o,t[r+9|0]=o>>>8,t[r+10|0]=o>>>16,t[r+11|0]=o>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,2e3,n+392|0),t[n+403|0]<0&&Z(i[n+392>>2]),r=0,m=i[n+168>>2]}if(m&&(i[n+172>>2]=m,Z(m)),!r)break n;if(w=w+4|0,(V|0)==(w|0))break}V=i[n+384>>2],w=i[n+380>>2]}if((w|0)!=(V|0)){for(U=e+172|0,j=e- -64|0,G=A+8|0,B=i[25168],S=i[25169];;){o:{I=i[w>>2];l:{if((X8(i[e+48>>2],I)|0)!=1919377774)break l;r=C(36),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100776,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[n+80>>2]=r,i[n+76>>2]=r+12,i[r+12>>2]=I,W6(n+168|0,i[e+48>>2],I);u:{s:switch(u[n+188|0]){case 1:if(r=i[n+172>>2],i[A>>2]=i[n+168>>2],i[A+4>>2]=r,t[n+187|0]>=0){r=i[n+180>>2],i[G>>2]=i[n+176>>2],i[G+4>>2]=r,i[G+8>>2]=i[n+184>>2],s=1;break u}T(G,i[n+176>>2],i[n+180>>2]),s=1;break u;case 0:break s;default:break A}l=n+48|0,f=i[n+76>>2],o=v-16|0,v=o,m=n+168|0,r=i[m>>2],k=i[m+4>>2]-r|0;s:{if(k>>>0<=7){if(r=C(32),i[o+4>>2]=r,i[o+8>>2]=25,i[o+12>>2]=-2147483616,f=u[20535]|u[20536]<<8|(u[20537]<<16|u[20538]<<24),k=u[20531]|u[20532]<<8|(u[20533]<<16|u[20534]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+25|0]=0,t[r+24|0]=u[20555],f=u[20551]|u[20552]<<8|(u[20553]<<16|u[20554]<<24),k=u[20547]|u[20548]<<8|(u[20549]<<16|u[20550]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[20543]|u[20544]<<8|(u[20545]<<16|u[20546]<<24),k=u[20539]|u[20540]<<8|(u[20541]<<16|u[20542]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(l,2,136,o+4|0),t[o+15|0]>=0)break s;Z(i[o+4>>2]);break s}_=t[r+1|0]&1;h:{if(_){if(k>>>0<=11){if(r=C(24),i[o+4>>2]=r,i[o+8>>2]=22,i[o+12>>2]=-2147483624,f=u[13255]|u[13256]<<8|(u[13257]<<16|u[13258]<<24),k=u[13251]|u[13252]<<8|(u[13253]<<16|u[13254]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+22|0]=0,f=u[13269]|u[13270]<<8|(u[13271]<<16|u[13272]<<24),k=u[13265]|u[13266]<<8|(u[13267]<<16|u[13268]<<24),t[r+14|0]=k,t[r+15|0]=k>>>8,t[r+16|0]=k>>>16,t[r+17|0]=k>>>24,t[r+18|0]=f,t[r+19|0]=f>>>8,t[r+20|0]=f>>>16,t[r+21|0]=f>>>24,f=u[13263]|u[13264]<<8|(u[13265]<<16|u[13266]<<24),k=u[13259]|u[13260]<<8|(u[13261]<<16|u[13262]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(l,2,136,o+4|0),t[o+15|0]>=0)break s;Z(i[o+4>>2]);break s}k=u[r+2|0]|u[r+3|0]<<8|(u[r+4|0]<<16|u[r+5|0]<<24),i[f+4>>2]=k<<24|(k&65280)<<8|(k>>>8&65280|k>>>24),s=u[r+7|0]<<16|u[r+6|0]<<24|u[r+8|0]<<8,h=10,k=r+9|0;break h}i[f+4>>2]=u[r+3|0]|u[r+2|0]<<8,s=u[r+4|0]<<8,h=6,k=r+5|0}if(i[f+8>>2]=u[k|0]|s,k=u[r+h|0],i[o>>2]=h|1,k)for(s=_?32:16,h=f+12|0,f=0;;){if(r=i[o>>2],_=i[m>>2],r>>>0>=i[m+4>>2]-_>>>0){if(r=C(24),i[o+4>>2]=r,i[o+8>>2]=22,i[o+12>>2]=-2147483624,f=u[13255]|u[13256]<<8|(u[13257]<<16|u[13258]<<24),k=u[13251]|u[13252]<<8|(u[13253]<<16|u[13254]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+22|0]=0,f=u[13269]|u[13270]<<8|(u[13271]<<16|u[13272]<<24),k=u[13265]|u[13266]<<8|(u[13267]<<16|u[13268]<<24),t[r+14|0]=k,t[r+15|0]=k>>>8,t[r+16|0]=k>>>16,t[r+17|0]=k>>>24,t[r+18|0]=f,t[r+19|0]=f>>>8,t[r+20|0]=f>>>16,t[r+21|0]=f>>>24,f=u[13263]|u[13264]<<8|(u[13265]<<16|u[13266]<<24),k=u[13259]|u[13260]<<8|(u[13261]<<16|u[13262]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(l,2,136,o+4|0),t[o+15|0]>=0)break s;Z(i[o+4>>2]);break s}_=u[r+_|0],i[o>>2]=r+1;h:{w:{_:switch(_|0){case 0:r=C(24),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=102468,i[r+12>>2]=102204,i[o+8>>2]=r,i[o+4>>2]=r+12;break w;case 1:r=C(32),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=102508,i[r+24>>2]=0,i[r+28>>2]=0,i[r+12>>2]=102248,i[o+8>>2]=r,i[o+4>>2]=r+12;break w;case 2:r=C(32),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=102548,i[r+24>>2]=0,i[r+28>>2]=0,i[r+12>>2]=102292,i[o+8>>2]=r,i[o+4>>2]=r+12;break w;case 3:if(r=C(40),i[r+16>>2]=1,i[r+20>>2]=0,i[r+24>>2]=0,i[r+4>>2]=1,i[r+8>>2]=0,i[r>>2]=102588,i[r+12>>2]=102380,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[o+8>>2]=r,i[o+4>>2]=r+12,_=i[r+4>>2],i[r+4>>2]=_-1,_)break w;W[i[i[r>>2]+8>>2]](r),y(r);break w;case 4:r=C(36),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=102628,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+12>>2]=102336,i[o+8>>2]=r,i[o+4>>2]=r+12;break w;case 5:r=C(52),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r>>2]=102668,i[r+24>>2]=0,i[r+28>>2]=0,i[r+12>>2]=102424,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[o+8>>2]=r,i[o+4>>2]=r+12;break w;case 6:break _;default:break h}if(r=C(40),i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+4>>2]=1,i[r+8>>2]=0,i[r>>2]=102588,i[r+12>>2]=102380,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[o+8>>2]=r,i[o+4>>2]=r+12,_=i[r+4>>2],i[r+4>>2]=_-1,_)break w;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[o+4>>2],W[i[i[r>>2]+12>>2]](l,r,m,s,o,j),_=i[l>>2];w:{if(_||(P0(h,o+4|0),t[l+19|0]>=0))break w;Z(i[l+8>>2])}r=i[o+8>>2];w:{if(!r||(Q=i[r+4>>2],i[r+4>>2]=Q-1,Q))break w;W[i[i[r>>2]+8>>2]](r),y(r)}if(_)break s}if(f=f+1|0,(k|0)==(f|0))break}if(r=i[28729],i[l>>2]=i[28728],i[l+4>>2]=r,r=l+8|0,t[114931]>=0){f=i[28731],i[r>>2]=i[28730],i[r+4>>2]=f,i[r+8>>2]=i[28732];break s}T(r,i[28730],i[28731])}if(v=o+16|0,t[n+67|0]<0&&Z(i[n+56>>2]),E){j3(n+320|0,E,I),l=i[n+320>>2],c=i[n+324>>2];s:{if((l|0)==(c|0)){s=44;break s}h:{for(;;){if(r=i[l+16>>2],(r|0)==1667527523){if(i[n+400>>2]=0,i[n+392>>2]=0,i[n+396>>2]=0,r=i[l+48>>2],f=i[l+44>>2],(r|0)!=(f|0)){if(r=r-f|0,(r|0)<0)break i;for(k=C(r),r&&z(k,f,r),s=r+k|0,f=k;;){w:{r=i[Y>>2];_:{if(!r)break _;for(m=i[f>>2],o=Y;h=m>>>0>o0[r+16>>2],o=h?o:r,r=i[(h?4:0)+r>>2],!!r;);if((o|0)==(Y|0))break _;if(m>>>0>=o0[o+16>>2])break w}r=C(48),i[n+344>>2]=r,i[n+348>>2]=42,i[n+352>>2]=-2147483600,f=u[15862]|u[15863]<<8|(u[15864]<<16|u[15865]<<24),o=u[15858]|u[15859]<<8|(u[15860]<<16|u[15861]<<24),t[r|0]=o,t[r+1|0]=o>>>8,t[r+2|0]=o>>>16,t[r+3|0]=o>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+42|0]=0,f=u[15898]|u[15899]<<8,t[r+40|0]=f,t[r+41|0]=f>>>8,f=u[15894]|u[15895]<<8|(u[15896]<<16|u[15897]<<24),o=u[15890]|u[15891]<<8|(u[15892]<<16|u[15893]<<24),t[r+32|0]=o,t[r+33|0]=o>>>8,t[r+34|0]=o>>>16,t[r+35|0]=o>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[15886]|u[15887]<<8|(u[15888]<<16|u[15889]<<24),o=u[15882]|u[15883]<<8|(u[15884]<<16|u[15885]<<24),t[r+24|0]=o,t[r+25|0]=o>>>8,t[r+26|0]=o>>>16,t[r+27|0]=o>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[15878]|u[15879]<<8|(u[15880]<<16|u[15881]<<24),o=u[15874]|u[15875]<<8|(u[15876]<<16|u[15877]<<24),t[r+16|0]=o,t[r+17|0]=o>>>8,t[r+18|0]=o>>>16,t[r+19|0]=o>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[15870]|u[15871]<<8|(u[15872]<<16|u[15873]<<24),o=u[15866]|u[15867]<<8|(u[15868]<<16|u[15869]<<24),t[r+8|0]=o,t[r+9|0]=o>>>8,t[r+10|0]=o>>>16,t[r+11|0]=o>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,2e3,n+344|0),t[n+355|0]<0&&Z(i[n+344>>2]),Z(k),s=1;break h}if(sl(i[o+20>>2],I),P0(U,n+76|0),f=f+4|0,(s|0)==(f|0))break}Z(k)}r=i[l+16>>2]}if((r|0)==1835103083){if(m=0,i[n+352>>2]=0,i[n+344>>2]=0,i[n+348>>2]=0,r=0,f=i[l+48>>2],o=i[l+44>>2],(f|0)!=(o|0)){if(f=f-o|0,(f|0)<0)break i;r=C(f),i[n+344>>2]=r,k=r+f|0,i[n+352>>2]=k,f&&z(r,o,f),i[n+348>>2]=k}Q=0,o=i[n+76>>2],f=i[o+16>>2],o=i[o+12>>2],k=f-o|0;w:{if((k|0)<=0){s=48;break w}_:{for(;;){if(i[n+400>>2]=0,i[n+392>>2]=0,i[n+396>>2]=0,r=0,s=0,(f|0)!=(o|0)){if((k|0)<0)break i;for(s=C(k),i[n+392>>2]=s,i[n+400>>2]=k+s,r=s;i[r>>2]=i[o>>2],k=i[o+4>>2],i[r+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+8|0,o=o+8|0,(f|0)!=(o|0););i[n+396>>2]=r}if(O=m<<3,f=i[O+s>>2],k=W[i[i[f>>2]+8>>2]](f)|0,o=s,(o|0)!=(r|0)){for(;;){f=i[r-4>>2];v:{if(!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break v;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=r-8|0,(s|0)==(r|0))break}o=i[n+392>>2]}i[n+396>>2]=s,Z(o);v:{if((k|0)!=4)break v;if(h=0,i[n+400>>2]=0,i[n+392>>2]=0,i[n+396>>2]=0,r=0,s=0,o=i[n+76>>2],f=i[o+16>>2],o=i[o+12>>2],(f|0)!=(o|0)){if(r=f-o|0,(r|0)<0)break i;for(s=C(r),i[n+392>>2]=s,i[n+400>>2]=r+s,r=s;i[r>>2]=i[o>>2],k=i[o+4>>2],i[r+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+8|0,o=o+8|0,(f|0)!=(o|0););i[n+396>>2]=r}_=0,f=s+O|0,o=i[f>>2];B:{if(!o)break B;if(_=Z0(o,101112,102360),!_){_=0;break B}if(h=i[f+4>>2],!h){h=0;break B}i[h+4>>2]=i[h+4>>2]+1}if(o=s,(o|0)!=(r|0)){for(;;){f=i[r-4>>2];B:{if(!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break B;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=r-8|0,(s|0)==(r|0))break}o=i[n+392>>2]}i[n+396>>2]=s,Z(o),r=i[n+344>>2];B:{if(i[n+348>>2]-r>>2>>>0<=Q>>>0){r=C(64),i[n+392>>2]=r,i[n+396>>2]=60,i[n+400>>2]=-2147483584,f=u[16871]|u[16872]<<8|(u[16873]<<16|u[16874]<<24),o=u[16867]|u[16868]<<8|(u[16869]<<16|u[16870]<<24),t[r|0]=o,t[r+1|0]=o>>>8,t[r+2|0]=o>>>16,t[r+3|0]=o>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+60|0]=0,f=u[16923]|u[16924]<<8|(u[16925]<<16|u[16926]<<24),t[r+56|0]=f,t[r+57|0]=f>>>8,t[r+58|0]=f>>>16,t[r+59|0]=f>>>24,f=u[16919]|u[16920]<<8|(u[16921]<<16|u[16922]<<24),o=u[16915]|u[16916]<<8|(u[16917]<<16|u[16918]<<24),t[r+48|0]=o,t[r+49|0]=o>>>8,t[r+50|0]=o>>>16,t[r+51|0]=o>>>24,t[r+52|0]=f,t[r+53|0]=f>>>8,t[r+54|0]=f>>>16,t[r+55|0]=f>>>24,f=u[16911]|u[16912]<<8|(u[16913]<<16|u[16914]<<24),o=u[16907]|u[16908]<<8|(u[16909]<<16|u[16910]<<24),t[r+40|0]=o,t[r+41|0]=o>>>8,t[r+42|0]=o>>>16,t[r+43|0]=o>>>24,t[r+44|0]=f,t[r+45|0]=f>>>8,t[r+46|0]=f>>>16,t[r+47|0]=f>>>24,f=u[16903]|u[16904]<<8|(u[16905]<<16|u[16906]<<24),o=u[16899]|u[16900]<<8|(u[16901]<<16|u[16902]<<24),t[r+32|0]=o,t[r+33|0]=o>>>8,t[r+34|0]=o>>>16,t[r+35|0]=o>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[16895]|u[16896]<<8|(u[16897]<<16|u[16898]<<24),o=u[16891]|u[16892]<<8|(u[16893]<<16|u[16894]<<24),t[r+24|0]=o,t[r+25|0]=o>>>8,t[r+26|0]=o>>>16,t[r+27|0]=o>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[16887]|u[16888]<<8|(u[16889]<<16|u[16890]<<24),o=u[16883]|u[16884]<<8|(u[16885]<<16|u[16886]<<24),t[r+16|0]=o,t[r+17|0]=o>>>8,t[r+18|0]=o>>>16,t[r+19|0]=o>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[16879]|u[16880]<<8|(u[16881]<<16|u[16882]<<24),o=u[16875]|u[16876]<<8|(u[16877]<<16|u[16878]<<24),t[r+8|0]=o,t[r+9|0]=o>>>8,t[r+10|0]=o>>>16,t[r+11|0]=o>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,0,n+392|0),t[n+403|0]<0&&Z(i[n+392>>2]),r=0;break B}m:{f=i[Y>>2];g:{if(!f)break g;for(k=i[r+(Q<<2)>>2],o=Y,r=f;s=k>>>0>o0[r+16>>2],o=s?o:r,r=i[(s?4:0)+r>>2],!!r;);if((o|0)==(Y|0))break g;if(k>>>0>=o0[o+16>>2])break m}r=C(48),i[n+392>>2]=r,i[n+396>>2]=43,i[n+400>>2]=-2147483600,f=u[15669]|u[15670]<<8|(u[15671]<<16|u[15672]<<24),o=u[15665]|u[15666]<<8|(u[15667]<<16|u[15668]<<24),t[r|0]=o,t[r+1|0]=o>>>8,t[r+2|0]=o>>>16,t[r+3|0]=o>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+43|0]=0,f=u[15704]|u[15705]<<8|(u[15706]<<16|u[15707]<<24),t[r+39|0]=f,t[r+40|0]=f>>>8,t[r+41|0]=f>>>16,t[r+42|0]=f>>>24,f=u[15701]|u[15702]<<8|(u[15703]<<16|u[15704]<<24),o=u[15697]|u[15698]<<8|(u[15699]<<16|u[15700]<<24),t[r+32|0]=o,t[r+33|0]=o>>>8,t[r+34|0]=o>>>16,t[r+35|0]=o>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[15693]|u[15694]<<8|(u[15695]<<16|u[15696]<<24),o=u[15689]|u[15690]<<8|(u[15691]<<16|u[15692]<<24),t[r+24|0]=o,t[r+25|0]=o>>>8,t[r+26|0]=o>>>16,t[r+27|0]=o>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[15685]|u[15686]<<8|(u[15687]<<16|u[15688]<<24),o=u[15681]|u[15682]<<8|(u[15683]<<16|u[15684]<<24),t[r+16|0]=o,t[r+17|0]=o>>>8,t[r+18|0]=o>>>16,t[r+19|0]=o>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[15677]|u[15678]<<8|(u[15679]<<16|u[15680]<<24),o=u[15673]|u[15674]<<8|(u[15675]<<16|u[15676]<<24),t[r+8|0]=o,t[r+9|0]=o>>>8,t[r+10|0]=o>>>16,t[r+11|0]=o>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,0,n+392|0),t[n+403|0]<0&&Z(i[n+392>>2]),r=0;break B}for(r=Y;o=k>>>0>o0[f+16>>2],r=o?r:f,f=i[(o?4:0)+f>>2],!!f;);m:{if(!((r|0)!=(Y|0)&k>>>0>=o0[r+16>>2])){i[n+392>>2]=0,i[n+396>>2]=0,r=0,o=0;break m}if(f=i[r+20>>2],W[i[i[f>>2]+88>>2]](n+392|0,f),t[n+411|0]<0&&Z(i[n+400>>2]),o=i[r+20>>2],i[n+392>>2]=o,r=i[r+24>>2],i[n+396>>2]=r,!r){r=0;break m}i[r+4>>2]=i[r+4>>2]+1}W[i[i[o>>2]+88>>2]](A,o),f=i[A>>2],f||(t[A+19|0]<0&&Z(i[A+8>>2]),i[_+20>>2]=k,i[_+12>>2]||(Z2=_,X2=$e(o),i[Z2+12>>2]=X2),i[_+16>>2]||(Z2=_,X2=Ke(o),i[Z2+16>>2]=X2),F3(e,n+392|0),Q=Q+1|0);m:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break m;W[i[i[r>>2]+8>>2]](r),y(r)}r=!f}B:{if(!h||(f=i[h+4>>2],i[h+4>>2]=f-1,f))break B;W[i[i[h>>2]+8>>2]](h),y(h)}if(r)break v;s=1,m=1;break _}if(m=m+1|0,r=i[n+76>>2],f=i[r+16>>2],o=i[r+12>>2],k=f-o|0,!((m|0)<k>>3))break}s=48,m=0}r=i[n+344>>2]}if(r&&(i[n+348>>2]=r,Z(r)),m)break h}if(l=l+56|0,(c|0)==(l|0))break}s=44}l=i[n+320>>2]}if(l){if(r=i[n+324>>2],o=l,(r|0)!=(o|0)){for(;f=i[r-12>>2],f&&(i[r-8>>2]=f,Z(f)),f=r-56|0,i[f>>2]=92500,o=i[r-36>>2],o&&(i[r-32>>2]=o,Z(o)),r=f,(l|0)!=(r|0););o=i[n+320>>2]}i[n+324>>2]=l,Z(o)}if((s|0)!=44)break u}s=0}r=u[n+188|0],(r|0)!=255&&(i[n+392>>2]=B,i[n+396>>2]=S,W[i[(n+392|0)+(r<<2)>>2]](n+320|0,n+168|0)),r=i[n+80>>2];u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;W[i[i[r>>2]+8>>2]](r),y(r)}u:switch(s-42|0){case 1:break l;case 0:break o;default:break u}if(s)break n}if(w=w+4|0,(V|0)!=(w|0))continue}break}V=i[n+384>>2],w=i[n+380>>2]}if((w|0)==(V|0))break t;for(_=e+184|0,B=A+8|0,k=i[25168],G=i[25169];;){s=i[w>>2];o:{if((X8(i[e+48>>2],s)|0)!=1835625829)break o;r=C(28),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101128,i[r+24>>2]=0,i[n+80>>2]=r,i[n+76>>2]=r+12,i[r+12>>2]=s,W6(n+168|0,i[e+48>>2],s);l:{u:switch(u[n+188|0]){case 1:if(r=i[n+172>>2],i[A>>2]=i[n+168>>2],i[A+4>>2]=r,t[n+187|0]>=0){r=i[n+180>>2],i[B>>2]=i[n+176>>2],i[B+4>>2]=r,i[B+8>>2]=i[n+184>>2],s=1;break l}T(B,i[n+176>>2],i[n+180>>2]),s=1;break l;case 0:break u;default:break A}r=i[n+168>>2],P8(i[n+76>>2]+4|0,r,i[n+172>>2]-r|0),f=i[28729],r=n+28|0,i[r>>2]=i[28728],i[r+4>>2]=f,r=r+8|0;u:{if(t[114931]>=0){f=i[28731],i[r>>2]=i[28730],i[r+4>>2]=f,i[r+8>>2]=i[28732];break u}T(r,i[28730],i[28731])}if(t[n+47|0]<0&&Z(i[n+36>>2]),E){j3(n+392|0,E,s),f=i[n+392>>2],I=i[n+396>>2];u:{if((f|0)==(I|0)){s=53;break u}s:{for(;;){h:{if(i[f+16>>2]!=1952807028||(i[n+328>>2]=0,i[n+320>>2]=0,i[n+324>>2]=0,r=i[f+48>>2],o=i[f+44>>2],(r|0)==(o|0)))break h;if(r=r-o|0,(r|0)<0)break i;for(l=C(r),r&&z(l,o,r),Q=r+l|0,m=l;;){w:{r=i[Y>>2];_:{if(!r)break _;for(h=i[m>>2],o=Y;U=h>>>0>o0[r+16>>2],o=U?o:r,r=i[(U?4:0)+r>>2],!!r;);if((o|0)==(Y|0))break _;if(h>>>0>=o0[o+16>>2])break w}r=C(48),i[n+344>>2]=r,i[n+348>>2]=40,i[n+352>>2]=-2147483600,f=u[15821]|u[15822]<<8|(u[15823]<<16|u[15824]<<24),o=u[15817]|u[15818]<<8|(u[15819]<<16|u[15820]<<24),t[r|0]=o,t[r+1|0]=o>>>8,t[r+2|0]=o>>>16,t[r+3|0]=o>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+40|0]=0,f=u[15853]|u[15854]<<8|(u[15855]<<16|u[15856]<<24),o=u[15849]|u[15850]<<8|(u[15851]<<16|u[15852]<<24),t[r+32|0]=o,t[r+33|0]=o>>>8,t[r+34|0]=o>>>16,t[r+35|0]=o>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[15845]|u[15846]<<8|(u[15847]<<16|u[15848]<<24),o=u[15841]|u[15842]<<8|(u[15843]<<16|u[15844]<<24),t[r+24|0]=o,t[r+25|0]=o>>>8,t[r+26|0]=o>>>16,t[r+27|0]=o>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[15837]|u[15838]<<8|(u[15839]<<16|u[15840]<<24),o=u[15833]|u[15834]<<8|(u[15835]<<16|u[15836]<<24),t[r+16|0]=o,t[r+17|0]=o>>>8,t[r+18|0]=o>>>16,t[r+19|0]=o>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[15829]|u[15830]<<8|(u[15831]<<16|u[15832]<<24),o=u[15825]|u[15826]<<8|(u[15827]<<16|u[15828]<<24),t[r+8|0]=o,t[r+9|0]=o>>>8,t[r+10|0]=o>>>16,t[r+11|0]=o>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,2,2e3,n+344|0),t[n+355|0]<0&&Z(i[n+344>>2]),Z(l),s=1;break s}if(hl(i[o+20>>2],s),P0(_,n+76|0),m=m+4|0,(Q|0)==(m|0))break}Z(l)}if(f=f+56|0,(I|0)==(f|0))break}s=53}f=i[n+392>>2]}if(f){if(r=i[n+396>>2],o=f,(r|0)!=(f|0)){for(;o=i[r-12>>2],o&&(i[r-8>>2]=o,Z(o)),o=r-56|0,i[o>>2]=92500,l=i[r-36>>2],l&&(i[r-32>>2]=l,Z(l)),r=o,(f|0)!=(r|0););o=i[n+392>>2]}i[n+396>>2]=f,Z(o)}if((s|0)!=53)break l}s=0}r=u[n+188|0],(r|0)!=255&&(i[n+392>>2]=k,i[n+396>>2]=G,W[i[(n+392|0)+(r<<2)>>2]](n+320|0,n+168|0)),r=i[n+80>>2];l:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break l;W[i[i[r>>2]+8>>2]](r),y(r)}l:switch(s-51|0){case 0:break t;case 1:break o;default:break l}if(s)break n}if(w=w+4|0,(V|0)==(w|0))break}}Z8(A,114912)}if(!N||(r=i[N+4>>2],i[N+4>>2]=r-1,r))break k;W[i[i[N>>2]+8>>2]](N),y(N)}r=i[n+380>>2],r&&(i[n+384>>2]=r,Z(r)),v=n+432|0;break f}e2(),M()}if(i[A>>2])break e;if(t[A+19|0]>=0)break r;Z(i[A+8>>2])}r:{if(!i[i[e+48>>2]+152>>2])break r;V=0,_=v+-64|0,v=_,s=e,$3(s+196|0,i[s+200>>2]),B=s+200|0,i[s+196>>2]=B,i[s+200>>2]=0,i[s+204>>2]=0,e=i[s+48>>2],f=i[e+152>>2],G=i[e+156>>2],G&&(i[G+4>>2]=i[G+4>>2]+1);f:{A:{k:{n:{r=i[f+36>>2],o=i[f+40>>2];t:{if((r|0)!=(o|0)){e=r;o:{for(;;){l:{u:{if(l=i[e>>2],!l||!Z0(l,92792,111476))break u;if(V=i[e+4>>2],!V)break l;i[V+4>>2]=i[V+4>>2]+1,o=i[f+40>>2],r=i[f+36>>2];break o}if(e=e+8|0,(o|0)!=(e|0))continue}break}V=0}if(i[_+56>>2]=0,i[_+48>>2]=0,i[_+52>>2]=0,(r|0)==(o|0))break t;for(;;){e=i[r>>2];o:{if(!e||(e=Z0(e,92792,99088),!e)||(i[_+24>>2]=e,e=i[r+4>>2],i[_+28>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),P0(_+48|0,_+24|0),e=i[_+28>>2],!e)||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break o;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r+8|0,(o|0)==(r|0))break}if(m=i[_+48>>2],U=i[_+52>>2],(m|0)==(U|0))break t;for(f=_+36|0,l=_+43|0,Y=_+32|0,n=A+8|0,h=i[25180],j=i[25181],E=_+8|0;;){o=_+24|0,k=v-192|0,v=k;o:{l:{u:{s:{if(e=i[m>>2],r=i[e+36>>2],w=i[e+40>>2],(r|0)!=(w|0))for(;;){h:{if(e=i[r>>2],!e||(e=Z0(e,92792,99248),!e))break h;I=i[r+4>>2],I&&(i[I+4>>2]=i[I+4>>2]+1);w:{_:{v:{if(r=i[e+36>>2],e=i[e+40>>2],(r|0)!=(e|0))for(;;){B:{if(w=i[r>>2],!w||(w=Z0(w,92792,93396),!w))break B;if(Q=i[r+4>>2],Q&&(i[Q+4>>2]=i[Q+4>>2]+1),e=i[w+108>>2],(e|0)>1885954931)break v;if((e|0)==1635088502)break _;if((e|0)!=1835365473)break w;r=C(320),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101248,w=Rl(r+16|0,s),e=w,i[e+292>>2]=0,i[e+296>>2]=0,i[e>>2]=113808,i[e+300>>2]=0;break s}if(r=r+8|0,(e|0)==(r|0))break}e=C(32),i[k+16>>2]=e,i[k+20>>2]=24,i[k+24>>2]=-2147483616,r=u[24804]|u[24805]<<8|(u[24806]<<16|u[24807]<<24),w=u[24800]|u[24801]<<8|(u[24802]<<16|u[24803]<<24),t[e+16|0]=w,t[e+17|0]=w>>>8,t[e+18|0]=w>>>16,t[e+19|0]=w>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[24796]|u[24797]<<8|(u[24798]<<16|u[24799]<<24),w=u[24792]|u[24793]<<8|(u[24794]<<16|u[24795]<<24),t[e+8|0]=w,t[e+9|0]=w>>>8,t[e+10|0]=w>>>16,t[e+11|0]=w>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[24788]|u[24789]<<8|(u[24790]<<16|u[24791]<<24),w=u[24784]|u[24785]<<8|(u[24786]<<16|u[24787]<<24),t[e|0]=w,t[e+1|0]=w>>>8,t[e+2|0]=w>>>16,t[e+3|0]=w>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+24|0]=0,e=a(k+40|0,2,0,k+16|0),r=i[e+4>>2],i[o>>2]=i[e>>2],i[o+4>>2]=r,r=o+8|0;B:{if(t[e+19|0]>=0){w=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=w,i[r+8>>2]=i[e+16>>2],t[o+20|0]=1;break B}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[o+20|0]=1,(r|0)>=0)break B;Z(i[e+8>>2])}if(t[k+27|0]>=0)break l;Z(i[k+16>>2]);break l}if((e|0)==1986618469)break _;if((e|0)!=1885954932)break w}r=C(360),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101208,w=Rl(r+16|0,s),e=w,i[e+312>>2]=0,i[e+316>>2]=0,t[e+304|0]=0,i[e+300>>2]=0,i[e+292>>2]=0,i[e+320>>2]=0,i[e+324>>2]=0,i[e>>2]=113712,i[e+308>>2]=e+312,i[e+328>>2]=0,i[e+332>>2]=0,i[e+336>>2]=0;break s}i[k+132>>2]=0,i[k+104>>2]=78164,i[k+48>>2]=78144,e=i[19545],i[k+40>>2]=e,r=i[e-12>>2],e=k+40|0,i[r+e>>2]=i[19546],i[k+44>>2]=0,r=e+i[i[k+40>>2]-12>>2]|0,N=k+52|0,J0(r,N),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[k+48>>2]=r,R=i[r-12>>2],r=k+48|0,i[R+r>>2]=i[19548],S=i[19544],i[k+40>>2]=S,i[e+i[S-12>>2]>>2]=i[19549],i[k+104>>2]=78164,i[k+40>>2]=78124,i[k+48>>2]=78144,N=R0(N),i[N>>2]=77200,i[k+92>>2]=0,i[k+96>>2]=0,i[k+84>>2]=0,i[k+88>>2]=0,i[k+100>>2]=24,e=F(r,30744,37),r=k+16|0,z1(r,i[w+108>>2]),w=e,R=r,e=t[k+27|0],r=(e|0)<0,F(F(w,r?i[k+16>>2]:R,r?i[k+20>>2]:e),29391,2),t[k+27|0]<0&&Z(i[k+16>>2]),e=i[k+100>>2];w:{_:{if(e&16){r=i[k+96>>2],e=i[k+76>>2],r>>>0<e>>>0&&(i[k+96>>2]=e,r=e),e=k+72|0;break _}if(!(e&8)){r=0,t[k+15|0]=0,w=k+4|0;break w}r=i[k+68>>2],e=k+60|0}_:{if(e=i[e>>2],r=r-e|0,r>>>0<2147483640){if(r>>>0>=11){S=r|7,w=C(S+1|0),i[k+12>>2]=S-2147483647,i[k+4>>2]=w,i[k+8>>2]=r;break _}if(t[k+15|0]=r,w=k+4|0,r)break _;r=0;break w}I0(),M()}if(!r)break w;z(w,e,r)}t[r+w|0]=0,e=a(k+16|0,4,3008,k+4|0),r=i[e+4>>2],i[o>>2]=i[e>>2],i[o+4>>2]=r,r=o+8|0;w:{if(t[e+19|0]>=0){w=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=w,i[r+8>>2]=i[e+16>>2],t[o+20|0]=1;break w}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[o+20|0]=1,(r|0)>=0)break w;Z(i[e+8>>2])}t[k+15|0]<0&&Z(i[k+4>>2]),e=i[19543],i[k+40>>2]=e,i[i[e-12>>2]+(k+40|0)>>2]=i[19551],i[k+48>>2]=i[19552],i[N>>2]=77200,t[k+95|0]<0&&Z(i[k+84>>2]),y0(N),Y0(k+104|0);break u}if(r=r+8|0,(w|0)==(r|0))break}e=C(32),i[k+16>>2]=e,i[k+20>>2]=24,i[k+24>>2]=-2147483616,r=u[25158]|u[25159]<<8|(u[25160]<<16|u[25161]<<24),w=u[25154]|u[25155]<<8|(u[25156]<<16|u[25157]<<24),t[e+16|0]=w,t[e+17|0]=w>>>8,t[e+18|0]=w>>>16,t[e+19|0]=w>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[25150]|u[25151]<<8|(u[25152]<<16|u[25153]<<24),w=u[25146]|u[25147]<<8|(u[25148]<<16|u[25149]<<24),t[e+8|0]=w,t[e+9|0]=w>>>8,t[e+10|0]=w>>>16,t[e+11|0]=w>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[25142]|u[25143]<<8|(u[25144]<<16|u[25145]<<24),w=u[25138]|u[25139]<<8|(u[25140]<<16|u[25141]<<24),t[e|0]=w,t[e+1|0]=w>>>8,t[e+2|0]=w>>>16,t[e+3|0]=w>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+24|0]=0,e=a(k+40|0,2,0,k+16|0),r=i[e+4>>2],i[o>>2]=i[e>>2],i[o+4>>2]=r,r=o+8|0;h:{if(t[e+19|0]>=0){w=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=w,i[r+8>>2]=i[e+16>>2],t[o+20|0]=1;break h}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[o+20|0]=1,(r|0)>=0)break h;Z(i[e+8>>2])}if(t[k+27|0]>=0)break o;Z(i[k+16>>2]);break o}W[i[i[w>>2]+8>>2]](k+40|0,w,m);s:{if(i[k+40>>2]){if(e=i[k+44>>2],i[o>>2]=i[k+40>>2],i[o+4>>2]=e,e=o+8|0,t[k+59|0]>=0){w=i[k+52>>2],i[e>>2]=i[k+48>>2],i[e+4>>2]=w,i[e+8>>2]=i[k+56>>2],e=1;break s}T(e,i[k+48>>2],i[k+52>>2]),e=1;break s}i[r+4>>2]=i[r+4>>2]+1,i[o+4>>2]=r,i[o>>2]=w,e=0}if(t[o+20|0]=e,t[k+59|0]<0&&Z(i[k+48>>2]),e=i[r+4>>2],i[r+4>>2]=e-1,e)break u;W[i[i[r>>2]+8>>2]](r),y(r)}if(!Q||(e=i[Q+4>>2],i[Q+4>>2]=e-1,e))break l;W[i[i[Q>>2]+8>>2]](Q),y(Q)}if(!I||(e=i[I+4>>2],i[I+4>>2]=e-1,e))break o;W[i[i[I>>2]+8>>2]](I),y(I)}v=k+192|0,r=114912,k=114924,o=114931,e=114920;o:switch(u[_+44|0]){case 1:r=_+24|0,e=Y,o=l,k=f;break;case 0:break o;default:break n}I=i[r+4>>2],r=i[r>>2],i[_>>2]=r,i[_+4>>2]=I;o:{if(t[o|0]>=0){o=i[e+4>>2],i[E>>2]=i[e>>2],i[E+4>>2]=o,i[E+8>>2]=i[e+8>>2],e=r;break o}T(E,i[e>>2],i[k>>2]),e=i[_>>2]}o:{if(!e){r=1,e=0;break o}if(!((e|0)!=4|i[_+4>>2]!=3008)){r=1,e=1;break o}r=114912,k=114924,o=114931,e=114920;l:switch(u[_+44|0]){case 1:r=_+24|0,e=Y,o=l,k=f;break;case 0:break l;default:break n}w=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=w;l:{if(t[o|0]>=0){r=i[e+4>>2],i[n>>2]=i[e>>2],i[n+4>>2]=r,i[n+8>>2]=i[e+8>>2];break l}T(n,i[e>>2],i[k>>2])}r=0,e=0}if(t[_+19|0]<0&&Z(i[_+8>>2]),r){o:{if(e)break o;if(u[_+44|0])break n;I=i[_+24>>2],w=i[_+28>>2];l:{if(!w){o=i[I+24>>2];break l}e=i[w+4>>2],i[w+4>>2]=e+1,o=i[I+24>>2],i[w+4>>2]=e+2}l:{u:{k=B,r=k,e=i[r>>2];s:{if(!e)break s;for(;;){if(r=e,e=i[r+16>>2],e>>>0>o>>>0){if(k=r,e=i[r>>2],e)continue;break s}if(e>>>0>=o>>>0)break u;if(e=i[r+4>>2],!e)break}k=r+4|0}e=C(28),i[e+24>>2]=w,i[e+20>>2]=I,i[e+16>>2]=o,i[e+8>>2]=r,i[e>>2]=0,i[e+4>>2]=0,i[k>>2]=e,r=i[i[s+196>>2]>>2],r&&(i[s+196>>2]=r),G1(i[s+200>>2],e),i[s+204>>2]=i[s+204>>2]+1;break l}if(!w||(e=i[w+4>>2],i[w+4>>2]=e-1,e))break l;W[i[i[w>>2]+8>>2]](w),y(w)}if(e=i[I+28>>2],i[s+208>>2]|!((e|0)==1885954932|(e|0)==1986618469)||(i[s+208>>2]=i[I+24>>2]),!w||(e=i[w+4>>2],i[w+4>>2]=e-1,e))break o;W[i[i[w>>2]+8>>2]](w),y(w)}if(e=u[_+44|0],(e|0)!=255&&(i[_>>2]=h,i[_+4>>2]=j,W[i[_+(e<<2)>>2]](_+63|0,_+24|0)),m=m+8|0,(U|0)!=(m|0))continue;break t}break}if(e=u[_+44|0],(e|0)==255)break f;r=i[25181],i[_>>2]=i[25180],i[_+4>>2]=r,W[i[_+(e<<2)>>2]](_+63|0,_+24|0);break f}i[_+56>>2]=0,i[_+48>>2]=0,i[_+52>>2]=0}if(i[_+32>>2]=0,i[_+24>>2]=0,i[_+28>>2]=0,r=i[s+196>>2],(B|0)==(r|0))break A;for(;;){P0(_+24|0,r+20|0),o=i[r+4>>2];t:{if(o){for(;;)if(e=o,o=i[o>>2],!o)break t}for(;e=i[r+8>>2],f=i[e>>2]!=(r|0),r=e,!!f;);}if(r=e,(B|0)==(r|0))break}break k}e2(),M()}r=i[s+196>>2]}A:{if((r|0)!=(B|0))for(;;){if(e=i[r+20>>2],W[i[i[e>>2]+12>>2]](A,e,s,_+24|0),i[A>>2])break A;t[A+19|0]<0&&Z(i[A+8>>2]),o=i[r+4>>2];k:{if(o){for(;;)if(e=o,o=i[o>>2],!o)break k}for(;e=i[r+8>>2],f=i[e>>2]!=(r|0),r=e,!!f;);}if(r=e,(B|0)==(r|0))break}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){r=i[28731],i[e>>2]=i[28730],i[e+4>>2]=r,i[e+8>>2]=i[28732];break A}T(e,i[28730],i[28731])}if(f=i[_+24>>2],!f)break f;if(r=i[_+28>>2],e=f,(r|0)!=(f|0)){for(;;){e=i[r-4>>2];A:{if(!e||(o=i[e+4>>2],i[e+4>>2]=o-1,o))break A;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(f|0)==(r|0))break}e=i[_+24>>2]}i[_+28>>2]=f,Z(e)}if(f=i[_+48>>2],f){if(r=i[_+52>>2],e=f,(r|0)!=(f|0)){for(;;){e=i[r-4>>2];f:{if(!e||(o=i[e+4>>2],i[e+4>>2]=o-1,o))break f;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(f|0)==(r|0))break}e=i[_+48>>2]}i[_+52>>2]=f,Z(e)}f:{if(!V||(e=i[V+4>>2],i[V+4>>2]=e-1,e))break f;W[i[i[V>>2]+8>>2]](V),y(V)}f:{if(!G||(e=i[G+4>>2],i[G+4>>2]=e-1,e))break f;W[i[i[G>>2]+8>>2]](G),y(G)}if(v=_- -64|0,i[A>>2])break e;if(t[A+19|0]>=0)break r;Z(i[A+8>>2])}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}return}s0(),M()}function W9(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0;X0=v-16|0,v=X0;i:{e:{r:{f:{A:{if(i[A+580>>2])break A;n=u[A+549|0];k:{k=u[A+548|0];n:{if(!(k&1)&&(l=0,!(n&1)))break n;if(i[A+3208>>2]==i[A+3212>>2])break k;f=n,l=k}if(l&1|f&1)break A;if(r=13,!e)break f;i[e>>2]=1;break f}if(ih(A+2140|0),!e)break f;i[e>>2]=i[A+2192>>2];break f}if(!vu(A+2140|0,0)){if(r=9,!e)break f;i[e>>2]=1;break f}n=i[A+580>>2];A:{k:{if(n){if(n?(k=i[A+564>>2],l=i[A+576>>2],f=i[i[k+(l>>>8&16777212)>>2]+((l&1023)<<2)>>2],i[A+580>>2]=n-1,n=l+1|0,i[A+576>>2]=n,n>>>0>=2048&&(Z(i[k>>2]),i[A+564>>2]=i[A+564>>2]+4,i[A+576>>2]=i[A+576>>2]-1024),i[A+584>>2]=i[A+584>>2]-i[f+24>>2]):f=0,O=f,!f)break r;S=v-32|0,v=S,h=i[f+20>>2],w=i[f+24>>2],f=S+8|0,i[f+16>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+4>>2]=w,i[f>>2]=h,n=-64;n:{if(!w||(i[f>>2]=h+1,l=u[h|0],k=w-1|0,i[f+4>>2]=k,i[f+8>>2]=0,l=l<<24,i[f+12>>2]=l,!k)||(i[f>>2]=h+2,k=u[h+1|0],m=w-2|0,i[f+4>>2]=m,l=k<<16|l,k=l,i[f+8>>2]=_,i[f+12>>2]=k,!m)||(i[f>>2]=h+3,l=u[h+2|0],m=w-3|0,i[f+4>>2]=m,l=l<<8|k,k=l,i[f+8>>2]=o,i[f+12>>2]=k,!m)||(i[f>>2]=h+4,l=u[h+3|0],m=w-4|0,i[f+4>>2]=m,i[f+8>>2]=o,l=k|l,i[f+12>>2]=l,!m)||(i[f>>2]=h+5,k=u[h+4|0],I=w-5|0,i[f+4>>2]=I,m=k<<24|_,i[f+8>>2]=m,l=k>>>8|l,i[f+12>>2]=l,!I)||(i[f>>2]=h+6,k=u[h+5|0],I=w-6|0,i[f+4>>2]=I,_=k<<16|m,i[f+8>>2]=_,l=k>>>16|l,i[f+12>>2]=l,!I)||(i[f>>2]=h+7,k=u[h+6|0],m=w-7|0,i[f+4>>2]=m,o=l,l=_,_=k>>>24|0,l=l|k<<8,i[f+8>>2]=l,k=o|_,i[f+12>>2]=k,!m))break n;i[f>>2]=h+8,n=u[h+7|0],i[f+4>>2]=w-8,i[f+8>>2]=n|l,i[f+12>>2]=k,n=-56}i[f+16>>2]=(((w>>>0>=7?7:w)<<3)+n|0)- -64,t[S+7|0]=0,t[S+5|0]=0,t[S+6|0]=0,ei(f,1),r0=S,f0=G0(f,6),t[r0+5|0]=f0,r0=S,f0=G0(f,6),t[r0+6|0]=f0,r0=S,f0=G0(f,3)-1|0,t[r0+7|0]=f0,f=u[S+5|0],t[A+3204|0]=f,t[A+3206|0]=(f&248)==16,t[A+3205|0]=(f-19&255)>>>0<2;n:{if(u[S+6|0]){H4(A+548|0,O);break n}if(i[A+1904>>2]<u[S+7|0]){H4(A+548|0,O);break n}if(f>>>0<=31){s=A,_=S+8|0,B=v-16|0,v=B,k=C(1364),i[k+792>>2]=0,i[k+784>>2]=0,i[k+788>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,j=k+1340|0,A=j,i[A>>2]=0,i[A+4>>2]=0,i[k+1360>>2]=0,i[k+1352>>2]=0,i[k+1356>>2]=0,A=i[k+8>>2],i[k+4>>2]=0,i[k+8>>2]=0;t:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break t;W[i[i[A>>2]+8>>2]](A),y(A)}t[k+40|0]=0,i[k+36>>2]=0,t[k+20|0]=0,i[k+16>>2]=0,X[k+12>>1]=0,i[k>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,X[k+32>>1]=0,l0(k+42|0,0,100),i[k+776>>2]=0,i[k+780>>2]=0,l0(k+144|0,0,237),l0(k+384|0,0,358),t[k+759|0]=0,t[k+760|0]=0,t[k+761|0]=0,t[k+762|0]=0,i[k+752>>2]=0,i[k+756>>2]=0,i[k+744>>2]=0,i[k+748>>2]=0,i[k+764>>2]=0,i[k+768>>2]=0,t[k+772|0]=0,i[k+796>>2]=0,i[k+800>>2]=0,i[k+804>>2]=0,i[k+808>>2]=0,i[k+812>>2]=0,i[k+816>>2]=0,i[k+788>>2]=i[k+784>>2],l0(k+820|0,0,100),l0(k+920|0,0,420),t[k+1348|0]=0,i[k+1356>>2]=i[k+1352>>2],t[B+15|0]=0,A=i[k+8>>2],i[k+4>>2]=0,i[k+8>>2]=0;t:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break t;W[i[i[A>>2]+8>>2]](A),y(A)}t[k+40|0]=0,i[k+36>>2]=0,t[k+20|0]=0,i[k+16>>2]=0,X[k+12>>1]=0,i[k>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,X[k+32>>1]=0,l=k+42|0,l0(l,0,100),i[k+776>>2]=0,i[k+780>>2]=0,l0(k+144|0,0,237),l0(k+384|0,0,358),t[k+759|0]=0,t[k+760|0]=0,t[k+761|0]=0,t[k+762|0]=0,i[k+752>>2]=0,i[k+756>>2]=0,i[k+744>>2]=0,i[k+748>>2]=0,i[k+764>>2]=0,i[k+768>>2]=0,t[k+772|0]=0,i[k+796>>2]=0,i[k+800>>2]=0,i[k+804>>2]=0,i[k+808>>2]=0,i[k+812>>2]=0,i[k+816>>2]=0,i[k+788>>2]=i[k+784>>2],w=k+820|0,l0(w,0,100),l0(k+920|0,0,420),t[k+1348|0]=0,t[k+20|0]=0,i[k+1356>>2]=i[k+1352>>2],r0=k,f0=G0(_,1),t[r0+12|0]=f0,u[s+3206|0]&&(r0=k,f0=G0(_,1),t[r0+13|0]=f0),A=k2(_),i[k+16>>2]=A;t:{o:{l:{u:{s:{if(!((A|0)!=-99999&(A|0)<=63)||(A=s+(A<<3)|0,f=i[A+856>>2],!f))break s;r=i[A+860>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[k+4>>2]=f,A=i[k+8>>2],i[k+8>>2]=r;h:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break h;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=i[k+4>>2],h=i[r+4>>2],!u[h|0]){C2(s+4|0,1010,0);break u}h:{w:{_:{v:{B:{if(!u[k+12|0]){for(A=0,u[r+14|0]?r=G0(_,1):r=0,t[k+20|0]=r,f=i[h+16908>>2];r=A,A=r+1|0,(f|0)>1<<r;);if(f=G0(_,r),o=u[k+20|0],o){if(!f){t[B+15|0]=0,C2(s+4|0,1021,0),A=0;break t}if(r=i[s+2220>>2],A=16,!r)break t;i[k>>2]=i[r>>2],A=i[r+4>>2],n=i[r+8>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[k+4>>2]=A,A=i[k+8>>2],i[k+8>>2]=n;m:{if(!A||(n=i[A+4>>2],i[A+4>>2]=n-1,n))break m;W[i[i[A>>2]+8>>2]](A),y(A)}z(k+12|0,r+12|0,772);m:{if((r|0)!=(k|0)){A=i[r+784>>2],n=i[r+788>>2],h1(k+784|0,A,n,n-A>>2),z(k+796|0,r+796|0,544),Di(k+1340|0,r+1340|0),t[k+1348|0]=u[r+1348|0],A=i[r+1352>>2],r=i[r+1356>>2],h1(k+1352|0,A,r,r-A>>2);break m}z(k+796|0,r+796|0,544),Di(k+1340|0,r+1340|0),t[k+1348|0]=u[r+1348|0]}t[k+20|0]=1,t[k+12|0]=0}if(i[k+24>>2]=f,(f|0)<0)break h;if((f|0)<i[h+16908>>2])break B;break h}if(i[k+24>>2]=0,t[k+20|0]=0,i[h+16908>>2]<=0)break h;r=i[k+4>>2];break v}if(r=i[k+4>>2],o)break _}if(A=0,t[r+8240|0]>0)for(;ei(_,1),A=A+1|0,(A|0)<t[i[k+4>>2]+8240|0];);if(A=k2(_),i[k+28>>2]=A,!((A|0)!=-99999&(A|0)<=2)){C2(s+4|0,1007,0);break u}u[i[k+4>>2]+43|0]?A=G0(_,1):A=1,t[k+32|0]=A,u[h+480|0]==1&&(r0=k,f0=G0(_,2),t[r0+33|0]=f0),t[k+40|0]=0,i[k+36>>2]=0;v:{B:{m:{g:{Z:{if((u[s+3204|0]-19&255)>>>0>=2){r0=k,f0=G0(_,i[h+520>>2]),i[r0+36>>2]=f0,A=G0(_,1),t[k+40|0]=A;W:{if(!(A&255)){Zn(s+4|0,h,_,l,(i[h+8820>>2]-i[h+8816>>2]|0)/100|0,h+8816|0,1),i[k+816>>2]=(i[h+8820>>2]-i[h+8816>>2]|0)/100;break W}for(l=i[h+8816>>2],o=(i[h+8820>>2]-l|0)/100|0,r=0;A=r,r=r+1|0,1<<A<(o|0););X:{if(!A){A=0;break X}A=G0(_,A),l=i[h+8816>>2],o=(i[h+8820>>2]-l|0)/100|0}if(i[k+144>>2]=A,(A|0)>=(o|0))break g;i[k+816>>2]=A,l=g(A,100)+l|0}z(w,l,100);W:{if(u[h+8828|0]){X:{if(i[h+8832>>2]>0){if(A=k2(_),i[k+148>>2]=A,(A|0)!=-99999)break X;A=8;break t}i[k+148>>2]=0}if(r=k2(_),i[k+152>>2]=r,l=8,(r|0)==-99999)break w;if(A=i[k+148>>2],r=r+A|0,i[(h+(t[h+2|0]<<2)|0)+524>>2]<(u[k+917|0]+(r+u[k+916|0]|0)|0))break m;if((r|0)<=0)break W;for(f=s+2352|0,n=k+268|0,m=k+252|0,I=h+8964|0,G=h+8836|0,V=k+156|0,E=s+2288|0,w=s+2224|0,Q=k+236|0,N=k+172|0,o=0;;){X:{if((A|0)>(o|0)){for(x=i[h+8832>>2],A=0;r=A,A=r+1|0,(x|0)>1<<r;);if(A=o+V|0,r=G0(_,r),t[A|0]=r,r=r&255,(r|0)<i[h+8832>>2]){i[w+(o<<2)>>2]=i[G+(r<<2)>>2],A=I+u[A|0]|0;break X}C2(s+4|0,1023,0);break u}r=o<<2,x=r+N|0,r0=x,f0=G0(_,i[h+520>>2]),i[r0>>2]=f0,A=o+Q|0,r0=A,f0=G0(_,1),t[r0|0]=f0,i[r+w>>2]=i[x>>2]}r=o<<2,x=t[A|0],i[r+E>>2]=x,A=G0(_,1),t[o+m|0]=A;X:{if(A&255){if(A=k2(_),i[r+n>>2]=A,(A|0)!=-99999)break X;break w}A=0,i[r+n>>2]=0}if(Y=((x|0)!=0)+Y|0,i[r+f>>2]=!o|i[k+148>>2]==(o|0)?A:i[(r+f|0)-4>>2]+A|0,o=o+1|0,A=i[k+148>>2],!((o|0)<(A+i[k+152>>2]|0)))break}break W}i[k+148>>2]=0,i[k+152>>2]=0}if(u[h+8996|0]){r0=k,f0=G0(_,1),t[r0+332|0]=f0;break Z}t[k+332|0]=0;break Z}i[k+148>>2]=0,i[k+152>>2]=0}Z:{if(u[h+8799|0]){if(r0=k,f0=G0(_,1),t[r0+333|0]=f0,A=0,!i[h+16848>>2])break Z;A=G0(_,1);break Z}t[k+333|0]=0,A=0}if(i[k+336>>2]=0,i[k+340>>2]=0,t[k+334|0]=A,o0[k+28>>2]>1)break v;A=G0(_,1),t[k+335|0]=A;Z:{if(A&255){if(A=k2(_),i[k+336>>2]=A,(A|0)==-99999)break l;if(A=A+1|0,i[k+336>>2]=A,i[k+28>>2]){r=i[k+340>>2];break Z}if(A=k2(_),i[k+340>>2]=A,(A|0)==-99999)break l;r=A+1|0,i[k+340>>2]=r,A=i[k+336>>2];break Z}r=i[k+4>>2],A=t[r+17|0],i[k+336>>2]=A,r=t[r+18|0],i[k+340>>2]=r}if(l=8,(A|0)>16|(r|0)>16)break w;f=u[k+919|0]+Y|0,i[k+920>>2]=f;Z:{W:{if(!(!u[i[k+4>>2]+8233|0]|(f|0)<2)){for(r=0;A=r,r=r+1|0,(f|0)>1<<A;);if(r=G0(_,1),t[k+344|0]=r,!(!(r&255)|i[k+336>>2]<=0))for(f=k+346|0,r=0;r0=r+f|0,f0=G0(_,A),t[r0|0]=f0,r=r+1|0,(r|0)<i[k+336>>2];);if(!i[k+28>>2]){if(r=G0(_,1),t[k+345|0]=r,!(r&255)|i[k+340>>2]<=0)break W;for(f=k+362|0,r=0;r0=r+f|0,f0=G0(_,A),t[r0|0]=f0,r=r+1|0,(r|0)<i[k+340>>2];);break W}t[k+345|0]=0;break Z}X[k+344>>1]=0}if(i[k+28>>2])break Z;r0=k,f0=G0(_,1),t[r0+378|0]=f0}if(u[i[k+4>>2]+16|0]?A=G0(_,1):A=0,t[k+379|0]=A,!u[k+332|0])break B;A=1,i[k+28>>2]||(A=G0(_,1)),t[k+380|0]=A,r=A&255;Z:{if(!(i[k+340>>2]<2|r)||i[k+336>>2]>1&&r){if(r=k2(_),i[k+384>>2]=r,(r|0)!=-99999){A=u[k+380|0];break Z}break l}r=0,i[k+384>>2]=0}Z:{if(A&255){if(i[k+336>>2]<=(r|0))break Z;break B}if(i[k+340>>2]>(r|0))break B}break o}C2(s+4|0,1015,0),A=8;break t}C2(s+4|0,1018,0);break u}B:{if(A=i[k+4>>2],r=i[k+28>>2],!(!(r|!u[A+42|0])||(r|0)==1&&u[A+41|0]))break B;n=0;m:{g:{if(A=i[(s+(i[k+16>>2]<<3)|0)+856>>2],A){if(o=i[(s+(t[A+13|0]<<3)|0)+728>>2],!o)break g;A=k2(_),t[k+388|0]=A;Z:{if(A>>>0>7)break Z;if(i[o+476>>2]){if(A=f4(_)+u[k+388|0]|0,A>>>0>7)break Z;t[k+389|0]=A}for(R=k+679|0,A0=k+552|0,V=k+678|0,E=k+550|0,g0=k+518|0,Q=k+454|0,N=k+422|0,q=k+390|0,f=k+336|0,l=k+340|0,r=1;;){A=f;W:{if(r||(A=l,!i[k+28>>2]))break W;n=1;break m}if(w=0,I=i[A>>2],(I|0)>0){for(;Y=n<<4,_0=Y+q|0,r0=_0+w|0,f0=G0(_,1),t[r0|0]=f0,w=w+1|0,(I|0)!=(w|0););if(w=0,i[o+476>>2])for(;r0=(Y+N|0)+w|0,f0=G0(_,1),t[r0|0]=f0,w=w+1|0,(I|0)!=(w|0););for(m=n<<5,U=m+R|0,x=n<<6,d=x+A0|0,w=0;;){W:{if(u[w+_0|0]){if(n=0,A=f4(_),A-128>>>0<4294967040)break m;if(X[(m+Q|0)+(w<<1)>>1]=A+(1<<u[k+388|0]),A=f4(_),G=i[o+16996>>2],(A|0)<(0-G|0))break Z;if((A|0)<(G|0))break W;break Z}X[(m+Q|0)+(w<<1)>>1]=1<<u[k+388|0],A=0}t[(Y+g0|0)+w|0]=A,C0=U+(w<<1)|0;W:{X:{if(u[(Y+N|0)+w|0]){if(A=f4(_),A-128>>>0>=4294967040)break X;n=0;break m}A=w<<2,n=1<<u[k+389|0],X[A+(E+x|0)>>1]=n,t[(m+V|0)+(w<<1)|0]=0,X[A+d>>1]=n,A=0;break W}if(c=w<<2,t0=c+(E+x|0)|0,X[t0>>1]=A+(1<<u[k+389|0]),n=0,G=f4(_),A=i[o+17e3>>2],V0=A<<2,(G|0)<(0-V0|0)|(G|0)>=(V0|0)||(V0=0-A|0,G=(A+G|0)-(g(A,X[t0>>1])>>u[k+389|0])|0,t[(m+V|0)+(w<<1)|0]=(G|0)<(V0|0)?V0:(A|0)>(G|0)?G:A-1|0,A=f4(_),A-128>>>0<4294967040)||(c=d+c|0,X[c>>1]=A+(1<<u[k+389|0]),G=f4(_),A=i[o+17e3>>2],t0=A<<2,(G|0)<(0-t0|0)|(G|0)>=(t0|0)))break Z;t0=0-A|0,n=(A+G|0)-(g(A,X[c>>1])>>u[k+389|0])|0,A=(n|0)<(t0|0)?t0:(A|0)>(n|0)?n:A+255|0}if(t[C0|0]=A,w=w+1|0,(I|0)==(w|0))break}}if(n=1,A=r,r=0,!A)break}}break m}U0(5285,19977,152,14771),M()}U0(5281,19977,154,14771),M()}if(n)break B;break o}if(A=k2(_),i[k+744>>2]=A,(A|0)==-99999)break l;i[k+812>>2]=5-A}if(A=f4(_),i[k+748>>2]=A,(A|0)==-99999)break l;A=i[k+4>>2];v:{if(u[A+40|0]){if(A=f4(_),i[k+752>>2]=A,(A|0)==-99999)break l;if(A=f4(_),i[k+756>>2]=A,(A|0)!=-99999){A=i[k+4>>2];break v}break l}i[k+752>>2]=0,i[k+756>>2]=0}u[A+8248|0]==1&&(r0=k,f0=G0(_,1),t[r0+760|0]=f0,A=i[k+4>>2]);v:{B:{if(!u[A+60|0]){t[k+761|0]=0,i[k+764>>2]=i[A+64>>2],i[k+768>>2]=i[A+68>>2];break B}if(r=G0(_,1),t[k+761|0]=r,A=i[k+4>>2],i[k+764>>2]=i[A+64>>2],i[k+768>>2]=i[A+68>>2],!(r&255))break B;if(A=G0(_,1),t[k+762|0]=A,A&255)break v;if(A=f4(_),i[k+764>>2]=A,(A|0)==-99999||(i[k+764>>2]=A<<1,A=f4(_),i[k+768>>2]=A,(A|0)==-99999))break l;i[k+768>>2]=A<<1;break v}t[k+762|0]=u[A+61|0]}if(r=i[k+4>>2],A=u[r+58|0],!(!A|!(!u[k+762|0]||u[k+333|0]|u[k+334|0]))){r0=k,f0=G0(_,1),t[r0+772|0]=f0,r=i[k+4>>2];break _}t[k+772|0]=A}_:{if(u[r+46|0]|u[r+45|0]){if(A=k2(_),i[k+776>>2]=A,(A|0)==-99999||(r=i[k+4>>2],!(!u[r+45|0]|i[h+16900>>2]>(A+(i[k+24>>2]/i[h+16892>>2]|0)|0))|!(!u[r+46|0]|(A|0)<=(g(i[r+52>>2],i[r+48>>2])|0))))break l;r=k+784|0,f=i[r>>2],n=i[r+4>>2]-f>>2;v:{if(n>>>0<A>>>0){T8(r,A-n|0);break v}A>>>0<n>>>0&&(i[r+4>>2]=f+(A<<2))}if(i[k+776>>2]<=0)break _;if(r=k2(_),i[k+780>>2]=r,(r|0)==-99999)break l;if(f=r+1|0,i[k+780>>2]=f,A=8,(r|0)>31)break t;if(i[k+776>>2]<=0||(A=1,r=G0(_,f),i[i[k+784>>2]>>2]=r+1,i[k+776>>2]<2))break _;for(;r=G0(_,i[k+780>>2]),f=i[k+784>>2]+(A<<2)|0,i[f>>2]=(r+i[f-4>>2]|0)+1,A=A+1|0,(A|0)<i[k+776>>2];);break _}i[k+776>>2]=0}_:{if(!u[i[k+4>>2]+8241|0])break _;if(r=k2(_),i[k+796>>2]=r,(r|0)==-99999|(r|0)>1e3)break l;if(A=0,(r|0)<=0)break _;for(;G0(_,8),A=A+1|0,(A|0)<i[k+796>>2];);}i[k+800>>2]=i[k+748>>2]+i[i[k+4>>2]+20>>2],A=0;_:{v:{B:switch(i[k+28>>2]){case 1:A=t[k+379|0]+1|0;break v;case 0:break B;case 2:break v;default:break _}A=2-t[k+379|0]|0}i[k+804>>2]=A}i[k+812>>2]=5-i[k+744>>2],t[B+15|0]=1,l=0}A=l;break t}C2(s+4|0,1020,0),A=8;break t}C2(s+4|0,1009,0),A=0;break t}t[B+15|0]=0,A=0;break t}C2(s+4|0,1007,0),A=8;break t}C2(s+4|0,8,0),A=8}i[B+8>>2]=A;t:{o:{if(!u[B+15|0]){A=i[s+2216>>2],A&&(t[A+312|0]=2),H4(s+548|0,O),A=i[k+1352>>2],A&&(i[k+1356>>2]=A,Z(A)),l6(j),A=i[k+784>>2],A&&(i[k+788>>2]=A,Z(A)),A=i[k+8>>2];l:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break l;W[i[i[A>>2]+8>>2]](A),y(A)}Z(k),r=i[B+8>>2];break o}if(f=i[s+528>>2],(f|0)>=0)l:{A=v-864|0,v=A,r=73524;u:{s:{h:{w:switch(f-1|0){case 1:r=73520;break;case 0:break w;default:break h}if(r=i[r>>2],n0(r,47355,0),f=i[(s+(i[k+16>>2]<<3)|0)+856>>2],!f){n0(r,38583,0);break h}if(!u[f|0])break s;if(n=i[(s+(t[f+13|0]<<3)|0)+728>>2],!n){n0(r,38559,0);break h}if(!u[n|0])break u;i[A+848>>2]=t[k+12|0],n0(r,43797,A+848|0),(u[s+3204|0]&248)==16&&(i[A+832>>2]=t[k+13|0],n0(r,44435,A+832|0)),i[A+816>>2]=i[k+16>>2],n0(r,45157,A+816|0),u[k+12|0]||(i[A+800>>2]=t[k+20|0],n0(r,44392,A+800|0),i[A+784>>2]=i[k+24>>2],n0(r,45933,A+784|0)),l=i[k+28>>2],i[A+768>>2]=l?(l|0)==1?80:73:66,n0(r,46652,A+768|0),u[f+43|0]&&(i[A+752>>2]=t[k+32|0],n0(r,46381,A+752|0)),u[n+480|0]==1&&(i[A+736>>2]=t[k+33|0],n0(r,46424,A+736|0)),i[A+720>>2]=i[k+36>>2],n0(r,45665,A+720|0);w:{if((u[s+3204|0]-19&255)>>>0<2)break w;i[A+704>>2]=t[k+40|0],n0(r,43516,A+704|0),l=i[n+8820>>2]-i[n+8816>>2]|0;_:{v:{if(!u[k+40|0]){i[A+672>>2]=(l|0)/100,n0(r,37480,A+672|0),l=k+42|0;break v}if((l|0)<101)break _;i[A+688>>2]=i[k+144>>2],n0(r,44888,A+688|0),l=i[n+8816>>2]+g(i[k+144>>2],100)|0}Xo(l,r)}if(u[n+8828|0]&&(i[n+8832>>2]>0&&(i[A+656>>2]=i[k+148>>2],n0(r,46558,A+656|0)),i[A+640>>2]=i[k+152>>2],n0(r,46467,A+640|0)),!u[n+8996|0])break w;i[A+624>>2]=t[k+332|0],n0(r,41101,A+624|0)}if(u[n+8799|0]&&(i[A+608>>2]=t[k+333|0],n0(r,45554,A+608|0),i[A+592>>2]=t[k+334|0],n0(r,45119,A+592|0)),o0[k+28>>2]<=1){i[A+576>>2]=t[k+335|0],n0(r,40808,A+576|0),l=u[k+335|0],i[A+560>>2]=i[k+336>>2],i[A+564>>2]=l?47881:29797,n0(r,38080,A+560|0),i[k+28>>2]||(l=u[k+335|0],i[A+544>>2]=i[k+340>>2],i[A+548>>2]=l?47881:29797,n0(r,38040,A+544|0));w:{if(!u[f+8233|0]|i[k+920>>2]<2)break w;if(i[A+528>>2]=t[k+344|0],n0(r,41726,A+528|0),!(!u[k+344|0]|i[k+336>>2]<=0))for(l=k+346|0,o=0;i[A+516>>2]=u[l+o|0],i[A+512>>2]=o,n0(r,39791,A+512|0),o=o+1|0,(o|0)<i[k+336>>2];);if(i[A+496>>2]=t[k+345|0],n0(r,41686,A+496|0),!u[k+345|0]|i[k+340>>2]<=0)break w;for(l=k+362|0,o=0;i[A+484>>2]=u[l+o|0],i[A+480>>2]=o,n0(r,39791,A+480|0),o=o+1|0,(o|0)<i[k+340>>2];);}i[k+28>>2]||(i[A+464>>2]=t[k+378|0],n0(r,45866,A+464|0)),i[A+448>>2]=t[k+379|0],n0(r,46009,A+448|0),u[k+332|0]&&(i[A+432>>2]=t[k+380|0],n0(r,44212,A+432|0),i[A+416>>2]=i[k+384>>2],n0(r,45355,A+416|0)),l=i[k+28>>2];w:{if(!(!(l|!u[f+42|0])||(l|0)==1&&u[f+41|0]))break w;if(i[A+400>>2]=u[k+388|0],n0(r,44355,A+400|0),i[n+476>>2]&&(i[A+384>>2]=u[k+389|0],n0(r,44683,A+384|0)),l=i[k+336>>2],(l|0)>0)for(h=k+678|0,w=k+550|0,m=k+518|0,I=k+454|0,Y=k+679|0,G=k+552|0,o=0;n=o<<1,i[A+376>>2]=X[n+I>>1],i[A+372>>2]=o,i[A+368>>2]=0,n0(r,45592,A+368|0),i[A+360>>2]=t[o+m|0],i[A+356>>2]=o,i[A+352>>2]=0,n0(r,45318,A+352|0),V=o<<2,i[A+348>>2]=X[V+w>>1],i[A+344>>2]=0,i[A+340>>2]=o,i[A+336>>2]=0,n0(r,44249,A+336|0),i[A+332>>2]=t[n+h|0],i[A+328>>2]=0,i[A+324>>2]=o,i[A+320>>2]=0,n0(r,44287,A+320|0),i[A+316>>2]=X[G+V>>1],i[A+312>>2]=1,i[A+308>>2]=o,i[A+304>>2]=0,n0(r,44249,A+304|0),i[A+300>>2]=t[n+Y|0],i[A+296>>2]=1,i[A+292>>2]=o,i[A+288>>2]=0,n0(r,44287,A+288|0),o=o+1|0,(l|0)!=(o|0););if(i[k+28>>2]||(l=i[k+340>>2],(l|0)<=0))break w;for(h=k+711|0,w=k+616|0,m=k+710|0,I=k+614|0,Y=k+534|0,G=k+486|0,o=0;n=o<<1,i[A+280>>2]=X[n+G>>1],i[A+276>>2]=o,i[A+272>>2]=1,n0(r,45592,A+272|0),i[A+264>>2]=t[o+Y|0],i[A+260>>2]=o,i[A+256>>2]=1,n0(r,45318,A+256|0),V=o<<2,i[A+252>>2]=X[V+I>>1],i[A+248>>2]=0,i[A+244>>2]=o,i[A+240>>2]=1,n0(r,44249,A+240|0),i[A+236>>2]=t[n+m|0],i[A+232>>2]=0,i[A+228>>2]=o,i[A+224>>2]=1,n0(r,44287,A+224|0),i[A+220>>2]=X[w+V>>1],i[A+216>>2]=1,i[A+212>>2]=o,i[A+208>>2]=1,n0(r,44249,A+208|0),i[A+204>>2]=t[n+h|0],i[A+200>>2]=1,i[A+196>>2]=o,i[A+192>>2]=1,n0(r,44287,A+192|0),o=o+1|0,(l|0)!=(o|0););}i[A+176>>2]=i[k+744>>2],n0(r,42075,A+176|0)}if(i[A+160>>2]=i[k+748>>2],n0(r,44583,A+160|0),u[f+40|0]&&(i[A+144>>2]=i[k+752>>2],n0(r,42973,A+144|0),i[A+128>>2]=i[k+756>>2],n0(r,42944,A+128|0)),u[f+60|0]&&(i[A+112>>2]=t[k+761|0],n0(r,40770,A+112|0)),n=u[k+761|0],i[A+96>>2]=t[k+762|0],i[A+100>>2]=n?29735:29466,n0(r,37993,A+96|0),u[k+762|0]|!u[k+761|0]||(i[A+80>>2]=i[k+764>>2],n0(r,41912,A+80|0),i[A+64>>2]=i[k+768>>2],n0(r,42527,A- -64|0)),!u[f+58|0]|!(!u[k+762|0]||u[k+333|0]|u[k+334|0])||(i[A+48>>2]=t[k+772|0],n0(r,41050,A+48|0)),!(u[f+46|0]|u[f+45|0])||(i[A+32>>2]=i[k+776>>2],n0(r,42589,A+32|0),i[k+776>>2]<=0)||(i[A+16>>2]=i[k+780>>2],n0(r,46126,A+16|0),i[k+776>>2]<=0))break h;for(o=0;i[A+4>>2]=i[i[k+784>>2]+(o<<2)>>2],i[A>>2]=o,n0(r,41624,A),o=o+1|0,(o|0)<i[k+776>>2];);}v=A+864|0;break l}U0(19519,19977,1287,7874),M()}U0(19505,19977,1294,7874),M()}n=i[O+8>>2],V=i[O+12>>2],E=i[O+16>>2],I=v-80|0,v=I,i[B+8>>2]=0,t[s+3220|0]=0,r=i[k+16>>2],f=s+(r<<3)|0,A=i[f+856>>2];l:{if(!(u[A|0]&&A)){if(i[I>>2]=r,r=v-16|0,v=r,u[132517]|i[33128]<-9999||(A=i[18381],f=u[38607]==42,f||r4(37523,5,1,A),i[r+12>>2]=I,G3(A,f+38607|0,I,2004,2005),Q6(A)),v=r+16|0,A=i[i[s+2216>>2]+112>>2],r=i[A+84>>2],(r|0)==20){i[A+80>>2]=1001,r=0;break l}i[A+84>>2]=r+1,i[(A+(r<<2)|0)+4>>2]=1009,r=0;break l}r=i[f+860>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[s+1384>>2]=A,A=i[s+1388>>2],i[s+1388>>2]=r;u:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break u;W[i[i[A>>2]+8>>2]](A),y(A)}A=s+(t[i[s+1384>>2]+13|0]<<3)|0,f=i[A+728>>2],r=i[A+732>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[s+1376>>2]=f,A=i[s+1380>>2],i[s+1380>>2]=r;u:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break u;W[i[i[A>>2]+8>>2]](A),y(A)}A=s+(t[i[s+1376>>2]+1|0]<<3)|0,f=i[A+600>>2],r=i[A+604>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[s+1368>>2]=f,A=i[s+1372>>2],i[s+1372>>2]=r;u:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break u;W[i[i[A>>2]+8>>2]](A),y(A)}u:{s:{h:{w:{if(A=i[s+1376>>2],!A){if(A=i[s+1368>>2],A)break w;if(A=6,u[s+2108|0]!=6)break s;break u}if(o=t[A+2|0],A=o-1|0,(A|0)!=t[s+2108|0])break h;break u}if(o=i[A+8>>2],t[s+2108|0]==(o-1|0))break u;A=o-1|0}if((o|0)<=0)break u}for(Q=s+2112|0,w=s+1908|0,m=A+1|0;;){r=g(A,100),h=(r+100|0)/(m|0)|0,f=(r|0)/(m|0)|0;s:{if((h|0)<(f|0)){r=A;break s}l=i[s+1888>>2];h:{if(f+h&1){r=A,o=f;break h}r=w+(f<<1)|0,t[r+1|0]=(A|0)>(l|0)?100:0,o=r,r=(A|0)<(l|0)?A:l,t[o|0]=r,o=f+1|0}if((f|0)==(h|0))break s;for(Y=h-f|0,A=r;G=w+(o<<1)|0,r=(A|0)<(l|0)?A:l,t[G|0]=r,t[G+1|0]=(A|0)>(l|0)?100:(g(o-f|0,100)|0)/(Y|0)|0,G=o+1|0,A=w+(G<<1)|0,t[A+1|0]=(g(G-f|0,100)|0)/(Y|0),t[A|0]=r,o=o+2|0,A=r,(h|0)!=(G|0););}if(i[Q+(r<<2)>>2]=h,A=r-1|0,!((r|0)>0))break}}A=s+(i[s+1892>>2]<<1)|0,r=t[A+1908|0],i[s+1896>>2]=r,i[s+1900>>2]=t[A+1909|0],i[s+1904>>2]=r;u:{s:{if(u[k+12|0]){if(i[s+2196>>2]=i[k+36>>2],A=i[s+1376>>2],r=u[A+8799|0],f=u[s+533|0],i[I+72>>2]=A,A=i[s+1380>>2],i[I+76>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=i[I+76>>2],i[I+40>>2]=i[I+72>>2],i[I+44>>2]=A,A=st(s+2140|0,I+40|0,s,n,V,E,(f|!r)&1),(A|0)<0){r=0,i[B+8>>2]=0-A;break l}r=0,f=i[s+2148>>2],A>>>0<i[s+2152>>2]-f>>2>>>0&&(r=i[f+(A<<2)>>2]),i[s+2216>>2]=r,t[r+316|0]=u[S+7|0],A=u[S+5|0]|u[S+6|0]<<8,t[r+314|0]=A,t[r+315|0]=A>>>8,A=i[s+2216>>2],i[I+64>>2]=i[s+1368>>2],r=i[s+1372>>2],i[I+68>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),i[I+56>>2]=i[s+1376>>2],r=i[s+1380>>2],i[I+60>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),i[I+48>>2]=i[s+1384>>2],r=i[s+1388>>2],i[I+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[I+68>>2],i[I+32>>2]=i[I+64>>2],i[I+36>>2]=r,r=i[I+60>>2],i[I+24>>2]=i[I+56>>2],i[I+28>>2]=r,r=i[I+52>>2],i[I+16>>2]=i[I+48>>2],i[I+20>>2]=r,r=i[I+32>>2],f=i[I+36>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+116>>2]=r,r=i[A+120>>2],i[A+120>>2]=f;h:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break h;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[I+24>>2],f=i[I+28>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+124>>2]=r,r=i[A+128>>2],i[A+128>>2]=f;h:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break h;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[I+16>>2],f=i[I+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+132>>2]=r,r=i[A+136>>2],i[A+136>>2]=f;h:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break h;W[i[i[r>>2]+8>>2]](r),y(r)}A=i[I+20>>2];h:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break h;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[I+28>>2];h:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break h;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[I+36>>2];h:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break h;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[s+2216>>2],i[A+112>>2]=s,l=0,w=0,r=i[A+160>>2];h:{if(!r||(f=g(i[A+164>>2],3),!f))break h;l0(r,0,f)}r=i[A+140>>2];h:{if(!r||(f=g(i[A+144>>2],24),!f))break h;l0(r,0,f)}r=i[A+260>>2];h:{if(!r||(f=i[A+264>>2],!f))break h;l0(r,0,f)}n=i[A+144>>2];h:{if((n|0)<=0)break h;if(A=i[A+320>>2],r=0,n>>>0>=8)for(o=A+532|0,h=A+456|0,m=A+380|0,Y=A+304|0,G=A+228|0,V=A+152|0,E=A+76|0,Q=n&2147483640;f=g(r,76),i[f+A>>2]=0,i[f+E>>2]=0,i[f+V>>2]=0,i[f+G>>2]=0,i[f+Y>>2]=0,i[f+m>>2]=0,i[f+h>>2]=0,i[f+o>>2]=0,r=r+8|0,w=w+8|0,(Q|0)!=(w|0););if(f=n&7,!f)break h;for(;i[A+g(r,76)>>2]=0,r=r+1|0,l=l+1|0,(f|0)!=(l|0););}A=u[s+3204|0];h:{if((A&248)!=16)break h;w:{if(!(t[s+2200|0]&1|((A|0)==18|(A&254)==16|(A-19&255)>>>0<2))&&!(t[s+2203|0]&1))break w;t[s+2203|0]=0,t[s+2201|0]=1;break h}t[s+2201|0]=0,t[s+2202|0]=0}h:{if(!(!(t[s+2201|0]&1)|(u[s+3204|0]&254)!=8)){t[i[s+2216>>2]+104|0]=0;break h}t[i[s+2216>>2]+104|0]=u[k+32|0]!=0}f=0;h:{if(!(!(t[s+2201|0]&1)|(u[s+3204|0]&248)!=16)){t[s+3220|0]=1,i[s+2204>>2]=0,A=i[k+36>>2];break h}A=i[k+36>>2],f=i[s+2208>>2],r=i[i[s+1376>>2]+16868>>2];w:{if(!((A|0)>=(f|0)|(f-A|0)<((r|0)/2|0))){l=r+i[s+2212>>2]|0;break w}if(l=i[s+2212>>2]-r|0,!((A|0)<=(f|0)|(A-f|0)<=((r|0)/2|0)))break w;l=i[s+2212>>2]}f=l,i[s+2204>>2]=f}r=i[s+2216>>2],i[r+92>>2]=A,i[r+96>>2]=A+f;h:{if(u[r+316|0]||(A=u[s+3204|0],!(A&241))||(A=A&254,(A|0)==8|(A|0)==6))break h;i[s+2208>>2]=i[k+36>>2],i[s+2212>>2]=i[s+2204>>2]}if(!u[k+12|0])break s;i[i[s+2216>>2]+100>>2]=1,f=0,l=0,w=0,n=0,m=v-32|0,v=m,i[m+28>>2]=0,i[m+20>>2]=0,i[m+24>>2]=0,r=i[s+2216>>2],Y=i[r>>2];h:{w:{_:{v:{if(!(!(t[s+2201|0]&1)|(u[s+3204|0]&248)!=16)){if(A=i[s+2152>>2],o=i[s+2148>>2],(A|0)!=(o|0))for(E=i[r+96>>2];;){G=i[(f<<2)+o>>2];B:{if(!i[G+100>>2]|(E|0)<=i[G+96>>2]||(h=i[G>>2],h>>>0>=o0[G+108>>2]))break B;m:{if(n>>>0<w>>>0){i[n>>2]=h,n=n+4|0;break m}if(r=n-l|0,Q=r>>2,V=Q+1|0,V>>>0>=1073741824)break v;if(n=w-l|0,w=n>>1,V=n>>>0>=2147483644?1073741823:w>>>0>V>>>0?w:V,V){if(V>>>0>=1073741824)break e;w=C(V<<2)}else w=0;n=w+r|0,i[n>>2]=h,h=n-(Q<<2)|0,r&&z(h,l,r),n=n+4|0,w=w+(V<<2)|0,l&&(Z(l),o=i[s+2148>>2],A=i[s+2152>>2]),l=h}i[G+108>>2]=i[G>>2]}if(f=f+1|0,!(f>>>0<A-o>>2>>>0))break}i[m+28>>2]=w,i[m+24>>2]=n,i[m+20>>2]=l}B:{if((u[s+3204|0]-19&255)>>>0<2){i[s+2544>>2]=0,i[s+2548>>2]=0,i[s+2560>>2]=0,A=s+2552|0,i[A>>2]=0,i[A+4>>2]=0;break B}if(o=0,l=0,A=0,n=u[k+916|0],n)for(h=k+820|0,w=s+2692|0,G=s+2564|0,V=k+884|0,E=i[s+2216>>2],f=0;;){r=i[E+96>>2]+X[h+(f<<1)>>1]|0;m:{if(u[f+V|0]){i[G+(A<<2)>>2]=r,A=A+1|0;break m}i[w+(l<<2)>>2]=r,l=l+1|0}if(f=f+1|0,(n|0)==(f|0))break}if(i[s+2544>>2]=A,r=u[k+917|0],r)for(n=s+2692|0,h=s+2628|0,w=k+852|0,G=k+900|0,V=i[s+2216>>2],f=0;;){A=i[V+96>>2]+X[w+(f<<1)>>1]|0;m:{if(u[f+G|0]){i[h+(o<<2)>>2]=A,o=o+1|0;break m}i[n+(l<<2)>>2]=A,l=l+1|0}if(f=f+1|0,(r|0)==(f|0))break}i[s+2552>>2]=l,i[s+2548>>2]=o;m:{if((i[k+152>>2]+i[k+148>>2]|0)<=0){n=0,r=0;break m}for(h=s+2480|0,w=s+2820|0,G=s+2416|0,V=s+2756|0,E=s+2288|0,Q=s+2352|0,N=k+252|0,x=s+2224|0,d=i[s+1376>>2],R=i[s+2216>>2],f=0,r=0,n=0;;){A=f<<2,l=i[A+x>>2],o=f+N|0,u[o|0]&&(l=i[R+96>>2]+l-(i[k+36>>2]+g(i[d+16868>>2],i[A+Q>>2]))|0);g:{if(i[A+E>>2]){A=r<<2,i[A+V>>2]=l,i[A+G>>2]=t[o|0],r=r+1|0;break g}A=n<<2,i[A+w>>2]=l,i[A+h>>2]=t[o|0],n=n+1|0}if(f=f+1|0,!((f|0)<(i[k+152>>2]+i[k+148>>2]|0)))break}}i[s+2560>>2]=n,i[s+2556>>2]=r}if(A=i[s+2148>>2],r=i[s+2152>>2],i[m+16>>2]=0,i[m+8>>2]=0,i[m+12>>2]=0,(A|0)!=(r|0)){if(A=r-A>>2,(A|0)<0)break i;r=C(A),i[m+8>>2]=r,f=A+r|0,i[m+16>>2]=f,A&&l0(r,0,A),i[m+12>>2]=f}if(n=s+2140|0,A=i[s+2556>>2],(A|0)<=0)break _;for(G=s+3076|0,V=s+2756|0,E=s+2416|0,o=0;;){A=o<<2,l=A+V|0,r=i[l>>2],Q=A+G|0;B:{if(!i[A+E>>2]){f=_l(n,r,Y);break B}f=Te(n,r,Y,1)}i[Q>>2]=f;B:{m:{if((f|0)>=0){t[i[m+8>>2]+f|0]=1;break m}if(f=v3(s,i[s+1376>>2],i[l>>2],1),(f|0)<0)break B;l=i[s+2152>>2]-i[s+2148>>2]>>2,A=i[m+12>>2],r=i[m+8>>2],h=A-r|0;g:{if(l>>>0>h>>>0){if(w=l-h|0,N=i[m+16>>2],w>>>0<=N-A>>>0){w&&l0(A,0,w),i[m+12>>2]=A+w;break g}if((l|0)<0)break i;if(A=N-r|0,N=A<<1,N=A>>>0>=1073741823?2147483647:l>>>0<N>>>0?N:l,A=C(N),w&&l0(A+h|0,0,w),h&&z(A,r,h),i[m+16>>2]=A+N,i[m+12>>2]=A+l,i[m+8>>2]=A,!r){r=A;break g}Z(r),r=A;break g}if(l>>>0>=h>>>0)break g;i[m+12>>2]=r+l}i[Q>>2]=f,t[r+f|0]=1}if(u[i[i[s+2148>>2]+(f<<2)>>2]+312|0]&&(t[i[s+2216>>2]+312|0]=4),A=i[s+2556>>2],o=o+1|0,(A|0)>(o|0))continue;break _}break}f=0-f|0;break w}i[m+28>>2]=w,i[m+24>>2]=n,i[m+20>>2]=l,s0(),M()}if(l=i[s+2560>>2],(l|0)>0){G=s+3140|0,V=s+2820|0,E=s+2480|0,o=0;_:{v:{for(;;){A=o<<2,f=A+V|0,r=i[f>>2],Q=A+G|0;B:{if(!i[A+E>>2]){A=_l(n,r,Y);break B}A=Te(n,r,Y,1)}i[Q>>2]=A;B:{m:{if((A|0)>=0){t[A+i[m+8>>2]|0]=1;break m}if(w=v3(s,i[s+1376>>2],i[f>>2],1),(w|0)<0)break v;r=i[s+2152>>2]-i[s+2148>>2]>>2,A=i[m+12>>2],f=i[m+8>>2],l=A-f|0;g:{if(r>>>0>l>>>0){if(h=r-l|0,N=i[m+16>>2],h>>>0<=N-A>>>0){h&&l0(A,0,h),i[m+12>>2]=A+h;break g}if((r|0)<0)break B;if(A=N-f|0,N=A<<1,N=A>>>0>=1073741823?2147483647:r>>>0<N>>>0?N:r,A=C(N),h&&l0(A+l|0,0,h),l&&z(A,f,l),i[m+16>>2]=A+N,i[m+12>>2]=A+r,i[m+8>>2]=A,!f){f=A;break g}Z(f),f=A;break g}if(r>>>0>=l>>>0)break g;i[m+12>>2]=r+f}i[Q>>2]=w,t[f+w|0]=1}if(l=i[s+2560>>2],o=o+1|0,(l|0)<=(o|0))break _;continue}break}break i}f=0-w|0;break w}A=i[s+2556>>2]}_:{if((A|0)<=0)break _;if(G=s+3076|0,h=i[s+2148>>2],r=0,f=0,A>>>0>=4)for(V=A&2147483644,o=0;w=G+(f<<2)|0,i[i[h+(i[w>>2]<<2)>>2]+100>>2]=2,i[i[h+(i[w+4>>2]<<2)>>2]+100>>2]=2,i[i[h+(i[w+8>>2]<<2)>>2]+100>>2]=2,i[i[h+(i[w+12>>2]<<2)>>2]+100>>2]=2,f=f+4|0,o=o+4|0,(V|0)!=(o|0););if(A=A&3,!A)break _;for(;i[i[h+(i[G+(f<<2)>>2]<<2)>>2]+100>>2]=2,f=f+1|0,r=r+1|0,(A|0)!=(r|0););}_:{if((l|0)<=0)break _;if(h=l&3,w=s+3140|0,A=i[s+2148>>2],r=0,f=0,l>>>0>=4)for(G=l&2147483644,l=0;o=w+(f<<2)|0,i[i[A+(i[o>>2]<<2)>>2]+100>>2]=2,i[i[A+(i[o+4>>2]<<2)>>2]+100>>2]=2,i[i[A+(i[o+8>>2]<<2)>>2]+100>>2]=2,i[i[A+(i[o+12>>2]<<2)>>2]+100>>2]=2,f=f+4|0,l=l+4|0,(G|0)!=(l|0););if(!h)break _;for(;i[i[A+(i[w+(f<<2)>>2]<<2)>>2]+100>>2]=2,f=f+1|0,r=r+1|0,(h|0)!=(r|0););}_:{if(i[s+2544>>2]<=0)break _;G=s+2884|0,V=s+2564|0,o=0;v:{for(;;){B:{A=o<<2,r=A+G|0,A=A+V|0,f=Te(n,i[A>>2],Y,0),i[r>>2]=f;m:{if((f|0)>=0){t[i[m+8>>2]+f|0]=1;break m}if(f=v3(s,i[s+1376>>2],i[A>>2],0),(f|0)<0)break v;i[r>>2]=f,l=i[s+2152>>2]-i[s+2148>>2]>>2,r=i[m+12>>2],A=i[m+8>>2],h=r-A|0;g:{if(l>>>0>h>>>0){if(w=l-h|0,E=i[m+16>>2],w>>>0<=E-r>>>0){w&&l0(r,0,w),i[m+12>>2]=r+w;break g}if((l|0)<0)break B;if(r=E-A|0,E=r<<1,E=r>>>0>=1073741823?2147483647:l>>>0<E>>>0?E:l,r=C(E),w&&l0(r+h|0,0,w),h&&z(r,A,h),i[m+16>>2]=r+E,i[m+12>>2]=r+l,i[m+8>>2]=r,!A){A=r;break g}Z(A),A=r;break g}if(l>>>0>=h>>>0)break g;i[m+12>>2]=A+l}t[A+f|0]=1}if(u[i[i[s+2148>>2]+(f<<2)>>2]+312|0]&&(t[i[s+2216>>2]+312|0]=4),o=o+1|0,(o|0)<i[s+2544>>2])continue;break _}break}break i}f=0-f|0;break w}_:{if(i[s+2548>>2]<=0)break _;G=s+2948|0,V=s+2628|0,o=0;v:{for(;;){B:{A=o<<2,r=A+G|0,A=A+V|0,f=Te(n,i[A>>2],Y,0),i[r>>2]=f;m:{if((f|0)>=0){t[i[m+8>>2]+f|0]=1;break m}if(f=v3(s,i[s+1376>>2],i[A>>2],0),(f|0)<0)break v;i[r>>2]=f,l=i[s+2152>>2]-i[s+2148>>2]>>2,r=i[m+12>>2],A=i[m+8>>2],h=r-A|0;g:{if(l>>>0>h>>>0){if(w=l-h|0,E=i[m+16>>2],w>>>0<=E-r>>>0){w&&l0(r,0,w),i[m+12>>2]=r+w;break g}if((l|0)<0)break B;if(r=E-A|0,E=r<<1,E=r>>>0>=1073741823?2147483647:l>>>0<E>>>0?E:l,r=C(E),w&&l0(r+h|0,0,w),h&&z(r,A,h),i[m+16>>2]=r+E,i[m+12>>2]=r+l,i[m+8>>2]=r,!A){A=r;break g}Z(A),A=r;break g}if(l>>>0>=h>>>0)break g;i[m+12>>2]=A+l}t[A+f|0]=1}if(u[i[i[s+2148>>2]+(f<<2)>>2]+312|0]&&(t[i[s+2216>>2]+312|0]=4),o=o+1|0,(o|0)<i[s+2548>>2])continue;break _}break}break i}f=0-f|0;break w}if(i[s+2552>>2]>0)for(r=s+3012|0,l=s+2692|0,f=0;o=f<<2,A=Te(n,i[o+l>>2],Y,0),i[r+o>>2]=A,(A|0)>=0&&(t[A+i[m+8>>2]|0]=1),f=f+1|0,(f|0)<i[s+2552>>2];);_:{if(A=i[s+2152>>2],Y=i[s+2148>>2],(A-Y|0)<=0)break _;V=i[m+8>>2],E=i[m+12>>2]-V|0,f=0,n=i[m+24>>2],w=i[m+28>>2],o=i[m+20>>2];v:{for(;;){B:{if(u[f+V|0]&&f>>>0<E>>>0||(h=i[(f<<2)+Y>>2],r=i[s+2216>>2],(h|0)==(r|0)|o0[h+108>>2]<=o0[r>>2]|!i[h+100>>2]))break B;l=i[h>>2];m:{if(n>>>0<w>>>0){i[n>>2]=l,n=n+4|0;break m}if(r=n-o|0,Q=r>>2,n=Q+1|0,n>>>0>=1073741824)break v;if(w=w-o|0,G=w>>1,w=w>>>0>=2147483644?1073741823:n>>>0<G>>>0?G:n,w){if(w>>>0>=1073741824)break e;n=C(w<<2)}else n=0;G=n+r|0,i[G>>2]=l,l=G-(Q<<2)|0,r&&z(l,o,r),w=n+(w<<2)|0,i[m+28>>2]=w,i[m+20>>2]=l,n=G+4|0,o&&(Z(o),Y=i[s+2148>>2],A=i[s+2152>>2]),o=l}i[m+24>>2]=n,i[h+108>>2]=i[i[s+2216>>2]>>2]}if(f=f+1|0,!((f|0)<A-Y>>2))break}break _}s0(),M()}if(f=0,A=k+1352|0,(A|0)==(m+20|0))break w;l=A,A=i[m+20>>2],r=i[m+24>>2],h1(l,A,r,r-A>>2)}A=i[m+8>>2],A&&(i[m+12>>2]=A,Z(A)),A=i[m+20>>2],A&&(i[m+24>>2]=A,Z(A)),v=m+32|0;break h}if(i[B+8>>2]=f,!f)break s;r=0;break l}if(i[s+2216>>2])break u;r=0;break l}A=i[s+2216>>2],i[A+100>>2]=1,i[33128]=i[A+96>>2],t[s+2200|0]=0}r=1;u:{if(o0[k+28>>2]>1)break u;A=0,n=v-480|0,v=n,l=i[k+336>>2],o=i[k+920>>2],l0(n,0,96),w=s+3076|0,m=s+2948|0,Y=s+2884|0,f=(l|0)>(o|0)?l:o,h=f-1|0,N=i[s+2556>>2],G=N-1|0,x=i[s+2548>>2],V=x-1|0,Q=i[s+2544>>2],E=Q-1|0,d=(Q|0)<=0;s:{h:{w:{_:{v:{for(;;){if((A|0)>=(f|0))break v;if(d||(Q=h-A|0,Q=Q>>>0<E>>>0?Q:E,R=(Q<<2)+4|0,R&&z((n+288|0)+(A<<2)|0,Y,R),A=(A+Q|0)+1|0),(x|0)<=0|(A|0)>=(f|0)||(Q=h-A|0,Q=V>>>0>Q>>>0?Q:V,R=(Q<<2)+4|0,R&&z((n+288|0)+(A<<2)|0,m,R),A=(A+Q|0)+1|0),(N|0)<=0|(A|0)>=(f|0)||(Q=h-A|0,R=G>>>0>Q>>>0?Q:G,Q=R+1|0,Q&&l0(A+n|0,1,Q),R=(R<<2)+4|0,R&&z((n+288|0)+(A<<2)|0,w,R),A=A+Q|0),!A)break}if(A=i[s+84>>2],(A|0)==20){i[s+80>>2]=1001,f=0;break _}i[s+84>>2]=A+1,i[(s+(A<<2)|0)+4>>2]=1016,f=0;break _}if((l|0)>16)break w;if((l|0)>0)for(V=k+1180|0,E=k+1052|0,Q=k+1308|0,N=k+924|0,x=k+346|0,A=0,d=u[k+344|0];;){if(h=A<<2,G=h+N|0,f=d?u[A+x|0]:A,i[G>>2]=i[(n+288|0)+(f<<2)>>2],t[A+Q|0]=u[f+n|0],f=0,G=i[G>>2],R=i[s+2148>>2],G>>>0>=i[s+2152>>2]-R>>2>>>0||(G=i[R+(G<<2)>>2],!G))break _;if(i[h+E>>2]=i[G+96>>2],i[h+V>>2]=i[G+100>>2],A=A+1|0,(l|0)==(A|0))break}if(f=1,i[k+28>>2])break _;N=i[s+2556>>2],h=N-1|0,x=i[s+2544>>2],G=x-1|0,Q=i[s+2548>>2],V=Q-1|0,l=i[k+340>>2],f=(l|0)>(o|0)?l:o,o=f-1|0,E=n+48|0,A=0,d=(Q|0)<=0;v:{for(;;){if((A|0)>=(f|0))break v;if(d||(Q=o-A|0,Q=V>>>0>Q>>>0?Q:V,R=(Q<<2)+4|0,R&&z((n+96|0)+(A<<2)|0,m,R),A=(A+Q|0)+1|0),(x|0)<=0|(A|0)>=(f|0)||(Q=o-A|0,Q=G>>>0>Q>>>0?Q:G,R=(Q<<2)+4|0,R&&z((n+96|0)+(A<<2)|0,Y,R),A=(A+Q|0)+1|0),(N|0)<=0|(A|0)>=(f|0)||(Q=o-A|0,R=h>>>0>Q>>>0?Q:h,Q=R+1|0,Q&&l0(A+E|0,1,Q),R=(R<<2)+4|0,R&&z((n+96|0)+(A<<2)|0,w,R),A=A+Q|0),!A)break}if(A=i[s+84>>2],(A|0)==20){i[s+80>>2]=1001,f=0;break _}i[s+84>>2]=A+1,i[(s+(A<<2)|0)+4>>2]=1016,f=0;break _}if((l|0)>16)break h;if(f=1,(l|0)<=0)break _;for(w=k+1244|0,m=k+1116|0,Y=k+1324|0,G=k+988|0,V=k+362|0,A=0,Q=u[k+345|0];;){if(o=A<<2,h=o+G|0,f=Q?u[A+V|0]:A,i[h>>2]=i[(n+96|0)+(f<<2)>>2],t[A+Y|0]=u[f+E|0],f=0,h=i[h>>2],N=i[s+2148>>2],h>>>0>=i[s+2152>>2]-N>>2>>>0||(h=i[N+(h<<2)>>2],!h))break _;if(i[o+m>>2]=i[h+96>>2],i[o+w>>2]=i[h+100>>2],f=1,A=A+1|0,(l|0)==(A|0))break}}v=n+480|0;break s}U0(22967,19835,1802,4863),M()}U0(22934,19835,1855,4863),M()}if(f)break u;r=0;break l}i[k+808>>2]=i[(u[k+20|0]?i[s+2220>>2]+808|0:k+24|0)>>2],i[s+2220>>2]=k}if(v=I+80|0,f=i[s+2216>>2],!r){f&&(t[f+312|0]=2),H4(s+548|0,O),A=i[k+1352>>2],A&&(i[k+1356>>2]=A,Z(A)),l6(j),A=i[k+784>>2],A&&(i[k+788>>2]=A,Z(A)),A=i[k+8>>2];l:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break l;W[i[i[A>>2]+8>>2]](A),y(A)}Z(k),r=i[B+8>>2];break o}A=i[f+56>>2],r=i[f+52>>2],n=A-r|0,o=n>>2,i[k>>2]=o;l:{if(l=i[f+60>>2],l>>>0>A>>>0){i[A>>2]=k,i[f+56>>2]=A+4;break l}u:{if(A=o+1|0,A>>>0<1073741824){if(l=l-r|0,h=l>>1,l=l>>>0>=2147483644?1073741823:A>>>0<h>>>0?h:A,l){if(l>>>0>=1073741824)break u;A=C(l<<2)}else A=0;h=A+n|0,i[h>>2]=k,o=h-(o<<2)|0,n&&z(o,r,n),i[f+60>>2]=A+(l<<2),A=h+4|0,i[f+56>>2]=A,i[f+52>>2]=o,r&&Z(r),i[f+56>>2]=A;break l}break i}break e}if(ei(_,1),Ds(_),i[k+776>>2]>0)for(l=i[_>>2]-i[O+20>>2]|0,f=i[k+784>>2],o=0;;){h=o<<2,f=i[h+f>>2],w=i[O+32>>2],A=i[O+36>>2]-w>>2;l:{for(;;){if(r=A,n=0,(r|0)<=0)break l;if(A=r-1|0,n=i[w+(A<<2)>>2],!((n|0)<(l|0)|(f|0)<(n-l|0)))break}n=r}if(f=i[k+784>>2],A=h+f|0,i[A>>2]=i[A>>2]-n,o=o+1|0,!((o|0)<i[k+776>>2]))break}l:{if(!u[k+12|0]){o=i[s+3212>>2];break l}f=C(480),fl(f+8|0),i[f+472>>2]=0,i[f+476>>2]=0,i[f+464>>2]=0,i[f+468>>2]=0,i[f+456>>2]=0,i[f+460>>2]=0,i[f+448>>2]=0,i[f+452>>2]=0,i[f+440>>2]=0,i[f+444>>2]=0,i[f+432>>2]=0,i[f+436>>2]=0,i[f+424>>2]=0,i[f+428>>2]=0,i[f>>2]=i[s+2216>>2],A=i[s+3212>>2],l=i[s+3216>>2];u:{if(A>>>0<l>>>0){i[A>>2]=f,o=A+4|0;break u}if(n=i[s+3208>>2],A=A-n|0,h=A>>2,r=h+1|0,r>>>0>=1073741824)break i;if(l=l-n|0,o=l>>1,l=l>>>0>=2147483644?1073741823:r>>>0<o>>>0?o:r,l){if(l>>>0>=1073741824)break e;r=C(l<<2)}else r=0;if(o=r+A|0,i[o>>2]=f,f=o-(h<<2)|0,A&&z(f,n,A),i[s+3216>>2]=r+(l<<2),o=o+4|0,i[s+3212>>2]=o,i[s+3208>>2]=f,!n)break u;Z(n)}i[s+3212>>2]=o}l:{if(i[s+3208>>2]!=(o|0)){if(f=C(144),t[f+36|0]=0,i[f+32>>2]=0,i[f>>2]=0,i[f+4>>2]=0,i[f+44>>2]=0,i[f+140>>2]=s,i[f+128>>2]=-1,i[f+132>>2]=0,i[f+120>>2]=0,i[f+124>>2]=-1,i[f+136>>2]=0,i[f+40>>2]=0,i[f+4>>2]=k,i[f>>2]=O,A=i[_+4>>2],i[f+8>>2]=i[_>>2],i[f+12>>2]=A,A=i[_+12>>2],i[f+16>>2]=i[_+8>>2],i[f+20>>2]=A,A=i[_+20>>2],i[f+24>>2]=i[_+16>>2],i[f+28>>2]=A,t[f+36|0]=u[s+3220|0],n=i[i[s+3212>>2]-4>>2],A=i[n+428>>2],k=i[n+432>>2],A>>>0<k>>>0){i[A>>2]=f,i[n+428>>2]=A+4;break l}if(l=i[n+424>>2],A=A-l|0,O=A>>2,r=O+1|0,r>>>0>=1073741824)break i;if(k=k-l|0,o=k>>1,k=k>>>0>=2147483644?1073741823:r>>>0<o>>>0?o:r,k){if(k>>>0>=1073741824)break e;r=C(k<<2)}else r=0;o=r+A|0,i[o>>2]=f,f=o-(O<<2)|0,A&&z(f,l,A),i[n+432>>2]=r+(k<<2),A=o+4|0,i[n+428>>2]=A,i[n+424>>2]=f,l&&Z(l),i[n+428>>2]=A;break l}H4(s+548|0,O)}Q9(s,B+7|0),r=0}v=B+16|0;break t}break n}t:switch(f-32|0){case 0:s=C(668),i[s>>2]=67368,i[s+4>>2]=0,i[s+8>>2]=0,r=s+12|0,l0(r,0,656),l=A,_=A+4|0,k=S+8|0,A=G0(k,4),i[r>>2]=A,n=8;o:{l:{u:{s:{if((A|0)>15||(ei(k,2),A=G0(k,6),i[r+4>>2]=A+1,(A|0)>62)||(A=G0(k,3),i[r+8>>2]=A+1,(A|0)>6))break s;if(r0=r,f0=G0(k,1),i[r0+12>>2]=f0,ei(k,16),Ol(r+16|0,k,i[r+8>>2]),A=G0(k,1),i[r+484>>2]=A,o=i[r+8>>2],f=A?0:o-1|0,(f|0)<(o|0)){for(B=r+488|0,A=f;;){if(o=B+g(A,12)|0,r0=o,f0=k2(k),i[r0>>2]=f0,r0=o,f0=k2(k),i[r0+4>>2]=f0,h=k2(k),i[o+8>>2]=h,i[o>>2]==-99999|(h|0)==-99999|i[o+4>>2]==-99999)break s;if(A=A+1|0,!((A|0)<i[r+8>>2]))break}A=i[r+484>>2]}h:{if(A)break h;if((f|0)>7)break u;if((f|0)<=0||(o=(r+488|0)+g(f,12)|0,A=i[o>>2],n=i[o+4>>2],o=i[o+8>>2],i[r+496>>2]=o,i[r+492>>2]=n,i[r+488>>2]=A,(f|0)==1)||(i[r+508>>2]=o,i[r+504>>2]=n,i[r+500>>2]=A,(f|0)==2)||(i[r+520>>2]=o,i[r+516>>2]=n,i[r+512>>2]=A,(f|0)==3)||(i[r+532>>2]=o,i[r+528>>2]=n,i[r+524>>2]=A,(f|0)==4)||(i[r+544>>2]=o,i[r+540>>2]=n,i[r+536>>2]=A,(f|0)==5)||(i[r+556>>2]=o,i[r+552>>2]=n,i[r+548>>2]=A,(f|0)==6))break h;i[r+568>>2]=o,i[r+564>>2]=n,i[r+560>>2]=A}if(r0=r,f0=G0(k,6),t[r0+584|0]=f0,A=k2(k),i[r+588>>2]=A,A-1023>>>0<=4294966271)break l;f=A+1|0,i[r+588>>2]=f,A=i[r+596>>2],n=i[r+592>>2],o=(A-n|0)/12|0;h:{if(o>>>0<f>>>0){if(n=0,f=f-o|0,h=i[r+600>>2],f>>>0<=(h-A|0)/12>>>0){f&&(f=g(f,12)-12|0,f=(f-((f>>>0)%12|0)|0)+12|0,f&&l0(A,0,f),A=A+f|0),i[r+596>>2]=A;break h}w:{if(o=A,A=i[r+592>>2],o=o-A|0,B=f+((o|0)/12|0)|0,B>>>0<357913942){if(h=(h-A|0)/12|0,w=h<<1,B=h>>>0>=178956970?357913941:w>>>0>B>>>0?w:B,B){if(B>>>0>=357913942)break w;n=C(g(B,12))}h=n+o|0,f=g(f,12)-12|0,f=(f-((f>>>0)%12|0)|0)+12|0,f&&l0(h,0,f),w=h+g((o|0)/-12|0,12)|0,o&&z(w,A,o),i[r+600>>2]=g(B,12)+n,i[r+596>>2]=f+h,i[r+592>>2]=w,A&&Z(A);break h}break i}break e}if(f>>>0>=o>>>0)break h;if(n=n+g(f,12)|0,(n|0)!=(A|0))for(;f=A-12|0,o=i[f>>2],o&&(i[A-8>>2]=o,Z(o)),A=f,(A|0)!=(n|0););i[r+596>>2]=n}if(i[r+588>>2]>=2)for(n=u[r+584|0],f=1;;){o=n+1|0,Q=n,m=g(f,12),A=m+i[r+592>>2]|0,w=i[A+4>>2],n=i[A>>2],B=w-n|0;h:{if(Q>>>0>=B>>>0){if(h=o-B|0,I=i[A+8>>2],h>>>0<=I-w>>>0){h&&l0(w,0,h),i[A+4>>2]=h+w;break h}if(w=I-n|0,I=w<<1,I=w>>>0>=1073741823?2147483647:o>>>0<I>>>0?I:o,w=C(I),h&&l0(w+B|0,0,h),B&&z(w,n,B),i[A+8>>2]=w+I,i[A+4>>2]=o+w,i[A>>2]=w,!n)break h;Z(n);break h}if(o>>>0>=B>>>0)break h;i[A+4>>2]=n+o}for(A=0;n=G0(k,1),t[i[m+i[r+592>>2]>>2]+A|0]=n,n=u[r+584|0],o=n>>>0>A>>>0,A=A+1|0,!!o;);if(f=f+1|0,!((f|0)<i[r+588>>2]))break}A=G0(k,1),t[r+604|0]=A;h:{w:{if(!(A&255)||(r0=r,f0=G0(k,32),i[r0+608>>2]=f0,r0=r,f0=G0(k,32),i[r0+612>>2]=f0,A=G0(k,1),t[r+616|0]=A,!(A&255)))break w;if(r0=r,f0=k2(k)+1|0,i[r0+620>>2]=f0,n=k2(k),i[r+624>>2]=n,n>>>0>=1024)break l;f=0,A=i[r+632>>2],B=i[r+628>>2],o=A-B>>1;_:{if(o>>>0<n>>>0){if(n=n-o|0,h=i[r+636>>2],n>>>0<=h-A>>1>>>0){n&&(f=n<<1,f&&l0(A,0,f),A=A+f|0),i[r+632>>2]=A;break _}v:{if(o=A,A=i[r+628>>2],o=o-A|0,w=o>>1,B=w+n|0,(B|0)>=0){if(h=h-A|0,B=h>>>0>=2147483646?2147483647:h>>>0>B>>>0?h:B,B){if((B|0)<0)break v;f=C(B<<1)}h=f+o|0,n=n<<1,n&&l0(h,0,n),w=h-(w<<1)|0,o&&z(w,A,o),i[r+636>>2]=(B<<1)+f,i[r+632>>2]=n+h,i[r+628>>2]=w,A&&Z(A);break _}s0(),M()}break e}n>>>0<o>>>0&&(i[r+632>>2]=B+(n<<1))}A=i[r+624>>2],B=i[r+644>>2],f=i[r+640>>2],n=B-f|0;_:{if(A>>>0>n>>>0){if(o=A-n|0,h=i[r+648>>2],o>>>0<=h-B>>>0){o&&l0(B,0,o),i[r+644>>2]=o+B;break _}if((A|0)<0)break i;if(B=h-f|0,h=B<<1,h=B>>>0>=1073741823?2147483647:A>>>0<h>>>0?h:A,B=C(h),o&&l0(n+B|0,0,o),n&&z(B,f,n),i[r+648>>2]=h+B,i[r+644>>2]=A+B,i[r+640>>2]=B,!f)break _;Z(f);break _}if(A>>>0>=n>>>0)break _;i[r+644>>2]=A+f}if(i[r+624>>2]<=0)break w;A=k2(k),X[i[r+628>>2]>>1]=A;break h}r0=r,f0=G0(k,1),t[r0+652|0]=f0}n=0}f=n;break o}U0(20953,19861,144,19528),M()}C2(_,8,0),f=8}o:{if(f)break o;if(n=i[l+520>>2],(n|0)>=0){k=v-368|0,v=k,A=73524;l:{u:switch(n-1|0){case 1:A=73520;break;case 0:break u;default:break l}if(o=i[A>>2],n0(o,47191,0),i[k+352>>2]=i[r>>2],n0(o,46082,k+352|0),i[k+336>>2]=i[r+4>>2],n0(o,46514,k+336|0),i[k+320>>2]=i[r+8>>2],n0(o,46159,k+320|0),i[k+304>>2]=i[r+12>>2],n0(o,44766,k+304|0),A=i[r+8>>2],Kr(r+16|0,1,o),(A|0)>=2)for(n=A-2|0,B=r+68|0,A=0;i[k+288>>2]=A,n0(o,46695,k+288|0),Kr(B+g(A,52)|0,0,o),h=(A|0)!=(n|0),A=A+1|0,!!h;);i[k+272>>2]=i[r+484>>2],n0(o,40207,k+272|0);u:{if(i[r+484>>2]){if(i[r+8>>2]<=0)break u;for(B=r+488|0,A=0;n=B+g(A,12)|0,i[k+260>>2]=i[n>>2],i[k+256>>2]=A,n0(o,38732,k+256|0),i[k+240>>2]=i[n+4>>2],n0(o,39023,k+240|0),i[k+224>>2]=i[n+8>>2],n0(o,39068,k+224|0),A=A+1|0,(A|0)<i[r+8>>2];);break u}i[k+208>>2]=i[r+488>>2],n0(o,38774,k+208|0),i[k+192>>2]=i[r+492>>2],n0(o,39019,k+192|0),i[k+176>>2]=i[r+496>>2],n0(o,39064,k+176|0)}if(i[k+160>>2]=u[r+584|0],n0(o,39109,k+160|0),i[k+144>>2]=i[r+588>>2],n0(o,38679,k+144|0),i[r+588>>2]>=2)for(n=1;;){for(A=0,B=g(n,12);i[k+136>>2]=t[i[B+i[r+592>>2]>>2]+A|0],i[k+132>>2]=A,i[k+128>>2]=n,n0(o,38982,k+128|0),h=u[r+584|0]>A>>>0,A=A+1|0,!!h;);if(n=n+1|0,!((n|0)<i[r+588>>2]))break}i[k+112>>2]=t[r+604|0],n0(o,38819,k+112|0);u:{if(!u[r+604|0]||(i[k+96>>2]=i[r+608>>2],n0(o,38704,k+96|0),i[k+80>>2]=i[r+612>>2],n0(o,39167,k+80|0),i[k+64>>2]=t[r+616|0],n0(o,38879,k- -64|0),!u[r+616|0])||(i[k+48>>2]=i[r+620>>2],n0(o,38921,k+48|0),i[k+32>>2]=i[r+624>>2],n0(o,39134,k+32|0),i[r+624>>2]<=0))break u;i[k+20>>2]=p[i[r+628>>2]>>1],i[k+16>>2]=0,n0(o,38954,k+16|0);break l}i[k>>2]=t[r+652|0],n0(o,38854,k)}v=k+368|0}if(i[s+4>>2]=i[s+4>>2]+1,n=l+(i[s+12>>2]<<3)|0,i[n+600>>2]=r,A=i[n+604>>2],i[n+604>>2]=s,!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break o;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[s+4>>2],i[s+4>>2]=A-1,A||(W[i[i[s>>2]+8>>2]](s),y(s)),r=f,H4(l+548|0,O);break n;case 1:B=C(17016),i[B>>2]=67484,i[B+4>>2]=0,i[B+8>>2]=0,h=A+4|0,k=B+12|0,i[k+8824>>2]=0,i[k+8816>>2]=0,i[k+8820>>2]=0,r=k+9e3|0,X[r+2>>1]=0,X[r+4>>1]=0,t[r|0]=0,t[r+21|0]=0,t[r+22|0]=0,t[r+23|0]=0,t[r+24|0]=0,t[r+25|0]=0,t[r+26|0]=0,t[r+27|0]=0,t[r+28|0]=0,t[r+20|0]=2,i[r+12>>2]=5,i[r+16>>2]=33685504,i[r+48>>2]=0,i[r+52>>2]=0,X[r+7810>>1]=258,X[r+7812>>1]=3855,X[r+7808>>1]=0,i[r+7804>>2]=65536,t[r+64|0]=0,i[r+60>>2]=1,t[r+5|0]=0,t[r+6|0]=0,t[r+7|0]=0,t[r+8|0]=0,t[r+29|0]=0,t[r+30|0]=0,t[r+31|0]=0,t[r+32|0]=0,t[r+33|0]=0,t[r+34|0]=0,t[r+35|0]=0,t[r+36|0]=0,t[r+37|0]=0,t[r+38|0]=0,t[r+39|0]=0,t[r+40|0]=0,t[r+41|0]=0,t[r+42|0]=0,t[r+43|0]=0,t[r+44|0]=0,t[r+56|0]=0,t[k+16828|0]=0,i[k+16820>>2]=0,i[k+16824>>2]=0,t[k|0]=0,l=S+8|0,r0=k,f0=G0(l,4),t[r0+1|0]=f0,r=G0(l,3)+1|0,t[k+2|0]=r,n=8;o:{if(r<<24>>24>7)break o;r0=k,f0=G0(l,1),t[r0+3|0]=f0,Ol(k+4|0,l,t[k+2|0]);l:{u:{s:{if(r=k2(l),(r|0)==-99999)break s;if(i[k+472>>2]=r,(r|0)>15)break o;if(o=k2(l),(o|0)==-99999)break s;if(i[k+476>>2]=o,(o|0)==3&&(s=G0(l,1),o=i[k+476>>2]),t[k+480|0]=s,o>>>0>=4){C2(h,1019,0);break o}if(r=k2(l),(r|0)==-99999||(i[k+484>>2]=r,r=k2(l),(r|0)==-99999))break s;if(i[k+488>>2]=r,!r||(f=i[k+484>>2],!f|(r|0)>65535|(f|0)>65535))break o;r=G0(l,1),t[k+492|0]=r;h:{if(r&255){if(r=k2(l),(r|0)==-99999||(i[k+496>>2]=r,r=k2(l),(r|0)==-99999)||(i[k+500>>2]=r,r=k2(l),(r|0)==-99999)||(i[k+504>>2]=r,r=k2(l),(r|0)==-99999))break s;i[k+508>>2]=r;break h}i[k+496>>2]=0,i[k+500>>2]=0,i[k+504>>2]=0,i[k+508>>2]=0}if(r=k2(l),(r|0)==-99999||(i[k+512>>2]=r+8,r=k2(l),(r|0)==-99999))break s;if(i[k+516>>2]=r+8,!(i[k+512>>2]<17&(r|0)<=8))break u;if(r=k2(l),(r|0)==-99999)break s;if(f=r+4|0,i[k+520>>2]=f,r>>>0>=13)break u;if(i[k+16868>>2]=1<<f,r=G0(l,1),t[k+524|0]=r,o=t[k+2|0],n=r&255?0:o-1|0,(n|0)<(o|0)){for(s=k+16964|0,w=k+584|0,_=k+556|0,m=k+528|0;;){if(f=k2(l),!((f|0)!=-99999&(f|0)<16)||(r=n<<2,i[r+m>>2]=f+1,f=k2(l),(f|0)==-99999)||(o=r+_|0,i[o>>2]=f,f=k2(l),(f|0)==-99999))break s;if(i[r+w>>2]=f,i[r+s>>2]=(f+i[o>>2]|0)-1,o=t[k+2|0],n=n+1|0,!((o|0)>(n|0)))break}r=u[k+524|0]}h:{w:{if(!(r&255))break w;if((o|0)>7)break h;if((o|0)<2||(r=o-1|0,o=r<<2,f=o+(k+528|0)|0,i[k+528>>2]=i[f>>2],n=o+(k+556|0)|0,i[k+556>>2]=i[n>>2],o=o+(k+584|0)|0,i[k+584>>2]=i[o>>2],(r|0)==1)||(i[k+532>>2]=i[f>>2],i[k+560>>2]=i[n>>2],i[k+588>>2]=i[o>>2],(r|0)==2)||(i[k+536>>2]=i[f>>2],i[k+564>>2]=i[n>>2],i[k+592>>2]=i[o>>2],(r|0)==3)||(i[k+540>>2]=i[f>>2],i[k+568>>2]=i[n>>2],i[k+596>>2]=i[o>>2],(r|0)==4)||(i[k+544>>2]=i[f>>2],i[k+572>>2]=i[n>>2],i[k+600>>2]=i[o>>2],(r|0)==5))break w;i[k+548>>2]=i[f>>2],i[k+576>>2]=i[n>>2],i[k+604>>2]=i[o>>2]}if(r=k2(l),(r|0)==-99999||(i[k+612>>2]=r+3,r=k2(l),(r|0)==-99999)||(i[k+616>>2]=r,r=k2(l),(r|0)==-99999)||(i[k+620>>2]=r+2,r=k2(l),(r|0)==-99999)||(i[k+624>>2]=r,r=k2(l),(r|0)==-99999)||(i[k+628>>2]=r,r=k2(l),(r|0)==-99999))break s;if(i[k+632>>2]=r,n=8,r=i[k+612>>2],(r|0)>6|(r+i[k+616>>2]|0)>6||(r=i[k+620>>2],(r|0)>5|(r+i[k+624>>2]|0)>5))break o;r=G0(l,1),t[k+636|0]=r;w:{if(!(r&255))break w;if(f=G0(l,1),t[k+637|0]=f,r=k+638|0,f&255){if(n=nn(l,r),!n)break w;break o}for(n=0,D8(r,114288,0),D8(r+16|0,114288,0),D8(r+32|0,114288,0),D8(r+48|0,114288,0),D8(r- -64|0,114288,0),D8(r+80|0,114288,0),o=r+96|0,s=i[i[17266]+12>>2];f=s+(n<<1)|0,t[(o+(u[f+1|0]<<3)|0)+u[f|0]|0]=u[n+114304|0],t[u[f+2|0]+(o+(u[f+3|0]<<3)|0)|0]=u[n+114305|0],n=n+2|0,(n|0)!=64;);for(o=r+288|0,n=0,s=i[i[17266]+12>>2];f=s+(n<<1)|0,t[(o+(u[f+1|0]<<3)|0)+u[f|0]|0]=u[n+114368|0],t[u[f+2|0]+(o+(u[f+3|0]<<3)|0)|0]=u[n+114369|0],n=n+2|0,(n|0)!=64;);for(o=r+160|0,n=0,s=i[i[17266]+12>>2];f=s+(n<<1)|0,t[(o+(u[f+1|0]<<3)|0)+u[f|0]|0]=u[n+114304|0],t[u[f+2|0]+(o+(u[f+3|0]<<3)|0)|0]=u[n+114305|0],n=n+2|0,(n|0)!=64;);for(o=r+352|0,n=0,s=i[i[17266]+12>>2];f=s+(n<<1)|0,t[(o+(u[f+1|0]<<3)|0)+u[f|0]|0]=u[n+114368|0],t[u[f+2|0]+(o+(u[f+3|0]<<3)|0)|0]=u[n+114369|0],n=n+2|0,(n|0)!=64;);for(o=r+224|0,n=0,s=i[i[17266]+12>>2];f=s+(n<<1)|0,t[(o+(u[f+1|0]<<3)|0)+u[f|0]|0]=u[n+114304|0],t[u[f+2|0]+(o+(u[f+3|0]<<3)|0)|0]=u[n+114305|0],n=n+2|0,(n|0)!=64;);for(o=r+416|0,n=0,s=i[i[17266]+12>>2];f=s+(n<<1)|0,t[(o+(u[f+1|0]<<3)|0)+u[f|0]|0]=u[n+114368|0],t[u[f+2|0]+(o+(u[f+3|0]<<3)|0)|0]=u[n+114369|0],n=n+2|0,(n|0)!=64;);for(o=r+481|0,s=r+480|0,n=0,w=i[i[17266]+12>>2];f=w+(n<<1)|0,_=n+114304|0,m=u[_|0],t[(s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,t[(o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,_=u[_|0],t[((s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,t[((o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(o=r+1249|0,s=r+1248|0,n=0,w=i[i[17266]+12>>2];f=w+(n<<1)|0,_=n+114368|0,m=u[_|0],t[(s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,t[(o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,_=u[_|0],t[((s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,t[((o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(o=r+737|0,s=r+736|0,n=0,w=i[i[17266]+12>>2];f=w+(n<<1)|0,_=n+114304|0,m=u[_|0],t[(s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,t[(o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,_=u[_|0],t[((s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,t[((o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(o=r+1505|0,s=r+1504|0,n=0,w=i[i[17266]+12>>2];f=w+(n<<1)|0,_=n+114368|0,m=u[_|0],t[(s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,t[(o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,_=u[_|0],t[((s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,t[((o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(o=r+993|0,s=r+992|0,n=0,w=i[i[17266]+12>>2];f=w+(n<<1)|0,_=n+114304|0,m=u[_|0],t[(s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,t[(o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,_=u[_|0],t[((s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,t[((o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(o=r+1761|0,s=r+1760|0,n=0,w=i[i[17266]+12>>2];f=w+(n<<1)|0,_=n+114368|0,m=u[_|0],t[(s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,t[(o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0]=m,_=u[_|0],t[((s+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,t[((o+(u[f|0]<<1)|0)+(u[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);D8(r+2016|0,114304,3),D8(r+3040|0,114368,3)}r0=k,f0=G0(l,1),t[r0+8798|0]=f0,r0=k,f0=G0(l,1),t[r0+8799|0]=f0,r=G0(l,1),t[k+8800|0]=r;w:{if(r&255){if(r0=k,f0=G0(l,4)+1|0,t[r0+8801|0]=f0,r0=k,f0=G0(l,4)+1|0,t[r0+8802|0]=f0,r=k2(l),(r|0)==-99999||(i[k+8804>>2]=r+3,r=k2(l),(r|0)==-99999))break s;if(i[k+8808>>2]=r,r0=k,f0=G0(l,1),t[r0+8812|0]=f0,i[k+512>>2]<t[k+8801|0])break l;if(i[k+516>>2]>=t[k+8802|0])break w;break l}i[k+8804>>2]=0,i[k+8808>>2]=0,t[k+8801|0]=0,t[k+8802|0]=0,t[k+8812|0]=0}if(n=k2(l),(n|0)==-99999)break s;if(n>>>0>=65){C2(h,1014,0),n=8;break o}s=0,r=k+8816|0,f=i[r+4>>2],w=i[r>>2],o=(f-w|0)/100|0;w:{if(o>>>0<n>>>0){if(o=n-o|0,m=i[r+8>>2],o>>>0<=(m-f|0)/100>>>0){o&&(o=g(o,100)-100|0,o=(o-((o>>>0)%100|0)|0)+100|0,o&&l0(f,0,o),f=f+o|0),i[r+4>>2]=f;break w}_:{if(Q=f,f=i[r>>2],w=Q-f|0,_=o+((w|0)/100|0)|0,_>>>0<42949673){if(m=(m-f|0)/100|0,I=m<<1,_=m>>>0>=21474836?42949672:_>>>0<I>>>0?I:_,_){if(_>>>0>=42949673)break _;s=C(g(_,100))}m=s+w|0,o=g(o,100)-100|0,o=(o-((o>>>0)%100|0)|0)+100|0,o&&l0(m,0,o),I=m+g((w|0)/-100|0,100)|0,w&&z(I,f,w),i[r+8>>2]=g(_,100)+s,i[r+4>>2]=o+m,i[r>>2]=I,f&&Z(f);break w}break i}break e}n>>>0<o>>>0&&(i[r+4>>2]=w+g(n,100))}w:{if(!n)break w;for(o=0;;){if(Zn(h,k,l,i[k+8816>>2]+g(o,100)|0,o,r,0)){if(o=o+1|0,(n|0)!=(o|0))continue;break w}break}n=1005;break o}r=G0(l,1),t[k+8828|0]=r;w:{if(r&255){if(r=k2(l),(r|0)==-99999)break s;if(i[k+8832>>2]=r,n=8,(r|0)>32)break o;if((r|0)<=0)break w;for(r=k+8964|0,f=k+8836|0,o=0;r0=f+(o<<2)|0,f0=G0(l,i[k+520>>2]),i[r0>>2]=f0,r0=r+o|0,f0=G0(l,1),t[r0|0]=f0,o=o+1|0,(o|0)<i[k+8832>>2];);break w}i[k+8832>>2]=0}if(r0=k,f0=G0(l,1),t[r0+8996|0]=f0,r0=k,f0=G0(l,1),t[r0+8997|0]=f0,r=G0(l,1),t[k+8998|0]=r,r&255){n=0,r=k+9e3|0,f=G0(l,1),t[r|0]=(f|0)!=0;w:{if(f){if(f=G0(l,8),(f|0)<=17){f=f<<2,X[r+2>>1]=p[f+69872>>1],n=p[f+69874>>1];break w}if((f|0)==255){r0=r,f0=G0(l,16),X[r0+2>>1]=f0,n=G0(l,16);break w}}X[r+2>>1]=0}X[r+4>>1]=n,f=G0(l,1),t[r+6|0]=(f|0)!=0,f&&(r0=r,f0=(G0(l,1)|0)!=0,t[r0+7|0]=f0),t[r+20|0]=2,X[r+18>>1]=514,t[r+16|0]=0,i[r+12>>2]=5,f=G0(l,1),t[r+8|0]=(f|0)!=0;w:{if(!f||(f=G0(l,3),i[r+12>>2]=(f|0)>=5?5:f,r0=r,f0=(G0(l,1)|0)!=0,t[r0+16|0]=f0,f=G0(l,1),t[r+17|0]=(f|0)!=0,!f))break w;f=G0(l,8),t[r+18|0]=f;_:{v:{B:switch(f=f&255,f|0){case 0:case 3:break v;default:break B}if(f>>>0<11)break _}t[r+18|0]=2}f=G0(l,8),t[r+19|0]=f;_:{v:switch(f&255){default:if((f&254)>>>0<18)break _;break;case 0:case 3:break v}t[r+19|0]=2}f=G0(l,8),t[r+20|0]=(f&255)>>>0>10?2:f}n=0,f=G0(l,1),t[r+21|0]=(f|0)!=0;w:{_:{v:{if(f){if(f=k2(l),(f|0)==-99999)break _;if(t[r+22|0]=f,n=k2(l),(n|0)!=-99999)break v;break _}t[r+22|0]=0}t[r+23|0]=n,r0=r,f0=(G0(l,1)|0)!=0,t[r0+24|0]=f0,r0=r,f0=(G0(l,1)|0)!=0,t[r0+25|0]=f0,r0=r,f0=(G0(l,1)|0)!=0,t[r0+26|0]=f0,f=G0(l,1),t[r+27|0]=(f|0)!=0;v:{if(f){if(f=k2(l),(f|0)==-99999||(i[r+28>>2]=f,f=k2(l),(f|0)==-99999)||(i[r+32>>2]=f,f=k2(l),(f|0)==-99999)||(i[r+36>>2]=f,f=k2(l),(f|0)==-99999))break _;i[r+40>>2]=f;break v}i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0}f=G0(l,1),t[r+44|0]=(f|0)!=0;v:{B:{if(!f)break B;if(r0=r,f0=G0(l,32),i[r0+48>>2]=f0,r0=r,f0=G0(l,32),i[r0+52>>2]=f0,f=G0(l,1),t[r+56|0]=(f|0)!=0,f){if(f=k2(l),(f|0)==-99999)break _;i[r+60>>2]=f+1}if(f=G0(l,1),t[r+64|0]=(f|0)!=0,!f)break B;s=0,r0=r,f0=(G0(l,1)|0)!=0,t[r0+65|0]=f0,f=G0(l,1),t[r+66|0]=(f|0)!=0,f|t[r+65|0]&1&&(f=G0(l,1),t[r+67|0]=(f|0)!=0,f&&(r0=r,f0=G0(l,8),i[r0+68>>2]=f0,r0=r,f0=G0(l,5),i[r0+72>>2]=f0,r0=r,f0=(G0(l,1)|0)!=0,t[r0+76|0]=f0,r0=r,f0=G0(l,5),i[r0+80>>2]=f0),r0=r,f0=G0(l,4),i[r0+84>>2]=f0,r0=r,f0=G0(l,4),i[r0+88>>2]=f0,u[r+67|0]==1&&(r0=r,f0=G0(l,4),i[r0+92>>2]=f0),r0=r,f0=G0(l,5),i[r0+96>>2]=f0,r0=r,f0=G0(l,5),i[r0+100>>2]=f0,r0=r,f0=G0(l,5),i[r0+104>>2]=f0),n=0;m:{if(t[k+2|0]<=0)break m;Y=r+7357|0,G=r+5568|0,V=r+3776|0,j=r+1984|0,E=r+192|0,Q=r+7356|0,N=r+5564|0,x=r+3772|0,d=r+1980|0,R=r+188|0,A0=r+160|0,_=r+132|0,m=r+122|0,I=r+115|0,g0=r+108|0;g:{for(;;){Z:{f=G0(l,1),t[s+g0|0]=(f|0)!=0;W:{X:{V:{I:{if(f){t[s+I|0]=1,n=s+m|0,t[n|0]=0,f=_+(s<<2)|0,i[f>>2]=0;break I}if(o=G0(l,1),t[s+I|0]=(o|0)!=0,n=s+m|0,t[n|0]=0,f=_+(s<<2)|0,i[f>>2]=0,!o)break V}if(o=k2(l),(o|0)==-99999)break Z;if(i[A0+(s<<2)>>2]=o,t[n|0]&1)break W;break X}if(o=n,n=G0(l,1),t[o|0]=(n|0)!=0,n)break W}if(n=k2(l),(n|0)==-99999)break Z;if(i[f>>2]=n,n>>>0<=31)break W;n=8;break m}if(n=0,t[r+65|0]&1)for(;;){if(q=k2(l),(q|0)==-99999||(w=n<<3,o=s<<8,i[w+(o+R|0)>>2]=q,q=k2(l),(q|0)==-99999))break Z;if(i[w+(o+d|0)>>2]=q,u[r+67|0]==1){if(q=k2(l),(q|0)==-99999||(i[w+(o+x|0)>>2]=q,q=k2(l),(q|0)==-99999))break Z;i[w+(o+N|0)>>2]=q}if(r0=(Q+(s<<6)|0)+(n<<1)|0,f0=(G0(l,1)|0)!=0,t[r0|0]=f0,o=o0[f>>2]>n>>>0,n=n+1|0,!o)break}if(t[r+66|0]&1)for(w=Y+(s<<6)|0,n=s<<8,q=n+G|0,_0=n+V|0,U=n+j|0,t0=n+E|0,n=0;;){if(c=k2(l),(c|0)==-99999||(o=n<<3,i[o+t0>>2]=c,c=k2(l),(c|0)==-99999))break Z;if(i[o+U>>2]=c,u[r+67|0]==1){if(c=k2(l),(c|0)==-99999||(i[o+_0>>2]=c,c=k2(l),(c|0)==-99999))break Z;i[o+q>>2]=c}if(r0=w+(n<<1)|0,f0=(G0(l,1)|0)!=0,t[r0|0]=f0,o=o0[f>>2]>n>>>0,n=n+1|0,!o)break}if(n=0,s=s+1|0,(s|0)<t[k+2|0])continue;break g}break}n=8,C2(h,8,0)}}if(n)break v}if(f=G0(l,1),t[r+7804|0]=(f|0)!=0,f){if(r0=r,f0=(G0(l,1)|0)!=0,t[r0+7805|0]=f0,r0=r,f0=(G0(l,1)|0)!=0,t[r0+7806|0]=f0,r0=r,f0=(G0(l,1)|0)!=0,t[r0+7807|0]=f0,f=k2(l),(f|0)==-99999||(X[r+7808>>1]=f,f&61440&&(C2(h,8,0),X[r+7808>>1]=0),f=k2(l),(f|0)==-99999)||(t[r+7810|0]=f,(f&255)>>>0>=17&&(C2(h,8,0),t[r+7810|0]=2),f=k2(l),(f|0)==-99999)||(t[r+7811|0]=f,(f&255)>>>0>=17&&(C2(h,8,0),t[r+7811|0]=1),f=k2(l),(f|0)==-99999)||(t[r+7812|0]=f,f&240&&(C2(h,8,0),t[r+7812|0]=15),f=k2(l),(f|0)==-99999))break _;if(t[r+7813|0]=f,n=0,!(f&240))break v;C2(h,8,0),t[r+7813|0]=15;break w}X[r+7810>>1]=258,X[r+7812>>1]=3855,n=0,X[r+7808>>1]=0,t[r+7807|0]=0,t[r+7805|0]=0,t[r+7806|0]=1}break w}C2(h,8,0),n=8}if(n)break o}r=G0(l,1),t[k+16816|0]=r;w:{if(!(r&255)){t[k+16817|0]=0;break w}if(r0=k,f0=G0(l,1),t[r0+16817|0]=f0,r0=k,f0=G0(l,1),t[r0+16818|0]=f0,r0=k,f0=G0(l,6),t[r0+16819|0]=f0,!u[k+16817|0])break w;r=k+16820|0,r0=r,f0=G0(l,1),t[r0|0]=f0,r0=r,f0=G0(l,1),t[r0+1|0]=f0,r0=r,f0=G0(l,1),t[r0+2|0]=f0,r0=r,f0=G0(l,1),t[r0+3|0]=f0,r0=r,f0=G0(l,1),t[r0+4|0]=f0,r0=r,f0=G0(l,1),t[r0+5|0]=f0,r0=r,f0=G0(l,1),t[r0+6|0]=f0,r0=r,f0=G0(l,1),t[r0+7|0]=f0,r0=r,f0=G0(l,1),t[r0+8|0]=f0}o=i[k+476>>2],r=o<<2,Y=i[r+69728>>2],i[k+16856>>2]=Y,G=i[r+69712>>2],i[k+16852>>2]=G,E=u[k+480|0];w:{if(E){i[k+16848>>2]=0,l=1,r=1;break w}i[k+16848>>2]=o,l=o?Y:1,r=o?G:1}i[k+16864>>2]=l,i[k+16860>>2]=r,h=i[k+512>>2],i[k+16832>>2]=h,w=i[k+516>>2],i[k+16840>>2]=w,_=i[k+612>>2],i[k+16872>>2]=_,n=1<<_,i[k+16880>>2]=n,Q=i[k+616>>2],m=Q+_|0,i[k+16876>>2]=m,V=i[k+488>>2],j=i[k+484>>2],i[k+16912>>2]=g(V,j),i[k+16836>>2]=g(h,6)-48,i[k+16844>>2]=g(w,6)-48,f=1<<m,i[k+16884>>2]=f,r=j-1|0,s=(r+n|0)/(n|0)|0,i[k+16888>>2]=s,I=V-1|0,N=(I+n|0)/(n|0)|0,i[k+16896>>2]=N,l=(r+f|0)/(f|0)|0,i[k+16892>>2]=l,i[k+16904>>2]=g(s,N),s=(f+I|0)/(f|0)|0,i[k+16900>>2]=s,i[k+16908>>2]=g(l,s),r=0,A0=0;w:{if(!o||(A0=0,E))break w;r=(f|0)/(G|0)|0,A0=(f|0)/(Y|0)|0}i[k+16920>>2]=A0,i[k+16916>>2]=r,r=i[k+620>>2],i[k+16936>>2]=r,I=r+i[k+624>>2]|0,i[k+16940>>2]=I;w:{_:{if(f=m-r|0,(f|0)<i[k+628>>2]){r4(38331,70,1,i[18380]);break _}if((f|0)<i[k+632>>2]){r4(38402,70,1,i[18380]);break _}i[k+16944>>2]=_-1,o=i[k+8804>>2],i[k+16956>>2]=o,Y=s<<f,i[k+16928>>2]=Y,f=l<<f,i[k+16924>>2]=f,A0=s,s=Q+1|0,i[k+16952>>2]=A0<<s,i[k+16948>>2]=l<<s,i[k+16960>>2]=o+i[k+8808>>2],i[k+16932>>2]=g(f,Y);v:{if(u[k+16826|0]){s=1<<w-1,l=1<<h-1,o=0,f=0;break v}l=128,s=128,o=w-8|0,f=h-8|0}if(i[k+17e3>>2]=s,i[k+16996>>2]=l,t[k+16993|0]=o,t[k+16992|0]=f,n-1&(V|j)){r4(37946,24,1,i[18380]);break _}if((r|0)>(_|0)){r4(46833,19,1,i[18380]);break _}if((I|0)>(((m|0)>=5?5:m)|0)){r4(46802,30,1,i[18380]);break _}if(h-17>>>0<=4294967286){r4(46728,36,1,i[18380]);break _}if(w-17>>>0<=4294967286){r4(46765,36,1,i[18380]);break _}t[k|0]=1,n=0;break w}n=8}if(n)break o;t[k|0]=1,n=0;break o}U0(22921,19868,320,19528),M()}C2(h,8,0),n=8;break o}C2(h,1005,0);break o}C2(h,1027,0),n=8}if(l=n,!n){if(s=i[A+516>>2],(s|0)>=0){r=v-928|0,v=r,o=73524;o:{l:switch(s-1|0){case 1:o=73520;break;case 0:break l;default:break o}if(f=i[o>>2],n0(f,47232,0),i[r+912>>2]=t[k+1|0],n0(f,42112,r+912|0),i[r+896>>2]=t[k+2|0],n0(f,43369,r+896|0),i[r+880>>2]=t[k+3|0],n0(f,40588,r+880|0),l=t[k+2|0],n=v-16|0,v=n,o=k+4|0,Kr(o,1,f),(l|0)>=2)for(l=l-2|0,h=o+52|0,o=0;i[n>>2]=o,n0(f,46695,n),Kr(h+g(o,52)|0,0,f),w=(l|0)==(o|0),o=o+1|0,!w;);v=n+16|0,i[r+864>>2]=i[k+472>>2],n0(f,42914,r+864|0),n=i[k+476>>2];l:{if(n>>>0>=3){l=(n|0)==3?23184:8706;break l}l=i[(n<<2)+69744>>2]}if(i[r+852>>2]=l,i[r+848>>2]=n,n0(f,47544,r+848|0),i[k+476>>2]==3&&(i[r+832>>2]=t[k+480|0],n0(f,40665,r+832|0)),i[r+816>>2]=i[k+484>>2],n0(f,41937,r+816|0),i[r+800>>2]=i[k+488>>2],n0(f,39896,r+800|0),i[r+784>>2]=t[k+492|0],n0(f,42725,r+784|0),u[k+492|0]&&(i[r+768>>2]=i[k+496>>2],n0(f,41848,r+768|0),i[r+752>>2]=i[k+500>>2],n0(f,39801,r+752|0),i[r+736>>2]=i[k+504>>2],n0(f,42178,r+736|0),i[r+720>>2]=i[k+508>>2],n0(f,39195,r+720|0)),i[r+704>>2]=i[k+512>>2],n0(f,42356,r+704|0),i[r+688>>2]=i[k+516>>2],n0(f,41601,r+688|0),i[r+672>>2]=i[k+520>>2],n0(f,41526,r+672|0),i[r+656>>2]=t[k+524|0],n0(f,40254,r+656|0),n=t[k+2|0],o=u[k+524|0]?0:n-1|0,(o|0)<(n|0))for(l=k+584|0,h=k+556|0,w=k+528|0;i[r+640>>2]=o,n0(f,38669,r+640|0),n=o<<2,i[r+624>>2]=i[n+w>>2],n0(f,43477,r+624|0),i[r+608>>2]=i[n+h>>2],n0(f,43912,r+608|0),i[r+592>>2]=i[n+l>>2],n0(f,41647,r+592|0),o=o+1|0,(o|0)<t[k+2|0];);i[r+576>>2]=i[k+612>>2],n0(f,41323,r+576|0),i[r+560>>2]=i[k+616>>2],n0(f,41276,r+560|0),i[r+544>>2]=i[k+620>>2],n0(f,42275,r+544|0),i[r+528>>2]=i[k+624>>2],n0(f,41231,r+528|0),i[r+512>>2]=i[k+628>>2],n0(f,39929,r+512|0),i[r+496>>2]=i[k+632>>2],n0(f,41559,r+496|0),i[r+480>>2]=t[k+636|0],n0(f,40698,r+480|0);l:{if(!u[k+636|0]||(i[r+464>>2]=t[k+637|0],n0(f,40427,r+464|0),!u[k+637|0]))break l;n0(f,18129,0)}if(i[r+448>>2]=t[k+8798|0],n0(f,46203,r+448|0),i[r+432>>2]=t[k+8799|0],n0(f,40920,r+432|0),i[r+416>>2]=t[k+8800|0],n0(f,46245,r+416|0),u[k+8800|0]&&(i[r+400>>2]=t[k+8801|0],n0(f,43314,r+400|0),i[r+384>>2]=t[k+8802|0],n0(f,42379,r+384|0),i[r+368>>2]=i[k+8804>>2],n0(f,41412,r+368|0),i[r+352>>2]=i[k+8808>>2],n0(f,41361,r+352|0),i[r+336>>2]=t[k+8812|0],n0(f,42039,r+336|0)),i[r+320>>2]=(i[k+8820>>2]-i[k+8816>>2]|0)/100,n0(f,39829,r+320|0),i[k+8820>>2]!=i[k+8816>>2])for(o=0;i[r+304>>2]=o,n0(f,37480,r+304|0),Xo(i[k+8816>>2]+g(o,100)|0,f),o=o+1|0,o>>>0<(i[k+8820>>2]-i[k+8816>>2]|0)/100>>>0;);i[r+288>>2]=t[k+8828|0],n0(f,40136,r+288|0);l:{if(!u[k+8828|0]||(i[r+272>>2]=i[k+8832>>2],n0(f,39863,r+272|0),i[k+8832>>2]<=0))break l;for(n=k+8964|0,l=k+8836|0,o=0;h=i[l+(o<<2)>>2],i[r+264>>2]=t[n+o|0],i[r+260>>2]=h,i[r+256>>2]=o,n0(f,47783,r+256|0),o=o+1|0,(o|0)<i[k+8832>>2];);}if(i[r+240>>2]=t[k+8996|0],n0(f,43756,r+240|0),i[r+224>>2]=t[k+8997|0],n0(f,40729,r+224|0),i[r+208>>2]=t[k+8998|0],n0(f,44171,r+208|0),i[r+192>>2]=t[k+16816|0],n0(f,42791,r+192|0),i[r+176>>2]=t[k+16817|0],n0(f,43559,r+176|0),i[r+160>>2]=t[k+16818|0],n0(f,40516,r+160|0),i[r+144>>2]=t[k+16819|0],n0(f,44931,r+144|0),i[r+128>>2]=i[k+16884>>2],n0(f,43350,r+128|0),i[r+112>>2]=i[k+16880>>2],n0(f,42434,r+112|0),i[r+96>>2]=1<<i[k+616>>2]+i[k+612>>2],n0(f,42415,r+96|0),i[r+80>>2]=1<<i[k+620>>2],n0(f,42472,r+80|0),i[r+64>>2]=1<<i[k+624>>2]+i[k+620>>2],n0(f,42453,r- -64|0),i[r+48>>2]=i[k+16892>>2],n0(f,44612,r+48|0),i[r+32>>2]=i[k+16900>>2],n0(f,44325,r+32|0),i[r+16>>2]=i[k+16852>>2],n0(f,45903,r+16|0),i[r>>2]=i[k+16856>>2],n0(f,45754,r),u[k+16817|0]){l=k+16820|0,f=v-144|0,v=f,n=73524;l:switch(s-1|0){case 1:n=73520;case 0:n=i[n>>2],n0(n,47134,0),i[f+128>>2]=u[l|0],n0(n,42868,f+128|0),i[f+112>>2]=u[l+1|0],n0(n,43106,f+112|0),i[f+96>>2]=u[l+2|0],n0(n,45508,f+96|0),i[f+80>>2]=u[l+3|0],n0(n,45462,f+80|0),i[f+64>>2]=u[l+4|0],n0(n,43631,f- -64|0),i[f+48>>2]=u[l+5|0],n0(n,45038,f+48|0),i[f+32>>2]=u[l+6|0],n0(n,43198,f+32|0),i[f+16>>2]=u[l+7|0],n0(n,41185,f+16|0),i[f>>2]=u[l+8|0],n0(n,43152,f);break;default:break l}v=f+144|0}if(!u[k+8998|0])break o;l=k+9e3|0,f=v-576|0,v=f,n=73524;l:{u:switch(s-1|0){case 1:n=73520;break;case 0:break u;default:break l}if(n=i[n>>2],n0(n,47314,0),o=p[l+2>>1],i[f+564>>2]=p[l+4>>1],i[f+560>>2]=o,n0(n,38633,f+560|0),i[f+544>>2]=u[l+6|0],n0(n,40174,f+544|0),i[f+528>>2]=u[l+7|0],n0(n,42006,f+528|0),i[f+512>>2]=u[l+8|0],n0(n,39338,f+512|0),u[l+8|0]==1&&(o=i[l+12>>2],o>>>0<=4?o=i[(o<<2)+69944>>2]:o=18839,i[f+496>>2]=o,n0(n,38149,f+496|0),i[f+480>>2]=u[l+16|0],n0(n,44028,f+480|0),i[f+464>>2]=u[l+17|0],n0(n,40337,f+464|0),i[f+448>>2]=u[l+18|0],n0(n,45200,f+448|0),i[f+432>>2]=u[l+19|0],n0(n,42648,f+432|0),i[f+416>>2]=u[l+20|0],n0(n,45784,f+416|0)),i[f+400>>2]=u[l+21|0],n0(n,39223,f+400|0),u[l+21|0]==1&&(i[f+384>>2]=u[l+22|0],n0(n,42313,f+384|0),i[f+368>>2]=u[l+23|0],n0(n,39748,f+368|0)),i[f+352>>2]=u[l+24|0],n0(n,39454,f+352|0),i[f+336>>2]=u[l+25|0],n0(n,46046,f+336|0),i[f+320>>2]=u[l+26|0],n0(n,40301,f+320|0),i[f+304>>2]=u[l+27|0],n0(n,42206,f+304|0),i[f+288>>2]=i[l+28>>2],n0(n,42491,f+288|0),i[f+272>>2]=i[l+32>>2],n0(n,42142,f+272|0),i[f+256>>2]=i[l+36>>2],n0(n,43002,f+256|0),i[f+240>>2]=i[l+40>>2],n0(n,41876,f+240|0),i[f+224>>2]=u[l+44|0],n0(n,41970,f+224|0),u[l+44|0]==1&&(i[f+208>>2]=i[l+48>>2],n0(n,43951,f+208|0),i[f+192>>2]=i[l+52>>2],n0(n,45629,f+192|0)),i[f+176>>2]=u[l+56|0],n0(n,40623,f+176|0),i[f+160>>2]=i[l+60>>2],n0(n,44846,f+160|0),i[f+144>>2]=u[l+64|0],n0(n,40098,f+144|0),i[f+128>>2]=u[l+7804|0],n0(n,44507,f+128|0),u[l+7804|0]!=1)break l;i[f+112>>2]=u[l+7805|0],n0(n,43987,f+112|0),i[f+96>>2]=u[l+7806|0],n0(n,40468,f+96|0),i[f+80>>2]=u[l+7807|0],n0(n,42827,f+80|0),i[f+64>>2]=p[l+7808>>1],n0(n,43273,f- -64|0),i[f+48>>2]=u[l+7810|0],n0(n,44642,f+48|0),i[f+32>>2]=u[l+7811|0],n0(n,44130,f+32|0),i[f+16>>2]=u[l+7812|0],n0(n,42684,f+16|0),i[f>>2]=u[l+7813|0],n0(n,43436,f)}v=f+576|0}v=r+928|0}i[B+4>>2]=i[B+4>>2]+1,f=(i[B+484>>2]<<3)+A|0,i[f+728>>2]=k,r=i[f+732>>2],i[f+732>>2]=B;o:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break o;W[i[i[r>>2]+8>>2]](r),y(r)}for(l=856,o=A+856|0;;){r=i[o>>2];o:{if(!r|i[B+484>>2]!=t[r+13|0]||(r=i[o+4>>2],i[o>>2]=0,i[o+4>>2]=0,!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break o;W[i[i[r>>2]+8>>2]](r),y(r)}if(l=l+8|0,o=l+A|0,(l|0)==1368)break}l=0}r=i[B+4>>2],i[B+4>>2]=r-1,r||(W[i[i[B>>2]+8>>2]](B),y(B)),r=l,H4(A+548|0,O);break n;case 2:l=A,A=S+8|0,m=C(8520),i[m>>2]=67596,i[m+4>>2]=0,i[m+8>>2]=0,o=1006,k=m+12|0,t[k+8263|0]=0,t[k+8264|0]=0,t[k+8246|0]=2,t[k+8247|0]=0,t[k+8248|0]=0,t[k+8249|0]=0,t[k+8250|0]=0,i[k+4>>2]=0,i[k+8>>2]=0,t[k|0]=0,i[k+8448>>2]=0,i[k+8452>>2]=0,t[k+26|0]=0,X[k+24>>1]=0,i[k+20>>2]=27,t[k+17|0]=1,t[k+18|0]=1,t[k+9|0]=0,t[k+10|0]=0,t[k+11|0]=0,t[k+12|0]=0,t[k+13|0]=0,t[k+14|0]=0,t[k+15|0]=0,t[k+16|0]=0,r=k+8456|0,i[r>>2]=0,i[r+4>>2]=0,r=k+8464|0,i[r>>2]=0,i[r+4>>2]=0,f=k+8472|0,i[f>>2]=0,i[f+4>>2]=0,f=k+8480|0,i[f>>2]=0,i[f+4>>2]=0,f=k+8488|0,i[f>>2]=0,i[f+4>>2]=0,n=k+8496|0,i[n>>2]=0,i[n+4>>2]=0,i[k+8504>>2]=0,t[k+43|0]=0,t[k+44|0]=0,t[k+45|0]=0,t[k+46|0]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,X[k+56>>1]=257,i[k+48>>2]=1,i[k+52>>2]=1,t[k+58|0]=1,l0(k+8280|0,0,168),i[f>>2]=0,i[r>>2]=0,i[k+8268>>2]=0,t[k+8233|0]=0,t[k+61|0]=0,t[k+59|0]=0,t[k+60|0]=0,i[k+64>>2]=0,i[k+68>>2]=0,t[k+72|0]=0,i[k+8236>>2]=2,i[k+8240>>2]=0,X[k+8244>>1]=0,t[k|0]=0,r=i[k+8>>2],i[k+4>>2]=0,i[k+8>>2]=0;o:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break o;W[i[i[r>>2]+8>>2]](r),y(r)}i[k+12>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,t[k+26|0]=0,X[k+24>>1]=0,i[k+20>>2]=27,t[k+18|0]=1,t[k+58|0]=1,X[k+56>>1]=257,i[k+48>>2]=1,i[k+52>>2]=1,X[k+16>>1]=256,i[k+36>>2]=0,i[k+40>>2]=0,t[k+43|0]=0,t[k+44|0]=0,t[k+45|0]=0,t[k+46|0]=0,h=k+8280|0,l0(h,0,168),i[k+8268>>2]=0,t[k+8233|0]=0,t[k+61|0]=0,t[k+59|0]=0,t[k+60|0]=0,i[k+64>>2]=0,i[k+68>>2]=0,t[k+72|0]=0,i[k+8236>>2]=2,i[k+8240>>2]=0,X[k+8244>>1]=0,i[k+8452>>2]=i[k+8448>>2],i[k+8464>>2]=i[k+8460>>2],i[k+8476>>2]=i[k+8472>>2],i[k+8488>>2]=i[k+8484>>2],i[k+8500>>2]=i[k+8496>>2],r=k2(A),t[k+12|0]=r;o:{if(!((r|0)!=-99999&(r|0)<=63)){C2(l+4|0,1009,0);break o}r=k2(A),t[k+13|0]=r;l:{u:{if(!((r|0)!=-99999&(r|0)<=15))break u;if(r0=k,f0=G0(A,1),t[r0+14|0]=f0,r0=k,f0=G0(A,1),t[r0+43|0]=f0,r0=k,f0=G0(A,3),t[r0+8240|0]=f0,r0=k,f0=G0(A,1),t[r0+15|0]=f0,r0=k,f0=G0(A,1),t[r0+16|0]=f0,r=k2(A),t[k+17|0]=r,(r|0)==-99999||(t[k+17|0]=r+1,r=k2(A),t[k+18|0]=r,(r|0)==-99999))break l;if(t[k+18|0]=r+1,r=l+(t[k+13|0]<<3)|0,n=i[r+728>>2],!n)break u;f=i[r+732>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[k+4>>2]=n,r=i[k+8>>2],i[k+8>>2]=f;s:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break s;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=f4(A),i[k+20>>2]=r,(r|0)==-99999)break l;i[k+20>>2]=r+26,r0=k,f0=G0(A,1),t[r0+24|0]=f0,r0=k,f0=G0(A,1),t[r0+25|0]=f0,r=G0(A,1),t[k+26|0]=r;s:{if(r&255){if(r=k2(A),i[k+28>>2]=r,(r|0)!=-99999)break s;break l}i[k+28>>2]=0}if(r=f4(A),i[k+32>>2]=r,(r|0)==-99999||(r=f4(A),i[k+36>>2]=r,(r|0)==-99999))break l;r0=k,f0=G0(A,1),t[r0+40|0]=f0,r0=k,f0=G0(A,1),t[r0+41|0]=f0,r0=k,f0=G0(A,1),t[r0+42|0]=f0,r0=k,f0=G0(A,1),t[r0+44|0]=f0,r0=k,f0=G0(A,1),t[r0+46|0]=f0,r0=k,f0=G0(A,1),t[r0+45|0]=f0;s:{h:{if(u[k+46|0]){if(r=k2(A),i[k+48>>2]=r,!((r|0)!=-99999&(r|0)<10)||(i[k+48>>2]=r+1,r=k2(A),i[k+52>>2]=r,!((r|0)!=-99999&(r|0)<10)))break l;if(i[k+52>>2]=r+1,r=G0(A,1),t[k+56|0]=r,!(r&255)){if(r=i[k+4>>2],f=i[r+16900>>2],n=i[r+16892>>2],w=i[k+48>>2],(w|0)>=2)for(r=0;;){if(_=h+(r<<2)|0,w=k2(A),i[_>>2]=w,(w|0)==-99999)break l;if(w=w+1|0,i[_>>2]=w,n=n-w|0,r=r+1|0,w=i[k+48>>2],!((r|0)<(w-1|0)))break}if((n|0)<=0)break s;if(i[(h+(w<<2)|0)-4>>2]=n,n=i[k+52>>2],(n|0)>=2)for(h=k+8320|0,r=0;;){if(w=h+(r<<2)|0,n=k2(A),i[w>>2]=n,(n|0)==-99999)break l;if(n=n+1|0,i[w>>2]=n,f=f-n|0,r=r+1|0,n=i[k+52>>2],!((r|0)<(n-1|0)))break}if((f|0)<=0)break s;i[(k+(n<<2)|0)+8316>>2]=f}r=G0(A,1);break h}t[k+56|0]=1,i[k+48>>2]=1,i[k+52>>2]=1,r=0}i[k+64>>2]=0,i[k+68>>2]=0,t[k+57|0]=r,r0=k,f0=G0(A,1),t[r0+58|0]=f0,r=G0(A,1),t[k+59|0]=r;h:{if(r&255){if(r0=k,f0=G0(A,1),t[r0+60|0]=f0,r=G0(A,1),t[k+61|0]=r,r&255)break h;if(r=f4(A),i[k- -64>>2]=r,(r|0)==-99999||(i[k+64>>2]=r<<1,r=f4(A),i[k+68>>2]=r,(r|0)==-99999))break l;i[k+68>>2]=r<<1;break h}X[k+60>>1]=0}if(f=G0(A,1),t[k+72|0]=f,r=i[k+4>>2],n=f&255,!(u[r+636|0]|!n))break l;f=k+73|0;h:{if(n){if(r=nn(A,f),!r)break h;C2(l+4|0,r,0);break o}z(f,r+638|0,8160)}if(r0=k,f0=G0(A,1),t[r0+8233|0]=f0,r=k2(A),i[k+8236>>2]=r,(r|0)==-99999)break l;if(i[k+8236>>2]=r+2,f=i[k+4>>2],(r|0)>((i[f+612>>2]+i[f+616>>2]|0)-2|0))break s;r0=k,f0=G0(A,1),t[r0+8241|0]=f0,r=G0(A,1),t[k+8242|0]=r;h:{if(!(r&255)||(r0=k,f0=G0(A,1),t[r0+8243|0]=f0,r0=k,f0=G0(A,1),t[r0+8244|0]=f0,r0=k,f0=G0(A,6),t[r0+8245|0]=f0,!u[k+8243|0]))break h;r=k+8246|0,f=i[(l+(t[k+13|0]<<3)|0)+728>>2],u[k+25|0]&&(r0=r,f0=k2(A)+2|0,t[r0|0]=f0),n=G0(A,1),t[r+1|0]=(n|0)!=0,!n|i[f+16848>>2]==3||C2(l+4|0,1006,0),n=G0(A,1),t[r+2|0]=(n|0)!=0;w:{_:{v:{B:{if(!(i[f+16848>>2]|!n)){if(C2(l+4|0,1006,0),t[r+2|0]&1)break B;break v}if(!n)break v}if(n=k2(A),!((n|0)!=-99999&(n|0)<=i[f+616>>2])||(t[r+3|0]=n,n=k2(A),!((n|0)!=-99999&(n|0)<6)))break _;if(n=(n&255)+1|0,t[r+4|0]=n,(n|0)!=(n&255))break v;for(h=r+11|0,w=r+5|0,n=0;;){if(_=f4(A),_-13>>>0<=4294967270||(t[n+w|0]=_,_=f4(A),_-13>>>0<=4294967270))break _;if(t[n+h|0]=_,n=n+1|0,!(n>>>0<u[r+4|0]))break}}v:{if(n=k2(A),(n|0)!=-99999&&(h=i[f+16832>>2],(n|0)<=(((h|0)<=10?10:h)-10|0)))break v;break _}t[r+17|0]=n;v:{if(A=k2(A),(A|0)!=-99999&&(f=i[f+16840>>2],(A|0)<=(((f|0)<=10?10:f)-10|0)))break v;break _}t[r+18|0]=A,A=1;break w}C2(l+4|0,1006,0),A=0}if(!A)break s}f=0,r=v,A0=r,h=i[k+4>>2],A=i[h+16876>>2],i[k+8276>>2]=u[k+8246|0],i[k+8268>>2]=A-i[k+28>>2],i[k+8272>>2]=A-u[k+8249|0],w=i[k+48>>2];h:{if(!u[k+56|0])break h;_=r-((w<<2)+19&-16)|0,v=_;w:{if((w|0)<0)break w;if(A=i[h+16892>>2],w)for(n=w+1&-2,r=0;i[_+(f<<2)>>2]=(g(A,f)|0)/(w|0),I=f|1,i[_+(I<<2)>>2]=(g(A,I)|0)/(w|0),f=f+2|0,r=r+2|0,(n|0)!=(r|0););w&1||(i[_+(f<<2)>>2]=(g(A,f)|0)/(w|0)),Y=w&3,I=k+8280|0,r=i[_>>2];_:{if(w-1>>>0<3){f=0;break _}for(V=w&2147483644,f=0,n=0;A=f<<2,j=A|4,G=i[j+_>>2],i[A+I>>2]=G-r,Q=I+j|0,r=A|8,j=i[r+_>>2],i[Q>>2]=j-G,A=A|12,G=i[A+_>>2],i[r+I>>2]=G-j,f=f+4|0,r=i[_+(f<<2)>>2],i[A+I>>2]=r-G,n=n+4|0,(V|0)!=(n|0););}if(!Y)break w;for(;n=I+(f<<2)|0,f=f+1|0,A=i[_+(f<<2)>>2],i[n>>2]=A-r,r=A,s=s+1|0,(Y|0)!=(s|0););}if(f=0,A=i[k+52>>2],_=_-((A<<2)+19&-16)|0,v=_,(A|0)<0)break h;if(n=i[h+16900>>2],A)for(s=A+1&-2,r=0;i[_+(f<<2)>>2]=(g(f,n)|0)/(A|0),I=f|1,i[_+(I<<2)>>2]=(g(n,I)|0)/(A|0),f=f+2|0,r=r+2|0,(s|0)!=(r|0););A&1||(i[_+(f<<2)>>2]=(g(f,n)|0)/(A|0)),Y=A&3,I=k+8320|0,r=i[_>>2],s=0;w:{if(A-1>>>0<3){f=0;break w}for(V=A&2147483644,f=0,n=0;A=f<<2,j=A|4,G=i[j+_>>2],i[A+I>>2]=G-r,Q=I+j|0,r=A|8,j=i[r+_>>2],i[Q>>2]=j-G,A=A|12,G=i[A+_>>2],i[r+I>>2]=G-j,f=f+4|0,r=i[_+(f<<2)>>2],i[A+I>>2]=r-G,n=n+4|0,(V|0)!=(n|0););}if(!Y)break h;for(;n=I+(f<<2)|0,f=f+1|0,A=i[_+(f<<2)>>2],i[n>>2]=A-r,r=A,s=s+1|0,(Y|0)!=(s|0););}i[k+8360>>2]=0,_=k+8360|0;h:{if((w|0)<=0)break h;if(s=k+8280|0,A=0,w>>>0>=4)for(f=w&2147483644,n=0;r=A<<2,I=r|4,B=i[r+s>>2]+B|0,i[I+_>>2]=B,Y=r|8,B=B+i[s+I>>2]|0,i[Y+_>>2]=B,r=r|12,B=B+i[s+Y>>2]|0,i[r+_>>2]=B,A=A+4|0,B=B+i[r+s>>2]|0,i[_+(A<<2)>>2]=B,n=n+4|0,(f|0)!=(n|0););if(n=w&3,!n)break h;for(r=0;f=A+1|0,B=i[s+(A<<2)>>2]+B|0,i[_+(f<<2)>>2]=B,A=f,r=r+1|0,(n|0)!=(r|0););}i[k+8404>>2]=0,w=k+8404|0,r=i[k+52>>2];h:{if((r|0)<=0)break h;if(s=k+8320|0,n=0,B=0,A=0,r>>>0>=4)for(Y=r&2147483644,f=0;I=A<<2,G=I|4,B=i[s+I>>2]+B|0,i[G+w>>2]=B,V=I|8,B=B+i[s+G>>2]|0,i[V+w>>2]=B,I=I|12,B=B+i[s+V>>2]|0,i[I+w>>2]=B,A=A+4|0,B=B+i[s+I>>2]|0,i[w+(A<<2)>>2]=B,f=f+4|0,(Y|0)!=(f|0););if(f=r&3,!f)break h;for(;r=A+1|0,B=i[s+(A<<2)>>2]+B|0,i[w+(r<<2)>>2]=B,A=r,n=n+1|0,(f|0)!=(n|0););}j=k+8448|0,A=i[h+16908>>2],f=i[k+8448>>2],r=i[k+8452>>2]-f>>2;h:{if(A>>>0>r>>>0){T8(j,A-r|0),A=i[h+16908>>2];break h}if(A>>>0>=r>>>0)break h;i[k+8452>>2]=f+(A<<2)}f=i[k+8460>>2],r=i[k+8464>>2]-f>>2;h:{if(r>>>0<A>>>0){T8(k+8460|0,A-r|0),A=i[h+16908>>2];break h}if(A>>>0>=r>>>0)break h;i[k+8464>>2]=f+(A<<2)}N=k+8472|0,f=i[k+8472>>2],r=i[k+8476>>2]-f>>2;h:{if(r>>>0<A>>>0){T8(N,A-r|0),A=i[h+16908>>2];break h}if(A>>>0>=r>>>0)break h;i[k+8476>>2]=f+(A<<2)}x=k+8484|0,f=i[k+8484>>2],r=i[k+8488>>2]-f>>2;h:{if(r>>>0<A>>>0){T8(x,A-r|0);break h}if(A>>>0>=r>>>0)break h;i[k+8488>>2]=f+(A<<2)}d=k+8496|0,A=i[h+16932>>2],f=i[k+8496>>2],r=i[k+8500>>2]-f>>2;h:{if(A>>>0>r>>>0){T8(d,A-r|0);break h}if(A>>>0>=r>>>0)break h;i[k+8500>>2]=f+(A<<2)}if(i[h+16908>>2]>0)for(E=k+8280|0,Q=k+8320|0,g0=i[k+8460>>2],q=i[k+8448>>2],r=0;;){A=i[h+16892>>2],I=(r|0)/(A|0)|0,Y=r-g(A,I)|0,s=-1,n=i[k+48>>2];h:{if((n|0)<=0)break h;if(f=0,A=0,n>>>0>=4)for(G=n&2147483644,B=0;U=(Y|0)<i[_+(A<<2)>>2]?s:A,s=A|1,U=(Y|0)<i[_+(s<<2)>>2]?U:s,s=A|2,U=(Y|0)<i[_+(s<<2)>>2]?U:s,s=A|3,s=(Y|0)<i[_+(s<<2)>>2]?U:s,A=A+4|0,B=B+4|0,(G|0)!=(B|0););if(n=n&3,!n)break h;for(;s=(Y|0)<i[_+(A<<2)>>2]?s:A,A=A+1|0,f=f+1|0,(n|0)!=(f|0););}G=i[k+52>>2];h:{if((G|0)<=0){n=-1;break h}if(n=-1,f=0,A=0,G>>>0>=4)for(V=G&2147483644,B=0;U=(I|0)<i[w+(A<<2)>>2]?n:A,n=A|1,U=(I|0)<i[w+(n<<2)>>2]?U:n,n=A|2,U=(I|0)<i[w+(n<<2)>>2]?U:n,n=A|3,n=(I|0)<i[w+(n<<2)>>2]?U:n,A=A+4|0,B=B+4|0,(V|0)!=(B|0););if(B=G&3,!B)break h;for(;n=(I|0)<i[w+(A<<2)>>2]?n:A,A=A+1|0,f=f+1|0,(B|0)!=(f|0););}f=0,A=q+(r<<2)|0,i[A>>2]=0;h:{if((s|0)<=0)break h;if(G=Q+(n<<2)|0,V=0,B=0,s>>>0>=4)for(_0=s&2147483644,R=0;U=f,f=E+(B<<2)|0,U=U+g(i[f>>2],i[G>>2])|0,i[A>>2]=U,U=U+g(i[f+4>>2],i[G>>2])|0,i[A>>2]=U,U=U+g(i[f+8>>2],i[G>>2])|0,i[A>>2]=U,f=U+g(i[f+12>>2],i[G>>2])|0,i[A>>2]=f,B=B+4|0,R=R+4|0,(_0|0)!=(R|0););if(R=s&3,!R)break h;for(;f=g(i[E+(B<<2)>>2],i[G>>2])+f|0,i[A>>2]=f,B=B+1|0,V=V+1|0,(R|0)!=(V|0););}h:{if((n|0)<=0)break h;R=n&3,G=0;w:{if(n>>>0<4){B=0;break w}for(_0=n&2147483644,B=0,V=0;U=f,f=Q+(B<<2)|0,U=U+g(i[f>>2],i[h+16892>>2])|0,i[A>>2]=U,U=U+g(i[f+4>>2],i[h+16892>>2])|0,i[A>>2]=U,U=U+g(i[f+8>>2],i[h+16892>>2])|0,i[A>>2]=U,f=U+g(i[f+12>>2],i[h+16892>>2])|0,i[A>>2]=f,B=B+4|0,V=V+4|0,(_0|0)!=(V|0););}if(!R)break h;for(;f=g(i[Q+(B<<2)>>2],i[h+16892>>2])+f|0,i[A>>2]=f,B=B+1|0,G=G+1|0,(R|0)!=(G|0););}if((n|s)<0&&(U0(23793,19875,620,5736),M()),B=f,f=s<<2,n=B+g(i[f+E>>2],I-i[w+(n<<2)>>2]|0)|0,i[A>>2]=n,s=A,A=n+(Y-i[f+_>>2]|0)|0,i[s>>2]=A,i[g0+(A<<2)>>2]=r,r=r+1|0,!((r|0)<i[h+16908>>2]))break}f=i[k+52>>2];h:{if((f|0)<=0||(B=0,A=i[k+48>>2],(A|0)<=0))break h;for(s=0;;){w:{if((A|0)<=0){s=s+1|0;break w}if(n=0,I=w+(s<<2)|0,s=s+1|0,V=w+(s<<2)|0,G=i[V>>2],(G|0)<=i[I>>2]){B=((A|0)<=1?1:A)+B|0;break w}for(;;){f=i[I>>2];_:{if((G|0)<=(f|0)){n=n+1|0;break _}if(Y=_+(n<<2)|0,n=n+1|0,E=_+(n<<2)|0,r=i[E>>2],(r|0)<=i[Y>>2])break _;for(Q=i[x>>2],R=i[N>>2],g0=i[j>>2];;){if(A=i[Y>>2],(r|0)>(A|0)){for(;r=A<<2,i[R+(i[r+(g0+(g(i[h+16892>>2],f)<<2)|0)>>2]<<2)>>2]=B,i[r+(Q+(g(i[h+16892>>2],f)<<2)|0)>>2]=B,A=A+1|0,r=i[E>>2],(A|0)<(r|0););G=i[V>>2]}if(f=f+1|0,!((G|0)>(f|0)))break}A=i[k+48>>2]}if(B=B+1|0,!((A|0)>(n|0)))break}f=i[k+52>>2]}if(!((f|0)>(s|0)))break}}f=i[h+16928>>2];h:{if((f|0)<=0||(n=0,A=i[h+16924>>2],(A|0)<=0))break h;for(_=i[d>>2],I=i[j>>2];;){if(r=0,(A|0)>0){for(;;){Y=_+(r<<2)|0,s=Y+(g(A,n)<<2)|0,A=i[h+16936>>2],f=i[h+16876>>2],i[s>>2]=i[(I+(g(i[h+16892>>2],n<<A>>f)<<2)|0)+(r<<A>>f<<2)>>2]<<(f-A<<1),s=i[h+16876>>2],B=i[h+16936>>2],w=s-B|0;w:{if((w|0)<=0){f=0;break w}if(A=0,f=0,(s|0)!=(B+1|0))for(G=w&2147483646,s=0;V=A|1,B=2<<A,Q=f,f=1<<A,f=((B&n?4<<A<<V:0)+((Q+(f&n?B<<A:0)|0)+(r&f?f<<A:0)|0)|0)+(r&B?B<<V:0)|0,A=A+2|0,s=s+2|0,(G|0)!=(s|0););if(!(w&1))break w;s=f,f=1<<A,f=(s+(f&n?2<<A<<A:0)|0)+(r&f?f<<A:0)|0}if(A=Y+(g(i[h+16924>>2],n)<<2)|0,i[A>>2]=i[A>>2]+f,A=i[h+16924>>2],r=r+1|0,!((A|0)>(r|0)))break}f=i[h+16928>>2]}if(n=n+1|0,!((n|0)<(f|0)))break}}v=A0,t[k|0]=1,s=1}break o}C2(l+4|0,1010,0);break o}C2(l+4|0,1006,0)}o:{if(!s)break o;if(o=0,s=i[l+524>>2],(s|0)>=0){f=0,A=v-720|0,v=A,r=73524;l:{u:switch(s-1|0){case 1:r=73520;break;case 0:break u;default:break l}if(r=i[r>>2],n0(r,47273,0),i[A+704>>2]=t[k+12|0],n0(r,44097,A+704|0),i[A+688>>2]=t[k+13|0],n0(r,44064,A+688|0),i[A+672>>2]=t[k+14|0],n0(r,40962,A+672|0),i[A+656>>2]=t[k+15|0],n0(r,43677,A+656|0),i[A+640>>2]=t[k+16|0],n0(r,42758,A+640|0),i[A+624>>2]=t[k+17|0],n0(r,41490,A+624|0),i[A+608>>2]=t[k+18|0],n0(r,41454,A+608|0),i[A+592>>2]=i[k+20>>2],n0(r,45976,A+592|0),i[A+576>>2]=t[k+24|0],n0(r,39551,A+576|0),i[A+560>>2]=t[k+25|0],n0(r,39632,A+560|0),i[A+544>>2]=t[k+26|0],n0(r,42242,A+544|0),u[k+26|0]&&(i[A+528>>2]=i[k+28>>2],n0(r,43038,A+528|0)),i[A+512>>2]=i[k+32>>2],n0(r,45427,A+512|0),i[A+496>>2]=i[k+36>>2],n0(r,45392,A+496|0),i[A+480>>2]=t[k+40|0],n0(r,40051,A+480|0),i[A+464>>2]=t[k+41|0],n0(r,45003,A+464|0),i[A+448>>2]=t[k+42|0],n0(r,44548,A+448|0),i[A+432>>2]=t[k+43|0],n0(r,43071,A+432|0),i[A+416>>2]=t[k+44|0],n0(r,39516,A+416|0),i[A+400>>2]=t[k+46|0],n0(r,45084,A+400|0),i[A+384>>2]=t[k+45|0],n0(r,39710,A+384|0),u[k+46|0]){if(i[A+368>>2]=i[k+48>>2],n0(r,42622,A+368|0),i[A+352>>2]=i[k+52>>2],n0(r,43886,A+352|0),i[A+336>>2]=t[k+56|0],n0(r,39490,A+336|0),n0(r,34042,0),i[k+48>>2]>=0)for(n=k+8360|0;i[A+320>>2]=i[n+(f<<2)>>2],n0(r,32787,A+320|0),B=i[k+48>>2]>(f|0),f=f+1|0,!!B;);if(f=0,n0(r,47531,0),n0(r,34020,0),i[k+52>>2]>=0)for(n=k+8404|0;i[A+304>>2]=i[n+(f<<2)>>2],n0(r,32787,A+304|0),B=i[k+52>>2]>(f|0),f=f+1|0,!!B;);n0(r,47531,0),i[A+288>>2]=t[k+57|0],n0(r,41006,A+288|0)}if(i[A+272>>2]=t[k+58|0],n0(r,39584,A+272|0),i[A+256>>2]=t[k+59|0],n0(r,39294,A+256|0),u[k+59|0]&&(i[A+240>>2]=t[k+60|0],n0(r,39665,A+240|0),i[A+224>>2]=t[k+61|0],n0(r,39414,A+224|0),i[A+208>>2]=i[k+64>>2],n0(r,46605,A+208|0),i[A+192>>2]=i[k+68>>2],n0(r,46623,A+192|0)),i[A+176>>2]=t[k+72|0],n0(r,39374,A+176|0),i[A+160>>2]=t[k+8233|0],n0(r,39257,A+160|0),i[A+144>>2]=i[k+8236>>2],n0(r,43399,A+144|0),i[A+128>>2]=t[k+8240|0],n0(r,42552,A+128|0),i[A+112>>2]=t[k+8241|0],n0(r,40377,A+112|0),i[A+96>>2]=t[k+8242|0],n0(r,45236,A+96|0),i[A+80>>2]=t[k+8243|0],n0(r,43595,A+80|0),i[A+64>>2]=t[k+8244|0],n0(r,40552,A- -64|0),i[A+48>>2]=t[k+8245|0],n0(r,44967,A+48|0),i[A+32>>2]=i[k+8268>>2],n0(r,44810,A+32|0),i[A+16>>2]=i[k+8272>>2],n0(r,41766,A+16|0),i[A>>2]=i[k+8276>>2],n0(r,41807,A),!u[k+8243|0])break l;f=k+8246|0,r=v-144|0,v=r,n=73524;u:switch(s-1|0){case 1:n=73520;case 0:s=i[n>>2],n0(s,47398,0),i[r+128>>2]=u[f|0],n0(s,43840,r+128|0),i[r+112>>2]=u[f+1|0],n0(s,41139,r+112|0),i[r+96>>2]=u[f+2|0],n0(s,43710,r+96|0);s:{if(u[f+2|0]!=1||(i[r+80>>2]=u[f+3|0],n0(s,44720,r+80|0),i[r+64>>2]=u[f+4|0],n0(s,45820,r- -64|0),!u[f+4|0]))break s;for(B=f+11|0,h=f+5|0,n=0;i[r+52>>2]=t[n+h|0],i[r+48>>2]=n,n0(s,46334,r+48|0),i[r+36>>2]=t[n+B|0],i[r+32>>2]=n,n0(s,46287,r+32|0),n=n+1|0,n>>>0<u[f+4|0];);}i[r+16>>2]=u[f+17|0],n0(s,45708,r+16|0),i[r>>2]=u[f+18|0],n0(s,45272,r);break;default:break u}v=r+144|0}v=A+720|0}if(i[m+4>>2]=i[m+4>>2]+1,r=l+(t[m+24|0]<<3)|0,i[r+856>>2]=k,A=i[r+860>>2],i[r+860>>2]=m,!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break o;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[m+4>>2],i[m+4>>2]=A-1,A||(W[i[i[m>>2]+8>>2]](m),y(m)),r=o,H4(l+548|0,O);break n;case 7:case 8:n=S+8|0,s=(f|0)==40,f=0,o=0,l=v-80|0,v=l;o:{for(k=i[A+1376>>2];r=G0(n,8),f=r+f|0,(r|0)==255;);for(;r=G0(n,8),o=r+o|0,(r|0)==255;);i[l+4>>2]=o,i[l>>2]=f,r=0;l:{if((f|0)!=132||(r0=l,f0=G0(n,8),i[r0+8>>2]=f0,r=1025,!k))break l;for(f=l+27|0,B=l+26|0,h=l+25|0,w=l+24|0,_=l+23|0,m=l+22|0,I=l+21|0,Y=l+20|0,G=l+19|0,V=l+18|0,j=l+17|0,E=l+16|0,Q=l+15|0,N=l+14|0,x=l+13|0,d=l+12|0,R=l+60|0,A0=l+68|0,k=i[k+476>>2],o=0;;){u:{s:switch(i[l+8>>2]){case 0:r=o<<4,r0=r+d|0,f0=G0(n,8),t[r0|0]=f0,r0=r+x|0,f0=G0(n,8),t[r0|0]=f0,r0=r+N|0,f0=G0(n,8),t[r0|0]=f0,r0=r+Q|0,f0=G0(n,8),t[r0|0]=f0,r0=r+E|0,f0=G0(n,8),t[r0|0]=f0,r0=r+j|0,f0=G0(n,8),t[r0|0]=f0,r0=r+V|0,f0=G0(n,8),t[r0|0]=f0,r0=r+G|0,f0=G0(n,8),t[r0|0]=f0,r0=r+Y|0,f0=G0(n,8),t[r0|0]=f0,r0=r+I|0,f0=G0(n,8),t[r0|0]=f0,r0=r+m|0,f0=G0(n,8),t[r0|0]=f0,r0=r+_|0,f0=G0(n,8),t[r0|0]=f0,r0=r+w|0,f0=G0(n,8),t[r0|0]=f0,r0=r+h|0,f0=G0(n,8),t[r0|0]=f0,r0=r+B|0,f0=G0(n,8),t[r0|0]=f0,r0=r+f|0,f0=G0(n,8),t[r0|0]=f0;break u;case 1:r0=R+(o<<1)|0,f0=G0(n,16),X[r0>>1]=f0;break u;case 2:break s;default:break u}r0=A0+(o<<2)|0,f0=G0(n,32),i[r0>>2]=f0}if(!(k&&(r=o>>>0<2,o=o+1|0,r)))break}r=0}l:{if(!r){if(!s||(f=i[A+3212>>2],(f|0)==i[A+3208>>2]))break l;if(k=i[f-4>>2],f=i[k+440>>2],s=i[k+444>>2],f>>>0<s>>>0){z(f,l,80),i[k+440>>2]=f+80;break l}if(o=i[k+436>>2],f=f-o|0,n=((f|0)/80|0)+1|0,n>>>0>=53687092)break i;if(s=(s-o|0)/80|0,B=s<<1,s=s>>>0>=26843545?53687091:n>>>0<B>>>0?B:n,s){if(s>>>0>=53687092)break e;n=C(g(s,80))}else n=0;B=n+f|0,z(B,l,80),h=B+g((f|0)/-80|0,80)|0,f&&z(h,o,f),i[k+444>>2]=n+g(s,80),f=B+80|0,i[k+440>>2]=f,i[k+436>>2]=h,o&&Z(o),i[k+440>>2]=f;break l}if(f=i[A+84>>2],(f|0)==20){i[A+80>>2]=1001;break l}i[A+84>>2]=f+1,i[((f<<2)+A|0)+4>>2]=r}v=l+80|0;break o}H4(A+548|0,O);break n;case 4:t[A+2203|0]=1,H4(A+548|0,O);break n;default:break t}H4(A+548|0,O)}v=S+32|0,t[X0+15|0]=1;break k}if(!(u[A+549|0]!=1|i[A+3208>>2]!=i[A+3212>>2])){if(r=13,A=1,e)break A;break f}r=Q9(A,X0+15|0)}if(!e)break f;A=r?0:u[X0+15|0]}i[e>>2]=A}return v=X0+16|0,r}U0(10982,19835,1331,16629),M()}x0(),M()}s0(),M()}function c8(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;n=v-336|0,v=n,i[n+304>>2]=0,i[n+308>>2]=0,i[n+312>>2]=0,i[n+316>>2]=0,i[n+320>>2]=0,i[n+296>>2]=0,i[n+300>>2]=0,i[n+288>>2]=92500,Wi(n+264|0,n+288|0,e);i:{if(i[n+264>>2]){e=i[n+268>>2],i[A>>2]=i[n+264>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+280>>2],e=i[n+276>>2],i[A+8>>2]=i[n+272>>2],i[A+12>>2]=e,i[n+280>>2]=0,i[n+272>>2]=0,i[n+276>>2]=0;break i}if(u[e+20|0]==1){if(t[n+72|0]=0,t[n+83|0]=0,a(A,2,100,n+72|0),t[n+83|0]>=0)break i;Z(i[n+72>>2]);break i}k=i[r+4>>2],i[r>>2]=0,i[r+4>>2]=0;e:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break e;W[i[i[k>>2]+8>>2]](k),y(k)}i[n+256>>2]=0,i[n+260>>2]=0;e:{r:{f:{A:{k:{n:{t:{o:{l:{u:{s:{h:{w:{_:{v:{B:{m:{g:{Z:{W:{X:{V:{I:{F:{Q:{p:{Y:{D:{U:{M:{J:{C:{y:{N:{E:{_0:{H:{z:{x:{R:{T:{j:{S:{O:{P:{L:{q:{a:{K:{$:{d:{b:{v0:{c:{m0:{i0:{e0:{r0:{f0:{A0:{k0:{n0:{t0:{o0:{l0:{Z0:{u0:{s0:{h0:{w0:{if(k=i[n+304>>2],(k|0)<=1785751362){if((k|0)<=1701604966){if((k|0)<=1667523941){if((k|0)<=1635135536){if((k|0)<=1634563684){if((k|0)==1630628984)break P;if((k|0)==1630629744)break L;if((k|0)!=1634497650)break A;k=C(136),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=97188,o=k+16|0,l0(o,0,104),i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=94524,i[k+128>>2]=0,i[k+132>>2]=0,i[n+260>>2]=k,i[n+256>>2]=o,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1634563685)break j;if((k|0)==1635088451)break t0;if((k|0)!=1635088489)break A;k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=112456,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=99908,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+128>>2]=0,i[k+32>>2]=1635088489,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1635148592){if((k|0)==1635135537)break r0;if((k|0)!=1635135811)break A;k=C(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=104700,X[k+114>>1]=0,X[k+116>>1]=0,X[k+118>>1]=0,X[k+120>>1]=0,i[k+136>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k>>2]=96748,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=256,t[k+121|0]=0,t[k+122|0]=0,t[k+123|0]=0,t[k+124|0]=0,i[k+32>>2]=1635135811,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}G:switch(k-1635148593|0){case 0:break Y;case 18:break D;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 17:break A;default:break G}if((k|0)==1651798644)break h;if((k|0)!=1667462004)break A;k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,t[k+122|0]=0,t[k+120|0]=0,t[k+121|0]=0,i[k+16>>2]=112376,i[k>>2]=99868,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1667462004,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1668114797){if((k|0)<=1668050024){if((k|0)==1667523942)break E;if((k|0)!=1668047216)break A;k=C(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+140>>2]=0,i[k+144>>2]=1,i[k+132>>2]=0,i[k+136>>2]=1,i[k+124>>2]=0,i[k+128>>2]=1,i[k+116>>2]=0,i[k+120>>2]=1,i[k>>2]=96508,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=94204,i[k+32>>2]=1668047216,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1668050025)break O;if((k|0)==1668112752)break N;if((k|0)!=1668113784)break A;ko(n+72|0),o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1684631141){if((k|0)==1668114798)break T;if((k|0)==1668246642)break $;if((k|0)!=1668576371)break A;k=C(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=111976,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=99668,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1668576371,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1684631142)break v0;if((k|0)==1685218662)break b;if((k|0)!=1701082227)break A;k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=99948,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=99988,i[k+32>>2]=1701082227,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)<=1768778097){if((k|0)<=1752589104){if((k|0)<=1718909295){if((k|0)==1701604967)break H;if((k|0)==1701606260)break _;if((k|0)!=1718773093)break A;break r}if((k|0)==1718909296)break w0;if((k|0)==1735553132)break m0;if((k|0)!=1751411826)break A;k=C(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=1885954932,i[k+128>>2]=0,i[k+132>>2]=0,i[k>>2]=96028,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93336,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+32>>2]=1751411826,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1768517221)switch(k-1752589105|0){case 0:break f0;case 18:break A0;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 17:break A;default:break k}if((k|0)==1768517222)break s0;if((k|0)!=1768714083)break A;k=C(176),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+152>>2]=0,i[k+144>>2]=0,i[k>>2]=96108,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=92528,t[k+133|0]=0,t[k+134|0]=0,t[k+135|0]=0,t[k+136|0]=0,t[k+137|0]=0,t[k+138|0]=0,t[k+139|0]=0,t[k+140|0]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1768714083,t[k+148|0]=0,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1769107315){if((k|0)<=1768975712){if((k|0)==1768778098)break k0;if((k|0)==1768842853)break u0;if((k|0)!=1768973167)break A;k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=96268,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=93736,i[k+32>>2]=1768973167,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1768975713)break l0;if((k|0)==1768977008)break Z0;if((k|0)!=1769104742)break A;k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=96548,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=94284,i[k+32>>2]=1769104742,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1781689159){if((k|0)==1769107316)break n0;if((k|0)==1769173093)break o0;if((k|0)!=1769234793)break A;k=C(144),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=98428,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=95668,i[k+32>>2]=1769234793,i[k+128>>2]=0,i[k+132>>2]=0,t[k+120|0]=1,t[k+135|0]=0,t[k+136|0]=0,t[k+137|0]=0,t[k+138|0]=0,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}switch(k-1781689160|0){case 1:case 2:case 3:break A;case 0:break _0;case 4:break C;default:break J}}if((k|0)<=1935963247){if((k|0)<=1836280642){if((k|0)<=1835365472){if((k|0)<=1835295605){if((k|0)==1785751363)break x;if((k|0)==1819501932)break q;if((k|0)!=1835295092)break A;k=C(120),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=98708,o=k+16|0,l0(o,0,104),i[k+52>>2]=0,i[k+56>>2]=0,i[k+16>>2]=92868,i[k+60>>2]=0,i[k+64>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[n+260>>2]=k,i[n+256>>2]=o,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1835295606)break S;if((k|0)==1835296868)break V;if((k|0)!=1835297121)break A;k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=99148,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=99188,i[k+32>>2]=1835297121,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)<=1835692134)switch(k-1835626086|0){case 1:case 2:break A;case 0:break X;case 3:break p;default:break h0}if((k|0)==1835692135)break z;if((k|0)!=1836019574)break A;k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=98828,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=98868,i[k+32>>2]=1836019574,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)<=1885960296){if((k|0)<=1885434735){if((k|0)==1836280643)break M;if((k|0)==1836476516)break F;if((k|0)!=1852663908)break A;k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=1,i[k+16>>2]=111736,i[k>>2]=100388,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1852663908,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1885434736)break a;if((k|0)==1885564018)break y;if((k|0)!=1885959277)break A;k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=96068,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93416,i[k+32>>2]=1885959277,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1935763822){if((k|0)==1885960297)break K;if((k|0)==1886545522)break n;if((k|0)!=1887006052)break A;k=C(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=97148,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+16>>2]=94684,i[k+144>>2]=0,i[k+148>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1887006052,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}switch(k-1935763823|0){case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:break A;case 0:break u;case 11:break s;default:break w}}if((k|0)<=1952541026){if((k|0)<=1937007985){if((k|0)<=1936419183){if((k|0)==1935963248)break t;if((k|0)!=1936158820)break A;k=C(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+148>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,t[k+136|0]=0,t[k+132|0]=0,t[k+128|0]=0,t[k+124|0]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=112904,i[k>>2]=100148,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1936158820,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1936419184)break r;if((k|0)==1937007212)break Z;if((k|0)!=1937007471)break A;k=C(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=112136,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=99748,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1937007471,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}G:switch(k-1937011555|0){case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 17:case 18:case 19:case 20:case 21:case 22:break A;case 0:break m;case 1:break g;case 16:break v;case 23:break B;default:break G}if((k|0)==1937007986)break c;if((k|0)!=1937011827)break A;k=C(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=111896,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=99628,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1937011827,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1970432364){if((k|0)<=1953654117){if((k|0)==1952541027)break U;if((k|0)==1953196132)break I;if((k|0)!=1953653099)break A;k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=98988,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=99028,i[k+32>>2]=1953653099,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1953654118)break o;if((k|0)==1969513843)break R;if((k|0)!=1970432288)break A;k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=112696,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=100348,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+128>>2]=0,i[k+32>>2]=1970432288,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1986881635){if((k|0)==1970432365)break l;if((k|0)==1970433056)break d;if((k|0)!=1970628964)break A;if(z3(n+40|0,n+288|0),i[n+240>>2]=16,t[n+80|0]=157,t[n+81|0]=144,t[n+82|0]=78,t[n+83|0]=182,t[n+84|0]=236,t[n+85|0]=186,t[n+86|0]=243,t[n+87|0]=163,t[n+72|0]=34,t[n+73|0]=204,t[n+74|0]=4,t[n+75|0]=199,t[n+76|0]=214,t[n+77|0]=217,t[n+78|0]=78,t[n+79|0]=7,i[n+236>>2]=n+72,k=i[n+240>>2],i[n+24>>2]=i[n+236>>2],i[n+28>>2]=k,o=0,s=x5(n+244|0,n+24|0),l=i[s>>2],k=i[n+40>>2],h=i[n+44>>2]-k|0,(i[s+4>>2]-l|0)==(h|0)&&(o=!N2(k,l,h)),l&&(i[s+4>>2]=l,Z(l),k=i[n+40>>2]),k&&(i[n+44>>2]=k,Z(k)),!o)break Q;Qo(n+72|0),o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;G:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}switch(k-1987470129|0){case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 17:break A;case 0:break i0;case 18:break e0;default:break W}}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=95948,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=93096,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+32>>2]=1718909296,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;w0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break w0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)!=1835365473)break A;k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=95908,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93256,i[k+32>>2]=1835365473,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;h0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break h0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=96148,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93576,i[k+32>>2]=1768517222,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;s0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break s0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(184),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,X[k+124>>1]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k>>2]=96188,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93496,t[k+173|0]=0,t[k+174|0]=0,t[k+175|0]=0,t[k+176|0]=0,t[k+177|0]=0,t[k+178|0]=0,t[k+179|0]=0,t[k+180|0]=0,i[k+168>>2]=0,i[k+172>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1768842853,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;u0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break u0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=96228,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=93656,i[k+32>>2]=1768977008,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=96308,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93884,i[k+32>>2]=1768975713,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;l0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break l0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=96348,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93816,i[k+32>>2]=1769173093,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;o0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break o0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=96388,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93964,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1635088451,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;t0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break t0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k>>2]=96428,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=94044,i[k+32>>2]=1769107316,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;n0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break n0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k>>2]=96468,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=94124,i[k+32>>2]=1768778098,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;k0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break k0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(160),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+156>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,t[k+145|0]=4,i[k+124>>2]=0,i[k+128>>2]=0,i[k+16>>2]=104068,i[k>>2]=96588,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1752589123,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;A0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break A0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,X[k+118>>1]=0,X[k+120>>1]=0,X[k+122>>1]=0,X[k+124>>1]=0,X[k+116>>1]=1,i[k>>2]=96628,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,X[k+126>>1]=0,X[k+128>>1]=0,X[k+130>>1]=0,X[k+132>>1]=0,X[k+134>>1]=0,X[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=96668,i[k+32>>2]=1752589105,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;f0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break f0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,X[k+118>>1]=0,X[k+120>>1]=0,X[k+122>>1]=0,X[k+124>>1]=0,X[k+116>>1]=1,i[k>>2]=96788,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,X[k+126>>1]=0,X[k+128>>1]=0,X[k+130>>1]=0,X[k+132>>1]=0,X[k+134>>1]=0,X[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=96828,i[k+32>>2]=1635135537,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;r0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break r0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(208),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,X[k+120>>1]=259,i[k+16>>2]=106584,X[k+122>>1]=0,X[k+124>>1]=0,X[k+126>>1]=0,X[k+128>>1]=0,i[k>>2]=96908,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,X[k+130>>1]=0,X[k+132>>1]=0,X[k+182>>1]=0,X[k+184>>1]=0,X[k+186>>1]=0,X[k+188>>1]=0,i[k+176>>2]=0,i[k+180>>2]=0,i[k+168>>2]=0,i[k+172>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+200>>2]=0,i[k+192>>2]=0,i[k+196>>2]=0,i[k+32>>2]=1987470147,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;e0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break e0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,X[k+118>>1]=0,X[k+120>>1]=0,X[k+122>>1]=0,X[k+124>>1]=0,X[k+116>>1]=1,i[k>>2]=96948,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,X[k+126>>1]=0,X[k+128>>1]=0,X[k+130>>1]=0,X[k+132>>1]=0,X[k+134>>1]=0,X[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=96988,i[k+32>>2]=1987470129,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;i0:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break i0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=97108,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=94444,i[k+32>>2]=1735553132,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=97228,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+16>>2]=94604,i[k+32>>2]=1937007986,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;c:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break c;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=97268,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=94764,i[k+32>>2]=1684631142,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=97308,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=94844,i[k+32>>2]=1685218662,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;b:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break b;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+116>>2]=1,i[k>>2]=97348,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=94924,i[k+128>>2]=0,i[k+32>>2]=1970433056,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;d:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break d;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=101860,i[k>>2]=97388,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1668246642,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;$:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break $;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=97428,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=95004,i[k+32>>2]=1885960297,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;K:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break K;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=1,i[k+120>>2]=1,i[k>>2]=97468,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=95084,i[k+32>>2]=1885434736,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;a:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break a;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,X[k+114>>1]=0,i[k>>2]=97508,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=95164,i[k+32>>2]=1819501932,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;q:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=104780,i[k>>2]=97548,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1630629744,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;L:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break L;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=104860,i[k>>2]=97588,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+124>>2]=0,i[k+32>>2]=1630628984,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;P:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break P;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,X[k+114>>1]=0,X[k+116>>1]=0,i[k>>2]=97628,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=95244,i[k+32>>2]=1668050025,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;O:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break O;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(144),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=97668,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=92596,i[k+132>>2]=0,i[k+136>>2]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+32>>2]=1835295606,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;S:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break S;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=97708,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=92664,i[k+32>>2]=1634563685,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;j:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break j;W[i[i[k>>2]+8>>2]](k),y(k)}break e}Qo(n+72|0),o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;T:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break T;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=97828,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=95520,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+32>>2]=1969513843,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;R:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break R;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=105168,i[k>>2]=97868,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1785751363,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;x:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break x;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,X[k+118>>1]=0,X[k+120>>1]=0,X[k+122>>1]=0,X[k+124>>1]=0,X[k+116>>1]=1,i[k>>2]=97908,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,X[k+126>>1]=0,X[k+128>>1]=0,X[k+130>>1]=0,X[k+132>>1]=0,X[k+134>>1]=0,X[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=97948,i[k+32>>2]=1835692135,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;z:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break z;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=98028,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=95816,i[k+128>>2]=0,i[k+32>>2]=1701604967,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;H:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break H;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=106136,i[k>>2]=98068,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1781689160,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=105816,i[k>>2]=98108,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1667523942,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;E:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break E;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=105896,i[k>>2]=98148,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1668112752,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;N:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break N;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(144),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=105976,i[k>>2]=98188,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1885564018,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;y:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break y;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=106056,i[k>>2]=98228,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1781689164,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;C:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break C;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)!=1781689193)break A;k=C(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,X[k+118>>1]=0,X[k+120>>1]=0,X[k+122>>1]=0,X[k+124>>1]=0,X[k+116>>1]=1,i[k>>2]=98268,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,X[k+126>>1]=0,X[k+128>>1]=0,X[k+130>>1]=0,X[k+132>>1]=0,X[k+134>>1]=0,X[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=98308,i[k+32>>2]=1781689193,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;J:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break J;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,t[k+120|0]=0,i[k+16>>2]=107128,i[k>>2]=98388,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1836280643,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;M:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break M;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(152),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=98468,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=95600,i[k+32>>2]=1952541027,t[k+144|0]=0,i[k+136>>2]=0,i[k+140>>2]=2147483647,i[k+128>>2]=-1,i[k+132>>2]=-1,t[k+120|0]=1,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;U:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break U;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+16>>2]=106924,X[k+128>>1]=2056,i[k+124>>2]=1,i[k>>2]=98508,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,t[k+120|0]=0,i[k+164>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1635148611,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;D:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break D;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,X[k+118>>1]=0,X[k+120>>1]=0,X[k+122>>1]=0,X[k+124>>1]=0,X[k+116>>1]=1,i[k>>2]=98548,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,X[k+126>>1]=0,X[k+128>>1]=0,X[k+130>>1]=0,X[k+132>>1]=0,X[k+134>>1]=0,X[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=98588,i[k+32>>2]=1635148593,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;Y:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break Y;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(464),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+16>>2]=114076,t[k+113|0]=0,t[k+114|0]=0,t[k+115|0]=0,t[k+116|0]=0,t[k+117|0]=0,t[k+118|0]=0,t[k+119|0]=0,t[k+120|0]=0,i[k>>2]=98668,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,t[k+118|0]=0,t[k+119|0]=0,t[k+120|0]=0,t[k+121|0]=0,t[k+122|0]=0,t[k+123|0]=0,t[k+124|0]=0,t[k+125|0]=0,t[k+137|0]=0,t[k+138|0]=0,t[k+139|0]=0,t[k+140|0]=0,t[k+141|0]=0,t[k+142|0]=0,t[k+143|0]=0,t[k+144|0]=0,t[k+136|0]=8,t[k+145|0]=0,i[k+148>>2]=0,i[k+152>>2]=0,t[k+156|0]=0,i[k+160>>2]=0,i[k+164>>2]=0,X[k+166>>1]=0,X[k+168>>1]=0,X[k+170>>1]=0,X[k+172>>1]=0,i[k+344>>2]=0,i[k+348>>2]=0,i[k+352>>2]=0,i[k+360>>2]=0,i[k+364>>2]=0,i[k+368>>2]=0,i[k+376>>2]=0,i[k+380>>2]=0,i[k+384>>2]=0,X[k+174>>1]=8,t[k+176|0]=0,X[k+178>>1]=0,X[k+180>>1]=0,X[k+182>>1]=0,X[k+184>>1]=0,t[k+186|0]=0,i[k+188>>2]=0,i[k+192>>2]=0,i[k+196>>2]=0,i[k+200>>2]=0,i[k+204>>2]=0,i[k+208>>2]=0,i[k+212>>2]=0,i[k+216>>2]=0,X[k+220>>1]=0,l0(k+224|0,0,116),l0(k+392|0,0,72),i[k+32>>2]=1835626089,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;p:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break p;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if(z3(n+40|0,n+288|0),i[n+232>>2]=16,t[n+80|0]=151,t[n+81|0]=174,t[n+82|0]=190,t[n+83|0]=166,t[n+84|0]=152,t[n+85|0]=3,t[n+86|0]=180,t[n+87|0]=52,t[n+72|0]=67,t[n+73|0]=99,t[n+74|0]=233,t[n+75|0]=20,t[n+76|0]=91,t[n+77|0]=125,t[n+78|0]=74,t[n+79|0]=171,i[n+228>>2]=n+72,k=i[n+232>>2],i[n+16>>2]=i[n+228>>2],i[n+20>>2]=k,o=0,s=x5(n+244|0,n+16|0),l=i[s>>2],k=i[n+40>>2],h=i[n+44>>2]-k|0,(i[s+4>>2]-l|0)==(h|0)&&(o=!N2(k,l,h)),l&&(i[s+4>>2]=l,Z(l),k=i[n+40>>2]),k&&(i[n+44>>2]=k,Z(k)),o){ko(n+72|0),o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;Q:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if(z3(n+40|0,n+288|0),i[n+224>>2]=16,t[n+80|0]=172,t[n+81|0]=189,t[n+82|0]=157,t[n+83|0]=44,t[n+84|0]=142,t[n+85|0]=167,t[n+86|0]=53,t[n+87|0]=34,t[n+72|0]=38,t[n+73|0]=30,t[n+74|0]=243,t[n+75|0]=116,t[n+76|0]=29,t[n+77|0]=151,t[n+78|0]=91,t[n+79|0]=186,i[n+220>>2]=n+72,k=i[n+224>>2],i[n+8>>2]=i[n+220>>2],i[n+12>>2]=k,o=0,s=x5(n+244|0,n+8|0),l=i[s>>2],k=i[n+40>>2],h=i[n+44>>2]-k|0,(i[s+4>>2]-l|0)==(h|0)&&(o=!N2(k,l,h)),l&&(i[s+4>>2]=l,Z(l),k=i[n+40>>2]),k&&(i[n+44>>2]=k,Z(k)),o){o=C(128),i[o+24>>2]=0,i[o+28>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,i[o+72>>2]=-1,i[o+76>>2]=-1,i[o+88>>2]=0,i[o+92>>2]=0,i[o+116>>2]=0,i[o+120>>2]=0,i[o>>2]=98748,i[o+32>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+52>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o- -64>>2]=0,i[o+80>>2]=-1,i[o+84>>2]=-1,i[o+96>>2]=0,i[o+100>>2]=0,i[o+104>>2]=0,i[o+108>>2]=0,t[o+112|0]=0,i[o+16>>2]=95736,i[o+124>>2]=0,l=C(16),t[l|0]=38,t[l+1|0]=30,t[l+2|0]=243,t[l+3|0]=116,t[l+4|0]=29,t[l+5|0]=151,t[l+6|0]=91,t[l+7|0]=186,t[l+8|0]=172,t[l+9|0]=189,t[l+10|0]=157,t[l+11|0]=44,t[l+12|0]=142,t[l+13|0]=167,t[l+14|0]=53,t[l+15|0]=34,i[o+32>>2]=1970628964,k=C(16),i[o+36>>2]=k,w=k+16|0,i[o+44>>2]=w,s=u[l+12|0]|u[l+13|0]<<8|(u[l+14|0]<<16|u[l+15|0]<<24),h=u[l+8|0]|u[l+9|0]<<8|(u[l+10|0]<<16|u[l+11|0]<<24),t[k+8|0]=h,t[k+9|0]=h>>>8,t[k+10|0]=h>>>16,t[k+11|0]=h>>>24,t[k+12|0]=s,t[k+13|0]=s>>>8,t[k+14|0]=s>>>16,t[k+15|0]=s>>>24,s=u[l+4|0]|u[l+5|0]<<8|(u[l+6|0]<<16|u[l+7|0]<<24),h=u[l|0]|u[l+1|0]<<8|(u[l+2|0]<<16|u[l+3|0]<<24),t[k|0]=h,t[k+1|0]=h>>>8,t[k+2|0]=h>>>16,t[k+3|0]=h>>>24,t[k+4|0]=s,t[k+5|0]=s>>>8,t[k+6|0]=s>>>16,t[k+7|0]=s>>>24,i[o+40>>2]=w,Z(l),i[n+76>>2]=o,i[n+72>>2]=o+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;Q:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}i[n+40>>2]=1970628964,kl(n+72|0,n+40|0),o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;Q:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(200),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+16>>2]=111416,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=98948,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,X[k+156>>1]=256,i[k+152>>2]=65536,i[k+196>>2]=0,i[k+32>>2]=1836476516,o=i[13102],i[k+160>>2]=i[13101],i[k+164>>2]=o,o=i[13104],i[k+168>>2]=i[13103],i[k+172>>2]=o,o=i[13106],i[k+176>>2]=i[13105],i[k+180>>2]=o,o=i[13108],i[k+184>>2]=i[13107],i[k+188>>2]=o,i[k+192>>2]=i[13109],i[n+72>>2]=k+16,i[n+76>>2]=k,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;F:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break F;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(208),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+152>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+16>>2]=111496,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=99108,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+136>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,X[k+156>>1]=256,i[k+196>>2]=0,i[k+200>>2]=0,i[k+116>>2]=7,i[k+32>>2]=1953196132,i[k+192>>2]=i[13109],o=i[13108],i[k+184>>2]=i[13107],i[k+188>>2]=o,o=i[13106],i[k+176>>2]=i[13105],i[k+180>>2]=o,o=i[13104],i[k+168>>2]=i[13103],i[k+172>>2]=o,o=i[13102],i[k+160>>2]=i[13101],i[k+164>>2]=o,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;I:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break I;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(160),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+16>>2]=111576,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=99268,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1835296868,t[k+152|0]=117,t[k+153|0]=110,t[k+154|0]=107,t[k+155|0]=0,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;V:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break V;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=99308,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=99348,i[k+32>>2]=1835626086,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)!=1986881636)break A;k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=111656,i[k+116>>2]=1,i[k>>2]=99428,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1986881636,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;W:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break W;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=99468,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=99508,i[k+32>>2]=1937007212,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=111816,i[k>>2]=99588,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1937011556,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;g:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break g;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=112056,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=99708,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1937011555,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;m:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break m;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=112216,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=99788,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+32>>2]=1937011578,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;B:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break B;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=112296,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=99828,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,t[k+133|0]=0,t[k+134|0]=0,t[k+135|0]=0,t[k+136|0]=0,t[k+137|0]=0,t[k+138|0]=0,t[k+139|0]=0,t[k+140|0]=0,i[k+32>>2]=1937011571,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;v:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break v;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=113384,i[k>>2]=100068,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1701606260,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;_:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break _;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)!=1935828848)break A;k=C(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,t[k+128|0]=0,t[k+124|0]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=112776,i[k>>2]=100108,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+148>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1935828848,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;w:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break w;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=112984,i[k>>2]=100188,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1651798644,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;h:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break h;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(160),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=113064,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=100228,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,t[k+128|0]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1935763834,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;s:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break s;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=113144,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=100268,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,t[k+128|0]=0,i[k+160>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+32>>2]=1935763823,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;u:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break u;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=112616,i[k>>2]=100308,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1970432365,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=113304,i[k>>2]=100428,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1953654118,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;o:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break o;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=113224,i[k>>2]=100468,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1935963248,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;t:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break t;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=114196,i[k>>2]=100508,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+32>>2]=1886545522,i[n+76>>2]=k,i[n+72>>2]=k+16,o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;n:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break n;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1768186228)break f}i[n+40>>2]=k,kl(n+72|0,n+40|0),o=i[n+72>>2],l=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=o,i[n+260>>2]=l;A:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break A;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=C(152),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=97068,o=k+16|0,l0(o,0,136),i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=94364,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[n+260>>2]=k,i[n+256>>2]=o,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=C(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=95988,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=93176,i[k+32>>2]=1718773093,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0}o=n+72|0,g2(o),l=i[n+300>>2],k=i[n+256>>2],i[k+8>>2]=i[n+296>>2],i[k+12>>2]=l,i[k+16>>2]=i[n+304>>2],l=i[n+308>>2],s=i[n+312>>2],$4(k+20|0,l,s,s-l|0),l=k,k=i[n+320>>2],i[l+32>>2]=k,Ce(o,n+288|0),o=i[n+256>>2],t[o+95|0]<0&&Z(i[o+84>>2]),l=i[n+76>>2],i[o+84>>2]=i[n+72>>2],i[o+88>>2]=l,i[o+92>>2]=i[n+80>>2];e:{if(i[e+12>>2]>=21){if(e=C(64),i[n+72>>2]=e,i[n+76>>2]=61,i[n+80>>2]=-2147483584,r=u[19005]|u[19006]<<8|(u[19007]<<16|u[19008]<<24),f=u[19001]|u[19002]<<8|(u[19003]<<16|u[19004]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+61|0]=0,r=u[19058]|u[19059]<<8|(u[19060]<<16|u[19061]<<24),f=u[19054]|u[19055]<<8|(u[19056]<<16|u[19057]<<24),t[e+53|0]=f,t[e+54|0]=f>>>8,t[e+55|0]=f>>>16,t[e+56|0]=f>>>24,t[e+57|0]=r,t[e+58|0]=r>>>8,t[e+59|0]=r>>>16,t[e+60|0]=r>>>24,r=u[19053]|u[19054]<<8|(u[19055]<<16|u[19056]<<24),f=u[19049]|u[19050]<<8|(u[19051]<<16|u[19052]<<24),t[e+48|0]=f,t[e+49|0]=f>>>8,t[e+50|0]=f>>>16,t[e+51|0]=f>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[19045]|u[19046]<<8|(u[19047]<<16|u[19048]<<24),f=u[19041]|u[19042]<<8|(u[19043]<<16|u[19044]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[19037]|u[19038]<<8|(u[19039]<<16|u[19040]<<24),f=u[19033]|u[19034]<<8|(u[19035]<<16|u[19036]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[19029]|u[19030]<<8|(u[19031]<<16|u[19032]<<24),f=u[19025]|u[19026]<<8|(u[19027]<<16|u[19028]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[19021]|u[19022]<<8|(u[19023]<<16|u[19024]<<24),f=u[19017]|u[19018]<<8|(u[19019]<<16|u[19020]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[19013]|u[19014]<<8|(u[19015]<<16|u[19016]<<24),f=u[19009]|u[19010]<<8|(u[19011]<<16|u[19012]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,1e3,n+72|0),t[n+83|0]>=0)break e;Z(i[n+72>>2]);break e}r:{f:{A:{o=i[n+296>>2],s=i[n+300>>2];k:{if(o|s){if(l=k,!s&k>>>0>o>>>0){i[n+164>>2]=0,i[n+136>>2]=78164,i[n+80>>2]=78144,e=i[19545],i[n+72>>2]=e,r=i[e-12>>2],e=n+72|0,i[r+e>>2]=i[19546],i[n+76>>2]=0,r=e+i[i[n+72>>2]-12>>2]|0,f=n+84|0,J0(r,f),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[n+80>>2]=r,l=i[r-12>>2],r=n+80|0,i[l+r>>2]=i[19548],l=i[19544],i[n+72>>2]=l,i[e+i[l-12>>2]>>2]=i[19549],i[n+136>>2]=78164,i[n+72>>2]=78124,i[n+80>>2]=78144,f=R0(f),i[f>>2]=77200,i[n+124>>2]=0,i[n+128>>2]=0,i[n+116>>2]=0,i[n+120>>2]=0,i[n+132>>2]=24,F(B0(F(M2(F(r,30482,10),o,s),30493,34),k),29508,7),e=i[n+132>>2];n:{if(e&16){k=n+104|0,r=i[n+128>>2],e=i[n+108>>2],r>>>0<e>>>0?i[n+128>>2]=e:e=r;break n}if(!(e&8)){e=0,t[n+51|0]=0,k=n+40|0;break r}k=n+92|0,e=i[n+100>>2]}if(r=i[k>>2],e=e-r|0,e>>>0>=2147483640)break A;if(e>>>0>=11){o=e|7,k=C(o+1|0),i[n+48>>2]=o-2147483647,i[n+40>>2]=k,i[n+44>>2]=e;break f}if(t[n+51|0]=e,k=n+40|0,e)break f;e=0;break r}if(k=o-l|0,o=s-(o>>>0<l>>>0)|0,(o|0)==1|o>>>0>1){if(e=A,A=V2(n+72|0,15100),a(e,6,101,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}if((s|0)<0){if(e=A,A=V2(n+72|0,47881),a(e,2,101,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(l=i[e>>2],s=W[i[i[l>>2]+8>>2]](l)|0,h=i[e>>2],l=h0,s=k+s|0,l=s>>>0<k>>>0?l+1|0:l,W[i[i[h>>2]+12>>2]](h,s,l)|0){if(e=A,A=V2(n+72|0,47881),a(e,2,100,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(!o&o0[e+16>>2]>=k>>>0)break k;if(t[n+72|0]=0,t[n+83|0]=0,a(A,2,101,n+72|0),t[n+83|0]>=0)break e;Z(i[n+72>>2]);break e}k=i[e+16>>2]}if(i[n+64>>2]=i[e>>2],o=i[e+4>>2],i[n+68>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),o=i[n+68>>2],i[n>>2]=i[n+64>>2],i[n+4>>2]=o,k=$i(n+72|0,n,k,e),e=i[n+256>>2],W[i[i[e>>2]+48>>2]](n+40|0,e,k,f),e=i[n+44>>2],i[n+264>>2]=i[n+40>>2],i[n+268>>2]=e,t[n+283|0]<0&&Z(i[n+272>>2]),e=i[n+52>>2],i[n+272>>2]=i[n+48>>2],i[n+276>>2]=e,i[n+280>>2]=i[n+56>>2],f=i[k+16>>2],f&&(e=i[k+8>>2],e&&(l4(e,f),f=i[k+16>>2]),e=i[k>>2],l=W[i[i[e>>2]+8>>2]](e)|0,o=h0,s=f,f=f+l|0,o=s>>>0>f>>>0?o+1|0:o,W[i[i[e>>2]+20>>2]](e,f,o)|0,i[k+16>>2]=0),i[n+264>>2]!=i[28728]){e=i[n+256>>2],_=n,B=W[i[i[e>>2]+36>>2]](e)|0,i[_+244>>2]=B,i[n+36>>2]=i[i[n+256>>2]+16>>2],o=v-32|0,v=o,e=C(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=100548,l=i[n+36>>2],f=i[n+268>>2],i[o+8>>2]=i[n+264>>2],i[o+12>>2]=f,f=o+16|0;k:{if(t[n+283|0]>=0){s=i[n+276>>2],i[f>>2]=i[n+272>>2],i[f+4>>2]=s,i[f+8>>2]=i[n+280>>2];break k}T(f,i[n+272>>2],i[n+276>>2])}s=i[n+244>>2],i[e- -64>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,t[e+112|0]=0,i[e+16>>2]=93016,i[e+120>>2]=0,i[e+124>>2]=0,i[e+136>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+116>>2]=l,i[e+32>>2]=1163022880,l=i[o+12>>2],i[e+120>>2]=i[o+8>>2],i[e+124>>2]=l,t[e+139|0]<0&&Z(i[e+128>>2]),l=i[f+4>>2],i[e+128>>2]=i[f>>2],i[e+132>>2]=l,i[e+136>>2]=i[f+8>>2],i[e+140>>2]=s,i[n+44>>2]=e,i[n+40>>2]=e+16,v=o+32|0,f=i[n+40>>2],o=i[n+44>>2],i[n+40>>2]=0,i[n+44>>2]=0,e=i[n+260>>2],i[n+256>>2]=f,i[n+260>>2]=o;k:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break k;W[i[i[e>>2]+8>>2]](e),y(e)}g2(n+40|0)}if(Q8(r,n+256|0),e=i[n+268>>2],i[A>>2]=i[n+264>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+280>>2],e=i[n+276>>2],i[A+8>>2]=i[n+272>>2],i[A+12>>2]=e,i[n+272>>2]=0,i[n+276>>2]=0,i[n+280>>2]=0,A=i[k+4>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}I0(),M()}if(!e)break r;z(k,r,e)}t[e+k|0]=0,a(A,2,101,n+40|0),t[n+51|0]<0&&Z(i[n+40>>2]),A=i[19543],i[n+72>>2]=A,i[i[A-12>>2]+(n+72|0)>>2]=i[19551],i[n+80>>2]=i[19552],i[f>>2]=77200,t[n+127|0]<0&&Z(i[n+116>>2]),y0(f),Y0(n+136|0)}if(A=i[n+260>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}t[n+283|0]<0&&Z(i[n+272>>2]),A=i[n+308>>2],A&&Z(A),v=n+336|0}function fA(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0;Y=v-48|0,v=Y,f=i[r>>2],n=i[r+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[e+8>>2]=f,h=i[e+12>>2],i[e+12>>2]=n;i:{if(!h||(f=i[h+4>>2],i[h+4>>2]=f-1,f))break i;W[i[i[h>>2]+8>>2]](h),y(h)}if(i[Y+24>>2]=0,i[Y+28>>2]=0,i[Y+40>>2]=0,i[Y+32>>2]=0,i[Y+36>>2]=0,O=i[e+168>>2],s=v-336|0,v=s,o=i[e>>2],n=i[o+16>>2],l=i[o+20>>2],(n|0)!=(l|0))for(;;){h=i[l-4>>2];i:{if(!h||(f=i[h+4>>2],i[h+4>>2]=f-1,f))break i;W[i[i[h>>2]+8>>2]](h),y(h)}if(l=l-8|0,(n|0)==(l|0))break}i[o+20>>2]=n,f=i[r>>2],n=i[r+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[o+72>>2]=f,h=i[o+76>>2],i[o+76>>2]=n;i:{if(!h||(f=i[h+4>>2],i[h+4>>2]=f-1,f))break i;W[i[i[h>>2]+8>>2]](h),y(h)}f=i[r>>2],f=W[i[i[f>>2]+24>>2]](f,0,0,1024,0)|0,i[o+64>>2]=f,n=h0,i[o+68>>2]=n;i:{if(!n&f>>>0<=31){if(k=C(24),i[s+264>>2]=k,i[s+268>>2]=20,i[s+272>>2]=-2147483624,f=u[27011]|u[27012]<<8|(u[27013]<<16|u[27014]<<24),r=u[27007]|u[27008]<<8|(u[27009]<<16|u[27010]<<24),t[k|0]=r,t[k+1|0]=r>>>8,t[k+2|0]=r>>>16,t[k+3|0]=r>>>24,t[k+4|0]=f,t[k+5|0]=f>>>8,t[k+6|0]=f>>>16,t[k+7|0]=f>>>24,t[k+20|0]=0,r=u[27023]|u[27024]<<8|(u[27025]<<16|u[27026]<<24),t[k+16|0]=r,t[k+17|0]=r>>>8,t[k+18|0]=r>>>16,t[k+19|0]=r>>>24,f=u[27019]|u[27020]<<8|(u[27021]<<16|u[27022]<<24),r=u[27015]|u[27016]<<8|(u[27017]<<16|u[27018]<<24),t[k+8|0]=r,t[k+9|0]=r>>>8,t[k+10|0]=r>>>16,t[k+11|0]=r>>>24,t[k+12|0]=f,t[k+13|0]=f>>>8,t[k+14|0]=f>>>16,t[k+15|0]=f>>>24,a(Y,2,0,s+264|0),t[s+275|0]>=0)break i;Z(i[s+264>>2]);break i}i[s+304>>2]=i[o+72>>2],n=i[o+76>>2],i[s+308>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1,f=i[o+64>>2]),n=i[s+308>>2],i[s+40>>2]=i[s+304>>2],i[s+44>>2]=n,x=$i(s+312|0,s+40|0,f,0),N=s+264|0,f=N,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=92500,i[s+240>>2]=0,i[s+244>>2]=0,i[s+256>>2]=0,i[s+248>>2]=0,i[s+252>>2]=0,Wi(s+128|0,f,x),n=i[s+132>>2],f=i[s+128>>2],i[s+240>>2]=f,i[s+244>>2]=n,t[s+259|0]<0&&(Z(i[s+248>>2]),f=i[s+240>>2]),n=i[s+140>>2],i[s+248>>2]=i[s+136>>2],i[s+252>>2]=n,i[s+256>>2]=i[s+144>>2];e:{if(f){r=i[s+244>>2],i[Y>>2]=i[s+240>>2],i[Y+4>>2]=r,i[Y+16>>2]=i[s+256>>2],r=i[s+252>>2],i[Y+8>>2]=i[s+248>>2],i[Y+12>>2]=r,i[s+248>>2]=0,i[s+252>>2]=0,i[s+256>>2]=0;break e}if(i[N+16>>2]!=1718909296){if(k=C(40),i[s+128>>2]=k,i[s+132>>2]=36,i[s+136>>2]=-2147483608,f=u[24813]|u[24814]<<8|(u[24815]<<16|u[24816]<<24),r=u[24809]|u[24810]<<8|(u[24811]<<16|u[24812]<<24),t[k|0]=r,t[k+1|0]=r>>>8,t[k+2|0]=r>>>16,t[k+3|0]=r>>>24,t[k+4|0]=f,t[k+5|0]=f>>>8,t[k+6|0]=f>>>16,t[k+7|0]=f>>>24,t[k+36|0]=0,r=u[24841]|u[24842]<<8|(u[24843]<<16|u[24844]<<24),t[k+32|0]=r,t[k+33|0]=r>>>8,t[k+34|0]=r>>>16,t[k+35|0]=r>>>24,f=u[24837]|u[24838]<<8|(u[24839]<<16|u[24840]<<24),r=u[24833]|u[24834]<<8|(u[24835]<<16|u[24836]<<24),t[k+24|0]=r,t[k+25|0]=r>>>8,t[k+26|0]=r>>>16,t[k+27|0]=r>>>24,t[k+28|0]=f,t[k+29|0]=f>>>8,t[k+30|0]=f>>>16,t[k+31|0]=f>>>24,f=u[24829]|u[24830]<<8|(u[24831]<<16|u[24832]<<24),r=u[24825]|u[24826]<<8|(u[24827]<<16|u[24828]<<24),t[k+16|0]=r,t[k+17|0]=r>>>8,t[k+18|0]=r>>>16,t[k+19|0]=r>>>24,t[k+20|0]=f,t[k+21|0]=f>>>8,t[k+22|0]=f>>>16,t[k+23|0]=f>>>24,f=u[24821]|u[24822]<<8|(u[24823]<<16|u[24824]<<24),r=u[24817]|u[24818]<<8|(u[24819]<<16|u[24820]<<24),t[k+8|0]=r,t[k+9|0]=r>>>8,t[k+10|0]=r>>>16,t[k+11|0]=r>>>24,t[k+12|0]=f,t[k+13|0]=f>>>8,t[k+14|0]=f>>>16,t[k+15|0]=f>>>24,a(Y,2,102,s+128|0),t[s+139|0]>=0)break e;Z(i[s+128>>2]);break e}if(f=i[N+12>>2],w=f,h=i[N+8>>2],!(f|h)){if(k=C(48),i[s+128>>2]=k,i[s+132>>2]=46,i[s+136>>2]=-2147483600,f=u[14466]|u[14467]<<8|(u[14468]<<16|u[14469]<<24),r=u[14462]|u[14463]<<8|(u[14464]<<16|u[14465]<<24),t[k|0]=r,t[k+1|0]=r>>>8,t[k+2|0]=r>>>16,t[k+3|0]=r>>>24,t[k+4|0]=f,t[k+5|0]=f>>>8,t[k+6|0]=f>>>16,t[k+7|0]=f>>>24,t[k+46|0]=0,f=u[14504]|u[14505]<<8|(u[14506]<<16|u[14507]<<24),r=u[14500]|u[14501]<<8|(u[14502]<<16|u[14503]<<24),t[k+38|0]=r,t[k+39|0]=r>>>8,t[k+40|0]=r>>>16,t[k+41|0]=r>>>24,t[k+42|0]=f,t[k+43|0]=f>>>8,t[k+44|0]=f>>>16,t[k+45|0]=f>>>24,f=u[14498]|u[14499]<<8|(u[14500]<<16|u[14501]<<24),r=u[14494]|u[14495]<<8|(u[14496]<<16|u[14497]<<24),t[k+32|0]=r,t[k+33|0]=r>>>8,t[k+34|0]=r>>>16,t[k+35|0]=r>>>24,t[k+36|0]=f,t[k+37|0]=f>>>8,t[k+38|0]=f>>>16,t[k+39|0]=f>>>24,f=u[14490]|u[14491]<<8|(u[14492]<<16|u[14493]<<24),r=u[14486]|u[14487]<<8|(u[14488]<<16|u[14489]<<24),t[k+24|0]=r,t[k+25|0]=r>>>8,t[k+26|0]=r>>>16,t[k+27|0]=r>>>24,t[k+28|0]=f,t[k+29|0]=f>>>8,t[k+30|0]=f>>>16,t[k+31|0]=f>>>24,f=u[14482]|u[14483]<<8|(u[14484]<<16|u[14485]<<24),r=u[14478]|u[14479]<<8|(u[14480]<<16|u[14481]<<24),t[k+16|0]=r,t[k+17|0]=r>>>8,t[k+18|0]=r>>>16,t[k+19|0]=r>>>24,t[k+20|0]=f,t[k+21|0]=f>>>8,t[k+22|0]=f>>>16,t[k+23|0]=f>>>24,f=u[14474]|u[14475]<<8|(u[14476]<<16|u[14477]<<24),r=u[14470]|u[14471]<<8|(u[14472]<<16|u[14473]<<24),t[k+8|0]=r,t[k+9|0]=r>>>8,t[k+10|0]=r>>>16,t[k+11|0]=r>>>24,t[k+12|0]=f,t[k+13|0]=f>>>8,t[k+14|0]=f>>>16,t[k+15|0]=f>>>24,a(Y,2,102,s+128|0),t[s+139|0]>=0)break e;Z(i[s+128>>2]);break e}if(f=i[o+68>>2],(w|0)==(f|0)&h>>>0>o0[o+64>>2]|f>>>0<w>>>0){if(k=C(40),i[s+128>>2]=k,i[s+132>>2]=39,i[s+136>>2]=-2147483608,f=u[15408]|u[15409]<<8|(u[15410]<<16|u[15411]<<24),r=u[15404]|u[15405]<<8|(u[15406]<<16|u[15407]<<24),t[k|0]=r,t[k+1|0]=r>>>8,t[k+2|0]=r>>>16,t[k+3|0]=r>>>24,t[k+4|0]=f,t[k+5|0]=f>>>8,t[k+6|0]=f>>>16,t[k+7|0]=f>>>24,t[k+39|0]=0,f=u[15439]|u[15440]<<8|(u[15441]<<16|u[15442]<<24),r=u[15435]|u[15436]<<8|(u[15437]<<16|u[15438]<<24),t[k+31|0]=r,t[k+32|0]=r>>>8,t[k+33|0]=r>>>16,t[k+34|0]=r>>>24,t[k+35|0]=f,t[k+36|0]=f>>>8,t[k+37|0]=f>>>16,t[k+38|0]=f>>>24,f=u[15432]|u[15433]<<8|(u[15434]<<16|u[15435]<<24),r=u[15428]|u[15429]<<8|(u[15430]<<16|u[15431]<<24),t[k+24|0]=r,t[k+25|0]=r>>>8,t[k+26|0]=r>>>16,t[k+27|0]=r>>>24,t[k+28|0]=f,t[k+29|0]=f>>>8,t[k+30|0]=f>>>16,t[k+31|0]=f>>>24,f=u[15424]|u[15425]<<8|(u[15426]<<16|u[15427]<<24),r=u[15420]|u[15421]<<8|(u[15422]<<16|u[15423]<<24),t[k+16|0]=r,t[k+17|0]=r>>>8,t[k+18|0]=r>>>16,t[k+19|0]=r>>>24,t[k+20|0]=f,t[k+21|0]=f>>>8,t[k+22|0]=f>>>16,t[k+23|0]=f>>>24,f=u[15416]|u[15417]<<8|(u[15418]<<16|u[15419]<<24),r=u[15412]|u[15413]<<8|(u[15414]<<16|u[15415]<<24),t[k+8|0]=r,t[k+9|0]=r>>>8,t[k+10|0]=r>>>16,t[k+11|0]=r>>>24,t[k+12|0]=f,t[k+13|0]=f>>>8,t[k+14|0]=f>>>16,t[k+15|0]=f>>>24,a(Y,2,102,s+128|0),t[s+139|0]>=0)break e;Z(i[s+128>>2]);break e}i[s+208>>2]=i[o+72>>2],f=i[o+76>>2],i[s+212>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[s+212>>2],i[s+32>>2]=i[s+208>>2],i[s+36>>2]=f,R=wr(s+216|0,s+32|0,0,h),i[s+200>>2]=0,i[s+204>>2]=0,c8(s+128|0,R,s+200|0,O),f=i[s+132>>2],i[s+240>>2]=i[s+128>>2],i[s+244>>2]=f,t[s+259|0]<0&&Z(i[s+248>>2]),f=i[s+140>>2],i[s+248>>2]=i[s+136>>2],i[s+252>>2]=f,i[s+256>>2]=i[s+144>>2],B=o+16|0,P0(B,s+200|0),l=0,f=i[s+200>>2];r:{if(!f)break r;if(l=Z0(f,92792,93156),!l){l=0;break r}if(m=i[s+204>>2],!m){m=0;break r}i[m+4>>2]=i[m+4>>2]+1}i[o+28>>2]=l,n=i[o+32>>2],i[o+32>>2]=m;r:{if(!n||(f=i[n+4>>2],i[n+4>>2]=f-1,f))break r;W[i[i[n>>2]+8>>2]](n),y(n)}for(j=o+52|0,E=o+44|0,I=Y+8|0,m=0;;){f=w,l=h+32|0,_=l>>>0<32?f+1|0:f,Q=i[o+68>>2],V=Q,f=i[o+64>>2],(_|0)==(V|0)&f>>>0<l>>>0|_>>>0>V>>>0&&(f=i[r>>2],f=W[i[i[f>>2]+24>>2]](f,h,w,l,_)|0,n=h0,Q=n,i[o+64>>2]=f,i[o+68>>2]=n);r:{if((_|0)==(Q|0)&f>>>0<l>>>0|_>>>0>Q>>>0){if((m|U|k)&1){if(r=i[28729],i[Y>>2]=i[28728],i[Y+4>>2]=r,t[114931]>=0){r=i[28731],i[I>>2]=i[28730],i[I+4>>2]=r,i[I+8>>2]=i[28732];break r}T(I,i[28730],i[28731]);break r}if(k=C(24),i[s+128>>2]=k,i[s+132>>2]=23,i[s+136>>2]=-2147483624,f=u[20436]|u[20437]<<8|(u[20438]<<16|u[20439]<<24),r=u[20432]|u[20433]<<8|(u[20434]<<16|u[20435]<<24),t[k|0]=r,t[k+1|0]=r>>>8,t[k+2|0]=r>>>16,t[k+3|0]=r>>>24,t[k+4|0]=f,t[k+5|0]=f>>>8,t[k+6|0]=f>>>16,t[k+7|0]=f>>>24,t[k+23|0]=0,f=u[20451]|u[20452]<<8|(u[20453]<<16|u[20454]<<24),r=u[20447]|u[20448]<<8|(u[20449]<<16|u[20450]<<24),t[k+15|0]=r,t[k+16|0]=r>>>8,t[k+17|0]=r>>>16,t[k+18|0]=r>>>24,t[k+19|0]=f,t[k+20|0]=f>>>8,t[k+21|0]=f>>>16,t[k+22|0]=f>>>24,f=u[20444]|u[20445]<<8|(u[20446]<<16|u[20447]<<24),r=u[20440]|u[20441]<<8|(u[20442]<<16|u[20443]<<24),t[k+8|0]=r,t[k+9|0]=r>>>8,t[k+10|0]=r>>>16,t[k+11|0]=r>>>24,t[k+12|0]=f,t[k+13|0]=f>>>8,t[k+14|0]=f>>>16,t[k+15|0]=f>>>24,a(Y,2,0,s+128|0),t[s+139|0]>=0)break r;Z(i[s+128>>2]);break r}i[s+168>>2]=i[o+72>>2],n=i[o+76>>2],i[s+172>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1,f=i[o+64>>2]),n=i[s+172>>2],i[s+24>>2]=i[s+168>>2],i[s+28>>2]=n,f=wr(s+176|0,s+24|0,h,f),G=s+128|0,n=G,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=92500,Wi(s+104|0,n,f),n=i[s+108>>2],f=i[s+104>>2],i[s+240>>2]=f,i[s+244>>2]=n,t[s+259|0]<0&&(Z(i[s+248>>2]),f=i[s+240>>2]),n=i[s+116>>2],i[s+248>>2]=i[s+112>>2],i[s+252>>2]=n,i[s+256>>2]=i[s+120>>2];f:{if(f){f=i[s+244>>2],i[Y>>2]=i[s+240>>2],i[Y+4>>2]=f,i[I+8>>2]=i[s+256>>2],f=i[s+252>>2],i[I>>2]=i[s+248>>2],i[I+4>>2]=f,i[s+248>>2]=0,i[s+252>>2]=0,i[s+256>>2]=0,n=0;break f}if(l=i[s+144>>2],(l|0)==1835365473){if(f=i[s+140>>2],V=f,l=i[s+136>>2],!(f|l)){f=C(48),i[s+104>>2]=f,i[s+108>>2]=42,i[s+112>>2]=-2147483600,l=u[12969]|u[12970]<<8|(u[12971]<<16|u[12972]<<24),n=u[12965]|u[12966]<<8|(u[12967]<<16|u[12968]<<24),t[f|0]=n,t[f+1|0]=n>>>8,t[f+2|0]=n>>>16,t[f+3|0]=n>>>24,t[f+4|0]=l,t[f+5|0]=l>>>8,t[f+6|0]=l>>>16,t[f+7|0]=l>>>24,t[f+42|0]=0,n=u[13005]|u[13006]<<8,t[f+40|0]=n,t[f+41|0]=n>>>8,l=u[13001]|u[13002]<<8|(u[13003]<<16|u[13004]<<24),n=u[12997]|u[12998]<<8|(u[12999]<<16|u[13e3]<<24),t[f+32|0]=n,t[f+33|0]=n>>>8,t[f+34|0]=n>>>16,t[f+35|0]=n>>>24,t[f+36|0]=l,t[f+37|0]=l>>>8,t[f+38|0]=l>>>16,t[f+39|0]=l>>>24,l=u[12993]|u[12994]<<8|(u[12995]<<16|u[12996]<<24),n=u[12989]|u[12990]<<8|(u[12991]<<16|u[12992]<<24),t[f+24|0]=n,t[f+25|0]=n>>>8,t[f+26|0]=n>>>16,t[f+27|0]=n>>>24,t[f+28|0]=l,t[f+29|0]=l>>>8,t[f+30|0]=l>>>16,t[f+31|0]=l>>>24,l=u[12985]|u[12986]<<8|(u[12987]<<16|u[12988]<<24),n=u[12981]|u[12982]<<8|(u[12983]<<16|u[12984]<<24),t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24,t[f+20|0]=l,t[f+21|0]=l>>>8,t[f+22|0]=l>>>16,t[f+23|0]=l>>>24,l=u[12977]|u[12978]<<8|(u[12979]<<16|u[12980]<<24),n=u[12973]|u[12974]<<8|(u[12975]<<16|u[12976]<<24),t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24,t[f+12|0]=l,t[f+13|0]=l>>>8,t[f+14|0]=l>>>16,t[f+15|0]=l>>>24,a(Y,2,104,s+104|0),t[s+115|0]<0&&Z(i[s+104>>2]),n=0;break f}if(f=i[o+64>>2],n=i[o+68>>2],Q=n,V=w+V|0,_=n,n=l+h|0,V=n>>>0<h>>>0?V+1|0:V,l=V,(_|0)==(l|0)&f>>>0<n>>>0|_>>>0<l>>>0&&(f=i[o+72>>2],f=W[i[i[f>>2]+24>>2]](f,h,w,n,l)|0,_=h0,Q=_,i[o+64>>2]=f,i[o+68>>2]=_),(l|0)==(Q|0)&f>>>0<n>>>0|l>>>0>Q>>>0){f=C(32),i[s+104>>2]=f,i[s+108>>2]=25,i[s+112>>2]=-2147483616,l=u[2492]|u[2493]<<8|(u[2494]<<16|u[2495]<<24),n=u[2488]|u[2489]<<8|(u[2490]<<16|u[2491]<<24),t[f|0]=n,t[f+1|0]=n>>>8,t[f+2|0]=n>>>16,t[f+3|0]=n>>>24,t[f+4|0]=l,t[f+5|0]=l>>>8,t[f+6|0]=l>>>16,t[f+7|0]=l>>>24,t[f+25|0]=0,t[f+24|0]=u[2512],l=u[2508]|u[2509]<<8|(u[2510]<<16|u[2511]<<24),n=u[2504]|u[2505]<<8|(u[2506]<<16|u[2507]<<24),t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24,t[f+20|0]=l,t[f+21|0]=l>>>8,t[f+22|0]=l>>>16,t[f+23|0]=l>>>24,l=u[2500]|u[2501]<<8|(u[2502]<<16|u[2503]<<24),n=u[2496]|u[2497]<<8|(u[2498]<<16|u[2499]<<24),t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24,t[f+12|0]=l,t[f+13|0]=l>>>8,t[f+14|0]=l>>>16,t[f+15|0]=l>>>24,a(Y,2,104,s+104|0),t[s+115|0]<0&&Z(i[s+104>>2]),n=0;break f}i[s+96>>2]=i[o+72>>2],f=i[o+76>>2],i[s+100>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[s+100>>2],i[s+16>>2]=i[s+96>>2],i[s+20>>2]=f,f=wr(s+104|0,s+16|0,h,n),i[s+88>>2]=0,i[s+92>>2]=0,c8(s- -64|0,f,s+88|0,O),n=i[s+68>>2],f=i[s+64>>2],i[s+240>>2]=f,i[s+244>>2]=n,t[s+259|0]<0&&(Z(i[s+248>>2]),f=i[s+240>>2]),n=i[s+76>>2],i[s+248>>2]=i[s+72>>2],i[s+252>>2]=n,i[s+256>>2]=i[s+80>>2];A:{if(f){n=i[s+244>>2],i[Y>>2]=i[s+240>>2],i[Y+4>>2]=n,i[I+8>>2]=i[s+256>>2],n=i[s+252>>2],i[I>>2]=i[s+248>>2],i[I+4>>2]=n,i[s+248>>2]=0,i[s+252>>2]=0,i[s+256>>2]=0;break A}P0(B,s+88|0);k:{n:{if(n=i[s+88>>2],!n||(l=Z0(n,92792,93316),!l))break n;if(m=i[s+92>>2],!m){m=0;break k}i[m+4>>2]=i[m+4>>2]+1;break k}m=0,l=0}if(i[o+36>>2]=l,l=i[o+40>>2],i[o+40>>2]=m,m=1,!l||(n=i[l+4>>2],i[l+4>>2]=n-1,n))break A;W[i[i[l>>2]+8>>2]](l),y(l)}l=i[s+92>>2];A:{if(!l||(n=i[l+4>>2],i[l+4>>2]=n-1,n))break A;W[i[i[l>>2]+8>>2]](l),y(l)}l=i[s+108>>2];A:{if(!l||(n=i[l+4>>2],i[l+4>>2]=n-1,n))break A;W[i[i[l>>2]+8>>2]](l),y(l)}if(n=0,f)break f;l=i[s+144>>2]}A:{if((l|0)==1835626089){if(f=i[s+140>>2],V=f,l=i[s+136>>2],!(f|l)){f=C(48),i[s+104>>2]=f,i[s+108>>2]=42,i[s+112>>2]=-2147483600,l=u[12926]|u[12927]<<8|(u[12928]<<16|u[12929]<<24),n=u[12922]|u[12923]<<8|(u[12924]<<16|u[12925]<<24),t[f|0]=n,t[f+1|0]=n>>>8,t[f+2|0]=n>>>16,t[f+3|0]=n>>>24,t[f+4|0]=l,t[f+5|0]=l>>>8,t[f+6|0]=l>>>16,t[f+7|0]=l>>>24,t[f+42|0]=0,n=u[12962]|u[12963]<<8,t[f+40|0]=n,t[f+41|0]=n>>>8,l=u[12958]|u[12959]<<8|(u[12960]<<16|u[12961]<<24),n=u[12954]|u[12955]<<8|(u[12956]<<16|u[12957]<<24),t[f+32|0]=n,t[f+33|0]=n>>>8,t[f+34|0]=n>>>16,t[f+35|0]=n>>>24,t[f+36|0]=l,t[f+37|0]=l>>>8,t[f+38|0]=l>>>16,t[f+39|0]=l>>>24,l=u[12950]|u[12951]<<8|(u[12952]<<16|u[12953]<<24),n=u[12946]|u[12947]<<8|(u[12948]<<16|u[12949]<<24),t[f+24|0]=n,t[f+25|0]=n>>>8,t[f+26|0]=n>>>16,t[f+27|0]=n>>>24,t[f+28|0]=l,t[f+29|0]=l>>>8,t[f+30|0]=l>>>16,t[f+31|0]=l>>>24,l=u[12942]|u[12943]<<8|(u[12944]<<16|u[12945]<<24),n=u[12938]|u[12939]<<8|(u[12940]<<16|u[12941]<<24),t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24,t[f+20|0]=l,t[f+21|0]=l>>>8,t[f+22|0]=l>>>16,t[f+23|0]=l>>>24,l=u[12934]|u[12935]<<8|(u[12936]<<16|u[12937]<<24),n=u[12930]|u[12931]<<8|(u[12932]<<16|u[12933]<<24),t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24,t[f+12|0]=l,t[f+13|0]=l>>>8,t[f+14|0]=l>>>16,t[f+15|0]=l>>>24,a(Y,2,149,s+104|0),t[s+115|0]<0&&Z(i[s+104>>2]),n=0;break f}if(f=i[o+64>>2],n=i[o+68>>2],Q=n,_=n,n=w+V|0,l=l+h|0,n=l>>>0<h>>>0?n+1|0:n,(n|0)==(_|0)&f>>>0<l>>>0|n>>>0>_>>>0&&(f=i[o+72>>2],f=W[i[i[f>>2]+24>>2]](f,h,w,l,n)|0,_=h0,Q=_,i[o+64>>2]=f,i[o+68>>2]=_),(n|0)==(Q|0)&f>>>0<l>>>0|n>>>0>Q>>>0){l=C(32),i[s+104>>2]=l,i[s+108>>2]=25,i[s+112>>2]=-2147483616,n=u[2466]|u[2467]<<8|(u[2468]<<16|u[2469]<<24),f=u[2462]|u[2463]<<8|(u[2464]<<16|u[2465]<<24),t[l|0]=f,t[l+1|0]=f>>>8,t[l+2|0]=f>>>16,t[l+3|0]=f>>>24,t[l+4|0]=n,t[l+5|0]=n>>>8,t[l+6|0]=n>>>16,t[l+7|0]=n>>>24,t[l+25|0]=0,t[l+24|0]=u[2486],n=u[2482]|u[2483]<<8|(u[2484]<<16|u[2485]<<24),f=u[2478]|u[2479]<<8|(u[2480]<<16|u[2481]<<24),t[l+16|0]=f,t[l+17|0]=f>>>8,t[l+18|0]=f>>>16,t[l+19|0]=f>>>24,t[l+20|0]=n,t[l+21|0]=n>>>8,t[l+22|0]=n>>>16,t[l+23|0]=n>>>24,n=u[2474]|u[2475]<<8|(u[2476]<<16|u[2477]<<24),f=u[2470]|u[2471]<<8|(u[2472]<<16|u[2473]<<24),t[l+8|0]=f,t[l+9|0]=f>>>8,t[l+10|0]=f>>>16,t[l+11|0]=f>>>24,t[l+12|0]=n,t[l+13|0]=n>>>8,t[l+14|0]=n>>>16,t[l+15|0]=n>>>24,a(Y,2,149,s+104|0),t[s+115|0]<0&&Z(i[s+104>>2]),n=0;break f}i[s+56>>2]=i[o+72>>2],f=i[o+76>>2],i[s+60>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[s+60>>2],i[s+8>>2]=i[s+56>>2],i[s+12>>2]=f,f=wr(s+104|0,s+8|0,h,l),i[s+88>>2]=0,i[s+92>>2]=0,c8(s- -64|0,f,s+88|0,101976),n=i[s+68>>2],f=i[s+64>>2],i[s+240>>2]=f,i[s+244>>2]=n,t[s+259|0]<0&&(Z(i[s+248>>2]),f=i[s+240>>2]),n=i[s+76>>2],i[s+248>>2]=i[s+72>>2],i[s+252>>2]=n,i[s+256>>2]=i[s+80>>2];k:{if(f){n=i[s+244>>2],i[Y>>2]=i[s+240>>2],i[Y+4>>2]=n,i[I+8>>2]=i[s+256>>2],n=i[s+252>>2],i[I>>2]=i[s+248>>2],i[I+4>>2]=n,i[s+248>>2]=0,i[s+252>>2]=0,i[s+256>>2]=0;break k}P0(B,s+88|0),l=s- -64|0;n:{t:{if(n=i[s+88>>2],!n||(n=Z0(n,92792,114136),!n))break t;if(i[l>>2]=n,n=i[s+92>>2],i[l+4>>2]=n,!n)break n;i[n+4>>2]=i[n+4>>2]+1;break n}i[l>>2]=0,i[l+4>>2]=0}Q8(E,l),g2(l),U=1}l=i[s+92>>2];k:{if(!l||(n=i[l+4>>2],i[l+4>>2]=n-1,n))break k;W[i[i[l>>2]+8>>2]](l),y(l)}l=i[s+108>>2];k:{if(!l||(n=i[l+4>>2],i[l+4>>2]=n-1,n))break k;W[i[i[l>>2]+8>>2]](l),y(l)}if(n=0,f)break f;l=i[s+144>>2]}if((l|0)!=1836019574)break A;if(f=i[s+140>>2],V=f,l=i[s+136>>2],!(f|l)){l=C(48),i[s+104>>2]=l,i[s+108>>2]=42,i[s+112>>2]=-2147483600,n=u[12883]|u[12884]<<8|(u[12885]<<16|u[12886]<<24),f=u[12879]|u[12880]<<8|(u[12881]<<16|u[12882]<<24),t[l|0]=f,t[l+1|0]=f>>>8,t[l+2|0]=f>>>16,t[l+3|0]=f>>>24,t[l+4|0]=n,t[l+5|0]=n>>>8,t[l+6|0]=n>>>16,t[l+7|0]=n>>>24,t[l+42|0]=0,f=u[12919]|u[12920]<<8,t[l+40|0]=f,t[l+41|0]=f>>>8,n=u[12915]|u[12916]<<8|(u[12917]<<16|u[12918]<<24),f=u[12911]|u[12912]<<8|(u[12913]<<16|u[12914]<<24),t[l+32|0]=f,t[l+33|0]=f>>>8,t[l+34|0]=f>>>16,t[l+35|0]=f>>>24,t[l+36|0]=n,t[l+37|0]=n>>>8,t[l+38|0]=n>>>16,t[l+39|0]=n>>>24,n=u[12907]|u[12908]<<8|(u[12909]<<16|u[12910]<<24),f=u[12903]|u[12904]<<8|(u[12905]<<16|u[12906]<<24),t[l+24|0]=f,t[l+25|0]=f>>>8,t[l+26|0]=f>>>16,t[l+27|0]=f>>>24,t[l+28|0]=n,t[l+29|0]=n>>>8,t[l+30|0]=n>>>16,t[l+31|0]=n>>>24,n=u[12899]|u[12900]<<8|(u[12901]<<16|u[12902]<<24),f=u[12895]|u[12896]<<8|(u[12897]<<16|u[12898]<<24),t[l+16|0]=f,t[l+17|0]=f>>>8,t[l+18|0]=f>>>16,t[l+19|0]=f>>>24,t[l+20|0]=n,t[l+21|0]=n>>>8,t[l+22|0]=n>>>16,t[l+23|0]=n>>>24,n=u[12891]|u[12892]<<8|(u[12893]<<16|u[12894]<<24),f=u[12887]|u[12888]<<8|(u[12889]<<16|u[12890]<<24),t[l+8|0]=f,t[l+9|0]=f>>>8,t[l+10|0]=f>>>16,t[l+11|0]=f>>>24,t[l+12|0]=n,t[l+13|0]=n>>>8,t[l+14|0]=n>>>16,t[l+15|0]=n>>>24,a(Y,2,151,s+104|0),t[s+115|0]<0&&Z(i[s+104>>2]),n=0;break f}if(f=i[o+64>>2],n=i[o+68>>2],Q=n,_=n,n=w+V|0,l=l+h|0,n=l>>>0<h>>>0?n+1|0:n,(n|0)==(_|0)&f>>>0<l>>>0|n>>>0>_>>>0&&(f=i[o+72>>2],f=W[i[i[f>>2]+24>>2]](f,h,w,l,n)|0,_=h0,Q=_,i[o+64>>2]=f,i[o+68>>2]=_),(n|0)==(Q|0)&f>>>0<l>>>0|n>>>0>Q>>>0){l=C(32),i[s+104>>2]=l,i[s+108>>2]=25,i[s+112>>2]=-2147483616,n=u[2376]|u[2377]<<8|(u[2378]<<16|u[2379]<<24),f=u[2372]|u[2373]<<8|(u[2374]<<16|u[2375]<<24),t[l|0]=f,t[l+1|0]=f>>>8,t[l+2|0]=f>>>16,t[l+3|0]=f>>>24,t[l+4|0]=n,t[l+5|0]=n>>>8,t[l+6|0]=n>>>16,t[l+7|0]=n>>>24,t[l+25|0]=0,t[l+24|0]=u[2396],n=u[2392]|u[2393]<<8|(u[2394]<<16|u[2395]<<24),f=u[2388]|u[2389]<<8|(u[2390]<<16|u[2391]<<24),t[l+16|0]=f,t[l+17|0]=f>>>8,t[l+18|0]=f>>>16,t[l+19|0]=f>>>24,t[l+20|0]=n,t[l+21|0]=n>>>8,t[l+22|0]=n>>>16,t[l+23|0]=n>>>24,n=u[2384]|u[2385]<<8|(u[2386]<<16|u[2387]<<24),f=u[2380]|u[2381]<<8|(u[2382]<<16|u[2383]<<24),t[l+8|0]=f,t[l+9|0]=f>>>8,t[l+10|0]=f>>>16,t[l+11|0]=f>>>24,t[l+12|0]=n,t[l+13|0]=n>>>8,t[l+14|0]=n>>>16,t[l+15|0]=n>>>24,a(Y,2,151,s+104|0),t[s+115|0]<0&&Z(i[s+104>>2]),n=0;break f}i[s+48>>2]=i[o+72>>2],f=i[o+76>>2],i[s+52>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[s+52>>2],i[s>>2]=i[s+48>>2],i[s+4>>2]=f,f=wr(s+104|0,s,h,l),i[s+88>>2]=0,i[s+92>>2]=0,c8(s- -64|0,f,s+88|0,O),n=i[s+68>>2],f=i[s+64>>2],i[s+240>>2]=f,i[s+244>>2]=n,t[s+259|0]<0&&(Z(i[s+248>>2]),f=i[s+240>>2]),n=i[s+76>>2],i[s+248>>2]=i[s+72>>2],i[s+252>>2]=n,i[s+256>>2]=i[s+80>>2];k:{if(f){n=i[s+244>>2],i[Y>>2]=i[s+240>>2],i[Y+4>>2]=n,i[I+8>>2]=i[s+256>>2],n=i[s+252>>2],i[I>>2]=i[s+248>>2],i[I+4>>2]=n,i[s+248>>2]=0,i[s+252>>2]=0,i[s+256>>2]=0;break k}P0(B,s+88|0),n=s- -64|0;n:{t:{if(k=i[s+88>>2],!k||(k=Z0(k,92792,98928),!k))break t;if(i[n>>2]=k,k=i[s+92>>2],i[n+4>>2]=k,!k)break n;i[k+4>>2]=i[k+4>>2]+1;break n}i[n>>2]=0,i[n+4>>2]=0}Q8(j,n),g2(n),k=1}l=i[s+92>>2];k:{if(!l||(n=i[l+4>>2],i[l+4>>2]=n-1,n))break k;W[i[i[l>>2]+8>>2]](l),y(l)}l=i[s+108>>2];k:{if(!l||(n=i[l+4>>2],i[l+4>>2]=n-1,n))break k;W[i[i[l>>2]+8>>2]](l),y(l)}if(!f)break A;n=0;break f}if(n=i[s+140>>2],l=n,f=i[s+136>>2],!(n|f)){if((m|U|k)&1){if(f=i[28729],i[Y>>2]=i[28728],i[Y+4>>2]=f,t[114931]>=0){f=i[28731],i[I>>2]=i[28730],i[I+4>>2]=f,i[I+8>>2]=i[28732],n=0;break f}T(I,i[28730],i[28731]),n=0;break f}n=C(24),i[s+104>>2]=n,i[s+108>>2]=17,i[s+112>>2]=-2147483624,k=u[17356]|u[17357]<<8|(u[17358]<<16|u[17359]<<24),f=u[17352]|u[17353]<<8|(u[17354]<<16|u[17355]<<24),t[n|0]=f,t[n+1|0]=f>>>8,t[n+2|0]=f>>>16,t[n+3|0]=f>>>24,t[n+4|0]=k,t[n+5|0]=k>>>8,t[n+6|0]=k>>>16,t[n+7|0]=k>>>24,t[n+17|0]=0,t[n+16|0]=u[17368],k=u[17364]|u[17365]<<8|(u[17366]<<16|u[17367]<<24),f=u[17360]|u[17361]<<8|(u[17362]<<16|u[17363]<<24),t[n+8|0]=f,t[n+9|0]=f>>>8,t[n+10|0]=f>>>16,t[n+11|0]=f>>>24,t[n+12|0]=k,t[n+13|0]=k>>>8,t[n+14|0]=k>>>16,t[n+15|0]=k>>>24,a(Y,2,0,s+104|0),t[s+115|0]<0&&Z(i[s+104>>2]),k=0,U=0,m=0,n=0;break f}if(n=l^-1,(w|0)==(n|0)&h>>>0>(f^-1)>>>0|n>>>0<w>>>0){l=C(40),i[s+104>>2]=l,i[s+108>>2]=36,i[s+112>>2]=-2147483608,n=u[3185]|u[3186]<<8|(u[3187]<<16|u[3188]<<24),f=u[3181]|u[3182]<<8|(u[3183]<<16|u[3184]<<24),t[l|0]=f,t[l+1|0]=f>>>8,t[l+2|0]=f>>>16,t[l+3|0]=f>>>24,t[l+4|0]=n,t[l+5|0]=n>>>8,t[l+6|0]=n>>>16,t[l+7|0]=n>>>24,t[l+36|0]=0,f=u[3213]|u[3214]<<8|(u[3215]<<16|u[3216]<<24),t[l+32|0]=f,t[l+33|0]=f>>>8,t[l+34|0]=f>>>16,t[l+35|0]=f>>>24,n=u[3209]|u[3210]<<8|(u[3211]<<16|u[3212]<<24),f=u[3205]|u[3206]<<8|(u[3207]<<16|u[3208]<<24),t[l+24|0]=f,t[l+25|0]=f>>>8,t[l+26|0]=f>>>16,t[l+27|0]=f>>>24,t[l+28|0]=n,t[l+29|0]=n>>>8,t[l+30|0]=n>>>16,t[l+31|0]=n>>>24,n=u[3201]|u[3202]<<8|(u[3203]<<16|u[3204]<<24),f=u[3197]|u[3198]<<8|(u[3199]<<16|u[3200]<<24),t[l+16|0]=f,t[l+17|0]=f>>>8,t[l+18|0]=f>>>16,t[l+19|0]=f>>>24,t[l+20|0]=n,t[l+21|0]=n>>>8,t[l+22|0]=n>>>16,t[l+23|0]=n>>>24,n=u[3193]|u[3194]<<8|(u[3195]<<16|u[3196]<<24),f=u[3189]|u[3190]<<8|(u[3191]<<16|u[3192]<<24),t[l+8|0]=f,t[l+9|0]=f>>>8,t[l+10|0]=f>>>16,t[l+11|0]=f>>>24,t[l+12|0]=n,t[l+13|0]=n>>>8,t[l+14|0]=n>>>16,t[l+15|0]=n>>>24,a(Y,2,0,s+104|0),t[s+115|0]<0&&Z(i[s+104>>2]),n=0;break f}w=l+w|0,n=h,h=f+h|0,w=n>>>0>h>>>0?w+1|0:w,n=1}f=n,i[G>>2]=92500,n=i[s+148>>2],n&&(i[s+152>>2]=n,Z(n)),l=i[s+180>>2];f:{if(!l||(n=i[l+4>>2],i[l+4>>2]=n-1,n))break f;W[i[i[l>>2]+8>>2]](l),y(l)}if(f)continue}break}f=i[s+204>>2];r:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break r;W[i[i[f>>2]+8>>2]](f),y(f)}if(f=i[R+4>>2],!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(t[s+259|0]<0&&Z(i[s+248>>2]),i[N>>2]=92500,r=i[N+20>>2],r&&(i[N+24>>2]=r,Z(r)),f=i[x+4>>2],!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=s+336|0,f=i[Y+4>>2],r=i[Y>>2],i[Y+24>>2]=r,i[Y+28>>2]=f,t[Y+43|0]<0&&(Z(i[Y+32>>2]),r=i[Y+24>>2]),f=i[Y+12>>2],i[Y+32>>2]=i[Y+8>>2],i[Y+36>>2]=f,i[Y+40>>2]=i[Y+16>>2];i:{e:{if(r){e=i[Y+28>>2],i[A>>2]=i[Y+24>>2],i[A+4>>2]=e,e=i[Y+36>>2],i[A+8>>2]=i[Y+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[Y+40>>2];break e}N=v-176|0,v=N,f=i[e>>2],r=i[f+28>>2],f=i[f+32>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+28>>2]=r,k=i[e+32>>2],i[e+32>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[e+28>>2]);r:{f:{A:{if(!r){if(t[N+24|0]=0,t[N+35|0]=0,a(A,2,102,N+24|0),t[N+35|0]>=0)break A;Z(i[N+24>>2]);break A}_=i[e+32>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),f=i[e+20>>2],k=i[e+24>>2];k:{if(f>>>0<k>>>0){i[f+4>>2]=_,i[f>>2]=r,r=f+8|0;break k}if(l=i[e+16>>2],n=f-l|0,w=n>>3,m=w+1|0,m>>>0>=536870912)break i;if(h=k-l|0,k=h>>2,m=h>>>0>=2147483640?536870911:k>>>0>m>>>0?k:m,m){if(m>>>0>=536870912)break f;f=C(m<<3)}else f=0;if(h=f+n|0,i[h+4>>2]=_,i[h>>2]=r,k=h-(w<<3)|0,n&&z(k,l,n),i[e+24>>2]=f+(m<<3),r=h+8|0,i[e+20>>2]=r,i[e+16>>2]=k,!l)break k;Z(l)}i[e+20>>2]=r,n=1;k:{if(P4(i[e+28>>2],1836279345)||P4(i[e+28>>2],1769172845)||P4(i[e+28>>2],1836069937))break k;n=P4(i[e+28>>2],1836069938)}k:{if(P4(i[e+28>>2],1751476579)||P4(i[e+28>>2],1751476600)||P4(i[e+28>>2],1835623985)||P4(i[e+28>>2],1635150182)||P4(i[e+28>>2],829450595)||(r=i[e+28>>2],i[r+100>>2]==1835623987)||P4(r,1785750887)||P4(i[e+28>>2],1769172845)||P4(i[e+28>>2],1836069938)||P4(i[e+28>>2],1836069937)||P4(i[e+28>>2],1836279345))break k;r=ri(N+24|0),F(r+8|0,46952,44),e=N+12|0,ki(e,r),a(A,3,0,e),t[N+23|0]<0&&Z(i[N+12>>2]),F8(r);break A}r=i[e>>2],f=i[r+44>>2],r=i[r+48>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[e+52>>2]=f,k=i[e+56>>2],i[e+56>>2]=r,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),f=i[e+52>>2],r=i[e+56>>2]),r&&(i[r+4>>2]=i[r+4>>2]+1),k=i[e+20>>2],h=i[e+24>>2];k:{if(k>>>0<h>>>0){i[k+4>>2]=r,i[k>>2]=f,r=k+8|0;break k}if(V=i[e+16>>2],w=k-V|0,l=w>>3,_=l+1|0,_>>>0>=536870912)break i;if(m=h-V|0,h=m>>2,m=m>>>0>=2147483640?536870911:h>>>0>_>>>0?h:_,m){if(m>>>0>=536870912)break f;k=C(m<<3)}else k=0;if(h=k+w|0,i[h+4>>2]=r,i[h>>2]=f,f=h-(l<<3)|0,w&&z(f,V,w),i[e+24>>2]=k+(m<<3),r=h+8|0,i[e+20>>2]=r,i[e+16>>2]=f,!V)break k;Z(V)}if(i[e+20>>2]=r,I=i[e+52>>2],I){o=v-464|0,v=o,k=C(120),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=95908,r=k+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93256,i[k+32>>2]=1835365473,i[e+44>>2]=r,f=i[e+48>>2],i[e+48>>2]=k;k:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break k;W[i[i[f>>2]+8>>2]](f),y(f)}l=C(152),r=l,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96028,r=r+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[l+32>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,i[l+44>>2]=0,i[l+48>>2]=0,i[l+16>>2]=92500,i[l+60>>2]=0,i[l+64>>2]=0,i[l+52>>2]=0,i[l+56>>2]=0,i[l+72>>2]=-1,i[l+76>>2]=-1,i[l+80>>2]=-1,i[l+84>>2]=-1,i[l+116>>2]=0,i[l+88>>2]=0,i[l+92>>2]=0,i[l+96>>2]=0,i[l+100>>2]=0,i[l+104>>2]=0,i[l+108>>2]=0,X[l+112>>1]=0,i[l+16>>2]=93336,i[l+128>>2]=0,i[l+132>>2]=0,i[l+120>>2]=0,i[l+124>>2]=1885954932,i[l+136>>2]=0,i[l+140>>2]=0,i[l+144>>2]=0,i[l+148>>2]=0,i[l+32>>2]=1751411826,i[l+4>>2]=i[l+4>>2]+1,i[e+36>>2]=r,f=i[e+40>>2],i[e+40>>2]=l;k:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break k;W[i[i[f>>2]+8>>2]](f),y(f)}Bt(e,1),G=C(184),i[G>>2]=96188,i[G+4>>2]=0,i[G+8>>2]=0,r=G+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[G+32>>2]=0,i[G+36>>2]=0,i[G+40>>2]=0,i[G+44>>2]=0,i[G+48>>2]=0,i[G+16>>2]=92500,i[G+60>>2]=0,i[G+64>>2]=0,i[G+52>>2]=0,i[G+56>>2]=0,i[G+72>>2]=-1,i[G+76>>2]=-1,i[G+80>>2]=-1,i[G+84>>2]=-1,i[G+116>>2]=0,i[G+88>>2]=0,i[G+92>>2]=0,i[G+96>>2]=0,i[G+100>>2]=0,i[G+104>>2]=0,i[G+108>>2]=0,X[G+112>>1]=0,i[G+16>>2]=93496,i[G+128>>2]=0,i[G+132>>2]=0,X[G+124>>1]=0,i[G+136>>2]=0,i[G+140>>2]=0,i[G+144>>2]=0,i[G+148>>2]=0,i[G+152>>2]=0,i[G+156>>2]=0,i[G+160>>2]=0,i[G+164>>2]=0,i[G+168>>2]=0,i[G+172>>2]=0,t[G+173|0]=0,t[G+174|0]=0,t[G+175|0]=0,t[G+176|0]=0,t[G+177|0]=0,t[G+178|0]=0,t[G+179|0]=0,t[G+180|0]=0,i[G+120>>2]=1,t[G+113|0]=2,i[G+32>>2]=1768842853,f=i[e+28>>2],U=i[e+32>>2],U&&(i[U+4>>2]=i[U+4>>2]+1),O=N+24|0;k:{n:{t:{if(!f){if(e=C(72),i[o+312>>2]=e,i[o+316>>2]=66,i[o+320>>2]=-2147483576,z(e,17370,66),t[e+66|0]=0,a(O,2,102,o+312|0),t[o+323|0]>=0)break t;Z(i[o+312>>2]);break t}o:{l:{if(x=i[f+104>>2],R=(x|0)==1751476579?1752589105:0,f=(x|0)==1635150182?1635135537:R,!f){i[o+404>>2]=0,i[o+376>>2]=78164,i[o+320>>2]=78144,e=i[19545],i[o+312>>2]=e,k=o+312|0,i[k+i[e-12>>2]>>2]=i[19546],i[o+316>>2]=0,e=k+i[i[o+312>>2]-12>>2]|0,f=o+324|0,J0(e,f),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[o+320>>2]=e,r=o+320|0,i[r+i[e-12>>2]>>2]=i[19548],e=i[19544],i[o+312>>2]=e,i[k+i[e-12>>2]>>2]=i[19549],i[o+376>>2]=78164,i[o+312>>2]=78124,i[o+320>>2]=78144,n=R0(f),i[n>>2]=77200,i[o+364>>2]=0,i[o+368>>2]=0,i[o+356>>2]=0,i[o+360>>2]=0,i[o+372>>2]=24,r=F(r,32487,30),e=o+112|0,z1(e,x),f=r,_=e,r=t[o+123|0],e=(r|0)<0,F(F(f,e?i[o+112>>2]:_,e?i[o+116>>2]:r),28773,31),t[o+123|0]<0&&Z(i[o+112>>2]),e=i[o+372>>2];u:{if(e&16){e=i[o+368>>2],r=i[o+348>>2],e>>>0<r>>>0&&(i[o+368>>2]=r,e=r),r=o+344|0;break u}if(!(e&8)){e=0,t[o+123|0]=0,r=o+112|0;break o}e=i[o+340>>2],r=o+332|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break n;if(e>>>0>=11){f=e|7,r=C(f+1|0),i[o+120>>2]=f-2147483647,i[o+112>>2]=r,i[o+116>>2]=e;break l}if(t[o+123|0]=e,r=o+112|0,e)break l;e=0;break o}i[G+128>>2]=f,i[o+308>>2]=G,i[o+304>>2]=r,i[G+4>>2]=i[G+4>>2]+1,r=i[o+308>>2],i[o+96>>2]=i[o+304>>2],i[o+100>>2]=r,Z3(e,1,o+96|0);u:{if(!i[I+320>>2]||(k=C(184),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=96188,r=k+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93496,i[k+128>>2]=0,i[k+132>>2]=0,X[k+124>>1]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+168>>2]=0,i[k+172>>2]=0,t[k+173|0]=0,t[k+174|0]=0,t[k+175|0]=0,t[k+176|0]=0,t[k+177|0]=0,t[k+178|0]=0,t[k+179|0]=0,t[k+180|0]=0,i[k+116>>2]=1,i[k+120>>2]=2,t[k+113|0]=2,i[k+32>>2]=1768842853,i[k+128>>2]=f,i[o+300>>2]=k,i[o+296>>2]=r,i[k+4>>2]=i[k+4>>2]+1,r=i[o+300>>2],i[o+88>>2]=i[o+296>>2],i[o+92>>2]=r,Z3(e,2,o+88|0),r=i[k+4>>2],i[k+4>>2]=r-1,r))break u;W[i[i[k>>2]+8>>2]](k),y(k)}u:{if(u[I+105|0]!=1||(n=C(184),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=96188,k=n+16|0,r=k,i[r+8>>2]=0,i[r+12>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,i[n+16>>2]=92500,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,X[n+112>>1]=0,i[n+16>>2]=93496,i[n+128>>2]=0,i[n+132>>2]=0,X[n+124>>1]=0,i[n+136>>2]=0,i[n+140>>2]=0,i[n+144>>2]=0,i[n+148>>2]=0,i[n+152>>2]=0,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+172>>2]=0,t[n+173|0]=0,t[n+174|0]=0,t[n+175|0]=0,t[n+176|0]=0,t[n+177|0]=0,t[n+178|0]=0,t[n+179|0]=0,t[n+180|0]=0,i[n+116>>2]=1,i[n+120>>2]=6,t[n+113|0]=2,i[n+32>>2]=1768842853,i[n+128>>2]=1165519206,u[I+107|0]==1&&(t[n+163|0]=0,i[n+156>>2]=i[16236],r=u[64947]|u[64948]<<8|(u[64949]<<16|u[64950]<<24),t[n+159|0]=r,t[n+160|0]=r>>>8,t[n+161|0]=r>>>16,t[n+162|0]=r>>>24,f=u[o+314|0],r=p[o+312>>1],t[n+167|0]=7,X[n+164>>1]=r,t[n+166|0]=f),i[o+292>>2]=n,i[o+288>>2]=k,i[n+4>>2]=i[n+4>>2]+1,r=i[o+292>>2],i[o+80>>2]=i[o+288>>2],i[o+84>>2]=r,Z3(e,6,o+80|0),r=i[n+4>>2],i[n+4>>2]=r-1,r))break u;W[i[i[n>>2]+8>>2]](n),y(n)}u:{if(u[I+106|0]!=1)break u;w=C(184),i[w+4>>2]=0,i[w+8>>2]=0,i[w>>2]=96188,f=w+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[w+32>>2]=0,i[w+36>>2]=0,i[w+40>>2]=0,i[w+44>>2]=0,i[w+48>>2]=0,i[w+16>>2]=92500,i[w+60>>2]=0,i[w+64>>2]=0,i[w+52>>2]=0,i[w+56>>2]=0,i[w+72>>2]=-1,i[w+76>>2]=-1,i[w+80>>2]=-1,i[w+84>>2]=-1,i[w+88>>2]=0,i[w+92>>2]=0,i[w+96>>2]=0,i[w+100>>2]=0,i[w+104>>2]=0,i[w+108>>2]=0,X[w+112>>1]=0,i[w+16>>2]=93496,i[w+128>>2]=0,i[w+132>>2]=0,X[w+124>>1]=0,i[w+136>>2]=0,i[w+140>>2]=0,r=w+144|0,i[r>>2]=0,i[r+4>>2]=0,i[w+152>>2]=0,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+172>>2]=0,t[w+173|0]=0,t[w+174|0]=0,t[w+175|0]=0,t[w+176|0]=0,t[w+177|0]=0,t[w+178|0]=0,t[w+179|0]=0,t[w+180|0]=0,i[w+116>>2]=1,i[w+120>>2]=7,t[w+113|0]=2,i[w+32>>2]=1768842853,i[w+128>>2]=1835625829,h=C(24),t[h+19|0]=0,k=u[10685]|u[10686]<<8|(u[10687]<<16|u[10688]<<24),t[h+15|0]=k,t[h+16|0]=k>>>8,t[h+17|0]=k>>>16,t[h+18|0]=k>>>24,n=u[10682]|u[10683]<<8|(u[10684]<<16|u[10685]<<24),k=u[10678]|u[10679]<<8|(u[10680]<<16|u[10681]<<24),t[h+8|0]=k,t[h+9|0]=k>>>8,t[h+10|0]=k>>>16,t[h+11|0]=k>>>24,t[h+12|0]=n,t[h+13|0]=n>>>8,t[h+14|0]=n>>>16,t[h+15|0]=n>>>24,n=u[10674]|u[10675]<<8|(u[10676]<<16|u[10677]<<24),k=u[10670]|u[10671]<<8|(u[10672]<<16|u[10673]<<24),t[h|0]=k,t[h+1|0]=k>>>8,t[h+2|0]=k>>>16,t[h+3|0]=k>>>24,t[h+4|0]=n,t[h+5|0]=n>>>8,t[h+6|0]=n>>>16,t[h+7|0]=n>>>24,m1(r,h,19),Z(h);s:{if(u[I+107|0]!=1)break s;if(t[o+323|0]=7,i[o+312>>2]=i[16236],r=u[64947]|u[64948]<<8|(u[64949]<<16|u[64950]<<24),t[o+315|0]=r,t[o+316|0]=r>>>8,t[o+317|0]=r>>>16,t[o+318|0]=r>>>24,k=w+156|0,t[o+319|0]=0,t[w+167|0]>=0){r=i[o+316>>2],i[k>>2]=i[o+312>>2],i[k+4>>2]=r,i[k+8>>2]=i[o+320>>2];break s}if(R1(k,o+312|0,7),t[o+323|0]>=0)break s;Z(i[o+312>>2])}if(i[o+284>>2]=w,i[o+280>>2]=f,i[w+4>>2]=i[w+4>>2]+1,r=i[o+284>>2],i[o+72>>2]=i[o+280>>2],i[o+76>>2]=r,Z3(e,7,o+72|0),r=i[w+4>>2],i[w+4>>2]=r-1,r)break u;W[i[i[w>>2]+8>>2]](w),y(w)}_=C(120),r=_,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96268,r=r+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[_+32>>2]=0,i[_+36>>2]=0,i[_+40>>2]=0,i[_+44>>2]=0,i[_+48>>2]=0,i[_+16>>2]=92500,i[_+60>>2]=0,i[_+64>>2]=0,i[_+52>>2]=0,i[_+56>>2]=0,i[_+72>>2]=-1,i[_+76>>2]=-1,i[_+80>>2]=-1,i[_+84>>2]=-1,i[_+88>>2]=0,i[_+92>>2]=0,i[_+96>>2]=0,i[_+100>>2]=0,i[_+104>>2]=0,i[_+108>>2]=0,t[_+112|0]=0,i[_+16>>2]=93736,i[_+32>>2]=1768973167,i[o+276>>2]=_,i[o+272>>2]=r,i[_+4>>2]=i[_+4>>2]+1,r=i[o+276>>2],i[o+64>>2]=i[o+272>>2],i[o+68>>2]=r,w=o- -64|0,r=i[w>>2],f=i[w+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+120>>2]=r,k=i[e+124>>2],i[e+124>>2]=f;u:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break u;W[i[i[k>>2]+8>>2]](k),y(k)}h=v-16|0,v=h,n=i[e+44>>2],r=i[n+36>>2],k=i[n+40>>2];u:{if((r|0)!=(k|0))for(;;){s:{if(f=i[r>>2],!f||!Z0(f,92792,93796))break s;if(f=i[r+4>>2],!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),f=i[w>>2],k=i[w+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[r>>2]=f,f=i[r+4>>2],i[r+4>>2]=k,!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;W[i[i[f>>2]+8>>2]](f),y(f);break u}if(r=r+8|0,(k|0)==(r|0))break}i[h+8>>2]=i[w>>2],r=i[w+4>>2],i[h+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),P0(n+36|0,h+8|0),f=i[h+12>>2];s:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break s;W[i[i[f>>2]+8>>2]](f),y(f)}}v=h+16|0,f=i[w+4>>2];u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;W[i[i[f>>2]+8>>2]](f),y(f)}i[o+320>>2]=0,i[o+312>>2]=0,i[o+316>>2]=0,B=_+52|0;u:{s:{h:{f=i[I+268>>2],r=i[I+264>>2];w:{if((f|0)!=(r|0)){if((f-r|0)<0)break i;if(r=(x|0)==1635150182,!(r|(x|0)==1751476579)){i[o+404>>2]=0,i[o+376>>2]=78164,i[o+320>>2]=78144,e=i[19545],i[o+312>>2]=e,k=o+312|0,i[k+i[e-12>>2]>>2]=i[19546],i[o+316>>2]=0,e=k+i[i[o+312>>2]-12>>2]|0,f=o+324|0,J0(e,f),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[o+320>>2]=e,r=o+320|0,i[r+i[e-12>>2]>>2]=i[19548],e=i[19544],i[o+312>>2]=e,i[k+i[e-12>>2]>>2]=i[19549],i[o+376>>2]=78164,i[o+312>>2]=78124,i[o+320>>2]=78144,n=R0(f),i[n>>2]=77200,i[o+364>>2]=0,i[o+368>>2]=0,i[o+356>>2]=0,i[o+360>>2]=0,i[o+372>>2]=24,r=F(r,31160,41),e=o+112|0,z1(e,R),f=r,Q=e,r=t[o+123|0],e=(r|0)<0,F(F(f,e?i[o+112>>2]:Q,e?i[o+116>>2]:r),28773,31),t[o+123|0]<0&&Z(i[o+112>>2]),e=i[o+372>>2];_:{if(e&16){e=i[o+368>>2],r=i[o+348>>2],e>>>0<r>>>0&&(i[o+368>>2]=r,e=r),r=o+344|0;break _}if(!(e&8)){e=0,t[o+123|0]=0,r=o+112|0;break s}e=i[o+340>>2],r=o+332|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break n;if(e>>>0>=11){f=e|7,r=C(f+1|0),i[o+120>>2]=f-2147483647,i[o+112>>2]=r,i[o+116>>2]=e;break h}if(t[o+123|0]=e,r=o+112|0,e)break h;e=0;break s}k=r?1635135811:1752589123,i[o+112>>2]=0,i[o+116>>2]=0,i[o+320>>2]=0,i[o+312>>2]=0,i[o+316>>2]=0,r=i[I+268>>2],f=i[I+264>>2];_:{if((r|0)==(f|0)){dr(O,o+312|0,k,o+112|0);break _}if(h=r-f|0,(h|0)<0)break i;n=C(h),i[o+312>>2]=n,r=n+h|0,i[o+320>>2]=r,h&&z(n,f,h),i[o+316>>2]=r,dr(O,o+312|0,k,o+112|0),Z(n)}f=i[O>>2],f||(t[O+19|0]<0&&Z(i[O+8>>2]),P0(B,o+112|0)),k=i[o+116>>2];_:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break _;W[i[i[k>>2]+8>>2]](k),y(k)}if(!f)break w;break u}if(f=C(120),i[f>>2]=95988,i[f+4>>2]=0,i[f+8>>2]=0,r=f+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,i[f+16>>2]=93176,i[f+32>>2]=1718773093,i[o+316>>2]=f,i[o+312>>2]=r,P0(B,o+312|0),f=i[o+316>>2],!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break w;W[i[i[f>>2]+8>>2]](f),y(f)}m=C(128),r=m,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96348,f=r+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,X[r+112>>1]=0,i[r+16>>2]=93816,i[r+32>>2]=1769173093,r=i[I+116>>2],i[m+120>>2]=i[I+112>>2],i[m+124>>2]=r,i[o+316>>2]=m,i[o+312>>2]=f,i[m+4>>2]=i[m+4>>2]+1,P0(B,o+312|0),f=i[o+316>>2];w:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break w;W[i[i[f>>2]+8>>2]](f),y(f)}E=C(136),r=E,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97428,n=r+16|0,r=n,i[r+8>>2]=0,i[r+12>>2]=0,i[E+32>>2]=0,i[E+36>>2]=0,i[E+40>>2]=0,i[E+44>>2]=0,i[E+48>>2]=0,i[E+16>>2]=92500,i[E+60>>2]=0,i[E+64>>2]=0,i[E+52>>2]=0,i[E+56>>2]=0,i[E+72>>2]=-1,i[E+76>>2]=-1,i[E+80>>2]=-1,i[E+84>>2]=-1,i[E+116>>2]=0,i[E+88>>2]=0,i[E+92>>2]=0,i[E+96>>2]=0,i[E+100>>2]=0,i[E+104>>2]=0,i[E+108>>2]=0,X[E+112>>1]=0,i[E+16>>2]=95004,i[E+128>>2]=0,i[E+120>>2]=0,i[E+124>>2]=0,i[E+32>>2]=1885960297,f=u[I+120|0],k=C(1),t[k|0]=f,r=k+1|0,i[E+128>>2]=r,i[E+120>>2]=k,i[E+124>>2]=r,h=C(2),t[h+1|0]=f,t[h|0]=u[k|0],r=h+2|0,i[E+128>>2]=r,i[E+124>>2]=r,i[E+120>>2]=h,Z(k),w=u[I+120|0],i[E+124>>2]=r,f=i[E+128>>2];w:{if(f>>>0>r>>>0){t[h+2|0]=w,k=h+3|0;break w}if(V=i[E+120>>2],r=r-V|0,h=r+1|0,(h|0)<0)break i;if(k=f-V|0,f=k<<1,h=k>>>0>=1073741823?2147483647:f>>>0>h>>>0?f:h,h?f=C(h):f=0,k=f+r|0,t[k|0]=w,r&&z(f,V,r),i[E+128>>2]=f+h,k=k+1|0,i[E+124>>2]=k,i[E+120>>2]=f,!V)break w;Z(V)}i[E+124>>2]=k,i[o+316>>2]=E,i[o+312>>2]=n,i[E+4>>2]=i[E+4>>2]+1,P0(B,o+312|0),f=i[o+316>>2];w:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break w;W[i[i[f>>2]+8>>2]](f),y(f)}V=C(128),r=V,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97388,h=r+16|0,i[h+8>>2]=0,i[h+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[r+16>>2]=101860,i[r+32>>2]=1668246642,i[r+116>>2]=0,i[r+120>>2]=0,k=i[I+124>>2],n=p[I+128>>1],f=u[I+100|0],j=C(24),i[j+12>>2]=101820,i[j>>2]=101740,i[j+4>>2]=2,i[j+8>>2]=0,r=j,i[r+16>>2]=k,i[r+20>>2]=f<<16|n,i[V+120>>2]=r,i[V+116>>2]=r+12,r=i[r+4>>2],i[j+4>>2]=r-1,r||(W[i[i[j>>2]+8>>2]](j),y(j)),i[o+316>>2]=V,i[o+312>>2]=h,i[V+4>>2]=i[V+4>>2]+1,P0(B,o+312|0),f=i[o+316>>2];w:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break w;W[i[i[f>>2]+8>>2]](f),y(f)}w:{if(u[I+104|0]==1){if(Q=C(128),i[Q+4>>2]=0,i[Q+8>>2]=0,i[Q>>2]=97388,f=Q+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[Q+32>>2]=0,i[Q+36>>2]=0,i[Q+40>>2]=0,i[Q+44>>2]=0,i[Q+48>>2]=0,i[Q+16>>2]=92500,i[Q+60>>2]=0,i[Q+64>>2]=0,i[Q+52>>2]=0,i[Q+56>>2]=0,i[Q+72>>2]=-1,i[Q+76>>2]=-1,i[Q+80>>2]=-1,i[Q+84>>2]=-1,i[Q+88>>2]=0,i[Q+92>>2]=0,i[Q+96>>2]=0,i[Q+100>>2]=0,i[Q+104>>2]=0,i[Q+108>>2]=0,h=0,t[Q+112|0]=0,i[Q+16>>2]=101860,i[Q+32>>2]=1668246642,i[Q+116>>2]=0,i[Q+120>>2]=0,i[o+320>>2]=0,i[o+312>>2]=0,i[o+316>>2]=0,k=0,r=i[I+280>>2],n=i[I+276>>2],(r|0)!=(n|0)){if(r=r-n|0,(r|0)<0)break i;k=C(r),i[o+312>>2]=k,h=r+k|0,i[o+320>>2]=h,r&&z(k,n,r),i[o+316>>2]=h}if(w=C(32),r=w,i[r+24>>2]=0,i[r+28>>2]=0,i[r+16>>2]=1886547814,i[r+20>>2]=0,i[r+12>>2]=101780,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101940,(k|0)!=(h|0)){if(h=h-k|0,(h|0)<0)break i;n=C(h),i[r+20>>2]=n,r=n+h|0,i[w+28>>2]=r,h&&z(n,k,h),i[w+24>>2]=r}r=w+12|0;_:{if(!k){i[w+4>>2]=i[w+4>>2]+2,i[Q+120>>2]=w,i[Q+116>>2]=r;break _}if(Z(k),k=i[Q+120>>2],i[w+4>>2]=i[w+4>>2]+2,i[Q+120>>2]=w,i[Q+116>>2]=r,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break _;W[i[i[k>>2]+8>>2]](k),y(k)}r=i[w+4>>2],i[w+4>>2]=r-1,r||(W[i[i[w>>2]+8>>2]](w),y(w)),i[o+316>>2]=Q,i[o+312>>2]=f,i[Q+4>>2]=i[Q+4>>2]+1,P0(B,o+312|0),f=i[o+316>>2];_:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break _;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=i[w+4>>2],i[w+4>>2]=r-1,r||(W[i[i[w>>2]+8>>2]](w),y(w)),r=i[Q+4>>2],i[Q+4>>2]=r-1,r)break w;W[i[i[Q>>2]+8>>2]](Q),y(Q);break w}if(f=C(120),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=95988,r=f+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,i[f+16>>2]=93176,i[f+32>>2]=1718773093,i[o+316>>2]=f,i[o+312>>2]=r,P0(B,o+312|0),f=i[o+316>>2],!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break w;W[i[i[f>>2]+8>>2]](f),y(f)}i[o+320>>2]=0,i[o+312>>2]=0,i[o+316>>2]=0;w:{_:{v:{f=i[I+244>>2],r=i[I+240>>2];B:{if((f|0)!=(r|0)){if((f-r|0)<0)break i;if(r=(x|0)==1635150182,!(r|(x|0)==1751476579)){i[o+404>>2]=0,i[o+376>>2]=78164,i[o+320>>2]=78144,e=i[19545],i[o+312>>2]=e,k=o+312|0,i[k+i[e-12>>2]>>2]=i[19546],i[o+316>>2]=0,e=k+i[i[o+312>>2]-12>>2]|0,f=o+324|0,J0(e,f),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[o+320>>2]=e,r=o+320|0,i[r+i[e-12>>2]>>2]=i[19548],e=i[19544],i[o+312>>2]=e,i[k+i[e-12>>2]>>2]=i[19549],i[o+376>>2]=78164,i[o+312>>2]=78124,i[o+320>>2]=78144,n=R0(f),i[n>>2]=77200,i[o+364>>2]=0,i[o+368>>2]=0,i[o+356>>2]=0,i[o+360>>2]=0,i[o+372>>2]=24,r=F(r,31160,41),e=o+112|0,z1(e,R),f=r,Q=e,r=t[o+123|0],e=(r|0)<0,F(F(f,e?i[o+112>>2]:Q,e?i[o+116>>2]:r),28773,31),t[o+123|0]<0&&Z(i[o+112>>2]),e=i[o+372>>2];m:{if(e&16){k=o+344|0,e=i[o+368>>2],r=i[o+348>>2],e>>>0<r>>>0&&(i[o+368>>2]=r,e=r);break m}if(!(e&8)){e=0,t[o+123|0]=0,k=o+112|0;break _}k=o+332|0,e=i[o+340>>2]}if(f=i[k>>2],e=e-f|0,e>>>0>=2147483640)break n;if(e>>>0>=11){r=e|7,k=C(r+1|0),i[o+120>>2]=r-2147483647,i[o+112>>2]=k,i[o+116>>2]=e;break v}if(t[o+123|0]=e,k=o+112|0,e)break v;e=0;break _}k=r?1635135811:1752589123,i[o+112>>2]=0,i[o+116>>2]=0,i[o+320>>2]=0,i[o+312>>2]=0,i[o+316>>2]=0,r=i[I+244>>2],f=i[I+240>>2];m:{if((r|0)==(f|0)){dr(O,o+312|0,k,o+112|0);break m}if(h=r-f|0,(h|0)<0)break i;n=C(h),i[o+312>>2]=n,r=n+h|0,i[o+320>>2]=r,h&&z(n,f,h),i[o+316>>2]=r,dr(O,o+312|0,k,o+112|0),Z(n)}f=i[O>>2],f||(t[O+19|0]<0&&Z(i[O+8>>2]),P0(B,o+112|0)),k=i[o+116>>2];m:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break m;W[i[i[k>>2]+8>>2]](k),y(k)}if(!f)break B;break w}if(f=C(120),i[f>>2]=95988,i[f+4>>2]=0,i[f+8>>2]=0,r=f+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,i[f+16>>2]=93176,i[f+32>>2]=1718773093,i[o+316>>2]=f,i[o+312>>2]=r,P0(B,o+312|0),f=i[o+316>>2],!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break B;W[i[i[f>>2]+8>>2]](f),y(f)}B:{if(i[I+320>>2]){n=C(144),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=96388,r=n+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,i[n+16>>2]=92500,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,X[n+112>>1]=0,i[n+16>>2]=93964,i[n+136>>2]=0,i[n+140>>2]=0,i[n+128>>2]=0,i[n+132>>2]=0,i[n+120>>2]=0,i[n+124>>2]=0,i[n+32>>2]=1635088451,h=C(48),t[h+43|0]=0,f=u[20745]|u[20746]<<8|(u[20747]<<16|u[20748]<<24),t[h+39|0]=f,t[h+40|0]=f>>>8,t[h+41|0]=f>>>16,t[h+42|0]=f>>>24,k=u[20742]|u[20743]<<8|(u[20744]<<16|u[20745]<<24),f=u[20738]|u[20739]<<8|(u[20740]<<16|u[20741]<<24),t[h+32|0]=f,t[h+33|0]=f>>>8,t[h+34|0]=f>>>16,t[h+35|0]=f>>>24,t[h+36|0]=k,t[h+37|0]=k>>>8,t[h+38|0]=k>>>16,t[h+39|0]=k>>>24,k=u[20734]|u[20735]<<8|(u[20736]<<16|u[20737]<<24),f=u[20730]|u[20731]<<8|(u[20732]<<16|u[20733]<<24),t[h+24|0]=f,t[h+25|0]=f>>>8,t[h+26|0]=f>>>16,t[h+27|0]=f>>>24,t[h+28|0]=k,t[h+29|0]=k>>>8,t[h+30|0]=k>>>16,t[h+31|0]=k>>>24,k=u[20726]|u[20727]<<8|(u[20728]<<16|u[20729]<<24),f=u[20722]|u[20723]<<8|(u[20724]<<16|u[20725]<<24),t[h+16|0]=f,t[h+17|0]=f>>>8,t[h+18|0]=f>>>16,t[h+19|0]=f>>>24,t[h+20|0]=k,t[h+21|0]=k>>>8,t[h+22|0]=k>>>16,t[h+23|0]=k>>>24,k=u[20718]|u[20719]<<8|(u[20720]<<16|u[20721]<<24),f=u[20714]|u[20715]<<8|(u[20716]<<16|u[20717]<<24),t[h+8|0]=f,t[h+9|0]=f>>>8,t[h+10|0]=f>>>16,t[h+11|0]=f>>>24,t[h+12|0]=k,t[h+13|0]=k>>>8,t[h+14|0]=k>>>16,t[h+15|0]=k>>>24,k=u[20710]|u[20711]<<8|(u[20712]<<16|u[20713]<<24),f=u[20706]|u[20707]<<8|(u[20708]<<16|u[20709]<<24),t[h|0]=f,t[h+1|0]=f>>>8,t[h+2|0]=f>>>16,t[h+3|0]=f>>>24,t[h+4|0]=k,t[h+5|0]=k>>>8,t[h+6|0]=k>>>16,t[h+7|0]=k>>>24,m1(n+120|0,h,43),Z(h),i[o+316>>2]=n,i[o+312>>2]=r,i[n+4>>2]=i[n+4>>2]+1,P0(B,o+312|0),f=i[o+316>>2];m:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break m;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=i[n+4>>2],i[n+4>>2]=r-1,r)break B;W[i[i[n>>2]+8>>2]](n),y(n);break B}if(f=C(120),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=95988,r=f+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,i[f+16>>2]=93176,i[f+32>>2]=1718773093,i[o+316>>2]=f,i[o+312>>2]=r,P0(B,o+312|0),f=i[o+316>>2],!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break B;W[i[i[f>>2]+8>>2]](f),y(f)}f=C(120),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=95988,r=f+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,i[f+16>>2]=93176,i[f+32>>2]=1718773093,i[o+316>>2]=f,i[o+312>>2]=r,P0(B,o+312|0),f=i[o+316>>2];B:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break B;W[i[i[f>>2]+8>>2]](f),y(f)}h=C(136),r=h,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96308,R=r+16|0,i[R+8>>2]=0,i[R+12>>2]=0,i[R+16>>2]=0,i[R+20>>2]=0,i[R+24>>2]=0,i[R+28>>2]=0,i[R+32>>2]=0,i[R>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,X[r+112>>1]=0,i[R>>2]=93884,i[r+128>>2]=0,i[r+120>>2]=0,i[r+124>>2]=0,i[r+32>>2]=1768975713,i[o+268>>2]=r,i[o+264>>2]=R,i[r+4>>2]=i[r+4>>2]+1,r=i[o+268>>2],i[o+56>>2]=i[o+264>>2],i[o+60>>2]=r,r=i[o+56>>2],f=i[o+60>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+128>>2]=r,k=i[e+132>>2],i[e+132>>2]=f;B:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break B;W[i[i[k>>2]+8>>2]](k),y(k)}w=v-16|0,v=w,n=i[e+44>>2],f=i[n+36>>2],k=i[n+40>>2];B:{if((f|0)!=(k|0))for(;;){m:{if(r=i[f>>2],!r||!Z0(r,92792,93944))break m;if(r=i[f+4>>2],!r|i[r+4>>2]!=-1||(W[i[i[r>>2]+8>>2]](r),y(r)),r=i[o+56>>2],k=i[o+60>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[f>>2]=r,n=i[f+4>>2],i[f+4>>2]=k,!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break B;W[i[i[n>>2]+8>>2]](n),y(n);break B}if(f=f+8|0,(k|0)==(f|0))break}i[w+8>>2]=i[o+56>>2],r=i[o+60>>2],i[w+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),P0(n+36|0,w+8|0),f=i[w+12>>2];m:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break m;W[i[i[f>>2]+8>>2]](f),y(f)}}v=w+16|0,f=i[o+60>>2];B:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break B;W[i[i[f>>2]+8>>2]](f),y(f)}X[o+262>>1]=1,t[o+260|0]=1,i[o+52>>2]=p[o+260>>1]|p[o+262>>1]<<16,U4(R,1,o+52|0),X[o+258>>1]=2,t[o+256|0]=0,i[o+48>>2]=p[o+256>>1]|p[o+258>>1]<<16,U4(R,1,o+48|0),X[o+254>>1]=3,t[o+252|0]=0,i[o+44>>2]=p[o+252>>1]|p[o+254>>1]<<16,U4(R,1,o+44|0),X[o+250>>1]=4,t[o+248|0]=1,i[o+40>>2]=p[o+248>>1]|p[o+250>>1]<<16,U4(R,1,o+40|0),X[o+246>>1]=5,t[o+244|0]=1,i[o+36>>2]=p[o+244>>1]|p[o+246>>1]<<16,U4(R,1,o+36|0),i[I+320>>2]&&(X[o+242>>1]=6,t[o+240|0]=1,i[o+32>>2]=p[o+240>>1]|p[o+242>>1]<<16,U4(R,2,o+32|0),X[o+238>>1]=2,t[o+236|0]=0,i[o+28>>2]=p[o+236>>1]|p[o+238>>1]<<16,U4(R,2,o+28|0),X[o+234>>1]=7,t[o+232|0]=1,i[o+24>>2]=p[o+232>>1]|p[o+234>>1]<<16,U4(R,2,o+24|0),X[o+230>>1]=8,t[o+228|0]=0,i[o+20>>2]=p[o+228>>1]|p[o+230>>1]<<16,U4(R,2,o+20|0)),r=u[I+109|0],P6(e,1,r),i[I+320>>2]&&P6(e,2,r),f=C(176),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=96108,r=k5(f+16|0),i[o+224>>2]=f,i[o+220>>2]=r,i[f+4>>2]=i[f+4>>2]+1,r=i[o+224>>2],i[o+8>>2]=i[o+220>>2],i[o+12>>2]=r,r=i[o+8>>2],k=i[o+12>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),n=e,i[n+64>>2]=r,r=i[n+68>>2],i[n+68>>2]=k;B:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break B;W[i[i[r>>2]+8>>2]](r),y(r)}R=v-16|0,v=R,w=i[n+44>>2],e=i[w+36>>2],k=i[w+40>>2];B:{if((e|0)!=(k|0))for(;;){m:{if(r=i[e>>2],!r||!Z0(r,92792,95888))break m;if(r=i[e+4>>2],!r|i[r+4>>2]!=-1||(W[i[i[r>>2]+8>>2]](r),y(r)),r=i[o+8>>2],k=i[o+12>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e>>2]=r,r=i[e+4>>2],i[e+4>>2]=k,!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break B;W[i[i[r>>2]+8>>2]](r),y(r);break B}if(e=e+8|0,(k|0)==(e|0))break}i[R+8>>2]=i[o+8>>2],e=i[o+12>>2],i[R+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),P0(w+36|0,R+8|0),r=i[R+12>>2];m:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break m;W[i[i[r>>2]+8>>2]](r),y(r)}}v=R+16|0,r=i[o+12>>2];B:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break B;W[i[i[r>>2]+8>>2]](r),y(r)}i[o+208>>2]=0,i[o+200>>2]=0,i[o+204>>2]=0,i[o+192>>2]=0,i[o+196>>2]=0,t[o+188|0]=0,i[o+184>>2]=1,X[o+190>>1]=0,i[o+344>>2]=0,i[o+336>>2]=0,i[o+340>>2]=0,i[o+328>>2]=0,i[o+332>>2]=0,i[o+320>>2]=0,i[o+324>>2]=0,i[o+312>>2]=0,i[o+316>>2]=0,e=i[I+332>>2],i[o+320>>2]=i[I+328>>2],i[o+324>>2]=e,i[o+328>>2]=i[I+336>>2],i[o+332>>2]=0,S=o,q=ye(o+200|0,o+312|0),i[S+204>>2]=q,e=i[f+124>>2];B:{if(e>>>0<o0[f+128>>2]){r=i[o+188>>2],i[e>>2]=i[o+184>>2],i[e+4>>2]=r,r=i[o+196>>2],i[e+8>>2]=i[o+192>>2],i[e+12>>2]=r,i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,k=i[o+200>>2],r=i[o+204>>2],b6(e+16|0,k,r,(r-k|0)/40|0),e=e+32|0;break B}e=Vi(f+120|0,o+184|0)}i[f+124>>2]=e,k=i[I+320>>2];B:{if(!k)break B;i[o+176>>2]=0,i[o+168>>2]=0,i[o+172>>2]=0,t[o+156|0]=0,i[o+160>>2]=0,i[o+164>>2]=0,i[o+152>>2]=2,X[o+158>>1]=0,i[o+144>>2]=0,i[o+136>>2]=0,i[o+140>>2]=0,i[o+128>>2]=0,i[o+132>>2]=0,i[o+120>>2]=0,i[o+124>>2]=0,i[o+112>>2]=0,i[o+116>>2]=0,r=i[I+312>>2],e=i[I+316>>2],i[o+128>>2]=k,i[o+132>>2]=0,i[o+120>>2]=r,i[o+124>>2]=e,r=ye(o+168|0,o+112|0),e=i[f+124>>2],i[o+172>>2]=r;m:{if(e>>>0<o0[f+128>>2]){r=i[o+156>>2],i[e>>2]=i[o+152>>2],i[e+4>>2]=r,r=i[o+164>>2],i[e+8>>2]=i[o+160>>2],i[e+12>>2]=r,i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,k=i[o+168>>2],r=i[o+172>>2],b6(e+16|0,k,r,(r-k|0)/40|0),e=e+32|0;break m}e=Vi(f+120|0,o+152|0)}if(i[f+124>>2]=e,e=i[o+136>>2],e&&(i[o+140>>2]=e,Z(e)),r=i[o+168>>2],!r)break B;if(k=i[o+172>>2],e=r,(k|0)!=(r|0)){for(;e=i[k-16>>2],e&&(i[k-12>>2]=e,Z(e)),k=k-40|0,(r|0)!=(k|0););e=i[o+168>>2]}i[o+172>>2]=r,Z(e)}B:{if(u[I+105|0]!=1)break B;i[o+176>>2]=0,i[o+168>>2]=0,i[o+172>>2]=0,t[o+156|0]=0,i[o+160>>2]=0,i[o+164>>2]=0,i[o+152>>2]=6,X[o+158>>1]=0,i[o+144>>2]=0,i[o+136>>2]=0,i[o+140>>2]=0,i[o+128>>2]=0,i[o+132>>2]=0,i[o+120>>2]=0,i[o+124>>2]=0,i[o+112>>2]=0,i[o+116>>2]=0,e=i[I+364>>2],i[o+120>>2]=i[I+360>>2],i[o+124>>2]=e,i[o+128>>2]=i[I+368>>2],i[o+132>>2]=0,S=o,q=ye(o+168|0,o+112|0),i[S+172>>2]=q,e=i[f+124>>2];m:{if(e>>>0<o0[f+128>>2]){r=i[o+156>>2],i[e>>2]=i[o+152>>2],i[e+4>>2]=r,r=i[o+164>>2],i[e+8>>2]=i[o+160>>2],i[e+12>>2]=r,i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,k=i[o+168>>2],r=i[o+172>>2],b6(e+16|0,k,r,(r-k|0)/40|0),e=e+32|0;break m}e=Vi(f+120|0,o+152|0)}if(i[f+124>>2]=e,e=i[o+136>>2],e&&(i[o+140>>2]=e,Z(e)),r=i[o+168>>2],!r)break B;if(k=i[o+172>>2],e=r,(k|0)!=(r|0)){for(;e=i[k-16>>2],e&&(i[k-12>>2]=e,Z(e)),k=k-40|0,(r|0)!=(k|0););e=i[o+168>>2]}i[o+172>>2]=r,Z(e)}B:{if(u[I+106|0]!=1)break B;i[o+176>>2]=0,i[o+168>>2]=0,i[o+172>>2]=0,t[o+156|0]=0,i[o+160>>2]=0,i[o+164>>2]=0,i[o+152>>2]=7,X[o+158>>1]=0,i[o+144>>2]=0,i[o+136>>2]=0,i[o+140>>2]=0,i[o+128>>2]=0,i[o+132>>2]=0,i[o+120>>2]=0,i[o+124>>2]=0,i[o+112>>2]=0,i[o+116>>2]=0,e=i[I+380>>2],i[o+120>>2]=i[I+376>>2],i[o+124>>2]=e,i[o+128>>2]=i[I+384>>2],i[o+132>>2]=0,S=o,q=ye(o+168|0,o+112|0),i[S+172>>2]=q,e=i[f+124>>2];m:{if(e>>>0<o0[f+128>>2]){r=i[o+156>>2],i[e>>2]=i[o+152>>2],i[e+4>>2]=r,r=i[o+164>>2],i[e+8>>2]=i[o+160>>2],i[e+12>>2]=r,i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,k=i[o+168>>2],r=i[o+172>>2],b6(e+16|0,k,r,(r-k|0)/40|0),e=e+32|0;break m}e=Vi(f+120|0,o+152|0)}if(i[f+124>>2]=e,e=i[o+136>>2],e&&(i[o+140>>2]=e,Z(e)),r=i[o+168>>2],!r)break B;if(k=i[o+172>>2],e=r,(k|0)!=(r|0)){for(;e=i[k-16>>2],e&&(i[k-12>>2]=e,Z(e)),k=k-40|0,(r|0)!=(k|0););e=i[o+168>>2]}i[o+172>>2]=r,Z(e)}e=C(136),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=96548,x=e+16|0,r=x,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[r>>2]=94284,i[e+128>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1769104742,i[o+108>>2]=e,i[o+104>>2]=r,i[e+4>>2]=i[e+4>>2]+1,r=i[o+108>>2],i[o>>2]=i[o+104>>2],i[o+4>>2]=r,r=i[o>>2],k=i[o+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[n+80>>2]=r,w=i[n+84>>2],i[n+84>>2]=k;B:{if(!w||(r=i[w+4>>2],i[w+4>>2]=r-1,r))break B;W[i[i[w>>2]+8>>2]](w),y(w)}R=v-16|0,v=R,w=i[n+44>>2],r=i[w+36>>2],n=i[w+40>>2];B:{if((r|0)!=(n|0))for(;;){m:{if(k=i[r>>2],!k||!Z0(k,92792,94344))break m;if(k=i[r+4>>2],!k|i[k+4>>2]!=-1||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[o>>2],n=i[o+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[r>>2]=k,k=i[r+4>>2],i[r+4>>2]=n,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break B;W[i[i[k>>2]+8>>2]](k),y(k);break B}if(r=r+8|0,(n|0)==(r|0))break}i[R+8>>2]=i[o>>2],r=i[o+4>>2],i[R+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),P0(w+36|0,R+8|0),k=i[R+12>>2];m:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break m;W[i[i[k>>2]+8>>2]](k),y(k)}}v=R+16|0,k=i[o+4>>2];B:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break B;W[i[i[k>>2]+8>>2]](k),y(k)}k=C(4),i[o+112>>2]=k,r=k+4|0,i[o+120>>2]=r,i[k>>2]=1,i[o+116>>2]=r,i[I+320>>2]&&C3(x,2,1635088492,o+112|0),u[I+105|0]==1&&C3(x,6,1667527523,o+112|0),u[I+106|0]==1&&C3(x,7,1667527523,o+112|0),r=i[28729],i[O>>2]=i[28728],i[O+4>>2]=r,k=O+8|0;B:{if(t[114931]>=0){r=i[28731],i[k>>2]=i[28730],i[k+4>>2]=r,i[k+8>>2]=i[28732];break B}T(k,i[28730],i[28731])}if(r=i[o+112>>2],r&&(i[o+116>>2]=r,Z(r)),r=i[e+4>>2],i[e+4>>2]=r-1,r||(W[i[i[e>>2]+8>>2]](e),y(e)),e=i[o+336>>2],e&&(i[o+340>>2]=e,Z(e)),k=i[o+200>>2],k){if(e=i[o+204>>2],r=k,(e|0)!=(r|0)){for(;r=i[e-16>>2],r&&(i[e-12>>2]=r,Z(r)),e=e-40|0,(k|0)!=(e|0););r=i[o+200>>2]}i[o+204>>2]=k,Z(r)}if(e=i[f+4>>2],i[f+4>>2]=e-1,e||(W[i[i[f>>2]+8>>2]](f),y(f)),e=i[h+4>>2],i[h+4>>2]=e-1,e)break w;W[i[i[h>>2]+8>>2]](h),y(h);break w}if(!e)break _;z(k,f,e)}t[e+k|0]=0,a(O,3,0,o+112|0),t[o+123|0]<0&&Z(i[o+112>>2]),e=i[19543],i[o+312>>2]=e,i[i[e-12>>2]+(o+312|0)>>2]=i[19551],i[o+320>>2]=i[19552],i[n>>2]=77200,t[o+367|0]<0&&Z(i[o+356>>2]),y0(n),Y0(o+376|0)}if(e=i[j+4>>2],i[j+4>>2]=e-1,e||(W[i[i[j>>2]+8>>2]](j),y(j)),e=i[V+4>>2],i[V+4>>2]=e-1,e||(W[i[i[V>>2]+8>>2]](V),y(V)),e=i[E+4>>2],i[E+4>>2]=e-1,e||(W[i[i[E>>2]+8>>2]](E),y(E)),e=i[m+4>>2],i[m+4>>2]=e-1,e)break u;W[i[i[m>>2]+8>>2]](m),y(m);break u}if(!e)break s;z(r,k,e)}t[e+r|0]=0,a(O,3,0,o+112|0),t[o+123|0]<0&&Z(i[o+112>>2]),e=i[19543],i[o+312>>2]=e,i[i[e-12>>2]+(o+312|0)>>2]=i[19551],i[o+320>>2]=i[19552],i[n>>2]=77200,t[o+367|0]<0&&Z(i[o+356>>2]),y0(n),Y0(o+376|0)}if(e=i[_+4>>2],i[_+4>>2]=e-1,e)break t;W[i[i[_>>2]+8>>2]](_),y(_);break t}if(!e)break o;z(r,k,e)}t[e+r|0]=0,a(O,3,0,o+112|0),t[o+123|0]<0&&Z(i[o+112>>2]),e=i[19543],i[o+312>>2]=e,i[i[e-12>>2]+(o+312|0)>>2]=i[19551],i[o+320>>2]=i[19552],i[n>>2]=77200,t[o+367|0]<0&&Z(i[o+356>>2]),y0(n),Y0(o+376|0)}t:{if(!U||(e=i[U+4>>2],i[U+4>>2]=e-1,e))break t;W[i[i[U>>2]+8>>2]](U),y(U)}e=i[G+4>>2],i[G+4>>2]=e-1,e||(W[i[i[G>>2]+8>>2]](G),y(G)),e=i[l+4>>2],i[l+4>>2]=e-1,e||(W[i[i[l>>2]+8>>2]](l),y(l)),v=o+464|0;break k}I0(),M()}r=A+8|0;k:{if(i[N+24>>2]){e=i[N+28>>2],i[A>>2]=i[N+24>>2],i[A+4>>2]=e,i[r+8>>2]=i[N+40>>2],A=i[N+36>>2],i[r>>2]=i[N+32>>2],i[r+4>>2]=A,i[N+40>>2]=0,i[N+32>>2]=0,i[N+36>>2]=0;break k}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,t[114931]>=0){A=i[28731],i[r>>2]=i[28730],i[r+4>>2]=A,i[r+8>>2]=i[28732];break k}T(r,i[28730],i[28731])}if(t[N+43|0]>=0)break A;Z(i[N+32>>2]);break A}if(f=i[e>>2],r=i[f+36>>2],f=i[f+40>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+44>>2]=r,k=i[e+48>>2],i[e+48>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[e+44>>2]),r){V=i[e+48>>2],V&&(i[V+4>>2]=i[V+4>>2]+1),f=i[e+20>>2],k=i[e+24>>2];k:{if(f>>>0<k>>>0){i[f+4>>2]=V,i[f>>2]=r,r=f+8|0;break k}if(_=i[e+16>>2],h=f-_|0,m=h>>3,l=m+1|0,l>>>0>=536870912)break i;if(w=k-_|0,k=w>>2,l=w>>>0>=2147483640?536870911:k>>>0>l>>>0?k:l,l){if(l>>>0>=536870912)break f;f=C(l<<3)}else f=0;if(w=f+h|0,i[w+4>>2]=V,i[w>>2]=r,k=w-(m<<3)|0,h&&z(k,_,h),i[e+24>>2]=f+(l<<3),r=w+8|0,i[e+20>>2]=r,i[e+16>>2]=k,!_)break k;Z(_)}i[e+20>>2]=r}if(f=i[e>>2],r=i[f+52>>2],f=i[f+56>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+152>>2]=r,k=i[e+156>>2],i[e+156>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[e+152>>2]),r){V=i[e+156>>2],V&&(i[V+4>>2]=i[V+4>>2]+1),f=i[e+20>>2],k=i[e+24>>2];k:{if(f>>>0<k>>>0){i[f+4>>2]=V,i[f>>2]=r,r=f+8|0;break k}if(_=i[e+16>>2],h=f-_|0,m=h>>3,l=m+1|0,l>>>0>=536870912)break i;if(w=k-_|0,k=w>>2,l=w>>>0>=2147483640?536870911:k>>>0>l>>>0?k:l,l){if(l>>>0>=536870912)break f;f=C(l<<3)}else f=0;if(w=f+h|0,i[w+4>>2]=V,i[w>>2]=r,k=w-(m<<3)|0,h&&z(k,_,h),i[e+24>>2]=f+(l<<3),r=w+8|0,i[e+20>>2]=r,i[e+16>>2]=k,!_)break k;Z(_)}i[e+20>>2]=r}if(f=i[e+44>>2],!((f|0)!=0|n)){if(t[N+24|0]=0,t[N+35|0]=0,a(A,2,104,N+24|0),t[N+35|0]>=0)break A;Z(i[N+24>>2]);break A}if(r=i[e+152>>2],!(n^1|(r|0)!=0)){if(t[N+24|0]=0,t[N+35|0]=0,a(A,2,151,N+24|0),t[N+35|0]>=0)break A;Z(i[N+24>>2]);break A}if(f){B=v-48|0,v=B,f=i[e+44>>2],r=i[f+36>>2],n=i[f+40>>2];k:{n:{if((r|0)!=(n|0))for(;;){t:{if(f=i[r>>2],!f||(k=Z0(f,92792,93396),!k))break t;if(r=i[r+4>>2],!r)break n;i[r+4>>2]=i[r+4>>2]+1;break k}if(r=r+8|0,(n|0)==(r|0))break}k=0}r=0}i[e+36>>2]=k,f=i[e+40>>2],i[e+40>>2]=r;k:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break k;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[e+44>>2],r=i[f+36>>2],n=i[f+40>>2];k:{n:{if((r|0)!=(n|0))for(;;){t:{if(f=i[r>>2],!f||(k=Z0(f,92792,93636),!k))break t;if(r=i[r+4>>2],!r)break n;i[r+4>>2]=i[r+4>>2]+1;break k}if(r=r+8|0,(n|0)==(r|0))break}k=0}r=0}i[e+88>>2]=k,f=i[e+92>>2],i[e+92>>2]=r,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(W[i[i[f>>2]+8>>2]](f),y(f)),k=i[e+88>>2]);k:{if(!k){if(t[B+24|0]=0,t[B+35|0]=0,a(A,2,111,B+24|0),t[B+35|0]>=0)break k;Z(i[B+24>>2]);break k}i[B+20>>2]=0,i[B+12>>2]=0,i[B+16>>2]=0,r=i[k+36>>2],k=i[k+40>>2];n:{t:{if((r|0)==(k|0))break t;for(;;){f=i[r>>2];o:{if(!f||(f=Z0(f,92792,93556),!f)||(i[B+24>>2]=f,f=i[r+4>>2],i[B+28>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),P0(B+12|0,B+24|0),n=i[B+28>>2],!n)||(f=i[n+4>>2],i[n+4>>2]=f-1,f))break o;W[i[i[n>>2]+8>>2]](n),y(n)}if(r=r+8|0,(k|0)==(r|0))break}if(l=i[B+12>>2],h=i[B+16>>2],(l|0)==(h|0))break t;for(n=e+140|0;;){if(w=i[l>>2],!w){if(t[B+24|0]=0,t[B+35|0]=0,a(A,2,125,B+24|0),t[B+35|0]>=0)break n;Z(i[B+24>>2]);break n}m=i[w+104>>2],_=i[l+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);o:{l:{f=n,r=f,k=i[f>>2];u:{if(!k)break u;for(;;){if(r=k,f=i[r+16>>2],f>>>0>m>>>0){if(f=r,k=i[f>>2],k)continue;break u}if(f>>>0>=m>>>0)break l;if(k=i[r+4>>2],!k)break}f=r+4|0}k=C(28),i[k+24>>2]=_,i[k+20>>2]=w,i[k+16>>2]=m,i[k+8>>2]=r,i[k>>2]=0,i[k+4>>2]=0,i[f>>2]=k,r=i[i[e+136>>2]>>2],r&&(i[e+136>>2]=r),G1(i[e+140>>2],k),i[e+144>>2]=i[e+144>>2]+1;break o}if(!_||(r=i[_+4>>2],i[_+4>>2]=r-1,r))break o;W[i[i[_>>2]+8>>2]](_),y(_)}if(l=l+8|0,(h|0)==(l|0))break}}if(k=i[e+44>>2],r=i[e+36>>2],!(!r|i[r+108>>2]!=1885954932)){r=i[k+36>>2],n=i[k+40>>2];t:{if((r|0)!=(n|0))for(;;){o:{if(f=i[r>>2],!f||(k=Z0(f,92792,93476),!k))break o;if(r=i[r+4>>2],!r){r=0;break t}i[r+4>>2]=i[r+4>>2]+1;break t}if(r=r+8|0,(n|0)==(r|0))break}r=0,k=0}if(i[e+104>>2]=k,f=i[e+108>>2],i[e+108>>2]=r,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(W[i[i[f>>2]+8>>2]](f),y(f)),k=i[e+104>>2]),!k){if(t[B+24|0]=0,t[B+35|0]=0,a(A,2,107,B+24|0),t[B+35|0]>=0)break n;Z(i[B+24>>2]);break n}f=i[e+44>>2],r=i[f+36>>2],n=i[f+40>>2];t:{if((r|0)!=(n|0))for(;;){o:{if(f=i[r>>2],!f||(k=Z0(f,92792,93716),!k))break o;if(r=i[r+4>>2],!r){r=0;break t}i[r+4>>2]=i[r+4>>2]+1;break t}if(r=r+8|0,(n|0)==(r|0))break}r=0,k=0}if(i[e+112>>2]=k,f=i[e+116>>2],i[e+116>>2]=r,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(W[i[i[f>>2]+8>>2]](f),y(f)),k=i[e+112>>2]),!k){if(t[B+24|0]=0,t[B+35|0]=0,a(A,2,112,B+24|0),t[B+35|0]>=0)break n;Z(i[B+24>>2]);break n}r=i[k+36>>2],n=i[k+40>>2];t:{if((r|0)!=(n|0))for(;;){o:{if(f=i[r>>2],!f||(k=Z0(f,92792,93796),!k))break o;if(r=i[r+4>>2],!r){r=0;break t}i[r+4>>2]=i[r+4>>2]+1;break t}if(r=r+8|0,(n|0)==(r|0))break}r=0,k=0}if(i[e+120>>2]=k,f=i[e+124>>2],i[e+124>>2]=r,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(W[i[i[f>>2]+8>>2]](f),y(f)),k=i[e+120>>2]),!k){if(t[B+24|0]=0,t[B+35|0]=0,a(A,2,108,B+24|0),t[B+35|0]>=0)break n;Z(i[B+24>>2]);break n}f=i[e+112>>2],i[B+32>>2]=0,i[B+24>>2]=0,i[B+28>>2]=0;t:{o:{if(r=i[f+36>>2],k=i[f+40>>2],(r|0)==(k|0))break o;for(;;){f=i[r>>2];l:{if(!f||(f=Z0(f,92792,93944),!f)||(i[B>>2]=f,f=i[r+4>>2],i[B+4>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),P0(B+24|0,B),n=i[B+4>>2],!n)||(f=i[n+4>>2],i[n+4>>2]=f-1,f))break l;W[i[i[n>>2]+8>>2]](n),y(n)}if(r=r+8|0,(k|0)==(r|0))break}if(r=i[B+24>>2],f=i[B+28>>2],(r|0)==(f|0))break o;if(f-r>>>0>8)for(k=1;;){f=0,n=i[r>>2],x=n+104|0,w=i[n+108>>2],r=i[(k<<3)+r>>2],n=i[r+104>>2],_=n,r=i[r+108>>2],G=r,U=v-32|0,v=U;l:{u:{R=r-n>>4;s:{if((R|0)<=0)break s;if(r=i[x+8>>2],h=i[x+4>>2],(R|0)<=r-h>>4){r=h-w|0,l=r>>4;h:{if((l|0)>=(R|0)){m=(R<<4)+n|0,r=h;break h}m=r+_|0;w:{if((G|0)==(m|0)){r=h;break w}for(f=m,r=h;;){if(n=i[f>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=n,n=i[f+8>>2],V=i[f+4>>2],(n|0)!=(V|0)){if(j=n-V|0,(j|0)<0)break i;E=C(j),i[r+8>>2]=E,i[r+4>>2]=E,n=E+j|0,i[r+12>>2]=n,j&&z(E,V,j),i[r+8>>2]=n}if(r=r+16|0,f=f+16|0,(G|0)==(f|0))break}}if(i[x+4>>2]=r,(l|0)<=0)break s}if(n=R<<4,G=n+w|0,f=r,n=f-n|0,h>>>0>n>>>0)for(l=n;V=i[l>>2],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=V,i[f+4>>2]=i[l+4>>2],i[f+8>>2]=i[l+8>>2],i[f+12>>2]=i[l+12>>2],i[l+12>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,f=f+16|0,l=l+16|0,h>>>0>l>>>0;);if(i[x+4>>2]=f,(r|0)!=(G|0))for(;h=r-16|0,f=n-16|0,i[h>>2]=i[f>>2],G=r-12|0,V=i[G>>2],V&&(l=r-8|0,i[l>>2]=V,Z(V),i[l>>2]=0,i[l+4>>2]=0,i[G>>2]=0),l=n-12|0,i[G>>2]=i[l>>2],i[r-8>>2]=i[n-8>>2],Q=r-4|0,r=n-4|0,i[Q>>2]=i[r>>2],i[r>>2]=0,i[l>>2]=0,i[l+4>>2]=0,r=h,n=f,(w|0)!=(f|0););if((_|0)==(m|0))break s;for(r=w;i[r>>2]=i[_>>2],(r|0)!=(_|0)&&(n=i[_+4>>2],f=i[_+8>>2],h1(r+4|0,n,f,f-n>>2)),r=r+16|0,_=_+16|0,(m|0)!=(_|0););break s}if(m=i[x>>2],h=R+(h-m>>4)|0,h>>>0>=268435456)break i;if(i[U+28>>2]=x+8,n=r-m|0,r=n>>3,n=n>>>0>=2147483632?268435455:r>>>0>h>>>0?r:h,n){if(n>>>0>=268435456)break u;f=C(n<<4)}for(i[U+12>>2]=f,r=(w-m|0)+f|0,i[U+20>>2]=r,i[U+24>>2]=(n<<4)+f,i[U+16>>2]=r,h=(R<<4)+r|0;;){if(f=i[_>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=f,f=i[_+8>>2],n=i[_+4>>2],(f|0)!=(n|0)){if(l=f-n|0,(l|0)<0)break i;m=C(l),i[r+8>>2]=m,i[r+4>>2]=m,f=l+m|0,i[r+12>>2]=f,l&&z(m,n,l),i[r+8>>2]=f}if(_=_+16|0,r=r+16|0,(h|0)==(r|0))break}i[U+20>>2]=h,f=i[U+20>>2],n=i[U+16>>2],r=w,w=i[x+4>>2];h:{if((r|0)==(w|0)){m=r;break h}for(n=r;h=i[n>>2],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=h,i[f+4>>2]=i[n+4>>2],i[f+8>>2]=i[n+8>>2],i[f+12>>2]=i[n+12>>2],i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,f=f+16|0,n=n+16|0,(w|0)!=(n|0););for(f=r;n=i[f+4>>2],n&&(i[f+8>>2]=n,Z(n)),f=f+16|0,(w|0)!=(f|0););f=i[U+20>>2],n=i[U+16>>2],m=i[x+4>>2]}if(i[U+20>>2]=(m-r|0)+f,i[x+4>>2]=r,m=i[x>>2],h=(m-r|0)+n|0,(r|0)!=(m|0)){for(f=m,n=h;w=i[f>>2],i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=w,i[n+4>>2]=i[f+4>>2],i[n+8>>2]=i[f+8>>2],i[n+12>>2]=i[f+12>>2],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,n=n+16|0,f=f+16|0,(r|0)!=(f|0););for(;f=i[m+4>>2],f&&(i[m+8>>2]=f,Z(f)),m=m+16|0,(r|0)!=(m|0););m=i[x>>2]}if(i[U+16>>2]=h,i[x+4>>2]=m,i[x>>2]=i[U+16>>2],i[U+16>>2]=m,r=i[x+4>>2],i[x+4>>2]=i[U+20>>2],i[U+20>>2]=r,r=i[x+8>>2],i[x+8>>2]=i[U+24>>2],i[U+24>>2]=r,i[U+12>>2]=i[U+16>>2],_=i[U+20>>2],f=i[U+16>>2],(_|0)!=(f|0))for(;r=_-16|0,i[U+20>>2]=r,n=i[_-12>>2],n&&(i[_-8>>2]=n,Z(n),r=i[U+20>>2]),_=r,(f|0)!=(r|0););if(r=i[U+12>>2],!r)break s;Z(r)}v=U+32|0;break l}x0(),M()}if(k=k+1|0,r=i[B+24>>2],!(k>>>0<i[B+28>>2]-r>>3>>>0))break}qi(e+128|0,r),f=0;break t}r=V2(B,47881),a(A,2,109,r),t[r+11|0]<0&&Z(i[r>>2]),f=1}if(n=i[B+24>>2],n){if(r=i[B+28>>2],k=n,(r|0)!=(k|0)){for(;;){h=i[r-4>>2];t:{if(!h||(k=i[h+4>>2],i[h+4>>2]=k-1,k))break t;W[i[i[h>>2]+8>>2]](h),y(h)}if(r=r-8|0,(n|0)==(r|0))break}k=i[B+24>>2]}i[B+28>>2]=n,Z(k)}if(f)break n;k=i[e+44>>2]}r=i[k+36>>2],n=i[k+40>>2];t:{if((r|0)!=(n|0))for(;;){o:{if(f=i[r>>2],!f||(k=Z0(f,92792,95888),!k))break o;if(r=i[r+4>>2],!r){r=0;break t}i[r+4>>2]=i[r+4>>2]+1;break t}if(r=r+8|0,(n|0)==(r|0))break}r=0,k=0}if(i[e+64>>2]=k,f=i[e+68>>2],i[e+68>>2]=r,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(W[i[i[f>>2]+8>>2]](f),y(f)),k=i[e+64>>2]),!k){if(t[B+24|0]=0,t[B+35|0]=0,a(A,2,110,B+24|0),t[B+35|0]>=0)break n;Z(i[B+24>>2]);break n}f=i[e+44>>2],r=i[f+36>>2],n=i[f+40>>2];t:{if((r|0)!=(n|0))for(;;){o:{if(f=i[r>>2],!f||(k=Z0(f,92792,94424),!k))break o;if(r=i[r+4>>2],!r){r=0;break t}i[r+4>>2]=i[r+4>>2]+1;break t}if(r=r+8|0,(n|0)==(r|0))break}r=0,k=0}i[e+72>>2]=k,f=i[e+76>>2],i[e+76>>2]=r;t:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break t;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[e+44>>2],r=i[f+36>>2],n=i[f+40>>2];t:{if((r|0)!=(n|0))for(;;){o:{if(f=i[r>>2],!f||(k=Z0(f,92792,94344),!k))break o;if(r=i[r+4>>2],!r){r=0;break t}i[r+4>>2]=i[r+4>>2]+1;break t}if(r=r+8|0,(n|0)==(r|0))break}r=0,k=0}i[e+80>>2]=k,n=i[e+84>>2],i[e+84>>2]=r,f=e+80|0,n&&(r=i[n+4>>2],i[n+4>>2]=r-1,r||(W[i[i[n>>2]+8>>2]](n),y(n)),k=i[f>>2]);t:{if(!k||(r=i[e+104>>2],!r))break t;if(r=i[r+104>>2],i[B+32>>2]=0,i[B+36>>2]=0,i[B+24>>2]=0,i[B+28>>2]=0,i[B+40>>2]=1065353216,L9(A,e,r,f,B+24|0),r=i[B+32>>2],r)for(;f=i[r>>2],Z(r),r=f,!!f;);if(r=i[B+24>>2],i[B+24>>2]=0,r&&Z(r),i[A>>2])break n;if(t[A+19|0]>=0)break t;Z(i[A+8>>2])}f=i[e+44>>2],r=i[f+36>>2],n=i[f+40>>2];t:{if((r|0)!=(n|0))for(;;){o:{if(f=i[r>>2],!f||(k=Z0(f,92792,94504),!k))break o;if(r=i[r+4>>2],!r){r=0;break t}i[r+4>>2]=i[r+4>>2]+1;break t}if(r=r+8|0,(n|0)==(r|0))break}r=0,k=0}i[e+96>>2]=k,f=i[e+100>>2],i[e+100>>2]=r;t:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break t;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=i[28729],i[A>>2]=i[28728],i[A+4>>2]=r,f=A+8|0,t[114931]>=0){r=i[28731],i[f>>2]=i[28730],i[f+4>>2]=r,i[f+8>>2]=i[28732];break n}T(f,i[28730],i[28731])}if(f=i[B+12>>2],!f)break k;if(r=i[B+16>>2],k=f,(r|0)!=(f|0)){for(;;){n=i[r-4>>2];n:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break n;W[i[i[n>>2]+8>>2]](n),y(n)}if(r=r-8|0,(f|0)==(r|0))break}k=i[B+12>>2]}i[B+16>>2]=f,Z(k)}if(v=B+48|0,i[A>>2])break A;t[A+19|0]<0&&Z(i[A+8>>2]),r=i[e+152>>2]}k:{if(!r)break k;h=v-16|0,v=h,r=i[e+152>>2],k=i[r+36>>2],f=i[r+40>>2];n:{if((k|0)!=(f|0))for(;;){t:{if(r=i[k>>2],!r||(n=Z0(r,92792,111476),!n))break t;if(f=i[k+4>>2],!f){f=0;break n}i[f+4>>2]=i[f+4>>2]+1;break n}if(k=k+8|0,(f|0)==(k|0))break}f=0,n=0}i[e+160>>2]=n,k=i[e+164>>2],i[e+164>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),n=i[e+160>>2]);n:{if(!n){if(e=C(32),i[h+4>>2]=e,i[h+8>>2]=30,i[h+12>>2]=-2147483616,f=u[28445]|u[28446]<<8|(u[28447]<<16|u[28448]<<24),r=u[28441]|u[28442]<<8|(u[28443]<<16|u[28444]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+30|0]=0,f=u[28467]|u[28468]<<8|(u[28469]<<16|u[28470]<<24),r=u[28463]|u[28464]<<8|(u[28465]<<16|u[28466]<<24),t[e+22|0]=r,t[e+23|0]=r>>>8,t[e+24|0]=r>>>16,t[e+25|0]=r>>>24,t[e+26|0]=f,t[e+27|0]=f>>>8,t[e+28|0]=f>>>16,t[e+29|0]=f>>>24,f=u[28461]|u[28462]<<8|(u[28463]<<16|u[28464]<<24),r=u[28457]|u[28458]<<8|(u[28459]<<16|u[28460]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[28453]|u[28454]<<8|(u[28455]<<16|u[28456]<<24),r=u[28449]|u[28450]<<8|(u[28451]<<16|u[28452]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,0,h+4|0),t[h+15|0]>=0)break n;Z(i[h+4>>2]);break n}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,r=A+8|0,t[114931]>=0){e=i[28731],i[r>>2]=i[28730],i[r+4>>2]=e,i[r+8>>2]=i[28732];break n}T(r,i[28730],i[28731])}if(v=h+16|0,i[A>>2])break A;if(t[A+19|0]>=0)break k;Z(i[A+8>>2])}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break A}T(e,i[28730],i[28731])}v=N+176|0;break r}x0(),M()}if(t[Y+43|0]>=0)break e;Z(i[Y+32>>2])}v=Y+48|0;return}s0(),M()}function X9(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0;R=v+-64|0,v=R;i:{e:{if(!r){if(t[R+24|0]=0,t[R+35|0]=0,r=A,A=a(R+44|0,5,2001,R+24|0),c0(r,A,i[e>>2]),t[A+19|0]<0&&Z(i[A+8>>2]),t[R+35|0]>=0)break e;Z(i[R+24>>2]);break e}if(i[r>>2]!=1){if(t[R+24|0]=0,t[R+35|0]=0,r=a(R+44|0,5,2004,R+24|0),t[R+35|0]<0&&Z(i[R+24>>2]),c0(A,r,i[e>>2]),t[r+19|0]>=0)break e;Z(i[r+8>>2]);break e}i[R+32>>2]=0,i[R+36>>2]=0,i[R+24>>2]=0,i[R+28>>2]=0,q=R+44|0,O=R+24|0,E=v-80|0,v=E,o=i[e>>2],k=i[o+48>>2],c=i[k+160>>2],Q=i[k+164>>2],Q&&(i[Q+4>>2]=i[Q+4>>2]+1);r:{f:{if(c){if(n=i[o+196>>2],V=o+200|0,(n|0)!=(V|0))for(;;){k=i[n+20>>2],W[i[i[k>>2]+20>>2]](E+48|0,k),t[E+67|0]<0&&Z(i[E+56>>2]),l=i[i[n+20>>2]+160>>2],k=i[l+128>>2],h=i[l+132>>2],w=i[l+120>>2],s=i[o+48>>2],l=i[s+160>>2],s=i[s+164>>2];A:{if(!s){l=i[l+120>>2];break A}if(_=i[s+4>>2],I=_+1|0,i[s+4>>2]=I,l=i[l+120>>2],i[s+4>>2]=_,I)break A;W[i[i[s>>2]+8>>2]](s),y(s)}A:{if(l)break A;if(l=i[i[i[n+20>>2]+160>>2]+120>>2],s=i[o+48>>2],_=i[s+160>>2],s=i[s+164>>2],!s){i[_+120>>2]=l;break A}if(i[s+4>>2]=i[s+4>>2]+1,i[_+120>>2]=l,_=i[s+4>>2],i[s+4>>2]=_-1,_)break A;W[i[i[s>>2]+8>>2]](s),y(s)}w?(k=O1(L0(k,h,l,0),h0,w,0),_=h0):(k=0,_=0),w=k,k=i[o+212>>2];A:{k:{if(!k){s=-1,N=-1;break k}if(e4(E,k,0,0,0,w,_,0,0),s=L0(k,0,w,_),l=(i[E+8>>2]|i[E+12>>2])!=0,s=l?-1:s,N=l?-1:h0,(k|0)==1)break A}h=v-16|0,v=h,I=i[n+20>>2];k:{if(i[I+240>>2])break k;k=C(120),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=99948,l=k+16|0,i[l+8>>2]=0,i[l+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1701082227,i[k+16>>2]=99988,B=i[I+136>>2],i[h+12>>2]=k,i[h+8>>2]=l,i[k+4>>2]=i[k+4>>2]+1,P0(B+36|0,h+8|0),l=i[h+12>>2];n:{if(!l||(B=i[l+4>>2],i[l+4>>2]=B-1,B))break n;W[i[i[l>>2]+8>>2]](l),y(l)}U=k+52|0,l=C(136),i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=100068,G=l+16|0,i[G+8>>2]=0,i[G+12>>2]=0,i[l+32>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,i[l+44>>2]=0,i[l+48>>2]=0,i[l+16>>2]=92500,i[l+60>>2]=0,i[l+64>>2]=0,i[l+52>>2]=0,i[l+56>>2]=0,i[l+72>>2]=-1,i[l+76>>2]=-1,i[l+80>>2]=-1,i[l+84>>2]=-1,i[l+116>>2]=0,i[l+88>>2]=0,i[l+92>>2]=0,i[l+96>>2]=0,i[l+100>>2]=0,i[l+104>>2]=0,i[l+108>>2]=0,X[l+112>>1]=0,i[l+16>>2]=113384,i[l+128>>2]=0,i[l+120>>2]=0,i[l+124>>2]=0,i[l+32>>2]=1701606260,i[I+240>>2]=G,B=i[I+244>>2],i[I+244>>2]=l;n:{t:{if(!B){i[h+12>>2]=l,i[h+8>>2]=G;break t}if(l=i[B+4>>2],i[B+4>>2]=l-1,l||(W[i[i[B>>2]+8>>2]](B),y(B)),B=i[I+240>>2],l=i[I+244>>2],i[h+12>>2]=l,i[h+8>>2]=B,!l)break n}i[l+4>>2]=i[l+4>>2]+1}P0(U,h+8|0),l=i[h+12>>2];n:{if(!l||(B=i[l+4>>2],i[l+4>>2]=B-1,B))break n;W[i[i[l>>2]+8>>2]](l),y(l)}if(l=i[I+240>>2],i[l+100>>2]=i[l+100>>2]&-2|1,l=i[k+4>>2],i[k+4>>2]=l-1,l)break k;W[i[i[k>>2]+8>>2]](k),y(k)}v=h+16|0}if(k=v-32|0,v=k,l=i[n+20>>2],h=i[l+144>>2],i[h+128>>2]=s,i[h+132>>2]=N,h=i[l+240>>2],h){i[k+24>>2]=1,i[k+16>>2]=0,i[k+20>>2]=0,i[k+8>>2]=w,i[k+12>>2]=_;A:{if(l=i[h+108>>2],_=i[h+112>>2],l>>>0<_>>>0){w=i[k+12>>2],i[l>>2]=i[k+8>>2],i[l+4>>2]=w,w=i[k+28>>2],i[l+16>>2]=i[k+24>>2],i[l+20>>2]=w,w=i[k+20>>2],i[l+8>>2]=i[k+16>>2],i[l+12>>2]=w,i[h+108>>2]=l+24;break A}k:{if(I=i[h+104>>2],l=l-I|0,w=((l|0)/24|0)+1|0,w>>>0<178956971){if(_=(_-I|0)/24|0,B=_<<1,B=_>>>0>=89478485?178956970:w>>>0<B>>>0?B:w,B){if(B>>>0>=178956971)break k;w=C(g(B,24))}else w=0;_=w+l|0,G=i[k+12>>2],i[_>>2]=i[k+8>>2],i[_+4>>2]=G,G=i[k+28>>2],i[_+16>>2]=i[k+24>>2],i[_+20>>2]=G,G=i[k+20>>2],i[_+8>>2]=i[k+16>>2],i[_+12>>2]=G,G=_+g((l|0)/-24|0,24)|0,l&&z(G,I,l),i[h+112>>2]=w+g(B,24),l=_+24|0,i[h+108>>2]=l,i[h+104>>2]=G,I&&Z(I),i[h+108>>2]=l;break A}break f}x0(),M()}}v=k+32|0,w=(N|0)==(x|0)&s>>>0<m>>>0|N>>>0<x>>>0,l=i[n+4>>2];A:{if(l){for(;;)if(k=l,l=i[k>>2],!l)break A}for(;k=i[n+8>>2],l=i[k>>2]!=(n|0),n=k,!!l;);}if(m=w?m:s,x=w?x:N,n=k,(V|0)==(k|0))break}i[c+128>>2]=m,i[c+132>>2]=x}A:{if(!Q||(k=i[Q+4>>2],i[Q+4>>2]=k-1,k))break A;W[i[i[Q>>2]+8>>2]](Q),y(Q)}if(l=i[o+16>>2],Q=o+20|0,(l|0)!=(Q|0))for(;;){if(n=i[l+20>>2],k=i[n+356>>2],s=i[n+360>>2],(k|0)!=(s|0))for(;w=i[o+48>>2],_=i[k>>2],m=i[l+16>>2],n=C(4),i[E+24>>2]=n,h=n+4|0,i[E+32>>2]=h,i[n>>2]=m,i[E+28>>2]=h,o8(w,_,1667527523,E+24|0),n=i[E+24>>2],n&&(i[E+28>>2]=n,Z(n)),k=k+4|0,(s|0)!=(k|0););n=i[l+4>>2];A:{if(n){for(;;)if(k=n,n=i[k>>2],!n)break A}for(;k=i[l+8>>2],n=i[k>>2]!=(l|0),l=k,!!n;);}if(l=k,(Q|0)==(k|0))break}A:{k:{if(k=i[o+172>>2],h=i[o+176>>2],(k|0)!=(h|0))for(;;){i[E+32>>2]=0,i[E+24>>2]=0,i[E+28>>2]=0,s=i[k>>2],m=E+24|0,_=0,l=v-32|0,v=l,i[l+24>>2]=0,i[l+28>>2]=0,i[l+16>>2]=0,i[l+20>>2]=0,h2(l+16|0,0);n:{t:{if(!(o0[s+4>>2]>65535|o0[s+8>>2]>=65536)){_=1;break t}if(w=2,n=i[s+12>>2],I=i[s+16>>2],(n|0)==(I|0))break n;for(;;){if(_=i[n>>2],_=W[i[i[_>>2]+16>>2]](_)|0,_)break t;if(n=n+8|0,(I|0)==(n|0))break}break n}w=4}n=l+16|0,h2(n,_),Y1(n,w,i[s+4>>2],0),Y1(n,w,i[s+8>>2],0),n=i[s+16>>2]-i[s+12>>2]>>3;n:{if(n>>>0>=256){if(t[l+4|0]=0,t[l+15|0]=0,a(q,9,5004,l+4|0),t[l+15|0]>=0)break n;Z(i[l+4>>2]);break n}if(h2(l+16|0,n),n=i[s+12>>2],s=i[s+16>>2],(n|0)!=(s|0))for(;_=i[n>>2],W[i[i[_>>2]+20>>2]](_,l+16|0,w),n=n+8|0,(s|0)!=(n|0););if(_=0,i[l+12>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,n=0,s=i[l+20>>2],w=i[l+16>>2],(s|0)!=(w|0)){if(s=s-w|0,(s|0)<0)break f;n=C(s),s&&z(n,w,s),_=n+s|0}if((m|0)!=(l+4|0)&&$4(m,n,_,_-n|0),n&&Z(n),n=i[28729],i[q>>2]=i[28728],i[q+4>>2]=n,n=q+8|0,t[114931]>=0){s=i[28731],i[n>>2]=i[28730],i[n+4>>2]=s,i[n+8>>2]=i[28732];break n}T(n,i[28730],i[28731])}if(n=i[l+16>>2],n&&(i[l+20>>2]=n,Z(n)),v=l+32|0,i[q>>2])break k;if(w6(i[o+48>>2],i[i[k>>2]>>2],m,0),t[q+19|0]<0&&Z(i[q+8>>2]),n=i[E+24>>2],n&&(i[E+28>>2]=n,Z(n)),k=k+8|0,(h|0)==(k|0))break}if(l=i[o+16>>2],(Q|0)!=(l|0))for(;;){if(n=i[l+20>>2],k=i[n+540>>2],s=i[n+544>>2],(k|0)!=(s|0))for(;w=i[o+48>>2],_=i[k>>2],m=i[l+16>>2],n=C(4),i[E+24>>2]=n,h=n+4|0,i[E+32>>2]=h,i[n>>2]=m,i[E+28>>2]=h,o8(w,_,1952807028,E+24|0),n=i[E+24>>2],n&&(i[E+28>>2]=n,Z(n)),k=k+4|0,(s|0)!=(k|0););n=i[l+4>>2];n:{if(n){for(;;)if(k=n,n=i[k>>2],!n)break n}for(;k=i[l+8>>2],n=i[k>>2]!=(l|0),l=k,!!n;);}if(l=k,(Q|0)==(k|0))break}if(k=i[o+184>>2],B=i[o+188>>2],(k|0)!=(B|0))for(w=i[25168],N=i[25169];;){n=i[k>>2],s=v-16|0,v=s,i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,l=t[n+15|0],_=(l|0)<0,m=_?i[n+4>>2]:n+4|0,l=_?i[n+8>>2]:l,h=m+l|0;n:{if(_=i[s+12>>2],n=i[s+4>>2],l>>>0<=_-n>>>0){if(_=l,l=i[s+8>>2],I=l-n|0,_>>>0>I>>>0){if(_=m+I|0,(n|0)!=(l|0)&&(I&&z(n,m,I),l=i[s+8>>2]),n=l,(h|0)!=(_|0))for(;t[n|0]=u[_|0],n=n+1|0,_=_+1|0,(h|0)!=(_|0););i[s+8>>2]=(n-l|0)+l;break n}l=h-m|0,!l|(h|0)==(m|0)||z(n,m,l),i[s+8>>2]=n+l;break n}if(n&&(i[s+8>>2]=n,Z(n),i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,_=0),(l|0)>=0){n=_<<1,l=_>>>0>=1073741823?2147483647:n>>>0>l>>>0?n:l,n=C(l),i[s+8>>2]=n,i[s+4>>2]=n,i[s+12>>2]=n+l,(h|0)!=(m|0)&&(l=h-m|0,l&&z(n,m,l),n=n+l|0),i[s+8>>2]=n;break n}break f}if(n=i[s+4>>2],_=i[s+8>>2],m=i[s+12>>2],l=E+24|0,t[l+20|0]=0,i[l+8>>2]=m,i[l>>2]=n,i[l+4>>2]=_,v=s+16|0,n=u[E+44|0],n||(w6(i[o+48>>2],i[i[k>>2]>>2],l,1),n=u[E+44|0]),n=n&255,(n|0)!=255&&(i[E+72>>2]=w,i[E+76>>2]=N,W[i[(E+72|0)+(n<<2)>>2]](E+71|0,E+24|0)),k=k+8|0,(B|0)==(k|0))break}if(l=i[o+16>>2],(Q|0)!=(l|0))for(;;){if(k=i[l+20>>2],W[i[i[k>>2]+120>>2]](q,k),i[q>>2])break A;t[q+19|0]<0&&Z(i[q+8>>2]),n=i[l+4>>2];n:{if(n){for(;;)if(k=n,n=i[k>>2],!n)break n}for(;k=i[l+8>>2],n=i[k>>2]!=(l|0),l=k,!!n;);}if(l=k,(Q|0)==(k|0))break}k=i[o+48>>2],l=i[k+128>>2],_=i[k+132>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);n:{if(!l)break n;k=i[o+48>>2],i[E+24>>2]=i[k+120>>2],k=i[k+124>>2],i[E+28>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),n=0,s=v-32|0,v=s,k=i[E+24>>2],i[s+16>>2]=0,i[s+8>>2]=0,i[s+12>>2]=0;t:{o:{l:{if(w=i[k+36>>2],h=i[k+40>>2],(w|0)!=(h|0)){if(k=h-w|0,(k|0)<0)break l;for(n=C(k),i[s+12>>2]=n,i[s+8>>2]=n,i[s+16>>2]=k+n,k=n;i[k>>2]=i[w>>2],m=i[w+4>>2],i[k+4>>2]=m,m&&(i[m+4>>2]=i[m+4>>2]+1),k=k+8|0,w=w+8|0,(h|0)!=(w|0););i[s+12>>2]=k}if(m=i[l+104>>2],Q=i[l+108>>2],(m|0)==(Q|0))break t;for(;;){n=i[m+8>>2],w=i[m+4>>2],i[s+20>>2]=s+8;u:{if((n|0)==(w|0))break u;for(;;){s:{k=p[w+2>>1];h:{if(!k||(l=i[s+8>>2],k>>>0>i[s+12>>2]-l>>3>>>0))break h;if(k=i[(l+(k<<3)|0)-8>>2],W[i[i[k>>2]+44>>2]](k)|0)break s}if(w=w+4|0,(w|0)!=(n|0))continue;break u}break}for(;;){if(l=n-4|0,(l|0)==(w|0))break u;k=p[n-2>>1];s:{if(!k||(h=i[s+8>>2],k>>>0>i[s+12>>2]-h>>3>>>0))break s;if(n=l,k=i[(h+(k<<3)|0)-8>>2],W[i[i[k>>2]+44>>2]](k)|0)continue}break}I=l-w>>2,h=I+1|0,k=0,n=0;s:{if((I|0)<3)break s;for(k=h>>>0>=536870911?536870911:h;;){if(n=Xs(k<<2),n)break s;if(n=k>>>0>1,k=k>>>1|0,!n)break}k=0,n=0}if(i[s+28>>2]=k,i[s+24>>2]=n,k=i[s+28>>2],i[s>>2]=i[s+24>>2],i[s+4>>2]=k,WA(w,l,s+20|0,h,s),!n)break u;Z(n)}if(m=m+16|0,(Q|0)==(m|0))break}break o}s0(),M()}n=i[s+8>>2]}if(n){if(k=n,w=i[s+12>>2],(k|0)!=(w|0)){for(;;){k=i[w-4>>2];t:{if(!k||(l=i[k+4>>2],i[k+4>>2]=l-1,l))break t;W[i[i[k>>2]+8>>2]](k),y(k)}if(w=w-8|0,(w|0)==(n|0))break}k=i[s+8>>2]}i[s+12>>2]=n,Z(k)}if(v=s+32|0,k=i[E+28>>2],!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break n;W[i[i[k>>2]+8>>2]](k),y(k)}n:{if(!_||(k=i[_+4>>2],i[_+4>>2]=k-1,k))break n;W[i[i[_>>2]+8>>2]](_),y(_)}if(n=i[o+48>>2],k=i[n+16>>2],n=i[n+20>>2],(k|0)!=(n|0))for(;vs(i[k>>2]),k=k+8|0,(n|0)!=(k|0););w=0,m=v+-64|0,v=m,i[m+44>>2]=0,i[m+36>>2]=0,i[m+40>>2]=0,Q=E+72|0,Q&&(i[Q>>2]=0),k=o,s=i[k+48>>2],l=i[k+52>>2],l&&(i[l+4>>2]=i[l+4>>2]+1),n=i[s+44>>2],s=i[s+48>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);n:{if(u[n+97|0]|!n||(o=i[n+36>>2],_=i[n+40>>2],(o|0)==(_|0)))break n;for(;;){t:{if(h=i[o>>2],!h||(h=Z0(h,92792,93396),!h))break t;_=i[o+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);o:{if(u[h+97|0]||(o=i[n+36>>2],h=i[n+40>>2],(o|0)==(h|0)))break o;for(;;){l:{if(I=i[o>>2],!I||(I=Z0(I,92792,95888),!I))break l;if(B=i[o+4>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),u[I+97|0]<=2){if(Vl(m,n),h=i[m>>2],!(!h|u[h+97|0]>1)){u:{s:{if(o=i[h+36>>2],N=i[h+40>>2],(o|0)!=(N|0)){if(h=i[o>>2],h&&(I=i[m+28>>2],h=Z0(h,92792,93556),h))break s;if(o=o+8|0,(N|0)!=(o|0))for(;;){if(h=i[o>>2],h&&(I=0,h=Z0(h,92792,93556),h))break s;if(o=o+8|0,(N|0)==(o|0))break}i[m+24>>2]=0,i[m+28>>2]=0}i[m+24>>2]=0,i[m+28>>2]=0;break u}if(i[m+28>>2]=I,i[m+24>>2]=h,o=i[o+4>>2],i[m+28>>2]=o,!o)break u;i[o+4>>2]=i[o+4>>2]+1}if(o=i[m+24>>2],!(!o|(u[o+97|0]&254)!=2)){u:{s:{if(o=i[n+36>>2],N=i[n+40>>2],(o|0)!=(N|0)){if(h=i[o>>2],h&&(I=i[m+60>>2],h=Z0(h,92792,93476),h))break s;if(o=o+8|0,(N|0)!=(o|0))for(;;){if(h=i[o>>2],h&&(I=0,h=Z0(h,92792,93476),h))break s;if(o=o+8|0,(N|0)==(o|0))break}i[m+56>>2]=0,i[m+60>>2]=0}i[m+56>>2]=0,i[m+60>>2]=0;break u}if(i[m+60>>2]=I,i[m+56>>2]=h,o=i[o+4>>2],i[m+60>>2]=o,!o)break u;i[o+4>>2]=i[o+4>>2]+1}if(o=i[m+56>>2],!(!o|u[o+97|0]>1)){o=m+48|0;u:{s:{if(w=i[n+36>>2],n=i[n+40>>2],(w|0)!=(n|0)){if(I=i[w>>2],I&&(h=i[o+4>>2],I=Z0(I,92792,93716),I))break s;if(w=w+8|0,(n|0)!=(w|0))for(;;){if(I=i[w>>2],I&&(h=0,I=Z0(I,92792,93716),I))break s;if(w=w+8|0,(n|0)==(w|0))break}i[o>>2]=0,i[o+4>>2]=0}i[o>>2]=0,i[o+4>>2]=0;break u}if(i[o+4>>2]=h,i[o>>2]=I,n=i[w+4>>2],i[o+4>>2]=n,!n)break u;i[n+4>>2]=i[n+4>>2]+1}w=i[m+48>>2]!=0,g2(o)}g2(m+56|0)}g2(m+24|0)}g2(m)}if(!B||(n=i[B+4>>2],i[B+4>>2]=n-1,n))break o;W[i[i[B>>2]+8>>2]](B),y(B);break o}if(o=o+8|0,(h|0)==(o|0))break}}if(!_||(n=i[_+4>>2],i[_+4>>2]=n-1,n))break n;W[i[i[_>>2]+8>>2]](_),y(_);break n}if(o=o+8|0,(_|0)==(o|0))break}}n:{if(!s||(n=i[s+4>>2],i[s+4>>2]=n-1,n))break n;W[i[i[s>>2]+8>>2]](s),y(s)}n:{if(!l||(n=i[l+4>>2],i[l+4>>2]=n-1,n))break n;W[i[i[l>>2]+8>>2]](l),y(l)}n:{t:{o:{if(!w)break o;n=i[m+40>>2],s=i[m+44>>2];l:{if(n>>>0<s>>>0){i[n>>2]=1835623985,o=n+4|0;break l}if(l=i[m+36>>2],n=n-l|0,h=n>>2,o=h+1|0,o>>>0>=1073741824)break f;if(s=s-l|0,_=s>>1,s=s>>>0>=2147483644?1073741823:o>>>0<_>>>0?_:o,s){if(s>>>0>=1073741824)break t;o=C(s<<2)}else o=0;if(_=o+n|0,i[_>>2]=1835623985,h=_-(h<<2)|0,n&&z(h,l,n),i[m+44>>2]=o+(s<<2),o=_+4|0,i[m+40>>2]=o,i[m+36>>2]=h,!l)break l;Z(l)}if(i[m+40>>2]=o,!Q)break o;i[Q>>2]=1835623985}n=v-16|0,v=n,o=v-32|0,v=o;o:{l:{if(s=k,k=i[k+40>>2],!k||(W[i[i[k>>2]+88>>2]](o+12|0,k),k=i[o+12>>2],t[o+31|0]<0&&Z(i[o+20>>2]),k))break l;if(l=i[s+40>>2],k=i[s+44>>2],!k){k=0;break o}i[k+4>>2]=i[k+4>>2]+1;break o}k=0,l=0}i[n+12>>2]=k,i[n+8>>2]=l,v=o+32|0,_=i[n+8>>2];o:{if(_){if(k=i[n+12>>2],i[n+8>>2]=0,i[n+12>>2]=0,o=C(8),i[m+24>>2]=o,l=o+8|0,i[m+32>>2]=l,i[o+4>>2]=k,i[o>>2]=_,!k){i[m+28>>2]=l;break o}if(i[k+4>>2]=i[k+4>>2]+1,i[m+28>>2]=l,o=i[k+4>>2],i[k+4>>2]=o-1,o)break o;W[i[i[k>>2]+8>>2]](k),y(k);break o}i[m+32>>2]=0,i[m+24>>2]=0,i[m+28>>2]=0}k=i[n+12>>2];o:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break o;W[i[i[k>>2]+8>>2]](k),y(k)}v=n+16|0;o:{l:{u:{k=i[m+24>>2],I=i[m+28>>2],c=(k|0)==(I|0);s:{if(c){l=1;break s}if(!w)break u;for(l=1,o=k;;){if(n=i[o>>2],N=W[i[i[n>>2]+128>>2]](n)|0,N){n=i[m+40>>2],B=i[m+44>>2];h:{if(n>>>0<B>>>0){i[n>>2]=N,_=n+4|0;break h}if(h=i[m+36>>2],n=n-h|0,G=n>>2,_=G+1|0,_>>>0>=1073741824)break f;if(B=B-h|0,x=B>>1,B=B>>>0>=2147483644?1073741823:_>>>0<x>>>0?x:_,B){if(B>>>0>=1073741824)break t;_=C(B<<2)}else _=0;if(x=_+n|0,i[x>>2]=N,N=x-(G<<2)|0,n&&z(N,h,n),i[m+44>>2]=_+(B<<2),_=x+4|0,i[m+40>>2]=_,i[m+36>>2]=N,!h)break h;Z(h)}i[m+40>>2]=_}if(l=u[i[o>>2]+352|0]&l,o=o+8|0,(I|0)==(o|0))break}}if((k|0)!=(I|0)&l&w){n=i[m+40>>2],w=i[m+44>>2];s:{if(n>>>0<w>>>0){i[n>>2]=1835622758,o=n+4|0;break s}if(l=i[m+36>>2],n=n-l|0,h=n>>2,o=h+1|0,o>>>0>=1073741824)break f;if(w=w-l|0,_=w>>1,w=w>>>0>=2147483644?1073741823:o>>>0<_>>>0?_:o,w){if(w>>>0>=1073741824)break t;o=C(w<<2)}else o=0;if(_=o+n|0,i[_>>2]=1835622758,h=_-(h<<2)|0,n&&z(h,l,n),i[m+44>>2]=o+(w<<2),o=_+4|0,i[m+40>>2]=o,i[m+36>>2]=h,!l)break s;Z(l)}i[m+40>>2]=o}if(c)break o;break l}for(o=k;n=i[o>>2],W[i[i[n>>2]+128>>2]](n)|0,o=o+8|0,(I|0)!=(o|0););}if(k=i[k>>2],k=W[i[i[k>>2]+128>>2]](k)|0,!Q|!k)break o;i[Q>>2]=k}o:{if(!i[s+204>>2])break o;k=i[m+44>>2],n=i[m+40>>2];l:{if(k>>>0>n>>>0){i[n>>2]=1836279345,o=n+4|0;break l}if(l=i[m+36>>2],n=n-l|0,_=n>>2,o=_+1|0,o>>>0>=1073741824)break f;if(k=k-l|0,w=k>>1,o=k>>>0>=2147483644?1073741823:o>>>0<w>>>0?w:o,o){if(o>>>0>=1073741824)break t;k=C(o<<2)}else k=0;if(w=k+n|0,i[w>>2]=1836279345,_=w-(_<<2)|0,n&&z(_,l,n),k=k+(o<<2)|0,i[m+44>>2]=k,o=w+4|0,i[m+40>>2]=o,i[m+36>>2]=_,!l)break l;Z(l),k=i[m+44>>2]}i[m+40>>2]=o;l:{if(k>>>0>o>>>0){i[o>>2]=1769172845,o=o+4|0;break l}if(l=i[m+36>>2],n=o-l|0,_=n>>2,o=_+1|0,o>>>0>=1073741824)break f;if(k=k-l|0,w=k>>1,o=k>>>0>=2147483644?1073741823:o>>>0<w>>>0?w:o,o){if(o>>>0>=1073741824)break t;k=C(o<<2)}else k=0;if(w=k+n|0,i[w>>2]=1769172845,_=w-(_<<2)|0,n&&z(_,l,n),i[m+44>>2]=k+(o<<2),o=w+4|0,i[m+40>>2]=o,i[m+36>>2]=_,!l)break l;Z(l)}i[m+40>>2]=o,k=v-48|0,v=k,RA(k+8|0,s,0);l:{u:{s:{h:switch(o=u[k+28|0],o|0){case 0:break u;case 1:break s;default:break h}e2(),M()}if(n=i[k+12>>2],i[m>>2]=i[k+8>>2],i[m+4>>2]=n,n=m+8|0,t[k+27|0]>=0){l=i[k+20>>2],i[n>>2]=i[k+16>>2],i[n+4>>2]=l,i[n+8>>2]=i[k+24>>2];break l}T(n,i[k+16>>2],i[k+20>>2]);break l}l=i[k+8>>2],n=i[k+12>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[m+4>>2]=n,i[m>>2]=l}t[m+20|0]=o,n=u[k+28|0],(n|0)!=255&&(o=i[25181],i[k+40>>2]=i[25180],i[k+44>>2]=o,W[i[(k+40|0)+(n<<2)>>2]](k+39|0,k+8|0)),v=k+48|0;l:{u:{s:{if(!u[m+20|0]){if(o=i[m>>2],n=i[m+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),k=0,!o||(o=Z0(o,113600,113736),!o))break s;if(n&&(i[n+4>>2]=i[n+4>>2]+1),k=n,l=i[o+184>>2],o=i[l+104>>2],(o|0)==i[l+108>>2])l=0;else{w=i[o>>2],o=i[o+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);h:{w:{_:{v:{B:{m:{if(l=i[w+16>>2],(l|0)<=1781689192){if((l|0)==1635135537)break m;if((l|0)!=1635148593)break _;l=1635148659;break h}if((l|0)==1781689193)break B;if((l|0)==1835692135)break v;if((l|0)!=1987470129)break w;l=1987471731;break h}l=1635150195;break h}l=1781688691;break h}l=1785751411;break h}if((l|0)!=1752589105||(l=i[w+36>>2],w=i[w+40>>2],(l|0)==(w|0)))break w;for(;;){_:{if(_=i[l>>2],!_||(_=Z0(_,92792,104128),!_))break _;if(w=i[l+4>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),l=1751479907,h=u[_+103|0],_=i[_+104>>2],(h|0)==1|(_&1073741824)!=0||(l=_&268435456|(h|0)==3?1751479907:1751479928),!w||(_=i[w+4>>2],i[w+4>>2]=_-1,_))break h;W[i[i[w>>2]+8>>2]](w),y(w);break h}if(l=l+8|0,(w|0)==(l|0))break}}l=0}h:{if(!o||(w=i[o+4>>2],i[o+4>>2]=w-1,w))break h;W[i[i[o>>2]+8>>2]](o),y(o)}}if(!l)break s;k=i[m+40>>2],_=i[m+44>>2];h:{if(k>>>0<_>>>0){i[k>>2]=l,k=k+4|0;break h}if(w=i[m+36>>2],k=k-w|0,I=k>>2,o=I+1|0,o>>>0>=1073741824)break f;if(_=_-w|0,h=_>>1,_=_>>>0>=2147483644?1073741823:o>>>0<h>>>0?h:o,_){if(_>>>0>=1073741824)break t;o=C(_<<2)}else o=0;if(h=o+k|0,i[h>>2]=l,I=h-(I<<2)|0,k&&z(I,w,k),i[m+44>>2]=o+(_<<2),k=h+4|0,i[m+40>>2]=k,i[m+36>>2]=I,!w)break h;Z(w)}if(i[m+40>>2]=k,k=n,!Q)break l;break u}e2(),M()}if(i[Q>>2]|!Q)break l;l=1836279345}i[Q>>2]=l}l:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break l;W[i[i[k>>2]+8>>2]](k),y(k)}l:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break l;W[i[i[n>>2]+8>>2]](n),y(n)}if(k=u[m+20|0],(k|0)==255)break o;n=i[25677],i[m+56>>2]=i[25676],i[m+60>>2]=n,W[i[(m+56|0)+(k<<2)>>2]](m+48|0,m)}if(_=i[m+40>>2],u[i[s+48>>2]+172|0]){l=i[m+44>>2];o:{if(l>>>0>_>>>0){i[_>>2]=1970170214,_=_+4|0;break o}if(o=i[m+36>>2],k=_-o|0,_=k>>2,n=_+1|0,n>>>0>=1073741824)break f;if(l=l-o|0,w=l>>1,l=l>>>0>=2147483644?1073741823:n>>>0<w>>>0?w:n,l){if(l>>>0>=1073741824)break t;n=C(l<<2)}else n=0;if(w=n+k|0,i[w>>2]=1970170214,h=w-(_<<2)|0,k&&z(h,o,k),i[m+44>>2]=n+(l<<2),_=w+4|0,i[m+40>>2]=_,i[m+36>>2]=h,!o)break o;Z(o)}i[m+40>>2]=_}if(o=0,i[E+32>>2]=0,i[E+24>>2]=0,i[E+28>>2]=0,k=i[m+36>>2],(_|0)==(k|0))break n;for(l=0;;){if(w=i[k>>2],n=ie(l,w,o-l>>2),n=n||o,o=i[E+28>>2],(n|0)==(o|0)){h=i[E+32>>2];o:{if(h>>>0>n>>>0){i[o>>2]=w,o=o+4|0;break o}if(n=n-l|0,I=n>>2,o=I+1|0,o>>>0>=1073741824)break f;if(h=h-l|0,Q=h>>1,h=h>>>0>=2147483644?1073741823:o>>>0<Q>>>0?Q:o,h){if(h>>>0>=1073741824)break t;o=C(h<<2)}else o=0;Q=o+n|0,i[Q>>2]=w,w=Q-(I<<2)|0,n&&z(w,l,n),i[E+32>>2]=o+(h<<2),o=Q+4|0,i[E+28>>2]=o,i[E+24>>2]=w,l&&Z(l),l=w}i[E+28>>2]=o}if(k=k+4|0,(_|0)==(k|0))break}break n}x0(),M()}if(l=i[m+24>>2],l){if(o=i[m+28>>2],(l|0)!=(o|0)){for(;;){k=i[o-4>>2];n:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break n;W[i[i[k>>2]+8>>2]](k),y(k)}if(o=o-8|0,(l|0)==(o|0))break}l=i[m+24>>2]}Z(l)}if(k=i[m+36>>2],k&&(i[m+40>>2]=k,Z(k)),v=m- -64|0,o=i[E+28>>2],k=i[s+48>>2],n=i[k+28>>2],A0=i[k+32>>2],A0&&(i[A0+4>>2]=i[A0+4>>2]+1),c=i[E+24>>2],i[n+100>>2]||(i[n+100>>2]=i[E+72>>2]),i[n+104>>2]=0,(o|0)!=(c|0))for(k=c;Q3(n,i[k>>2]),k=k+4|0,(o|0)!=(k|0););V=v-80|0,v=V,l=1,U=i[s+48>>2];n:{if(u[U+60|0]==1){i[V+8>>2]=0,i[V>>2]=0,i[V+4>>2]=0;t:{if(!en(U,V))break t;n=0,s=0,h=0,Q=0,w=0,N=0,x=0,_=0,m=0,G=v-160|0,v=G,i[G+152>>2]=0,i[G+144>>2]=0,i[G+148>>2]=0;o:{if(!en(U,G+144|0)){i[V+72>>2]=0,i[V+76>>2]=0;break o}k=C(464),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=98668,o=k+16|0,i[o+8>>2]=0,i[o+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+16>>2]=114076,t[k+114|0]=0,t[k+115|0]=0,t[k+116|0]=0,t[k+117|0]=0,t[k+118|0]=0,t[k+119|0]=0,t[k+120|0]=0,t[k+121|0]=0,i[k+128>>2]=0,i[k+132>>2]=0,t[k+122|0]=0,t[k+123|0]=0,t[k+124|0]=0,t[k+125|0]=0,t[k+137|0]=0,t[k+138|0]=0,t[k+139|0]=0,t[k+140|0]=0,t[k+141|0]=0,t[k+142|0]=0,t[k+143|0]=0,t[k+144|0]=0,t[k+136|0]=8,t[k+145|0]=0,i[k+148>>2]=0,i[k+152>>2]=0,t[k+156|0]=0,i[k+160>>2]=0,i[k+164>>2]=0,X[k+166>>1]=0,X[k+168>>1]=0,X[k+170>>1]=0,X[k+172>>1]=0,i[k+384>>2]=0,i[k+376>>2]=0,i[k+380>>2]=0,i[k+368>>2]=0,i[k+360>>2]=0,i[k+364>>2]=0,i[k+352>>2]=0,i[k+344>>2]=0,i[k+348>>2]=0,t[k+176|0]=0,X[k+174>>1]=8,t[k+186|0]=0,X[k+178>>1]=0,X[k+180>>1]=0,X[k+182>>1]=0,X[k+184>>1]=0,i[k+188>>2]=0,i[k+192>>2]=0,i[k+196>>2]=0,i[k+200>>2]=0,i[k+204>>2]=0,i[k+208>>2]=0,i[k+212>>2]=0,i[k+216>>2]=0,X[k+220>>1]=0,l0(k+224|0,0,116),l0(k+392|0,0,72),i[k+32>>2]=1835626089,i[V+76>>2]=k,i[V+72>>2]=o,t[k+113|0]=0,o=i[U+104>>2],o&&(j=i[o+104>>2]),d=X8(U,j),t[k+114|0]=0,i[G+140>>2]=0,i[G+132>>2]=0,i[G+136>>2]=0,L1(G+112|0,U,j,G+132|0),t[G+131|0]<0&&Z(i[G+120>>2]),B=i[G+132>>2],Y=i[G+136>>2];l:{if((B|0)!=(Y|0)){for(;;){o=i[B>>2];u:{if(!o)break u;s:{h:{if(k=Z0(o,92792,92812),k){o=i[B+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+2);w:{if(!N||(h=i[N+4>>2],i[N+4>>2]=h-1,h))break w;W[i[i[N>>2]+8>>2]](N),y(N)}if(o)break h;N=0,h=k;break u}w:{if(k=Z0(o,92792,95064),k){o=i[B+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+2);_:{if(!x||(s=i[x+4>>2],i[x+4>>2]=s-1,s))break _;W[i[i[x>>2]+8>>2]](x),y(x)}if(o)break w;x=0,s=k;break u}_:{v:{B:{m:{if(k=Z0(o,92792,101920),k){if(o=i[B+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),I=i[k+100>>2],(W[i[i[I>>2]+8>>2]](I)|0)==1852009592){if(o&&(i[o+4>>2]=i[o+4>>2]+1),_)break m;_=o;break _}if(o&&(i[o+4>>2]=i[o+4>>2]+1),!m){Q=k,m=o;break v}if(t0=i[m+4>>2],i[m+4>>2]=t0-1,I=m,Q=k,m=o,k=n,!t0)break B;break _}g:{Z:{if(Z0(o,92792,104760)){if(o=i[B+4>>2],!o)break g;if(i[o+4>>2]==-1)break Z;break g}if(!Z0(o,92792,104128))break u;if(o=i[B+4>>2],!o|i[o+4>>2]!=-1)break g}W[i[i[o>>2]+8>>2]](o),y(o)}if(S=i[B>>2],k=i[B+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),!w){w=k;break u}if(I=i[w+4>>2],i[w+4>>2]=I-1,o=w,w=k,!I)break s;break u}if(t0=i[_+4>>2],i[_+4>>2]=t0-1,I=_,n=k,_=o,t0)break _}W[i[i[I>>2]+8>>2]](I),y(I)}k=n}if(!o){n=k;break u}if(I=i[o+4>>2],i[o+4>>2]=I-1,n=k,!I)break s;break u}if(I=i[o+4>>2],i[o+4>>2]=I-1,x=o,s=k,!I)break s;break u}if(I=i[o+4>>2],i[o+4>>2]=I-1,N=o,h=k,I)break u}W[i[i[o>>2]+8>>2]](o),y(o)}if(B=B+8|0,(Y|0)==(B|0))break}if(o=Jt(G+132|0),h&&(k=i[V+72>>2],i[k+112>>2]=i[h+104>>2],i[k+116>>2]=i[h+108>>2]),!s){B=i[V+72>>2];break l}if(B=i[V+72>>2],k=i[s+104>>2],(i[s+108>>2]-k|0)<=0)break l;t[B+120|0]=u[k|0];break l}o=Jt(G+132|0),B=i[V+72>>2]}t[B+99|0]=0,t[B+104|0]=(Q|0)!=0;l:{if(!Q||(k=i[Q+100>>2],!k)||(s=Z0(k,100680,101800),!s))break l;if(k=i[Q+104>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),Y=0,i[G+108>>2]=0,i[G+100>>2]=0,i[G+104>>2]=0,I=0,t0=i[s+12>>2],h=i[s+8>>2],(t0|0)!=(h|0)){if(s=t0-h|0,(s|0)<0)break f;I=C(s),s&&z(I,h,s),Y=s+I|0}if(s=i[B+276>>2],s&&(i[B+280>>2]=s,Z(s)),i[B+284>>2]=Y,i[B+280>>2]=Y,i[B+276>>2]=I,i[G+108>>2]=0,i[G+100>>2]=0,i[G+104>>2]=0,!k||(s=i[k+4>>2],i[k+4>>2]=s-1,s))break l;W[i[i[k>>2]+8>>2]](k),y(k)}l:{if(!n||(k=i[n+100>>2],!k)||(k=Z0(k,100680,101840),!k)||(h=i[n+104>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),s=i[k+4>>2],k=i[k+8>>2],I=i[V+72>>2],X[I+124>>1]=s,X[I+128>>1]=k,X[I+126>>1]=(k&65535)<<16|s>>>16,t[I+100|0]=k>>>16&1,!h)||(k=i[h+4>>2],i[h+4>>2]=k-1,k))break l;W[i[i[h>>2]+8>>2]](h),y(h)}l:{u:{s:{h:{if((d|0)!=1752589105){if(!S|(d|0)!=1635135537||(k=Z0(S,92792,104760),!k))break u;w&&(i[w+4>>2]=i[w+4>>2]+1),h=0;w:{_:switch(u[k+104|0]){case 1:if(h=1,k=u[k+105|0],(k|0)==1)break w;h=k?0:2;break w;case 0:break _;default:break w}if(u[k+105|0])break w;h=u[k+103|0]?0:3}if(!w)break s;k=i[w+4>>2],i[w+4>>2]=k-1;break h}if(!S||(s=Z0(S,92792,104128),!s))break u;if(!w){h=u[s+121|0];break s}I=i[w+4>>2],k=I+1|0,i[w+4>>2]=k,h=u[s+121|0],i[w+4>>2]=I}if(k)break s;W[i[i[w>>2]+8>>2]](w),y(w)}B=i[V+72>>2],t[B+108|0]=h,Y=Q?2:1,k=h&255?6:2;break l}B=i[V+72>>2],t[B+108|0]=0,Y=Q?2:1,k=2}Q=Q?2:13;l:{if(n){if(B=1,s=i[n+100>>2],!s||(I=Z0(s,100680,101840),!I)||(h=i[n+104>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),n=i[I+8>>2],s=i[I+4>>2],(s&65535)!=(Y|0)?s=1:s=(Q&65535)!=(((n&65535)<<16|s>>>16)&65535),B=s|(k&65535)!=(n&65535),!h)||(k=i[h+4>>2],i[h+4>>2]=k-1,k))break l;W[i[i[h>>2]+8>>2]](h),y(h);break l}X[B+128>>1]=k,X[B+126>>1]=Q,X[B+124>>1]=Y,B=0}if(k=i[V+72>>2],t[k+109|0]=o,t[k+102|0]=B,wo(G+88|0,S),n=i[V+72>>2],B=0,i[G+84>>2]=0,i[G+76>>2]=0,i[G+80>>2]=0,k=0,o=i[G+92>>2],s=i[G+88>>2],(o|0)!=(s|0)){if(o=o-s|0,(o|0)<0)break f;k=C(o),o&&z(k,s,o),B=k+o|0}o=i[n+264>>2],o&&(i[n+268>>2]=o,Z(o)),i[n+272>>2]=B,i[n+268>>2]=B,i[n+264>>2]=k,i[G+84>>2]=0,i[G+76>>2]=0,i[G+80>>2]=0,Me(G- -64|0,U),h=i[U+80>>2],I=i[U+84>>2],I&&(i[I+4>>2]=i[I+4>>2]+1);l:{u:{s:{h:{w:{if(B=i[G+64>>2],S=i[G+68>>2],!(!h|(B|0)==(S|0))){for(n=0,s=0,Q=0;;){k=i[B>>2];_:{if((k|0)==(j|0))break _;d4(G+52|0,h,k,1635088492),o=i[G+52>>2];v:{if(!((o|0)==i[G+56>>2]|i[o>>2]!=(j|0))){n=k;break v}if(d4(G+40|0,h,k,1667527523),o=i[G+40>>2],(o|0)!=i[G+44>>2]){B:{if(i[o>>2]!=(j|0))break B;if(o=X8(U,k),(o|0)==1165519206){s=k;break B}if((o|0)!=1835625829)break B;j1(G+32|0,U,k),o=i[G+32>>2];m:{if(!o||(d=t[o+139|0],Y=(d|0)<0,((Y?i[o+132>>2]:d)|0)!=19))break m;Q=N2(Y?i[o+128>>2]:o+128|0,10670,19)?Q:k}if(k=i[G+36>>2],!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break B;W[i[i[k>>2]+8>>2]](k),y(k)}o=i[G+40>>2]}if(o&&(i[G+44>>2]=o,Z(o)),o=i[G+52>>2],!o)break _}i[G+56>>2]=o,Z(o)}if(B=B+4|0,(S|0)==(B|0))break}break w}t[n+105|0]=0,t[n+106|0]=0,t[n+101|0]=0;break h}if(Y=i[V+72>>2],t[Y+101|0]=(n|0)!=0,n){t[Y+123|0]=0,i[G+60>>2]=0,i[G+52>>2]=0,i[G+56>>2]=0,L1(G+12|0,U,n,G+52|0),t[G+31|0]<0&&Z(i[G+20>>2]),B=i[G+52>>2],o=i[G+56>>2];w:{if((B|0)==(o|0))break w;for(;;){_:{if(k=i[B>>2],!k)break _;v:{B:{if(Z0(k,92792,104760)){if(o=i[B+4>>2],!o)break v;if(i[o+4>>2]==-1)break B;break v}if(!Z0(k,92792,104128))break _;if(o=i[B+4>>2],!o|i[o+4>>2]!=-1)break v}W[i[i[o>>2]+8>>2]](o),y(o)}wo(G+40|0,i[B>>2]),Y=i[V+72>>2],o=0,i[G+8>>2]=0,i[G>>2]=0,i[G+4>>2]=0,k=0;v:{if(B=i[G+40>>2],h=i[G+44>>2],(B|0)!=(h|0)){if(o=h-B|0,(o|0)<0)break v;k=C(o),o&&z(k,B,o),o=k+o|0}if(h=i[Y+240>>2],h&&(i[Y+244>>2]=h,Z(h),B=i[G+40>>2]),i[Y+248>>2]=o,i[Y+244>>2]=o,i[Y+240>>2]=k,i[G+8>>2]=0,i[G>>2]=0,i[G+4>>2]=0,!B)break w;i[G+44>>2]=B,Z(B);break w}break f}if(B=B+8|0,(o|0)==(B|0))break}}k=i[U+64>>2],d=i[U+68>>2],d&&(i[d+4>>2]=i[d+4>>2]+1);w:{if(!k||(B=i[k+104>>2],k=i[k+108>>2],(B|0)==(k|0)))break w;for(;;){if(i[B>>2]==(n|0)){if(i[G+48>>2]=0,i[G+40>>2]=0,i[G+44>>2]=0,k=0,S=0,h=0,o=i[B+16>>2],n=i[B+20>>2],(o|0)!=(n|0)){for(;k=i[o+24>>2],h=i[o+28>>2],V4(G+40|0,i[G+44>>2],k,h,h-k|0),o=o+40|0,(n|0)!=(o|0););S=i[G+44>>2],h=i[G+40>>2],k=i[G+48>>2]}if(i[G+48>>2]=0,i[G+40>>2]=0,i[G+44>>2]=0,n=i[Y+400>>2],!n){i[Y+408>>2]=k,i[Y+404>>2]=S,i[Y+400>>2]=h;break w}if(i[Y+404>>2]=n,Z(n),n=i[G+40>>2],i[Y+408>>2]=k,i[Y+404>>2]=S,i[Y+400>>2]=h,!n)break w;i[G+44>>2]=n,Z(n);break w}if(B=B+32|0,(k|0)==(B|0))break}}w:{if(!d||(k=i[d+4>>2],i[d+4>>2]=k-1,k))break w;W[i[i[d>>2]+8>>2]](d),y(d)}if(k=i[G+52>>2],k){if(o=k,B=i[G+56>>2],(k|0)!=(B|0)){for(;;){n=i[B-4>>2];w:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break w;W[i[i[n>>2]+8>>2]](n),y(n)}if(B=B-8|0,(k|0)==(B|0))break}o=i[G+52>>2]}i[G+56>>2]=k,Z(o)}Y=i[V+72>>2]}t[Y+106|0]=(Q|0)!=0,t[Y+105|0]=(s|0)!=0;w:{if(s){j1(G+52|0,U,s),k=i[G+52>>2],B=0;_:{if(!k||(o=t[k+151|0],n=(o|0)<0,B=0,((n?i[k+144>>2]:o)|0)!=7))break _;B=!N2(n?i[k+140>>2]:k+140|0,64944,7)}k=i[G+56>>2];_:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break _;W[i[i[k>>2]+8>>2]](k),y(k)}if(Q){o=s;break w}n=i[V+72>>2],t[n+107|0]=B,S=0,Q=0,o=s;break s}if(B=0,o=0,!Q)break h}j1(G+52|0,U,Q),k=i[G+52>>2],k&&(h=t[k+151|0],n=(h|0)<0,((n?i[k+144>>2]:h)|0)==7?k=N2(n?i[k+140>>2]:k+140|0,64944,7):k=1,B=!k|B),k=i[G+56>>2];w:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break w;W[i[i[k>>2]+8>>2]](k),y(k)}if(n=i[V+72>>2],t[n+107|0]=B,S=1,s)break s;break u}t[i[V+72>>2]+107|0]=0;break l}k=i[U+64>>2],Y=i[U+68>>2],Y&&(i[Y+4>>2]=i[Y+4>>2]+1);s:{if(!k||(B=i[k+104>>2],k=i[k+108>>2],(B|0)==(k|0)))break s;for(;;){if(i[B>>2]==(o|0)){if(i[G+60>>2]=0,i[G+52>>2]=0,i[G+56>>2]=0,k=0,s=0,h=0,o=i[B+16>>2],B=i[B+20>>2],(o|0)!=(B|0)){for(;k=i[o+24>>2],s=i[o+28>>2],V4(G+52|0,i[G+56>>2],k,s,s-k|0),o=o+40|0,(B|0)!=(o|0););s=i[G+56>>2],h=i[G+52>>2],k=i[G+60>>2]}if(i[G+60>>2]=0,i[G+52>>2]=0,i[G+56>>2]=0,o=i[n+424>>2],!o){i[n+432>>2]=k,i[n+428>>2]=s,i[n+424>>2]=h;break s}if(i[n+428>>2]=o,Z(o),o=i[G+52>>2],i[n+432>>2]=k,i[n+428>>2]=s,i[n+424>>2]=h,!o)break s;i[G+56>>2]=o,Z(o);break s}if(B=B+32|0,(k|0)==(B|0))break}}s:{if(!Y||(k=i[Y+4>>2],i[Y+4>>2]=k-1,k))break s;W[i[i[Y>>2]+8>>2]](Y),y(Y)}if(!S)break l}k=i[U+64>>2],s=i[U+68>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);u:{if(!k||(B=i[k+104>>2],k=i[k+108>>2],(B|0)==(k|0)))break u;for(;;){if(i[B>>2]==(Q|0)){if(i[G+60>>2]=0,i[G+52>>2]=0,i[G+56>>2]=0,k=0,n=0,Q=0,o=i[B+16>>2],h=i[B+20>>2],(o|0)!=(h|0)){for(;k=i[o+24>>2],n=i[o+28>>2],V4(G+52|0,i[G+56>>2],k,n,n-k|0),o=o+40|0,(h|0)!=(o|0););n=i[G+56>>2],Q=i[G+52>>2],k=i[G+60>>2]}if(o=i[V+72>>2],i[G+60>>2]=0,i[G+52>>2]=0,i[G+56>>2]=0,h=i[o+436>>2],!h){i[o+444>>2]=k,i[o+440>>2]=n,i[o+436>>2]=Q;break u}if(i[o+440>>2]=h,Z(h),h=i[G+52>>2],i[o+444>>2]=k,i[o+440>>2]=n,i[o+436>>2]=Q,!h)break u;i[G+56>>2]=h,Z(h);break u}if(B=B+32|0,(k|0)==(B|0))break}}if(!s||(k=i[s+4>>2],i[s+4>>2]=k-1,k))break l;W[i[i[s>>2]+8>>2]](s),y(s)}k=i[U+64>>2],s=i[U+68>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);l:{if(!k||(B=i[k+104>>2],k=i[k+108>>2],(B|0)==(k|0)))break l;u:{s:{for(;;){h:{if(i[B>>2]==(j|0)){if(j=0,i[G+60>>2]=0,i[G+52>>2]=0,i[G+56>>2]=0,o=i[B+16>>2],S=i[B+20>>2],(o|0)==(S|0)){Y=0,k=0;break u}for(;;){k=i[o+28>>2],B=i[o+24>>2],h=k-B|0;w:{if((h|0)<=0)break w;if(Y=i[G+60>>2],(h|0)<=(Y-j|0)){!h|(k|0)==(B|0)||z(j,B,h),j=h+j|0,i[G+56>>2]=j;break w}if(Q=i[G+52>>2],k=j-Q|0,n=k+h|0,(n|0)<0)break h;if(Y=Y-Q|0,j=Y<<1,Y=Y>>>0>=1073741823?2147483647:n>>>0<j>>>0?j:n,Y?n=C(Y):n=0,j=n+k|0,h&&z(j,B,h),k&&z(n,Q,k),i[G+60>>2]=n+Y,j=h+j|0,i[G+56>>2]=j,i[G+52>>2]=n,!Q)break w;Z(Q)}if(o=o+40|0,(S|0)==(o|0))break}break s}if(B=B+32|0,(k|0)!=(B|0))continue;break l}break}break f}Y=i[G+52>>2],k=i[G+60>>2]}n=i[V+72>>2],o=i[n+388>>2],o&&(i[n+392>>2]=o,Z(o)),i[n+396>>2]=k,i[n+392>>2]=j,i[n+388>>2]=Y}l:{if(!s||(k=i[s+4>>2],i[s+4>>2]=k-1,k))break l;W[i[i[s>>2]+8>>2]](s),y(s)}t[i[V+72>>2]+103|0]=0;l:{if(!I||(k=i[I+4>>2],i[I+4>>2]=k-1,k))break l;W[i[i[I>>2]+8>>2]](I),y(I)}k=i[G+64>>2],k&&(i[G+68>>2]=k,Z(k)),k=i[G+88>>2],k&&(i[G+92>>2]=k,Z(k));l:{if(!w||(k=i[w+4>>2],i[w+4>>2]=k-1,k))break l;W[i[i[w>>2]+8>>2]](w),y(w)}l:{if(!m||(k=i[m+4>>2],i[m+4>>2]=k-1,k))break l;W[i[i[m>>2]+8>>2]](m),y(m)}l:{if(!_||(k=i[_+4>>2],i[_+4>>2]=k-1,k))break l;W[i[i[_>>2]+8>>2]](_),y(_)}l:{if(!x||(k=i[x+4>>2],i[x+4>>2]=k-1,k))break l;W[i[i[x>>2]+8>>2]](x),y(x)}l:{if(!N||(k=i[N+4>>2],i[N+4>>2]=k-1,k))break l;W[i[i[N>>2]+8>>2]](N),y(N)}if(k=i[G+132>>2],!k)break o;if(o=k,B=i[G+136>>2],(k|0)!=(B|0)){for(;;){n=i[B-4>>2];l:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break l;W[i[i[n>>2]+8>>2]](n),y(n)}if(B=B-8|0,(k|0)==(B|0))break}o=i[G+132>>2]}i[G+136>>2]=k,Z(o)}t[G+155|0]<0&&Z(i[G+144>>2]),v=G+160|0,w=i[V+72>>2];o:{if(w){s=i[U+28>>2],n=i[U+32>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),k=i[U+104>>2],k&&(_0=i[k+104>>2]),l=i[U+140>>2];l:{if(!l)break l;for(k=U+140|0,o=k;_=o0[l+16>>2]<_0>>>0,o=_?o:l,l=i[(_?4:0)+l>>2],!!l;);if((k|0)==(o|0)|o0[o+16>>2]>_0>>>0)break l;k=i[o+20>>2],o=i[o+24>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),k=k?i[k+112>>2]:0;u:{if(!o||(l=i[o+4>>2],i[o+4>>2]=l-1,l))break u;W[i[i[o>>2]+8>>2]](o),y(o)}if(g0=1635150182,(k|0)==1635135537)break l;g0=(k|0)==1752589105?1751476579:0}i[s+104>>2]=g0,i[s+100>>2]=1835623987,i[s+112>>2]=i[s+108>>2],W[i[i[s>>2]+20>>2]](V+48|0,s,O),t[V+67|0]<0&&Z(i[V+56>>2]),k=i[V+72>>2],W[i[i[k>>2]+20>>2]](V+28|0,k,O),t[V+47|0]<0&&Z(i[V+36>>2]);l:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break l;W[i[i[n>>2]+8>>2]](n),y(n)}if(l=0,o=i[V+76>>2],!o)break t;if(k=i[o+4>>2],i[o+4>>2]=k-1,!k)break o;break t}if(o=i[V+76>>2],!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break t}l=!w,W[i[i[o>>2]+8>>2]](o),y(o)}if(t[V+11|0]<0&&Z(i[V>>2]),!l)break n}if(l=i[U+16>>2],n=i[U+20>>2],(l|0)!=(n|0))for(;;){k=i[l>>2];t:{if(!k||(W[i[i[k>>2]+20>>2]](V,k,O),t[V+19|0]>=0))break t;Z(i[V+8>>2])}if(l=l+8|0,(n|0)==(l|0))break}k=i[U+64>>2];t:{if(!k)break t;if(l=0,o=v-176|0,v=o,s=i[k+104>>2],w=i[k+108>>2],(s|0)==(w|0))n=8;else{for(;;){o:{if(u[s+4|0]||(n=i[s+16>>2],_=i[s+20>>2],(n|0)==(_|0)))break o;for(;l=i[n+16>>2]+l|0,n=n+40|0,(_|0)!=(n|0););}if(s=s+32|0,(w|0)==(s|0))break}n=l+8|0}p0(O,n),p0(O,1835295092),u[k+132|0]&&ss(i[k+136>>2],0,0,0);o:{l:{u:{s:{h:{w:{if(l=i[k+104>>2],m=i[k+108>>2],(l|0)!=(m|0))for(;;){_:{if(u[l+4|0]||(i[l+8>>2]=i[O+12>>2],i[l+12>>2]=0,n=i[l+16>>2],h=i[l+20>>2],(n|0)==(h|0)))break _;for(;;){s=i[O+12>>2],w=i[l+8>>2],_=s-w|0,s=0-(i[l+12>>2]+(s>>>0<w>>>0)|0)|0,i[n+8>>2]=_,i[n+12>>2]=s;v:{if(u[k+132|0]==1){w=i[n+16>>2],_=0,i[o+172>>2]=0,i[o+164>>2]=0,i[o+168>>2]=0;B:{if(!w){s=0;break B}if((w|0)<0)break w;s=C(w),i[o+164>>2]=s,_=s+w|0,i[o+172>>2]=_,w&&l0(s,0,w),i[o+168>>2]=_,_=i[n+16>>2]}if(Q=i[k+136>>2],w=v-16|0,v=w,i[w+12>>2]=_,i[w+8>>2]=s,s=g9(Q|0,w+8|0,1,w+4|0)|0,s?(i[33136]=s,s=-1):s=0,v=w+16|0,s=s?-1:i[w+4>>2],(s|0)<0){i[o+108>>2]=0,i[o+80>>2]=78164,i[o+24>>2]=78144,k=i[19545],i[o+16>>2]=k,n=i[k-12>>2],k=o+16|0,i[n+k>>2]=i[19546],i[o+20>>2]=0,n=k+i[i[o+16>>2]-12>>2]|0,l=o+28|0,J0(n,l),t[n+80|0]=0,i[n+72>>2]=0,n=i[19547],i[o+24>>2]=n,s=i[n-12>>2],n=o+24|0,i[s+n>>2]=i[19548],s=i[19544],i[o+16>>2]=s,i[k+i[s-12>>2]>>2]=i[19549],i[o+80>>2]=78164,i[o+16>>2]=78124,i[o+24>>2]=78144,s=R0(l),i[s>>2]=77200,i[o+68>>2]=0,i[o+72>>2]=0,i[o+60>>2]=0,i[o+64>>2]=0,i[o+76>>2]=24,D0(F(n,31126,33),i[33136]),k=i[o+76>>2];B:{if(k&16){l=o+48|0,n=i[o+72>>2],k=i[o+52>>2],n>>>0<k>>>0?i[o+72>>2]=k:k=n;break B}if(!(k&8)){n=0,t[o+15|0]=0,l=o+4|0;break u}l=o+36|0,k=i[o+44>>2]}if(n=k,k=i[l>>2],n=n-k|0,n>>>0>=2147483640)break h;if(n>>>0>=11){w=n|7,l=C(w+1|0),i[o+12>>2]=w-2147483647,i[o+4>>2]=l,i[o+8>>2]=n;break s}if(t[o+15|0]=n,l=o+4|0,n)break s;n=0;break u}if(i[n+16>>2]!=(s|0)|i[n+20>>2]){if(k=C(40),i[o+16>>2]=k,i[o+20>>2]=37,i[o+24>>2]=-2147483608,n=u[1636]|u[1637]<<8|(u[1638]<<16|u[1639]<<24),l=u[1632]|u[1633]<<8|(u[1634]<<16|u[1635]<<24),t[k|0]=l,t[k+1|0]=l>>>8,t[k+2|0]=l>>>16,t[k+3|0]=l>>>24,t[k+4|0]=n,t[k+5|0]=n>>>8,t[k+6|0]=n>>>16,t[k+7|0]=n>>>24,t[k+37|0]=0,n=u[1665]|u[1666]<<8|(u[1667]<<16|u[1668]<<24),l=u[1661]|u[1662]<<8|(u[1663]<<16|u[1664]<<24),t[k+29|0]=l,t[k+30|0]=l>>>8,t[k+31|0]=l>>>16,t[k+32|0]=l>>>24,t[k+33|0]=n,t[k+34|0]=n>>>8,t[k+35|0]=n>>>16,t[k+36|0]=n>>>24,n=u[1660]|u[1661]<<8|(u[1662]<<16|u[1663]<<24),l=u[1656]|u[1657]<<8|(u[1658]<<16|u[1659]<<24),t[k+24|0]=l,t[k+25|0]=l>>>8,t[k+26|0]=l>>>16,t[k+27|0]=l>>>24,t[k+28|0]=n,t[k+29|0]=n>>>8,t[k+30|0]=n>>>16,t[k+31|0]=n>>>24,n=u[1652]|u[1653]<<8|(u[1654]<<16|u[1655]<<24),l=u[1648]|u[1649]<<8|(u[1650]<<16|u[1651]<<24),t[k+16|0]=l,t[k+17|0]=l>>>8,t[k+18|0]=l>>>16,t[k+19|0]=l>>>24,t[k+20|0]=n,t[k+21|0]=n>>>8,t[k+22|0]=n>>>16,t[k+23|0]=n>>>24,n=u[1644]|u[1645]<<8|(u[1646]<<16|u[1647]<<24),l=u[1640]|u[1641]<<8|(u[1642]<<16|u[1643]<<24),t[k+8|0]=l,t[k+9|0]=l>>>8,t[k+10|0]=l>>>16,t[k+11|0]=l>>>24,t[k+12|0]=n,t[k+13|0]=n>>>8,t[k+14|0]=n>>>16,t[k+15|0]=n>>>24,a(V,9,0,o+16|0),t[o+27|0]>=0)break l;Z(i[o+16>>2]);break l}if(F4(O,o+164|0),s=i[o+164>>2],!s)break v;i[o+168>>2]=s,Z(s);break v}F4(O,n+24|0)}if(n=n+40|0,(h|0)==(n|0))break}}if(l=l+32|0,(m|0)==(l|0))break}if(ro(k,O),k=i[28729],i[V>>2]=i[28728],i[V+4>>2]=k,k=V+8|0,t[114931]>=0){n=i[28731],i[k>>2]=i[28730],i[k+4>>2]=n,i[k+8>>2]=i[28732];break o}T(k,i[28730],i[28731]);break o}s0(),M()}I0(),M()}if(!n)break u;z(l,k,n)}t[n+l|0]=0,a(V,9,0,o+4|0),t[o+15|0]<0&&Z(i[o+4>>2]),k=i[19543],i[o+16>>2]=k,i[i[k-12>>2]+(o+16|0)>>2]=i[19551],i[o+24>>2]=i[19552],i[s>>2]=77200,t[o+71|0]<0&&Z(i[o+60>>2]),y0(s),Y0(o+80|0)}if(k=i[o+164>>2],!k)break o;i[o+168>>2]=k,Z(k)}if(v=o+176|0,t[V+19|0]>=0)break t;Z(i[V+8>>2])}if(n=i[U+148>>2],!n)break n;k=v-32|0,v=k,n=W[i[i[n>>2]+12>>2]](n)|0;t:{if(n>>>0<=4294967287){p0(O,n+8|0),p0(O,1835295092);break t}p0(O,1),p0(O,1835295092),h4(O,n+16|0,0)}if(n=i[O+12>>2],o=i[U+148>>2],W[i[i[o>>2]+16>>2]](k+12|0,o,O),t[k+31|0]<0&&Z(i[k+20>>2]),t[V+20|0]=0,i[V>>2]=n,v=k+32|0,k=u[V+20|0],(k|0)==255)break n;t:{if(k||(l=i[U+16>>2],n=i[U+20>>2],(l|0)==(n|0)))break t;for(;os(i[l>>2],O,i[V>>2]),l=l+8|0,(n|0)!=(l|0););}n=i[25321],i[V+72>>2]=i[25320],i[V+76>>2]=n,W[i[(V+72|0)+(k<<2)>>2]](V+71|0,V)}v=V+80|0,i[q>>2]=0,i[q+4>>2]=0,i[q+16>>2]=0,i[q+8>>2]=0,i[q+12>>2]=0;n:{if(!A0||(k=i[A0+4>>2],i[A0+4>>2]=k-1,k))break n;W[i[i[A0>>2]+8>>2]](A0),y(A0)}if(!c)break A;Z(c);break A}if(k=i[E+24>>2],!k)break A;i[E+28>>2]=k,Z(k)}v=E+80|0;break r}s0(),M()}r:{if(i[R+44>>2]){c0(A,q,i[e>>2]);break r}i[R+20>>2]=0,i[R+12>>2]=0,i[R+16>>2]=0,k=i[R+28>>2],n=i[R+24>>2];f:{if((k|0)==(n|0)){o=0;break f}if(k=k-n|0,(k|0)<0)break i;o=C(k),k&&z(o,n,k),X0=k+o|0}W[i[r+4>>2]](R,e,o,X0-o|0,f);f:{if(!i[R+8>>2]){if(!i[R>>2]){i[R+8>>2]=54203,i[A+8>>2]=54203,e=i[R+4>>2],i[A>>2]=i[R>>2],i[A+4>>2]=e;break f}i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=3416;break f}e=i[R+4>>2],i[A>>2]=i[R>>2],i[A+4>>2]=e,i[A+8>>2]=i[R+8>>2]}if(!o)break r;Z(o)}if(t[R+63|0]<0&&Z(i[R+52>>2]),A=i[R+24>>2],!A)break e;i[R+28>>2]=A,Z(A)}v=R- -64|0;return}s0(),M()}function i6(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0;i:{e:{r:{if(!n){V=i[A+18588>>2],A0=i[V+124>>2];f:{if(!k){if(s=i[V+208>>2],l=e>>s,(l|0)<0||(w=i[V+212>>2],(w|0)<=(l|0)))break e;if(s=r>>s,(s|0)<0|(s|0)>=i[V+216>>2])break i;l=u[(l+i[V+200>>2]|0)+g(s,w)|0],l=l>>>0<=34?l:0;break f}if(s=i[V+228>>2],l=g(i[A0+16852>>2],e)>>s,(l|0)<0||(w=i[V+232>>2],(w|0)<=(l|0)))break e;if(s=g(i[A0+16856>>2],r)>>s,(s|0)<0|(s|0)>=i[V+236>>2])break i;l=u[(l+i[V+220>>2]|0)+g(s,w)|0]&63}t0=l>>>0>34?1:l,E=t0,x=i[V+(k?44:40)>>2],l=g(x,r),s=i[(V+(k<<2)|0)+4>>2];f:{A:{k:{n:{t:{o:{if(i[i[V+124>>2]+(k?16840:16832)>>2]>=9){U=s+(e+l<<1)|0,w=0,j=v-528|0,v=j,G=v-336|0,v=G,i[G+24>>2]=k,i[G+16>>2]=V,i[G+32>>2]=r,i[G+28>>2]=e,m=j+256|0,i[G+12>>2]=m,i[G+20>>2]=f;l:{if((f|0)<65){i[G+316>>2]=16843009,h=G+12|0,ot(h);u:{if(i[h+8>>2]<33){if(s=i[h+4>>2],l=i[h+12>>2],B=i[s+(l?44:40)>>2],_=i[h+16>>2],I=i[h+24>>2],Q=i[I+16936>>2],N=i[h+20>>2],I=i[(i[i[h+28>>2]+8496>>2]+(g(_,i[h+296>>2])>>Q<<2)|0)+(g(i[I+16924>>2],g(N,i[h+300>>2])>>Q)<<2)>>2],Q=i[(s+(l<<2)|0)+4>>2],l=i[h+308>>2],!(u[h+304|0]!=1|(l|0)<=0))for(O=Q-2|0,l=l-1|0;;){s=l;s:{if(u[h+304|0]!=1)break s;R=i[h+28>>2],S=g(i[h+296>>2],_-1|0),Y=i[h+24>>2],q=i[Y+16936>>2],d=l+N|0,c=g(d,i[h+300>>2]),Y=i[(i[R+8496>>2]+(S>>q<<2)|0)+(g(i[Y+16924>>2],c>>q)<<2)>>2];h:{if(u[R+24|0]){if(R=S,l=i[h+4>>2],S=i[l+168>>2],R=R>>S,(R|0)<0||(q=i[l+172>>2],(q|0)<=(R|0)))break e;if(S=c>>S,(S|0)<0|(S|0)>=i[l+176>>2])break i;if(u[((i[l+160>>2]+g(R,3)|0)+g(g(S,q),3)|0)+1|0]&3)break s;if((I|0)>=(Y|0))break h;break s}if((I|0)<(Y|0))break s}i[h+316>>2]||(X[h+320>>1]=p[(O+(_<<1)|0)+(g(B,d)<<1)>>1]),l=s^-1,t[l+i[h+292>>2]|0]=1,X[i[h>>2]+(l<<1)>>1]=p[(O+(i[h+16>>2]<<1)|0)+(g(B,s+i[h+20>>2]|0)<<1)>>1],t[i[h+292>>2]-s|0]=1,X[i[h>>2]-(s<<1)>>1]=p[(O+(i[h+16>>2]<<1)|0)+(g(B,(s+i[h+20>>2]|0)-1|0)<<1)>>1],l=1-s|0,t[l+i[h+292>>2]|0]=1,X[i[h>>2]+(l<<1)>>1]=p[(O+(i[h+16>>2]<<1)|0)+(g(B,(s+i[h+20>>2]|0)-2|0)<<1)>>1],l=2-s|0,t[l+i[h+292>>2]|0]=1,_=i[h+16>>2],N=i[h+20>>2],X[i[h>>2]+(l<<1)>>1]=p[(O+(_<<1)|0)+(g(B,(s+N|0)-3|0)<<1)>>1],i[h+316>>2]=i[h+316>>2]+4}if(l=s-4|0,!((s|0)>3))break}s:{if(!u[h+307|0])break s;l=i[h+28>>2],O=g(i[h+296>>2],_-1|0),s=i[h+24>>2],Y=i[s+16936>>2],R=N-1|0,N=g(R,i[h+300>>2]),s=i[(i[l+8496>>2]+(O>>Y<<2)|0)+(g(i[s+16924>>2],N>>Y)<<2)>>2];h:{if(u[l+24|0]){if(l=i[h+4>>2],Y=i[l+168>>2],O=O>>Y,(O|0)<0||(S=i[l+172>>2],(S|0)<=(O|0)))break e;if(N=N>>Y,(N|0)<0|(N|0)>=i[l+176>>2])break i;if(u[((i[l+160>>2]+g(O,3)|0)+g(g(N,S),3)|0)+1|0]&3)break s;if((s|0)<=(I|0))break h;break s}if((s|0)>(I|0))break s}l=g(B,R),i[h+316>>2]||(X[h+320>>1]=p[((Q+(_<<1)|0)+(l<<1)|0)-2>>1]),X[i[h>>2]>>1]=p[((Q+(_<<1)|0)+(l<<1)|0)-2>>1],t[i[h+292>>2]]=1,i[h+316>>2]=i[h+316>>2]+1}if(l=i[h+312>>2],(l|0)>0)for(_=0;;){s:{if(u[h+(i[h+8>>2]>(_|0)?305:306)|0]!=1)break s;s=i[h+28>>2],O=i[h+16>>2],Y=g(i[h+296>>2],O+_|0),N=i[h+24>>2],R=i[N+16936>>2],S=i[h+20>>2]-1|0,q=g(S,i[h+300>>2]),N=i[(i[s+8496>>2]+(Y>>R<<2)|0)+(g(i[N+16924>>2],q>>R)<<2)>>2];h:{if(u[s+24|0]){if(s=i[h+4>>2],R=i[s+168>>2],Y=Y>>R,(Y|0)<0||(d=i[s+172>>2],(d|0)<=(Y|0)))break e;if(R=q>>R,(R|0)<0|(R|0)>=i[s+176>>2])break i;if(u[((i[s+160>>2]+g(Y,3)|0)+g(g(R,d),3)|0)+1|0]&3)break s;if((I|0)>=(N|0))break h;break s}if((I|0)<(N|0))break s}s=g(B,S),i[h+316>>2]||(X[h+320>>1]=p[((Q+(O<<1)|0)+(_<<1)|0)+(s<<1)>>1]),N=_|1,l=Q+(_<<1)|0,X[i[h>>2]+(N<<1)>>1]=p[(l+(O<<1)|0)+(s<<1)>>1],t[N+i[h+292>>2]|0]=1,s=_|2,X[i[h>>2]+(s<<1)>>1]=p[((l+(i[h+16>>2]<<1)|0)+(g(B,i[h+20>>2]-1|0)<<1)|0)+2>>1],t[s+i[h+292>>2]|0]=1,s=_|3,X[i[h>>2]+(s<<1)>>1]=p[((l+(i[h+16>>2]<<1)|0)+(g(B,i[h+20>>2]-1|0)<<1)|0)+4>>1],t[s+i[h+292>>2]|0]=1,s=_+4|0,X[i[h>>2]+(s<<1)>>1]=p[((l+(i[h+16>>2]<<1)|0)+(g(B,i[h+20>>2]-1|0)<<1)|0)+6>>1],t[s+i[h+292>>2]|0]=1,i[h+316>>2]=i[h+316>>2]+4,l=i[h+312>>2]}if(_=_+4|0,!((_|0)<(l|0)))break}break u}break o}s=i[G+328>>2],l=i[G+20>>2],h=l<<2,Q=h|1;u:{if((s|0)==(Q|0))break u;if(!s){if(B=0,I=l<<1,_=0-I|0,(_|0)>(I|0))break u;for(Q=Q&5,l=1<<i[i[i[G+16>>2]+124>>2]+(i[G+24>>2]?16840:16832)>>2]-1,s=i[G+12>>2];X[s+(_<<1)>>1]=l,_=_+1|0,B=B+1|0,(Q|0)!=(B|0););if(h>>>0<7)break u;for(B=s+12|0,Q=s+10|0,O=s+8|0,N=s+6|0,Y=s+4|0,R=s+2|0;h=_<<1,X[h+s>>1]=l,X[h+R>>1]=l,X[h+Y>>1]=l,X[h+N>>1]=l,X[h+O>>1]=l,X[h+Q>>1]=l,X[h+B>>1]=l,h=_+7|0,X[s+(h<<1)>>1]=l,_=_+8|0,(h|0)!=(I|0););break u}if(l=l<<1,s=0-l|0,h=i[G+304>>2],u[h-l|0]||(X[i[G+12>>2]+(s<<1)>>1]=p[G+332>>1]),(l|0)<=(s|0))break u;for(_=s|1,s=i[G+12>>2];u[h+_|0]||(B=s+(_<<1)|0,X[B>>1]=p[B-2>>1]),B=_+1|0,u[B+h|0]||(I=s+(B<<1)|0,X[I>>1]=p[I-2>>1]),_=_+2|0,(l|0)!=(B|0););}v=G+336|0;break l}break t}l=i[V+124>>2];l:{if(u[l+16825|0]||k&&(w=k,i[l+16848>>2]!=3))break l;h=v-272|0,v=h;u:{if((f|0)==4|(E|0)==1)break u;s=(E|0)<26?26-E|0:E-26|0,_=(E|0)<10?10-E|0:E-10|0,s=(s|0)<(_|0)?s:_;s:{h:switch(t2(f-8|0,29)|0){case 1:if((s|0)<=1)break u;break s;case 3:if((s|0)>0)break s;break u;case 7:break u;case 0:break h;default:break n}if((s|0)<8)break u}s:{h:{w:{if(!(!u[l+8997|0]|(w|(f|0)!=32))&&(w=p[m+128>>1],s=p[m>>1],B=(w+s|0)-(p[m+64>>1]<<1)|0,_=B>>31,G=1<<i[l+512>>2]-5,(G|0)>((_^B)-_|0)))break w;l=h+128|0;break h}if(l=h+128|0,_=p[m-128>>1],I=(_+s|0)-(p[m+-64>>1]<<1)|0,B=I>>31,G>>>0<=(B^I)-B>>>0)break h;for(X[h+256>>1]=w,X[h>>1]=_,X[h+128>>1]=s,B=w-s|0,G=_-s|0,w=1;;)if(_=w<<1,X[l-_>>1]=s+(g(w,G)+32>>>6|0),X[l+_>>1]=s+(g(w,B)+32>>>6|0),_=w+1|0,(_|0)==64){_=-64;break s}else{X[((w^-1)<<1)+l>>1]=s+(g(_,G)+32>>>6|0),X[(_<<1)+l>>1]=s+(g(_,B)+32>>>6|0),w=w+2|0;continue}}if(s=h+128|0,w=f<<2,X[s-w>>1]=p[m-w>>1],X[s+w>>1]=p[w+m>>1],B=f<<1,_=0-B|0,w=1-B|0,(w|0)>=(B|0))break s;for(I=w<<1,O=m-2|0,w=2-B|0,G=p[m+(w<<1)>>1],X[I+s>>1]=(p[O+I>>1]+(G+(p[m+I>>1]<<1)|0)|0)+2>>>2;I=w<<1,N=I+2|0,Q=p[N+m>>1],X[s+I>>1]=(p[I+O>>1]+(Q+(G<<1)|0)|0)+2>>>2,w=w+2|0,G=p[m+(w<<1)>>1],X[s+N>>1]=(p[m+I>>1]+(G+(Q<<1)|0)|0)+2>>>2,(w|0)!=(B|0););}if(s=f<<3|2,!s)break u;w=_<<1,z(w+m|0,l+w|0,s)}v=h+272|0}l:{u:switch(E|0){case 0:s:{if((f|0)>=2){for(s=0,l=f;w=s,s=s+1|0,h=l>>>0>3,l=l>>>1|0,!!h;);h=w+2|0;break s}if(h=1,(f|0)!=1)break l}for(N=f&-2,Y=f&1,w=f-1|0,R=p[m+((f^-1)<<1)>>1],_=p[(m+(f<<1)|0)+2>>1],l=0;;){if(B=w-l|0,s=l+1|0,E=g(s,R),V=U+(g(l,x)<<1)|0,G=p[m+((l^-1)<<1)>>1],l=0,I=0,(f|0)!=1)for(;Q=l|1,O=Q<<1,X[V+(l<<1)>>1]=E+(((g(G,w-l|0)+f|0)+g(_,Q)|0)+g(B,p[m+O>>1])|0)>>h,l=l+2|0,X[V+O>>1]=E+(((g(G,w-Q|0)+f|0)+g(_,l)|0)+g(B,p[m+(l<<1)>>1])|0)>>h,I=I+2|0,(N|0)!=(I|0););if(Y&&(Q=V+(l<<1)|0,S=g(G,w-l|0)+f|0,l=l+1|0,X[Q>>1]=E+((S+g(l,_)|0)+g(B,p[m+(l<<1)>>1])|0)>>h),l=s,(l|0)==(f|0))break}break l;case 1:s=0,w=0;s:{h:{if((f|0)>=2){for(l=f;w=s,s=s+1|0,h=l>>>0>3,l=l>>>1|0,!!h;);_=w+2|0;break h}if(_=1,(f|0)!=1)break s}w=1,E=f&1;h:{if((f|0)==1){h=0,s=0;break h}for(V=m+2|0,G=f&-2,l=0,s=0,B=0;h=l+2|0,s=p[m+((l^2147483646)<<1)>>1]+(p[m+(h<<1)>>1]+(p[m+((l^-1)<<1)>>1]+(p[V+(l<<1)>>1]+s|0)|0)|0)|0,l=h,B=B+2|0,(G|0)!=(B|0););}if(!E)break s;s=p[m+((h^-1)<<1)>>1]+(p[(m+(h<<1)|0)+2>>1]+s|0)|0}_=f+s>>_;s:{if(!(!k&(f|0)<=31)){if(!w)break s;for(E=f&-8,m=f&7,h=0,V=f-1>>>0<7;;){if(l=U+(g(h,x)<<1)|0,s=0,!V)for(G=l+14|0,I=l+12|0,Q=l+10|0,O=l+8|0,N=l+6|0,Y=l+4|0,R=l+2|0,B=0;w=s<<1,X[w+l>>1]=_,X[w+R>>1]=_,X[w+Y>>1]=_,X[w+N>>1]=_,X[w+O>>1]=_,X[w+Q>>1]=_,X[w+I>>1]=_,X[w+G>>1]=_,s=s+8|0,B=B+8|0,(E|0)!=(B|0););if(B=0,m)for(;X[l+(s<<1)>>1]=_,s=s+1|0,B=B+1|0,(m|0)!=(B|0););if(h=h+1|0,(h|0)==(f|0))break}break s}if(s=1,X[U>>1]=(p[m+2>>1]+(p[m-2>>1]+(_<<1)|0)|0)+2>>>2,(f|0)<2)break s;if(w=f-1|0,E=w&3,h=g(_,3)+2|0,V=f-2|0,V>>>0>=3)for(I=w&-4,l=0;B=s<<1,G=B+2|0,X[B+U>>1]=h+p[m+G>>1]>>>2,Y=G+U|0,G=B+4|0,X[Y>>1]=h+p[G+m>>1]>>>2,B=B+6|0,X[G+U>>1]=h+p[B+m>>1]>>>2,s=s+4|0,X[B+U>>1]=h+p[m+(s<<1)>>1]>>>2,l=l+4|0,(I|0)!=(l|0););if(E)for(B=0;l=U+(s<<1)|0,s=s+1|0,X[l>>1]=h+p[m+(s<<1)>>1]>>>2,B=B+1|0,(E|0)!=(B|0););if(s=1,l=g(_,3)+2|0,V)for(h=w&-2,B=0;X[U+(g(s,x)<<1)>>1]=l+p[m+((s^-1)<<1)>>1]>>>2,X[U+(g(x,s+1|0)<<1)>>1]=l+p[m+(-2-s<<1)>>1]>>>2,s=s+2|0,B=B+2|0,(h|0)!=(B|0););for(w&1&&(X[U+(g(s,x)<<1)>>1]=l+p[m+((s^-1)<<1)>>1]>>>2),E=w&-8,m=w&7,h=1;;){if(l=U+(g(h,x)<<1)|0,s=1,V>>>0>=7)for(G=l+14|0,I=l+12|0,Q=l+10|0,O=l+8|0,N=l+6|0,Y=l+4|0,R=l+2|0,B=0;w=s<<1,X[w+l>>1]=_,X[w+R>>1]=_,X[w+Y>>1]=_,X[w+N>>1]=_,X[w+O>>1]=_,X[w+Q>>1]=_,X[w+I>>1]=_,X[w+G>>1]=_,s=s+8|0,B=B+8|0,(E|0)!=(B|0););if(B=0,m)for(;X[l+(s<<1)>>1]=_,s=s+1|0,B=B+1|0,(m|0)!=(B|0););if(h=h+1|0,(h|0)==(f|0))break}}break l;default:break u}if(l=i[V+124>>2],O=i[l+(k?16840:16832)>>2],u[l+16822|0]){if(s=i[V+168>>2],l=e>>s,(l|0)<0||(w=i[V+172>>2],(w|0)<=(l|0)))break e;if(s=r>>s,(s|0)<0|(s|0)>=i[V+176>>2])break i;h=(u[((i[V+160>>2]+g(l,3)|0)+g(g(s,w),3)|0)+1|0]&8)>>>3|0}else h=0;l=0,w=0,V=v-528|0,v=V;u:{if((E|0)<35){if((E|0)<=1)break A;_=V+256|0,B=i[(E<<2)+69088>>2];s:{h:{w:{if(E>>>0<=17){_:{if((f|0)<0)break _;if(s=f+1|0,G=s&3,f>>>0>=3)for(I=s&-4;s=l<<1,X[s+_>>1]=p[m-s>>1],Q=s|2,X[Q+_>>1]=p[m-Q>>1],Q=s|4,X[Q+_>>1]=p[m-Q>>1],s=s|6,X[s+_>>1]=p[m-s>>1],l=l+4|0,w=w+4|0,(I|0)!=(w|0););if(!G)break _;for(s=0;w=l<<1,X[w+_>>1]=p[m-w>>1],l=l+1|0,s=s+1|0,(G|0)!=(s|0););}if(s=E-11|0,s>>>0<15)break w;if(G=f<<1,(G|0)<=(f|0))break h;if(l=f,I=l&3,I)for(w=0,s=l;l=s+1|0,X[_+(l<<1)>>1]=p[m+((s^-1)<<1)>>1],s=l,w=w+1|0,(I|0)!=(w|0););if(f-1>>>0<3)break h;for(w=_+6|0,I=_+4|0,Q=_+2|0;s=l<<1,X[s+Q>>1]=p[m+((l^-1)<<1)>>1],X[s+I>>1]=p[m+(-2-l<<1)>>1],X[s+w>>1]=p[m+(-3-l<<1)>>1],s=l+4|0,X[_+(s<<1)>>1]=p[m+(-4-l<<1)>>1],l=s,(G|0)!=(l|0););break h}_:{if((f|0)<0||(l=(f<<1)+2|0,!l))break _;z(_,m,l)}s=E-11|0;_:{if(s>>>0>=15){if(l=f<<1,(l|0)<=(f|0)|!l)break _;z((l+V|0)+258|0,(l+m|0)+2|0,l);break _}if(w=g(f,B),l=w>>5,(l|0)>-2)break _;for(s=i[(s<<2)+69232>>2],w&32&&(X[_+(l<<1)>>1]=p[m-(g(l,s)+128>>8<<1)>>1],l=l+1|0);X[_+(l<<1)>>1]=p[m-(g(l,s)+128>>8<<1)>>1],w=l+1|0,X[_+(w<<1)>>1]=p[m-(g(s,w)+128>>8<<1)>>1],l=l+2|0,!!l;);}if((f|0)>0)for(q=V+258|0,d=f&2147483646,c=f&1,N=f<<1,g0=x<<1,s=0;;){l=s,s=l+1|0,w=g(B,s),Q=w>>5<<1,w=w&31;_:{if(w){if(G=U+(g(l,x)<<1)|0,I=32-w|0,Q=_+Q|0,l=0,(f|0)!=1)for(X0=Q+4|0,Y=0;R=l<<1,_0=R+Q|0,S=p[_0+4>>1],X[G+R>>1]=(g(I,p[_0+2>>1])+g(w,S)|0)+16>>>5,R=R|2,X[R+G>>1]=(g(I,S)+g(w,p[R+X0>>1])|0)+16>>>5,l=l+2|0,Y=Y+2|0,(d|0)!=(Y|0););if(!c)break _;Y=Q,Q=l<<1,l=Y+Q|0,X[G+Q>>1]=(g(I,p[l+2>>1])+g(w,p[l+4>>1])|0)+16>>>5;break _}if(!N)break _;z(U+g(l,g0)|0,Q+q|0,N)}if((f|0)==(s|0))break}if((E|0)!=26|f-32>>>0<4294967265|(k|h))break s;for(s=-1<<O^-1,l=0;w=p[m+2>>1]+(p[m+((l^-1)<<1)>>1]-p[m>>1]>>1)|0,X[U+(g(l,x)<<1)>>1]=(w|0)>=0?(s|0)>(w|0)?w:s:0,l=l+1|0,(l|0)!=(f|0););break s}if(w=g(f,B),l=w>>5,(l|0)>-2)break h;for(s=i[(s<<2)+69232>>2],w&32&&(X[_+(l<<1)>>1]=p[m+(g(l,s)+128>>8<<1)>>1],l=l+1|0);X[_+(l<<1)>>1]=p[m+(g(l,s)+128>>8<<1)>>1],w=l+1|0,X[_+(w<<1)>>1]=p[m+(g(s,w)+128>>8<<1)>>1],l=l+2|0,!!l;);}if((f|0)>0)for(I=V+258|0,w=0;;){for(l=w<<1,Q=l+I|0,N=l+_|0,Y=U+(g(w,x)<<1)|0,l=0;;){s=l+1|0,R=g(s,B),G=R>>5,S=Y+(l<<1)|0,l=R&31;h:{if(l){G=N+(G<<1)|0,l=(g(p[G+2>>1],32-l|0)+g(l,p[G+4>>1])|0)+16>>>5|0;break h}l=p[Q+(G<<1)>>1]}if(X[S>>1]=l,l=s,(l|0)==(f|0))break}if(w=w+1|0,(w|0)==(f|0))break}if((E|0)!=10|f-32>>>0<4294967265|(k|h))break s;if(w=m-2|0,l=-1<<O^-1,s=0,(f|0)!=1)for(_=f&30,B=0;E=s<<1,x=E|2,h=p[w>>1]+(p[x+m>>1]-p[m>>1]>>1)|0,X[E+U>>1]=(h|0)>=0?(l|0)>(h|0)?h:l:0,s=s+2|0,h=p[w>>1]+(p[m+(s<<1)>>1]-p[m>>1]>>1)|0,X[U+x>>1]=(h|0)>=0?(l|0)>(h|0)?h:l:0,B=B+2|0,(_|0)!=(B|0););if(!(f&1))break s;h=p[w>>1],w=s<<1,s=h+(p[(w+m|0)+2>>1]-p[m>>1]>>1)|0,X[w+U>>1]=(s|0)>=0?(l|0)>(s|0)?s:l:0}v=V+528|0;break u}break k}}v=j+528|0;break f}U=l+(e+s|0)|0,w=0,O=v-272|0,v=O,B=v-336|0,v=B,i[B+24>>2]=k,i[B+16>>2]=V,i[B+32>>2]=r,i[B+28>>2]=e,m=O+128|0,i[B+12>>2]=m,i[B+20>>2]=f;l:{if((f|0)<65){i[B+316>>2]=16843009,h=B+12|0,ot(h);u:{if(i[h+8>>2]<33){if(s=i[h+4>>2],l=i[h+12>>2],G=i[s+(l?44:40)>>2],_=i[h+24>>2],I=i[_+16936>>2],I=i[(i[i[h+28>>2]+8496>>2]+(g(i[h+296>>2],i[h+16>>2])>>I<<2)|0)+(g(i[_+16924>>2],g(i[h+300>>2],i[h+20>>2])>>I)<<2)>>2],Q=i[(s+(l<<2)|0)+4>>2],l=i[h+308>>2],!(u[h+304|0]!=1|(l|0)<=0))for(_=Q-1|0,l=l-1|0;;){s=l;s:{if(u[h+304|0]!=1)break s;j=i[h+28>>2],R=i[h+16>>2],Y=g(i[h+296>>2],R-1|0),N=i[h+24>>2],S=i[N+16936>>2],q=l+i[h+20>>2]|0,d=g(q,i[h+300>>2]),N=i[(i[j+8496>>2]+(Y>>S<<2)|0)+(g(i[N+16924>>2],d>>S)<<2)>>2];h:{if(u[j+24|0]){if(j=Y,l=i[h+4>>2],Y=i[l+168>>2],j=j>>Y,(j|0)<0||(S=i[l+172>>2],(S|0)<=(j|0)))break e;if(Y=d>>Y,(Y|0)<0|(Y|0)>=i[l+176>>2])break i;if(u[((i[l+160>>2]+g(j,3)|0)+g(g(Y,S),3)|0)+1|0]&3)break s;if((I|0)>=(N|0))break h;break s}if((I|0)<(N|0))break s}i[h+316>>2]||(t[h+320|0]=u[(_+R|0)+g(G,q)|0]),l=s^-1,t[l+i[h+292>>2]|0]=1,t[l+i[h>>2]|0]=u[(_+i[h+16>>2]|0)+g(G,s+i[h+20>>2]|0)|0],t[i[h+292>>2]-s|0]=1,t[i[h>>2]-s|0]=u[(_+i[h+16>>2]|0)+g(G,(s+i[h+20>>2]|0)-1|0)|0],l=1-s|0,t[l+i[h+292>>2]|0]=1,t[l+i[h>>2]|0]=u[(_+i[h+16>>2]|0)+g(G,(s+i[h+20>>2]|0)-2|0)|0],l=2-s|0,t[l+i[h+292>>2]|0]=1,t[l+i[h>>2]|0]=u[(_+i[h+16>>2]|0)+g(G,(s+i[h+20>>2]|0)-3|0)|0],i[h+316>>2]=i[h+316>>2]+4}if(l=s-4|0,!((s|0)>3))break}s:{if(!u[h+307|0])break s;l=i[h+28>>2],s=i[h+16>>2],N=g(i[h+296>>2],s-1|0),_=i[h+24>>2],j=i[_+16936>>2],Y=i[h+20>>2]-1|0,R=g(Y,i[h+300>>2]),_=i[(i[l+8496>>2]+(N>>j<<2)|0)+(g(i[_+16924>>2],R>>j)<<2)>>2];h:{if(u[l+24|0]){if(l=i[h+4>>2],j=i[l+168>>2],N=N>>j,(N|0)<0||(S=i[l+172>>2],(S|0)<=(N|0)))break e;if(j=R>>j,(j|0)<0|(j|0)>=i[l+176>>2])break i;if(u[((i[l+160>>2]+g(N,3)|0)+g(g(j,S),3)|0)+1|0]&3)break s;if((_|0)<=(I|0))break h;break s}if((_|0)>(I|0))break s}l=g(G,Y),i[h+316>>2]||(t[h+320|0]=u[(l+(s+Q|0)|0)-1|0]),t[i[h>>2]]=u[(l+(s+Q|0)|0)-1|0],t[i[h+292>>2]]=1,i[h+316>>2]=i[h+316>>2]+1}if(l=i[h+312>>2],(l|0)>0)for(_=0;;){s:{if(u[h+(i[h+8>>2]>(_|0)?305:306)|0]!=1)break s;s=i[h+28>>2],N=i[h+16>>2],Y=g(i[h+296>>2],N+_|0),j=i[h+24>>2],R=i[j+16936>>2],S=i[h+20>>2]-1|0,q=g(S,i[h+300>>2]),j=i[(i[s+8496>>2]+(Y>>R<<2)|0)+(g(i[j+16924>>2],q>>R)<<2)>>2];h:{if(u[s+24|0]){if(s=i[h+4>>2],R=i[s+168>>2],Y=Y>>R,(Y|0)<0||(d=i[s+172>>2],(d|0)<=(Y|0)))break e;if(R=q>>R,(R|0)<0|(R|0)>=i[s+176>>2])break i;if(u[((i[s+160>>2]+g(Y,3)|0)+g(g(R,d),3)|0)+1|0]&3)break s;if((I|0)>=(j|0))break h;break s}if((I|0)<(j|0))break s}s=g(G,S),i[h+316>>2]||(t[h+320|0]=u[s+((Q+N|0)+_|0)|0]),j=_|1,l=_+Q|0,t[j+i[h>>2]|0]=u[s+(l+N|0)|0],t[j+i[h+292>>2]|0]=1,s=_|2,t[s+i[h>>2]|0]=u[((l+i[h+16>>2]|0)+g(G,i[h+20>>2]-1|0)|0)+1|0],t[s+i[h+292>>2]|0]=1,s=_|3,t[s+i[h>>2]|0]=u[((l+i[h+16>>2]|0)+g(G,i[h+20>>2]-1|0)|0)+2|0],t[s+i[h+292>>2]|0]=1,s=_+4|0,t[s+i[h>>2]|0]=u[((l+i[h+16>>2]|0)+g(G,i[h+20>>2]-1|0)|0)+3|0],t[s+i[h+292>>2]|0]=1,i[h+316>>2]=i[h+316>>2]+4,l=i[h+312>>2]}if(_=_+4|0,!((_|0)<(l|0)))break}break u}break o}h=i[B+328>>2],l=i[B+20>>2],s=l<<2|1;u:{if((h|0)==(s|0))break u;if(!h){if(!s)break u;l0(i[B+12>>2]-(l<<1)|0,1<<i[i[i[B+16>>2]+124>>2]+(i[B+24>>2]?16840:16832)>>2]-1,s);break u}if(s=l<<1,_=0-s|0,u[i[B+304>>2]-s|0]||(t[i[B+12>>2]+_|0]=u[B+332|0],l=i[B+20>>2],_=0-(l<<1)|0),l<<1<=(_|0))break u;for(_=_|1;u[i[B+304>>2]+_|0]||(l=i[B+12>>2]+_|0,t[l|0]=u[l-1|0],l=i[B+20>>2]),s=l<<1>(_|0),_=_+1|0,!!s;);}v=B+336|0;break l}break t}l=i[V+124>>2];l:{if(u[l+16825|0]||k&&(w=k,i[l+16848>>2]!=3))break l;h=v-144|0,v=h;u:{if((f|0)==4|(E|0)==1)break u;s=(E|0)<26?26-E|0:E-26|0,_=(E|0)<10?10-E|0:E-10|0,s=(s|0)<(_|0)?s:_;s:{h:switch(t2(f-8|0,29)|0){case 1:if((s|0)<=1)break u;break s;case 3:if((s|0)>0)break s;break u;case 7:break u;case 0:break h;default:break n}if((s|0)<8)break u}s:{h:{w:{if(!(!u[l+8997|0]|(w|(f|0)!=32))&&(w=u[m+64|0],s=u[m|0],B=(w+s|0)-(u[m+32|0]<<1)|0,_=B>>31,G=1<<i[l+512>>2]-5,(G|0)>((_^B)-_|0)))break w;l=h- -64|0;break h}if(l=h- -64|0,_=u[m+-64|0],I=(_+s|0)-(u[m-32|0]<<1)|0,B=I>>31,G>>>0<=(B^I)-B>>>0)break h;for(t[h+128|0]=w,t[h|0]=_,t[h+64|0]=s,B=w-s|0,G=_-s|0,w=1;;)if(t[l-w|0]=s+(g(w,G)+32>>>6|0),t[l+w|0]=s+(g(w,B)+32>>>6|0),_=w+1|0,(_|0)==64){B=-64;break s}else{t[(w^-1)+l|0]=s+(g(_,G)+32>>>6|0),t[l+_|0]=s+(g(_,B)+32>>>6|0),w=w+2|0;continue}}if(_=h- -64|0,s=f<<1,t[_-s|0]=u[m-s|0],t[s+_|0]=u[s+m|0],B=0-s|0,I=1-s|0,(I|0)>=(s|0))break s;for(Q=m-1|0,w=2-s|0,G=u[m+w|0],t[_+I|0]=(u[Q+I|0]+(G+(u[m+I|0]<<1)|0)|0)+2>>>2;Y=G<<1,G=w+1|0,I=u[G+m|0],t[w+_|0]=(u[w+Q|0]+(Y+I|0)|0)+2>>>2,Y=_+G|0,R=u[w+m|0],w=w+2|0,G=u[m+w|0],t[Y|0]=(R+(G+(I<<1)|0)|0)+2>>>2,(s|0)!=(w|0););}if(s=f<<2|1,!s)break u;z(m+B|0,l+B|0,s)}v=h+144|0}l:{u:switch(E|0){case 0:s:{if((f|0)>=2){for(s=0,l=f;w=s,s=s+1|0,h=l>>>0>3,l=l>>>1|0,!!h;);h=w+2|0;break s}if(h=1,(f|0)!=1)break l}for(N=f&-2,j=f&1,w=f-1|0,Y=u[m+(f^-1)|0],_=u[(f+m|0)+1|0],l=0;;){if(E=w-l|0,s=l+1|0,V=g(s,Y),G=U+g(l,x)|0,I=u[m+(l^-1)|0],l=0,B=0,(f|0)!=1)for(;Q=l|1,t[l+G|0]=V+(((g(I,w-l|0)+f|0)+g(Q,_)|0)+g(E,u[m+Q|0])|0)>>h,l=l+2|0,t[G+Q|0]=V+(((g(I,w-Q|0)+f|0)+g(_,l)|0)+g(E,u[l+m|0])|0)>>h,B=B+2|0,(N|0)!=(B|0););if(j&&(Q=l+G|0,R=g(I,w-l|0)+f|0,l=l+1|0,t[Q|0]=V+((R+g(l,_)|0)+g(E,u[l+m|0])|0)>>h),l=s,(l|0)==(f|0))break}break l;case 1:s=0,w=0;s:{h:{if((f|0)>=2){for(l=f;w=s,s=s+1|0,h=l>>>0>3,l=l>>>1|0,!!h;);_=w+2|0;break h}if(_=1,(f|0)!=1)break s}w=1,E=f&1;h:{if((f|0)==1){h=0,s=0;break h}for(V=m+1|0,G=f&-2,l=0,s=0,B=0;h=l+2|0,s=u[m+(l^-2)|0]+(u[m+h|0]+(u[m+(l^-1)|0]+(u[l+V|0]+s|0)|0)|0)|0,l=h,B=B+2|0,(G|0)!=(B|0););}if(!E)break s;s=u[m+(h^-1)|0]+(u[(h+m|0)+1|0]+s|0)|0}s=f+s>>_;s:{if(!(!k&(f|0)<=31)){if(!w)break s;if(h=0,l=0,f-1>>>0>=3)for(m=f&-4,B=0;w=!f,w||l0(U+g(l,x)|0,s,f),w||l0(U+g(x,l|1)|0,s,f),w||l0(U+g(x,l|2)|0,s,f),w||l0(U+g(x,l|3)|0,s,f),l=l+4|0,B=B+4|0,(m|0)!=(B|0););if(w=f&3,!w)break s;for(;f&&l0(U+g(l,x)|0,s,f),l=l+1|0,h=h+1|0,(w|0)!=(h|0););break s}if(l=1,t[U|0]=(u[m+1|0]+(u[m-1|0]+(s<<1)|0)|0)+2>>>2,(f|0)<2)break s;if(h=f-1|0,_=h&3,w=g(s,3)+2|0,E=f-2|0,E>>>0>=3)for(V=h&-4,B=0;G=l+1|0,t[l+U|0]=w+u[G+m|0]>>>2,Y=G+U|0,G=l+2|0,t[Y|0]=w+u[G+m|0]>>>2,Y=G+U|0,G=l+3|0,t[Y|0]=w+u[G+m|0]>>>2,l=l+4|0,t[G+U|0]=w+u[m+l|0]>>>2,B=B+4|0,(V|0)!=(B|0););if(_)for(B=0;Y=l+U|0,l=l+1|0,t[Y|0]=w+u[m+l|0]>>>2,B=B+1|0,(_|0)!=(B|0););if(l=1,w=g(s,3)+2|0,E)for(_=h&-2,B=0;t[U+g(l,x)|0]=w+u[m+(l^-1)|0]>>>2,t[U+g(x,l+1|0)|0]=w+u[(m-l|0)-2|0]>>>2,l=l+2|0,B=B+2|0,(_|0)!=(B|0););if(h&1&&(t[U+g(l,x)|0]=w+u[m+(l^-1)|0]>>>2),w=f-1|0,m=(U+x|0)+1|0,_=0,l=0,E>>>0>=3)for(V=h&-4,B=0;E=!w,E||l0(m+g(l,x)|0,s,w),E||l0(m+g(x,l|1)|0,s,w),E||l0(m+g(x,l|2)|0,s,w),E||l0(m+g(x,l|3)|0,s,w),l=l+4|0,B=B+4|0,(V|0)!=(B|0););if(h=h&3,!h)break s;for(;w&&l0(m+g(l,x)|0,s,w),l=l+1|0,_=_+1|0,(h|0)!=(_|0););}break l;default:break u}if(l=i[V+124>>2],N=i[l+(k?16840:16832)>>2],u[l+16822|0]){if(s=i[V+168>>2],l=e>>s,(l|0)<0||(w=i[V+172>>2],(w|0)<=(l|0)))break e;if(s=r>>s,(s|0)<0|(s|0)>=i[V+176>>2])break i;h=(u[((i[V+160>>2]+g(l,3)|0)+g(g(s,w),3)|0)+1|0]&8)>>>3|0}else h=0;l=0,V=v-272|0,v=V;u:{if((E|0)<35){if((E|0)<=1)break A;_=V+128|0,B=i[(E<<2)+69088>>2];s:{h:{w:{if(E>>>0<=17){_:{if((f|0)<0)break _;if(s=f+1|0,w=s&3,f>>>0>=3)for(G=s&-4,s=0;t[l+_|0]=u[m-l|0],I=l|1,t[I+_|0]=u[m-I|0],I=l|2,t[I+_|0]=u[m-I|0],I=l|3,t[I+_|0]=u[m-I|0],l=l+4|0,s=s+4|0,(G|0)!=(s|0););if(!w)break _;for(s=0;t[l+_|0]=u[m-l|0],l=l+1|0,s=s+1|0,(w|0)!=(s|0););}if(s=E-11|0,s>>>0<15)break w;if(G=f<<1,(G|0)<=(f|0))break h;if(l=f,I=l&3,I)for(w=0,s=l;l=s+1|0,t[_+l|0]=u[m+(s^-1)|0],s=l,w=w+1|0,(I|0)!=(w|0););if(f-1>>>0<3)break h;for(w=_+3|0,I=_+2|0,Q=_+1|0;t[l+Q|0]=u[m+(l^-1)|0],s=m-l|0,t[l+I|0]=u[s-2|0],t[l+w|0]=u[s-3|0],l=l+4|0,t[_+l|0]=u[s-4|0],(l|0)!=(G|0););break h}_:{if((f|0)<0||(l=f+1|0,!l))break _;z(_,m,l)}s=E-11|0;_:{if(s>>>0>=15){if(!f|f<<1<=(f|0))break _;z((f+V|0)+129|0,(f+m|0)+1|0,f);break _}if(w=g(f,B),l=w>>5,(l|0)>-2)break _;for(s=i[(s<<2)+69232>>2],w&32&&(t[l+_|0]=u[m-(g(l,s)+128>>8)|0],l=l+1|0);t[l+_|0]=u[m-(g(l,s)+128>>8)|0],w=l+1|0,t[w+_|0]=u[m-(g(s,w)+128>>8)|0],l=l+2|0,!!l;);}if((f|0)>0)for(R=V+129|0,S=f&2147483646,q=f&1,s=0;;){w=U+g(s,x)|0,s=s+1|0,G=g(B,s),l=G>>5,G=G&31;_:{if(G){if(I=l+_|0,Q=32-G|0,l=0,(f|0)!=1)for(d=I+2|0,j=0;c=l+I|0,Y=u[c+2|0],t[l+w|0]=(g(Q,u[c+1|0])+g(G,Y)|0)+16>>>5,c=l|1,t[c+w|0]=(g(Q,Y)+g(G,u[d+c|0])|0)+16>>>5,l=l+2|0,j=j+2|0,(S|0)!=(j|0););if(!q)break _;w=l+w|0,l=l+I|0,t[w|0]=(g(Q,u[l+1|0])+g(G,u[l+2|0])|0)+16>>>5;break _}if(!f)break _;z(w,l+R|0,f)}if((f|0)==(s|0))break}if((E|0)!=26|f-32>>>0<4294967265|(k|h))break s;for(s=-1<<N^-1,l=0;w=u[m+1|0]+(u[m+(l^-1)|0]-u[m|0]>>1)|0,t[U+g(l,x)|0]=(w|0)>=0?(s|0)>(w|0)?w:s:0,l=l+1|0,(l|0)!=(f|0););break s}if(w=g(f,B),l=w>>5,(l|0)>-2)break h;for(s=i[(s<<2)+69232>>2],w&32&&(t[l+_|0]=u[m+(g(l,s)+128>>8)|0],l=l+1|0);t[l+_|0]=u[m+(g(l,s)+128>>8)|0],w=l+1|0,t[w+_|0]=u[m+(g(s,w)+128>>8)|0],l=l+2|0,!!l;);}if((f|0)>0)for(I=V+129|0,w=0;;){for(Q=w+I|0,j=w+_|0,Y=U+g(w,x)|0,l=0;;){s=l+1|0,R=g(s,B),G=R>>5,S=l+Y|0,l=R&31;h:{if(l){G=G+j|0,l=(g(u[G+1|0],32-l|0)+g(l,u[G+2|0])|0)+16>>>5|0;break h}l=u[G+Q|0]}if(t[S|0]=l,l=s,(l|0)==(f|0))break}if(w=w+1|0,(w|0)==(f|0))break}if((E|0)!=10|f-32>>>0<4294967265|(k|h))break s;if(w=m-1|0,s=-1<<N^-1,l=0,(f|0)!=1)for(_=f&30,B=0;E=l|1,h=u[w|0]+(u[E+m|0]-u[m|0]>>1)|0,t[l+U|0]=(h|0)>=0?(s|0)>(h|0)?h:s:0,l=l+2|0,h=u[w|0]+(u[m+l|0]-u[m|0]>>1)|0,t[E+U|0]=(h|0)>=0?(s|0)>(h|0)?h:s:0,B=B+2|0,(_|0)!=(B|0););if(!(f&1))break s;h=l+U|0,l=u[w|0]+(u[(l+m|0)+1|0]-u[m|0]>>1)|0,t[h|0]=(l|0)>=0?(l|0)<(s|0)?l:s:0}v=V+272|0;break u}break k}}v=O+272|0;break f}U0(23403,11982,533,15577),M()}U0(21342,11982,146,4205),M()}U0(13347,11982,211,12219),M()}U0(23101,11982,342,8308),M()}U0(23311,11982,343,8308),M()}l=0,l=!u[A0+16822|0]|!(u[A+32|0]|u[(A+k|0)+33|0])?l:(t0&47)==10,l=(t0|0)==26?l&&2:l;break r}if(l=0,!u[A+36|0])break r;l=u[A+37|0]?2:1}r:{f:{A:{k:{if(!o){if(!k|!i[A+28>>2])break k;X[((k<<1)+A|0)+14396>>1]=0,l=0}G=u[(A+k|0)+33|0]!=0,w=!n,n=k?16840:16832;n:{if(i[n+i[i[A+18588>>2]+124>>2]>>2]>=9){o=A,U=v-4096|0,v=U;t:{if(k>>>0<3){if(s=i[A+18588>>2],m=i[s+168>>2],h=e>>m,(h|0)<0||(V=i[s+172>>2],(V|0)<=(h|0)))break e;if(_=r>>m,(_|0)<0|(_|0)>=i[s+176>>2])break i;I=k<<2,E=i[s+(k?44:40)>>2],x=i[(I+s|0)+4>>2]+(g(E,r)+e<<1)|0,B=i[s+124>>2],m=i[B+n>>2],n=i[A+2104>>2],e=0,Q=u[((i[s+160>>2]+g(h,3)|0)+g(g(_,V),3)|0)+1|0]&3,V=!Q&(f|0)==4&u[B+16820|0]!=0;o:{if(u[A+32|0]){if(A=A+(k<<1)|0,X[A+14396>>1]>0)for(e=A+14396|0,A=0,r=k<<11,s=r+(o+8252|0)|0,r=r+(o+2108|0)|0;w=A<<1,X[n+(X[w+s>>1]<<1)>>1]=p[r+w>>1],A=A+1|0,(A|0)<X[e>>1];);if(V&&W[i[i[o+18584>>2]+432>>2]](n,4),w=o+14404|0,s=k?U:w,W[i[i[o+18584>>2]+(l?(l|0)==2?368:372:364)>>2]](s,n,f),!(!k|!i[o+28>>2]|(f|0)<=0))for(A=i[i[o+18588>>2]+124>>2],l=i[A+16832>>2],h=i[A+16840>>2],G=f&2147483646,I=f&1,r=0;;){if(_=g(r,f),A=0,e=0,(f|0)!=1)for(;B=A+_<<2,Q=B+s|0,i[Q>>2]=i[Q>>2]+(g(i[o+28>>2],i[w+B>>2]<<h>>l)>>3),B=B+4|0,Q=B+s|0,i[Q>>2]=i[Q>>2]+(g(i[o+28>>2],i[w+B>>2]<<h>>l)>>3),A=A+2|0,e=e+2|0,(G|0)!=(e|0););if(I&&(A=A+_<<2,e=A+s|0,i[e>>2]=i[e>>2]+(g(i[o+28>>2],i[A+w>>2]<<h>>l)>>3)),r=r+1|0,(f|0)==(r|0))break}if(W[i[i[o+18584>>2]+460>>2]](x,E,s,f,m),!V)break o;X[n>>1]=0,X[n+2>>1]=0,X[n+4>>1]=0,X[n+6>>1]=0,X[n+24>>1]=0,X[n+26>>1]=0,X[n+28>>1]=0,X[n+30>>1]=0,X[n+16>>1]=0,X[n+18>>1]=0,X[n+20>>1]=0,X[n+22>>1]=0,X[n+8>>1]=0,X[n+10>>1]=0,X[n+12>>1]=0,X[n+14>>1]=0;break o}if((f|0)>=2)for(A=f;e=e+1|0,r=A>>>0>3,A=A>>>1|0,!!r;);_=i[s+132>>2],r=i[(o+I|0)+18536>>2],e=e+m|0;l:{if(!u[B+636|0]){if(A=o+(k<<1)|0,X[A+14396>>1]<=0)break l;for(r=i[((r|0)%6<<2)+69824>>2]<<(r|0)/6,s=e-9|0,w=1<<e-10,h=A+14396|0,A=0,e=k<<11,B=e+(o+2108|0)|0,I=e+(o+8252|0)|0;O=A<<1,e=w+g(r,X[O+B>>1])>>s,e=(e|0)>=32767?32767:e,X[n+(X[I+O>>1]<<1)>>1]=(e|0)<=-32768?-32768:e,A=A+1|0,(A|0)<X[h>>1];);break l}s=(f|0)!=32?k:0,A=s;u:{if(w||(A=k+3|0,(f|0)<=31))break u;A=s+1|0}u:{s:switch(t2(f-4|0,30)|0){case 1:A=(_+(A<<6)|0)+169|0;break u;case 3:A=(_+(A<<8)|0)+553|0;break u;case 7:A=(_+(A<<10)|0)+2089|0;break u;case 0:break s;default:break A}A=(_+(A<<4)|0)+73|0}if(s=o+(k<<1)|0,X[s+14396>>1]<=0)break l;for(h=A,I=s+14396|0,O=(r|0)/6|0,A0=i[(r-g(O,6)<<2)+69824>>2],s=e-5|0,w=1<<e-6,N=w>>31,A=0,e=k<<11,t0=e+(o+2108|0)|0,j=e+(o+8252|0)|0;e=A<<1,r=X[e+j>>1],Y=n+(r<<1)|0,e=X[e+t0>>1],R=e,S=e>>31,e=g(A0,u[r+h|0])<<O,e=L0(R,S,e,e>>31),r=N+h0|0,e=e+w|0,r=e>>>0<w>>>0?r+1|0:r,R=e,B=s&31,(s&63)>>>0>=32?(e=r>>31,r=r>>B):(e=r>>B,r=((1<<B)-1&r)<<32-B|R>>>B),B=(e|0)>=0&r>>>0>=32767|(e|0)>0,r=B?32767:r,e=B?0:e,(e|0)<-1?e=1:e=(e|0)<0&r>>>0<=4294934528,X[Y>>1]=e?-32768:r,A=A+1|0,(A|0)<X[I>>1];);}if(G){if(A=5,(f|0)>=2){for(e=0,A=f;r=e,e=e+1|0,s=A>>>0>3,A=A>>>1|0,!!s;);A=r+6|0}if(V&&W[i[i[o+18584>>2]+432>>2]](n,4),w=o+14404|0,s=k?U:w,W[i[i[o+18584>>2]+(l?(l|0)==2?464:468:472)>>2]](s,n,f,A,(m|0)<20?20-m|0:0),!(!k|!i[o+28>>2]|(f|0)<=0))for(A=i[i[o+18588>>2]+124>>2],l=i[A+16832>>2],h=i[A+16840>>2],G=f&2147483646,I=f&1,r=0;;){if(_=g(r,f),A=0,e=0,(f|0)!=1)for(;B=A+_<<2,Q=B+s|0,i[Q>>2]=i[Q>>2]+(g(i[o+28>>2],i[w+B>>2]<<h>>l)>>3),B=B+4|0,Q=B+s|0,i[Q>>2]=i[Q>>2]+(g(i[o+28>>2],i[w+B>>2]<<h>>l)>>3),A=A+2|0,e=e+2|0,(G|0)!=(e|0););if(I&&(A=A+_<<2,e=A+s|0,i[e>>2]=i[e>>2]+(g(i[o+28>>2],i[A+w>>2]<<h>>l)>>3)),r=r+1|0,(f|0)==(r|0))break}if(W[i[i[o+18584>>2]+460>>2]](x,E,s,f,m),!V)break o;X[n>>1]=0,X[n+2>>1]=0,X[n+4>>1]=0,X[n+6>>1]=0,X[n+24>>1]=0,X[n+26>>1]=0,X[n+28>>1]=0,X[n+30>>1]=0,X[n+16>>1]=0,X[n+18>>1]=0,X[n+20>>1]=0,X[n+22>>1]=0,X[n+8>>1]=0,X[n+10>>1]=0,X[n+12>>1]=0,X[n+14>>1]=0;break o}if(l)break t;if(e=!(k|Q)&(f|0)==4,u[_+8247|0]==1){r=0,w=v-4096|0,v=w,s=20-m|0,l=o+14404|0,A=k?w:l,h=i[o+18584>>2];l:{if(e){e=436;break l}e=440;u:switch(f-4|0){case 4:e=444;break l;case 12:e=448;break l;case 0:break l;default:break u}e=452}if(W[i[e+h>>2]](A,n,s,15),!(!k|!i[o+28>>2]|(f|0)<=0))for(e=i[i[o+18588>>2]+124>>2],n=i[e+16832>>2],s=i[e+16840>>2],G=f&2147483646,I=f&1;;){if(B=g(r,f),e=0,_=0,(f|0)!=1)for(;V=e+B<<2,Q=V+A|0,i[Q>>2]=i[Q>>2]+(g(i[o+28>>2],i[l+V>>2]<<s>>n)>>3),V=V+4|0,Q=V+A|0,i[Q>>2]=i[Q>>2]+(g(i[o+28>>2],i[l+V>>2]<<s>>n)>>3),e=e+2|0,_=_+2|0,(G|0)!=(_|0););if(I&&(e=e+B<<2,_=e+A|0,i[_>>2]=i[_>>2]+(g(i[o+28>>2],i[e+l>>2]<<s>>n)>>3)),r=r+1|0,(f|0)==(r|0))break}W[i[h+460>>2]](x,E,A,f,m),v=w+4096|0;break o}r=i[o+18584>>2]+172|0;l:{if(e){A=240;break l}A=244;u:switch(f-4|0){case 4:A=248;break l;case 12:A=252;break l;case 0:break l;default:break u}A=256}W[i[A+r>>2]](x,n,E,m)}if(A=o+(k<<1)|0,X[A+14396>>1]>0)for(e=A+14396|0,r=i[o+2104>>2],f=(o+8252|0)+(k<<11)|0,A=0;X[r+(X[f+(A<<1)>>1]<<1)>>1]=0,A=A+1|0,(A|0)<X[e>>1];);v=U+4096|0;break n}break f}break r}o=A,V=v-4096|0,v=V;t:{if(k>>>0<3){if(s=i[A+18588>>2],n=i[s+168>>2],h=e>>n,(h|0)<0||(_=i[s+172>>2],(_|0)<=(h|0)))break e;if(m=r>>n,(m|0)<0|(m|0)>=i[s+176>>2])break i;U=k<<2,B=i[s+(k?44:40)>>2],E=(i[(U+s|0)+4>>2]+e|0)+g(B,r)|0,n=i[A+2104>>2],e=0,I=u[((i[s+160>>2]+g(h,3)|0)+g(g(_,m),3)|0)+1|0]&3,h=i[s+124>>2],x=!I&(f|0)==4&u[h+16820|0]!=0;o:{if(u[A+32|0]){if(A=A+(k<<1)|0,X[A+14396>>1]>0)for(e=A+14396|0,A=0,r=k<<11,s=r+(o+8252|0)|0,r=r+(o+2108|0)|0;w=A<<1,X[n+(X[w+s>>1]<<1)>>1]=p[r+w>>1],A=A+1|0,(A|0)<X[e>>1];);if(x&&W[i[i[o+18584>>2]+432>>2]](n,4),w=o+14404|0,s=k?V:w,W[i[i[o+18584>>2]+(l?(l|0)==2?368:372:364)>>2]](s,n,f),!(!k|!i[o+28>>2]|(f|0)<=0))for(A=i[i[o+18588>>2]+124>>2],l=i[A+16832>>2],h=i[A+16840>>2],U=f&2147483646,G=f&1,r=0;;){if(m=g(r,f),A=0,e=0,(f|0)!=1)for(;_=A+m<<2,I=_+s|0,i[I>>2]=i[I>>2]+(g(i[o+28>>2],i[w+_>>2]<<h>>l)>>3),_=_+4|0,I=_+s|0,i[I>>2]=i[I>>2]+(g(i[o+28>>2],i[w+_>>2]<<h>>l)>>3),A=A+2|0,e=e+2|0,(U|0)!=(e|0););if(G&&(A=A+m<<2,e=A+s|0,i[e>>2]=i[e>>2]+(g(i[o+28>>2],i[A+w>>2]<<h>>l)>>3)),r=r+1|0,(f|0)==(r|0))break}if(W[i[i[o+18584>>2]+456>>2]](E,B,s,f,8),!x)break o;X[n>>1]=0,X[n+2>>1]=0,X[n+4>>1]=0,X[n+6>>1]=0,X[n+24>>1]=0,X[n+26>>1]=0,X[n+28>>1]=0,X[n+30>>1]=0,X[n+16>>1]=0,X[n+18>>1]=0,X[n+20>>1]=0,X[n+22>>1]=0,X[n+8>>1]=0,X[n+10>>1]=0,X[n+12>>1]=0,X[n+14>>1]=0;break o}if(_=i[h+(k?16840:16832)>>2],(f|0)>=2)for(A=f;e=e+1|0,r=A>>>0>3,A=A>>>1|0,!!r;);m=i[s+132>>2],r=i[(o+U|0)+18536>>2],e=e+_|0;l:{if(!u[h+636|0]){if(A=o+(k<<1)|0,X[A+14396>>1]<=0)break l;for(r=i[((r|0)%6<<2)+69824>>2]<<(r|0)/6,s=e-9|0,w=1<<e-10,h=A+14396|0,A=0,e=k<<11,_=e+(o+2108|0)|0,U=e+(o+8252|0)|0;Q=A<<1,e=w+g(r,X[Q+_>>1])>>s,e=(e|0)>=32767?32767:e,X[n+(X[Q+U>>1]<<1)>>1]=(e|0)<=-32768?-32768:e,A=A+1|0,(A|0)<X[h>>1];);break l}s=(f|0)!=32?k:0,A=s;u:{if(w||(A=k+3|0,(f|0)<=31))break u;A=s+1|0}u:{s:switch(t2(f-4|0,30)|0){case 1:A=(m+(A<<6)|0)+169|0;break u;case 3:A=(m+(A<<8)|0)+553|0;break u;case 7:A=(m+(A<<10)|0)+2089|0;break u;case 0:break s;default:break A}A=(m+(A<<4)|0)+73|0}if(s=o+(k<<1)|0,X[s+14396>>1]<=0)break l;for(h=A,U=s+14396|0,Q=(r|0)/6|0,O=i[(r-g(Q,6)<<2)+69824>>2],s=e-5|0,w=1<<e-6,A0=w>>31,A=0,e=k<<11,N=e+(o+2108|0)|0,t0=e+(o+8252|0)|0;e=A<<1,r=X[e+t0>>1],j=n+(r<<1)|0,e=X[e+N>>1],Y=e,R=e>>31,e=g(O,u[r+h|0])<<Q,e=L0(Y,R,e,e>>31),r=A0+h0|0,e=e+w|0,r=e>>>0<w>>>0?r+1|0:r,Y=e,_=s&31,(s&63)>>>0>=32?(e=r>>31,r=r>>_):(e=r>>_,r=((1<<_)-1&r)<<32-_|Y>>>_),_=(e|0)>=0&r>>>0>=32767|(e|0)>0,r=_?32767:r,e=_?0:e,(e|0)<-1?e=1:e=(e|0)<0&r>>>0<=4294934528,X[j>>1]=e?-32768:r,A=A+1|0,(A|0)<X[U>>1];);}if(G){if(A=5,(f|0)>=2){for(e=0,A=f;r=e,e=e+1|0,s=A>>>0>3,A=A>>>1|0,!!s;);A=r+6|0}if(x&&W[i[i[o+18584>>2]+432>>2]](n,4),w=o+14404|0,s=k?V:w,W[i[i[o+18584>>2]+(l?(l|0)==2?464:468:472)>>2]](s,n,f,A,12),!(!k|!i[o+28>>2]|(f|0)<=0))for(A=i[i[o+18588>>2]+124>>2],l=i[A+16832>>2],h=i[A+16840>>2],U=f&2147483646,G=f&1,r=0;;){if(m=g(r,f),A=0,e=0,(f|0)!=1)for(;_=A+m<<2,I=_+s|0,i[I>>2]=i[I>>2]+(g(i[o+28>>2],i[w+_>>2]<<h>>l)>>3),_=_+4|0,I=_+s|0,i[I>>2]=i[I>>2]+(g(i[o+28>>2],i[w+_>>2]<<h>>l)>>3),A=A+2|0,e=e+2|0,(U|0)!=(e|0););if(G&&(A=A+m<<2,e=A+s|0,i[e>>2]=i[e>>2]+(g(i[o+28>>2],i[A+w>>2]<<h>>l)>>3)),r=r+1|0,(f|0)==(r|0))break}if(W[i[i[o+18584>>2]+456>>2]](E,B,s,f,8),!x)break o;X[n>>1]=0,X[n+2>>1]=0,X[n+4>>1]=0,X[n+6>>1]=0,X[n+24>>1]=0,X[n+26>>1]=0,X[n+28>>1]=0,X[n+30>>1]=0,X[n+16>>1]=0,X[n+18>>1]=0,X[n+20>>1]=0,X[n+22>>1]=0,X[n+8>>1]=0,X[n+10>>1]=0,X[n+12>>1]=0,X[n+14>>1]=0;break o}if(l)break r;if(e=!(k|I)&(f|0)==4,u[m+8247|0]==1){r=0,w=v-4096|0,v=w,l=o+14404|0,A=k?w:l,h=i[o+18584>>2];l:{if(e){e=436;break l}e=440;u:switch(f-4|0){case 4:e=444;break l;case 12:e=448;break l;case 0:break l;default:break u}e=452}if(W[i[e+h>>2]](A,n,12,15),!(!k|!i[o+28>>2]|(f|0)<=0))for(e=i[i[o+18588>>2]+124>>2],n=i[e+16832>>2],s=i[e+16840>>2],U=f&2147483646,G=f&1;;){if(m=g(r,f),e=0,_=0,(f|0)!=1)for(;x=e+m<<2,I=x+A|0,i[I>>2]=i[I>>2]+(g(i[o+28>>2],i[l+x>>2]<<s>>n)>>3),x=x+4|0,I=x+A|0,i[I>>2]=i[I>>2]+(g(i[o+28>>2],i[l+x>>2]<<s>>n)>>3),e=e+2|0,_=_+2|0,(U|0)!=(_|0););if(G&&(e=e+m<<2,m=e+A|0,i[m>>2]=i[m>>2]+(g(i[o+28>>2],i[e+l>>2]<<s>>n)>>3)),r=r+1|0,(f|0)==(r|0))break}W[i[h+456>>2]](E,B,A,f,8),v=w+4096|0;break o}r=i[o+18584>>2]+172|0;l:{if(e){A=216;break l}A=220;u:switch(f-4|0){case 4:A=224;break l;case 12:A=228;break l;case 0:break l;default:break u}A=232}W[i[A+r>>2]](E,n,B)}if(A=o+(k<<1)|0,X[A+14396>>1]>0)for(e=A+14396|0,r=i[o+2104>>2],f=(o+8252|0)+(k<<11)|0,A=0;X[r+(X[f+(A<<1)>>1]<<1)>>1]=0,A=A+1|0,(A|0)<X[e>>1];);v=V+4096|0;break t}break f}}}return}U0(24033,19915,507,10958),M()}U0(24033,19915,377,10958),M()}U0(23814,19915,604,10958),M()}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function AA(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0;o=v-192|0,v=o,f=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+136>>2]=f,n=i[e+140>>2],i[e+140>>2]=k;i:{if(!n||(f=i[n+4>>2],i[n+4>>2]=f-1,f))break i;W[i[i[n>>2]+8>>2]](n),y(n)}i:{e:{r:{if(f=i[r>>2],k=i[f+36>>2],n=i[f+40>>2],(k|0)!=(n|0))for(;;){f:{if(f=i[k>>2],!f||(h=Z0(f,92792,111556),!h))break f;Y=i[k+4>>2],Y&&(i[Y+4>>2]=i[Y+4>>2]+2),i[e+144>>2]=h,k=i[e+148>>2],i[e+148>>2]=Y;A:{if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(i[e+24>>2]=i[h+120>>2],f=i[r>>2],k=i[f+36>>2],n=i[f+40>>2],(k|0)!=(n|0))break r;break e}if(k=k+8|0,(n|0)==(k|0))break}if(f=C(32),i[o+24>>2]=f,i[o+28>>2]=24,i[o+32>>2]=-2147483616,r=u[25067]|u[25068]<<8|(u[25069]<<16|u[25070]<<24),e=u[25063]|u[25064]<<8|(u[25065]<<16|u[25066]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+24|0]=0,r=u[25083]|u[25084]<<8|(u[25085]<<16|u[25086]<<24),e=u[25079]|u[25080]<<8|(u[25081]<<16|u[25082]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[25075]|u[25076]<<8|(u[25077]<<16|u[25078]<<24),e=u[25071]|u[25072]<<8|(u[25073]<<16|u[25074]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,a(A,2,0,o+24|0),t[o+35|0]>=0)break i;Z(i[o+24>>2]);break i}for(;;){r:{if(f=i[k>>2],!f||(f=Z0(f,92792,100048),!f))break r;R=i[k+4>>2],R&&(i[R+4>>2]=i[R+4>>2]+1),k=i[f+36>>2],n=i[f+40>>2];f:{if((k|0)!=(n|0))for(;;){A:{if(f=i[k>>2],!f||(f=Z0(f,92792,113444),!f))break A;if(s=i[k+4>>2],!s){s=0;break f}i[s+4>>2]=i[s+4>>2]+1;break f}if(k=k+8|0,(n|0)==(k|0))break}f=0}if(i[e+240>>2]=f,k=i[e+244>>2],i[e+244>>2]=s,!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break e;W[i[i[k>>2]+8>>2]](k),y(k);break e}if(k=k+8|0,(n|0)==(k|0))break}}k=i[r>>2],f=i[k+36>>2],s=i[k+40>>2];e:{if((f|0)!=(s|0))for(k=f;;){r:{if(n=i[k>>2],!n||(h=Z0(n,92792,99248),!h))break r;N=i[k+4>>2],N&&(i[N+4>>2]=i[N+4>>2]+1,f=i[r>>2],s=i[f+40>>2],f=i[f+36>>2]);f:{if((f|0)!=(s|0))for(;;){A:{if(k=i[f>>2],!k||(k=Z0(k,92792,113364),!k))break A;if(s=i[f+4>>2],!s){s=0;break f}i[s+4>>2]=i[s+4>>2]+1;break f}if(f=f+8|0,(s|0)==(f|0))break}s=0,k=0}i[e+248>>2]=k,k=i[e+252>>2],i[e+252>>2]=s;f:{if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break f;W[i[i[k>>2]+8>>2]](k),y(k)}f=i[h+36>>2],s=i[h+40>>2];f:{if((f|0)!=(s|0))for(k=f;;){A:{if(n=i[k>>2],!n||(n=Z0(n,92792,93396),!n))break A;U=i[k+4>>2],U&&(i[U+4>>2]=i[U+4>>2]+1,s=i[h+40>>2],f=i[h+36>>2]),i[e+28>>2]=i[n+108>>2];k:{if((f|0)!=(s|0))for(;;){n:{if(k=i[f>>2],!k||(k=Z0(k,92792,99408),!k))break n;if(s=i[f+4>>2],!s){s=0;break k}i[s+4>>2]=i[s+4>>2]+1;break k}if(f=f+8|0,(s|0)==(f|0))break}s=0,k=0}i[e+152>>2]=k,n=i[e+156>>2],i[e+156>>2]=s,n&&(f=i[n+4>>2],i[n+4>>2]=f-1,f||(W[i[i[n>>2]+8>>2]](n),y(n)),k=i[e+152>>2]);k:{if(!k){if(f=C(32),i[o+24>>2]=f,i[o+28>>2]=24,i[o+32>>2]=-2147483616,r=u[25017]|u[25018]<<8|(u[25019]<<16|u[25020]<<24),e=u[25013]|u[25014]<<8|(u[25015]<<16|u[25016]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+24|0]=0,r=u[25033]|u[25034]<<8|(u[25035]<<16|u[25036]<<24),e=u[25029]|u[25030]<<8|(u[25031]<<16|u[25032]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[25025]|u[25026]<<8|(u[25027]<<16|u[25028]<<24),e=u[25021]|u[25022]<<8|(u[25023]<<16|u[25024]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,a(A,2,0,o+24|0),t[o+35|0]>=0)break k;Z(i[o+24>>2]);break k}k=i[h+36>>2],n=i[h+40>>2];n:{if((k|0)!=(n|0))for(;;){t:{if(f=i[k>>2],!f||(f=Z0(f,92792,111636),!f))break t;if(s=i[k+4>>2],!s){s=0;break n}i[s+4>>2]=i[s+4>>2]+1;break n}if(k=k+8|0,(n|0)==(k|0))break}s=0,f=0}if(i[e+160>>2]=f,k=i[e+164>>2],i[e+164>>2]=s,k&&(f=i[k+4>>2],i[k+4>>2]=f-1,f||(W[i[i[k>>2]+8>>2]](k),y(k)),f=i[e+160>>2]),!f){if(f=C(32),i[o+24>>2]=f,i[o+28>>2]=24,i[o+32>>2]=-2147483616,r=u[25092]|u[25093]<<8|(u[25094]<<16|u[25095]<<24),e=u[25088]|u[25089]<<8|(u[25090]<<16|u[25091]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+24|0]=0,r=u[25108]|u[25109]<<8|(u[25110]<<16|u[25111]<<24),e=u[25104]|u[25105]<<8|(u[25106]<<16|u[25107]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[25100]|u[25101]<<8|(u[25102]<<16|u[25103]<<24),e=u[25096]|u[25097]<<8|(u[25098]<<16|u[25099]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,a(A,2,0,o+24|0),t[o+35|0]>=0)break k;Z(i[o+24>>2]);break k}n:{t:{if(f=i[e+152>>2],k=i[f+36>>2],n=i[f+40>>2],(k|0)!=(n|0))for(;;){o:{if(f=i[k>>2],!f||(V=Z0(f,92792,99568),!V))break o;x=i[k+4>>2],x&&(i[x+4>>2]=i[x+4>>2]+1),h=o+24|0;l:{u:{if(k=i[V+36>>2],n=i[V+40>>2],(k|0)!=(n|0)){if(f=i[k>>2],f&&(_=i[h+4>>2],B=Z0(f,92792,111876),B))break u;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(f=i[k>>2],f&&(_=0,B=Z0(f,92792,111876),B))break u;if(k=k+8|0,(n|0)==(k|0))break}i[h>>2]=0,i[h+4>>2]=0}i[h>>2]=0,i[h+4>>2]=0;break l}if(i[h+4>>2]=_,i[h>>2]=B,f=i[k+4>>2],i[h+4>>2]=f,!f)break l;i[f+4>>2]=i[f+4>>2]+1}if(Q8(e+184|0,h),g2(h),i[e+184>>2])break t;if(e=A,A=V2(h,25038),a(e,2,0,A),t[A+11|0]>=0)break n;Z(i[A>>2]);break n}if(k=k+8|0,(n|0)==(k|0))break}if(e=A,A=V2(o+24|0,24988),a(e,2,0,A),t[A+11|0]>=0)break k;Z(i[A>>2]);break k}h=o+24|0;t:{o:{if(k=i[V+36>>2],n=i[V+40>>2],(k|0)!=(n|0)){if(f=i[k>>2],f&&(_=i[h+4>>2],B=Z0(f,92792,112116),B))break o;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(f=i[k>>2],f&&(_=0,B=Z0(f,92792,112116),B))break o;if(k=k+8|0,(n|0)==(k|0))break}i[h>>2]=0,i[h+4>>2]=0}i[h>>2]=0,i[h+4>>2]=0;break t}if(i[h+4>>2]=_,i[h>>2]=B,f=i[k+4>>2],i[h+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(Q8(e+192|0,h),g2(h),!i[e+192>>2]){if(e=A,A=V2(h,25113),a(e,2,0,A),t[A+11|0]>=0)break n;Z(i[A>>2]);break n}h=o+24|0;t:{o:{if(k=i[V+36>>2],n=i[V+40>>2],(k|0)!=(n|0)){if(f=i[k>>2],f&&(_=i[h+4>>2],B=Z0(f,92792,112196),B))break o;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(f=i[k>>2],f&&(_=0,B=Z0(f,92792,112196),B))break o;if(k=k+8|0,(n|0)==(k|0))break}i[h>>2]=0,i[h+4>>2]=0}i[h>>2]=0,i[h+4>>2]=0;break t}if(i[h+4>>2]=_,i[h>>2]=B,f=i[k+4>>2],i[h+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(Q8(e+200|0,h),g2(h),!i[e+200>>2]){if(e=A,A=V2(h,24963),a(e,2,0,A),t[A+11|0]>=0)break n;Z(i[A>>2]);break n}h=o+24|0;t:{o:{if(k=i[V+36>>2],n=i[V+40>>2],(k|0)!=(n|0)){if(f=i[k>>2],f&&(_=i[h+4>>2],B=Z0(f,92792,112276),B))break o;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(f=i[k>>2],f&&(_=0,B=Z0(f,92792,112276),B))break o;if(k=k+8|0,(n|0)==(k|0))break}i[h>>2]=0,i[h+4>>2]=0}i[h>>2]=0,i[h+4>>2]=0;break t}if(i[h+4>>2]=_,i[h>>2]=B,f=i[k+4>>2],i[h+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(Q8(e+232|0,h),g2(h),!i[e+232>>2]){if(e=A,A=V2(h,24666),a(e,2,0,A),t[A+11|0]>=0)break n;Z(i[A>>2]);break n}h=o+24|0;t:{o:{if(k=i[V+36>>2],n=i[V+40>>2],(k|0)!=(n|0)){if(f=i[k>>2],f&&(B=i[h+4>>2],G=Z0(f,92792,111956),G))break o;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(f=i[k>>2],f&&(B=0,G=Z0(f,92792,111956),G))break o;if(k=k+8|0,(n|0)==(k|0))break}i[h>>2]=0,i[h+4>>2]=0}i[h>>2]=0,i[h+4>>2]=0;break t}if(i[h+4>>2]=B,i[h>>2]=G,f=i[k+4>>2],i[h+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(Q8(e+208|0,h),g2(h),f=i[e+208>>2],!f){if(e=A,A=V2(h,24759),a(e,2,0,A),t[A+11|0]>=0)break n;Z(i[A>>2]);break n}if((Gs(f)|0)!=i[i[e+232>>2]+108>>2]){if(e=A,A=V2(o+24|0,25298),a(e,2,0,A),t[A+11|0]>=0)break n;Z(i[A>>2]);break n}t:{if(f=i[e+216>>2],!f||(Gs(f)|0)==i[i[e+232>>2]+108>>2])break t;if(e=A,A=V2(o+24|0,25354),a(e,2,0,A),t[A+11|0]>=0)break n;Z(i[A>>2]);break n}A0=i[e+200>>2],i[o+176>>2]=0,q=e+104|0,t0=e+284|0,s=0,m=-1;t:{for(;;){if(i[A0+108>>2]-i[A0+104>>2]>>2>>>0>s>>>0){if(h=s+1|0,n=J5(i[e+192>>2],h),!n){if(e=A,A=V2(o+24|0,27061),a(e,2,0,A),t[A+11|0]>=0)break n;Z(i[A>>2]);break n}k=i[n+8>>2],i[o+32>>2]=k,f=i[n+4>>2],i[o+24>>2]=i[n>>2],i[o+28>>2]=f,f=i[e+184>>2],n=i[f+104>>2];o:{w=i[f+108>>2]-n>>3,f=k-1|0;l:{if(w>>>0<=f>>>0){i[o+140>>2]=0,i[o+144>>2]=0;break l}if(f=n+(f<<3)|0,k=i[f>>2],i[o+140>>2]=k,f=i[f+4>>2],i[o+144>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),k)break o}if(e=A,A=V2(o+48|0,26680),a(e,2,0,A),t[A+11|0]>=0)break t;Z(i[A>>2]);break t}o:{l:{if(_=i[k+36>>2],n=i[k+40>>2],(_|0)!=(n|0)){if(k=i[_>>2],k&&(f=i[o+132>>2],G=Z0(k,92792,112516),G))break l;if(_=_+8|0,(n|0)!=(_|0))for(;;){if(k=i[_>>2],k&&(f=0,G=Z0(k,92792,112516),G))break l;if(_=_+8|0,(n|0)==(_|0))break}i[o+128>>2]=0,i[o+132>>2]=0}i[o+128>>2]=0,i[o+132>>2]=0;break o}if(i[o+132>>2]=f,i[o+128>>2]=G,f=i[_+4>>2],i[o+132>>2]=f,!f)break o;i[f+4>>2]=i[f+4>>2]+1}if(k=i[o+128>>2],k){o:{if(t[k+115|0]>=0){i[o+56>>2]=i[k+112>>2],f=i[k+108>>2],i[o+48>>2]=i[k+104>>2],i[o+52>>2]=f;break o}T(o+48|0,i[k+104>>2],i[k+108>>2])}t[e+267|0]<0&&Z(i[e+256>>2]),f=i[o+52>>2],i[e+256>>2]=i[o+48>>2],i[e+260>>2]=f,i[e+264>>2]=i[o+56>>2]}if(g2(o+128|0),!i[t0>>2]){n=o+48|0;o:{l:{if(f=i[o+140>>2],_=i[f+36>>2],k=i[f+40>>2],(_|0)!=(k|0)){if(f=i[_>>2],f&&(G=i[n+4>>2],B=Z0(f,92792,92836),B))break l;if(_=_+8|0,(k|0)!=(_|0))for(;;){if(f=i[_>>2],f&&(G=0,B=Z0(f,92792,92836),B))break l;if(_=_+8|0,(k|0)==(_|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break o}if(i[n+4>>2]=G,i[n>>2]=B,f=i[_+4>>2],i[n+4>>2]=f,!f)break o;i[f+4>>2]=i[f+4>>2]+1}i[o+48>>2]&&qi(t0,n),g2(o+48|0)}if(o0[i[e+232>>2]+108>>2]<i[o+28>>2]+i[o+176>>2]>>>0){if(e=A,A=V2(o+48|0,24691),a(e,2,0,A),t[A+11|0]>=0)break t;Z(i[A>>2]);break t}f=i[i[e+200>>2]+104>>2],j=v-16|0,v=j,E=C(68),k=E,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=113672,n=i[(s<<2)+f>>2],f=0,c=i[o+28>>2],d=i[o+176>>2],l=i[e+24>>2],k=i[e+20>>2],i[j+8>>2]=i[e+232>>2],w=i[e+236>>2],i[j+12>>2]=w,w&&(i[w+4>>2]=i[w+4>>2]+1),_=0,w=E+12|0,i[w+12>>2]=0,i[w+16>>2]=0,i[w+20>>2]=0,i[w+24>>2]=0,i[w+8>>2]=l,i[w+4>>2]=k,i[w+16>>2]=d,i[w+28>>2]=0,i[w+32>>2]=0,i[w+36>>2]=0,i[w+40>>2]=0,i[w+44>>2]=0,i[w+48>>2]=0,B=0,i[w+52>>2]=0,i[w>>2]=113504,i[w+24>>2]=d,i[w+20>>2]=(d+c|0)-1;o:{l:{u:{if(c)for(;;){k=i[j+8>>2],O=i[k+104>>2],O||(O=i[(i[k+112>>2]+(d<<2)|0)+(_<<2)>>2]),k=i[w+36>>2];s:{if(k>>>0>B>>>0){i[B+8>>2]=O,i[B>>2]=n,i[B+4>>2]=f,B=B+16|0;break s}if(S=i[w+28>>2],G=B-S|0,I=G>>4,Q=I+1|0,Q>>>0>=268435456)break u;if(l=k-S|0,k=l>>3,Q=l>>>0>=2147483632?268435455:k>>>0>Q>>>0?k:Q,Q){if(Q>>>0>=268435456)break l;k=C(Q<<4)}else k=0;if(B=k+G|0,i[B+8>>2]=O,i[B>>2]=n,i[B+4>>2]=f,l=B-(I<<4)|0,G&&z(l,S,G),i[w+36>>2]=k+(Q<<4),B=B+16|0,i[w+32>>2]=B,i[w+28>>2]=l,!S)break s;Z(S)}if(i[w+32>>2]=B,n=n+O|0,f=n>>>0<O>>>0?f+1|0:f,_=_+1|0,(c|0)==(_|0))break}f=w;break o}s0(),M()}x0(),M()}n=i[j+12>>2];o:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break o;W[i[i[n>>2]+8>>2]](n),y(n)}i[o+132>>2]=E,i[o+128>>2]=f,v=j+16|0;o:{l:{if(f=i[o+140>>2],!f||(f=Z0(f,92792,112596),!f))break l;if(i[o+84>>2]=f,f=i[o+144>>2],i[o+88>>2]=f,!f)break o;i[f+4>>2]=i[f+4>>2]+1;break o}i[o+84>>2]=0,i[o+88>>2]=0}f=i[o+84>>2];o:{l:{if(!f)break l;if(!(!s|i[o+32>>2]!=(m|0))){k=i[o+128>>2],f=i[(i[q>>2]+(s<<3)|0)-8>>2],W[i[i[f>>2]+8>>2]](o+168|0,f),f=i[o+172>>2],i[o>>2]=i[o+168>>2],i[o+4>>2]=f,ku(k,o);break l}i[o+160>>2]=f,f=i[o+88>>2],i[o+164>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[o+164>>2],i[o+16>>2]=i[o+160>>2],i[o+20>>2]=f,w=v-16|0,v=w,n=i[o+16>>2];u:{if(t[n+143|0]>=0){i[w+8>>2]=i[n+140>>2],f=i[n+136>>2],i[w>>2]=i[n+132>>2],i[w+4>>2]=f;break u}T(w,i[n+132>>2],i[n+136>>2])}u:{s:{h:{w:{_:{if(f=i[n+16>>2],(f|0)<=1781689192){v:{B:{m:{g:{if((f|0)!=1635135537){if((f|0)==1635148593)break g;if((f|0)!=1752589105)break _;if(k=i[n+36>>2],n=i[n+40>>2],(k|0)!=(n|0))for(;;){Z:{if(f=i[k>>2],!f||(f=Z0(f,92792,104128),!f))break Z;if(n=i[k+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),l=C(96),i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=103600,n&&(i[n+4>>2]=i[n+4>>2]+1),k=l+16|0,i[l+72>>2]=0,i[l+64>>2]=0,i[l+68>>2]=0,i[l+24>>2]=0,i[l+28>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,i[l+80>>2]=0,i[l+84>>2]=0,i[l+92>>2]=n,i[l+88>>2]=f,t[l+32|0]=0,i[l+44>>2]=0,i[l+48>>2]=0,i[l+52>>2]=0,i[l+56>>2]=0,i[l+16>>2]=104216,!n)break m;if(i[n+4>>2]==-1&&(W[i[i[n>>2]+8>>2]](n),y(n)),i[o+76>>2]=l,i[o+72>>2]=k,f=i[n+4>>2],i[n+4>>2]=f-1,f)break u;W[i[i[n>>2]+8>>2]](n),y(n);break u}if(k=k+8|0,(n|0)==(k|0))break}i[o+72>>2]=0,i[o+76>>2]=0;break u}if(k=i[n+36>>2],n=i[n+40>>2],(k|0)!=(n|0))for(;;){Z:{if(f=i[k>>2],!f||(f=Z0(f,92792,104760),!f))break Z;if(n=i[k+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),l=C(96),i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=103640,n&&(i[n+4>>2]=i[n+4>>2]+1),k=l+16|0,i[l+72>>2]=0,i[l+64>>2]=0,i[l+68>>2]=0,i[l+24>>2]=0,i[l+28>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,i[l+80>>2]=0,i[l+84>>2]=0,i[l+92>>2]=n,i[l+88>>2]=f,t[l+32|0]=0,i[l+44>>2]=0,i[l+48>>2]=0,i[l+52>>2]=0,i[l+56>>2]=0,i[l+16>>2]=104632,!n)break B;if(i[n+4>>2]==-1&&(W[i[i[n>>2]+8>>2]](n),y(n)),i[o+76>>2]=l,i[o+72>>2]=k,f=i[n+4>>2],i[n+4>>2]=f-1,f)break u;W[i[i[n>>2]+8>>2]](n),y(n);break u}if(k=k+8|0,(n|0)==(k|0))break}i[o+72>>2]=0,i[o+76>>2]=0;break u}if(k=i[n+36>>2],n=i[n+40>>2],(k|0)!=(n|0))for(;;){g:{if(f=i[k>>2],!f||(f=Z0(f,92792,106984),!f))break g;if(n=i[k+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),l=C(96),i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=103680,n&&(i[n+4>>2]=i[n+4>>2]+1),k=l+16|0,i[l+72>>2]=0,i[l+64>>2]=0,i[l+68>>2]=0,i[l+24>>2]=0,i[l+28>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,i[l+80>>2]=0,i[l+84>>2]=0,i[l+92>>2]=n,i[l+88>>2]=f,t[l+32|0]=0,i[l+44>>2]=0,i[l+48>>2]=0,i[l+52>>2]=0,i[l+56>>2]=0,i[l+16>>2]=107004,!n)break v;if(i[n+4>>2]==-1&&(W[i[i[n>>2]+8>>2]](n),y(n)),i[o+76>>2]=l,i[o+72>>2]=k,f=i[n+4>>2],i[n+4>>2]=f-1,f)break u;W[i[i[n>>2]+8>>2]](n),y(n);break u}if(k=k+8|0,(n|0)==(k|0))break}i[o+72>>2]=0,i[o+76>>2]=0;break u}i[o+76>>2]=l,i[o+72>>2]=k;break u}i[o+76>>2]=l,i[o+72>>2]=k;break u}i[o+76>>2]=l,i[o+72>>2]=k;break u}v:{if((f|0)!=1781689193){if((f|0)==1835692135)break v;if((f|0)!=1987470129)break _;if(k=i[n+36>>2],n=i[n+40>>2],(k|0)!=(n|0))for(;;){B:{if(f=i[k>>2],!f||(f=Z0(f,92792,106644),!f))break B;if(n=i[k+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),l=C(96),i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=103760,n&&(i[n+4>>2]=i[n+4>>2]+1),k=l+16|0,i[l+72>>2]=0,i[l+64>>2]=0,i[l+68>>2]=0,i[l+24>>2]=0,i[l+28>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,i[l+80>>2]=0,i[l+84>>2]=0,i[l+92>>2]=n,i[l+88>>2]=f,t[l+32|0]=0,i[l+44>>2]=0,i[l+48>>2]=0,i[l+52>>2]=0,i[l+56>>2]=0,i[l+16>>2]=106444,!n)break w;if(i[n+4>>2]==-1&&(W[i[i[n>>2]+8>>2]](n),y(n)),i[o+76>>2]=l,i[o+72>>2]=k,f=i[n+4>>2],i[n+4>>2]=f-1,f)break u;W[i[i[n>>2]+8>>2]](n),y(n);break u}if(k=k+8|0,(n|0)==(k|0))break}i[o+72>>2]=0,i[o+76>>2]=0;break u}k=i[n+36>>2],n=i[n+40>>2];B:{if((k|0)!=(n|0))for(;;){m:{if(f=i[k>>2],!f||(f=Z0(f,92792,106196),!f))break m;if(s=i[k+4>>2],!s){s=0;break B}i[s+4>>2]=i[s+4>>2]+1;break B}if(k=k+8|0,(n|0)==(k|0))break}s=0,f=0}if(n=C(96),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=103720,s&&(i[s+4>>2]=i[s+4>>2]+1),k=n+16|0,i[n+72>>2]=0,i[n+64>>2]=0,i[n+68>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+80>>2]=0,i[n+84>>2]=0,i[n+92>>2]=s,i[n+88>>2]=f,t[n+32|0]=0,i[n+44>>2]=0,i[n+48>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+16>>2]=105620,!s)break h;if(i[s+4>>2]==-1&&(W[i[i[s>>2]+8>>2]](s),y(s)),i[o+76>>2]=n,i[o+72>>2]=k,f=i[s+4>>2],i[s+4>>2]=f-1,f)break u;W[i[i[s>>2]+8>>2]](s),y(s);break u}k=i[n+36>>2],n=i[n+40>>2];v:{if((k|0)!=(n|0))for(;;){B:{if(f=i[k>>2],!f||(s=Z0(f,92792,105228),!s))break B;if(f=i[k+4>>2],!f){f=0;break v}i[f+4>>2]=i[f+4>>2]+1;break v}if(k=k+8|0,(n|0)==(k|0))break}f=0,s=0}if(l=C(120),i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=103800,f&&(i[f+4>>2]=i[f+4>>2]+1),n=l+16|0,i[l+72>>2]=0,i[l+64>>2]=0,i[l+68>>2]=0,i[l+24>>2]=0,i[l+28>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,i[l+80>>2]=0,i[l+84>>2]=0,i[l+92>>2]=f,i[l+88>>2]=s,t[l+32|0]=0,i[l+44>>2]=0,i[l+48>>2]=0,i[l+52>>2]=0,i[l+56>>2]=0,i[l+16>>2]=105248,!f)break s;if(i[f+4>>2]=i[f+4>>2]+1,t[l+112|0]=0,t[l+96|0]=0,k=i[f+4>>2],i[f+4>>2]=k-1,k||(W[i[i[f>>2]+8>>2]](f),y(f)),i[o+76>>2]=l,i[o+72>>2]=n,k=i[f+4>>2],i[f+4>>2]=k-1,k)break u;W[i[i[f>>2]+8>>2]](f),y(f);break u}i[o+72>>2]=0,i[o+76>>2]=0;break u}i[o+76>>2]=l,i[o+72>>2]=k;break u}i[o+76>>2]=n,i[o+72>>2]=k;break u}t[l+112|0]=0,t[l+96|0]=0,i[o+76>>2]=l,i[o+72>>2]=n}t[w+11|0]<0&&Z(i[w>>2]),k=i[o+20>>2];u:{if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break u;W[i[i[k>>2]+8>>2]](k),y(k)}if(v=w+16|0,f=i[o+72>>2],!f){f=V2(o+48|0,24199),a(A,2,0,f),t[o+59|0]<0&&Z(i[f>>2]),g2(o+72|0),g2(o+84|0),f=0;break o}i[o+152>>2]=f,f=i[o+76>>2],i[o+156>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),k=i[o+128>>2],f=i[o+156>>2],i[o+8>>2]=i[o+152>>2],i[o+12>>2]=f,ku(k,o+8|0),g2(o+72|0)}g2(o+84|0),P0(q,o+128|0),i[o+176>>2]=i[o+176>>2]+i[o+28>>2],m=i[o+32>>2],f=1}if(g2(o+128|0),g2(o+140|0),s=h,f)continue;break n}break}if(i[o+176>>2]!=i[i[e+232>>2]+108>>2]){if(e=A,A=V2(o+24|0,29202),a(e,2,0,A),t[A+11|0]>=0)break n;Z(i[A>>2]);break n}if(w=v-16|0,v=w,n=o+140|0,i[n+8>>2]=0,i[n>>2]=0,i[n+4>>2]=0,_=i[V+36>>2],k=i[V+40>>2],(_|0)!=(k|0))for(;;){f=i[_>>2];o:{if(!f||(f=Z0(f,92792,113124),!f)||(i[w+8>>2]=f,f=i[_+4>>2],i[w+12>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),P0(n,w+8|0),h=i[w+12>>2],!h)||(f=i[h+4>>2],i[h+4>>2]=f-1,f))break o;W[i[i[h>>2]+8>>2]](h),y(h)}if(_=_+8|0,(k|0)==(_|0))break}if(v=w+16|0,w=v-16|0,v=w,n=o+128|0,i[n+8>>2]=0,i[n>>2]=0,i[n+4>>2]=0,s=i[V+36>>2],k=i[V+40>>2],(s|0)!=(k|0))for(;;){f=i[s>>2];o:{if(!f||(f=Z0(f,92792,113204),!f)||(i[w+8>>2]=f,f=i[s+4>>2],i[w+12>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),P0(n,w+8|0),h=i[w+12>>2],!h)||(f=i[h+4>>2],i[h+4>>2]=f-1,f))break o;W[i[i[h>>2]+8>>2]](h),y(h)}if(s=s+8|0,(k|0)==(s|0))break}v=w+16|0;o:{l:{u:{if(I=i[o+144>>2],k=i[o+140>>2],(i[o+132>>2]-i[o+128>>2]|0)==(I-k|0)){if((k|0)!=(I|0))for(s=e+280|0,l=e+276|0;;){if(f=i[k>>2],w=i[f+108>>2],Q=i[f+104>>2],i[o+48>>2]=0,i[o+52>>2]=0,f=i[o+128>>2],h=i[o+132>>2],(f|0)==(h|0))break u;for(;;){if(n=i[f>>2],!((Q|0)==i[n+104>>2]&(w|0)==i[n+108>>2])){if(f=f+8|0,(h|0)!=(f|0))continue;break u}break}if(qi(o+48|0,f),f=i[o+48>>2],!f)break u;s:{if(f=i[f+132>>2]-i[f+128>>2]|0,(f|0)==8){f=i[k>>2];break s}if(h=f>>3,f=i[e+200>>2],(h|0)!=i[f+108>>2]-i[f+104>>2]>>2){if(e=A,A=V2(o+24|0,24883),a(e,2,0,A),t[A+11|0]>=0)break l;Z(i[A>>2]);break l}if(f=i[k>>2],!i[f+116>>2]|i[e+104>>2]!=i[e+108>>2])break s;if(e=A,A=V2(o+24|0,25163),a(e,2,0,A),t[A+11|0]>=0)break l;Z(i[A>>2]);break l}if(o0[f+116>>2]>o0[i[e+232>>2]+108>>2]){if(e=A,A=V2(o+24|0,26297),a(e,2,0,A),t[A+11|0]>=0)break l;Z(i[A>>2]);break l}s:{if((Q|0)!=1937006953){if((Q|0)!=1937074532)break s;f=Ln(k,o+48|0,q),i[o+24>>2]=0,zi(s,f),zi(o+24|0,0);break s}f=Ln(k,o+48|0,q),i[o+24>>2]=0,zi(l,f),zi(o+24|0,0)}if(g2(o+48|0),k=k+8|0,(I|0)==(k|0))break}s:{h:{if(f=i[r>>2],r=i[f+36>>2],n=i[f+40>>2],(r|0)!=(n|0)){if(k=i[r>>2],k&&(f=i[o+124>>2],s=Z0(k,92792,93316),s))break h;if(r=r+8|0,(n|0)!=(r|0))for(;;){if(k=i[r>>2],k&&(f=0,s=Z0(k,92792,93316),s))break h;if(r=r+8|0,(n|0)==(r|0))break}i[o+120>>2]=0,i[o+124>>2]=0}i[o+120>>2]=0,i[o+124>>2]=0;break s}if(i[o+124>>2]=f,i[o+120>>2]=s,r=i[r+4>>2],i[o+124>>2]=r,!r)break s;i[r+4>>2]=i[r+4>>2]+1}s:{if(f=i[o+120>>2],f){h:{w:{if(r=i[f+36>>2],n=i[f+40>>2],(r|0)!=(n|0)){if(k=i[r>>2],k&&(f=i[o+116>>2],s=Z0(k,92792,95888),s))break w;if(r=r+8|0,(n|0)!=(r|0))for(;;){if(k=i[r>>2],k&&(f=0,s=Z0(k,92792,95888),s))break w;if(r=r+8|0,(n|0)==(r|0))break}i[o+112>>2]=0,i[o+116>>2]=0}i[o+112>>2]=0,i[o+116>>2]=0;break h}if(i[o+116>>2]=f,i[o+112>>2]=s,r=i[r+4>>2],i[o+116>>2]=r,!r)break h;i[r+4>>2]=i[r+4>>2]+1}h:{w:{if(f=i[o+120>>2],r=i[f+36>>2],n=i[f+40>>2],(r|0)!=(n|0)){if(k=i[r>>2],k&&(f=i[o+108>>2],s=Z0(k,92792,94424),s))break w;if(r=r+8|0,(n|0)!=(r|0))for(;;){if(k=i[r>>2],k&&(f=0,s=Z0(k,92792,94424),s))break w;if(r=r+8|0,(n|0)==(r|0))break}i[o+104>>2]=0,i[o+108>>2]=0}i[o+104>>2]=0,i[o+108>>2]=0;break h}if(i[o+108>>2]=f,i[o+104>>2]=s,r=i[r+4>>2],i[o+108>>2]=r,!r)break h;i[r+4>>2]=i[r+4>>2]+1}if(Vl(o+96|0,i[o+120>>2]),r=i[o+96>>2],r){if(w=v-16|0,v=w,n=o+84|0,i[n+8>>2]=0,i[n>>2]=0,i[n+4>>2]=0,f=i[r+36>>2],k=i[r+40>>2],(f|0)!=(k|0))for(;;){r=i[f>>2];h:{if(!r||(r=Z0(r,92792,93556),!r)||(i[w+8>>2]=r,r=i[f+4>>2],i[w+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),P0(n,w+8|0),h=i[w+12>>2],!h)||(r=i[h+4>>2],i[h+4>>2]=r-1,r))break h;W[i[i[h>>2]+8>>2]](h),y(h)}if(f=f+8|0,(k|0)==(f|0))break}if(v=w+16|0,f=i[o+84>>2],s=i[o+88>>2],(f|0)!=(s|0))for(l=e+52|0,r=i[28406],w=i[28407];;){k=i[f>>2];h:{if(i[k+112>>2]!=1970432288||!_r(k+152|0,23243))break h;if(h=i[i[f>>2]+104>>2],i[o+80>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,n=i[o+112>>2],k=i[e+20>>2],I=i[k+48>>2],i[o+184>>2]=I,k=i[k+52>>2],i[o+188>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),i[o+24>>2]=i[I+8>>2],k=i[I+12>>2],i[o+28>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),E=h,h=o+24|0,k=o+72|0,gi(o+48|0,n,E,h,o+104|0,k,i[e+20>>2]- -64|0),g2(h),n=o+184|0,g2(n),ZA(h,k),u[o+44|0])break s;if(Eu(l,h),k=u[o+44|0],(k|0)!=255&&(i[o+184>>2]=r,i[o+188>>2]=w,W[i[n+(k<<2)>>2]](o+183|0,h)),t[o+67|0]<0&&Z(i[o+56>>2]),k=i[o+72>>2],!k)break h;i[o+76>>2]=k,Z(k)}if(f=f+8|0,(s|0)==(f|0))break}U5(o+84|0)}g2(o+96|0),g2(o+104|0),g2(o+112|0)}if(g2(o+120|0),r=i[i[e+20>>2]+144>>2],!(!r|r>>>0>=o0[i[e+232>>2]+108>>2])){if(e=A,A=V2(o+24|0,18939),a(e,6,1e3,A),t[A+11|0]>=0)break o;Z(i[A>>2]);break o}l=o+24|0,s=0,k=0,G=0,_=0,n=0,f=0,B=0,m=v-48|0,v=m,h=e,r=i[i[e+232>>2]+108>>2],i[e+64>>2]=r,h=e;h:{w:{_:{v:{B:{m:{if(!r){e=0;break m}for(e=0;;){w=k,i[m+20>>2]=0,i[m+24>>2]=0,i[m+28>>2]=0,i[m+32>>2]=0,E=j5(i[h+208>>2],B);g:{I=i[h+104>>2],r=i[h+108>>2]-I>>3;Z:{if(r>>>0<=_>>>0)break Z;if(o0[i[I+(_<<3)>>2]+20>>2]>=B>>>0){k=k+1|0;break g}if(_=_+1|0,(r|0)==(_|0))break Z;for(;;){if(o0[i[I+(_<<3)>>2]+20>>2]>=B>>>0){k=0;break g}if(_=_+1|0,(r|0)==(_|0))break}}if(i[m+44>>2]=G,i[m+40>>2]=s,i[m+36>>2]=e,k=C(40),i[m+4>>2]=k,i[m+8>>2]=32,i[m+12>>2]=-2147483608,f=u[27056]|u[27057]<<8|(u[27058]<<16|u[27059]<<24),r=u[27052]|u[27053]<<8|(u[27054]<<16|u[27055]<<24),t[k+24|0]=r,t[k+25|0]=r>>>8,t[k+26|0]=r>>>16,t[k+27|0]=r>>>24,t[k+28|0]=f,t[k+29|0]=f>>>8,t[k+30|0]=f>>>16,t[k+31|0]=f>>>24,f=u[27048]|u[27049]<<8|(u[27050]<<16|u[27051]<<24),r=u[27044]|u[27045]<<8|(u[27046]<<16|u[27047]<<24),t[k+16|0]=r,t[k+17|0]=r>>>8,t[k+18|0]=r>>>16,t[k+19|0]=r>>>24,t[k+20|0]=f,t[k+21|0]=f>>>8,t[k+22|0]=f>>>16,t[k+23|0]=f>>>24,f=u[27040]|u[27041]<<8|(u[27042]<<16|u[27043]<<24),r=u[27036]|u[27037]<<8|(u[27038]<<16|u[27039]<<24),t[k+8|0]=r,t[k+9|0]=r>>>8,t[k+10|0]=r>>>16,t[k+11|0]=r>>>24,t[k+12|0]=f,t[k+13|0]=f>>>8,t[k+14|0]=f>>>16,t[k+15|0]=f>>>24,f=u[27032]|u[27033]<<8|(u[27034]<<16|u[27035]<<24),r=u[27028]|u[27029]<<8|(u[27030]<<16|u[27031]<<24),t[k|0]=r,t[k+1|0]=r>>>8,t[k+2|0]=r>>>16,t[k+3|0]=r>>>24,t[k+4|0]=f,t[k+5|0]=f>>>8,t[k+6|0]=f>>>16,t[k+7|0]=f>>>24,t[k+32|0]=0,a(l,2,0,m+4|0),t[m+15|0]>=0)break h;Z(i[m+4>>2]);break h}g:{if(s>>>0<G>>>0){i[s+8>>2]=_,i[s+4>>2]=w,i[s>>2]=B,r=i[m+20>>2],i[s+12>>2]=i[m+16>>2],i[s+16>>2]=r,r=i[m+28>>2],i[s+20>>2]=i[m+24>>2],i[s+24>>2]=r,i[s+28>>2]=i[m+32>>2],i[s+44>>2]=0,i[s+40>>2]=E,i[s+32>>2]=n,i[s+36>>2]=f,s=s+48|0;break g}if(Q=s-e|0,I=((Q|0)/48|0)+1|0,I>>>0>=89478486)break B;if(s=(G-e|0)/48|0,r=s<<1,I=s>>>0>=44739242?89478485:r>>>0>I>>>0?r:I,I){if(I>>>0>=89478486)break v;r=C(g(I,48))}else r=0;s=r+Q|0,i[s+8>>2]=_,i[s+4>>2]=w,i[s>>2]=B,w=i[m+20>>2],i[s+12>>2]=i[m+16>>2],i[s+16>>2]=w,w=i[m+28>>2],i[s+20>>2]=i[m+24>>2],i[s+24>>2]=w,i[s+28>>2]=i[m+32>>2],i[s+44>>2]=0,i[s+40>>2]=E,i[s+32>>2]=n,i[s+36>>2]=f,w=s+g((Q|0)/-48|0,48)|0,Q&&z(w,e,Q),s=s+48|0,G=r+g(I,48)|0,e&&Z(e),e=w}if(n=n+E|0,f=n>>>0<E>>>0?f+1|0:f,B=B+1|0,!(B>>>0<o0[h+64>>2]))break}}i[m+44>>2]=G,i[m+40>>2]=s,i[m+36>>2]=e;m:{if(r=ju(i[h+20>>2]),k=i[h+160>>2],(r|0)!=i[k+120>>2]||(n=i[h+240>>2],!n)||(f=i[n+104>>2],(i[n+108>>2]-f|0)!=24|(i[f+8>>2]|i[f+12>>2]))||(r=i[f>>2],f=i[f+4>>2],!(t[n+100|0]&1)|((r|0)!=i[k+128>>2]|(f|0)!=i[k+132>>2])))break m;if(k=h+68|0,(k|0)!=(m+36|0)&&(Co(k,e,s,(s-e|0)/48|0),e=i[h+160>>2],r=i[e+128>>2],f=i[e+132>>2]),r|f)break _;e=V2(m+16|0,26619),a(l,2,0,e),t[e+11|0]<0&&Z(i[e>>2]),e=i[m+36>>2];break h}r=h+68|0,(r|0)!=(m+36|0)&&(Co(r,e,s,(s-e|0)/48|0),s=i[m+40>>2],e=i[m+36>>2]),i[h+80>>2]=(s-e|0)/48,i[h+84>>2]=0,r=!i[h+240>>2];break w}i[m+44>>2]=G,i[m+40>>2]=s,i[m+36>>2]=e,s0(),M()}x0(),M()}r=pu(i[h+20>>2]),e=i[h+160>>2],f=O1(r,h0,i[e+128>>2],i[e+132>>2]),n=h0,e=i[m+36>>2],_0=h,g0=L0(f,n,(i[m+40>>2]-e|0)/48|0,0),i[_0+80>>2]=g0,i[h+84>>2]=h0,r=i[i[h+20>>2]+48>>2],k=i[r+160>>2],w=i[r+164>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),k?(r=u[k+97|0]==1,r=i[k+128>>2]==-1&i[k+132>>2]==((r?-1:0)|0)):r=0;_:{if(!w||(k=i[w+4>>2],i[w+4>>2]=k-1,k))break _;W[i[i[w>>2]+8>>2]](w),y(w)}r=!n&(f|0)==-1|n||r?-1:f}i[h+88>>2]=r,i[l>>2]=0,i[l+4>>2]=0,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0}if(e&&(i[m+40>>2]=e,Z(e)),v=m+48|0,i[o+24>>2]){e=i[o+28>>2],i[A>>2]=i[o+24>>2],i[A+4>>2]=e,e=i[o+36>>2],i[A+8>>2]=i[o+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[o+40>>2];break o}if(i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,t[o+43|0]>=0)break o;Z(i[o+32>>2]);break o}e2(),M()}if(e=A,A=V2(o+24|0,25763),a(e,2,0,A),t[A+11|0]>=0)break o;Z(i[A>>2]);break o}if(e=A,A=V2(o+24|0,24923),a(e,2,0,A),t[A+11|0]>=0)break l;Z(i[A>>2])}g2(o+48|0)}U5(o+128|0),U5(o+140|0);break n}g2(o+140|0)}if(!x||(A=i[x+4>>2],i[x+4>>2]=A-1,A))break k;W[i[i[x>>2]+8>>2]](x),y(x)}if(!U||(A=i[U+4>>2],i[U+4>>2]=A-1,A))break f;W[i[i[U>>2]+8>>2]](U),y(U);break f}if(k=k+8|0,(s|0)==(k|0))break}if(f=C(32),i[o+24>>2]=f,i[o+28>>2]=24,i[o+32>>2]=-2147483616,r=u[24788]|u[24789]<<8|(u[24790]<<16|u[24791]<<24),e=u[24784]|u[24785]<<8|(u[24786]<<16|u[24787]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+24|0]=0,r=u[24804]|u[24805]<<8|(u[24806]<<16|u[24807]<<24),e=u[24800]|u[24801]<<8|(u[24802]<<16|u[24803]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[24796]|u[24797]<<8|(u[24798]<<16|u[24799]<<24),e=u[24792]|u[24793]<<8|(u[24794]<<16|u[24795]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,a(A,2,0,o+24|0),t[o+35|0]>=0)break f;Z(i[o+24>>2])}if(!N||(A=i[N+4>>2],i[N+4>>2]=A-1,A))break e;W[i[i[N>>2]+8>>2]](N),y(N);break e}if(k=k+8|0,(s|0)==(k|0))break}if(f=C(32),i[o+24>>2]=f,i[o+28>>2]=24,i[o+32>>2]=-2147483616,r=u[25142]|u[25143]<<8|(u[25144]<<16|u[25145]<<24),e=u[25138]|u[25139]<<8|(u[25140]<<16|u[25141]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+24|0]=0,r=u[25158]|u[25159]<<8|(u[25160]<<16|u[25161]<<24),e=u[25154]|u[25155]<<8|(u[25156]<<16|u[25157]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[25150]|u[25151]<<8|(u[25152]<<16|u[25153]<<24),e=u[25146]|u[25147]<<8|(u[25148]<<16|u[25149]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,a(A,2,0,o+24|0),t[o+35|0]>=0)break e;Z(i[o+24>>2])}e:{if(!R||(A=i[R+4>>2],i[R+4>>2]=A-1,A))break e;W[i[i[R>>2]+8>>2]](R),y(R)}if(!Y||(A=i[Y+4>>2],i[Y+4>>2]=A-1,A))break i;W[i[i[Y>>2]+8>>2]](Y),y(Y)}v=o+192|0}function nv(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=0;E=v+-64|0,v=E,G=i[e+196>>2],B=o+4|0,w=B,m=w,l=i[o+4>>2];i:{e:{r:{if(!l)break r;for(m=l;s=G>>>0>o0[m+16>>2],w=s?w:m,m=i[(s?4:0)+m>>2],!!m;);if(!((w|0)==(B|0)|G>>>0<o0[w+16>>2])){f=C(32),i[E+28>>2]=f,i[E+32>>2]=28,i[E+36>>2]=-2147483616,e=u[6467]|u[6468]<<8|(u[6469]<<16|u[6470]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,r=u[6463]|u[6464]<<8|(u[6465]<<16|u[6466]<<24),e=u[6459]|u[6460]<<8|(u[6461]<<16|u[6462]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[6455]|u[6456]<<8|(u[6457]<<16|u[6458]<<24),e=u[6451]|u[6452]<<8|(u[6453]<<16|u[6454]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,r=u[6447]|u[6448]<<8|(u[6449]<<16|u[6450]<<24),e=u[6443]|u[6444]<<8|(u[6445]<<16|u[6446]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+28|0]=0,f=a(E+40|0,2,0,E+28|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(t[E+39|0]>=0)break i;Z(i[E+28>>2]);break i}for(;;){if(m=l,s=i[l+16>>2],s>>>0>G>>>0){if(w=l,l=i[l>>2],l)continue;break r}if(s>>>0>=G>>>0)break e;if(l=i[m+4>>2],!l)break}w=m+4|0}l=C(20),i[l+8>>2]=m,i[l>>2]=0,i[l+4>>2]=0,i[l+16>>2]=G,i[w>>2]=l,s=i[i[o>>2]>>2],s&&(i[o>>2]=s),G1(i[o+4>>2],l),i[o+8>>2]=i[o+8>>2]+1}if(f){i[E+20>>2]=0,i[E+24>>2]=0,i[E+16>>2]=E+20,l=E+16|0,W8(l,i[o>>2],B),s=v-48|0,v=s,k=g(p[e+554>>1],n)+k|0,o=i[e+564>>2];e:{if(k>>>0>=i[e+568>>2]-o>>2>>>0){f=C(40),i[s+12>>2]=f,i[s+16>>2]=33,i[s+20>>2]=-2147483608,t[f+32|0]=u[15237],r=u[15233]|u[15234]<<8|(u[15235]<<16|u[15236]<<24),e=u[15229]|u[15230]<<8|(u[15231]<<16|u[15232]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,t[f+28|0]=r,t[f+29|0]=r>>>8,t[f+30|0]=r>>>16,t[f+31|0]=r>>>24,r=u[15225]|u[15226]<<8|(u[15227]<<16|u[15228]<<24),e=u[15221]|u[15222]<<8|(u[15223]<<16|u[15224]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[15217]|u[15218]<<8|(u[15219]<<16|u[15220]<<24),e=u[15213]|u[15214]<<8|(u[15215]<<16|u[15216]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,r=u[15209]|u[15210]<<8|(u[15211]<<16|u[15212]<<24),e=u[15205]|u[15206]<<8|(u[15207]<<16|u[15208]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+33|0]=0,f=a(s+24|0,2,119,s+12|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(t[s+23|0]>=0)break e;Z(i[s+12>>2]);break e}f=s+24|0,$1(f,i[e+180>>2],i[o+(k<<2)>>2],1),k=i[s+28>>2],e=i[s+24>>2];r:{if(!e){n=C(48),i[s+12>>2]=n,i[s+16>>2]=40,i[s+20>>2]=-2147483600,r=u[10379]|u[10380]<<8|(u[10381]<<16|u[10382]<<24),e=u[10375]|u[10376]<<8|(u[10377]<<16|u[10378]<<24),t[n+32|0]=e,t[n+33|0]=e>>>8,t[n+34|0]=e>>>16,t[n+35|0]=e>>>24,t[n+36|0]=r,t[n+37|0]=r>>>8,t[n+38|0]=r>>>16,t[n+39|0]=r>>>24,r=u[10371]|u[10372]<<8|(u[10373]<<16|u[10374]<<24),e=u[10367]|u[10368]<<8|(u[10369]<<16|u[10370]<<24),t[n+24|0]=e,t[n+25|0]=e>>>8,t[n+26|0]=e>>>16,t[n+27|0]=e>>>24,t[n+28|0]=r,t[n+29|0]=r>>>8,t[n+30|0]=r>>>16,t[n+31|0]=r>>>24,r=u[10363]|u[10364]<<8|(u[10365]<<16|u[10366]<<24),e=u[10359]|u[10360]<<8|(u[10361]<<16|u[10362]<<24),t[n+16|0]=e,t[n+17|0]=e>>>8,t[n+18|0]=e>>>16,t[n+19|0]=e>>>24,t[n+20|0]=r,t[n+21|0]=r>>>8,t[n+22|0]=r>>>16,t[n+23|0]=r>>>24,r=u[10355]|u[10356]<<8|(u[10357]<<16|u[10358]<<24),e=u[10351]|u[10352]<<8|(u[10353]<<16|u[10354]<<24),t[n+8|0]=e,t[n+9|0]=e>>>8,t[n+10|0]=e>>>16,t[n+11|0]=e>>>24,t[n+12|0]=r,t[n+13|0]=r>>>8,t[n+14|0]=r>>>16,t[n+15|0]=r>>>24,r=u[10347]|u[10348]<<8|(u[10349]<<16|u[10350]<<24),e=u[10343]|u[10344]<<8|(u[10345]<<16|u[10346]<<24),t[n|0]=e,t[n+1|0]=e>>>8,t[n+2|0]=e>>>16,t[n+3|0]=e>>>24,t[n+4|0]=r,t[n+5|0]=r>>>8,t[n+6|0]=r>>>16,t[n+7|0]=r>>>24,t[n+40|0]=0,f=a(f,2,119,s+12|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(t[s+23|0]>=0)break r;Z(i[s+12>>2]);break r}if(W[i[i[e>>2]+88>>2]](s+24|0,e),i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,r=A+8|0,t[s+43|0]>=0){e=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+40>>2],t[A+20|0]=1;break r}if(T(r,i[s+32>>2],i[s+36>>2]),e=t[s+43|0],t[A+20|0]=1,(e|0)>=0)break r;Z(i[s+32>>2]);break r}t[s+43|0]<0&&Z(i[s+32>>2]),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=s+4,W8(s,i[l>>2],l+4|0),W[i[i[e>>2]+144>>2]](A,e,r,0,0,0,s),S1(s,i[s+4>>2])}if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break e;W[i[i[k>>2]+8>>2]](k),y(k)}v=s+48|0,S1(l,i[E+20>>2]);break i}i[E+8>>2]=0,i[E+12>>2]=0,i[E+4>>2]=E+8,r2=E+4|0,W8(r2,i[o>>2],B),f=0,h=v-240|0,v=h,i[h+232>>2]=0,i[h+236>>2]=0;e:{r:{f:{A:{k:{if(k=i[e+564>>2],o=i[e+568>>2],(k|0)==(o|0))break k;for(;;){if(n=i[k>>2],yu(i[e+180>>2],n)){if(k=k+4|0,(o|0)!=(k|0))continue;break k}break}i[h+172>>2]=0,i[h+144>>2]=78164,i[h+88>>2]=78144,e=i[19545],i[h+80>>2]=e,k=h+80|0,i[k+i[e-12>>2]>>2]=i[19546],i[h+84>>2]=0,e=k+i[i[h+80>>2]-12>>2]|0,f=h+92|0,J0(e,f),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[h+88>>2]=e,r=h+88|0,i[r+i[e-12>>2]>>2]=i[19548],e=i[19544],i[h+80>>2]=e,i[k+i[e-12>>2]>>2]=i[19549],i[h+144>>2]=78164,i[h+80>>2]=78124,i[h+88>>2]=78144,k=R0(f),i[k>>2]=77200,i[h+132>>2]=0,i[h+136>>2]=0,i[h+124>>2]=0,i[h+128>>2]=0,i[h+140>>2]=24,F(B0(F(r,22838,14),n),28051,23),e=i[h+140>>2];n:{if(e&16){o=h+112|0,e=i[h+136>>2],r=i[h+116>>2],e>>>0<r>>>0&&(i[h+136>>2]=r,e=r);break n}if(!(e&8)){e=0,t[h+55|0]=0,o=h+44|0;break r}o=h+100|0,e=i[h+108>>2]}if(f=i[o>>2],e=e-f|0,e>>>0>=2147483640)break A;if(e>>>0>=11){r=e|7,o=C(r+1|0),i[h+52>>2]=r-2147483647,i[h+44>>2]=o,i[h+48>>2]=e;break f}if(t[h+55|0]=e,o=h+44|0,e)break f;e=0;break r}Ii(h+80|0,i[e+180>>2]- -64|0,i[e+556>>2],i[e+560>>2]);k:{if(i[h+80>>2]){e=i[h+84>>2],i[A>>2]=i[h+80>>2],i[A+4>>2]=e,r=A+8|0;n:{if(t[h+99|0]>=0){e=i[h+92>>2],i[r>>2]=i[h+88>>2],i[r+4>>2]=e,i[r+8>>2]=i[h+96>>2];break n}T(r,i[h+88>>2],i[h+92>>2])}t[A+20|0]=1;break k}k=i[r+4>>2],k&&W[k|0](0,g(p[e+554>>1],p[e+552>>1]),i[r+16>>2]),k=i[r+8>>2],k&&W[k|0](0,0,i[r+16>>2]),i[h+40>>2]=0,j=C(12),i[j+8>>2]=0,i[j>>2]=0,i[j+4>>2]=0,q=C(16),i[q+12>>2]=j,i[q>>2]=108272,i[q+4>>2]=0,i[q+8>>2]=0,o=p[e+552>>1];n:{t:{if(!o)break t;for(R2=r2+4|0,V=A+8|0,k=p[e+554>>1],I=h- -64|0,D2=h+24|0,n=0;;){o:{l:{if(k&65535){f2=0,o=0;break l}k=0,_0=0;break o}for(;;){k=h+56|0,B=i[i[e+564>>2]+(g0<<2)>>2],$1(k,i[e+180>>2],B,1),C0=i[h+60>>2],m=i[h+56>>2];l:{if(!m){if(!(u[r+21|0]|!g0)){t[h+44|0]=0,t[h+55|0]=0,l=a(k,2,119,h+44|0),s=i[j+4>>2];u:{if(s>>>0<o0[j+8>>2]){k=i[l+4>>2],i[s>>2]=i[l>>2],i[s+4>>2]=k,i[s+16>>2]=i[I+8>>2],k=i[I+4>>2],i[s+8>>2]=i[I>>2],i[s+12>>2]=k,i[I>>2]=0,i[I+4>>2]=0,i[I+8>>2]=0,i[j+4>>2]=s+20;break u}if(l=Je(j,l),k=t[h+75|0],i[j+4>>2]=l,(k|0)>=0)break u;Z(i[h+64>>2])}t[h+55|0]<0&&Z(i[h+44>>2]),o=f+o|0,g0=g0+1|0,k=9,_0=0;break l}s=C(40),i[h+44>>2]=s,i[h+48>>2]=33,i[h+52>>2]=-2147483608,t[s+32|0]=u[19405],l=u[19401]|u[19402]<<8|(u[19403]<<16|u[19404]<<24),k=u[19397]|u[19398]<<8|(u[19399]<<16|u[19400]<<24),t[s+24|0]=k,t[s+25|0]=k>>>8,t[s+26|0]=k>>>16,t[s+27|0]=k>>>24,t[s+28|0]=l,t[s+29|0]=l>>>8,t[s+30|0]=l>>>16,t[s+31|0]=l>>>24,l=u[19393]|u[19394]<<8|(u[19395]<<16|u[19396]<<24),k=u[19389]|u[19390]<<8|(u[19391]<<16|u[19392]<<24),t[s+16|0]=k,t[s+17|0]=k>>>8,t[s+18|0]=k>>>16,t[s+19|0]=k>>>24,t[s+20|0]=l,t[s+21|0]=l>>>8,t[s+22|0]=l>>>16,t[s+23|0]=l>>>24,l=u[19385]|u[19386]<<8|(u[19387]<<16|u[19388]<<24),k=u[19381]|u[19382]<<8|(u[19383]<<16|u[19384]<<24),t[s+8|0]=k,t[s+9|0]=k>>>8,t[s+10|0]=k>>>16,t[s+11|0]=k>>>24,t[s+12|0]=l,t[s+13|0]=l>>>8,t[s+14|0]=l>>>16,t[s+15|0]=l>>>24,l=u[19377]|u[19378]<<8|(u[19379]<<16|u[19380]<<24),k=u[19373]|u[19374]<<8|(u[19375]<<16|u[19376]<<24),t[s|0]=k,t[s+1|0]=k>>>8,t[s+2|0]=k>>>16,t[s+3|0]=k>>>24,t[s+4|0]=l,t[s+5|0]=l>>>8,t[s+6|0]=l>>>16,t[s+7|0]=l>>>24,t[s+33|0]=0,l=a(h+56|0,2,119,h+44|0),k=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=k;u:{if(t[h+75|0]>=0){k=i[I+4>>2],i[V>>2]=i[I>>2],i[V+4>>2]=k,i[V+8>>2]=i[I+8>>2],t[A+20|0]=1;break u}if(T(V,i[h+64>>2],i[h+68>>2]),k=t[h+75|0],t[A+20|0]=1,(k|0)>=0)break u;Z(i[h+64>>2])}t[h+55|0]<0&&Z(i[h+44>>2]),k=1,_0=0;break l}W[i[i[m>>2]+88>>2]](h+56|0,m),s=i[h+56>>2],k=0;u:{if(!s)break u;if(!(u[r+21|0]|!g0)){k=j,G=i[k+4>>2];s:{if(G>>>0<o0[k+8>>2]){if(l=i[h+60>>2],i[G>>2]=i[h+56>>2],i[G+4>>2]=l,w=G+8|0,t[h+75|0]>=0){l=i[I+4>>2],i[w>>2]=i[I>>2],i[w+4>>2]=l,i[w+8>>2]=i[I+8>>2],l=G+20|0;break s}T(w,i[h+64>>2],i[h+68>>2]),l=G+20|0;break s}l=yi(j,h+56|0)}i[k+4>>2]=l,o=f+o|0,g0=g0+1|0,k=9;break u}k=i[h+60>>2],i[A>>2]=i[h+56>>2],i[A+4>>2]=k;s:{if(t[h+75|0]>=0){k=i[I+4>>2],i[V>>2]=i[I>>2],i[V+4>>2]=k,i[V+8>>2]=i[I+8>>2];break s}T(V,i[h+64>>2],i[h+68>>2])}t[A+20|0]=1,k=1}if(t[h+75|0]<0&&Z(i[h+64>>2]),_0=0,s)break l;j0=i[m+200>>2],l=i[m+204>>2],Ii(h+56|0,i[e+180>>2]- -64|0,j0,l),s=i[h+60>>2],k=i[h+56>>2],i[h+80>>2]=k,i[h+84>>2]=s,t[h+99|0]<0&&(Z(i[h+88>>2]),k=i[h+80>>2]),s=i[I+4>>2],i[h+88>>2]=i[I>>2],i[h+92>>2]=s,i[h+96>>2]=i[I+8>>2];u:{if(k){if(k=i[h+84>>2],i[A>>2]=i[h+80>>2],i[A+4>>2]=k,t[h+99|0]>=0){k=i[h+92>>2],i[V>>2]=i[h+88>>2],i[V+4>>2]=k,i[V+8>>2]=i[h+96>>2];break u}T(V,i[h+88>>2],i[h+92>>2]);break u}w=i[e+556>>2],s=L0(p[e+554>>1],0,j0,0);s:{if(k=h0,!k&s>>>0>=w>>>0|k&&(w=i[e+560>>2],s=L0(p[e+552>>1],0,l,0),k=h0,!k&s>>>0>=w>>>0|k))break s;s=C(40),i[h+44>>2]=s,i[h+48>>2]=35,i[h+52>>2]=-2147483608,k=u[16129]|u[16130]<<8|(u[16131]<<16|u[16132]<<24),t[s+31|0]=k,t[s+32|0]=k>>>8,t[s+33|0]=k>>>16,t[s+34|0]=k>>>24,l=u[16126]|u[16127]<<8|(u[16128]<<16|u[16129]<<24),k=u[16122]|u[16123]<<8|(u[16124]<<16|u[16125]<<24),t[s+24|0]=k,t[s+25|0]=k>>>8,t[s+26|0]=k>>>16,t[s+27|0]=k>>>24,t[s+28|0]=l,t[s+29|0]=l>>>8,t[s+30|0]=l>>>16,t[s+31|0]=l>>>24,l=u[16118]|u[16119]<<8|(u[16120]<<16|u[16121]<<24),k=u[16114]|u[16115]<<8|(u[16116]<<16|u[16117]<<24),t[s+16|0]=k,t[s+17|0]=k>>>8,t[s+18|0]=k>>>16,t[s+19|0]=k>>>24,t[s+20|0]=l,t[s+21|0]=l>>>8,t[s+22|0]=l>>>16,t[s+23|0]=l>>>24,l=u[16110]|u[16111]<<8|(u[16112]<<16|u[16113]<<24),k=u[16106]|u[16107]<<8|(u[16108]<<16|u[16109]<<24),t[s+8|0]=k,t[s+9|0]=k>>>8,t[s+10|0]=k>>>16,t[s+11|0]=k>>>24,t[s+12|0]=l,t[s+13|0]=l>>>8,t[s+14|0]=l>>>16,t[s+15|0]=l>>>24,l=u[16102]|u[16103]<<8|(u[16104]<<16|u[16105]<<24),k=u[16098]|u[16099]<<8|(u[16100]<<16|u[16101]<<24),t[s|0]=k,t[s+1|0]=k>>>8,t[s+2|0]=k>>>16,t[s+3|0]=k>>>24,t[s+4|0]=l,t[s+5|0]=l>>>8,t[s+6|0]=l>>>16,t[s+7|0]=l>>>24,t[s+35|0]=0,l=a(h+56|0,2,118,h+44|0),k=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=k;h:{if(t[h+75|0]>=0){k=i[I+4>>2],i[V>>2]=i[I>>2],i[V+4>>2]=k,i[V+8>>2]=i[I+8>>2],t[A+20|0]=1;break h}if(T(V,i[h+64>>2],i[h+68>>2]),k=t[h+75|0],t[A+20|0]=1,(k|0)>=0)break h;Z(i[h+64>>2])}t[h+55|0]<0&&Z(i[h+44>>2]),k=1;break l}s:{if(!(f2|v2)){f=j0,n=l;break s}if((f|0)==(j0|0)&(n|0)==(l|0))break s;s=C(32),i[h+44>>2]=s,i[h+48>>2]=31,i[h+52>>2]=-2147483616,l=u[5692]|u[5693]<<8|(u[5694]<<16|u[5695]<<24),k=u[5688]|u[5689]<<8|(u[5690]<<16|u[5691]<<24),t[s+23|0]=k,t[s+24|0]=k>>>8,t[s+25|0]=k>>>16,t[s+26|0]=k>>>24,t[s+27|0]=l,t[s+28|0]=l>>>8,t[s+29|0]=l>>>16,t[s+30|0]=l>>>24,l=u[5685]|u[5686]<<8|(u[5687]<<16|u[5688]<<24),k=u[5681]|u[5682]<<8|(u[5683]<<16|u[5684]<<24),t[s+16|0]=k,t[s+17|0]=k>>>8,t[s+18|0]=k>>>16,t[s+19|0]=k>>>24,t[s+20|0]=l,t[s+21|0]=l>>>8,t[s+22|0]=l>>>16,t[s+23|0]=l>>>24,l=u[5677]|u[5678]<<8|(u[5679]<<16|u[5680]<<24),k=u[5673]|u[5674]<<8|(u[5675]<<16|u[5676]<<24),t[s+8|0]=k,t[s+9|0]=k>>>8,t[s+10|0]=k>>>16,t[s+11|0]=k>>>24,t[s+12|0]=l,t[s+13|0]=l>>>8,t[s+14|0]=l>>>16,t[s+15|0]=l>>>24,l=u[5669]|u[5670]<<8|(u[5671]<<16|u[5672]<<24),k=u[5665]|u[5666]<<8|(u[5667]<<16|u[5668]<<24),t[s|0]=k,t[s+1|0]=k>>>8,t[s+2|0]=k>>>16,t[s+3|0]=k>>>24,t[s+4|0]=l,t[s+5|0]=l>>>8,t[s+6|0]=l>>>16,t[s+7|0]=l>>>24,t[s+31|0]=0,l=a(h+56|0,2,118,h+44|0),k=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=k;h:{if(t[h+75|0]>=0){k=i[I+4>>2],i[V>>2]=i[I>>2],i[V+4>>2]=k,i[V+8>>2]=i[I+8>>2],t[A+20|0]=1;break h}if(T(V,i[h+64>>2],i[h+68>>2]),k=t[h+75|0],t[A+20|0]=1,(k|0)>=0)break h;Z(i[h+64>>2])}t[h+55|0]<0&&Z(i[h+44>>2]),k=1;break l}k=i[r+44>>2],k?_0=(W[k|0](i[r+16>>2])|0)!=0:_0=0,i[h+36>>2]=q,i[h+32>>2]=j,i[q+4>>2]=i[q+4>>2]+1,i[h+20>>2]=D2,i[h+24>>2]=0,i[h+28>>2]=0,l=h+20|0,W8(l,i[r2>>2],R2),k=i[h+36>>2],i[h+8>>2]=i[h+32>>2],i[h+12>>2]=k,R=h+56|0,c=h+232|0,_=v-80|0,v=_,k=_+56|0,$1(k,i[e+180>>2],B,1),r0=i[_+60>>2];s:{h:{s=i[_+56>>2];w:{if(!(s|u[r+21|0])){w=i[h+8>>2],i[_+56>>2]=2,i[_+24>>2]=119,l=i[w+4>>2];_:{if(l>>>0<o0[w+8>>2]){dl(l,k,_+24|0),k=l+20|0;break _}m=_+56|0,B=_+24|0;v:{B:{if(l=i[w>>2],k=i[w+4>>2]-l|0,G=((k|0)/20|0)+1|0,G>>>0<214748365){if(s=(i[w+8>>2]-l|0)/20|0,l=s<<1,Y=s>>>0>=107374182?214748364:l>>>0>G>>>0?l:G,Y){if(Y>>>0>=214748365)break B;s=C(g(Y,20))}else s=0;if(U=s+k|0,dl(U,m,B),O=i[w+4>>2],k=i[w>>2],B=U+g((O-k|0)/-20|0,20)|0,(k|0)!=(O|0)){for(m=k,l=B;G=i[m+4>>2],i[l>>2]=i[m>>2],i[l+4>>2]=G,i[l+16>>2]=i[m+16>>2],G=i[m+12>>2],i[l+8>>2]=i[m+8>>2],i[l+12>>2]=G,i[m+16>>2]=0,i[m+8>>2]=0,i[m+12>>2]=0,l=l+20|0,m=m+20|0,(O|0)!=(m|0););for(;t[k+19|0]<0&&Z(i[k+8>>2]),k=k+20|0,(O|0)!=(k|0););k=i[w>>2]}l=U+20|0,i[w+4>>2]=l,i[w>>2]=B,i[w+8>>2]=s+g(Y,20),k&&Z(k),k=l;break v}s0(),M()}x0(),M()}}if(i[w+4>>2]=k,s=i[r+8>>2],s&&(l=i[r+16>>2],k=i[h+40>>2]+1|0,i[h+40>>2]=k,W[s|0](0,k,l)),k=i[28729],i[R>>2]=i[28728],i[R+4>>2]=k,l=R+8|0,m=0,t[114931]>=0){k=i[28731],i[l>>2]=i[28730],i[l+4>>2]=k,i[l+8>>2]=i[28732];break w}T(l,i[28730],i[28731]);break w}if(W[i[i[s>>2]+88>>2]](R,s),m=0,i[R>>2])break w;t[R+19|0]<0&&Z(i[R+8>>2]),i[_+48>>2]=0,i[_+52>>2]=0,i[_+44>>2]=_+48,k=_+44|0,W8(k,i[l>>2],l+4|0),W[i[i[s>>2]+140>>2]](_+56|0,s,r,0,0,0,k),S1(k,i[_+48>>2]),k=u[_+76|0];_:{if(k){if(B=_- -64|0,!u[r+21|0]){if((k|0)!=1)break h;l=i[h+8>>2],w=i[l+4>>2];v:{if(w>>>0<o0[l+8>>2]){k=i[_+60>>2],i[w>>2]=i[_+56>>2],i[w+4>>2]=k,s=w+8|0;B:{if(t[_+75|0]>=0){k=i[B+4>>2],i[s>>2]=i[B>>2],i[s+4>>2]=k,i[s+8>>2]=i[B+8>>2];break B}T(s,i[_+64>>2],i[_+68>>2])}k=w+20|0;break v}k=yi(l,_+56|0)}if(i[l+4>>2]=k,s=i[r+8>>2],s&&(l=i[r+16>>2],k=i[h+40>>2]+1|0,i[h+40>>2]=k,W[s|0](0,k,l)),k=i[28729],i[R>>2]=i[28728],i[R+4>>2]=k,l=R+8|0,t[114931]>=0){k=i[28731],i[l>>2]=i[28730],i[l+4>>2]=k,i[l+8>>2]=i[28732];break _}T(l,i[28730],i[28731]);break _}if((k|0)!=1)break h;if(k=i[_+60>>2],i[R>>2]=i[_+56>>2],i[R+4>>2]=k,l=R+8|0,t[_+75|0]>=0){k=i[B+4>>2],i[l>>2]=i[B>>2],i[l+4>>2]=k,i[l+8>>2]=i[B+8>>2];break _}T(l,i[_+64>>2],i[_+68>>2]);break _}m=i[_+60>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),f0=i[_+56>>2];v:{if(k=i[c>>2],!k){s=i[e+560>>2],l=i[e+556>>2],w=C(248),i[w+4>>2]=0,i[w+8>>2]=0,i[w>>2]=101168,l0(w+16|0,0,156),i[w+76>>2]=0,i[w+80>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,t[w+24|0]=1,X[w+22>>1]=2,X[w+18>>1]=2,X[w+20>>1]=2,i[w+84>>2]=0,i[w+88>>2]=0,i[w+92>>2]=0,i[w+96>>2]=0,i[w+128>>2]=0,i[w+132>>2]=0,i[w+100>>2]=0,i[w+104>>2]=1,i[w+136>>2]=0,i[w+140>>2]=0,i[w+144>>2]=0,i[w+148>>2]=0,i[w+152>>2]=0,i[w+156>>2]=0,X[w+158>>1]=0,X[w+160>>1]=0,X[w+162>>1]=0,X[w+164>>1]=0,i[w+184>>2]=0,i[w+188>>2]=0,i[w+172>>2]=255,i[w+192>>2]=0,i[w+196>>2]=5186,i[w+208>>2]=99,i[w+212>>2]=99,i[w+200>>2]=0,i[w+204>>2]=0,i[w+12>>2]=101488,i[w+216>>2]=0,i[w+220>>2]=0,i[w+224>>2]=0,i[w+228>>2]=0,i[w+232>>2]=0,i[w+236>>2]=0,i[w+240>>2]=0,i[w+244>>2]=0,i[_+28>>2]=w,k=w+12|0,i[_+24>>2]=k,i[w+176>>2]=k,i[w+8>>2]=i[w+8>>2]+1,i[w+180>>2]=w,i[w+4>>2]==-1&&(W[i[i[w>>2]+8>>2]](w),y(w)),k=i[_+24>>2],i[_+40>>2]=m,i[_+36>>2]=f0,m&&(i[m+4>>2]=i[m+4>>2]+1),Xn(R,k,_+36|0,l,s,i[e+180>>2]- -64|0),l=i[_+40>>2];B:{if(!l||(k=i[l+4>>2],i[l+4>>2]=k-1,k))break B;W[i[i[l>>2]+8>>2]](l),y(l)}if(i[R>>2])break v;if($2(i[_+24>>2],6)){N=(-1<<K0(i[_+24>>2],6)^-1)&65535,s=0,G=0,A0=0,k=1;B:{m:{g:{Z:switch(l=i[_+24>>2],i[l+200>>2]){case 10:case 12:case 14:break Z;case 11:case 13:case 15:break g;case 0:case 1:case 2:case 3:case 99:break B;default:break m}k=3;break B}k=4;break B}k=0}U=k,k=i[l+204>>2],Y=i[l+208>>2];B:{if((k|0)==(Y|0))break B;l=k;m:{g:{for(;;){if(i[l>>2]==6)break g;if(l=l+56|0,(Y|0)==(l|0))break}w=1;break m}w=p[l+20>>1]<9}l=k;m:{g:{for(;;){if(i[l>>2]==6)break g;if(l=l+56|0,(Y|0)==(l|0))break}B=0;break m}B=i[l+24>>2]}l=k;m:{g:{for(;;){if(i[l>>2]==6)break g;if(l=l+56|0,(Y|0)==(l|0))break}O=0;break m}O=i[l+28>>2]}if(w){m:{g:{for(;;){if(i[k>>2]==6)break g;if(k=k+56|0,(Y|0)==(k|0))break}k=0;break m}G=i[k+40>>2],k=i[k+52>>2]}if(!O)break B;if(w=k,Y=g(B,U),k=0,O>>>0>=4)for(B=O&-4,l=0;U=!Y,U||l0(g(s,w)+G|0,N,Y),U||l0(g(w,s|1)+G|0,N,Y),U||l0(g(w,s|2)+G|0,N,Y),U||l0(g(w,s|3)+G|0,N,Y),s=s+4|0,l=l+4|0,(B|0)!=(l|0););if(l=O&3,!l)break B;for(;Y&&l0(g(s,w)+G|0,N,Y),s=s+1|0,k=k+1|0,(l|0)!=(k|0););break B}m:{g:{for(;;){if(i[k>>2]==6)break g;if(k=k+56|0,(Y|0)==(k|0))break}k=0;break m}A0=i[k+52>>2]>>>1|0,k=i[k+40>>2]}if(!O||(l=g(B,U),!l))break B;for(M0=l&-8,X0=l&7,z0=l-1>>>0<7;;){if(S=k+(g(G,A0)<<1)|0,B=0,!z0)for(x=S+14|0,Z2=S+12|0,X2=S+10|0,Y=S+8|0,U=S+6|0,w=S+4|0,s=S+2|0,l=0;d=B<<1,X[d+S>>1]=N,X[s+d>>1]=N,X[w+d>>1]=N,X[U+d>>1]=N,X[Y+d>>1]=N,X[d+X2>>1]=N,X[d+Z2>>1]=N,X[x+d>>1]=N,B=B+8|0,l=l+8|0,(M0|0)!=(l|0););if(s=0,X0)for(;X[S+(B<<1)>>1]=N,B=B+1|0,s=s+1|0,(X0|0)!=(s|0););if(G=G+1|0,(O|0)==(G|0))break}}}Ye(i[_+24>>2],f0),qi(c,_+24|0),t[R+19|0]<0&&Z(i[R+8>>2]),g2(_+24|0),k=i[c>>2]}if(i[k+200>>2]!=i[f0+200>>2]){if(s=C(64),i[_+24>>2]=s,i[_+28>>2]=58,i[_+32>>2]=-2147483584,l=u[16427]|u[16428]<<8|(u[16429]<<16|u[16430]<<24),k=u[16423]|u[16424]<<8|(u[16425]<<16|u[16426]<<24),t[s|0]=k,t[s+1|0]=k>>>8,t[s+2|0]=k>>>16,t[s+3|0]=k>>>24,t[s+4|0]=l,t[s+5|0]=l>>>8,t[s+6|0]=l>>>16,t[s+7|0]=l>>>24,t[s+58|0]=0,k=u[16479]|u[16480]<<8,t[s+56|0]=k,t[s+57|0]=k>>>8,l=u[16475]|u[16476]<<8|(u[16477]<<16|u[16478]<<24),k=u[16471]|u[16472]<<8|(u[16473]<<16|u[16474]<<24),t[s+48|0]=k,t[s+49|0]=k>>>8,t[s+50|0]=k>>>16,t[s+51|0]=k>>>24,t[s+52|0]=l,t[s+53|0]=l>>>8,t[s+54|0]=l>>>16,t[s+55|0]=l>>>24,l=u[16467]|u[16468]<<8|(u[16469]<<16|u[16470]<<24),k=u[16463]|u[16464]<<8|(u[16465]<<16|u[16466]<<24),t[s+40|0]=k,t[s+41|0]=k>>>8,t[s+42|0]=k>>>16,t[s+43|0]=k>>>24,t[s+44|0]=l,t[s+45|0]=l>>>8,t[s+46|0]=l>>>16,t[s+47|0]=l>>>24,l=u[16459]|u[16460]<<8|(u[16461]<<16|u[16462]<<24),k=u[16455]|u[16456]<<8|(u[16457]<<16|u[16458]<<24),t[s+32|0]=k,t[s+33|0]=k>>>8,t[s+34|0]=k>>>16,t[s+35|0]=k>>>24,t[s+36|0]=l,t[s+37|0]=l>>>8,t[s+38|0]=l>>>16,t[s+39|0]=l>>>24,l=u[16451]|u[16452]<<8|(u[16453]<<16|u[16454]<<24),k=u[16447]|u[16448]<<8|(u[16449]<<16|u[16450]<<24),t[s+24|0]=k,t[s+25|0]=k>>>8,t[s+26|0]=k>>>16,t[s+27|0]=k>>>24,t[s+28|0]=l,t[s+29|0]=l>>>8,t[s+30|0]=l>>>16,t[s+31|0]=l>>>24,l=u[16443]|u[16444]<<8|(u[16445]<<16|u[16446]<<24),k=u[16439]|u[16440]<<8|(u[16441]<<16|u[16442]<<24),t[s+16|0]=k,t[s+17|0]=k>>>8,t[s+18|0]=k>>>16,t[s+19|0]=k>>>24,t[s+20|0]=l,t[s+21|0]=l>>>8,t[s+22|0]=l>>>16,t[s+23|0]=l>>>24,l=u[16435]|u[16436]<<8|(u[16437]<<16|u[16438]<<24),k=u[16431]|u[16432]<<8|(u[16433]<<16|u[16434]<<24),t[s+8|0]=k,t[s+9|0]=k>>>8,t[s+10|0]=k>>>16,t[s+11|0]=k>>>24,t[s+12|0]=l,t[s+13|0]=l>>>8,t[s+14|0]=l>>>16,t[s+15|0]=l>>>24,a(R,2,127,_+24|0),t[_+35|0]>=0)break _;Z(i[_+24>>2]);break _}i[_+28>>2]=m,i[_+24>>2]=f0,m&&(i[m+4>>2]=i[m+4>>2]+1),S0=_+4|0,c=k,Q=v-32|0,v=Q,k=i[_+24>>2],X0=Q+24|0,i[Q+20>>2]=X0,i[Q+24>>2]=0,i[Q+28>>2]=0,B=i[k+204>>2],w=i[k+208>>2];B:{m:{if((B|0)==(w|0))break m;for(;;){G=i[B>>2],l=X0,k=l,s=i[Q+24>>2];g:{Z:{if(!s)break Z;for(;;){if(k=s,l=i[s+16>>2],(l|0)>(G|0)){if(l=s,s=i[s>>2],s)continue;break Z}if((l|0)>=(G|0))break g;if(s=i[k+4>>2],!s)break}l=k+4|0}s=C(20),i[s+8>>2]=k,i[s>>2]=0,i[s+4>>2]=0,i[s+16>>2]=G,i[l>>2]=s,k=i[i[Q+20>>2]>>2],k&&(i[Q+20>>2]=k),G1(i[Q+24>>2],s),i[Q+28>>2]=i[Q+28>>2]+1}if(B=B+56|0,(w|0)==(B|0))break}if(G=i[Q+20>>2],(X0|0)==(G|0)|i[c+204>>2]==i[c+208>>2])break m;for(M0=i[c+188>>2],d=i[c+192>>2],f0=M0>>>0>o>>>0&d>>>0>q0>>>0,k=i[c+200>>2],l=(k|0)==1,Z2=q0-(l?q0>>>1|0:0)|0,k=k-1>>>0<2,X2=M0-(k?M0>>>1|0:0)|0,Y=o-(k?o>>>1|0:0)|0,O=l?d>>>1|0:0;;){B=i[c+204>>2],x=i[c+208>>2];g:{if((B|0)==(x|0))break g;for(t0=i[G+16>>2],s=B;;){if((t0|0)!=i[s>>2]){if(s=s+56|0,(x|0)!=(s|0))continue;break g}break}l=i[_+24>>2],k=i[l+204>>2],w=k;Z:{W:{if(V0=i[l+208>>2],S=(V0|0)==(k|0),S)break W;for(;;){if((t0|0)!=i[w>>2]){if(w=w+56|0,(V0|0)!=(w|0))continue;break W}break}A2=i[w+40>>2],z0=i[w+52>>2];break Z}A2=0,z0=0}w=B;Z:{W:{for(;;){if((t0|0)==i[w>>2])break W;if(w=w+56|0,(x|0)==(w|0))break}s2=0,U=0;break Z}s2=i[w+52>>2],U=i[w+40>>2]}if(!f0){if(t[Q+8|0]=0,t[Q+19|0]=0,a(S0,2,118,Q+8|0),t[Q+19|0]>=0)break B;Z(i[Q+8>>2]);break B}A0=0,w=k;Z:{if(S)break Z;for(;;){if((t0|0)!=i[w>>2]){if(w=w+56|0,(V0|0)!=(w|0))continue;break Z}break}A0=p[w+20>>1]}Z:{W:{for(;;){if((t0|0)==i[B>>2])break W;if(B=B+56|0,(x|0)==(B|0))break}l=0;break Z}l=p[B+20>>1]}if((l|0)!=(A0&65535)){if(t[Q+8|0]=0,t[Q+19|0]=0,a(S0,2,132,Q+8|0),t[Q+19|0]>=0)break B;Z(i[Q+8>>2]);break B}B=0,l=k,A0=0,x=0;Z:{if(S)break Z;W:{X:{for(;;){if((t0|0)==i[l>>2])break X;if(l=l+56|0,(V0|0)==(l|0))break}A0=0;break W}A0=i[l+24>>2]}l=k;W:{for(;;){if((t0|0)==i[l>>2])break W;if(l=l+56|0,(V0|0)==(l|0))break}x=0;break Z}x=i[l+28>>2]}w=q0,s=o,l=M0,t0-1>>>0<=1&&(w=Z2,B=O,s=Y,l=X2),B=d-(w+B|0)|0,N=B>>>0<x>>>0?B:x,B=0;Z:{if(S){l=0;break Z}l=l-s|0,x=l>>>0<A0>>>0?l:A0,l=k;W:{X:{for(;;){if((t0|0)==i[l>>2])break X;if(l=l+56|0,(V0|0)==(l|0))break}l=0;break W}l=u[l+23|0]&31}for(l=g(l,x);;){if((t0|0)!=i[k>>2]){if(k=k+56|0,(V0|0)!=(k|0))continue;break Z}break}B=u[k+23|0]&31}if(!N)break g;if(x=g(s,B)+U|0,k=0,(N|0)!=1)for(U=N&-2,s=0;B=!l,B||z(x+g(k+w|0,s2)|0,g(k,z0)+A2|0,l),B||(B=k|1,z(x+g(B+w|0,s2)|0,g(B,z0)+A2|0,l)),k=k+2|0,s=s+2|0,(U|0)!=(s|0););if(!(N&1)|!l)break g;z(x+g(k+w|0,s2)|0,g(k,z0)+A2|0,l)}s=i[G+4>>2];g:{if(s){for(;;)if(k=s,s=i[s>>2],!s)break g}for(;k=i[G+8>>2],l=i[k>>2]!=(G|0),G=k,!!l;);}if(G=k,(k|0)==(X0|0))break}}if(k=i[28729],i[S0>>2]=i[28728],i[S0+4>>2]=k,l=S0+8|0,t[114931]>=0){k=i[28731],i[l>>2]=i[28730],i[l+4>>2]=k,i[l+8>>2]=i[28732];break B}T(l,i[28730],i[28731])}ee(Q+20|0,i[Q+24>>2]),v=Q+32|0,t[_+23|0]<0&&Z(i[_+12>>2]),l=i[_+28>>2];B:{if(!l||(k=i[l+4>>2],i[l+4>>2]=k-1,k))break B;W[i[i[l>>2]+8>>2]](l),y(l)}if(s=i[r+8>>2],s&&(l=i[r+16>>2],k=i[h+40>>2]+1|0,i[h+40>>2]=k,W[s|0](0,k,l)),k=i[28729],i[R>>2]=i[28728],i[R+4>>2]=k,l=R+8|0,t[114931]>=0){k=i[28731],i[l>>2]=i[28730],i[l+4>>2]=k,i[l+8>>2]=i[28732];break _}T(l,i[28730],i[28731]);break _}if(l=i[_+28>>2],!l||(k=i[l+4>>2],i[l+4>>2]=k-1,k))break _;W[i[i[l>>2]+8>>2]](l),y(l)}if(l=u[_+76|0],(l|0)==255)break w;k=i[27061],i[_+24>>2]=i[27060],i[_+28>>2]=k,W[i[(_+24|0)+(l<<2)>>2]](_+36|0,_+56|0)}w:{if(!r0||(k=i[r0+4>>2],i[r0+4>>2]=k-1,k))break w;W[i[i[r0>>2]+8>>2]](r0),y(r0)}w:{if(!m||(k=i[m+4>>2],i[m+4>>2]=k-1,k))break w;W[i[i[m>>2]+8>>2]](m),y(m)}l=i[h+12>>2];w:{if(!l||(k=i[l+4>>2],i[l+4>>2]=k-1,k))break w;W[i[i[l>>2]+8>>2]](l),y(l)}v=_+80|0;break s}e2(),M()}if(k=i[h+60>>2],i[h+80>>2]=i[h+56>>2],i[h+84>>2]=k,t[h+99|0]<0&&Z(i[h+88>>2]),k=i[I+4>>2],i[h+88>>2]=i[I>>2],i[h+92>>2]=k,i[h+96>>2]=i[I+8>>2],t[h+64|0]=0,t[h+75|0]=0,S1(h+20|0,i[h+24>>2]),i[h+80>>2]){if(k=i[h+84>>2],i[A>>2]=i[h+80>>2],i[A+4>>2]=k,t[h+99|0]>=0){k=i[h+92>>2],i[V>>2]=i[h+88>>2],i[V+4>>2]=k,i[V+8>>2]=i[h+96>>2];break u}T(V,i[h+88>>2],i[h+92>>2]);break u}g0=g0+1|0,o=o+j0|0,k=0;break l}k=1,t[A+20|0]=1}l:{if(!C0||(l=i[C0+4>>2],i[C0+4>>2]=l-1,l))break l;W[i[i[C0>>2]+8>>2]](C0),y(C0)}l:switch(k|0){case 0:case 9:break l;default:break n}if(k=p[e+554>>1],f2=f2+1|0,!!(k>>>0<=f2>>>0|_0))break}o=p[e+552>>1]}if(v2=v2+1|0,v2>>>0>=(o&65535)>>>0)break t;if(q0=n+q0|0,!!_0)break}}if(e=i[r+12>>2],e&&W[e|0](0,i[r+16>>2]),_0){f=C(32),i[h+44>>2]=f,i[h+48>>2]=31,i[h+52>>2]=-2147483616,r=u[18743]|u[18744]<<8|(u[18745]<<16|u[18746]<<24),e=u[18739]|u[18740]<<8|(u[18741]<<16|u[18742]<<24),t[f+23|0]=e,t[f+24|0]=e>>>8,t[f+25|0]=e>>>16,t[f+26|0]=e>>>24,t[f+27|0]=r,t[f+28|0]=r>>>8,t[f+29|0]=r>>>16,t[f+30|0]=r>>>24,r=u[18736]|u[18737]<<8|(u[18738]<<16|u[18739]<<24),e=u[18732]|u[18733]<<8|(u[18734]<<16|u[18735]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[18728]|u[18729]<<8|(u[18730]<<16|u[18731]<<24),e=u[18724]|u[18725]<<8|(u[18726]<<16|u[18727]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,r=u[18720]|u[18721]<<8|(u[18722]<<16|u[18723]<<24),e=u[18716]|u[18717]<<8|(u[18718]<<16|u[18719]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+31|0]=0,f=a(h+56|0,12,0,h+44|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;t:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break t}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break t;Z(i[f+8>>2])}if(t[h+55|0]>=0)break n;Z(i[h+44>>2]);break n}r=i[h+232>>2],e=0;t:{if(!r||(e=r,k=i[j>>2],o=i[j+4>>2],(k|0)==(o|0)))break t;for(n=e+224|0,e=i[e+228>>2];;){o:{if(o0[r+232>>2]>e>>>0){if(f=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=f,l=e+8|0,t[k+19|0]>=0){f=i[k+12>>2],i[l>>2]=i[k+8>>2],i[l+4>>2]=f,i[l+8>>2]=i[k+16>>2],e=e+20|0;break o}T(l,i[k+8>>2],i[k+12>>2]),e=e+20|0;break o}e=yi(n,k)}if(i[r+228>>2]=e,k=k+20|0,(o|0)==(k|0))break}e=i[h+232>>2]}r=i[h+236>>2],i[h+232>>2]=0,i[h+236>>2]=0,t[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}if(A=i[q+4>>2],i[q+4>>2]=A-1,A)break k;W[i[i[q>>2]+8>>2]](q),y(q)}if(t[h+99|0]>=0)break e;Z(i[h+88>>2]);break e}I0(),M()}if(!e)break r;z(o,f,e)}t[e+o|0]=0,f=a(h+56|0,2,119,h+44|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}t[h+55|0]<0&&Z(i[h+44>>2]),A=i[19543],i[h+80>>2]=A,i[i[A-12>>2]+(h+80|0)>>2]=i[19551],i[h+88>>2]=i[19552],i[k>>2]=77200,t[h+135|0]<0&&Z(i[h+124>>2]),y0(k),Y0(h+144|0)}e=i[h+236>>2];e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}v=h+240|0,S1(r2,i[E+8>>2])}v=E- -64|0}function I9(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;l=v+-64|0,v=l,i[A+4>>2]=0,i[A+8>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,t[A+36|0]=0,i[A+32>>2]=9e4,i[A+24>>2]=0,i[A+28>>2]=0,i[A+92>>2]=0,i[A+96>>2]=0,i[A+88>>2]=1,i[A+12>>2]=0,i[A+16>>2]=5186,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,n=A- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+80>>2]=0,i[A+84>>2]=0,t[A+100|0]=0,i[A>>2]=113576,l0(A+104|0,0,188),i[A+20>>2]=e,o=i[e+48>>2],k=i[e+52>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),n=i[o+152>>2],o=i[o+156>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[A+128>>2]=n,s=i[A+132>>2],i[A+132>>2]=o;i:{if(!s||(n=i[s+4>>2],i[s+4>>2]=n-1,n))break i;W[i[i[s>>2]+8>>2]](s),y(s)}i:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break i;W[i[i[k>>2]+8>>2]](k),y(k)}QA(l+28|0,i[e+48>>2]+172|0,1);i:{if(!u[l+48|0])for(k=i[i[A+128>>2]+36>>2],o=i[l+28>>2];;){e:{if(e=i[k>>2],!e||(e=Z0(e,92792,111476),!e))break e;n=i[k+4>>2];r:{if(!n){i[e+180>>2]=o+1,i[A+24>>2]=o;break r}if(i[n+4>>2]=i[n+4>>2]+1,i[e+180>>2]=o+1,i[A+24>>2]=o,e=i[n+4>>2],i[n+4>>2]=e-1,e)break r;W[i[i[n>>2]+8>>2]](n),y(n)}if(n=u[l+48|0],(n|0)==255)break i;e=i[28409],i[l+56>>2]=i[28408],i[l+60>>2]=e,W[i[(l+56|0)+(n<<2)>>2]](l+55|0,l+28|0);break i}k=k+8|0}e2(),M()}k=C(120),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=98988,n=k+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1953653099,i[k+16>>2]=99028,i[A+136>>2]=e,s=i[A+140>>2],i[A+140>>2]=k;i:{e:{if(!s){e=i[A+128>>2],i[l+32>>2]=k,i[l+28>>2]=n;break e}if(e=i[s+4>>2],i[s+4>>2]=e-1,e||(W[i[i[s>>2]+8>>2]](s),y(s)),e=i[A+128>>2],n=i[A+136>>2],k=i[A+140>>2],i[l+32>>2]=k,i[l+28>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(e+36|0,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}k=C(208),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=99108,n=k+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=111496,e=i[16214],i[k+160>>2]=i[16213],i[k+164>>2]=e,e=i[16216],i[k+168>>2]=i[16215],i[k+172>>2]=e,e=i[16218],i[k+176>>2]=i[16217],i[k+180>>2]=e,e=i[16220],i[k+184>>2]=i[16219],i[k+188>>2]=e,i[k+192>>2]=i[16221],i[k+152>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,X[k+156>>1]=256,i[k+196>>2]=0,i[k+200>>2]=0,i[k+32>>2]=1953196132,i[k+116>>2]=7,i[A+144>>2]=n,s=i[A+148>>2],i[A+148>>2]=k;i:{e:{if(!s){e=i[A+136>>2],i[l+32>>2]=k,i[l+28>>2]=n;break e}if(e=i[s+4>>2],i[s+4>>2]=e-1,e||(W[i[i[s>>2]+8>>2]](s),y(s)),e=i[A+136>>2],n=i[A+144>>2],k=i[A+148>>2],i[l+32>>2]=k,i[l+28>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(e+36|0,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}i[i[A+144>>2]+120>>2]=o,s=C(120),i[s>>2]=99148,i[s+4>>2]=0,i[s+8>>2]=0,n=s+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[s+32>>2]=0,i[s+36>>2]=0,i[s+40>>2]=0,i[s+44>>2]=0,i[s+48>>2]=0,i[s+16>>2]=92500,i[s+60>>2]=0,i[s+64>>2]=0,i[s+52>>2]=0,i[s+56>>2]=0,i[s+72>>2]=-1,i[s+76>>2]=-1,i[s+80>>2]=-1,i[s+84>>2]=-1,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+100>>2]=0,i[s+104>>2]=0,i[s+108>>2]=0,t[s+112|0]=0,i[s+32>>2]=1835297121,i[s+16>>2]=99188,e=i[A+136>>2],i[l+32>>2]=s,i[l+28>>2]=n,i[s+4>>2]=i[s+4>>2]+1,P0(e+36|0,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}e=C(160),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=99268,n=e+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[e+16>>2]=111576,i[e+120>>2]=0,i[e+124>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,t[e+152|0]=117,t[e+153|0]=110,t[e+154|0]=107,t[e+155|0]=0,i[e+32>>2]=1835296868,i[A+160>>2]=n,n=i[A+164>>2],i[A+164>>2]=e;i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}e=i[A+160>>2],i[e+120>>2]=r?i[r>>2]:9e4,i[l+28>>2]=e,e=i[A+164>>2],i[l+32>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),n=s+52|0,P0(n,l+28|0),o=i[l+32>>2];i:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break i;W[i[i[o>>2]+8>>2]](o),y(o)}k=C(152),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=96028,e=k+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93336,i[k+128>>2]=0,i[k+132>>2]=0,i[k+120>>2]=0,i[k+124>>2]=1885954932,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+32>>2]=1751411826,i[A+168>>2]=e,o=i[A+172>>2],i[A+172>>2]=k;i:{e:{if(!o){i[l+32>>2]=k,i[l+28>>2]=e;break e}if(e=i[o+4>>2],i[o+4>>2]=e-1,e||(W[i[i[o>>2]+8>>2]](o),y(o)),e=i[A+168>>2],k=i[A+172>>2],i[l+32>>2]=k,i[l+28>>2]=e,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(n,l+28|0),o=i[l+32>>2];i:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break i;W[i[i[o>>2]+8>>2]](o),y(o)}i[i[A+168>>2]+108>>2]=f,k=C(120),i[k>>2]=99308,i[k+4>>2]=0,i[k+8>>2]=0,e=k+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1835626086,i[k+16>>2]=99348,i[A+152>>2]=e,f=i[A+156>>2],i[A+156>>2]=k;i:{e:{if(!f){i[l+32>>2]=k,i[l+28>>2]=e;break e}if(e=i[f+4>>2],i[f+4>>2]=e-1,e||(W[i[i[f>>2]+8>>2]](f),y(f)),e=i[A+152>>2],k=i[A+156>>2],i[l+32>>2]=k,i[l+28>>2]=e,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(n,l+28|0),f=i[l+32>>2];i:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break i;W[i[i[f>>2]+8>>2]](f),y(f)}f=C(120),e=f,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=97268,n=e+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,i[f+16>>2]=94764,i[f+32>>2]=1684631142,m=C(120),i[m>>2]=97308,i[m+4>>2]=0,i[m+8>>2]=0,h=m+16|0,e=h,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[m+60>>2]=0,i[m+64>>2]=0,i[m+52>>2]=0,i[m+56>>2]=0,i[m+72>>2]=-1,i[m+76>>2]=-1,i[m+80>>2]=-1,i[m+84>>2]=-1,i[m+116>>2]=0,i[m+88>>2]=0,i[m+92>>2]=0,i[m+96>>2]=0,i[m+100>>2]=0,i[m+104>>2]=0,i[m+108>>2]=0,X[m+112>>1]=0,i[e>>2]=94844,i[m+32>>2]=1685218662,B=C(136),i[B>>2]=97348,i[B+4>>2]=0,i[B+8>>2]=0,k=B+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=92500,i[B+60>>2]=0,i[B+64>>2]=0,i[B+52>>2]=0,i[B+56>>2]=0,i[B+72>>2]=-1,i[B+76>>2]=-1,i[B+80>>2]=-1,i[B+84>>2]=-1,i[B+88>>2]=0,i[B+92>>2]=0,i[B+96>>2]=0,i[B+100>>2]=0,i[B+104>>2]=0,i[B+108>>2]=0,X[B+112>>1]=0,i[k>>2]=94924,i[B+128>>2]=0,i[B+120>>2]=0,i[B+124>>2]=0,i[B+116>>2]=1,i[B+32>>2]=1970433056,e=i[A+152>>2],i[l+32>>2]=f,i[l+28>>2]=n,i[f+4>>2]=i[f+4>>2]+1,P0(e+36|0,l+28|0),o=f+52|0,n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}n=m+52|0,i[l+32>>2]=m,i[l+28>>2]=h,i[m+4>>2]=i[m+4>>2]+1,P0(o,l+28|0),o=i[l+32>>2];i:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break i;W[i[i[o>>2]+8>>2]](o),y(o)}i[l+32>>2]=B,i[l+28>>2]=k,i[B+4>>2]=i[B+4>>2]+1,P0(n,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}k=C(120),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=99468,n=k+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[k+32>>2]=1937007212,i[k+16>>2]=99508,i[A+176>>2]=e,o=i[A+180>>2],i[A+180>>2]=k;i:{e:{if(!o){e=i[A+152>>2],i[l+32>>2]=k,i[l+28>>2]=n;break e}if(e=i[o+4>>2],i[o+4>>2]=e-1,e||(W[i[i[o>>2]+8>>2]](o),y(o)),e=i[A+152>>2],n=i[A+176>>2],k=i[A+180>>2],i[l+32>>2]=k,i[l+28>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(e+36|0,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}k=C(136),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=99588,n=k+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=111816,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1937011556,i[A+184>>2]=e,o=i[A+188>>2],i[A+188>>2]=k;i:{e:{if(!o){e=i[A+176>>2],i[l+32>>2]=k,i[l+28>>2]=n;break e}if(e=i[o+4>>2],i[o+4>>2]=e-1,e||(W[i[i[o>>2]+8>>2]](o),y(o)),e=i[A+176>>2],n=i[A+184>>2],k=i[A+188>>2],i[l+32>>2]=k,i[l+28>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(e+36|0,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}k=C(144),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=99628,n=k+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=111896,i[k+136>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1937011827,i[A+208>>2]=e,o=i[A+212>>2],i[A+212>>2]=k;i:{e:{if(!o){e=i[A+176>>2],i[l+32>>2]=k,i[l+28>>2]=n;break e}if(e=i[o+4>>2],i[o+4>>2]=e-1,e||(W[i[i[o>>2]+8>>2]](o),y(o)),e=i[A+176>>2],n=i[A+208>>2],k=i[A+212>>2],i[l+32>>2]=k,i[l+28>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(e+36|0,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}e=C(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=99668,n=e+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[e+16>>2]=111976,i[e+136>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1668576371,i[A+216>>2]=n,n=i[A+220>>2],i[A+220>>2]=e;i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}k=C(144),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=99708,n=k+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=112056,i[k+136>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1937011555,i[A+192>>2]=e,o=i[A+196>>2],i[A+196>>2]=k;i:{e:{if(!o){e=i[A+176>>2],i[l+32>>2]=k,i[l+28>>2]=n;break e}if(e=i[o+4>>2],i[o+4>>2]=e-1,e||(W[i[i[o>>2]+8>>2]](o),y(o)),e=i[A+176>>2],n=i[A+192>>2],k=i[A+196>>2],i[l+32>>2]=k,i[l+28>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(e+36|0,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}k=C(152),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=99788,n=k+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=112216,i[k+144>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1937011578,i[A+232>>2]=e,o=i[A+236>>2],i[A+236>>2]=k;i:{e:{if(!o){e=i[A+176>>2],i[l+32>>2]=k,i[l+28>>2]=n;break e}if(e=i[o+4>>2],i[o+4>>2]=e-1,e||(W[i[i[o>>2]+8>>2]](o),y(o)),e=i[A+176>>2],n=i[A+232>>2],k=i[A+236>>2],i[l+32>>2]=k,i[l+28>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(e+36|0,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}k=C(144),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=99748,n=k+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=112136,i[k+136>>2]=0,i[k+140>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1937007471,i[A+200>>2]=e,o=i[A+204>>2],i[A+204>>2]=k;i:{e:{if(!o){e=i[A+176>>2],i[l+32>>2]=k,i[l+28>>2]=n;break e}if(e=i[o+4>>2],i[o+4>>2]=e-1,e||(W[i[i[o>>2]+8>>2]](o),y(o)),e=i[A+176>>2],n=i[A+200>>2],k=i[A+204>>2],i[l+32>>2]=k,i[l+28>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(e+36|0,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}k=C(144),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=99828,n=k+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=112296,t[k+133|0]=0,t[k+134|0]=0,t[k+135|0]=0,t[k+136|0]=0,t[k+137|0]=0,t[k+138|0]=0,t[k+139|0]=0,t[k+140|0]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1937011571,i[A+224>>2]=e,o=i[A+228>>2],i[A+228>>2]=k;i:{e:{if(!o){e=i[A+176>>2],i[l+32>>2]=k,i[l+28>>2]=n;break e}if(e=i[o+4>>2],i[o+4>>2]=e-1,e||(W[i[i[o>>2]+8>>2]](o),y(o)),e=i[A+176>>2],n=i[A+224>>2],k=i[A+228>>2],i[l+32>>2]=k,i[l+28>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(e+36|0,l+28|0),n=i[l+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}i:{if(!r)break i;if(h=A+32|0,(h|0)!=(r|0))e:{i[h>>2]=i[r>>2],t[h+4|0]=u[r+4|0],i[h+8>>2]=i[r+8>>2];r:{if(i[r+12>>2]){e=b5(),i[h+12>>2]=e,K3(e,i[r+12>>2]);break r}i[h+12>>2]=0}if(i[h+16>>2]=i[r+16>>2],k=h+20|0,o=r+20|0,n=t[r+31|0],t[h+31|0]>=0){if((n|0)>=0){e=i[o+4>>2],i[k>>2]=i[o>>2],i[k+4>>2]=e,i[k+8>>2]=i[o+8>>2];break e}m1(k,i[r+20>>2],i[r+24>>2]);break e}e=(n|0)<0,R1(k,e?i[r+20>>2]:o,e?i[r+24>>2]:n)}if(i[A+40>>2]&&(e=tt(C(32),u[A+36|0]),i[l+28>>2]=0,xi(A+268|0,e),xi(l+28|0,0),e=i[A+268>>2],n=i[e>>2],i[n+108>>2]=0,i[n+104>>2]=1937006953,i[n+100>>2]=1,e=i[e+8>>2],i[e+108>>2]=0,i[e+104>>2]=1937006953,i[e+100>>2]=1),i[A+48>>2]&&(e=tt(C(32),u[A+36|0]),i[l+28>>2]=0,xi(A+272|0,e),xi(l+28|0,0),e=i[A+272>>2],n=i[e>>2],i[n+108>>2]=0,i[n+104>>2]=1937074532,i[n+100>>2]=1,e=i[e+8>>2],i[e+108>>2]=0,i[e+104>>2]=1937074532,i[e+100>>2]=1),e=t[r+31|0],!((e|0)<0?i[r+24>>2]:e))break i;Q=r+20|0,o=C(152),e=o,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=96028,I=e+16|0,e=I,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[o+60>>2]=0,i[o+64>>2]=0,i[o+52>>2]=0,i[o+56>>2]=0,i[o+72>>2]=-1,i[o+76>>2]=-1,i[o+80>>2]=-1,i[o+84>>2]=-1,i[o+116>>2]=0,i[o+88>>2]=0,i[o+92>>2]=0,i[o+96>>2]=0,i[o+100>>2]=0,i[o+104>>2]=0,i[o+108>>2]=0,X[o+112>>1]=0,i[e>>2]=93336,i[o+128>>2]=0,i[o+132>>2]=0,i[o+120>>2]=0,i[o+124>>2]=1835365473,i[o+136>>2]=0,i[o+140>>2]=0,i[o+144>>2]=0,i[o+148>>2]=0,i[o+32>>2]=1751411826,n=C(184),i[n>>2]=96188,i[n+4>>2]=0,i[n+8>>2]=0,h=n+16|0,e=h,i[e+8>>2]=0,i[e+12>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,i[n+16>>2]=92500,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,X[n+112>>1]=0,i[n+16>>2]=93496,i[n+128>>2]=0,i[n+132>>2]=0,X[n+124>>1]=0,i[n+120>>2]=0,i[n+136>>2]=0,i[n+140>>2]=0,i[n+144>>2]=0,i[n+148>>2]=0,i[n+152>>2]=0,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,k=n+168|0,i[k>>2]=0,i[k+4>>2]=0,t[n+173|0]=0,t[n+174|0]=0,t[n+175|0]=0,t[n+176|0]=0,t[n+177|0]=0,t[n+178|0]=0,t[n+179|0]=0,t[n+180|0]=0,i[n+32>>2]=1768842853,i[n+128>>2]=1970432288,e=C(48),t[e+45|0]=0,_=u[23284]|u[23285]<<8|(u[23286]<<16|u[23287]<<24),w=u[23280]|u[23281]<<8|(u[23282]<<16|u[23283]<<24),t[e+37|0]=w,t[e+38|0]=w>>>8,t[e+39|0]=w>>>16,t[e+40|0]=w>>>24,t[e+41|0]=_,t[e+42|0]=_>>>8,t[e+43|0]=_>>>16,t[e+44|0]=_>>>24,_=u[23279]|u[23280]<<8|(u[23281]<<16|u[23282]<<24),w=u[23275]|u[23276]<<8|(u[23277]<<16|u[23278]<<24),t[e+32|0]=w,t[e+33|0]=w>>>8,t[e+34|0]=w>>>16,t[e+35|0]=w>>>24,t[e+36|0]=_,t[e+37|0]=_>>>8,t[e+38|0]=_>>>16,t[e+39|0]=_>>>24,_=u[23271]|u[23272]<<8|(u[23273]<<16|u[23274]<<24),w=u[23267]|u[23268]<<8|(u[23269]<<16|u[23270]<<24),t[e+24|0]=w,t[e+25|0]=w>>>8,t[e+26|0]=w>>>16,t[e+27|0]=w>>>24,t[e+28|0]=_,t[e+29|0]=_>>>8,t[e+30|0]=_>>>16,t[e+31|0]=_>>>24,_=u[23263]|u[23264]<<8|(u[23265]<<16|u[23266]<<24),w=u[23259]|u[23260]<<8|(u[23261]<<16|u[23262]<<24),t[e+16|0]=w,t[e+17|0]=w>>>8,t[e+18|0]=w>>>16,t[e+19|0]=w>>>24,t[e+20|0]=_,t[e+21|0]=_>>>8,t[e+22|0]=_>>>16,t[e+23|0]=_>>>24,_=u[23255]|u[23256]<<8|(u[23257]<<16|u[23258]<<24),w=u[23251]|u[23252]<<8|(u[23253]<<16|u[23254]<<24),t[e+8|0]=w,t[e+9|0]=w>>>8,t[e+10|0]=w>>>16,t[e+11|0]=w>>>24,t[e+12|0]=_,t[e+13|0]=_>>>8,t[e+14|0]=_>>>16,t[e+15|0]=_>>>24,_=u[23247]|u[23248]<<8|(u[23249]<<16|u[23250]<<24),w=u[23243]|u[23244]<<8|(u[23245]<<16|u[23246]<<24),t[e|0]=w,t[e+1|0]=w>>>8,t[e+2|0]=w>>>16,t[e+3|0]=w>>>24,t[e+4|0]=_,t[e+5|0]=_>>>8,t[e+6|0]=_>>>16,t[e+7|0]=_>>>24,m1(k,e,45),Z(e),i[n+120>>2]=1,k=C(120),i[k>>2]=96148,i[k+4>>2]=0,i[k+8>>2]=0,e=k+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[e>>2]=93576,i[k+32>>2]=1768517222,i[l+32>>2]=n,i[l+28>>2]=h,i[n+4>>2]=i[n+4>>2]+1,P0(k+52|0,l+28|0),w=i[l+32>>2];e:{if(!w||(h=i[w+4>>2],i[w+4>>2]=h-1,h))break e;W[i[i[w>>2]+8>>2]](w),y(w)}i[l+36>>2]=0,i[l+28>>2]=0,i[l+32>>2]=0,_=l+28|0,h=Q,w=t[r+31|0],Q=(w|0)<0,h=Q?i[r+20>>2]:h,r=(Q?i[r+24>>2]:w)+1|0,Ft(_,h,r+h|0,r),G=C(176),i[G>>2]=96108,i[G+4>>2]=0,i[G+8>>2]=0,Q=k5(G+16|0),jr(l+8|0,Q,1,_,1),t[l+27|0]<0&&Z(i[l+16>>2]),r=C(120),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=95908,_=r+16|0,h=_,i[h+8>>2]=0,i[h+12>>2]=0,i[h+16>>2]=0,i[h+20>>2]=0,i[h+24>>2]=0,i[h+28>>2]=0,i[h+32>>2]=0,i[h>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,X[r+112>>1]=0,i[h>>2]=93256,i[r+32>>2]=1835365473,i[l+60>>2]=o,i[l+56>>2]=I,i[o+4>>2]=i[o+4>>2]+1,w=r+52|0,P0(w,l+56|0),I=i[l+60>>2];e:{if(!I||(h=i[I+4>>2],i[I+4>>2]=h-1,h))break e;W[i[i[I>>2]+8>>2]](I),y(I)}i[l+60>>2]=k,i[l+56>>2]=e,i[k+4>>2]=i[k+4>>2]+1,P0(w,l+56|0),h=i[l+60>>2];e:{if(!h||(e=i[h+4>>2],i[h+4>>2]=e-1,e))break e;W[i[i[h>>2]+8>>2]](h),y(h)}i[l+60>>2]=G,i[l+56>>2]=Q,i[G+4>>2]=i[G+4>>2]+1,P0(w,l+56|0),h=i[l+60>>2];e:{if(!h||(e=i[h+4>>2],i[h+4>>2]=e-1,e))break e;W[i[i[h>>2]+8>>2]](h),y(h)}e=i[A+136>>2],i[l+60>>2]=r,i[l+56>>2]=_,i[r+4>>2]=i[r+4>>2]+1,P0(e+36|0,l+56|0),h=i[l+60>>2];e:{if(!h||(e=i[h+4>>2],i[h+4>>2]=e-1,e))break e;W[i[i[h>>2]+8>>2]](h),y(h)}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),e=i[G+4>>2],i[G+4>>2]=e-1,e||(W[i[i[G>>2]+8>>2]](G),y(G)),e=i[l+28>>2],e&&(i[l+32>>2]=e,Z(e)),e=i[k+4>>2],i[k+4>>2]=e-1,e||(W[i[i[k>>2]+8>>2]](k),y(k)),e=i[n+4>>2],i[n+4>>2]=e-1,e||(W[i[i[n>>2]+8>>2]](n),y(n)),e=i[o+4>>2],i[o+4>>2]=e-1,e)break i;W[i[i[o>>2]+8>>2]](o),y(o)}return e=i[B+4>>2],i[B+4>>2]=e-1,e||(W[i[i[B>>2]+8>>2]](B),y(B)),e=i[m+4>>2],i[m+4>>2]=e-1,e||(W[i[i[m>>2]+8>>2]](m),y(m)),e=i[f+4>>2],i[f+4>>2]=e-1,e||(W[i[i[f>>2]+8>>2]](f),y(f)),e=i[s+4>>2],i[s+4>>2]=e-1,e||(W[i[i[s>>2]+8>>2]](s),y(s)),v=l- -64|0,A}function Q9(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0;if(t[e|0]=0,r=i[A+3212>>2],f=i[A+3208>>2],(r|0)==(f|0))return 0;i:{e:{h=i[f>>2],k=i[h+428>>2],s=i[h+424>>2];r:{f:{if((k|0)==(s|0))break f;for(k=k-s>>2,o=k>>>0<=1?1:k;;){if(k=i[s+(w<<2)>>2],i[k+40>>2]){if(w=w+1|0,(o|0)!=(w|0))continue;break f}break}if(u[k+36|0]==1&&ih(A+2140|0),t[e|0]=1,f=k,k=i[f+4>>2],r=i[k+1352>>2],(r|0)!=i[k+1356>>2])for(s=A+2140|0;r=Lu(s,i[(n<<2)+r>>2]),(r|0)>=0&&(i[i[i[A+2148>>2]+(r<<2)>>2]+100>>2]=0),n=n+1|0,r=i[k+1352>>2],n>>>0<i[k+1356>>2]-r>>2>>>0;);l=i[h>>2],r=i[l+132>>2],i[f+40>>2]=1,k=u[r+46|0],s=u[r+45|0],r=i[l+112>>2],_=i[r+1884>>2];A:{if(k|(s|(_|0)<=0))break A;o=i[r+168>>2];k:{if((o|0)>0){for(w=r+88|0,n=0;;){if(i[w+(n<<2)>>2]==1e3)break A;if(n=n+1|0,(o|0)==(n|0))break}if((o|0)>19)break k}i[r+168>>2]=o+1,i[(r+(o<<2)|0)+88>>2]=1e3}if(o=i[r+84>>2],(o|0)==20){i[r+80>>2]=1001;break A}i[r+84>>2]=o+1,i[(r+4|0)+(o<<2)>>2]=1e3}r=i[h+424>>2],n=i[h+428>>2];A:{if((r|0)==(n|0)|(f|0)!=i[r>>2]||(o=i[i[f+4>>2]+24>>2],(o|0)<=0))break A;for(n=0;r=i[l+320>>2]+g(n,76)|0,i[r>>2]<=0&&(i[r>>2]=1),n=n+1|0,(o|0)!=(n|0););r=i[h+424>>2],n=i[h+428>>2]}l=n-r>>2;A:{if(l>>>0<2)break A;for(n=1;;){if(o=(n<<2)+r|0,(f|0)!=i[o>>2]){if(n=n+1|0,(l|0)!=(n|0))continue;break A}break}if(o=i[o-4>>2],!o|i[o+40>>2]!=2||(l=l-1|0,!l))break A;for(n=0;;){if(w=(n<<2)+r|0,(o|0)!=i[w>>2]){if(n=n+1|0,(l|0)!=(n|0))continue;break A}break}if(r=i[w+4>>2],!r||(n=i[i[o+4>>2]+24>>2],(n|0)>=i[i[r+4>>2]+24>>2]))break A;for(;;){if(o=i[h>>2],i[o+144>>2]<=(n|0))break A;if(o=i[o+320>>2]+g(n,76)|0,i[o>>2]<=0&&(i[o>>2]=1),n=n+1|0,!((n|0)<i[i[r+4>>2]+24>>2]))break}}n=0;A:{if(!(k|s&&(_|0)>0)){if(k=0,l=v-18608|0,v=l,s=i[f+4>>2],r=i[s+1352>>2],(r|0)!=i[s+1356>>2]){for(o=A+2140|0;r=Lu(o,i[(k<<2)+r>>2]),(r|0)>=0&&(i[i[i[A+2148>>2]+(r<<2)>>2]+100>>2]=0),k=k+1|0,r=i[s+1352>>2],k>>>0<i[s+1356>>2]-r>>2>>>0;);s=i[f+4>>2]}if(k=6,r=i[i[h>>2]+132>>2],o0[s+24>>2]<i[r+8452>>2]-i[r+8448>>2]>>2>>>0){w=l+18572|0,i[w>>2]=0,i[w+4>>2]=0,i[l+18516>>2]=0,r=l+18508|0,i[r>>2]=0,i[r+4>>2]=0,i[l+18500>>2]=0,i[l+18504>>2]=0,r=(l+38&-16)+16|0,i[l+2104>>2]=r,l0(r,0,2048),k=i[f+4>>2],i[l+18592>>2]=k,r=i[h>>2],i[l+18600>>2]=f,i[l+18596>>2]=h,i[l+18584>>2]=A,i[l+18588>>2]=r,r=i[i[i[r+132>>2]+8448>>2]+(i[k+24>>2]<<2)>>2],i[l+18604>>2]=0,i[l+4>>2]=r,He(l),r=i[f+12>>2];k:{if((r|0)<=0){k=17;break k}vr(l+18548|0,i[f+8>>2],r);n:{if(!u[i[i[h>>2]+132>>2]+45|0]|!u[i[f+4>>2]+12|0])break n;if(r=i[i[i[A+2216>>2]+124>>2]+16900>>2]-1|0,k=i[h+472>>2],o=i[h+468>>2],s=k-o>>3,r>>>0>s>>>0){zt(h+468|0,r-s|0);break n}if(r>>>0>=s>>>0)break n;if(r=o+(r<<3)|0,(r|0)!=(k|0))for(;k=l6(k-8|0),(r|0)!=(k|0););i[h+472>>2]=r}i[f+120>>2]=1,k=0,s=0,r=i[l+18588>>2],_=i[r+132>>2],r=i[r+124>>2],o=i[r+16908>>2],B=i[l+4>>2],(o|0)>(B|0)&&(o=i[i[_+8460>>2]+(B<<2)>>2]),r=i[r+16892>>2],i[l>>2]=o,B=(o|0)/(r|0)|0,i[l+12>>2]=B,i[l+8>>2]=o-g(r,B),B=i[l+18592>>2],r=18;n:{t:{if(!PA(l)||(rr(l+18548|0),o=1,r=0,!(Sr(l,0,!u[B+20|0])&1)))break n;B=l+18572|0;o:{if(u[_+46|0]){if(k=i[l+18592>>2],s=i[k+804>>2],s>>>0>2)break t;r=0;break o}r=1}for(;;){if(!r){Ge(B,s,i[k+800>>2]),t[l+18580|0]=0,t[l+18581|0]=0,t[l+18582|0]=0,t[l+18583|0]=0,r=1;continue}for(;;){k=i[l+18592>>2],r=i[k+784>>2],s=i[k+788>>2]-r>>2,k=o-1|0;o:{if(s>>>0>k>>>0&&i[r+(k<<2)>>2]==((i[l+18552>>2]-i[l+18548>>2]|0)-2|0))break o;C2(i[l+18584>>2]+4|0,1003,1)}if(r=0,!(Sr(l,0,0)&1))break n;if(o=o+1|0,!!u[_+46|0])break}if(k=i[l+18592>>2],s=i[k+804>>2],!(s>>>0<3))break}break t}U0(23510,19977,1520,5620),M()}k=r,i[f+44>>2]<=0&&(i[f+44>>2]=1)}l6(w)}if(v=l+18608|0,r=k,i[f+40>>2]=2,k=i[h+424>>2],s=(i[h+428>>2]-k>>2)-1|0,!s)break A;for(;;){if(o=k+(n<<2)|0,(f|0)!=i[o>>2]){if(n=n+1|0,(s|0)!=(n|0))continue;break A}break}if(k=i[o+4>>2],!k||(n=i[i[f+4>>2]+24>>2],(n|0)>=i[i[k+4>>2]+24>>2]))break A;for(;;){if(f=i[h>>2],i[f+144>>2]<=(n|0))break A;if(f=i[f+320>>2]+g(n,76)|0,i[f>>2]<=0&&(i[f>>2]=1),n=n+1|0,!((n|0)<i[i[k+4>>2]+24>>2]))break}break A}if(s&&(r=1006,k))break A;if(s){s=f;k:{if(o=i[h>>2],i[o+332>>2]==(0-i[o+328>>2]|0)){w=i[f+4>>2],_=i[w+776>>2],Q=i[o+132>>2],r=i[o+124>>2],G=i[r+16892>>2];n:{if(!u[w+12|0])break n;if(r=i[r+16900>>2]-1|0,f=i[h+472>>2],l=i[h+468>>2],k=f-l>>3,r>>>0>k>>>0){zt(h+468|0,r-k|0);break n}if(r>>>0>=k>>>0)break n;if(r=l+(r<<3)|0,(r|0)!=(f|0))for(;f=l6(f-8|0),(r|0)!=(f|0););i[h+472>>2]=r}if(i[s+132>>2])break e;k=_+1|0,l=C((A2=-1,s2=L0(k,0,18608,0)|4,v2=h0,v2?A2:s2)),i[l>>2]=k,r=l+4|0;n:{if(!k){i[s+136>>2]=k,i[s+132>>2]=r;break n}for(B=r+g(k,18608)|0,f=r;I=f+18572|0,i[I>>2]=0,i[I+4>>2]=0,i[f+18516>>2]=0,I=f+18508|0,i[I>>2]=0,i[I+4>>2]=0,i[f+18500>>2]=0,i[f+18504>>2]=0,i[f+18584>>2]=0,i[f+18588>>2]=0,I=f+18592|0,i[I>>2]=0,i[I+4>>2]=0,i[f+18600>>2]=0,I=(f+38&-15)+16|0,i[f+2104>>2]=I,l0(I,0,2048),f=f+18608|0,(B|0)!=(f|0););if(i[s+136>>2]=k,i[s+132>>2]=r,(_|0)<0)break n;if(f=i[w+24>>2],B=(f|0)/(G|0)|0,_){if(f-g(B,G)|0)break n;if((_|0)==2147483647)break i}if(i[l+18596>>2]=w,k=i[o+112>>2],i[l+18604>>2]=s,i[l+18600>>2]=h,i[l+18592>>2]=o,i[l+18588>>2]=k,i[l+8>>2]=i[i[Q+8448>>2]+(f<<2)>>2],He(r),I=s+12|0,f=I,_&&(f=i[w+784>>2]),f=i[f>>2],(f|0)>i[I>>2]||(k=1,(f|0)<=0)||(vr(l+18552|0,i[s+8>>2],f),i[o+324>>2]=i[o+324>>2]+1,i[o+340>>2]=i[o+340>>2]+1,i[s+120>>2]=i[s+120>>2]+1,Mo(A,r,1,B),!_))break n;for(;;){if(i[s+136>>2]<=(k|0))break i;if(r=i[s+132>>2]+g(k,18608)|0,i[r+18592>>2]=w,f=i[o+112>>2],i[r+18600>>2]=s,i[r+18596>>2]=h,i[r+18588>>2]=o,i[r+18584>>2]=f,B=B+1|0,i[r+4>>2]=i[i[Q+8448>>2]+(g(G,B)<<2)>>2],He(r),l=k<<2,m=i[w+784>>2],f=i[(l+m|0)-4>>2],(f|0)<0||(R=l+m|0,m=(k|0)!=(_|0),l=i[(m?R:I)>>2],(l|0)>i[I>>2]|(f|0)>=(l|0)))break n;if(vr(r+18548|0,f+i[s+8>>2]|0,l-f|0),i[o+324>>2]=i[o+324>>2]+1,i[o+340>>2]=i[o+340>>2]+1,i[s+120>>2]=i[s+120>>2]+1,Mo(A,r,0,B),k=k+1|0,!m)break}}if(kf(o),r=i[h+460>>2],k=i[h+456>>2],(r|0)!=(k|0))for(f=0;o=i[(f<<2)+k>>2],o&&(W[i[i[o>>2]+4>>2]](o),k=i[h+456>>2],r=i[h+460>>2]),f=f+1|0,f>>>0<r-k>>2>>>0;);i[h+460>>2]=k;break k}U0(24004,19835,1006,21080),M()}if(i[s+40>>2]=2,r=0,f=i[h+424>>2],k=(i[h+428>>2]-f>>2)-1|0,!k)break A;for(;;){if(o=f+(n<<2)|0,(s|0)!=i[o>>2]){if(n=n+1|0,(k|0)!=(n|0))continue;break A}break}if(f=i[o+4>>2],!f||(n=i[i[s+4>>2]+24>>2],(n|0)>=i[i[f+4>>2]+24>>2]))break A;for(;;){if(k=i[h>>2],i[k+144>>2]<=(n|0))break A;if(k=i[k+320>>2]+g(n,76)|0,i[k>>2]<=0&&(i[k>>2]=1),n=n+1|0,!((n|0)<i[i[f+4>>2]+24>>2]))break}break A}k:{if(!k)break k;o=0;n:{if(l=i[h>>2],i[l+332>>2]==(0-i[l+328>>2]|0)){if(i[f+132>>2])break e;w=i[l+132>>2],G=i[i[l+124>>2]+16892>>2],I=i[f+4>>2],B=i[I+776>>2],k=B+1|0,_=C((A2=-1,s2=L0(k,0,18608,0)|4,v2=h0,v2?A2:s2)),i[_>>2]=k,r=_+4|0;t:{if(!k){i[f+136>>2]=k,i[f+132>>2]=r;break t}for(Q=r+g(k,18608)|0,s=r;m=s+18572|0,i[m>>2]=0,i[m+4>>2]=0,i[s+18516>>2]=0,m=s+18508|0,i[m>>2]=0,i[m+4>>2]=0,i[s+18500>>2]=0,i[s+18504>>2]=0,i[s+18584>>2]=0,i[s+18588>>2]=0,m=s+18592|0,i[m>>2]=0,i[m+4>>2]=0,i[s+18600>>2]=0,m=(s+38&-15)+16|0,i[s+2104>>2]=m,l0(m,0,2048),s=s+18608|0,(Q|0)!=(s|0););if(i[f+136>>2]=k,i[f+132>>2]=r,(B|0)<0)break t;if((B|0)==2147483647)break i;if(m=i[I+24>>2],k=m<<2,s=i[k+i[w+8484>>2]>>2],i[_+18596>>2]=I,Q=i[l+112>>2],i[_+18604>>2]=f,i[_+18600>>2]=h,i[_+18592>>2]=l,i[_+18588>>2]=Q,i[_+8>>2]=i[k+i[w+8448>>2]>>2],He(r),Q=f+12|0,k=Q,B&&(k=i[I+784>>2]),Y=i[k>>2],(Y|0)>i[Q>>2]){o=17;break t}if(k=1,(Y|0)<=0){o=17;break t}if(vr(_+18552|0,i[f+8>>2],Y),i[l+324>>2]=i[l+324>>2]+1,i[l+340>>2]=i[l+340>>2]+1,i[f+120>>2]=i[f+120>>2]+1,R=r,r=(m|0)/(G|0)|0,Do(A,R,1,m-g(r,G)|0,r),!B)break t;for(Y=w+8404|0,E=w+8360|0;;){if(s=s+1|0,r=i[w+48>>2],(s|0)>=(g(r,i[w+52>>2])|0)){o=1007;break t}if(i[f+136>>2]<=(k|0))break i;if(o=(s|0)/(r|0)|0,_=i[Y+(o<<2)>>2],o=i[E+(s-g(r,o)<<2)>>2],r=i[f+132>>2]+g(k,18608)|0,i[r+18592>>2]=I,m=i[l+112>>2],i[r+18600>>2]=f,i[r+18596>>2]=h,i[r+18588>>2]=l,i[r+18584>>2]=m,_=o+g(_,G)|0,i[r+4>>2]=i[i[w+8448>>2]+(_<<2)>>2],He(r),m=k<<2,V=i[I+784>>2],o=i[(m+V|0)-4>>2],(o|0)<0){o=17;break t}if(m=i[((k|0)!=(B|0)?m+V|0:Q)>>2],(m|0)>i[Q>>2]){o=17;break t}if((o|0)>=(m|0)){o=17;break t}if(vr(r+18548|0,o+i[f+8>>2]|0,m-o|0),i[l+324>>2]=i[l+324>>2]+1,i[l+340>>2]=i[l+340>>2]+1,i[f+120>>2]=i[f+120>>2]+1,o=0,R=r,r=(_|0)/(G|0)|0,Do(A,R,0,_-g(r,G)|0,r),r=(k|0)!=(B|0),k=k+1|0,!r)break}}if(kf(l),r=i[h+460>>2],k=i[h+456>>2],(r|0)!=(k|0))for(s=0;l=i[(s<<2)+k>>2],l&&(W[i[i[l>>2]+4>>2]](l),k=i[h+456>>2],r=i[h+460>>2]),s=s+1|0,s>>>0<r-k>>2>>>0;);i[h+460>>2]=k,r=o;break n}U0(24004,19835,1120,5972),M()}if(i[f+40>>2]=2,k=i[h+424>>2],s=(i[h+428>>2]-k>>2)-1|0,!s)break A;for(;;){if(o=k+(n<<2)|0,(f|0)!=i[o>>2]){if(n=n+1|0,(s|0)!=(n|0))continue;break A}break}if(k=i[o+4>>2],!k||(n=i[i[f+4>>2]+24>>2],(n|0)>=i[i[k+4>>2]+24>>2]))break A;for(;;){if(f=i[h>>2],i[f+144>>2]<=(n|0))break A;if(f=i[f+320>>2]+g(n,76)|0,i[f>>2]<=0&&(i[f>>2]=1),n=n+1|0,!((n|0)<i[i[k+4>>2]+24>>2]))break}break A}U0(13347,19835,988,10897),M()}if(r)break r;f=i[A+3208>>2],r=i[A+3212>>2]}f:{if(r-f>>>0>=5&&(s=i[f>>2],k=i[s+428>>2],i[i[k-4>>2]+40>>2]|(k|0)==i[s+424>>2]))break f;if((r|0)==(f|0))return 0;if(s=i[f>>2],f=i[s+428>>2],(f|0)!=i[s+424>>2]&&(r=0,!i[i[f-4>>2]+40>>2])||(r=0,i[A+580>>2]!=((i[A+556>>2]?-1:0)|0)))break r;if(u[A+548|0])break f;if(!(t[A+549|0]&1))break r}if(t[e|0]=1,e=i[s>>2],i[e+144>>2]>0)for(w=0;r=i[e+320>>2]+g(w,76)|0,i[r>>2]<=0&&(i[r>>2]=1),w=w+1|0,(w|0)<i[e+144>>2];);h=i[s>>2],e=i[h+112>>2],r=u[e+532|0];f:{if(i[i[i[A+2216>>2]+112>>2]+1884>>2]){if(f=1,!(r&1)){f=0,k=i[s>>2],e=i[k+112>>2],r=i[i[k+124>>2]+16900>>2]<<1,i[k+324>>2]=r+i[k+324>>2],i[k+340>>2]=r+i[k+340>>2];A:{if(i[i[k+124>>2]+16900>>2]<=0)break A;_=e+1392|0;k:{n:{for(;;){o=C(20),t[o+16|0]=1,i[o+12>>2]=f,i[o+8>>2]=k,i[o>>2]=66588,i[o+4>>2]=0,e=i[s+460>>2],l=i[s+464>>2];t:{if(e>>>0<l>>>0){i[e>>2]=o,e=e+4|0;break t}if(n=i[s+456>>2],e=e-n|0,B=e>>2,r=B+1|0,r>>>0>=1073741824)break n;if(l=l-n|0,w=l>>1,l=l>>>0>=2147483644?1073741823:r>>>0<w>>>0?w:r,l){if(l>>>0>=1073741824)break k;r=C(l<<2)}else r=0;if(w=r+e|0,i[w>>2]=o,B=w-(B<<2)|0,e&&z(B,n,e),i[s+464>>2]=r+(l<<2),e=w+4|0,i[s+460>>2]=e,i[s+456>>2]=B,!n)break t;Z(n)}if(i[s+460>>2]=e,ir(_,o),f=f+1|0,e=i[i[k+124>>2]+16900>>2],!((f|0)<(e|0)))break}if((e|0)<=0)break A;for(f=0;;){o=C(20),t[o+16|0]=0,i[o+12>>2]=f,i[o+8>>2]=k,i[o>>2]=66588,i[o+4>>2]=0,e=i[s+460>>2],l=i[s+464>>2];t:{if(e>>>0>=l>>>0){if(n=i[s+456>>2],e=e-n|0,B=e>>2,r=B+1|0,r>>>0>1073741823)break n;if(l=l-n|0,w=l>>1,l=l>>>0>=2147483644?1073741823:r>>>0<w>>>0?w:r,l){if(l>>>0>1073741823)break k;r=C(l<<2)}else r=0;if(w=r+e|0,i[w>>2]=o,B=w-(B<<2)|0,e&&z(B,n,e),i[s+464>>2]=r+(l<<2),e=w+4|0,i[s+460>>2]=e,i[s+456>>2]=B,!n)break t;Z(n);break t}i[e>>2]=o,e=e+4|0}if(i[s+460>>2]=e,ir(_,o),f=f+1|0,!((f|0)<i[i[k+124>>2]+16900>>2]))break}break A}s0(),M()}x0(),M()}f=3,e=i[h+112>>2]}if(!u[e+533|0])A:{k=f,_=v-16|0,v=_;k:{n:{n=i[s>>2],o=i[n+124>>2];t:{if(!u[o+8799|0])break t;if(l=i[n+20>>2],w=i[n+28>>2],B=i[n+24>>2],e=i[n+112>>2],i[_+8>>2]=o,r=i[n+128>>2],i[_+12>>2]=r,f=e,r&&(i[r+4>>2]=i[r+4>>2]+1,f=i[n+112>>2]),r=i[n+288>>2],G=i[n+280>>2],I=i[n+284>>2],Q=i[_+12>>2],i[_>>2]=i[_+8>>2],i[_+4>>2]=Q,Q=s+8|0,kn(Q,B,w,l,_,0,f,G,I,r,1)){C2(i[n+112>>2]+4|0,1024,0);break t}if(I=i[o+16900>>2],r=I,i[n+324>>2]=r+i[n+324>>2],i[n+340>>2]=r+i[n+340>>2],(r|0)>0)for(m=e+1392|0,o=0;;){l=C(28),i[l+20>>2]=Q,i[l+16>>2]=n,i[l>>2]=68776,i[l+4>>2]=0,i[l+12>>2]=n,i[l+24>>2]=k,i[l+8>>2]=o,e=i[s+460>>2],f=i[s+464>>2];o:{if(e>>>0<f>>>0){i[e>>2]=l,f=e+4|0;break o}if(w=i[s+456>>2],e=e-w|0,G=e>>2,r=G+1|0,r>>>0>=1073741824)break n;if(f=f-w|0,B=f>>1,f=f>>>0>=2147483644?1073741823:r>>>0<B>>>0?B:r,f){if(f>>>0>=1073741824)break k;r=C(f<<2)}else r=0;if(B=r+e|0,i[B>>2]=l,G=B-(G<<2)|0,e&&z(G,w,e),i[s+464>>2]=r+(f<<2),f=B+4|0,i[s+460>>2]=f,i[s+456>>2]=G,!w)break o;Z(w)}if(i[s+460>>2]=f,ir(m,l),o=o+1|0,(I|0)==(o|0))break}kf(n),e=i[n+4>>2],i[n+4>>2]=i[s+12>>2],i[s+12>>2]=e,e=i[n+64>>2],i[n+64>>2]=i[s+72>>2],i[s+72>>2]=e,e=i[n+292>>2],i[n+292>>2]=i[s+300>>2],i[s+300>>2]=e,e=i[n+8>>2],i[n+8>>2]=i[s+16>>2],i[s+16>>2]=e,e=i[n+68>>2],i[n+68>>2]=i[s+76>>2],i[s+76>>2]=e,e=i[n+296>>2],i[n+296>>2]=i[s+304>>2],i[s+304>>2]=e,e=i[n+12>>2],i[n+12>>2]=i[s+20>>2],i[s+20>>2]=e,e=i[n+72>>2],i[n+72>>2]=i[s+80>>2],i[s+80>>2]=e,e=i[n+300>>2],i[n+300>>2]=i[s+308>>2],i[s+308>>2]=e,e=i[n+40>>2],i[n+40>>2]=i[s+48>>2],i[s+48>>2]=e,e=i[n+44>>2],i[n+44>>2]=i[s+52>>2],i[s+52>>2]=e,e=i[n+304>>2],r=i[n+308>>2],f=i[s+316>>2],i[n+304>>2]=i[s+312>>2],i[n+308>>2]=f,i[s+312>>2]=e,i[s+316>>2]=r}v=_+16|0;break A}s0(),M()}x0(),M()}kf(h);break f}if(!(r&1)){f=0,r=0;A:{if(i[i[h+124>>2]+16900>>2]<=0)break A;for(;r=un(h,f)|r,f=f+1|0,(f|0)<i[i[h+124>>2]+16900>>2];);if(!(r&1))break A;BA(h,1,0,i[h+276>>2],i[h+272>>2]),e=i[h+272>>2],r=i[h+276>>2];k:{if(i[i[h+124>>2]+16832>>2]>=9){lA(h,1,0,r,e);break k}sA(h,1,0,r,e)}f=i[h+124>>2];k:{if(!i[f+16848>>2])break k;if(e=i[h+272>>2],r=i[h+276>>2],i[f+16840>>2]>=9){wA(h,1,0,r,e);break k}_A(h,1,0,r,e)}BA(h,0,0,i[h+276>>2],i[h+272>>2]),e=i[h+272>>2],r=i[h+276>>2];k:{if(i[i[h+124>>2]+16832>>2]>=9){lA(h,0,0,r,e);break k}sA(h,0,0,r,e)}if(f=i[h+124>>2],!i[f+16848>>2])break A;if(e=i[h+272>>2],r=i[h+276>>2],i[f+16840>>2]>=9){wA(h,0,0,r,e);break A}_A(h,0,0,r,e)}e=i[h+112>>2]}if(u[e+533|0])break f;if(e=i[h+124>>2],u[e+8799|0]){for(r=g(g(i[h+28>>2],i[h+40>>2]),(i[e+16832>>2]+7|0)/8|0),f=g(g(i[h+36>>2],i[h+44>>2]),(i[e+16840>>2]+7|0)/8|0),k=C((r|0)>(f|0)?r:f),I=i[e+16848>>2]?3:1,Q=h+4|0,f=i[e+16900>>2],n=0;;){_=Q+(n<<2)|0,m=h+(n?44:40)|0,l=i[m>>2],r=g(g(l,i[h+(n?36:28)>>2]),(i[i[h+124>>2]+(n?16840:16832)>>2]+7|0)/8|0),r&&z(k,i[_>>2],r);A:{k:{if((f|0)<=0||(r=0,o=i[e+16892>>2],(o|0)<=0))break k;for(;;){n:{if((o|0)<=0)break n;if(f=0,!n)for(;;){if(w=p[((i[h+140>>2]+g(f,24)|0)+g(g(i[h+152>>2],r),24)|0)+2>>1],o=i[h+52>>2],w>>>0>=i[h+56>>2]-o>>2>>>0||(o=i[o+(w<<2)>>2],!o))break A;t:{if(!u[o+333|0])break t;if(o=1<<i[e+16876>>2],w=i[h+40>>2],B=i[h+4>>2],i[i[h+124>>2]+16832>>2]<=8){Ie(h,f,r,0,o,o,k,l,B,w);break t}We(h,f,r,0,o,o,k,l,B,w)}if(f=f+1|0,o=i[e+16892>>2],!((f|0)<(o|0)))break n}for(;;){if(w=p[((i[h+140>>2]+g(f,24)|0)+g(g(i[h+152>>2],r),24)|0)+2>>1],o=i[h+52>>2],w>>>0>=i[h+56>>2]-o>>2>>>0||(o=i[o+(w<<2)>>2],!o))break A;t:{if(!u[o+334|0])break t;if(w=1<<i[e+16876>>2],o=(w|0)/i[e+16856>>2]|0,w=(w|0)/i[e+16852>>2]|0,B=i[m>>2],G=i[_>>2],i[i[h+124>>2]+16840>>2]>=9){We(h,f,r,n,w,o,k,l,G,B);break t}Ie(h,f,r,n,w,o,k,l,G,B)}if(f=f+1|0,o=i[e+16892>>2],!((f|0)<(o|0)))break}}if(r=r+1|0,f=i[e+16900>>2],!((r|0)<(f|0)))break}}if(n=n+1|0,(I|0)!=(n|0))continue}break}Z(k)}}r=i[s+436>>2];f:{if((r|0)==i[s+440>>2]){r=0;break f}for(w=0;;){e=0,o=0,n=v-176|0,v=n,l=g(w,80)+r|0,B=i[s>>2];A:{if(i[l>>2]!=132|u[i[B+112>>2]+512|0]!=1|!u[B+104|0])break A;for(j=l+27|0,O=l+26|0,S=l+25|0,q=l+24|0,d=l+23|0,c=l+22|0,A0=l+21|0,t0=l+20|0,_0=l+19|0,g0=l+18|0,X0=l+17|0,V0=l+16|0,C0=l+15|0,r0=l+14|0,f0=l+13|0,M0=l+12|0,z0=l+60|0,j0=l+68|0,S0=B+4|0,q0=i[i[B+124>>2]+476>>2];;){I=i[B+(o?44:40)>>2],_=i[B+(o?36:28)>>2],h=i[B+(o?32:24)>>2],Y=o<<2,Q=i[Y+S0>>2];k:{n:switch(i[l+8>>2]){case 0:r=i[i[B+124>>2]+(o?16840:16832)>>2],i[n+40>>2]=-1732584194,i[n+44>>2]=271733878,i[n+32>>2]=1732584193,i[n+36>>2]=-271733879,i[n+24>>2]=0,i[n+28>>2]=0;t:{if((_|0)>0){if((r|0)>=9){r=h<<1;o:{if((h|0)<=0){for(f=0;f||(f=C(r)),Y5(n+24|0,f,r),e=e+1|0,(_|0)!=(e|0););break o}for(E=h&2147483646,V=h&1,G=0,f=0;;){if(f||(f=C(r)),m=Q+(g(G,I)<<1)|0,e=0,k=0,(h|0)!=1)for(;Y=e<<1,N=Y+f|0,U=m+Y|0,t[N|0]=u[U|0],t[N+1|0]=u[U+1|0],Y=Y|2,N=Y+f|0,Y=m+Y|0,t[N|0]=u[Y|0],t[N+1|0]=u[Y+1|0],e=e+2|0,k=k+2|0,(E|0)!=(k|0););if(V&&(e=e<<1,k=e+f|0,e=e+m|0,t[k|0]=u[e|0],t[k+1|0]=u[e+1|0]),Y5(n+24|0,f,r),G=G+1|0,(_|0)==(G|0))break}}Wo(n,n+24|0),Z(f);break t}for(;Y5(n+24|0,Q+g(e,I)|0,h),e=e+1|0,(_|0)!=(e|0););}Wo(n,n+24|0)}e=o<<4;t:{if(u[n|0]!=u[e+M0|0]|u[n+1|0]!=u[e+f0|0]|(u[n+2|0]!=u[e+r0|0]|u[n+3|0]!=u[e+C0|0])||u[n+4|0]!=u[e+V0|0]|u[n+5|0]!=u[e+X0|0]|(u[n+6|0]!=u[e+g0|0]|u[n+7|0]!=u[e+_0|0])||u[n+8|0]!=u[e+t0|0]|u[n+9|0]!=u[e+A0|0]|(u[n+10|0]!=u[e+c|0]|u[n+11|0]!=u[e+d|0])||u[n+12|0]!=u[e+q|0]|u[n+13|0]!=u[e+S|0]|u[n+14|0]!=u[e+O|0])break t;if(u[n+15|0]==u[e+j|0])break k}e=5;break A;case 1:e=7439;t:{if((_|0)<=0)break t;if(i[i[B+124>>2]+(o?16840:16832)>>2]>=9){if(G=h<<1,(h|0)<=0){for(e=0,r=0;r||(r=C(G)),e=e+1|0,(_|0)!=(e|0););e=7439,Z(r);break t}for(N=h&2147483646,U=h&1,Y=(G|0)<=1?1:G,r2=Y&2147483646,f2=Y&1,m=0,f=0;;){if(f||(f=C(G)),k=Q+(g(m,I)<<1)|0,r=0,E=0,(h|0)!=1)for(;V=r<<1,R=V+f|0,x=k+V|0,t[R|0]=u[x|0],t[R+1|0]=u[x+1|0],V=V|2,R=V+f|0,V=k+V|0,t[R|0]=u[V|0],t[R+1|0]=u[V+1|0],r=r+2|0,E=E+2|0,(N|0)!=(E|0););if(U&&(r=r<<1,E=r+f|0,r=r+k|0,t[E|0]=u[r|0],t[E+1|0]=u[r+1|0]),r=0,(Y|0)!=1)for(E=f+1|0,k=0;R=e<<8,e=u[r+f|0]^(e&65280)>>>8,e=e>>>4^e,V=(R|e)^e<<5,e=u[r+E|0]^((V^e<<12)&65280)>>>8,e=e>>>4^e,e=(V<<8|e)^e<<5^e<<12,r=r+2|0,k=k+2|0,(r2|0)!=(k|0););if(f2&&(k=e<<8,e=u[r+f|0]^(e&65280)>>>8,e=e>>>4^e,e=(k|e)^e<<5^e<<12),m=m+1|0,(_|0)==(m|0))break}Z(f);break t}if((h|0)<=0)break t;for(m=h&2147483646,Y=h&1,G=0;;){f=Q+g(G,I)|0;o:{if((h|0)==1){r=0;break o}for(E=f+1|0,r=0,k=0;R=e<<8,e=u[r+f|0]^(e&65280)>>>8,e=e>>>4^e,V=(R|e)^e<<5,e=u[r+E|0]^((V^e<<12)&65280)>>>8,e=e>>>4^e,e=(V<<8|e)^e<<5^e<<12,r=r+2|0,k=k+2|0,(m|0)!=(k|0););}if(Y&&(k=e<<8,e=u[r+f|0]^(e&65280)>>>8,e=e>>>4^e,e=(k|e)^e<<5^e<<12),G=G+1|0,(_|0)==(G|0))break}}if(p[(o<<1)+z0>>1]==(e&65535))break k;e=5;break A;case 2:break n;default:break k}e=(h|0)>0&(_|0)>0;n:{if(i[i[B+124>>2]+(o?16840:16832)>>2]>=9){if(!e){r=0;break n}for(E=h&2147483646,V=h&1,r=0,f=0;;){if(G=Q+g(f,I)|0,e=0,k=0,(h|0)!=1)for(;N=(e^f)>>>8^f,U=e|1,m=(N^U)&255,R=r,r=(e^N)&255,r=(m+((R+r|0)+(r^u[e+G|0])|0)|0)+(m^u[G+U|0])|0,e=e+2|0,k=k+2|0,(E|0)!=(k|0););if(V&&(k=r,r=((e^f)>>>8^f^e)&255,r=(k+r|0)+(r^u[e+G|0])|0),f=f+1|0,(_|0)==(f|0))break}break n}if(!e){r=0;break n}for(m=h&2147483646,E=h&1,r=0,f=0;;){if(G=Q+g(f,I)|0,e=0,k=0,(h|0)!=1)for(;V=(e^f)>>>8^f,N=e|1,r=((V^N)&255^u[G+N|0])+((u[e+G|0]^(e^V)&255)+r|0)|0,e=e+2|0,k=k+2|0,(m|0)!=(k|0););if(E&&(r=(u[e+G|0]^((e^f)>>>8^f^e)&255)+r|0),f=f+1|0,(_|0)==(f|0))break}}if(i[Y+j0>>2]==(r|0))break k;e=5;break A}if(e=0,!q0)break A;if(r=o>>>0<2,o=o+1|0,!r)break}}if(v=n+176|0,r=e,r)break f;if(w=w+1|0,r=i[s+436>>2],!(w>>>0<(i[s+440>>2]-r|0)/80>>>0))break}r=0}if(o=i[s>>2],o){if(!(u[o+104|0]!=1|(t[A+514|0]&1?u[o+312|0]:0)))f:{if(k=A+2140|0,e=i[k+24>>2],h=i[k+28>>2],e>>>0<h>>>0){i[e>>2]=o,i[k+24>>2]=e+4;break f}A:{if(n=i[k+20>>2],e=e-n|0,_=e>>2,f=_+1|0,f>>>0<1073741824){if(h=h-n|0,l=h>>1,h=h>>>0>=2147483644?1073741823:f>>>0<l>>>0?l:f,h){if(h>>>0>=1073741824)break A;f=C(h<<2)}else f=0;l=f+e|0,i[l>>2]=o,_=l-(_<<2)|0,e&&z(_,n,e),i[k+28>>2]=f+(h<<2),e=l+4|0,i[k+24>>2]=e,i[k+20>>2]=_,n&&Z(n),i[k+24>>2]=e;break f}s0(),M()}x0(),M()}e=i[o+116>>2],e?e=i[(e+g(i[e+8>>2],12)|0)+480>>2]:e=0,(e|0)<i[A+2164>>2]-i[A+2160>>2]>>2&&eo(A+2140|0)}Z(at(s)),f=i[A+3212>>2],e=i[A+3208>>2],k=f-e|0;f:{if(k>>>0<5||(k=k-4|0,!k))break f;z(e,e+4|0,k)}i[A+3212>>2]=f-4}return r}U0(21136,19835,172,4808),M()}U0(4833,11941,174,3397),M()}function tv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],s=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(s,n),t[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,s=R0(n),i[s>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(D0(F(k,34691,9),u[e+97|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35481,27),u[e+98|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35468,12),u[e+99|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35652,17),u[e+100|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35686,12),u[e+101|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35556,20),u[e+102|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35529,10),u[e+103|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35675,10),u[e+104|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35592,11),u[e+105|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35540,10),u[e+106|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(D0(F(k,35188,20),u[e+108|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(D0(F(k,34516,13),u[e+109|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,35150,7),i[e+112>>2]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,33388,8),i[e+116>>2]),47878,1);i:{if((u[e+108|0]-1&255)>>>0>1||(n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,37144,33),u[e+121|0]),47878,1),u[e+108|0]!=1))break i;n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(i1(F(f+8|0,37178,31),u[e+122|0]),47878,1)}k=f+8|0,F(D0(F(k,35057,11),u[e+120|0]),47878,1),u[e+101|0]==1&&F(i1(F(k,37240,24),u[e+123|0]),47878,1),k=f+8|0,F(D0(F(k,34001,18),p[e+124>>1]),47878,1),F(D0(F(k,34092,26),p[e+126>>1]),47878,1),F(D0(F(k,33644,21),p[e+128>>1]),47878,1);i:{if(u[e+98|0]!=1||(k=F(k,36550,11),n=f+148|0,z1(n,i[e+132>>2]),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(F(B0(F(F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),30581,2),i[e+132>>2]),30255,1),47878,1),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(f+8|0,36530,19),n=f+148|0,z1(n,i[e+136>>2]),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(F(B0(F(F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),30581,2),i[e+136>>2]),30255,1),47878,1),t[f+159|0]>=0))break i;Z(i[f+148>>2])}i:{if(u[e+103|0]!=1)break i;k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35577,14),u[e+140|0]),47878,1);e:{if(u[e+140|0]!=1)break e;n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,35113,15),i[e+144>>2]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,33328,16),i[e+148>>2]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(D0(F(k,33636,29),u[e+152|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35644,25),u[e+153|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(D0(F(k,35180,28),u[e+154|0]),47878,1);r:{if((u[e+154|0]-1&255)>>>0>1||(n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,37064,40),u[e+155|0]),47878,1),u[e+154|0]!=1))break r;n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(i1(F(f+8|0,37105,38),u[e+156|0]),47878,1)}if(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35460,20),u[e+157|0]),47878,1),F(D0(F(k,35049,19),u[e+158|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35670,15),u[e+159|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35551,25),u[e+160|0]),47878,1),u[e+160|0]!=1)break e;F(D0(F(k,33996,23),p[e+162>>1]),47878,1),F(D0(F(k,34087,31),p[e+164>>1]),47878,1),F(D0(F(k,33609,26),p[e+166>>1]),47878,1),F(i1(F(k,35621,22),u[e+168|0]),47878,1)}e:{if(i[e+172>>2]){k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,34768,30),p[i[e+172>>2]+98>>1]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,34839,34),p[i[e+172>>2]+100>>1]),47878,1);break e}k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,47486,10)}e:{if(i[e+180>>2]){k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(k,37714,30),F(B0(F(B0(F(k,30582,1),p[i[e+180>>2]+100>>1]),22872,1),p[i[e+180>>2]+106>>1]),37810,3),F(B0(F(B0(F(k,30582,1),p[i[e+180>>2]+102>>1]),22872,1),p[i[e+180>>2]+108>>1]),37810,3),F(B0(F(B0(F(k,30582,1),p[i[e+180>>2]+104>>1]),22872,1),p[i[e+180>>2]+110>>1]),47877,2),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(B0(F(k,30549,25),p[i[e+180>>2]+112>>1]),22872,1),p[i[e+180>>2]+114>>1]),47877,2),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,36829,38),i[i[e+180>>2]+116>>2]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36873,38),i[i[e+180>>2]+120>>2]),47878,1);break e}k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,47470,10)}e:{if(i[e+188>>2]){if(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35279,33),u[i[e+188>>2]+97|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35367,43),u[i[e+188>>2]+128|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35318,43),u[i[e+188>>2]+136|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+8|0,F(i1(F(n,35416,43),u[i[e+188>>2]+144|0]),47878,1),k=i[e+188>>2],u[k+97|0]==1&&(k=f+148|0,k0(k,r),o=n,l=k,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(k,37750,26),F(D0(F(D0(F(k,30582,1),i[i[e+188>>2]+100>>2]),22872,1),i[i[e+188>>2]+112>>2]),37810,3),F(D0(F(D0(F(k,30582,1),i[i[e+188>>2]+104>>2]),22872,1),i[i[e+188>>2]+116>>2]),37810,3),F(D0(F(D0(F(k,30582,1),i[i[e+188>>2]+108>>2]),22872,1),i[i[e+188>>2]+120>>2]),47877,2),k=i[e+188>>2]),u[k+128|0]==1&&(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36095,30),i[i[e+188>>2]+124>>2]),47878,1),k=i[e+188>>2]),u[k+136|0]==1&&(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36059,30),i[i[e+188>>2]+132>>2]),47878,1),k=i[e+188>>2]),u[k+144|0]!=1)break e;k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36131,30),i[i[e+188>>2]+140>>2]),47878,1);break e}k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,47454,10)}e:{if(i[e+196>>2]){k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,34554,27),i[i[e+196>>2]+100>>2]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,33182,22),p[i[e+196>>2]+104>>1]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,32915,22),p[i[e+196>>2]+106>>1]),47878,1);break e}k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,47502,10)}if(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35609,11),u[e+169|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35262,11),u[e+170|0]),47878,1),u[e+140|0]!=1)break i;e:{if(i[e+208>>2]){n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,34732,35),p[i[e+208>>2]+98>>1]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,34799,39),p[i[e+208>>2]+100>>1]),47878,1);break e}k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,47481,15)}e:{if(i[e+216>>2]){k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(k,37709,35),F(B0(F(B0(F(k,30582,1),p[i[e+216>>2]+100>>1]),22872,1),p[i[e+216>>2]+106>>1]),37810,3),F(B0(F(B0(F(k,30582,1),p[i[e+216>>2]+102>>1]),22872,1),p[i[e+216>>2]+108>>1]),37810,3),F(B0(F(B0(F(k,30582,1),p[i[e+216>>2]+104>>1]),22872,1),p[i[e+216>>2]+110>>1]),47877,2),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(B0(F(k,30544,30),p[i[e+216>>2]+112>>1]),22872,1),p[i[e+216>>2]+114>>1]),47877,2),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,36824,43),i[i[e+216>>2]+116>>2]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36868,43),i[i[e+216>>2]+120>>2]),47878,1);break e}k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,47465,15)}e:{if(i[e+224>>2]){if(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35274,38),u[i[e+224>>2]+97|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35362,48),u[i[e+224>>2]+128|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35313,48),u[i[e+224>>2]+136|0]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+8|0,F(i1(F(n,35411,48),u[i[e+224>>2]+144|0]),47878,1),k=i[e+224>>2],u[k+97|0]==1&&(k=f+148|0,k0(k,r),o=n,l=k,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(k,37745,31),F(D0(F(D0(F(k,30582,1),i[i[e+224>>2]+100>>2]),22872,1),i[i[e+224>>2]+112>>2]),37810,3),F(D0(F(D0(F(k,30582,1),i[i[e+224>>2]+104>>2]),22872,1),i[i[e+224>>2]+116>>2]),37810,3),F(D0(F(D0(F(k,30582,1),i[i[e+224>>2]+108>>2]),22872,1),i[i[e+224>>2]+120>>2]),47877,2),k=i[e+224>>2]),u[k+128|0]==1&&(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36090,35),i[i[e+224>>2]+124>>2]),47878,1),k=i[e+224>>2]),u[k+136|0]==1&&(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36054,35),i[i[e+224>>2]+132>>2]),47878,1),k=i[e+224>>2]),u[k+144|0]!=1)break e;k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36126,35),i[i[e+224>>2]+140>>2]),47878,1);break e}k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,47449,15)}e:{if(i[e+232>>2]){k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,34549,32),i[i[e+232>>2]+100>>2]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,33177,27),p[i[e+232>>2]+104>>1]),47878,1),n=f+148|0,k0(n,r),o=k,l=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,32910,27),p[i[e+232>>2]+106>>1]),47878,1);break e}k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,47497,15)}k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35604,16),u[e+204|0]),47878,1),n=f+148|0,k0(n,r),o=k,r=t[f+159|0],k=(r|0)<0,F(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(i1(F(f+8|0,35257,16),u[e+205|0]),47878,1)}!i[e+320>>2]|u[e+101|0]!=1|i[e+244>>2]==i[e+240>>2]||F(B0(F(f+8|0,35868,29),i[e+244>>2]-i[e+240>>2]|0),47878,1),!(t[e+140|0]&1)|u[e+103|0]!=1|i[e+256>>2]==i[e+252>>2]||F(B0(F(f+8|0,35898,32),i[e+256>>2]-i[e+252>>2]|0),47878,1),i[e+268>>2]!=i[e+264>>2]&&F(B0(F(f+8|0,35839,28),i[e+268>>2]-i[e+264>>2]|0),47878,1),u[e+104|0]==1&&F(B0(F(f+8|0,36029,15),i[e+280>>2]-i[e+276>>2]|0),47878,1),r=u[e+140|0],k=u[e+103|0],!(t[e+159|0]&1)|(!(r&1)|(k|0)!=1)||(F(B0(F(f+8|0,36024,20),i[e+292>>2]-i[e+288>>2]|0),47878,1),k=u[e+103|0],r=u[e+140|0]),!(k&1)|!(r&1)|i[e+304>>2]==i[e+300>>2]||F(B0(F(f+8|0,36e3,23),i[e+304>>2]-i[e+300>>2]|0),47878,1),!i[e+320>>2]|u[e+101|0]!=1||F(B0(F(M2(F(f+8|0,33482,24),i[e+312>>2],i[e+316>>2]),36045,8),i[e+320>>2]),47878,1),!i[e+352>>2]|(!(t[e+140|0]&1)|u[e+103|0]!=1)||F(B0(F(M2(F(f+8|0,33431,26),i[e+344>>2],i[e+348>>2]),36045,8),i[e+352>>2]),47878,1),r=f+8|0,F(B0(F(M2(F(r,33458,23),i[e+328>>2],i[e+332>>2]),36045,8),i[e+336>>2]),47878,1),u[e+105|0]==1&&F(B0(F(M2(F(r,33507,18),i[e+360>>2],i[e+364>>2]),36045,8),i[e+368>>2]),47878,1),u[e+106|0]==1&&F(B0(F(M2(F(f+8|0,33413,17),i[e+376>>2],i[e+380>>2]),36045,8),i[e+384>>2]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[s>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(s),Y0(f- -64|0),v=f+160|0}function G6(A,e,r,f,k,n,o,l,s){var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0;h=v-160|0,v=h,U=ws(),uu(U,l),w=i[e>>2],B=i[w+192>>2],l=i[w+188>>2];i:{e:{if(!$2(w,6)||(V8(i[e>>2],6)|0)==(l|0)&&(p8(i[e>>2],6)|0)==(B|0))break e;e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,r=A+8|0;r:{if(t[114951]>=0){e=i[28736],i[r>>2]=i[28735],i[r+4>>2]=e,i[r+8>>2]=i[28737];break r}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}if(!(f-4>>>0>4294967292|r)){e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,r=A+8|0;e:{if(t[114951]>=0){e=i[28736],i[r>>2]=i[28735],i[r+4>>2]=e,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}if(t[h+158|0]=1,X[h+156>>1]=2,i[h+152>>2]=131074,i[h+144>>2]=8,i[h+148>>2]=0,l=i[e>>2],i[h+132>>2]=i[l+196>>2],i[h+136>>2]=i[l+200>>2],$2(l,6)?l=1:(l=i[i[e>>2]+200>>2],l=43008>>>l&l>>>0<16),t[h+140|0]=l,r8(i[e>>2])&&(B=i[e>>2],l=p[B+6>>1]|p[B+8>>1]<<16,B=p[B+10>>1]|p[B+12>>1]<<16,t[h+158|0]=B>>>16,X[h+156>>1]=B,i[h+152>>2]=l),eh(h+152|0),l=i[e>>2],Q=h+120|0,B=Q,i[B+4>>2]=0,i[B+8>>2]=0,I=B+4|0,i[B>>2]=I,N=i[l+204>>2],G=i[l+208>>2],(N|0)!=(G|0))for(;;){E=i[N>>2],B=I,l=B,w=i[l>>2];e:{r:{if(!w)break r;for(;;){if(l=w,B=i[l+16>>2],(B|0)>(E|0)){if(B=l,w=i[l>>2],w)continue;break r}if((B|0)>=(E|0))break e;if(w=i[l+4>>2],!w)break}B=l+4|0}w=C(20),i[w+8>>2]=l,i[w>>2]=0,i[w+4>>2]=0,i[w+16>>2]=E,i[B>>2]=w,l=i[i[Q>>2]>>2],l&&(i[Q>>2]=l),G1(i[Q+4>>2],w),i[Q+8>>2]=i[Q+8>>2]+1}if(N=N+56|0,(G|0)==(N|0))break}A0=h,t0=K0(i[e>>2],i[i[h+120>>2]+16>>2]),i[A0+144>>2]=t0;e:{if(u[h+140|0]!=1||!$2(i[e>>2],6))break e;A0=h,t0=K0(i[e>>2],6),i[A0+148>>2]=t0}i[h+112>>2]=i[h+156>>2],l=i[h+152>>2],i[h+104>>2]=i[h+148>>2],i[h+108>>2]=l,l=i[h+144>>2],i[h+96>>2]=i[h+140>>2],i[h+100>>2]=l,l=i[h+136>>2],i[h+88>>2]=i[h+132>>2],i[h+92>>2]=l,i[h+92>>2]=f,i[h+88>>2]=r,r=u[k+3|0]|u[k+4|0]<<8|(u[k+5|0]<<16|u[k+6|0]<<24),t[h+111|0]=r,t[h+112|0]=r>>>8,t[h+113|0]=r>>>16,t[h+114|0]=r>>>24,i[h+108>>2]=p[k>>1]|p[k+2>>1]<<16,p[h+112>>1]==2&&(X[h+112>>1]=p[h+156>>1]),p[h+108>>1]==2&&(X[h+108>>1]=p[h+152>>1]),p[h+110>>1]==2&&(X[h+110>>1]=p[h+154>>1]),r=1;e:{r:switch(f|0){case 10:case 12:case 14:r=3;break e;case 11:case 13:case 15:r=4;break e;case 0:case 1:case 2:case 3:case 99:break e;default:break r}r=0}e:{if((r|0)>=2){t[h+96|0]=43008>>>f&f>>>0<16;break e}if(i[U+4>>2]){t[h+96|0]=0;break e}t[h+96|0]=u[h+140|0]}if(n&&(i[h+100>>2]=n),r=(f&-4)!=12,(f&-2)!=10?l=i[h+100>>2]:(i[h+100>>2]=8,l=8),r|(l|0)>8||(i[h+100>>2]=10,l=10),i[h+104>>2]=l,i[h+44>>2]=0,i[h+36>>2]=0,i[h+40>>2]=0,Y=h+132|0,m=h+88|0,_=v-80|0,v=_,f=i[h+40>>2],k=i[h+36>>2],(f|0)!=(k|0))for(;;){n=i[f-60>>2];e:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break e;W[i[i[n>>2]+8>>2]](n),y(n)}if(f=f+-64|0,(k|0)==(f|0))break}i[h+40>>2]=k,r=i[o+12>>2],i[h+56>>2]=i[o+8>>2],i[h+60>>2]=r,r=i[o+4>>2],i[h+48>>2]=i[o>>2],i[h+52>>2]=r,r=i[U+20>>2],i[h+80>>2]=i[U+16>>2],i[h+84>>2]=r,r=i[U+12>>2],i[h+72>>2]=i[U+8>>2],i[h+76>>2]=r,r=i[U+4>>2],i[h+64>>2]=i[U>>2],i[h+68>>2]=r,f=i[Y>>2];e:{r:{if((f|0)!=i[m>>2]|i[Y+4>>2]!=i[m+4>>2]||(r=u[Y+8|0],(r|0)!=u[m+8|0])||(k=i[Y+12>>2],(k|0)!=i[m+12>>2])||r&&(r=i[Y+16>>2],n=r||k,r=i[m+16>>2],(n|0)!=((r||k)|0)))break r;if(B=1,f||of(Y+20|0,m+20|0))break e}kA(),i[_+76>>2]=0,i[_+68>>2]=0,i[_+72>>2]=0,i[_+64>>2]=0,i[_+56>>2]=0,i[_+60>>2]=0,i[_+8>>2]=-1,i[_+40>>2]=0,i[_+52>>2]=0;r:{f:{A:{G=i[_+60>>2],r=i[_+64>>2];k:{if(G>>>0<r>>>0){I=i[_+52>>2],r=i[_+8>>2],i[G+4>>2]=0,i[G+8>>2]=0,i[G>>2]=r,t[G+38|0]=1,X[G+36>>1]=2,i[G+28>>2]=0,i[G+32>>2]=131074,i[G+24>>2]=8,t[G+20|0]=0,i[G+12>>2]=99,i[G+16>>2]=99,w=i[Y+24>>2],B=i[Y+16>>2],l=i[Y+20>>2],n=i[Y+8>>2],k=i[Y+12>>2],f=i[Y>>2],r=i[Y+4>>2],i[G+40>>2]=I,i[G+20>>2]=n,i[G+24>>2]=k,i[G+28>>2]=B,i[G+32>>2]=l,i[G+36>>2]=w,i[G+12>>2]=f,i[G+16>>2]=r,r=G+44|0;break k}if(B=i[_+56>>2],l=G-B|0,k=((l|0)/44|0)+1|0,k>>>0>=97612894)break A;if(f=(r-B|0)/44|0,r=f<<1,n=f>>>0>=48806446?97612893:r>>>0>k>>>0?r:k,n){if(n>>>0>=97612894)break f;r=C(g(n,44))}else r=0;if(k=i[_+52>>2],f=i[_+8>>2],w=r+l|0,i[w+4>>2]=0,i[w+8>>2]=0,i[w>>2]=f,f=i[Y+4>>2],i[w+12>>2]=i[Y>>2],i[w+16>>2]=f,f=i[Y+12>>2],i[w+20>>2]=i[Y+8>>2],i[w+24>>2]=f,f=i[Y+20>>2],i[w+28>>2]=i[Y+16>>2],i[w+32>>2]=f,i[w+36>>2]=i[Y+24>>2],i[w+40>>2]=k,f=w+g((l|0)/-44|0,44)|0,l&&z(f,B,l),i[_+64>>2]=r+g(n,44),r=w+44|0,i[_+60>>2]=r,i[_+56>>2]=f,!B)break k;Z(B)}i[_+60>>2]=r;break r}s0(),M()}x0(),M()}f=i[_+60>>2],k=i[_+56>>2],B=0;r:{if((f|0)==(k|0))break r;for(j=m+20|0;;){f=f-k|0;f:{if((f|0)<=0){V=-1;break f}r=(f>>>0)/44|0,r=r>>>0<=1?1:r,O=r&3,B=0;A:{if(f>>>0<176){r=2147483647,V=-1,f=0;break A}for(E=r&67108860,f=0,r=2147483647,V=-1,N=0;l=i[(g(f,44)+k|0)+40>>2],S=(l|0)<(r|0),G=f|1,n=i[(g(G,44)+k|0)+40>>2],r=S?l:r,q=(n|0)<(r|0),I=f|2,w=i[(g(I,44)+k|0)+40>>2],r=q?n:r,Q=(w|0)<(r|0),l=f|3,n=i[(g(l,44)+k|0)+40>>2],r=Q?w:r,w=(n|0)<(r|0),r=w?n:r,V=w?l:Q?I:q?G:S?f:V,f=f+4|0,N=N+4|0,(E|0)!=(N|0););}if(!O)break f;for(;n=i[(g(f,44)+k|0)+40>>2],l=(n|0)<(r|0),r=l?n:r,V=l?f:V,f=f+1|0,B=B+1|0,(O|0)!=(B|0););}l=g(V,44),w=l+k|0;f:{if(f=i[_+72>>2],r=i[_+76>>2],f>>>0<r>>>0){i[f>>2]=i[w>>2],i[f+4>>2]=i[w+4>>2],r=i[w+8>>2],i[f+8>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[w+16>>2],i[f+12>>2]=i[w+12>>2],i[f+16>>2]=r,r=i[w+40>>2],i[f+36>>2]=i[w+36>>2],i[f+40>>2]=r,r=i[w+32>>2],i[f+28>>2]=i[w+28>>2],i[f+32>>2]=r,r=i[w+24>>2],i[f+20>>2]=i[w+20>>2],i[f+24>>2]=r,i[_+72>>2]=f+44;break f}A:{if(k=i[_+68>>2],B=f-k|0,n=((B|0)/44|0)+1|0,n>>>0<97612894){if(f=(r-k|0)/44|0,r=f<<1,r=f>>>0>=48806446?97612893:r>>>0>n>>>0?r:n,r>>>0>=97612894)break A;n=g(r,44),f=C(n),I=f+B|0,i[I>>2]=i[w>>2],i[I+4>>2]=i[w+4>>2],r=i[w+8>>2],i[I+8>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1,k=i[_+68>>2],B=i[_+72>>2]-k|0),r=i[w+16>>2],i[I+12>>2]=i[w+12>>2],i[I+16>>2]=r,r=i[w+40>>2],i[I+36>>2]=i[w+36>>2],i[I+40>>2]=r,r=i[w+32>>2],i[I+28>>2]=i[w+28>>2],i[I+32>>2]=r,r=i[w+24>>2],i[I+20>>2]=i[w+20>>2],i[I+24>>2]=r,w=I+g((B|0)/-44|0,44)|0,B&&z(w,k,B),i[_+76>>2]=f+n,r=I+44|0,i[_+72>>2]=r,i[_+68>>2]=w,k&&Z(k),i[_+72>>2]=r;break f}s0(),M()}x0(),M()}l=l+i[_+56>>2]|0,k=i[_+60>>2],i[l>>2]=i[k-44>>2],r=i[k-40>>2],f=i[k-36>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[l+4>>2]=r,n=i[l+8>>2],i[l+8>>2]=f;f:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break f;W[i[i[n>>2]+8>>2]](n),y(n)}f=k-32|0,r=i[f+4>>2],i[l+12>>2]=i[f>>2],i[l+16>>2]=r,r=i[f+28>>2],i[l+36>>2]=i[f+24>>2],i[l+40>>2]=r,r=i[f+20>>2],i[l+28>>2]=i[f+16>>2],i[l+32>>2]=r,r=i[f+12>>2],i[l+20>>2]=i[f+8>>2],i[l+24>>2]=r,f=i[_+60>>2],k=i[f-36>>2];f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;W[i[i[k>>2]+8>>2]](k),y(k)}i[_+60>>2]=f-44;f:{if(r=i[_+72>>2],k=i[r-32>>2],(k|0)!=i[m>>2]|i[r-28>>2]!=i[m+4>>2]||(f=u[r-24|0],(f|0)!=u[m+8|0])||(n=i[r-20>>2],(n|0)!=i[m+12>>2])||f&&(f=i[r-16>>2],l=f||n,f=i[m+16>>2],(l|0)!=((f||n)|0)))break f;if(!k){if(!of(r-12|0,j))break f;r=i[_+72>>2]}k=i[_+68>>2],r=((r-k|0)/44|0)-1|0;A:{k:{if(r){for(f=0;n=f,f=f+1|0,r=i[k+g(r,44)>>2],!!r;);if(o=i[h+40>>2],r=o,B=i[h+36>>2],k=r-B>>6,n>>>0<k>>>0)break k;n:{if(w=f-k|0,n=i[h+44>>2],w>>>0<=n-r>>6>>>0){if(w){for(r=(w<<6)+r|0;i[o+56>>2]=0,i[o+60>>2]=0,i[o+48>>2]=0,i[o+52>>2]=0,i[o+40>>2]=0,i[o+44>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=99,i[o+12>>2]=99,t[o+62|0]=1,X[o+60>>1]=2,X[o+56>>1]=2,X[o+58>>1]=2,i[o+48>>2]=8,i[o+40>>2]=99,i[o+36>>2]=99,t[o+34|0]=1,X[o+32>>1]=2,X[o+28>>1]=2,X[o+30>>1]=2,i[o+20>>2]=8,o=o- -64|0,(r|0)!=(o|0););o=r}i[h+40>>2]=o;break n}t:{if(k=i[h+36>>2],r=o-k|0,l=w+(r>>6)|0,l>>>0<67108864){if(n=n-k|0,k=n>>5,B=n>>>0>=2147483584?67108863:k>>>0>l>>>0?k:l,B){if(B>>>0>=67108864)break t;k=C(B<<6)}else k=0;for(n=k+r|0,l=n+(w<<6)|0,r=n;i[r+56>>2]=0,i[r+60>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=99,i[r+12>>2]=99,t[r+62|0]=1,X[r+60>>1]=2,X[r+56>>1]=2,X[r+58>>1]=2,i[r+48>>2]=8,i[r+40>>2]=99,i[r+36>>2]=99,t[r+34|0]=1,X[r+32>>1]=2,X[r+28>>1]=2,X[r+30>>1]=2,i[r+20>>2]=8,r=r- -64|0,(l|0)!=(r|0););r=n,n=o,o=i[h+36>>2],n=n-o|0,r=r-n|0,n&&z(r,o,n),i[h+44>>2]=k+(B<<6),i[h+40>>2]=l,i[h+36>>2]=r,o&&Z(o);break n}s0(),M()}x0(),M()}break A}r=i[h+40>>2],B=i[h+36>>2],k=r-B>>6,f=0}if(f>>>0>=k>>>0)break A;if(n=(f<<6)+B|0,(n|0)!=(r|0))for(;;){o=i[r-60>>2];k:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break k;W[i[i[o>>2]+8>>2]](o),y(o)}if(r=r+-64|0,(n|0)==(r|0))break}i[h+40>>2]=n}if(r=i[h+36>>2],k=i[_+68>>2],o=((i[_+72>>2]-k|0)/44|0)-1|0,o){n=f-1|0,l=(n<<6)+r|0,k=k+g(o,44)|0,r=i[k+4>>2],k=i[k+8>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[l>>2]=r,B=i[l+4>>2],i[l+4>>2]=k;A:{if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break A;W[i[i[B>>2]+8>>2]](B),y(B)}if(k=i[h+36>>2]+(n<<6)|0,B=i[_+68>>2],n=B+g(o,44)|0,r=i[n+16>>2],i[k+36>>2]=i[n+12>>2],i[k+40>>2]=r,i[k+60>>2]=i[n+36>>2],r=i[n+32>>2],i[k+52>>2]=i[n+28>>2],i[k+56>>2]=r,r=i[n+24>>2],i[k+44>>2]=i[n+20>>2],i[k+48>>2]=r,V=i[n>>2],V)for(k=1;;){l=(k^-1)+f<<6,w=l+i[h+36>>2]|0,o=g(V,44),n=o+B|0,r=i[n+4>>2],n=i[n+8>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[w>>2]=r,B=i[w+4>>2],i[w+4>>2]=n;A:{if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break A;W[i[i[B>>2]+8>>2]](B),y(B)}if(B=i[_+68>>2],w=o+B|0,r=i[w+16>>2],n=l+i[h+36>>2]|0,i[n+36>>2]=i[w+12>>2],i[n+40>>2]=r,i[n+60>>2]=i[w+36>>2],r=i[w+32>>2],i[n+52>>2]=i[w+28>>2],i[n+56>>2]=r,r=i[w+24>>2],i[n+44>>2]=i[w+20>>2],i[n+48>>2]=r,r=i[h+36>>2],n=r+(f-k<<6)|0,o=r+l|0,r=i[o+40>>2],i[n+8>>2]=i[o+36>>2],i[n+12>>2]=r,i[n+32>>2]=i[o+60>>2],r=i[o+56>>2],i[n+24>>2]=i[o+52>>2],i[n+28>>2]=r,r=i[o+48>>2],i[n+16>>2]=i[o+44>>2],i[n+20>>2]=r,k=k+1|0,V=i[w>>2],!V)break}r=i[h+36>>2]}f=i[Y+4>>2],i[r+8>>2]=i[Y>>2],i[r+12>>2]=f,i[r+32>>2]=i[Y+24>>2],f=i[Y+20>>2],i[r+24>>2]=i[Y+16>>2],i[r+28>>2]=f,f=i[Y+12>>2],i[r+16>>2]=i[Y+8>>2],i[r+20>>2]=f,k=i[_+56>>2],B=1;break r}if(B=i[28782],x=i[28783],(B|0)!=(x|0))for(;;){if(r=i[B>>2],W[i[i[r>>2]+8>>2]](_+40|0,r,i[_+72>>2]-32|0,m,o,U),f=i[_+40>>2],d=i[_+44>>2],(f|0)!=(d|0)){f:{A:{for(;;){k:{E=i[_+72>>2],I=i[E-4>>2],w=i[f+28>>2],r=i[_+68>>2];n:{if((E|0)!=(r|0))for(l=f+20|0;;){n=i[r+12>>2];t:{if((n|0)!=i[f>>2]|i[r+16>>2]!=i[f+4>>2]||(k=u[r+20|0],(k|0)!=u[f+8|0])||(G=i[r+24>>2],(G|0)!=i[f+12>>2])||k&&(k=i[r+28>>2],Q=k||G,k=i[f+16>>2],(Q|0)!=((k||G)|0)))break t;if(n||of(r+32|0,l))break n}if(r=r+44|0,(E|0)==(r|0))break}if(r=i[_+56>>2],k=i[_+60>>2],(r|0)!=(k|0)){for(N=w+I|0,w=f+20|0;;){t:{if(l=i[r+12>>2],(l|0)!=i[f>>2]|i[r+16>>2]!=i[f+4>>2]||(n=u[r+20|0],(n|0)!=u[f+8|0])||(I=i[r+24>>2],(I|0)!=i[f+12>>2])||n&&(n=i[r+28>>2],Q=n||I,n=i[f+16>>2],(Q|0)!=((n||I)|0))||!l&&!of(r+32|0,w))break t;if((N|0)>=i[r+40>>2])break n;c=((i[_+72>>2]-i[_+68>>2]|0)/44|0)-1|0,k=i[B>>2],R=i[B+4>>2],R&&(i[R+4>>2]=i[R+4>>2]+1),O=u[f+8|0],S=i[f+4>>2],q=i[f>>2],t[_+10|0]=u[f+11|0],X[_+8>>1]=u[f+9|0]|u[f+10|0]<<8,V=i[r+8>>2],Q=u[f+27|0],E=u[f+26|0],G=p[f+24>>1],I=p[f+22>>1],w=p[f+20>>1],l=i[f+16>>2],n=i[f+12>>2],i[r+8>>2]=R,i[r+4>>2]=k,i[r>>2]=c;o:{if(!V||(k=i[V+4>>2],i[V+4>>2]=k-1,k))break o;W[i[i[V>>2]+8>>2]](V),y(V)}t[r+20|0]=O,i[r+16>>2]=S,i[r+12>>2]=q,k=p[_+8>>1],t[r+21|0]=k,t[r+22|0]=k>>>8,t[r+23|0]=u[_+10|0],t[r+39|0]=Q,t[r+38|0]=E,X[r+36>>1]=G,X[r+34>>1]=I,X[r+32>>1]=w,i[r+28>>2]=l,i[r+24>>2]=n,i[r+40>>2]=N;break n}if(r=r+44|0,(k|0)==(r|0))break}k=i[_+60>>2]}i[_+32>>2]=i[f+24>>2],r=i[f+20>>2],i[_+24>>2]=i[f+16>>2],i[_+28>>2]=r,r=i[f+12>>2],i[_+16>>2]=i[f+8>>2],i[_+20>>2]=r,r=i[f+4>>2],i[_+8>>2]=i[f>>2],i[_+12>>2]=r,r=i[_+72>>2],I=((r-i[_+68>>2]|0)/44|0)-1|0,w=i[r-4>>2]+i[f+28>>2]|0,r=i[_+64>>2];t:{if(r>>>0>k>>>0){t[k+38|0]=1,X[k+36>>1]=2,X[k+32>>1]=2,X[k+34>>1]=2,i[k+24>>2]=8,i[k+28>>2]=0,t[k+20|0]=0,i[k+12>>2]=99,i[k+16>>2]=99,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=I,r=i[B>>2],n=i[B+4>>2];o:{if(!n){i[k+8>>2]=0,i[k+4>>2]=r;break o}if(i[n+4>>2]=i[n+4>>2]+1,i[k+4>>2]=r,l=i[k+8>>2],i[k+8>>2]=n,!l||(r=i[l+4>>2],i[l+4>>2]=r-1,r))break o;W[i[i[l>>2]+8>>2]](l),y(l)}r=i[_+12>>2],i[k+12>>2]=i[_+8>>2],i[k+16>>2]=r,i[k+36>>2]=i[_+32>>2],r=i[_+28>>2],i[k+28>>2]=i[_+24>>2],i[k+32>>2]=r,r=i[_+20>>2],i[k+20>>2]=i[_+16>>2],i[k+24>>2]=r,i[k+40>>2]=w,r=k+44|0;break t}if(E=i[_+56>>2],k=k-E|0,l=((k|0)/44|0)+1|0,l>>>0>=97612894)break k;if(n=(r-E|0)/44|0,r=n<<1,G=n>>>0>=48806446?97612893:r>>>0>l>>>0?r:l,G){if(G>>>0>=97612894)break A;r=C(g(G,44))}else r=0;if(Q=r+k|0,i[Q>>2]=I,n=i[B>>2],l=i[B+4>>2],l&&(i[l+4>>2]=i[l+4>>2]+1,k=i[_+60>>2]-E|0),i[Q+8>>2]=l,i[Q+4>>2]=n,i[Q+36>>2]=i[_+32>>2],n=i[_+28>>2],i[Q+28>>2]=i[_+24>>2],i[Q+32>>2]=n,n=i[_+20>>2],i[Q+20>>2]=i[_+16>>2],i[Q+24>>2]=n,n=i[_+12>>2],i[Q+12>>2]=i[_+8>>2],i[Q+16>>2]=n,i[Q+40>>2]=w,n=Q+g((k|0)/-44|0,44)|0,k&&z(n,E,k),i[_+64>>2]=r+g(G,44),r=Q+44|0,i[_+60>>2]=r,i[_+56>>2]=n,!E)break t;Z(E)}i[_+60>>2]=r}if(f=f+32|0,(d|0)!=(f|0))continue;break f}break}s0(),M()}x0(),M()}f=i[_+40>>2]}if(f&&(i[_+44>>2]=f,Z(f)),B=B+8|0,(x|0)==(B|0))break}if(f=i[_+60>>2],k=i[_+56>>2],(f|0)==(k|0))break}B=0}if(k){if(r=k,f=i[_+60>>2],(r|0)!=(f|0)){for(;;){n=i[f-36>>2];r:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break r;W[i[i[n>>2]+8>>2]](n),y(n)}if(f=f-44|0,(k|0)==(f|0))break}r=i[_+56>>2]}i[_+60>>2]=k,Z(r)}if(k=i[_+68>>2],!k)break e;if(r=k,f=i[_+72>>2],(r|0)!=(f|0)){for(;;){n=i[f-36>>2];r:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break r;W[i[i[n>>2]+8>>2]](n),y(n)}if(f=f-44|0,(k|0)==(f|0))break}r=i[_+68>>2]}i[_+72>>2]=k,Z(r)}v=_+80|0;e:{if(!B){t[h+4|0]=0,t[h+15|0]=0,f=a(h+16|0,4,3003,h+4|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(t[h+15|0]>=0)break e;Z(i[h+4>>2]);break e}if(i[h+36>>2]==i[h+40>>2]){r=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r;break e}m=v+-64|0,v=m,r=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+2),n=A;r:{f:{if(A=h+36|0,V=i[A>>2],c=i[A+4>>2],(V|0)==(c|0)){A=r;break f}for(j=n+8|0,O=A+28|0,S=A+12|0,f=i[27192],q=i[27193],R=m+8|0,A=r;;){k=i[V>>2],i[m+60>>2]=e,i[m+56>>2]=r,e&&(i[e+4>>2]=i[e+4>>2]+1),W[i[i[k>>2]+12>>2]](m+24|0,k,m+56|0,V+8|0,V+36|0,S,O,s),o=i[m+60>>2];A:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break A;W[i[i[o>>2]+8>>2]](o),y(o)}A:{k:{n:{t:{o:{if(d=u[m+44|0],d){if((d|0)!=1)break o;k=i[m+28>>2],i[n>>2]=i[m+24>>2],i[n+4>>2]=k;l:{if(t[m+43|0]>=0){k=i[m+36>>2],i[j>>2]=i[m+32>>2],i[j+4>>2]=k,i[j+8>>2]=i[m+40>>2];break l}T(j,i[m+32>>2],i[m+36>>2])}t[n+20|0]=1;break A}k=i[m+28>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),A=i[m+24>>2];l:{if(!e||(o=i[e+4>>2],i[e+4>>2]=o-1,o))break l;W[i[i[e>>2]+8>>2]](e),y(e)}if(Ye(A,r),W[i[i[A>>2]+8>>2]](A,V+56|0),B=i[r+224>>2],Q=i[r+228>>2],(B|0)==(Q|0))break k;for(;;){r=i[B+4>>2],i[m>>2]=i[B>>2],i[m+4>>2]=r;l:{if(t[B+19|0]>=0){r=i[B+12>>2],i[R>>2]=i[B+8>>2],i[R+4>>2]=r,i[R+8>>2]=i[B+16>>2];break l}T(R,i[B+8>>2],i[B+12>>2])}l=i[A+228>>2],o=i[A+232>>2];l:{if(l>>>0<o>>>0){r=i[m+4>>2],i[l>>2]=i[m>>2],i[l+4>>2]=r,i[l+16>>2]=i[R+8>>2],r=i[R+4>>2],i[l+8>>2]=i[R>>2],i[l+12>>2]=r,i[R>>2]=0,i[R+4>>2]=0,i[R+8>>2]=0,N=l+20|0;break l}if(r=i[A+224>>2],l=l-r|0,w=((l|0)/20|0)+1|0,w>>>0>=214748365)break t;if(o=(o-r|0)/20|0,r=o<<1,r=o>>>0>=107374182?214748364:r>>>0>w>>>0?r:w,r>>>0>=214748365)break n;if(E=g(r,20),G=C(E),o=G+l|0,r=i[m+4>>2],i[o>>2]=i[m>>2],i[o+4>>2]=r,i[o+16>>2]=i[R+8>>2],r=i[R+4>>2],i[o+8>>2]=i[R>>2],i[o+12>>2]=r,i[R>>2]=0,i[R+4>>2]=0,i[R+8>>2]=0,N=o+20|0,l=i[A+224>>2],w=l,x=i[A+228>>2],I=o+g((x-l|0)/-20|0,20)|0,r=I,(l|0)!=(x|0)){for(;o=i[w+4>>2],i[r>>2]=i[w>>2],i[r+4>>2]=o,i[r+16>>2]=i[w+16>>2],o=i[w+12>>2],i[r+8>>2]=i[w+8>>2],i[r+12>>2]=o,i[w+16>>2]=0,i[w+8>>2]=0,i[w+12>>2]=0,r=r+20|0,w=w+20|0,(x|0)!=(w|0););for(;t[l+19|0]<0&&Z(i[l+8>>2]),l=l+20|0,(x|0)!=(l|0););l=i[A+224>>2]}if(i[A+228>>2]=N,i[A+224>>2]=I,i[A+232>>2]=G+E,!l)break l;Z(l)}if(i[A+228>>2]=N,t[m+19|0]<0&&Z(i[m+8>>2]),B=B+20|0,(Q|0)==(B|0))break}break k}e2(),M()}s0(),M()}x0(),M()}k&&(i[k+4>>2]=i[k+4>>2]+1);k:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break k;W[i[i[e>>2]+8>>2]](e),y(e)}e=k,r=A}if(k=u[m+44|0],(k|0)!=255&&(i[m+56>>2]=f,i[m+60>>2]=q,W[i[(m+56|0)+(k<<2)>>2]](m+55|0,m+24|0)),!d){if(V=V- -64|0,(c|0)==(V|0))break f;continue}break}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break r;W[i[i[e>>2]+8>>2]](e),y(e);break r}t[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A}r:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break r;W[i[i[e>>2]+8>>2]](e),y(e)}v=m- -64|0}if(r=i[h+36>>2],r){if(e=i[h+40>>2],A=r,(e|0)!=(r|0)){for(;;){f=i[e-60>>2];e:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(e=e+-64|0,(r|0)==(e|0))break}A=i[h+36>>2]}i[h+40>>2]=r,Z(A)}ee(h+120|0,i[h+124>>2])}U&&a2(U),v=h+160|0}function ov(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=0;f=v-16|0,v=f,i[f+8>>2]=0,i[f+12>>2]=0,i[f+4>>2]=f+8,k=f+4|0,W8(k,i[o>>2],o+4|0),n=A,c=r,l=v-112|0,v=l,G=e,r=i[e+196>>2],A0=k+4|0,o=A0,A=o,e=i[k+4>>2];i:{e:{r:{if(!e)break r;for(A=e;s=r>>>0>o0[A+16>>2],o=s?o:A,A=i[(s?4:0)+A>>2],!!A;);if(!((o|0)==(A0|0)|r>>>0<o0[o+16>>2])){A=C(32),i[l>>2]=A,i[l+4>>2]=28,i[l+8>>2]=-2147483616,e=u[6467]|u[6468]<<8|(u[6469]<<16|u[6470]<<24),t[A+24|0]=e,t[A+25|0]=e>>>8,t[A+26|0]=e>>>16,t[A+27|0]=e>>>24,e=u[6463]|u[6464]<<8|(u[6465]<<16|u[6466]<<24),r=u[6459]|u[6460]<<8|(u[6461]<<16|u[6462]<<24),t[A+16|0]=r,t[A+17|0]=r>>>8,t[A+18|0]=r>>>16,t[A+19|0]=r>>>24,t[A+20|0]=e,t[A+21|0]=e>>>8,t[A+22|0]=e>>>16,t[A+23|0]=e>>>24,e=u[6455]|u[6456]<<8|(u[6457]<<16|u[6458]<<24),r=u[6451]|u[6452]<<8|(u[6453]<<16|u[6454]<<24),t[A+8|0]=r,t[A+9|0]=r>>>8,t[A+10|0]=r>>>16,t[A+11|0]=r>>>24,t[A+12|0]=e,t[A+13|0]=e>>>8,t[A+14|0]=e>>>16,t[A+15|0]=e>>>24,e=u[6447]|u[6448]<<8|(u[6449]<<16|u[6450]<<24),r=u[6443]|u[6444]<<8|(u[6445]<<16|u[6446]<<24),t[A|0]=r,t[A+1|0]=r>>>8,t[A+2|0]=r>>>16,t[A+3|0]=r>>>24,t[A+4|0]=e,t[A+5|0]=e>>>8,t[A+6|0]=e>>>16,t[A+7|0]=e>>>24,t[A+28|0]=0,A=a(l+48|0,2,0,l),e=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=e,e=n+8|0;f:{if(t[A+19|0]>=0){r=i[A+12>>2],i[e>>2]=i[A+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[A+16>>2],t[n+20|0]=1;break f}if(T(e,i[A+8>>2],i[A+12>>2]),e=t[A+19|0],t[n+20|0]=1,(e|0)>=0)break f;Z(i[A+8>>2])}if(t[l+11|0]>=0)break i;Z(i[l>>2]);break i}for(;;){if(A=e,o=i[e+16>>2],o>>>0>r>>>0){if(o=e,e=i[e>>2],e)continue;break r}if(r>>>0<=o>>>0)break e;if(e=i[A+4>>2],!e)break}o=A+4|0}e=C(20),i[e+8>>2]=A,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=r,i[o>>2]=e,A=i[i[k>>2]>>2],A&&(i[k>>2]=A),G1(i[k+4>>2],e),i[k+8>>2]=i[k+8>>2]+1}e=i[G+564>>2],r=i[G+568>>2],Ii(l+80|0,i[G+180>>2]- -64|0,e,r);e:{if(i[l+80>>2]){A=i[l+84>>2],i[n>>2]=i[l+80>>2],i[n+4>>2]=A,A=n+8|0;r:{if(t[l+99|0]>=0){e=i[l+92>>2],i[A>>2]=i[l+88>>2],i[A+4>>2]=e,i[A+8>>2]=i[l+96>>2];break r}T(A,i[l+88>>2],i[l+92>>2])}t[n+20|0]=1,A=0;break e}if(A=C(248),i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=101168,l0(A+16|0,0,156),i[A+76>>2]=0,i[A+80>>2]=0,i[A+36>>2]=1,i[A+40>>2]=1,t[A+24|0]=1,X[A+22>>1]=2,X[A+18>>1]=2,X[A+20>>1]=2,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,i[A+96>>2]=0,i[A+128>>2]=0,i[A+132>>2]=0,i[A+100>>2]=0,i[A+104>>2]=1,i[A+136>>2]=0,i[A+140>>2]=0,i[A+144>>2]=0,i[A+148>>2]=0,i[A+152>>2]=0,i[A+156>>2]=0,X[A+158>>1]=0,X[A+160>>1]=0,X[A+162>>1]=0,X[A+164>>1]=0,i[A+184>>2]=0,i[A+188>>2]=0,i[A+172>>2]=255,i[A+192>>2]=0,i[A+196>>2]=5186,i[A+208>>2]=99,i[A+212>>2]=99,i[A+200>>2]=0,i[A+204>>2]=0,i[A+12>>2]=101488,i[A+216>>2]=0,i[A+220>>2]=0,i[A+224>>2]=0,i[A+228>>2]=0,i[A+232>>2]=0,i[A+236>>2]=0,i[A+240>>2]=0,i[A+244>>2]=0,B=A+12|0,i[A+176>>2]=B,i[A+8>>2]=i[A+8>>2]+1,i[A+180>>2]=A,i[A+4>>2]==-1&&(W[i[i[A>>2]+8>>2]](A),y(A)),t1(B,e,r,1,3),a0(l+48|0,B,3,e,r,8,i[G+180>>2]- -64|0,0),i[l+48>>2]){if(e=i[l+52>>2],i[n>>2]=i[l+48>>2],i[n+4>>2]=e,e=n+8|0,t[l+67|0]>=0){r=i[l+60>>2],i[e>>2]=i[l+56>>2],i[e+4>>2]=r,i[e+8>>2]=i[l+64>>2],t[n+20|0]=1;break e}if(T(e,i[l+56>>2],i[l+60>>2]),e=t[l+67|0],t[n+20|0]=1,(e|0)>=0)break e;Z(i[l+56>>2]);break e}if(t[l+67|0]<0&&Z(i[l+56>>2]),a0(l+48|0,B,4,e,r,8,i[G+180>>2]- -64|0,0),i[l+48>>2]){if(e=i[l+52>>2],i[n>>2]=i[l+48>>2],i[n+4>>2]=e,e=n+8|0,t[l+67|0]>=0){r=i[l+60>>2],i[e>>2]=i[l+56>>2],i[e+4>>2]=r,i[e+8>>2]=i[l+64>>2],t[n+20|0]=1;break e}if(T(e,i[l+56>>2],i[l+60>>2]),e=t[l+67|0],t[n+20|0]=1,(e|0)>=0)break e;Z(i[l+56>>2]);break e}if(t[l+67|0]<0&&Z(i[l+56>>2]),a0(l+48|0,B,5,e,r,8,i[G+180>>2]- -64|0,0),i[l+48>>2]){if(e=i[l+52>>2],i[n>>2]=i[l+48>>2],i[n+4>>2]=e,e=n+8|0,t[l+67|0]>=0){r=i[l+60>>2],i[e>>2]=i[l+56>>2],i[e+4>>2]=r,i[e+8>>2]=i[l+64>>2],t[n+20|0]=1;break e}if(T(e,i[l+56>>2],i[l+60>>2]),e=t[l+67|0],t[n+20|0]=1,(e|0)>=0)break e;Z(i[l+56>>2]);break e}t[l+67|0]<0&&Z(i[l+56>>2]),o=l+48|0,s=p[G+554>>1],h=p[G+556>>1],V=p[G+558>>1],I=p[G+560>>1],r=v-16|0,v=r;r:{f:{if(e=i[B+204>>2],m=i[B+208>>2],(e|0)==(m|0))break f;for(h=h>>>8|0,V=V>>>8|0,I=I>>>8|0,s=s>>>8|0;;){if(i[e>>2]!=3){if(e=e+56|0,(m|0)!=(e|0))continue;break f}break}A:{if(p[e+20>>1]!=8)break A;if(m=g(i[e+52>>2],i[e+28>>2]),m&&l0(i[e+40>>2],s,m),e=i[B+204>>2],s=i[B+208>>2],(e|0)==(s|0))break f;for(;;){if(i[e>>2]!=4){if(e=e+56|0,(s|0)!=(e|0))continue;break f}break}if(p[e+20>>1]!=8)break A;if(s=g(i[e+52>>2],i[e+28>>2]),s&&l0(i[e+40>>2],h,s),e=i[B+204>>2],s=i[B+208>>2],(e|0)==(s|0))break f;for(;;){if(i[e>>2]!=5){if(e=e+56|0,(s|0)!=(e|0))continue;break f}break}if(p[e+20>>1]!=8)break A;s=g(i[e+52>>2],i[e+28>>2]),s&&l0(i[e+40>>2],V,s),e=i[B+204>>2],s=i[B+208>>2];k:{if((e|0)==(s|0))break k;for(;;){if(i[e>>2]!=6){if(e=e+56|0,(s|0)!=(e|0))continue;break k}break}if(p[e+20>>1]!=8)break A;if(s=g(i[e+52>>2],i[e+28>>2]),!s)break k;l0(i[e+40>>2],I,s)}if(e=i[28729],i[o>>2]=i[28728],i[o+4>>2]=e,e=o+8|0,t[114931]>=0){o=i[28731],i[e>>2]=i[28730],i[e+4>>2]=o,i[e+8>>2]=i[28732];break r}T(e,i[28730],i[28731]);break r}if(e=C(56),i[r+4>>2]=e,i[r+8>>2]=52,i[r+12>>2]=-2147483592,s=u[10759]|u[10760]<<8|(u[10761]<<16|u[10762]<<24),h=u[10755]|u[10756]<<8|(u[10757]<<16|u[10758]<<24),t[e|0]=h,t[e+1|0]=h>>>8,t[e+2|0]=h>>>16,t[e+3|0]=h>>>24,t[e+4|0]=s,t[e+5|0]=s>>>8,t[e+6|0]=s>>>16,t[e+7|0]=s>>>24,t[e+52|0]=0,s=u[10803]|u[10804]<<8|(u[10805]<<16|u[10806]<<24),t[e+48|0]=s,t[e+49|0]=s>>>8,t[e+50|0]=s>>>16,t[e+51|0]=s>>>24,s=u[10799]|u[10800]<<8|(u[10801]<<16|u[10802]<<24),h=u[10795]|u[10796]<<8|(u[10797]<<16|u[10798]<<24),t[e+40|0]=h,t[e+41|0]=h>>>8,t[e+42|0]=h>>>16,t[e+43|0]=h>>>24,t[e+44|0]=s,t[e+45|0]=s>>>8,t[e+46|0]=s>>>16,t[e+47|0]=s>>>24,s=u[10791]|u[10792]<<8|(u[10793]<<16|u[10794]<<24),h=u[10787]|u[10788]<<8|(u[10789]<<16|u[10790]<<24),t[e+32|0]=h,t[e+33|0]=h>>>8,t[e+34|0]=h>>>16,t[e+35|0]=h>>>24,t[e+36|0]=s,t[e+37|0]=s>>>8,t[e+38|0]=s>>>16,t[e+39|0]=s>>>24,s=u[10783]|u[10784]<<8|(u[10785]<<16|u[10786]<<24),h=u[10779]|u[10780]<<8|(u[10781]<<16|u[10782]<<24),t[e+24|0]=h,t[e+25|0]=h>>>8,t[e+26|0]=h>>>16,t[e+27|0]=h>>>24,t[e+28|0]=s,t[e+29|0]=s>>>8,t[e+30|0]=s>>>16,t[e+31|0]=s>>>24,s=u[10775]|u[10776]<<8|(u[10777]<<16|u[10778]<<24),h=u[10771]|u[10772]<<8|(u[10773]<<16|u[10774]<<24),t[e+16|0]=h,t[e+17|0]=h>>>8,t[e+18|0]=h>>>16,t[e+19|0]=h>>>24,t[e+20|0]=s,t[e+21|0]=s>>>8,t[e+22|0]=s>>>16,t[e+23|0]=s>>>24,s=u[10767]|u[10768]<<8|(u[10769]<<16|u[10770]<<24),h=u[10763]|u[10764]<<8|(u[10765]<<16|u[10766]<<24),t[e+8|0]=h,t[e+9|0]=h>>>8,t[e+10|0]=h>>>16,t[e+11|0]=h>>>24,t[e+12|0]=s,t[e+13|0]=s>>>8,t[e+14|0]=s>>>16,t[e+15|0]=s>>>24,a(o,4,0,r+4|0),t[r+15|0]>=0)break r;Z(i[r+4>>2]);break r}if(t[r+4|0]=0,t[r+15|0]=0,a(o,5,2002,r+4|0),t[r+15|0]>=0)break r;Z(i[r+4>>2])}if(v=r+16|0,r=i[l+52>>2],e=i[l+48>>2],i[l+80>>2]=e,i[l+84>>2]=r,t[l+99|0]<0&&(Z(i[l+88>>2]),e=i[l+80>>2]),r=i[l+60>>2],i[l+88>>2]=i[l+56>>2],i[l+92>>2]=r,i[l+96>>2]=i[l- -64>>2],!e){r:{f:{A:{if(r=i[G+584>>2],(r|0)!=i[G+588>>2])for(_=n+8|0,M0=c+28|0,X0=i[27126],V0=i[27127],z0=l+40|0,e=0;;){if(r=i[(e<<2)+r>>2],(r|0)==i[G+196>>2]){r=V2(l,26859),e=a(l+48|0,2,0,r),o=i[e+4>>2],i[n>>2]=i[e>>2],i[n+4>>2]=o;k:{if(t[e+19|0]>=0){o=i[e+12>>2],i[_>>2]=i[e+8>>2],i[_+4>>2]=o,i[_+8>>2]=i[e+16>>2],t[n+20|0]=1;break k}if(T(_,i[e+8>>2],i[e+12>>2]),o=t[e+19|0],t[n+20|0]=1,(o|0)>=0)break k;Z(i[e+8>>2])}if(t[r+11|0]>=0)break e;Z(i[r>>2]);break e}if(o=l+48|0,$1(o,i[G+180>>2],r,1),r=i[l+48>>2],i[l+72>>2]=r,i[l+76>>2]=i[l+52>>2],!r){r=V2(l,26814),e=a(o,2,2e3,r),o=i[e+4>>2],i[n>>2]=i[e>>2],i[n+4>>2]=o;k:{if(t[e+19|0]>=0){o=i[e+12>>2],i[_>>2]=i[e+8>>2],i[_+4>>2]=o,i[_+8>>2]=i[e+16>>2],t[n+20|0]=1;break k}if(T(_,i[e+8>>2],i[e+12>>2]),o=t[e+19|0],t[n+20|0]=1,(o|0)>=0)break k;Z(i[e+8>>2])}if(t[r+11|0]>=0)break r;Z(i[r>>2]);break r}if(W[i[i[r>>2]+88>>2]](l+48|0,r),i[l+48>>2]){if(e=i[l+52>>2],i[n>>2]=i[l+48>>2],i[n+4>>2]=e,t[l+67|0]>=0){e=i[l+60>>2],i[_>>2]=i[l+56>>2],i[_+4>>2]=e,i[_+8>>2]=i[l+64>>2],t[n+20|0]=1;break r}if(T(_,i[l+56>>2],i[l+60>>2]),e=t[l+67|0],t[n+20|0]=1,(e|0)>=0)break r;Z(i[l+56>>2]);break r}if(t[l+67|0]<0&&Z(i[l+56>>2]),i[l+40>>2]=0,i[l+44>>2]=0,i[l+36>>2]=z0,r=i[l+72>>2],o=l+36|0,W8(o,i[k>>2],A0),s=l+48|0,W[i[i[r>>2]+140>>2]](s,r,c,0,0,0,o),S1(o,i[l+40>>2]),r=u[l+68|0],r){if((r|0)!=1)break f;h6(n,s),e=u[l+68|0],(e|0)!=255&&(r=i[27127],i[l>>2]=i[27126],i[l+4>>2]=r,W[i[l+(e<<2)>>2]](l+104|0,s)),g2(l+72|0);break e}if(o=i[l+48>>2],i[l+28>>2]=o,r=i[l+52>>2],i[l+32>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),!(i[o+196>>2]==1&i[o+200>>2]==3)){t[l+110|0]=1,X[l+108>>1]=2,X[l+104>>1]=2,X[l+106>>1]=2,G6(l,l+28|0,1,3,l+104|0,0,M0,i[c+48>>2],i[G+180>>2]- -64|0),s=u[l+20|0];k:{if(s){if((s|0)!=1)break f;if(r=i[l+4>>2],i[n>>2]=i[l>>2],i[n+4>>2]=r,t[l+19|0]>=0){r=i[l+12>>2],i[_>>2]=i[l+8>>2],i[_+4>>2]=r,i[_+8>>2]=i[l+16>>2],t[n+20|0]=1;break k}T(_,i[l+8>>2],i[l+12>>2]),t[n+20|0]=1;break k}if(o=i[l+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[l+28>>2]=i[l>>2],r=i[l+32>>2],i[l+32>>2]=o,!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break k;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=u[l+20|0],(r|0)!=255&&(i[l+104>>2]=X0,i[l+108>>2]=V0,W[i[(l+104|0)+(r<<2)>>2]](l+103|0,l)),s)break A}r=i[G+572>>2]+g(e,12)|0,R=i[r+4>>2],m=i[r+8>>2],t0=0,C0=0,w=v-16|0,v=w;k:{n:{if(i[B+200>>2]-1>>>0>=2&&(r=i[l+28>>2],i[r+200>>2]-1>>>0>1))break n;if(r=C(64),i[w+4>>2]=r,i[w+8>>2]=57,i[w+12>>2]=-2147483584,o=u[17811]|u[17812]<<8|(u[17813]<<16|u[17814]<<24),s=u[17807]|u[17808]<<8|(u[17809]<<16|u[17810]<<24),t[r|0]=s,t[r+1|0]=s>>>8,t[r+2|0]=s>>>16,t[r+3|0]=s>>>24,t[r+4|0]=o,t[r+5|0]=o>>>8,t[r+6|0]=o>>>16,t[r+7|0]=o>>>24,t[r+57|0]=0,t[r+56|0]=u[17863],o=u[17859]|u[17860]<<8|(u[17861]<<16|u[17862]<<24),s=u[17855]|u[17856]<<8|(u[17857]<<16|u[17858]<<24),t[r+48|0]=s,t[r+49|0]=s>>>8,t[r+50|0]=s>>>16,t[r+51|0]=s>>>24,t[r+52|0]=o,t[r+53|0]=o>>>8,t[r+54|0]=o>>>16,t[r+55|0]=o>>>24,o=u[17851]|u[17852]<<8|(u[17853]<<16|u[17854]<<24),s=u[17847]|u[17848]<<8|(u[17849]<<16|u[17850]<<24),t[r+40|0]=s,t[r+41|0]=s>>>8,t[r+42|0]=s>>>16,t[r+43|0]=s>>>24,t[r+44|0]=o,t[r+45|0]=o>>>8,t[r+46|0]=o>>>16,t[r+47|0]=o>>>24,o=u[17843]|u[17844]<<8|(u[17845]<<16|u[17846]<<24),s=u[17839]|u[17840]<<8|(u[17841]<<16|u[17842]<<24),t[r+32|0]=s,t[r+33|0]=s>>>8,t[r+34|0]=s>>>16,t[r+35|0]=s>>>24,t[r+36|0]=o,t[r+37|0]=o>>>8,t[r+38|0]=o>>>16,t[r+39|0]=o>>>24,o=u[17835]|u[17836]<<8|(u[17837]<<16|u[17838]<<24),s=u[17831]|u[17832]<<8|(u[17833]<<16|u[17834]<<24),t[r+24|0]=s,t[r+25|0]=s>>>8,t[r+26|0]=s>>>16,t[r+27|0]=s>>>24,t[r+28|0]=o,t[r+29|0]=o>>>8,t[r+30|0]=o>>>16,t[r+31|0]=o>>>24,o=u[17827]|u[17828]<<8|(u[17829]<<16|u[17830]<<24),s=u[17823]|u[17824]<<8|(u[17825]<<16|u[17826]<<24),t[r+16|0]=s,t[r+17|0]=s>>>8,t[r+18|0]=s>>>16,t[r+19|0]=s>>>24,t[r+20|0]=o,t[r+21|0]=o>>>8,t[r+22|0]=o>>>16,t[r+23|0]=o>>>24,o=u[17819]|u[17820]<<8|(u[17821]<<16|u[17822]<<24),s=u[17815]|u[17816]<<8|(u[17817]<<16|u[17818]<<24),t[r+8|0]=s,t[r+9|0]=s>>>8,t[r+10|0]=s>>>16,t[r+11|0]=s>>>24,t[r+12|0]=o,t[r+13|0]=o>>>8,t[r+14|0]=o>>>16,t[r+15|0]=o>>>24,a(l,4,0,w+4|0),t[w+15|0]>=0)break k;Z(i[w+4>>2]);break k}i[w+8>>2]=0,i[w+12>>2]=0,O=w+8|0,i[w+4>>2]=O;n:{t:{if(I=i[r+204>>2],V=i[r+208>>2],(I|0)==(V|0))break t;for(;;){h=i[I>>2],s=O,r=s,o=i[w+8>>2];o:{l:{if(!o)break l;for(;;){if(r=o,s=i[r+16>>2],(s|0)>(h|0)){if(s=r,o=i[r>>2],o)continue;break l}if((s|0)>=(h|0))break o;if(o=i[r+4>>2],!o)break}s=r+4|0}o=C(20),i[o+8>>2]=r,r=o,i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=h,i[s>>2]=r,r=i[i[w+4>>2]>>2],r&&(i[w+4>>2]=r),G1(i[w+8>>2],o),i[w+12>>2]=i[w+12>>2]+1}if(I=I+56|0,(V|0)==(I|0))break}if(r=i[l+28>>2],o=i[r+204>>2],s=i[r+208>>2],(o|0)==(s|0))break t;for(r=o;t0=i[r>>2]==6,!t0&&(r=r+56|0,(s|0)!=(r|0)););for(;;){if(i[o>>2]!=6){if(o=o+56|0,(s|0)!=(o|0))continue;break t}break}C0=i[o+52>>2],r=i[o+40>>2];break n}r=0}I=i[w+4>>2];n:{if(!((O|0)==(I|0)|i[B+204>>2]==i[B+208>>2]))for(r0=0-R|0,S=(R|0)>=0,q=S?0:r0,j0=r+q|0,S0=S?0:R,q0=S?R:0,r2=m>>31,f2=R>>31,A2=m+1|0,f0=0-m|0,_0=(m|0)>=0,V=_0?0:f0,g0=_0?0:m,s2=V-g0|0,v2=V+1|0,Z2=m+V|0,X2=g0-V|0;;){s=i[B+204>>2],Y=i[B+208>>2];t:{if((s|0)==(Y|0))break t;for(Q=i[I+16>>2],o=s;;){if((Q|0)!=i[o>>2]){if(o=o+56|0,(Y|0)!=(o|0))continue;break t}break}h=i[l+28>>2],r=i[h+204>>2],o=r;o:{l:{if(U=i[h+208>>2],h=(U|0)==(r|0),h)break l;for(;;){if((Q|0)!=i[o>>2]){if(o=o+56|0,(U|0)!=(o|0))continue;break l}break}d=i[o+40>>2],x=i[o+52>>2];break o}d=0,x=0}o=s;o:{l:{for(;;){if((Q|0)==i[o>>2])break l;if(o=o+56|0,(Y|0)==(o|0))break}N=0,j=0;break o}N=i[o+40>>2],j=i[o+52>>2]}E=0,o=r;o:{if(h){h=0;break o}l:{u:{for(;;){if((Q|0)==i[o>>2])break u;if(o=o+56|0,(U|0)==(o|0))break}h=0;break l}h=i[o+24>>2]}for(;;){if((Q|0)!=i[r>>2]){if(r=r+56|0,(U|0)!=(r|0))continue;break o}break}E=i[r+28>>2]}o=s;o:{l:{for(;;){if((Q|0)==i[o>>2])break l;if(o=o+56|0,(Y|0)==(o|0))break}r=0;break o}r=i[o+24>>2]}o:{l:{for(;;){if((Q|0)==i[s>>2])break l;if(s=s+56|0,(Y|0)==(s|0))break}o=0;break o}o=i[s+28>>2]}if(!((R|0)<=0|r>>>0>R>>>0)){if(r=i[28729],i[l>>2]=i[28728],i[l+4>>2]=r,r=l+8|0,t[114931]>=0){o=i[28731],i[r>>2]=i[28730],i[r+4>>2]=o,i[r+8>>2]=i[28732];break n}T(r,i[28730],i[28731]);break n}if(!(h>>>0>r0>>>0|S)){if(r=i[28729],i[l>>2]=i[28728],i[l+4>>2]=r,r=l+8|0,t[114931]>=0){o=i[28731],i[r>>2]=i[28730],i[r+4>>2]=o,i[r+8>>2]=i[28732];break n}T(r,i[28730],i[28731]);break n}if(!((m|0)<=0|o>>>0>m>>>0)){if(r=i[28729],i[l>>2]=i[28728],i[l+4>>2]=r,r=l+8|0,t[114931]>=0){o=i[28731],i[r>>2]=i[28730],i[r+4>>2]=o,i[r+8>>2]=i[28732];break n}T(r,i[28730],i[28731]);break n}if(!(E>>>0>f0>>>0|_0)){if(r=i[28729],i[l>>2]=i[28728],i[l+4>>2]=r,r=l+8|0,t[114931]>=0){o=i[28731],i[r>>2]=i[28730],i[r+4>>2]=o,i[r+8>>2]=i[28732];break n}T(r,i[28730],i[28731]);break n}if(Y=o-m|0,s=o,o=r2,Q=m+E|0,o=Q>>>0<m>>>0?o+1|0:o,(o|0)>0?o=1:o=s>>>0<Q>>>0&(o|0)>=0,Q=o?Y:E,Y=Q+g0|0,Y>>>0<=V>>>0)break t;if(E=r-R|0,o=r,r=f2,s=h+R|0,r=s>>>0<R>>>0?r+1|0:r,(r|0)>0?r=1:r=o>>>0<s>>>0&(r|0)>=0,o=(r?E:h)+S0|0,s=d+q|0,E=N+q0|0,!t0){if(r=V,Q+X2&1&&(o&&z(E+g(j,Z2)|0,s+g(r,x)|0,o),r=v2),(Q-1|0)==(s2|0))break t;for(;h=!o,h||z(E+g(r+m|0,j)|0,s+g(r,x)|0,o),h||z(E+g(r+A2|0,j)|0,s+g(r+1|0,x)|0,o),r=r+2|0,(Y|0)!=(r|0););break t}if(h=V,o>>>0<=q>>>0)break t;for(;;){for(Q=g(h,C0)+j0|0,U=s+g(h,x)|0,d=E+g(h+m|0,j)|0,r=q;N=r+d|0,R2=N,D2=u[N|0],N=u[r+Q|0],t[R2|0]=(g(D2,N^255)+g(N,u[r+U|0])>>>0)/255,r=r+1|0,(o|0)!=(r|0););if(h=h+1|0,(Y|0)==(h|0))break}}o=i[I+4>>2];t:{if(o){for(;;)if(r=o,o=i[r>>2],!o)break t}for(;r=i[I+8>>2],o=i[r>>2]!=(I|0),I=r,!!o;);}if(I=r,(r|0)==(O|0))break}if(r=i[28729],i[l>>2]=i[28728],i[l+4>>2]=r,r=l+8|0,t[114931]>=0){o=i[28731],i[r>>2]=i[28730],i[r+4>>2]=o,i[r+8>>2]=i[28732];break n}T(r,i[28730],i[28731])}ee(w+4|0,i[w+8>>2])}if(v=w+16|0,o=i[l+4>>2],r=i[l>>2],i[l+80>>2]=r,i[l+84>>2]=o,t[l+99|0]<0&&(Z(i[l+88>>2]),r=i[l+80>>2]),o=i[l+12>>2],i[l+88>>2]=i[l+8>>2],i[l+92>>2]=o,i[l+96>>2]=i[l+16>>2],!(!r|(r|0)==2&i[l+84>>2]==122)){e=i[l+84>>2],i[n>>2]=i[l+80>>2],i[n+4>>2]=e;k:{if(t[l+99|0]>=0){e=i[l+92>>2],i[_>>2]=i[l+88>>2],i[_+4>>2]=e,i[_+8>>2]=i[l+96>>2];break k}T(_,i[l+88>>2],i[l+92>>2])}t[n+20|0]=1,g2(l+28|0),e=u[l+68|0],(e|0)!=255&&(r=i[27127],i[l>>2]=i[27126],i[l+4>>2]=r,W[i[l+(e<<2)>>2]](l+104|0,l+48|0)),g2(l+72|0);break e}r=i[l+32>>2];k:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break k;W[i[i[r>>2]+8>>2]](r),y(r)}r=u[l+68|0],(r|0)!=255&&(i[l>>2]=X0,i[l+4>>2]=V0,W[i[l+(r<<2)>>2]](l+104|0,l+48|0)),r=i[l+76>>2];k:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break k;W[i[i[r>>2]+8>>2]](r),y(r)}if(e=e+1|0,r=i[G+584>>2],!(e>>>0<i[G+588>>2]-r>>2>>>0))break}t[n+20|0]=0,i[n+4>>2]=A,i[n>>2]=B,A=0;break e}g2(l+28|0),e=u[l+68|0],(e|0)!=255&&(r=i[27127],i[l>>2]=i[27126],i[l+4>>2]=r,W[i[(e<<2)+l>>2]](l+104|0,l+48|0)),g2(l+72|0);break e}e2(),M()}g2(l+72|0);break e}e=i[l+84>>2],i[n>>2]=i[l+80>>2],i[n+4>>2]=e,e=n+8|0;r:{if(t[l+99|0]>=0){r=i[l+92>>2],i[e>>2]=i[l+88>>2],i[e+4>>2]=r,i[e+8>>2]=i[l+96>>2];break r}T(e,i[l+88>>2],i[l+92>>2])}t[n+20|0]=1}if(t[l+99|0]<0&&Z(i[l+88>>2]),!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=l+112|0,S1(k,i[f+8>>2]),v=f+16|0}function V9(A,e,r,f,k,n,o,l,s,h,w,_){var B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=0,c2=0,f1=0,o1=0,u1=0,y1=0,a1=0,d1=0,u4=0,Y4=0,y4=0,E4=0,f8=0,A8=0,k8=0,v6=0,m6=0;d1=v-16|0,v=d1,R=d1+4|0,U=v-80|0,v=U;i:{e:{if(m=i[r+168>>2],S=k>>m,(S|0)<0||(V=i[r+172>>2],(V|0)<=(S|0)))break e;if(q=n>>m,(q|0)<0|(q|0)>=i[r+176>>2])break i;m=n+l|0,E=k+o|0,N=u[f+10|0];r:{f:{A:switch((u[((i[r+160>>2]+g(S,3)|0)+g(g(V,q),3)|0)+1|0]&3)-1|0){case 0:if(!(N&16))break f;break;case 1:break A;default:break f}i[U+12>>2]=r,i[U+8>>2]=69400,B=U+8|0,f=m,S=h,q=w,V=_,t0=N>>>5|0,I=U+16|0,N=v-16|0,v=N,Y=i[i[r+132>>2]+8236>>2],(s|0)!=8|i[i[r+132>>2]+8236>>2]<3||(q=8,V=0,S=8,E=k,f=n),O=f+q|0,x=O-1|0,m=W[i[i[B>>2]>>2]](B,k,n)|0;A:{c=t0+1|0,d=E>>Y,A0=E-1|0,M0=(d|0)!=A0>>Y;k:{if(!M0&&(_=0,f>>Y==x>>Y)||!((V|0)!=1|m>>>0>7)&&(_=0,1<<m&196)||(_=0,!M8(r,k,n,s,E,f,S,q,V,A0,x)))break k;_=W[i[i[B>>2]+4>>2]](B,A0,x)|0,B=p[_+4>>1]|p[_+6>>1]<<16,x=p[_>>1]|p[_+2>>1]<<16,X[I>>1]=x,X[I+2>>1]=x>>>16,X[I+4>>1]=B,X[I+6>>1]=B>>>16,_=p[_+8>>1]|p[_+10>>1]<<16,X[I+8>>1]=_,X[I+10>>1]=_>>>16,_=1}if((c|0)<=(_|0))break A;k:{n:{t:{if(Q=E+S|0,B=Q-1|0,x=f-1|0,!(!(1<<m&50)||(V|0)!=1|m>>>0>5)|(d|0)==B>>Y&f>>Y==x>>Y||!M8(r,k,n,s,E,f,S,q,V,B,x))break t;if(G=i[r+188>>2],m=B>>G,(m|0)<0||(B=i[r+192>>2],(B|0)<=(m|0)))break e;if(G=x>>G,!((G|0)<0|(G|0)>=i[r+196>>2])){B=(i[r+180>>2]+g(m,12)|0)+g(g(B,G),12)|0;o:{if(!_||(m=u[I|0],(m|0)!=u[B|0])||m&&p[I+4>>1]!=p[B+4>>1]|p[I+6>>1]!=p[B+6>>1]|u[I+2|0]!=u[B+2|0]||(C0=u[I+1|0],(C0|0)!=u[B+1|0]))break o;if(G=0,V0=1,m=_,!C0)break n;if(p[I+8>>1]!=p[B+8>>1]|p[I+10>>1]!=p[B+10>>1]|u[I+3|0]!=u[B+3|0])break o;m=_;break n}G=p[B+4>>1]|p[B+6>>1]<<16,m=I+g(_,12)|0,V0=p[B>>1]|p[B+2>>1]<<16,X[m>>1]=V0,X[m+2>>1]=V0>>>16,X[m+4>>1]=G,X[m+6>>1]=G>>>16,G=p[B+8>>1]|p[B+10>>1]<<16,X[m+8>>1]=G,X[m+10>>1]=G>>>16,V0=1,G=_,m=_+1|0;break n}break k}m=_}n:{if(c>>>0<=m>>>0)break n;t:{if((d|0)==Q>>Y&f>>Y==x>>Y||!M8(r,k,n,s,E,f,S,q,V,Q,x))break t;if(B=Q,Q=i[r+188>>2],B=B>>Q,(B|0)<0||(d=i[r+192>>2],(d|0)<=(B|0)))break e;if(Q=x>>Q,(Q|0)<0|(Q|0)>=i[r+196>>2])break k;B=(i[r+180>>2]+g(B,12)|0)+g(g(Q,d),12)|0;o:{if(!V0||(Q=I+g(G,12)|0,d=u[Q|0],(d|0)!=u[B|0])||d&&p[Q+4>>1]!=p[B+4>>1]|p[Q+6>>1]!=p[B+6>>1]|u[Q+2|0]!=u[B+2|0]||(d=u[Q+1|0],(d|0)!=u[B+1|0]))break o;if(!d)break t;if(p[Q+8>>1]!=p[B+8>>1]|p[Q+10>>1]!=p[B+10>>1])break o;if(u[Q+3|0]==u[B+3|0])break t}d=p[B+4>>1]|p[B+6>>1]<<16,Q=I+g(m,12)|0,C0=p[B>>1]|p[B+2>>1]<<16,X[Q>>1]=C0,X[Q+2>>1]=C0>>>16,X[Q+4>>1]=d,X[Q+6>>1]=d>>>16,B=p[B+8>>1]|p[B+10>>1]<<16,X[Q+8>>1]=B,X[Q+10>>1]=B>>>16,m=m+1|0}if(m>>>0>=c>>>0)break n;t:{o:{if(!M0&&(B=f>>Y,(B|0)==O>>Y))break o;l:{if(!M8(r,k,n,s,E,f,S,q,V,A0,O))break l;if(Q=i[r+188>>2],B=A0>>Q,(B|0)<0||(d=i[r+192>>2],(d|0)<=(B|0)))break e;if(Q=O>>Q,(Q|0)<0|(Q|0)>=i[r+196>>2])break k;B=(i[r+180>>2]+g(B,12)|0)+g(g(Q,d),12)|0;u:{if(!_||(Q=u[I|0],(Q|0)!=u[B|0])||Q&&p[I+4>>1]!=p[B+4>>1]|p[I+6>>1]!=p[B+6>>1]|u[I+2|0]!=u[B+2|0]||(Q=u[I+1|0],(Q|0)!=u[B+1|0]))break u;if(!Q)break l;if(p[I+8>>1]!=p[B+8>>1]|p[I+10>>1]!=p[B+10>>1])break u;if(u[I+3|0]==u[B+3|0])break l}O=p[B+4>>1]|p[B+6>>1]<<16,Q=I+g(m,12)|0,d=p[B>>1]|p[B+2>>1]<<16,X[Q>>1]=d,X[Q+2>>1]=d>>>16,X[Q+4>>1]=O,X[Q+6>>1]=O>>>16,B=p[B+8>>1]|p[B+10>>1]<<16,X[Q+8>>1]=B,X[Q+10>>1]=B>>>16,m=m+1|0}if((m|0)==4|m>>>0>=c>>>0)break n;if(M0)break t;B=f>>Y}if(x>>Y==(B|0))break n}if(!M8(r,k,n,s,E,f,S,q,V,A0,x))break n;if(Y=i[r+188>>2],V=A0>>Y,(V|0)<0||(B=i[r+192>>2],(B|0)<=(V|0)))break e;if(Y=x>>Y,(Y|0)<0|(Y|0)>=i[r+196>>2])break k;if(V=(i[r+180>>2]+g(V,12)|0)+g(g(B,Y),12)|0,V0&&_u(I+g(G,12)|0,V)||_&&_u(I,V))break n;G=p[V+4>>1]|p[V+6>>1]<<16,_=I+g(m,12)|0,Y=p[V>>1]|p[V+2>>1]<<16,X[_>>1]=Y,X[_+2>>1]=Y>>>16,X[_+4>>1]=G,X[_+6>>1]=G>>>16,V=p[V+8>>1]|p[V+10>>1]<<16,X[_+8>>1]=V,X[_+10>>1]=V>>>16,m=m+1|0}_=m;break A}break i}i[N+12>>2]=_;A:{if((_|0)>(t0|0)||(X3(A,r,e,E,f,S,q,0,0,N+4|0,N+2|0),t[N+3|0]=0,m=u[N+2|0],i[e+28>>2]||(X3(A,r,e,E,f,S,q,0,1,N+8|0,N+3|0),j0=u[N+3|0],m=m|j0),!(m&255)))break A;i[N+12>>2]=_+1,f=I+g(_,12)|0,_=i[N+4>>2],X[f+4>>1]=_,X[f+6>>1]=_>>>16,_=i[N+8>>2],X[f+8>>1]=_,X[f+10>>1]=_>>>16,_=u[N+2|0],X[f+2>>1]=0,t[f+1|0]=j0,t[f|0]=_}if(_=i[e+28>>2],!_){E=0;A:{if(S=i[N+12>>2],(S|0)<2|(S|0)>=(c|0))break A;Y=e+988|0,B=e+924|0,x=g(S,S-1|0);k:{for(;;){if(f=E<<2,_=i[f+69296>>2],(_|0)>=(S|0)||(m=i[f+69344>>2],(m|0)>=(S|0)))break k;if(V=0,f=0,_=I+g(_,12)|0,u[_|0]&&(f=W[i[i[A>>2]+8>>2]](A,i[B+(t[_+2|0]<<2)>>2])|0),m=I+g(m,12)|0,u[m+1|0]&&(V=W[i[i[A>>2]+8>>2]](A,i[Y+(t[m+3|0]<<2)>>2])|0),q=u[_|0],!(!q||f)||(G=u[m+1|0],!(!G||V))||(!(i[f+96>>2]!=i[V+96>>2]|p[_+4>>1]!=p[m+8>>1])&p[_+6>>1]==p[m+10>>1]|(!q|!G)||(f=I+g(i[N+12>>2],12)|0,t[f+2|0]=u[_+2|0],V=u[m+3|0],t[f+1|0]=G,t[f|0]=q,t[f+3|0]=V,_=p[_+4>>1]|p[_+6>>1]<<16,X[f+4>>1]=_,X[f+6>>1]=_>>>16,_=p[m+8>>1]|p[m+10>>1]<<16,X[f+8>>1]=_,X[f+10>>1]=_>>>16,i[N+12>>2]=i[N+12>>2]+1),E=E+1|0,(x|0)==(E|0)))break A;if((c|0)==i[N+12>>2])break}break A}U0(13347,19905,1432,5762),M()}_=i[e+28>>2]}S=i[e+336>>2],(_|0)!=1&&(f=i[e+340>>2],S=(f|0)>(S|0)?S:f),q=i[N+12>>2];A:{if((t0|0)<(q|0))break A;if(f=c-q|0,E=f&1,_=0,(q|0)!=(t0|0))for(V=f&-2,f=0;c=i[e+28>>2],m=I+g(q,12)|0,G=(_|0)<(S|0)?_:0,t[m+2|0]=G,X[m+4>>1]=0,X[m+6>>1]=0,X[m+8>>1]=0,X[m+10>>1]=0,c=(c|0)!=1,t[m+1|0]=c,t[m|0]=1,t[m+3|0]=c?G:-1,c=i[e+28>>2],G=_|1,G=(G|0)<(S|0)?G:0,t[m+14|0]=G,X[m+16>>1]=0,X[m+18>>1]=0,X[m+20>>1]=0,X[m+22>>1]=0,t[m+12|0]=1,c=(c|0)!=1,t[m+13|0]=c,t[m+15|0]=c?G:-1,_=_+2|0,q=q+2|0,f=f+2|0,(V|0)!=(f|0););if(!E)break A;m=i[e+28>>2],f=I+g(q,12)|0,_=(_|0)<(S|0)?_:0,t[f+2|0]=_,X[f+4>>1]=0,X[f+6>>1]=0,X[f+8>>1]=0,X[f+10>>1]=0,m=(m|0)!=1,t[f+1|0]=m,t[f|0]=1,t[f+3|0]=m?_:-1}if(v=N+16|0,f=I+g(t0,12)|0,_=p[f>>1]|p[f+2>>1]<<16,m=p[f+4>>1]|p[f+6>>1]<<16,X[R>>1]=_,X[R+2>>1]=_>>>16,X[R+4>>1]=m,X[R+6>>1]=m>>>16,f=p[f+8>>1]|p[f+10>>1]<<16,X[R+8>>1]=f,X[R+10>>1]=f>>>16,!(_&255)|!u[R+1|0]|(h+w|0)!=12)break r;t[R+1|0]=0,t[R+3|0]=255;break r}f:{A:{k:{n:switch((N&3)-1|0){case 0:case 2:if(N=t[f|0],t[R|0]=1,t[R+2|0]=N,t[f|0]<16)break k;f=R+2|0;break f;default:break n}t[R|0]=0,t[R+2|0]=255;break A}S=p[f+4>>1],q=p[f+2>>1],G=N,N=U+16|0,D9(A,e,r,k,n,s,E,m,h,w,0,G,_,N),N=N+(u[f+10|0]&4)|0,N=p[N>>1]|p[N+2>>1]<<16,X[R+4>>1]=N+q,X[R+6>>1]=S+(N>>>16|0)}if(!(u[f+10|0]&2)){t[R+1|0]=0,t[R+3|0]=255;break r}if(N=t[f+1|0],t[R+1|0]=1,t[R+3|0]=N,t[f+1|0]>15){f=R+3|0;break f}S=p[f+8>>1],q=p[f+6>>1],G=_,_=U+16|0,D9(A,e,r,k,n,s,E,m,h,w,1,N,G,_),f=_+(u[f+10|0]>>>1&4)|0,f=p[f>>1]|p[f+2>>1]<<16,X[R+8>>1]=f+q,X[R+10>>1]=S+(f>>>16|0);break r}t[f|0]=0,t[r+312|0]=3,C2(A+4|0,1012,0)}v=U+80|0,_=A,m=k,N=n,S=o,q=l,f=R,k=v-49152|0,v=k;r:{f:{if(n=e,f1=i[e+4>>2],Q=i[f1+4>>2],x=i[Q+16832>>2],A=i[r+124>>2],(x|0)==i[A+16832>>2]&&(B=i[Q+16840>>2],(B|0)==i[A+16840>>2]))break f;t[r+312|0]=3,C2(_+4|0,1031,0);break r}if(i[Q+476>>2]!=i[r+20>>2]){t[r+312|0]=3,C2(_+4|0,1030,0);break r}Y=i[r+44>>2],s2=N+q|0,v2=i[Q+16856>>2],Z2=m+S|0,X2=i[Q+16852>>2],A=g(Y,(s2|0)/(v2|0)|0)+((Z2|0)/(X2|0)|0)|0,e=A<<u[r+18|0],l=i[r+12>>2],A=A<<u[r+17|0],R=i[r+8>>2],V0=i[r+40>>2],G=g(V0,s2)+Z2<<u[r+16|0],I=i[r+4>>2],E=u[f+1|0],o=u[f|0];f:{if(u[f1+41|0]|!o|(!E|p[f+4>>1]!=p[f+8>>1])||p[f+6>>1]!=p[f+10>>1])break f;E=i[(n+(t[f+2|0]<<2)|0)+924>>2]!=i[(n+(t[f+3|0]<<2)|0)+988>>2]?E:0}for(V=k+40960|0,c=k- -8192|0,d=e+l|0,M0=A+R|0,C0=I+G|0,v6=f+4|0,c2=_+4|0,m6=n+924|0,u4=f+2|0,j0=k+16384|0,l=k+32768|0,e=k,R=1,A=o;;){f:{if(!A)break f;if(A=t[u1+u4|0],(A|0)>=16){t[r+312|0]=3,C2(c2,1012,0);break r}if(t0=W[i[i[_>>2]+8>>2]](_,i[((u1<<6)+m6|0)+(A<<2)>>2])|0,!(i[t0+100>>2]&&t0)){t[r+312|0]=3,C2(c2,1012,0);break f}if(!(!(i[t0+24>>2]!=i[Q+484>>2]|i[t0+28>>2]!=i[Q+488>>2])&i[r+20>>2]==i[t0+20>>2])){t[r+312|0]=3,C2(c2,1029,0);break f}if(G=i[r+124>>2],I=i[G+16832>>2],A=i[t0+124>>2],!((I|0)==i[A+16832>>2]&i[G+16840>>2]==i[A+16840>>2])){t[r+312|0]=3,C2(c2,1028,0);break f}R2=(u1<<2)+v6|0,A=X[R2+2>>1],G=X[R2>>1],A0=i[t0+40>>2],D2=i[t0+4>>2];A:{if((I|0)>=9){U=0,g0=v-20448|0,v=g0,r0=(A>>2)+s2|0,O=(G>>2)+Z2|0,S0=i[Q+488>>2],X0=i[Q+484>>2];k:{if(!((A|G)&3)){A=i[Q+16832>>2];n:{if(!((O|r0)<0|(X0|0)<(h+O|0))&&(S0|0)>=(w+r0|0))break n;if((w|0)<=0|(h|0)<=0)break k;for(I=14-A|0,q0=S0-1|0,_0=X0-1|0,r2=h&2147483646,f2=h&1;;){if(A=U+r0|0,f0=(g((A|0)>=0?(A|0)<(S0|0)?A:q0:0,A0)<<1)+D2|0,z0=(g(s,U)<<1)+l|0,A=0,G=0,(h|0)!=1)for(;j=A+O|0,X[z0+(A<<1)>>1]=p[f0+(((j|0)>=0?(j|0)<(X0|0)?j:_0:0)<<1)>>1]<<I,A2=A|1,j=A2+O|0,X[z0+(A2<<1)>>1]=p[f0+(((j|0)>=0?(j|0)<(X0|0)?j:_0:0)<<1)>>1]<<I,A=A+2|0,G=G+2|0,(r2|0)!=(G|0););if(f2&&(G=z0+(A<<1)|0,A=A+O|0,X[G>>1]=p[f0+(((A|0)>=0?(A|0)<(X0|0)?A:_0:0)<<1)>>1]<<I),U=U+1|0,(U|0)==(w|0))break}break k}if(A=((g(A0,r0)<<1)+D2|0)+(O<<1)|0,(x|0)<=8){W[i[_+220>>2]](l,s,A,A0,h,w,g0+11360|0);break k}W[i[_+300>>2]](l,s,A,A0,h,w,g0+11360|0,x);break k}q0=A&3,A=q0<<2,I=i[A+69504>>2],f0=i[A+69488>>2],r2=G&3,G=r2<<2,A=i[G+69504>>2],_0=i[G+69488>>2];n:{if(!((r0|0)<(f0|0)|(_0|0)>(O|0)|((X0|0)<=(A+(h+O|0)|0)|(S0|0)<=(I+(w+r0|0)|0)))){A=((O<<1)+D2|0)+(g(A0,r0)<<1)|0;break n}U=0-f0|0,A2=w+I|0;t:{if((U|0)>=(A2|0)||(o1=A+h|0,G=0-_0|0,(o1|0)<=(G|0)))break t;for(Y4=S0-1|0,y4=_0+1|0,E4=O+1|0,I=1-_0|0,y1=(A+_0|0)+h|0,a1=y1&1,A=O-_0|0,f2=X0-1|0,f8=((A|0)>=0?(A|0)<(X0|0)?A:f2:0)<<1;;){if(A=U+r0|0,z0=(g((A|0)>=0?(A|0)<(S0|0)?A:Y4:0,A0)<<1)+D2|0,j=g(U+f0|0,80),A=G,a1&&(X[g0+(j<<1)>>1]=p[z0+f8>>1],A=I),(y1|0)!=1)for(A8=j+_0|0,k8=j+y4|0;j=A+O|0,X[g0+(A+A8<<1)>>1]=p[z0+(((j|0)>=0?(j|0)<(X0|0)?j:f2:0)<<1)>>1],j=A+E4|0,X[g0+(A+k8<<1)>>1]=p[z0+(((j|0)>=0?(j|0)<(X0|0)?j:f2:0)<<1)>>1],A=A+2|0,(o1|0)!=(A|0););if(U=U+1|0,(A2|0)==(U|0))break}}A0=80,A=g0+(_0+g(f0,80)<<1)|0}if((x|0)<=8){W[i[((_+(r2<<4)|0)+(q0<<2)|0)+220>>2]](l,s,A,A0,h,w,g0+11360|0);break k}W[i[((_+(r2<<4)|0)+(q0<<2)|0)+300>>2]](l,s,A,A0,h,w,g0+11360|0,x)}v=g0+20448|0;break A}U=0,g0=v-14768|0,v=g0,r0=(A>>2)+s2|0,O=(G>>2)+Z2|0,S0=i[Q+488>>2],X0=i[Q+484>>2];k:{if(!((A|G)&3)){A=i[Q+16832>>2];n:{if(!((O|r0)<0|(X0|0)<(h+O|0))&&(S0|0)>=(w+r0|0))break n;if((w|0)<=0|(h|0)<=0)break k;for(I=14-A|0,q0=S0-1|0,_0=X0-1|0,r2=h&2147483646,f2=h&1;;){if(A=U+r0|0,f0=g((A|0)>=0?(A|0)<(S0|0)?A:q0:0,A0)+D2|0,z0=(g(s,U)<<1)+l|0,A=0,G=0,(h|0)!=1)for(;j=A+O|0,X[z0+(A<<1)>>1]=u[f0+((j|0)>=0?(j|0)<(X0|0)?j:_0:0)|0]<<I,A2=A|1,j=A2+O|0,X[z0+(A2<<1)>>1]=u[f0+((j|0)>=0?(j|0)<(X0|0)?j:_0:0)|0]<<I,A=A+2|0,G=G+2|0,(r2|0)!=(G|0););if(f2&&(G=z0+(A<<1)|0,A=A+O|0,X[G>>1]=u[f0+((A|0)>=0?(A|0)<(X0|0)?A:_0:0)|0]<<I),U=U+1|0,(U|0)==(w|0))break}break k}if(A=O+(g(A0,r0)+D2|0)|0,(x|0)<=8){W[i[_+220>>2]](l,s,A,A0,h,w,g0+5680|0);break k}W[i[_+300>>2]](l,s,A,A0,h,w,g0+5680|0,x);break k}q0=A&3,A=q0<<2,I=i[A+69504>>2],f0=i[A+69488>>2],r2=G&3,G=r2<<2,A=i[G+69504>>2],_0=i[G+69488>>2];n:{if(!((r0|0)<(f0|0)|(_0|0)>(O|0)|((X0|0)<=(A+(h+O|0)|0)|(S0|0)<=(I+(w+r0|0)|0)))){A=(O+D2|0)+g(A0,r0)|0;break n}U=0-f0|0,A2=w+I|0;t:{if((U|0)>=(A2|0)||(o1=A+h|0,G=0-_0|0,(o1|0)<=(G|0)))break t;for(Y4=S0-1|0,I=O-_0|0,f2=X0-1|0,y4=(I|0)>=0?(I|0)<(X0|0)?I:f2:0,E4=_0+1|0,y1=O+1|0,I=1-_0|0,a1=(A+_0|0)+h|0,f8=a1&1;;){if(A=U+r0|0,z0=g((A|0)>=0?(A|0)<(S0|0)?A:Y4:0,A0)+D2|0,j=g(U+f0|0,80),A=G,f8&&(t[j+g0|0]=u[z0+y4|0],A=I),(a1|0)!=1)for(A8=j+_0|0,k8=j+E4|0;j=A+O|0,t[g0+(A+A8|0)|0]=u[z0+((j|0)>=0?(j|0)<(X0|0)?j:f2:0)|0],j=A+y1|0,t[g0+(A+k8|0)|0]=u[z0+((j|0)>=0?(j|0)<(X0|0)?j:f2:0)|0],A=A+2|0,(o1|0)!=(A|0););if(U=U+1|0,(A2|0)==(U|0))break}}A0=80,A=g0+(_0+g(f0,80)|0)|0}if((x|0)<=8){W[i[((_+(r2<<4)|0)+(q0<<2)|0)+220>>2]](l,s,A,A0,h,w,g0+5680|0);break k}W[i[((_+(r2<<4)|0)+(q0<<2)|0)+300>>2]](l,s,A,A0,h,w,g0+5680|0,x)}v=g0+14768|0}if(!i[r+20>>2])break f;if(A=(w|0)/(v2|0)|0,l=(h|0)/(X2|0)|0,G=(u1<<13)+j0|0,I=X[R2+2>>1],U=X[R2>>1],A0=i[t0+44>>2],O=i[t0+8>>2],i[i[r+124>>2]+16840>>2]>=9){Tn(_,Q,U,I,Z2,s2,e,s,O,A0,l,A,B),Tn(_,Q,X[R2>>1],X[R2+2>>1],Z2,s2,G,s,i[t0+12>>2],i[t0+44>>2],l,A,B);break f}qn(_,Q,U,I,Z2,s2,e,s,O,A0,l,A,B),qn(_,Q,X[R2>>1],X[R2+2>>1],Z2,s2,G,s,i[t0+12>>2],i[t0+44>>2],l,A,B)}if(u1=1,G=R,R=0,A=E,e=c,l=V,!G)break}A=i[Q+16840>>2],l=(A|0)>12?2:14-A|0,A=i[Q+16832>>2],R=(A|0)>12?2:14-A|0,e=i[r+124>>2],A=u[e+16993|0],e=u[e+16992|0];f:switch(i[n+28>>2]){case 1:if(o=!E&(o|0)==1,!u[f1+41|0]){if(o){A:{if((x|0)<=8){W[i[_+176>>2]](C0,V0,k+32768|0,s,h,w);break A}W[i[_+192>>2]](C0,V0,k+32768|0,s,h,w,x)}if(!i[r+20>>2])break r;if(A=(w|0)/(v2|0)|0,e=(h|0)/(X2|0)|0,(B|0)<=8){W[i[_+176>>2]](M0,Y,k,s,e,A),W[i[_+176>>2]](d,Y,j0,s,e,A);break r}W[i[_+192>>2]](M0,Y,k,s,e,A,B),W[i[_+192>>2]](d,Y,j0,s,e,A,B);break r}C2(c2,1011,0),t[r+312|0]=3;break r}if(o){o=R+u[n+388|0]|0,E=t[u4|0],e=t[(E+n|0)+518|0]<<e,R=n+(E<<1)|0,c=t[R+679|0],V=n+(E<<2)|0,E=X[V+552>>1],G=t[R+678|0],V=X[V+550>>1],R=X[R+454>>1],I=u[n+389|0];A:{if((x|0)<=8){W[i[_+180>>2]](C0,V0,k+32768|0,s,h,w,R,e,o);break A}W[i[_+196>>2]](C0,V0,k+32768|0,s,h,w,R,e,o,x)}if(!i[r+20>>2])break r;if(e=(w|0)/(v2|0)|0,n=(h|0)/(X2|0)|0,o=l+I|0,l=G<<A,A=c<<A,(B|0)<=8){W[i[_+180>>2]](M0,Y,k,s,n,e,V,l,o),W[i[_+180>>2]](d,Y,j0,s,n,e,E,A,o);break r}W[i[_+196>>2]](M0,Y,k,s,n,e,V,l,o,B),W[i[_+196>>2]](d,Y,j0,s,n,e,E,A,o,B);break r}C2(c2,1011,0),t[r+312|0]=3;break r;default:U0(21748,19905,528,5903),M();case 0:break f}if(!((o|0)!=1|(E|0)!=1)){if(!u[f1+42|0]){A=k+40960|0;f:{if((x|0)<=8){W[i[_+172>>2]](C0,V0,k+32768|0,A,s,h,w);break f}W[i[_+188>>2]](C0,V0,k+32768|0,A,s,h,w,x)}if(!i[r+20>>2])break r;if(A=(w|0)/(v2|0)|0,e=(h|0)/(X2|0)|0,n=k- -8192|0,o=k+24576|0,(B|0)<=8){W[i[_+172>>2]](M0,Y,k,n,s,e,A),W[i[_+172>>2]](d,Y,j0,o,s,e,A);break r}W[i[_+188>>2]](M0,Y,k,n,s,e,A,B),W[i[_+188>>2]](d,Y,j0,o,s,e,A,B);break r}if(o=t[f+3|0],E=n+(o<<1)|0,G=t[E+711|0],V=n+(o<<2)|0,I=X[V+616>>1],U=t[E+710|0],Q=X[V+614>>1],V=t[f+2|0],c=n+(V<<1)|0,A0=t[c+679|0],t0=n+(V<<2)|0,O=X[t0+552>>1],X0=t[c+678|0],t0=X[t0+550>>1],g0=u[n+389|0],_=_+172|0,K5(_,C0,V0,k+32768|0,k+40960|0,s,h,w,X[c+454>>1],t[(n+V|0)+518|0]<<e,X[E+486>>1],t[(n+o|0)+534|0]<<e,R+u[n+388|0]|0,x),!i[r+20>>2])break r;e=(h|0)/(X2|0)|0,n=(w|0)/(v2|0)|0,o=l+g0|0,K5(_,M0,Y,k,k- -8192|0,s,e,n,t0,X0<<A,Q,U<<A,o,B),K5(_,d,Y,j0,k+24576|0,s,e,n,O,A0<<A,I,G<<A,o,B);break r}if(!((o|0)!=1&(E|0)!=1)){if(!u[f1+42|0]){A=(k+32768|0)+(o?0:8192)|0;f:{if((x|0)<=8){W[i[_+176>>2]](C0,V0,A,s,h,w);break f}W[i[_+192>>2]](C0,V0,A,s,h,w,x)}if(!i[r+20>>2])break r;if(n=o?j0:k+24576|0,o=k+(o?0:8192)|0,A=(w|0)/(v2|0)|0,e=(h|0)/(X2|0)|0,(B|0)<=8){W[i[_+176>>2]](M0,Y,o,s,e,A),W[i[_+176>>2]](d,Y,n,s,e,A);break r}W[i[_+192>>2]](M0,Y,o,s,e,A,B),W[i[_+192>>2]](d,Y,n,s,e,A,B);break r}E=!o,V=t[E+u4|0],e=t[(V+(n+(E<<4)|0)|0)+518|0]<<e,c=(k+32768|0)+(o?0:8192)|0,G=(n+(E<<5)|0)+(V<<1)|0,I=t[G+679|0],V=(n+(E<<6)|0)+(V<<2)|0,E=X[V+552>>1],U=t[G+678|0],V=X[V+550>>1],G=X[G+454>>1],R=R+u[n+388|0]|0,Q=u[n+389|0];f:{if((x|0)<=8){W[i[_+180>>2]](C0,V0,c,s,h,w,G,e,R);break f}W[i[_+196>>2]](C0,V0,c,s,h,w,G,e,R,x)}if(!i[r+20>>2])break r;if(R=o?j0:k+24576|0,c=k+(o?0:8192)|0,e=(w|0)/(v2|0)|0,n=(h|0)/(X2|0)|0,o=l+Q|0,l=U<<A,A=I<<A,(B|0)<=8){W[i[_+180>>2]](M0,Y,c,s,n,e,V,l,o),W[i[_+180>>2]](d,Y,R,s,n,e,E,A,o);break r}W[i[_+196>>2]](M0,Y,c,s,n,e,V,l,o,B),W[i[_+196>>2]](d,Y,R,s,n,e,E,A,o,B);break r}C2(c2,1011,0),t[r+312|0]=3}v=k+49152|0,k=m+S|0,n=N+q|0,A=f,w=w>>2;r:{if((w|0)<=0||(e=h>>2,(e|0)<=0))break r;for(_=n>>2,n=k>>2,m=i[r+192>>2],h=h&4,E=e&2147483646,f=0,R=(e|0)==1;;){if(l=g(m,f+_|0),e=0,o=0,!R)for(;s=p[A+4>>1]|p[A+6>>1]<<16,q=g(l,12),S=g(e,12),N=g(n,12),k=q+(S+(N+i[r+180>>2]|0)|0)|0,V=p[A>>1]|p[A+2>>1]<<16,X[k>>1]=V,X[k+2>>1]=V>>>16,X[k+4>>1]=s,X[k+6>>1]=s>>>16,s=p[A+8>>1]|p[A+10>>1]<<16,X[k+8>>1]=s,X[k+10>>1]=s>>>16,k=q+(S+(N+i[r+180>>2]|0)|0)|0,s=p[A+8>>1]|p[A+10>>1]<<16,X[k+20>>1]=s,X[k+22>>1]=s>>>16,s=p[A+4>>1]|p[A+6>>1]<<16,N=p[A>>1]|p[A+2>>1]<<16,X[k+12>>1]=N,X[k+14>>1]=N>>>16,X[k+16>>1]=s,X[k+18>>1]=s>>>16,e=e+2|0,o=o+2|0,(E|0)!=(o|0););if(h&&(k=p[A+4>>1]|p[A+6>>1]<<16,e=((i[r+180>>2]+g(n,12)|0)+g(e,12)|0)+g(l,12)|0,o=p[A>>1]|p[A+2>>1]<<16,X[e>>1]=o,X[e+2>>1]=o>>>16,X[e+4>>1]=k,X[e+6>>1]=k>>>16,k=p[A+8>>1]|p[A+10>>1]<<16,X[e+8>>1]=k,X[e+10>>1]=k>>>16),f=f+1|0,(w|0)==(f|0))break}}v=d1+16|0;return}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function kA(){var A=0,e=0,r=0,f=0,k=0,n=0,o=0,l=0;i:{e:{if(r=i[28782],n=i[28783],(r|0)==(n|0)){A=C(16),i[A+12>>2]=110908,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=108784,f=A+12|0,e=i[28784];r:{if(r>>>0<e>>>0){i[n+4>>2]=A,i[n>>2]=f,A=n+8|0;break r}if(e=e-r|0,n=e>>2,e=e>>>0>=2147483640?536870911:n>>>0<=1?1:n,e>>>0>=536870912)break e;if(e=e<<3,n=C(e),i[n+4>>2]=A,i[n>>2]=f,e=e+n|0,i[28784]=e,A=n+8|0,i[28783]=A,i[28782]=n,!r)break r;Z(r),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=111052,i[r>>2]=108832,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=108912,i[r>>2]=108872,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=108988,i[r>>2]=108948,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110800,i[r>>2]=109024,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110836,i[r>>2]=109064,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110872,i[r>>2]=109104,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110944,i[r>>2]=109144,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110980,i[r>>2]=109184,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=111124,i[r>>2]=109224,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=111160,i[r>>2]=109264,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=111368,i[r>>2]=109304,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=111088,i[r>>2]=109344,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=111016,i[r>>2]=109384,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110692,i[r>>2]=109424,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=109504,i[r>>2]=109464,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=109580,i[r>>2]=109540,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110656,i[r>>2]=109616,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110728,i[r>>2]=109656,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=111268,i[r>>2]=109696,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=109776,i[r>>2]=109736,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=109852,i[r>>2]=109812,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=111304,i[r>>2]=109888,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=111196,i[r>>2]=109928,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=111232,i[r>>2]=109968,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110048,i[r>>2]=110008,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110124,i[r>>2]=110084,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110200,i[r>>2]=110160,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110276,i[r>>2]=110236,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110352,i[r>>2]=110312,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110428,i[r>>2]=110388,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110504,i[r>>2]=110464,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110580,i[r>>2]=110540,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,A=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[28784]=e,A=k+8|0,i[28783]=A,i[28782]=r,!n)break r;Z(n),e=i[28784]}i[28783]=A,r=C(16),i[r+12>>2]=110764,i[r>>2]=110616,i[r+4>>2]=0,i[r+8>>2]=0,o=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=o,e=A+8|0;break r}if(n=i[28782],A=A-n|0,l=A>>3,f=l+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=C(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=o,r=k-(l<<3)|0,A&&z(r,n,A),i[28784]=e+(f<<3),e=k+8|0,i[28783]=e,i[28782]=r,!n)break r;Z(n)}i[28783]=e}return}x0(),M()}s0(),M()}function p9(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0;o=v-272|0,v=o;i:{e:{r:{f:{A:{k:{n:{t:switch(i[e+200>>2]-1|0){case 1:if((r|0)<=179){if(!r)break A;if((r|0)==90)break n;break r}if((r|0)==270)break n;if((r|0)!=180)break r;if(k=i[e+192>>2],k&1)break n;l=i[e+188>>2];break e;case 0:break t;default:break k}if((r|0)<=179){if(!r)break A;if((r|0)!=90)break r;if(k=i[e+188>>2],k&1)break n;l=i[e+192>>2];break e}if((r|0)!=180){if((r|0)!=270)break r;if(l=i[e+192>>2],l&1)break n;k=i[e+188>>2];break e}if(l=i[e+188>>2],l&1)break n;if(k=i[e+192>>2],!(k&1))break e}if(i[o+224>>2]=0,i[o+228>>2]=0,i[o+216>>2]=0,i[o+220>>2]=0,t[o+228|0]=1,i[o+220>>2]=2,i[o+224>>2]=2,t[o+216|0]=1,i[o+24>>2]=i[e+164>>2],k=i[e+168>>2],!k||(k=Oi(k),i[o+28>>2]=k,!k))break f;i[o+200>>2]=131074,i[o+204>>2]=65538,l=o+48|0,U=o+24|0,s=o+200|0,n=i[e+204>>2],e=i[e+208>>2],k=0;n:{if((n|0)==(e|0))break n;t:{for(;;){if(!i[n>>2])break t;if(n=n+56|0,(e|0)==(n|0))break}k=0;break n}k=p[n+20>>1]}G6(l,U,0,3,s,k,o+216|0,0,f),e=i[o+28>>2];n:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break n;W[i[i[e>>2]+8>>2]](e),y(e)}n:{t:switch(u[o+68|0]){default:e2(),M();case 1:e=i[o+52>>2],i[A>>2]=i[o+48>>2],i[A+4>>2]=e,e=A+8|0;o:{if(t[o+67|0]>=0){r=i[o+60>>2],i[e>>2]=i[o+56>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+64>>2];break o}T(e,i[o+56>>2],i[o+60>>2])}t[A+20|0]=1;break n;case 0:break t}p9(A,i[o+48>>2],r,f)}if(A=u[o+68|0],(A|0)==255)break i;e=i[25407],i[o+24>>2]=i[25406],i[o+28>>2]=e,W[i[(o+24|0)+(A<<2)>>2]](o+200|0,o+48|0);break i}if(r)break r}if(r=i[e+168>>2],!r||(e=i[e+164>>2],r=Oi(r),!r))break f;t[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e;break i}sf(),M()}if(l=i[e+192>>2],n=i[e+188>>2],!((r|0)==270|(r|0)==90)){k=l,l=n;break e}k=n}U=C(248),n=U,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=101168,l0(n+16|0,0,156),i[n+76>>2]=0,i[n+80>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,t[n+24|0]=1,X[n+22>>1]=2,X[n+18>>1]=2,X[n+20>>1]=2,i[n+84>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+128>>2]=0,i[n+132>>2]=0,i[n+100>>2]=0,i[n+104>>2]=1,i[n+136>>2]=0,i[n+140>>2]=0,i[n+144>>2]=0,i[n+148>>2]=0,i[n+152>>2]=0,i[n+156>>2]=0,X[n+158>>1]=0,X[n+160>>1]=0,X[n+162>>1]=0,X[n+164>>1]=0,i[n+184>>2]=0,i[n+188>>2]=0,i[n+172>>2]=255,i[n+192>>2]=0,i[n+196>>2]=5186,i[n+208>>2]=99,i[n+212>>2]=99,i[n+200>>2]=0,i[n+204>>2]=0,i[n+12>>2]=101488,i[n+216>>2]=0,i[n+220>>2]=0,i[n+224>>2]=0,i[n+228>>2]=0,i[n+232>>2]=0,i[n+236>>2]=0,i[n+240>>2]=0,i[n+244>>2]=0,q=n+12|0,i[n+176>>2]=q,i[n+8>>2]=i[n+8>>2]+1,i[n+180>>2]=n,i[n+4>>2]==-1&&(W[i[i[n>>2]+8>>2]](n),y(n)),n=i[e+200>>2],h=i[e+196>>2],i[U+208>>2]=h,i[U+204>>2]=k,i[U+200>>2]=l,i[U+212>>2]=(h|0)==1?n||3:n,Ye(q,e);e:{if(R=i[e+204>>2],d=i[e+208>>2],(R|0)!=(d|0))for(c=U+216|0,A0=U+228|0,t0=(r|0)==270,_0=(r|0)!=90;;){l=i[R+28>>2],n=i[R+24>>2];r:{if(!(!_0|t0)){k=n,n=l;break r}k=l}if(i[o+220>>2]=0,i[o+224>>2]=0,X[o+236>>1]=0,i[o+228>>2]=0,i[o+232>>2]=0,t[o+238|0]=1,t[o+271|0]=0,t[o+263|0]=0,t[o+264|0]=0,t[o+265|0]=0,t[o+266|0]=0,t[o+267|0]=0,t[o+268|0]=0,t[o+269|0]=0,t[o+270|0]=0,t[o+255|0]=0,t[o+256|0]=0,t[o+257|0]=0,t[o+258|0]=0,t[o+259|0]=0,t[o+260|0]=0,t[o+261|0]=0,t[o+262|0]=0,t[o+247|0]=0,t[o+248|0]=0,t[o+249|0]=0,t[o+250|0]=0,t[o+251|0]=0,t[o+252|0]=0,t[o+253|0]=0,t[o+254|0]=0,t[o+239|0]=0,t[o+240|0]=0,t[o+241|0]=0,t[o+242|0]=0,t[o+243|0]=0,t[o+244|0]=0,t[o+245|0]=0,t[o+246|0]=0,i[o+216>>2]=i[R>>2],O6(o+48|0,o+216|0,k,n,i[R+16>>2],p[R+20>>1],u[R+22|0],f,A0),i[o+48>>2]){if(e=i[o+52>>2],i[A>>2]=i[o+48>>2],i[A+4>>2]=e,e=A+8|0,t[o+67|0]>=0){r=i[o+60>>2],i[e>>2]=i[o+56>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+64>>2],t[A+20|0]=1;break e}if(T(e,i[o+56>>2],i[o+60>>2]),e=t[o+67|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[o+56>>2]);break e}t[o+67|0]<0&&Z(i[o+56>>2]),l=0,i[o+208>>2]=0,i[o+200>>2]=0,i[o+204>>2]=0;r:{f:{A:{k:{if(h=i[R+4>>2],s=i[R+8>>2],(h|0)!=(s|0)){if(k=s-h|0,(k|0)<0)break k;l=C(k),i[o+204>>2]=l,i[o+200>>2]=l,i[o+208>>2]=k+l,s=i[R+8>>2],h=i[R+4>>2]}if((s|0)==(h|0))break r;for(;;){k=0,n=i[e+80>>2],I=i[e+84>>2];n:{if((n|0)==(I|0))break n;for(w=i[h>>2];;){if((w|0)==i[n>>2]){k=n;break n}if(n=n+44|0,(I|0)==(n|0))break}}w=i[o+208>>2];n:{if(w>>>0>l>>>0){i[l>>2]=k,l=l+4|0;break n}if(I=i[o+200>>2],n=l-I|0,Y=n>>2,l=Y+1|0,l>>>0>=1073741824)break A;if(w=w-I|0,N=w>>1,w=w>>>0>=2147483644?1073741823:l>>>0<N>>>0?N:l,w){if(w>>>0>=1073741824)break f;l=C(w<<2)}else l=0;if(N=l+n|0,i[N>>2]=k,k=N-(Y<<2)|0,n&&z(k,I,n),i[o+208>>2]=l+(w<<2),l=N+4|0,i[o+204>>2]=l,i[o+200>>2]=k,!I)break n;Z(I)}if(i[o+204>>2]=l,h=h+4|0,(s|0)==(h|0))break}break r}s0(),M()}s0(),M()}x0(),M()}yn(q,o+216|0,o+200|0);r:{f:{A:{k=p[R+20>>1];k:{if(k>>>0<9){n=0,N=i[o+256>>2],l=i[o+268>>2],Y=i[R+40>>2],B=i[R+52>>2],I=i[R+28>>2],k=i[R+24>>2];n:{if((r|0)!=270){if((r|0)!=180){if(!k|(!I|(r|0)!=90))break n;for(G=k+Y|0,m=k&-4,Y=k&3,E=k>>>0<4;;){if(s=n+N|0,w=G+g(n,B)|0,k=0,h=0,!E)for(;t[s+g(k,l)|0]=u[w+(k^-1)|0],t[s+g(l,k|1)|0]=u[w+(k^-2)|0],t[s+g(l,k|2)|0]=u[w+(k^-3)|0],t[s+g(l,k|3)|0]=u[w+(k^-4)|0],k=k+4|0,h=h+4|0,(m|0)!=(h|0););if(h=0,Y)for(;t[s+g(k,l)|0]=u[w+(k^-1)|0],k=k+1|0,h=h+1|0,(Y|0)!=(h|0););if(n=n+1|0,(I|0)==(n|0))break}break n}if(!I|!k)break n;for(G=k+Y|0,m=k&-4,Y=k&3,E=k>>>0<4;;){if(h=N+g(n,l)|0,w=G+g(B,I+(n^-1)|0)|0,k=0,!E)for(_=h+3|0,V=h+2|0,Q=h+1|0,s=0;t[k+h|0]=u[w+(k^-1)|0],t[k+Q|0]=u[w+(k^-2)|0],t[k+V|0]=u[w+(k^-3)|0],t[k+_|0]=u[w+(k^-4)|0],k=k+4|0,s=s+4|0,(m|0)!=(s|0););if(s=0,Y)for(;t[k+h|0]=u[w+(k^-1)|0],k=k+1|0,s=s+1|0,(Y|0)!=(s|0););if(n=n+1|0,(I|0)==(n|0))break}break n}if(!I|!k)break n;for(m=k&-4,G=k&3,E=k-1>>>0<3;;){if(s=n+N|0,w=Y+g(B,I+(n^-1)|0)|0,k=0,h=0,!E)for(;t[s+g(k,l)|0]=u[k+w|0],_=k|1,t[s+g(_,l)|0]=u[w+_|0],_=k|2,t[s+g(_,l)|0]=u[w+_|0],_=k|3,t[s+g(_,l)|0]=u[w+_|0],k=k+4|0,h=h+4|0,(m|0)!=(h|0););if(h=0,G)for(;t[s+g(k,l)|0]=u[k+w|0],k=k+1|0,h=h+1|0,(G|0)!=(h|0););if(n=n+1|0,(I|0)==(n|0))break}}break k}if(k>>>0<=16){n=0,l=i[o+268>>2]>>>1|0,N=i[R+52>>2]>>>1|0,Y=i[o+256>>2],B=i[R+40>>2],I=i[R+28>>2],k=i[R+24>>2];n:{if((r|0)!=270){if((r|0)!=180){if(!k|(!I|(r|0)!=90))break n;for(G=B+(k<<1)|0,m=k&-4,B=k&3,E=k>>>0<4;;){if(s=Y+(n<<1)|0,w=G+(g(n,N)<<1)|0,k=0,h=0,!E)for(;X[s+(g(k,l)<<1)>>1]=p[w+((k^-1)<<1)>>1],X[s+(g(l,k|1)<<1)>>1]=p[w+((k^2147483646)<<1)>>1],X[s+(g(l,k|2)<<1)>>1]=p[w+((k^2147483645)<<1)>>1],X[s+(g(l,k|3)<<1)>>1]=p[w+((k^2147483644)<<1)>>1],k=k+4|0,h=h+4|0,(m|0)!=(h|0););if(h=0,B)for(;X[s+(g(k,l)<<1)>>1]=p[w+((k^-1)<<1)>>1],k=k+1|0,h=h+1|0,(B|0)!=(h|0););if(n=n+1|0,(I|0)==(n|0))break}break n}if(!I|!k)break n;for(m=B+(k<<1)|0,E=k&-4,G=k&3,_=k>>>0<4;;){if(h=Y+(g(n,l)<<1)|0,w=m+(g(N,I+(n^-1)|0)<<1)|0,k=0,!_)for(V=h+6|0,Q=h+4|0,j=h+2|0,s=0;B=k<<1,X[B+h>>1]=p[w+((k^-1)<<1)>>1],X[B+j>>1]=p[w+((k^2147483646)<<1)>>1],X[B+Q>>1]=p[w+((k^2147483645)<<1)>>1],X[B+V>>1]=p[w+((k^2147483644)<<1)>>1],k=k+4|0,s=s+4|0,(E|0)!=(s|0););if(s=0,G)for(;X[h+(k<<1)>>1]=p[w+((k^-1)<<1)>>1],k=k+1|0,s=s+1|0,(G|0)!=(s|0););if(n=n+1|0,(I|0)==(n|0))break}break n}if(!I|!k)break n;for(m=k&-4,G=k&3,E=k-1>>>0<3;;){if(s=Y+(n<<1)|0,w=B+(g(N,I+(n^-1)|0)<<1)|0,k=0,h=0,!E)for(;X[s+(g(k,l)<<1)>>1]=p[w+(k<<1)>>1],_=k|1,X[s+(g(_,l)<<1)>>1]=p[w+(_<<1)>>1],_=k|2,X[s+(g(_,l)<<1)>>1]=p[w+(_<<1)>>1],_=k|3,X[s+(g(_,l)<<1)>>1]=p[w+(_<<1)>>1],k=k+4|0,h=h+4|0,(m|0)!=(h|0););if(h=0,G)for(;X[s+(g(k,l)<<1)>>1]=p[w+(k<<1)>>1],k=k+1|0,h=h+1|0,(G|0)!=(h|0););if(n=n+1|0,(I|0)==(n|0))break}}break k}if(k>>>0<=32){n=0,l=i[o+268>>2]>>>2|0,N=i[R+52>>2]>>>2|0,Y=i[o+256>>2],B=i[R+40>>2],I=i[R+28>>2],k=i[R+24>>2];n:{if((r|0)!=270){if((r|0)!=180){if(!k|(!I|(r|0)!=90))break n;for(G=B+(k<<2)|0,m=k&-4,B=k&3,E=k>>>0<4;;){if(s=Y+(n<<2)|0,w=G+(g(n,N)<<2)|0,k=0,h=0,!E)for(;i[s+(g(k,l)<<2)>>2]=i[w+((k^-1)<<2)>>2],i[s+(g(l,k|1)<<2)>>2]=i[w+((k^1073741822)<<2)>>2],i[s+(g(l,k|2)<<2)>>2]=i[w+((k^1073741821)<<2)>>2],i[s+(g(l,k|3)<<2)>>2]=i[w+((k^1073741820)<<2)>>2],k=k+4|0,h=h+4|0,(m|0)!=(h|0););if(h=0,B)for(;i[s+(g(k,l)<<2)>>2]=i[w+((k^-1)<<2)>>2],k=k+1|0,h=h+1|0,(B|0)!=(h|0););if(n=n+1|0,(I|0)==(n|0))break}break n}if(!I|!k)break n;for(m=B+(k<<2)|0,E=k&-4,G=k&3,_=k>>>0<4;;){if(h=Y+(g(n,l)<<2)|0,w=m+(g(N,I+(n^-1)|0)<<2)|0,k=0,!_)for(V=h+12|0,Q=h+8|0,j=h+4|0,s=0;B=k<<2,i[B+h>>2]=i[w+((k^-1)<<2)>>2],i[B+j>>2]=i[w+((k^1073741822)<<2)>>2],i[B+Q>>2]=i[w+((k^1073741821)<<2)>>2],i[B+V>>2]=i[w+((k^1073741820)<<2)>>2],k=k+4|0,s=s+4|0,(E|0)!=(s|0););if(s=0,G)for(;i[h+(k<<2)>>2]=i[w+((k^-1)<<2)>>2],k=k+1|0,s=s+1|0,(G|0)!=(s|0););if(n=n+1|0,(I|0)==(n|0))break}break n}if(!I|!k)break n;for(m=k&-4,G=k&3,E=k-1>>>0<3;;){if(s=Y+(n<<2)|0,w=B+(g(N,I+(n^-1)|0)<<2)|0,k=0,h=0,!E)for(;i[s+(g(k,l)<<2)>>2]=i[w+(k<<2)>>2],_=k|1,i[s+(g(_,l)<<2)>>2]=i[w+(_<<2)>>2],_=k|2,i[s+(g(_,l)<<2)>>2]=i[w+(_<<2)>>2],_=k|3,i[s+(g(_,l)<<2)>>2]=i[w+(_<<2)>>2],k=k+4|0,h=h+4|0,(m|0)!=(h|0););if(h=0,G)for(;i[s+(g(k,l)<<2)>>2]=i[w+(k<<2)>>2],k=k+1|0,h=h+1|0,(G|0)!=(h|0););if(n=n+1|0,(I|0)==(n|0))break}}break k}if(k>>>0<=64){n=0,l=i[o+268>>2]>>>3|0,N=i[R+52>>2]>>>3|0,Y=i[o+256>>2],B=i[R+40>>2],I=i[R+28>>2],k=i[R+24>>2];n:{if((r|0)!=270){if((r|0)!=180){if(!k|(!I|(r|0)!=90))break n;for(G=B+(k<<3)|0,m=k&-4,B=k&3,E=k>>>0<4;;){if(s=Y+(n<<3)|0,w=G+(g(n,N)<<3)|0,k=0,h=0,!E)for(;V=w+((k^-1)<<3)|0,Q=i[V+4>>2],_=s+(g(k,l)<<3)|0,i[_>>2]=i[V>>2],i[_+4>>2]=Q,V=w+((k^536870910)<<3)|0,Q=i[V+4>>2],_=s+(g(l,k|1)<<3)|0,i[_>>2]=i[V>>2],i[_+4>>2]=Q,V=w+((k^536870909)<<3)|0,Q=i[V+4>>2],_=s+(g(l,k|2)<<3)|0,i[_>>2]=i[V>>2],i[_+4>>2]=Q,V=w+((k^536870908)<<3)|0,Q=i[V+4>>2],_=s+(g(l,k|3)<<3)|0,i[_>>2]=i[V>>2],i[_+4>>2]=Q,k=k+4|0,h=h+4|0,(m|0)!=(h|0););if(h=0,B)for(;V=w+((k^-1)<<3)|0,Q=i[V+4>>2],_=s+(g(k,l)<<3)|0,i[_>>2]=i[V>>2],i[_+4>>2]=Q,k=k+1|0,h=h+1|0,(B|0)!=(h|0););if(n=n+1|0,(I|0)==(n|0))break}break n}if(!I|!k)break n;for(m=B+(k<<3)|0,E=k&-4,G=k&3,_=k>>>0<4;;){if(h=Y+(g(n,l)<<3)|0,w=m+(g(N,I+(n^-1)|0)<<3)|0,k=0,!_)for(V=h+24|0,Q=h+16|0,j=h+8|0,s=0;O=w+((k^-1)<<3)|0,S=i[O+4>>2],B=k<<3,x=B+h|0,i[x>>2]=i[O>>2],i[x+4>>2]=S,O=w+((k^536870910)<<3)|0,S=i[O+4>>2],x=B+j|0,i[x>>2]=i[O>>2],i[x+4>>2]=S,O=w+((k^536870909)<<3)|0,S=i[O+4>>2],x=B+Q|0,i[x>>2]=i[O>>2],i[x+4>>2]=S,x=w+((k^536870908)<<3)|0,O=i[x+4>>2],B=B+V|0,i[B>>2]=i[x>>2],i[B+4>>2]=O,k=k+4|0,s=s+4|0,(E|0)!=(s|0););if(s=0,G)for(;V=w+((k^-1)<<3)|0,Q=i[V+4>>2],B=h+(k<<3)|0,i[B>>2]=i[V>>2],i[B+4>>2]=Q,k=k+1|0,s=s+1|0,(G|0)!=(s|0););if(n=n+1|0,(I|0)==(n|0))break}break n}if(!I|!k)break n;for(m=k&-4,G=k&3,E=k-1>>>0<3;;){if(s=Y+(n<<3)|0,w=B+(g(N,I+(n^-1)|0)<<3)|0,k=0,h=0,!E)for(;V=w+(k<<3)|0,Q=i[V+4>>2],_=s+(g(k,l)<<3)|0,i[_>>2]=i[V>>2],i[_+4>>2]=Q,_=k|1,V=s+(g(_,l)<<3)|0,_=w+(_<<3)|0,Q=i[_+4>>2],i[V>>2]=i[_>>2],i[V+4>>2]=Q,_=k|2,V=s+(g(_,l)<<3)|0,_=w+(_<<3)|0,Q=i[_+4>>2],i[V>>2]=i[_>>2],i[V+4>>2]=Q,_=k|3,V=s+(g(_,l)<<3)|0,_=w+(_<<3)|0,Q=i[_+4>>2],i[V>>2]=i[_>>2],i[V+4>>2]=Q,k=k+4|0,h=h+4|0,(m|0)!=(h|0););if(h=0,G)for(;V=w+(k<<3)|0,Q=i[V+4>>2],_=s+(g(k,l)<<3)|0,i[_>>2]=i[V>>2],i[_+4>>2]=Q,k=k+1|0,h=h+1|0,(G|0)!=(h|0););if(n=n+1|0,(I|0)==(n|0))break}}break k}if(k>>>0>128)break A;I=i[o+268>>2]>>>4|0,w=i[R+52>>2]>>>4|0,N=i[o+256>>2],Y=i[R+40>>2],h=i[R+28>>2],n=i[R+24>>2];n:{if((r|0)!=270){if((r|0)!=180){if(!n|(!h|(r|0)!=90))break n;for(E=Y+(n<<4)|0,_=n&-2,V=n&1,l=0;;){if(Y=N+(l<<4)|0,B=E+(g(l,w)<<4)|0,k=0,s=0,(n|0)!=1)for(;G=B+((k^-1)<<4)|0,Q=i[G+4>>2],m=Y+(g(k,I)<<4)|0,i[m>>2]=i[G>>2],i[m+4>>2]=Q,Q=i[G+12>>2],i[m+8>>2]=i[G+8>>2],i[m+12>>2]=Q,G=B+((k^268435454)<<4)|0,Q=i[G+12>>2],m=Y+(g(I,k|1)<<4)|0,i[m+8>>2]=i[G+8>>2],i[m+12>>2]=Q,Q=i[G+4>>2],i[m>>2]=i[G>>2],i[m+4>>2]=Q,k=k+2|0,s=s+2|0,(_|0)!=(s|0););if(V&&(s=Y+(g(k,I)<<4)|0,k=B+((k^-1)<<4)|0,Y=i[k+4>>2],i[s>>2]=i[k>>2],i[s+4>>2]=Y,Y=i[k+12>>2],i[s+8>>2]=i[k+8>>2],i[s+12>>2]=Y),l=l+1|0,(h|0)==(l|0))break}break n}if(!h|!n)break n;for(E=Y+(n<<4)|0,_=n&-2,V=n&1,l=0;;){if(Y=N+(g(l,I)<<4)|0,B=E+(g(w,h+(l^-1)|0)<<4)|0,k=0,(n|0)!=1)for(Q=Y+16|0,s=0;G=B+((k^-1)<<4)|0,x=i[G+4>>2],j=k<<4,m=j+Y|0,i[m>>2]=i[G>>2],i[m+4>>2]=x,x=i[G+12>>2],i[m+8>>2]=i[G+8>>2],i[m+12>>2]=x,m=Q+j|0,G=B+((k^268435454)<<4)|0,j=i[G+12>>2],i[m+8>>2]=i[G+8>>2],i[m+12>>2]=j,j=i[G+4>>2],i[m>>2]=i[G>>2],i[m+4>>2]=j,k=k+2|0,s=s+2|0,(_|0)!=(s|0););if(V&&(s=Y+(k<<4)|0,k=B+((k^-1)<<4)|0,Y=i[k+4>>2],i[s>>2]=i[k>>2],i[s+4>>2]=Y,Y=i[k+12>>2],i[s+8>>2]=i[k+8>>2],i[s+12>>2]=Y),l=l+1|0,(h|0)==(l|0))break}break n}if(!h|!n)break n;for(_=n&-2,V=n&1,l=0;;){if(B=N+(l<<4)|0,G=Y+(g(w,h+(l^-1)|0)<<4)|0,k=0,s=0,(n|0)!=1)for(;m=G+(k<<4)|0,Q=i[m+4>>2],E=B+(g(k,I)<<4)|0,i[E>>2]=i[m>>2],i[E+4>>2]=Q,Q=i[m+12>>2],i[E+8>>2]=i[m+8>>2],i[E+12>>2]=Q,m=k|1,E=B+(g(m,I)<<4)|0,m=G+(m<<4)|0,Q=i[m+12>>2],i[E+8>>2]=i[m+8>>2],i[E+12>>2]=Q,Q=i[m+4>>2],i[E>>2]=i[m>>2],i[E+4>>2]=Q,k=k+2|0,s=s+2|0,(_|0)!=(s|0););if(V&&(s=B+(g(k,I)<<4)|0,k=G+(k<<4)|0,B=i[k+4>>2],i[s>>2]=i[k>>2],i[s+4>>2]=B,B=i[k+12>>2],i[s+8>>2]=i[k+8>>2],i[s+12>>2]=B),l=l+1|0,(h|0)==(l|0))break}}}if(k=i[U+220>>2],k>>>0>=o0[U+224>>2])break f;n=i[o+216>>2],i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=n,i[k+4>>2]=i[o+220>>2],i[k+8>>2]=i[o+224>>2],i[k+12>>2]=i[o+228>>2],i[o+228>>2]=0,i[o+220>>2]=0,i[o+224>>2]=0,n=i[o+268>>2],i[k+48>>2]=i[o+264>>2],i[k+52>>2]=n,n=i[o+260>>2],i[k+40>>2]=i[o+256>>2],i[k+44>>2]=n,n=i[o+252>>2],i[k+32>>2]=i[o+248>>2],i[k+36>>2]=n,n=i[o+244>>2],i[k+24>>2]=i[o+240>>2],i[k+28>>2]=n,n=i[o+236>>2],i[k+16>>2]=i[o+232>>2],i[k+20>>2]=n,n=k+56|0;break r}f=ri(o+48|0),F(B0(F(f+8|0,31852,26),p[R+20>>1]),10792,15),e=o+12|0,ki(e,f),e=a(o+24|0,4,0,e),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(t[o+23|0]<0&&Z(i[o+12>>2]),F8(f),A=i[o+200>>2],!A)break e;i[o+204>>2]=A,Z(A);break e}n=l3(c,o+216|0)}if(i[U+220>>2]=n,k=i[o+200>>2],k&&(i[o+204>>2]=k,Z(k)),k=i[o+220>>2],k&&(i[o+224>>2]=k,Z(k)),R=R+56|0,(d|0)==(R|0))break}if(l=i[e+224>>2],r=i[e+228>>2],(l|0)!=(r|0))for(f=U+236|0,n=i[U+240>>2];;){r:{if(o0[U+244>>2]>n>>>0){if(e=i[l+4>>2],i[n>>2]=i[l>>2],i[n+4>>2]=e,e=n+8|0,t[l+19|0]>=0){k=i[l+12>>2],i[e>>2]=i[l+8>>2],i[e+4>>2]=k,i[e+8>>2]=i[l+16>>2],n=n+20|0;break r}T(e,i[l+8>>2],i[l+12>>2]),n=n+20|0;break r}n=yi(f,l)}if(i[U+240>>2]=n,l=l+20|0,(r|0)==(l|0))break}t[A+20|0]=0,i[A+4>>2]=U,i[A>>2]=q;break i}if(A=i[o+220>>2],A&&(i[o+224>>2]=A,Z(A)),A=i[U+4>>2],i[U+4>>2]=A-1,A)break i;W[i[i[U>>2]+8>>2]](U),y(U)}v=o+272|0}function F9(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0;G=v-48|0,v=G;i:{e:{if(r>>>0>2)break e;for(r=r<<2,S=i[r+80012>>2],O=i[r+8e4>>2];;){r=i[e+4>>2];r:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=u[r|0];break r}r=q2(e)}if(!((r|0)==32|r-9>>>0<5))break}Q=1;r:{f:switch(r-43|0){case 0:case 2:break f;default:break r}if(Q=(r|0)==45?-1:1,r=i[e+4>>2],(r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=u[r|0];break r}r=q2(e)}r:{f:{if((r&-33)==73)for(;;){if((o|0)==7)break f;r=i[e+4>>2];A:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=u[r|0];break A}r=q2(e)}if(k=o+1491|0,o=o+1|0,t[k|0]!=(r|32))break}if((o|0)!=3){if(k=(o|0)==8,k)break f;if(!f|o>>>0<4)break r;if(k)break f}if(r=i[e+116>>2],(r|0)>=0|(r|0)>0&&(i[e+4>>2]=i[e+4>>2]-1),!f|o>>>0<4)break f;for(r=(r|0)<0;r||(i[e+4>>2]=i[e+4>>2]-1),o=o-1|0,o>>>0>3;);}s=v-16|0,v=s,f=(P1(D(D(Q|0)*D(1/0))),o2(2)),e=f&8388607,I=f>>>23|0,r=I&255;f:{if(r){if((r|0)!=255){r=e,e=e>>>7|0,l=r<<25,n=e,r=(I&255)+16256|0;break f}r=e,e=e>>>7|0,l=r<<25,n=e,r=32767;break f}if(r=0,!e)break f;r=e,e=_1(e),g4(s,r,0,0,0,e+81|0),l=i[s+8>>2],n=i[s+12>>2]^65536,h=i[s>>2],w=i[s+4>>2],r=16265-e|0}i[G>>2]=h,i[G+4>>2]=w,e=G,i[e+8>>2]=l,i[e+12>>2]=n|(f&-2147483648|r<<16),v=s+16|0,l=i[e+8>>2],n=i[e+12>>2],h=i[e>>2],w=i[e+4>>2];break i}r:{f:{A:{k:{n:{t:{if(o||(o=0,(r&-33)!=78))break t;for(;;){if((o|0)==2)break n;r=i[e+4>>2];o:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=u[r|0];break o}r=q2(e)}if(k=o+10085|0,o=o+1|0,t[k|0]!=(r|32))break}}switch(o|0){case 3:break n;case 0:break f;default:break k}}n:{r=i[e+4>>2];t:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=u[r|0];break t}r=q2(e)}if((r|0)==40){o=1;break n}if(n=2147450880,i[e+116>>2]<0)break i;i[e+4>>2]=i[e+4>>2]-1;break i}for(;;){n:{r=i[e+4>>2];t:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=u[r|0];break t}r=q2(e)}if(!(r-48>>>0<10|r-65>>>0<26|(r|0)==95)&&r-97>>>0>=26)break n;o=o+1|0;continue}break}if(n=2147450880,(r|0)==41)break i;r=i[e+116>>2],(r|0)>=0|(r|0)>0&&(i[e+4>>2]=i[e+4>>2]-1);n:{if(f){if(o)break n;break r}i[33136]=28;break A}for(;(r|0)>0|(r|0)>=0&&(i[e+4>>2]=i[e+4>>2]-1),o=o-1|0,!!o;);break r}r=i[e+116>>2],(r|0)>0?r=1:r=(r|0)>=0,r&&(i[e+4>>2]=i[e+4>>2]-1),i[33136]=28}I8(e,0,0);break e}f:{if((r|0)!=48)break f;o=i[e+4>>2];A:{if((o|0)!=i[e+104>>2]){i[e+4>>2]=o+1,o=u[o|0];break A}o=q2(e)}if((o&-33)==88){k=v-432|0,v=k,r=i[e+4>>2];A:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=u[r|0];break A}r=q2(e)}A:{k:{for(;;){if((r|0)!=48)n:{if((r|0)!=46)break A;if(r=i[e+4>>2],(r|0)==i[e+104>>2])break n;i[e+4>>2]=r+1,r=u[r|0];break k}else{r=i[e+4>>2],(r|0)!=i[e+104>>2]?(V=1,i[e+4>>2]=r+1,r=u[r|0]):(V=1,r=q2(e));continue}break}r=q2(e)}if((r|0)!=48){U=1;break A}for(;;){r=I,I=r-1|0,Y=Y-!r|0,r=i[e+4>>2];k:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=u[r|0];break k}r=q2(e)}if((r|0)!=48)break}U=1,V=1}for(w=1073676288;;){A:{o=r;k:{n:{if(q=r-48|0,q>>>0<10)break n;if(c=(r|0)!=46,o=r|32,c&o-97>>>0>5)break A;if(c)break n;if(U)break A;U=1,I=l,Y=n;break k}r=(r|0)>57?o-87|0:q;n:{if((n|0)<=0&l>>>0<=7|(n|0)<0){_=r+(_<<4)|0;break n}if(!n&l>>>0<=28){b4(k+48|0,r),Z1(k+32|0,x,j,h,w,0,0,0,1073414144),x=i[k+32>>2],j=i[k+36>>2],h=i[k+40>>2],w=i[k+44>>2],Z1(k+16|0,i[k+48>>2],i[k+52>>2],i[k+56>>2],i[k+60>>2],x,j,h,w),j4(k,i[k+16>>2],i[k+20>>2],i[k+24>>2],i[k+28>>2],s,B,R,N),R=i[k+8>>2],N=i[k+12>>2],s=i[k>>2],B=i[k+4>>2];break n}if(m|!r)break n;Z1(k+80|0,x,j,h,w,0,0,0,1073610752),j4(k- -64|0,i[k+80>>2],i[k+84>>2],i[k+88>>2],i[k+92>>2],s,B,R,N),m=1,R=i[k+72>>2],N=i[k+76>>2],s=i[k+64>>2],B=i[k+68>>2]}l=l+1|0,n=l?n:n+1|0,V=1}r=i[e+4>>2],(r|0)!=i[e+104>>2]?(i[e+4>>2]=r+1,r=u[r|0]):r=q2(e);continue}break}A:{if(!V){r=i[e+116>>2],(r|0)>0?r=1:r=(r|0)>=0;k:{n:{if(r){if(r=i[e+4>>2],i[e+4>>2]=r-1,!f)break n;if(i[e+4>>2]=r-2,!U)break k;i[e+4>>2]=r-3;break k}if(f)break k}I8(e,0,0)}j2(0),e=o2(1)|0,f=o2(0)|0,j2(+(Q|0)),r=o2(1)|0,o2(0)|0,T2(0,f|0),T2(1,e&2147483647|r&-2147483648),x8(k+96|0,+s1()),s=i[k+96>>2],B=i[k+100>>2],r=i[k+108>>2],e=i[k+104>>2];break A}if((n|0)<=0&l>>>0<=7|(n|0)<0)for(h=l,w=n;_=_<<4,h=h+1|0,w=h?w:w+1|0,!!((h|0)!=8|w););k:{n:{t:{if((r&-33)==80){if(h=Gt(e,f),r=h0,w=r,h|(r|0)!=-2147483648)break k;if(f){if(r=i[e+116>>2],(r|0)>0?r=1:r=(r|0)>=0,r)break t;break n}s=0,B=0,I8(e,0,0),r=0,e=0;break A}if(h=0,w=0,i[e+116>>2]<0)break k}i[e+4>>2]=i[e+4>>2]-1}h=0,w=0}if(!_){j2(0),e=o2(1)|0,f=o2(0)|0,j2(+(Q|0)),r=o2(1)|0,o2(0)|0,T2(0,f|0),T2(1,e&2147483647|r&-2147483648),x8(k+112|0,+s1()),s=i[k+112>>2],B=i[k+116>>2],r=i[k+124>>2],e=i[k+120>>2];break A}if(e=U?I:l,f=h+(e<<2)|0,e=w+((U?Y:n)<<2|e>>>30)|0,l=f-32|0,r=0-S|0,n=(f>>>0<h>>>0?e+1|0:e)-(f>>>0<32)|0,e=n,(e|0)>0?e=1:e=r>>>0<l>>>0&(e|0)>=0,e){i[33136]=68,b4(k+160|0,Q),Z1(k+144|0,i[k+160>>2],i[k+164>>2],i[k+168>>2],i[k+172>>2],-1,-1,-1,2147418111),Z1(k+128|0,i[k+144>>2],i[k+148>>2],i[k+152>>2],i[k+156>>2],-1,-1,-1,2147418111),s=i[k+128>>2],B=i[k+132>>2],r=i[k+140>>2],e=i[k+136>>2];break A}if(e=S-226|0,r=e>>31,(n|0)>=(r|0)&e>>>0<=l>>>0|(r|0)<(n|0)){if((_|0)>=0)for(;j4(k+416|0,s,B,R,N,0,0,0,-1073807360),e=Wl(s,B,R,N,1073610752),e=(e|0)>=0,j4(k+400|0,s,B,R,N,e?i[k+416>>2]:s,e?i[k+420>>2]:B,e?i[k+424>>2]:R,e?i[k+428>>2]:N),r=_<<1,_=r|e,e=l,l=e-1|0,n=n-!e|0,R=i[k+408>>2],N=i[k+412>>2],s=i[k+400>>2],B=i[k+404>>2],(r|0)>=0;);e=32-S|0,r=e,e=e+l|0,w=r>>>0>e>>>0?n+1|0:n,r=e>>>0<O>>>0&(w|0)<=0|(w|0)<0?(e|0)>0?e:0:O;k:{if(r>>>0>=113){b4(k+384|0,Q),h=i[k+392>>2],w=i[k+396>>2],x=i[k+384>>2],j=i[k+388>>2],n=0,e=0;break k}x8(k+352|0,_4(1,144-r|0)),b4(k+336|0,Q),x=i[k+336>>2],j=i[k+340>>2],h=i[k+344>>2],w=i[k+348>>2],xs(k+368|0,i[k+352>>2],i[k+356>>2],i[k+360>>2],i[k+364>>2],w),E=i[k+376>>2],d=i[k+380>>2],n=i[k+372>>2],e=i[k+368>>2]}f=!(_&1)&((d6(s,B,R,N,0,0,0,0)|0)!=0&r>>>0<32),ji(k+320|0,f|_),Z1(k+304|0,x,j,h,w,i[k+320>>2],i[k+324>>2],i[k+328>>2],i[k+332>>2]),r=e,j4(k+272|0,i[k+304>>2],i[k+308>>2],i[k+312>>2],i[k+316>>2],e,n,E,d),e=f,Z1(k+288|0,x,j,h,w,e?0:s,e?0:B,e?0:R,e?0:N),j4(k+256|0,i[k+288>>2],i[k+292>>2],i[k+296>>2],i[k+300>>2],i[k+272>>2],i[k+276>>2],i[k+280>>2],i[k+284>>2]),O5(k+240|0,i[k+256>>2],i[k+260>>2],i[k+264>>2],i[k+268>>2],r,n,E,d),e=i[k+240>>2],f=i[k+244>>2],r=i[k+248>>2],h=i[k+252>>2],d6(e,f,r,h,0,0,0,0)||(i[33136]=68),bA(k+224|0,e,f,r,h,l),s=i[k+224>>2],B=i[k+228>>2],r=i[k+236>>2],e=i[k+232>>2];break A}i[33136]=68,b4(k+208|0,Q),Z1(k+192|0,i[k+208>>2],i[k+212>>2],i[k+216>>2],i[k+220>>2],0,0,0,65536),Z1(k+176|0,i[k+192>>2],i[k+196>>2],i[k+200>>2],i[k+204>>2],0,0,0,65536),s=i[k+176>>2],B=i[k+180>>2],r=i[k+188>>2],e=i[k+184>>2]}i[G+16>>2]=s,i[G+20>>2]=B,i[G+24>>2]=e,i[G+28>>2]=r,v=k+432|0,l=i[G+24>>2],n=i[G+28>>2],h=i[G+16>>2],w=i[G+20>>2];break i}if(i[e+116>>2]<0)break f;i[e+4>>2]=i[e+4>>2]-1}o=e,s=r,E=f,f=0,k=v-8976|0,v=k,q=0-S|0,d=q-O|0;f:{A:{for(;;){if((s|0)!=48)k:{if((s|0)!=46)break f;if(e=i[o+4>>2],(e|0)==i[o+104>>2])break k;i[o+4>>2]=e+1,s=u[e|0];break A}else{e=i[o+4>>2],(e|0)!=i[o+104>>2]?(i[o+4>>2]=e+1,s=u[e|0]):s=q2(o),f=1;continue}break}s=q2(o)}if((s|0)==48){for(;;){e=l,l=e-1|0,n=n-!e|0,e=i[o+4>>2];A:{if((e|0)!=i[o+104>>2]){i[o+4>>2]=e+1,s=u[e|0];break A}s=q2(o)}if((s|0)!=48)break}f=1}U=1}i[k+784>>2]=0;f:{A:{e=(s|0)==46,r=s-48|0;k:{n:{t:{if(e|r>>>0<=9)for(;;){o:{if(e&1){if(!U){l=h,n=w,U=1;break o}e=!f;break t}if(e=w,h=h+1|0,w=h?e:e+1|0,(_|0)<=2044){V=(s|0)==48?V:h,e=(k+784|0)+(_<<2)|0,m&&(r=(g(i[e>>2],10)+s|0)-48|0),i[e>>2]=r,f=1,r=m+1|0,e=(r|0)==9,m=e?0:r,_=e+_|0;break o}if((s|0)==48)break o;i[k+8960>>2]=i[k+8960>>2]|1,V=18396}e=i[o+4>>2];o:{if((e|0)!=i[o+104>>2]){i[o+4>>2]=e+1,s=u[e|0];break o}s=q2(o)}if(e=(s|0)==46,r=s-48|0,!(e|r>>>0<10))break}if(l=U?l:h,n=U?n:w,!(!f|(s&-33)!=69)){s=Gt(o,E),e=h0,B=e;o:{if(s|(e|0)!=-2147483648)break o;if(!E)break k;if(s=0,B=0,i[o+116>>2]<0)break o;i[o+4>>2]=i[o+4>>2]-1}n=n+B|0,l=l+s|0,n=l>>>0<s>>>0?n+1|0:n;break A}if(e=!f,(s|0)<0)break n}if(i[o+116>>2]<0)break n;i[o+4>>2]=i[o+4>>2]-1}if(!e)break A;i[33136]=28}I8(o,0,0),l=0,n=0,r=0,e=0;break f}if(e=i[k+784>>2],!e){j2(0),e=o2(1)|0,f=o2(0)|0,j2(+(Q|0)),r=o2(1)|0,o2(0)|0,T2(0,f|0),T2(1,e&2147483647|r&-2147483648),x8(k,+s1()),l=i[k+8>>2],n=i[k+12>>2],r=i[k+4>>2],e=i[k>>2];break f}if(!(h>>>0>9&(w|0)>=0|(w|0)>0|((l|0)!=(h|0)|(n|0)!=(w|0))|(e>>>O|0?O>>>0<=30:0))){b4(k+48|0,Q),ji(k+32|0,e),Z1(k+16|0,i[k+48>>2],i[k+52>>2],i[k+56>>2],i[k+60>>2],i[k+32>>2],i[k+36>>2],i[k+40>>2],i[k+44>>2]),l=i[k+24>>2],n=i[k+28>>2],r=i[k+20>>2],e=i[k+16>>2];break f}if(e=q>>>1|0,e>>>0<l>>>0&(n|0)>=0|(n|0)>0){i[33136]=68,b4(k+96|0,Q),Z1(k+80|0,i[k+96>>2],i[k+100>>2],i[k+104>>2],i[k+108>>2],-1,-1,-1,2147418111),Z1(k- -64|0,i[k+80>>2],i[k+84>>2],i[k+88>>2],i[k+92>>2],-1,-1,-1,2147418111),l=i[k+72>>2],n=i[k+76>>2],r=i[k+68>>2],e=i[k+64>>2];break f}if(e=S-226|0,r=l>>>0<e>>>0,e=e>>31,r&(n|0)<=(e|0)|(e|0)>(n|0)){i[33136]=68,b4(k+144|0,Q),Z1(k+128|0,i[k+144>>2],i[k+148>>2],i[k+152>>2],i[k+156>>2],0,0,0,65536),Z1(k+112|0,i[k+128>>2],i[k+132>>2],i[k+136>>2],i[k+140>>2],0,0,0,65536),l=i[k+120>>2],n=i[k+124>>2],r=i[k+116>>2],e=i[k+112>>2];break f}if(m){if((m|0)<=8){for(e=(k+784|0)+(_<<2)|0,o=i[e>>2];o=g(o,10),m=m+1|0,(m|0)!=9;);i[e>>2]=o}_=_+1|0}m=l;A:{if(l>>>0>17&(n|0)>=0|(n|0)>0|(V|0)>=9|(l|0)<(V|0))break A;if(!n&(l|0)==9){b4(k+192|0,Q),ji(k+176|0,i[k+784>>2]),Z1(k+160|0,i[k+192>>2],i[k+196>>2],i[k+200>>2],i[k+204>>2],i[k+176>>2],i[k+180>>2],i[k+184>>2],i[k+188>>2]),l=i[k+168>>2],n=i[k+172>>2],r=i[k+164>>2],e=i[k+160>>2];break f}if((n|0)<=0&l>>>0<=8|(n|0)<0){b4(k+272|0,Q),ji(k+256|0,i[k+784>>2]),Z1(k+240|0,i[k+272>>2],i[k+276>>2],i[k+280>>2],i[k+284>>2],i[k+256>>2],i[k+260>>2],i[k+264>>2],i[k+268>>2]),b4(k+224|0,i[(0-m<<2)+8e4>>2]),M9(k+208|0,i[k+240>>2],i[k+244>>2],i[k+248>>2],i[k+252>>2],i[k+224>>2],i[k+228>>2],i[k+232>>2],i[k+236>>2]),l=i[k+216>>2],n=i[k+220>>2],r=i[k+212>>2],e=i[k+208>>2];break f}if(e=(g(m,-3)+O|0)+27|0,r=i[k+784>>2],r>>>e|0&&(e|0)<=30)break A;b4(k+352|0,Q),ji(k+336|0,r),Z1(k+320|0,i[k+352>>2],i[k+356>>2],i[k+360>>2],i[k+364>>2],i[k+336>>2],i[k+340>>2],i[k+344>>2],i[k+348>>2]),b4(k+304|0,i[(m<<2)+79928>>2]),Z1(k+288|0,i[k+320>>2],i[k+324>>2],i[k+328>>2],i[k+332>>2],i[k+304>>2],i[k+308>>2],i[k+312>>2],i[k+316>>2]),l=i[k+296>>2],n=i[k+300>>2],r=i[k+292>>2],e=i[k+288>>2];break f}for(;e=_,_=e-1|0,!i[(k+784|0)+(_<<2)>>2];);V=0,r=(m|0)%9|0;A:{if(!r){r=0;break A}f=(n|0)<0?r+9|0:r;k:{if(!e){r=0,e=0;break k}for(l=i[(0-f<<2)+8e4>>2],n=1e9/(l|0)|0,s=0,o=0,r=0;h=s,w=k+784|0,s=w+(o<<2)|0,_=i[s>>2],E=(_>>>0)/(l>>>0)|0,h=h+E|0,i[s>>2]=h,h=!h&(r|0)==(o|0),r=h?r+1&2047:r,m=h?m-9|0:m,s=g(n,_-g(l,E)|0),o=o+1|0,(o|0)!=(e|0););if(!s)break k;i[w+(e<<2)>>2]=s,e=e+1|0}m=(m-f|0)+9|0}for(;;){w=(k+784|0)+(r<<2)|0,o=(m|0)<36;A:{for(;;){if(!o&((m|0)!=36|o0[w>>2]>=10384593))break A;for(_=e+2047|0,f=0;h=e,l=f,s=_&2047,_=(k+784|0)+(s<<2)|0,f=i[_>>2],e=f>>>3|0,f=f<<29,l=l+f|0,n=f>>>0>l>>>0?e+1|0:e,!n&l>>>0<1000000001?f=0:(e=l,f=O1(e,n,1e9,0),E=L0(f,h0,1e9,0),l=e-E|0,n=n-(h0+(e>>>0<E>>>0)|0)|0),i[_>>2]=l,e=(r|0)==(s|0)||n|l?h:s,l=h-1&2047,e=(l|0)!=(s|0)?h:e,_=s-1|0,(r|0)!=(s|0););if(V=V-29|0,e=h,!!f)break}r=r-1&2047,(r|0)==(e|0)&&(n=(e+2046&2047)<<2,e=k+784|0,h=n+e|0,i[h>>2]=i[h>>2]|i[e+(l<<2)>>2],e=l),m=m+9|0,i[(k+784|0)+(r<<2)>>2]=f;continue}break}A:{k:for(;;){for(l=e+1&2047,n=(k+784|0)+((e-1&2047)<<2)|0;;){h=(m|0)>45?9:1;n:{for(;;){f=r,o=0;t:{for(;;){o:{if(r=f+o&2047,(r|0)==(e|0)||(r=i[(k+784|0)+(r<<2)>>2],s=i[(o<<2)+79952>>2],r>>>0<s>>>0))break o;if(r>>>0>s>>>0)break t;if(o=o+1|0,(o|0)!=4)continue}break}if((m|0)!=36)break t;for(l=0,n=0,o=0,h=0,w=0;r=f+o&2047,(r|0)==(e|0)&&(e=e+1&2047,i[((e<<2)+k|0)+780>>2]=0),ji(k+768|0,i[(k+784|0)+(r<<2)>>2]),Z1(k+752|0,l,n,h,w,0,0,1342177280,1075633366),j4(k+736|0,i[k+752>>2],i[k+756>>2],i[k+760>>2],i[k+764>>2],i[k+768>>2],i[k+772>>2],i[k+776>>2],i[k+780>>2]),h=i[k+744>>2],w=i[k+748>>2],l=i[k+736>>2],n=i[k+740>>2],o=o+1|0,(o|0)!=4;);if(b4(k+720|0,Q),Z1(k+704|0,l,n,h,w,i[k+720>>2],i[k+724>>2],i[k+728>>2],i[k+732>>2]),l=0,n=0,h=i[k+712>>2],w=i[k+716>>2],s=i[k+704>>2],B=i[k+708>>2],E=V+113|0,o=E-S|0,m=(o|0)<(O|0),r=m?(o|0)>0?o:0:O,r>>>0<=112)break n;break A}if(V=h+V|0,r=e,(e|0)!=(f|0))break}for(w=1e9>>>h|0,_=-1<<h^-1,o=0,r=f;s=o,E=k+784|0,o=E+(f<<2)|0,B=i[o>>2],s=s+(B>>>h|0)|0,i[o>>2]=s,s=!s&(r|0)==(f|0),r=s?r+1&2047:r,m=s?m-9|0:m,o=g(w,_&B),f=f+1&2047,(f|0)!=(e|0););if(!o)continue;if((r|0)!=(l|0)){i[E+(e<<2)>>2]=o,e=l;continue k}i[n>>2]=i[n>>2]|1;continue}break}break}x8(k+656|0,_4(1,225-r|0)),xs(k+688|0,i[k+656>>2],i[k+660>>2],i[k+664>>2],i[k+668>>2],w),x=i[k+696>>2],j=i[k+700>>2],R=i[k+688>>2],N=i[k+692>>2],x8(k+640|0,_4(1,113-r|0)),zn(k+672|0,s,B,h,w,i[k+640>>2],i[k+644>>2],i[k+648>>2],i[k+652>>2]),l=i[k+672>>2],n=i[k+676>>2],I=i[k+680>>2],Y=i[k+684>>2],O5(k+624|0,s,B,h,w,l,n,I,Y),j4(k+608|0,R,N,x,j,i[k+624>>2],i[k+628>>2],i[k+632>>2],i[k+636>>2]),h=i[k+616>>2],w=i[k+620>>2],s=i[k+608>>2],B=i[k+612>>2]}_=f+4&2047;A:{if((_|0)==(e|0))break A;_=i[(k+784|0)+(_<<2)>>2];k:{if(_>>>0<=499999999){if(!_&(f+5&2047)==(e|0))break k;x8(k+496|0,+(Q|0)*.25),j4(k+480|0,l,n,I,Y,i[k+496>>2],i[k+500>>2],i[k+504>>2],i[k+508>>2]),I=i[k+488>>2],Y=i[k+492>>2],l=i[k+480>>2],n=i[k+484>>2];break k}if((_|0)!=5e8){x8(k+592|0,+(Q|0)*.75),j4(k+576|0,l,n,I,Y,i[k+592>>2],i[k+596>>2],i[k+600>>2],i[k+604>>2]),I=i[k+584>>2],Y=i[k+588>>2],l=i[k+576>>2],n=i[k+580>>2];break k}if(A0=+(Q|0),(f+5&2047)==(e|0)){x8(k+528|0,A0*.5),j4(k+512|0,l,n,I,Y,i[k+528>>2],i[k+532>>2],i[k+536>>2],i[k+540>>2]),I=i[k+520>>2],Y=i[k+524>>2],l=i[k+512>>2],n=i[k+516>>2];break k}x8(k+560|0,A0*.75),j4(k+544|0,l,n,I,Y,i[k+560>>2],i[k+564>>2],i[k+568>>2],i[k+572>>2]),I=i[k+552>>2],Y=i[k+556>>2],l=i[k+544>>2],n=i[k+548>>2]}if(r>>>0>111||(zn(k+464|0,l,n,I,Y,0,0,0,1073676288),d6(i[k+464>>2],i[k+468>>2],i[k+472>>2],i[k+476>>2],0,0,0,0)))break A;j4(k+448|0,l,n,I,Y,0,0,0,1073676288),I=i[k+456>>2],Y=i[k+460>>2],l=i[k+448>>2],n=i[k+452>>2]}j4(k+432|0,s,B,h,w,l,n,I,Y),O5(k+416|0,i[k+432>>2],i[k+436>>2],i[k+440>>2],i[k+444>>2],R,N,x,j),h=i[k+424>>2],w=i[k+428>>2],s=i[k+416>>2],B=i[k+420>>2];A:{if((d-2|0)>=(E&2147483647)||(i[k+408>>2]=h,i[k+412>>2]=w&2147483647,i[k+400>>2]=s,i[k+404>>2]=B,Z1(k+384|0,s,B,h,w,0,0,0,1073610752),f=Wl(i[k+400>>2],i[k+404>>2],i[k+408>>2],i[k+412>>2],1081081856),e=(f|0)>=0,h=e?i[k+392>>2]:h,w=e?i[k+396>>2]:w,s=e?i[k+384>>2]:s,B=e?i[k+388>>2]:B,l=d6(l,n,I,Y,0,0,0,0),V=e+V|0,(V+110|0)<=(d|0)&&!(m&((r|0)!=(o|0)|(f|0)<0)&(l|0)!=0)))break A;i[33136]=68}bA(k+368|0,s,B,h,w,V),l=i[k+376>>2],n=i[k+380>>2],r=i[k+372>>2],e=i[k+368>>2]}i[G+40>>2]=l,i[G+44>>2]=n,i[G+32>>2]=e,i[G+36>>2]=r,v=k+8976|0,l=i[G+40>>2],n=i[G+44>>2],h=i[G+32>>2],w=i[G+36>>2];break i}break i}n=0}i[A>>2]=h,i[A+4>>2]=w,i[A+8>>2]=l,i[A+12>>2]=n,v=G+48|0}function lv(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0;l=v-384|0,v=l,i[l+376>>2]=n,i[l+380>>2]=k,_=o+4|0;i:{e:{if(n=i[o+4>>2],!n)break e;for(w=i[e+196>>2],k=_;s=w>>>0>o0[n+16>>2],k=s?k:n,n=i[(s?4:0)+n>>2],!!n;);if((k|0)==(_|0)|w>>>0<o0[k+16>>2])break e;e=C(32),i[l+352>>2]=e,i[l+356>>2]=28,i[l+360>>2]=-2147483616,r=u[6467]|u[6468]<<8|(u[6469]<<16|u[6470]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,r=u[6463]|u[6464]<<8|(u[6465]<<16|u[6466]<<24),f=u[6459]|u[6460]<<8|(u[6461]<<16|u[6462]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[6455]|u[6456]<<8|(u[6457]<<16|u[6458]<<24),f=u[6451]|u[6452]<<8|(u[6453]<<16|u[6454]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[6447]|u[6448]<<8|(u[6449]<<16|u[6450]<<24),f=u[6443]|u[6444]<<8|(u[6445]<<16|u[6446]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+28|0]=0,e=a(l+112|0,2,0,l+352|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(t[l+363|0]>=0)break i;Z(i[l+352>>2]);break i}e:{r:{if(!f){if(n=i[e+184>>2],k=i[e+188>>2],(n|0)==(k|0))break r;for(;;){f:{if(w=i[n>>2],!w||(w=Z0(w,92792,92812),!w))break f;if(k=i[n+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),Ii(l+112|0,i[e+180>>2]- -64|0,i[w+104>>2],i[w+108>>2]),i[l+112>>2]){e=i[l+116>>2],i[A>>2]=i[l+112>>2],i[A+4>>2]=e,e=A+8|0;A:{if(t[l+131|0]>=0){r=i[l+124>>2],i[e>>2]=i[l+120>>2],i[e+4>>2]=r,i[e+8>>2]=i[l+128>>2],t[A+20|0]=1;break A}if(T(e,i[l+120>>2],i[l+124>>2]),e=t[l+131|0],t[A+20|0]=1,(e|0)>=0)break A;Z(i[l+120>>2])}if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break e;W[i[i[k>>2]+8>>2]](k),y(k);break e}if(t[l+131|0]<0&&Z(i[l+120>>2]),!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break r;W[i[i[k>>2]+8>>2]](k),y(k);break r}if(n=n+8|0,(k|0)==(n|0))break}break r}if(u[r+1|0])break r;if(Bn(l+112|0,e,l+380|0,l+376|0),i[l+112>>2]){if(e=i[l+116>>2],i[A>>2]=i[l+112>>2],i[A+4>>2]=e,e=A+8|0,t[l+131|0]>=0){r=i[l+124>>2],i[e>>2]=i[l+120>>2],i[e+4>>2]=r,i[e+8>>2]=i[l+128>>2],t[A+20|0]=1;break e}if(T(e,i[l+120>>2],i[l+124>>2]),e=t[l+131|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[l+120>>2]);break e}if(t[l+131|0]>=0)break r;Z(i[l+120>>2])}i[l+344>>2]=0,i[l+348>>2]=0,i[l+340>>2]=l+344,n=i[l+380>>2],w=i[l+376>>2],k=l+340|0,W8(k,i[o>>2],_),W[i[i[e>>2]+144>>2]](l+352|0,e,r,f,n,w,k),S1(k,i[l+344>>2]);r:{f:{A:{k:{n:{t:{o:{l:{u:{s:{h:switch(u[l+372|0]){case 1:e=i[l+356>>2],i[A>>2]=i[l+352>>2],i[A+4>>2]=e,e=A+8|0;w:{if(t[l+371|0]>=0){r=i[l+364>>2],i[e>>2]=i[l+360>>2],i[e+4>>2]=r,i[e+8>>2]=i[l+368>>2];break w}T(e,i[l+360>>2],i[l+364>>2])}t[A+20|0]=1;break r;case 0:break h;default:break s}if(s=i[l+352>>2],i[l+332>>2]=s,k=i[l+356>>2],i[l+336>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),!s){t[l+296|0]=0,t[l+307|0]=0,e=a(l+112|0,7,0,l+296|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;h:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break h}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break h;Z(i[e+8>>2])}if(t[l+307|0]>=0)break f;Z(i[l+296>>2]);break f}if(W[i[i[e>>2]+148>>2]](l+112|0,e,s,f,n,w),i[l+112>>2]){if(e=i[l+116>>2],i[A>>2]=i[l+112>>2],i[A+4>>2]=e,e=A+8|0,t[l+131|0]>=0){r=i[l+124>>2],i[e>>2]=i[l+120>>2],i[e+4>>2]=r,i[e+8>>2]=i[l+128>>2],t[A+20|0]=1;break f}if(T(e,i[l+120>>2],i[l+124>>2]),e=t[l+131|0],t[A+20|0]=1,(e|0)>=0)break f;Z(i[l+120>>2]);break f}t[l+131|0]<0&&Z(i[l+120>>2]),k=i[e+180>>2],V=i[k+48>>2],G=i[k+52>>2],G&&(i[G+4>>2]=i[G+4>>2]+1);h:{if(u[r+1|0])break h;t3(l+112|0,e);w:switch(u[l+132|0]){case 1:if(e=A,A=l+112|0,h6(e,A),e=u[l+132|0],(e|0)==255)break A;r=i[26907],i[l+296>>2]=i[26906],i[l+300>>2]=r,W[i[(l+296|0)+(e<<2)>>2]](l+272|0,A);break A;case 0:break w;default:break s}n=i[l+112>>2],E=i[l+116>>2];w:{if((n|0)==(E|0)){n=0;break w}for(w=A+8|0,k=i[26908],Y=i[26909];;){s=i[n>>2];_:{if(!s||(h=Z0(s,92792,94104),!h))break _;i[l+320>>2]=h,s=i[n+4>>2],i[l+324>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),p9(l+296|0,i[l+332>>2],i[h+100>>2],i[e+180>>2]- -64|0),B=u[l+316|0];v:{if(B){if((B|0)!=1)break s;if(s=i[l+300>>2],i[A>>2]=i[l+296>>2],i[A+4>>2]=s,t[l+315|0]>=0){s=i[l+308>>2],i[w>>2]=i[l+304>>2],i[w+4>>2]=s,i[w+8>>2]=i[l+312>>2],t[A+20|0]=1;break v}T(w,i[l+304>>2],i[l+308>>2]),t[A+20|0]=1;break v}if(h=i[l+300>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),i[l+332>>2]=i[l+296>>2],s=i[l+336>>2],i[l+336>>2]=h,!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break v;W[i[i[s>>2]+8>>2]](s),y(s)}if(s=u[l+316|0],(s|0)!=255&&(i[l+272>>2]=k,i[l+276>>2]=Y,W[i[(l+272|0)+(s<<2)>>2]](l+288|0,l+296|0)),B)break k;if(s=i[l+324>>2],!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break _;W[i[i[s>>2]+8>>2]](s),y(s)}s=i[n>>2];_:{if(!s||(h=Z0(s,92792,94184),!h))break _;i[l+320>>2]=h,s=i[n+4>>2],i[l+324>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),J9(l+296|0,i[l+332>>2],i[h+100>>2],i[e+180>>2]- -64|0),B=u[l+316|0];v:{if(B){if((B|0)!=1)break s;if(s=i[l+300>>2],i[A>>2]=i[l+296>>2],i[A+4>>2]=s,t[l+315|0]>=0){s=i[l+308>>2],i[w>>2]=i[l+304>>2],i[w+4>>2]=s,i[w+8>>2]=i[l+312>>2],t[A+20|0]=1;break v}T(w,i[l+304>>2],i[l+308>>2]),t[A+20|0]=1;break v}if(h=i[l+300>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),i[l+332>>2]=i[l+296>>2],s=i[l+336>>2],i[l+336>>2]=h,!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break v;W[i[i[s>>2]+8>>2]](s),y(s)}if(s=u[l+316|0],(s|0)!=255&&(i[l+272>>2]=k,i[l+276>>2]=Y,W[i[(l+272|0)+(s<<2)>>2]](l+288|0,l+296|0)),B)break k;if(s=i[l+324>>2],!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break _;W[i[i[s>>2]+8>>2]](s),y(s)}_:{if(f||(s=i[n>>2],!s)||(h=Z0(s,92792,94264),!h))break _;i[l+320>>2]=h,s=i[n+4>>2],i[l+324>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),i[l+288>>2]=0,i[l+292>>2]=0,m=i[l+332>>2],B=i[m+192>>2],m=i[m+188>>2],I=pe(h,m),Q=aA(h,m),R=Qe(h,B),h=KA(h,B);v:{if(I=(I|0)>0?I:0,m=m>>>0>Q>>>0?Q:m-1|0,(I|0)<=(m|0)&&(Q=(R|0)>0?R:0,h=h>>>0<B>>>0?h:B-1|0,(Q|0)<=(h|0)))break v;r=V2(l+272|0,47881),e=a(l+296|0,2,120,r),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f;B:{if(t[e+19|0]>=0){f=i[e+12>>2],i[w>>2]=i[e+8>>2],i[w+4>>2]=f,i[w+8>>2]=i[e+16>>2],t[A+20|0]=1;break B}if(T(w,i[e+8>>2],i[e+12>>2]),f=t[e+19|0],t[A+20|0]=1,(f|0)>=0)break B;Z(i[e+8>>2])}t[r+11|0]<0&&Z(i[r>>2]),g2(l+288|0);break k}B=l+296|0,oA(B,i[l+332>>2],I,m,Q,h,i[e+180>>2]- -64|0),h=u[l+316|0];v:{if(h){if((h|0)!=1)break s;h6(A,B);break v}qi(l+332|0,l+296|0)}if(B=u[l+316|0],(B|0)!=255&&(i[l+272>>2]=k,i[l+276>>2]=Y,W[i[(l+272|0)+(B<<2)>>2]](l- -64|0,l+296|0)),h)break k;if(!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break _;W[i[i[s>>2]+8>>2]](s),y(s)}if(n=n+8|0,(E|0)==(n|0))break}if(n=u[l+132|0],(n|0)==255)break h}k=i[26907],i[l+296>>2]=i[26906],i[l+300>>2]=k,W[i[(l+296|0)+(n<<2)>>2]](l+272|0,l+112|0)}if(k=i[e+228>>2],n=i[e+232>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),!k)break o;if(W[i[i[k>>2]+88>>2]](l+112|0,k),w=i[l+112>>2],t[l+131|0]<0&&Z(i[l+120>>2]),w){if(W[i[i[k>>2]+88>>2]](l+112|0,k),e=i[l+116>>2],i[A>>2]=i[l+112>>2],i[A+4>>2]=e,e=A+8|0,t[l+131|0]>=0){r=i[l+124>>2],i[e>>2]=i[l+120>>2],i[e+4>>2]=r,i[e+8>>2]=i[l+128>>2],t[A+20|0]=1;break n}if(T(e,i[l+120>>2],i[l+124>>2]),e=t[l+131|0],t[A+20|0]=1,(e|0)>=0)break n;Z(i[l+120>>2]);break n}switch(i[l+264>>2]=0,i[l+268>>2]=0,i[l+260>>2]=l+264,s=i[l+380>>2],h=i[l+376>>2],w=l+260|0,W8(w,i[o>>2],_),W[i[i[k>>2]+140>>2]](l+112|0,k,r,f,s,h,w),S1(w,i[l+264>>2]),u[l+132|0]){case 0:break l;case 1:break u;default:break s}}e2(),M()}if(e=A,A=l+112|0,h6(e,A),e=u[l+132|0],(e|0)==255)break n;r=i[26909],i[l+296>>2]=i[26908],i[l+300>>2]=r,W[i[(l+296|0)+(e<<2)>>2]](l+272|0,A);break n}if(_=i[l+112>>2],i[l+320>>2]=_,f=i[l+116>>2],i[l+324>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[_+196>>2],f>>>0>=3){f=V2(l+272|0,47881),e=a(l+296|0,2,3003,f),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;l:{if(t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break l}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break l;Z(i[e+8>>2])}if(t[f+11|0]>=0)break t;Z(i[f>>2]);break t}w=i[(f<<2)+60276>>2],f=i[l+332>>2],s=i[f+188>>2];l:{u:{if((s|0)!=i[k+200>>2]){o=i[f+192>>2];break u}if(o=i[f+192>>2],(o|0)==i[k+204>>2])break l}i[l+272>>2]=0,i[l+276>>2]=0,nA(l+296|0,_,l+272|0,s,o,i[e+180>>2]- -64|0),k=i[l+296>>2];u:{if(k){f=i[l+300>>2],i[A>>2]=i[l+296>>2],i[A+4>>2]=f,f=A+8|0;s:{if(t[l+315|0]>=0){o=i[l+308>>2],i[f>>2]=i[l+304>>2],i[f+4>>2]=o,i[f+8>>2]=i[l+312>>2];break s}T(f,i[l+304>>2],i[l+308>>2])}t[A+20|0]=1;break u}if(o=i[l+272>>2],_=i[l+276>>2],i[l+272>>2]=0,i[l+276>>2]=0,f=i[l+324>>2],i[l+320>>2]=o,i[l+324>>2]=_,!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break u;W[i[i[f>>2]+8>>2]](f),y(f)}if(t[l+315|0]<0&&Z(i[l+304>>2]),g2(l+272|0),k)break t;f=i[l+332>>2]}if(x9(f,l+320|0,w),u[e+225|0]==1&&(f=i[l+332>>2],W[i[i[f>>2]+16>>2]](f,1)),g2(l+320|0),f=u[l+132|0],(f|0)==255)break o;k=i[26909],i[l+296>>2]=i[26908],i[l+300>>2]=k,W[i[(l+296|0)+(f<<2)>>2]](l+272|0,l+112|0)}if(f=p[e+10>>1]|p[e+12>>1]<<16,i[l+272>>2]=p[e+6>>1]|p[e+8>>1]<<16,i[l+276>>2]=f,!_h(l+272|0)){f=i[l+276>>2],i[l+320>>2]=i[l+272>>2],i[l+324>>2]=f,f=i[l+332>>2],k=p[f+10>>1]|p[f+12>>1]<<16,i[l+288>>2]=p[f+6>>1]|p[f+8>>1]<<16,i[l+292>>2]=k;o:{if(_h(l+288|0))break o;f=p[l+288>>1],k=p[l+272>>1];l:{u:{if(!((f|0)==(k|0)|(f|0)==2)&(k|0)!=2||(f=p[l+290>>1],k=p[l+274>>1],!((f|0)==(k|0)|(f|0)==2)&(k|0)!=2)||(f=p[l+292>>1],k=p[l+276>>1],!((f|0)==(k|0)|(f|0)==2)&(k|0)!=2))break u;if(o=u[l+294|0],f=o,(f|0)==u[l+278|0])break l}f=ri(l+112|0),o=F(B0(F(B0(F(B0(F(f+8|0,30528,15),p[l+272>>1]),24035,1),p[l+274>>1]),24035,1),p[l+276>>1]),24035,1),k=u[l+278|0],o=F(B0(F(B0(F(B0(F(F(o,k?10690:18173,k?4:7),30442,39),p[l+288>>1]),24035,1),p[l+290>>1]),24035,1),p[l+292>>1]),24035,1),k=u[l+294|0],F(F(o,k?10690:18173,k?4:7),29808,73),k=l+296|0,ki(k,f),k=a(l+92|0,2,152,k),Bu(e,k),t[k+19|0]<0&&Z(i[k+8>>2]),t[l+307|0]<0&&Z(i[l+296>>2]),F8(f),f=u[l+294|0],o=u[l+278|0]}if(!u[r+68|0]|u[r|0]<9|(!(f&1)|o&1))break o;r=V2(l+112|0,29606),f=a(l+72|0,2,152,r),Bu(e,f),t[f+19|0]<0&&Z(i[f+8>>2]),t[r+11|0]<0&&Z(i[r>>2]),t[l+326|0]=1}r=i[l+332>>2],W[i[i[r>>2]+8>>2]](r,l+320|0)}f=i[e+16>>2],i[l+112>>2]=f,r=i[e+20>>2],i[l+116>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f&&(r=i[l+332>>2],W[i[i[r>>2]+12>>2]](r,l+112|0)),i[l+296>>2]=i[V+120>>2],r=i[V+124>>2],i[l+300>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),i[l+320>>2]=i[V+128>>2],r=i[V+132>>2],i[l+324>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1);o:{l:{if(r=i[e+184>>2],f=i[e+188>>2],(r|0)!=(f|0)){if(o=i[r>>2],o&&(k=i[l+292>>2],o=Z0(o,92792,95304),o))break l;if(r=r+8|0,(f|0)!=(r|0))for(;;){if(o=i[r>>2],o&&(k=0,o=Z0(o,92792,95304),o))break l;if(r=r+8|0,(f|0)==(r|0))break}i[l+288>>2]=0,i[l+292>>2]=0}i[l+288>>2]=0,i[l+292>>2]=0;break o}if(i[l+292>>2]=k,i[l+288>>2]=o,r=i[r+4>>2],i[l+292>>2]=r,!r)break o;i[r+4>>2]=i[r+4>>2]+1}r=i[l+288>>2],r&&(f=i[l+332>>2],W[i[i[f>>2]+24>>2]](f,r+98|0)),f=l- -64|0;o:{l:{if(r=i[e+184>>2],k=i[e+188>>2],(r|0)!=(k|0)){if(_=i[r>>2],_&&(o=i[f+4>>2],_=Z0(_,92792,95316),_))break l;if(r=r+8|0,(k|0)!=(r|0))for(;;){if(_=i[r>>2],_&&(o=0,_=Z0(_,92792,95316),_))break l;if(r=r+8|0,(k|0)==(r|0))break}i[f>>2]=0,i[f+4>>2]=0}i[f>>2]=0,i[f+4>>2]=0;break o}if(i[f+4>>2]=o,i[f>>2]=_,r=i[r+4>>2],i[f+4>>2]=r,!r)break o;i[r+4>>2]=i[r+4>>2]+1}r=i[l+64>>2],r&&(f=i[l+332>>2],W[i[i[f>>2]+28>>2]](f,r+100|0));o:{l:{if(r=i[e+184>>2],f=i[e+188>>2],(r|0)!=(f|0)){if(o=i[r>>2],o&&(k=i[l+60>>2],o=Z0(o,92792,95144),o))break l;if(r=r+8|0,(f|0)!=(r|0))for(;;){if(o=i[r>>2],o&&(k=0,o=Z0(o,92792,95144),o))break l;if(r=r+8|0,(f|0)==(r|0))break}i[l+56>>2]=0,i[l+60>>2]=0}i[l+56>>2]=0,i[l+60>>2]=0;break o}if(i[l+60>>2]=k,i[l+56>>2]=o,r=i[r+4>>2],i[l+60>>2]=r,!r)break o;i[r+4>>2]=i[r+4>>2]+1}r=i[l+56>>2],r&&(f=i[l+332>>2],W[i[i[f>>2]+20>>2]](f,i[r+100>>2],i[r+104>>2]));o:{l:{if(r=i[e+184>>2],f=i[e+188>>2],(r|0)!=(f|0)){if(o=i[r>>2],o&&(k=i[l+52>>2],o=Z0(o,92792,92848),o))break l;if(r=r+8|0,(f|0)!=(r|0))for(;;){if(o=i[r>>2],o&&(k=0,o=Z0(o,92792,92848),o))break l;if(r=r+8|0,(f|0)==(r|0))break}i[l+48>>2]=0,i[l+52>>2]=0}i[l+48>>2]=0,i[l+52>>2]=0;break o}if(i[l+52>>2]=k,i[l+48>>2]=o,r=i[r+4>>2],i[l+52>>2]=r,!r)break o;i[r+4>>2]=i[r+4>>2]+1}r=i[l+48>>2];o:{if(!r||(f=i[l+332>>2],W[i[i[f>>2]+32>>2]](l+28|0,f,r+104|0),t[l+47|0]>=0))break o;Z(i[l+36>>2])}o:{l:{if(r=i[e+184>>2],f=i[e+188>>2],(r|0)!=(f|0)){if(o=i[r>>2],o&&(k=i[l+24>>2],o=Z0(o,92792,95796),o))break l;if(r=r+8|0,(f|0)!=(r|0))for(;;){if(o=i[r>>2],o&&(k=0,o=Z0(o,92792,95796),o))break l;if(r=r+8|0,(f|0)==(r|0))break}i[l+20>>2]=0,i[l+24>>2]=0}i[l+20>>2]=0,i[l+24>>2]=0;break o}if(i[l+24>>2]=k,i[l+20>>2]=o,r=i[r+4>>2],i[l+24>>2]=r,!r)break o;i[r+4>>2]=i[r+4>>2]+1}r=i[l+20>>2];o:{if(!r)break o;f=i[l+332>>2];l:{if(t[r+111|0]>=0){i[l+16>>2]=i[r+108>>2],k=i[r+104>>2],i[l+8>>2]=i[r+100>>2],i[l+12>>2]=k;break l}T(l+8|0,i[r+100>>2],i[r+104>>2])}if(W[i[i[f>>2]+36>>2]](f,l+8|0),t[l+19|0]>=0)break o;Z(i[l+8>>2])}o:{l:{if(r=i[e+184>>2],e=i[e+188>>2],(r|0)!=(e|0)){if(k=i[r>>2],k&&(f=i[l+4>>2],k=Z0(k,92792,114256),k))break l;if(r=r+8|0,(e|0)!=(r|0))for(;;){if(k=i[r>>2],k&&(f=0,k=Z0(k,92792,114256),k))break l;if(r=r+8|0,(e|0)==(r|0))break}i[l>>2]=0,i[l+4>>2]=0}i[l>>2]=0,i[l+4>>2]=0;break o}if(i[l+4>>2]=f,i[l>>2]=k,e=i[r+4>>2],i[l+4>>2]=e,!e)break o;i[e+4>>2]=i[e+4>>2]+1}e=i[l>>2],e&&(r=i[l+332>>2],W[i[i[r>>2]+72>>2]](r,i[e+104>>2])),g2(l),g2(l+20|0),g2(l+48|0),g2(l+56|0),g2(l- -64|0),g2(l+288|0),g2(l+320|0),g2(l+296|0),e=i[l+332>>2],r=i[l+336>>2],i[l+332>>2]=0,i[l+336>>2]=0,t[A+20|0]=0,i[A>>2]=e,i[A+4>>2]=r,g2(l+112|0);break n}if(g2(l+320|0),A=u[l+132|0],(A|0)==255)break n;e=i[26909],i[l+296>>2]=i[26908],i[l+300>>2]=e,W[i[(l+296|0)+(A<<2)>>2]](l+272|0,l+112|0)}if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break A;W[i[i[n>>2]+8>>2]](n),y(n);break A}if(g2(l+320|0),A=u[l+132|0],(A|0)==255)break A;e=i[26907],i[l+296>>2]=i[26906],i[l+300>>2]=e,W[i[(l+296|0)+(A<<2)>>2]](l+272|0,l+112|0)}if(!G||(A=i[G+4>>2],i[G+4>>2]=A-1,A))break f;W[i[i[G>>2]+8>>2]](G),y(G)}if(A=i[l+336>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=u[l+372|0],(A|0)==255)break e;e=i[26909],i[l+112>>2]=i[26908],i[l+116>>2]=e,W[i[(l+112|0)+(A<<2)>>2]](l+296|0,l+352|0)}}v=l+384|0}function xr(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0;w=A+18548|0;i:{e:{r:{f:{A:{k:{n:{t:{for(;;){s=i[A+18588>>2],h=i[s+132>>2];o:{l:{if(_=i[s+124>>2],l=i[_+484>>2],o=1<<f,(l|0)<(o+e|0)||(m=i[_+488>>2],(m|0)<(r+o|0)|i[_+16872>>2]>=(f|0)))break l;n=1,B=e-1|0,o=1;u:{if((B|r)<0||(o=1,(e|0)>(l|0))||(o=1,(r|0)>=(m|0))||(I=i[_+16876>>2],V=g(i[_+16892>>2],r>>I),Q=i[s+140>>2],G=V+(e>>I)|0,I=V+(B>>I)|0,o=1,p[Q+g(G,24)>>1]!=p[Q+g(I,24)>>1]))break u;o=i[h+8484>>2],o=i[o+(G<<2)>>2]!=i[o+(I<<2)>>2]}I=r-1|0;u:{if((I|e)<0|(e|0)>=(l|0)|(r|0)>(m|0)||(l=i[_+16876>>2],m=e>>l,Q=i[s+140>>2],V=i[_+16892>>2],G=m+g(V,r>>l)|0,l=m+g(V,I>>l)|0,p[Q+g(G,24)>>1]!=p[Q+g(l,24)>>1]))break u;n=i[h+8484>>2],n=i[n+(G<<2)>>2]!=i[n+(l<<2)>>2]}if(l=0,!o){if(l=i[s+168>>2],o=B>>l,(o|0)<0||(m=i[s+172>>2],(m|0)<=(o|0)))break A;if(l=r>>l,(l|0)<0|(l|0)>=i[s+176>>2])break f;o=(i[s+160>>2]+g(o,3)|0)+g(g(l,m),3)|0,l=((u[o|0]|u[o+1|0]<<8)>>>6&3)>(k|0)}if(n)o=0;else{if(n=i[s+168>>2],o=e>>n,(o|0)<0||(m=i[s+172>>2],(m|0)<=(o|0)))break A;if(n=I>>n,(n|0)<0|(n|0)>=i[s+176>>2])break f;o=(i[s+160>>2]+g(o,3)|0)+g(g(n,m),3)|0,o=((u[o|0]|u[o+1|0]<<8)>>>6&3)>(k|0)}o=!W2(w,(o+(i[A+18572>>2]+l|0)|0)+2|0);break o}o=i[_+16872>>2]>=(f|0)}if(!u[h+26|0]|i[h+8268>>2]>(f|0)||(i[A+18500>>2]=0,i[A+18504>>2]=0),!u[i[A+18592>>2]+760|0]|i[h+8272>>2]>(f|0)||(i[A+18508>>2]=0),!o){if(f=f-1|0,k=k+1|0,xr(A,e,r,f,k),s=1<<f,o=s+r|0,s=e+s|0,(s|0)<i[_+484>>2]&&xr(A,s,r,f,k),(o|0)<i[_+488>>2]&&xr(A,e,o,f,k),(s|0)>=i[_+484>>2])break t;if(e=s,r=o,(r|0)<i[_+488>>2])continue;break t}break}if(o=i[s+168>>2],w=f-o|0,(w|0)!=31)for(l=r>>o,w=1<<w,n=l+w|0,o=e>>o,m=o+w|0,B=k<<6&192;;){for(h=o;w=(i[s+160>>2]+g(h,3)|0)+g(g(i[s+172>>2],l),3)|0,_=B|(u[w|0]|u[w+1|0]<<8)&65343,t[w|0]=_,t[w+1|0]=_>>>8,h=h+1|0,(m|0)>(h|0););if(l=l+1|0,!((n|0)>(l|0)))break}if(m=v+-64|0,v=m,o=A,V=i[A+18592>>2],n=i[A+18588>>2],B=i[n+132>>2],I=i[n+124>>2],s=e,w=r,_=f,A=i[n+168>>2],h=f-A|0,(h|0)!=31)for(r=r>>A,h=1<<h,G=r+h|0,e=e>>A,Q=e+h|0;;){for(A=e;h=(i[n+160>>2]+g(A,3)|0)+g(g(i[n+172>>2],r),3)|0,l=(u[h|0]|u[h+1|0]<<8)&65528,t[h|0]=l,t[h+1|0]=l>>>8,A=A+1|0,(Q|0)>(A|0););if(r=r+1|0,!((G|0)>(r|0)))break}if(e=i[n+168>>2],A=s>>e,(A|0)<0||(r=i[n+172>>2],(r|0)<=(A|0)))break n;if(e=w>>e,(e|0)<0|(e|0)>=i[n+176>>2])break k;if(A=(i[n+160>>2]+g(A,3)|0)+g(g(e,r),3)|0,e=(u[A|0]|u[A+1|0]<<8)&65528|f&7,t[A|0]=e,t[A+1|0]=e>>>8,e=i[n+248>>2],r=_-e|0,(r|0)!=31)for(A=w>>e,r=1<<r,f=A+r|0,h=r,r=s>>e,h=h+r|0;;){for(e=r;t[(i[n+240>>2]+e|0)+g(i[n+252>>2],A)|0]=0,e=e+1|0,(h|0)>(e|0););if(A=A+1|0,!((f|0)>(A|0)))break}Jn(o,s,w);o:{if(u[B+44|0]){if(A=W2(o+18548|0,i[o+18572>>2]+161|0),t[o+32|0]=A,!A)break o;if(A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=w>>A,e=1<<e,l=r+e|0,f=e,e=s>>A,B=f+e|0;;){for(A=e;f=(i[n+160>>2]+g(A,3)|0)+g(g(i[n+172>>2],r),3)|0,h=(u[f|0]|u[f+1|0]<<8)&63487|2048,t[f|0]=h,t[f+1|0]=h>>>8,A=A+1|0,(B|0)>(A|0););if(r=r+1|0,!((l|0)>(r|0)))break}if(e=i[n+148>>2],A=s>>e,(A|0)<0||(r=i[n+152>>2],(r|0)<=(A|0)))break n;if(e=w>>e,(e|0)<0|(e|0)>=i[n+156>>2])break k;t[((i[n+140>>2]+g(A,24)|0)+g(g(e,r),24)|0)+22|0]=1;break o}t[o+32|0]=0}l=1<<_,f=0;o:{l:{if(i[V+28>>2]==2)break l;e=i[o+18588>>2],B=1,h=s-1|0,A=1;u:{if((h|w)<0||(r=i[e+124>>2],A=1,(s|0)>i[r+484>>2])||(A=1,(w|0)>=i[r+488>>2])||(A=i[r+16892>>2],r=i[r+16876>>2],f=g(A,w>>r),Q=i[e+140>>2],G=f+(s>>r)|0,r=f+(h>>r)|0,A=1,p[Q+g(G,24)>>1]!=p[Q+g(r,24)>>1]))break u;A=i[i[e+132>>2]+8484>>2],A=i[A+(G<<2)>>2]!=i[A+(r<<2)>>2]}G=w-1|0;u:{if((G|s)<0||(r=i[e+124>>2],(s|0)>=i[r+484>>2]|(w|0)>i[r+488>>2])||(f=i[r+16876>>2],Q=s>>f,E=i[e+140>>2],r=i[r+16892>>2],Y=Q+g(r,w>>f)|0,r=Q+g(r,G>>f)|0,p[E+g(Y,24)>>1]!=p[E+g(r,24)>>1]))break u;f=i[i[e+132>>2]+8484>>2],B=i[f+(Y<<2)>>2]!=i[f+(r<<2)>>2]}if(f=0,r=0,!A){if(r=i[e+168>>2],A=h>>r,(A|0)<0||(h=i[e+172>>2],(h|0)<=(A|0)))break A;if(r=w>>r,(r|0)<0|(r|0)>=i[e+176>>2])break f;A=(i[e+160>>2]+g(A,3)|0)+g(g(r,h),3)|0,r=((u[A|0]|u[A+1|0]<<8)&768)==512}if(!B){if(f=i[e+168>>2],A=s>>f,(A|0)<0||(h=i[e+172>>2],(h|0)<=(A|0)))break A;if(f=G>>f,(f|0)<0|(f|0)>=i[e+176>>2])break f;A=(i[e+160>>2]+g(A,3)|0)+g(g(f,h),3)|0,f=((u[A|0]|u[A+1|0]<<8)&768)==512}if(A=o+18548|0,W2(A,((i[o+18572>>2]+r|0)+f|0)+5|0)&255){e=16;u:{if(i[i[o+18592>>2]+812>>2]<2||!W2(A,i[o+18572>>2]+148|0)||(e=48,i[i[o+18592>>2]+812>>2]<3))break u;for(e=1;B4(A)&&(e=e+1|0,(e|0)<(i[i[o+18592>>2]+812>>2]-1|0)););e=e<<5|16}if(t[o+26|0]=u[o+26|0]&15|e,e=i[n+168>>2],A=s>>e,(A|0)<0||(r=i[n+172>>2],(r|0)<=(A|0)))break n;if(e=w>>e,(e|0)<0|(e|0)>=i[n+176>>2])break k;if(A=(i[n+160>>2]+g(A,3)|0)+g(g(e,r),3)|0,e=(u[A|0]|u[A+1|0]<<8)&65479,t[A|0]=e,t[A+1|0]=e>>>8,A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=w>>A,e=1<<e,_=r+e|0,A=s>>A,h=A+e|0;;){for(e=A;f=(i[n+160>>2]+g(e,3)|0)+g(g(i[n+172>>2],r),3)|0,k=(u[f|0]|u[f+1|0]<<8)&64767|512,t[f|0]=k,t[f+1|0]=k>>>8,e=e+1|0,(h|0)>(e|0););if(r=r+1|0,!((_|0)>(r|0)))break}V9(i[o+18584>>2],i[o+18592>>2],i[o+18588>>2],o+16|0,s,w,0,0,l,l,l,0);break o}if(f=0,i[V+28>>2]==2)break l;f=!W2(A,i[o+18572>>2]+149|0)}if(A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=w>>A,e=1<<e,V=r+e|0,G=f<<8,A=s>>A,Q=A+e|0;;){for(e=A;h=(i[n+160>>2]+g(e,3)|0)+g(g(i[n+172>>2],r),3)|0,B=G|(u[h|0]|u[h+1|0]<<8)&64767,t[h|0]=B,t[h+1|0]=B>>>8,e=e+1|0,(Q|0)>(e|0););if(r=r+1|0,!((V|0)>(r|0)))break}B=!f;l:{u:{if(f){h=i[i[o+18588>>2]+124>>2],A=0,r=o+18548|0;s:{if(W2(r,i[o+18572>>2]+8|0))break s;e=W2(r,i[o+18572>>2]+9|0);h:{w:{if((_|0)>i[h+16872>>2]){if(A=e?1:2,!u[h+8798|0]||W2(r,i[o+18572>>2]+11|0))break s;if(A=B4(r),!(!e|!A)){A=5;break s}if(!(A|!e)){A=4;break s}if(A|e)break w;A=6;break s}if(A=1,e)break s;if((_|0)!=3)break h;A=2;break s}if(!(!A|e)){A=7;break s}U0(13347,19977,1774,16612),M()}A=3-W2(r,i[o+18572>>2]+10|0)|0}break u}if(e=0,h=0,(_|0)!=i[I+16872>>2])break l;A=W2(o+18548|0,i[o+18572>>2]+8|0)?0:3}e=A,h=(A|0)==3&B}if(r=i[n+168>>2],A=s>>r,(A|0)<0||(B=i[n+172>>2],(B|0)<=(A|0)))break n;if(r=w>>r,(r|0)<0|(r|0)>=i[n+176>>2])break k;A=(i[n+160>>2]+g(A,3)|0)+g(g(r,B),3)|0,r=(u[A|0]|u[A+1|0]<<8)&65479|e<<3&56,t[A|0]=r,t[A+1|0]=r>>>8;l:{if(!f){u:{if(!u[I+8800|0]|e|((_|0)<i[I+16956>>2]|(_|0)>i[I+16960>>2])||!Q5(o+18548|0))break u;if(A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=w>>A,e=1<<e,h=r+e|0,f=e,e=s>>A,l=f+e|0;;){for(A=e;f=(i[n+160>>2]+g(A,3)|0)+g(g(i[n+172>>2],r),3)|0,k=(u[f|0]|u[f+1|0]<<8)&64511|1024,t[f|0]=k,t[f+1|0]=k>>>8,A=A+1|0,(l|0)>(A|0););if(r=r+1|0,!((h|0)>(r|0)))break}if(e=i[n+148>>2],A=s>>e,(A|0)<0||(r=i[n+152>>2],(r|0)<=(A|0)))break n;if(e=w>>e,(e|0)<0|(e|0)>=i[n+156>>2])break k;t[((i[n+140>>2]+g(A,24)|0)+g(g(e,r),24)|0)+22|0]=1,r=0,k=v-32|0,v=k,A=i[o+18552>>2],i[k+8>>2]=A,e=i[o+18556>>2],i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+12>>2]=e-A,A=1<<_,e=i[o+18588>>2],h=i[e+40>>2],n=g(h,w),l=i[e+4>>2],e=i[e+124>>2],f=t[e+8801|0],e=i[e+16832>>2];s:{if((e|0)>=9){if((_|0)==31)break s;for(e=e-f|0,B=(e|0)>0?e:0,n=l+(n+s<<1)|0;;){for(l=n+(g(r,h)<<1)|0,e=0;A0=l+(e<<1)|0,t0=G0(k+8|0,f)<<B,X[A0>>1]=t0,e=e+1|0,(A|0)!=(e|0););if(r=r+1|0,(A|0)==(r|0))break}break s}if((_|0)==31)break s;for(e=e-f|0,B=(e|0)>0?e:0,n=n+(l+s|0)|0;;){for(l=n+g(r,h)|0,e=0;A0=e+l|0,t0=G0(k+8|0,f)<<B,t[A0|0]=t0,e=e+1|0,(A|0)!=(e|0););if(r=r+1|0,(A|0)==(r|0))break}}h=i[o+18588>>2],f=i[h+124>>2];s:{if(!i[f+16848>>2])break s;if(A=i[f+16852>>2],B=(s|0)/(A|0)|0,I=1<<_,_=i[f+16856>>2],r=(I|0)/(_|0)|0,e=(I|0)/(A|0)|0,l=i[h+44>>2],A=g(l,(w|0)/(_|0)|0),V=i[h+8>>2],_=t[f+8802|0],n=i[f+16840>>2],(n|0)>=9){if(f=0,n=n-_|0,n=(n|0)>0?n:0,A=A+B<<1,!((e|0)<=0|(r|0)<=0)){for(h=A+V|0;;){for(B=h+(g(f,l)<<1)|0,A=0;A0=B+(A<<1)|0,t0=G0(k+8|0,_)<<n,X[A0>>1]=t0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}h=i[o+18588>>2],A=i[h+124>>2],_=t[A+8802|0],e=i[A+16840>>2]-_|0,n=(e|0)>0?e:0,l=i[h+44>>2],e=i[A+16856>>2],f=i[A+16852>>2],A=g(l,(w|0)/(e|0)|0)+((s|0)/(f|0)|0)<<1,r=(I|0)/(e|0)|0,e=(I|0)/(f|0)|0}if((e|0)<=0|(r|0)<=0)break s;for(s=i[h+12>>2]+A|0,f=0;;){for(w=s+(g(f,l)<<1)|0,A=0;A0=w+(A<<1)|0,t0=G0(k+8|0,_)<<n,X[A0>>1]=t0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}break s}if(f=0,n=n-_|0,n=(n|0)>0?n:0,!((e|0)<=0|(r|0)<=0)){for(h=(B+V|0)+A|0;;){for(B=h+g(f,l)|0,A=0;A0=A+B|0,t0=G0(k+8|0,_)<<n,t[A0|0]=t0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}h=i[o+18588>>2],A=i[h+124>>2],_=t[A+8802|0],e=i[A+16840>>2]-_|0,n=(e|0)>0?e:0,e=i[A+16852>>2],B=(s|0)/(e|0)|0,A=i[A+16856>>2],r=(I|0)/(A|0)|0,e=(I|0)/(e|0)|0,l=i[h+44>>2],A=g(l,(w|0)/(A|0)|0)}if((e|0)<=0|(r|0)<=0)break s;for(s=(i[h+12>>2]+B|0)+A|0,f=0;;){for(w=s+g(f,l)|0,A=0;A0=A+w|0,t0=G0(k+8|0,_)<<n,t[A0|0]=t0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}}Ds(k+8|0),i[o+18552>>2]=i[k+8>>2],rr(o+18548|0),v=k+32|0;break o}if(B=(e|0)==3,V=B?(l|0)/2|0:l,(_|0)!=31)for(r=o+18548|0,e=0,f=0;;){for(A=0;A0=(m+48|0)+(e<<2)|0,t0=W2(r,i[o+18572>>2]+12|0),i[A0>>2]=t0,e=e+1|0,A=A+V|0,(l|0)>(A|0););if(f=f+V|0,!((l|0)>(f|0)))break}f=s-1|0,A=0;u:{if((f|w)<0||(e=i[n+124>>2],A=0,(s|0)>i[e+484>>2])||(A=0,(w|0)>=i[e+488>>2])||(A=i[e+16892>>2],e=i[e+16876>>2],r=g(A,w>>e),G=i[n+140>>2],k=r+(s>>e)|0,e=r+(f>>e)|0,A=0,p[G+g(k,24)>>1]!=p[G+g(e,24)>>1]))break u;A=i[i[n+132>>2]+8484>>2],A=i[A+(k<<2)>>2]==i[A+(e<<2)>>2]}k=A,f=w-1|0;u:{if((f|s)<0||(A=i[n+124>>2],(s|0)>=i[A+484>>2]|(w|0)>i[A+488>>2])||(e=i[A+16876>>2],r=s>>e,Q=i[n+140>>2],A=i[A+16892>>2],G=r+g(A,w>>e)|0,A=r+g(A,f>>e)|0,p[Q+g(G,24)>>1]!=p[Q+g(A,24)>>1]))break u;e=i[i[n+132>>2]+8484>>2],d=i[e+(G<<2)>>2]==i[e+(A<<2)>>2]}if(Q=_-B|0,(_|0)!=31)for(j=o+18548|0,B=0;;){for(G=w+B|0,c=(B|0)>0|d,Y=0;;){E=O<<2,S=i[E+(m+48|0)>>2];u:{if(S){f=qe(j,2),A=m+32|0;break u}f=j8(j,5),A=m+16|0}i[A+E>>2]=f,r=s+Y|0,x=r,A=i[I+16944>>2],R=g(i[I+16948>>2],G>>A)+(r>>A)|0,f=R,U=i[n+124>>2],e=1,A=1;u:{if(!((Y|0)>0|k))break u;if(A=i[n+168>>2],r=r-1>>A,(r|0)<0||(q=i[n+172>>2],(q|0)<=(r|0)))break A;if(N=G>>A,(N|0)<0|(N|0)>=i[n+176>>2])break f;if(A=1,u[((i[n+160>>2]+g(r,3)|0)+g(g(N,q),3)|0)+1|0]&7)break u;A=u[(f+i[n+200>>2]|0)-1|0]}u:{if(!c)break u;if(N=i[n+168>>2],r=x>>N,(r|0)<0||(x=i[n+172>>2],(x|0)<=(r|0)))break A;if(N=G-1>>N,(N|0)<0|(N|0)>=i[n+176>>2])break f;if(u[((i[n+160>>2]+g(r,3)|0)+g(g(N,x),3)|0)+1|0]&7|(G|0)==(G&-1<<i[U+16876>>2]))break u;e=u[i[n+200>>2]+(f-i[U+16948>>2]|0)|0]}u:{if((A|0)==(e|0)){if(A>>>0<=1){i[m+12>>2]=26,i[m+4>>2]=0,i[m+8>>2]=1;break u}i[m+4>>2]=A,i[m+12>>2]=(A-1&31)+2,i[m+8>>2]=(A+29&31)+2;break u}if(i[m+8>>2]=e,i[m+4>>2]=A,!(!A|!e)){i[m+12>>2]=0;break u}if(!((A|0)==1|(e|0)==1)){i[m+12>>2]=1;break u}i[m+12>>2]=26}u:{if((S|0)!=1){A=i[m+4>>2],r=i[m+8>>2],e=(A|0)>(r|0)?A:r,A=(A|0)<(r|0)?A:r,r=i[m+12>>2];s:{if((A|0)<=(r|0)){f=A,A=r;break s}i[m+12>>2]=A,i[m+4>>2]=r,f=r}s:{if((A|0)>=(e|0)){r=A,A=e;break s}i[m+8>>2]=A,r=e}e=A,A=i[E+(m+16|0)>>2],A=((A|0)>=(f|0))+A|0,A=((e|0)<=(A|0))+A|0,f=((A|0)>=(r|0))+A|0;break u}f=i[(m+4|0)+(i[E+(m+32|0)>>2]<<2)>>2]}if(E=i[n+208>>2],A=Q-E|0,(A|0)!=31)for(U=1<<A,N=U&2147483646,A=0;;){if(e=0,r=0,(Q|0)!=(E|0))for(;t[((i[n+200>>2]+R|0)+e|0)+g(i[n+212>>2],A)|0]=f,t[(((i[n+200>>2]+R|0)+e|0)+g(i[n+212>>2],A)|0)+1|0]=f,e=e+2|0,r=r+2|0,(N|0)!=(r|0););if((Q|0)==(E|0)&&(t[((i[n+200>>2]+R|0)+e|0)+g(i[n+212>>2],A)|0]=f),A=A+1|0,(U|0)==(A|0))break}if(O=O+1|0,Y=V+Y|0,!((l|0)>(Y|0)))break}if(B=B+V|0,!((l|0)>(B|0)))break}u:switch(i[I+16848>>2]){case 3:if((_|0)==31)break l;f=o+18548|0,r=0;s:{for(;;){k=r+w|0,B=0;h:{for(;;){if(W2(f,i[o+18572>>2]+13|0)?A=j8(f,2):A=4,E=s+B|0,G=i[n+208>>2],e=E>>G,(e|0)<0||(R=i[n+212>>2],(R|0)<=(e|0)))break h;if(Y=k>>G,(Y|0)<0|(Y|0)>=i[n+216>>2])break f;if(e=u[(e+i[n+200>>2]|0)+g(Y,R)|0],e=e>>>0<=34?e:0,Y=(A|0)==4,Y||(A=i[(A<<2)+69536>>2],e=(A|0)==(e|0)?34:A),A=Q-G|0,(A|0)!=31)for(Y=Y?e|-128:e,e=i[n+124>>2],G=i[e+16944>>2],E=g(k>>G,i[e+16948>>2])+(E>>G)|0,G=1<<A,A=0;;){for(e=0;;){if(R=i[n+124>>2],i[R+16948>>2]<=(e|0))break r;if(i[R+16952>>2]<=(A|0))break e;if(R=(e+E|0)+g(i[n+232>>2],A)|0,(R|0)>=i[n+224>>2])break s;if(t[R+i[n+220>>2]|0]=Y,e=e+1|0,(G|0)==(e|0))break}if(A=A+1|0,(G|0)==(A|0))break}if(B=B+V|0,!((l|0)>(B|0)))break}if(r=r+V|0,(l|0)>(r|0))continue;break l}break}break A}break i;case 0:break l;default:break u}if(A=o+18548|0,W2(A,i[o+18572>>2]+13|0)?A=j8(A,2):A=4,r=i[n+208>>2],e=s>>r,(e|0)<0||(f=i[n+212>>2],(f|0)<=(e|0)))break A;if(r=w>>r,(r|0)<0|(r|0)>=i[n+216>>2])break f;if(e=u[(e+i[n+200>>2]|0)+g(r,f)|0],e=e>>>0<=34?e:0,(A|0)!=4&&(r=i[(A<<2)+69536>>2],e=(e|0)==(r|0)?34:r),e=i[I+16848>>2]==2?u[e+69552|0]:e,A=(A|0)==4,r=_-i[n+208>>2]|0,(r|0)!=31)for(f=i[n+124>>2],k=i[f+16944>>2],f=g(w>>k,i[f+16948>>2])+(s>>k)|0,k=A?e|-128:e,r=1<<r,A=0;;){for(e=0;;){if(l=i[n+124>>2],i[l+16948>>2]<=(e|0))break r;if(i[l+16952>>2]<=(A|0))break e;if(l=(e+f|0)+g(i[n+232>>2],A)|0,(l|0)>=i[n+224>>2])break i;if(t[l+i[n+220>>2]|0]=k,e=e+1|0,(r|0)==(e|0))break}if(A=A+1|0,(r|0)==(A|0))break}break l}u:{s:{h:switch(e|0){case 1:A=(l|0)/2|0,Q4(o,s,w,0,0,l,A,k,l,0),Q4(o,s,w,0,A,l,A,k,l,1);break s;case 2:A=(l|0)/2|0,Q4(o,s,w,0,0,A,l,k,l,0),Q4(o,s,w,A,0,A,l,k,l,1);break s;case 4:A=(l|0)/4|0,Q4(o,s,w,0,0,l,A,k,l,0),Q4(o,s,w,0,A,l,(3<<_)/4|0,k,l,1);break s;case 5:A=(3<<_)/4|0,Q4(o,s,w,0,0,l,A,k,l,0),Q4(o,s,w,0,A,l,(l|0)/4|0,k,l,1);break s;case 6:A=(l|0)/4|0,Q4(o,s,w,0,0,A,l,k,l,0),Q4(o,s,w,A,0,(3<<_)/4|0,l,k,l,1);break s;case 7:A=(3<<_)/4|0,Q4(o,s,w,0,0,A,l,k,l,0),Q4(o,s,w,A,0,(l|0)/4|0,l,k,l,1);break s;case 3:A=(l|0)/2|0,Q4(o,s,w,0,0,A,A,k,l,0),Q4(o,s,w,A,0,A,A,k,l,1),Q4(o,s,w,0,A,A,A,k,l,2),Q4(o,s,w,A,A,A,A,k,l,3);break s;default:U0(24033,19977,4544,4188),M();case 0:break h}if(Q4(o,s,w,0,0,l,l,k,l,0),u[o+26|0]&16)break u}if(!W2(o+18548|0,i[o+18572>>2]+153|0))break o}A=i[I+16848>>2]!=0,Xe(o,s,w,s,w,s,w,_,0,0,i[I+628>>2],h,1,A,A);break o}A=i[I+16848>>2]!=0,Xe(o,s,w,s,w,s,w,_,0,0,h+i[I+632>>2]|0,h,0,A,A)}v=m- -64|0}return}U0(5068,11952,128,4625),M()}U0(5030,11952,129,4625),M()}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}U0(6692,11952,691,21593),M()}U0(6667,11952,692,21593),M()}U0(12511,11952,695,21593),M()}function uv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0;s=v-96|0,v=s,k=i[r>>2],o=i[r+4>>2];i:{if(!o){Q=W[i[i[k>>2]+8>>2]](k)|0,V=h0;break i}if(i[o+4>>2]=i[o+4>>2]+1,Q=W[i[i[k>>2]+8>>2]](k)|0,V=h0,k=i[o+4>>2],i[o+4>>2]=k-1,k)break i;W[i[i[o>>2]+8>>2]](o),y(o)}k=i[r+16>>2],i[s+76>>2]=0,i[s+80>>2]=0,D4(A,s+76|0,k,f,19479);i:{if(i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),i[s+72>>2]=0,i[s+64>>2]=0,i[s+68>>2]=0;e:{r:{f:{A:{k:{n:{if(!k)break n;if((k|0)<0)break k;B=C(k),i[s+64>>2]=B,_=k+B|0,i[s+72>>2]=_,k&&l0(B,0,k),i[s+68>>2]=_}if(k=_-B|0,!s6(r,B,k)){if(u[r+20|0]==1){if(t[s+32|0]=0,t[s+43|0]=0,a(A,2,100,s+32|0),t[s+43|0]>=0)break e;Z(i[s+32>>2]);break e}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break e}T(e,i[28730],i[28731]);break e}n=K6(s+32|0,B,k),S=e,q=O2(n,2),t[S+97|0]=q,S=e,q=U2(n),t[S+98|0]=q,S=e,q=U2(n),t[S+99|0]=q,S=e,q=U2(n),t[S+100|0]=q,S=e,q=U2(n),t[S+101|0]=q,S=e,q=U2(n),t[S+102|0]=q,S=e,q=U2(n),t[S+103|0]=q,S=e,q=U2(n),t[S+104|0]=q,S=e,q=U2(n),t[S+105|0]=q,S=e,q=U2(n),t[S+106|0]=q,S=e,q=O2(n,2),t[S+108|0]=q,S=e,q=O2(n,3)+1|0,t[S+109|0]=q,o=U2(n)?15:7,S=e,q=T0(n,o)+1|0,i[S+112>>2]=q,S=e,q=T0(n,o)+1|0,i[S+116>>2]=q;n:{if((u[e+108|0]-1&255)>>>0>1||(S=e,q=U2(n),t[S+121|0]=q,u[e+108|0]!=1))break n;S=e,q=U2(n),t[S+122|0]=q}if(u[e+99|0]==1){if(k=O2(n,2)+4&255,k>>>0<7)break A;if(f=C(64),i[s+84>>2]=f,i[s+88>>2]=58,i[s+92>>2]=-2147483584,r=u[2904]|u[2905]<<8|(u[2906]<<16|u[2907]<<24),e=u[2900]|u[2901]<<8|(u[2902]<<16|u[2903]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+58|0]=0,e=u[2956]|u[2957]<<8,t[f+56|0]=e,t[f+57|0]=e>>>8,r=u[2952]|u[2953]<<8|(u[2954]<<16|u[2955]<<24),e=u[2948]|u[2949]<<8|(u[2950]<<16|u[2951]<<24),t[f+48|0]=e,t[f+49|0]=e>>>8,t[f+50|0]=e>>>16,t[f+51|0]=e>>>24,t[f+52|0]=r,t[f+53|0]=r>>>8,t[f+54|0]=r>>>16,t[f+55|0]=r>>>24,r=u[2944]|u[2945]<<8|(u[2946]<<16|u[2947]<<24),e=u[2940]|u[2941]<<8|(u[2942]<<16|u[2943]<<24),t[f+40|0]=e,t[f+41|0]=e>>>8,t[f+42|0]=e>>>16,t[f+43|0]=e>>>24,t[f+44|0]=r,t[f+45|0]=r>>>8,t[f+46|0]=r>>>16,t[f+47|0]=r>>>24,r=u[2936]|u[2937]<<8|(u[2938]<<16|u[2939]<<24),e=u[2932]|u[2933]<<8|(u[2934]<<16|u[2935]<<24),t[f+32|0]=e,t[f+33|0]=e>>>8,t[f+34|0]=e>>>16,t[f+35|0]=e>>>24,t[f+36|0]=r,t[f+37|0]=r>>>8,t[f+38|0]=r>>>16,t[f+39|0]=r>>>24,r=u[2928]|u[2929]<<8|(u[2930]<<16|u[2931]<<24),e=u[2924]|u[2925]<<8|(u[2926]<<16|u[2927]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,t[f+28|0]=r,t[f+29|0]=r>>>8,t[f+30|0]=r>>>16,t[f+31|0]=r>>>24,r=u[2920]|u[2921]<<8|(u[2922]<<16|u[2923]<<24),e=u[2916]|u[2917]<<8|(u[2918]<<16|u[2919]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[2912]|u[2913]<<8|(u[2914]<<16|u[2915]<<24),e=u[2908]|u[2909]<<8|(u[2910]<<16|u[2911]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,a(A,2,149,s+84|0),t[s+95|0]>=0)break e;Z(i[s+84>>2]);break e}if(!U2(n))break r;k=O2(n,3)+9|0;break f}s0(),M()}fs(s+16|0,k),k=Mu(i[s+16>>2],i[s+20>>2],i[s+24>>2],i[s+28>>2])}t[e+120|0]=k}u[e+101|0]==1&&(S=e,q=U2(n),t[S+123|0]=q);r:{if(u[e+102|0]==1){S=e,q=O2(n,8),X[S+124>>1]=q,S=e,q=O2(n,8),X[S+126>>1]=q,h=O2(n,8);break r}k=u[e+104|0],X[e+126>>1]=k?2:13,X[e+124>>1]=k?2:1,h=u[e+108|0]?6:2}X[e+128>>1]=h,u[e+98|0]==1&&(S=e,q=T0(n,32),i[S+132>>2]=q,S=e,q=T0(n,32),i[S+136>>2]=q);r:{if(u[e+103|0]!=1)break r;k=U2(n),t[e+140|0]=k;f:{if(!k)break f;A:{if(U2(n)){i[e+144>>2]=i[e+112>>2],h=i[e+116>>2];break A}S=e,q=T0(n,o)+1|0,i[S+144>>2]=q,h=T0(n,o)+1|0}i[e+148>>2]=h,S=e,q=O2(n,8),t[S+152|0]=q,S=e,q=U2(n),t[S+153|0]=q,k=O2(n,2),t[e+154|0]=k;A:{if((k-1&255)>>>0>1||(S=e,q=U2(n),t[S+155|0]=q,u[e+154|0]!=1))break A;S=e,q=U2(n),t[S+156|0]=q}k=U2(n),t[e+157|0]=k;A:{k:{n:{if(k){if(k=O2(n,2)+4&255,k>>>0<7)break n;if(e=A,A=V2(s+84|0,2959),a(e,2,149,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(!U2(n))break A;h=O2(n,3)+9|0;break k}fs(s,k),h=Mu(i[s>>2],i[s+4>>2],i[s+8>>2],i[s+12>>2])}t[e+158|0]=h}if(S=e,q=U2(n),t[S+159|0]=q,k=U2(n),t[e+160|0]=k,k){S=e,q=O2(n,8),X[S+162>>1]=q,S=e,q=O2(n,8),X[S+164>>1]=q,S=e,q=O2(n,8),X[S+166>>1]=q,S=e,q=U2(n),t[S+168|0]=q;break f}t[e+168|0]=1,X[e+166>>1]=6,X[e+162>>1]=1,X[e+164>>1]=13}if(k=U2(n),h=U2(n),o=U2(n),I=U2(n),S=e,q=U2(n),t[S+169|0]=q,S=e,q=U2(n),t[S+170|0]=q,k){l=C(120),i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=97628,k=l+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[l+32>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,i[l+44>>2]=0,i[l+48>>2]=0,i[l+16>>2]=92500,i[l+60>>2]=0,i[l+64>>2]=0,i[l+52>>2]=0,i[l+56>>2]=0,i[l+72>>2]=-1,i[l+76>>2]=-1,i[l+80>>2]=-1,i[l+84>>2]=-1,i[l+88>>2]=0,i[l+92>>2]=0,i[l+96>>2]=0,i[l+100>>2]=0,i[l+104>>2]=0,i[l+108>>2]=0,t[l+112|0]=0,i[l+16>>2]=95244,X[l+114>>1]=0,X[l+116>>1]=0,i[l+32>>2]=1668050025,i[e+172>>2]=k,w=i[e+176>>2],i[e+176>>2]=l;f:{if(!w||(k=i[w+4>>2],i[w+4>>2]=k-1,k))break f;W[i[i[w>>2]+8>>2]](w),y(w)}k=c1(n),X[i[e+172>>2]+98>>1]=k,k=c1(n),X[i[e+172>>2]+100>>1]=k}if(h){k=C(144),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=97668,S=e,q=R3(k+16|0),i[S+180>>2]=q,h=i[e+184>>2],i[e+184>>2]=k;f:{if(!h||(k=i[h+4>>2],i[h+4>>2]=k-1,k))break f;W[i[i[h>>2]+8>>2]](h),y(h)}k=c1(n),X[i[e+180>>2]+100>>1]=k,k=c1(n),X[i[e+180>>2]+106>>1]=k,k=c1(n),X[i[e+180>>2]+102>>1]=k,k=c1(n),X[i[e+180>>2]+108>>1]=k,k=c1(n),X[i[e+180>>2]+104>>1]=k,k=c1(n),X[i[e+180>>2]+110>>1]=k,k=c1(n),X[i[e+180>>2]+112>>1]=k,k=c1(n),X[i[e+180>>2]+114>>1]=k,k=T0(n,32),i[i[e+180>>2]+116>>2]=k,k=T0(n,32),i[i[e+180>>2]+120>>2]=k}f:{if(!o)break f;k=C(168),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=114156,S=e,q=Lo(k+16|0),i[S+188>>2]=q,o=i[e+192>>2],i[e+192>>2]=k;A:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break A;W[i[i[o>>2]+8>>2]](o),y(o)}if(m2(n,2),k=U2(n),m=U2(n),G=U2(n),B=U2(n),m2(n,2),k&&(_=m8(n),l=m8(n),w=m8(n),h=m8(n),o=m8(n),k=m8(n),Es(i[e+188>>2],_,l,w,h,o,k)),m&&(o=i[e+188>>2],k=T0(n,32),t[o+128|0]=1,i[o+124>>2]=k),G&&(o=i[e+188>>2],k=T0(n,32),t[o+136|0]=1,i[o+132>>2]=k),!B)break f;o=i[e+188>>2],k=T0(n,32),t[o+144|0]=1,i[o+140>>2]=k}if(I){k=C(128),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=97708,S=e,q=Dl(k+16|0),i[S+196>>2]=q,o=i[e+200>>2],i[e+200>>2]=k;f:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break f;W[i[i[o>>2]+8>>2]](o),y(o)}k=T0(n,32),i[i[e+196>>2]+100>>2]=k,k=c1(n),X[i[e+196>>2]+104>>1]=k,k=c1(n),X[i[e+196>>2]+106>>1]=k}if(u[e+169|0]==1&&(m2(n,32),m2(n,16),m2(n,16),m2(n,32),m2(n,16),m2(n,16)),u[e+170|0]==1&&m2(n,32),u[e+140|0]!=1)break r;if(k=U2(n),h=U2(n),o=U2(n),I=U2(n),S=e,q=U2(n),t[S+204|0]=q,S=e,q=U2(n),t[S+205|0]=q,k){l=C(120),i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=97628,k=l+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[l+32>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,i[l+44>>2]=0,i[l+48>>2]=0,i[l+16>>2]=92500,i[l+60>>2]=0,i[l+64>>2]=0,i[l+52>>2]=0,i[l+56>>2]=0,i[l+72>>2]=-1,i[l+76>>2]=-1,i[l+80>>2]=-1,i[l+84>>2]=-1,i[l+88>>2]=0,i[l+92>>2]=0,i[l+96>>2]=0,i[l+100>>2]=0,i[l+104>>2]=0,i[l+108>>2]=0,t[l+112|0]=0,i[l+16>>2]=95244,X[l+114>>1]=0,X[l+116>>1]=0,i[l+32>>2]=1668050025,i[e+208>>2]=k,w=i[e+212>>2],i[e+212>>2]=l;f:{if(!w||(k=i[w+4>>2],i[w+4>>2]=k-1,k))break f;W[i[i[w>>2]+8>>2]](w),y(w)}k=T0(n,16),X[i[e+208>>2]+98>>1]=k,k=T0(n,16),X[i[e+208>>2]+100>>1]=k}if(h){k=C(144),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=97668,S=e,q=R3(k+16|0),i[S+216>>2]=q,h=i[e+220>>2],i[e+220>>2]=k;f:{if(!h||(k=i[h+4>>2],i[h+4>>2]=k-1,k))break f;W[i[i[h>>2]+8>>2]](h),y(h)}k=c1(n),X[i[e+216>>2]+100>>1]=k,k=c1(n),X[i[e+216>>2]+106>>1]=k,k=c1(n),X[i[e+216>>2]+102>>1]=k,k=c1(n),X[i[e+216>>2]+108>>1]=k,k=c1(n),X[i[e+216>>2]+104>>1]=k,k=c1(n),X[i[e+216>>2]+110>>1]=k,k=c1(n),X[i[e+216>>2]+112>>1]=k,k=c1(n),X[i[e+216>>2]+114>>1]=k,k=T0(n,32),i[i[e+216>>2]+116>>2]=k,k=T0(n,32),i[i[e+216>>2]+120>>2]=k}f:{if(!o)break f;k=C(168),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=114156,S=e,q=Lo(k+16|0),i[S+224>>2]=q,o=i[e+228>>2],i[e+228>>2]=k;A:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break A;W[i[i[o>>2]+8>>2]](o),y(o)}if(m2(n,2),k=U2(n),m=U2(n),G=U2(n),B=U2(n),m2(n,2),k&&(_=m8(n),l=m8(n),w=m8(n),h=m8(n),o=m8(n),k=m8(n),Es(i[e+224>>2],_,l,w,h,o,k)),m&&(o=i[e+224>>2],k=T0(n,32),t[o+128|0]=1,i[o+124>>2]=k),G&&(o=i[e+224>>2],k=T0(n,32),t[o+136|0]=1,i[o+132>>2]=k),!B)break f;o=i[e+224>>2],k=T0(n,32),t[o+144|0]=1,i[o+140>>2]=k}if(I){k=C(128),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=97708,S=e,q=Dl(k+16|0),i[S+232>>2]=q,o=i[e+236>>2],i[e+236>>2]=k;f:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break f;W[i[i[o>>2]+8>>2]](o),y(o)}k=T0(n,32),i[i[e+232>>2]+100>>2]=k,k=c1(n),X[i[e+232>>2]+104>>1]=k,k=c1(n),X[i[e+232>>2]+106>>1]=k}if(u[e+204|0]==1&&(m2(n,32),m2(n,16),m2(n,16),m2(n,32),m2(n,16),m2(n,16)),u[e+205|0]!=1)break r;m2(n,32)}r:{if(!(t[e+106|0]&1|(u[e+104|0]|t[e+105|0]&1))&&(l=10,!(t[e+140|0]&1)|u[e+103|0]!=1))break r;l=U2(n)?20:10}k=U2(n),h=U2(n),u[e+104|0]==1&&(N=T0(n,l)+1|0),B=u[e+140|0],_=u[e+103|0],!(t[e+159|0]&1)|(!(B&1)|(_|0)!=1)||(U=T0(n,l)+1|0,_=u[e+103|0],B=u[e+140|0]),!(_&1)|!(B&1)||(Y=T0(n,l),B=u[e+140|0],_=u[e+103|0]);r:{if(!(_&1&(B&1))){o=i[e+352>>2];break r}o=T0(n,h?28:15),i[e+352>>2]=o,_=u[e+103|0],B=u[e+140|0]}w=k?12:3,G=0;r:{if(!(_&1)||(G=0,!(B&1))||(G=0,!o))break r;G=T0(n,w)}E=T0(n,w),k=h?28:15,S=e,q=T0(n,k)+1|0,i[S+336>>2]=q;r:{if(u[e+101|0]!=1||(k=T0(n,k),i[e+320>>2]=k,!k|!(t[e+101|0]&1)))break r;R=T0(n,w)}r:{if(!(u[e+105|0]|t[e+106|0]&1)||(S=e,q=U2(n),t[S+107|0]=q,!(t[e+105|0]&1)))break r;S=e,q=T0(n,l)+1|0,i[S+368>>2]=q}u[e+106|0]==1&&(S=e,q=T0(n,l)+1|0,i[S+384>>2]=q),k=i[n+24>>2],i[n+24>>2]=k&-8,w=k&7,o=i[n+20>>2],l=i[n+16>>2],_=w&31,k=n,(w&63)>>>0>=32?(h=l<<_,o=0):(h=(1<<_)-1&l>>>32-_|o<<_,o=l<<_),i[n+16>>2]=o,i[k+20>>2]=h,h=0,o=i[e+336>>2]+E|0,h=o>>>0<E>>>0?1:h,k=h,B=u[e+101|0];r:{if((B|0)!=1||(w=i[e+320>>2],!w))break r;o=o+R|0,k=o>>>0<R>>>0?k+1|0:k,h=o,o=o+w|0,k=h>>>0>o>>>0?k+1|0:k}I=u[e+103|0]&u[e+140|0],x=I&1;r:{if(!x||(h=i[e+352>>2],!h))break r;o=o+G|0,k=o>>>0<G>>>0?k+1|0:k,w=o,o=o+h|0,k=w>>>0>o>>>0?k+1|0:k}h=i[n+24>>2],m=h>>31,l=h,h=i[n+12>>2],w=h,h=h>>31<<3|h>>>29,w=w<<3,_=l+w|0,h=h+m|0,h=w>>>0>_>>>0?h+1|0:h,w=h;r:{if((h|0)>0|(h|0)>=0&&(j=u[e+104|0],l=o+(j?N:0)|0,o=l>>>0<o>>>0?k+1|0:k,k=l+Y|0,h=k>>>0<Y>>>0?o+1|0:o,I=I&u[e+159|0],m=I&1?U:0,O=m+k|0,k=h,h=u[e+105|0]?i[e+368>>2]:0,l=h+(x?O:l)|0,m=x?m>>>0>O>>>0?k+1|0:k:o,m=l>>>0<h>>>0?m+1|0:m,o=u[e+106|0]?i[e+384>>2]:0,h=o+l|0,k=m,l=h,o=o>>>0>l>>>0?k+1|0:k,k=w>>>3|0,(o|0)==(k|0)&((w&7)<<29|_>>>3)>>>0>=l>>>0|k>>>0>o>>>0))break r;if(e=C(72),i[s+84>>2]=e,i[s+88>>2]=67,i[s+92>>2]=-2147483576,z(e,28886,67),t[e+67|0]=0,a(A,2,149,s+84|0),t[s+95|0]>=0)break e;Z(i[s+84>>2]);break e}r:{if(!f||(f=i[f+32>>2],!f))break r;if(!(!j|f>>>0>=N>>>0)){if(e=A,A=V2(s+84|0,12764),a(e,2,1e3,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}if((I^-1|f>>>0>=U>>>0)&1)break r;if(e=A,A=V2(s+84|0,12755),a(e,2,1e3,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}E&&(Yi(s+84|0,n,E),f=i[e+264>>2],f&&(i[e+268>>2]=f,Z(f)),i[e+264>>2]=i[s+84>>2],i[e+268>>2]=i[s+88>>2],i[e+272>>2]=i[s+92>>2],B=u[e+101|0]);r:{if(!(B&1)|!i[e+320>>2])break r;if(!R){k=i[e+264>>2],f=i[e+268>>2],$4(e+240|0,k,f,f-k|0);break r}Yi(s+84|0,n,R),f=i[e+240>>2],f&&(i[e+244>>2]=f,Z(f)),i[e+240>>2]=i[s+84>>2],i[e+244>>2]=i[s+88>>2],i[e+248>>2]=i[s+92>>2]}r:{if(!i[e+352>>2]|(!(t[e+140|0]&1)|u[e+103|0]!=1))break r;if(!G){k=i[e+264>>2],f=i[e+268>>2],$4(e+252|0,k,f,f-k|0);break r}Yi(s+84|0,n,G),f=i[e+252>>2],f&&(i[e+256>>2]=f,Z(f)),i[e+252>>2]=i[s+84>>2],i[e+256>>2]=i[s+88>>2],i[e+260>>2]=i[s+92>>2]}u[e+104|0]==1&&(Yi(s+84|0,n,N),f=i[e+276>>2],f&&(i[e+280>>2]=f,Z(f)),i[e+276>>2]=i[s+84>>2],i[e+280>>2]=i[s+88>>2],i[e+284>>2]=i[s+92>>2]),f=u[e+103|0];r:{f:{if(!(!(t[e+159|0]&1)|(!(t[e+140|0]&1)|(f|0)!=1))){if(Yi(s+84|0,n,U),f=i[e+288>>2],f&&(i[e+292>>2]=f,Z(f)),i[e+288>>2]=i[s+84>>2],i[e+292>>2]=i[s+88>>2],i[e+296>>2]=i[s+92>>2],t[e+103|0]&1)break f;break r}if(!f)break r}if(!Y|!(t[e+140|0]&1)||(Yi(s+84|0,n,Y),f=i[e+300>>2],f&&(i[e+304>>2]=f,Z(f),i[e+308>>2]=0,i[e+300>>2]=0,i[e+304>>2]=0),i[e+300>>2]=i[s+84>>2],i[e+304>>2]=i[s+88>>2],i[e+308>>2]=i[s+92>>2],i[s+92>>2]=0,i[s+84>>2]=0,i[s+88>>2]=0,f=i[s+84>>2],!f))break r;i[s+88>>2]=f,Z(f)}r:{if(u[e+101|0]!=1||(k=i[e+320>>2],!k))break r;f=(i[n+8>>2]-i[n+12>>2]|0)+(i[n+24>>2]/-8|0)|0,o=f+Q|0,m=(f>>31)+V|0,i[e+312>>2]=o,i[e+316>>2]=f>>>0>o>>>0?m+1|0:m,c6(n,k)}r:{if(!(t[e+140|0]&1)|u[e+103|0]!=1||(k=i[e+352>>2],!k))break r;f=(i[n+8>>2]-i[n+12>>2]|0)+(i[n+24>>2]/-8|0)|0,o=f+Q|0,h=(f>>31)+V|0,i[e+344>>2]=o,i[e+348>>2]=f>>>0>o>>>0?h+1|0:h,c6(n,k)}if(f=(i[n+8>>2]-i[n+12>>2]|0)+(i[n+24>>2]/-8|0)|0,o=f+Q|0,k=(f>>31)+V|0,i[e+328>>2]=o,i[e+332>>2]=f>>>0>o>>>0?k+1|0:k,c6(n,i[e+336>>2]),u[e+105|0]==1&&(f=(i[n+8>>2]-i[n+12>>2]|0)+(i[n+24>>2]/-8|0)|0,o=f+Q|0,k=(f>>31)+V|0,i[e+360>>2]=o,i[e+364>>2]=f>>>0>o>>>0?k+1|0:k,c6(n,i[e+368>>2])),u[e+106|0]==1&&(f=(i[n+8>>2]-i[n+12>>2]|0)+(i[n+24>>2]/-8|0)|0,o=f+Q|0,k=(f>>31)+V|0,i[e+376>>2]=o,i[e+380>>2]=f>>>0>o>>>0?k+1|0:k,c6(n,i[e+384>>2])),u[r+20|0]==1){if(t[s+84|0]=0,t[s+95|0]=0,a(A,2,100,s+84|0),t[s+95|0]>=0)break e;Z(i[s+84>>2]);break e}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break e}T(e,i[28730],i[28731])}if(A=i[s+64>>2],!A)break i;Z(A)}k1(s+76|0),v=s+96|0}function C9(A,e,r,f,k,n){var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;B=v-192|0,v=B,W[i[i[e>>2]+164>>2]](A,e,r,f,k,n);i:{e:{r:{if(u[A+44|0])break r;Mn(B+180|0,r,k,n,i[k+4>>2]),k=i[B+180>>2],n=i[B+184>>2],bn(A,i[A+4>>2],k,n,n-k>>3),k=i[r>>2],s=i[k+192>>2],l=i[k+188>>2],k=i[A+28>>2],i[B+176>>2]=k,i[B+172>>2]=i[A+32>>2];f:{if(k)break f;A:{if(k=i[f>>2],i[k>>2]<3||(k=i[k+112>>2],!k))break A;W[k|0](i[f+4>>2],l,s,B+176|0,B+172|0);break f}i[B+172>>2]=s,i[B+176>>2]=l}G=C(128),f=G,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=96348,w=f+16|0,f=w,i[f+8>>2]=0,i[f+12>>2]=0,f=G,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,X[f+112>>1]=0,i[f+16>>2]=93816,i[f+32>>2]=1769173093,k=i[B+176>>2],i[f+124>>2]=i[B+172>>2],i[f+120>>2]=k,Q=f,V=W[i[i[e>>2]+84>>2]](e)|0,t[Q+112|0]=V,i[f+4>>2]=i[f+4>>2]+1,k=i[A+4>>2],o=i[A+8>>2];f:{if(k>>>0<o>>>0){i[k+4>>2]=f,i[k>>2]=w,k=k+8|0;break f}if(n=i[A>>2],f=k-n|0,_=f>>3,k=_+1|0,k>>>0>=536870912)break i;if(o=o-n|0,h=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<h>>>0?h:k,o){if(o>>>0>=536870912)break e;k=C(o<<3)}else k=0;if(h=k+f|0,i[h+4>>2]=G,i[h>>2]=w,w=h-(_<<3)|0,f&&z(w,n,f),i[A+8>>2]=k+(o<<3),k=h+8|0,i[A+4>>2]=k,i[A>>2]=w,!n)break f;Z(n)}i[A+4>>2]=k;f:{if((l|0)==i[B+176>>2]&(s|0)==i[B+172>>2])break f;n=C(152),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=96508,h=n+16|0,f=h,i[f+8>>2]=0,i[f+12>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,i[n+16>>2]=92500,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,t[n+112|0]=0,i[n+16>>2]=94204,i[n+140>>2]=0,i[n+144>>2]=1,i[n+132>>2]=0,i[n+136>>2]=1,i[n+124>>2]=0,i[n+128>>2]=1,i[n+116>>2]=0,i[n+120>>2]=1,i[n+32>>2]=1668047216,o=i[B+176>>2],f=i[B+172>>2],i[n+124>>2]=s,i[n+128>>2]=1,i[n+116>>2]=l,i[n+120>>2]=1,f=s-f|0,k=f-65537>>>0<4294836223,i[n+140>>2]=0|(k?(f|0)/2|0:f),i[n+144>>2]=k?1:2,f=l-o|0,k=f-65537>>>0<4294836223,i[n+132>>2]=0|(k?(f|0)/2|0:f),i[n+136>>2]=k?1:2,i[n+4>>2]=i[n+4>>2]+1,f=i[A+4>>2],l=i[A+8>>2];A:{if(f>>>0<l>>>0){i[f+4>>2]=n,i[f>>2]=h,f=f+8|0;break A}if(s=i[A>>2],f=f-s|0,w=f>>3,k=w+1|0,k>>>0>=536870912)break i;if(l=l-s|0,o=l>>2,l=l>>>0>=2147483640?536870911:k>>>0<o>>>0?o:k,l){if(l>>>0>=536870912)break e;k=C(l<<3)}else k=0;if(o=k+f|0,i[o+4>>2]=n,i[o>>2]=h,h=o-(w<<3)|0,f&&z(h,s,f),i[A+8>>2]=k+(l<<3),f=o+8|0,i[A+4>>2]=f,i[A>>2]=h,!s)break A;Z(s)}if(i[A+4>>2]=f,f=i[n+4>>2],i[n+4>>2]=f-1,f)break f;W[i[i[n>>2]+8>>2]](n),y(n)}k=i[r>>2],f=i[k+200>>2],k=i[k+196>>2],h=C(136),i[h>>2]=97428,i[h+4>>2]=0,i[h+8>>2]=0,n=h+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=92500,i[h+60>>2]=0,i[h+64>>2]=0,i[h+52>>2]=0,i[h+56>>2]=0,i[h+72>>2]=-1,i[h+76>>2]=-1,i[h+80>>2]=-1,i[h+84>>2]=-1,i[h+116>>2]=0,i[h+88>>2]=0,i[h+92>>2]=0,i[h+96>>2]=0,i[h+100>>2]=0,i[h+104>>2]=0,i[h+108>>2]=0,X[h+112>>1]=0,i[n>>2]=95004,i[h+128>>2]=0,i[h+120>>2]=0,i[h+124>>2]=0,i[h+32>>2]=1885960297;f:{A:{k:{n:switch(k|0){case 2:if(l=K0(i[r>>2],0),l>>>0>255)break f;if(f=i[h+124>>2],o=i[h+128>>2],f>>>0<o>>>0){t[f|0]=l,f=f+1|0;break k}if(s=i[h+120>>2],f=f-s|0,k=f+1|0,(k|0)<0)break i;if(o=o-s|0,w=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<w>>>0?w:k,o?k=C(o):k=0,w=k+f|0,t[w|0]=l,f&&z(k,s,f),i[h+128>>2]=k+o,f=w+1|0,i[h+124>>2]=f,i[h+120>>2]=k,!s)break k;Z(s);break k;case 0:if(l=K0(i[r>>2],0),l>>>0<=255){if(f=i[h+124>>2],o=i[h+128>>2],f>>>0<o>>>0){t[f|0]=l,f=f+1|0;break k}if(s=i[h+120>>2],f=f-s|0,k=f+1|0,(k|0)<0)break i;if(o=o-s|0,w=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<w>>>0?w:k,o?k=C(o):k=0,w=k+f|0,t[w|0]=l,f&&z(k,s,f),i[h+128>>2]=k+o,f=w+1|0,i[h+124>>2]=f,i[h+120>>2]=k,!s)break k;Z(s);break k}if(l=K0(i[r>>2],1),l>>>0<=255){if(f=i[h+124>>2],o=i[h+128>>2],f>>>0<o>>>0){t[f|0]=l,f=f+1|0;break k}if(s=i[h+120>>2],f=f-s|0,k=f+1|0,(k|0)<0)break i;if(o=o-s|0,w=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<w>>>0?w:k,o?k=C(o):k=0,w=k+f|0,t[w|0]=l,f&&z(k,s,f),i[h+128>>2]=k+o,f=w+1|0,i[h+124>>2]=f,i[h+120>>2]=k,!s)break k;Z(s);break k}if(l=K0(i[r>>2],2),l>>>0>255)break f;if(f=i[h+124>>2],o=i[h+128>>2],f>>>0<o>>>0){t[f|0]=l,f=f+1|0;break k}if(s=i[h+120>>2],f=f-s|0,k=f+1|0,(k|0)<0)break i;if(o=o-s|0,w=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<w>>>0?w:k,o?k=C(o):k=0,w=k+f|0,t[w|0]=l,f&&z(k,s,f),i[h+128>>2]=k+o,f=w+1|0,i[h+124>>2]=f,i[h+120>>2]=k,!s)break k;Z(s);break k;case 1:break n;default:break f}if(f-10>>>0>=6){if((f|0)!=3)break f;if(_5(n,K0(i[r>>2],3))||_5(n,K0(i[r>>2],4))||_5(n,K0(i[r>>2],5)))break A;break f}if(l=K0(i[r>>2],10),l>>>0>255)break f;if(f=i[h+124>>2],o=i[h+128>>2],f>>>0<o>>>0){t[f|0]=l,f=f+1|0;break k}if(s=i[h+120>>2],f=f-s|0,k=f+1|0,(k|0)<0)break i;if(o=o-s|0,w=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<w>>>0?w:k,o?k=C(o):k=0,w=k+f|0,t[w|0]=l,f&&z(k,s,f),i[h+128>>2]=k+o,f=w+1|0,i[h+124>>2]=f,i[h+120>>2]=k,!s)break k;Z(s)}i[h+124>>2]=f}i[h+4>>2]=i[h+4>>2]+1,f=i[A+4>>2],l=i[A+8>>2];A:{if(f>>>0<l>>>0){i[f+4>>2]=h,i[f>>2]=n,f=f+8|0;break A}if(s=i[A>>2],f=f-s|0,w=f>>3,k=w+1|0,k>>>0>=536870912)break i;if(l=l-s|0,o=l>>2,l=l>>>0>=2147483640?536870911:k>>>0<o>>>0?o:k,l){if(l>>>0>=536870912)break e;k=C(l<<3)}else k=0;if(o=k+f|0,i[o+4>>2]=h,i[o>>2]=n,n=o-(w<<3)|0,f&&z(n,s,f),i[A+8>>2]=k+(l<<3),f=o+8|0,i[A+4>>2]=f,i[A>>2]=n,!s)break A;Z(s)}i[A+4>>2]=f}f=i[r>>2],s=B+8|0,i[s>>2]=101648,k=i[f+8>>2],i[s+4>>2]=i[f+4>>2],i[s+8>>2]=k,t[s+12|0]=u[f+12|0],i[s+16>>2]=i[f+16>>2],k=i[f+20>>2],i[s+20>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),k=i[f+28>>2],i[s+24>>2]=i[f+24>>2],i[s+28>>2]=k,i[s- -64>>2]=i[f- -64>>2],k=i[f+60>>2],i[s+56>>2]=i[f+56>>2],i[s+60>>2]=k,k=i[f+52>>2],i[s+48>>2]=i[f+48>>2],i[s+52>>2]=k,k=i[f+44>>2],i[s+40>>2]=i[f+40>>2],i[s+44>>2]=k,k=i[f+36>>2],i[s+32>>2]=i[f+32>>2],i[s+36>>2]=k,k=s+68|0;f:{if(t[f+79|0]>=0){n=i[f+72>>2],i[k>>2]=i[f+68>>2],i[k+4>>2]=n,i[k+8>>2]=i[f+76>>2];break f}T(k,i[f+68>>2],i[f+72>>2])}if(i[s+88>>2]=0,i[s+80>>2]=0,i[s+84>>2]=0,k=i[f+80>>2],w=i[f+84>>2],(k|0)!=(w|0)){if(l=w-k|0,(l|0)/44>>>0>=97612894)break i;for(n=C(l),i[s+84>>2]=n,i[s+80>>2]=n,i[s+88>>2]=n+l;;){l=i[k+4>>2],i[n>>2]=i[k>>2],i[n+4>>2]=l,l=u[k+25|0]|u[k+26|0]<<8|(u[k+27|0]<<16|u[k+28|0]<<24),o=u[k+21|0]|u[k+22|0]<<8|(u[k+23|0]<<16|u[k+24|0]<<24),t[n+21|0]=o,t[n+22|0]=o>>>8,t[n+23|0]=o>>>16,t[n+24|0]=o>>>24,t[n+25|0]=l,t[n+26|0]=l>>>8,t[n+27|0]=l>>>16,t[n+28|0]=l>>>24,l=i[k+20>>2],i[n+16>>2]=i[k+16>>2],i[n+20>>2]=l,l=i[k+12>>2],i[n+8>>2]=i[k+8>>2],i[n+12>>2]=l,l=n+32|0;f:{if(t[k+43|0]>=0){o=i[k+36>>2],i[l>>2]=i[k+32>>2],i[l+4>>2]=o,i[l+8>>2]=i[k+40>>2];break f}T(l,i[k+32>>2],i[k+36>>2])}if(n=n+44|0,k=k+44|0,(w|0)==(k|0))break}i[s+84>>2]=n}if(k=i[f+92>>2],t[s+112|0]=0,t[s+96|0]=0,i[s+92>>2]=k,u[f+112|0]==1){if(k=i[f+96>>2],i[s+108>>2]=0,i[s+100>>2]=0,i[s+104>>2]=0,i[s+96>>2]=k,k=i[f+104>>2],l=i[f+100>>2],(k|0)!=(l|0)){if(k=k-l|0,(k|0)<0)break i;n=C(k),i[s+104>>2]=n,i[s+100>>2]=n,o=k+n|0,i[s+108>>2]=o,k&&z(n,l,k),i[s+104>>2]=o}t[s+112|0]=1}if(i[s+124>>2]=0,i[s+116>>2]=0,i[s+120>>2]=0,n=i[f+116>>2],l=i[f+120>>2],(n|0)!=(l|0)){if(o=l-n|0,(o|0)/28>>>0>=153391690)break i;for(k=C(o),i[s+120>>2]=k,i[s+116>>2]=k,i[s+124>>2]=k+o;Se(k,n),k=k+28|0,n=n+28|0,(l|0)!=(n|0););i[s+120>>2]=k}if(i[s+136>>2]=0,i[s+128>>2]=0,i[s+132>>2]=0,k=i[f+128>>2],l=i[f+132>>2],(k|0)!=(l|0)){if(o=l-k|0,(o|0)/52>>>0>=82595525)break i;for(n=C(o),i[s+132>>2]=n,i[s+128>>2]=n,i[s+136>>2]=n+o;n=Re(n,k)+52|0,k=k+52|0,(l|0)!=(k|0););i[s+132>>2]=n}i[s+148>>2]=0,i[s+140>>2]=0,i[s+144>>2]=0;f:{if(k=i[f+140>>2],l=i[f+144>>2],(k|0)!=(l|0)){if(o=l-k|0,(o|0)/48>>>0>=89478486)break i;for(n=C(o),i[s+144>>2]=n,i[s+140>>2]=n,i[s+148>>2]=n+o;n=Ue(n,k)+48|0,k=k+48|0,(l|0)!=(k|0););i[s+144>>2]=n}k=i[f+156>>2],i[s+152>>2]=i[f+152>>2],i[s+156>>2]=k,i[s+160>>2]=i[f+160>>2],f=s;break f}l=f,f=i[f+8>>2],i[e+4>>2]=i[l+4>>2],i[e+8>>2]=f,t[e+12|0]=u[l+12|0],f=i[l+16>>2],k=i[l+20>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+16>>2]=f,f=i[e+20>>2],i[e+20>>2]=k;f:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[l+28>>2],i[e+24>>2]=i[l+24>>2],i[e+28>>2]=f,i[e- -64>>2]=i[l- -64>>2],f=i[l+60>>2],i[e+56>>2]=i[l+56>>2],i[e+60>>2]=f,f=i[l+52>>2],i[e+48>>2]=i[l+48>>2],i[e+52>>2]=f,f=i[l+44>>2],i[e+40>>2]=i[l+40>>2],i[e+44>>2]=f,f=i[l+36>>2],i[e+32>>2]=i[l+32>>2],i[e+36>>2]=f;f:{if((e|0)==(l|0)){i[e+92>>2]=i[l+92>>2],y3(e+96|0,l+96|0);break f}k=l+68|0,f=e+68|0,n=t[l+79|0];A:{if(t[e+79|0]>=0){if((n|0)>=0){n=i[k+4>>2],i[f>>2]=i[k>>2],i[f+4>>2]=n,i[f+8>>2]=i[k+8>>2];break A}m1(f,i[l+68>>2],i[l+72>>2]);break A}o=f,f=(n|0)<0,R1(o,f?i[l+68>>2]:k,f?i[l+72>>2]:n)}f=i[l+80>>2],n=f;A:{if(w=i[l+84>>2],_=(w-f|0)/44|0,o=i[e+88>>2],k=i[e+80>>2],_>>>0<=(o-k|0)/44>>>0){if(f=i[e+84>>2],o=f-k|0,_>>>0>(o|0)/44>>>0){if(o=n+o|0,(f|0)!=(k|0)){for(;;){f=i[n+4>>2],i[k>>2]=i[n>>2],i[k+4>>2]=f,f=u[n+25|0]|u[n+26|0]<<8|(u[n+27|0]<<16|u[n+28|0]<<24),_=u[n+21|0]|u[n+22|0]<<8|(u[n+23|0]<<16|u[n+24|0]<<24),t[k+21|0]=_,t[k+22|0]=_>>>8,t[k+23|0]=_>>>16,t[k+24|0]=_>>>24,t[k+25|0]=f,t[k+26|0]=f>>>8,t[k+27|0]=f>>>16,t[k+28|0]=f>>>24,f=i[n+20>>2],i[k+16>>2]=i[n+16>>2],i[k+20>>2]=f,f=i[n+12>>2],i[k+8>>2]=i[n+8>>2],i[k+12>>2]=f;k:{if((k|0)==(n|0))break k;if(_=n+32|0,f=k+32|0,m=t[n+43|0],t[k+43|0]>=0){if((m|0)>=0){m=i[_+4>>2],i[f>>2]=i[_>>2],i[f+4>>2]=m,i[f+8>>2]=i[_+8>>2];break k}m1(f,i[n+32>>2],i[n+36>>2]);break k}I=f,f=(m|0)<0,R1(I,f?i[n+32>>2]:_,f?i[n+36>>2]:m)}if(k=k+44|0,n=n+44|0,(o|0)==(n|0))break}f=i[e+84>>2]}if(n=f,(o|0)!=(w|0))for(;;){k=o,_=i[k+4>>2],i[n>>2]=i[k>>2],i[n+4>>2]=_,_=u[k+25|0]|u[k+26|0]<<8|(u[k+27|0]<<16|u[k+28|0]<<24),m=u[k+21|0]|u[k+22|0]<<8|(u[k+23|0]<<16|u[k+24|0]<<24),t[n+21|0]=m,t[n+22|0]=m>>>8,t[n+23|0]=m>>>16,t[n+24|0]=m>>>24,t[n+25|0]=_,t[n+26|0]=_>>>8,t[n+27|0]=_>>>16,t[n+28|0]=_>>>24,_=i[k+20>>2],i[n+16>>2]=i[k+16>>2],i[n+20>>2]=_,_=i[k+12>>2],i[n+8>>2]=i[k+8>>2],i[n+12>>2]=_,_=n+32|0;k:{if(t[k+43|0]>=0){m=i[k+36>>2],i[_>>2]=i[k+32>>2],i[_+4>>2]=m,i[_+8>>2]=i[k+40>>2];break k}T(_,i[o+32>>2],i[o+36>>2])}if(n=n+44|0,o=o+44|0,(w|0)==(o|0))break}i[e+84>>2]=(n-f|0)+f;break A}if((n|0)!=(w|0)){for(;;){f=i[n+4>>2],i[k>>2]=i[n>>2],i[k+4>>2]=f,f=u[n+25|0]|u[n+26|0]<<8|(u[n+27|0]<<16|u[n+28|0]<<24),o=u[n+21|0]|u[n+22|0]<<8|(u[n+23|0]<<16|u[n+24|0]<<24),t[k+21|0]=o,t[k+22|0]=o>>>8,t[k+23|0]=o>>>16,t[k+24|0]=o>>>24,t[k+25|0]=f,t[k+26|0]=f>>>8,t[k+27|0]=f>>>16,t[k+28|0]=f>>>24,f=i[n+20>>2],i[k+16>>2]=i[n+16>>2],i[k+20>>2]=f,f=i[n+12>>2],i[k+8>>2]=i[n+8>>2],i[k+12>>2]=f;k:{if((k|0)==(n|0))break k;if(o=n+32|0,f=k+32|0,_=t[n+43|0],t[k+43|0]>=0){if((_|0)>=0){_=i[o+4>>2],i[f>>2]=i[o>>2],i[f+4>>2]=_,i[f+8>>2]=i[o+8>>2];break k}m1(f,i[n+32>>2],i[n+36>>2]);break k}I=f,f=(_|0)<0,R1(I,f?i[n+32>>2]:o,f?i[n+36>>2]:_)}if(k=k+44|0,n=n+44|0,(w|0)==(n|0))break}f=i[e+84>>2]}if((f|0)!=(k|0))for(;t[f-1|0]<0&&Z(i[f-12>>2]),f=f-44|0,(k|0)!=(f|0););i[e+84>>2]=k;break A}if(k){if(f=k,o=i[e+84>>2],(f|0)!=(o|0)){for(;t[o-1|0]<0&&Z(i[o-12>>2]),o=o-44|0,(o|0)!=(k|0););f=i[e+80>>2]}i[e+84>>2]=k,Z(f),i[e+88>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,o=0}k:{if(_>>>0>=97612894||(f=(o|0)/44|0,k=f<<1,f=f>>>0>=48806446?97612893:k>>>0>_>>>0?k:_,f>>>0>=97612894))break k;if(f=g(f,44),k=C(f),i[e+84>>2]=k,i[e+80>>2]=k,i[e+88>>2]=f+k,(n|0)!=(w|0))for(;;){f=i[n+4>>2],i[k>>2]=i[n>>2],i[k+4>>2]=f,f=u[n+25|0]|u[n+26|0]<<8|(u[n+27|0]<<16|u[n+28|0]<<24),o=u[n+21|0]|u[n+22|0]<<8|(u[n+23|0]<<16|u[n+24|0]<<24),t[k+21|0]=o,t[k+22|0]=o>>>8,t[k+23|0]=o>>>16,t[k+24|0]=o>>>24,t[k+25|0]=f,t[k+26|0]=f>>>8,t[k+27|0]=f>>>16,t[k+28|0]=f>>>24,f=i[n+20>>2],i[k+16>>2]=i[n+16>>2],i[k+20>>2]=f,f=i[n+12>>2],i[k+8>>2]=i[n+8>>2],i[k+12>>2]=f,f=k+32|0;n:{if(t[n+43|0]>=0){o=i[n+36>>2],i[f>>2]=i[n+32>>2],i[f+4>>2]=o,i[f+8>>2]=i[n+40>>2];break n}T(f,i[n+32>>2],i[n+36>>2])}if(k=k+44|0,n=n+44|0,(w|0)==(n|0))break}i[e+84>>2]=k;break A}s0(),M()}i[e+92>>2]=i[l+92>>2],y3(e+96|0,l+96|0),f=i[l+116>>2],k=i[l+120>>2],MA(e+116|0,f,k,(k-f|0)/28|0),f=i[l+128>>2],k=i[l+132>>2],e5(e+128|0,f,k,(k-f|0)/52|0),f=i[l+140>>2],k=i[l+144>>2],EA(e+140|0,f,k,(k-f|0)/48|0)}if(f=i[l+156>>2],i[e+152>>2]=i[l+152>>2],i[e+156>>2]=f,i[e+160>>2]=i[l+160>>2],Ee(l),tA(s,i[r>>2],0),r=A,f=i[A+4>>2],A=i[B+8>>2],e=i[B+12>>2],bn(r,f,A,e,e-A>>3),e=i[B+8>>2],e){if(A=i[B+12>>2],r=e,(A|0)!=(e|0)){for(;;){r=i[A-4>>2];f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=A-8|0,(e|0)==(A|0))break}r=i[B+8>>2]}i[B+12>>2]=e,Z(r)}if(A=i[h+4>>2],i[h+4>>2]=A-1,A||(W[i[i[h>>2]+8>>2]](h),y(h)),A=i[G+4>>2],i[G+4>>2]=A-1,A||(W[i[i[G>>2]+8>>2]](G),y(G)),e=i[B+180>>2],!e)break r;if(A=i[B+184>>2],r=e,(A|0)!=(e|0)){for(;;){r=i[A-4>>2];f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=A-8|0,(e|0)==(A|0))break}r=i[B+180>>2]}i[B+184>>2]=e,Z(r)}v=B+192|0;return}x0(),M()}s0(),M()}function nA(A,e,r,f,k,n){var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0;w=v-16|0,v=w,o=C(248),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=101168,l0(o+16|0,0,156),i[o+76>>2]=0,i[o+80>>2]=0,i[o+36>>2]=1,i[o+40>>2]=1,t[o+24|0]=1,X[o+22>>1]=2,X[o+18>>1]=2,X[o+20>>1]=2,i[o+84>>2]=0,i[o+88>>2]=0,i[o+92>>2]=0,i[o+96>>2]=0,i[o+128>>2]=0,i[o+132>>2]=0,i[o+100>>2]=0,i[o+104>>2]=1,i[o+136>>2]=0,i[o+140>>2]=0,i[o+144>>2]=0,i[o+148>>2]=0,i[o+152>>2]=0,i[o+156>>2]=0,X[o+158>>1]=0,X[o+160>>1]=0,X[o+162>>1]=0,X[o+164>>1]=0,i[o+184>>2]=0,i[o+188>>2]=0,i[o+172>>2]=255,i[o+192>>2]=0,i[o+196>>2]=5186,i[o+208>>2]=99,i[o+212>>2]=99,i[o+200>>2]=0,i[o+204>>2]=0,i[o+12>>2]=101488,i[o+216>>2]=0,i[o+220>>2]=0,i[o+224>>2]=0,i[o+228>>2]=0,i[o+232>>2]=0,i[o+236>>2]=0,i[o+240>>2]=0,i[o+244>>2]=0,l=o+12|0,i[o+176>>2]=l,i[o+8>>2]=i[o+8>>2]+1,i[o+180>>2]=o,i[o+4>>2]==-1&&(W[i[i[o>>2]+8>>2]](o),y(o)),i[r>>2]=l,s=i[r+4>>2],i[r+4>>2]=o;i:{if(!s||(l=i[s+4>>2],i[s+4>>2]=l-1,l))break i;W[i[i[s>>2]+8>>2]](s),y(s)}l=i[e+200>>2],s=i[r>>2],m=i[e+196>>2],i[s+196>>2]=m,i[s+192>>2]=k,i[s+188>>2]=f,i[s+200>>2]=(m|0)==1?l||3:l;i:{e:{r:{f:{A:{k:{n:{t:{o:{l:{u:{s:{if(o=i[e+204>>2],_=i[e+208>>2],(o|0)!=(_|0)){for(l=o;;){if(i[l>>2]==10){h:{w:{for(;;){if(i[o>>2]==10)break w;if(o=o+56|0,(_|0)==(o|0))break}o=0;break h}o=p[o+20>>1]}if(a0(A,s,10,f,k,o,n,0),i[A>>2])break i;if(t[A+19|0]>=0)break r;Z(i[A+8>>2]);break r}if(l=l+56|0,(_|0)==(l|0))break}switch(l=o,h=o,m|0){case 0:break l;case 1:break s;case 2:break t;default:break u}}switch(m|0){case 1:break e;case 2:break n;case 0:break o;default:break u}}for(;;){if(i[l>>2]!=3){if(l=l+56|0,(_|0)!=(l|0))continue;break e}break}for(l=o;;){if(i[l>>2]==4){l=o;s:{for(;;){h:{if(i[l>>2]==5){for(;;){if(i[o>>2]==3)break h;if(o=o+56|0,(_|0)==(o|0))break}o=0;break s}if(l=l+56|0,(_|0)!=(l|0))continue;break e}break}o=p[o+20>>1]}if(a0(A,s,3,f,k,o,n,0),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),h=i[r>>2],l=i[e+204>>2],o=i[e+208>>2],s=0;s:{if((l|0)==(o|0))break s;h:{for(;;){if(i[l>>2]==4)break h;if(l=l+56|0,(o|0)==(l|0))break}s=0;break s}s=p[l+20>>1]}if(a0(A,h,4,f,k,s,n,0),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),h=i[r>>2],l=i[e+204>>2],o=i[e+208>>2],s=0;s:{if((l|0)==(o|0))break s;h:{for(;;){if(i[l>>2]==5)break h;if(l=l+56|0,(o|0)==(l|0))break}s=0;break s}s=p[l+20>>1]}if(a0(A,h,5,f,k,s,n,0),i[A>>2])break i;if(t[A+19|0]>=0)break f;Z(i[A+8>>2]);break f}if(l=l+56|0,(_|0)==(l|0))break}break e}if(e=C(32),i[w+4>>2]=e,i[w+8>>2]=27,i[w+12>>2]=-2147483616,f=u[9027]|u[9028]<<8|(u[9029]<<16|u[9030]<<24),r=u[9023]|u[9024]<<8|(u[9025]<<16|u[9026]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+27|0]=0,r=u[9046]|u[9047]<<8|(u[9048]<<16|u[9049]<<24),t[e+23|0]=r,t[e+24|0]=r>>>8,t[e+25|0]=r>>>16,t[e+26|0]=r>>>24,f=u[9043]|u[9044]<<8|(u[9045]<<16|u[9046]<<24),r=u[9039]|u[9040]<<8|(u[9041]<<16|u[9042]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[9035]|u[9036]<<8|(u[9037]<<16|u[9038]<<24),r=u[9031]|u[9032]<<8|(u[9033]<<16|u[9034]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,0,w+4|0),t[w+15|0]>=0)break i;Z(i[w+4>>2]);break i}for(;;){if(i[h>>2]){if(h=h+56|0,(_|0)!=(h|0))continue;break o}break}for(;;){if(i[l>>2]==1){for(;;){if(i[o>>2]!=2){if(o=o+56|0,(_|0)!=(o|0))continue;break o}break}L3(f,k,1,i[e+200>>2],w+4|0,w),h=i[r>>2],l=i[e+204>>2],o=i[e+208>>2],s=0;l:{if((l|0)==(o|0))break l;u:{for(;;){if(!i[l>>2])break u;if(l=l+56|0,(o|0)==(l|0))break}s=0;break l}s=p[l+20>>1]}if(a0(A,h,0,f,k,s,n,0),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),h=i[r>>2],m=i[w+4>>2],_=i[w>>2],l=i[e+204>>2],o=i[e+208>>2],s=0;l:{if((l|0)==(o|0))break l;u:{for(;;){if(i[l>>2]==1)break u;if(l=l+56|0,(o|0)==(l|0))break}s=0;break l}s=p[l+20>>1]}if(a0(A,h,1,m,_,s,n,0),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),h=i[r>>2],m=i[w+4>>2],_=i[w>>2],l=i[e+204>>2],o=i[e+208>>2],s=0;l:{if((l|0)==(o|0))break l;u:{for(;;){if(i[l>>2]==2)break u;if(l=l+56|0,(o|0)==(l|0))break}s=0;break l}s=p[l+20>>1]}if(a0(A,h,2,m,_,s,n,0),l=i[A>>2],!(l|t[A+19|0]>=0)){Z(i[A+8>>2]);break f}if(l)break i;break f}if(l=l+56|0,(_|0)==(l|0))break}}if(e=C(40),i[w+4>>2]=e,i[w+8>>2]=34,i[w+12>>2]=-2147483608,f=u[5814]|u[5815]<<8|(u[5816]<<16|u[5817]<<24),r=u[5810]|u[5811]<<8|(u[5812]<<16|u[5813]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+34|0]=0,r=u[5842]|u[5843]<<8,t[e+32|0]=r,t[e+33|0]=r>>>8,f=u[5838]|u[5839]<<8|(u[5840]<<16|u[5841]<<24),r=u[5834]|u[5835]<<8|(u[5836]<<16|u[5837]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[5830]|u[5831]<<8|(u[5832]<<16|u[5833]<<24),r=u[5826]|u[5827]<<8|(u[5828]<<16|u[5829]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[5822]|u[5823]<<8|(u[5824]<<16|u[5825]<<24),r=u[5818]|u[5819]<<8|(u[5820]<<16|u[5821]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,0,w+4|0),t[w+15|0]>=0)break i;Z(i[w+4>>2]);break i}for(;;){if(!i[h>>2]){for(;;){if(!i[o>>2])break k;if(o=o+56|0,(_|0)==(o|0))break}l=0;break A}if(h=h+56|0,(_|0)==(h|0))break}}if(e=C(40),i[w+4>>2]=e,i[w+8>>2]=32,i[w+12>>2]=-2147483608,f=u[14089]|u[14090]<<8|(u[14091]<<16|u[14092]<<24),r=u[14085]|u[14086]<<8|(u[14087]<<16|u[14088]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+32|0]=0,f=u[14113]|u[14114]<<8|(u[14115]<<16|u[14116]<<24),r=u[14109]|u[14110]<<8|(u[14111]<<16|u[14112]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[14105]|u[14106]<<8|(u[14107]<<16|u[14108]<<24),r=u[14101]|u[14102]<<8|(u[14103]<<16|u[14104]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[14097]|u[14098]<<8|(u[14099]<<16|u[14100]<<24),r=u[14093]|u[14094]<<8|(u[14095]<<16|u[14096]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,0,w+4|0),t[w+15|0]>=0)break i;Z(i[w+4>>2]);break i}l=p[o+20>>1]}if(a0(A,s,0,f,k,l,n,0),i[A>>2])break i;if(t[A+19|0]>=0)break f;Z(i[A+8>>2])}if(s=i[e+204>>2],o=i[e+208>>2],(s|0)==(o|0))break r;for(l=s;;){if(i[l>>2]!=6){if(l=l+56|0,(o|0)!=(l|0))continue;break r}break}l=i[r>>2];f:{A:{for(;;){if(i[s>>2]==6)break A;if(s=s+56|0,(o|0)==(s|0))break}o=0;break f}o=p[s+20>>1]}if(a0(A,l,6,f,k,o,n,0),i[A>>2])break i;if(t[A+19|0]>=0)break r;Z(i[A+8>>2])}O=i[e+208>>2],s=i[e+204>>2],n=1;r:{f:switch(i[e+200>>2]){case 10:case 12:case 14:n=3;break r;case 11:case 13:case 15:n=4;break r;case 0:case 1:case 2:case 3:case 99:break r;default:break f}n=0}r:{f:{if(G=n,n>>>0>=2){h=0;A:{if((s|0)==(O|0))break A;for(;;){if(i[s>>2]==10){h=s;break A}if(s=s+56|0,(O|0)==(s|0))break}}if(r=i[r>>2],s=i[r+204>>2],n=i[r+208>>2],(s|0)==(n|0))break r;o=s;A:{k:{for(;;){if(i[o>>2]==10)break k;if(o=o+56|0,(n|0)==(o|0))break}m=0;break A}m=i[o+24>>2]}o=s;A:{k:{for(;;){if(i[o>>2]==10)break k;if(o=o+56|0,(n|0)==(o|0))break}r=0;break A}r=i[o+28>>2]}if(U=i[h+40>>2],R=i[h+52>>2],p[h+20>>1]>8)break f;A:{k:{for(;;){if(i[s>>2]==10)break k;if(s=s+56|0,(n|0)==(s|0))break}h=0,s=0;break A}h=i[s+40>>2],s=i[s+52>>2]}if(!r)break r;for(o=r,r=f,V=((G>>>0<=1?1:G)|0)!=1,Y=(G|0)==2,E=(G|0)==3;;){if(m)for(x=g(s,B)+h|0,_=U+g(O1(L0(B,I,i[e+192>>2],0),h0,k,0),R)|0,l=0,f=0;;){Q=g(l,G)+x|0,n=g(O1(L0(l,f,i[e+188>>2],0),h0,r,0),G)+_|0,t[Q|0]=u[n|0];A:{if(!V||(t[Q+1|0]=u[n+1|0],Y)||(t[Q+2|0]=u[n+2|0],E))break A;t[Q+3|0]=u[n+3|0]}if(l=l+1|0,n=l?f:f+1|0,f=n,!((l|0)!=(m|0)|f))break}if(f=I,B=B+1|0,f=B?f:f+1|0,I=f,!((o|0)!=(B|0)|f))break}break r}if((s|0)==(O|0))break r;for(Y=f,x=k;;){A:{k:{if(f=i[r>>2],h=i[f+204>>2],n=i[f+208>>2],(h|0)!=(n|0))for(k=i[s>>2],l=h;;){if((k|0)==i[l>>2]){for(l=h;;){if((k|0)==i[l>>2])break k;if(l=l+56|0,(n|0)==(l|0))break}V=0;break A}if(l=l+56|0,(n|0)==(l|0))break}if(e=C(40),i[w+4>>2]=e,i[w+8>>2]=35,i[w+12>>2]=-2147483608,f=u[14053]|u[14054]<<8|(u[14055]<<16|u[14056]<<24),r=u[14049]|u[14050]<<8|(u[14051]<<16|u[14052]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+35|0]=0,r=u[14080]|u[14081]<<8|(u[14082]<<16|u[14083]<<24),t[e+31|0]=r,t[e+32|0]=r>>>8,t[e+33|0]=r>>>16,t[e+34|0]=r>>>24,f=u[14077]|u[14078]<<8|(u[14079]<<16|u[14080]<<24),r=u[14073]|u[14074]<<8|(u[14075]<<16|u[14076]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[14069]|u[14070]<<8|(u[14071]<<16|u[14072]<<24),r=u[14065]|u[14066]<<8|(u[14067]<<16|u[14068]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[14061]|u[14062]<<8|(u[14063]<<16|u[14064]<<24),r=u[14057]|u[14058]<<8|(u[14059]<<16|u[14060]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,0,w+4|0),t[w+15|0]>=0)break i;Z(i[w+4>>2]);break i}V=i[l+24>>2]}l=h;A:{k:{for(;;){if((k|0)==i[l>>2])break k;if(l=l+56|0,(n|0)==(l|0))break}f=0;break A}f=i[l+28>>2]}q=i[s+40>>2],Q=i[s+52>>2];A:{if(p[s+20>>1]<=8){k:{n:{for(;;){if((k|0)==i[h>>2])break n;if(h=h+56|0,(n|0)==(h|0))break}_=0,o=0;break k}_=i[h+40>>2],o=i[h+52>>2]}if(!f)break A;for(U=V&-2,R=V&1,m=f,B=0,I=0,E=(V|0)!=1;;){k:{if(!V)break k;if(N=_+g(o,B)|0,j=q+g(O1(L0(B,I,i[e+192>>2],0),h0,x,0),Q)|0,l=0,f=0,h=0,n=0,E)for(;d=l+N|0,c=u[O1(L0(l,f,i[e+188>>2],0),h0,Y,0)+j|0],t[d|0]=c,G=l|1,k=O1(L0(G,f,i[e+188>>2],0),h0,Y,0),t[G+N|0]=u[k+j|0],l=l+2|0,f=l>>>0<2?f+1|0:f,h=h+2|0,n=h>>>0<2?n+1|0:n,!!((h|0)!=(U|0)|n););if(!R)break k;d=l+N|0,c=u[O1(L0(l,f,i[e+188>>2],0),h0,Y,0)+j|0],t[d|0]=c}if(B=B+1|0,I=B?I:I+1|0,!((B|0)!=(m|0)|I))break}break A}k:{n:{for(;;){if((k|0)==i[h>>2])break n;if(h=h+56|0,(n|0)==(h|0))break}G=0,o=0;break k}G=i[h+40>>2],o=i[h+52>>2]>>>1|0}if(!f)break A;for(Q=Q>>>1|0,U=V&-2,R=V&1,_=f,E=i[e+188>>2],m=i[e+192>>2],B=0,I=0;;){k:{if(!V)break k;if(S=G+(g(o,B)<<1)|0,N=q+(g(O1(L0(B,I,m,0),h0,x,0),Q)<<1)|0,l=0,f=0,h=0,n=0,(V|0)!=1)for(;d=S+(l<<1)|0,c=p[N+(O1(L0(l,f,E,0),h0,Y,0)<<1)>>1],X[d>>1]=c,j=l|1,k=O1(L0(E,0,j,f),h0,Y,0),X[S+(j<<1)>>1]=p[N+(k<<1)>>1],l=l+2|0,f=l>>>0<2?f+1|0:f,h=h+2|0,k=h>>>0<2?n+1|0:n,n=k,!!((h|0)!=(U|0)|n););if(!R)break k;d=S+(l<<1)|0,c=p[N+(O1(L0(l,f,E,0),h0,Y,0)<<1)>>1],X[d>>1]=c}if(B=B+1|0,I=B?I:I+1|0,!((_|0)!=(B|0)|I))break}}if(s=s+56|0,(O|0)==(s|0))break}break r}f:{A:{for(;;){if(i[s>>2]==10)break A;if(s=s+56|0,(n|0)==(s|0))break}_=0,h=0;break f}_=i[s+40>>2],h=i[s+52>>2]>>>1|0}if(!r)break r;for(R=R>>>1|0,s=r,o=f,n=i[e+188>>2],r=k,e=i[e+192>>2],V=((G>>>0<=1?1:G)|0)!=1,Y=(G|0)==3;;){if(m)for(E=_+(g(h,B)<<1)|0,x=U+(g(O1(L0(B,I,e,0),h0,r,0),R)<<1)|0,l=0,f=0;;){Q=E+(g(l,G)<<1)|0,k=x+(g(O1(L0(l,f,n,0),h0,o,0),G)<<1)|0,X[Q>>1]=p[k>>1];f:{if(!V||(X[Q+2>>1]=p[k+2>>1],(G|0)==2)||(X[Q+4>>1]=p[k+4>>1],Y))break f;X[Q+6>>1]=p[k+6>>1]}if(l=l+1|0,f=l?f:f+1|0,!((l|0)!=(m|0)|f))break}if(k=I,B=B+1|0,k=B?k:k+1|0,I=k,!((s|0)!=(B|0)|k))break}}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731]);break i}if(e=C(32),i[w+4>>2]=e,i[w+8>>2]=31,i[w+12>>2]=-2147483616,f=u[5849]|u[5850]<<8|(u[5851]<<16|u[5852]<<24),r=u[5845]|u[5846]<<8|(u[5847]<<16|u[5848]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+31|0]=0,f=u[5872]|u[5873]<<8|(u[5874]<<16|u[5875]<<24),r=u[5868]|u[5869]<<8|(u[5870]<<16|u[5871]<<24),t[e+23|0]=r,t[e+24|0]=r>>>8,t[e+25|0]=r>>>16,t[e+26|0]=r>>>24,t[e+27|0]=f,t[e+28|0]=f>>>8,t[e+29|0]=f>>>16,t[e+30|0]=f>>>24,f=u[5865]|u[5866]<<8|(u[5867]<<16|u[5868]<<24),r=u[5861]|u[5862]<<8|(u[5863]<<16|u[5864]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[5857]|u[5858]<<8|(u[5859]<<16|u[5860]<<24),r=u[5853]|u[5854]<<8|(u[5855]<<16|u[5856]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,0,w+4|0),t[w+15|0]>=0)break i;Z(i[w+4>>2])}v=w+16|0}function sv(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0;_=v-32|0,v=_;i:{e:{if(!A)break e;E=_+20|0,w=E,k=i[i[A>>2]+48>>2],l=v-176|0,v=l,i[l+120>>2]=0,i[l+92>>2]=78164,i[l+36>>2]=78144,f=i[19545],i[l+28>>2]=f,o=i[f-12>>2],G=l+28|0,f=G,i[o+f>>2]=i[19546],i[l+32>>2]=0,f=f+i[i[l+28>>2]-12>>2]|0,r=l+40|0,J0(f,r),t[f+80|0]=0,i[f+72>>2]=0,f=i[19547],i[l+36>>2]=f,n=l+36|0,i[n+i[f-12>>2]>>2]=i[19548],f=i[19544],i[l+28>>2]=f,i[G+i[f-12>>2]>>2]=i[19549],i[l+92>>2]=78164,i[l+28>>2]=78124,i[l+36>>2]=78144,G=R0(r),i[G>>2]=77200,i[l+80>>2]=0,i[l+84>>2]=0,i[l+72>>2]=0,i[l+76>>2]=0,i[l+88>>2]=24;r:{f:{A:{if(f=i[k+16>>2],B=i[k+20>>2],(f|0)!=(B|0)){for(r=1;k=i[f>>2],k&&(r||(F(n,47878,1),k=i[f>>2]),i[l+24>>2]=0,r=l+12|0,W[i[i[k>>2]+12>>2]](r,k,l+24|0),o=r,k=t[l+23|0],r=(k|0)<0,F(n,r?i[l+12>>2]:o,r?i[l+16>>2]:k),t[l+23|0]<0&&Z(i[l+12>>2]),r=0),f=f+8|0,(B|0)!=(f|0););if(f=i[l+88>>2],!(f&16))break A}f=i[l+84>>2],k=i[l+64>>2],f>>>0<k>>>0&&(i[l+84>>2]=k,f=k),k=l+60|0;break f}if(!(f&8)){f=0,t[w+11|0]=0;break r}f=i[l+56>>2],k=l+48|0}f:{if(n=i[k>>2],f=f-n|0,f>>>0<2147483640){if(f>>>0>=11){r=f|7,k=C(r+1|0),i[w+8>>2]=r-2147483647,i[w>>2]=k,i[w+4>>2]=f,w=k;break f}if(t[w+11|0]=f,f)break f;f=0;break r}break i}if(!f)break r;z(w,n,f)}t[f+w|0]=0,f=i[19543],i[l+28>>2]=f,i[i[f-12>>2]+(l+28|0)>>2]=i[19551],i[l+36>>2]=i[19552],i[G>>2]=77200,t[l+83|0]<0&&Z(i[l+72>>2]),y0(G),Y0(l+92|0),v=l+176|0,x=_+8|0,l=x,Q=i[i[A>>2]+48>>2],r=v-416|0,v=r,i[r+352>>2]=0,i[r+324>>2]=78164,i[r+268>>2]=78144,A=i[19545],i[r+260>>2]=A,k=i[A-12>>2],A=r+260|0,i[k+A>>2]=i[19546],i[r+264>>2]=0,f=A+i[i[r+260>>2]-12>>2]|0,w=r+272|0,J0(f,w),t[f+80|0]=0,i[f+72>>2]=0,f=i[19547],i[r+268>>2]=f,B=r+268|0,i[B+i[f-12>>2]>>2]=i[19548],f=i[19544],i[r+260>>2]=f,i[A+i[f-12>>2]>>2]=i[19549],i[r+324>>2]=78164,i[r+260>>2]=78124,i[r+268>>2]=78144,R=R0(w),i[R>>2]=77200,i[r+312>>2]=0,i[r+316>>2]=0,i[r+304>>2]=0,i[r+308>>2]=0,i[r+320>>2]=24,F(B,46862,18);r:{f:{A:{k:{if(w=i[Q+136>>2],j=Q+140|0,(w|0)==(j|0))break k;for(N=i[19664],O=N-12|0,U=i[19665],S=U-12|0,G=i[25322],q=i[25323],_0=r+128|0,g0=r+120|0,V=r+112|0,d=r+164|0,c=i[19667],A0=i[19666];;){A=i[i[w+20>>2]+112>>2];n:{if((A|0)!=1768912492){if((A|0)!=1735551332)break n;f=r+32|0,W6(f,Q,i[w+16>>2]);t:{if(A=u[r+52|0],!A){if(i[r+256>>2]=0,i[r+248>>2]=0,i[r+252>>2]=0,gA(r- -64|0,r+248|0,f),!i[r+64>>2]){F(B0(F(B,32799,9),i[w+16>>2]),46914,9),f=r+8|0,n=v-144|0,v=n,i[n+88>>2]=0,i[n+60>>2]=78468,A=i[19620],i[n+4>>2]=A,k=i[A-12>>2],A=n+4|0,i[k+A>>2]=i[19621],k=A+i[i[n+4>>2]-12>>2]|0,o=n+8|0,J0(k,o),t[k+80|0]=0,i[k+72>>2]=0,i[n+60>>2]=78468,i[n+4>>2]=78448,o=R0(o),i[o>>2]=77200,i[n+48>>2]=0,i[n+52>>2]=0,i[n+40>>2]=0,i[n+44>>2]=0,i[n+56>>2]=16,F(B0(F(F(B0(F(F(B0(F(F(B0(F(A,33590,6),p[r+248>>1]),47878,1),33774,9),p[r+250>>1]),47878,1),35129,14),i[r+252>>2]),47878,1),33345,15),i[r+256>>2]),47878,1),A=i[n+56>>2];o:{l:{if(A&16){A=i[n+52>>2],k=i[n+32>>2],A>>>0<k>>>0&&(i[n+52>>2]=k,A=k),k=n+28|0;break l}if(!(A&8)){A=0,t[f+11|0]=0;break o}A=i[n+24>>2],k=n+16|0}l:{if(s=i[k>>2],A=A-s|0,A>>>0<2147483640){if(A>>>0>=11){h=A|7,k=C(h+1|0),i[f+8>>2]=h-2147483647,i[f>>2]=k,i[f+4>>2]=A,f=k;break l}if(t[f+11|0]=A,A)break l;A=0;break o}break i}if(!A)break o;z(f,s,A)}for(t[A+f|0]=0,A=i[19619],i[n+4>>2]=A,i[i[A-12>>2]+(n+4|0)>>2]=i[19622],i[o>>2]=77200,t[n+51|0]<0&&Z(i[n+40>>2]),y0(o),Y0(n+60|0),v=n+144|0,i[r+164>>2]=78648,i[r+192>>2]=0,i[r+104>>2]=U,A=r+104|0,i[A+i[S>>2]>>2]=A0,i[r+108>>2]=0,A=A+i[i[r+104>>2]-12>>2]|0,J0(A,V),t[A+80|0]=0,i[A+72>>2]=0,i[r+164>>2]=78648,i[r+104>>2]=78628,I=R0(V),i[I>>2]=77200,i[r+152>>2]=i[r+16>>2],A=i[r+12>>2],i[r+144>>2]=i[r+8>>2],i[r+148>>2]=A,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+156>>2]=0,i[r+160>>2]=8,Yo(I),t[r+19|0]<0&&Z(i[r+8>>2]),i[r+96>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0;;){if(A=r+8|0,k=r+104|0,f=i[(k+i[i[r+104>>2]-12>>2]|0)+28>>2],i[A>>2]=f,(f|0)!=136824&&(i[f+4>>2]=i[f+4>>2]+1),f=$0(A,137008),f=W[i[i[f>>2]+28>>2]](f,10)|0,i2(A),u[lr(A,k)|0]==1){o:{if(t[r+99|0]<0){t[i[r+88>>2]]=0,i[r+92>>2]=0;break o}t[r+99|0]=0,t[r+88|0]=0}s=0,Y=f&255;o:{for(;;){A=i[i[i[r+104>>2]-12>>2]+_0>>2],f=i[A+12>>2];l:{u:{s:{h:{if((f|0)!=i[A+16>>2]){i[A+12>>2]=f+1,f=u[f|0];break h}if(f=W[i[i[A>>2]+40>>2]](A)|0,(f|0)==-1)break s}if(A=0,(Y|0)==(f&255))break o;k=t[r+99|0];h:{w:{_:{if((k|0)>=0){if(A=10,(k|0)!=10)break u;m=r+88|0,n=24;break _}if(A=i[r+92>>2],o=i[r+96>>2]&2147483647,k=o-1|0,(A|0)!=(k|0)){h=i[r+88>>2];break h}if((o|0)==2147483640)break i;if(n=2147483639,m=i[r+88>>2],k>>>0>1073741810){A=k;break w}if(!k){A=0,n=11;break _}A=k,n=A>>>0<6?11:(A<<1|7)+1|0}o=A+1|0}h=C(n),k=!A,k|k||z(h,m,A),(o|0)!=11&&Z(m),i[r+88>>2]=h,i[r+96>>2]=n|-2147483648}i[r+92>>2]=A+1;break l}A=s?2:6;break o}t[r+99|0]=k+1&127,h=r+88|0,A=k}if(s=s+1|0,A=A+h|0,t[A+1|0]=0,t[A|0]=f,!(i[r+92>>2]!=2147483639|t[r+99|0]>=0))break}A=4}f=i[i[r+104>>2]-12>>2]+(r+104|0)|0,M1(f,A|i[f+16>>2])}if(!(u[i[i[r+104>>2]-12>>2]+g0|0]&5)){h=X1(r+408|0,B);o:{if(u[h|0]!=1)break o;f=B+i[i[r+268>>2]-12>>2]|0,s=i[f+4>>2],n=i[f+24>>2];l:{if(u[f+80|0]==1){A=u[f+76|0]|u[f+77|0]<<8|(u[f+78|0]<<16|u[f+79|0]<<24);break l}k=r+8|0,A=i[f+28>>2],i[k>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),A=$0(k,137008),A=W[i[i[A>>2]+28>>2]](A,32)|0,i2(k),t[f+76|0]=A,t[f+77|0]=A>>>8,t[f+78|0]=A>>>16,t[f+79|0]=A>>>24,t[f+80|0]=1}l:{if(!n||(o=i[f+12>>2],s=(s&176)==32?37887:37885,k=s-37885|0,(k|0)>0&&(W[i[i[n>>2]+48>>2]](n,37885,k)|0)!=(k|0)))break l;if((o|0)>=3){if(o>>>0>=2147483642)break i;k=((o|0)<=2?2:o)-2|0;u:{if(o>>>0>=13){m=k|7,o=C(m+1|0),i[r+16>>2]=m-2147483647,i[r+8>>2]=o,i[r+12>>2]=k;break u}t[r+19|0]=k,o=r+8|0}if(k&&l0(o,A,k),t[k+o|0]=0,A=W[i[i[n>>2]+48>>2]](n,t[r+19|0]<0?i[r+8>>2]:r+8|0,k)|0,t[r+19|0]<0&&Z(i[r+8>>2]),(A|0)!=(k|0))break l}if(A=37887-s|0,(A|0)>0&&(W[i[i[n>>2]+48>>2]](n,s,A)|0)!=(A|0))break l;i[f+12>>2]=0;break o}A=B+i[i[r+268>>2]-12>>2]|0,M1(A,i[A+16>>2]|5)}v1(h),o=t[r+99|0],h=i[r+88>>2],m=i[r+92>>2],Y=X1(r+408|0,B);o:{if(u[Y|0]!=1)break o;f=B+i[i[r+268>>2]-12>>2]|0,X0=i[f+4>>2],n=i[f+24>>2];l:{if(u[f+80|0]==1){A=u[f+76|0]|u[f+77|0]<<8|(u[f+78|0]<<16|u[f+79|0]<<24);break l}k=r+8|0,A=i[f+28>>2],i[k>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),A=$0(k,137008),A=W[i[i[A>>2]+28>>2]](A,32)|0,i2(k),t[f+76|0]=A,t[f+77|0]=A>>>8,t[f+78|0]=A>>>16,t[f+79|0]=A>>>24,t[f+80|0]=1}l:{if(!n||(s=i[f+12>>2],k=h,h=(o|0)<0,k=h?k:r+88|0,o=h?m:o,t0=k+o|0,h=(X0&176)==32?t0:k,m=h-k|0,(m|0)>0&&(W[i[i[n>>2]+48>>2]](n,k,m)|0)!=(m|0)))break l;if(k=(o|0)<(s|0)?s-o|0:0,(k|0)>0){if(k>>>0>=2147483640)break i;u:{if(k>>>0>=11){o=k|7,s=C(o+1|0),i[r+16>>2]=o-2147483647,i[r+8>>2]=s,i[r+12>>2]=k;break u}t[r+19|0]=k,s=r+8|0}if(k&&l0(s,A,k),t[k+s|0]=0,A=W[i[i[n>>2]+48>>2]](n,t[r+19|0]<0?i[r+8>>2]:r+8|0,k)|0,t[r+19|0]<0&&Z(i[r+8>>2]),(A|0)!=(k|0))break l}if(A=t0-h|0,(A|0)>0&&(W[i[i[n>>2]+48>>2]](n,h,A)|0)!=(A|0))break l;i[f+12>>2]=0;break o}A=B+i[i[r+268>>2]-12>>2]|0,M1(A,i[A+16>>2]|5)}if(v1(Y),s=X1(r+408|0,B),u[s|0]==1){f=B+i[i[r+268>>2]-12>>2]|0,h=i[f+4>>2],n=i[f+24>>2];o:{if(u[f+80|0]==1){A=u[f+76|0]|u[f+77|0]<<8|(u[f+78|0]<<16|u[f+79|0]<<24);break o}k=r+8|0,A=i[f+28>>2],i[k>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),A=$0(k,137008),A=W[i[i[A>>2]+28>>2]](A,32)|0,i2(k),t[f+76|0]=A,t[f+77|0]=A>>>8,t[f+78|0]=A>>>16,t[f+79|0]=A>>>24,t[f+80|0]=1}o:{if(!n||(o=i[f+12>>2],h=(h&176)==32?47879:47878,k=h-47878|0,(k|0)>0&&(W[i[i[n>>2]+48>>2]](n,47878,k)|0)!=(k|0)))break o;if((o|0)>=2){if(o>>>0>=2147483641)break t;k=((o|0)<=1?1:o)-1|0;l:{if(o>>>0>=12){m=k|7,o=C(m+1|0),i[r+16>>2]=m-2147483647,i[r+8>>2]=o,i[r+12>>2]=k;break l}t[r+19|0]=k,o=r+8|0}if(k&&l0(o,A,k),t[k+o|0]=0,A=W[i[i[n>>2]+48>>2]](n,t[r+19|0]<0?i[r+8>>2]:r+8|0,k)|0,t[r+19|0]<0&&Z(i[r+8>>2]),(A|0)!=(k|0))break o}if(A=47879-h|0,(A|0)>0&&(W[i[i[n>>2]+48>>2]](n,h,A)|0)!=(A|0))break o;i[f+12>>2]=0,v1(s);continue}A=B+i[i[r+268>>2]-12>>2]|0,M1(A,i[A+16>>2]|5)}v1(s);continue}break}t[r+99|0]<0&&Z(i[r+88>>2]),i[r+104>>2]=N,i[i[O>>2]+(r+104|0)>>2]=c,i[I>>2]=77200,t[r+155|0]<0&&Z(i[r+144>>2]),y0(I),Y0(d),h=1}t[r+83|0]<0&&Z(i[r+72>>2]),A=u[r+52|0]}if(A=A&255,(A|0)==255)break n;i[r+104>>2]=G,i[r+108>>2]=q,W[i[(r+104|0)+(A<<2)>>2]](r- -64|0,r+32|0);break n}break i}if(A=i[Q+80>>2],!A)break n;if(d4(r+248|0,A,i[w+16>>2],1684630887),f=r- -64|0,W6(f,Q,i[w+16>>2]),A=u[r+84|0],!A){if(X[r+40>>1]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+60>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,O9(r+8|0,r+32|0,i[r+252>>2]-i[r+248>>2]>>2,f),!i[r+8>>2]){if(F(B0(F(B,32799,9),i[w+16>>2]),46904,9),f=r+88|0,n=v-160|0,v=n,i[n+104>>2]=0,i[n+76>>2]=78164,i[n+20>>2]=78144,A=i[19545],i[n+12>>2]=A,k=i[A-12>>2],o=n+12|0,A=o,i[k+A>>2]=i[19546],i[n+16>>2]=0,A=A+i[i[n+12>>2]-12>>2]|0,s=n+24|0,J0(A,s),t[A+80|0]=0,i[A+72>>2]=0,A=i[19547],i[n+20>>2]=A,k=n+20|0,i[k+i[A-12>>2]>>2]=i[19548],A=i[19544],i[n+12>>2]=A,i[o+i[A-12>>2]>>2]=i[19549],i[n+76>>2]=78164,i[n+12>>2]=78124,i[n+20>>2]=78144,o=R0(s),i[o>>2]=77200,A=n- -64|0,i[A>>2]=0,i[A+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,F(F(B0(F(B0(F(F(B0(F(B0(F(B0(F(B0(F(F(D0(F(F(D0(F(k,34691,9),u[r+32|0]),47878,1),33912,7),u[r+33|0]),47878,1),34204,18),p[r+34>>1]),22872,1),p[r+36>>1]),22872,1),p[r+38>>1]),22872,1),p[r+40>>1]),47878,1),35789,13),i[r+44>>2]),3179,1),i[r+48>>2]),47878,1),33666,9),A=i[r+52>>2],s=i[r+56>>2],(A|0)!=(s|0))for(;F(D0(F(D0(k,i[A+4>>2]),22872,1),i[A+8>>2]),37886,1),A=A+12|0,(s|0)!=(A|0););F(k,47878,1),A=i[n+72>>2];t:{o:{if(A&16){A=i[n+68>>2],k=i[n+48>>2],A>>>0<k>>>0&&(i[n+68>>2]=k,A=k),k=n+44|0;break o}if(!(A&8)){A=0,t[f+11|0]=0;break t}A=i[n+40>>2],k=n+32|0}o:{if(s=i[k>>2],A=A-s|0,A>>>0<2147483640){if(A>>>0>=11){h=A|7,k=C(h+1|0),i[f+8>>2]=h-2147483647,i[f>>2]=k,i[f+4>>2]=A,f=k;break o}if(t[f+11|0]=A,A)break o;A=0;break t}break i}if(!A)break t;z(f,s,A)}for(t[A+f|0]=0,A=i[19543],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[19551],i[n+20>>2]=i[19552],i[o>>2]=77200,t[n+67|0]<0&&Z(i[n+56>>2]),y0(o),Y0(n+76|0),v=n+160|0,i[r+164>>2]=78648,i[r+192>>2]=0,i[r+104>>2]=U,A=r+104|0,i[A+i[S>>2]>>2]=A0,i[r+108>>2]=0,A=A+i[i[r+104>>2]-12>>2]|0,J0(A,V),t[A+80|0]=0,i[A+72>>2]=0,i[r+164>>2]=78648,i[r+104>>2]=78628,n=R0(V),i[n>>2]=77200,i[r+152>>2]=i[r+96>>2],A=i[r+92>>2],i[r+144>>2]=i[r+88>>2],i[r+148>>2]=A,i[r+96>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+156>>2]=0,i[r+160>>2]=8,Yo(n),t[r+99|0]<0&&Z(i[r+88>>2]),i[r+96>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0;;){if(f=r+408|0,k=r+104|0,A=i[(k+i[i[r+104>>2]-12>>2]|0)+28>>2],i[f>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),A=$0(f,137008),o=W[i[i[A>>2]+28>>2]](A,10)|0,i2(f),A=r+88|0,s=0,h=v-16|0,v=h,u[lr(h+15|0,k)|0]==1){t:{if(t[A+11|0]<0){t[i[A>>2]]=0,i[A+4>>2]=0;break t}t[A+11|0]=0,t[A|0]=0}I=k+24|0,m=o&255;t:{o:{for(;;){f=i[I+i[i[k>>2]-12>>2]>>2],o=i[f+12>>2];l:{if((o|0)!=i[f+16>>2]){i[f+12>>2]=o+1,f=t[o|0];break l}if(f=W[i[i[f>>2]+40>>2]](f)|0,(f|0)==-1)break o}if(o=0,(m|0)==(f&255))break t;if(Ai(A,f<<24>>24),s=s+1|0,!(i[A+4>>2]!=2147483639|t[A+11|0]>=0))break}o=4;break t}o=s?2:6}f=k+i[i[k>>2]-12>>2]|0,M1(f,o|i[f+16>>2])}if(v=h+16|0,!(u[(k+i[i[k>>2]-12>>2]|0)+16|0]&5)){o=F(B,37885,2),k=A,A=t[r+99|0],f=(A|0)<0,F(F(o,f?i[r+88>>2]:k,f?i[r+92>>2]:A),47878,1);continue}break}t[r+99|0]<0&&Z(i[r+88>>2]),i[r+104>>2]=N,i[i[O>>2]+(r+104|0)>>2]=c,i[n>>2]=77200,t[r+155|0]<0&&Z(i[r+144>>2]),y0(n),Y0(d),h=1}t[r+27|0]<0&&Z(i[r+16>>2]),A=i[r+52>>2],A&&(i[r+56>>2]=A,Z(A)),A=u[r+84|0]}if(A=A&255,(A|0)!=255&&(i[r+104>>2]=G,i[r+108>>2]=q,W[i[(r+104|0)+(A<<2)>>2]](r+32|0,r- -64|0)),A=i[r+248>>2],!A)break n;i[r+252>>2]=A,Z(A)}f=i[w+4>>2];n:{if(f){for(;;)if(A=f,f=i[A>>2],!f)break n}for(;A=i[w+8>>2],f=i[A>>2]!=(w|0),w=A,!!f;);}if(w=A,(A|0)==(j|0))break}if(!(h&1))break k;A=i[r+320>>2];n:{if(A&16){f=r+292|0,w=i[r+316>>2],A=i[r+296>>2],w>>>0<A>>>0?i[r+316>>2]=A:A=w;break n}if(!(A&8)){A=0,t[l+11|0]=0;break f}f=r+280|0,A=i[r+288>>2]}if(w=i[f>>2],A=A-w|0,A>>>0>=2147483640)break i;if(A>>>0>=11){k=A|7,f=C(k+1|0),i[l+8>>2]=k-2147483647,i[l>>2]=f,i[l+4>>2]=A,l=f;break A}if(t[l+11|0]=A,A)break A;A=0;break f}i[l>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0;break r}if(!A)break f;z(l,w,A)}t[A+l|0]=0}if(A=i[19543],i[r+260>>2]=A,i[i[A-12>>2]+(r+260|0)>>2]=i[19551],i[r+268>>2]=i[19552],i[R>>2]=77200,t[r+315|0]<0&&Z(i[r+304>>2]),y0(R),Y0(r+324|0),v=r+416|0,A=t[_+19|0],((A|0)<0?i[_+12>>2]:A)&&(ae(E,47878,1),A=t[_+19|0],f=(A|0)<0,ae(E,f?i[_+8>>2]:x,f?i[_+12>>2]:A)),k=e,A=t[_+31|0],e=(A|0)<0,_s(k,e?i[_+20>>2]:_+20|0,e?i[_+24>>2]:A),t[_+19|0]<0&&Z(i[_+8>>2]),t[_+31|0]>=0)break e;Z(i[_+20>>2])}v=_+32|0;return}I0(),M()}function gi(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0;l=v-192|0,v=l;i:{e:{r:{f:{A:{if(w=i[e+104>>2],e=i[e+108>>2],(w|0)!=(e|0))for(;;){if(i[w>>2]==(r|0))break A;if(w=w+32|0,(e|0)==(w|0))break}i[l+136>>2]=0,i[l+108>>2]=78164,i[l+52>>2]=78144,e=i[19545],i[l+44>>2]=e,n=l+44|0,i[n+i[e-12>>2]>>2]=i[19546],i[l+48>>2]=0,e=n+i[i[l+44>>2]-12>>2]|0,k=l+56|0,J0(e,k),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[l+52>>2]=e,f=l+52|0,i[f+i[e-12>>2]>>2]=i[19548],e=i[19544],i[l+44>>2]=e,i[n+i[e-12>>2]>>2]=i[19549],i[l+108>>2]=78164,i[l+44>>2]=78124,i[l+52>>2]=78144,k=R0(k),i[k>>2]=77200,i[l+96>>2]=0,i[l+100>>2]=0,i[l+88>>2]=0,i[l+92>>2]=0,i[l+104>>2]=24,F(B0(F(f,32809,13),r),20598,23),e=i[l+104>>2];k:{if(e&16){w=i[l+100>>2],e=i[l+80>>2],w>>>0<e>>>0&&(i[l+100>>2]=e,w=e),e=l+76|0;break k}if(!(e&8)){w=0,t[l+43|0]=0,r=l+32|0;break r}w=i[l+72>>2],e=l- -64|0}if(f=i[e>>2],w=w-f|0,w>>>0>=2147483640)break i;if(w>>>0>=11){e=w|7,r=C(e+1|0),i[l+40>>2]=e-2147483647,i[l+32>>2]=r,i[l+36>>2]=w;break f}if(t[l+43|0]=w,r=l+32|0,w)break f;w=0;break r}e=-1,R=-1;A:{k:{n:{t:{o:{l:{if(r=i[w+16>>2],S=i[w+20>>2],(r|0)!=(S|0))for(;;){u:{s:{h:switch(u[w+4|0]){case 0:s=i[r+8>>2],h=i[r+12>>2],Q=h;w:{_:{if(h>>>0>8388607||(m=i[w+8>>2],h=i[w+12>>2],G=h,h>>>0>8388607))break _;if(h=i[r+16>>2],B=i[r+20>>2],_=B,_>>>0<8388608)break w}if(f=C(40),i[l+44>>2]=f,i[l+48>>2]=39,i[l+52>>2]=-2147483608,r=u[15368]|u[15369]<<8|(u[15370]<<16|u[15371]<<24),e=u[15364]|u[15365]<<8|(u[15366]<<16|u[15367]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+39|0]=0,r=u[15399]|u[15400]<<8|(u[15401]<<16|u[15402]<<24),e=u[15395]|u[15396]<<8|(u[15397]<<16|u[15398]<<24),t[f+31|0]=e,t[f+32|0]=e>>>8,t[f+33|0]=e>>>16,t[f+34|0]=e>>>24,t[f+35|0]=r,t[f+36|0]=r>>>8,t[f+37|0]=r>>>16,t[f+38|0]=r>>>24,r=u[15392]|u[15393]<<8|(u[15394]<<16|u[15395]<<24),e=u[15388]|u[15389]<<8|(u[15390]<<16|u[15391]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,t[f+28|0]=r,t[f+29|0]=r>>>8,t[f+30|0]=r>>>16,t[f+31|0]=r>>>24,r=u[15384]|u[15385]<<8|(u[15386]<<16|u[15387]<<24),e=u[15380]|u[15381]<<8|(u[15382]<<16|u[15383]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[15376]|u[15377]<<8|(u[15378]<<16|u[15379]<<24),e=u[15372]|u[15373]<<8|(u[15374]<<16|u[15375]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,a(A,2,1e3,l+44|0),t[l+55|0]>=0)break e;Z(i[l+44>>2]);break e}B=i[f>>2],V=G+Q|0,s=s+m|0,I=_+(s>>>0<m>>>0?V+1|0:V)|0,_=h,h=s+h|0,I=_>>>0>h>>>0?I+1|0:I;w:switch((W[i[i[B>>2]+12>>2]](B,h,I)|0)-1|0){case 1:i[n+4>>2]=i[n>>2],i[l+108>>2]=78164,i[l+136>>2]=0,i[l+52>>2]=78144,e=i[19545],i[l+44>>2]=e,n=l+44|0,i[n+i[e-12>>2]>>2]=i[19546],i[l+48>>2]=0,e=n+i[i[l+44>>2]-12>>2]|0,k=l+56|0,J0(e,k),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[l+52>>2]=e,f=l+52|0,i[f+i[e-12>>2]>>2]=i[19548],e=i[19544],i[l+44>>2]=e,i[n+i[e-12>>2]>>2]=i[19549],i[l+108>>2]=78164,i[l+44>>2]=78124,i[l+52>>2]=78144,n=R0(k),i[n>>2]=77200,i[l+96>>2]=0,i[l+100>>2]=0,i[l+88>>2]=0,i[l+92>>2]=0,i[l+104>>2]=24,f=F(F(f,31031,58),31445,25),B=i[w+12>>2]+i[r+12>>2]|0,e=i[r+8>>2],k=e+i[w+8>>2]|0,F(M2(f,k,e>>>0>k>>>0?B+1|0:B),47877,2),e=i[l+104>>2];_:{if(e&16){w=i[l+100>>2],e=i[l+80>>2],w>>>0<e>>>0&&(i[l+100>>2]=e,w=e),e=l+76|0;break _}if(!(e&8)){w=0,t[l+43|0]=0,r=l+32|0;break A}w=i[l+72>>2],e=l- -64|0}if(f=i[e>>2],w=w-f|0,w>>>0>=2147483640)break i;if(w>>>0>=11){e=w|7,r=C(e+1|0),i[l+40>>2]=e-2147483647,i[l+32>>2]=r,i[l+36>>2]=w;break k}if(t[l+43|0]=w,r=l+32|0,w)break k;w=0;break A;case 0:if(t[l+44|0]=0,t[l+55|0]=0,a(A,2,100,l+44|0),t[l+55|0]>=0)break e;Z(i[l+44>>2]);break e;default:break w}if(G=i[r+16>>2],_=i[r+20>>2],m=(j|0)==(_|0)&G>>>0<O>>>0|_>>>0<j>>>0,s=m?G:O,h=O-s|0,Q=m?_:j,B=Q,m=j-(B+(s>>>0>O>>>0)|0)|0,j=m,O=h,m|h||(h=G-s|0,B=_-((s>>>0>G>>>0)+B|0)|0,m=(R|0)==(B|0)&e>>>0<h>>>0|B>>>0>R>>>0,h=m?e:h,B=m?R:B,I=B,m=h,!(B|h)))break u;Y=i[n+4>>2]-i[n>>2]|0,B=i[o+44>>2],G=B;w:{if(h=i[o+40>>2],!(B|h)||(B=B-(h>>>0<Y>>>0)|0,(I|0)==(B|0)&m>>>0<=h-Y>>>0|B>>>0>I>>>0))break w;i[l+136>>2]=0,i[l+108>>2]=78164,i[l+52>>2]=78144,e=i[19545],i[l+44>>2]=e,n=l+44|0,i[n+i[e-12>>2]>>2]=i[19546],i[l+48>>2]=0,e=n+i[i[l+44>>2]-12>>2]|0,k=l+56|0,J0(e,k),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[l+52>>2]=e,f=l+52|0,i[f+i[e-12>>2]>>2]=i[19548],e=i[19544],i[l+44>>2]=e,i[n+i[e-12>>2]>>2]=i[19549],i[l+108>>2]=78164,i[l+44>>2]=78124,i[l+52>>2]=78144,k=R0(k),i[k>>2]=77200,i[l+96>>2]=0,i[l+100>>2]=0,i[l+88>>2]=0,i[l+92>>2]=0,i[l+104>>2]=24,f=F(M2(F(f,32605,19),i[r+16>>2],i[r+20>>2]),32425,35),V=i[r+20>>2],e=Y+i[r+16>>2]|0,V=e>>>0<Y>>>0?V+1|0:V,F(M2(F(M2(f,e,V),32112,40),h,G),5755,6),e=i[l+104>>2];_:{if(e&16){w=i[l+100>>2],e=i[l+80>>2],w>>>0<e>>>0&&(i[l+100>>2]=e,w=e),e=l+76|0;break _}if(!(e&8)){w=0,t[l+43|0]=0,r=l+32|0;break n}w=i[l+72>>2],e=l- -64|0}if(f=i[e>>2],w=w-f|0,w>>>0>=2147483640)break i;if(w>>>0>=11){e=w|7,r=C(e+1|0),i[l+40>>2]=e-2147483647,i[l+32>>2]=r,i[l+36>>2]=w;break t}if(t[l+43|0]=w,r=l+32|0,w)break t;w=0;break n}if(G=i[f>>2],_=i[w+8>>2],Q=Q+i[r+12>>2]|0,h=s+i[r+8>>2]|0,B=i[w+12>>2]+(h>>>0<s>>>0?Q+1|0:Q)|0,s=h,h=_+h|0,B=s>>>0>h>>>0?B+1|0:B,s=B+I|0,_=h+m|0,s=_>>>0<h>>>0?s+1|0:s,s=W[i[i[G>>2]+24>>2]](G,h,B,_,s)|0,_=i[f>>2],!(h0|s)){if(e=i[_+8>>2],i[A>>2]=i[_+4>>2],i[A+4>>2]=e,e=A+8|0,t[_+23|0]>=0){A=i[_+16>>2],i[e>>2]=i[_+12>>2],i[e+4>>2]=A,i[e+8>>2]=i[_+20>>2];break e}T(e,i[_+12>>2],i[_+16>>2]);break e}if(!(W[i[i[_>>2]+20>>2]](_,h,B)|0)){if(e=A,A=V2(l+44|0,8883),a(e,2,0,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(pl(n,m+Y|0),h=i[f>>2],W[i[i[h>>2]+16>>2]](h,Y+i[n>>2]|0,m)|0)break s;if(e=A,A=V2(l+44|0,14338),a(e,2,0,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e;case 1:if(N=i[k>>2],!N){if(f=C(56),i[l+44>>2]=f,i[l+48>>2]=54,i[l+52>>2]=-2147483592,r=u[14367]|u[14368]<<8|(u[14369]<<16|u[14370]<<24),e=u[14363]|u[14364]<<8|(u[14365]<<16|u[14366]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+54|0]=0,r=u[14413]|u[14414]<<8|(u[14415]<<16|u[14416]<<24),e=u[14409]|u[14410]<<8|(u[14411]<<16|u[14412]<<24),t[f+46|0]=e,t[f+47|0]=e>>>8,t[f+48|0]=e>>>16,t[f+49|0]=e>>>24,t[f+50|0]=r,t[f+51|0]=r>>>8,t[f+52|0]=r>>>16,t[f+53|0]=r>>>24,r=u[14407]|u[14408]<<8|(u[14409]<<16|u[14410]<<24),e=u[14403]|u[14404]<<8|(u[14405]<<16|u[14406]<<24),t[f+40|0]=e,t[f+41|0]=e>>>8,t[f+42|0]=e>>>16,t[f+43|0]=e>>>24,t[f+44|0]=r,t[f+45|0]=r>>>8,t[f+46|0]=r>>>16,t[f+47|0]=r>>>24,r=u[14399]|u[14400]<<8|(u[14401]<<16|u[14402]<<24),e=u[14395]|u[14396]<<8|(u[14397]<<16|u[14398]<<24),t[f+32|0]=e,t[f+33|0]=e>>>8,t[f+34|0]=e>>>16,t[f+35|0]=e>>>24,t[f+36|0]=r,t[f+37|0]=r>>>8,t[f+38|0]=r>>>16,t[f+39|0]=r>>>24,r=u[14391]|u[14392]<<8|(u[14393]<<16|u[14394]<<24),e=u[14387]|u[14388]<<8|(u[14389]<<16|u[14390]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,t[f+28|0]=r,t[f+29|0]=r>>>8,t[f+30|0]=r>>>16,t[f+31|0]=r>>>24,r=u[14383]|u[14384]<<8|(u[14385]<<16|u[14386]<<24),e=u[14379]|u[14380]<<8|(u[14381]<<16|u[14382]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[14375]|u[14376]<<8|(u[14377]<<16|u[14378]<<24),e=u[14371]|u[14372]<<8|(u[14373]<<16|u[14374]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,a(A,2,103,l+44|0),t[l+55|0]>=0)break e;Z(i[l+44>>2]);break e}U=l+12|0,s=i[r+8>>2],h=s+i[w+8>>2]|0,I=i[w+12>>2]+i[r+12>>2]|0,I=s>>>0>h>>>0?I+1|0:I,Y=h,m=i[r+16>>2],E=i[r+20>>2],_=v-160|0,v=_,x=i[n+4>>2]-i[n>>2]|0,s=i[o+44>>2],V=s;w:{_:{v:{B:{m:{g:{if(h=i[o+40>>2],!(s|h)||(s=s-(h>>>0<x>>>0)|0,(E|0)==(s|0)&m>>>0<=h-x>>>0|s>>>0>E>>>0))break g;i[_+104>>2]=0,i[_+76>>2]=78164,i[_+20>>2]=78144,s=i[19545],i[_+12>>2]=s,Q=_+12|0,i[Q+i[s-12>>2]>>2]=i[19546],i[_+16>>2]=0,s=Q+i[i[_+12>>2]-12>>2]|0,G=_+24|0,J0(s,G),t[s+80|0]=0,i[s+72>>2]=0,s=i[19547],i[_+20>>2]=s,B=_+20|0,i[B+i[s-12>>2]>>2]=i[19548],s=i[19544],i[_+12>>2]=s,i[Q+i[s-12>>2]>>2]=i[19549],i[_+76>>2]=78164,i[_+12>>2]=78124,i[_+20>>2]=78144,G=R0(G),i[G>>2]=77200,s=_- -64|0,i[s>>2]=0,i[s+4>>2]=0,i[_+56>>2]=0,i[_+60>>2]=0,i[_+72>>2]=24,B=F(M2(F(B,32585,19),m,E),32425,35),s=E,m=m+x|0,s=m>>>0<x>>>0?s+1|0:s,F(M2(F(M2(B,m,s),32112,40),h,V),5755,6),h=i[_+72>>2];Z:{if(h&16){s=_+44|0,h=i[_+68>>2],m=i[_+48>>2],h>>>0<m>>>0&&(i[_+68>>2]=m,h=m);break Z}if(!(h&8)){B=0,t[_+11|0]=0,s=_;break _}s=_+32|0,h=i[_+40>>2]}if(m=i[s>>2],B=h-m|0,B>>>0>=2147483640)break m;if(B>>>0>=11){h=B|7,s=C(h+1|0),i[_+8>>2]=h-2147483647,i[_>>2]=s,i[_+4>>2]=B;break v}if(t[_+11|0]=B,s=_,B)break v;B=0;break _}if(s=i[N+8>>2],Q=i[N+112>>2],G=s+Q|0,h=i[N+12>>2],q=i[N+116>>2],B=h+q|0,B=G>>>0<Q>>>0?B+1|0:B,(I|0)==(B|0)&G>>>0<Y>>>0|B>>>0<I>>>0){if(t[_+12|0]=0,t[_+23|0]=0,a(U,2,100,_+12|0),t[_+23|0]>=0)break w;Z(i[_+12>>2]);break w}g:{if((h|0)==(E|0)&s>>>0>=m>>>0|h>>>0>E>>>0&&(B=s,V=I+E|0,G=h,s=m+Y|0,V=s>>>0<Y>>>0?V+1|0:V,h=V,(G|0)==(h|0)&s>>>0<=B>>>0|G>>>0>h>>>0))break g;if(t[_+12|0]=0,t[_+23|0]=0,a(U,2,100,_+12|0),t[_+23|0]>=0)break w;Z(i[_+12>>2]);break w}if(B=i[f>>2],G=h+q|0,h=s+Q|0,G=h>>>0<s>>>0?G+1|0:G,((W[i[i[B>>2]+12>>2]](B,h,G)|0)-1&255)>>>0<=1){if(t[_+12|0]=0,t[_+23|0]=0,a(U,2,100,_+12|0),t[_+23|0]>=0)break w;Z(i[_+12>>2]);break w}if(B=i[f>>2],s=I+i[N+116>>2]|0,h=Y+i[N+112>>2]|0,s=h>>>0<Y>>>0?s+1|0:s,W[i[i[B>>2]+20>>2]](B,h,s)|0,m|E){I=m+x|0,s=i[n+4>>2],Q=i[n>>2],G=s-Q|0;g:{if(I>>>0>G>>>0){if(B=I-G|0,h=i[n+8>>2],B>>>0<=h-s>>>0){B&&l0(s,0,B),i[n+4>>2]=s+B;break g}if((I|0)<0)break B;if(s=h-Q|0,h=s<<1,h=s>>>0>=1073741823?2147483647:h>>>0>I>>>0?h:I,s=C(h),B&&l0(s+G|0,0,B),G&&z(s,Q,G),i[n+8>>2]=s+h,i[n+4>>2]=s+I,i[n>>2]=s,!Q)break g;Z(Q);break g}if(G>>>0<=I>>>0)break g;i[n+4>>2]=I+Q}h=i[f>>2],W[i[i[h>>2]+16>>2]](h,i[n>>2]+x|0,m)|0}if(h=i[28729],i[U>>2]=i[28728],i[U+4>>2]=h,s=U+8|0,t[114931]>=0){h=i[28731],i[s>>2]=i[28730],i[s+4>>2]=h,i[s+8>>2]=i[28732];break w}T(s,i[28730],i[28731]);break w}I0(),M()}s0(),M()}if(!B)break _;z(s,m,B)}t[s+B|0]=0,a(U,6,1e3,_),t[_+11|0]<0&&Z(i[_>>2]),h=i[19543],i[_+12>>2]=h,i[i[h-12>>2]+(_+12|0)>>2]=i[19551],i[_+20>>2]=i[19552],i[G>>2]=77200,t[_+67|0]<0&&Z(i[_+56>>2]),y0(G),Y0(_+76|0)}v=_+160|0,t[l+31|0]<0&&Z(i[l+20>>2]),h=e,s=i[r+16>>2],e=e-s|0,R=R-(i[r+20>>2]+(s>>>0>h>>>0)|0)|0;break u;default:break h}i[l+136>>2]=0,i[l+108>>2]=78164,i[l+52>>2]=78144,e=i[19545],i[l+44>>2]=e,k=l+44|0,i[k+i[e-12>>2]>>2]=i[19546],i[l+48>>2]=0,e=k+i[i[l+44>>2]-12>>2]|0,f=l+56|0,J0(e,f),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[l+52>>2]=e,r=l+52|0,i[r+i[e-12>>2]>>2]=i[19548],e=i[19544],i[l+44>>2]=e,i[k+i[e-12>>2]>>2]=i[19549],i[l+108>>2]=78164,i[l+44>>2]=78124,i[l+52>>2]=78144,k=R0(f),i[k>>2]=77200,i[l+96>>2]=0,i[l+100>>2]=0,i[l+88>>2]=0,i[l+92>>2]=0,i[l+104>>2]=24,F(D0(F(r,32461,25),u[w+4|0]),18156,16),e=i[l+104>>2];h:{if(e&16){w=i[l+100>>2],e=i[l+80>>2],w>>>0<e>>>0&&(i[l+100>>2]=e,w=e),e=l+76|0;break h}if(!(e&8)){w=0,t[l+43|0]=0,e=l+32|0;break o}w=i[l+72>>2],e=l- -64|0}if(f=i[e>>2],w=w-f|0,w>>>0>=2147483640)break i;if(w>>>0>=11){r=w|7,e=C(r+1|0),i[l+40>>2]=r-2147483647,i[l+32>>2]=e,i[l+36>>2]=w;break l}if(t[l+43|0]=w,e=l+32|0,w)break l;w=0;break o}h=e,e=e-m|0,R=R-((h>>>0<m>>>0)+I|0)|0,O=0,j=0}if(r=r+40|0,(S|0)==(r|0))break}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break e}T(e,i[28730],i[28731]);break e}if(!w)break o;z(e,f,w)}t[e+w|0]=0,a(A,4,3004,l+32|0),t[l+43|0]<0&&Z(i[l+32>>2]),A=i[19543],i[l+44>>2]=A,i[i[A-12>>2]+(l+44|0)>>2]=i[19551],i[l+52>>2]=i[19552],i[k>>2]=77200,t[l+99|0]<0&&Z(i[l+88>>2]),y0(k),Y0(l+108|0);break e}if(!w)break n;z(r,f,w)}t[r+w|0]=0,a(A,6,1e3,l+32|0),t[l+43|0]<0&&Z(i[l+32>>2]),A=i[19543],i[l+44>>2]=A,i[i[A-12>>2]+(l+44|0)>>2]=i[19551],i[l+52>>2]=i[19552],i[k>>2]=77200,t[l+99|0]<0&&Z(i[l+88>>2]),y0(k),Y0(l+108|0);break e}if(!w)break A;z(r,f,w)}t[r+w|0]=0,a(A,2,100,l+32|0),t[l+43|0]<0&&Z(i[l+32>>2]),A=i[19543],i[l+44>>2]=A,i[i[A-12>>2]+(l+44|0)>>2]=i[19551],i[l+52>>2]=i[19552],i[n>>2]=77200,t[l+99|0]<0&&Z(i[l+88>>2]),y0(n),Y0(l+108|0);break e}if(!w)break r;z(r,f,w)}t[r+w|0]=0,a(A,2,117,l+32|0),t[l+43|0]<0&&Z(i[l+32>>2]),A=i[19543],i[l+44>>2]=A,i[i[A-12>>2]+(l+44|0)>>2]=i[19551],i[l+52>>2]=i[19552],i[k>>2]=77200,t[l+99|0]<0&&Z(i[l+88>>2]),y0(k),Y0(l+108|0)}v=l+192|0;return}I0(),M()}function hv(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;V=v-32|0,v=V;i:{e:{if(!(!n|(!e|!r))&&o)break e;e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}e:{if(s=i[r>>2],!s)break e;if(w=Z0(s,107564,108732),w){G=i[r+4>>2],G&&(i[G+4>>2]=i[G+4>>2]+1),l=v-112|0,v=l,d9(l+100|0,i[w+180>>2],i[i[o>>2]+4>>2]),t[l+92|0]=0,i[l+72>>2]=0,i[l+76>>2]=0,r=i[l+100>>2],W[i[i[r>>2]+160>>2]](l- -64|0,r),r=i[w+644>>2],qA(l+16|0,i[l+64>>2],n,o,i[r+4>>2],r+16|0,i[w+180>>2]- -64|0),r=u[l+36|0];r:{if((r|0)==255){W[i[27186]](l,l+72|0),t[l+92|0]=255;break r}s=l+72|0,i[l+108>>2]=s,_=i[27189],i[l>>2]=i[27188],i[l+4>>2]=_,W[i[l+(r<<2)>>2]](l+108|0,s,l+16|0)}r=u[l+36|0],(r|0)!=255&&(s=i[27187],i[l>>2]=i[27186],i[l+4>>2]=s,W[i[l+(r<<2)>>2]](l+108|0,l+16|0)),_=V+12|0,t[l+36|0]=255,r=i[l+68>>2];r:{if(!r||(s=i[r+4>>2],i[r+4>>2]=s-1,s))break r;W[i[i[r>>2]+8>>2]](r),y(r)}r:{f:{A:{k:{n:{t:switch(u[l+92|0]){case 1:if(r=i[l+76>>2],i[_>>2]=i[l+72>>2],i[_+4>>2]=r,r=_+8|0,t[l+91|0]>=0){f=i[l+84>>2],i[r>>2]=i[l+80>>2],i[r+4>>2]=f,i[r+8>>2]=i[l+88>>2];break r}T(r,i[l+80>>2],i[l+84>>2]);break r;case 0:break t;default:break n}i[l+64>>2]=i[l+72>>2],r=i[l+76>>2],i[l+68>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),C9(l+16|0,i[l+100>>2],l- -64|0,o,i[w+644>>2],1);t:{o:switch(u[l+60|0]){case 1:if(r=i[l+20>>2],i[_>>2]=i[l+16>>2],i[_+4>>2]=r,r=_+8|0,t[l+35|0]<0)break t;f=i[l+28>>2],i[r>>2]=i[l+24>>2],i[r+4>>2]=f,i[r+8>>2]=i[l+32>>2];break f;case 0:break o;default:break n}if(r=i[w+180>>2],i[l>>2]=i[r+48>>2],r=i[r+52>>2],i[l+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),u[l+60|0])break n;w6(i[l>>2],i[w+196>>2],l+28|0,0),r=i[l+4>>2];o:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break o;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=i[n>>2],!(i[r+188>>2]==i[w+564>>2]&i[r+192>>2]==i[w+568>>2])){if(r=C(56),i[l>>2]=r,i[l+4>>2]=55,i[l+8>>2]=-2147483592,f=u[27341]|u[27342]<<8|(u[27343]<<16|u[27344]<<24),k=u[27337]|u[27338]<<8|(u[27339]<<16|u[27340]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+55|0]=0,f=u[27388]|u[27389]<<8|(u[27390]<<16|u[27391]<<24),k=u[27384]|u[27385]<<8|(u[27386]<<16|u[27387]<<24),t[r+47|0]=k,t[r+48|0]=k>>>8,t[r+49|0]=k>>>16,t[r+50|0]=k>>>24,t[r+51|0]=f,t[r+52|0]=f>>>8,t[r+53|0]=f>>>16,t[r+54|0]=f>>>24,f=u[27381]|u[27382]<<8|(u[27383]<<16|u[27384]<<24),k=u[27377]|u[27378]<<8|(u[27379]<<16|u[27380]<<24),t[r+40|0]=k,t[r+41|0]=k>>>8,t[r+42|0]=k>>>16,t[r+43|0]=k>>>24,t[r+44|0]=f,t[r+45|0]=f>>>8,t[r+46|0]=f>>>16,t[r+47|0]=f>>>24,f=u[27373]|u[27374]<<8|(u[27375]<<16|u[27376]<<24),k=u[27369]|u[27370]<<8|(u[27371]<<16|u[27372]<<24),t[r+32|0]=k,t[r+33|0]=k>>>8,t[r+34|0]=k>>>16,t[r+35|0]=k>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[27365]|u[27366]<<8|(u[27367]<<16|u[27368]<<24),k=u[27361]|u[27362]<<8|(u[27363]<<16|u[27364]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[27357]|u[27358]<<8|(u[27359]<<16|u[27360]<<24),k=u[27353]|u[27354]<<8|(u[27355]<<16|u[27356]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[27349]|u[27350]<<8|(u[27351]<<16|u[27352]<<24),k=u[27345]|u[27346]<<8|(u[27347]<<16|u[27348]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(_,5,0,l),t[l+11|0]>=0)break f;Z(i[l>>2]);break f}if(u[l+60|0])break n;o=i[w+632>>2],n=i[w+636>>2],h=i[l+32>>2]-i[l+28>>2]|0,r=v-160|0,v=r;o:{l:{u:{s:{h:{w:{_:{if(B=u[w+576|0],B>>>0>63||(I=o,s=B&31,(B&63)>>>0>=32?I=n>>>s|0:(Q=n>>>s|0,I=((1<<s)-1&n)<<32-s|I>>>s),!(I|Q)))break _;i[r+104>>2]=0,i[r+76>>2]=78164,i[r+20>>2]=78144,f=i[19545],i[r+12>>2]=f,k=i[f-12>>2],f=r+12|0,i[k+f>>2]=i[19546],i[r+16>>2]=0,k=f+i[i[r+12>>2]-12>>2]|0,s=r+24|0,J0(k,s),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[r+20>>2]=k,I=i[k-12>>2],k=r+20|0,i[I+k>>2]=i[19548],h=i[19544],i[r+12>>2]=h,i[f+i[h-12>>2]>>2]=i[19549],i[r+76>>2]=78164,i[r+12>>2]=78124,i[r+20>>2]=78144,s=R0(s),i[s>>2]=77200,f=r- -64|0,i[f>>2]=0,i[f+4>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+72>>2]=24,F(D0(F(M2(F(k,30882,12),o,n),32518,32),B),28290,91),f=i[r+72>>2];v:{if(f&16){k=i[r+68>>2],f=i[r+48>>2],k>>>0<f>>>0&&(i[r+68>>2]=f,k=f),f=r+44|0;break v}if(!(f&8)){k=0,t[r+11|0]=0,f=r;break l}k=i[r+40>>2],f=r+32|0}if(h=i[f>>2],k=k-h|0,k>>>0>=2147483640)break w;if(k>>>0>=11){B=k|7,f=C(B+1|0),i[r+8>>2]=B-2147483647,i[r>>2]=f,i[r+4>>2]=k;break u}if(t[r+11|0]=k,f=r,k)break u;k=0;break l}if(s=u[w+577|0],!((s-32&255)>>>0<225|!(h>>>s|0))){i[r+104>>2]=0,i[r+76>>2]=78164,i[r+20>>2]=78144,f=i[19545],i[r+12>>2]=f,k=i[f-12>>2],f=r+12|0,i[k+f>>2]=i[19546],i[r+16>>2]=0,k=f+i[i[r+12>>2]-12>>2]|0,B=r+24|0,J0(k,B),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[r+20>>2]=k,I=i[k-12>>2],k=r+20|0,i[I+k>>2]=i[19548],Q=i[19544],i[r+12>>2]=Q,i[f+i[Q-12>>2]>>2]=i[19549],i[r+76>>2]=78164,i[r+12>>2]=78124,i[r+20>>2]=78144,B=R0(B),i[B>>2]=77200,f=r- -64|0,i[f>>2]=0,i[f+4>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+72>>2]=24,F(D0(F(B0(F(k,32277,10),h),32518,32),s),28612,16),f=i[r+72>>2];_:{if(f&16){k=i[r+68>>2],f=i[r+48>>2],k>>>0<f>>>0&&(i[r+68>>2]=f,k=f),f=r+44|0;break _}if(!(f&8)){k=0,t[r+11|0]=0,f=r;break s}k=i[r+40>>2],f=r+32|0}if(s=i[f>>2],k=k-s|0,k>>>0>=2147483640)break w;if(k>>>0>=11){h=k|7,f=C(h+1|0),i[r+8>>2]=h-2147483647,i[r>>2]=f,i[r+4>>2]=k;break h}if(t[r+11|0]=k,f=r,k)break h;k=0;break s}if(I=i[w+616>>2],s=i[w+564>>2],Y=i[w+556>>2],B=s+Y|0,Q=0,Q=B>>>0<Y>>>0?1:Q,f=((g(O1(B-1|0,Q-!B|0,s,0),k)<<4)+I|0)+(f<<4)|0,i[f+8>>2]=h,i[f>>2]=o,i[f+4>>2]=n,f=i[28729],i[_>>2]=i[28728],i[_+4>>2]=f,f=_+8|0,t[114931]>=0){k=i[28731],i[f>>2]=i[28730],i[f+4>>2]=k,i[f+8>>2]=i[28732];break o}T(f,i[28730],i[28731]);break o}I0(),M()}if(!k)break s;z(f,s,k)}t[f+k|0]=0,a(_,9,0,r),t[r+11|0]<0&&Z(i[r>>2]),f=i[19543],i[r+12>>2]=f,i[i[f-12>>2]+(r+12|0)>>2]=i[19551],i[r+20>>2]=i[19552],i[B>>2]=77200,t[r+67|0]<0&&Z(i[r+56>>2]),y0(B),Y0(r+76|0);break o}if(!k)break l;z(f,h,k)}t[f+k|0]=0,a(_,9,0,r),t[r+11|0]<0&&Z(i[r>>2]),f=i[19543],i[r+12>>2]=f,i[i[f-12>>2]+(r+12|0)>>2]=i[19551],i[r+20>>2]=i[19552],i[s>>2]=77200,t[r+67|0]<0&&Z(i[r+56>>2]),y0(s),Y0(r+76|0)}if(v=r+160|0,i[_>>2])break f;if(t[_+19|0]<0&&Z(i[_+8>>2]),u[l+60|0])break n;if(r=i[l+32>>2]-i[l+28>>2]|0,f=r,r=r+o|0,n=f>>>0>r>>>0?n+1|0:n,i[w+632>>2]=r,i[w+636>>2]=n,r=i[w+184>>2],f=i[w+188>>2],(r|0)==(f|0))break k;for(;;){o:{l:{if(k=i[r>>2],!k||(o=Z0(k,92792,108720),!o))break l;if(m=i[r+4>>2],m)break o;m=0;break A}if(r=r+8|0,(f|0)!=(r|0))continue;break k}break}if(i[m+4>>2]=i[m+4>>2]+1,u[l+60|0])break n;break A}T(r,i[l+24>>2],i[l+28>>2]);break f}e2(),M()}o=0}if(h=i[l+16>>2],f=i[l+20>>2],(h|0)!=(f|0))for(k=o+36|0;;){n=i[i[h>>2]+16>>2];A:{if((n|0)==1769173093)break A;if(r=i[o+36>>2],s=i[o+40>>2],(r|0)!=(s|0))for(;;){if((n|0)==i[i[r>>2]+16>>2])break A;if(r=r+8|0,(s|0)==(r|0))break}No(k,h);k:{if(i[i[h>>2]+16>>2]!=1885960297||(r=i[w+180>>2],i[l>>2]=i[r+48>>2],r=i[r+52>>2],i[l+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[h>>2],a3(i[l>>2],i[w+196>>2],h,W[i[i[r>>2]+40>>2]](r)|0),r=i[l+4>>2],!r)||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break k;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=i[w+180>>2],i[l>>2]=i[r+48>>2],r=i[r+52>>2],i[l+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),P6(i[l>>2],i[w+196>>2],i[w+640>>2]),r=i[l+4>>2],!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break A;W[i[i[r>>2]+8>>2]](r),y(r)}if(h=h+8|0,(f|0)==(h|0))break}r=i[28729],i[_>>2]=i[28728],i[_+4>>2]=r,r=_+8|0;A:{if(t[114931]>=0){f=i[28731],i[r>>2]=i[28730],i[r+4>>2]=f,i[r+8>>2]=i[28732];break A}T(r,i[28730],i[28731])}if(!m||(r=i[m+4>>2],i[m+4>>2]=r-1,r))break f;W[i[i[m>>2]+8>>2]](m),y(m)}if(r=u[l+60|0],(r|0)!=255&&(f=i[27191],i[l>>2]=i[27190],i[l+4>>2]=f,W[i[l+(r<<2)>>2]](l+108|0,l+16|0)),r=i[l+68>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;W[i[i[r>>2]+8>>2]](r),y(r)}r=u[l+92|0],(r|0)!=255&&(f=i[27187],i[l+16>>2]=i[27186],i[l+20>>2]=f,W[i[(l+16|0)+(r<<2)>>2]](l,l+72|0)),r=i[l+104>>2];r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;W[i[i[r>>2]+8>>2]](r),y(r)}if(v=l+112|0,c0(A,_,i[e>>2]),t[V+31|0]<0&&Z(i[V+20>>2]),!G||(A=i[G+4>>2],i[G+4>>2]=A-1,A))break i;W[i[i[G>>2]+8>>2]](G),y(G);break i}if(l=Z0(s,107564,108216),!l)break e;_=i[r+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),G=V+12|0,s=v-192|0,v=s,ge(s+168|0,i[l+180>>2],n,o,i[l+580>>2],1);r:{f:switch(u[s+188|0]){default:e2(),M();case 1:if(r=i[s+172>>2],i[G>>2]=i[s+168>>2],i[G+4>>2]=r,r=G+8|0,t[s+187|0]>=0){f=i[s+180>>2],i[r>>2]=i[s+176>>2],i[r+4>>2]=f,i[r+8>>2]=i[s+184>>2];break r}T(r,i[s+176>>2],i[s+180>>2]);break r;case 0:break f}B=i[s+168>>2],m=i[s+172>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),r=i[l+180>>2],i[s+160>>2]=i[r+48>>2],r=i[r+52>>2],i[s+164>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),j1(s+88|0,i[s+160>>2],i[B+196>>2]),r=i[s+88>>2],t[r+164|0]=1,i[r+100>>2]=i[r+100>>2]&-2|1,r=i[s+92>>2];f:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(W[i[i[l>>2]+152>>2]](s+88|0,l),o=i[l+196>>2],w=g(i[s+92>>2],k)+f|0,Q=i[B+196>>2],I=i[i[s+160>>2]+80>>2],r=i[I+104>>2],I=i[I+108>>2],(r|0)!=(I|0))for(;;){f:{if(!((o|0)!=i[r+40>>2]|i[r+16>>2]!=1684630887)){i[i[r+44>>2]+(w<<2)>>2]=Q;break f}if(r=r+56|0,(I|0)!=(r|0))continue}break}i[(i[l+564>>2]+(g(p[l+554>>1],k)<<2)|0)+(f<<2)>>2]=i[B+196>>2],o=0,r=i[B+184>>2],w=i[B+188>>2];f:{A:{if((r|0)==(w|0))break A;for(;;){k:{if(h=i[r>>2],!h||(h=Z0(h,92792,95064),!h))break k;if(r=i[r+4>>2],!r)break A;i[r+4>>2]=i[r+4>>2]+1,i[s+84>>2]=r,i[s+80>>2]=h,i[r+4>>2]=i[r+4>>2]+1,o=r,w=0;break f}if(r=r+8|0,(w|0)==(r|0))break}h=0}i[s+84>>2]=0,i[s+80>>2]=h,w=1}r=i[s+84>>2],i[s+24>>2]=i[s+80>>2],i[s+28>>2]=r,O4(l,s+24|0,1);f:{if(f|k)break f;if(tA(s+68|0,B,0),r=i[s+68>>2],k=i[s+72>>2],(r|0)!=(k|0))for(;i[s+60>>2]=i[r>>2],f=i[r+4>>2],i[s+64>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),h=i[r>>2],f=i[h+16>>2]==1769173093,h=f?l:h,f=W[i[i[h>>2]+(f?84:40)>>2]](h)|0,h=i[s+64>>2],i[s+16>>2]=i[s+60>>2],i[s+20>>2]=h,O4(l,s+16|0,f),r=r+8|0,(k|0)!=(r|0););if(r=i[l+580>>2],Mn(s+48|0,n,r,1,i[r+4>>2]),r=i[s+48>>2],k=i[s+52>>2],(r|0)!=(k|0))for(;;){n=i[r>>2],i[s+40>>2]=n,f=i[r+4>>2],i[s+44>>2]=f;A:{if(!f){i[s+36>>2]=0,i[s+32>>2]=n;break A}if(i[f+4>>2]=i[f+4>>2]+1,n=i[r>>2],f=i[r+4>>2],i[s+36>>2]=f,i[s+32>>2]=n,!f)break A;i[f+4>>2]=i[f+4>>2]+1}n=i[s+32>>2],f=i[n+16>>2]==1769173093,n=f?l:n,f=W[i[i[n>>2]+(f?84:40)>>2]](n)|0,n=i[s+44>>2],i[s+8>>2]=i[s+40>>2],i[s+12>>2]=n,O4(l,s+8|0,f),f=i[s+36>>2];A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=r+8|0,(k|0)==(r|0))break}r=i[l+180>>2],f=i[r+48>>2],r=i[r+52>>2];A:{if(!r){P6(f,i[l+196>>2],i[l+576>>2]);break A}if(i[r+4>>2]=i[r+4>>2]+1,P6(f,i[l+196>>2],i[l+576>>2]),f=i[r+4>>2],i[r+4>>2]=f-1,f)break A;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=i[s+48>>2],f){if(r=f,n=i[s+52>>2],(r|0)!=(n|0)){for(;;){r=i[n-4>>2];A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;W[i[i[r>>2]+8>>2]](r),y(r)}if(n=n-8|0,(f|0)==(n|0))break}r=i[s+48>>2]}i[s+52>>2]=f,Z(r)}if(f=i[s+68>>2],!f)break f;if(r=f,n=i[s+72>>2],(r|0)!=(n|0)){for(;;){r=i[n-4>>2];A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;W[i[i[r>>2]+8>>2]](r),y(r)}if(n=n-8|0,(f|0)==(n|0))break}r=i[s+68>>2]}i[s+72>>2]=f,Z(r)}r=i[28729],i[G>>2]=i[28728],i[G+4>>2]=r,r=G+8|0;f:{if(t[114931]>=0){f=i[28731],i[r>>2]=i[28730],i[r+4>>2]=f,i[r+8>>2]=i[28732];break f}T(r,i[28730],i[28731])}f:{if(w||(r=i[o+4>>2],i[o+4>>2]=r-1,r))break f;W[i[i[o>>2]+8>>2]](o),y(o)}r=i[s+164>>2];f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(!m||(r=i[m+4>>2],i[m+4>>2]=r-1,r))break r;W[i[i[m>>2]+8>>2]](m),y(m)}if(r=u[s+188|0],(r|0)!=255&&(f=i[27065],i[s+88>>2]=i[27064],i[s+92>>2]=f,W[i[(s+88|0)+(r<<2)>>2]](s+68|0,s+168|0)),v=s+192|0,c0(A,G,i[e>>2]),t[V+31|0]<0&&Z(i[V+20>>2]),!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;W[i[i[_>>2]+8>>2]](_),y(_);break i}i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=16482}v=V+32|0}function Y9(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;k=e+60|0,(k|0)!=(r|0)&&(f=k,k=i[r>>2],r=i[r+4>>2],$4(f,k,r,r-k|0)),l=v-48|0,v=l,i[e+72>>2]=0,n=l+24|0,k=v-16|0,v=k;i:{e:{if(f=i[e+60>>2],r=i[e+64>>2]-f|0,r>>>0>=2&&(o=r-2|0,r=i[e+72>>2],o>>>0>=r>>>0))break e;if(t[k+4|0]=0,t[k+15|0]=0,a(n,2,140,k+4|0),t[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(f=r+f|0,f=u[f|0]|u[f+1|0]<<8,i[e+72>>2]=r+2,((f<<8|f>>>8)&65535)==65359){if(r=i[28729],i[n>>2]=i[28728],i[n+4>>2]=r,r=n+8|0,t[114931]>=0){n=i[28731],i[r>>2]=i[28730],i[r+4>>2]=n,i[r+8>>2]=i[28732];break i}T(r,i[28730],i[28731]);break i}if(r=C(32),i[k+4>>2]=r,i[k+8>>2]=27,i[k+12>>2]=-2147483616,f=u[7748]|u[7749]<<8|(u[7750]<<16|u[7751]<<24),s=u[7744]|u[7745]<<8|(u[7746]<<16|u[7747]<<24),t[r|0]=s,t[r+1|0]=s>>>8,t[r+2|0]=s>>>16,t[r+3|0]=s>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+27|0]=0,f=u[7767]|u[7768]<<8|(u[7769]<<16|u[7770]<<24),t[r+23|0]=f,t[r+24|0]=f>>>8,t[r+25|0]=f>>>16,t[r+26|0]=f>>>24,f=u[7764]|u[7765]<<8|(u[7766]<<16|u[7767]<<24),s=u[7760]|u[7761]<<8|(u[7762]<<16|u[7763]<<24),t[r+16|0]=s,t[r+17|0]=s>>>8,t[r+18|0]=s>>>16,t[r+19|0]=s>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[7756]|u[7757]<<8|(u[7758]<<16|u[7759]<<24),s=u[7752]|u[7753]<<8|(u[7754]<<16|u[7755]<<24),t[r+8|0]=s,t[r+9|0]=s>>>8,t[r+10|0]=s>>>16,t[r+11|0]=s>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(n,2,140,k+4|0),t[k+15|0]>=0)break i;Z(i[k+4>>2])}v=k+16|0;i:{if(i[l+24>>2]){e=i[l+28>>2],i[A>>2]=i[l+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+40>>2],e=i[l+36>>2],i[A+8>>2]=i[l+32>>2],i[A+12>>2]=e,i[l+40>>2]=0,i[l+32>>2]=0,i[l+36>>2]=0;break i}n=v-16|0,v=n;e:{r:{if(k=i[e+60>>2],s=i[e+64>>2]-k|0,s>>>0>=43&&(r=i[e+72>>2],r>>>0<=s-43>>>0))break r;if(t[n+4|0]=0,t[n+15|0]=0,a(l,2,140,n+4|0),t[n+15|0]>=0)break e;Z(i[n+4>>2]);break e}if(f=r+k|0,f=u[f|0]|u[f+1|0]<<8,o=r+2|0,i[e+72>>2]=o,((f<<8|f>>>8)&65535)!=65361){if(r=C(32),i[n+4>>2]=r,i[n+8>>2]=27,i[n+12>>2]=-2147483616,k=u[7720]|u[7721]<<8|(u[7722]<<16|u[7723]<<24),f=u[7716]|u[7717]<<8|(u[7718]<<16|u[7719]<<24),t[r|0]=f,t[r+1|0]=f>>>8,t[r+2|0]=f>>>16,t[r+3|0]=f>>>24,t[r+4|0]=k,t[r+5|0]=k>>>8,t[r+6|0]=k>>>16,t[r+7|0]=k>>>24,t[r+27|0]=0,k=u[7739]|u[7740]<<8|(u[7741]<<16|u[7742]<<24),t[r+23|0]=k,t[r+24|0]=k>>>8,t[r+25|0]=k>>>16,t[r+26|0]=k>>>24,k=u[7736]|u[7737]<<8|(u[7738]<<16|u[7739]<<24),f=u[7732]|u[7733]<<8|(u[7734]<<16|u[7735]<<24),t[r+16|0]=f,t[r+17|0]=f>>>8,t[r+18|0]=f>>>16,t[r+19|0]=f>>>24,t[r+20|0]=k,t[r+21|0]=k>>>8,t[r+22|0]=k>>>16,t[r+23|0]=k>>>24,k=u[7728]|u[7729]<<8|(u[7730]<<16|u[7731]<<24),f=u[7724]|u[7725]<<8|(u[7726]<<16|u[7727]<<24),t[r+8|0]=f,t[r+9|0]=f>>>8,t[r+10|0]=f>>>16,t[r+11|0]=f>>>24,t[r+12|0]=k,t[r+13|0]=k>>>8,t[r+14|0]=k>>>16,t[r+15|0]=k>>>24,a(l,2,140,n+4|0),t[n+15|0]>=0)break e;Z(i[n+4>>2]);break e}if(f=k+o|0,f=u[f|0]|u[f+1|0]<<8,o=r+4|0,i[e+72>>2]=o,((f<<8|f>>>8)+16345&65535)>>>0<=16385){if(r=C(24),i[n+4>>2]=r,i[n+8>>2]=23,i[n+12>>2]=-2147483624,k=u[13107]|u[13108]<<8|(u[13109]<<16|u[13110]<<24),f=u[13103]|u[13104]<<8|(u[13105]<<16|u[13106]<<24),t[r|0]=f,t[r+1|0]=f>>>8,t[r+2|0]=f>>>16,t[r+3|0]=f>>>24,t[r+4|0]=k,t[r+5|0]=k>>>8,t[r+6|0]=k>>>16,t[r+7|0]=k>>>24,t[r+23|0]=0,k=u[13122]|u[13123]<<8|(u[13124]<<16|u[13125]<<24),f=u[13118]|u[13119]<<8|(u[13120]<<16|u[13121]<<24),t[r+15|0]=f,t[r+16|0]=f>>>8,t[r+17|0]=f>>>16,t[r+18|0]=f>>>24,t[r+19|0]=k,t[r+20|0]=k>>>8,t[r+21|0]=k>>>16,t[r+22|0]=k>>>24,k=u[13115]|u[13116]<<8|(u[13117]<<16|u[13118]<<24),f=u[13111]|u[13112]<<8|(u[13113]<<16|u[13114]<<24),t[r+8|0]=f,t[r+9|0]=f>>>8,t[r+10|0]=f>>>16,t[r+11|0]=f>>>24,t[r+12|0]=k,t[r+13|0]=k>>>8,t[r+14|0]=k>>>16,t[r+15|0]=k>>>24,a(l,2,140,n+4|0),t[n+15|0]>=0)break e;Z(i[n+4>>2]);break e}if(f=k+o|0,f=u[f|0]|u[f+1|0]<<8,o=r+6|0,i[e+72>>2]=o,X[e>>1]=f<<8|f>>>8,f=k+o|0,f=u[f|0]|u[f+1|0]<<8|(u[f+2|0]<<16|u[f+3|0]<<24),o=r+10|0,i[e+72>>2]=o,i[e+4>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+o|0,f=u[f|0]|u[f+1|0]<<8|(u[f+2|0]<<16|u[f+3|0]<<24),o=r+14|0,i[e+72>>2]=o,i[e+8>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+o|0,f=u[f|0]|u[f+1|0]<<8|(u[f+2|0]<<16|u[f+3|0]<<24),o=r+18|0,i[e+72>>2]=o,i[e+12>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+o|0,f=u[f|0]|u[f+1|0]<<8|(u[f+2|0]<<16|u[f+3|0]<<24),o=r+22|0,i[e+72>>2]=o,i[e+16>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+o|0,f=u[f|0]|u[f+1|0]<<8|(u[f+2|0]<<16|u[f+3|0]<<24),o=r+26|0,i[e+72>>2]=o,i[e+20>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+o|0,f=u[f|0]|u[f+1|0]<<8|(u[f+2|0]<<16|u[f+3|0]<<24),o=r+30|0,i[e+72>>2]=o,i[e+24>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+o|0,f=u[f|0]|u[f+1|0]<<8|(u[f+2|0]<<16|u[f+3|0]<<24),o=r+34|0,i[e+72>>2]=o,i[e+28>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+o|0,f=u[f|0]|u[f+1|0]<<8|(u[f+2|0]<<16|u[f+3|0]<<24),o=r+38|0,i[e+72>>2]=o,i[e+32>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),k=k+o|0,k=u[k|0]|u[k+1|0]<<8,r=r+40|0,i[e+72>>2]=r,_=k<<8|k>>>8,(_-16385&65535)>>>0<=49151){if(r=C(24),i[n+4>>2]=r,i[n+8>>2]=23,i[n+12>>2]=-2147483624,k=u[13131]|u[13132]<<8|(u[13133]<<16|u[13134]<<24),f=u[13127]|u[13128]<<8|(u[13129]<<16|u[13130]<<24),t[r|0]=f,t[r+1|0]=f>>>8,t[r+2|0]=f>>>16,t[r+3|0]=f>>>24,t[r+4|0]=k,t[r+5|0]=k>>>8,t[r+6|0]=k>>>16,t[r+7|0]=k>>>24,t[r+23|0]=0,k=u[13146]|u[13147]<<8|(u[13148]<<16|u[13149]<<24),f=u[13142]|u[13143]<<8|(u[13144]<<16|u[13145]<<24),t[r+15|0]=f,t[r+16|0]=f>>>8,t[r+17|0]=f>>>16,t[r+18|0]=f>>>24,t[r+19|0]=k,t[r+20|0]=k>>>8,t[r+21|0]=k>>>16,t[r+22|0]=k>>>24,k=u[13139]|u[13140]<<8|(u[13141]<<16|u[13142]<<24),f=u[13135]|u[13136]<<8|(u[13137]<<16|u[13138]<<24),t[r+8|0]=f,t[r+9|0]=f>>>8,t[r+10|0]=f>>>16,t[r+11|0]=f>>>24,t[r+12|0]=k,t[r+13|0]=k>>>8,t[r+14|0]=k>>>16,t[r+15|0]=k>>>24,a(l,2,140,n+4|0),t[n+15|0]>=0)break e;Z(i[n+4>>2]);break e}if(s-r>>>0>=g(_&65535,3)>>>0){f=i[e+40>>2];r:{f:{for(;;){k=i[e+60>>2],r=i[e+72>>2],s=u[k+r|0],o=r+1|0,i[e+72>>2]=o,h=u[k+o|0],o=r+2|0,i[e+72>>2]=o,m=u[k+o|0],i[e+72>>2]=r+3,B=s>>>7|0,G=(s&127)+1|0,o=i[e+44>>2];A:{if(o>>>0>f>>>0){r=h|(G<<16|B<<24|m<<8),t[f|0]=r,t[f+1|0]=r>>>8,t[f+2|0]=r>>>16,t[f+3|0]=r>>>24,f=f+4|0;break A}if(s=i[e+36>>2],r=f-s|0,I=r>>2,k=I+1|0,k>>>0>=1073741824)break f;if(f=o-s|0,o=f>>1,o=f>>>0>=2147483644?1073741823:k>>>0<o>>>0?o:k,o){if(o>>>0>=1073741824)break r;k=C(o<<2)}else k=0;if(f=k+r|0,h=h|(G<<16|B<<24|m<<8),t[f|0]=h,t[f+1|0]=h>>>8,t[f+2|0]=h>>>16,t[f+3|0]=h>>>24,h=f-(I<<2)|0,r&&z(h,s,r),i[e+44>>2]=k+(o<<2),f=f+4|0,i[e+40>>2]=f,i[e+36>>2]=h,!s)break A;Z(s)}if(i[e+40>>2]=f,w=w+1|0,!((w&65535)>>>0<(_&65535)>>>0))break}Z8(l,114912);break e}s0(),M()}x0(),M()}if(r=V2(n+4|0,47881),a(l,2,140,r),t[r+11|0]>=0)break e;Z(i[r>>2])}if(v=n+16|0,k=i[l+4>>2],r=i[l>>2],i[l+24>>2]=r,i[l+28>>2]=k,t[l+43|0]<0&&(Z(i[l+32>>2]),r=i[l+24>>2]),k=i[l+12>>2],i[l+32>>2]=i[l+8>>2],i[l+36>>2]=k,i[l+40>>2]=i[l+16>>2],r){e=i[l+28>>2],i[A>>2]=i[l+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+40>>2],e=i[l+36>>2],i[A+8>>2]=i[l+32>>2],i[A+12>>2]=e,i[l+32>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0;break i}if(r=i[e+72>>2],k=i[e+60>>2],r>>>0<(i[e+64>>2]-k|0)-2>>>0){if(k=r+k|0,k=u[k|0]|u[k+1|0]<<8,i[e+72>>2]=r+2,((k<<8|k>>>8)&65535)==65360){n=v-16|0,v=n,k=i[e+60>>2],o=i[e+64>>2]-k|0,r=i[e+72>>2];e:{if(o-r>>>0<=5){if(t[n+4|0]=0,t[n+15|0]=0,a(A,2,140,n+4|0),t[n+15|0]>=0)break e;Z(i[n+4>>2]);break e}if(f=r+k|0,f=u[f|0]|u[f+1|0]<<8,s=r+2|0,i[e+72>>2]=s,f=f<<8|f>>>8,(f-71&65535)>>>0<=65472){if(e=C(24),i[n+4>>2]=e,i[n+8>>2]=23,i[n+12>>2]=-2147483624,r=u[13179]|u[13180]<<8|(u[13181]<<16|u[13182]<<24),k=u[13175]|u[13176]<<8|(u[13177]<<16|u[13178]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+23|0]=0,r=u[13194]|u[13195]<<8|(u[13196]<<16|u[13197]<<24),k=u[13190]|u[13191]<<8|(u[13192]<<16|u[13193]<<24),t[e+15|0]=k,t[e+16|0]=k>>>8,t[e+17|0]=k>>>16,t[e+18|0]=k>>>24,t[e+19|0]=r,t[e+20|0]=r>>>8,t[e+21|0]=r>>>16,t[e+22|0]=r>>>24,r=u[13187]|u[13188]<<8|(u[13189]<<16|u[13190]<<24),k=u[13183]|u[13184]<<8|(u[13185]<<16|u[13186]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,140,n+4|0),t[n+15|0]>=0)break e;Z(i[n+4>>2]);break e}if(f=f&65535,f-2>>>0>o-s>>>0){if(t[n+4|0]=0,t[n+15|0]=0,a(A,2,140,n+4|0),t[n+15|0]>=0)break e;Z(i[n+4>>2]);break e}for(k=k+s|0,k=u[k|0]|u[k+1|0]<<8|(u[k+2|0]<<16|u[k+3|0]<<24),i[e+72>>2]=r+6,_=k<<24|(k&65280)<<8|(k>>>8&65280|k>>>24),m=r+f|0,f=2;;){r:{if(!(_>>>32-f&1))break r;if(r=i[e+72>>2],m-r>>>0<=1){if(e=C(40),i[n+4>>2]=e,i[n+8>>2]=39,i[n+12>>2]=-2147483608,r=u[8599]|u[8600]<<8|(u[8601]<<16|u[8602]<<24),k=u[8595]|u[8596]<<8|(u[8597]<<16|u[8598]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+39|0]=0,r=u[8630]|u[8631]<<8|(u[8632]<<16|u[8633]<<24),k=u[8626]|u[8627]<<8|(u[8628]<<16|u[8629]<<24),t[e+31|0]=k,t[e+32|0]=k>>>8,t[e+33|0]=k>>>16,t[e+34|0]=k>>>24,t[e+35|0]=r,t[e+36|0]=r>>>8,t[e+37|0]=r>>>16,t[e+38|0]=r>>>24,r=u[8623]|u[8624]<<8|(u[8625]<<16|u[8626]<<24),k=u[8619]|u[8620]<<8|(u[8621]<<16|u[8622]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[8615]|u[8616]<<8|(u[8617]<<16|u[8618]<<24),k=u[8611]|u[8612]<<8|(u[8613]<<16|u[8614]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[8607]|u[8608]<<8|(u[8609]<<16|u[8610]<<24),k=u[8603]|u[8604]<<8|(u[8605]<<16|u[8606]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,140,n+4|0),t[n+15|0]>=0)break e;Z(i[n+4>>2]);break e}if((f|0)==15){k=r+i[e+60>>2]|0,s=u[k+1|0],k=u[k|0],i[e+72>>2]=r+2,r=k<<24|s<<16|15,i[n>>2]=r,i[n+4>>2]=r;f:{if(r=i[e+52>>2],o=i[e+56>>2],r>>>0<o>>>0){k=p[n>>1]|p[n+2>>1]<<16,X[r>>1]=k,X[r+2>>1]=k>>>16,i[e+52>>2]=r+4;break f}A:{if(s=i[e+48>>2],r=r-s|0,w=r>>2,k=w+1|0,k>>>0<1073741824){if(o=o-s|0,h=o>>1,o=o>>>0>=2147483644?1073741823:k>>>0<h>>>0?h:k,o){if(o>>>0>=1073741824)break A;k=C(o<<2)}else k=0;h=k+r|0,B=p[n>>1]|p[n+2>>1]<<16,X[h>>1]=B,X[h+2>>1]=B>>>16,w=h-(w<<2)|0,r&&z(w,s,r),i[e+56>>2]=k+(o<<2),r=h+4|0,i[e+52>>2]=r,i[e+48>>2]=w,s&&Z(s),i[e+52>>2]=r;break f}s0(),M()}x0(),M()}break r}i[e+72>>2]=r+2}if(f=f+1|0,(f|0)==33)break}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731])}v=n+16|0;break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}if(e=C(40),i[l>>2]=e,i[l+4>>2]=33,i[l+8>>2]=-2147483608,r=u[29520]|u[29521]<<8|(u[29522]<<16|u[29523]<<24),k=u[29516]|u[29517]<<8|(u[29518]<<16|u[29519]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+33|0]=0,t[e+32|0]=u[29548],r=u[29544]|u[29545]<<8|(u[29546]<<16|u[29547]<<24),k=u[29540]|u[29541]<<8|(u[29542]<<16|u[29543]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[29536]|u[29537]<<8|(u[29538]<<16|u[29539]<<24),k=u[29532]|u[29533]<<8|(u[29534]<<16|u[29535]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[29528]|u[29529]<<8|(u[29530]<<16|u[29531]<<24),k=u[29524]|u[29525]<<8|(u[29526]<<16|u[29527]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,140,l),t[l+11|0]>=0)break i;Z(i[l>>2])}t[l+43|0]<0&&Z(i[l+32>>2]),v=l+48|0}function ge(A,e,r,f,k,n){var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;o=v-224|0,v=o,d9(o+216|0,e,i[i[f>>2]+4>>2]),l=i[k+36>>2],i[o+208>>2]=i[k+32>>2],i[o+212>>2]=l,l=i[k+28>>2],i[o+200>>2]=i[k+24>>2],i[o+204>>2]=l,l=i[k+20>>2],i[o+192>>2]=i[k+16>>2],i[o+196>>2]=l,l=i[k+12>>2],i[o+184>>2]=i[k+8>>2],i[o+188>>2]=l,l=i[k+4>>2],i[o+176>>2]=i[k>>2],i[o+180>>2]=l,i[o+168>>2]=0,i[o+172>>2]=0,k=i[o+216>>2],W[i[i[k>>2]+160>>2]](o+144|0,k),l=i[o+144>>2],k=i[o+148>>2];i:{if(!k||(w=i[k+4>>2],i[k+4>>2]=w-1,w))break i;W[i[i[k>>2]+8>>2]](k),y(k)}i:{e:{r:{f:{A:{k:{n:{t:{if(l){k=i[o+216>>2],W[i[i[k>>2]+160>>2]](o+144|0,k),k=i[o+144>>2],l=W[i[i[k>>2]+8>>2]](k)|0,k=i[o+148>>2];o:{if(!k||(w=i[k+4>>2],i[k+4>>2]=w-1,w))break o;W[i[i[k>>2]+8>>2]](k),y(k)}if(l&&(i[o+180>>2]=l),t[o+164|0]=0,i[o+144>>2]=0,i[o+148>>2]=0,k=i[o+216>>2],W[i[i[k>>2]+160>>2]](o+68|0,k),qA(o+120|0,i[o+68>>2],r,f,i[o+180>>2],o+192|0,e- -64|0),k=u[o+140|0],l=u[o+164|0],(l|0)==255){if((k|0)==255)break k;break t}if((k|0)!=255)break t;k=i[25173],i[o+96>>2]=i[25172],i[o+100>>2]=k,W[i[(o+96|0)+(l<<2)>>2]](o+56|0,o+144|0),t[o+164|0]=255;break n}if(k=i[r>>2],l=i[r+4>>2],l&&(i[l+4>>2]=i[l+4>>2]+1),i[o+168>>2]=k,k=i[o+172>>2],i[o+172>>2]=l,!k||(l=i[k+4>>2],i[k+4>>2]=l-1,l))break A;W[i[i[k>>2]+8>>2]](k),y(k);break A}l=o+144|0,i[o+56>>2]=l,w=i[25175],i[o+96>>2]=i[25174],i[o+100>>2]=w,W[i[(o+96|0)+(k<<2)>>2]](o+56|0,l,o+120|0)}if(k=u[o+140|0],(k|0)==255)break k;l=i[25173],i[o+96>>2]=i[25172],i[o+100>>2]=l,W[i[(o+96|0)+(k<<2)>>2]](o+56|0,o+120|0)}t[o+140|0]=255,k=i[o+72>>2];k:{if(!k||(l=i[k+4>>2],i[k+4>>2]=l-1,l))break k;W[i[i[k>>2]+8>>2]](k),y(k)}w=u[o+164|0];k:{if(w){if((w|0)!=1)break r;k=i[o+148>>2],i[A>>2]=i[o+144>>2],i[A+4>>2]=k,k=A+8|0;n:{if(t[o+163|0]>=0){l=i[o+156>>2],i[k>>2]=i[o+152>>2],i[k+4>>2]=l,i[k+8>>2]=i[o+160>>2];break n}T(k,i[o+152>>2],i[o+156>>2])}t[A+20|0]=1;break k}if(k=i[o+144>>2],l=i[o+148>>2],l&&(i[l+4>>2]=i[l+4>>2]+1),i[o+168>>2]=k,k=i[o+172>>2],i[o+172>>2]=l,!k||(l=i[k+4>>2],i[k+4>>2]=l-1,l))break k;W[i[i[k>>2]+8>>2]](k),y(k)}if(k=u[o+164|0],(k|0)!=255&&(l=i[25173],i[o+120>>2]=i[25172],i[o+124>>2]=l,W[i[(o+120|0)+(k<<2)>>2]](o+96|0,o+144|0)),w)break f}w=o+96|0,l=v-112|0,v=l,I=o+168|0,s=i[I>>2],h=i[s+192>>2],B=i[o+216>>2],k=B,i[k+200>>2]=i[s+188>>2],i[k+204>>2]=h,C9(l+48|0,k,I,f,o+176|0,n);A:{k:{n:{t:switch(u[l+92|0]){case 1:if(k=i[l+52>>2],i[w>>2]=i[l+48>>2],i[w+4>>2]=k,k=w+8|0,t[l+67|0]>=0){n=i[l+60>>2],i[k>>2]=i[l+56>>2],i[k+4>>2]=n,i[k+8>>2]=i[l+64>>2];break n}T(k,i[l+56>>2],i[l+60>>2]);break n;case 0:break t;default:break k}n=i[e+48>>2],k=i[e+52>>2];t:{if(k){if(i[k+4>>2]=i[k+4>>2]+1,S6(l+24|0,n,W[i[i[B>>2]+76>>2]](B)|0),n=i[k+4>>2],i[k+4>>2]=n-1,n)break t;W[i[i[k>>2]+8>>2]](k),y(k);break t}S6(l+24|0,n,W[i[i[B>>2]+76>>2]](B)|0)}t:{o:switch(u[l+44|0]){case 1:if(k=i[l+28>>2],i[w>>2]=i[l+24>>2],i[w+4>>2]=k,k=w+8|0,t[l+43|0]>=0){n=i[l+36>>2],i[k>>2]=i[l+32>>2],i[k+4>>2]=n,i[k+8>>2]=i[l+40>>2];break t}T(k,i[l+32>>2],i[l+36>>2]);break t;case 0:break o;default:break k}k=i[l+24>>2],n=i[l+28>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),s=l+60|0,_=i[k+104>>2],i[B+196>>2]=_,h=i[e+48>>2],k=i[e+52>>2];o:{if(!k){w6(h,_,s,0);break o}if(i[k+4>>2]=i[k+4>>2]+1,w6(h,_,s,0),s=i[k+4>>2],i[k+4>>2]=s-1,s)break o;W[i[i[k>>2]+8>>2]](k),y(k)}if(u[l+92|0])break k;if(k=i[l+48>>2],Q=i[l+52>>2],(k|0)!=(Q|0))for(;;){h=i[k>>2],s=i[h+16>>2]==1769173093,h=s?B:h,V=W[i[i[h>>2]+(s?84:40)>>2]](h)|0,h=i[e+48>>2],s=i[e+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),m=i[h+120>>2],h=i[h+124>>2];o:{if(!h){m=ni(m,k);break o}if(i[h+4>>2]=i[h+4>>2]+1,m=ni(m,k),G=i[h+4>>2],i[h+4>>2]=G-1,G)break o;W[i[i[h>>2]+8>>2]](h),y(h)}o:{if(!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break o;W[i[i[s>>2]+8>>2]](s),y(s)}h=i[e+48>>2],s=i[e+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),G=i[h+128>>2],h=i[h+132>>2];o:{if(h){if(i[h+4>>2]=i[h+4>>2]+1,X[l+22>>1]=m+1,t[l+20|0]=V,i[l+16>>2]=p[l+20>>1]|p[l+22>>1]<<16,U4(G,_,l+16|0),m=i[h+4>>2],i[h+4>>2]=m-1,m)break o;W[i[i[h>>2]+8>>2]](h),y(h);break o}t[l+20|0]=V,X[l+22>>1]=m+1,i[l+12>>2]=p[l+20>>1]|p[l+22>>1]<<16,U4(G,_,l+12|0)}o:{if(!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break o;W[i[i[s>>2]+8>>2]](s),y(s)}if(k=k+8|0,(Q|0)==(k|0))break}o:{if(i[i[f>>2]+4>>2]==4||(s=i[I>>2],i[s+196>>2]))break o;h=i[s+188>>2],m=i[s+192>>2],k=1;l:{u:switch(i[s+200>>2]){case 2:k=!(h&1);break l;case 1:k=!((h|m)&1);break l;case 0:case 3:break l;default:break u}k=0}if(k)break o;t[B+352|0]=0}s=i[e+48>>2],k=i[e+52>>2];o:{if(!k){P6(s,_,i[o+188>>2]);break o}if(i[k+4>>2]=i[k+4>>2]+1,P6(s,_,i[o+188>>2]),s=i[k+4>>2],i[k+4>>2]=s-1,s)break o;W[i[i[k>>2]+8>>2]](k),y(k)}k=i[28729],i[w>>2]=i[28728],i[w+4>>2]=k,k=w+8|0;o:{if(t[114931]>=0){w=i[28731],i[k>>2]=i[28730],i[k+4>>2]=w,i[k+8>>2]=i[28732];break o}T(k,i[28730],i[28731])}if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break t;W[i[i[n>>2]+8>>2]](n),y(n)}if(k=u[l+44|0],(k|0)==255)break n;n=i[26903],i[l+104>>2]=i[26902],i[l+108>>2]=n,W[i[(l+104|0)+(k<<2)>>2]](l+103|0,l+24|0)}k=u[l+92|0],(k|0)!=255&&(n=i[26901],i[l+24>>2]=i[26900],i[l+28>>2]=n,W[i[(l+24|0)+(k<<2)>>2]](l+104|0,l+48|0)),v=l+112|0;break A}e2(),M()}A:{if(i[o+96>>2]){e=i[o+100>>2],i[A>>2]=i[o+96>>2],i[A+4>>2]=e,e=A+8|0;k:{if(t[o+115|0]>=0){r=i[o+108>>2],i[e>>2]=i[o+104>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+112>>2];break k}T(e,i[o+104>>2],i[o+108>>2])}t[A+20|0]=1;break A}I3(e,i[i[o+216>>2]+196>>2],o+216|0);k:{if(!u[o+177|0]||!H5(i[o+168>>2])||(k=i[o+216>>2],!(W[i[i[k>>2]+80>>2]](k)|0)))break k;i[o+88>>2]=0,i[o+92>>2]=0,$9(o+144|0,o+168|0,e- -64|0);n:switch(u[o+164|0]){case 1:e=i[o+148>>2],i[A>>2]=i[o+144>>2],i[A+4>>2]=e,e=A+8|0;t:{o:{if(t[o+163|0]>=0){r=i[o+156>>2],i[e>>2]=i[o+152>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+160>>2],k=1,t[A+20|0]=1;break o}if(T(e,i[o+152>>2],i[o+156>>2]),k=u[o+164|0],t[A+20|0]=1,(k|0)==255)break t}A=i[25173],i[o+120>>2]=i[25172],i[o+124>>2]=A,W[i[(o+120|0)+(k<<2)>>2]](o+68|0,o+144|0)}if(A=i[o+92>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break A;W[i[i[A>>2]+8>>2]](A),y(A);break A;case 0:break n;default:break r}k=i[o+144>>2],n=i[o+148>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[o+88>>2]=k,k=i[o+92>>2],i[o+92>>2]=n;n:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break n;W[i[i[k>>2]+8>>2]](k),y(k)}if(k=i[f>>2],i[o+84>>2]=0,i[o+80>>2]=k,W[i[k+36>>2]](o+68|0,o+84|0),k=i[o+68>>2],k){if(f=i[o+72>>2],n=i[o+76>>2],r=l2(n),r>>>0>=2147483640)break e;n:{t:{if(r>>>0>=11){l=r|7,e=C(l+1|0),i[o+64>>2]=l-2147483647,i[o+56>>2]=e,i[o+60>>2]=r;break t}if(t[o+67|0]=r,e=o+56|0,!r)break n}if(!r)break n;z(e,n,r)}t[e+r|0]=0,e=a(o+120|0,k,f,o+56|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;n:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break n}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break n;Z(i[e+8>>2])}if(t[o+67|0]<0&&Z(i[o+56>>2]),A=i[o+84>>2],A&&W[i[i[o+80>>2]+40>>2]](A),A=u[o+164|0],(A|0)!=255&&(e=i[25173],i[o+120>>2]=i[25172],i[o+124>>2]=e,W[i[(o+120|0)+(A<<2)>>2]](o+68|0,o+144|0)),A=i[o+92>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break A;W[i[i[A>>2]+8>>2]](A),y(A);break A}k=o+80|0,Nt(k,f),f=o+120|0,ge(f,e,o+88|0,k,o+176|0,2),s=u[o+140|0];n:{if(s){if((s|0)!=1)break r;h6(A,f);break n}k=i[o+120>>2],i[o+48>>2]=k,f=i[o+124>>2],i[o+52>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[k+196>>2],k=i[e+48>>2],n=i[i[o+216>>2]+196>>2],i[o+44>>2]=1,i[o+36>>2]=n,i[o+40>>2]=o+36,n=i[o+44>>2],i[o+8>>2]=i[o+40>>2],i[o+12>>2]=n,n=f,f=Ju(o+56|0,o+8|0),o8(k,n,1635088492,f),k=i[f>>2],k&&(i[f+4>>2]=k,Z(k)),B=i[e+48>>2],h=i[i[o+48>>2]+196>>2],f=i[o+216>>2],l=V2(o+56|0,W[i[i[f>>2]+80>>2]](f)|0),n=v-16|0,v=n,f=C(144),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=96388,k=f+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,X[f+112>>1]=0,i[k>>2]=93964,i[f+136>>2]=0,i[f+140>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+120>>2]=0,i[f+124>>2]=0,i[f+32>>2]=1635088451,w=f+120|0;t:{if((w|0)==(l|0))break t;if(t[l+11|0]>=0){_=i[l+4>>2],i[w>>2]=i[l>>2],i[w+4>>2]=_,i[w+8>>2]=i[l+8>>2];break t}m1(w,i[l>>2],i[l+4>>2])}w=i[B+120>>2],i[n+12>>2]=f,i[n+8>>2]=k,i[f+4>>2]=i[f+4>>2]+1,w=ni(w,n+8|0),k=i[n+12>>2];t:{if(!k||(_=i[k+4>>2],i[k+4>>2]=_-1,_))break t;W[i[i[k>>2]+8>>2]](k),y(k)}k=i[B+128>>2],t[n+4|0]=1,X[n+6>>1]=w+1,i[n>>2]=p[n+4>>1]|p[n+6>>1]<<16,U4(k,h,n),k=i[f+4>>2],i[f+4>>2]=k-1,k||(W[i[i[f>>2]+8>>2]](f),y(f)),v=n+16|0,t[l+11|0]<0&&Z(i[l>>2]);t:{if(u[i[r>>2]+4|0]!=1||(r=i[i[o+216>>2]+196>>2],f=i[e+48>>2],k=i[i[o+48>>2]+196>>2],i[o+32>>2]=1,i[o+36>>2]=k,i[o+28>>2]=o+36,k=i[o+32>>2],i[o>>2]=i[o+28>>2],i[o+4>>2]=k,k=r,r=Ju(o+56|0,o),o8(f,k,1886545261,r),f=i[r>>2],!f))break t;i[r+4>>2]=f,Z(f)}g2(o+48|0)}if(r=u[o+140|0],(r|0)!=255&&(f=i[25177],i[o+56>>2]=i[25176],i[o+60>>2]=f,W[i[(o+56|0)+(r<<2)>>2]](o+48|0,o+120|0)),r=i[o+84>>2],r&&W[i[i[o+80>>2]+40>>2]](r),r=u[o+164|0],(r|0)!=255&&(f=i[25173],i[o+120>>2]=i[25172],i[o+124>>2]=f,W[i[(o+120|0)+(r<<2)>>2]](o+68|0,o+144|0)),g2(o+88|0),s)break A}i[o+128>>2]=0,i[o+120>>2]=0,i[o+124>>2]=0,L1(o+144|0,i[e+48>>2],i[i[o+216>>2]+196>>2],o+120|0),r=i[o+148>>2],e=i[o+144>>2],i[o+96>>2]=e,i[o+100>>2]=r,t[o+115|0]<0&&(Z(i[o+104>>2]),e=i[o+96>>2]),r=i[o+156>>2],i[o+104>>2]=i[o+152>>2],i[o+108>>2]=r,i[o+112>>2]=i[o+160>>2];k:{if(e){if(e=i[o+100>>2],i[A>>2]=i[o+96>>2],i[A+4>>2]=e,e=A+8|0,t[o+115|0]>=0){r=i[o+108>>2],i[e>>2]=i[o+104>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+112>>2],e=1;break k}T(e,i[o+104>>2],i[o+108>>2]),e=1;break k}if(w=0,i[o+24>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,l=i[o+216>>2],k=0,n=0,e=i[o+120>>2],f=i[o+124>>2],(e|0)!=(f|0)){if(r=f-e|0,(r|0)<0)break i;for(n=C(r),i[o+16>>2]=n,w=r+n|0,i[o+24>>2]=w,k=n;i[k>>2]=i[e>>2],r=i[e+4>>2],i[k+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),k=k+8|0,e=e+8|0,(f|0)!=(e|0););i[o+20>>2]=k}if(r=i[l+184>>2],r){if(e=i[l+188>>2],f=r,(e|0)!=(f|0)){for(;;){f=i[e-4>>2];n:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break n;W[i[i[f>>2]+8>>2]](f),y(f)}if(e=e-8|0,(r|0)==(e|0))break}w=i[o+24>>2],k=i[o+20>>2],n=i[o+16>>2],f=i[l+184>>2]}i[l+188>>2]=r,Z(f)}i[l+192>>2]=w,i[l+188>>2]=k,i[l+184>>2]=n,i[o+24>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,W[i[i[l>>2]+100>>2]](l),e=i[o+216>>2],r=i[o+220>>2],i[o+216>>2]=0,i[o+220>>2]=0,i[A>>2]=e,i[A+4>>2]=r,e=0}if(t[A+20|0]=e,A=i[o+120>>2],!A)break A;if(e=A,k=i[o+124>>2],(e|0)!=(k|0)){for(;;){e=i[k-4>>2];k:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break k;W[i[i[e>>2]+8>>2]](e),y(e)}if(k=k-8|0,(A|0)==(k|0))break}e=i[o+120>>2]}i[o+124>>2]=A,Z(e)}if(t[o+115|0]>=0)break f;Z(i[o+104>>2])}A=i[o+172>>2];f:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break f;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[o+220>>2];f:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break f;W[i[i[A>>2]+8>>2]](A),y(A)}v=o+224|0;return}e2(),M()}I0(),M()}s0(),M()}function wv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=78468,o=i[19620],i[f+24>>2]=o,n=i[o-12>>2],o=f+24|0,i[n+o>>2]=i[19621],n=o+i[i[f+24>>2]-12>>2]|0,k=f+28|0,J0(n,k),t[n+80|0]=0,i[n+72>>2]=0,i[f+80>>2]=78468,i[f+24>>2]=78448,m=R0(k),i[m>>2]=77200,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,n=f+164|0,J2(n,e,r),k=o,l=n,o=t[f+175|0],n=(o|0)<0,F(k,n?i[f+164>>2]:l,n?i[f+168>>2]:o),t[f+175|0]<0&&Z(i[f+164>>2]),o=f+164|0,k0(o,r),k=o,o=t[f+175|0],n=(o|0)<0,F(f+24|0,n?i[f+164>>2]:k,n?i[f+168>>2]:o),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(D0(F(f+24|0,34661,23),u[e+100|0]),47878,1),o=f+164|0,k0(o,r),l=o,o=t[f+175|0],n=(o|0)<0,F(k,n?i[f+164>>2]:l,n?i[f+168>>2]:o),t[f+175|0]<0&&Z(i[f+164>>2]),o=f+8|7,n=f+18|0,h=F(D0(F(k,34638,22),u[e+101|0]),30581,2);i:{e:{r:{f:{A:{k:{n:{t:{o:{l:{u:{s:switch(k=u[e+101|0],k-66|0){case 0:break r;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 12:case 13:case 14:case 15:case 16:case 17:case 18:case 19:case 20:case 21:case 23:case 24:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 32:case 33:case 35:case 36:case 37:case 38:case 39:case 40:case 41:case 42:case 43:case 45:case 46:case 47:case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:break A;case 11:break u;case 22:break l;case 34:break o;case 44:break t;case 56:break n;default:break s}if((k|0)==244)break k;if((k|0)!=44)break A;n=C(16),i[f+8>>2]=n,i[f+12>>2]=11,i[f+16>>2]=-2147483632,o=u[23182]|u[23183]<<8|(u[23184]<<16|u[23185]<<24),k=u[23178]|u[23179]<<8|(u[23180]<<16|u[23181]<<24),t[n|0]=k,t[n+1|0]=k>>>8,t[n+2|0]=k>>>16,t[n+3|0]=k>>>24,t[n+4|0]=o,t[n+5|0]=o>>>8,t[n+6|0]=o>>>16,t[n+7|0]=o>>>24,t[n+11|0]=0,o=u[23185]|u[23186]<<8|(u[23187]<<16|u[23188]<<24),t[n+7|0]=o,t[n+8|0]=o>>>8,t[n+9|0]=o>>>16,t[n+10|0]=o>>>24;break e}o=f+8|4,i[f+8>>2]=1852399949,t[f+19|0]=4,k=4;break f}o=f+16|0,i[f+8>>2]=1702131781,i[f+12>>2]=1684366446,t[f+19|0]=8,k=8;break f}n=C(16),i[f+8>>2]=n,i[f+12>>2]=12,i[f+16>>2]=-2147483632,o=u[4138]|u[4139]<<8|(u[4140]<<16|u[4141]<<24),k=u[4134]|u[4135]<<8|(u[4136]<<16|u[4137]<<24),t[n|0]=k,t[n+1|0]=k>>>8,t[n+2|0]=k>>>16,t[n+3|0]=k>>>24,t[n+4|0]=o,t[n+5|0]=o>>>8,t[n+6|0]=o>>>16,t[n+7|0]=o>>>24,t[n+12|0]=0,o=u[4142]|u[4143]<<8|(u[4144]<<16|u[4145]<<24),t[n+8|0]=o,t[n+9|0]=o>>>8,t[n+10|0]=o>>>16,t[n+11|0]=o>>>24;break e}t[f+19|0]=7,i[f+8>>2]=u[23869]|u[23870]<<8|(u[23871]<<16|u[23872]<<24),n=u[23872]|u[23873]<<8|(u[23874]<<16|u[23875]<<24),t[f+11|0]=n,t[f+12|0]=n>>>8,t[f+13|0]=n>>>16,t[f+14|0]=n>>>24,k=7;break f}X[f+16>>1]=u[23379]|u[23380]<<8,t[f+19|0]=10,o=u[23375]|u[23376]<<8|(u[23377]<<16|u[23378]<<24),i[f+8>>2]=u[23371]|u[23372]<<8|(u[23373]<<16|u[23374]<<24),i[f+12>>2]=o,o=n,k=10;break f}X[f+16>>1]=u[23175]|u[23176]<<8,t[f+19|0]=10,o=u[23171]|u[23172]<<8|(u[23173]<<16|u[23174]<<24),i[f+8>>2]=u[23167]|u[23168]<<8|(u[23169]<<16|u[23170]<<24),i[f+12>>2]=o,o=n,k=10;break f}t[f+19|0]=7,i[f+8>>2]=u[8714]|u[8715]<<8|(u[8716]<<16|u[8717]<<24),n=u[8717]|u[8718]<<8|(u[8719]<<16|u[8720]<<24),t[f+11|0]=n,t[f+12|0]=n>>>8,t[f+13|0]=n>>>16,t[f+14|0]=n>>>24,k=7}t[o|0]=0,n=f+8|0;break i}n=C(24),i[f+8>>2]=n,i[f+12>>2]=20,i[f+16>>2]=-2147483624,o=u[13999]|u[14e3]<<8|(u[14001]<<16|u[14002]<<24),k=u[13995]|u[13996]<<8|(u[13997]<<16|u[13998]<<24),t[n|0]=k,t[n+1|0]=k>>>8,t[n+2|0]=k>>>16,t[n+3|0]=k>>>24,t[n+4|0]=o,t[n+5|0]=o>>>8,t[n+6|0]=o>>>16,t[n+7|0]=o>>>24,t[n+20|0]=0,o=u[14011]|u[14012]<<8|(u[14013]<<16|u[14014]<<24),t[n+16|0]=o,t[n+17|0]=o>>>8,t[n+18|0]=o>>>16,t[n+19|0]=o>>>24,o=u[14007]|u[14008]<<8|(u[14009]<<16|u[14010]<<24),k=u[14003]|u[14004]<<8|(u[14005]<<16|u[14006]<<24),t[n+8|0]=k,t[n+9|0]=k>>>8,t[n+10|0]=k>>>16,t[n+11|0]=k>>>24,t[n+12|0]=o,t[n+13|0]=o>>>8,t[n+14|0]=o>>>16,t[n+15|0]=o>>>24}k=i[f+12>>2]}o=F(F(h,n,k),47877,2),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],k=(n|0)<0,F(o,k?i[f+164>>2]:l,k?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),o=F(D0(F(o,32846,23),u[e+102|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],k=(n|0)<0,F(o,k?i[f+164>>2]:l,k?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),o=F(D0(F(o,34617,20),u[e+103|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],k=(n|0)<0,F(o,k?i[f+164>>2]:l,k?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),F(o,33558,15),t[f+19|0]<0&&Z(i[f+8>>2]);i:{e:switch(i[e+108>>2]){case 0:F(f+24|0,46945,6);break i;case 1:F(f+24|0,46938,6);break i;case 2:F(f+24|0,46931,6);break i;case 3:F(f+24|0,46924,6);break i;default:break e}F(f+24|0,38535,12)}o=f+164|0,k0(o,r),k=o,o=t[f+175|0],n=(o|0)<0,F(f+24|0,n?i[f+164>>2]:k,n?i[f+168>>2]:o),t[f+175|0]<0&&Z(i[f+164>>2]),o=F(D0(F(f+24|0,37425,16),u[e+112|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],k=(n|0)<0,F(o,k?i[f+164>>2]:l,k?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),F(D0(F(o,37461,18),u[e+113|0]),47878,1);i:{if(n=i[e+116>>2],Q=i[e+120>>2],(n|0)!=(Q|0))for(V=f+36|0;;){o=f+164|0,k0(o,r),l=o,o=t[f+175|0],k=(o|0)<0,F(f+24|0,k?i[f+164>>2]:l,k?i[f+168>>2]:o),t[f+175|0]<0&&Z(i[f+164>>2]),F(f+24|0,37511,5);e:{if(o=i[n>>2],G=i[n+4>>2],(o|0)==(G|0))break e;for(;;){s=u[o|0],k=i[f+24>>2],h=i[k-12>>2]+(f+24|0)|0,u[h+80|0]||(l=f+164|0,k=i[h+28>>2],i[l>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(l,137008),W[i[i[k>>2]+28>>2]](k,32)|0,i2(l),k=i[f+24>>2]),t[h+76|0]=48,t[h+77|0]=0,t[h+78|0]=0,t[h+79|0]=0,t[h+80|0]=1,k=k-12|0,i[V+i[k>>2]>>2]=2,k=i[k>>2]+m|0,i[k>>2]=i[k>>2]&-75|8;r:{_=D0(f+24|0,s),I=X1(f+8|0,_);f:{if(u[I|0]!=1)break f;l=_+i[i[_>>2]-12>>2]|0,B=i[l+4>>2],w=i[l+24>>2];A:{if(u[l+80|0]==1){h=u[l+76|0]|u[l+77|0]<<8|(u[l+78|0]<<16|u[l+79|0]<<24);break A}s=f+164|0,k=i[l+28>>2],i[s>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(s,137008),h=W[i[i[k>>2]+28>>2]](k,32)|0,i2(s),t[l+76|0]=h,t[l+77|0]=h>>>8,t[l+78|0]=h>>>16,t[l+79|0]=h>>>24,t[l+80|0]=1}A:{if(!w||(k=i[l+12>>2],B=(B&176)==32?37887:37886,s=B-37886|0,(s|0)>0&&(W[i[i[w>>2]+48>>2]](w,37886,s)|0)!=(s|0)))break A;if((k|0)>=2){if(k>>>0>=2147483641)break r;s=((k|0)<=1?1:k)-1|0;k:{if(k>>>0>=12){Y=s|7,k=C(Y+1|0),i[f+172>>2]=Y-2147483647,i[f+164>>2]=k,i[f+168>>2]=s;break k}t[f+175|0]=s,k=f+164|0}if(s&&l0(k,h,s),t[k+s|0]=0,k=W[i[i[w>>2]+48>>2]](w,t[f+175|0]<0?i[f+164>>2]:f+164|0,s)|0,t[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(s|0))break A}if(k=37887-B|0,(k|0)>0&&(W[i[i[w>>2]+48>>2]](w,B,k)|0)!=(k|0))break A;i[l+12>>2]=0;break f}k=_+i[i[_>>2]-12>>2]|0,M1(k,i[k+16>>2]|5)}if(v1(I),o=o+1|0,(G|0)==(o|0))break e;continue}break}break i}if(F(f+24|0,47878,1),o=i[i[f+24>>2]-12>>2]+m|0,i[o>>2]=i[o>>2]&-75|2,n=n+12|0,(Q|0)==(n|0))break}if(n=i[e+140>>2],Q=i[e+144>>2],(n|0)!=(Q|0))for(V=f+36|0;;){o=f+164|0,k0(o,r),l=o,o=t[f+175|0],k=(o|0)<0,F(f+24|0,k?i[f+164>>2]:l,k?i[f+168>>2]:o),t[f+175|0]<0&&Z(i[f+164>>2]),F(f+24|0,37501,9);e:{if(o=i[n>>2],G=i[n+4>>2],(o|0)==(G|0))break e;for(;;){s=u[o|0],k=i[f+24>>2],h=i[k-12>>2]+(f+24|0)|0,u[h+80|0]||(l=f+164|0,k=i[h+28>>2],i[l>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(l,137008),W[i[i[k>>2]+28>>2]](k,32)|0,i2(l),k=i[f+24>>2]),t[h+76|0]=48,t[h+77|0]=0,t[h+78|0]=0,t[h+79|0]=0,t[h+80|0]=1,k=k-12|0,i[V+i[k>>2]>>2]=2,k=i[k>>2]+m|0,i[k>>2]=i[k>>2]&-75|8;r:{_=D0(f+24|0,s),I=X1(f+8|0,_);f:{if(u[I|0]!=1)break f;l=_+i[i[_>>2]-12>>2]|0,B=i[l+4>>2],w=i[l+24>>2];A:{if(u[l+80|0]==1){h=u[l+76|0]|u[l+77|0]<<8|(u[l+78|0]<<16|u[l+79|0]<<24);break A}s=f+164|0,k=i[l+28>>2],i[s>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(s,137008),h=W[i[i[k>>2]+28>>2]](k,32)|0,i2(s),t[l+76|0]=h,t[l+77|0]=h>>>8,t[l+78|0]=h>>>16,t[l+79|0]=h>>>24,t[l+80|0]=1}A:{if(!w||(k=i[l+12>>2],B=(B&176)==32?37887:37886,s=B-37886|0,(s|0)>0&&(W[i[i[w>>2]+48>>2]](w,37886,s)|0)!=(s|0)))break A;if((k|0)>=2){if(k>>>0>=2147483641)break r;s=((k|0)<=1?1:k)-1|0;k:{if(k>>>0>=12){Y=s|7,k=C(Y+1|0),i[f+172>>2]=Y-2147483647,i[f+164>>2]=k,i[f+168>>2]=s;break k}t[f+175|0]=s,k=f+164|0}if(s&&l0(k,h,s),t[k+s|0]=0,k=W[i[i[w>>2]+48>>2]](w,t[f+175|0]<0?i[f+164>>2]:f+164|0,s)|0,t[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(s|0))break A}if(k=37887-B|0,(k|0)>0&&(W[i[i[w>>2]+48>>2]](w,B,k)|0)!=(k|0))break A;i[l+12>>2]=0;break f}k=_+i[i[_>>2]-12>>2]|0,M1(k,i[k+16>>2]|5)}if(v1(I),o=o+1|0,(G|0)==(o|0))break e;continue}break}break i}if(F(f+24|0,47878,1),o=i[i[f+24>>2]-12>>2]+m|0,i[o>>2]=i[o>>2]&-75|2,n=n+12|0,(Q|0)==(n|0))break}if(n=i[e+128>>2],B=i[e+132>>2],(n|0)!=(B|0))for(Q=f+36|0;;){e=f+164|0,k0(e,r),k=e,e=t[f+175|0],o=(e|0)<0,F(f+24|0,o?i[f+164>>2]:k,o?i[f+168>>2]:e),t[f+175|0]<0&&Z(i[f+164>>2]),F(f+24|0,37517,5);e:{if(o=i[n>>2],V=i[n+4>>2],(o|0)==(V|0))break e;for(;;){l=u[o|0],k=i[f+24>>2],e=i[k-12>>2]+(f+24|0)|0,u[e+80|0]||(h=f+164|0,k=i[e+28>>2],i[h>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(h,137008),W[i[i[k>>2]+28>>2]](k,32)|0,i2(h),k=i[f+24>>2]),t[e+76|0]=48,t[e+77|0]=0,t[e+78|0]=0,t[e+79|0]=0,t[e+80|0]=1,e=k-12|0,i[Q+i[e>>2]>>2]=2,e=i[e>>2]+m|0,i[e>>2]=i[e>>2]&-75|8;r:{w=D0(f+24|0,l),G=X1(f+8|0,w);f:{if(u[G|0]!=1)break f;e=w+i[i[w>>2]-12>>2]|0,_=i[e+4>>2],s=i[e+24>>2];A:{if(u[e+80|0]==1){h=u[e+76|0]|u[e+77|0]<<8|(u[e+78|0]<<16|u[e+79|0]<<24);break A}l=f+164|0,k=i[e+28>>2],i[l>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(l,137008),h=W[i[i[k>>2]+28>>2]](k,32)|0,i2(l),t[e+76|0]=h,t[e+77|0]=h>>>8,t[e+78|0]=h>>>16,t[e+79|0]=h>>>24,t[e+80|0]=1}A:{if(!s||(k=i[e+12>>2],_=(_&176)==32?37887:37886,l=_-37886|0,(l|0)>0&&(W[i[i[s>>2]+48>>2]](s,37886,l)|0)!=(l|0)))break A;if((k|0)>=2){if(k>>>0>=2147483641)break r;l=((k|0)<=1?1:k)-1|0;k:{if(k>>>0>=12){I=l|7,k=C(I+1|0),i[f+172>>2]=I-2147483647,i[f+164>>2]=k,i[f+168>>2]=l;break k}t[f+175|0]=l,k=f+164|0}if(l&&l0(k,h,l),t[k+l|0]=0,k=W[i[i[s>>2]+48>>2]](s,t[f+175|0]<0?i[f+164>>2]:f+164|0,l)|0,t[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(l|0))break A}if(k=37887-_|0,(k|0)>0&&(W[i[i[s>>2]+48>>2]](s,_,k)|0)!=(k|0))break A;i[e+12>>2]=0;break f}e=w+i[i[w>>2]-12>>2]|0,M1(e,i[e+16>>2]|5)}if(v1(G),o=o+1|0,(V|0)==(o|0))break e;continue}break}break i}if(F(f+24|0,47878,1),e=i[i[f+24>>2]-12>>2]+m|0,i[e>>2]=i[e>>2]&-75|2,n=n+12|0,(B|0)==(n|0))break}e=i[f+76>>2];e:{r:{if(e&16){n=i[f+72>>2],e=i[f+52>>2],n>>>0<e>>>0&&(i[f+72>>2]=e,n=e),e=f+48|0;break r}if(!(e&8)){n=0,t[A+11|0]=0;break e}n=i[f+44>>2],e=f+36|0}r:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){o=n|7,e=C(o+1|0),i[A+8>>2]=o-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break r}if(t[A+11|0]=n,n)break r;n=0;break e}I0(),M()}if(!n)break e;z(A,r,n)}t[A+n|0]=0,A=i[19619],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[19622],i[m>>2]=77200,t[f+71|0]<0&&Z(i[f+60>>2]),y0(m),Y0(f+80|0),v=f+176|0;return}I0(),M()}function _v(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=D(0),w=D(0),_=0,B=0,m=0,G=0,I=D(0),Q=0,V=0,Y=0,E=D(0),R=0,N=0,U=0,x=0,j=D(0),O=D(0),S=D(0),q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0;e=v-160|0,v=e,f=i[r>>2],Q=i[f+192>>2],_=i[f+188>>2],n=C(248),i[n>>2]=101168,f=n,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,U=f+12|0,i[f+176>>2]=U,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),f=i[k+4>>2],o=f>>>0<4,t1(U,_,Q,0,f),V0=u[k+8|0],C0=i[i[r>>2]+200>>2],a0(e+136|0,U,0,_,Q,8,l,0),g0=_-1|0,f=f<<3,R=(o?16908801>>>f|0:0)&3,V=(g0+R>>>0)/(R>>>0)|0,X0=Q-1|0,Y=(o?16843265>>>f|0:0)&3,o=(X0+Y>>>0)/(Y>>>0)|0,a0(e+112|0,U,1,V,o,8,l,0),f=e+16|0;i:{if(i[e+136>>2]){if(B=i[e+140>>2],i[e+8>>2]=i[e+136>>2],i[e+12>>2]=B,t[e+155|0]>=0){B=i[e+148>>2],i[f>>2]=i[e+144>>2],i[f+4>>2]=B,i[f+8>>2]=i[e+152>>2];break i}T(f,i[e+144>>2],i[e+148>>2]);break i}if(B=i[e+116>>2],i[e+8>>2]=i[e+112>>2],i[e+12>>2]=B,t[e+131|0]>=0){B=i[e+124>>2],i[f>>2]=i[e+120>>2],i[f+4>>2]=B,i[f+8>>2]=i[e+128>>2];break i}T(f,i[e+120>>2],i[e+124>>2])}a0(e+88|0,U,2,V,o,8,l,0),o=e+56|0;i:{if(i[e+8>>2]){if(V=i[e+12>>2],i[e+48>>2]=i[e+8>>2],i[e+52>>2]=V,t[e+27|0]>=0){V=i[f+4>>2],i[o>>2]=i[f>>2],i[o+4>>2]=V,i[o+8>>2]=i[f+8>>2];break i}T(o,i[e+16>>2],i[e+20>>2]);break i}if(f=i[e+92>>2],i[e+48>>2]=i[e+88>>2],i[e+52>>2]=f,t[e+107|0]>=0){f=i[e+100>>2],i[o>>2]=i[e+96>>2],i[o+4>>2]=f,i[o+8>>2]=i[e+104>>2];break i}T(o,i[e+96>>2],i[e+100>>2])}t[e+107|0]<0&&Z(i[e+96>>2]),t[e+27|0]<0&&Z(i[e+16>>2]),t[e+131|0]<0&&Z(i[e+120>>2]),t[e+155|0]<0&&Z(i[e+144>>2]);i:{e:{if(i[e+48>>2]){if(r=i[e+52>>2],i[A>>2]=i[e+48>>2],i[A+4>>2]=r,r=A+8|0,t[e+67|0]>=0){f=i[o+4>>2],i[r>>2]=i[o>>2],i[r+4>>2]=f,i[r+8>>2]=i[o+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+56>>2],i[e+60>>2]),r=t[e+67|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+56>>2]);break e}t[e+67|0]<0&&Z(i[e+56>>2]);r:{if(!(V0&1))break r;if(a0(e+48|0,U,6,_,Q,8,l,0),i[e+48>>2]){if(r=i[e+52>>2],i[A>>2]=i[e+48>>2],i[A+4>>2]=r,r=A+8|0,t[e+67|0]>=0){f=i[e+60>>2],i[r>>2]=i[e+56>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+64>>2],t[A+20|0]=1;break e}if(T(r,i[e+56>>2],i[e+60>>2]),r=t[e+67|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+56>>2]);break e}if(t[e+67|0]>=0)break r;Z(i[e+56>>2])}r=Q0(i[r>>2],10),r?(q=i[r+40>>2],f=i[r+52>>2]):f=0,r=Q0(U,0),r?(m=i[r+52>>2],r=i[r+40>>2]):r=0,o=Q0(U,1),o?(c=i[o+40>>2],B=i[o+52>>2]):B=0,o=Q0(U,2),o?(A0=i[o+52>>2],x=i[o+40>>2]):x=0,V=0;r:{if(!(V0&1)||(o=Q0(U,6),V=0,!o))break r;d=i[o+40>>2],V=i[o+52>>2]}i[e+84>>2]=-1113159960,i[e+76>>2]=1056964608,i[e+80>>2]=-1093247418,i[e+68>>2]=-1096180881,i[e+72>>2]=1056964608,i[e+60>>2]=1038710997,i[e+64>>2]=-1104361250,i[e+52>>2]=1050220167,i[e+56>>2]=1058424226,t[e+48|0]=1,G=u[k+26|0],g3(e+8|0,p[k+24>>1],p[k+20>>1]),k=i[e+44>>2],i[e+80>>2]=i[e+40>>2],i[e+84>>2]=k,k=i[e+36>>2],i[e+72>>2]=i[e+32>>2],i[e+76>>2]=k,o=i[e+28>>2],k=e- -64|0,i[k>>2]=i[e+24>>2],i[k+4>>2]=o,k=i[e+20>>2],i[e+56>>2]=i[e+16>>2],i[e+60>>2]=k,k=i[e+12>>2],i[e+48>>2]=i[e+8>>2],i[e+52>>2]=k,N=(C0|0)==11?4:3;r:{f:{A:{if(Q){if(_){o=0;k:{if(G&1)for(;;){for(t0=r+g(o,m)|0,l=g(f,o)+q|0,k=0;_0=k+t0|0,h=D(D(D(D(u[l+2|0])*E0[e+60>>2])+D(D(D(u[l|0])*E0[e+52>>2])+D(E0[e+56>>2]*D(u[l+1|0]))))+D(.5)),D(B2(h))<D(2147483648)?s=~~h:s=-2147483648,s=(s|0)>=255?255:s,t[_0|0]=(s|0)>0?s:0,l=l+N|0,k=k+1|0,(_|0)!=(k|0););if(o=o+1|0,(Q|0)==(o|0))break k}for(;;){for(t0=r+g(o,m)|0,l=g(f,o)+q|0,k=0;_0=k+t0|0,h=D(D(D(D(D(u[l+2|0])*E0[e+60>>2])+D(D(D(u[l|0])*E0[e+52>>2])+D(E0[e+56>>2]*D(u[l+1|0]))))*D(.8554700016975403))+D(.5)),D(B2(h))<D(2147483648)?s=~~h:s=-2147483648,t[_0|0]=(s|0)<0?16:(s>>>0>=219?219:s)+16|0,l=l+N|0,k=k+1|0,(_|0)!=(k|0););if(o=o+1|0,(Q|0)==(o|0))break}}if(l=(Y|0)==1,(R|0)!=1|(Y|0)!=1)break A;for(Y=G&1,r=0;;){s=g(r,A0)+x|0,m=g(r,B)+c|0,l=g(r,f)+q|0,k=0,o=0;k:{if(!Y){for(;;)if(h=E0[e+84>>2],w=E0[e+76>>2],E=E0[e+80>>2],G=k+m|0,I=D(u[l+2|0]),j=D(u[l|0]),O=D(u[l+1|0]),S=D(D(D(D(D(I*E0[e+72>>2])+D(D(j*E0[e+64>>2])+D(E0[e+68>>2]*O)))*D(.875))+D(128))+D(.5)),D(B2(S))<D(2147483648)?o=~~S:o=-2147483648,o=(o|0)>=255?255:o,t[G|0]=(o|0)>0?o:0,G=k+s|0,h=D(D(D(D(D(I*h)+D(D(j*w)+D(E*O)))*D(.875))+D(128))+D(.5)),D(B2(h))<D(2147483648)?o=~~h:o=-2147483648,o=(o|0)>=255?255:o,t[G|0]=(o|0)>0?o:0,l=l+N|0,k=k+1|0,(_|0)==(k|0))break k}for(;h=E0[e+84>>2],w=E0[e+76>>2],E=E0[e+80>>2],G=o+m|0,I=D(u[l+2|0]),j=D(u[l|0]),O=D(u[l+1|0]),S=D(D(D(D(I*E0[e+72>>2])+D(D(j*E0[e+64>>2])+D(E0[e+68>>2]*O)))+D(128))+D(.5)),D(B2(S))<D(2147483648)?k=~~S:k=-2147483648,k=(k|0)>=255?255:k,t[G|0]=(k|0)>0?k:0,G=o+s|0,h=D(D(D(D(I*h)+D(D(j*w)+D(E*O)))+D(128))+D(.5)),D(B2(h))<D(2147483648)?k=~~h:k=-2147483648,k=(k|0)>=255?255:k,t[G|0]=(k|0)>0?k:0,l=l+N|0,o=o+1|0,(_|0)!=(o|0););}if(r=r+1|0,(Q|0)==(r|0))break}break f}if(r=(Y|0)==1,l=r,(R|0)!=1)break A;if(r)break r;break A}if(r=(Y|0)==1,l=r,(R|0)!=1)break A;if(r)break f}if(r=(R|0)!=2,!(r|(Y|0)!=2)){Y=Q&-2;A:{if(!Y||(R=_&-2,!R))break A;for(t0=N<<1,r=0;;){for(l=g(r,f)+q|0,k=r>>>1|0,_0=g(k,A0)+x|0,r0=g(k,B)+c|0,o=0;;){k=l+N|0,s=k+f|0,m=f+l|0,w=D((u[s+2|0]+(u[m+2|0]+(u[k+2|0]+u[l+2|0]|0)|0)>>>2&255)>>>0),E=D((u[s|0]+(u[m|0]+(u[k|0]+u[l|0]|0)|0)>>>2&255)>>>0),I=D((u[s+1|0]+(u[m+1|0]+(u[k+1|0]+u[l+1|0]|0)|0)>>>2&255)>>>0),h=D(D(w*E0[e+84>>2])+D(D(E*E0[e+76>>2])+D(E0[e+80>>2]*I))),w=D(D(w*E0[e+72>>2])+D(D(E*E0[e+64>>2])+D(E0[e+68>>2]*I))),s=o>>>1|0,k=s+_0|0,l=l+t0|0,m=s+r0|0;k:{if(!(G&1)){h=D(D(h*D(.875))+D(128)),w=D(D(D(w*D(.875))+D(128))+D(.5)),D(B2(w))<D(2147483648)?s=~~w:s=-2147483648,s=(s|0)>=255?255:s,s=(s|0)>0?s:0;break k}h=D(h+D(128)),w=D(D(w+D(128))+D(.5)),D(B2(w))<D(2147483648)?s=~~w:s=-2147483648,s=(s|0)>=255?255:s,s=(s|0)>0?s:0}if(t[m|0]=s,m=k,h=D(h+D(.5)),D(B2(h))<D(2147483648)?s=~~h:s=-2147483648,k=(s|0)>=255?255:s,t[m|0]=(k|0)>0?k:0,o=o+2|0,!(R>>>0>o>>>0))break}if(r=r+2|0,!(Y>>>0>r>>>0))break}}if(_&1){if(!Q)break f;for(m=f<<1,r=g0>>>1|0,Y=r+x|0,R=r+c|0,l=g(N,g0)+q|0,k=0;;){o=u[l|0];A:{if((k|1)>>>0<Q>>>0){s=f+l|0,o=u[s|0]+(o&255)>>>1|0,r=u[s+2|0]+u[l+2|0]>>>1|0,s=u[s+1|0]+u[l+1|0]>>>1|0;break A}r=u[l+2|0],s=u[l+1|0]}w=D((r&255)>>>0),E=D((o&255)>>>0),I=D((s&255)>>>0),h=D(D(w*E0[e+84>>2])+D(D(E*E0[e+76>>2])+D(E0[e+80>>2]*I))),w=D(D(w*E0[e+72>>2])+D(D(E*E0[e+64>>2])+D(E0[e+68>>2]*I))),o=k>>>1|0,r=Y+g(o,A0)|0,s=R+g(o,B)|0;A:{if(G&1){h=D(h+D(128)),w=D(D(w+D(128))+D(.5)),D(B2(w))<D(2147483648)?o=~~w:o=-2147483648,o=(o|0)>=255?255:o,o=(o|0)>0?o:0;break A}h=D(D(h*D(.875))+D(128)),w=D(D(D(w*D(.875))+D(128))+D(.5)),D(B2(w))<D(2147483648)?o=~~w:o=-2147483648,o=(o|0)>=255?255:o,o=(o|0)>0?o:0}if(t[s|0]=o,s=r,h=D(h+D(.5)),D(B2(h))<D(2147483648)?o=~~h:o=-2147483648,r=(o|0)>=255?255:o,t[s|0]=(r|0)>0?r:0,l=l+m|0,k=k+2|0,!(Q>>>0>k>>>0))break}}if(!(Q&1)|!_)break f;for(s=N<<1,l=g(f,X0)+q|0,r=X0>>>1|0,x=g(r,A0)+x|0,m=g(r,B)+c|0,k=0;;){o=u[l|0];A:{if(_>>>0>(k|1)>>>0){B=l+N|0,o=u[B|0]+(o&255)>>>1|0,r=u[B+2|0]+u[l+2|0]>>>1|0,B=u[B+1|0]+u[l+1|0]>>>1|0;break A}r=u[l+2|0],B=u[l+1|0]}w=D((r&255)>>>0),E=D((o&255)>>>0),I=D((B&255)>>>0),h=D(D(w*E0[e+84>>2])+D(D(E*E0[e+76>>2])+D(E0[e+80>>2]*I))),w=D(D(w*E0[e+72>>2])+D(D(E*E0[e+64>>2])+D(E0[e+68>>2]*I))),o=k>>>1|0,r=o+x|0,B=o+m|0;A:{if(G&1){h=D(h+D(128)),w=D(D(w+D(128))+D(.5)),D(B2(w))<D(2147483648)?o=~~w:o=-2147483648,o=(o|0)>=255?255:o,o=(o|0)>0?o:0;break A}h=D(D(h*D(.875))+D(128)),w=D(D(D(w*D(.875))+D(128))+D(.5)),D(B2(w))<D(2147483648)?o=~~w:o=-2147483648,o=(o|0)>=255?255:o,o=(o|0)>0?o:0}if(t[B|0]=o,B=r,h=D(h+D(.5)),D(B2(h))<D(2147483648)?o=~~h:o=-2147483648,r=(o|0)>=255?255:o,t[B|0]=(r|0)>0?r:0,l=l+s|0,k=k+2|0,!(_>>>0>k>>>0))break}break f}if(!_|(!Q|(r|l^1)))break f;for(o=N<<1,m=0,Y=G&1;;){s=g(m,A0)+x|0,N=g(B,m)+c|0,l=g(f,m)+q|0,k=0;A:{if(!Y){for(;;)if(h=E0[e+84>>2],w=E0[e+76>>2],E=E0[e+80>>2],G=k>>>1|0,R=G+N|0,I=D(u[l+2|0]),j=D(u[l|0]),O=D(u[l+1|0]),S=D(D(D(D(D(I*E0[e+72>>2])+D(D(j*E0[e+64>>2])+D(E0[e+68>>2]*O)))*D(.875))+D(128))+D(.5)),D(B2(S))<D(2147483648)?r=~~S:r=-2147483648,r=(r|0)>=255?255:r,t[R|0]=(r|0)>0?r:0,G=s+G|0,h=D(D(D(D(D(I*h)+D(D(j*w)+D(E*O)))*D(.875))+D(128))+D(.5)),D(B2(h))<D(2147483648)?r=~~h:r=-2147483648,r=(r|0)>=255?255:r,t[G|0]=(r|0)>0?r:0,l=o+l|0,k=k+2|0,!(_>>>0>k>>>0))break A}for(;h=E0[e+84>>2],w=E0[e+76>>2],E=E0[e+80>>2],G=k>>>1|0,R=G+N|0,I=D(u[l+2|0]),j=D(u[l|0]),O=D(u[l+1|0]),S=D(D(D(D(I*E0[e+72>>2])+D(D(j*E0[e+64>>2])+D(E0[e+68>>2]*O)))+D(128))+D(.5)),D(B2(S))<D(2147483648)?r=~~S:r=-2147483648,r=(r|0)>=255?255:r,t[R|0]=(r|0)>0?r:0,G=s+G|0,h=D(D(D(D(I*h)+D(D(j*w)+D(E*O)))+D(128))+D(.5)),D(B2(h))<D(2147483648)?r=~~h:r=-2147483648,r=(r|0)>=255?255:r,t[G|0]=(r|0)>0?r:0,l=o+l|0,k=k+2|0,_>>>0>k>>>0;);}if(m=m+1|0,(Q|0)==(m|0))break}}if(!_|(!(V0&1)|!Q))break r;if((C0|0)!=11){if(k=0,l=0,X0>>>0>=3)for(f=Q&-4,o=0;r=!_,r||l0(g(l,V)+d|0,255,_),r||l0(g(l|1,V)+d|0,255,_),r||l0(g(l|2,V)+d|0,255,_),r||l0(g(l|3,V)+d|0,255,_),l=l+4|0,o=o+4|0,(f|0)!=(o|0););if(r=Q&3,!r)break r;for(;_&&l0(g(l,V)+d|0,255,_),l=l+1|0,k=k+1|0,(r|0)!=(k|0););break r}for(s=q+3|0,N=_&-4,x=_&3,r=0;;){if(o=g(r,V)+d|0,B=s+g(r,f)|0,l=0,k=0,g0>>>0>=3)for(;t[o+l|0]=u[B+(l<<2)|0],_=l|1,t[_+o|0]=u[B+(_<<2)|0],_=l|2,t[_+o|0]=u[B+(_<<2)|0],_=l|3,t[_+o|0]=u[B+(_<<2)|0],l=l+4|0,k=k+4|0,(N|0)!=(k|0););if(k=0,x)for(;t[o+l|0]=u[B+(l<<2)|0],l=l+1|0,k=k+1|0,(x|0)!=(k|0););if(r=r+1|0,(Q|0)==(r|0))break}}t[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=U;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=e+160|0}function Ge(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;w=v-32|0,v=w,u[115885]==1&&(i[w+16>>2]=A,q8(37971,w+16|0));i:{k=i[A+4>>2];e:{if(k){if(n=i[k>>2],(n|0)==1){k=i[A>>2];break e}if((n|0)<=1)break i;i[k>>2]=n-1}u[115885]==1&&(i[w>>2]=A,q8(47852,w)),k=C(172),i[A>>2]=k,l0(k,0,172),s=A,A=C(4),i[s+4>>2]=A,i[A>>2]=1}e:{r:{f:{A:{k:{n:{t:{o:{l:{u:{s:{h:{w:{_:{v:{if((e|0)<=0){A=(r|0)>=51?51:r,n=(A|0)>0?A:0;break v}if(o=e-1|0,f=g(o,12)+65104|0,A=i[f>>2],r=(r|0)>=51?51:r,n=(r|0)>0?r:0,A=((A<<3&120)+(g(n,g(A>>4,5)-45|0)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+5|0,(s&127)>>>0>=63||(t[k+5|0]=A,A=i[f+4>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+6|0,(s&127)>>>0>62)||(t[k+6|0]=A,A=i[f+8>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+7|0,(f&127)>>>0>62))break k;if(t[k+7|0]=A,A=o<<2,r=i[A+65128>>2],r=((r<<3&120)+(g(g(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,f=r?f^64:63-f|0,r=f<<1|r,(f&127)>>>0>=63)break _;if(t[k+149|0]=r,r=i[A+65136>>2],r=((r<<3&120)+(g(g(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,f=r?f^64:63-f|0,r=f<<1|r,(f&127)>>>0>=63)break w;if(t[k+147|0]=r,A=i[A+65144>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,r=A?r^64:63-r|0,A=r<<1|A,(r&127)>>>0>=63)break h;if(t[k+148|0]=A,A=g(n,-20)>>4,r=(A|0)>-41,f=r?A+104^64:-41-A|0,A=r|f<<1,r=k+156|0,(f&127)>>>0>=63||(t[k+156|0]=A,f=g(n,-25)>>4,o=-41-f|0,_=f+104^64,s=(f|0)>-41,A=s,l=A?_:o,A=l<<1|A,r=k+157|0,(l&127)>>>0>62)||(t[k+157|0]=A,A=g(n,-30)>>4,r=(A|0)>-41,l=r?A+104^64:-41-A|0,A=r|l<<1,r=k+158|0,(l&127)>>>0>62)||(t[k+158|0]=A,A=g(n,-40)>>4,r=(A|0)<=-103?-103:A,A=(A|0)>-41,l=A?r+104^64:-41-r|0,A=l<<1|A,r=k+159|0,(l&127)>>>0>62)||(A=g(A&255,257),t[k+159|0]=A,t[k+160|0]=A>>>8,t[k+154|0]=14,t[k+155|0]=14,l=(e|0)!=1?65160:65152,A=i[l>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,h=A?r^64:63-r|0,A=h<<1|A,r=k+150|0,(h&127)>>>0>=63)||(t[k+150|0]=A,A=i[l+4>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,l=A?r^64:63-r|0,A=l<<1|A,r=k+151|0,(l&127)>>>0>62))break k;if(t[k+151|0]=A,t[k+152|0]=30-(g(n,5)>>>3&62),r=s?_:o,A=s|r<<1,(r&127)>>>0>62)break s;if(t[k+153|0]=A,A=g(n,-5)>>4,r=(A|0)>-9,f=r?A+72^64:-9-A|0,A=r|f<<1,(f&127)>>>0>=63)break u;A=g(A&255,16843009),t[k+143|0]=A,t[k+144|0]=A>>>8,t[k+145|0]=A>>>16,t[k+146|0]=A>>>24}if(o=g(e,12),f=o+65168|0,A=i[f>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+2|0,(s&127)>>>0>=63||(t[k+2|0]=A,A=i[f+4>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+3|0,(s&127)>>>0>62)||(t[k+3|0]=A,A=i[f+8>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+4|0,(f&127)>>>0>62)||(t[k+4|0]=A,f=(((e|0)==2?5:e)<<2)+65216|0,A=i[f>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+8|0,(s&127)>>>0>=63)||(t[k+8|0]=A,A=i[f+4>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+9|0,(s&127)>>>0>62)||(t[k+9|0]=A,A=i[f+8>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+10|0,(s&127)>>>0>62)||(t[k+10|0]=A,A=i[f+12>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+11|0,(f&127)>>>0>62))break k;if(t[k+11|0]=A,s=e<<2,r=s,A=i[r+65252>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,f=(A|0)>=126?126:A,f=(f|0)<=1?1:f,A=(A|0)>63,f=A?f^64:63-f|0,A=f<<1|A,(f&127)>>>0>=63)break l;if(t[k+12|0]=A,A=i[r+65264>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,r=A?r^64:63-r|0,A=r<<1|A,(r&127)>>>0>=63)break o;if(t[k+13|0]=A,f=e?65288:65280,A=i[f>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,l=A?r^64:63-r|0,A=l<<1|A,r=k+14|0,(l&127)>>>0>=63||(t[k+14|0]=A,A=i[f+4>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+15|0,(f&127)>>>0>62)||(t[k+15|0]=A,f=(e<<4)+65296|0,A=i[f>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,l=A?r^64:63-r|0,A=l<<1|A,r=k+16|0,(l&127)>>>0>=63)||(t[k+16|0]=A,A=i[f+4>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,l=A?r^64:63-r|0,A=l<<1|A,r=k+17|0,(l&127)>>>0>62)||(t[k+17|0]=A,A=i[f+8>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,l=A?r^64:63-r|0,A=l<<1|A,r=k+18|0,(l&127)>>>0>62)||(t[k+18|0]=A,A=i[f+12>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+19|0,(f&127)>>>0>62)||(t[k+19|0]=A,f=o+65344|0,A=i[f>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+20|0,(o&127)>>>0>=63)||(t[k+20|0]=A,A=i[f+4>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+21|0,(o&127)>>>0>62)||(t[k+21|0]=A,A=i[f+8>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+22|0,(f&127)>>>0>62))break k;for(t[k+22|0]=A,l=k+25|0,o=g(e,72)+65392|0,A=0;;){if(r=i[o+(A<<2)>>2],r=((r<<3&120)+(g(g(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,h=r?f^64:63-f|0,f=h<<1|r,r=A+l|0,(h&127)>>>0>=63)break A;if(t[r|0]=f,A=A+1|0,(A|0)==18)break}for(l=k+43|0,A=0;;){if(r=i[o+(A<<2)>>2],r=((r<<3&120)+(g(g(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,h=r?f^64:63-f|0,f=h<<1|r,r=A+l|0,(h&127)>>>0>=63)break A;if(t[r|0]=f,A=A+1|0,(A|0)==18)break}if(f=(s<<2)+65616|0,A=i[f>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+61|0,(o&127)>>>0>=63||(t[k+61|0]=A,A=i[f+4>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+62|0,(o&127)>>>0>62)||(t[k+62|0]=A,A=i[f+8>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+63|0,(o&127)>>>0>62)||(t[k+63|0]=A,A=i[f+12>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k- -64|0,(f&127)>>>0>62))break k;for(t[r|0]=A,o=k+65|0,s=g(e,168)+65664|0,A=0;;){if(r=i[s+(A<<2)>>2],r=((r<<3&120)+(g(g(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,l=r?f^64:63-f|0,r=l<<1|r,f=A+o|0,(l&127)>>>0>=63)break f;if(t[f|0]=r,A=A+1|0,(A|0)==42)break}if(f=(e<<3)+66176|0,A=i[f>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+107|0,(o&127)>>>0>=63||(t[k+107|0]=A,A=i[f+4>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+108|0,(f&127)>>>0>62))break k;for(t[k+108|0]=A,o=k+109|0,s=g(e,96)+66208|0,A=0;;){if(r=i[s+(A<<2)>>2],r=((r<<3&120)+(g(g(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,l=r?f^64:63-f|0,r=l<<1|r,f=A+o|0,(l&127)>>>0>=63)break f;if(t[f|0]=r,A=A+1|0,(A|0)==24)break}if(f=g(e,24)+66496|0,A=i[f>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+133|0,(o&127)>>>0>=63||(t[k+133|0]=A,A=i[f+4>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+134|0,(o&127)>>>0>62)||(t[k+134|0]=A,A=i[f+8>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+135|0,(o&127)>>>0>62)||(t[k+135|0]=A,A=i[f+12>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+136|0,(o&127)>>>0>62)||(t[k+136|0]=A,A=i[f+16>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+137|0,(o&127)>>>0>62)||(t[k+137|0]=A,A=i[f+20>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+138|0,(f&127)>>>0>62))break k;if(t[k+138|0]=A,t[k|0]=14,A=i[(e<<2)+66568>>2],A=((A<<3&120)+(g(g(A>>4,5)-45|0,n)>>4)|0)-16|0,e=(A|0)>=126?126:A,e=(e|0)<=1?1:e,A=(A|0)>63,e=A?e^64:63-e|0,A=e<<1|A,(e&127)>>>0>=63)break t;if(t[k+1|0]=A,t[k+139|0]=1,t[k+140|0]=1,A=g(n,-5)>>4,e=(A|0)>=54?54:A,e=(e|0)<=-71?-71:e,A=(A|0)>-9,e=A?e+72^64:-9-e|0,A=e<<1|A,(e&127)>>>0<=62)break n;t[k+141|0]=A;break r}t[k+149|0]=r;break r}t[k+147|0]=r;break r}t[k+148|0]=A;break r}t[k+153|0]=A;break r}t[k+143|0]=A;break r}t[k+12|0]=A;break r}t[k+13|0]=A;break r}t[k+1|0]=A;break r}A=g(A&255,257),t[k+141|0]=A,t[k+142|0]=A>>>8,t[k+170|0]=1,t[k+171|0]=1,t[k+162|0]=1,t[k+163|0]=1,t[k+164|0]=1,t[k+165|0]=1,t[k+166|0]=1,t[k+167|0]=1,t[k+168|0]=1,t[k+169|0]=1,t[k+161|0]=1,t[k+23|0]=1,t[k+24|0]=1;break e}t[r|0]=A;break r}t[r|0]=f;break r}t[f|0]=r}U0(23382,19941,212,13233),M()}v=w+32|0;return}U0(23591,19941,177,20094),M()}function y9(A,e,r,f,k,n){var o=0,l=0,s=0,h=0,w=0,_=0;o=v-176|0,v=o;i:{s=i[r>>2];e:{if(!(o0[s+188>>2]<=65535&o0[s+192>>2]<65536)){if(e=C(32),i[o+128>>2]=e,i[o+132>>2]=31,i[o+136>>2]=-2147483616,f=u[11870]|u[11871]<<8|(u[11872]<<16|u[11873]<<24),k=u[11866]|u[11867]<<8|(u[11868]<<16|u[11869]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+31|0]=0,f=u[11893]|u[11894]<<8|(u[11895]<<16|u[11896]<<24),k=u[11889]|u[11890]<<8|(u[11891]<<16|u[11892]<<24),t[e+23|0]=k,t[e+24|0]=k>>>8,t[e+25|0]=k>>>16,t[e+26|0]=k>>>24,t[e+27|0]=f,t[e+28|0]=f>>>8,t[e+29|0]=f>>>16,t[e+30|0]=f>>>24,f=u[11886]|u[11887]<<8|(u[11888]<<16|u[11889]<<24),k=u[11882]|u[11883]<<8|(u[11884]<<16|u[11885]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[11878]|u[11879]<<8|(u[11880]<<16|u[11881]<<24),k=u[11874]|u[11875]<<8|(u[11876]<<16|u[11877]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,0,o+128|0),t[o+139|0]>=0)break e;Z(i[o+128>>2]);break e}i[e+296>>2]=n;r:{f:{A:{if(!i[k+36>>2]||!H5(s)|i[e+324>>2]|i[i[f>>2]+4>>2]==8)break A;if(i[e+332>>2]){if(e=A,A=V2(o+128|0,26939),a(e,5,0,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}i[o+144>>2]=0,i[o+148>>2]=0,i[o+152>>2]=0,i[o+156>>2]=0,i[o+136>>2]=0,i[o+140>>2]=0,t[o+132|0]=0,i[o+128>>2]=i[e+32>>2],s=i[r>>2],et(o+104|0,i[e+20>>2],o+128|0,1635088502,p[s+188>>1],p[s+192>>1]),l=114912;k:switch(u[o+124|0]){case 1:l=o+104|0;break;case 0:break k;default:break i}if(h=Z8(A,l),i[h>>2])break f;if(t[h+19|0]<0&&Z(i[h+8>>2]),u[o+124|0])break i;qi(e+324|0,o+104|0),xn(i[e+324>>2],1635088492,i[e+24>>2]),s=C(8),l=i[f>>2],i[s+4>>2]=0,i[s>>2]=l,i[o+40>>2]=s,l=o+40|0,w=i[l>>2],i[l>>2]=0,s=i[e+336>>2],i[e+336>>2]=w,s&&(w=i[s+4>>2],w&&(W[i[i[s>>2]+40>>2]](w),i[s+4>>2]=0),Z(s)),s=i[l>>2],i[l>>2]=0,s&&(w=i[s+4>>2],w&&(W[i[i[s>>2]+40>>2]](w),i[s+4>>2]=0),Z(s)),o7(l,i[e+336>>2]),s=i[o+40>>2];k:{if(s){if(w=i[o+44>>2],l=V2(o+16|0,i[o+48>>2]),a(h,s,w,l),t[l+11|0]>=0)break k;Z(i[l>>2]);break k}Nt(i[e+336>>2],f)}if(l=u[o+124|0],(l|0)!=255&&(h=i[28449],i[o+40>>2]=i[28448],i[o+44>>2]=h,W[i[(o+40|0)+(l<<2)>>2]](o+16|0,o+104|0)),Yh(o+128|0),s)break e}if(s=i[e+332>>2],!s){i[e+332>>2]=f;break r}if((f|0)==(s|0))break r;if(e=C(64),i[o+128>>2]=e,i[o+132>>2]=62,i[o+136>>2]=-2147483584,f=u[28476]|u[28477]<<8|(u[28478]<<16|u[28479]<<24),k=u[28472]|u[28473]<<8|(u[28474]<<16|u[28475]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+62|0]=0,f=u[28530]|u[28531]<<8|(u[28532]<<16|u[28533]<<24),k=u[28526]|u[28527]<<8|(u[28528]<<16|u[28529]<<24),t[e+54|0]=k,t[e+55|0]=k>>>8,t[e+56|0]=k>>>16,t[e+57|0]=k>>>24,t[e+58|0]=f,t[e+59|0]=f>>>8,t[e+60|0]=f>>>16,t[e+61|0]=f>>>24,f=u[28524]|u[28525]<<8|(u[28526]<<16|u[28527]<<24),k=u[28520]|u[28521]<<8|(u[28522]<<16|u[28523]<<24),t[e+48|0]=k,t[e+49|0]=k>>>8,t[e+50|0]=k>>>16,t[e+51|0]=k>>>24,t[e+52|0]=f,t[e+53|0]=f>>>8,t[e+54|0]=f>>>16,t[e+55|0]=f>>>24,f=u[28516]|u[28517]<<8|(u[28518]<<16|u[28519]<<24),k=u[28512]|u[28513]<<8|(u[28514]<<16|u[28515]<<24),t[e+40|0]=k,t[e+41|0]=k>>>8,t[e+42|0]=k>>>16,t[e+43|0]=k>>>24,t[e+44|0]=f,t[e+45|0]=f>>>8,t[e+46|0]=f>>>16,t[e+47|0]=f>>>24,f=u[28508]|u[28509]<<8|(u[28510]<<16|u[28511]<<24),k=u[28504]|u[28505]<<8|(u[28506]<<16|u[28507]<<24),t[e+32|0]=k,t[e+33|0]=k>>>8,t[e+34|0]=k>>>16,t[e+35|0]=k>>>24,t[e+36|0]=f,t[e+37|0]=f>>>8,t[e+38|0]=f>>>16,t[e+39|0]=f>>>24,f=u[28500]|u[28501]<<8|(u[28502]<<16|u[28503]<<24),k=u[28496]|u[28497]<<8|(u[28498]<<16|u[28499]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[28492]|u[28493]<<8|(u[28494]<<16|u[28495]<<24),k=u[28488]|u[28489]<<8|(u[28490]<<16|u[28491]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[28484]|u[28485]<<8|(u[28486]<<16|u[28487]<<24),k=u[28480]|u[28481]<<8|(u[28482]<<16|u[28483]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,5,0,o+128|0),t[o+139|0]>=0)break e;Z(i[o+128>>2]);break e}A=u[o+124|0],(A|0)!=255&&(e=i[28449],i[o+40>>2]=i[28448],i[o+44>>2]=e,W[i[(o+40|0)+(A<<2)>>2]](o+16|0,o+104|0)),Yh(o+128|0);break e}if(s=i[f>>2],i[s>>2]<=3){if(e=C(48),i[o+128>>2]=e,i[o+132>>2]=46,i[o+136>>2]=-2147483600,f=u[29104]|u[29105]<<8|(u[29106]<<16|u[29107]<<24),k=u[29100]|u[29101]<<8|(u[29102]<<16|u[29103]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+46|0]=0,f=u[29142]|u[29143]<<8|(u[29144]<<16|u[29145]<<24),k=u[29138]|u[29139]<<8|(u[29140]<<16|u[29141]<<24),t[e+38|0]=k,t[e+39|0]=k>>>8,t[e+40|0]=k>>>16,t[e+41|0]=k>>>24,t[e+42|0]=f,t[e+43|0]=f>>>8,t[e+44|0]=f>>>16,t[e+45|0]=f>>>24,f=u[29136]|u[29137]<<8|(u[29138]<<16|u[29139]<<24),k=u[29132]|u[29133]<<8|(u[29134]<<16|u[29135]<<24),t[e+32|0]=k,t[e+33|0]=k>>>8,t[e+34|0]=k>>>16,t[e+35|0]=k>>>24,t[e+36|0]=f,t[e+37|0]=f>>>8,t[e+38|0]=f>>>16,t[e+39|0]=f>>>24,f=u[29128]|u[29129]<<8|(u[29130]<<16|u[29131]<<24),k=u[29124]|u[29125]<<8|(u[29126]<<16|u[29127]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[29120]|u[29121]<<8|(u[29122]<<16|u[29123]<<24),k=u[29116]|u[29117]<<8|(u[29118]<<16|u[29119]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[29112]|u[29113]<<8|(u[29114]<<16|u[29115]<<24),k=u[29108]|u[29109]<<8|(u[29110]<<16|u[29111]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,11,6003,o+128|0),t[o+139|0]>=0)break e;Z(i[o+128>>2]);break e}l=i[e+108>>2];r:{f:{if((l|0)==i[e+104>>2]){s=i[s+4>>2];break f}if(s=i[s+4>>2],l=i[l-8>>2],(s|0)==i[l+12>>2])break r}gn(e,s),l=i[i[e+108>>2]-8>>2]}W[i[i[l>>2]+12>>2]](o+96|0,l),s=i[o+96>>2],l=W[i[i[s>>2]+8>>2]](s)|0,l||(l=i[k+4>>2]),qA(o+128|0,i[o+96>>2],r,f,l,k+8|0,i[e+20>>2]- -64|0);r:{f:switch(u[o+148|0]){case 1:if(e=i[o+132>>2],i[A>>2]=i[o+128>>2],i[A+4>>2]=e,A=A+8|0,t[o+147|0]>=0){e=i[o+140>>2],i[A>>2]=i[o+136>>2],i[A+4>>2]=e,i[A+8>>2]=i[o+144>>2];break r}T(A,i[o+136>>2],i[o+140>>2]);break r;case 0:break f;default:break i}l=i[o+128>>2],i[o+88>>2]=l,s=i[o+132>>2],i[o+92>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),X[e+292>>1]=i[l+188>>2],X[e+294>>1]=i[l+192>>2],w=Ru(),El(w,k),i[w+40>>2]||(i[w+40>>2]=i[e+28>>2]==1986618469?2:1),k=i[o+96>>2],W[i[i[k>>2]+20>>2]](o- -64|0,k,o+88|0,f,w,n,i[i[o+88>>2]+156>>2],i[i[e+160>>2]+120>>2],i[e+300>>2]);f:{if(i[o+64>>2]){e=i[o+68>>2],i[A>>2]=i[o+64>>2],i[A+4>>2]=e,e=i[o+76>>2],i[A+8>>2]=i[o+72>>2],i[A+12>>2]=e,i[A+16>>2]=i[o+80>>2];break f}if(k=i[i[o+88>>2]+156>>2],i[e+320>>2]=k,i[o+124>>2]=0,t[o+120|0]=0,t[o+108|0]=0,i[o+104>>2]=k,l=o+108|0,k=i[r>>2],n=t[k+79|0],(n|0)<0?i[k+72>>2]:n){k=k+68|0;A:{if(u[l+12|0]==1){if((k|0)==(l|0))break A;if(n=t[k+11|0],t[l+11|0]>=0){if((n|0)>=0){n=i[k+4>>2],i[l>>2]=i[k>>2],i[l+4>>2]=n,i[l+8>>2]=i[k+8>>2];break A}m1(l,i[k>>2],i[k+4>>2]);break A}s=(n|0)<0,R1(l,s?i[k>>2]:k,s?i[k+4>>2]:n);break A}k:{if(t[k+11|0]>=0){n=i[k+4>>2],i[l>>2]=i[k>>2],i[l+4>>2]=n,i[l+8>>2]=i[k+8>>2];break k}T(l,i[k>>2],i[k+4>>2])}t[l+12|0]=1}k=i[r>>2]}k=i[k+64>>2],k&&(n=bi(),i[o+124>>2]=n,li(n,k)),_=i[e+300>>2],h=e+308|0,n=i[h+4>>2];A:{k:{if(!n){s=h+4|0,k=s;break k}for(;;){if(k=n,n=i[k+16>>2],n>>>0>_>>>0){if(s=k,n=i[k>>2],n)continue;break k}if(n>>>0>=_>>>0){n=k;break A}if(n=i[k+4>>2],!n)break}s=k+4|0}n=C(44),i[n+20>>2]=0,i[n+24>>2]=0,i[n+16>>2]=_,i[n+8>>2]=k,i[n>>2]=0,i[n+4>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[s>>2]=n,k=i[i[h>>2]>>2],k&&(i[h>>2]=k),G1(i[h+4>>2],n),i[h+8>>2]=i[h+8>>2]+1}s=n+20|0,i[s>>2]=i[o+104>>2],k=s+4|0,n=u[k+12|0];A:{if((n|0)==u[l+12|0]){if(!n|(k|0)==(l|0))break A;if(n=t[l+11|0],t[k+11|0]>=0){if((n|0)>=0){n=i[l+4>>2],i[k>>2]=i[l>>2],i[k+4>>2]=n,i[k+8>>2]=i[l+8>>2];break A}m1(k,i[l>>2],i[l+4>>2]);break A}h=k,k=(n|0)<0,R1(h,k?i[l>>2]:l,k?i[l+4>>2]:n);break A}if(n){t[k+11|0]<0&&Z(i[k>>2]),t[k+12|0]=0;break A}k:{if(t[l+11|0]>=0){n=i[l+4>>2],i[k>>2]=i[l>>2],i[k+4>>2]=n,i[k+8>>2]=i[l+8>>2];break k}T(k,i[l>>2],i[l+4>>2])}t[k+12|0]=1}i[s+20>>2]=i[o+124>>2],i[e+300>>2]=i[e+300>>2]+1,An(o+40|0,e,f),f=114912;A:switch(u[o+60|0]){case 1:f=o+40|0;break;case 0:break A;default:break i}A=Z8(A,f);A:{if(i[A>>2])break A;if(t[A+19|0]<0&&Z(i[A+8>>2]),i[e+324>>2]){$9(o+16|0,o+88|0,i[e+20>>2]- -64|0),f=114912;k:switch(u[o+36|0]){case 1:f=o+16|0;break;case 0:break k;default:break i}k=0,f=Z8(A,f);k:{if(i[f>>2])break k;if(t[A+19|0]<0&&Z(i[f+8>>2]),u[o+36|0])break i;if(n=i[o+16>>2],i[n+156>>2]=i[i[o+88>>2]+156>>2],s=i[e+324>>2],i[o+8>>2]=n,n=i[o+20>>2],i[o+12>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),e=i[e+336>>2],n=i[o+12>>2],i[o>>2]=i[o+8>>2],i[o+4>>2]=n,y9(f,s,o,e,w,2),i[f>>2]||(k=1,t[A+19|0]>=0))break k;Z(i[f+8>>2])}if(e=u[o+36|0],(e|0)!=255&&(f=i[28439],i[o+168>>2]=i[28438],i[o+172>>2]=f,W[i[(o+168|0)+(e<<2)>>2]](o+167|0,o+16|0)),!k)break A}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}if(A=u[o+60|0],(A|0)!=255&&(e=i[28447],i[o+16>>2]=i[28446],i[o+20>>2]=e,W[i[(o+16|0)+(A<<2)>>2]](o+168|0,o+40|0)),u[o+120|0]!=1|t[o+119|0]>=0||Z(i[o+108>>2]),t[o+83|0]>=0)break f;Z(i[o+72>>2])}if(a2(w),A=i[o+92>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=u[o+148|0],(A|0)!=255&&(e=i[28439],i[o+104>>2]=i[28438],i[o+108>>2]=e,W[i[(o+104|0)+(A<<2)>>2]](o+40|0,o+128|0)),A=i[o+100>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}v=o+176|0;return}e2(),M()}function Bv(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0;w=v-80|0,v=w;i:{if(!n){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!k){if(t[w|0]=0,t[w+11|0]=0,r=A,A=a(w+24|0,5,2006,w),c0(r,A,i[e>>2]),t[A+19|0]<0&&Z(i[A+8>>2]),t[w+11|0]>=0)break i;Z(i[w>>2]);break i}i[w+64>>2]=0,i[w+56>>2]=0,i[w+60>>2]=0,h=n,m=k<<2,_=h+m|0,I=k;e:{if((k|0)<=0)break e;if(B=i[w+64>>2],n=i[w+60>>2],B-n>>2>=(k|0)){B=n>>2;r:{if((B|0)>=(k|0)){m=h+m|0,k=n;break r}if(m=n+h|0,k=_-m|0,!k|(_|0)==(m|0)||z(n,m,k),k=k+n|0,i[w+60>>2]=k,(B|0)<=0)break e}if(B=I<<2,Q=B,_=k,B=k-B|0,n>>>0>B>>>0)for(;i[_>>2]=i[B>>2],_=_+4|0,B=B+4|0,n>>>0>B>>>0;);i[w+60>>2]=_;r:{if((k|0)==(Q|0)||(n=k-Q|0,!n))break r;z(k-n|0,0,n)}if((h|0)==(m|0)||(k=m-h|0,!k))break e;z(0,h,k);break e}r:{if(_=i[w+56>>2],k=I+(n-_>>2)|0,k>>>0<1073741824){if(B=B-_|0,m=B>>1,B=B>>>0>=2147483644?1073741823:k>>>0<m>>>0?m:k,B){if(B>>>0>=1073741824)break r;k=C(B<<2)}else k=0;m=0-_|0,Q=k+m|0,V=I<<2,V&&z(Q,h,V),V=Q+V|0,n&&z(V,0,n),i[w+60>>2]=0,Q=Q-(m&-4)|0,m&&z(Q,_,m),i[w+64>>2]=k+(B<<2),i[w+60>>2]=n+V,i[w+56>>2]=Q,_&&Z(_);break e}s0(),M()}x0(),M()}X[w+32>>1]=0,i[w+52>>2]=0,i[w+24>>2]=0,i[w+28>>2]=0,i[w+44>>2]=0,i[w+48>>2]=0,i[w+40>>2]=f,i[w+36>>2]=r,l&&(X[w+26>>1]=p[l>>1],X[w+28>>1]=p[l+2>>1],X[w+30>>1]=p[l+4>>1],X[w+32>>1]=p[l+6>>1]);e:{if(!o){for(;;)if($o(w+24|0,i[h+(G<<2)>>2],0,0),G=G+1|0,(I|0)==(G|0))break e}for(r=o+4|0;f=G<<3,$o(w+24|0,i[h+(G<<2)>>2],i[f+o>>2],i[r+f>>2]),G=G+1|0,(I|0)!=(G|0););}Q=i[e>>2],h=v-96|0,v=h;e:{r:{f:{k=i[w+48>>2],f=i[w+44>>2];A:{if((k-f|0)/12>>>0>=65536){r=C(48),i[h+72>>2]=r,i[h+76>>2]=40,i[h+80>>2]=-2147483600,f=u[30092]|u[30093]<<8|(u[30094]<<16|u[30095]<<24),k=u[30088]|u[30089]<<8|(u[30090]<<16|u[30091]<<24),t[r+32|0]=k,t[r+33|0]=k>>>8,t[r+34|0]=k>>>16,t[r+35|0]=k>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[30084]|u[30085]<<8|(u[30086]<<16|u[30087]<<24),k=u[30080]|u[30081]<<8|(u[30082]<<16|u[30083]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[30076]|u[30077]<<8|(u[30078]<<16|u[30079]<<24),k=u[30072]|u[30073]<<8|(u[30074]<<16|u[30075]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[30068]|u[30069]<<8|(u[30070]<<16|u[30071]<<24),k=u[30064]|u[30065]<<8|(u[30066]<<16|u[30067]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,f=u[30060]|u[30061]<<8|(u[30062]<<16|u[30063]<<24),k=u[30056]|u[30057]<<8|(u[30058]<<16|u[30059]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+40|0]=0,r=a(h+32|0,5,0,h+72|0),f=i[r+4>>2],i[w>>2]=i[r>>2],i[w+4>>2]=f,f=w+8|0;k:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[w+20|0]=1;break k}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[w+20|0]=1,(f|0)>=0)break k;Z(i[r+8>>2])}if(t[h+83|0]>=0)break A;Z(i[h+72>>2]);break A}if(i[h+80>>2]=0,i[h+72>>2]=0,i[h+76>>2]=0,G=i[Q+48>>2],I=i[Q+52>>2],I&&(i[I+4>>2]=i[I+4>>2]+1,k=i[w+48>>2],f=i[w+44>>2]),(f|0)!=(k|0))for(;;){j1(h+32|0,G,i[f>>2]),r=i[h+32>>2],t[r+164|0]=1,i[r+100>>2]=i[r+100>>2]&-2|1,r=i[h+36>>2];k:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break k;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[h+76>>2],l=i[h+80>>2];k:{if(r>>>0<l>>>0){i[r>>2]=i[f>>2],_=r+4|0;break k}if(o=i[h+72>>2],r=r-o|0,B=r>>2,n=B+1|0,n>>>0>=1073741824)break f;if(l=l-o|0,_=l>>1,l=l>>>0>=2147483644?1073741823:n>>>0<_>>>0?_:n,l){if(l>>>0>=1073741824)break r;n=C(l<<2)}else n=0;if(_=n+r|0,i[_>>2]=i[f>>2],B=_-(B<<2)|0,r&&z(B,o,r),i[h+80>>2]=n+(l<<2),_=_+4|0,i[h+76>>2]=_,i[h+72>>2]=B,!o)break k;Z(o)}if(i[h+76>>2]=_,f=f+12|0,(k|0)==(f|0))break}_=i[w+36>>2],m=i[w+40>>2],f=_>>>0>65535|m>>>0>65535,o=i[w+44>>2],V=i[w+48>>2],R=(o|0)==(V|0),r=f;k:{n:{if(R)break n;for(k=o;;){if(n=i[k+4>>2],(n|0)>=32768){i[h+68>>2]=0,i[h+60>>2]=0,i[h+64>>2]=0,k=V-o|0,l=2,r=1,f=4;break k}if(r=1,(n|0)<-32768|i[k+8>>2]-32768>>>0<=4294901759)break n;if(k=k+12|0,(V|0)==(k|0))break}r=f}i[h+68>>2]=0,i[h+60>>2]=0,i[h+64>>2]=0,f=r&1,l=f?2:1,k=V-o|0,f=f?4:2}k:{if(n=((k|0)/12<<1)+2<<l,(n|0)>-11){if(k=0,l=n+10|0,n=C(l),l&&l0(n,0,l),l=n+l|0,i[h+68>>2]=l,i[h+64>>2]=l,i[h+60>>2]=n,l=u[w+24|0],t[n+1|0]=r&1,t[n|0]=l,r=p[w+26>>1],r=r<<8|r>>>8,t[n+2|0]=r,t[n+3|0]=r>>>8,r=p[w+28>>1],r=r<<8|r>>>8,t[n+4|0]=r,t[n+5|0]=r>>>8,r=p[w+30>>1],r=r<<8|r>>>8,t[n+6|0]=r,t[n+7|0]=r>>>8,r=p[w+32>>1],r=r<<8|r>>>8,t[n+8|0]=r,t[n+9|0]=r>>>8,l=n+10|0,f>>>0>=4)for(B=l+3|0,Y=l+2|0,N=l+1|0,U=f&4,r=0;t[k+l|0]=_>>>(f+(k^-1)<<3),t[k+N|0]=_>>>(f+(k^536870910)<<3),t[k+Y|0]=_>>>(f+(k^536870909)<<3),t[k+B|0]=_>>>(f+(k^536870908)<<3),k=k+4|0,r=r+4|0,(U|0)!=(r|0););if(B=f&2,B)for(r=0;t[k+l|0]=_>>>(f+(k^-1)<<3),k=k+1|0,r=r+1|0,(B|0)!=(r|0););if(Y=f+10|0,l=n+Y|0,B=0,k=0,f>>>0>=4)for(_=l+3|0,N=l+2|0,U=l+1|0,E=f&4,r=0;t[k+l|0]=m>>>(f+(k^-1)<<3),t[k+U|0]=m>>>(f+(k^536870910)<<3),t[k+N|0]=m>>>(f+(k^536870909)<<3),t[k+_|0]=m>>>(f+(k^536870908)<<3),k=k+4|0,r=r+4|0,(E|0)!=(r|0););if(r=f&2,r)for(;t[k+l|0]=m>>>(f+(k^-1)<<3),k=k+1|0,B=B+1|0,(r|0)!=(B|0););if(!R)for(N=f<<1,R=f&4,m=f&2,U=f+n|0;;){if(l=Y+U|0,_=i[o+4>>2],r=0,k=0,E=f>>>0<4,!E)for(x=l+3|0,j=l+2|0,O=l+1|0,B=0;t[k+l|0]=_>>(f+(k^-1)<<3),t[k+O|0]=_>>(f+(k^536870910)<<3),t[k+j|0]=_>>(f+(k^536870909)<<3),t[k+x|0]=_>>(f+(k^536870908)<<3),k=k+4|0,B=B+4|0,(R|0)!=(B|0););if(m)for(;t[k+l|0]=_>>(f+(k^-1)<<3),k=k+1|0,r=r+1|0,(m|0)!=(r|0););if(Y=Y+N|0,l=n+Y|0,_=i[o+8>>2],r=0,k=0,!E)for(E=l+3|0,x=l+2|0,j=l+1|0,B=0;t[k+l|0]=_>>(f+(k^-1)<<3),t[k+j|0]=_>>(f+(k^536870910)<<3),t[k+x|0]=_>>(f+(k^536870909)<<3),t[k+E|0]=_>>(f+(k^536870908)<<3),k=k+4|0,B=B+4|0,(R|0)!=(B|0););if(m)for(;t[k+l|0]=_>>(f+(k^-1)<<3),k=k+1|0,r=r+1|0,(m|0)!=(r|0););if(o=o+12|0,(V|0)==(o|0))break}break k}s0(),M()}t5(h+32|0,G,1768912492);k:{n:switch(u[h+52|0]){default:e2(),M();case 1:r=i[h+36>>2],i[w>>2]=i[h+32>>2],i[w+4>>2]=r,r=w+8|0;t:{if(t[h+51|0]>=0){f=i[h+44>>2],i[r>>2]=i[h+40>>2],i[r+4>>2]=f,i[r+8>>2]=i[h+48>>2];break t}T(r,i[h+40>>2],i[h+44>>2])}t[w+20|0]=1;break k;case 0:break n}f=i[h+32>>2],_=C(616),r=_,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107968,o=a4(r+16|0,Q,f),i[o>>2]=108312,X[r+576>>1]=0,i[r+568>>2]=0,i[r+572>>2]=0,i[r+580>>2]=0,i[r+584>>2]=0,i[r+588>>2]=0,i[r+592>>2]=0,i[r+596>>2]=0,i[r+600>>2]=0,i[r+604>>2]=0,i[r+608>>2]=0,i[h+92>>2]=r,i[h+88>>2]=o,i[r+4>>2]=i[r+4>>2]+1,I3(Q,f,h+88|0),r=i[h+92>>2];n:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break n;W[i[i[r>>2]+8>>2]](r),y(r)}w6(G,f,h+60|0,1),o8(G,f,1684630887,h+72|0),k=C(128),i[k>>2]=96348,i[k+4>>2]=0,i[k+8>>2]=0,r=k+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93816,i[k+32>>2]=1769173093,f=i[w+40>>2],i[k+120>>2]=i[w+36>>2],i[k+124>>2]=f,i[h+28>>2]=k,i[h+24>>2]=r,i[k+4>>2]=i[k+4>>2]+1,r=i[h+28>>2],i[h+8>>2]=i[h+24>>2],i[h+12>>2]=r,O4(o,h+8|0,0),r=i[i[h+72>>2]>>2],n=v-32|0,v=n,i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,L1(n,G,r,n+20|0);n:{if(i[n>>2]){i[h+88>>2]=0,i[h+92>>2]=0;break n}t:{if(l=i[n+20>>2],f=i[n+24>>2],(l|0)!=(f|0)){if(r=i[l>>2],r&&(G=i[h+92>>2],r=Z0(r,92792,95064),r))break t;if(l=l+8|0,(f|0)!=(l|0))for(;;){if(r=i[l>>2],r&&(G=0,r=Z0(r,92792,95064),r))break t;if(l=l+8|0,(f|0)==(l|0))break}i[h+88>>2]=0,i[h+92>>2]=0}i[h+88>>2]=0,i[h+92>>2]=0;break n}if(i[h+92>>2]=G,i[h+88>>2]=r,r=i[l+4>>2],i[h+92>>2]=r,!r)break n;i[r+4>>2]=i[r+4>>2]+1}if(t[n+19|0]<0&&Z(i[n+8>>2]),f=i[n+20>>2],f){if(r=f,l=i[n+24>>2],(r|0)!=(l|0)){for(;;){r=i[l-4>>2];n:{if(!r||(B=i[r+4>>2],i[r+4>>2]=B-1,B))break n;W[i[i[r>>2]+8>>2]](r),y(r)}if(l=l-8|0,(f|0)==(l|0))break}r=i[n+20>>2]}i[n+24>>2]=f,Z(r)}v=n+32|0,i[h+16>>2]=i[h+88>>2],r=i[h+92>>2],i[h+20>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[h+20>>2],i[h>>2]=i[h+16>>2],i[h+4>>2]=r,O4(o,h,1),t[w+20|0]=0,i[w+4>>2]=_,i[w>>2]=o,r=i[h+92>>2];n:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break n;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break k;W[i[i[k>>2]+8>>2]](k),y(k)}r=u[h+52|0],(r|0)!=255&&(f=i[27129],i[h+88>>2]=i[27128],i[h+92>>2]=f,W[i[(h+88|0)+(r<<2)>>2]](h+87|0,h+32|0)),r=i[h+60>>2],r&&(i[h+64>>2]=r,Z(r));k:{if(!I||(r=i[I+4>>2],i[I+4>>2]=r-1,r))break k;W[i[i[I>>2]+8>>2]](I),y(I)}if(r=i[h+72>>2],!r)break A;i[h+76>>2]=r,Z(r)}v=h+96|0;break e}s0(),M()}x0(),M()}e:{r:switch(u[w+20|0]){default:e2(),M();case 1:c0(A,w,i[e>>2]);break e;case 0:break r}k=i[w>>2];r:{r=i[w+4>>2];f:{if(!r){if(s)break f;e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680];break e}if(i[r+4>>2]=i[r+4>>2]+1,!s)break r}f=C(16),i[f+8>>2]=0,i[f+12>>2]=0,i[s>>2]=f,i[f+4>>2]=r,i[f>>2]=k,k=i[e>>2],r=i[e+4>>2];f:{if(!r){i[f+12>>2]=r,i[f+8>>2]=k;break f}if(i[r+4>>2]=i[r+4>>2]+1,i[f+8>>2]=k,e=i[f+12>>2],i[f+12>>2]=r,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680];break e}if(e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[r+4>>2],i[r+4>>2]=A-1,A)break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=u[w+20|0],(A|0)!=255&&(e=i[25835],i[w+72>>2]=i[25834],i[w+76>>2]=e,W[i[(w+72|0)+(A<<2)>>2]](w+71|0,w)),A=i[w+44>>2],A&&(i[w+48>>2]=A,Z(A)),A=i[w+56>>2],!A)break i;i[w+60>>2]=A,Z(A)}v=w+80|0}function vv(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0;l=v+-64|0,v=l,B=i[e+196>>2],m=o+4|0,w=m,s=w,h=i[o+4>>2];i:{e:{r:{if(!h)break r;for(s=h;_=B>>>0>o0[s+16>>2],w=_?w:s,s=i[(_?4:0)+s>>2],!!s;);if(!((w|0)==(m|0)|B>>>0<o0[w+16>>2])){f=C(32),i[l+28>>2]=f,i[l+32>>2]=28,i[l+36>>2]=-2147483616,e=u[6467]|u[6468]<<8|(u[6469]<<16|u[6470]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,r=u[6463]|u[6464]<<8|(u[6465]<<16|u[6466]<<24),e=u[6459]|u[6460]<<8|(u[6461]<<16|u[6462]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[6455]|u[6456]<<8|(u[6457]<<16|u[6458]<<24),e=u[6451]|u[6452]<<8|(u[6453]<<16|u[6454]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,r=u[6447]|u[6448]<<8|(u[6449]<<16|u[6450]<<24),e=u[6443]|u[6444]<<8|(u[6445]<<16|u[6446]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+28|0]=0,f=a(l+40|0,2,0,l+28|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(t[l+39|0]>=0)break i;Z(i[l+28>>2]);break i}for(;;){if(s=h,h=i[s+16>>2],h>>>0>B>>>0){if(w=s,h=i[s>>2],h)continue;break r}if(h>>>0>=B>>>0)break e;if(h=i[s+4>>2],!h)break}w=s+4|0}h=C(20),i[h+8>>2]=s,i[h>>2]=0,i[h+4>>2]=0,i[h+16>>2]=B,i[w>>2]=h,s=i[i[o>>2]>>2],s&&(i[o>>2]=s),G1(i[o+4>>2],h),i[o+8>>2]=i[o+8>>2]+1}s=i[e+180>>2],i[l+40>>2]=i[s+48>>2],s=i[s+52>>2],i[l+44>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),s=i[l+40>>2],h=i[s+80>>2],_=i[s+84>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),w=i[l+44>>2];e:{if(!w||(s=i[w+4>>2],i[w+4>>2]=s-1,s))break e;W[i[i[w>>2]+8>>2]](w),y(w)}e:{if(!h){f=C(56),i[l+28>>2]=f,i[l+32>>2]=48,i[l+36>>2]=-2147483592,r=u[15660]|u[15661]<<8|(u[15662]<<16|u[15663]<<24),e=u[15656]|u[15657]<<8|(u[15658]<<16|u[15659]<<24),t[f+40|0]=e,t[f+41|0]=e>>>8,t[f+42|0]=e>>>16,t[f+43|0]=e>>>24,t[f+44|0]=r,t[f+45|0]=r>>>8,t[f+46|0]=r>>>16,t[f+47|0]=r>>>24,r=u[15652]|u[15653]<<8|(u[15654]<<16|u[15655]<<24),e=u[15648]|u[15649]<<8|(u[15650]<<16|u[15651]<<24),t[f+32|0]=e,t[f+33|0]=e>>>8,t[f+34|0]=e>>>16,t[f+35|0]=e>>>24,t[f+36|0]=r,t[f+37|0]=r>>>8,t[f+38|0]=r>>>16,t[f+39|0]=r>>>24,r=u[15644]|u[15645]<<8|(u[15646]<<16|u[15647]<<24),e=u[15640]|u[15641]<<8|(u[15642]<<16|u[15643]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,t[f+28|0]=r,t[f+29|0]=r>>>8,t[f+30|0]=r>>>16,t[f+31|0]=r>>>24,r=u[15636]|u[15637]<<8|(u[15638]<<16|u[15639]<<24),e=u[15632]|u[15633]<<8|(u[15634]<<16|u[15635]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[15628]|u[15629]<<8|(u[15630]<<16|u[15631]<<24),e=u[15624]|u[15625]<<8|(u[15626]<<16|u[15627]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,r=u[15620]|u[15621]<<8|(u[15622]<<16|u[15623]<<24),e=u[15616]|u[15617]<<8|(u[15618]<<16|u[15619]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+48|0]=0,f=a(l+40|0,2,113,l+28|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(t[l+39|0]>=0)break e;Z(i[l+28>>2]);break e}d4(l+28|0,h,i[e+196>>2],1684630887),s=i[l+32>>2],h=i[l+28>>2];r:{if(s-h>>>0>=5){f=C(48),i[l+16>>2]=f,i[l+20>>2]=47,i[l+24>>2]=-2147483600,r=u[16278]|u[16279]<<8|(u[16280]<<16|u[16281]<<24),e=u[16274]|u[16275]<<8|(u[16276]<<16|u[16277]<<24),t[f+39|0]=e,t[f+40|0]=e>>>8,t[f+41|0]=e>>>16,t[f+42|0]=e>>>24,t[f+43|0]=r,t[f+44|0]=r>>>8,t[f+45|0]=r>>>16,t[f+46|0]=r>>>24,r=u[16271]|u[16272]<<8|(u[16273]<<16|u[16274]<<24),e=u[16267]|u[16268]<<8|(u[16269]<<16|u[16270]<<24),t[f+32|0]=e,t[f+33|0]=e>>>8,t[f+34|0]=e>>>16,t[f+35|0]=e>>>24,t[f+36|0]=r,t[f+37|0]=r>>>8,t[f+38|0]=r>>>16,t[f+39|0]=r>>>24,r=u[16263]|u[16264]<<8|(u[16265]<<16|u[16266]<<24),e=u[16259]|u[16260]<<8|(u[16261]<<16|u[16262]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,t[f+28|0]=r,t[f+29|0]=r>>>8,t[f+30|0]=r>>>16,t[f+31|0]=r>>>24,r=u[16255]|u[16256]<<8|(u[16257]<<16|u[16258]<<24),e=u[16251]|u[16252]<<8|(u[16253]<<16|u[16254]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[16247]|u[16248]<<8|(u[16249]<<16|u[16250]<<24),e=u[16243]|u[16244]<<8|(u[16245]<<16|u[16246]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,r=u[16239]|u[16240]<<8|(u[16241]<<16|u[16242]<<24),e=u[16235]|u[16236]<<8|(u[16237]<<16|u[16238]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+47|0]=0,f=a(l+40|0,2,0,l+16|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(t[l+27|0]>=0)break r;Z(i[l+16>>2]);break r}if((s|0)==(h|0)){f=C(40),i[l+16>>2]=f,i[l+20>>2]=37,i[l+24>>2]=-2147483608,r=u[16961]|u[16962]<<8|(u[16963]<<16|u[16964]<<24),e=u[16957]|u[16958]<<8|(u[16959]<<16|u[16960]<<24),t[f+29|0]=e,t[f+30|0]=e>>>8,t[f+31|0]=e>>>16,t[f+32|0]=e>>>24,t[f+33|0]=r,t[f+34|0]=r>>>8,t[f+35|0]=r>>>16,t[f+36|0]=r>>>24,r=u[16956]|u[16957]<<8|(u[16958]<<16|u[16959]<<24),e=u[16952]|u[16953]<<8|(u[16954]<<16|u[16955]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,t[f+28|0]=r,t[f+29|0]=r>>>8,t[f+30|0]=r>>>16,t[f+31|0]=r>>>24,r=u[16948]|u[16949]<<8|(u[16950]<<16|u[16951]<<24),e=u[16944]|u[16945]<<8|(u[16946]<<16|u[16947]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[16940]|u[16941]<<8|(u[16942]<<16|u[16943]<<24),e=u[16936]|u[16937]<<8|(u[16938]<<16|u[16939]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,r=u[16932]|u[16933]<<8|(u[16934]<<16|u[16935]<<24),e=u[16928]|u[16929]<<8|(u[16930]<<16|u[16931]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+37|0]=0,f=a(l+40|0,2,0,l+16|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(t[l+27|0]>=0)break r;Z(i[l+16>>2]);break r}if(h=i[h>>2],(h|0)==i[e+196>>2]){f=C(40),i[l+16>>2]=f,i[l+20>>2]=32,i[l+24>>2]=-2147483608,r=u[12396]|u[12397]<<8|(u[12398]<<16|u[12399]<<24),e=u[12392]|u[12393]<<8|(u[12394]<<16|u[12395]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,t[f+28|0]=r,t[f+29|0]=r>>>8,t[f+30|0]=r>>>16,t[f+31|0]=r>>>24,r=u[12388]|u[12389]<<8|(u[12390]<<16|u[12391]<<24),e=u[12384]|u[12385]<<8|(u[12386]<<16|u[12387]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[12380]|u[12381]<<8|(u[12382]<<16|u[12383]<<24),e=u[12376]|u[12377]<<8|(u[12378]<<16|u[12379]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,r=u[12372]|u[12373]<<8|(u[12374]<<16|u[12375]<<24),e=u[12368]|u[12369]<<8|(u[12370]<<16|u[12371]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+32|0]=0,f=a(l+40|0,2,0,l+16|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(t[l+27|0]>=0)break r;Z(i[l+16>>2]);break r}s=l+40|0,$1(s,i[e+180>>2],h,1),w=i[l+44>>2],h=i[l+40>>2];f:{if(!h){r=V2(l+16|0,16134),k=a(s,2,0,r),e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,f=A+8|0;A:{if(t[k+19|0]>=0){e=i[k+12>>2],i[f>>2]=i[k+8>>2],i[f+4>>2]=e,i[f+8>>2]=i[k+16>>2],t[A+20|0]=1;break A}if(T(f,i[k+8>>2],i[k+12>>2]),e=t[k+19|0],t[A+20|0]=1,(e|0)>=0)break A;Z(i[k+8>>2])}if(t[r+11|0]>=0)break f;Z(i[r>>2]);break f}if(W[i[i[h>>2]+88>>2]](l+40|0,h),i[l+40>>2]){if(e=i[l+44>>2],i[A>>2]=i[l+40>>2],i[A+4>>2]=e,r=A+8|0,t[l+59|0]>=0){e=i[l+52>>2],i[r>>2]=i[l+48>>2],i[r+4>>2]=e,i[r+8>>2]=i[l+56>>2],t[A+20|0]=1;break f}if(T(r,i[l+48>>2],i[l+52>>2]),e=t[l+59|0],t[A+20|0]=1,(e|0)>=0)break f;Z(i[l+48>>2]);break f}t[l+59|0]<0&&Z(i[l+48>>2]),i[l+8>>2]=0,i[l+12>>2]=0,i[l+4>>2]=l+8,e=l+4|0,W8(e,i[o>>2],m),W[i[i[h>>2]+140>>2]](A,h,r,f,k,n,e),S1(e,i[l+8>>2])}if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break r;W[i[i[w>>2]+8>>2]](w),y(w)}if(A=i[l+28>>2],!A)break e;i[l+32>>2]=A,Z(A)}if(!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;W[i[i[_>>2]+8>>2]](_),y(_)}v=l- -64|0}function E2(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;w=v-16|0,v=w;i:{e:{r:{f:{A:{k:{n:{t:{o:{l:{if(A>>>0<=244){if(k=i[33450],o=A>>>0<11?16:A+11&504,A=o>>>3|0,e=k>>>A|0,e&3){r=A+((e^-1)&1)|0,e=r<<3,A=e+133840|0,e=i[e+133848>>2],f=i[e+8>>2];u:{if((A|0)==(f|0)){B=133800,m=t2(-2,r)&k,i[B>>2]=m;break u}i[f+12>>2]=A,i[A+8>>2]=f}A=e+8|0,r=r<<3,i[e+4>>2]=r|3,e=e+r|0,i[e+4>>2]=i[e+4>>2]|1;break i}if(s=i[33452],s>>>0>=o>>>0)break l;if(e){r=2<<A,A=w8((0-r|r)&e<<A),r=A<<3,e=r+133840|0,r=i[r+133848>>2],f=i[r+8>>2];u:{if((e|0)==(f|0)){k=t2(-2,A)&k,i[33450]=k;break u}i[f+12>>2]=e,i[e+8>>2]=f}if(i[r+4>>2]=o|3,l=r+o|0,A=A<<3,n=A-o|0,i[l+4>>2]=n|1,i[A+r>>2]=n,s){A=(s&-8)+133840|0,f=i[33455],e=1<<(s>>>3);u:{if(!(e&k)){i[33450]=e|k,e=A;break u}e=i[A+8>>2]}i[A+8>>2]=f,i[e+12>>2]=f,i[f+12>>2]=A,i[f+8>>2]=e}A=r+8|0,i[33455]=l,i[33452]=n;break i}if(_=i[33451],!_)break l;for(r=i[(w8(_)<<2)+134104>>2],n=(i[r+4>>2]&-8)-o|0,e=r;;){u:{if(A=i[e+16>>2],!A&&(A=i[e+20>>2],!A))break u;f=(i[A+4>>2]&-8)-o|0,e=f>>>0<n>>>0,n=e?f:n,r=e?A:r,e=A;continue}break}if(h=i[r+24>>2],A=i[r+12>>2],(r|0)!=(A|0)){e=i[r+8>>2],i[e+12>>2]=A,i[A+8>>2]=e;break e}if(e=i[r+20>>2],e)f=r+20|0;else{if(e=i[r+16>>2],!e)break o;f=r+16|0}for(;l=f,A=e,f=A+20|0,e=i[A+20>>2],!(!e&&(f=A+16|0,e=i[A+16>>2],!e)););i[l>>2]=0;break e}if(o=-1,A>>>0>4294967231||(e=A+11|0,o=e&-8,l=i[33451],!l))break l;s=31,n=0-o|0,A>>>0<=16777204&&(A=_1(e>>>8|0),s=((o>>>38-A&1)-(A<<1)|0)+62|0),e=i[(s<<2)+134104>>2];u:{s:{h:{if(!e){A=0;break h}for(A=0,r=o<<((s|0)!=31?25-(s>>>1|0)|0:0);;){w:{if(k=(i[e+4>>2]&-8)-o|0,k>>>0>=n>>>0||(f=e,n=k,n))break w;n=0,A=e;break s}if(k=i[e+20>>2],e=i[((r>>>29&4)+e|0)+16>>2],A=k?(k|0)==(e|0)?A:k:A,r=r<<1,!e)break}}if(!(A|f)){if(f=0,A=2<<s,A=(0-A|A)&l,!A)break l;A=i[(w8(A)<<2)+134104>>2]}if(!A)break u}for(;r=(i[A+4>>2]&-8)-o|0,e=r>>>0<n>>>0,n=e?r:n,f=e?A:f,e=i[A+16>>2],e?A=e:A=i[A+20>>2],!!A;);}if(!f|i[33452]-o>>>0<=n>>>0)break l;if(s=i[f+24>>2],A=i[f+12>>2],(f|0)!=(A|0)){e=i[f+8>>2],i[e+12>>2]=A,i[A+8>>2]=e;break r}if(e=i[f+20>>2],e)r=f+20|0;else{if(e=i[f+16>>2],!e)break t;r=f+16|0}for(;k=r,A=e,r=A+20|0,e=i[A+20>>2],!(!e&&(r=A+16|0,e=i[A+16>>2],!e)););i[k>>2]=0;break r}if(f=i[33452],f>>>0>=o>>>0){A=i[33455],e=f-o|0;l:{if(e>>>0>=16){r=A+o|0,i[r+4>>2]=e|1,i[A+f>>2]=e,i[A+4>>2]=o|3;break l}i[A+4>>2]=f|3,e=A+f|0,i[e+4>>2]=i[e+4>>2]|1,r=0,e=0}i[33452]=e,i[33455]=r,A=A+8|0;break i}if(r=i[33453],r>>>0>o>>>0){e=r-o|0,i[33453]=e,A=i[33456],r=A+o|0,i[33456]=r,i[r+4>>2]=e|1,i[A+4>>2]=o|3,A=A+8|0;break i}if(A=0,n=o+47|0,i[33568]?e=i[33570]:(i[33571]=-1,i[33572]=-1,i[33569]=4096,i[33570]=4096,i[33568]=w+12&-16^1431655768,i[33573]=0,i[33561]=0,e=4096),k=n+e|0,l=0-e|0,e=k&l,e>>>0<=o>>>0||(s=i[33560],s&&(h=i[33558],f=h+e|0,f>>>0<=h>>>0|f>>>0>s>>>0)))break i;l:{if(!(u[134244]&4)){u:{s:{h:{w:{if(f=i[33456],f)for(A=134248;;){if(s=i[A>>2],s>>>0<=f>>>0&f>>>0<s+i[A+4>>2]>>>0)break w;if(A=i[A+8>>2],!A)break}if(r=ai(0),(r|0)==-1||(k=e,A=i[33569],f=A-1|0,f&r&&(k=(e-r|0)+(r+f&0-A)|0),k>>>0<=o>>>0)||(f=i[33560],f&&(l=i[33558],A=l+k|0,A>>>0<=l>>>0|A>>>0>f>>>0)))break u;if(A=ai(k),(r|0)!=(A|0))break h;break l}if(k=l&k-r,r=ai(k),(r|0)==(i[A>>2]+i[A+4>>2]|0))break s;A=r}if((A|0)==-1)break u;if(o+48>>>0<=k>>>0){r=A;break l}if(r=i[33570],r=r+(n-k|0)&0-r,(ai(r)|0)==-1)break u;k=r+k|0,r=A;break l}if((r|0)!=-1)break l}i[33561]=i[33561]|4}if(r=ai(e),A=ai(0),(r|0)==-1|(A|0)==-1|A>>>0<=r>>>0||(k=A-r|0,k>>>0<=o+40>>>0))break A}A=i[33558]+k|0,i[33558]=A,A>>>0>o0[33559]&&(i[33559]=A);l:{if(n=i[33456],n){for(A=134248;;){if(e=i[A>>2],f=i[A+4>>2],(e+f|0)==(r|0))break l;if(A=i[A+8>>2],!A)break}break n}for(A=i[33454],A>>>0<=r>>>0&&A||(i[33454]=r),A=0,i[33563]=k,i[33562]=r,i[33458]=-1,i[33459]=i[33568],i[33565]=0;e=A<<3,f=e+133840|0,i[e+133848>>2]=f,i[e+133852>>2]=f,A=A+1|0,(A|0)!=32;);A=k-40|0,e=-8-r&7,f=A-e|0,i[33453]=f,e=e+r|0,i[33456]=e,i[e+4>>2]=f|1,i[(A+r|0)+4>>2]=40,i[33457]=i[33572];break k}if(i[A+12>>2]&8|(r>>>0<=n>>>0|e>>>0>n>>>0))break n;i[A+4>>2]=f+k,A=-8-n&7,e=A+n|0,i[33456]=e,r=i[33453]+k|0,A=r-A|0,i[33453]=A,i[e+4>>2]=A|1,i[(r+n|0)+4>>2]=40,i[33457]=i[33572];break k}A=0;break e}A=0;break r}o0[33454]>r>>>0&&(i[33454]=r),f=r+k|0,A=134248;n:{for(;;){if(e=i[A>>2],(e|0)!=(f|0)){if(A=i[A+8>>2],A)continue;break n}break}if(!(u[A+12|0]&8))break f}for(A=134248;;){n:{if(e=i[A>>2],e>>>0<=n>>>0&&(f=e+i[A+4>>2]|0,f>>>0>n>>>0))break n;A=i[A+8>>2];continue}break}for(A=k-40|0,e=-8-r&7,l=A-e|0,i[33453]=l,e=e+r|0,i[33456]=e,i[e+4>>2]=l|1,i[(A+r|0)+4>>2]=40,i[33457]=i[33572],A=(f+(39-f&7)|0)-47|0,e=A>>>0<n+16>>>0?n:A,i[e+4>>2]=27,A=i[33565],i[e+16>>2]=i[33564],i[e+20>>2]=A,A=i[33563],i[e+8>>2]=i[33562],i[e+12>>2]=A,i[33564]=e+8,i[33563]=k,i[33562]=r,i[33565]=0,A=e+24|0;i[A+4>>2]=7,r=A+8|0,A=A+4|0,r>>>0<f>>>0;);if((e|0)==(n|0))break k;i[e+4>>2]=i[e+4>>2]&-2,r=e-n|0,i[n+4>>2]=r|1,i[e>>2]=r;n:{if(r>>>0<=255){A=(r&-8)+133840|0,e=i[33450],r=1<<(r>>>3);t:{if(!(e&r)){i[33450]=e|r,e=A;break t}e=i[A+8>>2]}i[A+8>>2]=n,i[e+12>>2]=n,f=8,r=12;break n}A=31,r>>>0<=16777215&&(A=_1(r>>>8|0),A=((r>>>38-A&1)-(A<<1)|0)+62|0),i[n+28>>2]=A,i[n+16>>2]=0,i[n+20>>2]=0,e=(A<<2)+134104|0;t:{f=i[33451],k=1<<A;o:{if(!(f&k)){i[33451]=f|k,i[e>>2]=n;break o}for(A=r<<((A|0)!=31?25-(A>>>1|0)|0:0),f=i[e>>2];;){if(e=f,(r|0)==(i[e+4>>2]&-8))break t;if(f=A>>>29|0,A=A<<1,k=(f&4)+e|0,f=i[k+16>>2],!f)break}i[k+16>>2]=n}i[n+24>>2]=e,e=n,A=e,f=12,r=8;break n}A=i[e+8>>2],i[A+12>>2]=n,i[e+8>>2]=n,i[n+8>>2]=A,A=0,f=12,r=24}i[f+n>>2]=e,i[r+n>>2]=A}if(A=i[33453],A>>>0<=o>>>0)break A;e=A-o|0,i[33453]=e,A=i[33456],r=A+o|0,i[33456]=r,i[r+4>>2]=e|1,i[A+4>>2]=o|3,A=A+8|0;break i}i[33136]=48,A=0;break i}i[A>>2]=r,i[A+4>>2]=i[A+4>>2]+k,s=(-8-r&7)+r|0,i[s+4>>2]=o|3,k=e+(-8-e&7)|0,n=o+s|0,l=k-n|0;f:{if(i[33456]==(k|0)){i[33456]=n,A=i[33453]+l|0,i[33453]=A,i[n+4>>2]=A|1;break f}if(i[33455]==(k|0)){i[33455]=n,A=i[33452]+l|0,i[33452]=A,i[n+4>>2]=A|1,i[A+n>>2]=A;break f}if(A=i[k+4>>2],(A&3)==1){h=A&-8,r=i[k+12>>2];A:{if(A>>>0<=255){if(e=i[k+8>>2],(e|0)==(r|0)){B=133800,m=i[33450]&t2(-2,A>>>3|0),i[B>>2]=m;break A}i[e+12>>2]=r,i[r+8>>2]=e;break A}o=i[k+24>>2];k:{if((r|0)!=(k|0)){A=i[k+8>>2],i[A+12>>2]=r,i[r+8>>2]=A;break k}n:{if(A=i[k+20>>2],A)e=k+20|0;else{if(A=i[k+16>>2],!A)break n;e=k+16|0}for(;f=e,r=A,e=A+20|0,A=i[A+20>>2],!(!A&&(e=r+16|0,A=i[r+16>>2],!A)););i[f>>2]=0;break k}r=0}if(!o)break A;A=i[k+28>>2],e=(A<<2)+134104|0;k:{if(i[e>>2]==(k|0)){if(i[e>>2]=r,r)break k;B=133804,m=i[33451]&t2(-2,A),i[B>>2]=m;break A}n:{if(i[o+16>>2]==(k|0)){i[o+16>>2]=r;break n}i[o+20>>2]=r}if(!r)break A}if(i[r+24>>2]=o,A=i[k+16>>2],A&&(i[r+16>>2]=A,i[A+24>>2]=r),A=i[k+20>>2],!A)break A;i[r+20>>2]=A,i[A+24>>2]=r}l=l+h|0,k=k+h|0,A=i[k+4>>2]}if(i[k+4>>2]=A&-2,i[n+4>>2]=l|1,i[n+l>>2]=l,l>>>0<=255){A=(l&-8)+133840|0,e=i[33450],r=1<<(l>>>3);A:{if(!(e&r)){i[33450]=e|r,e=A;break A}e=i[A+8>>2]}i[A+8>>2]=n,i[e+12>>2]=n,i[n+12>>2]=A,i[n+8>>2]=e;break f}r=31,l>>>0<=16777215&&(A=_1(l>>>8|0),r=((l>>>38-A&1)-(A<<1)|0)+62|0),i[n+28>>2]=r,i[n+16>>2]=0,i[n+20>>2]=0,A=(r<<2)+134104|0;A:{e=i[33451],f=1<<r;k:{if(!(e&f)){i[33451]=e|f,i[A>>2]=n;break k}for(r=l<<((r|0)!=31?25-(r>>>1|0)|0:0),e=i[A>>2];;){if(A=e,(i[A+4>>2]&-8)==(l|0))break A;if(e=r>>>29|0,r=r<<1,f=(e&4)+A|0,e=i[f+16>>2],!e)break}i[f+16>>2]=n}i[n+24>>2]=A,i[n+12>>2]=n,i[n+8>>2]=n;break f}e=i[A+8>>2],i[e+12>>2]=n,i[A+8>>2]=n,i[n+24>>2]=0,i[n+12>>2]=A,i[n+8>>2]=e}A=s+8|0;break i}r:{if(!s)break r;e=i[f+28>>2],r=(e<<2)+134104|0;f:{if(i[r>>2]==(f|0)){if(i[r>>2]=A,A)break f;l=t2(-2,e)&l,i[33451]=l;break r}A:{if(i[s+16>>2]==(f|0)){i[s+16>>2]=A;break A}i[s+20>>2]=A}if(!A)break r}if(i[A+24>>2]=s,e=i[f+16>>2],e&&(i[A+16>>2]=e,i[e+24>>2]=A),e=i[f+20>>2],!e)break r;i[A+20>>2]=e,i[e+24>>2]=A}r:{if(n>>>0<=15){A=n+o|0,i[f+4>>2]=A|3,A=A+f|0,i[A+4>>2]=i[A+4>>2]|1;break r}if(i[f+4>>2]=o|3,k=f+o|0,i[k+4>>2]=n|1,i[n+k>>2]=n,n>>>0<=255){A=(n&-8)+133840|0,e=i[33450],r=1<<(n>>>3);f:{if(!(e&r)){i[33450]=e|r,e=A;break f}e=i[A+8>>2]}i[A+8>>2]=k,i[e+12>>2]=k,i[k+12>>2]=A,i[k+8>>2]=e;break r}A=31,n>>>0<=16777215&&(A=_1(n>>>8|0),A=((n>>>38-A&1)-(A<<1)|0)+62|0),i[k+28>>2]=A,i[k+16>>2]=0,i[k+20>>2]=0,e=(A<<2)+134104|0;f:{r=1<<A;A:{if(!(r&l)){i[33451]=r|l,i[e>>2]=k,i[k+24>>2]=e;break A}for(A=n<<((A|0)!=31?25-(A>>>1|0)|0:0),e=i[e>>2];;){if(r=e,(i[e+4>>2]&-8)==(n|0))break f;if(l=A>>>29|0,A=A<<1,l=e+(l&4)|0,e=i[l+16>>2],!e)break}i[l+16>>2]=k,i[k+24>>2]=r}i[k+12>>2]=k,i[k+8>>2]=k;break r}A=i[r+8>>2],i[A+12>>2]=k,i[r+8>>2]=k,i[k+24>>2]=0,i[k+12>>2]=r,i[k+8>>2]=A}A=f+8|0;break i}e:{if(!h)break e;e=i[r+28>>2],f=(e<<2)+134104|0;r:{if(i[f>>2]==(r|0)){if(i[f>>2]=A,A)break r;B=133804,m=t2(-2,e)&_,i[B>>2]=m;break e}f:{if(i[h+16>>2]==(r|0)){i[h+16>>2]=A;break f}i[h+20>>2]=A}if(!A)break e}if(i[A+24>>2]=h,e=i[r+16>>2],e&&(i[A+16>>2]=e,i[e+24>>2]=A),e=i[r+20>>2],!e)break e;i[A+20>>2]=e,i[e+24>>2]=A}e:{if(n>>>0<=15){A=n+o|0,i[r+4>>2]=A|3,A=A+r|0,i[A+4>>2]=i[A+4>>2]|1;break e}if(i[r+4>>2]=o|3,l=r+o|0,i[l+4>>2]=n|1,i[n+l>>2]=n,s){A=(s&-8)+133840|0,f=i[33455],e=1<<(s>>>3);r:{if(!(e&k)){i[33450]=e|k,e=A;break r}e=i[A+8>>2]}i[A+8>>2]=f,i[e+12>>2]=f,i[f+12>>2]=A,i[f+8>>2]=e}i[33455]=l,i[33452]=n}A=r+8|0}return v=w+16|0,A|0}function mv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;k=v-32|0,v=k,l=W[i[i[e>>2]+52>>2]](e,r,0)|0,h2(r,u[e+100|0]),h2(r,u[e+101|0]),h2(r,u[e+102|0]),h2(r,u[e+103|0]),h2(r,(u[e+104|0]-1|252)&255),f=(i[e+120>>2]-i[e+116>>2]|0)/12|0;i:{if(f>>>0>=32){if(e=C(48),i[k+20>>2]=e,i[k+24>>2]=44,i[k+28>>2]=-2147483600,r=u[24625]|u[24626]<<8|(u[24627]<<16|u[24628]<<24),f=u[24621]|u[24622]<<8|(u[24623]<<16|u[24624]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+44|0]=0,r=u[24661]|u[24662]<<8|(u[24663]<<16|u[24664]<<24),t[e+40|0]=r,t[e+41|0]=r>>>8,t[e+42|0]=r>>>16,t[e+43|0]=r>>>24,r=u[24657]|u[24658]<<8|(u[24659]<<16|u[24660]<<24),f=u[24653]|u[24654]<<8|(u[24655]<<16|u[24656]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[24649]|u[24650]<<8|(u[24651]<<16|u[24652]<<24),f=u[24645]|u[24646]<<8|(u[24647]<<16|u[24648]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[24641]|u[24642]<<8|(u[24643]<<16|u[24644]<<24),f=u[24637]|u[24638]<<8|(u[24639]<<16|u[24640]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[24633]|u[24634]<<8|(u[24635]<<16|u[24636]<<24),f=u[24629]|u[24630]<<8|(u[24631]<<16|u[24632]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(h2(r,(f|224)&255),f=i[e+116>>2],n=i[e+120>>2],(f|0)!=(n|0))for(;;){if(o=i[f+4>>2]-i[f>>2]|0,o>>>0>=65536){if(e=C(56),i[k+20>>2]=e,i[k+24>>2]=55,i[k+28>>2]=-2147483592,r=u[24467]|u[24468]<<8|(u[24469]<<16|u[24470]<<24),f=u[24463]|u[24464]<<8|(u[24465]<<16|u[24466]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+55|0]=0,r=u[24514]|u[24515]<<8|(u[24516]<<16|u[24517]<<24),f=u[24510]|u[24511]<<8|(u[24512]<<16|u[24513]<<24),t[e+47|0]=f,t[e+48|0]=f>>>8,t[e+49|0]=f>>>16,t[e+50|0]=f>>>24,t[e+51|0]=r,t[e+52|0]=r>>>8,t[e+53|0]=r>>>16,t[e+54|0]=r>>>24,r=u[24507]|u[24508]<<8|(u[24509]<<16|u[24510]<<24),f=u[24503]|u[24504]<<8|(u[24505]<<16|u[24506]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[24499]|u[24500]<<8|(u[24501]<<16|u[24502]<<24),f=u[24495]|u[24496]<<8|(u[24497]<<16|u[24498]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[24491]|u[24492]<<8|(u[24493]<<16|u[24494]<<24),f=u[24487]|u[24488]<<8|(u[24489]<<16|u[24490]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[24483]|u[24484]<<8|(u[24485]<<16|u[24486]<<24),f=u[24479]|u[24480]<<8|(u[24481]<<16|u[24482]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[24475]|u[24476]<<8|(u[24477]<<16|u[24478]<<24),f=u[24471]|u[24472]<<8|(u[24473]<<16|u[24474]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(u2(r,o),F4(r,f),f=f+12|0,(n|0)==(f|0))break}if(f=(i[e+132>>2]-i[e+128>>2]|0)/12|0,f>>>0>=256){if(e=C(48),i[k+20>>2]=e,i[k+24>>2]=45,i[k+28>>2]=-2147483600,r=u[24579]|u[24580]<<8|(u[24581]<<16|u[24582]<<24),f=u[24575]|u[24576]<<8|(u[24577]<<16|u[24578]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+45|0]=0,r=u[24616]|u[24617]<<8|(u[24618]<<16|u[24619]<<24),f=u[24612]|u[24613]<<8|(u[24614]<<16|u[24615]<<24),t[e+37|0]=f,t[e+38|0]=f>>>8,t[e+39|0]=f>>>16,t[e+40|0]=f>>>24,t[e+41|0]=r,t[e+42|0]=r>>>8,t[e+43|0]=r>>>16,t[e+44|0]=r>>>24,r=u[24611]|u[24612]<<8|(u[24613]<<16|u[24614]<<24),f=u[24607]|u[24608]<<8|(u[24609]<<16|u[24610]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[24603]|u[24604]<<8|(u[24605]<<16|u[24606]<<24),f=u[24599]|u[24600]<<8|(u[24601]<<16|u[24602]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[24595]|u[24596]<<8|(u[24597]<<16|u[24598]<<24),f=u[24591]|u[24592]<<8|(u[24593]<<16|u[24594]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[24587]|u[24588]<<8|(u[24589]<<16|u[24590]<<24),f=u[24583]|u[24584]<<8|(u[24585]<<16|u[24586]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(h2(r,f),f=i[e+128>>2],n=i[e+132>>2],(f|0)!=(n|0))for(;;){if(o=i[f+4>>2]-i[f>>2]|0,o>>>0>=65536){if(e=C(56),i[k+20>>2]=e,i[k+24>>2]=55,i[k+28>>2]=-2147483592,r=u[24523]|u[24524]<<8|(u[24525]<<16|u[24526]<<24),f=u[24519]|u[24520]<<8|(u[24521]<<16|u[24522]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+55|0]=0,r=u[24570]|u[24571]<<8|(u[24572]<<16|u[24573]<<24),f=u[24566]|u[24567]<<8|(u[24568]<<16|u[24569]<<24),t[e+47|0]=f,t[e+48|0]=f>>>8,t[e+49|0]=f>>>16,t[e+50|0]=f>>>24,t[e+51|0]=r,t[e+52|0]=r>>>8,t[e+53|0]=r>>>16,t[e+54|0]=r>>>24,r=u[24563]|u[24564]<<8|(u[24565]<<16|u[24566]<<24),f=u[24559]|u[24560]<<8|(u[24561]<<16|u[24562]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[24555]|u[24556]<<8|(u[24557]<<16|u[24558]<<24),f=u[24551]|u[24552]<<8|(u[24553]<<16|u[24554]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[24547]|u[24548]<<8|(u[24549]<<16|u[24550]<<24),f=u[24543]|u[24544]<<8|(u[24545]<<16|u[24546]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[24539]|u[24540]<<8|(u[24541]<<16|u[24542]<<24),f=u[24535]|u[24536]<<8|(u[24537]<<16|u[24538]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[24531]|u[24532]<<8|(u[24533]<<16|u[24534]<<24),f=u[24527]|u[24528]<<8|(u[24529]<<16|u[24530]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(u2(r,o),F4(r,f),f=f+12|0,(n|0)==(f|0))break}f=u[e+101|0]-66|0;e:{if(1<<f&4196353&&f>>>0<=22)break e;if(h2(r,u[e+108|0]),h2(r,u[e+112|0]-8&255),h2(r,u[e+113|0]-8&255),f=(i[e+144>>2]-i[e+140>>2]|0)/12|0,f>>>0>=256){if(e=A,A=V2(k+20|0,24353),a(e,9,0,A),t[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(h2(r,f),f=i[e+140>>2],n=i[e+144>>2],(f|0)==(n|0))break e;for(;;){if(o=i[f+4>>2]-i[f>>2]|0,o>>>0>=65536){if(e=C(64),i[k+20>>2]=e,i[k+24>>2]=59,i[k+28>>2]=-2147483584,r=u[24407]|u[24408]<<8|(u[24409]<<16|u[24410]<<24),f=u[24403]|u[24404]<<8|(u[24405]<<16|u[24406]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+59|0]=0,r=u[24458]|u[24459]<<8|(u[24460]<<16|u[24461]<<24),t[e+55|0]=r,t[e+56|0]=r>>>8,t[e+57|0]=r>>>16,t[e+58|0]=r>>>24,r=u[24455]|u[24456]<<8|(u[24457]<<16|u[24458]<<24),f=u[24451]|u[24452]<<8|(u[24453]<<16|u[24454]<<24),t[e+48|0]=f,t[e+49|0]=f>>>8,t[e+50|0]=f>>>16,t[e+51|0]=f>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[24447]|u[24448]<<8|(u[24449]<<16|u[24450]<<24),f=u[24443]|u[24444]<<8|(u[24445]<<16|u[24446]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[24439]|u[24440]<<8|(u[24441]<<16|u[24442]<<24),f=u[24435]|u[24436]<<8|(u[24437]<<16|u[24438]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[24431]|u[24432]<<8|(u[24433]<<16|u[24434]<<24),f=u[24427]|u[24428]<<8|(u[24429]<<16|u[24430]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[24423]|u[24424]<<8|(u[24425]<<16|u[24426]<<24),f=u[24419]|u[24420]<<8|(u[24421]<<16|u[24422]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[24415]|u[24416]<<8|(u[24417]<<16|u[24418]<<24),f=u[24411]|u[24412]<<8|(u[24413]<<16|u[24414]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(u2(r,o),F4(r,f),f=f+12|0,(n|0)==(f|0))break}}if(n1(k,e,r,l),t[k+19|0]<0&&Z(i[k+8>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function E9(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=D(0),S=0;f=v-144|0,v=f,l0(f,0,144),i[f+76>>2]=-1,i[f+44>>2]=A,i[f+32>>2]=2125,i[f+84>>2]=A,k=e,R=r,l=v-304|0,v=l;i:{e:{if(!i[f+4>>2]&&(fr(f),!i[f+4>>2]))break e;if(e=u[k|0],!e)break i;r:{f:{for(;;){A:{A=e&255;k:{if((A|0)==32|A-9>>>0<5){for(;e=k,k=k+1|0,A=u[e+1|0],!!((A|0)==32|A-9>>>0<5););for(I8(f,0,0);;){A=i[f+4>>2];n:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break n}A=q2(f)}if(!((A|0)==32|A-9>>>0<5))break}k=i[f+4>>2],A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(k=k-1|0,i[f+4>>2]=k),A=k-i[f+44>>2]|0,r=A,o=G+i[f+124>>2]|0,k=A>>31,A=_+i[f+120>>2]|0,o=k+(A>>>0<_>>>0?o+1|0:o)|0,_=A+r|0,G=_>>>0<A>>>0?o+1|0:o;break k}n:{t:{o:{if((A|0)==37){if(A=u[k+1|0],(A|0)==42)break o;if((A|0)!=37)break t}I8(f,0,0);l:{if(u[k|0]==37){for(;;){A=i[f+4>>2];u:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,e=u[A|0];break u}e=q2(f)}if(!((e|0)==32|e-9>>>0<5))break}k=k+1|0;break l}if(A=i[f+4>>2],(A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,e=u[A|0];break l}e=q2(f)}if(u[k|0]!=(e|0)){if(A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),E|(e|0)>=0)break i;break e}A=i[f+4>>2]-i[f+44>>2]|0,r=A,n=A>>31,A=G+i[f+124>>2]|0,e=_+i[f+120>>2]|0,s=(e>>>0<_>>>0?A+1|0:A)+n|0,_=e+r|0,G=_>>>0<e>>>0?s+1|0:s,e=k;break k}w=0,e=k+2|0;break n}if(A=A-48|0,!(u[k+2|0]!=36|A>>>0>9)){e=v-16|0,i[e+12>>2]=R,A=A>>>0>1?((A<<2)+R|0)-4|0:R,i[e+8>>2]=A+4,w=i[A>>2],e=k+3|0;break n}w=i[R>>2],R=R+4|0,e=k+1|0}if(V=0,r=0,k=u[e|0],(k-48&255)>>>0<=9)for(;r=(g(r,10)+(k&255)|0)-48|0,k=u[e+1|0],e=e+1|0,(k-48&255)>>>0<10;);(k&255)==109&&(m=0,V=(w|0)!=0,k=u[e+1|0],I=0,e=e+1|0),n=e,e=e+1|0,A=3;n:{t:switch((k&255)-65|0){case 39:A=u[n+1|0]==104,e=A?n+2|0:e,A=A?-2:-1;break n;case 43:A=u[n+1|0]==108,e=A?n+2|0:e,A=A?3:1;break n;case 51:case 57:A=1;break n;case 11:A=2;break n;case 0:case 2:case 4:case 5:case 6:case 18:case 23:case 26:case 32:case 34:case 35:case 36:case 37:case 38:case 40:case 45:case 46:case 47:case 50:case 52:case 55:break t;case 41:break n;default:break f}A=0,e=n}n=A,A=u[e|0],k=(A&47)==3,N=k?1:n,Q=k?A|32:A;n:{if((Q|0)==91)break n;t:{if((Q|0)!=110){if((Q|0)!=99)break t;r=(r|0)<=1?1:r;break n}du(w,N,_,G);break k}for(I8(f,0,0);;){A=i[f+4>>2];t:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break t}A=q2(f)}if(!((A|0)==32|A-9>>>0<5))break}k=i[f+4>>2],A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(k=k-1|0,i[f+4>>2]=k),A=k-i[f+44>>2]|0,k=A,o=G+i[f+124>>2]|0,n=A>>31,A=_+i[f+120>>2]|0,G=n+(A>>>0<_>>>0?o+1|0:o)|0,_=A+k|0,G=_>>>0<A>>>0?G+1|0:G}s=r,B=r>>31,I8(f,r,B),A=i[f+4>>2];n:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1;break n}if((q2(f)|0)<0)break f}A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),k=16;n:{t:{o:{l:{u:{s:{h:switch(Q-88|0){default:if(A=Q-65|0,A>>>0>6|!(1<<A&113))break n;case 9:case 13:case 14:case 15:if(F9(l+8|0,f,N,0),A=i[f+4>>2]-i[f+44>>2]|0,i[f+120>>2]==(0-A|0)&i[f+124>>2]==(0-((A>>31)+((A|0)!=0)|0)|0))break r;if(!w)break n;switch(A=i[l+16>>2],k=i[l+20>>2],r=i[l+8>>2],n=i[l+12>>2],N|0){case 0:break u;case 1:break l;case 2:break o;default:break n}case 3:case 11:case 27:if((Q|16)==115){if(Ni(l+32|0,-1,257),t[l+32|0]=0,(Q|0)!=115)break t;t[l+65|0]=0,t[l+46|0]=0,X[l+42>>1]=0,X[l+44>>1]=0;break t}k=u[e+1|0],n=(k|0)==94,Ni(l+32|0,n,257),t[l+32|0]=0,A=n?e+2|0:e+1|0;w:{_:{v:{if(e=u[(n?2:1)+e|0],(e|0)!=45){if((e|0)==93)break v;h=(k|0)!=94;break w}h=(k|0)!=94,t[l+78|0]=h;break _}h=(k|0)!=94,t[l+126|0]=h}A=A+1|0}for(e=A;;){A=u[e|0];w:{if((A|0)!=45){if(!A)break f;if((A|0)==93)break t;break w}if(A=45,n=u[e+1|0],!n|(n|0)==93)break w;o=e+1|0,k=u[e-1|0];_:{if(n>>>0<=k>>>0){A=n;break _}for(;k=k+1|0,t[k+(l+32|0)|0]=h,A=u[o|0],k>>>0<A>>>0;);}e=o}t[((l+32|0)+A|0)+1|0]=h,e=e+1|0}case 23:k=8;break s;case 12:case 29:k=10;break s;case 0:case 24:case 32:break s;case 1:case 2:case 4:case 5:case 6:case 7:case 8:case 10:case 16:case 18:case 19:case 20:case 21:case 22:case 25:case 26:case 28:case 30:case 31:break n;case 17:break h}k=0}n=0,o=0,r=0,s=0,h=0,U=v-16|0,v=U;s:{if(!((k|0)!=1&k>>>0<=36)){i[33136]=28;break s}for(;;){A=i[f+4>>2];h:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break h}A=q2(f)}if(!((A|0)==32|A-9>>>0<5))break}h:{w:switch(A-43|0){case 0:case 2:break w;default:break h}if(h=(A|0)==45?-1:0,A=i[f+4>>2],(A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break h}A=q2(f)}h:{w:{_:{v:{if(!((k|0)!=0&(k|0)!=16|(A|0)!=48)){A=i[f+4>>2];B:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break B}A=q2(f)}if((A&-33)==88){k=16,A=i[f+4>>2];B:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break B}A=q2(f)}if(u[A+80033|0]<16)break _;A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),I8(f,0,0);break s}if(k)break v;k=8;break _}if(k=k||10,k>>>0>u[A+80033|0])break v;A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),I8(f,0,0),i[33136]=28;break s}if((k|0)!=10)break _;if(r=A-48|0,r>>>0<=9){for(A=0;;){A=g(A,10)+r|0,k=A>>>0<429496729,r=i[f+4>>2];v:{if((r|0)!=i[f+104>>2]){i[f+4>>2]=r+1,r=u[r|0];break v}r=q2(f)}if(r=r-48|0,!(k&r>>>0<=9))break}n=A}if(r>>>0>9)break h;for(k=L0(n,0,10,0),B=h0;;){v:{o=B,n=r+k|0,o=n>>>0<r>>>0?o+1|0:o,r=(o|0)==429496729&n>>>0<2576980378|o>>>0<429496729,A=i[f+4>>2];B:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break B}A=q2(f)}if(s=A-48|0,!(r&s>>>0<=9)){if(s>>>0<=9)break v;break h}if(k=L0(n,o,10,0),B=h0,r=s,(B|0)==-1&(r^-1)>>>0>=k>>>0|(B|0)!=-1)continue}break}k=10;break w}if(k-1&k){if(s=u[A+80033|0],s>>>0<k>>>0){for(;;){r=g(r,k)+s|0,n=r>>>0<119304647,A=i[f+4>>2];_:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break _}A=q2(f)}if(s=u[A+80033|0],!(n&s>>>0<k>>>0))break}n=r}if(k>>>0<=s>>>0)break w;for(;;){if(r=L0(n,o,k,0),B=h0,s=s&255,(B|0)==-1&(s^-1)>>>0<r>>>0)break w;o=B,n=r+s|0,o=n>>>0<s>>>0?o+1|0:o,A=i[f+4>>2];_:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break _}A=q2(f)}if(s=u[A+80033|0],k>>>0<=s>>>0)break w;if(e4(U,k,0,0,0,n,o,0,0),!!(i[U+8>>2]|i[U+12>>2]))break}break w}if(B=t[(g(k,23)>>>5&7)+80289|0],r=u[A+80033|0],k>>>0>r>>>0){for(;;){A=s<<B,s=A|r,n=A>>>0<134217728,A=i[f+4>>2];_:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break _}A=q2(f)}if(r=u[A+80033|0],!(n&k>>>0>r>>>0))break}n=s}if(r>>>0>=k>>>0||(Y=B&31,(B&63)>>>0>=32?(s=0,Y=-1>>>Y|0):(s=-1>>>Y|0,Y=s|(1<<Y)-1<<32-Y),!s&n>>>0>Y>>>0))break w;for(;;){x=r&255,r=n,A=B&31,(B&63)>>>0>=32?(o=r<<A,A=0):(o=(1<<A)-1&r>>>32-A|o<<A,A=r<<A),n=x|A,A=i[f+4>>2];_:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break _}A=q2(f)}if(r=u[A+80033|0],k>>>0<=r>>>0)break w;if(!((o|0)==(s|0)&n>>>0<=Y>>>0|o>>>0<s>>>0))break}}if(u[A+80033|0]>=k>>>0)break h;for(;;){A=i[f+4>>2];w:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break w}A=q2(f)}if(!(u[A+80033|0]<k>>>0))break}i[33136]=68,h=0,n=-1,o=-1}A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1);h:if((o&n)!=-1)break h;A=n^h,n=A-h|0,r=h>>31,o=(r^o)-((A>>>0<h>>>0)+r|0)|0}if(v=U+16|0,A=i[f+4>>2]-i[f+44>>2]|0,i[f+120>>2]==(0-A|0)&i[f+124>>2]==(0-((A>>31)+((A|0)!=0)|0)|0))break r;if(!(!w|(Q|0)!=112)){i[w>>2]=n;break n}du(w,N,n,o);break n}j=w,O=Ut(r,n,A,k),E0[j>>2]=O;break n}j=w,S=TA(r,n,A,k),u0[j>>3]=S;break n}i[w>>2]=r,i[w+4>>2]=n,i[w+8>>2]=A,i[w+12>>2]=k;break n}n=(Q|0)!=99,h=n?31:r+1|0;t:{if((N|0)==1){if(r=w,V&&(r=E2(h<<2),!r))break A;i[l+296>>2]=0,i[l+300>>2]=0,k=0;o:{l:{for(;;){for(A=r;;){r=i[f+4>>2];u:{if((r|0)!=i[f+104>>2]){i[f+4>>2]=r+1,r=u[r|0];break u}r=q2(f)}if(!u[(r+l|0)+33|0])break l;if(t[l+27|0]=r,r=ze(l+28|0,l+27|0,1,l+296|0),(r|0)!=-2){if((r|0)==-1){m=0;break o}if(A&&(i[(k<<2)+A>>2]=i[l+28>>2],k=k+1|0),!(!V|(k|0)!=(h|0)))break}}if(h=h<<1|1,r=f3(A,h<<2),!r)break}m=0,I=A,V=1;break f}if(m=0,I=A,!(l+296|0&&i[l+296>>2]))break t}I=A;break f}if(V){if(k=0,r=E2(h),!r)break A;for(;;){for(A=r;;){r=i[f+4>>2];o:{if((r|0)!=i[f+104>>2]){i[f+4>>2]=r+1,r=u[r|0];break o}r=q2(f)}if(!u[(r+l|0)+33|0]){m=A,I=0;break t}if(t[A+k|0]=r,k=k+1|0,(h|0)==(k|0))break}if(h=h<<1|1,r=f3(A,h),!r)break}I=0,m=A,V=1;break f}if(k=0,w)for(;;){A=i[f+4>>2];o:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break o}A=q2(f)}if(u[(A+l|0)+33|0]){t[k+w|0]=A,k=k+1|0;continue}else{A=w,m=A,I=0;break t}}for(;;){A=i[f+4>>2];o:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=u[A|0];break o}A=q2(f)}if(!u[(A+l|0)+33|0])break}A=0,m=0,I=0}if(r=i[f+4>>2],o=i[f+116>>2],(o|0)>0?o=1:o=(o|0)>=0,o&&(r=r-1|0,i[f+4>>2]=r),o=r-i[f+44>>2]|0,h=o,r=o+i[f+120>>2]|0,o=i[f+124>>2]+(o>>31)|0,o=r>>>0<h>>>0?o+1|0:o,!(o|r)|!(n|(r|0)==(s|0)&(o|0)==(B|0)))break r;if(V&&(i[w>>2]=A),(Q|0)==99)break n;if(I&&(i[(k<<2)+I>>2]=0),!m){m=0;break n}t[k+m|0]=0}A=i[f+4>>2]-i[f+44>>2]|0,k=A,n=A>>31,A=G+i[f+124>>2]|0,r=_+i[f+120>>2]|0,o=(r>>>0<_>>>0?A+1|0:A)+n|0,_=r+k|0,G=_>>>0<r>>>0?o+1|0:o,E=((w|0)!=0)+E|0}if(k=e+1|0,e=u[e+1|0],e)continue;break i}break}V=1,m=0,I=0}E=E||-1}if(!V)break i;Z(m),Z(I);break i}E=-1}return v=l+304|0,v=f+144|0,E}function R9(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0;f=v-208|0,v=f,k=i[r+52>>2],n=k?i[e+64>>2]:i[e+80>>2];i:{if(!(!k&&i[e+84>>2])&n>>>0<=o0[e+96>>2]){e=C(16),i[f+48>>2]=e,i[f+52>>2]=15,i[f+56>>2]=-2147483632,r=u[16807]|u[16808]<<8|(u[16809]<<16|u[16810]<<24),k=u[16803]|u[16804]<<8|(u[16805]<<16|u[16806]<<24),t[e+7|0]=k,t[e+8|0]=k>>>8,t[e+9|0]=k>>>16,t[e+10|0]=k>>>24,t[e+11|0]=r,t[e+12|0]=r>>>8,t[e+13|0]=r>>>16,t[e+14|0]=r>>>24,r=u[16800]|u[16801]<<8|(u[16802]<<16|u[16803]<<24),k=u[16796]|u[16797]<<8|(u[16798]<<16|u[16799]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+15|0]=0,e=a(f+128|0,13,0,f+48|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(t[f+59|0]>=0)break i;Z(i[f+48>>2]);break i}G=f+140|0,I=f+147|0,Q=f+136|0,i[f+204>>2]=0,l=A+8|0,V=i[28438],Y=i[28439],B=f+152|0,E=f+96|0;e:{r:{f:{for(;;){k=i[e+68>>2],k=g(o0[e+92>>2]%((i[e+72>>2]-k|0)/48>>>0)|0,48)+k|0,_=i[k>>2],m=i[e+104>>2]+(i[k+8>>2]<<3)|0,k=i[m>>2],W[i[i[k>>2]+8>>2]](f+196|0,k);A:{if(i[e+92>>2]){k=i[f+196>>2],W[i[i[k>>2]+44>>2]](f+128|0,k,r,f+204|0,i[e+20>>2]- -64|0);k:{n:{t:{o:{l:{u:switch(u[f+148|0]){case 0:if(k=114912,!i[28728])break o;o=114924,h=114931,n=114920;break l;case 1:break u;default:break f}if(k=f+128|0,n=Q,h=I,o=G,!i[f+128>>2])break f}R=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=R;l:{if(t[h|0]>=0){k=i[n+4>>2],i[l>>2]=i[n>>2],i[l+4>>2]=k,i[l+8>>2]=i[n+8>>2];break l}T(l,i[n>>2],i[o>>2])}t[A+20|0]=1;break t}if(h=i[f+128>>2],h){o=i[f+132>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);o:{if(!s||(k=i[s+4>>2],i[s+4>>2]=k-1,k))break o;W[i[i[s>>2]+8>>2]](s),y(s)}if(n=2,k=0,(i[e+96>>2]+1>>>0)%((i[e+72>>2]-i[e+68>>2]|0)/48>>>0)|0)break n;t[e+100|0]=0;break n}if(k=1,u[e+100|0]!=1){n=0;break k}k=C(32),i[f+184>>2]=k,i[f+188>>2]=25,i[f+192>>2]=-2147483616,t[k+24|0]=u[5901],n=u[5897]|u[5898]<<8|(u[5899]<<16|u[5900]<<24),o=u[5893]|u[5894]<<8|(u[5895]<<16|u[5896]<<24),t[k+16|0]=o,t[k+17|0]=o>>>8,t[k+18|0]=o>>>16,t[k+19|0]=o>>>24,t[k+20|0]=n,t[k+21|0]=n>>>8,t[k+22|0]=n>>>16,t[k+23|0]=n>>>24,n=u[5889]|u[5890]<<8|(u[5891]<<16|u[5892]<<24),o=u[5885]|u[5886]<<8|(u[5887]<<16|u[5888]<<24),t[k+8|0]=o,t[k+9|0]=o>>>8,t[k+10|0]=o>>>16,t[k+11|0]=o>>>24,t[k+12|0]=n,t[k+13|0]=n>>>8,t[k+14|0]=n>>>16,t[k+15|0]=n>>>24,n=u[5881]|u[5882]<<8|(u[5883]<<16|u[5884]<<24),o=u[5877]|u[5878]<<8|(u[5879]<<16|u[5880]<<24),t[k|0]=o,t[k+1|0]=o>>>8,t[k+2|0]=o>>>16,t[k+3|0]=o>>>24,t[k+4|0]=n,t[k+5|0]=n>>>8,t[k+6|0]=n>>>16,t[k+7|0]=n>>>24,t[k+25|0]=0,k=a(f+48|0,7,0,f+184|0),n=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=n;o:{if(t[f+67|0]>=0){k=i[f+60>>2],i[l>>2]=i[f+56>>2],i[l+4>>2]=k,i[l+8>>2]=i[f+64>>2],t[A+20|0]=1;break o}if(T(l,i[f+56>>2],i[f+60>>2]),k=t[f+67|0],t[A+20|0]=1,(k|0)>=0)break o;Z(i[f+56>>2])}t[f+195|0]<0&&Z(i[f+184>>2])}n=1,k=0;break k}w=h,s=o}if(o=u[f+148|0],(o|0)!=255&&(i[f+48>>2]=V,i[f+52>>2]=Y,W[i[(f+48|0)+(o<<2)>>2]](f+184|0,f+128|0)),!k)break A;k=i[e+92>>2]}else k=0;k:{n:{if(n=i[e+84>>2],!n&o0[e+80>>2]>k>>>0|n){oo(f+128|0,i[m>>2],_),t[f+80|0]=u[f+136|0],o=i[f+128>>2],h=i[f+132>>2],i[f+128>>2]=0,i[f+132>>2]=0,k=i[f+140>>2],i[f+140>>2]=0,i[f+84>>2]=k,k=i[f+144>>2],n=i[f+148>>2],i[f+144>>2]=0,i[f+148>>2]=0,i[f+88>>2]=k,i[f+92>>2]=n,k=i[f+152>>2],n=i[f+156>>2],i[f+152>>2]=0,i[f+156>>2]=0,i[f+96>>2]=k,i[f+100>>2]=n,k=i[f+196>>2],i[f+120>>2]=i[f+176>>2],n=i[f+172>>2],i[f+112>>2]=i[f+168>>2],i[f+116>>2]=n,n=i[f+164>>2],i[f+104>>2]=i[f+160>>2],i[f+108>>2]=n,i[f+72>>2]=0,i[f+76>>2]=0,n=i[k+12>>2],i[k+8>>2]=o,i[k+12>>2]=h;t:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break t;W[i[i[n>>2]+8>>2]](n),y(n)}t[k+16|0]=u[f+80|0],n=i[k+20>>2],n&&(i[k+24>>2]=n,Z(n)),i[k+20>>2]=i[f+84>>2],i[k+24>>2]=i[f+88>>2],i[k+28>>2]=i[f+92>>2],i[f+92>>2]=0,i[f+84>>2]=0,i[f+88>>2]=0,(k|0)!=(f- -64|0)&&(k1(k+32|0),i[k+32>>2]=i[f+96>>2],i[k+36>>2]=i[f+100>>2],i[f+96>>2]=0,i[f+100>>2]=0),n=i[f+108>>2],i[k+40>>2]=i[f+104>>2],i[k+44>>2]=n,i[k+56>>2]=i[f+120>>2],n=i[f+116>>2],i[k+48>>2]=i[f+112>>2],i[k+52>>2]=n,k1(E),k=i[f+84>>2],k&&(i[f+88>>2]=k,Z(k)),k=i[f+76>>2];t:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break t;W[i[i[k>>2]+8>>2]](k),y(k)}if(i[e+92>>2]=i[e+92>>2]+1,k=i[f+196>>2],W[i[i[k>>2]+36>>2]](f+48|0,k,!_,r,_,i[e+20>>2]- -64|0),!i[f+48>>2])break n;k=i[f+52>>2],i[A>>2]=i[f+48>>2],i[A+4>>2]=k;t:{if(t[f+67|0]>=0){k=i[f+60>>2],i[l>>2]=i[f+56>>2],i[l+4>>2]=k,i[l+8>>2]=i[f+64>>2],t[A+20|0]=1;break t}if(T(l,i[f+56>>2],i[f+60>>2]),k=t[f+67|0],t[A+20|0]=1,(k|0)>=0)break t;Z(i[f+56>>2])}k1(B),k=i[f+140>>2],k&&(i[f+144>>2]=k,Z(k)),k=i[f+132>>2];t:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break t;W[i[i[k>>2]+8>>2]](k),y(k)}n=1;break A}k=i[f+196>>2],W[i[i[k>>2]+40>>2]](f+128|0,k),k=i[f+128>>2];t:{if(k){if(n=i[f+132>>2],i[A>>2]=i[f+128>>2],i[A+4>>2]=n,t[f+147|0]>=0){n=i[f+140>>2],i[l>>2]=i[f+136>>2],i[l+4>>2]=n,i[l+8>>2]=i[f+144>>2],t[A+20|0]=1;break t}T(l,i[f+136>>2],i[f+140>>2]),t[A+20|0]=1;break t}t[e+100|0]=1}if(t[f+147|0]<0&&Z(i[f+136>>2]),n=1,!k)break k;break A}if(t[f+67|0]<0&&Z(i[f+56>>2]),k1(B),k=i[f+140>>2],k&&(i[f+144>>2]=k,Z(k)),k=i[f+132>>2],!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break k;W[i[i[k>>2]+8>>2]](k),y(k)}n=0}k=i[f+200>>2];A:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(n)break}if((n|0)!=2)break e;if(k=i[e+208>>2],k&&(N=w,U=j5(k,_),i[N+156>>2]=U),k=i[e+324>>2],k){R9(f+128|0,k,r),k=u[f+148|0];A:{if(k){if((k|0)!=1)break f;r=i[f+132>>2],i[A>>2]=i[f+128>>2],i[A+4>>2]=r;k:{if(t[f+147|0]>=0){r=i[f+140>>2],i[l>>2]=i[f+136>>2],i[l+4>>2]=r,i[l+8>>2]=i[f+144>>2];break k}T(l,i[f+136>>2],i[f+140>>2])}t[A+20|0]=1;break A}if(i[f+48>>2]=i[f+128>>2],r=i[f+132>>2],i[f+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),x9(w,f+48|0,0),r=i[f+52>>2],!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break A;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=u[f+148|0],(r|0)!=255&&(n=i[28439],i[f+48>>2]=i[28438],i[f+52>>2]=n,W[i[(f+48|0)+(r<<2)>>2]](f+184|0,f+128|0)),k)break e}if(k=i[e+280>>2],k){r=i[e+20>>2],i[f+48>>2]=i[r+48>>2],r=i[r+52>>2],i[f+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),Ci(f+128|0,k,i[f+48>>2],i[f+204>>2]),r=i[f+52>>2];A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;W[i[i[r>>2]+8>>2]](r),y(r)}A:switch(u[f+148|0]){case 1:e=i[f+132>>2],i[A>>2]=i[f+128>>2],i[A+4>>2]=e;k:{if(t[f+147|0]>=0){e=i[f+140>>2],i[l>>2]=i[f+136>>2],i[l+4>>2]=e,i[l+8>>2]=i[f+144>>2],e=1,t[A+20|0]=1;break k}if(T(l,i[f+136>>2],i[f+140>>2]),e=u[f+148|0],t[A+20|0]=1,(e|0)==255)break e}A=i[28443],i[f+48>>2]=i[28442],i[f+52>>2]=A,W[i[(f+48|0)+(e<<2)>>2]](f+184|0,f+128|0);break e;case 0:break A;default:break f}ZA(f+48|0,f+128|0),r=u[f+68|0];A:{if(r){if((r|0)!=1)break f;k=i[f+52>>2],i[A>>2]=i[f+48>>2],i[A+4>>2]=k;k:{if(t[f+67|0]>=0){k=i[f+60>>2],i[l>>2]=i[f+56>>2],i[l+4>>2]=k,i[l+8>>2]=i[f+64>>2];break k}T(l,i[f+56>>2],i[f+60>>2])}t[A+20|0]=1;break A}k:{if(t[f+59|0]>=0){i[f+40>>2]=i[f+56>>2],k=i[f+52>>2],i[f+32>>2]=i[f+48>>2],i[f+36>>2]=k;break k}T(f+32|0,i[f+48>>2],i[f+52>>2])}if(W[i[i[w>>2]+36>>2]](w,f+32|0),t[f+43|0]>=0)break A;Z(i[f+32>>2])}if(k=u[f+68|0],(k|0)!=255&&(n=i[28441],i[f+184>>2]=i[28440],i[f+188>>2]=n,W[i[(f+184|0)+(k<<2)>>2]](f+196|0,f+48|0)),k=u[f+148|0],(k|0)!=255&&(n=i[28443],i[f+48>>2]=i[28442],i[f+52>>2]=n,W[i[(f+48|0)+(k<<2)>>2]](f+184|0,f+128|0)),r)break e}k=i[e+276>>2];A:{if(!k)break A;r=i[e+20>>2],i[f+128>>2]=i[r+48>>2],r=i[r+52>>2],i[f+132>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),Ci(f+48|0,k,i[f+128>>2],i[f+204>>2]),r=i[f+132>>2];k:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break k;W[i[i[r>>2]+8>>2]](r),y(r)}k:switch(u[f+68|0]){case 1:e=i[f+52>>2],i[A>>2]=i[f+48>>2],i[A+4>>2]=e;n:{if(t[f+67|0]>=0){e=i[f+60>>2],i[l>>2]=i[f+56>>2],i[l+4>>2]=e,i[l+8>>2]=i[f+64>>2],k=1;break n}T(l,i[f+56>>2],i[f+60>>2]),k=u[f+68|0]}t[A+20|0]=1;break r;case 0:break k;default:break f}k:{if(i[f+48>>2]==i[f+52>>2]){k=0;break k}k=f+128|0,dn(k,f+48|0),r=u[f+152|0];n:{if(r){if((r|0)!=1)break f;h6(A,k);break n}if(W[i[i[w>>2]+32>>2]](f+12|0,w,f+128|0),t[f+31|0]>=0)break n;Z(i[f+20>>2])}if(k=u[f+152|0],(k|0)!=255&&(n=i[28445],i[f+184>>2]=i[28444],i[f+188>>2]=n,W[i[(f+184|0)+(k<<2)>>2]](f+196|0,f+128|0)),k=u[f+68|0],r)break r;if((k&255)==255)break A}r=i[28443],i[f+128>>2]=i[28442],i[f+132>>2]=r,W[i[(f+128|0)+((k&255)<<2)>>2]](f+184|0,f+48|0)}i[e+96>>2]=i[e+96>>2]+1,t[A+20|0]=0,i[A+4>>2]=s,i[A>>2]=w;break i}e2(),M()}if(A=k&255,(A|0)==255)break e;e=i[28443],i[f+128>>2]=i[28442],i[f+132>>2]=e,W[i[(f+128|0)+(A<<2)>>2]](f+184|0,f+48|0)}if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=f+208|0}function Zv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;for(f=v-176|0,v=f,i[f+88>>2]=0,i[f+60>>2]=78468,k=i[19620],i[f+4>>2]=k,n=i[k-12>>2],k=f+4|0,i[n+k>>2]=i[19621],n=k+i[i[f+4>>2]-12>>2]|0,o=f+8|0,J0(n,o),t[n+80|0]=0,i[n+72>>2]=0,i[f+60>>2]=78468,i[f+4>>2]=78448,m=R0(o),i[m>>2]=77200,i[f+48>>2]=0,i[f+52>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+56>>2]=16,n=f+164|0,J2(n,e,r),o=k,l=n,k=t[f+175|0],n=(k|0)<0,F(o,n?i[f+164>>2]:l,n?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),k=f+164|0,k0(k,r),o=k,k=t[f+175|0],n=(k|0)<0,F(f+4|0,n?i[f+164>>2]:o,n?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(D0(F(f+4|0,34661,23),u[e+100|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(D0(F(k,36912,23),u[e+101|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(i1(F(k,35509,19),u[e+102|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),F(D0(F(k,37358,21),u[e+103|0]),47878,1),k=f+164|0,k0(k,r),o=k,k=t[f+175|0],n=(k|0)<0,F(f+4|0,n?i[f+164>>2]:o,n?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),F(f+4|0,33845,37),k=0;;){n=f+4|0,B0(n,i[e+104>>2]>>>31-k&1);i:{if((k&7)==7){t[f+164|0]=32,F(n,f+164|0,1);break i}if((k&3)!=3)break i;t[f+164|0]=46,F(f+4|0,f+164|0,1)}if(k=k+1|0,(k|0)==32)break}for(n=f+4|0,F(n,47878,1),o=f+164|0,k0(o,r),k=0,l=n,s=o,n=t[f+175|0],o=(n|0)<0,F(l,o?i[f+164>>2]:s,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),F(f+4|0,33883,36),n=e+108|0;o=f+4|0,D0(o,i[n+(k>>>3&536870908)>>2]>>>k&1),k=k+1|0,k&7||(t[f+164|0]=32,F(o,f+164|0,1)),(k|0)!=48;);k=f+4|0,F(k,47878,1),n=f+164|0,k0(n,r),o=k,l=n,k=t[f+175|0],n=(k|0)<0,F(o,n?i[f+164>>2]:l,n?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(D0(F(f+4|0,37338,19),u[e+116|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(B0(F(k,37307,30),p[e+118>>1]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(D0(F(k,36436,18),u[e+120|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),F(k,33526,15);i:{e:{r:{f:{A:{k:switch(k=u[e+121|0],k|0){case 0:break k;case 1:break A;case 2:break f;case 3:break r;default:break e}F(f+4|0,14186,10);break i}F(f+4|0,23840,5);break i}F(f+4|0,23376,5);break i}F(f+4|0,23184,5);break i}D0(f+4|0,k)}k=F(f+4|0,47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(D0(F(k,37408,16),u[e+122|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(D0(F(k,37442,18),u[e+123|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(B0(F(k,36255,16),p[e+124>>1]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(D0(F(k,36233,21),u[e+126|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(D0(F(k,33734,21),u[e+127|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(D0(F(k,37025,20),u[e+128|0]),47878,1),n=f+164|0,k0(n,r),l=n,n=t[f+175|0],o=(n|0)<0,F(k,o?i[f+164>>2]:l,o?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),F(D0(F(k,35775,13),u[e+129|0]),47878,1);i:{if(_=i[e+132>>2],V=i[e+136>>2],(_|0)!=(V|0))for(E=f+16|0;;){e=f+164|0,k0(e,r),n=e,e=t[f+175|0],k=(e|0)<0,F(f+4|0,k?i[f+164>>2]:n,k?i[f+168>>2]:e),t[f+175|0]<0&&Z(i[f+164>>2]),e=f+4|0,F(e,46853,8),i[r>>2]=i[r>>2]+1,k=f+164|0,k0(k,r),n=e,o=k,e=t[f+175|0],k=(e|0)<0,F(n,k?i[f+164>>2]:o,k?i[f+168>>2]:e),t[f+175|0]<0&&Z(i[f+164>>2]),e=F(D0(F(f+4|0,33676,20),u[_|0]),47878,1),k=f+164|0,k0(k,r),o=k,k=t[f+175|0],n=(k|0)<0,F(e,n?i[f+164>>2]:o,n?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),F(D0(F(e,36357,15),u[_+1|0]),47878,1);e:{if(B=i[_+4>>2],Y=i[_+8>>2],(B|0)==(Y|0))break e;for(;;){k0(f+144|0,r),o=t[f+155|0],l=i[f+144>>2],w=i[f+148>>2],e=f+4|0,G=X1(f+156|0,e);r:{if(u[G|0]!=1)break r;e=e+i[i[f+4>>2]-12>>2]|0,Q=i[e+4>>2],s=i[e+24>>2];f:{if(u[e+80|0]==1){k=u[e+76|0]|u[e+77|0]<<8|(u[e+78|0]<<16|u[e+79|0]<<24);break f}n=f+164|0,k=i[e+28>>2],i[n>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(n,137008),k=W[i[i[k>>2]+28>>2]](k,32)|0,i2(n),t[e+76|0]=k,t[e+77|0]=k>>>8,t[e+78|0]=k>>>16,t[e+79|0]=k>>>24,t[e+80|0]=1}f:{if(!s||(h=i[e+12>>2],n=l,l=(o|0)<0,n=l?n:f+144|0,o=l?w:o,I=n+o|0,l=(Q&176)==32?I:n,w=l-n|0,(w|0)>0&&(W[i[i[s>>2]+48>>2]](s,n,w)|0)!=(w|0)))break f;if(o=(o|0)<(h|0)?h-o|0:0,(o|0)>0){if(o>>>0>=2147483640)break i;A:{if(o>>>0>=11){h=o|7,n=C(h+1|0),i[f+172>>2]=h-2147483647,i[f+164>>2]=n,i[f+168>>2]=o;break A}t[f+175|0]=o,n=f+164|0}if(o&&l0(n,k,o),t[n+o|0]=0,k=W[i[i[s>>2]+48>>2]](s,t[f+175|0]<0?i[f+164>>2]:f+164|0,o)|0,t[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(o|0))break f}if(k=I-l|0,(k|0)>0&&(W[i[i[s>>2]+48>>2]](s,l,k)|0)!=(k|0))break f;i[e+12>>2]=0;break r}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,M1(e,i[e+16>>2]|5)}if(v1(G),t[f+155|0]<0&&Z(i[f+144>>2]),e=i[B>>2],G=i[B+4>>2],(e|0)!=(G|0))for(;;){s=u[e|0],n=i[f+4>>2],k=i[n-12>>2]+(f+4|0)|0,u[k+80|0]||(o=f+164|0,n=i[k+28>>2],i[o>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=$0(o,137008),W[i[i[n>>2]+28>>2]](n,32)|0,i2(o),n=i[f+4>>2]),t[k+76|0]=48,t[k+77|0]=0,t[k+78|0]=0,t[k+79|0]=0,t[k+80|0]=1,k=n-12|0,i[i[k>>2]+E>>2]=2,k=i[k>>2]+m|0,i[k>>2]=i[k>>2]&-75|8,l=D0(f+4|0,s),Q=X1(f+144|0,l);r:{if(u[Q|0]!=1)break r;n=l+i[i[l>>2]-12>>2]|0,w=i[n+4>>2],s=i[n+24>>2];f:{if(u[n+80|0]==1){h=u[n+76|0]|u[n+77|0]<<8|(u[n+78|0]<<16|u[n+79|0]<<24);break f}o=f+164|0,k=i[n+28>>2],i[o>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(o,137008),h=W[i[i[k>>2]+28>>2]](k,32)|0,i2(o),t[n+76|0]=h,t[n+77|0]=h>>>8,t[n+78|0]=h>>>16,t[n+79|0]=h>>>24,t[n+80|0]=1}f:{if(!s||(k=i[n+12>>2],w=(w&176)==32?37887:37886,o=w-37886|0,(o|0)>0&&(W[i[i[s>>2]+48>>2]](s,37886,o)|0)!=(o|0)))break f;if((k|0)>=2){if(k>>>0>=2147483641)break i;o=((k|0)<=1?1:k)-1|0;A:{if(k>>>0>=12){I=o|7,k=C(I+1|0),i[f+172>>2]=I-2147483647,i[f+164>>2]=k,i[f+168>>2]=o;break A}t[f+175|0]=o,k=f+164|0}if(o&&l0(k,h,o),t[k+o|0]=0,k=W[i[i[s>>2]+48>>2]](s,t[f+175|0]<0?i[f+164>>2]:f+164|0,o)|0,t[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(o|0))break f}if(k=37887-w|0,(k|0)>0&&(W[i[i[s>>2]+48>>2]](s,w,k)|0)!=(k|0))break f;i[n+12>>2]=0;break r}k=l+i[i[l>>2]-12>>2]|0,M1(k,i[k+16>>2]|5)}if(v1(Q),e=e+1|0,(G|0)==(e|0))break}r:{e=f+4|0,l=X1(f+144|0,e);f:{if(u[l|0]!=1)break f;e=e+i[i[f+4>>2]-12>>2]|0,o=i[e+4>>2],s=i[e+24>>2];A:{if(u[e+80|0]==1){k=u[e+76|0]|u[e+77|0]<<8|(u[e+78|0]<<16|u[e+79|0]<<24);break A}n=f+164|0,k=i[e+28>>2],i[n>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(n,137008),k=W[i[i[k>>2]+28>>2]](k,32)|0,i2(n),t[e+76|0]=k,t[e+77|0]=k>>>8,t[e+78|0]=k>>>16,t[e+79|0]=k>>>24,t[e+80|0]=1}A:{if(!s||(n=i[e+12>>2],h=(o&176)==32?47879:47878,o=h-47878|0,(o|0)>0&&(W[i[i[s>>2]+48>>2]](s,47878,o)|0)!=(o|0)))break A;if((n|0)>=2){if(n>>>0>=2147483641)break r;o=((n|0)<=1?1:n)-1|0;k:{if(n>>>0>=12){w=o|7,n=C(w+1|0),i[f+172>>2]=w-2147483647,i[f+164>>2]=n,i[f+168>>2]=o;break k}t[f+175|0]=o,n=f+164|0}if(o&&l0(n,k,o),t[n+o|0]=0,k=W[i[i[s>>2]+48>>2]](s,t[f+175|0]<0?i[f+164>>2]:f+164|0,o)|0,t[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(o|0))break A}if(k=47879-h|0,(k|0)>0&&(W[i[i[s>>2]+48>>2]](s,h,k)|0)!=(k|0))break A;i[e+12>>2]=0;break f}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,M1(e,i[e+16>>2]|5)}if(v1(l),e=i[i[f+4>>2]-12>>2]+m|0,i[e>>2]=i[e>>2]&-75|2,B=B+12|0,(Y|0)==(B|0))break e;continue}break}break i}if(e=i[r>>2],i[r>>2]=((e|0)<=1?1:e)-1,_=_+16|0,(V|0)==(_|0))break}e=i[f+56>>2];e:{r:{if(e&16){k=i[f+52>>2],e=i[f+32>>2],k>>>0<e>>>0&&(i[f+52>>2]=e,k=e),e=f+28|0;break r}if(!(e&8)){k=0,t[A+11|0]=0;break e}k=i[f+24>>2],e=f+16|0}r:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break r}if(t[A+11|0]=k,k)break r;k=0;break e}I0(),M()}if(!k)break e;z(A,r,k)}t[A+k|0]=0,A=i[19619],i[f+4>>2]=A,i[i[A-12>>2]+(f+4|0)>>2]=i[19622],i[m>>2]=77200,t[f+51|0]<0&&Z(i[f+40>>2]),y0(m),Y0(f+60|0),v=f+176|0;return}I0(),M()}function J9(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0;o=v-208|0,v=o;i:{e:{r:{f:{A:switch(i[e+200>>2]-1|0){case 1:if((r|0)!=1)break r;if(t[e+188|0]&1)break f;break r;case 0:break A;default:break r}if(t[e+188|0]&1)break f;if(!(t[e+192|0]&1))break r}if(i[o+32>>2]=0,i[o+36>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,t[o+36|0]=1,i[o+28>>2]=2,i[o+32>>2]=2,t[o+24|0]=1,i[o+8>>2]=i[e+164>>2],k=i[e+168>>2],!k||(k=Oi(k),i[o+12>>2]=k,!k))break i;i[o+200>>2]=131074,i[o+204>>2]=65538,B=o+48|0,G=o+8|0,s=o+200|0,k=i[e+204>>2],e=i[e+208>>2],n=0;f:{if((k|0)==(e|0))break f;A:{for(;;){if(!i[k>>2])break A;if(k=k+56|0,(e|0)==(k|0))break}n=0;break f}n=p[k+20>>1]}G6(B,G,0,3,s,n,o+24|0,0,f),e=i[o+12>>2];f:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break f;W[i[i[e>>2]+8>>2]](e),y(e)}f:{A:switch(u[o+68|0]){default:e2(),M();case 1:e=i[o+52>>2],i[A>>2]=i[o+48>>2],i[A+4>>2]=e,e=A+8|0;k:{if(t[o+67|0]>=0){r=i[o+60>>2],i[e>>2]=i[o+56>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+64>>2];break k}T(e,i[o+56>>2],i[o+60>>2])}t[A+20|0]=1;break f;case 0:break A}J9(A,i[o+48>>2],r,f)}if(A=u[o+68|0],(A|0)==255)break e;e=i[25407],i[o+8>>2]=i[25406],i[o+12>>2]=e,W[i[(o+8|0)+(A<<2)>>2]](o+200|0,o+48|0);break e}if(f=i[e+204>>2],j=i[e+208>>2],(f|0)!=(j|0))for(x=(r|0)==1;;){r:{if(r=p[f+20>>1],r>>>0<=8){if(I=i[f+40>>2],B=i[f+28>>2],m=i[f+24>>2],!x){if(!m|B>>>0<2)break r;for(h=B>>>1|0,Y=m&-2,l=m&1,r=0;;){if(n=B+(r^-1)|0,k=0,_=0,(m|0)!=1)for(;w=i[f+52>>2],Q=(I+g(w,r)|0)+k|0,E=u[Q|0],w=(I+g(n,w)|0)+k|0,t[Q|0]=u[w|0],t[w|0]=E,Q=k|1,w=i[f+52>>2],E=Q+(I+g(w,r)|0)|0,s=u[E|0],w=Q+(I+g(n,w)|0)|0,t[E|0]=u[w|0],t[w|0]=s,k=k+2|0,_=_+2|0,(Y|0)!=(_|0););if(l&&(_=i[f+52>>2],w=(I+g(_,r)|0)+k|0,Q=u[w|0],k=(I+g(n,_)|0)+k|0,t[w|0]=u[k|0],t[k|0]=Q),r=r+1|0,(h|0)==(r|0))break}break r}if(!B|m>>>0<2)break r;for(_=m&2,h=m>>>1|0,Y=h&2147483646,r=0;;){if(k=0,n=0,(h|0)!=1)for(;l=I+g(i[f+52>>2],r)|0,w=l+k|0,Q=u[w|0],l=(l+m|0)+(k^-1)|0,t[w|0]=u[l|0],t[l|0]=Q,l=I+g(i[f+52>>2],r)|0,w=l+k|0,Q=u[w+1|0],l=(l+m|0)+(k^-2)|0,t[w+1|0]=u[l|0],t[l|0]=Q,k=k+2|0,n=n+2|0,(Y|0)!=(n|0););if(_&&(n=I+g(i[f+52>>2],r)|0,l=n+k|0,w=u[l|0],k=(n+m|0)+(k^-1)|0,t[l|0]=u[k|0],t[k|0]=w),r=r+1|0,(B|0)==(r|0))break}break r}if(r>>>0<=16){if(h=i[f+40>>2],I=i[f+28>>2],n=i[f+24>>2],!x){if(!n|I>>>0<2)break r;for(w=I>>>1|0,Y=i[f+52>>2],Q=n&-4,l=n&3,m=0,E=n>>>0<4;;){if(r=h+(g(m,Y)&-2)|0,B=h+(g(Y,I+(m^-1)|0)&-2)|0,k=0,n=0,!E)for(;_=k<<1,s=_+r|0,G=p[s>>1],R=s,s=_+B|0,X[R>>1]=p[s>>1],X[s>>1]=G,s=_|2,G=s+r|0,V=p[G>>1],s=s+B|0,X[G>>1]=p[s>>1],X[s>>1]=V,s=_|4,G=s+r|0,V=p[G>>1],s=s+B|0,X[G>>1]=p[s>>1],X[s>>1]=V,_=_|6,s=_+r|0,G=p[s>>1],_=_+B|0,X[s>>1]=p[_>>1],X[_>>1]=G,k=k+4|0,n=n+4|0,(Q|0)!=(n|0););if(n=0,l)for(;_=k<<1,s=_+r|0,G=p[s>>1],_=_+B|0,X[s>>1]=p[_>>1],X[_>>1]=G,k=k+1|0,n=n+1|0,(l|0)!=(n|0););if(m=m+1|0,(w|0)==(m|0))break}break r}if(!I|n>>>0<2)break r;for(Y=i[f+52>>2],l=n&2,w=n>>>1|0,Q=w&2147483646,m=0;;){if(B=h+(g(m,Y)&-2)|0,_=B+(n<<1)|0,k=0,(w|0)!=1)for(E=B+2|0,r=0;s=k<<1,G=s+B|0,V=p[G>>1],R=G,G=_+((k^-1)<<1)|0,X[R>>1]=p[G>>1],X[G>>1]=V,s=s+E|0,G=p[s>>1],R=s,s=_+((k^2147483646)<<1)|0,X[R>>1]=p[s>>1],X[s>>1]=G,k=k+2|0,r=r+2|0,(Q|0)!=(r|0););if(l&&(r=B+(k<<1)|0,B=p[r>>1],s=r,r=_+((k^-1)<<1)|0,X[s>>1]=p[r>>1],X[r>>1]=B),m=m+1|0,(I|0)==(m|0))break}break r}if(r>>>0<=32){if(Y=i[f+40>>2],B=i[f+28>>2],I=i[f+24>>2],!x){if(!I|B>>>0<2)break r;for(Q=B>>>1|0,l=i[f+52>>2],E=I&-4,w=I&3,m=0;;){if(r=Y+(g(l,m)&-4)|0,_=Y+(g(l,B+(m^-1)|0)&-4)|0,k=0,n=0,I>>>0>=4)for(;h=k<<2,s=h+r|0,G=i[s>>2],R=s,s=h+_|0,i[R>>2]=i[s>>2],i[s>>2]=G,s=h|4,G=s+r|0,V=i[G>>2],s=_+s|0,i[G>>2]=i[s>>2],i[s>>2]=V,s=h|8,G=s+r|0,V=i[G>>2],s=_+s|0,i[G>>2]=i[s>>2],i[s>>2]=V,h=h|12,s=h+r|0,G=i[s>>2],h=h+_|0,i[s>>2]=i[h>>2],i[h>>2]=G,k=k+4|0,n=n+4|0,(E|0)!=(n|0););if(n=0,w)for(;h=k<<2,s=h+r|0,G=i[s>>2],h=h+_|0,i[s>>2]=i[h>>2],i[h>>2]=G,k=k+1|0,n=n+1|0,(w|0)!=(n|0););if(m=m+1|0,(Q|0)==(m|0))break}break r}if(!B|I>>>0<2)break r;for(h=i[f+52>>2],l=I&2,w=I>>>1|0,Q=w&2147483646,m=0;;){if(n=Y+(g(h,m)&-4)|0,_=n+(I<<2)|0,k=0,(w|0)!=1)for(E=n+4|0,r=0;s=k<<2,G=s+n|0,V=i[G>>2],R=G,G=_+((k^-1)<<2)|0,i[R>>2]=i[G>>2],i[G>>2]=V,s=s+E|0,G=i[s>>2],R=s,s=_+((k^1073741822)<<2)|0,i[R>>2]=i[s>>2],i[s>>2]=G,k=k+2|0,r=r+2|0,(Q|0)!=(r|0););if(l&&(r=n+(k<<2)|0,n=i[r>>2],s=r,r=_+((k^-1)<<2)|0,i[s>>2]=i[r>>2],i[r>>2]=n),m=m+1|0,(B|0)==(m|0))break}break r}if(r>>>0<=64){if(Y=i[f+40>>2],B=i[f+28>>2],m=i[f+24>>2],!x){if(!m|B>>>0<2)break r;for(s=B>>>1|0,Q=i[f+52>>2],G=m&-4,E=m&3,I=0;;){if(r=Y+(g(I,Q)&-8)|0,_=Y+(g(Q,B+(I^-1)|0)&-8)|0,k=0,n=0,m>>>0>=4)for(;h=k<<3,l=h+r|0,V=i[l>>2],N=i[l+4>>2],w=h+_|0,U=i[w+4>>2],i[l>>2]=i[w>>2],i[l+4>>2]=U,i[w>>2]=V,i[w+4>>2]=N,l=h|8,w=l+r|0,V=i[w>>2],N=i[w+4>>2],l=l+_|0,U=i[l+4>>2],i[w>>2]=i[l>>2],i[w+4>>2]=U,i[l>>2]=V,i[l+4>>2]=N,l=h|16,w=l+r|0,V=i[w>>2],N=i[w+4>>2],l=l+_|0,U=i[l+4>>2],i[w>>2]=i[l>>2],i[w+4>>2]=U,i[l>>2]=V,i[l+4>>2]=N,l=h|24,h=l+r|0,w=i[h>>2],V=i[h+4>>2],l=l+_|0,N=i[l+4>>2],i[h>>2]=i[l>>2],i[h+4>>2]=N,i[l>>2]=w,i[l+4>>2]=V,k=k+4|0,n=n+4|0,(G|0)!=(n|0););if(n=0,E)for(;l=k<<3,h=l+r|0,w=i[h>>2],V=i[h+4>>2],l=l+_|0,N=i[l+4>>2],i[h>>2]=i[l>>2],i[h+4>>2]=N,i[l>>2]=w,i[l+4>>2]=V,k=k+1|0,n=n+1|0,(E|0)!=(n|0););if(I=I+1|0,(s|0)==(I|0))break}break r}if(!B|m>>>0<2)break r;for(w=i[f+52>>2],Q=m&2,E=m>>>1|0,s=E&2147483646,I=0;;){if(n=Y+(g(w,I)&-8)|0,_=n+(m<<3)|0,k=0,(E|0)!=1)for(G=n+8|0,r=0;V=k<<3,h=V+n|0,N=i[h>>2],U=i[h+4>>2],l=_+((k^-1)<<3)|0,R=i[l+4>>2],i[h>>2]=i[l>>2],i[h+4>>2]=R,i[l>>2]=N,i[l+4>>2]=U,h=G+V|0,V=i[h>>2],N=i[h+4>>2],l=_+((k^536870910)<<3)|0,U=i[l+4>>2],i[h>>2]=i[l>>2],i[h+4>>2]=U,i[l>>2]=V,i[l+4>>2]=N,k=k+2|0,r=r+2|0,(s|0)!=(r|0););if(Q&&(r=n+(k<<3)|0,n=i[r>>2],h=i[r+4>>2],k=_+((k^-1)<<3)|0,_=i[k+4>>2],i[r>>2]=i[k>>2],i[r+4>>2]=_,i[k>>2]=n,i[k+4>>2]=h),I=I+1|0,(B|0)==(I|0))break}break r}if(r>>>0<=128){if(_=i[f+40>>2],m=i[f+28>>2],I=i[f+24>>2],!x){if(!I|m>>>0<2)break r;for(h=m>>>1|0,r=0;;){for(Y=m+(r^-1)|0,k=0;w=k<<4,l=i[f+52>>2],B=w+(_+(g(l,r)&-16)|0)|0,n=B,Q=i[n+12>>2],i[o+56>>2]=i[n+8>>2],i[o+60>>2]=Q,Q=i[n+4>>2],i[o+48>>2]=i[n>>2],i[o+52>>2]=Q,n=w+(_+(g(l,Y)&-16)|0)|0,l=i[n+12>>2],i[B+8>>2]=i[n+8>>2],i[B+12>>2]=l,l=i[n+4>>2],i[B>>2]=i[n>>2],i[B+4>>2]=l,B=i[o+60>>2],i[n+8>>2]=i[o+56>>2],i[n+12>>2]=B,B=i[o+52>>2],i[n>>2]=i[o+48>>2],i[n+4>>2]=B,k=k+1|0,(I|0)!=(k|0););if(r=r+1|0,(h|0)==(r|0))break}break r}if(!m|I>>>0<2)break r;for(h=I>>>1|0,r=0;;){for(k=0;Y=_+(g(i[f+52>>2],r)&-16)|0,B=Y+(k<<4)|0,n=B,l=i[n+12>>2],i[o+56>>2]=i[n+8>>2],i[o+60>>2]=l,l=i[n+4>>2],i[o+48>>2]=i[n>>2],i[o+52>>2]=l,n=(Y+(I<<4)|0)+((k^-1)<<4)|0,Y=i[n+12>>2],i[B+8>>2]=i[n+8>>2],i[B+12>>2]=Y,Y=i[n+4>>2],i[B>>2]=i[n>>2],i[B+4>>2]=Y,B=i[o+60>>2],i[n+8>>2]=i[o+56>>2],i[n+12>>2]=B,B=i[o+52>>2],i[n>>2]=i[o+48>>2],i[n+4>>2]=B,k=k+1|0,(h|0)!=(k|0););if(r=r+1|0,(m|0)==(r|0))break}break r}i[o+140>>2]=0,i[o+112>>2]=78164,i[o+56>>2]=78144,e=i[19545],i[o+48>>2]=e,r=i[e-12>>2],e=o+48|0,i[r+e>>2]=i[19546],i[o+52>>2]=0,r=e+i[i[o+48>>2]-12>>2]|0,k=o+60|0,J0(r,k),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[o+56>>2]=r,s=i[r-12>>2],r=o+56|0,i[s+r>>2]=i[19548],n=i[19544],i[o+48>>2]=n,i[e+i[n-12>>2]>>2]=i[19549],i[o+112>>2]=78164,i[o+48>>2]=78124,i[o+56>>2]=78144,n=R0(k),i[n>>2]=77200,i[o+100>>2]=0,i[o+104>>2]=0,i[o+92>>2]=0,i[o+96>>2]=0,i[o+108>>2]=24,F(B0(F(r,31825,26),p[f+20>>1]),10792,15),e=i[o+108>>2];f:{A:{if(e&16){k=i[o+104>>2],e=i[o+84>>2],k>>>0<e>>>0&&(i[o+104>>2]=e,k=e),e=o+80|0;break A}if(!(e&8)){k=0,t[o+19|0]=0,f=o+8|0;break f}k=i[o+76>>2],e=o+68|0}A:{if(e=i[e>>2],k=k-e|0,k>>>0<2147483640){if(k>>>0>=11){r=k|7,f=C(r+1|0),i[o+16>>2]=r-2147483647,i[o+8>>2]=f,i[o+12>>2]=k;break A}if(t[o+19|0]=k,f=o+8|0,k)break A;k=0;break f}I0(),M()}if(!k)break f;z(f,e,k)}t[f+k|0]=0,e=a(o+24|0,4,0,o+8|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}t[o+19|0]<0&&Z(i[o+8>>2]),A=i[19543],i[o+48>>2]=A,i[i[A-12>>2]+(o+48|0)>>2]=i[19551],i[o+56>>2]=i[19552],i[n>>2]=77200,t[o+103|0]<0&&Z(i[o+92>>2]),y0(n),Y0(o+112|0);break e}if(f=f+56|0,(j|0)==(f|0))break}if(r=i[e+168>>2],!r||(e=i[e+164>>2],r=Oi(r),!r))break i;t[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}v=o+208|0;return}sf(),M()}function Tr(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;h=v-112|0,v=h,HA(h+100|0,e,r),e=i[h+100>>2],r=K6(h- -64|0,e,i[h+104>>2]-e|0),m2(r,16),m2(r,4),m2(r,4),X[f+2>>1]=0,m=f,G=O2(r,3)+1|0,t[m+4|0]=G,m=f,G=O2(r,2),t[m+6|0]=G,m2(r,2);i:{e:{if(!T0(r,1))break e;if(m=f,G=O2(r,7),t[m+9|0]=G,m=f,G=O2(r,1),t[m+10|0]=G,m=f,G=O2(r,8),t[m+11|0]=G,m=f,G=O2(r,1),t[m+12|0]=G,m=f,G=O2(r,1),t[m+13|0]=G,T0(r,1)){if(e=C(64),i[h+40>>2]=e,i[h+44>>2]=58,i[h+48>>2]=-2147483584,r=u[4405]|u[4406]<<8|(u[4407]<<16|u[4408]<<24),f=u[4401]|u[4402]<<8|(u[4403]<<16|u[4404]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+58|0]=0,r=u[4457]|u[4458]<<8,t[e+56|0]=r,t[e+57|0]=r>>>8,r=u[4453]|u[4454]<<8|(u[4455]<<16|u[4456]<<24),f=u[4449]|u[4450]<<8|(u[4451]<<16|u[4452]<<24),t[e+48|0]=f,t[e+49|0]=f>>>8,t[e+50|0]=f>>>16,t[e+51|0]=f>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[4445]|u[4446]<<8|(u[4447]<<16|u[4448]<<24),f=u[4441]|u[4442]<<8|(u[4443]<<16|u[4444]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[4437]|u[4438]<<8|(u[4439]<<16|u[4440]<<24),f=u[4433]|u[4434]<<8|(u[4435]<<16|u[4436]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[4429]|u[4430]<<8|(u[4431]<<16|u[4432]<<24),f=u[4425]|u[4426]<<8|(u[4427]<<16|u[4428]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[4421]|u[4422]<<8|(u[4423]<<16|u[4424]<<24),f=u[4417]|u[4418]<<8|(u[4419]<<16|u[4420]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[4413]|u[4414]<<8|(u[4415]<<16|u[4416]<<24),f=u[4409]|u[4410]<<8|(u[4411]<<16|u[4412]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,4,3002,h+40|0),t[h+51|0]>=0)break i;Z(i[h+40>>2]);break i}t[f+8|0]=1;r:{f:{e=i[f+20>>2],_=i[f+24>>2];A:{if(e>>>0<_>>>0){t[e|0]=0,s=e+1|0;break A}if(l=i[f+16>>2],s=e-l|0,w=s+1|0,(w|0)<0)break f;if(e=0,_=_-l|0,B=_<<1,w=_>>>0>=1073741823?2147483647:w>>>0<B>>>0?B:w,w&&(e=C(w)),_=e+s|0,t[_|0]=0,s&&z(e,l,s),i[f+24>>2]=e+w,s=_+1|0,i[f+20>>2]=s,i[f+16>>2]=e,!l)break A;Z(l)}if(i[f+20>>2]=s,e=i[r+24>>2],i[r+24>>2]=e&-8,w=i[r+20>>2],s=i[r+16>>2],l=e&7,e=l,(e&63)>>>0>=32?(l=s<<e,e=0):(l=(1<<e)-1&s>>>32-e|w<<e,e=s<<e),i[r+16>>2]=e,i[r+20>>2]=l,ft(f+28|0,u[f+4|0]),e=u[f+4|0],e>>>0<2)break r;for(e=e-2|0;l=1<<e,w=T0(r,1),s=i[f+28>>2]+(e>>>3&536870908)|0,w?l=l|i[s>>2]:l=i[s>>2]&(l^-1),i[s>>2]=l,l=(e|0)>0,e=e-1|0,!!l;);break r}s0(),M()}e=i[r+24>>2],i[r+24>>2]=e&-8,w=i[r+20>>2],s=i[r+16>>2],l=e&7,e=l,(e&63)>>>0>=32?(l=s<<e,e=0):(l=(1<<e)-1&s>>>32-e|w<<e,e=s<<e),i[r+16>>2]=e,i[r+20>>2]=l,e=u[f+4|0],_=i[f+44>>2],l=i[f+40>>2],s=_-l|0;r:{if(e>>>0>s>>>0){if(w=e-s|0,B=i[f+48>>2],w>>>0<=B-_>>>0){w&&l0(_,0,w),i[f+44>>2]=w+_;break r}if(_=B-l|0,B=_<<1,B=_>>>0>=1073741823?2147483647:e>>>0<B>>>0?B:e,_=C(B),w&&l0(s+_|0,0,w),s&&z(_,l,s),i[f+48>>2]=_+B,i[f+44>>2]=e+_,i[f+40>>2]=_,!l)break r;Z(l);break r}if(e>>>0>=s>>>0)break r;i[f+44>>2]=e+l}if(e=u[f+4|0],e>>>0>=2)for(e=e-2|0;i[i[f+28>>2]+(e>>>3&536870908)>>2]>>>e&1&&(l=O2(r,8),t[i[f+40>>2]+e|0]=l),l=(e|0)>0,e=e-1|0,!!l;);s=f+52|0,l=T0(r,8),w=i[f+52>>2],e=i[f+56>>2]-w>>2;r:{if(l>>>0>e>>>0){T8(s,l-e|0);break r}if(e>>>0<=l>>>0)break r;i[f+56>>2]=w+(l<<2)}if(e=0,(l|0)<=0)break e;for(;w=T0(r,32),i[i[s>>2]+(e<<2)>>2]=w,e=e+1|0,(l|0)!=(e|0););}m2(r,1),T0(r,1)&&m2(r,1),e=C(48),i[h+28>>2]=e,i[h+32>>2]=46,i[h+36>>2]=-2147483600,l=u[7973]|u[7974]<<8|(u[7975]<<16|u[7976]<<24),s=u[7969]|u[7970]<<8|(u[7971]<<16|u[7972]<<24),t[e+38|0]=s,t[e+39|0]=s>>>8,t[e+40|0]=s>>>16,t[e+41|0]=s>>>24,t[e+42|0]=l,t[e+43|0]=l>>>8,t[e+44|0]=l>>>16,t[e+45|0]=l>>>24,l=u[7967]|u[7968]<<8|(u[7969]<<16|u[7970]<<24),s=u[7963]|u[7964]<<8|(u[7965]<<16|u[7966]<<24),t[e+32|0]=s,t[e+33|0]=s>>>8,t[e+34|0]=s>>>16,t[e+35|0]=s>>>24,t[e+36|0]=l,t[e+37|0]=l>>>8,t[e+38|0]=l>>>16,t[e+39|0]=l>>>24,l=u[7959]|u[7960]<<8|(u[7961]<<16|u[7962]<<24),s=u[7955]|u[7956]<<8|(u[7957]<<16|u[7958]<<24),t[e+24|0]=s,t[e+25|0]=s>>>8,t[e+26|0]=s>>>16,t[e+27|0]=s>>>24,t[e+28|0]=l,t[e+29|0]=l>>>8,t[e+30|0]=l>>>16,t[e+31|0]=l>>>24,l=u[7951]|u[7952]<<8|(u[7953]<<16|u[7954]<<24),s=u[7947]|u[7948]<<8|(u[7949]<<16|u[7950]<<24),t[e+16|0]=s,t[e+17|0]=s>>>8,t[e+18|0]=s>>>16,t[e+19|0]=s>>>24,t[e+20|0]=l,t[e+21|0]=l>>>8,t[e+22|0]=l>>>16,t[e+23|0]=l>>>24,l=u[7943]|u[7944]<<8|(u[7945]<<16|u[7946]<<24),s=u[7939]|u[7940]<<8|(u[7941]<<16|u[7942]<<24),t[e+8|0]=s,t[e+9|0]=s>>>8,t[e+10|0]=s>>>16,t[e+11|0]=s>>>24,t[e+12|0]=l,t[e+13|0]=l>>>8,t[e+14|0]=l>>>16,t[e+15|0]=l>>>24,l=u[7935]|u[7936]<<8|(u[7937]<<16|u[7938]<<24),s=u[7931]|u[7932]<<8|(u[7933]<<16|u[7934]<<24),t[e|0]=s,t[e+1|0]=s>>>8,t[e+2|0]=s>>>16,t[e+3|0]=s>>>24,t[e+4|0]=l,t[e+5|0]=l>>>8,t[e+6|0]=l>>>16,t[e+7|0]=l>>>24,t[e+46|0]=0,l=a(h+40|0,2,2006,h+28|0),t[h+39|0]<0&&Z(i[h+28>>2]);e:{r:{if(A1(r,h+24|0)&&A1(r,h+20|0))break r;e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break e}if(e=i[h+24>>2],i[k>>2]=e,s=i[h+20>>2],i[n>>2]=s,o&&(i[o>>2]=i[k>>2],i[o+4>>2]=i[n>>2]),!(s>>>0<65536&e>>>0<=65535)){if(e=C(56),i[h+28>>2]=e,i[h+32>>2]=55,i[h+36>>2]=-2147483592,r=u[29972]|u[29973]<<8|(u[29974]<<16|u[29975]<<24),f=u[29968]|u[29969]<<8|(u[29970]<<16|u[29971]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+55|0]=0,r=u[30019]|u[30020]<<8|(u[30021]<<16|u[30022]<<24),f=u[30015]|u[30016]<<8|(u[30017]<<16|u[30018]<<24),t[e+47|0]=f,t[e+48|0]=f>>>8,t[e+49|0]=f>>>16,t[e+50|0]=f>>>24,t[e+51|0]=r,t[e+52|0]=r>>>8,t[e+53|0]=r>>>16,t[e+54|0]=r>>>24,r=u[30012]|u[30013]<<8|(u[30014]<<16|u[30015]<<24),f=u[30008]|u[30009]<<8|(u[30010]<<16|u[30011]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[30004]|u[30005]<<8|(u[30006]<<16|u[30007]<<24),f=u[3e4]|u[30001]<<8|(u[30002]<<16|u[30003]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[29996]|u[29997]<<8|(u[29998]<<16|u[29999]<<24),f=u[29992]|u[29993]<<8|(u[29994]<<16|u[29995]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[29988]|u[29989]<<8|(u[29990]<<16|u[29991]<<24),f=u[29984]|u[29985]<<8|(u[29986]<<16|u[29987]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[29980]|u[29981]<<8|(u[29982]<<16|u[29983]<<24),f=u[29976]|u[29977]<<8|(u[29978]<<16|u[29979]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,2006,h+28|0),t[h+39|0]>=0)break e;Z(i[h+28>>2]);break e}if(X[f+66>>1]=s,X[f+64>>1]=e,T0(r,1)){r:{f:{if(!A1(r,h+16|0)||!A1(r,h+12|0)||!A1(r,h+8|0))break f;if(A1(r,h+4|0))break r}e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break e}o=1,e=1;r:{f:switch(u[f+6|0]-1|0){case 0:e=2,o=2;break r;case 1:break f;default:break r}e=2}w=0,_=i[h+16>>2],s=_+i[h+12>>2]|0,e=L0(s,s>>>0<_>>>0?1:w,e,0);r:{if(s=i[k>>2],!h0&s>>>0>=e>>>0&&(_=0,B=i[h+8>>2],w=B+i[h+4>>2]|0,o=L0(w,w>>>0<B>>>0?1:_,o,0),!h0&o0[n>>2]>=o>>>0))break r;if(e=A,A=V2(h+28|0,5368),a(e,2,2006,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}i[k>>2]=s-e,i[n>>2]=i[n>>2]-o}if(T0(r,1)){if(e=A,A=V2(h+28|0,4460),a(e,4,3002,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(!A1(r,h+16|0)){e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break e}if(e=i[h+16>>2],e>>>0>=248){if(e=A,A=V2(h+28|0,27991),a(e,9,0,A),t[A+11|0]>=0)break e;Z(i[A>>2]);break e}t[f+5|0]=1,t[f+7|0]=e,Z8(A,114912)}if(t[l+19|0]>=0)break i;Z(i[l+8>>2])}A=i[h+100>>2],A&&(i[h+104>>2]=A,Z(A)),v=h+112|0}function N9(){var A=0,e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;for(t[121360]=0,t[121361]=0,t[121362]=0,t[121363]=1,t[121364]=1,t[121365]=0,t[121366]=1,t[121367]=1,t[118624]=0,t[118625]=0,t[118626]=1,t[118627]=0,t[118628]=0,t[118629]=1,t[118630]=1,t[118631]=1;;){if((A|0)<0)A=0;else{i:{e:{if(A>>>0<=1){if(k=e<<1,t[k+115895|0]=A,t[k+115894|0]=0,r=e+1|0,!A){e=r;break i}t[(r<<1)+115894|0]=1,f=A-1|0,k=2;break e}if((A|0)!=2)break i;f=1,t[(e<<1)+115894|0]=1,r=e,k=1}t[(r<<1)+115895|0]=f,e=e+k|0}A=A+1|0}if(!((e|0)<4))break}for(i[29666]=50397952,i[29667]=50529026,i[29664]=33620480,i[29665]=33751554,i[29662]=16843008,i[29663]=16974082,i[29660]=65536,i[29661]=196610,i[30344]=16777216,i[30345]=50332160,i[30346]=16842753,i[30347]=50397697,i[30348]=16908290,i[30349]=50463234,i[30350]=16973827,i[30351]=50528771,e=0,A=0;;){if((A|0)<0)A=0;else{i:{e:{r:{f:{A:{k:{n:{if(A>>>0<=3){if(k=e<<1,t[k+115905|0]=A,t[k+115904|0]=0,k=e+1|0,A)break n;e=k;break i}if((A|0)!=4)break k;X[(e<<1)+115904>>1]=769,r=e+1|0,f=2;break A}if(k=k<<1,t[k+115905|0]=A-1,t[k+115904|0]=1,k=e+2|0,(A|0)==1){e=k;break i}if(k=k<<1,t[k+115905|0]=A-2,t[k+115904|0]=2,k=e+3|0,(A|0)!=2)break f;e=k;break i}if(f=1,r=e,A>>>0>=6)break r}k=r<<1,t[k+115905|0]=A-2,t[k+115904|0]=2,e=e+f|0;break e}k=k<<1,t[k+115905|0]=A-3,t[k+115904|0]=3,e=e+4|0;break i}if((A|0)!=6)break i}k=e<<1,t[k+115905|0]=A-3,t[k+115904|0]=3,e=e+1|0}A=A+1|0}if(!((e|0)<16))break}for(i[29698]=117769988,i[29699]=117901062,i[29696]=117507840,i[29697]=117638914,i[29694]=100992516,i[29695]=101123590,i[29692]=100730368,i[29693]=100861442,i[29690]=84215044,i[29691]=84346118,i[29688]=83952896,i[29689]=84083970,i[29686]=67437572,i[29687]=67568646,i[29684]=67175424,i[29685]=67306498,i[29682]=50660100,i[29683]=50791174,i[29680]=50397952,i[29681]=50529026,i[29678]=33882628,i[29679]=34013702,i[29676]=33620480,i[29677]=33751554,i[29674]=17105156,i[29675]=17236230,i[29672]=16843008,i[29673]=16974082,i[29670]=327684,i[29671]=458758,i[29668]=65536,i[29669]=196610,i[30352]=16777216,i[30353]=50332160,i[30354]=83887104,i[30355]=117442048,i[30356]=16842753,i[30357]=50397697,i[30358]=83952641,i[30359]=117507585,i[30360]=16908290,i[30361]=50463234,i[30362]=84018178,i[30363]=117573122,i[30364]=16973827,i[30365]=50528771,i[30366]=84083715,i[30367]=117638659,i[30368]=17039364,i[30369]=50594308,i[30370]=84149252,i[30371]=117704196,i[30372]=17104901,i[30373]=50659845,i[30374]=84214789,i[30375]=117769733,i[30376]=17170438,i[30377]=50725382,i[30378]=84280326,i[30379]=117835270,i[30380]=17235975,i[30381]=50790919,i[30382]=84345863,i[30383]=117900807,r=0,k=0;;){if((k|0)<0)k=0;else{i:{if(!k){e=0,A=k;break i}for(n=k+1&-2,e=0,A=k,f=0;(A|0)>7|e>>>0>7||(o=r<<1,t[o+115937|0]=A,t[o+115936|0]=e,r=r+1|0),(A|0)>8|e>>>0>7||(o=r<<1,t[o+115937|0]=A-1,t[o+115936|0]=e|1,r=r+1|0),e=e+2|0,A=A-2|0,f=f+2|0,(n|0)!=(f|0););}k&1|(A|0)>7|e>>>0>7||(n=r<<1,t[n+115937|0]=A,t[n+115936|0]=e,r=r+1|0),k=k+1|0}if(!((r|0)<64))break}for(r=0,f=0;A=f<<1,t[A+118831|0]=r,t[A+118830|0]=15,t[A+118829|0]=r,t[A+118828|0]=14,t[A+118827|0]=r,t[A+118826|0]=13,t[A+118825|0]=r,t[A+118824|0]=12,t[A+118823|0]=r,t[A+118822|0]=11,t[A+118821|0]=r,t[A+118820|0]=10,t[A+118819|0]=r,t[A+118818|0]=9,t[A+118817|0]=r,t[A+118816|0]=8,t[A+118815|0]=r,t[A+118814|0]=7,t[A+118813|0]=r,t[A+118812|0]=6,t[A+118811|0]=r,t[A+118810|0]=5,t[A+118809|0]=r,t[A+118808|0]=4,t[A+118807|0]=r,t[A+118806|0]=3,t[A+118805|0]=r,t[A+118804|0]=2,t[A+118803|0]=r,t[A+118802|0]=1,t[A+118801|0]=r,e=0,t[A+118800|0]=0,f=f+16|0,r=r+1|0,(r|0)!=16;);for(f=0;A=f<<1,t[A+121567|0]=15,t[A+121566|0]=e,t[A+121565|0]=14,t[A+121564|0]=e,t[A+121563|0]=13,t[A+121562|0]=e,t[A+121561|0]=12,t[A+121560|0]=e,t[A+121559|0]=11,t[A+121558|0]=e,t[A+121557|0]=10,t[A+121556|0]=e,t[A+121555|0]=9,t[A+121554|0]=e,t[A+121553|0]=8,t[A+121552|0]=e,t[A+121551|0]=7,t[A+121550|0]=e,t[A+121549|0]=6,t[A+121548|0]=e,t[A+121547|0]=5,t[A+121546|0]=e,t[A+121545|0]=4,t[A+121544|0]=e,t[A+121543|0]=3,t[A+121542|0]=e,t[A+121541|0]=2,t[A+121540|0]=e,t[A+121539|0]=1,t[A+121538|0]=e,r=0,t[A+121537|0]=0,t[A+121536|0]=e,f=f+16|0,e=e+1|0,(e|0)!=16;);for(n=0;;){if(f=0,(n|0)<0)n=0;else{i:{if(!n){e=0,A=n;break i}for(o=n+1&-2,e=0,A=n,k=0;(A|0)>15|e>>>0>15||(l=r<<1,t[l+116065|0]=A,t[l+116064|0]=e,r=r+1|0),(A|0)>16|e>>>0>15||(l=r<<1,t[l+116065|0]=A-1,t[l+116064|0]=e|1,r=r+1|0),e=e+2|0,A=A-2|0,k=k+2|0,(o|0)!=(k|0););}n&1|(A|0)>15|e>>>0>15||(k=r<<1,t[k+116065|0]=A,t[k+116064|0]=e,r=r+1|0),n=n+1|0}if(!((r|0)<256))break}for(r=0;A=r<<1,t[A+119375|0]=f,t[A+119374|0]=31,t[A+119373|0]=f,t[A+119372|0]=30,t[A+119371|0]=f,t[A+119370|0]=29,t[A+119369|0]=f,t[A+119368|0]=28,t[A+119367|0]=f,t[A+119366|0]=27,t[A+119365|0]=f,t[A+119364|0]=26,t[A+119363|0]=f,t[A+119362|0]=25,t[A+119361|0]=f,t[A+119360|0]=24,t[A+119359|0]=f,t[A+119358|0]=23,t[A+119357|0]=f,t[A+119356|0]=22,t[A+119355|0]=f,t[A+119354|0]=21,t[A+119353|0]=f,t[A+119352|0]=20,t[A+119351|0]=f,t[A+119350|0]=19,t[A+119349|0]=f,t[A+119348|0]=18,t[A+119347|0]=f,t[A+119346|0]=17,t[A+119345|0]=f,t[A+119344|0]=16,t[A+119343|0]=f,t[A+119342|0]=15,t[A+119341|0]=f,t[A+119340|0]=14,t[A+119339|0]=f,t[A+119338|0]=13,t[A+119337|0]=f,t[A+119336|0]=12,t[A+119335|0]=f,t[A+119334|0]=11,t[A+119333|0]=f,t[A+119332|0]=10,t[A+119331|0]=f,t[A+119330|0]=9,t[A+119329|0]=f,t[A+119328|0]=8,t[A+119327|0]=f,t[A+119326|0]=7,t[A+119325|0]=f,t[A+119324|0]=6,t[A+119323|0]=f,t[A+119322|0]=5,t[A+119321|0]=f,t[A+119320|0]=4,t[A+119319|0]=f,t[A+119318|0]=3,t[A+119317|0]=f,t[A+119316|0]=2,t[A+119315|0]=f,t[A+119314|0]=1,t[A+119313|0]=f,e=0,t[A+119312|0]=0,r=r+32|0,f=f+1|0,(f|0)!=32;);for(f=0;A=f<<1,t[A+122111|0]=31,t[A+122110|0]=e,t[A+122109|0]=30,t[A+122108|0]=e,t[A+122107|0]=29,t[A+122106|0]=e,t[A+122105|0]=28,t[A+122104|0]=e,t[A+122103|0]=27,t[A+122102|0]=e,t[A+122101|0]=26,t[A+122100|0]=e,t[A+122099|0]=25,t[A+122098|0]=e,t[A+122097|0]=24,t[A+122096|0]=e,t[A+122095|0]=23,t[A+122094|0]=e,t[A+122093|0]=22,t[A+122092|0]=e,t[A+122091|0]=21,t[A+122090|0]=e,t[A+122089|0]=20,t[A+122088|0]=e,t[A+122087|0]=19,t[A+122086|0]=e,t[A+122085|0]=18,t[A+122084|0]=e,t[A+122083|0]=17,t[A+122082|0]=e,t[A+122081|0]=16,t[A+122080|0]=e,t[A+122079|0]=15,t[A+122078|0]=e,t[A+122077|0]=14,t[A+122076|0]=e,t[A+122075|0]=13,t[A+122074|0]=e,t[A+122073|0]=12,t[A+122072|0]=e,t[A+122071|0]=11,t[A+122070|0]=e,t[A+122069|0]=10,t[A+122068|0]=e,t[A+122067|0]=9,t[A+122066|0]=e,t[A+122065|0]=8,t[A+122064|0]=e,t[A+122063|0]=7,t[A+122062|0]=e,t[A+122061|0]=6,t[A+122060|0]=e,t[A+122059|0]=5,t[A+122058|0]=e,t[A+122057|0]=4,t[A+122056|0]=e,t[A+122055|0]=3,t[A+122054|0]=e,t[A+122053|0]=2,t[A+122052|0]=e,t[A+122051|0]=1,t[A+122050|0]=e,r=0,t[A+122049|0]=0,t[A+122048|0]=e,f=f+32|0,e=e+1|0,(e|0)!=32;);for(k=0;;){if((k|0)<0)k=0;else{i:{if(!k){e=0,A=k;break i}for(n=k+1&-2,e=0,A=k,f=0;(A|0)>31|e>>>0>31||(o=r<<1,t[o+116577|0]=A,t[o+116576|0]=e,r=r+1|0),(A|0)>32|e>>>0>31||(o=r<<1,t[o+116577|0]=A-1,t[o+116576|0]=e|1,r=r+1|0),e=e+2|0,A=A-2|0,f=f+2|0,(n|0)!=(f|0););}k&1|(A|0)>31|e>>>0>31||(n=r<<1,t[n+116577|0]=A,t[n+116576|0]=e,r=r+1|0),k=k+1|0}if(!((r|0)<1024))break}for(f=2;;){for(e=f-2|0,k=(1<<e<<e)-1|0,o=1<<f,l=f<<2,B=i[l+68992>>2],w=e<<2,_=i[w+68896>>2],n=0;;){for(G=B+(n<<f<<1)|0,r=0;;){for(s=G+(r<<1)|0,A=16,e=k;e=e-!A|0,h=_+(e<<1)|0,A=A?A-1|0:15,m=A<<1,!!((u[m+115904|0]+(u[h|0]<<2)|0)!=(r|0)|(u[m+115905|0]+(u[h+1|0]<<2)|0)!=(n|0)););if(t[s+1|0]=A,t[s|0]=e,r=r+1|0,(o|0)==(r|0))break}if(n=n+1|0,(o|0)==(n|0))break}for(B=i[w+68928>>2],_=i[l+69016>>2],n=0;;){for(G=_+(n<<f<<1)|0,r=0;;){for(s=G+(r<<1)|0,A=16,e=k;e=e-!A|0,h=B+(e<<1)|0,A=A?A-1|0:15,m=A<<1,!!((u[m+118640|0]+(u[h|0]<<2)|0)!=(r|0)|(u[m+118641|0]+(u[h+1|0]<<2)|0)!=(n|0)););if(t[s+1|0]=A,t[s|0]=e,r=r+1|0,(o|0)==(r|0))break}if(n=n+1|0,(o|0)==(n|0))break}for(s=i[w+68960>>2],h=i[l+69040>>2],n=0;;){for(B=h+(n<<f<<1)|0,r=0;;){for(l=B+(r<<1)|0,A=16,e=k;e=e-!A|0,w=s+(e<<1)|0,A=A?A-1|0:15,_=A<<1,!!((u[_+121376|0]+(u[w|0]<<2)|0)!=(r|0)|(u[_+121377|0]+(u[w+1|0]<<2)|0)!=(n|0)););if(t[l+1|0]=A,t[l|0]=e,r=r+1|0,(o|0)==(r|0))break}if(n=n+1|0,(o|0)==(n|0))break}if(f=f+1|0,(f|0)==6)break}}function gv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=D(0),B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=D(0),O=0,S=0,q=0,d=0,c=D(0),A0=D(0),t0=D(0),_0=0,g0=0,X0=0,V0=0,C0=D(0),r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=D(0),R2=D(0),D2=D(0),c2=D(0),f1=D(0),o1=D(0),u1=0,y1=0;e=v-160|0,v=e,f=i[r>>2],V=i[f+192>>2],B=i[f+188>>2],n=i[k+4>>2],o=n>>>0<4,s=n<<3,Y=(o?16908801>>>s|0:0)&3,d=(o?16843265>>>s|0:0)&3,I=K0(f,3);i:{if(I>>>0<=8){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}e:{if(_0=$2(i[r>>2],6),!_0||(K0(i[r>>2],6)|0)==(I|0))break e;r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;r:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break r}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}O=C(248),f=O,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=101168,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,U=f+12|0,i[f+176>>2]=U,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(U,B,V,0,n),a0(e+136|0,U,0,B,V,I,l,0),n=((B+Y|0)-1>>>0)/(Y>>>0)|0,o=((V+d|0)-1>>>0)/(d>>>0)|0,a0(e+112|0,U,1,n,o,I,l,0),f=e+16|0;e:{if(i[e+136>>2]){if(E=i[e+140>>2],i[e+8>>2]=i[e+136>>2],i[e+12>>2]=E,t[e+155|0]>=0){E=i[e+148>>2],i[f>>2]=i[e+144>>2],i[f+4>>2]=E,i[f+8>>2]=i[e+152>>2];break e}T(f,i[e+144>>2],i[e+148>>2]);break e}if(E=i[e+116>>2],i[e+8>>2]=i[e+112>>2],i[e+12>>2]=E,t[e+131|0]>=0){E=i[e+124>>2],i[f>>2]=i[e+120>>2],i[f+4>>2]=E,i[f+8>>2]=i[e+128>>2];break e}T(f,i[e+120>>2],i[e+124>>2])}a0(e+88|0,U,2,n,o,I,l,0),n=e+56|0;e:{if(i[e+8>>2]){if(o=i[e+12>>2],i[e+48>>2]=i[e+8>>2],i[e+52>>2]=o,t[e+27|0]>=0){o=i[f+4>>2],i[n>>2]=i[f>>2],i[n+4>>2]=o,i[n+8>>2]=i[f+8>>2];break e}T(n,i[e+16>>2],i[e+20>>2]);break e}if(f=i[e+92>>2],i[e+48>>2]=i[e+88>>2],i[e+52>>2]=f,t[e+107|0]>=0){f=i[e+100>>2],i[n>>2]=i[e+96>>2],i[n+4>>2]=f,i[n+8>>2]=i[e+104>>2];break e}T(n,i[e+96>>2],i[e+100>>2])}t[e+107|0]<0&&Z(i[e+96>>2]),t[e+27|0]<0&&Z(i[e+16>>2]),t[e+131|0]<0&&Z(i[e+120>>2]),t[e+155|0]<0&&Z(i[e+144>>2]);e:{if(i[e+48>>2]){if(r=i[e+52>>2],i[A>>2]=i[e+48>>2],i[A+4>>2]=r,r=A+8|0,t[e+67|0]>=0){f=i[n+4>>2],i[r>>2]=i[n>>2],i[r+4>>2]=f,i[r+8>>2]=i[n+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+56>>2],i[e+60>>2]),r=t[e+67|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+56>>2]);break e}t[e+67|0]<0&&Z(i[e+56>>2]);r:{if(!_0)break r;if(a0(e+48|0,U,6,B,V,I,l,0),i[e+48>>2]){if(r=i[e+52>>2],i[A>>2]=i[e+48>>2],i[A+4>>2]=r,r=A+8|0,t[e+67|0]>=0){f=i[e+60>>2],i[r>>2]=i[e+56>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+64>>2],t[A+20|0]=1;break e}if(T(r,i[e+56>>2],i[e+60>>2]),r=t[e+67|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+56>>2]);break e}if(t[e+67|0]>=0)break r;Z(i[e+56>>2])}f=Q0(i[r>>2],3),f?(f0=i[f+52>>2]>>>1|0,n=i[f+40>>2]):n=0,f=Q0(i[r>>2],4),f?(M0=i[f+52>>2]>>>1|0,o=i[f+40>>2]):o=0,l=0,f=Q0(i[r>>2],5),f?(z0=i[f+40>>2],E=i[f+52>>2]>>>1|0):E=0,f=Q0(U,0),f?(l=i[f+52>>2]>>>1|0,x=i[f+40>>2]):x=0,f=Q0(U,1),f?(v2=i[f+40>>2],f=i[f+52>>2]>>>1|0):f=0,Z2=f,f=Q0(U,2),f?(A2=i[f+52>>2]>>>1|0,g0=i[f+40>>2]):g0=0,f=0;r:{if(!_0||(f=Q0(i[r>>2],6),f?(j0=i[f+40>>2],X0=i[f+52>>2]):X0=0,S=Q0(U,6),f=0,!S))break r;S0=i[S+52>>2],f=i[S+40>>2]}S=f,i[e+84>>2]=-1113159960,i[e+76>>2]=1056964608,i[e+80>>2]=-1093247418,i[e+68>>2]=-1096180881,i[e+72>>2]=1056964608,i[e+60>>2]=1038710997,i[e+64>>2]=-1104361250,i[e+52>>2]=1050220167,i[e+56>>2]=1058424226,t[e+48|0]=1,V0=u[k+26|0],q0=p[k+24>>1],g3(e+8|0,q0,p[k+20>>1]),f=i[e+44>>2],i[e+80>>2]=i[e+40>>2],i[e+84>>2]=f,f=i[e+36>>2],i[e+72>>2]=i[e+32>>2],i[e+76>>2]=f,k=i[e+28>>2],f=e- -64|0,i[f>>2]=i[e+24>>2],i[f+4>>2]=k,f=i[e+20>>2],i[e+56>>2]=i[e+16>>2],i[e+60>>2]=f,f=i[e+12>>2],i[e+48>>2]=i[e+8>>2],i[e+52>>2]=f;r:{if(!V)break r;if(f=-1<<I^-1,C0=D(16<<I-8),B)for(q=B&-4,R=B&3,r0=B&-2,r2=B&1,f2=B>>>0<4;;){h=x+(g(l,Q)<<1)|0,w=(g(Q,E)<<1)+z0|0,N=(g(Q,f0)<<1)+n|0,G=(g(Q,M0)<<1)+o|0,_=E0[e+60>>2],c=E0[e+56>>2],A0=E0[e+52>>2],k=0;f:{A:{k:switch(q0|0){default:for(;s=k<<1,m=s+h|0,j=D(D(D(p[s+w>>1])*_)+D(D(D(p[s+N>>1])*A0)+D(c*D(p[s+G>>1])))),j=D((V0&1?j:D(D(D(j*D(219))*D(.00390625))+C0))+D(.5)),D(B2(j))<D(2147483648)?s=~~j:s=-2147483648,X[m>>1]=(s|0)>=0?(f|0)<(s|0)?f:s:0,k=k+1|0,(B|0)!=(k|0););break f;case 0:if(s=0,V0&1){if(N=0,f2)break A;for(;w=s<<1,X[w+h>>1]=p[w+G>>1],m=w|2,X[m+h>>1]=p[G+m>>1],m=w|4,X[m+h>>1]=p[G+m>>1],w=w|6,X[w+h>>1]=p[w+G>>1],s=s+4|0,k=k+4|0,(q|0)!=(k|0););break A}for(;k=s<<1,w=k+h|0,_=D(D(D(D(D(p[k+G>>1])*D(219))*D(.00390625))+C0)+D(.5)),D(B2(_))<D(2147483648)?k=~~_:k=-2147483648,X[w>>1]=(k|0)>=0?(f|0)<(k|0)?f:k:0,s=s+1|0,(B|0)!=(s|0););break f;case 8:break k}if(m=0,(B|0)!=1)for(;s=k<<1,X[s+h>>1]=(p[s+G>>1]>>>1)+(p[s+w>>1]+p[s+N>>1]>>>2),s=s|2,X[s+h>>1]=(p[s+G>>1]>>>1)+(p[s+w>>1]+p[s+N>>1]>>>2),k=k+2|0,m=m+2|0,(r0|0)!=(m|0););if(!r2)break f;k=k<<1,X[k+h>>1]=(p[k+G>>1]>>>1)+(p[k+w>>1]+p[k+N>>1]>>>2);break f}if(!R)break f;for(;k=s<<1,X[k+h>>1]=p[k+G>>1],s=s+1|0,N=N+1|0,(R|0)!=(N|0););}if(Q=Q+1|0,(Q|0)==(V|0))break}if(!B)break r;for(G=f&65535,N=1<<I-1&65535,j=D(N>>>0),r0=(d|0)==2,r2=r0&(Y|0)==2,f2=(Y|d)>>>0<2,l=0;;){s=g(l,E)<<1,x=s+z0|0,Q=(g(l,f0)<<1)+n|0,w=(g(l,M0)<<1)+o|0,k=(l>>>0)/(d>>>0)|0,R=g(k,Z2)<<1,I=R+v2|0;f:{A:{k:switch(q0|0){default:for(s=l+1|0,s=r0&&s>>>0<V>>>0?s:l,R=(g(s,E)<<1)+z0|0,m=(g(s,M0)<<1)+o|0,q=(g(s,f0)<<1)+n|0,X2=E0[e+84>>2],R2=E0[e+80>>2],D2=E0[e+76>>2],c2=E0[e+72>>2],f1=E0[e+68>>2],o1=E0[e+64>>2],u1=(g(k,A2)<<1)+g0|0,k=0;s=k<<1,_=D(p[s+x>>1]),c=D(p[s+w>>1]),A0=D(p[s+Q>>1]),f2||(h=k+1|0,h=(h>>>0<B>>>0&&r2?h:k)<<1,_=D(D(D(D(_+D(p[h+x>>1]))+D(p[s+R>>1]))+D(p[h+R>>1]))*D(.25)),A0=D(D(D(D(A0+D(p[h+Q>>1]))+D(p[s+q>>1]))+D(p[h+q>>1]))*D(.25)),c=D(D(D(D(c+D(p[h+w>>1]))+D(p[s+m>>1]))+D(p[h+m>>1]))*D(.25))),h=(k>>>0)/(Y>>>0)<<1,y1=h+I|0,t0=D(D(_*c2)+D(D(A0*o1)+D(c*f1))),s2=V0&1,t0=D(D((s2?t0:D(D(t0*D(224))*D(.00390625)))+j)+D(.5)),D(B2(t0))<D(2147483648)?s=~~t0:s=-2147483648,X[y1>>1]=(s|0)>=0?(f|0)<(s|0)?f:s:0,h=h+u1|0,_=D(D(_*X2)+D(D(A0*D2)+D(c*R2))),_=D(D((s2?_:D(D(_*D(224))*D(.00390625)))+j)+D(.5)),D(B2(_))<D(2147483648)?s=~~_:s=-2147483648,X[h>>1]=(s|0)>=0?(f|0)<(s|0)?f:s:0,k=k+Y|0,B>>>0>k>>>0;);break f;case 0:if(h=n+s|0,Q=R+g0|0,k=0,V0&1)break A;for(;w=(k>>>0)/(Y>>>0)<<1,R=w+I|0,m=k<<1,_=D(D(D(D(D(p[m+x>>1])*D(224))*D(.00390625))+C0)+D(.5)),D(B2(_))<D(2147483648)?s=~~_:s=-2147483648,X[R>>1]=(s|0)>=0?(f|0)<(s|0)?f:s:0,w=w+Q|0,_=D(D(D(D(D(p[h+m>>1])*D(224))*D(.00390625))+C0)+D(.5)),D(B2(_))<D(2147483648)?s=~~_:s=-2147483648,X[w>>1]=(s|0)>=0?(f|0)<(s|0)?f:s:0,k=k+Y|0,B>>>0>k>>>0;);break f;case 8:break k}for(R=(g(k,A2)<<1)+g0|0,k=0;s=k<<1,h=s+x|0,m=(k>>>0)/(Y>>>0)<<1,q=s+Q|0,s=N+((p[s+w>>1]>>>1)-(p[h>>1]+p[q>>1]>>>2)|0)|0,X[m+I>>1]=(s|0)>=0?s>>>0<G>>>0?s:G:0,s=N+((p[q>>1]-p[h>>1]|0)/2|0)|0,X[m+R>>1]=(s|0)>=0?s>>>0<G>>>0?s:G:0,k=k+Y|0,B>>>0>k>>>0;);break f}for(;s=(k>>>0)/(Y>>>0)<<1,w=k<<1,X[s+I>>1]=p[w+x>>1],X[s+Q>>1]=p[h+w>>1],k=k+Y|0,B>>>0>k>>>0;);}if(l=l+d|0,!(V>>>0>l>>>0))break}}r:{if(!_0||(r=K0(i[r>>2],6),!V))break r;if(f=B<<(r>>>0>8),r=0,(V|0)!=1)for(n=V&-2,k=0;o=!f,o||z(g(r,S0)+S|0,g(r,X0)+j0|0,f),o||(o=r|1,z(g(o,S0)+S|0,g(o,X0)+j0|0,f)),r=r+2|0,k=k+2|0,(n|0)!=(k|0););if(!(V&1)|!f)break r;z(g(r,S0)+S|0,g(r,X0)+j0|0,f)}t[A+20|0]=0,i[A+4>>2]=O,i[A>>2]=U;break i}if(A=i[O+4>>2],i[O+4>>2]=A-1,A)break i;W[i[i[O>>2]+8>>2]](O),y(O)}v=e+160|0}function D9(A,e,r,f,k,n,o,l,s,h,w,_,B,m){var G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0;I=v-32|0,v=I,V=A,G=r,_0=e,O=f,A0=k,t0=n,E=I+20|0,Y=v+-64|0,v=Y;i:{e:{r:{f:{if((_|0)>=16){C2(A+4|0,1008,0),t[G+312|0]=3,t[I+30|0]=0,t[I+31|0]=0,X[E>>1]=0,X[E+2>>1]=0,X[E+4>>1]=0,X[E+6>>1]=0;break f}if(t[I+31|0]=0,f=-1,S=o-1|0,i[Y+60>>2]=S,i[Y+56>>2]=S,e=l+h|0,i[Y+52>>2]=e,k=e-1|0,i[Y+48>>2]=k,t[I+30|0]=0,X[E>>1]=0,X[E+2>>1]=0,R=M8(G,O,A0,t0,o,l,s,h,B,S,e),t[Y+47|0]=R,q=M8(G,O,A0,t0,o,l,s,h,B,S,k),t[Y+46|0]=q,U=_0+924|0,x=w<<6,g0=(U+x|0)+(_<<2)|0,r=W[i[i[V>>2]+8>>2]](V,i[g0>>2])|0,!r)break f;A=1-w|0,j=i[r+96>>2];A:{if(u[I+30|0]|!R)break A;if(n=i[G+168>>2],r=S>>n,(r|0)<0||(Q=i[G+172>>2],(Q|0)<=(r|0)))break r;if(n=e>>n,(n|0)<0|(n|0)>=i[G+176>>2])break e;if(!(u[((i[G+160>>2]+g(r,3)|0)+g(g(n,Q),3)|0)+1|0]&3))break A;if(n=i[G+188>>2],r=S>>n,(r|0)<0||(c=i[G+192>>2],(c|0)<=(r|0)))break r;if(e=e>>n,(e|0)<0|(e|0)>=i[G+196>>2])break e;if(n=0,Q=0,e=(i[G+180>>2]+g(r,12)|0)+g(g(e,c),12)|0,r=e+w|0,u[r|0]){if(Q=u[r+2|0],Q>>>0>15)break f;Q=W[i[i[V>>2]+8>>2]](V,i[(U+x|0)+(Q<<2)>>2])|0}if(x=A+e|0,u[x|0]){if(n=u[x+2|0],n>>>0>15)break f;n=W[i[i[V>>2]+8>>2]](V,i[((A<<6)+U|0)+(n<<2)>>2])|0}k:{if(!(!Q|!u[r|0])&&(r=w,i[Q+96>>2]==(j|0)))break k;if(!n|!u[x|0]||(r=A,i[n+96>>2]!=(j|0)))break A}t[I+30|0]=1,f=e+(r<<2)|0,f=p[f+4>>1]|p[f+6>>1]<<16,X[E>>1]=f,X[E+2>>1]=f>>>16,f=t[(e+r|0)+2|0]}A:{if(u[I+30|0]|!q)break A;if(r=i[G+168>>2],e=S>>r,(e|0)<0||(n=i[G+172>>2],(n|0)<=(e|0)))break r;if(r=k>>r,(r|0)<0|(r|0)>=i[G+176>>2])break e;if(!(u[((i[G+160>>2]+g(e,3)|0)+g(g(r,n),3)|0)+1|0]&3))break A;if(r=i[G+188>>2],e=S>>r,(e|0)<0||(n=i[G+192>>2],(n|0)<=(e|0)))break r;if(k=k>>r,(k|0)<0|(k|0)>=i[G+196>>2])break e;if(Q=0,r=0,k=(i[G+180>>2]+g(e,12)|0)+g(g(k,n),12)|0,e=k+w|0,u[e|0]){if(r=u[e+2|0],r>>>0>15)break f;r=W[i[i[V>>2]+8>>2]](V,i[((w<<6)+U|0)+(r<<2)>>2])|0}if(n=A+k|0,u[n|0]){if(Q=u[n+2|0],Q>>>0>15)break f;Q=W[i[i[V>>2]+8>>2]](V,i[((A<<6)+U|0)+(Q<<2)>>2])|0}k:{if(!(!r|!u[e|0])&&(e=w,i[r+96>>2]==(j|0)))break k;if(!Q|!u[n|0]||(e=A,i[Q+96>>2]!=(j|0)))break A}t[I+30|0]=1,r=k+(e<<2)|0,r=p[r+4>>1]|p[r+6>>1]<<16,X[E>>1]=r,X[E+2>>1]=r>>>16,f=t[(e+k|0)+2|0]}X0=R|q,x=_0+1308|0,R=x+(w<<4)|0,q=R+_|0,c=V+4|0,e=Y+60|0,Q=Y+52|0,n=Y+47|0,r=1;A:{k:{n:{for(;;){if(!u[I+30|0]){k=-1;t:{if(u[n|0]!=1)break t;if(N=i[e>>2],n=i[G+168>>2],e=N>>n,(e|0)<0||(d=i[G+172>>2],(d|0)<=(e|0)))break r;if(Q=i[Q>>2],n=Q>>n,(n|0)<0|(n|0)>=i[G+176>>2])break e;if(!(u[((i[G+160>>2]+g(e,3)|0)+g(g(n,d),3)|0)+1|0]&3))break t;if(n=i[G+188>>2],e=N>>n,(e|0)<0||(N=i[G+192>>2],(N|0)<=(e|0)))break r;if(n=Q>>n,(n|0)<0|(n|0)>=i[G+196>>2])break e;if(e=(i[G+180>>2]+g(e,12)|0)+g(g(n,N),12)|0,n=e+w|0,!(u[n|0]!=1|u[q|0]!=u[R+t[n+2|0]|0])){t[I+30|0]=1,e=e+(w<<2)|0,e=p[e+4>>1]|p[e+6>>1]<<16,X[E>>1]=e,X[E+2>>1]=e>>>16,f=t[n+2|0],k=w;break t}if(n=A+e|0,u[n|0]!=1|u[q|0]!=u[t[n+2|0]+(x+(A<<4)|0)|0])break t;t[I+30|0]=1,e=e+(A<<2)|0,e=p[e+4>>1]|p[e+6>>1]<<16,X[E>>1]=e,X[E+2>>1]=e>>>16,f=t[n+2|0],k=A}t:{if(u[I+30|0]!=1)break t;if((f|0)<0){t[I+30|0]=0,t[I+31|0]=0;break f}if((k|0)<0)break n;if(n=W[i[i[V>>2]+8>>2]](V,i[((k<<6)+U|0)+(f<<2)>>2])|0,W[i[i[V>>2]+8>>2]](V,i[g0>>2])|0,u[(x+(k<<4)|0)+f|0]|u[q|0])break t;if(e=i[G+96>>2],k=i[n+96>>2],(e|0)!=(k|0)){k=e-k|0,k=(k|0)>=127?127:k,k=(k|0)<=-128?-128:k,n=k>>31,e=e-j|0,e=(e|0)>=127?127:e,e=g(((k^n)-n>>>1|16384)/(k|0)<<16>>16,(e|0)<=-128?-128:e)+32>>6,e=(e|0)>=4095?4095:e,n=(e|0)<=-4096?-4096:e,Q=p[E>>1]|p[E+2>>1]<<16,e=g(n,Q>>16),k=e>>31,e=g(((e|0)>0)-((e|0)<0)|0,((e^k)-k|0)+127>>>8|0),e=(e|0)>=32767?32767:e,X[E+2>>1]=(e|0)<=-32768?-32768:e,e=g(n,Q<<16>>16),k=e>>31,e=g(((e|0)>0)-((e|0)<0)|0,((e^k)-k|0)+127>>>8|0),e=(e|0)>=32767?32767:e,X[E>>1]=(e|0)<=-32768?-32768:e;break t}C2(c,1008,0),t[G+312|0]=3}if(k=r&1,e=Y+56|0,Q=Y+48|0,n=Y+46|0,r=0,k)continue}break}i[Y+40>>2]=S,e=o+s|0,i[Y+32>>2]=e,r=-1,k=l-1|0,i[Y+20>>2]=k,i[Y+24>>2]=k,i[Y+28>>2]=k,N=e-1|0,i[Y+36>>2]=N,t[I+31|0]=0,X[E+4>>1]=0,X[E+6>>1]=0,f=M8(G,O,A0,t0,o,l,s,h,B,e,k),t[Y+17|0]=f,R=E+4|0;t:{if(u[I+31|0]|!f)break t;if(f=i[G+188>>2],e=e>>f,(e|0)<0||(d=i[G+192>>2],(d|0)<=(e|0)))break r;if(f=k>>f,(f|0)<0|(f|0)>=i[G+196>>2])break e;if(n=0,Q=0,f=(i[G+180>>2]+g(e,12)|0)+g(g(f,d),12)|0,e=f+w|0,u[e|0]){if(Q=u[e+2|0],Q>>>0>15)break f;Q=W[i[i[V>>2]+8>>2]](V,i[((w<<6)+U|0)+(Q<<2)>>2])|0}if(d=A+f|0,u[d|0]){if(n=u[d+2|0],n>>>0>15)break f;n=W[i[i[V>>2]+8>>2]](V,i[((A<<6)+U|0)+(n<<2)>>2])|0}o:{if(!(!Q|!u[e|0])&&(e=w,i[Q+96>>2]==(j|0)))break o;if(!n|!u[d|0]||(e=A,i[n+96>>2]!=(j|0)))break t}t[I+31|0]=1,r=f+(e<<2)|0,r=p[r+4>>1]|p[r+6>>1]<<16,X[R>>1]=r,X[R+2>>1]=r>>>16,r=t[(e+f|0)+2|0]}e=M8(G,O,A0,t0,o,l,s,h,B,N,k),t[Y+18|0]=e;t:{if(u[I+31|0]|!e)break t;if(e=i[G+188>>2],f=N>>e,(f|0)<0||(N=i[G+192>>2],(N|0)<=(f|0)))break r;if(n=k>>e,(n|0)<0|(n|0)>=i[G+196>>2])break e;if(Q=0,e=0,n=(i[G+180>>2]+g(f,12)|0)+g(g(n,N),12)|0,f=n+w|0,u[f|0]){if(e=u[f+2|0],e>>>0>15)break f;e=W[i[i[V>>2]+8>>2]](V,i[((w<<6)+U|0)+(e<<2)>>2])|0}if(N=A+n|0,u[N|0]){if(Q=u[N+2|0],Q>>>0>15)break f;Q=W[i[i[V>>2]+8>>2]](V,i[((A<<6)+U|0)+(Q<<2)>>2])|0}o:{if(!(!e|!u[f|0])&&(f=w,i[e+96>>2]==(j|0)))break o;if(!Q|!u[N|0]||(f=A,i[Q+96>>2]!=(j|0)))break t}t[I+31|0]=1,e=n+(f<<2)|0,e=p[e+4>>1]|p[e+6>>1]<<16,X[R>>1]=e,X[R+2>>1]=e>>>16,r=t[(f+n|0)+2|0]}e=M8(G,O,A0,t0,o,l,s,h,B,S,k),t[Y+19|0]=e;t:{if(u[I+31|0]|!e)break t;if(f=i[G+188>>2],e=S>>f,(e|0)<0||(n=i[G+192>>2],(n|0)<=(e|0)))break r;if(k=k>>f,(k|0)<0|(k|0)>=i[G+196>>2])break e;if(Q=0,f=0,e=(i[G+180>>2]+g(e,12)|0)+g(g(k,n),12)|0,k=e+w|0,u[k|0]){if(f=u[k+2|0],f>>>0>15)break f;f=W[i[i[V>>2]+8>>2]](V,i[((w<<6)+U|0)+(f<<2)>>2])|0}if(B=A+e|0,u[B|0]){if(n=u[B+2|0],n>>>0>15)break f;Q=W[i[i[V>>2]+8>>2]](V,i[((A<<6)+U|0)+(n<<2)>>2])|0}o:{if(!(!f|!u[k|0])&&(n=w,i[f+96>>2]==(j|0)))break o;if(!Q|!u[B|0]||(n=A,i[Q+96>>2]!=(j|0)))break t}t[I+31|0]=1,r=e+(n<<2)|0,r=p[r+4>>1]|p[r+6>>1]<<16,X[R>>1]=r,X[R+2>>1]=r>>>16,r=t[(e+n|0)+2|0]}if(X0)break f;for(u[I+31|0]&&(t[I+30|0]=1,e=p[E+4>>1]|p[E+6>>1]<<16,X[E>>1]=e,X[E+2>>1]=e>>>16),t[I+31|0]=0,n=x+(w<<4)|0,k=0;;){e=-1;t:{if(u[(Y+17|0)+k|0]!=1)break t;if(f=k<<2,B=i[G+188>>2],e=i[f+(Y+32|0)>>2]>>B,(e|0)<0||(O=i[G+192>>2],(O|0)<=(e|0)))break r;if(f=i[f+(Y+20|0)>>2]>>B,(f|0)<0|(f|0)>=i[G+196>>2])break e;if(f=(i[G+180>>2]+g(e,12)|0)+g(g(f,O),12)|0,B=f+2|0,e=B+w|0,O=t[e|0],(O|0)>15)break k;if(!(u[f+w|0]!=1|u[q|0]!=u[n+O|0])){t[I+31|0]=1,r=f+(w<<2)|0,r=p[r+4>>1]|p[r+6>>1]<<16,X[R>>1]=r,X[R+2>>1]=r>>>16,r=t[e|0],e=w;break t}if(e=-1,u[A+f|0]!=1||(B=A+B|0,e=-1,u[q|0]!=u[t[B|0]+(x+(A<<4)|0)|0]))break t;t[I+31|0]=1,e=f+(A<<2)|0,e=p[e+4>>1]|p[e+6>>1]<<16,X[R>>1]=e,X[R+2>>1]=e>>>16,r=t[B|0],e=A}t:{if(u[I+31|0]!=1)break t;if((r|0)<0){t[I+30|0]=0,t[I+31|0]=0;break f}if((e|0)<0)break A;f=W[i[i[V>>2]+8>>2]](V,i[((e<<6)+U|0)+(r<<2)>>2])|0,B=W[i[i[V>>2]+8>>2]](V,i[g0>>2])|0;o:{if(!(B&&f)){C2(i[G+112>>2]+4|0,1012,0);break o}if(f=i[f+96>>2],u[q|0]|(u[(x+(e<<4)|0)+r|0]|(f|0)==i[B+96>>2])||(e=i[G+96>>2],B=p[R>>1]|p[R+2>>1]<<16,i[Y+8>>2]=B,i[Y+12>>2]=B,jo(R,Y+8|0,e-f|0,e-j|0)))break t;C2(c,1008,0)}t[G+312|0]=3}if(k=k+1|0,(k|0)==3)break f;if(u[I+31|0])break}break f}U0(23779,19905,1801,8917),M()}t[G+312|0]=3,C2(c,1012,0);break f}U0(23779,19905,1959,8917),M()}v=Y- -64|0;break i}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}i:{e:{r:{f:{A:{k:{if(A=u[I+30|0],e=u[I+31|0],!(!A|!e)){if(p[I+20>>1]!=p[I+24>>1]|p[I+22>>1]!=p[I+26>>1])break k;X3(V,G,_0,o,l,s,h,_,w,I+12|0,I+19|0);break A}if(X3(V,G,_0,o,l,s,h,_,w,I+12|0,I+19|0),A)break f;if(_=0,A=0,!e)break i;break e}t[I+19|0]=0}A=i[I+20>>2],X[m>>1]=A,X[m+2>>1]=A>>>16;break r}if(A=i[I+20>>2],X[m>>1]=A,X[m+2>>1]=A>>>16,e)break r;A=1;break i}if(_=1,p[I+20>>1]!=p[I+24>>1])break e;if(A=1,p[I+22>>1]==p[I+26>>1])break i}A=(_<<2)+m|0,e=i[I+24>>2],X[A>>1]=e,X[A+2>>1]=e>>>16,A=_+1|0}_=A,u[I+19|0]&&(A=(_<<2)+m|0,e=i[I+12>>2],X[A>>1]=e,X[A+2>>1]=e>>>16,_=_+1|0);i:{if(_>>>0<=1){if(A=_<<2,e=8-A|0,!e)break i;l0(A+m|0,0,e);break i}if((_|0)==2)break i;U0(23328,19905,2063,5213),M()}v=I+32|0}function e6(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;for(k=v-208|0,v=k,i[k+200>>2]=0,i[k+204>>2]=0,w=k+200|0,i[k+196>>2]=w,s=A+8|0;;){i:{o=w,f=o;e:{r:{f:{A:{k:{n:{t:{o:{l:{u:{s:{h:{if(!n)break h;for(;;){if(f=n,o=i[f+16>>2],o>>>0>r>>>0){if(o=f,n=i[f>>2],n)continue;break h}if(r>>>0<=o>>>0)break s;if(n=i[f+4>>2],!n)break}o=f+4|0}if(n=C(20),i[n+8>>2]=f,i[n>>2]=0,i[n+4>>2]=0,i[n+16>>2]=r,i[o>>2]=n,f=i[i[k+196>>2]>>2],f&&(i[k+196>>2]=f),G1(i[k+200>>2],n),i[k+204>>2]=i[k+204>>2]+1,f=X8(i[e+48>>2],r),!((f|0)==1735551332|(f|0)==1768912492)&(f|0)!=1768187246)break t;if(f=i[e+48>>2],o=i[f+80>>2],h=i[f+84>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),o)break o;if(f=C(56),i[k+8>>2]=f,i[k+12>>2]=54,i[k+16>>2]=-2147483592,r=u[5598]|u[5599]<<8|(u[5600]<<16|u[5601]<<24),e=u[5594]|u[5595]<<8|(u[5596]<<16|u[5597]<<24),t[f+46|0]=e,t[f+47|0]=e>>>8,t[f+48|0]=e>>>16,t[f+49|0]=e>>>24,t[f+50|0]=r,t[f+51|0]=r>>>8,t[f+52|0]=r>>>16,t[f+53|0]=r>>>24,r=u[5592]|u[5593]<<8|(u[5594]<<16|u[5595]<<24),e=u[5588]|u[5589]<<8|(u[5590]<<16|u[5591]<<24),t[f+40|0]=e,t[f+41|0]=e>>>8,t[f+42|0]=e>>>16,t[f+43|0]=e>>>24,t[f+44|0]=r,t[f+45|0]=r>>>8,t[f+46|0]=r>>>16,t[f+47|0]=r>>>24,r=u[5584]|u[5585]<<8|(u[5586]<<16|u[5587]<<24),e=u[5580]|u[5581]<<8|(u[5582]<<16|u[5583]<<24),t[f+32|0]=e,t[f+33|0]=e>>>8,t[f+34|0]=e>>>16,t[f+35|0]=e>>>24,t[f+36|0]=r,t[f+37|0]=r>>>8,t[f+38|0]=r>>>16,t[f+39|0]=r>>>24,r=u[5576]|u[5577]<<8|(u[5578]<<16|u[5579]<<24),e=u[5572]|u[5573]<<8|(u[5574]<<16|u[5575]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,t[f+28|0]=r,t[f+29|0]=r>>>8,t[f+30|0]=r>>>16,t[f+31|0]=r>>>24,r=u[5568]|u[5569]<<8|(u[5570]<<16|u[5571]<<24),e=u[5564]|u[5565]<<8|(u[5566]<<16|u[5567]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[5560]|u[5561]<<8|(u[5562]<<16|u[5563]<<24),e=u[5556]|u[5557]<<8|(u[5558]<<16|u[5559]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,r=u[5552]|u[5553]<<8|(u[5554]<<16|u[5555]<<24),e=u[5548]|u[5549]<<8|(u[5550]<<16|u[5551]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+54|0]=0,r=a(k+32|0,2,117,k+8|0),e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,t[r+19|0]<0)break u;e=i[r+12>>2],i[s>>2]=i[r+8>>2],i[s+4>>2]=e,i[s+8>>2]=i[r+16>>2],t[A+20|0]=1;break l}e=C(40),i[k+8>>2]=e,i[k+12>>2]=37,i[k+16>>2]=-2147483608,f=u[14759]|u[14760]<<8|(u[14761]<<16|u[14762]<<24),r=u[14755]|u[14756]<<8|(u[14757]<<16|u[14758]<<24),t[e+29|0]=r,t[e+30|0]=r>>>8,t[e+31|0]=r>>>16,t[e+32|0]=r>>>24,t[e+33|0]=f,t[e+34|0]=f>>>8,t[e+35|0]=f>>>16,t[e+36|0]=f>>>24,f=u[14754]|u[14755]<<8|(u[14756]<<16|u[14757]<<24),r=u[14750]|u[14751]<<8|(u[14752]<<16|u[14753]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[14746]|u[14747]<<8|(u[14748]<<16|u[14749]<<24),r=u[14742]|u[14743]<<8|(u[14744]<<16|u[14745]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[14738]|u[14739]<<8|(u[14740]<<16|u[14741]<<24),r=u[14734]|u[14735]<<8|(u[14736]<<16|u[14737]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,f=u[14730]|u[14731]<<8|(u[14732]<<16|u[14733]<<24),r=u[14726]|u[14727]<<8|(u[14728]<<16|u[14729]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+37|0]=0,r=a(k+32|0,2,117,k+8|0),e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e;s:{if(t[r+19|0]>=0){e=i[r+12>>2],i[s>>2]=i[r+8>>2],i[s+4>>2]=e,i[s+8>>2]=i[r+16>>2],t[A+20|0]=1;break s}if(T(s,i[r+8>>2],i[r+12>>2]),e=t[r+19|0],t[A+20|0]=1,(e|0)>=0)break s;Z(i[r+8>>2])}if(t[k+19|0]>=0)break i;Z(i[k+8>>2]);break i}if(T(s,i[r+8>>2],i[r+12>>2]),e=t[r+19|0],t[A+20|0]=1,(e|0)>=0)break l;Z(i[r+8>>2])}if(t[k+19|0]<0&&Z(i[k+8>>2]),!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break i;W[i[i[h>>2]+8>>2]](h),y(h);break i}if(d4(k+8|0,o,r,1684630887),_=i[k+12>>2],f=i[k+8>>2],(_|0)!=(f|0))break n;l=C(56),i[k+184>>2]=l,i[k+188>>2]=54,i[k+192>>2]=-2147483592,n=u[5598]|u[5599]<<8|(u[5600]<<16|u[5601]<<24),o=u[5594]|u[5595]<<8|(u[5596]<<16|u[5597]<<24),t[l+46|0]=o,t[l+47|0]=o>>>8,t[l+48|0]=o>>>16,t[l+49|0]=o>>>24,t[l+50|0]=n,t[l+51|0]=n>>>8,t[l+52|0]=n>>>16,t[l+53|0]=n>>>24,n=u[5592]|u[5593]<<8|(u[5594]<<16|u[5595]<<24),o=u[5588]|u[5589]<<8|(u[5590]<<16|u[5591]<<24),t[l+40|0]=o,t[l+41|0]=o>>>8,t[l+42|0]=o>>>16,t[l+43|0]=o>>>24,t[l+44|0]=n,t[l+45|0]=n>>>8,t[l+46|0]=n>>>16,t[l+47|0]=n>>>24,n=u[5584]|u[5585]<<8|(u[5586]<<16|u[5587]<<24),o=u[5580]|u[5581]<<8|(u[5582]<<16|u[5583]<<24),t[l+32|0]=o,t[l+33|0]=o>>>8,t[l+34|0]=o>>>16,t[l+35|0]=o>>>24,t[l+36|0]=n,t[l+37|0]=n>>>8,t[l+38|0]=n>>>16,t[l+39|0]=n>>>24,n=u[5576]|u[5577]<<8|(u[5578]<<16|u[5579]<<24),o=u[5572]|u[5573]<<8|(u[5574]<<16|u[5575]<<24),t[l+24|0]=o,t[l+25|0]=o>>>8,t[l+26|0]=o>>>16,t[l+27|0]=o>>>24,t[l+28|0]=n,t[l+29|0]=n>>>8,t[l+30|0]=n>>>16,t[l+31|0]=n>>>24,n=u[5568]|u[5569]<<8|(u[5570]<<16|u[5571]<<24),o=u[5564]|u[5565]<<8|(u[5566]<<16|u[5567]<<24),t[l+16|0]=o,t[l+17|0]=o>>>8,t[l+18|0]=o>>>16,t[l+19|0]=o>>>24,t[l+20|0]=n,t[l+21|0]=n>>>8,t[l+22|0]=n>>>16,t[l+23|0]=n>>>24,n=u[5560]|u[5561]<<8|(u[5562]<<16|u[5563]<<24),o=u[5556]|u[5557]<<8|(u[5558]<<16|u[5559]<<24),t[l+8|0]=o,t[l+9|0]=o>>>8,t[l+10|0]=o>>>16,t[l+11|0]=o>>>24,t[l+12|0]=n,t[l+13|0]=n>>>8,t[l+14|0]=n>>>16,t[l+15|0]=n>>>24,n=u[5552]|u[5553]<<8|(u[5554]<<16|u[5555]<<24),o=u[5548]|u[5549]<<8|(u[5550]<<16|u[5551]<<24),t[l|0]=o,t[l+1|0]=o>>>8,t[l+2|0]=o>>>16,t[l+3|0]=o>>>24,t[l+4|0]=n,t[l+5|0]=n>>>8,t[l+6|0]=n>>>16,t[l+7|0]=n>>>24,t[l+54|0]=0,n=a(k+32|0,2,117,k+184|0),o=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=o;o:{if(t[k+51|0]>=0){o=i[k+44>>2],i[s>>2]=i[k+40>>2],i[s+4>>2]=o,i[s+8>>2]=i[k+48>>2],t[A+20|0]=1;break o}if(T(s,i[k+40>>2],i[k+44>>2]),o=t[k+51|0],t[A+20|0]=1,(o|0)>=0)break o;Z(i[k+40>>2])}if(t[k+195|0]<0&&Z(i[k+184>>2]),n=i[k+8>>2],!n)break e;break r}t:{if(f=i[e+20>>2],!f)break t;for(o=e+20|0,n=o;e=o0[f+16>>2]<r>>>0,n=e?n:f,f=i[(e?4:0)+f>>2],!!f;);if((n|0)==(o|0)|o0[n+16>>2]>r>>>0)break t;t[A+20|0]=0,i[A>>2]=r;break i}i[k+124>>2]=0,i[k+96>>2]=78164,i[k+40>>2]=78144,e=i[19545],i[k+32>>2]=e,n=k+32|0,i[n+i[e-12>>2]>>2]=i[19546],i[k+36>>2]=0,e=n+i[i[k+32>>2]-12>>2]|0,o=k+44|0,J0(e,o),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[k+40>>2]=e,f=k+40|0,i[f+i[e-12>>2]>>2]=i[19548],e=i[19544],i[k+32>>2]=e,i[n+i[e-12>>2]>>2]=i[19549],i[k+96>>2]=78164,i[k+32>>2]=78124,i[k+40>>2]=78144,n=R0(o),i[n>>2]=77200,i[k+84>>2]=0,i[k+88>>2]=0,i[k+76>>2]=0,i[k+80>>2]=0,i[k+92>>2]=24,F(B0(F(f,31808,11),r),37897,35),e=i[k+92>>2];t:{if(e&16){f=i[k+88>>2],e=i[k+68>>2],f>>>0<e>>>0&&(i[k+88>>2]=e,f=e),e=k- -64|0;break t}if(!(e&8)){f=0,t[k+195|0]=0,r=k+184|0;break f}f=i[k+60>>2],e=k+52|0}if(o=i[e>>2],f=f-o|0,f>>>0>=2147483640)break k;if(f>>>0>=11){e=f|7,r=C(e+1|0),i[k+192>>2]=e-2147483647,i[k+184>>2]=r,i[k+188>>2]=f;break A}if(t[k+195|0]=f,r=k+184|0,f)break A;f=0;break f}r=i[f>>2],n=f;break r}I0(),M()}if(!f)break f;z(r,o,f)}t[r+f|0]=0,r=a(k+8|0,2,2e3,k+184|0),e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e;f:{if(t[r+19|0]>=0){e=i[r+12>>2],i[s>>2]=i[r+8>>2],i[s+4>>2]=e,i[s+8>>2]=i[r+16>>2],t[A+20|0]=1;break f}if(T(s,i[r+8>>2],i[r+12>>2]),e=t[r+19|0],t[A+20|0]=1,(e|0)>=0)break f;Z(i[r+8>>2])}t[k+195|0]<0&&Z(i[k+184>>2]),A=i[19543],i[k+32>>2]=A,i[i[A-12>>2]+(k+32|0)>>2]=i[19551],i[k+40>>2]=i[19552],i[n>>2]=77200,t[k+87|0]<0&&Z(i[k+76>>2]),y0(n),Y0(k+96|0);break i}i[k+12>>2]=n,Z(n)}e:{if(!h||(o=i[h+4>>2],i[h+4>>2]=o-1,o))break e;W[i[i[h>>2]+8>>2]](h),y(h)}if((f|0)==(_|0))break i;n=i[k+200>>2];continue}break}S1(k+196|0,i[k+200>>2]),v=k+208|0}function Gv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;o=v-16|0,v=o,l=(f|0)/8|0,h=i[r>>2],B=i[r+4>>2]-h|0,s=i[k>>2];i:{if(l>>>0>B-s>>>0){if(e=C(40),i[o+4>>2]=e,i[o+8>>2]=39,i[o+12>>2]=-2147483608,r=u[9909]|u[9910]<<8|(u[9911]<<16|u[9912]<<24),f=u[9905]|u[9906]<<8|(u[9907]<<16|u[9908]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+39|0]=0,r=u[9940]|u[9941]<<8|(u[9942]<<16|u[9943]<<24),f=u[9936]|u[9937]<<8|(u[9938]<<16|u[9939]<<24),t[e+31|0]=f,t[e+32|0]=f>>>8,t[e+33|0]=f>>>16,t[e+34|0]=f>>>24,t[e+35|0]=r,t[e+36|0]=r>>>8,t[e+37|0]=r>>>16,t[e+38|0]=r>>>24,r=u[9933]|u[9934]<<8|(u[9935]<<16|u[9936]<<24),f=u[9929]|u[9930]<<8|(u[9931]<<16|u[9932]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[9925]|u[9926]<<8|(u[9927]<<16|u[9928]<<24),f=u[9921]|u[9922]<<8|(u[9923]<<16|u[9924]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[9917]|u[9918]<<8|(u[9919]<<16|u[9920]<<24),f=u[9913]|u[9914]<<8|(u[9915]<<16|u[9916]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,136,o+4|0),t[o+15|0]>=0)break i;Z(i[o+4>>2]);break i}w=h+s|0,_=u[w|0],h=u[w+1|0];e:{if((f|0)==32){_=h<<16|_<<24|u[w+2|0]<<8,h=u[w+3|0],w=4;break e}_=_<<8,w=2}if(w=w+s|0,i[k>>2]=w,s=B-w|0,w=h|_,l=L0(l,l>>31,w,0),h=h0<<1|l>>>31,l=l<<1,!h&s>>>0<l>>>0|h){if(e=C(40),i[o+4>>2]=e,i[o+8>>2]=39,i[o+12>>2]=-2147483608,r=u[9909]|u[9910]<<8|(u[9911]<<16|u[9912]<<24),f=u[9905]|u[9906]<<8|(u[9907]<<16|u[9908]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+39|0]=0,r=u[9940]|u[9941]<<8|(u[9942]<<16|u[9943]<<24),f=u[9936]|u[9937]<<8|(u[9938]<<16|u[9939]<<24),t[e+31|0]=f,t[e+32|0]=f>>>8,t[e+33|0]=f>>>16,t[e+34|0]=f>>>24,t[e+35|0]=r,t[e+36|0]=r>>>8,t[e+37|0]=r>>>16,t[e+38|0]=r>>>24,r=u[9933]|u[9934]<<8|(u[9935]<<16|u[9936]<<24),f=u[9929]|u[9930]<<8|(u[9931]<<16|u[9932]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[9925]|u[9926]<<8|(u[9927]<<16|u[9928]<<24),f=u[9921]|u[9922]<<8|(u[9923]<<16|u[9924]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[9917]|u[9918]<<8|(u[9919]<<16|u[9920]<<24),f=u[9913]|u[9914]<<8|(u[9915]<<16|u[9916]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,136,o+4|0),t[o+15|0]>=0)break i;Z(i[o+4>>2]);break i}e:{if(u[e+4|0]==1){if(w>>>0>2)break e;if(e=C(40),i[o+4>>2]=e,i[o+8>>2]=39,i[o+12>>2]=-2147483608,r=u[25593]|u[25594]<<8|(u[25595]<<16|u[25596]<<24),f=u[25589]|u[25590]<<8|(u[25591]<<16|u[25592]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+39|0]=0,r=u[25624]|u[25625]<<8|(u[25626]<<16|u[25627]<<24),f=u[25620]|u[25621]<<8|(u[25622]<<16|u[25623]<<24),t[e+31|0]=f,t[e+32|0]=f>>>8,t[e+33|0]=f>>>16,t[e+34|0]=f>>>24,t[e+35|0]=r,t[e+36|0]=r>>>8,t[e+37|0]=r>>>16,t[e+38|0]=r>>>24,r=u[25617]|u[25618]<<8|(u[25619]<<16|u[25620]<<24),f=u[25613]|u[25614]<<8|(u[25615]<<16|u[25616]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[25609]|u[25610]<<8|(u[25611]<<16|u[25612]<<24),f=u[25605]|u[25606]<<8|(u[25607]<<16|u[25608]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[25601]|u[25602]<<8|(u[25603]<<16|u[25604]<<24),f=u[25597]|u[25598]<<8|(u[25599]<<16|u[25600]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,o+4|0),t[o+15|0]>=0)break i;Z(i[o+4>>2]);break i}if(w>>>0>1)break e;if(e=C(48),i[o+4>>2]=e,i[o+8>>2]=40,i[o+12>>2]=-2147483600,r=u[25633]|u[25634]<<8|(u[25635]<<16|u[25636]<<24),f=u[25629]|u[25630]<<8|(u[25631]<<16|u[25632]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+40|0]=0,r=u[25665]|u[25666]<<8|(u[25667]<<16|u[25668]<<24),f=u[25661]|u[25662]<<8|(u[25663]<<16|u[25664]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[25657]|u[25658]<<8|(u[25659]<<16|u[25660]<<24),f=u[25653]|u[25654]<<8|(u[25655]<<16|u[25656]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[25649]|u[25650]<<8|(u[25651]<<16|u[25652]<<24),f=u[25645]|u[25646]<<8|(u[25647]<<16|u[25648]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[25641]|u[25642]<<8|(u[25643]<<16|u[25644]<<24),f=u[25637]|u[25638]<<8|(u[25639]<<16|u[25640]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,o+4|0),t[o+15|0]>=0)break i;Z(i[o+4>>2]);break i}if(_>>>0>=536870912){if(e=C(48),i[o+4>>2]=e,i[o+8>>2]=42,i[o+12>>2]=-2147483600,r=u[27791]|u[27792]<<8|(u[27793]<<16|u[27794]<<24),f=u[27787]|u[27788]<<8|(u[27789]<<16|u[27790]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+42|0]=0,r=u[27827]|u[27828]<<8,t[e+40|0]=r,t[e+41|0]=r>>>8,r=u[27823]|u[27824]<<8|(u[27825]<<16|u[27826]<<24),f=u[27819]|u[27820]<<8|(u[27821]<<16|u[27822]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[27815]|u[27816]<<8|(u[27817]<<16|u[27818]<<24),f=u[27811]|u[27812]<<8|(u[27813]<<16|u[27814]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[27807]|u[27808]<<8|(u[27809]<<16|u[27810]<<24),f=u[27803]|u[27804]<<8|(u[27805]<<16|u[27806]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[27799]|u[27800]<<8|(u[27801]<<16|u[27802]<<24),f=u[27795]|u[27796]<<8|(u[27797]<<16|u[27798]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,0,o+4|0),t[o+15|0]>=0)break i;Z(i[o+4>>2]);break i}if(D4(A,e+20|0,w<<3,n,9945),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),I=(f|0)!=32;e:{r:{for(;;){n=i[k>>2],f=n+4|0,l=i[r>>2],h=l+n|0,_=u[h|0],s=u[h+1|0];f:{if(!I){B=u[h+3|0],m=u[h+2|0],i[k>>2]=f,f=f+l|0,f=u[f|0]|u[f+1|0]<<8|(u[f+2|0]<<16|u[f+3|0]<<24),h=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=n+8|0,n=s<<16|_<<24|m<<8|B;break f}n=n+2|0,i[k>>2]=n,n=n+l|0,h=(u[n+1|0]<<16|u[n|0]<<24)>>16,n=(s<<16|_<<24)>>16}i[k>>2]=f;f:{f=i[e+12>>2],s=i[e+16>>2];A:{if(f>>>0<s>>>0){i[f>>2]=n,i[f+4>>2]=h,f=f+8|0;break A}if(_=i[e+8>>2],f=f-_|0,m=f>>3,l=m+1|0,l>>>0>=536870912)break f;if(s=s-_|0,B=s>>2,s=s>>>0>=2147483640?536870911:l>>>0<B>>>0?B:l,s){if(s>>>0>=536870912)break r;l=C(s<<3)}else l=0;if(B=l+f|0,i[B>>2]=n,i[B+4>>2]=h,n=B-(m<<3)|0,f&&z(n,_,f),i[e+16>>2]=l+(s<<3),f=B+8|0,i[e+12>>2]=f,i[e+8>>2]=n,!_)break A;Z(_)}if(i[e+12>>2]=f,G=G+1|0,(w|0)==(G|0))break e;continue}break}s0(),M()}x0(),M()}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=o+16|0}function Wv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=D(0),_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=D(0),q=0,d=0,c=0,A0=0,t0=D(0),_0=D(0),g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=D(0),s2=D(0),v2=D(0),Z2=0;e=v-160|0,v=e,o=i[r>>2],f=o,V=i[f+192>>2],_=i[f+188>>2],n=i[k+4>>2],f=n>>>0<4,s=n<<3,Y=(f?16908801>>>s|0:0)&3,j=(f?16843265>>>s|0:0)&3;i:{if((K0(o,3)|0)!=8){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}e:{if(q=$2(i[r>>2],6),!q||(K0(i[r>>2],6)|0)==8)break e;r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;r:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break r}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}U=C(248),f=U,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=101168,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,R=f+12|0,i[f+176>>2]=R,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(R,_,V,0,n),a0(e+136|0,R,0,_,V,8,l,0),n=((_+Y|0)-1>>>0)/(Y>>>0)|0,o=((V+j|0)-1>>>0)/(j>>>0)|0,a0(e+112|0,R,1,n,o,8,l,0),f=e+16|0;e:{if(i[e+136>>2]){if(E=i[e+140>>2],i[e+8>>2]=i[e+136>>2],i[e+12>>2]=E,t[e+155|0]>=0){E=i[e+148>>2],i[f>>2]=i[e+144>>2],i[f+4>>2]=E,i[f+8>>2]=i[e+152>>2];break e}T(f,i[e+144>>2],i[e+148>>2]);break e}if(E=i[e+116>>2],i[e+8>>2]=i[e+112>>2],i[e+12>>2]=E,t[e+131|0]>=0){E=i[e+124>>2],i[f>>2]=i[e+120>>2],i[f+4>>2]=E,i[f+8>>2]=i[e+128>>2];break e}T(f,i[e+120>>2],i[e+124>>2])}a0(e+88|0,R,2,n,o,8,l,0),n=e+56|0;e:{if(i[e+8>>2]){if(o=i[e+12>>2],i[e+48>>2]=i[e+8>>2],i[e+52>>2]=o,t[e+27|0]>=0){o=i[f+4>>2],i[n>>2]=i[f>>2],i[n+4>>2]=o,i[n+8>>2]=i[f+8>>2];break e}T(n,i[e+16>>2],i[e+20>>2]);break e}if(f=i[e+92>>2],i[e+48>>2]=i[e+88>>2],i[e+52>>2]=f,t[e+107|0]>=0){f=i[e+100>>2],i[n>>2]=i[e+96>>2],i[n+4>>2]=f,i[n+8>>2]=i[e+104>>2];break e}T(n,i[e+96>>2],i[e+100>>2])}t[e+107|0]<0&&Z(i[e+96>>2]),t[e+27|0]<0&&Z(i[e+16>>2]),t[e+131|0]<0&&Z(i[e+120>>2]),t[e+155|0]<0&&Z(i[e+144>>2]);e:{if(i[e+48>>2]){if(r=i[e+52>>2],i[A>>2]=i[e+48>>2],i[A+4>>2]=r,r=A+8|0,t[e+67|0]>=0){f=i[n+4>>2],i[r>>2]=i[n>>2],i[r+4>>2]=f,i[r+8>>2]=i[n+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+56>>2],i[e+60>>2]),r=t[e+67|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+56>>2]);break e}t[e+67|0]<0&&Z(i[e+56>>2]);r:{if(!q)break r;if(a0(e+48|0,R,6,_,V,8,l,0),i[e+48>>2]){if(r=i[e+52>>2],i[A>>2]=i[e+48>>2],i[A+4>>2]=r,r=A+8|0,t[e+67|0]>=0){f=i[e+60>>2],i[r>>2]=i[e+56>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+64>>2],t[A+20|0]=1;break e}if(T(r,i[e+56>>2],i[e+60>>2]),r=t[e+67|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+56>>2]);break e}if(t[e+67|0]>=0)break r;Z(i[e+56>>2])}f=Q0(i[r>>2],3),f?(g0=i[f+52>>2],n=i[f+40>>2]):n=0,f=Q0(i[r>>2],4),f?(X0=i[f+52>>2],o=i[f+40>>2]):o=0,f=Q0(i[r>>2],5),f?(V0=i[f+40>>2],l=i[f+52>>2]):l=0,f=Q0(R,0),f?(d=i[f+52>>2],s=i[f+40>>2]):s=0,f=Q0(R,1),f?(r2=i[f+40>>2],f=i[f+52>>2]):f=0,f2=f,f=Q0(R,2),f?(S0=i[f+52>>2],E=i[f+40>>2]):E=0,f=0;r:{if(!q||(f=Q0(i[r>>2],6),f?(C0=i[f+40>>2],c=i[f+52>>2]):c=0,x=Q0(R,6),f=0,!x))break r;r0=i[x+52>>2],f=i[x+40>>2]}if(x=f,i[e+84>>2]=-1113159960,i[e+76>>2]=1056964608,i[e+80>>2]=-1093247418,i[e+68>>2]=-1096180881,i[e+72>>2]=1056964608,i[e+60>>2]=1038710997,i[e+64>>2]=-1104361250,i[e+52>>2]=1050220167,i[e+56>>2]=1058424226,t[e+48|0]=1,A0=u[k+26|0],f0=p[k+24>>1],g3(e+8|0,f0,p[k+20>>1]),f=i[e+44>>2],i[e+80>>2]=i[e+40>>2],i[e+84>>2]=f,f=i[e+36>>2],i[e+72>>2]=i[e+32>>2],i[e+76>>2]=f,k=i[e+28>>2],f=e- -64|0,i[f>>2]=i[e+24>>2],i[f+4>>2]=k,f=i[e+20>>2],i[e+56>>2]=i[e+16>>2],i[e+60>>2]=f,f=i[e+12>>2],i[e+48>>2]=i[e+8>>2],i[e+52>>2]=f,!(!V|!_)){for(M0=_&-4,N=_&3,z0=_&-2,j0=_&1,O=_>>>0<4;;){B=s+g(I,d)|0,m=g(l,I)+V0|0,h=n+g(I,g0)|0,G=g(I,X0)+o|0,f=0;r:{f:{A:switch(f0|0){default:for(;Q=f+B|0,w=D(D(D(u[f+m|0])*E0[e+60>>2])+D(D(D(u[f+h|0])*E0[e+52>>2])+D(E0[e+56>>2]*D(u[f+G|0])))),w=D((A0&1?w:D(D(D(w*D(219))*D(.00390625))+D(16)))+D(.5)),D(B2(w))<D(2147483648)?k=~~w:k=-2147483648,t[Q|0]=(k|0)>=0?k>>>0>=255?255:k:0,f=f+1|0,(_|0)!=(f|0););break r;case 0:if(A0&1){if(k=0,m=0,O)break f;for(;t[f+B|0]=u[f+G|0],h=f|1,t[h+B|0]=u[h+G|0],h=f|2,t[h+B|0]=u[h+G|0],h=f|3,t[h+B|0]=u[h+G|0],f=f+4|0,m=m+4|0,(M0|0)!=(m|0););break f}for(;h=f+B|0,w=D(D(D(D(D(u[f+G|0])*D(219))*D(.00390625))+D(16))+D(.5)),D(B2(w))<D(2147483648)?k=~~w:k=-2147483648,t[h|0]=(k|0)>=0?k>>>0>=255?255:k:0,f=f+1|0,(_|0)!=(f|0););break r;case 8:break A}if(Q=0,(_|0)!=1)for(;t[f+B|0]=(u[f+G|0]>>>1)+(u[f+m|0]+u[f+h|0]>>>2),k=f|1,t[k+B|0]=(u[k+G|0]>>>1)+(u[k+m|0]+u[k+h|0]>>>2),f=f+2|0,Q=Q+2|0,(z0|0)!=(Q|0););if(!j0)break r;t[f+B|0]=(u[f+G|0]>>>1)+(u[f+m|0]+u[f+h|0]>>>2);break r}if(!N)break r;for(;t[f+B|0]=u[f+G|0],f=f+1|0,k=k+1|0,(N|0)!=(k|0););}if(I=I+1|0,(V|0)==(I|0))break}for(d=(j|0)==2,M0=d&(Y|0)==2,z0=(Y|j)>>>0<2,k=0;;){s=g(k,l),B=s+V0|0,I=n+g(k,g0)|0,m=g(k,X0)+o|0,f=(k>>>0)/(j>>>0)|0,h=g(f,f2),G=h+r2|0;r:{f:{A:switch(f0|0){default:for(s=k+1|0,s=d&&s>>>0<V>>>0?s:k,h=g(s,l)+V0|0,N=g(s,X0)+o|0,Q=n+g(s,g0)|0,j0=g(f,S0)+E|0,f=0;w=D(u[f+B|0]),t0=D(u[f+m|0]),_0=D(u[f+I|0]),z0||(s=f+1|0,s=s>>>0<_>>>0&&M0?s:f,w=D(D(D(D(w+D(u[s+B|0]))+D(u[f+h|0]))+D(u[s+h|0]))*D(.25)),_0=D(D(D(D(_0+D(u[s+I|0]))+D(u[f+Q|0]))+D(u[s+Q|0]))*D(.25)),t0=D(D(D(D(t0+D(u[s+m|0]))+D(u[f+N|0]))+D(u[s+N|0]))*D(.25))),A2=E0[e+84>>2],s2=E0[e+76>>2],v2=E0[e+80>>2],O=(f>>>0)/(Y>>>0)|0,Z2=O+G|0,S=D(D(w*E0[e+72>>2])+D(D(_0*E0[e+64>>2])+D(t0*E0[e+68>>2]))),q0=A0&1,S=D(D((q0?S:D(D(S*D(224))*D(.00390625)))+D(128))+D(.5)),D(B2(S))<D(2147483648)?s=~~S:s=-2147483648,t[Z2|0]=(s|0)>=0?s>>>0>=255?255:s:0,O=j0+O|0,w=D(D(w*A2)+D(D(_0*s2)+D(t0*v2))),w=D(D((q0?w:D(D(w*D(224))*D(.00390625)))+D(128))+D(.5)),D(B2(w))<D(2147483648)?s=~~w:s=-2147483648,t[O|0]=(s|0)>=0?s>>>0>=255?255:s:0,f=f+Y|0,_>>>0>f>>>0;);break r;case 0:if(I=n+s|0,m=h+E|0,f=0,A0&1)break f;for(;h=(f>>>0)/(Y>>>0)|0,Q=h+G|0,w=D(D(D(D(D(u[f+B|0])*D(224))*D(.00390625))+D(16))+D(.5)),D(B2(w))<D(2147483648)?s=~~w:s=-2147483648,t[Q|0]=(s|0)>=0?s>>>0>=255?255:s:0,h=h+m|0,w=D(D(D(D(D(u[f+I|0])*D(224))*D(.00390625))+D(16))+D(.5)),D(B2(w))<D(2147483648)?s=~~w:s=-2147483648,t[h|0]=(s|0)>=0?s>>>0>=255?255:s:0,f=f+Y|0,_>>>0>f>>>0;);break r;case 8:break A}for(s=g(f,S0)+E|0,f=0;h=(f>>>0)/(Y>>>0)|0,N=f+B|0,Q=f+I|0,t[h+G|0]=(u[f+m|0]>>>1)-(u[N|0]+u[Q|0]>>>2)^128,t[s+h|0]=(u[Q|0]-u[N|0]|0)/2^128,f=f+Y|0,_>>>0>f>>>0;);break r}for(;s=(f>>>0)/(Y>>>0)|0,t[s+G|0]=u[f+B|0],t[s+m|0]=u[f+I|0],f=f+Y|0,_>>>0>f>>>0;);}if(k=k+j|0,!(V>>>0>k>>>0))break}}r:{if(!q||(r=K0(i[r>>2],6),!V))break r;if(r=_<<(r>>>0>8),f=0,(V|0)!=1)for(n=V&-2,k=0;o=!r,o||z(g(f,r0)+x|0,g(f,c)+C0|0,r),o||(o=f|1,z(g(o,r0)+x|0,g(o,c)+C0|0,r)),f=f+2|0,k=k+2|0,(n|0)!=(k|0););if(!(V&1)|!r)break r;z(g(f,r0)+x|0,g(f,c)+C0|0,r)}t[A+20|0]=0,i[A+4>>2]=U,i[A>>2]=R;break i}if(A=i[U+4>>2],i[U+4>>2]=A-1,A)break i;W[i[i[U>>2]+8>>2]](U),y(U)}v=e+160|0}function Xv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0;k=v-256|0,v=k,S2(k+236|0,e,r),t[k+255|0]<0&&Z(i[k+244>>2]);i:{_=u[e+97|0];e:{if(_>>>0>=3){B1(A,e,19639);break e}n=w2(r);r:{if((_|0)!=2){w=w2(r);break r}w=F0(r)}if(l=i[f+28>>2],!(l>>>0<w>>>0&&l)){r:{f:{A:{if(w)for(S=n&15,_0=(S|0)!=0&(_-1&255)>>>0<2,g0=e+104|0,G=i[19543],Q=G-12|0,q=i[19544],V=q-12|0,d=i[19547],Y=d-12|0,I=i[19545],E=I-12|0,R=i[19552],N=i[19551],X0=k+108|0,V0=k+120|0,U=i[19549],x=i[19548],j=i[19546],c=k+100|0,A0=k+96|0,C0=k+152|0,r0=k+72|0,f0=k+56|6,M0=(n>>>4&15)-4|0,z0=(n>>>12|0)-4|0,j0=(n>>>8&15)-4|0;;){if(t[k+60|0]=0,i[k+56>>2]=0,n=f0,X[n+14>>1]=0,X[n+16>>1]=0,X[n+18>>1]=0,X[n+20>>1]=0,X[n+8>>1]=0,X[n+10>>1]=0,X[n+12>>1]=0,X[n+14>>1]=0,X[n>>1]=0,X[n+2>>1]=0,X[n+4>>1]=0,X[n+6>>1]=0,!i[r+16>>2]){i[k+180>>2]=0,i[k+88>>2]=I,i[k+152>>2]=78164,i[k+96>>2]=78144,e=k+88|0,i[e+i[E>>2]>>2]=j,i[k+92>>2]=0,r=e+i[i[k+88>>2]-12>>2]|0,f=k+100|0,J0(r,f),t[r+80|0]=0,i[r+72>>2]=0,r=k+96|0,i[r+i[Y>>2]>>2]=x,i[e+i[V>>2]>>2]=U,i[k+152>>2]=78164,i[k+88>>2]=78124,i[k+96>>2]=78144,f=R0(f),i[f>>2]=77200,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,F(B0(F(B0(F(r,31745,24),w),32657,29),O),25807,7),e=i[k+148>>2];k:{if(e&16){l=k+120|0,r=i[k+144>>2],e=i[k+124>>2],r>>>0<e>>>0?i[k+144>>2]=e:e=r;break k}if(!(e&8)){r=0,t[k+27|0]=0,l=k+16|0;break f}l=k+108|0,e=i[k+116>>2]}if(r=e,e=i[l>>2],r=r-e|0,r>>>0>=2147483640)break i;if(r>>>0>=11){n=r|7,l=C(n+1|0),i[k+24>>2]=n-2147483647,i[k+16>>2]=l,i[k+20>>2]=r;break A}if(t[k+27|0]=r,l=k+16|0,r)break A;r=0;break f}k:{n:{if((_|0)==2){S0=k,q0=F0(r),i[S0+56>>2]=q0;break n}if(S0=k,q0=w2(r),i[S0+56>>2]=q0,!_)break k}S0=k,q0=w2(r)&15,t[S0+60|0]=q0}n=w2(r),i[k+64>>2]=0,i[k+68>>2]=0,X[k+62>>1]=n;k:{n:{t:switch(M0|0){case 0:n=F0(r),l=0;break n;case 4:break t;default:break k}n=F0(r),i[k+64>>2]=0,i[k+68>>2]=n,n=F0(r)|i[k+64>>2],l=i[k+68>>2]}i[k+64>>2]=n,i[k+68>>2]=l}B=w2(r);k:{n:{t:{o:{if(n=i[f+52>>2],!(n>>>0<B>>>0&&n)){if(l=0,B)break o;break k}i[k+180>>2]=0,i[k+88>>2]=I,i[k+152>>2]=78164,i[k+96>>2]=78144,e=k+88|0,i[e+i[E>>2]>>2]=j,i[k+92>>2]=0,r=e+i[i[k+88>>2]-12>>2]|0,f=k+100|0,J0(r,f),t[r+80|0]=0,i[r+72>>2]=0,r=k+96|0,i[r+i[Y>>2]>>2]=x,i[e+i[V>>2]>>2]=U,i[k+152>>2]=78164,i[k+88>>2]=78124,i[k+96>>2]=78144,f=R0(f),i[f>>2]=77200,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,F(B0(F(B0(F(r,30327,31),B),30359,26),n),47877,2),e=i[k+148>>2];l:{if(e&16){n=k+120|0,r=i[k+144>>2],e=i[k+124>>2],r>>>0<e>>>0?i[k+144>>2]=e:e=r;break l}if(!(e&8)){r=0,t[k+27|0]=0,n=k+16|0;break n}n=k+108|0,e=i[k+116>>2]}if(r=e,e=i[n>>2],r=r-e|0,r>>>0>=2147483640)break i;if(r>>>0>=11){l=r|7,n=C(l+1|0),i[k+24>>2]=l-2147483647,i[k+16>>2]=n,i[k+20>>2]=r;break t}if(t[k+27|0]=r,n=k+16|0,r)break t;r=0;break n}for(;;){i[k+48>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;o:{l:{u:{s:{h:{if(t0=i[r+16>>2],!t0){i[k+180>>2]=0,i[k+88>>2]=I,i[k+152>>2]=78164,i[k+96>>2]=78144,n=k+88|0,i[n+i[E>>2]>>2]=j,i[k+92>>2]=0,o=n+i[i[k+88>>2]-12>>2]|0,J0(o,c),t[o+80|0]=0,i[o+72>>2]=0,i[k+96>>2]=d,i[i[Y>>2]+A0>>2]=x,i[k+88>>2]=q,i[n+i[V>>2]>>2]=U,i[k+152>>2]=78164,i[k+88>>2]=78124,i[k+96>>2]=78144,h=R0(c),i[h>>2]=77200,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,F(D0(F(B0(F(A0,31770,25),B),32625,31),l),25670,9),n=i[k+148>>2];w:{if(n&16){if(n=V0,o=i[k+144>>2],s=i[k+124>>2],o>>>0>=s>>>0)break w;i[k+144>>2]=s,o=s;break w}if(!(n&8)){n=0,t[k+15|0]=0,o=k+4|0;break l}o=i[k+116>>2],n=X0}if(s=i[n>>2],n=o-s|0,n>>>0>=2147483640)break h;if(n>>>0>=11){m=n|7,o=C(m+1|0),i[k+12>>2]=m-2147483647,i[k+4>>2]=o,i[k+8>>2]=n;break u}if(t[k+15|0]=n,o=k+4|0,n)break u;n=0;break l}w:{if(!_0)break w;_:{v:switch(S-4|0){case 0:n=F0(r),o=0;break _;case 4:break v;default:break w}n=F0(r),i[k+16>>2]=0,i[k+20>>2]=n,n=F0(r)|i[k+16>>2],o=i[k+20>>2]}i[k+16>>2]=n,i[k+20>>2]=o}i[k+24>>2]=0,i[k+28>>2]=0;w:{_:{v:switch(z0|0){case 0:n=F0(r),o=0;break _;case 4:break v;default:break w}n=F0(r),i[k+24>>2]=0,i[k+28>>2]=n,n=F0(r)|i[k+24>>2],o=i[k+28>>2]}i[k+24>>2]=n,i[k+28>>2]=o}i[k+32>>2]=0,i[k+36>>2]=0;w:{_:{v:switch(j0|0){case 0:n=F0(r),o=0;break _;case 4:break v;default:break w}n=F0(r),i[k+32>>2]=0,i[k+36>>2]=n,n=F0(r)|i[k+32>>2],o=i[k+36>>2]}i[k+32>>2]=n,i[k+36>>2]=o}n=i[k+76>>2];w:{if(n>>>0<o0[k+80>>2]){if(o=i[k+20>>2],i[n>>2]=i[k+16>>2],i[n+4>>2]=o,o=i[k+36>>2],i[n+16>>2]=i[k+32>>2],i[n+20>>2]=o,o=i[k+28>>2],i[n+8>>2]=i[k+24>>2],i[n+12>>2]=o,i[n+32>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,o=i[k+44>>2],h=i[k+40>>2],(o|0)!=(h|0)){if(o=o-h|0,(o|0)<0)break s;s=C(o),i[n+28>>2]=s,i[n+24>>2]=s,m=o+s|0,i[n+32>>2]=m,o&&z(s,h,o),i[n+28>>2]=m}o=n+40|0;break w}o=ye(r0,k+16|0)}i[k+76>>2]=o;break o}I0(),M()}s0(),M()}if(!n)break l;z(o,s,n)}t[n+o|0]=0,a(A,2,100,k+4|0),t[k+15|0]<0&&Z(i[k+4>>2]),i[k+88>>2]=G,i[i[Q>>2]+(k+88|0)>>2]=N,i[k+96>>2]=R,i[h>>2]=77200,t[k+143|0]<0&&Z(i[k+132>>2]),y0(h),Y0(C0)}if(n=i[k+40>>2],n&&(i[k+44>>2]=n,Z(n)),!t0)break r;if(l=l+1|0,(B|0)==(l|0))break}break k}if(!r)break n;z(n,e,r)}t[r+n|0]=0,a(A,6,1e3,k+16|0),t[k+27|0]<0&&Z(i[k+16>>2]),i[k+88>>2]=G,i[i[Q>>2]+(k+88|0)>>2]=N,i[k+96>>2]=R,i[f>>2]=77200,t[k+143|0]<0&&Z(i[k+132>>2]),y0(f),Y0(k+152|0);break r}if(!u[r+20|0]){n=i[e+108>>2];k:{if(n>>>0<o0[e+112>>2]){l=i[k+60>>2],i[n>>2]=i[k+56>>2],i[n+4>>2]=l,l=k- -64|0,o=i[l+4>>2],i[n+8>>2]=i[l>>2],i[n+12>>2]=o,i[n+24>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,l=i[k+72>>2],o=i[k+76>>2],b6(n+16|0,l,o,(o-l|0)/40|0),o=n+32|0;break k}o=Vi(g0,k+56|0)}i[e+108>>2]=o}if(o=i[k+72>>2],o){if(n=i[k+76>>2],l=o,(n|0)!=(o|0)){for(;l=i[n-16>>2],l&&(i[n-12>>2]=l,Z(l)),n=n-40|0,(o|0)!=(n|0););l=i[k+72>>2]}i[k+76>>2]=o,Z(l)}if(O=O+1|0,(O|0)==(w|0))break}if(u[r+20|0]==1){if(t[k+88|0]=0,t[k+99|0]=0,a(A,2,100,k+88|0),t[k+99|0]>=0)break e;Z(i[k+88>>2]);break e}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731]);break e}if(!r)break f;z(l,e,r)}t[r+l|0]=0,a(A,2,100,k+16|0),t[k+27|0]<0&&Z(i[k+16>>2]),i[k+88>>2]=G,i[i[Q>>2]+(k+88|0)>>2]=N,i[k+96>>2]=R,i[f>>2]=77200,t[k+143|0]<0&&Z(i[k+132>>2]),y0(f),Y0(k+152|0)}if(A=i[k+72>>2],!A)break e;if(r=i[k+76>>2],n=A,(r|0)!=(n|0)){for(;e=i[r-16>>2],e&&(i[r-12>>2]=e,Z(e)),r=r-40|0,(A|0)!=(r|0););n=i[k+72>>2]}i[k+76>>2]=A,Z(n);break e}i[k+180>>2]=0,i[k+152>>2]=78164,i[k+96>>2]=78144,e=i[19545],i[k+88>>2]=e,e=i[e-12>>2],r=k+88|0,i[e+r>>2]=i[19546],i[k+92>>2]=0,e=r+i[i[k+88>>2]-12>>2]|0,n=k+100|0,J0(e,n),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[k+96>>2]=e,o=i[e-12>>2],e=k+96|0,i[o+e>>2]=i[19548],l=i[19544],i[k+88>>2]=l,i[r+i[l-12>>2]>>2]=i[19549],i[k+152>>2]=78164,i[k+88>>2]=78124,i[k+96>>2]=78144,n=R0(n),i[n>>2]=77200,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,F(B0(F(B0(F(e,31012,18),w),32067,44),i[f+28>>2]),25807,7),e=i[k+148>>2];r:{f:{if(e&16){l=k+120|0,r=i[k+144>>2],e=i[k+124>>2],r>>>0<e>>>0?i[k+144>>2]=e:e=r;break f}if(!(e&8)){r=0,t[k+27|0]=0,l=k+16|0;break r}l=k+108|0,e=i[k+116>>2]}f:{if(r=e,e=i[l>>2],r=r-e|0,r>>>0<2147483640){if(r>>>0>=11){f=r|7,l=C(f+1|0),i[k+24>>2]=f-2147483647,i[k+16>>2]=l,i[k+20>>2]=r;break f}if(t[k+27|0]=r,l=k+16|0,r)break f;r=0;break r}break i}if(!r)break r;z(l,e,r)}t[r+l|0]=0,a(A,6,1e3,k+16|0),t[k+27|0]<0&&Z(i[k+16>>2]),A=i[19543],i[k+88>>2]=A,i[i[A-12>>2]+(k+88|0)>>2]=i[19551],i[k+96>>2]=i[19552],i[n>>2]=77200,t[k+143|0]<0&&Z(i[k+132>>2]),y0(n),Y0(k+152|0)}v=k+256|0;return}I0(),M()}function U9(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;i:{e:{r:for(;;){Q=e-4|0,V=e-20|0,G=e-24|0,Y=e-12|0,I=e-16|0,B=e-8|0;f:for(;;){E=f&1;A:{for(;;){k:{n:{t:{o:{l:{u:switch(k=A,o=e-k>>3,o|0){case 0:case 1:break A;case 2:break u;case 3:break l;case 4:break n;case 5:break o;default:break t}if(i[e-4>>2]<=i[k+4>>2])break A;n=i[k>>2],_=i[k+4>>2],A=e-8|0,e=i[A+4>>2],i[k>>2]=i[A>>2],i[k+4>>2]=e;break e}if(A=e-8|0,f=e-4|0,r=i[f>>2],e=i[k+12>>2],(e|0)<=i[k+4>>2]){if((e|0)>=(r|0)||(f=i[k+8>>2],r=i[k+12>>2],e=i[A+4>>2],i[k+8>>2]=i[A>>2],i[k+12>>2]=e,i[A>>2]=f,i[A+4>>2]=r,i[k+12>>2]<=i[k+4>>2]))break A;n=i[k+8>>2],_=i[k+12>>2];break i}if(n=i[k>>2],_=i[k+4>>2],(e|0)<(r|0)){e=i[A+4>>2],i[k>>2]=i[A>>2],i[k+4>>2]=e;break e}if(r=i[k+8>>2],e=i[k+12>>2],i[k+8>>2]=n,i[k+12>>2]=_,i[k>>2]=r,i[k+4>>2]=e,(_|0)>=i[f>>2])break A;e=i[A+4>>2],i[k+8>>2]=i[A>>2],i[k+12>>2]=e;break e}if(w3(k,k+8|0,k+16|0,k+24|0),i[e-4>>2]<=i[k+28>>2]||(f=i[k+24>>2],r=i[k+28>>2],e=e-8|0,A=i[e+4>>2],i[k+24>>2]=i[e>>2],i[k+28>>2]=A,i[e>>2]=f,i[e+4>>2]=r,i[k+28>>2]<=i[k+20>>2])||(n=i[k+24>>2],_=i[k+28>>2],A=i[k+20>>2],i[k+24>>2]=i[k+16>>2],i[k+28>>2]=A,i[k+16>>2]=n,i[k+20>>2]=_,(_|0)<=i[k+12>>2])||(A=i[k+12>>2],i[k+16>>2]=i[k+8>>2],i[k+20>>2]=A,i[k+8>>2]=n,i[k+12>>2]=_,(_|0)<=i[k+4>>2]))break A;break i}if((o|0)<=23){if(A=k+8|0,r=(e|0)==(k|0)|(e|0)==(A|0),f&1){if(r)break A;for(s=k;;){if(r=A,i[s+12>>2]>i[s+4>>2]){for(n=i[A>>2],f=i[A+4>>2],o=A;;){t:{if(A=s,h=i[A+4>>2],i[o>>2]=i[A>>2],i[o+4>>2]=h,(A|0)==(k|0)){A=k;break t}if(s=A-8|0,o=A,(f|0)>i[A-4>>2])continue}break}i[A>>2]=n,i[A+4>>2]=f}if(s=r,A=s+8|0,(e|0)==(A|0))break}break A}if(r)break A;for(;;){if(i[k+12>>2]>i[k+4>>2]){for(f=i[A>>2],r=i[A+4>>2],s=A;n=s,s=k,o=i[k+4>>2],i[n>>2]=i[k>>2],i[n+4>>2]=o,k=k-8|0,(r|0)>i[s-4>>2];);i[s>>2]=f,i[s+4>>2]=r}if(k=A,A=k+8|0,(e|0)==(A|0))break}break A}if(!r){if((e|0)==(k|0))break A;for(w=o-2>>>1|0,A=w;;){_=A;t:{if(A>>>0>w>>>0||(h=(A<<3)+k|0,r=A<<1,s=r|1,A=(s<<3)+k|0,r=r+2|0,(r|0)<(o|0)&&(f=r,r=i[A+4>>2]>i[A+12>>2],s=r?f:s,A=(r?8:0)+A|0),i[A+4>>2]>i[h+4>>2]))break t;for(f=i[h>>2],r=i[h+4>>2];;){o:{if(n=h,h=A,m=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=m,(s|0)>(w|0))break o;if(n=s<<1,s=n|1,A=(s<<3)+k|0,n=n+2|0,(n|0)<(o|0)&&(m=n,n=i[A+4>>2]>i[A+12>>2],s=n?m:s,A=(n?8:0)+A|0),(r|0)>=i[A+4>>2])continue}break}i[h>>2]=f,i[h+4>>2]=r}if(A=_-1|0,!((_|0)>0))break}for(;;){for(h=o,_=o-2>>>1|0,f=i[k>>2],m=i[k+4>>2],s=0,o=k;;){n=s<<1,r=n|1,w=(s<<3)+o|0,A=w+8|0,n=n+2|0;t:{if((n|0)>=(h|0)){s=r;break t}s=r,r=i[w+12>>2]>i[w+20>>2],s=r?n:s,A=r?w+16|0:A}if(r=i[A+4>>2],i[o>>2]=i[A>>2],i[o+4>>2]=r,o=A,!((s|0)<=(_|0)))break}e=e-8|0;t:{if((A|0)==(e|0)){i[A>>2]=f,i[A+4>>2]=m;break t}if(r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[e>>2]=f,i[e+4>>2]=m,r=(A-k|0)+8>>3,(r|0)<2||(s=r-2>>>1|0,o=(s<<3)+k|0,i[o+4>>2]<=i[A+4>>2]))break t;for(n=i[A>>2],f=i[A+4>>2];;){o:{if(r=A,A=o,o=i[A+4>>2],i[r>>2]=i[A>>2],i[r+4>>2]=o,!s)break o;if(s=s-1>>>1|0,o=(s<<3)+k|0,(f|0)<i[o+4>>2])continue}break}i[A>>2]=n,i[A+4>>2]=f}if(o=h-1|0,!((h|0)>2))break}break A}l=(o<<2&-8)+k|0,h=i[Q>>2];t:{if(o>>>0>=129){n=i[l+4>>2];o:{if((n|0)<=i[k+4>>2]){if((n|0)>=(h|0)||(o=i[l>>2],n=i[l+4>>2],A=i[B+4>>2],i[l>>2]=i[B>>2],i[l+4>>2]=A,i[B>>2]=o,i[B+4>>2]=n,i[l+4>>2]<=i[k+4>>2]))break o;o=i[k>>2],n=i[k+4>>2],A=i[l+4>>2],i[k>>2]=i[l>>2],i[k+4>>2]=A,i[l>>2]=o,i[l+4>>2]=n;break o}A=i[k>>2],o=i[k+4>>2];l:{if((n|0)<(h|0)){n=i[B+4>>2],i[k>>2]=i[B>>2],i[k+4>>2]=n;break l}if(n=i[l+4>>2],i[k>>2]=i[l>>2],i[k+4>>2]=n,i[l>>2]=A,i[l+4>>2]=o,(o|0)>=i[Q>>2])break o;n=i[B+4>>2],i[l>>2]=i[B>>2],i[l+4>>2]=n}i[B>>2]=A,i[B+4>>2]=o}w=l-8|0,o=i[Y>>2],h=l-4|0,n=i[h>>2];o:{if((n|0)<=i[k+12>>2]){if((n|0)>=(o|0)||(o=i[w>>2],n=i[w+4>>2],A=i[I+4>>2],i[w>>2]=i[I>>2],i[w+4>>2]=A,i[I>>2]=o,i[I+4>>2]=n,i[h>>2]<=i[k+12>>2]))break o;o=i[k+8>>2],n=i[k+12>>2],A=i[w+4>>2],i[k+8>>2]=i[w>>2],i[k+12>>2]=A,i[w>>2]=o,i[w+4>>2]=n;break o}A=i[k+8>>2],s=i[k+12>>2];l:{if((n|0)<(o|0)){n=i[I+4>>2],i[k+8>>2]=i[I>>2],i[k+12>>2]=n;break l}if(n=i[w+4>>2],i[k+8>>2]=i[w>>2],i[k+12>>2]=n,i[w>>2]=A,i[w+4>>2]=s,(s|0)>=i[Y>>2])break o;n=i[I+4>>2],i[w>>2]=i[I>>2],i[w+4>>2]=n}i[I>>2]=A,i[I+4>>2]=s}o=i[V>>2],n=i[l+12>>2];o:{if((n|0)<=i[k+20>>2]){if((n|0)>=(o|0)||(o=i[l+8>>2],n=i[l+12>>2],A=i[G+4>>2],i[l+8>>2]=i[G>>2],i[l+12>>2]=A,i[G>>2]=o,i[G+4>>2]=n,i[l+12>>2]<=i[k+20>>2]))break o;o=i[k+16>>2],n=i[k+20>>2],A=i[l+12>>2],i[k+16>>2]=i[l+8>>2],i[k+20>>2]=A,i[l+8>>2]=o,i[l+12>>2]=n;break o}A=i[k+16>>2],s=i[k+20>>2];l:{if((n|0)<(o|0)){n=i[G+4>>2],i[k+16>>2]=i[G>>2],i[k+20>>2]=n;break l}if(n=i[l+12>>2],i[k+16>>2]=i[l+8>>2],i[k+20>>2]=n,i[l+8>>2]=A,i[l+12>>2]=s,(s|0)>=i[V>>2])break o;n=i[G+4>>2],i[l+8>>2]=i[G>>2],i[l+12>>2]=n}i[G>>2]=A,i[G+4>>2]=s}m=i[l+12>>2],s=i[l+4>>2],h=i[h>>2];o:{l:{if((s|0)<=(h|0)){if(n=i[l>>2],_=i[l+4>>2],(s|0)>=(m|0))break o;if(A=i[l+8>>2],o=i[l+12>>2],i[l+8>>2]=n,i[l+12>>2]=_,i[l>>2]=A,i[l+4>>2]=o,(o|0)<=(h|0)){n=A,_=o;break o}n=i[w>>2],_=i[w+4>>2],i[w>>2]=A,i[w+4>>2]=o;break l}if(A=i[w>>2],o=i[w+4>>2],(s|0)<(m|0)){n=i[l+12>>2],i[w>>2]=i[l+8>>2],i[w+4>>2]=n,i[l+8>>2]=A,i[l+12>>2]=o,n=i[l>>2],_=i[l+4>>2];break o}if(n=i[l+4>>2],i[w>>2]=i[l>>2],i[w+4>>2]=n,i[l>>2]=A,i[l+4>>2]=o,(o|0)>=(m|0)){n=A,_=o;break o}n=i[l+8>>2],_=i[l+12>>2],i[l+8>>2]=A,i[l+12>>2]=o}i[l>>2]=n,i[l+4>>2]=_}o=i[k>>2],A=i[k+4>>2],i[k>>2]=n,i[k+4>>2]=_,i[l>>2]=o,i[l+4>>2]=A;break t}if(n=i[k+4>>2],(n|0)<=i[l+4>>2]){if((n|0)>=(h|0)||(o=i[k>>2],n=i[k+4>>2],A=i[B+4>>2],i[k>>2]=i[B>>2],i[k+4>>2]=A,i[B>>2]=o,i[B+4>>2]=n,i[k+4>>2]<=i[l+4>>2]))break t;o=i[l>>2],n=i[l+4>>2],A=i[k+4>>2],i[l>>2]=i[k>>2],i[l+4>>2]=A,i[k>>2]=o,i[k+4>>2]=n;break t}A=i[l>>2],o=i[l+4>>2];o:{if((n|0)<(h|0)){n=i[B+4>>2],i[l>>2]=i[B>>2],i[l+4>>2]=n;break o}if(n=i[k+4>>2],i[l>>2]=i[k>>2],i[l+4>>2]=n,i[k>>2]=A,i[k+4>>2]=o,(o|0)>=i[Q>>2])break t;n=i[B+4>>2],i[k>>2]=i[B>>2],i[k+4>>2]=n}i[B>>2]=A,i[B+4>>2]=o}if(r=r-1|0,E){n=i[k>>2],_=i[k+4>>2];break k}if(n=i[k>>2],A=i[k+4>>2],_=A,i[k-4>>2]>i[k+4>>2])break k;o=k,h=k,s=A;t:{if((A|0)>i[Q>>2]){for(;;)if(f=o,A=o+8|0,o=A,!((s|0)<=i[f+12>>2]))break t}for(;;){if(A=h+8|0,e>>>0<=A>>>0)break t;if(f=h,h=A,!((s|0)<=i[f+12>>2]))break}}if(h=e,h>>>0>A>>>0)for(;f=h-4|0,h=h-8|0,(s|0)>i[f>>2];);if(A>>>0<h>>>0)for(;;){for(m=i[A>>2],o=i[A+4>>2],f=i[h+4>>2],i[A>>2]=i[h>>2],i[A+4>>2]=f,i[h>>2]=m,i[h+4>>2]=o;o=A,f=A+8|0,A=f,(s|0)<=i[o+12>>2];);for(A=h;o=A-4|0,h=A-8|0,A=h,(s|0)>i[o>>2];);if(A=f,!(h>>>0>A>>>0))break}o=A-8|0,(o|0)!=(k|0)&&(f=i[o+4>>2],i[k>>2]=i[o>>2],i[k+4>>2]=f),i[o>>2]=n,i[o+4>>2]=_,f=0;continue f}w3(k,k+8|0,k+16|0,e-8|0);break A}for(o=k;s=o,o=o+8|0,i[s+12>>2]>(_|0););h=e,A=h;k:{if((k|0)==(s|0))for(;;){if(o>>>0>=h>>>0){m=h;break k}if(A=h-4|0,m=h-8|0,h=m,!(i[A>>2]<=(_|0)))break k}for(;h=A-4|0,m=A-8|0,A=m,i[h>>2]<=(_|0););}if(A=m,h=o,A>>>0>o>>>0)for(;;){for(l=i[h>>2],w=i[h+4>>2],s=i[A+4>>2],i[h>>2]=i[A>>2],i[h+4>>2]=s,i[A>>2]=l,i[A+4>>2]=w;s=h,h=s+8|0,i[s+12>>2]>(_|0););for(;w=A-4|0,A=A-8|0,i[w>>2]<=(_|0););if(!(A>>>0>h>>>0))break}if((k|0)!=(s|0)&&(A=i[s+4>>2],i[k>>2]=i[s>>2],i[k+4>>2]=A),i[s>>2]=n,i[s+4>>2]=_,o>>>0>=m>>>0){if(n=Nn(k,s),A=s+8|0,Nn(A,e)){if(e=s,A=k,!n)continue r;break A}if(n)continue}break}U9(k,s,r,E),A=s+8|0,f=0;continue}break}break}return}i[A>>2]=n,i[A+4>>2]=_;return}A=i[k+4>>2],i[k+8>>2]=i[k>>2],i[k+12>>2]=A,i[k>>2]=n,i[k+4>>2]=_}function Iv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0;for(n=v-240|0,v=n,X0=e+100|0,B=A+8|0,Y=i[19543],R=Y-12|0,N=i[19544]-12|0,U=i[19547]-12|0,E=i[19545],x=E-12|0,j=n+48|0,O=n+60|0,I=n+40|0,Q=n+36|0,S=n+92|0,q=i[19552],d=i[19551],c=i[19549],A0=i[19548],t0=i[19546];;){i:{e:{r:{f:{A:{k:{n:{t:{o:{l:{u:{s:{if(i[r+16>>2]){if(_0=n+200|0,k=_0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=92500,Wi(n+176|0,k,r),i[n+176>>2]!=i[28728]){k=i[n+180>>2],i[A>>2]=i[n+176>>2],i[A+4>>2]=k,i[B+8>>2]=i[n+192>>2],k=i[n+188>>2],i[B>>2]=i[n+184>>2],i[B+4>>2]=k,i[n+184>>2]=0,i[n+188>>2]=0,k=0,i[n+192>>2]=0;break e}if(_=i[n+212>>2],k=i[n+208>>2],s=i[n+232>>2],!_&k>>>0<s>>>0){k=C(40),i[n+28>>2]=k,i[n+32>>2]=38,i[n+36>>2]=-2147483608,o=u[29554]|u[29555]<<8|(u[29556]<<16|u[29557]<<24),l=u[29550]|u[29551]<<8|(u[29552]<<16|u[29553]<<24),t[k|0]=l,t[k+1|0]=l>>>8,t[k+2|0]=l>>>16,t[k+3|0]=l>>>24,t[k+4|0]=o,t[k+5|0]=o>>>8,t[k+6|0]=o>>>16,t[k+7|0]=o>>>24,t[k+38|0]=0,o=u[29584]|u[29585]<<8|(u[29586]<<16|u[29587]<<24),l=u[29580]|u[29581]<<8|(u[29582]<<16|u[29583]<<24),t[k+30|0]=l,t[k+31|0]=l>>>8,t[k+32|0]=l>>>16,t[k+33|0]=l>>>24,t[k+34|0]=o,t[k+35|0]=o>>>8,t[k+36|0]=o>>>16,t[k+37|0]=o>>>24,o=u[29578]|u[29579]<<8|(u[29580]<<16|u[29581]<<24),l=u[29574]|u[29575]<<8|(u[29576]<<16|u[29577]<<24),t[k+24|0]=l,t[k+25|0]=l>>>8,t[k+26|0]=l>>>16,t[k+27|0]=l>>>24,t[k+28|0]=o,t[k+29|0]=o>>>8,t[k+30|0]=o>>>16,t[k+31|0]=o>>>24,o=u[29570]|u[29571]<<8|(u[29572]<<16|u[29573]<<24),l=u[29566]|u[29567]<<8|(u[29568]<<16|u[29569]<<24),t[k+16|0]=l,t[k+17|0]=l>>>8,t[k+18|0]=l>>>16,t[k+19|0]=l>>>24,t[k+20|0]=o,t[k+21|0]=o>>>8,t[k+22|0]=o>>>16,t[k+23|0]=o>>>24,o=u[29562]|u[29563]<<8|(u[29564]<<16|u[29565]<<24),l=u[29558]|u[29559]<<8|(u[29560]<<16|u[29561]<<24),t[k+8|0]=l,t[k+9|0]=l>>>8,t[k+10|0]=l>>>16,t[k+11|0]=l>>>24,t[k+12|0]=o,t[k+13|0]=o>>>8,t[k+14|0]=o>>>16,t[k+15|0]=o>>>24,a(A,2,0,n+28|0),t[n+39|0]<0&&Z(i[n+28>>2]),k=0;break e}if(o=k-s|0,l=o,h=_-(k>>>0<s>>>0)|0,!(!(o&3)&(!h&o>>>0>=4|(h|0)!=0))){k=C(72),i[n+28>>2]=k,i[n+32>>2]=64,i[n+36>>2]=-2147483576,o=u[27534]|u[27535]<<8|(u[27536]<<16|u[27537]<<24),l=u[27530]|u[27531]<<8|(u[27532]<<16|u[27533]<<24),t[k|0]=l,t[k+1|0]=l>>>8,t[k+2|0]=l>>>16,t[k+3|0]=l>>>24,t[k+4|0]=o,t[k+5|0]=o>>>8,t[k+6|0]=o>>>16,t[k+7|0]=o>>>24,t[k+64|0]=0,o=u[27590]|u[27591]<<8|(u[27592]<<16|u[27593]<<24),l=u[27586]|u[27587]<<8|(u[27588]<<16|u[27589]<<24),t[k+56|0]=l,t[k+57|0]=l>>>8,t[k+58|0]=l>>>16,t[k+59|0]=l>>>24,t[k+60|0]=o,t[k+61|0]=o>>>8,t[k+62|0]=o>>>16,t[k+63|0]=o>>>24,o=u[27582]|u[27583]<<8|(u[27584]<<16|u[27585]<<24),l=u[27578]|u[27579]<<8|(u[27580]<<16|u[27581]<<24),t[k+48|0]=l,t[k+49|0]=l>>>8,t[k+50|0]=l>>>16,t[k+51|0]=l>>>24,t[k+52|0]=o,t[k+53|0]=o>>>8,t[k+54|0]=o>>>16,t[k+55|0]=o>>>24,o=u[27574]|u[27575]<<8|(u[27576]<<16|u[27577]<<24),l=u[27570]|u[27571]<<8|(u[27572]<<16|u[27573]<<24),t[k+40|0]=l,t[k+41|0]=l>>>8,t[k+42|0]=l>>>16,t[k+43|0]=l>>>24,t[k+44|0]=o,t[k+45|0]=o>>>8,t[k+46|0]=o>>>16,t[k+47|0]=o>>>24,o=u[27566]|u[27567]<<8|(u[27568]<<16|u[27569]<<24),l=u[27562]|u[27563]<<8|(u[27564]<<16|u[27565]<<24),t[k+32|0]=l,t[k+33|0]=l>>>8,t[k+34|0]=l>>>16,t[k+35|0]=l>>>24,t[k+36|0]=o,t[k+37|0]=o>>>8,t[k+38|0]=o>>>16,t[k+39|0]=o>>>24,o=u[27558]|u[27559]<<8|(u[27560]<<16|u[27561]<<24),l=u[27554]|u[27555]<<8|(u[27556]<<16|u[27557]<<24),t[k+24|0]=l,t[k+25|0]=l>>>8,t[k+26|0]=l>>>16,t[k+27|0]=l>>>24,t[k+28|0]=o,t[k+29|0]=o>>>8,t[k+30|0]=o>>>16,t[k+31|0]=o>>>24,o=u[27550]|u[27551]<<8|(u[27552]<<16|u[27553]<<24),l=u[27546]|u[27547]<<8|(u[27548]<<16|u[27549]<<24),t[k+16|0]=l,t[k+17|0]=l>>>8,t[k+18|0]=l>>>16,t[k+19|0]=l>>>24,t[k+20|0]=o,t[k+21|0]=o>>>8,t[k+22|0]=o>>>16,t[k+23|0]=o>>>24,o=u[27542]|u[27543]<<8|(u[27544]<<16|u[27545]<<24),l=u[27538]|u[27539]<<8|(u[27540]<<16|u[27541]<<24),t[k+8|0]=l,t[k+9|0]=l>>>8,t[k+10|0]=l>>>16,t[k+11|0]=l>>>24,t[k+12|0]=o,t[k+13|0]=o>>>8,t[k+14|0]=o>>>16,t[k+15|0]=o>>>24,a(A,2,0,n+28|0),t[n+39|0]<0&&Z(i[n+28>>2]),k=0;break e}if(o=h,h=o>>>2|0,V=(o&3)<<30|l>>>2,o=i[f+28>>2],l=h,!(!o|!l&o>>>0>=V>>>0)){i[n+120>>2]=0,i[n+28>>2]=E,i[n+92>>2]=78164,i[n+36>>2]=78144,k=n+28|0,i[k+i[x>>2]>>2]=t0,i[n+32>>2]=0,o=k+i[i[n+28>>2]-12>>2]|0,J0(o,I),t[o+80|0]=0,i[o+72>>2]=0,i[i[U>>2]+Q>>2]=A0,i[k+i[N>>2]>>2]=c,i[n+92>>2]=78164,i[n+28>>2]=78124,i[n+36>>2]=78144,s=R0(I),i[s>>2]=77200,i[n+80>>2]=0,i[n+84>>2]=0,i[n+72>>2]=0,i[n+76>>2]=0,i[n+88>>2]=24,F(B0(F(M2(F(Q,30257,34),V,l),32153,33),i[f+28>>2]),26474,12),k=i[n+88>>2];h:{if(k&16){if(k=O,o=i[n+84>>2],l=i[n+64>>2],o>>>0>=l>>>0)break h;i[n+84>>2]=l,o=l;break h}if(!(k&8)){k=0,t[n+23|0]=0,o=n+12|0;break r}o=i[n+56>>2],k=j}if(l=i[k>>2],k=o-l|0,k>>>0>=2147483640)break s;if(k>>>0>=11){h=k|7,o=C(h+1|0),i[n+20>>2]=h-2147483647,i[n+12>>2]=o,i[n+16>>2]=k;break f}if(t[n+23|0]=k,o=n+12|0,k)break f;k=0;break r}if(i[n+24>>2]=0,h=0,o=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+12>>2]=i[n+216>>2],(k|0)!=(s|0)|_)for(;;){if(!i[r+16>>2]){i[n+120>>2]=0,i[n+28>>2]=E,i[n+92>>2]=78164,i[n+36>>2]=78144,k=n+28|0,i[k+i[x>>2]>>2]=t0,i[n+32>>2]=0,s=k+i[i[n+28>>2]-12>>2]|0,J0(s,I),t[s+80|0]=0,i[s+72>>2]=0,i[i[U>>2]+Q>>2]=A0,i[k+i[N>>2]>>2]=c,i[n+92>>2]=78164,i[n+28>>2]=78124,i[n+36>>2]=78144,s=R0(I),i[s>>2]=77200,i[n+80>>2]=0,i[n+84>>2]=0,i[n+72>>2]=0,i[n+76>>2]=0,i[n+88>>2]=24,F(M2(F(M2(F(Q,31695,24),V,l),32752,34),h,o),26474,12),k=i[n+88>>2];h:{if(k&16){if(k=O,o=i[n+84>>2],l=i[n+64>>2],o>>>0>=l>>>0)break h;i[n+84>>2]=l,o=l;break h}if(!(k&8)){k=0,t[n+11|0]=0,o=n;break k}o=i[n+56>>2],k=j}if(l=i[k>>2],k=o-l|0,k>>>0>=2147483640)break u;if(k>>>0>=11){h=k|7,o=C(h+1|0),i[n+8>>2]=h-2147483647,i[n>>2]=o,i[n+4>>2]=k;break n}if(t[n+11|0]=k,o=n,k)break n;k=0;break k}G=F0(r),k=i[n+20>>2],w=i[n+24>>2];h:{if(k>>>0<w>>>0){i[k>>2]=G,k=k+4|0;break h}if(_=i[n+16>>2],k=k-_|0,g0=k>>2,s=g0+1|0,s>>>0>=1073741824)break l;if(w=w-_|0,m=w>>1,w=w>>>0>=2147483644?1073741823:s>>>0<m>>>0?m:s,w){if(w>>>0>=1073741824)break o;s=C(w<<2)}else s=0;if(m=s+k|0,i[m>>2]=G,G=m-(g0<<2)|0,k&&z(G,_,k),i[n+24>>2]=s+(w<<2),k=m+4|0,i[n+20>>2]=k,i[n+16>>2]=G,!_)break h;Z(_)}if(i[n+20>>2]=k,h=h+1|0,o=h?o:o+1|0,!((h|0)!=(V|0)|(o|0)!=(l|0)))break}k=i[e+104>>2];h:{if(k>>>0<o0[e+108>>2]){if(o=i[n+12>>2],i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=o,o=i[n+20>>2],s=i[n+16>>2],(o|0)!=(s|0)){if(o=o-s|0,(o|0)<0)break t;l=C(o),i[k+8>>2]=l,i[k+4>>2]=l,h=o+l|0,i[k+12>>2]=h,o&&z(l,s,o),i[k+8>>2]=h}k=k+16|0;break h}k=B3(X0,n+12|0)}i[e+104>>2]=k,k=1;break A}if(mn(A,e),i[A>>2])break i;if(t[A+19|0]<0&&Z(i[A+8>>2]),u[r+20|0]==1){if(t[n+28|0]=0,t[n+39|0]=0,a(A,2,100,n+28|0),t[n+39|0]>=0)break i;Z(i[n+28>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,t[114931]>=0){A=i[28731],i[B>>2]=i[28730],i[B+4>>2]=A,i[B+8>>2]=i[28732];break i}T(B,i[28730],i[28731]);break i}I0(),M()}I0(),M()}s0(),M()}x0(),M()}s0(),M()}if(!k)break k;z(o,l,k)}t[k+o|0]=0,a(A,2,100,n),t[n+11|0]<0&&Z(i[n>>2]),i[n+28>>2]=Y,i[i[R>>2]+(n+28|0)>>2]=d,i[n+36>>2]=q,i[s>>2]=77200,t[n+83|0]<0&&Z(i[n+72>>2]),y0(s),Y0(S),k=0}if(o=i[n+16>>2],!o)break e;i[n+20>>2]=o,Z(o);break e}if(!k)break r;z(o,l,k)}t[k+o|0]=0,a(A,2,1e3,n+12|0),t[n+23|0]<0&&Z(i[n+12>>2]),i[n+28>>2]=Y,i[i[R>>2]+(n+28|0)>>2]=d,i[n+36>>2]=q,i[s>>2]=77200,t[n+83|0]<0&&Z(i[n+72>>2]),y0(s),Y0(S),k=0}if(t[n+195|0]<0&&Z(i[n+184>>2]),i[_0>>2]=92500,o=i[n+220>>2],o&&(i[n+224>>2]=o,Z(o)),k)continue}break}v=n+240|0}function Qv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;o=v-48|0,v=o,S2(o+28|0,e,r),t[o+47|0]<0&&Z(i[o+36>>2]),f=Q2(r),n=f&1,t[e+105|0]=n,t[e+104|0]=f>>>1&3;i:{e:{r:{f:{A:{k:{if(n){if(f=w2(r),t[e+110|0]=f&3,X[e+106>>1]=f>>>7,t[e+109|0]=f>>>2&3,t[e+108|0]=f>>>4&7,Q=e,V=Q2(r)>>>5|0,t[Q+111|0]=V,f=Q2(r)&63,t[e+112|0]=f,!f){if(e=C(56),i[o+12>>2]=e,i[o+16>>2]=54,i[o+20>>2]=-2147483592,r=u[28633]|u[28634]<<8|(u[28635]<<16|u[28636]<<24),f=u[28629]|u[28630]<<8|(u[28631]<<16|u[28632]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+54|0]=0,r=u[28679]|u[28680]<<8|(u[28681]<<16|u[28682]<<24),f=u[28675]|u[28676]<<8|(u[28677]<<16|u[28678]<<24),t[e+46|0]=f,t[e+47|0]=f>>>8,t[e+48|0]=f>>>16,t[e+49|0]=f>>>24,t[e+50|0]=r,t[e+51|0]=r>>>8,t[e+52|0]=r>>>16,t[e+53|0]=r>>>24,r=u[28673]|u[28674]<<8|(u[28675]<<16|u[28676]<<24),f=u[28669]|u[28670]<<8|(u[28671]<<16|u[28672]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[28665]|u[28666]<<8|(u[28667]<<16|u[28668]<<24),f=u[28661]|u[28662]<<8|(u[28663]<<16|u[28664]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[28657]|u[28658]<<8|(u[28659]<<16|u[28660]<<24),f=u[28653]|u[28654]<<8|(u[28655]<<16|u[28656]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[28649]|u[28650]<<8|(u[28651]<<16|u[28652]<<24),f=u[28645]|u[28646]<<8|(u[28647]<<16|u[28648]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[28641]|u[28642]<<8|(u[28643]<<16|u[28644]<<24),f=u[28637]|u[28638]<<8|(u[28639]<<16|u[28640]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,2006,o+12|0),t[o+23|0]>=0)break f;Z(i[o+12>>2]);break f}if(f=Q2(r),t[e+114|0]=f&1,t[e+113|0]=f>>>1,Q=e,V=Q2(r),t[Q+115|0]=V,!u[e+112|0])break A;f=Q2(r),t[e+116|0]=f>>>7,t[e+117|0]=f>>>6&1,h=f&63,n=i[e+124>>2],s=i[e+128>>2];n:{if(n>>>0>=s>>>0){if(f=0,k=i[e+120>>2],n=n-k|0,l=n+1|0,(l|0)<0)break k;if(s=s-k|0,w=s<<1,l=s>>>0>=1073741823?2147483647:l>>>0<w>>>0?w:l,l&&(f=C(l)),s=f+n|0,t[s|0]=h,n&&z(f,k,n),i[e+128>>2]=f+l,n=s+1|0,i[e+124>>2]=n,i[e+120>>2]=f,!k)break n;Z(k);break n}t[n|0]=h,n=n+1|0}if(i[e+124>>2]=n,n=1,u[e+112|0]<=1)break A;for(;;){l=Q2(r),f=i[e+124>>2],s=i[e+128>>2];n:{if(f>>>0<s>>>0){t[f|0]=l,l=f+1|0;break n}if(h=i[e+120>>2],f=f-h|0,k=f+1|0,(k|0)<0)break k;if(s=s-h|0,w=s<<1,s=s>>>0>=1073741823?2147483647:k>>>0<w>>>0?w:k,s?k=C(s):k=0,w=k+f|0,t[w|0]=l,f&&z(k,h,f),i[e+128>>2]=k+s,l=w+1|0,i[e+124>>2]=l,i[e+120>>2]=k,!h)break n;Z(h)}if(i[e+124>>2]=l,n=n+1|0,!(n>>>0<u[e+112|0]))break}break A}if(e=C(72),i[o+12>>2]=e,i[o+16>>2]=68,i[o+20>>2]=-2147483576,z(e,28684,68),t[e+68|0]=0,a(A,4,0,o+12|0),t[o+23|0]>=0)break f;Z(i[o+12>>2]);break f}s0(),M()}h=u[e+108|0];A:{if(h>>>0<=1||(ft(e+132|0,h-1|0),s=Q2(r),h=u[e+108|0],h>>>0<2))break A;for(f=h-2|0,w=i[e+132>>2],n=128;k=1<<f,l=w+(f>>>3&536870908)|0,n&s?k=k|i[l>>2]:k=i[l>>2]&(k^-1),i[l>>2]=k,n=n>>>1|0,k=(f|0)>0,f=f-1|0,!!k;);}l=i[e+148>>2],f=i[e+144>>2],n=l-f|0;A:{if(n>>>0<h>>>0){if(k=h-n|0,s=i[e+152>>2],k>>>0<=s-l>>>0){k&&l0(l,0,k),i[e+148>>2]=k+l;break A}if(l=s-f|0,s=l<<1,s=l>>>0>=1073741823?2147483647:h>>>0<s>>>0?s:h,l=C(s),k&&l0(n+l|0,0,k),n&&z(l,f,n),i[e+152>>2]=l+s,i[e+148>>2]=h+l,i[e+144>>2]=l,!f)break A;Z(f);break A}if(n>>>0<=h>>>0)break A;i[e+148>>2]=f+h}f=u[e+108|0];A:{if(!f||(t[(f+i[e+144>>2]|0)-1|0]=u[e+115|0],f=u[e+108|0],f>>>0<2))break A;for(f=f-2|0;;){k:{if(i[i[e+132>>2]+(f>>>3&536870908)>>2]>>>f&1){n=Q2(r),t[i[e+144>>2]+f|0]=n;break k}n=i[e+144>>2]+f|0,t[n|0]=u[n+1|0]}if(n=(f|0)>0,f=f-1|0,!n)break}}if(_=Q2(r),_)for(h=0;;){s=F0(r),f=i[e+160>>2],l=i[e+164>>2];A:{if(f>>>0<l>>>0){i[f>>2]=s,f=f+4|0;break A}if(k=i[e+156>>2],f=f-k|0,B=f>>2,n=B+1|0,n>>>0>=1073741824)break i;if(l=l-k|0,w=l>>1,l=l>>>0>=2147483644?1073741823:n>>>0<w>>>0?w:n,l){if(l>>>0>=1073741824)break r;n=C(l<<2)}else n=0;if(w=n+f|0,i[w>>2]=s,s=w-(B<<2)|0,f&&z(s,k,f),i[e+164>>2]=n+(l<<2),f=w+4|0,i[e+160>>2]=f,i[e+156>>2]=s,!k)break A;Z(k)}if(i[e+160>>2]=f,h=h+1|0,(_|0)==(h|0))break}Q=e,V=w2(r),X[Q+168>>1]=V,Q=e,V=w2(r),X[Q+170>>1]=V,Q=e,V=w2(r),X[Q+172>>1]=V,m=Q2(r);A:{if(!m)break A;for(I=e+176|0,B=0;;){if(u[r+20|0])break A;f=Q2(r),l=0,i[o+24>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,t[o+13|0]=f&63,t[o+12|0]=f>>>7,G=w2(r);k:{n:{if(!G|t[r+20|0]&1)break n;for(;;){if(f=w2(r),f){h=0,n=0;t:{if(!w4(r,f))break t;n=C(f),f&&l0(n,0,f),h=f+n|0,s=i[r>>2],k=i[r+4>>2];o:{if(!k){if(!(W[i[i[s>>2]+16>>2]](s,n,f)|0))break o;break t}if(i[k+4>>2]=i[k+4>>2]+1,f=W[i[i[s>>2]+16>>2]](s,n,f)|0,s=i[k+4>>2],i[k+4>>2]=s-1,s||(W[i[i[k>>2]+8>>2]](k),y(k)),f)break t}f=C(32),i[o>>2]=f,i[o+4>>2]=28,i[o+8>>2]=-2147483616,k=u[2589]|u[2590]<<8|(u[2591]<<16|u[2592]<<24),h=u[2585]|u[2586]<<8|(u[2587]<<16|u[2588]<<24),t[f|0]=h,t[f+1|0]=h>>>8,t[f+2|0]=h>>>16,t[f+3|0]=h>>>24,t[f+4|0]=k,t[f+5|0]=k>>>8,t[f+6|0]=k>>>16,t[f+7|0]=k>>>24,t[f+28|0]=0,k=u[2609]|u[2610]<<8|(u[2611]<<16|u[2612]<<24),t[f+24|0]=k,t[f+25|0]=k>>>8,t[f+26|0]=k>>>16,t[f+27|0]=k>>>24,k=u[2605]|u[2606]<<8|(u[2607]<<16|u[2608]<<24),h=u[2601]|u[2602]<<8|(u[2603]<<16|u[2604]<<24),t[f+16|0]=h,t[f+17|0]=h>>>8,t[f+18|0]=h>>>16,t[f+19|0]=h>>>24,t[f+20|0]=k,t[f+21|0]=k>>>8,t[f+22|0]=k>>>16,t[f+23|0]=k>>>24,k=u[2597]|u[2598]<<8|(u[2599]<<16|u[2600]<<24),h=u[2593]|u[2594]<<8|(u[2595]<<16|u[2596]<<24),t[f+8|0]=h,t[f+9|0]=h>>>8,t[f+10|0]=h>>>16,t[f+11|0]=h>>>24,t[f+12|0]=k,t[f+13|0]=k>>>8,t[f+14|0]=k>>>16,t[f+15|0]=k>>>24,a(A,2,100,o),t[o+11|0]<0&&Z(i[o>>2]),Z(n),f=0;break k}f=i[o+20>>2],w=i[o+24>>2];t:{if(f>>>0<w>>>0){i[f+8>>2]=h,i[f+4>>2]=h,i[f>>2]=n,f=f+12|0;break t}if(s=i[o+16>>2],f=f-s|0,k=((f|0)/12|0)+1|0,k>>>0>=357913942)break e;if(w=(w-s|0)/12|0,_=w<<1,_=w>>>0>=178956970?357913941:k>>>0<_>>>0?_:k,_){if(_>>>0>=357913942)break r;k=C(g(_,12))}else k=0;if(w=k+f|0,i[w+8>>2]=h,i[w+4>>2]=h,i[w>>2]=n,n=w+g((f|0)/-12|0,12)|0,f&&z(n,s,f),i[o+24>>2]=k+g(_,12),f=w+12|0,i[o+20>>2]=f,i[o+16>>2]=n,!s)break t;Z(s)}i[o+20>>2]=f}if(l=l+1|0,G>>>0<=l>>>0)break n;if(t[r+20|0]&1)break}}f=i[e+180>>2];n:{if(f>>>0<o0[e+184>>2]){n=p[o+12>>1],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,X[f>>1]=n,i[f+4>>2]=i[o+16>>2],i[f+8>>2]=i[o+20>>2],i[f+12>>2]=i[o+24>>2],i[o+24>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,f=f+16|0;break n}f=Tt(I,o+12|0)}i[e+180>>2]=f,f=1}if(h=f,k=i[o+16>>2],k){if(f=i[o+20>>2],n=k,(f|0)!=(k|0)){for(;n=f-12|0,l=i[n>>2],l&&(i[f-8>>2]=l,Z(l)),f=n,(k|0)!=(f|0););n=i[o+16>>2]}i[o+20>>2]=k,Z(n)}if(!h)break f;if(B=B+1|0,(m|0)==(B|0))break}}if(u[r+20|0]==1){if(t[o+12|0]=0,t[o+23|0]=0,a(A,2,100,o+12|0),t[o+23|0]>=0)break f;Z(i[o+12>>2]);break f}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break f}T(A,i[28730],i[28731])}v=o+48|0;return}x0(),M()}s0(),M()}s0(),M()}function Vv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=D(0),_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=D(0),_0=0,g0=0,X0=0,V0=D(0),C0=0,r0=D(0),f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=D(0),c2=D(0),f1=D(0),o1=D(0),u1=D(0);e=v-128|0,v=e,f=i[r>>2],h=i[f+200>>2],I=K0(f,0),d=K0(i[r>>2],1),f=K0(i[r>>2],2),c=$2(i[r>>2],6),c&&(B=K0(i[r>>2],6));i:{if(!(!((I|0)==8|(d|0)==8)&(f|0)!=8)){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,f=A+8|0;e:{if(t[114951]>=0){r=i[28736],i[f>>2]=i[28735],i[f+4>>2]=r,i[f+8>>2]=i[28737];break e}T(f,i[28735],i[28736])}t[A+20|0]=1;break i}if(!((I|0)==(d|0)&(f|0)==(I|0))){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,f=A+8|0;e:{if(t[114951]>=0){r=i[28736],i[f>>2]=i[28735],i[f+4>>2]=r,i[f+8>>2]=i[28737];break e}T(f,i[28735],i[28736])}t[A+20|0]=1;break i}f=i[r>>2],o=i[f+192>>2],G=i[f+188>>2],s=C(248),i[s>>2]=101168,i[s+4>>2]=0,i[s+8>>2]=0,l0(s+16|0,0,156),i[s+76>>2]=0,i[s+80>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,t[s+24|0]=1,X[s+22>>1]=2,X[s+18>>1]=2,X[s+20>>1]=2,i[s+84>>2]=0,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+128>>2]=0,i[s+132>>2]=0,i[s+100>>2]=0,i[s+104>>2]=1,i[s+136>>2]=0,i[s+140>>2]=0,i[s+144>>2]=0,i[s+148>>2]=0,i[s+152>>2]=0,i[s+156>>2]=0,X[s+158>>1]=0,X[s+160>>1]=0,X[s+162>>1]=0,X[s+164>>1]=0,i[s+184>>2]=0,i[s+188>>2]=0,i[s+172>>2]=255,i[s+192>>2]=0,i[s+196>>2]=5186,i[s+208>>2]=99,i[s+212>>2]=99,i[s+200>>2]=0,i[s+204>>2]=0,i[s+12>>2]=101488,i[s+216>>2]=0,i[s+220>>2]=0,i[s+224>>2]=0,i[s+228>>2]=0,i[s+232>>2]=0,i[s+236>>2]=0,i[s+240>>2]=0,i[s+244>>2]=0,Q=s+12|0,i[s+176>>2]=Q,i[s+8>>2]=i[s+8>>2]+1,i[s+180>>2]=s,i[s+4>>2]==-1&&(W[i[i[s>>2]+8>>2]](s),y(s)),t1(Q,G,o,1,3),a0(e+56|0,Q,3,G,o,I,l,0),a0(e+32|0,Q,4,G,o,I,l,0),n=e+88|0;e:{if(i[e+56>>2]){if(f=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=f,t[e+75|0]>=0){k=e- -64|0,f=i[k+4>>2],i[n>>2]=i[k>>2],i[n+4>>2]=f,i[n+8>>2]=i[k+8>>2];break e}T(n,i[e+64>>2],i[e+68>>2]);break e}if(f=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=f,t[e+51|0]>=0){f=i[e+44>>2],i[n>>2]=i[e+40>>2],i[n+4>>2]=f,i[n+8>>2]=i[e+48>>2];break e}T(n,i[e+40>>2],i[e+44>>2])}a0(e+8|0,Q,5,G,o,I,l,0),k=e+112|0;e:{if(i[e+80>>2]){if(f=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=f,t[e+99|0]>=0){f=i[n+4>>2],i[k>>2]=i[n>>2],i[k+4>>2]=f,i[k+8>>2]=i[n+8>>2];break e}T(k,i[e+88>>2],i[e+92>>2]);break e}if(f=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=f,t[e+27|0]>=0){f=i[e+20>>2],i[k>>2]=i[e+16>>2],i[k+4>>2]=f,i[k+8>>2]=i[e+24>>2];break e}T(k,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,f=A+8|0,t[e+123|0]>=0){r=i[k+4>>2],i[f>>2]=i[k>>2],i[f+4>>2]=r,i[f+8>>2]=i[k+8>>2],t[A+20|0]=1;break e}if(T(f,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!c)break r;if(a0(e+104|0,Q,6,G,o,B,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,f=A+8|0,t[e+123|0]>=0){r=i[e+116>>2],i[f>>2]=i[e+112>>2],i[f+4>>2]=r,i[f+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(f,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}f=Q0(i[r>>2],0),f?(r2=i[f+40>>2],f0=i[f+52>>2]>>>1|0):f0=0,f=Q0(i[r>>2],1),f?(f2=i[f+52>>2]>>>1|0,M0=i[f+40>>2]):M0=0,f=Q0(i[r>>2],2),f?(A2=i[f+40>>2],z0=i[f+52>>2]>>>1|0):z0=0,f=Q0(Q,3),f?(s2=i[f+52>>2]>>>1|0,j0=i[f+40>>2]):j0=0,f=Q0(Q,4),f?(v2=i[f+40>>2],S0=i[f+52>>2]>>>1|0):S0=0,f=Q0(Q,5),f?(Z2=i[f+52>>2]>>>1|0,k=i[f+40>>2]):k=0,Y=0;r:{if(!c||(f=Q0(i[r>>2],6),f?(_0=i[f+40>>2],f=i[f+52>>2]):f=0,g0=f,n=Q0(Q,6),Y=0,!n))break r;X0=i[n+52>>2],Y=i[n+40>>2]}_=h<<3,h=h>>>0<4,l=(h?16908801>>>_|0:0)&3,i[e+116>>2]=-1086926434,i[e+120>>2]=1071829221,i[e+108>>2]=1068725436,i[e+112>>2]=-1095748968,t[e+104|0]=1,n=2,A0=1,r8(i[r>>2])&&(f=i[r>>2],r=p[f+6>>1]|p[f+8>>1]<<16,n=p[f+10>>1]|p[f+12>>1]<<16,f=n,Pe(e+80|0,f&65535,r&65535),i[e+120>>2]=i[e+96>>2],r=i[e+92>>2],i[e+112>>2]=i[e+88>>2],i[e+116>>2]=r,r=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=r,A0=(f&65536)>>>16|0),r=(h?16843265>>>_|0:0)&3;r:{if(!o)break r;if(E=G<<(B>>>0>8),G){for(R=l-1|0,X2=r-1|0,V0=D(16<<I-8),C0=1<<I-1&65535,f=-1<<I^-1,q=f&65535,q0=1<<d-1,R2=G&-2,I=G&1,d=n&65535,l=0;;){N=(g(l,Z2)<<1)+k|0,U=(g(l,S0)<<1)+v2|0,x=(g(l,s2)<<1)+j0|0,j=(g(l,f0)<<1)+r2|0,r=l>>>X2|0,O=(g(r,z0)<<1)+A2|0,S=(g(r,f2)<<1)+M0|0,D2=E0[e+120>>2],c2=E0[e+116>>2],f1=E0[e+112>>2],o1=E0[e+108>>2],r=0,n=0;f:{A:{k:switch(d|0){default:for(;r=n>>>R<<1,_=p[r+S>>1],B=n<<1,m=B+x|0,w=D(p[r+O>>1]-C0|0),t0=A0?w:D(w*D(1.142899990081787)),w=D(p[B+j>>1]),r0=A0?w:D(D(w-V0)*D(1.1689000129699707)),w=D(D(D(o1*t0)+r0)+D(.5)),D(B2(w))<D(2147483648)?r=~~w:r=-2147483648,X[m>>1]=(r|0)>=0?(r|0)>(f|0)?f:r:0,m=B+U|0,u1=D(c2*t0),w=D(_-C0|0),t0=A0?w:D(w*D(1.142899990081787)),w=D(D(u1+D(D(f1*t0)+r0))+D(.5)),D(B2(w))<D(2147483648)?r=~~w:r=-2147483648,X[m>>1]=(r|0)>=0?(r|0)>(f|0)?f:r:0,m=B+N|0,w=D(D(D(D2*t0)+r0)+D(.5)),D(B2(w))<D(2147483648)?r=~~w:r=-2147483648,X[m>>1]=(r|0)>=0?(r|0)>(f|0)?f:r:0,n=n+1|0,(G|0)!=(n|0););break f;case 0:if(A0){if((G|0)==1)break A;for(;_=r<<1,h=r>>>R<<1,X[_+x>>1]=p[h+O>>1],X[_+U>>1]=p[_+j>>1],X[_+N>>1]=p[h+S>>1],h=r|1,_=h<<1,h=h>>>R<<1,X[_+x>>1]=p[h+O>>1],X[_+U>>1]=p[_+j>>1],X[_+N>>1]=p[h+S>>1],r=r+2|0,n=n+2|0,(R2|0)!=(n|0););break A}for(;B=r<<1,m=B+x|0,_=r>>>R<<1,w=D(D(D(D(p[_+O>>1])-V0)*D(1.142899990081787))+D(.5)),D(B2(w))<D(2147483648)?n=~~w:n=-2147483648,X[m>>1]=(n|0)>=0?(f|0)<(n|0)?f:n:0,m=B+U|0,w=D(D(D(D(p[B+j>>1])-V0)*D(1.1689000129699707))+D(.5)),D(B2(w))<D(2147483648)?n=~~w:n=-2147483648,X[m>>1]=(n|0)>=0?(f|0)<(n|0)?f:n:0,m=B+N|0,w=D(D(D(D(p[_+S>>1])-V0)*D(1.142899990081787))+D(.5)),D(B2(w))<D(2147483648)?n=~~w:n=-2147483648,X[m>>1]=(n|0)>=0?(f|0)<(n|0)?f:n:0,r=r+1|0,(G|0)!=(r|0););break f;case 8:for(;V=r<<1,_=p[V+j>>1],n=r>>>R<<1,h=p[n+S>>1]-C0|0,m=_-h|0,n=p[n+O>>1]-C0|0,B=n+m|0,X[x+V>>1]=(B|0)>=0?B>>>0>=255?255:B:0,h=h+_|0,X[U+V>>1]=(h|0)>=0?h>>>0>=255?255:h:0,n=m-n|0,X[N+V>>1]=(n|0)>=0?n>>>0>=255?255:n:0,r=r+1|0,(G|0)!=(r|0););break f;case 16:break k}for(;V=n<<1,r=n>>>R<<1,B=p[r+S>>1]-q0|0,_=p[V+j>>1]-(B<<16>>16>>1)|0,r=p[r+O>>1]-q0|0,m=_-(r<<16>>16>>1)|0,h=r+m<<16>>16,r=h<<2,X[x+V>>1]=(h|0)>=0?r>>>0<q>>>0?r:q:0,h=_+B<<16>>16,r=h<<2,X[U+V>>1]=(h|0)>=0?r>>>0<q>>>0?r:q:0,h=m<<16>>16,r=h<<2,X[N+V>>1]=(h|0)>=0?r>>>0<q>>>0?r:q:0,n=n+1|0,(G|0)!=(n|0););break f}if(!I)break f;n=r<<1,r=r>>>R<<1,X[n+x>>1]=p[r+O>>1],X[n+U>>1]=p[n+j>>1],X[n+N>>1]=p[r+S>>1]}if(!c|!E||z(g(l,X0)+Y|0,g(l,g0)+_0|0,E),l=l+1|0,(l|0)==(o|0))break}break r}if(!c)break r;if(r=0,(o|0)!=1)for(n=o&-2,k=0;f=!E,f||z(g(r,X0)+Y|0,g(r,g0)+_0|0,E),f||(f=r|1,z(g(f,X0)+Y|0,g(f,g0)+_0|0,E)),r=r+2|0,k=k+2|0,(n|0)!=(k|0););if(!(o&1)|!E)break r;z(g(r,X0)+Y|0,g(r,g0)+_0|0,E)}t[A+20|0]=0,i[A+4>>2]=s,i[A>>2]=Q;break i}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=e+128|0}function pv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0;e=v-128|0,v=e,k=K0(i[r>>2],0),n=K0(i[r>>2],1),o=K0(i[r>>2],2),_0=$2(i[r>>2],6),_0&&(M0=K0(i[r>>2],6));i:{if(!(!(k>>>0<9|n>>>0<9)&o>>>0>8)){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(o|0))){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}f=i[r>>2],Y=i[f+192>>2],V=i[f+188>>2],d=C(248),i[d>>2]=101168,f=d,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,U=f+12|0,i[f+176>>2]=U,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(U,V,Y,0,3),a0(e+56|0,U,0,V,Y,k,l,0),a0(e+32|0,U,1,V,Y,n,l,0),f=e+88|0;e:{if(i[e+56>>2]){if(k=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=k,t[e+75|0]>=0){k=e- -64|0,n=i[k+4>>2],i[f>>2]=i[k>>2],i[f+4>>2]=n,i[f+8>>2]=i[k+8>>2];break e}T(f,i[e+64>>2],i[e+68>>2]);break e}if(k=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=k,t[e+51|0]>=0){k=i[e+44>>2],i[f>>2]=i[e+40>>2],i[f+4>>2]=k,i[f+8>>2]=i[e+48>>2];break e}T(f,i[e+40>>2],i[e+44>>2])}a0(e+8|0,U,2,V,Y,o,l,0),k=e+112|0;e:{if(i[e+80>>2]){if(n=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=n,t[e+99|0]>=0){n=i[f+4>>2],i[k>>2]=i[f>>2],i[k+4>>2]=n,i[k+8>>2]=i[f+8>>2];break e}T(k,i[e+88>>2],i[e+92>>2]);break e}if(f=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=f,t[e+27|0]>=0){f=i[e+20>>2],i[k>>2]=i[e+16>>2],i[k+4>>2]=f,i[k+8>>2]=i[e+24>>2];break e}T(k,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){f=i[k+4>>2],i[r>>2]=i[k>>2],i[r+4>>2]=f,i[r+8>>2]=i[k+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!_0)break r;if(a0(e+104|0,U,6,V,Y,M0,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){f=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}f=Q0(i[r>>2],0),f?(g0=i[f+40>>2],l=i[f+52>>2]>>>1|0):l=0,f=Q0(i[r>>2],1),f?(j=i[f+52>>2]>>>1|0,f=i[f+40>>2]):f=0,k=Q0(i[r>>2],2),k?(O=i[k+52>>2]>>>1|0,k=i[k+40>>2]):k=0,n=Q0(U,0),n?(X0=i[n+52>>2]>>>1|0,t0=i[n+40>>2]):t0=0,n=Q0(U,1),n?(S=i[n+52>>2]>>>1|0,n=i[n+40>>2]):n=0,o=Q0(U,2),o?(q=i[o+52>>2]>>>1|0,o=i[o+40>>2]):o=0,x=0;r:{if(!_0||(r=Q0(i[r>>2],6),r?(q0=i[r+40>>2],r=i[r+52>>2]):r=0,r2=r,r=Q0(U,6),x=0,!r))break r;f2=i[r+52>>2],x=i[r+40>>2]}if(X[n>>1]=p[f>>1],X[o>>1]=p[k>>1],A0=V-1|0,h=A0>>>1|0,A0>>>0>=2)for(s=h>>>0<=1?1:h,r=0;E=r<<2,w=E|2,_=r&-2,R=_+2|0,m=R+f|0,G=f+_|0,X[w+n>>1]=(p[m>>1]+g(p[G>>1],3)|0)+2>>>2,E=E+4|0,X[E+n>>1]=(p[G>>1]+g(p[m>>1],3)|0)+2>>>2,N=o+w|0,w=k+R|0,_=k+_|0,X[N>>1]=(p[w>>1]+g(p[_>>1],3)|0)+2>>>2,X[o+E>>1]=(p[_>>1]+g(p[w>>1],3)|0)+2>>>2,r=r+1|0,(s|0)!=(r|0););if(E=V&1,E||(r=A0<<1,_=V-2|0,X[r+n>>1]=p[_+f>>1],X[r+o>>1]=p[k+_>>1]),_=Y-1|0,s=_>>>1|0,_>>>0>=2)for(R=s>>>0<=1?1:s,r=0;m=r<<1,G=m|1,w=r>>>1|0,I=w+1|0,Q=f+(g(I,j)<<1)|0,B=f+(g(w,j)<<1)|0,X[n+(g(G,S)<<1)>>1]=(p[Q>>1]+g(p[B>>1],3)|0)+2>>>2,m=m+2|0,X[n+(g(m,S)<<1)>>1]=(p[B>>1]+g(p[Q>>1],3)|0)+2>>>2,N=o+(g(G,q)<<1)|0,G=k+(g(I,O)<<1)|0,w=k+(g(w,O)<<1)|0,X[N>>1]=(p[G>>1]+g(p[w>>1],3)|0)+2>>>2,X[o+(g(m,q)<<1)>>1]=(p[w>>1]+g(p[G>>1],3)|0)+2>>>2,r=r+1|0,(R|0)!=(r|0););if(I=Y&1,I||(r=(Y>>>1|0)-1|0,X[n+(g(_,S)<<1)>>1]=p[f+(g(r,j)<<1)>>1],X[o+(g(_,q)<<1)>>1]=p[k+(g(r,O)<<1)>>1]),!(_>>>0<2|E))for(w=(k+V|0)-2|0,R=(f+V|0)-2|0,r=V<<1,m=(r+o|0)-2|0,G=(r+n|0)-2|0,Q=s>>>0<=1?1:s,r=0;B=r<<1,c=B|1,s=r>>>1|0,V0=s+1|0,C0=R+(g(V0,j)<<1)|0,r0=R+(g(s,j)<<1)|0,X[G+(g(c,S)<<1)>>1]=(p[C0>>1]+g(p[r0>>1],3)|0)+2>>>2,B=B+2|0,X[G+(g(B,S)<<1)>>1]=(p[r0>>1]+g(p[C0>>1],3)|0)+2>>>2,N=m+(g(q,c)<<1)|0,c=w+(g(O,V0)<<1)|0,s=w+(g(s,O)<<1)|0,X[N>>1]=(p[c>>1]+g(p[s>>1],3)|0)+2>>>2,X[m+(g(B,q)<<1)>>1]=(p[s>>1]+g(p[c>>1],3)|0)+2>>>2,r=r+1|0,(Q|0)!=(r|0););r:{if(I)break r;if(A0>>>0>=2)for(s=h>>>0<=1?1:h,w=o+(g(_,q)<<1)|0,R=n+(g(_,S)<<1)|0,r=(Y>>>1|0)-1|0,m=k+(g(r,O)<<1)|0,G=f+(g(r,j)<<1)|0,r=0;I=r<<2,Q=I+R|0,B=r&-2,h=B+G|0,X[Q+2>>1]=(p[h+2>>1]+g(p[h>>1],3)|0)+2>>>2,X[Q+4>>1]=(p[h>>1]+g(p[h+2>>1],3)|0)+2>>>2,I=w+I|0,h=m+B|0,X[I+2>>1]=(p[h+2>>1]+g(p[h>>1],3)|0)+2>>>2,X[I+4>>1]=(p[h>>1]+g(p[h+2>>1],3)|0)+2>>>2,r=r+1|0,(s|0)!=(r|0););if(E)break r;r=V<<1,h=(Y>>>1|0)-1|0,X[(r+(n+(g(_,S)<<1)|0)|0)-2>>1]=p[(V+(f+(g(h,j)<<1)|0)|0)-2>>1],X[(r+(o+(g(_,q)<<1)|0)|0)-2>>1]=p[(V+(k+(g(h,O)<<1)|0)|0)-2>>1]}r:{if(_>>>0>=2){if(A0>>>0>=2)for(h=1;;){for(c=o+(g(h,q)<<1)|0,V0=n+(g(h,S)<<1)|0,r=h+1|0,C0=o+(g(r,q)<<1)|0,r0=n+(g(r,S)<<1)|0,r=h>>>1|0,A2=k+(g(r,O)<<1)|0,s2=f+(g(r,j)<<1)|0,r=r+1|0,v2=k+(g(r,O)<<1)|0,Z2=f+(g(r,j)<<1)|0,r=1;s=r&-2,w=s+v2|0,E=p[w+2>>1],w=p[w>>1],m=s+A2|0,R=p[m>>1],m=p[m+2>>1],Q=s+Z2|0,G=p[Q>>1],I=r<<1,N=I+V0|0,Q=p[Q+2>>1],z0=g(Q,3),B=s+s2|0,s=p[B>>1],j0=g(s,3)+8|0,B=p[B+2>>1],X[N+2>>1]=z0+(G+(j0+g(B,9)|0)|0)>>>4,f0=N,S0=g(G,3),N=g(B,3)+8|0,X[f0>>1]=Q+(S0+(N+g(s,9)|0)|0)>>>4,f0=I+r0|0,X[f0+2>>1]=(S0+(s+N|0)|0)+g(Q,9)>>>4,X[f0>>1]=((B+j0|0)+g(G,9)|0)+z0>>>4,s=I+c|0,Q=g(E,3),G=g(R,3)+8|0,X[s+2>>1]=Q+(w+(G+g(m,9)|0)|0)>>>4,N=s,B=g(w,3),s=g(m,3)+8|0,X[N>>1]=E+(B+(s+g(R,9)|0)|0)>>>4,I=I+C0|0,X[I+2>>1]=(B+(s+R|0)|0)+g(E,9)>>>4,X[I>>1]=Q+((m+G|0)+g(w,9)|0)>>>4,r=r+2|0,A0>>>0>r>>>0;);if(h=h+2|0,!(_>>>0>h>>>0))break}if(!Y)break r}if(f=V<<1,_0){for(k=M0>>>0>8?f:V,r=0;f&&z((g(r,X0)<<1)+t0|0,(g(r,l)<<1)+g0|0,f),k&&z(g(r,f2)+x|0,g(r,r2)+q0|0,k),r=r+1|0,(Y|0)!=(r|0););break r}n=Y&1;f:{if(!_){r=0;break f}for(o=Y&-2,r=0,k=0;x=!f,x||z((g(r,X0)<<1)+t0|0,(g(r,l)<<1)+g0|0,f),x||(x=r|1,z((g(x,X0)<<1)+t0|0,(g(l,x)<<1)+g0|0,f)),r=r+2|0,k=k+2|0,(o|0)!=(k|0););}if(!n|!f)break r;z((g(r,X0)<<1)+t0|0,(g(r,l)<<1)+g0|0,f)}t[A+20|0]=0,i[A+4>>2]=d,i[A>>2]=U;break i}if(A=i[d+4>>2],i[d+4>>2]=A-1,A)break i;W[i[i[d>>2]+8>>2]](d),y(d)}v=e+128|0}function M9(A,e,r,f,k,n,o,l,s){var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0;w=v-336|0,v=w,B=l,m=s&65535,G=f,I=k&65535,Y=(k^s)&-2147483648,x=s>>>16&32767,R=k>>>16&32767;i:{e:{if(x-32767>>>0>4294934529&R-32767>>>0>=4294934530)break e;if(h=k&2147483647,!(!f&(h|0)==2147418112?!(e|r):h>>>0<2147418112)){V=f,Y=k|32768;break i}if(k=s&2147483647,!(!l&(k|0)==2147418112?!(n|o):k>>>0<2147418112)){V=l,Y=s|32768,e=n,r=o;break i}if(!(e|f|(h^2147418112|r))){if(!(n|l|(k^2147418112|o))){e=0,r=0,Y=2147450880;break i}Y=Y|2147418112,e=0,r=0;break i}if(!(n|l|(k^2147418112|o))){e=0,r=0;break i}if(!(e|f|(r|h))){e=!(n|l|(k|o)),V=e?0:V,Y=e?2147450880:Y,e=0,r=0;break i}if(!(n|l|(k|o))){Y=Y|2147418112,e=0,r=0;break i}if((h|0)==65535|h>>>0<65535&&(f=!(G|I),s=_1(f?r:I),f=((s|0)==32?_1(f?e:G)+32|0:s)+(f?64:0)|0,g4(w+320|0,e,r,G,I,f-15|0),Q=16-f|0,G=i[w+328>>2],I=i[w+332>>2],r=i[w+324>>2],e=i[w+320>>2]),k>>>0>65535)break e;f=!(m|B),l=_1(f?o:m),f=((l|0)==32?_1(f?n:B)+32|0:l)+(f?64:0)|0,g4(w+304|0,n,o,B,m,f-15|0),Q=(f+Q|0)-16|0,B=i[w+312>>2],m=i[w+316>>2],n=i[w+304>>2],o=i[w+308>>2]}k=m|65536,j=k,O=B,f=B,h=k<<15|f>>>17,k=f<<15|o>>>17,f=k,s=0-f|0,l=h,h=1963258675-(h+((f|0)!=0)|0)|0,e4(w+288|0,f,l,0,0,s,h,0,0),f=i[w+296>>2],e4(w+272|0,0-f|0,0-(i[w+300>>2]+((f|0)!=0)|0)|0,0,0,s,h,0,0),f=i[w+280>>2],s=f<<1|i[w+276>>2]>>>31,f=i[w+284>>2]<<1|f>>>31,e4(w+256|0,s,f,0,0,k,l,0,0),h=i[w+264>>2],e4(w+240|0,s,f,0,0,0-h|0,0-(i[w+268>>2]+((h|0)!=0)|0)|0,0,0),s=i[w+248>>2],h=s<<1|i[w+244>>2]>>>31,f=i[w+252>>2]<<1|s>>>31,e4(w+224|0,h,f,0,0,k,l,0,0),s=i[w+232>>2],e4(w+208|0,h,f,0,0,0-s|0,0-(i[w+236>>2]+((s|0)!=0)|0)|0,0,0),f=i[w+216>>2],s=f<<1|i[w+212>>2]>>>31,f=i[w+220>>2]<<1|f>>>31,e4(w+192|0,s,f,0,0,k,l,0,0),h=i[w+200>>2],e4(w+176|0,s,f,0,0,0-h|0,0-(i[w+204>>2]+((h|0)!=0)|0)|0,0,0),s=k,k=i[w+184>>2],f=l,B=k<<1|i[w+180>>2]>>>31,l=B-1|0,k=(i[w+188>>2]<<1|k>>>31)-!B|0,e4(w+160|0,s,f,0,0,l,k,0,0),f=l,e4(w+144|0,n<<15,o<<15|n>>>17,0,0,f,k,0,0),N=w+112|0,S=i[w+168>>2],l=i[w+172>>2],B=i[w+160>>2],s=i[w+152>>2],_=B+s|0,m=i[w+164>>2],h=m+i[w+156>>2]|0,h=s>>>0>_>>>0?h+1|0:h,s=h,h=(m|0)==(h|0)&_>>>0<B>>>0|h>>>0<m>>>0,m=h+S|0,h=h>>>0>m>>>0?l+1|0:l,B=!s&_>>>0>1|(s|0)!=0,l=m+B|0,h=B>>>0>l>>>0?h+1|0:h,e4(N,f,k,0,0,0-l|0,0-(((l|0)!=0)+h|0)|0,0,0),e4(w+128|0,1-_|0,0-((_>>>0>1)+s|0)|0,0,0,f,k,0,0),V0=(R-x|0)+Q|0,k=i[w+116>>2],R=k,f=i[w+112>>2],h=k<<1|f>>>31,s=f<<1,m=h,f=h,l=i[w+140>>2],U=l,k=i[w+136>>2],h=l<<1|k>>>31,_=k<<1|i[w+132>>2]>>>31,l=_+s|0,f=f+h|0,f=l>>>0<_>>>0?f+1|0:f,k=f,f=f-(l>>>0<13927)|0,E=f,N=f,_=0,h=I|65536,C0=h,r0=G,f=G,h=h<<1|f>>>31,M0=f<<1,z0=h,A0=h,f=L0(E,_,h,0),h=h0,q=f,d=h,_0=e<<1,f=r<<1|e>>>31,x=f,S=f,h=0,Q=h,B=l-13927|0,E=(k|0)==(E|0)&B>>>0<l>>>0|k>>>0>E>>>0,k=(k|0)==(m|0)&l>>>0<s>>>0|k>>>0<m>>>0,f=i[w+120>>2],l=i[w+124>>2]<<1|f>>>31,f=f<<1|R>>>31,_=U>>>31|0,f=_+f|0,h=l,h=f>>>0<_>>>0?h+1|0:h,l=f,f=f+k|0,h=l>>>0>f>>>0?h+1|0:h,k=f,f=f+E|0,_=k>>>0>f>>>0?h+1|0:h,k=f-1|0,c=_-!f|0,U=0,s=L0(S,Q,c,U),f=s+q|0,l=h0+d|0,l=f>>>0<s>>>0?l+1|0:l,m=(d|0)==(l|0)&f>>>0<q>>>0|l>>>0<d>>>0,q=k,f0=r>>>31|0,t0=f0|G<<1,E=0,k=L0(k,0,t0,E),G=k+f|0,h=h0+l|0,_=0,h=k>>>0>G>>>0?h+1|0:h,I=h,f=(h|0)==(l|0)&f>>>0>G>>>0|l>>>0>h>>>0,k=f,f=f+m|0,_=k>>>0>f>>>0?1:_,k=L0(A0,Q,c,U),f=k+f|0,h=h0+_|0,m=f,f=f>>>0<k>>>0?h+1|0:h,k=L0(A0,Q,q,E),_=h0,l=k,k=L0(t0,E,c,U),s=l+k|0,h=h0+_|0,h=k>>>0>s>>>0?h+1|0:h,k=h,h=(_|0)==(h|0)&l>>>0>s>>>0|h>>>0<_>>>0,_=m+k|0,f=f+h|0,f=_>>>0<k>>>0?f+1|0:f,m=_,_=f,k=0,f=k+G|0,h=s+I|0,h=f>>>0<k>>>0?h+1|0:h,k=h,l=(h|0)==(I|0)&f>>>0<G>>>0|h>>>0<I>>>0,h=_,s=l,l=l+m|0,h=s>>>0>l>>>0?h+1|0:h,R=l,_=h,G=f,d=B,f=L0(B,0,t0,E),s=h0,l=f,B=L0(N,V,S,V),f=f+B|0,h=h0+s|0,h=f>>>0<B>>>0?h+1|0:h,B=(s|0)==(h|0)&f>>>0<l>>>0|s>>>0>h>>>0,l=h,g0=_0&-2,s=L0(q,E,g0,0),I=s+f|0,h=h0+h|0,h=s>>>0>I>>>0?h+1|0:h,s=h,f=(h|0)==(l|0)&f>>>0>I>>>0|l>>>0>h>>>0,l=0,h=f+B|0,f=(h>>>0<f>>>0?1:l)+k|0,m=h+G|0,f=m>>>0<h>>>0?f+1|0:f,h=_,B=f,f=(f|0)==(k|0)&m>>>0<G>>>0|f>>>0<k>>>0,k=f,f=f+R|0,h=k>>>0>f>>>0?h+1|0:h,j0=f,R=h,f=L0(A0,Q,d,V),X0=h0,A0=f,k=L0(c,U,g0,V),f=f+k|0,h=h0+X0|0,h=f>>>0<k>>>0?h+1|0:h,G=f,_=L0(N,V,t0,E),k=f+_|0,l=h,f=h+h0|0,f=k>>>0<_>>>0?f+1|0:f,Q=k,h=L0(S,V,q,E),k=k+h|0,_=h0+f|0,_=k>>>0<h>>>0?_+1|0:_,c=(f|0)==(_|0)&k>>>0<Q>>>0|f>>>0>_>>>0,h=(l|0)==(X0|0)&G>>>0<A0>>>0|l>>>0<X0>>>0,f=(f|0)==(l|0)&G>>>0>Q>>>0|f>>>0<l>>>0,f=f+h|0,f=f+c|0,l=_,Q=l+m|0,h=(f|U)+B|0,h=l>>>0>Q>>>0?h+1|0:h,G=h,f=(B|0)==(h|0)&m>>>0>Q>>>0|h>>>0<B>>>0,h=R,l=f,f=f+j0|0,h=l>>>0>f>>>0?h+1|0:h,U=f,B=h,f=L0(N,V,g0,V),N=h0,m=f,l=L0(S,V,d,V),f=f+l|0,h=h0+N|0,h=f>>>0<l>>>0?h+1|0:h,R=0,l=(h|0)==(N|0)&f>>>0<m>>>0|h>>>0<N>>>0,m=h,f=h+I|0,h=(l|R)+s|0,h=f>>>0<m>>>0?h+1|0:h,s=(s|0)==(h|0)&f>>>0<I>>>0|s>>>0>h>>>0,l=h,h=k,I=0,k=I+f|0,_=l+h|0,h=0,_=k>>>0<I>>>0?_+1|0:_,f=(l|0)==(_|0)&f>>>0>k>>>0|l>>>0>_>>>0,k=f,f=f+s|0,h=(k>>>0>f>>>0?1:h)+G|0,_=B,k=f,f=f+Q|0,h=k>>>0>f>>>0?h+1|0:h,k=h,l=(G|0)==(h|0)&f>>>0<Q>>>0|h>>>0<G>>>0,s=l,l=l+U|0,_=s>>>0>l>>>0?_+1|0:_,s=_;e:{if((_|0)==131071|_>>>0<131071){r0=M0|f0,C0=E|z0,e4(w+80|0,f,h,l,_,n,o,O,j),_=i[w+84>>2],Q=_,h=e<<17,G=0,I=i[w+88>>2],r=G-I|0,e=i[w+80>>2],_=(_|e)!=0,B=r-_|0,m=(h-(i[w+92>>2]+(G>>>0<I>>>0)|0)|0)-(r>>>0<_>>>0)|0,I=0-(((e|0)!=0)+Q|0)|0,Q=V0+16382|0,G=0-e|0;break e}f=(k&1)<<31|f>>>1,k=l<<31|k>>>1,l=(s&1)<<31|l>>>1,s=s>>>1|0,e4(w+96|0,f,k,l,s,n,o,O,j),B=i[w+100>>2],x=B,m=0,Q=i[w+104>>2],G=m-Q|0,_=i[w+96>>2],I=(B|_)!=0,B=G-I|0,m=((e<<16)-(i[w+108>>2]+(m>>>0<Q>>>0)|0)|0)-(G>>>0<I>>>0)|0,I=0-(((_|0)!=0)+x|0)|0,_0=e,x=r,Q=V0+16383|0,G=0-_|0}if((Q|0)>=32767){Y=Y|2147418112,e=0,r=0;break i}e:{if((Q|0)>0){e=B<<1|I>>>31,r=m<<1|B>>>31,B=l,m=s&65535|Q<<16,_=I<<1|G>>>31,l=G<<1;break e}if((Q|0)<=-113){e=0,r=0;break i}I6(w- -64|0,f,k,l,s,1-Q|0),g4(w+48|0,_0,x,r0,C0,Q+112|0),f=i[w+64>>2],k=i[w+68>>2],B=i[w+72>>2],m=i[w+76>>2],e4(w+32|0,n,o,O,j,f,k,B,m),e=i[w+40>>2],r=i[w+56>>2],s=i[w+36>>2],I=e<<1|s>>>31,_=r-I|0,I=i[w+60>>2]-((i[w+44>>2]<<1|e>>>31)+(r>>>0<I>>>0)|0)|0,r=i[w+52>>2],Q=r,e=i[w+32>>2],l=s<<1|e>>>31,G=e<<1,e=G,h=i[w+48>>2],r=(r|0)==(l|0)&e>>>0>h>>>0|r>>>0<l>>>0,e=_-r|0,r=I-(r>>>0>_>>>0)|0,_=Q-((h>>>0<G>>>0)+l|0)|0,l=h-G|0}e4(w+16|0,n,o,O,j,3,0,0,0),e4(w,n,o,O,j,5,0,0,0),G=f,I=f&1,s=I,f=l+s|0,h=0,l=h+_|0,l=f>>>0<s>>>0?l+1|0:l,s=f,o=(o|0)==(l|0)&f>>>0>n>>>0|o>>>0<l>>>0,_=r,f=(l|0)==(h|0)&f>>>0<I>>>0|l>>>0<h>>>0,n=e+f|0,_=f>>>0>n>>>0?_+1|0:_,h=k,e=(_|0)==(j|0),e=e&(n|0)==(O|0)?o:e&n>>>0>O>>>0|_>>>0>j>>>0,r=e,e=e+G|0,h=r>>>0>e>>>0?h+1|0:h,r=h,f=(k|0)==(h|0)&e>>>0<G>>>0|k>>>0>h>>>0,h=m,k=f,f=f+B|0,h=k>>>0>f>>>0?h+1|0:h,o=f,k=i[w+20>>2],B=(k|0)==(l|0)&o0[w+16>>2]<s>>>0|k>>>0<l>>>0,k=i[w+28>>2],f=i[w+24>>2],k=h>>>0<2147418112&((f|0)==(n|0)&(k|0)==(_|0)?B:(k|0)==(_|0)&f>>>0<n>>>0|k>>>0<_>>>0),f=r,B=k,k=e+k|0,f=B>>>0>k>>>0?f+1|0:f,e=(r|0)==(f|0)&e>>>0>k>>>0|r>>>0>f>>>0,r=e,e=e+o|0,h=r>>>0>e>>>0?h+1|0:h,o=e,r=i[w+4>>2],l=(r|0)==(l|0)&o0[w>>2]<s>>>0|r>>>0<l>>>0,r=i[w+12>>2],e=i[w+8>>2],e=h>>>0<2147418112&((e|0)==(n|0)&(r|0)==(_|0)?l:(r|0)==(_|0)&e>>>0<n>>>0|r>>>0<_>>>0),r=e,e=e+k|0,_=r>>>0>e>>>0?f+1|0:f,r=_,k=(f|0)==(_|0)&e>>>0<k>>>0|f>>>0>_>>>0,f=h,n=k,k=k+o|0,f=n>>>0>k>>>0?f+1|0:f,V=k|V,Y=f|Y}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=V,i[A+12>>2]=Y,v=w+336|0}function Fv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0;o=v-48|0,v=o;i:{e:{k=i[r>>2];r:{if(!u[k+112|0]){e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;f:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break f}T(e,i[28735],i[28736])}t[A+20|0]=1;break r}f:{if(I=p[k+96>>1],I&&(E=p[k+98>>1],E))break f;e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;A:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break A}T(e,i[28735],i[28736])}t[A+20|0]=1;break r}Y=i[k+192>>2],Q=i[k+188>>2],N=K0(k,11),e=C(248),i[e>>2]=101168,i[e+4>>2]=0,i[e+8>>2]=0,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,O=e+12|0,i[e+176>>2]=O,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e)),t1(O,Q,Y,1,N>>>0>8?14:10),a0(o+24|0,O,10,Q,Y,N,l,0);f:{if(i[o+24>>2]){if(r=i[o+28>>2],i[A>>2]=i[o+24>>2],i[A+4>>2]=r,r=A+8|0,t[o+43|0]>=0){f=i[o+36>>2],i[r>>2]=i[o+32>>2],i[r+4>>2]=f,i[r+8>>2]=i[o+40>>2],t[A+20|0]=1;break f}if(T(r,i[o+32>>2],i[o+36>>2]),r=t[o+43|0],t[A+20|0]=1,(r|0)>=0)break f;Z(i[o+32>>2]);break f}if(t[o+43|0]<0&&Z(i[o+32>>2]),f=Q0(i[r>>2],11),f?(G=i[f+52>>2],U=i[f+40>>2]):U=0,f=Q0(O,10),f?(S=i[f+52>>2],f=i[f+40>>2]):f=0,l=0,i[o+20>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,n=g(I,E),n>>>0>=1073741824)break i;q=f,f=n<<2,R=C(f),i[o+12>>2]=R,V=f+R|0,i[o+20>>2]=V,f&&l0(R,0,f),i[o+16>>2]=V;A:{for(;;){if(f=$u(i[r>>2],i[i[k+100>>2]+(l<<3)>>2])-4&65535,f>>>0>=3){i[(l<<2)+R>>2]=-1,r=C(80),i[o>>2]=r,i[o+4>>2]=78,i[o+8>>2]=-2147483568,z(r,21829,78),t[r+78|0]=0,r=a(o+24|0,4,3002,o),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;k:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[A+20|0]=1;break k}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+20|0]=1,(f|0)>=0)break k;Z(i[r+8>>2])}t[o+11|0]<0&&Z(i[o>>2]);break A}if(i[(l<<2)+R>>2]=f,l=l+1|0,(n|0)==(l|0))break}if(i[o+32>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,n>>>0>=119304648)break e;for(f=g(n,36),r=C(f),i[o+24>>2]=r,i[o+32>>2]=r+f,f=f-36|0,f=(f-((f>>>0)%36|0)|0)+36|0,f&&l0(r,0,f),i[o+28>>2]=r+f,V=1-E|0,w=1-I|0,x=(V|0)>=(E|0)|(w|0)>=(I|0);;){for(A0=g(B,I),n=0;;){k:{n:{t:{o:{r=n+A0|0,d=i[o+24>>2]+g(r,36)|0,c=i[(r<<2)+R>>2],k=d+g(c,12)|0,r=i[k+4>>2],h=i[k+8>>2];l:{if(r>>>0>=h>>>0){if(l=i[k>>2],r=r-l|0,_=r>>3,f=_+1|0,f>>>0>536870911)break o;if(h=h-l|0,s=h>>2,h=h>>>0>=2147483640?536870911:f>>>0<s>>>0?s:f,h){if(h>>>0>536870911)break n;f=C(h<<3)}else f=0;if(m=f+r|0,s=m,i[s>>2]=0,i[s+4>>2]=0,s=s-(_<<3)|0,r&&z(s,l,r),i[k+8>>2]=f+(h<<3),r=m+8|0,i[k+4>>2]=r,i[k>>2]=s,!l)break l;Z(l);break l}i[r>>2]=0,i[r+4>>2]=0,r=r+8|0}if(i[k+4>>2]=r,r=V,x)break k;for(;;){for(t0=r+B|0,l=w;;){l:{if(!(r|l)||(f=i[((g((((t0|0)%(E|0)|0)+E|0)%(E|0)|0,I)<<2)+R|0)+((((n+l|0)%(I|0)|0)+I|0)%(I|0)<<2)>>2],(f|0)==(c|0)))break l;s=g(f,12)+d|0,f=i[s+4>>2],h=i[s+8>>2];u:{if(f>>>0>=h>>>0){if(_=i[s>>2],f=f-_|0,j=f>>3,k=j+1|0,k>>>0>536870911)break t;if(h=h-_|0,m=h>>2,h=h>>>0>=2147483640?536870911:k>>>0<m>>>0?m:k,h){if(h>>>0>536870911)break n;k=C(h<<3)}else k=0;if(m=k+f|0,i[m+4>>2]=r,i[m>>2]=l,j=m-(j<<3)|0,f&&z(j,_,f),i[s+8>>2]=k+(h<<3),h=m+8|0,i[s+4>>2]=h,i[s>>2]=j,!_)break u;Z(_);break u}i[f+4>>2]=r,i[f>>2]=l,h=f+8|0}i[s+4>>2]=h}if(l=l+1|0,(I|0)==(l|0))break}if(r=r+1|0,(E|0)==(r|0))break}break k}s0(),M()}s0(),M()}x0(),M()}if(n=n+1|0,(I|0)==(n|0))break}if(B=B+1|0,(E|0)==(B|0))break}k:{if(N>>>0>8){if(!Y|!Q)break k;for(N=S>>>1|0,s=G>>>1|0,m=i[o+24>>2],B=0,h=0;;){for(S=m+g(g(B,I),36)|0,j=(g(h,N)<<1)+q|0,f=0,r=0;;){V=j+g(r,6)|0,k=0,w=S+g(f,36)|0,l=i[w>>2],x=i[w+4>>2],_=0;n:{if((l|0)==(x|0))break n;for(n=0;;){G=i[l>>2]+r|0;t:{if((G|0)<0|(Q|0)<=(G|0)||(_=i[l+4>>2]+h|0,(_|0)<0|(_|0)>=(Y|0)))break t;k=p[((g(s,_)<<1)+U|0)+(G<<1)>>1]+k|0,n=n+1|0}if(l=l+8|0,(x|0)==(l|0))break}if(_=0,(n|0)<=0)break n;_=((n>>>1|0)+k|0)/(n|0)|0}X[V>>1]=_,k=0,l=i[w+12>>2],x=i[w+16>>2],_=0;n:{if((l|0)==(x|0))break n;for(n=0;;){G=i[l>>2]+r|0;t:{if((G|0)<0|(Q|0)<=(G|0)||(_=i[l+4>>2]+h|0,(_|0)<0|(_|0)>=(Y|0)))break t;k=p[((g(s,_)<<1)+U|0)+(G<<1)>>1]+k|0,n=n+1|0}if(l=l+8|0,(x|0)==(l|0))break}if(_=0,(n|0)<=0)break n;_=((n>>>1|0)+k|0)/(n|0)|0}X[V+2>>1]=_,k=0,l=i[w+24>>2],_=i[w+28>>2],w=0;n:{if((l|0)==(_|0))break n;for(n=0;;){w=i[l>>2]+r|0;t:{if((w|0)<0|(w|0)>=(Q|0)||(G=i[l+4>>2]+h|0,(G|0)<0|(G|0)>=(Y|0)))break t;k=p[((g(s,G)<<1)+U|0)+(w<<1)>>1]+k|0,n=n+1|0}if(l=l+8|0,(_|0)==(l|0))break}if(w=0,(n|0)<=0)break n;w=((n>>>1|0)+k|0)/(n|0)|0}if(X[V+4>>1]=w,f=f+1|0,f=(f|0)!=(I|0)?f:0,r=r+1|0,(Q|0)==(r|0))break}if(r=B+1|0,B=(r|0)!=(E|0)?r:0,h=h+1|0,(Y|0)==(h|0))break}break k}if(!Y|!Q)break k;for(h=0,r=1;;){if(r){for(_=g(h,S)+q|0,f=0,N=g(g((h>>>0)%(E>>>0)|0,I),36),r=0;;){k=0,n=0,V=_+g(r,3)|0,w=(N+i[o+24>>2]|0)+g(f,36)|0,l=i[w>>2],m=i[w+4>>2],s=0;n:{if((l|0)==(m|0))break n;for(;;){B=i[l>>2]+r|0;t:{if((B|0)<0|(B|0)>=(Q|0)||(s=i[l+4>>2]+h|0,(s|0)<0|(s|0)>=(Y|0)))break t;n=n+1|0,k=u[B+(g(s,G)+U|0)|0]+k|0}if(l=l+8|0,(m|0)==(l|0))break}if(s=0,(n|0)<=0)break n;s=((n>>>1|0)+k|0)/(n|0)|0}t[V|0]=s,n=0,l=i[w+12>>2],m=i[w+16>>2],s=0;n:{if((l|0)==(m|0))break n;for(k=0;;){B=i[l>>2]+r|0;t:{if((B|0)<0|(B|0)>=(Q|0)||(s=i[l+4>>2]+h|0,(s|0)<0|(s|0)>=(Y|0)))break t;k=k+1|0,n=u[B+(g(s,G)+U|0)|0]+n|0}if(l=l+8|0,(m|0)==(l|0))break}if(s=0,(k|0)<=0)break n;s=((k>>>1|0)+n|0)/(k|0)|0}t[V+1|0]=s,n=0,l=i[w+24>>2],s=i[w+28>>2],w=0;n:{if((l|0)==(s|0))break n;for(k=0;;){w=i[l>>2]+r|0;t:{if((w|0)<0|(w|0)>=(Q|0)||(B=i[l+4>>2]+h|0,(B|0)<0|(B|0)>=(Y|0)))break t;k=k+1|0,n=u[w+(g(B,G)+U|0)|0]+n|0}if(l=l+8|0,(s|0)==(l|0))break}if(w=0,(k|0)<=0)break n;w=((k>>>1|0)+n|0)/(k|0)|0}if(t[V+2|0]=w,f=f+1|0,f=(f|0)!=(I|0)?f:0,r=r+1|0,(Q|0)==(r|0))break}r=Q}else r=0;if(h=h+1|0,(Y|0)==(h|0))break}}if(t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=O,i[o>>2]=o+24,k=i[o>>2],e=i[k>>2],e){if(A=i[k+4>>2],f=e,(A|0)!=(e|0)){for(;r=i[A-12>>2],r&&(i[A-8>>2]=r,Z(r)),r=i[A-24>>2],r&&(i[A-20>>2]=r,Z(r)),r=A-36|0,f=i[r>>2],f&&(i[A-32>>2]=f,Z(f)),A=r,(r|0)!=(e|0););f=i[i[o>>2]>>2]}i[k+4>>2]=e,Z(f)}e=0}if(Z(R),!e)break r}if(A=i[e+4>>2],i[e+4>>2]=A-1,A)break r;W[i[i[e>>2]+8>>2]](e),y(e)}v=o+48|0;return}s0(),M()}s0(),M()}function Cv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0;_=v-48|0,v=_,h=_+12|0,Y=f,j=k,O=n,c=o,s=v-80|0,v=s,S=r;i:{e:{r:{f:{if(B=i[e>>2],k=i[B+188>>2],k>>>0>r>>>0&&(f=i[B+192>>2],Y>>>0<f>>>0))break f;r=C(64),i[s+24>>2]=r,i[s+28>>2]=58,i[s+32>>2]=-2147483584,f=u[16232]|u[16233]<<8,t[r+56|0]=f,t[r+57|0]=f>>>8,f=u[16228]|u[16229]<<8|(u[16230]<<16|u[16231]<<24),k=u[16224]|u[16225]<<8|(u[16226]<<16|u[16227]<<24),t[r+48|0]=k,t[r+49|0]=k>>>8,t[r+50|0]=k>>>16,t[r+51|0]=k>>>24,t[r+52|0]=f,t[r+53|0]=f>>>8,t[r+54|0]=f>>>16,t[r+55|0]=f>>>24,f=u[16220]|u[16221]<<8|(u[16222]<<16|u[16223]<<24),k=u[16216]|u[16217]<<8|(u[16218]<<16|u[16219]<<24),t[r+40|0]=k,t[r+41|0]=k>>>8,t[r+42|0]=k>>>16,t[r+43|0]=k>>>24,t[r+44|0]=f,t[r+45|0]=f>>>8,t[r+46|0]=f>>>16,t[r+47|0]=f>>>24,f=u[16212]|u[16213]<<8|(u[16214]<<16|u[16215]<<24),k=u[16208]|u[16209]<<8|(u[16210]<<16|u[16211]<<24),t[r+32|0]=k,t[r+33|0]=k>>>8,t[r+34|0]=k>>>16,t[r+35|0]=k>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[16204]|u[16205]<<8|(u[16206]<<16|u[16207]<<24),k=u[16200]|u[16201]<<8|(u[16202]<<16|u[16203]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[16196]|u[16197]<<8|(u[16198]<<16|u[16199]<<24),k=u[16192]|u[16193]<<8|(u[16194]<<16|u[16195]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[16188]|u[16189]<<8|(u[16190]<<16|u[16191]<<24),k=u[16184]|u[16185]<<8|(u[16186]<<16|u[16187]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,f=u[16180]|u[16181]<<8|(u[16182]<<16|u[16183]<<24),k=u[16176]|u[16177]<<8|(u[16178]<<16|u[16179]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+58|0]=0,r=a(s+56|0,5,2006,s+24|0),f=i[r+4>>2],i[h>>2]=i[r>>2],i[h+4>>2]=f,f=h+8|0;A:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[h+20|0]=1;break A}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[h+20|0]=1,(f|0)>=0)break A;Z(i[r+8>>2])}if(t[s+35|0]>=0)break r;Z(i[s+24>>2]);break r}if(m=C(248),r=m,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101168,l0(r+16|0,0,156),i[r+76>>2]=0,i[r+80>>2]=0,i[r+36>>2]=1,i[r+40>>2]=1,t[r+24|0]=1,X[r+22>>1]=2,X[r+18>>1]=2,X[r+20>>1]=2,i[r+84>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+128>>2]=0,i[r+132>>2]=0,i[r+100>>2]=0,i[r+104>>2]=1,i[r+136>>2]=0,i[r+140>>2]=0,i[r+144>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+156>>2]=0,X[r+158>>1]=0,X[r+160>>1]=0,X[r+162>>1]=0,X[r+164>>1]=0,i[r+184>>2]=0,i[r+188>>2]=0,i[r+172>>2]=255,i[r+192>>2]=0,i[r+196>>2]=5186,i[r+208>>2]=99,i[r+212>>2]=99,i[r+200>>2]=0,i[r+204>>2]=0,i[r+12>>2]=101488,i[r+216>>2]=0,i[r+220>>2]=0,i[r+224>>2]=0,i[r+228>>2]=0,i[r+232>>2]=0,i[r+236>>2]=0,i[r+240>>2]=0,i[r+244>>2]=0,E=r+12|0,i[r+176>>2]=E,i[r+8>>2]=i[r+8>>2]+1,i[r+180>>2]=r,i[r+4>>2]==-1&&(W[i[i[r>>2]+8>>2]](r),y(r)),i[s+24>>2]=i[B+164>>2],r=i[B+168>>2],!r||(r=Oi(r),i[s+28>>2]=r,!r))break e;k=k-S|0,q=k>>>0<j>>>0?k:j,f=f-Y|0,d=f>>>0<O>>>0?f:O,Xn(s+56|0,E,s+24|0,q,d,c),f=i[r+4>>2],i[r+4>>2]=f-1,f||(W[i[i[r>>2]+8>>2]](r),y(r));f:{if(i[s+56>>2]){r=i[s+60>>2],i[h>>2]=i[s+56>>2],i[h+4>>2]=r,r=h+8|0;A:{if(t[s+75|0]>=0){f=s- -64|0,k=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=k,i[r+8>>2]=i[f+8>>2];break A}T(r,i[s+64>>2],i[s+68>>2])}t[h+20|0]=1;break f}i[s+48>>2]=0,i[s+52>>2]=0,R=s+48|0,i[s+44>>2]=R,k=i[B+204>>2],w=i[B+208>>2];A:{k:{if((k|0)==(w|0))break k;for(;;){o=i[k>>2],f=R,r=f,n=i[s+48>>2];n:{t:{if(!n)break t;for(;;){if(r=n,f=i[r+16>>2],(f|0)>(o|0)){if(f=r,n=i[r>>2],n)continue;break t}if((f|0)>=(o|0))break n;if(n=i[r+4>>2],!n)break}f=r+4|0}n=C(20),i[n+8>>2]=r,r=n,i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=o,i[f>>2]=r,r=i[i[s+44>>2]>>2],r&&(i[s+44>>2]=r),G1(i[s+48>>2],n),i[s+52>>2]=i[s+52>>2]+1}if(k=k+56|0,(w|0)==(k|0))break}if(o=i[s+44>>2],(R|0)==(o|0))break k;for(g0=d>>>1|0,X0=q>>>1|0,V0=Y>>>1|0,C0=S>>>1|0,A0=i[B+200>>2],r0=A0-1>>>0<2;;){Q=i[o+16>>2],n=0;n:{t:{if(f=i[B+204>>2],k=f,G=i[B+208>>2],I=(k|0)==(G|0),I)break t;for(;;){if((Q|0)!=i[k>>2]){if(k=k+56|0,(G|0)!=(k|0))continue;break t}break}t0=i[k+40>>2],N=i[k+52>>2];break n}t0=0,N=0}k=i[m+216>>2],w=k,r=i[m+220>>2];n:{if((r|0)==(k|0)){V=0,w=0;break n}t:{o:{for(;;){if((Q|0)==i[w>>2])break o;if(w=w+56|0,(r|0)==(w|0))break}V=0,w=0;break t}V=i[w+40>>2],w=i[w+52>>2]}for(;;){if((Q|0)!=i[k>>2]){if(k=k+56|0,(r|0)!=(k|0))continue;break n}break}n=p[k+20>>1]}r=0,k=f;n:{if(I)break n;for(;;){if((Q|0)!=i[k>>2]){if(k=k+56|0,(G|0)!=(k|0))continue;break n}break}r=p[k+20>>1]}if((r|0)!=(n|0)){t[s+12|0]=0,t[s+23|0]=0,r=a(s+24|0,2,132,s+12|0),f=i[r+4>>2],i[h>>2]=i[r>>2],i[h+4>>2]=f,f=h+8|0;n:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[h+20|0]=1;break n}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[h+20|0]=1,(f|0)>=0)break n;Z(i[r+8>>2])}if(t[s+23|0]>=0)break A;Z(i[s+12>>2]);break A}r=0,n=i[B+192>>2],_0=Q-1>>>0<2,k=_0&(A0|0)==1,U=Y-(k?V0:0)|0,n=n-(U+(k?n>>>1|0:0)|0)|0,k=d-(k?g0:0)|0,x=k>>>0>n>>>0?n:k,k=r0&_0,n=S-(k?C0:0)|0;n:{if(I){k=0;break n}I=i[B+188>>2],I=I-(n+(k?I>>>1|0:0)|0)|0,k=q-(k?X0:0)|0,I=k>>>0>I>>>0?I:k,k=f;t:{o:{for(;;){if((Q|0)==i[k>>2])break o;if(k=k+56|0,(G|0)==(k|0))break}k=0;break t}k=u[k+23|0]&31}for(k=g(k,I);;){if((Q|0)!=i[f>>2]){if(f=f+56|0,(G|0)!=(f|0))continue;break n}break}r=u[f+23|0]&31}n:{if(!x)break n;if(f=g(r,n)+t0|0,r=0,(x|0)!=1)for(Q=x&-2,n=0;G=!k,G||z(g(r,w)+V|0,f+g(r+U|0,N)|0,k),G||(G=r|1,z(g(G,w)+V|0,f+g(G+U|0,N)|0,k)),r=r+2|0,n=n+2|0,(Q|0)!=(n|0););if(!(x&1)|!k)break n;z(g(r,w)+V|0,f+g(r+U|0,N)|0,k)}n=i[o+4>>2];n:{if(n){for(;;)if(r=n,n=i[r>>2],!n)break n}for(;r=i[o+8>>2],f=i[r>>2]!=(o|0),o=r,!!f;);}if(o=r,(r|0)==(R|0))break}}if(rn(s+24|0,E,j,O,c),f=i[s+28>>2],r=i[s+24>>2],i[s+56>>2]=r,i[s+60>>2]=f,f=s- -64|0,t[s+75|0]<0&&(Z(i[s+64>>2]),r=i[s+56>>2]),k=i[s+36>>2],i[f>>2]=i[s+32>>2],i[f+4>>2]=k,i[f+8>>2]=i[s+40>>2],r){r=i[s+60>>2],i[h>>2]=i[s+56>>2],i[h+4>>2]=r,r=h+8|0;k:{if(t[s+75|0]>=0){k=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=k,i[r+8>>2]=i[f+8>>2];break k}T(r,i[s+64>>2],i[s+68>>2])}t[h+20|0]=1;break A}t[h+20|0]=0,i[h+4>>2]=m,i[h>>2]=E,m=0}ee(s+44|0,i[s+48>>2])}if(t[s+75|0]<0&&Z(i[s+64>>2]),!m||(r=i[m+4>>2],i[m+4>>2]=r-1,r))break r;W[i[i[m>>2]+8>>2]](m),y(m)}v=s+80|0;break i}sf(),M()}i:{e:switch(u[_+32|0]){default:e2(),M();case 1:r=A,A=i[e>>2],c0(r,_+12|0,A?A+172|0:0);break i;case 0:break e}e=C(8),f=i[_+12>>2],r=i[_+16>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[e+4>>2]=r,i[e>>2]=f,i[l>>2]=e,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}A=u[_+32|0],(A|0)!=255&&(e=i[25779],i[_+40>>2]=i[25778],i[_+44>>2]=e,W[i[(_+40|0)+(A<<2)>>2]](_+39|0,_+12|0)),v=_+48|0}function Yv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0;k=v+-64|0,v=k,c=W[i[i[e>>2]+52>>2]](e,r,0)|0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+56>>2]=0,t[k+45|0]=0,t[k+46|0]=0,t[k+47|0]=0,t[k+48|0]=0,t[k+49|0]=0,t[k+50|0]=0,t[k+51|0]=0,t[k+52|0]=0,f=k+40|0,H0(f,u[e+97|0],2),H0(f,u[e+98|0],1),H0(f,u[e+99|0],1),H0(f,u[e+100|0],1),H0(f,u[e+101|0],1),H0(f,u[e+102|0],1),H0(f,u[e+103|0],1),H0(f,u[e+104|0],1),H0(f,u[e+105|0],1),H0(f,u[e+106|0],1),H0(f,u[e+108|0],2),H0(f,u[e+109|0]-1&255,3),o=o0[e+112>>2]>128|o0[e+116>>2]>128,H0(f,o,1),o=o?15:7,H0(f,i[e+112>>2]-1|0,o),H0(f,i[e+116>>2]-1|0,o);i:{if((u[e+108|0]-1&255)>>>0>1||(H0(f,u[e+121|0],1),u[e+108|0]!=1))break i;H0(f,u[e+122|0],1)}f=u[e+120|0];i:{if(u[e+99|0]==1){n=k+40|0,f=t2(f-16|0,28)-1|0,f>>>0<=6?f=i[(f<<2)+65024>>2]:f=0,H0(n,f,2);break i}if(n=k+40|0,H0(n,f>>>0>8,1),f>>>0<9)break i;H0(n,u[e+120|0]-9&255,3)}u[e+101|0]==1&&H0(k+40|0,u[e+123|0],1),u[e+102|0]==1&&(f=k+40|0,H0(f,u[e+124|0],8),H0(f,u[e+126|0],8),H0(f,u[e+128|0],8)),u[e+98|0]==1&&(f=k+40|0,H0(f,i[e+132>>2],32),H0(f,i[e+136>>2],32));i:{if(u[e+103|0]!=1)break i;f=k+40|0,H0(f,u[e+140|0],1);e:{if(u[e+140|0]!=1)break e;n=i[e+144>>2]==i[e+112>>2]&i[e+148>>2]==i[e+116>>2],H0(f,n,1),n||(H0(f,i[e+144>>2]-1|0,o),H0(f,i[e+148>>2]-1|0,o)),f=k+40|0,H0(f,u[e+152|0],8),H0(f,u[e+153|0],1),H0(f,u[e+154|0],2);r:{if((u[e+154|0]-1&255)>>>0>1||(H0(f,u[e+155|0],1),u[e+154|0]!=1))break r;H0(f,u[e+156|0],1)}f=k+40|0,H0(f,u[e+157|0],1),o=u[e+158|0];r:{if(u[e+157|0]==1){o=t2(o-16|0,28)-1|0,o>>>0<=6?n=i[(o<<2)+65024>>2]:n=0,H0(f,n,2);break r}if(f=k+40|0,H0(f,o>>>0>8,1),o>>>0<9)break r;H0(f,u[e+158|0]-9&255,3)}if(f=k+40|0,H0(f,u[e+159|0],1),H0(f,u[e+160|0],1),u[e+160|0]!=1)break e;H0(f,u[e+162|0],8),H0(f,u[e+164|0],8),H0(f,u[e+166|0],8),H0(f,u[e+168|0],1)}if(f=k+40|0,H0(f,i[e+172>>2]!=0,1),H0(f,i[e+180>>2]!=0,1),H0(f,i[e+188>>2]!=0,1),H0(f,i[e+196>>2]!=0,1),H0(f,u[e+169|0],1),H0(f,u[e+170|0],1),o=i[e+172>>2],o&&(H0(f,p[o+98>>1],16),H0(f,p[i[e+172>>2]+100>>1],16)),o=i[e+180>>2],o&&(f=k+40|0,H0(f,p[o+100>>1],16),H0(f,p[i[e+180>>2]+106>>1],16),H0(f,p[i[e+180>>2]+102>>1],16),H0(f,p[i[e+180>>2]+108>>1],16),H0(f,p[i[e+180>>2]+104>>1],16),H0(f,p[i[e+180>>2]+110>>1],16),H0(f,p[i[e+180>>2]+112>>1],16),H0(f,p[i[e+180>>2]+114>>1],16),H0(f,i[i[e+180>>2]+116>>2],32),H0(f,i[i[e+180>>2]+120>>2],32)),f=i[e+188>>2],f&&Ll(k+40|0,f),o=i[e+196>>2],o&&(f=k+40|0,H0(f,i[o+100>>2],32),H0(f,p[i[e+196>>2]+104>>1],16),H0(f,p[i[e+196>>2]+106>>1],16)),u[e+169|0]==1&&(f=k+40|0,H0(f,0,32),H0(f,0,16),H0(f,0,16),H0(f,0,32),H0(f,0,16),H0(f,0,16)),u[e+170|0]==1&&H0(k+40|0,0,32),u[e+140|0]!=1||(f=k+40|0,H0(f,i[e+208>>2]!=0,1),H0(f,i[e+216>>2]!=0,1),H0(f,i[e+224>>2]!=0,1),H0(f,i[e+232>>2]!=0,1),H0(f,u[e+204|0],1),H0(f,u[e+205|0],1),o=i[e+208>>2],o&&(H0(f,p[o+98>>1],16),H0(f,p[i[e+208>>2]+100>>1],16)),o=i[e+216>>2],o&&(f=k+40|0,H0(f,p[o+100>>1],16),H0(f,p[i[e+216>>2]+106>>1],16),H0(f,p[i[e+216>>2]+102>>1],16),H0(f,p[i[e+216>>2]+108>>1],16),H0(f,p[i[e+216>>2]+104>>1],16),H0(f,p[i[e+216>>2]+110>>1],16),H0(f,p[i[e+216>>2]+112>>1],16),H0(f,p[i[e+216>>2]+114>>1],16),H0(f,i[i[e+216>>2]+116>>2],32),H0(f,i[i[e+216>>2]+120>>2],32)),f=i[e+224>>2],f&&Ll(k+40|0,f),o=i[e+232>>2],o&&(f=k+40|0,H0(f,i[o+100>>2],32),H0(f,p[i[e+232>>2]+104>>1],16),H0(f,p[i[e+232>>2]+106>>1],16)),u[e+204|0]==1&&(f=k+40|0,H0(f,0,32),H0(f,0,16),H0(f,0,16),H0(f,0,32),H0(f,0,16),H0(f,0,16)),u[e+205|0]!=1))break i;H0(k+40|0,0,32)}O=i[e+268>>2],E=i[e+264>>2],h=O-E|0,_=i[e+436>>2],B=i[e+440>>2],G=i[e+424>>2],R=i[e+428>>2],I=i[e+412>>2],Q=i[e+416>>2],N=i[e+388>>2],U=i[e+392>>2],S=i[e+300>>2],q=i[e+304>>2],x=i[e+288>>2],m=i[e+292>>2],l=i[e+276>>2],s=i[e+280>>2],o=0,V=i[e+404>>2],Y=i[e+400>>2],j=(V|0)==(Y|0),f=0;i:{if(j||(f=0,!(t[e+101|0]&1))||(w=i[e+240>>2],n=i[e+244>>2]-w|0,(n|0)==(h|0)&&(f=0,!N2(w,E,h))))break i;f=n}w=u[e+103|0];i:{if(!(t[e+140|0]&1)|((I|0)==(Q|0)|(w|0)!=1)||(d=i[e+252>>2],n=i[e+256>>2]-d|0,(n|0)==(h|0)&&!N2(d,E,h)))break i;o=n}_=B-_|0,B=R-G|0,R=Q-I|0,V=V-Y|0,N=U-N|0,U=q-S|0,G=m-x|0,x=s-l|0,n=u[e+106|0],Y=u[e+104|0],m=u[e+105|0];i:{e:{if(!(n&1|(Y|m&1))){if(l=10,!w|!(t[e+140|0]&1))break i;n=0,l=1;break e}l=Y&&(l|0)!=(s|0)?x:0,l=m&1?l>>>0>B>>>0?l:B:l,n=n&1?l>>>0>_>>>0?l:_:l,l=w&u[e+140|0]}s=l&&t[e+159|0]&1?n>>>0>G>>>0?n:G:n,w=U+1|0,n=(l?s>>>0>w>>>0?s:w:n)>>>0>1024,H0(k+40|0,n,1),l=n?20:10}n=k+40|0,w=f|h|o,H0(n,w>>>0>7,1),m=N>>>0>32768|V>>>0>32767|R>>>0>32767,H0(n,m,1),u[e+104|0]==1&&H0(n,x-1|0,l),s=u[e+140|0],n=u[e+103|0],!(t[e+159|0]&1)|(!(s&1)|(n|0)!=1)||(H0(k+40|0,G-1|0,l),n=u[e+103|0],s=u[e+140|0]),!(n&1)|!(s&1)||(H0(k+40|0,U,l),s=u[e+140|0],n=u[e+103|0]);i:{e:{if(!(!(n&1)|!(s&1))){if(H0(k+40|0,R,m?28:15),t[e+103|0]&1)break e;break i}if(!(n&1))break i}if(!(t[e+140|0]&1)|(I|0)==(Q|0))break i;H0(k+40|0,o,w>>>0>7?12:3)}n=k+40|0,s=h,h=w>>>0>7?12:3,H0(n,s,h),s=m?28:15,H0(n,N-1|0,s);i:{if(u[e+101|0]!=1||(H0(n,V,s),!(t[e+101|0]&1)|j))break i;H0(n,f,h)}i:{if(!(u[e+105|0]|t[e+106|0]&1)||(n=k+40|0,H0(n,u[e+107|0],1),!(t[e+105|0]&1)))break i;H0(n,B-1|0,l)}u[e+106|0]==1&&H0(k+40|0,_-1|0,l);i:{e:{if(s=k+40|0,i[s+16>>2]>0){n=i[s+4>>2],l=i[s+8>>2];r:{if(n>>>0<l>>>0){t[n|0]=u[s+12|0],l=n+1|0;break r}if(_=i[s>>2],n=n-_|0,h=n+1|0,(h|0)<0)break e;if(l=l-_|0,B=l<<1,l=l>>>0>=1073741823?2147483647:h>>>0<B>>>0?B:h,l?h=C(l):h=0,B=h+n|0,t[B|0]=u[s+12|0],n&&z(h,_,n),i[s+8>>2]=l+h,l=B+1|0,i[s+4>>2]=l,i[s>>2]=h,!_)break r;Z(_)}i[s+16>>2]=0,t[s+12|0]=0,i[s+4>>2]=l}break i}s0(),M()}(E|0)!=(O|0)&&Y8(s,e+264|0),!(t[e+101|0]&1)|(!f|j)||Y8(k+40|0,e+240|0),!o|u[e+103|0]!=1|(!(t[e+140|0]&1)|(I|0)==(Q|0))||Y8(k+40|0,e+252|0),u[e+104|0]==1&&Y8(k+40|0,e+276|0),f=u[e+103|0];i:{e:{if(!(!(t[e+159|0]&1)|(!(t[e+140|0]&1)|(f|0)!=1))){if(Y8(k+40|0,e+288|0),t[e+103|0]&1)break e;break i}if(!f)break i}if(!(t[e+140|0]&1)|(S|0)==(q|0))break i;Y8(k+40|0,e+300|0)}!(t[e+101|0]&1)|j||Y8(k+40|0,e+400|0),f=e+388|0,!(t[e+140|0]&1)|((I|0)==(Q|0)|u[e+103|0]!=1)||Y8(k+40|0,e+412|0),o=k+40|0,Y8(o,f),u[e+105|0]==1&&Y8(o,e+424|0),u[e+106|0]==1&&Y8(k+40|0,e+436|0),l=0,n=0,h=k+28|0,i[h+8>>2]=0,i[h>>2]=0,i[h+4>>2]=0;i:{e:{if(f=i[k+44>>2],o=i[k+40>>2],(f|0)!=(o|0)){if(f=f-o|0,(f|0)<0)break e;n=C(f),i[h>>2]=n,l=f+n|0,i[h+8>>2]=l,f&&z(n,o,f),i[h+4>>2]=l}if(i[k+56>>2]>0){if(f=l-n|0,o=f+1|0,(o|0)<0)break e;l=f<<1,l=f>>>0>=1073741823?2147483647:o>>>0<l>>>0?l:o,l?o=C(l):o=0,s=o+f|0,t[s|0]=u[k+52|0],f&&z(o,n,f),i[h+8>>2]=o+l,f=s+1|0,i[h+4>>2]=f,i[h>>2]=o,n&&Z(n),i[h+4>>2]=f}break i}s0(),M()}F4(r,h),f=i[k+28>>2],f&&(i[k+32>>2]=f,Z(f)),n1(k+8|0,e,r,c),t[k+27|0]<0&&Z(i[k+16>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}A=i[k+40>>2],A&&(i[k+44>>2]=A,Z(A)),v=k- -64|0}function yv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;k=v-112|0,v=k,i[k+72>>2]=0,i[k+76>>2]=0,i[k+80>>2]=0,i[k+84>>2]=0,t[k+87|0]=0,t[k+88|0]=0,t[k+89|0]=0,t[k+90|0]=0,i[k+64>>2]=0,i[k+68>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+104>>2]=0,t[k+100|0]=1,h=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[k+44>>2]=e,i[k+40>>2]=h,W[i[i[f>>2]+100>>2]](k+48|0,i[f+4>>2],k+40|0,n);i:{e:{r:{if(!i[k+48>>2]){if(W[i[i[f>>2]+104>>2]](k+16|0,i[f+4>>2],k+12|0,k+8|0,0),i[k+56>>2]=i[k+24>>2],n=i[k+20>>2],e=i[k+16>>2],i[k+48>>2]=e,i[k+52>>2]=n,!e)break r;break e}if(Gi(k+16|0,k+48|0),e=i[k+20>>2],i[A>>2]=i[k+16>>2],i[A+4>>2]=e,e=A+8|0,t[k+35|0]>=0){r=i[k+28>>2],i[e>>2]=i[k+24>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+32>>2],t[A+44|0]=1;break i}if(T(e,i[k+24>>2],i[k+28>>2]),e=t[k+35|0],t[A+44|0]=1,(e|0)>=0)break i;Z(i[k+24>>2]);break i}for(;;){if(e=i[k+12>>2],e){if(Gr(k- -64|0,e,i[k+8>>2]),W[i[i[f>>2]+104>>2]](k+16|0,i[f+4>>2],k+12|0,k+8|0,0),i[k+56>>2]=i[k+24>>2],n=i[k+20>>2],e=i[k+16>>2],i[k+48>>2]=e,i[k+52>>2]=n,!e)continue;break e}break}h=C(120),i[h>>2]=98068,i[h+4>>2]=0,i[h+8>>2]=0,w=h+16|0,e=w,i[e+8>>2]=0,i[e+12>>2]=0,e=h,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,t[e+112|0]=0,i[e+16>>2]=106136,i[e+32>>2]=1781689160,o=C(128),i[o>>2]=98108,i[o+4>>2]=0,i[o+8>>2]=0,_=o+16|0,e=_,i[e+8>>2]=0,i[e+12>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=92500,i[o+60>>2]=0,i[o+64>>2]=0,i[o+52>>2]=0,i[o+56>>2]=0,i[o+72>>2]=-1,i[o+76>>2]=-1,i[o+80>>2]=-1,i[o+84>>2]=-1,i[o+88>>2]=0,i[o+92>>2]=0,i[o+96>>2]=0,i[o+100>>2]=0,i[o+104>>2]=0,i[o+108>>2]=0,t[o+112|0]=0,i[o+16>>2]=105816,i[o+124>>2]=0,i[o+116>>2]=0,i[o+120>>2]=0,i[o+32>>2]=1667523942;r:{f:{A:{k:{n:{t:{o:{l:switch(i[i[r>>2]+196>>2]){case 1:f=i[o+124>>2],e=i[o+120>>2];u:{if(f>>>0>e>>>0){X[e+4>>1]=1,X[e>>1]=0,X[e+2>>1]=0,r=e+6|0;break u}if(r=e,e=i[o+116>>2],n=r-e|0,l=((n|0)/6|0)+1|0,l>>>0>=715827883)break o;if(r=0,f=(f-e|0)/6|0,s=f<<1,f=f>>>0>=357913941?715827882:l>>>0<s>>>0?s:l,f){if(f>>>0>=715827883)break t;r=C(g(f,6))}if(l=r+n|0,X[l+4>>1]=1,X[l>>1]=0,X[l+2>>1]=0,s=l+g((n|0)/-6|0,6)|0,n&&z(s,e,n),f=g(f,6)+r|0,i[o+124>>2]=f,r=l+6|0,i[o+120>>2]=r,i[o+116>>2]=s,!e)break u;Z(e),f=i[o+124>>2]}i[o+120>>2]=r;u:{if(r>>>0<f>>>0){X[r+4>>1]=2,X[r>>1]=1,X[r+2>>1]=0,r=r+6|0;break u}if(n=i[o+116>>2],e=r-n|0,r=((e|0)/6|0)+1|0,r>>>0>=715827883)break o;if(f=(f-n|0)/6|0,l=f<<1,f=f>>>0>=357913941?715827882:r>>>0<l>>>0?l:r,f){if(f>>>0>=715827883)break t;r=C(g(f,6))}else r=0;if(l=r+e|0,X[l+4>>1]=2,X[l>>1]=1,X[l+2>>1]=0,s=l+g((e|0)/-6|0,6)|0,e&&z(s,n,e),f=r+g(f,6)|0,i[o+124>>2]=f,r=l+6|0,i[o+120>>2]=r,i[o+116>>2]=s,!n)break u;Z(n),f=i[o+124>>2]}if(i[o+120>>2]=r,r>>>0<f>>>0)break A;if(e=r,r=i[o+116>>2],e=e-r|0,n=((e|0)/6|0)+1|0,n>>>0>=715827883)break o;if(f=(f-r|0)/6|0,l=f<<1,n=f>>>0>=357913941?715827882:n>>>0<l>>>0?l:n,n){if(n>>>0>=715827883)break t;f=C(g(n,6))}else f=0;l=e+f|0,X[l+4>>1]=3;break f;case 0:f=i[o+124>>2],e=i[o+120>>2];u:{if(f>>>0>e>>>0){X[e+4>>1]=1,X[e>>1]=0,X[e+2>>1]=0,r=e+6|0;break u}if(r=e,e=i[o+116>>2],n=r-e|0,l=((n|0)/6|0)+1|0,l>>>0>=715827883)break n;if(r=0,f=(f-e|0)/6|0,s=f<<1,f=f>>>0>=357913941?715827882:l>>>0<s>>>0?s:l,f){if(f>>>0>=715827883)break t;r=C(g(f,6))}if(l=r+n|0,X[l+4>>1]=1,X[l>>1]=0,X[l+2>>1]=0,s=l+g((n|0)/-6|0,6)|0,n&&z(s,e,n),f=g(f,6)+r|0,i[o+124>>2]=f,r=l+6|0,i[o+120>>2]=r,i[o+116>>2]=s,!e)break u;Z(e),f=i[o+124>>2]}i[o+120>>2]=r;u:{if(r>>>0<f>>>0){X[r+4>>1]=2,X[r>>1]=1,X[r+2>>1]=0,r=r+6|0;break u}if(n=i[o+116>>2],e=r-n|0,r=((e|0)/6|0)+1|0,r>>>0>=715827883)break n;if(f=(f-n|0)/6|0,l=f<<1,f=f>>>0>=357913941?715827882:r>>>0<l>>>0?l:r,f){if(f>>>0>=715827883)break t;r=C(g(f,6))}else r=0;if(l=r+e|0,X[l+4>>1]=2,X[l>>1]=1,X[l+2>>1]=0,s=l+g((e|0)/-6|0,6)|0,e&&z(s,n,e),f=r+g(f,6)|0,i[o+124>>2]=f,r=l+6|0,i[o+120>>2]=r,i[o+116>>2]=s,!n)break u;Z(n),f=i[o+124>>2]}if(i[o+120>>2]=r,r>>>0<f>>>0)break A;if(e=r,r=i[o+116>>2],e=e-r|0,n=((e|0)/6|0)+1|0,n>>>0>=715827883)break n;if(f=(f-r|0)/6|0,l=f<<1,n=f>>>0>=357913941?715827882:n>>>0<l>>>0?l:n,n){if(n>>>0>=715827883)break t;f=C(g(n,6))}else f=0;l=e+f|0,X[l+4>>1]=3;break f;case 2:break l;default:break r}e=i[o+120>>2],l=i[o+124>>2];l:{if(e>>>0<l>>>0){X[e+4>>1]=1,X[e>>1]=0,X[e+2>>1]=0,f=e+6|0;break l}if(r=e,e=i[o+116>>2],r=r-e|0,f=((r|0)/6|0)+1|0,f>>>0>=715827883)break k;if(n=0,l=(l-e|0)/6|0,s=l<<1,l=l>>>0>=357913941?715827882:f>>>0<s>>>0?s:f,l){if(l>>>0>=715827883)break t;n=C(g(l,6))}if(f=r+n|0,X[f+4>>1]=1,X[f>>1]=0,X[f+2>>1]=0,s=f+g((r|0)/-6|0,6)|0,r&&z(s,e,r),i[o+124>>2]=g(l,6)+n,f=f+6|0,i[o+120>>2]=f,i[o+116>>2]=s,!e)break l;Z(e)}i[o+120>>2]=f;break r}s0(),M()}x0(),M()}s0(),M()}s0(),M()}X[r+4>>1]=3,X[r>>1]=2,X[r+2>>1]=0,i[o+120>>2]=r+6;break r}X[l>>1]=2,X[l+2>>1]=0,s=g((e|0)/-6|0,6)+l|0,e&&z(s,r,e),i[o+124>>2]=g(n,6)+f,e=l+6|0,i[o+120>>2]=e,i[o+116>>2]=s,r&&Z(r),i[o+120>>2]=e}i[k+20>>2]=o,i[k+16>>2]=_,i[o+4>>2]=i[o+4>>2]+1,P0(h+52|0,k+16|0),e=i[k+20>>2];r:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}i[h+4>>2]=i[h+4>>2]+1;r:{f:{r=i[k+72>>2],e=i[k+68>>2];A:{if(r>>>0>e>>>0){i[e+4>>2]=h,i[e>>2]=w,n=e+8|0;break A}if(f=i[k+64>>2],n=e-f|0,s=n>>3,e=s+1|0,e>>>0>=536870912)break f;if(r=r-f|0,l=r>>2,r=r>>>0>=2147483640?536870911:e>>>0<l>>>0?l:e,r){if(r>>>0>=536870912)break r;e=C(r<<3)}else e=0;if(l=e+n|0,i[l+4>>2]=h,i[l>>2]=w,w=l-(s<<3)|0,n&&z(w,f,n),r=e+(r<<3)|0,i[k+72>>2]=r,n=l+8|0,i[k+68>>2]=n,i[k+64>>2]=w,!f)break A;Z(f),r=i[k+72>>2]}if(t[k+90|0]=0,X[k+88>>1]=1,e=i[k+64>>2],i[k+64>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,f=i[k+84>>2],i[k+84>>2]=0,l=i[k+76>>2],w=i[k+80>>2],i[k+76>>2]=0,i[k+80>>2]=0,i[A+20>>2]=f,i[A+12>>2]=l,i[A+16>>2]=w,i[A+8>>2]=r,i[A+4>>2]=n,i[A>>2]=e,e=i[k+92>>2],i[A+24>>2]=i[k+88>>2],i[A+28>>2]=e,e=i[k+100>>2],i[A+32>>2]=i[k+96>>2],i[A+36>>2]=e,i[A+40>>2]=i[k+104>>2],t[A+44|0]=0,A=i[o+4>>2],i[o+4>>2]=A-1,A||(W[i[i[o>>2]+8>>2]](o),y(o)),A=i[h+4>>2],i[h+4>>2]=A-1,A)break i;W[i[i[h>>2]+8>>2]](h),y(h);break i}s0(),M()}x0(),M()}if(Gi(k+16|0,k+48|0),e=i[k+20>>2],i[A>>2]=i[k+16>>2],i[A+4>>2]=e,e=A+8|0,t[k+35|0]>=0){r=i[k+28>>2],i[e>>2]=i[k+24>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+32>>2],t[A+44|0]=1;break i}if(T(e,i[k+24>>2],i[k+28>>2]),e=t[k+35|0],t[A+44|0]=1,(e|0)>=0)break i;Z(i[k+24>>2])}A=i[k+44>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[k+76>>2],A&&(i[k+80>>2]=A,Z(A)),A=i[k+64>>2],A){if(e=A,f=i[k+68>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(A|0)==(f|0))break}e=i[k+64>>2]}i[k+68>>2]=A,Z(e)}v=k+112|0}function Ev(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;l=v-96|0,v=l;i:{e:{if(!(k&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break e}s=v-96|0,v=s,o=i[e>>2],n=i[o+48>>2],_=i[o+52>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),h=l+60|0;r:{if(!f){n=v-48|0,v=n,f=i[o+48>>2],B=i[o+52>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),o=v-32|0,v=o,i[o+28>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,L1(o,f,r,o+20|0);f:{if(i[o>>2]){i[n+40>>2]=0,i[n+44>>2]=0;break f}A:{if(w=i[o+20>>2],f=i[o+24>>2],(w|0)!=(f|0)){if(r=i[w>>2],r&&(m=i[n+44>>2],r=Z0(r,92792,95580),r))break A;if(w=w+8|0,(f|0)!=(w|0))for(;;){if(r=i[w>>2],r&&(m=0,r=Z0(r,92792,95580),r))break A;if(w=w+8|0,(f|0)==(w|0))break}i[n+40>>2]=0,i[n+44>>2]=0}i[n+40>>2]=0,i[n+44>>2]=0;break f}if(i[n+44>>2]=m,i[n+40>>2]=r,r=i[w+4>>2],i[n+44>>2]=r,!r)break f;i[r+4>>2]=i[r+4>>2]+1}if(t[o+19|0]<0&&Z(i[o+8>>2]),f=i[o+20>>2],f){if(r=f,w=i[o+24>>2],(r|0)!=(w|0)){for(;;){r=i[w-4>>2];f:{if(!r||(m=i[r+4>>2],i[r+4>>2]=m-1,m))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(w=w-8|0,(f|0)==(w|0))break}r=i[o+20>>2]}i[o+24>>2]=f,Z(r)}v=o+32|0,r=i[n+40>>2];f:{if(!r){r=C(32),i[n+4>>2]=r,i[n+8>>2]=26,i[n+12>>2]=-2147483616,f=u[10439]|u[10440]<<8,t[r+24|0]=f,t[r+25|0]=f>>>8,f=u[10435]|u[10436]<<8|(u[10437]<<16|u[10438]<<24),o=u[10431]|u[10432]<<8|(u[10433]<<16|u[10434]<<24),t[r+16|0]=o,t[r+17|0]=o>>>8,t[r+18|0]=o>>>16,t[r+19|0]=o>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[10427]|u[10428]<<8|(u[10429]<<16|u[10430]<<24),o=u[10423]|u[10424]<<8|(u[10425]<<16|u[10426]<<24),t[r+8|0]=o,t[r+9|0]=o>>>8,t[r+10|0]=o>>>16,t[r+11|0]=o>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,f=u[10419]|u[10420]<<8|(u[10421]<<16|u[10422]<<24),o=u[10415]|u[10416]<<8|(u[10417]<<16|u[10418]<<24),t[r|0]=o,t[r+1|0]=o>>>8,t[r+2|0]=o>>>16,t[r+3|0]=o>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+26|0]=0,r=a(n+16|0,2,116,n+4|0),f=i[r+4>>2],i[h>>2]=i[r>>2],i[h+4>>2]=f,f=h+8|0;A:{if(t[r+19|0]>=0){o=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=o,i[f+8>>2]=i[r+16>>2],t[h+20|0]=1;break A}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[h+20|0]=1,(f|0)>=0)break A;Z(i[r+8>>2])}if(t[n+15|0]<0&&Z(i[n+4>>2]),r=i[n+44>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r);break f}f=i[n+44>>2],t[h+20|0]=0,i[h+4>>2]=f,i[h>>2]=r}f:{if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break f;W[i[i[B>>2]+8>>2]](B),y(B)}v=n+48|0;break r}i[s+92>>2]=0,i[s+84>>2]=0,i[s+88>>2]=0,L1(s- -64|0,n,r,s+84|0);f:{if(i[s+64>>2]){r=i[s+68>>2],i[h>>2]=i[s+64>>2],i[h+4>>2]=r,r=h+8|0;A:{if(t[s+83|0]>=0){f=i[s+76>>2],i[r>>2]=i[s+72>>2],i[r+4>>2]=f,i[r+8>>2]=i[s+80>>2];break A}T(r,i[s+72>>2],i[s+76>>2])}t[h+20|0]=1;break f}o=f-1|0,n=i[s+84>>2],o>>>0>=i[s+88>>2]-n>>3>>>0&&(r=C(32),i[s+24>>2]=r,i[s+28>>2]=27,i[s+32>>2]=-2147483616,f=u[15152]|u[15153]<<8|(u[15154]<<16|u[15155]<<24),n=u[15148]|u[15149]<<8|(u[15150]<<16|u[15151]<<24),t[r|0]=n,t[r+1|0]=n>>>8,t[r+2|0]=n>>>16,t[r+3|0]=n>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+27|0]=0,f=u[15171]|u[15172]<<8|(u[15173]<<16|u[15174]<<24),t[r+23|0]=f,t[r+24|0]=f>>>8,t[r+25|0]=f>>>16,t[r+26|0]=f>>>24,f=u[15168]|u[15169]<<8|(u[15170]<<16|u[15171]<<24),n=u[15164]|u[15165]<<8|(u[15166]<<16|u[15167]<<24),t[r+16|0]=n,t[r+17|0]=n>>>8,t[r+18|0]=n>>>16,t[r+19|0]=n>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[15160]|u[15161]<<8|(u[15162]<<16|u[15163]<<24),n=u[15156]|u[15157]<<8|(u[15158]<<16|u[15159]<<24),t[r+8|0]=n,t[r+9|0]=n>>>8,t[r+10|0]=n>>>16,t[r+11|0]=n>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,r=a(s+44|0,5,2007,s+24|0),t[r+19|0]<0&&Z(i[r+8>>2]),t[s+35|0]<0&&Z(i[s+24>>2]),n=i[s+84>>2]),f=n+(o<<3)|0,r=i[f>>2],f=i[f+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);A:{k:{if(!r||(r=Z0(r,92792,95580),!r))break k;f&&(i[f+4>>2]=i[f+4>>2]+1),t[h+20|0]=0,i[h+4>>2]=f,i[h>>2]=r;break A}r=C(24),i[s+12>>2]=r,i[s+16>>2]=19,i[s+20>>2]=-2147483624,n=u[13877]|u[13878]<<8|(u[13879]<<16|u[13880]<<24),t[r+15|0]=n,t[r+16|0]=n>>>8,t[r+17|0]=n>>>16,t[r+18|0]=n>>>24,n=u[13874]|u[13875]<<8|(u[13876]<<16|u[13877]<<24),o=u[13870]|u[13871]<<8|(u[13872]<<16|u[13873]<<24),t[r+8|0]=o,t[r+9|0]=o>>>8,t[r+10|0]=o>>>16,t[r+11|0]=o>>>24,t[r+12|0]=n,t[r+13|0]=n>>>8,t[r+14|0]=n>>>16,t[r+15|0]=n>>>24,n=u[13866]|u[13867]<<8|(u[13868]<<16|u[13869]<<24),o=u[13862]|u[13863]<<8|(u[13864]<<16|u[13865]<<24),t[r|0]=o,t[r+1|0]=o>>>8,t[r+2|0]=o>>>16,t[r+3|0]=o>>>24,t[r+4|0]=n,t[r+5|0]=n>>>8,t[r+6|0]=n>>>16,t[r+7|0]=n>>>24,t[r+19|0]=0,r=a(s+24|0,5,2007,s+12|0),n=i[r+4>>2],i[h>>2]=i[r>>2],i[h+4>>2]=n,n=h+8|0;k:{if(t[r+19|0]>=0){o=i[r+12>>2],i[n>>2]=i[r+8>>2],i[n+4>>2]=o,i[n+8>>2]=i[r+16>>2],t[h+20|0]=1;break k}if(T(n,i[r+8>>2],i[r+12>>2]),n=t[r+19|0],t[h+20|0]=1,(n|0)>=0)break k;Z(i[r+8>>2])}if(t[s+23|0]>=0)break A;Z(i[s+12>>2])}if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(t[s+83|0]<0&&Z(i[s+72>>2]),r=i[s+84>>2],!r)break r;if(f=r,n=i[s+88>>2],(r|0)!=(n|0)){for(;;){f=i[n-4>>2];f:{if(!f||(h=i[f+4>>2],i[f+4>>2]=h-1,h))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(n=n-8|0,(r|0)==(n|0))break}f=i[s+84>>2]}i[s+88>>2]=r,Z(f)}r:{if(!_||(r=i[_+4>>2],i[_+4>>2]=r-1,r))break r;W[i[i[_>>2]+8>>2]](_),y(_)}v=s+96|0;r:{f:switch(u[l+80|0]){case 1:c0(A,l+60|0,i[e>>2]);break r;case 0:break f;default:break i}e=C(20),i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,i[e>>2]=1,r=i[l+60>>2];f:{if(t[r+115|0]>=0){i[l+56>>2]=i[r+112>>2],f=i[r+108>>2],i[l+48>>2]=i[r+104>>2],i[l+52>>2]=f;break f}T(l+48|0,i[r+104>>2],i[r+108>>2])}if(f=t[l+59|0],r=(f|0)<0,n=C((r?i[l+52>>2]:f)+1|0),f=i[l+48>>2],G=e,I=u8(n,r?f:l+48|0),i[G+4>>2]=I,r&&Z(f),u[l+80|0])break i;r=i[l+60>>2];f:{if(t[r+127|0]>=0){i[l+40>>2]=i[r+124>>2],f=i[r+120>>2],i[l+32>>2]=i[r+116>>2],i[l+36>>2]=f;break f}T(l+32|0,i[r+116>>2],i[r+120>>2])}if(f=t[l+43|0],r=(f|0)<0,n=C((r?i[l+36>>2]:f)+1|0),f=i[l+32>>2],G=e,I=u8(n,r?f:l+32|0),i[G+8>>2]=I,r&&Z(f),u[l+80|0])break i;r=i[l+60>>2];f:{if(t[r+139|0]>=0){i[l+24>>2]=i[r+136>>2],f=i[r+132>>2],i[l+16>>2]=i[r+128>>2],i[l+20>>2]=f;break f}T(l+16|0,i[r+128>>2],i[r+132>>2])}if(f=t[l+27|0],r=(f|0)<0,n=C((r?i[l+20>>2]:f)+1|0),f=i[l+16>>2],G=e,I=u8(n,r?f:l+16|0),i[G+12>>2]=I,r&&Z(f),u[l+80|0])break i;r=i[l+60>>2];f:{if(t[r+151|0]>=0){i[l+8>>2]=i[r+148>>2],f=i[r+144>>2],i[l>>2]=i[r+140>>2],i[l+4>>2]=f;break f}T(l,i[r+140>>2],i[r+144>>2])}f=t[l+11|0],r=(f|0)<0,n=C((r?i[l+4>>2]:f)+1|0),f=i[l>>2],G=e,I=u8(n,r?f:l),i[G+16>>2]=I,r&&Z(f),i[k>>2]=e,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}if(A=u[l+80|0],(A|0)==255)break e;e=i[25797],i[l+88>>2]=i[25796],i[l+92>>2]=e,W[i[(l+88|0)+(A<<2)>>2]](l+87|0,l+60|0)}v=l+96|0;return}e2(),M()}function Rv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0;f=v-96|0,v=f,i[f+56>>2]=0,i[f+60>>2]=0,e=f- -64|0,i[e>>2]=0,i[e+4>>2]=0,t[f+71|0]=0,t[f+72|0]=0,t[f+73|0]=0,t[f+74|0]=0,i[f+48>>2]=0,i[f+52>>2]=0,i[f+76>>2]=0,i[f+80>>2]=0,i[f+88>>2]=0,t[f+84|0]=1;i:{e:{e=i[r>>2];r:{if(i[e+196>>2]!=2){e=C(40),i[f+12>>2]=e,i[f+16>>2]=39,i[f+20>>2]=-2147483608,r=u[9698]|u[9699]<<8|(u[9700]<<16|u[9701]<<24),k=u[9694]|u[9695]<<8|(u[9696]<<16|u[9697]<<24),t[e+31|0]=k,t[e+32|0]=k>>>8,t[e+33|0]=k>>>16,t[e+34|0]=k>>>24,t[e+35|0]=r,t[e+36|0]=r>>>8,t[e+37|0]=r>>>16,t[e+38|0]=r>>>24,r=u[9691]|u[9692]<<8|(u[9693]<<16|u[9694]<<24),k=u[9687]|u[9688]<<8|(u[9689]<<16|u[9690]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[9683]|u[9684]<<8|(u[9685]<<16|u[9686]<<24),k=u[9679]|u[9680]<<8|(u[9681]<<16|u[9682]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[9675]|u[9676]<<8|(u[9677]<<16|u[9678]<<24),k=u[9671]|u[9672]<<8|(u[9673]<<16|u[9674]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[9667]|u[9668]<<8|(u[9669]<<16|u[9670]<<24),k=u[9663]|u[9664]<<8|(u[9665]<<16|u[9666]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+39|0]=0,e=a(f+24|0,4,3002,f+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+44|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+44|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(t[f+23|0]>=0)break r;Z(i[f+12>>2]);break r}if((K0(e,0)|0)!=8){e=C(40),i[f+12>>2]=e,i[f+16>>2]=37,i[f+20>>2]=-2147483608,r=u[9658]|u[9659]<<8|(u[9660]<<16|u[9661]<<24),k=u[9654]|u[9655]<<8|(u[9656]<<16|u[9657]<<24),t[e+29|0]=k,t[e+30|0]=k>>>8,t[e+31|0]=k>>>16,t[e+32|0]=k>>>24,t[e+33|0]=r,t[e+34|0]=r>>>8,t[e+35|0]=r>>>16,t[e+36|0]=r>>>24,r=u[9653]|u[9654]<<8|(u[9655]<<16|u[9656]<<24),k=u[9649]|u[9650]<<8|(u[9651]<<16|u[9652]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[9645]|u[9646]<<8|(u[9647]<<16|u[9648]<<24),k=u[9641]|u[9642]<<8|(u[9643]<<16|u[9644]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[9637]|u[9638]<<8|(u[9639]<<16|u[9640]<<24),k=u[9633]|u[9634]<<8|(u[9635]<<16|u[9636]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[9629]|u[9630]<<8|(u[9631]<<16|u[9632]<<24),k=u[9625]|u[9626]<<8|(u[9627]<<16|u[9628]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+37|0]=0,e=a(f+24|0,4,3002,f+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+44|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+44|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(t[f+23|0]>=0)break r;Z(i[f+12>>2]);break r}n=0,i[f+20>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,e=Q0(i[r>>2],0),e?(n=i[e+52>>2],e=i[e+40>>2]):e=0;f:{A:{k:{if(k=i[r>>2],s=i[k+192>>2],l=i[k+188>>2],k=g(s,l),k){if((k|0)<0)break k;o=C(k),k&&l0(o,0,k),h=k+o|0,i[f+20>>2]=h,i[f+16>>2]=h,i[f+12>>2]=o}if((n|0)==(l|0))break A;if(!s)break f;for(k=0;Gr(f+48|0,e+g(k,n)|0,l),k=k+1|0,(s|0)!=(k|0););break f}s0(),M()}Gr(f+48|0,e,k)}o=C(128),e=o,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=98388,n=e+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,e=o,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[n>>2]=107128,i[e+32>>2]=1836280643,t[e+120|0]=0,e=K0(i[r>>2],0);f:{if(e>>>0>=256){e=C(40),i[f>>2]=e,i[f+4>>2]=39,i[f+8>>2]=-2147483608,r=u[28263]|u[28264]<<8|(u[28265]<<16|u[28266]<<24),k=u[28259]|u[28260]<<8|(u[28261]<<16|u[28262]<<24),t[e+31|0]=k,t[e+32|0]=k>>>8,t[e+33|0]=k>>>16,t[e+34|0]=k>>>24,t[e+35|0]=r,t[e+36|0]=r>>>8,t[e+37|0]=r>>>16,t[e+38|0]=r>>>24,r=u[28256]|u[28257]<<8|(u[28258]<<16|u[28259]<<24),k=u[28252]|u[28253]<<8|(u[28254]<<16|u[28255]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[28248]|u[28249]<<8|(u[28250]<<16|u[28251]<<24),k=u[28244]|u[28245]<<8|(u[28246]<<16|u[28247]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[28240]|u[28241]<<8|(u[28242]<<16|u[28243]<<24),k=u[28236]|u[28237]<<8|(u[28238]<<16|u[28239]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[28232]|u[28233]<<8|(u[28234]<<16|u[28235]<<24),k=u[28228]|u[28229]<<8|(u[28230]<<16|u[28231]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+39|0]=0,e=a(f+24|0,2,0,f),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+44|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+44|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(t[f+11|0]>=0)break f;Z(i[f>>2]);break f}t[o+120|0]=e,i[o+4>>2]=i[o+4>>2]+1,k=i[f+56>>2],e=i[f+52>>2];A:{if(k>>>0>e>>>0){i[e+4>>2]=o,i[e>>2]=n,n=e+8|0;break A}if(s=i[f+48>>2],e=e-s|0,h=e>>3,r=h+1|0,r>>>0>=536870912)break e;if(k=k-s|0,l=k>>2,k=k>>>0>=2147483640?536870911:r>>>0<l>>>0?l:r,k){if(k>>>0>=536870912)break i;r=C(k<<3)}else r=0;if(l=r+e|0,i[l+4>>2]=o,i[l>>2]=n,h=l-(h<<3)|0,e&&z(h,s,e),k=r+(k<<3)|0,i[f+56>>2]=k,n=l+8|0,i[f+52>>2]=n,i[f+48>>2]=h,!s)break A;Z(s),k=i[f+56>>2]}e=i[f+60>>2],r=i[f+64>>2],i[f+56>>2]=0,i[f+60>>2]=0,s=i[f+48>>2],i[f+48>>2]=0,i[f+52>>2]=0,l=i[f+68>>2],i[f+64>>2]=0,i[f+68>>2]=0,i[A+20>>2]=l,i[A+12>>2]=e,i[A+16>>2]=r,i[A+8>>2]=k,i[A+4>>2]=n,i[A>>2]=s,e=i[f+76>>2],i[A+24>>2]=i[f+72>>2],i[A+28>>2]=e,e=i[f+84>>2],i[A+32>>2]=i[f+80>>2],i[A+36>>2]=e,i[A+40>>2]=i[f+88>>2],t[A+44|0]=0}if(A=i[o+4>>2],i[o+4>>2]=A-1,A||(W[i[i[o>>2]+8>>2]](o),y(o)),A=i[f+12>>2],!A)break r;i[f+16>>2]=A,Z(A)}if(A=i[f+60>>2],A&&(i[f+64>>2]=A,Z(A)),e=i[f+48>>2],e){if(k=i[f+52>>2],A=e,(k|0)!=(e|0)){for(;;){A=i[k-4>>2];r:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(k=k-8|0,(e|0)==(k|0))break}A=i[f+48>>2]}i[f+52>>2]=e,Z(A)}v=f+96|0;return}s0(),M()}x0(),M()}function Jv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0;e=v-128|0,v=e,n=K0(i[r>>2],0),o=K0(i[r>>2],1),S=K0(i[r>>2],2),_0=$2(i[r>>2],6),_0&&(M0=K0(i[r>>2],6));i:{if(!(!(n>>>0>8|o>>>0>8)&S>>>0<9)){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}if(!((n|0)==(o|0)&(n|0)==(S|0))){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}f=i[r>>2],Q=i[f+192>>2],k=i[f+188>>2],q=C(248),i[q>>2]=101168,f=q,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,N=f+12|0,i[f+176>>2]=N,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(N,k,Q,0,3),a0(e+56|0,N,0,k,Q,n,l,0),a0(e+32|0,N,1,k,Q,o,l,0),f=e+88|0;e:{if(i[e+56>>2]){if(n=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=n,t[e+75|0]>=0){n=e- -64|0,o=i[n+4>>2],i[f>>2]=i[n>>2],i[f+4>>2]=o,i[f+8>>2]=i[n+8>>2];break e}T(f,i[e+64>>2],i[e+68>>2]);break e}if(n=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=n,t[e+51|0]>=0){n=i[e+44>>2],i[f>>2]=i[e+40>>2],i[f+4>>2]=n,i[f+8>>2]=i[e+48>>2];break e}T(f,i[e+40>>2],i[e+44>>2])}a0(e+8|0,N,2,k,Q,S,l,0),n=e+112|0;e:{if(i[e+80>>2]){if(o=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=o,t[e+99|0]>=0){o=i[f+4>>2],i[n>>2]=i[f>>2],i[n+4>>2]=o,i[n+8>>2]=i[f+8>>2];break e}T(n,i[e+88>>2],i[e+92>>2]);break e}if(f=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=f,t[e+27|0]>=0){f=i[e+20>>2],i[n>>2]=i[e+16>>2],i[n+4>>2]=f,i[n+8>>2]=i[e+24>>2];break e}T(n,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){f=i[n+4>>2],i[r>>2]=i[n>>2],i[r+4>>2]=f,i[r+8>>2]=i[n+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!_0)break r;if(a0(e+104|0,N,6,k,Q,M0,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){f=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}f=Q0(i[r>>2],0),f?(g0=i[f+40>>2],f=i[f+52>>2]):f=0,S=f,f=Q0(i[r>>2],1),f?(U=i[f+52>>2],f=i[f+40>>2]):f=0,n=Q0(i[r>>2],2),n?(x=i[n+52>>2],n=i[n+40>>2]):n=0,o=Q0(N,0),o?(X0=i[o+52>>2],o=i[o+40>>2]):o=0,V0=o,o=Q0(N,1),o?(j=i[o+52>>2],o=i[o+40>>2]):o=0,l=Q0(N,2),l?(O=i[l+52>>2],l=i[l+40>>2]):l=0,t0=0;r:{if(!_0||(r=Q0(i[r>>2],6),r?(r2=i[r+40>>2],z0=i[r+52>>2]):z0=0,r=Q0(N,6),t0=0,!r))break r;f2=i[r+52>>2],t0=i[r+40>>2]}if(t[o|0]=u[f|0],t[l|0]=u[n|0],c=k-1|0,h=c>>>1|0,c>>>0>=2)for(s=h>>>0<=1?1:h,r=0;V=r<<1,w=V|1,G=r>>>1|0,Y=G+1|0,m=Y+f|0,_=f+G|0,t[w+o|0]=(u[m|0]+g(u[_|0],3)|0)+2>>>2,V=V+2|0,t[V+o|0]=(u[_|0]+g(u[m|0],3)|0)+2>>>2,R=l+w|0,w=n+Y|0,G=n+G|0,t[R|0]=(u[w|0]+g(u[G|0],3)|0)+2>>>2,t[l+V|0]=(u[G|0]+g(u[w|0],3)|0)+2>>>2,r=r+1|0,(s|0)!=(r|0););if(V=k&1,V||(r=(k>>>1|0)-1|0,t[o+c|0]=u[r+f|0],t[l+c|0]=u[r+n|0]),G=Q-1|0,s=G>>>1|0,G>>>0>=2)for(Y=s>>>0<=1?1:s,r=0;m=r<<1,_=m|1,w=r>>>1|0,B=w+1|0,I=f+g(B,U)|0,E=f+g(w,U)|0,t[o+g(_,j)|0]=(u[I|0]+g(u[E|0],3)|0)+2>>>2,m=m+2|0,t[o+g(m,j)|0]=(u[E|0]+g(u[I|0],3)|0)+2>>>2,R=l+g(_,O)|0,_=n+g(B,x)|0,w=n+g(w,x)|0,t[R|0]=(u[_|0]+g(u[w|0],3)|0)+2>>>2,t[l+g(m,O)|0]=(u[w|0]+g(u[_|0],3)|0)+2>>>2,r=r+1|0,(Y|0)!=(r|0););if(B=Q&1,B||(r=(Q>>>1|0)-1|0,t[o+g(G,j)|0]=u[f+g(r,U)|0],t[l+g(G,O)|0]=u[n+g(r,x)|0]),!(G>>>0<2|V))for(w=(k+l|0)-1|0,Y=(k+o|0)-1|0,I=s>>>0<=1?1:s,r=k>>>1|0,s=(r+n|0)-1|0,m=(r+f|0)-1|0,r=0;E=r<<1,A0=E|1,_=r>>>1|0,C0=_+1|0,r0=m+g(C0,U)|0,f0=m+g(_,U)|0,t[Y+g(A0,j)|0]=(u[r0|0]+g(u[f0|0],3)|0)+2>>>2,E=E+2|0,t[Y+g(E,j)|0]=(u[f0|0]+g(u[r0|0],3)|0)+2>>>2,R=w+g(O,A0)|0,A0=s+g(x,C0)|0,_=s+g(_,x)|0,t[R|0]=(u[A0|0]+g(u[_|0],3)|0)+2>>>2,t[w+g(O,E)|0]=(u[_|0]+g(u[A0|0],3)|0)+2>>>2,r=r+1|0,(I|0)!=(r|0););r:{if(B)break r;if(c>>>0>=2)for(s=h>>>0<=1?1:h,w=l+g(G,O)|0,Y=o+g(G,j)|0,r=(Q>>>1|0)-1|0,m=n+g(r,x)|0,_=f+g(r,U)|0,r=0;B=r<<1,I=B+Y|0,E=r>>>1|0,h=E+_|0,t[I+1|0]=(u[h+1|0]+g(u[h|0],3)|0)+2>>>2,t[I+2|0]=(u[h|0]+g(u[h+1|0],3)|0)+2>>>2,B=w+B|0,h=m+E|0,t[B+1|0]=(u[h+1|0]+g(u[h|0],3)|0)+2>>>2,t[B+2|0]=(u[h|0]+g(u[h+1|0],3)|0)+2>>>2,r=r+1|0,(s|0)!=(r|0););if(V)break r;h=k>>>1|0,r=(Q>>>1|0)-1|0,t[((o+g(G,j)|0)+k|0)-1|0]=u[(h+(f+g(r,U)|0)|0)-1|0],t[((l+g(G,O)|0)+k|0)-1|0]=u[(h+(n+g(r,x)|0)|0)-1|0]}r:{if(G>>>0>=2){if(c>>>0>=2)for(h=1;;){for(E=l+g(h,O)|0,A0=o+g(h,j)|0,r=h+1|0,C0=l+g(r,O)|0,r0=o+g(r,j)|0,r=h>>>1|0,f0=n+g(r,x)|0,A2=f+g(r,U)|0,r=r+1|0,s2=n+g(r,x)|0,v2=f+g(r,U)|0,r=1;s=r>>>1|0,w=s+s2|0,V=u[w+1|0],w=u[w|0],m=s+f0|0,Y=u[m|0],m=u[m+1|0],B=s+v2|0,_=u[B|0],d=r+A0|0,B=u[B+1|0],j0=g(B,3),I=s+A2|0,s=u[I|0],S0=g(s,3)+8|0,I=u[I+1|0],t[d+1|0]=j0+(_+(S0+g(I,9)|0)|0)>>>4,R=d,q0=g(_,3),d=g(I,3)+8|0,t[R|0]=B+(q0+(d+g(s,9)|0)|0)>>>4,R=r+r0|0,t[R+1|0]=(q0+(s+d|0)|0)+g(B,9)>>>4,t[R|0]=((I+S0|0)+g(_,9)|0)+j0>>>4,s=r+E|0,B=g(V,3),_=g(Y,3)+8|0,t[s+1|0]=B+(w+(_+g(m,9)|0)|0)>>>4,R=s,I=g(w,3),s=g(m,3)+8|0,t[R|0]=V+(I+(s+g(Y,9)|0)|0)>>>4,d=r+C0|0,t[d+1|0]=(I+(s+Y|0)|0)+g(V,9)>>>4,t[d|0]=B+((_+m|0)+g(w,9)|0)>>>4,r=r+2|0,c>>>0>r>>>0;);if(h=h+2|0,!(G>>>0>h>>>0))break}if(!Q)break r}if(_0){for(f=k<<(M0>>>0>8),r=0;k&&z(g(r,X0)+V0|0,g(r,S)+g0|0,k),f&&z(g(r,f2)+t0|0,g(r,z0)+r2|0,f),r=r+1|0,(Q|0)!=(r|0););break r}f=Q&1;f:{if(!G){r=0;break f}for(o=Q&-2,r=0,n=0;l=!k,l||z(g(r,X0)+V0|0,g(r,S)+g0|0,k),l||(l=r|1,z(g(l,X0)+V0|0,g(l,S)+g0|0,k)),r=r+2|0,n=n+2|0,(o|0)!=(n|0););}if(!f|!k)break r;z(g(r,X0)+V0|0,g(r,S)+g0|0,k)}t[A+20|0]=0,i[A+4>>2]=q,i[A>>2]=N;break i}if(A=i[q+4>>2],i[q+4>>2]=A-1,A)break i;W[i[i[q>>2]+8>>2]](q),y(q)}v=e+128|0}function Nv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;l=v-16|0,v=l,_=i[r>>2],m=i[r+4>>2]-_|0,w=i[k>>2];i:{if(m-w>>>0<=(f|0)/8<<2>>>0){if(e=C(56),i[l+4>>2]=e,i[l+8>>2]=50,i[l+12>>2]=-2147483592,f=u[9707]|u[9708]<<8|(u[9709]<<16|u[9710]<<24),r=u[9703]|u[9704]<<8|(u[9705]<<16|u[9706]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+50|0]=0,r=u[9751]|u[9752]<<8,t[e+48|0]=r,t[e+49|0]=r>>>8,f=u[9747]|u[9748]<<8|(u[9749]<<16|u[9750]<<24),r=u[9743]|u[9744]<<8|(u[9745]<<16|u[9746]<<24),t[e+40|0]=r,t[e+41|0]=r>>>8,t[e+42|0]=r>>>16,t[e+43|0]=r>>>24,t[e+44|0]=f,t[e+45|0]=f>>>8,t[e+46|0]=f>>>16,t[e+47|0]=f>>>24,f=u[9739]|u[9740]<<8|(u[9741]<<16|u[9742]<<24),r=u[9735]|u[9736]<<8|(u[9737]<<16|u[9738]<<24),t[e+32|0]=r,t[e+33|0]=r>>>8,t[e+34|0]=r>>>16,t[e+35|0]=r>>>24,t[e+36|0]=f,t[e+37|0]=f>>>8,t[e+38|0]=f>>>16,t[e+39|0]=f>>>24,f=u[9731]|u[9732]<<8|(u[9733]<<16|u[9734]<<24),r=u[9727]|u[9728]<<8|(u[9729]<<16|u[9730]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[9723]|u[9724]<<8|(u[9725]<<16|u[9726]<<24),r=u[9719]|u[9720]<<8|(u[9721]<<16|u[9722]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[9715]|u[9716]<<8|(u[9717]<<16|u[9718]<<24),r=u[9711]|u[9712]<<8|(u[9713]<<16|u[9714]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,136,l+4|0),t[l+15|0]>=0)break i;Z(i[l+4>>2]);break i}o=w+_|0,B=u[o|0],h=u[o+1|0];e:{if((f|0)==32){s=u[o+3|0],o=u[o+2|0],i[k>>2]=w+4,i[e+4>>2]=h<<16|B<<24|o<<8|s,o=i[k>>2],s=o+_|0,s=u[s|0]|u[s+1|0]<<8|(u[s+2|0]<<16|u[s+3|0]<<24),i[k>>2]=o+4,i[e+8>>2]=s<<24|(s&65280)<<8|(s>>>8&65280|s>>>24),w=i[k>>2],o=_+w|0,B=u[o+1|0]<<16|u[o|0]<<24|u[o+2|0]<<8,h=o+3|0,s=4;break e}i[k>>2]=w+2,i[e+4>>2]=(h<<16|B<<24)>>16,h=i[k>>2],o=h+_|0,s=u[o+1|0],o=u[o|0],i[k>>2]=h+2,i[e+8>>2]=(s<<16|o<<24)>>16,w=i[k>>2],o=_+w|0,h=o+1|0,B=u[o|0]<<8,s=2}o=u[h|0],i[k>>2]=s+w,i[e+12>>2]=o|B,o=i[k>>2],h=o+_|0,s=u[h|0],w=u[h+1|0];e:{if((f|0)==32){f=w<<16|s<<24|u[h+2|0]<<8,w=u[h+3|0],s=4;break e}f=s<<8,s=2}if(i[k>>2]=s+o,i[e+16>>2]=f|w,o=i[k>>2],f=u[o+_|0],w=o+1|0,i[k>>2]=w,f){if(e=C(56),i[l+4>>2]=e,i[l+8>>2]=51,i[l+12>>2]=-2147483592,f=u[18081]|u[18082]<<8|(u[18083]<<16|u[18084]<<24),r=u[18077]|u[18078]<<8|(u[18079]<<16|u[18080]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+51|0]=0,r=u[18124]|u[18125]<<8|(u[18126]<<16|u[18127]<<24),t[e+47|0]=r,t[e+48|0]=r>>>8,t[e+49|0]=r>>>16,t[e+50|0]=r>>>24,f=u[18121]|u[18122]<<8|(u[18123]<<16|u[18124]<<24),r=u[18117]|u[18118]<<8|(u[18119]<<16|u[18120]<<24),t[e+40|0]=r,t[e+41|0]=r>>>8,t[e+42|0]=r>>>16,t[e+43|0]=r>>>24,t[e+44|0]=f,t[e+45|0]=f>>>8,t[e+46|0]=f>>>16,t[e+47|0]=f>>>24,f=u[18113]|u[18114]<<8|(u[18115]<<16|u[18116]<<24),r=u[18109]|u[18110]<<8|(u[18111]<<16|u[18112]<<24),t[e+32|0]=r,t[e+33|0]=r>>>8,t[e+34|0]=r>>>16,t[e+35|0]=r>>>24,t[e+36|0]=f,t[e+37|0]=f>>>8,t[e+38|0]=f>>>16,t[e+39|0]=f>>>24,f=u[18105]|u[18106]<<8|(u[18107]<<16|u[18108]<<24),r=u[18101]|u[18102]<<8|(u[18103]<<16|u[18104]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[18097]|u[18098]<<8|(u[18099]<<16|u[18100]<<24),r=u[18093]|u[18094]<<8|(u[18095]<<16|u[18096]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[18089]|u[18090]<<8|(u[18091]<<16|u[18092]<<24),r=u[18085]|u[18086]<<8|(u[18087]<<16|u[18088]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,136,l+4|0),t[l+15|0]>=0)break i;Z(i[l+4>>2]);break i}e:{if(s=i[e+12>>2],s&&(h=i[e+16>>2],h))break e;if(e=C(24),i[l+4>>2]=e,i[l+8>>2]=21,i[l+12>>2]=-2147483624,f=u[28272]|u[28273]<<8|(u[28274]<<16|u[28275]<<24),r=u[28268]|u[28269]<<8|(u[28270]<<16|u[28271]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+21|0]=0,f=u[28285]|u[28286]<<8|(u[28287]<<16|u[28288]<<24),r=u[28281]|u[28282]<<8|(u[28283]<<16|u[28284]<<24),t[e+13|0]=r,t[e+14|0]=r>>>8,t[e+15|0]=r>>>16,t[e+16|0]=r>>>24,t[e+17|0]=f,t[e+18|0]=f>>>8,t[e+19|0]=f>>>16,t[e+20|0]=f>>>24,f=u[28280]|u[28281]<<8|(u[28282]<<16|u[28283]<<24),r=u[28276]|u[28277]<<8|(u[28278]<<16|u[28279]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,0,l+4|0),t[l+15|0]>=0)break i;Z(i[l+4>>2]);break i}if(f=L0(h,0,s,0),o=h0,(o|0)==3&f>>>0>=4294967289|o>>>0>3){if(e=C(48),i[l+4>>2]=e,i[l+8>>2]=46,i[l+12>>2]=-2147483600,f=u[27834]|u[27835]<<8|(u[27836]<<16|u[27837]<<24),r=u[27830]|u[27831]<<8|(u[27832]<<16|u[27833]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+46|0]=0,f=u[27872]|u[27873]<<8|(u[27874]<<16|u[27875]<<24),r=u[27868]|u[27869]<<8|(u[27870]<<16|u[27871]<<24),t[e+38|0]=r,t[e+39|0]=r>>>8,t[e+40|0]=r>>>16,t[e+41|0]=r>>>24,t[e+42|0]=f,t[e+43|0]=f>>>8,t[e+44|0]=f>>>16,t[e+45|0]=f>>>24,f=u[27866]|u[27867]<<8|(u[27868]<<16|u[27869]<<24),r=u[27862]|u[27863]<<8|(u[27864]<<16|u[27865]<<24),t[e+32|0]=r,t[e+33|0]=r>>>8,t[e+34|0]=r>>>16,t[e+35|0]=r>>>24,t[e+36|0]=f,t[e+37|0]=f>>>8,t[e+38|0]=f>>>16,t[e+39|0]=f>>>24,f=u[27858]|u[27859]<<8|(u[27860]<<16|u[27861]<<24),r=u[27854]|u[27855]<<8|(u[27856]<<16|u[27857]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[27850]|u[27851]<<8|(u[27852]<<16|u[27853]<<24),r=u[27846]|u[27847]<<8|(u[27848]<<16|u[27849]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[27842]|u[27843]<<8|(u[27844]<<16|u[27845]<<24),r=u[27838]|u[27839]<<8|(u[27840]<<16|u[27841]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,6,0,l+4|0),t[l+15|0]>=0)break i;Z(i[l+4>>2]);break i}if(s=O1(i[n+8>>2],i[n+12>>2],s,0),!h0&s>>>0<h>>>0){if(e=A,A=V2(l+4|0,27484),a(e,6,1e3,A),t[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(f=f+7|0,o=f>>>0<7?o+1|0:o,f=(o&7)<<29|f>>>3,h=o>>>3|0,!h&m-w>>>0<f>>>0|h){if(e=A,A=V2(l+4|0,20806),a(e,2,136,A),t[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(D4(A,e+32|0,f,n,11008),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),pl(e+20|0,f),f&&z(i[e+20>>2],i[r>>2]+i[k>>2]|0,f),i[k>>2]=f+i[k>>2],Z8(A,114912)}v=l+16|0}function H9(){var A=0,e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0;i:{if(l=E2(11296),l)for(l0(l,255,11296),k=l+1056|0,i[33100]=k,i[33096]=k,i[33095]=l+992,i[33094]=l+928,i[33093]=l+864,i[33092]=l+800,i[33091]=l+736,i[33090]=l+672,i[33089]=l+608,i[33088]=l+544,i[33087]=l+480,i[33086]=l+416,i[33085]=l+352,i[33084]=l+288,i[33083]=l+224,i[33082]=l+160,i[33081]=l+96,i[33080]=l+32,k=l+16|0,i[33079]=k,i[33078]=k,i[33077]=k,i[33076]=k,i[33075]=k,i[33074]=k,i[33073]=k,i[33072]=k,i[33071]=l,i[33070]=l,i[33069]=l,i[33068]=l,i[33067]=l,i[33066]=l,i[33065]=l,i[33064]=l,k=l+1312|0,i[33101]=k,i[33097]=k,k=l+1568|0,i[33102]=k,i[33098]=k,k=l+2080|0,i[33108]=k,i[33104]=k,k=l+1824|0,i[33103]=k,i[33099]=k,k=l+2336|0,i[33109]=k,i[33105]=k,k=l+2592|0,i[33110]=k,i[33106]=k,k=l+3104|0,i[33116]=k,i[33112]=k,k=l+2848|0,i[33111]=k,i[33107]=k,k=l+4128|0,i[33117]=k,i[33113]=k,k=l+5152|0,i[33118]=k,i[33114]=k,k=l+7200|0,i[33124]=k,i[33120]=k,k=l+6176|0,i[33119]=k,i[33115]=k,k=l+8224|0,i[33125]=k,i[33121]=k,k=l+9248|0,i[33126]=k,i[33122]=k,k=l+10272|0,i[33127]=k,i[33123]=k,m=2;;){N=m-2|0,s=1<<m;e:{if((m|0)!=2){for(V=(m|0)==3,B=V?11:14,U=0,r=1;;){for(k=1,A=0;;){for(Y=((N<<6)+(U<<5)|0)+(A<<4)|0,I=Y+132256|0,E=k?9:15,h=0;;){for(R=h&3,o=h<<m,A=0;;){f=A|h,e=0;r:{if(!f)break r;if(e=R+(A&3)|0,w=e>>>0<=2?e?1:2:0,r){if(w=f>>>0<4?w:w+3|0,e=w+E|0,(m|0)==3)break r;e=w+21|0;break r}if(e=w+9|0,(m|0)==3)break r;e=w|12}if(w=o+(i[I>>2]+A|0)|0,f=u[w|0],e=r?e:e+27|0,(f|0)!=255&(e|0)!=(f|0))break i;if(t[w|0]=e,A=A+1|0,(s|0)==(A|0))break}if(h=h+1|0,(h|0)==(s|0))break}for(o=Y+132260|0,h=0;;){for(e=h&3,w=e?(e|0)==1:2,f=V?w+9|0:w|12,G=w+3|0,n=h<<m,A=0;;){I=A|h,e=I?f:0,R=!r;r:{if(R|!I)break r;if(e=I>>>0<4?w:G,!V){e=e+21|0;break r}e=e+E|0}if(I=n+(i[o>>2]+A|0)|0,_=u[I|0],e=r?e:e+27|0,(_|0)!=255&(e|0)!=(_|0))break i;if(t[I|0]=e,A=A+1|0,(s|0)==(A|0))break}if(h=h+1|0,(h|0)==(s|0))break}for(I=Y+132264|0,h=0;;){for(o=h<<m,A=0;;){f=A|h,e=0;r:{if(!f)break r;if(e=A&3,w=e?(e|0)==1:2,!r){if(e=w|12,!V)break r;e=w+9|0;break r}if(w=f>>>0<4?w:w+3|0,e=w+21|0,!V)break r;e=w+E|0}if(w=o+(i[I>>2]+A|0)|0,f=u[w|0],e=r?e:e+27|0,(f|0)!=255&(e|0)!=(f|0))break i;if(t[w|0]=e,A=A+1|0,(s|0)==(A|0))break}if(h=h+1|0,(h|0)==(s|0))break}for(Y=Y+132268|0,h=0;;){for(I=h<<m,A=0;;){w=A|h,e=w?B:0;r:{if(R|!w)break r;if(e=w>>>0<4?2:5,!V){e=e+21|0;break r}e=e+E|0}if(w=I+(i[Y>>2]+A|0)|0,o=u[w|0],e=r?e:e+27|0,(o|0)!=255&(e|0)!=(o|0))break i;if(t[w|0]=e,A=A+1|0,(s|0)==(A|0))break}if(h=h+1|0,(h|0)==(s|0))break}if(A=1,e=k,k=0,!e)break}if(U=1,k=r,r=0,!k)break}break e}for(h=N<<6,V=h+132284|0,E=h+132280|0,w=h+132276|0,Y=h+132272|0,N=h+132268|0,U=h+132264|0,I=h+132260|0,R=h+132256|0,e=0,k=1;;){r=0;r:{if(!k){for(e=h+(e<<5)|0,B=e+132256|0;;){for(o=r<<2,f=r<<m,A=0;;){if(G=f+(i[B>>2]+A|0)|0,n=u[G|0],Q=(n|0)!=255,_=n,n=u[(A+o|0)+69520|0]+27|0,Q&(_|0)!=(n|0))break i;if(t[G|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+132260|0,r=0;;){for(o=r<<2,f=r<<m,A=0;;){if(G=f+(i[B>>2]+A|0)|0,n=u[G|0],Q=(n|0)!=255,_=n,n=u[(A+o|0)+69520|0]+27|0,Q&(_|0)!=(n|0))break i;if(t[G|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+132264|0,r=0;;){for(o=r<<2,f=r<<m,A=0;;){if(G=f+(i[B>>2]+A|0)|0,n=u[G|0],Q=(n|0)!=255,_=n,n=u[(A+o|0)+69520|0]+27|0,Q&(_|0)!=(n|0))break i;if(t[G|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+132268|0,r=0;;){for(o=r<<2,f=r<<m,A=0;;){if(G=f+(i[B>>2]+A|0)|0,n=u[G|0],Q=(n|0)!=255,_=n,n=u[(A+o|0)+69520|0]+27|0,Q&(_|0)!=(n|0))break i;if(t[G|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+132272|0,r=0;;){for(o=r<<2,f=r<<m,A=0;;){if(G=f+(i[B>>2]+A|0)|0,n=u[G|0],Q=(n|0)!=255,_=n,n=u[(A+o|0)+69520|0]+27|0,Q&(_|0)!=(n|0))break i;if(t[G|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+132276|0,r=0;;){for(o=r<<2,f=r<<m,A=0;;){if(G=f+(i[B>>2]+A|0)|0,n=u[G|0],Q=(n|0)!=255,_=n,n=u[(A+o|0)+69520|0]+27|0,Q&(_|0)!=(n|0))break i;if(t[G|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+132280|0,r=0;;){for(o=r<<2,f=r<<m,A=0;;){if(G=f+(i[B>>2]+A|0)|0,n=u[G|0],Q=(n|0)!=255,_=n,n=u[(A+o|0)+69520|0]+27|0,Q&(_|0)!=(n|0))break i;if(t[G|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(e=e+132284|0,r=0;;){for(B=r<<2,o=r<<m,A=0;;){if(f=o+(i[e>>2]+A|0)|0,G=u[f|0],_=(G|0)!=255,n=G,G=u[(A+B|0)+69520|0]+27|0,_&(n|0)!=(G|0))break i;if(t[f|0]=G,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}break r}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(o=B+(i[R>>2]+A|0)|0,f=u[o|0],_=(f|0)!=255,n=f,f=u[(A+e|0)+69520|0],_&(n|0)!=(f|0))break i;if(t[o|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(o=B+(i[I>>2]+A|0)|0,f=u[o|0],_=(f|0)!=255,n=f,f=u[(A+r|0)+69520|0],_&(n|0)!=(f|0))break i;if(t[o|0]=f,A=A+1|0,(s|0)==(A|0))break}if(r=0,e=e+1|0,(s|0)==(e|0))break}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(o=B+(i[U>>2]+A|0)|0,f=u[o|0],_=(f|0)!=255,n=f,f=u[(A+e|0)+69520|0],_&(n|0)!=(f|0))break i;if(t[o|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(o=B+(i[N>>2]+A|0)|0,f=u[o|0],_=(f|0)!=255,n=f,f=u[(A+r|0)+69520|0],_&(n|0)!=(f|0))break i;if(t[o|0]=f,A=A+1|0,(s|0)==(A|0))break}if(r=0,e=e+1|0,(s|0)==(e|0))break}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(o=B+(i[Y>>2]+A|0)|0,f=u[o|0],_=(f|0)!=255,n=f,f=u[(A+e|0)+69520|0],_&(n|0)!=(f|0))break i;if(t[o|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(o=B+(i[w>>2]+A|0)|0,f=u[o|0],_=(f|0)!=255,n=f,f=u[(A+r|0)+69520|0],_&(n|0)!=(f|0))break i;if(t[o|0]=f,A=A+1|0,(s|0)==(A|0))break}if(r=0,e=e+1|0,(s|0)==(e|0))break}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(o=B+(i[E>>2]+A|0)|0,f=u[o|0],_=(f|0)!=255,n=f,f=u[(A+e|0)+69520|0],_&(n|0)!=(f|0))break i;if(t[o|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(o=B+(i[V>>2]+A|0)|0,f=u[o|0],_=(f|0)!=255,n=f,f=u[(A+r|0)+69520|0],_&(n|0)!=(f|0))break i;if(t[o|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=e+1|0,(s|0)==(e|0))break}}if(e=1,r=k,k=0,!r)break}}if(m=m+1|0,(m|0)==6)break}return(l|0)!=0}U0(19644,19977,2114,14982),M()}function Dv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=D(0),w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=D(0),d=0,c=0,A0=0,t0=0,_0=D(0),g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=D(0);e=v-128|0,v=e,f=i[r>>2],G=i[f+200>>2],I=K0(f,0),k=K0(i[r>>2],1),f=K0(i[r>>2],2),O=$2(i[r>>2],6),O&&(d=K0(i[r>>2],6));i:{if(!(!((I|0)!=8|(k|0)!=8)&(f|0)==8)){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,f=A+8|0;e:{if(t[114951]>=0){r=i[28736],i[f>>2]=i[28735],i[f+4>>2]=r,i[f+8>>2]=i[28737];break e}T(f,i[28735],i[28736])}t[A+20|0]=1;break i}f=i[r>>2],n=i[f+192>>2],_=i[f+188>>2],s=C(248),i[s>>2]=101168,i[s+4>>2]=0,i[s+8>>2]=0,l0(s+16|0,0,156),i[s+76>>2]=0,i[s+80>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,t[s+24|0]=1,X[s+22>>1]=2,X[s+18>>1]=2,X[s+20>>1]=2,i[s+84>>2]=0,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+128>>2]=0,i[s+132>>2]=0,i[s+100>>2]=0,i[s+104>>2]=1,i[s+136>>2]=0,i[s+140>>2]=0,i[s+144>>2]=0,i[s+148>>2]=0,i[s+152>>2]=0,i[s+156>>2]=0,X[s+158>>1]=0,X[s+160>>1]=0,X[s+162>>1]=0,X[s+164>>1]=0,i[s+184>>2]=0,i[s+188>>2]=0,i[s+172>>2]=255,i[s+192>>2]=0,i[s+196>>2]=5186,i[s+208>>2]=99,i[s+212>>2]=99,i[s+200>>2]=0,i[s+204>>2]=0,i[s+12>>2]=101488,i[s+216>>2]=0,i[s+220>>2]=0,i[s+224>>2]=0,i[s+228>>2]=0,i[s+232>>2]=0,i[s+236>>2]=0,i[s+240>>2]=0,i[s+244>>2]=0,o=s+12|0,i[s+176>>2]=o,i[s+8>>2]=i[s+8>>2]+1,i[s+180>>2]=s,i[s+4>>2]==-1&&(W[i[i[s>>2]+8>>2]](s),y(s)),t1(o,_,n,1,3),a0(e+56|0,o,3,_,n,I,l,0),a0(e+32|0,o,4,_,n,I,l,0),B=e+88|0;e:{if(i[e+56>>2]){if(f=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=f,t[e+75|0]>=0){k=e- -64|0,f=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=f,i[B+8>>2]=i[k+8>>2];break e}T(B,i[e+64>>2],i[e+68>>2]);break e}if(f=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=f,t[e+51|0]>=0){f=i[e+44>>2],i[B>>2]=i[e+40>>2],i[B+4>>2]=f,i[B+8>>2]=i[e+48>>2];break e}T(B,i[e+40>>2],i[e+44>>2])}a0(e+8|0,o,5,_,n,I,l,0),k=e+112|0;e:{if(i[e+80>>2]){if(f=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=f,t[e+99|0]>=0){f=i[B+4>>2],i[k>>2]=i[B>>2],i[k+4>>2]=f,i[k+8>>2]=i[B+8>>2];break e}T(k,i[e+88>>2],i[e+92>>2]);break e}if(f=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=f,t[e+27|0]>=0){f=i[e+20>>2],i[k>>2]=i[e+16>>2],i[k+4>>2]=f,i[k+8>>2]=i[e+24>>2];break e}T(k,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,f=A+8|0,t[e+123|0]>=0){r=i[k+4>>2],i[f>>2]=i[k>>2],i[f+4>>2]=r,i[f+8>>2]=i[k+8>>2],t[A+20|0]=1;break e}if(T(f,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!O)break r;if(a0(e+104|0,o,6,_,n,d,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,f=A+8|0,t[e+123|0]>=0){r=i[e+116>>2],i[f>>2]=i[e+112>>2],i[f+4>>2]=r,i[f+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(f,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}f=Q0(i[r>>2],0),f?(X0=i[f+40>>2],f=i[f+52>>2]):f=0,V0=f,f=Q0(i[r>>2],1),f?(C0=i[f+52>>2],f=i[f+40>>2]):f=0,r0=f,f=Q0(i[r>>2],2),f?(f0=i[f+40>>2],f=i[f+52>>2]):f=0,M0=f,f=Q0(o,3),f?(z0=i[f+52>>2],B=i[f+40>>2]):B=0,f=Q0(o,4),f?(j0=i[f+40>>2],I=i[f+52>>2]):I=0,f=Q0(o,5),f?(S0=i[f+52>>2],k=i[f+40>>2]):k=0,f=0;r:{if(!O||(f=Q0(i[r>>2],6),f?(c=i[f+40>>2],S=i[f+52>>2]):S=0,l=Q0(o,6),f=0,!l))break r;A0=i[l+52>>2],f=i[l+40>>2]}t0=f,l=G<<3,f=G>>>0<4,w=(f?16908801>>>l|0:0)&3,l=(f?16843265>>>l|0:0)&3,i[e+116>>2]=-1086926434,i[e+120>>2]=1071829221,i[e+108>>2]=1068725436,i[e+112>>2]=-1095748968,t[e+104|0]=1;r:{if(!r8(i[r>>2])){r=2,G=1;break r}r=i[r>>2],f=p[r+6>>1]|p[r+8>>1]<<16,r=p[r+10>>1]|p[r+12>>1]<<16,Pe(e+80|0,r&65535,f&65535),i[e+120>>2]=i[e+96>>2],f=i[e+92>>2],i[e+112>>2]=i[e+88>>2],i[e+116>>2]=f,f=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=f,G=(r&65536)>>>16|0}r:{if(!n)break r;if(Q=_<<(d>>>0>8),_){for(V=w-1|0,q0=l-1|0,r2=_&-2,f2=_&1,d=r&65535;;){Y=g(m,S0)+k|0,E=g(m,I)+j0|0,R=g(m,z0)+B|0,N=g(m,V0)+X0|0,r=m>>>q0|0,U=g(r,M0)+f0|0,x=g(r,C0)+r0|0,r=0,l=0;f:{A:{k:switch(d|0){default:for(;r=l>>>V|0,w=u[r+x|0],f=l+R|0,h=D(u[r+U|0]-128|0),q=G?h:D(h*D(1.142899990081787)),h=D(u[l+N|0]),_0=G?h:D(D(h+D(-16))*D(1.1689000129699707)),h=D(D(D(E0[e+108>>2]*q)+_0)+D(.5)),D(B2(h))<D(2147483648)?r=~~h:r=-2147483648,t[f|0]=(r|0)>=0?r>>>0>=255?255:r:0,f=l+E|0,A2=D(E0[e+116>>2]*q),h=D(w-128|0),q=G?h:D(h*D(1.142899990081787)),h=D(D(A2+D(D(E0[e+112>>2]*q)+_0))+D(.5)),D(B2(h))<D(2147483648)?r=~~h:r=-2147483648,t[f|0]=(r|0)>=0?r>>>0>=255?255:r:0,f=l+Y|0,h=D(D(D(E0[e+120>>2]*q)+_0)+D(.5)),D(B2(h))<D(2147483648)?r=~~h:r=-2147483648,t[f|0]=(r|0)>=0?r>>>0>=255?255:r:0,l=l+1|0,(_|0)!=(l|0););break f;case 0:if(G){if((_|0)==1)break A;for(;f=r>>>V|0,t[r+R|0]=u[f+U|0],t[r+E|0]=u[r+N|0],t[r+Y|0]=u[f+x|0],w=r|1,f=w>>>V|0,t[w+R|0]=u[f+U|0],t[w+E|0]=u[w+N|0],t[w+Y|0]=u[f+x|0],r=r+2|0,l=l+2|0,(r2|0)!=(l|0););break A}for(;l=r+R|0,w=r>>>V|0,h=D(D(D(D(u[w+U|0])+D(-16))*D(1.142899990081787))+D(.5)),D(B2(h))<D(2147483648)?f=~~h:f=-2147483648,t[l|0]=(f|0)>=0?f>>>0>=255?255:f:0,l=r+E|0,h=D(D(D(D(u[r+N|0])+D(-16))*D(1.1689000129699707))+D(.5)),D(B2(h))<D(2147483648)?f=~~h:f=-2147483648,t[l|0]=(f|0)>=0?f>>>0>=255?255:f:0,l=r+Y|0,h=D(D(D(D(u[w+x|0])+D(-16))*D(1.142899990081787))+D(.5)),D(B2(h))<D(2147483648)?f=~~h:f=-2147483648,t[l|0]=(f|0)>=0?f>>>0>=255?255:f:0,r=r+1|0,(_|0)!=(r|0););break f;case 8:for(;w=u[r+N|0],f=r>>>V|0,l=u[f+x|0]-128|0,g0=w-l|0,f=u[f+U|0]-128|0,j=g0+f|0,t[r+R|0]=(j|0)>=0?j>>>0>=255?255:j:0,l=l+w|0,t[r+E|0]=(l|0)>=0?l>>>0>=255?255:l:0,f=g0-f|0,t[r+Y|0]=(f|0)>=0?f>>>0>=255?255:f:0,r=r+1|0,(_|0)!=(r|0););break f;case 16:break k}for(;r=l>>>V|0,w=u[r+x|0]-128|0,f=u[l+N|0]-(w>>>1|0)|0,r=u[r+U|0]-128|0,j=f-(r>>>1|0)|0,r=r+j<<16>>14,t[l+R|0]=(r|0)>=0?r>>>0>=255?255:r:0,r=f+w<<16>>14,t[l+E|0]=(r|0)>=0?r>>>0>=255?255:r:0,r=j<<16>>14,t[l+Y|0]=(r|0)>=0?r>>>0>=255?255:r:0,l=l+1|0,(_|0)!=(l|0););break f}if(!f2)break f;f=r>>>V|0,t[r+R|0]=u[f+U|0],t[r+E|0]=u[r+N|0],t[r+Y|0]=u[f+x|0]}if(!O|!Q||z(g(m,A0)+t0|0,g(m,S)+c|0,Q),m=m+1|0,(m|0)==(n|0))break}break r}if(!O)break r;if(r=0,(n|0)!=1)for(k=n&-2,l=0;f=!Q,f||z(g(r,A0)+t0|0,g(r,S)+c|0,Q),f||(f=r|1,z(g(f,A0)+t0|0,g(f,S)+c|0,Q)),r=r+2|0,l=l+2|0,(k|0)!=(l|0););if(!(n&1)|!Q)break r;z(g(r,A0)+t0|0,g(r,S)+c|0,Q)}t[A+20|0]=0,i[A+4>>2]=s,i[A>>2]=o;break i}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=e+128|0}function tA(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;_=v-32|0,v=_,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{r:{if(i[e+24>>2]==i[e+28>>2])break r;k=C(128),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=97468,n=k+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[n>>2]=95084,i[k+32>>2]=1885434736,i[k+116>>2]=i[e+24>>2],i[k+120>>2]=i[e+28>>2],i[k+4>>2]=i[k+4>>2]+1,f=i[A+4>>2],s=i[A+8>>2];f:{if(f>>>0<s>>>0){i[f+4>>2]=k,i[f>>2]=n,f=f+8|0;break f}if(l=i[A>>2],f=f-l|0,w=f>>3,o=w+1|0,o>>>0>=536870912)break e;if(s=s-l|0,h=s>>2,s=s>>>0>=2147483640?536870911:o>>>0<h>>>0?h:o,s){if(s>>>0>=536870912)break i;o=C(s<<3)}else o=0;if(h=o+f|0,i[h+4>>2]=k,i[h>>2]=n,n=h-(w<<3)|0,f&&z(n,l,f),i[A+8>>2]=o+(s<<3),f=h+8|0,i[A+4>>2]=f,i[A>>2]=n,!l)break f;Z(l)}if(i[A+4>>2]=f,f=i[k+4>>2],i[k+4>>2]=f-1,f)break r;W[i[i[k>>2]+8>>2]](k),y(k)}if(p[e+32>>1]|p[e+34>>1]){k=C(120),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=97628,n=k+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[n>>2]=95244,i[k+32>>2]=1668050025,f=i[e+32>>2],X[k+114>>1]=f,X[k+116>>1]=f>>>16,f=i[A+4>>2],s=i[A+8>>2];r:{if(f>>>0<s>>>0){i[f+4>>2]=k,i[f>>2]=n,f=f+8|0;break r}if(l=i[A>>2],f=f-l|0,w=f>>3,o=w+1|0,o>>>0>=536870912)break e;if(s=s-l|0,h=s>>2,s=s>>>0>=2147483640?536870911:o>>>0<h>>>0?h:o,s){if(s>>>0>=536870912)break i;o=C(s<<3)}else o=0;if(h=o+f|0,i[h+4>>2]=k,i[h>>2]=n,k=h-(w<<3)|0,f&&z(k,l,f),i[A+8>>2]=o+(s<<3),f=h+8|0,i[A+4>>2]=f,i[A>>2]=k,!l)break r;Z(l)}i[A+4>>2]=f}r:{if(u[e+60|0]!=1)break r;k=C(144),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=97668,h=R3(k+16|0),f=i[e+56>>2],i[k+132>>2]=i[e+52>>2],i[k+136>>2]=f,f=i[e+48>>2],i[k+124>>2]=i[e+44>>2],i[k+128>>2]=f,f=i[e+40>>2],i[k+116>>2]=i[e+36>>2],i[k+120>>2]=f,i[k+4>>2]=i[k+4>>2]+1,f=i[A+4>>2],l=i[A+8>>2];f:{if(f>>>0<l>>>0){i[f+4>>2]=k,i[f>>2]=h,f=f+8|0;break f}if(n=i[A>>2],f=f-n|0,w=f>>3,o=w+1|0,o>>>0>=536870912)break e;if(l=l-n|0,s=l>>2,l=l>>>0>=2147483640?536870911:o>>>0<s>>>0?s:o,l){if(l>>>0>=536870912)break i;o=C(l<<3)}else o=0;if(s=o+f|0,i[s+4>>2]=k,i[s>>2]=h,h=s-(w<<3)|0,f&&z(h,n,f),i[A+8>>2]=o+(l<<3),f=s+8|0,i[A+4>>2]=f,i[A>>2]=h,!n)break f;Z(n)}if(i[A+4>>2]=f,f=i[k+4>>2],i[k+4>>2]=f-1,f)break r;W[i[i[k>>2]+8>>2]](k),y(k)}o=i[e+64>>2];r:{if(!o)break r;k=C(144),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=98428,n=k+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[n>>2]=95668,i[k+32>>2]=1769234793,f=k+120|0,i[f+8>>2]=0,i[f+12>>2]=0,t[f|0]=1,t[f+15|0]=0,t[f+16|0]=0,t[f+17|0]=0,t[f+18|0]=0,li(f,o),i[k+4>>2]=i[k+4>>2]+1,f=i[A+4>>2],s=i[A+8>>2];f:{if(f>>>0<s>>>0){i[f+4>>2]=k,i[f>>2]=n,f=f+8|0;break f}if(l=i[A>>2],f=f-l|0,w=f>>3,o=w+1|0,o>>>0>=536870912)break e;if(s=s-l|0,h=s>>2,s=s>>>0>=2147483640?536870911:o>>>0<h>>>0?h:o,s){if(s>>>0>=536870912)break i;o=C(s<<3)}else o=0;if(h=o+f|0,i[h+4>>2]=k,i[h>>2]=n,n=h-(w<<3)|0,f&&z(n,l,f),i[A+8>>2]=o+(s<<3),f=h+8|0,i[A+4>>2]=f,i[A>>2]=n,!l)break f;Z(l)}if(i[A+4>>2]=f,f=i[k+4>>2],i[k+4>>2]=f-1,f)break r;W[i[i[k>>2]+8>>2]](k),y(k)}f=t[e+79|0];r:{if(!((f|0)<0?i[e+72>>2]:f))break r;k=C(128),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=98748,h=no(k+16|0),f=k+116|0,o=e+68|0;f:{if((f|0)==(o|0))break f;if(n=t[e+79|0],t[k+127|0]>=0){if((n|0)>=0){n=i[o+4>>2],i[f>>2]=i[o>>2],i[f+4>>2]=n,i[f+8>>2]=i[o+8>>2];break f}m1(f,i[e+68>>2],i[e+72>>2]);break f}l=f,f=(n|0)<0,R1(l,f?i[e+68>>2]:o,f?i[e+72>>2]:n)}i[k+4>>2]=i[k+4>>2]+1,f=i[A+4>>2],l=i[A+8>>2];f:{if(f>>>0<l>>>0){i[f+4>>2]=k,i[f>>2]=h,f=f+8|0;break f}if(n=i[A>>2],f=f-n|0,w=f>>3,o=w+1|0,o>>>0>=536870912)break e;if(l=l-n|0,s=l>>2,l=l>>>0>=2147483640?536870911:o>>>0<s>>>0?s:o,l){if(l>>>0>=536870912)break i;o=C(l<<3)}else o=0;if(s=o+f|0,i[s+4>>2]=k,i[s>>2]=h,h=s-(w<<3)|0,f&&z(h,n,f),i[A+8>>2]=o+(l<<3),f=s+8|0,i[A+4>>2]=f,i[A>>2]=h,!n)break f;Z(n)}if(i[A+4>>2]=f,f=i[k+4>>2],i[k+4>>2]=f-1,f)break r;W[i[i[k>>2]+8>>2]](k),y(k)}r:{if(!r)break r;f:{if(!(p[e+6>>1]!=2|p[e+8>>1]!=2|p[e+10>>1]!=2)&&u[e+12|0])break f;dt(_+24|0,e),l=i[_+24>>2],i[_+24>>2]=0,s=i[_+28>>2],r=i[A+4>>2],k=i[A+8>>2];A:{if(r>>>0<k>>>0){i[r+4>>2]=s,i[r>>2]=l,f=r+8|0;break A}if(o=i[A>>2],r=r-o|0,h=r>>3,f=h+1|0,f>>>0>=536870912)break e;if(k=k-o|0,n=k>>2,k=k>>>0>=2147483640?536870911:f>>>0<n>>>0?n:f,k){if(k>>>0>=536870912)break i;f=C(k<<3)}else f=0;if(n=f+r|0,i[n+4>>2]=s,i[n>>2]=l,l=n-(h<<3)|0,r&&z(l,o,r),i[A+8>>2]=f+(k<<3),f=n+8|0,i[A+4>>2]=f,i[A>>2]=l,!o)break A;Z(o)}i[A+4>>2]=f}if(!i[e+16>>2])break r;ct(_+24|0,e),l=i[_+24>>2],i[_+24>>2]=0,s=i[_+28>>2],r=i[A+4>>2],k=i[A+8>>2];f:{if(r>>>0<k>>>0){i[r+4>>2]=s,i[r>>2]=l,f=r+8|0;break f}if(o=i[A>>2],r=r-o|0,h=r>>3,f=h+1|0,f>>>0>=536870912)break e;if(k=k-o|0,n=k>>2,k=k>>>0>=2147483640?536870911:f>>>0<n>>>0?n:f,k){if(k>>>0>=536870912)break i;f=C(k<<3)}else f=0;if(n=f+r|0,i[n+4>>2]=s,i[n>>2]=l,l=n-(h<<3)|0,r&&z(l,o,r),i[A+8>>2]=f+(k<<3),f=n+8|0,i[A+4>>2]=f,i[A>>2]=l,!o)break f;Z(o)}i[A+4>>2]=f}r:{if(i[e+160>>2]==255)break r;f=C(128),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100508,o=f+16|0,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,X[f+112>>1]=0,i[o>>2]=114196,i[f+32>>2]=1886545522,i[f+120>>2]=0,$n(_+4|0,o,i[e+160>>2]),t[_+23|0]<0&&Z(i[_+12>>2]),i[f+4>>2]=i[f+4>>2]+1,e=i[A+4>>2],n=i[A+8>>2];f:{if(e>>>0<n>>>0){i[e+4>>2]=f,i[e>>2]=o,e=e+8|0;break f}if(k=i[A>>2],e=e-k|0,s=e>>3,r=s+1|0,r>>>0>=536870912)break e;if(n=n-k|0,l=n>>2,n=n>>>0>=2147483640?536870911:r>>>0<l>>>0?l:r,n){if(n>>>0>=536870912)break i;r=C(n<<3)}else r=0;if(l=r+e|0,i[l+4>>2]=f,i[l>>2]=o,o=l-(s<<3)|0,e&&z(o,k,e),i[A+8>>2]=r+(n<<3),e=l+8|0,i[A+4>>2]=e,i[A>>2]=o,!k)break f;Z(k)}if(i[A+4>>2]=e,A=i[f+4>>2],i[f+4>>2]=A-1,A)break r;W[i[i[f>>2]+8>>2]](f),y(f)}v=_+32|0;return}s0(),M()}x0(),M()}function Uv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0;w=v-112|0,v=w;i:{if(!(n&&r)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!(k&&f)){if(t[w+4|0]=0,t[w+15|0]=0,r=A,A=a(w+48|0,5,2006,w+4|0),c0(r,A,i[e>>2]),t[A+19|0]<0&&Z(i[A+8>>2]),t[w+15|0]>=0)break i;Z(i[w+4>>2]);break i}E=Li();e:{if(!o||(p3(E,o),i[E+4>>2])||!r8(i[i[r>>2]>>2]))break e;h=i[i[r>>2]>>2],o=p[h+6>>1]|p[h+8>>1]<<16,h=p[h+10>>1]|p[h+12>>1]<<16,i[E+4>>2]=w+48,i[w+56>>2]=o>>>16,i[w+52>>2]=o&65535,t[w+48|0]=1,t[w+64|0]=h>>>16&1,i[w+60>>2]=h&65535}if(o=0,i[w+44>>2]=0,i[w+36>>2]=0,i[w+40>>2]=0,h=g(f,k),h)for(;P0(w+36|0,i[(o<<2)+r>>2]),o=o+1|0,(h|0)!=(o|0););i[w+28>>2]=0,i[w+32>>2]=0,R=i[e>>2],s=v-128|0,v=s,r=V8(i[i[w+36>>2]>>2],10),m=g(p8(i[i[w+36>>2]>>2],10),k),o=g(r,f),h=m|o,I=h>>>0>65535,r=I?12:8,B=C(r),i[s+112>>2]=B,_=r+B|0,i[s+120>>2]=_,r&&l0(B,0,r),i[s+116>>2]=_,t[B+3|0]=f-1,t[B+2|0]=k-1,t[B+1|0]=I,t[B|0]=0;e:{if(h>>>0>=65536){r=m<<24|(m&65280)<<8|(m>>>8&65280|m>>>24),t[B+8|0]=r,t[B+9|0]=r>>>8,t[B+10|0]=r>>>16,t[B+11|0]=r>>>24,_=o>>>24|0,r=o,h=r>>>16|0;break e}_=o>>>8|0,r=m,h=o}t[B+7|0]=r,t[B+5|0]=h,t[B+4|0]=_,t[B+6|0]=r>>>8,x=i[R+48>>2],V=i[R+52>>2],V&&(i[V+4>>2]=i[V+4>>2]+1),G=w+4|0,B=n,r=0,i[s+108>>2]=0,i[s+100>>2]=0,i[s+104>>2]=0,n=0;e:{r:{f:{A:{q=g(f,k);k:{if(q)for(j=G+8|0,I=i[27064],c=i[27065],k=0;;){ge(s+72|0,R,i[w+36>>2]+(k<<3)|0,B,E,1),S=u[s+92|0];n:{if(S){if((S|0)!=1)break A;f=i[s+76>>2],i[G>>2]=i[s+72>>2],i[G+4>>2]=f;t:{if(t[s+91|0]>=0){f=i[s+84>>2],i[j>>2]=i[s+80>>2],i[j+4>>2]=f,i[j+8>>2]=i[s+88>>2];break t}T(j,i[s+80>>2],i[s+84>>2])}t[G+20|0]=1,_=0;break n}_=i[s+76>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),O=i[s+72>>2],j1(s+40|0,x,i[O+196>>2]),f=i[s+40>>2],t[f+164|0]=1,i[f+100>>2]=i[f+100>>2]&-2|1,f=i[s+44>>2];t:{if(!f||(h=i[f+4>>2],i[f+4>>2]=h-1,h))break t;W[i[i[f>>2]+8>>2]](f),y(f)}N=i[O+196>>2],f=i[s+104>>2],Q=i[s+108>>2];t:{if(f>>>0<Q>>>0){i[f>>2]=N,f=f+4|0;break t}if(U=i[s+100>>2],f=f-U|0,d=f>>2,h=d+1|0,h>>>0>=1073741824)break f;if(Q=Q-U|0,Y=Q>>1,Q=Q>>>0>=2147483644?1073741823:h>>>0<Y>>>0?Y:h,Q){if(Q>>>0>=1073741824)break r;h=C(Q<<2)}else h=0;if(Y=h+f|0,i[Y>>2]=N,N=Y-(d<<2)|0,f&&z(N,U,f),i[s+108>>2]=h+(Q<<2),f=Y+4|0,i[s+104>>2]=f,i[s+100>>2]=N,!U)break t;Z(U)}if(i[s+104>>2]=f,r)break n;f=i[O+184>>2],h=i[O+188>>2];t:{if((f|0)!=(h|0))for(;;){o:{if(r=i[f>>2],!r||(r=Z0(r,92792,95064),!r))break o;if(f=i[f+4>>2],!f){f=0;break t}i[f+4>>2]=i[f+4>>2]+1;break t}if(f=f+8|0,(h|0)==(f|0))break}f=0,r=0}t:{if(!n||(h=i[n+4>>2],i[n+4>>2]=h-1,h))break t;W[i[i[n>>2]+8>>2]](n),y(n)}n=f}f=u[s+92|0],(f|0)!=255&&(i[s+40>>2]=I,i[s+44>>2]=c,W[i[(s+40|0)+(f<<2)>>2]](s+127|0,s+72|0));n:{if(!_||(f=i[_+4>>2],i[_+4>>2]=f-1,f))break n;W[i[i[_>>2]+8>>2]](_),y(_)}if(S)break k;if(k=k+1|0,(q|0)==(k|0))break}t5(s+72|0,x,1735551332);n:{t:switch(u[s+92|0]){case 1:r=i[s+76>>2],i[G>>2]=i[s+72>>2],i[G+4>>2]=r,r=G+8|0;o:{if(t[s+91|0]>=0){f=i[s+84>>2],i[r>>2]=i[s+80>>2],i[r+4>>2]=f,i[r+8>>2]=i[s+88>>2];break o}T(r,i[s+80>>2],i[s+84>>2])}t[G+20|0]=1;break n;case 0:break t;default:break A}h=i[s+72>>2],B=C(600),f=B,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=107928,k=a4(f+16|0,R,h),i[k>>2]=108048,i[f+584>>2]=0,i[f+588>>2]=0,i[f+576>>2]=0,i[f+580>>2]=0,i[f+568>>2]=0,i[f+572>>2]=0,i[f+592>>2]=1,i[f+596>>2]=0,A0=f,t0=Li(),i[A0+596>>2]=t0,i[s+44>>2]=f,i[s+40>>2]=k,i[f+4>>2]=i[f+4>>2]+1,I3(R,h,s+40|0),f=i[s+44>>2];t:{if(!f||(I=i[f+4>>2],i[f+4>>2]=I-1,I))break t;W[i[i[f>>2]+8>>2]](f),y(f)}if(w6(x,h,s+112|0,1),o8(x,h,1684630887,s+100|0),h=C(128),i[h>>2]=96348,i[h+4>>2]=0,i[h+8>>2]=0,I=h+16|0,f=I,i[f+8>>2]=0,i[f+12>>2]=0,f=h,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,X[f+112>>1]=0,i[f+16>>2]=93816,i[f+124>>2]=m,i[f+120>>2]=o,i[f+32>>2]=1769173093,i[s+68>>2]=f,i[s+64>>2]=I,i[f+4>>2]=i[f+4>>2]+1,f=i[s+68>>2],i[s+24>>2]=i[s+64>>2],i[s+28>>2]=f,O4(k,s+24|0,0),i[s+60>>2]=n,i[s+56>>2]=r,n&&(i[n+4>>2]=i[n+4>>2]+1),r=i[s+60>>2],i[s+16>>2]=i[s+56>>2],i[s+20>>2]=r,O4(k,s+16|0,1),tA(s+40|0,i[i[w+36>>2]>>2],1),f=i[s+40>>2],o=i[s+44>>2],(f|0)!=(o|0)){for(;i[s+32>>2]=i[f>>2],r=i[f+4>>2],i[s+36>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),m=i[f>>2],r=i[m+16>>2]==1769173093,m=r?k:m,r=W[i[i[m>>2]+(r?84:40)>>2]](m)|0,m=i[s+36>>2],i[s+8>>2]=i[s+32>>2],i[s+12>>2]=m,O4(k,s+8|0,r),f=f+8|0,(o|0)!=(f|0););f=i[s+40>>2]}if(t[G+20|0]=0,i[G+4>>2]=B,i[G>>2]=k,f){if(k=f,_=i[s+44>>2],(_|0)!=(f|0)){for(;;){r=i[_-4>>2];t:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break t;W[i[i[r>>2]+8>>2]](r),y(r)}if(_=_-8|0,(_|0)==(f|0))break}k=i[s+40>>2]}i[s+44>>2]=f,Z(k)}if(r=i[h+4>>2],i[h+4>>2]=r-1,r)break n;W[i[i[h>>2]+8>>2]](h),y(h)}if(r=u[s+92|0],(r|0)==255)break k;f=i[27063],i[s+40>>2]=i[27062],i[s+44>>2]=f,W[i[(s+40|0)+(r<<2)>>2]](s+127|0,s+72|0)}k:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break k;W[i[i[n>>2]+8>>2]](n),y(n)}r=i[s+100>>2],r&&(i[s+104>>2]=r,Z(r));k:{if(!V||(r=i[V+4>>2],i[V+4>>2]=r-1,r))break k;W[i[i[V>>2]+8>>2]](V),y(V)}r=i[s+112>>2],r&&(i[s+116>>2]=r,Z(r)),v=s+128|0;break e}e2(),M()}s0(),M()}x0(),M()}a2(E);e:{r:switch(u[w+24|0]){default:e2(),M();case 1:c0(A,w+4|0,i[e>>2]);break e;case 0:break r}f=i[w+4>>2],r=i[w+8>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[w+32>>2]=r,i[w+28>>2]=f,r=i[e>>2],i[r+40>>2]||x3(r,w+28|0);r:{if(!l)break r;if(r=C(16),i[r+8>>2]=0,i[r+12>>2]=0,i[l>>2]=r,f=i[w+28>>2],k=i[w+32>>2],i[w+28>>2]=0,i[w+32>>2]=0,i[r>>2]=f,i[r+4>>2]=k,k=i[e>>2],f=i[e+4>>2],!f){i[r+12>>2]=f,i[r+8>>2]=k;break r}if(i[f+4>>2]=i[f+4>>2]+1,i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}A=u[w+24|0],(A|0)!=255&&(e=i[25861],i[w+104>>2]=i[25860],i[w+108>>2]=e,W[i[(w+104|0)+(A<<2)>>2]](w+103|0,w+4|0)),A=i[w+32>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[w+36>>2],!A)break i;if(r=A,o=i[w+40>>2],(r|0)!=(o|0)){for(;;){e=i[o-4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(o=o-8|0,(A|0)==(o|0))break}r=i[w+36>>2]}i[w+40>>2]=A,Z(r)}v=w+112|0}function z9(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;f=v-96|0,v=f,m=i[e+80>>2],r=i[e+84>>2];i:{if((m|0)==(r|0))break i;e:{if(r=r-m|0,_=i[A+84>>2],n=i[A+80>>2],(r|0)!=(_-n|0))break e;for(r=(r|0)/44|0,s=r>>>0<=1?1:r;;){if(r=g(k,44),o=r+n|0,r=r+m|0,i[o>>2]!=i[r>>2]|i[o+4>>2]!=i[r+4>>2])break e;if(k=k+1|0,(s|0)==(k|0))break}break i}if(i[f+88>>2]=0,i[f+92>>2]=0,m=f+88|0,i[f+84>>2]=m,(n|0)!=(_|0))for(;;){l=i[n+4>>2],s=m,k=s,r=i[f+88>>2];e:{r:{if(!r)break r;for(;;){if(k=r,o=i[r+16>>2],(o|0)>(l|0)){if(s=r,r=i[r>>2],r)continue;break r}if((l|0)<=(o|0))break e;if(r=i[k+4>>2],!r)break}s=k+4|0}r=C(64),i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=l,i[r+52>>2]=0,i[r+56>>2]=0,i[r+8>>2]=k,i[r>>2]=0,i[r+4>>2]=0,i[r+24>>2]=65535,i[r+36>>2]=0,i[r+40>>2]=0,i[r+60>>2]=0,i[r+32>>2]=255,t[r+48|0]=1,i[s>>2]=r,k=i[i[f+84>>2]>>2],k&&(i[f+84>>2]=k),G1(i[f+88>>2],r),i[f+92>>2]=i[f+92>>2]+1}k=i[n+4>>2],i[r+20>>2]=i[n>>2],i[r+24>>2]=k,o=u[n+25|0]|u[n+26|0]<<8|(u[n+27|0]<<16|u[n+28|0]<<24),k=u[n+21|0]|u[n+22|0]<<8|(u[n+23|0]<<16|u[n+24|0]<<24),t[r+41|0]=k,t[r+42|0]=k>>>8,t[r+43|0]=k>>>16,t[r+44|0]=k>>>24,t[r+45|0]=o,t[r+46|0]=o>>>8,t[r+47|0]=o>>>16,t[r+48|0]=o>>>24,k=i[n+20>>2],i[r+36>>2]=i[n+16>>2],i[r+40>>2]=k,k=i[n+12>>2],i[r+28>>2]=i[n+8>>2],i[r+32>>2]=k;e:{if((n|0)==(r+20|0))break e;if(o=n+32|0,s=r+52|0,k=t[n+43|0],t[r+63|0]>=0){if((k|0)>=0){r=i[o+4>>2],i[s>>2]=i[o>>2],i[s+4>>2]=r,i[s+8>>2]=i[o+8>>2];break e}m1(s,i[n+32>>2],i[n+36>>2]);break e}r=(k|0)<0,R1(s,r?i[n+32>>2]:o,r?i[n+36>>2]:k)}if(n=n+44|0,(_|0)==(n|0))break}if(i[f+76>>2]=0,i[f+80>>2]=0,_=f+76|0,i[f+72>>2]=_,s=i[A+204>>2],G=i[A+208>>2],(s|0)!=(G|0))for(;;){h=i[s>>2],o=i[s+24>>2],l=i[s+28>>2],n=_,k=n,r=i[f+76>>2];e:{r:{if(!r)break r;for(;;){if(k=r,n=i[r+16>>2],(n|0)>(h|0)){if(n=r,r=i[r>>2],r)continue;break r}if((n|0)>=(h|0))break e;if(r=i[k+4>>2],!r)break}n=k+4|0}r=C(28),i[r+20>>2]=0,i[r+24>>2]=0,i[r+16>>2]=h,i[r+8>>2]=k,i[r>>2]=0,i[r+4>>2]=0,i[n>>2]=r,k=i[i[f+72>>2]>>2],k&&(i[f+72>>2]=k),G1(i[f+76>>2],r),i[f+80>>2]=i[f+80>>2]+1}if(i[r+20>>2]=o,i[r+24>>2]=l,s=s+56|0,(G|0)==(s|0))break}n=0,i[f+68>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,s=f+52|0,i[f+48>>2]=s,i[f+52>>2]=0,i[f+56>>2]=0,l=i[e+80>>2],G=i[e+84>>2];e:{if((l|0)==(G|0)){w=i[e+92>>2],o=0;break e}for(w=f+32|0;;){r:{if(u[l+28|0]!=1)break r;k=u[l+25|0]|u[l+26|0]<<8|(u[l+27|0]<<16|u[l+28|0]<<24),r=u[l+21|0]|u[l+22|0]<<8|(u[l+23|0]<<16|u[l+24|0]<<24),t[f+21|0]=r,t[f+22|0]=r>>>8,t[f+23|0]=r>>>16,t[f+24|0]=r>>>24,t[f+25|0]=k,t[f+26|0]=k>>>8,t[f+27|0]=k>>>16,t[f+28|0]=k>>>24,r=i[l+20>>2],i[f+16>>2]=i[l+16>>2],i[f+20>>2]=r,r=i[l+12>>2],i[f+8>>2]=i[l+8>>2],i[f+12>>2]=r,r=i[l+4>>2],i[f>>2]=i[l>>2],i[f+4>>2]=r;f:{if(t[l+43|0]>=0){r=i[l+36>>2],i[w>>2]=i[l+32>>2],i[w+4>>2]=r,i[w+8>>2]=i[l+40>>2];break f}T(w,i[l+32>>2],i[l+36>>2])}o=i[f+76>>2];f:{if(!o)break f;for(B=i[l+4>>2],r=_;n=r,k=o,h=(B|0)>i[k+16>>2],r=h?r:k,o=i[k+(h?4:0)>>2],!!o;);if((r|0)==(_|0)|(B|0)<i[(h?n:k)+16>>2])break f;i[f+20>>2]=i[r+20>>2],i[f+24>>2]=i[r+24>>2]}n=i[f+64>>2];f:{if(n>>>0<o0[f+68>>2]){if(r=i[f+4>>2],i[n>>2]=i[f>>2],i[n+4>>2]=r,k=u[f+25|0]|u[f+26|0]<<8|(u[f+27|0]<<16|u[f+28|0]<<24),r=u[f+21|0]|u[f+22|0]<<8|(u[f+23|0]<<16|u[f+24|0]<<24),t[n+21|0]=r,t[n+22|0]=r>>>8,t[n+23|0]=r>>>16,t[n+24|0]=r>>>24,t[n+25|0]=k,t[n+26|0]=k>>>8,t[n+27|0]=k>>>16,t[n+28|0]=k>>>24,r=i[f+20>>2],i[n+16>>2]=i[f+16>>2],i[n+20>>2]=r,r=i[f+12>>2],i[n+8>>2]=i[f+8>>2],i[n+12>>2]=r,k=n+32|0,t[f+43|0]>=0){r=i[w+4>>2],i[k>>2]=i[w>>2],i[k+4>>2]=r,i[k+8>>2]=i[w+8>>2],r=n+44|0;break f}T(k,i[f+32>>2],i[f+36>>2]),r=n+44|0;break f}r=rt(f+60|0,f)}i[f+64>>2]=r,h=i[l+4>>2],o=i[l>>2],n=s,k=n,r=i[f+52>>2];f:{A:{if(!r)break A;for(;;){if(k=r,n=i[r+16>>2],(n|0)>(h|0)){if(n=r,r=i[r>>2],r)continue;break A}if((n|0)>=(h|0))break f;if(r=i[k+4>>2],!r)break}n=k+4|0}r=C(24),i[r+20>>2]=0,i[r+16>>2]=h,i[r+8>>2]=k,i[r>>2]=0,i[r+4>>2]=0,i[n>>2]=r,k=i[i[f+48>>2]>>2],k&&(i[f+48>>2]=k),G1(i[f+52>>2],r),i[f+56>>2]=i[f+56>>2]+1}if(i[r+20>>2]=o,t[f+43|0]>=0)break r;Z(i[f+32>>2])}if(l=l+44|0,(G|0)==(l|0))break}if(w=i[e+92>>2],n=i[f+60>>2],o=i[f+64>>2],(n|0)==(o|0))break e;for(k=n;e=i[k>>2],w=e>>>0<w>>>0?w:e+1|0,k=k+44|0,(o|0)!=(k|0););}if(l=i[A+204>>2],_=i[A+208>>2],(l|0)!=(_|0)){for(B=f+32|0;;){e:{if(i[l+4>>2]==i[l+8>>2])break e;G=l+4|0,h=i[l>>2],r=s;r:{if(o=i[f+52>>2],!o)break r;for(;k=r,e=o,n=(h|0)>i[e+16>>2],r=n?r:e,o=i[(n?4:0)+e>>2],!!o;);if((r|0)==(s|0)|(h|0)<i[(n?k:e)+16>>2])break r;Kt(G,r+20|0);break e}if(r=m,o=i[f+88>>2],!o)break e;for(;k=r,e=o,n=(h|0)>i[e+16>>2],r=n?r:e,o=i[(n?4:0)+e>>2],!!o;);if((r|0)==(m|0)|(h|0)<i[(n?k:e)+16>>2])break e;k=u[r+45|0]|u[r+46|0]<<8|(u[r+47|0]<<16|u[r+48|0]<<24),e=u[r+41|0]|u[r+42|0]<<8|(u[r+43|0]<<16|u[r+44|0]<<24),t[f+21|0]=e,t[f+22|0]=e>>>8,t[f+23|0]=e>>>16,t[f+24|0]=e>>>24,t[f+25|0]=k,t[f+26|0]=k>>>8,t[f+27|0]=k>>>16,t[f+28|0]=k>>>24,e=i[r+40>>2],i[f+16>>2]=i[r+36>>2],i[f+20>>2]=e,e=i[r+32>>2],i[f+8>>2]=i[r+28>>2],i[f+12>>2]=e,e=i[r+24>>2],i[f>>2]=i[r+20>>2],i[f+4>>2]=e;r:{if(t[r+63|0]>=0){e=i[r+56>>2],i[B>>2]=i[r+52>>2],i[B+4>>2]=e,i[B+8>>2]=i[r+60>>2];break r}T(B,i[r+52>>2],i[r+56>>2])}i[f>>2]=w,k=i[f+64>>2];r:{if(k>>>0<o0[f+68>>2]){if(e=i[f+4>>2],i[k>>2]=i[f>>2],i[k+4>>2]=e,r=u[f+25|0]|u[f+26|0]<<8|(u[f+27|0]<<16|u[f+28|0]<<24),e=u[f+21|0]|u[f+22|0]<<8|(u[f+23|0]<<16|u[f+24|0]<<24),t[k+21|0]=e,t[k+22|0]=e>>>8,t[k+23|0]=e>>>16,t[k+24|0]=e>>>24,t[k+25|0]=r,t[k+26|0]=r>>>8,t[k+27|0]=r>>>16,t[k+28|0]=r>>>24,e=i[f+20>>2],i[k+16>>2]=i[f+16>>2],i[k+20>>2]=e,e=i[f+12>>2],i[k+8>>2]=i[f+8>>2],i[k+12>>2]=e,r=k+32|0,t[f+43|0]>=0){e=i[B+4>>2],i[r>>2]=i[B>>2],i[r+4>>2]=e,i[r+8>>2]=i[B+8>>2],e=k+44|0;break r}T(r,i[f+32>>2],i[f+36>>2]),e=k+44|0;break r}e=rt(f+60|0,f)}i[f+64>>2]=e,Kt(G,f),t[f+43|0]<0&&Z(i[f+32>>2]),w=w+1|0}if(l=l+56|0,(_|0)==(l|0))break}o=i[f+64>>2],n=i[f+60>>2]}if(r=i[f+68>>2],i[f+68>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,e=i[A+80>>2],e){if(k=i[A+84>>2],s=e,(k|0)!=(e|0)){for(;t[k-1|0]<0&&Z(i[k-12>>2]),k=k-44|0,(e|0)!=(k|0););s=i[A+80>>2]}i[A+84>>2]=e,Z(s)}if(i[A+92>>2]=w,i[A+88>>2]=r,i[A+84>>2]=o,i[A+80>>2]=n,Z7(f+48|0,i[f+52>>2]),A=i[f+60>>2],A){if(k=i[f+64>>2],o=A,(k|0)!=(o|0)){for(;t[k-1|0]<0&&Z(i[k-12>>2]),k=k-44|0,(A|0)!=(k|0););o=i[f+60>>2]}i[f+64>>2]=A,Z(o)}g7(f+72|0,i[f+76>>2]),w7(f+84|0,i[f+88>>2])}v=f+96|0}function Mv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;o=v-32|0,v=o,k=F0(r),i[o+16>>2]=k;i:{e:{r:{f:{A:{k:{n:{if((k|0)<=1886547813){if((k|0)==1852009571)break k;if((k|0)!=1852009592)break n;f=C(24),t[f+22|0]=1,X[f+20>>1]=6,X[f+16>>1]=1,X[f+18>>1]=13,i[f+4>>2]=1,i[f+8>>2]=0,i[f+12>>2]=101820,i[f>>2]=101740,n=f+12|0,i[e+100>>2]=n,k=i[e+104>>2],i[e+104>>2]=f;t:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break t;W[i[i[k>>2]+8>>2]](k),y(k)}e=v-16|0,v=e,k=i[r>>2],l=W[i[i[k>>2]+8>>2]](k)|0,s=i[r>>2],k=h0,l=l+7|0,k=l>>>0<7?k+1|0:k;t:{if(W[i[i[s>>2]+12>>2]](s,l,k)|0){if(t[e+4|0]=0,t[e+15|0]=0,a(A,2,100,e+4|0),t[e+15|0]>=0)break t;Z(i[e+4>>2]);break t}if(_=n,B=w2(r),X[_+4>>1]=B,_=n,B=w2(r),X[_+6>>1]=B,_=n,B=w2(r),X[_+8>>1]=B,_=n,B=Q2(r)>>>7|0,t[_+10|0]=B,k=i[28729],i[A>>2]=i[28728],i[A+4>>2]=k,k=A+8|0,t[114931]>=0){n=i[28731],i[k>>2]=i[28730],i[k+4>>2]=n,i[k+8>>2]=i[28732];break t}T(k,i[28730],i[28731])}if(v=e+16|0,i[A>>2])break r;if(t[A+19|0]<0&&Z(i[A+8>>2]),e=i[f+4>>2],i[f+4>>2]=e-1,e)break f;W[i[i[f>>2]+8>>2]](f),y(f);break f}if((k|0)==1886547814|(k|0)==1917403971)break A}if(t[o+20|0]=0,t[o+31|0]=0,a(A,2,126,o+20|0),t[o+31|0]>=0)break i;Z(i[o+20>>2]);break i}f=C(24),t[f+22|0]=1,X[f+20>>1]=6,X[f+16>>1]=1,X[f+18>>1]=13,i[f+4>>2]=1,i[f+8>>2]=0,i[f+12>>2]=101820,i[f>>2]=101740,n=f+12|0,i[e+100>>2]=n,k=i[e+104>>2],i[e+104>>2]=f;k:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break k;W[i[i[k>>2]+8>>2]](k),y(k)}e=v-16|0,v=e,k=i[r>>2],l=W[i[i[k>>2]+8>>2]](k)|0,s=i[r>>2],k=h0,l=l+6|0,k=l>>>0<6?k+1|0:k;k:{if(W[i[i[s>>2]+12>>2]](s,l,k)|0){if(t[e+4|0]=0,t[e+15|0]=0,a(A,2,100,e+4|0),t[e+15|0]>=0)break k;Z(i[e+4>>2]);break k}if(_=n,B=w2(r),X[_+4>>1]=B,_=n,B=w2(r),X[_+6>>1]=B,k=w2(r),X[n+8>>1]=k,t[n+10|0]=!k,k=i[28729],i[A>>2]=i[28728],i[A+4>>2]=k,k=A+8|0,t[114931]>=0){n=i[28731],i[k>>2]=i[28730],i[k+4>>2]=n,i[k+8>>2]=i[28732];break k}T(k,i[28730],i[28731])}if(v=e+16|0,i[A>>2])break e;if(t[A+19|0]<0&&Z(i[A+8>>2]),e=i[f+4>>2],i[f+4>>2]=e-1,e)break f;W[i[i[f>>2]+8>>2]](f),y(f);break f}if(k=i[e+12>>2],h=k,n=i[e+8>>2],!(k|n)){if(e=C(56),i[o+20>>2]=e,i[o+24>>2]=52,i[o+28>>2]=-2147483592,r=u[17962]|u[17963]<<8|(u[17964]<<16|u[17965]<<24),f=u[17958]|u[17959]<<8|(u[17960]<<16|u[17961]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+52|0]=0,r=u[18006]|u[18007]<<8|(u[18008]<<16|u[18009]<<24),t[e+48|0]=r,t[e+49|0]=r>>>8,t[e+50|0]=r>>>16,t[e+51|0]=r>>>24,r=u[18002]|u[18003]<<8|(u[18004]<<16|u[18005]<<24),f=u[17998]|u[17999]<<8|(u[18e3]<<16|u[18001]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[17994]|u[17995]<<8|(u[17996]<<16|u[17997]<<24),f=u[17990]|u[17991]<<8|(u[17992]<<16|u[17993]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[17986]|u[17987]<<8|(u[17988]<<16|u[17989]<<24),f=u[17982]|u[17983]<<8|(u[17984]<<16|u[17985]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[17978]|u[17979]<<8|(u[17980]<<16|u[17981]<<24),f=u[17974]|u[17975]<<8|(u[17976]<<16|u[17977]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[17970]|u[17971]<<8|(u[17972]<<16|u[17973]<<24),f=u[17966]|u[17967]<<8|(u[17968]<<16|u[17969]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,4,0,o+20|0),t[o+31|0]>=0)break i;Z(i[o+20>>2]);break i}if(w=i[e+32>>2],l=n-w|0,k=l-4|0,f=i[f+32>>2],!(!f|(h-(n>>>0<w>>>0)|0)==(l>>>0<4|0)&f>>>0>=k>>>0)){if(e=C(48),i[o+20>>2]=e,i[o+24>>2]=44,i[o+28>>2]=-2147483600,r=u[12838]|u[12839]<<8|(u[12840]<<16|u[12841]<<24),f=u[12834]|u[12835]<<8|(u[12836]<<16|u[12837]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+44|0]=0,r=u[12874]|u[12875]<<8|(u[12876]<<16|u[12877]<<24),t[e+40|0]=r,t[e+41|0]=r>>>8,t[e+42|0]=r>>>16,t[e+43|0]=r>>>24,r=u[12870]|u[12871]<<8|(u[12872]<<16|u[12873]<<24),f=u[12866]|u[12867]<<8|(u[12868]<<16|u[12869]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[12862]|u[12863]<<8|(u[12864]<<16|u[12865]<<24),f=u[12858]|u[12859]<<8|(u[12860]<<16|u[12861]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[12854]|u[12855]<<8|(u[12856]<<16|u[12857]<<24),f=u[12850]|u[12851]<<8|(u[12852]<<16|u[12853]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[12846]|u[12847]<<8|(u[12848]<<16|u[12849]<<24),f=u[12842]|u[12843]<<8|(u[12844]<<16|u[12845]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,1e3,o+20|0),t[o+31|0]>=0)break i;Z(i[o+20>>2]);break i}if(f=i[r>>2],n=W[i[i[f>>2]+8>>2]](f)|0,l=i[r>>2],f=h0,n=k+n|0,f=n>>>0<k>>>0?f+1|0:f,W[i[i[l>>2]+12>>2]](l,n,f)|0){if(t[o+20|0]=0,t[o+31|0]=0,a(A,2,100,o+20|0),t[o+31|0]>=0)break i;Z(i[o+20>>2]);break i}f=o+20|0,i[f+8>>2]=0,i[f>>2]=0,i[f+4>>2]=0;A:{k:{if(k){if((k|0)<0)break k;n=C(k),i[f>>2]=n,l=k+n|0,i[f+8>>2]=l,k&&l0(n,0,k),i[f+4>>2]=l}break A}s0(),M()}if(k)for(;n=Q2(r),t[i[f>>2]+s|0]=n,s=s+1|0,(k|0)!=(s|0););n=o+8|0,k=C(32),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=101940,l=i[o+16>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+16>>2]=l,i[k+12>>2]=101780;A:{k:{if(l=i[f+4>>2],s=i[f>>2],(l|0)!=(s|0)){if(l=l-s|0,(l|0)<0)break k;h=C(l),i[k+20>>2]=h,w=l+h|0,i[k+28>>2]=w,l&&z(h,s,l),i[k+24>>2]=w}i[n+4>>2]=k,i[n>>2]=k+12;break A}s0(),M()}if(Q8(e+100|0,n),g2(n),e=i[f>>2],!e)break f;i[f+4>>2]=e,Z(e)}if(u[r+20|0]==1){if(t[o+20|0]=0,t[o+31|0]=0,a(A,2,100,o+20|0),t[o+31|0]>=0)break i;Z(i[o+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f);break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=o+32|0}function Hv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;h=v-48|0,v=h,s=h+16|0,l=v-48|0,v=l,o=i[i[e>>2]+184>>2],f=i[o+104>>2];i:{if((f|0)==i[o+108>>2]){f=C(40),i[l+12>>2]=f,i[l+16>>2]=33,i[l+20>>2]=-2147483608,t[f+32|0]=u[26436],o=u[26432]|u[26433]<<8|(u[26434]<<16|u[26435]<<24),k=u[26428]|u[26429]<<8|(u[26430]<<16|u[26431]<<24),t[f+24|0]=k,t[f+25|0]=k>>>8,t[f+26|0]=k>>>16,t[f+27|0]=k>>>24,t[f+28|0]=o,t[f+29|0]=o>>>8,t[f+30|0]=o>>>16,t[f+31|0]=o>>>24,o=u[26424]|u[26425]<<8|(u[26426]<<16|u[26427]<<24),k=u[26420]|u[26421]<<8|(u[26422]<<16|u[26423]<<24),t[f+16|0]=k,t[f+17|0]=k>>>8,t[f+18|0]=k>>>16,t[f+19|0]=k>>>24,t[f+20|0]=o,t[f+21|0]=o>>>8,t[f+22|0]=o>>>16,t[f+23|0]=o>>>24,o=u[26416]|u[26417]<<8|(u[26418]<<16|u[26419]<<24),k=u[26412]|u[26413]<<8|(u[26414]<<16|u[26415]<<24),t[f+8|0]=k,t[f+9|0]=k>>>8,t[f+10|0]=k>>>16,t[f+11|0]=k>>>24,t[f+12|0]=o,t[f+13|0]=o>>>8,t[f+14|0]=o>>>16,t[f+15|0]=o>>>24,o=u[26408]|u[26409]<<8|(u[26410]<<16|u[26411]<<24),k=u[26404]|u[26405]<<8|(u[26406]<<16|u[26407]<<24),t[f|0]=k,t[f+1|0]=k>>>8,t[f+2|0]=k>>>16,t[f+3|0]=k>>>24,t[f+4|0]=o,t[f+5|0]=o>>>8,t[f+6|0]=o>>>16,t[f+7|0]=o>>>24,t[f+33|0]=0,f=a(l+24|0,2,0,l+12|0),o=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=o,o=s+8|0;e:{if(t[f+19|0]>=0){k=i[f+12>>2],i[o>>2]=i[f+8>>2],i[o+4>>2]=k,i[o+8>>2]=i[f+16>>2],t[s+20|0]=1;break e}if(T(o,i[f+8>>2],i[f+12>>2]),o=t[f+19|0],t[s+20|0]=1,(o|0)>=0)break e;Z(i[f+8>>2])}if(t[l+23|0]>=0)break i;Z(i[l+12>>2]);break i}k=i[f>>2],o=i[f+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);e:{r:{if(!k||(k=Z0(k,92792,112676),!k))break r;o&&(i[o+4>>2]=i[o+4>>2]+1);f:{A:{k:{if(f=i[k+36>>2],n=i[k+40>>2],(f|0)!=(n|0))for(;;){n:{if(k=i[f>>2],!k||(k=Z0(k,92792,112756),!k))break n;if(f=i[f+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),t[k+115|0]<0)break k;i[l+8>>2]=i[k+112>>2],n=i[k+108>>2],i[l>>2]=i[k+104>>2],i[l+4>>2]=n;break A}if(f=f+8|0,(n|0)==(f|0))break}f=C(40),i[l+12>>2]=f,i[l+16>>2]=38,i[l+20>>2]=-2147483608,k=u[24348]|u[24349]<<8|(u[24350]<<16|u[24351]<<24),n=u[24344]|u[24345]<<8|(u[24346]<<16|u[24347]<<24),t[f+30|0]=n,t[f+31|0]=n>>>8,t[f+32|0]=n>>>16,t[f+33|0]=n>>>24,t[f+34|0]=k,t[f+35|0]=k>>>8,t[f+36|0]=k>>>16,t[f+37|0]=k>>>24,k=u[24342]|u[24343]<<8|(u[24344]<<16|u[24345]<<24),n=u[24338]|u[24339]<<8|(u[24340]<<16|u[24341]<<24),t[f+24|0]=n,t[f+25|0]=n>>>8,t[f+26|0]=n>>>16,t[f+27|0]=n>>>24,t[f+28|0]=k,t[f+29|0]=k>>>8,t[f+30|0]=k>>>16,t[f+31|0]=k>>>24,k=u[24334]|u[24335]<<8|(u[24336]<<16|u[24337]<<24),n=u[24330]|u[24331]<<8|(u[24332]<<16|u[24333]<<24),t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24,t[f+20|0]=k,t[f+21|0]=k>>>8,t[f+22|0]=k>>>16,t[f+23|0]=k>>>24,k=u[24326]|u[24327]<<8|(u[24328]<<16|u[24329]<<24),n=u[24322]|u[24323]<<8|(u[24324]<<16|u[24325]<<24),t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24,t[f+12|0]=k,t[f+13|0]=k>>>8,t[f+14|0]=k>>>16,t[f+15|0]=k>>>24,k=u[24318]|u[24319]<<8|(u[24320]<<16|u[24321]<<24),n=u[24314]|u[24315]<<8|(u[24316]<<16|u[24317]<<24),t[f|0]=n,t[f+1|0]=n>>>8,t[f+2|0]=n>>>16,t[f+3|0]=n>>>24,t[f+4|0]=k,t[f+5|0]=k>>>8,t[f+6|0]=k>>>16,t[f+7|0]=k>>>24,t[f+38|0]=0,f=a(l+24|0,2,0,l+12|0),k=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=k,k=s+8|0;n:{if(t[f+19|0]>=0){n=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=n,i[k+8>>2]=i[f+16>>2],t[s+20|0]=1;break n}if(T(k,i[f+8>>2],i[f+12>>2]),k=t[f+19|0],t[s+20|0]=1,(k|0)>=0)break n;Z(i[f+8>>2])}if(t[l+23|0]>=0)break f;Z(i[l+12>>2]);break f}T(l,i[k+104>>2],i[k+108>>2])}if(k=i[l+4>>2],i[s>>2]=i[l>>2],i[s+4>>2]=k,i[s+8>>2]=i[l+8>>2],i[l+8>>2]=0,i[l>>2]=0,i[l+4>>2]=0,t[s+20|0]=0,!f||(s=i[f+4>>2],i[f+4>>2]=s-1,s))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(!o)break i;if(f=i[o+4>>2],i[o+4>>2]=f-1,f)break e;W[i[i[o>>2]+8>>2]](o),y(o);break e}f=C(40),i[l+12>>2]=f,i[l+16>>2]=39,i[l+20>>2]=-2147483608,k=u[24164]|u[24165]<<8|(u[24166]<<16|u[24167]<<24),n=u[24160]|u[24161]<<8|(u[24162]<<16|u[24163]<<24),t[f+31|0]=n,t[f+32|0]=n>>>8,t[f+33|0]=n>>>16,t[f+34|0]=n>>>24,t[f+35|0]=k,t[f+36|0]=k>>>8,t[f+37|0]=k>>>16,t[f+38|0]=k>>>24,k=u[24157]|u[24158]<<8|(u[24159]<<16|u[24160]<<24),n=u[24153]|u[24154]<<8|(u[24155]<<16|u[24156]<<24),t[f+24|0]=n,t[f+25|0]=n>>>8,t[f+26|0]=n>>>16,t[f+27|0]=n>>>24,t[f+28|0]=k,t[f+29|0]=k>>>8,t[f+30|0]=k>>>16,t[f+31|0]=k>>>24,k=u[24149]|u[24150]<<8|(u[24151]<<16|u[24152]<<24),n=u[24145]|u[24146]<<8|(u[24147]<<16|u[24148]<<24),t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24,t[f+20|0]=k,t[f+21|0]=k>>>8,t[f+22|0]=k>>>16,t[f+23|0]=k>>>24,k=u[24141]|u[24142]<<8|(u[24143]<<16|u[24144]<<24),n=u[24137]|u[24138]<<8|(u[24139]<<16|u[24140]<<24),t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24,t[f+12|0]=k,t[f+13|0]=k>>>8,t[f+14|0]=k>>>16,t[f+15|0]=k>>>24,k=u[24133]|u[24134]<<8|(u[24135]<<16|u[24136]<<24),n=u[24129]|u[24130]<<8|(u[24131]<<16|u[24132]<<24),t[f|0]=n,t[f+1|0]=n>>>8,t[f+2|0]=n>>>16,t[f+3|0]=n>>>24,t[f+4|0]=k,t[f+5|0]=k>>>8,t[f+6|0]=k>>>16,t[f+7|0]=k>>>24,t[f+39|0]=0,f=a(l+24|0,5,0,l+12|0),k=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=k,k=s+8|0;r:{if(t[f+19|0]>=0){n=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=n,i[k+8>>2]=i[f+16>>2],t[s+20|0]=1;break r}if(T(k,i[f+8>>2],i[f+12>>2]),k=t[f+19|0],t[s+20|0]=1,(k|0)>=0)break r;Z(i[f+8>>2])}if(t[l+23|0]<0&&Z(i[l+12>>2]),!o)break i}if(f=i[o+4>>2],i[o+4>>2]=f-1,f)break i;W[i[i[o>>2]+8>>2]](o),y(o)}v=l+48|0;i:{e:switch(u[h+36|0]){default:e2(),M();case 1:c0(A,h+16|0,i[e+8>>2]);break i;case 0:break e}e:{if(!r)break e;i[h+8>>2]=i[h+24>>2],i[h+24>>2]=0,e=i[h+20>>2],i[h>>2]=i[h+16>>2],i[h+4>>2]=e,i[h+16>>2]=0,i[h+20>>2]=0,o=t[h+11|0],s=(o|0)<0,f=s?i[h+4>>2]:o,k=C(f+1|0),l=k,e=f,w=i[h>>2],s=s?w:h;r:{f:{A:{k:{if((s^k)&3)break k;n=(f|0)!=0;n:{if(!(s&3)|!f)break n;for(;;){if(n=u[s|0],t[l|0]=n,!n)break r;if(l=l+1|0,e=e-1|0,n=(e|0)!=0,s=s+1|0,!(s&3))break n;if(!e)break}}if(!n)break f;if(!u[s|0])break r;if(e>>>0<4)break k;for(;;){if(n=i[s>>2],((16843008-n|n)&-2139062144)!=-2139062144)break A;if(i[l>>2]=n,l=l+4|0,s=s+4|0,e=e-4|0,!(e>>>0>3))break}}if(!e)break f}for(;;){if(n=u[s|0],t[l|0]=n,!n)break r;if(l=l+1|0,s=s+1|0,e=e-1|0,!e)break}}e=0}if(Ni(l,0,e),t[f+k|0]=0,i[r>>2]=k,(o|0)>=0)break e;Z(w)}e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}A=u[h+36|0],(A|0)!=255&&(e=i[25817],i[h>>2]=i[25816],i[h+4>>2]=e,W[i[h+(A<<2)>>2]](h+47|0,h+16|0)),v=h+48|0}function x9(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;f=v-192|0,v=f,X[f+150>>1]=0,X[f+152>>1]=0,X[f+154>>1]=0,X[f+156>>1]=0,i[f+144>>2]=0,i[f+148>>2]=0,t[f+167|0]=0,t[f+168|0]=0,t[f+169|0]=0,t[f+170|0]=0,t[f+171|0]=0,t[f+172|0]=0,t[f+173|0]=0,t[f+174|0]=0,t[f+175|0]=0,t[f+176|0]=0,t[f+177|0]=0,t[f+178|0]=0,t[f+179|0]=0,t[f+180|0]=0,t[f+181|0]=0,t[f+182|0]=0,t[f+183|0]=0,t[f+184|0]=0,t[f+185|0]=0,t[f+186|0]=0,t[f+187|0]=0,t[f+188|0]=0,t[f+189|0]=0,t[f+190|0]=0,t[f+191|0]=0,i[f+136>>2]=0,i[f+140>>2]=0,t[f+159|0]=0,t[f+160|0]=0,t[f+161|0]=0,t[f+162|0]=0,t[f+163|0]=0,t[f+164|0]=0,t[f+165|0]=0,t[f+166|0]=0,t[f+158|0]=1,s=i[e>>2],k=i[s+204>>2],o=i[s+208>>2];i:{if((k|0)!=(o|0))for(;;){if(i[k>>2]==(r|0)){i[f+136>>2]=r,r=f+136|0,(r|0)!=(k|0)&&(o=r|4,r=i[k+4>>2],n=i[k+8>>2],h1(o,r,n,n-r>>2),s=i[e>>2],o=i[s+208>>2]),r=i[k+52>>2],i[f+184>>2]=i[k+48>>2],i[f+188>>2]=r,r=i[k+44>>2],i[f+176>>2]=i[k+40>>2],i[f+180>>2]=r,r=i[k+36>>2],i[f+168>>2]=i[k+32>>2],i[f+172>>2]=r,r=i[k+28>>2],i[f+160>>2]=i[k+24>>2],i[f+164>>2]=r,r=i[k+20>>2],i[f+152>>2]=i[k+16>>2],i[f+156>>2]=r,n=k+56|0;e:{if((o|0)==(n|0)){r=k;break e}for(r=k;i[r>>2]=i[n>>2],l=i[r+4>>2],l&&(i[r+8>>2]=l,Z(l),i[r+12>>2]=0),i[r+4>>2]=i[n+4>>2],i[r+8>>2]=i[n+8>>2],i[r+12>>2]=i[n+12>>2],i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,l=i[n+52>>2],i[r+48>>2]=i[n+48>>2],i[r+52>>2]=l,l=i[n+44>>2],i[r+40>>2]=i[n+40>>2],i[r+44>>2]=l,l=i[n+36>>2],i[r+32>>2]=i[n+32>>2],i[r+36>>2]=l,l=i[n+28>>2],i[r+24>>2]=i[n+24>>2],i[r+28>>2]=l,l=i[n+20>>2],i[r+16>>2]=i[n+16>>2],i[r+20>>2]=l,r=r+56|0,n=n+56|0,(o|0)!=(n|0););o=i[s+208>>2]}if(r=(r-k|0)+k|0,(r|0)!=(o|0))for(;k=i[o-52>>2],k&&(i[o-48>>2]=k,Z(k)),o=o-56|0,(r|0)!=(o|0););i[s+208>>2]=r,s=i[e>>2],r=i[f+184>>2];break i}if(k=k+56|0,(o|0)==(k|0))break}r=0}if(R5(s+216|0,r),i[f+132>>2]=0,i[f+124>>2]=0,i[f+128>>2]=0,s=i[f+140>>2],B=i[f+144>>2],(s|0)!=(B|0)){i:{e:{r:{if(r=B-s|0,(r|0)>=0){for(k=C(r),i[f+128>>2]=k,i[f+124>>2]=k,i[f+132>>2]=r+k,m=A+80|0,l=f+112|0;;){h=i[s>>2],t[f+108|0]=1,i[f+100>>2]=0,i[f+104>>2]=0,X[f+96>>1]=0,i[f+92>>2]=255,X[f+88>>1]=0,i[f+80>>2]=0,i[f+84>>2]=65535,i[l+8>>2]=0,i[l>>2]=0,i[l+4>>2]=0,k=i[e>>2],r=i[k+80>>2],k=i[k+84>>2];f:{if((r|0)==(k|0))break f;for(;;){if(i[r>>2]!=(h|0)){if(r=r+44|0,(k|0)!=(r|0))continue;break f}break}if(k=u[r+25|0]|u[r+26|0]<<8|(u[r+27|0]<<16|u[r+28|0]<<24),n=u[r+21|0]|u[r+22|0]<<8|(u[r+23|0]<<16|u[r+24|0]<<24),t[f+101|0]=n,t[f+102|0]=n>>>8,t[f+103|0]=n>>>16,t[f+104|0]=n>>>24,t[f+105|0]=k,t[f+106|0]=k>>>8,t[f+107|0]=k>>>16,t[f+108|0]=k>>>24,k=i[r+20>>2],i[f+96>>2]=i[r+16>>2],i[f+100>>2]=k,k=i[r+12>>2],i[f+88>>2]=i[r+8>>2],i[f+92>>2]=k,k=i[r+4>>2],i[f+80>>2]=i[r>>2],i[f+84>>2]=k,(f+80|0)==(r|0))break f;if(t[r+43|0]>=0){k=i[r+36>>2],i[l>>2]=i[r+32>>2],i[l+4>>2]=k,i[l+8>>2]=i[r+40>>2];break f}m1(l,i[r+32>>2],i[r+36>>2])}r=i[A+92>>2],i[A+92>>2]=r+1,i[f+84>>2]=6,i[f+80>>2]=r,kt(f+68|0,6,99),r=i[f+68>>2],(r|0)!=i[f+72>>2]&&(X[f+88>>1]=p[r>>1]),r=i[f+128>>2],o=i[f+132>>2];f:{if(r>>>0<o>>>0){i[r>>2]=i[f+80>>2],r=r+4|0;break f}if(n=i[f+124>>2],r=r-n|0,_=r>>2,k=_+1|0,k>>>0>=1073741824)break r;if(o=o-n|0,w=o>>1,o=o>>>0>=2147483644?1073741823:k>>>0<w>>>0?w:k,o){if(o>>>0>=1073741824)break e;k=C(o<<2)}else k=0;if(w=k+r|0,i[w>>2]=i[f+80>>2],_=w-(_<<2)|0,r&&z(_,n,r),i[f+132>>2]=k+(o<<2),r=w+4|0,i[f+128>>2]=r,i[f+124>>2]=_,!n)break f;Z(n)}k=u[f+105|0]|u[f+106|0]<<8|(u[f+107|0]<<16|u[f+108|0]<<24),n=u[f+101|0]|u[f+102|0]<<8|(u[f+103|0]<<16|u[f+104|0]<<24),t[f+45|0]=n,t[f+46|0]=n>>>8,t[f+47|0]=n>>>16,t[f+48|0]=n>>>24,t[f+49|0]=k,t[f+50|0]=k>>>8,t[f+51|0]=k>>>16,t[f+52|0]=k>>>24,k=i[f+100>>2],i[f+40>>2]=i[f+96>>2],i[f+44>>2]=k,k=i[f+92>>2],i[f+32>>2]=i[f+88>>2],i[f+36>>2]=k,k=i[f+84>>2],i[f+24>>2]=i[f+80>>2],i[f+28>>2]=k,i[f+128>>2]=r,i[f+64>>2]=i[l+8>>2],r=i[l+4>>2],i[f+56>>2]=i[l>>2],i[f+60>>2]=r,i[l>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,r=i[A+84>>2];f:{if(r>>>0<o0[A+88>>2]){k=i[f+88>>2],n=i[f+92>>2],o=i[f+96>>2],w=i[f+100>>2],_=i[f+104>>2],G=i[f+80>>2],I=i[f+84>>2],t[r+28|0]=u[f+108|0],i[r+24>>2]=_,i[r+16>>2]=o,i[r+20>>2]=w,i[r+8>>2]=k,i[r+12>>2]=n,i[r>>2]=G,i[r+4>>2]=I,i[r+40>>2]=i[f+64>>2],k=i[f+60>>2],i[r+32>>2]=i[f+56>>2],i[r+36>>2]=k,i[f+56>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[A+84>>2]=r+44;break f}if(r=U8(m,f+24|0),k=t[f+67|0],i[A+84>>2]=r,(k|0)>=0)break f;Z(i[f+56>>2])}f:{A:{if(w=i[e>>2],k=i[w+80>>2],o=i[w+84>>2],(k|0)==(o|0))break A;for(;;){if(i[k>>2]==(h|0))break A;if(k=k+44|0,(o|0)==(k|0))break}break f}if((k|0)==(o|0))break f;if(n=k,r=k+44|0,(o|0)!=(r|0)){for(;h=i[r+4>>2],i[n>>2]=i[r>>2],i[n+4>>2]=h,h=u[r+25|0]|u[r+26|0]<<8|(u[r+27|0]<<16|u[r+28|0]<<24),_=u[r+21|0]|u[r+22|0]<<8|(u[r+23|0]<<16|u[r+24|0]<<24),t[n+21|0]=_,t[n+22|0]=_>>>8,t[n+23|0]=_>>>16,t[n+24|0]=_>>>24,t[n+25|0]=h,t[n+26|0]=h>>>8,t[n+27|0]=h>>>16,t[n+28|0]=h>>>24,h=i[r+20>>2],i[n+16>>2]=i[r+16>>2],i[n+20>>2]=h,h=i[r+12>>2],i[n+8>>2]=i[r+8>>2],i[n+12>>2]=h,t[n+43|0]<0&&Z(i[n+32>>2]),h=i[r+36>>2],i[n+32>>2]=i[r+32>>2],i[n+36>>2]=h,i[n+40>>2]=i[r+40>>2],t[r+43|0]=0,t[r+32|0]=0,n=n+44|0,r=r+44|0,(o|0)!=(r|0););o=i[w+84>>2]}if(r=(n-k|0)+k|0,(r|0)!=(o|0))for(;t[o-1|0]<0&&Z(i[o-12>>2]),o=o-44|0,(r|0)!=(o|0););i[w+84>>2]=r}if(r=i[f+68>>2],r&&(i[f+72>>2]=r,Z(r)),t[f+123|0]<0&&Z(i[f+112>>2]),s=s+4|0,(B|0)==(s|0))break}break i}s0(),M()}s0(),M()}x0(),M()}s=i[f+140>>2]}s&&(i[f+144>>2]=s,Z(s)),i[f+140>>2]=i[f+124>>2],r=i[f+128>>2],k=i[f+132>>2],i[f+132>>2]=0,i[f+144>>2]=r,i[f+148>>2]=k,i[f+124>>2]=0,i[f+128>>2]=0,i[f+136>>2]=6;i:{r=i[A+208>>2];e:{if(r>>>0<o0[A+212>>2]){if(i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=6,k=i[f+144>>2],o=i[f+140>>2],(k|0)!=(o|0)){if(k=k-o|0,(k|0)<0)break i;n=C(k),i[r+8>>2]=n,i[r+4>>2]=n,s=k+n|0,i[r+12>>2]=s,k&&z(n,o,k),i[r+8>>2]=s}k=i[f+156>>2],i[r+16>>2]=i[f+152>>2],i[r+20>>2]=k,k=i[f+188>>2],i[r+48>>2]=i[f+184>>2],i[r+52>>2]=k,k=i[f+180>>2],i[r+40>>2]=i[f+176>>2],i[r+44>>2]=k,k=i[f+172>>2],i[r+32>>2]=i[f+168>>2],i[r+36>>2]=k,k=i[f+164>>2],i[r+24>>2]=i[f+160>>2],i[r+28>>2]=k,r=r+56|0;break e}r=ht(A+204|0,f+136|0)}i[A+208>>2]=r,D4(f+4|0,A+216|0,i[f+184>>2],i[i[e>>2]+216>>2],20557),t[f+23|0]<0&&Z(i[f+12>>2]),A=i[f+124>>2],A&&(i[f+128>>2]=A,Z(A)),A=i[f+140>>2],A&&(i[f+144>>2]=A,Z(A)),v=f+192|0;return}s0(),M()}function oA(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0;s=v-96|0,v=s;i:{e:{r:{if(!(r>>>0>f>>>0|k>>>0>n>>>0|o0[e+188>>2]<=f>>>0)&&o0[e+192>>2]>n>>>0)break r;e=C(24),i[s>>2]=e,i[s+4>>2]=19,i[s+8>>2]=-2147483624,r=u[9620]|u[9621]<<8|(u[9622]<<16|u[9623]<<24),t[e+15|0]=r,t[e+16|0]=r>>>8,t[e+17|0]=r>>>16,t[e+18|0]=r>>>24,r=u[9617]|u[9618]<<8|(u[9619]<<16|u[9620]<<24),f=u[9613]|u[9614]<<8|(u[9615]<<16|u[9616]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[9609]|u[9610]<<8|(u[9611]<<16|u[9612]<<24),f=u[9605]|u[9606]<<8|(u[9607]<<16|u[9608]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+19|0]=0,e=a(s+24|0,5,2006,s),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(t[s+11|0]>=0)break e;Z(i[s>>2]);break e}if(l=i[e+200>>2],!(!(r&1&(l|0)==2)&(!((r|k)&1)|(l|0)!=1))){if(i[s+8>>2]=0,i[s+12>>2]=0,i[s>>2]=0,i[s+4>>2]=0,t[s+12|0]=1,i[s+4>>2]=2,i[s+8>>2]=2,t[s|0]=1,i[s+88>>2]=i[e+164>>2],l=i[e+168>>2],!l||(l=Oi(l),i[s+92>>2]=l,!l))break i;i[s+80>>2]=131074,i[s+84>>2]=65538,m=s+24|0,h=s+88|0,_=s+80|0,l=i[e+204>>2],e=i[e+208>>2],w=0;r:{if((l|0)==(e|0))break r;f:{for(;;){if(!i[l>>2])break f;if(l=l+56|0,(e|0)==(l|0))break}w=0;break r}w=p[l+20>>1]}cA(m,h,0,_,w,s,0,o),e=i[s+92>>2];r:{if(!e||(l=i[e+4>>2],i[e+4>>2]=l-1,l))break r;W[i[i[e>>2]+8>>2]](e),y(e)}r:{f:switch(u[s+44|0]){default:e2(),M();case 1:e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,e=A+8|0;A:{if(t[s+43|0]>=0){r=i[s+36>>2],i[e>>2]=i[s+32>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+40>>2];break A}T(e,i[s+32>>2],i[s+36>>2])}t[A+20|0]=1;break r;case 0:break f}oA(A,i[s+24>>2],r,f,k,n,o)}if(A=u[s+44|0],(A|0)==255)break e;e=i[25409],i[s+88>>2]=i[25408],i[s+92>>2]=e,W[i[(s+88|0)+(A<<2)>>2]](s+80|0,s+24|0);break e}if(_=C(248),l=_,i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=101168,l0(l+16|0,0,156),i[l+76>>2]=0,i[l+80>>2]=0,i[l+36>>2]=1,i[l+40>>2]=1,t[l+24|0]=1,X[l+22>>1]=2,X[l+18>>1]=2,X[l+20>>1]=2,i[l+84>>2]=0,i[l+88>>2]=0,i[l+92>>2]=0,i[l+96>>2]=0,i[l+128>>2]=0,i[l+132>>2]=0,i[l+100>>2]=0,i[l+104>>2]=1,i[l+136>>2]=0,i[l+140>>2]=0,i[l+144>>2]=0,i[l+148>>2]=0,i[l+152>>2]=0,i[l+156>>2]=0,X[l+158>>1]=0,X[l+160>>1]=0,X[l+162>>1]=0,X[l+164>>1]=0,i[l+184>>2]=0,i[l+188>>2]=0,i[l+172>>2]=255,i[l+192>>2]=0,i[l+196>>2]=5186,i[l+208>>2]=99,i[l+212>>2]=99,i[l+200>>2]=0,i[l+204>>2]=0,i[l+12>>2]=101488,i[l+216>>2]=0,i[l+220>>2]=0,i[l+224>>2]=0,i[l+228>>2]=0,i[l+232>>2]=0,i[l+236>>2]=0,i[l+240>>2]=0,i[l+244>>2]=0,E=l+12|0,i[l+176>>2]=E,i[l+8>>2]=i[l+8>>2]+1,i[l+180>>2]=l,i[l+4>>2]==-1&&(W[i[i[l>>2]+8>>2]](l),y(l)),l=i[e+200>>2],w=i[e+196>>2],i[_+208>>2]=w,i[_+204>>2]=(n-k|0)+1,i[_+200>>2]=(f-r|0)+1,i[_+212>>2]=(w|0)==1?l||3:l,Ye(E,e),B=i[e+204>>2],N=i[e+208>>2],(B|0)!=(N|0))for(O=_+216|0,S=_+228|0;;){if(l=i[B>>2],U=zu(r,l,i[e+200>>2],2),m=zu(f,l,i[e+200>>2],0),w=xu(k,l,i[e+200>>2],2),R=xu(n,l,i[e+200>>2],0),X[s+44>>1]=0,i[s+36>>2]=0,i[s+40>>2]=0,i[s+28>>2]=0,i[s+32>>2]=0,t[s+46|0]=1,t[s+79|0]=0,t[s+71|0]=0,t[s+72|0]=0,t[s+73|0]=0,t[s+74|0]=0,t[s+75|0]=0,t[s+76|0]=0,t[s+77|0]=0,t[s+78|0]=0,t[s+63|0]=0,t[s+64|0]=0,t[s+65|0]=0,t[s+66|0]=0,t[s+67|0]=0,t[s+68|0]=0,t[s+69|0]=0,t[s+70|0]=0,t[s+55|0]=0,t[s+56|0]=0,t[s+57|0]=0,t[s+58|0]=0,t[s+59|0]=0,t[s+60|0]=0,t[s+61|0]=0,t[s+62|0]=0,t[s+47|0]=0,t[s+48|0]=0,t[s+49|0]=0,t[s+50|0]=0,t[s+51|0]=0,t[s+52|0]=0,t[s+53|0]=0,t[s+54|0]=0,i[s+24>>2]=l,x=(m-U|0)+1|0,O6(s,s+24|0,x,(R-w|0)+1|0,i[B+16>>2],p[B+20>>1],u[B+22|0],o,S),i[s>>2]){e=i[s+4>>2],i[A>>2]=i[s>>2],i[A+4>>2]=e,e=A+8|0;r:{if(t[s+19|0]>=0){r=i[s+12>>2],i[e>>2]=i[s+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+16>>2],t[A+20|0]=1;break r}if(T(e,i[s+8>>2],i[s+12>>2]),e=t[s+19|0],t[A+20|0]=1,(e|0)>=0)break r;Z(i[s+8>>2])}if(A=i[s+28>>2],A&&(i[s+32>>2]=A,Z(A)),A=i[_+4>>2],i[_+4>>2]=A-1,A)break e;W[i[i[_>>2]+8>>2]](_),y(_);break e}t[s+19|0]<0&&Z(i[s+8>>2]),h=0,i[s+8>>2]=0,i[s>>2]=0,i[s+4>>2]=0;r:{f:{A:{if(I=i[B+4>>2],V=i[B+8>>2],(I|0)!=(V|0)){if(l=V-I|0,(l|0)<0)break A;h=C(l),i[s+4>>2]=h,i[s>>2]=h,i[s+8>>2]=l+h,V=i[B+8>>2],I=i[B+4>>2]}if((I|0)==(V|0))break r;for(;;){m=0,l=i[e+80>>2],Q=i[e+84>>2];k:{if((l|0)==(Q|0))break k;for(G=i[I>>2];;){if((G|0)==i[l>>2]){m=l;break k}if(l=l+44|0,(Q|0)==(l|0))break}}G=i[s+8>>2];k:{if(G>>>0>h>>>0){i[h>>2]=m,h=h+4|0;break k}if(Q=i[s>>2],l=h-Q|0,j=l>>2,h=j+1|0,h>>>0>=1073741824)break A;if(G=G-Q|0,Y=G>>1,G=G>>>0>=2147483644?1073741823:h>>>0<Y>>>0?Y:h,G){if(G>>>0>=1073741824)break f;h=C(G<<2)}else h=0;if(Y=h+l|0,i[Y>>2]=m,m=Y-(j<<2)|0,l&&z(m,Q,l),i[s+8>>2]=h+(G<<2),h=Y+4|0,i[s+4>>2]=h,i[s>>2]=m,!Q)break k;Z(Q)}if(i[s+4>>2]=h,I=I+4|0,(V|0)==(I|0))break}break r}s0(),M()}x0(),M()}if(yn(E,s+24|0,s),w>>>0<=R>>>0)for(h=i[B+52>>2],I=i[s+64>>2],V=i[s+76>>2],l=u[B+23|0],m=g(l,x),Q=i[B+40>>2]+g(l,U)|0,l=w;m&&z(I+g(V,l-w|0)|0,Q+g(l,h)|0,m),l=l+1|0,R>>>0>=l>>>0;);l=i[_+220>>2];r:{if(l>>>0<o0[_+224>>2]){w=i[s+24>>2],i[l+12>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=w,i[l+4>>2]=i[s+28>>2],i[l+8>>2]=i[s+32>>2],i[l+12>>2]=i[s+36>>2],i[s+36>>2]=0,i[s+28>>2]=0,i[s+32>>2]=0,w=i[s+76>>2],i[l+48>>2]=i[s+72>>2],i[l+52>>2]=w,w=i[s+68>>2],i[l+40>>2]=i[s+64>>2],i[l+44>>2]=w,w=i[s+60>>2],i[l+32>>2]=i[s+56>>2],i[l+36>>2]=w,w=i[s+52>>2],i[l+24>>2]=i[s+48>>2],i[l+28>>2]=w,w=i[s+44>>2],i[l+16>>2]=i[s+40>>2],i[l+20>>2]=w,l=l+56|0;break r}l=l3(O,s+24|0)}if(i[_+220>>2]=l,l=i[s>>2],l&&(i[s+4>>2]=l,Z(l)),l=i[s+28>>2],l&&(i[s+32>>2]=l,Z(l)),B=B+56|0,(N|0)==(B|0))break}if(r=i[e+224>>2],f=i[e+228>>2],(r|0)!=(f|0))for(k=_+236|0,l=i[_+240>>2];;){r:{if(o0[_+244>>2]>l>>>0){if(e=i[r+4>>2],i[l>>2]=i[r>>2],i[l+4>>2]=e,e=l+8|0,t[r+19|0]>=0){n=i[r+12>>2],i[e>>2]=i[r+8>>2],i[e+4>>2]=n,i[e+8>>2]=i[r+16>>2],l=l+20|0;break r}T(e,i[r+8>>2],i[r+12>>2]),l=l+20|0;break r}l=yi(k,r)}if(i[_+240>>2]=l,r=r+20|0,(f|0)==(r|0))break}t[A+20|0]=0,i[A+4>>2]=_,i[A>>2]=E}v=s+96|0;return}sf(),M()}function T9(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0;if(w=v-128|0,v=w,e){i:{for(;;){e:{r:{f:{A:{h=u[r|0];k:{if((h|0)!=37){if(h)break k;n=_;break i}o=0,l=1;n:switch(n=u[r+1|0],n-45|0){case 0:case 3:break A;case 1:case 2:break f;default:break n}if((n|0)==95)break A;if(n)break f}t[A+_|0]=h,_=_+1|0;break r}o=n,n=u[r+2|0],l=2}Y=0,x=n,h=(r+l|0)+((n|0)==43)|0;f:{if(t[h|0]-48>>>0<=9){r=Fi(h,w+12|0,10,-1,0),l=i[w+12>>2];break f}i[w+12>>2]=h,r=0,l=h}n=u[l|0],s=n-67|0;f:{if(s>>>0>22|!(1<<s&4194329)||(Y=r,r))break f;Y=(l|0)!=(h|0)}(n|0)==79|(n|0)==69?(n=u[l+1|0],r=l+1|0):r=l,h=w+16|0,N=o,o=0,m=v-80|0,v=m,B=1786,U=48,G=131112;f:{A:{k:{n:{t:{o:{l:{u:{s:{h:{w:{_:{v:{B:{m:{g:{Z:{W:{X:{V:{I:{F:{Q:{p:{Y:{D:{U:{M:{J:{C:{y:{N:{E:{_0:{H:{z:{x:{R:{T:{j:{S:{O:{P:{L:{q:{a:switch(I=n<<24>>24,I-37|0){case 0:break v;case 28:break q;case 29:break P;case 30:break O;case 31:break l;case 33:break T;case 34:case 66:break R;case 35:break x;case 36:break z;case 40:break E;case 45:break C;case 46:break M;case 47:break D;case 48:break p;case 49:break F;case 50:break Q;case 51:break W;case 52:break g;case 53:break B;case 60:break a;case 61:case 67:break L;case 62:break u;case 63:break j;case 64:break S;case 69:break H;case 72:break _0;case 73:break N;case 75:break y;case 77:break s;case 78:break J;case 79:break U;case 80:break Y;case 82:break I;case 83:break X;case 84:break Z;case 85:break m;default:break f}if(n=i[f+24>>2],n>>>0<=6)break w;break k}if(n=i[f+24>>2],n>>>0>6)break k;o=n+131079|0;break h}if(n=i[f+16>>2],n>>>0>11)break k;o=n+131086|0;break h}if(n=i[f+16>>2],n>>>0>11)break k;o=n+131098|0;break h}n=i[f+20>>2],o=n>>31,n=n+1900|0,o=n>>>0<1900?o+1|0:o,n=p2(n,o,100,0),l=h0;break o}U=95}n=i[f+12>>2],l=n>>31;break o}B=19571;break l}s=i[f+20>>2],o=s>>31,n=s+1900|0,l=n>>>0<1900?o+1|0:o,G=i[f+28>>2];R:{if((G|0)<=2){s=s+1899|0,o=s>>>0<1899?o+1|0:o,Q=s,s=(h5(f)|0)==1,n=s?n:Q,l=s?l:o;break R}if(G>>>0<361)break R;s=s+1901|0,o=s>>>0<1901?o+1|0:o,Q=s,s=(h5(f)|0)==1,n=s?Q:n,l=s?o:l}if((I|0)==103)break _;break t}n=i[f+8>>2],l=n>>31;break o}if(o=2,l=i[f+8>>2],!l){n=12,l=0;break n}I=(l|0)>12,n=I?l-12|0:l,s=l>>31,l=I?s-(l>>>0<12)|0:s;break n}n=i[f+28>>2]+1|0,l=n>>31,o=3;break n}n=i[f+16>>2]+1|0,l=n>>31;break o}n=i[f+4>>2],l=n>>31;break o}i[w+124>>2]=1,o=47878;break f}o=i[f+8>>2]>11?131111:131110;break h}B=21115;break l}G=0,E=0,R=v-16|0,v=R,n=i[f+20>>2],l=n>>31,B=i[f+16>>2],B>>>0>=12&&(s=(B|0)/12|0,o=B-g(s,12)|0,B=(o|0)<0?o+12|0:o,o=s+(o>>31)|0,l=l+(o>>31)|0,s=n,n=n+o|0,l=s>>>0>n>>>0?l+1|0:l),s=R+12|0;J:{if((n>>>0<2|0)==(l|0)&n-2>>>0<=136){o=n-68>>2;C:{y:{if(!(n&3)){if(o=o-1|0,!s)break C;l=1;break y}if(!s)break C;l=0}i[s>>2]=l}n=(g(n,31536e3)+g(o,86400)|0)+2087447296|0,o=n>>31;break J}o=n-100|0,I=o,n=l-(n>>>0<100)|0,Q=n,n=p2(o,n,400,0),V=L0(n,h0,400,0),l=o-V|0,o=Q-(h0+(o>>>0<V>>>0)|0)|0,V=n+(o>>31)|0;C:{y:{N:{if(n=(o|0)<0?l+400|0:l,n){E:{if((n|0)>=200){if(n>>>0>=300){G=3,n=n-300|0;break E}G=2,n=n-200|0;break E}G=(n|0)>99,n=G?n-100|0:n}if(n)break N;o=0}else o=1;if(s)break y;break C}if(E=n>>>2|0,o=!(n&3),!s)break C}i[s>>2]=o}l=L0(I,Q,31536e3,0),s=h0,I=l,n=((g(G,24)+g(V,97)|0)+E|0)-o|0,l=L0(n,n>>31,86400,0),n=I+l|0,o=h0+s|0,o=n>>>0<l>>>0?o+1|0:o,n=n+946771200|0,o=n>>>0<946771200?o+1|0:o}E=i[f+12>>2],s=i[f+8>>2],Q=s>>31,I=i[f+4>>2],V=I>>31,v=R+16|0,l=i[f>>2],G=l,j=l>>31,l=i[(B<<2)+80384>>2],B=(B|0)>1&&i[R+12>>2]?l+86400|0:l,l=(B>>31)+o|0,o=n+B|0,l=o>>>0<B>>>0?l+1|0:l,n=E-1|0,B=L0(n,n>>31,86400,0),n=B+o|0,o=h0+l|0,o=n>>>0<B>>>0?o+1|0:o,l=L0(s,Q,3600,0),n=l+n|0,o=h0+o|0,o=n>>>0<l>>>0?o+1|0:o,l=L0(I,V,60,0),n=l+n|0,o=h0+o|0,l=(n>>>0<l>>>0?o+1|0:o)+j|0,o=n+G|0,l=o>>>0<n>>>0?l+1|0:l,s=i[f+36>>2],n=o-s|0,l=l-((s>>31)+(o>>>0<s>>>0)|0)|0;break V}n=i[f>>2],l=n>>31;break o}i[w+124>>2]=1,o=47880;break f}B=21056;break l}n=i[f+24>>2],n=n||7,l=n>>31;break V}n=((i[f+28>>2]-i[f+24>>2]|0)+7>>>0)/7|0,l=0;break o}n=((i[f+28>>2]-((i[f+24>>2]+6>>>0)%7|0)|0)+7>>>0)/7|0,l=0;break o}n=h5(f),l=0;break o}n=i[f+24>>2],l=n>>31}o=1;break n}G=131113;break u}G=131114;break u}n=i[f+20>>2],o=n>>31,n=n+1900|0,o=n>>>0<1900?o+1|0:o,o=gs(n,o),n=h0,I=n,l=o,o=n>>31,s=l^o,n=s-o|0,l=(o^I)-((o>>>0>s>>>0)+o|0)|0;break o}if(n=i[f+20>>2],l=n>>31,s=n,o=l,n=n+1900|0,l=n>>>0<1900?o+1|0:o,s>>>0<8100&(o|0)<=0|(o|0)<0)break t;i[m+48>>2]=n,i[m+52>>2]=l,O=w,S=_6(h,100,17450,m+48|0),i[O+124>>2]=S,o=h;break f}if(i[f+32>>2]<0){i[w+124>>2]=0,o=47881;break f}n=i[f+36>>2],o=(n|0)/3600|0,i[m+64>>2]=g(o,100)+((n-g(o,3600)<<16>>16)/60<<16>>16),O=w,S=_6(h,100,17456,m- -64|0),i[O+124>>2]=S,o=h;break f}if(i[f+32>>2]<0){i[w+124>>2]=0,o=47881;break f}o=i[f+40>>2],t[136516]&1||(OB(136472,136476,136528,136560),i[34121]=136560,i[34120]=136528,t[136516]=1);break A}i[w+124>>2]=1,o=30825;break f}n=gs(n,l),l=h0;break o}o=n|131072}o=Xl(o,k);break A}G=131115}B=Xl(G,k)}n=T9(h,100,B,f,k),i[w+124>>2]=n,o=n?h:0;break f}o=2;break n}o=4}n:{if(s=N||U,(s|0)!=95){if((s|0)!=45)break n;i[m+16>>2]=n,i[m+20>>2]=l,O=w,S=_6(h,100,17451,m+16|0),i[O+124>>2]=S,o=h;break f}i[m+40>>2]=n,i[m+44>>2]=l,i[m+32>>2]=o,O=w,S=_6(h,100,17444,m+32|0),i[O+124>>2]=S,o=h;break f}i[m+8>>2]=n,i[m+12>>2]=l,i[m>>2]=o,O=w,S=_6(h,100,17437,m),i[O+124>>2]=S,o=h;break f}o=29394}O=w,S=l2(o),i[O+124>>2]=S}if(v=m+80|0,!o)break e;f:{if(!Y){l=i[w+124>>2];break f}A:{k:{n:switch(n=u[o|0],n-43|0){case 0:case 2:break k;default:break n}l=i[w+124>>2];break A}n=u[o+1|0],o=o+1|0,l=i[w+124>>2]-1|0}A:{if((n&255)!=48)break A;for(;;){if(n=t[o+1|0],n-48>>>0>9)break A;if(o=o+1|0,l=l-1|0,(n|0)!=48)break}}for(i[w+124>>2]=l,n=0;h=n,n=n+1|0,t[o+h|0]-48>>>0<10;);n=l>>>0<Y>>>0?Y:l,s=A+_|0;A:{if(i[f+20>>2]<-1900)h=45;else{if((x|0)!=43|h+(n-l|0)>>>0<(u[i[w+12>>2]]==67?3:5)>>>0)break A;h=43}t[s|0]=h,n=n-1|0,_=_+1|0}if(n>>>0<=l>>>0|e>>>0<=_>>>0)break f;for(;;){if(t[A+_|0]=48,_=_+1|0,n=n-1|0,l>>>0>=n>>>0)break f;if(!(e>>>0>_>>>0))break}}n=e-_|0,n=n>>>0>l>>>0?l:n,i[w+124>>2]=n,v8(A+_|0,o,n),_=i[w+124>>2]+_|0}if(r=r+1|0,e>>>0>_>>>0)continue}break}_=(e|0)==(_|0)?e-1|0:_,n=0}t[A+_|0]=0}return v=w+128|0,n}function zv(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0;r=v+-64|0,v=r,i[r+56>>2]=0,i[r+60>>2]=0,i[r+52>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,f=i[e+180>>2],i[r>>2]=i[f+48>>2],f=i[f+52>>2],i[r+4>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),lt(r+24|0,i[r>>2],i[e+196>>2],r+44|0),f=i[r+4>>2];i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;W[i[i[f>>2]+8>>2]](f),y(f)}i:{if(i[r+24>>2]){e=i[r+28>>2],i[A>>2]=i[r+24>>2],i[A+4>>2]=e,e=A+8|0;e:{if(t[r+43|0]>=0){f=i[r+36>>2],i[e>>2]=i[r+32>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+40>>2];break e}T(e,i[r+32>>2],i[r+36>>2])}t[A+20|0]=1;break i}n=0,o=v-48|0,v=o,f=o+24|0,s=i[e+180>>2],$1(f,s,i[e+196>>2],0),B=i[o+28>>2],k=i[o+24>>2];e:{if(!k){if(t[o+24|0]=0,t[o+35|0]=0,a(r,2,2e3,f),t[o+35|0]>=0)break e;Z(i[o+24>>2]);break e}r:{f:{A:{f=i[k+184>>2],l=i[k+188>>2];k:{if((f|0)==(l|0))break k;e=f;n:{for(;;){t:{if(n=i[e>>2],!n||(h=Z0(n,92792,92812),!h))break t;if(n=i[e+4>>2],!n){n=0;break n}i[n+4>>2]=i[n+4>>2]+1,l=i[k+188>>2],f=i[k+184>>2];break n}if(e=e+8|0,(l|0)==(e|0))break}n=0,h=0}if((f|0)!=(l|0))for(;;){n:{if(e=i[f>>2],!e||(m=Z0(e,92792,107188),!m))break n;if(w=i[f+4>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),!h)break k;if(_=s- -64|0,k=i[h+104>>2],s=i[h+108>>2],Ii(o+24|0,_,k,s),!i[o+24>>2])break A;e=i[o+28>>2],i[r>>2]=i[o+24>>2],i[r+4>>2]=e,i[r+16>>2]=i[o+40>>2],e=i[o+36>>2],i[r+8>>2]=i[o+32>>2],i[r+12>>2]=e,i[o+40>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0;break f}if(f=f+8|0,(l|0)==(f|0))break}}if(e=C(40),i[o+24>>2]=e,i[o+28>>2]=35,i[o+32>>2]=-2147483608,f=u[19781]|u[19782]<<8|(u[19783]<<16|u[19784]<<24),k=u[19777]|u[19778]<<8|(u[19779]<<16|u[19780]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+35|0]=0,f=u[19808]|u[19809]<<8|(u[19810]<<16|u[19811]<<24),t[e+31|0]=f,t[e+32|0]=f>>>8,t[e+33|0]=f>>>16,t[e+34|0]=f>>>24,f=u[19805]|u[19806]<<8|(u[19807]<<16|u[19808]<<24),k=u[19801]|u[19802]<<8|(u[19803]<<16|u[19804]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[19797]|u[19798]<<8|(u[19799]<<16|u[19800]<<24),k=u[19793]|u[19794]<<8|(u[19795]<<16|u[19796]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[19789]|u[19790]<<8|(u[19791]<<16|u[19792]<<24),k=u[19785]|u[19786]<<8|(u[19787]<<16|u[19788]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(r,4,3002,o+24|0),t[o+35|0]>=0)break r;Z(i[o+24>>2]);break r}A:{k:switch(e=u[m+104|0],e-8|0){case 0:case 8:break A;default:break k}if(e=V2(o,10442),a(r,4,3002,e),t[e+11|0]>=0)break f;Z(i[e>>2]);break f}if(l=g(k,e+7>>>3|0),s>>>0>(i[r+48>>2]-i[r+44>>2]>>>0)/(l>>>0)>>>0){if(e=C(32),i[o>>2]=e,i[o+4>>2]=28,i[o+8>>2]=-2147483616,f=u[3926]|u[3927]<<8|(u[3928]<<16|u[3929]<<24),k=u[3922]|u[3923]<<8|(u[3924]<<16|u[3925]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+28|0]=0,f=u[3946]|u[3947]<<8|(u[3948]<<16|u[3949]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,f=u[3942]|u[3943]<<8|(u[3944]<<16|u[3945]<<24),k=u[3938]|u[3939]<<8|(u[3940]<<16|u[3941]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[3934]|u[3935]<<8|(u[3936]<<16|u[3937]<<24),k=u[3930]|u[3931]<<8|(u[3932]<<16|u[3933]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(r,2,0,o),t[o+11|0]>=0)break f;Z(i[o>>2]);break f}e=C(248),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=101168,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,f=e+12|0,i[e+176>>2]=f,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e)),i[r+56>>2]=f,f=i[r+60>>2],i[r+60>>2]=e;A:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break A;W[i[i[f>>2]+8>>2]](f),y(f)}if(h=0,t1(i[r+56>>2],k,s,2,0),a0(o,i[r+56>>2],0,k,s,u[m+104|0],_,0),i[o>>2]){e=i[o+4>>2],i[r>>2]=i[o>>2],i[r+4>>2]=e,e=i[o+12>>2],i[r+8>>2]=i[o+8>>2],i[r+12>>2]=e,i[r+16>>2]=i[o+16>>2];break f}e=Q0(i[r+56>>2],0),e?(h=i[e+52>>2],k=i[e+40>>2]):k=0;A:{if((l|0)!=(h|0)){if(!s)break A;if(e=0,(s|0)!=1)for(m=s&-2,f=0;_=!l,_||z(k+g(e,h)|0,i[r+44>>2]+g(e,l)|0,l),_||(_=e|1,z(k+g(_,h)|0,i[r+44>>2]+g(l,_)|0,l)),e=e+2|0,f=f+2|0,(m|0)!=(f|0););if(!(s&1)|!l)break A;z(k+g(e,h)|0,i[r+44>>2]+g(e,l)|0,l);break A}if(e=g(l,s),!e)break A;z(k,i[r+44>>2],e)}if(Z8(r,114912),t[o+19|0]>=0)break f;Z(i[o+8>>2])}if(t[o+43|0]>=0)break r;Z(i[o+32>>2])}r:{if(!w||(e=i[w+4>>2],i[w+4>>2]=e-1,e))break r;W[i[i[w>>2]+8>>2]](w),y(w)}if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break e;W[i[i[n>>2]+8>>2]](n),y(n)}e:{if(!B||(e=i[B+4>>2],i[B+4>>2]=e-1,e))break e;W[i[i[B>>2]+8>>2]](B),y(B)}v=o+48|0;e:{if(i[r>>2]){if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,e=A+8|0,t[r+19|0]>=0){f=i[r+12>>2],i[e>>2]=i[r+8>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+16>>2],e=1;break e}T(e,i[r+8>>2],i[r+12>>2]),e=1;break e}e=i[r+56>>2],f=i[r+60>>2],i[r+56>>2]=0,i[r+60>>2]=0,i[A>>2]=e,i[A+4>>2]=f,e=0}if(t[A+20|0]=e,t[r+19|0]>=0)break i;Z(i[r+8>>2])}t[r+43|0]<0&&Z(i[r+32>>2]),A=i[r+44>>2],A&&(i[r+48>>2]=A,Z(A)),A=i[r+60>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=r- -64|0}function xv(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0;n=v-240|0,v=n;i:{e:{r:{f:{A:{k:{n:{t:{o:{l:{if(o=i[A+24>>2],i[o>>2]>=2){W[i[o+20>>2]](n+216|0,e,r,f,k,i[A+28>>2]),i[n+208>>2]=0,i[n+200>>2]=0,i[n+204>>2]=0,r=i[n+236>>2];u:{if(!r)break u;if(e=l2(r),e>>>0>=2147483640)break l;s:{h:{if(e>>>0>=11){l=e|7,o=C(l+1|0),i[n+56>>2]=l-2147483647,i[n+48>>2]=o,i[n+52>>2]=e;break h}if(t[n+59|0]=e,o=n+48|0,!e)break s}if(!e)break s;z(o,r,e)}if(t[e+o|0]=0,t[n+211|0]<0&&Z(i[n+200>>2]),i[n+208>>2]=i[n+56>>2],e=i[n+52>>2],i[n+200>>2]=i[n+48>>2],i[n+204>>2]=e,e=i[i[A+24>>2]+32>>2],!e)break u;W[e|0](i[n+236>>2])}u:switch(i[n+216>>2]){case 2:e=C(24),i[n+24>>2]=e,i[n+28>>2]=21,i[n+32>>2]=-2147483624,r=u[12695]|u[12696]<<8|(u[12697]<<16|u[12698]<<24),f=u[12691]|u[12692]<<8|(u[12693]<<16|u[12694]<<24),t[e+13|0]=f,t[e+14|0]=f>>>8,t[e+15|0]=f>>>16,t[e+16|0]=f>>>24,t[e+17|0]=r,t[e+18|0]=r>>>8,t[e+19|0]=r>>>16,t[e+20|0]=r>>>24,r=u[12690]|u[12691]<<8|(u[12692]<<16|u[12693]<<24),f=u[12686]|u[12687]<<8|(u[12688]<<16|u[12689]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[12682]|u[12683]<<8|(u[12684]<<16|u[12685]<<24),f=u[12678]|u[12679]<<8|(u[12680]<<16|u[12681]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+21|0]=0,e=a(n+48|0,2,100,n+24|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,t[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],t[e+19|0]=0,t[e+8|0]=0,t[n+35|0]<0&&Z(i[n+24>>2]),f=i[n+224>>2],k=i[n+228>>2];break e;case 3:if(i[n+236>>2]){i[n+140>>2]=0,i[n+112>>2]=78164,i[n+56>>2]=78144,e=i[19545],i[n+48>>2]=e,r=i[e-12>>2],e=n+48|0,i[r+e>>2]=i[19546],i[n+52>>2]=0,r=e+i[i[n+48>>2]-12>>2]|0,f=n+60|0,J0(r,f),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[n+56>>2]=r,k=i[r-12>>2],r=n+56|0,i[k+r>>2]=i[19548],k=i[19544],i[n+48>>2]=k,i[e+i[k-12>>2]>>2]=i[19549],i[n+112>>2]=78164,i[n+48>>2]=78124,i[n+56>>2]=78144,f=R0(f),i[f>>2]=77200,i[n+100>>2]=0,i[n+104>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+108>>2]=24,k=F(D0(F(r,30418,13),i[n+232>>2]),37805,4),e=t[n+211|0],r=(e|0)<0,F(k,r?i[n+200>>2]:n+200|0,r?i[n+204>>2]:e),e=i[n+108>>2];s:{if(e&16){o=n+80|0,r=i[n+104>>2],e=i[n+84>>2],r>>>0<e>>>0?i[n+104>>2]=e:e=r;break s}if(!(e&8)){e=0,t[n+23|0]=0,o=n+12|0;break f}o=n+68|0,e=i[n+76>>2]}if(r=i[o>>2],e=e-r|0,e>>>0>=2147483640)break o;if(e>>>0>=11){k=e|7,o=C(k+1|0),i[n+20>>2]=k-2147483647,i[n+12>>2]=o,i[n+16>>2]=e;break A}if(t[n+23|0]=e,o=n+12|0,e)break A;e=0;break f}i[n+140>>2]=0,i[n+112>>2]=78164,i[n+56>>2]=78144,e=i[19545],i[n+48>>2]=e,r=i[e-12>>2],e=n+48|0,i[r+e>>2]=i[19546],i[n+52>>2]=0,r=e+i[i[n+48>>2]-12>>2]|0,f=n+60|0,J0(r,f),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[n+56>>2]=r,k=i[r-12>>2],r=n+56|0,i[k+r>>2]=i[19548],k=i[19544],i[n+48>>2]=k,i[e+i[k-12>>2]>>2]=i[19549],i[n+112>>2]=78164,i[n+48>>2]=78124,i[n+56>>2]=78144,f=R0(f),i[f>>2]=77200,i[n+100>>2]=0,i[n+104>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+108>>2]=24,F(D0(F(r,30418,13),i[n+232>>2]),30255,1),e=i[n+108>>2];s:{if(e&16){o=n+80|0,r=i[n+104>>2],e=i[n+84>>2],r>>>0<e>>>0?i[n+104>>2]=e:e=r;break s}if(!(e&8)){e=0,t[n+23|0]=0,o=n+12|0;break k}o=n+68|0,e=i[n+76>>2]}if(r=i[o>>2],e=e-r|0,e>>>0>=2147483640)break t;if(e>>>0>=11){k=e|7,o=C(k+1|0),i[n+20>>2]=k-2147483647,i[n+12>>2]=o,i[n+16>>2]=e;break n}if(t[n+23|0]=e,o=n+12|0,e)break n;e=0;break k;case 0:break e;case 1:break r;default:break u}if(e=C(40),i[n+24>>2]=e,i[n+28>>2]=33,i[n+32>>2]=-2147483608,t[e+32|0]=u[13231],r=u[13227]|u[13228]<<8|(u[13229]<<16|u[13230]<<24),f=u[13223]|u[13224]<<8|(u[13225]<<16|u[13226]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[13219]|u[13220]<<8|(u[13221]<<16|u[13222]<<24),f=u[13215]|u[13216]<<8|(u[13217]<<16|u[13218]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[13211]|u[13212]<<8|(u[13213]<<16|u[13214]<<24),f=u[13207]|u[13208]<<8|(u[13209]<<16|u[13210]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[13203]|u[13204]<<8|(u[13205]<<16|u[13206]<<24),f=u[13199]|u[13200]<<8|(u[13201]<<16|u[13202]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+33|0]=0,e=a(n+48|0,2,0,n+24|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,t[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],t[e+19|0]=0,t[e+8|0]=0,t[n+35|0]>=0)break r;Z(i[n+24>>2]);break r}if(!(W[i[o+16>>2]](f,k,i[A+28>>2])|0))break i;if(e=W[i[i[A+24>>2]+4>>2]](i[A+28>>2])|0,r=h0,o=r,l=e+1|0,r=l?r:r+1|0,(f|0)==(l|0)&(r|0)==(k|0)){f=e,k=o;break i}for(r=f,l=k,f=e,k=o;o=k+l|0,s=r+f|0,o=s>>>0<r>>>0?o+1|0:o,s=(o&1)<<31|s>>>1,e=o>>>1|0,h=W[i[i[A+24>>2]+16>>2]](s,e,i[A+28>>2])|0,r=h?s:r,o=h?e:l,l=o,e=h?k:e,k=e,f=h?f:s,s=f+1|0,e=s?e:e+1|0,!!((r|0)!=(s|0)|(e|0)!=(o|0)););break i}I0(),M()}I0(),M()}I0(),M()}if(!e)break k;z(o,r,e)}t[e+o|0]=0,e=a(n+24|0,2,0,n+12|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,t[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],t[e+19|0]=0,t[e+8|0]=0,t[n+23|0]<0&&Z(i[n+12>>2]),A=i[19543],i[n+48>>2]=A,i[i[A-12>>2]+(n+48|0)>>2]=i[19551],i[n+56>>2]=i[19552],i[f>>2]=77200,t[n+103|0]<0&&Z(i[n+92>>2]),y0(f),Y0(n+112|0);break r}if(!e)break f;z(o,r,e)}t[e+o|0]=0,e=a(n+24|0,2,0,n+12|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,t[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],t[e+19|0]=0,t[e+8|0]=0,t[n+23|0]<0&&Z(i[n+12>>2]),A=i[19543],i[n+48>>2]=A,i[i[A-12>>2]+(n+48|0)>>2]=i[19551],i[n+56>>2]=i[19552],i[f>>2]=77200,t[n+103|0]<0&&Z(i[n+92>>2]),y0(f),Y0(n+112|0)}f=0,k=0}if(t[n+211|0]>=0)break i;Z(i[n+200>>2])}return v=n+240|0,h0=k,f|0}function lA(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=0,c2=0,f1=0,o1=0,u1=0,y1=0,a1=0,d1=0,u4=0,Y4=0,y4=0,E4=0;n=v+-64|0,v=n;i:{e:{w=i[A+276>>2],v2=(f|0)<(w|0)?f:w;r:{if((v2|0)<=(r|0)||(r2=i[A+272>>2],Z2=(k|0)<(r2|0)?k:r2,(Z2|0)<=0))break r;for(o1=e?1:2,u1=e?2:1,R=i[A+40>>2],X2=R<<1,R2=i[A+124>>2],f=i[R2+16832>>2],D2=f-8|0,O=-1<<f^-1,y1=e?4:3,g0=g(R,-6),X0=g(R,6),r0=R<<2,f2=0-r0|0,a1=R<<(e^1)<<3,d1=g(r,R)<<3,u4=i[A+260>>2],V0=0-R<<1,S=R<<1,z0=0-S<<1;;){for(f0=r<<2,c2=f0-1|0,Y4=g(R,f0),y4=g(f1,a1)+d1|0,E4=g(f0>>2,r2)+u4|0,A2=0,j0=0;;){s=j0<<2,c=u[(s>>2)+E4|0]&3;f:{if(!c)break f;f=i[A+4>>2],w=f+(s+Y4<<1)|0;A:{if(!e){X[n+32>>1]=p[w>>1],f=p[w+V0>>1],X[n>>1]=f,X[n+34>>1]=p[w+S>>1],h=p[w+z0>>1],X[n+2>>1]=h,_=S<<1,X[n+36>>1]=p[_+w>>1],m=p[w+g0>>1],X[n+4>>1]=m,X[n+38>>1]=p[w+X0>>1],B=f2<<1,l=p[B+w>>1],X[n+6>>1]=l,k=w+2|0,X[n+40>>1]=p[k>>1],X[n+8>>1]=p[k+V0>>1],X[n+42>>1]=p[k+S>>1],X[n+10>>1]=p[k+z0>>1],X[n+44>>1]=p[k+_>>1],X[n+12>>1]=p[k+g0>>1],X[n+46>>1]=p[k+X0>>1],X[n+14>>1]=p[k+B>>1],k=w+4|0,X[n+48>>1]=p[k>>1],X[n+16>>1]=p[k+V0>>1],X[n+50>>1]=p[k+S>>1],X[n+18>>1]=p[k+z0>>1],X[n+52>>1]=p[k+_>>1],X[n+20>>1]=p[k+g0>>1],X[n+54>>1]=p[k+X0>>1],X[n+22>>1]=p[k+B>>1],o=w+6|0,X[n+56>>1]=p[o>>1],V=p[o+V0>>1],X[n+24>>1]=V,X[n+58>>1]=p[o+S>>1],k=p[o+z0>>1],X[n+26>>1]=k,X[n+60>>1]=p[o+_>>1],_=p[o+g0>>1],X[n+28>>1]=_,X[n+62>>1]=p[o+X0>>1],o=o+B|0;break A}k=f+((A2<<y1)+y4|0)|0,f=p[k+4>>1]|p[k+6>>1]<<16,i[n+32>>2]=p[k>>1]|p[k+2>>1]<<16,i[n+36>>2]=f,f=p[w-2>>1],X[n>>1]=f,h=p[w-4>>1],X[n+2>>1]=h,m=p[w-6>>1],X[n+4>>1]=m,l=p[w-8>>1],X[n+6>>1]=l,o=k+X2|0,_=p[o+4>>1]|p[o+6>>1]<<16,i[n+40>>2]=p[o>>1]|p[o+2>>1]<<16,i[n+44>>2]=_,o=w+S|0,X[n+8>>1]=p[o-2>>1],X[n+10>>1]=p[o-4>>1],X[n+12>>1]=p[o-6>>1],X[n+14>>1]=p[o-8>>1],o=k+r0|0,_=p[o+4>>1]|p[o+6>>1]<<16,i[n+48>>2]=p[o>>1]|p[o+2>>1]<<16,i[n+52>>2]=_,o=w+r0|0,X[n+16>>1]=p[o-2>>1],X[n+18>>1]=p[o-4>>1],X[n+20>>1]=p[o-6>>1],X[n+22>>1]=p[o-8>>1],k=k+X0|0,o=p[k+4>>1]|p[k+6>>1]<<16,i[n+56>>2]=p[k>>1]|p[k+2>>1]<<16,i[n+60>>2]=o,o=w+X0|0,V=p[o-2>>1],X[n+24>>1]=V,k=p[o-4>>1],X[n+26>>1]=k,_=p[o-6>>1],X[n+28>>1]=_,o=o-8|0}if(S0=p[o>>1],X[n+30>>1]=S0,B=i[A+168>>2],E=s>>B,(E|0)<0||(o=i[A+172>>2],(o|0)<=(E|0)))break i;if(N=f0>>B,(N|0)<0||(j=i[A+176>>2],(j|0)<=(N|0)))break e;G=g(E,3),E=i[A+160>>2],U=G+E|0,N=g(g(o,N),3),q=U+N|0,s2=t[q+2|0];A:{if(!e){if(G=c2>>B,(G|0)<0|(G|0)>=(j|0))break e;G=(U+g(g(o,G),3)|0)+2|0;break A}if(G=s-1>>B,(G|0)<0|o>>>0<=G>>>0)break i;G=(N+(E+g(G,3)|0)|0)+2|0}if(I=i[A+148>>2],Q=s>>I,(Q|0)<0||(q0=i[A+152>>2],(q0|0)<=(Q|0)))break i;if(I=f0>>I,(I|0)<0|(I|0)>=i[A+156>>2])break e;if(C0=p[n+56>>1],A0=C0+(p[n+60>>1]-(p[n+58>>1]<<1)|0)|0,t0=A0>>31,V=V&65535,_0=V+(_-((k&65535)<<1)|0)|0,k=_0>>31,M0=p[n+32>>1],Y=M0+(p[n+36>>1]-(p[n+34>>1]<<1)|0)|0,_=Y>>31,m=(m-(h<<1)|0)+f|0,h=m>>31,t0=(t0^A0)-t0|0,A0=(k^_0)-k|0,_0=t0+A0|0,Y=(_^Y)-_|0,x=(h^m)-h|0,d=Y+x|0,_=(s2+t[G|0]|0)+1>>1,k=i[i[A+52>>2]+(p[((i[A+140>>2]+g(Q,24)|0)+g(g(I,q0),24)|0)+2>>1]<<2)>>2],h=_+i[k+764>>2]|0,h=(h|0)>=51?51:h,m=u[((h|0)>0?h:0)+66672|0]<<D2,(_0+d|0)>=(m|0))break f;k=(i[k+768>>2]+(_+(c<<1)|0)|0)-2|0,k=(k|0)>=53?53:k,_=u[((k|0)>0?k:0)+66736|0]<<D2,h=0,Q=m>>>2|0,k=0;A:{if(Q>>>0<=d<<1>>>0||(I=M0-p[n+38>>1]|0,G=I>>31,c=l-f|0,l=c>>31,k=0,(G^I)-G+((l^c)-l)>>>0>=m>>>3>>>0))break A;k=f-M0|0,f=k>>31,k=((f^k)-f|0)<g(_,5)+1>>1}f=k;A:{if(Q>>>0<=_0<<1>>>0||(G=C0-p[n+62>>1]|0,k=G>>31,Q=S0-V|0,l=Q>>31,(k^G)-k+((l^Q)-l)>>>0>=m>>>3>>>0))break A;h=V-C0|0,k=h>>31,h=((k^h)-k|0)<g(_,5)+1>>1}l=u[R2+8812|0];A:{if(!e){if(s=c2>>B,l){if((s|0)<0|(s|0)>=(j|0))break e;k=!(u[(U+g(g(o,s),3)|0)+1|0]&4)}else k=1;if((s|0)<0|(s|0)>=(j|0))break e;o=U+g(g(o,s),3)|0;break A}if(s=s-1>>B,l){if((s|0)<0|o>>>0<=s>>>0)break i;k=!(u[(N+(E+g(s,3)|0)|0)+1|0]&4)}else k=1;if((s|0)<0|o>>>0<=s>>>0)break i;o=N+(E+g(s,3)|0)|0}for(M0=f&h,E=!(u[o+1|0]&8)&k,f=m+(m>>>1|0)>>>3|0,c=E&f>>>0>x+A0>>>0,k=f>>>0>Y+t0>>>0,f=u[q|0]|u[q+1|0]<<8,j=!(f&2048)&(!l|!(f&1024)),t0=k&j,o=_<<1,f=0,C0=0-_|0,S0=g(_,10),s2=w+2|0,q0=w-4|0,A0=w-2|0,q=_>>1,G=0-q|0,_0=w+S|0;;){h=f<<3,k=h+n|0,s=p[k+2>>1],l=h+(n+32|0)|0,U=p[l+4>>1],h=p[l+2>>1],B=p[l>>1],N=p[k+4>>1],m=p[k>>1];A:{if(!M0){if(k=(g(B-m|0,9)+g(h-s|0,-3)|0)+8>>4,l=k>>31,(S0|0)<=((k^l)-l|0))break A;l=(k|0)<(C0|0)?C0:(k|0)<(_|0)?k:_;k:{n:{if(!e){if(E&&(k=l+m|0,X[w+(f-R<<1)>>1]=(k|0)>=0?(k|0)<(O|0)?k:O:0),!j)break k;k=B-l|0,V=(k|0)>=0?(k|0)<(O|0)?k:O:0,k=f;break n}if(E&&(k=l+m|0,X[A0+(g(f,R)<<1)>>1]=(k|0)>=0?(k|0)<(O|0)?k:O:0),!j)break k;k=B-l|0,V=(k|0)>=0?(k|0)<(O|0)?k:O:0,k=g(f,R)}X[(k<<1)+w>>1]=V}k:{if(!c)break k;if(k=l+(((m+N|0)+1>>>1|0)-s|0)>>1,k=((k|0)<(G|0)?G:(k|0)<(q|0)?k:q)+s|0,k=(k|0)>=0?(k|0)<(O|0)?k:O:0,!e){X[w+(f-X2<<1)>>1]=k;break k}X[q0+(g(f,R)<<1)>>1]=k}if(!t0)break A;if(k=((B+U|0)+1>>>1)-(l+h)>>1,k=h+((k|0)<(G|0)?G:(k|0)<(q|0)?k:q)|0,k=(k|0)>=0?(k|0)<(O|0)?k:O:0,!e){X[_0+(f<<1)>>1]=k;break A}X[s2+(g(f,R)<<1)>>1]=k;break A}if(Q=h-o|0,I=B+m|0,Y=I+h|0,V=(Y+U|0)+2>>>2|0,x=o+h|0,V=(V|0)<(Q|0)?Q:(V|0)<(x|0)?V:x,x=s-o|0,I=s+I|0,Q=(I+N|0)+2>>>2|0,d=o+s|0,Q=(Q|0)<(x|0)?x:(Q|0)<(d|0)?Q:d,x=U-o|0,l=((Y+g(U,3)|0)+(p[l+6>>1]<<1)|0)+4>>>3|0,Y=o+U|0,l=(l|0)<(x|0)?x:(l|0)<(Y|0)?l:Y,Y=N-o|0,k=((I+g(N,3)|0)+(p[k+6>>1]<<1)|0)+4>>>3|0,I=o+N|0,I=(k|0)<(Y|0)?Y:(k|0)<(I|0)?k:I,Y=B-o|0,d=B<<1,x=(m<<1)+4|0,k=U+((d+(x+s|0)|0)+(h<<1)|0)>>>3|0,B=o+B|0,B=(k|0)<(Y|0)?Y:(k|0)<(B|0)?k:B,U=m-o|0,k=h+(d+((N+x|0)+(s<<1)|0)|0)>>>3|0,s=o+m|0,s=(k|0)<(U|0)?U:(k|0)<(s|0)?k:s,!e){if(k=w+(f<<1)|0,!E){if(!j)break A;X[k>>1]=B,X[k+S>>1]=V,X[k+r0>>1]=l;break A}if(!j){X[k+V0>>1]=s,X[k+f2>>1]=Q,X[k+g0>>1]=I;break A}X[k+V0>>1]=s,X[k>>1]=B,X[k+f2>>1]=Q,X[k+S>>1]=V,X[k+g0>>1]=I,X[k+r0>>1]=l;break A}if(k=w+(g(f,R)<<1)|0,E&&(X[k-2>>1]=s),j&&(X[k>>1]=B),E&&(X[k-4>>1]=Q),j&&(X[k+2>>1]=V),E&&(X[k-6>>1]=I),!j)break A;X[k+4>>1]=l}if(f=f+1|0,(f|0)==4)break}}if(A2=A2+1|0,j0=j0+u1|0,!((Z2|0)>(j0|0)))break}if(f1=f1+1|0,r=r+o1|0,!((v2|0)>(r|0)))break}}v=n- -64|0;return}U0(5030,11952,119,4625),M()}U0(5068,11952,118,4625),M()}function uA(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;s=v-144|0,v=s,HA(s+132|0,e,r),e=i[s+132>>2],w=K6(s+96|0,e,i[s+136>>2]-e|0),m2(w,8),t[f|0]=1,Y=f,E=O2(w,8),t[Y+1|0]=E,Y=f,E=O2(w,8),t[Y+2|0]=E,e=O2(w,8),t[f+4|0]=4,t[f+3|0]=e,e=C(48),i[s+24>>2]=e,i[s+28>>2]=46,i[s+32>>2]=-2147483600,r=u[8068]|u[8069]<<8|(u[8070]<<16|u[8071]<<24),h=u[8064]|u[8065]<<8|(u[8066]<<16|u[8067]<<24),t[e+38|0]=h,t[e+39|0]=h>>>8,t[e+40|0]=h>>>16,t[e+41|0]=h>>>24,t[e+42|0]=r,t[e+43|0]=r>>>8,t[e+44|0]=r>>>16,t[e+45|0]=r>>>24,r=u[8062]|u[8063]<<8|(u[8064]<<16|u[8065]<<24),h=u[8058]|u[8059]<<8|(u[8060]<<16|u[8061]<<24),t[e+32|0]=h,t[e+33|0]=h>>>8,t[e+34|0]=h>>>16,t[e+35|0]=h>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[8054]|u[8055]<<8|(u[8056]<<16|u[8057]<<24),h=u[8050]|u[8051]<<8|(u[8052]<<16|u[8053]<<24),t[e+24|0]=h,t[e+25|0]=h>>>8,t[e+26|0]=h>>>16,t[e+27|0]=h>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[8046]|u[8047]<<8|(u[8048]<<16|u[8049]<<24),h=u[8042]|u[8043]<<8|(u[8044]<<16|u[8045]<<24),t[e+16|0]=h,t[e+17|0]=h>>>8,t[e+18|0]=h>>>16,t[e+19|0]=h>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[8038]|u[8039]<<8|(u[8040]<<16|u[8041]<<24),h=u[8034]|u[8035]<<8|(u[8036]<<16|u[8037]<<24),t[e+8|0]=h,t[e+9|0]=h>>>8,t[e+10|0]=h>>>16,t[e+11|0]=h>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[8030]|u[8031]<<8|(u[8032]<<16|u[8033]<<24),h=u[8026]|u[8027]<<8|(u[8028]<<16|u[8029]<<24),t[e|0]=h,t[e+1|0]=h>>>8,t[e+2|0]=h>>>16,t[e+3|0]=h>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+46|0]=0,l=a(s+72|0,2,0,s+24|0),t[s+35|0]<0&&Z(i[s+24>>2]);i:{e:{if(!A1(w,s+68|0))break e;if(i[s+48>>2]=i[14877],e=i[14876],i[s+40>>2]=i[14875],i[s+44>>2]=e,e=i[14874],i[s+32>>2]=i[14873],i[s+36>>2]=e,i[s+60>>2]=0,i[s+64>>2]=0,m=s+60|0,I=m,i[s+56>>2]=m,e=i[14872],i[s+24>>2]=i[14871],i[s+28>>2]=e,B=s+24|0,Q=s+52|0,(B|0)!=(Q|0))for(;;){_=i[s+60>>2];r:{f:{A:{if(e=m,V=i[s+56>>2],(e|0)==(V|0))break A;r=e;k:{if(h=_,h){for(;e=h,h=i[e+4>>2],!!h;);if(G=i[B>>2],(G|0)<=i[e+16>>2])break k;break A}for(;e=i[r+8>>2],h=i[e>>2]==(r|0),r=e,!!h;);if(r=m,h=r,i[e+16>>2]<i[B>>2])break A;break f}for(;;){if(h=_,e=i[h+16>>2],(e|0)>(G|0)){if(r=h,_=i[r>>2],_)continue;break f}if((e|0)>=(G|0))break r;if(_=i[h+4>>2],!_)break}r=h+4|0;break f}if(r=_?e+4|0:m,i[r>>2])break r;h=_?e:m}e=C(20),_=i[B>>2],i[e+8>>2]=h,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=_,i[r>>2]=e,r=i[V>>2],r&&(i[s+56>>2]=r),G1(i[s+60>>2],e),i[s+64>>2]=i[s+64>>2]+1}if(B=B+4|0,(Q|0)==(B|0))break}r:{f:{r=i[s+60>>2];A:{if(!r)break A;for(B=u[f+1|0],e=I,h=r;_=e,m=h,G=(B|0)>i[h+16>>2],e=G?e:h,h=i[(G?4:0)+h>>2],!!h;);if((e|0)==(I|0))break A;if((B|0)>=i[(G?_:m)+16>>2])break f}_f(s+56|0,r),X[f+12>>1]=2056,i[f+8>>2]=1;break r}if(_f(s+56|0,r),!A1(w,s+68|0)||(e=i[s+68>>2],i[f+8>>2]=e,(e|0)==3&&m2(w,1),e=s+68|0,!A1(w,e))||(t[f+12|0]=u[s+68|0]+8,!A1(w,e)))break e;if(t[f+13|0]=u[s+68|0]+8,m2(w,1),!T0(w,1))break r;for(h=0;;){f:{if(!T0(w,1))break f;if(r=8,e=0,h>>>0<=5)for(;;){if(d3(w,s+24|0),r=((i[s+24>>2]+r|0)+256|0)%256|0,!r)break f;if(e=e+1|0,(e|0)==16)break f}for(;;){if(d3(w,s+24|0),r=((i[s+24>>2]+r|0)+256|0)%256|0,!r)break f;if(e=e+1|0,(e|0)==64)break}}if(h=h+1|0,!(h>>>0<(i[f+8>>2]==3?12:8)>>>0))break}}if(!A1(w,s+68|0))break e;if(!A1(w,s+56|0)){e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break i}r:{f:switch(i[s+56>>2]){case 0:if(A1(w,s+68|0))break r;e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break i;case 1:break f;default:break r}T0(w,1);f:{if(e=s+24|0,d3(w,e)&&d3(w,e))break f;e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break i}f:{if(A1(w,s+20|0)){if(!i[s+20>>2])break r;r=0;break f}e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break i}for(;;){if(A1(w,s+68|0)){if(r=r+1|0,r>>>0<o0[s+20>>2])continue;break r}break}e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break i}if(!A1(w,s+68|0)){e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break i}m2(w,1);r:{f:{if(A1(w,s+20|0)&&A1(w,s+16|0))break f;e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break r}f:{if(e=i[s+20>>2],e>>>0<=268435454&&(r=i[s+16>>2],r>>>0<268435455))break f;if(e=A,A=V2(s+24|0,15119),a(e,2,129,A),t[A+11|0]>=0)break r;Z(i[A>>2]);break r}if(i[k>>2]=(e<<4)+16,i[n>>2]=(r<<4)+16,o&&(i[o>>2]=i[k>>2],i[o+4>>2]=i[n>>2]),T0(w,1)||m2(w,1),m2(w,1),T0(w,1)){f:{A:{if(!A1(w,s+12|0)||!A1(w,s+8|0)||!A1(w,s+4|0))break A;if(A1(w,s))break f}e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0;break r}f=i[s+12>>2],e=f+i[s+8>>2]|0,r=0,r=e>>>0<f>>>0?1:r,f=e;f:{if(o=i[k>>2],!r&e>>>0<=o>>>0&&(h=i[s+4>>2],e=h+i[s>>2]|0,r=0,!(e>>>0<h>>>0||r)&o0[n>>2]>=e>>>0))break f;if(e=A,A=V2(s+24|0,12700),a(e,2,129,A),t[A+11|0]>=0)break r;Z(i[A>>2]);break r}i[k>>2]=o-f,i[n>>2]=i[n>>2]-e}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}if(t[l+19|0]>=0)break i;Z(i[l+8>>2]);break i}e=i[l+4>>2],i[A>>2]=i[l>>2],i[A+4>>2]=e,i[A+16>>2]=i[l+16>>2],e=i[l+12>>2],i[A+8>>2]=i[l+8>>2],i[A+12>>2]=e,i[l+16>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0}A=i[s+132>>2],A&&(i[s+136>>2]=A,Z(A)),v=s+144|0}function Tv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=D(0),E=0,R=0,N=D(0),U=D(0),x=0,j=0,O=D(0),S=0,q=0,d=0,c=0,A0=D(0),t0=D(0),_0=D(0),g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=D(0),j0=D(0),S0=0,q0=0,r2=0,f2=D(0),A2=D(0);e=v-144|0,v=e,f=i[r>>2],o=i[f+192>>2],n=i[f+188>>2],w=K0(f,10),s=i[i[r>>2]+200>>2],R=C(248),i[R>>2]=101168,f=R,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,I=f+12|0,i[f+176>>2]=I,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(I,n,o,0,1),a0(e+96|0,I,0,n,o,w,l,0),h=n+1>>>1|0,_=o+1>>>1|0,a0(e+72|0,I,1,h,_,w,l,0),f=e+128|0;i:{if(i[e+96>>2]){if(V=i[e+100>>2],i[e+120>>2]=i[e+96>>2],i[e+124>>2]=V,t[e+115|0]>=0){V=i[e+108>>2],i[f>>2]=i[e+104>>2],i[f+4>>2]=V,i[f+8>>2]=i[e+112>>2];break i}T(f,i[e+104>>2],i[e+108>>2]);break i}if(V=i[e+76>>2],i[e+120>>2]=i[e+72>>2],i[e+124>>2]=V,t[e+91|0]>=0){V=i[e+84>>2],i[f>>2]=i[e+80>>2],i[f+4>>2]=V,i[f+8>>2]=i[e+88>>2];break i}T(f,i[e+80>>2],i[e+84>>2])}a0(e+48|0,I,2,h,_,w,l,0),h=e+16|0;i:{if(i[e+120>>2]){if(_=i[e+124>>2],i[e+8>>2]=i[e+120>>2],i[e+12>>2]=_,t[e+139|0]>=0){_=i[f+4>>2],i[h>>2]=i[f>>2],i[h+4>>2]=_,i[h+8>>2]=i[f+8>>2];break i}T(h,i[e+128>>2],i[e+132>>2]);break i}if(f=i[e+52>>2],i[e+8>>2]=i[e+48>>2],i[e+12>>2]=f,t[e+67|0]>=0){f=i[e+60>>2],i[h>>2]=i[e+56>>2],i[h+4>>2]=f,i[h+8>>2]=i[e+64>>2];break i}T(h,i[e+56>>2],i[e+60>>2])}t[e+67|0]<0&&Z(i[e+56>>2]),t[e+139|0]<0&&Z(i[e+128>>2]),t[e+91|0]<0&&Z(i[e+80>>2]),t[e+115|0]<0&&Z(i[e+104>>2]);i:{e:{if(i[e+8>>2]){if(r=i[e+12>>2],i[A>>2]=i[e+8>>2],i[A+4>>2]=r,r=A+8|0,t[e+27|0]>=0){f=i[h+4>>2],i[r>>2]=i[h>>2],i[r+4>>2]=f,i[r+8>>2]=i[h+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+16>>2],i[e+20>>2]),r=t[e+27|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+16>>2]);break e}t[e+27|0]<0&&Z(i[e+16>>2]);r:{f:switch(s-13|0){case 0:case 2:break f;default:break r}if(a0(e+8|0,I,6,n,o,w,l,0),i[e+8>>2]){if(r=i[e+12>>2],i[A>>2]=i[e+8>>2],i[A+4>>2]=r,r=A+8|0,t[e+27|0]>=0){f=i[e+20>>2],i[r>>2]=i[e+16>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+24>>2],t[A+20|0]=1;break e}if(T(r,i[e+16>>2],i[e+20>>2]),r=t[e+27|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+16>>2]);break e}if(t[e+27|0]>=0)break r;Z(i[e+16>>2])}f=Q0(i[r>>2],10);r:{if(!f){h=0;break r}g0=i[f+40>>2],h=i[f+52>>2]}f=Q0(I,0),f?(m=i[f+52>>2]>>>1|0,_=i[f+40>>2]):_=0,f=Q0(I,1),f?(S0=i[f+40>>2],V=i[f+52>>2]>>>1|0):V=0,f=Q0(I,2),f?(q0=i[f+52>>2]>>>1|0,f=i[f+40>>2]):f=0,r2=f;r:{f:switch(s-13|0){case 0:case 2:break f;default:break r}if(f=Q0(I,6),!f)break r;j=i[f+52>>2]>>>1|0,X0=i[f+40>>2]}C0=u[k+26|0],r=i[i[r>>2]+200>>2],g3(e+8|0,p[k+24>>1],p[k+20>>1]);r:{if(!o)break r;q=(s&-3)==13?8:6,f=-1<<w^-1,B=r&-2,E=(B|0)==14,V0=E^3;f:{if(!n)break f;U=D(16<<w-8),d=E?4:5,c=!E,O=E0[e+20>>2],A0=E0[e+16>>2],t0=E0[e+12>>2],r=0;A:switch(s-13|0){case 0:case 2:if(M0=E^7,C0&1)for(;;){for(Q=g(r,h)+g0|0,S=(g(r,j)<<1)+X0|0,r0=_+(g(r,m)<<1)|0,l=0;x=l<<1,f0=x+r0|0,s=Q+g(l,q)|0,G=s+E|0,U=D(D(D(D((u[G+4|0]<<8|u[s+d|0])>>>0)*O)+D(D(D((u[s+c|0]|u[G|0]<<8)>>>0)*t0)+D(A0*D((u[s+V0|0]|u[G+2|0]<<8)>>>0))))+D(.5)),D(B2(U))<D(2147483648)?k=~~U:k=-2147483648,X[f0>>1]=(k|0)>=0?(f|0)<(k|0)?f:k:0,X[S+x>>1]=u[s+M0|0]|u[G+6|0]<<8,l=l+1|0,(l|0)!=(n|0););if(r=r+1|0,(o|0)==(r|0))break f}for(;;){for(Q=g(r,h)+g0|0,S=(g(r,j)<<1)+X0|0,r0=_+(g(r,m)<<1)|0,l=0;x=l<<1,f0=x+r0|0,s=Q+g(l,q)|0,G=s+E|0,Y=D(D(D(D(D(D((u[G+4|0]<<8|u[s+d|0])>>>0)*O)+D(D(D((u[s+c|0]|u[G|0]<<8)>>>0)*t0)+D(A0*D((u[s+V0|0]|u[G+2|0]<<8)>>>0))))*D(.8554700016975403))+U)+D(.5)),D(B2(Y))<D(2147483648)?k=~~Y:k=-2147483648,X[f0>>1]=(k|0)>=0?(f|0)<(k|0)?f:k:0,X[S+x>>1]=u[s+M0|0]|u[G+6|0]<<8,l=l+1|0,(l|0)!=(n|0););if(r=r+1|0,(o|0)==(r|0))break}break f;default:break A}for(;;){for(G=g(r,h)+g0|0,j=_+(g(r,m)<<1)|0,l=0;Q=j+(l<<1)|0,k=G+g(l,q)|0,s=k+E|0,Y=D(D(D((u[s+4|0]<<8|u[k+d|0])>>>0)*O)+D(D(D((u[k+c|0]|u[s|0]<<8)>>>0)*t0)+D(A0*D((u[k+V0|0]|u[s+2|0]<<8)>>>0)))),Y=D((C0&1?Y:D(D(Y*D(.8554700016975403))+U))+D(.5)),D(B2(Y))<D(2147483648)?k=~~Y:k=-2147483648,X[Q>>1]=(k|0)>=0?(f|0)<(k|0)?f:k:0,l=l+1|0,(l|0)!=(n|0););if(r=r+1|0,(o|0)==(r|0))break}}if(!n)break r;for(d=(B|0)==14?4:5,c=!E,O=D((1<<w-1&65535)>>>0),_=0,A0=E0[e+44>>2],t0=E0[e+40>>2],U=E0[e+36>>2],Y=E0[e+32>>2],f2=E0[e+28>>2],A2=E0[e+24>>2];;){for(k=(_|1)>>>0<o>>>0?h:0,G=g(h,_)+g0|0,r=_>>>1|0,j=(g(r,q0)<<1)+r2|0,X0=(g(r,V)<<1)+S0|0,l=0;x=l+X0|0,s=G+g(l,q)|0,r=s+E|0,B=r+4|0,w=(l|1)>>>0<n>>>0?q:0,Q=B+w|0,m=s+d|0,S=m+w|0,N=D(D((((u[Q|0]<<8|u[S|0])+(u[m|0]|u[r+4|0]<<8)|0)+(u[k+m|0]|u[k+B|0]<<8)|0)+(u[k+S|0]|u[k+Q|0]<<8)>>>0)*D(.25)),m=s+c|0,B=m+w|0,Q=r+w|0,z0=D(D((((u[B|0]|u[Q|0]<<8)+(u[m|0]|u[r|0]<<8)|0)+(u[k+m|0]|u[r+k|0]<<8)|0)+(u[k+B|0]|u[k+Q|0]<<8)>>>0)*D(.25)),s=s+V0|0,m=s+w|0,B=w,w=r+2|0,B=B+w|0,j0=D(D((((u[m|0]|u[B|0]<<8)+(u[s|0]|u[r+2|0]<<8)|0)+(u[k+s|0]|u[k+w|0]<<8)|0)+(u[k+m|0]|u[k+B|0]<<8)>>>0)*D(.25)),_0=D(D(N*Y)+D(D(z0*A2)+D(f2*j0))),w=C0&1,_0=D(D((w?_0:D(_0*D(.875)))+O)+D(.5)),D(B2(_0))<D(2147483648)?r=~~_0:r=-2147483648,X[x>>1]=(r|0)>=0?(r|0)>(f|0)?f:r:0,B=l+j|0,N=D(D(N*A0)+D(D(z0*U)+D(j0*t0))),N=D(D((w?N:D(N*D(.875)))+O)+D(.5)),D(B2(N))<D(2147483648)?r=~~N:r=-2147483648,X[B>>1]=(r|0)>=0?(r|0)>(f|0)?f:r:0,l=l+2|0,l>>>0<n>>>0;);if(_=_+2|0,!(_>>>0<o>>>0))break}}t[A+20|0]=0,i[A+4>>2]=R,i[A>>2]=I;break i}if(A=i[R+4>>2],i[R+4>>2]=A-1,A)break i;W[i[i[R>>2]+8>>2]](R),y(R)}v=e+144|0}function jv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0;k=v-32|0,v=k;i:{if(f){W[i[i[e>>2]+112>>2]](e,k+28|0,k+24|0),n=i[k+24>>2];break i}n=0,f=i[e+184>>2],l=i[e+188>>2];e:{if((f|0)==(l|0))break e;r:{for(;;){f:{if(o=i[f>>2],!o||(o=Z0(o,92792,92812),!o))break f;if(f=i[f+4>>2],f)break r;o=i[o+104>>2];break e}if(f=f+8|0,(l|0)==(f|0))break}o=0;break e}if(l=i[f+4>>2],s=l+1|0,i[f+4>>2]=s,o=i[o+104>>2],i[f+4>>2]=l,s)break e;W[i[i[f>>2]+8>>2]](f),y(f)}i[k+28>>2]=o,f=i[e+184>>2],e=i[e+188>>2];e:{if((f|0)==(e|0))break e;r:{for(;;){f:{if(n=i[f>>2],!n||(n=Z0(n,92792,92812),!n))break f;if(e=i[f+4>>2],e)break r;n=i[n+108>>2];break e}if(f=f+8|0,(e|0)==(f|0))break}n=0;break e}if(f=i[e+4>>2],o=f+1|0,i[e+4>>2]=o,n=i[n+108>>2],i[e+4>>2]=f,o)break e;W[i[i[e>>2]+8>>2]](e),y(e)}i[k+24>>2]=n}l=i[k+28>>2];i:{if(!(n&&l)){if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}h=v-16|0,v=h,o=1,f=r;e:{r:{f:{A:{k:{n:{t:{o:switch(i[r+196>>2]){case 2:if(e=i[f+204>>2],f=i[f+208>>2],(e|0)==(f|0))break t;r=e;l:{u:{for(;;){if(!i[r>>2])break u;if(r=r+56|0,(f|0)==(r|0))break}r=0;break l}r=i[r+24>>2]}if((r|0)!=(l|0)){o=0;break e}l:{for(;;){if(!i[e>>2])break l;if(e=e+56|0,(f|0)==(e|0))break}o=0;break f}o=i[e+28>>2];break f;case 0:l:{u:{if(e=i[f+204>>2],s=i[f+208>>2],(e|0)!=(s|0)){r=e;s:{h:{for(;;){if(!i[r>>2])break h;if(r=r+56|0,(s|0)==(r|0))break}r=0;break s}r=i[r+24>>2]}if((r|0)==(l|0))break u;o=0;break e}if(e=0,!l)break l;o=0;break e}u:{for(;;){if(!i[e>>2])break u;if(e=e+56|0,(s|0)==(e|0))break}e=0;break l}e=i[e+28>>2]}if((e|0)!=(n|0)){o=0;break e}if(e=i[f+200>>2],!e)break e;if(L3(l,n,1,e,h+12|0,h+8|0),n=i[h+8>>2],l=i[h+12>>2],e=i[f+204>>2],f=i[f+208>>2],(e|0)==(f|0))break k;r=e,o=0;l:{u:{for(;;){if(i[r>>2]==1)break u;if(r=r+56|0,(f|0)==(r|0))break}r=0;break l}r=i[r+24>>2]}if((r|0)!=(l|0))break e;r=e;l:{u:{for(;;){if(i[r>>2]==1)break u;if(r=r+56|0,(f|0)==(r|0))break}r=0;break l}r=i[r+28>>2]}if((r|0)!=(n|0))break e;r=e;l:{u:{for(;;){if(i[r>>2]==2)break u;if(r=r+56|0,(f|0)==(r|0))break}r=0;break l}r=i[r+24>>2]}if((r|0)!=(l|0))break e;l:{for(;;){if(i[e>>2]==2)break l;if(e=e+56|0,(f|0)==(e|0))break}o=!n;break e}o=i[e+28>>2];break r;case 1:if(s=i[f+208>>2],e=i[f+204>>2],i[f+200>>2]==3){if((e|0)==(s|0))break A;r=e,o=0;l:{u:{for(;;){if(i[r>>2]==3)break u;if(r=r+56|0,(s|0)==(r|0))break}r=0;break l}r=i[r+24>>2]}if((r|0)!=(l|0))break e;r=e;l:{u:{for(;;){if(i[r>>2]==3)break u;if(r=r+56|0,(s|0)==(r|0))break}r=0;break l}r=i[r+28>>2]}if((r|0)!=(n|0))break e;r=e;l:{u:{for(;;){if(i[r>>2]==4)break u;if(r=r+56|0,(s|0)==(r|0))break}r=0;break l}r=i[r+24>>2]}if((r|0)!=(l|0))break e;r=e;l:{u:{for(;;){if(i[r>>2]==4)break u;if(r=r+56|0,(s|0)==(r|0))break}r=0;break l}r=i[r+28>>2]}if((r|0)!=(n|0))break e;r=e;l:{u:{for(;;){if(i[r>>2]==5)break u;if(r=r+56|0,(s|0)==(r|0))break}r=0;break l}r=i[r+24>>2]}if((r|0)!=(l|0))break e;l:{for(;;){if(i[e>>2]==5)break l;if(e=e+56|0,(s|0)==(e|0))break}break f}o=i[e+28>>2];break f}if((e|0)==(s|0))break t;r=e;l:{u:{for(;;){if(i[r>>2]==10)break u;if(r=r+56|0,(s|0)==(r|0))break}r=0;break l}r=i[r+24>>2]}if((r|0)!=(l|0)){o=0;break e}l:{for(;;){if(i[e>>2]==10)break l;if(e=e+56|0,(s|0)==(e|0))break}o=0;break f}o=i[e+28>>2];break f;case 4:break o;default:break e}if(e=i[f+204>>2],f=i[f+208>>2],(e|0)==(f|0))break t;r=e;o:{l:{for(;;){if(i[r>>2]==11)break l;if(r=r+56|0,(f|0)==(r|0))break}r=0;break o}r=i[r+24>>2]}if((r|0)==(l|0))break n;o=0;break e}if(o=0,!l)break f;break e}n:{for(;;){if(i[e>>2]==11)break n;if(e=e+56|0,(f|0)==(e|0))break}o=0;break f}o=i[e+28>>2];break f}if(o=0,!(n|l))break r;break e}if(o=0,n|l)break e}o=(n|0)==(o|0);break e}o=(n|0)==(o|0)}if(v=h+16|0,!o){if(e=C(64),i[k+12>>2]=e,i[k+16>>2]=58,i[k+20>>2]=-2147483584,r=u[27661]|u[27662]<<8|(u[27663]<<16|u[27664]<<24),f=u[27657]|u[27658]<<8|(u[27659]<<16|u[27660]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+58|0]=0,r=u[27713]|u[27714]<<8,t[e+56|0]=r,t[e+57|0]=r>>>8,r=u[27709]|u[27710]<<8|(u[27711]<<16|u[27712]<<24),f=u[27705]|u[27706]<<8|(u[27707]<<16|u[27708]<<24),t[e+48|0]=f,t[e+49|0]=f>>>8,t[e+50|0]=f>>>16,t[e+51|0]=f>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[27701]|u[27702]<<8|(u[27703]<<16|u[27704]<<24),f=u[27697]|u[27698]<<8|(u[27699]<<16|u[27700]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[27693]|u[27694]<<8|(u[27695]<<16|u[27696]<<24),f=u[27689]|u[27690]<<8|(u[27691]<<16|u[27692]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[27685]|u[27686]<<8|(u[27687]<<16|u[27688]<<24),f=u[27681]|u[27682]<<8|(u[27683]<<16|u[27684]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[27677]|u[27678]<<8|(u[27679]<<16|u[27680]<<24),f=u[27673]|u[27674]<<8|(u[27675]<<16|u[27676]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[27669]|u[27670]<<8|(u[27671]<<16|u[27672]<<24),f=u[27665]|u[27666]<<8|(u[27667]<<16|u[27668]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,129,k+12|0),t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function j9(A,e,r,f,k,n,o,l,s,h,w){var _=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0;_=v-528|0,v=_,i[_+520>>2]=w,i[_+524>>2]=e;i:{if(d2(A,_+524|0)){i[n>>2]=i[n>>2]|4,A=0;break i}i[_+76>>2]=2127,Q=_+76|0,V=J1(_+104|0,_+112|0,Q),e=i[V>>2],i[_+100>>2]=e,i[_+96>>2]=e+400,e=v-16|0,v=e,i[Q>>2]=0,i[Q+4>>2]=0,i[Q+8>>2]=0,v=e+16|0,e=v-16|0,v=e,G=_- -64|0,i[G>>2]=0,i[G+4>>2]=0,i[G+8>>2]=0,v=e+16|0,e=v-16|0,v=e,m=_+52|0,i[m>>2]=0,i[m+4>>2]=0,i[m+8>>2]=0,v=e+16|0,e=v-16|0,v=e,B=_+40|0,i[B>>2]=0,i[B+4>>2]=0,i[B+8>>2]=0,v=e+16|0,e=v-16|0,v=e,I=_+28|0,i[I>>2]=0,i[I+4>>2]=0,i[I+8>>2]=0,v=e+16|0,e=v-16|0,v=e;e:{if(r){w=e+4|0,r=$0(f,136744),W[i[i[r>>2]+44>>2]](w,r);break e}w=e+4|0,r=$0(f,136736),W[i[i[r>>2]+44>>2]](w,r)}for(f=i[e+4>>2],t[_+92|0]=f,t[_+93|0]=f>>>8,t[_+94|0]=f>>>16,t[_+95|0]=f>>>24,W[i[i[r>>2]+32>>2]](w,r),u6(B,w),_2(w),W[i[i[r>>2]+28>>2]](w,r),u6(m,w),_2(w),R=_,N=W[i[i[r>>2]+12>>2]](r)|0,t[R+91|0]=N,R=_,N=W[i[i[r>>2]+16>>2]](r)|0,t[R+90|0]=N,W[i[i[r>>2]+20>>2]](w,r),u6(Q,w),_2(w),W[i[i[r>>2]+24>>2]](w,r),u6(G,w),_2(w),R=_,N=W[i[i[r>>2]+36>>2]](r)|0,i[R+24>>2]=N,v=e+16|0,i[h>>2]=i[s>>2],Y=k&512,f=0,e=0;;){r=e;e:{r:{f:{A:{if((f|0)==4||d2(A,_+524|0))break A;w=0;k:{n:{t:{o:{l:switch(u[(_+92|0)+f|0]){case 1:if((f|0)==3)break r;e=i[A>>2],k=i[e+12>>2];u:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break u}e=t[k|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[l+8>>2]+(e<<2)>>2]&1:e=0,e){gh(_+16|0,A),Ai(I,t[_+16|0]);break o}i[n>>2]=i[n>>2]|4,A=0;break f;case 0:break l;case 2:break n;case 3:break t;case 4:break k;default:break e}if((f|0)==3)break r}for(;;){if(d2(A,_+524|0))break r;e=i[A>>2],k=i[e+12>>2];o:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break o}e=t[k|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[l+8>>2]+(e<<2)>>2]&1:e=0,!e)break r;gh(_+16|0,A),Ai(I,t[_+16|0])}}t:{if(u[m+11|0]>>>7|0?e=i[m+4>>2]:e=u[m+11|0]&127,!e)break t;e=i[A>>2],k=i[e+12>>2];o:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break o}e=t[k|0]}if(k=e<<24>>24&255,u[m+11|0]>>>7|0?e=i[m>>2]:e=m,(k|0)!=u[e|0])break t;A4(A),t[o|0]=0,u[m+11|0]>>>7|0?e=i[m+4>>2]:e=u[m+11|0]&127,e=e>>>0>1?m:r;break e}t:{if(u[B+11|0]>>>7|0?e=i[B+4>>2]:e=u[B+11|0]&127,!e)break t;e=i[A>>2],k=i[e+12>>2];o:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break o}e=t[k|0]}if(k=e<<24>>24&255,u[B+11|0]>>>7|0?e=i[B>>2]:e=B,(k|0)!=u[e|0])break t;A4(A),t[o|0]=1,u[B+11|0]>>>7|0?e=i[B+4>>2]:e=u[B+11|0]&127,e=e>>>0>1?B:r;break e}if(u[m+11|0]>>>7|0?e=i[m+4>>2]:e=u[m+11|0]&127,k=!e,u[B+11|0]>>>7|0?e=i[B+4>>2]:e=u[B+11|0]&127,!(k|!e)){i[n>>2]=i[n>>2]|4,A=0;break f}if(u[m+11|0]>>>7|0?e=i[m+4>>2]:e=u[m+11|0]&127,!e&&(u[B+11|0]>>>7|0?e=i[B+4>>2]:e=u[B+11|0]&127,!e))break r;u[B+11|0]>>>7|0?e=i[B+4>>2]:e=u[B+11|0]&127,t[o|0]=!e;break r}if(!(Y|(f>>>0<2|r))&&(e=0,!((f|0)==2&u[_+95|0]!=0)))break e;R=_,N=e8(G),i[R+12>>2]=N,i[_+16>>2]=i[_+12>>2];n:{if(!f|u[(f+_|0)+91|0]>1)break n;for(;;){t:{if(R=_,N=E6(G),i[R+12>>2]=N,e=i[_+16>>2],(e|0)==i[_+12>>2]||(e=t[e|0],(e|0)>=0?e=i[i[l+8>>2]+(e<<2)>>2]&1:e=0,!e))break t;i[_+16>>2]=i[_+16>>2]+1;continue}break}if(R=_,N=e8(G),i[R+12>>2]=N,u[I+11|0]>>>7|0?w=i[I+4>>2]:w=u[I+11|0]&127,e=_+12|0,k=i[_+16>>2]-i[e>>2]|0,w>>>0>=k>>>0&&(R=_,N=E6(I),i[R+12>>2]=N,e=A7(e,0-k|0),k=E6(I),w=e8(G),E=v-16|0,v=E,e=R6(e),k=R6(k),e=N2(e,R6(w),k-e|0),v=E+16|0,!e))break n;R=_,N=e8(G),i[R+8>>2]=N,i[_+12>>2]=i[_+8>>2],i[_+16>>2]=i[_+12>>2]}for(i[_+12>>2]=i[_+16>>2];;){n:{if(R=_,N=E6(G),i[R+8>>2]=N,i[_+12>>2]==i[_+8>>2]||d2(A,_+524|0))break n;e=i[A>>2],k=i[e+12>>2];t:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break t}e=t[k|0]}if((e<<24>>24&255)!=u[i[_+12>>2]])break n;A4(A),i[_+12>>2]=i[_+12>>2]+1;continue}break}if(!Y||(R=_,N=E6(G),i[R+8>>2]=N,i[_+12>>2]==i[_+8>>2]))break r;i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){k:{if(d2(A,_+524|0))break k;e=i[A>>2],k=i[e+12>>2];n:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break n}e=t[k|0]}e=e<<24>>24,(e|0)>=0?k=i[i[l+8>>2]+(e<<2)>>2]&64:k=0;n:{if(k){k=i[h>>2],(k|0)==i[_+520>>2]&&(zl(s,h,_+520|0),k=i[h>>2]),i[h>>2]=k+1,t[k|0]=e,w=w+1|0;break n}if(u[Q+11|0]>>>7|0?k=i[Q+4>>2]:k=u[Q+11|0]&127,!k|!w|u[_+90|0]!=(e&255))break k;e=i[_+100>>2],(e|0)==i[_+96>>2]&&(Mi(V,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=w,w=0}A4(A);continue}break}e=i[_+100>>2],!w|(e|0)==i[V>>2]||(i[_+96>>2]==(e|0)&&(Mi(V,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=w);k:{if(i[_+24>>2]<=0)break k;n:{if(!d2(A,_+524|0)){e=i[A>>2],k=i[e+12>>2];t:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break t}e=t[k|0]}if((e<<24>>24&255)==u[_+91|0])break n}i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){if(A4(A),i[_+24>>2]<=0)break k;n:{if(!d2(A,_+524|0)){e=i[A>>2],k=i[e+12>>2];t:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break t}e=t[k|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[l+8>>2]+(e<<2)>>2]&64:e=0,e)break n}i[n>>2]=i[n>>2]|4,A=0;break f}i[h>>2]==i[_+520>>2]&&zl(s,h,_+520|0),e=i[A>>2],k=i[e+12>>2];n:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break n}e=t[k|0]}k=i[h>>2],i[h>>2]=k+1,t[k|0]=e<<24>>24,i[_+24>>2]=i[_+24>>2]-1}}if(e=r,i[s>>2]!=i[h>>2])break e;i[n>>2]=i[n>>2]|4,A=0;break f}A:{if(!r)break A;for(w=1;;){if(u[r+11|0]>>>7|0?e=i[r+4>>2]:e=u[r+11|0]&127,e>>>0<=w>>>0)break A;k:{if(!d2(A,_+524|0)){e=i[A>>2],f=i[e+12>>2];n:{if((f|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break n}e=t[f|0]}if(f=e<<24>>24&255,u[r+11|0]>>>7|0?e=i[r>>2]:e=r,(f|0)==u[e+w|0])break k}i[n>>2]=i[n>>2]|4,A=0;break f}A4(A),w=w+1|0}}if(A=1,i[V>>2]==i[_+100>>2])break f;if(A=0,i[_+16>>2]=0,G4(Q,i[V>>2],i[_+100>>2],_+16|0),i[_+16>>2]){i[n>>2]=i[n>>2]|4;break f}A=1}_2(I),_2(B),_2(m),_2(G),_2(Q),e=i[V>>2],i[V>>2]=0,e&&W[i[V+4>>2]](e);break i}e=r}f=f+1|0}}return v=_+528|0,A}function Sv(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;m=v-48|0,v=m,w=v-96|0,v=w,A=i[A>>2],h=i[A+48>>2],G=i[A+52>>2],G&&(i[G+4>>2]=i[G+4>>2]+1),_=m+12|0;i:{if(!r){r=v-48|0,v=r,B=i[A+48>>2],I=i[A+52>>2],I&&(i[I+4>>2]=i[I+4>>2]+1),h=v-32|0,v=h,i[h+28>>2]=0,i[h+20>>2]=0,i[h+24>>2]=0,L1(h,B,e,h+20|0);e:{if(i[h>>2]){i[r+40>>2]=0,i[r+44>>2]=0;break e}r:{if(B=i[h+20>>2],A=i[h+24>>2],(B|0)!=(A|0)){if(e=i[B>>2],e&&(Q=i[r+44>>2],e=Z0(e,92792,94264),e))break r;if(B=B+8|0,(A|0)!=(B|0))for(;;){if(e=i[B>>2],e&&(Q=0,e=Z0(e,92792,94264),e))break r;if(B=B+8|0,(A|0)==(B|0))break}i[r+40>>2]=0,i[r+44>>2]=0}i[r+40>>2]=0,i[r+44>>2]=0;break e}if(i[r+44>>2]=Q,i[r+40>>2]=e,A=i[B+4>>2],i[r+44>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1}if(t[h+19|0]<0&&Z(i[h+8>>2]),A=i[h+20>>2],A){if(B=i[h+24>>2],e=A,(B|0)!=(A|0)){for(;;){e=i[B-4>>2];e:{if(!e||(Q=i[e+4>>2],i[e+4>>2]=Q-1,Q))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(B=B-8|0,(A|0)==(B|0))break}e=i[h+20>>2]}i[h+24>>2]=A,Z(e)}v=h+32|0,A=i[r+40>>2];e:{if(!A){A=C(32),i[r+4>>2]=A,i[r+8>>2]=26,i[r+12>>2]=-2147483616,e=u[10439]|u[10440]<<8,t[A+24|0]=e,t[A+25|0]=e>>>8,e=u[10435]|u[10436]<<8|(u[10437]<<16|u[10438]<<24),h=u[10431]|u[10432]<<8|(u[10433]<<16|u[10434]<<24),t[A+16|0]=h,t[A+17|0]=h>>>8,t[A+18|0]=h>>>16,t[A+19|0]=h>>>24,t[A+20|0]=e,t[A+21|0]=e>>>8,t[A+22|0]=e>>>16,t[A+23|0]=e>>>24,e=u[10427]|u[10428]<<8|(u[10429]<<16|u[10430]<<24),h=u[10423]|u[10424]<<8|(u[10425]<<16|u[10426]<<24),t[A+8|0]=h,t[A+9|0]=h>>>8,t[A+10|0]=h>>>16,t[A+11|0]=h>>>24,t[A+12|0]=e,t[A+13|0]=e>>>8,t[A+14|0]=e>>>16,t[A+15|0]=e>>>24,e=u[10419]|u[10420]<<8|(u[10421]<<16|u[10422]<<24),h=u[10415]|u[10416]<<8|(u[10417]<<16|u[10418]<<24),t[A|0]=h,t[A+1|0]=h>>>8,t[A+2|0]=h>>>16,t[A+3|0]=h>>>24,t[A+4|0]=e,t[A+5|0]=e>>>8,t[A+6|0]=e>>>16,t[A+7|0]=e>>>24,t[A+26|0]=0,A=a(r+16|0,2,116,r+4|0),e=i[A+4>>2],i[_>>2]=i[A>>2],i[_+4>>2]=e,e=_+8|0;r:{if(t[A+19|0]>=0){h=i[A+12>>2],i[e>>2]=i[A+8>>2],i[e+4>>2]=h,i[e+8>>2]=i[A+16>>2],t[_+20|0]=1;break r}if(T(e,i[A+8>>2],i[A+12>>2]),e=t[A+19|0],t[_+20|0]=1,(e|0)>=0)break r;Z(i[A+8>>2])}if(t[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}e=i[r+44>>2],t[_+20|0]=0,i[_+4>>2]=e,i[_>>2]=A}e:{if(!I||(A=i[I+4>>2],i[I+4>>2]=A-1,A))break e;W[i[i[I>>2]+8>>2]](I),y(I)}v=r+48|0;break i}i[w+92>>2]=0,i[w+84>>2]=0,i[w+88>>2]=0,L1(w- -64|0,h,e,w+84|0);e:{if(i[w+64>>2]){A=i[w+68>>2],i[_>>2]=i[w+64>>2],i[_+4>>2]=A,A=_+8|0;r:{if(t[w+83|0]>=0){e=i[w+76>>2],i[A>>2]=i[w+72>>2],i[A+4>>2]=e,i[A+8>>2]=i[w+80>>2];break r}T(A,i[w+72>>2],i[w+76>>2])}t[_+20|0]=1;break e}h=r-1|0,r=i[w+84>>2],h>>>0>=i[w+88>>2]-r>>3>>>0&&(A=C(32),i[w+24>>2]=A,i[w+28>>2]=27,i[w+32>>2]=-2147483616,e=u[15152]|u[15153]<<8|(u[15154]<<16|u[15155]<<24),r=u[15148]|u[15149]<<8|(u[15150]<<16|u[15151]<<24),t[A|0]=r,t[A+1|0]=r>>>8,t[A+2|0]=r>>>16,t[A+3|0]=r>>>24,t[A+4|0]=e,t[A+5|0]=e>>>8,t[A+6|0]=e>>>16,t[A+7|0]=e>>>24,t[A+27|0]=0,e=u[15171]|u[15172]<<8|(u[15173]<<16|u[15174]<<24),t[A+23|0]=e,t[A+24|0]=e>>>8,t[A+25|0]=e>>>16,t[A+26|0]=e>>>24,e=u[15168]|u[15169]<<8|(u[15170]<<16|u[15171]<<24),r=u[15164]|u[15165]<<8|(u[15166]<<16|u[15167]<<24),t[A+16|0]=r,t[A+17|0]=r>>>8,t[A+18|0]=r>>>16,t[A+19|0]=r>>>24,t[A+20|0]=e,t[A+21|0]=e>>>8,t[A+22|0]=e>>>16,t[A+23|0]=e>>>24,e=u[15160]|u[15161]<<8|(u[15162]<<16|u[15163]<<24),r=u[15156]|u[15157]<<8|(u[15158]<<16|u[15159]<<24),t[A+8|0]=r,t[A+9|0]=r>>>8,t[A+10|0]=r>>>16,t[A+11|0]=r>>>24,t[A+12|0]=e,t[A+13|0]=e>>>8,t[A+14|0]=e>>>16,t[A+15|0]=e>>>24,A=a(w+44|0,5,2007,w+24|0),t[A+19|0]<0&&Z(i[A+8>>2]),t[w+35|0]<0&&Z(i[w+24>>2]),r=i[w+84>>2]),e=r+(h<<3)|0,A=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{f:{if(!A||(A=Z0(A,92792,94264),!A))break f;e&&(i[e+4>>2]=i[e+4>>2]+1),t[_+20|0]=0,i[_+4>>2]=e,i[_>>2]=A;break r}A=C(24),i[w+12>>2]=A,i[w+16>>2]=19,i[w+20>>2]=-2147483624,r=u[13877]|u[13878]<<8|(u[13879]<<16|u[13880]<<24),t[A+15|0]=r,t[A+16|0]=r>>>8,t[A+17|0]=r>>>16,t[A+18|0]=r>>>24,r=u[13874]|u[13875]<<8|(u[13876]<<16|u[13877]<<24),h=u[13870]|u[13871]<<8|(u[13872]<<16|u[13873]<<24),t[A+8|0]=h,t[A+9|0]=h>>>8,t[A+10|0]=h>>>16,t[A+11|0]=h>>>24,t[A+12|0]=r,t[A+13|0]=r>>>8,t[A+14|0]=r>>>16,t[A+15|0]=r>>>24,r=u[13866]|u[13867]<<8|(u[13868]<<16|u[13869]<<24),h=u[13862]|u[13863]<<8|(u[13864]<<16|u[13865]<<24),t[A|0]=h,t[A+1|0]=h>>>8,t[A+2|0]=h>>>16,t[A+3|0]=h>>>24,t[A+4|0]=r,t[A+5|0]=r>>>8,t[A+6|0]=r>>>16,t[A+7|0]=r>>>24,t[A+19|0]=0,A=a(w+24|0,5,2007,w+12|0),r=i[A+4>>2],i[_>>2]=i[A>>2],i[_+4>>2]=r,r=_+8|0;f:{if(t[A+19|0]>=0){h=i[A+12>>2],i[r>>2]=i[A+8>>2],i[r+4>>2]=h,i[r+8>>2]=i[A+16>>2],t[_+20|0]=1;break f}if(T(r,i[A+8>>2],i[A+12>>2]),r=t[A+19|0],t[_+20|0]=1,(r|0)>=0)break f;Z(i[A+8>>2])}if(t[w+23|0]>=0)break r;Z(i[w+12>>2])}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(t[w+83|0]<0&&Z(i[w+72>>2]),A=i[w+84>>2],!A)break i;if(r=i[w+88>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];e:{if(!e||(_=i[e+4>>2],i[e+4>>2]=_-1,_))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[w+84>>2]}i[w+88>>2]=A,Z(e)}i:{if(!G||(A=i[G+4>>2],i[G+4>>2]=A-1,A))break i;W[i[i[G>>2]+8>>2]](G),y(G)}v=w+96|0;i:{A=u[m+32|0];e:{r:{f:{if(A)break f;A:{k:{n:{t:{o:{l:{u:{if(n){if(V=n,Y=pe(i[m+12>>2],f),i[V>>2]=Y,A=u[m+32|0],!l)break l;if(!A)break u;break i}if(!l)break o}V=l,Y=(aA(i[m+12>>2],f)^-1)+f|0,i[V>>2]=Y,A=u[m+32|0]}if(!o)break n;if(A&255)break i;break t}if(!o)break k}V=o,Y=Qe(i[m+12>>2],k),i[V>>2]=Y,A=u[m+32|0]}if(!s)break f;if(A&255)break i;break A}if(s)break A;A=0;break r}V=s,Y=(KA(i[m+12>>2],k)^-1)+k|0,i[V>>2]=Y,A=u[m+32|0]}if((A&255)==255)break e}e=i[25803],i[m+40>>2]=i[25802],i[m+44>>2]=e,W[i[(m+40|0)+((A&255)<<2)>>2]](m+39|0,m+12|0)}v=m+48|0;return}e2(),M()}function r6(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0;h=v-160|0,v=h;i:{e:{if(B=i[A+18588>>2],o=i[B+168>>2],s=e>>o,(s|0)<0||(n=i[B+172>>2],(n|0)<=(s|0)))break e;if(o=r>>o,(o|0)<0|(o|0)>=i[B+176>>2])break i;S=i[B+132>>2],N=i[B+124>>2],w=u[((i[B+160>>2]+g(s,3)|0)+g(g(n,o),3)|0)+1|0];r:{if(k||(s=i[B+248>>2],n=f-s|0,(n|0)==31))break r;for(o=r>>s,n=1<<n,G=o+n|0,s=e>>s,l=s+n|0;;){for(n=s;m=(i[B+240>>2]+n|0)+g(i[B+252>>2],o)|0,t[m|0]=u[m|0]|128,n=n+1|0,(l|0)>(n|0););if(o=o+1|0,!((G|0)>(o|0)))break}}A0=w&3,n=A+k|0,q=n,o=0;r:{if(!u[S+25|0]||(o=0,u[A+32|0])||(o=0,i[S+8276>>2]<(f|0)))break r;o=W2(A+18548|0,i[A+18572>>2]+(k?142:141)|0)}t[n+33|0]=o,t[A+36|0]=0;r:{if(!(u[n+33|0]|u[A+32|0])|(!u[N+16823|0]|(A0|0)!=1)||(s=A+18548|0,o=(k|0)!=0,n=W2(s,(o+i[A+18572>>2]|0)+143|0),t[A+36|0]=n,!(n&255)))break r;j0=A,S0=W2(s,(o+i[A+18572>>2]|0)+145|0),t[j0+37|0]=S0}m=k?0:2,m=u[q+33|0]|u[A+32|0]?m|1:m,w=f<<1;r:{if(!k){l=f+1>>2,n=(g(f,3)+(f-1>>2)|0)-6|0;break r}l=f-2|0,n=15}_=i[A+18572>>2],o=w-1|0;r:{if((w|0)<2){n=o;break r}G=n+(_+25|0)|0,s=A+18548|0,n=0;f:{for(;;){if(!W2(s,G+(n>>>l|0)|0))break f;if(n=n+1|0,(o|0)==(n|0))break}n=o}_=i[A+18572>>2]}r:{if(!k){l=(g(f,3)+(f-1>>2)|0)-6|0,s=f+1>>2;break r}l=15,s=f-2|0}r:{if((w|0)<2)break r;for(w=l+(_+43|0)|0,G=A+18548|0,l=0;;){if(!W2(G,w+(l>>>s|0)|0)){o=l;break r}if(l=l+1|0,(l|0)==(o|0))break}}(n|0)>=4&&(s=(n>>>1|0)-1|0,n=j8(A+18548|0,s)+((n&1|2)<<s)|0),(o|0)>=4&&(s=(o>>>1|0)-1|0,o=j8(A+18548|0,s)+((o&1|2)<<s)|0);r:{f:{if(A0){l=0;break f}A:{if(!k){if(l=i[B+208>>2],G=e>>l,(G|0)<0||(s=i[B+212>>2],(s|0)<=(G|0)))break e;if(l=r>>l,(l|0)<0|(l|0)>=i[B+216>>2])break i;s=u[(G+i[B+200>>2]|0)+g(l,s)|0],_=s>>>0<=34?s:0,s=0;break A}if(l=i[B+228>>2],G=e>>l,(G|0)<0||(s=i[B+232>>2],(s|0)<=(G|0)))break e;if(l=r>>l,(l|0)<0|(l|0)>=i[B+236>>2])break i;_=u[(G+i[B+220>>2]|0)+g(l,s)|0]&63,s=k}l=2,G=s,s=0;A:{k:{n:switch(f-2|0){case 0:break k;case 1:break n;default:break A}if(!G)break k;if(i[N+16848>>2]!=3)break A}if(s=2,_-6>>>0<9)break A;s=_-22>>>0<9}if((s|0)!=2){l=s;break f}s=o;break r}s=n,n=o}for(R=f-2|0,o=R,l>>>0<=2?G=i[i[(l<<2)+69064>>2]+(o<<2)>>2]:G=0,V0=l>>>0<=2?i[i[(l<<2)+69064>>2]+8>>2]:0,n=(i[(g(l,24)+(f<<2)|0)+68992>>2]+(n<<f<<1)|0)+(s<<1)|0,n=u[n|0]|u[n+1|0]<<8,t[h+158|0]=n,t[h+159|0]=n>>>8,j=u[h+158|0],C0=u[h+159|0],n=1<<R<<R,n&&l0(h+80|0,0,n),O=((k<<1)+A|0)+14396|0,X[O>>1]=0,s=k?43:42,Y=A+18548|0,d=(A+m|0)+18580|0,r0=C0-1|0,f0=R<<6|((k|0)!=0)<<5|((l|0)!=0)<<4,n=k<<11,M0=n+(A+2108|0)|0,z0=n+(A+8252|0)|0,E=1,n=j;;){o=(n<<1)+G|0,l=u[o+1|0],w=u[o|0],U=n;r:{f:{if(!(!n|n>>>0>=j>>>0)){if(n=u[h+80+(w+(l<<R))|0],n=n&1|n>>>1,m=1,W2(Y,(i[A+18572>>2]+(k?n+2|0:n)|0)+61|0))break f;break r}if((U|0)!=(j|0)&&U)break r;m=0}if(w&&(n=(w+(l<<R)|0)+h|0,t[n+79|0]=u[n+79|0]|1),_=0,o=0,l&&(n=h+80+(w+(l-1<<R))|0,t[n|0]=u[n|0]|2,o=l),n=((u[h+80+(w+(o<<R))|0]<<2)+f0|0)+132256|0,(U|0)==(j|0)&&(t[h|0]=1,X[h+48>>1]=1,t[h+32|0]=C0,_=1),c=i[n>>2],t0=o<<2,_0=w<<2,o=(U|0)!=(j|0)?15:r0,(o|0)>0)for(I=c+_0|0,n=o;;){l=(n<<1)+V0|0,Q=u[l+1|0],w=u[l|0],x=i[A+18572>>2];f:{if(u[N+16821|0]&&(l=s,u[A+32|0]|u[q+33|0]))break f;l=u[(w+I|0)+(Q+t0<<f)|0]}if(W2(Y,(x+(l&255)|0)+65|0)&&(t[h+_|0]=1,t[(h+32|0)+_|0]=n,X[(h+48|0)+(_<<1)>>1]=1,_=_+1|0,m=0),l=(n|0)>1,n=n-1|0,!l)break}f:{if((o|0)<0)break f;if(!m){o=i[A+18572>>2];A:{if(u[N+16821|0]&&(n=s,u[A+32|0]|u[q+33|0]))break A;n=u[(c+_0|0)+(t0<<f)|0]}if(!W2(Y,(o+(n&255)|0)+65|0))break f}t[h+_|0]=1,t[(h+32|0)+_|0]=0,X[(h+48|0)+(_<<1)>>1]=1,_=_+1|0}if(!_)break r;m=1;f:{if((_|0)<=0)break f;n=!E,E=(k|0)>0,I=n|(E?0:U?2:0),n=I<<2,Q=E?n|16:n,V=W2(Y,(Q+i[A+18572>>2]|0)+110|0);A:{if(V){X[h+48>>1]=p[h+48>>1]+1,m=0,o=0;break A}t[h|0]=0,m=2,o=-1}if(l=1,(_|0)!=1)for(w=(_|0)>=8?8:_,n=1;;){n=(n|0)>0?(V|0)!=1?n+1|0:0:n,V=W2(Y,(Q+(i[A+18572>>2]+((n|0)>=3?3:n)|0)|0)+109|0);A:{if(V){m=(h+48|0)+(l<<1)|0,X[m>>1]=p[m>>1]+1,o=(o|0)==-1?l:o,m=0;break A}t[l+h|0]=0,m=(m-1>>>0<2)+m|0}if(l=l+1|0,(w|0)==(l|0))break}if((o|0)==-1)break f;l=W2(Y,(i[A+18572>>2]+(E?I|4:I)|0)+133|0),t[o+h|0]=l,n=(h+48|0)+(o<<1)|0,X[n>>1]=l+p[n>>1]}f:{if(!k){if(o=i[B+208>>2],l=e>>o,(l|0)<0||(n=i[B+212>>2],(n|0)<=(l|0)))break e;if(o=r>>o,(o|0)<0|(o|0)>=i[B+216>>2])break i;n=u[(l+i[B+200>>2]|0)+g(n,o)|0],o=n>>>0<=34?n:0;break f}if(o=i[B+228>>2],l=e>>o,(l|0)<0||(n=i[B+232>>2],(n|0)<=(l|0)))break e;if(o=r>>o,(o|0)<0|(o|0)>=i[B+236>>2])break i;o=u[(l+i[B+220>>2]|0)+g(n,o)|0]&63}n=0,Q=0;f:{if(u[A+32|0]||!(!u[N+16822|0]|A0|(o&239)!=10)&&(Q=0,u[q+33|0])||(Q=0,u[A+36|0]))break f;Q=(t[h+32|0]-t[(h+_|0)+31|0]|0)>3}if(g0=_-1|0,(_|0)>1)for(;j0=(h+16|0)+n|0,S0=B4(Y),t[j0|0]=S0,n=n+1|0,(g0|0)!=(n|0););if(l=0,o=g0+(h+16|0)|0,Q&u[S+15|0]!=0?n=0:n=B4(Y),t[o|0]=n,l=u[N+16827|0]?u[d|0]>>>2|0:l,E=1,V=0,X0=0,(_|0)>0)for(;;){o=X[(h+48|0)+(V<<1)>>1],n=-1;f:{if(!u[h+V|0]){n=0;break f}I=3<<l;A:{for(;;){if(c=B4(Y),w=n,x=0,(n|0)==64)break A;if(n=n+1|0,!c)break}if((w|0)<=2){x=j8(Y,l)+(n<<l)|0;break A}n=w-2|0,x=j8(Y,n+l|0)+((1<<n)+2<<l)|0}n=x,w=o+n|0;A:{if(!u[N+16827|0]){if((w|0)<=(I|0))break A;l=((l|0)>=3?3:l)+1|0;break A}if(l=((w|0)>(I|0))+l|0,!(E&1))break A;if(I=u[d|0],w=I>>>2|0,3<<w<=(n|0)){t[d|0]=I+1;break A}if(!I|n<<1>=1<<w)break A;t[d|0]=I-1}E=0}if(n=n+o|0,n=u[(h+16|0)+V|0]?0-n|0:n,o=(t[(h+32|0)+V|0]<<1)+V0|0,I=u[o+1|0],w=u[o|0],o=(X[O>>1]<<1)+M0|0,Q&u[S+15|0]!=0&&(X0=(n&65535)+X0|0,n=(V|0)!=(g0|0)?n:X0&1?0-n|0:n),X[o>>1]=n,X[(X[O>>1]<<1)+z0>>1]=(w+_0|0)+(I+t0<<f),X[O>>1]=p[O>>1]+1,V=V+1|0,(V|0)==(_|0))break}E=m}if(n=U-1|0,!((U|0)>0))break}v=h+160|0;return}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function S9(A,e,r,f,k,n){var o=0,l=0,s=0,h=0,w=0,_=0;o=v-160|0,v=o,s=i[r>>2],w=i[r+4>>2],_=i[e+8>>2],l=f+n|0,h=l>>>0<n>>>0?k+1|0:k;i:{e:{r:{f:{A:{k:{n:{if(W[i[i[_>>2]+12>>2]](_,l,h)|0){i[o+104>>2]=0,i[o+76>>2]=78164,i[o+20>>2]=78144,e=i[19545],i[o+12>>2]=e,r=i[e-12>>2],e=o+12|0,i[r+e>>2]=i[19546],i[o+16>>2]=0,r=e+i[i[o+12>>2]-12>>2]|0,n=o+24|0,J0(r,n),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[o+20>>2]=r,s=i[r-12>>2],r=o+20|0,i[s+r>>2]=i[19548],s=i[19544],i[o+12>>2]=s,i[e+i[s-12>>2]>>2]=i[19549],i[o+76>>2]=78164,i[o+12>>2]=78124,i[o+20>>2]=78144,s=R0(n),i[s>>2]=77200,e=o- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+72>>2]=24,F(M2(F(M2(F(r,32385,11),f,k),29199,2),l,h),27633,23),e=i[o+72>>2];t:{if(e&16){n=o+44|0,r=i[o+68>>2],e=i[o+48>>2],r>>>0<e>>>0?i[o+68>>2]=e:e=r;break t}if(!(e&8)){r=0,t[o+11|0]=0,n=o;break e}n=o+32|0,e=i[o+40>>2]}if(r=e,e=i[n>>2],r=r-e|0,r>>>0>=2147483640)break n;if(r>>>0>=11){f=r|7,n=C(f+1|0),i[o+8>>2]=f-2147483647,i[o>>2]=n,i[o+4>>2]=r;break r}if(t[o+11|0]=r,n=o,r)break r;r=0;break e}h=w-s|0;t:{if(s=i[e+168>>2],!s||(l=i[s+40>>2],s=i[s+44>>2],!(l|s))||(_=s-(l>>>0<h>>>0)|0,!_&n>>>0<=l-h>>>0|_))break t;i[o+104>>2]=0,i[o+76>>2]=78164,i[o+20>>2]=78144,e=i[19545],i[o+12>>2]=e,r=i[e-12>>2],e=o+12|0,i[r+e>>2]=i[19546],i[o+16>>2]=0,r=e+i[i[o+12>>2]-12>>2]|0,f=o+24|0,J0(r,f),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[o+20>>2]=r,k=i[r-12>>2],r=o+20|0,i[k+r>>2]=i[19548],k=i[19544],i[o+12>>2]=k,i[e+i[k-12>>2]>>2]=i[19549],i[o+76>>2]=78164,i[o+12>>2]=78124,i[o+20>>2]=78144,f=R0(f),i[f>>2]=77200,e=o- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+72>>2]=24,F(M2(F(B0(F(B0(F(r,32204,15),n),31410,34),n+h|0),32112,40),l,s),25971,7),e=i[o+72>>2];o:{if(e&16){n=o+44|0,r=i[o+68>>2],e=i[o+48>>2],r>>>0<e>>>0?i[o+68>>2]=e:e=r;break o}if(!(e&8)){r=0,t[o+11|0]=0,n=o;break f}n=o+32|0,e=i[o+40>>2]}if(r=e,e=i[n>>2],r=r-e|0,r>>>0>=2147483640)break n;if(r>>>0>=11){k=r|7,n=C(k+1|0),i[o+8>>2]=k-2147483647,i[o>>2]=n,i[o+4>>2]=r;break A}if(t[o+11|0]=r,n=o,r)break A;r=0;break f}if(l=i[e+8>>2],!(W[i[i[l>>2]+20>>2]](l,f,k)|0)){if(e=C(40),i[o+12>>2]=e,i[o+16>>2]=34,i[o+20>>2]=-2147483608,r=u[25480]|u[25481]<<8|(u[25482]<<16|u[25483]<<24),f=u[25476]|u[25477]<<8|(u[25478]<<16|u[25479]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+34|0]=0,r=u[25508]|u[25509]<<8,t[e+32|0]=r,t[e+33|0]=r>>>8,r=u[25504]|u[25505]<<8|(u[25506]<<16|u[25507]<<24),f=u[25500]|u[25501]<<8|(u[25502]<<16|u[25503]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[25496]|u[25497]<<8|(u[25498]<<16|u[25499]<<24),f=u[25492]|u[25493]<<8|(u[25494]<<16|u[25495]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[25488]|u[25489]<<8|(u[25490]<<16|u[25491]<<24),f=u[25484]|u[25485]<<8|(u[25486]<<16|u[25487]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,100,o+12|0),t[o+23|0]>=0)break i;Z(i[o+12>>2]);break i}f=n+h|0,w=i[r+4>>2],k=i[r>>2],l=w-k|0;t:{if(f>>>0>l>>>0){if(s=f-l|0,_=i[r+8>>2],s>>>0<=_-w>>>0){s&&l0(w,0,s),i[r+4>>2]=s+w;break t}if((f|0)<0)break k;if(w=_-k|0,_=w<<1,_=w>>>0>=1073741823?2147483647:f>>>0<_>>>0?_:f,w=C(_),s&&l0(l+w|0,0,s),l&&z(w,k,l),i[r+8>>2]=w+_,i[r+4>>2]=f+w,i[r>>2]=w,!k)break t;Z(k);break t}if(f>>>0>=l>>>0)break t;i[r+4>>2]=f+k}if(e=i[e+8>>2],!(W[i[i[e>>2]+16>>2]](e,h+i[r>>2]|0,n)|0)){n=i[r+4>>2],e=i[r>>2],f=n-e|0;t:{if(f>>>0<h>>>0){if(k=h-f|0,l=i[r+8>>2],k>>>0<=l-n>>>0){k&&l0(n,0,k),i[r+4>>2]=k+n;break t}if((h|0)<0)break k;if(n=l-e|0,l=n<<1,l=n>>>0>=1073741823?2147483647:l>>>0>h>>>0?l:h,n=C(l),k&&l0(f+n|0,0,k),f&&z(n,e,f),i[r+8>>2]=n+l,i[r+4>>2]=n+h,i[r>>2]=n,!e)break t;Z(e);break t}if(f>>>0<=h>>>0)break t;i[r+4>>2]=e+h}if(e=C(40),i[o+12>>2]=e,i[o+16>>2]=37,i[o+20>>2]=-2147483608,r=u[27599]|u[27600]<<8|(u[27601]<<16|u[27602]<<24),f=u[27595]|u[27596]<<8|(u[27597]<<16|u[27598]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+37|0]=0,r=u[27628]|u[27629]<<8|(u[27630]<<16|u[27631]<<24),f=u[27624]|u[27625]<<8|(u[27626]<<16|u[27627]<<24),t[e+29|0]=f,t[e+30|0]=f>>>8,t[e+31|0]=f>>>16,t[e+32|0]=f>>>24,t[e+33|0]=r,t[e+34|0]=r>>>8,t[e+35|0]=r>>>16,t[e+36|0]=r>>>24,r=u[27623]|u[27624]<<8|(u[27625]<<16|u[27626]<<24),f=u[27619]|u[27620]<<8|(u[27621]<<16|u[27622]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[27615]|u[27616]<<8|(u[27617]<<16|u[27618]<<24),f=u[27611]|u[27612]<<8|(u[27613]<<16|u[27614]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[27607]|u[27608]<<8|(u[27609]<<16|u[27610]<<24),f=u[27603]|u[27604]<<8|(u[27605]<<16|u[27606]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,100,o+12|0),t[o+23|0]>=0)break i;Z(i[o+12>>2]);break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}I0(),M()}s0(),M()}if(!r)break f;z(n,e,r)}t[r+n|0]=0,a(A,6,1e3,o),t[o+11|0]<0&&Z(i[o>>2]),A=i[19543],i[o+12>>2]=A,i[i[A-12>>2]+(o+12|0)>>2]=i[19551],i[o+20>>2]=i[19552],i[f>>2]=77200,t[o+67|0]<0&&Z(i[o+56>>2]),y0(f),Y0(o+76|0);break i}if(!r)break e;z(n,e,r)}t[r+n|0]=0,a(A,2,100,o),t[o+11|0]<0&&Z(i[o>>2]),A=i[19543],i[o+12>>2]=A,i[i[A-12>>2]+(o+12|0)>>2]=i[19551],i[o+20>>2]=i[19552],i[s>>2]=77200,t[o+67|0]<0&&Z(i[o+56>>2]),y0(s),Y0(o+76|0)}v=o+160|0}function O9(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0;n=v-192|0,v=n,k=C(32),i[n+20>>2]=k,i[n+24>>2]=29,i[n+28>>2]=-2147483616,s=u[13299]|u[13300]<<8|(u[13301]<<16|u[13302]<<24),h=u[13295]|u[13296]<<8|(u[13297]<<16|u[13298]<<24),t[k+21|0]=h,t[k+22|0]=h>>>8,t[k+23|0]=h>>>16,t[k+24|0]=h>>>24,t[k+25|0]=s,t[k+26|0]=s>>>8,t[k+27|0]=s>>>16,t[k+28|0]=s>>>24,s=u[13294]|u[13295]<<8|(u[13296]<<16|u[13297]<<24),h=u[13290]|u[13291]<<8|(u[13292]<<16|u[13293]<<24),t[k+16|0]=h,t[k+17|0]=h>>>8,t[k+18|0]=h>>>16,t[k+19|0]=h>>>24,t[k+20|0]=s,t[k+21|0]=s>>>8,t[k+22|0]=s>>>16,t[k+23|0]=s>>>24,s=u[13286]|u[13287]<<8|(u[13288]<<16|u[13289]<<24),h=u[13282]|u[13283]<<8|(u[13284]<<16|u[13285]<<24),t[k+8|0]=h,t[k+9|0]=h>>>8,t[k+10|0]=h>>>16,t[k+11|0]=h>>>24,t[k+12|0]=s,t[k+13|0]=s>>>8,t[k+14|0]=s>>>16,t[k+15|0]=s>>>24,s=u[13278]|u[13279]<<8|(u[13280]<<16|u[13281]<<24),h=u[13274]|u[13275]<<8|(u[13276]<<16|u[13277]<<24),t[k|0]=h,t[k+1|0]=h>>>8,t[k+2|0]=h>>>16,t[k+3|0]=h>>>24,t[k+4|0]=s,t[k+5|0]=s>>>8,t[k+6|0]=s>>>16,t[k+7|0]=s>>>24,t[k+29|0]=0,s=a(n+168|0,2,121,n+20|0),t[n+31|0]<0&&Z(i[n+20>>2]),k=i[f>>2],o=i[f+4>>2]-k|0;i:{if(o>>>0<=9){e=i[s+4>>2],i[A>>2]=i[s>>2],i[A+4>>2]=e,i[A+16>>2]=i[s+16>>2],e=i[s+12>>2],i[A+8>>2]=i[s+8>>2],i[A+12>>2]=e,i[s+16>>2]=0,i[s+8>>2]=0,i[s+12>>2]=0;break i}h=u[k|0],t[e|0]=h;e:{r:{f:{if(h){i[n+112>>2]=0,i[n+84>>2]=78164,i[n+28>>2]=78144,r=i[19545],i[n+20>>2]=r,f=i[r-12>>2],r=n+20|0,i[f+r>>2]=i[19546],i[n+24>>2]=0,f=r+i[i[n+20>>2]-12>>2]|0,k=n+32|0,J0(f,k),t[f+80|0]=0,i[f+72>>2]=0,f=i[19547],i[n+28>>2]=f,l=n+28|0,i[l+i[f-12>>2]>>2]=i[19548],f=i[19544],i[n+20>>2]=f,i[r+i[f-12>>2]>>2]=i[19549],i[n+84>>2]=78164,i[n+20>>2]=78124,i[n+28>>2]=78144,f=R0(k),i[f>>2]=77200,i[n+72>>2]=0,i[n+76>>2]=0,i[n+64>>2]=0,i[n+68>>2]=0,i[n+80>>2]=24,F(D0(F(l,31523,27),u[e|0]),4559,23),e=i[n+80>>2];A:{if(e&16){l=n+52|0,r=i[n+76>>2],e=i[n+56>>2],r>>>0<e>>>0?i[n+76>>2]=e:e=r;break A}if(!(e&8)){k=0,t[n+19|0]=0,l=n+8|0;break e}l=n+40|0,e=i[n+48>>2]}if(r=e,e=i[l>>2],k=r-e|0,k>>>0>=2147483640)break f;if(k>>>0>=11){r=k|7,l=C(r+1|0),i[n+16>>2]=r-2147483647,i[n+8>>2]=l,i[n+12>>2]=k;break r}if(t[n+19|0]=k,l=n+8|0,k)break r;k=0;break e}if(h=u[k+1|0],t[e+1|0]=h,k=10,G=h&1,B=G?4:2,V=B<<1,h=V+10|0,o>>>0>=h+(r<<1<<(G?2:1))>>>0){if(o=i[f>>2],o=u[o+2|0]|u[o+3|0]<<8,X[e+2>>1]=o<<8|o>>>8,o=i[f>>2],o=u[o+4|0]|u[o+5|0]<<8,X[e+4>>1]=o<<8|o>>>8,o=i[f>>2],o=u[o+6|0]|u[o+7|0]<<8,X[e+6>>1]=o<<8|o>>>8,o=i[f>>2],o=u[o+8|0]|u[o+9|0]<<8,X[e+8>>1]=o<<8|o>>>8,_=i[f>>2],G){for(m=B&4;o=k,k=k+4|0,w=w+4|0,(m|0)!=(w|0););o=o+_|0,o=u[o|0]|u[o+1|0]<<8|(u[o+2|0]<<16|u[o+3|0]<<24),w=o<<24|(o&65280)<<8|(o>>>8&65280|o>>>24)}if(o=B&2,o)for(;w=u[k+_|0]|w<<8,k=k+1|0,l=l+1|0,(o|0)!=(l|0););if(i[e+12>>2]=w,m=B&2,k=B+10|0,I=i[f>>2],_=0,G){for(Q=B&4,l=0;o=k,k=k+4|0,l=l+4|0,(Q|0)!=(l|0););l=o+I|0,l=u[l|0]|u[l+1|0]<<8|(u[l+2|0]<<16|u[l+3|0]<<24),l=l<<24|(l&65280)<<8|(l>>>8&65280|l>>>24)}else l=0;if(m)for(;l=u[k+I|0]|l<<8,k=k+1|0,_=_+1|0,(m|0)!=(_|0););if(i[e+16>>2]=l,!(l&&w)){if(e=C(48),i[n+20>>2]=e,i[n+24>>2]=40,i[n+28>>2]=-2147483600,r=u[25439]|u[25440]<<8|(u[25441]<<16|u[25442]<<24),f=u[25435]|u[25436]<<8|(u[25437]<<16|u[25438]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+40|0]=0,r=u[25471]|u[25472]<<8|(u[25473]<<16|u[25474]<<24),f=u[25467]|u[25468]<<8|(u[25469]<<16|u[25470]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[25463]|u[25464]<<8|(u[25465]<<16|u[25466]<<24),f=u[25459]|u[25460]<<8|(u[25461]<<16|u[25462]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[25455]|u[25456]<<8|(u[25457]<<16|u[25458]<<24),f=u[25451]|u[25452]<<8|(u[25453]<<16|u[25454]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[25447]|u[25448]<<8|(u[25449]<<16|u[25450]<<24),f=u[25443]|u[25444]<<8|(u[25445]<<16|u[25446]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,121,n+20|0),t[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}k=e+20|0,o=i[e+20>>2],l=(i[e+24>>2]-o|0)/12|0;A:{k:{if(l>>>0<r>>>0){So(k,r-l|0);break k}if(r>>>0<l>>>0&&(i[e+24>>2]=o+g(r,12)),!r)break A}for(I=B&4,o=B&2,Q=128<<(B<<3)-8,R=i[k>>2],m=0;;){if(l=i[f>>2],k=h,_=0,w=0,G){for(;e=k,k=e+4|0,_=_+4|0,(I|0)!=(_|0););w=e+l|0,e=(u[w|0]<<16|u[w+1|0]<<8|u[w+2|0])<<8,w=e|u[w+3|0]}if(_=0,o)for(;e=w<<8,w=e|u[k+l|0],k=k+1|0,_=_+1|0,(o|0)!=(_|0););if(Y=g(m,12)+R|0,i[Y+4>>2]=e&Q?w|-2147483648:w,k=h+B|0,E=i[f>>2],_=0,e=0,w=0,G){for(;l=k,k=k+4|0,e=e+4|0,(I|0)!=(e|0););w=l+E|0,l=(u[w|0]<<16|u[w+1|0]<<8|u[w+2|0])<<8,w=l|u[w+3|0]}if(o)for(;l=w<<8,w=l|u[k+E|0],k=k+1|0,_=_+1|0,(o|0)!=(_|0););if(i[Y+8>>2]=l&Q?w|-2147483648:w,h=h+V|0,m=m+1|0,(m|0)==(r|0))break}}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}e=i[s+4>>2],i[A>>2]=i[s>>2],i[A+4>>2]=e,i[A+16>>2]=i[s+16>>2],e=i[s+12>>2],i[A+8>>2]=i[s+8>>2],i[A+12>>2]=e,i[s+16>>2]=0,i[s+8>>2]=0,i[s+12>>2]=0;break i}I0(),M()}if(!k)break e;z(l,e,k)}t[k+l|0]=0,a(A,4,3002,n+8|0),t[n+19|0]<0&&Z(i[n+8>>2]),A=i[19543],i[n+20>>2]=A,i[i[A-12>>2]+(n+20|0)>>2]=i[19551],i[n+28>>2]=i[19552],i[f>>2]=77200,t[n+75|0]<0&&Z(i[n+64>>2]),y0(f),Y0(n+84|0)}t[s+19|0]<0&&Z(i[s+8>>2]),v=n+192|0}function P9(A,e,r,f,k,n,o,l,s,h,w){var _=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0;_=v-528|0,v=_,i[_+520>>2]=w,i[_+524>>2]=e;i:{if(b2(A,_+524|0)){i[n>>2]=i[n>>2]|4,A=0;break i}i[_+72>>2]=2127,Q=_+72|0,Y=J1(_+104|0,_+112|0,Q),e=i[Y>>2],i[_+100>>2]=e,i[_+96>>2]=e+400,e=v-16|0,v=e,i[Q>>2]=0,i[Q+4>>2]=0,i[Q+8>>2]=0,v=e+16|0,e=v-16|0,v=e,G=_+60|0,i[G>>2]=0,i[G+4>>2]=0,i[G+8>>2]=0,v=e+16|0,e=v-16|0,v=e,m=_+48|0,i[m>>2]=0,i[m+4>>2]=0,i[m+8>>2]=0,v=e+16|0,e=v-16|0,v=e,B=_+36|0,i[B>>2]=0,i[B+4>>2]=0,i[B+8>>2]=0,v=e+16|0,e=v-16|0,v=e,I=_+24|0,i[I>>2]=0,i[I+4>>2]=0,i[I+8>>2]=0,v=e+16|0,V=v-16|0,v=V;e:{if(r){w=V+4|0,r=$0(f,136760),W[i[i[r>>2]+44>>2]](w,r);break e}w=V+4|0,r=$0(f,136752),W[i[i[r>>2]+44>>2]](w,r)}for(e=i[V+4>>2],t[_+92|0]=e,t[_+93|0]=e>>>8,t[_+94|0]=e>>>16,t[_+95|0]=e>>>24,W[i[i[r>>2]+32>>2]](w,r),er(B,w),q1(w),W[i[i[r>>2]+28>>2]](w,r),er(m,w),q1(w),R=_,N=W[i[i[r>>2]+12>>2]](r)|0,i[R+88>>2]=N,R=_,N=W[i[i[r>>2]+16>>2]](r)|0,i[R+84>>2]=N,W[i[i[r>>2]+20>>2]](w,r),u6(Q,w),_2(w),W[i[i[r>>2]+24>>2]](w,r),er(G,w),q1(w),R=_,N=W[i[i[r>>2]+36>>2]](r)|0,i[R+20>>2]=N,v=V+16|0,i[h>>2]=i[s>>2],E=k&512,f=0,e=0;;){r=e;e:{r:{f:{A:{if((f|0)==4||b2(A,_+524|0))break A;w=0;k:{n:{t:{o:{l:switch(u[(_+92|0)+f|0]){case 1:if((f|0)==3)break r;k=i[A>>2],e=i[k+12>>2];u:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break u}e=i[e>>2]}if(W[i[i[l>>2]+12>>2]](l,1,e)|0){ph(_+12|0,A),s5(I,i[_+12>>2]);break o}i[n>>2]=i[n>>2]|4,A=0;break f;case 0:break l;case 2:break n;case 3:break t;case 4:break k;default:break e}if((f|0)==3)break r}for(;;){if(b2(A,_+524|0))break r;k=i[A>>2],e=i[k+12>>2];o:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break o}e=i[e>>2]}if(!(W[i[i[l>>2]+12>>2]](l,1,e)|0))break r;ph(_+12|0,A),s5(I,i[_+12>>2])}}t:{if(u[m+11|0]>>>7|0?e=i[m+4>>2]:e=u[m+11|0]&127,!e)break t;k=i[A>>2],e=i[k+12>>2];o:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break o}e=i[e>>2]}if(u[m+11|0]>>>7|0?k=i[m>>2]:k=m,(e|0)!=i[k>>2])break t;k4(A),t[o|0]=0,u[m+11|0]>>>7|0?e=i[m+4>>2]:e=u[m+11|0]&127,e=e>>>0>1?m:r;break e}t:{if(u[B+11|0]>>>7|0?e=i[B+4>>2]:e=u[B+11|0]&127,!e)break t;k=i[A>>2],e=i[k+12>>2];o:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break o}e=i[e>>2]}if(u[B+11|0]>>>7|0?k=i[B>>2]:k=B,(e|0)!=i[k>>2])break t;k4(A),t[o|0]=1,u[B+11|0]>>>7|0?e=i[B+4>>2]:e=u[B+11|0]&127,e=e>>>0>1?B:r;break e}if(u[m+11|0]>>>7|0?e=i[m+4>>2]:e=u[m+11|0]&127,e=!e,u[B+11|0]>>>7|0?k=i[B+4>>2]:k=u[B+11|0]&127,!(e|!k)){i[n>>2]=i[n>>2]|4,A=0;break f}if(u[m+11|0]>>>7|0?e=i[m+4>>2]:e=u[m+11|0]&127,!e&&(u[B+11|0]>>>7|0?e=i[B+4>>2]:e=u[B+11|0]&127,!e))break r;u[B+11|0]>>>7|0?e=i[B+4>>2]:e=u[B+11|0]&127,t[o|0]=!e;break r}if(!(E|(f>>>0<2|r))&&(e=0,!((f|0)==2&u[_+95|0]!=0)))break e;R=_,N=e8(G),i[R+8>>2]=N,i[_+12>>2]=i[_+8>>2];n:{if(!f|u[(f+_|0)+91|0]>1)break n;for(;;){t:{if(R=_,N=y6(G),i[R+8>>2]=N,e=i[_+12>>2],(e|0)==i[_+8>>2]||!(W[i[i[l>>2]+12>>2]](l,1,i[e>>2])|0))break t;i[_+12>>2]=i[_+12>>2]+4;continue}break}if(R=_,N=e8(G),i[R+8>>2]=N,u[I+11|0]>>>7|0?w=i[I+4>>2]:w=u[I+11|0]&127,k=_+8|0,e=i[_+12>>2]-i[k>>2]>>2,w>>>0>=e>>>0&&(R=_,N=y6(I),i[R+8>>2]=N,V=e7(k,0-e|0),e=y6(I),w=e8(G),k=v-16|0,v=k,V=R6(V),e=R6(e),e=N2(V,R6(w),e-V&-4),v=k+16|0,!e))break n;R=_,N=e8(G),i[R+4>>2]=N,i[_+8>>2]=i[_+4>>2],i[_+12>>2]=i[_+8>>2]}for(i[_+8>>2]=i[_+12>>2];;){n:{if(R=_,N=y6(G),i[R+4>>2]=N,i[_+8>>2]==i[_+4>>2]||b2(A,_+524|0))break n;k=i[A>>2],e=i[k+12>>2];t:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break t}e=i[e>>2]}if((e|0)!=i[i[_+8>>2]>>2])break n;k4(A),i[_+8>>2]=i[_+8>>2]+4;continue}break}if(!E||(R=_,N=y6(G),i[R+4>>2]=N,i[_+8>>2]==i[_+4>>2]))break r;i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){k:{if(b2(A,_+524|0))break k;k=i[A>>2],e=i[k+12>>2];n:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break n}e=i[e>>2]}n:{if(W[i[i[l>>2]+12>>2]](l,64,e)|0){k=i[h>>2],(k|0)==i[_+520>>2]&&(Mi(s,h,_+520|0),k=i[h>>2]),i[h>>2]=k+4,i[k>>2]=e,w=w+1|0;break n}if(u[Q+11|0]>>>7|0?k=i[Q+4>>2]:k=u[Q+11|0]&127,!k|!w|(e|0)!=i[_+84>>2])break k;e=i[_+100>>2],(e|0)==i[_+96>>2]&&(Mi(Y,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=w,w=0}k4(A);continue}break}e=i[_+100>>2],!w|(e|0)==i[Y>>2]||(i[_+96>>2]==(e|0)&&(Mi(Y,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=w);k:{if(i[_+20>>2]<=0)break k;n:{if(!b2(A,_+524|0)){k=i[A>>2],e=i[k+12>>2];t:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break t}e=i[e>>2]}if((e|0)==i[_+88>>2])break n}i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){if(k4(A),i[_+20>>2]<=0)break k;n:{if(!b2(A,_+524|0)){k=i[A>>2],e=i[k+12>>2];t:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break t}e=i[e>>2]}if(W[i[i[l>>2]+12>>2]](l,64,e)|0)break n}i[n>>2]=i[n>>2]|4,A=0;break f}i[h>>2]==i[_+520>>2]&&Mi(s,h,_+520|0),k=i[A>>2],e=i[k+12>>2];n:{if((e|0)==i[k+16>>2]){k=W[i[i[k>>2]+36>>2]](k)|0;break n}k=i[e>>2]}e=i[h>>2],i[h>>2]=e+4,i[e>>2]=k,i[_+20>>2]=i[_+20>>2]-1}}if(e=r,i[s>>2]!=i[h>>2])break e;i[n>>2]=i[n>>2]|4,A=0;break f}A:{if(!r)break A;for(w=1;;){if(u[r+11|0]>>>7|0?e=i[r+4>>2]:e=u[r+11|0]&127,e>>>0<=w>>>0)break A;k:{if(!b2(A,_+524|0)){f=i[A>>2],e=i[f+12>>2];n:{if((e|0)==i[f+16>>2]){e=W[i[i[f>>2]+36>>2]](f)|0;break n}e=i[e>>2]}if(u[r+11|0]>>>7|0?f=i[r>>2]:f=r,(e|0)==i[f+(w<<2)>>2])break k}i[n>>2]=i[n>>2]|4,A=0;break f}k4(A),w=w+1|0}}if(A=1,i[Y>>2]==i[_+100>>2])break f;if(A=0,i[_+12>>2]=0,G4(Q,i[Y>>2],i[_+100>>2],_+12|0),i[_+12>>2]){i[n>>2]=i[n>>2]|4;break f}A=1}q1(I),q1(B),q1(m),q1(G),_2(Q),e=i[Y>>2],i[Y>>2]=0,e&&W[i[Y+4>>2]](e);break i}e=r}f=f+1|0}}return v=_+528|0,A}function sA(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=0,c2=0,f1=0,o1=0,u1=0,y1=0;o=v-32|0,v=o;i:{e:{n=i[A+276>>2],v2=(f|0)<(n|0)?f:n;r:{if((v2|0)<=(r|0)||(f=i[A+272>>2],Z2=(f|0)>(k|0)?k:f,(Z2|0)<=0))break r;for(c2=e?1:2,f1=e?2:1,h=i[A+40>>2],o1=h<<1,X2=i[A+124>>2],f=i[X2+16832>>2],R2=f-8|0,E=-1<<f^-1,u1=e?3:2,r0=g(h,-3),f0=0-h|0,M0=g(h,3),S=h<<1,z0=0-S|0,r2=0-(h<<2)|0;;){for(q0=r<<2,D2=q0-1|0,y1=q0>>2,s2=0,f2=0;;){I=f2<<2,B=u[(i[A+260>>2]+(I>>2)|0)+g(i[A+272>>2],y1)|0]&3;f:{if(!B)break f;f=g(i[A+40>>2],q0),k=i[A+4>>2],s=f+(k+I|0)|0;A:{if(!e){t[o+16|0]=u[s|0],f=u[s+f0|0],t[o|0]=f,t[o+17|0]=u[s+h|0],G=u[s+z0|0],t[o+1|0]=G,t[o+18|0]=u[s+S|0],q=u[s+r0|0],t[o+2|0]=q,t[o+19|0]=u[s+M0|0],O=u[s+r2|0],t[o+3|0]=O,k=s+1|0,t[o+20|0]=u[k|0],t[o+4|0]=u[k+f0|0],t[o+21|0]=u[k+h|0],t[o+5|0]=u[k+z0|0],t[o+22|0]=u[k+S|0],t[o+6|0]=u[k+r0|0],t[o+23|0]=u[k+M0|0],t[o+7|0]=u[k+r2|0],k=s+2|0,t[o+24|0]=u[k|0],t[o+8|0]=u[k+f0|0],t[o+25|0]=u[k+h|0],t[o+9|0]=u[k+z0|0],t[o+26|0]=u[k+S|0],t[o+10|0]=u[k+r0|0],t[o+27|0]=u[k+M0|0],t[o+11|0]=u[k+r2|0],n=s+3|0,t[o+28|0]=u[n|0],_=u[n+f0|0],t[o+12|0]=_,t[o+29|0]=u[n+h|0],k=u[n+z0|0],t[o+13|0]=k,t[o+30|0]=u[n+S|0],R=u[n+r0|0],t[o+14|0]=R,t[o+31|0]=u[n+M0|0],n=n+r2|0;break A}n=k+(f+(s2<<u1)|0)|0,i[o+16>>2]=u[n|0]|u[n+1|0]<<8|(u[n+2|0]<<16|u[n+3|0]<<24),f=u[s-1|0],t[o|0]=f,G=u[s-2|0],t[o+1|0]=G,q=u[s-3|0],t[o+2|0]=q,O=u[s-4|0],t[o+3|0]=O,k=n+h|0,i[o+20>>2]=u[k|0]|u[k+1|0]<<8|(u[k+2|0]<<16|u[k+3|0]<<24),k=s+h|0,t[o+4|0]=u[k-1|0],t[o+5|0]=u[k-2|0],t[o+6|0]=u[k-3|0],t[o+7|0]=u[k-4|0],k=n+S|0,i[o+24>>2]=u[k|0]|u[k+1|0]<<8|(u[k+2|0]<<16|u[k+3|0]<<24),k=s+S|0,t[o+8|0]=u[k-1|0],t[o+9|0]=u[k-2|0],t[o+10|0]=u[k-3|0],t[o+11|0]=u[k-4|0],k=n+M0|0,i[o+28>>2]=u[k|0]|u[k+1|0]<<8|(u[k+2|0]<<16|u[k+3|0]<<24),n=s+M0|0,_=u[n-1|0],t[o+12|0]=_,k=u[n-2|0],t[o+13|0]=k,R=u[n-3|0],t[o+14|0]=R,n=n-4|0}if(A2=u[n|0],t[o+15|0]=A2,Q=i[A+168>>2],l=I>>Q,(l|0)<0||(m=i[A+172>>2],(m|0)<=(l|0)))break i;if(n=q0>>Q,(n|0)<0||(Y=i[A+176>>2],(Y|0)<=(n|0)))break e;N=i[A+160>>2],x=N+g(l,3)|0,j=g(g(n,m),3),d=x+j|0,j0=t[d+2|0];A:{if(!e){if(n=D2>>Q,(n|0)<0|(n|0)>=(Y|0))break e;A0=(x+g(g(n,m),3)|0)+2|0;break A}if(n=I-1>>Q,(n|0)<0|n>>>0>=m>>>0)break i;A0=(j+(N+g(n,3)|0)|0)+2|0}if(n=i[A+148>>2],t0=I>>n,(t0|0)<0||(_0=i[A+152>>2],(_0|0)<=(t0|0)))break i;if(V=q0>>n,(V|0)<0|(V|0)>=i[A+156>>2])break e;if(g0=u[o+28|0],w=g0+(u[o+30|0]-(u[o+29|0]<<1)|0)|0,X0=w>>31,_=_&255,l=_+(R-((k&255)<<1)|0)|0,V0=l>>31,S0=u[o+16|0],n=S0+(u[o+18|0]-(u[o+17|0]<<1)|0)|0,C0=n>>31,k=(q-(G<<1)|0)+f|0,R=k>>31,q=(w^X0)-X0|0,X0=(l^V0)-V0|0,V0=q+X0|0,C0=(n^C0)-C0|0,R=(k^R)-R|0,w=C0+R|0,n=(j0+t[A0|0]|0)+1>>1,l=i[i[A+52>>2]+(p[((i[A+140>>2]+g(t0,24)|0)+g(g(V,_0),24)|0)+2>>1]<<2)>>2],k=n+i[l+764>>2]|0,k=(k|0)>=51?51:k,V=u[((k|0)>0?k:0)+66672|0]<<R2,(V0+w|0)>=(V|0))break f;k=(i[l+768>>2]+(n+(B<<1)|0)|0)-2|0,k=(k|0)>=53?53:k,c=u[((k|0)>0?k:0)+66736|0]<<R2,G=0,n=w<<1,w=V>>>2|0,k=0;A:{if(n>>>0>=w>>>0||(l=S0-u[o+19|0]|0,j0=l>>31,n=O-f|0,_0=n>>31,k=0,(l^j0)-j0+((n^_0)-_0)>>>0>=V>>>3>>>0))break A;f=f-S0|0,k=f>>31,k=((f^k)-k|0)<g(c,5)+1>>1}f=k;A:{if(w>>>0<=V0<<1>>>0||(n=g0-u[o+31|0]|0,w=n>>31,k=A2-_|0,l=k>>31,(n^w)-w+((k^l)-l)>>>0>=V>>>3>>>0))break A;k=_-g0|0,n=k>>31,G=((k^n)-n|0)<g(c,5)+1>>1}l=u[X2+8812|0];A:{if(!e){if(n=D2>>Q,l){if((n|0)<0|(n|0)>=(Y|0))break e;k=!(u[(x+g(g(n,m),3)|0)+1|0]&4)}else k=1;if((n|0)<0|(n|0)>=(Y|0))break e;n=x+g(g(n,m),3)|0;break A}if(n=I-1>>Q,l){if((n|0)<0|n>>>0>=m>>>0)break i;k=!(u[(j+(N+g(n,3)|0)|0)+1|0]&4)}else k=1;if((n|0)<0|n>>>0>=m>>>0)break i;n=j+(N+g(n,3)|0)|0}for(A2=f&G,N=!(u[n+1|0]&8)&k,f=V+(V>>>1|0)>>>3|0,j0=N&f>>>0>R+X0>>>0,k=f>>>0>q+C0>>>0,f=u[d|0]|u[d+1|0]<<8,Y=!(f&2048)&(!l|!(f&1024)),_0=k&Y,U=c<<1,f=0,S0=0-c|0,q=g(c,10),X0=s+1|0,V0=s+h|0,C0=s-2|0,R=s-1|0,O=c>>1,d=0-O|0;;){k=f<<2,A0=k+o|0,m=u[A0+1|0],_=k+(o+16|0)|0,x=u[_+2|0],I=u[_+1|0],G=u[_|0],j=u[A0+2|0],Q=u[A0|0];A:{if(!A2){if(n=(g(G-Q|0,9)+g(I-m|0,-3)|0)+8>>4,k=n>>31,(q|0)<=((k^n)-k|0))break A;n=(n|0)<(S0|0)?S0:(n|0)<(c|0)?n:c;k:{n:{if(!e){if(N&&(k=n+Q|0,t[s+(f-h|0)|0]=(k|0)>=0?(k|0)<(E|0)?k:E:0),!Y)break k;k=G-n|0,_=(k|0)>=0?(k|0)<(E|0)?k:E:0,k=f;break n}if(N&&(k=n+Q|0,t[R+g(f,h)|0]=(k|0)>=0?(k|0)<(E|0)?k:E:0),!Y)break k;k=G-n|0,_=(k|0)>=0?(k|0)<(E|0)?k:E:0,k=g(f,h)}t[k+s|0]=_}k:{if(!j0)break k;if(k=n+(((Q+j|0)+1>>>1|0)-m|0)>>1,k=((k|0)<(d|0)?d:(k|0)<(O|0)?k:O)+m|0,k=(k|0)>=0?(k|0)<(E|0)?k:E:0,!e){t[s+(f-o1|0)|0]=k;break k}t[C0+g(f,h)|0]=k}if(!_0)break A;if(k=((G+x|0)+1>>>1)-(n+I)>>1,k=I+((k|0)<(d|0)?d:(k|0)<(O|0)?k:O)|0,k=(k|0)>=0?(k|0)<(E|0)?k:E:0,!e){t[f+V0|0]=k;break A}t[X0+g(f,h)|0]=k;break A}if(n=I-U|0,l=G+Q|0,w=l+I|0,B=(w+x|0)+2>>>2|0,k=I+U|0,t0=(n|0)>(B|0)?n:(k|0)>(B|0)?B:k,n=m-U|0,l=l+m|0,B=(l+j|0)+2>>>2|0,k=m+U|0,V=(n|0)>(B|0)?n:(k|0)>(B|0)?B:k,n=x-U|0,w=((w+g(x,3)|0)+(u[_+3|0]<<1)|0)+4>>>3|0,k=U+x|0,g0=(n|0)>(w|0)?n:(k|0)>(w|0)?w:k,n=j-U|0,l=((l+g(j,3)|0)+(u[A0+3|0]<<1)|0)+4>>>3|0,k=U+j|0,_=(n|0)>(l|0)?n:(k|0)>(l|0)?l:k,n=G-U|0,l=G<<1,w=(Q<<1)+4|0,B=x+((l+(w+m|0)|0)+(I<<1)|0)>>>3|0,k=G+U|0,B=(n|0)>(B|0)?n:(k|0)>(B|0)?B:k,n=Q-U|0,l=I+(l+((w+j|0)+(m<<1)|0)|0)>>>3|0,k=Q+U|0,k=(n|0)>(l|0)?n:(k|0)>(l|0)?l:k,!e){if(n=f+s|0,!N){if(!Y)break A;t[n|0]=B,t[n+h|0]=t0,t[n+S|0]=g0;break A}if(!Y){t[n+f0|0]=k,t[n+z0|0]=V,t[n+r0|0]=_;break A}t[n+f0|0]=k,t[n|0]=B,t[n+z0|0]=V,t[n+h|0]=t0,t[n+r0|0]=_,t[n+S|0]=g0;break A}if(n=s+g(f,h)|0,N&&(t[n-1|0]=k),Y&&(t[n|0]=B),N&&(t[n-2|0]=V),Y&&(t[n+1|0]=t0),N&&(t[n-3|0]=_),!Y)break A;t[n+2|0]=g0}if(f=f+1|0,(f|0)==4)break}}if(s2=s2+1|0,f2=f2+f1|0,!((Z2|0)>(f2|0)))break}if(r=r+c2|0,!((v2|0)>(r|0)))break}}v=o+32|0;return}U0(5030,11952,119,4625),M()}U0(5068,11952,118,4625),M()}function jr(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;n=v-208|0,v=n,s=i[e+108>>2],w=i[e+104>>2],h=s-w>>5;i:{if((s|0)==(w|0))break i;for(l=h>>>0<=1?1:h;;){if(i[(o<<5)+w>>2]==(r|0))break i;if(o=o+1|0,(l|0)==(o|0))break}o=l}if(B=e+104|0,(o|0)==(h|0)){X[n+36>>1]=0,X[n+38>>1]=0,X[n+40>>1]=0,X[n+42>>1]=0,X[n+30>>1]=0,X[n+32>>1]=0,X[n+34>>1]=0,X[n+36>>1]=0,X[n+22>>1]=0,X[n+24>>1]=0,X[n+26>>1]=0,X[n+28>>1]=0,t[n+20|0]=k,i[n+16>>2]=r;i:{if(s>>>0<o0[e+112>>2]){r=i[n+20>>2],i[s>>2]=i[n+16>>2],i[s+4>>2]=r,r=i[n+28>>2],i[s+8>>2]=i[n+24>>2],i[s+12>>2]=r,i[s+24>>2]=0,i[s+16>>2]=0,i[s+20>>2]=0,b6(s+16|0,0,0,0),i[e+108>>2]=s+32;break i}if(r=Vi(B,n+16|0),l=i[n+32>>2],i[e+108>>2]=r,!l)break i;if(r=l,w=i[n+36>>2],(r|0)!=(w|0)){for(;r=i[w-16>>2],r&&(i[w-12>>2]=r,Z(r)),w=w-40|0,(l|0)!=(w|0););r=i[n+32>>2]}i[n+36>>2]=l,Z(r)}w=i[B>>2]}i[n+200>>2]=0,i[n+192>>2]=0,i[n+196>>2]=0,i[n+184>>2]=0,i[n+188>>2]=0,i[n+176>>2]=0,i[n+180>>2]=0,i[n+168>>2]=0,i[n+172>>2]=0,l=i[f+4>>2],s=i[f>>2],_=l-s|0,i[n+184>>2]=_,i[n+188>>2]=0;i:{e:{r:{f:{A:{if(!(!(t[e+132|0]&1)|k)){if(e=_s(i[e+136>>2],s,_),(e|0)<0){i[n+108>>2]=0,i[n+80>>2]=78164,i[n+24>>2]=78144,e=i[19545],i[n+16>>2]=e,r=i[e-12>>2],k=n+16|0,e=k,i[r+e>>2]=i[19546],i[n+20>>2]=0,e=e+i[i[n+16>>2]-12>>2]|0,f=n+28|0,J0(e,f),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[n+24>>2]=e,r=n+24|0,i[r+i[e-12>>2]>>2]=i[19548],e=i[19544],i[n+16>>2]=e,i[k+i[e-12>>2]>>2]=i[19549],i[n+80>>2]=78164,i[n+16>>2]=78124,i[n+24>>2]=78144,k=R0(f),i[k>>2]=77200,i[n+68>>2]=0,i[n+72>>2]=0,i[n+60>>2]=0,i[n+64>>2]=0,i[n+76>>2]=24,D0(F(r,31090,35),i[33136]),e=i[n+76>>2];k:{if(e&16){o=i[n+72>>2],e=i[n+52>>2],o>>>0<e>>>0&&(i[n+72>>2]=e,o=e),e=n+48|0;break k}if(!(e&8)){o=0,t[n+15|0]=0,r=n+4|0;break e}o=i[n+44>>2],e=n+36|0}if(f=i[e>>2],o=o-f|0,o>>>0>=2147483640)break f;if(o>>>0>=11){e=o|7,r=C(e+1|0),i[n+12>>2]=e-2147483647,i[n+4>>2]=r,i[n+8>>2]=o;break r}if(t[n+15|0]=o,r=n+4|0,o)break r;o=0;break e}if((e|0)==(i[f+4>>2]-i[f>>2]|0))break A;if(e=C(48),i[n+16>>2]=e,i[n+20>>2]=43,i[n+24>>2]=-2147483600,f=u[29928]|u[29929]<<8|(u[29930]<<16|u[29931]<<24),r=u[29924]|u[29925]<<8|(u[29926]<<16|u[29927]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+43|0]=0,r=u[29963]|u[29964]<<8|(u[29965]<<16|u[29966]<<24),t[e+39|0]=r,t[e+40|0]=r>>>8,t[e+41|0]=r>>>16,t[e+42|0]=r>>>24,f=u[29960]|u[29961]<<8|(u[29962]<<16|u[29963]<<24),r=u[29956]|u[29957]<<8|(u[29958]<<16|u[29959]<<24),t[e+32|0]=r,t[e+33|0]=r>>>8,t[e+34|0]=r>>>16,t[e+35|0]=r>>>24,t[e+36|0]=f,t[e+37|0]=f>>>8,t[e+38|0]=f>>>16,t[e+39|0]=f>>>24,f=u[29952]|u[29953]<<8|(u[29954]<<16|u[29955]<<24),r=u[29948]|u[29949]<<8|(u[29950]<<16|u[29951]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[29944]|u[29945]<<8|(u[29946]<<16|u[29947]<<24),r=u[29940]|u[29941]<<8|(u[29942]<<16|u[29943]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[29936]|u[29937]<<8|(u[29938]<<16|u[29939]<<24),r=u[29932]|u[29933]<<8|(u[29934]<<16|u[29935]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,9,0,n+16|0),t[n+27|0]>=0)break i;Z(i[n+16>>2]);break i}if(r=(o<<5)+w|0,h=i[r+20>>2],(h|0)!=i[r+16>>2]){if(r=h-16|0,e=h-12|0,V4(r,i[e>>2],s,l,_),r=i[e>>2]-i[r>>2]|0,e=h-24|0,i[e>>2]=r,i[e+4>>2]=0,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731]);break i}if(r=n+192|0,(r|0)!=(f|0)&&$4(r,s,l,_),(k|0)!=1)break A;k=i[e+128>>2],r=k,i[n+176>>2]=r,i[n+180>>2]=r>>31,r=i[f+4>>2]-i[f>>2]|0,i[n+184>>2]=r,i[n+188>>2]=0,i[e+128>>2]=r+k}k=i[B>>2]+(o<<5)|0,e=i[k+20>>2];A:{if(o0[k+24>>2]>e>>>0){r=i[n+172>>2],i[e>>2]=i[n+168>>2],i[e+4>>2]=r,r=i[n+188>>2],i[e+16>>2]=i[n+184>>2],i[e+20>>2]=r,r=i[n+180>>2],i[e+8>>2]=i[n+176>>2],i[e+12>>2]=r,i[e+32>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+24>>2]=i[n+192>>2],i[e+28>>2]=i[n+196>>2],i[e+32>>2]=i[n+200>>2],i[n+200>>2]=0,i[n+192>>2]=0,i[n+196>>2]=0,e=e+40|0;break A}k:{n:{if(h=i[k+20>>2],e=i[k+16>>2],l=h-e|0,o=((l|0)/40|0)+1|0,o>>>0<107374183){if(f=(i[k+24>>2]-e|0)/40|0,r=f<<1,r=f>>>0>=53687091?107374182:r>>>0>o>>>0?r:o,r>>>0>=107374183)break n;if(B=g(r,40),s=C(B),_=s+l|0,f=_,r=i[n+172>>2],i[f>>2]=i[n+168>>2],i[f+4>>2]=r,r=i[n+188>>2],i[f+16>>2]=i[n+184>>2],i[f+20>>2]=r,r=i[n+180>>2],i[f+8>>2]=i[n+176>>2],i[f+12>>2]=r,i[f+24>>2]=i[n+192>>2],i[f+28>>2]=i[n+196>>2],i[f+32>>2]=i[n+200>>2],i[n+200>>2]=0,i[n+192>>2]=0,i[n+196>>2]=0,o=f+g((l|0)/-40|0,40)|0,(e|0)!=(h|0)){for(r=e,f=o;l=i[r+4>>2],i[f>>2]=i[r>>2],i[f+4>>2]=l,l=i[r+20>>2],i[f+16>>2]=i[r+16>>2],i[f+20>>2]=l,l=i[r+12>>2],i[f+8>>2]=i[r+8>>2],i[f+12>>2]=l,i[f+24>>2]=i[r+24>>2],i[f+28>>2]=i[r+28>>2],i[f+32>>2]=i[r+32>>2],i[r+32>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,f=f+40|0,r=r+40|0,(h|0)!=(r|0););for(;r=i[e+24>>2],r&&(i[e+28>>2]=r,Z(r)),e=e+40|0,(h|0)!=(e|0););e=i[k+16>>2]}i[k+24>>2]=s+B,r=_+40|0,i[k+20>>2]=r,i[k+16>>2]=o,e&&Z(e),e=r;break k}s0(),M()}x0(),M()}}if(i[k+20>>2]=e,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731]);break i}I0(),M()}if(!o)break e;z(r,f,o)}t[r+o|0]=0,a(A,9,0,n+4|0),t[n+15|0]<0&&Z(i[n+4>>2]),A=i[19543],i[n+16>>2]=A,i[i[A-12>>2]+(n+16|0)>>2]=i[19551],i[n+24>>2]=i[19552],i[k>>2]=77200,t[n+71|0]<0&&Z(i[n+60>>2]),y0(k),Y0(n+80|0)}A=i[n+192>>2],A&&(i[n+196>>2]=A,Z(A)),v=n+208|0}function Sr(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0;f=i[A+18588>>2],I=i[f+132>>2],R=i[f+124>>2],U=i[R+16892>>2];i:{e:{r:{f:{if(!u[I+45|0]|r||(r=i[A+12>>2],i[A+8>>2]|(r|0)<=0))break f;if(x=2,(U|0)>=2){if(r=r-1|0,k=i[A+18596>>2],r>>>0>=i[k+472>>2]-i[k+468>>2]>>3>>>0)break r;O8(f,i[A+18604>>2],1,r,1),Di(A+18572|0,(i[i[A+18596>>2]+468>>2]+(i[A+12>>2]<<3)|0)-8|0),Qu((i[i[A+18596>>2]+468>>2]+(i[A+12>>2]<<3)|0)-8|0);break f}if(O8(f,i[A+18604>>2],0,r-1|0,1),r=i[A+18592>>2],f=i[r+804>>2],f>>>0>=3)break e;Ge(A+18572|0,f,i[r+800>>2]),t[A+18580|0]=0,t[A+18581|0]=0,t[A+18582|0]=0,t[A+18583|0]=0}for(j=A+18548|0,g0=A+18572|0,C0=U-1|0,_=i[A+12>>2],r=i[A+8>>2],x=2;;){if(X0=g(_,U)+r|0,i[R+16892>>2]<=(r|0)|X0>>>0>=i[I+8452>>2]-i[I+8448>>2]>>2>>>0|i[R+16900>>2]<=(_|0)||(!e|(_|0)<=0|(r|0)>=(C0|0)||O8(i[A+18588>>2],i[A+18604>>2],r+1|0,_-1|0,1),!i[A+18576>>2]))break r;V=0,O=0,f=i[A>>2],k=i[A+18588>>2],S=i[k+124>>2],o=i[S+16892>>2],s=(f|0)/(o|0)|0,m=f-g(o,s)|0,f=i[S+16876>>2],w=m<<f,o=i[A+18592>>2],n=i[k+152>>2],(n|0)<=(m|0)|(s|0)>=i[k+156>>2]||(X[(i[k+140>>2]+g(m,24)|0)+g(g(n,s),24)>>1]=i[o+808>>2]);f:{A:{if(l=i[k+148>>2],h=w>>l,!((h|0)<0|(n|0)<=(h|0))){if(Q=s<<f,l=Q>>l,(l|0)<0|(l|0)>=i[k+156>>2])break A;if(X[((i[k+140>>2]+g(h,24)|0)+g(g(n,l),24)|0)+2>>1]=i[o>>2],r0=w,f0=Q,u[o+333|0]|u[o+334|0]){o=v-32|0,v=o,N=i[A+18592>>2],h=i[A+18588>>2],q=i[h+132>>2],n=i[h+124>>2],t[o+24|0]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+8>>2]=0,i[o+12>>2]=0,f=0;k:{if((m|0)<=0||(f=0,i[A>>2]<=i[N+808>>2])||(k=(i[q+8484>>2]+(m<<2)|0)+(g(s,i[n+16892>>2])<<2)|0,f=0,i[k>>2]!=i[k-4>>2]))break k;f=W2(A+18548|0,i[A+18572>>2])}k:{if(f&255|(s|0)<=0||(k=i[n+16892>>2],i[N+808>>2]>(i[A>>2]-k|0))||(l=i[q+8484>>2]+(m<<2)|0,i[l+(g(k,s)<<2)>>2]!=i[l+(g(k,s-1|0)<<2)>>2]))break k;O=(W2(A+18548|0,i[A+18572>>2])&255)!=0}if(V0=f&255,!(O|V0)){for(k=A+18548|0,M0=o+16|0,f=o+8|0,z0=f|7,j0=f|6,S0=f|2,q0=f|5,r2=i[n+16848>>2],n=0,l=0;;){k:{n:{t:{o:{l:{if(!u[N+333|0]||n){if(!n|!u[N+334|0])break k;if((n|0)!=1)break t;if(W2(k,i[A+18572>>2]+1|0))break l;f=0;break o}if(!W2(k,i[A+18572>>2]+1|0)){l=0,f=0;break n}l=B4(k)?2:1,f=l;break n}f=B4(k)?2:1}l=f<<2|f<<4|l;break n}f=(l&255)>>>(n<<1)&3}if(!f)break k;w=n<<2,d=w+q0|0,G=n?16840:16832,B=i[G+i[h+124>>2]>>2],B=qe(k,-1<<((B|0)>=10?10:B)-5^-1),t[d|0]=B,c=w+j0|0,Y=i[G+i[h+124>>2]>>2],Y=qe(k,-1<<((Y|0)>=10?10:Y)-5^-1),t[c|0]=Y,A0=w+z0|0,E=i[G+i[h+124>>2]>>2],E=qe(k,-1<<((E|0)>=10?10:E)-5^-1),t[A0|0]=E,t0=w+M0|0,w=i[G+i[h+124>>2]>>2],G=qe(k,-1<<((w|0)>=10?10:w)-5^-1),t[t0|0]=G;n:{if((f|0)==1){f=0,Q=0,B&255&&(Q=B4(k)?-1:1),Y&255&&(f=B4(k)?-1:1),w=0,_0=0,E&255&&(_0=B4(k)?-1:1),G&255&&(w=B4(k)?-1:1),A2=n+S0|0,s2=j8(k,5),t[A2|0]=s2,G=u[t0|0],E=u[A0|0],Y=u[c|0],B=u[d|0];break n}t:{if(!n){f=1,w=-1,V=j8(k,2);break t}if(f=1,w=-1,(n|0)!=1)break t;Q=V,V=j8(k,2),V=Q|(V<<2|V<<4)}_0=-1,Q=1}f2=B,B=u[(n?8264:8263)+q|0],t[d|0]=g(f2<<B,Q),t[c|0]=g(Y<<B,f),t[A0|0]=g(E<<B,_0),t[t0|0]=g(G<<B,w)}if(!(r2&&(f=n>>>0<2,n=n+1|0,f)))break}t[o+8|0]=l,t[o+9|0]=V,f=(i[h+140>>2]+g(m,24)|0)+g(g(s,i[h+152>>2]),24)|0,t[f+20|0]=u[o+24|0],k=i[o+20>>2],n=i[o+16>>2],t[f+12|0]=n,t[f+13|0]=n>>>8,t[f+14|0]=n>>>16,t[f+15|0]=n>>>24,t[f+16|0]=k,t[f+17|0]=k>>>8,t[f+18|0]=k>>>16,t[f+19|0]=k>>>24,k=i[o+12>>2],n=i[o+8>>2],t[f+4|0]=n,t[f+5|0]=n>>>8,t[f+6|0]=n>>>16,t[f+7|0]=n>>>24,t[f+8|0]=k,t[f+9|0]=k>>>8,t[f+10|0]=k>>>16,t[f+11|0]=k>>>24}V0&&(f=(i[h+140>>2]+g(m,24)|0)+g(g(s,i[h+152>>2]),24)|0,k=f-20|0,n=u[k+4|0]|u[k+5|0]<<8|(u[k+6|0]<<16|u[k+7|0]<<24),l=u[k|0]|u[k+1|0]<<8|(u[k+2|0]<<16|u[k+3|0]<<24),t[f+4|0]=l,t[f+5|0]=l>>>8,t[f+6|0]=l>>>16,t[f+7|0]=l>>>24,t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24,t[f+20|0]=u[k+16|0],n=u[k+12|0]|u[k+13|0]<<8|(u[k+14|0]<<16|u[k+15|0]<<24),k=u[k+8|0]|u[k+9|0]<<8|(u[k+10|0]<<16|u[k+11|0]<<24),t[f+12|0]=k,t[f+13|0]=k>>>8,t[f+14|0]=k>>>16,t[f+15|0]=k>>>24,t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24),O&&(n=i[h+140>>2]+g(m,24)|0,k=i[h+152>>2],f=n+g(g(k,s),24)|0,k=n+g(g(k,s-1|0),24)|0,t[f+20|0]=u[k+20|0],n=u[k+16|0]|u[k+17|0]<<8|(u[k+18|0]<<16|u[k+19|0]<<24),s=u[k+12|0]|u[k+13|0]<<8|(u[k+14|0]<<16|u[k+15|0]<<24),t[f+12|0]=s,t[f+13|0]=s>>>8,t[f+14|0]=s>>>16,t[f+15|0]=s>>>24,t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24,n=u[k+8|0]|u[k+9|0]<<8|(u[k+10|0]<<16|u[k+11|0]<<24),k=u[k+4|0]|u[k+5|0]<<8|(u[k+6|0]<<16|u[k+7|0]<<24),t[f+4|0]=k,t[f+5|0]=k>>>8,t[f+6|0]=k>>>16,t[f+7|0]=k>>>24,t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24),v=o+32|0,f=i[S+16876>>2]}xr(A,r0,f0,f,0);break f}U0(5068,11952,128,4625),M()}U0(5030,11952,129,4625),M()}if(!(!u[I+45|0]|(r|0)!=1|(i[R+16900>>2]-1|0)<=(_|0))){if(f=i[A+18596>>2],r=i[f+468>>2],i[f+472>>2]-r>>3>>>0<=_>>>0)break r;f=r,r=_<<3,Di(f+r|0,g0),wu(r+i[i[A+18596>>2]+468>>2]|0)}if(k=Q5(j),!k|!u[I+14|0]||(Di(i[A+18592>>2]+1340|0,g0),wu(i[A+18592>>2]+1340|0),t[i[A+18592>>2]+1348|0]=1),r=i[i[A+18588>>2]+320>>2]+g(X0,76)|0,i[r>>2]<=0&&(i[r>>2]=1),s=i[A+4>>2],f=s+1|0,i[A+4>>2]=f,h=i[A+12>>2],_=i[A+18588>>2],n=i[_+124>>2],o=i[n+16908>>2],n=i[n+16892>>2],r=(f|0)<(o|0)?i[i[i[_+132>>2]+8460>>2]+(f<<2)>>2]:o,i[A>>2]=r,_=(r|0)/(n|0)|0,i[A+12>>2]=_,r=r-g(n,_)|0,i[A+8>>2]=r,!((f|0)<(o|0)|k)){C2(i[A+18584>>2]+4|0,1004,0);break i}if(k)return 0;if(u[I+46|0]?(o=f<<2,f=i[I+8472>>2],f=i[o+f>>2]!=i[f+(s<<2)>>2]):f=0,!!(f|u[I+45|0]!=0&(h|0)!=(_|0)))break}if(!Q5(j)){C2(i[A+18584>>2]+4|0,1017,0);break i}rr(j),x=1}return x}U0(23510,19977,1520,5620),M()}return t[i[A+18588>>2]+312|0]=3,2}function Ov(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;if(f=v-176|0,v=f,i[f+88>>2]=0,i[f+60>>2]=78468,k=i[19620],i[f+4>>2]=k,o=i[k-12>>2],k=f+4|0,i[o+k>>2]=i[19621],o=k+i[i[f+4>>2]-12>>2]|0,n=f+8|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+60>>2]=78468,i[f+4>>2]=78448,G=R0(n),i[G>>2]=77200,i[f+48>>2]=0,i[f+52>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+56>>2]=16,o=f+164|0,J2(o,e,r),h=k,n=o,k=t[f+175|0],o=(k|0)<0,F(h,o?i[f+164>>2]:n,o?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),m=i[e+104>>2],I=i[e+108>>2],(m|0)!=(I|0))for(;;){if(e=f+164|0,k0(e,r),o=e,e=t[f+175|0],k=(e|0)<0,F(f+4|0,k?i[f+164>>2]:o,k?i[f+168>>2]:e),t[f+175|0]<0&&Z(i[f+164>>2]),F(B0(F(f+4|0,37591,26),i[m>>2]),47878,1),e=i[r>>2]+1|0,i[r>>2]=e,_=i[m+4>>2],Q=i[m+8>>2],(_|0)!=(Q|0)){i:{e:{for(;;){r:{k0(f+144|0,r),n=t[f+155|0],h=i[f+144>>2],w=i[f+148>>2],e=f+4|0,B=X1(f+156|0,e);f:{if(u[B|0]!=1)break f;k=e+i[i[f+4>>2]-12>>2]|0,Y=i[k+4>>2],l=i[k+24>>2];A:{if(u[k+80|0]==1){o=u[k+76|0]|u[k+77|0]<<8|(u[k+78|0]<<16|u[k+79|0]<<24);break A}s=f+164|0,e=i[k+28>>2],i[s>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(s,137008),o=W[i[i[e>>2]+28>>2]](e,32)|0,i2(s),t[k+76|0]=o,t[k+77|0]=o>>>8,t[k+78|0]=o>>>16,t[k+79|0]=o>>>24,t[k+80|0]=1}A:{if(!l||(s=i[k+12>>2],e=h,h=(n|0)<0,e=h?e:f+144|0,n=h?w:n,V=e+n|0,h=(Y&176)==32?V:e,w=h-e|0,(w|0)>0&&(W[i[i[l>>2]+48>>2]](l,e,w)|0)!=(w|0)))break A;if(n=(n|0)<(s|0)?s-n|0:0,(n|0)>0){if(n>>>0>=2147483640)break r;k:{if(n>>>0>=11){s=n|7,e=C(s+1|0),i[f+172>>2]=s-2147483647,i[f+164>>2]=e,i[f+168>>2]=n;break k}t[f+175|0]=n,e=f+164|0}if(n&&l0(e,o,n),t[e+n|0]=0,e=W[i[i[l>>2]+48>>2]](l,t[f+175|0]<0?i[f+164>>2]:f+164|0,n)|0,t[f+175|0]<0&&Z(i[f+164>>2]),(e|0)!=(n|0))break A}if(e=V-h|0,(e|0)>0&&(W[i[i[l>>2]+48>>2]](l,h,e)|0)!=(e|0))break A;i[k+12>>2]=0;break f}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,M1(e,i[e+16>>2]|5)}v1(B),t[f+155|0]<0&&Z(i[f+144>>2]),e=f+4|0,h=X1(f+144|0,e);f:{if(u[h|0]!=1)break f;e=e+i[i[f+4>>2]-12>>2]|0,s=i[e+4>>2],n=i[e+24>>2];A:{if(u[e+80|0]==1){o=u[e+76|0]|u[e+77|0]<<8|(u[e+78|0]<<16|u[e+79|0]<<24);break A}l=f+164|0,k=i[e+28>>2],i[l>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(l,137008),o=W[i[i[k>>2]+28>>2]](k,32)|0,i2(l),t[e+76|0]=o,t[e+77|0]=o>>>8,t[e+78|0]=o>>>16,t[e+79|0]=o>>>24,t[e+80|0]=1}A:{if(!n||(l=i[e+12>>2],s=(s&176)==32?33124:33108,k=s-33108|0,(k|0)>0&&(W[i[i[n>>2]+48>>2]](n,33108,k)|0)!=(k|0)))break A;if((l|0)>=17){k=((l|0)<=16?16:l)-16|0;k:{if(l>>>0>=27){w=k|7,l=C(w+1|0),i[f+172>>2]=w-2147483647,i[f+164>>2]=l,i[f+168>>2]=k;break k}t[f+175|0]=k,l=f+164|0}if(k&&l0(l,o,k),t[k+l|0]=0,o=W[i[i[n>>2]+48>>2]](n,t[f+175|0]<0?i[f+164>>2]:f+164|0,k)|0,t[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(o|0))break A}if(k=33124-s|0,(k|0)>0&&(W[i[i[n>>2]+48>>2]](n,s,k)|0)!=(k|0))break A;i[e+12>>2]=0;break f}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,M1(e,i[e+16>>2]|5)}v1(h),l=B0(f+4|0,p[_+2>>1]),w=X1(f+144|0,l);f:{if(u[w|0]!=1)break f;k=l+i[i[l>>2]-12>>2]|0,h=i[k+4>>2],s=i[k+24>>2];A:{if(u[k+80|0]==1){o=u[k+76|0]|u[k+77|0]<<8|(u[k+78|0]<<16|u[k+79|0]<<24);break A}n=f+164|0,e=i[k+28>>2],i[n>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(n,137008),o=W[i[i[e>>2]+28>>2]](e,32)|0,i2(n),t[k+76|0]=o,t[k+77|0]=o>>>8,t[k+78|0]=o>>>16,t[k+79|0]=o>>>24,t[k+80|0]=1}A:{if(!s||(e=i[k+12>>2],h=(h&176)==32?34906:34893,n=h-34893|0,(n|0)>0&&(W[i[i[s>>2]+48>>2]](s,34893,n)|0)!=(n|0)))break A;if((e|0)>=14){n=((e|0)<=13?13:e)-13|0;k:{if(e>>>0>=24){B=n|7,e=C(B+1|0),i[f+172>>2]=B-2147483647,i[f+164>>2]=e,i[f+168>>2]=n;break k}t[f+175|0]=n,e=f+164|0}if(n&&l0(e,o,n),t[e+n|0]=0,e=W[i[i[s>>2]+48>>2]](s,t[f+175|0]<0?i[f+164>>2]:f+164|0,n)|0,t[f+175|0]<0&&Z(i[f+164>>2]),(e|0)!=(n|0))break A}if(e=34906-h|0,(e|0)>0&&(W[i[i[s>>2]+48>>2]](s,h,e)|0)!=(e|0))break A;i[k+12>>2]=0;break f}e=l+i[i[l>>2]-12>>2]|0,M1(e,i[e+16>>2]|5)}v1(w),e=l+i[i[l>>2]-12>>2]|0,i[e+4>>2]=i[e+4>>2]|1,s=i1(l,u[_|0]),w=X1(f+144|0,s);f:{if(u[w|0]!=1)break f;k=s+i[i[s>>2]-12>>2]|0,h=i[k+4>>2],l=i[k+24>>2];A:{if(u[k+80|0]==1){o=u[k+76|0]|u[k+77|0]<<8|(u[k+78|0]<<16|u[k+79|0]<<24);break A}n=f+164|0,e=i[k+28>>2],i[n>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(n,137008),o=W[i[i[e>>2]+28>>2]](e,32)|0,i2(n),t[k+76|0]=o,t[k+77|0]=o>>>8,t[k+78|0]=o>>>16,t[k+79|0]=o>>>24,t[k+80|0]=1}A:{if(!l||(e=i[k+12>>2],h=(h&176)==32?47879:47877,n=h-47877|0,(n|0)>0&&(W[i[i[l>>2]+48>>2]](l,47877,n)|0)!=(n|0)))break A;if((e|0)>=3){if(e>>>0>=2147483642)break e;n=((e|0)<=2?2:e)-2|0;k:{if(e>>>0>=13){B=n|7,e=C(B+1|0),i[f+172>>2]=B-2147483647,i[f+164>>2]=e,i[f+168>>2]=n;break k}t[f+175|0]=n,e=f+164|0}if(n&&l0(e,o,n),t[e+n|0]=0,e=W[i[i[l>>2]+48>>2]](l,t[f+175|0]<0?i[f+164>>2]:f+164|0,n)|0,t[f+175|0]<0&&Z(i[f+164>>2]),(e|0)!=(n|0))break A}if(e=47879-h|0,(e|0)>0&&(W[i[i[l>>2]+48>>2]](l,h,e)|0)!=(e|0))break A;i[k+12>>2]=0;break f}e=s+i[i[s>>2]-12>>2]|0,M1(e,i[e+16>>2]|5)}if(v1(w),_=_+4|0,(Q|0)!=(_|0))continue;break i}break}I0(),M()}I0(),M()}e=i[r>>2]}if(i[r>>2]=((e|0)<=1?1:e)-1,m=m+16|0,(I|0)==(m|0))break}e=i[f+56>>2];i:{e:{if(e&16){_=f+28|0,r=i[f+52>>2],e=i[f+32>>2],r>>>0<e>>>0?i[f+52>>2]=e:e=r;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}_=f+16|0,e=i[f+24>>2]}e:{if(k=i[_>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){o=e|7,r=C(o+1|0),i[A+8>>2]=o-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+4>>2]=A,i[i[A-12>>2]+(f+4|0)>>2]=i[19622],i[G>>2]=77200,t[f+51|0]<0&&Z(i[f+40>>2]),y0(G),Y0(f+60|0),v=f+176|0}function Pv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;if(f=v-192|0,v=f,i[f+116>>2]=0,i[f+88>>2]=78468,n=i[19620],i[f+32>>2]=n,k=i[n-12>>2],n=f+32|0,i[k+n>>2]=i[19621],k=n+i[i[f+32>>2]-12>>2]|0,o=f+36|0,J0(k,o),t[k+80|0]=0,i[k+72>>2]=0,i[f+88>>2]=78468,i[f+32>>2]=78448,m=R0(o),i[m>>2]=77200,i[f+76>>2]=0,i[f+80>>2]=0,i[f+68>>2]=0,i[f+72>>2]=0,i[f+84>>2]=16,k=f+180|0,K1(k,e,r),l=n,o=k,n=t[f+191|0],k=(n|0)<0,F(l,k?i[f+180>>2]:o,k?i[f+184>>2]:n),t[f+191|0]<0&&Z(i[f+180>>2]),n=f+180|0,k0(n,r),l=n,n=t[f+191|0],k=(n|0)<0,F(f+32|0,k?i[f+180>>2]:l,k?i[f+184>>2]:n),t[f+191|0]<0&&Z(i[f+180>>2]),n=f+32|0,F(D0(F(n,35821,17),u[e+104|0]+1|0),47878,1),u[e+105|0]==1&&(k=f+180|0,k0(k,r),l=n,o=k,n=t[f+191|0],k=(n|0)<0,F(l,k?i[f+180>>2]:o,k?i[f+184>>2]:n),t[f+191|0]<0&&Z(i[f+180>>2]),n=F(B0(F(f+32|0,33085,11),p[e+106>>1]),47878,1),k=f+180|0,k0(k,r),l=k,k=t[f+191|0],o=(k|0)<0,F(n,o?i[f+180>>2]:l,o?i[f+184>>2]:k),t[f+191|0]<0&&Z(i[f+180>>2]),n=F(D0(F(n,33718,15),u[e+108|0]),47878,1),k=f+180|0,k0(k,r),l=k,k=t[f+191|0],o=(k|0)<0,F(n,o?i[f+180>>2]:l,o?i[f+184>>2]:k),t[f+191|0]<0&&Z(i[f+180>>2]),k=F(n,36272,21),n=u[e+109|0],n=(n|0)==1?4125:(n|0)==2?7473:8706,n=F(F(k,n,l2(n)),47878,1),k=f+180|0,k0(k,r),l=k,k=t[f+191|0],o=(k|0)<0,F(n,o?i[f+180>>2]:l,o?i[f+184>>2]:k),t[f+191|0]<0&&Z(i[f+180>>2]),k=F(n,33542,15),n=i[(u[e+110|0]<<2)+106560>>2],n=F(F(k,n,l2(n)),47878,1),k=f+180|0,k0(k,r),l=k,k=t[f+191|0],o=(k|0)<0,F(n,o?i[f+180>>2]:l,o?i[f+184>>2]:k),t[f+191|0]<0&&Z(i[f+180>>2]),n=F(D0(F(n,35069,11),u[e+111|0]+8|0),47878,1),k=f+180|0,k0(k,r),l=k,k=t[f+191|0],o=(k|0)<0,F(n,o?i[f+180>>2]:l,o?i[f+184>>2]:k),t[f+191|0]<0&&Z(i[f+180>>2]),n=F(B0(F(n,37824,20),p[e+168>>1]),47878,1),k=f+180|0,k0(k,r),l=k,k=t[f+191|0],o=(k|0)<0,F(n,o?i[f+180>>2]:l,o?i[f+184>>2]:k),t[f+191|0]<0&&Z(i[f+180>>2]),F(B0(F(n,33361,20),p[e+170>>1]),47878,1),n=f+180|0,k0(n,r),l=n,n=t[f+191|0],k=(n|0)<0,F(f+32|0,k?i[f+180>>2]:l,k?i[f+184>>2]:n),t[f+191|0]<0&&Z(i[f+180>>2]),n=F(D0(F(f+32|0,36720,17),u[e+113|0]),47878,1),k=f+180|0,k0(k,r),l=k,k=t[f+191|0],o=(k|0)<0,F(n,o?i[f+180>>2]:l,o?i[f+184>>2]:k),t[f+191|0]<0&&Z(i[f+180>>2]),n=F(D0(F(n,35732,11),u[e+114|0]),47878,1),k=f+180|0,k0(k,r),l=k,k=t[f+191|0],o=(k|0)<0,F(n,o?i[f+180>>2]:l,o?i[f+184>>2]:k),t[f+191|0]<0&&Z(i[f+180>>2]),n=F(D0(F(n,22887,14),u[e+115|0]),47878,1),k=f+180|0,k0(k,r),l=k,k=t[f+191|0],o=(k|0)<0,F(n,o?i[f+180>>2]:l,o?i[f+184>>2]:k),t[f+191|0]<0&&Z(i[f+180>>2]),n=F(D0(F(n,35699,32),u[e+116|0]),47878,1),k=f+180|0,k0(k,r),l=k,k=t[f+191|0],o=(k|0)<0,F(n,o?i[f+180>>2]:l,o?i[f+184>>2]:k),t[f+191|0]<0&&Z(i[f+180>>2]),F(D0(F(n,35744,30),u[e+117|0]),47878,1)),n=f+180|0,k0(n,r),l=n,n=t[f+191|0],k=(n|0)<0,F(f+32|0,k?i[f+180>>2]:l,k?i[f+184>>2]:n),t[f+191|0]<0&&Z(i[f+180>>2]),n=f+32|0,F(B0(F(n,33574,15),i[e+180>>2]-i[e+176>>2]>>4),47878,1),k=f+180|0,k0(k,r),l=n,o=k,n=t[f+191|0],k=(n|0)<0,F(l,k?i[f+180>>2]:o,k?i[f+184>>2]:n),t[f+191|0]<0&&Z(i[f+180>>2]),F(f+32|0,46890,13),h=i[e+176>>2],G=i[e+180>>2],(h|0)!=(G|0))for(e=i[r>>2]+1|0;;){i[r>>2]=e,e=f+180|0,k0(e,r),k=e,e=t[f+191|0],n=(e|0)<0,F(f+32|0,n?i[f+180>>2]:k,n?i[f+184>>2]:e),t[f+191|0]<0&&Z(i[f+180>>2]),k=F(D0(F(f+32|0,36611,10),u[h+1|0]),30581,2),e=u[h+1|0]-12&255,e>>>0>7?e=22032:e=i[(e<<2)+106656>>2],F(F(k,e,l2(e)),47877,2),e=f+180|0,k0(e,r),k=e,e=t[f+191|0],n=(e|0)<0,F(f+32|0,n?i[f+180>>2]:k,n?i[f+184>>2]:e),t[f+191|0]<0&&Z(i[f+180>>2]),F(D0(F(f+32|0,33697,20),u[h|0]),47878,1);i:{if(e=i[h+4>>2],I=i[h+8>>2],(e|0)==(I|0))break i;for(;;){e:{i[r>>2]=i[r>>2]+1,n=f+20|0,k0(n,r),k=i[e>>2],Pn(f+8|0,k,i[e+4>>2]-k|0,n,n),s=t[f+19|0],l=i[f+8>>2],_=i[f+12>>2],n=f+32|0,Q=X1(f+172|0,n);r:{if(u[Q|0]!=1)break r;k=n+i[i[f+32>>2]-12>>2]|0,Y=i[k+4>>2],w=i[k+24>>2];f:{if(u[k+80|0]==1){n=u[k+76|0]|u[k+77|0]<<8|(u[k+78|0]<<16|u[k+79|0]<<24);break f}o=f+180|0,n=i[k+28>>2],i[o>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=$0(o,137008),n=W[i[i[n>>2]+28>>2]](n,32)|0,i2(o),t[k+76|0]=n,t[k+77|0]=n>>>8,t[k+78|0]=n>>>16,t[k+79|0]=n>>>24,t[k+80|0]=1}f:{if(!w||(B=i[k+12>>2],o=l,l=(s|0)<0,o=l?o:f+8|0,s=l?_:s,V=o+s|0,l=(Y&176)==32?V:o,_=l-o|0,(_|0)>0&&(W[i[i[w>>2]+48>>2]](w,o,_)|0)!=(_|0)))break f;if(o=(s|0)<(B|0)?B-s|0:0,(o|0)>0){if(o>>>0>=2147483640)break e;A:{if(o>>>0>=11){B=o|7,s=C(B+1|0),i[f+188>>2]=B-2147483647,i[f+180>>2]=s,i[f+184>>2]=o;break A}t[f+191|0]=o,s=f+180|0}if(o&&l0(s,n,o),t[o+s|0]=0,n=W[i[i[w>>2]+48>>2]](w,t[f+191|0]<0?i[f+180>>2]:f+180|0,o)|0,t[f+191|0]<0&&Z(i[f+180>>2]),(n|0)!=(o|0))break f}if(n=V-l|0,(n|0)>0&&(W[i[i[w>>2]+48>>2]](w,l,n)|0)!=(n|0))break f;i[k+12>>2]=0;break r}n=i[i[f+32>>2]-12>>2]+(f+32|0)|0,M1(n,i[n+16>>2]|5)}if(v1(Q),t[f+19|0]<0&&Z(i[f+8>>2]),n=i[r>>2],i[r>>2]=((n|0)<=1?1:n)-1,t[f+31|0]<0&&Z(i[f+20>>2]),e=e+12|0,(I|0)!=(e|0))continue;break i}break}I0(),M()}if(e=i[r>>2],e=(e|0)<=1?1:e,i[r>>2]=e-1,h=h+16|0,(G|0)==(h|0))break}e=i[f+84>>2];i:{e:{if(e&16){r=i[f+80>>2],e=i[f+60>>2],r>>>0<e>>>0&&(i[f+80>>2]=e,r=e),e=f+56|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+52>>2],e=f+44|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,n,r)}t[A+r|0]=0,A=i[19619],i[f+32>>2]=A,i[i[A-12>>2]+(f+32|0)>>2]=i[19622],i[m>>2]=77200,t[f+79|0]<0&&Z(i[f+68>>2]),y0(m),Y0(f+88|0),v=f+192|0}function L9(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=D(0),m=0,G=0,I=D(0);_=v-16|0,v=_,i[_+12>>2]=r;i:{e:{if(o=i[k+4>>2],!o)break e;n=i[k>>2],w=mr(o),s=o-1&r;r:{if(w>>>0<=1||(s=r,r>>>0<o>>>0))break r;s=(r>>>0)%(o>>>0)|0}if(n=i[n+(s<<2)>>2],!n||(n=i[n>>2],!n))break e;r:{if(w>>>0<=1){for(l=o-1|0;;){o=i[n+4>>2];f:{if((o|0)!=(r|0)){if((s|0)==(o&l))break f;break e}if(i[n+8>>2]==(r|0))break r}if(n=i[n>>2],!n)break}break e}for(;;){l=i[n+4>>2];f:{if((l|0)!=(r|0)){if(o>>>0<=l>>>0&&(l=(l>>>0)%(o>>>0)|0),(l|0)==(s|0))break f;break e}if(i[n+8>>2]==(r|0))break r}if(n=i[n>>2],!n)break}break e}if(e=C(24),i[_>>2]=e,i[_+4>>2]=21,i[_+8>>2]=-2147483624,r=u[14708]|u[14709]<<8|(u[14710]<<16|u[14711]<<24),f=u[14704]|u[14705]<<8|(u[14706]<<16|u[14707]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+21|0]=0,r=u[14721]|u[14722]<<8|(u[14723]<<16|u[14724]<<24),f=u[14717]|u[14718]<<8|(u[14719]<<16|u[14720]<<24),t[e+13|0]=f,t[e+14|0]=f>>>8,t[e+15|0]=f>>>16,t[e+16|0]=f>>>24,t[e+17|0]=r,t[e+18|0]=r>>>8,t[e+19|0]=r>>>16,t[e+20|0]=r>>>24,r=u[14716]|u[14717]<<8|(u[14718]<<16|u[14719]<<24),f=u[14712]|u[14713]<<8|(u[14714]<<16|u[14715]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,2008,_),t[_+11|0]>=0)break i;Z(i[_>>2]);break i}r=0,s=i[_+12>>2],o=i[k+4>>2];e:{r:{if(!o)break r;n=i[k>>2],l=mr(o),r=s&o-1;f:{if(l>>>0<=1||(r=s,r>>>0<o>>>0))break f;r=(r>>>0)%(o>>>0)|0}if(n=i[n+(r<<2)>>2],!n||(h=i[n>>2],!h))break r;if(l>>>0<=1){for(n=o-1|0;;){f:{if(l=i[h+4>>2],(l|0)!=(s|0)){if((n&l)!=(r|0))break r;break f}if((s|0)!=i[h+8>>2])break f;r=0;break e}if(h=i[h>>2],!h)break}break r}for(;;){f:{if(n=i[h+4>>2],(n|0)!=(s|0)){if(n>>>0>=o>>>0&&(n=(n>>>0)%(o>>>0)|0),(r|0)!=(n|0))break r;break f}if((s|0)!=i[h+8>>2])break f;r=0;break e}if(h=i[h>>2],!h)break}}h=C(12),i[h+4>>2]=s,i[h>>2]=0,i[h+8>>2]=i[_+12>>2],I=D(i[k+12>>2]+1>>>0),B=E0[k+16>>2];r:{if(!(I>D(B*D(o>>>0)))&&o)break r;r=2,l=(o-1&o)!=0|o>>>0<3|o<<1,B=D(v9(D(I/B))),B<D(4294967296)&B>=D(0)?n=~~B>>>0:n=0,n=n>>>0<l>>>0?l:n;f:{if((n|0)==1)break f;if(!(n&n-1)){r=n;break f}r=fn(n),o=i[k+4>>2]}f:{if(r>>>0<=o>>>0){if(r>>>0>=o>>>0)break f;B=D(v9(D(D(o0[k+12>>2])/E0[k+16>>2]))),B<D(4294967296)&B>=D(0)?n=~~B>>>0:n=0;A:{k:{if(o>>>0<3||mr(o)>>>0>1)break k;n=n>>>0<2?n:1<<32-_1(n-1|0);break A}n=fn(n)}if(r=r>>>0>n>>>0?r:n,o>>>0<=r>>>0)break f}w=r;A:{k:{n:{if(r){if(r>>>0>=1073741824)break n;if(r=r<<2,m=C(r),n=i[k>>2],i[k>>2]=m,n&&(Z(n),m=i[k>>2]),i[k+4>>2]=w,r&&l0(m,0,r),r=i[k+8>>2],!r)break A;if(n=k+8|0,o=i[r+4>>2],l=w-1|0,!(l&w))break k;for(o=o>>>0>=w>>>0?(o>>>0)%(w>>>0)|0:o,i[(o<<2)+m>>2]=n;;){if(l=i[r>>2],!l)break A;if(n=i[l+4>>2],w>>>0<=n>>>0&&(n=(n>>>0)%(w>>>0)|0),(n|0)==(o|0)){r=l;continue}G=(n<<2)+m|0,i[G>>2]?(i[r>>2]=i[l>>2],i[l>>2]=i[i[G>>2]>>2],i[i[G>>2]>>2]=l):(i[G>>2]=r,r=l,o=n)}}r=i[k>>2],i[k>>2]=0,r&&Z(r),i[k+4>>2]=0;break A}x0(),M()}if(o=o&l,i[(o<<2)+m>>2]=n,n=i[r>>2],!n)break A;for(G=w-1|0;;){l=G&i[n+4>>2];k:{if((l|0)==(o|0)){r=n;break k}if(w=(l<<2)+m|0,i[w>>2]){i[r>>2]=i[n>>2],i[n>>2]=i[i[w>>2]>>2],i[i[w>>2]>>2]=n;break k}i[w>>2]=r,r=n,o=l}if(n=i[r>>2],!n)break}}}if(o=i[k+4>>2],r=o-1|0,!(r&o)){r=r&s;break r}if(o>>>0>s>>>0){r=s;break r}r=(s>>>0)%(o>>>0)|0}n=i[k>>2],l=n+(r<<2)|0,r=i[l>>2];r:{if(!r){if(r=k+8|0,i[h>>2]=i[r>>2],i[k+8>>2]=h,i[l>>2]=r,r=i[h>>2],!r)break r;r=i[r+4>>2],l=o-1|0;f:{if(!(l&o)){r=r&l;break f}if(r>>>0<o>>>0)break f;r=(r>>>0)%(o>>>0)|0}i[n+(r<<2)>>2]=h;break r}i[h>>2]=i[r>>2],i[r>>2]=h}i[k+12>>2]=i[k+12>>2]+1,r=1}t[_+4|0]=r,i[_>>2]=h,d4(_,i[f>>2],i[_+12>>2],1684630887),n=i[_>>2],r=i[_+4>>2];e:{if((n|0)!=(r|0))for(;;){if(L9(A,e,i[n>>2],f,k),i[A>>2])break e;if(t[A+19|0]<0&&Z(i[A+8>>2]),n=n+4|0,(r|0)==(n|0))break}w=v-16|0,v=w,l=i[k+4>>2];r:{if(!l)break r;f=i[k>>2],r=i[_+12>>2],e=r&l-1,s=mr(l);f:{if(s>>>0<=1||(e=r,r>>>0<l>>>0))break f;e=(r>>>0)%(l>>>0)|0}if(n=e,e=i[(n<<2)+f>>2],!e||(e=i[e>>2],!e))break r;f:{if(s>>>0<=1){for(f=l-1|0;;){l=i[e+4>>2];A:{if((l|0)!=(r|0)){if((n|0)==(f&l))break A;break r}if((r|0)==i[e+8>>2])break f}if(e=i[e>>2],!e)break}break r}for(;;){f=i[e+4>>2];A:{if((f|0)!=(r|0)){if(f>>>0>=l>>>0&&(f=(f>>>0)%(l>>>0)|0),(f|0)==(n|0))break A;break r}if((r|0)==i[e+8>>2])break f}if(e=i[e>>2],!e)break}break r}o=i[e+4>>2],s=i[k+4>>2],h=mr(s);f:{if(h>>>0<=1){o=s-1&o;break f}if(o>>>0<s>>>0)break f;o=(o>>>0)%(s>>>0)|0}for(m=i[k>>2],n=m+(o<<2)|0,f=i[n>>2];r=f,f=i[r>>2],(f|0)!=(e|0););G=k+8|0;f:{if((G|0)!=(r|0)){f=i[r+4>>2];A:{if(h>>>0<=1){f=s-1&f;break A}if(f>>>0<s>>>0)break A;f=(f>>>0)%(s>>>0)|0}if((f|0)==(o|0))break f}if(f=i[e>>2],f){f=i[f+4>>2];A:{if(h>>>0<=1){f=s-1&f;break A}if(f>>>0<s>>>0)break A;f=(f>>>0)%(s>>>0)|0}if((f|0)==(o|0))break f}i[n>>2]=0}l=i[e>>2],n=0;f:{if(!l)break f;f=i[l+4>>2];A:{if(h>>>0<=1){f=s-1&f;break A}if(f>>>0<s>>>0)break A;f=(f>>>0)%(s>>>0)|0}if(n=l,(f|0)==(o|0))break f;i[m+(f<<2)>>2]=r,n=i[e>>2]}i[r>>2]=n,i[e>>2]=0,i[k+12>>2]=i[k+12>>2]-1,t[w+12|0]=1,i[w+8>>2]=G,i[w+4>>2]=e,e=i[w+4>>2],i[w+4>>2]=0,e&&Z(e)}if(v=w+16|0,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731])}if(A=i[_>>2],!A)break i;i[_+4>>2]=A,Z(A)}v=_+16|0}function Lv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0;e=v-128|0,v=e,n=K0(i[r>>2],0),s=K0(i[r>>2],1),B=K0(i[r>>2],2),S=$2(i[r>>2],6),S&&(g0=K0(i[r>>2],6));i:{if(!(!(n>>>0<9|s>>>0<9)&B>>>0>8)){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}if(!((n|0)==(s|0)&(n|0)==(B|0))){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}f=i[r>>2],k=i[f+192>>2],I=i[f+188>>2],f=C(248),i[f>>2]=101168,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,o=f+12|0,i[f+176>>2]=o,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(o,I,k,0,1),a0(e+56|0,o,0,I,k,n,l,0),m=I+1>>>1|0,E=k+1>>>1|0,a0(e+32|0,o,1,m,E,s,l,0),n=e+88|0;e:{if(i[e+56>>2]){if(s=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=s,t[e+75|0]>=0){s=e- -64|0,G=i[s+4>>2],i[n>>2]=i[s>>2],i[n+4>>2]=G,i[n+8>>2]=i[s+8>>2];break e}T(n,i[e+64>>2],i[e+68>>2]);break e}if(s=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=s,t[e+51|0]>=0){s=i[e+44>>2],i[n>>2]=i[e+40>>2],i[n+4>>2]=s,i[n+8>>2]=i[e+48>>2];break e}T(n,i[e+40>>2],i[e+44>>2])}a0(e+8|0,o,2,m,E,B,l,0),s=e+112|0;e:{if(i[e+80>>2]){if(B=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=B,t[e+99|0]>=0){B=i[n+4>>2],i[s>>2]=i[n>>2],i[s+4>>2]=B,i[s+8>>2]=i[n+8>>2];break e}T(s,i[e+88>>2],i[e+92>>2]);break e}if(n=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=n,t[e+27|0]>=0){n=i[e+20>>2],i[s>>2]=i[e+16>>2],i[s+4>>2]=n,i[s+8>>2]=i[e+24>>2];break e}T(s,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[s+4>>2],i[r>>2]=i[s>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!S)break r;if(a0(e+104|0,o,6,I,k,g0,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}l=0,n=Q0(i[r>>2],0),n?(q=i[n+40>>2],B=i[n+52>>2]>>>1|0):B=0,n=Q0(i[r>>2],1),n?(l=i[n+52>>2]>>>1|0,n=i[n+40>>2]):n=0,s=Q0(i[r>>2],2);r:{if(!s){s=0;break r}U=i[s+52>>2]>>>1|0,s=i[s+40>>2]}G=Q0(o,0),G?(d=i[G+52>>2]>>>1|0,G=i[G+40>>2]):G=0,h=Q0(o,1),h?(c=i[h+40>>2],h=i[h+52>>2]>>>1|0):h=0,Q=Q0(o,2),Q?(A0=i[Q+52>>2]>>>1|0,Q=i[Q+40>>2]):Q=0,j=0;r:{if(!S||(r=Q0(i[r>>2],6),r?(V0=i[r+40>>2],r=i[r+52>>2]):r=0,C0=r,r=Q0(o,6),j=0,!r))break r;r0=i[r+52>>2],j=i[r+40>>2]}r:{f:{A:{k:{if(t0=k&1,t0){if(w=I-1|0,!w)break k;for(r=E-1|0,_=(g(r,A0)<<1)+Q|0,V=k-1|0,x=(g(V,U)<<1)+s|0,O=(g(r,h)<<1)+c|0,V=(g(l,V)<<1)+n|0,r=0;Y=r<<1,R=Y+V|0,X[r+O>>1]=(p[R>>1]+p[R+2>>1]|0)+1>>>1,Y=Y+x|0,X[r+_>>1]=(p[Y>>1]+p[Y+2>>1]|0)+1>>>1,r=r+2|0,w>>>0>r>>>0;);}if(I&1)break k;m=k-1|0;break A}if(w=m<<1,_=I<<1,m=k-1|0,m){for(O=(w+Q|0)-2|0,V=(s+_|0)-2|0,Y=(w+c|0)-2|0,x=(n+_|0)-2|0,r=0;R=r>>>1|0,N=r|1,X[Y+(g(R,h)<<1)>>1]=(p[x+(g(r,l)<<1)>>1]+p[x+(g(N,l)<<1)>>1]|0)+1>>>1,X[O+(g(R,A0)<<1)>>1]=(p[V+(g(r,U)<<1)>>1]+p[V+(g(U,N)<<1)>>1]|0)+1>>>1,r=r+2|0,m>>>0>r>>>0;);if(!t0)break f}r=E-1|0,X[(w+((g(r,h)<<1)+c|0)|0)-2>>1]=p[(_+((g(l,m)<<1)+n|0)|0)-2>>1],X[(w+((g(r,A0)<<1)+Q|0)|0)-2>>1]=p[(_+((g(m,U)<<1)+s|0)|0)-2>>1]}if(!m)break r}if(E=I-1|0,!E)break r;for(w=0;;){for(V=(g(w,U)<<1)+s|0,x=(g(l,w)<<1)+n|0,r=w>>>1|0,t0=(g(r,A0)<<1)+Q|0,O=(g(r,h)<<1)+c|0,r=w|1,Y=(g(r,U)<<1)+s|0,R=(g(r,l)<<1)+n|0,r=0;_=r<<1,N=_+Y|0,f0=p[N+2>>1],N=p[N>>1],_0=_+V|0,M0=p[_0+2>>1],_0=p[_0>>1],X0=_+R|0,_=_+x|0,X[r+O>>1]=((p[X0>>1]+(p[_>>1]+p[_+2>>1]|0)|0)+p[X0+2>>1]|0)+2>>>2,X[r+t0>>1]=((N+(_0+M0|0)|0)+f0|0)+2>>>2,r=r+2|0,E>>>0>r>>>0;);if(w=w+2|0,!(w>>>0<m>>>0))break}}r:{if(!k)break r;if(l=I<<1,S){for(n=g0>>>0>8?l:I,r=0;l&&z((g(r,d)<<1)+G|0,(g(r,B)<<1)+q|0,l),n&&z(g(r,r0)+j|0,g(r,C0)+V0|0,n),r=r+1|0,(k|0)!=(r|0););break r}if(r=0,(k|0)!=1)for(s=k&-2,n=0;h=!l,h||z((g(r,d)<<1)+G|0,(g(r,B)<<1)+q|0,l),h||(h=r|1,z((g(h,d)<<1)+G|0,(g(B,h)<<1)+q|0,l)),r=r+2|0,n=n+2|0,(s|0)!=(n|0););if(!(k&1)|!l)break r;z((g(r,d)<<1)+G|0,(g(r,B)<<1)+q|0,l)}t[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=o;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=e+128|0}function qv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0;n=v-272|0,v=n,S2(n+252|0,e,r),t[n+271|0]<0&&Z(i[n+260>>2]);i:{if(u[e+97|0]<=1){for(g0=e+104|0,B=A+8|0,V=i[19543],E=V-12|0,R=i[19544]-12|0,N=i[19547]-12|0,Y=i[19545],U=Y-12|0,x=n+40|0,j=n+52|0,_=n- -64|0,I=n+32|0,Q=n+28|0,O=n+84|0,S=i[19552],q=i[19551],d=i[19549],c=i[19548],A0=i[19546];;){e:{r:{f:{A:{k:{n:{t:{o:{l:{if(i[r+16>>2]){if(i[n+192>>2]=92500,i[n+224>>2]=0,i[n+216>>2]=0,i[n+220>>2]=0,i[n+208>>2]=0,i[n+212>>2]=0,i[n+200>>2]=0,i[n+204>>2]=0,i[n+244>>2]=0,i[n+236>>2]=0,i[n+240>>2]=0,Wi(n+168|0,n+192|0,r),i[n+168>>2]!=i[28728]){k=i[n+172>>2],i[A>>2]=i[n+168>>2],i[A+4>>2]=k,i[B+8>>2]=i[n+184>>2],k=i[n+180>>2],i[B>>2]=i[n+176>>2],i[B+4>>2]=k,i[n+176>>2]=0,i[n+180>>2]=0,i[n+184>>2]=0,k=0;break e}if(t0=u[e+97|0]?32:16,X0=n,V0=gt(r,t0),i[X0+232>>2]=V0,h=w2(r),!h){k=C(56),i[n+20>>2]=k,i[n+24>>2]=48,i[n+28>>2]=-2147483592,o=u[26442]|u[26443]<<8|(u[26444]<<16|u[26445]<<24),l=u[26438]|u[26439]<<8|(u[26440]<<16|u[26441]<<24),t[k|0]=l,t[k+1|0]=l>>>8,t[k+2|0]=l>>>16,t[k+3|0]=l>>>24,t[k+4|0]=o,t[k+5|0]=o>>>8,t[k+6|0]=o>>>16,t[k+7|0]=o>>>24,t[k+48|0]=0,o=u[26482]|u[26483]<<8|(u[26484]<<16|u[26485]<<24),l=u[26478]|u[26479]<<8|(u[26480]<<16|u[26481]<<24),t[k+40|0]=l,t[k+41|0]=l>>>8,t[k+42|0]=l>>>16,t[k+43|0]=l>>>24,t[k+44|0]=o,t[k+45|0]=o>>>8,t[k+46|0]=o>>>16,t[k+47|0]=o>>>24,o=u[26474]|u[26475]<<8|(u[26476]<<16|u[26477]<<24),l=u[26470]|u[26471]<<8|(u[26472]<<16|u[26473]<<24),t[k+32|0]=l,t[k+33|0]=l>>>8,t[k+34|0]=l>>>16,t[k+35|0]=l>>>24,t[k+36|0]=o,t[k+37|0]=o>>>8,t[k+38|0]=o>>>16,t[k+39|0]=o>>>24,o=u[26466]|u[26467]<<8|(u[26468]<<16|u[26469]<<24),l=u[26462]|u[26463]<<8|(u[26464]<<16|u[26465]<<24),t[k+24|0]=l,t[k+25|0]=l>>>8,t[k+26|0]=l>>>16,t[k+27|0]=l>>>24,t[k+28|0]=o,t[k+29|0]=o>>>8,t[k+30|0]=o>>>16,t[k+31|0]=o>>>24,o=u[26458]|u[26459]<<8|(u[26460]<<16|u[26461]<<24),l=u[26454]|u[26455]<<8|(u[26456]<<16|u[26457]<<24),t[k+16|0]=l,t[k+17|0]=l>>>8,t[k+18|0]=l>>>16,t[k+19|0]=l>>>24,t[k+20|0]=o,t[k+21|0]=o>>>8,t[k+22|0]=o>>>16,t[k+23|0]=o>>>24,o=u[26450]|u[26451]<<8|(u[26452]<<16|u[26453]<<24),l=u[26446]|u[26447]<<8|(u[26448]<<16|u[26449]<<24),t[k+8|0]=l,t[k+9|0]=l>>>8,t[k+10|0]=l>>>16,t[k+11|0]=l>>>24,t[k+12|0]=o,t[k+13|0]=o>>>8,t[k+14|0]=o>>>16,t[k+15|0]=o>>>24,a(A,2,0,n+20|0),t[n+31|0]<0&&Z(i[n+20>>2]),k=0;break e}if(o=0,k=i[f+28>>2],!(!k|k>>>0>=h>>>0)){i[n+112>>2]=0,i[n+20>>2]=Y,i[n+84>>2]=78164,i[n+28>>2]=78144,k=n+20|0,i[k+i[U>>2]>>2]=A0,i[n+24>>2]=0,o=k+i[i[n+20>>2]-12>>2]|0,J0(o,I),t[o+80|0]=0,i[o+72>>2]=0,i[i[N>>2]+Q>>2]=c,i[k+i[R>>2]>>2]=d,i[n+84>>2]=78164,i[n+20>>2]=78124,i[n+28>>2]=78144,s=R0(I),i[s>>2]=77200,i[_+8>>2]=0,i[_+12>>2]=0,i[_>>2]=0,i[_+4>>2]=0,i[n+80>>2]=24,F(B0(F(B0(F(Q,30292,34),h),32153,33),i[f+28>>2]),26474,12),k=i[n+80>>2];u:{if(k&16){if(k=j,o=i[n+76>>2],l=i[n+56>>2],o>>>0>=l>>>0)break u;i[n+76>>2]=l,o=l;break u}if(!(k&8)){k=0,t[n+19|0]=0,o=n+8|0;break r}o=i[n+48>>2],k=x}if(l=i[k>>2],k=o-l|0,k>>>0>=2147483640)break l;if(k>>>0>=11){h=k|7,o=C(h+1|0),i[n+16>>2]=h-2147483647,i[n+8>>2]=o,i[n+12>>2]=k;break f}if(t[n+19|0]=k,o=n+8|0,k)break f;k=0;break r}for(;;){if(!i[r+16>>2]){i[n+112>>2]=0,i[n+20>>2]=Y,i[n+84>>2]=78164,i[n+28>>2]=78144,k=n+20|0,i[k+i[U>>2]>>2]=A0,i[n+24>>2]=0,l=k+i[i[n+20>>2]-12>>2]|0,J0(l,I),t[l+80|0]=0,i[l+72>>2]=0,i[i[N>>2]+Q>>2]=c,i[k+i[R>>2]>>2]=d,i[n+84>>2]=78164,i[n+20>>2]=78124,i[n+28>>2]=78144,s=R0(I),i[s>>2]=77200,i[_+8>>2]=0,i[_+12>>2]=0,i[_>>2]=0,i[_+4>>2]=0,i[n+80>>2]=24,F(D0(F(B0(F(Q,31720,24),h),32752,34),o),26474,12),k=i[n+80>>2];u:{if(k&16){if(k=j,o=i[n+76>>2],l=i[n+56>>2],o>>>0>=l>>>0)break u;i[n+76>>2]=l,o=l;break u}if(!(k&8)){k=0,t[n+19|0]=0,o=n+8|0;break A}o=i[n+48>>2],k=x}if(l=i[k>>2],k=o-l|0,k>>>0>=2147483640)break o;if(k>>>0>=11){h=k|7,o=C(h+1|0),i[n+16>>2]=h-2147483647,i[n+8>>2]=o,i[n+12>>2]=k;break k}if(t[n+19|0]=k,o=n+8|0,k)break k;k=0;break A}k=gt(r,t0),s=k,l=i[n+240>>2],w=i[n+244>>2];u:{if(l>>>0<w>>>0){i[l>>2]=k,k=l+4|0;break u}if(G=i[n+236>>2],k=l-G|0,_0=k>>2,l=_0+1|0,l>>>0>=1073741824)break t;if(w=w-G|0,m=w>>1,w=w>>>0>=2147483644?1073741823:l>>>0<m>>>0?m:l,w){if(w>>>0>=1073741824)break n;l=C(w<<2)}else l=0;if(m=l+k|0,i[m>>2]=s,s=m-(_0<<2)|0,k&&z(s,G,k),i[n+244>>2]=l+(w<<2),k=m+4|0,i[n+240>>2]=k,i[n+236>>2]=s,!G)break u;Z(G)}if(i[n+240>>2]=k,o=o+1|0,(h|0)==(o|0))break}k=i[e+108>>2];u:{if(k>>>0<o0[e+112>>2]){xe(k,n+192|0),k=k+56|0;break u}k=r5(g0,n+192|0)}i[e+108>>2]=k,k=1;break e}if(vn(A,e),i[A>>2])break i;if(t[A+19|0]<0&&Z(i[A+8>>2]),u[r+20|0]==1){if(t[n+20|0]=0,t[n+31|0]=0,a(A,2,100,n+20|0),t[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,t[114931]>=0){A=i[28731],i[B>>2]=i[28730],i[B+4>>2]=A,i[B+8>>2]=i[28732];break i}T(B,i[28730],i[28731]);break i}I0(),M()}I0(),M()}s0(),M()}x0(),M()}if(!k)break A;z(o,l,k)}t[k+o|0]=0,a(A,2,100,n+8|0),t[n+19|0]<0&&Z(i[n+8>>2]),i[n+20>>2]=V,i[i[E>>2]+(n+20|0)>>2]=q,i[n+28>>2]=S,i[s>>2]=77200,t[n+75|0]<0&&Z(i[n+64>>2]),y0(s),Y0(O),k=0;break e}if(!k)break r;z(o,l,k)}t[k+o|0]=0,a(A,2,1e3,n+8|0),t[n+19|0]<0&&Z(i[n+8>>2]),i[n+20>>2]=V,i[i[E>>2]+(n+20|0)>>2]=q,i[n+28>>2]=S,i[s>>2]=77200,t[n+75|0]<0&&Z(i[n+64>>2]),y0(s),Y0(O),k=0}if(t[n+187|0]<0&&Z(i[n+176>>2]),o=i[n+236>>2],o&&(i[n+240>>2]=o,Z(o)),i[n+192>>2]=92500,o=i[n+212>>2],o&&(i[n+216>>2]=o,Z(o)),!k)break}break i}B1(A,e,12427)}v=n+272|0}function av(A,e,r,f,k,n){A=A|0,e=+e,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0;m=v-560|0,v=m,i[m+44>>2]=0,j2(+e),l=o2(1)|0,o2(0)|0;i:{if((l|0)<0){Y=1,U=3151,e=-e,j2(+e),l=o2(1)|0,o2(0)|0;break i}if(k&2048){Y=1,U=3154;break i}Y=k&1,U=Y?3157:3152,j=!Y}i:{if((l&2146435072)==2146435072){l=Y+3|0,W4(A,32,r,l,k&-65537),m4(A,U,Y),f=n&32,m4(A,e!=e?f?10084:21102:f?12364:21334,3),W4(A,32,r,l,k^8192),_=(r|0)>(l|0)?r:l;break i}R=m+16|0;e:{r:{f:{if(e=Fu(e,m+44|0),e=e+e,e!=0){if(l=i[m+44>>2],i[m+44>>2]=l-1,N=n|32,(N|0)!=97)break f;break e}if(N=n|32,(N|0)==97)break e;B=i[m+44>>2];break r}B=l-29|0,i[m+44>>2]=B,e=e*268435456}for(w=(f|0)<0?6:f,Q=(m+48|0)+((B|0)>=0?288:0)|0,l=Q;f=e<4294967295&e>=0?~~e>>>0:0,i[l>>2]=f,l=l+4|0,e=(e-+(f>>>0))*1e9,e!=0;);r:{if((B|0)<=0){h=B,o=l,s=Q;break r}for(s=Q,h=B;;){h=h>>>0>=29?29:h,o=l-4|0;f:{if(s>>>0>o>>>0)break f;for(G=0;f=i[o>>2],I=h&31,_=G,(h&63)>>>0>=32?(G=f<<I,f=0):(G=(1<<I)-1&f>>>32-I,f=f<<I),_=_+f|0,I=G+x|0,I=f>>>0>_>>>0?I+1|0:I,G=O1(_,I,1e9,0),O=o,S=_-L0(G,h0,1e9,0)|0,i[O>>2]=S,o=o-4|0,s>>>0<=o>>>0;);if(!I&_>>>0<1e9)break f;s=s-4|0,i[s>>2]=G}for(;o=l,s>>>0<o>>>0&&(l=o-4|0,!i[l>>2]););if(h=i[m+44>>2]-h|0,i[m+44>>2]=h,l=o,!((h|0)>0))break}}if((h|0)<0)for(E=((w+25>>>0)/9|0)+1|0,I=(N|0)==102;;){f=0-h|0,_=f>>>0>=9?9:f;r:{if(o>>>0<=s>>>0){l=i[s>>2]?0:4;break r}for(x=1e9>>>_|0,G=-1<<_^-1,h=0,l=s;f=i[l>>2],i[l>>2]=(f>>>_|0)+h,h=g(x,f&G),l=l+4|0,l>>>0<o>>>0;);if(l=i[s>>2]?0:4,!h)break r;i[o>>2]=h,o=o+4|0}if(h=_+i[m+44>>2]|0,i[m+44>>2]=h,s=l+s|0,f=I?Q:s,o=o-f>>2>(E|0)?f+(E<<2)|0:o,!((h|0)<0))break}h=0;r:{if(o>>>0<=s>>>0||(h=g(Q-s>>2,9),l=10,f=i[s>>2],f>>>0<10))break r;for(;h=h+1|0,l=g(l,10),f>>>0>=l>>>0;);}if(f=(w-((N|0)!=102?h:0)|0)-((N|0)==103&(w|0)!=0)|0,(f|0)<(g(o-Q>>2,9)-9|0)){if(l=(m+48|0)+((B|0)<0?-4092:-3804)|0,B=f+9216|0,f=(B|0)/9|0,_=l+(f<<2)|0,l=10,f=B-g(f,9)|0,(f|0)<=7)for(;l=g(l,10),f=f+1|0,(f|0)!=8;);B=i[_>>2],E=(B>>>0)/(l>>>0)|0,G=B-g(l,E)|0,f=_+4|0;r:{if(!G&(f|0)==(o|0))break r;f:{if(!(E&1)&&(e=9007199254740992,!(t[_-4|0]&1)|((l|0)!=1e9|s>>>0>=_>>>0)))break f;e=9007199254740994}if(V=(f|0)==(o|0)?1:1.5,f=l>>>1|0,V=f>>>0>G>>>0?.5:(f|0)==(G|0)?V:1.5,u[U|0]!=45|j||(V=-V,e=-e),f=B-G|0,i[_>>2]=f,e+V==e)break r;if(f=f+l|0,i[_>>2]=f,f>>>0>=1e9)for(;i[_>>2]=0,_=_-4|0,_>>>0<s>>>0&&(s=s-4|0,i[s>>2]=0),f=i[_>>2]+1|0,i[_>>2]=f,f>>>0>999999999;);if(h=g(Q-s>>2,9),l=10,f=i[s>>2],f>>>0<10)break r;for(;h=h+1|0,l=g(l,10),f>>>0>=l>>>0;);}f=_+4|0,o=f>>>0<o>>>0?f:o}for(;B=o,G=o>>>0<=s>>>0,!G&&(o=o-4|0,!i[o>>2]););r:{if((N|0)!=103){I=k&8;break r}if(l=w||1,f=(l|0)>(h|0)&(h|0)>-5,w=(f?h^-1:-1)+l|0,n=(f?-1:-2)+n|0,I=k&8,I)break r;o=-9;f:{if(G||(G=i[B-4>>2],!G)||(f=10,o=0,(G>>>0)%10|0))break f;for(;l=o,o=o+1|0,f=g(f,10),!((G>>>0)%(f>>>0)|0););o=l^-1}if(f=g(B-Q>>2,9),(n&-33)==70){I=0,f=(f+o|0)-9|0,f=(f|0)>0?f:0,w=(f|0)>(w|0)?w:f;break r}I=0,f=((f+h|0)+o|0)-9|0,f=(f|0)>0?f:0,w=(f|0)>(w|0)?w:f}if(_=-1,G=w|I,((G?2147483645:2147483646)|0)<(w|0))break i;x=(((G|0)!=0)+w|0)+1|0,l=n&-33;r:{if((l|0)==70){if((x^2147483647)<(h|0))break i;o=(h|0)>0?h:0;break r}if(f=h>>31,o=Ti((f^h)-f|0,0,R),(R-o|0)<=1)for(;o=o-1|0,t[o|0]=48,(R-o|0)<2;);if(E=o-2|0,t[E|0]=n,t[o-1|0]=(h|0)<0?45:43,o=R-E|0,(o|0)>(x^2147483647))break i}if(f=o+x|0,(f|0)>(Y^2147483647))break i;h=f+Y|0,W4(A,32,r,h,k),m4(A,U,Y),W4(A,48,r,h,k^65536);r:{f:{A:{if((l|0)==70){for(l=m+16|9,n=s>>>0>Q>>>0?Q:s,s=n;;){o=Ti(i[s>>2],0,l);k:{if((n|0)!=(s|0)){if(m+16>>>0>=o>>>0)break k;for(;o=o-1|0,t[o|0]=48,m+16>>>0<o>>>0;);break k}if((o|0)!=(l|0))break k;o=o-1|0,t[o|0]=48}if(m4(A,o,l-o|0),s=s+4|0,!(Q>>>0>=s>>>0))break}if(G&&m4(A,29392,1),(w|0)<=0|s>>>0>=B>>>0)break A;for(;;){if(o=Ti(i[s>>2],0,l),o>>>0>m+16>>>0)for(;o=o-1|0,t[o|0]=48,m+16>>>0<o>>>0;);if(m4(A,o,(w|0)>=9?9:w),o=w-9|0,s=s+4|0,B>>>0<=s>>>0)break f;if(f=(w|0)>9,w=o,!f)break}break f}k:{if((w|0)<0)break k;for(n=s>>>0<B>>>0?B:s+4|0,B=m+16|9,l=s;;){o=Ti(i[l>>2],0,B),(B|0)==(o|0)&&(o=o-1|0,t[o|0]=48);n:{if((l|0)!=(s|0)){if(m+16>>>0>=o>>>0)break n;for(;o=o-1|0,t[o|0]=48,m+16>>>0<o>>>0;);break n}if(m4(A,o,1),o=o+1|0,!(w|I))break n;m4(A,29392,1)}if(f=B-o|0,m4(A,o,(f|0)<(w|0)?f:w),w=w-f|0,l=l+4|0,n>>>0<=l>>>0)break k;if(!((w|0)>=0))break}}W4(A,48,w+18|0,18,0),m4(A,E,R-E|0);break r}o=w}W4(A,48,o+9|0,9,0)}W4(A,32,r,h,k^8192),_=(r|0)>(h|0)?r:h;break i}w=(n<<26>>31&9)+U|0;e:{if(f>>>0>11)break e;for(o=12-f|0,V=16;V=V*16,o=o-1|0,!!o;);if(u[w|0]==45){e=-(V+(-e-V));break e}e=e+V-V}for(l=i[m+44>>2],o=l>>31,o=Ti((o^l)-o|0,0,R),(R|0)==(o|0)&&(o=o-1|0,t[o|0]=48,l=i[m+44>>2]),Q=Y|2,s=n&32,B=o-2|0,t[B|0]=n+15,t[o-1|0]=(l|0)<0?45:43,o=!(k&8)&(f|0)<=0,l=m+16|0;n=l,h=B2(e)<2147483647?~~e:-2147483648,t[l|0]=s|u[h+76240|0],e=(e-+(h|0))*16,l=l+1|0,o&e==0|(l-(m+16|0)|0)!=1||(t[n+1|0]=46,l=n+2|0),e!=0;);if(_=-1,o=R-B|0,n=o+Q|0,(2147483645-n|0)<(f|0))break i;h=n,n=m+16|0,s=l-n|0,f=f&&(s-2|0)<(f|0)?f+2|0:s,l=h+f|0,W4(A,32,r,l,k),m4(A,w,Q),W4(A,48,r,l,k^65536),m4(A,n,s),W4(A,48,f-s|0,0,0),m4(A,B,o),W4(A,32,r,l,k^8192),_=(r|0)>(l|0)?r:l}return v=m+560|0,_|0}function S6(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;l=v-48|0,v=l,o=v-16|0,v=o,n=e,hn(e),e=i[e+36>>2],i[e+108>>2]==1853189228&&(i[e+108>>2]=1885954932);i:{if(i[n+104>>2])break i;e=C(128),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=96068,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[e+16>>2]=93416,i[e+32>>2]=1885959277,i[e+120>>2]=0,i[n+104>>2]=f,k=i[n+108>>2],i[n+108>>2]=e;e:{r:{if(!k){k=i[n+44>>2],i[o+12>>2]=e,i[o+8>>2]=f;break r}if(e=i[k+4>>2],i[k+4>>2]=e-1,e||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[n+44>>2],f=i[n+104>>2],e=i[n+108>>2],i[o+12>>2]=e,i[o+8>>2]=f,!e)break e}i[e+4>>2]=i[e+4>>2]+1}if(P0(k+36|0,o+8|0),f=i[o+12>>2],!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break i;W[i[i[f>>2]+8>>2]](f),y(f)}i:{if(i[n+112>>2])break i;e=C(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=96228,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,t[e+112|0]=0,i[e+16>>2]=93656,i[e+32>>2]=1768977008,i[n+112>>2]=f,k=i[n+116>>2],i[n+116>>2]=e;e:{r:{if(!k){k=i[n+44>>2],i[o+12>>2]=e,i[o+8>>2]=f;break r}if(e=i[k+4>>2],i[k+4>>2]=e-1,e||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[n+44>>2],f=i[n+112>>2],e=i[n+116>>2],i[o+12>>2]=e,i[o+8>>2]=f,!e)break e}i[e+4>>2]=i[e+4>>2]+1}if(P0(k+36|0,o+8|0),f=i[o+12>>2],!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break i;W[i[i[f>>2]+8>>2]](f),y(f)}i:{if(i[n+120>>2])break i;e=C(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=96268,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,t[e+112|0]=0,i[e+16>>2]=93736,i[e+32>>2]=1768973167,i[n+120>>2]=f,k=i[n+124>>2],i[n+124>>2]=e;e:{r:{if(!k){k=i[n+112>>2],i[o+12>>2]=e,i[o+8>>2]=f;break r}if(e=i[k+4>>2],i[k+4>>2]=e-1,e||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[n+112>>2],f=i[n+120>>2],e=i[n+124>>2],i[o+12>>2]=e,i[o+8>>2]=f,!e)break e}i[e+4>>2]=i[e+4>>2]+1}if(P0(k+36|0,o+8|0),f=i[o+12>>2],!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break i;W[i[i[f>>2]+8>>2]](f),y(f)}i:{if(i[n+128>>2])break i;e=C(136),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=96308,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[e+16>>2]=93884,i[e+128>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1768975713,i[n+128>>2]=f,k=i[n+132>>2],i[n+132>>2]=e;e:{r:{if(!k){k=i[n+112>>2],i[o+12>>2]=e,i[o+8>>2]=f;break r}if(e=i[k+4>>2],i[k+4>>2]=e-1,e||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[n+112>>2],f=i[n+128>>2],e=i[n+132>>2],i[o+12>>2]=e,i[o+8>>2]=f,!e)break e}i[e+4>>2]=i[e+4>>2]+1}if(P0(k+36|0,o+8|0),f=i[o+12>>2],!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=o+16|0,QA(l+8|0,n+172|0,0);i:{e:{r:{f:switch(o=u[l+28|0],o|0){case 0:break e;case 1:break r;default:break f}e2(),M()}if(e=i[l+12>>2],i[A>>2]=i[l+8>>2],i[A+4>>2]=e,r=A+8|0,t[l+27|0]>=0){e=i[l+20>>2],i[r>>2]=i[l+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[l+24>>2];break i}T(r,i[l+16>>2],i[l+20>>2]);break i}s=i[l+8>>2],f=C(184),e=f,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=96188,h=e+16|0,e=h,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,X[f+112>>1]=0,i[e>>2]=93496,i[f+128>>2]=0,i[f+132>>2]=0,X[f+124>>1]=0,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,i[f+160>>2]=0,i[f+164>>2]=0,i[f+168>>2]=0,i[f+172>>2]=0,t[f+173|0]=0,t[f+174|0]=0,t[f+175|0]=0,t[f+176|0]=0,t[f+177|0]=0,t[f+178|0]=0,t[f+179|0]=0,t[f+180|0]=0,i[f+120>>2]=s,i[f+32>>2]=1768842853,t[e+164|0]=0,i[e+100>>2]=i[e+100>>2]&-2,i[f+128>>2]=r,e=i[n+140>>2];e:{r:{if(!e){k=n+140|0,r=k;break r}for(;;){if(r=e,k=i[e+16>>2],k>>>0>s>>>0){if(k=e,e=i[e>>2],e)continue;break r}if(k>>>0>=s>>>0)break e;if(e=i[r+4>>2],!e)break}k=r+4|0}e=C(28),i[e+20>>2]=0,i[e+24>>2]=0,i[e+16>>2]=s,i[e+8>>2]=r,i[e>>2]=0,i[e+4>>2]=0,i[k>>2]=e,r=i[i[n+136>>2]>>2],r&&(i[n+136>>2]=r),G1(i[n+140>>2],e),i[n+144>>2]=i[n+144>>2]+1}i[f+4>>2]=i[f+4>>2]+1,i[e+20>>2]=h,r=i[e+24>>2],i[e+24>>2]=f;e:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break e;W[i[i[r>>2]+8>>2]](r),y(r)}e=i[n+88>>2],i[l+44>>2]=f,i[l+40>>2]=h,i[f+4>>2]=i[f+4>>2]+1,P0(e+36|0,l+40|0),r=i[l+44>>2];e:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break e;W[i[i[r>>2]+8>>2]](r),y(r)}i[A+4>>2]=f,i[A>>2]=h}t[A+20|0]=o,e=u[l+28|0],(e|0)!=255&&(A=i[25327],i[l+40>>2]=i[25326],i[l+44>>2]=A,W[i[(l+40|0)+(e<<2)>>2]](l+39|0,l+8|0)),v=l+48|0}function q9(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0;I=v-48|0,v=I,j2(+A),w=o2(1)|0,r=o2(0)|0;i:{e:{l=w&2147483647;r:{if(l>>>0<=1074752122){if((w&1048575)==598523)break r;if(l>>>0<=1073928572){if((w|0)>0|(w|0)>=0){A=A+-1.5707963267341256,k=A+-6077100506506192e-26,u0[e>>3]=k,u0[e+8>>3]=A-k+-6077100506506192e-26,f=1;break i}A=A+1.5707963267341256,k=A+6077100506506192e-26,u0[e>>3]=k,u0[e+8>>3]=A-k+6077100506506192e-26,f=-1;break i}if((w|0)>0|(w|0)>=0){A=A+-3.1415926534682512,k=A+-12154201013012384e-26,u0[e>>3]=k,u0[e+8>>3]=A-k+-12154201013012384e-26,f=2;break i}A=A+3.1415926534682512,k=A+12154201013012384e-26,u0[e>>3]=k,u0[e+8>>3]=A-k+12154201013012384e-26,f=-2;break i}if(l>>>0<=1075594811){if(l>>>0<=1075183036){if((l|0)==1074977148)break r;if((w|0)>0|(w|0)>=0){A=A+-4.712388980202377,k=A+-18231301519518578e-26,u0[e>>3]=k,u0[e+8>>3]=A-k+-18231301519518578e-26,f=3;break i}A=A+4.712388980202377,k=A+18231301519518578e-26,u0[e>>3]=k,u0[e+8>>3]=A-k+18231301519518578e-26,f=-3;break i}if((l|0)==1075388923)break r;if((w|0)>0|(w|0)>=0){A=A+-6.2831853069365025,k=A+-2430840202602477e-25,u0[e>>3]=k,u0[e+8>>3]=A-k+-2430840202602477e-25,f=4;break i}A=A+6.2831853069365025,k=A+2430840202602477e-25,u0[e>>3]=k,u0[e+8>>3]=A-k+2430840202602477e-25,f=-4;break i}if(l>>>0>1094263290)break e}h=A*.6366197723675814+6755399441055744+-6755399441055744,B2(h)<2147483647?f=~~h:f=-2147483648,k=A+h*-1.5707963267341256,B=h*6077100506506192e-26,R=k-B;r:{if(R<-.7853981633974483){f=f-1|0,h=h+-1,B=h*6077100506506192e-26,k=A+h*-1.5707963267341256;break r}if(!(R>.7853981633974483))break r;f=f+1|0,h=h+1,B=h*6077100506506192e-26,k=A+h*-1.5707963267341256}A=k-B,u0[e>>3]=A,j2(+A),r=o2(1)|0,o2(0)|0,w=l>>>20|0;r:{if((w-(r>>>20&2047)|0)<17||(B=k,A=h*6077100506303966e-26,k=k-A,B=h*20222662487959506e-37-(B-k-A),A=k-B,u0[e>>3]=A,j2(+A),r=o2(1)|0,o2(0)|0,(w-(r>>>20&2047)|0)<50))break r;B=k,A=h*20222662487111665e-37,k=k-A,B=h*84784276603689e-45-(B-k-A),A=k-B,u0[e>>3]=A}u0[e+8>>3]=k-A-B;break i}if(l>>>0>=2146435072){A=A-A,u0[e>>3]=A,u0[e+8>>3]=A;break i}for(f=I+16|0,n=f|8,T2(0,r|0),T2(1,w&1048575|1096810496),A=+s1(),r=1;k=+((B2(A)<2147483647?~~A:-2147483648)|0),u0[f>>3]=k,A=(A-k)*16777216,_=r,r=0,f=n,!!_;);for(u0[I+32>>3]=A,f=2;r=f,f=r-1|0,Y=I+16|0,u0[Y+(r<<3)>>3]==0;);if(n=0,o=v-560|0,v=o,f=(l>>>20|0)-1046|0,_=(f-3|0)/24|0,E=(_|0)>0?_:0,Q=g(E,-24)+f|0,_=i[17669],V=r+1|0,s=V-1|0,(_+s|0)>=0)for(f=_+V|0,r=E-s|0;u0[(o+320|0)+(n<<3)>>3]=(r|0)<0?0:+i[(r<<2)+70688>>2],r=r+1|0,n=n+1|0,(f|0)!=(n|0););for(l=Q-24|0,f=0,n=(_|0)>0?_:0,G=(V|0)<=0;;){e:{if(G){A=0;break e}for(m=f+s|0,r=0,A=0;A=u0[(r<<3)+Y>>3]*u0[(o+320|0)+(m-r<<3)>>3]+A,r=r+1|0,(V|0)!=(r|0););}if(u0[(f<<3)+o>>3]=A,r=(f|0)==(n|0),f=f+1|0,!!r)break}j=47-Q|0,N=48-Q|0,O=Q-25|0,f=_;e:{for(;;){if(A=u0[(f<<3)+o>>3],r=0,n=f,(f|0)>0)for(;G=(o+480|0)+(r<<2)|0,k=A*5960464477539063e-23,B2(k)<2147483647?s=~~k:s=-2147483648,k=+(s|0),A=k*-16777216+A,B2(A)<2147483647?s=~~A:s=-2147483648,i[G>>2]=s,n=n-1|0,A=u0[(n<<3)+o>>3]+k,r=r+1|0,(f|0)!=(r|0););A=_4(A,l),A=A+HB(A*.125)*-8,B2(A)<2147483647?G=~~A:G=-2147483648,A=A-+(G|0);r:{f:{A:{U=(l|0)<=0;k:{if(!U){n=(f<<2)+o|0,s=i[n+476>>2],r=s>>N,m=n,n=s-(r<<N)|0,i[m+476>>2]=n,G=r+G|0,s=n>>j;break k}if(l)break A;s=i[((f<<2)+o|0)+476>>2]>>23}if((s|0)<=0)break r;break f}if(s=2,A>=.5)break f;s=0;break r}if(r=0,m=0,n=1,(f|0)>0)for(;;){n=(o+480|0)+(r<<2)|0,x=i[n>>2];f:{A:{if(m)m=16777215;else{if(!x)break A;m=16777216}i[n>>2]=m-x,m=1,n=0;break f}m=0,n=1}if(r=r+1|0,(f|0)==(r|0))break}f:{if(U)break f;r=8388607;A:switch(O|0){case 1:r=4194303;break;case 0:break A;default:break f}m=(f<<2)+o|0,i[m+476>>2]=i[m+476>>2]&r}if(G=G+1|0,(s|0)!=2||(A=1-A,s=2,n))break r;A=A-_4(1,l)}if(A==0){n=0;r:{if(r=f,(_|0)>=(r|0))break r;for(;r=r-1|0,n=i[(o+480|0)+(r<<2)>>2]|n,(r|0)>(_|0););if(!n)break r;for(;l=l-24|0,f=f-1|0,!i[(o+480|0)+(f<<2)>>2];);break e}for(r=1;n=r,r=r+1|0,!i[(o+480|0)+(_-n<<2)>>2];);for(n=f+n|0;;){if(s=f+V|0,f=f+1|0,u0[(o+320|0)+(s<<3)>>3]=i[(E+f<<2)+70688>>2],r=0,A=0,(V|0)>0)for(;A=u0[(r<<3)+Y>>3]*u0[(o+320|0)+(s-r<<3)>>3]+A,r=r+1|0,(V|0)!=(r|0););if(u0[(f<<3)+o>>3]=A,!((f|0)<(n|0)))break}f=n;continue}break}A=_4(A,24-Q|0);r:{if(A>=16777216){l=(o+480|0)+(f<<2)|0,k=A*5960464477539063e-23,B2(k)<2147483647?r=~~k:r=-2147483648,A=+(r|0)*-16777216+A,B2(A)<2147483647?n=~~A:n=-2147483648,i[l>>2]=n,f=f+1|0,l=Q;break r}r=B2(A)<2147483647?~~A:-2147483648}i[(o+480|0)+(f<<2)>>2]=r}if(A=_4(1,l),(f|0)>=0){for(r=f;n=r,u0[(r<<3)+o>>3]=A*+i[(o+480|0)+(r<<2)>>2],r=r-1|0,A=A*5960464477539063e-23,!!n;);for(n=f;;){if(A=0,r=0,l=f-n|0,Q=(l|0)>(_|0)?_:l,(Q|0)>=0)for(;A=u0[(r<<3)+73456>>3]*u0[(r+n<<3)+o>>3]+A,V=(r|0)!=(Q|0),r=r+1|0,!!V;);if(u0[(o+160|0)+(l<<3)>>3]=A,r=(n|0)>0,n=n-1|0,!r)break}}if(A=0,(f|0)>=0)for(r=f;n=r,r=r-1|0,A=A+u0[(o+160|0)+(n<<3)>>3],!!n;);if(u0[I>>3]=s?-A:A,A=u0[o+160>>3]-A,r=1,(f|0)>0)for(;A=A+u0[(o+160|0)+(r<<3)>>3],n=(r|0)!=(f|0),r=r+1|0,!!n;);if(u0[I+8>>3]=s?-A:A,v=o+560|0,f=G&7,A=u0[I>>3],(w|0)<0){u0[e>>3]=-A,u0[e+8>>3]=-u0[I+8>>3],f=0-f|0;break i}u0[e>>3]=A,u0[e+8>>3]=u0[I+8>>3]}return v=I+48|0,f}function Kv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0;e=v-128|0,v=e,n=K0(i[r>>2],0),s=K0(i[r>>2],1),h=K0(i[r>>2],2),j=$2(i[r>>2],6),j&&(c=K0(i[r>>2],6));i:{if(!(!(n>>>0<9|s>>>0<9)&h>>>0>8)){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}if(!((n|0)==(s|0)&(n|0)==(h|0))){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}f=i[r>>2],k=i[f+192>>2],_=i[f+188>>2],f=C(248),i[f>>2]=101168,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,o=f+12|0,i[f+176>>2]=o,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(o,_,k,0,3),a0(e+56|0,o,0,_,k,n,l,0),a0(e+32|0,o,1,_,k,s,l,0),n=e+88|0;e:{if(i[e+56>>2]){if(s=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=s,t[e+75|0]>=0){s=e- -64|0,B=i[s+4>>2],i[n>>2]=i[s>>2],i[n+4>>2]=B,i[n+8>>2]=i[s+8>>2];break e}T(n,i[e+64>>2],i[e+68>>2]);break e}if(s=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=s,t[e+51|0]>=0){s=i[e+44>>2],i[n>>2]=i[e+40>>2],i[n+4>>2]=s,i[n+8>>2]=i[e+48>>2];break e}T(n,i[e+40>>2],i[e+44>>2])}a0(e+8|0,o,2,_,k,h,l,0),s=e+112|0;e:{if(i[e+80>>2]){if(h=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=h,t[e+99|0]>=0){h=i[n+4>>2],i[s>>2]=i[n>>2],i[s+4>>2]=h,i[s+8>>2]=i[n+8>>2];break e}T(s,i[e+88>>2],i[e+92>>2]);break e}if(n=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=n,t[e+27|0]>=0){n=i[e+20>>2],i[s>>2]=i[e+16>>2],i[s+4>>2]=n,i[s+8>>2]=i[e+24>>2];break e}T(s,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[s+4>>2],i[r>>2]=i[s>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!j)break r;if(a0(e+104|0,o,6,_,k,c,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}l=0,n=Q0(i[r>>2],0),n?(O=i[n+40>>2],R=i[n+52>>2]>>>1|0):R=0,n=Q0(i[r>>2],1),n?(l=i[n+52>>2]>>>1|0,s=i[n+40>>2]):s=0,n=Q0(i[r>>2],2),n?(N=i[n+40>>2],n=i[n+52>>2]>>>1|0):n=0,h=Q0(o,0),h?(S=i[h+52>>2]>>>1|0,U=i[h+40>>2]):U=0,h=Q0(o,1);r:{if(!h){h=0;break r}Q=i[h+52>>2]>>>1|0,h=i[h+40>>2]}B=Q0(o,2),B?(V=i[B+52>>2]>>>1|0,B=i[B+40>>2]):B=0,x=0;r:{if(!j||(r=Q0(i[r>>2],6),r?(g0=i[r+40>>2],r=i[r+52>>2]):r=0,X0=r,r=Q0(o,6),x=0,!r))break r;V0=i[r+52>>2],x=i[r+40>>2]}r:{f:{A:{if(k){if(r=0,(k|0)!=1)for(m=k&-2;X[h+(g(r,Q)<<1)>>1]=p[(g(r,l)<<1)+s>>1],X[B+(g(r,V)<<1)>>1]=p[(g(r,n)<<1)+N>>1],G=r|1,X[h+(g(G,Q)<<1)>>1]=p[(g(l,G)<<1)+s>>1],X[B+(g(G,V)<<1)>>1]=p[(g(n,G)<<1)+N>>1],r=r+2|0,w=w+2|0,(m|0)!=(w|0););if(k&1&&(X[h+(g(r,Q)<<1)>>1]=p[(g(r,l)<<1)+s>>1],X[B+(g(r,V)<<1)>>1]=p[(g(r,n)<<1)+N>>1]),_&1)break f;break A}if(_&1)break r}if(!k)break r;if(w=(_+N|0)-2|0,G=(s+_|0)-2|0,r=_<<1,m=(r+B|0)-2|0,Y=(r+h|0)-2|0,r=0,(k|0)!=1)for(d=k&-2;X[Y+(g(r,Q)<<1)>>1]=p[G+(g(r,l)<<1)>>1],X[m+(g(r,V)<<1)>>1]=p[w+(g(r,n)<<1)>>1],E=r|1,X[Y+(g(E,Q)<<1)>>1]=p[G+(g(l,E)<<1)>>1],X[m+(g(V,E)<<1)>>1]=p[w+(g(n,E)<<1)>>1],r=r+2|0,q=q+2|0,(d|0)!=(q|0););if(!(k&1))break f;X[Y+(g(r,Q)<<1)>>1]=p[G+(g(r,l)<<1)>>1],X[m+(g(r,V)<<1)>>1]=p[w+(g(r,n)<<1)>>1]}if(Y=_-1|0,Y>>>0>=2)for(w=0;;){for(E=B+(g(w,V)<<1)|0,d=h+(g(w,Q)<<1)|0,q=(g(n,w)<<1)+N|0,C0=(g(l,w)<<1)+s|0,r=1;I=r&-2,m=I+q|0,G=p[m>>1],m=p[m+2>>1],A0=r<<1,t0=d+A0|0,I=I+C0|0,_0=p[I>>1],I=p[I+2>>1],X[t0>>1]=(g(_0,3)+I|0)+2>>>2,X[t0+2>>1]=(g(I,3)+_0|0)+2>>>2,I=E+A0|0,X[I+2>>1]=(G+g(m,3)|0)+2>>>2,X[I>>1]=(m+g(G,3)|0)+2>>>2,r=r+2|0,Y>>>0>r>>>0;);if(w=w+1|0,(w|0)==(k|0))break}if(n=_<<1,j){for(l=c>>>0>8?n:_,r=0;n&&z((g(r,S)<<1)+U|0,(g(r,R)<<1)+O|0,n),l&&z(g(r,V0)+x|0,g(r,X0)+g0|0,l),r=r+1|0,(k|0)!=(r|0););break r}if(r=0,(k|0)!=1)for(l=k&-2,w=0;s=!n,s||z((g(r,S)<<1)+U|0,(g(r,R)<<1)+O|0,n),s||(s=r|1,z((g(s,S)<<1)+U|0,(g(s,R)<<1)+O|0,n)),r=r+2|0,w=w+2|0,(l|0)!=(w|0););if(!(k&1)|!n)break r;z((g(r,S)<<1)+U|0,(g(r,R)<<1)+O|0,n)}t[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=o;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=e+128|0}function $v(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;l=v-48|0,v=l,k=v-96|0,v=k,A=i[A>>2],f=i[A+48>>2],s=i[A+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),n=l+12|0;i:{if(!r){r=v-48|0,v=r,o=i[A+48>>2],h=i[A+52>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),f=v-32|0,v=f,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,L1(f,o,e,f+20|0);e:{if(i[f>>2]){i[r+40>>2]=0,i[r+44>>2]=0;break e}r:{if(o=i[f+20>>2],A=i[f+24>>2],(o|0)!=(A|0)){if(e=i[o>>2],e&&(w=i[r+44>>2],e=Z0(e,92792,94184),e))break r;if(o=o+8|0,(A|0)!=(o|0))for(;;){if(e=i[o>>2],e&&(w=0,e=Z0(e,92792,94184),e))break r;if(o=o+8|0,(A|0)==(o|0))break}i[r+40>>2]=0,i[r+44>>2]=0}i[r+40>>2]=0,i[r+44>>2]=0;break e}if(i[r+44>>2]=w,i[r+40>>2]=e,A=i[o+4>>2],i[r+44>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1}if(t[f+19|0]<0&&Z(i[f+8>>2]),A=i[f+20>>2],A){if(o=i[f+24>>2],e=A,(o|0)!=(A|0)){for(;;){e=i[o-4>>2];e:{if(!e||(w=i[e+4>>2],i[e+4>>2]=w-1,w))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(o=o-8|0,(A|0)==(o|0))break}e=i[f+20>>2]}i[f+24>>2]=A,Z(e)}v=f+32|0,A=i[r+40>>2];e:{if(!A){A=C(32),i[r+4>>2]=A,i[r+8>>2]=26,i[r+12>>2]=-2147483616,e=u[10439]|u[10440]<<8,t[A+24|0]=e,t[A+25|0]=e>>>8,e=u[10435]|u[10436]<<8|(u[10437]<<16|u[10438]<<24),f=u[10431]|u[10432]<<8|(u[10433]<<16|u[10434]<<24),t[A+16|0]=f,t[A+17|0]=f>>>8,t[A+18|0]=f>>>16,t[A+19|0]=f>>>24,t[A+20|0]=e,t[A+21|0]=e>>>8,t[A+22|0]=e>>>16,t[A+23|0]=e>>>24,e=u[10427]|u[10428]<<8|(u[10429]<<16|u[10430]<<24),f=u[10423]|u[10424]<<8|(u[10425]<<16|u[10426]<<24),t[A+8|0]=f,t[A+9|0]=f>>>8,t[A+10|0]=f>>>16,t[A+11|0]=f>>>24,t[A+12|0]=e,t[A+13|0]=e>>>8,t[A+14|0]=e>>>16,t[A+15|0]=e>>>24,e=u[10419]|u[10420]<<8|(u[10421]<<16|u[10422]<<24),f=u[10415]|u[10416]<<8|(u[10417]<<16|u[10418]<<24),t[A|0]=f,t[A+1|0]=f>>>8,t[A+2|0]=f>>>16,t[A+3|0]=f>>>24,t[A+4|0]=e,t[A+5|0]=e>>>8,t[A+6|0]=e>>>16,t[A+7|0]=e>>>24,t[A+26|0]=0,A=a(r+16|0,2,116,r+4|0),e=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=e,e=n+8|0;r:{if(t[A+19|0]>=0){f=i[A+12>>2],i[e>>2]=i[A+8>>2],i[e+4>>2]=f,i[e+8>>2]=i[A+16>>2],t[n+20|0]=1;break r}if(T(e,i[A+8>>2],i[A+12>>2]),e=t[A+19|0],t[n+20|0]=1,(e|0)>=0)break r;Z(i[A+8>>2])}if(t[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}e=i[r+44>>2],t[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A}e:{if(!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break e;W[i[i[h>>2]+8>>2]](h),y(h)}v=r+48|0;break i}i[k+92>>2]=0,i[k+84>>2]=0,i[k+88>>2]=0,L1(k- -64|0,f,e,k+84|0);e:{if(i[k+64>>2]){A=i[k+68>>2],i[n>>2]=i[k+64>>2],i[n+4>>2]=A,A=n+8|0;r:{if(t[k+83|0]>=0){e=i[k+76>>2],i[A>>2]=i[k+72>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+80>>2];break r}T(A,i[k+72>>2],i[k+76>>2])}t[n+20|0]=1;break e}f=r-1|0,r=i[k+84>>2],f>>>0>=i[k+88>>2]-r>>3>>>0&&(A=C(32),i[k+24>>2]=A,i[k+28>>2]=27,i[k+32>>2]=-2147483616,e=u[15152]|u[15153]<<8|(u[15154]<<16|u[15155]<<24),r=u[15148]|u[15149]<<8|(u[15150]<<16|u[15151]<<24),t[A|0]=r,t[A+1|0]=r>>>8,t[A+2|0]=r>>>16,t[A+3|0]=r>>>24,t[A+4|0]=e,t[A+5|0]=e>>>8,t[A+6|0]=e>>>16,t[A+7|0]=e>>>24,t[A+27|0]=0,e=u[15171]|u[15172]<<8|(u[15173]<<16|u[15174]<<24),t[A+23|0]=e,t[A+24|0]=e>>>8,t[A+25|0]=e>>>16,t[A+26|0]=e>>>24,e=u[15168]|u[15169]<<8|(u[15170]<<16|u[15171]<<24),r=u[15164]|u[15165]<<8|(u[15166]<<16|u[15167]<<24),t[A+16|0]=r,t[A+17|0]=r>>>8,t[A+18|0]=r>>>16,t[A+19|0]=r>>>24,t[A+20|0]=e,t[A+21|0]=e>>>8,t[A+22|0]=e>>>16,t[A+23|0]=e>>>24,e=u[15160]|u[15161]<<8|(u[15162]<<16|u[15163]<<24),r=u[15156]|u[15157]<<8|(u[15158]<<16|u[15159]<<24),t[A+8|0]=r,t[A+9|0]=r>>>8,t[A+10|0]=r>>>16,t[A+11|0]=r>>>24,t[A+12|0]=e,t[A+13|0]=e>>>8,t[A+14|0]=e>>>16,t[A+15|0]=e>>>24,A=a(k+44|0,5,2007,k+24|0),t[A+19|0]<0&&Z(i[A+8>>2]),t[k+35|0]<0&&Z(i[k+24>>2]),r=i[k+84>>2]),e=r+(f<<3)|0,A=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{f:{if(!A||(A=Z0(A,92792,94184),!A))break f;e&&(i[e+4>>2]=i[e+4>>2]+1),t[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A;break r}A=C(24),i[k+12>>2]=A,i[k+16>>2]=19,i[k+20>>2]=-2147483624,r=u[13877]|u[13878]<<8|(u[13879]<<16|u[13880]<<24),t[A+15|0]=r,t[A+16|0]=r>>>8,t[A+17|0]=r>>>16,t[A+18|0]=r>>>24,r=u[13874]|u[13875]<<8|(u[13876]<<16|u[13877]<<24),f=u[13870]|u[13871]<<8|(u[13872]<<16|u[13873]<<24),t[A+8|0]=f,t[A+9|0]=f>>>8,t[A+10|0]=f>>>16,t[A+11|0]=f>>>24,t[A+12|0]=r,t[A+13|0]=r>>>8,t[A+14|0]=r>>>16,t[A+15|0]=r>>>24,r=u[13866]|u[13867]<<8|(u[13868]<<16|u[13869]<<24),f=u[13862]|u[13863]<<8|(u[13864]<<16|u[13865]<<24),t[A|0]=f,t[A+1|0]=f>>>8,t[A+2|0]=f>>>16,t[A+3|0]=f>>>24,t[A+4|0]=r,t[A+5|0]=r>>>8,t[A+6|0]=r>>>16,t[A+7|0]=r>>>24,t[A+19|0]=0,A=a(k+24|0,5,2007,k+12|0),r=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=r,r=n+8|0;f:{if(t[A+19|0]>=0){f=i[A+12>>2],i[r>>2]=i[A+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[A+16>>2],t[n+20|0]=1;break f}if(T(r,i[A+8>>2],i[A+12>>2]),r=t[A+19|0],t[n+20|0]=1,(r|0)>=0)break f;Z(i[A+8>>2])}if(t[k+23|0]>=0)break r;Z(i[k+12>>2])}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(t[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+84>>2],!A)break i;if(r=i[k+88>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];e:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+84>>2]}i[k+88>>2]=A,Z(e)}i:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}return v=k+96|0,A=-1,e=u[l+32|0],(e|0)!=255&&(A=e?A:i[i[l+12>>2]+100>>2],r=i[25799],i[l+40>>2]=i[25798],i[l+44>>2]=r,W[i[(l+40|0)+(e<<2)>>2]](l+39|0,l+12|0)),v=l+48|0,A|0}function dv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;l=v-48|0,v=l,k=v-96|0,v=k,A=i[A>>2],f=i[A+48>>2],s=i[A+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),n=l+12|0;i:{if(!r){r=v-48|0,v=r,o=i[A+48>>2],h=i[A+52>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),f=v-32|0,v=f,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,L1(f,o,e,f+20|0);e:{if(i[f>>2]){i[r+40>>2]=0,i[r+44>>2]=0;break e}r:{if(o=i[f+20>>2],A=i[f+24>>2],(o|0)!=(A|0)){if(e=i[o>>2],e&&(w=i[r+44>>2],e=Z0(e,92792,94104),e))break r;if(o=o+8|0,(A|0)!=(o|0))for(;;){if(e=i[o>>2],e&&(w=0,e=Z0(e,92792,94104),e))break r;if(o=o+8|0,(A|0)==(o|0))break}i[r+40>>2]=0,i[r+44>>2]=0}i[r+40>>2]=0,i[r+44>>2]=0;break e}if(i[r+44>>2]=w,i[r+40>>2]=e,A=i[o+4>>2],i[r+44>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1}if(t[f+19|0]<0&&Z(i[f+8>>2]),A=i[f+20>>2],A){if(o=i[f+24>>2],e=A,(o|0)!=(A|0)){for(;;){e=i[o-4>>2];e:{if(!e||(w=i[e+4>>2],i[e+4>>2]=w-1,w))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(o=o-8|0,(A|0)==(o|0))break}e=i[f+20>>2]}i[f+24>>2]=A,Z(e)}v=f+32|0,A=i[r+40>>2];e:{if(!A){A=C(32),i[r+4>>2]=A,i[r+8>>2]=26,i[r+12>>2]=-2147483616,e=u[10439]|u[10440]<<8,t[A+24|0]=e,t[A+25|0]=e>>>8,e=u[10435]|u[10436]<<8|(u[10437]<<16|u[10438]<<24),f=u[10431]|u[10432]<<8|(u[10433]<<16|u[10434]<<24),t[A+16|0]=f,t[A+17|0]=f>>>8,t[A+18|0]=f>>>16,t[A+19|0]=f>>>24,t[A+20|0]=e,t[A+21|0]=e>>>8,t[A+22|0]=e>>>16,t[A+23|0]=e>>>24,e=u[10427]|u[10428]<<8|(u[10429]<<16|u[10430]<<24),f=u[10423]|u[10424]<<8|(u[10425]<<16|u[10426]<<24),t[A+8|0]=f,t[A+9|0]=f>>>8,t[A+10|0]=f>>>16,t[A+11|0]=f>>>24,t[A+12|0]=e,t[A+13|0]=e>>>8,t[A+14|0]=e>>>16,t[A+15|0]=e>>>24,e=u[10419]|u[10420]<<8|(u[10421]<<16|u[10422]<<24),f=u[10415]|u[10416]<<8|(u[10417]<<16|u[10418]<<24),t[A|0]=f,t[A+1|0]=f>>>8,t[A+2|0]=f>>>16,t[A+3|0]=f>>>24,t[A+4|0]=e,t[A+5|0]=e>>>8,t[A+6|0]=e>>>16,t[A+7|0]=e>>>24,t[A+26|0]=0,A=a(r+16|0,2,116,r+4|0),e=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=e,e=n+8|0;r:{if(t[A+19|0]>=0){f=i[A+12>>2],i[e>>2]=i[A+8>>2],i[e+4>>2]=f,i[e+8>>2]=i[A+16>>2],t[n+20|0]=1;break r}if(T(e,i[A+8>>2],i[A+12>>2]),e=t[A+19|0],t[n+20|0]=1,(e|0)>=0)break r;Z(i[A+8>>2])}if(t[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}e=i[r+44>>2],t[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A}e:{if(!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break e;W[i[i[h>>2]+8>>2]](h),y(h)}v=r+48|0;break i}i[k+92>>2]=0,i[k+84>>2]=0,i[k+88>>2]=0,L1(k- -64|0,f,e,k+84|0);e:{if(i[k+64>>2]){A=i[k+68>>2],i[n>>2]=i[k+64>>2],i[n+4>>2]=A,A=n+8|0;r:{if(t[k+83|0]>=0){e=i[k+76>>2],i[A>>2]=i[k+72>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+80>>2];break r}T(A,i[k+72>>2],i[k+76>>2])}t[n+20|0]=1;break e}f=r-1|0,r=i[k+84>>2],f>>>0>=i[k+88>>2]-r>>3>>>0&&(A=C(32),i[k+24>>2]=A,i[k+28>>2]=27,i[k+32>>2]=-2147483616,e=u[15152]|u[15153]<<8|(u[15154]<<16|u[15155]<<24),r=u[15148]|u[15149]<<8|(u[15150]<<16|u[15151]<<24),t[A|0]=r,t[A+1|0]=r>>>8,t[A+2|0]=r>>>16,t[A+3|0]=r>>>24,t[A+4|0]=e,t[A+5|0]=e>>>8,t[A+6|0]=e>>>16,t[A+7|0]=e>>>24,t[A+27|0]=0,e=u[15171]|u[15172]<<8|(u[15173]<<16|u[15174]<<24),t[A+23|0]=e,t[A+24|0]=e>>>8,t[A+25|0]=e>>>16,t[A+26|0]=e>>>24,e=u[15168]|u[15169]<<8|(u[15170]<<16|u[15171]<<24),r=u[15164]|u[15165]<<8|(u[15166]<<16|u[15167]<<24),t[A+16|0]=r,t[A+17|0]=r>>>8,t[A+18|0]=r>>>16,t[A+19|0]=r>>>24,t[A+20|0]=e,t[A+21|0]=e>>>8,t[A+22|0]=e>>>16,t[A+23|0]=e>>>24,e=u[15160]|u[15161]<<8|(u[15162]<<16|u[15163]<<24),r=u[15156]|u[15157]<<8|(u[15158]<<16|u[15159]<<24),t[A+8|0]=r,t[A+9|0]=r>>>8,t[A+10|0]=r>>>16,t[A+11|0]=r>>>24,t[A+12|0]=e,t[A+13|0]=e>>>8,t[A+14|0]=e>>>16,t[A+15|0]=e>>>24,A=a(k+44|0,5,2007,k+24|0),t[A+19|0]<0&&Z(i[A+8>>2]),t[k+35|0]<0&&Z(i[k+24>>2]),r=i[k+84>>2]),e=r+(f<<3)|0,A=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{f:{if(!A||(A=Z0(A,92792,94104),!A))break f;e&&(i[e+4>>2]=i[e+4>>2]+1),t[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A;break r}A=C(24),i[k+12>>2]=A,i[k+16>>2]=19,i[k+20>>2]=-2147483624,r=u[13877]|u[13878]<<8|(u[13879]<<16|u[13880]<<24),t[A+15|0]=r,t[A+16|0]=r>>>8,t[A+17|0]=r>>>16,t[A+18|0]=r>>>24,r=u[13874]|u[13875]<<8|(u[13876]<<16|u[13877]<<24),f=u[13870]|u[13871]<<8|(u[13872]<<16|u[13873]<<24),t[A+8|0]=f,t[A+9|0]=f>>>8,t[A+10|0]=f>>>16,t[A+11|0]=f>>>24,t[A+12|0]=r,t[A+13|0]=r>>>8,t[A+14|0]=r>>>16,t[A+15|0]=r>>>24,r=u[13866]|u[13867]<<8|(u[13868]<<16|u[13869]<<24),f=u[13862]|u[13863]<<8|(u[13864]<<16|u[13865]<<24),t[A|0]=f,t[A+1|0]=f>>>8,t[A+2|0]=f>>>16,t[A+3|0]=f>>>24,t[A+4|0]=r,t[A+5|0]=r>>>8,t[A+6|0]=r>>>16,t[A+7|0]=r>>>24,t[A+19|0]=0,A=a(k+24|0,5,2007,k+12|0),r=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=r,r=n+8|0;f:{if(t[A+19|0]>=0){f=i[A+12>>2],i[r>>2]=i[A+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[A+16>>2],t[n+20|0]=1;break f}if(T(r,i[A+8>>2],i[A+12>>2]),r=t[A+19|0],t[n+20|0]=1,(r|0)>=0)break f;Z(i[A+8>>2])}if(t[k+23|0]>=0)break r;Z(i[k+12>>2])}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(t[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+84>>2],!A)break i;if(r=i[k+88>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];e:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+84>>2]}i[k+88>>2]=A,Z(e)}i:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}return v=k+96|0,A=-1,e=u[l+32|0],(e|0)!=255&&(A=e?A:i[i[l+12>>2]+100>>2],r=i[25801],i[l+40>>2]=i[25800],i[l+44>>2]=r,W[i[(l+40|0)+(e<<2)>>2]](l+39|0,l+12|0)),v=l+48|0,A|0}function bv(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;w=v-48|0,v=w;i:{e:{if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break e}if(!(n&&k)){if(t[w+32|0]=0,t[w+43|0]=0,r=A,A=a(w+8|0,5,2006,w+32|0),c0(r,A,i[e>>2]),t[A+19|0]<0&&Z(i[A+8>>2]),t[w+43|0]>=0)break e;Z(i[w+32>>2]);break e}if((k|n)>>>0>=65536){i[A>>2]=5,i[A+4>>2]=129,i[A+8>>2]=23118;break e}B=w+8|0,V=i[e>>2],s=v+-64|0,v=s,I=g(k,n);r:{if(I>>>16|0){r=C(32),i[s+48>>2]=r,i[s+52>>2]=31,i[s+56>>2]=-2147483616,f=u[30051]|u[30052]<<8|(u[30053]<<16|u[30054]<<24),k=u[30047]|u[30048]<<8|(u[30049]<<16|u[30050]<<24),t[r+23|0]=k,t[r+24|0]=k>>>8,t[r+25|0]=k>>>16,t[r+26|0]=k>>>24,t[r+27|0]=f,t[r+28|0]=f>>>8,t[r+29|0]=f>>>16,t[r+30|0]=f>>>24,f=u[30044]|u[30045]<<8|(u[30046]<<16|u[30047]<<24),k=u[30040]|u[30041]<<8|(u[30042]<<16|u[30043]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[30036]|u[30037]<<8|(u[30038]<<16|u[30039]<<24),k=u[30032]|u[30033]<<8|(u[30034]<<16|u[30035]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,f=u[30028]|u[30029]<<8|(u[30030]<<16|u[30031]<<24),k=u[30024]|u[30025]<<8|(u[30026]<<16|u[30027]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+31|0]=0,r=a(s+24|0,5,0,s+48|0),f=i[r+4>>2],i[B>>2]=i[r>>2],i[B+4>>2]=f,f=B+8|0;f:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[B+20|0]=1;break f}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[B+20|0]=1,(f|0)>=0)break f;Z(i[r+8>>2])}if(t[s+59|0]>=0)break r;Z(i[s+48>>2]);break r}m=r|f,G=m>>>0>65535,h=G?12:8,_=C(h),i[s+48>>2]=_,Q=h+_|0,i[s+56>>2]=Q,h&&l0(_,0,h),i[s+52>>2]=Q,t[_+3|0]=k-1,t[_+2|0]=n-1,t[_+1|0]=G,t[_|0]=0;f:{if(m>>>0>=65536){h=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),t[_+8|0]=h,t[_+9|0]=h>>>8,t[_+10|0]=h>>>16,t[_+11|0]=h>>>24,m=r>>>16|0,G=r>>>24|0,h=r;break f}G=r>>>8|0,m=r,h=f}t[_+7|0]=h,t[_+5|0]=m,t[_+4|0]=G,t[_+6|0]=h>>>8,m=i[V+48>>2],_=i[V+52>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),t5(s+24|0,m,1735551332);f:{A:switch(u[s+44|0]){default:e2(),M();case 1:r=i[s+28>>2],i[B>>2]=i[s+24>>2],i[B+4>>2]=r,r=B+8|0;k:{if(t[s+43|0]>=0){f=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=f,i[r+8>>2]=i[s+40>>2];break k}T(r,i[s+32>>2],i[s+36>>2])}t[B+20|0]=1;break f;case 0:break A}G=i[s+24>>2],h=C(600),i[h+4>>2]=0,i[h+8>>2]=0,i[h>>2]=107928,Q=a4(h+16|0,V,G),i[Q>>2]=108048,i[h+584>>2]=0,i[h+588>>2]=0,i[h+576>>2]=0,i[h+580>>2]=0,i[h+568>>2]=0,i[h+572>>2]=0,i[h+592>>2]=1,i[h+596>>2]=0,Y=Li(),i[h+596>>2]=Y,p3(Y,o),i[i[h+596>>2]+12>>2]=1,i[h+576>>2]=f,i[h+572>>2]=r,X[h+570>>1]=k,X[h+568>>1]=n,n=i[h+580>>2],k=i[h+584>>2]-n>>2;A:{if(k>>>0<I>>>0){T8(h+580|0,I-k|0);break A}if(k>>>0<=I>>>0)break A;i[h+584>>2]=n+(I<<2)}i[h+220>>2]=f,i[h+216>>2]=r,i[h+592>>2]=i[o+12>>2],i[s+12>>2]=h,i[s+8>>2]=Q,i[h+4>>2]=i[h+4>>2]+1,I3(V,G,s+8|0),k=i[s+12>>2];A:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break A;W[i[i[k>>2]+8>>2]](k),y(k)}w6(m,G,s+48|0,1),i[s+16>>2]=0,i[s+8>>2]=0,i[s+12>>2]=0,I&&T8(s+8|0,I),o8(m,G,1684630887,s+8|0),n=v-16|0,v=n,k=C(128),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=96348,o=k+16|0,i[o+8>>2]=0,i[o+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[k+16>>2]=93816,i[k+124>>2]=f,i[k+120>>2]=r,i[k+32>>2]=1769173093,r=i[m+120>>2],i[n+12>>2]=k,i[n+8>>2]=o,i[k+4>>2]=i[k+4>>2]+1,f=ni(r,n+8|0),r=i[n+12>>2];A:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break A;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=i[m+128>>2],X[n+6>>1]=f+1,t[n+4|0]=0,i[n>>2]=p[n+4>>1]|p[n+6>>1]<<16,U4(r,G,n),r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),v=n+16|0,t[B+20|0]=0,i[B+4>>2]=h,i[B>>2]=Q,r=i[s+8>>2],!r)break f;i[s+12>>2]=r,Z(r)}r=u[s+44|0],(r|0)!=255&&(f=i[27063],i[s+8>>2]=i[27062],i[s+12>>2]=f,W[i[(s+8|0)+(r<<2)>>2]](s+63|0,s+24|0));f:{if(!_||(r=i[_+4>>2],i[_+4>>2]=r-1,r))break f;W[i[i[_>>2]+8>>2]](_),y(_)}if(r=i[s+48>>2],!r)break r;i[s+52>>2]=r,Z(r)}v=s- -64|0;r:{f:switch(u[w+28|0]){case 1:c0(A,w+8|0,i[e>>2]);break r;case 0:break f;default:break i}f=i[e>>2];f:{if(i[f+40>>2]||(i[w+32>>2]=i[w+8>>2],r=i[w+12>>2],i[w+36>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),x3(f,w+32|0),r=i[w+36>>2],!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}f:{if(!l)break f;if(r=C(16),i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[l>>2]=r,u[w+28|0])break i;f=i[w+8>>2],k=i[w+12>>2];A:{if(!k){i[r+4>>2]=k,i[r>>2]=f;break A}if(i[k+4>>2]=i[k+4>>2]+1,i[r>>2]=f,f=i[r+4>>2],i[r+4>>2]=k,!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break A;W[i[i[f>>2]+8>>2]](f),y(f)}if(k=i[e>>2],r=i[l>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}if(A=u[w+28|0],(A|0)==255)break e;e=i[25861],i[w+32>>2]=i[25860],i[w+36>>2]=e,W[i[(w+32|0)+(A<<2)>>2]](w+47|0,w+8|0)}v=w+48|0;return}e2(),M()}function cv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0;if(f=X[e+22>>1],B=X[e+6>>1],w=X[e+30>>1],l=((g(f,-74)+g(B,74)|0)+g(w,74)|0)- -64>>7,l=(l|0)>=32767?32767:l,l=(l|0)<=-32768?-32768:l,n=X[e+20>>1],s=X[e+4>>1],o=X[e+28>>1],G=((g(n,-74)+g(s,74)|0)+g(o,74)|0)- -64>>7,G=(G|0)>=32767?32767:G,G=(G|0)<=-32768?-32768:G,V=X[e+18>>1],h=X[e+2>>1],m=X[e+26>>1],_=((g(V,-74)+g(h,74)|0)+g(m,74)|0)- -64>>7,_=(_|0)>=32767?32767:_,Y=(_|0)<=-32768?-32768:_,E=X[e+16>>1],R=X[e>>1],N=X[e+24>>1],_=((g(E,-74)+g(R,74)|0)+g(N,74)|0)- -64>>7,_=(_|0)>=32767?32767:_,_=(_|0)<=-32768?-32768:_,k=X[e+14>>1],I=(((g(k,-74)+g(B,84)|0)+g(f,55)|0)+g(w,-29)|0)- -64>>7,I=(I|0)>=32767?32767:I,I=(I|0)<=-32768?-32768:I,Q=g(k,74),k=(((Q+g(B,55)|0)+g(f,-29)|0)+g(w,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,k=(k|0)<=-32768?-32768:k,f=(((Q+g(B,29)|0)+g(f,84)|0)+g(w,55)|0)- -64>>7,f=(f|0)>=32767?32767:f,f=(f|0)<=-32768?-32768:f,w=X[e+12>>1],B=(((g(w,-74)+g(s,84)|0)+g(n,55)|0)+g(o,-29)|0)- -64>>7,B=(B|0)>=32767?32767:B,B=(B|0)<=-32768?-32768:B,Q=g(w,74),w=(((Q+g(s,55)|0)+g(n,-29)|0)+g(o,-84)|0)- -64>>7,w=(w|0)>=32767?32767:w,w=(w|0)<=-32768?-32768:w,n=(((Q+g(s,29)|0)+g(n,84)|0)+g(o,55)|0)- -64>>7,n=(n|0)>=32767?32767:n,n=(n|0)<=-32768?-32768:n,s=X[e+10>>1],o=(((g(s,-74)+g(h,84)|0)+g(V,55)|0)+g(m,-29)|0)- -64>>7,o=(o|0)>=32767?32767:o,Q=(o|0)<=-32768?-32768:o,s=g(s,74),o=(((s+g(h,55)|0)+g(V,-29)|0)+g(m,-84)|0)- -64>>7,o=(o|0)>=32767?32767:o,U=(o|0)<=-32768?-32768:o,s=(((s+g(h,29)|0)+g(V,84)|0)+g(m,55)|0)- -64>>7,s=(s|0)>=32767?32767:s,V=(s|0)<=-32768?-32768:s,s=X[e+8>>1],e=(((g(s,-74)+g(R,84)|0)+g(E,55)|0)+g(N,-29)|0)- -64>>7,e=(e|0)>=32767?32767:e,e=(e|0)<=-32768?-32768:e,o=g(s,74),s=(((o+g(R,55)|0)+g(E,-29)|0)+g(N,-84)|0)- -64>>7,s=(s|0)>=32767?32767:s,s=(s|0)<=-32768?-32768:s,o=(((o+g(R,29)|0)+g(E,84)|0)+g(N,55)|0)- -64>>7,o=(o|0)>=32767?32767:o,o=(o|0)<=-32768?-32768:o,(r|0)!=1){h=u[A+2|0]+(((g(n,-74)+g(o,74)|0)+g(f,74)|0)+2048>>12)|0,h=(h|0)>=255?255:h,t[A+2|0]=(h|0)>0?h:0,h=g(V,74),m=u[A|0]+((((h+g(o,29)|0)+g(n,84)|0)+g(f,55)|0)+2048>>12)|0,m=(m|0)>=255?255:m,t[A|0]=(m|0)>0?m:0,h=u[A+1|0]+((((h+g(o,55)|0)+g(n,-29)|0)+g(f,-84)|0)+2048>>12)|0,h=(h|0)>=255?255:h,t[A+1|0]=(h|0)>0?h:0,f=u[A+3|0]+((((g(V,-74)+g(o,84)|0)+g(n,55)|0)+g(f,-29)|0)+2048>>12)|0,f=(f|0)>=255?255:f,t[A+3|0]=(f|0)>0?f:0,f=A+r|0,o=g(U,74),n=u[f|0]+((((o+g(s,29)|0)+g(w,84)|0)+g(k,55)|0)+2048>>12)|0,n=(n|0)>=255?255:n,t[f|0]=(n|0)>0?n:0,n=u[f+1|0]+((((o+g(s,55)|0)+g(w,-29)|0)+g(k,-84)|0)+2048>>12)|0,n=(n|0)>=255?255:n,t[f+1|0]=(n|0)>0?n:0,n=u[f+2|0]+(((g(w,-74)+g(s,74)|0)+g(k,74)|0)+2048>>12)|0,n=(n|0)>=255?255:n,t[f+2|0]=(n|0)>0?n:0,k=u[f+3|0]+((((g(U,-74)+g(s,84)|0)+g(w,55)|0)+g(k,-29)|0)+2048>>12)|0,k=(k|0)>=255?255:k,t[f+3|0]=(k|0)>0?k:0,k=(r<<1)+A|0,w=g(Y,74),f=u[k|0]+((((w+g(_,29)|0)+g(G,84)|0)+g(l,55)|0)+2048>>12)|0,f=(f|0)>=255?255:f,t[k|0]=(f|0)>0?f:0,f=u[k+1|0]+((((w+g(_,55)|0)+g(G,-29)|0)+g(l,-84)|0)+2048>>12)|0,f=(f|0)>=255?255:f,t[k+1|0]=(f|0)>0?f:0,f=u[k+2|0]+(((g(G,-74)+g(_,74)|0)+g(l,74)|0)+2048>>12)|0,f=(f|0)>=255?255:f,t[k+2|0]=(f|0)>0?f:0,l=u[k+3|0]+((((g(Y,-74)+g(_,84)|0)+g(G,55)|0)+g(l,-29)|0)+2048>>12)|0,l=(l|0)>=255?255:l,t[k+3|0]=(l|0)>0?l:0,A=g(r,3)+A|0,l=g(Q,74),r=u[A|0]+((((l+g(e,29)|0)+g(B,84)|0)+g(I,55)|0)+2048>>12)|0,r=(r|0)>=255?255:r,t[A|0]=(r|0)>0?r:0,r=u[A+1|0]+((((l+g(e,55)|0)+g(B,-29)|0)+g(I,-84)|0)+2048>>12)|0,r=(r|0)>=255?255:r,t[A+1|0]=(r|0)>0?r:0,r=u[A+2|0]+(((g(B,-74)+g(e,74)|0)+g(I,74)|0)+2048>>12)|0,r=(r|0)>=255?255:r,t[A+2|0]=(r|0)>0?r:0,r=A,A=u[A+3|0]+((((g(Q,-74)+g(e,84)|0)+g(B,55)|0)+g(I,-29)|0)+2048>>12)|0,A=(A|0)>=255?255:A,t[r+3|0]=(A|0)>0?A:0;return}h=u[A+2|0]+(((g(n,-74)+g(o,74)|0)+g(f,74)|0)+2048>>12)|0,h=(h|0)>=255?255:h,t[A+2|0]=(h|0)>0?h:0,h=g(V,74),m=u[A|0]+((((h+g(o,29)|0)+g(n,84)|0)+g(f,55)|0)+2048>>12)|0,m=(m|0)>=255?255:m,t[A|0]=(m|0)>0?m:0,h=u[A+1|0]+((((h+g(o,55)|0)+g(n,-29)|0)+g(f,-84)|0)+2048>>12)|0,h=(h|0)>=255?255:h,t[A+1|0]=(h|0)>0?h:0,f=u[A+3|0]+((((g(V,-74)+g(o,84)|0)+g(n,55)|0)+g(f,-29)|0)+2048>>12)|0,f=(f|0)>=255?255:f,n=(f|0)>0?f:0,t[A+3|0]=n,f=A+r|0,n=n+(((g(w,-74)+g(s,74)|0)+g(k,74)|0)+2048>>12)|0,n=(n|0)>=255?255:n,t[f+2|0]=(n|0)>0?n:0,n=g(U,74),o=u[f|0]+((((n+g(s,29)|0)+g(w,84)|0)+g(k,55)|0)+2048>>12)|0,o=(o|0)>=255?255:o,t[f|0]=(o|0)>0?o:0,n=u[f+1|0]+((((n+g(s,55)|0)+g(w,-29)|0)+g(k,-84)|0)+2048>>12)|0,n=(n|0)>=255?255:n,t[f+1|0]=(n|0)>0?n:0,k=u[f+3|0]+((((g(U,-74)+g(s,84)|0)+g(w,55)|0)+g(k,-29)|0)+2048>>12)|0,k=(k|0)>=255?255:k,k=(k|0)>0?k:0,t[f+3|0]=k,k=k+(((g(G,-74)+g(_,74)|0)+g(l,74)|0)+2048>>12)|0,k=(k|0)>=255?255:k,t[A+4|0]=(k|0)>0?k:0,k=g(Y,74),f=u[A+2|0]+((((k+g(_,29)|0)+g(G,84)|0)+g(l,55)|0)+2048>>12)|0,f=(f|0)>=255?255:f,t[A+2|0]=(f|0)>0?f:0,k=u[A+3|0]+((((k+g(_,55)|0)+g(G,-29)|0)+g(l,-84)|0)+2048>>12)|0,k=(k|0)>=255?255:k,t[A+3|0]=(k|0)>0?k:0,l=u[A+5|0]+((((g(Y,-74)+g(_,84)|0)+g(G,55)|0)+g(l,-29)|0)+2048>>12)|0,l=(l|0)>=255?255:l,l=(l|0)>0?l:0,t[A+5|0]=l,A=g(r,3)+A|0,r=l+(((g(B,-74)+g(e,74)|0)+g(I,74)|0)+2048>>12)|0,r=(r|0)>=255?255:r,t[A+2|0]=(r|0)>0?r:0,r=g(Q,74),l=u[A|0]+((((r+g(e,29)|0)+g(B,84)|0)+g(I,55)|0)+2048>>12)|0,l=(l|0)>=255?255:l,t[A|0]=(l|0)>0?l:0,r=u[A+1|0]+((((r+g(e,55)|0)+g(B,-29)|0)+g(I,-84)|0)+2048>>12)|0,r=(r|0)>=255?255:r,t[A+1|0]=(r|0)>0?r:0,r=A,A=u[A+3|0]+((((g(Q,-74)+g(e,84)|0)+g(B,55)|0)+g(I,-29)|0)+2048>>12)|0,A=(A|0)>=255?255:A,t[r+3|0]=(A|0)>0?A:0}function im(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=0,c2=0,f1=0,o1=0,u1=0,y1=0,a1=0,d1=0,u4=0,Y4=0,y4=0,E4=0,f8=0,A8=0,k8=0,v6=0,m6=0,ne=0,te=0,N7=0,D7=0,U7=0,M7=0,H7=0,z7=0,x7=0,T7=0,j7=0,S7=0,O7=0,P7=0,L7=0,q7=0,a7=0,K7=0,$7=0,d7=0,b7=0,c7=0,ik=0,ek=0,rk=0,fk=0,Ak=0,kk=0,nk=0,tk=0,ok=0,lk=0,uk=0,sk=0,hk=0,wk=0,_k=0,Bk=0,vk=0,mk=0,Zk=0,gk=0,Gk=0,Wk=0,Xk=0,Ik=0,Qk=0,Vk=0,pk=0,Fk=0,Ck=0,Yk=0,yk=0,Ek=0,Rk=0,Jk=0,Nk=0,Dk=0;G=g(r,14)+e|0,E=p[G+14>>1],R=p[e+14>>1],N=p[e+6>>1],s=R+N|0,O=p[e+10>>1],S=p[e+2>>1],h=O+S|0,f=s+h|0,q=p[e+12>>1],d=p[e+4>>1],_=q+d|0,g0=p[e+8>>1],X0=p[e>>1],B=g0+X0|0,n=_+B|0,o=f+n|0,k=(r<<3)+e|0,V0=p[k+14>>1],C0=p[k+6>>1],I=V0+C0|0,r0=p[k+10>>1],f0=p[k+2>>1],Q=r0+f0|0,w=I+Q|0,M0=p[k+12>>1],z0=p[k+4>>1],V=M0+z0|0,Z2=p[k+8>>1],X2=p[k>>1],U=Z2+X2|0,m=V+U|0,l=w+m|0,Y=o-l|0,k=(r<<2)+e|0,R2=p[k+14>>1],D2=p[k+6>>1],j0=R2+D2|0,c2=p[k+10>>1],f1=p[k+2>>1],S0=c2+f1|0,c=j0+S0|0,o1=p[k+12>>1],u1=p[k+4>>1],q0=o1+u1|0,y1=p[k+8>>1],a1=p[k>>1],r2=y1+a1|0,A0=q0+r2|0,x=c+A0|0,k=g(r,12)+e|0,d1=p[k+14>>1],u4=p[k+6>>1],f2=d1+u4|0,Y4=p[k+10>>1],y4=p[k+2>>1],A2=Y4+y4|0,t0=f2+A2|0,E4=p[k+12>>1],f8=p[k+4>>1],s2=E4+f8|0,A8=p[k+8>>1],v6=p[k>>1],k8=A8+v6|0,v2=s2+k8|0,_0=t0+v2|0,j=x-_0|0,m6=Y-j|0,k=(r<<1)+e|0,ne=p[k+14>>1],te=p[k+6>>1],N7=ne+te|0,D7=p[k+10>>1],U7=p[k+2>>1],M7=D7+U7|0,H7=N7+M7|0,z7=p[k+12>>1],x7=p[k+4>>1],T7=z7+x7|0,j7=p[k+8>>1],S7=p[k>>1],O7=j7+S7|0,P7=T7+O7|0,L7=H7+P7|0,k=g(r,10)+e|0,q7=p[k+14>>1],a7=p[k+6>>1],K7=q7+a7|0,$7=p[k+10>>1],d7=p[k+2>>1],b7=$7+d7|0,c7=K7+b7|0,ik=p[k+12>>1],ek=p[k+4>>1],rk=ik+ek|0,fk=p[k+8>>1],k=p[k>>1],Ak=fk+k|0,kk=rk+Ak|0,nk=c7+kk|0,tk=L7-nk|0,e=g(r,6)+e|0,r=p[e+14>>1],ok=p[e+6>>1],lk=r+ok|0,uk=p[e+10>>1],sk=p[e+2>>1],hk=uk+sk|0,wk=lk+hk|0,_k=p[e+12>>1],Bk=p[e+4>>1],vk=_k+Bk|0,mk=p[e+8>>1],e=p[e>>1],Zk=mk+e|0,gk=vk+Zk|0,Gk=wk+gk|0,Wk=p[G+6>>1],Xk=E+Wk|0,Ik=p[G+10>>1],Qk=p[G+2>>1],Vk=Ik+Qk|0,pk=Xk+Vk|0,Fk=p[G+12>>1],Ck=p[G+4>>1],Yk=Fk+Ck|0,yk=p[G+8>>1],G=p[G>>1],Ek=yk+G|0,Rk=Yk+Ek|0,Jk=pk+Rk|0,Nk=Gk-Jk|0,Dk=tk-Nk|0,X[A+112>>1]=m6-Dk,X[A+96>>1]=m6+Dk,Y=Y+j|0,j=tk+Nk|0,X[A+80>>1]=Y-j,X[A+64>>1]=Y+j,o=o+l|0,l=x+_0|0,Y=o-l|0,x=L7+nk|0,_0=Gk+Jk|0,j=x-_0|0,X[A+48>>1]=Y-j,X[A+32>>1]=Y+j,o=o+l|0,l=x+_0|0,X[A+16>>1]=o-l,X[A>>1]=o+l,f=n-f|0,n=m-w|0,o=f-n|0,w=A0-c|0,m=v2-t0|0,l=w-m|0,Y=o-l|0,c=P7-H7|0,A0=kk-c7|0,x=c-A0|0,t0=gk-wk|0,v2=Rk-pk|0,_0=t0-v2|0,j=x-_0|0,X[A+114>>1]=Y-j,X[A+98>>1]=Y+j,o=o+l|0,l=x+_0|0,X[A+82>>1]=o-l,X[A+66>>1]=o+l,f=f+n|0,n=w+m|0,o=f-n|0,w=c+A0|0,m=t0+v2|0,l=w-m|0,X[A+50>>1]=o-l,X[A+34>>1]=o+l,f=f+n|0,n=w+m|0,X[A+18>>1]=f-n,X[A+2>>1]=f+n,s=h-s|0,h=B-_|0,f=s+h|0,_=Q-I|0,B=U-V|0,n=_+B|0,o=f-n|0,I=S0-j0|0,Q=r2-q0|0,w=I+Q|0,V=A2-f2|0,U=k8-s2|0,m=V+U|0,l=w-m|0,Y=o-l|0,j0=M7-N7|0,S0=O7-T7|0,c=j0+S0|0,q0=b7-K7|0,r2=Ak-rk|0,A0=q0+r2|0,x=c-A0|0,f2=hk-lk|0,A2=Zk-vk|0,t0=f2+A2|0,s2=Vk-Xk|0,k8=Ek-Yk|0,v2=s2+k8|0,_0=t0-v2|0,j=x-_0|0,X[A+116>>1]=Y-j,X[A+100>>1]=Y+j,o=o+l|0,l=x+_0|0,X[A+84>>1]=o-l,X[A+68>>1]=o+l,f=f+n|0,n=w+m|0,o=f-n|0,w=c+A0|0,m=t0+v2|0,l=w-m|0,X[A+52>>1]=o-l,X[A+36>>1]=o+l,f=f+n|0,n=w+m|0,X[A+20>>1]=f-n,X[A+4>>1]=f+n,s=h-s|0,h=B-_|0,f=s-h|0,_=Q-I|0,B=U-V|0,n=_-B|0,o=f-n|0,I=S0-j0|0,Q=r2-q0|0,w=I-Q|0,V=A2-f2|0,U=k8-s2|0,m=V-U|0,l=w-m|0,X[A+118>>1]=o-l,X[A+102>>1]=o+l,f=f+n|0,n=w+m|0,X[A+86>>1]=f-n,X[A+70>>1]=f+n,s=s+h|0,h=_+B|0,f=s-h|0,_=I+Q|0,B=V+U|0,n=_-B|0,X[A+54>>1]=f-n,X[A+38>>1]=f+n,s=s+h|0,h=_+B|0,X[A+22>>1]=s-h,X[A+6>>1]=s+h,R=N-R|0,N=S-O|0,s=R+N|0,O=d-q|0,S=X0-g0|0,h=O+S|0,f=s+h|0,q=C0-V0|0,d=f0-r0|0,_=q+d|0,g0=z0-M0|0,X0=X2-Z2|0,B=g0+X0|0,n=_+B|0,o=f-n|0,V0=D2-R2|0,C0=f1-c2|0,I=V0+C0|0,r0=u1-o1|0,f0=a1-y1|0,Q=r0+f0|0,w=I+Q|0,M0=u4-d1|0,z0=y4-Y4|0,V=M0+z0|0,Z2=f8-E4|0,X2=v6-A8|0,U=Z2+X2|0,m=V+U|0,l=w-m|0,Y=o-l|0,R2=te-ne|0,D2=U7-D7|0,j0=R2+D2|0,c2=x7-z7|0,f1=S7-j7|0,S0=c2+f1|0,c=j0+S0|0,o1=a7-q7|0,u1=d7-$7|0,q0=o1+u1|0,y1=ek-ik|0,k=k-fk|0,a1=y1+k|0,r2=q0+a1|0,A0=c-r2|0,r=ok-r|0,x=sk-uk|0,d1=r+x|0,u4=Bk-_k|0,e=e-mk|0,f2=u4+e|0,Y4=d1+f2|0,E=Wk-E|0,y4=Qk-Ik|0,A2=E+y4|0,t0=Ck-Fk|0,G=G-yk|0,E4=t0+G|0,f8=A2+E4|0,s2=Y4-f8|0,A8=A0-s2|0,X[A+120>>1]=Y-A8,X[A+104>>1]=Y+A8,o=o+l|0,l=A0+s2|0,X[A+88>>1]=o-l,X[A+72>>1]=o+l,f=f+n|0,n=w+m|0,o=f-n|0,w=c+r2|0,m=Y4+f8|0,l=w-m|0,X[A+56>>1]=o-l,X[A+40>>1]=o+l,f=f+n|0,n=w+m|0,X[A+24>>1]=f-n,X[A+8>>1]=f+n,s=h-s|0,h=B-_|0,f=s-h|0,_=Q-I|0,B=U-V|0,n=_-B|0,o=f-n|0,I=S0-j0|0,Q=a1-q0|0,w=I-Q|0,V=f2-d1|0,U=E4-A2|0,m=V-U|0,l=w-m|0,X[A+122>>1]=o-l,X[A+106>>1]=o+l,f=f+n|0,n=w+m|0,X[A+90>>1]=f-n,X[A+74>>1]=f+n,s=s+h|0,h=_+B|0,f=s-h|0,_=I+Q|0,B=V+U|0,n=_-B|0,X[A+58>>1]=f-n,X[A+42>>1]=f+n,s=s+h|0,h=_+B|0,X[A+26>>1]=s-h,X[A+10>>1]=s+h,R=N-R|0,N=S-O|0,s=R+N|0,O=d-q|0,S=X0-g0|0,h=O+S|0,f=s-h|0,q=C0-V0|0,d=f0-r0|0,_=q+d|0,g0=z0-M0|0,X0=X2-Z2|0,B=g0+X0|0,n=_-B|0,o=f-n|0,V0=D2-R2|0,C0=f1-c2|0,I=V0+C0|0,r0=u1-o1|0,k=k-y1|0,f0=r0+k|0,Q=I-f0|0,r=x-r|0,e=e-u4|0,w=r+e|0,E=y4-E|0,G=G-t0|0,M0=E+G|0,z0=w-M0|0,V=Q-z0|0,X[A+124>>1]=o-V,X[A+108>>1]=o+V,f=f+n|0,n=Q+z0|0,X[A+92>>1]=f-n,X[A+76>>1]=f+n,s=s+h|0,h=_+B|0,f=s-h|0,_=I+f0|0,B=w+M0|0,n=_-B|0,X[A+60>>1]=f-n,X[A+44>>1]=f+n,s=s+h|0,h=_+B|0,X[A+28>>1]=s-h,X[A+12>>1]=s+h,G=G-E|0,e=e-r|0,r=G+e|0,k=k-r0|0,E=C0-V0|0,s=k+E|0,h=r+s|0,f=X0-g0|0,q=d-q|0,d=f+q|0,O=S-O|0,R=N-R|0,N=O+R|0,S=d+N|0,X[A+14>>1]=h+S,X[A+30>>1]=S-h,r=s-r|0,N=N-d|0,X[A+46>>1]=r+N,X[A+62>>1]=N-r,e=e-G|0,r=E-k|0,G=e+r|0,k=q-f|0,E=R-O|0,R=k+E|0,X[A+78>>1]=G+R,X[A+94>>1]=R-G,e=r-e|0,r=E-k|0,X[A+110>>1]=e+r,X[A+126>>1]=r-e}function em(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0;e=v-128|0,v=e,s=K0(i[r>>2],0),h=K0(i[r>>2],1),_=K0(i[r>>2],2),O=$2(i[r>>2],6),O&&(_0=K0(i[r>>2],6));i:{if(!(!(s>>>0>8|h>>>0>8)&_>>>0<9)){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}if(!((s|0)==(h|0)&(s|0)==(_|0))){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}f=i[r>>2],n=i[f+192>>2],k=i[f+188>>2],f=C(248),i[f>>2]=101168,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,o=f+12|0,i[f+176>>2]=o,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(o,k,n,0,1),a0(e+56|0,o,0,k,n,s,l,0),w=k+1>>>1|0,E=n+1>>>1|0,a0(e+32|0,o,1,w,E,h,l,0),s=e+88|0;e:{if(i[e+56>>2]){if(h=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=h,t[e+75|0]>=0){h=e- -64|0,m=i[h+4>>2],i[s>>2]=i[h>>2],i[s+4>>2]=m,i[s+8>>2]=i[h+8>>2];break e}T(s,i[e+64>>2],i[e+68>>2]);break e}if(h=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=h,t[e+51|0]>=0){h=i[e+44>>2],i[s>>2]=i[e+40>>2],i[s+4>>2]=h,i[s+8>>2]=i[e+48>>2];break e}T(s,i[e+40>>2],i[e+44>>2])}a0(e+8|0,o,2,w,E,_,l,0),h=e+112|0;e:{if(i[e+80>>2]){if(_=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=_,t[e+99|0]>=0){_=i[s+4>>2],i[h>>2]=i[s>>2],i[h+4>>2]=_,i[h+8>>2]=i[s+8>>2];break e}T(h,i[e+88>>2],i[e+92>>2]);break e}if(s=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=s,t[e+27|0]>=0){s=i[e+20>>2],i[h>>2]=i[e+16>>2],i[h+4>>2]=s,i[h+8>>2]=i[e+24>>2];break e}T(h,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[h+4>>2],i[r>>2]=i[h>>2],i[r+4>>2]=k,i[r+8>>2]=i[h+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!O)break r;if(a0(e+104|0,o,6,k,n,_0,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}l=0,s=Q0(i[r>>2],0),s?(S=i[s+40>>2],_=i[s+52>>2]):_=0,s=Q0(i[r>>2],1),s?(l=i[s+52>>2],h=i[s+40>>2]):h=0,s=Q0(i[r>>2],2);r:{if(!s){s=0;break r}N=i[s+40>>2],s=i[s+52>>2]}m=Q0(o,0),m?(q=i[m+52>>2],m=i[m+40>>2]):m=0,Q=Q0(o,1),Q?(d=i[Q+40>>2],Q=i[Q+52>>2]):Q=0,V=Q0(o,2),V?(c=i[V+52>>2],V=i[V+40>>2]):V=0,U=0;r:{if(!O||(r=Q0(i[r>>2],6),r?(C0=i[r+40>>2],r=i[r+52>>2]):r=0,r0=r,r=Q0(o,6),U=0,!r))break r;f0=i[r+52>>2],U=i[r+40>>2]}r:{f:{A:{k:{if(A0=n&1,A0){if(G=k-1|0,!G)break k;for(r=E-1|0,R=g(r,c)+V|0,Y=n-1|0,x=g(Y,s)+N|0,j=g(r,Q)+d|0,Y=g(l,Y)+h|0,r=0;I=r>>>1|0,B=r+Y|0,t[I+j|0]=(u[B|0]+u[B+1|0]|0)+1>>>1,B=I+R|0,I=r+x|0,t[B|0]=(u[I|0]+u[I+1|0]|0)+1>>>1,r=r+2|0,G>>>0>r>>>0;);}if(k&1)break k;G=n-1|0;break A}if(G=n-1|0,G){for(x=(w+V|0)-1|0,R=(k+N|0)-1|0,j=(w+d|0)-1|0,Y=(k+h|0)-1|0,r=0;I=r>>>1|0,B=r|1,t[j+g(I,Q)|0]=(u[Y+g(r,l)|0]+u[Y+g(B,l)|0]|0)+1>>>1,t[x+g(I,c)|0]=(u[R+g(r,s)|0]+u[R+g(s,B)|0]|0)+1>>>1,r=r+2|0,G>>>0>r>>>0;);if(!A0)break f}r=E-1|0,t[(w+(g(r,Q)+d|0)|0)-1|0]=u[((g(l,G)+h|0)+k|0)-1|0],t[(w+(g(r,c)+V|0)|0)-1|0]=u[((g(s,G)+N|0)+k|0)-1|0]}if(!G)break r}if(E=k-1|0,!E)break r;for(w=0;;){for(R=g(s,w)+N|0,Y=g(l,w)+h|0,r=w>>>1|0,A0=g(r,c)+V|0,x=g(r,Q)+d|0,r=w|1,j=g(r,s)+N|0,I=g(r,l)+h|0,r=0;B=r+j|0,M0=u[B+1|0],B=u[B|0],t0=r+R|0,z0=u[t0+1|0],t0=u[t0|0],g0=r>>>1|0,X0=r+I|0,V0=r+Y|0,t[x+g0|0]=((u[X0|0]+(u[V0|0]+u[V0+1|0]|0)|0)+u[X0+1|0]|0)+2>>>2,t[A0+g0|0]=((B+(t0+z0|0)|0)+M0|0)+2>>>2,r=r+2|0,E>>>0>r>>>0;);if(w=w+2|0,!(w>>>0<G>>>0))break}}r:{if(!n)break r;if(O){for(l=k<<(_0>>>0>8),r=0;k&&z(g(r,q)+m|0,g(r,_)+S|0,k),l&&z(g(r,f0)+U|0,g(r,r0)+C0|0,l),r=r+1|0,(n|0)!=(r|0););break r}if(r=0,(n|0)!=1)for(s=n&-2,l=0;h=!k,h||z(g(r,q)+m|0,g(r,_)+S|0,k),h||(h=r|1,z(g(h,q)+m|0,g(h,_)+S|0,k)),r=r+2|0,l=l+2|0,(s|0)!=(l|0););if(!(n&1)|!k)break r;z(g(r,q)+m|0,g(r,_)+S|0,k)}t[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=o;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=e+128|0}function a9(A,e,r,f,k,n,o,l){var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;s=v-32|0,v=s,w=i[r>>2],h=i[r+4>>2],V4(e+116|0,i[e+120>>2],w,h,h-w|0),w=i[i[e+192>>2]+108>>2]-8|0,i[w>>2]=i[w>>2]+1;i:{if(h=i[e+232>>2],w=i[h+108>>2],G=i[r+4>>2]-i[r>>2]|0,!(w|!G)){i[h+104>>2]=G,i[h+108>>2]=1;break i}if(r=i[h+104>>2],!(!G|(r|0)!=(G|0))){i[h+108>>2]=w+1;break i}e:{r:{f:{if(r){if(w)for(r=i[h+116>>2];;){_=i[h+120>>2];A:{if(_>>>0>r>>>0){i[r>>2]=i[h+104>>2],r=r+4|0;break A}if(m=i[h+112>>2],r=r-m|0,I=r>>2,w=I+1|0,w>>>0>=1073741824)break f;if(_=_-m|0,B=_>>1,_=_>>>0>=2147483644?1073741823:w>>>0<B>>>0?B:w,_){if(_>>>0>=1073741824)break r;w=C(_<<2)}else w=0;if(B=w+r|0,i[B>>2]=i[h+104>>2],I=B-(I<<2)|0,r&&z(I,m,r),i[h+120>>2]=w+(_<<2),r=B+4|0,i[h+116>>2]=r,i[h+112>>2]=I,!m)break A;Z(m)}if(i[h+116>>2]=r,Q=Q+1|0,!(Q>>>0<o0[h+108>>2]))break}i[h+104>>2]=0}r=i[h+116>>2],_=i[h+120>>2];A:{if(r>>>0<_>>>0){i[r>>2]=G,r=r+4|0;break A}if(m=i[h+112>>2],r=r-m|0,I=r>>2,w=I+1|0,w>>>0>=1073741824)break e;if(_=_-m|0,B=_>>1,_=_>>>0>=2147483644?1073741823:w>>>0<B>>>0?B:w,_){if(_>>>0>=1073741824)break r;w=C(_<<2)}else w=0;if(B=w+r|0,i[B>>2]=G,G=B-(I<<2)|0,r&&z(G,m,r),i[h+120>>2]=w+(_<<2),r=B+4|0,i[h+116>>2]=r,i[h+112>>2]=G,!m)break A;Z(m)}i[h+116>>2]=r,i[h+108>>2]=i[h+108>>2]+1;break i}s0(),M()}x0(),M()}s0(),M()}n&&wl(i[e+224>>2],i[e+96>>2]+1|0);i:{if(!f){if(e=C(32),i[s+16>>2]=e,i[s+20>>2]=28,i[s+24>>2]=-2147483616,r=u[23907]|u[23908]<<8|(u[23909]<<16|u[23910]<<24),f=u[23903]|u[23904]<<8|(u[23905]<<16|u[23906]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+28|0]=0,r=u[23927]|u[23928]<<8|(u[23929]<<16|u[23930]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,r=u[23923]|u[23924]<<8|(u[23925]<<16|u[23926]<<24),f=u[23919]|u[23920]<<8|(u[23921]<<16|u[23922]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[23915]|u[23916]<<8|(u[23917]<<16|u[23918]<<24),f=u[23911]|u[23912]<<8|(u[23913]<<16|u[23914]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,5,0,s+16|0),t[s+27|0]>=0)break i;Z(i[s+16>>2]);break i}xo(i[e+208>>2],f),xo(i[e+216>>2],k);e:{if(r=i[e+40>>2],!r)break e;if(o){if(r=s+16|0,Yl(r,o),Hn(A,i[e+268>>2],r),f=i[A>>2],f|t[A+19|0]>=0||Z(i[A+8>>2]),r=i[s+16>>2],r&&(i[s+20>>2]=r,Z(r)),f)break i;break e}if((r|0)==1){SA(i[i[e+268>>2]>>2],0);break e}if(e=C(32),i[s+16>>2]=e,i[s+20>>2]=31,i[s+24>>2]=-2147483616,r=u[12033]|u[12034]<<8|(u[12035]<<16|u[12036]<<24),f=u[12029]|u[12030]<<8|(u[12031]<<16|u[12032]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+31|0]=0,r=u[12056]|u[12057]<<8|(u[12058]<<16|u[12059]<<24),f=u[12052]|u[12053]<<8|(u[12054]<<16|u[12055]<<24),t[e+23|0]=f,t[e+24|0]=f>>>8,t[e+25|0]=f>>>16,t[e+26|0]=f>>>24,t[e+27|0]=r,t[e+28|0]=r>>>8,t[e+29|0]=r>>>16,t[e+30|0]=r>>>24,r=u[12049]|u[12050]<<8|(u[12051]<<16|u[12052]<<24),f=u[12045]|u[12046]<<8|(u[12047]<<16|u[12048]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[12041]|u[12042]<<8|(u[12043]<<16|u[12044]<<24),f=u[12037]|u[12038]<<8|(u[12039]<<16|u[12040]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,s+16|0),t[s+27|0]>=0)break i;Z(i[s+16>>2]);break i}e:{r:{r=i[e+48>>2];f:{if(!r)break f;if(u[l+12|0]==1){A:{if(t[l+11|0]>=0){i[s+24>>2]=i[l+8>>2],r=i[l+4>>2],i[s+16>>2]=i[l>>2],i[s+20>>2]=r;break A}T(s+16|0,i[l>>2],i[l+4>>2])}if(f=i[s+16>>2],r=t[s+27|0],i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,k=s+4|0,n=f,f=(r|0)<0,n=f?n:s+16|0,r=(f?i[s+20>>2]:r)+1|0,Ft(k,n,r+n|0,r),Hn(A,i[e+272>>2],k),f=i[A>>2],f|t[A+19|0]>=0||Z(i[A+8>>2]),r=i[s+4>>2],r&&(i[s+8>>2]=r,Z(r)),t[s+27|0]<0&&Z(i[s+16>>2]),!f)break f;break i}if((r|0)!=1)break r;SA(i[i[e+272>>2]>>2],0)}if(i[e+96>>2]=i[e+96>>2]+1,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]<0)break e;e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}if(e=C(32),i[s+16>>2]=e,i[s+20>>2]=27,i[s+24>>2]=-2147483616,r=u[12065]|u[12066]<<8|(u[12067]<<16|u[12068]<<24),f=u[12061]|u[12062]<<8|(u[12063]<<16|u[12064]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+27|0]=0,r=u[12084]|u[12085]<<8|(u[12086]<<16|u[12087]<<24),t[e+23|0]=r,t[e+24|0]=r>>>8,t[e+25|0]=r>>>16,t[e+26|0]=r>>>24,r=u[12081]|u[12082]<<8|(u[12083]<<16|u[12084]<<24),f=u[12077]|u[12078]<<8|(u[12079]<<16|u[12080]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[12073]|u[12074]<<8|(u[12075]<<16|u[12076]<<24),f=u[12069]|u[12070]<<8|(u[12071]<<16|u[12072]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,s+16|0),t[s+27|0]>=0)break i;Z(i[s+16>>2]);break i}T(A,i[28730],i[28731])}v=s+32|0}function hA(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0;n=v-96|0,v=n,k=i[e+48>>2],l=i[e+52>>2],l&&(i[l+4>>2]=i[l+4>>2]+1);i:{if(!f){f=v-48|0,v=f,o=i[e+48>>2],s=i[e+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),k=v-32|0,v=k,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,L1(k,o,r,k+20|0);e:{if(i[k>>2]){i[f+40>>2]=0,i[f+44>>2]=0;break e}r:{if(o=i[k+20>>2],r=i[k+24>>2],(o|0)!=(r|0)){if(e=i[o>>2],e&&(h=i[f+44>>2],e=Z0(e,92792,92996),e))break r;if(o=o+8|0,(r|0)!=(o|0))for(;;){if(e=i[o>>2],e&&(h=0,e=Z0(e,92792,92996),e))break r;if(o=o+8|0,(r|0)==(o|0))break}i[f+40>>2]=0,i[f+44>>2]=0}i[f+40>>2]=0,i[f+44>>2]=0;break e}if(i[f+44>>2]=h,i[f+40>>2]=e,e=i[o+4>>2],i[f+44>>2]=e,!e)break e;i[e+4>>2]=i[e+4>>2]+1}if(t[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(e=r,o=i[k+24>>2],(e|0)!=(o|0)){for(;;){e=i[o-4>>2];e:{if(!e||(h=i[e+4>>2],i[e+4>>2]=h-1,h))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(o=o-8|0,(r|0)==(o|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}v=k+32|0,e=i[f+40>>2];e:{if(!e){e=C(32),i[f+4>>2]=e,i[f+8>>2]=26,i[f+12>>2]=-2147483616,r=u[10439]|u[10440]<<8,t[e+24|0]=r,t[e+25|0]=r>>>8,r=u[10435]|u[10436]<<8|(u[10437]<<16|u[10438]<<24),k=u[10431]|u[10432]<<8|(u[10433]<<16|u[10434]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[10427]|u[10428]<<8|(u[10429]<<16|u[10430]<<24),k=u[10423]|u[10424]<<8|(u[10425]<<16|u[10426]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[10419]|u[10420]<<8|(u[10421]<<16|u[10422]<<24),k=u[10415]|u[10416]<<8|(u[10417]<<16|u[10418]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+26|0]=0,e=a(f+16|0,2,116,f+4|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(t[f+15|0]<0&&Z(i[f+4>>2]),A=i[f+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}r=i[f+44>>2],t[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}e:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break e;W[i[i[s>>2]+8>>2]](s),y(s)}v=f+48|0;break i}i[n+92>>2]=0,i[n+84>>2]=0,i[n+88>>2]=0,L1(n- -64|0,k,r,n+84|0);e:{if(i[n+64>>2]){e=i[n+68>>2],i[A>>2]=i[n+64>>2],i[A+4>>2]=e,e=A+8|0;r:{if(t[n+83|0]>=0){r=i[n+76>>2],i[e>>2]=i[n+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+80>>2];break r}T(e,i[n+72>>2],i[n+76>>2])}t[A+20|0]=1;break e}k=f-1|0,e=i[n+84>>2],k>>>0>=i[n+88>>2]-e>>3>>>0&&(e=C(32),i[n+24>>2]=e,i[n+28>>2]=27,i[n+32>>2]=-2147483616,r=u[15152]|u[15153]<<8|(u[15154]<<16|u[15155]<<24),f=u[15148]|u[15149]<<8|(u[15150]<<16|u[15151]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+27|0]=0,r=u[15171]|u[15172]<<8|(u[15173]<<16|u[15174]<<24),t[e+23|0]=r,t[e+24|0]=r>>>8,t[e+25|0]=r>>>16,t[e+26|0]=r>>>24,r=u[15168]|u[15169]<<8|(u[15170]<<16|u[15171]<<24),f=u[15164]|u[15165]<<8|(u[15166]<<16|u[15167]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[15160]|u[15161]<<8|(u[15162]<<16|u[15163]<<24),f=u[15156]|u[15157]<<8|(u[15158]<<16|u[15159]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,e=a(n+44|0,5,2007,n+24|0),t[e+19|0]<0&&Z(i[e+8>>2]),t[n+35|0]<0&&Z(i[n+24>>2]),e=i[n+84>>2]),r=e+(k<<3)|0,e=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);r:{f:{if(!e||(e=Z0(e,92792,92996),!e))break f;r&&(i[r+4>>2]=i[r+4>>2]+1),t[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e;break r}e=C(24),i[n+12>>2]=e,i[n+16>>2]=19,i[n+20>>2]=-2147483624,f=u[13877]|u[13878]<<8|(u[13879]<<16|u[13880]<<24),t[e+15|0]=f,t[e+16|0]=f>>>8,t[e+17|0]=f>>>16,t[e+18|0]=f>>>24,f=u[13874]|u[13875]<<8|(u[13876]<<16|u[13877]<<24),k=u[13870]|u[13871]<<8|(u[13872]<<16|u[13873]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,f=u[13866]|u[13867]<<8|(u[13868]<<16|u[13869]<<24),k=u[13862]|u[13863]<<8|(u[13864]<<16|u[13865]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+19|0]=0,e=a(n+24|0,5,2007,n+12|0),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,f=A+8|0;f:{if(t[e+19|0]>=0){k=i[e+12>>2],i[f>>2]=i[e+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[e+16>>2],t[A+20|0]=1;break f}if(T(f,i[e+8>>2],i[e+12>>2]),f=t[e+19|0],t[A+20|0]=1,(f|0)>=0)break f;Z(i[e+8>>2])}if(t[n+23|0]>=0)break r;Z(i[n+12>>2])}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(t[n+83|0]<0&&Z(i[n+72>>2]),r=i[n+84>>2],!r)break i;if(e=i[n+88>>2],A=r,(e|0)!=(r|0)){for(;;){A=i[e-4>>2];e:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[n+84>>2]}i[n+88>>2]=r,Z(A)}i:{if(!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break i;W[i[i[l>>2]+8>>2]](l),y(l)}v=n+96|0}function rm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;k=v-160|0,v=k,i[k+84>>2]=0,i[k+56>>2]=78468,f=i[19620],i[k>>2]=f,i[i[f-12>>2]+k>>2]=i[19621],f=i[i[k>>2]-12>>2]+k|0,n=k+4|0,J0(f,n),t[f+80|0]=0,i[f+72>>2]=0,i[k+56>>2]=78468,i[k>>2]=78448,m=R0(n),i[m>>2]=77200,i[k+44>>2]=0,i[k+48>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+52>>2]=16,f=k+148|0,J2(f,e,r),o=f,f=t[k+159|0],n=(f|0)<0,F(k,n?i[k+148>>2]:o,n?i[k+152>>2]:f),t[k+159|0]<0&&Z(i[k+148>>2]);i:{if(w=i[e+104>>2],G=i[e+108>>2],(w|0)!=(G|0))for(;;){e=k+148|0,k0(e,r),o=e,e=t[k+159|0],f=(e|0)<0,F(k,f?i[k+148>>2]:o,f?i[k+152>>2]:e),t[k+159|0]<0&&Z(i[k+148>>2]),e=F(B0(F(k,37608,9),i[w>>2]),47878,1),f=k+148|0,k0(f,r),o=f,f=t[k+159|0],n=(f|0)<0,F(e,n?i[k+148>>2]:o,n?i[k+152>>2]:f),t[k+159|0]<0&&Z(i[k+148>>2]),e=F(D0(F(e,36936,23),u[w+4|0]),47878,1),f=k+148|0,k0(f,r),o=f,f=t[k+159|0],n=(f|0)<0,F(e,n?i[k+148>>2]:o,n?i[k+152>>2]:f),t[k+159|0]<0&&Z(i[k+148>>2]),e=F(e,33060,24),f=i[i[e>>2]-12>>2]+e|0,i[f+4>>2]=i[f+4>>2]&-75|8,e=B0(e,p[w+6>>1]),f=i[i[e>>2]-12>>2]+e|0,i[f+4>>2]=i[f+4>>2]&-75|2,e=F(e,47878,1),f=k+148|0,k0(f,r),o=f,f=t[k+159|0],n=(f|0)<0,F(e,n?i[k+148>>2]:o,n?i[k+152>>2]:f),t[k+159|0]<0&&Z(i[k+148>>2]),F(M2(F(e,33397,15),i[w+8>>2],i[w+12>>2]),47878,1),e=k+148|0,k0(e,r),o=e,e=t[k+159|0],f=(e|0)<0,F(k,f?i[k+148>>2]:o,f?i[k+152>>2]:e),t[k+159|0]<0&&Z(i[k+148>>2]),F(k,33597,11);e:{if(e=i[w+16>>2],I=i[w+20>>2],(e|0)==(I|0))break e;r:{for(;;){f:{h=M2(k,i[e+8>>2],i[e+12>>2]),B=X1(k+140|0,h);A:{if(u[B|0]!=1)break A;n=h+i[i[h>>2]-12>>2]|0,_=i[n+4>>2],l=i[n+24>>2];k:{if(u[n+80|0]==1){s=u[n+76|0]|u[n+77|0]<<8|(u[n+78|0]<<16|u[n+79|0]<<24);break k}o=k+148|0,f=i[n+28>>2],i[o>>2]=f,(f|0)!=136824&&(i[f+4>>2]=i[f+4>>2]+1),f=$0(o,137008),s=W[i[i[f>>2]+28>>2]](f,32)|0,i2(o),t[n+76|0]=s,t[n+77|0]=s>>>8,t[n+78|0]=s>>>16,t[n+79|0]=s>>>24,t[n+80|0]=1}k:{if(!l||(f=i[n+12>>2],_=(_&176)==32?29398:29397,o=_-29397|0,(o|0)>0&&(W[i[i[l>>2]+48>>2]](l,29397,o)|0)!=(o|0)))break k;if((f|0)>=2){if(f>>>0>=2147483641)break f;o=((f|0)<=1?1:f)-1|0;n:{if(f>>>0>=12){Q=o|7,f=C(Q+1|0),i[k+156>>2]=Q-2147483647,i[k+148>>2]=f,i[k+152>>2]=o;break n}t[k+159|0]=o,f=k+148|0}if(o&&l0(f,s,o),t[f+o|0]=0,f=W[i[i[l>>2]+48>>2]](l,t[k+159|0]<0?i[k+148>>2]:k+148|0,o)|0,t[k+159|0]<0&&Z(i[k+148>>2]),(f|0)!=(o|0))break k}if(f=29398-_|0,(f|0)>0&&(W[i[i[l>>2]+48>>2]](l,_,f)|0)!=(f|0))break k;i[n+12>>2]=0;break A}f=h+i[i[h>>2]-12>>2]|0,M1(f,i[f+16>>2]|5)}if(v1(B),M2(h,i[e+16>>2],i[e+20>>2]),i[e>>2]|i[e+4>>2]){_=X1(k+140|0,k);A:{if(u[_|0]!=1)break A;n=i[i[k>>2]-12>>2]+k|0,l=i[n+4>>2],s=i[n+24>>2];k:{if(u[n+80|0]==1){f=u[n+76|0]|u[n+77|0]<<8|(u[n+78|0]<<16|u[n+79|0]<<24);break k}o=k+148|0,f=i[n+28>>2],i[o>>2]=f,(f|0)!=136824&&(i[f+4>>2]=i[f+4>>2]+1),f=$0(o,137008),f=W[i[i[f>>2]+28>>2]](f,32)|0,i2(o),t[n+76|0]=f,t[n+77|0]=f>>>8,t[n+78|0]=f>>>16,t[n+79|0]=f>>>24,t[n+80|0]=1}k:{if(!s||(o=i[n+12>>2],h=(l&176)==32?22699:22692,l=h-22692|0,(l|0)>0&&(W[i[i[s>>2]+48>>2]](s,22692,l)|0)!=(l|0)))break k;if((o|0)>=8){if((o|0)==2147483647)break i;l=((o|0)<=7?7:o)-7|0;n:{if(o>>>0>=18){B=l|7,o=C(B+1|0),i[k+156>>2]=B-2147483647,i[k+148>>2]=o,i[k+152>>2]=l;break n}t[k+159|0]=l,o=k+148|0}if(l&&l0(o,f,l),t[o+l|0]=0,f=W[i[i[s>>2]+48>>2]](s,t[k+159|0]<0?i[k+148>>2]:k+148|0,l)|0,t[k+159|0]<0&&Z(i[k+148>>2]),(f|0)!=(l|0))break k}if(f=22699-h|0,(f|0)>0&&(W[i[i[s>>2]+48>>2]](s,h,f)|0)!=(f|0))break k;i[n+12>>2]=0;break A}f=i[i[k>>2]-12>>2]+k|0,M1(f,i[f+16>>2]|5)}v1(_),M2(k,i[e>>2],i[e+4>>2])}_=X1(k+140|0,k);A:{if(u[_|0]!=1)break A;n=i[i[k>>2]-12>>2]+k|0,l=i[n+4>>2],s=i[n+24>>2];k:{if(u[n+80|0]==1){f=u[n+76|0]|u[n+77|0]<<8|(u[n+78|0]<<16|u[n+79|0]<<24);break k}o=k+148|0,f=i[n+28>>2],i[o>>2]=f,(f|0)!=136824&&(i[f+4>>2]=i[f+4>>2]+1),f=$0(o,137008),f=W[i[i[f>>2]+28>>2]](f,32)|0,i2(o),t[n+76|0]=f,t[n+77|0]=f>>>8,t[n+78|0]=f>>>16,t[n+79|0]=f>>>24,t[n+80|0]=1}k:{if(!s||(o=i[n+12>>2],h=(l&176)==32?37887:37886,l=h-37886|0,(l|0)>0&&(W[i[i[s>>2]+48>>2]](s,37886,l)|0)!=(l|0)))break k;if((o|0)>=2){if(o>>>0>=2147483641)break r;l=((o|0)<=1?1:o)-1|0;n:{if(o>>>0>=12){B=l|7,o=C(B+1|0),i[k+156>>2]=B-2147483647,i[k+148>>2]=o,i[k+152>>2]=l;break n}t[k+159|0]=l,o=k+148|0}if(l&&l0(o,f,l),t[o+l|0]=0,f=W[i[i[s>>2]+48>>2]](s,t[k+159|0]<0?i[k+148>>2]:k+148|0,l)|0,t[k+159|0]<0&&Z(i[k+148>>2]),(f|0)!=(l|0))break k}if(f=37887-h|0,(f|0)>0&&(W[i[i[s>>2]+48>>2]](s,h,f)|0)!=(f|0))break k;i[n+12>>2]=0;break A}f=i[i[k>>2]-12>>2]+k|0,M1(f,i[f+16>>2]|5)}if(v1(_),e=e+40|0,(I|0)!=(e|0))continue;break e}break}break i}break i}if(F(k,47878,1),w=w+32|0,(G|0)==(w|0))break}e=i[k+52>>2];e:{r:{if(e&16){e=i[k+48>>2],r=i[k+28>>2],e>>>0<r>>>0&&(i[k+48>>2]=r,e=r),r=k+24|0;break r}if(!(e&8)){e=0,t[A+11|0]=0;break e}e=i[k+20>>2],r=k+12|0}r:{if(f=i[r>>2],e=e-f|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break r}if(t[A+11|0]=e,e)break r;e=0;break e}I0(),M()}if(!e)break e;z(A,f,e)}t[A+e|0]=0,A=i[19619],i[k>>2]=A,i[i[A-12>>2]+k>>2]=i[19622],i[m>>2]=77200,t[k+47|0]<0&&Z(i[k+36>>2]),y0(m),Y0(k+56|0),v=k+160|0;return}I0(),M()}function fm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0;e=v-128|0,v=e,n=K0(i[r>>2],0),s=K0(i[r>>2],1),h=K0(i[r>>2],2),j=$2(i[r>>2],6),j&&(t0=K0(i[r>>2],6));i:{if(!(!(n>>>0>8|s>>>0>8)&h>>>0<9)){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}if(!((n|0)==(s|0)&(n|0)==(h|0))){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}f=i[r>>2],_=i[f+192>>2],k=i[f+188>>2],f=C(248),i[f>>2]=101168,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,o=f+12|0,i[f+176>>2]=o,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(o,k,_,0,3),a0(e+56|0,o,0,k,_,n,l,0),a0(e+32|0,o,1,k,_,s,l,0),n=e+88|0;e:{if(i[e+56>>2]){if(s=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=s,t[e+75|0]>=0){s=e- -64|0,B=i[s+4>>2],i[n>>2]=i[s>>2],i[n+4>>2]=B,i[n+8>>2]=i[s+8>>2];break e}T(n,i[e+64>>2],i[e+68>>2]);break e}if(s=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=s,t[e+51|0]>=0){s=i[e+44>>2],i[n>>2]=i[e+40>>2],i[n+4>>2]=s,i[n+8>>2]=i[e+48>>2];break e}T(n,i[e+40>>2],i[e+44>>2])}a0(e+8|0,o,2,k,_,h,l,0),s=e+112|0;e:{if(i[e+80>>2]){if(h=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=h,t[e+99|0]>=0){h=i[n+4>>2],i[s>>2]=i[n>>2],i[s+4>>2]=h,i[s+8>>2]=i[n+8>>2];break e}T(s,i[e+88>>2],i[e+92>>2]);break e}if(n=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=n,t[e+27|0]>=0){n=i[e+20>>2],i[s>>2]=i[e+16>>2],i[s+4>>2]=n,i[s+8>>2]=i[e+24>>2];break e}T(s,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[s+4>>2],i[r>>2]=i[s>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!j)break r;if(a0(e+104|0,o,6,k,_,t0,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}l=0,n=Q0(i[r>>2],0),n?(O=i[n+40>>2],E=i[n+52>>2]):E=0,n=Q0(i[r>>2],1),n?(l=i[n+52>>2],h=i[n+40>>2]):h=0,n=Q0(i[r>>2],2),n?(R=i[n+40>>2],n=i[n+52>>2]):n=0,s=Q0(o,0),s?(S=i[s+52>>2],N=i[s+40>>2]):N=0,s=Q0(o,1),s?(U=i[s+40>>2],s=i[s+52>>2]):s=0,B=Q0(o,2),B?(V=i[B+52>>2],B=i[B+40>>2]):B=0,x=0;r:{if(!j||(r=Q0(i[r>>2],6),r?(X0=i[r+40>>2],r=i[r+52>>2]):r=0,V0=r,r=Q0(o,6),x=0,!r))break r;C0=i[r+52>>2],x=i[r+40>>2]}r:{if(!_)break r;Q=_&1,d=_-1|0;f:{if(!d){r=0;break f}for(m=_&-2,r=0;t[g(r,s)+U|0]=u[g(r,l)+h|0],t[g(r,V)+B|0]=u[g(r,n)+R|0],w=r|1,t[g(w,s)+U|0]=u[g(l,w)+h|0],t[g(w,V)+B|0]=u[g(n,w)+R|0],r=r+2|0,I=I+2|0,(m|0)!=(I|0););}Q&&(t[g(r,s)+U|0]=u[g(r,l)+h|0],t[g(r,V)+B|0]=u[g(r,n)+R|0]);f:{if(k&1)break f;c=_&1,w=(k+B|0)-1|0,Q=(k+U|0)-1|0,r=k>>>1|0,m=(r+R|0)-1|0,I=(r+h|0)-1|0;A:{if(!d){r=0;break A}for(A0=_&-2,r=0;t[Q+g(r,s)|0]=u[I+g(r,l)|0],t[w+g(r,V)|0]=u[m+g(r,n)|0],Y=r|1,t[Q+g(Y,s)|0]=u[I+g(l,Y)|0],t[w+g(V,Y)|0]=u[m+g(n,Y)|0],r=r+2|0,q=q+2|0,(A0|0)!=(q|0););}if(!c)break f;t[Q+g(r,s)|0]=u[I+g(r,l)|0],t[w+g(r,V)|0]=u[m+g(r,n)|0]}if(I=k-1|0,I>>>0>=2)for(w=0;;){for(Y=g(w,V)+B|0,c=g(s,w)+U|0,A0=g(n,w)+R|0,q=g(l,w)+h|0,r=1;G=r>>>1|0,m=G+A0|0,Q=u[m|0],m=u[m+1|0],_0=r+c|0,G=G+q|0,g0=u[G|0],G=u[G+1|0],t[_0|0]=(g(g0,3)+G|0)+2>>>2,t[_0+1|0]=(g(G,3)+g0|0)+2>>>2,G=r+Y|0,t[G+1|0]=(Q+g(m,3)|0)+2>>>2,t[G|0]=(m+g(Q,3)|0)+2>>>2,r=r+2|0,I>>>0>r>>>0;);if(w=w+1|0,(_|0)==(w|0))break}if(j){for(n=k<<(t0>>>0>8),r=0;k&&z(g(r,S)+N|0,g(r,E)+O|0,k),n&&z(g(r,C0)+x|0,g(r,V0)+X0|0,n),r=r+1|0,(_|0)!=(r|0););break r}l=_&1;f:{if(!d){r=0;break f}for(s=_&-2,r=0,n=0;h=!k,h||z(g(r,S)+N|0,g(r,E)+O|0,k),h||(h=r|1,z(g(h,S)+N|0,g(h,E)+O|0,k)),r=r+2|0,n=n+2|0,(s|0)!=(n|0););}if(!l|!k)break r;z(g(r,S)+N|0,g(r,E)+O|0,k)}t[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=o;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=e+128|0}function K9(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0;h=v+-64|0,v=h,i[h+60>>2]=e,O=h+39|0,E=h+40|0;i:{e:{r:{f:{A:for(;;){l=0;k:for(;;){if(w=e,(G^2147483647)<(l|0))break f;G=l+G|0;n:{t:{o:{l:{if(l=e,s=u[l|0],s)for(;;){u:{e=s&255;s:{if(!e){e=l;break s}if((e|0)!=37)break u;for(s=l;;){if(u[s+1|0]!=37){e=s;break s}if(l=l+1|0,m=u[s+2|0],e=s+2|0,s=e,(m|0)!=37)break}}if(l=l-w|0,j=G^2147483647,(l|0)>(j|0))break f;if(A&&m4(A,w,l),l)continue k;i[h+60>>2]=e,l=e+1|0,Q=-1,s=t[e+1|0]-48|0,u[e+2|0]!=36|s>>>0>9||(R=1,Q=s,l=e+3|0),i[h+60>>2]=l,B=0,s=t[l|0],e=s-32|0;s:{if(e>>>0>31){m=l;break s}if(m=l,e=1<<e,!(e&75913))break s;for(;;){if(m=l+1|0,i[h+60>>2]=m,B=e|B,s=t[l+1|0],e=s-32|0,e>>>0>=32)break s;if(l=m,e=1<<e,!(e&75913))break}}s:{if((s|0)==42){e=t[m+1|0]-48|0;h:{if(!(u[m+2|0]!=36|e>>>0>9)){w:{if(!A){i[(e<<2)+k>>2]=10,I=0;break w}I=i[(e<<3)+f>>2]}e=m+3|0,R=1;break h}if(R)break l;if(e=m+1|0,!A){i[h+60>>2]=e,R=0,I=0;break s}l=i[r>>2],i[r>>2]=l+4,I=i[l>>2],R=0}if(i[h+60>>2]=e,(I|0)>=0)break s;I=0-I|0,B=B|8192;break s}if(I=Vu(h+60|0),(I|0)<0)break f;e=i[h+60>>2]}l=0,_=-1,s=0;s:{if(u[e|0]!=46)break s;if(u[e+1|0]==42){s=t[e+2|0]-48|0;h:{if(!(u[e+3|0]!=36|s>>>0>9)){e=e+4|0;w:{if(!A){i[(s<<2)+k>>2]=10,_=0;break w}_=i[(s<<3)+f>>2]}break h}if(R)break l;if(e=e+2|0,_=0,!A)break h;s=i[r>>2],i[r>>2]=s+4,_=i[s>>2]}i[h+60>>2]=e,s=(_|0)>=0;break s}i[h+60>>2]=e+1,_=Vu(h+60|0),e=i[h+60>>2],s=1}for(U=s;;){if(N=l,m=28,V=e,s=t[e|0],s-123>>>0<4294967238)break r;if(e=e+1|0,l=u[(s+g(l,58)|0)+75711|0],!((l-1&255)>>>0<8))break}i[h+60>>2]=e;s:{if((l|0)!=27){if(!l)break r;if((Q|0)>=0){if(!A){i[(Q<<2)+k>>2]=l;continue A}l=(Q<<3)+f|0,s=i[l+4>>2],i[h+48>>2]=i[l>>2],i[h+52>>2]=s;break s}if(!A)break n;to(h+48|0,l,r,o);break s}if((Q|0)>=0)break r;if(l=0,!A)continue k}if(u[A|0]&32)break e;s=B&-65537,B=B&8192?s:B,Q=0,x=3141,m=E;s:{h:{w:{_:{v:{B:{m:{g:{Z:{W:{X:{V:{I:{F:{Q:{p:{Y:switch(V=u[V|0],l=V<<24>>24,l=N&&(V&15)==3?l&-45:l,l-88|0){case 0:case 32:break I;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 10:case 16:case 18:case 19:case 20:case 21:case 25:case 26:case 28:case 30:case 31:break t;case 9:case 13:case 14:case 15:break s;case 11:break g;case 12:case 17:break X;case 22:break Q;case 23:break V;case 24:break F;case 27:break m;case 29:break p;default:break Y}Y:switch(l-65|0){case 1:case 3:break t;case 0:case 4:case 5:case 6:break s;case 2:break B;default:break Y}if((l|0)==83)break v;break t}s=i[h+48>>2],V=i[h+52>>2],e=3141;break W}l=0;Q:switch(N|0){case 0:i[i[h+48>>2]>>2]=G;continue k;case 1:i[i[h+48>>2]>>2]=G;continue k;case 2:w=i[h+48>>2],i[w>>2]=G,i[w+4>>2]=G>>31;continue k;case 3:X[i[h+48>>2]>>1]=G;continue k;case 4:t[i[h+48>>2]]=G;continue k;case 6:i[i[h+48>>2]>>2]=G;continue k;case 7:break Q;default:continue k}w=i[h+48>>2],i[w>>2]=G,i[w+4>>2]=G>>31;continue k}_=_>>>0<=8?8:_,B=B|8,l=120}if(e=E,S=l&32,w=i[h+52>>2],V=w,s=i[h+48>>2],Y=s,s|w)for(;e=e-1|0,t[e|0]=S|u[(Y&15)+76240|0],N=!w&Y>>>0>15|(w|0)!=0,Y=(w&15)<<28|Y>>>4,w=w>>>4|0,!!N;);if(w=e,!(s|V)|!(B&8))break Z;x=(l>>>4|0)+3141|0,Q=2;break Z}if(e=E,w=i[h+52>>2],V=w,s=i[h+48>>2],Y=s,s|w)for(;e=e-1|0,t[e|0]=Y&7|48,N=!w&Y>>>0>7|(w|0)!=0,Y=(w&7)<<29|Y>>>3,w=w>>>3|0,!!N;);if(w=e,!(B&8))break Z;e=E-e|0,_=(e|0)<(_|0)?_:e+1|0;break Z}if(s=i[h+48>>2],e=i[h+52>>2],V=e,(e|0)<0){l=0-(e+((s|0)!=0)|0)|0,V=l,s=0-s|0,i[h+48>>2]=s,i[h+52>>2]=l,Q=1,e=3141;break W}if(B&2048){Q=1,e=3142;break W}Q=B&1,e=Q?3143:3141}x=e,w=Ti(s,V,E)}if((_|0)<0&U)break f;if(B=U?B&-65537:B,!(_|(s|V)!=0)){w=E,_=0;break t}e=!(s|V)+(E-w|0)|0,_=(e|0)<(_|0)?_:e;break t}l=u[h+48|0];break o}if(e=i[h+48>>2],w=e||29599,e=_>>>0>=2147483647?2147483647:_,l=l5(w,0,e),e=l?l-w|0:e,m=e+w|0,(_|0)>=0){B=s,_=e;break t}if(B=s,_=e,u[m|0])break f;break t}if(l=i[h+48>>2],l|i[h+52>>2])break _;l=0;break o}if(_){s=i[h+48>>2];break w}l=0,W4(A,32,I,0,B);break h}i[h+12>>2]=0,i[h+8>>2]=l,s=h+8|0,i[h+48>>2]=s,_=-1}for(l=0;;){w:{if(w=i[s>>2],!w)break w;if(w=Zf(h+4|0,w),(w|0)<0)break e;if(w>>>0>_-l>>>0)break w;if(s=s+4|0,l=l+w|0,_>>>0>l>>>0)continue}break}if(m=61,(l|0)<0)break r;if(W4(A,32,I,l,B),!l){l=0;break h}for(m=0,s=i[h+48>>2];;){if(w=i[s>>2],!w||(_=h+4|0,w=Zf(_,w),m=w+m|0,m>>>0>l>>>0))break h;if(m4(A,_,w),s=s+4|0,!(l>>>0>m>>>0))break}}W4(A,32,I,l,B^8192),l=(l|0)<(I|0)?I:l;continue k}if((_|0)<0&U)break f;if(m=61,l=W[n|0](A,u0[h+48>>3],I,_,B,l)|0,(l|0)>=0)continue k;break r}s=u[l+1|0],l=l+1|0}if(A)break i;if(!R)break n;for(l=1;;){if(A=i[(l<<2)+k>>2],A){if(to((l<<3)+f|0,A,r,o),G=1,l=l+1|0,(l|0)!=10)continue;break i}break}if(l>>>0>=10){G=1;break i}for(;;){if(i[(l<<2)+k>>2])break l;if(G=1,l=l+1|0,(l|0)==10)break}break i}m=28;break r}t[h+39|0]=l,_=1,w=O,B=s}if(s=m-w|0,_=(s|0)<(_|0)?_:s,(_|0)>(Q^2147483647))break f;if(m=61,e=_+Q|0,l=(e|0)<(I|0)?I:e,(j|0)<(l|0))break r;W4(A,32,l,e,B),m4(A,x,Q),W4(A,48,l,e,B^65536),W4(A,48,_,s,0),m4(A,w,s),W4(A,32,l,e,B^8192),e=i[h+60>>2];continue}break}break}G=0;break i}m=61}i[33136]=m}G=-1}return v=h- -64|0,G}function $9(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;n=v-48|0,v=n,s=C(248),f=s,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=101168,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,h=f+12|0,i[f+176>>2]=h,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),f=i[e>>2],t1(h,i[f+188>>2],i[f+192>>2],2,0);i:{e:{r:{if($2(i[e>>2],6)){if(i[n+8>>2]=i[e>>2],e=i[e+4>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),K4(n+28|0,h,n+8|0,6,0,r),t[n+47|0]<0&&Z(i[n+36>>2]),e=i[n+12>>2],!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e);break r}if(f=i[e>>2],i[f+200>>2]!=11)break r;i[n>>2]=f,e=i[e+4>>2],i[n+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),f=n+8|0,l=r,w=v-16|0,v=w;f:{A:{if(e=i[n>>2],r=i[e+204>>2],o=i[e+208>>2],(r|0)==(o|0))break A;for(m=i[e+192>>2],k=i[e+188>>2],e=r;;){if(i[e>>2]!=10){if(e=e+56|0,(o|0)!=(e|0))continue;break A}break}if(p[e+20>>1]!=8)break A;k:{n:{for(;;){if(i[r>>2]==10)break n;if(r=r+56|0,(o|0)==(r|0))break}e=0;break k}e=p[r+20>>1]}if(a0(f,h,0,k,m,e,l,0),i[f>>2])break f;t[f+19|0]<0&&Z(i[f+8>>2]);k:{n:{if(r=i[n>>2],e=i[r+204>>2],r=i[r+208>>2],(e|0)==(r|0))break n;for(;;){if(i[e>>2]!=10){if(e=e+56|0,(r|0)!=(e|0))continue;break n}break}I=i[e+52>>2],l=i[e+40>>2];break k}l=0}e=i[h+204>>2],o=i[h+208>>2],r=0;k:{if((e|0)==(o|0))break k;n:{for(;;){if(!i[e>>2])break n;if(e=e+56|0,(o|0)==(e|0))break}r=0;break k}Q=i[e+52>>2],r=i[e+40>>2]}if(!(!m|!k))for(V=l+3|0,Y=k&-4,G=k&3,E=k-1>>>0<3;;){if(k=g(B,Q)+r|0,l=g(B,I)+V|0,e=0,o=0,!E)for(;t[e+k|0]=u[l+(e<<2)|0],_=e|1,t[_+k|0]=u[l+(_<<2)|0],_=e|2,t[_+k|0]=u[l+(_<<2)|0],_=e|3,t[_+k|0]=u[l+(_<<2)|0],e=e+4|0,o=o+4|0,(Y|0)!=(o|0););if(o=0,G)for(;t[e+k|0]=u[l+(e<<2)|0],e=e+1|0,o=o+1|0,(G|0)!=(o|0););if(B=B+1|0,(B|0)==(m|0))break}if(e=i[28729],i[f>>2]=i[28728],i[f+4>>2]=e,e=f+8|0,t[114931]>=0){r=i[28731],i[e>>2]=i[28730],i[e+4>>2]=r,i[e+8>>2]=i[28732];break f}T(e,i[28730],i[28731]);break f}if(e=C(64),i[w+4>>2]=e,i[w+8>>2]=60,i[w+12>>2]=-2147483584,r=u[21941]|u[21942]<<8|(u[21943]<<16|u[21944]<<24),k=u[21937]|u[21938]<<8|(u[21939]<<16|u[21940]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+60|0]=0,r=u[21993]|u[21994]<<8|(u[21995]<<16|u[21996]<<24),t[e+56|0]=r,t[e+57|0]=r>>>8,t[e+58|0]=r>>>16,t[e+59|0]=r>>>24,r=u[21989]|u[21990]<<8|(u[21991]<<16|u[21992]<<24),k=u[21985]|u[21986]<<8|(u[21987]<<16|u[21988]<<24),t[e+48|0]=k,t[e+49|0]=k>>>8,t[e+50|0]=k>>>16,t[e+51|0]=k>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[21981]|u[21982]<<8|(u[21983]<<16|u[21984]<<24),k=u[21977]|u[21978]<<8|(u[21979]<<16|u[21980]<<24),t[e+40|0]=k,t[e+41|0]=k>>>8,t[e+42|0]=k>>>16,t[e+43|0]=k>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[21973]|u[21974]<<8|(u[21975]<<16|u[21976]<<24),k=u[21969]|u[21970]<<8|(u[21971]<<16|u[21972]<<24),t[e+32|0]=k,t[e+33|0]=k>>>8,t[e+34|0]=k>>>16,t[e+35|0]=k>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[21965]|u[21966]<<8|(u[21967]<<16|u[21968]<<24),k=u[21961]|u[21962]<<8|(u[21963]<<16|u[21964]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[21957]|u[21958]<<8|(u[21959]<<16|u[21960]<<24),k=u[21953]|u[21954]<<8|(u[21955]<<16|u[21956]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[21949]|u[21950]<<8|(u[21951]<<16|u[21952]<<24),k=u[21945]|u[21946]<<8|(u[21947]<<16|u[21948]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(f,4,0,w+4|0),t[w+15|0]>=0)break f;Z(i[w+4>>2])}v=w+16|0,e=i[n+4>>2];f:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;W[i[i[e>>2]+8>>2]](e),y(e)}if(i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,e=A+8|0,t[n+27|0]>=0){r=i[n+20>>2],i[e>>2]=i[n+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+24>>2],t[A+20|0]=1;break e}if(T(e,i[n+16>>2],i[n+20>>2]),e=t[n+27|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}if(t[n+27|0]>=0)break r;Z(i[n+16>>2])}t[n+14|0]=1,X[n+12>>1]=2,X[n+8>>1]=2,X[n+10>>1]=2,W[i[i[s+12>>2]+8>>2]](h,n+8|0),t[A+20|0]=0,i[A+4>>2]=s,i[A>>2]=h;break i}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=n+48|0}function We(A,e,r,f,k,n,o,l,s,h){var w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=0,c2=0,f1=0,o1=0,u1=0,y1=0,a1=0,d1=0;V=v-128|0,v=V;i:{e:{r:{if(x=i[A+140>>2],t0=x+g(e,24)|0,G=i[A+152>>2],U=g(G,r),I=(t0+g(U,24)|0)+4|0,B=f<<1,_0=u[I|0]>>>B&3,!_0)break r;if(R=g(e,k),N=i[A+148>>2],w=R>>N,(w|0)<0|(w|0)>=(G|0))break e;if(S=g(r,n),r=S>>N,(r|0)<0|(r|0)>=i[A+156>>2])break i;if(Q=i[A+124>>2],c=i[Q+(f?16840:16832)>>2],e=-1<<c^-1,Y=i[(f?36:28)+A>>2],q=(Y|0)<(n+S|0)?Y-S|0:n,E=i[(f?32:24)+A>>2],d=(E|0)<(k+R|0)?E-R|0:k,j=f?i[Q+16856>>2]-1|0:0,n=f?i[Q+16852>>2]-1|0:0,M0=u[(t0+g(U,24)|0)+22|0],(_0|0)==2){if(t0=i[A+132>>2],r=p[((x+g(w,24)|0)+g(g(r,G),24)|0)+2>>1]<<2,w=i[A+52>>2],U=i[i[r+w>>2]+808>>2],c=i[A+56>>2],k=i[Q+16876>>2],_0=i[Q+16892>>2],g0=u[I+1|0],r=I+(f<<2)|0,t[V|0]=u[r+5|0],f=u[r+6|0],t[V+2|0]=0,t[V+1|0]=f,t[V+3|0]=u[r+7|0],t[V+4|0]=u[r+8|0],(q|0)<=0|(d|0)<=0)break r;for(c=c-w>>2,r=(g0>>>B&3)<<2,g0=i[r+68840>>2],z0=i[r+68824>>2],X0=k-n|0,j0=R>>X0,A2=q-1|0,s2=d-1|0,V0=k-j|0,S0=g(_0,S>>V0),f=R<<1,v2=f+s|0,Z2=f+o|0,f=0,q0=i[r+68856>>2],X2=g(q0,l)<<1,r2=i[r+68872>>2],R2=g(r2,l)<<1;;){for(r=f+S|0,D2=(g(r,h)<<1)+v2|0,c2=(g(r,l)<<1)+Z2|0,C0=r<<j,o=C0>>N,f1=(x+g(g(o,G),24)|0)+2|0,s=r+q0|0,r0=s<<j>>N,o1=(x+g(g(G,r0),24)|0)+2|0,I=r+r2|0,f0=I<<j>>N,u1=(x+g(g(G,f0),24)|0)+2|0,y1=g(_0,I>>>V0|0)<<2,a1=g(_0,s>>>V0|0)<<2,d1=(f|0)==(A2|0),k=0;;){f:{A:{if(!(M0&1)){r=i[A+168>>2];break A}if(r=i[A+168>>2],!u[Q+8812|0])break A;if(B=k+R<<n>>r,(B|0)<0||(m=i[A+172>>2],(m|0)<=(B|0)))break e;if(_=C0>>r,(_|0)<0|(_|0)>=i[A+176>>2])break i;if(u[((i[A+160>>2]+g(B,3)|0)+g(g(_,m),3)|0)+1|0]&4)break f}if(_=k+R|0,O=_<<n,B=O>>r,(B|0)<0||(m=i[A+172>>2],(m|0)<=(B|0)))break e;if(r=C0>>r,(r|0)<0|(r|0)>=i[A+176>>2])break i;if(u[((i[A+160>>2]+g(B,3)|0)+g(g(r,m),3)|0)+1|0]&8)break f;A:{if(!(!f|!k|(k|0)==(s2|0))&&!d1)break A;if(r=_+g0|0,(r|0)>=(E|0)|(r|0)<0|((I|0)<0|(I|0)>=(Y|0)))break f;if(m=r<<n>>N,(m|0)<0|(G|0)<=(m|0))break e;if((f0|0)<0||(B=i[A+156>>2],(B|0)<=(f0|0)))break i;if(m=p[g(m,24)+u1>>1],m>>>0>=c>>>0||(m=i[w+(m<<2)>>2],!m))break r;O=O>>N,f2=(O|0)>=0&G>>>0>O>>>0,O=g(O,24)+f1|0;k:{if(A0=i[m+808>>2],(A0|0)<(U|0)){if(!f2)break e;if((o|0)<0|(o|0)>=(B|0))break k;if(!u[i[w+(p[O>>1]<<2)>>2]+772|0])break f}if(!u[m+772|0]&(U|0)<(A0|0)||(m=u[t0+57|0],!m&&(A0=r>>>X0<<2,r=i[t0+8484>>2],i[(A0+r|0)+y1>>2]!=i[(r+(j0<<2)|0)+(S0<<2)>>2]))||(r=_+z0|0,(r|0)>=(E|0)|(r|0)<0|((s|0)<0|(s|0)>=(Y|0))))break f;if(_=r<<n>>N,(_|0)<0|(G|0)<=(_|0))break e;if((r0|0)<0|(B|0)<=(r0|0))break i;if(_=p[g(_,24)+o1>>1],_>>>0>=c>>>0||(_=i[w+(_<<2)>>2],!_))break r;if(A0=i[_+808>>2],(A0|0)<(U|0)){if(!f2)break e;if((o|0)<0|(o|0)>=(B|0))break k;if(!u[i[w+(p[O>>1]<<2)>>2]+772|0])break f}if(!u[_+772|0]&(U|0)<(A0|0))break f;if(m||(_=r>>>X0<<2,r=i[t0+8484>>2],i[(_+r|0)+a1>>2]==i[(r+(j0<<2)|0)+(S0<<2)>>2]))break A;break f}break i}_=k<<1,B=_+c2|0,r=p[B>>1],m=_+D2|0,_=p[(B+(g0<<1)|0)+R2>>1],B=p[(B+(z0<<1)|0)+X2>>1],r=r+t[(((_>>>0<r>>>0)-(r>>>0<_>>>0)+((B>>>0<r>>>0)-(r>>>0<B>>>0))|0)+V|0)+2|0]|0,X[m>>1]=(r|0)>=0?(e|0)>(r|0)?r:e:0}if(k=k+1|0,(d|0)==(k|0))break}if(f=f+1|0,(q|0)==(f|0))break}break r}if(r=u[(f+I|0)+2|0],l0(V,0,128),i[((r&31)<<2)+V>>2]=1,i[((r+1&31)<<2)+V>>2]=2,i[((r+2&31)<<2)+V>>2]=3,i[((r+3&31)<<2)+V>>2]=4,N=c-5|0,!(M0&1)){if((q|0)<=0|(d|0)<=0)break r;for(n=I+5|0,r=0;;){for(A=r+S|0,G=(g(A,h)<<1)+s|0,Q=(g(A,l)<<1)+o|0,A=0;j=A+R<<1,k=p[j+Q>>1],I=i[((e>>>0>k>>>0?k:e)>>>N<<2)+V>>2],(I|0)>0&&(k=k+t[(I+(n+(f<<2)|0)|0)-1|0]|0,X[G+j>>1]=(k|0)>=0?(e|0)>(k|0)?k:e:0),A=A+1|0,(d|0)>(A|0););if(r=r+1|0,!((q|0)>(r|0)))break}break r}if((q|0)<=0|(d|0)<=0)break r;I=I+5|0,r=i[A+168>>2],G=0;f:{A:{k:{if(!u[Q+8812|0])for(;;){if(k=G+S|0,Q=k<<j>>r,(Q|0)<0)break k;for(x=(g(k,h)<<1)+s|0,U=(g(k,l)<<1)+o|0,k=0;;){if(Y=k+R|0,w=Y<<n>>r,(w|0)<0||(E=i[A+172>>2],(E|0)<=(w|0)))break e;if((Q|0)>=i[A+176>>2])break i;n:{if(u[((i[A+160>>2]+g(w,3)|0)+g(g(Q,E),3)|0)+1|0]&8||(Y=Y<<1,w=p[Y+U>>1],E=i[((e>>>0>w>>>0?w:e)>>>N<<2)+V>>2],(E|0)<=0))break n;w=w+t[(E+(I+(f<<2)|0)|0)-1|0]|0,X[Y+x>>1]=(w|0)>=0?(e|0)>(w|0)?w:e:0}if(k=k+1|0,!((d|0)>(k|0)))break}if(G=G+1|0,!((q|0)>(G|0)))break r}for(;;){if(k=G+S|0,Q=k<<j>>r,(Q|0)<0)break A;for(x=(g(k,h)<<1)+s|0,U=(g(k,l)<<1)+o|0,k=0;;){if(Y=k+R|0,w=Y<<n>>r,(w|0)<0||(E=i[A+172>>2],(E|0)<=(w|0)))break f;if((Q|0)>=i[A+176>>2])break i;w=(i[A+160>>2]+g(w,3)|0)+g(g(Q,E),3)|0;n:{if(u[w+1|0]&4|u[w+1|0]&8||(Y=Y<<1,w=p[Y+U>>1],E=i[((e>>>0>w>>>0?w:e)>>>N<<2)+V>>2],(E|0)<=0))break n;w=w+t[(E+(I+(f<<2)|0)|0)-1|0]|0,X[Y+x>>1]=(w|0)>=0?(e|0)>(w|0)?w:e:0}if(k=k+1|0,!((d|0)>(k|0)))break}if(G=G+1|0,!((q|0)>(G|0)))break}break r}if(e=R<<n>>r,(e|0)<0)break e;if((e|0)<i[A+172>>2])break i;break e}if(e=R<<n>>r,(e|0)<0|(e|0)>=i[A+172>>2])break f;break i}break e}v=V+128|0;return}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function Am(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0;e=v-128|0,v=e,o=K0(i[r>>2],0),s=K0(i[r>>2],1),h=K0(i[r>>2],2),R=$2(i[r>>2],6),R&&(O=K0(i[r>>2],6));i:{if(!(!(o>>>0<9|s>>>0<9)&h>>>0>8)){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}if(!((o|0)==(s|0)&(o|0)==(h|0))){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}f=i[r>>2],k=i[f+192>>2],_=i[f+188>>2],f=C(248),i[f>>2]=101168,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,n=f+12|0,i[f+176>>2]=n,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(n,_,k,0,2),a0(e+56|0,n,0,_,k,o,l,0),w=_+1>>>1|0,a0(e+32|0,n,1,w,k,s,l,0),o=e+88|0;e:{if(i[e+56>>2]){if(s=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=s,t[e+75|0]>=0){s=e- -64|0,B=i[s+4>>2],i[o>>2]=i[s>>2],i[o+4>>2]=B,i[o+8>>2]=i[s+8>>2];break e}T(o,i[e+64>>2],i[e+68>>2]);break e}if(s=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=s,t[e+51|0]>=0){s=i[e+44>>2],i[o>>2]=i[e+40>>2],i[o+4>>2]=s,i[o+8>>2]=i[e+48>>2];break e}T(o,i[e+40>>2],i[e+44>>2])}a0(e+8|0,n,2,w,k,h,l,0),s=e+112|0;e:{if(i[e+80>>2]){if(h=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=h,t[e+99|0]>=0){h=i[o+4>>2],i[s>>2]=i[o>>2],i[s+4>>2]=h,i[s+8>>2]=i[o+8>>2];break e}T(s,i[e+88>>2],i[e+92>>2]);break e}if(o=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=o,t[e+27|0]>=0){o=i[e+20>>2],i[s>>2]=i[e+16>>2],i[s+4>>2]=o,i[s+8>>2]=i[e+24>>2];break e}T(s,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[s+4>>2],i[r>>2]=i[s>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!R)break r;if(a0(e+104|0,n,6,_,k,O,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}o=Q0(i[r>>2],0);r:{if(!o){s=0;break r}N=i[o+40>>2],s=i[o+52>>2]>>>1|0}o=Q0(i[r>>2],1),o?(U=i[o+52>>2]>>>1|0,m=i[o+40>>2]):m=0,o=Q0(i[r>>2],2),o?(S=i[o+40>>2],o=i[o+52>>2]>>>1|0):o=0,l=Q0(n,0),l?(x=i[l+52>>2]>>>1|0,h=i[l+40>>2]):h=0,l=Q0(n,1),l?(q=i[l+40>>2],B=i[l+52>>2]>>>1|0):B=0,l=Q0(n,2),l?(j=i[l+52>>2]>>>1|0,l=i[l+40>>2]):l=0,d=l,l=0;r:{if(!R||(r=Q0(i[r>>2],6),r?(c=i[r+40>>2],r=i[r+52>>2]):r=0,A0=r,r=Q0(n,6),l=0,!r))break r;t0=i[r+52>>2],l=i[r+40>>2]}_0=l;r:{f:{A:{if(!(_&1))break A;if(Y=k-1|0,!Y)break f;if(r=w<<1,l=(r+d|0)-2|0,G=_<<1,w=(G+S|0)-2|0,E=(r+q|0)-2|0,G=(G+m|0)-2|0,r=0,(k|0)!=2)for(I=Y&-2;X[E+(g(r,B)<<1)>>1]=p[G+(g(r,U)<<1)>>1],X[l+(g(r,j)<<1)>>1]=p[w+(g(r,o)<<1)>>1],V=r|1,X[E+(g(V,B)<<1)>>1]=p[G+(g(U,V)<<1)>>1],X[l+(g(V,j)<<1)>>1]=p[w+(g(o,V)<<1)>>1],r=r+2|0,Q=Q+2|0,(I|0)!=(Q|0););if(!(Y&1))break A;X[E+(g(r,B)<<1)>>1]=p[G+(g(r,U)<<1)>>1],X[l+(g(r,j)<<1)>>1]=p[w+(g(r,o)<<1)>>1]}if(!k)break r}if(w=_-1|0,w)for(l=0;;){for(E=(g(l,j)<<1)+d|0,G=(g(l,B)<<1)+q|0,V=(g(o,l)<<1)+S|0,Y=(g(l,U)<<1)+m|0,r=0;I=r<<1,Q=I+V|0,g0=p[Q>>1],Q=p[Q+2>>1],I=I+Y|0,X[r+G>>1]=(p[I>>1]+p[I+2>>1]|0)+1>>>1,X[r+E>>1]=(Q+g0|0)+1>>>1,r=r+2|0,w>>>0>r>>>0;);if(l=l+1|0,(l|0)==(k|0))break}if(l=_<<1,R){for(o=O>>>0>8?l:_,r=0;l&&z((g(r,x)<<1)+h|0,(g(r,s)<<1)+N|0,l),o&&z(g(r,t0)+_0|0,g(r,A0)+c|0,o),r=r+1|0,(k|0)!=(r|0););break r}if(r=0,(k|0)!=1)for(B=k&-2,o=0;m=!l,m||z((g(r,x)<<1)+h|0,(g(r,s)<<1)+N|0,l),m||(m=r|1,z((g(m,x)<<1)+h|0,(g(s,m)<<1)+N|0,l)),r=r+2|0,o=o+2|0,(B|0)!=(o|0););if(!(k&1)|!l)break r;z((g(r,x)<<1)+h|0,(g(r,s)<<1)+N|0,l)}t[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=n;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=e+128|0}function km(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0;k=v-48|0,v=k,e=i[r>>2],n=i[e+192>>2],e=i[e+188>>2],s=C(248),i[s>>2]=101168,i[s+4>>2]=0,i[s+8>>2]=0,l0(s+16|0,0,156),i[s+76>>2]=0,i[s+80>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,t[s+24|0]=1,X[s+22>>1]=2,X[s+18>>1]=2,X[s+20>>1]=2,i[s+84>>2]=0,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+128>>2]=0,i[s+132>>2]=0,i[s+100>>2]=0,i[s+104>>2]=1,i[s+136>>2]=0,i[s+140>>2]=0,i[s+144>>2]=0,i[s+148>>2]=0,i[s+152>>2]=0,i[s+156>>2]=0,X[s+158>>1]=0,X[s+160>>1]=0,X[s+162>>1]=0,X[s+164>>1]=0,i[s+184>>2]=0,i[s+188>>2]=0,i[s+172>>2]=255,i[s+192>>2]=0,i[s+196>>2]=5186,i[s+208>>2]=99,i[s+212>>2]=99,i[s+200>>2]=0,i[s+204>>2]=0,i[s+12>>2]=101488,i[s+216>>2]=0,i[s+220>>2]=0,i[s+224>>2]=0,i[s+228>>2]=0,i[s+232>>2]=0,i[s+236>>2]=0,i[s+240>>2]=0,i[s+244>>2]=0,Y=s+12|0,i[s+176>>2]=Y,i[s+8>>2]=i[s+8>>2]+1,i[s+180>>2]=s,i[s+4>>2]==-1&&(W[i[i[s>>2]+8>>2]](s),y(s)),o=e,e=i[r>>2],t1(Y,o,n,i[e+196>>2],i[e+200>>2]);i:{if(!$2(i[r>>2],0)||(K4(k+28|0,Y,r,0,0,l),t[k+47|0]>=0))break i;Z(i[k+36>>2])}i:{if(!$2(i[r>>2],1)||(K4(k+28|0,Y,r,1,1,l),t[k+47|0]>=0))break i;Z(i[k+36>>2])}i:{if(!$2(i[r>>2],2)||(K4(k+28|0,Y,r,2,2,l),t[k+47|0]>=0))break i;Z(i[k+36>>2])}i:{if(!$2(i[r>>2],3)||(K4(k+28|0,Y,r,3,3,l),t[k+47|0]>=0))break i;Z(i[k+36>>2])}i:{if(!$2(i[r>>2],4)||(K4(k+28|0,Y,r,4,4,l),t[k+47|0]>=0))break i;Z(i[k+36>>2])}i:{if(!$2(i[r>>2],5)||(K4(k+28|0,Y,r,5,5,l),t[k+47|0]>=0))break i;Z(i[k+36>>2])}i:{e:{if(!$2(i[r>>2],6))break e;h=K0(i[r>>2],6),B=i[f+12>>2],m=V8(i[r>>2],6),R=p8(i[r>>2],6),a0(k+8|0,Y,6,m,R,B,l,0);r:{if(i[k+8>>2]){if(e=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=e,r=A+8|0,t[k+27|0]>=0){e=i[k+20>>2],i[r>>2]=i[k+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+24>>2],t[A+20|0]=1;break r}if(T(r,i[k+16>>2],i[k+20>>2]),e=t[k+27|0],t[A+20|0]=1,(e|0)>=0)break r;Z(i[k+16>>2]);break r}t[k+27|0]<0&&Z(i[k+16>>2]);f:{if(!((B|0)<9|h>>>0>8)){if(n=0,e=Q0(i[r>>2],6),e?(V=i[e+40>>2],f=i[e+52>>2]):f=0,e=Q0(Y,6),e?(n=i[e+52>>2]>>>1|0,e=i[e+40>>2]):e=0,!R|!m)break f;for(I=B-h|0,w=(h<<1)-B|0,Q=m&-2,B=m&1,o=0;;){if(_=g(f,o)+V|0,G=e+(g(n,o)<<1)|0,r=0,l=0,(m|0)!=1)for(;h=u[r+_|0],X[G+(r<<1)>>1]=h<<I|h>>>w,h=r|1,E=u[h+_|0],X[G+(h<<1)>>1]=E<<I|E>>>w,r=r+2|0,l=l+2|0,(Q|0)!=(l|0););if(B&&(l=G+(r<<1)|0,r=u[r+_|0],X[l>>1]=r<<I|r>>>w),o=o+1|0,(R|0)==(o|0))break}break f}if(e=h>>>0<9,!(e|(B|0)>8)){if(n=0,e=Q0(i[r>>2],6),e?(V=i[e+40>>2],f=i[e+52>>2]>>>1|0):f=0,e=Q0(Y,6),e?(n=i[e+52>>2],e=i[e+40>>2]):e=0,!R|!m)break f;for(w=h-8|0,Q=m&-4,E=m&3,o=0,B=m-1>>>0<3;;){if(_=e+g(n,o)|0,G=(g(f,o)<<1)+V|0,r=0,l=0,!B)for(;t[r+_|0]=p[G+(r<<1)>>1]>>>w,h=r|1,t[h+_|0]=p[G+(h<<1)>>1]>>>w,h=r|2,t[h+_|0]=p[G+(h<<1)>>1]>>>w,h=r|3,t[h+_|0]=p[G+(h<<1)>>1]>>>w,r=r+4|0,l=l+4|0,(Q|0)!=(l|0););if(l=0,E)for(;t[r+_|0]=p[G+(r<<1)>>1]>>>w,r=r+1|0,l=l+1|0,(E|0)!=(l|0););if(o=o+1|0,(R|0)==(o|0))break}break f}if(r=Q0(i[r>>2],6),!((B|0)<9|e)){if(r?(G=i[r+40>>2],o=i[r+52>>2]>>>1|0):o=0,e=Q0(Y,6),e?(E=i[e+52>>2]>>>1|0,e=i[e+40>>2]):e=0,h>>>0<B>>>0){if(!R|!m)break f;for(V=B-h|0,I=(h<<1)-B|0,B=m&-2,h=m&1,n=0;;){if(w=e+(g(n,E)<<1)|0,_=(g(n,o)<<1)+G|0,r=0,l=0,(m|0)!=1)for(;Q=r<<1,f=p[Q+_>>1],X[w+Q>>1]=f<<V|f>>>I,f=Q|2,Q=p[f+_>>1],X[f+w>>1]=Q<<V|Q>>>I,r=r+2|0,l=l+2|0,(B|0)!=(l|0););if(h&&(r=r<<1,f=p[r+_>>1],X[r+w>>1]=f<<V|f>>>I),n=n+1|0,(R|0)==(n|0))break}break f}if(!R|!m)break f;for(V=h-B|0,B=m&-4,Q=m&3,n=0,h=m-1>>>0<3;;){if(I=e+(g(n,E)<<1)|0,w=(g(n,o)<<1)+G|0,r=0,f=0,!h)for(;_=r<<1,X[_+I>>1]=p[w+_>>1]>>>V,l=_|2,X[l+I>>1]=p[l+w>>1]>>>V,l=_|4,X[l+I>>1]=p[l+w>>1]>>>V,l=_|6,X[l+I>>1]=p[l+w>>1]>>>V,r=r+4|0,f=f+4|0,(B|0)!=(f|0););if(l=0,Q)for(;f=r<<1,X[f+I>>1]=p[f+w>>1]>>>V,r=r+1|0,l=l+1|0,(Q|0)!=(l|0););if(n=n+1|0,(R|0)==(n|0))break}break f}if(n=0,r?(V=i[r+40>>2],f=i[r+52>>2]):f=0,e=Q0(Y,6),e?(n=i[e+52>>2],e=i[e+40>>2]):e=0,(h|0)<(B|0)){if(!R|!m)break f;for(I=B-h|0,w=(h<<1)-B|0,Q=m&-2,B=m&1,o=0;;){if(_=e+g(n,o)|0,G=g(f,o)+V|0,r=0,l=0,(m|0)!=1)for(;h=u[r+G|0],t[r+_|0]=h<<I|h>>>w,h=r|1,E=u[h+G|0],t[h+_|0]=E<<I|E>>>w,r=r+2|0,l=l+2|0,(Q|0)!=(l|0););if(B&&(l=r+_|0,r=u[r+G|0],t[l|0]=r<<I|r>>>w),o=o+1|0,(R|0)==(o|0))break}break f}if(!R|!m)break f;for(w=h-B|0,Q=m&-4,E=m&3,o=0,B=m-1>>>0<3;;){if(_=e+g(n,o)|0,G=g(f,o)+V|0,r=0,l=0,!B)for(;t[r+_|0]=u[r+G|0]>>>w,h=r|1,t[h+_|0]=u[h+G|0]>>>w,h=r|2,t[h+_|0]=u[h+G|0]>>>w,h=r|3,t[h+_|0]=u[h+G|0]>>>w,r=r+4|0,l=l+4|0,(Q|0)!=(l|0););if(l=0,E)for(;t[r+_|0]=u[r+G|0]>>>w,r=r+1|0,l=l+1|0,(E|0)!=(l|0););if(o=o+1|0,(R|0)==(o|0))break}}break e}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;W[i[i[s>>2]+8>>2]](s),y(s);break i}t[A+20|0]=0,i[A+4>>2]=s,i[A>>2]=Y}v=k+48|0}function nm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;f=v-16|0,v=f,B=w2(r);i:{e:{if(w=Q2(r),!w)break e;for(;;){if(n=Q2(r),n<<24>>24<0){if(e=C(40),i[f+4>>2]=e,i[f+8>>2]=38,i[f+12>>2]=-2147483608,r=u[17772]|u[17773]<<8|(u[17774]<<16|u[17775]<<24),k=u[17768]|u[17769]<<8|(u[17770]<<16|u[17771]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+38|0]=0,r=u[17802]|u[17803]<<8|(u[17804]<<16|u[17805]<<24),k=u[17798]|u[17799]<<8|(u[17800]<<16|u[17801]<<24),t[e+30|0]=k,t[e+31|0]=k>>>8,t[e+32|0]=k>>>16,t[e+33|0]=k>>>24,t[e+34|0]=r,t[e+35|0]=r>>>8,t[e+36|0]=r>>>16,t[e+37|0]=r>>>24,r=u[17796]|u[17797]<<8|(u[17798]<<16|u[17799]<<24),k=u[17792]|u[17793]<<8|(u[17794]<<16|u[17795]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[17788]|u[17789]<<8|(u[17790]<<16|u[17791]<<24),k=u[17784]|u[17785]<<8|(u[17786]<<16|u[17787]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[17780]|u[17781]<<8|(u[17782]<<16|u[17783]<<24),k=u[17776]|u[17777]<<8|(u[17778]<<16|u[17779]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,4,3002,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(n>>>0>=17){if(e=C(56),i[f+4>>2]=e,i[f+8>>2]=51,i[f+12>>2]=-2147483592,r=u[17720]|u[17721]<<8|(u[17722]<<16|u[17723]<<24),k=u[17716]|u[17717]<<8|(u[17718]<<16|u[17719]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+51|0]=0,r=u[17763]|u[17764]<<8|(u[17765]<<16|u[17766]<<24),t[e+47|0]=r,t[e+48|0]=r>>>8,t[e+49|0]=r>>>16,t[e+50|0]=r>>>24,r=u[17760]|u[17761]<<8|(u[17762]<<16|u[17763]<<24),k=u[17756]|u[17757]<<8|(u[17758]<<16|u[17759]<<24),t[e+40|0]=k,t[e+41|0]=k>>>8,t[e+42|0]=k>>>16,t[e+43|0]=k>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[17752]|u[17753]<<8|(u[17754]<<16|u[17755]<<24),k=u[17748]|u[17749]<<8|(u[17750]<<16|u[17751]<<24),t[e+32|0]=k,t[e+33|0]=k>>>8,t[e+34|0]=k>>>16,t[e+35|0]=k>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[17744]|u[17745]<<8|(u[17746]<<16|u[17747]<<24),k=u[17740]|u[17741]<<8|(u[17742]<<16|u[17743]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[17736]|u[17737]<<8|(u[17738]<<16|u[17739]<<24),k=u[17732]|u[17733]<<8|(u[17734]<<16|u[17735]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[17728]|u[17729]<<8|(u[17730]<<16|u[17731]<<24),k=u[17724]|u[17725]<<8|(u[17726]<<16|u[17727]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,4,3002,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}r:{k=i[e+104>>2],l=i[e+108>>2];f:{if(k>>>0<l>>>0){t[k|0]=n,n=k+1|0;break f}if(s=i[e+100>>2],k=k-s|0,o=k+1|0,(o|0)<0)break r;if(l=l-s|0,h=l<<1,l=l>>>0>=1073741823?2147483647:o>>>0<h>>>0?h:o,l?o=C(l):o=0,h=o+k|0,t[h|0]=n,k&&z(o,s,k),i[e+108>>2]=o+l,n=h+1|0,i[e+104>>2]=n,i[e+100>>2]=o,!s)break f;Z(s)}if(i[e+104>>2]=n,_=_+1|0,w>>>0>(_&255)>>>0)continue;break e}break}s0(),M()}e:{if(!B)break e;for(;;){r:{i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,k=i[e+116>>2];f:{if(k>>>0<o0[e+120>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],s=i[f+4>>2],(n|0)!=(s|0)){if(n=n-s|0,(n|0)<0)break r;o=C(n),i[k+4>>2]=o,i[k>>2]=o,l=n+o|0,i[k+8>>2]=l,n&&z(o,s,n),i[k+4>>2]=l}k=k+12|0;break f}A:{k:{n:{if(w=i[e+116>>2],k=i[e+112>>2],o=w-k|0,n=((o|0)/12|0)+1|0,n>>>0<357913942){if(s=(i[e+120>>2]-k|0)/12|0,l=s<<1,n=s>>>0>=178956970?357913941:n>>>0<l>>>0?l:n,n>>>0>=357913942)break n;if(_=g(n,12),m=C(_),l=o+m|0,i[l+8>>2]=0,i[l>>2]=0,i[l+4>>2]=0,n=i[f+8>>2],s=i[f+4>>2],(n|0)!=(s|0)){if(n=n-s|0,(n|0)<0)break k;h=C(n),i[l>>2]=h,G=n+h|0,i[l+8>>2]=G,n&&z(h,s,n),i[l+4>>2]=G}if(s=l+g((o|0)/-12|0,12)|0,(k|0)!=(w|0)){for(o=k,n=s;i[n>>2]=i[o>>2],i[n+4>>2]=i[o+4>>2],i[n+8>>2]=i[o+8>>2],i[o+8>>2]=0,i[o>>2]=0,i[o+4>>2]=0,n=n+12|0,o=o+12|0,(w|0)!=(o|0););for(;n=i[k>>2],n&&(i[k+4>>2]=n,Z(n)),k=k+12|0,(w|0)!=(k|0););k=i[e+112>>2]}i[e+120>>2]=_+m,n=l+12|0,i[e+116>>2]=n,i[e+112>>2]=s,k&&Z(k),k=n;break A}s0(),M()}x0(),M()}s0(),M()}}if(i[e+116>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),I=I+1|0,(I&65535)>>>0<B>>>0)continue;break e}break}s0(),M()}if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function tm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;o=v-48|0,v=o,AA(o+24|0,e,r);i:{if(i[o+24>>2]){e=i[o+28>>2],i[A>>2]=i[o+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[o+40>>2],e=i[o+36>>2],i[A+8>>2]=i[o+32>>2],i[A+12>>2]=e,i[o+40>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0;break i}r=i[e+200>>2];e:{if(i[r+104>>2]==i[r+108>>2])break e;if(f=J5(i[e+192>>2],1),!f){if(e=C(32),i[o+12>>2]=e,i[o+16>>2]=27,i[o+20>>2]=-2147483616,r=u[23709]|u[23710]<<8|(u[23711]<<16|u[23712]<<24),k=u[23705]|u[23706]<<8|(u[23707]<<16|u[23708]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+27|0]=0,r=u[23728]|u[23729]<<8|(u[23730]<<16|u[23731]<<24),t[e+23|0]=r,t[e+24|0]=r>>>8,t[e+25|0]=r>>>16,t[e+26|0]=r>>>24,r=u[23725]|u[23726]<<8|(u[23727]<<16|u[23728]<<24),k=u[23721]|u[23722]<<8|(u[23723]<<16|u[23724]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[23717]|u[23718]<<8|(u[23719]<<16|u[23720]<<24),k=u[23713]|u[23714]<<8|(u[23715]<<16|u[23716]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,o+12|0),t[o+23|0]>=0)break i;Z(i[o+12>>2]);break i}r=0,n=i[e+184>>2],k=i[n+104>>2];r:{if(f=i[f+8>>2]-1|0,f>>>0<i[n+108>>2]-k>>3>>>0&&(r=k+(f<<3)|0,k=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),k))break r;if(e=C(40),i[o+12>>2]=e,i[o+16>>2]=35,i[o+20>>2]=-2147483608,k=u[8734]|u[8735]<<8|(u[8736]<<16|u[8737]<<24),f=u[8730]|u[8731]<<8|(u[8732]<<16|u[8733]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=k,t[e+5|0]=k>>>8,t[e+6|0]=k>>>16,t[e+7|0]=k>>>24,t[e+35|0]=0,k=u[8761]|u[8762]<<8|(u[8763]<<16|u[8764]<<24),t[e+31|0]=k,t[e+32|0]=k>>>8,t[e+33|0]=k>>>16,t[e+34|0]=k>>>24,k=u[8758]|u[8759]<<8|(u[8760]<<16|u[8761]<<24),f=u[8754]|u[8755]<<8|(u[8756]<<16|u[8757]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=k,t[e+29|0]=k>>>8,t[e+30|0]=k>>>16,t[e+31|0]=k>>>24,k=u[8750]|u[8751]<<8|(u[8752]<<16|u[8753]<<24),f=u[8746]|u[8747]<<8|(u[8748]<<16|u[8749]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=k,t[e+21|0]=k>>>8,t[e+22|0]=k>>>16,t[e+23|0]=k>>>24,k=u[8742]|u[8743]<<8|(u[8744]<<16|u[8745]<<24),f=u[8738]|u[8739]<<8|(u[8740]<<16|u[8741]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=k,t[e+13|0]=k>>>8,t[e+14|0]=k>>>16,t[e+15|0]=k>>>24,a(A,2,0,o+12|0),t[o+23|0]<0&&Z(i[o+12>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r);break i}r:{f:{if(k=Z0(k,92792,112596),k){if(r)break f;X[e+292>>1]=p[k+116>>1],X[e+294>>1]=p[k+118>>1];break e}if(e=C(64),i[o+12>>2]=e,i[o+16>>2]=60,i[o+20>>2]=-2147483584,f=u[27234]|u[27235]<<8|(u[27236]<<16|u[27237]<<24),n=u[27230]|u[27231]<<8|(u[27232]<<16|u[27233]<<24),t[e|0]=n,t[e+1|0]=n>>>8,t[e+2|0]=n>>>16,t[e+3|0]=n>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+60|0]=0,f=u[27286]|u[27287]<<8|(u[27288]<<16|u[27289]<<24),t[e+56|0]=f,t[e+57|0]=f>>>8,t[e+58|0]=f>>>16,t[e+59|0]=f>>>24,f=u[27282]|u[27283]<<8|(u[27284]<<16|u[27285]<<24),n=u[27278]|u[27279]<<8|(u[27280]<<16|u[27281]<<24),t[e+48|0]=n,t[e+49|0]=n>>>8,t[e+50|0]=n>>>16,t[e+51|0]=n>>>24,t[e+52|0]=f,t[e+53|0]=f>>>8,t[e+54|0]=f>>>16,t[e+55|0]=f>>>24,f=u[27274]|u[27275]<<8|(u[27276]<<16|u[27277]<<24),n=u[27270]|u[27271]<<8|(u[27272]<<16|u[27273]<<24),t[e+40|0]=n,t[e+41|0]=n>>>8,t[e+42|0]=n>>>16,t[e+43|0]=n>>>24,t[e+44|0]=f,t[e+45|0]=f>>>8,t[e+46|0]=f>>>16,t[e+47|0]=f>>>24,f=u[27266]|u[27267]<<8|(u[27268]<<16|u[27269]<<24),n=u[27262]|u[27263]<<8|(u[27264]<<16|u[27265]<<24),t[e+32|0]=n,t[e+33|0]=n>>>8,t[e+34|0]=n>>>16,t[e+35|0]=n>>>24,t[e+36|0]=f,t[e+37|0]=f>>>8,t[e+38|0]=f>>>16,t[e+39|0]=f>>>24,f=u[27258]|u[27259]<<8|(u[27260]<<16|u[27261]<<24),n=u[27254]|u[27255]<<8|(u[27256]<<16|u[27257]<<24),t[e+24|0]=n,t[e+25|0]=n>>>8,t[e+26|0]=n>>>16,t[e+27|0]=n>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[27250]|u[27251]<<8|(u[27252]<<16|u[27253]<<24),n=u[27246]|u[27247]<<8|(u[27248]<<16|u[27249]<<24),t[e+16|0]=n,t[e+17|0]=n>>>8,t[e+18|0]=n>>>16,t[e+19|0]=n>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[27242]|u[27243]<<8|(u[27244]<<16|u[27245]<<24),n=u[27238]|u[27239]<<8|(u[27240]<<16|u[27241]<<24),t[e+8|0]=n,t[e+9|0]=n>>>8,t[e+10|0]=n>>>16,t[e+11|0]=n>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,0,o+12|0),t[o+23|0]<0&&Z(i[o+12>>2]),!r)break i;if(e=i[r+4>>2],i[r+4>>2]=e-1,!e)break r;break i}if(i[r+4>>2]=i[r+4>>2]+1,X[e+292>>1]=p[k+116>>1],X[e+294>>1]=p[k+118>>1],e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),e=i[r+4>>2],i[r+4>>2]=e-1,e)break e}if(W[i[i[r>>2]+8>>2]](r),y(r),!k)break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}t[o+43|0]<0&&Z(i[o+32>>2]),v=o+48|0}function om(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;e=v-192|0,v=e,t[e+167|0]=0,t[e+168|0]=0,t[e+169|0]=0,t[e+170|0]=0,t[e+171|0]=0,t[e+172|0]=0,t[e+173|0]=0,t[e+174|0]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+176>>2]=0,i[e+180>>2]=0,i[e+188>>2]=0,t[e+184|0]=1,k=C(208),i[k>>2]=96908,i[k+4>>2]=0,i[k+8>>2]=0,o=k+16|0,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[o>>2]=106584,X[k+122>>1]=0,X[k+124>>1]=0,X[k+126>>1]=0,X[k+128>>1]=0,X[k+120>>1]=259,X[k+130>>1]=0,X[k+132>>1]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+168>>2]=0,i[k+172>>2]=0,i[k+176>>2]=0,i[k+180>>2]=0,X[k+182>>1]=0,X[k+184>>1]=0,X[k+186>>1]=0,X[k+188>>1]=0,i[k+200>>2]=0,i[k+192>>2]=0,i[k+196>>2]=0,i[k+32>>2]=1987470147,i[k+4>>2]=i[k+4>>2]+1,l=C(8),i[l+4>>2]=k,i[l>>2]=o,s=l+8|0,i[e+156>>2]=s,i[e+148>>2]=l,i[e+152>>2]=s,i[e+144>>2]=0,s=i[r>>2],l=i[r+4>>2];i:{if(!l){i[e+140>>2]=s;break i}if(i[l+4>>2]=i[l+4>>2]+1,i[e+140>>2]=s,r=i[e+144>>2],i[e+144>>2]=l,!r||(l=i[r+4>>2],i[r+4>>2]=l-1,l))break i;W[i[i[r>>2]+8>>2]](r),y(r)}W[i[i[f>>2]+100>>2]](e+128|0,i[f+4>>2],e+140|0,n);i:{e:{r:{f:{if(l=i[e+128>>2],l){if(f=i[e+132>>2],o=i[e+136>>2],r=l2(o),r>>>0>=2147483640)break f;A:{k:{if(r>>>0>=11){s=r|7,n=C(s+1|0),i[e+124>>2]=s-2147483647,i[e+116>>2]=n,i[e+120>>2]=r;break k}if(t[e+127|0]=r,n=e+116|0,!r)break A}if(!r)break A;z(n,o,r)}t[r+n|0]=0,r=a(e+24|0,l,f,e+116|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;A:{if(t[r+19|0]>=0){n=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[r+16>>2],t[A+44|0]=1;break A}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+44|0]=1,(f|0)>=0)break A;Z(i[r+8>>2])}if(t[e+127|0]>=0)break e;Z(i[e+116>>2]);break e}if(i[e+112>>2]=0,i[e+108>>2]=0,r=e+24|0,W[i[i[f>>2]+104>>2]](r,i[f+4>>2],e+104|0,e+100|0,0),i[e+136>>2]=i[e+32>>2],l=i[e+28>>2],n=i[e+24>>2],i[e+128>>2]=n,i[e+132>>2]=l,n)break r;for(l=r|2;;){if(n=i[e+104>>2],n){A:{k:{if(r=i[e+100>>2],(r|0)<2)break k;n:switch((u[n+1|0]>>>3|0)-14|0){case 1:X[e+24>>1]=259,X[l+8>>1]=0,X[l+10>>1]=0,X[l>>1]=0,X[l+2>>1]=0,X[l+4>>1]=0,X[l+6>>1]=0,X[e+86>>1]=0,X[e+88>>1]=0,X[e+90>>1]=0,X[e+92>>1]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,Tr(e+4|0,n,r,e+24|0,e+112|0,e+108|0,0),t[e+23|0]<0&&Z(i[e+12>>2]),r=e+24|0,n=i[r+4>>2],i[o+104>>2]=i[r>>2],i[o+108>>2]=n,i[o+112>>2]=i[r+8>>2],X[o+116>>1]=p[r+12>>1];t:{if((r|0)==(o+104|0)){Fl(o+132|0,r+28|0);break t}n=i[r+16>>2],s=i[r+20>>2],$4(o+120|0,n,s,s-n|0),Fl(o+132|0,r+28|0),n=i[r+40>>2],s=i[r+44>>2],$4(o+144|0,n,s,s-n|0),n=i[r+52>>2],s=i[r+56>>2],h1(o+156|0,n,s,s-n>>2)}i[o+168>>2]=i[r+64>>2],X[o+172>>1]=p[r+68>>1],r=i[e+76>>2],r&&(i[e+80>>2]=r,Z(r)),r=i[e+64>>2],r&&(i[e+68>>2]=r,Z(r)),r=i[e+52>>2],r&&Z(r),r=i[e+40>>2],r&&(i[e+44>>2]=r,Z(r)),r=i[e+100>>2],n=i[e+104>>2];break;case 0:case 2:break n;default:break k}q6(o,n,r);break A}C6(e+148|0,n,r)}if(W[i[i[f>>2]+104>>2]](e+24|0,i[f+4>>2],e+104|0,e+100|0,0),i[e+136>>2]=i[e+32>>2],r=i[e+28>>2],n=i[e+24>>2],i[e+128>>2]=n,i[e+132>>2]=r,!n)continue;break r}break}t[e+174|0]=0,X[e+172>>1]=257,r=i[e+156>>2],f=i[e+160>>2],i[e+156>>2]=0,n=i[e+148>>2],o=i[e+152>>2],i[e+148>>2]=0,i[e+152>>2]=0,l=i[e+164>>2],s=i[e+168>>2],i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[A+16>>2]=l,i[A+20>>2]=s,i[A+8>>2]=r,i[A+12>>2]=f,i[A>>2]=n,i[A+4>>2]=o,r=i[e+176>>2],i[A+24>>2]=i[e+172>>2],i[A+28>>2]=r,r=i[e+184>>2],i[A+32>>2]=i[e+180>>2],i[A+36>>2]=r,i[A+40>>2]=i[e+188>>2],t[A+44|0]=0;break e}I0(),M()}if(o=i[e+132>>2],l=i[e+136>>2],f=l2(l),f>>>0>=2147483640)break i;r:{f:{if(f>>>0>=11){s=f|7,r=C(s+1|0),i[e+124>>2]=s-2147483647,i[e+116>>2]=r,i[e+120>>2]=f;break f}if(t[e+127|0]=f,r=e+116|0,!f)break r}if(!f)break r;z(r,l,f)}t[r+f|0]=0,r=a(e+24|0,n,o,e+116|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;r:{if(t[r+19|0]>=0){n=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[r+16>>2],t[A+44|0]=1;break r}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+44|0]=1,(f|0)>=0)break r;Z(i[r+8>>2])}if(t[e+127|0]>=0)break e;Z(i[e+116>>2])}A=i[e+144>>2];e:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[k+4>>2],i[k+4>>2]=A-1,A||(W[i[i[k>>2]+8>>2]](k),y(k)),A=i[e+160>>2],A&&(i[e+164>>2]=A,Z(A)),A=i[e+148>>2],A){if(k=i[e+152>>2],f=A,(k|0)!=(A|0)){for(;;){r=i[k-4>>2];e:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=k-8|0,(A|0)==(k|0))break}f=i[e+148>>2]}i[e+152>>2]=A,Z(f)}v=e+192|0;return}I0(),M()}function d9(A,e,r){var f=0,k=0;i:{e:switch(r-1|0){case 2:k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107648,f=Qi(r+16|0,e),e=f,i[e+552>>2]=0,i[e+556>>2]=0,i[e>>2]=104940,i[e+560>>2]=0,i[e+564>>2]=0,e=C(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e>>2]=105128,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=105328,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[f+564>>2]=e,i[f+560>>2]=e+12;break i;case 0:k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107688,f=Qi(r+16|0,e),e=f,i[e+552>>2]=0,i[e+556>>2]=0,i[e>>2]=103840,i[e+560>>2]=0,i[e+564>>2]=0,e=C(92),i[e>>2]=104028,i[e+4>>2]=0,i[e+8>>2]=0,l0(e+20|0,0,72),i[e+16>>2]=0,i[e+12>>2]=104284,t[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,t[e+32|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,t[e+44|0]=0,i[f+564>>2]=e,i[f+560>>2]=e+12;break i;case 3:k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107728,f=Qi(r+16|0,e),e=f,i[e+552>>2]=0,i[e+556>>2]=0,i[e>>2]=104348,i[e+560>>2]=0,i[e+564>>2]=0,e=C(84),i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=104536,i[e+4>>2]=0,i[e+8>>2]=0,t[e+19|0]=0,t[e+20|0]=0,t[e+21|0]=0,t[e+22|0]=0,t[e+23|0]=0,t[e+24|0]=0,t[e+25|0]=0,t[e+26|0]=0,t[e+18|0]=1,X[e+16>>1]=0,i[e+12>>2]=104576,t[e+27|0]=0,t[e+28|0]=0,t[e+29|0]=0,t[e+30|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0,i[f+564>>2]=e,i[f+560>>2]=e+12;break i;case 4:k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107768,f=Qi(r+16|0,e),e=f,i[e+552>>2]=0,i[e+556>>2]=0,i[e>>2]=106216,i[e+560>>2]=0,i[e+564>>2]=0,e=C(96),i[e>>2]=106404,i[e+4>>2]=0,i[e+8>>2]=0,l0(e+20|0,0,76),i[e+16>>2]=0,i[e+12>>2]=106512,t[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,t[e+32|0]=0,i[f+564>>2]=e,i[f+560>>2]=e+12;break i;case 1:k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107808,f=Qi(r+16|0,e),e=f,i[e+552>>2]=0,i[e+556>>2]=0,i[e>>2]=106696,i[e+560>>2]=0,i[e+564>>2]=0,e=C(92),i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e>>2]=106884,i[e+4>>2]=0,i[e+8>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+12>>2]=107072,t[e+21|0]=0,t[e+22|0]=0,t[e+23|0]=0,t[e+24|0]=0,t[e+25|0]=0,t[e+26|0]=0,t[e+27|0]=0,t[e+28|0]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+88>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,t[e+40|0]=0,i[f+564>>2]=e,i[f+560>>2]=e+12;break i;case 6:case 9:k=C(584),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=107848,f=Qi(r+16|0,e),e=f,i[e+552>>2]=0,i[e+556>>2]=0,i[e>>2]=105392,i[e+560>>2]=0,i[e+564>>2]=0,e=C(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e>>2]=105580,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=105696,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[f+564>>2]=e,i[f+560>>2]=e+12;break i;case 8:break e;default:break i}k=C(568),r=k,i[r+80>>2]=0,i[r+84>>2]=0,t[r+76|0]=0,t[r+52|0]=0,i[r+48>>2]=0,i[r+40>>2]=1,i[r+44>>2]=1,i[r+32>>2]=0,i[r+36>>2]=0,t[r+28|0]=1,X[r+26>>1]=2,X[r+22>>1]=2,X[r+24>>1]=2,t[r+20|0]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+172>>2]=0,t[r+128|0]=0,t[r+112|0]=0,i[r>>2]=107888,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=1,X[r+162>>1]=0,X[r+164>>1]=0,X[r+166>>1]=0,X[r+168>>1]=0,i[r+156>>2]=0,i[r+160>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+140>>2]=0,i[r+144>>2]=0,i[r+132>>2]=0,i[r+136>>2]=0,i[r+180>>2]=0,i[r+184>>2]=0,i[r+176>>2]=255,i[r+188>>2]=0,i[r+192>>2]=5186,i[r+196>>2]=e,t[r+328|0]=0,i[r+200>>2]=0,i[r+204>>2]=0,i[r+208>>2]=0,i[r+212>>2]=0,i[r+216>>2]=0,i[r+220>>2]=0,X[r+224>>1]=0,i[r+228>>2]=0,i[r+232>>2]=0,X[r+234>>1]=0,X[r+236>>1]=0,X[r+238>>1]=0,X[r+240>>1]=0,i[r+244>>2]=0,i[r+248>>2]=0,t[r+252|0]=0,t[r+264|0]=0,i[r+256>>2]=0,i[r+260>>2]=0,i[r+364>>2]=0,i[r+356>>2]=0,i[r+360>>2]=0,i[r+348>>2]=0,i[r+352>>2]=0,i[r+340>>2]=0,i[r+344>>2]=0,i[r+332>>2]=0,i[r+336>>2]=0,t[r+368|0]=1,i[r+440>>2]=0,i[r+444>>2]=0,i[r+448>>2]=0,t[r+377|0]=0,t[r+378|0]=0,t[r+379|0]=0,t[r+380|0]=0,t[r+381|0]=0,t[r+382|0]=0,t[r+383|0]=0,t[r+384|0]=0,i[r+372>>2]=0,i[r+376>>2]=0,t[r+432|0]=0,i[r+424>>2]=0,i[r+428>>2]=0,i[r+416>>2]=0,i[r+420>>2]=0,i[r+408>>2]=0,i[r+412>>2]=0,i[r+400>>2]=0,i[r+404>>2]=0,i[r+392>>2]=0,i[r+396>>2]=0,X[r+452>>1]=1,i[r+472>>2]=0,i[r+476>>2]=0,i[r+464>>2]=0,i[r+468>>2]=0,i[r+456>>2]=0,i[r+460>>2]=0,i[r+480>>2]=0,i[r+484>>2]=1072693248,i[r+320>>2]=0,i[r+324>>2]=0,i[r+312>>2]=0,i[r+316>>2]=0,i[r+304>>2]=0,i[r+308>>2]=0,i[r+296>>2]=0,i[r+300>>2]=0,i[r+288>>2]=0,i[r+292>>2]=0,i[r+280>>2]=0,i[r+284>>2]=0,i[r+272>>2]=0,i[r+276>>2]=0,i[r+512>>2]=0,i[r+504>>2]=0,i[r+508>>2]=0,i[r+496>>2]=0,i[r+500>>2]=0,i[r+488>>2]=0,i[r+492>>2]=0,i[r+560>>2]=0,i[r+564>>2]=0,i[r+552>>2]=0,i[r+556>>2]=0,i[r+544>>2]=0,i[r+548>>2]=0,i[r+536>>2]=0,i[r+540>>2]=0,i[r+528>>2]=0,i[r+532>>2]=0,i[r+520>>2]=0,i[r+524>>2]=0,i[r+16>>2]=107208,f=r+16|0}i[A+4>>2]=k,i[A>>2]=f}function Xe(A,e,r,f,k,n,o,l,s,h,w,_,B,m,G){var I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0;i:{e:{if(Y=i[A+18588>>2],Q=i[Y+168>>2],I=e>>Q,(I|0)<0)break e;R=A+18548|0,N=r>>Q;r:{f:{A:{k:{n:{t:{for(;;){if(Q=i[Y+172>>2],(Q|0)<=(I|0))break e;if((N|0)<0|i[Y+176>>2]<=(N|0))break i;if(I=(i[Y+160>>2]+g(I,3)|0)+g(g(Q,N),3)|0,I=u[I|0]|u[I+1|0]<<8,N=I>>>8&3,(N|0)!=(B|0))break n;o:{l:{u:{s:{h:{V=i[Y+124>>2],Q=i[V+16940>>2]<(l|0);w:{_:{v:{if(!(Q|(s|0)>=(w|0)|(!s&(_|0)!=0|i[V+16936>>2]>=(l|0)))){if(l-3>>>0>=3)break k;if(W2(R,(i[A+18572>>2]-l|0)+25|0))break v;E=1;break w}if(E=1,Q|!s&(_|0)==1)break v;if(!(!(i[V+628>>2]|s)&(N|0)==1&(I&56)!=0))break _}if(Q=i[Y+248>>2],I=e>>Q,(I|0)<0||(E=i[Y+252>>2],(E|0)<=(I|0)))break A;if(Q=r>>Q,(Q|0)<0|(Q|0)>=i[Y+256>>2])break f;I=(I+i[Y+240>>2]|0)+g(Q,E)|0,t[I|0]=u[I|0]|1<<s,E=0}if((l|0)<3)break h}if(i[V+16848>>2])break s;I=-1,Y=0;break l}if(I=-1,i[V+16848>>2]!=3)break u}I=-1,Q=-1;s:{if(!(m&255)||(Q=W2(R,(i[A+18572>>2]+s|0)+16|0),!E&(l|0)!=3|i[V+16848>>2]!=2))break s;Q=W2(R,(i[A+18572>>2]+s|0)+16|0)<<1|Q}s:{if(!(G&255)||(I=W2(R,(i[A+18572>>2]+s|0)+16|0),!E&(l|0)!=3|i[V+16848>>2]!=2))break s;I=W2(R,(i[A+18572>>2]+s|0)+16|0)<<1|I}if((Q|0)>=0)break o}if(Y=(l|0)==2,(l|0)!=2)break l;if(!s)break r}Q=Y&&(s|0)>0?m&255:0}if((I|0)<0&&(I=(l|0)==2&&(s|0)>0?G&255:0),E)break t;if(l=l-1|0,s=s+1|0,f=Q&255,k=I&255,Xe(A,e,r,e,r,n,o,l,s,0,w,_,B,f,k),h=1<<l,E=h+e|0,Xe(A,E,r,e,r,n,o,l,s,1,w,_,B,f,k),V=r+h|0,Xe(A,e,V,e,r,n,o,l,s,2,w,_,B,f,k),Y=i[A+18588>>2],U=i[Y+168>>2],N=V>>U,h=3,G=I,m=Q,k=r,f=e,r=V,e=E,I=e>>U,!((I|0)>=0))break}break e}t:{if(N&&(w=1,!(s|Q|I)))break t;w=W2(R,i[A+18572>>2]+(s?14:15)|0)}t:{o:{l:{u:{s:{h:{if((Q|0)!=-1){if((I|0)==-1)break h;if((w|0)==-1)break s;if(s=i[A+18588>>2],m=i[s+124>>2],G=i[m+16848>>2],t[A+33|0]=0,t[A+34|0]=0,t[A+35|0]=0,t[A+36|0]=0,B=i[s+168>>2],_=e>>B,(_|0)<0||(V=i[s+172>>2],(V|0)<=(_|0)))break e;if(B=r>>B,(B|0)<0|(B|0)>=i[s+176>>2])break i;if(E=l-((G|0)!=3)|0,Y=(E|0)>2,R=u[((i[s+160>>2]+g(_,3)|0)+g(g(B,V),3)|0)+1|0],V=I|Q,!(V|w))break t;if(_=0,i[A+18500>>2]|!u[i[s+132>>2]+26|0])break o;if(_=1,B=A+18548|0,!W2(B,i[A+18572>>2]+139|0)){s=0,B=1;break l}if(s=1,!W2(B,i[A+18572>>2]+140|0))break u;if(!W2(B,i[A+18572>>2]+140|0)){s=2;break u}if(!W2(B,i[A+18572>>2]+140|0)){s=3;break u}if(!W2(B,i[A+18572>>2]+140|0)){s=4;break u}if(s=dA(B,0)+5|0,s)break u;s=0,B=1;break l}U0(23677,19977,3575,4168),M()}U0(23664,19977,3576,4168),M()}U0(23690,19977,3577,4168),M()}B=1-(B4(B)<<1)|0}i[A+18500>>2]=1,i[A+18504>>2]=g(s,B)}o:{l:{u:{if(!(!V|!u[i[A+18592>>2]+760|0]|(u[A+32|0]|i[A+18508>>2]))){if(_=A+18548|0,!W2(_,i[A+18572>>2]+23|0))break u;s=0,B=i[i[A+18588>>2]+132>>2],u[B+8250|0]>=2&&(s=W2(_,i[A+18572>>2]+24|0)),i[A+18508>>2]=1,s=s+B|0,i[A+18512>>2]=t[s+8251|0],s=t[s+8257|0];break l}if(_)break o;break t}i[A+18508>>2]=1,i[A+18512>>2]=0,s=0}i[A+18516>>2]=s}Jn(A,n,o)}n=i[m+16856>>2],s=i[m+16852>>2],i[A+28>>2]=0,w&&r6(A,e,r,l,0),V=Y?E:2,_=1<<V,B=1<<l,o=R&3,i6(A,e,r,B,0,o,(w|0)!=0);t:{if(!((G|0)!=3&(l|0)<=2)){f=0,k=0;o:{if(!w||(l=i[A+18588>>2],k=0,!(t[i[l+132>>2]+8247|0]&1)))break o;if((o|0)!=1){if(f=i[l+228>>2],h=e>>f,(h|0)<0||(B=i[l+232>>2],(B|0)<=(h|0)))break e;if(w=r>>f,(w|0)<0|(w|0)>=i[l+236>>2])break i;if(f=0,k=0,t[(h+i[l+220>>2]|0)+g(w,B)|0]>=0)break o}if(l=A+18548|0,k=1,!W2(l,i[A+18572>>2]+162|0))break o;f=0;l:{if(!W2(l,i[A+18572>>2]+163|0)||(f=1,!W2(l,i[A+18572>>2]+164|0)))break l;f=W2(l,i[A+18572>>2]+165|0)?3:2}f=1-(W2(l,i[A+18572>>2]+170|0)<<1)<<f,k=1}i[A+28>>2]=f,f=Q&1,f&&r6(A,e,r,V,1),i[m+16848>>2]&&i6(A,(e|0)/(s|0)|0,(r|0)/(n|0)|0,_,1,o,f),(G|0)==2&&(f=Q&2,f&&r6(A,e,(n<<V)+r|0,V,1),i6(A,(e|0)/(s|0)|0,_+((r|0)/(n|0)|0)|0,_,1,o,(f|0)!=0)),f=0;o:{if(!k||(k=A+18548|0,!W2(k,i[A+18572>>2]+166|0)))break o;f=0;l:{if(!W2(k,i[A+18572>>2]+167|0)||(f=1,!W2(k,i[A+18572>>2]+168|0)))break l;f=W2(k,i[A+18572>>2]+169|0)?3:2}f=1-(W2(k,i[A+18572>>2]+171|0)<<1)<<f}if(i[A+28>>2]=f,f=I&1,f&&r6(A,e,r,V,2),i[m+16848>>2]&&i6(A,(e|0)/(s|0)|0,(r|0)/(n|0)|0,_,2,o,f),(G|0)!=2)break t;f=I&2,f&&r6(A,e,(n<<V)+r|0,V,2),i6(A,(e|0)/(s|0)|0,_+((r|0)/(n|0)|0)|0,_,2,o,(f|0)!=0);break t}if((h|0)!=3||(e=Q&1,e&&r6(A,f,k,l,1),i[m+16848>>2]&&i6(A,(f|0)/(s|0)|0,(k|0)/(n|0)|0,B,1,o,e),e=Q&2,e&&r6(A,f,k+B|0,l,1),(G|0)==2&&i6(A,(f|0)/(s|0)|0,B+((k|0)/(n|0)|0)|0,B,1,o,(e|0)!=0),e=I&1,e&&r6(A,f,k,l,2),i[m+16848>>2]&&i6(A,(f|0)/(s|0)|0,(k|0)/(n|0)|0,B,2,o,e),e=I&2,e&&r6(A,f,k+_|0,l,2),(G|0)!=2))break t;i6(A,(f|0)/(s|0)|0,B+((k|0)/(n|0)|0)|0,B,2,o,(e|0)!=0);break t}return}U0(16679,19977,3857,16524),M()}U0(23454,19977,1834,12336),M()}U0(5068,11952,128,4625),M()}U0(5030,11952,129,4625),M()}U0(30097,19977,3924,16524),M()}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function lm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0;e=v-128|0,v=e,h=K0(i[r>>2],0),s=K0(i[r>>2],1),w=K0(i[r>>2],2),Y=$2(i[r>>2],6),Y&&(j=K0(i[r>>2],6));i:{if(!(!(h>>>0>8|s>>>0>8)&w>>>0<9)){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}if(!((s|0)==(h|0)&(h|0)==(w|0))){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;e:{if(t[114951]>=0){f=i[28736],i[r>>2]=i[28735],i[r+4>>2]=f,i[r+8>>2]=i[28737];break e}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}f=i[r>>2],n=i[f+192>>2],k=i[f+188>>2],f=C(248),i[f>>2]=101168,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,o=f+12|0,i[f+176>>2]=o,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(o,k,n,0,2),a0(e+56|0,o,0,k,n,h,l,0),B=k+1>>>1|0,a0(e+32|0,o,1,B,n,s,l,0),h=e+88|0;e:{if(i[e+56>>2]){if(s=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=s,t[e+75|0]>=0){s=e- -64|0,_=i[s+4>>2],i[h>>2]=i[s>>2],i[h+4>>2]=_,i[h+8>>2]=i[s+8>>2];break e}T(h,i[e+64>>2],i[e+68>>2]);break e}if(s=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=s,t[e+51|0]>=0){s=i[e+44>>2],i[h>>2]=i[e+40>>2],i[h+4>>2]=s,i[h+8>>2]=i[e+48>>2];break e}T(h,i[e+40>>2],i[e+44>>2])}a0(e+8|0,o,2,B,n,w,l,0),s=e+112|0;e:{if(i[e+80>>2]){if(w=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=w,t[e+99|0]>=0){w=i[h+4>>2],i[s>>2]=i[h>>2],i[s+4>>2]=w,i[s+8>>2]=i[h+8>>2];break e}T(s,i[e+88>>2],i[e+92>>2]);break e}if(h=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=h,t[e+27|0]>=0){h=i[e+20>>2],i[s>>2]=i[e+16>>2],i[s+4>>2]=h,i[s+8>>2]=i[e+24>>2];break e}T(s,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[s+4>>2],i[r>>2]=i[s>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!Y)break r;if(a0(e+104|0,o,6,k,n,j,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}l=Q0(i[r>>2],0);r:{if(!l){h=0;break r}E=i[l+40>>2],h=i[l+52>>2]}l=Q0(i[r>>2],1),l?(R=i[l+52>>2],l=i[l+40>>2]):l=0,O=l,l=Q0(i[r>>2],2),l?(S=i[l+40>>2],s=i[l+52>>2]):s=0,l=Q0(o,0),l?(N=i[l+52>>2],w=i[l+40>>2]):w=0,l=Q0(o,1),l?(q=i[l+40>>2],_=i[l+52>>2]):_=0,l=Q0(o,2),l?(U=i[l+52>>2],l=i[l+40>>2]):l=0,d=l,l=0;r:{if(!Y||(r=Q0(i[r>>2],6),r?(t0=i[r+40>>2],r=i[r+52>>2]):r=0,_0=r,r=Q0(o,6),l=0,!r))break r;g0=i[r+52>>2],l=i[r+40>>2]}X0=l;r:{f:{A:{if(!(k&1))break A;if(I=n-1|0,!I)break f;if(l=(B+d|0)-1|0,Q=(k+S|0)-1|0,B=(B+q|0)-1|0,V=(k+O|0)-1|0,r=0,(n|0)!=2)for(m=I&-2;t[B+g(r,_)|0]=u[V+g(r,R)|0],t[l+g(r,U)|0]=u[Q+g(r,s)|0],G=r|1,t[B+g(G,_)|0]=u[V+g(R,G)|0],t[l+g(G,U)|0]=u[Q+g(s,G)|0],r=r+2|0,x=x+2|0,(m|0)!=(x|0););if(!(I&1))break A;t[B+g(r,_)|0]=u[V+g(r,R)|0],t[l+g(r,U)|0]=u[Q+g(r,s)|0]}if(!n)break r}if(B=k-1|0,B)for(l=0;;){for(Q=g(l,U)+d|0,V=g(l,_)+q|0,G=g(l,s)+S|0,I=g(l,R)+O|0,r=0;m=r+G|0,x=u[m|0],m=u[m+1|0],c=r>>>1|0,A0=r+I|0,t[V+c|0]=(u[A0|0]+u[A0+1|0]|0)+1>>>1,t[Q+c|0]=(m+x|0)+1>>>1,r=r+2|0,B>>>0>r>>>0;);if(l=l+1|0,(l|0)==(n|0))break}if(Y){for(l=k<<(j>>>0>8),r=0;k&&z(g(r,N)+w|0,g(r,h)+E|0,k),l&&z(g(r,g0)+X0|0,g(r,_0)+t0|0,l),r=r+1|0,(n|0)!=(r|0););break r}if(r=0,(n|0)!=1)for(s=n&-2,l=0;_=!k,_||z(g(r,N)+w|0,g(r,h)+E|0,k),_||(_=r|1,z(g(_,N)+w|0,g(h,_)+E|0,k)),r=r+2|0,l=l+2|0,(s|0)!=(l|0););if(!(n&1)|!k)break r;z(g(r,N)+w|0,g(r,h)+E|0,k)}t[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=o;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=e+128|0}function b9(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(i[A>>2]=67248,e=i[A+3212>>2],r=i[A+3208>>2],(e|0)!=(r|0))for(;f=i[e-4>>2],f&&(Z(at(f)),r=i[A+3208>>2],e=i[A+3212>>2]),e=e-4|0,i[A+3212>>2]=e,(e|0)!=(r|0););if(r&&(i[A+3212>>2]=r,Z(r)),r=0,e=A+2140|0,f=i[e+12>>2],k=i[e+8>>2],(f|0)!=(k|0))for(;n=i[(r<<2)+k>>2],n&&(Z(A5(n)),k=i[e+8>>2],f=i[e+12>>2]),r=r+1|0,r>>>0<f-k>>2>>>0;);u5(e+32|0),r=i[e+20>>2],r&&(i[e+24>>2]=r,Z(r)),r=i[e+8>>2],r&&(i[e+12>>2]=r,Z(r)),u5(A+1396|0),e=i[A+1388>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+1380>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+1372>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}for(f=A+4|0,e=1368;;){e=e-8|0,r=i[f+e>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if((e|0)==856)break}e=i[A+852>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+844>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+836>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+828>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+820>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+812>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+804>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+796>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+788>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+780>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+772>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+764>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+756>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+748>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+740>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+732>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+724>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+716>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+708>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+700>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+692>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+684>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+676>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+668>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+660>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+652>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+644>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+636>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+628>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+620>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+612>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+604>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=A+548|0,r=i[e+32>>2],r)for(;n=i[e+16>>2],f=i[e+28>>2],k=i[i[n+(f>>>8&16777212)>>2]+((f&1023)<<2)>>2],i[e+32>>2]=r-1,r=f+1|0,i[e+28>>2]=r,r>>>0>=2048&&(Z(i[n>>2]),i[e+16>>2]=i[e+16>>2]+4,i[e+28>>2]=i[e+28>>2]-1024),i[e+36>>2]=i[e+36>>2]-i[k+24>>2],H4(e,k),r=i[e+32>>2],!!r;);if(r=i[e+8>>2],r&&H4(e,r),r=i[e+40>>2],n=i[e+44>>2],(r|0)!=(n|0))for(f=0;k=i[(f<<2)+r>>2],k&&(Z(i[k+20>>2]),r=i[k+32>>2],r&&(i[k+36>>2]=r,Z(r)),Z(k),n=i[e+44>>2],r=i[e+40>>2]),f=f+1|0,f>>>0<n-r>>2>>>0;);return r&&(i[e+44>>2]=r,Z(r)),u5(e+12|0),A|0}function c9(){var A=0,e=0;F1(9370,1,102724,56993,909,910,0,0),F1(1580,3,102736,57040,911,912,0,0),F1(13580,2,102780,57068,913,914,0,0),F1(6798,2,102796,57091,915,916,0,0),F1(14621,3,102812,57095,917,918,0,0),F1(14550,2,102796,57091,915,919,0,0),F1(23289,4,102848,57173,920,921,0,0),F1(8168,1,102928,57285,922,923,0,0),F1(19605,1,102932,56993,924,925,0,0),F1(16594,2,102936,57288,926,927,0,0),F1(6116,2,102944,57068,928,929,0,0),F1(13353,2,102952,57288,930,931,0,0),F1(11833,2,102976,57068,932,933,0,0),F1(4324,2,102976,57068,932,934,0,0),F1(15532,2,102976,57068,932,935,0,0),F1(13379,2,102984,57288,936,937,0,0),F1(10821,2,102976,57068,932,938,0,0),F1(20665,2,102976,57068,932,939,0,0),F1(6716,2,102796,57091,915,940,0,0),F1(13669,3,103008,57095,941,942,0,0),F1(13632,3,103008,57095,941,943,0,0),F1(12253,3,103008,57095,941,944,0,0),F1(13730,3,103008,57095,941,945,0,0),F1(14197,3,103008,57095,941,946,0,0),F1(5515,2,103036,57068,947,948,0,0),F1(10059,3,103044,57346,949,950,0,0),F1(13557,2,102780,57068,913,914,0,0),F1(6750,2,102796,57091,915,916,0,0),F1(14588,3,102812,57095,917,918,0,0),F1(14509,2,102796,57091,915,919,0,0),b8(103056,16663,4,0),N0(103056,11347,0),N0(103056,3633,1),N0(103056,3464,2),N0(103056,7104,11),N0(103056,13600,3),N0(103056,13506,4),N0(103056,7147,5),N0(103056,6944,6),N0(103056,7011,7),N0(103056,6979,8),N0(103056,7043,9),N0(103056,16709,13),N0(103056,3665,10),N0(103056,18748,12),b8(103064,16644,4,0),N0(103064,18851,0),N0(103064,20163,5e3),N0(103064,6897,1001),N0(103064,20321,150),N0(103064,8971,5001),N0(103064,12294,5002),N0(103064,8473,5003),N0(103064,5416,5004),N0(103064,20263,100),N0(103064,12447,101),N0(103064,1907,102),N0(103064,1829,103),N0(103064,2177,104),N0(103064,1803,151),N0(103064,1855,105),N0(103064,2255,106),N0(103064,2229,141),N0(103064,1985,107),N0(103064,1959,108),N0(103064,2203,109),N0(103064,2151,110),N0(103064,2073,111),N0(103064,1933,112),N0(103064,2099,113),N0(103064,7665,114),N0(103064,1154,115),N0(103064,10255,116),N0(103064,20236,117),N0(103064,20289,118),N0(103064,6160,119),N0(103064,11898,152),N0(103064,2307,131),N0(103064,2281,143),N0(103064,2042,149),N0(103064,13398,120),N0(103064,20128,121),N0(103064,6621,122),N0(103064,19063,6001),N0(103064,7069,6e3),N0(103064,18768,123),N0(103064,1537,6002),N0(103064,18640,6003),N0(103064,10214,124),N0(103064,2125,125),N0(103064,18877,1e3),N0(103064,13762,126),N0(103064,4663,127),N0(103064,8192,128),N0(103064,12478,129),N0(103064,19172,2e3),N0(103064,4012,2001),N0(103064,19214,2002),N0(103064,9428,2003),N0(103064,9387,2004),N0(103064,7485,2005),N0(103064,13065,2006),N0(103064,1240,2007),N0(103064,14669,2008),N0(103064,2011,130),N0(103064,20202,136),N0(103064,19745,3e3),N0(103064,13803,3001),N0(103064,9469,3002),N0(103064,17185,3006),N0(103064,1109,3007),N0(103064,9298,3003),N0(103064,17082,3004),N0(103064,17133,3005),N0(103064,11595,4e3),N0(103064,13693,3008),N0(103064,11631,132),N0(103064,6028,133),N0(103064,6531,134),N0(103064,4950,135),N0(103064,1209,137),N0(103064,18449,138),N0(103064,18401,139),N0(103064,10571,140),N0(103064,1881,142),b8(103072,4639,4,0),N0(103072,18497,0),N0(103072,21681,1),N0(103072,21703,2),N0(103072,21312,3),N0(103072,23551,4),N0(103072,21639,5),N0(103072,21660,6),N0(103072,23877,7),N0(103072,18338,8),N0(103072,10986,9),N0(103072,21248,10),b8(102872,20637,4,0),N0(102872,18550,99),N0(102872,14174,0),N0(102872,23846,1),N0(102872,23410,2),N0(102872,23190,3),N0(102872,21801,10),N0(102872,21908,11),N0(102872,21444,12),N0(102872,21478,13),N0(102872,21374,14),N0(102872,21408,15),N0(102872,8289,0),N0(102872,4264,10),N0(102872,4294,11),b8(103080,10179,4,0),N0(103080,15499,2),N0(103080,7399,1),N0(103080,3341,3),b8(103088,10146,4,0),N0(103088,8347,2),N0(103088,7359,1),b8(102864,17030,4,0),N0(102864,18524,99),N0(102864,8399,0),N0(102864,21781,1),N0(102864,14147,2),N0(102864,1696,4),N0(102864,10102,3),N0(102864,10924,3),b8(102904,10808,4,0),N0(102904,20887,0),N0(102904,8421,2),N0(102904,20048,1),N0(102904,21065,3),N0(102904,21292,4),N0(102904,21733,5),N0(102904,20750,6),N0(102904,17533,10),N0(102904,1670,11),N0(102904,11674,12),N0(102904,1467,13),N0(102904,8693,65535),b8(102788,4147,4,0),N0(102788,8652,0),N0(102788,17588,1),N0(102788,17558,2),N0(102788,17057,3),cf(102772,102756,103020,0,56993,951,57488,0,57488,0,3384,57490,952),cf(102840,102824,102960,0,56993,953,57488,0,57488,0,14651,57490,954),cf(102896,102880,102992,0,56993,955,57488,0,57488,0,15593,57490,956),TB(102748,7136,57493,957,57490,958),A=C(4),i[A>>2]=0,e=C(4),i[e>>2]=0,bf(102748,16674,103056,57068,959,A|0,103056,57495,960,e|0),A=C(4),i[A>>2]=4,e=C(4),i[e>>2]=4,bf(102748,16636,103064,57068,961,A|0,103064,57495,962,e|0),A=C(4),i[A>>2]=963,e=C(4),i[e>>2]=964,bf(102748,15491,102728,57091,965,A|0,102728,57500,966,e|0),xB(102748)}function um(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=78468,n=i[19620],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[19621],n=i[i[f>>2]-12>>2]+f|0,k=f+4|0,J0(n,k),t[n+80|0]=0,i[n+72>>2]=0,i[f+56>>2]=78468,i[f>>2]=78448,B=R0(k),i[B>>2]=77200,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,n=f+148|0,K1(n,e,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,k0(n,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(f,37224,15),n=i[e+100>>2]&1,n=F(F(k,n?5732:8666,n|2),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(n,36771,16),n=i[e+100>>2]&2,n=F(F(k,n?5732:8666,n?3:2),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(n,33235,18),n=i[e+100>>2]&4,n=F(F(k,n?5732:8666,n?3:2),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(n,34338,28),n=i[e+100>>2]&8,F(F(k,n?5732:8666,n?3:2),47878,1),n=f+148|0,k0(n,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(M2(F(f,37855,19),i[e+104>>2],i[e+108>>2]),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(M2(F(n,36644,19),i[e+112>>2],i[e+116>>2]),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(n,37618,10),i[e+120>>2]),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(M2(F(n,34538,10),i[e+128>>2],i[e+132>>2]),47878,1),n=f+148|0,k0(n,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(f,34223,7),p[e+136>>1]),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(n,34304,17),p[e+138>>1]),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(Il(F(n,36622,8),D(D(p[e+140>>1])*D(.00390625))),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(n,46881,8),V=e+144|0;i:{for(;;){n=f+148|0,k0(n,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),F(f,37885,2),Y=g(m,3),n=0;e:{for(;;){k=f+140|0,l=n+Y|0,(l|0)!=8?G=+o0[(l<<2)+V>>2]*152587890625e-16:G=1,w=t4(f,G),I=X1(k,w);r:{if(u[I|0]!=1)break r;l=i[i[w>>2]-12>>2]+w|0,_=i[l+4>>2],h=i[l+24>>2];f:{if(u[l+80|0]==1){k=u[l+76|0]|u[l+77|0]<<8|(u[l+78|0]<<16|u[l+79|0]<<24);break f}o=f+148|0,k=i[l+28>>2],i[o>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(o,137008),k=W[i[i[k>>2]+28>>2]](k,32)|0,i2(o),t[l+76|0]=k,t[l+77|0]=k>>>8,t[l+78|0]=k>>>16,t[l+79|0]=k>>>24,t[l+80|0]=1}f:{if(!h||(s=i[l+12>>2],_=(_&176)==32?37887:37886,o=_-37886|0,(o|0)>0&&(W[i[i[h>>2]+48>>2]](h,37886,o)|0)!=(o|0)))break f;if((s|0)>=2){if(s>>>0>=2147483641)break e;o=((s|0)<=1?1:s)-1|0;A:{if(s>>>0>=12){Q=o|7,s=C(Q+1|0),i[f+156>>2]=Q-2147483647,i[f+148>>2]=s,i[f+152>>2]=o;break A}t[f+159|0]=o,s=f+148|0}if(o&&l0(s,k,o),t[o+s|0]=0,k=W[i[i[h>>2]+48>>2]](h,t[f+159|0]<0?i[f+148>>2]:f+148|0,o)|0,t[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(o|0))break f}if(k=37887-_|0,(k|0)>0&&(W[i[i[h>>2]+48>>2]](h,_,k)|0)!=(k|0))break f;i[l+12>>2]=0;break r}k=i[i[w>>2]-12>>2]+w|0,M1(k,i[k+16>>2]|5)}if(v1(I),n=n+1|0,(n|0)==3)break}if(F(f,47878,1),m=m+1|0,(m|0)==3)break i;continue}break}I0(),M()}n=f+148|0,k0(n,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(t4(F(f,35150,7),+D(o0[e+180>>2])*152587890625e-16),47878,1),k=f+148|0,k0(k,r),o=k,r=t[f+159|0],k=(r|0)<0,F(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(t4(F(n,33388,8),+D(o0[e+184>>2])*152587890625e-16),47878,1),e=i[f+52>>2];i:{e:{if(e&16){n=i[f+48>>2],e=i[f+28>>2],n>>>0<e>>>0&&(i[f+48>>2]=e,n=e),e=f+24|0;break e}if(!(e&8)){n=0,t[A+11|0]=0;break i}n=i[f+20>>2],e=f+12|0}e:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){k=n|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(t[A+11|0]=n,n)break e;n=0;break i}I0(),M()}if(!n)break i;z(A,r,n)}t[A+n|0]=0,A=i[19619],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19622],i[B>>2]=77200,t[f+47|0]<0&&Z(i[f+36>>2]),y0(B),Y0(f+56|0),v=f+160|0}function sm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=D(0),_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=D(0),U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=D(0),A0=D(0),t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=D(0),M0=0,z0=0,j0=0,S0=0,q0=D(0),r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0;s=v-48|0,v=s,e=i[r>>2],B=i[e+192>>2],m=i[e+188>>2],n=K0(e,0),Y=$2(i[r>>2],6),f=i[k+4>>2],h=C(248),i[h>>2]=101168,i[h+4>>2]=0,i[h+8>>2]=0,l0(h+16|0,0,156),i[h+76>>2]=0,i[h+80>>2]=0,i[h+36>>2]=1,i[h+40>>2]=1,t[h+24|0]=1,X[h+22>>1]=2,X[h+18>>1]=2,X[h+20>>1]=2,i[h+84>>2]=0,i[h+88>>2]=0,i[h+92>>2]=0,i[h+96>>2]=0,i[h+128>>2]=0,i[h+132>>2]=0,i[h+100>>2]=0,i[h+104>>2]=1,i[h+136>>2]=0,i[h+140>>2]=0,i[h+144>>2]=0,i[h+148>>2]=0,i[h+152>>2]=0,i[h+156>>2]=0,X[h+158>>1]=0,X[h+160>>1]=0,X[h+162>>1]=0,X[h+164>>1]=0,i[h+184>>2]=0,i[h+188>>2]=0,i[h+172>>2]=255,i[h+192>>2]=0,i[h+196>>2]=5186,i[h+208>>2]=99,i[h+212>>2]=99,i[h+200>>2]=0,i[h+204>>2]=0,i[h+12>>2]=101488,i[h+216>>2]=0,i[h+220>>2]=0,i[h+224>>2]=0,i[h+228>>2]=0,i[h+232>>2]=0,i[h+236>>2]=0,i[h+240>>2]=0,i[h+244>>2]=0,G=h+12|0,i[h+176>>2]=G,i[h+8>>2]=i[h+8>>2]+1,i[h+180>>2]=h,i[h+4>>2]==-1&&(W[i[i[h>>2]+8>>2]](h),y(h)),t1(G,m,B,1,i[k+4>>2]),a0(s+24|0,G,10,m,B,n,l,0);i:{e:{if(i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,r=A+8|0,t[s+43|0]>=0){e=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+40>>2],t[A+20|0]=1;break e}if(T(r,i[s+32>>2],i[s+36>>2]),e=t[s+43|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}t[s+43|0]<0&&Z(i[s+32>>2]);r:{if(!Y)break r;f:{if((V8(i[r>>2],6)|0)==(m|0)&&(p8(i[r>>2],6)|0)==(B|0))break f;e=C(96),i[s+4>>2]=e,i[s+8>>2]=90,i[s+12>>2]=-2147483552,z(e,27393,90),t[e+90|0]=0,f=a(s+24|0,4,0,s+4|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;A:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break A}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break A;Z(i[f+8>>2])}if(t[s+15|0]>=0)break e;Z(i[s+4>>2]);break e}if((K0(i[r>>2],6)|0)!=(n|0)){e=C(96),i[s+4>>2]=e,i[s+8>>2]=94,i[s+12>>2]=-2147483552,z(e,28075,94),t[e+94|0]=0,f=a(s+24|0,4,0,s+4|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(t[s+15|0]>=0)break e;Z(i[s+4>>2]);break e}if(a0(s+24|0,G,6,m,B,n,l,0),i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,r=A+8|0,t[s+43|0]>=0){e=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+40>>2],t[A+20|0]=1;break e}if(T(r,i[s+32>>2],i[s+36>>2]),e=t[s+43|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}if(t[s+43|0]>=0)break r;Z(i[s+32>>2])}e=Q0(G,10),e?(_0=i[e+52>>2],e=i[e+40>>2]):e=0,Q=e,e=Q0(i[r>>2],0),e?(g0=i[e+52>>2],x=i[e+40>>2]):x=0,e=Q0(i[r>>2],1),e?(X0=i[e+40>>2],j=i[e+52>>2]):j=0,e=Q0(i[r>>2],2),e?(V0=i[e+52>>2],O=i[e+40>>2]):O=0,V=0;r:{if(!Y||(e=Q0(i[r>>2],6),V=0,!e))break r;C0=i[e+40>>2],V=i[e+52>>2]}if(i[s+36>>2]=-1086926434,i[s+40>>2]=1071829221,i[s+28>>2]=1068725436,i[s+32>>2]=-1095748968,t[s+24|0]=1,k=1,r8(i[r>>2])&&(r=i[r>>2],e=p[r+6>>1]|p[r+8>>1]<<16,r=p[r+10>>1]|p[r+12>>1]<<16,Pe(s+4|0,r&65535,e&65535),i[s+40>>2]=i[s+20>>2],e=i[s+16>>2],i[s+32>>2]=i[s+12>>2],i[s+36>>2]=e,e=i[s+8>>2],i[s+24>>2]=i[s+4>>2],i[s+28>>2]=e,k=(r&65536)>>>16|0),!(!B|!m))for(e=f&-2,S=(e|0)==14,r0=Y?8:6,f0=D(16<<n-8),_=-1<<n^-1,f=_>>>8|0,q=1<<n-1,M0=((e|0)!=14)+Q|0,e=(e|0)==14,z0=(e?6:7)+Q|0,j0=(e?4:5)+Q|0,S0=(e?2:3)+Q|0,q0=E0[s+28>>2];;){for(R=g(I,_0),r2=z0+R|0,f2=(g(I,V)&-2)+C0|0,A2=(g(I,g0)&-2)+x|0,d=Q+R|0,s2=(d+S|0)+6|0,e=I>>>1|0,v2=(g(e,V0)&-2)+O|0,Z2=(g(e,j)&-2)+X0|0,r=0;;){n=0,e=r&-2,w=D(p[e+Z2>>1]-q|0),c=k?w:D(w*D(1.142899990081787)),o=0,w=D(p[e+v2>>1]-q|0),A0=k?w:D(w*D(1.142899990081787)),t0=r<<1,w=D(p[t0+A2>>1]),N=k?w:D(D(w-f0)*D(1.1689000129699707)),w=D(D(D(q0*A0)+N)+D(.5)),D(B2(w))<D(2147483648)?l=~~w:l=-2147483648,e=0;r:{if((l|0)<0)break r;if((l|0)>(_|0)){o=f,e=_;break r}o=l>>>8|0,e=l}X2=e,w=D(D(D(E0[s+36>>2]*A0)+D(D(E0[s+32>>2]*c)+N))+D(.5)),D(B2(w))<D(2147483648)?e=~~w:e=-2147483648,l=0;r:{if((e|0)<0)break r;if((e|0)>(_|0)){n=_,l=f;break r}n=e,l=e>>>8|0}R2=l,l=0,w=D(D(D(E0[s+40>>2]*c)+N)+D(.5)),D(B2(w))<D(2147483648)?e=~~w:e=-2147483648,E=0;r:{if((e|0)<0)break r;if((e|0)>(_|0)){l=f,E=_;break r}l=e>>>8|0,E=e}if(e=g(r,r0),U=(e+d|0)+S|0,t[U|0]=o,t[U+2|0]=R2,t[U+4|0]=l,e=e+R|0,t[e+M0|0]=X2,t[e+S0|0]=n,t[e+j0|0]=E,Y&&(n=r<<3,e=f2+t0|0,t[n+s2|0]=u[e+1|0],t[n+r2|0]=u[e|0]),r=r+1|0,(m|0)==(r|0))break}if(I=I+1|0,(I|0)==(B|0))break}t[A+20|0]=0,i[A+4>>2]=h,i[A>>2]=G;break i}if(A=i[h+4>>2],i[h+4>>2]=A-1,A)break i;W[i[i[h>>2]+8>>2]](h),y(h)}v=s+48|0}function O6(A,e,r,f,k,n,o,l,s){var h=0,w=0,_=0;h=v-160|0,v=h;i:{if(!(f&&r)){if(e=C(24),i[h+12>>2]=e,i[h+16>>2]=18,i[h+20>>2]=-2147483624,r=u[12740]|u[12741]<<8|(u[12742]<<16|u[12743]<<24),f=u[12736]|u[12737]<<8|(u[12738]<<16|u[12739]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+18|0]=0,r=u[12752]|u[12753]<<8,t[e+16|0]=r,t[e+17|0]=r>>>8,r=u[12748]|u[12749]<<8|(u[12750]<<16|u[12751]<<24),f=u[12744]|u[12745]<<8|(u[12746]<<16|u[12747]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,5,0,h+12|0),t[h+23|0]>=0)break i;Z(i[h+12>>2]);break i}if(!((r|0)!=-1&(f|0)!=-1)){if(e=C(48),i[h+12>>2]=e,i[h+16>>2]=41,i[h+20>>2]=-2147483600,r=u[4080]|u[4081]<<8|(u[4082]<<16|u[4083]<<24),f=u[4076]|u[4077]<<8|(u[4078]<<16|u[4079]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+41|0]=0,t[e+40|0]=u[4116],r=u[4112]|u[4113]<<8|(u[4114]<<16|u[4115]<<24),f=u[4108]|u[4109]<<8|(u[4110]<<16|u[4111]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[4104]|u[4105]<<8|(u[4106]<<16|u[4107]<<24),f=u[4100]|u[4101]<<8|(u[4102]<<16|u[4103]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[4096]|u[4097]<<8|(u[4098]<<16|u[4099]<<24),f=u[4092]|u[4093]<<8|(u[4094]<<16|u[4095]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[4088]|u[4089]<<8|(u[4090]<<16|u[4091]<<24),f=u[4084]|u[4085]<<8|(u[4086]<<16|u[4087]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,1e3,h+12|0),t[h+23|0]>=0)break i;Z(i[h+12>>2]);break i}i[e+28>>2]=f,i[e+24>>2]=r,t[e+22|0]=o,i[e+16>>2]=k,X[e+20>>1]=n&255,w=(f>>>0<=63?63:f)+1&-2,i[e+36>>2]=w,_=(r>>>0<=63?63:r)+1&-2,i[e+32>>2]=_,k=1;e:{if((n|0)<9||(k=2,n>>>0<17)||(k=4,n>>>0<33))break e;k=n>>>0<65?8:16}if(k=g(k,o),t[e+23|0]=k,k=L0(k&255,0,_,0),n=h0,!n&k>>>0>=4294967281|n){if(e=C(24),i[h+12>>2]=e,i[h+16>>2]=21,i[h+20>>2]=-2147483624,r=u[3301]|u[3302]<<8|(u[3303]<<16|u[3304]<<24),f=u[3297]|u[3298]<<8|(u[3299]<<16|u[3300]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+21|0]=0,r=u[3314]|u[3315]<<8|(u[3316]<<16|u[3317]<<24),f=u[3310]|u[3311]<<8|(u[3312]<<16|u[3313]<<24),t[e+13|0]=f,t[e+14|0]=f>>>8,t[e+15|0]=f>>>16,t[e+16|0]=f>>>24,t[e+17|0]=r,t[e+18|0]=r>>>8,t[e+19|0]=r>>>16,t[e+20|0]=r>>>24,r=u[3309]|u[3310]<<8|(u[3311]<<16|u[3312]<<24),f=u[3305]|u[3306]<<8|(u[3307]<<16|u[3308]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,1e3,h+12|0),t[h+23|0]>=0)break i;Z(i[h+12>>2]);break i}n=k+15&-16,i[e+52>>2]=n;e:{if(!l||(k=i[l+8>>2],o=i[l+12>>2],!(k|o))||(k=O1(k,o,f,0),o=h0,!o&r>>>0<=k>>>0|o))break e;e=ri(h+12|0),F(M2(F(B0(F(B0(F(e+8|0,32248,28),r),3179,1),f),32080,31),i[l+8>>2],i[l+12>>2]),5603,7),ki(h,e),a(A,6,1e3,h),t[h+11|0]<0&&Z(i[h>>2]),F8(e);break i}if(r=L0(n,0,w,0),h0){if(e=C(32),i[h+12>>2]=e,i[h+16>>2]=30,i[h+20>>2]=-2147483616,r=u[3222]|u[3223]<<8|(u[3224]<<16|u[3225]<<24),f=u[3218]|u[3219]<<8|(u[3220]<<16|u[3221]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+30|0]=0,r=u[3244]|u[3245]<<8|(u[3246]<<16|u[3247]<<24),f=u[3240]|u[3241]<<8|(u[3242]<<16|u[3243]<<24),t[e+22|0]=f,t[e+23|0]=f>>>8,t[e+24|0]=f>>>16,t[e+25|0]=f>>>24,t[e+26|0]=r,t[e+27|0]=r>>>8,t[e+28|0]=r>>>16,t[e+29|0]=r>>>24,r=u[3238]|u[3239]<<8|(u[3240]<<16|u[3241]<<24),f=u[3234]|u[3235]<<8|(u[3236]<<16|u[3237]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[3230]|u[3231]<<8|(u[3232]<<16|u[3233]<<24),f=u[3226]|u[3227]<<8|(u[3228]<<16|u[3229]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,1e3,h+12|0),t[h+23|0]>=0)break i;Z(i[h+12>>2]);break i}if(r=r|15,i[e+48>>2]=r,D4(A,s,r,l,20569),i[A>>2])break i;if(t[A+19|0]<0&&Z(i[A+8>>2]),f=i[e+48>>2],r=E2(f),!r|!(u[r-4|0]&3)||Ni(r,0,f),i[e+44>>2]=r,!r){r=ri(h+12|0),F(B0(F(r+8|0,31897,11),i[e+48>>2]),18684,13),ki(h,r),a(A,6,0,h),t[h+11|0]<0&&Z(i[h>>2]),F8(r);break i}f=e,e=r&15,i[f+40>>2]=r+(e?16-e|0:0),Z8(A,114912)}v=h+160|0}function hm(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;o=v-96|0,v=o,wn(o+72|0,e,f);i:{e:{if(i[o+72>>2]){e=i[o+76>>2],i[A>>2]=i[o+72>>2],i[A+4>>2]=e,e=i[o+84>>2],i[A+8>>2]=i[o+80>>2],i[A+12>>2]=e,i[A+16>>2]=i[o+88>>2];break e}W[i[i[e>>2]+28>>2]](o+44|0,e);r:{f:{A:{k:{n:{t:switch(u[o+68|0]){case 1:if(e=i[o+52>>2],i[A>>2]=i[o+48>>2],i[A+4>>2]=e,A=A+8|0,t[o+67|0]>=0){e=i[o+60>>2],i[A>>2]=i[o+56>>2],i[A+4>>2]=e,i[A+8>>2]=i[o+64>>2];break r}T(A,i[o+56>>2],i[o+60>>2]);break r;case 0:break t;default:break n}t:{if(u[o+56|0]!=1)break t;if(Ii(A,n,i[o+48>>2],i[o+52>>2]),i[A>>2])break r;if(t[A+19|0]>=0)break t;Z(i[A+8>>2])}l=e+68|0;t:{if(i[e+68>>2])break t;if(s=i[e+64>>2],h=i[s+20>>2],!h){if(e=C(48),i[o+8>>2]=e,i[o+12>>2]=42,i[o+16>>2]=-2147483600,r=u[26775]|u[26776]<<8|(u[26777]<<16|u[26778]<<24),f=u[26771]|u[26772]<<8|(u[26773]<<16|u[26774]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+42|0]=0,r=u[26811]|u[26812]<<8,t[e+40|0]=r,t[e+41|0]=r>>>8,r=u[26807]|u[26808]<<8|(u[26809]<<16|u[26810]<<24),f=u[26803]|u[26804]<<8|(u[26805]<<16|u[26806]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[26799]|u[26800]<<8|(u[26801]<<16|u[26802]<<24),f=u[26795]|u[26796]<<8|(u[26797]<<16|u[26798]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[26791]|u[26792]<<8|(u[26793]<<16|u[26794]<<24),f=u[26787]|u[26788]<<8|(u[26789]<<16|u[26790]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[26783]|u[26784]<<8|(u[26785]<<16|u[26786]<<24),f=u[26779]|u[26780]<<8|(u[26781]<<16|u[26782]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,11,6003,o+8|0),t[o+19|0]>=0)break r;Z(i[o+8>>2]);break r}if(i[s>>2]>=5){if(w=o,_=W[i[i[e>>2]+8>>2]](e)|0,i[w+8>>2]=_,i[o+16>>2]=i[f+64>>2],f=u[f+21|0],i[o+20>>2]=n,i[o+12>>2]=f,f=o+32|0,W[i[i[e+64>>2]+56>>2]](f,l,o+8|0),n=i[o+32>>2],!n)break t;if(e=A,r=i[o+36>>2],A=V2(f,i[o+40>>2]),a(e,n,r,A),t[A+11|0]>=0)break r;Z(i[A>>2]);break r}if(n=o+8|0,W[h|0](n,l),s=i[o+8>>2],s){if(e=A,r=i[o+12>>2],A=V2(n,i[o+16>>2]),a(e,s,r,A),t[A+11|0]>=0)break r;Z(i[A>>2]);break r}if(n=i[e+64>>2],i[n>>2]<2||(n=i[n+36>>2],!n))break t;W[n|0](i[l>>2],u[f+21|0])}switch(r3(o+8|0,e,r),u[o+28|0]){case 0:break A;case 1:break k;default:break n}}e2(),M()}if(e=i[o+12>>2],i[A>>2]=i[o+8>>2],i[A+4>>2]=e,A=A+8|0,t[o+27|0]>=0){e=i[o+20>>2],i[A>>2]=i[o+16>>2],i[A+4>>2]=e,i[A+8>>2]=i[o+24>>2];break f}T(A,i[o+16>>2],i[o+20>>2]);break f}if(f=i[o+12>>2],r=i[o+8>>2],(f|0)==(r|0)){if(e=C(32),i[o+32>>2]=e,i[o+36>>2]=29,i[o+40>>2]=-2147483616,r=u[25272]|u[25273]<<8|(u[25274]<<16|u[25275]<<24),f=u[25268]|u[25269]<<8|(u[25270]<<16|u[25271]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+29|0]=0,r=u[25293]|u[25294]<<8|(u[25295]<<16|u[25296]<<24),f=u[25289]|u[25290]<<8|(u[25291]<<16|u[25292]<<24),t[e+21|0]=f,t[e+22|0]=f>>>8,t[e+23|0]=f>>>16,t[e+24|0]=f>>>24,t[e+25|0]=r,t[e+26|0]=r>>>8,t[e+27|0]=r>>>16,t[e+28|0]=r>>>24,r=u[25288]|u[25289]<<8|(u[25290]<<16|u[25291]<<24),f=u[25284]|u[25285]<<8|(u[25286]<<16|u[25287]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[25280]|u[25281]<<8|(u[25282]<<16|u[25283]<<24),f=u[25276]|u[25277]<<8|(u[25278]<<16|u[25279]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,o+32|0),t[o+43|0]>=0)break f;Z(i[o+32>>2]);break f}f=f-r|0;A:{k:{if(e=i[e+64>>2],i[e>>2]<5||(n=i[e+60>>2],!n))break k;W[n|0](o+32|0,i[l>>2],r,f,k);break A}W[i[e+28>>2]](o+32|0,i[l>>2],r,f)}if(r=i[o+40>>2],f=i[o+36>>2],k=i[o+32>>2],k){if(e=l2(r),e>>>0>=2147483640)break i;A:{k:{if(e>>>0>=11){l=e|7,n=C(l+1|0),i[o+40>>2]=l-2147483647,i[o+32>>2]=n,i[o+36>>2]=e;break k}if(t[o+43|0]=e,n=o+32|0,!e)break A}if(!e)break A;z(n,r,e)}if(t[e+n|0]=0,a(A,k,f,o+32|0),t[o+43|0]>=0)break f;Z(i[o+32>>2]);break f}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}if(A=u[o+28|0],(A|0)==255)break r;e=i[25889],i[o+32>>2]=i[25888],i[o+36>>2]=e,W[i[(o+32|0)+(A<<2)>>2]](o+95|0,o+8|0)}if(A=u[o+68|0],(A|0)!=255&&(e=i[25891],i[o+8>>2]=i[25890],i[o+12>>2]=e,W[i[(o+8|0)+(A<<2)>>2]](o+32|0,o+48|0)),t[o+91|0]>=0)break e;Z(i[o+80>>2])}v=o+96|0;return}I0(),M()}function wm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0;e=v-128|0,v=e,f=C(248),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=101168,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,n=f+12|0,i[f+176>>2]=n,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),k=i[r>>2],G=i[k+188>>2],_=i[k+192>>2],t1(n,G,_,0,1),V=K0(i[r>>2],0),a0(e+56|0,n,0,G,_,V,l,0),h=G+1|0,I=h>>>1|0,o=_+1|0,E=o>>>1|0,a0(e+32|0,n,1,I,E,V,l,0),w=e+88|0;i:{if(i[e+56>>2]){if(k=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=k,t[e+75|0]>=0){s=e- -64|0,k=i[s+4>>2],i[w>>2]=i[s>>2],i[w+4>>2]=k,i[w+8>>2]=i[s+8>>2];break i}T(w,i[e+64>>2],i[e+68>>2]);break i}if(k=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=k,t[e+51|0]>=0){k=i[e+44>>2],i[w>>2]=i[e+40>>2],i[w+4>>2]=k,i[w+8>>2]=i[e+48>>2];break i}T(w,i[e+40>>2],i[e+44>>2])}a0(e+8|0,n,2,I,E,V,l,0),s=e+112|0;i:{if(i[e+80>>2]){if(k=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=k,t[e+99|0]>=0){k=i[w+4>>2],i[s>>2]=i[w>>2],i[s+4>>2]=k,i[s+8>>2]=i[w+8>>2];break i}T(s,i[e+88>>2],i[e+92>>2]);break i}if(k=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=k,t[e+27|0]>=0){k=i[e+20>>2],i[s>>2]=i[e+16>>2],i[s+4>>2]=k,i[s+8>>2]=i[e+24>>2];break i}T(s,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);i:{e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,k=A+8|0,t[e+123|0]>=0){r=i[s+4>>2],i[k>>2]=i[s>>2],i[k+4>>2]=r,i[k+8>>2]=i[s+8>>2],t[A+20|0]=1;break e}if(T(k,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]<0&&Z(i[e+112>>2]),j=$2(i[r>>2],6),j){if(k=K0(i[r>>2],6),a0(e+104|0,n,6,G,_,k,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,k=A+8|0,t[e+123|0]>=0){r=i[e+116>>2],i[k>>2]=i[e+112>>2],i[k+4>>2]=r,i[k+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(k,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]),S=k>>>0>8}k=Q0(i[r>>2],0);r:{if(V>>>0<=8){f:{if(!k){h=0,o=0;break f}h=i[k+52>>2],o=i[k+40>>2]}if(k=Q0(n,0),k?(Y=i[k+52>>2],w=i[k+40>>2]):w=0,l=0,k=Q0(n,1),k?(R=i[k+40>>2],s=i[k+52>>2]):s=0,k=Q0(n,2),k?(l=i[k+52>>2],k=i[k+40>>2]):k=0,I=1<<V-1,s=g(s,E),s&&l0(R,I,s),l=g(l,E),l&&l0(k,I,l),!_)break r;if(l=0,(_|0)!=1)for(s=_&-2;k=!G,k||z(w+g(l,Y)|0,g(l,h)+o|0,G),k||(k=l|1,z(w+g(k,Y)|0,g(k,h)+o|0,G)),l=l+2|0,B=B+2|0,(s|0)!=(B|0););if(!(_&1)|!G)break r;z(w+g(l,Y)|0,g(l,h)+o|0,G);break r}k?(R=i[k+40>>2],w=i[k+52>>2]>>>1|0):w=0,k=Q0(n,0),k?(Y=i[k+52>>2]>>>1|0,s=i[k+40>>2]):s=0,k=Q0(n,1),k?(q=i[k+40>>2],l=i[k+52>>2]>>>1|0):l=0,k=Q0(n,2),k?(d=i[k+52>>2]>>>1|0,k=i[k+40>>2]):k=0;f:{if(o>>>0>=2){if(h>>>0<2)break f;for(Q=128<<V-8,V=I&2147483644,O=I&3,I=I-1>>>0<3;;){if(N=(g(m,d)<<1)+k|0,U=(g(l,m)<<1)+q|0,B=0,o=0,!I)for(;x=B<<1,X[x+U>>1]=Q,X[N+x>>1]=Q,h=x|2,X[h+U>>1]=Q,X[h+N>>1]=Q,h=x|4,X[h+U>>1]=Q,X[h+N>>1]=Q,h=x|6,X[h+U>>1]=Q,X[h+N>>1]=Q,B=B+4|0,o=o+4|0,(V|0)!=(o|0););if(o=0,O)for(;h=B<<1,X[h+U>>1]=Q,X[h+N>>1]=Q,B=B+1|0,o=o+1|0,(O|0)!=(o|0););if(m=m+1|0,(E|0)==(m|0))break}}if(!_)break r}if(h=G<<1,l=0,(_|0)!=1)for(o=_&-2,m=0;k=!h,k||z((g(l,Y)<<1)+s|0,(g(l,w)<<1)+R|0,h),k||(k=l|1,z((g(k,Y)<<1)+s|0,(g(k,w)<<1)+R|0,h)),l=l+2|0,m=m+2|0,(o|0)!=(m|0););if(!(_&1)|!h)break r;z((g(l,Y)<<1)+s|0,(g(l,w)<<1)+R|0,h)}r:{if(!j)break r;o=0,r=Q0(i[r>>2],6);f:{if(!r){B=0,k=0;break f}B=i[r+40>>2],k=i[r+52>>2]}if(r=Q0(n,6),r?(o=i[r+52>>2],r=i[r+40>>2]):r=0,!_)break r;if(h=G<<S,l=0,(_|0)!=1)for(w=_&-2,m=0;s=!h,s||z(r+g(o,l)|0,g(k,l)+B|0,h),s||(s=l|1,z(r+g(s,o)|0,g(k,s)+B|0,h)),l=l+2|0,m=m+2|0,(w|0)!=(m|0););if(!(_&1)|!h)break r;z(r+g(o,l)|0,g(k,l)+B|0,h)}t[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=n;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=e+128|0}function _m(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;e=v-144|0,v=e,i[e+104>>2]=0,i[e+108>>2]=0,i[e+112>>2]=0,i[e+116>>2]=0,t[e+119|0]=0,t[e+120|0]=0,t[e+121|0]=0,t[e+122|0]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+124>>2]=0,i[e+128>>2]=0,i[e+136>>2]=0,t[e+132|0]=1,s=C(168),i[s>>2]=98508,i[s+4>>2]=0,i[s+8>>2]=0,o=s+16|0,k=o,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=92500,k=s,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,t[k+112|0]=0,i[o>>2]=106924,t[k+120|0]=0,i[k+116>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,X[k+128>>1]=2056,i[k+124>>2]=1,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+32>>2]=1635148611,l=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+92>>2]=k,i[e+88>>2]=l,W[i[i[f>>2]+100>>2]](e+72|0,i[f+4>>2],e+88|0,n);i:{e:{r:{f:{A:{k:{if(n=i[e+72>>2],n){if(f=i[e+76>>2],o=i[e+80>>2],r=l2(o),r>>>0>=2147483640)break k;n:{t:{if(r>>>0>=11){l=r|7,k=C(l+1|0),i[e+44>>2]=l-2147483647,i[e+36>>2]=k,i[e+40>>2]=r;break t}if(t[e+47|0]=r,k=e+36|0,!r)break n}if(!r)break n;z(k,o,r)}t[r+k|0]=0,r=a(e+48|0,n,f,e+36|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;n:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[A+44|0]=1;break n}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+44|0]=1,(f|0)>=0)break n;Z(i[r+8>>2])}if(t[e+47|0]>=0)break e;Z(i[e+36>>2]);break e}if(i[e+32>>2]=0,i[e+28>>2]=0,W[i[i[f>>2]+104>>2]](e+48|0,i[f+4>>2],e+24|0,e+20|0,0),i[e+80>>2]=i[e+56>>2],n=i[e+52>>2],k=i[e+48>>2],i[e+72>>2]=k,i[e+76>>2]=n,k)break r;for(l=s+116|0;;){if(k=i[e+24>>2],k){n=i[e+20>>2];n:{t:switch((u[k|0]&31)-7|0){case 0:uA(e,k,n,l,e+32|0,e+28|0,0),t[e+19|0]<0&&Z(i[e+8>>2]),i[e+124>>2]=i[e+32>>2],i[e+128>>2]=i[e+28>>2],_o(o,i[e+24>>2],i[e+20>>2]);break n;case 6:Bo(o,k,n);break n;case 1:vo(o,k,n);break n;default:break t}C6(e+96|0,k,n)}if(W[i[i[f>>2]+104>>2]](e+48|0,i[f+4>>2],e+24|0,e+20|0,0),i[e+80>>2]=i[e+56>>2],n=i[e+52>>2],k=i[e+48>>2],i[e+72>>2]=k,i[e+76>>2]=n,!k)continue;break r}break}if(!(i[e+28>>2]&&i[e+32>>2])){t[e+36|0]=0,t[e+47|0]=0,r=a(e+48|0,8,129,e+36|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;n:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[A+44|0]=1;break n}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+44|0]=1,(f|0)>=0)break n;Z(i[r+8>>2])}if(t[e+47|0]>=0)break e;Z(i[e+36>>2]);break e}i[s+4>>2]=i[s+4>>2]+1,k=i[e+100>>2],h=i[e+104>>2];n:{if(k>>>0<h>>>0){i[k+4>>2]=s,i[k>>2]=o,k=k+8|0;break n}if(l=i[e+96>>2],k=k-l|0,_=k>>3,n=_+1|0,n>>>0>=536870912)break A;if(h=h-l|0,w=h>>2,h=h>>>0>=2147483640?536870911:n>>>0<w>>>0?w:n,h){if(h>>>0>=536870912)break f;n=C(h<<3)}else n=0;if(w=n+k|0,i[w+4>>2]=s,i[w>>2]=o,o=w-(_<<3)|0,k&&z(o,l,k),i[e+104>>2]=n+(h<<3),k=w+8|0,i[e+100>>2]=k,i[e+96>>2]=o,!l)break n;Z(l)}i[e+100>>2]=k,n=i[f>>2];n:{if(i[n>>2]<3||(n=i[n+112>>2],!n))break n;r=i[r>>2],k=i[r+188>>2],i[e+48>>2]=k,r=i[r+192>>2],i[e+36>>2]=r,W[n|0](i[f+4>>2],k,r,e+48|0,e+36|0),k=i[e+100>>2]}X[e+120>>1]=257,r=i[e+96>>2],i[e+96>>2]=0,f=i[e+104>>2],n=i[e+108>>2],i[e+100>>2]=0,i[e+104>>2]=0,o=i[e+112>>2],l=i[e+116>>2],i[e+108>>2]=0,i[e+112>>2]=0,i[e+116>>2]=0,i[A+16>>2]=o,i[A+20>>2]=l,i[A+8>>2]=f,i[A+12>>2]=n,i[A+4>>2]=k,i[A>>2]=r,r=i[e+124>>2],i[A+24>>2]=i[e+120>>2],i[A+28>>2]=r,r=i[e+132>>2],i[A+32>>2]=i[e+128>>2],i[A+36>>2]=r,i[A+40>>2]=i[e+136>>2],t[A+44|0]=0;break e}I0(),M()}s0(),M()}x0(),M()}if(f=i[e+76>>2],o=i[e+80>>2],r=l2(o),r>>>0>=2147483640)break i;r:{f:{if(r>>>0>=11){l=r|7,n=C(l+1|0),i[e+44>>2]=l-2147483647,i[e+36>>2]=n,i[e+40>>2]=r;break f}if(t[e+47|0]=r,n=e+36|0,!r)break r}if(!r)break r;z(n,o,r)}t[r+n|0]=0,r=a(e+48|0,k,f,e+36|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;r:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[A+44|0]=1;break r}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+44|0]=1,(f|0)>=0)break r;Z(i[r+8>>2])}if(t[e+47|0]>=0)break e;Z(i[e+36>>2])}A=i[e+92>>2];e:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[s+4>>2],i[s+4>>2]=A-1,A||(W[i[i[s>>2]+8>>2]](s),y(s)),A=i[e+108>>2],A&&(i[e+112>>2]=A,Z(A)),A=i[e+96>>2],A){if(k=i[e+100>>2],f=A,(k|0)!=(A|0)){for(;;){r=i[k-4>>2];e:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=k-8|0,(A|0)==(k|0))break}f=i[e+96>>2]}i[e+100>>2]=A,Z(f)}v=e+144|0;return}I0(),M()}function Or(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;if(s=v-112|0,v=s,HA(s+100|0,e,r),e=i[s+100>>2],h=K6(s- -64|0,e,i[s+104>>2]-e|0),m2(h,16),m2(h,4),r=O2(h,3),I=f,Q=O2(h,1),t[I+28|0]=Q,I=f,Q=O2(h,2),t[I+1|0]=Q,I=f,Q=(O2(h,1)|0)!=0,t[I+2|0]=Q,I=f,Q=O2(h,5),t[I+3|0]=Q,I=f,Q=T0(h,32),i[I+4>>2]=Q,m2(h,16),m2(h,16),m2(h,16),I=f,Q=O2(h,8),t[I+16|0]=Q,r){w=r-1>>>5|0,_=w+1<<2,B=C(_);i:{e:{if(r>>>0>=33){i[(w<<2)+B>>2]=0,e=r>>>5|0;break e}if(i[B>>2]=0,e=1,(r|0)==32)break e;e=r>>>5|0;break i}if(l=e<<2,!l)break i;l0(B,0,l)}l=r&31,l&&(e=(e<<2)+B|0,i[e>>2]=i[e>>2]&(-1>>>32-l^-1)),_=C(_);i:{e:{if(r>>>0>=33){i[(w<<2)+_>>2]=0,e=r>>>5|0;break e}if(i[_>>2]=0,e=1,(r|0)==32)break e;e=r>>>5|0;break i}if(w=e<<2,!w)break i;l0(_,0,w)}for(l&&(e=(e<<2)+_|0,i[e>>2]=i[e>>2]&(-1>>>32-l^-1)),e=0;;){l=1<<e,m=e>>>5<<2,w=m+B|0;i:{if(T0(h,1)){G=l|i[w>>2];break i}G=i[w>>2]&(l^-1)}i[w>>2]=G,w=_+m|0;i:{if(T0(h,1)){l=l|i[w>>2];break i}l=i[w>>2]&(l^-1)}if(i[w>>2]=l,e=e+1|0,(r|0)==(e|0))break}if(r>>>0<8)for(e=r;m2(h,2),e=e+1|0,(e|0)!=8;);for(e=0;w=1<<e,l=e>>>5<<2,w&i[l+B>>2]&&(m2(h,8),m2(h,32),m2(h,16)),w&i[l+_>>2]&&m2(h,8),e=e+1|0,(r|0)!=(e|0););}e=C(48),i[s+28>>2]=e,i[s+32>>2]=47,i[s+36>>2]=-2147483600,r=u[8021]|u[8022]<<8|(u[8023]<<16|u[8024]<<24),l=u[8017]|u[8018]<<8|(u[8019]<<16|u[8020]<<24),t[e+39|0]=l,t[e+40|0]=l>>>8,t[e+41|0]=l>>>16,t[e+42|0]=l>>>24,t[e+43|0]=r,t[e+44|0]=r>>>8,t[e+45|0]=r>>>16,t[e+46|0]=r>>>24,r=u[8014]|u[8015]<<8|(u[8016]<<16|u[8017]<<24),l=u[8010]|u[8011]<<8|(u[8012]<<16|u[8013]<<24),t[e+32|0]=l,t[e+33|0]=l>>>8,t[e+34|0]=l>>>16,t[e+35|0]=l>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[8006]|u[8007]<<8|(u[8008]<<16|u[8009]<<24),l=u[8002]|u[8003]<<8|(u[8004]<<16|u[8005]<<24),t[e+24|0]=l,t[e+25|0]=l>>>8,t[e+26|0]=l>>>16,t[e+27|0]=l>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[7998]|u[7999]<<8|(u[8e3]<<16|u[8001]<<24),l=u[7994]|u[7995]<<8|(u[7996]<<16|u[7997]<<24),t[e+16|0]=l,t[e+17|0]=l>>>8,t[e+18|0]=l>>>16,t[e+19|0]=l>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[7990]|u[7991]<<8|(u[7992]<<16|u[7993]<<24),l=u[7986]|u[7987]<<8|(u[7988]<<16|u[7989]<<24),t[e+8|0]=l,t[e+9|0]=l>>>8,t[e+10|0]=l>>>16,t[e+11|0]=l>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[7982]|u[7983]<<8|(u[7984]<<16|u[7985]<<24),l=u[7978]|u[7979]<<8|(u[7980]<<16|u[7981]<<24),t[e|0]=l,t[e+1|0]=l>>>8,t[e+2|0]=l>>>16,t[e+3|0]=l>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+47|0]=0,r=a(s+40|0,2,2006,s+28|0),t[s+39|0]<0&&Z(i[s+28>>2]);i:{e:{if(A1(h,s+24|0)&&A1(h,s+20|0))break e;e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,i[A+16>>2]=i[r+16>>2],e=i[r+12>>2],i[A+8>>2]=i[r+8>>2],i[A+12>>2]=e,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0;break i}e=i[s+20>>2],t[f+21|0]=e,(e&255)==3&&m2(h,1);e:{if(A1(h,k)&&A1(h,n))break e;e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,i[A+16>>2]=i[r+16>>2],e=i[r+12>>2],i[A+8>>2]=i[r+8>>2],i[A+12>>2]=e,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0;break i}if(o&&(i[o>>2]=i[k>>2],i[o+4>>2]=i[n>>2]),T0(h,1)){e:{r:{if(!A1(h,s+16|0)||!A1(h,s+12|0)||!A1(h,s+8|0))break r;if(A1(h,s+4|0))break e}e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,i[A+16>>2]=i[r+16>>2],e=i[r+12>>2],i[A+8>>2]=i[r+8>>2],i[A+12>>2]=e,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0;break i}o=i[s+16>>2],l=o+i[s+12>>2]|0,e=0,e=o>>>0>l>>>0?1:e,m=l,G=u[f+21|0],w=(G-1&255)>>>0<2,o=w,(o&63)>>>0>=32?(e=l<<o,w=0):(e=(1<<o)-1&m>>>32-o|e<<o,w=m<<o);e:{if(m=i[k>>2],!e&m>>>0>=w>>>0&&(o=i[s+8>>2],l=o+i[s+4>>2]|0,e=0,e=o>>>0>l>>>0?1:e,G=(G|0)==1,o=G,(o&63)>>>0>=32?(e=l<<o,o=0):(e=(1<<o)-1&l>>>32-o|e<<o,o=l<<o),!e&o0[n>>2]>=o>>>0))break e;if(e=A,A=V2(s+28|0,5368),a(e,2,2006,A),t[A+11|0]>=0)break i;Z(i[A>>2]);break i}i[k>>2]=m-w,i[n>>2]=i[n>>2]-o}if(!A1(h,s+20|0)){e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,i[A+16>>2]=i[r+16>>2],e=i[r+12>>2],i[A+8>>2]=i[r+8>>2],i[A+12>>2]=e,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0;break i}if(e=i[s+20>>2],e>>>0>=9){if(e=A,A=V2(s+28|0,15284),a(e,2,2006,A),t[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(t[f+22|0]=e+8,!A1(h,s+20|0)){e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,i[A+16>>2]=i[r+16>>2],e=i[r+12>>2],i[A+8>>2]=i[r+8>>2],i[A+12>>2]=e,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0;break i}if(e=i[s+20>>2],e>>>0>=9){if(e=A,A=V2(s+28|0,15323),a(e,2,2006,A),t[A+11|0]>=0)break i;Z(i[A>>2]);break i}i[f+24>>2]=16777216,t[f+20|0]=0,X[f+18>>1]=0,t[f|0]=1,t[f+23|0]=e+8,Z8(A,114912)}t[r+19|0]<0&&Z(i[r+8>>2]),_&&Z(_),B&&Z(B),A=i[s+100>>2],A&&(i[s+104>>2]=A,Z(A)),v=s+112|0}function en(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0;k=v-112|0,v=k;i:{e:{if(f=i[A+104>>2],f&&(G=i[f+104>>2],G))break e;P8(e,10300,15);break i}if(Q=X8(A,G),!((Q|0)==1635135537|(Q|0)==1752589105)){P8(e,30134,60);break i}i[k+108>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,L1(k+80|0,A,G,k+100|0),t[k+99|0]<0&&Z(i[k+88>>2]),o=i[k+100>>2],s=i[k+104>>2];e:{if((o|0)!=(s|0))for(;;){f=i[o>>2];r:{if(!f||(r=Z0(f,92792,92812),!r))break r;if(f=i[o+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),!(o0[r+108>>2]<32769&o0[r+104>>2]<=32768)){if(P8(e,5105,33),!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break e;W[i[i[f>>2]+8>>2]](f),y(f);break e}if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break r;W[i[i[f>>2]+8>>2]](f),y(f)}if(o=o+8|0,(s|0)==(o|0))break}Me(k+68|0,A),o=i[k+68>>2],Y=i[k+72>>2];r:{if((o|0)==(Y|0)){n=1;break r}s=0;f:{for(;;){A:{k:{if(f=i[o>>2],(f|0)==(G|0))break k;if(w=X8(A,f),!(!((w|0)==1735551332|(w|0)==1768912492)&(w|0)!=1768187246)){P8(e,11513,65);break f}r=i[A+80>>2],_=i[A+84>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);n:{if(r){d4(k+56|0,r,f,1635088492),n=i[k+56>>2];t:{if(!((n|0)==i[k+60>>2]|i[n>>2]!=(G|0))){if(!N){r=5,N=f;break t}P8(e,11387,42),r=1;break t}d4(k+44|0,r,f,1667527523),n=i[k+44>>2];o:{if((n|0)==i[k+48>>2]){r=0;break o}r=0;l:{if(i[n>>2]!=(G|0))break l;if((w|0)!=1835625829){if((w|0)!=1165519206)break l;if(!s){r=5,s=f;break l}P8(e,11471,41),r=1;break l}j1(k+36|0,A,f);u:{s:{h:{w:{if(r=i[k+36>>2],!r)break w;if(_r(r+128|0,10670)){if(!V){V=f,r=5;break u}P8(e,11430,40);break s}if(r=i[k+36>>2],!r)break w;if(t[r+139|0]>=0){i[k+16>>2]=i[r+136>>2],n=i[r+132>>2],i[k+8>>2]=i[r+128>>2],i[k+12>>2]=n;break h}T(k+8|0,i[r+128>>2],i[r+132>>2]);break h}V2(k+8|0,8706)}E=v-16|0,v=E,m=l2(34995),R=v-16|0,v=R,r=k+24|0;h:{n=k+8|0;w:{if(u[n+11|0]>>>7|0){h=i[n+4>>2];break w}h=u[n+11|0]&127}if(l=h+m|0,l>>>0<=2147483639){w:{if(l>>>0<11){i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,t[r+11|0]=u[r+11|0]&128|l&127,t[r+11|0]=u[r+11|0]&127;break w}l>>>0>=11?(I=l+8&-8,B=I-1|0,B=(B|0)==11?I:B):B=10,B=B+1|0,I=y5(B,1),i[r+8>>2]=i[r+8>>2]&-2147483648|B&2147483647,i[r+8>>2]=i[r+8>>2]|-2147483648,i[r>>2]=I,i[r+4>>2]=l}v=R+16|0;break h}I4(),M()}if(u[r+11|0]>>>7|0&&(r=i[r>>2]),l=!m,l|l||z(r,34995,m),r=r+m|0,u[n+11|0]>>>7|0&&(n=i[n>>2]),l=!h,l|l||z(r,n,h),d5(r+h|0,1,0),v=E+16|0,t[e+11|0]<0&&Z(i[e>>2]),r=i[k+28>>2],i[e>>2]=i[k+24>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+32>>2],t[k+35|0]=0,t[k+24|0]=0,t[k+19|0]>=0)break s;Z(i[k+8>>2])}r=1}g2(k+36|0)}n=i[k+44>>2]}if(!n)break t;i[k+48>>2]=n,Z(n)}if(n=i[k+56>>2],n&&(i[k+60>>2]=n,Z(n)),r)break n}if(j1(k+44|0,A,f),r=0,f=i[k+44>>2],!(!f|(w|0)==(Q|0)|t[f+164|0]&1)){r=k+56|0,z1(r,w),h=v-16|0,v=h,u[r+11|0]>>>7|0?n=i[r+4>>2]:n=u[r+11|0]&127,f=u[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10;t:{if(f-n>>>0>=43){u[r+11|0]>>>7|0?f=i[r>>2]:f=r,n?(w=q5(f,f+n|0,34951),l=f+43|0,m=!n,m|m||z(l,f,n),l=w?34994:34951):l=34951,z(f,l,43),n=n+43|0,J6(r,n),t[h+15|0]=0,t[f+n|0]=u[h+15|0];break t}De(r,f,(n+43|0)-f|0,n,0,0,43,34951)}v=h+16|0,f=i[r+4>>2],n=i[r>>2],i[r>>2]=0,i[r+4>>2]=0,h=i[r+8>>2],i[r+8>>2]=0,t[e+11|0]<0&&Z(i[e>>2]),i[e+8>>2]=h,i[e+4>>2]=f,i[e>>2]=n,t[k+67|0]<0&&Z(i[k+56>>2]),r=1}if(f=i[k+48>>2],!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break n;W[i[i[f>>2]+8>>2]](f),y(f)}n:{if(!_||(f=i[_+4>>2],i[_+4>>2]=f-1,f))break n;W[i[i[_>>2]+8>>2]](_),y(_)}switch(n=0,r|0){case 4:break A;case 0:case 5:break k;default:break f}}if(o=o+4|0,(Y|0)!=(o|0))continue}break}if(n=1,!s|!V)break f;j1(k+56|0,A,s),j1(k+44|0,A,V),o=0,f=i[k+56>>2],A=0;A:{if(!f||(s=t[f+151|0],r=(s|0)<0,A=0,((r?i[f+144>>2]:s)|0)!=7))break A;A=!N2(r?i[f+140>>2]:f+140|0,64944,7)}f=i[k+44>>2];A:{if(!f||(s=t[f+151|0],r=(s|0)<0,((r?i[f+144>>2]:s)|0)!=7))break A;o=!N2(r?i[f+140>>2]:f+140|0,64944,7)}if((A|0)!=(o|0)){P8(e,6472,47),A=i[k+48>>2];A:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break A;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[k+60>>2];A:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break A;W[i[i[A>>2]+8>>2]](A),y(A)}n=0;break f}A=i[k+48>>2];A:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break A;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[k+60>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break f;W[i[i[A>>2]+8>>2]](A),y(A)}o=i[k+68>>2]}if(!o)break e;i[k+72>>2]=o,Z(o)}if(e=i[k+100>>2],!e)break i;if(A=e,o=i[k+104>>2],(A|0)!=(o|0)){for(;;){A=i[o-4>>2];e:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(o=o-8|0,(e|0)==(o|0))break}A=i[k+100>>2]}i[k+104>>2]=e,Z(A)}return v=k+112|0,n}function rn(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;n=v+-64|0,v=n,o=i[e+204>>2],Y=i[e+208>>2];i:{if((o|0)!=(Y|0))for(Q=A+8|0,E=e+216|0,B=n+4|0;;){e:{if(!(i[o+24>>2]!=i[e+188>>2]|i[o+28>>2]!=i[e+192>>2])){s=i[o>>2];break e}if(s=i[o>>2],s-1>>>0<2)break e;if(e=C(64),i[n>>2]=e,i[n+4>>2]=56,i[n+8>>2]=-2147483584,f=u[25888]|u[25889]<<8|(u[25890]<<16|u[25891]<<24),r=u[25884]|u[25885]<<8|(u[25886]<<16|u[25887]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+56|0]=0,f=u[25936]|u[25937]<<8|(u[25938]<<16|u[25939]<<24),r=u[25932]|u[25933]<<8|(u[25934]<<16|u[25935]<<24),t[e+48|0]=r,t[e+49|0]=r>>>8,t[e+50|0]=r>>>16,t[e+51|0]=r>>>24,t[e+52|0]=f,t[e+53|0]=f>>>8,t[e+54|0]=f>>>16,t[e+55|0]=f>>>24,f=u[25928]|u[25929]<<8|(u[25930]<<16|u[25931]<<24),r=u[25924]|u[25925]<<8|(u[25926]<<16|u[25927]<<24),t[e+40|0]=r,t[e+41|0]=r>>>8,t[e+42|0]=r>>>16,t[e+43|0]=r>>>24,t[e+44|0]=f,t[e+45|0]=f>>>8,t[e+46|0]=f>>>16,t[e+47|0]=f>>>24,f=u[25920]|u[25921]<<8|(u[25922]<<16|u[25923]<<24),r=u[25916]|u[25917]<<8|(u[25918]<<16|u[25919]<<24),t[e+32|0]=r,t[e+33|0]=r>>>8,t[e+34|0]=r>>>16,t[e+35|0]=r>>>24,t[e+36|0]=f,t[e+37|0]=f>>>8,t[e+38|0]=f>>>16,t[e+39|0]=f>>>24,f=u[25912]|u[25913]<<8|(u[25914]<<16|u[25915]<<24),r=u[25908]|u[25909]<<8|(u[25910]<<16|u[25911]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[25904]|u[25905]<<8|(u[25906]<<16|u[25907]<<24),r=u[25900]|u[25901]<<8|(u[25902]<<16|u[25903]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[25896]|u[25897]<<8|(u[25898]<<16|u[25899]<<24),r=u[25892]|u[25893]<<8|(u[25894]<<16|u[25895]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,4,0,n),t[n+11|0]>=0)break i;Z(i[n>>2]);break i}L3(r,f,s,i[e+200>>2],n+60|0,n+56|0),_=u[o+23|0],h=i[o+28>>2],m=i[o+24>>2];e:{r:{f:{A:{l=i[n+60>>2];k:{if(l>>>0<=o0[o+32>>2]&o0[o+36>>2]>=o0[n+56>>2])break k;i[B>>2]=0,i[B+4>>2]=0,X[B+16>>1]=0,i[B+8>>2]=0,i[B+12>>2]=0,t[n+22|0]=1,t[n+55|0]=0,t[n+47|0]=0,t[n+48|0]=0,t[n+49|0]=0,t[n+50|0]=0,t[n+51|0]=0,t[n+52|0]=0,t[n+53|0]=0,t[n+54|0]=0,t[n+39|0]=0,t[n+40|0]=0,t[n+41|0]=0,t[n+42|0]=0,t[n+43|0]=0,t[n+44|0]=0,t[n+45|0]=0,t[n+46|0]=0,t[n+31|0]=0,t[n+32|0]=0,t[n+33|0]=0,t[n+34|0]=0,t[n+35|0]=0,t[n+36|0]=0,t[n+37|0]=0,t[n+38|0]=0,t[n+23|0]=0,t[n+24|0]=0,t[n+25|0]=0,t[n+26|0]=0,t[n+27|0]=0,t[n+28|0]=0,t[n+29|0]=0,t[n+30|0]=0,i[n>>2]=i[o>>2],w=(n|0)==(o|0),w||(s=i[o+4>>2],l=i[o+8>>2],h1(B,s,l,l-s>>2),l=i[n+60>>2]),G=i[n+56>>2],I=i[o+16>>2],V=p[o+20>>1],s=1;n:{t:switch(i[e+200>>2]){case 10:case 12:case 14:s=3;break n;case 11:case 13:case 15:s=4;break n;case 0:case 1:case 2:case 3:case 99:break n;default:break t}s=0}if(O6(A,n,l,G,I,V,s,k,E),i[A>>2])break f;if(t[A+19|0]<0&&Z(i[A+8>>2]),!i[n+40>>2])break A;if(i[o+28>>2])for(s=0;l=g(i[o+24>>2],_),l&&z(i[n+40>>2]+g(i[n+52>>2],s)|0,i[o+40>>2]+g(i[o+52>>2],s)|0,l),s=s+1|0,s>>>0<o0[o+28>>2];);if(R5(E,i[o+48>>2]),Z(i[o+44>>2]),i[o>>2]=i[n>>2],w||(s=i[n+4>>2],l=i[n+8>>2],h1(o+4|0,s,l,l-s>>2)),l=i[n+20>>2],i[o+16>>2]=i[n+16>>2],i[o+20>>2]=l,l=i[n+52>>2],i[o+48>>2]=i[n+48>>2],i[o+52>>2]=l,l=i[n+44>>2],i[o+40>>2]=i[n+40>>2],i[o+44>>2]=l,l=i[n+36>>2],i[o+32>>2]=i[n+32>>2],i[o+36>>2]=l,l=i[n+28>>2],i[o+24>>2]=i[n+24>>2],i[o+28>>2]=l,l=i[n+4>>2],!l)break k;i[n+8>>2]=l,Z(l)}w=0,(_|0)==1&&(w=i[o>>2]-1>>>0<2?-128:0);k:{if(!h|(m|0)==i[n+60>>2])break k;if(G=g(_,m),s=0,(h|0)!=1)for(V=h&-2,I=0;l=g(i[n+60>>2]-m|0,_),l&&l0(G+(i[o+40>>2]+g(i[o+52>>2],s)|0)|0,w,l),l=g(i[n+60>>2]-m|0,_),l&&l0(G+(i[o+40>>2]+g(i[o+52>>2],s|1)|0)|0,w,l),s=s+2|0,I=I+2|0,(V|0)!=(I|0););if(!(h&1)||(l=g(i[n+60>>2]-m|0,_),!l))break k;l0(G+(i[o+40>>2]+g(i[o+52>>2],s)|0)|0,w,l)}if(s=i[n+56>>2],h>>>0<s>>>0)break r;break e}if(e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,t[114951]>=0){A=i[28736],i[Q>>2]=i[28735],i[Q+4>>2]=A,i[Q+8>>2]=i[28737];break f}T(Q,i[28735],i[28736])}if(A=i[n+4>>2],!A)break i;i[n+8>>2]=A,Z(A);break i}for(;l=g(i[n+60>>2],_),l&&l0(i[o+40>>2]+g(i[o+52>>2],h)|0,w,l),s=i[n+56>>2],h=h+1|0,s>>>0>h>>>0;);}if(l=i[n+60>>2],i[o+28>>2]=s,i[o+24>>2]=l,o=o+56|0,(Y|0)==(o|0))break}if(i[e+192>>2]=f,i[e+188>>2]=r,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731])}v=n- -64|0}function Bm(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;_=v-16|0,v=_,i[_+12>>2]=0,i[_+4>>2]=0,i[_+8>>2]=0,k=_+4|0;i:{e:{if(h=i[e+72>>2],s=i[h+116>>2],w=i[h+120>>2],(s|0)!=(w|0))for(;;){n=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+4>>2],f=i[k+8>>2];r:{if(e>>>0<f>>>0){t[e|0]=n,e=e+1|0;break r}if(o=i[k>>2],e=e-o|0,r=e+1|0,(r|0)<0)break e;if(f=f-o|0,l=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<l>>>0?l:r,f?r=C(f):r=0,l=r+e|0,t[l|0]=n,e&&z(r,o,e),i[k+8>>2]=r+f,e=l+1|0,i[k+4>>2]=e,i[k>>2]=r,!o)break r;Z(o)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>16|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){t[e|0]=n,e=e+1|0;break r}if(o=i[k>>2],e=e-o|0,r=e+1|0,(r|0)<0)break e;if(f=f-o|0,l=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<l>>>0?l:r,f?r=C(f):r=0,l=r+e|0,t[l|0]=n,e&&z(r,o,e),i[k+8>>2]=r+f,e=l+1|0,i[k+4>>2]=e,i[k>>2]=r,!o)break r;Z(o)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>8|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){t[e|0]=n,e=e+1|0;break r}if(o=i[k>>2],e=e-o|0,r=e+1|0,(r|0)<0)break e;if(f=f-o|0,l=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<l>>>0?l:r,f?r=C(f):r=0,l=r+e|0,t[l|0]=n,e&&z(r,o,e),i[k+8>>2]=r+f,e=l+1|0,i[k+4>>2]=e,i[k>>2]=r,!o)break r;Z(o)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){t[e|0]=n,e=e+1|0;break r}if(o=i[k>>2],e=e-o|0,r=e+1|0,(r|0)<0)break e;if(f=f-o|0,l=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<l>>>0?l:r,f?r=C(f):r=0,l=r+e|0,t[l|0]=n,e&&z(r,o,e),i[k+8>>2]=r+f,e=l+1|0,i[k+4>>2]=e,i[k>>2]=r,!o)break r;Z(o)}if(i[k+4>>2]=e,n=e,e=i[s>>2],r=i[s+4>>2],V4(k,n,e,r,r-e|0),s=s+12|0,(w|0)==(s|0))break}if(s=i[h+140>>2],w=i[h+144>>2],(s|0)!=(w|0))for(;;){n=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+4>>2],f=i[k+8>>2];r:{if(e>>>0<f>>>0){t[e|0]=n,e=e+1|0;break r}if(o=i[k>>2],e=e-o|0,r=e+1|0,(r|0)<0)break e;if(f=f-o|0,l=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<l>>>0?l:r,f?r=C(f):r=0,l=r+e|0,t[l|0]=n,e&&z(r,o,e),i[k+8>>2]=r+f,e=l+1|0,i[k+4>>2]=e,i[k>>2]=r,!o)break r;Z(o)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>16|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){t[e|0]=n,e=e+1|0;break r}if(o=i[k>>2],e=e-o|0,r=e+1|0,(r|0)<0)break e;if(f=f-o|0,l=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<l>>>0?l:r,f?r=C(f):r=0,l=r+e|0,t[l|0]=n,e&&z(r,o,e),i[k+8>>2]=r+f,e=l+1|0,i[k+4>>2]=e,i[k>>2]=r,!o)break r;Z(o)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>8|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){t[e|0]=n,e=e+1|0;break r}if(o=i[k>>2],e=e-o|0,r=e+1|0,(r|0)<0)break e;if(f=f-o|0,l=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<l>>>0?l:r,f?r=C(f):r=0,l=r+e|0,t[l|0]=n,e&&z(r,o,e),i[k+8>>2]=r+f,e=l+1|0,i[k+4>>2]=e,i[k>>2]=r,!o)break r;Z(o)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){t[e|0]=n,e=e+1|0;break r}if(o=i[k>>2],e=e-o|0,r=e+1|0,(r|0)<0)break e;if(f=f-o|0,l=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<l>>>0?l:r,f?r=C(f):r=0,l=r+e|0,t[l|0]=n,e&&z(r,o,e),i[k+8>>2]=r+f,e=l+1|0,i[k+4>>2]=e,i[k>>2]=r,!o)break r;Z(o)}if(i[k+4>>2]=e,n=e,e=i[s>>2],r=i[s+4>>2],V4(k,n,e,r,r-e|0),s=s+12|0,(w|0)==(s|0))break}if(s=i[h+128>>2],f=i[h+132>>2],(s|0)!=(f|0))for(;;){o=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+4>>2],n=i[k+8>>2];r:{if(e>>>0<n>>>0){t[e|0]=o,e=e+1|0;break r}if(h=i[k>>2],e=e-h|0,r=e+1|0,(r|0)<0)break e;if(n=n-h|0,w=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<w>>>0?w:r,n?r=C(n):r=0,w=r+e|0,t[w|0]=o,e&&z(r,h,e),i[k+8>>2]=r+n,e=w+1|0,i[k+4>>2]=e,i[k>>2]=r,!h)break r;Z(h)}i[k+4>>2]=e,o=i[s+4>>2]-i[s>>2]>>>16|0,n=i[k+8>>2];r:{if(n>>>0>e>>>0){t[e|0]=o,e=e+1|0;break r}if(h=i[k>>2],e=e-h|0,r=e+1|0,(r|0)<0)break e;if(n=n-h|0,w=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<w>>>0?w:r,n?r=C(n):r=0,w=r+e|0,t[w|0]=o,e&&z(r,h,e),i[k+8>>2]=r+n,e=w+1|0,i[k+4>>2]=e,i[k>>2]=r,!h)break r;Z(h)}i[k+4>>2]=e,o=i[s+4>>2]-i[s>>2]>>>8|0,n=i[k+8>>2];r:{if(n>>>0>e>>>0){t[e|0]=o,e=e+1|0;break r}if(h=i[k>>2],e=e-h|0,r=e+1|0,(r|0)<0)break e;if(n=n-h|0,w=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<w>>>0?w:r,n?r=C(n):r=0,w=r+e|0,t[w|0]=o,e&&z(r,h,e),i[k+8>>2]=r+n,e=w+1|0,i[k+4>>2]=e,i[k>>2]=r,!h)break r;Z(h)}i[k+4>>2]=e,o=i[s+4>>2]-i[s>>2]|0,n=i[k+8>>2];r:{if(n>>>0>e>>>0){t[e|0]=o,e=e+1|0;break r}if(h=i[k>>2],e=e-h|0,r=e+1|0,(r|0)<0)break e;if(n=n-h|0,w=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<w>>>0?w:r,n?r=C(n):r=0,w=r+e|0,t[w|0]=o,e&&z(r,h,e),i[k+8>>2]=r+n,e=w+1|0,i[k+4>>2]=e,i[k>>2]=r,!h)break r;Z(h)}if(i[k+4>>2]=e,n=e,e=i[s>>2],r=i[s+4>>2],V4(k,n,e,r,r-e|0),s=s+12|0,(f|0)==(s|0))break}break i}s0(),M()}e=i[_+8>>2],r=i[_+4>>2],k=i[_+12>>2],t[A+20|0]=0,i[A+8>>2]=k,i[A>>2]=r,i[A+4>>2]=e,v=_+16|0}function Ie(A,e,r,f,k,n,o,l,s,h){var w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=0,c2=0,f1=0,o1=0,u1=0;m=v-128|0,v=m;i:{e:{r:{if(I=i[A+140>>2],w=I+g(e,24)|0,Q=i[A+152>>2],N=g(Q,r),_=(w+g(N,24)|0)+4|0,S=f<<1,V=u[_|0]>>>S&3,!V)break r;if(Y=g(e,k),e=i[A+148>>2],E=Y>>e,(E|0)<0|(Q|0)<=(E|0))break e;if(q=g(r,n),r=q>>e,(r|0)<0|(r|0)>=i[A+156>>2])break i;if(R=i[A+124>>2],_0=i[R+(f?16840:16832)>>2],e=-1<<_0^-1,U=i[(f?36:28)+A>>2],d=(U|0)<(n+q|0)?U-q|0:n,t0=i[(f?32:24)+A>>2],c=(t0|0)<(k+Y|0)?t0-Y|0:k,x=f?i[R+16856>>2]-1|0:0,j=f?i[R+16852>>2]-1|0:0,k=u[(w+g(N,24)|0)+22|0],(V|0)==2){if(N=i[A+132>>2],Q=i[i[i[A+52>>2]+(p[((I+g(E,24)|0)+g(g(r,Q),24)|0)+2>>1]<<2)>>2]+808>>2],n=i[R+16876>>2],E=i[R+16892>>2],I=u[_+1|0],r=_+(f<<2)|0,t[m|0]=u[r+5|0],f=u[r+6|0],t[m+2|0]=0,t[m+1|0]=f,t[m+3|0]=u[r+7|0],t[m+4|0]=u[r+8|0],(d|0)<=0|(c|0)<=0)break r;for(r=(I>>>S&3)<<2,C0=i[r+68856>>2],q0=g(C0,l),r0=i[r+68872>>2],r2=g(r0,l),_0=i[r+68840>>2],f0=i[r+68824>>2],g0=n-j|0,M0=Y>>g0,f2=d-1|0,A2=c-1|0,s2=s+Y|0,v2=o+Y|0,X0=n-x|0,z0=g(E,q>>X0),o=0,Z2=k&1;;){for(r=o+q|0,s=r<<x,_=r+C0|0,X2=_<<x,I=r+r0|0,R2=I<<x,D2=g(r,h)+s2|0,c2=g(r,l)+v2|0,f1=g(E,I>>>X0|0)<<2,o1=g(E,_>>>X0|0)<<2,u1=(o|0)!=(f2|0),k=0;;){f:{A:{if(!Z2){n=i[A+168>>2];break A}if(n=i[A+168>>2],!u[R+8812|0])break A;if(r=k+Y<<j>>n,(r|0)<0||(w=i[A+172>>2],(w|0)<=(r|0)))break e;if(f=s>>n,(f|0)<0|(f|0)>=i[A+176>>2])break i;if(u[((i[A+160>>2]+g(r,3)|0)+g(g(f,w),3)|0)+1|0]&4)break f}if(G=k+Y|0,A0=G<<j,r=A0>>n,(r|0)<0||(w=i[A+172>>2],(w|0)<=(r|0)))break e;if(f=s>>n,(f|0)<0|(f|0)>=i[A+176>>2])break i;if(u[((i[A+160>>2]+g(r,3)|0)+g(g(f,w),3)|0)+1|0]&8)break f;A:{if(!(!o|!k|(k|0)==(A2|0))&&u1)break A;if(w=G+_0|0,(w|0)>=(t0|0)|(w|0)<0|((I|0)<0|(I|0)>=(U|0)))break f;if(r=i[A+148>>2],V=w<<j>>r,(V|0)<0||(f=i[A+152>>2],(f|0)<=(V|0)))break e;if(B=R2>>r,(B|0)<0||(S=i[A+156>>2],(S|0)<=(B|0)))break i;if(n=i[A+52>>2],j0=i[A+56>>2]-n>>2,O=g(V,24),V=i[A+140>>2],B=p[((O+V|0)+g(g(f,B),24)|0)+2>>1],j0>>>0<=B>>>0||(B=i[n+(B<<2)>>2],!B))break r;if(S0=i[B+808>>2],(Q|0)>(S0|0)){if(O=A0>>r,(O|0)<0|f>>>0<=O>>>0)break e;if(V0=s>>r,(V0|0)<0|(S|0)<=(V0|0))break i;if(!u[i[n+(p[((V+g(O,24)|0)+g(g(f,V0),24)|0)+2>>1]<<2)>>2]+772|0])break f}if(!u[B+772|0]&(Q|0)<(S0|0)||(O=u[N+57|0],!O&&(B=w>>>g0<<2,w=i[N+8484>>2],i[(B+w|0)+f1>>2]!=i[(w+(M0<<2)|0)+(z0<<2)>>2]))||(w=G+f0|0,(w|0)>=(t0|0)|(w|0)<0|((_|0)<0|(_|0)>=(U|0))))break f;if(G=w<<j>>r,(G|0)<0|f>>>0<=G>>>0)break e;if(B=X2>>r,(B|0)<0|(B|0)>=(S|0))break i;if(G=p[((V+g(G,24)|0)+g(g(f,B),24)|0)+2>>1],G>>>0>=j0>>>0||(G=i[n+(G<<2)>>2],!G))break r;if(B=i[G+808>>2],(B|0)<(Q|0)){if(A0=A0>>r,(A0|0)<0|f>>>0<=A0>>>0)break e;if(r=s>>r,(r|0)<0|(r|0)>=(S|0))break i;if(!u[i[n+(p[((V+g(A0,24)|0)+g(g(r,f),24)|0)+2>>1]<<2)>>2]+772|0])break f}if(!u[G+772|0]&(B|0)>(Q|0))break f;if(O||(r=i[N+8484>>2],i[(r+(w>>>g0<<2)|0)+o1>>2]==i[(r+(M0<<2)|0)+(z0<<2)>>2]))break A;break f}f=k+c2|0,r=u[f|0],n=u[(f+_0|0)+r2|0],f=u[(f+f0|0)+q0|0],r=t[(((r>>>0>n>>>0)-(r>>>0<n>>>0)+((f>>>0<r>>>0)-(r>>>0<f>>>0))|0)+m|0)+2|0]+r|0,t[k+D2|0]=(r|0)>=0?(e|0)>(r|0)?r:e:0}if(k=k+1|0,(c|0)==(k|0))break}if(o=o+1|0,(d|0)==(o|0))break}break r}if(r=u[(f+_|0)+2|0],l0(m,0,128),i[((r&31)<<2)+m>>2]=1,i[((r+1&31)<<2)+m>>2]=2,i[((r+2&31)<<2)+m>>2]=3,i[((r+3&31)<<2)+m>>2]=4,Q=_0-5|0,!(k&1)){if((d|0)<=0|(c|0)<=0)break r;for(n=_+5|0,r=0;;){for(A=r+q|0,R=g(A,h)+s|0,j=g(A,l)+o|0,A=0;_=A+Y|0,k=u[_+j|0],x=i[((e>>>0>k>>>0?k:e)>>>Q<<2)+m>>2],(x|0)>0&&(k=k+t[(x+(n+(f<<2)|0)|0)-1|0]|0,t[_+R|0]=(k|0)>=0?(e|0)>(k|0)?k:e:0),A=A+1|0,(c|0)>(A|0););if(r=r+1|0,!((d|0)>(r|0)))break}break r}if((d|0)<=0|(c|0)<=0)break r;t0=_+5|0,_=0;f:{for(;;){r=_+q|0,N=r<<x,E=g(r,h)+s|0,I=g(r,l)+o|0,r=0;A:{for(;;){n=i[A+168>>2],k=N>>n,U=r+Y|0,n=U<<j>>n;k:{n:{if(u[R+8812|0]){if((n|0)<0||(w=i[A+172>>2],(w|0)<=(n|0)))break A;if((k|0)<0|(k|0)>=i[A+176>>2])break i;if(!(u[((i[A+160>>2]+g(n,3)|0)+g(g(k,w),3)|0)+1|0]&4))break n;break k}if((n|0)<0)break e}if(w=i[A+172>>2],(w|0)<=(n|0))break e;if((k|0)<0|(k|0)>=i[A+176>>2])break f;if(u[((i[A+160>>2]+g(n,3)|0)+g(g(k,w),3)|0)+1|0]&8||(k=u[I+U|0],n=i[((e>>>0>k>>>0?k:e)>>>Q<<2)+m>>2],(n|0)<=0))break k;k=k+t[(n+(t0+(f<<2)|0)|0)-1|0]|0,t[E+U|0]=(k|0)>=0?(e|0)>(k|0)?k:e:0}if(r=r+1|0,!((c|0)>(r|0)))break}if(_=_+1|0,(d|0)<=(_|0))break r;continue}break}break e}break i}v=m+128|0;return}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function fn(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0;k=v-16|0,v=k,i[k+12>>2]=A;i:{if(A>>>0<=211){A=i[mu(76400,76592,k+12|0)>>2];break i}for(A>>>0>=4294967292&&(N1(),M()),n=(A>>>0)/210|0,f=g(n,210),i[k+8>>2]=A-f,o=mu(76592,76784,k+8|0)-76592>>2;;){A=i[(o<<2)+76592>>2]+f|0,f=5;e:{r:{for(;;){if(r=f,(r|0)==47)break r;if(l=i[(r<<2)+76400>>2],e=(A>>>0)/(l>>>0)|0,e>>>0<l>>>0)break i;if(f=r+1|0,(g(e,l)|0)==(A|0))break}if(r>>>0<47)break e}for(f=211;;){if(r=(A>>>0)/(f>>>0)|0,r>>>0<f>>>0)break i;if((g(r,f)|0)==(A|0))break e;if(e=f+10|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+12|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+16|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+18|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+22|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+28|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+30|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+36|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+40|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+42|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+46|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+52|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+58|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+60|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+66|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+70|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+72|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+78|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+82|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+88|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+96|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+100|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+102|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+106|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+108|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+112|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+120|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+126|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+130|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+136|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+138|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+142|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+148|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+150|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+156|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+162|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+166|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+168|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+172|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+178|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+180|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+186|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+190|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+192|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+196|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+198|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((g(r,e)|0)==(A|0))break e;if(e=f+208|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if(f=f+210|0,(g(r,e)|0)==(A|0))break}}A=o+1|0,r=(A|0)==48,o=r?0:A,n=r+n|0,f=g(n,210)}}return v=k+16|0,A}function Pr(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0;for(_=i[A+20>>2],w=i[A+16>>2],h=i[A+12>>2],q=i[A+8>>2];s=u[e|0]|u[e+1|0]<<8|(u[e+2|0]<<16|u[e+3|0]<<24),i[A+88>>2]=s,B=u[e+4|0]|u[e+5|0]<<8|(u[e+6|0]<<16|u[e+7|0]<<24),i[A+92>>2]=B,m=u[e+8|0]|u[e+9|0]<<8|(u[e+10|0]<<16|u[e+11|0]<<24),i[A+96>>2]=m,G=u[e+12|0]|u[e+13|0]<<8|(u[e+14|0]<<16|u[e+15|0]<<24),i[A+100>>2]=G,I=u[e+16|0]|u[e+17|0]<<8|(u[e+18|0]<<16|u[e+19|0]<<24),i[A+104>>2]=I,Q=u[e+20|0]|u[e+21|0]<<8|(u[e+22|0]<<16|u[e+23|0]<<24),i[A+108>>2]=Q,V=u[e+24|0]|u[e+25|0]<<8|(u[e+26|0]<<16|u[e+27|0]<<24),i[A+112>>2]=V,Y=u[e+28|0]|u[e+29|0]<<8|(u[e+30|0]<<16|u[e+31|0]<<24),i[A+116>>2]=Y,E=u[e+32|0]|u[e+33|0]<<8|(u[e+34|0]<<16|u[e+35|0]<<24),i[A+120>>2]=E,R=u[e+36|0]|u[e+37|0]<<8|(u[e+38|0]<<16|u[e+39|0]<<24),i[A+124>>2]=R,N=u[e+40|0]|u[e+41|0]<<8|(u[e+42|0]<<16|u[e+43|0]<<24),i[A+128>>2]=N,U=u[e+44|0]|u[e+45|0]<<8|(u[e+46|0]<<16|u[e+47|0]<<24),i[A+132>>2]=U,x=u[e+48|0]|u[e+49|0]<<8|(u[e+50|0]<<16|u[e+51|0]<<24),i[A+136>>2]=x,j=u[e+52|0]|u[e+53|0]<<8|(u[e+54|0]<<16|u[e+55|0]<<24),i[A+140>>2]=j,O=u[e+56|0]|u[e+57|0]<<8|(u[e+58|0]<<16|u[e+59|0]<<24),i[A+144>>2]=O,S=u[e+60|0]|u[e+61|0]<<8|(u[e+62|0]<<16|u[e+63|0]<<24),i[A+148>>2]=S,f=t2(((((w^_)&h^_)+q|0)+s|0)-680876936|0,7)+h|0,k=t2(((_+B|0)+(f&(h^w)^w)|0)-389564586|0,12)+f|0,n=t2(((w+m|0)+(k&(f^h)^h)|0)+606105819|0,17)+k|0,o=t2(((h+G|0)+(f^n&(f^k))|0)-1044525330|0,22)+n|0,f=t2(((f+I|0)+(k^o&(k^n))|0)-176418897|0,7)+o|0,k=t2(((k+Q|0)+(n^f&(o^n))|0)+1200080426|0,12)+f|0,n=t2(((n+V|0)+(o^k&(f^o))|0)-1473231341|0,17)+k|0,o=t2(((o+Y|0)+(f^n&(f^k))|0)-45705983|0,22)+n|0,f=t2(((f+E|0)+(k^o&(k^n))|0)+1770035416|0,7)+o|0,k=t2(((k+R|0)+(n^f&(o^n))|0)-1958414417|0,12)+f|0,n=t2(((n+N|0)+(o^k&(f^o))|0)-42063|0,17)+k|0,o=t2(((o+U|0)+(f^n&(f^k))|0)-1990404162|0,22)+n|0,l=k+j|0,k=t2(((f+x|0)+(k^o&(k^n))|0)+1804603682|0,7)+o|0,l=t2((l+(n^k&(o^n))|0)-40341101|0,12)+k|0,f=o+S|0,o=t2(((n+O|0)+(o^l&(k^o))|0)-1502002290|0,17)+l|0,f=t2((f+(k^o&(k^l))|0)+1236535329|0,22)+o|0,k=t2(((k+B|0)+(o^l&(f^o))|0)-165796510|0,5)+f|0,n=t2(((l+V|0)+((f^k)&o^f)|0)-1069501632|0,9)+k|0,o=t2(((o+U|0)+(k^f&(k^n))|0)+643717713|0,14)+n|0,f=t2(((f+s|0)+(n^k&(o^n))|0)-373897302|0,20)+o|0,k=t2(((k+Q|0)+(o^n&(f^o))|0)-701558691|0,5)+f|0,n=t2(((n+N|0)+((f^k)&o^f)|0)+38016083|0,9)+k|0,o=t2(((o+S|0)+(k^f&(k^n))|0)-660478335|0,14)+n|0,f=t2(((f+I|0)+(n^k&(o^n))|0)-405537848|0,20)+o|0,k=t2(((k+R|0)+(o^n&(f^o))|0)+568446438|0,5)+f|0,n=t2(((n+O|0)+((f^k)&o^f)|0)-1019803690|0,9)+k|0,o=t2(((o+G|0)+(k^f&(k^n))|0)-187363961|0,14)+n|0,f=t2(((f+E|0)+(n^k&(o^n))|0)+1163531501|0,20)+o|0,k=t2(((k+j|0)+(o^n&(f^o))|0)-1444681467|0,5)+f|0,n=t2(((n+m|0)+((f^k)&o^f)|0)-51403784|0,9)+k|0,d=f+x|0,l=t2(((o+Y|0)+(k^f&(k^n))|0)+1735328473|0,14)+n|0,f=l^n,o=t2((d+(n^k&f)|0)-1926607734|0,20)+l|0,f=t2(((k+Q|0)+(f^o)|0)-378558|0,4)+o|0,k=t2(((n+E|0)+(f^(o^l))|0)-2022574463|0,11)+f|0,n=t2(((l+U|0)+(k^(f^o))|0)+1839030562|0,16)+k|0,o=t2(((o+O|0)+(n^(f^k))|0)-35309556|0,23)+n|0,f=t2(((f+B|0)+(o^(k^n))|0)-1530992060|0,4)+o|0,k=t2(((k+I|0)+(f^(o^n))|0)+1272893353|0,11)+f|0,n=t2(((n+Y|0)+(k^(f^o))|0)-155497632|0,16)+k|0,o=t2(((o+N|0)+(n^(f^k))|0)-1094730640|0,23)+n|0,f=t2(((f+j|0)+(o^(k^n))|0)+681279174|0,4)+o|0,k=t2(((k+s|0)+(f^(o^n))|0)-358537222|0,11)+f|0,n=t2(((n+G|0)+(k^(f^o))|0)-722521979|0,16)+k|0,o=t2(((o+V|0)+(n^(f^k))|0)+76029189|0,23)+n|0,f=t2(((f+R|0)+(o^(k^n))|0)-640364487|0,4)+o|0,k=t2(((k+x|0)+(f^(o^n))|0)-421815835|0,11)+f|0,l=f+s|0,s=f^k,f=t2(((n+S|0)+(k^(f^o))|0)+530742520|0,16)+k|0,n=t2(((o+m|0)+(s^f)|0)-995338651|0,23)+f|0,o=t2((l+((n|k^-1)^f)|0)-198630844|0,6)+n|0,l=n+Q|0,s=f+O|0,f=t2(((k+Y|0)+(n^(o|f^-1))|0)+1126891415|0,10)+o|0,n=t2((s+(o^(f|n^-1))|0)-1416354905|0,15)+f|0,k=t2((l+((n|o^-1)^f)|0)-57434055|0,21)+n|0,l=n+N|0,s=f+G|0,f=t2(((o+x|0)+(n^(k|f^-1))|0)+1700485571|0,6)+k|0,n=t2((s+(k^(f|n^-1))|0)-1894986606|0,10)+f|0,o=t2((l+((n|k^-1)^f)|0)-1051523|0,15)+n|0,l=n+S|0,s=f+E|0,f=t2(((k+B|0)+(n^(o|f^-1))|0)-2054922799|0,21)+o|0,n=t2((s+(o^(f|n^-1))|0)+1873313359|0,6)+f|0,k=t2((l+((n|o^-1)^f)|0)-30611744|0,10)+n|0,l=n+I|0,s=f+j|0,f=t2(((o+V|0)+(n^(k|f^-1))|0)-1560198380|0,15)+k|0,n=t2((s+(k^(f|n^-1))|0)+1309151649|0,21)+f|0,o=t2((l+((n|k^-1)^f)|0)-145523070|0,6)+n|0,k=t2(((k+U|0)+(n^(o|f^-1))|0)-1120210379|0,10)+o|0,f=t2(((f+m|0)+(o^(k|n^-1))|0)+718787259|0,15)+k|0,h=(f+h|0)+t2(((n+R|0)+(k^(f|o^-1))|0)-343485551|0,21)|0,w=f+w|0,_=k+_|0,q=o+q|0,e=e- -64|0,r=r+-64|0,!!r;);return i[A+20>>2]=_,i[A+16>>2]=w,i[A+12>>2]=h,i[A+8>>2]=q,e}function An(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;k=v-112|0,v=k,f=i[i[e+108>>2]-8>>2],W[i[i[f>>2]+12>>2]](k+104|0,f),f=i[k+104>>2],W[i[i[f>>2]+28>>2]](k+56|0,f);i:{e:{if(!u[k+100|0]){i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break e}if(l=i[k+68>>2],f=i[k+72>>2],!((l|0)!=(f|0)|i[k+56>>2]!=i[k+60>>2])){t[A+20|0]=0,t[A|0]=0;break e}if(!u[e+304|0]){if(f=i[k+104>>2],W[i[i[f>>2]+32>>2]](k+48|0,f,k+56|0),f=i[k+48>>2],f){X[f+116>>1]=p[e+292>>1],X[f+118>>1]=p[e+294>>1],o=C(128),i[o>>2]=99868,i[o+4>>2]=0,i[o+8>>2]=0,l=o+16|0,f=l,i[f+8>>2]=0,i[f+12>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=92500,i[o+60>>2]=0,i[o+64>>2]=0,i[o+52>>2]=0,i[o+56>>2]=0,i[o+72>>2]=-1,i[o+76>>2]=-1,i[o+80>>2]=-1,i[o+84>>2]=-1,i[o+116>>2]=0,i[o+88>>2]=0,i[o+92>>2]=0,i[o+96>>2]=0,i[o+100>>2]=0,i[o+104>>2]=0,i[o+108>>2]=0,X[o+112>>1]=0,i[o+16>>2]=112376,i[o+32>>2]=1667462004,X[o+120>>1]=p[k+80>>1],t[o+122|0]=u[k+82|0],f=i[k+48>>2],i[k+20>>2]=o,i[k+16>>2]=l,i[o+4>>2]=i[o+4>>2]+1,P0(f+36|0,k+16|0),l=i[k+20>>2];r:{if(!l||(f=i[l+4>>2],i[l+4>>2]=f-1,f))break r;W[i[i[l>>2]+8>>2]](l),y(l)}f=i[o+4>>2],i[o+4>>2]=f-1,f||(W[i[i[o>>2]+8>>2]](o),y(o));r:{if(i[e+296>>2]!=2)break r;if(n=C(136),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=99908,o=n+16|0,f=o,i[f+8>>2]=0,i[f+12>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,i[n+16>>2]=92500,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,X[n+112>>1]=0,i[n+16>>2]=112456,i[n+128>>2]=0,i[n+120>>2]=0,i[n+124>>2]=0,i[n+32>>2]=1635088489,r=i[i[r>>2]+4>>2],l=(r|0)==1?23611:(r|0)==2?23638:20706,s=l2(l),s>>>0>=2147483640)break i;f:{A:{if(s>>>0>=11){f=s|7,r=C(f+1|0),i[k+24>>2]=f-2147483647,i[k+16>>2]=r,i[k+20>>2]=s;break A}if(t[k+27|0]=s,r=k+16|0,!s)break f}if(!s)break f;z(r,l,s)}l=n+120|0,t[r+s|0]=0,f=t[k+27|0];f:{A:{if(t[n+131|0]>=0){if((f|0)>=0){r=i[k+20>>2],i[l>>2]=i[k+16>>2],i[l+4>>2]=r,i[l+8>>2]=i[k+24>>2];break f}m1(l,i[k+16>>2],i[k+20>>2]);break A}r=(f|0)<0,R1(l,r?i[k+16>>2]:k+16|0,r?i[k+20>>2]:f)}if(t[k+27|0]>=0)break f;Z(i[k+16>>2])}r=i[k+48>>2],i[k+20>>2]=n,i[k+16>>2]=o,i[n+4>>2]=i[n+4>>2]+1,P0(r+36|0,k+16|0),f=i[k+20>>2];f:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=i[n+4>>2],i[n+4>>2]=r-1,r)break r;W[i[i[n>>2]+8>>2]](n),y(n)}i[k+40>>2]=i[k+48>>2],r=i[k+52>>2],i[k+44>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[k+44>>2],i[k+8>>2]=i[k+40>>2],i[k+12>>2]=r,Qt(e,k+8|0),t[e+304|0]=1}f=i[k+52>>2];r:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break r;W[i[i[f>>2]+8>>2]](f),y(f)}l=i[k+68>>2],f=i[k+72>>2]}r:{if((f|0)==(l|0))break r;o=k+68|0,s=i[k+96>>2],i[k+48>>2]=s,n=e+308|0,f=i[e+312>>2];f:{A:{if(!f){r=e+312|0,l=r;break A}for(;;){if(l=f,r=i[f+16>>2],r>>>0>s>>>0){if(r=f,f=i[f>>2],f)continue;break A}if(r>>>0>=s>>>0)break f;if(f=i[l+4>>2],!f)break}r=l+4|0}f=C(44),i[f+20>>2]=0,i[f+24>>2]=0,i[f+16>>2]=s,i[f+8>>2]=l,i[f>>2]=0,i[f+4>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[r>>2]=f,r=i[i[n>>2]>>2],r&&(i[n>>2]=r),G1(i[e+312>>2],f),i[e+316>>2]=i[e+316>>2]+1}if(a9(k+16|0,e,o,i[f+20>>2],g(i[e+320>>2],s-i[i[e+232>>2]+108>>2]|0),u[k+92|0],i[f+40>>2],f+24|0),a2(i[f+40>>2]),i[f+40>>2]=0,f=i[n+4>>2],f){for(s=i[k+48>>2],o=n+4|0,l=o,r=f;e=s>>>0>o0[r+16>>2],l=e?l:r,r=i[(e?4:0)+r>>2],!!r;);if(!((o|0)==(l|0)|s>>>0<o0[l+16>>2])){e=i[l+4>>2];f:{if(!e){for(e=l;r=i[e+8>>2],o=i[r>>2]!=(e|0),e=r,!!o;);break f}for(;r=e,e=i[r>>2],!!e;);}i[n>>2]==(l|0)&&(i[n>>2]=r),i[n+8>>2]=i[n+8>>2]-1,Rn(f,l),u[l+36|0]!=1|t[l+35|0]>=0||Z(i[l+24>>2]),Z(l)}}if(i[k+16>>2]){if(e=i[k+20>>2],i[A>>2]=i[k+16>>2],i[A+4>>2]=e,r=A+8|0,t[k+35|0]>=0){e=i[k+28>>2],i[r>>2]=i[k+24>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+32>>2],t[A+20|0]=1;break e}if(T(r,i[k+24>>2],i[k+28>>2]),e=t[k+35|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[k+24>>2]);break e}if(t[k+35|0]>=0)break r;Z(i[k+24>>2])}t[A+20|0]=0,t[A|0]=1}e:{if(u[k+100|0]!=1||(A=i[k+68>>2],A&&(i[k+72>>2]=A,Z(A)),A=i[k+56>>2],!A))break e;if(l=i[k+60>>2],f=A,(l|0)!=(f|0)){for(;;){r=i[l-4>>2];r:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break r;W[i[i[r>>2]+8>>2]](r),y(r)}if(l=l-8|0,(A|0)==(l|0))break}f=i[k+56>>2]}i[k+60>>2]=A,Z(f)}e=i[k+108>>2];e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}v=k+112|0;return}I0(),M()}function vm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;h=v-48|0,v=h,n=i[e>>2],_=i[e+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);i:{if(!i[n+84>>2]&o0[n+80>>2]<=o0[n+96>>2]){i[A>>2]=13,i[A+4>>2]=0,i[A+8>>2]=16796;break i}o=h+12|0,k=v-160|0,v=k,f=i[n+96>>2];e:{if(!i[n+84>>2]&f>>>0>=o0[n+80>>2]){f=C(16),i[k+8>>2]=f,i[k+12>>2]=15,i[k+16>>2]=-2147483632,n=u[16807]|u[16808]<<8|(u[16809]<<16|u[16810]<<24),l=u[16803]|u[16804]<<8|(u[16805]<<16|u[16806]<<24),t[f+7|0]=l,t[f+8|0]=l>>>8,t[f+9|0]=l>>>16,t[f+10|0]=l>>>24,t[f+11|0]=n,t[f+12|0]=n>>>8,t[f+13|0]=n>>>16,t[f+14|0]=n>>>24,n=u[16800]|u[16801]<<8|(u[16802]<<16|u[16803]<<24),l=u[16796]|u[16797]<<8|(u[16798]<<16|u[16799]<<24),t[f|0]=l,t[f+1|0]=l>>>8,t[f+2|0]=l>>>16,t[f+3|0]=l>>>24,t[f+4|0]=n,t[f+5|0]=n>>>8,t[f+6|0]=n>>>16,t[f+7|0]=n>>>24,t[f+15|0]=0,f=a(k+88|0,13,0,k+8|0),n=i[f+4>>2],i[o>>2]=i[f>>2],i[o+4>>2]=n,n=o+8|0;r:{if(t[f+19|0]>=0){l=i[f+12>>2],i[n>>2]=i[f+8>>2],i[n+4>>2]=l,i[n+8>>2]=i[f+16>>2],t[o+20|0]=1;break r}if(T(n,i[f+8>>2],i[f+12>>2]),n=t[f+19|0],t[o+20|0]=1,(n|0)>=0)break r;Z(i[f+8>>2])}if(t[k+19|0]>=0)break e;Z(i[k+8>>2]);break e}w=f,f=i[n+68>>2],f=g((w>>>0)%((i[n+72>>2]-f|0)/48>>>0)|0,48)+f|0,l=i[f>>2],w=k+88|0,oo(w,i[i[n+104>>2]+(i[f+8>>2]<<3)>>2],l),DA(k- -64|0,w);r:{f:{A:{k:{n:switch(u[k+84|0]){case 1:f=i[k+68>>2],i[o>>2]=i[k+64>>2],i[o+4>>2]=f,f=o+8|0;t:{if(t[k+83|0]>=0){n=i[k+76>>2],i[f>>2]=i[k+72>>2],i[f+4>>2]=n,i[f+8>>2]=i[k+80>>2];break t}T(f,i[k+72>>2],i[k+76>>2])}t[o+20|0]=1;break r;case 0:break n;default:break k}w=C(32),f=w,i[f>>2]=0,i[f+4>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0,s=i[k+64>>2],(s|0)!=(f|0)&&(f=i[s>>2],s=i[s+4>>2],$4(w,f,s,s-f|0)),f=i[n+208>>2],f&&(G=w,I=j5(f,l),i[G+12>>2]=I),s=i[n+280>>2];n:{if(!s)break n;f=i[n+20>>2],B=i[f+48>>2],f=i[f+52>>2];t:{if(!f){Ci(k+8|0,s,B,l);break t}if(i[f+4>>2]=i[f+4>>2]+1,Ci(k+8|0,s,B,l),s=i[f+4>>2],i[f+4>>2]=s-1,s)break t;W[i[i[f>>2]+8>>2]](f),y(f)}t:switch(u[k+28|0]){case 1:f=i[k+12>>2],i[o>>2]=i[k+8>>2],i[o+4>>2]=f,f=o+8|0;o:{if(t[k+27|0]>=0){n=i[k+20>>2],i[f>>2]=i[k+16>>2],i[f+4>>2]=n,i[f+8>>2]=i[k+24>>2],f=1;break o}T(f,i[k+16>>2],i[k+20>>2]),f=u[k+28|0]}t[o+20|0]=1;break f;case 0:break t;default:break k}t:{if(i[k+8>>2]==i[k+12>>2]){f=0;break t}f=k+40|0,ZA(f,k+8|0),s=u[k+60|0];o:{if(s){if((s|0)!=1)break k;h6(o,f);break o}Eu(w+20|0,k+40|0)}if(f=u[k+60|0],(f|0)!=255&&(B=i[28407],i[k+152>>2]=i[28406],i[k+156>>2]=B,W[i[(k+152|0)+(f<<2)>>2]](k+151|0,k+40|0)),f=u[k+28|0],s)break f;if((f|0)==255)break n}s=i[28411],i[k+40>>2]=i[28410],i[k+44>>2]=s,W[i[(k+40|0)+(f<<2)>>2]](k+152|0,k+8|0)}s=i[n+276>>2];n:{if(!s)break n;f=i[n+20>>2],B=i[f+48>>2],f=i[f+52>>2];t:{if(!f){Ci(k+40|0,s,B,l);break t}if(i[f+4>>2]=i[f+4>>2]+1,Ci(k+40|0,s,B,l),l=i[f+4>>2],i[f+4>>2]=l-1,l)break t;W[i[i[f>>2]+8>>2]](f),y(f)}t:switch(u[k+60|0]){case 1:f=i[k+44>>2],i[o>>2]=i[k+40>>2],i[o+4>>2]=f,f=o+8|0;o:{if(t[k+59|0]>=0){n=i[k+52>>2],i[f>>2]=i[k+48>>2],i[f+4>>2]=n,i[f+8>>2]=i[k+56>>2],f=1;break o}T(f,i[k+48>>2],i[k+52>>2]),f=u[k+60|0]}t[o+20|0]=1;break A;case 0:break t;default:break k}t:{if(i[k+40>>2]==i[k+44>>2]){f=0;break t}f=k+8|0,dn(f,k+40|0),l=u[k+32|0];o:{if(l){if((l|0)!=1)break k;h6(o,f);break o}if(f=bi(),i[w+16>>2]=f,u[k+32|0])break k;li(f,k+8|0)}if(f=u[k+32|0],(f|0)!=255&&(s=i[28413],i[k+152>>2]=i[28412],i[k+156>>2]=s,W[i[(k+152|0)+(f<<2)>>2]](k+151|0,k+8|0)),f=u[k+60|0],l)break A;if((f|0)==255)break n}l=i[28411],i[k+8>>2]=i[28410],i[k+12>>2]=l,W[i[(k+8|0)+(f<<2)>>2]](k+152|0,k+40|0)}i[n+96>>2]=i[n+96>>2]+1,t[o+20|0]=0,i[o>>2]=w;break r}e2(),M()}if((f|0)==255)break r;o=i[28411],i[k+8>>2]=i[28410],i[k+12>>2]=o,W[i[(k+8|0)+(f<<2)>>2]](k+152|0,k+40|0);break r}if((f|0)==255)break r;o=i[28411],i[k+40>>2]=i[28410],i[k+44>>2]=o,W[i[(k+40|0)+(f<<2)>>2]](k+152|0,k+8|0)}if(f=u[k+84|0],(f|0)!=255&&(o=i[28415],i[k+8>>2]=i[28414],i[k+12>>2]=o,W[i[(k+8|0)+(f<<2)>>2]](k+40|0,k- -64|0)),k1(k+112|0),f=i[k+100>>2],f&&(i[k+104>>2]=f,Z(f)),f=i[k+92>>2],!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break e;W[i[i[f>>2]+8>>2]](f),y(f)}v=k+160|0;e:{r:switch(u[h+32|0]){default:e2(),M();case 0:i[r>>2]=i[h+12>>2],i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e;break e;case 1:break r}if(c0(A,h+12|0,i[e+8>>2]),m=u[h+32|0],(m|0)==255)break i}A=i[25819],i[h+40>>2]=i[25818],i[h+44>>2]=A,W[i[(h+40|0)+(m<<2)>>2]](h+39|0,h+12|0)}i:{if(!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;W[i[i[_>>2]+8>>2]](_),y(_)}v=h+48|0}function mm(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;k=v-144|0,v=k,i[k+104>>2]=0,i[k+108>>2]=0,i[k+112>>2]=0,i[k+116>>2]=0,t[k+119|0]=0,t[k+120|0]=0,t[k+121|0]=0,t[k+122|0]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+136>>2]=0,t[k+132|0]=1,s=C(160),i[s>>2]=96588,i[s+4>>2]=0,i[s+8>>2]=0,l=s+16|0,e=l,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,e=s,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,t[e+112|0]=0,i[l>>2]=104068,i[e+156>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,t[e+145|0]=4,i[e+124>>2]=0,i[e+128>>2]=0,i[e+32>>2]=1752589123,o=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[k+92>>2]=e,i[k+88>>2]=o,W[i[i[f>>2]+100>>2]](k+72|0,i[f+4>>2],k+88|0,n);i:{e:{r:{f:{A:{k:{if(n=i[k+72>>2],n){if(r=i[k+76>>2],l=i[k+80>>2],e=l2(l),e>>>0>=2147483640)break k;n:{t:{if(e>>>0>=11){o=e|7,f=C(o+1|0),i[k+44>>2]=o-2147483647,i[k+36>>2]=f,i[k+40>>2]=e;break t}if(t[k+47|0]=e,f=k+36|0,!e)break n}if(!e)break n;z(f,l,e)}t[e+f|0]=0,e=a(k+48|0,n,r,k+36|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;n:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+44|0]=1;break n}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+44|0]=1,(r|0)>=0)break n;Z(i[e+8>>2])}if(t[k+47|0]>=0)break e;Z(i[k+36>>2]);break e}if(i[k+32>>2]=0,i[k+28>>2]=0,W[i[i[f>>2]+104>>2]](k+48|0,i[f+4>>2],k+24|0,k+20|0,0),i[k+80>>2]=i[k+56>>2],n=i[k+52>>2],e=i[k+48>>2],i[k+72>>2]=e,i[k+76>>2]=n,e)break r;for(h=s+116|0;;){if(e=i[k+24>>2],e){n=u[e|0],(n&254)==66&&(Or(k,e,i[k+20>>2],h,k+32|0,k+28|0,0),t[k+19|0]<0&&Z(i[k+8>>2]),i[k+124>>2]=i[k+32>>2],i[k+128>>2]=i[k+28>>2],e=i[k+24>>2],n=u[e|0]),o=i[k+20>>2];n:{if((((n&254)>>>1|0)-32&255)>>>0<=2){L6(l,e,o);break n}C6(k+96|0,e,o)}if(W[i[i[f>>2]+104>>2]](k+48|0,i[f+4>>2],k+24|0,k+20|0,0),i[k+80>>2]=i[k+56>>2],n=i[k+52>>2],e=i[k+48>>2],i[k+72>>2]=e,i[k+76>>2]=n,!e)continue;break r}break}if(!(i[k+28>>2]&&i[k+32>>2])){t[k+36|0]=0,t[k+47|0]=0,e=a(k+48|0,8,129,k+36|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;n:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+44|0]=1;break n}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+44|0]=1,(r|0)>=0)break n;Z(i[e+8>>2])}if(t[k+47|0]>=0)break e;Z(i[k+36>>2]);break e}i[s+4>>2]=i[s+4>>2]+1,e=i[k+100>>2],h=i[k+104>>2];n:{if(e>>>0<h>>>0){i[e+4>>2]=s,i[e>>2]=l,e=e+8|0;break n}if(o=i[k+96>>2],e=e-o|0,_=e>>3,n=_+1|0,n>>>0>=536870912)break A;if(h=h-o|0,w=h>>2,h=h>>>0>=2147483640?536870911:n>>>0<w>>>0?w:n,h){if(h>>>0>=536870912)break f;n=C(h<<3)}else n=0;if(w=n+e|0,i[w+4>>2]=s,i[w>>2]=l,l=w-(_<<3)|0,e&&z(l,o,e),i[k+104>>2]=n+(h<<3),e=w+8|0,i[k+100>>2]=e,i[k+96>>2]=l,!o)break n;Z(o)}i[k+100>>2]=e,n=i[f>>2];n:{if(i[n>>2]<3||(n=i[n+112>>2],!n))break n;e=i[r>>2],r=i[e+188>>2],i[k+48>>2]=r,e=i[e+192>>2],i[k+36>>2]=e,W[n|0](i[f+4>>2],r,e,k+48|0,k+36|0),e=i[k+100>>2]}X[k+120>>1]=257,r=i[k+96>>2],i[k+96>>2]=0,f=i[k+104>>2],n=i[k+108>>2],i[k+100>>2]=0,i[k+104>>2]=0,l=i[k+112>>2],o=i[k+116>>2],i[k+108>>2]=0,i[k+112>>2]=0,i[k+116>>2]=0,i[A+16>>2]=l,i[A+20>>2]=o,i[A+8>>2]=f,i[A+12>>2]=n,i[A+4>>2]=e,i[A>>2]=r,e=i[k+124>>2],i[A+24>>2]=i[k+120>>2],i[A+28>>2]=e,e=i[k+132>>2],i[A+32>>2]=i[k+128>>2],i[A+36>>2]=e,i[A+40>>2]=i[k+136>>2],t[A+44|0]=0;break e}I0(),M()}s0(),M()}x0(),M()}if(f=i[k+76>>2],l=i[k+80>>2],r=l2(l),r>>>0>=2147483640)break i;r:{f:{if(r>>>0>=11){o=r|7,n=C(o+1|0),i[k+44>>2]=o-2147483647,i[k+36>>2]=n,i[k+40>>2]=r;break f}if(t[k+47|0]=r,n=k+36|0,!r)break r}if(!r)break r;z(n,l,r)}t[r+n|0]=0,e=a(k+48|0,e,f,k+36|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+44|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+44|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(t[k+47|0]>=0)break e;Z(i[k+36>>2])}A=i[k+92>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[s+4>>2],i[s+4>>2]=A-1,A||(W[i[i[s>>2]+8>>2]](s),y(s)),A=i[k+108>>2],A&&(i[k+112>>2]=A,Z(A)),A=i[k+96>>2],A){if(e=A,r=i[k+100>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];e:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+96>>2]}i[k+100>>2]=A,Z(e)}v=k+144|0;return}I0(),M()}function Zm(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;n=v-32|0,v=n,f=v-224|0,v=f,r=i[e+180>>2],k=i[r+48>>2],l=i[r+52>>2],l&&(i[l+4>>2]=i[l+4>>2]+1),o=n+8|0,W6(f+200|0,k,i[e+196>>2]);i:{e:switch(u[f+220|0]){default:e2(),M();case 1:if(e=i[f+204>>2],i[o>>2]=i[f+200>>2],i[o+4>>2]=e,r=o+8|0,t[f+219|0]>=0){e=i[f+212>>2],i[r>>2]=i[f+208>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+216>>2];break i}T(r,i[f+208>>2],i[f+212>>2]);break i;case 0:break e}gA(f+176|0,e+552|0,f+200|0);e:{if(i[f+176>>2]){e=i[f+180>>2],i[o>>2]=i[f+176>>2],i[o+4>>2]=e,i[o+16>>2]=i[f+192>>2],e=i[f+188>>2],i[o+8>>2]=i[f+184>>2],i[o+12>>2]=e,i[f+192>>2]=0,i[f+184>>2]=0,i[f+188>>2]=0;break e}r=i[k+80>>2],s=i[k+84>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);r:{if(!r){if(k=C(56),i[f+24>>2]=k,i[f+28>>2]=48,i[f+32>>2]=-2147483592,r=u[16287]|u[16288]<<8|(u[16289]<<16|u[16290]<<24),e=u[16283]|u[16284]<<8|(u[16285]<<16|u[16286]<<24),t[k|0]=e,t[k+1|0]=e>>>8,t[k+2|0]=e>>>16,t[k+3|0]=e>>>24,t[k+4|0]=r,t[k+5|0]=r>>>8,t[k+6|0]=r>>>16,t[k+7|0]=r>>>24,t[k+48|0]=0,r=u[16327]|u[16328]<<8|(u[16329]<<16|u[16330]<<24),e=u[16323]|u[16324]<<8|(u[16325]<<16|u[16326]<<24),t[k+40|0]=e,t[k+41|0]=e>>>8,t[k+42|0]=e>>>16,t[k+43|0]=e>>>24,t[k+44|0]=r,t[k+45|0]=r>>>8,t[k+46|0]=r>>>16,t[k+47|0]=r>>>24,r=u[16319]|u[16320]<<8|(u[16321]<<16|u[16322]<<24),e=u[16315]|u[16316]<<8|(u[16317]<<16|u[16318]<<24),t[k+32|0]=e,t[k+33|0]=e>>>8,t[k+34|0]=e>>>16,t[k+35|0]=e>>>24,t[k+36|0]=r,t[k+37|0]=r>>>8,t[k+38|0]=r>>>16,t[k+39|0]=r>>>24,r=u[16311]|u[16312]<<8|(u[16313]<<16|u[16314]<<24),e=u[16307]|u[16308]<<8|(u[16309]<<16|u[16310]<<24),t[k+24|0]=e,t[k+25|0]=e>>>8,t[k+26|0]=e>>>16,t[k+27|0]=e>>>24,t[k+28|0]=r,t[k+29|0]=r>>>8,t[k+30|0]=r>>>16,t[k+31|0]=r>>>24,r=u[16303]|u[16304]<<8|(u[16305]<<16|u[16306]<<24),e=u[16299]|u[16300]<<8|(u[16301]<<16|u[16302]<<24),t[k+16|0]=e,t[k+17|0]=e>>>8,t[k+18|0]=e>>>16,t[k+19|0]=e>>>24,t[k+20|0]=r,t[k+21|0]=r>>>8,t[k+22|0]=r>>>16,t[k+23|0]=r>>>24,r=u[16295]|u[16296]<<8|(u[16297]<<16|u[16298]<<24),e=u[16291]|u[16292]<<8|(u[16293]<<16|u[16294]<<24),t[k+8|0]=e,t[k+9|0]=e>>>8,t[k+10|0]=e>>>16,t[k+11|0]=e>>>24,t[k+12|0]=r,t[k+13|0]=r>>>8,t[k+14|0]=r>>>16,t[k+15|0]=r>>>24,a(o,2,113,f+24|0),t[f+35|0]>=0)break r;Z(i[f+24>>2]);break r}d4(f+24|0,r,i[e+196>>2],1684630887),r=i[e+564>>2],r&&(i[e+568>>2]=r,Z(r)),k=i[f+24>>2],i[e+564>>2]=k,r=i[f+28>>2],i[e+568>>2]=r,i[e+572>>2]=i[f+32>>2];f:{A:{k:{if((g(p[e+554>>1],p[e+552>>1])|0)!=r-k>>2){i[f+116>>2]=0,i[f+88>>2]=78164,i[f+32>>2]=78144,r=i[19545],i[f+24>>2]=r,h=f+24|0,i[h+i[r-12>>2]>>2]=i[19546],i[f+28>>2]=0,r=h+i[i[f+24>>2]-12>>2]|0,w=f+36|0,J0(r,w),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[f+32>>2]=r,k=f+32|0,i[k+i[r-12>>2]>>2]=i[19548],r=i[19544],i[f+24>>2]=r,i[h+i[r-12>>2]>>2]=i[19549],i[f+88>>2]=78164,i[f+24>>2]=78124,i[f+32>>2]=78144,w=R0(w),i[w>>2]=77200,i[f+76>>2]=0,i[f+80>>2]=0,i[f+68>>2]=0,i[f+72>>2]=0,i[f+84>>2]=24,F(B0(F(D0(F(B0(F(B0(F(k,31879,17),p[e+552>>1]),3179,1),p[e+554>>1]),22870,1),g(p[e+554>>1],p[e+552>>1])),30860,17),i[e+568>>2]-i[e+564>>2]>>2),14418,20),e=i[f+84>>2];n:{if(e&16){e=i[f+80>>2],r=i[f+60>>2],e>>>0<r>>>0&&(i[f+80>>2]=r,e=r),r=f+56|0;break n}if(!(e&8)){e=0,t[f+23|0]=0,h=f+12|0;break f}e=i[f+52>>2],r=f+44|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break k;if(e>>>0>=11){r=e|7,h=C(r+1|0),i[f+20>>2]=r-2147483647,i[f+12>>2]=h,i[f+16>>2]=e;break A}if(t[f+23|0]=e,h=f+12|0,e)break A;e=0;break f}if(e=i[28729],i[o>>2]=i[28728],i[o+4>>2]=e,r=o+8|0,t[114931]>=0){e=i[28731],i[r>>2]=i[28730],i[r+4>>2]=e,i[r+8>>2]=i[28732];break r}T(r,i[28730],i[28731]);break r}I0(),M()}if(!e)break f;z(h,k,e)}t[e+h|0]=0,a(o,2,119,f+12|0),t[f+23|0]<0&&Z(i[f+12>>2]),e=i[19543],i[f+24>>2]=e,i[i[e-12>>2]+(f+24|0)>>2]=i[19551],i[f+32>>2]=i[19552],i[w>>2]=77200,t[f+79|0]<0&&Z(i[f+68>>2]),y0(w),Y0(f+88|0)}if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break e;W[i[i[s>>2]+8>>2]](s),y(s)}if(t[f+195|0]>=0)break i;Z(i[f+184>>2])}r=u[f+220|0],(r|0)!=255&&(e=i[27059],i[f+24>>2]=i[27058],i[f+28>>2]=e,W[i[(f+24|0)+(r<<2)>>2]](f+176|0,f+200|0));i:{if(!l||(e=i[l+4>>2],i[l+4>>2]=e-1,e))break i;W[i[i[l>>2]+8>>2]](l),y(l)}v=f+224|0,r=A+8|0;i:{if(i[n+8>>2]){e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,i[r+8>>2]=i[n+24>>2],A=i[n+20>>2],i[r>>2]=i[n+16>>2],i[r+4>>2]=A,i[n+24>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0;break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,t[114931]>=0){A=i[28731],i[r>>2]=i[28730],i[r+4>>2]=A,i[r+8>>2]=i[28732];break i}T(r,i[28730],i[28731])}t[n+27|0]<0&&Z(i[n+16>>2]),v=n+32|0}function gm(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0;e=v-160|0,v=e,i[e+120>>2]=0,i[e+124>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,t[e+135|0]=0,t[e+136|0]=0,t[e+137|0]=0,t[e+138|0]=0,i[e+112>>2]=0,i[e+116>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+152>>2]=0,t[e+148|0]=1,t[e+108|0]=0,t[e+109|0]=0,t[e+110|0]=0,t[e+111|0]=0,t[e+101|0]=0,t[e+102|0]=0,t[e+103|0]=0,t[e+104|0]=0,t[e+105|0]=0,t[e+106|0]=0,t[e+107|0]=0,t[e+108|0]=0,t[e+100|0]=1,Io(e+80|0,e+100|0,r),t[e+99|0]<0&&Z(i[e+88>>2]),i[e+76>>2]=0,o=i[r>>2],k=i[r+4>>2];i:{if(!k){i[e+76>>2]=0,i[e+72>>2]=o;break i}if(i[k+4>>2]=i[k+4>>2]+1,i[e+72>>2]=o,r=i[e+76>>2],i[e+76>>2]=k,!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}W[i[i[f>>2]+100>>2]](e+56|0,i[f+4>>2],e+72|0,n);i:{e:{r:{f:{A:{k:{n:{if(k=i[e+56>>2],!k){if(W[i[i[f>>2]+104>>2]](e+32|0,i[f+4>>2],e+16|0,e+12|0,0),k=e- -64|0,i[k>>2]=i[e+40>>2],n=i[e+36>>2],r=i[e+32>>2],i[e+56>>2]=r,i[e+60>>2]=n,!r)break n;break r}if(n=i[e+60>>2],o=i[e+64>>2],f=l2(o),f>>>0>=2147483640)break k;t:{o:{if(f>>>0>=11){l=f|7,r=C(l+1|0),i[e+28>>2]=l-2147483647,i[e+20>>2]=r,i[e+24>>2]=f;break o}if(t[e+31|0]=f,r=e+20|0,!f)break t}if(!f)break t;z(r,o,f)}t[r+f|0]=0,r=a(e+32|0,k,n,e+20|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;t:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[A+44|0]=1;break t}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+44|0]=1,(f|0)>=0)break t;Z(i[r+8>>2])}if(t[e+31|0]>=0)break e;Z(i[e+20>>2]);break e}for(;;){n:{if(Qn(e+100|0,i[e+16>>2],i[e+12>>2]),r=i[e+16>>2],!r)break n;if(Gr(e+112|0,r,i[e+12>>2]),W[i[i[f>>2]+104>>2]](e+32|0,i[f+4>>2],e+16|0,e+12|0,0),i[k>>2]=i[e+40>>2],n=i[e+36>>2],r=i[e+32>>2],i[e+56>>2]=r,i[e+60>>2]=n,!r)continue;break r}break}f=C(144),i[f>>2]=96748,i[f+4>>2]=0,i[f+8>>2]=0,o=f+16|0,r=o,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,i[r>>2]=104700,i[f+136>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+32>>2]=1635135811,r=u[e+104|0]|u[e+105|0]<<8|(u[e+106|0]<<16|u[e+107|0]<<24),k=u[e+100|0]|u[e+101|0]<<8|(u[e+102|0]<<16|u[e+103|0]<<24),t[f+113|0]=k,t[f+114|0]=k>>>8,t[f+115|0]=k>>>16,t[f+116|0]=k>>>24,t[f+117|0]=r,t[f+118|0]=r>>>8,t[f+119|0]=r>>>16,t[f+120|0]=r>>>24,r=u[e+108|0]|u[e+109|0]<<8|(u[e+110|0]<<16|u[e+111|0]<<24),t[f+121|0]=r,t[f+122|0]=r>>>8,t[f+123|0]=r>>>16,t[f+124|0]=r>>>24,i[f+4>>2]=i[f+4>>2]+1,r=i[e+120>>2],k=i[e+116>>2];n:{if(r>>>0>k>>>0){i[k+4>>2]=f,i[k>>2]=o,k=k+8|0;break n}if(n=i[e+112>>2],k=k-n|0,h=k>>3,l=h+1|0,l>>>0>=536870912)break A;if(r=r-n|0,s=r>>2,l=r>>>0>=2147483640?536870911:l>>>0<s>>>0?s:l,l){if(l>>>0>=536870912)break f;r=C(l<<3)}else r=0;if(s=r+k|0,i[s+4>>2]=f,i[s>>2]=o,o=s-(h<<3)|0,k&&z(o,n,k),r=r+(l<<3)|0,i[e+120>>2]=r,k=s+8|0,i[e+116>>2]=k,i[e+112>>2]=o,!n)break n;Z(n),r=i[e+120>>2]}if(X[e+136>>1]=257,n=i[e+112>>2],i[e+112>>2]=0,i[e+116>>2]=0,i[e+120>>2]=0,o=i[e+132>>2],i[e+132>>2]=0,l=i[e+124>>2],s=i[e+128>>2],i[e+124>>2]=0,i[e+128>>2]=0,i[A+20>>2]=o,i[A+12>>2]=l,i[A+16>>2]=s,i[A+8>>2]=r,i[A+4>>2]=k,i[A>>2]=n,r=i[e+140>>2],i[A+24>>2]=i[e+136>>2],i[A+28>>2]=r,r=i[e+148>>2],i[A+32>>2]=i[e+144>>2],i[A+36>>2]=r,i[A+40>>2]=i[e+152>>2],t[A+44|0]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break e;W[i[i[f>>2]+8>>2]](f),y(f);break e}I0(),M()}s0(),M()}x0(),M()}if(n=i[e+60>>2],o=i[e+64>>2],f=l2(o),f>>>0>=2147483640)break i;r:{f:{if(f>>>0>=11){l=f|7,k=C(l+1|0),i[e+28>>2]=l-2147483647,i[e+20>>2]=k,i[e+24>>2]=f;break f}if(t[e+31|0]=f,k=e+20|0,!f)break r}if(!f)break r;z(k,o,f)}t[f+k|0]=0,r=a(e+32|0,r,n,e+20|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;r:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[A+44|0]=1;break r}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+44|0]=1,(f|0)>=0)break r;Z(i[r+8>>2])}if(t[e+31|0]>=0)break e;Z(i[e+20>>2])}A=i[e+76>>2];e:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[e+124>>2],A&&(i[e+128>>2]=A,Z(A)),A=i[e+112>>2],A){if(r=A,f=i[e+116>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(A|0)==(f|0))break}r=i[e+112>>2]}i[e+116>>2]=A,Z(r)}v=e+160|0;return}I0(),M()}function Gm(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0;l=v-272|0,v=l,k=o+4|0,s=i[e+196>>2],n=i[o+4>>2];i:{e:{r:{if(!n){f=k;break r}for(h=k,f=n;w=s>>>0>o0[f+16>>2],h=w?h:f,f=i[(w?4:0)+f>>2],!!f;);if(!((k|0)==(h|0)|s>>>0<o0[h+16>>2])){e=C(32),i[l+208>>2]=e,i[l+212>>2]=28,i[l+216>>2]=-2147483616,r=u[6467]|u[6468]<<8|(u[6469]<<16|u[6470]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,r=u[6463]|u[6464]<<8|(u[6465]<<16|u[6466]<<24),f=u[6459]|u[6460]<<8|(u[6461]<<16|u[6462]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[6455]|u[6456]<<8|(u[6457]<<16|u[6458]<<24),f=u[6451]|u[6452]<<8|(u[6453]<<16|u[6454]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[6447]|u[6448]<<8|(u[6449]<<16|u[6450]<<24),f=u[6443]|u[6444]<<8|(u[6445]<<16|u[6446]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+28|0]=0,e=a(l+16|0,2,0,l+208|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(t[l+219|0]>=0)break i;Z(i[l+208>>2]);break i}for(;;){if(f=n,k=i[f+16>>2],k>>>0>s>>>0){if(k=f,n=i[f>>2],n)continue;break r}if(k>>>0>=s>>>0)break e;if(n=i[f+4>>2],!n)break}k=f+4|0}n=C(20),i[n+8>>2]=f,f=n,i[f>>2]=0,i[f+4>>2]=0,i[f+16>>2]=s,i[k>>2]=f,f=i[i[o>>2]>>2],f&&(i[o>>2]=f),G1(i[o+4>>2],n),i[o+8>>2]=i[o+8>>2]+1}t[l+216|0]=0,i[l+228>>2]=0,i[l+232>>2]=0,i[l+236>>2]=0,i[l+240>>2]=0,i[l+256>>2]=0,i[l+248>>2]=0,i[l+252>>2]=0,i[l+208>>2]=0,i[l+212>>2]=0,i[l+220>>2]=0,i[l+224>>2]=0,f=i[e+180>>2],i[l+200>>2]=i[f+48>>2],f=i[f+52>>2],i[l+204>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[e+196>>2],k=i[l+204>>2],i[l+8>>2]=i[l+200>>2],i[l+12>>2]=k,eu(l+208|0,l+8|0,f),W[i[i[e>>2]+156>>2]](l+176|0,e);e:{r:switch(u[l+196|0]){default:e2(),M();case 1:e=i[l+180>>2],i[A>>2]=i[l+176>>2],i[A+4>>2]=e,e=A+8|0;f:{if(t[l+195|0]>=0){r=i[l+188>>2],i[e>>2]=i[l+184>>2],i[e+4>>2]=r,i[e+8>>2]=i[l+192>>2];break f}T(e,i[l+184>>2],i[l+188>>2])}t[A+20|0]=1;break e;case 0:break r}o=i[l+176>>2],h=i[l+180>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),i[l+168>>2]=i[l+256>>2],f=i[l+252>>2],i[l+160>>2]=i[l+248>>2],i[l+164>>2]=f,k=i[l+208>>2],n=i[l+212>>2],i[l+208>>2]=0,i[l+212>>2]=0,t[l+128|0]=u[l+216|0],f=i[l+220>>2],i[l+220>>2]=0,i[l+132>>2]=f,f=i[l+224>>2],s=i[l+228>>2],i[l+224>>2]=0,i[l+228>>2]=0,i[l+136>>2]=f,i[l+140>>2]=s,f=i[l+232>>2],s=i[l+236>>2],i[l+232>>2]=0,i[l+236>>2]=0,i[l+144>>2]=f,i[l+148>>2]=s,f=i[l+244>>2],i[l+152>>2]=i[l+240>>2],i[l+156>>2]=f,i[l+120>>2]=0,i[l+124>>2]=0,f=i[o+12>>2],i[o+8>>2]=k,i[o+12>>2]=n;r:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break r;W[i[i[f>>2]+8>>2]](f),y(f)}t[o+16|0]=u[l+128|0],f=i[o+20>>2],f&&(i[o+24>>2]=f,Z(f)),i[o+20>>2]=i[l+132>>2],i[o+24>>2]=i[l+136>>2],i[o+28>>2]=i[l+140>>2],i[l+140>>2]=0,i[l+132>>2]=0,i[l+136>>2]=0,(o|0)!=(l+112|0)&&(k1(o+32|0),i[o+32>>2]=i[l+144>>2],i[o+36>>2]=i[l+148>>2],i[l+144>>2]=0,i[l+148>>2]=0),f=i[l+156>>2],i[o+40>>2]=i[l+152>>2],i[o+44>>2]=f,i[o+56>>2]=i[l+168>>2],f=i[l+164>>2],i[o+48>>2]=i[l+160>>2],i[o+52>>2]=f,k1(l+144|0),f=i[l+132>>2],f&&(i[l+136>>2]=f,Z(f)),f=i[l+124>>2];r:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break r;W[i[i[f>>2]+8>>2]](f),y(f)}s=l+16|0,k=i[e+180>>2]- -64|0,w=i[e+200>>2],_=i[e+204>>2],e=(W[i[i[e>>2]+92>>2]](e)|0)-1|0,e>>>0<=9?f=i[(e<<2)+56232>>2]:f=0,n=v-16|0,v=n,z(s,k,104);r:{if(u[k|0]>=4&&(e=i[k+96>>2],e))break r;e=k}t[s|0]=4,i[s+96>>2]=e;r:{if(!w|!_||(k=0,e=f+w|0,k=e>>>0<w>>>0?1:k,w=0,B=_,_=f+_|0,w=B>>>0>_>>>0?1:w,e4(n,e,k,0,0,_,w,0,0),i[n+8>>2]|i[n+12>>2]))break r;f=i[s+8>>2],B=i[s+12>>2],k=L0(_,w,e,k),e=f,f=e-1|0,_=e,w=B-!e|0,e=h0,f=(w|0)==(e|0)&f>>>0<k>>>0|e>>>0>w>>>0,i[s+8>>2]=f?_:k,i[s+12>>2]=f?B:e}if(v=n+16|0,W[i[i[o>>2]+32>>2]](A,o,r,s),!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break e;W[i[i[h>>2]+8>>2]](h),y(h)}if(A=u[l+196|0],(A|0)!=255&&(e=i[26905],i[l+16>>2]=i[26904],i[l+20>>2]=e,W[i[(l+16|0)+(A<<2)>>2]](l+271|0,l+176|0)),k1(l+232|0),A=i[l+220>>2],A&&(i[l+224>>2]=A,Z(A)),A=i[l+212>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=l+272|0}function Wm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0;e=v-112|0,v=e,h=i[r>>2],i[e+92>>2]=h,s=i[r+4>>2],i[e+96>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),s=i[o+20>>2],i[e+80>>2]=i[o+16>>2],i[e+84>>2]=s,s=i[o+12>>2],i[e+72>>2]=i[o+8>>2],i[e+76>>2]=s,s=i[o+4>>2],i[e+64>>2]=i[o>>2],i[e+68>>2]=s,i[e+68>>2]=0;i:{e:{r:{if(i[o+4>>2]){cA(e+40|0,e+92|0,1,f+20|0,i[f+12>>2],n,e- -64|0,l),m=u[e+60|0];f:{if(m){if((m|0)!=1)break r;s=i[e+44>>2],i[A>>2]=i[e+40>>2],i[A+4>>2]=s,s=A+8|0;A:{if(t[e+59|0]>=0){w=i[e+52>>2],i[s>>2]=i[e+48>>2],i[s+4>>2]=w,i[s+8>>2]=i[e+56>>2];break A}T(s,i[e+48>>2],i[e+52>>2])}t[A+20|0]=1;break f}if(s=i[e+40>>2],w=i[e+44>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),i[e+92>>2]=s,s=i[e+96>>2],i[e+96>>2]=w,!s||(w=i[s+4>>2],i[s+4>>2]=w-1,w))break f;W[i[i[s>>2]+8>>2]](s),y(s)}if(s=u[e+60|0],(s|0)!=255&&(w=i[27835],i[e+104>>2]=i[27834],i[e+108>>2]=w,W[i[(e+104|0)+(s<<2)>>2]](e+32|0,e+40|0)),m)break i;h=i[e+92>>2]}for(R=i[h+192>>2],Q=i[h+188>>2],s=C(248),i[s>>2]=101168,i[s+4>>2]=0,i[s+8>>2]=0,l0(s+16|0,0,156),i[s+76>>2]=0,i[s+80>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,t[s+24|0]=1,X[s+22>>1]=2,X[s+18>>1]=2,X[s+20>>1]=2,i[s+84>>2]=0,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+128>>2]=0,i[s+132>>2]=0,i[s+100>>2]=0,i[s+104>>2]=1,i[s+136>>2]=0,i[s+140>>2]=0,i[s+144>>2]=0,i[s+148>>2]=0,i[s+152>>2]=0,i[s+156>>2]=0,X[s+158>>1]=0,X[s+160>>1]=0,X[s+162>>1]=0,X[s+164>>1]=0,i[s+184>>2]=0,i[s+188>>2]=0,i[s+172>>2]=255,i[s+192>>2]=0,i[s+196>>2]=5186,i[s+208>>2]=99,i[s+212>>2]=99,i[s+200>>2]=0,i[s+204>>2]=0,i[s+12>>2]=101488,i[s+216>>2]=0,i[s+220>>2]=0,i[s+224>>2]=0,i[s+228>>2]=0,i[s+232>>2]=0,i[s+236>>2]=0,i[s+240>>2]=0,i[s+244>>2]=0,i[e+36>>2]=s,w=s+12|0,i[e+32>>2]=w,i[s+176>>2]=w,i[s+8>>2]=i[s+8>>2]+1,i[s+180>>2]=s,i[s+4>>2]==-1&&(W[i[i[s>>2]+8>>2]](s),y(s)),j=i[e+32>>2],s=i[e+92>>2],t1(j,Q,R,i[s+196>>2],i[s+200>>2]),i[e+48>>2]=5,i[e+40>>2]=3,i[e+44>>2]=4,A0=Q&-2,t0=Q&1;;){B=i[(e+40|0)+O>>2],a0(e+12|0,j,B,Q,R,i[k+12>>2],l,0),t[e+31|0]<0&&Z(i[e+20>>2]),S=0,s=Q0(i[e+92>>2],6);f:{if(!s){q=0,s=0;break f}q=i[s+40>>2],s=i[s+52>>2]>>>1|0}N=K0(i[e+92>>2],6),w=Q0(i[e+92>>2],B),w?(S=i[w+52>>2]>>>1|0,w=i[w+40>>2]):w=0,h=-1<<N,m=Q0(j,B);f:{if(!m){d=0,m=0;break f}d=i[m+40>>2],m=i[m+52>>2]>>>1|0}I=h^-1;f:{A:{k:switch(i[o+4>>2]-1|0){case 1:if(p[o+20>>1])break A;break;case 0:break k;default:break A}_=0;k:{n:switch(B-3|0){case 0:_=p[o+8>>1];break k;case 1:_=p[o+10>>1];break k;case 2:break n;default:break k}_=p[o+12>>1]}if(h=K0(i[e+92>>2],B),!R|!Q)break f;for(B=_>>>16-h|0,I=I&65535,_=0;;){if(Y=(g(_,m)<<1)+d|0,U=(g(_,S)<<1)+w|0,V=(g(s,_)<<1)+q|0,h=0,x=0,(Q|0)!=1)for(;G=h<<1,E=p[G+V>>1],X[G+Y>>1]=g(E,p[G+U>>1])+g(B,I-E|0)>>N,G=G|2,E=p[G+V>>1],X[G+Y>>1]=g(E,p[G+U>>1])+g(B,I-E|0)>>N,h=h+2|0,x=x+2|0,(A0|0)!=(x|0););if(t0&&(h=h<<1,V=p[h+V>>1],X[h+Y>>1]=g(V,p[h+U>>1])+g(B,I-V|0)>>N),_=_+1|0,(R|0)==(_|0))break}break f}_=0,h=0;A:{k:switch(B-3|0){case 0:h=p[o+14>>1],_=p[o+8>>1];break A;case 1:h=p[o+16>>1],_=p[o+10>>1];break A;case 2:break k;default:break A}h=p[o+18>>1],_=p[o+12>>1]}if(Y=K0(i[e+92>>2],B),B=K0(i[e+92>>2],B),!R|!Q)break f;for(Y=_>>>16-Y|0,U=(h&65535)>>>16-B|0,V=I&65535,h=0;;){for(G=(g(h,m)<<1)+d|0,x=(g(h,S)<<1)+w|0,E=(g(s,h)<<1)+q|0,_=0;B=_<<1,I=p[B+E>>1],c=p[o+20>>1],X[B+G>>1]=g(V-I|0,((h>>>0)/(c>>>0)|0)+((_>>>0)/(c>>>0)|0)&1?Y:U)+g(I,p[B+x>>1])>>N,_=_+1|0,(Q|0)!=(_|0););if(h=h+1|0,(R|0)==(h|0))break}}if(O=O+4|0,(O|0)==12)break}if(!i[o+4>>2])break e;r=i[r>>2],G6(e+40|0,e+32|0,i[r+196>>2],i[r+200>>2],f+20|0,i[f+12>>2],n,e- -64|0,l);f:{A:switch(u[e+60|0]){case 1:r=i[e+44>>2],i[A>>2]=i[e+40>>2],i[A+4>>2]=r,r=A+8|0;k:{if(t[e+59|0]>=0){f=i[e+52>>2],i[r>>2]=i[e+48>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+56>>2];break k}T(r,i[e+48>>2],i[e+52>>2])}t[A+20|0]=1;break f;case 0:break A;default:break r}t[A+20|0]=255,t[A|0]=0,i[e+104>>2]=A,W[i[27838]](e+104|0,e+40|0),t[A+20|0]=0}if(A=u[e+60|0],(A|0)!=255&&(r=i[27837],i[e+104>>2]=i[27836],i[e+108>>2]=r,W[i[(e+104|0)+(A<<2)>>2]](e+103|0,e+40|0)),A=i[e+36>>2],!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}e2(),M()}r=i[e+36>>2],t[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=j}A=i[e+96>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=e+112|0}function Xm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0;e=v-128|0,v=e,f=i[r>>2],Y=i[f+192>>2],n=i[f+188>>2],f=C(248),i[f>>2]=101168,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,o=f+12|0,i[f+176>>2]=o,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),t1(o,n,Y,0,3),h=u[k+8|0],m=i[i[r>>2]+200>>2],a0(e+56|0,o,0,n,Y,8,l,0),a0(e+32|0,o,1,n,Y,8,l,0),k=e+88|0;i:{if(i[e+56>>2]){if(s=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=s,t[e+75|0]>=0){s=e- -64|0,Q=i[s+4>>2],i[k>>2]=i[s>>2],i[k+4>>2]=Q,i[k+8>>2]=i[s+8>>2];break i}T(k,i[e+64>>2],i[e+68>>2]);break i}if(s=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=s,t[e+51|0]>=0){s=i[e+44>>2],i[k>>2]=i[e+40>>2],i[k+4>>2]=s,i[k+8>>2]=i[e+48>>2];break i}T(k,i[e+40>>2],i[e+44>>2])}a0(e+8|0,o,2,n,Y,8,l,0),s=e+112|0;i:{if(i[e+80>>2]){if(Q=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=Q,t[e+99|0]>=0){Q=i[k+4>>2],i[s>>2]=i[k>>2],i[s+4>>2]=Q,i[s+8>>2]=i[k+8>>2];break i}T(s,i[e+88>>2],i[e+92>>2]);break i}if(k=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=k,t[e+27|0]>=0){k=i[e+20>>2],i[s>>2]=i[e+16>>2],i[s+4>>2]=k,i[s+8>>2]=i[e+24>>2];break i}T(s,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);i:{e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[s+4>>2],i[r>>2]=i[s>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!(h&1))break r;if(a0(e+104|0,o,6,n,Y,8,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}r=Q0(i[r>>2],10),r?(O=i[r+52>>2],k=i[r+40>>2]):k=0,r=Q0(o,0),r?(S=i[r+52>>2],s=i[r+40>>2]):s=0,r=Q0(o,1),r?(q=i[r+40>>2],Q=i[r+52>>2]):Q=0,r=Q0(o,2),r?(d=i[r+52>>2],x=i[r+40>>2]):x=0,V=0;r:{if(!(h&1)||(l=Q0(o,6),V=0,!l))break r;j=i[l+40>>2],V=i[l+52>>2]}r:{if(!Y|!n)break r;if(R=(m|0)==11?4:3,!(h&1)){for(j=n&-2,E=n&1,r=0;;){if(V=g(r,d)+x|0,h=g(r,Q)+q|0,m=g(r,S)+s|0,_=k+g(r,O)|0,l=0,G=0,(n|0)!=1)for(;w=_+g(l,R)|0,B=u[w|0],I=u[w+2|0],t[l+m|0]=u[w+1|0],t[l+h|0]=I,t[l+V|0]=B,w=l|1,B=_+g(w,R)|0,I=u[B|0],N=u[B+2|0],t[w+m|0]=u[B+1|0],t[h+w|0]=N,t[w+V|0]=I,l=l+2|0,G=G+2|0,(j|0)!=(G|0););if(E&&(_=_+g(l,R)|0,w=u[_|0],G=u[_+2|0],t[l+m|0]=u[_+1|0],t[l+h|0]=G,t[l+V|0]=w),r=r+1|0,(Y|0)==(r|0))break}break r}if((m|0)==11){for(m=k+3|0,r=0;;){for(_=g(r,V)+j|0,l=g(r,O),w=l+m|0,G=g(r,d)+x|0,B=g(r,Q)+q|0,E=g(r,S)+s|0,I=k+l|0,l=0;N=g(l,R),h=N+I|0,c=u[h|0],U=u[h+2|0],t[l+E|0]=u[h+1|0],t[l+B|0]=U,t[l+G|0]=c,t[l+_|0]=u[w+N|0],l=l+1|0,(l|0)!=(n|0););if(r=r+1|0,(Y|0)==(r|0))break}break r}for(N=n&-2,c=n&1,r=0;;){if(m=g(r,V)+j|0,_=g(r,d)+x|0,w=g(r,Q)+q|0,G=g(r,S)+s|0,B=k+g(r,O)|0,l=0,E=0,(n|0)!=1)for(;h=B+g(l,R)|0,I=u[h|0],U=u[h+2|0],t[l+G|0]=u[h+1|0],t[l+w|0]=U,t[l+_|0]=I,t[l+m|0]=255,h=l|1,I=B+g(h,R)|0,U=u[I|0],A0=u[I+2|0],t[h+G|0]=u[I+1|0],t[h+w|0]=A0,t[h+_|0]=U,t[h+m|0]=255,l=l+2|0,E=E+2|0,(N|0)!=(E|0););if(c&&(h=B+g(l,R)|0,B=u[h|0],E=u[h+2|0],t[l+G|0]=u[h+1|0],t[l+w|0]=E,t[l+_|0]=B,t[l+m|0]=255),r=r+1|0,(Y|0)==(r|0))break}}t[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=o;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=e+128|0}function Im(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0;e=v-112|0,v=e,w=i[r>>2],i[e+92>>2]=w,s=i[r+4>>2],i[e+96>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),s=i[o+20>>2],i[e+80>>2]=i[o+16>>2],i[e+84>>2]=s,s=i[o+12>>2],i[e+72>>2]=i[o+8>>2],i[e+76>>2]=s,s=i[o+4>>2],i[e+64>>2]=i[o>>2],i[e+68>>2]=s,i[e+68>>2]=0;i:{e:{r:{if(i[o+4>>2]){cA(e+40|0,e+92|0,1,f+20|0,i[f+12>>2],n,e- -64|0,l),B=u[e+60|0];f:{if(B){if((B|0)!=1)break r;s=i[e+44>>2],i[A>>2]=i[e+40>>2],i[A+4>>2]=s,s=A+8|0;A:{if(t[e+59|0]>=0){_=i[e+52>>2],i[s>>2]=i[e+48>>2],i[s+4>>2]=_,i[s+8>>2]=i[e+56>>2];break A}T(s,i[e+48>>2],i[e+52>>2])}t[A+20|0]=1;break f}if(s=i[e+40>>2],_=i[e+44>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),i[e+92>>2]=s,s=i[e+96>>2],i[e+96>>2]=_,!s||(_=i[s+4>>2],i[s+4>>2]=_-1,_))break f;W[i[i[s>>2]+8>>2]](s),y(s)}if(s=u[e+60|0],(s|0)!=255&&(_=i[27835],i[e+104>>2]=i[27834],i[e+108>>2]=_,W[i[(e+104|0)+(s<<2)>>2]](e+32|0,e+40|0)),B)break i;w=i[e+92>>2]}for(Y=i[w+192>>2],Q=i[w+188>>2],s=C(248),i[s>>2]=101168,i[s+4>>2]=0,i[s+8>>2]=0,l0(s+16|0,0,156),i[s+76>>2]=0,i[s+80>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,t[s+24|0]=1,X[s+22>>1]=2,X[s+18>>1]=2,X[s+20>>1]=2,i[s+84>>2]=0,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+128>>2]=0,i[s+132>>2]=0,i[s+100>>2]=0,i[s+104>>2]=1,i[s+136>>2]=0,i[s+140>>2]=0,i[s+144>>2]=0,i[s+148>>2]=0,i[s+152>>2]=0,i[s+156>>2]=0,X[s+158>>1]=0,X[s+160>>1]=0,X[s+162>>1]=0,X[s+164>>1]=0,i[s+184>>2]=0,i[s+188>>2]=0,i[s+172>>2]=255,i[s+192>>2]=0,i[s+196>>2]=5186,i[s+208>>2]=99,i[s+212>>2]=99,i[s+200>>2]=0,i[s+204>>2]=0,i[s+12>>2]=101488,i[s+216>>2]=0,i[s+220>>2]=0,i[s+224>>2]=0,i[s+228>>2]=0,i[s+232>>2]=0,i[s+236>>2]=0,i[s+240>>2]=0,i[s+244>>2]=0,i[e+36>>2]=s,_=s+12|0,i[e+32>>2]=_,i[s+176>>2]=_,i[s+8>>2]=i[s+8>>2]+1,i[s+180>>2]=s,i[s+4>>2]==-1&&(W[i[i[s>>2]+8>>2]](s),y(s)),j=i[e+32>>2],s=i[e+92>>2],t1(j,Q,Y,i[s+196>>2],i[s+200>>2]),i[e+48>>2]=5,i[e+40>>2]=3,i[e+44>>2]=4,c=Q&-2,A0=Q&1;;){h=i[(e+40|0)+O>>2],a0(e+12|0,j,h,Q,Y,i[k+12>>2],l,0),t[e+31|0]<0&&Z(i[e+20>>2]),S=0,s=Q0(i[e+92>>2],6);f:{if(!s){q=0,s=0;break f}q=i[s+40>>2],s=i[s+52>>2]}E=K0(i[e+92>>2],6),_=Q0(i[e+92>>2],h),_?(S=i[_+52>>2],_=i[_+40>>2]):_=0,w=-1<<E,B=Q0(j,h);f:{if(!B){d=0,B=0;break f}d=i[B+40>>2],B=i[B+52>>2]}V=w^-1;f:{A:{k:switch(i[o+4>>2]-1|0){case 1:if(p[o+20>>1])break A;break;case 0:break k;default:break A}w=0;k:{n:switch(h-3|0){case 0:w=p[o+8>>1];break k;case 1:w=p[o+10>>1];break k;case 2:break n;default:break k}w=p[o+12>>1]}if(h=K0(i[e+92>>2],h),!Y|!Q)break f;for(G=(w&65535)>>>16-h&255,V=V&255,w=0;;){if(I=g(w,B)+d|0,R=g(w,S)+_|0,N=g(s,w)+q|0,h=0,U=0,(Q|0)!=1)for(;m=u[h+N|0],t[h+I|0]=g(m,u[h+R|0])+g(G,V-m|0)>>E,m=h|1,x=u[m+N|0],t[I+m|0]=g(x,u[m+R|0])+g(G,V-x|0)>>E,h=h+2|0,U=U+2|0,(c|0)!=(U|0););if(A0&&(m=h+I|0,I=u[h+R|0],h=u[h+N|0],t[m|0]=g(I,h)+g(G,V-h|0)>>E),w=w+1|0,(Y|0)==(w|0))break}break f}w=0,G=0;A:{k:switch(h-3|0){case 0:G=p[o+14>>1],w=p[o+8>>1];break A;case 1:G=p[o+16>>1],w=p[o+10>>1];break A;case 2:break k;default:break A}G=p[o+18>>1],w=p[o+12>>1]}if(I=K0(i[e+92>>2],h),h=K0(i[e+92>>2],h),!Y|!Q)break f;for(I=(w&65535)>>>16-I|0,G=G>>>16-h|0,V=V&255,w=0;;){for(R=g(w,B)+d|0,N=g(w,S)+_|0,U=g(s,w)+q|0,h=0;m=u[h+U|0],x=p[o+20>>1],t[h+R|0]=g(V-m|0,(((w>>>0)/(x>>>0)|0)+((h>>>0)/(x>>>0)|0)&1?I:G)&255)+g(m,u[h+N|0])>>E,h=h+1|0,(Q|0)!=(h|0););if(w=w+1|0,(Y|0)==(w|0))break}}if(O=O+4|0,(O|0)==12)break}if(!i[o+4>>2])break e;r=i[r>>2],G6(e+40|0,e+32|0,i[r+196>>2],i[r+200>>2],f+20|0,i[f+12>>2],n,e- -64|0,l);f:{A:switch(u[e+60|0]){case 1:r=i[e+44>>2],i[A>>2]=i[e+40>>2],i[A+4>>2]=r,r=A+8|0;k:{if(t[e+59|0]>=0){f=i[e+52>>2],i[r>>2]=i[e+48>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+56>>2];break k}T(r,i[e+48>>2],i[e+52>>2])}t[A+20|0]=1;break f;case 0:break A;default:break r}t[A+20|0]=255,t[A|0]=0,i[e+104>>2]=A,W[i[27838]](e+104|0,e+40|0),t[A+20|0]=0}if(A=u[e+60|0],(A|0)!=255&&(r=i[27837],i[e+104>>2]=i[27836],i[e+108>>2]=r,W[i[(e+104|0)+(A<<2)>>2]](e+103|0,e+40|0)),A=i[e+36>>2],!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}e2(),M()}r=i[e+36>>2],t[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=j}A=i[e+96>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=e+112|0}function Qm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0;e=v-128|0,v=e,w=u[k+8|0],B=i[i[r>>2]+200>>2],f=C(248),i[f>>2]=101168,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,m=f+12|0,i[f+176>>2]=m,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),k=i[r>>2],n=i[k+192>>2],o=i[k+188>>2],s=K0(k,10),t1(m,o,n,1,3),a0(e+56|0,m,3,o,n,s,l,0),a0(e+32|0,m,4,o,n,s,l,0),k=e+88|0;i:{if(i[e+56>>2]){if(h=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=h,t[e+75|0]>=0){h=e- -64|0,G=i[h+4>>2],i[k>>2]=i[h>>2],i[k+4>>2]=G,i[k+8>>2]=i[h+8>>2];break i}T(k,i[e+64>>2],i[e+68>>2]);break i}if(h=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=h,t[e+51|0]>=0){h=i[e+44>>2],i[k>>2]=i[e+40>>2],i[k+4>>2]=h,i[k+8>>2]=i[e+48>>2];break i}T(k,i[e+40>>2],i[e+44>>2])}a0(e+8|0,m,5,o,n,s,l,0),h=e+112|0;i:{if(i[e+80>>2]){if(G=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=G,t[e+99|0]>=0){G=i[k+4>>2],i[h>>2]=i[k>>2],i[h+4>>2]=G,i[h+8>>2]=i[k+8>>2];break i}T(h,i[e+88>>2],i[e+92>>2]);break i}if(k=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=k,t[e+27|0]>=0){k=i[e+20>>2],i[h>>2]=i[e+16>>2],i[h+4>>2]=k,i[h+8>>2]=i[e+24>>2];break i}T(h,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);i:{e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[h+4>>2],i[r>>2]=i[h>>2],i[r+4>>2]=k,i[r+8>>2]=i[h+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!(w&1))break r;if(a0(e+104|0,m,6,o,n,s,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}r=Q0(i[r>>2],10),r?(R=i[r+40>>2],k=i[r+52>>2]):k=0,r=Q0(m,3),r?(N=i[r+52>>2]>>>1|0,h=i[r+40>>2]):h=0,r=Q0(m,4),r?(U=i[r+40>>2],G=i[r+52>>2]>>>1|0):G=0,r=Q0(m,5),r?(x=i[r+52>>2]>>>1|0,Y=i[r+40>>2]):Y=0,_=0;r:{if(!(w&1)||(l=Q0(m,6),_=0,!l))break r;E=i[l+40>>2],_=i[l+52>>2]>>>1|0}r:{if(!n|!o)break r;if(j=(B&-3)==13?8:6,!(w&1)){for(l=0;;){for(E=g(k,l)+R|0,I=(g(l,x)<<1)+Y|0,Q=(g(l,G)<<1)+U|0,V=(g(l,N)<<1)+h|0,r=0;_=E+g(r,j)|0,s=u[_+4|0]|u[_+5|0]<<8,w=u[_+2|0]|u[_+3|0]<<8,B=r<<1,_=u[_|0]|u[_+1|0]<<8,X[B+V>>1]=_<<8|_>>>8,X[B+Q>>1]=w<<8|w>>>8,X[B+I>>1]=s<<8|s>>>8,r=r+1|0,(o|0)!=(r|0););if(l=l+1|0,(l|0)==(n|0))break}break r}Q=-1<<s^-1,l=0;f:switch(B-13|0){case 0:case 2:for(;;){for(B=g(k,l)+R|0,V=(g(l,_)<<1)+E|0,O=(g(l,x)<<1)+Y|0,S=(g(l,G)<<1)+U|0,q=(g(l,N)<<1)+h|0,r=0;s=B+g(r,j)|0,I=u[s+4|0]|u[s+5|0]<<8,Q=u[s+2|0]|u[s+3|0]<<8,w=r<<1,s=u[s|0]|u[s+1|0]<<8,X[w+q>>1]=s<<8|s>>>8,X[w+S>>1]=Q<<8|Q>>>8,X[w+O>>1]=I<<8|I>>>8,s=B+(r<<3)|0,s=u[s+6|0]|u[s+7|0]<<8,X[w+V>>1]=s<<8|s>>>8,r=r+1|0,(o|0)!=(r|0););if(l=l+1|0,(l|0)==(n|0))break}break r;default:break f}for(;;){for(V=g(k,l)+R|0,O=(g(l,_)<<1)+E|0,S=(g(l,x)<<1)+Y|0,q=(g(l,G)<<1)+U|0,d=(g(l,N)<<1)+h|0,r=0;s=V+g(r,j)|0,B=u[s+4|0]|u[s+5|0]<<8,I=u[s+2|0]|u[s+3|0]<<8,w=r<<1,s=u[s|0]|u[s+1|0]<<8,X[w+d>>1]=s<<8|s>>>8,X[w+q>>1]=I<<8|I>>>8,X[w+S>>1]=B<<8|B>>>8,X[w+O>>1]=Q,r=r+1|0,(o|0)!=(r|0););if(l=l+1|0,(l|0)==(n|0))break}}t[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=m;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=e+128|0}function kn(A,e,r,f,k,n,o,l,s,h,w){var _=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0;_=v-48|0,v=_,B=i[k>>2];i:{e:{if(n){if(B)break e;U0(5281,19968,244,15604),M()}if(!B)break i}if(m=i[k+4>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),i[A+124>>2]=B,B=i[A+128>>2],i[A+128>>2]=m,!B||(m=i[B+4>>2],i[B+4>>2]=m-1,m))break i;W[i[i[B>>2]+8>>2]](B),y(B)}n5(A),G=1,m=i[28972],i[28972]=m+1,i[A+112>>2]=o,i[A+108>>2]=2147483647,i[A>>2]=m,i[A+288>>2]=h,i[A+36>>2]=r,i[A+32>>2]=e,i[A+28>>2]=r,i[A+24>>2]=e,i[A+20>>2]=f,i[A+280>>2]=l,i[A+284>>2]=s;i:{e:{r:{f:{A:{k:{n:{t:switch(f|0){default:U0(24033,19968,280,15604),M();case 1:G=2,i[_+8>>2]=2,I=(r+1|0)/2|0,i[A+36>>2]=I,Q=(e+1|0)/2|0,i[A+32>>2]=Q,h=2,f=2;break k;case 2:i[_+8>>2]=3,G=2,Q=(e+1|0)/2|0,i[A+32>>2]=Q,h=1;break n;case 0:break A;case 3:break t}i[_+8>>2]=4,Q=e,h=1}I=r,f=1}if(t[A+51|0]=h,t[A+50|0]=G,h=i[k>>2],!h){i[_+20>>2]=16,i[_+16>>2]=r,i[_+12>>2]=e,Y=1;break f}if(i[h+16852>>2]!=(G|0))break r;if(i[h+16856>>2]==(f|0)){i[_+20>>2]=16,i[_+16>>2]=r,i[_+12>>2]=e;break e}U0(21535,19968,320,15604),M()}if(Y=1,i[_+8>>2]=1,X[A+50>>1]=257,i[A+32>>2]=0,i[A+36>>2]=0,h=i[k>>2],i[_+20>>2]=16,i[_+16>>2]=r,i[_+12>>2]=e,h){f=1;break e}f=1}h=0,l=0;break i}U0(21565,19968,319,15604),M()}R=i[h+508>>2],E=i[h+504>>2],N=i[h+500>>2],Y=0,l=i[h+496>>2]}V=8,U=l+N|0,B=g(U,G);i:{if((B|0)>=(e|0)||(m=E+R|0,s=g(m,f),(s|0)>=(r|0)))break i;i[A+88>>2]=I-m,i[A+84>>2]=Q-U,r=r-s|0,i[A+80>>2]=r,e=e-B|0,i[A+76>>2]=e,i[_+44>>2]=r,i[_+40>>2]=e,i[_+36>>2]=g(f,R),I=g(f,E),i[_+32>>2]=I,i[_+28>>2]=g(G,N),s=g(l,G),i[_+24>>2]=s,f=0,r=8,G=0,e=8,Y||(r=i[h+16832>>2],G=(r&255)>>>0>8,e=i[h+16840>>2]),t[A+49|0]=e,t[A+48|0]=r,t[A+16|0]=G,e=(e&255)>>>0>8,t[A+18|0]=e,t[A+17|0]=e;e:{r:{if(!o||(f=i[o+544>>2],!w))break r;r=i[o+540>>2],e=i[o+536>>2];break e}r=i[28569],e=i[28568]}i[A+304>>2]=e,i[A+308>>2]=r;e:{if(!e)break e;r=W[e|0](o,_+8|0,A,f)|0,i[A+64>>2]=(s+i[A+4>>2]|0)+g(I,i[A+40>>2]);r:{if(!i[A+20>>2]){G=0,e=0;break r}e=g(i[A+44>>2],E),G=e+(i[A+12>>2]+l|0)|0,e=e+(i[A+8>>2]+l|0)|0}if(i[A+72>>2]=G,i[A+68>>2]=e,r)break e;V=7;break i}e:{if(!n)break e;e=i[A+200>>2],n=i[h+16944>>2],f=i[h+16952>>2],r=i[h+16948>>2],o=g(f,r);r:{if((o|0)!=i[A+204>>2]){if(Z(e),e=E2(o),i[A+200>>2]=e,!e){i[A+204>>2]=0,r=0;break r}i[A+204>>2]=o}i[A+216>>2]=f,i[A+212>>2]=r,i[A+208>>2]=n,r=(e|0)!=0}e=i[A+220>>2],o=i[h+16944>>2],n=i[h+16952>>2],f=i[h+16948>>2],l=g(n,f);r:{if((l|0)!=i[A+224>>2]){if(Z(e),e=E2(l),i[A+220>>2]=e,!e){i[A+224>>2]=0,e=0;break r}i[A+224>>2]=l}i[A+236>>2]=n,i[A+232>>2]=f,i[A+228>>2]=o,e=(e|0)!=0}o=e&r,e=i[A+160>>2],n=i[h+16872>>2],f=i[h+16896>>2],r=i[h+16888>>2],l=g(f,r);r:{if((l|0)!=i[A+164>>2]){if(Z(e),e=E2(g(l,3)),i[A+160>>2]=e,!e){i[A+164>>2]=0,e=0;break r}i[A+164>>2]=l}i[A+176>>2]=f,i[A+172>>2]=r,i[A+168>>2]=n,e=(e|0)!=0}n=e&o,e=i[A+180>>2],r=i[h+16872>>2]-2|0,f=i[h+16896>>2]<<r,r=i[h+16888>>2]<<r,o=g(f,r);r:{if((o|0)!=i[A+184>>2]){if(Z(e),e=E2(g(o,12)),i[A+180>>2]=e,!e){i[A+184>>2]=0,e=0;break r}i[A+184>>2]=o}i[A+196>>2]=f,i[A+192>>2]=r,i[A+188>>2]=2,e=(e|0)!=0}o=e&n,e=i[A+240>>2],n=i[h+16936>>2],f=i[h+16928>>2],r=i[h+16924>>2],l=g(f,r);r:{if((l|0)!=i[A+244>>2]){if(Z(e),e=E2(l),i[A+240>>2]=e,!e){i[A+244>>2]=0,e=0;break r}i[A+244>>2]=l}i[A+256>>2]=f,i[A+252>>2]=r,i[A+248>>2]=n,e=(e|0)!=0}n=e&o,e=i[A+260>>2],f=(i[h+488>>2]+3|0)/4|0,r=(i[h+484>>2]+3|0)/4|0,o=g(f,r);r:{if((o|0)!=i[A+264>>2]){if(Z(e),e=E2(o),i[A+260>>2]=e,!e){i[A+264>>2]=0,e=0;break r}i[A+264>>2]=o}i[A+276>>2]=f,i[A+272>>2]=r,i[A+268>>2]=2,e=(e|0)!=0}if(o=e&n,h=i[k>>2],r=i[h+16892>>2],!((r|0)==i[A+152>>2]&i[A+156>>2]==i[h+16900>>2])){if(f=i[A+320>>2],f){if(r=f-4|0,e=i[r>>2],e){for(h=f+g(e,76)|0;h=h-76|0,(f|0)!=(h|0););h=i[k>>2]}Z(r),r=i[h+16892>>2]}e=i[A+140>>2],n=i[h+16876>>2],f=i[h+16900>>2],h=g(f,r);r:{if((h|0)!=i[A+144>>2]){if(Z(e),e=E2(g(h,24)),i[A+140>>2]=e,!e){h=0,i[A+144>>2]=0,e=0;break r}i[A+144>>2]=h}i[A+156>>2]=f,i[A+152>>2]=r,i[A+148>>2]=n,e=(e|0)!=0}if(r=L0(h,0,76,0),f=r+4|0,r=C(h0||r>>>0>f>>>0?-1:f),i[r>>2]=h,r=r+4|0,h)for(f=r+g(h,76)|0,h=r;i[h>>2]=0,h=h+76|0,(f|0)!=(h|0););if(i[A+320>>2]=r,e&o)break e;V=7;break i}if(o)break e;V=7;break i}V=0}e=i[k+4>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=_+48|0,V}function Vm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0;e=v-128|0,v=e,s=u[k+8|0],B=i[i[r>>2]+200>>2],f=C(248),i[f>>2]=101168,i[f+4>>2]=0,i[f+8>>2]=0,l0(f+16|0,0,156),i[f+76>>2]=0,i[f+80>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,t[f+24|0]=1,X[f+22>>1]=2,X[f+18>>1]=2,X[f+20>>1]=2,i[f+84>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+100>>2]=0,i[f+104>>2]=1,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,X[f+158>>1]=0,X[f+160>>1]=0,X[f+162>>1]=0,X[f+164>>1]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+172>>2]=255,i[f+192>>2]=0,i[f+196>>2]=5186,i[f+208>>2]=99,i[f+212>>2]=99,i[f+200>>2]=0,i[f+204>>2]=0,i[f+12>>2]=101488,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,n=f+12|0,i[f+176>>2]=n,i[f+8>>2]=i[f+8>>2]+1,i[f+180>>2]=f,i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),k=i[r>>2],_=i[k+188>>2],G=i[k+192>>2],t1(n,_,G,1,3),a0(e+56|0,n,3,_,G,8,l,0),a0(e+32|0,n,4,_,G,8,l,0),k=e+88|0;i:{if(i[e+56>>2]){if(o=i[e+60>>2],i[e+80>>2]=i[e+56>>2],i[e+84>>2]=o,t[e+75|0]>=0){o=e- -64|0,m=i[o+4>>2],i[k>>2]=i[o>>2],i[k+4>>2]=m,i[k+8>>2]=i[o+8>>2];break i}T(k,i[e+64>>2],i[e+68>>2]);break i}if(o=i[e+36>>2],i[e+80>>2]=i[e+32>>2],i[e+84>>2]=o,t[e+51|0]>=0){o=i[e+44>>2],i[k>>2]=i[e+40>>2],i[k+4>>2]=o,i[k+8>>2]=i[e+48>>2];break i}T(k,i[e+40>>2],i[e+44>>2])}a0(e+8|0,n,5,_,G,8,l,0),o=e+112|0;i:{if(i[e+80>>2]){if(m=i[e+84>>2],i[e+104>>2]=i[e+80>>2],i[e+108>>2]=m,t[e+99|0]>=0){m=i[k+4>>2],i[o>>2]=i[k>>2],i[o+4>>2]=m,i[o+8>>2]=i[k+8>>2];break i}T(o,i[e+88>>2],i[e+92>>2]);break i}if(k=i[e+12>>2],i[e+104>>2]=i[e+8>>2],i[e+108>>2]=k,t[e+27|0]>=0){k=i[e+20>>2],i[o>>2]=i[e+16>>2],i[o+4>>2]=k,i[o+8>>2]=i[e+24>>2];break i}T(o,i[e+16>>2],i[e+20>>2])}t[e+27|0]<0&&Z(i[e+16>>2]),t[e+99|0]<0&&Z(i[e+88>>2]),t[e+51|0]<0&&Z(i[e+40>>2]),t[e+75|0]<0&&Z(i[e+64>>2]);i:{e:{if(i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[o+4>>2],i[r>>2]=i[o>>2],i[r+4>>2]=k,i[r+8>>2]=i[o+8>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}t[e+123|0]<0&&Z(i[e+112>>2]);r:{if(!(s&1))break r;if(a0(e+104|0,n,6,_,G,8,l,0),i[e+104>>2]){if(r=i[e+108>>2],i[A>>2]=i[e+104>>2],i[A+4>>2]=r,r=A+8|0,t[e+123|0]>=0){k=i[e+116>>2],i[r>>2]=i[e+112>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+120>>2],t[A+20|0]=1;break e}if(T(r,i[e+112>>2],i[e+116>>2]),r=t[e+123|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+112>>2]);break e}if(t[e+123|0]>=0)break r;Z(i[e+112>>2])}r=Q0(i[r>>2],10),r?(U=i[r+40>>2],k=i[r+52>>2]):k=0,r=Q0(n,3),r?(x=i[r+52>>2],o=i[r+40>>2]):o=0,r=Q0(n,4),r?(j=i[r+40>>2],m=i[r+52>>2]):m=0,r=Q0(n,5),r?(O=i[r+52>>2],R=i[r+40>>2]):R=0,h=0;r:{if(!(s&1)||(l=Q0(n,6),h=0,!l))break r;N=i[l+40>>2],h=i[l+52>>2]}r:{if(!G|!_)break r;if(Y=(B|0)==11?4:3,!(s&1)){for(E=_&-2,N=_&1,h=0;;){if(s=g(h,O)+R|0,B=g(m,h)+j|0,I=g(h,x)+o|0,Q=g(k,h)+U|0,l=0,r=0,(_|0)!=1)for(;w=Q+g(l,Y)|0,t[l+I|0]=u[w|0],t[l+B|0]=u[w+1|0],t[l+s|0]=u[w+2|0],w=l|1,V=Q+g(w,Y)|0,t[w+I|0]=u[V|0],t[B+w|0]=u[V+1|0],t[s+w|0]=u[V+2|0],l=l+2|0,r=r+2|0,(E|0)!=(r|0););if(N&&(r=Q+g(l,Y)|0,t[l+I|0]=u[r|0],t[l+B|0]=u[r+1|0],t[l+s|0]=u[r+2|0]),h=h+1|0,(G|0)==(h|0))break}break r}if((B|0)==11){for(r=0;;){for(B=g(r,h)+N|0,I=g(r,O)+R|0,Q=g(r,m)+j|0,w=g(r,x)+o|0,V=g(r,k)+U|0,l=0;s=V+g(l,Y)|0,t[l+w|0]=u[s|0],t[l+Q|0]=u[s+1|0],t[l+I|0]=u[s+2|0],t[l+B|0]=u[s+3|0],l=l+1|0,(_|0)!=(l|0););if(r=r+1|0,(G|0)==(r|0))break}break r}for(q=_&-2,d=_&1,r=0;;){if(B=g(r,h)+N|0,I=g(r,O)+R|0,Q=g(r,m)+j|0,w=g(r,x)+o|0,V=g(r,k)+U|0,l=0,S=0,(_|0)!=1)for(;s=V+g(l,Y)|0,t[l+w|0]=u[s|0],t[l+Q|0]=u[s+1|0],t[l+I|0]=u[s+2|0],t[l+B|0]=255,s=l|1,E=V+g(s,Y)|0,t[s+w|0]=u[E|0],t[s+Q|0]=u[E+1|0],t[s+I|0]=u[E+2|0],t[s+B|0]=255,l=l+2|0,S=S+2|0,(q|0)!=(S|0););if(d&&(s=V+g(l,Y)|0,t[l+w|0]=u[s|0],t[l+Q|0]=u[s+1|0],t[l+I|0]=u[s+2|0],t[l+B|0]=255),r=r+1|0,(G|0)==(r|0))break}}t[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=n;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=e+128|0}function pm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0;h=v-80|0,v=h,_=Li(),p3(_,n),w=h+56|0,m=i[e>>2],n=k,s=v+-64|0,v=s,B=i[r>>2],r=i[B+192>>2],k=i[B+188>>2];i:{if(!((k|0)>(o|0)|(r|0)>(o|0))){r=i[28729],i[w>>2]=i[28728],i[w+4>>2]=r,r=w+8|0;e:{if(t[114931]>=0){k=i[28731],i[r>>2]=i[28730],i[r+4>>2]=k,i[r+8>>2]=i[28732];break e}T(r,i[28730],i[28731])}t[w+20|0]=1;break i}e:{if((r|0)<(k|0)){r=(g(r,o)|0)/(k|0)|0,k=o;break e}k=(g(k,o)|0)/(r|0)|0,r=o}i[s+44>>2]=0,i[s+48>>2]=0,nA(s+24|0,B,s+44|0,k&-2,r&-2,m- -64|0);e:{if(i[s+24>>2]){r=i[s+28>>2],i[w>>2]=i[s+24>>2],i[w+4>>2]=r,r=w+8|0;r:{if(t[s+43|0]>=0){k=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+40>>2];break r}T(r,i[s+32>>2],i[s+36>>2])}t[w+20|0]=1;break e}ge(s,m,s+44|0,n,_,4);r:{f:{A:{k:switch(k=u[s+20|0],k|0){case 0:break f;case 1:break A;default:break k}e2(),M()}if(r=i[s+4>>2],i[w>>2]=i[s>>2],i[w+4>>2]=r,r=w+8|0,t[s+19|0]>=0){n=i[s+12>>2],i[r>>2]=i[s+8>>2],i[r+4>>2]=n,i[r+8>>2]=i[s+16>>2];break r}T(r,i[s+8>>2],i[s+12>>2]);break r}n=i[s>>2],r=i[s+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[w+4>>2]=r,i[w>>2]=n}if(t[w+20|0]=k,r=u[s+20|0],(r|0)==255)break e;k=i[25177],i[s+56>>2]=i[25176],i[s+60>>2]=k,W[i[(s+56|0)+(r<<2)>>2]](s+55|0,s)}if(t[s+43|0]<0&&Z(i[s+32>>2]),r=i[s+48>>2],!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}v=s- -64|0,a2(_);i:{e:switch(u[h+76|0]){default:e2(),M();case 1:c0(A,h+56|0,i[e>>2]);break i;case 0:break e}k=i[h+56>>2],i[h+48>>2]=k,r=i[h+60>>2],i[h+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1);e:{if(!k){if(f=C(64),i[h+12>>2]=f,i[h+16>>2]=57,i[h+20>>2]=-2147483584,t[f+56|0]=u[28226],k=u[28222]|u[28223]<<8|(u[28224]<<16|u[28225]<<24),n=u[28218]|u[28219]<<8|(u[28220]<<16|u[28221]<<24),t[f+48|0]=n,t[f+49|0]=n>>>8,t[f+50|0]=n>>>16,t[f+51|0]=n>>>24,t[f+52|0]=k,t[f+53|0]=k>>>8,t[f+54|0]=k>>>16,t[f+55|0]=k>>>24,k=u[28214]|u[28215]<<8|(u[28216]<<16|u[28217]<<24),n=u[28210]|u[28211]<<8|(u[28212]<<16|u[28213]<<24),t[f+40|0]=n,t[f+41|0]=n>>>8,t[f+42|0]=n>>>16,t[f+43|0]=n>>>24,t[f+44|0]=k,t[f+45|0]=k>>>8,t[f+46|0]=k>>>16,t[f+47|0]=k>>>24,k=u[28206]|u[28207]<<8|(u[28208]<<16|u[28209]<<24),n=u[28202]|u[28203]<<8|(u[28204]<<16|u[28205]<<24),t[f+32|0]=n,t[f+33|0]=n>>>8,t[f+34|0]=n>>>16,t[f+35|0]=n>>>24,t[f+36|0]=k,t[f+37|0]=k>>>8,t[f+38|0]=k>>>16,t[f+39|0]=k>>>24,k=u[28198]|u[28199]<<8|(u[28200]<<16|u[28201]<<24),n=u[28194]|u[28195]<<8|(u[28196]<<16|u[28197]<<24),t[f+24|0]=n,t[f+25|0]=n>>>8,t[f+26|0]=n>>>16,t[f+27|0]=n>>>24,t[f+28|0]=k,t[f+29|0]=k>>>8,t[f+30|0]=k>>>16,t[f+31|0]=k>>>24,k=u[28190]|u[28191]<<8|(u[28192]<<16|u[28193]<<24),n=u[28186]|u[28187]<<8|(u[28188]<<16|u[28189]<<24),t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24,t[f+20|0]=k,t[f+21|0]=k>>>8,t[f+22|0]=k>>>16,t[f+23|0]=k>>>24,k=u[28182]|u[28183]<<8|(u[28184]<<16|u[28185]<<24),n=u[28178]|u[28179]<<8|(u[28180]<<16|u[28181]<<24),t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24,t[f+12|0]=k,t[f+13|0]=k>>>8,t[f+14|0]=k>>>16,t[f+15|0]=k>>>24,k=u[28174]|u[28175]<<8|(u[28176]<<16|u[28177]<<24),n=u[28170]|u[28171]<<8|(u[28172]<<16|u[28173]<<24),t[f|0]=n,t[f+1|0]=n>>>8,t[f+2|0]=n>>>16,t[f+3|0]=n>>>24,t[f+4|0]=k,t[f+5|0]=k>>>8,t[f+6|0]=k>>>16,t[f+7|0]=k>>>24,t[f+57|0]=0,f=a(h+24|0,5,2006,h+12|0),t[h+23|0]<0&&Z(i[h+12>>2]),c0(A,f,i[e>>2]),t[f+19|0]>=0)break e;Z(i[f+8>>2]);break e}r=h+24|0,Jl(r,i[e>>2],f,h+48|0);r:{if(i[h+24>>2]!=i[28728]){c0(A,r,i[e>>2]);break r}f:{if(!l)break f;k=C(16),r=k,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[l>>2]=r,n=i[h+48>>2],f=i[h+52>>2];A:{if(!f){i[r+4>>2]=f,i[r>>2]=n;break A}if(i[f+4>>2]=i[f+4>>2]+1,i[k>>2]=n,r=i[k+4>>2],i[k+4>>2]=f,!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break A;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=i[e>>2],r=i[l>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}t[h+43|0]<0&&Z(i[h+32>>2]),r=i[h+52>>2]}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}A=u[h+76|0],(A|0)!=255&&(e=i[25825],i[h+24>>2]=i[25824],i[h+28>>2]=e,W[i[(h+24|0)+(A<<2)>>2]](h+12|0,h+56|0)),v=h+80|0}function Fm(A,e,r,f,k,n,o,l,s,h){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0,h=h|0;var w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0;m=h-8|0,B=n+3|0,N=v-((g(B,k)<<1)+15&-16)|0;i:{if((n|0)>=-2){if((k|0)<=0)break i;for(Q=r-2|0,R=N+2|0,r=n+2|0,V=(r|0)>0?r:0,j=k&2147483646,O=k&1,Y=k-o&3,G=-1,E=k-1|0,S=E-o>>>0<3;;){_=R+(G<<1)|0,h=Q+(g(f,G)<<1)|0;e:{r:{f:switch(o|0){case 0:if(s=0,r=o,Y)for(;X[_+(g(r,B)<<1)>>1]=p[h+2>>1],r=r+1|0,h=h+2|0,s=s+1|0,(Y|0)!=(s|0););if(S)break e;for(;X[_+(g(r,B)<<1)>>1]=p[h+2>>1],X[_+(g(r+1|0,B)<<1)>>1]=p[h+4>>1],X[_+(g(r+2|0,B)<<1)>>1]=p[h+6>>1],X[_+(g(r+3|0,B)<<1)>>1]=p[h+8>>1],h=h+8|0,r=r+4|0,(k|0)!=(r|0););break e;default:for(s=p[h>>1],r=0;w=p[h+2>>1],X[_+(g(r,B)<<1)>>1]=(g(p[h+4>>1],58)+g(w,10)|0)-(p[h+6>>1]+(s&65535)<<1)>>m,h=h+2|0,s=w,r=r+1|0,(k|0)!=(r|0););break e;case 1:for(s=p[h>>1],r=0;w=p[h+2>>1],X[_+(g(r,B)<<1)>>1]=(g(p[h+4>>1],10)+g(w,58)|0)-(p[h+6>>1]+(s&65535)<<1)>>m,h=h+2|0,s=w,r=r+1|0,(k|0)!=(r|0););break e;case 2:for(s=p[h>>1],r=0;w=s&65535,s=p[h+2>>1],X[_+(g(r,B)<<1)>>1]=g(s,54)+(p[h+4>>1]<<4)-((w<<2)+(p[h+6>>1]<<1))>>m,h=h+2|0,r=r+1|0,(k|0)!=(r|0););break e;case 3:for(s=p[h>>1],r=0;w=s&65535,s=p[h+2>>1],X[_+(g(r,B)<<1)>>1]=((g(s,46)+g(w,-6)|0)+g(p[h+4>>1],28)|0)-(p[h+6>>1]<<2)>>m,h=h+2|0,r=r+1|0,(k|0)!=(r|0););break e;case 4:if(s=p[h>>1],r=0,I=0,!E)break r;for(;w=s&65535,s=p[h+4>>1],U=p[h+2>>1],x=p[h+6>>1],X[_+(g(r,B)<<1)>>1]=g(s+U|0,36)-(w+x<<2)>>m,X[_+(g(r|1,B)<<1)>>1]=g(s+x|0,36)-(p[h+8>>1]+U<<2)>>m,r=r+2|0,h=h+4|0,I=I+2|0,(j|0)!=(I|0););break r;case 5:for(s=p[h>>1],r=0;w=s&65535,s=p[h+2>>1],X[_+(g(r,B)<<1)>>1]=((g(s,28)-(w<<2)|0)+g(p[h+4>>1],46)|0)+g(p[h+6>>1],-6)>>m,h=h+2|0,r=r+1|0,(k|0)!=(r|0););break e;case 6:break f}for(s=p[h>>1],r=0;w=s&65535,s=p[h+2>>1],X[_+(g(r,B)<<1)>>1]=g(p[h+4>>1],54)+(s<<4)-((w<<1)+(p[h+6>>1]<<2))>>m,h=h+2|0,r=r+1|0,(k|0)!=(r|0););break e}if(!O)break e;X[_+(g(r,B)<<1)>>1]=g(p[h+4>>1]+p[h+2>>1]|0,36)-(p[h+6>>1]+(s&65535)<<2)>>m}if(G=G+1|0,(V|0)==(G|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(w=o?6:m,m=n&2147483646,Y=n&1,_=n-l&3,G=0,Q=n-1|0,R=Q-l>>>0<3;;){o=(G<<1)+A|0,h=(g(B,G)<<1)+N|0;e:{r:{f:switch(l|0){case 0:if(s=0,r=l,_)for(;X[o+(g(e,r)<<1)>>1]=p[h+2>>1],r=r+1|0,h=h+2|0,s=s+1|0,(_|0)!=(s|0););if(R)break e;for(;X[o+(g(e,r)<<1)>>1]=p[h+2>>1],X[o+(g(r+1|0,e)<<1)>>1]=p[h+4>>1],X[o+(g(r+2|0,e)<<1)>>1]=p[h+6>>1],X[o+(g(r+3|0,e)<<1)>>1]=p[h+8>>1],h=h+8|0,r=r+4|0,(n|0)!=(r|0););break e;default:for(s=p[h>>1],r=0;f=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=(g(X[h+4>>1],58)+g(f,10)|0)-(X[h+6>>1]+(s<<16>>16)<<1)>>w,h=h+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 1:for(s=p[h>>1],r=0;f=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=(g(X[h+4>>1],10)+g(f,58)|0)-(X[h+6>>1]+(s<<16>>16)<<1)>>w,h=h+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 2:for(s=p[h>>1],r=0;f=s<<16>>16,s=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=g(s,54)+(X[h+4>>1]<<4)-((f<<2)+(X[h+6>>1]<<1))>>w,h=h+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 3:for(s=p[h>>1],r=0;f=s<<16>>16,s=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=((g(s,46)+g(f,-6)|0)+g(X[h+4>>1],28)|0)-(X[h+6>>1]<<2)>>w,h=h+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 4:if(s=p[h>>1],r=0,I=0,!Q)break r;for(;f=s<<16>>16,s=X[h+4>>1],V=X[h+2>>1],E=f,f=X[h+6>>1],X[o+(g(e,r)<<1)>>1]=g(s+V|0,36)-(E+f<<2)>>w,X[o+(g(r|1,e)<<1)>>1]=g(f+s|0,36)-(V+X[h+8>>1]<<2)>>w,r=r+2|0,h=h+4|0,I=I+2|0,(m|0)!=(I|0););break r;case 5:for(s=p[h>>1],r=0;f=s<<16>>16,s=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=((g(s,28)-(f<<2)|0)+g(X[h+4>>1],46)|0)+g(X[h+6>>1],-6)>>w,h=h+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 6:break f}for(s=p[h>>1],r=0;f=s<<16>>16,s=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=g(X[h+4>>1],54)+(s<<4)-((f<<1)+(X[h+6>>1]<<2))>>w,h=h+2|0,r=r+1|0,(n|0)!=(r|0););break e}if(!Y)break e;X[o+(g(e,r)<<1)>>1]=g(X[h+4>>1]+X[h+2>>1]|0,36)-(X[h+6>>1]+(s<<16>>16)<<2)>>w}if(G=G+1|0,(G|0)==(k|0))break}}}function Z1(A,e,r,f,k,n,o,l,s){var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0;w=v-96|0,v=w,R=s&65535,m=(k^s)&-2147483648,I=k&65535,S=I,j0=s>>>16&32767,S0=k>>>16&32767;i:{e:{if(j0-32767>>>0>4294934529&S0-32767>>>0>=4294934530)break e;if(_=k&2147483647,G=_,h=f,!(!h&(_|0)==2147418112?!(e|r):_>>>0<2147418112)){B=h,m=k|32768;break i}if(_=s&2147483647,k=l,!(!k&(_|0)==2147418112?!(n|o):_>>>0<2147418112)){B=k,m=s|32768,e=n,r=o;break i}if(!(e|h|(G^2147418112|r))){if(!(k|n|(o|_))){m=2147450880,e=0,r=0;break i}m=m|2147418112,e=0,r=0;break i}if(!(k|n|(_^2147418112|o))){if(k=e|h,f=r|G,e=0,r=0,!(f|k)){m=2147450880;break i}m=m|2147418112;break i}if(!(e|h|(r|G))){e=0,r=0;break i}if(!(k|n|(o|_))){e=0,r=0;break i}if((G|0)==65535|G>>>0<65535&&(h=!(f|I),s=_1(h?r:I),h=((s|0)==32?_1(h?e:f)+32|0:s)+(h?64:0)|0,g4(w+80|0,e,r,f,I,h-15|0),Y=16-h|0,f=i[w+88>>2],S=i[w+92>>2],r=i[w+84>>2],e=i[w+80>>2]),_>>>0>65535)break e;s=!(l|R),k=_1(s?o:R),s=((k|0)==32?_1(s?n:l)+32|0:k)+(s?64:0)|0,g4(w- -64|0,n,o,l,R,s-15|0),Y=(Y-s|0)+16|0,l=i[w+72>>2],R=i[w+76>>2],n=i[w+64>>2],o=i[w+68>>2]}k=n,n=o<<15|k>>>17,s=k<<15,k=0,N=s&-32768,C0=r,j=L0(N,k,r,0),k=h0,q=k,r0=n,Q=e,e=L0(n,0,e,0),r=e+j|0,h=h0+k|0,s=e>>>0>r>>>0?h+1|0:h,h=0,e=L0(Q,E,N,E),G=h+e|0,n=r,k=n+h0|0,k=e>>>0>G>>>0?k+1|0:k,I=k,r=(n|0)==(k|0)&h>>>0>G>>>0|k>>>0<n>>>0,f0=f,V=L0(N,E,f,0),M0=h0,e=L0(C0,O,r0,O),U=e+V|0,h=h0+M0|0,h=e>>>0>U>>>0?h+1|0:h,_=h,e=R<<15|l>>>17,c=l<<15|o>>>17,f=L0(c,0,Q,E),A0=f+U|0,h=h0+h|0,h=f>>>0>A0>>>0?h+1|0:h,t0=h,k=s,_0=k+A0|0,n=((k|0)==(q|0)&n>>>0<j>>>0|k>>>0<q>>>0)+h|0,n=k>>>0>_0>>>0?n+1|0:n,s=n,o=_0,g0=S|65536,q=L0(N,E,g0,x),z0=h0,f=L0(f0,B,r0,O),N=f+q|0,k=h0+z0|0,k=f>>>0>N>>>0?k+1|0:k,l=k,X0=e|-2147483648,e=L0(X0,0,Q,E),E=e+N|0,h=h0+k|0,h=e>>>0>E>>>0?h+1|0:h,e=L0(c,B,C0,O),x=e+E|0,V0=h,n=h+h0|0,R=e>>>0>x>>>0?n+1|0:n,e=0,j=e+o|0,k=s+x|0,k=e>>>0>j>>>0?k+1|0:k,S=k,e=j+r|0,r=e>>>0<j>>>0?k+1|0:k,Y=((S0+j0|0)+Y|0)-16383|0,f=L0(X0,d,C0,O),o=h0,n=L0(g0,B,r0,O),k=n+f|0,h=h0+o|0,h=k>>>0<n>>>0?h+1|0:h,Q=(o|0)==(h|0)&f>>>0>k>>>0|o>>>0>h>>>0,o=L0(c,B,f0,B),f=o+k|0,n=h0+h|0,n=f>>>0<o>>>0?n+1|0:n,k=(n|0)==(h|0)&f>>>0<k>>>0|n>>>0<h>>>0,h=0,o=k,k=k+Q|0,h=o>>>0>k>>>0?1:h,o=k,k=L0(X0,d,g0,B),o=o+k|0,h=h0+h|0,h=k>>>0>o>>>0?h+1|0:h,O=o,o=f,Q=n,k=(_|0)==(M0|0)&V>>>0>U>>>0|_>>>0<M0>>>0,n=0,_=(_|0)==(t0|0)&U>>>0>A0>>>0|_>>>0>t0>>>0,V=_,_=k+_|0,k=(V>>>0>_>>>0?1:n)+Q|0,f=f+_|0,k=f>>>0<_>>>0?k+1|0:k,_=k,U=f,f=(k|0)==(Q|0)&f>>>0<o>>>0|k>>>0<Q>>>0,k=f,f=f+O|0,h=k>>>0>f>>>0?h+1|0:h,Q=f,V=h,k=L0(c,B,g0,B),h=h0,o=L0(X0,d,f0,B),f=o+k|0,n=h0+h|0,n=f>>>0<o>>>0?n+1|0:n,o=n,n=(h|0)==(n|0)&f>>>0<k>>>0|n>>>0<h>>>0,d=Q+o|0,k=n+V|0,k=o>>>0>d>>>0?k+1|0:k,V=d,h=f,n=0,f=n+U|0,h=h+_|0,h=f>>>0<n>>>0?h+1|0:h,n=k,o=(h|0)==(_|0)&f>>>0<U>>>0|h>>>0<_>>>0,k=o+V|0,n=o>>>0>k>>>0?n+1|0:n,U=k,o=n,_=f,V=h,n=(R|0)==(V0|0)&E>>>0>x>>>0|R>>>0<V0>>>0,k=(l|0)==(z0|0)&N>>>0<q>>>0|l>>>0<z0>>>0,l=(l|0)==(V0|0)&E>>>0<N>>>0|l>>>0>V0>>>0,k=k+l|0,n=k+n|0,l=R,f=l+f|0,k=n+V|0,n=o,k=f>>>0<l>>>0?k+1|0:k,l=(k|0)==(V|0)&f>>>0<_>>>0|k>>>0<V>>>0,o=l+U|0,n=l>>>0>o>>>0?n+1|0:n,x=o,h=n,o=f,l=k,k=(s|0)==(t0|0)&A0>>>0>_0>>>0|s>>>0<t0>>>0,n=0,s=(s|0)==(S|0)&j>>>0<_0>>>0|s>>>0>S>>>0,Q=s,s=k+s|0,k=(Q>>>0>s>>>0?1:n)+l|0,f=f+s|0,k=f>>>0<s>>>0?k+1|0:k,n=(k|0)==(l|0)&f>>>0<o>>>0|k>>>0<l>>>0,l=n+x|0,h=n>>>0>l>>>0?h+1|0:h,s=h;e:{if(h&65536){Y=Y+1|0;break e}x=I>>>31|0,h=s<<1|l>>>31,l=l<<1|k>>>31,s=h,h=k<<1|f>>>31,f=f<<1|r>>>31,k=h,h=I<<1|G>>>31,G=G<<1,I=h,h=r<<1|e>>>31,e=e<<1|x,r=h}if((Y|0)>=32767){m=m|2147418112,e=0,r=0;break i}e:{if((Y|0)<=0){if(o=1-Y|0,o>>>0<=127){n=Y+127|0,g4(w+48|0,G,I,e,r,n),g4(w+32|0,f,k,l,s,n),I6(w+16|0,G,I,e,r,o),I6(w,f,k,l,s,o),G=i[w+32>>2]|i[w+16>>2]|(i[w+48>>2]|i[w+56>>2]|(i[w+52>>2]|i[w+60>>2]))!=0,I=i[w+36>>2]|i[w+20>>2],e=i[w+40>>2]|i[w+24>>2],r=i[w+44>>2]|i[w+28>>2],f=i[w>>2],k=i[w+4>>2],o=i[w+8>>2],n=i[w+12>>2];break e}e=0,r=0;break i}o=l,n=s&65535|Y<<16}if(B=o|B,m=n|m,!(!e&(r|0)==-2147483648?!(G|I):(r|0)>0|(r|0)>=0)){e=f+1|0,h=e?k:k+1|0,k=m,r=h,f=!(h|e),B=f+B|0,m=f>>>0>B>>>0?k+1|0:k;break i}if(e|G|(r^-2147483648|I)){e=f,r=k;break i}n=m,e=f&1,r=e,e=e+f|0,r=r>>>0>e>>>0?k+1|0:k,f=(k|0)==(r|0)&e>>>0<f>>>0|r>>>0<k>>>0,B=f+B|0,m=f>>>0>B>>>0?n+1|0:n}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=B,i[A+12>>2]=m,v=w+96|0}function Cm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;n=v-16|0,v=n,I=e,Q=F0(r),i[I+100>>2]=Q,I=e,Q=F0(r),i[I+104>>2]=Q;i:{e:{if(k=i[e+12>>2],o=i[e+8>>2],!k&o>>>0>=8|k&&(k=k-(o>>>0<8)|0,o=o-8|0,s=i[e+32>>2],!k&o>>>0>=s>>>0|k))break e;if(e=C(40),i[n+4>>2]=e,i[n+8>>2]=38,i[n+12>>2]=-2147483608,r=u[29481]|u[29482]<<8|(u[29483]<<16|u[29484]<<24),f=u[29477]|u[29478]<<8|(u[29479]<<16|u[29480]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+38|0]=0,r=u[29511]|u[29512]<<8|(u[29513]<<16|u[29514]<<24),f=u[29507]|u[29508]<<8|(u[29509]<<16|u[29510]<<24),t[e+30|0]=f,t[e+31|0]=f>>>8,t[e+32|0]=f>>>16,t[e+33|0]=f>>>24,t[e+34|0]=r,t[e+35|0]=r>>>8,t[e+36|0]=r>>>16,t[e+37|0]=r>>>24,r=u[29505]|u[29506]<<8|(u[29507]<<16|u[29508]<<24),f=u[29501]|u[29502]<<8|(u[29503]<<16|u[29504]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[29497]|u[29498]<<8|(u[29499]<<16|u[29500]<<24),f=u[29493]|u[29494]<<8|(u[29495]<<16|u[29496]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[29489]|u[29490]<<8|(u[29491]<<16|u[29492]<<24),f=u[29485]|u[29486]<<8|(u[29487]<<16|u[29488]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,101,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}if(h=o-s|0,o=k-(o>>>0<s>>>0)|0,s=o>>>2|0,m=(o&3)<<30|h>>>2,k=m,f=i[f+84>>2],!((f|0)!=0&(!s&f>>>0<k>>>0|(s|0)!=0))){e:{f=u[r+20|0];r:{if(!(!o&h>>>0<4|f&1)){h=0,o=0;f:{A:{for(;;){_=F0(r),f=i[e+112>>2],l=i[e+116>>2];k:{if(f>>>0<l>>>0){i[f>>2]=_,f=f+4|0;break k}if(B=i[e+108>>2],f=f-B|0,G=f>>2,k=G+1|0,k>>>0>=1073741824)break A;if(l=l-B|0,w=l>>1,l=l>>>0>=2147483644?1073741823:k>>>0<w>>>0?w:k,l){if(l>>>0>=1073741824)break f;k=C(l<<2)}else k=0;if(w=k+f|0,i[w>>2]=_,_=w-(G<<2)|0,f&&z(_,B,f),i[e+116>>2]=k+(l<<2),f=w+4|0,i[e+112>>2]=f,i[e+108>>2]=_,!B)break k;Z(B)}if(i[e+112>>2]=f,f=o,k=t[r+20|0]&1,h=h+1|0,f=h?f:f+1|0,o=f,!(!k&((f|0)==(s|0)&h>>>0<m>>>0|f>>>0<s>>>0)))break}if(k)break r;break e}s0(),M()}x0(),M()}if(!(f&1))break e}if(t[n+4|0]=0,t[n+15|0]=0,a(A,2,100,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}if(e=C(56),i[n+4>>2]=e,i[n+8>>2]=53,i[n+12>>2]=-2147483592,r=u[4214]|u[4215]<<8|(u[4216]<<16|u[4217]<<24),f=u[4210]|u[4211]<<8|(u[4212]<<16|u[4213]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+53|0]=0,r=u[4259]|u[4260]<<8|(u[4261]<<16|u[4262]<<24),f=u[4255]|u[4256]<<8|(u[4257]<<16|u[4258]<<24),t[e+45|0]=f,t[e+46|0]=f>>>8,t[e+47|0]=f>>>16,t[e+48|0]=f>>>24,t[e+49|0]=r,t[e+50|0]=r>>>8,t[e+51|0]=r>>>16,t[e+52|0]=r>>>24,r=u[4254]|u[4255]<<8|(u[4256]<<16|u[4257]<<24),f=u[4250]|u[4251]<<8|(u[4252]<<16|u[4253]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[4246]|u[4247]<<8|(u[4248]<<16|u[4249]<<24),f=u[4242]|u[4243]<<8|(u[4244]<<16|u[4245]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[4238]|u[4239]<<8|(u[4240]<<16|u[4241]<<24),f=u[4234]|u[4235]<<8|(u[4236]<<16|u[4237]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[4230]|u[4231]<<8|(u[4232]<<16|u[4233]<<24),f=u[4226]|u[4227]<<8|(u[4228]<<16|u[4229]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[4222]|u[4223]<<8|(u[4224]<<16|u[4225]<<24),f=u[4218]|u[4219]<<8|(u[4220]<<16|u[4221]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,1e3,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2])}v=n+16|0}function Ym(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;o=v-48|0,v=o,_=W[i[i[e>>2]+52>>2]](e,r,0)|0,h=o+24|0,l=v-16|0,v=l,h2(r,u[e+100|0]),h2(r,(u[e+103|0]&31|(u[e+102|0]<<5|u[e+101|0]<<6))&255),p0(r,i[e+104>>2]),f=u[e+108|0],k=f>>>6|0,n=f>>>4|0,h2(r,((k&1|((n&1|(f>>>2&2|(f&4|f<<2&8)))<<2|n&2))<<2|k)&254),f=i[e+108>>2],k=f>>>14|0,n=f>>>12|0,s=f>>>10|0,h2(r,((k&1|((n&1|((s&1|f>>>8&2)<<2|s&2))<<2|n&2))<<2|k&2)&254),f=i[e+108>>2],k=f>>>22|0,n=f>>>20|0,s=f>>>18|0,h2(r,((k&1|((n&1|((s&1|f>>>16&2)<<2|s&2))<<2|n&2))<<2|k&2)&254),f=i[e+108>>2],k=f>>>30|0,n=f>>>28|0,s=f>>>26|0,h2(r,((k&1|((n&1|((s&1|f>>>24&2)<<2|s&2))<<2|n&2))<<2|k)&254),f=u[e+112|0],k=f>>>6|0,n=f>>>4|0,h2(r,((k&1|((n&1|(f>>>2&2|(f&4|f<<2&8)))<<2|n&2))<<2|k)&254),f=i[e+112>>2],k=f>>>14|0,n=f>>>12|0,s=f>>>10|0,h2(r,((k&1|((n&1|((s&1|f>>>8&2)<<2|s&2))<<2|n&2))<<2|k&2)&254),h2(r,u[e+116|0]),u2(r,p[e+118>>1]|61440),h2(r,u[e+120|0]|252),h2(r,u[e+121|0]|252),h2(r,u[e+122|0]|248),h2(r,u[e+123|0]|248),u2(r,p[e+124>>1]),h2(r,(u[e+129|0]-1&3|(u[e+128|0]<<2&4|(u[e+127|0]<<3&56|u[e+126|0]<<6)))&255),h2(r,i[e+136>>2]-i[e+132>>2]>>>4&255),f=i[e+132>>2],n=i[e+136>>2];i:{if((f|0)!=(n|0))for(;;){if(h2(r,u[f|0]<<6&64|u[f+1|0]&63),k=(i[f+8>>2]-i[f+4>>2]|0)/12|0,k>>>0>=65536){if(f=C(32),i[l+4>>2]=f,i[l+8>>2]=26,i[l+12>>2]=-2147483616,k=u[21616]|u[21617]<<8|(u[21618]<<16|u[21619]<<24),n=u[21612]|u[21613]<<8|(u[21614]<<16|u[21615]<<24),t[f|0]=n,t[f+1|0]=n>>>8,t[f+2|0]=n>>>16,t[f+3|0]=n>>>24,t[f+4|0]=k,t[f+5|0]=k>>>8,t[f+6|0]=k>>>16,t[f+7|0]=k>>>24,t[f+26|0]=0,k=u[21636]|u[21637]<<8,t[f+24|0]=k,t[f+25|0]=k>>>8,k=u[21632]|u[21633]<<8|(u[21634]<<16|u[21635]<<24),n=u[21628]|u[21629]<<8|(u[21630]<<16|u[21631]<<24),t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24,t[f+20|0]=k,t[f+21|0]=k>>>8,t[f+22|0]=k>>>16,t[f+23|0]=k>>>24,k=u[21624]|u[21625]<<8|(u[21626]<<16|u[21627]<<24),n=u[21620]|u[21621]<<8|(u[21622]<<16|u[21623]<<24),t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24,t[f+12|0]=k,t[f+13|0]=k>>>8,t[f+14|0]=k>>>16,t[f+15|0]=k>>>24,a(h,2,0,l+4|0),t[l+15|0]>=0)break i;Z(i[l+4>>2]);break i}if(u2(r,k),k=i[f+4>>2],s=i[f+8>>2],(k|0)!=(s|0))for(;;){if(w=i[k+4>>2]-i[k>>2]|0,w>>>0>=65536){if(f=C(48),i[l+4>>2]=f,i[l+8>>2]=41,i[l+12>>2]=-2147483600,k=u[29886]|u[29887]<<8|(u[29888]<<16|u[29889]<<24),n=u[29882]|u[29883]<<8|(u[29884]<<16|u[29885]<<24),t[f|0]=n,t[f+1|0]=n>>>8,t[f+2|0]=n>>>16,t[f+3|0]=n>>>24,t[f+4|0]=k,t[f+5|0]=k>>>8,t[f+6|0]=k>>>16,t[f+7|0]=k>>>24,t[f+41|0]=0,t[f+40|0]=u[29922],k=u[29918]|u[29919]<<8|(u[29920]<<16|u[29921]<<24),n=u[29914]|u[29915]<<8|(u[29916]<<16|u[29917]<<24),t[f+32|0]=n,t[f+33|0]=n>>>8,t[f+34|0]=n>>>16,t[f+35|0]=n>>>24,t[f+36|0]=k,t[f+37|0]=k>>>8,t[f+38|0]=k>>>16,t[f+39|0]=k>>>24,k=u[29910]|u[29911]<<8|(u[29912]<<16|u[29913]<<24),n=u[29906]|u[29907]<<8|(u[29908]<<16|u[29909]<<24),t[f+24|0]=n,t[f+25|0]=n>>>8,t[f+26|0]=n>>>16,t[f+27|0]=n>>>24,t[f+28|0]=k,t[f+29|0]=k>>>8,t[f+30|0]=k>>>16,t[f+31|0]=k>>>24,k=u[29902]|u[29903]<<8|(u[29904]<<16|u[29905]<<24),n=u[29898]|u[29899]<<8|(u[29900]<<16|u[29901]<<24),t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24,t[f+20|0]=k,t[f+21|0]=k>>>8,t[f+22|0]=k>>>16,t[f+23|0]=k>>>24,k=u[29894]|u[29895]<<8|(u[29896]<<16|u[29897]<<24),n=u[29890]|u[29891]<<8|(u[29892]<<16|u[29893]<<24),t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24,t[f+12|0]=k,t[f+13|0]=k>>>8,t[f+14|0]=k>>>16,t[f+15|0]=k>>>24,a(h,2,0,l+4|0),t[l+15|0]>=0)break i;Z(i[l+4>>2]);break i}if(u2(r,w),F4(r,k),k=k+12|0,(s|0)==(k|0))break}if(f=f+16|0,(n|0)==(f|0))break}if(f=i[28729],i[h>>2]=i[28728],i[h+4>>2]=f,f=h+8|0,t[114931]>=0){h=i[28731],i[f>>2]=i[28730],i[f+4>>2]=h,i[f+8>>2]=i[28732];break i}T(f,i[28730],i[28731])}v=l+16|0;i:{if(i[o+24>>2]){e=i[o+28>>2],i[A>>2]=i[o+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[o+40>>2],e=i[o+36>>2],i[A+8>>2]=i[o+32>>2],i[A+12>>2]=e,i[o+40>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0;break i}if(n1(o+4|0,e,r,_),t[o+23|0]<0&&Z(i[o+12>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}t[o+43|0]<0&&Z(i[o+32>>2]),v=o+48|0}function ym(A,e,r,f,k,n,o,l,s,h){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0,h=h|0;var w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0;m=h-8|0,B=n+3|0,N=v-((g(B,k)<<1)+15&-16)|0;i:{if((n|0)>=-2){if((k|0)<=0)break i;for(Q=r-1|0,R=N+2|0,r=n+2|0,V=(r|0)>0?r:0,j=k&2147483646,O=k&1,Y=k-o&3,G=-1,E=k-1|0,S=E-o>>>0<3;;){_=R+(G<<1)|0,h=Q+g(f,G)|0;e:{r:{f:switch(o|0){case 0:if(s=0,r=o,Y)for(;X[_+(g(r,B)<<1)>>1]=u[h+1|0],r=r+1|0,h=h+1|0,s=s+1|0,(Y|0)!=(s|0););if(S)break e;for(;X[_+(g(r,B)<<1)>>1]=u[h+1|0],X[_+(g(r+1|0,B)<<1)>>1]=u[h+2|0],X[_+(g(r+2|0,B)<<1)>>1]=u[h+3|0],X[_+(g(r+3|0,B)<<1)>>1]=u[h+4|0],h=h+4|0,r=r+4|0,(k|0)!=(r|0););break e;default:for(s=u[h|0],r=0;w=u[h+1|0],X[_+(g(r,B)<<1)>>1]=(g(u[h+2|0],58)+g(w,10)|0)-(u[h+3|0]+(s&255)<<1)>>m,h=h+1|0,s=w,r=r+1|0,(k|0)!=(r|0););break e;case 1:for(s=u[h|0],r=0;w=u[h+1|0],X[_+(g(r,B)<<1)>>1]=(g(u[h+2|0],10)+g(w,58)|0)-(u[h+3|0]+(s&255)<<1)>>m,h=h+1|0,s=w,r=r+1|0,(k|0)!=(r|0););break e;case 2:for(s=u[h|0],r=0;w=s&255,s=u[h+1|0],X[_+(g(r,B)<<1)>>1]=g(s,54)+(u[h+2|0]<<4)-((w<<2)+(u[h+3|0]<<1))>>m,h=h+1|0,r=r+1|0,(k|0)!=(r|0););break e;case 3:for(s=u[h|0],r=0;w=s&255,s=u[h+1|0],X[_+(g(r,B)<<1)>>1]=((g(s,46)+g(w,-6)|0)+g(u[h+2|0],28)|0)-(u[h+3|0]<<2)>>m,h=h+1|0,r=r+1|0,(k|0)!=(r|0););break e;case 4:if(s=u[h|0],r=0,I=0,!E)break r;for(;w=s&255,s=u[h+2|0],U=u[h+1|0],x=u[h+3|0],X[_+(g(r,B)<<1)>>1]=g(s+U|0,36)-(w+x<<2)>>m,X[_+(g(r|1,B)<<1)>>1]=g(s+x|0,36)-(u[h+4|0]+U<<2)>>m,r=r+2|0,h=h+2|0,I=I+2|0,(j|0)!=(I|0););break r;case 5:for(s=u[h|0],r=0;w=s&255,s=u[h+1|0],X[_+(g(r,B)<<1)>>1]=((g(s,28)-(w<<2)|0)+g(u[h+2|0],46)|0)+g(u[h+3|0],-6)>>m,h=h+1|0,r=r+1|0,(k|0)!=(r|0););break e;case 6:break f}for(s=u[h|0],r=0;w=s&255,s=u[h+1|0],X[_+(g(r,B)<<1)>>1]=g(u[h+2|0],54)+(s<<4)-((w<<1)+(u[h+3|0]<<2))>>m,h=h+1|0,r=r+1|0,(k|0)!=(r|0););break e}if(!O)break e;X[_+(g(r,B)<<1)>>1]=g(u[h+2|0]+u[h+1|0]|0,36)-(u[h+3|0]+(s&255)<<2)>>m}if(G=G+1|0,(V|0)==(G|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(w=o?6:m,m=n&2147483646,Y=n&1,_=n-l&3,G=0,Q=n-1|0,R=Q-l>>>0<3;;){o=(G<<1)+A|0,h=(g(B,G)<<1)+N|0;e:{r:{f:switch(l|0){case 0:if(s=0,r=l,_)for(;X[o+(g(e,r)<<1)>>1]=p[h+2>>1],r=r+1|0,h=h+2|0,s=s+1|0,(_|0)!=(s|0););if(R)break e;for(;X[o+(g(e,r)<<1)>>1]=p[h+2>>1],X[o+(g(r+1|0,e)<<1)>>1]=p[h+4>>1],X[o+(g(r+2|0,e)<<1)>>1]=p[h+6>>1],X[o+(g(r+3|0,e)<<1)>>1]=p[h+8>>1],h=h+8|0,r=r+4|0,(n|0)!=(r|0););break e;default:for(s=p[h>>1],r=0;f=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=(g(X[h+4>>1],58)+g(f,10)|0)-(X[h+6>>1]+(s<<16>>16)<<1)>>w,h=h+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 1:for(s=p[h>>1],r=0;f=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=(g(X[h+4>>1],10)+g(f,58)|0)-(X[h+6>>1]+(s<<16>>16)<<1)>>w,h=h+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 2:for(s=p[h>>1],r=0;f=s<<16>>16,s=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=g(s,54)+(X[h+4>>1]<<4)-((f<<2)+(X[h+6>>1]<<1))>>w,h=h+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 3:for(s=p[h>>1],r=0;f=s<<16>>16,s=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=((g(s,46)+g(f,-6)|0)+g(X[h+4>>1],28)|0)-(X[h+6>>1]<<2)>>w,h=h+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 4:if(s=p[h>>1],r=0,I=0,!Q)break r;for(;f=s<<16>>16,s=X[h+4>>1],V=X[h+2>>1],E=f,f=X[h+6>>1],X[o+(g(e,r)<<1)>>1]=g(s+V|0,36)-(E+f<<2)>>w,X[o+(g(r|1,e)<<1)>>1]=g(f+s|0,36)-(V+X[h+8>>1]<<2)>>w,r=r+2|0,h=h+4|0,I=I+2|0,(m|0)!=(I|0););break r;case 5:for(s=p[h>>1],r=0;f=s<<16>>16,s=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=((g(s,28)-(f<<2)|0)+g(X[h+4>>1],46)|0)+g(X[h+6>>1],-6)>>w,h=h+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 6:break f}for(s=p[h>>1],r=0;f=s<<16>>16,s=X[h+2>>1],X[o+(g(e,r)<<1)>>1]=g(X[h+4>>1],54)+(s<<4)-((f<<1)+(X[h+6>>1]<<2))>>w,h=h+2|0,r=r+1|0,(n|0)!=(r|0););break e}if(!Y)break e;X[o+(g(e,r)<<1)>>1]=g(X[h+4>>1]+X[h+2>>1]|0,36)-(X[h+6>>1]+(s<<16>>16)<<2)>>w}if(G=G+1|0,(G|0)==(k|0))break}}}function Em(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;if(n=v-32|0,v=n,_=W[i[i[e>>2]+52>>2]](e,r,0)|0,h2(r,u[e+105|0]|u[e+104|0]<<1&6|248),u[e+105|0]==1){u2(r,(u[e+110|0]|(u[e+108|0]<<4|p[e+106>>1]<<7|u[e+109|0]<<2))&65535),h2(r,(u[e+111|0]<<5|31)&255),h2(r,u[e+112|0]&63),h2(r,u[e+114|0]|u[e+113|0]<<1&254),h2(r,u[e+115|0]);i:{if(!u[e+112|0]||(h2(r,(u[i[e+120>>2]]|(u[e+117|0]<<6|u[e+116|0]<<7))&255),k=1,u[e+112|0]<=1))break i;for(;h2(r,u[i[e+120>>2]+k|0]),k=k+1|0,k>>>0<u[e+112|0];);}f=u[e+108|0];i:{if(f>>>0<=1)break i;o=f-1|0,h=o&1,l=i[e+132>>2],k=f-2|0;e:{if(!k){o=128,f=0;break e}for(B=o&-2,o=128,f=0;s=k-1|0,m=0-(i[l+(s>>>3&536870908)>>2]>>>s&1)|0,s=o&255,f=m&s>>>1|(0-(i[l+(k>>>3&536870908)>>2]>>>k&1)&o|f),k=k-2|0,o=s>>>2|0,w=w+2|0,(w|0)!=(B|0););}if(h&&(f=0-(i[l+(k>>>3&536870908)>>2]>>>k&1)&o|f),h2(r,f&255),f=u[e+108|0],f>>>0<2)break i;for(k=f-2|0;i[i[e+132>>2]+(k>>>3&536870908)>>2]>>>k&1&&h2(r,u[i[e+144>>2]+k|0]),f=(k|0)>0,k=k-1|0,!!f;);}if(f=i[e+160>>2]-i[e+156>>2]>>>2&255,h2(r,f),f)for(k=0;p0(r,i[i[e+156>>2]+(k<<2)>>2]),k=k+1|0,(f|0)!=(k|0););u2(r,p[e+168>>1]),u2(r,p[e+170>>1]),u2(r,p[e+172>>1])}f=i[e+180>>2]-i[e+176>>2]>>4;i:{if(f>>>0>=256){if(e=C(32),i[n+20>>2]=e,i[n+24>>2]=24,i[n+28>>2]=-2147483616,r=u[25515]|u[25516]<<8|(u[25517]<<16|u[25518]<<24),f=u[25511]|u[25512]<<8|(u[25513]<<16|u[25514]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+24|0]=0,r=u[25531]|u[25532]<<8|(u[25533]<<16|u[25534]<<24),f=u[25527]|u[25528]<<8|(u[25529]<<16|u[25530]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[25523]|u[25524]<<8|(u[25525]<<16|u[25526]<<24),f=u[25519]|u[25520]<<8|(u[25521]<<16|u[25522]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,n+20|0),t[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(h2(r,f),f=i[e+176>>2],o=i[e+180>>2],(f|0)!=(o|0))for(;;){if(h2(r,u[f+1|0]|u[f|0]<<7&128),k=(i[f+8>>2]-i[f+4>>2]|0)/12|0,k>>>0>=65536){if(e=C(24),i[n+20>>2]=e,i[n+24>>2]=23,i[n+28>>2]=-2147483624,r=u[25684]|u[25685]<<8|(u[25686]<<16|u[25687]<<24),f=u[25680]|u[25681]<<8|(u[25682]<<16|u[25683]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+23|0]=0,r=u[25699]|u[25700]<<8|(u[25701]<<16|u[25702]<<24),f=u[25695]|u[25696]<<8|(u[25697]<<16|u[25698]<<24),t[e+15|0]=f,t[e+16|0]=f>>>8,t[e+17|0]=f>>>16,t[e+18|0]=f>>>24,t[e+19|0]=r,t[e+20|0]=r>>>8,t[e+21|0]=r>>>16,t[e+22|0]=r>>>24,r=u[25692]|u[25693]<<8|(u[25694]<<16|u[25695]<<24),f=u[25688]|u[25689]<<8|(u[25690]<<16|u[25691]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,n+20|0),t[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(u2(r,k),k=i[f+4>>2],l=i[f+8>>2],(k|0)!=(l|0))for(;;){if(h=i[k+4>>2]-i[k>>2]|0,h>>>0>=65536){if(e=C(24),i[n+20>>2]=e,i[n+24>>2]=18,i[n+28>>2]=-2147483624,r=u[27720]|u[27721]<<8|(u[27722]<<16|u[27723]<<24),f=u[27716]|u[27717]<<8|(u[27718]<<16|u[27719]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+18|0]=0,r=u[27732]|u[27733]<<8,t[e+16|0]=r,t[e+17|0]=r>>>8,r=u[27728]|u[27729]<<8|(u[27730]<<16|u[27731]<<24),f=u[27724]|u[27725]<<8|(u[27726]<<16|u[27727]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,n+20|0),t[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(u2(r,h),F4(r,k),k=k+12|0,(l|0)==(k|0))break}if(f=f+16|0,(o|0)==(f|0))break}if(n1(n,e,r,_),t[n+19|0]<0&&Z(i[n+8>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+32|0}function wA(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=0,c2=0,f1=0,o1=0,u1=0,y1=0,a1=0,d1=0,u4=0,Y4=0,y4=0,E4=0,f8=0,A8=0,k8=0,v6=0,m6=0,ne=0,te=0;i:{e:{h=i[A+276>>2],r0=(f|0)<(h|0)?f:h;r:{if((r0|0)<=(r|0)||(_0=i[A+272>>2],f0=(k|0)<(_0|0)?k:_0,(f0|0)<=0))break r;for(q=i[A+124>>2],g0=i[q+16856>>2],c2=g0<<(e^1),X0=i[q+16852>>2],f1=X0<<e,o1=A+4|0,u1=3-g0|0,y1=3-X0|0,f=i[q+16840>>2],a1=f-8|0,s=-1<<f^-1,G=i[A+44>>2],M0=g(G,6),z0=G<<2,R=G<<1,j0=0-R|0,d1=i[A+260>>2],d=g(G,6),u4=0-G<<1,Y4=1-G<<1,y4=2-G<<1,E4=3-G<<1;;){for(f=r<<u1,S0=g(f,G),f8=S0+G|0,c=g(f,g0),A8=c-1|0,k8=g((c|0)/4|0,_0)+d1|0,A0=0;;){if(k=A0<<y1,t0=g(k,X0),f=u[((t0|0)/4|0)+k8|0]&3,f>>>0>1)for(h=1,v6=k+f8<<1,m6=(f<<1)-2|0,f=i[A+168>>2],Y=t0-1>>f,E=A8>>f,V0=c>>f,C0=t0>>f,q0=k+S0<<1,ne=q0+j0|0,te=i[A+132>>2],f=1;;){k=i[(f<<2)+o1>>2],_=k+q0|0;f:{if(!e){N=_+6|0,U=_+4|0,x=_+2|0,f=k+v6|0,j=f+6|0,B=f+4|0,k=k+ne|0,O=k+6|0,n=k+2|0,I=k+j0|0,o=I+6|0,Q=I+4|0,V=I+2|0,S=f+2|0,l=k+4|0;break f}I=_-4|0,o=d+I|0,f=_+2|0,j=d+f|0,w=R<<1,Q=w+I|0,B=f+w|0,V=I+R|0,k=_-2|0,O=d+k|0,n=k+R|0,N=_+d|0,U=w+_|0,x=_+R|0,S=f+R|0,l=k+w|0}if((C0|0)<0||(w=i[A+172>>2],(w|0)<=(C0|0)))break e;if((V0|0)<0||(m=i[A+176>>2],(m|0)<=(V0|0)))break i;r2=p[o>>1],f2=p[Q>>1],A2=p[V>>1],s2=p[I>>1],O=p[O>>1],l=p[l>>1],n=p[n>>1],o=p[k>>1],v2=p[j>>1],Z2=p[B>>1],X2=p[S>>1],R2=p[f>>1],N=p[N>>1],U=p[U>>1],x=p[x>>1],j=p[_>>1],I=h,k=i[(h?32:36)+te>>2],Q=i[A+160>>2],V=Q+g(C0,3)|0,S=g(g(w,V0),3),h=V+S|0,B=t[h+2|0];f:{if(!e){if((E|0)<0|(m|0)<=(E|0))break i;f=(V+g(g(w,E),3)|0)+2|0;break f}if((Y|0)<0|w>>>0<=Y>>>0)break e;f=(S+(Q+g(Y,3)|0)|0)+2|0}k=k+((B+t[f|0]|0)+1>>1)|0;f:{if(i[q+16848>>2]!=1){k=(k|0)>=51?51:k;break f}if((k|0)<30)break f;if(k>>>0<=42){k=i[(k<<2)+69640>>2];break f}k=k-6|0}if(B=i[A+148>>2],f=t0>>B,(f|0)<0||(D2=i[A+152>>2],(f|0)>=(D2|0)))break e;if(B=c>>B,(B|0)<0|(B|0)>=i[A+156>>2])break i;f=i[i[i[A+52>>2]+(p[((i[A+140>>2]+g(f,24)|0)+g(g(B,D2),24)|0)+2>>1]<<2)>>2]+768>>2]+(k+m6|0)|0,f=(f|0)>=53?53:f,f=u[((f|0)>0?f:0)+66736|0]<<a1,B=u[q+8812|0];f:{A:{if(!e){if(B){if((E|0)<0|(m|0)<=(E|0))break i;Q=!(u[(V+g(g(w,E),3)|0)+1|0]&4)}else Q=1;if((E|0)<0|(m|0)<=(E|0))break i;if(k=0-f|0,m=(((j-o<<2)+s2|0)-R2|0)+4>>3,m=(k|0)>(m|0)?k:(f|0)>(m|0)?m:f,h=u[h|0]|u[h+1|0]<<8,h=!(h&2048)&(!B|!(h&1024)),w=Q&!(u[(V+g(g(w,E),3)|0)+1|0]&8),w&&(o=o+m|0,X[_+u4>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0),h&&(o=j-m|0,X[_>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0),o=(((x-n<<2)+A2|0)-X2|0)+4>>3,o=(k|0)>(o|0)?k:(f|0)>(o|0)?o:f,w&&(n=n+o|0,X[_+Y4>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),h&&(n=x-o|0,X[_+2>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),n=(((U-l<<2)+f2|0)-Z2|0)+4>>3,n=(k|0)>(n|0)?k:(f|0)>(n|0)?n:f,w&&(l=n+l|0,X[_+y4>>1]=(l|0)>=0?(s|0)>(l|0)?l:s:0),h&&(l=U-n|0,X[_+4>>1]=(l|0)>=0?(s|0)>(l|0)?l:s:0),l=(((N-O<<2)+r2|0)-v2|0)+4>>3,f=(k|0)>(l|0)?k:(f|0)>(l|0)?l:f,w&&(k=f+O|0,X[_+E4>>1]=(k|0)>=0?(k|0)<(s|0)?k:s:0),!h)break f;k=N-f|0,f=6;break A}if(B){if((Y|0)<0|w>>>0<=Y>>>0)break e;m=!(u[(S+(Q+g(Y,3)|0)|0)+1|0]&4)}else m=1;if((Y|0)<0|w>>>0<=Y>>>0)break e;if(k=0-f|0,w=(((j-o<<2)+s2|0)-R2|0)+4>>3,V=(k|0)>(w|0)?k:(f|0)>(w|0)?w:f,h=u[h|0]|u[h+1|0]<<8,h=!(h&2048)&(!B|!(h&1024)),w=_-2|0,B=m&!(u[(S+(Q+g(Y,3)|0)|0)+1|0]&8),B&&(o=o+V|0,X[w>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0),h&&(o=j-V|0,X[_>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0),o=(((x-n<<2)+A2|0)-X2|0)+4>>3,o=(k|0)>(o|0)?k:(f|0)>(o|0)?o:f,B&&(n=n+o|0,X[w+R>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),h&&(n=x-o|0,X[_+R>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),n=(((U-l<<2)+f2|0)-Z2|0)+4>>3,n=(k|0)>(n|0)?k:(f|0)>(n|0)?n:f,B&&(l=n+l|0,X[w+z0>>1]=(l|0)>=0?(s|0)>(l|0)?l:s:0),h&&(l=U-n|0,X[_+z0>>1]=(l|0)>=0?(s|0)>(l|0)?l:s:0),l=(((N-O<<2)+r2|0)-v2|0)+4>>3,f=(k|0)>(l|0)?k:(f|0)>(l|0)?l:f,B&&(k=f+O|0,X[w+M0>>1]=(k|0)>=0?(k|0)<(s|0)?k:s:0),!h)break f;k=N-f|0,f=M0}X[f+_>>1]=(k|0)>=0?(k|0)<(s|0)?k:s:0}if(f=2,h=0,!I)break}if(A0=A0+f1|0,!((f0|0)>(A0|0)))break}if(r=r+c2|0,!((r0|0)>(r|0)))break}}return}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function nn(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;m=v-6240|0,v=m,I=e+96|0,Q=e+480|0,V=e+2016|0;i:{for(;;){for(_=w?64:16,G=(w|0)==3,Y=G?3:1,B=(m+6144|0)+g(w,24)|0,k=0;;){n=k<<10,f=n+m|0;e:{r:{f:{A:{k:{if(!(G0(A,1)&255)){if(r=k2(A),(r|0)==-99999||(r=G?g(r,3):r,(r|0)>(k|0)))break f;if(o=B+(k<<2)|0,i[o>>2]=16,!r){if(!w){r=i[28575],i[f+8>>2]=i[28574],i[f+12>>2]=r,r=i[28573],i[f>>2]=i[28572],i[f+4>>2]=r;break r}if(k>>>0<=2){r=i[28591],i[f+56>>2]=i[28590],i[f+60>>2]=r,r=i[28589],i[f+48>>2]=i[28588],i[f+52>>2]=r,r=i[28587],i[f+40>>2]=i[28586],i[f+44>>2]=r,r=i[28585],i[f+32>>2]=i[28584],i[f+36>>2]=r,r=i[28583],i[f+24>>2]=i[28582],i[f+28>>2]=r,r=16,o=i[28581],i[f+16>>2]=i[28580],i[f+20>>2]=o,o=i[28579],i[f+8>>2]=i[28578],i[f+12>>2]=o,o=i[28577],i[f>>2]=i[28576],i[f+4>>2]=o;break k}r=i[28607],i[f+56>>2]=i[28606],i[f+60>>2]=r,r=i[28605],i[f+48>>2]=i[28604],i[f+52>>2]=r,r=i[28603],i[f+40>>2]=i[28602],i[f+44>>2]=r,r=i[28601],i[f+32>>2]=i[28600],i[f+36>>2]=r,r=i[28599],i[f+24>>2]=i[28598],i[f+28>>2]=r,r=16,o=i[28597],i[f+16>>2]=i[28596],i[f+20>>2]=o,o=i[28595],i[f+8>>2]=i[28594],i[f+12>>2]=o,o=i[28593],i[f>>2]=i[28592],i[f+4>>2]=o;break k}if((w|0)==3&(r|0)!=3)break A;r=k-r|0,_&&z(f,(r<<10)+m|0,_),r=i[B+(r<<2)>>2],i[o>>2]=r;break k}n:{if(w>>>0<2){o=8,r=16;break n}if(r=f4(A),r-248>>>0<4294967041)break f;o=r+8|0,i[B+(k<<2)>>2]=o,r=o}for(s=0;;){if(l=f4(A),l+128>>>0>255)break f;if(o=o+l|0,t[f+s|0]=o,s=s+1|0,(_|0)==(s|0))break}}k:switch(w|0){case 1:for(r=(k<<6)+I|0,s=0,o=i[i[17266]+12>>2];n=o+(s<<1)|0,t[(r+(u[n+1|0]<<3)|0)+u[n|0]|0]=u[f+s|0],n=s|1,l=o+(n<<1)|0,t[(r+(u[l+1|0]<<3)|0)+u[l|0]|0]=u[f+n|0],s=s+2|0,(s|0)!=64;);break e;case 2:for(n=(k<<8)+Q|0,h=n+1|0,o=0,E=i[i[17266]+12>>2];s=(o<<1)+E|0,l=u[f+o|0],t[(n+(u[s|0]<<1)|0)+(u[s+1|0]<<5)|0]=l,t[((u[s|0]<<1)+h|0)+(u[s+1|0]<<5)|0]=l,t[((n+(u[s|0]<<1)|0)+(u[s+1|0]<<5)|0)+16|0]=l,t[(((u[s|0]<<1)+h|0)+(u[s+1|0]<<5)|0)+16|0]=l,o=o+1|0,(o|0)!=64;);t[n|0]=r;break e;case 0:break r;case 3:break k;default:break e}o=n+V|0,D8(o,f,3),t[o|0]=r;break e}U0(23206,19868,934,3877),M()}A=8;break i}D8((k<<4)+e|0,f,0)}if(k=k+Y|0,!(k>>>0<6))break}if(w=w+1|0,(w|0)==4)break}for(s=e+96|0,w=e- -64|0,_=e+32|0,B=e+160|0,A=0,o=i[i[17266]+12>>2];r=o+(A<<1)|0,n=u[r+1|0],r=u[r|0],f=((n<<7)+(r<<2)|0)+3040|0,k=f+e|0,r=g(u[r+(B+(n<<3)|0)|0],16843009),t[k|0]=r,n=r>>>8|0,t[k+1|0]=n,l=r>>>16|0,t[k+2|0]=l,h=r>>>24|0,t[k+3|0]=h,k=f+_|0,t[k|0]=r,t[k+1|0]=n,t[k+2|0]=l,t[k+3|0]=h,k=f+w|0,t[k|0]=r,t[k+1|0]=n,t[k+2|0]=l,t[k+3|0]=h,f=f+s|0,t[f|0]=r,t[f+1|0]=n,t[f+2|0]=l,t[f+3|0]=h,A=A+1|0,(A|0)!=64;);for(t[e+3040|0]=u[e+160|0],s=e+96|0,w=e- -64|0,_=e+32|0,B=e+224|0,A=0;r=o+(A<<1)|0,n=u[r+1|0],r=u[r|0],f=((n<<7)+(r<<2)|0)+4064|0,k=f+e|0,r=g(u[r+(B+(n<<3)|0)|0],16843009),t[k|0]=r,n=r>>>8|0,t[k+1|0]=n,l=r>>>16|0,t[k+2|0]=l,h=r>>>24|0,t[k+3|0]=h,k=f+_|0,t[k|0]=r,t[k+1|0]=n,t[k+2|0]=l,t[k+3|0]=h,k=f+w|0,t[k|0]=r,t[k+1|0]=n,t[k+2|0]=l,t[k+3|0]=h,f=f+s|0,t[f|0]=r,t[f+1|0]=n,t[f+2|0]=l,t[f+3|0]=h,A=A+1|0,(A|0)!=64;);for(t[e+4064|0]=u[e+224|0],s=e+96|0,w=e- -64|0,_=e+32|0,B=e+352|0,A=0;r=o+(A<<1)|0,n=u[r+1|0],r=u[r|0],f=((n<<7)+(r<<2)|0)+6112|0,k=f+e|0,r=g(u[r+(B+(n<<3)|0)|0],16843009),t[k|0]=r,n=r>>>8|0,t[k+1|0]=n,l=r>>>16|0,t[k+2|0]=l,h=r>>>24|0,t[k+3|0]=h,k=f+_|0,t[k|0]=r,t[k+1|0]=n,t[k+2|0]=l,t[k+3|0]=h,k=f+w|0,t[k|0]=r,t[k+1|0]=n,t[k+2|0]=l,t[k+3|0]=h,f=f+s|0,t[f|0]=r,t[f+1|0]=n,t[f+2|0]=l,t[f+3|0]=h,A=A+1|0,(A|0)!=64;);for(t[e+6112|0]=u[e+352|0],s=e+96|0,w=e- -64|0,_=e+32|0,B=e+416|0,A=0;r=o+(A<<1)|0,n=u[r+1|0],r=u[r|0],f=((n<<7)+(r<<2)|0)+7136|0,k=f+e|0,r=g(u[r+(B+(n<<3)|0)|0],16843009),t[k|0]=r,n=r>>>8|0,t[k+1|0]=n,l=r>>>16|0,t[k+2|0]=l,h=r>>>24|0,t[k+3|0]=h,k=f+_|0,t[k|0]=r,t[k+1|0]=n,t[k+2|0]=l,t[k+3|0]=h,k=f+w|0,t[k|0]=r,t[k+1|0]=n,t[k+2|0]=l,t[k+3|0]=h,f=f+s|0,t[f|0]=r,t[f+1|0]=n,t[f+2|0]=l,t[f+3|0]=h,A=A+1|0,(A|0)!=64;);t[e+7136|0]=u[e+416|0],A=0}return v=m+6240|0,A}function Rm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0;l=v-48|0,v=l,i[l+44>>2]=e,i[k>>2]=0,s=i[f+28>>2],i[l>>2]=s,(s|0)!=136824&&(i[s+4>>2]=i[s+4>>2]+1),s=$0(l,137e3),i2(l);i:{e:{r:{f:switch(o-65|0){case 0:case 32:Cs(A,n+24|0,l+44|0,r,k,s);break e;case 1:case 33:case 39:ps(A,n+16|0,l+44|0,r,k,s);break e;case 34:e=W[i[i[A+8>>2]+12>>2]](A+8|0)|0,o=A,h=i[l+44>>2],u[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,u[e+11|0]>>>7|0?A=i[e>>2]:A=e,u[e+11|0]>>>7|0?e=i[e+4>>2]:e=u[e+11|0]&127,w=l,_=n6(o,h,r,f,k,n,s,A+(e<<2)|0),i[w+44>>2]=_;break e;case 35:case 36:A=z8(l+44|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>30|e&4)){i[n+12>>2]=A;break A}i[k>>2]=e|4}break e;case 3:o=i[20995],i[l+24>>2]=i[20994],i[l+28>>2]=o,o=i[20993],i[l+16>>2]=i[20992],i[l+20>>2]=o,o=i[20991],i[l+8>>2]=i[20990],i[l+12>>2]=o,o=i[20989],i[l>>2]=i[20988],i[l+4>>2]=o,w=l,_=n6(A,e,r,f,k,n,l,l+32|0),i[w+44>>2]=_;break e;case 5:o=i[21003],i[l+24>>2]=i[21002],i[l+28>>2]=o,o=i[21001],i[l+16>>2]=i[21e3],i[l+20>>2]=o,o=i[20999],i[l+8>>2]=i[20998],i[l+12>>2]=o,o=i[20997],i[l>>2]=i[20996],i[l+4>>2]=o,w=l,_=n6(A,e,r,f,k,n,l,l+32|0),i[w+44>>2]=_;break e;case 7:A=z8(l+44|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>23|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 8:A=z8(l+44|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>11|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 41:A=z8(l+44|0,r,k,s,3),e=i[k>>2];A:{if(!((A|0)>365|e&4)){i[n+28>>2]=A;break A}i[k>>2]=e|4}break e;case 44:e=z8(l+44|0,r,k,s,2)-1|0,A=i[k>>2];A:{if(!(e>>>0>11|A&4)){i[n+16>>2]=e;break A}i[k>>2]=A|4}break e;case 12:A=z8(l+44|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>59|e&4)){i[n+4>>2]=A;break A}i[k>>2]=e|4}break e;case 45:case 51:for(A=l+44|0,e=v-16|0,v=e,i[e+12>>2]=r;;){A:{if(b2(A,e+12|0))break A;r=i[A>>2],f=i[r+12>>2];k:{if((f|0)==i[r+16>>2]){r=W[i[i[r>>2]+36>>2]](r)|0;break k}r=i[f>>2]}if(!(W[i[i[s>>2]+12>>2]](s,1,r)|0))break A;k4(A);continue}break}b2(A,e+12|0)&&(i[k>>2]=i[k>>2]|2),v=e+16|0;break e;case 47:o=l+44|0,e=W[i[i[A+8>>2]+8>>2]](A+8|0)|0;A:{if(u[e+11|0]>>>7|0){A=i[e+4>>2];break A}A=u[e+11|0]&127}u[e+23|0]>>>7|0?f=i[e+16>>2]:f=u[e+23|0]&127;A:{if((A|0)==(0-f|0)){i[k>>2]=i[k>>2]|4;break A}if(r=o3(o,r,e,e+24|0,s,k,0),A=i[n+8>>2],!((r|0)!=(e|0)|(A|0)!=12)){i[n+8>>2]=0;break A}(r-e|0)!=12|(A|0)>11||(i[n+8>>2]=A+12)}break e;case 49:z(l,84016,44),w=l,_=n6(A,e,r,f,k,n,l,l+44|0),i[w+44>>2]=_;break e;case 17:i[l+16>>2]=i[21020],o=i[21019],i[l+8>>2]=i[21018],i[l+12>>2]=o,o=i[21017],i[l>>2]=i[21016],i[l+4>>2]=o,w=l,_=n6(A,e,r,f,k,n,l,l+20|0),i[w+44>>2]=_;break e;case 18:A=z8(l+44|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>60|e&4)){i[n>>2]=A;break A}i[k>>2]=e|4}break e;case 19:o=i[21031],i[l+24>>2]=i[21030],i[l+28>>2]=o,o=i[21029],i[l+16>>2]=i[21028],i[l+20>>2]=o,o=i[21027],i[l+8>>2]=i[21026],i[l+12>>2]=o,o=i[21025],i[l>>2]=i[21024],i[l+4>>2]=o,w=l,_=n6(A,e,r,f,k,n,l,l+32|0),i[w+44>>2]=_;break e;case 54:A=z8(l+44|0,r,k,s,1),e=i[k>>2];A:{if(!((A|0)>6|e&4)){i[n+24>>2]=A;break A}i[k>>2]=e|4}break e;case 55:A=W[i[i[A>>2]+20>>2]](A,e,r,f,k,n)|0;break i;case 23:e=W[i[i[A+8>>2]+24>>2]](A+8|0)|0,o=A,h=i[l+44>>2],u[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,u[e+11|0]>>>7|0?A=i[e>>2]:A=e,u[e+11|0]>>>7|0?e=i[e+4>>2]:e=u[e+11|0]&127,w=l,_=n6(o,h,r,f,k,n,s,A+(e<<2)|0),i[w+44>>2]=_;break e;case 56:as(n+20|0,l+44|0,r,k,s);break e;case 24:A=z8(l+44|0,r,k,s,4),u[k|0]&4||(i[n+20>>2]=A-1900);break e;default:if((o|0)==37)break r;break;case 2:case 4:case 6:case 9:case 10:case 11:case 13:case 14:case 15:case 16:case 20:case 21:case 22:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 37:case 38:case 40:case 42:case 43:case 46:case 48:case 50:case 52:case 53:break f}i[k>>2]=i[k>>2]|4;break e}A=v-16|0,v=A,i[A+12>>2]=r,r=l+44|0,n=A+12|0,e=6;r:{f:{if(b2(r,n))break f;e=i[r>>2],f=i[e+12>>2];A:{if((f|0)==i[e+16>>2]){f=W[i[i[e>>2]+36>>2]](e)|0;break A}f=i[f>>2]}if(e=4,(W[i[i[s>>2]+52>>2]](s,f,0)|0)!=37)break f;if(!b2(k4(r),n))break r;e=2}i[k>>2]=e|i[k>>2]}v=A+16|0}A=i[l+44>>2]}return v=l+48|0,A|0}function Jm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;k=v-112|0,v=k,W[i[i[e>>2]+36>>2]](k+80|0,e,1,r,0,f);i:{e:{if(i[k+80>>2]){r=i[e+68>>2],r&&(W[i[i[e+64>>2]+24>>2]](r),i[e+68>>2]=0),e=i[k+84>>2],i[A>>2]=i[k+80>>2],i[A+4>>2]=e,r=A+8|0;r:{if(t[k+99|0]>=0){e=i[k+92>>2],i[r>>2]=i[k+88>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+96>>2];break r}T(r,i[k+88>>2],i[k+92>>2])}t[A+20|0]=1;break e}W[i[i[e>>2]+40>>2]](k+60|0,e),t[k+79|0]<0&&Z(i[k+68>>2]),_=k+44|0,B=k+51|0,m=k+40|0,o=i[25894],G=i[25895],s=i[25892],h=i[25893];r:{f:{for(;;){t[k+52|0]=0,i[k+32>>2]=0,i[k+36>>2]=0,W[i[i[e>>2]+44>>2]](k+8|0,e,r,0,f),w=u[k+28|0];A:{k:{if(n=u[k+52|0],(n|0)==255){if((w|0)==255)break i;break k}if((w|0)!=255)break k;i[k+104>>2]=s,i[k+108>>2]=h,W[i[(k+104|0)+(n<<2)>>2]](k+100|0,k+32|0),t[k+52|0]=255;break A}n=k+32|0,i[k+100>>2]=n,i[k+104>>2]=o,i[k+108>>2]=G,W[i[(k+104|0)+(w<<2)>>2]](k+100|0,n,k+8|0)}if(n=u[k+28|0],(n|0)!=255&&(i[k+104>>2]=s,i[k+108>>2]=h,W[i[(k+104|0)+(n<<2)>>2]](k+100|0,k+8|0)),n=u[k+52|0],n){if(!i[k+32>>2]|(n|0)!=1)break i;break f}if(i[28728])break f;if(i[k+32>>2]){r=i[e+68>>2];A:{if(!r){t[A+20|0]=255,e=0,t[A|0]=0;break A}if(W[i[i[e+64>>2]+24>>2]](r),i[e+68>>2]=0,e=u[k+52|0],t[A+20|0]=255,t[A|0]=0,(e|0)==255)break e}i[k+104>>2]=A,r=i[25897],i[k+8>>2]=i[25896],i[k+12>>2]=r,W[i[(k+8|0)+(e<<2)>>2]](k+104|0,k+32|0),t[A+20|0]=e;break r}if(W[s|0](k+8|0,k+32|0),l=l+1|0,(l|0)==50)break}r=i[e+68>>2],r&&(W[i[i[e+64>>2]+24>>2]](r),i[e+68>>2]=0),f=C(64),i[k+8>>2]=f,i[k+12>>2]=58,i[k+16>>2]=-2147483584,e=u[28438]|u[28439]<<8,t[f+56|0]=e,t[f+57|0]=e>>>8,r=u[28434]|u[28435]<<8|(u[28436]<<16|u[28437]<<24),e=u[28430]|u[28431]<<8|(u[28432]<<16|u[28433]<<24),t[f+48|0]=e,t[f+49|0]=e>>>8,t[f+50|0]=e>>>16,t[f+51|0]=e>>>24,t[f+52|0]=r,t[f+53|0]=r>>>8,t[f+54|0]=r>>>16,t[f+55|0]=r>>>24,r=u[28426]|u[28427]<<8|(u[28428]<<16|u[28429]<<24),e=u[28422]|u[28423]<<8|(u[28424]<<16|u[28425]<<24),t[f+40|0]=e,t[f+41|0]=e>>>8,t[f+42|0]=e>>>16,t[f+43|0]=e>>>24,t[f+44|0]=r,t[f+45|0]=r>>>8,t[f+46|0]=r>>>16,t[f+47|0]=r>>>24,r=u[28418]|u[28419]<<8|(u[28420]<<16|u[28421]<<24),e=u[28414]|u[28415]<<8|(u[28416]<<16|u[28417]<<24),t[f+32|0]=e,t[f+33|0]=e>>>8,t[f+34|0]=e>>>16,t[f+35|0]=e>>>24,t[f+36|0]=r,t[f+37|0]=r>>>8,t[f+38|0]=r>>>16,t[f+39|0]=r>>>24,r=u[28410]|u[28411]<<8|(u[28412]<<16|u[28413]<<24),e=u[28406]|u[28407]<<8|(u[28408]<<16|u[28409]<<24),t[f+24|0]=e,t[f+25|0]=e>>>8,t[f+26|0]=e>>>16,t[f+27|0]=e>>>24,t[f+28|0]=r,t[f+29|0]=r>>>8,t[f+30|0]=r>>>16,t[f+31|0]=r>>>24,r=u[28402]|u[28403]<<8|(u[28404]<<16|u[28405]<<24),e=u[28398]|u[28399]<<8|(u[28400]<<16|u[28401]<<24),t[f+16|0]=e,t[f+17|0]=e>>>8,t[f+18|0]=e>>>16,t[f+19|0]=e>>>24,t[f+20|0]=r,t[f+21|0]=r>>>8,t[f+22|0]=r>>>16,t[f+23|0]=r>>>24,r=u[28394]|u[28395]<<8|(u[28396]<<16|u[28397]<<24),e=u[28390]|u[28391]<<8|(u[28392]<<16|u[28393]<<24),t[f+8|0]=e,t[f+9|0]=e>>>8,t[f+10|0]=e>>>16,t[f+11|0]=e>>>24,t[f+12|0]=r,t[f+13|0]=r>>>8,t[f+14|0]=r>>>16,t[f+15|0]=r>>>24,r=u[28386]|u[28387]<<8|(u[28388]<<16|u[28389]<<24),e=u[28382]|u[28383]<<8|(u[28384]<<16|u[28385]<<24),t[f|0]=e,t[f+1|0]=e>>>8,t[f+2|0]=e>>>16,t[f+3|0]=e>>>24,t[f+4|0]=r,t[f+5|0]=r>>>8,t[f+6|0]=r>>>16,t[f+7|0]=r>>>24,t[f+58|0]=0,f=a(k+32|0,7,0,k+8|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;A:{if(t[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],t[A+20|0]=1;break A}if(T(r,i[f+8>>2],i[f+12>>2]),e=t[f+19|0],t[A+20|0]=1,(e|0)>=0)break A;Z(i[f+8>>2])}if(t[k+19|0]>=0)break e;Z(i[k+8>>2]);break e}r=i[e+68>>2],r&&(W[i[i[e+64>>2]+24>>2]](r),i[e+68>>2]=0,n=u[k+52|0]),e=114912,r=114924,f=114931,l=114920;f:switch(n|0){case 1:e=k+32|0,l=m,f=B,r=_;break;case 0:break f;default:break i}o=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=o,o=A+8|0;f:{if(t[f|0]>=0){e=i[l+4>>2],i[o>>2]=i[l>>2],i[o+4>>2]=e,i[o+8>>2]=i[l+8>>2];break f}T(o,i[l>>2],i[r>>2])}t[A+20|0]=1}if(A=u[k+52|0],(A|0)==255)break e;i[k+8>>2]=s,i[k+12>>2]=h,W[i[(k+8|0)+(A<<2)>>2]](k+104|0,k+32|0)}t[k+99|0]<0&&Z(i[k+88>>2]),v=k+112|0;return}e2(),M()}function Nm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;k=v-192|0,v=k,S2(k+172|0,e,r),t[k+191|0]<0&&Z(i[k+180>>2]),l=u[e+97|0];i:{if(l>>>0>=2){B1(A,e,4858);break i}if(o=F0(r),n=i[f+80>>2],!(!n|o>>>0<=n>>>0)){if(e=C(64),i[k+24>>2]=e,i[k+28>>2]=61,i[k+32>>2]=-2147483584,r=u[18943]|u[18944]<<8|(u[18945]<<16|u[18946]<<24),f=u[18939]|u[18940]<<8|(u[18941]<<16|u[18942]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+61|0]=0,r=u[18996]|u[18997]<<8|(u[18998]<<16|u[18999]<<24),f=u[18992]|u[18993]<<8|(u[18994]<<16|u[18995]<<24),t[e+53|0]=f,t[e+54|0]=f>>>8,t[e+55|0]=f>>>16,t[e+56|0]=f>>>24,t[e+57|0]=r,t[e+58|0]=r>>>8,t[e+59|0]=r>>>16,t[e+60|0]=r>>>24,r=u[18991]|u[18992]<<8|(u[18993]<<16|u[18994]<<24),f=u[18987]|u[18988]<<8|(u[18989]<<16|u[18990]<<24),t[e+48|0]=f,t[e+49|0]=f>>>8,t[e+50|0]=f>>>16,t[e+51|0]=f>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[18983]|u[18984]<<8|(u[18985]<<16|u[18986]<<24),f=u[18979]|u[18980]<<8|(u[18981]<<16|u[18982]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[18975]|u[18976]<<8|(u[18977]<<16|u[18978]<<24),f=u[18971]|u[18972]<<8|(u[18973]<<16|u[18974]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[18967]|u[18968]<<8|(u[18969]<<16|u[18970]<<24),f=u[18963]|u[18964]<<8|(u[18965]<<16|u[18966]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[18959]|u[18960]<<8|(u[18961]<<16|u[18962]<<24),f=u[18955]|u[18956]<<8|(u[18957]<<16|u[18958]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[18951]|u[18952]<<8|(u[18953]<<16|u[18954]<<24),f=u[18947]|u[18948]<<8|(u[18949]<<16|u[18950]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,1e3,k+24|0),t[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(D4(A,e+116|0,o<<3,f,14869),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),f=e+104|0;e:{s=i[e+104>>2],n=i[e+108>>2]-s>>3;r:{f:{if(n>>>0<o>>>0){fi(f,o-n|0);break f}if(o>>>0<n>>>0&&(i[e+108>>2]=s+(o<<3)),!o)break r}if(e=0,!l)for(;;){if(!i[r+16>>2])break e;if(n=F0(r),l=F0(r),s=i[f>>2]+(e<<3)|0,i[s+4>>2]=l,i[s>>2]=n,e=e+1|0,(o|0)==(e|0))break r}for(;;){if(!i[r+16>>2])break e;if(n=F0(r),l=F0(r),s=i[f>>2]+(e<<3)|0,i[s+4>>2]=l,i[s>>2]=n,e=e+1|0,(o|0)==(e|0))break}}if(u[r+20|0]==1){if(t[k+24|0]=0,t[k+35|0]=0,a(A,2,100,k+24|0),t[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}i[k+116>>2]=0,i[k+88>>2]=78164,i[k+32>>2]=78144,r=i[19545],i[k+24>>2]=r,f=i[r-12>>2],r=k+24|0,i[f+r>>2]=i[19546],i[k+28>>2]=0,f=r+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(f,n),t[f+80|0]=0,i[f+72>>2]=0,f=i[19547],i[k+32>>2]=f,l=k+32|0,i[l+i[f-12>>2]>>2]=i[19548],f=i[19544],i[k+24>>2]=f,i[r+i[f-12>>2]>>2]=i[19549],i[k+88>>2]=78164,i[k+24>>2]=78124,i[k+32>>2]=78144,f=R0(n),i[f>>2]=77200,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,F(B0(F(B0(F(l,31612,24),o),32551,33),e),6019,8),e=i[k+84>>2];e:{r:{if(e&16){r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0&&(i[k+80>>2]=e,r=e),e=k+56|0;break r}if(!(e&8)){r=0,t[k+23|0]=0,e=k+12|0;break e}r=i[k+52>>2],e=k+44|0}r:{if(o=i[e>>2],r=r-o|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[k+20>>2]=n-2147483647,i[k+12>>2]=e,i[k+16>>2]=r;break r}if(t[k+23|0]=r,e=k+12|0,r)break r;r=0;break e}I0(),M()}if(!r)break e;z(e,o,r)}t[e+r|0]=0,a(A,2,100,k+12|0),t[k+23|0]<0&&Z(i[k+12>>2]),A=i[19543],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[19551],i[k+32>>2]=i[19552],i[f>>2]=77200,t[k+79|0]<0&&Z(i[k+68>>2]),y0(f),Y0(k+88|0)}v=k+192|0}function W6(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;f=v-96|0,v=f;i:{if(!i[e+64>>2]){t[f+16|0]=0,t[f+27|0]=0,e=a(f+72|0,2,110,f+16|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(t[f+27|0]>=0)break i;Z(i[f+16>>2]);break i}e:{r:{f:{A:{k:{if(n=i[e+140>>2],!n)break k;for(l=e+140|0,o=l,k=n;s=o0[k+16>>2]<r>>>0,o=s?o:k,k=i[(s?4:0)+k>>2],!!k;);if((o|0)==(l|0)|o0[o+16>>2]>r>>>0)break k;for(k=l;o=o0[n+16>>2]<r>>>0,k=o?k:n,n=i[(o?4:0)+n>>2],!!n;);if(o=0,!((k|0)==(l|0)|o0[k+16>>2]>r>>>0)&&(n=i[k+20>>2],o=i[k+24>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),n))break r;if(t[f+16|0]=0,t[f+27|0]=0,e=a(f+72|0,5,2e3,f+16|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,t[e+19|0]<0)break A;k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break f}t[f+16|0]=0,t[f+27|0]=0,e=a(f+72|0,5,2e3,f+16|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;k:{if(t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break k}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break k;Z(i[e+8>>2])}if(t[f+27|0]>=0)break i;Z(i[f+16>>2]);break i}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(t[f+27|0]>=0)break e;Z(i[f+16>>2]);break e}k=i[n+112>>2];r:{if(t[n+139|0]>=0){i[f- -64>>2]=i[n+136>>2],l=i[n+132>>2],i[f+56>>2]=i[n+128>>2],i[f+60>>2]=l;break r}T(f+56|0,i[n+128>>2],i[n+132>>2])}i[f+72>>2]=0,i[f+76>>2]=0,i[f+88>>2]=0,i[f+80>>2]=0,i[f+84>>2]=0;r:{f:{if((k|0)!=1835625829)break f;A:{if(t[n+151|0]>=0){i[f+48>>2]=i[n+148>>2],k=i[n+144>>2],i[f+40>>2]=i[n+140>>2],i[f+44>>2]=k;break A}T(f+40|0,i[n+140>>2],i[n+144>>2])}if(k=t[f+51|0],n=(k|0)<0,l=n?i[f+44>>2]:k,l){A:{k:{if((l|0)!=13||(e=f+40|0,N2(n?i[f+40>>2]:e,20027,13)))break k;if(e=a(f+16|0,4,3005,e),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break A;Z(i[e+8>>2]);break A}if(e=f+40|0,_r(e,13339)){if(e=a(f+16|0,4,3005,e),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break A;Z(i[e+8>>2]);break A}if(e=f+40|0,_r(e,8286)){if(e=a(f+16|0,4,3005,e),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break A;Z(i[e+8>>2]);break A}k=V2(f+4|0,47881),e=a(f+16|0,4,3e3,k),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;k:{if(t[e+19|0]>=0){n=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=n,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break k}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break k;Z(i[e+8>>2])}if(t[k+11|0]>=0)break A;Z(i[k>>2])}if(t[f+51|0]>=0)break r;Z(i[f+40>>2]);break r}if((k|0)>=0)break f;Z(i[f+40>>2])}i[f+48>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,gi(f+16|0,i[e+64>>2],r,e+8|0,e+72|0,f+40|0,i[e+168>>2]),r=i[f+20>>2],e=i[f+16>>2],i[f+72>>2]=e,i[f+76>>2]=r,t[f+91|0]<0&&(Z(i[f+80>>2]),e=i[f+72>>2]),r=i[f+28>>2],i[f+80>>2]=i[f+24>>2],i[f+84>>2]=r,i[f+88>>2]=i[f+32>>2];f:{A:{if(e){if(e=i[f+76>>2],i[A>>2]=i[f+72>>2],i[A+4>>2]=e,e=A+8|0,t[f+91|0]<0)break A;r=i[f+84>>2],i[e>>2]=i[f+80>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+88>>2];break f}e=i[f+48>>2],i[f+48>>2]=0,r=i[f+44>>2],k=i[f+40>>2],t[A+20|0]=0,i[A+8>>2]=e,i[A>>2]=k,i[A+4>>2]=r;break r}T(e,i[f+80>>2],i[f+84>>2])}if(t[A+20|0]=1,A=i[f+40>>2],!A)break r;i[f+44>>2]=A,Z(A)}if(t[f+91|0]<0&&Z(i[f+80>>2]),t[f+67|0]>=0)break e;Z(i[f+56>>2])}if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o)}v=f+96|0}function _A(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0,X0=0,V0=0,C0=0,r0=0,f0=0,M0=0,z0=0,j0=0,S0=0,q0=0,r2=0,f2=0,A2=0,s2=0,v2=0,Z2=0,X2=0,R2=0,D2=0,c2=0,f1=0,o1=0,u1=0,y1=0,a1=0,d1=0,u4=0;i:{e:{V=i[A+276>>2],S0=(f|0)<(V|0)?f:V;r:{if((S0|0)<=(r|0)||(f=i[A+272>>2],q0=(f|0)>(k|0)?k:f,(q0|0)<=0))break r;for(U=i[A+124>>2],z0=i[U+16856>>2],Z2=z0<<(e^1),j0=i[U+16852>>2],X2=j0<<e,R2=A+4|0,D2=3-z0|0,c2=3-j0|0,o=-1<<i[U+16840>>2]^-1,_=i[A+44>>2],x=g(_,3),j=_<<1,f1=3-_|0,o1=2-_|0,u1=1-_|0,y1=0-_|0;;){for(r2=r<<D2,_0=g(r2,z0),f2=_0-1|0,a1=(_0|0)/4|0,g0=0;;){if(X0=g0<<c2,V0=g(j0,X0),f=u[(i[A+260>>2]+((V0|0)/4|0)|0)+g(i[A+272>>2],a1)|0]&3,f>>>0>1)for(d1=X0-_|0,A2=V0-1|0,n=1,u4=(f<<1)-2|0,f=1;;){k=g(i[A+44>>2],r2),l=i[(f<<2)+R2>>2],s=k+(l+X0|0)|0;f:{if(!e){V=k+d1|0,f=V+l|0,N=f+3|0,E=f+1|0,k=l+(k+X0|0)|0,O=k+3|0,w=k+2|0,m=k+1|0,G=l+(V-_|0)|0,q=G+3|0,d=G+2|0,c=G+1|0,I=k+_|0,A0=I+3|0,t0=I+2|0,Y=I+1|0,V=f+2|0;break f}O=s+x|0,w=s+j|0,m=s+_|0,G=s-2|0,q=x+G|0,I=s+1|0,A0=x+I|0,d=G+j|0,t0=I+j|0,c=_+G|0,Y=_+I|0,f=s-1|0,N=x+f|0,E=f+_|0,k=s,V=f+j|0}if(S=i[A+168>>2],B=V0>>S,(B|0)<0||(R=i[A+172>>2],(R|0)<=(B|0)))break e;if(l=_0>>S,(l|0)<0||(Q=i[A+176>>2],(Q|0)<=(l|0)))break i;s2=u[q|0],v2=u[d|0],q=u[c|0],d=u[G|0],C0=u[N|0],r0=u[V|0],f0=u[E|0],M0=u[f|0],c=u[A0|0],A0=u[t0|0],t0=u[Y|0],Y=u[I|0],O=u[O|0],G=u[w|0],I=u[m|0],N=u[k|0],V=n,k=i[i[A+132>>2]+(n?32:36)>>2],w=i[A+160>>2],m=w+g(B,3)|0,B=g(g(l,R),3),E=m+B|0,l=t[E+2|0];f:{if(!e){if(n=f2>>S,(n|0)<0|(n|0)>=(Q|0))break i;f=(m+g(g(n,R),3)|0)+2|0;break f}if(n=A2>>S,(n|0)<0|n>>>0>=R>>>0)break e;f=(B+(w+g(n,3)|0)|0)+2|0}f=k+((l+t[f|0]|0)+1>>1)|0;f:{if(i[U+16848>>2]!=1){f=(f|0)>=51?51:f;break f}if((f|0)<30)break f;if(f>>>0<=42){f=i[(f<<2)+69640>>2];break f}f=f-6|0}if(n=i[A+148>>2],l=V0>>n,(l|0)<0||(k=i[A+152>>2],(k|0)<=(l|0)))break e;if(n=_0>>n,(n|0)<0|(n|0)>=i[A+156>>2])break i;f=i[i[i[A+52>>2]+(p[((i[A+140>>2]+g(l,24)|0)+g(g(k,n),24)|0)+2>>1]<<2)>>2]+768>>2]+(f+u4|0)|0,f=(f|0)>=53?53:f,h=u[((f|0)>0?f:0)+66736|0]<<i[U+16840>>2]-8,l=u[U+8812|0];f:{A:{if(!e){if(B=f2>>S,l){if((B|0)<0|(B|0)>=(Q|0))break i;n=!(u[(m+g(g(B,R),3)|0)+1|0]&4)}else n=1;if((B|0)<0|(B|0)>=(Q|0))break i;if(w=0-h|0,f=(((N-M0<<2)+d|0)-Y|0)+4>>3,k=(f|0)<(w|0)?w:(f|0)<(h|0)?f:h,f=u[E|0]|u[E+1|0]<<8,l=!(f&2048)&(!l|!(f&1024)),n=n&!(u[(m+g(g(B,R),3)|0)+1|0]&8),n&&(f=k+M0|0,t[s+y1|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),l&&(f=N-k|0,t[s|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),f=(((I-f0<<2)+q|0)-t0|0)+4>>3,k=(f|0)<(w|0)?w:(f|0)<(h|0)?f:h,n&&(f=k+f0|0,t[s+u1|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),l&&(f=I-k|0,t[s+1|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),f=(((G-r0<<2)+v2|0)-A0|0)+4>>3,k=(f|0)<(w|0)?w:(f|0)<(h|0)?f:h,n&&(f=k+r0|0,t[s+o1|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),l&&(f=G-k|0,t[s+2|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),f=(((O-C0<<2)+s2|0)-c|0)+4>>3,f=(f|0)<(w|0)?w:(f|0)<(h|0)?f:h,n&&(k=f+C0|0,t[s+f1|0]=(k|0)>=0?(k|0)<(o|0)?k:o:0),!l)break f;k=3;break A}if(m=A2>>S,l){if((m|0)<0|m>>>0>=R>>>0)break e;n=!(u[(B+(w+g(m,3)|0)|0)+1|0]&4)}else n=1;if((m|0)<0|m>>>0>=R>>>0)break e;if(Q=0-h|0,f=(((N-M0<<2)+d|0)-Y|0)+4>>3,k=(f|0)<(Q|0)?Q:(f|0)<(h|0)?f:h,f=u[E|0]|u[E+1|0]<<8,Y=!(f&2048)&(!l|!(f&1024)),l=s-1|0,n=n&!(u[(B+(w+g(m,3)|0)|0)+1|0]&8),n&&(f=k+M0|0,t[l|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),Y&&(f=N-k|0,t[s|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),f=(((I-f0<<2)+q|0)-t0|0)+4>>3,k=(f|0)<(Q|0)?Q:(f|0)<(h|0)?f:h,n&&(f=k+f0|0,t[l+_|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),Y&&(f=I-k|0,t[s+_|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),f=(((G-r0<<2)+v2|0)-A0|0)+4>>3,k=(f|0)<(Q|0)?Q:(f|0)<(h|0)?f:h,n&&(f=k+r0|0,t[l+j|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),Y&&(f=G-k|0,t[s+j|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0),f=(((O-C0<<2)+s2|0)-c|0)+4>>3,f=(f|0)<(Q|0)?Q:(f|0)<(h|0)?f:h,n&&(k=f+C0|0,t[l+x|0]=(k|0)>=0?(k|0)<(o|0)?k:o:0),!Y)break f;k=x}f=O-f|0,t[k+s|0]=(f|0)>=0?(f|0)<(o|0)?f:o:0}if(f=2,n=0,!V)break}if(g0=g0+X2|0,!((q0|0)>(g0|0)))break}if(r=r+Z2|0,!((S0|0)>(r|0)))break}}return}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function Dm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0;f=v-32|0,v=f;i:{e:{r:{if(K0(i[r>>2],3)>>>0<9||K0(i[r>>2],4)>>>0<9)break r;if(K0(i[r>>2],5)>>>0>8)break e}e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;r:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break r}T(e,i[28735],i[28736])}t[A+20|0]=1;break i}s=$2(i[r>>2],6),n=u[k+8|0];e:{if(!s)break e;if(K0(i[r>>2],6)>>>0<=8){e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;r:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break r}T(e,i[28735],i[28736])}t[A+20|0]=1;break i}if((V8(i[r>>2],6)|0)==(V8(i[r>>2],4)|0)&&(p8(i[r>>2],6)|0)==(p8(i[r>>2],4)|0))break e;e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;r:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break r}T(e,i[28735],i[28736])}t[A+20|0]=1;break i}if(k=K0(i[r>>2],3),!k){e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;e:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break e}T(e,i[28735],i[28736])}t[A+20|0]=1;break i}_=C(248),e=_,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=101168,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,I=e+12|0,i[e+176>>2]=I,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e)),e=i[r>>2],o=i[e+188>>2],m=i[e+192>>2],G=n|s,t1(I,o,m,1,G&1?13:12),a0(f+8|0,I,10,o,m,k,l,0);e:{if(i[f+8>>2]){if(e=i[f+12>>2],i[A>>2]=i[f+8>>2],i[A+4>>2]=e,e=A+8|0,t[f+27|0]>=0){r=i[f+20>>2],i[e>>2]=i[f+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+24>>2],t[A+20|0]=1;break e}if(T(e,i[f+16>>2],i[f+20>>2]),e=t[f+27|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[f+16>>2]);break e}t[f+27|0]<0&&Z(i[f+16>>2]),e=Q0(i[r>>2],3),e?(N=i[e+40>>2],e=i[e+52>>2]>>>1|0):e=0,n=Q0(i[r>>2],4),n?(U=i[n+52>>2]>>>1|0,n=i[n+40>>2]):n=0,l=Q0(i[r>>2],5),l?(x=i[l+40>>2],E=i[l+52>>2]>>>1|0):E=0,l=Q0(I,10),l?(j=i[l+52>>2],R=i[l+40>>2]):R=0,l=0;r:{if(s){if(r=Q0(i[r>>2],6),!r||(B=i[r+40>>2],!B))break r;l=i[r+52>>2]}f:{if(!m|!o)break f;if(r=G&1,G=r?8:6,!r){for(r=0;;){for(B=g(r,j)+R|0,Q=(g(r,E)<<1)+x|0,V=(g(r,U)<<1)+n|0,Y=(g(e,r)<<1)+N|0,k=0;s=k<<1,h=p[s+Y>>1],w=p[s+V>>1],l=B+g(k,G)|0,s=p[s+Q>>1],t[l+5|0]=s,t[l+3|0]=w,t[l+1|0]=h,t[l+4|0]=s>>>8,t[l+2|0]=w>>>8,t[l|0]=h>>>8,k=k+1|0,(o|0)!=(k|0););if(r=r+1|0,(m|0)==(r|0))break}break f}if(r=0,s){for(Q=l>>>1|0;;){for(V=g(r,j)+R|0,Y=(g(r,Q)<<1)+B|0,O=(g(r,E)<<1)+x|0,S=(g(r,U)<<1)+n|0,d=(g(e,r)<<1)+N|0,k=0;s=k<<1,h=p[s+d>>1],w=p[s+S>>1],l=V+g(k,G)|0,q=p[s+O>>1],t[l+5|0]=q,t[l+3|0]=w,t[l+1|0]=h,t[l+4|0]=q>>>8,t[l+2|0]=w>>>8,t[l|0]=h>>>8,s=p[s+Y>>1],s=s<<8|s>>>8,t[l+6|0]=s,t[l+7|0]=s>>>8,k=k+1|0,(o|0)!=(k|0););if(r=r+1|0,(m|0)==(r|0))break}break f}for(B=-1<<k^-1,Q=(B&65280)>>>8|0;;){for(V=g(r,j)+R|0,Y=(g(r,E)<<1)+x|0,O=(g(r,U)<<1)+n|0,S=(g(e,r)<<1)+N|0,k=0;l=k<<1,s=p[l+S>>1],h=p[l+O>>1],w=p[l+Y>>1],l=V+g(k,G)|0,t[l+7|0]=B,t[l+6|0]=Q,t[l+5|0]=w,t[l+3|0]=h,t[l+1|0]=s,t[l+4|0]=w>>>8,t[l+2|0]=h>>>8,t[l|0]=s>>>8,k=k+1|0,(o|0)!=(k|0););if(r=r+1|0,(m|0)==(r|0))break}}t[A+20|0]=0,i[A+4>>2]=_,i[A>>2]=I;break i}h6(A,114932)}if(A=i[_+4>>2],i[_+4>>2]=A-1,A)break i;W[i[i[_>>2]+8>>2]](_),y(_)}v=f+32|0}function BA(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0;i:{e:{n=i[A+276>>2],U=(f|0)<(n|0)?f:n;r:{if((U|0)<=(r|0)||(f=i[A+272>>2],x=(f|0)>(k|0)?k:f,(x|0)<=0))break r;for(S=e?16:32,q=e?80:160,d=e?1:2,c=e?2:1,A0=e-1|0,t0=0-e|0;;){for(V=r<<2,Y=A0+V|0,j=V>>2,f=0;;){f:{A:{k:{if(k=f<<2,O=k>>2,_=(O+i[A+260>>2]|0)+g(i[A+272>>2],j)|0,o=u[_|0],o&q){if(n=k+t0|0,e=i[A+168>>2],s=n>>e,(s|0)<0||(l=i[A+172>>2],(l|0)<=(s|0)))break e;if(h=Y>>e,(h|0)<0||(w=i[A+176>>2],(w|0)<=(h|0)))break i;if(B=k>>e,(B|0)<0|l>>>0<=B>>>0)break e;if(m=V>>e,(m|0)<0|(w|0)<=(m|0))break i;e=2,w=g(s,3),s=i[A+160>>2],h=(w+s|0)+g(g(l,h),3)|0;n:{if(!((u[h|0]|u[h+1|0]<<8)&768)||(l=(s+g(B,3)|0)+g(g(l,m),3)|0,!((u[l|0]|u[l+1|0]<<8)&768)))break n;if(o&S){if(l=i[A+248>>2],h=k>>l,(h|0)<0||(s=i[A+252>>2],(s|0)<=(h|0)))break e;if(B=V>>l,(B|0)<0||(m=i[A+256>>2],(m|0)<=(B|0)))break i;if(e=1,w=i[A+240>>2],t[(w+h|0)+g(s,B)|0]<0)break n;if(h=n>>l,(h|0)<0|s>>>0<=h>>>0)break e;if(l=Y>>l,(l|0)<0|(l|0)>=(m|0))break i;if(t[(h+w|0)+g(l,s)|0]<0)break n}if(e=i[A+188>>2],h=n>>e,(h|0)<0||(l=i[A+192>>2],(l|0)<=(h|0)))break e;if(B=Y>>e,(B|0)<0||(s=i[A+196>>2],(s|0)<=(B|0)))break i;if(m=k>>e,(m|0)<0|l>>>0<=m>>>0)break e;if(w=V>>e,(w|0)<0|(s|0)<=(w|0))break i;if(e=n,n=i[A+148>>2],G=e>>n,(G|0)<0||(s=i[A+152>>2],(s|0)<=(G|0)))break e;if(I=Y>>n,(I|0)<0||(E=i[A+156>>2],(E|0)<=(I|0)))break i;if(e=0,Q=i[A+52>>2],R=i[A+56>>2]-Q>>2,N=g(G,24),G=i[A+140>>2],I=p[((N+G|0)+g(g(s,I),24)|0)+2>>1],R>>>0>I>>>0&&(e=i[Q+(I<<2)>>2]),k=k>>n,(k|0)<0|k>>>0>=s>>>0)break e;if(n=V>>n,(n|0)<0|(n|0)>=(E|0))break i;if(k=p[((G+g(k,24)|0)+g(g(n,s),24)|0)+2>>1],k>>>0>=R>>>0){e=0;break n}if(!e){e=0;break n}if(G=i[Q+(k<<2)>>2],!G){e=0;break n}if(n=i[A+180>>2],k=(n+g(h,12)|0)+g(g(l,B),12)|0,h=t[k+2|0],(h|0)>16||(I=t[k+3|0],(I|0)>16)||(n=(n+g(m,12)|0)+g(g(l,w),12)|0,w=t[n+2|0],(w|0)>16)||(Q=t[n+3|0],(Q|0)>16))break A;if(s=-1,o=-1,m=u[k|0],o=m?i[((h<<2)+e|0)+924>>2]:o,B=u[k+1|0],s=B?i[((I<<2)+e|0)+988>>2]:s,_=-1,l=-1,h=u[n|0],l=h?i[(G+(w<<2)|0)+924>>2]:l,w=u[n+1|0],_=w?i[(G+(Q<<2)|0)+988>>2]:_,!((o|0)==(l|0)&(_|0)==(s|0))&&(e=1,(o|0)!=(_|0)|(l|0)!=(s|0)))break n;e=p[n+8>>1],G=p[n+10>>1],I=p[n+4>>1],n=p[n+6>>1],Q=p[k+8>>1],E=p[k+10>>1],R=p[k+4>>1],N=p[k+6>>1],(B+m|0)!=(h+w|0)&&(C2(i[A+112>>2]+4|0,1013,0),t[A+312|0]=3),e=w?e:0,k=w?G:0,w=h?I:0,n=h?n:0,h=B?Q:0,B=B?E:0,G=m?R:0,m=m?N:0;t:{if((o|0)!=(s|0)){if(s=G<<16>>16,(o|0)!=(l|0)){if(o=s-(e<<16>>16)|0,e=o>>31,(e^o)-e>>>0>3||(k=(m<<16>>16)-(k<<16>>16)|0,e=k>>31,(e^k)-e>>>0>3)||(k=(h<<16>>16)-(w<<16>>16)|0,e=k>>31,(e^k)-e>>>0>3)||(e=0,n=(B<<16>>16)-(n<<16>>16)|0,k=n>>31,(k^n)-k>>>0>=4))break t;break n}if(l=s-(w<<16>>16)|0,o=l>>31,(o^l)-o>>>0>3||(o=(m<<16>>16)-(n<<16>>16)|0,n=o>>31,(n^o)-n>>>0>3)||(n=(h<<16>>16)-(e<<16>>16)|0,e=n>>31,(e^n)-e>>>0>3)||(e=0,n=(B<<16>>16)-(k<<16>>16)|0,k=n>>31,(k^n)-k>>>0>=4))break t;break n}if((l|0)!=(_|0))break k;l=G<<16>>16,s=w<<16>>16,_=l-s|0,o=_>>31;o:{if((o^_)-o>>>0>3||(_=(m<<16>>16)-(n<<16>>16)|0,o=_>>31,(o^_)-o>>>0>3)||(_=(h<<16>>16)-(e<<16>>16)|0,o=_>>31,(o^_)-o>>>0>3)||(_=(B<<16>>16)-(k<<16>>16)|0,o=_>>31,(o^_)-o>>>0>=4))break o;e=0;break n}if(o=l-(e<<16>>16)|0,e=o>>31,(e^o)-e>>>0>3||(k=(m<<16>>16)-(k<<16>>16)|0,e=k>>31,(e^k)-e>>>0>3)||(k=(h<<16>>16)-s|0,e=k>>31,(e^k)-e>>>0>3))break t;if(e=0,n=(B<<16>>16)-(n<<16>>16)|0,k=n>>31,(k^n)-k>>>0<4)break n}e=1}k=(i[A+260>>2]+O|0)+g(i[A+272>>2],j)|0,t[k|0]=u[k|0]&252|e;break f}t[_|0]=o&252;break f}U0(23572,19957,355,11788),M()}t[_|0]=o&252}if(f=f+c|0,!((x|0)>(f|0)))break}if(r=r+d|0,!((U|0)>(r|0)))break}}return}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function Um(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;k=v-192|0,v=k,S2(k+172|0,e,r),t[k+191|0]<0&&Z(i[k+180>>2]);i:{if(u[e+97|0]){B1(A,e,4853);break i}if(o=F0(r),n=i[f+80>>2],!(!n|o>>>0<=n>>>0)){if(e=C(64),i[k+24>>2]=e,i[k+28>>2]=61,i[k+32>>2]=-2147483584,r=u[18943]|u[18944]<<8|(u[18945]<<16|u[18946]<<24),f=u[18939]|u[18940]<<8|(u[18941]<<16|u[18942]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+61|0]=0,r=u[18996]|u[18997]<<8|(u[18998]<<16|u[18999]<<24),f=u[18992]|u[18993]<<8|(u[18994]<<16|u[18995]<<24),t[e+53|0]=f,t[e+54|0]=f>>>8,t[e+55|0]=f>>>16,t[e+56|0]=f>>>24,t[e+57|0]=r,t[e+58|0]=r>>>8,t[e+59|0]=r>>>16,t[e+60|0]=r>>>24,r=u[18991]|u[18992]<<8|(u[18993]<<16|u[18994]<<24),f=u[18987]|u[18988]<<8|(u[18989]<<16|u[18990]<<24),t[e+48|0]=f,t[e+49|0]=f>>>8,t[e+50|0]=f>>>16,t[e+51|0]=f>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[18983]|u[18984]<<8|(u[18985]<<16|u[18986]<<24),f=u[18979]|u[18980]<<8|(u[18981]<<16|u[18982]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[18975]|u[18976]<<8|(u[18977]<<16|u[18978]<<24),f=u[18971]|u[18972]<<8|(u[18973]<<16|u[18974]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[18967]|u[18968]<<8|(u[18969]<<16|u[18970]<<24),f=u[18963]|u[18964]<<8|(u[18965]<<16|u[18966]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[18959]|u[18960]<<8|(u[18961]<<16|u[18962]<<24),f=u[18955]|u[18956]<<8|(u[18957]<<16|u[18958]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[18951]|u[18952]<<8|(u[18953]<<16|u[18954]<<24),f=u[18947]|u[18948]<<8|(u[18949]<<16|u[18950]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,1e3,k+24|0),t[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(D4(A,e+116|0,o<<3,f,14852),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),f=e+104|0;e:{r:{f:{l=i[e+104>>2],n=i[e+108>>2]-l>>3;A:{k:{if(n>>>0<o>>>0){fi(f,o-n|0);break k}if(o>>>0<n>>>0&&(i[e+108>>2]=l+(o<<3)),!o)break A}for(e=0;;){if(!i[r+16>>2]){i[k+116>>2]=0,i[k+88>>2]=78164,i[k+32>>2]=78144,r=i[19545],i[k+24>>2]=r,f=i[r-12>>2],r=k+24|0,i[f+r>>2]=i[19546],i[k+28>>2]=0,f=r+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(f,n),t[f+80|0]=0,i[f+72>>2]=0,f=i[19547],i[k+32>>2]=f,l=k+32|0,i[l+i[f-12>>2]>>2]=i[19548],f=i[19544],i[k+24>>2]=f,i[r+i[f-12>>2]>>2]=i[19549],i[k+88>>2]=78164,i[k+24>>2]=78124,i[k+32>>2]=78144,f=R0(n),i[f>>2]=77200,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,F(B0(F(B0(F(l,31587,24),o),32551,33),e),6019,8),e=i[k+84>>2];k:{if(e&16){r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0&&(i[k+80>>2]=e,r=e),e=k+56|0;break k}if(!(e&8)){r=0,t[k+23|0]=0,e=k+12|0;break e}r=i[k+52>>2],e=k+44|0}if(o=i[e>>2],r=r-o|0,r>>>0>=2147483640)break f;if(r>>>0>=11){n=r|7,e=C(n+1|0),i[k+20>>2]=n-2147483647,i[k+12>>2]=e,i[k+16>>2]=r;break r}if(t[k+23|0]=r,e=k+12|0,r)break r;r=0;break e}if(n=F0(r),l=F0(r),s=i[f>>2]+(e<<3)|0,i[s+4>>2]=l,i[s>>2]=n,e=e+1|0,(o|0)==(e|0))break}}if(u[r+20|0]==1){if(t[k+24|0]=0,t[k+35|0]=0,a(A,2,100,k+24|0),t[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}I0(),M()}if(!r)break e;z(e,o,r)}t[e+r|0]=0,a(A,2,100,k+12|0),t[k+23|0]<0&&Z(i[k+12>>2]),A=i[19543],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[19551],i[k+32>>2]=i[19552],i[f>>2]=77200,t[k+79|0]<0&&Z(i[k+68>>2]),y0(f),Y0(k+88|0)}v=k+192|0}function Mm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0;l=v-16|0,v=l,i[l+12>>2]=e,i[k>>2]=0,s=i[f+28>>2],i[l>>2]=s,(s|0)!=136824&&(i[s+4>>2]=i[s+4>>2]+1),s=$0(l,137008),i2(l);i:{e:{r:{f:switch(o-65|0){case 0:case 32:Fs(A,n+24|0,l+12|0,r,k,s);break e;case 1:case 33:case 39:Vs(A,n+16|0,l+12|0,r,k,s);break e;case 34:e=W[i[i[A+8>>2]+12>>2]](A+8|0)|0,o=A,h=i[l+12>>2],u[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,u[e+11|0]>>>7|0?A=i[e>>2]:A=e,u[e+11|0]>>>7|0?e=i[e+4>>2]:e=u[e+11|0]&127,w=l,_=k6(o,h,r,f,k,n,s,A+e|0),i[w+12>>2]=_;break e;case 35:case 36:A=H8(l+12|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>30|e&4)){i[n+12>>2]=A;break A}i[k>>2]=e|4}break e;case 3:i[l>>2]=623865125,i[l+4>>2]=2032480100,w=l,_=k6(A,e,r,f,k,n,l,l+8|0),i[w+12>>2]=_;break e;case 5:i[l>>2]=623728933,i[l+4>>2]=1680158061,w=l,_=k6(A,e,r,f,k,n,l,l+8|0),i[w+12>>2]=_;break e;case 7:A=H8(l+12|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>23|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 8:A=H8(l+12|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>11|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 41:A=H8(l+12|0,r,k,s,3),e=i[k>>2];A:{if(!((A|0)>365|e&4)){i[n+28>>2]=A;break A}i[k>>2]=e|4}break e;case 44:e=H8(l+12|0,r,k,s,2)-1|0,A=i[k>>2];A:{if(!(e>>>0>11|A&4)){i[n+16>>2]=e;break A}i[k>>2]=A|4}break e;case 12:A=H8(l+12|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>59|e&4)){i[n+4>>2]=A;break A}i[k>>2]=e|4}break e;case 45:case 51:for(A=l+12|0,e=v-16|0,v=e,i[e+12>>2]=r;;){A:{if(d2(A,e+12|0))break A;r=i[A>>2],f=i[r+12>>2];k:{if((f|0)==i[r+16>>2]){r=W[i[i[r>>2]+36>>2]](r)|0;break k}r=t[f|0]}if(r=r<<24>>24,(r|0)>=0?r=i[i[s+8>>2]+(r<<2)>>2]&1:r=0,!r)break A;A4(A);continue}break}d2(A,e+12|0)&&(i[k>>2]=i[k>>2]|2),v=e+16|0;break e;case 47:o=l+12|0,e=W[i[i[A+8>>2]+8>>2]](A+8|0)|0;A:{if(u[e+11|0]>>>7|0){A=i[e+4>>2];break A}A=u[e+11|0]&127}u[e+23|0]>>>7|0?f=i[e+16>>2]:f=u[e+23|0]&127;A:{if((A|0)==(0-f|0)){i[k>>2]=i[k>>2]|4;break A}if(r=n3(o,r,e,e+24|0,s,k,0),A=i[n+8>>2],!((r|0)!=(e|0)|(A|0)!=12)){i[n+8>>2]=0;break A}(r-e|0)!=12|(A|0)>11||(i[n+8>>2]=A+12)}break e;case 49:o=u[83928]|u[83929]<<8|(u[83930]<<16|u[83931]<<24),t[l+7|0]=o,t[l+8|0]=o>>>8,t[l+9|0]=o>>>16,t[l+10|0]=o>>>24,o=u[83925]|u[83926]<<8|(u[83927]<<16|u[83928]<<24),i[l>>2]=u[83921]|u[83922]<<8|(u[83923]<<16|u[83924]<<24),i[l+4>>2]=o,w=l,_=k6(A,e,r,f,k,n,l,l+11|0),i[w+12>>2]=_;break e;case 17:t[l+4|0]=u[83936],i[l>>2]=u[83932]|u[83933]<<8|(u[83934]<<16|u[83935]<<24),w=l,_=k6(A,e,r,f,k,n,l,l+5|0),i[w+12>>2]=_;break e;case 18:A=H8(l+12|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>60|e&4)){i[n>>2]=A;break A}i[k>>2]=e|4}break e;case 19:i[l>>2]=624576549,i[l+4>>2]=1394948685,w=l,_=k6(A,e,r,f,k,n,l,l+8|0),i[w+12>>2]=_;break e;case 54:A=H8(l+12|0,r,k,s,1),e=i[k>>2];A:{if(!((A|0)>6|e&4)){i[n+24>>2]=A;break A}i[k>>2]=e|4}break e;case 55:A=W[i[i[A>>2]+20>>2]](A,e,r,f,k,n)|0;break i;case 23:e=W[i[i[A+8>>2]+24>>2]](A+8|0)|0,o=A,h=i[l+12>>2],u[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,u[e+11|0]>>>7|0?A=i[e>>2]:A=e,u[e+11|0]>>>7|0?e=i[e+4>>2]:e=u[e+11|0]&127,w=l,_=k6(o,h,r,f,k,n,s,A+e|0),i[w+12>>2]=_;break e;case 56:qs(n+20|0,l+12|0,r,k,s);break e;case 24:A=H8(l+12|0,r,k,s,4),u[k|0]&4||(i[n+20>>2]=A-1900);break e;default:if((o|0)==37)break r;break;case 2:case 4:case 6:case 9:case 10:case 11:case 13:case 14:case 15:case 16:case 20:case 21:case 22:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 37:case 38:case 40:case 42:case 43:case 46:case 48:case 50:case 52:case 53:break f}i[k>>2]=i[k>>2]|4;break e}A=v-16|0,v=A,i[A+12>>2]=r,r=l+12|0,n=A+12|0,e=6;r:{f:{if(d2(r,n))break f;e=i[r>>2],f=i[e+12>>2];A:{if((f|0)==i[e+16>>2]){f=W[i[i[e>>2]+36>>2]](e)|0;break A}f=t[f|0]}if(e=4,(W[i[i[s>>2]+36>>2]](s,f<<24>>24,0)|0)!=37)break f;if(!d2(A4(r),n))break r;e=2}i[k>>2]=e|i[k>>2]}v=A+16|0}A=i[l+12>>2]}return v=l+16|0,A|0}function tn(A,e,r,f){var k=0,n=0,o=0,l=0,s=0;k=v-112|0,v=k,i[k+88>>2]=0,i[k+92>>2]=0,i[k+104>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0;i:{if(!i[e+64>>2]){t[k+48|0]=0,t[k+59|0]=0,e=a(k- -64|0,2,110,k+48|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(t[k+59|0]>=0)break i;Z(i[k+48>>2]);break i}e:{r:{n=i[e+140>>2];f:{if(!n)break f;for(s=e+140|0,o=s;l=o0[n+16>>2]<r>>>0,o=l?o:n,n=i[(l?4:0)+n>>2],!!n;);if(l=0,(o|0)==(s|0)|o0[o+16>>2]>r>>>0)break f;if(n=i[o+20>>2],l=i[o+24>>2],l&&(i[l+4>>2]=i[l+4>>2]+1),n)break r}t[k+48|0]=0,t[k+59|0]=0,e=a(k- -64|0,5,2e3,k+48|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(t[k+59|0]>=0)break e;Z(i[k+48>>2]);break e}o=i[n+112>>2];r:{if(t[n+139|0]>=0){i[k+56>>2]=i[n+136>>2],s=i[n+132>>2],i[k+48>>2]=i[n+128>>2],i[k+52>>2]=s;break r}T(k+48|0,i[n+128>>2],i[n+132>>2])}r:{if((o|0)!=1835625829){f&&(i[f>>2]=0),n=0,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,gi(k- -64|0,i[e+64>>2],r,e+8|0,e+72|0,k+32|0,i[e+168>>2]);f:{if(i[k+64>>2]){if(e=i[k+68>>2],i[A>>2]=i[k+64>>2],i[A+4>>2]=e,e=A+8|0,t[k+83|0]>=0){r=i[k+76>>2],i[e>>2]=i[k+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+80>>2],n=1;break f}T(e,i[k+72>>2],i[k+76>>2]),n=1;break f}e=i[k+40>>2],i[k+40>>2]=0,r=i[k+32>>2],f=i[k+36>>2],i[k+32>>2]=0,i[k+36>>2]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=f}if(t[A+20|0]=n,t[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+32>>2],!A)break r;i[k+36>>2]=A,Z(A);break r}f:{if(t[n+151|0]>=0){i[k+40>>2]=i[n+148>>2],o=i[n+144>>2],i[k+32>>2]=i[n+140>>2],i[k+36>>2]=o;break f}T(k+32|0,i[n+140>>2],i[n+144>>2])}o=t[k+43|0],n=(o|0)<0;f:{A:{k:{n:switch((n?i[k+36>>2]:o)|0){case 0:f&&(i[f>>2]=0),n=0,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,gi(k- -64|0,i[e+64>>2],r,e+8|0,e+72|0,k+20|0,i[e+168>>2]);t:{if(i[k+64>>2]){if(e=i[k+68>>2],i[A>>2]=i[k+64>>2],i[A+4>>2]=e,e=A+8|0,t[k+83|0]>=0){r=i[k+76>>2],i[e>>2]=i[k+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+80>>2],n=1;break t}T(e,i[k+72>>2],i[k+76>>2]),n=1;break t}e=i[k+28>>2],i[k+28>>2]=0,r=i[k+20>>2],f=i[k+24>>2],i[k+20>>2]=0,i[k+24>>2]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=f}if(t[A+20|0]=n,t[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+20>>2],!A)break f;i[k+24>>2]=A,Z(A);break f;case 13:if(N2(n?i[k+32>>2]:k+32|0,20027,13))break k;n=4;break A;case 7:break n;default:break k}if(N2(n?i[k+32>>2]:k+32|0,13339,7))break k;n=3;break A}n=_r(k+32|0,8286)?5:2}i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,gi(k- -64|0,i[e+64>>2],r,e+8|0,e+72|0,k+20|0,i[e+168>>2]),r=i[k+68>>2],e=i[k+64>>2],i[k+88>>2]=e,i[k+92>>2]=r,t[k+107|0]<0&&(Z(i[k+96>>2]),e=i[k+88>>2]),r=i[k+76>>2],i[k+96>>2]=i[k+72>>2],i[k+100>>2]=r,i[k+104>>2]=i[k+80>>2];A:{if(e){e=i[k+92>>2],i[A>>2]=i[k+88>>2],i[A+4>>2]=e,e=A+8|0;k:{if(t[k+107|0]>=0){r=i[k+100>>2],i[e>>2]=i[k+96>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+104>>2];break k}T(e,i[k+96>>2],i[k+100>>2])}t[A+20|0]=1;break A}if(f){i[f>>2]=n,e=i[k+28>>2],i[k+28>>2]=0,r=i[k+20>>2],f=i[k+24>>2],i[k+20>>2]=0,t[A+20|0]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=f;break A}f=V2(k+8|0,47881),e=a(k- -64|0,3,3005,f),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;k:{if(t[e+19|0]>=0){n=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=n,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break k}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break k;Z(i[e+8>>2])}if(t[f+11|0]>=0)break A;Z(i[f>>2])}if(A=i[k+20>>2],!A)break f;i[k+24>>2]=A,Z(A)}if(t[k+43|0]>=0)break r;Z(i[k+32>>2])}if(t[k+59|0]>=0)break e;Z(i[k+48>>2])}if(!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break i;W[i[i[l>>2]+8>>2]](l),y(l)}t[k+107|0]<0&&Z(i[k+96>>2]),v=k+112|0}function on(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;f=v-96|0,v=f,i[f+56>>2]=0,i[f+60>>2]=0,o=f- -64|0,i[o>>2]=0,i[o+4>>2]=0,t[f+71|0]=0,t[f+72|0]=0,t[f+73|0]=0,t[f+74|0]=0,i[f+48>>2]=0,i[f+52>>2]=0,i[f+76>>2]=0,i[f+80>>2]=0,i[f+88>>2]=0,t[f+84|0]=1,i[f+32>>2]=0,W[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,f+32|0,0);i:{e:{r:{f:{A:{if(n=i[f+20>>2],!n)for(k=e+6|0;;){if(o=i[f+44>>2],!o||(n=u[o|0],Qn(k,o,i[f+40>>2]),Gr(f+48|0,i[f+44>>2],i[f+40>>2]),i[f+88>>2]=i[f+36>>2],o=i[r>>2],i[o>>2]<4|!i[o+136>>2]||(t[f+84|0]=i[f+32>>2]!=0),(n&120)==16))break A;if(i[f+32>>2]=0,W[i[o+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,f+32|0,0),n=i[f+20>>2],!!n)break}if(o=i[f+24>>2],k=i[f+28>>2],e=l2(k),e>>>0>=2147483640)break r;k:{n:{if(e>>>0>=11){s=e|7,r=C(s+1|0),i[f+16>>2]=s-2147483647,i[f+8>>2]=r,i[f+12>>2]=e;break n}if(t[f+19|0]=e,r=f+8|0,!e)break k}if(!e)break k;z(r,k,e)}if(t[e+r|0]=0,a(A,n,o,f+8|0),t[f+19|0]>=0)break f;Z(i[f+8>>2]);break f}A:{if(u[e+18|0]|u[e+5|0]!=1)break A;o=C(144),r=o,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96748,s=r+16|0,r=s,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=92500,r=o,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[s>>2]=104700,i[r+136>>2]=0,i[r+128>>2]=0,i[r+132>>2]=0,i[r+32>>2]=1635135811,n=u[k+4|0]|u[k+5|0]<<8|(u[k+6|0]<<16|u[k+7|0]<<24),l=u[k|0]|u[k+1|0]<<8|(u[k+2|0]<<16|u[k+3|0]<<24),t[r+113|0]=l,t[r+114|0]=l>>>8,t[r+115|0]=l>>>16,t[r+116|0]=l>>>24,t[r+117|0]=n,t[r+118|0]=n>>>8,t[r+119|0]=n>>>16,t[r+120|0]=n>>>24,k=u[k+8|0]|u[k+9|0]<<8|(u[k+10|0]<<16|u[k+11|0]<<24),t[r+121|0]=k,t[r+122|0]=k>>>8,t[r+123|0]=k>>>16,t[r+124|0]=k>>>24,i[r+4>>2]=i[r+4>>2]+1,k=i[f+52>>2],l=i[f+56>>2];k:{if(k>>>0<l>>>0){i[k+4>>2]=r,i[k>>2]=s,r=k+8|0;break k}if(n=i[f+48>>2],r=k-n|0,w=r>>3,k=w+1|0,k>>>0>=536870912)break e;if(l=l-n|0,h=l>>2,l=l>>>0>=2147483640?536870911:k>>>0<h>>>0?h:k,l){if(l>>>0>=536870912)break i;k=C(l<<3)}else k=0;if(h=k+r|0,i[h+4>>2]=o,i[h>>2]=s,s=h-(w<<3)|0,r&&z(s,n,r),i[f+56>>2]=k+(l<<3),r=h+8|0,i[f+52>>2]=r,i[f+48>>2]=s,!n)break k;Z(n)}if(i[f+52>>2]=r,t[e+18|0]=1,r=i[o+4>>2],i[o+4>>2]=r-1,r)break A;W[i[i[o>>2]+8>>2]](o),y(o)}t[f+73|0]=1,t[f+72|0]=u[e+68|0];A:{if(u[e+64|0]==1){if(o=i[e+20>>2],o){if(r=o,n=i[e+24>>2],(r|0)!=(n|0)){for(;;){r=i[n-4>>2];k:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break k;W[i[i[r>>2]+8>>2]](r),y(r)}if(n=n-8|0,(o|0)==(n|0))break}r=i[e+20>>2]}i[e+24>>2]=o,Z(r)}i[e+20>>2]=i[f+48>>2],i[e+24>>2]=i[f+52>>2],i[e+28>>2]=i[f+56>>2],i[f+56>>2]=0,i[f+48>>2]=0,i[f+52>>2]=0,r=i[e+32>>2],r&&(i[e+36>>2]=r,Z(r)),i[e+32>>2]=i[f+60>>2],i[e+36>>2]=i[f+64>>2],i[e+40>>2]=i[f+68>>2],i[f+68>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[e+60>>2]=i[f+88>>2],r=i[f+84>>2],i[e+52>>2]=i[f+80>>2],i[e+56>>2]=r,r=i[f+76>>2],i[e+44>>2]=i[f+72>>2],i[e+48>>2]=r;break A}i[e+20>>2]=i[f+48>>2],i[e+24>>2]=i[f+52>>2],i[e+28>>2]=i[f+56>>2],i[f+56>>2]=0,i[f+48>>2]=0,i[f+52>>2]=0,i[e+32>>2]=i[f+60>>2],i[e+36>>2]=i[f+64>>2],i[e+40>>2]=i[f+68>>2],i[f+68>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[e+60>>2]=i[f+88>>2],r=i[f+84>>2],i[e+52>>2]=i[f+80>>2],i[e+56>>2]=r,r=i[f+76>>2],i[e+44>>2]=i[f+72>>2],i[e+48>>2]=r,t[e+64|0]=1}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}if(A=i[f+60>>2],A&&(i[f+64>>2]=A,Z(A)),A=i[f+48>>2],A){if(r=A,n=i[f+52>>2],(r|0)!=(n|0)){for(;;){e=i[n-4>>2];f:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;W[i[i[e>>2]+8>>2]](e),y(e)}if(n=n-8|0,(A|0)==(n|0))break}r=i[f+48>>2]}i[f+52>>2]=A,Z(r)}v=f+96|0;return}I0(),M()}s0(),M()}x0(),M()}function Hm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;i:{for(f=A,A=0,o=v-32|0,v=o,s=e+100|0,Q=s,V=Q2(r),t[Q|0]=V,e=Q2(r),t[s+3|0]=e&31,t[s+1|0]=e>>>6,t[s+2|0]=e>>>5&1,Q=s,V=F0(r),i[Q+4>>2]=V,h=s+8|0;e=Q2(r),l=h+(A&-4)|0,n=i[l>>2],k=A<<3,n=(Q=n|1<<k,V=t2(-2,k)&n,Y=e<<24>>24<0,Y?Q:V),w=l,l=2<<k,n=e&64?l|n:n&(l^-1),l=4<<k,n=e&32?n|l:n&(l^-1),l=8<<k,n=e&16?n|l:n&(l^-1),l=16<<k,n=e&8?n|l:n&(l^-1),l=32<<k,n=e&4?n|l:n&(l^-1),l=64<<k,n=e&2?n|l:n&(l^-1),k=128<<k,i[w>>2]=e&1?n|k:n&(k^-1),A=A+1|0,(A|0)!=6;);Q=s,V=Q2(r),t[Q+16|0]=V,Q=s,V=w2(r)&4095,X[Q+18>>1]=V,Q=s,V=Q2(r)&3,t[Q+20|0]=V,Q=s,V=Q2(r)&3,t[Q+21|0]=V,Q=s,V=Q2(r)&7|8,t[Q+22|0]=V,Q=s,V=Q2(r)&7|8,t[Q+23|0]=V,Q=s,V=w2(r),X[Q+24>>1]=V,A=Q2(r),t[s+26|0]=A>>>6,t[s+29|0]=(A&3)+1,t[s+28|0]=A>>>2&1,t[s+27|0]=A>>>3&7;e:{r:{B=Q2(r);f:{A:{if(!B)break A;for(I=s+32|0;;){if(u[r+20|0])break A;A=Q2(r),_=0,i[o+28>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,t[o+17|0]=A&63,t[o+16|0]=A>>>6&1,m=w2(r);k:{n:{if(!m|t[r+20|0]&1)break n;for(;;){if(k=w2(r),k){e=0,A=0;t:{if(!w4(r,k))break t;e=C(k),k&&l0(e,0,k),A=e+k|0,h=i[r>>2],n=i[r+4>>2];o:{if(!n){if(!(W[i[i[h>>2]+16>>2]](h,e,k)|0))break o;break t}if(i[n+4>>2]=i[n+4>>2]+1,k=W[i[i[h>>2]+16>>2]](h,e,k)|0,h=i[n+4>>2],i[n+4>>2]=h-1,h||(W[i[i[n>>2]+8>>2]](n),y(n)),k)break t}A=C(32),i[o+4>>2]=A,i[o+8>>2]=28,i[o+12>>2]=-2147483616,k=u[2589]|u[2590]<<8|(u[2591]<<16|u[2592]<<24),n=u[2585]|u[2586]<<8|(u[2587]<<16|u[2588]<<24),t[A|0]=n,t[A+1|0]=n>>>8,t[A+2|0]=n>>>16,t[A+3|0]=n>>>24,t[A+4|0]=k,t[A+5|0]=k>>>8,t[A+6|0]=k>>>16,t[A+7|0]=k>>>24,t[A+28|0]=0,k=u[2609]|u[2610]<<8|(u[2611]<<16|u[2612]<<24),t[A+24|0]=k,t[A+25|0]=k>>>8,t[A+26|0]=k>>>16,t[A+27|0]=k>>>24,k=u[2605]|u[2606]<<8|(u[2607]<<16|u[2608]<<24),n=u[2601]|u[2602]<<8|(u[2603]<<16|u[2604]<<24),t[A+16|0]=n,t[A+17|0]=n>>>8,t[A+18|0]=n>>>16,t[A+19|0]=n>>>24,t[A+20|0]=k,t[A+21|0]=k>>>8,t[A+22|0]=k>>>16,t[A+23|0]=k>>>24,k=u[2597]|u[2598]<<8|(u[2599]<<16|u[2600]<<24),n=u[2593]|u[2594]<<8|(u[2595]<<16|u[2596]<<24),t[A+8|0]=n,t[A+9|0]=n>>>8,t[A+10|0]=n>>>16,t[A+11|0]=n>>>24,t[A+12|0]=k,t[A+13|0]=k>>>8,t[A+14|0]=k>>>16,t[A+15|0]=k>>>24,a(f,2,100,o+4|0),t[o+15|0]<0&&Z(i[o+4>>2]),Z(e),n=0;break k}k=i[o+24>>2],l=i[o+28>>2];t:{if(k>>>0<l>>>0){i[k+8>>2]=A,i[k+4>>2]=A,i[k>>2]=e,A=k+12|0;break t}if(h=i[o+20>>2],k=k-h|0,n=((k|0)/12|0)+1|0,n>>>0>=357913942)break r;if(l=(l-h|0)/12|0,w=l<<1,w=l>>>0>=178956970?357913941:n>>>0<w>>>0?w:n,w){if(w>>>0>=357913942)break e;n=C(g(w,12))}else n=0;if(l=n+k|0,i[l+8>>2]=A,i[l+4>>2]=A,i[l>>2]=e,e=l+g((k|0)/-12|0,12)|0,k&&z(e,h,k),i[o+28>>2]=n+g(w,12),A=l+12|0,i[o+24>>2]=A,i[o+20>>2]=e,!h)break t;Z(h)}i[o+24>>2]=A}if(_=_+1|0,m>>>0<=_>>>0)break n;if(t[r+20|0]&1)break}}A=i[s+36>>2];n:{if(A>>>0<o0[s+40>>2]){e=p[o+16>>1],i[A+12>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,X[A>>1]=e,i[A+4>>2]=i[o+20>>2],i[A+8>>2]=i[o+24>>2],i[A+12>>2]=i[o+28>>2],i[o+28>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,A=A+16|0;break n}A=Tt(I,o+16|0)}i[s+36>>2]=A,n=1}if(k=i[o+20>>2],k){if(A=i[o+24>>2],e=k,(A|0)!=(k|0)){for(;e=A-12|0,h=i[e>>2],h&&(i[A-8>>2]=h,Z(h)),A=e,(k|0)!=(A|0););e=i[o+20>>2]}i[o+24>>2]=k,Z(e)}if(!n)break f;if(G=G+1|0,(B|0)==(G|0))break}}if(e=i[r+16>>2],e&&(A=i[r+8>>2],A&&(l4(A,e),e=i[r+16>>2]),A=i[r>>2],k=W[i[i[A>>2]+8>>2]](A)|0,s=h0,n=e,e=e+k|0,s=n>>>0>e>>>0?s+1|0:s,W[i[i[A>>2]+20>>2]](A,e,s)|0,i[r+16>>2]=0),u[r+20|0]==1){if(t[o+16|0]=0,t[o+27|0]=0,a(f,2,100,o+16|0),t[o+27|0]>=0)break f;Z(i[o+16>>2]);break f}if(A=i[28729],i[f>>2]=i[28728],i[f+4>>2]=A,A=f+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break f}T(A,i[28730],i[28731])}v=o+32|0;break i}s0(),M()}x0(),M()}}function ln(A){var e=0;i:{e:{r:{f:{A:{k:{n:{t:{o:{l:{u:{s:{h:{w:{_:{v:{B:{m:{g:{Z:{W:{X:{V:{I:{F:{Q:{p:{Y:{D:{U:{M:{J:{C:{y:{N:{E:{_0:{H:{z:{x:{R:{T:{j:{S:{O:{P:{L:{q:{a:{K:{$:{d:{b:{v0:{c:{m0:{i0:{e0:{r0:{f0:{A0:{k0:{n0:{t0:{o0:{l0:{Z0:{u0:{s0:{h0:{w0:{G:{g0:{G0:{W0:{X0:{I0:{Q0:{V0:{p0:{F0:{if((A|0)<=1999){e=18865;B0:switch(A|0){case 0:break e;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 17:case 18:case 19:case 20:case 21:case 22:case 23:case 24:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 32:case 33:case 34:case 35:case 36:case 37:case 38:case 39:case 40:case 41:case 42:case 43:case 44:case 45:case 46:case 47:case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:case 58:case 59:case 60:case 61:case 62:case 63:case 64:case 65:case 66:case 67:case 68:case 69:case 70:case 71:case 72:case 73:case 74:case 75:case 76:case 77:case 78:case 79:case 80:case 81:case 82:case 83:case 84:case 85:case 86:case 87:case 88:case 89:case 90:case 91:case 92:case 93:case 94:case 95:case 96:case 97:case 98:case 99:case 144:case 145:case 146:case 147:case 148:break r;case 108:break u0;case 109:break Z0;case 110:break l0;case 111:break o0;case 112:break t0;case 113:break n0;case 114:break A0;case 115:break f0;case 116:break r0;case 117:break e0;case 100:break F0;case 118:break V0;case 119:break Q0;case 120:break i0;case 121:break m0;case 122:break c;case 123:break v0;case 124:break b;case 125:break k0;case 126:break d;case 127:break $;case 101:break p0;case 128:break K;case 129:break a;case 130:break q;case 131:break w0;case 132:break L;case 133:break P;case 134:break O;case 135:break S;case 136:break j;case 137:break T;case 102:break I0;case 138:break R;case 139:break x;case 140:break z;case 141:break G;case 142:break N;case 143:break h0;case 149:break y;case 150:break H;case 151:break _0;case 152:break E;case 103:break X0;case 104:break W0;case 105:break G0;case 106:break g0;case 107:break s0;default:break B0}switch(A-1e3|0){case 0:break C;case 1:break J;default:break r}}if((A|0)<=3999){B0:switch(A-2e3|0){case 0:break M;case 1:break U;case 2:break D;case 3:break Y;case 4:break p;case 5:break Q;case 6:break F;case 7:break I;case 8:break V;default:break B0}switch(A-3e3|0){case 0:break X;case 1:break W;case 2:break Z;case 3:break g;case 4:break m;case 5:break B;case 6:break v;case 7:break _;case 8:break w;default:break r}}B0:switch(A-5e3|0){case 0:break h;case 1:break s;case 2:break u;case 3:break l;case 4:break o;default:break B0}switch(A-6e3|0){case 0:break t;case 1:break n;case 2:break k;case 3:break A;default:break f}}return 14439}return 12540}return 20580}return 6252}return 2670}return 2628}return 2816}return 2642}return 2858}return 2844}return 2886}return 2872}return 2712}return 2698}return 2830}return 2802}return 2760}return 2684}return 2774}return 2788}return 7695}return 1341}return 10384}return 20489}return 9261}return 20362}return 20769}return 18815}return 10316}return 13905}return 4741}return 8232}return 12736}return 2445}return 11759}return 6071}return 6583}return 4997}return 20506}return 1438}return 18606}return 18572}return 10608}return 9175}return 2614}return 16544}return 2656}return 2726}return 18915}return 7319}return 19443}return 17510}return 19265}return 17666}return 17616}return 7551}return 13151}return 1387}return 14704}return 19813}return 13932}return 9535}return 9341}return 17238}return 17275}return 17313}return 1271}return 13882}return 20383}return 10531}return 10554}return 10515}return 26896}return 19143}return 19098}return 5447}return 10001}if((A|0)==4e3)break i}e=i[25148]}return e}return 11737}function vA(){var A=0,e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;u[115884]||(t[115884]=1),e=i[28964],i[28964]=e+1;i:{if((e|0)>0||(N9(),H9()))break i;return i[28964]=i[28964]-1,0}A=C(3224),i[A+168>>2]=0,i[A+84>>2]=0,i[A>>2]=67224,i[A+384>>2]=1904,i[A+376>>2]=1905,i[A+360>>2]=1906,i[A+356>>2]=1907,i[A+352>>2]=1908,i[A+348>>2]=1909,i[A+344>>2]=1910,i[A+340>>2]=1911,i[A+336>>2]=1912,i[A+332>>2]=1913,i[A+328>>2]=1914,i[A+324>>2]=1915,i[A+320>>2]=1916,i[A+316>>2]=1917,i[A+312>>2]=1918,i[A+308>>2]=1919,i[A+304>>2]=1920,i[A+300>>2]=1921,i[A+296>>2]=1922,i[A+292>>2]=1922,i[A+288>>2]=1922,i[A+284>>2]=1923,i[A+280>>2]=1924,i[A+276>>2]=1925,i[A+272>>2]=1926,i[A+268>>2]=1927,i[A+264>>2]=1928,i[A+260>>2]=1929,i[A+256>>2]=1930,i[A+252>>2]=1931,i[A+248>>2]=1932,i[A+244>>2]=1933,i[A+240>>2]=1934,i[A+236>>2]=1935,i[A+232>>2]=1936,i[A+228>>2]=1937,i[A+224>>2]=1938,i[A+220>>2]=1939,i[A+216>>2]=1940,i[A+212>>2]=1940,i[A+208>>2]=1940,i[A+204>>2]=1941,i[A+200>>2]=1942,i[A+196>>2]=1943,i[A+192>>2]=1944,i[A+188>>2]=1945,i[A+184>>2]=1946,i[A+180>>2]=1947,i[A+176>>2]=1948,i[A+172>>2]=1949,i[A+372>>2]=1950,i[A+380>>2]=1951,i[A+364>>2]=1952,i[A+368>>2]=1953,i[A+388>>2]=1954,i[A+392>>2]=1955,i[A+396>>2]=1956,i[A+400>>2]=1957,i[A+404>>2]=1958,i[A+408>>2]=1959,i[A+412>>2]=1960,i[A+416>>2]=1961,i[A+420>>2]=1962,i[A+424>>2]=1963,i[A+428>>2]=1964,i[A+432>>2]=1965,i[A+456>>2]=1966,i[A+460>>2]=1967,i[A+468>>2]=1968,i[A+472>>2]=1969,i[A+464>>2]=1970,i[A+508>>2]=1971,i[A+504>>2]=1972,i[A+500>>2]=1973,i[A+496>>2]=1974,i[A+492>>2]=1975,i[A+488>>2]=1976,i[A+484>>2]=1977,i[A+480>>2]=1978,i[A+476>>2]=1979,i[A+452>>2]=1980,i[A+448>>2]=1981,i[A+444>>2]=1982,i[A+440>>2]=1983,i[A+436>>2]=1984,i[A>>2]=67248,i[A+552>>2]=0,i[A+556>>2]=0,X[A+548>>1]=0,i[A+560>>2]=0,i[A+564>>2]=0,i[A+568>>2]=0,i[A+572>>2]=0,i[A+576>>2]=0,i[A+580>>2]=0,i[A+584>>2]=0,i[A+588>>2]=0,i[A+592>>2]=0,i[A+596>>2]=0,e=A+1412|0,i[e>>2]=0,i[e+4>>2]=0,e=A+1404|0,i[e>>2]=0,i[e+4>>2]=0,i[A+1396>>2]=0,i[A+1400>>2]=0,l0(A+600|0,0,792),e=A+2140|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e>>2]=30,i[e+4>>2]=30,i[e+48>>2]=0,i[e+52>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[A+3216>>2]=0,i[A+3208>>2]=0,i[A+3212>>2]=0,X[A+532>>1]=0,t[A+514|0]=0,X[A+512>>1]=256,i[A+516>>2]=-1,i[A+520>>2]=-1,i[A+524>>2]=-1,i[A+528>>2]=-1,e=i[28569],r=i[28568],i[A+1368>>2]=0,i[A+544>>2]=0,i[A+536>>2]=r,i[A+540>>2]=e,e=i[A+1372>>2],i[A+1372>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+1380>>2],i[A+1376>>2]=0,i[A+1380>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+1388>>2],i[A+1384>>2]=0,i[A+1388>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}i[A+1892>>2]=100,i[A+1896>>2]=6,i[A+1884>>2]=0,i[A+1888>>2]=6,i[A+1900>>2]=100,i[A+1904>>2]=6,e=i[A+1376>>2];i:{e:{r:{if(e){e=t[e+2|0];break r}if(r=i[A+1368>>2],e=6,!r)break e;e=i[r+8>>2]}if((e|0)<=0)break i;e=e-1|0}for(_=A+2112|0,s=A+1908|0,h=e+1|0;;){r=g(e,100),n=(r+100|0)/(h|0)|0,f=(r|0)/(h|0)|0;e:{if((n|0)<(f|0)){r=e;break e}o=i[A+1888>>2];r:{if(f+n&1){r=e,e=f;break r}r=(f<<1)+s|0,t[r+1|0]=(e|0)>(o|0)?100:0,k=r,r=(e|0)<(o|0)?e:o,t[k|0]=r,e=f+1|0}if(k=e,(f|0)==(n|0))break e;for(w=n-f|0,e=r;l=(k<<1)+s|0,r=(e|0)<(o|0)?e:o,t[l|0]=r,t[l+1|0]=(e|0)>(o|0)?100:(g(k-f|0,100)|0)/(w|0)|0,l=k+1|0,e=(l<<1)+s|0,t[e+1|0]=(g(l-f|0,100)|0)/(w|0),t[e|0]=r,k=k+2|0,e=r,(n|0)!=(l|0););}if(i[(r<<2)+_>>2]=n,e=r-1|0,!((r|0)>0))break}}return i[A+2200>>2]=0,i[A+2204>>2]=0,i[A+2196>>2]=-1,e=A+2216|0,i[e>>2]=0,i[e+4>>2]=0,e=A+2208|0,i[e>>2]=0,i[e+4>>2]=0,t[A+2200|0]=1,A|0}function zm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;n=v-160|0,v=n,i[n+104>>2]=0,i[n+76>>2]=78164,i[n+20>>2]=78144,o=i[19545],i[n+12>>2]=o,h=n+12|0,i[h+i[o-12>>2]>>2]=i[19546],i[n+16>>2]=0,o=h+i[i[n+12>>2]-12>>2]|0,k=n+24|0,J0(o,k),t[o+80|0]=0,i[o+72>>2]=0,o=i[19547],i[n+20>>2]=o,_=n+20|0,i[_+i[o-12>>2]>>2]=i[19548],o=i[19544],i[n+12>>2]=o,i[h+i[o-12>>2]>>2]=i[19549],i[n+76>>2]=78164,i[n+12>>2]=78124,i[n+20>>2]=78144,B=R0(k),i[B>>2]=77200,o=n- -64|0,i[o>>2]=0,i[o+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,J2(n,e,r),k=t[n+11|0],o=(k|0)<0,F(_,o?i[n>>2]:n,o?i[n+4>>2]:k),t[n+11|0]<0&&Z(i[n>>2]),o=n,w=e+100|0,f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78164,i[f+8>>2]=78144,k=i[19545],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19546],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,h=f+12|0,J0(k,h),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[f+8>>2]=k,l=f+8|0,i[l+i[k-12>>2]>>2]=i[19548],k=i[19544],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19549],i[f+64>>2]=78164,i[f>>2]=78124,i[f+8>>2]=78144,m=R0(h),i[m>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,h=r,k=f+148|0,k0(k,r),s=k,k=t[f+159|0],r=(k|0)<0,F(l,r?i[f+148>>2]:s,r?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),l=F(B0(F(l,33154,22),p[w>>1]),47878,1),r=f+148|0,k0(r,h),s=r,k=t[f+159|0],r=(k|0)<0,F(l,r?i[f+148>>2]:s,r?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),l=F(B0(F(l,35150,7),p[w+16>>1]),47878,1),r=f+148|0,k0(r,h),s=r,k=t[f+159|0],r=(k|0)<0,F(l,r?i[f+148>>2]:s,r?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),l=F(B0(F(l,33388,8),p[w+18>>1]),47878,1),r=f+148|0,k0(r,h),s=r,k=t[f+159|0],r=(k|0)<0,F(l,r?i[f+148>>2]:s,r?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),l=F(t4(F(l,34386,19),+o0[w+20>>2]*152587890625e-16),47878,1),r=f+148|0,k0(r,h),s=r,k=t[f+159|0],r=(k|0)<0,F(l,r?i[f+148>>2]:s,r?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),l=F(t4(F(l,34406,18),+o0[w+24>>2]*152587890625e-16),47878,1),r=f+148|0,k0(r,h),s=r,k=t[f+159|0],r=(k|0)<0,F(l,r?i[f+148>>2]:s,r?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),l=F(B0(F(l,33268,13),p[w+28>>1]),47878,1),r=f+148|0,k0(r,h),s=r,k=t[f+159|0],r=(k|0)<0,F(l,r?i[f+148>>2]:s,r?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),s=F(l,36677,16),k=t[w+43|0],r=(k|0)<0,l=F(F(s,r?i[w+32>>2]:w+32|0,r?i[w+36>>2]:k),47878,1),r=f+148|0,k0(r,h),s=r,k=t[f+159|0],r=(k|0)<0,F(l,r?i[f+148>>2]:s,r?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(l,35073,7),p[w+44>>1]),47878,1),r=i[f+60>>2];i:{e:{if(r&16){r=i[f+56>>2],k=i[f+36>>2],r>>>0<k>>>0&&(i[f+56>>2]=k,r=k),k=f+32|0;break e}if(!(r&8)){r=0,t[o+11|0]=0;break i}r=i[f+28>>2],k=f+20|0}e:{if(w=i[k>>2],r=r-w|0,r>>>0<2147483640){if(r>>>0>=11){l=r|7,k=C(l+1|0),i[o+8>>2]=l-2147483647,i[o>>2]=k,i[o+4>>2]=r,o=k;break e}if(t[o+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(o,w,r)}t[r+o|0]=0,r=i[19543],i[f>>2]=r,i[i[r-12>>2]+f>>2]=i[19551],i[f+8>>2]=i[19552],i[m>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(m),Y0(f- -64|0),v=f+160|0,o=t[n+11|0],r=(o|0)<0,F(_,r?i[n>>2]:n,r?i[n+4>>2]:o),t[n+11|0]<0&&Z(i[n>>2]),A3(n,e,h,0),r=t[n+11|0],e=(r|0)<0,F(_,e?i[n>>2]:n,e?i[n+4>>2]:r),t[n+11|0]<0&&Z(i[n>>2]),e=i[n+72>>2];i:{e:{if(e&16){e=i[n+68>>2],r=i[n+48>>2],e>>>0<r>>>0&&(i[n+68>>2]=r,e=r),r=n+44|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[n+40>>2],r=n+32|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){o=e|7,r=C(o+1|0),i[A+8>>2]=o-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19543],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[19551],i[n+20>>2]=i[19552],i[B>>2]=77200,t[n+67|0]<0&&Z(i[n+56>>2]),y0(B),Y0(n+76|0),v=n+160|0}function xm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=78468,n=i[19620],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[19621],n=i[i[f>>2]-12>>2]+f|0,k=f+4|0,J0(n,k),t[n+80|0]=0,i[n+72>>2]=0,i[f+56>>2]=78468,i[f>>2]=78448,B=R0(k),i[B>>2]=77200,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,n=f+148|0,K1(n,e,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,k0(n,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(M2(F(f,37855,19),i[e+104>>2],i[e+108>>2]),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(M2(F(n,36644,19),i[e+112>>2],i[e+116>>2]),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(n,36759,11),i[e+120>>2]),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(M2(F(n,34538,10),i[e+128>>2],i[e+132>>2]),47878,1),n=f+148|0,k0(n,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(t4(F(f,36287,6),+o0[e+136>>2]*152587890625e-16),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(Il(F(n,36622,8),D(D(p[e+140>>1])*D(.00390625))),47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:o,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(n,46881,8),V=e+144|0;i:{for(;;){n=f+148|0,k0(n,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),F(f,37885,2),Y=g(m,3),n=0;e:{for(;;){k=f+140|0,l=n+Y|0,(l|0)!=8?G=+o0[(l<<2)+V>>2]*152587890625e-16:G=1,w=t4(f,G),I=X1(k,w);r:{if(u[I|0]!=1)break r;l=i[i[w>>2]-12>>2]+w|0,_=i[l+4>>2],h=i[l+24>>2];f:{if(u[l+80|0]==1){k=u[l+76|0]|u[l+77|0]<<8|(u[l+78|0]<<16|u[l+79|0]<<24);break f}o=f+148|0,k=i[l+28>>2],i[o>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(o,137008),k=W[i[i[k>>2]+28>>2]](k,32)|0,i2(o),t[l+76|0]=k,t[l+77|0]=k>>>8,t[l+78|0]=k>>>16,t[l+79|0]=k>>>24,t[l+80|0]=1}f:{if(!h||(s=i[l+12>>2],_=(_&176)==32?37887:37886,o=_-37886|0,(o|0)>0&&(W[i[i[h>>2]+48>>2]](h,37886,o)|0)!=(o|0)))break f;if((s|0)>=2){if(s>>>0>=2147483641)break e;o=((s|0)<=1?1:s)-1|0;A:{if(s>>>0>=12){Q=o|7,s=C(Q+1|0),i[f+156>>2]=Q-2147483647,i[f+148>>2]=s,i[f+152>>2]=o;break A}t[f+159|0]=o,s=f+148|0}if(o&&l0(s,k,o),t[o+s|0]=0,k=W[i[i[h>>2]+48>>2]](h,t[f+159|0]<0?i[f+148>>2]:f+148|0,o)|0,t[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(o|0))break f}if(k=37887-_|0,(k|0)>0&&(W[i[i[h>>2]+48>>2]](h,_,k)|0)!=(k|0))break f;i[l+12>>2]=0;break r}k=i[i[w>>2]-12>>2]+w|0,M1(k,i[k+16>>2]|5)}if(v1(I),n=n+1|0,(n|0)==3)break}if(F(f,47878,1),m=m+1|0,(m|0)==3)break i;continue}break}I0(),M()}n=f+148|0,k0(n,r),k=n,r=t[f+159|0],n=(r|0)<0,F(f,n?i[f+148>>2]:k,n?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f,37551,15),i[e+180>>2]),47878,1),e=i[f+52>>2];i:{e:{if(e&16){n=i[f+48>>2],e=i[f+28>>2],n>>>0<e>>>0&&(i[f+48>>2]=e,n=e),e=f+24|0;break e}if(!(e&8)){n=0,t[A+11|0]=0;break i}n=i[f+20>>2],e=f+12|0}e:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){k=n|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(t[A+11|0]=n,n)break e;n=0;break i}I0(),M()}if(!n)break i;z(A,r,n)}t[A+n|0]=0,A=i[19619],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19622],i[B>>2]=77200,t[f+47|0]<0&&Z(i[f+36>>2]),y0(B),Y0(f+56|0),v=f+160|0}function un(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0;if(k=i[A+124>>2],_=i[k+16876>>2],r=i[k+16872>>2],m=e<<_>>r,B=i[k+16896>>2],e=e+1<<_>>r,Y=(e|0)>(B|0)?B:e,(m|0)>=(Y|0))return 0;i:{e:{if(i[k+16888>>2]>0)for(E=-1<<_^-1,R=i[k+16892>>2],N=i[k+16880>>2],I=i[A+132>>2];;){if(i[k+16888>>2]>0)for(e=0,h=g(m,N),d=(h|0)!=0&!(h&E),B=h?32:0,U=g(h>>_,R),x=h-1|0,c=g(x>>_,R)<<2;;){r=(i[A+160>>2]+g(e,3)|0)+g(g(i[A+172>>2],m),3)|0,l=(u[r|0]|u[r+1|0]<<8)&7;r:{if(!l)break r;if(n=g(e,N),s=i[A+148>>2],r=n>>s,(r|0)<0||(w=i[A+152>>2],(w|0)<=(r|0)))break e;if(f=h>>s,(f|0)<0||(j=i[A+156>>2],(f|0)>=(j|0)))break i;if(Q=i[A+52>>2],V=i[A+56>>2]-Q>>2,G=i[A+140>>2],O=G+g(r,24)|0,S=g(g(f,w),24),r=p[(O+S|0)+2>>1],V>>>0<=r>>>0)return 0;q=n>>_,o=i[Q+(r<<2)>>2],f=n?16:0,r=f;f:{if(!n||(r=f,n&E))break f;A:{if(u[o+772|0])break A;if(r=n-1>>s,(r|0)<0|r>>>0>=w>>>0)break e;if(G=p[((g(r,24)+G|0)+S|0)+2>>1],G>>>0>=V>>>0)break A;if(r=0,i[o+808>>2]!=i[i[Q+(G<<2)>>2]+808>>2])break f}if(r=f,u[I+57|0])break f;f=U<<2,r=i[I+8484>>2],r=i[f+(r+(q<<2)|0)>>2]==i[f+(r+(n-1>>_<<2)|0)>>2]?16:0}f=r,r=B;f:{if(!d)break f;A:{if(u[o+772|0])break A;if(r=x>>s,(r|0)<0|(r|0)>=(j|0))break i;if(s=p[(g(g(r,w),24)+O|0)+2>>1],s>>>0>=V>>>0)break A;if(r=0,i[o+808>>2]!=i[i[Q+(s<<2)>>2]+808>>2])break f}if(r=B,u[I+57|0])break f;r=i[I+8484>>2]+(q<<2)|0,r=i[r+(U<<2)>>2]==i[r+c>>2]?32:0}if(u[o+762|0])break r;if(a6(A,n,h,l,0,f,r),r=i[A+168>>2],o=n>>r,(o|0)<0||(w=i[A+172>>2],(w|0)<=(o|0)))break e;if(s=h>>r,(s|0)<0|(s|0)>=i[A+176>>2])break i;r=1<<l,k=1<<l-2,f=1<<l-1;f:{A:{k:{n:{t:{o:{l:{u:switch(o=(i[A+160>>2]+g(o,3)|0)+g(g(s,w),3)|0,((u[o|0]|u[o+1|0]<<8)>>>3&7)-1|0){case 3:break l;case 4:break u;case 5:break t;case 6:break o;case 0:break n;case 1:break k;case 2:break A;default:break f}for(o=(r|0)<=1?1:r,f=(k+(f+h|0)|0)/4|0,r=0;k=(r+n|0)/4|0,l=i[A+272>>2],(k|0)>=(l|0)|(f|0)>=i[A+276>>2]||(k=(k+i[A+260>>2]|0)+g(f,l)|0,t[k|0]=u[k|0]|128),r=r+1|0,(o|0)!=(r|0););break f}for(o=(r|0)<=1?1:r,f=(k+h|0)/4|0,r=0;k=(r+n|0)/4|0,l=i[A+272>>2],(k|0)>=(l|0)|(f|0)>=i[A+276>>2]||(k=(k+i[A+260>>2]|0)+g(f,l)|0,t[k|0]=u[k|0]|128),r=r+1|0,(o|0)!=(r|0););break f}for(o=(r|0)<=1?1:r,f=(k+(f+n|0)|0)/4|0,r=0;k=i[A+272>>2],n=(r+h|0)/4|0,(k|0)<=(f|0)|(n|0)>=i[A+276>>2]||(n=(f+i[A+260>>2]|0)+g(k,n)|0,t[n|0]=u[n|0]|64),r=r+1|0,(o|0)!=(r|0););break f}for(o=(r|0)<=1?1:r,f=(k+n|0)/4|0,r=0;k=i[A+272>>2],n=(r+h|0)/4|0,(k|0)<=(f|0)|(n|0)>=i[A+276>>2]||(n=(f+i[A+260>>2]|0)+g(k,n)|0,t[n|0]=u[n|0]|64),r=r+1|0,(o|0)!=(r|0););break f}for(k=(r|0)<=1?1:r,f=(f+h|0)/4|0,r=0;o=(r+n|0)/4|0,l=i[A+272>>2],(o|0)>=(l|0)|(f|0)>=i[A+276>>2]||(o=(o+i[A+260>>2]|0)+g(f,l)|0,t[o|0]=u[o|0]|128),r=r+1|0,(k|0)!=(r|0););break f}for(k=(r|0)<=1?1:r,f=(f+n|0)/4|0,r=0;o=i[A+272>>2],n=(r+h|0)/4|0,(o|0)<=(f|0)|(n|0)>=i[A+276>>2]||(n=(f+i[A+260>>2]|0)+g(n,o)|0,t[n|0]=u[n|0]|64),r=r+1|0,(k|0)!=(r|0););break f}for(w=(r|0)<=1?1:r,o=(f+h|0)/4|0,l=(f+n|0)/4|0,r=0;f=i[A+276>>2],s=(r+h|0)/4|0,k=i[A+272>>2],(f|0)<=(s|0)|(l|0)>=(k|0)||(f=(l+i[A+260>>2]|0)+g(k,s)|0,t[f|0]=u[f|0]|64,k=i[A+272>>2],f=i[A+276>>2]),s=(r+n|0)/4|0,(f|0)<=(o|0)|(s|0)>=(k|0)||(f=(s+i[A+260>>2]|0)+g(k,o)|0,t[f|0]=u[f|0]|128),r=r+1|0,(w|0)!=(r|0););}k=i[A+124>>2],A0=1}if(e=e+1|0,!((e|0)<i[k+16888>>2]))break}if(m=m+1|0,(Y|0)==(m|0))break}return A0}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function D4(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0;n=v-160|0,v=n;i:{if(!f){if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731]);break i}e:{r:{f:{A:{k:{if(l=f,s=i[l+40>>2],o=i[l+44>>2],!(!(s|o)|(!o&r>>>0<=s>>>0|(o|0)!=0))){i[n+104>>2]=0,i[n+76>>2]=78164,i[n+20>>2]=78144,e=i[19545],i[n+12>>2]=e,o=i[e-12>>2],s=n+12|0,e=s,i[o+e>>2]=i[19546],i[n+16>>2]=0,e=e+i[i[n+12>>2]-12>>2]|0,l=n+24|0,J0(e,l),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[n+20>>2]=e,o=n+20|0,i[o+i[e-12>>2]>>2]=i[19548],e=i[19544],i[n+12>>2]=e,i[s+i[e-12>>2]>>2]=i[19549],i[n+76>>2]=78164,i[n+12>>2]=78124,i[n+20>>2]=78144,l=R0(l),i[l>>2]=77200,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,e=B0(F(o,31897,11),r);n:{if(k){e=F(F(F(e,31202,11),k,l2(k)),32080,31);break n}e=F(e,32029,37)}F(M2(e,i[f+40>>2],i[f+44>>2]),5755,6),e=i[n+72>>2];n:{if(e&16){o=n+44|0,e=i[n+68>>2],r=i[n+48>>2],e>>>0<r>>>0&&(i[n+68>>2]=r,e=r);break n}if(!(e&8)){e=0,t[n+11|0]=0,o=n;break e}o=n+32|0,e=i[n+40>>2]}if(f=i[o>>2],e=e-f|0,e>>>0>=2147483640)break k;if(e>>>0>=11){r=e|7,o=C(r+1|0),i[n+8>>2]=r-2147483647,i[n>>2]=o,i[n+4>>2]=e;break r}if(t[n+11|0]=e,o=n,e)break r;e=0;break e}for(;s=l,!!(u[l|0]>=4&&(l=i[l+96>>2],l)););if(!((s|0)!=101976&(s|0)!=102080)){if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731]);break i}u[115e3]||(t[115e3]=1);n:{l=i[28752];t:{if(!l)break t;for(o=115008;h=s>>>0>o0[l+16>>2],o=h?o:l,l=i[(h?4:0)+l>>2],!!l;);if((o|0)==115008)break t;if(s>>>0>=o0[o+16>>2])break n}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731]);break i}if(h=i[f+64>>2],l=i[f+68>>2],w=i[o+20>>2]+r|0,!(!(h|l)|(!l&h>>>0>=w>>>0|(l|0)!=0))){i[n+104>>2]=0,i[n+76>>2]=78164,i[n+20>>2]=78144,e=i[19545],i[n+12>>2]=e,s=i[e-12>>2],h=n+12|0,e=h,i[s+e>>2]=i[19546],i[n+16>>2]=0,e=e+i[i[n+12>>2]-12>>2]|0,s=n+24|0,J0(e,s),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[n+20>>2]=e,l=n+20|0,i[l+i[e-12>>2]>>2]=i[19548],e=i[19544],i[n+12>>2]=e,i[h+i[e-12>>2]>>2]=i[19549],i[n+76>>2]=78164,i[n+12>>2]=78124,i[n+20>>2]=78144,s=R0(s),i[s>>2]=77200,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,e=B0(F(l,32187,16),i[o+20>>2]+r|0);n:{if(k){e=F(F(F(e,31202,11),k,l2(k)),32080,31);break n}e=F(e,32029,37)}F(M2(e,i[f+64>>2],i[f+68>>2]),15462,28),e=i[n+72>>2];n:{if(e&16){o=n+44|0,e=i[n+68>>2],r=i[n+48>>2],e>>>0<r>>>0&&(i[n+68>>2]=r,e=r);break n}if(!(e&8)){e=0,t[n+11|0]=0,o=n;break f}o=n+32|0,e=i[n+40>>2]}if(f=i[o>>2],e=e-f|0,e>>>0>=2147483640)break k;if(e>>>0>=11){r=e|7,o=C(r+1|0),i[n+8>>2]=r-2147483647,i[n>>2]=o,i[n+4>>2]=e;break A}if(t[n+11|0]=e,o=n,e)break A;e=0;break f}if(i[e>>2]=s,i[e+4>>2]=i[e+4>>2]+r,i[o+20>>2]=w,w>>>0>o0[o+24>>2]&&(i[o+24>>2]=w),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731]);break i}I0(),M()}if(!e)break f;z(o,f,e)}t[e+o|0]=0,a(A,6,1e3,n),t[n+11|0]<0&&Z(i[n>>2]),A=i[19543],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[19551],i[n+20>>2]=i[19552],i[s>>2]=77200,t[n+67|0]<0&&Z(i[n+56>>2]),y0(s),Y0(n+76|0);break i}if(!e)break e;z(o,f,e)}t[e+o|0]=0,a(A,6,1e3,n),t[n+11|0]<0&&Z(i[n>>2]),A=i[19543],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[19551],i[n+20>>2]=i[19552],i[l>>2]=77200,t[n+67|0]<0&&Z(i[n+56>>2]),y0(l),Y0(n+76|0)}v=n+160|0}function Tm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;o=X[e+8>>1],_=v-32|0,l=X[e+16>>1],w=X[e>>1],n=X[e+24>>1],k=((g(l,-74)+g(w,74)|0)+g(n,74)|0)- -64>>7,k=(k|0)>=32767?32767:k,X[_+16>>1]=(k|0)<=-32768?-32768:k,k=(((g(o,-74)+g(w,84)|0)+g(l,55)|0)+g(n,-29)|0)- -64>>7,k=(k|0)>=32767?32767:k,X[_+24>>1]=(k|0)<=-32768?-32768:k,o=g(o,74),k=(((o+g(w,55)|0)+g(l,-29)|0)+g(n,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,X[_+8>>1]=(k|0)<=-32768?-32768:k,l=(((o+g(w,29)|0)+g(l,84)|0)+g(n,55)|0)- -64>>7,l=(l|0)>=32767?32767:l,X[_>>1]=(l|0)<=-32768?-32768:l,o=X[e+10>>1],l=X[e+18>>1],w=X[e+2>>1],n=X[e+26>>1],k=((g(l,-74)+g(w,74)|0)+g(n,74)|0)- -64>>7,k=(k|0)>=32767?32767:k,X[_+18>>1]=(k|0)<=-32768?-32768:k,k=(((g(o,-74)+g(w,84)|0)+g(l,55)|0)+g(n,-29)|0)- -64>>7,k=(k|0)>=32767?32767:k,X[_+26>>1]=(k|0)<=-32768?-32768:k,o=g(o,74),k=(((o+g(w,55)|0)+g(l,-29)|0)+g(n,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,X[_+10>>1]=(k|0)<=-32768?-32768:k,l=(((o+g(w,29)|0)+g(l,84)|0)+g(n,55)|0)- -64>>7,l=(l|0)>=32767?32767:l,X[_+2>>1]=(l|0)<=-32768?-32768:l,o=X[e+12>>1],l=X[e+20>>1],w=X[e+4>>1],n=X[e+28>>1],k=((g(l,-74)+g(w,74)|0)+g(n,74)|0)- -64>>7,k=(k|0)>=32767?32767:k,X[_+20>>1]=(k|0)<=-32768?-32768:k,k=(((g(o,-74)+g(w,84)|0)+g(l,55)|0)+g(n,-29)|0)- -64>>7,k=(k|0)>=32767?32767:k,X[_+28>>1]=(k|0)<=-32768?-32768:k,o=g(o,74),k=(((o+g(w,55)|0)+g(l,-29)|0)+g(n,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,X[_+12>>1]=(k|0)<=-32768?-32768:k,l=(((o+g(w,29)|0)+g(l,84)|0)+g(n,55)|0)- -64>>7,l=(l|0)>=32767?32767:l,X[_+4>>1]=(l|0)<=-32768?-32768:l,n=X[e+14>>1],l=X[e+22>>1],w=X[e+6>>1],e=X[e+30>>1],o=((g(l,-74)+g(w,74)|0)+g(e,74)|0)- -64>>7,o=(o|0)>=32767?32767:o,X[_+22>>1]=(o|0)<=-32768?-32768:o,o=(((g(n,-74)+g(w,84)|0)+g(l,55)|0)+g(e,-29)|0)- -64>>7,o=(o|0)>=32767?32767:o,X[_+30>>1]=(o|0)<=-32768?-32768:o,n=g(n,74),o=(((n+g(w,55)|0)+g(l,-29)|0)+g(e,-84)|0)- -64>>7,o=(o|0)>=32767?32767:o,X[_+14>>1]=(o|0)<=-32768?-32768:o,e=(((n+g(w,29)|0)+g(l,84)|0)+g(e,55)|0)- -64>>7,e=(e|0)>=32767?32767:e,X[_+6>>1]=(e|0)<=-32768?-32768:e,l=20-f|0,e=-1<<f^-1,w=1<<19-f;i:{if((r|0)!=1){for(f=0;o=(f<<3)+_|0,s=X[o+2>>1],n=(g(r,f)<<1)+A|0,k=X[o+4>>1],m=X[o>>1],o=X[o+6>>1],h=w+((g(k,-74)+g(m,74)|0)+g(o,74)|0)>>l,h=(h|0)>=32767?32767:h,h=p[n+4>>1]+((h|0)<=-32768?-32768:h)|0,X[n+4>>1]=(h|0)>=0?(e|0)>(h|0)?h:e:0,B=g(s,74),h=w+(((B+g(m,29)|0)+g(k,84)|0)+g(o,55)|0)>>l,h=(h|0)>=32767?32767:h,h=p[n>>1]+((h|0)<=-32768?-32768:h)|0,X[n>>1]=(h|0)>=0?(e|0)>(h|0)?h:e:0,h=w+(((B+g(m,55)|0)+g(k,-29)|0)+g(o,-84)|0)>>l,h=(h|0)>=32767?32767:h,h=p[n+2>>1]+((h|0)<=-32768?-32768:h)|0,X[n+2>>1]=(h|0)>=0?(e|0)>(h|0)?h:e:0,B=n,h=p[n+6>>1],n=w+(((g(s,-74)+g(m,84)|0)+g(k,55)|0)+g(o,-29)|0)>>l,n=(n|0)>=32767?32767:n,n=h+((n|0)<=-32768?-32768:n)|0,X[B+6>>1]=(n|0)>=0?(e|0)>(n|0)?n:e:0,f=f+1|0,(f|0)!=4;);break i}for(k=p[A+4>>1],f=0;o=(f<<3)+_|0,h=X[o+2>>1],n=(g(r,f)<<1)+A|0,B=k&65535,k=X[o+4>>1],m=X[o>>1],o=X[o+6>>1],s=w+((g(k,-74)+g(m,74)|0)+g(o,74)|0)>>l,s=(s|0)>=32767?32767:s,s=B+((s|0)<=-32768?-32768:s)|0,X[n+4>>1]=(s|0)>=0?(e|0)>(s|0)?s:e:0,B=g(h,74),s=w+(((B+g(m,29)|0)+g(k,84)|0)+g(o,55)|0)>>l,s=(s|0)>=32767?32767:s,s=p[n>>1]+((s|0)<=-32768?-32768:s)|0,X[n>>1]=(s|0)>=0?(e|0)>(s|0)?s:e:0,s=w+(((B+g(m,55)|0)+g(k,-29)|0)+g(o,-84)|0)>>l,s=(s|0)>=32767?32767:s,s=p[n+2>>1]+((s|0)<=-32768?-32768:s)|0,X[n+2>>1]=(s|0)>=0?(e|0)>(s|0)?s:e:0,B=n,s=p[n+6>>1],n=w+(((g(h,-74)+g(m,84)|0)+g(k,55)|0)+g(o,-29)|0)>>l,n=(n|0)>=32767?32767:n,n=s+((n|0)<=-32768?-32768:n)|0,k=(n|0)>=0?(e|0)>(n|0)?n:e:0,X[B+6>>1]=k,f=f+1|0,(f|0)!=4;);}}function sn(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;k=v+-64|0,v=k;i:{if(u[e+96|0]==1){if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}r3(k+40|0,e,1);e:{r:switch(u[k+60|0]){default:e2(),M();case 1:if(e=i[k+44>>2],i[A>>2]=i[k+40>>2],i[A+4>>2]=e,A=A+8|0,t[k+59|0]>=0){e=i[k+52>>2],i[A>>2]=i[k+48>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+56>>2];break e}T(A,i[k+48>>2],i[k+52>>2]);break e;case 0:break r}f=C(24),i[k+4>>2]=f,i[k+8>>2]=23,i[k+12>>2]=-2147483624,n=u[8092]|u[8093]<<8|(u[8094]<<16|u[8095]<<24),r=u[8088]|u[8089]<<8|(u[8090]<<16|u[8091]<<24),t[f+15|0]=r,t[f+16|0]=r>>>8,t[f+17|0]=r>>>16,t[f+18|0]=r>>>24,t[f+19|0]=n,t[f+20|0]=n>>>8,t[f+21|0]=n>>>16,t[f+22|0]=n>>>24,n=u[8085]|u[8086]<<8|(u[8087]<<16|u[8088]<<24),r=u[8081]|u[8082]<<8|(u[8083]<<16|u[8084]<<24),t[f+8|0]=r,t[f+9|0]=r>>>8,t[f+10|0]=r>>>16,t[f+11|0]=r>>>24,t[f+12|0]=n,t[f+13|0]=n>>>8,t[f+14|0]=n>>>16,t[f+15|0]=n>>>24,n=u[8077]|u[8078]<<8|(u[8079]<<16|u[8080]<<24),r=u[8073]|u[8074]<<8|(u[8075]<<16|u[8076]<<24),t[f|0]=r,t[f+1|0]=r>>>8,t[f+2|0]=r>>>16,t[f+3|0]=r>>>24,t[f+4|0]=n,t[f+5|0]=n>>>8,t[f+6|0]=n>>>16,t[f+7|0]=n>>>24,t[f+23|0]=0,r=a(k+16|0,2,0,k+4|0),t[k+15|0]<0&&Z(i[k+4>>2]);r:{f:{A:{k:{n:{t:{o:{l:{if(l=i[k+40>>2],s=i[k+44>>2]-l|0,s>>>0>=2)for(f=1;;){n=o,o=f;u:{if(h=n+l|0,u[h|0]!=255||(f=u[f+l|0],(f&240)!=192|u[(f&15)+59040|0]!=1))break u;if(o=n+9|0,o>>>0>=s>>>0){if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,t[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}s:{if(w=u[o+l|0],o=n+11|0,s>>>0>g(w,3)+o>>>0){if(!w)break o;if(l=o+l|0,s=u[l|0],n=0,f=0,o=0,(w|0)!=1)break s;break l}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,t[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}if(o=u[l+3|0],f=o&15,o=o>>>4|0,(w|0)==2)break l;l=u[l+6|0],_=l&15,B=l>>>4|0;break l}if(f=o+1|0,(s|0)==(f|0))break}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,t[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}switch(h=u[h+4|0],l=s&15,s=s>>>4|0,w-1|0){case 0:break n;case 2:break t;default:break o}}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,t[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}if(!((o|0)==(B|0)&(f|0)==(_|0))){if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,t[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}if(n=1,!((f|0)!=1|(o|0)!=1|(s|0)!=2)&&(l|0)==2)break n;if(n=(f|0)!=1,!(n|(o|0)!=1|((s|0)!=2|(l|0)!=1))){n=2;break n}if((o|0)!=1|n|((s|0)!=1|(l|0)!=1))break k;n=3}if(u[e+96|0]!=1)break A;t[e+80|0]=h,h=u[k+4|0]|u[k+5|0]<<8,t[e+81|0]=h,t[e+82|0]=h>>>8,t[e+83|0]=u[k+6|0];break f}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,t[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}t[e+80|0]=h,h=u[k+4|0]|u[k+5|0]<<8,t[e+81|0]=h,t[e+82|0]=h>>>8,t[e+83|0]=u[k+6|0],t[e+96|0]=1}t[e+94|0]=_,t[e+93|0]=f,t[e+92|0]=l,t[e+91|0]=B,t[e+90|0]=o,t[e+89|0]=s,t[e+88|0]=w,i[e+84>>2]=n,Z8(A,114912)}if(t[r+19|0]>=0)break e;Z(i[r+8>>2])}if(A=u[k+60|0],(A|0)==255)break i;e=i[26329],i[k+16>>2]=i[26328],i[k+20>>2]=e,W[i[(k+16|0)+(A<<2)>>2]](k+4|0,k+40|0)}v=k- -64|0}function jm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0;n=v-32|0,v=n,h=$2(i[r>>2],6),k=u[k+8|0];i:{e:{r:{if((K0(i[r>>2],3)|0)!=8||(K0(i[r>>2],4)|0)!=8)break r;if((K0(i[r>>2],5)|0)==8)break e}e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;r:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break r}T(e,i[28735],i[28736])}t[A+20|0]=1;break i}e:{if(!h||(K0(i[r>>2],6)|0)==8)break e;e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;r:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break r}T(e,i[28735],i[28736])}t[A+20|0]=1;break i}G=C(248),e=G,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=101168,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,Q=e+12|0,i[e+176>>2]=Q,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e)),e=i[r>>2],o=i[e+188>>2],I=i[e+192>>2],t1(Q,o,I,1,k&1?11:10),a0(n+8|0,Q,10,o,I,8,l,0);e:{if(i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,e=A+8|0,t[n+27|0]>=0){r=i[n+20>>2],i[e>>2]=i[n+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+24>>2],t[A+20|0]=1;break e}if(T(e,i[n+16>>2],i[n+20>>2]),e=t[n+27|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}t[n+27|0]<0&&Z(i[n+16>>2]),l=0,e=Q0(i[r>>2],3),e?(N=i[e+40>>2],e=i[e+52>>2]):e=0,f=Q0(i[r>>2],4),f?(l=i[f+52>>2],Y=i[f+40>>2]):Y=0,f=Q0(i[r>>2],5),f?(U=i[f+40>>2],E=i[f+52>>2]):E=0,f=Q0(Q,10),f?(x=i[f+52>>2],R=i[f+40>>2]):R=0,f=0;r:{if(!h||(r=Q0(i[r>>2],6),f=0,!r))break r;_=i[r+52>>2],f=i[r+40>>2]}r:{if(!I)break r;if((k&h)==1){if(!o)break r;for(k=0;;){for(B=f+g(k,_)|0,m=g(k,E)+U|0,s=Y+g(k,l)|0,w=R+g(k,x)|0,V=g(e,k)+N|0,r=0;h=w+(r<<2)|0,t[h|0]=u[r+V|0],t[h+1|0]=u[r+s|0],t[h+2|0]=u[r+m|0],t[h+3|0]=u[r+B|0],r=r+1|0,(o|0)!=(r|0););if(k=k+1|0,(I|0)==(k|0))break}break r}if(k&1){if(!o)break r;for(V=o&-2,j=o&1,f=0;;){if(h=g(f,E)+U|0,_=Y+g(f,l)|0,B=R+g(f,x)|0,m=g(e,f)+N|0,r=0,k=0,(o|0)!=1)for(;s=B+(r<<2)|0,t[s|0]=u[r+m|0],t[s+1|0]=u[r+_|0],w=u[r+h|0],t[s+3|0]=255,t[s+2|0]=w,s=r|1,w=B+(s<<2)|0,t[w|0]=u[s+m|0],t[w+1|0]=u[s+_|0],s=u[s+h|0],t[w+3|0]=255,t[w+2|0]=s,r=r+2|0,k=k+2|0,(V|0)!=(k|0););if(j&&(k=B+(r<<2)|0,t[k|0]=u[r+m|0],t[k+1|0]=u[r+_|0],r=u[r+h|0],t[k+3|0]=255,t[k+2|0]=r),f=f+1|0,(I|0)==(f|0))break}break r}if(!o)break r;for(V=o&-2,j=o&1,f=0;;){if(h=g(f,E)+U|0,_=Y+g(f,l)|0,B=R+g(f,x)|0,m=g(e,f)+N|0,r=0,k=0,(o|0)!=1)for(;s=B+g(r,3)|0,t[s|0]=u[r+m|0],t[s+1|0]=u[r+_|0],t[s+2|0]=u[r+h|0],s=r|1,w=B+g(s,3)|0,t[w|0]=u[s+m|0],t[w+1|0]=u[s+_|0],t[w+2|0]=u[s+h|0],r=r+2|0,k=k+2|0,(V|0)!=(k|0););if(j&&(k=B+g(r,3)|0,t[k|0]=u[r+m|0],t[k+1|0]=u[r+_|0],t[k+2|0]=u[r+h|0]),f=f+1|0,(I|0)==(f|0))break}}t[A+20|0]=0,i[A+4>>2]=G,i[A>>2]=Q;break i}if(A=i[G+4>>2],i[G+4>>2]=A-1,A)break i;W[i[i[G>>2]+8>>2]](G),y(G)}v=n+32|0}function Sm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=D(0),g0=D(0),X0=D(0),V0=D(0);f=v-48|0,v=f;i:{e:{r:{if((K0(i[r>>2],0)|0)!=8||(K0(i[r>>2],1)|0)!=8)break r;if((K0(i[r>>2],2)|0)==8)break e}e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,r=A+8|0;r:{if(t[114951]>=0){e=i[28736],i[r>>2]=i[28735],i[r+4>>2]=e,i[r+8>>2]=i[28737];break r}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}w=C(248),e=w,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=101168,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,n=e+12|0,i[e+176>>2]=n,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e)),e=i[r>>2],o=i[e+188>>2],m=i[e+192>>2],t1(n,o,m,1,11),a0(f+24|0,n,10,o,m,8,l,0);e:{if(i[f+24>>2]){if(e=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=e,r=A+8|0,t[f+43|0]>=0){e=i[f+36>>2],i[r>>2]=i[f+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+40>>2],t[A+20|0]=1;break e}if(T(r,i[f+32>>2],i[f+36>>2]),e=t[f+43|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[f+32>>2]);break e}t[f+43|0]<0&&Z(i[f+32>>2]),i[f+36>>2]=-1086926434,i[f+40>>2]=1071829221,i[f+28>>2]=1068725436,i[f+32>>2]=-1095748968,t[f+24|0]=1,r8(i[r>>2])&&(k=i[r>>2],e=p[k+6>>1]|p[k+8>>1]<<16,Pe(f+4|0,(p[k+10>>1]|p[k+12>>1]<<16)&65535,e&65535),i[f+40>>2]=i[f+20>>2],e=i[f+16>>2],i[f+32>>2]=i[f+12>>2],i[f+36>>2]=e,e=i[f+8>>2],i[f+24>>2]=i[f+4>>2],i[f+28>>2]=e),_0=E0[f+28>>2],g0=E0[f+36>>2],X0=E0[f+32>>2],V0=E0[f+40>>2],s=$2(i[r>>2],6),e=i[r>>2],l=0,O=p6(D(V0*D(256))),S=p6(D(X0*D(256))),q=p6(D(g0*D(256))),d=p6(D(_0*D(256))),e=Q0(e,0),e?(c=i[e+40>>2],Q=i[e+52>>2]):Q=0,e=Q0(i[r>>2],1),e?(l=i[e+52>>2],V=i[e+40>>2]):V=0,e=Q0(i[r>>2],2),e?(A0=i[e+40>>2],Y=i[e+52>>2]):Y=0,e=0;r:{if(!s||(r=Q0(i[r>>2],6),e=0,!r))break r;G=i[r+52>>2],e=i[r+40>>2]}r=Q0(n,10),r?(t0=i[r+40>>2],E=i[r+52>>2]):E=0;r:{if(!m|!o)break r;if(k=0,s)for(;;){for(B=e+g(k,G)|0,R=g(k,E)+t0|0,N=g(k,Q)+c|0,r=k>>>1|0,U=g(r,Y)+A0|0,x=g(r,l)+V|0,r=0;h=r>>>1|0,s=u[h+U|0],I=R+(r<<2)|0,j=u[r+N|0],h=u[h+x|0]-128|0,_=j+(g(h,O)+128>>8)|0,t[I+2|0]=(_|0)>=0?_>>>0>=255?255:_:0,s=s-128|0,_=j+(g(s,d)+128>>8)|0,t[I|0]=(_|0)>=0?_>>>0>=255?255:_:0,s=j+((g(h,S)+g(s,q)|0)+128>>8)|0,t[I+1|0]=(s|0)>=0?s>>>0>=255?255:s:0,t[I+3|0]=u[r+B|0],r=r+1|0,(o|0)!=(r|0););if(k=k+1|0,(m|0)==(k|0))break r}for(;;){for(R=g(k,E)+t0|0,N=g(k,Q)+c|0,e=k>>>1|0,U=g(e,Y)+A0|0,x=g(e,l)+V|0,r=0;e=r>>>1|0,h=u[e+U|0],G=u[r+N|0],e=u[e+x|0],B=R+(r<<2)|0,t[B+3|0]=255,s=e-128|0,e=G+(g(s,O)+128>>8)|0,t[B+2|0]=(e|0)>=0?e>>>0>=255?255:e:0,e=h-128|0,h=G+(g(e,d)+128>>8)|0,t[B|0]=(h|0)>=0?h>>>0>=255?255:h:0,e=G+((g(s,S)+g(e,q)|0)+128>>8)|0,t[B+1|0]=(e|0)>=0?e>>>0>=255?255:e:0,r=r+1|0,(o|0)!=(r|0););if(k=k+1|0,(m|0)==(k|0))break}}t[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=n;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;W[i[i[w>>2]+8>>2]](w),y(w)}v=f+48|0}function mA(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;f=v+-64|0,v=f,i[f+52>>2]=0,i[f+48>>2]=1,W[i[i[r>>2]+132>>2]](f+36|0,i[r+4>>2],f+60|0,f+56|0,f+52|0,0,f+48|0);i:{e:{r:{if(k=i[f+36>>2],k)break r;if(k=i[f+60>>2],!k){i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break e}n=e+32|0,s=e+28|0,l=e+24|0;f:{A:{k:{n:{t:switch(o=u[k|0],h=o>>>1|0,h-32|0){case 0:break n;case 1:break k;case 2:break t;default:break A}o=i[e+12>>2],!o|t[e+8|0]&1||L6(o,k,i[f+56>>2]),t[e+8|0]=1;break f}o=i[e+12>>2],!o|t[e+6|0]&1||L6(o,k,i[f+56>>2]),t[e+6|0]=1;break f}o=i[e+12>>2];k:{if(!o||(Or(f+4|0,k,i[f+56>>2],o+100|0,l,s,0),t[f+23|0]>=0))break k;Z(i[f+12>>2])}k=i[e+12>>2],!k|t[e+7|0]&1||L6(k,i[f+60>>2],i[f+56>>2]),t[e+7|0]=1;break f}if(u[e+76|0]||(i[e+60>>2]=0,i[e+64>>2]=0,t[n+23|0]=0,t[n+24|0]=0,t[n+25|0]=0,t[n+26|0]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0,i[n>>2]=0,i[n+4>>2]=0,t[e+76|0]=1,i[e+72>>2]=0,t[e+68|0]=1),C6(n,k,i[f+56>>2]),o>>>0>63)break f;t[e+68|0]=(h-19&255)>>>0<3,i[e+72>>2]=i[f+52>>2]}f:{if(!i[f+48>>2])break f;if(i[f+52>>2]=0,i[f+48>>2]=1,W[i[i[r>>2]+132>>2]](f+36|0,i[r+4>>2],f+60|0,f+56|0,f+52|0,0,f+48|0),k=i[f+36>>2],k)break r;for(;;){if(k=i[f+60>>2],!k)break f;A:{k:{n:{t:{o:switch(o=u[k|0],h=o>>>1|0,h-32|0){case 0:break t;case 1:break o;case 2:break n;default:break k}o=i[e+12>>2];o:{if(!o||(Or(f+4|0,k,i[f+56>>2],o+100|0,l,s,0),t[f+23|0]>=0))break o;Z(i[f+12>>2])}k=i[e+12>>2],!k|t[e+7|0]&1||L6(k,i[f+60>>2],i[f+56>>2]),t[e+7|0]=1;break A}o=i[e+12>>2],!o|t[e+6|0]&1||L6(o,k,i[f+56>>2]),t[e+6|0]=1;break A}o=i[e+12>>2],!o|t[e+8|0]&1||L6(o,k,i[f+56>>2]),t[e+8|0]=1;break A}if(u[e+76|0]||(i[e+60>>2]=0,i[e+64>>2]=0,t[n+23|0]=0,t[n+24|0]=0,t[n+25|0]=0,t[n+26|0]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0,i[n>>2]=0,i[n+4>>2]=0,t[e+76|0]=1,i[e+72>>2]=0,t[e+68|0]=1),C6(n,k,i[f+56>>2]),o>>>0>63)break A;t[e+68|0]=(h-19&255)>>>0<3,i[e+72>>2]=i[f+52>>2]}if(!i[f+48>>2])break f;if(i[f+52>>2]=0,i[f+48>>2]=1,W[i[i[r>>2]+132>>2]](f+36|0,i[r+4>>2],f+60|0,f+56|0,f+52|0,0,f+48|0),k=i[f+36>>2],!!k)break}break r}f:{if(r=i[l>>2],r&&(k=i[s>>2],k))break f;if(t[f+36|0]=0,t[f+47|0]=0,a(A,8,129,f+36|0),t[f+47|0]>=0)break e;Z(i[f+36>>2]);break e}f:{A:{k:{if(!(t[e+6|0]&1)|i[e+44>>2]==i[e+48>>2]|(!(t[e+7|0]&1)|!(t[e+8|0]&1))||u[e+20|0])break k;h=i[e+12>>2],k=i[e+16>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),r=i[e+36>>2],l=i[e+40>>2];n:{if(r>>>0<l>>>0){i[r+4>>2]=k,i[r>>2]=h,r=r+8|0;break n}if(s=i[n>>2],r=r-s|0,w=r>>3,n=w+1|0,n>>>0>=536870912)break A;if(l=l-s|0,o=l>>2,l=l>>>0>=2147483640?536870911:n>>>0<o>>>0?o:n,l){if(l>>>0>=536870912)break f;n=C(l<<3)}else n=0;if(o=n+r|0,i[o+4>>2]=k,i[o>>2]=h,k=o-(w<<3)|0,r&&z(k,s,r),i[e+40>>2]=n+(l<<3),r=o+8|0,i[e+36>>2]=r,i[e+32>>2]=k,!s)break n;Z(s)}i[e+36>>2]=r,r=i[e+16>>2],i[e+12>>2]=0,i[e+16>>2]=0;n:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break n;W[i[i[r>>2]+8>>2]](r),y(r)}t[e+20|0]=1,k=i[e+28>>2],r=i[e+24>>2]}i[e+64>>2]=k,i[e+60>>2]=r,X[e+56>>1]=257,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break e}s0(),M()}x0(),M()}if(n=i[f+40>>2],s=i[f+44>>2],e=l2(s),e>>>0>=2147483640)break i;r:{f:{if(e>>>0>=11){l=e|7,r=C(l+1|0),i[f+32>>2]=l-2147483647,i[f+24>>2]=r,i[f+28>>2]=e;break f}if(t[f+35|0]=e,r=f+24|0,!e)break r}if(!e)break r;z(r,s,e)}if(t[e+r|0]=0,a(A,k,n,f+24|0),t[f+35|0]>=0)break e;Z(i[f+24>>2])}v=f- -64|0;return}I0(),M()}function Om(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0;n=v-32|0,v=n,f=v+-64|0,v=f,r=i[e+180>>2],k=i[r+48>>2],l=i[r+52>>2],l&&(i[l+4>>2]=i[l+4>>2]+1),r=i[k+80>>2],s=i[k+84>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),o=n+8|0;i:{if(!r){if(e=C(56),i[f+40>>2]=e,i[f+44>>2]=48,i[f+48>>2]=-2147483592,k=u[15713]|u[15714]<<8|(u[15715]<<16|u[15716]<<24),r=u[15709]|u[15710]<<8|(u[15711]<<16|u[15712]<<24),t[e|0]=r,t[e+1|0]=r>>>8,t[e+2|0]=r>>>16,t[e+3|0]=r>>>24,t[e+4|0]=k,t[e+5|0]=k>>>8,t[e+6|0]=k>>>16,t[e+7|0]=k>>>24,t[e+48|0]=0,k=u[15753]|u[15754]<<8|(u[15755]<<16|u[15756]<<24),r=u[15749]|u[15750]<<8|(u[15751]<<16|u[15752]<<24),t[e+40|0]=r,t[e+41|0]=r>>>8,t[e+42|0]=r>>>16,t[e+43|0]=r>>>24,t[e+44|0]=k,t[e+45|0]=k>>>8,t[e+46|0]=k>>>16,t[e+47|0]=k>>>24,k=u[15745]|u[15746]<<8|(u[15747]<<16|u[15748]<<24),r=u[15741]|u[15742]<<8|(u[15743]<<16|u[15744]<<24),t[e+32|0]=r,t[e+33|0]=r>>>8,t[e+34|0]=r>>>16,t[e+35|0]=r>>>24,t[e+36|0]=k,t[e+37|0]=k>>>8,t[e+38|0]=k>>>16,t[e+39|0]=k>>>24,k=u[15737]|u[15738]<<8|(u[15739]<<16|u[15740]<<24),r=u[15733]|u[15734]<<8|(u[15735]<<16|u[15736]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,t[e+28|0]=k,t[e+29|0]=k>>>8,t[e+30|0]=k>>>16,t[e+31|0]=k>>>24,k=u[15729]|u[15730]<<8|(u[15731]<<16|u[15732]<<24),r=u[15725]|u[15726]<<8|(u[15727]<<16|u[15728]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,t[e+20|0]=k,t[e+21|0]=k>>>8,t[e+22|0]=k>>>16,t[e+23|0]=k>>>24,k=u[15721]|u[15722]<<8|(u[15723]<<16|u[15724]<<24),r=u[15717]|u[15718]<<8|(u[15719]<<16|u[15720]<<24),t[e+8|0]=r,t[e+9|0]=r>>>8,t[e+10|0]=r>>>16,t[e+11|0]=r>>>24,t[e+12|0]=k,t[e+13|0]=k>>>8,t[e+14|0]=k>>>16,t[e+15|0]=k>>>24,a(o,2,113,f+40|0),t[f+51|0]>=0)break i;Z(i[f+40>>2]);break i}d4(f+40|0,r,i[e+196>>2],1684630887),r=i[e+584>>2],r&&(i[e+588>>2]=r,Z(r)),i[e+584>>2]=i[f+40>>2],i[e+588>>2]=i[f+44>>2],i[e+592>>2]=i[f+48>>2],W6(f+40|0,k,i[e+196>>2]);e:{r:switch(u[f+60|0]){default:e2(),M();case 1:if(e=i[f+44>>2],i[o>>2]=i[f+40>>2],i[o+4>>2]=e,r=o+8|0,t[f+59|0]>=0){e=i[f+52>>2],i[r>>2]=i[f+48>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+56>>2];break e}T(r,i[f+48>>2],i[f+52>>2]);break e;case 0:break r}O9(f+16|0,e+552|0,i[e+588>>2]-i[e+584>>2]>>2,f+40|0);r:{if(i[f+16>>2]){e=i[f+20>>2],i[o>>2]=i[f+16>>2],i[o+4>>2]=e,i[o+16>>2]=i[f+32>>2],e=i[f+28>>2],i[o+8>>2]=i[f+24>>2],i[o+12>>2]=e,i[f+32>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0;break r}if(((i[e+576>>2]-i[e+572>>2]|0)/12|0)!=i[e+588>>2]-i[e+584>>2]>>2){if(e=C(72),i[f+4>>2]=e,i[f+8>>2]=69,i[f+12>>2]=-2147483576,z(e,6373,69),t[e+69|0]=0,a(o,2,121,f+4|0),t[f+15|0]>=0)break r;Z(i[f+4>>2]);break r}if(e=i[28729],i[o>>2]=i[28728],i[o+4>>2]=e,r=o+8|0,t[114931]>=0){e=i[28731],i[r>>2]=i[28730],i[r+4>>2]=e,i[r+8>>2]=i[28732];break r}T(r,i[28730],i[28731])}if(t[f+35|0]>=0)break e;Z(i[f+24>>2])}if(r=u[f+60|0],(r|0)==255)break i;e=i[27125],i[f+16>>2]=i[27124],i[f+20>>2]=e,W[i[(f+16|0)+(r<<2)>>2]](f+4|0,f+40|0)}i:{if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break i;W[i[i[s>>2]+8>>2]](s),y(s)}i:{if(!l||(e=i[l+4>>2],i[l+4>>2]=e-1,e))break i;W[i[i[l>>2]+8>>2]](l),y(l)}v=f- -64|0,r=A+8|0;i:{if(i[n+8>>2]){e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,i[r+8>>2]=i[n+24>>2],A=i[n+20>>2],i[r>>2]=i[n+16>>2],i[r+4>>2]=A,i[n+24>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0;break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,t[114931]>=0){A=i[28731],i[r>>2]=i[28730],i[r+4>>2]=A,i[r+8>>2]=i[28732];break i}T(r,i[28730],i[28731])}t[n+27|0]<0&&Z(i[n+16>>2]),v=n+32|0}function ZA(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;k=v-48|0,v=k;i:{r=i[e>>2],n=i[e+4>>2];e:{if((r|0)==(n|0)){t[A+20|0]=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break e}r:{f:{if(l=n-1|0,!u[l|0]){if(o=(r^-1)+n|0,!o)break r;e=0;break f}e=C(32),i[k+12>>2]=e,i[k+16>>2]=30,i[k+20>>2]=-2147483616,r=u[18333]|u[18334]<<8|(u[18335]<<16|u[18336]<<24),f=u[18329]|u[18330]<<8|(u[18331]<<16|u[18332]<<24),t[e+22|0]=f,t[e+23|0]=f>>>8,t[e+24|0]=f>>>16,t[e+25|0]=f>>>24,t[e+26|0]=r,t[e+27|0]=r>>>8,t[e+28|0]=r>>>16,t[e+29|0]=r>>>24,r=u[18327]|u[18328]<<8|(u[18329]<<16|u[18330]<<24),f=u[18323]|u[18324]<<8|(u[18325]<<16|u[18326]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[18319]|u[18320]<<8|(u[18321]<<16|u[18322]<<24),f=u[18315]|u[18316]<<8|(u[18317]<<16|u[18318]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[18311]|u[18312]<<8|(u[18313]<<16|u[18314]<<24),f=u[18307]|u[18308]<<8|(u[18309]<<16|u[18310]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+30|0]=0,e=a(k+24|0,2,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(t[k+23|0]>=0)break e;Z(i[k+12>>2]);break e}for(;;){if(u[e+r|0]){if(e=e+1|0,(o|0)!=(e|0))continue;break r}break}e=C(32),i[k+12>>2]=e,i[k+16>>2]=30,i[k+20>>2]=-2147483616,r=u[7599]|u[7600]<<8|(u[7601]<<16|u[7602]<<24),f=u[7595]|u[7596]<<8|(u[7597]<<16|u[7598]<<24),t[e+22|0]=f,t[e+23|0]=f>>>8,t[e+24|0]=f>>>16,t[e+25|0]=f>>>24,t[e+26|0]=r,t[e+27|0]=r>>>8,t[e+28|0]=r>>>16,t[e+29|0]=r>>>24,r=u[7593]|u[7594]<<8|(u[7595]<<16|u[7596]<<24),f=u[7589]|u[7590]<<8|(u[7591]<<16|u[7592]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[7585]|u[7586]<<8|(u[7587]<<16|u[7588]<<24),f=u[7581]|u[7582]<<8|(u[7583]<<16|u[7584]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[7577]|u[7578]<<8|(u[7579]<<16|u[7580]<<24),f=u[7573]|u[7574]<<8|(u[7575]<<16|u[7576]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+30|0]=0,e=a(k+24|0,2,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(t[k+23|0]>=0)break e;Z(i[k+12>>2]);break e}if(f=l-r|0,f>>>0>=2147483640)break i;r:{if(f>>>0<=10){t[k+11|0]=f,e=k;break r}s=f|7,e=C(s+1|0),i[k+8>>2]=s-2147483647,i[k>>2]=e,i[k+4>>2]=f}r:{if((r|0)==(l|0))break r;if(n=(n-r|0)-2|0,o=o&7,o)for(f=0;t[e|0]=u[r|0],r=r+1|0,e=e+1|0,f=f+1|0,(o|0)!=(f|0););if(n>>>0<7)break r;for(;t[e|0]=u[r|0],t[e+1|0]=u[r+1|0],t[e+2|0]=u[r+2|0],t[e+3|0]=u[r+3|0],t[e+4|0]=u[r+4|0],t[e+5|0]=u[r+5|0],t[e+6|0]=u[r+6|0],t[e+7|0]=u[r+7|0],e=e+8|0,r=r+8|0,(l|0)!=(r|0););}t[e|0]=0,i[A+8>>2]=i[k+8>>2],e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,t[A+20|0]=0}v=k+48|0;return}I0(),M()}function hn(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;f=v-16|0,v=f;i:{e:{if(!i[A+44>>2]){e=C(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=95908,n=e+16|0,r=n,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[r>>2]=93256,i[e+32>>2]=1835365473,i[A+44>>2]=r,r=i[A+48>>2],i[A+48>>2]=e;r:{f:{if(!r){k=A+16|0;break f}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),k=A+16|0,n=i[A+44>>2],e=i[A+48>>2],e)break f;e=0;break r}i[e+4>>2]=i[e+4>>2]+1}r=i[k+4>>2],o=i[k+8>>2];r:{if(r>>>0<o>>>0){i[r+4>>2]=e,i[r>>2]=n,e=r+8|0;break r}if(s=i[k>>2],h=r-s|0,w=h>>3,r=w+1|0,r>>>0>=536870912)break e;if(o=o-s|0,l=o>>2,o=o>>>0>=2147483640?536870911:r>>>0<l>>>0?l:r,o){if(o>>>0>=536870912)break i;r=C(o<<3)}else r=0;if(l=r+h|0,i[l+4>>2]=e,i[l>>2]=n,n=l-(w<<3)|0,h&&z(n,s,h),i[k+8>>2]=r+(o<<3),e=l+8|0,i[k+4>>2]=e,i[k>>2]=n,!s)break r;Z(s)}i[k+4>>2]=e}r:{if(i[A+36>>2])break r;e=C(152),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=96028,r=e+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[e+16>>2]=93336,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=1885954932,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+32>>2]=1751411826,i[A+36>>2]=r,r=i[A+40>>2],i[A+40>>2]=e;f:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(e=i[A+36>>2],i[e+108>>2]=1853189228,r=i[A+44>>2],i[f+8>>2]=e,e=i[A+40>>2],i[f+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),P0(r+36|0,f+8|0),e=i[f+12>>2],!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}r:{if(i[A+64>>2])break r;e=C(176),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=96108,n=k5(e+16|0),i[A+64>>2]=n,r=i[A+68>>2],i[A+68>>2]=e;f:{A:{if(!r){k=i[A+44>>2],i[f+12>>2]=e,i[f+8>>2]=n;break A}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),k=i[A+44>>2],r=i[A+64>>2],e=i[A+68>>2],i[f+12>>2]=e,i[f+8>>2]=r,!e)break f}i[e+4>>2]=i[e+4>>2]+1}if(P0(k+36|0,f+8|0),e=i[f+12>>2],!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}r:{if(i[A+88>>2])break r;e=C(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=96148,n=e+16|0,r=n,i[r+8>>2]=0,i[r+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[e+16>>2]=93576,i[e+32>>2]=1768517222,i[A+88>>2]=r,r=i[A+92>>2],i[A+92>>2]=e;f:{A:{if(!r){k=i[A+44>>2],i[f+12>>2]=e,i[f+8>>2]=n;break A}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),k=i[A+44>>2],r=i[A+88>>2],e=i[A+92>>2],i[f+12>>2]=e,i[f+8>>2]=r,!e)break f}i[e+4>>2]=i[e+4>>2]+1}if(P0(k+36|0,f+8|0),A=i[f+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=f+16|0;return}s0(),M()}x0(),M()}function Pm(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0;f=v-32|0,v=f,e=i[r>>2],Q=i[e+192>>2],w=i[e+188>>2];i:{if((K0(e,0)|0)!=8){e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;e:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break e}T(e,i[28735],i[28736])}t[A+20|0]=1;break i}s=C(248),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=101168,l0(s+16|0,0,156),i[s+76>>2]=0,i[s+80>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,t[s+24|0]=1,X[s+22>>1]=2,X[s+18>>1]=2,X[s+20>>1]=2,i[s+84>>2]=0,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+128>>2]=0,i[s+132>>2]=0,i[s+100>>2]=0,i[s+104>>2]=1,i[s+136>>2]=0,i[s+140>>2]=0,i[s+144>>2]=0,i[s+148>>2]=0,i[s+152>>2]=0,i[s+156>>2]=0,X[s+158>>1]=0,X[s+160>>1]=0,X[s+162>>1]=0,X[s+164>>1]=0,i[s+184>>2]=0,i[s+188>>2]=0,i[s+172>>2]=255,i[s+192>>2]=0,i[s+196>>2]=5186,i[s+208>>2]=99,i[s+212>>2]=99,i[s+200>>2]=0,i[s+204>>2]=0,i[s+12>>2]=101488,i[s+216>>2]=0,i[s+220>>2]=0,i[s+224>>2]=0,i[s+228>>2]=0,i[s+232>>2]=0,i[s+236>>2]=0,i[s+240>>2]=0,i[s+244>>2]=0,V=s+12|0,i[s+176>>2]=V,i[s+8>>2]=i[s+8>>2]+1,i[s+180>>2]=s,i[s+4>>2]==-1&&(W[i[i[s>>2]+8>>2]](s),y(s)),o=$2(i[r>>2],6),t1(V,w,Q,1,u[k+8|0]?11:10),a0(f+8|0,V,10,w,Q,8,l,0);e:{if(i[f+8>>2]){if(e=i[f+12>>2],i[A>>2]=i[f+8>>2],i[A+4>>2]=e,e=A+8|0,t[f+27|0]>=0){r=i[f+20>>2],i[e>>2]=i[f+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+24>>2],t[A+20|0]=1;break e}if(T(e,i[f+16>>2],i[f+20>>2]),e=t[f+27|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[f+16>>2]);break e}t[f+27|0]<0&&Z(i[f+16>>2]),e=Q0(i[r>>2],0),e?(E=i[e+40>>2],e=i[e+52>>2]):e=0,G=0;r:{if(!o||(r=Q0(i[r>>2],6),G=0,!r))break r;j=i[r+52>>2],G=i[r+40>>2]}r=Q0(V,10),r?(R=i[r+40>>2],n=i[r+52>>2]):n=0;r:{if(!Q)break r;if(o){for(Y=w&-2,U=w&1,x=w-1|0,l=0;;){f:{if(u[k+8|0]){if(!w)break f;if(o=g(l,j)+G|0,h=g(n,l)+R|0,m=g(e,l)+E|0,r=0,B=0,x)for(;_=h+(r<<2)|0,I=u[r+m|0],t[_|0]=I,t[_+2|0]=I,t[_+1|0]=I,t[_+3|0]=u[r+o|0],I=r|1,_=h+(I<<2)|0,N=u[m+I|0],t[_+2|0]=N,t[_+1|0]=N,t[_|0]=N,t[_+3|0]=u[o+I|0],r=r+2|0,B=B+2|0,(Y|0)!=(B|0););if(!U)break f;B=h+(r<<2)|0,h=u[r+m|0],t[B|0]=h,t[B+2|0]=h,t[B+1|0]=h,t[B+3|0]=u[r+o|0];break f}if(!w)break f;if(B=g(n,l)+R|0,h=g(e,l)+E|0,r=0,o=0,x)for(;m=B+g(r,3)|0,_=u[r+h|0],t[m|0]=_,t[m+2|0]=_,t[m+1|0]=_,_=r|1,m=B+g(_,3)|0,_=u[h+_|0],t[m+2|0]=_,t[m+1|0]=_,t[m|0]=_,r=r+2|0,o=o+2|0,(Y|0)!=(o|0););if(!U)break f;o=B+g(r,3)|0,r=u[r+h|0],t[o|0]=r,t[o+2|0]=r,t[o+1|0]=r}if(l=l+1|0,(Q|0)==(l|0))break}break r}if(!w)break r;for(m=w&-2,_=w&1,Y=w-1|0;;){l=g(n,B)+R|0,G=g(e,B)+E|0;f:{if(u[k+8|0]){if(r=0,o=0,Y)for(;w=l+(r<<2)|0,h=u[r+G|0],t[w|0]=h,t[w+3|0]=255,t[w+2|0]=h,t[w+1|0]=h,h=r|1,w=u[h+G|0],h=l+(h<<2)|0,t[h+3|0]=255,t[h+2|0]=w,t[h+1|0]=w,t[h|0]=w,r=r+2|0,o=o+2|0,(m|0)!=(o|0););if(!_)break f;o=l+(r<<2)|0,r=u[r+G|0],t[o|0]=r,t[o+3|0]=255,t[o+2|0]=r,t[o+1|0]=r;break f}if(r=0,o=0,Y)for(;w=l+g(r,3)|0,h=u[r+G|0],t[w|0]=h,t[w+2|0]=h,t[w+1|0]=h,h=r|1,w=l+g(h,3)|0,h=u[h+G|0],t[w+2|0]=h,t[w+1|0]=h,t[w|0]=h,r=r+2|0,o=o+2|0,(m|0)!=(o|0););if(!_)break f;o=l+g(r,3)|0,r=u[r+G|0],t[o|0]=r,t[o+2|0]=r,t[o+1|0]=r}if(B=B+1|0,(Q|0)==(B|0))break}}t[A+20|0]=0,i[A+4>>2]=s,i[A>>2]=V;break i}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=f+32|0}function gA(A,e,r){var f=0,k=0,n=0,o=0;k=v-160|0,v=k,f=i[r>>2],n=i[r+4>>2]-f|0;i:{if(n>>>0<=7){if(e=C(32),i[k+12>>2]=e,i[k+16>>2]=25,i[k+20>>2]=-2147483616,r=u[20535]|u[20536]<<8|(u[20537]<<16|u[20538]<<24),f=u[20531]|u[20532]<<8|(u[20533]<<16|u[20534]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+25|0]=0,t[e+24|0]=u[20555],r=u[20551]|u[20552]<<8|(u[20553]<<16|u[20554]<<24),f=u[20547]|u[20548]<<8|(u[20549]<<16|u[20550]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[20543]|u[20544]<<8|(u[20545]<<16|u[20546]<<24),f=u[20539]|u[20540]<<8|(u[20541]<<16|u[20542]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,118,k+12|0),t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}e:{r:{f:{if(o=u[f|0],o){i[k+104>>2]=0,i[k+76>>2]=78164,i[k+20>>2]=78144,e=i[19545],i[k+12>>2]=e,r=i[e-12>>2],e=k+12|0,i[r+e>>2]=i[19546],i[k+16>>2]=0,r=e+i[i[k+12>>2]-12>>2]|0,f=k+24|0,J0(r,f),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[k+20>>2]=r,n=i[r-12>>2],r=k+20|0,i[n+r>>2]=i[19548],n=i[19544],i[k+12>>2]=n,i[e+i[n-12>>2]>>2]=i[19549],i[k+76>>2]=78164,i[k+12>>2]=78124,i[k+20>>2]=78144,n=R0(f),i[n>>2]=77200,e=k- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,F(D0(F(r,31484,19),o),17847,17),e=i[k+72>>2];A:{if(e&16){e=k+44|0,f=i[k+68>>2],r=i[k+48>>2],f>>>0<r>>>0?i[k+68>>2]=r:r=f;break A}if(!(e&8)){r=0,t[k+11|0]=0,e=k;break e}e=k+32|0,r=i[k+40>>2]}if(f=i[e>>2],r=r-f|0,r>>>0>=2147483640)break f;if(r>>>0>=11){o=r|7,e=C(o+1|0),i[k+8>>2]=o-2147483647,i[k>>2]=e,i[k+4>>2]=r;break r}if(t[k+11|0]=r,e=k,r)break r;r=0;break e}o=u[f+1|0],X[e>>1]=u[f+2|0]+1,X[e+2>>1]=u[f+3|0]+1,r=e;A:{if(o&1){if(n>>>0<=11){if(e=C(32),i[k+12>>2]=e,i[k+16>>2]=26,i[k+20>>2]=-2147483616,r=u[13308]|u[13309]<<8|(u[13310]<<16|u[13311]<<24),f=u[13304]|u[13305]<<8|(u[13306]<<16|u[13307]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+26|0]=0,r=u[13328]|u[13329]<<8,t[e+24|0]=r,t[e+25|0]=r>>>8,r=u[13324]|u[13325]<<8|(u[13326]<<16|u[13327]<<24),f=u[13320]|u[13321]<<8|(u[13322]<<16|u[13323]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[13316]|u[13317]<<8|(u[13318]<<16|u[13319]<<24),f=u[13312]|u[13313]<<8|(u[13314]<<16|u[13315]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,118,k+12|0),t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}n=e,e=u[f+4|0]|u[f+5|0]<<8|(u[f+6|0]<<16|u[f+7|0]<<24),i[n+4>>2]=e<<24|(e&65280)<<8|(e>>>8&65280|e>>>24),e=u[f+9|0]<<16|u[f+8|0]<<24|u[f+10|0]<<8,f=f+11|0;break A}i[e+4>>2]=u[f+5|0]|u[f+4|0]<<8,e=u[f+6|0]<<8,f=f+7|0}if(i[r+8>>2]=u[f|0]|e,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}I0(),M()}if(!r)break e;z(e,f,r)}t[e+r|0]=0,a(A,4,3002,k),t[k+11|0]<0&&Z(i[k>>2]),A=i[19543],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[19551],i[k+20>>2]=i[19552],i[n>>2]=77200,t[k+67|0]<0&&Z(i[k+56>>2]),y0(n),Y0(k+76|0)}v=k+160|0}function GA(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0;u[136992]||(f=v-16|0,v=f,u[136984]||(k=v-16|0,v=k,i[k+12>>2]=1,i[34207]=i[k+12>>2]-1,i[34206]=90816,i[34206]=85616,i[34206]=84136,e=v-16|0,v=e,i[34208]=0,i[34209]=0,i[e+12>>2]=0,i[34210]=0,t[136964]=0,i[e+4>>2]=136832,t[e+10|0]=0,r=v-16|0,v=r,ks()>>>0<30&&(I4(),M()),Qs(r+8|0,136844,30),n=i[r+8>>2],i[34209]=n,i[34208]=n,i[34210]=(i[r+12>>2]<<2)+n,v=r+16|0,Yu(30),t[e+10|0]=1,v=e+16|0,je(136968,21731),Xw(136832),i[34564]=0,i[34563]=90816,i[34563]=85616,i[34563]=86728,C1(138252,W1(136656)),i[34566]=0,i[34565]=90816,i[34565]=85616,i[34565]=86760,C1(138260,W1(136664)),i[34568]=0,i[34567]=90816,i[34567]=85616,t[138280]=0,i[34569]=0,i[34567]=84156,i[34569]=84208,C1(138268,W1(137008)),i[34572]=0,i[34571]=90816,i[34571]=85616,i[34571]=85672,C1(138284,W1(137e3)),i[34574]=0,i[34573]=90816,i[34573]=85616,i[34573]=85824,C1(138292,W1(137016)),i[34576]=0,i[34575]=90816,i[34575]=85616,i[34575]=85240,o=138308,l=e1(),i[o>>2]=l,C1(138300,W1(137024)),i[34579]=0,i[34578]=90816,i[34578]=85616,i[34578]=85972,C1(138312,W1(137032)),i[34581]=0,i[34580]=90816,i[34580]=85616,i[34580]=86204,C1(138320,W1(137048)),i[34583]=0,i[34582]=90816,i[34582]=85616,i[34582]=86088,C1(138328,W1(137040)),i[34585]=0,i[34584]=90816,i[34584]=85616,i[34584]=86320,C1(138336,W1(137056)),i[34587]=0,i[34586]=90816,i[34586]=85616,X[69176]=11310,i[34586]=85288,e=v-16|0,v=e,i[34589]=0,i[34590]=0,i[34591]=0,v=e+16|0,C1(138344,W1(137064)),i[34593]=0,i[34592]=90816,i[34592]=85616,i[34594]=46,i[34595]=44,i[34592]=85328,e=v-16|0,v=e,i[34596]=0,i[34597]=0,i[34598]=0,v=e+16|0,C1(138368,W1(137072)),i[34600]=0,i[34599]=90816,i[34599]=85616,i[34599]=86792,C1(138396,W1(136672)),i[34602]=0,i[34601]=90816,i[34601]=85616,i[34601]=87040,C1(138404,W1(136680)),i[34604]=0,i[34603]=90816,i[34603]=85616,i[34603]=87252,C1(138412,W1(136688)),i[34606]=0,i[34605]=90816,i[34605]=85616,i[34605]=87488,C1(138420,W1(136696)),i[34608]=0,i[34607]=90816,i[34607]=85616,i[34607]=88484,C1(138428,W1(136736)),i[34610]=0,i[34609]=90816,i[34609]=85616,i[34609]=88632,C1(138436,W1(136744)),i[34612]=0,i[34611]=90816,i[34611]=85616,i[34611]=88748,C1(138444,W1(136752)),i[34614]=0,i[34613]=90816,i[34613]=85616,i[34613]=88864,C1(138452,W1(136760)),i[34616]=0,i[34615]=90816,i[34615]=85616,i[34615]=88980,C1(138460,W1(136768)),i[34618]=0,i[34617]=90816,i[34617]=85616,i[34617]=89148,C1(138468,W1(136776)),i[34620]=0,i[34619]=90816,i[34619]=85616,i[34619]=89316,C1(138476,W1(136784)),i[34622]=0,i[34621]=90816,i[34621]=85616,i[34621]=89484,C1(138484,W1(136792)),i[34624]=0,i[34623]=90816,i[34623]=85616,i[34625]=90744,i[34623]=87688,i[34625]=87736,C1(138492,W1(136704)),i[34627]=0,i[34626]=90816,i[34626]=85616,i[34628]=90780,i[34626]=87956,i[34628]=88004,C1(138504,W1(136712)),i[34630]=0,i[34629]=90816,i[34629]=85616,xh(138524),i[34629]=88196,C1(138516,W1(136720)),i[34633]=0,i[34632]=90816,i[34632]=85616,xh(138536),i[34632]=88356,C1(138528,W1(136728)),i[34636]=0,i[34635]=90816,i[34635]=85616,i[34635]=89652,C1(138540,W1(136800)),i[34638]=0,i[34637]=90816,i[34637]=85616,i[34637]=89772,C1(138548,W1(136808)),v=k+16|0,i[f+8>>2]=136824,i[34245]=i[f+8>>2],t[136984]=1),v=f+16|0,e=i[34245],i[34247]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),t[136992]=1),e=A,A=i[34247],i[e>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1)}function Lm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,n=i[19620],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19621],k=n+i[i[f+8>>2]-12>>2]|0,o=f+12|0,J0(k,o),t[k+80|0]=0,i[k+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,s=R0(o),i[s>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,J2(k,e,r),l=n,o=k,n=t[f+159|0],k=(n|0)<0,F(l,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,k0(n,r),l=n,n=t[f+159|0],k=(n|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(D0(F(f+8|0,34691,9),u[e+97|0]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(D0(F(n,36706,13),u[e+98|0]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(D0(F(n,37691,17),u[e+99|0]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(D0(F(n,35033,15),u[e+101|0]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(D0(F(n,33315,12),u[e+102|0]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(D0(F(n,36631,12),u[e+103|0]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(D0(F(n,33205,22),u[e+104|0]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(D0(F(n,32938,22),u[e+105|0]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(D0(F(n,34439,24),u[e+106|0]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(n,32881,28);i:{if(u[e+107|0]){F(D0(f+8|0,u[e+108|0]+1|0),47878,1);break i}F(f+8|0,37933,12)}if(n=f+148|0,k0(n,r),k=0,l=n,r=t[f+159|0],n=(r|0)<0,F(f+8|0,n?i[f+148>>2]:l,n?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,22874,12),i[e+116>>2]!=i[e+112>>2])for(;n=F(f+8|0,37886,1),o=i[n>>2],r=o-12|0,l=i[r>>2]+n|0,i[l+4>>2]=i[l+4>>2]&-75|8,r=n+i[r>>2]|0,u[r+80|0]||(l=f+148|0,o=i[r+28>>2],i[l>>2]=o,(o|0)!=136824&&(i[o+4>>2]=i[o+4>>2]+1),o=$0(l,137008),W[i[i[o>>2]+28>>2]](o,32)|0,i2(l),o=i[n>>2]),t[r+76|0]=48,t[r+77|0]=0,t[r+78|0]=0,t[r+79|0]=0,t[r+80|0]=1,i[(n+i[o-12>>2]|0)+12>>2]=2,D0(n,u[i[e+112>>2]+k|0]),k=k+1|0,k>>>0<i[e+116>>2]-i[e+112>>2]>>>0;);e=f+8|0,r=e+i[i[f+8>>2]-12>>2]|0,i[r+4>>2]=i[r+4>>2]&-75|2,F(e,47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,n,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[s>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(s),Y0(f- -64|0),v=f+160|0}function qm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;k=v-192|0,v=k,S2(k+172|0,e,r),t[k+191|0]<0&&Z(i[k+180>>2]);i:{e:{r:{if(u[e+97|0]){B1(A,e,1104);break r}B=e,m=F0(r),i[B+104>>2]=m,n=F0(r),i[e+108>>2]=n;f:{if(i[e+104>>2])break f;if(l=i[f+80>>2],!(!l|n>>>0<=l>>>0)){if(e=C(64),i[k+24>>2]=e,i[k+28>>2]=61,i[k+32>>2]=-2147483584,r=u[18943]|u[18944]<<8|(u[18945]<<16|u[18946]<<24),f=u[18939]|u[18940]<<8|(u[18941]<<16|u[18942]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+61|0]=0,r=u[18996]|u[18997]<<8|(u[18998]<<16|u[18999]<<24),f=u[18992]|u[18993]<<8|(u[18994]<<16|u[18995]<<24),t[e+53|0]=f,t[e+54|0]=f>>>8,t[e+55|0]=f>>>16,t[e+56|0]=f>>>24,t[e+57|0]=r,t[e+58|0]=r>>>8,t[e+59|0]=r>>>16,t[e+60|0]=r>>>24,r=u[18991]|u[18992]<<8|(u[18993]<<16|u[18994]<<24),f=u[18987]|u[18988]<<8|(u[18989]<<16|u[18990]<<24),t[e+48|0]=f,t[e+49|0]=f>>>8,t[e+50|0]=f>>>16,t[e+51|0]=f>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[18983]|u[18984]<<8|(u[18985]<<16|u[18986]<<24),f=u[18979]|u[18980]<<8|(u[18981]<<16|u[18982]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[18975]|u[18976]<<8|(u[18977]<<16|u[18978]<<24),f=u[18971]|u[18972]<<8|(u[18973]<<16|u[18974]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[18967]|u[18968]<<8|(u[18969]<<16|u[18970]<<24),f=u[18963]|u[18964]<<8|(u[18965]<<16|u[18966]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[18959]|u[18960]<<8|(u[18961]<<16|u[18962]<<24),f=u[18955]|u[18956]<<8|(u[18957]<<16|u[18958]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[18951]|u[18952]<<8|(u[18953]<<16|u[18954]<<24),f=u[18947]|u[18948]<<8|(u[18949]<<16|u[18950]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,1e3,k+24|0),t[k+35|0]>=0)break r;Z(i[k+24>>2]);break r}if(D4(A,e+124|0,n<<2,f,14835),i[A>>2])break r;if(t[A+19|0]<0&&Z(i[A+8>>2]),!i[e+108>>2])break f;for(;;){if(!i[r+16>>2]){r=ri(k+24|0),F(B0(F(B0(F(r+8|0,31562,24),i[e+108>>2]),32551,33),w),6019,8),e=k+12|0,ki(e,r),a(A,2,100,e),t[k+23|0]<0&&Z(i[k+12>>2]),F8(r);break r}h=F0(r),f=i[e+116>>2],o=i[e+120>>2];A:{if(f>>>0<o>>>0){i[f>>2]=h,f=f+4|0;break A}if(l=i[e+112>>2],f=f-l|0,_=f>>2,n=_+1|0,n>>>0>=1073741824)break e;if(o=o-l|0,s=o>>1,o=o>>>0>=2147483644?1073741823:n>>>0<s>>>0?s:n,o){if(o>>>0>=1073741824)break i;n=C(o<<2)}else n=0;if(s=n+f|0,i[s>>2]=h,h=s-(_<<2)|0,f&&z(h,l,f),i[e+120>>2]=n+(o<<2),f=s+4|0,i[e+116>>2]=f,i[e+112>>2]=h,!l)break A;Z(l)}if(i[e+116>>2]=f,u[r+20|0]==1){Au(A,r);break r}if(w=w+1|0,!(w>>>0<o0[e+108>>2]))break}}if(u[r+20|0]==1){if(t[k+24|0]=0,t[k+35|0]=0,a(A,2,100,k+24|0),t[k+35|0]>=0)break r;Z(i[k+24>>2]);break r}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break r}T(A,i[28730],i[28731])}v=k+192|0;return}s0(),M()}x0(),M()}function f6(A,e,r,f,k,n,o,l,s,h){var w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0;w=s<<2,m=i[w+68752>>2]+n|0,w=i[w+68736>>2],G=m+w|0,Q=h-8|0,h=i[(l<<2)+68736>>2];i:{e:switch(l|0){case 0:if(B=0-w|0,(m|0)<=(B|0)|(k|0)<=0)break i;for(V=(w<<1)+o|0,Y=r-(h<<1)|0,E=k&2147483644,I=k&3,R=k>>>0<4;;){if(h=(B<<1)+V|0,w=(g(f,B)<<1)+Y|0,_=0,!R)for(;X[h>>1]=p[w>>1],r=G<<1,h=r+h|0,X[h>>1]=p[w+2>>1],h=r+h|0,X[h>>1]=p[w+4>>1],h=r+h|0,X[h>>1]=p[w+6>>1],h=r+h|0,w=w+8|0,_=_+4|0,(E|0)!=(_|0););if(r=0,I)for(;X[h>>1]=p[w>>1],w=w+2|0,h=(G<<1)+h|0,r=r+1|0,(I|0)!=(r|0););if(B=B+1|0,(m|0)==(B|0))break}break i;case 1:if(_=0-w|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(w<<1)+o|0,I=r-(h<<1)|0;;){for(h=B+(_<<1)|0,w=I+(g(f,_)<<1)|0,r=0;X[h>>1]=p[w+12>>1]+((((((p[w+2>>1]<<2)-p[w>>1]|0)+g(p[w+4>>1],-10)|0)+g(p[w+6>>1],58)|0)+g(p[w+8>>1],17)|0)+g(p[w+10>>1],-5)|0)>>Q,w=w+2|0,h=(G<<1)+h|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 2:if(_=0-w|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(w<<1)+o|0,I=r-(h<<1)|0;;){for(h=B+(_<<1)|0,w=I+(g(f,_)<<1)|0,r=0;X[h>>1]=(((((p[w+2>>1]<<2)-p[w>>1]|0)+g(p[w+8>>1]+p[w+6>>1]|0,40)|0)+(p[w+12>>1]<<2)|0)-p[w+14>>1]|0)+g(p[w+10>>1]+p[w+4>>1]|0,-11)>>Q,w=w+2|0,h=(G<<1)+h|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 3:break e;default:break i}if(_=0-w|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(w<<1)+o|0,I=r-(h<<1)|0;;){for(h=B+(_<<1)|0,w=I+(g(f,_)<<1)|0,r=0;X[h>>1]=(((((p[w>>1]+g(p[w+2>>1],-5)|0)+g(p[w+4>>1],17)|0)+g(p[w+6>>1],58)|0)+g(p[w+8>>1],-10)|0)+(p[w+10>>1]<<2)|0)-p[w+12>>1]>>Q,w=w+2|0,h=(G<<1)+h|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}}f=l?6:Q;i:{e:switch(s|0){case 3:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(h=(_<<1)+A|0,w=(g(_,G)<<1)+o|0,r=0;X[h>>1]=(((((X[w>>1]+g(X[w+2>>1],-5)|0)+g(X[w+4>>1],17)|0)+g(X[w+6>>1],58)|0)+g(X[w+8>>1],-10)|0)+(X[w+10>>1]<<2)|0)-X[w+12>>1]>>f,w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 2:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(h=(_<<1)+A|0,w=(g(_,G)<<1)+o|0,r=0;X[h>>1]=(((((X[w+2>>1]<<2)-X[w>>1]|0)+g(X[w+8>>1]+X[w+6>>1]|0,40)|0)+(X[w+12>>1]<<2)|0)-X[w+14>>1]|0)+g(X[w+10>>1]+X[w+4>>1]|0,-11)>>f,w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 1:if((k|0)<=0)break i;for(_=0,l=(n|0)<=0;;){if(!l)for(h=(_<<1)+A|0,w=(g(_,G)<<1)+o|0,r=0;X[h>>1]=X[w+12>>1]+((((((X[w+2>>1]<<2)-X[w>>1]|0)+g(X[w+4>>1],-10)|0)+g(X[w+6>>1],58)|0)+g(X[w+8>>1],17)|0)+g(X[w+10>>1],-5)|0)>>f,w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 0:break e;default:break i}if((k|0)<=0)break i;for(_=n&2147483644,s=n&3,f=0,m=(n|0)<=0;;){e:{if(m)break e;if(h=(f<<1)+A|0,w=(g(f,G)<<1)+o|0,r=0,n>>>0>3)for(;X[h>>1]=p[w>>1],l=e<<1,h=l+h|0,X[h>>1]=p[w+2>>1],h=l+h|0,X[h>>1]=p[w+4>>1],h=l+h|0,X[h>>1]=p[w+6>>1],h=l+h|0,w=w+8|0,r=r+4|0,(_|0)!=(r|0););if(r=0,!s)break e;for(;X[h>>1]=p[w>>1],w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(s|0)!=(r|0););}if(f=f+1|0,(k|0)==(f|0))break}}}function am(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;k=v-16|0,v=k;i:{e:{if(!(i[e+8>>2]|i[e+12>>2])){if(e=C(48),i[k+4>>2]=e,i[k+8>>2]=44,i[k+12>>2]=-2147483600,r=u[18015]|u[18016]<<8|(u[18017]<<16|u[18018]<<24),f=u[18011]|u[18012]<<8|(u[18013]<<16|u[18014]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+44|0]=0,r=u[18051]|u[18052]<<8|(u[18053]<<16|u[18054]<<24),t[e+40|0]=r,t[e+41|0]=r>>>8,t[e+42|0]=r>>>16,t[e+43|0]=r>>>24,r=u[18047]|u[18048]<<8|(u[18049]<<16|u[18050]<<24),f=u[18043]|u[18044]<<8|(u[18045]<<16|u[18046]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[18039]|u[18040]<<8|(u[18041]<<16|u[18042]<<24),f=u[18035]|u[18036]<<8|(u[18037]<<16|u[18038]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[18031]|u[18032]<<8|(u[18033]<<16|u[18034]<<24),f=u[18027]|u[18028]<<8|(u[18029]<<16|u[18030]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[18023]|u[18024]<<8|(u[18025]<<16|u[18026]<<24),f=u[18019]|u[18020]<<8|(u[18021]<<16|u[18022]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,4,0,k+4|0),t[k+15|0]>=0)break e;Z(i[k+4>>2]);break e}if(l=i[f+40>>2],f=i[f+44>>2],o=i[r+16>>2],!(!(l|f)|(!f&o>>>0<=l>>>0|(f|0)!=0))){if(e=C(32),i[k+4>>2]=e,i[k+8>>2]=31,i[k+12>>2]=-2147483616,r=u[12650]|u[12651]<<8|(u[12652]<<16|u[12653]<<24),f=u[12646]|u[12647]<<8|(u[12648]<<16|u[12649]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+31|0]=0,r=u[12673]|u[12674]<<8|(u[12675]<<16|u[12676]<<24),f=u[12669]|u[12670]<<8|(u[12671]<<16|u[12672]<<24),t[e+23|0]=f,t[e+24|0]=f>>>8,t[e+25|0]=f>>>16,t[e+26|0]=f>>>24,t[e+27|0]=r,t[e+28|0]=r>>>8,t[e+29|0]=r>>>16,t[e+30|0]=r>>>24,r=u[12666]|u[12667]<<8|(u[12668]<<16|u[12669]<<24),f=u[12662]|u[12663]<<8|(u[12664]<<16|u[12665]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[12658]|u[12659]<<8|(u[12660]<<16|u[12661]<<24),f=u[12654]|u[12655]<<8|(u[12656]<<16|u[12657]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,k+4|0),t[k+15|0]>=0)break e;Z(i[k+4>>2]);break e}n=i[e+104>>2],f=i[e+100>>2],l=n-f|0;r:{if(l>>>0<o>>>0){if(h=o-l|0,s=i[e+108>>2],h>>>0<=s-n>>>0){h&&l0(n,0,h),i[e+104>>2]=n+h;break r}if((o|0)<0)break i;if(n=s-f|0,s=n<<1,s=n>>>0>=1073741823?2147483647:o>>>0<s>>>0?s:o,n=C(s),h&&l0(n+l|0,0,h),l&&z(n,f,l),i[e+108>>2]=n+s,i[e+104>>2]=n+o,i[e+100>>2]=n,!f)break r;Z(f);break r}if(o>>>0>=l>>>0)break r;i[e+104>>2]=f+o}if(s6(r,i[e+100>>2],o),u[r+20|0]==1){if(t[k+4|0]=0,t[k+15|0]=0,a(A,2,100,k+4|0),t[k+15|0]>=0)break e;Z(i[k+4>>2]);break e}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731])}v=k+16|0;return}s0(),M()}function Km(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0;n=v-32|0,v=n;i:{e:{r:{if((K0(i[r>>2],3)|0)!=8||(K0(i[r>>2],4)|0)!=8)break r;if((K0(i[r>>2],5)|0)==8)break e}e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;r:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break r}T(e,i[28735],i[28736])}t[A+20|0]=1;break i}f=$2(i[r>>2],6),k=u[k+8|0];e:{if(!f||(K0(i[r>>2],6)|0)==8)break e;e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;r:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break r}T(e,i[28735],i[28736])}t[A+20|0]=1;break i}m=C(248),e=m,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=101168,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,I=e+12|0,i[e+176>>2]=I,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e)),e=i[r>>2],o=i[e+188>>2],G=i[e+192>>2],t1(I,o,G,1,(f|k)&1?13:12),a0(n+8|0,I,10,o,G,K0(i[r>>2],3),l,0);e:{if(i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,e=A+8|0,t[n+27|0]>=0){r=i[n+20>>2],i[e>>2]=i[n+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+24>>2],t[A+20|0]=1;break e}if(T(e,i[n+16>>2],i[n+20>>2]),e=t[n+27|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}t[n+27|0]<0&&Z(i[n+16>>2]),l=0,e=Q0(i[r>>2],3),e?(N=i[e+40>>2],e=i[e+52>>2]):e=0,w=Q0(i[r>>2],4),w?(l=i[w+52>>2],w=i[w+40>>2]):w=0,_=Q0(i[r>>2],5),_?(U=i[_+40>>2],_=i[_+52>>2]):_=0,B=Q0(I,10),B?(x=i[B+52>>2],B=i[B+40>>2]):B=0;r:{if(f){if(f=0,r=Q0(i[r>>2],6),r?(Q=i[r+40>>2],r=i[r+52>>2]):r=0,!G|!o)break r;for(;;){for(V=g(r,f)+Q|0,Y=g(f,_)+U|0,E=g(f,l)+w|0,s=g(e,f)+N|0,j=B+g(f,x)|0,k=0;h=(k<<3)+j|0,t[h|0]=0,R=u[k+s|0],t[h+2|0]=0,t[h+1|0]=R,R=u[k+E|0],t[h+4|0]=0,t[h+3|0]=R,R=u[k+Y|0],t[h+6|0]=0,t[h+5|0]=R,t[h+7|0]=u[k+V|0],k=k+1|0,(o|0)!=(k|0););if(f=f+1|0,(G|0)==(f|0))break}break r}if(!G|!o)break r;if(r=k&1,h=r?8:6,f=0,r)for(;;){for(Q=g(f,_)+U|0,V=g(f,l)+w|0,Y=g(e,f)+N|0,E=B+g(f,x)|0,k=0;r=E+g(k,h)|0,t[r|0]=0,s=u[k+Y|0],t[r+2|0]=0,t[r+1|0]=s,s=u[k+V|0],t[r+4|0]=0,t[r+3|0]=s,s=u[k+Q|0],t[r+6|0]=0,t[r+7|0]=255,t[r+5|0]=s,k=k+1|0,(o|0)!=(k|0););if(f=f+1|0,(G|0)==(f|0))break r}for(;;){for(Q=g(f,_)+U|0,V=g(f,l)+w|0,Y=g(e,f)+N|0,E=B+g(f,x)|0,r=0;k=E+g(r,h)|0,t[k|0]=0,s=u[r+Y|0],t[k+2|0]=0,t[k+1|0]=s,s=u[r+V|0],t[k+4|0]=0,t[k+3|0]=s,t[k+5|0]=u[r+Q|0],r=r+1|0,(o|0)!=(r|0););if(f=f+1|0,(G|0)==(f|0))break}}t[A+20|0]=0,i[A+4>>2]=m,i[A>>2]=I;break i}if(A=i[m+4>>2],i[m+4>>2]=A-1,A)break i;W[i[i[m>>2]+8>>2]](m),y(m)}v=n+32|0}function $m(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0;f=v-48|0,v=f,e=C(248),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=101168,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,m=e+12|0,i[e+176>>2]=m,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e)),k=i[r>>2],t1(m,i[k+188>>2],i[k+192>>2],i[k+196>>2],i[k+200>>2]);i:{e:{for(;;){s=i[E+64152>>2];r:{if(!$2(i[r>>2],s))break r;if(o=K0(i[r>>2],s),o>>>0>=9){if(n=V8(i[r>>2],s),G=p8(i[r>>2],s),a0(f+24|0,m,s,n,G,8,l,0),i[f+24>>2]){if(r=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=r,k=A+8|0,t[f+43|0]>=0){r=i[f+36>>2],i[k>>2]=i[f+32>>2],i[k+4>>2]=r,i[k+8>>2]=i[f+40>>2],t[A+20|0]=1;break e}if(T(k,i[f+32>>2],i[f+36>>2]),r=t[f+43|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[f+32>>2]);break e}t[f+43|0]<0&&Z(i[f+32>>2]),I=0,k=Q0(i[r>>2],s);f:{if(!k){Q=0,V=0;break f}Q=i[k+40>>2],V=i[k+52>>2]>>>1|0}if(k=Q0(m,s),k?(I=i[k+52>>2],s=i[k+40>>2]):s=0,!G|!n)break r;for(w=o-8|0,R=n&-4,Y=n&3,o=0,N=n-1>>>0<3;;){if(_=s+g(o,I)|0,B=(g(o,V)<<1)+Q|0,k=0,n=0,!N)for(;t[k+_|0]=p[B+(k<<1)>>1]>>>w,h=k|1,t[h+_|0]=p[B+(h<<1)>>1]>>>w,h=k|2,t[h+_|0]=p[B+(h<<1)>>1]>>>w,h=k|3,t[h+_|0]=p[B+(h<<1)>>1]>>>w,k=k+4|0,n=n+4|0,(R|0)!=(n|0););if(n=0,Y)for(;t[k+_|0]=p[B+(k<<1)>>1]>>>w,k=k+1|0,n=n+1|0,(Y|0)!=(n|0););if(o=o+1|0,(G|0)==(o|0))break}break r}if((o|0)!=8){if(n=V8(i[r>>2],s),G=p8(i[r>>2],s),a0(f+24|0,m,s,n,G,8,l,0),i[f+24>>2]){if(r=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=r,k=A+8|0,t[f+43|0]>=0){r=i[f+36>>2],i[k>>2]=i[f+32>>2],i[k+4>>2]=r,i[k+8>>2]=i[f+40>>2],t[A+20|0]=1;break e}if(T(k,i[f+32>>2],i[f+36>>2]),r=t[f+43|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[f+32>>2]);break e}if(t[f+43|0]<0&&Z(i[f+32>>2]),w=1<<16-o,k=(w&65534)>>>o|0,k)for(;w=k|w,k=k>>>o|0,!!k;);I=0,k=Q0(i[r>>2],s);f:{if(!k){Q=0,V=0;break f}Q=i[k+40>>2],V=i[k+52>>2]}if(k=Q0(m,s),k?(I=i[k+52>>2],s=i[k+40>>2]):s=0,!G|!n)break r;for(R=n&-4,Y=n&3,o=0,N=n-1>>>0<3;;){if(_=s+g(o,I)|0,B=g(o,V)+Q|0,k=0,n=0,!N)for(;t[k+_|0]=g(u[k+B|0],w)>>>8,h=k|1,t[h+_|0]=g(u[B+h|0],w)>>>8,h=k|2,t[h+_|0]=g(u[B+h|0],w)>>>8,h=k|3,t[h+_|0]=g(u[B+h|0],w)>>>8,k=k+4|0,n=n+4|0,(R|0)!=(n|0););if(n=0,Y)for(;t[k+_|0]=g(u[k+B|0],w)>>>8,k=k+1|0,n=n+1|0,(Y|0)!=(n|0););if(o=o+1|0,(G|0)==(o|0))break}break r}if(K4(f+4|0,m,r,s,s,l),t[f+23|0]>=0)break r;Z(i[f+12>>2])}if(E=E+4|0,(E|0)==28)break}t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=m;break i}if(A=i[e+4>>2],i[e+4>>2]=A-1,A)break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=f+48|0}function wn(A,e,r){var f=0,k=0,n=0,o=0,l=0;k=v-16|0,v=k;i:{e:{if(i[e+64>>2])break e;r:{if(!i[r+24>>2])break r;o=W[i[i[e>>2]+8>>2]](e)|0,l=i[r+24>>2],Zr(),f=i[28738];f:{if((f|0)!=114956)for(;;){A:{if(n=i[f+16>>2],(W[i[n+16>>2]](o)|0)<=0||v4(l,i[n+40>>2]))break A;f=1;break f}n=i[f+4>>2];A:{if(n){for(;;)if(f=n,n=i[f>>2],!n)break A}for(;n=f,f=i[f+8>>2],(n|0)!=i[f>>2];);}if((f|0)==114956)break}f=0}if(f)break r;if(e=C(32),i[k+4>>2]=e,i[k+8>>2]=30,i[k+12>>2]=-2147483616,r=u[28585]|u[28586]<<8|(u[28587]<<16|u[28588]<<24),f=u[28581]|u[28582]<<8|(u[28583]<<16|u[28584]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+30|0]=0,r=u[28607]|u[28608]<<8|(u[28609]<<16|u[28610]<<24),f=u[28603]|u[28604]<<8|(u[28605]<<16|u[28606]<<24),t[e+22|0]=f,t[e+23|0]=f>>>8,t[e+24|0]=f>>>16,t[e+25|0]=f>>>24,t[e+26|0]=r,t[e+27|0]=r>>>8,t[e+28|0]=r>>>16,t[e+29|0]=r>>>24,r=u[28601]|u[28602]<<8|(u[28603]<<16|u[28604]<<24),f=u[28597]|u[28598]<<8|(u[28599]<<16|u[28600]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[28593]|u[28594]<<8|(u[28595]<<16|u[28596]<<24),f=u[28589]|u[28590]<<8|(u[28591]<<16|u[28592]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,11,0,k+4|0),t[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(f=e,e=Go(W[i[i[e>>2]+8>>2]](e)|0,i[r+24>>2]),i[f+64>>2]=e,!e){if(t[k+4|0]=0,t[k+15|0]=0,a(A,11,6003,k+4|0),t[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(i[e>>2]>4)break e;if(e=C(48),i[k+4>>2]=e,i[k+8>>2]=46,i[k+12>>2]=-2147483600,r=u[29057]|u[29058]<<8|(u[29059]<<16|u[29060]<<24),f=u[29053]|u[29054]<<8|(u[29055]<<16|u[29056]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+46|0]=0,r=u[29095]|u[29096]<<8|(u[29097]<<16|u[29098]<<24),f=u[29091]|u[29092]<<8|(u[29093]<<16|u[29094]<<24),t[e+38|0]=f,t[e+39|0]=f>>>8,t[e+40|0]=f>>>16,t[e+41|0]=f>>>24,t[e+42|0]=r,t[e+43|0]=r>>>8,t[e+44|0]=r>>>16,t[e+45|0]=r>>>24,r=u[29089]|u[29090]<<8|(u[29091]<<16|u[29092]<<24),f=u[29085]|u[29086]<<8|(u[29087]<<16|u[29088]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[29081]|u[29082]<<8|(u[29083]<<16|u[29084]<<24),f=u[29077]|u[29078]<<8|(u[29079]<<16|u[29080]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[29073]|u[29074]<<8|(u[29075]<<16|u[29076]<<24),f=u[29069]|u[29070]<<8|(u[29071]<<16|u[29072]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[29065]|u[29066]<<8|(u[29067]<<16|u[29068]<<24),f=u[29061]|u[29062]<<8|(u[29063]<<16|u[29064]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,11,6003,k+4|0),t[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}v=k+16|0}function A6(A,e,r,f,k,n,o,l,s){var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;h=s<<2,m=i[h+68752>>2]+n|0,h=i[h+68736>>2],G=m+h|0,w=i[(l<<2)+68736>>2];i:{e:switch(l|0){case 0:if(B=0-h|0,(m|0)<=(B|0)|(k|0)<=0)break i;for(Q=(h<<1)+o|0,V=r-w|0,Y=k&2147483644,I=k&3,E=k>>>0<4;;){if(w=(B<<1)+Q|0,h=g(f,B)+V|0,_=0,!E)for(;X[w>>1]=u[h|0],r=G<<1,w=r+w|0,X[w>>1]=u[h+1|0],w=r+w|0,X[w>>1]=u[h+2|0],w=r+w|0,X[w>>1]=u[h+3|0],w=r+w|0,h=h+4|0,_=_+4|0,(Y|0)!=(_|0););if(r=0,I)for(;X[w>>1]=u[h|0],h=h+1|0,w=(G<<1)+w|0,r=r+1|0,(I|0)!=(r|0););if(B=B+1|0,(m|0)==(B|0))break}break i;case 1:if(_=0-h|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(h<<1)+o|0,I=r-w|0;;){for(w=B+(_<<1)|0,h=I+g(f,_)|0,r=0;X[w>>1]=u[h+6|0]+((((((u[h+1|0]<<2)-u[h|0]|0)+g(u[h+2|0],-10)|0)+g(u[h+3|0],58)|0)+g(u[h+4|0],17)|0)+g(u[h+5|0],-5)|0),h=h+1|0,w=(G<<1)+w|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 2:if(_=0-h|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(h<<1)+o|0,I=r-w|0;;){for(w=B+(_<<1)|0,h=I+g(f,_)|0,r=0;X[w>>1]=(((((u[h+1|0]<<2)-u[h|0]|0)+g(u[h+4|0]+u[h+3|0]|0,40)|0)+(u[h+6|0]<<2)|0)-u[h+7|0]|0)+g(u[h+5|0]+u[h+2|0]|0,-11),h=h+1|0,w=(G<<1)+w|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 3:break e;default:break i}if(_=0-h|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(h<<1)+o|0,I=r-w|0;;){for(w=B+(_<<1)|0,h=I+g(f,_)|0,r=0;X[w>>1]=(((((u[h|0]+g(u[h+1|0],-5)|0)+g(u[h+2|0],17)|0)+g(u[h+3|0],58)|0)+g(u[h+4|0],-10)|0)+(u[h+5|0]<<2)|0)-u[h+6|0],h=h+1|0,w=(G<<1)+w|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}}f=l?6:0;i:{e:switch(s|0){case 3:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(w=(_<<1)+A|0,h=(g(_,G)<<1)+o|0,r=0;X[w>>1]=(((((X[h>>1]+g(X[h+2>>1],-5)|0)+g(X[h+4>>1],17)|0)+g(X[h+6>>1],58)|0)+g(X[h+8>>1],-10)|0)+(X[h+10>>1]<<2)|0)-X[h+12>>1]>>f,h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 2:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(w=(_<<1)+A|0,h=(g(_,G)<<1)+o|0,r=0;X[w>>1]=(((((X[h+2>>1]<<2)-X[h>>1]|0)+g(X[h+8>>1]+X[h+6>>1]|0,40)|0)+(X[h+12>>1]<<2)|0)-X[h+14>>1]|0)+g(X[h+10>>1]+X[h+4>>1]|0,-11)>>f,h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 1:if((k|0)<=0)break i;for(_=0,l=(n|0)<=0;;){if(!l)for(w=(_<<1)+A|0,h=(g(_,G)<<1)+o|0,r=0;X[w>>1]=X[h+12>>1]+((((((X[h+2>>1]<<2)-X[h>>1]|0)+g(X[h+4>>1],-10)|0)+g(X[h+6>>1],58)|0)+g(X[h+8>>1],17)|0)+g(X[h+10>>1],-5)|0)>>f,h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 0:break e;default:break i}if((k|0)<=0)break i;for(_=n&2147483644,s=n&3,f=0,m=(n|0)<=0;;){e:{if(m)break e;if(w=(f<<1)+A|0,h=(g(f,G)<<1)+o|0,r=0,n>>>0>3)for(;X[w>>1]=p[h>>1],l=e<<1,w=l+w|0,X[w>>1]=p[h+2>>1],w=l+w|0,X[w>>1]=p[h+4>>1],w=l+w|0,X[w>>1]=p[h+6>>1],w=l+w|0,h=h+8|0,r=r+4|0,(_|0)!=(r|0););if(r=0,!s)break e;for(;X[w>>1]=p[h>>1],h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(s|0)!=(r|0););}if(f=f+1|0,(k|0)==(f|0))break}}}function Gi(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;r=v-32|0,v=r,f=i[e>>2],f>>>0>13?f=7186:f=i[(f<<2)+100596>>2],s=ln(i[e+4>>2]);i:{e:{r:{f:{A:{if(o=i[e+8>>2],n=l2(o),n>>>0<2147483640){k:{n:{if(n>>>0>=11){l=n|7,k=C(l+1|0),i[r+24>>2]=l-2147483647,i[r+16>>2]=k,i[r+20>>2]=n;break n}if(t[r+27|0]=n,k=r+16|0,!n)break k}if(!n)break k;z(k,o,n)}if(t[n+k|0]=0,o=l2(f),o>>>0>=2147483640)break i;k:{n:{if(o>>>0>=11){n=o|7,k=C(n+1|0),i[r+12>>2]=n-2147483647,i[r+4>>2]=k,i[r+8>>2]=o;break n}if(t[r+15|0]=o,k=r+4|0,!o)break k}if(!o)break k;z(k,f,o)}if(n=0,t[k+o|0]=0,k=t[r+27|0],l=(k|0)<0,h=t[r+15|0],w=(h|0)<0,o=l?i[r+20>>2]:k,_=w?i[r+8>>2]:h,o>>>0>=_>>>0){if((_|0)==-1)break A;n=!N2(l?i[r+16>>2]:r+16|0,w?i[r+4>>2]:r+4|0,_)}(h|0)<0&&Z(i[r+4>>2]);k:{if(!n)break k;if(l=l2(f),l>>>0>o>>>0)break f;if(f=o-l|0,f>>>0>=2147483640)break i;h=i[r+16>>2];n:{t:{if(f>>>0>=11){o=f|7,n=C(o+1|0),i[r+12>>2]=o-2147483647,i[r+4>>2]=n,i[r+8>>2]=f;break t}if(t[r+15|0]=f,n=r+4|0,(o|0)==(l|0))break n}if(!f)break n;z(n,l+((k|0)<0?h:r+16|0)|0,f)}t[f+n|0]=0,t[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f,X[r+4>>1]=8250,f=t[r+27|0],n=(f|0)<0,f=n?i[r+20>>2]:f;n:{if(f>>>0<=1||(o=i[r+16>>2],k=n?o:r+16|0,p[r+4>>1]!=(u[k|0]|u[k+1|0]<<8)))break n;if(f=f-2|0,f>>>0>=2147483640)break i;t:{o:{if(f>>>0>=11){l=f|7,k=C(l+1|0),i[r+12>>2]=l-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break o}if(t[r+15|0]=f,k=r+4|0,!f)break t}if(!f)break t;z(k,(n?o:r+16|0)+2|0,f)}t[f+k|0]=0,t[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f}if(f=l2(s),f>>>0>=2147483640)break i;n:{t:{if(f>>>0>=11){n=f|7,k=C(n+1|0),i[r+12>>2]=n-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break t}if(t[r+15|0]=f,k=r+4|0,!f)break n}if(!f)break n;z(k,s,f)}if(n=0,t[f+k|0]=0,k=t[r+27|0],f=(k|0)<0,l=t[r+15|0],h=(l|0)<0,o=f?i[r+20>>2]:k,w=h?i[r+8>>2]:l,o>>>0>=w>>>0){if((w|0)==-1)break r;n=!N2(f?i[r+16>>2]:r+16|0,h?i[r+4>>2]:r+4|0,w)}if((l|0)<0&&Z(i[r+4>>2]),!n)break k;if(s=l2(s),s>>>0>o>>>0)break e;if(f=o-s|0,f>>>0>=2147483640)break i;l=i[r+16>>2];n:{t:{if(f>>>0>=11){o=f|7,n=C(o+1|0),i[r+12>>2]=o-2147483647,i[r+4>>2]=n,i[r+8>>2]=f;break t}if(t[r+15|0]=f,n=r+4|0,(o|0)==(s|0))break n}if(!f)break n;z(n,s+((k|0)<0?l:r+16|0)|0,f)}if(t[f+n|0]=0,t[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f,X[r+4>>1]=8250,k=t[r+27|0],n=(k|0)<0,f=n?i[r+20>>2]:k,f>>>0<=1||(o=i[r+16>>2],s=n?o:r+16|0,p[r+4>>1]!=(u[s|0]|u[s+1|0]<<8)))break k;if(f=f-2|0,f>>>0>=2147483640)break i;n:{t:{if(f>>>0>=11){s=f|7,k=C(s+1|0),i[r+12>>2]=s-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break t}if(t[r+15|0]=f,k=r+4|0,!f)break n}if(!f)break n;z(k,(n?o:r+16|0)+2|0,f)}t[f+k|0]=0,t[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f,k=u[r+27|0]}f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,A=A+8|0;k:{if(k<<24>>24>=0){e=i[r+20>>2],i[A>>2]=i[r+16>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+24>>2];break k}e=A,A=i[r+16>>2],T(e,A,i[r+20>>2]),Z(A)}v=r+32|0;return}I0(),M()}uf(),M()}uf(),M()}uf(),M()}uf(),M()}I0(),M()}function dm(){var A=0,e=0,r=0,f=0,k=0,n=0;A=v-16|0,v=A;i:{if(dB(A+12|0,A+8|0)|0||(e=E2((i[A+12>>2]<<2)+4|0),i[33137]=e,!e)||(e=E2(i[A+8>>2]),e&&(r=i[33137],i[r+(i[A+12>>2]<<2)>>2]=0,!($B(r|0,e|0)|0))))break i;i[33137]=0}v=A+16|0,u[136409]||(r=i[19803],f=v-16|0,v=f,A=R0(136056),i[A+40>>2]=136112,i[A+32>>2]=r,i[A>>2]=79540,t[A+52|0]=0,i[A+48>>2]=-1,k=f+12|0,e=i[A+4>>2],i[k>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),W[i[i[A>>2]+8>>2]](A,k),i2(k),v=f+16|0,i[33844]=0,i[33837]=79176,i[33837]=77328,i[33835]=76860,i[33837]=76880,i[33836]=0,vf(i[19212]+135340|0,136056),k=i[18381],Wu(136120,k,136168),c5(135524,136120),n=i[18380],Wu(136176,n,136224),c5(135700,136176),c5(135876,i[(i[i[33925]-12>>2]+135700|0)+24>>2]),i[(i[i[33835]-12>>2]+135340|0)+72>>2]=135524,A=i[i[33925]-12>>2]+135700|0,i[A+4>>2]=i[A+4>>2]|8192,i[(i[i[33925]-12>>2]+135700|0)+72>>2]=135524,f=v-16|0,v=f,A=Ys(136232),i[A+40>>2]=136288,i[A+32>>2]=r,i[A>>2]=79744,t[A+52|0]=0,i[A+48>>2]=-1,r=f+12|0,e=i[A+4>>2],i[r>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),W[i[i[A>>2]+8>>2]](A,r),i2(r),v=f+16|0,i[33867]=0,i[33860]=79176,i[33860]=77764,i[33858]=77108,i[33860]=77128,i[33859]=0,vf(i[19274]+135432|0,136232),Xu(136296,k,136344),i7(135612,136296),Xu(136352,n,136400),i7(135788,136352),i7(135964,i[(i[i[33947]-12>>2]+135788|0)+24>>2]),i[(i[i[33858]-12>>2]+135432|0)+72>>2]=135612,A=i[i[33947]-12>>2]+135788|0,i[A+4>>2]=i[A+4>>2]|8192,i[(i[i[33947]-12>>2]+135788|0)+72>>2]=135612,t[136409]=1),i[28728]=0,i[28729]=0,t[114931]=0,t[114920]=0,A=C(16),t[A+14|0]=0,e=u[7302]|u[7303]<<8|(u[7304]<<16|u[7305]<<24),r=u[7298]|u[7299]<<8|(u[7300]<<16|u[7301]<<24),t[A+6|0]=r,t[A+7|0]=r>>>8,t[A+8|0]=r>>>16,t[A+9|0]=r>>>24,t[A+10|0]=e,t[A+11|0]=e>>>8,t[A+12|0]=e>>>16,t[A+13|0]=e>>>24,e=u[7296]|u[7297]<<8|(u[7298]<<16|u[7299]<<24),r=u[7292]|u[7293]<<8|(u[7294]<<16|u[7295]<<24),t[A|0]=r,t[A+1|0]=r>>>8,t[A+2|0]=r>>>16,t[A+3|0]=r>>>24,t[A+4|0]=e,t[A+5|0]=e>>>8,t[A+6|0]=e>>>16,t[A+7|0]=e>>>24,i[28733]=4,i[28734]=0,T(114940,A,14),Z(A),i[28739]=0,i[28740]=0,i[28738]=114956,i[28741]=114968,i[28742]=0,i[28743]=0,$A(),i[28752]=0,i[28753]=0,i[28751]=115008,i[28757]=0,i[28756]=967,c9(),i[28757]=i[33133],i[33133]=115024,A=v-80|0,v=A,i[28761]=0,i[28762]=0,i[28760]=115044,e=i[14388],i[A+48>>2]=i[14387],i[A+52>>2]=e,e=i[14386],i[A+40>>2]=i[14385],i[A+44>>2]=e,e=i[14384],i[A+32>>2]=i[14383],i[A+36>>2]=e,e=i[14382],i[A+24>>2]=i[14381],i[A+28>>2]=e,e=i[14380],i[A+16>>2]=i[14379],i[A+20>>2]=e,e=i[14378],i[A+8>>2]=i[14377],i[A+12>>2]=e,e=A+8|0,Ne(115040,e,A+56|0),z(e,57556,68),i[28763]=115056,i[28764]=0,i[28765]=0,Ne(115052,e,A+76|0),i[28767]=0,i[28768]=0,i[28766]=115068,r=i[14419],i[A+56>>2]=i[14418],i[A+60>>2]=r,r=i[14417],i[A+48>>2]=i[14416],i[A+52>>2]=r,r=i[14415],i[A+40>>2]=i[14414],i[A+44>>2]=r,r=i[14413],i[A+32>>2]=i[14412],i[A+36>>2]=r,r=i[14411],i[A+24>>2]=i[14410],i[A+28>>2]=r,r=i[14409],i[A+16>>2]=i[14408],i[A+20>>2]=r,r=i[14407],i[A+8>>2]=i[14406],i[A+12>>2]=r,Ne(115064,e,A- -64|0),v=A+80|0,i[33134]=1998,i[33135]=0,Lt(),i[33135]=i[33133],i[33133]=132536,i[33178]=132592,i[33168]=65536,i[33167]=204096,i[33160]=42,i[33169]=i[28608]}function _n(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0;if(Q=v-2176|0,v=Q,(e|0)>0){G=e>>>1|0;i:{if(e>>>0>=8){for(h=e>>>2|0,x=e&2,U=G&1073741822,o=Q- -64|0,k=Q;;){e:{if((e|0)==1)break e;if(w=(g(f,R)<<1)+r|0,n=0,l=0,(G|0)!=1)for(;_=n<<1,s=_+w|0,m=o+_|0,_=n+G<<1,B=_+w|0,X[m>>1]=p[B>>1]+p[s>>1],X[o+_>>1]=p[s>>1]-p[B>>1],s=n|1,_=s<<1,m=_+o|0,s=s+G<<1,B=s+w|0,_=w+_|0,X[m>>1]=p[B>>1]+p[_>>1],X[o+s>>1]=p[_>>1]-p[B>>1],n=n+2|0,l=l+2|0,(U|0)!=(l|0););if(!x)break e;s=n<<1,l=s+w|0,n=n+G<<1,w=n+w|0,X[o+s>>1]=p[w>>1]+p[l>>1],X[n+o>>1]=p[l>>1]-p[w>>1]}for(l=h,w=G;;){e:{if(n=o,o=k,!l)break e;for(V=l&536870910,E=l&1,s=0;;){if(k=0,_=0,(l|0)!=1)for(;B=k+s|0,I=B<<1,m=I+o|0,N=l+B<<1,Y=p[N+n>>1],I=p[n+I>>1],X[m>>1]=Y+I,X[o+N>>1]=I-Y,B=B+1|0,I=B<<1,m=I+o|0,B=l+B<<1,N=p[B+n>>1],I=p[n+I>>1],X[m>>1]=N+I,X[o+B>>1]=I-N,k=k+2|0,_=_+2|0,(V|0)!=(_|0););if(E&&(k=k+s|0,_=k<<1,m=_+o|0,k=k+l<<1,B=p[k+n>>1],_=p[n+_>>1],X[m>>1]=B+_,X[k+o>>1]=_-B),s=s+w|0,!((s|0)<(e|0)))break}if(w=w>>>1|0,s=l>>>0>3,l=l>>>1|0,k=n,s)continue}break}for(l=g(e,R),k=0;w=Q+128|0,s=k|1,_=(s<<1)+o|0,B=(k<<1)+o|0,X[w+(k+l<<1)>>1]=p[_>>1]+p[B>>1],X[w+(l+s<<1)>>1]=p[B>>1]-p[_>>1],k=k+2|0,(k|0)<(e|0););if(k=n,R=R+1|0,(R|0)==(e|0))break}break i}for(k=e-1|0,_=k&2,R=(k>>>1|0)+1&-2,B=G<<1,k=Q- -64|0,x=B+k|0,U=G+2<<1,V=U+k|0,E=G+1<<1,I=E+k|0,N=e>>>0<3;;){e:{if((e|0)==1||(k=(g(f,l)<<1)+r|0,n=p[k+B>>1],o=p[k>>1],X[Q+64>>1]=n+o,X[x>>1]=o-n,e>>>0<4)||(n=p[k+E>>1],o=p[k+2>>1],X[Q+66>>1]=n+o,X[I>>1]=o-n,(G|0)==2))break e;n=p[k+U>>1],k=p[k+4>>1],X[Q+68>>1]=n+k,X[V>>1]=k-n}if(n=g(e,l),o=0,k=0,!N)for(;w=Q+128|0,h=Q- -64|0,s=o|1,Y=p[h+(s<<1)>>1],m=p[h+(o<<1)>>1],X[w+(n+o<<1)>>1]=Y+m,X[w+(n+s<<1)>>1]=m-Y,Y=o|2,s=p[h+(Y<<1)>>1],m=w+(n+Y<<1)|0,Y=o|3,h=p[h+(Y<<1)>>1],X[m>>1]=s+h,X[w+(n+Y<<1)>>1]=s-h,o=o+4|0,k=k+2|0,(R|0)!=(k|0););if(_||(k=Q+128|0,m=k+(n+o<<1)|0,h=Q- -64|0,w=o|1,s=p[h+(w<<1)>>1],o=p[h+(o<<1)>>1],X[m>>1]=s+o,X[k+(n+w<<1)>>1]=o-s),l=l+1|0,(l|0)==(e|0))break}n=Q,o=n- -64|0}for(r=e>>>1|0,R=r>>>0<=1?1:r,f=e>>>2|0,G=0,B=e>>>0<8;;){k=0;i:{if((e|0)==1){k=n;break i}for(;h=Q+128|0,w=r+k|0,l=p[h+(g(w,e)+G<<1)>>1],h=h+(g(e,k)+G<<1)|0,X[(k<<1)+o>>1]=l+p[h>>1],X[(w<<1)+o>>1]=p[h>>1]-l,k=k+1|0,(R|0)!=(k|0););if(l=f,w=r,k=n,B)break i;for(;;){if(k=o,o=n,!l)break i;for(x=l&536870910,U=l&1,s=0;;){if(n=0,_=0,(l|0)!=1)for(;h=n+s|0,V=h<<1,m=V+o|0,E=l+h<<1,I=p[E+k>>1],V=p[k+V>>1],X[m>>1]=I+V,X[o+E>>1]=V-I,h=h+1|0,V=h<<1,m=V+o|0,h=l+h<<1,E=p[h+k>>1],V=p[k+V>>1],X[m>>1]=E+V,X[o+h>>1]=V-E,n=n+2|0,_=_+2|0,(x|0)!=(_|0););if(U&&(n=n+s|0,h=n<<1,m=h+o|0,n=n+l<<1,_=p[n+k>>1],h=p[k+h>>1],X[m>>1]=_+h,X[n+o>>1]=h-_),s=s+w|0,!((s|0)<(e|0)))break}if(w=w>>>1|0,h=l>>>0>3,l=l>>>1|0,n=k,!h)break}}for(l=(G<<1)+A|0,n=0;w=n|1,h=(w<<1)+o|0,s=(n<<1)+o|0,X[l+(g(e,n)<<1)>>1]=p[h>>1]+p[s>>1],X[l+(g(e,w)<<1)>>1]=p[s>>1]-p[h>>1],n=n+2|0,(n|0)<(e|0););if(n=k,G=G+1|0,(G|0)==(e|0))break}}v=Q+2176|0}function WA(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;w=v-32|0,v=w;i:{e:switch(f-2|0){case 1:r:{k=p[A+6>>1];f:{if(!k||(r=i[r>>2],f=i[r>>2],k>>>0>i[r+4>>2]-f>>3>>>0))break f;if(r=i[(f+(k<<3)|0)-8>>2],W[i[i[r>>2]+44>>2]](r)|0)break r}r=p[A+4>>1]|p[A+6>>1]<<16,f=p[A>>1]|p[A+2>>1]<<16,X[A+4>>1]=f,k=f>>>16|0,X[A+6>>1]=k,X[A>>1]=r,X[A+2>>1]=r>>>16,r=p[e>>1]|p[e+2>>1]<<16,X[A+4>>1]=r,X[A+6>>1]=r>>>16,X[e>>1]=f,X[e+2>>1]=k;break i}f=p[A+4>>1]|p[A+6>>1]<<16,r=p[e>>1]|p[e+2>>1]<<16,X[A+4>>1]=r,X[A+6>>1]=r>>>16,X[e>>1]=f,X[e+2>>1]=f>>>16,e=Ff(p[A>>1]|p[A+2>>1]<<16,p[A+4>>1]|p[A+6>>1]<<16),X[A>>1]=e,X[A+2>>1]=e>>>16,e=h0,X[A+4>>1]=e,X[A+6>>1]=e>>>16,e=A+4|0;break i;default:if(i[k+4>>2]>=(f|0)){o=i[k>>2],f=p[A>>1]|p[A+2>>1]<<16,X[o>>1]=f,X[o+2>>1]=f>>>16,h=o+4|0,n=A+4|0;r:{if((n|0)==(e|0)){f=A;break r}for(f=A;;){f:{A:{s=p[A+6>>1];k:{if(!s||(A=i[r>>2],o=i[A>>2],s>>>0>i[A+4>>2]-o>>3>>>0))break k;if(A=i[(o+(s<<3)|0)-8>>2],W[i[i[A>>2]+44>>2]](A)|0)break A}A=p[n>>1]|p[n+2>>1]<<16,X[f>>1]=A,X[f+2>>1]=A>>>16,f=f+4|0;break f}A=p[n>>1]|p[n+2>>1]<<16,X[h>>1]=A,X[h+2>>1]=A>>>16,h=h+4|0}if(A=n,n=A+4|0,(n|0)==(e|0))break}}if(A=p[n>>1]|p[n+2>>1]<<16,X[f>>1]=A,X[f+2>>1]=A>>>16,e=f+4|0,n=i[k>>2],h>>>0<=n>>>0)break i;for(A=e;r=p[n>>1]|p[n+2>>1]<<16,X[A>>1]=r,X[A+2>>1]=r>>>16,A=A+4|0,n=n+4|0,h>>>0>n>>>0;);break i}s=(f|0)/2|0,o=(s<<2)+A|0,n=o-4|0,l=p[o-2>>1];r:{f:{if(!l){h=s;break f}for(h=s;;){if(_=i[r>>2],B=i[_>>2],l=l&65535,l>>>0>i[_+4>>2]-B>>3>>>0||(l=i[(B+(l<<3)|0)-8>>2],!(W[i[i[l>>2]+44>>2]](l)|0)))break f;if((A|0)==(n|0))break r;if(h=h-1|0,l=n-2|0,n=n-4|0,l=p[l>>1],!l)break}}_=i[k+4>>2],l=i[k>>2],i[w+8>>2]=l,i[w+12>>2]=_,i[w+24>>2]=l,i[w+28>>2]=_,A=WA(A,n,r,h,w+8|0)}f=f-s|0,l=e+4|0,n=o;r:{for(;;){f:{_=p[n+2>>1];A:{if(!_||(s=i[r>>2],h=i[s>>2],_>>>0>i[s+4>>2]-h>>3>>>0))break A;if(s=i[(h+(_<<3)|0)-8>>2],W[i[i[s>>2]+44>>2]](s)|0)break f}if(n=n+4|0,(n|0)==(e|0))break r;f=f-1|0;continue}break}s=i[k+4>>2],k=i[k>>2],i[w>>2]=k,i[w+4>>2]=s,i[w+16>>2]=k,i[w+20>>2]=s,l=WA(n,e,r,f,w)}if((A|0)==(o|0)){e=l;break i}if((l|0)==(o|0)){e=A;break i}if(e=A+4|0,(e|0)==(o|0)){f=p[A>>1]|p[A+2>>1]<<16,r=l-o|0,r&&z(A,e,r),e=A+r|0,X[e>>1]=f,X[e+2>>1]=f>>>16;break i}if((o+4|0)==(l|0)){k=l-4|0,f=k-A|0,e=l-f|0,r=p[k>>1]|p[k+2>>1]<<16,!f|(A|0)==(k|0)||z(e,A,f),X[A>>1]=r,X[A+2>>1]=r>>>16;break i}if(s=l-o|0,n=s>>2,h=o-A|0,k=h>>2,(n|0)==(k|0)){for(n=o;;){if(r=p[A>>1]|p[A+2>>1]<<16,e=p[n>>1]|p[n+2>>1]<<16,X[A>>1]=e,X[A+2>>1]=e>>>16,X[n>>1]=r,X[n+2>>1]=r>>>16,A=A+4|0,(o|0)==(A|0)){e=o;break i}if(n=n+4|0,(l|0)==(n|0))break}e=o;break i}for(e=k;r=e,e=n,n=(r|0)%(e|0)|0,!!n;);for(r=(e<<2)+A|0;;){for(r=r-4|0,e=h+r|0,n=p[r>>1]|p[r+2>>1]<<16,f=r;o=p[e>>1]|p[e+2>>1]<<16,X[f>>1]=o,X[f+2>>1]=o>>>16,f=e,o=e+h|0,e=l-e>>2,e=(e|0)>(k|0)?o:(k-e<<2)+A|0,(r|0)!=(e|0););if(X[f>>1]=n,X[f+2>>1]=n>>>16,(A|0)==(r|0))break}e=A+s|0;break i;case 0:break e}f=p[A>>1]|p[A+2>>1]<<16,r=p[e>>1]|p[e+2>>1]<<16,X[A>>1]=r,X[A+2>>1]=r>>>16,X[e>>1]=f,X[e+2>>1]=f>>>16}return v=w+32|0,e}function Bn(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0;k=v-112|0,v=k,t3(k+88|0,e);i:{e:{r:switch(u[k+108|0]){case 1:if(e=i[k+92>>2],i[A>>2]=i[k+88>>2],i[A+4>>2]=e,A=A+8|0,t[k+107|0]>=0){e=i[k+100>>2],i[A>>2]=i[k+96>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+104>>2];break i}T(A,i[k+96>>2],i[k+100>>2]);break i;case 0:break r;default:break e}if(l=k+16|0,W[i[i[e>>2]+152>>2]](l,e),En(A,e,l),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]);r:{if(s=i[k+20>>2],s>>>0>o0[r>>2]&&(l=i[k+24>>2],l>>>0>o0[f>>2]))break r;if(e=C(56),i[k+4>>2]=e,i[k+8>>2]=48,i[k+12>>2]=-2147483592,r=u[16378]|u[16379]<<8|(u[16380]<<16|u[16381]<<24),f=u[16374]|u[16375]<<8|(u[16376]<<16|u[16377]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+48|0]=0,r=u[16418]|u[16419]<<8|(u[16420]<<16|u[16421]<<24),f=u[16414]|u[16415]<<8|(u[16416]<<16|u[16417]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[16410]|u[16411]<<8|(u[16412]<<16|u[16413]<<24),f=u[16406]|u[16407]<<8|(u[16408]<<16|u[16409]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[16402]|u[16403]<<8|(u[16404]<<16|u[16405]<<24),f=u[16398]|u[16399]<<8|(u[16400]<<16|u[16401]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[16394]|u[16395]<<8|(u[16396]<<16|u[16397]<<24),f=u[16390]|u[16391]<<8|(u[16392]<<16|u[16393]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[16386]|u[16387]<<8|(u[16388]<<16|u[16389]<<24),f=u[16382]|u[16383]<<8|(u[16384]<<16|u[16385]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,5,0,k+4|0),t[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(u[k+108|0])break e;for(w=i[k+92>>2];;){r:{f:{A:{k:{n:{t:{if(o=w,(o|0)==i[k+88>>2]){if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]<0)break t;e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}if(w=o-8|0,n=i[w>>2],!n)break r;if(e=Z0(n,92792,94104),!e)break f;n=i[o-4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1);o:{if(e=i[e+100>>2],(e|0)!=270){if((e|0)==180)break o;if((e|0)!=90)break A;h=i[r>>2],i[r>>2]=(i[f>>2]^-1)+l;break n}e=i[r>>2],i[r>>2]=i[f>>2],h=(e^-1)+s|0;break n}i[r>>2]=(i[r>>2]^-1)+s,h=(i[f>>2]^-1)+l|0,e=l;break k}T(A,i[28730],i[28731]);break i}e=s,s=l}i[f>>2]=h,l=e}A:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break A;W[i[i[n>>2]+8>>2]](n),y(n)}if(n=i[w>>2],!n)break r}if(h=Z0(n,92792,94184),!h)break r;o=i[o-4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),n=r,e=s;f:switch(i[h+100>>2]){case 0:n=f,e=l;case 1:i[n>>2]=(i[n>>2]^-1)+e;break;default:break f}if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break r;W[i[i[o>>2]+8>>2]](o),y(o)}if(u[k+108|0])break}}e2(),M()}A=u[k+108|0],(A|0)!=255&&(e=i[26907],i[k+16>>2]=i[26906],i[k+20>>2]=e,W[i[(k+16|0)+(A<<2)>>2]](k+4|0,k+88|0)),v=k+112|0}function bm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;n=v-48|0,v=n,AA(n+24|0,e,r);i:{if(i[n+24>>2]){e=i[n+28>>2],i[A>>2]=i[n+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+40>>2],e=i[n+36>>2],i[A+8>>2]=i[n+32>>2],i[A+12>>2]=e,i[n+40>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0;break i}r=i[e+200>>2],f=i[e+144>>2],i[f+100>>2]=i[f+100>>2]&-7;e:{if(i[r+104>>2]==i[r+108>>2])break e;if(f=J5(i[e+192>>2],1),!f){if(e=C(32),i[n+12>>2]=e,i[n+16>>2]=29,i[n+20>>2]=-2147483616,r=u[23737]|u[23738]<<8|(u[23739]<<16|u[23740]<<24),f=u[23733]|u[23734]<<8|(u[23735]<<16|u[23736]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+29|0]=0,r=u[23758]|u[23759]<<8|(u[23760]<<16|u[23761]<<24),f=u[23754]|u[23755]<<8|(u[23756]<<16|u[23757]<<24),t[e+21|0]=f,t[e+22|0]=f>>>8,t[e+23|0]=f>>>16,t[e+24|0]=f>>>24,t[e+25|0]=r,t[e+26|0]=r>>>8,t[e+27|0]=r>>>16,t[e+28|0]=r>>>24,r=u[23753]|u[23754]<<8|(u[23755]<<16|u[23756]<<24),f=u[23749]|u[23750]<<8|(u[23751]<<16|u[23752]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[23745]|u[23746]<<8|(u[23747]<<16|u[23748]<<24),f=u[23741]|u[23742]<<8|(u[23743]<<16|u[23744]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,n+12|0),t[n+23|0]>=0)break i;Z(i[n+12>>2]);break i}r=0,k=i[e+184>>2],e=i[k+104>>2],f=i[f+8>>2]-1|0;r:{if(f>>>0>=i[k+108>>2]-e>>3>>>0)break r;if(r=e+(f<<3)|0,e=i[r>>2],r=i[r+4>>2],r){if(i[r+4>>2]=i[r+4>>2]+1,!e)break r;if(e=i[r+4>>2],i[r+4>>2]=e-1,e)break e;W[i[i[r>>2]+8>>2]](r),y(r);break e}if(r=0,e)break e}if(e=C(48),i[n+12>>2]=e,i[n+16>>2]=40,i[n+20>>2]=-2147483600,f=u[8770]|u[8771]<<8|(u[8772]<<16|u[8773]<<24),k=u[8766]|u[8767]<<8|(u[8768]<<16|u[8769]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=f,t[e+5|0]=f>>>8,t[e+6|0]=f>>>16,t[e+7|0]=f>>>24,t[e+40|0]=0,f=u[8802]|u[8803]<<8|(u[8804]<<16|u[8805]<<24),k=u[8798]|u[8799]<<8|(u[8800]<<16|u[8801]<<24),t[e+32|0]=k,t[e+33|0]=k>>>8,t[e+34|0]=k>>>16,t[e+35|0]=k>>>24,t[e+36|0]=f,t[e+37|0]=f>>>8,t[e+38|0]=f>>>16,t[e+39|0]=f>>>24,f=u[8794]|u[8795]<<8|(u[8796]<<16|u[8797]<<24),k=u[8790]|u[8791]<<8|(u[8792]<<16|u[8793]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=f,t[e+29|0]=f>>>8,t[e+30|0]=f>>>16,t[e+31|0]=f>>>24,f=u[8786]|u[8787]<<8|(u[8788]<<16|u[8789]<<24),k=u[8782]|u[8783]<<8|(u[8784]<<16|u[8785]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=f,t[e+21|0]=f>>>8,t[e+22|0]=f>>>16,t[e+23|0]=f>>>24,f=u[8778]|u[8779]<<8|(u[8780]<<16|u[8781]<<24),k=u[8774]|u[8775]<<8|(u[8776]<<16|u[8777]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=f,t[e+13|0]=f>>>8,t[e+14|0]=f>>>16,t[e+15|0]=f>>>24,a(A,2,0,n+12|0),t[n+23|0]<0&&Z(i[n+12>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r);break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}t[n+43|0]<0&&Z(i[n+32>>2]),v=n+48|0}function cm(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0;n=v+-64|0,v=n;i:{e:{r:{f:{A:{if(!(f&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break A}if(l=C(168),i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=97828,_=l+16|0,o=_,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=92500,i[l+60>>2]=0,i[l+64>>2]=0,i[l+52>>2]=0,i[l+56>>2]=0,i[l+72>>2]=-1,i[l+76>>2]=-1,i[l+80>>2]=-1,i[l+84>>2]=-1,i[l+116>>2]=0,i[l+88>>2]=0,i[l+92>>2]=0,i[l+96>>2]=0,i[l+100>>2]=0,i[l+104>>2]=0,i[l+108>>2]=0,X[l+112>>1]=0,i[o>>2]=95520,i[l+160>>2]=0,i[l+164>>2]=0,i[l+152>>2]=0,i[l+156>>2]=0,i[l+144>>2]=0,i[l+148>>2]=0,i[l+136>>2]=0,i[l+140>>2]=0,i[l+128>>2]=0,i[l+132>>2]=0,i[l+120>>2]=0,i[l+124>>2]=0,i[l+32>>2]=1969513843,o=i[f+4>>2],h=o||47881,s=l2(h),s>>>0>=2147483640)break f;k:{n:{if(s>>>0>=11){w=s|7,o=C(w+1|0),i[n+60>>2]=w-2147483647,i[n+52>>2]=o,i[n+56>>2]=s;break n}if(t[n+63|0]=s,o=n+52|0,!s)break k}if(!s)break k;z(o,h,s)}h=l+120|0,t[o+s|0]=0,o=t[n+63|0];k:{n:{if(t[l+131|0]>=0){if((o|0)>=0){o=i[n+56>>2],i[h>>2]=i[n+52>>2],i[h+4>>2]=o,i[h+8>>2]=i[n+60>>2];break k}m1(h,i[n+52>>2],i[n+56>>2]);break n}if(s=(o|0)<0,R1(h,s?i[n+52>>2]:n+52|0,s?i[n+56>>2]:o),t[n+63|0]>=0)break k}Z(i[n+52>>2])}if(o=i[f+8>>2],h=o||47881,s=l2(h),s>>>0>=2147483640)break r;k:{n:{if(s>>>0>=11){w=s|7,o=C(w+1|0),i[n+48>>2]=w-2147483647,i[n+40>>2]=o,i[n+44>>2]=s;break n}if(t[n+51|0]=s,o=n+40|0,!s)break k}if(!s)break k;z(o,h,s)}t[o+s|0]=0,o=l+132|0,s=t[n+51|0];k:{n:{if(t[l+143|0]>=0){if((s|0)>=0){s=i[n+44>>2],i[o>>2]=i[n+40>>2],i[o+4>>2]=s,i[o+8>>2]=i[n+48>>2];break k}m1(o,i[n+40>>2],i[n+44>>2]);break n}h=o,o=(s|0)<0,R1(h,o?i[n+40>>2]:n+40|0,o?i[n+44>>2]:s)}if(t[n+51|0]>=0)break k;Z(i[n+40>>2])}if(o=i[f+12>>2],h=o||47881,s=l2(h),s>>>0>=2147483640)break e;k:{n:{if(s>>>0>=11){w=s|7,o=C(w+1|0),i[n+36>>2]=w-2147483647,i[n+28>>2]=o,i[n+32>>2]=s;break n}if(t[n+39|0]=s,o=n+28|0,!s)break k}if(!s)break k;z(o,h,s)}t[o+s|0]=0,o=l+144|0,s=t[n+39|0];k:{n:{if(t[l+155|0]>=0){if((s|0)>=0){s=i[n+32>>2],i[o>>2]=i[n+28>>2],i[o+4>>2]=s,i[o+8>>2]=i[n+36>>2];break k}m1(o,i[n+28>>2],i[n+32>>2]);break n}h=o,o=(s|0)<0,R1(h,o?i[n+28>>2]:n+28|0,o?i[n+32>>2]:s)}if(t[n+39|0]>=0)break k;Z(i[n+28>>2])}if(f=i[f+16>>2],s=f||47881,f=l2(s),f>>>0>=2147483640)break i;k:{n:{if(f>>>0>=11){h=f|7,o=C(h+1|0),i[n+24>>2]=h-2147483647,i[n+16>>2]=o,i[n+20>>2]=f;break n}if(t[n+27|0]=f,o=n+16|0,!f)break k}if(!f)break k;z(o,s,f)}t[f+o|0]=0,f=l+156|0,o=t[n+27|0];k:{n:{if(t[l+167|0]>=0){if((o|0)>=0){o=i[n+20>>2],i[f>>2]=i[n+16>>2],i[f+4>>2]=o,i[f+8>>2]=i[n+24>>2];break k}m1(f,i[n+16>>2],i[n+20>>2]);break n}h=f,f=(o|0)<0,R1(h,f?i[n+16>>2]:n+16|0,f?i[n+20>>2]:o)}if(t[n+27|0]>=0)break k;Z(i[n+16>>2])}if(e=i[e>>2],i[n+12>>2]=l,i[n+8>>2]=_,i[l+4>>2]=i[l+4>>2]+1,f=i[n+12>>2],i[n>>2]=i[n+8>>2],i[n+4>>2]=f,e=Ei(e,r,n,0),k&&(i[k>>2]=e),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[l+4>>2],i[l+4>>2]=A-1,A)break A;W[i[i[l>>2]+8>>2]](l),y(l)}v=n- -64|0;return}I0(),M()}I0(),M()}I0(),M()}I0(),M()}function XA(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;k=v-192|0,v=k,S2(k+168|0,e,r);i:{if(i[k+168>>2]!=i[28728]){e=i[k+172>>2],i[A>>2]=i[k+168>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+184>>2],e=i[k+180>>2],i[A+8>>2]=i[k+176>>2],i[A+12>>2]=e,i[k+184>>2]=0,i[k+176>>2]=0,i[k+180>>2]=0;break i}s=e,h=F0(r),i[s+104>>2]=h,o=F0(r);e:{r:{f:{A:{k:{n:{if(o>>>0>i[r+16>>2]>>>2>>>0){i[k+112>>2]=0,i[k+84>>2]=78164,i[k+28>>2]=78144,e=i[19545],i[k+20>>2]=e,f=i[e-12>>2],e=k+20|0,i[f+e>>2]=i[19546],i[k+24>>2]=0,f=e+i[i[k+20>>2]-12>>2]|0,n=k+32|0,J0(f,n),t[f+80|0]=0,i[f+72>>2]=0,f=i[19547],i[k+28>>2]=f,l=k+28|0,i[l+i[f-12>>2]>>2]=i[19548],f=i[19544],i[k+20>>2]=f,i[e+i[f-12>>2]>>2]=i[19549],i[k+84>>2]=78164,i[k+20>>2]=78124,i[k+28>>2]=78144,f=R0(n),i[f>>2]=77200,i[k+72>>2]=0,i[k+76>>2]=0,i[k+64>>2]=0,i[k+68>>2]=0,i[k+80>>2]=24,e=i[r+16>>2],F(B0(F(B0(F(l,31662,32),o),32687,32),e>>>2|0),26363,10),e=i[k+80>>2];t:{if(e&16){e=i[k+76>>2],r=i[k+56>>2],e>>>0<r>>>0&&(i[k+76>>2]=r,e=r),r=k+52|0;break t}if(!(e&8)){e=0,t[k+19|0]=0,r=k+8|0;break e}e=i[k+48>>2],r=k+40|0}if(o=i[r>>2],e=e-o|0,e>>>0>=2147483640)break n;if(e>>>0>=11){n=e|7,r=C(n+1|0),i[k+16>>2]=n-2147483647,i[k+8>>2]=r,i[k+12>>2]=e;break r}if(t[k+19|0]=e,r=k+8|0,e)break r;e=0;break e}if(n=i[f+56>>2],!(!n|n>>>0>=o>>>0)){i[k+112>>2]=0,i[k+84>>2]=78164,i[k+28>>2]=78144,e=i[19545],i[k+20>>2]=e,r=i[e-12>>2],e=k+20|0,i[r+e>>2]=i[19546],i[k+24>>2]=0,r=e+i[i[k+20>>2]-12>>2]|0,n=k+32|0,J0(r,n),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[k+28>>2]=r,l=i[r-12>>2],r=k+28|0,i[l+r>>2]=i[19548],l=i[19544],i[k+20>>2]=l,i[e+i[l-12>>2]>>2]=i[19549],i[k+84>>2]=78164,i[k+20>>2]=78124,i[k+28>>2]=78144,n=R0(n),i[n>>2]=77200,i[k+72>>2]=0,i[k+76>>2]=0,i[k+64>>2]=0,i[k+68>>2]=0,i[k+80>>2]=24,F(B0(F(B0(F(r,30985,26),o),31317,44),i[f+56>>2]),26363,10),e=i[k+80>>2];t:{if(e&16){e=i[k+76>>2],r=i[k+56>>2],e>>>0<r>>>0&&(i[k+76>>2]=r,e=r),r=k+52|0;break t}if(!(e&8)){e=0,t[k+19|0]=0,r=k+8|0;break f}e=i[k+48>>2],r=k+40|0}if(f=i[r>>2],e=e-f|0,e>>>0>=2147483640)break k;if(e>>>0>=11){o=e|7,r=C(o+1|0),i[k+16>>2]=o-2147483647,i[k+8>>2]=r,i[k+12>>2]=e;break A}if(t[k+19|0]=e,r=k+8|0,e)break A;e=0;break f}f=e+108|0,l=i[e+108>>2],n=i[e+112>>2]-l>>2;t:{o:{if(n>>>0<o>>>0){T8(f,o-n|0);break o}if(n>>>0>o>>>0&&(i[e+112>>2]=l+(o<<2)),!o)break t}for(e=0;n=F0(r),i[i[f>>2]+(e<<2)>>2]=n,e=e+1|0,(o|0)!=(e|0););}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}I0(),M()}I0(),M()}if(!e)break f;z(r,f,e)}t[e+r|0]=0,a(A,2,1e3,k+8|0),t[k+19|0]<0&&Z(i[k+8>>2]),A=i[19543],i[k+20>>2]=A,i[i[A-12>>2]+(k+20|0)>>2]=i[19551],i[k+28>>2]=i[19552],i[n>>2]=77200,t[k+75|0]<0&&Z(i[k+64>>2]),y0(n),Y0(k+84|0);break i}if(!e)break e;z(r,o,e)}t[e+r|0]=0,a(A,2,100,k+8|0),t[k+19|0]<0&&Z(i[k+8>>2]),A=i[19543],i[k+20>>2]=A,i[i[A-12>>2]+(k+20|0)>>2]=i[19551],i[k+28>>2]=i[19552],i[f>>2]=77200,t[k+75|0]<0&&Z(i[k+64>>2]),y0(f),Y0(k+84|0)}t[k+187|0]<0&&Z(i[k+176>>2]),v=k+192|0}function Wi(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;f=v-160|0,v=f,k=i[r>>2],n=W[i[i[k>>2]+8>>2]](k)|0,o=i[r>>2],k=h0,n=n+8|0,k=n>>>0<8?k+1|0:k;i:{if(W[i[i[o>>2]+12>>2]](o,n,k)|0){if(t[f+12|0]=0,t[f+23|0]=0,a(A,2,100,f+12|0),t[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}h=e,w=F0(r),i[h+8>>2]=w,i[e+12>>2]=0,k=F0(r),i[e+32>>2]=8,i[e+16>>2]=k;e:{r:{f:{if(!i[e+12>>2]&i[e+8>>2]==1){if(k=i[r>>2],n=W[i[i[k>>2]+8>>2]](k)|0,o=i[r>>2],k=h0,n=n+8|0,k=n>>>0<8?k+1|0:k,W[i[i[o>>2]+12>>2]](o,n,k)|0){if(t[f+12|0]=0,t[f+23|0]=0,a(A,2,100,f+12|0),t[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}if(k=F0(r),h=e,w=F0(r),i[h+8>>2]=w,i[e+12>>2]=k,i[e+32>>2]=i[e+32>>2]+8,i[f+76>>2]=78164,i[f+104>>2]=0,i[f+20>>2]=78144,k=i[19545],i[f+12>>2]=k,n=i[k-12>>2],k=f+12|0,i[n+k>>2]=i[19546],i[f+16>>2]=0,n=k+i[i[f+12>>2]-12>>2]|0,o=f+24|0,J0(n,o),t[n+80|0]=0,i[n+72>>2]=0,n=i[19547],i[f+20>>2]=n,l=i[n-12>>2],n=f+20|0,i[l+n>>2]=i[19548],l=i[19544],i[f+12>>2]=l,i[k+i[l-12>>2]>>2]=i[19549],i[f+76>>2]=78164,i[f+12>>2]=78124,i[f+20>>2]=78144,k=R0(o),i[k>>2]=77200,o=f- -64|0,i[o>>2]=0,i[o+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=24,F(M2(F(n,32238,9),i[e+8>>2],i[e+12>>2]),25410,24),n=f+76|0,o=i[e+12>>2],(o|0)==268435456|o>>>0>268435456){e=i[f+72>>2];A:{if(e&16){r=i[f+68>>2],e=i[f+48>>2],r>>>0<e>>>0&&(i[f+68>>2]=e,r=e),e=f+44|0;break A}if(!(e&8)){r=0,t[f+11|0]=0,e=f;break e}r=i[f+40>>2],e=f+32|0}if(o=i[e>>2],r=r-o|0,r>>>0>=2147483640)break f;if(r>>>0>=11){l=r|7,e=C(l+1|0),i[f+8>>2]=l-2147483647,i[f>>2]=e,i[f+4>>2]=r;break r}if(t[f+11|0]=r,e=f,r)break r;r=0;break e}o=i[19543],i[f+12>>2]=o,i[i[o-12>>2]+(f+12|0)>>2]=i[19551],i[f+20>>2]=i[19552],i[k>>2]=77200,t[f+67|0]<0&&Z(i[f+56>>2]),y0(k),Y0(n),k=i[e+16>>2]}if((k|0)==1970628964){if(k=i[r>>2],n=W[i[i[k>>2]+8>>2]](k)|0,o=i[r>>2],k=h0,n=n+16|0,k=n>>>0<16?k+1|0:k,W[i[i[o>>2]+12>>2]](o,n,k)|0){if(t[f+12|0]=0,t[f+23|0]=0,a(A,2,100,f+12|0),t[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}A:{if(!w4(r,16))break A;l=i[e+24>>2],k=i[e+20>>2],n=l-k|0;k:{if(n>>>0<=15){if(o=16-n|0,s=i[e+28>>2],o>>>0<=s-l>>>0){o&&l0(l,0,o),i[e+24>>2]=o+l;break k}if(l=s-k|0,s=l<<1,s=l>>>0>=1073741823?2147483647:s>>>0<=16?16:s,l=C(s),o&&l0(n+l|0,0,o),n&&z(l,k,n),i[e+28>>2]=l+s,i[e+24>>2]=l+16,i[e+20>>2]=l,!k)break k;Z(k);break k}if((n|0)==16)break k;i[e+24>>2]=k+16}if(n=i[r>>2],k=i[r+4>>2],k){if(i[k+4>>2]=i[k+4>>2]+1,W[i[i[n>>2]+16>>2]](n,i[e+20>>2],16)|0,n=i[k+4>>2],i[k+4>>2]=n-1,n)break A;W[i[i[k>>2]+8>>2]](k),y(k);break A}W[i[i[n>>2]+16>>2]](n,i[e+20>>2],16)|0}i[e+32>>2]=i[e+32>>2]+16}if(u[r+20|0]==1){if(t[f+12|0]=0,t[f+23|0]=0,a(A,2,100,f+12|0),t[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}I0(),M()}if(!r)break e;z(e,o,r)}t[e+r|0]=0,a(A,6,1e3,f),t[f+11|0]<0&&Z(i[f>>2]),A=i[19543],i[f+12>>2]=A,i[i[A-12>>2]+(f+12|0)>>2]=i[19551],i[f+20>>2]=i[19552],i[k>>2]=77200,t[f+67|0]<0&&Z(i[f+56>>2]),y0(k),Y0(n)}v=f+160|0}function vn(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;n=v-32|0,v=n,s=i[e+104>>2],m=i[e+108>>2];i:{if((s|0)!=(m|0))for(w=n+24|0;;){if(i[n+20>>2]=w,i[n+24>>2]=0,G=w,_=0,h=i[s+44>>2],I=i[s+48>>2],(h|0)==(I|0))e=0;else{e:{for(;;){r:{l=i[h>>2],r=w,k=r,e=r,o=i[n+24>>2],f=o;f:{A:{if(!f)break A;for(;k=r,e=f,B=l>>>0>o0[e+16>>2],r=B?r:e,f=i[(B?4:0)+e>>2],!!f;);if((r|0)!=(w|0)&l>>>0>=o0[(B?k:e)+16>>2])break r;for(;;){if(e=o,r=i[e+16>>2],r>>>0>l>>>0){if(k=e,o=i[e>>2],o)continue;break A}if(r>>>0>=l>>>0)break f;if(o=i[e+4>>2],!o)break}k=e+4|0}r=C(20),i[r+8>>2]=e,i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=l,i[k>>2]=r,e=i[G>>2],e&&(i[n+20>>2]=e,G=e),o=i[n+24>>2],e=(o|0)==(r|0),t[r+12|0]=e;A:{if(e)break A;for(;;){if(k=i[r+8>>2],u[k+12|0])break A;k:{e=i[k+8>>2],f=i[e>>2];n:{if((k|0)==(f|0)){if(l=i[e+4>>2],!(!l|u[l+12|0])){t[k+12|0]=1,t[e+12|0]=(e|0)==(o|0),t[l+12|0]=1;break n}t:{if(i[k>>2]==(r|0)){r=k;break t}r=i[k+4>>2],f=i[r>>2],i[k+4>>2]=f;o:{if(!f){i[r+8>>2]=e,i[e>>2]=r;break o}if(i[f+8>>2]=k,e=i[k+8>>2],f=i[e>>2],i[r+8>>2]=e,(f|0)==(k|0)){i[e>>2]=r;break o}i[e+4>>2]=r}i[r>>2]=k,i[k+8>>2]=r,e=i[r+8>>2],f=i[e>>2]}t[r+12|0]=1,t[e+12|0]=0,r=i[f+4>>2],i[e>>2]=r,r&&(i[r+8>>2]=e),r=i[e+8>>2],i[f+8>>2]=r;t:{if(i[r>>2]==(e|0)){i[r>>2]=f;break t}i[r+4>>2]=f}i[f+4>>2]=e,i[e+8>>2]=f;break A}if(u[f+12|0]|!f)break k;t[k+12|0]=1,t[e+12|0]=(e|0)==(o|0),t[f+12|0]=1}if(r=e,(e|0)!=(o|0))continue;break A}break}f=i[k>>2];k:{if((f|0)!=(r|0)){f=k;break k}r=i[f+4>>2],i[k>>2]=r,r&&(i[r+8>>2]=k,e=i[k+8>>2]),i[f+8>>2]=e;n:{if((k|0)==i[e>>2]){i[e>>2]=f;break n}i[e+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,e=i[f+8>>2]}t[f+12|0]=1,t[e+12|0]=0,r=i[e+4>>2],f=i[r>>2],i[e+4>>2]=f,f&&(i[f+8>>2]=e),f=i[e+8>>2],i[r+8>>2]=f;k:{if(i[f>>2]==(e|0)){i[f>>2]=r;break k}i[f+4>>2]=r}i[r>>2]=e,i[e+8>>2]=r}_=_+1|0}if(h=h+4|0,(I|0)!=(h|0))continue;break e}break}i[n+28>>2]=_,e=C(32),i[n+8>>2]=e,i[n+12>>2]=28,i[n+16>>2]=-2147483616,r=u[6368]|u[6369]<<8|(u[6370]<<16|u[6371]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,r=u[6364]|u[6365]<<8|(u[6366]<<16|u[6367]<<24),f=u[6360]|u[6361]<<8|(u[6362]<<16|u[6363]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[6356]|u[6357]<<8|(u[6358]<<16|u[6359]<<24),f=u[6352]|u[6353]<<8|(u[6354]<<16|u[6355]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[6348]|u[6349]<<8|(u[6350]<<16|u[6351]<<24),f=u[6344]|u[6345]<<8|(u[6346]<<16|u[6347]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+28|0]=0,a(A,2,0,n+8|0),t[n+19|0]<0&&Z(i[n+8>>2]),S1(n+20|0,i[n+24>>2]);break i}e=i[n+24>>2]}if(i[n+28>>2]=_,S1(n+20|0,e),s=s+56|0,(m|0)==(s|0))break}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+32|0}function mn(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;n=v-32|0,v=n,s=i[e+100>>2],m=i[e+104>>2];i:{if((s|0)!=(m|0))for(w=n+24|0;;){if(i[n+20>>2]=w,i[n+24>>2]=0,G=w,_=0,h=i[s+4>>2],I=i[s+8>>2],(h|0)==(I|0))e=0;else{e:{for(;;){r:{l=i[h>>2],r=w,k=r,e=r,o=i[n+24>>2],f=o;f:{A:{if(!f)break A;for(;k=r,e=f,B=l>>>0>o0[e+16>>2],r=B?r:e,f=i[(B?4:0)+e>>2],!!f;);if((r|0)!=(w|0)&l>>>0>=o0[(B?k:e)+16>>2])break r;for(;;){if(e=o,r=i[e+16>>2],r>>>0>l>>>0){if(k=e,o=i[e>>2],o)continue;break A}if(r>>>0>=l>>>0)break f;if(o=i[e+4>>2],!o)break}k=e+4|0}r=C(20),i[r+8>>2]=e,i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=l,i[k>>2]=r,e=i[G>>2],e&&(i[n+20>>2]=e,G=e),o=i[n+24>>2],e=(o|0)==(r|0),t[r+12|0]=e;A:{if(e)break A;for(;;){if(k=i[r+8>>2],u[k+12|0])break A;k:{e=i[k+8>>2],f=i[e>>2];n:{if((k|0)==(f|0)){if(l=i[e+4>>2],!(!l|u[l+12|0])){t[k+12|0]=1,t[e+12|0]=(e|0)==(o|0),t[l+12|0]=1;break n}t:{if(i[k>>2]==(r|0)){r=k;break t}r=i[k+4>>2],f=i[r>>2],i[k+4>>2]=f;o:{if(!f){i[r+8>>2]=e,i[e>>2]=r;break o}if(i[f+8>>2]=k,e=i[k+8>>2],f=i[e>>2],i[r+8>>2]=e,(f|0)==(k|0)){i[e>>2]=r;break o}i[e+4>>2]=r}i[r>>2]=k,i[k+8>>2]=r,e=i[r+8>>2],f=i[e>>2]}t[r+12|0]=1,t[e+12|0]=0,r=i[f+4>>2],i[e>>2]=r,r&&(i[r+8>>2]=e),r=i[e+8>>2],i[f+8>>2]=r;t:{if(i[r>>2]==(e|0)){i[r>>2]=f;break t}i[r+4>>2]=f}i[f+4>>2]=e,i[e+8>>2]=f;break A}if(u[f+12|0]|!f)break k;t[k+12|0]=1,t[e+12|0]=(e|0)==(o|0),t[f+12|0]=1}if(r=e,(e|0)!=(o|0))continue;break A}break}f=i[k>>2];k:{if((f|0)!=(r|0)){f=k;break k}r=i[f+4>>2],i[k>>2]=r,r&&(i[r+8>>2]=k,e=i[k+8>>2]),i[f+8>>2]=e;n:{if((k|0)==i[e>>2]){i[e>>2]=f;break n}i[e+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,e=i[f+8>>2]}t[f+12|0]=1,t[e+12|0]=0,r=i[e+4>>2],f=i[r>>2],i[e+4>>2]=f,f&&(i[f+8>>2]=e),f=i[e+8>>2],i[r+8>>2]=f;k:{if(i[f>>2]==(e|0)){i[f>>2]=r;break k}i[f+4>>2]=r}i[r>>2]=e,i[e+8>>2]=r}_=_+1|0}if(h=h+4|0,(I|0)!=(h|0))continue;break e}break}i[n+28>>2]=_,e=C(32),i[n+8>>2]=e,i[n+12>>2]=28,i[n+16>>2]=-2147483616,r=u[6339]|u[6340]<<8|(u[6341]<<16|u[6342]<<24),t[e+24|0]=r,t[e+25|0]=r>>>8,t[e+26|0]=r>>>16,t[e+27|0]=r>>>24,r=u[6335]|u[6336]<<8|(u[6337]<<16|u[6338]<<24),f=u[6331]|u[6332]<<8|(u[6333]<<16|u[6334]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[6327]|u[6328]<<8|(u[6329]<<16|u[6330]<<24),f=u[6323]|u[6324]<<8|(u[6325]<<16|u[6326]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[6319]|u[6320]<<8|(u[6321]<<16|u[6322]<<24),f=u[6315]|u[6316]<<8|(u[6317]<<16|u[6318]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+28|0]=0,a(A,2,0,n+8|0),t[n+19|0]<0&&Z(i[n+8>>2]),S1(n+20|0,i[n+24>>2]);break i}e=i[n+24>>2]}if(i[n+28>>2]=_,S1(n+20|0,e),s=s+16|0,(m|0)==(s|0))break}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+32|0}function Zn(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;Q=v;i:{e:{r:{f:{A:{k:{n:{t:{o:{l:{if(!k||!(G0(r,1)&255))break l;if(o){if(A=0,e=k2(r),(e|0)==-99999|(e|0)>=(k|0))break r;A=e^-1}else A=-1;if(h=A+k|0,(h|0)<0)break t;if(e=G0(r,1),A=k2(r),(A|0)==-99999)break i;for(m=u[(i[n>>2]+g(h,100)|0)+98|0],k=m+16&496,s=Q-k|0,o=s,v=o,l=A^-1,_=A+1|0,w=o-k|0,v=w,k=0;A=G0(r,1),t[k+s|0]=A,o=k+w|0,A&255?A=1:A=G0(r,1),t[o|0]=A,A=(k|0)!=(m|0),k=k+1|0,!!A;);l=e?l:_,r=g(h,100),e=r+i[n>>2]|0,A=u[e+96|0],e=u[e+97|0];u:{if(!e){o=0;break u}for(_=f- -64|0,o=0,B=e>>>0<17,k=e;;){if(G=i[n>>2],h>>>0>=(i[n+4>>2]-G|0)/100>>>0)break n;if(!B)break k;k=k-1|0,G=l+X[((r+G|0)+(k<<1)|0)+32>>1]|0;s:{if((G|0)>=0||(I=A+k|0,!u[I+w|0]))break s;if((o|0)>15)break i;X[(o<<1)+f>>1]=G,t[o+_|0]=u[s+I|0],o=o+1|0}if(!k)break}}if(!(!u[w+m|0]|(l|0)>=0)){if((o|0)>15)break i;X[(o<<1)+f>>1]=l,t[(f+o|0)- -64|0]=u[s+m|0],o=o+1|0}u:{if(!A){t[f+96|0]=o,k=0;break u}for(r=f- -64|0,k=0,_=g(h,100);;){if(B=l+X[(_+i[n>>2]|0)+(k<<1)>>1]|0,!(!u[k+w|0]|(B|0)>=0)){if((o|0)>15)break i;X[(o<<1)+f>>1]=B,t[r+o|0]=u[k+s|0],o=o+1|0}if(k=k+1|0,(A|0)==(k|0))break}for(t[f+96|0]=o,_=f+80|0,B=f+32|0,k=0,G=g(h,100),o=A;;){if(r=o,o=o-1|0,I=l+X[(G+i[n>>2]|0)+(o<<1)>>1]|0,!((I|0)<=0|!u[o+w|0])){if((k|0)>15)break i;X[B+(k<<1)>>1]=I,t[k+_|0]=u[o+s|0],k=k+1|0}if(!((r|0)>1))break}}if(!(!u[w+m|0]|(l|0)<=0)){if((k|0)>15)break i;X[((k<<1)+f|0)+32>>1]=l,t[(f+k|0)+80|0]=u[s+m|0],k=k+1|0}if(e)for(r=f+80|0,m=f+32|0,o=0,h=g(h,100);;){_=l+X[((h+i[n>>2]|0)+(o<<1)|0)+32>>1]|0;u:{if((_|0)<=0||(B=A+o|0,!u[B+w|0]))break u;if((k|0)>15)break i;X[m+(k<<1)>>1]=_,t[r+k|0]=u[s+B|0],k=k+1|0}if(o=o+1|0,(e|0)==(o|0))break}t[f+97|0]=k;break o}if(n=k2(r),l=k2(r),!((n|0)!=-99999&(l|0)!=-99999))break e;if(i[((t[e+2|0]<<2)+e|0)+524>>2]<(n+l|0)){X[f+96>>1]=0,X[f+98>>1]=0;break e}if(!((l|0)<17&(n|0)<=16))break e;if(t[f+97|0]=l,t[f+96|0]=n,(n|0)>0)for(o=f- -64|0,A=0,k=0,e=0;;){if(s=k2(r),(s|0)==-99999)break r;if(w=G0(r,1),h=(k<<1)+f|0,X[h>>1]=(s^-1)+e,t[k+o|0]=w,e=p[h>>1],k=k+1|0,(n|0)==(k|0))break}if((l|0)<=0)break o;for(e=f+80|0,n=f+32|0,A=0,k=0,o=0;;){if(s=k2(r),(s|0)==-99999)break r;if(w=G0(r,1),h=n+(k<<1)|0,X[h>>1]=(o+s|0)+1,t[e+k|0]=w,o=p[h>>1],k=k+1|0,(l|0)==(k|0))break}}if(k=0,t[f+99|0]=0,A=u[f+96|0],!A)break f;if(n=A&1,e=f- -64|0,(A|0)==1){r=0;break A}for(l=A&254,r=0,o=0;s=e+r|0,u[s|0]&&(k=k+1|0,t[f+99|0]=k),u[s+1|0]&&(k=k+1|0,t[f+99|0]=k),r=r+2|0,o=o+2|0,(l|0)!=(o|0););break A}U0(23771,19986,129,4597),M()}U0(30225,19986,174,4597),M()}U0(21027,19986,175,4597),M()}if(!n|!u[e+r|0])break f;k=k+1|0,t[f+99|0]=k}e=u[f+97|0];f:{if(!e)break f;if(n=f+80|0,r=0,(e|0)!=1)for(l=e&254,o=0;s=r+n|0,u[s|0]&&(k=k+1|0,t[f+99|0]=k),u[s+1|0]&&(k=k+1|0,t[f+99|0]=k),r=r+2|0,o=o+2|0,(l|0)!=(o|0););if(!(e&1)|!u[r+n|0])break f;t[f+99|0]=k+1}t[f+98|0]=A+e,A=1}return v=Q,A}C2(A,1018,0)}return v=Q,0}function gn(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;o=v-16|0,v=o,r=C(68),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=113672,n=i[A+20>>2],f=i[A+24>>2],k=r+12|0,i[k+16>>2]=0,i[k+20>>2]=0,i[r+24>>2]=e,i[r+20>>2]=f,i[r+16>>2]=n,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+64>>2]=0,i[r+12>>2]=113504;i:{e:{r:switch(e-1|0){case 0:e=C(92),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=104028,l0(e+20|0,0,72),i[e+16>>2]=0,i[e+12>>2]=104284,t[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,t[e+32|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,t[e+44|0]=0;break e;case 3:e=C(84),i[e+28>>2]=0,i[e+32>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,t[e+19|0]=0,t[e+20|0]=0,t[e+21|0]=0,t[e+22|0]=0,t[e+23|0]=0,t[e+24|0]=0,t[e+25|0]=0,t[e+26|0]=0,t[e+18|0]=1,X[e+16>>1]=0,i[e+12>>2]=104576,i[e>>2]=104536,t[e+27|0]=0,t[e+28|0]=0,t[e+29|0]=0,t[e+30|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0;break e;case 4:e=C(96),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=106404,l0(e+20|0,0,76),i[e+16>>2]=0,i[e+12>>2]=106512,t[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,t[e+32|0]=0;break e;case 1:e=C(92),i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+12>>2]=107072,i[e>>2]=106884,t[e+21|0]=0,t[e+22|0]=0,t[e+23|0]=0,t[e+24|0]=0,t[e+25|0]=0,t[e+26|0]=0,t[e+27|0]=0,t[e+28|0]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+88>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,t[e+40|0]=0;break e;case 6:e=C(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=105696,i[e>>2]=105580,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0;break e;case 9:e=C(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=105752,i[e>>2]=113536,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0;break e;case 2:break r;default:break i}e=C(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=105328,i[e>>2]=105128,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0}i[r+64>>2]=e,i[r+60>>2]=e+12}i[o+12>>2]=r,i[o+8>>2]=k,P0(A+104|0,o+8|0),l=i[A+108>>2]-i[A+104>>2]>>3;i:{if(r=i[A+192>>2],A=i[r+108>>2],f=i[r+112>>2],A>>>0<f>>>0){i[A+8>>2]=l,i[A>>2]=1,i[A+4>>2]=0,i[r+108>>2]=A+12;break i}e:{if(n=i[r+104>>2],A=A-n|0,e=((A|0)/12|0)+1|0,e>>>0<357913942){if(f=(f-n|0)/12|0,k=f<<1,k=f>>>0>=178956970?357913941:e>>>0<k>>>0?k:e,k){if(k>>>0>=357913942)break e;e=C(g(k,12))}else e=0;f=e+A|0,i[f+8>>2]=l,i[f>>2]=1,i[f+4>>2]=0,l=f+g((A|0)/-12|0,12)|0,A&&z(l,n,A),i[r+112>>2]=e+g(k,12),A=f+12|0,i[r+108>>2]=A,i[r+104>>2]=l,n&&Z(n),i[r+108>>2]=A;break i}s0(),M()}x0(),M()}A=i[o+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=o+16|0}function iZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0;B=v-32|0,v=B,s=B+12|0,k=v+-64|0,v=k;i:{e:{r:{if(w=i[e>>2],o=i[w+204>>2],Y=i[w+208>>2],(o|0)!=(Y|0))for(V=s+8|0,E=w+216|0,m=k+4|0;;){f:{if(!(i[o+24>>2]!=i[w+188>>2]|i[o+28>>2]!=i[w+192>>2])){n=i[o>>2];break f}if(n=i[o>>2],n-1>>>0<2)break f;if(r=C(72),i[k>>2]=r,i[k+4>>2]=68,i[k+8>>2]=-2147483576,z(r,25815,68),t[r+68|0]=0,a(s,4,0,k),t[k+11|0]>=0)break i;Z(i[k>>2]);break i}if(L3(r,f,n,i[w+200>>2],k+60|0,k+56|0),G=u[o+23|0],h=i[o+28>>2],_=i[o+24>>2],l=i[k+60>>2],!(l>>>0<=o0[o+32>>2]&o0[o+36>>2]>=o0[k+56>>2])){i[m>>2]=0,i[m+4>>2]=0,X[m+16>>1]=0,i[m+8>>2]=0,i[m+12>>2]=0,t[k+22|0]=1,t[k+55|0]=0,t[k+47|0]=0,t[k+48|0]=0,t[k+49|0]=0,t[k+50|0]=0,t[k+51|0]=0,t[k+52|0]=0,t[k+53|0]=0,t[k+54|0]=0,t[k+39|0]=0,t[k+40|0]=0,t[k+41|0]=0,t[k+42|0]=0,t[k+43|0]=0,t[k+44|0]=0,t[k+45|0]=0,t[k+46|0]=0,t[k+31|0]=0,t[k+32|0]=0,t[k+33|0]=0,t[k+34|0]=0,t[k+35|0]=0,t[k+36|0]=0,t[k+37|0]=0,t[k+38|0]=0,t[k+23|0]=0,t[k+24|0]=0,t[k+25|0]=0,t[k+26|0]=0,t[k+27|0]=0,t[k+28|0]=0,t[k+29|0]=0,t[k+30|0]=0,i[k>>2]=i[o>>2],R=(k|0)==(o|0),R||(l=i[o+4>>2],n=i[o+8>>2],h1(m,l,n,n-l>>2),l=i[k+60>>2]),N=i[k+56>>2],I=i[o+16>>2],Q=p[o+20>>1],n=1;f:{A:switch(i[w+200>>2]){case 10:case 12:case 14:n=3;break f;case 11:case 13:case 15:n=4;break f;case 0:case 1:case 2:case 3:case 99:break f;default:break A}n=0}if(O6(s,k,l,N,I,Q,n,0,E),i[s>>2])break e;if(t[s+19|0]<0&&Z(i[s+8>>2]),!i[k+40>>2])break r;if(i[o+28>>2])for(n=0;l=g(i[o+24>>2],G),l&&z(i[k+40>>2]+g(i[k+52>>2],n)|0,i[o+40>>2]+g(i[o+52>>2],n)|0,l),n=n+1|0,n>>>0<o0[o+28>>2];);R5(E,i[o+48>>2]),Z(i[o+44>>2]),i[o>>2]=i[k>>2],R||(l=i[k+4>>2],n=i[k+8>>2],h1(o+4|0,l,n,n-l>>2)),n=i[k+20>>2],i[o+16>>2]=i[k+16>>2],i[o+20>>2]=n,n=i[k+52>>2],i[o+48>>2]=i[k+48>>2],i[o+52>>2]=n,n=i[k+44>>2],i[o+40>>2]=i[k+40>>2],i[o+44>>2]=n,n=i[k+36>>2],i[o+32>>2]=i[k+32>>2],i[o+36>>2]=n,n=i[k+28>>2],i[o+24>>2]=i[k+24>>2],i[o+28>>2]=n,n=i[k+4>>2],n&&(i[k+8>>2]=n,Z(n)),l=i[k+60>>2]}if(!(!h|(l|0)==(_|0)|l>>>0<=_>>>0))for(Q=g(_-1|0,G),I=0;;){if(n=_,l>>>0>n>>>0)for(;G&&(l=i[o+40>>2]+g(i[o+52>>2],I)|0,z(l+g(n,G)|0,l+Q|0,G)),n=n+1|0,l=i[k+60>>2],n>>>0<l>>>0;);if(I=I+1|0,(I|0)==(h|0))break}if(o0[k+56>>2]>h>>>0)for(Q=h-1|0;_=g(i[k+60>>2],G),_&&(n=i[o+40>>2],l=i[o+52>>2],z(n+g(l,h)|0,n+g(l,Q)|0,_)),h=h+1|0,h>>>0<o0[k+56>>2];);if(o=o+56|0,(Y|0)==(o|0))break}if(r=i[28729],i[s>>2]=i[28728],i[s+4>>2]=r,f=s+8|0,t[114931]>=0){r=i[28731],i[f>>2]=i[28730],i[f+4>>2]=r,i[f+8>>2]=i[28732];break i}T(f,i[28730],i[28731]);break i}if(r=i[28734],i[s>>2]=i[28733],i[s+4>>2]=r,t[114951]>=0){r=i[28736],i[V>>2]=i[28735],i[V+4>>2]=r,i[V+8>>2]=i[28737];break e}T(V,i[28735],i[28736])}if(r=i[k+4>>2],!r)break i;i[k+8>>2]=r,Z(r)}v=k- -64|0;i:{if(i[B+12>>2]){r=A,A=i[e>>2],c0(r,s,A?A+172|0:0);break i}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}t[B+31|0]<0&&Z(i[B+20>>2]),v=B+32|0}function eZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;k=v-160|0,v=k,o=w2(r);i:{e:{r:{f:{A:{k:{n:{if(n=i[f+48>>2],!(!n|o>>>0<=n>>>0)){i[k+104>>2]=0,i[k+76>>2]=78164,i[k+20>>2]=78144,e=i[19545],i[k+12>>2]=e,r=i[e-12>>2],e=k+12|0,i[r+e>>2]=i[19546],i[k+16>>2]=0,r=e+i[i[k+12>>2]-12>>2]|0,n=k+24|0,J0(r,n),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[k+20>>2]=r,l=i[r-12>>2],r=k+20|0,i[l+r>>2]=i[19548],l=i[19544],i[k+12>>2]=l,i[e+i[l-12>>2]>>2]=i[19549],i[k+76>>2]=78164,i[k+12>>2]=78124,i[k+20>>2]=78144,n=R0(n),i[n>>2]=77200,e=k- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,F(B0(F(B0(F(r,32333,25),o),31262,54),i[f+48>>2]),4938,11),e=i[k+72>>2];t:{if(e&16){f=k+44|0,r=i[k+68>>2],e=i[k+48>>2],r>>>0<e>>>0?i[k+68>>2]=e:e=r;break t}if(!(e&8)){r=0,t[k+11|0]=0,f=k;break e}f=k+32|0,e=i[k+40>>2]}if(r=e,e=i[f>>2],r=r-e|0,r>>>0>=2147483640)break n;if(r>>>0>=11){o=r|7,f=C(o+1|0),i[k+8>>2]=o-2147483647,i[k>>2]=f,i[k+4>>2]=r;break r}if(t[k+11|0]=r,f=k,r)break r;r=0;break e}if(o>>>0>o0[r+16>>2]/6>>>0){i[k+104>>2]=0,i[k+76>>2]=78164,i[k+20>>2]=78144,e=i[19545],i[k+12>>2]=e,f=i[e-12>>2],e=k+12|0,i[f+e>>2]=i[19546],i[k+16>>2]=0,f=e+i[i[k+12>>2]-12>>2]|0,n=k+24|0,J0(f,n),t[f+80|0]=0,i[f+72>>2]=0,f=i[19547],i[k+20>>2]=f,l=i[f-12>>2],f=k+20|0,i[l+f>>2]=i[19548],l=i[19544],i[k+12>>2]=l,i[e+i[l-12>>2]>>2]=i[19549],i[k+76>>2]=78164,i[k+12>>2]=78124,i[k+20>>2]=78144,n=R0(n),i[n>>2]=77200,e=k- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,F(B0(F(B0(F(f,32333,25),o),30940,44),o0[r+16>>2]/6|0),4938,11),e=i[k+72>>2];t:{if(e&16){f=k+44|0,r=i[k+68>>2],e=i[k+48>>2],r>>>0<e>>>0?i[k+68>>2]=e:e=r;break t}if(!(e&8)){r=0,t[k+11|0]=0,f=k;break f}f=k+32|0,e=i[k+40>>2]}if(r=e,e=i[f>>2],r=r-e|0,r>>>0>=2147483640)break n;if(r>>>0>=11){o=r|7,f=C(o+1|0),i[k+8>>2]=o-2147483647,i[k>>2]=f,i[k+4>>2]=r;break A}if(t[k+11|0]=r,f=k,r)break A;r=0;break f}n=e+100|0,l=i[e+100>>2],f=(i[e+104>>2]-l|0)/6|0;t:{if(f>>>0<o>>>0){Po(n,o-f|0);break t}if(f>>>0<=o>>>0)break t;i[e+104>>2]=l+g(o,6)}e=u[r+20|0];t:{if(!(!i[r+16>>2]|(!o|e&1))){for(f=0;;){o:{if(l=w2(r),s=w2(r),h=w2(r),e=i[n>>2]+g(f,6)|0,X[e+4>>1]=h,X[e+2>>1]=s,X[e>>1]=l,e=u[r+20|0],f=f+1|0,e&1|o>>>0<=f>>>0)break o;if(i[r+16>>2])continue}break}if(e&1)break t;break k}if(!(e&1))break k}if(t[k+12|0]=0,t[k+23|0]=0,a(A,2,100,k+12|0),t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}I0(),M()}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}if(!r)break f;z(f,e,r)}t[r+f|0]=0,a(A,2,100,k),t[k+11|0]<0&&Z(i[k>>2]),A=i[19543],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[19551],i[k+20>>2]=i[19552],i[n>>2]=77200,t[k+67|0]<0&&Z(i[k+56>>2]),y0(n),Y0(k+76|0);break i}if(!r)break e;z(f,e,r)}t[r+f|0]=0,a(A,2,1e3,k),t[k+11|0]<0&&Z(i[k>>2]),A=i[19543],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[19551],i[k+20>>2]=i[19552],i[n>>2]=77200,t[k+67|0]<0&&Z(i[k+56>>2]),y0(n),Y0(k+76|0)}v=k+160|0}function Gn(){var A=0,e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;Zr(),w=C(8),h=C(232),i[h>>2]=103360,i[h+4>>2]=0,i[h+8>>2]=0,f=h+16|0,A=f,i[A>>2]=0,i[A+4>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,i[A+8>>2]=0,i[A+12>>2]=5186,i[A+16>>2]=A+20,i[A+36>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=4,i[A+168>>2]=0,u[115e3]||(t[115e3]=1),k=f- -64|0,A=i[28752];i:{e:{if(!A){r=115008,e=115008;break e}for(;;){if(e=A,r=i[A+16>>2],r>>>0>k>>>0){if(r=A,A=i[A>>2],A)continue;break e}if(r>>>0>=k>>>0)break i;if(A=i[e+4>>2],!A)break}r=e+4|0}A=C(28),i[A+20>>2]=0,i[A+24>>2]=0,i[A+16>>2]=k,i[A+8>>2]=e,i[A>>2]=0,i[A+4>>2]=0,i[r>>2]=A,e=i[i[28751]>>2],e&&(i[28751]=e),G1(i[28752],A),i[28753]=i[28753]+1}i[A+20>>2]=0,i[A+24>>2]=0,i[f+168>>2]=k,i[f+172>>2]=0,i[f+176>>2]=0,i[f+200>>2]=0,i[f+204>>2]=0,i[f+180>>2]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+192>>2]=0,i[f+208>>2]=0,i[f+212>>2]=1,i[f+196>>2]=f+200;i:{e:{if(A=Y3(20929),!A||v4(A,12423)&&v4(A,21338))break e;z(k,102080,104);break i}z(k,101976,104)}e=C(204),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=100736,B=f,m=e3(e+12|0),i[B+48>>2]=m,A=i[f+52>>2],i[f+52>>2]=e;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(e=i[f+48>>2],i[e+168>>2]=f- -64,A=i[e+20>>2],k=i[e+16>>2],(A|0)!=(k|0))for(;;){r=i[A-4>>2];i:{if(!r||(s=i[r+4>>2],i[r+4>>2]=s-1,s))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=A-8|0,(k|0)==(A|0))break}i[e+20>>2]=k,A=C(136),i[A>>2]=95948,i[A+4>>2]=0,i[A+8>>2]=0,r=A+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=92500,i[A+60>>2]=0,i[A+64>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+72>>2]=-1,i[A+76>>2]=-1,i[A+80>>2]=-1,i[A+84>>2]=-1,i[A+88>>2]=0,i[A+92>>2]=0,i[A+96>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,t[A+112|0]=0,i[r>>2]=93096,i[A+132>>2]=0,i[A+124>>2]=0,i[A+128>>2]=0,i[A+116>>2]=0,i[A+120>>2]=0,i[A+32>>2]=1718909296,i[e+28>>2]=r,k=i[e+32>>2],i[e+32>>2]=A;i:{e:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[e+28>>2],A=i[e+32>>2],A))break e;A=0;break i}i[A+4>>2]=i[A+4>>2]+1}i:{if(k=i[e+20>>2],n=i[e+24>>2],k>>>0<n>>>0){i[k+4>>2]=A,i[k>>2]=r,i[e+20>>2]=k+8;break i}e:{if(o=k,k=i[e+16>>2],s=o-k|0,_=s>>3,l=_+1|0,l>>>0<536870912){if(n=n-k|0,o=n>>2,l=n>>>0>=2147483640?536870911:l>>>0<o>>>0?o:l,l){if(l>>>0>=536870912)break e;o=C(l<<3)}else o=0;n=o+s|0,i[n+4>>2]=A,i[n>>2]=r,A=n-(_<<3)|0,s&&z(A,k,s),i[e+24>>2]=o+(l<<3),r=n+8|0,i[e+20>>2]=r,i[e+16>>2]=A,k&&Z(k),i[e+20>>2]=r;break i}s0(),M()}x0(),M()}if(hr(f+16|0,i[f+20>>2]),i[f+16>>2]=f+20,i[f+20>>2]=0,i[f+24>>2]=0,A=i[f+32>>2],r=i[f+28>>2],(A|0)!=(r|0))for(;;){e=i[A-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(r|0)==(A|0))break}i[f+32>>2]=r,A=i[f+44>>2],i[f+40>>2]=0,i[f+44>>2]=0;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return i[w+4>>2]=h,i[w>>2]=f,w|0}function Wn(A,e,r,f){var k=0,n=0,o=0,l=0,s=0;n=v-80|0,v=n,k=n+48|0,VA(k,e,r);i:{e:{if(o=u[n+68|0],(o|0)==255||(l=i[25179],i[n+32>>2]=i[25178],i[n+36>>2]=l,l=n+32|0,W[i[l+(o<<2)>>2]](n+79|0,k),o))break e;e=C(48),i[n+32>>2]=e,i[n+36>>2]=45,i[n+40>>2]=-2147483600,r=u[24078]|u[24079]<<8|(u[24080]<<16|u[24081]<<24),f=u[24074]|u[24075]<<8|(u[24076]<<16|u[24077]<<24),t[e+37|0]=f,t[e+38|0]=f>>>8,t[e+39|0]=f>>>16,t[e+40|0]=f>>>24,t[e+41|0]=r,t[e+42|0]=r>>>8,t[e+43|0]=r>>>16,t[e+44|0]=r>>>24,r=u[24073]|u[24074]<<8|(u[24075]<<16|u[24076]<<24),f=u[24069]|u[24070]<<8|(u[24071]<<16|u[24072]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[24065]|u[24066]<<8|(u[24067]<<16|u[24068]<<24),f=u[24061]|u[24062]<<8|(u[24063]<<16|u[24064]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[24057]|u[24058]<<8|(u[24059]<<16|u[24060]<<24),f=u[24053]|u[24054]<<8|(u[24055]<<16|u[24056]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[24049]|u[24050]<<8|(u[24051]<<16|u[24052]<<24),f=u[24045]|u[24046]<<8|(u[24047]<<16|u[24048]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[24041]|u[24042]<<8|(u[24043]<<16|u[24044]<<24),f=u[24037]|u[24038]<<8|(u[24039]<<16|u[24040]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+45|0]=0,e=a(k,5,0,l),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(t[n+43|0]>=0)break i;Z(i[n+32>>2]);break i}k=C(136),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=98028,l=k+16|0,o=l,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[o>>2]=95816,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1701604967,o=k+120|0;e:{r:{f:{A:{if(t[f+11|0]>=0){if(i[n+24>>2]=i[f+8>>2],s=i[f+4>>2],i[n+16>>2]=i[f>>2],i[n+20>>2]=s,t[n+27|0]>=0)break A;break r}if(T(n+16|0,i[f>>2],i[f+4>>2]),f=t[n+27|0],t[k+131|0]<0)break f;if((f|0)<0)break r}f=i[n+20>>2],i[o>>2]=i[n+16>>2],i[o+4>>2]=f,i[o+8>>2]=i[n+24>>2];break e}s=o,o=(f|0)<0,R1(s,o?i[n+16>>2]:n+16|0,o?i[n+20>>2]:f);break e}m1(o,i[n+16>>2],i[n+20>>2])}if(t[n+27|0]<0&&Z(i[n+16>>2]),i[n+12>>2]=k,i[n+8>>2]=l,i[k+4>>2]=i[k+4>>2]+1,f=i[n+12>>2],i[n>>2]=i[n+8>>2],i[n+4>>2]=f,e=Ei(e,r,n,0),t[A+20|0]=0,i[A>>2]=e,A=i[k+4>>2],i[k+4>>2]=A-1,A)break i;W[i[i[k>>2]+8>>2]](k),y(k)}v=n+80|0}function rZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;k=v-128|0,v=k,o=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[k+124>>2]=e,i[k+120>>2]=o,W[i[i[f>>2]+100>>2]](k+104|0,i[f+4>>2],k+120|0,n);i:{e:{r:{f:{A:{k:{if(n=i[k+104>>2],n){if(f=i[k+108>>2],o=i[k+112>>2],e=l2(o),e>>>0>=2147483640)break k;n:{t:{if(e>>>0>=11){l=e|7,r=C(l+1|0),i[k+76>>2]=l-2147483647,i[k+68>>2]=r,i[k+72>>2]=e;break t}if(t[k+79|0]=e,r=k+68|0,!e)break n}if(!e)break n;z(r,o,e)}t[e+r|0]=0,e=a(k+80|0,n,f,k+68|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;n:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+44|0]=1;break n}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+44|0]=1,(r|0)>=0)break n;Z(i[e+8>>2])}t[k+79|0]<0&&Z(i[k+68>>2]),f=0;break e}if(n=0,i[k+76>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,W[i[i[f>>2]+104>>2]](k+80|0,i[f+4>>2],k- -64|0,k+60|0,0),i[k+112>>2]=i[k+88>>2],e=i[k+84>>2],r=i[k+80>>2],i[k+104>>2]=r,i[k+108>>2]=e,r)break r;for(o=0;;){if(i[k+64>>2]){r=o-n|0,l=i[k+60>>2],s=r+l|0;n:{if(s>>>0>r>>>0){if(e=i[k+76>>2],l>>>0<=e-o>>>0){l&&l0(o,0,l),o=o+l|0,i[k+72>>2]=o,n=i[k+68>>2];break n}if((s|0)<0)break A;if(e=e-n|0,o=e<<1,o=e>>>0>=1073741823?2147483647:o>>>0>s>>>0?o:s,e=C(o),l&&l0(e+r|0,0,l),r&&z(e,n,r),i[k+76>>2]=e+o,o=e+s|0,i[k+72>>2]=o,i[k+68>>2]=e,!n){n=e;break n}Z(n),n=e;break n}if(r>>>0<=s>>>0)break n;o=n+s|0,i[k+72>>2]=o}if(e=i[k+60>>2],e&&z(r+n|0,i[k+64>>2],e),W[i[i[f>>2]+104>>2]](k+80|0,i[f+4>>2],k- -64|0,k+60|0,0),i[k+112>>2]=i[k+88>>2],e=i[k+84>>2],r=i[k+80>>2],i[k+104>>2]=r,i[k+108>>2]=e,!r)continue;break r}break}if(i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,f=i[k+68>>2],i[k+68>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,i[k>>2]=0,i[k+4>>2]=0,r=0,e=0,(f|0)!=(o|0)){if(r=o-f|0,(r|0)<0)break f;e=C(r),r&&z(e,f,r),r=e+r|0}i[k+40>>2]=0,t[k+39|0]=u[k+82|0],t[k+36|0]=1,i[k+28>>2]=0,i[k+32>>2]=0,t[k+26|0]=0,X[k+24>>1]=1,n=u[k+80|0]|u[k+81|0]<<8,t[k+37|0]=n,t[k+38|0]=n>>>8,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,i[A+20>>2]=r,i[A+16>>2]=r,i[A+12>>2]=e,i[k+20>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,e=i[k+32>>2],r=i[k+36>>2],n=i[k+40>>2],o=i[k+24>>2],l=i[k+28>>2],t[A+44|0]=0,i[A+40>>2]=n,i[A+32>>2]=e,i[A+36>>2]=r,i[A+24>>2]=o,i[A+28>>2]=l;break e}I0(),M()}s0(),M()}s0(),M()}if(f=i[k+108>>2],o=i[k+112>>2],e=l2(o),e>>>0>=2147483640)break i;r:{f:{if(e>>>0>=11){l=e|7,n=C(l+1|0),i[k+56>>2]=l-2147483647,i[k+48>>2]=n,i[k+52>>2]=e;break f}if(t[k+59|0]=e,n=k+48|0,!e)break r}if(!e)break r;z(n,o,e)}t[e+n|0]=0,e=a(k+80|0,r,f,k+48|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+44|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+44|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}t[k+59|0]<0&&Z(i[k+48>>2]),A=i[k+68>>2],A&&(i[k+72>>2]=A,Z(A)),f=0}A=i[k+124>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}f&&Z(f),v=k+128|0;return}I0(),M()}function Xn(A,e,r,f,k,n){var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;o=v-80|0,v=o,l=i[r>>2],m=i[l+200>>2],s=i[l+196>>2],i[e+196>>2]=s,i[e+192>>2]=k,i[e+188>>2]=f,i[e+200>>2]=(s|0)==1?m||3:m;i:{e:{r:{f:{if(s=i[l+204>>2],G=i[l+208>>2],(s|0)!=(G|0)){for(Q=e+204|0,V=e+216|0,Y=k>>>1|0,w=o+28|0,E=m-1>>>0<2?f>>>1|0:0;;){if(l=i[s>>2],X[w+16>>1]=0,i[w+8>>2]=0,i[w+12>>2]=0,i[w>>2]=0,i[w+4>>2]=0,t[o+46|0]=1,t[o+79|0]=0,t[o+71|0]=0,t[o+72|0]=0,t[o+73|0]=0,t[o+74|0]=0,t[o+75|0]=0,t[o+76|0]=0,t[o+77|0]=0,t[o+78|0]=0,t[o+63|0]=0,t[o+64|0]=0,t[o+65|0]=0,t[o+66|0]=0,t[o+67|0]=0,t[o+68|0]=0,t[o+69|0]=0,t[o+70|0]=0,t[o+55|0]=0,t[o+56|0]=0,t[o+57|0]=0,t[o+58|0]=0,t[o+59|0]=0,t[o+60|0]=0,t[o+61|0]=0,t[o+62|0]=0,t[o+47|0]=0,t[o+48|0]=0,t[o+49|0]=0,t[o+50|0]=0,t[o+51|0]=0,t[o+52|0]=0,t[o+53|0]=0,t[o+54|0]=0,i[o+24>>2]=l,l=l-1>>>0<2,h=f-(l?E:0)|0,(o+24|0)!=(s|0)&&(_=i[s+4>>2],B=i[s+8>>2],h1(w,_,B,B-_>>2)),O6(A,o+24|0,h,k-((m|0)==1&&l?Y:0)|0,i[s+16>>2],p[s+20>>1],u[s+22|0],n,V),i[A>>2])break e;t[A+19|0]<0&&Z(i[A+8>>2]),l=i[e+208>>2];A:{if(l>>>0<o0[e+212>>2]){if(h=i[o+24>>2],i[l+12>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=h,h=i[o+32>>2],B=i[o+28>>2],(h|0)!=(B|0)){if(h=h-B|0,(h|0)<0)break f;_=C(h),i[l+8>>2]=_,i[l+4>>2]=_,I=h+_|0,i[l+12>>2]=I,h&&z(_,B,h),i[l+8>>2]=I}h=i[o+44>>2],i[l+16>>2]=i[o+40>>2],i[l+20>>2]=h,h=i[o+76>>2],i[l+48>>2]=i[o+72>>2],i[l+52>>2]=h,h=i[o+68>>2],i[l+40>>2]=i[o+64>>2],i[l+44>>2]=h,h=i[o+60>>2],i[l+32>>2]=i[o+56>>2],i[l+36>>2]=h,h=i[o+52>>2],i[l+24>>2]=i[o+48>>2],i[l+28>>2]=h,l=l+56|0;break A}l=ht(Q,o+24|0)}if(i[e+208>>2]=l,l=i[o+28>>2],l&&(i[o+32>>2]=l,Z(l)),s=s+56|0,(G|0)==(s|0))break}l=i[r>>2]}if(k=0,i[o+20>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,n=0,s=i[l+80>>2],w=i[l+84>>2],(s|0)!=(w|0)){if(f=w-s|0,(f|0)/44>>>0>=97612894)break r;for(n=C(f),i[o+16>>2]=n,i[o+12>>2]=n,k=f+n|0,i[o+20>>2]=k;;){f=i[s+4>>2],i[n>>2]=i[s>>2],i[n+4>>2]=f,f=u[s+25|0]|u[s+26|0]<<8|(u[s+27|0]<<16|u[s+28|0]<<24),l=u[s+21|0]|u[s+22|0]<<8|(u[s+23|0]<<16|u[s+24|0]<<24),t[n+21|0]=l,t[n+22|0]=l>>>8,t[n+23|0]=l>>>16,t[n+24|0]=l>>>24,t[n+25|0]=f,t[n+26|0]=f>>>8,t[n+27|0]=f>>>16,t[n+28|0]=f>>>24,f=i[s+20>>2],i[n+16>>2]=i[s+16>>2],i[n+20>>2]=f,f=i[s+12>>2],i[n+8>>2]=i[s+8>>2],i[n+12>>2]=f,f=n+32|0;A:{if(t[s+43|0]>=0){l=i[s+36>>2],i[f>>2]=i[s+32>>2],i[f+4>>2]=l,i[f+8>>2]=i[s+40>>2];break A}T(f,i[s+32>>2],i[s+36>>2])}if(n=n+44|0,s=s+44|0,(w|0)==(s|0))break}l=i[r>>2]}if(w=i[l+92>>2],f=i[e+80>>2],f){if(l=f,s=i[e+84>>2],(l|0)!=(s|0)){for(;t[s-1|0]<0&&Z(i[s-12>>2]),s=s-44|0,(f|0)!=(s|0););l=i[e+80>>2]}i[e+84>>2]=f,Z(l),l=i[r>>2]}if(r=i[o+12>>2],i[e+88>>2]=k,i[e+84>>2]=n,i[e+80>>2]=r,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[e+92>>2]=w,Ye(e,l),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}s0(),M()}s0(),M()}if(A=i[o+28>>2],!A)break i;i[o+32>>2]=A,Z(A)}v=o+80|0}function IA(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;f=v+-64|0,v=f,i[f+52>>2]=0,i[f+48>>2]=1,W[i[i[r>>2]+132>>2]](f+36|0,i[r+4>>2],f+60|0,f+56|0,f+52|0,0,f+48|0);i:{e:{r:{if(k=i[f+36>>2],k)break r;if(k=i[f+60>>2],!k){i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break e}n=e+36|0,l=e+28|0,w=e+24|0,s=e+12|0;f:{A:{k:{n:{t:switch(o=u[k+1|0],h=o>>>3|0,h-14|0){case 0:break n;case 1:break k;case 2:break t;default:break A}o=i[e+12>>2],!o|t[e+8|0]&1||q6(o,k,i[f+56>>2]),t[e+8|0]=1;break f}o=i[e+12>>2],!o|t[e+6|0]&1||q6(o,k,i[f+56>>2]),t[e+6|0]=1;break f}o=i[s>>2];k:{if(!o||(Tr(f+4|0,k,i[f+56>>2],o+104|0,w,l,0),t[f+23|0]<0&&Z(i[f+12>>2]),k=i[e+12>>2],X[k+172>>1]=p[e+32>>1],t[e+7|0]&1))break k;q6(k,i[f+60>>2],i[f+56>>2])}t[e+7|0]=1;break f}if(u[e+80|0]||(i[e+64>>2]=0,i[e+68>>2]=0,t[n+23|0]=0,t[n+24|0]=0,t[n+25|0]=0,t[n+26|0]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0,i[n>>2]=0,i[n+4>>2]=0,t[e+80|0]=1,i[e+76>>2]=0,t[e+72|0]=1),C6(n,k,i[f+56>>2]),o>>>0>95)break f;t[e+72|0]=h-7>>>0<3,i[e+76>>2]=i[f+52>>2]}f:{if(!i[f+48>>2])break f;if(i[f+52>>2]=0,i[f+48>>2]=1,W[i[i[r>>2]+132>>2]](f+36|0,i[r+4>>2],f+60|0,f+56|0,f+52|0,0,f+48|0),k=i[f+36>>2],k)break r;for(;;){if(k=i[f+60>>2],!k)break f;A:{k:{n:{t:{o:switch(o=u[k+1|0],h=o>>>3|0,h-14|0){case 0:break t;case 1:break o;case 2:break n;default:break k}o=i[s>>2];o:{if(!o||(Tr(f+4|0,k,i[f+56>>2],o+104|0,w,l,0),t[f+23|0]<0&&Z(i[f+12>>2]),k=i[e+12>>2],X[k+172>>1]=p[e+32>>1],t[e+7|0]&1))break o;q6(k,i[f+60>>2],i[f+56>>2])}t[e+7|0]=1;break A}o=i[e+12>>2],!o|t[e+6|0]&1||q6(o,k,i[f+56>>2]),t[e+6|0]=1;break A}o=i[e+12>>2],!o|t[e+8|0]&1||q6(o,k,i[f+56>>2]),t[e+8|0]=1;break A}if(u[e+80|0]||(i[e+64>>2]=0,i[e+68>>2]=0,t[n+23|0]=0,t[n+24|0]=0,t[n+25|0]=0,t[n+26|0]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0,i[n>>2]=0,i[n+4>>2]=0,t[e+80|0]=1,i[e+76>>2]=0,t[e+72|0]=1),C6(n,k,i[f+56>>2]),o>>>0>95)break A;t[e+72|0]=h-7>>>0<3,i[e+76>>2]=i[f+52>>2]}if(!i[f+48>>2])break f;if(i[f+52>>2]=0,i[f+48>>2]=1,W[i[i[r>>2]+132>>2]](f+36|0,i[r+4>>2],f+60|0,f+56|0,f+52|0,0,f+48|0),k=i[f+36>>2],!!k)break}break r}f:{if(r=i[w>>2],r&&(k=i[l>>2],k))break f;if(t[f+36|0]=0,t[f+47|0]=0,a(A,8,129,f+36|0),t[f+47|0]>=0)break e;Z(i[f+36>>2]);break e}f:{if(u[e+5|0]!=1||(l=i[s>>2],u[e+20|0]|!l))break f;i[f+36>>2]=l,r=i[e+16>>2],i[f+40>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=f+36|0,ao(n,r),g2(r),i[f+36>>2]=0,i[f+40>>2]=0,Q8(s,r),g2(r),t[e+20|0]=1,k=i[e+28>>2],r=i[e+24>>2]}i[e+68>>2]=k,i[e+64>>2]=r,X[e+60>>1]=257,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break e}if(n=i[f+40>>2],s=i[f+44>>2],e=l2(s),e>>>0>=2147483640)break i;r:{f:{if(e>>>0>=11){l=e|7,r=C(l+1|0),i[f+32>>2]=l-2147483647,i[f+24>>2]=r,i[f+28>>2]=e;break f}if(t[f+35|0]=e,r=f+24|0,!e)break r}if(!e)break r;z(r,s,e)}if(t[e+r|0]=0,a(A,k,n,f+24|0),t[f+35|0]>=0)break e;Z(i[f+24>>2])}v=f- -64|0;return}I0(),M()}function Lr(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;s=v-32|0,v=s,i[s+28>>2]=0,i[s+20>>2]=0,i[s+24>>2]=0,L1(s,i[e>>2],r,s+20|0);i:{e:{if(i[s>>2]||(r=i[s+20>>2],n=i[s+24>>2],(r|0)==(n|0)))break e;for(;;){r:{if(o=i[r>>2],!o||(o=Z0(o,92792,92812),!o))break r;r=i[r+4>>2];f:{if(!r){n=i[o+108>>2],o=i[o+104>>2];break f}if(l=i[r+4>>2],_=l+1|0,i[r+4>>2]=_,n=i[o+108>>2],o=i[o+104>>2],i[r+4>>2]=l,_)break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(!o|!n)break e;if(i[A+8>>2]=0,i[A+12>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,u0[A+24>>3]=+(n>>>0)/+(k|0),u0[A>>3]=+(o>>>0)/+(f|0),r=i[s+20>>2],_=i[s+24>>2],(r|0)==(_|0))break i;for(;;){f=i[r>>2],k=i[f+16>>2];f:{A:{if((k|0)!=1668047216){if((k|0)!=1769107316){if((k|0)!=1768778098)break f;k=0,l=Z0(f,92792,94184);k:{if(!l||(f=i[r+4>>2],!f))break k;i[f+4>>2]=i[f+4>>2]+1,k=f}k:{if(i[l+100>>2]==1){u0[A>>3]=-u0[A>>3],u0[A+8>>3]=-u0[A+8>>3],u0[A+32>>3]=+(o-1>>>0)-u0[A+32>>3];break k}u0[A+16>>3]=-u0[A+16>>3],u0[A+24>>3]=-u0[A+24>>3],u0[A+40>>3]=+(n-1>>>0)-u0[A+40>>3]}if(!k)break f;if(f=i[k+4>>2],i[k+4>>2]=f-1,!f)break A;break f}k=0,l=Z0(f,92792,94104);k:{if(!l||(f=i[r+4>>2],!f))break k;i[f+4>>2]=i[f+4>>2]+1,k=f}f=i[l+100>>2];k:{n:{t:{if((f|0)!=270){if((f|0)!=180){if((f|0)!=90){f=n;break k}h=u0[A+32>>3],u0[A+32>>3]=u0[A+40>>3],B=u0[A+8>>3],u0[A+8>>3]=u0[A+24>>3],m=u0[A>>3],u0[A>>3]=u0[A+16>>3],u0[A+24>>3]=-B,u0[A+16>>3]=-m,h=+(o>>>0)-h+-1;break t}u0[A>>3]=-u0[A>>3],u0[A+8>>3]=-u0[A+8>>3],u0[A+16>>3]=-u0[A+16>>3],u0[A+24>>3]=-u0[A+24>>3],u0[A+32>>3]=+(o-1>>>0)-u0[A+32>>3],h=+(n-1>>>0)-u0[A+40>>3],f=n;break n}h=u0[A+24>>3],u0[A+24>>3]=u0[A+8>>3],B=u0[A+16>>3],u0[A+16>>3]=u0[A>>3],u0[A+8>>3]=-h,u0[A>>3]=-B,h=u0[A+32>>3],u0[A+32>>3]=+(n>>>0)-u0[A+40>>3]+-1}f=o,o=n}u0[A+40>>3]=h}if(!k){n=f;break f}if(l=i[k+4>>2],i[k+4>>2]=l-1,n=f,!l)break A;break f}k=0,l=Z0(f,92792,94264);k:{if(!l||(f=i[r+4>>2],!f))break k;i[f+4>>2]=i[f+4>>2]+1,k=f}if(f=pe(l,o),n=Qe(l,n),u0[A+32>>3]=u0[A+32>>3]-+(f|0),u0[A+40>>3]=u0[A+40>>3]-+(n|0),f=i[l+100>>2],n=i[l+104>>2],w=(n|0)/2|0,o=f+w|0,f=(f>>31)+(w>>31)|0,o=p2(o,o>>>0<w>>>0?f+1|0:f,n,n>>31),f=i[l+108>>2],n=i[l+112>>2],w=(n|0)/2|0,l=f+w|0,f=(f>>31)+(w>>31)|0,n=p2(l,l>>>0<w>>>0?f+1|0:f,n,n>>31),!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break f}W[i[i[k>>2]+8>>2]](k),y(k)}if(r=r+8|0,(_|0)==(r|0))break}break i}if(r=r+8|0,(n|0)==(r|0))break}}i[A+8>>2]=0,i[A+12>>2]=0,i[A>>2]=0,i[A+4>>2]=1072693248,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=1072693248,i[A+16>>2]=0,i[A+20>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0}if(t[s+19|0]<0&&Z(i[s+8>>2]),f=i[s+20>>2],f){if(A=f,r=i[s+24>>2],(A|0)!=(r|0)){for(;;){A=i[r-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=r-8|0,(f|0)==(r|0))break}A=i[s+20>>2]}i[s+24>>2]=f,Z(A)}A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=s+32|0}function fZ(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=D(0),R=D(0),N=D(0),U=D(0),x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0,t0=0,_0=0,g0=0;f=v-48|0,v=f;i:{e:{r:{if((K0(i[r>>2],0)|0)!=8||(K0(i[r>>2],1)|0)!=8)break r;if((K0(i[r>>2],2)|0)==8)break e}e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,r=A+8|0;r:{if(t[114951]>=0){e=i[28736],i[r>>2]=i[28735],i[r+4>>2]=e,i[r+8>>2]=i[28737];break r}T(r,i[28735],i[28736])}t[A+20|0]=1;break i}h=C(248),e=h,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=101168,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,n=e+12|0,i[e+176>>2]=n,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e)),e=i[r>>2],o=i[e+188>>2],_=i[e+192>>2],t1(n,o,_,1,10),a0(f+24|0,n,10,o,_,8,l,0);e:{if(i[f+24>>2]){if(e=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=e,r=A+8|0,t[f+43|0]>=0){e=i[f+36>>2],i[r>>2]=i[f+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+40>>2],t[A+20|0]=1;break e}if(T(r,i[f+32>>2],i[f+36>>2]),e=t[f+43|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[f+32>>2]);break e}if(t[f+43|0]<0&&Z(i[f+32>>2]),i[f+36>>2]=-1086926434,i[f+40>>2]=1071829221,i[f+28>>2]=1068725436,i[f+32>>2]=-1095748968,t[f+24|0]=1,r8(i[r>>2])&&(k=i[r>>2],e=p[k+6>>1]|p[k+8>>1]<<16,Pe(f+4|0,(p[k+10>>1]|p[k+12>>1]<<16)&65535,e&65535),i[f+40>>2]=i[f+20>>2],e=i[f+16>>2],i[f+32>>2]=i[f+12>>2],i[f+36>>2]=e,e=i[f+8>>2],i[f+24>>2]=i[f+4>>2],i[f+28>>2]=e),E=E0[f+28>>2],R=E0[f+36>>2],N=E0[f+32>>2],U=E0[f+40>>2],l=0,e=Q0(i[r>>2],0),x=p6(D(U*D(256))),j=p6(D(N*D(256))),O=p6(D(R*D(256))),S=p6(D(E*D(256))),e?(q=i[e+40>>2],m=i[e+52>>2]):m=0,e=Q0(i[r>>2],1),e?(l=i[e+52>>2],G=i[e+40>>2]):G=0,e=Q0(i[r>>2],2),e?(d=i[e+40>>2],I=i[e+52>>2]):I=0,e=Q0(n,10),e?(c=i[e+52>>2],e=i[e+40>>2]):e=0,!(!_|!o))for(k=0;;){for(A0=g(k,c)+e|0,t0=g(k,m)+q|0,r=k>>>1|0,_0=g(r,I)+d|0,g0=g(r,l)+G|0,r=0,Q=0,V=0,Y=0;r&1||(s=r>>>1|0,w=u[s+g0|0]-128|0,s=u[s+_0|0]-128|0,V=(g(w,j)+g(s,O)|0)+128>>8,Q=g(w,x)+128>>8,Y=g(s,S)+128>>8),B=g(r,3)+A0|0,w=u[r+t0|0],s=w+Q|0,t[B+2|0]=(s|0)>=0?s>>>0>=255?255:s:0,s=w+V|0,t[B+1|0]=(s|0)>=0?s>>>0>=255?255:s:0,s=w+Y|0,t[B|0]=(s|0)>=0?s>>>0>=255?255:s:0,r=r+1|0,(o|0)!=(r|0););if(k=k+1|0,(_|0)==(k|0))break}t[A+20|0]=0,i[A+4>>2]=h,i[A>>2]=n;break i}if(A=i[h+4>>2],i[h+4>>2]=A-1,A)break i;W[i[i[h>>2]+8>>2]](h),y(h)}v=f+48|0}function j4(A,e,r,f,k,n,o,l,s){var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;w=v-112|0,v=w,h=s&2147483647;i:{e:{if(m=k&2147483647,_=2147418112,B=!(e|r),!(f|m?m-_>>>0<2147549184:B)&&(V=h-_|0,!l&(V|0)==-2147418112?n|o:(V|0)==-2147418112&(l|0)!=0|V>>>0>2147549184))break e;if(!(!f&(m|0)==2147418112?B:m>>>0<2147418112)){l=f,s=k|32768,n=e,o=r;break i}if(!(!l&(h|0)==2147418112?!(n|o):h>>>0<2147418112)){s=s|32768;break i}if(!(e|f|(m^2147418112|r))){_=f,f=!(e^n|f^l|(r^o|k^s^-2147483648)),l=f?0:_,s=f?2147450880:k,n=f?0:e,o=f?0:r;break i}if(_=n|l,!(_|(h^2147418112|o)))break i;if(!(e|f|(r|m))){if(o|h|_)break i;n=e&n,o=r&o,l=f&l,s=k&s;break i}if(n|l|(o|h))break e;n=e,o=r,l=f,s=k;break i}_=(h|0)==(m|0),I=_&(f|0)==(l|0)?(r|0)==(o|0)&e>>>0<n>>>0|r>>>0<o>>>0:_&f>>>0<l>>>0|h>>>0>m>>>0,B=I,m=B?n:e,V=B?o:r,_=B?s:k,Y=_,B=B?l:f,Q=_&65535,h=I?f:l,_=I?k:s,l=_,_=l>>>16&32767,G=Y>>>16&32767,G||(G=!(B|Q),f=_1(G?V:Q),G=((f|0)==32?_1(G?m:B)+32|0:f)+(G?64:0)|0,g4(w+96|0,m,V,B,Q,G-15|0),B=i[w+104>>2],Q=i[w+108>>2],V=i[w+100>>2],G=16-G|0,m=i[w+96>>2]),n=I?e:n,o=I?r:o,e=h,r=l&65535,_||(h=!(e|r),I=_1(h?o:r),h=((I|0)==32?_1(h?n:e)+32|0:I)+(h?64:0)|0,g4(w+80|0,n,o,e,r,h-15|0),_=16-h|0,n=i[w+80>>2],o=i[w+84>>2],e=i[w+88>>2],r=i[w+92>>2]),f=r<<3,r=e,e=f|e>>>29,h=r<<3,r=e,e=o>>>29|h,r=r|524288,h=Q<<3|B>>>29,Q=B<<3|V>>>29,I=h,l=k^s,h=o<<3|n>>>29,f=n<<3;e:{if((_|0)==(G|0))break e;if(k=G-_|0,k>>>0>127){e=0,r=0,h=0,f=1;break e}g4(w- -64|0,f,h,e,r,128-k|0),I6(w+48|0,f,h,e,r,k),e=i[w+56>>2],r=i[w+60>>2],h=i[w+52>>2],f=i[w+48>>2]|(i[w+64>>2]|i[w+72>>2]|(i[w+68>>2]|i[w+76>>2]))!=0}B=f,_=h,I=I|524288,h=V<<3|m>>>29,m=m<<3;e:{if((l|0)<0){if(n=0,o=0,l=0,s=0,!(m^B|e^Q|(h^_|r^I)))break i;if(f=m-B|0,k=h-((m>>>0<B>>>0)+_|0)|0,n=Q-e|0,o=(h|0)==(_|0)&m>>>0<B>>>0|h>>>0<_>>>0,l=n-o|0,e=(I-((e>>>0>Q>>>0)+r|0)|0)-(n>>>0<o>>>0)|0,s=e,e>>>0>524287)break e;r=!(e|l),o=_1(r?k:e),r=((o|0)==32?_1(r?f:l)+32|0:o)+(r?64:0)|0,e=r-12|0,g4(w+32|0,f,k,l,s,e),G=G-e|0,l=i[w+40>>2],s=i[w+44>>2],f=i[w+32>>2],k=i[w+36>>2];break e}if(k=h+_|0,f=m+B|0,k=f>>>0<m>>>0?k+1|0:k,n=(_|0)==(k|0)&f>>>0<B>>>0|k>>>0<_>>>0,h=r+I|0,e=e+Q|0,h=e>>>0<Q>>>0?h+1|0:h,l=e+n|0,s=l>>>0<e>>>0?h+1|0:h,!(s&1048576))break e;f=B&1|((k&1)<<31|f>>>1),k=l<<31|k>>>1,G=G+1|0,l=(s&1)<<31|l>>>1,s=s>>>1|0}if(n=0,e=Y&-2147483648,o=e,(G|0)>=32767){l=n,s=e|2147418112,o=0;break i}_=0;e:{if((G|0)>0){_=G;break e}g4(w+16|0,f,k,l,s,G+127|0),I6(w,f,k,l,s,1-G|0),f=i[w>>2]|(i[w+16>>2]|i[w+24>>2]|(i[w+20>>2]|i[w+28>>2]))!=0,k=i[w+4>>2],l=i[w+8>>2],s=i[w+12>>2]}r=(k&7)<<29|f>>>3,k=l<<29|k>>>3,n=n|((s&7)<<29|l>>>3),e=o|(s>>>3&65535|_<<16);e:{r:{if(h=f&7,(h|0)!=4){l=n,f=k,n=h>>>0>4,k=n,n=r+n|0,o=k>>>0>n>>>0?f+1|0:f,r=(f|0)==(o|0)&r>>>0>n>>>0|f>>>0>o>>>0,l=r+l|0,s=r>>>0>l>>>0?e+1|0:e;break r}l=n,f=e,e=k,n=r&1,k=n,n=r+n|0,o=k>>>0>n>>>0?e+1|0:e,e=(o|0)==(e|0)&r>>>0>n>>>0|e>>>0>o>>>0,l=e+l|0,s=l>>>0<e>>>0?f+1|0:f;break e}if(!h)break i}}i[A>>2]=n,i[A+4>>2]=o,i[A+8>>2]=l,i[A+12>>2]=s,v=w+112|0}function Z(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;i:{if(!A)break i;f=A-8|0,e=i[A-4>>2],A=e&-8,n=f+A|0;e:{if(e&1)break e;if(!(e&2)||(e=i[f>>2],f=f-e|0,f>>>0<o0[33454]))break i;A=A+e|0;r:{f:{A:{if(i[33455]!=(f|0)){if(r=i[f+12>>2],e>>>0<=255){if(k=i[f+8>>2],(k|0)!=(r|0))break A;h=133800,w=i[33450]&t2(-2,e>>>3|0),i[h>>2]=w;break e}if(l=i[f+24>>2],(r|0)!=(f|0)){e=i[f+8>>2],i[e+12>>2]=r,i[r+8>>2]=e;break r}if(k=i[f+20>>2],k)e=f+20|0;else{if(k=i[f+16>>2],!k)break f;e=f+16|0}for(;o=e,r=k,e=r+20|0,k=i[r+20>>2],!(!k&&(e=r+16|0,k=i[r+16>>2],!k)););i[o>>2]=0;break r}if(e=i[n+4>>2],(e&3)!=3)break e;i[33452]=A,i[n+4>>2]=e&-2,i[f+4>>2]=A|1,i[n>>2]=A;return}i[k+12>>2]=r,i[r+8>>2]=k;break e}r=0}if(!l)break e;e=i[f+28>>2],k=(e<<2)+134104|0;r:{if(i[k>>2]==(f|0)){if(i[k>>2]=r,r)break r;h=133804,w=i[33451]&t2(-2,e),i[h>>2]=w;break e}f:{if(i[l+16>>2]==(f|0)){i[l+16>>2]=r;break f}i[l+20>>2]=r}if(!r)break e}if(i[r+24>>2]=l,e=i[f+16>>2],e&&(i[r+16>>2]=e,i[e+24>>2]=r),e=i[f+20>>2],!e)break e;i[r+20>>2]=e,i[e+24>>2]=r}if(f>>>0>=n>>>0||(e=i[n+4>>2],!(e&1)))break i;e:{r:{f:{A:{if(!(e&2)){if(i[33456]==(n|0)){if(i[33456]=f,A=i[33453]+A|0,i[33453]=A,i[f+4>>2]=A|1,i[33455]!=(f|0))break i;i[33452]=0,i[33455]=0;return}if(s=i[33455],(s|0)==(n|0)){i[33455]=f,A=i[33452]+A|0,i[33452]=A,i[f+4>>2]=A|1,i[A+f>>2]=A;return}if(A=(e&-8)+A|0,r=i[n+12>>2],e>>>0<=255){if(k=i[n+8>>2],(k|0)==(r|0)){h=133800,w=i[33450]&t2(-2,e>>>3|0),i[h>>2]=w;break r}i[k+12>>2]=r,i[r+8>>2]=k;break r}if(l=i[n+24>>2],(r|0)!=(n|0)){e=i[n+8>>2],i[e+12>>2]=r,i[r+8>>2]=e;break f}if(k=i[n+20>>2],k)e=n+20|0;else{if(k=i[n+16>>2],!k)break A;e=n+16|0}for(;o=e,r=k,e=r+20|0,k=i[r+20>>2],!(!k&&(e=r+16|0,k=i[r+16>>2],!k)););i[o>>2]=0;break f}i[n+4>>2]=e&-2,i[f+4>>2]=A|1,i[A+f>>2]=A;break e}r=0}if(!l)break r;e=i[n+28>>2],k=(e<<2)+134104|0;f:{if(i[k>>2]==(n|0)){if(i[k>>2]=r,r)break f;h=133804,w=i[33451]&t2(-2,e),i[h>>2]=w;break r}A:{if(i[l+16>>2]==(n|0)){i[l+16>>2]=r;break A}i[l+20>>2]=r}if(!r)break r}if(i[r+24>>2]=l,e=i[n+16>>2],e&&(i[r+16>>2]=e,i[e+24>>2]=r),e=i[n+20>>2],!e)break r;i[r+20>>2]=e,i[e+24>>2]=r}if(i[f+4>>2]=A|1,i[A+f>>2]=A,(f|0)!=(s|0))break e;i[33452]=A;return}if(A>>>0<=255){e=(A&-8)+133840|0,k=i[33450],A=1<<(A>>>3);e:{if(!(k&A)){i[33450]=A|k,A=e;break e}A=i[e+8>>2]}i[e+8>>2]=f,i[A+12>>2]=f,i[f+12>>2]=e,i[f+8>>2]=A;return}r=31,A>>>0<=16777215&&(e=_1(A>>>8|0),r=((A>>>38-e&1)-(e<<1)|0)+62|0),i[f+28>>2]=r,i[f+16>>2]=0,i[f+20>>2]=0,e=(r<<2)+134104|0;e:{r:{k=i[33451],o=1<<r;f:{if(!(k&o)){i[33451]=k|o,i[e>>2]=f,r=24;break f}for(r=A<<((r|0)!=31?25-(r>>>1|0)|0:0),e=i[e>>2];;){if(k=e,(i[e+4>>2]&-8)==(A|0))break r;if(e=r>>>29|0,r=r<<1,o=(e&4)+k|0,e=i[o+16>>2],!e)break}i[o+16>>2]=f,e=k,r=24}k=f,o=f,A=8;break e}e=i[k+8>>2],i[e+12>>2]=f,i[k+8>>2]=f,r=8,o=0,A=24}i[r+f>>2]=e,i[f+12>>2]=k,i[A+f>>2]=o,A=i[33458]-1|0,i[33458]=A||-1}}function In(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;n=v-128|0,v=n;i:{if(!k||!e|!f){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if((r|0)<=0){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=13020;break i}s=C(72),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=101400,o=be(s+16|0,e,r,0),i[n+100>>2]=s,i[n+96>>2]=o,i[s+4>>2]=i[s+4>>2]+1,o=i[n+100>>2],i[n+8>>2]=i[n+96>>2],i[n+12>>2]=o,l=$i(n+104|0,n+8|0,r,0),o=n+56|0,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=92500,Wi(n+36|0,o,l);e:{if(h=i[n+36>>2],h){i[A>>2]=h,i[A+4>>2]=i[n+40>>2],e=7900;break e}if(i[o+16>>2]!=1718909296){i[A>>2]=2,i[A+4>>2]=0,e=24846;break e}t[n+55|0]<0&&Z(i[n+44>>2]),i[o>>2]=92500,h=i[o+20>>2],h&&(i[o+24>>2]=h,Z(h)),o=i[l+4>>2];r:{if(!o||(l=i[o+4>>2],i[o+4>>2]=l-1,l))break r;W[i[i[o>>2]+8>>2]](o),y(o)}o=i[s+4>>2],i[s+4>>2]=o-1,o||(W[i[i[s>>2]+8>>2]](s),y(s)),s=C(72),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=101400,e=be(s+16|0,e,r,0),i[n+32>>2]=s,i[n+28>>2]=e,i[s+4>>2]=i[s+4>>2]+1,e=i[n+32>>2],i[n>>2]=i[n+28>>2],i[n+4>>2]=e,h=$i(n+56|0,n,r,0),i[n+20>>2]=0,i[n+24>>2]=0,c8(n+104|0,h,n+20|0,101976),r=i[n+104>>2];r:{if(r){if(e=i[n+108>>2],i[A>>2]=r,(e|0)==100){i[A+4>>2]=100,i[A+8>>2]=20408;break r}i[A+4>>2]=e,i[A+8>>2]=2398;break r}f:{if(e=i[n+20>>2],!e||(e=Z0(e,92792,93156),!e))break f;o=i[n+24>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[n+44>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0;A:{k:{if(l=i[e+112>>2],r=i[e+108>>2],(l|0)!=(r|0)){if(e=l-r|0,(e|0)<0)break k;l=C(e),i[n+36>>2]=l,w=e+l|0,i[n+44>>2]=w,e&&z(l,r,e),i[n+40>>2]=w}break A}s0(),M()}e=i[n+40>>2],r=i[n+36>>2],w=e-r|0,l=w>>2;A:{if(l>>>0>o0[25515]){i[A>>2]=6,i[A+4>>2]=1e3,i[A+8>>2]=25704;break A}_=f,f=E2(w),i[_>>2]=f,i[k>>2]=l;k:{if((e|0)==(r|0))break k;if(_=l>>>0<=1?1:l,w=_&3,k=0,e=0,l>>>0>=4)for(m=_&-4,_=0;l=e<<2,i[l+f>>2]=i[r+l>>2],B=l|4,i[B+f>>2]=i[r+B>>2],B=l|8,i[B+f>>2]=i[r+B>>2],l=l|12,i[l+f>>2]=i[r+l>>2],e=e+4|0,_=_+4|0,(m|0)!=(_|0););if(!w)break k;for(;l=e<<2,i[l+f>>2]=i[r+l>>2],e=e+1|0,k=k+1|0,(w|0)!=(k|0););}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}if(r&&(i[n+40>>2]=r,Z(r)),!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break r;W[i[i[o>>2]+8>>2]](o),y(o);break r}i[A>>2]=2,i[A+4>>2]=102,i[A+8>>2]=2421}t[n+123|0]<0&&Z(i[n+112>>2]),A=i[n+24>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[h+4>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;W[i[i[s>>2]+8>>2]](s),y(s);break i}i[A+8>>2]=e,t[n+55|0]<0&&Z(i[n+44>>2]),i[o>>2]=92500,A=i[o+20>>2],A&&(i[o+24>>2]=A,Z(A)),A=i[l+4>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=n+128|0}function Xi(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0;n=v-192|0,v=n,_=A+8|0,m=i[19543],Y=m-12|0,E=i[19544]-12|0,R=i[19547]-12|0,G=i[19545],N=G-12|0,U=i[19552],x=i[19551],j=n+32|0,O=n+44|0,S=i[19549],q=i[19548],d=i[19546],I=n+24|0,Q=n+20|0,c=n+76|0,A0=(f|0)==-1;i:{e:{r:{f:{A:{for(;;){k:{n:{t:{o:{l:{if(l=u[r+20|0],!(!i[r+16>>2]|l&1)){i[n+184>>2]=0,i[n+188>>2]=0,c8(n+160|0,r,n+184|0,k);u:{if(i[n+160>>2]==i[28728]||(l=i[n+184>>2],l&&W[i[i[l>>2]+36>>2]](l)|0))break u;l=i[n+164>>2],i[A>>2]=i[n+160>>2],i[A+4>>2]=l,i[_+8>>2]=i[n+176>>2],l=i[n+172>>2],i[_>>2]=i[n+168>>2],i[_+4>>2]=l,i[n+168>>2]=0,i[n+172>>2]=0,i[n+176>>2]=0,l=1;break k}if(!A0){o=i[e+40>>2];break n}if(l=i[(i[e+16>>2]==1768517222?28:60)+k>>2],o=i[e+40>>2],!l|l>>>0>=o-i[e+36>>2]>>3>>>0)break n;i[n+104>>2]=0,i[n+12>>2]=G,i[n+76>>2]=78164,i[n+20>>2]=78144,o=n+12|0,i[o+i[N>>2]>>2]=d,i[n+16>>2]=0,s=o+i[i[n+12>>2]-12>>2]|0,J0(s,I),t[s+80|0]=0,i[s+72>>2]=0,i[i[R>>2]+Q>>2]=q,i[o+i[E>>2]>>2]=S,i[n+76>>2]=78164,i[n+12>>2]=78124,i[n+20>>2]=78144,h=R0(I),i[h>>2]=77200,i[n+64>>2]=0,i[n+68>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,l=F(B0(F(Q,30386,31),l),30737,6),Ce(n,e),s=l,l=t[n+11|0],o=(l|0)<0,F(F(s,o?i[n>>2]:n,o?i[n+4>>2]:l),28870,15),t[n+11|0]<0&&Z(i[n>>2]),l=i[n+72>>2];u:{if(l&16){if(o=O,l=i[n+68>>2],s=i[n+48>>2],l>>>0>=s>>>0)break u;i[n+68>>2]=s,l=s;break u}if(!(l&8)){o=0,t[n+11|0]=0,l=n;break t}l=i[n+40>>2],o=j}if(s=i[o>>2],o=l-s|0,o>>>0>=2147483640)break l;if(o>>>0>=11){w=o|7,l=C(w+1|0),i[n+8>>2]=w-2147483647,i[n>>2]=l,i[n+4>>2]=o;break o}if(t[n+11|0]=o,l=n,o)break o;o=0;break t}if(l&1)break A;break f}I0(),M()}if(!o)break t;z(l,s,o)}t[o+l|0]=0,a(A,6,1e3,n),t[n+11|0]<0&&Z(i[n>>2]),i[n+12>>2]=m,i[i[Y>>2]+(n+12|0)>>2]=x,i[n+20>>2]=U,i[h>>2]=77200,t[n+67|0]<0&&Z(i[n+56>>2]),y0(h),Y0(c),l=1;break k}h=i[e+44>>2];n:{if(h>>>0>o>>>0){i[o>>2]=i[n+184>>2],i[o+4>>2]=i[n+188>>2],i[n+184>>2]=0,i[n+188>>2]=0,o=o+8|0;break n}if(s=i[e+36>>2],l=o-s|0,B=l>>3,o=B+1|0,o>>>0>=536870912)break e;if(h=h-s|0,w=h>>2,h=h>>>0>=2147483640?536870911:o>>>0<w>>>0?w:o,h){if(h>>>0>=536870912)break i;o=C(h<<3)}else o=0;if(w=o+l|0,i[w>>2]=i[n+184>>2],i[w+4>>2]=i[n+188>>2],i[n+184>>2]=0,i[n+188>>2]=0,B=w-(B<<3)|0,l&&z(B,s,l),i[e+44>>2]=o+(h<<3),o=w+8|0,i[e+40>>2]=o,i[e+36>>2]=B,!s)break n;Z(s)}i[e+40>>2]=o,V=V+1|0,l=(f|0)!=-1&&(V|0)==(f|0)?3:0}t[n+179|0]<0&&Z(i[n+168>>2]),o=i[n+188>>2];k:{if(!o||(s=i[o+4>>2],i[o+4>>2]=s-1,s))break k;W[i[i[o>>2]+8>>2]](o),y(o)}if(l)break}if((l|0)!=3)break r;if(!(t[r+20|0]&1))break f}if(t[n+12|0]=0,t[n+23|0]=0,a(A,2,100,n+12|0),t[n+23|0]>=0)break r;Z(i[n+12>>2]);break r}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,t[114931]>=0){A=i[28731],i[_>>2]=i[28730],i[_+4>>2]=A,i[_+8>>2]=i[28732];break r}T(_,i[28730],i[28731])}v=n+192|0;return}s0(),M()}x0(),M()}function AZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,3127);break i}i[e+120>>2]=0,i[e+124>>2]=0,X[e+116>>1]=1,i[e+112>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+144>>2]=0,i[e+148>>2]=1072693248,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+172>>2]=0,i[e+176>>2]=0,k=i[e+100>>2],k&1&&(t[e+184|0]=1,_=e,B=F0(r),i[_+104>>2]=B,k=i[e+100>>2]),k&2&&(t[e+185|0]=1,_=e,B=F0(r),i[_+108>>2]=B,k=i[e+100>>2]),k&4&&(t[e+186|0]=1,_=e,B=F0(r),i[_+112>>2]=B,k=i[e+100>>2]);e:{if(!(k&8))break e;t[e+187|0]=1;r:{f:switch(u[e+97|0]){case 0:s=k&16;A:{if(s){k=F0(r),h=F0(r),w=F0(r);break A}k=Hi(r),h=Hi(r),w=Hi(r)}if(t[e+116|0]=1,n=+(16384<<s>>>0),o=+(w|0)/n,u0[e+136>>3]=o,l=+(h|0)/n,u0[e+128>>3]=l,n=+(k|0)/n,u0[e+120>>3]=n,n=o*o+(n*n+l*l),!(n>1))break r;if(e=C(48),i[f+20>>2]=e,i[f+24>>2]=47,i[f+28>>2]=-2147483600,r=u[3030]|u[3031]<<8|(u[3032]<<16|u[3033]<<24),k=u[3026]|u[3027]<<8|(u[3028]<<16|u[3029]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+47|0]=0,r=u[3069]|u[3070]<<8|(u[3071]<<16|u[3072]<<24),k=u[3065]|u[3066]<<8|(u[3067]<<16|u[3068]<<24),t[e+39|0]=k,t[e+40|0]=k>>>8,t[e+41|0]=k>>>16,t[e+42|0]=k>>>24,t[e+43|0]=r,t[e+44|0]=r>>>8,t[e+45|0]=r>>>16,t[e+46|0]=r>>>24,r=u[3062]|u[3063]<<8|(u[3064]<<16|u[3065]<<24),k=u[3058]|u[3059]<<8|(u[3060]<<16|u[3061]<<24),t[e+32|0]=k,t[e+33|0]=k>>>8,t[e+34|0]=k>>>16,t[e+35|0]=k>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[3054]|u[3055]<<8|(u[3056]<<16|u[3057]<<24),k=u[3050]|u[3051]<<8|(u[3052]<<16|u[3053]<<24),t[e+24|0]=k,t[e+25|0]=k>>>8,t[e+26|0]=k>>>16,t[e+27|0]=k>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[3046]|u[3047]<<8|(u[3048]<<16|u[3049]<<24),k=u[3042]|u[3043]<<8|(u[3044]<<16|u[3045]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[3038]|u[3039]<<8|(u[3040]<<16|u[3041]<<24),k=u[3034]|u[3035]<<8|(u[3036]<<16|u[3037]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i;case 1:break f;default:break e}_=e,m=+(F0(r)|0)*152587890625e-16,u0[_+152>>3]=m,_=e,m=+(F0(r)|0)*152587890625e-16,u0[_+160>>3]=m,_=e,m=+(F0(r)|0)*152587890625e-16,u0[_+168>>3]=m;break e}u0[e+144>>3]=zB(1-n)}if(u[e+100|0]&32&&(t[e+188|0]=1,_=e,B=F0(r),i[_+176>>2]=B),u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Qn(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;l=v-48|0,v=l,f=K6(l+16|0,e,r),e=i[f+12>>2],r=e>>31<<3|e>>>29,k=i[f+24>>2],e=k+(e<<3)|0,n=(k>>31)+r|0,n=e>>>0<k>>>0?n+1|0:n;i:{if(!e&(n|0)<=0|(n|0)<0)break i;e:{for(;;){if(m2(f,1),o=T0(f,4),e=T0(f,1),r=T0(f,1),m2(f,1),e&&m2(f,8),r){e=T0(f,8),r=e&127,k=0;r:{if(!(e&128)||(e=T0(f,8),r=r|e<<7&16256,!(e&128))||(e=T0(f,8),r=r|e<<14&2080768,!(e&128))||(e=T0(f,8),r=r|e<<21&266338304,!(e&128))||(e=T0(f,8),n=e>>>4|0,r=r|e<<28&-268435456,k=k|n&7,!(e&128))||(e=T0(f,8),k=k|e<<3&1016,!(e&128))||(e=T0(f,8),k=k|e<<10&130048,!(e&128)))break r;k=k|T0(f,8)<<17&16646144}if((o|0)==1)break e;if(!k&r>>>0>2147483647|k)break i;if(c6(f,r),e=i[f+24>>2],r=e,k=e>>31,e=i[f+12>>2],n=e>>31<<3|e>>>29,o=e<<3,r=o+r|0,e=k+n|0,e=r>>>0<o>>>0?e+1|0:e,!!r&(e|0)>=0|(e|0)>0)continue;break i}break}if((o|0)!=1)break i}h=A,w=T0(f,3),t[h+1|0]=w,n=1,T0(f,1),s=T0(f,1);e:{if(s){e=T0(f,5),t[A+3|0]=0,t[A+2|0]=e;break e}e=0;r:{if(!T0(f,1)||(c6(f,8),T0(f,1)&&A1(f,l+12|0),e=0,!T0(f,1)))break r;e=T0(f,5),m2(f,32),m2(f,10),n=e+1|0,e=1}if(k=T0(f,1),o=T0(f,5),(o|0)<0)break e;if(m2(f,12),r=T0(f,5),t[A+2|0]=r,r=r&248,!k){r&&(h=A,w=T0(f,1),t[h+3|0]=w);r:{if(!e||!T0(f,1))break r;m2(f,n),m2(f,n),m2(f,1)}if(!o)break e;for(r=1;;){m2(f,12),T0(f,5)&248&&T0(f,1),k=r;r:{if(!e||!T0(f,1))break r;m2(f,n),m2(f,n),m2(f,1)}if(r=k+1|0,(k|0)==(o|0))break}break e}if(!e){if(r&&(h=A,w=T0(f,1),t[h+3|0]=w),r=1,e=T0(f,1),t[A+10|0]=(e|0)!=0,e&&(h=A,w=T0(f,4),t[h+11|0]=w),!o)break e;for(;m2(f,12),T0(f,5)&248&&T0(f,1),T0(f,1)&&T0(f,4),e=(r|0)!=(o|0),r=r+1|0,!!e;);break e}if(r&&(h=A,w=T0(f,1),t[h+3|0]=w),T0(f,1)&&(m2(f,n),m2(f,n),m2(f,1)),e=T0(f,1),t[A+10|0]=(e|0)!=0,e&&(h=A,w=T0(f,4),t[h+11|0]=w),!o)break e;for(r=1;m2(f,12),T0(f,5)&248&&T0(f,1),T0(f,1)&&(m2(f,n),m2(f,n),m2(f,1)),T0(f,1)&&T0(f,4),e=(r|0)==(o|0),r=r+1|0,!e;);}e=T0(f,4),r=T0(f,4),T0(f,e+1|0),T0(f,r+1|0);e:{if(!s){T0(f,1)&&m2(f,7),m2(f,3),m2(f,4),e=T0(f,1),e&&m2(f,2);r:{if(!T0(f,1)&&(T0(f,1)|0)<=0||T0(f,1))break r;m2(f,1)}if(!e)break e}m2(f,3)}m2(f,3),k=T0(f,1),t[A+4|0]=k,e=u[A+1|0],r=0;e:{if(!(k&255)){n=0;break e}if(n=0,(e&255)!=2)break e;n=T0(f,1),e=u[A+1|0]}t[A+5|0]=n,(e&255)!=1?e=T0(f,1):e=0,t[A+6|0]=e;e:{if(!T0(f,1)){e=0,k=0;break e}e=(T0(f,8)|0)==1,r=(T0(f,8)|0)==13,k=!T0(f,8)}e:{r:{if(u[A+6|0]){m2(f,1),t[A+7|0]=1,t[A+8|0]=1,r=9,e=0;break r}f:{if((k&(e&r))==1)break f;m2(f,1);A:{k:{n:{t:switch(u[A+1|0]){default:if(u[A+5|0]){if(e=T0(f,1),t[A+7|0]=e,e&255)break n;break A}t[A+7|0]=1;break A;case 1:break f;case 0:break t}t[A+7|0]=1,t[A+8|0]=1;break k}if(e=T0(f,1),t[A+8|0]=e,!u[A+7|0]|!(e&255))break e}r=9,e=T0(f,2);break r}r=8,e=0;break r}t[A+7|0]=0,r=8,e=0}t[A+r|0]=e}m2(f,1)}v=l+48|0}function kZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;w=v-32|0,v=w;i:{e:{if(n=i[e>>2],!n||(l=Z0(n,113600,113832),!l))break e;s=i[e+4>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=w+12|0,f=v-80|0,v=f;r:{if(i[l+104>>2]!=i[l+108>>2])break r;n=C(120),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=100308,G=n+16|0,k=G,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=92500,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,t[n+112|0]=0,i[k>>2]=112616,i[n+32>>2]=1970432365,k=C(136),i[k>>2]=100348,i[k+4>>2]=0,i[k+8>>2]=0,h=k+16|0,o=h,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[o>>2]=112696,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1970432288,B=k+120|0;f:{A:{k:{n:{if(t[l+303|0]>=0){if(i[f+72>>2]=i[l+300>>2],o=i[l+296>>2],i[f+64>>2]=i[l+292>>2],i[f+68>>2]=o,t[f+75|0]>=0)break n;break A}if(T(f- -64|0,i[l+292>>2],i[l+296>>2]),m=t[f+75|0],t[k+131|0]<0)break k;if((m|0)<0)break A}o=i[f+68>>2],i[B>>2]=i[f+64>>2],i[B+4>>2]=o,i[B+8>>2]=i[f+72>>2];break f}o=(m|0)<0,R1(B,o?i[f+64>>2]:f- -64|0,o?i[f+68>>2]:m);break f}m1(B,i[f+64>>2],i[f+68>>2])}t[f+75|0]<0&&Z(i[f+64>>2]),i[f+36>>2]=k,i[f+32>>2]=h,i[k+4>>2]=i[k+4>>2]+1,P0(n+52|0,f+32|0),h=i[f+36>>2];f:{if(!h||(o=i[h+4>>2],i[h+4>>2]=o-1,o))break f;W[i[i[h>>2]+8>>2]](h),y(h)}if(gn(l,0),i[f+60>>2]=n,i[f+56>>2]=G,i[n+4>>2]=i[n+4>>2]+1,o=i[f+60>>2],i[f+8>>2]=i[f+56>>2],i[f+12>>2]=o,Qt(l,f+8|0),o=i[k+4>>2],i[k+4>>2]=o-1,o||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[n+4>>2],i[n+4>>2]=k-1,k)break r;W[i[i[n>>2]+8>>2]](n),y(n)}o=i[r+16>>2],k=i[r+12>>2];r:{if(t[r+31|0]>=0){i[f+24>>2]=i[r+28>>2],n=i[r+24>>2],i[f+16>>2]=i[r+20>>2],i[f+20>>2]=n;break r}T(f+16|0,i[r+20>>2],i[r+24>>2])}t[f+28|0]=1,a9(f+32|0,l,r,k,0,1,o,f+16|0),u[f+28|0]!=1|t[f+27|0]>=0||Z(i[f+16>>2]),n=_+8|0;r:{if(i[f+32>>2]){r=i[f+36>>2],i[_>>2]=i[f+32>>2],i[_+4>>2]=r,i[n+8>>2]=i[f+48>>2],r=i[f+44>>2],i[n>>2]=i[f+40>>2],i[n+4>>2]=r,i[f+48>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0;break r}if(r=i[28729],i[_>>2]=i[28728],i[_+4>>2]=r,t[114931]>=0){r=i[28731],i[n>>2]=i[28730],i[n+4>>2]=r,i[n+8>>2]=i[28732];break r}T(n,i[28730],i[28731])}t[f+51|0]<0&&Z(i[f+40>>2]),v=f+80|0;r:{if(i[w+12>>2]){c0(A,_,i[e+8>>2]);break r}e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}if(t[w+31|0]<0&&Z(i[w+20>>2]),!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s);break i}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27291}v=w+32|0}function nZ(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;s=v-48|0,v=s,l=i[e>>2],I=i[l+48>>2],_=i[l+52>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);i:{e:{r:{if(h=l2(f),h>>>0<2147483640){f:{A:{if(h>>>0>=11){B=h|7,l=C(B+1|0),i[s+8>>2]=B-2147483647,i[s>>2]=l,i[s+4>>2]=h;break A}if(t[s+11|0]=h,l=s,!h)break f}if(!h)break f;z(l,f,h)}t[l+h|0]=0,B=s+12|0,f=v-80|0,v=f,yA(f+56|0,I,1835625829);f:{A:{k:{n:switch(u[f+76|0]){default:e2(),M();case 1:r=i[f+60>>2],i[B>>2]=i[f+56>>2],i[B+4>>2]=r,r=B+8|0;t:{if(t[f+75|0]>=0){k=f- -64|0,n=i[k+4>>2],i[r>>2]=i[k>>2],i[r+4>>2]=n,i[r+8>>2]=i[k+8>>2];break t}T(r,i[f+64>>2],i[f+68>>2])}t[B+20|0]=1;break k;case 0:break n}if(w=i[f+56>>2],i[f+48>>2]=w,h=i[f+60>>2],i[f+52>>2]=h,h&&(i[h+4>>2]=i[h+4>>2]+1),t[w+164|0]=1,i[w+100>>2]=i[w+100>>2]&-2|1,l=l2(r),l>>>0>=2147483640)break A;n:{t:{if(l>>>0>=11){m=l|7,G=C(m+1|0),i[f+40>>2]=m-2147483647,i[f+32>>2]=G,i[f+36>>2]=l;break t}if(t[f+43|0]=l,G=f+32|0,!l)break n}if(!l)break n;z(G,r,l)}t[l+G|0]=0,r=w+128|0;n:{if((r|0)==(f+32|0))break n;if(l=t[f+43|0],t[w+139|0]>=0){if((l|0)>=0){l=i[f+36>>2],i[r>>2]=i[f+32>>2],i[r+4>>2]=l,i[r+8>>2]=i[f+40>>2];break n}m1(r,i[f+32>>2],i[f+36>>2]);break n}m=r,r=(l|0)<0,R1(m,r?i[f+32>>2]:f+32|0,r?i[f+36>>2]:l)}t[f+43|0]<0&&Z(i[f+32>>2]),G=i[w+104>>2],i[f+8>>2]=i[s+8>>2],r=i[s+4>>2],i[f>>2]=i[s>>2],i[f+4>>2]=r,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,r=f+12|0,w=0,l=v-32|0,v=l,i[l+8>>2]=0,i[l>>2]=0,i[l+4>>2]=0;n:{t:{if(n){if((n|0)<0)break t;w=C(n),n&&l0(w,0,n),m=n+w|0,i[l+8>>2]=m,i[l+4>>2]=m,i[l>>2]=w}n&&z(w,k,n),w=i[f+48>>2],k=w+140|0;o:{if((k|0)==(f|0))break o;if(n=t[f+11|0],t[w+151|0]>=0){if((n|0)>=0){n=i[f+4>>2],i[k>>2]=i[f>>2],i[k+4>>2]=n,i[k+8>>2]=i[f+8>>2];break o}m1(k,i[f>>2],i[f+4>>2]);break o}m=k,k=(n|0)<0,R1(m,k?i[f>>2]:f,k?i[f+4>>2]:n)}jr(l+12|0,i[I+64>>2],i[i[f+48>>2]+104>>2],l,0),t[l+31|0]<0&&Z(i[l+20>>2]),k=i[28729],i[r>>2]=i[28728],i[r+4>>2]=k,r=r+8|0;o:{if(t[114931]>=0){k=i[28731],i[r>>2]=i[28730],i[r+4>>2]=k,i[r+8>>2]=i[28732];break o}T(r,i[28730],i[28731])}r=i[l>>2],r&&(i[l+4>>2]=r,Z(r)),v=l+32|0;break n}s0(),M()}if(t[f+31|0]<0&&Z(i[f+20>>2]),t[f+11|0]<0&&Z(i[f>>2]),t[B+20|0]=0,i[B>>2]=G,!h||(r=i[h+4>>2],i[h+4>>2]=r-1,r))break k;W[i[i[h>>2]+8>>2]](h),y(h)}r=u[f+76|0],(r|0)!=255&&(k=i[25325],i[f+32>>2]=i[25324],i[f+36>>2]=k,W[i[(f+32|0)+(r<<2)>>2]](f+48|0,f+56|0)),v=f+80|0;break f}I0(),M()}t[s+11|0]<0&&Z(i[s>>2]);f:{if(!_||(r=i[_+4>>2],i[_+4>>2]=r-1,r))break f;W[i[i[_>>2]+8>>2]](_),y(_)}if(r=u[s+32|0],!(r|!o)){i[o>>2]=1;break r}f:switch(r|0){default:e2(),M();case 0:break r;case 1:break f}if(c0(A,s+12|0,i[e>>2]),A=u[s+32|0],(A|0)==255)break i;break e}I0(),M()}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=0}e=i[25811],i[s+40>>2]=i[25810],i[s+44>>2]=e,W[i[(s+40|0)+(A<<2)>>2]](s+39|0,s+12|0)}v=s+48|0}function tZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;n=v-160|0,v=n,i[n+104>>2]=0,i[n+76>>2]=78468,l=i[19620],i[n+20>>2]=l,k=i[l-12>>2],l=n+20|0,i[k+l>>2]=i[19621],k=l+i[i[n+20>>2]-12>>2]|0,f=n+24|0,J0(k,f),t[k+80|0]=0,i[k+72>>2]=0,i[n+76>>2]=78468,i[n+20>>2]=78448,w=R0(f),i[w>>2]=77200,k=n- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=16,k=n+8|0,J2(k,e,r),s=l,o=k,l=t[n+19|0],k=(l|0)<0,F(s,k?i[n+8>>2]:o,k?i[n+12>>2]:l),t[n+19|0]<0&&Z(i[n+8>>2]),B=n+8|0,l=B,f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[19621],h=k+i[i[f+8>>2]-12>>2]|0,o=f+12|0,J0(h,o),t[h+80|0]=0,i[h+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,h=R0(o),i[h>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,o=f+148|0,k0(o,r),_=k,s=o,k=t[f+159|0],o=(k|0)<0,F(_,o?i[f+148>>2]:s,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),o=f+8|0,F(o,32827,18),k=i[e+112>>2],s=i[e+116>>2];i:{if((k&s)==-1){F(o,38283,8);break i}F(M2(f+8|0,k,s),47878,1)}k=f+148|0,k0(k,r),s=k,k=t[f+159|0],o=(k|0)<0,F(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,34367,18),i[e+120>>2]),47878,1),o=f+148|0,k0(o,r),_=k,s=o,k=t[f+159|0],o=(k|0)<0,F(_,o?i[f+148>>2]:s,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(k,36214,18),o=i[e+124>>2];i:{if((o|0)==2147483647){F(k,38548,10);break i}F(D0(f+8|0,o),47878,1)}k=f+148|0,k0(k,r),o=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(f+8|0,36484,12),u[e+128|0]),37886,1);i:{e:switch(u[e+128|0]){case 0:F(f+8|0,47621,10);break i;case 2:F(f+8|0,47713,32);break i;case 1:F(f+8|0,47746,36);break i;default:break e}F(f+8|0,47682,16)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[l+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){o=e|7,r=C(o+1|0),i[l+8>>2]=o-2147483647,i[l>>2]=r,i[l+4>>2]=e,l=r;break e}if(t[l+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(l,k,e)}t[e+l|0]=0,e=i[19619],i[f+8>>2]=e,i[i[e-12>>2]+(f+8|0)>>2]=i[19622],i[h>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(h),Y0(f- -64|0),v=f+160|0,e=t[n+19|0],r=(e|0)<0,F(n+20|0,r?i[n+8>>2]:B,r?i[n+12>>2]:e),t[n+19|0]<0&&Z(i[n+8>>2]),e=i[n+72>>2];i:{e:{if(e&16){r=i[n+68>>2],e=i[n+48>>2],r>>>0<e>>>0&&(i[n+68>>2]=e,r=e),e=n+44|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[n+40>>2],e=n+32|0}e:{if(l=i[e>>2],r=r-l|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,l,r)}t[A+r|0]=0,A=i[19619],i[n+20>>2]=A,i[i[A-12>>2]+(n+20|0)>>2]=i[19622],i[w>>2]=77200,t[n+67|0]<0&&Z(i[n+56>>2]),y0(w),Y0(n+76|0),v=n+160|0}function oZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;k=v-192|0,v=k,S2(k+172|0,e,r),t[k+191|0]<0&&Z(i[k+180>>2]);i:{if(u[e+97|0]>=2){B1(A,e,20632);break i}if(_=F0(r),n=i[f+28>>2],!(n>>>0<_>>>0&&n)){e:{f=u[r+20|0];r:{if(!(!i[r+16>>2]|(!_|f&1))){Q=e+104|0;f:{for(;;){i[k+36>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0;A:{if(!u[e+97|0]){f=w2(r);break A}f=F0(r)}i[k+24>>2]=f,B=0;A:{if(m=Q2(r),!m)break A;k:{for(;;){n:{if(t[e+100|0]&1){n=w2(r),f=n&32767,o=n>>>15|0;break n}n=Q2(r),f=n&127,o=n>>>7|0}n:{n=i[k+32>>2],s=i[k+36>>2];t:{if(n>>>0<s>>>0){f=o|f<<16,X[n>>1]=f,X[n+2>>1]=f>>>16,f=n+4|0;break t}if(h=i[k+28>>2],n=n-h|0,G=n>>2,l=G+1|0,l>>>0>=1073741824)break n;if(s=s-h|0,w=s>>1,s=s>>>0>=2147483644?1073741823:l>>>0<w>>>0?w:l,s){if(s>>>0>=1073741824)break k;l=C(s<<2)}else l=0;if(w=l+n|0,f=o|f<<16,X[w>>1]=f,X[w+2>>1]=f>>>16,o=w-(G<<2)|0,n&&z(o,h,n),i[k+36>>2]=l+(s<<2),f=w+4|0,i[k+32>>2]=f,i[k+28>>2]=o,!h)break t;Z(h)}if(i[k+32>>2]=f,B=B+1|0,(m|0)==(B|0))break A;continue}break}s0(),M()}x0(),M()}f=i[e+108>>2];A:{if(f>>>0<o0[e+112>>2]){if(n=i[k+24>>2],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=n,n=i[k+32>>2],l=i[k+28>>2],(n|0)!=(l|0)){if(n=n-l|0,(n|0)<0)break f;o=C(n),i[f+8>>2]=o,i[f+4>>2]=o,h=n+o|0,i[f+12>>2]=h,n&&z(o,l,n),i[f+8>>2]=h}f=f+16|0;break A}f=B3(Q,k+24|0)}if(i[e+108>>2]=f,f=i[k+28>>2],f&&(i[k+32>>2]=f,Z(f)),f=u[r+20|0],I=I+1|0,!!(!i[r+16>>2]||f&1|_>>>0<=I>>>0))break}if(f&1)break r;break e}s0(),M()}if(!(f&1))break e}if(t[k+24|0]=0,t[k+35|0]=0,a(A,2,100,k+24|0),t[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}i[k+116>>2]=0,i[k+88>>2]=78164,i[k+32>>2]=78144,e=i[19545],i[k+24>>2]=e,r=i[e-12>>2],e=k+24|0,i[r+e>>2]=i[19546],i[k+28>>2]=0,r=e+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(r,n),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[k+32>>2]=r,o=k+32|0,i[o+i[r-12>>2]>>2]=i[19548],r=i[19544],i[k+24>>2]=r,i[e+i[r-12>>2]>>2]=i[19549],i[k+88>>2]=78164,i[k+24>>2]=78124,i[k+32>>2]=78144,r=R0(n),i[r>>2]=77200,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,F(B0(F(B0(F(o,31214,40),_),31362,47),i[f+28>>2]),5596,6),e=i[k+84>>2];e:{r:{if(e&16){f=i[k+80>>2],e=i[k+60>>2],f>>>0<e>>>0&&(i[k+80>>2]=e,f=e),e=k+56|0;break r}if(!(e&8)){f=0,t[k+23|0]=0,e=k+12|0;break e}f=i[k+52>>2],e=k+44|0}r:{if(n=i[e>>2],f=f-n|0,f>>>0<2147483640){if(f>>>0>=11){o=f|7,e=C(o+1|0),i[k+20>>2]=o-2147483647,i[k+12>>2]=e,i[k+16>>2]=f;break r}if(t[k+23|0]=f,e=k+12|0,f)break r;f=0;break e}I0(),M()}if(!f)break e;z(e,n,f)}t[e+f|0]=0,a(A,2,1e3,k+12|0),t[k+23|0]<0&&Z(i[k+12>>2]),A=i[19543],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[19551],i[k+32>>2]=i[19552],i[r>>2]=77200,t[k+79|0]<0&&Z(i[k+68>>2]),y0(r),Y0(k+88|0)}v=k+192|0}function lZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;n=v-48|0,v=n,B=n+24|0,h=v-16|0,v=h,k=i[r+16>>2],l=k>>>0>=6?6:k,k=i[r+8>>2],k&&l4(k,l),o=i[r>>2],k=W[i[i[o>>2]+8>>2]](o)|0,w=h0,k=k+l|0,w=k>>>0<l>>>0?w+1|0:w,W[i[i[o>>2]+20>>2]](o,k,w)|0,i[r+16>>2]=i[r+16>>2]-l,m=e,G=w2(r),X[m+100>>1]=G,m=e,G=w2(r),X[m+102>>1]=G,k=i[r+16>>2],w=k>>>0>=2?2:k,k=i[r+8>>2],k&&l4(k,w),o=i[r>>2],k=W[i[i[o>>2]+8>>2]](o)|0,l=h0,k=k+w|0,l=k>>>0<w>>>0?l+1|0:l,W[i[i[o>>2]+20>>2]](o,k,l)|0,i[r+16>>2]=i[r+16>>2]-w,m=e,G=F0(r),i[m+104>>2]=G,m=e,G=F0(r),i[m+108>>2]=G,m=e,G=F0(r),i[m+112>>2]=G,m=e,G=w2(r),X[m+116>>1]=G,m=e,G=w2(r),X[m+118>>1]=G,m=e,G=F0(r),i[m+120>>2]=G,m=e,G=F0(r),i[m+124>>2]=G,k=i[r+16>>2],w=k>>>0>=4?4:k,k=i[r+8>>2],k&&l4(k,w),o=i[r>>2],k=W[i[i[o>>2]+8>>2]](o)|0,l=h0,k=k+w|0,l=k>>>0<w>>>0?l+1|0:l,W[i[i[o>>2]+20>>2]](o,k,l)|0,i[r+16>>2]=i[r+16>>2]-w,m=e,G=w2(r),X[m+128>>1]=G,s=v-32|0,v=s,i[s+24>>2]=0,i[s+16>>2]=0,i[s+20>>2]=0;i:{if(!w4(r,32)){i[h+4>>2]=0,i[h+8>>2]=0,i[h+12>>2]=0;break i}k=i[r>>2],_=i[r+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);e:{r:{f:{A:{k:{if(!(W[i[i[k>>2]+16>>2]](k,s+15|0,1)|0)||(o=u[s+15|0],o>>>0>=32))break k;if(o)break A;o=-1;break f}i[h+4>>2]=0,i[h+8>>2]=0,i[h+12>>2]=0;break e}for(l=0;;){if(!(W[i[i[k>>2]+16>>2]](k,s+14|0,1)|0))break r;if(Ai(s+16|0,t[s+14|0]),l=l+1|0,o=u[s+15|0],!(l>>>0<o>>>0))break}o=o^-1}o=o+32|0,l=(W[i[i[k>>2]+8>>2]](k)|0)+o|0,w=h0+(o>>31)|0,W[i[i[k>>2]+20>>2]](k,l,l>>>0<o>>>0?w+1|0:w)|0,i[h+12>>2]=i[s+24>>2],k=i[s+20>>2],i[h+4>>2]=i[s+16>>2],i[h+8>>2]=k,i[s+24>>2]=0,i[s+16>>2]=0,i[s+20>>2]=0;break e}h8(r),i[h+12>>2]=0,i[h+4>>2]=0,i[h+8>>2]=0}if(!_||(k=i[_+4>>2],i[_+4>>2]=k-1,k))break i;W[i[i[_>>2]+8>>2]](_),y(_)}t[s+27|0]<0&&Z(i[s+16>>2]),v=s+32|0,t[e+143|0]<0&&Z(i[e+132>>2]),k=i[h+8>>2],i[e+132>>2]=i[h+4>>2],i[e+136>>2]=k,i[e+140>>2]=i[h+12>>2],m=e,G=w2(r),X[m+144>>1]=G,m=e,G=Hi(r),X[m+146>>1]=G,k=i[28729],i[B>>2]=i[28728],i[B+4>>2]=k,B=B+8|0;i:{if(t[114931]>=0){k=i[28731],i[B>>2]=i[28730],i[B+4>>2]=k,i[B+8>>2]=i[28732];break i}T(B,i[28730],i[28731])}v=h+16|0;i:{if(i[n+24>>2]){e=i[n+28>>2],i[A>>2]=i[n+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+40>>2],e=i[n+36>>2],i[A+8>>2]=i[n+32>>2],i[A+12>>2]=e,i[n+40>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0;break i}if(Xi(n,e,r,-1,f),r=i[n+4>>2],e=i[n>>2],i[n+24>>2]=e,i[n+28>>2]=r,t[n+43|0]<0&&(Z(i[n+32>>2]),e=i[n+24>>2]),r=i[n+12>>2],i[n+32>>2]=i[n+8>>2],i[n+36>>2]=r,i[n+40>>2]=i[n+16>>2],r=A+8|0,e){e=i[n+28>>2],i[A>>2]=i[n+24>>2],i[A+4>>2]=e,i[r+8>>2]=i[n+40>>2],A=i[n+36>>2],i[r>>2]=i[n+32>>2],i[r+4>>2]=A,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0;break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,t[114931]>=0){A=i[28731],i[r>>2]=i[28730],i[r+4>>2]=A,i[r+8>>2]=i[28732];break i}T(r,i[28730],i[28731])}t[n+43|0]<0&&Z(i[n+32>>2]),v=n+48|0}function uZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0;I=e+4|0,l=r<<2,N=X[I+l>>1],s=e+2|0,w=X[s+l>>1],m=e+6|0,_=X[m+l>>1],f=r<<1,Q=X[f+I>>1],h=g(r,6),r=X[h+I>>1],B=X[e+l>>1],I=X[I>>1],l=X[h+m>>1],Y=X[f+m>>1],m=X[m>>1],k=g(l,-74)+g(Y+m|0,74)>>1,k=(k|0)>=32767?32767:k,k=(k|0)<=-32768?-32768:k,E=X[s+h>>1],R=X[f+s>>1],s=X[s>>1],n=g(E,-74)+g(R+s|0,74)>>1,n=(n|0)>=32767?32767:n,n=(n|0)<=-32768?-32768:n,h=X[e+h>>1],f=X[e+f>>1],e=X[e>>1],o=g(h,-74)+g(f+e|0,74)>>1,o=(o|0)>=32767?32767:o,o=(o|0)<=-32768?-32768:o,X[A+10>>1]=(g(k,16777142)+g(n+o|0,74)|0)+128>>>8,G=g(r,-74)+g(I+Q|0,74)>>1,G=(G|0)>=32767?32767:G,G=(G|0)<=-32768?-32768:G,V=g(G,74),X[A+14>>1]=((V+(g(n,-84)+g(o,55)|0)|0)+g(k,16777187)|0)+128>>>8,X[A+12>>1]=(((g(n,-29)+g(o,84)|0)+g(G,16777142)|0)+g(k,55)|0)+128>>>8,X[A+8>>1]=((V+(g(n,55)+g(o,29)|0)|0)+g(k,84)|0)+128>>>8,G=g(_,74),k=((G+(g(Y,-84)+g(m,55)|0)|0)+g(l,-29)|0)+1>>1,k=(k|0)>=32767?32767:k,k=(k|0)<=-32768?-32768:k,V=g(w,74),n=((V+(g(R,-84)+g(s,55)|0)|0)+g(E,-29)|0)+1>>1,n=(n|0)>=32767?32767:n,n=(n|0)<=-32768?-32768:n,U=g(B,74),o=((U+(g(f,-84)+g(e,55)|0)|0)+g(h,-29)|0)+1>>1,o=(o|0)>=32767?32767:o,o=(o|0)<=-32768?-32768:o,X[A+26>>1]=(g(k,16777142)+g(n+o|0,74)|0)+128>>>8,_=(((g(Y,-29)+g(m,84)|0)+g(_,-74)|0)+g(l,55)|0)+1>>1,_=(_|0)>=32767?32767:_,_=(_|0)<=-32768?-32768:_,w=(((g(R,-29)+g(s,84)|0)+g(w,-74)|0)+g(E,55)|0)+1>>1,w=(w|0)>=32767?32767:w,w=(w|0)<=-32768?-32768:w,B=(((g(f,-29)+g(e,84)|0)+g(B,-74)|0)+g(h,55)|0)+1>>1,B=(B|0)>=32767?32767:B,B=(B|0)<=-32768?-32768:B,X[A+18>>1]=(g(_,16777142)+g(w+B|0,74)|0)+128>>>8,l=((G+(g(Y,55)+g(m,29)|0)|0)+g(l,84)|0)+1>>1,l=(l|0)>=32767?32767:l,l=(l|0)<=-32768?-32768:l,s=((V+(g(R,55)+g(s,29)|0)|0)+g(E,84)|0)+1>>1,s=(s|0)>=32767?32767:s,s=(s|0)<=-32768?-32768:s,e=(((g(f,55)+g(e,29)|0)+U|0)+g(h,84)|0)+1>>1,e=(e|0)>=32767?32767:e,e=(e|0)<=-32768?-32768:e,X[A+2>>1]=(g(l,16777142)+g(s+e|0,74)|0)+128>>>8,m=g(N,74),f=((m+(g(Q,-84)+g(I,55)|0)|0)+g(r,-29)|0)+1>>1,f=(f|0)>=32767?32767:f,f=(f|0)<=-32768?-32768:f,h=g(f,74),X[A+30>>1]=((h+(g(n,-84)+g(o,55)|0)|0)+g(k,16777187)|0)+128>>>8,X[A+28>>1]=(((g(n,-29)+g(o,84)|0)+g(f,16777142)|0)+g(k,55)|0)+128>>>8,X[A+24>>1]=((h+(g(n,55)+g(o,29)|0)|0)+g(k,84)|0)+128>>>8,f=(((g(Q,-29)+g(I,84)|0)+g(N,-74)|0)+g(r,55)|0)+1>>1,f=(f|0)>=32767?32767:f,f=(f|0)<=-32768?-32768:f,h=g(f,74),X[A+22>>1]=((h+(g(w,-84)+g(B,55)|0)|0)+g(_,16777187)|0)+128>>>8,X[A+20>>1]=(((g(w,-29)+g(B,84)|0)+g(f,16777142)|0)+g(_,55)|0)+128>>>8,X[A+16>>1]=((h+(g(w,55)+g(B,29)|0)|0)+g(_,84)|0)+128>>>8,r=((m+(g(Q,55)+g(I,29)|0)|0)+g(r,84)|0)+1>>1,r=(r|0)>=32767?32767:r,r=(r|0)<=-32768?-32768:r,Q=g(r,74),X[A+6>>1]=((Q+(g(s,-84)+g(e,55)|0)|0)+g(l,16777187)|0)+128>>>8,X[A+4>>1]=(((g(s,-29)+g(e,84)|0)+g(r,16777142)|0)+g(l,55)|0)+128>>>8,X[A>>1]=((Q+(g(s,55)+g(e,29)|0)|0)+g(l,84)|0)+128>>>8}function sZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0;d=X[e+10>>1],G=X[e+26>>1],U=X[e+18>>1],x=X[e+2>>1],E=X[e+14>>1],R=X[e+12>>1],N=X[e+8>>1],h=1<<r-1,n=1<<f,f=0-n|0,_=X[e+22>>1],k=X[e+6>>1],Y=X[e+30>>1],o=((g(_,-74)+g(k,74)|0)+g(Y,74)|0)- -64>>7,w=n+65535|0,o=((f|0)>(o|0)?f:(n|0)>(o|0)?o:w)<<16>>16,B=X[e+20>>1],j=X[e+4>>1],O=X[e+28>>1],l=((g(B,-74)+g(j,74)|0)+g(O,74)|0)- -64>>7,l=((f|0)>(l|0)?f:(n|0)>(l|0)?l:w)<<16>>16,S=X[e+16>>1],q=X[e>>1],e=X[e+24>>1],s=((g(S,-74)+g(q,74)|0)+g(e,74)|0)- -64>>7,s=((f|0)>(s|0)?f:(n|0)>(s|0)?s:w)<<16>>16,i[A+40>>2]=h+(g(o,74)+(g(l,-74)+g(s,74)|0)|0)>>r,I=(((g(R,-74)+g(j,84)|0)+g(B,55)|0)+g(O,-29)|0)- -64>>7,I=((f|0)>(I|0)?f:(n|0)>(I|0)?I:w)<<16>>16,Q=(((g(N,-74)+g(q,84)|0)+g(S,55)|0)+g(e,-29)|0)- -64>>7,Q=((f|0)>(Q|0)?f:(n|0)>(Q|0)?Q:w)<<16>>16,V=(((g(E,-74)+g(k,84)|0)+g(_,55)|0)+g(Y,-29)|0)- -64>>7,V=((f|0)>(V|0)?f:(n|0)>(V|0)?V:w)<<16>>16,i[A+56>>2]=((g(I,-74)+g(Q,74)|0)+g(V,74)|0)+h>>r,m=((g(U,-74)+g(x,74)|0)+g(G,74)|0)- -64>>7,m=((f|0)>(m|0)?f:(n|0)>(m|0)?m:w)<<16>>16,i[A+44>>2]=(((g(m,-74)+g(s,84)|0)+g(l,55)|0)+g(o,-29)|0)+h>>r,m=g(m,74),i[A+36>>2]=(((m+g(s,55)|0)+g(l,-29)|0)+g(o,-84)|0)+h>>r,i[A+32>>2]=(((m+g(s,29)|0)+g(l,84)|0)+g(o,55)|0)+h>>r,R=g(R,74),o=(((R+g(j,55)|0)+g(B,-29)|0)+g(O,-84)|0)- -64>>7,o=((f|0)>(o|0)?f:(n|0)>(o|0)?o:w)<<16>>16,N=g(N,74),l=(((N+g(q,55)|0)+g(S,-29)|0)+g(e,-84)|0)- -64>>7,l=((f|0)>(l|0)?f:(n|0)>(l|0)?l:w)<<16>>16,E=g(E,74),s=(((E+g(k,55)|0)+g(_,-29)|0)+g(Y,-84)|0)- -64>>7,s=((f|0)>(s|0)?f:(n|0)>(s|0)?s:w)<<16>>16,i[A+24>>2]=((g(o,-74)+g(l,74)|0)+g(s,74)|0)+h>>r,B=(((R+g(j,29)|0)+g(B,84)|0)+g(O,55)|0)- -64>>7,B=((f|0)>(B|0)?f:(n|0)>(B|0)?B:w)<<16>>16,e=(((N+g(q,29)|0)+g(S,84)|0)+g(e,55)|0)- -64>>7,e=((e|0)<(f|0)?f:(e|0)<(n|0)?e:w)<<16>>16,_=(((E+g(k,29)|0)+g(_,84)|0)+g(Y,55)|0)- -64>>7,_=((f|0)>(_|0)?f:(n|0)>(_|0)?_:w)<<16>>16,i[A+8>>2]=((g(B,-74)+g(e,74)|0)+g(_,74)|0)+h>>r,k=(((g(d,-74)+g(x,84)|0)+g(U,55)|0)+g(G,-29)|0)- -64>>7,k=((f|0)>(k|0)?f:(n|0)>(k|0)?k:w)<<16>>16,i[A+60>>2]=(((g(k,-74)+g(Q,84)|0)+g(I,55)|0)+g(V,-29)|0)+h>>r,k=g(k,74),i[A+52>>2]=(((k+g(Q,55)|0)+g(I,-29)|0)+g(V,-84)|0)+h>>r,i[A+48>>2]=(((k+g(Q,29)|0)+g(I,84)|0)+g(V,55)|0)+h>>r,Y=g(d,74),k=(((Y+g(x,55)|0)+g(U,-29)|0)+g(G,-84)|0)- -64>>7,k=((f|0)>(k|0)?f:(n|0)>(k|0)?k:w)<<16>>16,i[A+28>>2]=(((g(k,-74)+g(l,84)|0)+g(o,55)|0)+g(s,-29)|0)+h>>r,k=g(k,74),i[A+20>>2]=(((k+g(l,55)|0)+g(o,-29)|0)+g(s,-84)|0)+h>>r,i[A+16>>2]=(((k+g(l,29)|0)+g(o,84)|0)+g(s,55)|0)+h>>r,G=(((Y+g(x,29)|0)+g(U,84)|0)+g(G,55)|0)- -64>>7,f=((f|0)>(G|0)?f:(n|0)>(G|0)?G:w)<<16>>16,i[A+12>>2]=(((g(f,-74)+g(e,84)|0)+g(B,55)|0)+g(_,-29)|0)+h>>r,f=g(f,74),i[A+4>>2]=(((f+g(e,55)|0)+g(B,-29)|0)+g(_,-84)|0)+h>>r,i[A>>2]=(((f+g(e,29)|0)+g(B,84)|0)+g(_,55)|0)+h>>r}function qr(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;n=A+e|0,r=i[A+4>>2];i:{e:{if(r&1)break e;if(!(r&2))break i;r=i[A>>2],e=r+e|0;r:{f:{A:{if(A=A-r|0,(A|0)!=i[33455]){if(f=i[A+12>>2],r>>>0<=255){if(k=i[A+8>>2],(k|0)!=(f|0))break A;h=133800,w=i[33450]&t2(-2,r>>>3|0),i[h>>2]=w;break e}if(o=i[A+24>>2],(A|0)!=(f|0)){r=i[A+8>>2],i[r+12>>2]=f,i[f+8>>2]=r;break r}if(k=i[A+20>>2],k)r=A+20|0;else{if(k=i[A+16>>2],!k)break f;r=A+16|0}for(;l=r,f=k,r=f+20|0,k=i[f+20>>2],!(!k&&(r=f+16|0,k=i[f+16>>2],!k)););i[l>>2]=0;break r}if(r=i[n+4>>2],(r&3)!=3)break e;i[33452]=e,i[n+4>>2]=r&-2,i[A+4>>2]=e|1,i[n>>2]=e;return}i[k+12>>2]=f,i[f+8>>2]=k;break e}f=0}if(!o)break e;r=i[A+28>>2],k=(r<<2)+134104|0;r:{if(i[k>>2]==(A|0)){if(i[k>>2]=f,f)break r;h=133804,w=i[33451]&t2(-2,r),i[h>>2]=w;break e}f:{if(i[o+16>>2]==(A|0)){i[o+16>>2]=f;break f}i[o+20>>2]=f}if(!f)break e}if(i[f+24>>2]=o,r=i[A+16>>2],r&&(i[f+16>>2]=r,i[r+24>>2]=f),r=i[A+20>>2],!r)break e;i[f+20>>2]=r,i[r+24>>2]=f}e:{r:{f:{A:{if(r=i[n+4>>2],!(r&2)){if(i[33456]==(n|0)){if(i[33456]=A,e=i[33453]+e|0,i[33453]=e,i[A+4>>2]=e|1,i[33455]!=(A|0))break i;i[33452]=0,i[33455]=0;return}if(s=i[33455],(s|0)==(n|0)){i[33455]=A,e=i[33452]+e|0,i[33452]=e,i[A+4>>2]=e|1,i[A+e>>2]=e;return}if(e=(r&-8)+e|0,f=i[n+12>>2],r>>>0<=255){if(k=i[n+8>>2],(k|0)==(f|0)){h=133800,w=i[33450]&t2(-2,r>>>3|0),i[h>>2]=w;break r}i[k+12>>2]=f,i[f+8>>2]=k;break r}if(o=i[n+24>>2],(f|0)!=(n|0)){r=i[n+8>>2],i[r+12>>2]=f,i[f+8>>2]=r;break f}if(k=i[n+20>>2],k)r=n+20|0;else{if(k=i[n+16>>2],!k)break A;r=n+16|0}for(;l=r,f=k,r=f+20|0,k=i[f+20>>2],!(!k&&(r=f+16|0,k=i[f+16>>2],!k)););i[l>>2]=0;break f}i[n+4>>2]=r&-2,i[A+4>>2]=e|1,i[A+e>>2]=e;break e}f=0}if(!o)break r;r=i[n+28>>2],k=(r<<2)+134104|0;f:{if(i[k>>2]==(n|0)){if(i[k>>2]=f,f)break f;h=133804,w=i[33451]&t2(-2,r),i[h>>2]=w;break r}A:{if(i[o+16>>2]==(n|0)){i[o+16>>2]=f;break A}i[o+20>>2]=f}if(!f)break r}if(i[f+24>>2]=o,r=i[n+16>>2],r&&(i[f+16>>2]=r,i[r+24>>2]=f),r=i[n+20>>2],!r)break r;i[f+20>>2]=r,i[r+24>>2]=f}if(i[A+4>>2]=e|1,i[A+e>>2]=e,(A|0)!=(s|0))break e;i[33452]=e;return}if(e>>>0<=255){r=(e&-8)+133840|0,f=i[33450],e=1<<(e>>>3);e:{if(!(f&e)){i[33450]=e|f,e=r;break e}e=i[r+8>>2]}i[r+8>>2]=A,i[e+12>>2]=A,i[A+12>>2]=r,i[A+8>>2]=e;return}f=31,e>>>0<=16777215&&(r=_1(e>>>8|0),f=((e>>>38-r&1)-(r<<1)|0)+62|0),i[A+28>>2]=f,i[A+16>>2]=0,i[A+20>>2]=0,r=(f<<2)+134104|0;e:{k=i[33451],l=1<<f;r:{if(!(k&l)){i[33451]=k|l,i[r>>2]=A,i[A+24>>2]=r;break r}for(f=e<<((f|0)!=31?25-(f>>>1|0)|0:0),r=i[r>>2];;){if(k=r,(i[r+4>>2]&-8)==(e|0))break e;if(r=f>>>29|0,f=f<<1,l=k+(r&4)|0,r=i[l+16>>2],!r)break}i[l+16>>2]=A,i[A+24>>2]=k}i[A+12>>2]=A,i[A+8>>2]=A;return}e=i[k+8>>2],i[e+12>>2]=A,i[k+8>>2]=A,i[A+24>>2]=0,i[A+12>>2]=k,i[A+8>>2]=e}}function hZ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;h=v-48|0,v=h,m=h+12|0,n=v+-64|0,v=n,_=i[e+8>>2],S6(n+32|0,i[_+48>>2],1835625829);i:{e:{r:{f:{A:switch(u[n+52|0]){default:e2(),M();case 1:r=i[n+36>>2],i[m>>2]=i[n+32>>2],i[m+4>>2]=r,r=m+8|0;k:{if(t[n+51|0]>=0){f=i[n+44>>2],i[r>>2]=i[n+40>>2],i[r+4>>2]=f,i[r+8>>2]=i[n+48>>2];break k}T(r,i[n+40>>2],i[n+44>>2])}t[m+20|0]=1;break f;case 0:break A}if(s=i[n+32>>2],B=i[n+36>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),t[s+164|0]=1,i[s+100>>2]=i[s+100>>2]&-2|1,o=l2(r),o>>>0>=2147483640)break r;A:{k:{if(o>>>0>=11){w=o|7,l=C(w+1|0),i[n+24>>2]=w-2147483647,i[n+16>>2]=l,i[n+20>>2]=o;break k}if(t[n+27|0]=o,l=n+16|0,!o)break A}if(!o)break A;z(l,r,o)}t[o+l|0]=0,r=s+128|0;A:{if((r|0)==(n+16|0))break A;if(o=t[n+27|0],t[s+139|0]>=0){if((o|0)>=0){o=i[n+20>>2],i[r>>2]=i[n+16>>2],i[r+4>>2]=o,i[r+8>>2]=i[n+24>>2];break A}m1(r,i[n+16>>2],i[n+20>>2]);break A}l=r,r=(o|0)<0,R1(l,r?i[n+16>>2]:n+16|0,r?i[n+20>>2]:o)}if(t[n+27|0]<0&&Z(i[n+16>>2]),r=i[s+104>>2],o=C(28),i[o+12>>2]=r,i[o>>2]=101128,i[o+4>>2]=0,i[o+8>>2]=0,s=o+16|0,r=l2(f),r>>>0>=2147483640)break e;I=o+12|0;A:{k:{if(r>>>0>=11){l=r|7,s=C(l+1|0),i[o+24>>2]=l-2147483647,i[o+16>>2]=s,i[o+20>>2]=r;break k}if(t[o+27|0]=r,!r)break A}if(!r)break A;z(s,f,r)}t[r+s|0]=0,i[n+12>>2]=o,i[n+8>>2]=I,i[o+4>>2]=i[o+4>>2]+1,r=i[n+12>>2],i[n>>2]=i[n+8>>2],i[n+4>>2]=r;A:{if(r=i[_+188>>2],l=i[_+192>>2],r>>>0<l>>>0){i[r>>2]=i[n>>2],i[r+4>>2]=i[n+4>>2],i[_+188>>2]=r+8;break A}k:{if(s=i[_+184>>2],r=r-s|0,G=r>>3,f=G+1|0,f>>>0<536870912){if(l=l-s|0,w=l>>2,l=l>>>0>=2147483640?536870911:f>>>0<w>>>0?w:f,l){if(l>>>0>=536870912)break k;f=C(l<<3)}else f=0;w=f+r|0,i[w>>2]=i[n>>2],i[w+4>>2]=i[n+4>>2],G=w-(G<<3)|0,r&&z(G,s,r),i[_+192>>2]=f+(l<<3),r=w+8|0,i[_+188>>2]=r,i[_+184>>2]=G,s&&Z(s),i[_+188>>2]=r;break A}s0(),M()}x0(),M()}if(t[m+20|0]=0,i[m+4>>2]=o,i[m>>2]=I,!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break f;W[i[i[B>>2]+8>>2]](B),y(B)}r=u[n+52|0],(r|0)!=255&&(f=i[25167],i[n+16>>2]=i[25166],i[n+20>>2]=f,W[i[(n+16|0)+(r<<2)>>2]](n+63|0,n+32|0)),v=n- -64|0;break i}I0(),M()}I0(),M()}i:{e:switch(u[h+32|0]){default:e2(),M();case 1:c0(A,h+12|0,i[e+8>>2]);break i;case 0:break e}if(n=i[h+12>>2],r=i[h+16>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),hl(i[e>>2],i[n>>2]),k){f=C(16),o=i[e+8>>2],e=i[e+12>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[f+12>>2]=r,i[f+8>>2]=n,i[f+4>>2]=e,i[f>>2]=o,i[k>>2]=f,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e;break i}if(e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}A=u[h+32|0],(A|0)!=255&&(e=i[25865],i[h+40>>2]=i[25864],i[h+44>>2]=e,W[i[(h+40|0)+(A<<2)>>2]](h+39|0,h+12|0)),v=h+48|0}function wZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=78468,k=i[19620],i[f+24>>2]=k,n=i[k-12>>2],k=f+24|0,i[n+k>>2]=i[19621],s=k+i[i[f+24>>2]-12>>2]|0,n=f+28|0,J0(s,n),t[s+80|0]=0,i[s+72>>2]=0,i[f+80>>2]=78468,i[f+24>>2]=78448,s=R0(n),i[s>>2]=77200,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,n=f+164|0,J2(n,e,r),o=k,l=n,k=t[f+175|0],n=(k|0)<0,F(o,n?i[f+164>>2]:l,n?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),k=f+164|0,k0(k,r),o=k,k=t[f+175|0],n=(k|0)<0,F(f+24|0,n?i[f+164>>2]:o,n?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(B0(F(f+24|0,37541,9),i[e+104>>2]),47878,1),n=f+164|0,k0(n,r),o=n,n=t[f+175|0],l=(n|0)<0,F(k,l?i[f+164>>2]:o,l?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(B0(F(k,33020,23),p[e+108>>1]),47878,1),n=f+164|0,k0(n,r),o=n,n=t[f+175|0],l=(n|0)<0,F(k,l?i[f+164>>2]:o,l?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(k,36455,11),n=f+12|0,z1(n,i[e+112>>2]),o=k,l=n,k=t[f+23|0],n=(k|0)<0,k=F(F(o,n?i[f+12>>2]:l,n?i[f+16>>2]:k),47878,1),n=f+164|0,k0(n,r),o=n,n=t[f+175|0],l=(n|0)<0,F(k,l?i[f+164>>2]:o,l?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),o=F(k,36694,11),k=t[e+127|0],n=(k|0)<0,F(F(o,n?i[e+116>>2]:e+116|0,n?i[e+120>>2]:k),47878,1),t[f+23|0]<0&&Z(i[f+12>>2]),k=i[e+112>>2],(k|0)==1835625829&&(k=f+164|0,k0(k,r),o=k,k=t[f+175|0],n=(k|0)<0,F(f+24|0,n?i[f+164>>2]:o,n?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),o=F(f+24|0,36342,14),k=t[e+139|0],n=(k|0)<0,k=F(F(o,n?i[e+128>>2]:e+128|0,n?i[e+132>>2]:k),47878,1),n=f+164|0,k0(n,r),o=n,n=t[f+175|0],l=(n|0)<0,F(k,l?i[f+164>>2]:o,l?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),o=F(k,35209,18),k=t[e+151|0],n=(k|0)<0,F(F(o,n?i[e+140>>2]:e+140|0,n?i[e+144>>2]:k),47878,1),k=i[e+112>>2]),(k|0)==1970432288&&(k=f+164|0,k0(k,r),o=k,k=t[f+175|0],n=(k|0)<0,F(f+24|0,n?i[f+164>>2]:o,n?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),o=F(f+24|0,36595,15),k=t[e+163|0],n=(k|0)<0,F(F(o,n?i[e+152>>2]:e+152|0,n?i[e+156>>2]:k),47878,1)),k=f+164|0,k0(k,r),n=k,r=t[f+175|0],k=(r|0)<0,F(f+24|0,k?i[f+164>>2]:n,k?i[f+168>>2]:r),t[f+175|0]<0&&Z(i[f+164>>2]),r=F(f+24|0,34701,13),k=i[i[r>>2]-12>>2]+r|0,i[k+4>>2]=i[k+4>>2]|1,F(i1(r,u[e+164|0]),47878,1),e=i[f+76>>2];i:{e:{if(e&16){e=i[f+72>>2],r=i[f+52>>2],e>>>0<r>>>0&&(i[f+72>>2]=r,e=r),r=f+48|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+44>>2],r=f+36|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[19622],i[s>>2]=77200,t[f+71|0]<0&&Z(i[f+60>>2]),y0(s),Y0(f+80|0),v=f+176|0}function _Z(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;f=v-32|0,v=f,w=f+12|0,_=i[e>>2],s=v-32|0,v=s,n=C(204),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=100736,m=_,G=e3(n+12|0),i[m+48>>2]=G,k=i[_+52>>2],i[_+52>>2]=n;i:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break i;W[i[i[k>>2]+8>>2]](k),y(k)}h=i[_+48>>2],i[h+168>>2]=_- -64,n=v-176|0,v=n,k=C(192),i[k+108>>2]=78828,i[k+136>>2]=0,l=i[19710],i[k>>2]=l,i[k+i[l-12>>2]>>2]=i[19711],i[k+4>>2]=0,l=k+i[i[k>>2]-12>>2]|0,o=k+8|0,J0(l,o),t[l+80|0]=0,i[l+72>>2]=0,i[k+108>>2]=78828,i[k>>2]=78808,Yn(bo(o),r,12)||(r=k+i[i[k>>2]-12>>2]|0,M1(r,i[r+16>>2]|4)),l=s+8|0,i[n+172>>2]=k;i:{e:{r:{f:{if(i[(k+i[i[k>>2]-12>>2]|0)+16>>2]){i[n+116>>2]=0,i[n+88>>2]=78164,i[n+32>>2]=78144,r=i[19545],i[n+24>>2]=r,k=i[r-12>>2],r=n+24|0,i[k+r>>2]=i[19546],i[n+28>>2]=0,k=r+i[i[n+24>>2]-12>>2]|0,o=n+36|0,J0(k,o),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[n+32>>2]=k,h=i[k-12>>2],k=n+32|0,i[h+k>>2]=i[19548],h=i[19544],i[n+24>>2]=h,i[r+i[h-12>>2]>>2]=i[19549],i[n+88>>2]=78164,i[n+24>>2]=78124,i[n+32>>2]=78144,o=R0(o),i[o>>2]=77200,i[n+76>>2]=0,i[n+80>>2]=0,i[n+68>>2]=0,i[n+72>>2]=0,i[n+84>>2]=24,k=F(k,36738,20),r=i[33136],r=p[((r>>>0<=153?r:0)<<1)+75456>>1]+73528|0,F(D0(F(F(k,r,l2(r)),30581,2),i[33136]),47877,2),r=i[n+84>>2];A:{if(r&16){r=i[n+80>>2],k=i[n+60>>2],r>>>0<k>>>0&&(i[n+80>>2]=k,r=k),k=n+56|0;break A}if(!(r&8)){r=0,t[n+23|0]=0,k=n+12|0;break e}r=i[n+52>>2],k=n+44|0}if(h=i[k>>2],r=r-h|0,r>>>0>=2147483640)break f;if(r>>>0>=11){B=r|7,k=C(B+1|0),i[n+20>>2]=B-2147483647,i[n+12>>2]=k,i[n+16>>2]=r;break r}if(t[n+23|0]=r,k=n+12|0,r)break r;r=0;break e}r=C(56),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101360,k=v-16|0,v=k,B=r+16|0,i[B>>2]=92456,i[r+20>>2]=0,i[r+24>>2]=0,i[r+36>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+16>>2]=92280,o=i[n+172>>2],i[n+172>>2]=0,i[r+40>>2]=o,W5(o,0,0,2),fu(k,i[r+40>>2]),o=i[k+12>>2],i[r+48>>2]=i[k+8>>2],i[r+52>>2]=o,W5(i[r+40>>2],0,0,0),v=k+16|0,i[n+28>>2]=r,i[n+24>>2]=B,i[r+4>>2]=i[r+4>>2]+1,fA(l,h,n+24|0),k=i[n+28>>2];A:{if(!k||(l=i[k+4>>2],i[k+4>>2]=l-1,l))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(k=i[r+4>>2],i[r+4>>2]=k-1,k)break i;W[i[i[r>>2]+8>>2]](r),y(r);break i}I0(),M()}if(!r)break e;z(k,h,r)}t[r+k|0]=0,a(l,1,0,n+12|0),t[n+23|0]<0&&Z(i[n+12>>2]),r=i[19543],i[n+24>>2]=r,i[i[r-12>>2]+(n+24|0)>>2]=i[19551],i[n+32>>2]=i[19552],i[o>>2]=77200,t[n+79|0]<0&&Z(i[n+68>>2]),y0(o),Y0(n+88|0)}r=i[n+172>>2],i[n+172>>2]=0,r&&W[i[i[r>>2]+4>>2]](r),v=n+176|0;i:{if(i[s+8>>2]){r=i[s+12>>2],i[w>>2]=i[s+8>>2],i[w+4>>2]=r,r=i[s+20>>2],i[w+8>>2]=i[s+16>>2],i[w+12>>2]=r,i[w+16>>2]=i[s+24>>2];break i}if(rA(w,_),t[s+27|0]>=0)break i;Z(i[s+16>>2])}v=s+32|0,c0(A,w,i[e>>2]),t[f+31|0]<0&&Z(i[f+20>>2]),v=f+32|0}function Vn(A,e,r,f,k){var n=0,o=0,l=0,s=0;n=v-160|0,v=n;i:{e:{r:{f:{A:{k:{n:{if(o=i[f>>2],f=i[o+104>>2],o=i[o+108>>2],(f|0)!=(o|0))for(;;){if(i[f>>2]==(r|0))break n;if(f=f+16|0,(o|0)==(f|0))break}i[n+104>>2]=0,i[n+76>>2]=78164,i[n+20>>2]=78144,e=i[19545],i[n+12>>2]=e,f=i[e-12>>2],e=n+12|0,i[f+e>>2]=i[19546],i[n+16>>2]=0,f=e+i[i[n+12>>2]-12>>2]|0,k=n+24|0,J0(f,k),t[f+80|0]=0,i[f+72>>2]=0,f=i[19547],i[n+20>>2]=f,o=i[f-12>>2],f=n+20|0,i[o+f>>2]=i[19548],o=i[19544],i[n+12>>2]=o,i[e+i[o-12>>2]>>2]=i[19549],i[n+76>>2]=78164,i[n+12>>2]=78124,i[n+20>>2]=78144,k=R0(k),i[k>>2]=77200,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,F(B0(F(f,22828,9),r),2514,46),e=i[n+72>>2];t:{if(e&16){f=i[n+68>>2],e=i[n+48>>2],f>>>0<e>>>0&&(i[n+68>>2]=e,f=e),e=n+44|0;break t}if(!(e&8)){f=0,t[n+11|0]=0,r=n;break e}f=i[n+40>>2],e=n+32|0}if(e=i[e>>2],f=f-e|0,f>>>0>=2147483640)break k;if(f>>>0>=11){o=f|7,r=C(o+1|0),i[n+8>>2]=o-2147483647,i[n>>2]=r,i[n+4>>2]=f;break r}if(t[n+11|0]=f,r=n,f)break r;f=0;break e}if(o=i[f+4>>2],l=i[f+8>>2],(o|0)!=(l|0))for(;;){if(f=p[o+2>>1],s=i[e+36>>2],f>>>0>i[e+40>>2]-s>>3>>>0){i[n+104>>2]=0,i[n+76>>2]=78164,i[n+20>>2]=78144,e=i[19545],i[n+12>>2]=e,f=i[e-12>>2],e=n+12|0,i[f+e>>2]=i[19546],i[n+16>>2]=0,f=e+i[i[n+12>>2]-12>>2]|0,k=n+24|0,J0(f,k),t[f+80|0]=0,i[f+72>>2]=0,f=i[19547],i[n+20>>2]=f,l=i[f-12>>2],f=n+20|0,i[l+f>>2]=i[19548],l=i[19544],i[n+12>>2]=l,i[e+i[l-12>>2]>>2]=i[19549],i[n+76>>2]=78164,i[n+12>>2]=78124,i[n+20>>2]=78144,k=R0(k),i[k>>2]=77200,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,F(B0(F(F(B0(F(f,22700,28),p[o+2>>1]),31796,11),22848,4),r),2561,23),e=i[n+72>>2];n:{if(e&16){f=i[n+68>>2],e=i[n+48>>2],f>>>0<e>>>0&&(i[n+68>>2]=e,f=e),e=n+44|0;break n}if(!(e&8)){f=0,t[n+11|0]=0,r=n;break f}f=i[n+40>>2],e=n+32|0}if(e=i[e>>2],f=f-e|0,f>>>0>=2147483640)break k;if(f>>>0>=11){o=f|7,r=C(o+1|0),i[n+8>>2]=o-2147483647,i[n>>2]=r,i[n+4>>2]=f;break A}if(t[n+11|0]=f,r=n,f)break A;f=0;break f}if(f&&P0(k,((f<<3)+s|0)-8|0),o=o+4|0,(l|0)==(o|0))break}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}I0(),M()}if(!f)break f;z(r,e,f)}t[r+f|0]=0,a(A,2,115,n),t[n+11|0]<0&&Z(i[n>>2]),A=i[19543],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[19551],i[n+20>>2]=i[19552],i[k>>2]=77200,t[n+67|0]<0&&Z(i[n+56>>2]),y0(k),Y0(n+76|0);break i}if(!f)break e;z(r,e,f)}t[r+f|0]=0,a(A,2,116,n),t[n+11|0]<0&&Z(i[n>>2]),A=i[19543],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[19551],i[n+20>>2]=i[19552],i[k>>2]=77200,t[n+67|0]<0&&Z(i[n+56>>2]),y0(k),Y0(n+76|0)}v=n+160|0}function BZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;n=v-16|0,v=n,h=i[r+4>>2],o=i[k>>2],s=i[r>>2],r=o+s|0;i:{if(h-r>>>0<(f|0)/8<<2>>>0){if(e=C(56),i[n+4>>2]=e,i[n+8>>2]=54,i[n+12>>2]=-2147483592,r=u[9758]|u[9759]<<8|(u[9760]<<16|u[9761]<<24),f=u[9754]|u[9755]<<8|(u[9756]<<16|u[9757]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+54|0]=0,r=u[9804]|u[9805]<<8|(u[9806]<<16|u[9807]<<24),f=u[9800]|u[9801]<<8|(u[9802]<<16|u[9803]<<24),t[e+46|0]=f,t[e+47|0]=f>>>8,t[e+48|0]=f>>>16,t[e+49|0]=f>>>24,t[e+50|0]=r,t[e+51|0]=r>>>8,t[e+52|0]=r>>>16,t[e+53|0]=r>>>24,r=u[9798]|u[9799]<<8|(u[9800]<<16|u[9801]<<24),f=u[9794]|u[9795]<<8|(u[9796]<<16|u[9797]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[9790]|u[9791]<<8|(u[9792]<<16|u[9793]<<24),f=u[9786]|u[9787]<<8|(u[9788]<<16|u[9789]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[9782]|u[9783]<<8|(u[9784]<<16|u[9785]<<24),f=u[9778]|u[9779]<<8|(u[9780]<<16|u[9781]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[9774]|u[9775]<<8|(u[9776]<<16|u[9777]<<24),f=u[9770]|u[9771]<<8|(u[9772]<<16|u[9773]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[9766]|u[9767]<<8|(u[9768]<<16|u[9769]<<24),f=u[9762]|u[9763]<<8|(u[9764]<<16|u[9765]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,136,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}l=u[r|0],h=u[r+1|0];e:{if((f|0)==32){w=u[r+3|0],r=u[r+2|0],i[k>>2]=o+4,i[e+4>>2]=h<<16|l<<24|r<<8|w,o=i[k>>2],r=o+s|0,r=u[r|0]|u[r+1|0]<<8|(u[r+2|0]<<16|u[r+3|0]<<24),i[k>>2]=o+4,i[e+8>>2]=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),r=i[k>>2],o=s+r|0,l=u[o+1|0]<<16|u[o|0]<<24|u[o+2|0]<<8,o=o+3|0,h=4;break e}i[k>>2]=o+2,i[e+4>>2]=(h<<16|l<<24)>>16,r=i[k>>2],o=r+s|0,l=u[o+1|0],o=u[o|0],i[k>>2]=r+2,i[e+8>>2]=(l<<16|o<<24)>>16,r=i[k>>2],l=s+r|0,o=l+1|0,l=u[l|0]<<8,h=2}o=u[o|0],i[k>>2]=r+h,i[e+12>>2]=o|l,l=i[k>>2],s=l+s|0,o=u[s|0],r=u[s+1|0];e:{if((f|0)==32){f=r<<16|o<<24|u[s+2|0]<<8,r=u[s+3|0],h=4;break e}f=o<<8,h=2}if(i[k>>2]=h+l,i[e+16>>2]=r&255|f,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+16|0}function ar(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;o=v-32|0,v=o;i:{e=i[A+16>>2];e:{if(e>>>0>=1024){i[A+16>>2]=e-1024,e=i[A+4>>2],s=i[e>>2],e=e+4|0,i[A+4>>2]=e,f=i[A+8>>2];r:{if((f|0)!=i[A+12>>2])break r;if(n=i[A>>2],n>>>0<e>>>0){r=f-e|0,n=((e-n>>2)+1|0)/-2<<2,k=n+e|0,(e|0)!=(f|0)&&(r&&z(k,e,r),e=i[A+4>>2]),i[A+4>>2]=e+n,f=r+k|0;break r}if(r=(f|0)==(n|0)?1:f-n>>1,r>>>0>=1073741824)break i;if(k=r<<2,l=C(k),h=k+l|0,k=l+(r&-4)|0,r=k,(e|0)!=(f|0))for(r=(f-e|0)+r|0,f=k;i[f>>2]=i[e>>2],e=e+4|0,f=f+4|0,(r|0)!=(f|0););i[A+12>>2]=h,i[A+8>>2]=r,i[A+4>>2]=k,i[A>>2]=l,Z(n),f=i[A+8>>2]}i[f>>2]=s,i[A+8>>2]=f+4;break e}if(e=i[A+8>>2],f=i[A+4>>2],n=e-f|0,r=i[A+12>>2],k=i[A>>2],l=r-k|0,n>>>0<l>>>0){if((e|0)!=(r|0)){w=o,_=C(4096),i[w+12>>2]=_;r:{f:{r=i[A+8>>2];A:{if((r|0)!=i[A+12>>2]){f=r;break A}if(e=i[A+4>>2],n=i[A>>2],e>>>0>n>>>0){f=r-e|0,n=((e-n>>2)+1|0)/-2<<2,k=n+e|0,(e|0)!=(r|0)&&(f&&z(k,e,f),e=i[A+4>>2]),i[A+4>>2]=e+n,f=f+k|0;break A}if(f=(r|0)==(n|0)?1:r-n>>1,f>>>0>=1073741824)break f;if(k=f<<2,l=C(k),s=k+l|0,k=l+(f&-4)|0,f=k,(e|0)!=(r|0))for(f=(r-e|0)+f|0,r=k;i[r>>2]=i[e>>2],e=e+4|0,r=r+4|0,(r|0)!=(f|0););if(i[A+12>>2]=s,i[A+8>>2]=f,i[A+4>>2]=k,i[A>>2]=l,!n)break A;Z(n),f=i[A+8>>2]}i[f>>2]=i[o+12>>2],i[A+8>>2]=f+4;break r}x0(),M()}break e}w=o,_=C(4096),i[w+12>>2]=_,Eo(A,o+12|0),e=i[A+4>>2],s=i[e>>2],e=e+4|0,i[A+4>>2]=e,f=i[A+8>>2];r:{if((f|0)!=i[A+12>>2])break r;if(n=i[A>>2],n>>>0<e>>>0){r=f-e|0,n=((e-n>>2)+1|0)/-2<<2,k=n+e|0,(e|0)!=(f|0)&&(r&&z(k,e,r),e=i[A+4>>2]),i[A+4>>2]=e+n,f=r+k|0;break r}if(r=(f|0)==(n|0)?1:f-n>>1,r>>>0>=1073741824)break i;if(k=r<<2,l=C(k),h=k+l|0,k=l+(r&-4)|0,r=k,(e|0)!=(f|0))for(r=(f-e|0)+r|0,f=k;i[f>>2]=i[e>>2],e=e+4|0,f=f+4|0,(r|0)!=(f|0););i[A+12>>2]=h,i[A+8>>2]=r,i[A+4>>2]=k,i[A>>2]=l,Z(n),f=i[A+8>>2]}i[f>>2]=s,i[A+8>>2]=f+4;break e}if(i[o+28>>2]=A+12,r=(r|0)==(k|0)?1:l>>1,r>>>0>=1073741824)break i;s=r<<2,k=C(s),i[o+12>>2]=k,l=k+s|0,i[o+24>>2]=l,r=k+n|0,i[o+16>>2]=r,h=C(4096);r:{if((n|0)!=(s|0))break r;if((e|0)!=(f|0)){r=(((n>>2)+1|0)/-2<<2)+r|0,i[o+16>>2]=r;break r}r=C(4),i[o+16>>2]=r,i[o+12>>2]=r,l=r+4|0,i[o+24>>2]=l,Z(k),f=i[A+4>>2],e=i[A+8>>2],k=r}if(i[r>>2]=h,s=r+4|0,i[o+20>>2]=s,(e|0)!=(f|0)){for(;e=e-4|0,Eo(o+12|0,e),f=i[A+4>>2],(e|0)!=(f|0););l=i[o+24>>2],s=i[o+20>>2],k=i[o+12>>2],r=i[o+16>>2],e=i[A+8>>2]}if(n=i[A>>2],i[A>>2]=k,i[o+12>>2]=n,i[A+4>>2]=r,i[o+16>>2]=f,i[A+8>>2]=s,i[o+20>>2]=e,r=i[A+12>>2],i[A+12>>2]=l,i[o+24>>2]=r,(e|0)!=(f|0)&&(i[o+20>>2]=((f-e|0)+3&-4)+e),!n)break e;Z(n)}v=o+32|0;return}x0(),M()}function pn(A,e,r,f,k,n,o,l,s,h){var w=0,_=0,B=0,m=0,G=0,I=0,Q=0;w=v-96|0,v=w;i:{e:{G=i[e+20>>2];r:{if(!G)break r;for(Q=w- -64|0,m=e+20|0,B=m,_=G;I=o0[_+16>>2]<r>>>0,B=I?B:_,_=i[(I?4:0)+_>>2],!!_;);if(_=0,(B|0)==(m|0)|o0[B+16>>2]>r>>>0)break r;for(_=m;B=o0[G+16>>2]<r>>>0,_=B?_:G,G=i[(B?4:0)+G>>2],!!G;);if(_=(_|0)!=(m|0)&o0[_+16>>2]<=r>>>0?_:m,m=i[_+20>>2],_=i[_+24>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),m)break e}t[w+16|0]=0,t[w+27|0]=0,e=a(w+56|0,2,2e3,w+16|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(t[w+27|0]>=0)break i;Z(i[w+16>>2]);break i}i[w+48>>2]=0,i[w+52>>2]=0,i[w+44>>2]=w+48,r=w+44|0,W8(r,i[h>>2],h+4|0),W[i[i[m>>2]+140>>2]](w+56|0,m,n,o,l,s,r),S1(r,i[w+48>>2]);e:{r:{f:{A:{k:{n:switch(u[w+76|0]){case 1:e=i[w+60>>2],i[A>>2]=i[w+56>>2],i[A+4>>2]=e,r=A+8|0;t:{if(t[w+75|0]>=0){e=Q,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2];break t}T(r,i[w+64>>2],i[w+68>>2])}t[A+20|0]=1;break e;case 0:break n;default:break k}o=i[w+56>>2],r=i[w+60>>2];n:{if(!r){z9(o,m);break n}i[r+4>>2]=i[r+4>>2]+1,z9(o,m),i[r+4>>2]=i[r+4>>2]+1}switch(i[w+12>>2]=r,i[w+8>>2]=o,o=i[w+12>>2],i[w>>2]=i[w+8>>2],i[w+4>>2]=o,Cn(w+16|0,e,w,f,k,n),n=u[w+36|0],n|0){case 0:break f;case 1:break A;default:break k}}e2(),M()}if(e=i[w+20>>2],i[A>>2]=i[w+16>>2],i[A+4>>2]=e,e=A+8|0,t[w+35|0]>=0){f=i[w+28>>2],i[e>>2]=i[w+24>>2],i[e+4>>2]=f,i[e+8>>2]=i[w+32>>2];break r}T(e,i[w+24>>2],i[w+28>>2]);break r}k=i[w+20>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),e=i[w+16>>2];f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=i[m+504>>2],o=i[m+508>>2],(r|0)!=(o|0))for(l=e+224|0,B=i[e+228>>2];;){f:{if(o0[e+232>>2]>B>>>0){if(f=i[r+4>>2],i[B>>2]=i[r>>2],i[B+4>>2]=f,f=B+8|0,t[r+19|0]>=0){s=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=s,i[f+8>>2]=i[r+16>>2],B=B+20|0;break f}T(f,i[r+8>>2],i[r+12>>2]),B=B+20|0;break f}B=yi(l,r)}if(i[e+228>>2]=B,r=r+20|0,(o|0)==(r|0))break}i[A+4>>2]=k,i[A>>2]=e,r=0}if(t[A+20|0]=n,A=u[w+36|0],(A|0)!=255&&(e=i[25173],i[w+88>>2]=i[25172],i[w+92>>2]=e,W[i[(w+88|0)+(A<<2)>>2]](w+87|0,w+16|0)),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=u[w+76|0],(A|0)==255)break i;e=i[25173],i[w+16>>2]=i[25172],i[w+20>>2]=e,W[i[(w+16|0)+(A<<2)>>2]](w+88|0,w+56|0)}i:{if(!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;W[i[i[_>>2]+8>>2]](_),y(_)}v=w+96|0}function vZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;k=v-192|0,v=k,S2(k+172|0,e,r),t[k+191|0]<0&&Z(i[k+180>>2]),G=e,I=F0(r),i[G+104>>2]=I,n=u[e+97|0],(n|0)==1&&(n=F0(r),t[e+112|0]=1,i[e+108>>2]=n,n=u[e+97|0]),n>>>0>=2&&(n=F0(r),t[e+120|0]=1,i[e+116>>2]=n),_=F0(r),n=i[f+76>>2];i:{if(!(n>>>0<_>>>0&&n)){e:{r:{f:{A:{if(_)for(;;){o=0;k:{if(u[e+97|0]!=1||(o=0,i[e+108>>2]))break k;o=F0(r)}B=0,f=0;k:{if(i[e+104>>2]!=1919247987)break k;if(f=C(32),i[f+16>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f>>2]=113464,i[f+12>>2]=112856,B=f+12|0,fo(A,B,r,e),i[A>>2])break A;if(t[A+19|0]>=0)break k;Z(i[A+8>>2])}n=i[e+128>>2],l=i[e+132>>2];k:{if(n>>>0<l>>>0){i[n+8>>2]=f,i[n+4>>2]=B,i[n>>2]=o,f=n+12|0;break k}if(w=i[e+124>>2],n=n-w|0,s=((n|0)/12|0)+1|0,s>>>0>=357913942)break r;if(l=(l-w|0)/12|0,h=l<<1,h=l>>>0>=178956970?357913941:h>>>0>s>>>0?h:s,h){if(h>>>0>=357913942)break e;s=C(g(h,12))}else s=0;if(l=s+n|0,i[l+8>>2]=f,i[l+4>>2]=B,i[l>>2]=o,o=l+g((n|0)/-12|0,12)|0,n&&z(o,w,n),i[e+132>>2]=s+g(h,12),f=l+12|0,i[e+128>>2]=f,i[e+124>>2]=o,!w)break k;Z(w)}if(i[e+128>>2]=f,m=m+1|0,(_|0)==(m|0))break}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]<0)break f;e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f);break i}T(A,i[28730],i[28731]);break i}s0(),M()}x0(),M()}i[k+116>>2]=0,i[k+88>>2]=78164,i[k+32>>2]=78144,e=i[19545],i[k+24>>2]=e,r=i[e-12>>2],e=k+24|0,i[r+e>>2]=i[19546],i[k+28>>2]=0,r=e+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(r,n),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[k+32>>2]=r,o=i[r-12>>2],r=k+32|0,i[o+r>>2]=i[19548],o=i[19544],i[k+24>>2]=o,i[e+i[o-12>>2]>>2]=i[19549],i[k+88>>2]=78164,i[k+24>>2]=78124,i[k+32>>2]=78144,n=R0(n),i[n>>2]=77200,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,F(B0(F(M2(F(r,31897,11),_,0),31909,62),i[f+76>>2]),5596,6),e=i[k+84>>2];e:{r:{if(e&16){f=k+56|0,r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0?i[k+80>>2]=e:e=r;break r}if(!(e&8)){e=0,t[k+23|0]=0,f=k+12|0;break e}f=k+44|0,e=i[k+52>>2]}r:{if(r=i[f>>2],e=e-r|0,e>>>0<2147483640){if(e>>>0>=11){o=e|7,f=C(o+1|0),i[k+20>>2]=o-2147483647,i[k+12>>2]=f,i[k+16>>2]=e;break r}if(t[k+23|0]=e,f=k+12|0,e)break r;e=0;break e}I0(),M()}if(!e)break e;z(f,r,e)}t[e+f|0]=0,a(A,6,1e3,k+12|0),t[k+23|0]<0&&Z(i[k+12>>2]),A=i[19543],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[19551],i[k+32>>2]=i[19552],i[n>>2]=77200,t[k+79|0]<0&&Z(i[k+68>>2]),y0(n),Y0(k+88|0)}v=k+192|0}function mZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;f=v-192|0,v=f,S2(f+168|0,e,r);i:{if(i[f+168>>2]!=i[28728]){e=i[f+172>>2],i[A>>2]=i[f+168>>2],i[A+4>>2]=e,i[A+16>>2]=i[f+184>>2],e=i[f+180>>2],i[A+8>>2]=i[f+176>>2],i[A+12>>2]=e,i[f+184>>2]=0,i[f+176>>2]=0,i[f+180>>2]=0;break i}if(u[e+97|0]>=2){B1(A,e,5176);break i}B=F0(r),i[e+108>>2]=i[e+104>>2];e:{r:{f:{A:{k:{if(B)for(;;){if(!i[r+16>>2]){i[f+112>>2]=0,i[f+84>>2]=78164,i[f+28>>2]=78144,e=i[19545],i[f+20>>2]=e,r=i[e-12>>2],e=f+20|0,i[r+e>>2]=i[19546],i[f+24>>2]=0,r=e+i[i[f+20>>2]-12>>2]|0,k=f+32|0,J0(r,k),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[f+28>>2]=r,m=i[r-12>>2],r=f+28|0,i[m+r>>2]=i[19548],l=i[19544],i[f+20>>2]=l,i[e+i[l-12>>2]>>2]=i[19549],i[f+84>>2]=78164,i[f+20>>2]=78124,i[f+28>>2]=78144,l=R0(k),i[l>>2]=77200,i[f+72>>2]=0,i[f+76>>2]=0,i[f+64>>2]=0,i[f+68>>2]=0,i[f+80>>2]=24,F(M2(F(B0(F(r,31637,24),B),32720,31),_,s),26428,9),e=i[f+80>>2];n:{if(e&16){k=f+52|0,r=i[f+76>>2],e=i[f+56>>2],r>>>0<e>>>0?i[f+76>>2]=e:e=r;break n}if(!(e&8)){e=0,t[f+19|0]=0,k=f+8|0;break e}k=f+40|0,e=i[f+48>>2]}if(r=i[k>>2],e=e-r|0,e>>>0>=2147483640)break k;if(e>>>0>=11){s=e|7,k=C(s+1|0),i[f+16>>2]=s-2147483647,i[f+8>>2]=k,i[f+12>>2]=e;break r}if(t[f+19|0]=e,k=f+8|0,e)break r;e=0;break e}n:{if(u[e+97|0]==1){l=S4(r),G=h0,k=S4(r),I=h0;break n}l=F0(r),G=0,k=F0(r),I=k>>31}m=k,Q=Hi(r),V=Hi(r),n=i[e+108>>2],o=i[e+112>>2];n:{if(n>>>0<o>>>0){X[n+18>>1]=V,X[n+16>>1]=Q,i[n+8>>2]=k,i[n+12>>2]=I,i[n>>2]=l,i[n+4>>2]=G,k=n+24|0;break n}if(w=i[e+104>>2],k=n-w|0,n=((k|0)/24|0)+1|0,n>>>0>=178956971)break A;if(o=(o-w|0)/24|0,h=o<<1,h=o>>>0>=89478485?178956970:n>>>0<h>>>0?h:n,h){if(h>>>0>=178956971)break f;n=C(g(h,24))}else n=0;if(o=n+k|0,X[o+18>>1]=V,X[o+16>>1]=Q,i[o+8>>2]=m,i[o+12>>2]=I,i[o>>2]=l,i[o+4>>2]=G,l=o+g((k|0)/-24|0,24)|0,k&&z(l,w,k),i[e+112>>2]=n+g(h,24),k=o+24|0,i[e+108>>2]=k,i[e+104>>2]=l,!w)break n;Z(w)}if(i[e+108>>2]=k,_=_+1|0,s=_?s:s+1|0,!((B|0)!=(_|0)|s))break}if(u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}I0(),M()}s0(),M()}x0(),M()}if(!e)break e;z(k,r,e)}t[e+k|0]=0,a(A,2,100,f+8|0),t[f+19|0]<0&&Z(i[f+8>>2]),A=i[19543],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[19551],i[f+28>>2]=i[19552],i[l>>2]=77200,t[f+75|0]<0&&Z(i[f+64>>2]),y0(l),Y0(f+84|0)}t[f+187|0]<0&&Z(i[f+176>>2]),v=f+192|0}function ZZ(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;i[A+4>>2]=1,e=i[A+12>>2],i[e+324>>2]=i[e+324>>2]-1,i[e+328>>2]=i[e+328>>2]+1,e=i[A+12>>2],_=i[e+124>>2],w=i[_+16876>>2],r=e,B=i[_+16892>>2],e=B-1|0,O8(r,A,e,i[A+8>>2],i[A+24>>2]),r=i[A+8>>2],(r|0)>0&&(O8(i[A+12>>2],A,e,r-1|0,i[A+24>>2]),r=i[A+8>>2]),f=r+1|0,(f|0)<i[_+16900>>2]&&(O8(i[A+12>>2],A,e,f,i[A+24>>2]),r=i[A+8>>2],f=r+1|0),o=i[A+20>>2],k=i[A+16>>2],f=f<<w;i:{e:{if(e=r<<w,!(e&1)){if(r=i[k+28>>2],s=(r|0)>(f|0)?f:r,s&1)break e;r=i[o+124>>2],l=(i[r+16840>>2]+7|0)/8|0,h=(i[r+16832>>2]+7|0)/8|0,r=i[k+40>>2];r:{if((r|0)!=i[o+40>>2]){if((e|0)>=(s|0))break r;for(r=e;n=g(h,i[k+24>>2]),n&&(f=g(r,h),z(i[o+4>>2]+g(f,i[o+40>>2])|0,i[k+4>>2]+g(f,i[k+40>>2])|0,n)),r=r+1|0,(s|0)!=(r|0););break r}if(f=g(s-e|0,g(r,h)),!f)break r;r=g(r,g(e,h)),z(r+i[o+4>>2]|0,r+i[k+4>>2]|0,f)}r=u[k+51|0],f=(s|0)/(r|0)|0,r=(e|0)/(r|0)|0;r:{if(!i[k+20>>2])break r;if(e=i[k+44>>2],(e|0)!=i[o+44>>2]){if((r|0)>=(f|0))break r;for(;n=g(r,l),e=g(l,i[k+32>>2]),e&&z(i[o+8>>2]+g(n,i[o+44>>2])|0,i[k+8>>2]+g(n,i[k+44>>2])|0,e),e=g(l,i[k+32>>2]),e&&z(i[o+12>>2]+g(n,i[o+44>>2])|0,i[k+12>>2]+g(n,i[k+44>>2])|0,e),r=r+1|0,(f|0)!=(r|0););break r}if(n=g(r,l),f=g(l,f-r|0),r=g(f,e),r&&(e=g(e,n),z(e+i[o+8>>2]|0,e+i[k+8>>2]|0,r)),e=i[o+44>>2],r=g(e,f),!r)break r;e=g(e,n),z(e+i[o+12>>2]|0,e+i[k+12>>2]|0,r)}break i}U0(23976,19968,626,10125),M()}U0(23991,19968,627,10125),M()}i:{if(i[_+16892>>2]<=0)break i;for(k=1<<w,r=0;;){if(l=i[A+12>>2],f=i[l+52>>2],s=i[A+8>>2],e=p[((i[l+140>>2]+g(r,24)|0)+g(g(s,i[l+152>>2]),24)|0)+2>>1],e>>>0>=i[l+56>>2]-f>>2>>>0||(h=i[f+(e<<2)>>2],!h))break i;e:{if(!u[h+333|0])break e;if(e=i[A+20>>2],w=i[e+40>>2],n=i[e+4>>2],e=i[A+16>>2],f=i[e+40>>2],e=i[e+4>>2],i[i[l+124>>2]+16832>>2]>=9){We(l,r,s,0,k,k,e,f,n,w);break e}Ie(l,r,s,0,k,k,e,f,n,w)}e:{if(!u[h+334|0])break e;o=(k|0)/i[_+16856>>2]|0,l=(k|0)/i[_+16852>>2]|0,s=i[A+8>>2],e=i[A+20>>2],h=i[e+44>>2],w=i[e+8>>2],e=i[A+16>>2],n=i[e+44>>2],f=i[e+8>>2],e=i[A+12>>2];r:{if(i[i[e+124>>2]+16840>>2]>=9){We(e,r,s,1,l,o,f,n,w,h);break r}Ie(e,r,s,1,l,o,f,n,w,h)}if(s=i[A+8>>2],e=i[A+20>>2],h=i[e+44>>2],w=i[e+12>>2],e=i[A+16>>2],n=i[e+44>>2],f=i[e+12>>2],e=i[A+12>>2],i[i[e+124>>2]+16840>>2]>=9){We(e,r,s,2,l,o,f,n,w,h);break e}Ie(e,r,s,2,l,o,f,n,w,h)}if(r=r+1|0,!((r|0)<i[_+16892>>2]))break}}if(r=0,(B|0)>0)for(;e=(i[i[A+12>>2]+320>>2]+g(r,76)|0)+g(g(i[A+8>>2],i[_+16892>>2]),76)|0,i[e>>2]<4&&(i[e>>2]=4),r=r+1|0,(B|0)!=(r|0););i[A+4>>2]=3,ff(i[A+12>>2])}function Fn(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;k=v-96|0,v=k;i:{if(i[e+80>>2]==i[e+84>>2])break i;n=i[A+184>>2],o=i[A+188>>2];e:{if((n|0)==(o|0))break e;r:{for(;;){f:{if(s=i[n>>2],!s||(s=Z0(s,92792,92812),!s))break f;if(n=i[n+4>>2],n)break r;s=i[s+104>>2];break e}if(n=n+8|0,(o|0)==(n|0))break}s=0;break e}if(o=i[n+4>>2],l=o+1|0,i[n+4>>2]=l,s=i[s+104>>2],i[n+4>>2]=o,l)break e;W[i[i[n>>2]+8>>2]](n),y(n)}n=i[A+184>>2],o=i[A+188>>2];e:{if((n|0)==(o|0))break e;r:{for(;;){f:{if(h=i[n>>2],!h||(h=Z0(h,92792,92812),!h))break f;if(n=i[n+4>>2],n)break r;h=i[h+108>>2];break e}if(n=n+8|0,(o|0)==(n|0))break}h=0;break e}if(o=i[n+4>>2],l=o+1|0,i[n+4>>2]=l,h=i[h+108>>2],i[n+4>>2]=o,l)break e;W[i[i[n>>2]+8>>2]](n),y(n)}if(n=0,!f|!r|(!s|!h))break i;if(n=i[e+80>>2],_=i[e+84>>2],(n|0)!=(_|0))for(B=A+80|0,o=k+80|0;;){e=u[n+25|0]|u[n+26|0]<<8|(u[n+27|0]<<16|u[n+28|0]<<24),l=u[n+21|0]|u[n+22|0]<<8|(u[n+23|0]<<16|u[n+24|0]<<24),t[k+69|0]=l,t[k+70|0]=l>>>8,t[k+71|0]=l>>>16,t[k+72|0]=l>>>24,t[k+73|0]=e,t[k+74|0]=e>>>8,t[k+75|0]=e>>>16,t[k+76|0]=e>>>24,w=i[n+20>>2],l=k- -64|0,e=l,i[e>>2]=i[n+16>>2],i[e+4>>2]=w,e=i[n+12>>2],i[k+56>>2]=i[n+8>>2],i[k+60>>2]=e,e=i[n+4>>2],i[k+48>>2]=i[n>>2],i[k+52>>2]=e;e:{if(t[n+43|0]>=0){e=i[n+36>>2],i[o>>2]=i[n+32>>2],i[o+4>>2]=e,i[o+8>>2]=i[n+40>>2];break e}T(o,i[n+32>>2],i[n+36>>2])}e=i[A+92>>2],i[A+92>>2]=e+1,i[k+48>>2]=e,u[n+28|0]==1&&(e=i[n+20>>2],Y=k,E=O1(L0(i[n+24>>2],0,h,0),h0,f,0),i[Y+72>>2]=E,Y=k,E=O1(L0(e,0,s,0),h0,r,0),i[Y+68>>2]=E),e=u[k+73|0]|u[k+74|0]<<8|(u[k+75|0]<<16|u[k+76|0]<<24),w=u[k+69|0]|u[k+70|0]<<8|(u[k+71|0]<<16|u[k+72|0]<<24),t[k+21|0]=w,t[k+22|0]=w>>>8,t[k+23|0]=w>>>16,t[k+24|0]=w>>>24,t[k+25|0]=e,t[k+26|0]=e>>>8,t[k+27|0]=e>>>16,t[k+28|0]=e>>>24,e=i[l+4>>2],i[k+16>>2]=i[l>>2],i[k+20>>2]=e,e=i[k+60>>2],i[k+8>>2]=i[k+56>>2],i[k+12>>2]=e,e=i[k+52>>2],i[k>>2]=i[k+48>>2],i[k+4>>2]=e,i[k+40>>2]=i[o+8>>2],e=i[o+4>>2],i[k+32>>2]=i[o>>2],i[k+36>>2]=e,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,e=i[A+84>>2];e:{if(e>>>0<o0[A+88>>2]){w=i[k+56>>2],m=i[k+60>>2],G=i[l>>2],l=i[l+4>>2],I=i[k+72>>2],Q=i[k+48>>2],V=i[k+52>>2],t[e+28|0]=u[k+76|0],i[e+24>>2]=I,i[e+16>>2]=G,i[e+20>>2]=l,i[e+8>>2]=w,i[e+12>>2]=m,i[e>>2]=Q,i[e+4>>2]=V,i[e+40>>2]=i[k+40>>2],l=i[k+36>>2],i[e+32>>2]=i[k+32>>2],i[e+36>>2]=l,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[A+84>>2]=e+44;break e}if(e=U8(B,k),l=t[k+43|0],i[A+84>>2]=e,(l|0)>=0)break e;Z(i[k+32>>2])}if(t[k+91|0]<0&&Z(i[k+80>>2]),n=n+44|0,(_|0)==(n|0))break}n=1}return v=k+96|0,n}function gZ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0;if(n=v-80|0,v=n,i[n+52>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+64>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,t[n+40|0]=0,i[n+36>>2]=9e4,h=i[e>>2],l=l2(r),l>>>0<2147483640){o=f||n+36|0;i:{e:{if(l>>>0>=11){s=l|7,f=C(s+1|0),i[n+8>>2]=s-2147483647,i[n>>2]=f,i[n+4>>2]=l;break e}if(t[n+11|0]=l,f=n,!l)break i}if(!l)break i;z(f,r,l)}t[f+l|0]=0,l=v-16|0,v=l,$r(i[h+48>>2]),s=C(320),i[s>>2]=101248,i[s+4>>2]=0,i[s+8>>2]=0,r=s+16|0;i:{if(t[n+11|0]>=0){i[l+8>>2]=i[n+8>>2],f=i[n+4>>2],i[l>>2]=i[n>>2],i[l+4>>2]=f;break i}T(l,i[n>>2],i[n+4>>2])}f=v-16|0,v=f,_=I9(r,h,o,1835365473),i[_>>2]=113808,i[_+300>>2]=i[l+8>>2],r=i[l+4>>2],i[_+292>>2]=i[l>>2],i[_+296>>2]=r,i[l>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,r=C(120),i[r>>2]=100388,i[r+4>>2]=0,i[r+8>>2]=0,o=r+16|0,i[o+8>>2]=0,i[o+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,X[r+112>>1]=0,i[r+16>>2]=111736,i[r+116>>2]=1,i[r+32>>2]=1852663908,w=i[_+152>>2],i[f+12>>2]=r,i[f+8>>2]=o,i[r+4>>2]=i[r+4>>2]+1,P0(w+36|0,f+8|0),o=i[f+12>>2];i:{if(!o||(w=i[o+4>>2],i[o+4>>2]=w-1,w))break i;W[i[i[o>>2]+8>>2]](o),y(o)}o=i[r+4>>2],i[r+4>>2]=o-1,o||(W[i[i[r>>2]+8>>2]](r),y(r)),v=f+16|0,t[l+11|0]<0&&Z(i[l>>2]),i[s+4>>2]=i[s+4>>2]+1,w=i[s+40>>2];i:{e:{o=i[h+200>>2];r:{if(!o){f=h+200|0,r=f;break r}for(;;){if(r=o,f=i[r+16>>2],f>>>0>w>>>0){if(f=r,o=i[r>>2],o)continue;break r}if(f>>>0>=w>>>0)break e;if(o=i[r+4>>2],!o)break}f=r+4|0}o=C(28),i[o+24>>2]=s,i[o+20>>2]=_,i[o+16>>2]=w,i[o+8>>2]=r,i[o>>2]=0,i[o+4>>2]=0,i[f>>2]=o,r=i[i[h+196>>2]>>2],r&&(i[h+196>>2]=r),G1(i[h+200>>2],o),i[h+204>>2]=i[h+204>>2]+1;break i}if(r=i[s+4>>2],i[s+4>>2]=r-1,r)break i;W[i[i[s>>2]+8>>2]](s),y(s)}t[n+32|0]=0,i[n+16>>2]=s,i[n+12>>2]=_,v=l+16|0,t[n+11|0]<0&&Z(i[n>>2]);i:{e:switch(u[n+32|0]){default:e2(),M();case 1:c0(A,n+12|0,i[e>>2]);break i;case 0:break e}k&&(r=C(16),o=i[n+12>>2],f=i[n+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+4>>2]=f,i[r>>2]=o,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=e,i[r+8>>2]=f,i[k>>2]=r),e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}A=u[n+32|0],(A|0)!=255&&(e=i[25823],i[n+72>>2]=i[25822],i[n+76>>2]=e,W[i[(n+72|0)+(A<<2)>>2]](n+71|0,n+12|0)),a2(i[n+48>>2]),t[n+67|0]<0&&Z(i[n+56>>2]),v=n+80|0;return}I0(),M()}function Cn(A,e,r,f,k,n){var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;w=v-16|0,v=w,s=i[r>>2],f=(f|0)==99?i[s+196>>2]:f,l=i[s+196>>2],I=l,m=i[s+200>>2];i:{e:switch(l|0){case 2:if(l=i[s+204>>2],o=i[s+208>>2],(l|0)==(o|0))break i;for(;;){if(i[l>>2]){if(l=l+56|0,(o|0)!=(l|0))continue;break i}break}B=p[l+20>>1];break i;case 0:l=i[s+204>>2],_=i[s+208>>2];r:{if((l|0)==(_|0))break r;o=l;f:{A:{for(;;){if(!i[o>>2])break A;if(o=o+56|0,(_|0)==(o|0))break}h=0;break f}h=p[o+20>>1]}o=l;f:{A:{for(;;){if(i[o>>2]==1)break A;if(o=o+56|0,(_|0)==(o|0))break}o=0;break f}o=p[o+20>>1]}for(;;){if(i[l>>2]!=2){if(l=l+56|0,(_|0)!=(l|0))continue;break r}break}B=p[l+20>>1]}o=o&65535,l=B&65535,o=o>>>0>l>>>0?o:l,B=o>>>0<h>>>0?h:o;break i;case 1:if(_=i[s+208>>2],l=i[s+204>>2],i[s+200>>2]==3){r:{if((l|0)==(_|0))break r;o=l;f:{A:{for(;;){if(i[o>>2]==3)break A;if(o=o+56|0,(_|0)==(o|0))break}h=0;break f}h=p[o+20>>1]}o=l;f:{A:{for(;;){if(i[o>>2]==4)break A;if(o=o+56|0,(_|0)==(o|0))break}o=0;break f}o=p[o+20>>1]}for(;;){if(i[l>>2]!=5){if(l=l+56|0,(_|0)!=(l|0))continue;break r}break}B=p[l+20>>1]}o=o&65535,l=B&65535,o=o>>>0>l>>>0?o:l,B=o>>>0<h>>>0?h:o;break i}if((l|0)==(_|0))break i;for(;;){if(i[l>>2]!=10){if(l=l+56|0,(_|0)!=(l|0))continue;break i}break}B=p[l+20>>1];break i;case 4:break e;default:break i}if(l=i[s+204>>2],o=i[s+208>>2],(l|0)==(o|0))break i;for(;;){if(i[l>>2]!=11){if(l=l+56|0,(o|0)!=(l|0))continue;break i}break}B=p[l+20>>1]}_=u[n+20|0],o=w+8|0;i:{e:{if(!(p[s+6>>1]!=2|p[s+8>>1]!=2|p[s+10>>1]!=2)&&u[s+12|0])break e;l=p[s+10>>1]|p[s+12>>1]<<16,h=p[s+6>>1]|p[s+8>>1]<<16,X[o>>1]=h,X[o+2>>1]=h>>>16,X[o+4>>1]=l,X[o+6>>1]=l>>>16;break i}t[o+6|0]=1,X[o+4>>1]=2,X[o>>1]=2,X[o+2>>1]=2,t[o+6|0]=1,X[o+4>>1]=6,X[o>>1]=1,X[o+2>>1]=13}l=i[w+8>>2],o=i[w+12>>2],h=i[n+56>>2],h||(h=Af(),G=h);i:{if(!(i[h+4>>2]!=(l&65535)|i[h+8>>2]!=(l>>>16|0)|i[h+12>>2]!=(o&65535))&&(l=0,u[h+16|0]==(o>>>16&255)))break i;l=1}G&&a2(G);i:{e:{r:{f:{if(h=(_|0)!=0&(B&65535)>>>0>8,o=(k|0)==99?m:k,!((l|(h|((o|0)!=(m|0)|(f|0)!=(I|0))))&1)&&(!H5(s)||(k=i[n+48>>2],!k|!i[k+4>>2])))break f;if(t[w+6|0]=1,X[w+4>>1]=2,X[w>>1]=2,X[w+2>>1]=2,k=i[n+56>>2],!k)break r;X[w+4>>1]=i[k+12>>2],X[w>>1]=i[k+4>>2],t[w+6|0]=u[k+16|0]!=0;break e}e=i[r+4>>2],t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=s;break i}t[w+6|0]=1,X[w+4>>1]=6,X[w>>1]=1,X[w+2>>1]=13}if(G6(A,r,f,o,w,h?8:0,n+28|0,i[n+48>>2],e- -64|0),A=i[r+4>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=w+16|0}function GZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;o=v-32|0,v=o,A=i[A>>2],k=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),n=i[k+96>>2],h=i[k+100>>2],h&&(i[h+4>>2]=i[h+4>>2]+1);i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}i:{if(!n){i[f>>2]=0;break i}k=0,i[o+28>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0;e:{r:{f:{if(A=i[n+36>>2],w=i[n+40>>2],(A|0)!=(w|0)){if(k=w-A|0,(k|0)<0)break f;for(n=C(k),i[o+20>>2]=n,i[o+28>>2]=k+n,k=n;i[k>>2]=i[A>>2],s=k,k=i[A+4>>2],i[s+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),k=s+8|0,A=A+8|0,(w|0)!=(A|0););for(i[o+24>>2]=k,i[o+16>>2]=0,i[o+8>>2]=0,i[o+12>>2]=0;;){A=i[n>>2];A:{k:{if(e){if(i[A+16>>2]==(e|0))break k;break A}if(!A)break A}if(k=Z0(A,92792,94584),!k)break A;i[o>>2]=k,A=i[n+4>>2],i[o+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1);k:{n:{if(!r)break n;if(A=i[k+108>>2],k=i[k+112>>2],(A|0)==(k|0))break k;for(;;){if(i[A>>2]==(r|0))break n;if(A=A+4|0,(k|0)==(A|0))break}break k}No(o+8|0,o)}if(A=i[o+4>>2],!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break A;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=(n|0)==(s|0),n=n+8|0,!!A)break}break r}i[f>>2]=0;break e}s0(),M()}_=i[o+12>>2],s=i[o+8>>2],A=_-s|0,w=A>>3,G=C(w>>>0>268435455?-1:A<<1);r:{f:{if((s|0)!=(_|0)){for(Q=w>>>0<=1?1:w;;){e=(m<<4)+G|0,A=i[s+(m<<3)>>2],i[e>>2]=i[A+104>>2],i[e+4>>2]=i[A+16>>2],n=i[A+108>>2],r=i[A+112>>2];A:{if((n|0)==(r|0)){k=0,A=n;break A}r=r-n|0,k=C((r|0)<0?-1:r),n=i[A+108>>2],A=i[A+112>>2]}i[e+8>>2]=k,r=e,e=A-n>>2,i[r+12>>2]=e;A:{if(!k|(A|0)==(n|0))break A;if(l=e>>>0<=1?1:e,I=l&3,r=0,A=0,e>>>0>=4)for(V=l&-4,e=0;l=A<<2,i[l+k>>2]=i[n+l>>2],B=l|4,i[B+k>>2]=i[n+B>>2],B=l|8,i[B+k>>2]=i[n+B>>2],l=l|12,i[l+k>>2]=i[n+l>>2],A=A+4|0,e=e+4|0,(V|0)!=(e|0););if(!I)break A;for(;e=A<<2,i[e+k>>2]=i[e+n>>2],A=A+1|0,r=r+1|0,(I|0)!=(r|0););}if(m=m+1|0,(Q|0)==(m|0))break}for(i[f>>2]=w;;){A=i[_-4>>2];A:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break A;W[i[i[A>>2]+8>>2]](A),y(A)}if(_=_-8|0,(s|0)==(_|0))break}A=i[o+8>>2];break f}if(i[f>>2]=w,A=s,!A)break r}i[o+12>>2]=s,Z(A)}k=i[o+20>>2]}if(!k)break i;if(A=i[o+24>>2],n=k,(A|0)!=(k|0)){for(;;){e=i[A-4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(k|0)==(A|0))break}n=i[o+20>>2]}i[o+24>>2]=k,Z(n)}i:{if(!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break i;W[i[i[h>>2]+8>>2]](h),y(h)}return v=o+32|0,G|0}function WZ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;s=v-32|0,v=s,h=s+12|0,B=i[e>>2],m=r,r=0,o=v-16|0,v=o;i:{if(k>>>0<5)break i;for(n=k-4|0;;){if(l=r+f|0,w=u[l+1|0]<<8,_=u[l+2|0]<<16|u[l+3|0]<<24,(u[l|0]|w|_)==704662861|(_|(w|u[l|0]))==2771273)break i;if(r=r+1|0,(n|0)==(r|0))break}r=n}i:{e:{r:{if(r>>>0>=k>>>0){if(r=C(64),i[o+4>>2]=r,i[o+8>>2]=56,i[o+12>>2]=-2147483584,f=u[28958]|u[28959]<<8|(u[28960]<<16|u[28961]<<24),k=u[28954]|u[28955]<<8|(u[28956]<<16|u[28957]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+56|0]=0,f=u[29006]|u[29007]<<8|(u[29008]<<16|u[29009]<<24),k=u[29002]|u[29003]<<8|(u[29004]<<16|u[29005]<<24),t[r+48|0]=k,t[r+49|0]=k>>>8,t[r+50|0]=k>>>16,t[r+51|0]=k>>>24,t[r+52|0]=f,t[r+53|0]=f>>>8,t[r+54|0]=f>>>16,t[r+55|0]=f>>>24,f=u[28998]|u[28999]<<8|(u[29e3]<<16|u[29001]<<24),k=u[28994]|u[28995]<<8|(u[28996]<<16|u[28997]<<24),t[r+40|0]=k,t[r+41|0]=k>>>8,t[r+42|0]=k>>>16,t[r+43|0]=k>>>24,t[r+44|0]=f,t[r+45|0]=f>>>8,t[r+46|0]=f>>>16,t[r+47|0]=f>>>24,f=u[28990]|u[28991]<<8|(u[28992]<<16|u[28993]<<24),k=u[28986]|u[28987]<<8|(u[28988]<<16|u[28989]<<24),t[r+32|0]=k,t[r+33|0]=k>>>8,t[r+34|0]=k>>>16,t[r+35|0]=k>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[28982]|u[28983]<<8|(u[28984]<<16|u[28985]<<24),k=u[28978]|u[28979]<<8|(u[28980]<<16|u[28981]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[28974]|u[28975]<<8|(u[28976]<<16|u[28977]<<24),k=u[28970]|u[28971]<<8|(u[28972]<<16|u[28973]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[28966]|u[28967]<<8|(u[28968]<<16|u[28969]<<24),k=u[28962]|u[28963]<<8|(u[28964]<<16|u[28965]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(h,5,2006,o+4|0),t[o+15|0]>=0)break r;Z(i[o+4>>2]);break r}i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,l=k+4|0;f:{if(!l){n=0;break f}if((k|0)<=-5)break e;n=C(l),l&&l0(n,0,l),G=n+l|0}r=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),t[n|0]=r,t[n+1|0]=r>>>8,t[n+2|0]=r>>>16,t[n+3|0]=r>>>24,k&&z(n+4|0,f,k),Fe(h,B,m,n,G-n|0,1165519206,0,0,0),Z(n)}v=o+16|0;break i}s0(),M()}i:{if(i[s+12>>2]!=i[28728]){c0(A,h,i[e>>2]);break i}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}t[s+31|0]<0&&Z(i[s+20>>2]),v=s+32|0}function XZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;if(f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=78468,k=i[19620],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19621],k=i[i[f>>2]-12>>2]+f|0,n=f+4|0,J0(k,n),t[k+80|0]=0,i[k+72>>2]=0,i[f+56>>2]=78468,i[f>>2]=78448,B=R0(n),i[B>>2]=77200,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,k=f+148|0,J2(k,e,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),s=i[e+104>>2],m=i[e+108>>2],(s|0)!=(m|0))for(;;){e=f+148|0,k0(e,r),o=e,e=t[f+159|0],k=(e|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),e=F(f,30782,21),k=f+148|0,Ce(k,s),o=e,n=k,e=t[f+159|0],k=(e|0)<0,F(B0(F(F(F(o,k?i[f+148>>2]:n,k?i[f+152>>2]:e),30823,1),37580,10),i[s+40>>2]),34132,9),t[f+159|0]<0&&Z(i[f+148>>2]);i:{if(e=i[s+44>>2],G=i[s+48>>2],(e|0)==(G|0))break i;for(;;){e:{w=B0(f,i[e>>2]),I=X1(f+140|0,w);r:{if(u[I|0]!=1)break r;n=i[i[w>>2]-12>>2]+w|0,_=i[n+4>>2],h=i[n+24>>2];f:{if(u[n+80|0]==1){k=u[n+76|0]|u[n+77|0]<<8|(u[n+78|0]<<16|u[n+79|0]<<24);break f}o=f+148|0,k=i[n+28>>2],i[o>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(o,137008),k=W[i[i[k>>2]+28>>2]](k,32)|0,i2(o),t[n+76|0]=k,t[n+77|0]=k>>>8,t[n+78|0]=k>>>16,t[n+79|0]=k>>>24,t[n+80|0]=1}f:{if(!h||(l=i[n+12>>2],_=(_&176)==32?37887:37886,o=_-37886|0,(o|0)>0&&(W[i[i[h>>2]+48>>2]](h,37886,o)|0)!=(o|0)))break f;if((l|0)>=2){if(l>>>0>=2147483641)break e;o=((l|0)<=1?1:l)-1|0;A:{if(l>>>0>=12){Q=o|7,l=C(Q+1|0),i[f+156>>2]=Q-2147483647,i[f+148>>2]=l,i[f+152>>2]=o;break A}t[f+159|0]=o,l=f+148|0}if(o&&l0(l,k,o),t[o+l|0]=0,k=W[i[i[h>>2]+48>>2]](h,t[f+159|0]<0?i[f+148>>2]:f+148|0,o)|0,t[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(o|0))break f}if(k=37887-_|0,(k|0)>0&&(W[i[i[h>>2]+48>>2]](h,_,k)|0)!=(k|0))break f;i[n+12>>2]=0;break r}k=i[i[w>>2]-12>>2]+w|0,M1(k,i[k+16>>2]|5)}if(v1(I),e=e+4|0,(G|0)!=(e|0))continue;break i}break}I0(),M()}if(F(f,47878,1),s=s+56|0,(m|0)==(s|0))break}e=i[f+52>>2];i:{e:{if(e&16){e=i[f+48>>2],r=i[f+28>>2],e>>>0<r>>>0&&(i[f+48>>2]=r,e=r),r=f+24|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+20>>2],r=f+12|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19622],i[B>>2]=77200,t[f+47|0]<0&&Z(i[f+36>>2]),y0(B),Y0(f+56|0),v=f+160|0}function IZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;k=v-32|0,v=k,l=zr()|0;i:{if(!e){i[A+4>>2]=l,i[A>>2]=132616;break i}NA(k+4|0,e,k+16|0,r,f,0);e:{if(!i[k+4>>2]){r=B8(16513)|0,i[k+24>>2]=i[k+16>>2],f=T1(102880,k+24|0)|0,q4(l|0,r|0,f|0),f>>>0>=9&&g1(f|0),r>>>0>=9&&g1(r|0),f=0;r:{if(!e||(r=i[e>>2],!r))break r;r=i[r+200>>2],f=(r|0)>0?r:0}r=B8(11855)|0,i[k+24>>2]=f,f=T1(91512,k+24|0)|0,q4(l|0,r|0,f|0),f>>>0>=9&&g1(f|0),r>>>0>=9&&g1(r|0),r=0;r:{if(!e||(e=i[e>>2],!e))break r;e=i[e+204>>2],r=(e|0)>0?e:0}for(e=B8(4394)|0,i[k+24>>2]=r,f=T1(91512,k+24|0)|0,q4(l|0,e|0,f|0),f>>>0>=9&&g1(f|0),e>>>0>=9&&g1(e|0),f=i[i[i[k+16>>2]>>2]+200>>2],e=B8(20652)|0,i[k+24>>2]=f,f=T1(102872,k+24|0)|0,q4(l|0,e|0,f|0),f>>>0>=9&&g1(f|0),e>>>0>=9&&g1(e|0),f=i[i[i[k+16>>2]>>2]+196>>2],e=B8(17035)|0,i[k+24>>2]=f,f=T1(102864,k+24|0)|0,q4(l|0,e|0,f|0),f>>>0>=9&&g1(f|0),e>>>0>=9&&g1(e|0),e=r,h=C(32),r=h,f=i[14296],i[r>>2]=i[14295],i[r+4>>2]=f,r=i[14302],i[h+24>>2]=i[14301],i[h+28>>2]=r,r=i[14300],i[h+16>>2]=i[14299],i[h+20>>2]=r,r=i[14298],i[h+8>>2]=i[14297],i[h+12>>2]=r,w=df()|0,r=0;;){f=i[r+h>>2];r:{if(!I7(i[k+16>>2],f))break r;s=zr()|0,n=B8(17482)|0,i[k+24>>2]=f,o=T1(102904,k+24|0)|0,q4(s|0,n|0,o|0),o>>>0>=9&&g1(o|0),n>>>0>=9&&g1(n|0),_=Ki(i[k+16>>2],f,k),n=B8(16702)|0,i[k+24>>2]=i[k>>2],o=T1(91548,k+24|0)|0,q4(s|0,n|0,o|0),o>>>0>=9&&g1(o|0),n>>>0>=9&&g1(n|0),n=i[k>>2],i[k+28>>2]=_,i[k+24>>2]=g(e,n),n=T1(102912,k+24|0)|0,o=B8(20617)|0,q4(s|0,o|0,n|0),o>>>0>=9&&g1(o|0),n>>>0>=9&&g1(n|0),o=Wh(i[k+16>>2],f),n=B8(11855)|0,i[k+24>>2]=o,o=T1(91512,k+24|0)|0,q4(s|0,n|0,o|0),o>>>0>=9&&g1(o|0),n>>>0>=9&&g1(n|0),o=Xh(i[k+16>>2],f),n=B8(4394)|0,i[k+24>>2]=o,o=T1(91512,k+24|0)|0,q4(s|0,n|0,o|0),o>>>0>=9&&g1(o|0),n>>>0>=9&&g1(n|0),n=yh(i[k+16>>2],f),f=B8(10740)|0,i[k+24>>2]=n,n=T1(91512,k+24|0)|0,q4(s|0,f|0,n|0),n>>>0>=9&&g1(n|0),f>>>0>=9&&g1(f|0),n=s>>>0<9,n||kv(s|0),i[k+24>>2]=s,i[k+20>>2]=0;f:{if(t[115036]&1){f=i[28758];break f}f=Av(2,102920,0)|0,t[115036]=1,i[28758]=f}if(+fv(f|0,w|0,11861,k+20|0,k+24|0),f=i[k+20>>2],f&&rv(f|0),n)break r;g1(s|0)}if(r=r+4|0,(r|0)==32)break}break e}if(e=C(12),i[e+8>>2]=i[k+12>>2],r=i[k+8>>2],i[e>>2]=i[k+4>>2],i[e+4>>2]=r,i[k+24>>2]=e,B=A,m=T1(102748,k+24|0)|0,i[B+4>>2]=m,i[A>>2]=132616,l>>>0<9)break i;g1(l|0);break i}e=B8(5611)|0,q4(l|0,e|0,w|0),e>>>0>=9&&g1(e|0),i[A+4>>2]=l,i[A>>2]=132616,w>>>0>=9&&g1(w|0),Z(h)}v=k+32|0}function QZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;if(f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=78468,k=i[19620],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19621],k=i[i[f>>2]-12>>2]+f|0,n=f+4|0,J0(k,n),t[k+80|0]=0,i[k+72>>2]=0,i[f+56>>2]=78468,i[f>>2]=78448,B=R0(n),i[B>>2]=77200,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,k=f+148|0,J2(k,e,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),s=i[e+100>>2],m=i[e+104>>2],(s|0)!=(m|0))for(;;){e=f+148|0,k0(e,r),o=e,e=t[f+159|0],k=(e|0)<0,F(f,k?i[f+148>>2]:o,k?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),e=F(f,30782,21),k=f+148|0,z1(k,i[s>>2]),o=e,n=k,e=t[f+159|0],k=(e|0)<0,F(F(F(o,k?i[f+148>>2]:n,k?i[f+152>>2]:e),30823,1),34142,15),t[f+159|0]<0&&Z(i[f+148>>2]);i:{if(e=i[s+4>>2],G=i[s+8>>2],(e|0)==(G|0))break i;for(;;){e:{w=B0(f,i[e>>2]),I=X1(f+140|0,w);r:{if(u[I|0]!=1)break r;n=i[i[w>>2]-12>>2]+w|0,_=i[n+4>>2],h=i[n+24>>2];f:{if(u[n+80|0]==1){k=u[n+76|0]|u[n+77|0]<<8|(u[n+78|0]<<16|u[n+79|0]<<24);break f}o=f+148|0,k=i[n+28>>2],i[o>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(o,137008),k=W[i[i[k>>2]+28>>2]](k,32)|0,i2(o),t[n+76|0]=k,t[n+77|0]=k>>>8,t[n+78|0]=k>>>16,t[n+79|0]=k>>>24,t[n+80|0]=1}f:{if(!h||(l=i[n+12>>2],_=(_&176)==32?37887:37886,o=_-37886|0,(o|0)>0&&(W[i[i[h>>2]+48>>2]](h,37886,o)|0)!=(o|0)))break f;if((l|0)>=2){if(l>>>0>=2147483641)break e;o=((l|0)<=1?1:l)-1|0;A:{if(l>>>0>=12){Q=o|7,l=C(Q+1|0),i[f+156>>2]=Q-2147483647,i[f+148>>2]=l,i[f+152>>2]=o;break A}t[f+159|0]=o,l=f+148|0}if(o&&l0(l,k,o),t[o+l|0]=0,k=W[i[i[h>>2]+48>>2]](h,t[f+159|0]<0?i[f+148>>2]:f+148|0,o)|0,t[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(o|0))break f}if(k=37887-_|0,(k|0)>0&&(W[i[i[h>>2]+48>>2]](h,_,k)|0)!=(k|0))break f;i[n+12>>2]=0;break r}k=i[i[w>>2]-12>>2]+w|0,M1(k,i[k+16>>2]|5)}if(v1(I),e=e+4|0,(G|0)!=(e|0))continue;break i}break}I0(),M()}if(F(f,47878,1),s=s+16|0,(m|0)==(s|0))break}e=i[f+52>>2];i:{e:{if(e&16){e=i[f+48>>2],r=i[f+28>>2],e>>>0<r>>>0&&(i[f+48>>2]=r,e=r),r=f+24|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+20>>2],r=f+12|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19622],i[B>>2]=77200,t[f+47|0]<0&&Z(i[f+36>>2]),y0(B),Y0(f+56|0),v=f+160|0}function VZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]),k=u[e+97|0];i:{if(k>>>0>=2){B1(A,e,17485);break i}e:{if((k|0)==1){s=e,h=S4(r),i[s+104>>2]=h,i[e+108>>2]=h0,s=e,h=S4(r),i[s+112>>2]=h,i[e+116>>2]=h0,s=e,h=F0(r),i[s+120>>2]=h,k=S4(r),n=h0;break e}s=e,h=F0(r),i[s+104>>2]=h,i[e+108>>2]=0,s=e,h=F0(r),i[s+112>>2]=h,i[e+116>>2]=0,s=e,h=F0(r),i[s+120>>2]=h,k=F0(r),n=0}if(i[e+128>>2]=k,i[e+132>>2]=n,s=e,h=F0(r),i[s+136>>2]=h,s=e,h=w2(r),X[s+140>>1]=h,k=i[r+16>>2],n=k>>>0>=2?2:k,k=i[r+8>>2],k&&l4(k,n),o=i[r>>2],l=W[i[i[o>>2]+8>>2]](o)|0,k=h0,l=n+l|0,k=l>>>0<n>>>0?k+1|0:k,W[i[i[o>>2]+20>>2]](o,l,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=8?8:k,k=i[r+8>>2],k&&l4(k,n),o=i[r>>2],l=W[i[i[o>>2]+8>>2]](o)|0,k=h0,l=n+l|0,k=l>>>0<n>>>0?k+1|0:k,W[i[i[o>>2]+20>>2]](o,l,k)|0,i[r+16>>2]=i[r+16>>2]-n,s=e,h=F0(r),i[s+144>>2]=h,s=e,h=F0(r),i[s+148>>2]=h,s=e,h=F0(r),i[s+152>>2]=h,s=e,h=F0(r),i[s+156>>2]=h,s=e,h=F0(r),i[s+160>>2]=h,s=e,h=F0(r),i[s+164>>2]=h,s=e,h=F0(r),i[s+168>>2]=h,s=e,h=F0(r),i[s+172>>2]=h,s=e,h=F0(r),i[s+176>>2]=h,k=i[r+16>>2],n=k>>>0>=4?4:k,k=i[r+8>>2],k&&l4(k,n),o=i[r>>2],l=W[i[i[o>>2]+8>>2]](o)|0,k=h0,l=n+l|0,k=l>>>0<n>>>0?k+1|0:k,W[i[i[o>>2]+20>>2]](o,l,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&l4(k,n),o=i[r>>2],l=W[i[i[o>>2]+8>>2]](o)|0,k=h0,l=n+l|0,k=l>>>0<n>>>0?k+1|0:k,W[i[i[o>>2]+20>>2]](o,l,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&l4(k,n),o=i[r>>2],l=W[i[i[o>>2]+8>>2]](o)|0,k=h0,l=n+l|0,k=l>>>0<n>>>0?k+1|0:k,W[i[i[o>>2]+20>>2]](o,l,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&l4(k,n),o=i[r>>2],l=W[i[i[o>>2]+8>>2]](o)|0,k=h0,l=n+l|0,k=l>>>0<n>>>0?k+1|0:k,W[i[i[o>>2]+20>>2]](o,l,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&l4(k,n),o=i[r>>2],l=W[i[i[o>>2]+8>>2]](o)|0,k=h0,l=n+l|0,k=l>>>0<n>>>0?k+1|0:k,W[i[i[o>>2]+20>>2]](o,l,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&l4(k,n),o=i[r>>2],l=W[i[i[o>>2]+8>>2]](o)|0,k=h0,l=n+l|0,k=l>>>0<n>>>0?k+1|0:k,W[i[i[o>>2]+20>>2]](o,l,k)|0,i[r+16>>2]=i[r+16>>2]-n,s=e,h=F0(r),i[s+180>>2]=h,u[r+20|0]){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Kr(A,e,r){var f=0,k=0;f=v-656|0,v=f,e=e?10950:7463,u[A|0]&&(i[f+644>>2]=t[A+1|0],i[f+640>>2]=e,n0(r,43244,f+640|0),i[f+628>>2]=t[A+2|0],i[f+624>>2]=e,n0(r,44478,f+624|0),k=i[A+4>>2]-1|0,k>>>0<=3?k=i[(k<<2)+69848>>2]:k=29589,i[f+612>>2]=k,i[f+608>>2]=e,n0(r,38120,f+608|0),i[f+592>>2]=e,n0(r,33810,f+592|0),i[f+576>>2]=t[A+8|0],n0(r,19591,f+576|0),n0(r,29396,0),i[f+560>>2]=t[A+9|0],n0(r,19591,f+560|0),n0(r,29396,0),i[f+544>>2]=t[A+10|0],n0(r,19591,f+544|0),n0(r,29396,0),i[f+528>>2]=t[A+11|0],n0(r,19591,f+528|0),n0(r,29396,0),i[f+512>>2]=t[A+12|0],n0(r,19591,f+512|0),n0(r,29396,0),i[f+496>>2]=t[A+13|0],n0(r,19591,f+496|0),n0(r,29396,0),i[f+480>>2]=t[A+14|0],n0(r,19591,f+480|0),n0(r,29396,0),i[f+464>>2]=t[A+15|0],n0(r,19591,f+464|0),n0(r,29396,0),i[f+448>>2]=t[A+16|0],n0(r,19591,f+448|0),n0(r,29396,0),i[f+432>>2]=t[A+17|0],n0(r,19591,f+432|0),n0(r,29396,0),i[f+416>>2]=t[A+18|0],n0(r,19591,f+416|0),n0(r,29396,0),i[f+400>>2]=t[A+19|0],n0(r,19591,f+400|0),n0(r,29396,0),i[f+384>>2]=t[A+20|0],n0(r,19591,f+384|0),n0(r,29396,0),i[f+368>>2]=t[A+21|0],n0(r,19591,f+368|0),n0(r,29396,0),i[f+352>>2]=t[A+22|0],n0(r,19591,f+352|0),n0(r,29396,0),i[f+336>>2]=t[A+23|0],n0(r,19591,f+336|0),n0(r,29396,0),i[f+320>>2]=t[A+24|0],n0(r,19591,f+320|0),n0(r,29396,0),i[f+304>>2]=t[A+25|0],n0(r,19591,f+304|0),n0(r,29396,0),i[f+288>>2]=t[A+26|0],n0(r,19591,f+288|0),n0(r,29396,0),i[f+272>>2]=t[A+27|0],n0(r,19591,f+272|0),n0(r,29396,0),i[f+256>>2]=t[A+28|0],n0(r,19591,f+256|0),n0(r,29396,0),i[f+240>>2]=t[A+29|0],n0(r,19591,f+240|0),n0(r,29396,0),i[f+224>>2]=t[A+30|0],n0(r,19591,f+224|0),n0(r,29396,0),i[f+208>>2]=t[A+31|0],n0(r,19591,f+208|0),n0(r,29396,0),i[f+192>>2]=t[A+32|0],n0(r,19591,f+192|0),n0(r,29396,0),i[f+176>>2]=t[A+33|0],n0(r,19591,f+176|0),n0(r,29396,0),i[f+160>>2]=t[A+34|0],n0(r,19591,f+160|0),n0(r,29396,0),i[f+144>>2]=t[A+35|0],n0(r,19591,f+144|0),n0(r,29396,0),i[f+128>>2]=t[A+36|0],n0(r,19591,f+128|0),n0(r,29396,0),i[f+112>>2]=t[A+37|0],n0(r,19591,f+112|0),n0(r,29396,0),i[f+96>>2]=t[A+38|0],n0(r,19591,f+96|0),n0(r,29396,0),i[f+80>>2]=t[A+39|0],n0(r,19591,f+80|0),n0(r,47531,0),i[f+68>>2]=t[A+40|0],i[f+64>>2]=e,n0(r,40847,f- -64|0),i[f+52>>2]=t[A+41|0],i[f+48>>2]=e,n0(r,40884,f+48|0),i[f+36>>2]=t[A+42|0],i[f+32>>2]=e,n0(r,40011,f+32|0),i[f+20>>2]=t[A+43|0],i[f+16>>2]=e,n0(r,39971,f+16|0)),u[A+44|0]&&(A=i[A+48>>2],i[f+4>>2]=A,i[f>>2]=e,u0[f+8>>3]=D(D(A|0)/D(30)),n0(r,47645,f)),v=f+656|0}function Yn(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;i:{if(i[A+64>>2])break i;f=3339;e:{r:{f:{A:{k:{n:{t:{o:{l:{u:{s:{h:{w:{_:{v:{B:{m:{g:switch(o=r&-3,o-1|0){case 0:case 16:break m;case 23:break v;case 27:break l;case 1:case 2:case 3:case 5:case 6:case 9:case 10:case 13:case 14:case 17:case 18:case 21:case 22:case 25:case 26:break r;case 15:break e;case 4:case 20:break s;case 7:break B;case 8:case 24:break w;case 11:break u;case 12:case 28:break t;case 19:break h;default:break g}g:switch(o-48|0){case 1:case 2:case 3:break r;case 0:break e;case 4:break h;default:break g}g:switch(o-56|0){case 0:break _;case 4:break o;case 1:case 2:case 3:break r;default:break g}g:switch(o-80|0){case 0:break n;case 4:break A;case 1:case 2:case 3:break r;default:break g}g:switch(o-112|0){case 0:break n;case 4:break A;case 1:case 2:case 3:break r;default:break g}switch(o-120|0){case 0:break k;case 4:break f;default:break r}}f=20804;break e}f=8435;break e}f=29402;break e}f=29399;break e}f=29405;break e}f=20021;break e}f=20045;break e}f=20024;break e}f=20068;break e}f=20064;break e}f=20072;break e}f=1795;break e}f=3177;break e}f=3132;break e}f=3136;break e}f=0}if(o=f,!f)break i;l=v-16|0,v=l;e:{r:{if(!ke(20076,t[f|0])){i[33136]=28;break r}if(k=2,ke(o,43)||(k=u[o|0]!=114),f=ke(o,120)?k|128:k,f=ke(o,101)?f|524288:f,k=f,s=f|64,f=u[o|0],k=(f|0)==114?k:s,k=(f|0)==119?k|512:k,i[l>>2]=438,i[l+4>>2]=0,k=KB(-100,e|0,((f|0)==97?k|1024:k)|32768,l|0)|0,k>>>0>=4294963201&&(i[33136]=0-k,k=-1),(k|0)<0)break e;n=v-32|0,v=n;f:{A:{k:{if(!ke(20076,t[o|0])){i[33136]=28;break k}if(f=E2(1176),f)break A}e=0;break f}Ni(f,0,144),ke(o,43)||(i[f>>2]=u[o|0]==114?8:4);A:{if(u[o|0]!=97){e=i[f>>2];break A}e=m9(k|0,3,0)|0,e&1024||(e=e|1024,i[n+16>>2]=e,i[n+20>>2]=e>>31,m9(k|0,4,n+16|0)|0),e=i[f>>2]|128,i[f>>2]=e}i[f+80>>2]=-1,i[f+48>>2]=1024,i[f+60>>2]=k,i[f+44>>2]=f+152;A:{if(e&8||(i[n>>2]=n+24,i[n+4>>2]=0,PB(k|0,21523,n|0)|0))break A;i[f+80>>2]=10}i[f+40>>2]=2001,i[f+36>>2]=2e3,i[f+32>>2]=2007,i[f+12>>2]=1999,u[132561]||(i[f+76>>2]=-1),e=i[33139],i[f+56>>2]=e,e&&(i[e+52>>2]=f),i[33139]=f,e=f}if(v=n+32|0,n=e,n)break e;Z9(k|0)|0}n=0}v=l+16|0,i[A+64>>2]=n,e=0;e:{if(!n)break e;i[A+88>>2]=r,i[A+92>>2]==34&&(i[n+80>>2]=-1,i[n+48>>2]=0,i[n>>2]=i[n>>2]|64,i[A+92>>2]=0);r:{if(!(r&2)||(i[A+92>>2]=0,!lf(i[A+64>>2],0,0,2)))break r;z5(i[A+64>>2]),i[A+64>>2]=0,e=0;break e}e=A}k=e}return k}function pZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;n=v-16|0,v=n,h=i[r+4>>2],o=i[k>>2],s=i[r>>2],r=o+s|0;i:{if(h-r>>>0<(f|0)/8<<2>>>0){if(e=C(56),i[n+4>>2]=e,i[n+8>>2]=48,i[n+12>>2]=-2147483592,r=u[9860]|u[9861]<<8|(u[9862]<<16|u[9863]<<24),f=u[9856]|u[9857]<<8|(u[9858]<<16|u[9859]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+48|0]=0,r=u[9900]|u[9901]<<8|(u[9902]<<16|u[9903]<<24),f=u[9896]|u[9897]<<8|(u[9898]<<16|u[9899]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[9892]|u[9893]<<8|(u[9894]<<16|u[9895]<<24),f=u[9888]|u[9889]<<8|(u[9890]<<16|u[9891]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[9884]|u[9885]<<8|(u[9886]<<16|u[9887]<<24),f=u[9880]|u[9881]<<8|(u[9882]<<16|u[9883]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[9876]|u[9877]<<8|(u[9878]<<16|u[9879]<<24),f=u[9872]|u[9873]<<8|(u[9874]<<16|u[9875]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[9868]|u[9869]<<8|(u[9870]<<16|u[9871]<<24),f=u[9864]|u[9865]<<8|(u[9866]<<16|u[9867]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,136,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}l=u[r|0],h=u[r+1|0];e:{if((f|0)==32){w=u[r+3|0],r=u[r+2|0],i[k>>2]=o+4,i[e+4>>2]=h<<16|l<<24|r<<8|w,o=i[k>>2],r=o+s|0,r=u[r|0]|u[r+1|0]<<8|(u[r+2|0]<<16|u[r+3|0]<<24),i[k>>2]=o+4,i[e+8>>2]=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),r=i[k>>2],o=s+r|0,l=u[o+1|0]<<16|u[o|0]<<24|u[o+2|0]<<8,o=o+3|0,h=4;break e}i[k>>2]=o+2,i[e+4>>2]=(h<<16|l<<24)>>16,r=i[k>>2],o=r+s|0,l=u[o+1|0],o=u[o|0],i[k>>2]=r+2,i[e+8>>2]=(l<<16|o<<24)>>16,r=i[k>>2],l=s+r|0,o=l+1|0,l=u[l|0]<<8,h=2}o=u[o|0],i[k>>2]=r+h,i[e+12>>2]=o|l,l=i[k>>2],s=l+s|0,o=u[s|0],r=u[s+1|0];e:{if((f|0)==32){f=r<<16|o<<24|u[s+2|0]<<8,r=u[s+3|0],h=4;break e}f=o<<8,h=2}if(i[k>>2]=h+l,i[e+16>>2]=r&255|f,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+16|0}function FZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;n=v-16|0,v=n,h=i[r+4>>2],o=i[k>>2],s=i[r>>2],r=o+s|0;i:{if(h-r>>>0<(f|0)/8<<2>>>0){if(e=C(48),i[n+4>>2]=e,i[n+8>>2]=46,i[n+12>>2]=-2147483600,r=u[9813]|u[9814]<<8|(u[9815]<<16|u[9816]<<24),f=u[9809]|u[9810]<<8|(u[9811]<<16|u[9812]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+46|0]=0,r=u[9851]|u[9852]<<8|(u[9853]<<16|u[9854]<<24),f=u[9847]|u[9848]<<8|(u[9849]<<16|u[9850]<<24),t[e+38|0]=f,t[e+39|0]=f>>>8,t[e+40|0]=f>>>16,t[e+41|0]=f>>>24,t[e+42|0]=r,t[e+43|0]=r>>>8,t[e+44|0]=r>>>16,t[e+45|0]=r>>>24,r=u[9845]|u[9846]<<8|(u[9847]<<16|u[9848]<<24),f=u[9841]|u[9842]<<8|(u[9843]<<16|u[9844]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[9837]|u[9838]<<8|(u[9839]<<16|u[9840]<<24),f=u[9833]|u[9834]<<8|(u[9835]<<16|u[9836]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[9829]|u[9830]<<8|(u[9831]<<16|u[9832]<<24),f=u[9825]|u[9826]<<8|(u[9827]<<16|u[9828]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[9821]|u[9822]<<8|(u[9823]<<16|u[9824]<<24),f=u[9817]|u[9818]<<8|(u[9819]<<16|u[9820]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,136,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}l=u[r|0],h=u[r+1|0];e:{if((f|0)==32){w=u[r+3|0],r=u[r+2|0],i[k>>2]=o+4,i[e+4>>2]=h<<16|l<<24|r<<8|w,o=i[k>>2],r=o+s|0,r=u[r|0]|u[r+1|0]<<8|(u[r+2|0]<<16|u[r+3|0]<<24),i[k>>2]=o+4,i[e+8>>2]=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),r=i[k>>2],o=s+r|0,l=u[o+1|0]<<16|u[o|0]<<24|u[o+2|0]<<8,o=o+3|0,h=4;break e}i[k>>2]=o+2,i[e+4>>2]=(h<<16|l<<24)>>16,r=i[k>>2],o=r+s|0,l=u[o+1|0],o=u[o|0],i[k>>2]=r+2,i[e+8>>2]=(l<<16|o<<24)>>16,r=i[k>>2],l=s+r|0,o=l+1|0,l=u[l|0]<<8,h=2}o=u[o|0],i[k>>2]=r+h,i[e+12>>2]=o|l,l=i[k>>2],s=l+s|0,o=u[s|0],r=u[s+1|0];e:{if((f|0)==32){f=r<<16|o<<24|u[s+2|0]<<8,r=u[s+3|0],h=4;break e}f=o<<8,h=2}if(i[k>>2]=h+l,i[e+16>>2]=r&255|f,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+16|0}function yn(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;f=v-96|0,v=f;i:{e:{if(B=i[r>>2],m=i[r+4>>2],(B|0)!=(m|0))for(G=A+80|0,o=f+80|0;;){r=i[B>>2],_=i[A+92>>2],i[A+92>>2]=_+1,k=i[e+8>>2],l=i[e+12>>2];r:{if(k>>>0<l>>>0){i[k>>2]=_,k=k+4|0;break r}if(h=i[e+4>>2],k=k-h|0,w=k>>2,n=w+1|0,n>>>0>=1073741824)break e;if(l=l-h|0,s=l>>1,l=l>>>0>=2147483644?1073741823:n>>>0<s>>>0?s:n,l){if(l>>>0>=1073741824)break i;n=C(l<<2)}else n=0;if(s=n+k|0,i[s>>2]=_,w=s-(w<<2)|0,k&&z(w,h,k),i[e+12>>2]=n+(l<<2),k=s+4|0,i[e+8>>2]=k,i[e+4>>2]=w,!h)break r;Z(h)}i[e+8>>2]=k,t[f+76|0]=1,i[f+68>>2]=0,i[f+72>>2]=0,X[f+64>>1]=0,i[f+60>>2]=255,X[f+56>>1]=0,i[f+48>>2]=0,i[f+52>>2]=65535,i[o+8>>2]=0,i[o>>2]=0,i[o+4>>2]=0;r:{if(!r||(k=u[r+25|0]|u[r+26|0]<<8|(u[r+27|0]<<16|u[r+28|0]<<24),n=u[r+21|0]|u[r+22|0]<<8|(u[r+23|0]<<16|u[r+24|0]<<24),t[f+69|0]=n,t[f+70|0]=n>>>8,t[f+71|0]=n>>>16,t[f+72|0]=n>>>24,t[f+73|0]=k,t[f+74|0]=k>>>8,t[f+75|0]=k>>>16,t[f+76|0]=k>>>24,n=i[r+20>>2],k=f- -64|0,i[k>>2]=i[r+16>>2],i[k+4>>2]=n,k=i[r+12>>2],i[f+56>>2]=i[r+8>>2],i[f+60>>2]=k,k=i[r+4>>2],i[f+48>>2]=i[r>>2],i[f+52>>2]=k,(r|0)==(f+48|0)))break r;if(t[r+43|0]>=0){k=i[r+36>>2],i[o>>2]=i[r+32>>2],i[o+4>>2]=k,i[o+8>>2]=i[r+40>>2];break r}m1(o,i[r+32>>2],i[r+36>>2])}i[f+48>>2]=_,i[f+52>>2]=i[e>>2],i[f+60>>2]=i[e+16>>2],k=f- -64|0,X[k>>1]=p[e+20>>1],i[f+68>>2]=i[e+24>>2],r=i[e+28>>2],n=i[k+4>>2],i[f+16>>2]=i[k>>2],i[f+20>>2]=n,n=i[f+60>>2],i[f+8>>2]=i[f+56>>2],i[f+12>>2]=n,i[f+72>>2]=r,r=u[f+73|0]|u[f+74|0]<<8|(u[f+75|0]<<16|u[f+76|0]<<24),n=u[f+69|0]|u[f+70|0]<<8|(u[f+71|0]<<16|u[f+72|0]<<24),t[f+21|0]=n,t[f+22|0]=n>>>8,t[f+23|0]=n>>>16,t[f+24|0]=n>>>24,t[f+25|0]=r,t[f+26|0]=r>>>8,t[f+27|0]=r>>>16,t[f+28|0]=r>>>24,r=i[f+52>>2],i[f>>2]=i[f+48>>2],i[f+4>>2]=r,i[f+40>>2]=i[o+8>>2],r=i[o+4>>2],i[f+32>>2]=i[o>>2],i[f+36>>2]=r,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,r=i[A+84>>2];r:{if(r>>>0<o0[A+88>>2]){n=i[f+56>>2],h=i[f+60>>2],_=i[k>>2],k=i[k+4>>2],l=i[f+72>>2],s=i[f+48>>2],w=i[f+52>>2],t[r+28|0]=u[f+76|0],i[r+24>>2]=l,i[r+16>>2]=_,i[r+20>>2]=k,i[r+8>>2]=n,i[r+12>>2]=h,i[r>>2]=s,i[r+4>>2]=w,i[r+40>>2]=i[f+40>>2],k=i[f+36>>2],i[r+32>>2]=i[f+32>>2],i[r+36>>2]=k,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[A+84>>2]=r+44;break r}if(r=U8(G,f),k=t[f+43|0],i[A+84>>2]=r,(k|0)>=0)break r;Z(i[f+32>>2])}if(t[f+91|0]<0&&Z(i[f+80>>2]),B=B+4|0,(m|0)==(B|0))break}v=f+96|0;return}s0(),M()}x0(),M()}function CZ(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0;e=v-48|0,v=e;i:{if(i[A+80>>2]!=i[A+84>>2]||(k=$e(A),n=Ke(A),!k|!n))break i;l=A+80|0,r=i[A+92>>2],i[A+92>>2]=r+1,i[e+44>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,t[e+32|0]=1,i[e+28>>2]=n,i[e+24>>2]=k,X[e+20>>1]=8,i[e+16>>2]=0,X[e+12>>1]=4,i[e+8>>2]=3,i[e+4>>2]=r,r=i[A+84>>2];e:{if(r>>>0<o0[A+88>>2]){f=i[e+8>>2],i[r>>2]=i[e+4>>2],i[r+4>>2]=f,f=u[e+29|0]|u[e+30|0]<<8|(u[e+31|0]<<16|u[e+32|0]<<24),o=u[e+25|0]|u[e+26|0]<<8|(u[e+27|0]<<16|u[e+28|0]<<24),t[r+21|0]=o,t[r+22|0]=o>>>8,t[r+23|0]=o>>>16,t[r+24|0]=o>>>24,t[r+25|0]=f,t[r+26|0]=f>>>8,t[r+27|0]=f>>>16,t[r+28|0]=f>>>24,f=i[e+24>>2],i[r+16>>2]=i[e+20>>2],i[r+20>>2]=f,f=i[e+16>>2],i[r+8>>2]=i[e+12>>2],i[r+12>>2]=f,f=i[e+40>>2],i[r+32>>2]=i[e+36>>2],i[r+36>>2]=f,i[r+40>>2]=i[e+44>>2],r=r+44|0,i[A+84>>2]=r;break e}if(r=U8(l,e+4|0),f=t[e+47|0],i[A+84>>2]=r,(f|0)>=0)break e;Z(i[e+36>>2]),r=i[A+84>>2]}f=i[A+92>>2],i[A+92>>2]=f+1,i[e+44>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,t[e+32|0]=1,i[e+28>>2]=n,i[e+24>>2]=k,X[e+20>>1]=8,i[e+16>>2]=0,X[e+12>>1]=5,i[e+8>>2]=4,i[e+4>>2]=f;e:{if(o0[A+88>>2]>r>>>0){f=i[e+8>>2],i[r>>2]=i[e+4>>2],i[r+4>>2]=f,f=u[e+29|0]|u[e+30|0]<<8|(u[e+31|0]<<16|u[e+32|0]<<24),o=u[e+25|0]|u[e+26|0]<<8|(u[e+27|0]<<16|u[e+28|0]<<24),t[r+21|0]=o,t[r+22|0]=o>>>8,t[r+23|0]=o>>>16,t[r+24|0]=o>>>24,t[r+25|0]=f,t[r+26|0]=f>>>8,t[r+27|0]=f>>>16,t[r+28|0]=f>>>24,f=i[e+24>>2],i[r+16>>2]=i[e+20>>2],i[r+20>>2]=f,f=i[e+16>>2],i[r+8>>2]=i[e+12>>2],i[r+12>>2]=f,f=i[e+40>>2],i[r+32>>2]=i[e+36>>2],i[r+36>>2]=f,i[r+40>>2]=i[e+44>>2],r=r+44|0,i[A+84>>2]=r;break e}if(r=U8(l,e+4|0),f=t[e+47|0],i[A+84>>2]=r,(f|0)>=0)break e;Z(i[e+36>>2]),r=i[A+84>>2]}if(f=i[A+92>>2],i[A+92>>2]=f+1,i[e+44>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,t[e+32|0]=1,i[e+28>>2]=n,i[e+24>>2]=k,X[e+20>>1]=8,i[e+16>>2]=0,X[e+12>>1]=6,i[e+8>>2]=5,i[e+4>>2]=f,o0[A+88>>2]>r>>>0){k=i[e+8>>2],i[r>>2]=i[e+4>>2],i[r+4>>2]=k,k=u[e+29|0]|u[e+30|0]<<8|(u[e+31|0]<<16|u[e+32|0]<<24),n=u[e+25|0]|u[e+26|0]<<8|(u[e+27|0]<<16|u[e+28|0]<<24),t[r+21|0]=n,t[r+22|0]=n>>>8,t[r+23|0]=n>>>16,t[r+24|0]=n>>>24,t[r+25|0]=k,t[r+26|0]=k>>>8,t[r+27|0]=k>>>16,t[r+28|0]=k>>>24,k=i[e+24>>2],i[r+16>>2]=i[e+20>>2],i[r+20>>2]=k,k=i[e+16>>2],i[r+8>>2]=i[e+12>>2],i[r+12>>2]=k,k=i[e+40>>2],i[r+32>>2]=i[e+36>>2],i[r+36>>2]=k,i[r+40>>2]=i[e+44>>2],i[A+84>>2]=r+44;break i}if(r=U8(l,e+4|0),k=t[e+47|0],i[A+84>>2]=r,(k|0)>=0)break i;Z(i[e+36>>2])}v=e+48|0}function YZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,n=i[19620],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19621],k=n+i[i[f+8>>2]-12>>2]|0,l=f+12|0,J0(k,l),t[k+80|0]=0,i[k+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,_=R0(l),i[_>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,K1(k,e,r),s=n,o=k,n=t[f+159|0],k=(n|0)<0,F(s,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,k0(n,r),o=n,n=t[f+159|0],k=(n|0)<0,F(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(f+8|0,33254,13),n=i[e+100>>2]&1,F(F(k,n?5732:8666,n|2),47878,1),n=i[e+104>>2],B=i[e+108>>2],(n|0)!=(B|0))for(;;){e=f+148|0,k0(e,r),o=e,e=t[f+159|0],k=(e|0)<0,F(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),e=f+8|0,F(M2(F(e,34530,18),i[n>>2],i[n+4>>2]),47878,1),k=f+148|0,k0(k,r),s=e,o=k,e=t[f+159|0],k=(e|0)<0,F(s,k?i[f+148>>2]:o,k?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),m=f+8|0,k=F(m,36664,12),e=i[n+8>>2],s=i[n+12>>2],l=v-16|0,v=l,X1(l+8|0,k);i:{if(!u[l+8|0]||(w=l+4|0,h=i[(k+i[i[k>>2]-12>>2]|0)+28>>2],i[w>>2]=h,(h|0)!=136824&&(i[h+4>>2]=i[h+4>>2]+1),h=$0(w,136688),i2(w),i[l>>2]=i[(k+i[i[k>>2]-12>>2]|0)+24>>2],G=k+i[i[k>>2]-12>>2]|0,o=V6(G),I=l,Q=W[i[i[h>>2]+20>>2]](h,i[l>>2],G,o,e,s)|0,i[I+4>>2]=Q,i[w>>2]))break i;z4(k+i[i[k>>2]-12>>2]|0,5)}if(v1(l+8|0),v=l+16|0,F(k,47878,1),e=f+148|0,k0(e,r),o=e,e=t[f+159|0],k=(e|0)<0,F(m,k?i[f+148>>2]:o,k?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),e=f+8|0,F(il(F(e,34283,20),X[n+16>>1]),47878,1),k=f+148|0,k0(k,r),s=e,o=k,e=t[f+159|0],k=(e|0)<0,F(s,k?i[f+148>>2]:o,k?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),F(il(F(f+8|0,34483,21),X[n+18>>1]),47878,1),n=n+24|0,(B|0)==(n|0))break}e=i[f+60>>2];i:{e:{if(e&16){n=i[f+56>>2],e=i[f+36>>2],n>>>0<e>>>0&&(i[f+56>>2]=e,n=e),e=f+32|0;break e}if(!(e&8)){n=0,t[A+11|0]=0;break i}n=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){k=n|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(t[A+11|0]=n,n)break e;n=0;break i}I0(),M()}if(!n)break i;z(A,r,n)}t[A+n|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[_>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(_),Y0(f- -64|0),v=f+160|0}function En(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;n=v-48|0,v=n,t3(n+16|0,e);i:{e:switch(u[n+36|0]){default:e2(),M();case 1:if(e=i[n+20>>2],i[A>>2]=i[n+16>>2],i[A+4>>2]=e,e=A+8|0,t[n+35|0]>=0){A=i[n+28>>2],i[e>>2]=i[n+24>>2],i[e+4>>2]=A,i[e+8>>2]=i[n+32>>2];break i}T(e,i[n+24>>2],i[n+28>>2]);break i;case 0:break e}o=i[r+12>>2],f=0;e:{if(!o||(e=i[r+16>>2],f=0,!e))break e;l=o0[r+20>>2]%(o>>>0)|0,f=o0[r+24>>2]%(e>>>0)|0}if(e=i[n+16>>2],m=i[n+20>>2],(e|0)!=(m|0))for(;;){o=f,w=l,B=s,k=i[e>>2];e:{if(!k)break e;f=Z0(k,92792,94104);r:{if(!f){f=o;break r}k=i[e+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);f:{A:{k:{s=i[f+100>>2],l=(s|0)==270;n:{if(!l){if((s|0)==180)break n;if((s|0)!=90)break A}if(I=r,Q=Ff(i[r+12>>2],i[r+16>>2]),i[I+12>>2]=Q,i[r+16>>2]=h0,I=r,Q=Ff(i[r+20>>2],i[r+24>>2]),i[I+20>>2]=Q,i[r+24>>2]=h0,I=r,Q=Ff(i[r+4>>2],i[r+8>>2]),i[I+4>>2]=Q,i[r+8>>2]=h0,(s|0)==90){f=_,l=o,s=w,_=B;break f}if(l)break k;if((s|0)!=180)break A}f=B,l=_,s=o,_=w;break f}f=w,l=B,s=_,_=o;break f}f=o,l=w,s=B}f:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break f;W[i[i[k>>2]+8>>2]](k),y(k)}if(k=i[e>>2],!k)break e}w=Z0(k,92792,94184);r:{if(!w){B=l,o=f;break r}k=i[e+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),o=f,B=l;f:{A:switch(i[w+100>>2]){case 1:B=_,_=l;break f;case 0:break A;default:break f}o=s,s=f}if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break r;W[i[i[k>>2]+8>>2]](k),y(k)}r:{if(f=i[e>>2],!f||(k=Z0(f,92792,94264),!k))break r;h=i[e+4>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),f=pe(k,i[r+20>>2]),w=aA(k,i[r+20>>2]),l=Qe(k,i[r+24>>2]),G=KA(k,i[r+24>>2]);f:{if(k=(f|0)>0?f:0,f=i[r+20>>2],w=f>>>0>w>>>0?w:f-1|0,(k|0)<=(w|0)&&(l=(l|0)>0?l:0,f=i[r+24>>2],f=f>>>0>G>>>0?G:f-1|0,(l|0)<=(f|0)))break f;if(t[n|0]=0,t[n+11|0]=0,a(A,2,120,n),t[n+11|0]<0&&Z(i[n>>2]),!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break i;W[i[i[h>>2]+8>>2]](h),y(h);break i}if(f=f+o|0,s=l+s|0,l=w+B|0,_=k+_|0,!h||(o=i[h+4>>2],i[h+4>>2]=o-1,o))break e;W[i[i[h>>2]+8>>2]](h),y(h);break e}l=B,f=o}if(e=e+8|0,(m|0)==(e|0))break}if(i[r+28>>2]=s,i[r+32>>2]=_,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731])}e=u[n+36|0],(e|0)!=255&&(A=i[26907],i[n>>2]=i[26906],i[n+4>>2]=A,W[i[n+(e<<2)>>2]](n+47|0,n+16|0)),v=n+48|0}function yZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],s=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(s,n),t[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,s=R0(n),i[s>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),l=k,o=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(k,37777,22),F(D0(k,i[e+104>>2]),32823,3),F(D0(k,i[e+108>>2]),32823,3),F(D0(k,i[e+112>>2]),47878,1),n=f+148|0,k0(n,r),l=k,o=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(k,31471,12);i:{if(u[e+116|0]==1){F(k,47632,12),n=f+148|0,k0(n,r),l=k,o=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(t4(F(t4(F(t4(F(t4(F(f+8|0,20864,7),u0[e+120>>3]),22872,1),u0[e+128>>3]),22872,1),u0[e+136>>3]),22872,1),u0[e+144>>3]),46799,2);break i}k=f+8|0,F(k,47534,9),n=f+148|0,k0(n,r),l=k,o=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(t4(F(k,37845,9),u0[e+152>>3]),47878,1),n=f+148|0,k0(n,r),l=k,o=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(t4(F(k,35158,9),u0[e+160>>3]),47878,1),n=f+148|0,k0(n,r),l=k,o=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(t4(F(f+8|0,37814,9),u0[e+168>>3]),47878,1)}k=f+148|0,k0(k,r),n=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36996,28),i[e+176>>2]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[s>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(s),Y0(f- -64|0),v=f+160|0}function EZ(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;f=v-32|0,v=f,e=C(248),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=101168,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,w=e+12|0,i[e+176>>2]=w,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e));i:{e:{if(k=i[r>>2],n=i[k+200>>2]-12|0,n>>>0>=4){r=i[28734],i[A>>2]=i[28733],i[A+4>>2]=r,r=A+8|0;r:{if(t[114951]>=0){k=i[28736],i[r>>2]=i[28735],i[r+4>>2]=k,i[r+8>>2]=i[28737];break r}T(r,i[28735],i[28736])}t[A+20|0]=1;break e}if(o=i[k+188>>2],m=i[k+192>>2],t1(w,o,m,1,i[(n<<2)+64092>>2]),a0(f+8|0,w,10,o,m,K0(i[r>>2],10),l,0),i[f+8>>2]){if(r=i[f+12>>2],i[A>>2]=i[f+8>>2],i[A+4>>2]=r,r=A+8|0,t[f+27|0]>=0){k=i[f+20>>2],i[r>>2]=i[f+16>>2],i[r+4>>2]=k,i[r+8>>2]=i[f+24>>2],t[A+20|0]=1;break e}if(T(r,i[f+16>>2],i[f+20>>2]),r=t[f+27|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[f+16>>2]);break e}t[f+27|0]<0&&Z(i[f+16>>2]),l=0,r=Q0(i[r>>2],10),r?(Q=i[r+40>>2],k=i[r+52>>2]):k=0,r=Q0(w,10),r?(l=i[r+52>>2],n=i[r+40>>2]):n=0;r:{if(!m||(r=k>>>0>l>>>0?l:k,!r))break r;for(r=r-1|0,o=(r>>>1|0)+1|0,V=o&-4,I=o&3,Y=r>>>0<6;;){if(_=g(l,G)+n|0,B=g(k,G)+Q|0,r=0,o=0,!Y)for(;s=r+_|0,h=r+B|0,t[s|0]=u[h+1|0],t[s+1|0]=u[h|0],s=r|2,h=s+_|0,s=s+B|0,t[h|0]=u[s+1|0],t[h+1|0]=u[s|0],s=r|4,h=s+_|0,s=s+B|0,t[h|0]=u[s+1|0],t[h+1|0]=u[s|0],s=r|6,h=s+_|0,s=s+B|0,t[h|0]=u[s+1|0],t[h+1|0]=u[s|0],r=r+8|0,o=o+4|0,(V|0)!=(o|0););if(o=0,I)for(;s=r+_|0,h=r+B|0,t[s|0]=u[h+1|0],t[s+1|0]=u[h|0],r=r+2|0,o=o+1|0,(I|0)!=(o|0););if(G=G+1|0,(G|0)==(m|0))break}}t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=w;break i}if(A=i[e+4>>2],i[e+4>>2]=A-1,A)break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=f+32|0}function RZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,k=v-32|0,v=k;i:{if(f){W[i[i[e>>2]+112>>2]](e,k+28|0,k+24|0),e=i[k+24>>2],f=i[k+28>>2];break i}f=$e(e),i[k+28>>2]=f,e=Ke(e),i[k+24>>2]=e}i:{if(!(e&&f)){if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}if(!(i[r+188>>2]==(f|0)&i[r+192>>2]==(e|0))){if(e=C(64),i[k+12>>2]=e,i[k+16>>2]=58,i[k+20>>2]=-2147483584,r=u[27661]|u[27662]<<8|(u[27663]<<16|u[27664]<<24),f=u[27657]|u[27658]<<8|(u[27659]<<16|u[27660]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+58|0]=0,r=u[27713]|u[27714]<<8,t[e+56|0]=r,t[e+57|0]=r>>>8,r=u[27709]|u[27710]<<8|(u[27711]<<16|u[27712]<<24),f=u[27705]|u[27706]<<8|(u[27707]<<16|u[27708]<<24),t[e+48|0]=f,t[e+49|0]=f>>>8,t[e+50|0]=f>>>16,t[e+51|0]=f>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[27701]|u[27702]<<8|(u[27703]<<16|u[27704]<<24),f=u[27697]|u[27698]<<8|(u[27699]<<16|u[27700]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[27693]|u[27694]<<8|(u[27695]<<16|u[27696]<<24),f=u[27689]|u[27690]<<8|(u[27691]<<16|u[27692]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[27685]|u[27686]<<8|(u[27687]<<16|u[27688]<<24),f=u[27681]|u[27682]<<8|(u[27683]<<16|u[27684]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[27677]|u[27678]<<8|(u[27679]<<16|u[27680]<<24),f=u[27673]|u[27674]<<8|(u[27675]<<16|u[27676]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[27669]|u[27670]<<8|(u[27671]<<16|u[27672]<<24),f=u[27665]|u[27666]<<8|(u[27667]<<16|u[27668]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,129,k+12|0),t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function Rn(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;i:{e:{if(f=e,o=i[f>>2],o){if(r=i[f+4>>2],!r)break e;for(;f=r,r=i[r>>2],!!r;);}if(o=i[f+4>>2],o)break e;n=i[f+8>>2],o=0,k=1;break i}n=i[f+8>>2],i[o+8>>2]=n,k=0}r=i[n>>2];i:{if((f|0)==(r|0)){if(i[n>>2]=o,(A|0)==(f|0)){r=0,A=o;break i}r=i[n+4>>2];break i}i[n+4>>2]=o}if(l=u[f+12|0],(e|0)!=(f|0)){n=i[e+8>>2],i[f+8>>2]=n;i:{if(i[n>>2]==(e|0)){i[n>>2]=f;break i}i[n+4>>2]=f}n=i[e>>2],i[f>>2]=n,i[n+8>>2]=f,n=i[e+4>>2],i[f+4>>2]=n,n&&(i[n+8>>2]=f),t[f+12|0]=u[e+12|0],A=(A|0)==(e|0)?f:A}if(!(!A|!(l&1))){if(k)for(;;){e=u[r+12|0];i:{if(k=i[r+8>>2],f=i[k>>2],(f|0)!=(r|0)){if(!(e&1)){t[r+12|0]=1,t[k+12|0]=0,f=i[k+4>>2],e=i[f>>2],i[k+4>>2]=e,e&&(i[e+8>>2]=k),e=i[k+8>>2],i[f+8>>2]=e;e:{if((k|0)==i[e>>2]){i[e>>2]=f;break e}i[e+4>>2]=f}i[f>>2]=k,i[k+8>>2]=f,e=i[r>>2],A=(e|0)==(A|0)?r:A,r=i[e+4>>2]}e:{r:{f=i[r>>2];f:{if(!(u[f+12|0]!=1&&f)){if(e=i[r+4>>2],u[e+12|0]!=1&&e)break f;if(t[r+12|0]=0,r=i[r+8>>2],u[r+12|0]&&(r|0)!=(A|0))break i;t[r+12|0]=1;return}if(e=i[r+4>>2],!e)break r}if(u[e+12|0]==1)break r;f=r;break e}t[f+12|0]=1,t[r+12|0]=0,A=i[f+4>>2],i[r>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[f+8>>2]=A;r:{if(i[A>>2]==(r|0)){i[A>>2]=f;break r}i[A+4>>2]=f}i[f+4>>2]=r,i[r+8>>2]=f,e=r}r=i[f+8>>2],t[f+12|0]=u[r+12|0],t[r+12|0]=1,t[e+12|0]=1,e=i[r+4>>2],A=i[e>>2],i[r+4>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[e+8>>2]=A;e:{if((r|0)==i[A>>2]){i[A>>2]=e;break e}i[A+4>>2]=e}i[e>>2]=r,i[r+8>>2]=e;return}if(!(e&1)){t[r+12|0]=1,t[k+12|0]=0,e=i[f+4>>2],i[k>>2]=e,e&&(i[e+8>>2]=k),e=i[k+8>>2],i[f+8>>2]=e;e:{if((k|0)==i[e>>2]){i[e>>2]=f;break e}i[e+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,e=i[r+4>>2],A=(e|0)==(A|0)?r:A,r=i[e>>2]}e=i[r>>2];e:{if(!(!e|u[e+12|0]==1)){f=r;break e}if(f=i[r+4>>2],!(u[f+12|0]!=1&&f)){if(t[r+12|0]=0,r=i[r+8>>2],u[r+12|0]==1&(A|0)!=(r|0))break i;t[r+12|0]=1;return}if(e){if(!(t[e+12|0]&1)){f=r;break e}f=i[r+4>>2]}t[f+12|0]=1,t[r+12|0]=0,A=i[f>>2],i[r+4>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[f+8>>2]=A;r:{if(i[A>>2]==(r|0)){i[A>>2]=f;break r}i[A+4>>2]=f}i[f>>2]=r,i[r+8>>2]=f,e=r}r=i[f+8>>2],t[f+12|0]=u[r+12|0],t[r+12|0]=1,t[e+12|0]=1,e=i[r>>2],A=i[e+4>>2],i[r>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[e+8>>2]=A;e:{if((r|0)==i[A>>2]){i[A>>2]=e;break e}i[A+4>>2]=e}i[e+4>>2]=r,i[r+8>>2]=e;return}e=i[r+8>>2],r=i[(i[e>>2]==(r|0)?4:0)+e>>2]}t[o+12|0]=1}}function JZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;f=v-16|0,v=f,B=e,m=Q2(r),t[B+100|0]=m,B=e,m=Q2(r),t[B+101|0]=m,B=e,m=Q2(r),t[B+102|0]=m,B=e,m=Q2(r),t[B+103|0]=m,B=e,m=(Q2(r)&3)+1|0,t[B+104|0]=m;i:{if(h=Q2(r)&31,!h)break i;for(_=e+116|0;;){o=w2(r),i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0;e:{if(!o){n=0,k=0;break e}k=C(o),i[f+4>>2]=k,n=k+o|0,i[f+12>>2]=n,o&&l0(k,0,o),i[f+8>>2]=n}s6(r,k,n-k|0);e:{k=i[e+120>>2];r:{if(k>>>0<o0[e+124>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],l=i[f+4>>2],(n|0)!=(l|0)){if(n=n-l|0,(n|0)<0)break e;o=C(n),i[k+4>>2]=o,i[k>>2]=o,w=n+o|0,i[k+8>>2]=w,n&&z(o,l,n),i[k+4>>2]=w}k=k+12|0;break r}k=ii(_,f+4|0)}if(i[e+120>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),s=s+1|0,(h|0)!=(s|0))continue;break i}break}s0(),M()}i:{e:{if(h=Q2(r),h)for(_=e+128|0,s=0;;){o=w2(r),i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0;r:{if(!o){n=0,k=0;break r}k=C(o),i[f+4>>2]=k,n=k+o|0,i[f+12>>2]=n,o&&l0(k,0,o),i[f+8>>2]=n}s6(r,k,n-k|0),k=i[e+132>>2];r:{if(k>>>0<o0[e+136>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],l=i[f+4>>2],(n|0)!=(l|0)){if(n=n-l|0,(n|0)<0)break e;o=C(n),i[k+4>>2]=o,i[k>>2]=o,w=n+o|0,i[k+8>>2]=w,n&&z(o,l,n),i[k+4>>2]=w}k=k+12|0;break r}k=ii(_,f+4|0)}if(i[e+132>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),s=s+1|0,(h|0)==(s|0))break}r:{if(!i[r+16>>2]||(k=u[e+101|0]-66|0,1<<k&4196353&&k>>>0<=22)||(B=e,m=Q2(r)&3,i[B+108>>2]=m,B=e,m=Q2(r)&7|8,t[B+112|0]=m,B=e,m=Q2(r)&7|8,t[B+113|0]=m,h=Q2(r),!h))break r;for(_=e+140|0,s=0;;){o=w2(r),i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0;f:{if(!o){n=0,k=0;break f}k=C(o),i[f+4>>2]=k,n=k+o|0,i[f+12>>2]=n,o&&l0(k,0,o),i[f+8>>2]=n}s6(r,k,n-k|0),k=i[e+144>>2];f:{if(k>>>0<o0[e+148>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],l=i[f+4>>2],(n|0)!=(l|0)){if(n=n-l|0,(n|0)<0)break i;o=C(n),i[k+4>>2]=o,i[k>>2]=o,w=n+o|0,i[k+8>>2]=w,n&&z(o,l,n),i[k+4>>2]=w}k=k+12|0;break f}k=ii(_,f+4|0)}if(i[e+144>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),s=s+1|0,(h|0)==(s|0))break}}r:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break r;Z(i[f+4>>2]);break r}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break r}T(A,i[28730],i[28731])}v=f+16|0;return}s0(),M()}s0(),M()}function QA(A,e,r){var f=0,k=0;k=v-48|0,v=k;i:{if(u[e|0]==1){if(r=i[e+16>>2],!r){e=C(24),i[k+12>>2]=e,i[k+16>>2]=21,i[k+20>>2]=-2147483624,r=u[3336]|u[3337]<<8|(u[3338]<<16|u[3339]<<24),f=u[3332]|u[3333]<<8|(u[3334]<<16|u[3335]<<24),t[e+13|0]=f,t[e+14|0]=f>>>8,t[e+15|0]=f>>>16,t[e+16|0]=f>>>24,t[e+17|0]=r,t[e+18|0]=r>>>8,t[e+19|0]=r>>>16,t[e+20|0]=r>>>24,r=u[3331]|u[3332]<<8|(u[3333]<<16|u[3334]<<24),f=u[3327]|u[3328]<<8|(u[3329]<<16|u[3330]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[3323]|u[3324]<<8|(u[3325]<<16|u[3326]<<24),f=u[3319]|u[3320]<<8|(u[3321]<<16|u[3322]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+21|0]=0,e=a(k+24|0,5,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}i[e+16>>2]=r+1,t[A+20|0]=0,i[A>>2]=r;break i}e:{r:switch(r|0){case 0:f=e+4|0;break e;case 1:f=e+8|0;break e;case 2:break r;default:break e}f=e+12|0}if(e=i[f>>2],!e){e=C(24),i[k+12>>2]=e,i[k+16>>2]=21,i[k+20>>2]=-2147483624,r=u[3336]|u[3337]<<8|(u[3338]<<16|u[3339]<<24),f=u[3332]|u[3333]<<8|(u[3334]<<16|u[3335]<<24),t[e+13|0]=f,t[e+14|0]=f>>>8,t[e+15|0]=f>>>16,t[e+16|0]=f>>>24,t[e+17|0]=r,t[e+18|0]=r>>>8,t[e+19|0]=r>>>16,t[e+20|0]=r>>>24,r=u[3331]|u[3332]<<8|(u[3333]<<16|u[3334]<<24),f=u[3327]|u[3328]<<8|(u[3329]<<16|u[3330]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[3323]|u[3324]<<8|(u[3325]<<16|u[3326]<<24),f=u[3319]|u[3320]<<8|(u[3321]<<16|u[3322]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+21|0]=0,e=a(k+24|0,5,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}i[f>>2]=e+1,t[A+20|0]=0,i[A>>2]=e}v=k+48|0}function NZ(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0,_=0,B=0;h=v+-64|0,v=h,B=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[h+60>>2]=r,i[h+56>>2]=B;i:{e:{r:{if(!u[e+4|0]){if(W[i[i[f>>2]+120>>2]](h+24|0,i[f+4>>2],h+56|0,n,o,l,k),k=i[h+24>>2],k){if(f=i[h+28>>2],n=i[h+32>>2],r=l2(n),r>>>0>=2147483640)break e;f:{A:{if(r>>>0>=11){o=r|7,e=C(o+1|0),i[h+52>>2]=o-2147483647,i[h+44>>2]=e,i[h+48>>2]=r;break A}if(t[h+55|0]=r,e=h+44|0,!r)break f}if(!r)break f;z(e,n,r)}if(t[e+r|0]=0,a(A,k,f,h+44|0),t[h+55|0]>=0)break r;Z(i[h+44>>2]);break r}r=C(208),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96908,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,X[r+112>>1]=0,i[r+16>>2]=106584,X[r+122>>1]=0,X[r+124>>1]=0,X[r+126>>1]=0,X[r+128>>1]=0,X[r+120>>1]=259,X[r+130>>1]=0,X[r+132>>1]=0,i[r+136>>2]=0,i[r+140>>2]=0,i[r+144>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+156>>2]=0,i[r+160>>2]=0,i[r+164>>2]=0,i[r+168>>2]=0,i[r+172>>2]=0,i[r+176>>2]=0,i[r+180>>2]=0,X[r+182>>1]=0,X[r+184>>1]=0,X[r+186>>1]=0,X[r+188>>1]=0,i[r+200>>2]=0,i[r+192>>2]=0,i[r+196>>2]=0,i[r+32>>2]=1987470147,i[e+12>>2]=k,k=i[e+16>>2],i[e+16>>2]=r;f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;W[i[i[k>>2]+8>>2]](k),y(k)}t[e+4|0]=1,l&&(r=o>>>24|0,n=o<<8,k=n+(l>>>1|0)|0,w=O1(k,k>>>0<n>>>0?r+1|0:r,l,0),_=h0),X[e+32>>1]=!_&w>>>0>=65536|_?65536:w}if(IA(h+24|0,e,f),i[h+24>>2]){e=i[h+28>>2],i[A>>2]=i[h+24>>2],i[A+4>>2]=e,e=i[h+36>>2],i[A+8>>2]=i[h+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[h+40>>2];break r}W[i[i[f>>2]+124>>2]](h+44|0,i[f+4>>2],h+56|0,s),k=i[h+44>>2];f:{if(k){if(f=i[h+48>>2],n=i[h+52>>2],r=l2(n),r>>>0>=2147483640)break i;A:{k:{if(r>>>0>=11){o=r|7,e=C(o+1|0),i[h+20>>2]=o-2147483647,i[h+12>>2]=e,i[h+16>>2]=r;break k}if(t[h+23|0]=r,e=h+12|0,!r)break A}if(!r)break A;z(e,n,r)}if(t[e+r|0]=0,a(A,k,f,h+12|0),t[h+23|0]>=0)break f;Z(i[h+12>>2]);break f}IA(A,e,f)}if(t[h+43|0]>=0)break r;Z(i[h+32>>2])}A=i[h+60>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=h- -64|0;return}I0(),M()}I0(),M()}function Jn(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;k=i[A+18588>>2],w=i[k+132>>2],f=-1<<i[w+8268>>2],o=f&r,B=i[A+18592>>2],h=i[k+124>>2],s=e&f,(s|0)==i[A+18524>>2]&(o|0)==i[A+18528>>2]||(i[A+18528>>2]=o,i[A+18524>>2]=s,i[A+18532>>2]=i[A+18520>>2]),l=i[B+808>>2],_=i[h+16892>>2],n=(l|0)/(_|0)|0,k=l-g(n,_)|0,l=i[h+16884>>2],l=(s|0)==(g(k,l)|0)&(o|0)==(g(n,l)|0),n=0,k=i[h+16876>>2],f=-1<<k^-1,!u[w+46|0]|f&(o|s)||(n=Kl(w,s>>k,o>>k));i:{if(!(!u[w+45|0]|(s|f&o))||n|l){k=i[A+18592>>2]+800|0;break i}k=A+18532|0}f=i[k>>2];i:{e:{l=s-1|0;r:{if(!Uo(i[A+18588>>2],s,o,l,o)){n=i[A+18588>>2],k=f;break r}if(n=i[A+18588>>2],_=i[h+16936>>2],k=f,i[A+4>>2]!=i[(i[w+8496>>2]+(l>>_<<2)|0)+(g(i[h+16924>>2],o>>_)<<2)>>2]>>(i[h+16876>>2]-_<<1))break r;if(k=l,l=i[n+168>>2],k=k>>l,(k|0)<0||(_=i[n+172>>2],(_|0)<=(k|0)))break e;if(l=o>>l,(l|0)<0|(l|0)>=i[n+176>>2])break i;k=t[((i[n+160>>2]+g(k,3)|0)+g(g(l,_),3)|0)+2|0]}l=n,n=o-1|0;r:{if(!Uo(l,s,o,s,n)||(o=i[h+16936>>2],i[A+4>>2]!=i[(i[w+8496>>2]+(s>>o<<2)|0)+(g(i[h+16924>>2],n>>o)<<2)>>2]>>(i[h+16876>>2]-o<<1)))break r;if(l=s,f=i[A+18588>>2],s=i[f+168>>2],o=l>>s,(o|0)<0||(l=i[f+172>>2],(l|0)<=(o|0)))break e;if(n=n>>s,(n|0)<0|(n|0)>=i[f+176>>2])break i;f=t[((i[f+160>>2]+g(o,3)|0)+g(g(n,l),3)|0)+2|0]}k=i[A+18504>>2]+((f+k|0)+1>>1)|0,f=i[h+16836>>2],n=((k+(f<<1)|0)+52|0)%(f+52|0)|0,i[A+18536>>2]=(n|0)>0?n:0,s=i[h+16844>>2],k=0-s|0,o=n-f|0,f=i[A+18516>>2]+(i[B+756>>2]+(o+i[w+36>>2]|0)|0)|0,n=(f|0)<(k|0)?k:(f|0)>=57?57:f,f=i[A+18512>>2]+(i[B+752>>2]+(o+i[w+32>>2]|0)|0)|0,f=(f|0)<(k|0)?k:(f|0)>=57?57:f;r:{if(i[h+16848>>2]!=1)break r;f:{if((f|0)<30)break f;if(f>>>0>=43){f=f-6|0;break f}f=i[(f<<2)+69640>>2]}if((n|0)<30)break r;if(n>>>0>=43){n=n-6|0;break r}n=i[(n<<2)+69640>>2]}if(k=n+s|0,i[A+18544>>2]=(k|0)>0?k:0,k=f+s|0,i[A+18540>>2]=(k|0)>0?k:0,f=i[A+18588>>2],n=i[f+168>>2],k=e>>n,(k|0)<0||(h=i[f+172>>2],(h|0)<=(k|0)))break e;if(e=r>>n,(e|0)<0|i[f+176>>2]<=(e|0))break i;if(f=i[f+160>>2],r=(f+g(k,3)|0)+g(g(e,h),3)|0,r=(u[r|0]|u[r+1|0]<<8)&7,r=(r>>>0<=3?3:r)-n|0,(r|0)!=31)for(r=1<<r,n=r+e|0,s=r+k|0;;){for(w=(f+g(g(e,h),3)|0)+2|0,r=k;t[w+g(r,3)|0]=o,r=r+1|0,(s|0)>(r|0););if(e=e+1|0,!((n|0)>(e|0)))break}i[A+18520>>2]=o;return}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function Qe(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;k=e-1|0,f=k,r=(k|0)/2|0,k=e+65535>>>0<131073,s=k?f:r,n=i[A+124>>2],o=n>>31,e=k?2:1,r=i[A+128>>2];i:{if((e|0)==(r|0)){if(f=(s>>31)+o|0,o=n+s|0,f=o>>>0<s>>>0?f+1|0:f,r=f,!(o- -2147483648>>>0<2147483648?r+1|0:r))break i;e=r>>31,f=e,e=o+(e|1)|0,f=f+r|0,o=p2(e,e>>>0<o>>>0?f+1|0:f,2,0),e=1;break i}if(e=r,l=e>>31,r=L0(e,l,s,s>>31),h=h0,w=r,s=n,r=k&31,(k&63)>>>0>=32?(f=n<<r,n=0):(f=(1<<r)-1&s>>>32-r|o<<r,n=s<<r),o=w+n|0,r=f+h|0,r=n>>>0>o>>>0?r+1|0:r,h=0-(r+(o>>>0>2147483647)|0)|0,s=e,n=k&31,(k&63)>>>0>=32?(f=e<<n,k=0):(f=(1<<n)-1&s>>>32-n|l<<n,k=s<<n),e=k,n=f,e=0-(f+(e>>>0>2147483647)|0)|h,(e|0)==1|e>>>0>1)for(;e=n>>31,f=e,e=k+(e|1)|0,f=f+n|0,k=p2(e,e>>>0<k>>>0?f+1|0:f,2,0),n=h0,e=r>>31,f=e,e=o+(e|1)|0,r=f+r|0,o=p2(e,e>>>0<o>>>0?r+1|0:r,2,0),e=h0,r=e,(e-(o>>>0<2147483648)|0)!=-1;);e=k}if(n=i[A+108>>2],r=n,k=i[A+112>>2],A=r-k|0,n=k>>31,r=(r>>31)-(n+(r>>>0<k>>>0)|0)|0,f=0-(r+(A>>>0>2147483647)|0)|0-((k>>>0>2147483647)+n|0),(f|0)==1|f>>>0>1){for(;f=n>>31,l=k+(f|1)|0,f=f+n|0,k=p2(l,k>>>0>l>>>0?f+1|0:f,2,0),n=h0,f=r>>31,l=A+(f|1)|0,r=f+r|0,A=p2(l,A>>>0>l>>>0?r+1|0:r,2,0),r=h0,(r-(A>>>0<2147483648)|0)!=-1;);n=k>>31}f=n<<1|k>>>31,k=k<<1,r=f,l=A>>31,f=0-(r+(k>>>0>2147483646)|0)|0-(l+(A>>>0>2147483647)|0),(f|0)==1|f>>>0>1&&(f=n>>31,n=k+(f|1)|0,r=f+r|0,k=p2(n,n>>>0<k>>>0?r+1|0:r,2,0),f=l>>31,n=A+(f|1)|0,f=f+l|0,A=p2(n,A>>>0>n>>>0?f+1|0:f,2,0)),n=o>>31;i:{if((e|0)==(k|0)){if(k=A,r=o-k|0,n=n-((k>>31)+(k>>>0>o>>>0)|0)|0,k=r,A=e,r=e>>31,!(0-(n+(k>>>0>2147483647)|0)|0-(r+(e>>>0>2147483647)|0)))break i;for(;e=r>>31,f=e,e=A+(e|1)|0,f=f+r|0,A=p2(e,A>>>0>e>>>0?f+1|0:f,2,0),r=h0,e=n>>31,o=k+(e|1)|0,e=e+n|0,k=p2(o,k>>>0>o>>>0?e+1|0:e,2,0),e=h0,n=e,(e-(k>>>0<2147483648)|0)!=-1;);e=A;break i}if(r=k>>31,n=L0(k,r,o,n),f=h0,l=e>>31,A=L0(e,l,A,A>>31),o=n-A|0,n=f-(h0+(A>>>0>n>>>0)|0)|0,A=L0(k,r,e,l),k=o,r=h0,e=0-((k>>>0>2147483647)+n|0)|0-(r+(A>>>0>2147483647)|0),(e|0)==1|e>>>0>1)for(;e=r>>31,f=e,e=A+(e|1)|0,f=f+r|0,A=p2(e,A>>>0>e>>>0?f+1|0:f,2,0),o=h0,r=o,f=r-(A>>>0<2147483648)|0,e=n>>31,o=k+(e|1)|0,e=e+n|0,k=p2(o,k>>>0>o>>>0?e+1|0:e,2,0),e=h0,n=e,(e-(k>>>0<2147483648)&f)!=-1;);e=A}return n=(e|0)/2|0,A=k+n|0,r=(n>>31)+(k>>31)|0,p2(A,A>>>0<k>>>0?r+1|0:r,e,e>>31)}function $r(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;o=v-16|0,v=o;i:{e:{r:{if(i[A+152>>2])break r;e=C(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=98828,f=e+16|0,r=f,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,t[e+112|0]=0,i[e+32>>2]=1836019574,i[r>>2]=98868,i[A+152>>2]=r,r=i[A+156>>2],i[A+156>>2]=e;f:{A:{if(!r){k=A+16|0;break A}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),k=A+16|0,f=i[A+152>>2],e=i[A+156>>2],e)break A;e=0;break f}i[e+4>>2]=i[e+4>>2]+1}r=i[k+4>>2],n=i[k+8>>2];f:{if(r>>>0<n>>>0){i[r+4>>2]=e,i[r>>2]=f,e=r+8|0;break f}if(s=i[k>>2],h=r-s|0,w=h>>3,r=w+1|0,r>>>0>=536870912)break e;if(n=n-s|0,l=n>>2,n=n>>>0>=2147483640?536870911:r>>>0<l>>>0?l:r,n){if(n>>>0>=536870912)break i;r=C(n<<3)}else r=0;if(l=r+h|0,i[l+4>>2]=e,i[l>>2]=f,f=l-(w<<3)|0,h&&z(f,s,h),i[k+8>>2]=r+(n<<3),e=l+8|0,i[k+4>>2]=e,i[k>>2]=f,!s)break f;Z(s)}i[k+4>>2]=e,e=C(200),i[e>>2]=98948,i[e+4>>2]=0,i[e+8>>2]=0,f=e+16|0,r=f,i[r+8>>2]=0,i[r+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[e+16>>2]=111416,r=i[13772],i[e+160>>2]=i[13771],i[e+164>>2]=r,i[e+120>>2]=0,i[e+124>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,X[e+156>>1]=256,i[e+152>>2]=65536,r=i[13774],i[e+168>>2]=i[13773],i[e+172>>2]=r,r=i[13776],i[e+176>>2]=i[13775],i[e+180>>2]=r,r=i[13778],i[e+184>>2]=i[13777],i[e+188>>2]=r,i[e+192>>2]=i[13779],i[e+196>>2]=0,i[e+32>>2]=1836476516,i[A+160>>2]=f,r=i[A+164>>2],i[A+164>>2]=e;f:{A:{if(!r){k=i[A+152>>2],i[o+12>>2]=e,i[o+8>>2]=f;break A}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),k=i[A+152>>2],r=i[A+160>>2],e=i[A+164>>2],i[o+12>>2]=e,i[o+8>>2]=r,!e)break f}i[e+4>>2]=i[e+4>>2]+1}if(P0(k+36|0,o+8|0),A=i[o+12>>2],!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=o+16|0;return}s0(),M()}x0(),M()}function DZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;o=v-32|0,v=o;i:{e:{r:{if(i[e+28>>2]!=1885954932||(s=i[f>>2],w=i[f+4>>2],(s|0)==(w|0)))break r;for(;;){k=i[s>>2],r=i[s+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);f:{if(i[k+24>>2]==i[e+24>>2])break f;z1(o+20|0,i[k+28>>2]);A:{if(i[k+28>>2]!=1635088502||(lu(k)|0)!=1)break A;h=i[k+248>>2],l=i[k+252>>2],l&&(i[l+4>>2]=i[l+4>>2]+1);k:{if(!h){if(f=C(32),i[o+8>>2]=f,i[o+12>>2]=30,i[o+16>>2]=-2147483616,k=u[30648]|u[30649]<<8|(u[30650]<<16|u[30651]<<24),n=u[30644]|u[30645]<<8|(u[30646]<<16|u[30647]<<24),t[f|0]=n,t[f+1|0]=n>>>8,t[f+2|0]=n>>>16,t[f+3|0]=n>>>24,t[f+4|0]=k,t[f+5|0]=k>>>8,t[f+6|0]=k>>>16,t[f+7|0]=k>>>24,t[f+30|0]=0,k=u[30670]|u[30671]<<8|(u[30672]<<16|u[30673]<<24),n=u[30666]|u[30667]<<8|(u[30668]<<16|u[30669]<<24),t[f+22|0]=n,t[f+23|0]=n>>>8,t[f+24|0]=n>>>16,t[f+25|0]=n>>>24,t[f+26|0]=k,t[f+27|0]=k>>>8,t[f+28|0]=k>>>16,t[f+29|0]=k>>>24,k=u[30664]|u[30665]<<8|(u[30666]<<16|u[30667]<<24),n=u[30660]|u[30661]<<8|(u[30662]<<16|u[30663]<<24),t[f+16|0]=n,t[f+17|0]=n>>>8,t[f+18|0]=n>>>16,t[f+19|0]=n>>>24,t[f+20|0]=k,t[f+21|0]=k>>>8,t[f+22|0]=k>>>16,t[f+23|0]=k>>>24,k=u[30656]|u[30657]<<8|(u[30658]<<16|u[30659]<<24),n=u[30652]|u[30653]<<8|(u[30654]<<16|u[30655]<<24),t[f+8|0]=n,t[f+9|0]=n>>>8,t[f+10|0]=n>>>16,t[f+11|0]=n>>>24,t[f+12|0]=k,t[f+13|0]=k>>>8,t[f+14|0]=k>>>16,t[f+15|0]=k>>>24,a(A,2,0,o+8|0),t[o+19|0]>=0)break k;Z(i[o+8>>2]);break k}if(m5(o+8|0,h,1635088492),f=i[o+8>>2],n=i[o+12>>2],(f|0)!=(n|0)){_=i[e+24>>2];n:{for(;;){if(i[f>>2]!=(_|0)){if(f=f+4|0,(n|0)!=(f|0))continue;break n}break}if(f=0,k=Z0(k,113600,113736),!r|!k||(i[r+4>>2]=i[r+4>>2]+1,f=r),i[e+324>>2]=k,k=i[e+328>>2],i[e+328>>2]=f,!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break n;W[i[i[k>>2]+8>>2]](k),y(k)}f=i[o+8>>2]}if(!f)break k;i[o+12>>2]=f,Z(f)}k:{if(!l||(f=i[l+4>>2],i[l+4>>2]=f-1,f))break k;W[i[i[l>>2]+8>>2]](l),y(l)}if(!h)break e}if(t[o+31|0]>=0)break f;Z(i[o+20>>2])}f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(s=s+8|0,(w|0)==(s|0))break}}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}if(t[o+31|0]<0&&Z(i[o+20>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}v=o+32|0}function UZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0;k=v-32|0,v=k,S2(k,e,r),t[k+19|0]<0&&Z(i[k+8>>2]);i:{if(u[e+97|0]){B1(A,e,19600);break i}if(o=F0(r),!o){if(e=C(32),i[k+20>>2]=e,i[k+24>>2]=29,i[k+28>>2]=-2147483616,r=u[26378]|u[26379]<<8|(u[26380]<<16|u[26381]<<24),f=u[26374]|u[26375]<<8|(u[26376]<<16|u[26377]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+29|0]=0,r=u[26399]|u[26400]<<8|(u[26401]<<16|u[26402]<<24),f=u[26395]|u[26396]<<8|(u[26397]<<16|u[26398]<<24),t[e+21|0]=f,t[e+22|0]=f>>>8,t[e+23|0]=f>>>16,t[e+24|0]=f>>>24,t[e+25|0]=r,t[e+26|0]=r>>>8,t[e+27|0]=r>>>16,t[e+28|0]=r>>>24,r=u[26394]|u[26395]<<8|(u[26396]<<16|u[26397]<<24),f=u[26390]|u[26391]<<8|(u[26392]<<16|u[26393]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[26386]|u[26387]<<8|(u[26388]<<16|u[26389]<<24),f=u[26382]|u[26383]<<8|(u[26384]<<16|u[26385]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(n=i[f+80>>2],!(!n|n>>>0>=o>>>0)){if(e=C(88),i[k+20>>2]=e,i[k+24>>2]=83,i[k+28>>2]=-2147483560,z(e,25979,83),t[e+83|0]=0,a(A,2,0,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(D4(A,e+116|0,g(o,12),f,14965),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),h=e+104|0,s=i[e+104>>2],n=(i[e+108>>2]-s|0)/12|0;e:{if(n>>>0<o>>>0){So(h,o-n|0);break e}if(n>>>0<=o>>>0)break e;i[e+108>>2]=s+g(o,12)}for(e=0;;){if(w=F0(r),n=F0(r),s=F0(r),!n){if(e=A,A=V2(k+20|0,24083),a(e,2,0,A),t[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(!s){if(e=A,A=V2(k+20|0,29147),a(e,2,0,A),t[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(l=i[f+80>>2],!(!l|n>>>0<=l>>>0)){if(e=A,A=V2(k+20|0,26063),a(e,2,0,A),t[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(l=i[h>>2]+g(e,12)|0,i[l+8>>2]=s,i[l+4>>2]=n,i[l>>2]=w,e=e+1|0,(o|0)==(e|0))break}if(u[r+20|0]==1){if(t[k+20|0]=0,t[k+31|0]=0,a(A,2,100,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function MZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;o=v+-64|0,v=o,B=W[i[i[e>>2]+52>>2]](e,r,0)|0,h=o+40|0,l=v-16|0,v=l,p0(r,0),u2(r,0),u2(r,p[e+100>>1]),u2(r,p[e+102>>1]),u2(r,0),p0(r,i[e+104>>2]),p0(r,i[e+108>>2]),p0(r,i[e+112>>2]),u2(r,p[e+116>>1]),u2(r,p[e+118>>1]),p0(r,i[e+120>>2]),p0(r,i[e+124>>2]),p0(r,0),u2(r,p[e+128>>1]);i:{if(t[e+143|0]>=0){i[l+8>>2]=i[e+140>>2],f=i[e+136>>2],i[l>>2]=i[e+132>>2],i[l+4>>2]=f;break i}T(l,i[e+132>>2],i[e+136>>2])}i:{e:{f=i[r+12>>2]+32|0,k=i[r+4>>2],s=i[r>>2],w=k-s|0;r:{if(f>>>0<=w>>>0)break r;if(n=f-w|0,_=i[r+8>>2],n>>>0<=_-k>>>0){n&&l0(k,0,n),i[r+4>>2]=k+n;break r}if((f|0)<0)break e;if(k=_-s|0,_=k<<1,_=k>>>0>=1073741823?2147483647:f>>>0<_>>>0?_:f,k=C(_),n&&l0(k+w|0,0,n),w&&z(k,s,w),i[r+8>>2]=k+_,i[r+4>>2]=f+k,i[r>>2]=k,!s)break r;Z(s)}if(k=i[l+4>>2],f=t[l+11|0],s=i[r+12>>2],i[r+12>>2]=s+1,n=0,f=(f|0)<0?k:f,t[s+i[r>>2]|0]=f>>>0>31?31:f,k=t[l+11|0],f=(k|0)<0?i[l+4>>2]:k,!f)break i;for(k=k>>>31|0;;){if(f=u[(k?i[l>>2]:l)+n|0],k=i[r+12>>2],i[r+12>>2]=k+1,t[k+i[r>>2]|0]=f,k=t[l+11|0],f=(k|0)<0?i[l+4>>2]:k,n=n+1|0,n>>>0>=31)break i;if(k=k>>>31|0,!(f>>>0>n>>>0))break}break i}s0(),M()}i:{if(f>>>0>=31)break i;if(k=30-f|0,s=(f^-1)+32&3,s)for(n=0;w=i[r+12>>2],i[r+12>>2]=w+1,t[w+i[r>>2]|0]=0,f=f+1|0,n=n+1|0,(s|0)!=(n|0););if(k>>>0<3)break i;for(;n=i[r+12>>2],i[r+12>>2]=n+1,t[n+i[r>>2]|0]=0,n=i[r+12>>2],i[r+12>>2]=n+1,t[n+i[r>>2]|0]=0,n=i[r+12>>2],i[r+12>>2]=n+1,t[n+i[r>>2]|0]=0,n=i[r+12>>2],i[r+12>>2]=n+1,t[n+i[r>>2]|0]=0,f=f+4|0,(f|0)!=31;);}t[l+11|0]<0&&Z(i[l>>2]),u2(r,p[e+144>>1]),u2(r,p[e+146>>1]),f=i[28729],i[h>>2]=i[28728],i[h+4>>2]=f,h=h+8|0;i:{if(t[114931]>=0){f=i[28731],i[h>>2]=i[28730],i[h+4>>2]=f,i[h+8>>2]=i[28732];break i}T(h,i[28730],i[28731])}v=l+16|0;i:{if(i[o+40>>2]){e=i[o+44>>2],i[A>>2]=i[o+40>>2],i[A+4>>2]=e,i[A+16>>2]=i[o+56>>2],e=i[o+52>>2],i[A+8>>2]=i[o+48>>2],i[A+12>>2]=e,i[o+56>>2]=0,i[o+48>>2]=0,i[o+52>>2]=0;break i}if(Pl(o+20|0,e,r),t[o+39|0]<0&&Z(i[o+28>>2]),n1(o,e,r,B),t[o+19|0]<0&&Z(i[o+8>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}t[o+59|0]<0&&Z(i[o+48>>2]),v=o- -64|0}function HZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78164,i[f+8>>2]=78144,k=i[19545],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19546],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,n=f+12|0,J0(k,n),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[f+8>>2]=k,l=f+8|0,i[l+i[k-12>>2]>>2]=i[19548],k=i[19544],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19549],i[f+64>>2]=78164,i[f>>2]=78124,i[f+8>>2]=78144,h=R0(n),i[h>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,K1(k,e,r),o=k,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(l,36497,15),n=f+148|0,z1(n,i[e+104>>2]),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),47878,1),t[f+159|0]<0&&Z(i[f+148>>2]),u[e+112|0]==1&&(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(l,35081,16),i[e+108>>2]),47878,1)),u[e+120|0]==1&&(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(l,32985,34),i[e+116>>2]),47878,1)),i[e+128>>2]!=i[e+124>>2])for(k=0;;){n=f+148|0,k0(n,r),s=n,n=t[f+159|0],o=(n|0)<0,F(l,o?i[f+148>>2]:s,o?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=k+1|0,F(B0(F(l,20885,1),n),37800,4),o=g(k,12),k=i[(o+i[e+124>>2]|0)+4>>2];i:{if(k){if(o=f+148|0,W[i[i[k>>2]+8>>2]](o,k),s=o,k=t[f+159|0],o=(k|0)<0,F(F(l,o?i[f+148>>2]:s,o?i[f+152>>2]:k),47878,1),t[f+159|0]>=0)break i;Z(i[f+148>>2]);break i}F(B0(F(l,22776,26),i[o+i[e+124>>2]>>2]),47877,2)}if(k=n,!(k>>>0<(i[e+128>>2]-i[e+124>>2]|0)/12>>>0))break}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19543],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19551],i[f+8>>2]=i[19552],i[h>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(h),Y0(f- -64|0),v=f+160|0}function Nn(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;i:{e:{r:{f:switch(e-A>>3){case 2:if(i[e-4>>2]<=i[A+4>>2])break r;return f=i[A>>2],r=i[A+4>>2],k=e-8|0,e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,i[k>>2]=f,i[k+4>>2]=r,1;case 3:if(n=e-8|0,k=e-4|0,f=i[k>>2],r=i[A+12>>2],(r|0)<=i[A+4>>2]){if((r|0)>=(f|0)||(f=i[A+8>>2],r=i[A+12>>2],e=i[n+4>>2],i[A+8>>2]=i[n>>2],i[A+12>>2]=e,i[n>>2]=f,i[n+4>>2]=r,i[A+12>>2]<=i[A+4>>2]))break r;e=i[A+8>>2],r=i[A+12>>2];break e}if(e=i[A>>2],o=i[A+4>>2],(r|0)<(f|0)){r=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=r;break i}if(f=i[A+8>>2],r=i[A+12>>2],i[A+8>>2]=e,i[A+12>>2]=o,i[A>>2]=f,i[A+4>>2]=r,(o|0)>=i[k>>2])break r;r=i[n+4>>2],i[A+8>>2]=i[n>>2],i[A+12>>2]=r;break i;case 4:return w3(A,A+8|0,A+16|0,e-8|0),1;case 5:if(w3(A,A+8|0,A+16|0,A+24|0),i[e-4>>2]<=i[A+28>>2]||(f=i[A+24>>2],r=i[A+28>>2],k=e-8|0,e=i[k+4>>2],i[A+24>>2]=i[k>>2],i[A+28>>2]=e,i[k>>2]=f,i[k+4>>2]=r,i[A+28>>2]<=i[A+20>>2])||(e=i[A+24>>2],r=i[A+28>>2],f=i[A+20>>2],i[A+24>>2]=i[A+16>>2],i[A+28>>2]=f,i[A+16>>2]=e,i[A+20>>2]=r,(r|0)<=i[A+12>>2])||(f=i[A+12>>2],i[A+16>>2]=i[A+8>>2],i[A+20>>2]=f,i[A+8>>2]=e,i[A+12>>2]=r,(r|0)<=i[A+4>>2]))break r;break e;case 0:case 1:break r;default:break f}o=i[A+20>>2],f=i[A+12>>2],k=i[A+4>>2];f:{if((f|0)<=(k|0)){if((f|0)>=(o|0)||(r=i[A+16>>2],o=i[A+20>>2],f=i[A+12>>2],i[A+16>>2]=i[A+8>>2],i[A+20>>2]=f,i[A+8>>2]=r,i[A+12>>2]=o,(k|0)>=(o|0)))break f;f=i[A+4>>2],i[A+8>>2]=i[A>>2],i[A+12>>2]=f,i[A>>2]=r,i[A+4>>2]=o;break f}if(r=i[A>>2],n=i[A+4>>2],(f|0)<(o|0)){k=i[A+16>>2],f=i[A+20>>2],i[A+16>>2]=r,i[A+20>>2]=n,i[A>>2]=k,i[A+4>>2]=f;break f}if(k=i[A+8>>2],f=i[A+12>>2],i[A+8>>2]=r,i[A+12>>2]=n,i[A>>2]=k,i[A+4>>2]=f,(n|0)>=(o|0))break f;k=i[A+16>>2],f=i[A+20>>2],i[A+16>>2]=r,i[A+20>>2]=n,i[A+8>>2]=k,i[A+12>>2]=f}if(k=A+24|0,(k|0)==(e|0))break r;for(f=A+16|0;;){f:{if(i[k+4>>2]<=i[f+4>>2])break f;for(s=i[k>>2],n=i[k+4>>2],r=k;;){A:{if(o=r,r=f,f=i[r+4>>2],i[o>>2]=i[r>>2],i[o+4>>2]=f,(A|0)==(r|0)){r=A;break A}if(f=r-8|0,i[r-4>>2]<(n|0))continue}break}if(i[r>>2]=s,i[r+4>>2]=n,l=l+1|0,(l|0)!=8)break f;return(k+8|0)==(e|0)}if(f=k,k=k+8|0,(k|0)==(e|0))break}}return 1}return f=i[A+4>>2],i[A+8>>2]=i[A>>2],i[A+12>>2]=f,i[A>>2]=e,i[A+4>>2]=r,1}return i[n>>2]=e,i[n+4>>2]=o,1}function Dn(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0;k=v-16|0,v=k,r=i[e+20>>2],f=i[r+48>>2],r=i[r+52>>2];i:{if(!r){n=sr(f,e+116|0);break i}if(i[r+4>>2]=i[r+4>>2]+1,n=sr(f,e+116|0),f=i[r+4>>2],i[r+4>>2]=f-1,f)break i;W[i[i[r>>2]+8>>2]](r),y(r)}i[e+120>>2]=i[e+116>>2],f=i[e+268>>2];i:{if(!f||(r=i[e+20>>2],l=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+16>>2]==i[f+20>>2]|u[f+28|0]!=1||(l=sr(l,f+16|0),o5(i[f+8>>2],l),i[f+20>>2]=i[f+16>>2]),!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}f=i[e+272>>2];i:{if(!f||(r=i[e+20>>2],l=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+16>>2]==i[f+20>>2]|u[f+28|0]!=1||(l=sr(l,f+16|0),o5(i[f+8>>2],l),i[f+20>>2]=i[f+16>>2]),!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}wl(i[e+200>>2],n),n=i[e+268>>2];i:{if(!n)break i;i[k+8>>2]=i[e+176>>2],r=i[e+180>>2],i[k+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f=i[e+20>>2],i[k>>2]=i[f+48>>2],f=i[f+52>>2],i[k+4>>2]=f;e:{if(!f){V3(n,k+8|0,k);break e}if(i[f+4>>2]=i[f+4>>2]+1,V3(n,k+8|0,k),n=i[f+4>>2],i[f+4>>2]=n-1,n)break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}n=i[e+272>>2];i:{if(!n)break i;i[k+8>>2]=i[e+176>>2],r=i[e+180>>2],i[k+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f=i[e+20>>2],i[k>>2]=i[f+48>>2],f=i[f+52>>2],i[k+4>>2]=f;e:{if(!f){V3(n,k+8|0,k);break e}if(i[f+4>>2]=i[f+4>>2]+1,V3(n,k+8|0,k),n=i[f+4>>2],i[f+4>>2]=n-1,n)break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=i[e+208>>2],r=i[f+104>>2],f=i[f+108>>2],(r|0)!=(f|0))for(;n=L0(i[r+4>>2],0,i[r>>2],0),o=o+h0|0,l=s,s=n+s|0,o=l>>>0>s>>>0?o+1|0:o,r=r+8|0,(f|0)!=(r|0););r=i[e+160>>2],i[r+128>>2]=s,i[r+132>>2]=o,o=i[e+224>>2],t[o+124|0]=i[i[e+232>>2]+108>>2]==i[o+108>>2]-i[o+104>>2]>>2,o=i[e+216>>2],s=i[o+108>>2],r=i[o+104>>2];i:{if((s|0)==(r|0)|(s-r|0)==8||(s=i[e+176>>2],i[k+8>>2]=o,e=i[e+220>>2],i[k+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),P0(s+36|0,k+8|0),e=i[k+12>>2],!e)||(o=i[e+4>>2],i[e+4>>2]=o-1,o))break i;W[i[i[e>>2]+8>>2]](e),y(e)}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,v=k+16|0}function Ve(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=113576,e=i[A+288>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}zi(A+280|0,0),zi(A+276|0,0),xi(A+272|0,0),xi(A+268|0,0),t[A+267|0]<0&&Z(i[A+256>>2]),e=i[A+252>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+244>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+236>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+228>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+220>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+212>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+204>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+196>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+188>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+180>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+172>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+164>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+156>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+148>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+140>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+132>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),e=i[A+104>>2],e){if(r=e,f=i[A+108>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+104>>2]}i[A+108>>2]=e,Z(r)}return e=i[A+68>>2],e&&(i[A+72>>2]=e,Z(e)),a2(i[A+44>>2]),t[A+63|0]<0&&Z(i[A+52>>2]),t[A+15|0]<0&&Z(i[A+4>>2]),A|0}function pe(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;k=e-1|0,r=k,f=(k|0)/2|0,k=e+65535>>>0<131073,s=k?r:f,n=i[A+116>>2],o=n>>31,e=k?2:1,f=i[A+120>>2];i:{if((e|0)==(f|0)){if(r=(s>>31)+o|0,o=n+s|0,r=o>>>0<s>>>0?r+1|0:r,f=r,!(o- -2147483648>>>0<2147483648?r+1|0:r))break i;e=r>>31,r=e,e=o+(e|1)|0,r=r+f|0,o=p2(e,e>>>0<o>>>0?r+1|0:r,2,0),e=1;break i}if(e=f,l=e>>31,f=L0(e,l,s,s>>31),h=h0,w=f,s=n,f=k&31,(k&63)>>>0>=32?(r=n<<f,n=0):(r=(1<<f)-1&s>>>32-f|o<<f,n=s<<f),o=w+n|0,f=r+h|0,f=n>>>0>o>>>0?f+1|0:f,h=0-(f+(o>>>0>2147483647)|0)|0,s=e,n=k&31,(k&63)>>>0>=32?(r=e<<n,k=0):(r=(1<<n)-1&s>>>32-n|l<<n,k=s<<n),e=k,n=r,e=0-(r+(e>>>0>2147483647)|0)|h,(e|0)==1|e>>>0>1)for(;e=n>>31,r=e,e=k+(e|1)|0,r=r+n|0,k=p2(e,e>>>0<k>>>0?r+1|0:r,2,0),n=h0,e=f>>31,r=e,e=o+(e|1)|0,f=r+f|0,o=p2(e,e>>>0<o>>>0?f+1|0:f,2,0),e=h0,f=e,(e-(o>>>0<2147483648)|0)!=-1;);e=k}if(n=i[A+100>>2],f=n,k=i[A+104>>2],A=f-k|0,n=k>>31,f=(f>>31)-(n+(f>>>0<k>>>0)|0)|0,r=0-(f+(A>>>0>2147483647)|0)|0-((k>>>0>2147483647)+n|0),(r|0)==1|r>>>0>1){for(;r=n>>31,l=k+(r|1)|0,r=r+n|0,k=p2(l,k>>>0>l>>>0?r+1|0:r,2,0),n=h0,r=f>>31,l=A+(r|1)|0,f=r+f|0,A=p2(l,A>>>0>l>>>0?f+1|0:f,2,0),f=h0,(f-(A>>>0<2147483648)|0)!=-1;);n=k>>31}r=n<<1|k>>>31,k=k<<1,f=r,l=A>>31,r=0-(r+(k>>>0>2147483646)|0)|0-(l+(A>>>0>2147483647)|0),(r|0)==1|r>>>0>1&&(r=n>>31,n=k+(r|1)|0,f=r+f|0,k=p2(n,n>>>0<k>>>0?f+1|0:f,2,0),r=l>>31,n=A+(r|1)|0,r=r+l|0,A=p2(n,A>>>0>n>>>0?r+1|0:r,2,0)),n=o>>31;i:{if((e|0)==(k|0)){if(k=A,f=o-k|0,n=n-((k>>31)+(k>>>0>o>>>0)|0)|0,k=f,A=e,f=e>>31,!(0-(n+(k>>>0>2147483647)|0)|0-(f+(e>>>0>2147483647)|0)))break i;for(;e=f>>31,r=e,e=A+(e|1)|0,r=r+f|0,A=p2(e,A>>>0>e>>>0?r+1|0:r,2,0),f=h0,e=n>>31,o=k+(e|1)|0,e=e+n|0,k=p2(o,k>>>0>o>>>0?e+1|0:e,2,0),e=h0,n=e,(e-(k>>>0<2147483648)|0)!=-1;);e=A;break i}if(f=k>>31,n=L0(k,f,o,n),r=h0,l=e>>31,A=L0(e,l,A,A>>31),o=n-A|0,n=r-(h0+(A>>>0>n>>>0)|0)|0,A=L0(k,f,e,l),k=o,f=h0,e=0-((k>>>0>2147483647)+n|0)|0-(f+(A>>>0>2147483647)|0),(e|0)==1|e>>>0>1)for(;e=f>>31,r=e,e=A+(e|1)|0,r=r+f|0,A=p2(e,A>>>0>e>>>0?r+1|0:r,2,0),o=h0,f=o,r=f-(A>>>0<2147483648)|0,e=n>>31,o=k+(e|1)|0,e=e+n|0,k=p2(o,k>>>0>o>>>0?e+1|0:e,2,0),e=h0,n=e,(e-(k>>>0<2147483648)&r)!=-1;);e=A}return(k|0)/(e|0)|0}function zZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78164,i[f+8>>2]=78144,k=i[19545],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19546],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,s=f+12|0,J0(k,s),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[f+8>>2]=k,o=f+8|0,i[o+i[k-12>>2]>>2]=i[19548],k=i[19544],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19549],i[f+64>>2]=78164,i[f>>2]=78124,i[f+8>>2]=78144,s=R0(s),i[s>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,K1(k,e,r),l=k,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(o,36402,15),k=i[e+104>>2];i:{if(!k){F(o,46949,2);break i}if(n=f+148|0,z1(n,k),l=n,k=t[f+159|0],n=(k|0)<0,F(F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),47878,1),t[f+159|0]>=0)break i;Z(i[f+148>>2])}k=f+148|0,k0(k,r),l=k,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(o,34231,25),k=i[e+108>>2];i:{if(!k){F(o,46949,2);break i}if(n=f+148|0,z1(n,k),l=n,k=t[f+159|0],n=(k|0)<0,F(F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),47878,1),t[f+159|0]>=0)break i;Z(i[f+148>>2])}k=f+148|0,k0(k,r),l=k,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(o,35931,21),k=u[e+112|0];i:{if(!k){F(o,47699,13);break i}F(D0(o,k),47878,1)}if(!(u[e+112|0]|i[e+124>>2]==i[e+120>>2]))for(k=0;n=f+148|0,k0(n,r),l=n,n=t[f+159|0],h=(n|0)<0,F(o,h?i[f+148>>2]:l,h?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(B0(F(o,20885,1),k),37800,4),u[i[e+120>>2]+k|0]),47878,1),k=k+1|0,k>>>0<i[e+124>>2]-i[e+120>>2]>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,t[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){o=k|7,e=C(o+1|0),i[A+8>>2]=o-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(t[A+11|0]=k,k)break e;k=0;break i}I0(),M()}if(!k)break i;z(A,r,k)}t[A+k|0]=0,A=i[19543],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19551],i[f+8>>2]=i[19552],i[s>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(s),Y0(f- -64|0),v=f+160|0}function D8(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;i:{e:switch(r|0){case 1:for(r=0,k=i[i[17266]+12>>2];n=k+(r<<1)|0,t[((u[n+1|0]<<3)+A|0)+u[n|0]|0]=u[e+r|0],n=r|1,l=k+(n<<1)|0,t[((u[l+1|0]<<3)+A|0)+u[l|0]|0]=u[e+n|0],r=r+2|0,(r|0)!=64;);break i;case 2:for(n=A+1|0,l=i[i[17266]+12>>2];r=l+(k<<1)|0,o=e+k|0,s=u[o|0],t[((u[r|0]<<1)+A|0)+(u[r+1|0]<<5)|0]=s,t[(n+(u[r|0]<<1)|0)+(u[r+1|0]<<5)|0]=s,o=u[o|0],t[(((u[r|0]<<1)+A|0)+(u[r+1|0]<<5)|0)+16|0]=o,t[((n+(u[r|0]<<1)|0)+(u[r+1|0]<<5)|0)+16|0]=o,k=k+1|0,(k|0)!=64;);break i;case 3:for(n=A+3|0,l=A+2|0,o=A+1|0,h=i[i[17266]+12>>2];r=(s<<1)+h|0,k=e+s|0,f=u[k|0],t[((u[r|0]<<2)+A|0)+(u[r+1|0]<<7)|0]=f,t[(o+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0]=f,f=u[k|0],t[(l+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0]=f,t[(n+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0]=f,f=u[k|0],t[(((u[r|0]<<2)+A|0)+(u[r+1|0]<<7)|0)+32|0]=f,t[((o+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0)+32|0]=f,f=u[k|0],t[((l+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0)+32|0]=f,t[((n+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0)+32|0]=f,f=u[k|0],t[(((u[r|0]<<2)+A|0)+(u[r+1|0]<<7)|0)+64|0]=f,t[((o+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0)+64|0]=f,f=u[k|0],t[((l+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0)+64|0]=f,t[((n+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0)+64|0]=f,f=u[k|0],t[(((u[r|0]<<2)+A|0)+(u[r+1|0]<<7)|0)+96|0]=f,t[((o+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0)+96|0]=f,k=u[k|0],t[((l+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0)+96|0]=k,t[((n+(u[r|0]<<2)|0)+(u[r+1|0]<<7)|0)+96|0]=k,s=s+1|0,(s|0)!=64;);break i;default:U0(24033,19868,865,6877),M();case 0:break e}r=i[i[17266]+8>>2],t[((u[r+1|0]<<2)+A|0)+u[r|0]|0]=u[e|0],t[u[r+2|0]+((u[r+3|0]<<2)+A|0)|0]=u[e+1|0],t[u[r+4|0]+((u[r+5|0]<<2)+A|0)|0]=u[e+2|0],t[u[r+6|0]+((u[r+7|0]<<2)+A|0)|0]=u[e+3|0],t[u[r+8|0]+((u[r+9|0]<<2)+A|0)|0]=u[e+4|0],t[u[r+10|0]+((u[r+11|0]<<2)+A|0)|0]=u[e+5|0],t[u[r+12|0]+((u[r+13|0]<<2)+A|0)|0]=u[e+6|0],t[u[r+14|0]+((u[r+15|0]<<2)+A|0)|0]=u[e+7|0],t[u[r+16|0]+((u[r+17|0]<<2)+A|0)|0]=u[e+8|0],t[u[r+18|0]+((u[r+19|0]<<2)+A|0)|0]=u[e+9|0],t[u[r+20|0]+((u[r+21|0]<<2)+A|0)|0]=u[e+10|0],t[u[r+22|0]+((u[r+23|0]<<2)+A|0)|0]=u[e+11|0],t[u[r+24|0]+((u[r+25|0]<<2)+A|0)|0]=u[e+12|0],t[u[r+26|0]+((u[r+27|0]<<2)+A|0)|0]=u[e+13|0],t[u[r+28|0]+((u[r+29|0]<<2)+A|0)|0]=u[e+14|0],t[u[r+30|0]+((u[r+31|0]<<2)+A|0)|0]=u[e+15|0]}}function VA(A,e,r){var f=0,k=0,n=0,o=0,l=0;k=v-48|0,v=k,n=i[e+48>>2],o=i[e+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),f=v-32|0,v=f,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,L1(f,n,r,f+20|0);i:{if(i[f>>2]){i[k+40>>2]=0,i[k+44>>2]=0;break i}e:{if(n=i[f+20>>2],r=i[f+24>>2],(n|0)!=(r|0)){if(e=i[n>>2],e&&(l=i[k+44>>2],e=Z0(e,92792,95876),e))break e;if(n=n+8|0,(r|0)!=(n|0))for(;;){if(e=i[n>>2],e&&(l=0,e=Z0(e,92792,95876),e))break e;if(n=n+8|0,(r|0)==(n|0))break}i[k+40>>2]=0,i[k+44>>2]=0}i[k+40>>2]=0,i[k+44>>2]=0;break i}if(i[k+44>>2]=l,i[k+40>>2]=e,e=i[n+4>>2],i[k+44>>2]=e,!e)break i;i[e+4>>2]=i[e+4>>2]+1}if(t[f+19|0]<0&&Z(i[f+8>>2]),r=i[f+20>>2],r){if(e=r,n=i[f+24>>2],(e|0)!=(n|0)){for(;;){e=i[n-4>>2];i:{if(!e||(l=i[e+4>>2],i[e+4>>2]=l-1,l))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(n=n-8|0,(r|0)==(n|0))break}e=i[f+20>>2]}i[f+24>>2]=r,Z(e)}v=f+32|0,e=i[k+40>>2];i:{if(!e){e=C(32),i[k+4>>2]=e,i[k+8>>2]=26,i[k+12>>2]=-2147483616,r=u[10439]|u[10440]<<8,t[e+24|0]=r,t[e+25|0]=r>>>8,r=u[10435]|u[10436]<<8|(u[10437]<<16|u[10438]<<24),f=u[10431]|u[10432]<<8|(u[10433]<<16|u[10434]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[10427]|u[10428]<<8|(u[10429]<<16|u[10430]<<24),f=u[10423]|u[10424]<<8|(u[10425]<<16|u[10426]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[10419]|u[10420]<<8|(u[10421]<<16|u[10422]<<24),f=u[10415]|u[10416]<<8|(u[10417]<<16|u[10418]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+26|0]=0,e=a(k+16|0,2,116,k+4|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(t[k+15|0]<0&&Z(i[k+4>>2]),A=i[k+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}r=i[k+44>>2],t[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}i:{if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o)}v=k+48|0}function xZ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;r=v-112|0,v=r,l=i[e+72>>2],f=i[l+176>>2],k=i[l+180>>2];i:{if((f|0)!=(k|0))for(;;){if(u[f+1|0]==15&&(l=i[f+4>>2],(l|0)!=i[f+8>>2]))break i;if(f=f+16|0,(k|0)==(f|0))break}l=0}i:{if(!(i[l>>2]!=i[l+4>>2]&&l)){t[A+24|0]=0,t[A+12|0]=0,t[A+4|0]=0;break i}e=i[e+72>>2],f=i[e+108>>2],i[r+40>>2]=i[e+104>>2],i[r+44>>2]=f,i[r+48>>2]=i[e+112>>2],X[r+52>>1]=p[e+116>>1],i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0;e:{r:{f:{A:{if(f=i[e+124>>2],n=i[e+120>>2],(f|0)!=(n|0)){if(f=f-n|0,(f|0)<0)break A;k=C(f),i[r+60>>2]=k,i[r+56>>2]=k,o=f+k|0,i[r+64>>2]=o,f&&z(k,n,f),i[r+60>>2]=o}o=0,i[r+76>>2]=0,i[r+68>>2]=0,i[r+72>>2]=0;k:{if(f=i[e+136>>2],!f)break k;if((f|0)>=0){k=(f-1>>>5|0)+1|0,f=C(k<<2),i[r+76>>2]=k,i[r+72>>2]=0,i[r+68>>2]=f,k=i[e+132>>2],n=i[e+136>>2],i[r+72>>2]=n;n:{if(n>>>0>=33){i[(n-1>>>3&536870908)+f>>2]=0;break n}if(i[f>>2]=0,!n)break k}for(h=n&31,w=(n>>>3&536870908)+k|0,n=0;s=1<<n,i[k>>2]>>>o&1?s=s|i[f>>2]:s=i[f>>2]&(s^-1),i[f>>2]=s,s=(n|0)==31,n=s?0:n+1|0,f=(s?4:0)+f|0,s=(o|0)==31,k=(s?4:0)+k|0,o=s?0:o+1|0,!!((h|0)!=(o|0)|(k|0)!=(w|0)););break k}s0(),M()}if(i[r+88>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,f=i[e+148>>2],n=i[e+144>>2],(f|0)!=(n|0)){if(f=f-n|0,(f|0)<0)break f;k=C(f),i[r+84>>2]=k,i[r+80>>2]=k,o=f+k|0,i[r+88>>2]=o,f&&z(k,n,f),i[r+84>>2]=o}if(i[r+100>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,f=i[e+160>>2],n=i[e+156>>2],(f|0)!=(n|0)){if(f=f-n|0,(f|0)<0)break r;k=C(f),i[r+96>>2]=k,i[r+92>>2]=k,o=f+k|0,i[r+100>>2]=o,f&&z(k,n,f),i[r+96>>2]=o}break e}s0(),M()}s0(),M()}s0(),M()}X[r+108>>1]=p[e+172>>1],i[r+104>>2]=i[e+168>>2],e=0,i[r+36>>2]=0,i[r+32>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,f=i[l>>2],Tr(r,f,i[l+4>>2]-f|0,r+40|0,r+36|0,r+32|0,r+24|0);e:{if(i[r>>2]){if(e=A+12|0,f=i[r+4>>2],i[A+4>>2]=i[r>>2],i[A+8>>2]=f,t[r+19|0]>=0){f=i[r+12>>2],i[e>>2]=i[r+8>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+16>>2],e=1;break e}T(e,i[r+8>>2],i[r+12>>2]),e=1;break e}f=i[r+28>>2],l=i[r+24>>2],t[A+12|0]=1,i[A+4>>2]=l,i[A+8>>2]=f}if(t[A+24|0]=e,t[r+19|0]<0&&Z(i[r+8>>2]),A=i[r+92>>2],A&&(i[r+96>>2]=A,Z(A)),A=i[r+80>>2],A&&(i[r+84>>2]=A,Z(A)),A=i[r+68>>2],A&&Z(A),A=i[r+56>>2],!A)break i;i[r+60>>2]=A,Z(A)}v=r+112|0}function TZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0;f=v-160|0,v=f,n=w2(r);i:{e:{r:{f:{A:{k:{if(n>>>0>o0[r+16>>2]/5>>>0){i[f+92>>2]=0,i[f+64>>2]=78164,i[f+8>>2]=78144,e=i[19545],i[f>>2]=e,i[i[e-12>>2]+f>>2]=i[19546],i[f+4>>2]=0,e=i[i[f>>2]-12>>2]+f|0,k=f+12|0,J0(e,k),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[f+8>>2]=e,o=i[e-12>>2],e=f+8|0,i[o+e>>2]=i[19548],o=i[19544],i[f>>2]=o,i[i[o-12>>2]+f>>2]=i[19549],i[f+64>>2]=78164,i[f>>2]=78124,i[f+8>>2]=78144,o=R0(k),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,F(B0(F(B0(F(e,32359,25),n),30895,44),o0[r+16>>2]/5|0),6012,15),e=i[f+60>>2];n:{if(e&16){k=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break n}if(!(e&8)){r=0,t[f+159|0]=0,k=f+148|0;break e}k=f+20|0,e=i[f+28>>2]}if(r=e,e=i[k>>2],r=r-e|0,r>>>0>=2147483640)break k;if(r>>>0>=11){n=r|7,k=C(n+1|0),i[f+156>>2]=n-2147483647,i[f+148>>2]=k,i[f+152>>2]=r;break r}if(t[f+159|0]=r,k=f+148|0,r)break r;r=0;break e}o=e+104|0,l=i[e+104>>2],k=(i[e+108>>2]-l|0)/6|0;n:{if(k>>>0<n>>>0){Po(o,n-k|0);break n}if(k>>>0<=n>>>0)break n;i[e+108>>2]=l+g(n,6)}k=u[r+20|0];n:{if(!(!i[r+16>>2]|(!n|k&1))){for(k=0;;){t:{if(s=w2(r),h=Q2(r),w=w2(r),l=i[o>>2]+g(k,6)|0,X[l+4>>1]=w,t[l+2|0]=h,X[l>>1]=s,l=u[r+20|0],k=k+1|0,l&1|n>>>0<=k>>>0)break t;if(i[r+16>>2])continue}break}if(l&1)break n;break A}if(!(k&1))break A}if(t[f+148|0]=0,t[f+159|0]=0,a(f,2,100,f+148|0),t[f+159|0]>=0)break f;Z(i[f+148>>2]);break f}I0(),M()}if(k=i[28729],i[f>>2]=i[28728],i[f+4>>2]=k,k=f+8|0,t[114931]>=0){n=i[28731],i[k>>2]=i[28730],i[k+4>>2]=n,i[k+8>>2]=i[28732];break f}T(k,i[28730],i[28731])}if(k=i[f>>2],t[f+19|0]<0&&Z(i[f+8>>2]),k&&(i[e+108>>2]=i[e+104>>2]),u[r+20|0]==1){if(t[f|0]=0,t[f+11|0]=0,a(A,2,100,f),t[f+11|0]>=0)break i;Z(i[f>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}if(!r)break e;z(k,e,r)}t[r+k|0]=0,a(A,2,100,f+148|0),t[f+159|0]<0&&Z(i[f+148>>2]),A=i[19543],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19551],i[f+8>>2]=i[19552],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0)}v=f+160|0}function jZ(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0;s=v-32|0,v=s;i:{e:{r:{f:{if(l=i[e+16>>2],(W[i[i[l>>2]+8>>2]](l)|0)==5){A:{if(!(!k|(!r|!f))&&n)break A;e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(l=i[e+16>>2],!l||(h=Z0(l,101112,102448),!h))break f;l=i[e+20>>2],l&&(i[l+4>>2]=i[l+4>>2]+1),i[r>>2]=i[h+4>>2],i[f>>2]=i[h+8>>2],w=i[h+12>>2],i[k>>2]=w,e=n,n=i[h+16>>2],i[e>>2]=n,h=i[h+20>>2],YA(s+16|0,w,n,2,0,o);A:{if(i[s+16>>2]){e=i[s+20>>2],i[A>>2]=i[s+16>>2],i[A+4>>2]=e,i[A+8>>2]=i[s+24>>2];break A}if(hu(s+4|0,i[o>>2],0,w,n,8),i[s+24>>2]=i[s+12>>2],r=i[s+8>>2],e=i[s+4>>2],i[s+16>>2]=e,i[s+20>>2]=r,e){i8(i[o>>2]),i[A+8>>2]=i[s+24>>2],e=i[s+20>>2],i[A>>2]=i[s+16>>2],i[A+4>>2]=e;break A}if(r=0,o=Ki(i[o>>2],0,s+4|0),!(!w|!n))for(k=0,f=0;;){for(e=0;t[(o+g(i[s+4>>2],r)|0)+e|0]=(u[((f&7)<<29|k>>>3)+h|0]<<(k&7)&128)>>>7|0?-1:0,k=k+1|0,f=k?f:f+1|0,e=e+1|0,(w|0)!=(e|0););if(r=r+1|0,(n|0)==(r|0))break}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}if(!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break i;W[i[i[l>>2]+8>>2]](l),y(l);break i}if(l=i[e+16>>2],(W[i[i[l>>2]+8>>2]](l)|0)==4){A:{if(!(!k|(!r|!f))&&n)break A;r=i[25146],i[A>>2]=i[25145],i[A+4>>2]=r,i[A+8>>2]=i[25147],r=0;break e}if(l=i[e+16>>2],!l||(h=Z0(l,101112,102360),!h))break r;if(l=i[e+20>>2],l&&(i[l+4>>2]=i[l+4>>2]+1),i[r>>2]=i[h+4>>2],i[f>>2]=i[h+8>>2],i[k>>2]=i[h+12>>2],i[n>>2]=i[h+16>>2],r=i[h+20>>2],i[A+8>>2]=i[25680],f=i[25679],i[A>>2]=i[25678],i[A+4>>2]=f,!l||(f=i[l+4>>2],i[l+4>>2]=f-1,f))break e;W[i[i[l>>2]+8>>2]](l),y(l);break e}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794];break i}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794];break i}r=i[25793],i[A>>2]=i[25792],i[A+4>>2]=r,i[A+8>>2]=i[25794],r=0}if(i[A>>2]||(f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[s+8>>2]=e,i[s+4>>2]=f,OA(A,s+4|0,r,s),i[A>>2]||(NA(s+16|0,i[s>>2],o,2,0,0),i[A+8>>2]=i[s+24>>2],e=i[s+20>>2],i[A>>2]=i[s+16>>2],i[A+4>>2]=e,oi(i[s>>2])),A=i[s+8>>2],!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=s+32|0}function dr(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0;k=v-48|0,v=k,h=i[e+4>>2],l=i[e>>2],s=h-l|0,n=s+8|0;i:{if((n|0)<0){if(e=C(48),i[k+24>>2]=e,i[k+28>>2]=46,i[k+32>>2]=-2147483600,r=u[15057]|u[15058]<<8|(u[15059]<<16|u[15060]<<24),f=u[15053]|u[15054]<<8|(u[15055]<<16|u[15056]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+46|0]=0,r=u[15095]|u[15096]<<8|(u[15097]<<16|u[15098]<<24),f=u[15091]|u[15092]<<8|(u[15093]<<16|u[15094]<<24),t[e+38|0]=f,t[e+39|0]=f>>>8,t[e+40|0]=f>>>16,t[e+41|0]=f>>>24,t[e+42|0]=r,t[e+43|0]=r>>>8,t[e+44|0]=r>>>16,t[e+45|0]=r>>>24,r=u[15089]|u[15090]<<8|(u[15091]<<16|u[15092]<<24),f=u[15085]|u[15086]<<8|(u[15087]<<16|u[15088]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[15081]|u[15082]<<8|(u[15083]<<16|u[15084]<<24),f=u[15077]|u[15078]<<8|(u[15079]<<16|u[15080]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[15073]|u[15074]<<8|(u[15075]<<16|u[15076]<<24),f=u[15069]|u[15070]<<8|(u[15071]<<16|u[15072]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[15065]|u[15066]<<8|(u[15067]<<16|u[15068]<<24),f=u[15061]|u[15062]<<8|(u[15063]<<16|u[15064]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,149,k+24|0),t[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}e:{if(!n){e=0,o=0;break e}e=C(n),n&&l0(e,0,n),o=e+n|0}t[e+7|0]=r,t[e+3|0]=n,t[e+6|0]=r>>>8,t[e+5|0]=r>>>16,t[e+4|0]=r>>>24,t[e+2|0]=n>>>8,t[e+1|0]=n>>>16,t[e|0]=n>>>24,!s|(l|0)==(h|0)||z(e+8|0,l,s),r=C(72),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101400,o=o-e|0,n=be(r+16|0,e,o,0),i[k+20>>2]=r,i[k+16>>2]=n,i[r+4>>2]=i[r+4>>2]+1,n=i[k+20>>2],i[k+8>>2]=i[k+16>>2],i[k+12>>2]=n,n=A,A=$i(k+24|0,k+8|0,o,0),c8(n,A,f,101976),A=i[A+4>>2];e:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break e;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2],i[r+4>>2]=A-1,A||(W[i[i[r>>2]+8>>2]](r),y(r)),Z(e)}v=k+48|0}function SZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=78468,n=i[19620],i[f+24>>2]=n,k=i[n-12>>2],n=f+24|0,i[k+n>>2]=i[19621],s=n+i[i[f+24>>2]-12>>2]|0,k=f+28|0,J0(s,k),t[s+80|0]=0,i[s+72>>2]=0,i[f+80>>2]=78468,i[f+24>>2]=78448,s=R0(k),i[s>>2]=77200,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,k=f+164|0,k3(k,e,r),o=n,l=k,n=t[f+175|0],k=(n|0)<0,F(o,k?i[f+164>>2]:l,k?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),n=f+164|0,k0(n,r),o=n,n=t[f+175|0],k=(n|0)<0,F(f+24|0,k?i[f+164>>2]:o,k?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),n=F(f+24|0,36960,13),k=f+12|0,z1(k,i[e+100>>2]),o=n,l=k,n=t[f+23|0],k=(n|0)<0,n=F(F(o,k?i[f+12>>2]:l,k?i[f+16>>2]:n),47878,1),k=f+164|0,k0(k,r),o=k,k=t[f+175|0],l=(k|0)<0,F(n,l?i[f+164>>2]:o,l?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),F(n,34685,15),t[f+23|0]<0&&Z(i[f+12>>2]),n=i[e+104>>2];i:{if(n>>>0<=1090519039){B0(f+24|0,n);break i}if(k=f+164|0,z1(k,n),o=k,n=t[f+175|0],k=(n|0)<0,F(f+24|0,k?i[f+164>>2]:o,k?i[f+168>>2]:n),t[f+175|0]>=0)break i;Z(i[f+164>>2])}n=F(f+24|0,47878,1),k=f+164|0,k0(k,r),o=k,r=t[f+175|0],k=(r|0)<0,F(n,k?i[f+164>>2]:o,k?i[f+168>>2]:r),t[f+175|0]<0&&Z(i[f+164>>2]),F(n,34067,19),r=i[e+108>>2],n=i[e+112>>2];i:{if((r|0)==(n|0)||(e=f+164|0,z1(e,i[r>>2]),o=e,e=t[f+175|0],k=(e|0)<0,F(f+24|0,k?i[f+164>>2]:o,k?i[f+168>>2]:e),t[f+175|0]<0&&Z(i[f+164>>2]),e=r+4|0,(n|0)==(e|0)))break i;for(;k=i[e>>2],t[f+164|0]=44,l=f+24|0,r=f+164|0,F(l,r,1),z1(r,k),o=r,r=t[f+175|0],k=(r|0)<0,F(l,k?i[f+164>>2]:o,k?i[f+168>>2]:r),t[f+175|0]<0&&Z(i[f+164>>2]),e=e+4|0,(n|0)!=(e|0););}F(f+24|0,47878,1),e=i[f+76>>2];i:{e:{if(e&16){e=i[f+72>>2],r=i[f+52>>2],e>>>0<r>>>0&&(i[f+72>>2]=r,e=r),r=f+48|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+44>>2],r=f+36|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,n,e)}t[A+e|0]=0,A=i[19619],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[19622],i[s>>2]=77200,t[f+71|0]<0&&Z(i[f+60>>2]),y0(s),Y0(f+80|0),v=f+176|0}function OZ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;if(k=v-48|0,v=k,i[k+44>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,e=i[e+72>>2],w=i[e+132>>2],B=i[e+136>>2],(w|0)!=(B|0))for(;;){i:{if(s=i[w+4>>2],m=i[w+8>>2],(s|0)==(m|0))break i;for(;;){e:{l=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+40>>2],f=i[k+44>>2];r:{if(e>>>0<f>>>0){t[e|0]=l,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=C(f):r=0,o=r+e|0,t[o|0]=l,e&&z(r,n,e),i[k+44>>2]=r+f,e=o+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,l=i[s+4>>2]-i[s>>2]>>>16|0,f=i[k+44>>2];r:{if(f>>>0>e>>>0){t[e|0]=l,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=C(f):r=0,o=r+e|0,t[o|0]=l,e&&z(r,n,e),i[k+44>>2]=r+f,e=o+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,l=i[s+4>>2]-i[s>>2]>>>8|0,f=i[k+44>>2];r:{if(f>>>0>e>>>0){t[e|0]=l,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=C(f):r=0,o=r+e|0,t[o|0]=l,e&&z(r,n,e),i[k+44>>2]=r+f,e=o+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,l=i[s+4>>2]-i[s>>2]|0,f=i[k+44>>2];r:{if(f>>>0>e>>>0){t[e|0]=l,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=C(f):r=0,o=r+e|0,t[o|0]=l,e&&z(r,n,e),i[k+44>>2]=r+f,e=o+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,r=i[s+4>>2],o=i[s>>2],l=r-o|0;r:{if((l|0)<=0)break r;if(h=i[k+44>>2],(l|0)<=(h-e|0)){!l|(r|0)==(o|0)||z(e,o,l),i[k+40>>2]=e+l;break r}if(f=i[k+36>>2],r=e-f|0,n=r+l|0,(n|0)<0)break e;if(h=h-f|0,_=h<<1,h=h>>>0>=1073741823?2147483647:n>>>0<_>>>0?_:n,h?n=C(h):n=0,_=n+r|0,l&&z(_,o,l),i[k+40>>2]=e,r&&z(n,f,r),i[k+44>>2]=n+h,i[k+40>>2]=l+_,i[k+36>>2]=n,!f)break r;Z(f)}if(s=s+12|0,(m|0)!=(s|0))continue;break i}break}s0(),M()}if(w=w+16|0,(B|0)==(w|0))break}e=i[k+40>>2],r=i[k+36>>2],n=i[k+44>>2],t[A+20|0]=0,i[A+8>>2]=n,i[A>>2]=r,i[A+4>>2]=e,v=k+48|0}function PZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78164,i[f+8>>2]=78144,k=i[19545],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19546],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,n=f+12|0,J0(k,n),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[f+8>>2]=k,s=f+8|0,i[s+i[k-12>>2]>>2]=i[19548],k=i[19544],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19549],i[f+64>>2]=78164,i[f>>2]=78124,i[f+8>>2]=78144,h=R0(n),i[h>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,K1(k,e,r),o=k,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(s,36497,15),n=f+148|0,z1(n,i[e+104>>2]),l=k,o=n,k=t[f+159|0],n=(k|0)<0,F(F(l,n?i[f+148>>2]:o,n?i[f+152>>2]:k),47878,1),t[f+159|0]<0&&Z(i[f+148>>2]),u[e+112|0]==1&&(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(s,34257,25),i[e+108>>2]),47878,1)),i[e+120>>2]!=i[e+116>>2])for(k=0;n=f+148|0,k0(n,r),o=n,n=t[f+159|0],l=(n|0)<0,F(s,l?i[f+148>>2]:o,l?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(s,20885,1),i[(i[i[n>>2]-12>>2]+n|0)+12>>2]=2,o=n,n=k+1|0,l=F(B0(o,n),37800,4),i[(i[i[l>>2]-12>>2]+l|0)+12>>2]=3,k=k<<3,F(B0(F(B0(l,i[k+i[e+116>>2]>>2]),30879,2),i[(k+i[e+116>>2]|0)+4>>2]),47878,1),l=i[e+116>>2],w=i[l+k>>2]+w|0,k=n,k>>>0<i[e+120>>2]-l>>3>>>0;);e=f+148|0,k0(e,r),k=e,e=t[f+159|0],r=(e|0)<0,F(s,r?i[f+148>>2]:k,r?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(s,33970,15),w),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19543],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19551],i[f+8>>2]=i[19552],i[h>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(h),Y0(f- -64|0),v=f+160|0}function LZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(i1(F(k,35284,28),u[e+97|0]),47878,1),u[e+97|0]==1&&(n=f+148|0,k0(n,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(k,37755,21),F(D0(F(D0(F(k,30582,1),i[e+100>>2]),22872,1),i[e+112>>2]),37810,3),F(D0(F(D0(F(k,30582,1),i[e+104>>2]),22872,1),i[e+116>>2]),37810,3),F(D0(F(D0(F(k,30582,1),i[e+108>>2]),22872,1),i[e+120>>2]),47877,2)),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(f+8|0,36100,25);i:{if(u[e+128|0]==1){B0(k,i[e+124>>2]);break i}F(k,29394,1)}F(k,47878,1),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(f+8|0,36064,25);i:{if(u[e+136|0]==1){B0(k,i[e+132>>2]);break i}F(k,29394,1)}F(k,47878,1),k=f+148|0,k0(k,r),n=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),r=F(f+8|0,36136,25);i:{if(u[e+144|0]==1){B0(r,i[e+140>>2]);break i}F(r,29394,1)}F(r,47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function Ii(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0;k=v-160|0,v=k;i:{e:{r:{f:{A:{k:{n:{if(l=i[e+8>>2],e=i[e+12>>2],!(l|e))break n;if((r|f)>=0){if(!f)break k;if(o=O1(l,e,f,0),n=h0,!n&r>>>0<=o>>>0|n)break n}i[k+104>>2]=0,i[k+76>>2]=78164,i[k+20>>2]=78144,o=i[19545],i[k+12>>2]=o,n=i[o-12>>2],o=k+12|0,i[n+o>>2]=i[19546],i[k+16>>2]=0,n=o+i[i[k+12>>2]-12>>2]|0,s=k+24|0,J0(n,s),t[n+80|0]=0,i[n+72>>2]=0,n=i[19547],i[k+20>>2]=n,h=k+20|0,i[h+i[n-12>>2]>>2]=i[19548],n=i[19544],i[k+12>>2]=n,i[o+i[n-12>>2]>>2]=i[19549],i[k+76>>2]=78164,i[k+12>>2]=78124,i[k+20>>2]=78144,o=R0(s),i[o>>2]=77200,n=k- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,F(M2(F(B0(F(B0(F(h,32321,11),r),3179,1),f),32288,32),l,e),47878,1),e=i[k+72>>2];t:{if(e&16){f=i[k+68>>2],e=i[k+48>>2],f>>>0<e>>>0&&(i[k+68>>2]=e,f=e),e=k+44|0;break t}if(!(e&8)){f=0,t[k+11|0]=0,r=k;break e}f=i[k+40>>2],e=k+32|0}if(e=i[e>>2],f=f-e|0,f>>>0>=2147483640)break f;if(f>>>0>=11){l=f|7,r=C(l+1|0),i[k+8>>2]=l-2147483647,i[k>>2]=r,i[k+4>>2]=f;break r}if(t[k+11|0]=f,r=k,f)break r;f=0;break e}if(!r)break k;if(f)break A}if(e=C(24),i[k+12>>2]=e,i[k+16>>2]=20,i[k+20>>2]=-2147483624,r=u[4357]|u[4358]<<8|(u[4359]<<16|u[4360]<<24),f=u[4353]|u[4354]<<8|(u[4355]<<16|u[4356]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+20|0]=0,r=u[4369]|u[4370]<<8|(u[4371]<<16|u[4372]<<24),t[e+16|0]=r,t[e+17|0]=r>>>8,t[e+18|0]=r>>>16,t[e+19|0]=r>>>24,r=u[4365]|u[4366]<<8|(u[4367]<<16|u[4368]<<24),f=u[4361]|u[4362]<<8|(u[4363]<<16|u[4364]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,129,k+12|0),t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}I0(),M()}if(!f)break e;z(r,e,f)}t[r+f|0]=0,a(A,6,1e3,k),t[k+11|0]<0&&Z(i[k>>2]),A=i[19543],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[19551],i[k+20>>2]=i[19552],i[o>>2]=77200,t[k+67|0]<0&&Z(i[k+56>>2]),y0(o),Y0(k+76|0)}v=k+160|0}function qZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-208|0,v=f,i[f+140>>2]=0,i[f+112>>2]=78468,k=i[19620],i[f+56>>2]=k,o=i[k-12>>2],k=f+56|0,i[o+k>>2]=i[19621],l=k+i[i[f+56>>2]-12>>2]|0,n=f+60|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+112>>2]=78468,i[f+56>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+100>>2]=0,i[f+104>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+108>>2]=16,n=f+196|0,k3(n,e,r),s=k,o=n,k=t[f+207|0],n=(k|0)<0,F(s,n?i[f+196>>2]:o,n?i[f+200>>2]:k),t[f+207|0]<0&&Z(i[f+196>>2]);i:{e:{r:{f:{if(s=i[e+12>>2],n=i[e+32>>2],k=i[e+8>>2],!s&n>>>0<=k>>>0|s){s=i[e+100>>2],e=f+28|0,k0(e,r),e=ae(e,37380,6),i[f+48>>2]=i[e+8>>2],o=i[e+4>>2],i[f+40>>2]=i[e>>2],i[f+44>>2]=o,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,e=f+4|0,k0(e,r),e=ae(e,37881,6),i[f+24>>2]=i[e+8>>2],r=i[e+4>>2],i[f+16>>2]=i[e>>2],i[f+20>>2]=r,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,e=f+196|0,Pn(e,s,k-n|0,f+40|0,f+16|0),k=e,e=t[f+207|0],r=(e|0)<0,F(f+56|0,r?i[f+196>>2]:k,r?i[f+200>>2]:e),t[f+207|0]<0&&Z(i[f+196>>2]),t[f+27|0]<0&&Z(i[f+16>>2]),t[f+15|0]<0&&Z(i[f+4>>2]),t[f+51|0]<0&&Z(i[f+40>>2]),t[f+39|0]<0&&Z(i[f+28>>2]),e=i[f+108>>2];A:{if(e&16){e=i[f+104>>2],r=i[f+84>>2],e>>>0<r>>>0&&(i[f+104>>2]=r,e=r),r=f+80|0;break A}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+76>>2],r=f+68|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break f;if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}k=f+196|0,k0(k,r),o=k,r=t[f+207|0],k=(r|0)<0,F(f+56|0,k?i[f+196>>2]:o,k?i[f+200>>2]:r),t[f+207|0]<0&&Z(i[f+196>>2]),F(M2(F(f+56|0,32220,17),i[e+8>>2],i[e+12>>2]),47579,23),e=i[f+108>>2];A:{if(e&16){e=i[f+104>>2],r=i[f+84>>2],e>>>0<r>>>0&&(i[f+104>>2]=r,e=r),r=f+80|0;break A}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+76>>2],r=f+68|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break f;if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break r}if(t[A+11|0]=e,e)break r;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e);break i}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+56>>2]=A,i[i[A-12>>2]+(f+56|0)>>2]=i[19622],i[l>>2]=77200,t[f+103|0]<0&&Z(i[f+92>>2]),y0(l),Y0(f+112|0),v=f+208|0}function aZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=v-48|0,v=k,XA(k+24|0,e,r,f);i:{if(i[k+24>>2]){e=i[k+28>>2],i[A>>2]=i[k+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+40>>2],e=i[k+36>>2],i[A+8>>2]=i[k+32>>2],i[A+12>>2]=e,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0;break i}if((i[e+112>>2]-i[e+108>>2]|0)!=8){if(e=C(64),i[k+12>>2]=e,i[k+16>>2]=57,i[k+20>>2]=-2147483584,r=u[6198]|u[6199]<<8|(u[6200]<<16|u[6201]<<24),f=u[6194]|u[6195]<<8|(u[6196]<<16|u[6197]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+57|0]=0,t[e+56|0]=u[6250],r=u[6246]|u[6247]<<8|(u[6248]<<16|u[6249]<<24),f=u[6242]|u[6243]<<8|(u[6244]<<16|u[6245]<<24),t[e+48|0]=f,t[e+49|0]=f>>>8,t[e+50|0]=f>>>16,t[e+51|0]=f>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[6238]|u[6239]<<8|(u[6240]<<16|u[6241]<<24),f=u[6234]|u[6235]<<8|(u[6236]<<16|u[6237]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[6230]|u[6231]<<8|(u[6232]<<16|u[6233]<<24),f=u[6226]|u[6227]<<8|(u[6228]<<16|u[6229]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[6222]|u[6223]<<8|(u[6224]<<16|u[6225]<<24),f=u[6218]|u[6219]<<8|(u[6220]<<16|u[6221]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[6214]|u[6215]<<8|(u[6216]<<16|u[6217]<<24),f=u[6210]|u[6211]<<8|(u[6212]<<16|u[6213]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[6206]|u[6207]<<8|(u[6208]<<16|u[6209]<<24),f=u[6202]|u[6203]<<8|(u[6204]<<16|u[6205]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,101,k+12|0),t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}t[k+43|0]<0&&Z(i[k+32>>2]),v=k+48|0}function KZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78164,i[f+8>>2]=78144,k=i[19545],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19546],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,o=f+12|0,J0(k,o),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[f+8>>2]=k,w=f+8|0,i[w+i[k-12>>2]>>2]=i[19548],k=i[19544],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19549],i[f+64>>2]=78164,i[f>>2]=78124,i[f+8>>2]=78144,_=R0(o),i[_>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,K1(k,e,r),n=k,k=t[f+159|0],o=(k|0)<0,F(w,o?i[f+148>>2]:n,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(k=0;;){o=f+148|0,k0(o,r),n=o,o=t[f+159|0],l=(o|0)<0,F(w,l?i[f+148>>2]:n,l?i[f+152>>2]:o),t[f+159|0]<0&&Z(i[f+148>>2]),o=F(D0(F(B0(F(w,20885,1),k),22803,15),u[i[e+104>>2]+k|0]>>>6|0),47878,1),l=f+148|0,k0(l,r),n=l,l=t[f+159|0],s=(l|0)<0,F(o,s?i[f+148>>2]:n,s?i[f+152>>2]:l),t[f+159|0]<0&&Z(i[f+148>>2]),n=-6;i:{if((k|0)<=9||(n=-7,k>>>0<100)||(n=-8,k>>>0<1e3)||(n=-9,k>>>0<1e4)||(n=-10,k>>>0<1e5))break i;n=k>>>0>999999?-12:-11}if(l=n+37887|0,s=l2(l),o=F(D0(F(F(o,l,s),22748,11),u[i[e+104>>2]+k|0]>>>4&3),47878,1),n=f+148|0,k0(n,r),B=n,n=t[f+159|0],h=(n|0)<0,F(o,h?i[f+148>>2]:B,h?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),o=F(D0(F(F(o,l,s),22760,15),u[i[e+104>>2]+k|0]>>>2&3),47878,1),n=f+148|0,k0(n,r),B=n,n=t[f+159|0],h=(n|0)<0,F(o,h?i[f+148>>2]:B,h?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(F(o,l,s),22676,15),u[i[e+104>>2]+k|0]&3),47878,1),k=k+1|0,!(k>>>0<i[e+108>>2]-i[e+104>>2]>>>0))break}e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,t[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){o=k|7,e=C(o+1|0),i[A+8>>2]=o-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(t[A+11|0]=k,k)break e;k=0;break i}I0(),M()}if(!k)break i;z(A,r,k)}t[A+k|0]=0,A=i[19543],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19551],i[f+8>>2]=i[19552],i[_>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(_),Y0(f- -64|0),v=f+160|0}function $Z(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78164,i[f+8>>2]=78144,k=i[19545],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19546],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,h=f+12|0,J0(k,h),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[f+8>>2]=k,o=f+8|0,i[o+i[k-12>>2]>>2]=i[19548],k=i[19544],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19549],i[f+64>>2]=78164,i[f>>2]=78124,i[f+8>>2]=78144,h=R0(h),i[h>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,K1(k,e,r),l=k,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(o,36402,15),k=i[e+104>>2];i:{if(!k){F(o,46949,2);break i}if(n=f+148|0,z1(n,k),l=n,k=t[f+159|0],n=(k|0)<0,F(F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),47878,1),t[f+159|0]>=0)break i;Z(i[f+148>>2])}k=f+148|0,k0(k,r),l=k,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(o,34231,25),k=i[e+108>>2];i:{if(!k){F(o,46949,2);break i}if(n=f+148|0,z1(n,k),l=n,k=t[f+159|0],n=(k|0)<0,F(F(o,n?i[f+148>>2]:l,n?i[f+152>>2]:k),47878,1),t[f+159|0]>=0)break i;Z(i[f+148>>2])}if(i[e+132>>2]!=i[e+128>>2])for(k=0;n=f+148|0,k0(n,r),l=n,n=t[f+159|0],s=(n|0)<0,F(o,s?i[f+148>>2]:l,s?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(o,20885,1),k),3170,6),s=i[i[n>>2]-12>>2]+n|0,i[s+4>>2]=i[s+4>>2]&-75|8,s=i[e+128>>2]+(k<<3)|0,F(M2(n,i[s>>2],i[s+4>>2]),47878,1),k=k+1|0,k>>>0<i[e+132>>2]-i[e+128>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,t[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){o=k|7,e=C(o+1|0),i[A+8>>2]=o-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(t[A+11|0]=k,k)break e;k=0;break i}I0(),M()}if(!k)break i;z(A,r,k)}t[A+k|0]=0,A=i[19543],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19551],i[f+8>>2]=i[19552],i[h>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(h),Y0(f- -64|0),v=f+160|0}function br(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0;w=v-2048|0,v=w;i:{e:{if((r|0)>=2){for(o=r;n=_,_=n+1|0,l=o>>>0>3,o=o>>>1|0,!!l;);_=4-n|0;break e}if(_=5,(r|0)!=1)break i}for(R=20-k|0,N=1<<19-k,Y=r&-4,h=r&3,V=r-1|0;;){B=(s<<1)+f|0,o=0,l=r;e:{for(;;){if(G=o,n=l,(n|0)<=0){if(l=0,o=0,n=0,V>>>0>=3)for(;X[(g(r,o)+s<<1)+w>>1]=0,X[(g(o|1,r)+s<<1)+w>>1]=0,X[(g(o|2,r)+s<<1)+w>>1]=0,X[(g(o|3,r)+s<<1)+w>>1]=0,o=o+4|0,n=n+4|0,(Y|0)!=(n|0););if(!h)break e;for(;X[(g(r,o)+s<<1)+w>>1]=0,o=o+1|0,l=l+1|0,(h|0)!=(l|0););break e}if(o=G+1|0,l=n-1|0,!!p[B+(g(l,r)<<1)>>1])break}for(I=n&2147483646,E=n&1,l=0;;){if(o=0,n=0,m=0,(G|0)!=(V|0))for(;Q=g(X[B+(g(r,o)<<1)>>1],t[((o<<_<<5)+l|0)+67712|0])+n|0,n=o|1,n=Q+g(X[B+(g(n,r)<<1)>>1],t[((n<<_<<5)+l|0)+67712|0])|0,o=o+2|0,m=m+2|0,(I|0)!=(m|0););if(m=(g(r,l)+s<<1)+w|0,E&&(n=g(X[B+(g(r,o)<<1)>>1],t[((o<<_<<5)+l|0)+67712|0])+n|0),n=n- -64>>7,n=(n|0)>=32767?32767:n,X[m>>1]=(n|0)<=-32768?-32768:n,l=l+1|0,(l|0)==(r|0))break}}if(s=s+1|0,(s|0)==(r|0))break}for(m=r&-2,Y=r&1,B=N>>R,s=-1<<k^-1,k=0;;){h=g(r,k),o=h-1|0,l=0,n=r;e:{r:{for(;;){if(G=l,f=n,(n|0)<=0)break r;if(l=l+1|0,n=n-1|0,!!p[(f+o<<1)+w>>1])break}for(I=f&2147483646,E=f&1,U=(g(e,k)<<1)+A|0,l=0;;){if(o=0,n=0,f=0,(G|0)!=(V|0))for(;Q=g(X[(o+h<<1)+w>>1],t[((o<<_<<5)+l|0)+67712|0])+n|0,n=o|1,n=Q+g(X[(n+h<<1)+w>>1],t[((n<<_<<5)+l|0)+67712|0])|0,o=o+2|0,f=f+2|0,(I|0)!=(f|0););if(f=(l<<1)+U|0,Q=p[f>>1],E&&(n=g(X[(o+h<<1)+w>>1],t[((o<<_<<5)+l|0)+67712|0])+n|0),o=f,f=(n+N>>R)+Q|0,X[o>>1]=(f|0)>=0?(f|0)<(s|0)?f:s:0,l=l+1|0,(l|0)==(r|0))break}break e}f=(g(e,k)<<1)+A|0;r:{if(!V){o=0;break r}for(G=f+2|0,o=0,n=0;h=o<<1,I=h+f|0,l=B+p[I>>1]|0,X[I>>1]=(l|0)>=0?(l|0)<(s|0)?l:s:0,h=h+G|0,l=B+p[h>>1]|0,X[h>>1]=(l|0)>=0?(l|0)<(s|0)?l:s:0,o=o+2|0,n=n+2|0,(m|0)!=(n|0););}if(!Y)break e;n=f+(o<<1)|0,f=B+p[n>>1]|0,X[n>>1]=(f|0)>=0?(f|0)<(s|0)?f:s:0}if(k=k+1|0,(k|0)==(r|0))break}}v=w+2048|0}function dZ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;l=v-48|0,v=l,_=l+12|0,n=v+-64|0,v=n,h=i[e+8>>2],S6(n+24|0,i[h+48>>2],1919377774);i:{e:switch(u[n+44|0]){default:e2(),M();case 1:r=i[n+28>>2],i[_>>2]=i[n+24>>2],i[_+4>>2]=r,r=_+8|0;r:{if(t[n+43|0]>=0){f=i[n+36>>2],i[r>>2]=i[n+32>>2],i[r+4>>2]=f,i[r+8>>2]=i[n+40>>2];break r}T(r,i[n+32>>2],i[n+36>>2])}t[_+20|0]=1;break i;case 0:break e}o=i[n+24>>2],w=i[n+28>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),t[o+164|0]=1,i[o+100>>2]=i[o+100>>2]&-2|1,B=i[o+104>>2],o=C(36),i[o+32>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+20>>2]=f,i[o+16>>2]=r,i[o+12>>2]=B,i[o>>2]=100776,i[o+4>>2]=0,i[o+8>>2]=0,i[n+20>>2]=o,I=o+12|0,i[n+16>>2]=I,i[o+4>>2]=i[o+4>>2]+1,r=i[n+20>>2],i[n+8>>2]=i[n+16>>2],i[n+12>>2]=r;e:{if(r=i[h+176>>2],s=i[h+180>>2],r>>>0<s>>>0){i[r>>2]=i[n+8>>2],i[r+4>>2]=i[n+12>>2],i[h+176>>2]=r+8;break e}r:{if(B=i[h+172>>2],r=r-B|0,G=r>>3,f=G+1|0,f>>>0<536870912){if(s=s-B|0,m=s>>2,s=s>>>0>=2147483640?536870911:f>>>0<m>>>0?m:f,s){if(s>>>0>=536870912)break r;f=C(s<<3)}else f=0;m=f+r|0,i[m>>2]=i[n+8>>2],i[m+4>>2]=i[n+12>>2],G=m-(G<<3)|0,r&&z(G,B,r),i[h+180>>2]=f+(s<<3),r=m+8|0,i[h+176>>2]=r,i[h+172>>2]=G,B&&Z(B),i[h+176>>2]=r;break e}s0(),M()}x0(),M()}if(t[_+20|0]=0,i[_+4>>2]=o,i[_>>2]=I,!w||(r=i[w+4>>2],i[w+4>>2]=r-1,r))break i;W[i[i[w>>2]+8>>2]](w),y(w)}r=u[n+44|0],(r|0)!=255&&(f=i[25167],i[n+56>>2]=i[25166],i[n+60>>2]=f,W[i[(n+56|0)+(r<<2)>>2]](n+55|0,n+24|0)),v=n- -64|0;i:{e:switch(u[l+32|0]){default:e2(),M();case 1:c0(A,l+12|0,i[e+8>>2]);break i;case 0:break e}if(o=i[l+12>>2],r=i[l+16>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),sl(i[e>>2],i[o>>2]),k){f=C(16),n=i[e+8>>2],e=i[e+12>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[f+12>>2]=r,i[f+8>>2]=o,i[f+4>>2]=e,i[f>>2]=n,i[k>>2]=f,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e;break i}if(e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}A=u[l+32|0],(A|0)!=255&&(e=i[25785],i[l+40>>2]=i[25784],i[l+44>>2]=e,W[i[(l+40|0)+(A<<2)>>2]](l+39|0,l+12|0)),v=l+48|0}function pA(A,e,r,f,k,n){var o=0,l=0,s=0,h=0,w=0,_=0;i:{e:{if(s=A+548|0,!i[s+8>>2]){t[s+1|0]=0,A=7,o=i[s+44>>2];r:{if((o|0)!=i[s+40>>2]){l=o-4|0,o=i[l>>2],i[s+44>>2]=l,l=i[o+32>>2];break r}o=C(48),i[o+40>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0,t[o+2|0]=0,t[o|0]=0,t[o+1|0]=0,l=C(64),i[o+32>>2]=l,h=l- -64|0,i[o+40>>2]=h,i[l+56>>2]=0,i[l+60>>2]=0,i[l+48>>2]=0,i[l+52>>2]=0,i[l+40>>2]=0,i[l+44>>2]=0,i[l+32>>2]=0,i[l+36>>2]=0,i[l+24>>2]=0,i[l+28>>2]=0,i[l+16>>2]=0,i[l+20>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0,i[l>>2]=0,i[l+4>>2]=0,i[o+8>>2]=0,i[o+12>>2]=0,i[o+36>>2]=h,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0}if(i[o+36>>2]=l,i[o+24>>2]=0,i[o+16>>2]=0,i[o+8>>2]=0,i[o+12>>2]=0,t[o+2|0]=0,X[o>>1]=0,i[o+28>>2]<(r|0))r:{if(l=E2(r),l){h=i[o+20>>2],h&&Z(h),i[o+28>>2]=r,i[o+20>>2]=l;break r}H4(s,o),o=0}if(o){r:{if(i[o+28>>2]>=(r|0)){A=i[o+20>>2];break r}if(A=E2(r),!A)break e;l=i[o+20>>2],l&&(h=i[o+24>>2],h&&z(A,l,h),Z(l)),i[o+28>>2]=r,i[o+20>>2]=A}if(r&&z(A,e,r),i[o+16>>2]=n,i[o+8>>2]=f,i[o+12>>2]=k,i[o+24>>2]=r,(r|0)>=3)for(A=i[o+20>>2],n=0;;){e=A+2|0;r:{f:{A:switch(f=u[A+2|0],f|0){case 0:case 3:break f;default:break A}n=n+2|0;break r}if(u[A|0]){e=A;break r}if((f|0)!=3){e=A;break r}if(u[A+1|0]){e=A;break r}r=i[o+36>>2],h=((r-i[o+32>>2]>>2)+n|0)+2|0;f:{if(l=i[o+40>>2],l>>>0>r>>>0){i[r>>2]=h,i[o+36>>2]=r+4;break f}A:{if(k=i[o+32>>2],r=r-k|0,_=r>>2,f=_+1|0,f>>>0<1073741824){if(l=l-k|0,w=l>>1,l=l>>>0>=2147483644?1073741823:f>>>0<w>>>0?w:f,l){if(l>>>0>=1073741824)break A;f=C(l<<2)}else f=0;w=f+r|0,i[w>>2]=h,h=w-(_<<2)|0,r&&z(h,k,r),i[o+40>>2]=f+(l<<2),r=w+4|0,i[o+36>>2]=r,i[o+32>>2]=h,k&&Z(k),i[o+36>>2]=r;break f}s0(),M()}x0(),M()}r=(i[o+24>>2]-n|0)-3|0,r&&z(e,A+3|0,r),e=A+1|0,r=i[o+24>>2]-1|0,i[o+24>>2]=r,n=n+1|0}if(A=e+1|0,n=n+1|0,!((n|0)<(r-2|0)))break}A=0,l=i[s+32>>2],e=l+i[s+28>>2]|0,f=i[s+20>>2],n=i[s+16>>2],(e|0)==(((f|0)!=(n|0)?(f-n<<8)-1|0:0)|0)&&(ar(s+12|0),r=i[o+24>>2],n=i[s+16>>2],l=i[s+32>>2],e=l+i[s+28>>2]|0),i[i[(e>>>8&16777212)+n>>2]+((e&1023)<<2)>>2]=o,i[s+32>>2]=l+1,i[s+36>>2]=i[s+36>>2]+r}break i}U0(21202,19882,376,21239),M()}H4(s,o),A=7}return A}function bZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;f=v-16|0,v=f;i:{e:{if(!(i[e+8>>2]|i[e+12>>2])){if(e=C(32),i[f+4>>2]=e,i[f+8>>2]=30,i[f+12>>2]=-2147483616,r=u[12561]|u[12562]<<8|(u[12563]<<16|u[12564]<<24),k=u[12557]|u[12558]<<8|(u[12559]<<16|u[12560]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+30|0]=0,r=u[12583]|u[12584]<<8|(u[12585]<<16|u[12586]<<24),k=u[12579]|u[12580]<<8|(u[12581]<<16|u[12582]<<24),t[e+22|0]=k,t[e+23|0]=k>>>8,t[e+24|0]=k>>>16,t[e+25|0]=k>>>24,t[e+26|0]=r,t[e+27|0]=r>>>8,t[e+28|0]=r>>>16,t[e+29|0]=r>>>24,r=u[12577]|u[12578]<<8|(u[12579]<<16|u[12580]<<24),k=u[12573]|u[12574]<<8|(u[12575]<<16|u[12576]<<24),t[e+16|0]=k,t[e+17|0]=k>>>8,t[e+18|0]=k>>>16,t[e+19|0]=k>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[12569]|u[12570]<<8|(u[12571]<<16|u[12572]<<24),k=u[12565]|u[12566]<<8|(u[12567]<<16|u[12568]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,f+4|0),t[f+15|0]>=0)break e;Z(i[f+4>>2]);break e}w=e,_=Q2(r)&127,t[w+97|0]=_,k=Q2(r),t[e+99|0]=k&31,t[e+98|0]=k>>>5,k=Q2(r),t[e+106|0]=k&3,t[e+100|0]=k>>>7,t[e+105|0]=k>>>2&1,t[e+104|0]=k>>>3&1,t[e+103|0]=k>>>4&1,t[e+102|0]=k>>>5&1,t[e+101|0]=k>>>6&1,k=Q2(r),o=k>>>4&1,t[e+107|0]=o,o&&(t[e+108|0]=k&15),n=i[e+116>>2],o=i[e+112>>2],s=n-o|0,k=i[r+16>>2];r:{if(s>>>0<k>>>0){if(h=k-s|0,l=i[e+120>>2],h>>>0<=l-n>>>0){h&&l0(n,0,h),i[e+116>>2]=n+h;break r}if((k|0)<0)break i;if(n=l-o|0,l=n<<1,l=n>>>0>=1073741823?2147483647:k>>>0<l>>>0?l:k,n=C(l),h&&l0(n+s|0,0,h),s&&z(n,o,s),i[e+120>>2]=n+l,i[e+116>>2]=k+n,i[e+112>>2]=n,!o)break r;Z(o);break r}if(k>>>0>=s>>>0)break r;i[e+116>>2]=k+o}if(s6(r,i[e+112>>2],k),u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break e;Z(i[f+4>>2]);break e}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731])}v=f+16|0;return}s0(),M()}function cr(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0;h=v-2048|0,v=h;i:{e:{if((e|0)>=2){for(n=e;l=_,_=l+1|0,o=n>>>0>3,n=n>>>1|0,!!o;);_=4-l|0;break e}if(_=5,(e|0)!=1)break i}for(Q=e&-4,Y=e&3,E=e-1|0,m=1<<k,I=0-m|0,V=m+65535|0,U=1<<f-1;;){G=(s<<1)+r|0,n=0,o=e;e:{for(;;){if(w=n,k=o,(k|0)<=0){if(o=0,n=0,l=0,E>>>0>=3)for(;X[(g(e,n)+s<<1)+h>>1]=0,X[(g(n|1,e)+s<<1)+h>>1]=0,X[(g(n|2,e)+s<<1)+h>>1]=0,X[(g(n|3,e)+s<<1)+h>>1]=0,n=n+4|0,l=l+4|0,(Q|0)!=(l|0););if(!Y)break e;for(;X[(g(e,n)+s<<1)+h>>1]=0,n=n+1|0,o=o+1|0,(Y|0)!=(o|0););break e}if(n=w+1|0,o=k-1|0,!!p[G+(g(o,e)<<1)>>1])break}for(R=k&2147483646,N=k&1,o=0;;){if(n=0,l=0,B=0,(w|0)!=(E|0))for(;k=n|1,l=(g(X[G+(g(e,n)<<1)>>1],t[((n<<_<<5)+o|0)+67712|0])+l|0)+g(X[G+(g(k,e)<<1)>>1],t[((k<<_<<5)+o|0)+67712|0])|0,n=n+2|0,B=B+2|0,(R|0)!=(B|0););if(k=(g(e,o)+s<<1)+h|0,N&&(l=g(X[G+(g(e,n)<<1)>>1],t[((n<<_<<5)+o|0)+67712|0])+l|0),n=k,k=l- -64>>7,X[n>>1]=(k|0)<(I|0)?I:(k|0)<(m|0)?k:V,o=o+1|0,(o|0)==(e|0))break}}if(s=s+1|0,(s|0)==(e|0))break}for(Y=e&-8,G=e&7,w=U>>f,r=0;;){s=g(e,r),n=s-1|0,o=0,l=e;e:{r:{for(;;){if(I=o,k=l,(k|0)<=0)break r;if(o=o+1|0,l=k-1|0,!!p[(k+n<<1)+h>>1])break}for(B=k&2147483646,m=k&1,Q=(s<<2)+A|0,o=0;;){if(n=0,l=0,k=0,(I|0)!=(E|0))for(;V=g(X[(n+s<<1)+h>>1],t[((n<<_<<5)+o|0)+67712|0])+l|0,l=n|1,l=V+g(X[(l+s<<1)+h>>1],t[((l<<_<<5)+o|0)+67712|0])|0,n=n+2|0,k=k+2|0,(B|0)!=(k|0););if(k=Q+(o<<2)|0,m&&(l=g(X[(n+s<<1)+h>>1],t[((n<<_<<5)+o|0)+67712|0])+l|0),i[k>>2]=l+U>>f,o=o+1|0,(o|0)==(e|0))break}break e}if(k=(s<<2)+A|0,l=0,o=0,E>>>0>=7)for(I=k+28|0,s=k+24|0,m=k+20|0,Q=k+16|0,V=k+12|0,R=k+8|0,N=k+4|0,B=0;n=o<<2,i[n+k>>2]=w,i[n+N>>2]=w,i[n+R>>2]=w,i[n+V>>2]=w,i[n+Q>>2]=w,i[n+m>>2]=w,i[n+s>>2]=w,i[n+I>>2]=w,o=o+8|0,B=B+8|0,(Y|0)!=(B|0););if(!G)break e;for(;i[k+(o<<2)>>2]=w,o=o+1|0,l=l+1|0,(G|0)!=(l|0););}if(r=r+1|0,(r|0)==(e|0))break}}v=h+2048|0}function Un(A,e,r,f,k,n,o,l,s,h){var w=0,_=0,B=0,m=0,G=0,I=0,Q=0;I=v-16|0,v=I;i:{e:{r:{f:{A:{if(W[i[i[A>>2]+12>>2]](A,f)|0){if(_=W[i[i[A>>2]+8>>2]](A,f)|0,!(i[_+24>>2]>(k|0)&i[_+28>>2]>(n|0))){C2(A+4|0,1026,0),t[h|0]=0;break r}k:{if(w=i[_+168>>2],f=k>>w,(f|0)<0||(B=i[_+172>>2],(B|0)<=(f|0)))break k;if(w=n>>w,!((w|0)<0|(w|0)>=i[_+176>>2])){if(!(u[((i[_+160>>2]+g(f,3)|0)+g(g(w,B),3)|0)+1|0]&3)){X[s>>1]=0,X[s+2>>1]=0,t[h|0]=0;break r}if(u[_+312|0]==1){X[s>>1]=0,X[s+2>>1]=0,t[h|0]=0;break r}n:{if(w=i[_+188>>2],f=k>>w,(f|0)<0||(B=i[_+192>>2],(B|0)<=(f|0)))break n;if(w=n>>w,!((w|0)<0|(w|0)>=i[_+196>>2])){if(w=(i[_+180>>2]+g(f,12)|0)+g(g(w,B),12)|0,!u[w|0]){B=w+3|0,f=1,w=w+8|0;break f}if(!u[w+1|0]){B=w+2|0,f=0,w=w+4|0;break f}if(m=i[e+96>>2],B=1,i[r+340>>2]<=0)break A;for(G=r+988|0,f=0;;){if(Q=i[(W[i[i[A>>2]+8>>2]](A,i[G+(f<<2)>>2])|0)+96>>2],B=(Q|0)<=(m|0),f=f+1|0,(f|0)>=i[r+340>>2])break A;if(!((m|0)>=(Q|0)))break}break A}break e}break i}break e}break i}U0(29774,19905,1136,5248),M()}A:{if(!B|i[r+336>>2]<=0)break A;for(G=r+924|0,f=0;;){if(Q=i[(W[i[i[A>>2]+8>>2]](A,i[G+(f<<2)>>2])|0)+96>>2],B=(Q|0)<=(m|0),f=f+1|0,(f|0)>=i[r+336>>2])break A;if(!((m|0)>=(Q|0)))break}}if(B){B=(l+w|0)+2|0,f=l,w=(w+(f<<2)|0)+4|0;break f}f=t[r+380|0],B=(w+f|0)+2|0,w=(w+(f<<2)|0)+4|0}if(m=i[_+148>>2],k=k>>m,(k|0)<0||(G=i[_+152>>2],(G|0)<=(k|0)))break i;if(n=n>>m,(n|0)<0|(n|0)>=i[_+156>>2])break e;if(k=p[((i[_+140>>2]+g(k,24)|0)+g(g(n,G),24)|0)+2>>1],m=i[_+52>>2],k>>>0>=i[_+56>>2]-m>>2>>>0){C2(A+4|0,1033,0),t[h|0]=0,X[s>>1]=0,X[s+2>>1]=0;break r}if(n=(((l<<4)+r|0)+o|0)+1308|0,B=t[B|0],m=i[m+(k<<2)>>2],u[n|0]!=u[(B+(m+(f<<4)|0)|0)+1308|0]){t[h|0]=0,X[s>>1]=0,X[s+2>>1]=0;break r}k=p[w>>1]|p[w+2>>1]<<16,t[h|0]=1;f:{if(!u[n|0]&&(f=i[_+96>>2]-i[((m+(f<<6)|0)+(B<<2)|0)+1052>>2]|0,r=i[e+96>>2]-i[(((l<<6)+r|0)+(o<<2)|0)+1052>>2]|0,(f|0)!=(r|0)))break f;X[s>>1]=k,X[s+2>>1]=k>>>16;break r}if(i[I+8>>2]=k,i[I+12>>2]=k,jo(s,I+8|0,f,r))break r;C2(A+4|0,1008,0),t[e+312|0]=3}v=I+16|0;return}U0(5030,11952,119,4625),M()}U0(5068,11952,118,4625),M()}function cZ(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0;f=v-32|0,v=f,e=C(248),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=101168,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,o=e+12|0,i[e+176>>2]=o,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e)),n=i[r>>2],t1(o,i[n+188>>2],i[n+192>>2],i[n+196>>2],i[n+200>>2]);i:{e:{for(;;){s=i[m+64152>>2];r:{if(!$2(i[r>>2],s))break r;if(w=V8(i[r>>2],s),G=p8(i[r>>2],s),a0(f+8|0,o,s,w,G,i[k+12>>2],l,0),i[f+8>>2]){if(r=i[f+12>>2],i[A>>2]=i[f+8>>2],i[A+4>>2]=r,k=A+8|0,t[f+27|0]>=0){r=i[f+20>>2],i[k>>2]=i[f+16>>2],i[k+4>>2]=r,i[k+8>>2]=i[f+24>>2],t[A+20|0]=1;break e}if(T(k,i[f+16>>2],i[f+20>>2]),r=t[f+27|0],t[A+20|0]=1,(r|0)>=0)break e;Z(i[f+16>>2]);break e}t[f+27|0]<0&&Z(i[f+16>>2]),B=K0(i[r>>2],s),h=i[k+12>>2],R=0,n=Q0(i[r>>2],s);f:{if(!n){N=0,n=0;break f}N=i[n+40>>2],n=i[n+52>>2]}if(x=n,n=Q0(o,s),n?(R=i[n+52>>2]>>>1|0,s=i[n+40>>2]):s=0,!G|!w)break r;for(I=(B<<1)-h|0,Q=h-B|0,j=w&-2,B=w&1,_=0;;){if(V=g(_,x)+N|0,Y=(g(_,R)<<1)+s|0,n=0,E=0,(w|0)!=1)for(;h=u[n+V|0],X[(n<<1)+Y>>1]=h<<Q|h>>>I,h=n|1,U=u[h+V|0],X[(h<<1)+Y>>1]=U<<Q|U>>>I,n=n+2|0,E=E+2|0,(j|0)!=(E|0););if(B&&(h=(n<<1)+Y|0,n=u[n+V|0],X[h>>1]=n<<Q|n>>>I),_=_+1|0,(G|0)==(_|0))break}}if(m=m+4|0,(m|0)==28)break}t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=o;break i}if(A=i[e+4>>2],i[e+4>>2]=A-1,A)break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=f+32|0}function ig(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0;h=v-48|0,v=h;i:{e:{if(e&&(w=i[e>>2],w))break e;e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}_=h+12|0,s=v-80|0,v=s,B=k>>>0>11?65535:i[(k<<2)+55356>>2],X[s+44>>1]=0,i[s+36>>2]=0,i[s+40>>2]=0,t[s+55|0]=0,t[s+56|0]=0,t[s+57|0]=0,t[s+58|0]=0,t[s+59|0]=0,t[s+60|0]=0,t[s+61|0]=0,t[s+62|0]=0,t[s+63|0]=0,t[s+64|0]=0,t[s+65|0]=0,t[s+66|0]=0,t[s+67|0]=0,t[s+68|0]=0,t[s+69|0]=0,t[s+70|0]=0,t[s+71|0]=0,t[s+72|0]=0,t[s+73|0]=0,t[s+74|0]=0,t[s+75|0]=0,t[s+76|0]=0,t[s+77|0]=0,t[s+78|0]=0,t[s+79|0]=0,i[s+28>>2]=0,i[s+32>>2]=0,t[s+47|0]=0,t[s+48|0]=0,t[s+49|0]=0,t[s+50|0]=0,t[s+51|0]=0,t[s+52|0]=0,t[s+53|0]=0,t[s+54|0]=0,t[s+46|0]=1,i[s+24>>2]=B,O6(s,s+24|0,r,f,n,o,1,0,w+216|0);e:{if(i[s>>2]){if(r=i[s+4>>2],i[_>>2]=i[s>>2],i[_+4>>2]=r,r=_+8|0,t[s+19|0]>=0){f=i[s+12>>2],i[r>>2]=i[s+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[s+16>>2],t[_+20|0]=1;break e}if(T(r,i[s+8>>2],i[s+12>>2]),r=t[s+19|0],t[_+20|0]=1,(r|0)>=0)break e;Z(i[s+8>>2]);break e}t[s+19|0]<0&&Z(i[s+8>>2]),r=C(2),i[s>>2]=r,f=r+2|0,i[s+8>>2]=f,X[r>>1]=k,i[s+4>>2]=f,nt(w,s+24|0,s),Z(r),f=i[i[s+28>>2]>>2],r=i[w+208>>2];r:{if(r>>>0<o0[w+212>>2]){k=i[s+24>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=k,i[r+4>>2]=i[s+28>>2],i[r+8>>2]=i[s+32>>2],i[r+12>>2]=i[s+36>>2],i[s+28>>2]=0,i[s+36>>2]=0,k=i[s+76>>2],i[r+48>>2]=i[s+72>>2],i[r+52>>2]=k,k=s- -64|0,n=i[k+4>>2],i[r+40>>2]=i[k>>2],i[r+44>>2]=n,k=i[s+60>>2],i[r+32>>2]=i[s+56>>2],i[r+36>>2]=k,k=i[s+52>>2],i[r+24>>2]=i[s+48>>2],i[r+28>>2]=k,k=i[s+44>>2],i[r+16>>2]=i[s+40>>2],i[r+20>>2]=k,r=r+56|0;break r}r=l3(w+204|0,s+24|0)}i[w+208>>2]=r,t[_+20|0]=0,i[_>>2]=f}r=i[s+28>>2],r&&(i[s+32>>2]=r,Z(r)),v=s+80|0;e:{r:switch(u[h+32|0]){default:e2(),M();case 0:l&&(i[l>>2]=i[h+12>>2]),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],e=0;break e;case 1:break r}if(r=A,A=i[e>>2],c0(r,h+12|0,A?A+172|0:0),e=u[h+32|0],(e|0)==255)break i}A=i[25863],i[h+40>>2]=i[25862],i[h+44>>2]=A,W[i[(h+40|0)+(e<<2)>>2]](h+39|0,h+12|0)}v=h+48|0}function eg(A){A=A|0;var e=0,r=0,f=0,k=0;r=A+12|0,A=i[r+164>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+156>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+148>>2],i[r+148>>2]=0,A&&W[i[i[A>>2]+4>>2]](A),L5(r+136|0,i[r+140>>2]),A=i[r+132>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+124>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+116>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+108>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+100>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+92>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+84>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+76>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+68>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+56>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+48>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+40>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+32>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[r+16>>2],A){if(e=A,f=i[r+20>>2],(A|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(A|0)==(f|0))break}e=i[r+16>>2]}i[r+20>>2]=A,Z(e)}A=i[r+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function Mn(A,e,r,f,k){var n=0,o=0,l=0;o=v-16|0,v=o,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:switch(f-1|0){case 0:case 3:break e;default:break i}if(e=i[e>>2],i[e+196>>2]==3)break i;l=i[e+16>>2],n=i[e+20>>2],n&&(i[n+4>>2]=i[n+4>>2]+1);e:{if(l){e=C(128),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=97388,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,t[e+112|0]=0,i[f>>2]=101860,i[e+32>>2]=1668246642,i[o+12>>2]=e,i[o+8>>2]=f;r:{if(!n){i[e+120>>2]=n,i[e+116>>2]=l;break r}if(i[n+4>>2]=i[n+4>>2]+2,i[e+120>>2]=n,i[e+116>>2]=l,e=i[n+4>>2],i[n+4>>2]=e-1,e)break r;W[i[i[n>>2]+8>>2]](n),y(n)}P0(A,o+8|0),e=i[o+12>>2];r:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break r;W[i[i[e>>2]+8>>2]](e),y(e)}f=u[r|0],e=u[r+3|0]!=0&i[r+4>>2]!=0&f>>>0>2;break e}f=u[r|0],e=i[r+4>>2]!=0}e:{if(!(!u[r+8|0]|(f&255)>>>0<4)|!e)break e;r=C(24),t[r+22|0]=1,X[r+20>>1]=2,X[r+16>>1]=2,X[r+18>>1]=2,i[r+12>>2]=101820,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101740,e=r+16|0,t[e+6|0]=1,X[e+4>>1]=6,X[e>>1]=1,X[e+2>>1]=13,ds(e,k),e=C(128),i[e>>2]=97388,i[e+4>>2]=0,i[e+8>>2]=0,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,t[e+112|0]=0,i[f>>2]=101860,i[e+32>>2]=1668246642,i[o+12>>2]=e,i[o+8>>2]=f,i[r+4>>2]=i[r+4>>2]+2,i[e+120>>2]=r,i[e+116>>2]=r+12,e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),P0(A,o+8|0),A=i[o+12>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[r+4>>2],i[r+4>>2]=A-1,A)break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=o+16|0}function rg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;o=v-128|0,v=o;i:{if(!f){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}n&&(i[n>>2]=0),t[o+81|0]=0,t[o+82|0]=0,t[o+83|0]=0,t[o+84|0]=0,X[o+78>>1]=0,X[o+80>>1]=0,X[o+76>>1]=264,i[o+112>>2]=0,t[o+108|0]=1,t[o+104|0]=0,i[o+96>>2]=2,i[o+100>>2]=2,t[o+92|0]=1,i[o+88>>2]=1;e:{if(!k)break e;r:{f:{A:{k:{n:{t:{o:{l:{u:switch(l=u[k|0],(l>>>0>=8?8:l)-1|0){case 0:break o;case 1:break l;case 2:break u;case 3:break f;case 4:break A;case 5:break k;case 6:break n;case 7:break t;default:break r}t[o+79|0]=u[k+3|0],t[o+78|0]=u[k+2|0],t[o+77|0]=u[k+1|0];break r}t[o+78|0]=u[k+2|0],t[o+77|0]=u[k+1|0];break r}t[o+77|0]=u[k+1|0];break r}i[o+112>>2]=i[k+36>>2]}t[o+108|0]=u[k+32|0]}s=i[k+20>>2],l=o+92|0,i[l>>2]=i[k+16>>2],i[l+4>>2]=s,s=i[k+28>>2],i[l+8>>2]=i[k+24>>2],i[l+12>>2]=s}i[o+88>>2]=i[k+12>>2]}if(l=i[k+4>>2],i[o+80>>2]=l,t[o+84|0]=u[k+8|0],t[o+79|0]=u[k+3|0],t[o+78|0]=u[k+2|0],t[o+77|0]=u[k+1|0],l)break e}if(!r8(i[r>>2]))break e;l=i[r>>2],k=p[l+6>>1]|p[l+8>>1]<<16,l=p[l+10>>1]|p[l+12>>1]<<16,i[o+32>>2]=k>>>16,i[o+28>>2]=k&65535,t[o+24|0]=1,t[o+40|0]=l>>>16&1,i[o+36>>2]=l&65535,i[o+80>>2]=o+24}ge(o,i[e>>2],r,f,o+76|0,1);e:{r:switch(u[o+20|0]){default:e2(),M();case 1:c0(A,o,i[e>>2]);break e;case 0:break r}i[o+120>>2]=i[o>>2],r=i[o+4>>2],i[o+124>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[e>>2],i[r+40>>2]||x3(r,o+120|0);r:{if(!n)break r;if(r=C(16),i[r+8>>2]=0,i[r+12>>2]=0,i[n>>2]=r,f=i[o+120>>2],k=i[o+124>>2],i[o+120>>2]=0,i[o+124>>2]=0,i[r>>2]=f,i[r+4>>2]=k,k=i[e>>2],f=i[e+4>>2],!f){i[r+12>>2]=f,i[r+8>>2]=k;break r}if(i[f+4>>2]=i[f+4>>2]+1,i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[o+124>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=u[o+20|0],(A|0)==255)break i;e=i[25833],i[o+120>>2]=i[25832],i[o+124>>2]=e,W[i[(o+120|0)+(A<<2)>>2]](o+119|0,o)}v=o+128|0}function Hn(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,f=i[r+4>>2]-i[r>>2]|0;i:{if(f>>>0>=256){if(e=C(64),i[k+4>>2]=e,i[k+8>>2]=57,i[k+12>>2]=-2147483584,r=u[12592]|u[12593]<<8|(u[12594]<<16|u[12595]<<24),f=u[12588]|u[12589]<<8|(u[12590]<<16|u[12591]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+57|0]=0,t[e+56|0]=u[12644],r=u[12640]|u[12641]<<8|(u[12642]<<16|u[12643]<<24),f=u[12636]|u[12637]<<8|(u[12638]<<16|u[12639]<<24),t[e+48|0]=f,t[e+49|0]=f>>>8,t[e+50|0]=f>>>16,t[e+51|0]=f>>>24,t[e+52|0]=r,t[e+53|0]=r>>>8,t[e+54|0]=r>>>16,t[e+55|0]=r>>>24,r=u[12632]|u[12633]<<8|(u[12634]<<16|u[12635]<<24),f=u[12628]|u[12629]<<8|(u[12630]<<16|u[12631]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[12624]|u[12625]<<8|(u[12626]<<16|u[12627]<<24),f=u[12620]|u[12621]<<8|(u[12622]<<16|u[12623]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[12616]|u[12617]<<8|(u[12618]<<16|u[12619]<<24),f=u[12612]|u[12613]<<8|(u[12614]<<16|u[12615]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[12608]|u[12609]<<8|(u[12610]<<16|u[12611]<<24),f=u[12604]|u[12605]<<8|(u[12606]<<16|u[12607]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[12600]|u[12601]<<8|(u[12602]<<16|u[12603]<<24),f=u[12596]|u[12597]<<8|(u[12598]<<16|u[12599]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,9,0,k+4|0),t[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(SA(i[e>>2],f),f=e+16|0,n=i[e+20>>2],e=i[r>>2],r=i[r+4>>2],V4(f,n,e,r,r-e|0),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+16|0}function FA(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;f=v+-64|0,v=f,i[f+52>>2]=0,i[f+48>>2]=1,W[i[i[r>>2]+132>>2]](f+36|0,i[r+4>>2],f+60|0,f+56|0,f+52|0,0,f+48|0);i:{e:{r:{if(k=i[f+36>>2],k)break r;l=e+24|0,w=e+20|0,s=e+8|0,n=e+28|0;f:{A:{k:{for(;;){if(o=u[e+76|0],k=i[f+60>>2],!k)break k;h=u[k|0]&31,_=h-1|0,t[e+76|0]=o|_>>>0<5;n:{t:switch(h-7|0){case 0:o=i[s>>2];o:{if(!o||(uA(f+4|0,k,i[f+56>>2],o+100|0,w,l,0),t[f+23|0]>=0))break o;Z(i[f+12>>2])}k=i[e+8>>2],!k|t[e+6|0]&1||_o(k,i[f+60>>2],i[f+56>>2]),t[e+6|0]=1;break n;case 6:if(o=i[s>>2],!o)break n;Bo(o,k,i[f+56>>2]);break n;case 1:o=i[e+8>>2],!o|t[e+7|0]&1||vo(o,k,i[f+56>>2]),t[e+7|0]=1;break n;default:break t}if(u[e+72|0]||(i[e+56>>2]=0,i[e+60>>2]=0,t[n+23|0]=0,t[n+24|0]=0,t[n+25|0]=0,t[n+26|0]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0,i[n>>2]=0,i[n+4>>2]=0,t[e+72|0]=1,i[e+68>>2]=0,t[e+64|0]=1),C6(n,k,i[f+56>>2]),_>>>0>4)break n;t[e+64|0]=(h|0)==5,i[e+68>>2]=i[f+52>>2]}if(i[f+48>>2]){if(i[f+52>>2]=0,i[f+48>>2]=1,W[i[i[r>>2]+132>>2]](f+36|0,i[r+4>>2],f+60|0,f+56|0,f+52|0,0,f+48|0),k=i[f+36>>2],!k)continue;break r}break}if(t[e+76|0]&1)break A;break f}if(!(o&1))break f}A:{if(r=i[w>>2],r&&(k=i[l>>2],k))break A;if(t[f+36|0]=0,t[f+47|0]=0,a(A,8,129,f+36|0),t[f+47|0]>=0)break e;Z(i[f+36>>2]);break e}A:{if(u[e+5|0]!=1||(l=i[s>>2],u[e+16|0]|!l))break A;i[f+36>>2]=l,r=i[e+12>>2],i[f+40>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=f+36|0,ao(n,r),g2(r),i[f+36>>2]=0,i[f+40>>2]=0,Q8(s,r),g2(r),t[e+16|0]=1,k=i[e+24>>2],r=i[e+20>>2]}i[e+60>>2]=k,i[e+56>>2]=r,X[e+52>>1]=257,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break e}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break e}if(n=i[f+40>>2],s=i[f+44>>2],e=l2(s),e>>>0>=2147483640)break i;r:{f:{if(e>>>0>=11){l=e|7,r=C(l+1|0),i[f+32>>2]=l-2147483647,i[f+24>>2]=r,i[f+28>>2]=e;break f}if(t[f+35|0]=e,r=f+24|0,!e)break r}if(!e)break r;z(r,s,e)}if(t[e+r|0]=0,a(A,k,n,f+24|0),t[f+35|0]>=0)break e;Z(i[f+24>>2])}v=f- -64|0;return}I0(),M()}function zn(A,e,r,f,k,n,o,l,s){var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;h=v-128|0,v=h;i:{e:{r:{if(!d6(n,o,l,s,0,0,0,0))break r;w=s&65535,B=s>>>16&32767;f:A:{if((B|0)!=32767){if(m=4,B)break A;m=n|l|(o|w)?3:2;break f}m=!(n|l|(o|w))}if(!m)break r;if(Y=k>>>16|0,I=Y&32767,(I|0)!=32767)break e}Z1(h+16|0,e,r,f,k,n,o,l,s),e=i[h+16>>2],f=i[h+20>>2],k=i[h+24>>2],r=i[h+28>>2],M9(h,e,f,k,r,e,f,k,r),f=i[h+8>>2],k=i[h+12>>2],l=i[h>>2],s=i[h+4>>2];break i}if(G=f,m=k&2147483647,w=m,B=l,_=s&2147483647,(d6(e,r,G,w,n,o,l,_)|0)<=0){if(d6(e,r,G,w,n,o,l,_)){l=e,s=r;break i}Z1(h+112|0,e,r,f,k,0,0,0,0),f=i[h+120>>2],k=i[h+124>>2],l=i[h+112>>2],s=i[h+116>>2];break i}if(Q=s>>>16&32767,I?(s=r,l=e):(Z1(h+96|0,e,r,G,m,0,0,0,1081540608),G=i[h+104>>2],l=i[h+108>>2],m=l,I=(l>>>16|0)-120|0,s=i[h+100>>2],l=i[h+96>>2]),Q||(Z1(h+80|0,n,o,B,_,0,0,0,1081540608),B=i[h+88>>2],n=i[h+92>>2],_=n,Q=(n>>>16|0)-120|0,o=i[h+84>>2],n=i[h+80>>2]),V=B,E=_&65535|65536,m=m&65535|65536,(I|0)>(Q|0)){for(;;){_=G-V|0,w=(o|0)==(s|0)&n>>>0>l>>>0|o>>>0>s>>>0,B=_-w|0,w=(m-((G>>>0<V>>>0)+E|0)|0)-(w>>>0>_>>>0)|0;e:{if((w|0)>=0|(w|0)>0){if(G=l,l=l-n|0,s=s-((n>>>0>G>>>0)+o|0)|0,!(l|B|(s|w))){Z1(h+32|0,e,r,f,k,0,0,0,0),f=i[h+40>>2],k=i[h+44>>2],l=i[h+32>>2],s=i[h+36>>2];break i}w=w<<1|B>>>31,G=B<<1|s>>>31;break e}w=m<<1|G>>>31,G=G<<1|s>>>31}if(m=w,w=s<<1|l>>>31,l=l<<1,s=w,I=I-1|0,!((Q|0)<(I|0)))break}I=Q}_=G-V|0,w=(o|0)==(s|0)&n>>>0>l>>>0|o>>>0>s>>>0,B=_-w|0,w=(m-((G>>>0<V>>>0)+E|0)|0)-(w>>>0>_>>>0)|0,_=w;e:{if((w|0)<0){B=G,_=m;break e}if(G=l,l=l-n|0,s=s-((n>>>0>G>>>0)+o|0)|0,l|B|(s|_))break e;Z1(h+48|0,e,r,f,k,0,0,0,0),f=i[h+56>>2],k=i[h+60>>2],l=i[h+48>>2],s=i[h+52>>2];break i}if((_|0)==65535|_>>>0<65535)for(;e=s>>>31|0,I=I-1|0,m=s<<1|l>>>31,l=l<<1,s=m,r=e,e=_<<1|B>>>31,B=r|B<<1,_=e,e>>>0<65536;);if(e=Y&32768,(I|0)<=0){Z1(h- -64|0,l,s,B,_&65535|(e|I+120)<<16,0,0,0,1065811968),f=i[h+72>>2],k=i[h+76>>2],l=i[h+64>>2],s=i[h+68>>2];break i}f=B,k=_&65535|(e|I)<<16}i[A>>2]=l,i[A+4>>2]=s,i[A+8>>2]=f,i[A+12>>2]=k,v=h+128|0}function CA(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;n=v+-64|0,v=n,i[r>>2]=0,o=i[28480],w=i[28481];i:{e:{for(;;){r:{if(i[n+44>>2]=0,W9(i[e>>2],n+44|0))break r;if(l=au(i[e>>2]),l){if(o=i[r>>2],o&&i8(o),f&&(i[f>>2]=i[l+288>>2]),f=i[l+20>>2],I=f,YA(n+52|0,i[i[16266]+l>>2],i[i[16269]+l>>2],f?0:2,f,r),f=i[n+52>>2],f){o=i[n+60>>2],s=i[n+56>>2];break e}for(m=i[i[l+124>>2]+i[16272]>>2],Q=(m+7|0)/8|0;;){if(h>>>0<=2?f=i[i[l+124>>2]+i[(h<<2)+65088>>2]>>2]:f=0,(f|0)!=(m|0)){i8(i[r>>2]),o=17891,f=4,s=3003;break e}o=64928,G=Pu(l,h,n+48|0),s=129,f=7;f:{if(_=h>>>0<=2?i[i[(h<<2)+65064>>2]+l>>2]:0,w=h>>>0<=2?i[i[(h<<2)+65076>>2]+l>>2]:0,!((_|0)<=0|(w|0)<=0)){if(s=i[(h<<2)+64932>>2],ou(n+52|0,i[r>>2],s,_,w,m,k),f=i[n+52>>2],!f)break f;s=i[n+56>>2],k=e+8|0,H2(k,i[n+60>>2]),o=t[e+19|0]<0?i[e+8>>2]:k}i8(i[r>>2]);break e}if(o=g(_,Q),f=0,_=Ki(i[r>>2],s,n+52|0),(w|0)!=1)for(V=w&2147483646,s=0;B=!o,B||z(_+g(i[n+52>>2],f)|0,g(i[n+48>>2],f)+G|0,o),B||(B=f|1,z(_+g(B,i[n+52>>2])|0,g(B,i[n+48>>2])+G|0,o)),f=f+2|0,s=s+2|0,(V|0)!=(s|0););if(!(w&1)|!o||z(_+g(i[n+52>>2],f)|0,g(i[n+48>>2],f)+G|0,o),!(I&&(f=h>>>0<2,h=h+1|0,f)))break}if(f=Af(),B5(A,f,u[i[l+124>>2]+9018|0]),i[A>>2]){if(u[e+4|0]==1){a2(f),i8(i[r>>2]),i[r>>2]=0;break i}k=i[r>>2],i[n+40>>2]=i[A+8>>2],o=i[A+4>>2],i[n+32>>2]=i[A>>2],i[n+36>>2]=o,E3(k,n+32|0)}if(v5(A,f,u[i[l+124>>2]+9019|0]),i[A>>2]){if(u[e+4|0]==1){a2(f),i8(i[r>>2]),i[r>>2]=0;break i}k=i[r>>2],i[n+24>>2]=i[A+8>>2],o=i[A+4>>2],i[n+16>>2]=i[A>>2],i[n+20>>2]=o,E3(k,n+16|0)}if(w5(A,f,u[i[l+124>>2]+9020|0]),i[A>>2]){if(u[e+4|0]==1){a2(f),i8(i[r>>2]),i[r>>2]=0;break i}k=i[r>>2],i[n+8>>2]=i[A+8>>2],o=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=o,E3(k,n)}t[f+16|0]=u[i[l+124>>2]+9016|0]!=0,Iu(n+52|0,i[r>>2],f),a2(f),Ws(i[e>>2]),i[A+8>>2]=i[25788],e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e;break i}if(i[n+44>>2])continue}break}i[A+4>>2]=o,i[A+8>>2]=w,i[A>>2]=0;break i}i[A>>2]=f,i[A+4>>2]=s,i[A+8>>2]=o}v=n- -64|0}function YA(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0;h=v-16|0,v=h;i:{if(!n){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}f|k||(F(135700,46997,136),f=2);e:{r:{f:switch(f|0){case 0:o=C(12),i[h+4>>2]=o,s=o+12|0,i[h+12>>2]=s,i[o+8>>2]=3,i[o>>2]=1,i[o+4>>2]=2;break r;case 1:l=C(32),i[h+4>>2]=l,s=l+32|0,i[h+12>>2]=s,o=i[13794],i[l+24>>2]=i[13793],i[l+28>>2]=o,o=i[13792],i[l+16>>2]=i[13791],i[l+20>>2]=o,o=i[13790],i[l+8>>2]=i[13789],i[l+12>>2]=o,o=i[13788],i[l>>2]=i[13787],i[l+4>>2]=o;break r;default:i[h+12>>2]=0,i[h+4>>2]=0,i[h+8>>2]=0;break e;case 2:case 3:case 4:break f}o=C(4),i[h+4>>2]=o,s=o+4|0,i[h+12>>2]=s,i[o>>2]=0}i[h+8>>2]=s}e:{r:{f:{A:{if(l=i[h+4>>2],s=l,o=i[h+8>>2],(l|0)==(o|0))break A;for(;;){if(i[s>>2]==(k|0))break A;if(s=s+4|0,(o|0)==(s|0))break}break f}if((o|0)!=(s|0))break r}i[n>>2]=0,i[A+8>>2]=26732,i[A>>2]=5,i[A+4>>2]=2006;break e}s=C(8),o=s,i[o>>2]=0,i[o+4>>2]=0,o=C(248),i[o>>2]=101168,i[o+4>>2]=0,i[o+8>>2]=0,l0(o+16|0,0,156),i[o+76>>2]=0,i[o+80>>2]=0,i[o+36>>2]=1,i[o+40>>2]=1,t[o+24|0]=1,X[o+22>>1]=2,X[o+18>>1]=2,X[o+20>>1]=2,i[o+84>>2]=0,i[o+88>>2]=0,i[o+92>>2]=0,i[o+96>>2]=0,i[o+128>>2]=0,i[o+132>>2]=0,i[o+100>>2]=0,i[o+104>>2]=1,i[o+136>>2]=0,i[o+140>>2]=0,i[o+144>>2]=0,i[o+148>>2]=0,i[o+152>>2]=0,i[o+156>>2]=0,X[o+158>>1]=0,X[o+160>>1]=0,X[o+162>>1]=0,X[o+164>>1]=0,i[o+184>>2]=0,i[o+188>>2]=0,i[o+172>>2]=255,i[o+192>>2]=0,i[o+196>>2]=5186,i[o+208>>2]=99,i[o+212>>2]=99,i[o+200>>2]=0,i[o+204>>2]=0,i[o+12>>2]=101488,i[o+216>>2]=0,i[o+220>>2]=0,i[o+224>>2]=0,i[o+228>>2]=0,i[o+232>>2]=0,i[o+236>>2]=0,i[o+240>>2]=0,i[o+244>>2]=0,l=o+12|0,i[o+176>>2]=l,i[o+8>>2]=i[o+8>>2]+1,i[o+180>>2]=o,i[o+4>>2]==-1&&(W[i[i[o>>2]+8>>2]](o),y(o)),i[s>>2]=l,l=i[s+4>>2],i[s+4>>2]=o;r:{if(!l||(o=i[l+4>>2],i[l+4>>2]=o-1,o))break r;W[i[i[l>>2]+8>>2]](l),y(l)}t1(i[s>>2],e,r,f,k),i[n>>2]=s,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,l=i[h+4>>2]}if(!l)break i;i[h+8>>2]=l,Z(l)}v=h+16|0}function fg(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0;h=v+-64|0,v=h,w=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[h+60>>2]=r,i[h+56>>2]=w;i:{e:{r:{if(!u[e+4|0]){if(W[i[i[f>>2]+120>>2]](h+24|0,i[f+4>>2],h+56|0,n,o,l,k),k=i[h+24>>2],k){if(f=i[h+28>>2],n=i[h+32>>2],r=l2(n),r>>>0>=2147483640)break e;f:{A:{if(r>>>0>=11){o=r|7,e=C(o+1|0),i[h+52>>2]=o-2147483647,i[h+44>>2]=e,i[h+48>>2]=r;break A}if(t[h+55|0]=r,e=h+44|0,!r)break f}if(!r)break f;z(e,n,r)}if(t[e+r|0]=0,a(A,k,f,h+44|0),t[h+55|0]>=0)break r;Z(i[h+44>>2]);break r}r=C(168),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=98508,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[r+16>>2]=106924,t[r+120|0]=0,i[r+116>>2]=0,i[r+132>>2]=0,i[r+136>>2]=0,X[r+128>>1]=2056,i[r+124>>2]=1,i[r+140>>2]=0,i[r+144>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+156>>2]=0,i[r+160>>2]=0,i[r+164>>2]=0,i[r+32>>2]=1635148611,i[e+8>>2]=k,k=i[e+12>>2],i[e+12>>2]=r;f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;W[i[i[k>>2]+8>>2]](k),y(k)}t[e+4|0]=1}if(FA(h+24|0,e,f),i[h+24>>2]){e=i[h+28>>2],i[A>>2]=i[h+24>>2],i[A+4>>2]=e,e=i[h+36>>2],i[A+8>>2]=i[h+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[h+40>>2];break r}W[i[i[f>>2]+124>>2]](h+44|0,i[f+4>>2],h+56|0,s),k=i[h+44>>2];f:{if(k){if(f=i[h+48>>2],n=i[h+52>>2],r=l2(n),r>>>0>=2147483640)break i;A:{k:{if(r>>>0>=11){o=r|7,e=C(o+1|0),i[h+20>>2]=o-2147483647,i[h+12>>2]=e,i[h+16>>2]=r;break k}if(t[h+23|0]=r,e=h+12|0,!r)break A}if(!r)break A;z(e,n,r)}if(t[e+r|0]=0,a(A,k,f,h+12|0),t[h+23|0]>=0)break f;Z(i[h+12>>2]);break f}FA(A,e,f)}if(t[h+43|0]>=0)break r;Z(i[h+32>>2])}A=i[h+60>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=h- -64|0;return}I0(),M()}I0(),M()}function Ag(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;k=v-192|0,v=k,S2(k+172|0,e,r),t[k+191|0]<0&&Z(i[k+180>>2]);i:{if(u[e+97|0]){B1(A,e,17077);break i}l=F0(r);e:{r:{f:{A:{k:{if(n=i[f+72>>2],!(n>>>0<l>>>0&&n)){if(l)for(o=e+104|0,n=0;;){if(i[k+24>>2]=0,i[k+28>>2]=0,e=k+24|0,c8(A,r,e,f),i[A>>2])break k;P0(o,e),t[A+19|0]<0&&Z(i[A+8>>2]),e=i[k+28>>2];n:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break n;W[i[i[e>>2]+8>>2]](e),y(e)}if(n=n+1|0,(l|0)==(n|0))break}if(u[r+20|0]!=1)break A;if(t[k+24|0]=0,t[k+35|0]=0,a(A,2,100,k+24|0),t[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}i[k+116>>2]=0,i[k+88>>2]=78164,i[k+32>>2]=78144,e=i[19545],i[k+24>>2]=e,r=i[e-12>>2],e=k+24|0,i[r+e>>2]=i[19546],i[k+28>>2]=0,r=e+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(r,n),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[k+32>>2]=r,o=i[r-12>>2],r=k+32|0,i[o+r>>2]=i[19548],o=i[19544],i[k+24>>2]=o,i[e+i[o-12>>2]>>2]=i[19549],i[k+88>>2]=78164,i[k+24>>2]=78124,i[k+32>>2]=78144,o=R0(n),i[o>>2]=77200,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,F(B0(F(M2(F(r,31897,11),l,0),31972,56),i[f+72>>2]),5596,6),e=i[k+84>>2];n:{if(e&16){n=k+56|0,r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0?i[k+80>>2]=e:e=r;break n}if(!(e&8)){e=0,t[k+23|0]=0,n=k+12|0;break e}n=k+44|0,e=i[k+52>>2]}if(r=i[n>>2],e=e-r|0,e>>>0>=2147483640)break f;if(e>>>0>=11){f=e|7,n=C(f+1|0),i[k+20>>2]=f-2147483647,i[k+12>>2]=n,i[k+16>>2]=e;break r}if(t[k+23|0]=e,n=k+12|0,e)break r;e=0;break e}if(A=i[k+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}I0(),M()}if(!e)break e;z(n,r,e)}t[e+n|0]=0,a(A,6,1e3,k+12|0),t[k+23|0]<0&&Z(i[k+12>>2]),A=i[19543],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[19551],i[k+32>>2]=i[19552],i[o>>2]=77200,t[k+79|0]<0&&Z(i[k+68>>2]),y0(o),Y0(k+88|0)}v=k+192|0}function i3(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;h=v-2048|0,v=h;i:{e:{if((r|0)>=2){for(n=r;k=w,w=k+1|0,o=n>>>0>3,n=n>>>1|0,!!o;);w=4-k|0;break e}if(w=5,(r|0)!=1)break i}for(Q=r&-4,G=r&3,I=r-1|0;;){s=(l<<1)+f|0,n=0,o=r;e:{for(;;){if(B=n,k=o,(k|0)<=0){if(o=0,n=0,k=0,I>>>0>=3)for(;X[(g(r,n)+l<<1)+h>>1]=0,X[(g(n|1,r)+l<<1)+h>>1]=0,X[(g(n|2,r)+l<<1)+h>>1]=0,X[(g(n|3,r)+l<<1)+h>>1]=0,n=n+4|0,k=k+4|0,(Q|0)!=(k|0););if(!G)break e;for(;X[(g(r,n)+l<<1)+h>>1]=0,n=n+1|0,o=o+1|0,(G|0)!=(o|0););break e}if(n=B+1|0,o=k-1|0,!!p[s+(g(o,r)<<1)>>1])break}for(V=k&2147483646,Y=k&1,o=0;;){if(n=0,k=0,_=0,(B|0)!=(I|0))for(;m=g(X[s+(g(r,n)<<1)>>1],t[((n<<w<<5)+o|0)+67712|0])+k|0,k=n|1,k=m+g(X[s+(g(k,r)<<1)>>1],t[((k<<w<<5)+o|0)+67712|0])|0,n=n+2|0,_=_+2|0,(V|0)!=(_|0););if(_=(g(r,o)+l<<1)+h|0,Y&&(k=g(X[s+(g(r,n)<<1)>>1],t[((n<<w<<5)+o|0)+67712|0])+k|0),k=k- -64>>7,k=(k|0)>=32767?32767:k,X[_>>1]=(k|0)<=-32768?-32768:k,o=o+1|0,(o|0)==(r|0))break}}if(l=l+1|0,(l|0)==(r|0))break}for(G=r&-2,_=r&1,l=0;;){s=g(r,l),n=s-1|0,o=0,k=r;e:{r:{for(;;){if(B=o,f=k,(k|0)<=0)break r;if(o=o+1|0,k=k-1|0,!!p[(f+n<<1)+h>>1])break}for(Q=f&2147483646,V=f&1,Y=g(e,l)+A|0,o=0;;){if(n=0,k=0,f=0,(B|0)!=(I|0))for(;m=g(X[(n+s<<1)+h>>1],t[((n<<w<<5)+o|0)+67712|0])+k|0,k=n|1,k=m+g(X[(k+s<<1)+h>>1],t[((k<<w<<5)+o|0)+67712|0])|0,n=n+2|0,f=f+2|0,(Q|0)!=(f|0););if(f=o+Y|0,m=u[f|0],V&&(k=g(X[(n+s<<1)+h>>1],t[((n<<w<<5)+o|0)+67712|0])+k|0),n=f,f=(k+2048>>12)+m|0,t[n|0]=(f|0)>=0?(f|0)>=255?255:f:0,o=o+1|0,(o|0)==(r|0))break}break e}f=g(e,l)+A|0;r:{if(!I){n=0;break r}for(B=f+1|0,n=0,k=0;s=f+n|0,o=u[s|0],t[s|0]=o>>>0>=255?255:o,s=n+B|0,o=u[s|0],t[s|0]=o>>>0>=255?255:o,n=n+2|0,k=k+2|0,(G|0)!=(k|0););}if(!_)break e;k=f+n|0,f=u[k|0],t[k|0]=f>>>0>=255?255:f}if(l=l+1|0,(l|0)==(r|0))break}}v=h+2048|0}function yA(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;n=v-48|0,v=n,hn(e),QA(n+8|0,e+172|0,0);i:{e:{r:{f:switch(h=u[n+28|0],h|0){case 0:break e;case 1:break r;default:break f}e2(),M()}if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,r=A+8|0,t[n+27|0]>=0){e=i[n+20>>2],i[r>>2]=i[n+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[n+24>>2];break i}T(r,i[n+16>>2],i[n+20>>2]);break i}l=i[n+8>>2],f=C(184),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=96188,k=f+16|0,s=k,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,X[f+112>>1]=0,i[k>>2]=93496,i[f+128>>2]=0,i[f+132>>2]=0,X[f+124>>1]=0,i[f+136>>2]=0,i[f+140>>2]=0,i[f+144>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,i[f+156>>2]=0,i[f+160>>2]=0,i[f+164>>2]=0,i[f+168>>2]=0,i[f+172>>2]=0,t[f+173|0]=0,t[f+174|0]=0,t[f+175|0]=0,t[f+176|0]=0,t[f+177|0]=0,t[f+178|0]=0,t[f+179|0]=0,t[f+180|0]=0,i[f+120>>2]=l,i[f+32>>2]=1768842853,t[k+164|0]=0,i[k+100>>2]=i[k+100>>2]&-2,i[f+128>>2]=r,k=i[e+140>>2];e:{r:{if(!k){o=e+140|0,r=o;break r}for(;;){if(r=k,k=i[k+16>>2],k>>>0>l>>>0){if(o=r,k=i[r>>2],k)continue;break r}if(k>>>0>=l>>>0){k=r;break e}if(k=i[r+4>>2],!k)break}o=r+4|0}k=C(28),i[k+20>>2]=0,i[k+24>>2]=0,i[k+16>>2]=l,i[k+8>>2]=r,i[k>>2]=0,i[k+4>>2]=0,i[o>>2]=k,r=i[i[e+136>>2]>>2],r&&(i[e+136>>2]=r),G1(i[e+140>>2],k),i[e+144>>2]=i[e+144>>2]+1}i[f+4>>2]=i[f+4>>2]+1,i[k+20>>2]=s,o=i[k+24>>2],i[k+24>>2]=f;e:{if(!o||(r=i[o+4>>2],i[o+4>>2]=r-1,r))break e;W[i[i[o>>2]+8>>2]](o),y(o)}e=i[e+88>>2],i[n+44>>2]=f,i[n+40>>2]=s,i[f+4>>2]=i[f+4>>2]+1,P0(e+36|0,n+40|0),r=i[n+44>>2];e:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break e;W[i[i[r>>2]+8>>2]](r),y(r)}i[A+4>>2]=f,i[A>>2]=s}t[A+20|0]=h,e=u[n+28|0],(e|0)!=255&&(A=i[25327],i[n+40>>2]=i[25326],i[n+44>>2]=A,W[i[(n+40|0)+(e<<2)>>2]](n+39|0,n+8|0)),v=n+48|0}function kg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0;n=v-16|0,v=n,o=i[r+4>>2],l=i[k>>2],s=i[r>>2],r=l+s|0;i:{if(o-r>>>0<(f|0)/8<<1>>>0){if(e=C(48),i[n+4>>2]=e,i[n+8>>2]=44,i[n+12>>2]=-2147483600,r=u[9564]|u[9565]<<8|(u[9566]<<16|u[9567]<<24),f=u[9560]|u[9561]<<8|(u[9562]<<16|u[9563]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+44|0]=0,r=u[9600]|u[9601]<<8|(u[9602]<<16|u[9603]<<24),t[e+40|0]=r,t[e+41|0]=r>>>8,t[e+42|0]=r>>>16,t[e+43|0]=r>>>24,r=u[9596]|u[9597]<<8|(u[9598]<<16|u[9599]<<24),f=u[9592]|u[9593]<<8|(u[9594]<<16|u[9595]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[9588]|u[9589]<<8|(u[9590]<<16|u[9591]<<24),f=u[9584]|u[9585]<<8|(u[9586]<<16|u[9587]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[9580]|u[9581]<<8|(u[9582]<<16|u[9583]<<24),f=u[9576]|u[9577]<<8|(u[9578]<<16|u[9579]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[9572]|u[9573]<<8|(u[9574]<<16|u[9575]<<24),f=u[9568]|u[9569]<<8|(u[9570]<<16|u[9571]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,136,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}o=u[r|0],h=u[r+1|0];e:{if((f|0)==32){f=u[r+3|0],r=u[r+2|0],i[k>>2]=l+4,i[e+4>>2]=f|(h<<16|o<<24|r<<8),f=i[k>>2],r=f+s|0,r=u[r|0]|u[r+1|0]<<8|(u[r+2|0]<<16|u[r+3|0]<<24),r=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),f=f+4|0;break e}i[k>>2]=l+2,i[e+4>>2]=(h<<16|o<<24)>>16,f=i[k>>2],r=f+s|0,r=(u[r+1|0]<<16|u[r|0]<<24)>>16,f=f+2|0}if(i[k>>2]=f,i[e+8>>2]=r,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+16|0}function e3(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;i[A>>2]=0,i[A+4>>2]=0,i[A+140>>2]=0,i[A+144>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,i[A+52>>2]=0,t[A+53|0]=0,t[A+54|0]=0,t[A+55|0]=0,t[A+56|0]=0,t[A+57|0]=0,t[A+58|0]=0,t[A+59|0]=0,t[A+60|0]=0,l0(A- -64|0,0,72),i[A+148>>2]=0,i[A+152>>2]=0,i[A+136>>2]=A+140,i[A+156>>2]=0,i[A+160>>2]=0,i[A+164>>2]=0,i[A+168>>2]=0,t[A+172|0]=0,i[A+184>>2]=1,i[A+188>>2]=1,i[A+176>>2]=1,i[A+180>>2]=1,s=C(104),i[s>>2]=101320,i[s+4>>2]=0,i[s+8>>2]=0,f=s+16|0,e=f,i[e+16>>2]=0,i[e+20>>2]=0,i[e+8>>2]=-1,i[e+12>>2]=-1,i[e>>2]=1,i[e+64>>2]=0,i[e+68>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,e=C(136),i[e>>2]=95948,i[e+4>>2]=0,i[e+8>>2]=0,l=e+16|0,r=l,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,t[e+112|0]=0,i[r>>2]=93096,i[e+132>>2]=0,i[e+124>>2]=0,i[e+128>>2]=0,i[e+116>>2]=0,i[e+120>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+32>>2]=1718909296,i[e+4>>2]=i[e+4>>2]+1;i:{e:{r:{r=i[f+20>>2],k=i[f+24>>2];f:{if(r>>>0<k>>>0){i[r+4>>2]=e,i[r>>2]=l,r=r+8|0;break f}if(h=i[f+16>>2],r=r-h|0,w=r>>3,n=w+1|0,n>>>0>=536870912)break r;if(k=k-h|0,o=k>>2,k=k>>>0>=2147483640?536870911:o>>>0>n>>>0?o:n,k){if(k>>>0>=536870912)break e;n=C(k<<3)}else n=0;if(o=n+r|0,i[o+4>>2]=e,i[o>>2]=l,l=o-(w<<3)|0,r&&z(l,h,r),i[f+24>>2]=n+(k<<3),r=o+8|0,i[f+20>>2]=r,i[f+16>>2]=l,!h)break f;Z(h)}i[f+20>>2]=r,r=i[e+4>>2],i[e+4>>2]=r-1,r||(W[i[i[e>>2]+8>>2]](e),y(e));break i}s0(),M()}x0(),M()}i[A>>2]=f,e=i[A+4>>2],i[A+4>>2]=s;i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A}function Fe(A,e,r,f,k,n,o,l,s){var h=0,w=0,_=0,B=0,m=0;h=v+-64|0,v=h,S6(h+40|0,i[e+48>>2],n);i:{e:{r:{f:switch(u[h+60|0]){default:e2(),M();case 1:if(e=i[h+44>>2],i[A>>2]=i[h+40>>2],i[A+4>>2]=e,A=A+8|0,t[h+59|0]>=0){e=i[h+52>>2],i[A>>2]=i[h+48>>2],i[A+4>>2]=e,i[A+8>>2]=i[h+56>>2];break r}T(A,i[h+48>>2],i[h+52>>2]);break r;case 0:break f}_=i[h+40>>2],n=i[h+44>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),t[_+164|0]=1,i[_+100>>2]=i[_+100>>2]&-2|1;f:{if(!o)break f;if(w=l2(o),w>>>0>=2147483640)break e;A:{k:{if(w>>>0>=11){m=w|7,B=C(m+1|0),i[h+32>>2]=m-2147483647,i[h+24>>2]=B,i[h+28>>2]=w;break k}if(t[h+35|0]=w,B=h+24|0,!w)break A}if(!w)break A;z(B,o,w)}t[w+B|0]=0,o=_+128|0;A:{if((o|0)==(h+24|0))break A;if(w=t[h+35|0],t[_+139|0]>=0){if((w|0)>=0){w=i[h+28>>2],i[o>>2]=i[h+24>>2],i[o+4>>2]=w,i[o+8>>2]=i[h+32>>2];break A}m1(o,i[h+24>>2],i[h+28>>2]);break A}B=o,o=(w|0)<0,R1(B,o?i[h+24>>2]:h+24|0,o?i[h+28>>2]:w)}if(t[h+35|0]>=0)break f;Z(i[h+24>>2])}o=i[_+104>>2],s&&(i[s>>2]=o),s=i[e+48>>2],w=i[i[r>>2]+196>>2],r=C(4),i[h+24>>2]=r,_=r+4|0,i[h+32>>2]=_,i[r>>2]=w,i[h+28>>2]=_,o8(s,o,1667527523,h+24|0),r=i[h+24>>2],r&&(i[h+28>>2]=r,Z(r)),r=0,i[h+32>>2]=0,i[h+24>>2]=0,i[h+28>>2]=0;f:{A:switch(l-3|0){case 1:if(t[h+12|0]=0,t[h+23|0]=0,a(A,4,3005,h+12|0),t[h+23|0]>=0)break f;Z(i[h+12>>2]);break f;case 0:if(t[h+12|0]=0,t[h+23|0]=0,a(A,4,3005,h+12|0),t[h+23|0]>=0)break f;Z(i[h+12>>2]);break f;default:break A}if(k){if((k|0)<0)break i;r=C(k),k&&l0(r,0,k),l=r+k|0,i[h+32>>2]=l,i[h+28>>2]=l,i[h+24>>2]=r}if(k&&z(r,f,k),w6(i[e+48>>2],o,h+24|0,0),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break f}T(A,i[28730],i[28731])}if(A=i[h+24>>2],A&&(i[h+28>>2]=A,Z(A)),!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break r;W[i[i[n>>2]+8>>2]](n),y(n)}A=u[h+60|0],(A|0)!=255&&(e=i[25167],i[h+24>>2]=i[25166],i[h+28>>2]=e,W[i[(h+24|0)+(A<<2)>>2]](h+12|0,h+40|0)),v=h- -64|0;return}I0(),M()}s0(),M()}function ng(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;n=v-16|0,v=n,l=F0(r),s=F0(r),h=F0(r),_=F0(r),k=F0(r),f=F0(r),w=F0(r),o=F0(r);i:{if((o|(l|s|h|_|f))<0){if(e=C(32),i[n>>2]=e,i[n+4>>2]=31,i[n+8>>2]=-2147483616,r=u[28023]|u[28024]<<8|(u[28025]<<16|u[28026]<<24),f=u[28019]|u[28020]<<8|(u[28021]<<16|u[28022]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+31|0]=0,r=u[28046]|u[28047]<<8|(u[28048]<<16|u[28049]<<24),f=u[28042]|u[28043]<<8|(u[28044]<<16|u[28045]<<24),t[e+23|0]=f,t[e+24|0]=f>>>8,t[e+25|0]=f>>>16,t[e+26|0]=f>>>24,t[e+27|0]=r,t[e+28|0]=r>>>8,t[e+29|0]=r>>>16,t[e+30|0]=r>>>24,r=u[28039]|u[28040]<<8|(u[28041]<<16|u[28042]<<24),f=u[28035]|u[28036]<<8|(u[28037]<<16|u[28038]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[28031]|u[28032]<<8|(u[28033]<<16|u[28034]<<24),f=u[28027]|u[28028]<<8|(u[28029]<<16|u[28030]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,128,n),t[n+11|0]>=0)break i;Z(i[n>>2]);break i}if(s=su(n,l,s),l=i[s>>2],s=i[s+4>>2],i[e+100>>2]=l,i[e+104>>2]=s,h=su(n,h,_),l=i[h>>2],h=i[h+4>>2],i[e+108>>2]=l,i[e+112>>2]=h,f-65537>>>0<4294836223)for(;k=(k|0)/2|0,f=(f|0)/2|0,f-65537>>>0<4294836223;);e:{if((f|0)<=1)break e;for(;;){if(k-65537>>>0>4294836222)break e;if(k=(k|0)/2|0,l=f>>>0>3,f=f>>>1|0,!l)break}}if(i[e+116>>2]=k,i[e+120>>2]=f,o-65537>>>0<4294836223)for(;w=(w|0)/2|0,o=(o|0)/2|0,o-65537>>>0<4294836223;);e:{if((o|0)<=1){k=o;break e}for(;;){if(w-65537>>>0>4294836222){k=o;break e}if(w=(w|0)/2|0,l=o>>>0>3,k=o>>>1|0,o=k,!l)break}}i[e+124>>2]=w,i[e+128>>2]=k;e:{if(!(!f|(!s|!h))&&k)break e;if(e=A,A=V2(n,47881),a(e,2,128,A),t[A+11|0]>=0)break i;Z(i[A>>2]);break i}Au(A,r)}v=n+16|0}function xn(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;if(l=v-16|0,v=l,f=i[A+248>>2],!f){f=C(128),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100428,n=f+16|0,k=n,i[k+8>>2]=0,i[k+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,i[f+16>>2]=113304,i[f+124>>2]=0,i[f+116>>2]=0,i[f+120>>2]=0,i[f+32>>2]=1953654118,i[A+248>>2]=k,k=i[A+252>>2],i[A+252>>2]=f;i:{e:{if(!k){k=i[A+136>>2],i[l+12>>2]=f,i[l+8>>2]=n;break e}if(f=i[k+4>>2],i[k+4>>2]=f-1,f||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[A+136>>2],n=i[A+248>>2],f=i[A+252>>2],i[l+12>>2]=f,i[l+8>>2]=n,!f)break i}i[f+4>>2]=i[f+4>>2]+1}P0(k+36|0,l+8|0),f=i[l+12>>2];i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[A+248>>2]}k=v-32|0,v=k;i:{e:{r:{f:{n=i[f+100>>2],A=i[f+104>>2];A:{if((n|0)!=(A|0))for(;;){if(i[n>>2]==(e|0)){if(A=i[n+8>>2],o=i[n+12>>2],A>>>0<o>>>0){i[A>>2]=r,i[n+8>>2]=A+4;break A}if(f=i[n+4>>2],A=A-f|0,h=A>>2,e=h+1|0,e>>>0>=1073741824)break f;if(o=o-f|0,s=o>>1,o=o>>>0>=2147483644?1073741823:e>>>0<s>>>0?s:e,o){if(o>>>0>=1073741824)break r;e=C(o<<2)}else e=0;s=e+A|0,i[s>>2]=r,r=s-(h<<2)|0,A&&z(r,f,A),i[n+12>>2]=e+(o<<2),A=s+4|0,i[n+8>>2]=A,i[n+4>>2]=r,f&&Z(f),i[n+8>>2]=A;break A}if(n=n+16|0,(A|0)==(n|0))break}i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+16>>2]=e,i[k+12>>2]=r,h1(k+20|0,k+12|0,k+16|0,1),A=i[f+104>>2];k:{if(A>>>0<o0[f+108>>2]){if(e=i[k+16>>2],i[A+12>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=e,e=i[k+24>>2],n=i[k+20>>2],(e|0)!=(n|0)){if(e=e-n|0,(e|0)<0)break e;r=C(e),i[A+8>>2]=r,i[A+4>>2]=r,o=e+r|0,i[A+12>>2]=o,e&&z(r,n,e),i[A+8>>2]=o}A=A+16|0;break k}A=B3(f+100|0,k+16|0)}if(i[f+104>>2]=A,A=i[k+20>>2],!A)break A;i[k+24>>2]=A,Z(A)}v=k+32|0;break i}s0(),M()}x0(),M()}s0(),M()}v=l+16|0}function r3(A,e,r){var f=0,k=0,n=0,o=0;f=v-96|0,v=f,k=f- -64|0;i:{e:{r:{f:{A:{k:{n:{t:{o:{if(r){W[i[i[e>>2]+24>>2]](f+56|0,e);l:{u:switch(u[f+76|0]){case 1:e=i[f+60>>2],i[A>>2]=i[f+56>>2],i[A+4>>2]=e,e=A+8|0;s:{if(t[f+75|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2];break s}T(e,i[f+64>>2],i[f+68>>2])}t[A+20|0]=1;break l;case 0:break u;default:break o}if(i[f+52>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,r=i[f+60>>2],k=i[f+56>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break A;n=C(r),i[f+44>>2]=n,o=r+n|0,i[f+52>>2]=o,r&&z(n,k,r),i[f+48>>2]=o}DA(f+16|0,e+8|0);u:{s:{h:switch(r=u[f+36|0],r|0){case 0:break s;case 1:break h;default:break o}if(e=i[f+20>>2],i[A>>2]=i[f+16>>2],i[A+4>>2]=e,e=A+8|0,t[f+35|0]>=0){k=i[f+28>>2],i[e>>2]=i[f+24>>2],i[e+4>>2]=k,i[e+8>>2]=i[f+32>>2];break u}T(e,i[f+24>>2],i[f+28>>2]);break u}e=i[f+16>>2],k=i[e>>2],e=i[e+4>>2],V4(f+44|0,i[f+48>>2],k,e,e-k|0),e=i[f+52>>2],i[f+52>>2]=0,k=i[f+44>>2],n=i[f+48>>2],i[f+44>>2]=0,i[f+48>>2]=0,i[A+8>>2]=e,i[A>>2]=k,i[A+4>>2]=n}if(t[A+20|0]=r,A=u[f+36|0],(A|0)!=255&&(e=i[25887],i[f+88>>2]=i[25886],i[f+92>>2]=e,W[i[(f+88|0)+(A<<2)>>2]](f+87|0,f+16|0)),A=i[f+44>>2],!A)break l;i[f+48>>2]=A,Z(A)}if(A=u[f+76|0],(A|0)==255)break i;e=i[25889],i[f+16>>2]=i[25888],i[f+20>>2]=e,W[i[(f+16|0)+(A<<2)>>2]](f+44|0,f+56|0);break i}switch(DA(f+56|0,e+8|0),e=u[f+76|0],e|0){case 0:break n;case 1:break t;default:break o}}e2(),M()}if(r=i[f+60>>2],i[A>>2]=i[f+56>>2],i[A+4>>2]=r,r=A+8|0,t[f+75|0]<0)break r;n=i[k+4>>2],i[r>>2]=i[k>>2],i[r+4>>2]=n,i[r+8>>2]=i[k+8>>2];break k}if(r=0,i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,k=0,n=i[f+56>>2],o=i[n+4>>2],n=i[n>>2],(o|0)!=(n|0)){if(r=o-n|0,(r|0)<0)break f;k=C(r),r&&z(k,n,r),r=r+k|0}i[A+8>>2]=r,i[A+4>>2]=r,i[A>>2]=k}t[A+20|0]=e;break e}s0(),M()}s0(),M()}if(T(r,i[f+64>>2],i[f+68>>2]),e=u[f+76|0],t[A+20|0]=1,(e|0)==255)break i}A=i[25887],i[f+16>>2]=i[25886],i[f+20>>2]=A,W[i[(f+16|0)+(e<<2)>>2]](f+44|0,f+56|0)}v=f+96|0}function Tn(A,e,r,f,k,n,o,l,s,h,w,_,B){var m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0;m=v,x=m,m=m-19808&-32,v=m,I=i[e+16852>>2],Q=g(2/(I|0)|0,r),r=((k|0)/(I|0)|0)+(Q>>3)|0,k=f,f=i[e+16856>>2],G=g(k,2/(f|0)|0),n=((n|0)/(f|0)|0)+(G>>3)|0,Y=i[e+488>>2]/(f|0)|0,k=i[e+484>>2]/(I|0)|0;i:{if(I=Q&7,f=G&7,!(I|f)){if(e=i[e+16840>>2],!((r|0)<0|(k|0)<(r+w|0)|((n|0)<0|(Y|0)<(n+_|0)))){if(e=((r<<1)+s|0)+(g(n,h)<<1)|0,(B|0)<=8){W[i[A+204>>2]](o,l,e,h,w,_,0,0,0);break i}W[i[A+284>>2]](o,l,e,h,w,_,0,0,0,B);break i}if((_|0)<=0|(w|0)<=0)break i;for(B=14-e|0,E=Y-1|0,m=k-1|0,R=w&2147483646,N=w&1,A=0;;){if(e=A+n|0,I=(g((e|0)>=0?(e|0)<(Y|0)?e:E:0,h)<<1)+s|0,Q=(g(A,l)<<1)+o|0,e=0,f=0,(w|0)!=1)for(;G=e+r|0,X[Q+(e<<1)>>1]=p[I+(((G|0)>=0?(k|0)>(G|0)?G:m:0)<<1)>>1]<<B,V=e|1,G=V+r|0,X[Q+(V<<1)>>1]=p[I+(((G|0)>=0?(k|0)>(G|0)?G:m:0)<<1)>>1]<<B,e=e+2|0,f=f+2|0,(R|0)!=(f|0););if(N&&(f=Q+(e<<1)|0,e=e+r|0,X[f>>1]=p[I+(((e|0)>=0?(e|0)<(k|0)?e:m:0)<<1)>>1]<<B),A=A+1|0,(_|0)==(A|0))break}break i}e:{if(!((r|0)<=0|(r+w|0)>(k-2|0)|((n|0)<=0|(n+_|0)>(Y-2|0)))){e=((r<<1)+s|0)+(g(n,h)<<1)|0;break e}if(!((_|0)<-2|(w|0)<-2))for(Q=-1,j=Y-1|0,G=k-1|0,e=_+2|0,O=(e|0)>0?e:0,S=r+1|0,e=w+3|0,q=e&-2,d=e&1;;){if(e=n+Q|0,E=(g((e|0)>=0?(e|0)<(Y|0)?e:j:0,h)<<1)+s|0,R=g(Q,80)+81|0,e=-1,(w|0)!=-2)for(U=R+1|0,N=0;V=e+r|0,X[m+(e+R<<1)>>1]=p[E+(((V|0)>=0?(k|0)>(V|0)?V:G:0)<<1)>>1],V=e+S|0,X[m+(e+U<<1)>>1]=p[E+(((V|0)>=0?(k|0)>(V|0)?V:G:0)<<1)>>1],e=e+2|0,N=N+2|0,(q|0)!=(N|0););if(d&&(U=m+(e+R<<1)|0,e=e+r|0,X[U>>1]=p[E+(((e|0)>=0?(e|0)<(k|0)?e:G:0)<<1)>>1]),Q=Q+1|0,(O|0)==(Q|0))break}h=80,e=m+162|0}if(!(!I|!f)){W[i[(((B|0)<9?44:124)+A|0)+172>>2]](o,l,e,h,w,_,I,f,m+10720|0,B);break i}if(I){W[i[(((B|0)<9?36:116)+A|0)+172>>2]](o,l,e,h,w,_,I,f,m+10720|0,B);break i}if(f){W[i[(((B|0)<9?40:120)+A|0)+172>>2]](o,l,e,h,w,_,0,f,m+10720|0,B);break i}U0(13347,19905,269,20649),M()}v=x}function a4(A,e,r){return i[A+64>>2]=0,i[A+68>>2]=0,t[A+60|0]=0,t[A+36|0]=0,i[A+32>>2]=0,i[A+24>>2]=1,i[A+28>>2]=1,i[A+16>>2]=0,i[A+20>>2]=0,t[A+12|0]=1,X[A+10>>1]=2,X[A+6>>1]=2,X[A+8>>1]=2,t[A+4|0]=0,i[A+156>>2]=0,t[A+112|0]=0,t[A+96|0]=0,i[A+116>>2]=0,i[A+120>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=1,i[A+124>>2]=0,i[A+128>>2]=0,i[A+132>>2]=0,i[A+136>>2]=0,i[A+140>>2]=0,i[A+144>>2]=0,X[A+146>>1]=0,X[A+148>>1]=0,X[A+150>>1]=0,X[A+152>>1]=0,i[A+164>>2]=0,i[A+168>>2]=0,i[A+160>>2]=255,i[A+172>>2]=0,i[A+176>>2]=5186,i[A>>2]=107396,i[A+180>>2]=e,t[A+312|0]=0,i[A+184>>2]=0,i[A+188>>2]=0,i[A+192>>2]=0,i[A+196>>2]=0,i[A+200>>2]=0,i[A+204>>2]=0,X[A+208>>1]=0,i[A+212>>2]=0,i[A+216>>2]=0,X[A+218>>1]=0,X[A+220>>1]=0,X[A+222>>1]=0,X[A+224>>1]=0,i[A+228>>2]=0,i[A+232>>2]=0,t[A+236|0]=0,t[A+248|0]=0,i[A+240>>2]=0,i[A+244>>2]=0,i[A+316>>2]=0,i[A+320>>2]=0,i[A+324>>2]=0,i[A+328>>2]=0,i[A+332>>2]=0,i[A+336>>2]=0,i[A+340>>2]=0,i[A+344>>2]=0,i[A+348>>2]=0,i[A+432>>2]=0,i[A+424>>2]=0,i[A+428>>2]=0,t[A+352|0]=1,t[A+361|0]=0,t[A+362|0]=0,t[A+363|0]=0,t[A+364|0]=0,t[A+365|0]=0,t[A+366|0]=0,t[A+367|0]=0,t[A+368|0]=0,i[A+356>>2]=0,i[A+360>>2]=0,t[A+416|0]=0,i[A+408>>2]=0,i[A+412>>2]=0,i[A+400>>2]=0,i[A+404>>2]=0,i[A+392>>2]=0,i[A+396>>2]=0,i[A+384>>2]=0,i[A+388>>2]=0,i[A+376>>2]=0,i[A+380>>2]=0,i[A+456>>2]=0,i[A+460>>2]=0,X[A+436>>1]=1,i[A+448>>2]=0,i[A+452>>2]=0,i[A+440>>2]=0,i[A+444>>2]=0,i[A+464>>2]=0,i[A+468>>2]=1072693248,i[A+304>>2]=0,i[A+308>>2]=0,i[A+296>>2]=0,i[A+300>>2]=0,i[A+288>>2]=0,i[A+292>>2]=0,i[A+280>>2]=0,i[A+284>>2]=0,i[A+272>>2]=0,i[A+276>>2]=0,i[A+264>>2]=0,i[A+268>>2]=0,i[A+256>>2]=0,i[A+260>>2]=0,i[A+496>>2]=0,i[A+488>>2]=0,i[A+492>>2]=0,i[A+480>>2]=0,i[A+484>>2]=0,i[A+472>>2]=0,i[A+476>>2]=0,i[A+544>>2]=0,i[A+548>>2]=0,i[A+536>>2]=0,i[A+540>>2]=0,i[A+528>>2]=0,i[A+532>>2]=0,i[A+520>>2]=0,i[A+524>>2]=0,i[A+512>>2]=0,i[A+516>>2]=0,i[A+504>>2]=0,i[A+508>>2]=0,i[A+196>>2]=r,A}function tg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;k=v-32|0,v=k;i:{if(o0[e+104>>2]>=32){if(e=C(56),i[k+20>>2]=e,i[k+24>>2]=51,i[k+28>>2]=-2147483592,r=u[27739]|u[27740]<<8|(u[27741]<<16|u[27742]<<24),f=u[27735]|u[27736]<<8|(u[27737]<<16|u[27738]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+51|0]=0,r=u[27782]|u[27783]<<8|(u[27784]<<16|u[27785]<<24),t[e+47|0]=r,t[e+48|0]=r>>>8,t[e+49|0]=r>>>16,t[e+50|0]=r>>>24,r=u[27779]|u[27780]<<8|(u[27781]<<16|u[27782]<<24),f=u[27775]|u[27776]<<8|(u[27777]<<16|u[27778]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[27771]|u[27772]<<8|(u[27773]<<16|u[27774]<<24),f=u[27767]|u[27768]<<8|(u[27769]<<16|u[27770]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[27763]|u[27764]<<8|(u[27765]<<16|u[27766]<<24),f=u[27759]|u[27760]<<8|(u[27761]<<16|u[27762]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[27755]|u[27756]<<8|(u[27757]<<16|u[27758]<<24),f=u[27751]|u[27752]<<8|(u[27753]<<16|u[27754]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[27747]|u[27748]<<8|(u[27749]<<16|u[27750]<<24),f=u[27743]|u[27744]<<8|(u[27745]<<16|u[27746]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(f=W[i[i[e>>2]+52>>2]](e,r,0)|0,h2(r,i[e+104>>2]&31),n1(k,e,r,f),t[k+19|0]<0&&Z(i[k+8>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function Qi(A,e){return i[A+64>>2]=0,i[A+68>>2]=0,t[A+60|0]=0,t[A+36|0]=0,i[A+32>>2]=0,i[A+24>>2]=1,i[A+28>>2]=1,i[A+16>>2]=0,i[A+20>>2]=0,t[A+12|0]=1,X[A+10>>1]=2,X[A+6>>1]=2,X[A+8>>1]=2,t[A+4|0]=0,i[A+156>>2]=0,t[A+112|0]=0,t[A+96|0]=0,i[A+116>>2]=0,i[A+120>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=1,i[A+124>>2]=0,i[A+128>>2]=0,i[A+132>>2]=0,i[A+136>>2]=0,i[A+140>>2]=0,i[A+144>>2]=0,X[A+146>>1]=0,X[A+148>>1]=0,X[A+150>>1]=0,X[A+152>>1]=0,i[A+164>>2]=0,i[A+168>>2]=0,i[A+160>>2]=255,i[A+172>>2]=0,i[A+176>>2]=5186,i[A>>2]=107396,i[A+180>>2]=e,t[A+312|0]=0,i[A+184>>2]=0,i[A+188>>2]=0,i[A+192>>2]=0,i[A+196>>2]=0,i[A+200>>2]=0,i[A+204>>2]=0,X[A+208>>1]=0,i[A+212>>2]=0,i[A+216>>2]=0,X[A+218>>1]=0,X[A+220>>1]=0,X[A+222>>1]=0,X[A+224>>1]=0,i[A+228>>2]=0,i[A+232>>2]=0,t[A+236|0]=0,t[A+248|0]=0,i[A+240>>2]=0,i[A+244>>2]=0,i[A+316>>2]=0,i[A+320>>2]=0,i[A+324>>2]=0,i[A+328>>2]=0,i[A+332>>2]=0,i[A+336>>2]=0,i[A+340>>2]=0,i[A+344>>2]=0,i[A+348>>2]=0,i[A+432>>2]=0,i[A+424>>2]=0,i[A+428>>2]=0,t[A+352|0]=1,t[A+361|0]=0,t[A+362|0]=0,t[A+363|0]=0,t[A+364|0]=0,t[A+365|0]=0,t[A+366|0]=0,t[A+367|0]=0,t[A+368|0]=0,i[A+356>>2]=0,i[A+360>>2]=0,t[A+416|0]=0,i[A+408>>2]=0,i[A+412>>2]=0,i[A+400>>2]=0,i[A+404>>2]=0,i[A+392>>2]=0,i[A+396>>2]=0,i[A+384>>2]=0,i[A+388>>2]=0,i[A+376>>2]=0,i[A+380>>2]=0,i[A+456>>2]=0,i[A+460>>2]=0,X[A+436>>1]=1,i[A+448>>2]=0,i[A+452>>2]=0,i[A+440>>2]=0,i[A+444>>2]=0,i[A+464>>2]=0,i[A+468>>2]=1072693248,i[A+304>>2]=0,i[A+308>>2]=0,i[A+296>>2]=0,i[A+300>>2]=0,i[A+288>>2]=0,i[A+292>>2]=0,i[A+280>>2]=0,i[A+284>>2]=0,i[A+272>>2]=0,i[A+276>>2]=0,i[A+264>>2]=0,i[A+268>>2]=0,i[A+256>>2]=0,i[A+260>>2]=0,i[A+496>>2]=0,i[A+488>>2]=0,i[A+492>>2]=0,i[A+480>>2]=0,i[A+484>>2]=0,i[A+472>>2]=0,i[A+476>>2]=0,i[A+544>>2]=0,i[A+548>>2]=0,i[A+536>>2]=0,i[A+540>>2]=0,i[A+528>>2]=0,i[A+532>>2]=0,i[A+520>>2]=0,i[A+524>>2]=0,i[A+512>>2]=0,i[A+516>>2]=0,i[A+504>>2]=0,i[A+508>>2]=0,A}function og(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0;l=v-32|0,v=l;i:{if(!(f&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}n=i[e>>2],o=i[n+48>>2],s=i[n+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);e:{if(!P3(o,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3832;break e}$1(l+24|0,i[e>>2],r,0),o=i[l+24>>2];r:{if(!o||(n=i[o+184>>2],o=i[o+188>>2],(n|0)==(o|0)))break r;for(;;){f:{if(h=i[n>>2],!h||!Z0(h,92792,92836))break f;e=i[n+4>>2];A:{if(!e){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=1404;break A}if(i[e+4>>2]=i[e+4>>2]+1,i[A+8>>2]=1404,i[A>>2]=5,i[A+4>>2]=2006,A=i[e+4>>2],i[e+4>>2]=A-1,A)break A;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=i[l+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}if(n=n+8|0,(o|0)==(n|0))break}}n=i[l+28>>2];r:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break r;W[i[i[n>>2]+8>>2]](n),y(n)}if(n=C(152),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=98468,o=n+16|0,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=92500,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,X[n+112>>1]=0,i[o>>2]=95600,t[n+144|0]=0,i[n+136>>2]=0,i[n+140>>2]=2147483647,i[n+128>>2]=-1,i[n+132>>2]=-1,t[n+120|0]=1,i[n+32>>2]=1952541027,u[f|0]&&(h=i[f+12>>2],i[n+128>>2]=i[f+8>>2],i[n+132>>2]=h,i[n+136>>2]=i[f+16>>2],i[n+140>>2]=i[f+20>>2],t[n+144|0]=u[f+24|0]),e=i[e>>2],i[l+20>>2]=n,i[l+16>>2]=o,i[n+4>>2]=i[n+4>>2]+1,f=i[l+20>>2],i[l+8>>2]=i[l+16>>2],i[l+12>>2]=f,e=Ei(e,r,l+8|0,0),k&&(i[k>>2]=e),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[n+4>>2],i[n+4>>2]=A-1,A)break e;W[i[i[n>>2]+8>>2]](n),y(n)}if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=l+32|0}function lg(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0;h=v+-64|0,v=h,w=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[h+60>>2]=r,i[h+56>>2]=w;i:{e:{r:{if(!u[e+4|0]){if(W[i[i[f>>2]+120>>2]](h+24|0,i[f+4>>2],h+56|0,n,o,l,k),r=i[h+24>>2],r){if(k=i[h+28>>2],n=i[h+32>>2],e=l2(n),e>>>0>=2147483640)break e;f:{A:{if(e>>>0>=11){o=e|7,f=C(o+1|0),i[h+52>>2]=o-2147483647,i[h+44>>2]=f,i[h+48>>2]=e;break A}if(t[h+55|0]=e,f=h+44|0,!e)break f}if(!e)break f;z(f,n,e)}if(t[e+f|0]=0,a(A,r,k,h+44|0),t[h+55|0]>=0)break r;Z(i[h+44>>2]);break r}r=C(160),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96588,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[r+16>>2]=104068,i[r+156>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,t[r+145|0]=4,i[r+124>>2]=0,i[r+128>>2]=0,i[r+32>>2]=1752589123,i[e+12>>2]=k,k=i[e+16>>2],i[e+16>>2]=r;f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;W[i[i[k>>2]+8>>2]](k),y(k)}t[e+4|0]=1}if(mA(h+24|0,e,f),i[h+24>>2]){e=i[h+28>>2],i[A>>2]=i[h+24>>2],i[A+4>>2]=e,e=i[h+36>>2],i[A+8>>2]=i[h+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[h+40>>2];break r}W[i[i[f>>2]+124>>2]](h+44|0,i[f+4>>2],h+56|0,s),r=i[h+44>>2];f:{if(r){if(k=i[h+48>>2],n=i[h+52>>2],e=l2(n),e>>>0>=2147483640)break i;A:{k:{if(e>>>0>=11){o=e|7,f=C(o+1|0),i[h+20>>2]=o-2147483647,i[h+12>>2]=f,i[h+16>>2]=e;break k}if(t[h+23|0]=e,f=h+12|0,!e)break A}if(!e)break A;z(f,n,e)}if(t[e+f|0]=0,a(A,r,k,h+12|0),t[h+23|0]>=0)break f;Z(i[h+12>>2]);break f}mA(A,e,f)}if(t[h+43|0]>=0)break r;Z(i[h+32>>2])}A=i[h+60>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=h- -64|0;return}I0(),M()}I0(),M()}function ug(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0;l=v-32|0,v=l;i:{if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}n=i[e>>2],o=i[n+48>>2],s=i[n+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);e:{if(!P3(o,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3737;break e}$1(l+24|0,i[e>>2],r,0),o=i[l+24>>2];r:{if(!o||(n=i[o+184>>2],o=i[o+188>>2],(n|0)==(o|0)))break r;for(;;){f:{if(h=i[n>>2],!h||!Z0(h,92792,92848))break f;e=i[n+4>>2];A:{if(!e){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=1307;break A}if(i[e+4>>2]=i[e+4>>2]+1,i[A+8>>2]=1307,i[A>>2]=5,i[A+4>>2]=2006,A=i[e+4>>2],i[e+4>>2]=A-1,A)break A;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=i[l+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}if(n=n+8|0,(o|0)==(n|0))break}}n=i[l+28>>2];r:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break r;W[i[i[n>>2]+8>>2]](n),y(n)}if(n=C(144),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=98428,o=n+16|0,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=92500,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,X[n+112>>1]=0,i[o>>2]=95668,i[n+128>>2]=0,i[n+132>>2]=0,t[n+120|0]=1,i[n+32>>2]=1769234793,t[n+135|0]=0,t[n+136|0]=0,t[n+137|0]=0,t[n+138|0]=0,u[f|0]&&(h=i[f+12>>2],i[n+128>>2]=i[f+8>>2],i[n+132>>2]=h,t[n+136|0]=u[f+16|0],t[n+138|0]=u[f+18|0],t[n+137|0]=u[f+17|0]),e=i[e>>2],i[l+20>>2]=n,i[l+16>>2]=o,i[n+4>>2]=i[n+4>>2]+1,f=i[l+20>>2],i[l+8>>2]=i[l+16>>2],i[l+12>>2]=f,e=Ei(e,r,l+8|0,0),k&&(i[k>>2]=e),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[n+4>>2],i[n+4>>2]=A-1,A)break e;W[i[i[n>>2]+8>>2]](n),y(n)}if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=l+32|0}function jn(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if(h=i[A+176>>2],_=i[A+180>>2],(h|0)!=(_|0))for(;;){i:{if(A=i[h+4>>2],B=i[h+8>>2],(A|0)==(B|0))break i;for(;;){e:{s=i[A>>2],l=i[A+4>>2],o=i[e+4>>2],r=i[e+8>>2];r:{if(o>>>0<r>>>0){t[o|0]=0,r=o+1|0;break r}if(k=i[e>>2],o=o-k|0,f=o+1|0,(f|0)<0)break e;if(r=r-k|0,n=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r?f=C(r):f=0,n=f+o|0,t[n|0]=0,o&&z(f,k,o),i[e+8>>2]=r+f,r=n+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,n=i[e+8>>2];r:{if(n>>>0>r>>>0){t[r|0]=0,r=r+1|0;break r}if(k=i[e>>2],o=r-k|0,f=o+1|0,(f|0)<0)break e;if(r=n-k|0,n=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r?f=C(r):f=0,n=f+o|0,t[n|0]=0,o&&z(f,k,o),i[e+8>>2]=r+f,r=n+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,s=l-s|0,l=s>>>8|0,n=i[e+8>>2];r:{if(n>>>0>r>>>0){t[r|0]=l,r=r+1|0;break r}if(k=i[e>>2],o=r-k|0,f=o+1|0,(f|0)<0)break e;if(r=n-k|0,n=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r?f=C(r):f=0,n=f+o|0,t[n|0]=l,o&&z(f,k,o),i[e+8>>2]=r+f,r=n+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,l=i[e+8>>2];r:{if(l>>>0>r>>>0){t[r|0]=s,r=r+1|0;break r}if(k=i[e>>2],o=r-k|0,f=o+1|0,(f|0)<0)break e;if(r=l-k|0,l=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<l>>>0?l:f,r?f=C(r):f=0,l=f+o|0,t[l|0]=s,o&&z(f,k,o),i[e+8>>2]=r+f,r=l+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,o=i[A+4>>2],l=i[A>>2],k=o-l|0;r:{if((k|0)<=0)break r;if(n=i[e+8>>2],(k|0)<=(n-r|0)){!k|(o|0)==(l|0)||z(r,l,k),i[e+4>>2]=r+k;break r}if(s=i[e>>2],o=r-s|0,f=o+k|0,(f|0)<0)break e;if(n=n-s|0,w=n<<1,n=n>>>0>=1073741823?2147483647:f>>>0<w>>>0?w:f,n?f=C(n):f=0,w=f+o|0,k&&z(w,l,k),i[e+4>>2]=r,o&&z(f,s,o),i[e+8>>2]=f+n,i[e+4>>2]=k+w,i[e>>2]=f,!s)break r;Z(s)}if(A=A+12|0,(B|0)!=(A|0))continue;break i}break}s0(),M()}if(h=h+16|0,(_|0)==(h|0))break}return 1}function f3(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;if(!A)return E2(e);if(e>>>0>=4294967232)return i[33136]=48,0;o=e>>>0<11?16:e+11&-8,s=A-8|0,h=i[s+4>>2],k=h&-8;i:{if(!(h&3)){if(o>>>0<256||k>>>0>=o+4>>>0&&(r=s,k-o>>>0<=i[33570]<<1>>>0))break i;r=0;break i}l=k+s|0;e:{if(k>>>0>=o>>>0){if(f=k-o|0,f>>>0<16)break e;i[s+4>>2]=h&1|o|2,r=o+s|0,i[r+4>>2]=f|3,i[l+4>>2]=i[l+4>>2]|1,qr(r,f);break e}if(i[33456]==(l|0)){if(k=k+i[33453]|0,k>>>0<=o>>>0)break i;i[s+4>>2]=h&1|o|2,f=o+s|0,r=k-o|0,i[f+4>>2]=r|1,i[33453]=r,i[33456]=f;break e}if(i[33455]==(l|0)){if(k=k+i[33452]|0,k>>>0<o>>>0)break i;r=k-o|0;r:{if(r>>>0>=16){i[s+4>>2]=h&1|o|2,f=o+s|0,i[f+4>>2]=r|1,k=k+s|0,i[k>>2]=r,i[k+4>>2]=i[k+4>>2]&-2;break r}i[s+4>>2]=k|h&1|2,r=k+s|0,i[r+4>>2]=i[r+4>>2]|1,r=0}i[33455]=f,i[33452]=r;break e}if(f=i[l+4>>2],f&2||(w=k+(f&-8)|0,w>>>0<o>>>0))break i;B=w-o|0,n=i[l+12>>2];r:{if(f>>>0<=255){if(r=i[l+8>>2],(r|0)==(n|0)){m=133800,G=i[33450]&t2(-2,f>>>3|0),i[m>>2]=G;break r}i[r+12>>2]=n,i[n+8>>2]=r;break r}_=i[l+24>>2];f:{if((n|0)!=(l|0)){r=i[l+8>>2],i[r+12>>2]=n,i[n+8>>2]=r;break f}A:{if(r=i[l+20>>2],r)f=l+20|0;else{if(r=i[l+16>>2],!r)break A;f=l+16|0}for(;k=f,n=r,f=r+20|0,r=i[r+20>>2],!(!r&&(f=n+16|0,r=i[n+16>>2],!r)););i[k>>2]=0;break f}n=0}if(!_)break r;f=i[l+28>>2],r=(f<<2)+134104|0;f:{if(i[r>>2]==(l|0)){if(i[r>>2]=n,n)break f;m=133804,G=i[33451]&t2(-2,f),i[m>>2]=G;break r}A:{if(i[_+16>>2]==(l|0)){i[_+16>>2]=n;break A}i[_+20>>2]=n}if(!n)break r}if(i[n+24>>2]=_,r=i[l+16>>2],r&&(i[n+16>>2]=r,i[r+24>>2]=n),r=i[l+20>>2],!r)break r;i[n+20>>2]=r,i[r+24>>2]=n}if(B>>>0<=15){i[s+4>>2]=h&1|w|2,r=s+w|0,i[r+4>>2]=i[r+4>>2]|1;break e}i[s+4>>2]=h&1|o|2,f=o+s|0,i[f+4>>2]=B|3,r=s+w|0,i[r+4>>2]=i[r+4>>2]|1,qr(f,B)}r=s}return r?r+8|0:(f=E2(e),f?(r=i[A-4>>2],r=(r&3?-4:-8)+(r&-8)|0,v8(f,A,e>>>0>r>>>0?r:e),Z(A),f):0)}function Sn(A,e,r,f){var k=0,n=0,o=0,l=0,s=0;k=i[e>>2];i:{e:{r:{f:{A:{k:{n:{t:{o:{l:{u:{s:{if(!f||(o=i[f>>2],!o))break s;if(!A){f=r;break l}i[f>>2]=0,f=r;break u}s:{if(!i[i[33178]>>2]){if(!A)break s;if(!r)break i;for(o=r;;){if(f=t[k|0],f){if(i[A>>2]=f&57343,A=A+4|0,k=k+1|0,o=o-1|0,o)continue;break i}break}return i[A>>2]=0,i[e>>2]=0,r-o|0}if(f=r,!A)break o;break n}return l2(k)}n=1;break n}n=0;break t}n=1}for(;;){if(!n){if(n=u[k|0]>>>3|0,(n-16|n+(o>>26))>>>0>7)break k;n=k+1|0;t:{if(!(o&33554432))break t;if(t[n|0]>=-64){k=k-1|0;break f}if(n=k+2|0,!(o&524288))break t;if(t[n|0]>=-64){k=k-1|0;break f}n=k+3|0}k=n,f=f-1|0,n=1;continue}for(;;){o=t[k|0];t:{if(k&3|(o|0)<=0||(o=i[k>>2],(o|o-16843009)&-2139062144))break t;for(;f=f-4|0,o=i[k+4>>2],k=k+4|0,!((o-16843009|o)&-2139062144););}if(o<<24>>24>0){f=f-1|0,k=k+1|0;continue}break}if(n=(o&255)-194|0,n>>>0>50)break A;k=k+1|0,o=i[(n<<2)+79328>>2],n=0}}for(;;){if(!n){if(!f)break i;for(;;){n:{if(n=u[k|0],o=n<<24>>24,(o|0)<=0)break n;if(!(k&3|f>>>0<5)){t:{for(;;){if(o=i[k>>2],(o|o-16843009)&-2139062144)break t;if(i[A>>2]=o&255,i[A+4>>2]=u[k+1|0],i[A+8>>2]=u[k+2|0],i[A+12>>2]=u[k+3|0],A=A+16|0,k=k+4|0,f=f-4|0,!(f>>>0>4))break}o=u[k|0]}if(n=o&255,o<<24>>24<=0)break n}if(i[A>>2]=n,A=A+4|0,k=k+1|0,f=f-1|0,f)continue;break i}break}if(n=n-194|0,n>>>0>50)break A;k=k+1|0,o=i[(n<<2)+79328>>2],n=1;continue}if(n=u[k|0],l=n>>>3|0,(l-16|l+(o>>26))>>>0>7)break k;n:{t:{l=k+1|0,n=n-128|o<<6;o:{if((n|0)>=0)break o;if(l=u[l|0]-128|0,l>>>0>63)break t;if(s=n<<6,n=l|s,l=k+2|0,(s|0)>=0)break o;if(l=u[l|0]-128|0,l>>>0>63)break t;n=l|n<<6,l=k+3|0}k=l,i[A>>2]=n,f=f-1|0,A=A+4|0;break n}i[33136]=25,k=k-1|0;break r}n=0}}if(k=k-1|0,o)break f;o=u[k|0]}if(o&255)break f;return A&&(i[A>>2]=0,i[e>>2]=0),r-f|0}if(i[33136]=25,!A)break e}i[e>>2]=k}return-1}return i[e>>2]=k,r}function On(A,e,r,f,k,n,o,l,s,h,w,_,B,m,G){var I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0;for(R=v-16|0,v=R,i[r>>2]=A,U=l?4:0,x=f&512;;){if((N|0)==4)u[m+11|0]>>>7|0?k=i[m+4>>2]:k=u[m+11|0]&127,k>>>0>1&&(O=R,S=e8(m),i[O+12>>2]=S,O=r,S=Ko(e7(R+12|0,1),y6(m),i[r>>2]),i[O>>2]=S),f=f&176,(f|0)!=16&&((f|0)==32&&(A=i[r>>2]),i[e>>2]=A),v=R+16|0;else{i:{e:switch(u[s+N|0]){case 0:i[e>>2]=i[r>>2];break i;case 1:i[e>>2]=i[r>>2],Q=W[i[i[o>>2]+44>>2]](o,32)|0,l=i[r>>2],i[r>>2]=l+4,i[l>>2]=Q;break i;case 3:if(u[m+11|0]>>>7|0?l=i[m+4>>2]:l=u[m+11|0]&127,!l)break i;u[m+11|0]>>>7|0?l=i[m>>2]:l=m,Q=i[l>>2],l=i[r>>2],i[r>>2]=l+4,i[l>>2]=Q;break i;case 2:if(u[B+11|0]>>>7|0?l=i[B+4>>2]:l=u[B+11|0]&127,l=!l,l|!x)break i;O=r,S=Ko(e8(B),y6(B),i[r>>2]),i[O>>2]=S;break i;case 4:break e;default:break i}for(j=i[r>>2],k=k+U|0,l=k;;){e:{if(n>>>0<=l>>>0||!(W[i[i[o>>2]+12>>2]](o,64,i[l>>2])|0))break e;l=l+4|0;continue}break}if((G|0)>0){for(Q=i[r>>2],V=G;;){if(!(!V|k>>>0>=l>>>0)){V=V-1|0,l=l-4|0,Y=i[l>>2],I=Q+4|0,i[r>>2]=I,i[Q>>2]=Y,Q=I;continue}break}for(V?I=W[i[i[o>>2]+44>>2]](o,48)|0:I=0,Y=I,Q=i[r>>2];;){if((V|0)>0){I=Q+4|0,i[r>>2]=I,i[Q>>2]=Y,V=V-1|0,Q=I;continue}break}Q=i[r>>2],i[r>>2]=Q+4,i[Q>>2]=h}e:{if((k|0)==(l|0)){Q=W[i[i[o>>2]+44>>2]](o,48)|0,l=i[r>>2],i[r>>2]=l+4,i[l>>2]=Q;break e}for(u[_+11|0]>>>7|0?I=i[_>>2]:I=_,I=t[I|0],u[_+11|0]>>>7|0?Q=i[_+4>>2]:Q=u[_+11|0]&127,I=Q?I:-1,V=0,E=0;;){if((k|0)==(l|0))break e;r:{if((V|0)!=(I|0)){Q=V;break r}if(Q=i[r>>2],i[r>>2]=Q+4,i[Q>>2]=w,Q=0,u[_+11|0]>>>7|0?I=i[_+4>>2]:I=u[_+11|0]&127,E=E+1|0,I>>>0<=E>>>0){I=V;break r}if(u[_+11|0]>>>7|0?I=i[_>>2]:I=_,u[I+E|0]==127){I=-1;break r}u[_+11|0]>>>7|0?I=i[_>>2]:I=_,I=t[I+E|0]}l=l-4|0,Y=i[l>>2],V=i[r>>2],i[r>>2]=V+4,i[V>>2]=Y,V=Q+1|0}}T3(j,i[r>>2])}N=N+1|0;continue}break}}function Pn(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;o=v-160|0,v=o,i[o+100>>2]=0,i[o+72>>2]=78164,i[o+16>>2]=78144,n=i[19545],i[o+8>>2]=n,B=i[n-12>>2],l=o+8|0,n=l,i[B+n>>2]=i[19546],i[o+12>>2]=0,n=n+i[i[o+8>>2]-12>>2]|0,w=o+20|0,J0(n,w),t[n+80|0]=0,i[n+72>>2]=0,n=i[19547],i[o+16>>2]=n,s=o+16|0,i[s+i[n-12>>2]>>2]=i[19548],n=i[19544],i[o+8>>2]=n,i[l+i[n-12>>2]>>2]=i[19549],i[o+72>>2]=78164,i[o+8>>2]=78124,i[o+16>>2]=78144,w=R0(w),i[w>>2]=77200,i[o+60>>2]=0,i[o+64>>2]=0,i[o+52>>2]=0,i[o+56>>2]=0,i[o+68>>2]=24,n=i[o+16>>2]-12|0,l=s+i[n>>2]|0,i[l+4>>2]=i[l+4>>2]&-75|8,l=s+i[n>>2]|0,u[l+80|0]||(h=o+156|0,n=i[l+28>>2],i[h>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=$0(h,137008),W[i[i[n>>2]+28>>2]](n,32)|0,i2(h)),t[l+76|0]=48,t[l+77|0]=0,t[l+78|0]=0,t[l+79|0]=0,n=1,t[l+80|0]=1,l=o+28|0;i:{if(!r)break i;if(h=t[f+11|0],_=(h|0)<0,F(s,_?i[f>>2]:f,_?i[f+4>>2]:h),i[i[i[o+16>>2]-12>>2]+l>>2]=4,F(B0(s,0),37807,2),i[i[i[o+16>>2]-12>>2]+l>>2]=2,D0(s,u[e|0]),f=r-1|0,!f){F(s,47878,1);break i}for(;;){e:{r:{f:{A:switch(h=n&15,h|0){case 0:break A;case 8:break f;default:break r}_=t[k+11|0],B=(_|0)<0,F(s,B?i[k>>2]:k,B?i[k+4>>2]:_),i[i[i[o+16>>2]-12>>2]+l>>2]=4,F(B0(s,n),37807,2);break e}F(s,37885,2);break e}F(s,37886,1)}if(i[i[i[o+16>>2]-12>>2]+l>>2]=2,D0(s,u[e+n|0]),(f|0)!=(n|0)&(h|0)!=15||F(s,47878,1),n=n+1|0,(n|0)==(r|0))break}}e=i[o+68>>2];i:{e:{if(e&16){l=o+40|0,r=i[o+64>>2],e=i[o+44>>2],r>>>0<e>>>0?i[o+64>>2]=e:e=r;break e}if(!(e&8)){n=0,t[A+11|0]=0;break i}e=i[o+36>>2]}e:{if(r=i[l>>2],n=e-r|0,n>>>0<2147483640){if(n>>>0>=11){f=n|7,e=C(f+1|0),i[A+8>>2]=f-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(t[A+11|0]=n,n)break e;n=0;break i}I0(),M()}if(!n)break i;z(A,r,n)}t[A+n|0]=0,A=i[19543],i[o+8>>2]=A,i[i[A-12>>2]+(o+8|0)>>2]=i[19551],i[o+16>>2]=i[19552],i[w>>2]=77200,t[o+63|0]<0&&Z(i[o+52>>2]),y0(w),Y0(o+72|0),v=o+160|0}function Ln(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;k=v-32|0,v=k,f=C(48),i[k+24>>2]=i[A>>2],A=i[A+4>>2],i[k+28>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),i[k+16>>2]=i[e>>2],A=i[e+4>>2],i[k+20>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=i[k+28>>2],i[k+8>>2]=i[k+24>>2],i[k+12>>2]=A,A=i[k+20>>2],i[k>>2]=i[k+16>>2],i[k+4>>2]=A,i[f>>2]=0,i[f+4>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,t[f+16|0]=0,i[f+8>>2]=0,i[f+12>>2]=0,w=f+32|0,A=w,i[A>>2]=0,i[A+4>>2]=0,i[f+40>>2]=0,A=i[k+8>>2],e=i[k+12>>2];i:{if(!e){i[f+4>>2]=e,i[f>>2]=A;break i}if(i[e+4>>2]=i[e+4>>2]+1,i[f>>2]=A,A=i[f+4>>2],i[f+4>>2]=e,!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[k>>2],e=i[k+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[f+8>>2]=A,A=i[f+12>>2],i[f+12>>2]=e;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}h=i[k>>2],n=i[h+128>>2],o=i[h+132>>2],A=i[h+128>>2],o-A>>3?(e=i[A>>2],A=i[A+4>>2]):(e=0,A=0),_=i[k+8>>2],s=i[_+116>>2],o=o-n|0;i:{e:{if((o|0)==8){if(n=u[i[f>>2]+112|0],t[f+16|0]=(n|0)!=0,!n)break e;i[f+24>>2]=e,i[f+28>>2]=A;break i}t[f+16|0]=0}l=i[f+32>>2],n=i[f+36>>2]-l>>3;e:{if(n>>>0<s>>>0){fi(w,s-n|0);break e}if(n>>>0>s>>>0&&(i[f+36>>2]=l+(s<<3)),!s)break i}if(n=0,(o|0)==8){for(;;)if(r=i[w>>2]+(n<<3)|0,i[r>>2]=e,i[r+4>>2]=A,r=c3(_,n),e=e+r|0,A=r>>>0>e>>>0?A+1|0:A,n=n+1|0,(s|0)==(n|0))break i}for(o=0;;){if(l=i[r>>2],o0[i[l+(o<<3)>>2]+20>>2]<n>>>0){if(o=o+1|0,o>>>0>=i[r+4>>2]-l>>3>>>0)break i;A=i[h+128>>2],i[h+132>>2]-A>>3>>>0>o>>>0?(A=A+(o<<3)|0,e=i[A>>2],A=i[A+4>>2]):(e=0,A=0)}if(l=i[w>>2]+(n<<3)|0,i[l>>2]=e,i[l+4>>2]=A,l=c3(_,n),e=e+l|0,A=l>>>0>e>>>0?A+1|0:A,n=n+1|0,(s|0)==(n|0))break}}A=i[k+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[k+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=k+32|0,f}function sg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;n=v-32|0,v=n;i:{if(!r){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(i[r>>2]=0,f=i[e>>2],o=t[f+327|0],k=(o|0)<0,o=E2((k?i[f+320>>2]:o)+1|0),!o){if(r=C(48),i[n>>2]=r,i[n+4>>2]=45,i[n+8>>2]=-2147483600,f=u[12198]|u[12199]<<8|(u[12200]<<16|u[12201]<<24),k=u[12194]|u[12195]<<8|(u[12196]<<16|u[12197]<<24),t[r+37|0]=k,t[r+38|0]=k>>>8,t[r+39|0]=k>>>16,t[r+40|0]=k>>>24,t[r+41|0]=f,t[r+42|0]=f>>>8,t[r+43|0]=f>>>16,t[r+44|0]=f>>>24,f=u[12193]|u[12194]<<8|(u[12195]<<16|u[12196]<<24),k=u[12189]|u[12190]<<8|(u[12191]<<16|u[12192]<<24),t[r+32|0]=k,t[r+33|0]=k>>>8,t[r+34|0]=k>>>16,t[r+35|0]=k>>>24,t[r+36|0]=f,t[r+37|0]=f>>>8,t[r+38|0]=f>>>16,t[r+39|0]=f>>>24,f=u[12185]|u[12186]<<8|(u[12187]<<16|u[12188]<<24),k=u[12181]|u[12182]<<8|(u[12183]<<16|u[12184]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[12177]|u[12178]<<8|(u[12179]<<16|u[12180]<<24),k=u[12173]|u[12174]<<8|(u[12175]<<16|u[12176]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[12169]|u[12170]<<8|(u[12171]<<16|u[12172]<<24),k=u[12165]|u[12166]<<8|(u[12167]<<16|u[12168]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,f=u[12161]|u[12162]<<8|(u[12163]<<16|u[12164]<<24),k=u[12157]|u[12158]<<8|(u[12159]<<16|u[12160]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+45|0]=0,r=A,A=a(n+12|0,6,0,n),e=i[e>>2],c0(r,A,e?e+164|0:0),t[A+19|0]<0&&Z(i[A+8>>2]),t[n+11|0]>=0)break i;Z(i[n>>2]);break i}l=r,s=u8(o,k?i[f+316>>2]:f+316|0),i[l>>2]=s,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}v=n+32|0}function qn(A,e,r,f,k,n,o,l,s,h,w,_,B){var m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0;m=v,j=m,m=m-14464&-32,v=m,I=i[e+16852>>2],Q=g(2/(I|0)|0,r),r=((k|0)/(I|0)|0)+(Q>>3)|0,k=f,f=i[e+16856>>2],G=g(k,2/(f|0)|0),n=((n|0)/(f|0)|0)+(G>>3)|0,Y=i[e+488>>2]/(f|0)|0,k=i[e+484>>2]/(I|0)|0;i:{if(I=Q&7,f=G&7,!(I|f)){if(e=i[e+16840>>2],!((r|0)<0|(k|0)<(r+w|0)|((n|0)<0|(Y|0)<(n+_|0)))){if(e=(r+s|0)+g(n,h)|0,(B|0)<=8){W[i[A+204>>2]](o,l,e,h,w,_,0,0,0);break i}W[i[A+284>>2]](o,l,e,h,w,_,0,0,0,B);break i}if((_|0)<=0|(w|0)<=0)break i;for(B=14-e|0,E=Y-1|0,m=k-1|0,R=w&2147483646,N=w&1,A=0;;){if(e=A+n|0,I=g((e|0)>=0?(e|0)<(Y|0)?e:E:0,h)+s|0,Q=(g(A,l)<<1)+o|0,e=0,f=0,(w|0)!=1)for(;G=e+r|0,X[Q+(e<<1)>>1]=u[I+((G|0)>=0?(k|0)>(G|0)?G:m:0)|0]<<B,V=e|1,G=V+r|0,X[Q+(V<<1)>>1]=u[I+((G|0)>=0?(k|0)>(G|0)?G:m:0)|0]<<B,e=e+2|0,f=f+2|0,(R|0)!=(f|0););if(N&&(f=Q+(e<<1)|0,e=e+r|0,X[f>>1]=u[I+((e|0)>=0?(e|0)<(k|0)?e:m:0)|0]<<B),A=A+1|0,(_|0)==(A|0))break}break i}e:{if(!((r|0)<=0|(r+w|0)>(k-2|0)|((n|0)<=0|(n+_|0)>(Y-2|0)))){e=(r+s|0)+g(n,h)|0;break e}if(!((_|0)<-2|(w|0)<-2))for(Q=-1,O=Y-1|0,G=k-1|0,e=_+2|0,S=(e|0)>0?e:0,q=r+1|0,e=w+3|0,d=e&-2,c=e&1;;){if(e=n+Q|0,E=g((e|0)>=0?(e|0)<(Y|0)?e:O:0,h)+s|0,R=g(Q,80)+81|0,e=-1,(w|0)!=-2)for(U=R+1|0,N=0;x=m+16|0,V=e+r|0,t[x+(e+R|0)|0]=u[E+((V|0)>=0?(k|0)>(V|0)?V:G:0)|0],V=e+q|0,t[(e+U|0)+x|0]=u[E+((V|0)>=0?(k|0)>(V|0)?V:G:0)|0],e=e+2|0,N=N+2|0,(d|0)!=(N|0););if(c&&(U=m+16+(e+R)|0,e=e+r|0,t[U|0]=u[E+((e|0)>=0?(e|0)<(k|0)?e:G:0)|0]),Q=Q+1|0,(S|0)==(Q|0))break}h=80,e=m+97|0}if(!(!I|!f)){W[i[(((B|0)<9?44:124)+A|0)+172>>2]](o,l,e,h,w,_,I,f,m+5376|0,B);break i}if(I){W[i[(((B|0)<9?36:116)+A|0)+172>>2]](o,l,e,h,w,_,I,f,m+5376|0,B);break i}if(f){W[i[(((B|0)<9?40:120)+A|0)+172>>2]](o,l,e,h,w,_,0,f,m+5376|0,B);break i}U0(13347,19905,269,20649),M()}v=j}function hg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(t4(F(t4(F(k,33297,17),u0[e+112>>3]),37811,2),u0[e+120>>3]),47878,1);i:{if(u[e+128|0]==1){n=f+148|0,k0(n,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(t4(F(t4(F(k,35098,14),u0[e+104>>3]),37811,2),u0[e+136>>3]),47878,1),n=f+148|0,k0(n,r),o=k,r=t[f+159|0],k=(r|0)<0,F(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(t4(F(f+8|0,33228,6),u0[e+144>>3]),47878,1);break i}k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(t4(F(k,35098,14),u0[e+104>>3]),47878,1),e=f+148|0,k0(e,r),n=e,e=t[f+159|0],r=(e|0)<0,F(k,r?i[f+148>>2]:n,r?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,37888,8)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function wg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;k=v+-64|0,v=k,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+40>>2]-i[e+36>>2]>>3;i:{if(f>>>0>=65536){if(e=C(32),i[k+52>>2]=e,i[k+56>>2]=29,i[k+60>>2]=-2147483616,r=u[25945]|u[25946]<<8|(u[25947]<<16|u[25948]<<24),f=u[25941]|u[25942]<<8|(u[25943]<<16|u[25944]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+29|0]=0,r=u[25966]|u[25967]<<8|(u[25968]<<16|u[25969]<<24),f=u[25962]|u[25963]<<8|(u[25964]<<16|u[25965]<<24),t[e+21|0]=f,t[e+22|0]=f>>>8,t[e+23|0]=f>>>16,t[e+24|0]=f>>>24,t[e+25|0]=r,t[e+26|0]=r>>>8,t[e+27|0]=r>>>16,t[e+28|0]=r>>>24,r=u[25961]|u[25962]<<8|(u[25963]<<16|u[25964]<<24),f=u[25957]|u[25958]<<8|(u[25959]<<16|u[25960]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[25953]|u[25954]<<8|(u[25955]<<16|u[25956]<<24),f=u[25949]|u[25950]<<8|(u[25951]<<16|u[25952]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,5,0,k+52|0),t[k+63|0]>=0)break i;Z(i[k+52>>2]);break i}p0(r,f),f=i[e+36>>2],n=i[e+40>>2];e:{if((f|0)!=(n|0))for(;;){if(l=i[f>>2],W[i[i[l>>2]+20>>2]](k+32|0,l,r),i[k+32>>2])break e;if(t[k+51|0]<0&&Z(i[k+40>>2]),f=f+8|0,(n|0)==(f|0))break}if(f=i[28729],i[k+32>>2]=i[28728],i[k+36>>2]=f,f=k+40|0,t[114931]>=0){n=i[28731],i[f>>2]=i[28730],i[f+4>>2]=n,i[f+8>>2]=i[28732];break e}T(f,i[28730],i[28731])}if(t[k+51|0]<0&&Z(i[k+40>>2]),i[r+12>>2]=o,W[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+o|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k- -64|0}function _g(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],h=k+i[i[f+8>>2]-12>>2]|0,o=f+12|0,J0(h,o),t[h+80|0]=0,i[h+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,h=R0(o),i[h>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,o=f+148|0,J2(o,e,r),n=k,l=o,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),n=k,k=t[f+159|0],o=(k|0)<0,F(f+8|0,o?i[f+148>>2]:n,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,s=F(k,35250,6),o=e+104|0,n=t[e+115|0],l=(n|0)<0,F(F(s,l?i[e+104>>2]:o,l?i[e+108>>2]:n),47878,1),n=f+148|0,k0(n,r),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,s=F(k,36699,6),n=t[e+127|0],l=(n|0)<0,F(F(s,l?i[e+116>>2]:e+116|0,l?i[e+120>>2]:n),47878,1),n=f+148|0,k0(n,r),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,s=F(k,34425,13),n=t[e+139|0],l=(n|0)<0,F(F(s,l?i[e+128>>2]:e+128|0,l?i[e+132>>2]:n),47878,1),n=f+148|0,k0(n,r),l=k,r=t[f+159|0],k=(r|0)<0,F(l,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(f+8|0,33803,6),r=t[e+115|0],k=(r|0)<0,F(F(n,k?i[e+104>>2]:o,k?i[e+108>>2]:r),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){o=e|7,r=C(o+1|0),i[A+8>>2]=o-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[h>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(h),Y0(f- -64|0),v=f+160|0}function Bg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(k,37719,25),F(B0(F(B0(F(k,30582,1),p[e+100>>1]),22872,1),p[e+106>>1]),37810,3),F(B0(F(B0(F(k,30582,1),p[e+102>>1]),22872,1),p[e+108>>1]),37810,3),F(B0(F(B0(F(k,30582,1),p[e+104>>1]),22872,1),p[e+110>>1]),47877,2),n=f+148|0,k0(n,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(B0(F(k,30554,20),p[e+112>>1]),22872,1),p[e+114>>1]),47877,2),n=f+148|0,k0(n,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,36834,33),i[e+116>>2]),47878,1),n=f+148|0,k0(n,r),o=k,r=t[f+159|0],k=(r|0)<0,F(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36878,33),i[e+120>>2]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function A3(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;k=v-160|0,v=k,i[k+92>>2]=0,i[k+64>>2]=78468,o=i[19620],i[k+8>>2]=o,n=i[o-12>>2],o=k+8|0,i[n+o>>2]=i[19621],o=o+i[i[k+8>>2]-12>>2]|0,h=k+12|0,J0(o,h),t[o+80|0]=0,i[o+72>>2]=0,i[k+64>>2]=78468,i[k+8>>2]=78448,h=R0(h),i[h>>2]=77200,i[k+52>>2]=0,i[k+56>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+60>>2]=16,o=1,n=i[r>>2]+1|0,i[r>>2]=n;i:{e:{r:{w=i[e+40>>2],e=i[e+36>>2];f:{if((w|0)==(e|0)){i[r>>2]=((n|0)<=1?1:n)-1;break f}if(f&&(o=k+148|0,k0(o,r),s=o,o=t[k+159|0],n=(o|0)<0,F(k+8|0,n?i[k+148>>2]:s,n?i[k+152>>2]:o),t[k+159|0]<0&&Z(i[k+148>>2]),F(D0(F(k+8|0,33169,7),1),47878,1),o=2),n=k+148|0,l=i[e>>2],W[i[i[l>>2]+12>>2]](n,l,r),s=n,n=t[k+159|0],l=(n|0)<0,F(k+8|0,l?i[k+148>>2]:s,l?i[k+152>>2]:n),t[k+159|0]<0&&Z(i[k+148>>2]),e=e+8|0,(w|0)!=(e|0))for(;n=k+148|0,k0(n,r),s=n,n=t[k+159|0],l=(n|0)<0,F(k+8|0,l?i[k+148>>2]:s,l?i[k+152>>2]:n),t[k+159|0]<0&&Z(i[k+148>>2]),n=k+8|0,F(n,47878,1),f&&(l=k+148|0,k0(l,r),_=n,s=l,n=t[k+159|0],l=(n|0)<0,F(_,l?i[k+148>>2]:s,l?i[k+152>>2]:n),t[k+159|0]<0&&Z(i[k+148>>2]),F(D0(F(k+8|0,33169,7),o),47878,1),o=o+1|0),n=k+148|0,l=i[e>>2],W[i[i[l>>2]+12>>2]](n,l,r),s=n,n=t[k+159|0],l=(n|0)<0,F(k+8|0,l?i[k+148>>2]:s,l?i[k+152>>2]:n),t[k+159|0]<0&&Z(i[k+148>>2]),e=e+8|0,(w|0)!=(e|0););if(e=i[k+60>>2],f=r,r=i[r>>2],i[f>>2]=((r|0)<=1?1:r)-1,!(e&16))break r}e=i[k+56>>2],r=i[k+36>>2],e>>>0<r>>>0&&(i[k+56>>2]=r,e=r),r=k+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[k+28>>2],r=k+20|0}e:{if(f=i[r>>2],e=e-f|0,e>>>0<2147483640){if(e>>>0>=11){o=e|7,r=C(o+1|0),i[A+8>>2]=o-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,f,e)}t[A+e|0]=0,A=i[19619],i[k+8>>2]=A,i[i[A-12>>2]+(k+8|0)>>2]=i[19622],i[h>>2]=77200,t[k+55|0]<0&&Z(i[k+44>>2]),y0(h),Y0(k- -64|0),v=k+160|0}function an(A,e,r,f,k,n,o,l,s,h,w,_,B,m,G){var I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0;for(R=v-16|0,v=R,i[r>>2]=A,x=f&512;;){if((N|0)==4)u[m+11|0]>>>7|0?k=i[m+4>>2]:k=u[m+11|0]&127,k>>>0>1&&(O=R,S=e8(m),i[O+12>>2]=S,O=r,S=el(A7(R+12|0,1),E6(m),i[r>>2]),i[O>>2]=S),f=f&176,(f|0)!=16&&((f|0)==32&&(A=i[r>>2]),i[e>>2]=A),v=R+16|0;else{i:{e:switch(u[s+N|0]){case 0:i[e>>2]=i[r>>2];break i;case 1:i[e>>2]=i[r>>2],I=W[i[i[o>>2]+28>>2]](o,32)|0,Q=i[r>>2],i[r>>2]=Q+1,t[Q|0]=I;break i;case 3:if(u[m+11|0]>>>7|0?I=i[m+4>>2]:I=u[m+11|0]&127,!I)break i;u[m+11|0]>>>7|0?I=i[m>>2]:I=m,I=u[I|0],Q=i[r>>2],i[r>>2]=Q+1,t[Q|0]=I;break i;case 2:if(u[B+11|0]>>>7|0?I=i[B+4>>2]:I=u[B+11|0]&127,I=!I,I|!x)break i;O=r,S=el(e8(B),E6(B),i[r>>2]),i[O>>2]=S;break i;case 4:break e;default:break i}for(j=i[r>>2],k=k+l|0,V=k;;){e:{if(n>>>0<=V>>>0||(I=t[V|0],(I|0)>=0?I=(i[i[o+8>>2]+(I<<2)>>2]&64)!=0:I=0,!I))break e;V=V+1|0;continue}break}if(I=G,(I|0)>0){for(;;){if(!(!I|k>>>0>=V>>>0)){I=I-1|0,V=V-1|0,Q=u[V|0],Y=i[r>>2],i[r>>2]=Y+1,t[Y|0]=Q;continue}break}for(I?Q=W[i[i[o>>2]+28>>2]](o,48)|0:Q=0;;){if(Y=i[r>>2],i[r>>2]=Y+1,(I|0)>0){t[Y|0]=Q,I=I-1|0;continue}break}t[Y|0]=h}e:{if((k|0)==(V|0)){I=W[i[i[o>>2]+28>>2]](o,48)|0,Q=i[r>>2],i[r>>2]=Q+1,t[Q|0]=I;break e}for(u[_+11|0]>>>7|0?I=i[_>>2]:I=_,Q=t[I|0],u[_+11|0]>>>7|0?I=i[_+4>>2]:I=u[_+11|0]&127,Q=I?Q:-1,I=0,E=0;;){if((k|0)==(V|0))break e;r:{if((I|0)!=(Q|0)){Y=I;break r}if(Q=i[r>>2],i[r>>2]=Q+1,t[Q|0]=w,Y=0,u[_+11|0]>>>7|0?Q=i[_+4>>2]:Q=u[_+11|0]&127,E=E+1|0,Q>>>0<=E>>>0){Q=I;break r}if(u[_+11|0]>>>7|0?I=i[_>>2]:I=_,u[I+E|0]==127){Q=-1;break r}u[_+11|0]>>>7|0?I=i[_>>2]:I=_,Q=t[I+E|0]}V=V-1|0,I=u[V|0],U=i[r>>2],i[r>>2]=U+1,t[U|0]=I,I=Y+1|0}}ti(j,i[r>>2])}N=N+1|0;continue}break}}function vg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,n=i[19620],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19621],s=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(s,k),t[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,s=R0(k),i[s>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,K1(k,e,r),o=n,l=k,n=t[f+159|0],k=(n|0)<0,F(o,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,k0(n,r),l=n,n=t[f+159|0],k=(n|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(M2(F(f+8|0,37855,19),i[e+104>>2],i[e+108>>2]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(M2(F(n,36644,19),i[e+112>>2],i[e+116>>2]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(n,36759,11),i[e+120>>2]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(M2(F(n,34538,10),i[e+128>>2],i[e+132>>2]),47878,1),n=f+148|0,k0(n,r),k=n,r=t[f+159|0],n=(r|0)<0,F(f+8|0,n?i[f+148>>2]:k,n?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),e=e+136|0,F(F(F(f+8|0,36797,10),e,l2(e)),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,n,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[s>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(s),Y0(f- -64|0),v=f+160|0}function mg(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0;if(A=v-448|0,v=A,i[A+440>>2]=r,i[A+444>>2]=e,i[A+20>>2]=2127,h=A+20|0,w=J1(A+24|0,A+32|0,h),l=A+16|0,e=i[k+28>>2],i[l>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(l,137e3),t[A+15|0]=0,P9(A+444|0,r,f,l,i[k+4>>2],n,A+15|0,e,w,h,A+432|0)){r=v-16|0,v=r;i:if(u[o+11|0]>>>7|0)break i;i:{if(u[o+11|0]>>>7|0){f=i[o>>2],i[r+12>>2]=0,i[f>>2]=i[r+12>>2],i[o+4>>2]=0;break i}i[r+8>>2]=0,i[o>>2]=i[r+8>>2],t[o+11|0]=u[o+11|0]&128,t[o+11|0]=u[o+11|0]&127}for(v=r+16|0,u[A+15|0]==1&&s5(o,W[i[i[e>>2]+44>>2]](e,45)|0),e=W[i[i[e>>2]+44>>2]](e,48)|0,r=i[w>>2],k=i[A+20>>2],f=k-4|0;;){if(!((e|0)!=i[r>>2]|r>>>0>=f>>>0)){r=r+4|0;continue}break}_=v-16|0,v=_,u[o+11|0]>>>7|0?f=i[o+4>>2]:f=u[o+11|0]&127,l=u[o+11|0]>>>7|0?(i[o+8>>2]&2147483647)-1|0:1,s=k-r>>2;i:{if(!s)break i;if(u[o+11|0]>>>7|0?e=i[o>>2]:e=o,h=e,u[o+11|0]>>>7|0?e=i[o>>2]:e=o,u[o+11|0]>>>7|0?B=i[o+4>>2]:B=u[o+11|0]&127,!q5(h,(e+(B<<2)|0)+4|0,r)){s>>>0>l-f>>>0&&go(o,l,s+(f-l|0)|0,f,f),u[o+11|0]>>>7|0?e=i[o>>2]:e=o,e=bs(r,k,e+(f<<2)|0),i[_+4>>2]=0,i[e>>2]=i[_+4>>2],J6(o,f+s|0);break i}e=v-16|0,v=e,f=_+4|0,vl(f,r,k),v=e+16|0,u[f+11|0]>>>7|0?e=i[f>>2]:e=f,l=e,h=v-16|0,v=h,u[f+11|0]>>>7|0?r=i[f+4>>2]:r=u[f+11|0]&127,e=u[o+11|0]>>>7|0?(i[o+8>>2]&2147483647)-1|0:1,u[o+11|0]>>>7|0?k=i[o+4>>2]:k=u[o+11|0]&127;e:{if(r>>>0<=e-k>>>0){if(s=!r,s)break e;u[o+11|0]>>>7|0?e=i[o>>2]:e=o,B=e+(k<<2)|0;r:{if(s||(s=r<<2,!s))break r;z(B,l,s)}r=r+k|0,J6(o,r),i[h+12>>2]=0,i[(r<<2)+e>>2]=i[h+12>>2];break e}Pt(o,e,k+(r-e|0)|0,k,k,0,r,l)}v=h+16|0,q1(f)}v=_+16|0}return b2(A+444|0,A+440|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+444>>2],i2(A+16|0),e=i[w>>2],i[w>>2]=0,e&&W[i[w+4>>2]](e),v=A+448|0,r|0}function Kn(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;f=i[i[A>>2]+196>>2],e=v-112|0,v=e,n=i[A+8>>2],k=i[n+20>>2];i:{if(!k){k=0;break i}for(l=n+20|0,A=l;o=f>>>0>o0[k+16>>2],A=o?A:k,k=i[(o?4:0)+k>>2],!!k;);if(k=0,(A|0)==(l|0)|f>>>0<o0[A+16>>2])break i;r=i[A+20>>2],o=i[A+24>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),k=1;e:{if(i[r+228>>2]||W[i[i[r>>2]+124>>2]](r)|0)break e;W[i[i[r>>2]+116>>2]](e+80|0,r,e+108|0,e+104|0),k=0;r:{if(i[e+80>>2]||(A=i[e+104>>2],A>>>0<=15&&(k=1,1<<A&43008))||(k=0,(X8(i[n+48>>2],f)|0)!=1735551332))break r;if(r=e+56|0,W6(r,i[n+48>>2],f),A=u[e+76|0],!A){if(i[e+48>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,gA(e+16|0,e+40|0,r),r=i[e+20>>2],A=i[e+16>>2],i[e+80>>2]=A,i[e+84>>2]=r,t[e+99|0]<0&&(Z(i[e+88>>2]),A=i[e+80>>2]),r=i[e+28>>2],i[e+88>>2]=i[e+24>>2],i[e+92>>2]=r,i[e+96>>2]=i[e+32>>2],!A){A=i[n+48>>2],r=i[A+80>>2],i[e+8>>2]=r,A=i[A+84>>2],i[e+12>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1);f:{if(!r)break f;d4(e+16|0,r,f,1684630887),r=i[e+20>>2],f=i[e+16>>2];A:{if((g(p[e+42>>1],p[e+40>>1])|0)!=r-f>>2|(r|0)==(f|0))break A;for(A=f;;){if(!yu(n,i[A>>2]))break A;if(A=A+4|0,(r|0)==(A|0))break}for(;;){k:{if(A=i[l>>2],!A){k=0;break k}for(s=i[f>>2],n=l;h=s>>>0>o0[A+16>>2],n=h?n:A,A=i[(h?4:0)+A>>2],!!A;);if((n|0)==(l|0)){k=0;break k}if(s>>>0<o0[n+16>>2]){k=0;break k}if(s=i[n+20>>2],i[e>>2]=s,A=i[n+24>>2],i[e+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),k=i[s+228>>2]!=0|k,g2(e),f=f+4|0,(r|0)!=(f|0))continue}break}f=i[e+16>>2]}if(!f)break f;i[e+20>>2]=f,Z(f)}g2(e+8|0)}A=u[e+76|0]}if(A=A&255,(A|0)==255)break r;f=i[25169],i[e+16>>2]=i[25168],i[e+20>>2]=f,W[i[(e+16|0)+(A<<2)>>2]](e+40|0,e+56|0)}if(t[e+99|0]>=0)break e;Z(i[e+88>>2])}if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o)}return v=e+112|0,k&1}function $n(A,e,r){var f=0,k=0;k=v-16|0,v=k;i:{if(r>>>0>=32){if(e=C(56),i[k+4>>2]=e,i[k+8>>2]=51,i[k+12>>2]=-2147483592,r=u[27739]|u[27740]<<8|(u[27741]<<16|u[27742]<<24),f=u[27735]|u[27736]<<8|(u[27737]<<16|u[27738]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+51|0]=0,r=u[27782]|u[27783]<<8|(u[27784]<<16|u[27785]<<24),t[e+47|0]=r,t[e+48|0]=r>>>8,t[e+49|0]=r>>>16,t[e+50|0]=r>>>24,r=u[27779]|u[27780]<<8|(u[27781]<<16|u[27782]<<24),f=u[27775]|u[27776]<<8|(u[27777]<<16|u[27778]<<24),t[e+40|0]=f,t[e+41|0]=f>>>8,t[e+42|0]=f>>>16,t[e+43|0]=f>>>24,t[e+44|0]=r,t[e+45|0]=r>>>8,t[e+46|0]=r>>>16,t[e+47|0]=r>>>24,r=u[27771]|u[27772]<<8|(u[27773]<<16|u[27774]<<24),f=u[27767]|u[27768]<<8|(u[27769]<<16|u[27770]<<24),t[e+32|0]=f,t[e+33|0]=f>>>8,t[e+34|0]=f>>>16,t[e+35|0]=f>>>24,t[e+36|0]=r,t[e+37|0]=r>>>8,t[e+38|0]=r>>>16,t[e+39|0]=r>>>24,r=u[27763]|u[27764]<<8|(u[27765]<<16|u[27766]<<24),f=u[27759]|u[27760]<<8|(u[27761]<<16|u[27762]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[27755]|u[27756]<<8|(u[27757]<<16|u[27758]<<24),f=u[27751]|u[27752]<<8|(u[27753]<<16|u[27754]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[27747]|u[27748]<<8|(u[27749]<<16|u[27750]<<24),f=u[27743]|u[27744]<<8|(u[27745]<<16|u[27746]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,k+4|0),t[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(i[e+104>>2]=r,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+16|0}function Zg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]),k=u[e+97|0];i:{if(k>>>0>=2){B1(A,e,17500);break i}e:{if((k|0)==1){s=e,h=S4(r),i[s+104>>2]=h,i[e+108>>2]=h0,s=e,h=S4(r),i[s+112>>2]=h,i[e+116>>2]=h0,s=e,h=F0(r),i[s+120>>2]=h,k=i[r+16>>2],k=k>>>0>=4?4:k,n=i[r+8>>2],n&&l4(n,k),n=i[r>>2],o=W[i[i[n>>2]+8>>2]](n)|0,l=h0,o=k+o|0,l=o>>>0<k>>>0?l+1|0:l,W[i[i[n>>2]+20>>2]](n,o,l)|0,i[r+16>>2]=i[r+16>>2]-k,k=S4(r),n=h0;break e}s=e,h=F0(r),i[s+104>>2]=h,i[e+108>>2]=0,s=e,h=F0(r),i[s+112>>2]=h,i[e+116>>2]=0,s=e,h=F0(r),i[s+120>>2]=h,k=i[r+16>>2],k=k>>>0>=4?4:k,n=i[r+8>>2],n&&l4(n,k),n=i[r>>2],o=W[i[i[n>>2]+8>>2]](n)|0,l=h0,o=k+o|0,l=o>>>0<k>>>0?l+1|0:l,W[i[i[n>>2]+20>>2]](n,o,l)|0,i[r+16>>2]=i[r+16>>2]-k,k=F0(r),n=0}if(i[e+128>>2]=k,i[e+132>>2]=n,k=i[r+16>>2],k=k>>>0>=8?8:k,n=i[r+8>>2],n&&l4(n,k),n=i[r>>2],o=W[i[i[n>>2]+8>>2]](n)|0,l=h0,o=k+o|0,l=o>>>0<k>>>0?l+1|0:l,W[i[i[n>>2]+20>>2]](n,o,l)|0,i[r+16>>2]=i[r+16>>2]-k,s=e,h=w2(r),X[s+136>>1]=h,s=e,h=w2(r),X[s+138>>1]=h,s=e,h=w2(r),X[s+140>>1]=h,k=i[r+16>>2],k=k>>>0>=2?2:k,n=i[r+8>>2],n&&l4(n,k),n=i[r>>2],o=W[i[i[n>>2]+8>>2]](n)|0,l=h0,o=k+o|0,l=o>>>0<k>>>0?l+1|0:l,W[i[i[n>>2]+20>>2]](n,o,l)|0,i[r+16>>2]=i[r+16>>2]-k,s=e,h=F0(r),i[s+144>>2]=h,s=e,h=F0(r),i[s+148>>2]=h,s=e,h=F0(r),i[s+152>>2]=h,s=e,h=F0(r),i[s+156>>2]=h,s=e,h=F0(r),i[s+160>>2]=h,s=e,h=F0(r),i[s+164>>2]=h,s=e,h=F0(r),i[s+168>>2]=h,s=e,h=F0(r),i[s+172>>2]=h,s=e,h=F0(r),i[s+176>>2]=h,s=e,h=F0(r),i[s+180>>2]=h,s=e,h=F0(r),i[s+184>>2]=h,u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function EA(A,e,r,f){var k=0,n=0,o=0,l=0;if(n=i[A>>2],(i[A+8>>2]-n|0)/48>>>0>=f>>>0){if(o=f,k=i[A+4>>2],f=k-n|0,o>>>0>(f|0)/48>>>0){if(f=e+f|0,(k|0)!=(n|0)){for(;;){i:{if((e|0)==(n|0)){k=i[e+16>>2],i[n+12>>2]=i[e+12>>2],i[n+16>>2]=k,i[n+20>>2]=i[e+20>>2];break i}k=i[e>>2],o=i[e+4>>2],h1(n,k,o,o-k>>2),i[n+20>>2]=i[e+20>>2],k=i[e+16>>2],i[n+12>>2]=i[e+12>>2],i[n+16>>2]=k,k=i[e+24>>2],o=i[e+28>>2],h1(n+24|0,k,o,o-k>>2),k=i[e+36>>2],o=i[e+40>>2],h1(n+36|0,k,o,o-k>>2)}if(n=n+48|0,e=e+48|0,(f|0)==(e|0))break}k=i[A+4>>2]}if(e=k,(r|0)!=(f|0))for(;e=Ue(e,f)+48|0,f=f+48|0,(f|0)!=(r|0););i[A+4>>2]=(e-k|0)+k;return}if((e|0)!=(r|0)){for(;;){i:{if((e|0)==(n|0)){f=i[e+16>>2],i[n+12>>2]=i[e+12>>2],i[n+16>>2]=f,i[n+20>>2]=i[e+20>>2];break i}f=i[e>>2],k=i[e+4>>2],h1(n,f,k,k-f>>2),i[n+20>>2]=i[e+20>>2],f=i[e+16>>2],i[n+12>>2]=i[e+12>>2],i[n+16>>2]=f,f=i[e+24>>2],k=i[e+28>>2],h1(n+24|0,f,k,k-f>>2),f=i[e+36>>2],k=i[e+40>>2],h1(n+36|0,f,k,k-f>>2)}if(n=n+48|0,e=e+48|0,(r|0)==(e|0))break}k=i[A+4>>2]}if((k|0)!=(n|0))for(;e=i[k-12>>2],e&&(i[k-8>>2]=e,Z(e)),e=i[k-24>>2],e&&(i[k-20>>2]=e,Z(e)),e=k-48|0,r=i[e>>2],r&&(i[k-44>>2]=r,Z(r)),k=e,(e|0)!=(n|0););i[A+4>>2]=n;return}if(k=A,n=i[k>>2],n){if(o=n,A=i[k+4>>2],(n|0)!=(A|0)){for(;o=i[A-12>>2],o&&(i[A-8>>2]=o,Z(o)),o=i[A-24>>2],o&&(i[A-20>>2]=o,Z(o)),o=A-48|0,l=i[o>>2],l&&(i[A-44>>2]=l,Z(l)),A=o,(n|0)!=(A|0););o=i[k>>2]}i[k+4>>2]=n,Z(o),i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0}i:{if(f>>>0>=89478486||(A=(i[k+8>>2]-i[k>>2]|0)/48|0,n=A<<1,A=A>>>0>=44739242?89478485:f>>>0<n>>>0?n:f,A>>>0>=89478486))break i;if(A=g(A,48),n=C(A),i[k+4>>2]=n,i[k>>2]=n,i[k+8>>2]=A+n,(e|0)!=(r|0))for(;n=Ue(n,e)+48|0,e=e+48|0,(r|0)!=(e|0););i[k+4>>2]=n;return}s0(),M()}function gg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;if(k=i[A+132>>2],k>>>0<o0[A+136>>2]){B=A,m=Re(k,e)+52|0,i[B+132>>2]=m;return}_=A,n=v-32|0,v=n,o=A+128|0,h=i[o>>2];i:{e:{if(A=i[o+4>>2]-h|0,s=((A|0)/52|0)+1|0,s>>>0<82595525){if(f=o+8|0,k=i[f>>2],i[n+28>>2]=f,f=(k-h|0)/52|0,k=f<<1,w=f>>>0>=41297762?82595524:k>>>0>s>>>0?k:s,w){if(w>>>0>=82595525)break e;k=C(g(w,52))}else k=0;if(h=Re(A+k|0,e),A=i[o>>2],e=A,f=i[o+4>>2],l=f,s=h+g((f-A|0)/-52|0,52)|0,r=s,(A|0)!=(f|0))for(;i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,i[r>>2]=i[A>>2],i[r+4>>2]=i[A+4>>2],i[r+8>>2]=i[A+8>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=u[A+12|0],i[r+24>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,t[r+12|0]=f,i[r+16>>2]=i[A+16>>2],i[r+20>>2]=i[A+20>>2],i[r+24>>2]=i[A+24>>2],i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[r+36>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+28>>2]=i[A+28>>2],i[r+32>>2]=i[A+32>>2],i[r+36>>2]=i[A+36>>2],i[A+36>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,i[r+48>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+40>>2]=i[A+40>>2],i[r+44>>2]=i[A+44>>2],i[r+48>>2]=i[A+48>>2],i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,r=r+52|0,A=A+52|0,(l|0)!=(A|0););if((e|0)!=(l|0))for(;A=i[e+40>>2],A&&(i[e+44>>2]=A,Z(A)),A=i[e+28>>2],A&&(i[e+32>>2]=A,Z(A)),A=i[e+16>>2],A&&(i[e+20>>2]=A,Z(A)),A=i[e>>2],A&&(i[e+4>>2]=A,Z(A)),e=e+52|0,(l|0)!=(e|0););if(l=i[o>>2],i[o>>2]=s,i[n+16>>2]=l,A=h+52|0,i[o+4>>2]=A,i[n+20>>2]=l,e=i[o+8>>2],i[o+8>>2]=g(w,52)+k,i[n+12>>2]=l,i[n+24>>2]=e,e=i[n+20>>2],(l|0)!=(e|0))for(;k=e-52|0,i[n+20>>2]=k,f=i[e-12>>2],f&&(i[e-8>>2]=f,Z(f)),f=i[e-24>>2],f&&(i[e-20>>2]=f,Z(f)),f=i[e-36>>2],f&&(i[e-32>>2]=f,Z(f)),k=i[k>>2],k&&(i[e-48>>2]=k,Z(k)),e=i[n+20>>2],(l|0)!=(e|0););e=i[n+12>>2],e&&Z(e),v=n+32|0;break i}s0(),M()}x0(),M()}i[_+132>>2]=A}function Gg(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(f=A+16|0,r=i[f+16>>2],k=f+20|0,(r|0)!=(k|0))for(;;){e=i[r+20>>2],A=i[r+24>>2];i:{if(!A){uo(e);break i}if(i[A+4>>2]=i[A+4>>2]+1,uo(e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2];i:{if(A){for(;;)if(e=A,A=i[A>>2],!A)break i}for(;e=i[r+8>>2],A=i[e>>2]!=(r|0),r=e,!!A;);}if(r=e,(k|0)==(e|0))break}if($3(f+196|0,i[f+200>>2]),r=i[f+184>>2],r){if(A=r,e=i[f+188>>2],(A|0)!=(e|0)){for(;;){A=i[e-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[f+184>>2]}i[f+188>>2]=r,Z(A)}if(r=i[f+172>>2],r){if(A=r,e=i[f+176>>2],(A|0)!=(e|0)){for(;;){A=i[e-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[f+172>>2]}i[f+176>>2]=r,Z(A)}u[115e3]||(t[115e3]=1),k=i[28752];i:{if(!k)break i;for(r=115008,e=i[f+168>>2],A=k;n=e>>>0>o0[A+16>>2],r=n?r:A,A=i[(n?4:0)+A>>2],!!A;);if((r|0)==115008|e>>>0<o0[r+16>>2])break i;e=i[r+4>>2];e:{if(!e){for(e=r;A=i[e+8>>2],n=i[A>>2]!=(e|0),e=A,!!n;);break e}for(;A=e,e=i[A>>2],!!e;);}i[28751]==(r|0)&&(i[28751]=A),i[28753]=i[28753]-1,Rn(k,r),Z(r)}A=i[f+52>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[f+44>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=i[f+28>>2],r){if(A=r,e=i[f+32>>2],(A|0)!=(e|0)){for(;;){A=i[e-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[f+28>>2]}i[f+32>>2]=r,Z(A)}hr(f+16|0,i[f+20>>2]),t[f+11|0]<0&&Z(i[f>>2])}function Wg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,At(n,e,r),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(B0(F(f+8|0,35973,11),p[e+120>>1]),3179,1),p[e+122>>1]),47878,1),k=i[e+124>>2],w=i[e+128>>2],(k|0)!=(w|0))for(e=0;n=f+148|0,k0(n,r),s=n,n=t[f+159|0],o=(n|0)<0,F(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(D0(F(f+8|0,31255,6),e),46921,2),o=f+148|0,k0(o,r),s=o,o=t[f+159|0],h=(o|0)<0,F(n,h?i[f+148>>2]:s,h?i[f+152>>2]:o),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(n,35168,11),p[k>>1]),47878,1),o=f+148|0,k0(o,r),s=o,o=t[f+159|0],h=(o|0)<0,F(n,h?i[f+148>>2]:s,h?i[f+152>>2]:o),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(D0(F(n,33986,9),p[k+2>>1]+1|0),3179,1),p[k+4>>1]+1|0),47878,1),e=e+1|0,k=k+6|0,(w|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,t[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(t[A+11|0]=k,k)break e;k=0;break i}I0(),M()}if(!k)break i;z(A,r,k)}t[A+k|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function Xg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,o=i[19620],i[f+8>>2]=o,k=i[o-12>>2],o=f+8|0,i[k+o>>2]=i[19621],s=o+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(s,k),t[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,s=R0(k),i[s>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,K1(k,e,r),n=o,l=k,o=t[f+159|0],k=(o|0)<0,F(n,k?i[f+148>>2]:l,k?i[f+152>>2]:o),t[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(o=0;k=f+148|0,k0(k,r),n=k,k=t[f+159|0],l=(k|0)<0,F(f+8|0,l?i[f+148>>2]:n,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(B0(F(f+8|0,20885,1),o),46799,2),l=f+148|0,k0(l,r),h=l,l=t[f+159|0],n=(l|0)<0,F(k,n?i[f+148>>2]:h,n?i[f+152>>2]:l),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(k,34907,15),k=g(o,12),l=F(B0(n,i[k+i[e+104>>2]>>2]),47878,1),n=f+148|0,k0(n,r),h=n,n=t[f+159|0],w=(n|0)<0,F(l,w?i[f+148>>2]:h,w?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),l=F(B0(F(l,34923,21),i[(k+i[e+104>>2]|0)+4>>2]),47878,1),n=f+148|0,k0(n,r),h=n,n=t[f+159|0],w=(n|0)<0,F(l,w?i[f+148>>2]:h,w?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(l,33125,28),i[(k+i[e+104>>2]|0)+8>>2]),47878,1),o=o+1|0,o>>>0<(i[e+108>>2]-i[e+104>>2]|0)/12>>>0;);e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(o=i[r>>2],e=e-o|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,o,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[s>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(s),Y0(f- -64|0),v=f+160|0}function Ig(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;A=v-1056|0,v=A,i[A+16>>2]=n,i[A+20>>2]=o,i[A+24>>2]=l,i[A+28>>2]=s,h=A+944|0,i[A+940>>2]=h,h=_6(h,100,12437,A+16|0),i[A+528>>2]=2126,w=A+528|0,m=J1(A+520|0,0,w),i[A+528>>2]=2126,_=J1(A+512|0,0,w);i:{if(h>>>0>=100&&(h=e1(),i[A>>2]=n,i[A+4>>2]=o,i[A+8>>2]=l,i[A+12>>2]=s,h=S8(A+940|0,h,12437,A),(h|0)==-1||(n=i[m>>2],i[m>>2]=i[A+940>>2],n&&W[i[m+4>>2]](n),o=E2(h<<2),n=i[_>>2],i[_>>2]=o,n&&W[i[_+4>>2]](n),w=i[_>>2],!w)))break i;o=A+508|0,n=i[f+28>>2],i[o>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),V=$0(o,137e3),n=V,o=i[A+940>>2],W[i[i[n>>2]+48>>2]](n,o,o+h|0,w)|0,Q=(h|0)>0?u[i[A+940>>2]]==45:Q,o=v-16|0,v=o,n=A+484|0,i[n>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,v=o+16|0,o=v-16|0,v=o,l=A+472|0,i[l>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,v=o+16|0,o=v-16|0,v=o,s=A+460|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=o+16|0,po(r,Q,A+508|0,A+504|0,A+500|0,A+496|0,n,l,s,A+456|0),i[A+48>>2]=2126,r=A+48|0,B=J1(A+40|0,0,r),o=i[A+456>>2];e:{if((o|0)<(h|0)){u[l+11|0]>>>7|0?G=i[l+4>>2]:G=u[l+11|0]&127,u[s+11|0]>>>7|0?I=i[s+4>>2]:I=u[s+11|0]&127,o=(o+(G+(I+(h-o<<1)|0)|0)|0)+1|0;break e}I=i[A+456>>2],u[s+11|0]>>>7|0?o=i[s+4>>2]:o=u[s+11|0]&127,u[l+11|0]>>>7|0?G=i[l+4>>2]:G=u[l+11|0]&127,o=(I+(o+G|0)|0)+2|0}if(o>>>0>=101&&(o=E2(o<<2),r=i[B>>2],i[B>>2]=o,r&&W[i[B+4>>2]](r),r=i[B>>2],!r))break i;return On(r,A+36|0,A+32|0,i[f+4>>2],w,(h<<2)+w|0,V,Q,A+504|0,i[A+500>>2],i[A+496>>2],n,l,s,i[A+456>>2]),r=t6(e,r,i[A+36>>2],i[A+32>>2],f,k),e=i[B>>2],i[B>>2]=0,e&&W[i[B+4>>2]](e),q1(s),q1(l),_2(n),i2(A+508|0),e=i[_>>2],i[_>>2]=0,e&&W[i[_+4>>2]](e),e=i[m>>2],i[m>>2]=0,e&&W[i[m+4>>2]](e),v=A+1056|0,r|0}N1(),M()}function P6(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;k=v-32|0,v=k,f=180,o=1;i:{e:{r:f:{A:switch(r-2|0){case 2:o=0;break e;case 3:f=270,l=1;break r;case 4:f=270;break f;case 5:f=270,o=0,l=1;break r;case 0:break e;case 1:break r;case 6:break A;default:break i}f=90}r=C(120),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96428,n=r+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[n>>2]=94044,i[r+116>>2]=f,i[r+32>>2]=1769107316,f=i[A+120>>2],i[k+28>>2]=r,i[k+24>>2]=n,i[r+4>>2]=i[r+4>>2]+1,n=ni(f,k+24|0),f=i[k+28>>2];r:{if(!f||(s=i[f+4>>2],i[f+4>>2]=s-1,s))break r;W[i[i[f>>2]+8>>2]](f),y(f)}if(f=i[A+128>>2],t[k+20|0]=1,X[k+22>>1]=n+1,i[k+12>>2]=p[k+20>>1]|p[k+22>>1]<<16,U4(f,e,k+12|0),f=i[r+4>>2],i[r+4>>2]=f-1,f||(W[i[i[r>>2]+8>>2]](r),y(r)),!l)break i}r=C(120),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96468,f=r+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[f>>2]=94124,i[r+116>>2]=o,i[r+32>>2]=1768778098,n=i[A+120>>2],i[k+28>>2]=r,i[k+24>>2]=f,i[r+4>>2]=i[r+4>>2]+1,n=ni(n,k+24|0),f=i[k+28>>2];e:{if(!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(A=i[A+128>>2],t[k+16|0]=1,X[k+18>>1]=n+1,i[k+8>>2]=p[k+16>>1]|p[k+18>>1]<<16,U4(A,e,k+8|0),A=i[r+4>>2],i[r+4>>2]=A-1,A)break i;W[i[i[r>>2]+8>>2]](r),y(r)}v=k+32|0}function Qg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,o=i[19620],i[f+8>>2]=o,n=f+8|0,i[n+i[o-12>>2]>>2]=i[19621],o=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(o,k),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(k),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,J2(k,e,r),l=n,s=k,n=t[f+159|0],k=(n|0)<0,F(l,k?i[f+148>>2]:s,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,k0(n,r),l=n,n=t[f+159|0],k=(n|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),l=F(f+8|0,36562,10),n=t[e+115|0],k=(n|0)<0,n=F(F(l,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:n),47878,1),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(n,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(n,33955,14),n=f+20|0,r=i[e+116>>2],s=i[e+120>>2],(r|0)!=(s|0))for(;h=u[r|0],e=i[f+8>>2]-12|0,k=o+i[e>>2]|0,i[k>>2]=i[k>>2]&-75|8,i[i[e>>2]+n>>2]=2,e=i[e>>2]+(f+8|0)|0,u[e+80|0]||(l=f+148|0,k=i[e+28>>2],i[l>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(l,137008),W[i[i[k>>2]+28>>2]](k,32)|0,i2(l)),t[e+76|0]=48,t[e+77|0]=0,t[e+78|0]=0,t[e+79|0]=0,t[e+80|0]=1,F(D0(f+8|0,h),37886,1),r=r+1|0,(s|0)!=(r|0););F(f+8|0,47878,1),e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2]}e:{if(n=i[n>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,n,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function Vg(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;h=v-16|0,v=h;i:{e:{if(!I7(o,0)){i[A>>2]=5,i[A+4>>2]=2002,i[A+8>>2]=10857;break e}s=C(52),i[s+32>>2]=0,i[s+36>>2]=0,i[s+12>>2]=102424,i[s+4>>2]=0,i[s+8>>2]=0,i[s+28>>2]=n,i[s+24>>2]=k,i[s+20>>2]=f,i[s+16>>2]=r,i[s>>2]=102668,i[s+40>>2]=0,i[s+44>>2]=0,i[s+48>>2]=0,m=k,f=L0(k,0,n,0),r=h0;r:{if((r|0)==7&f>>>0>=4294967289|r>>>0>7){i[A>>2]=6,i[A+4>>2]=1e3,i[A+8>>2]=3249;break r}G=s+32|0;f:{if(!(r|f)){f=0,r=0;break f}if(f=f+7|0,f=((f>>>0<7?r+1|0:r)&7)<<29|f>>>3,(f|0)<0)break i;r=C(f),f&&l0(r,0,f),f=r+f|0,i[s+40>>2]=f,i[s+36>>2]=f,i[s+32>>2]=r}f=f-r|0,f&&l0(r,0,f),B=s+12|0,f=i[o>>2],r=i[f+192>>2],f=i[f+188>>2],I=Ki(o,0,h+12|0),r=r>>>0<n>>>0?r:n;f:{if(!r||(f=f>>>0<k>>>0?f:k,!f))break f;for(Q=f,V=r,r=0,f=0;;){for(o=L0(r,f,m,0),Y=h0,n=0,k=0;w=k+Y|0,_=n+o|0,w=i[G>>2]+(((_>>>0<o>>>0?w+1|0:w)&7)<<29|_>>>3)|0,t[w|0]=u[w|0]|(u[(I+g(r,i[h+12>>2])|0)+n|0]&128)>>>(_&7),n=n+1|0,k=n?k:k+1|0,!!((n|0)!=(Q|0)|k););if(r=r+1|0,f=r?f:f+1|0,!((r|0)!=(V|0)|f))break}}r=i[e+8>>2],i[h+8>>2]=s,i[h+4>>2]=B,i[s+4>>2]=i[s+4>>2]+1,P0(r+12|0,h+4|0),r=i[h+8>>2];f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}f:{if(!l||(i[s+4>>2]=i[s+4>>2]+1,r=C(24),i[s+4>>2]=i[s+4>>2]+1,i[r+20>>2]=s,i[r+16>>2]=B,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[l>>2]=r,e=i[s+4>>2],i[s+4>>2]=e-1,e))break f;W[i[i[s>>2]+8>>2]](s),y(s)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break e;W[i[i[s>>2]+8>>2]](s),y(s)}v=h+16|0;return}s0(),M()}function pg(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0,k=v-112|0,v=k,i[k+88>>2]=0,i[k+92>>2]=0,i[k+80>>2]=0,i[k+84>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,o=k- -64|0,i[o>>2]=0,i[o+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,W[i[i[e>>2]+12>>2]](k+8|0,e,r,f,k+56|0,n);i:{e:{r:{f:{A:switch(u[k+52|0]){case 0:if(n=114912,!i[28728])break e;r=114924,f=114931,e=114920;break f;case 1:break A;default:break r}if(!i[k+8>>2])break r;r=k+20|0,f=k+27|0,n=k+8|0,e=k+16|0}if(o=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=o,A=A+8|0,t[f|0]>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];break i}T(A,i[e>>2],i[r>>2]);break i}e2(),M()}e:{if(u[e+48|0]==1){if(r=i[e+4>>2],r){if(f=r,n=i[e+8>>2],(r|0)!=(n|0)){for(;;){f=i[n-4>>2];r:{if(!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break r;W[i[i[f>>2]+8>>2]](f),y(f)}if(n=n-8|0,(r|0)==(n|0))break}f=i[e+4>>2]}i[e+8>>2]=r,Z(f)}i[e+4>>2]=i[k+8>>2],i[e+8>>2]=i[k+12>>2],i[e+12>>2]=i[k+16>>2],i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,r=i[e+16>>2],r&&(i[e+20>>2]=r,Z(r)),i[e+16>>2]=i[k+20>>2],i[e+20>>2]=i[k+24>>2],i[e+24>>2]=i[k+28>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,r=i[k+44>>2],i[e+36>>2]=i[k+40>>2],i[e+40>>2]=r,r=i[k+36>>2],i[e+28>>2]=i[k+32>>2],i[e+32>>2]=r;break e}i[e+4>>2]=i[k+8>>2],i[e+8>>2]=i[k+12>>2],i[e+12>>2]=i[k+16>>2],i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+16>>2]=i[k+20>>2],i[e+20>>2]=i[k+24>>2],i[e+24>>2]=i[k+28>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,r=i[k+40>>2],f=i[k+44>>2],n=i[k+32>>2],o=i[k+36>>2],t[e+48|0]=1,i[e+36>>2]=r,i[e+40>>2]=f,i[e+28>>2]=n,i[e+32>>2]=o}t[e+40|0]=1,i[e+44>>2]=s,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}A=u[k+52|0],(A|0)!=255&&(e=i[26345],i[k+104>>2]=i[26344],i[k+108>>2]=e,W[i[(k+104|0)+(A<<2)>>2]](k+103|0,k+8|0)),v=k+112|0}function Fg(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0,k=v-112|0,v=k,i[k+88>>2]=0,i[k+92>>2]=0,i[k+80>>2]=0,i[k+84>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,o=k- -64|0,i[o>>2]=0,i[o+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,W[i[i[e>>2]+12>>2]](k+8|0,e,r,f,k+56|0,n);i:{e:{r:{f:{A:switch(u[k+52|0]){case 0:if(n=114912,!i[28728])break e;r=114924,f=114931,e=114920;break f;case 1:break A;default:break r}if(!i[k+8>>2])break r;r=k+20|0,f=k+27|0,n=k+8|0,e=k+16|0}if(o=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=o,A=A+8|0,t[f|0]>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];break i}T(A,i[e>>2],i[r>>2]);break i}e2(),M()}e:{if(u[e+48|0]==1){if(r=i[e+4>>2],r){if(f=r,n=i[e+8>>2],(r|0)!=(n|0)){for(;;){f=i[n-4>>2];r:{if(!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break r;W[i[i[f>>2]+8>>2]](f),y(f)}if(n=n-8|0,(r|0)==(n|0))break}f=i[e+4>>2]}i[e+8>>2]=r,Z(f)}i[e+4>>2]=i[k+8>>2],i[e+8>>2]=i[k+12>>2],i[e+12>>2]=i[k+16>>2],i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,r=i[e+16>>2],r&&(i[e+20>>2]=r,Z(r)),i[e+16>>2]=i[k+20>>2],i[e+20>>2]=i[k+24>>2],i[e+24>>2]=i[k+28>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,r=i[k+44>>2],i[e+36>>2]=i[k+40>>2],i[e+40>>2]=r,r=i[k+36>>2],i[e+28>>2]=i[k+32>>2],i[e+32>>2]=r;break e}i[e+4>>2]=i[k+8>>2],i[e+8>>2]=i[k+12>>2],i[e+12>>2]=i[k+16>>2],i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+16>>2]=i[k+20>>2],i[e+20>>2]=i[k+24>>2],i[e+24>>2]=i[k+28>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,r=i[k+40>>2],f=i[k+44>>2],n=i[k+32>>2],o=i[k+36>>2],t[e+48|0]=1,i[e+36>>2]=r,i[e+40>>2]=f,i[e+28>>2]=n,i[e+32>>2]=o}t[e+40|0]=1,i[e+44>>2]=s,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}A=u[k+52|0],(A|0)!=255&&(e=i[26451],i[k+104>>2]=i[26450],i[k+108>>2]=e,W[i[(k+104|0)+(A<<2)>>2]](k+103|0,k+8|0)),v=k+112|0}function Cg(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;A=v-448|0,v=A,i[A+16>>2]=n,i[A+20>>2]=o,i[A+24>>2]=l,i[A+28>>2]=s,h=A+336|0,i[A+332>>2]=h,h=_6(h,100,12437,A+16|0),i[A+224>>2]=2126,w=A+224|0,m=J1(A+216|0,0,w),i[A+224>>2]=2126,_=J1(A+208|0,0,w);i:{if(h>>>0>=100&&(h=e1(),i[A>>2]=n,i[A+4>>2]=o,i[A+8>>2]=l,i[A+12>>2]=s,h=S8(A+332|0,h,12437,A),(h|0)==-1||(n=i[m>>2],i[m>>2]=i[A+332>>2],n&&W[i[m+4>>2]](n),o=E2(h),n=i[_>>2],i[_>>2]=o,n&&W[i[_+4>>2]](n),w=i[_>>2],!w)))break i;o=A+204|0,n=i[f+28>>2],i[o>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),V=$0(o,137008),n=V,o=i[A+332>>2],W[i[i[n>>2]+32>>2]](n,o,o+h|0,w)|0,Q=(h|0)>0?u[i[A+332>>2]]==45:Q,o=v-16|0,v=o,n=A+184|0,i[n>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,v=o+16|0,o=v-16|0,v=o,l=A+172|0,i[l>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,v=o+16|0,o=v-16|0,v=o,s=A+160|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=o+16|0,Fo(r,Q,A+204|0,A+200|0,A+199|0,A+198|0,n,l,s,A+156|0),i[A+48>>2]=2126,r=A+48|0,B=J1(A+40|0,0,r),o=i[A+156>>2];e:{if((o|0)<(h|0)){u[l+11|0]>>>7|0?G=i[l+4>>2]:G=u[l+11|0]&127,u[s+11|0]>>>7|0?I=i[s+4>>2]:I=u[s+11|0]&127,o=(o+(G+(I+(h-o<<1)|0)|0)|0)+1|0;break e}I=i[A+156>>2],u[s+11|0]>>>7|0?o=i[s+4>>2]:o=u[s+11|0]&127,u[l+11|0]>>>7|0?G=i[l+4>>2]:G=u[l+11|0]&127,o=(I+(o+G|0)|0)+2|0}if(o>>>0>=101&&(o=E2(o),r=i[B>>2],i[B>>2]=o,r&&W[i[B+4>>2]](r),r=i[B>>2],!r))break i;return an(r,A+36|0,A+32|0,i[f+4>>2],w,h+w|0,V,Q,A+200|0,t[A+199|0],t[A+198|0],n,l,s,i[A+156>>2]),r=o6(e,r,i[A+36>>2],i[A+32>>2],f,k),e=i[B>>2],i[B>>2]=0,e&&W[i[B+4>>2]](e),_2(s),_2(l),_2(n),i2(A+204|0),e=i[_>>2],i[_>>2]=0,e&&W[i[_+4>>2]](e),e=i[m>>2],i[m>>2]=0,e&&W[i[m+4>>2]](e),v=A+448|0,r|0}N1(),M()}function dn(A,e){var r=0,f=0,k=0,n=0,o=0;k=v-48|0,v=k,r=i[e>>2];i:{if((i[e+4>>2]-r|0)!=9){e=C(40),i[k+12>>2]=e,i[k+16>>2]=32,i[k+20>>2]=-2147483608,r=u[20484]|u[20485]<<8|(u[20486]<<16|u[20487]<<24),f=u[20480]|u[20481]<<8|(u[20482]<<16|u[20483]<<24),t[e+24|0]=f,t[e+25|0]=f>>>8,t[e+26|0]=f>>>16,t[e+27|0]=f>>>24,t[e+28|0]=r,t[e+29|0]=r>>>8,t[e+30|0]=r>>>16,t[e+31|0]=r>>>24,r=u[20476]|u[20477]<<8|(u[20478]<<16|u[20479]<<24),f=u[20472]|u[20473]<<8|(u[20474]<<16|u[20475]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[20468]|u[20469]<<8|(u[20470]<<16|u[20471]<<24),f=u[20464]|u[20465]<<8|(u[20466]<<16|u[20467]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[20460]|u[20461]<<8|(u[20462]<<16|u[20463]<<24),f=u[20456]|u[20457]<<8|(u[20458]<<16|u[20459]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+32|0]=0,e=a(k+24|0,2,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+24|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+24|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}f=u[r|0]|u[r+1|0]<<8|(u[r+2|0]<<16|u[r+3|0]<<24),e=u[r+4|0]|u[r+5|0]<<8|(u[r+6|0]<<16|u[r+7|0]<<24),r=u[r+8|0],t[A+24|0]=0,t[A|0]=1,t[A+16|0]=r>>>7,t[A+18|0]=r>>>5&1,t[A+17|0]=r>>>6&1,r=f,n=r&16711680,f=n>>>8|0,o=n<<24,n=r&-16777216,i[A+8>>2]=o|n<<8|(((e&255)<<24|r>>>8)&-16777216|((e&16777215)<<8|r>>>24)&16711680|(e>>>8&65280|e>>>24)),e=f|n>>>24|(r<<24|(r&65280)<<8),f=0,i[A+12>>2]=e|(f|f)}v=k+48|0}function RA(A,e,r){var f=0,k=0,n=0,o=0;n=v-48|0,v=n;i:{if(r){e:{k=i[e+200>>2];r:{if(!k)break r;for(e=e+200|0,f=e;o=o0[k+16>>2]<r>>>0,f=o?f:k,k=i[(o?4:0)+k>>2],!!k;);if((e|0)==(f|0))break r;if(o0[f+16>>2]<=r>>>0)break e}e=C(24),i[n+12>>2]=e,i[n+16>>2]=16,i[n+20>>2]=-2147483624,r=u[17480]|u[17481]<<8|(u[17482]<<16|u[17483]<<24),f=u[17476]|u[17477]<<8|(u[17478]<<16|u[17479]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,r=u[17472]|u[17473]<<8|(u[17474]<<16|u[17475]<<24),f=u[17468]|u[17469]<<8|(u[17470]<<16|u[17471]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+16|0]=0,e=a(n+24|0,5,0,n+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(t[n+23|0]>=0)break i;Z(i[n+12>>2]);break i}r=i[f+20>>2],e=i[f+24>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r;break i}if(o=i[e+208>>2],o){f=i[e+200>>2];e:{r:{if(!f){r=e+200|0,k=r;break r}for(;;){if(k=f,r=i[f+16>>2],r>>>0>o>>>0){if(r=f,f=i[f>>2],f)continue;break r}if(r>>>0>=o>>>0)break e;if(f=i[k+4>>2],!f)break}r=k+4|0}f=C(28),i[f+20>>2]=0,i[f+24>>2]=0,i[f+16>>2]=o,i[f+8>>2]=k,i[f>>2]=0,i[f+4>>2]=0,i[r>>2]=f,r=i[i[e+196>>2]>>2],r&&(i[e+196>>2]=r),G1(i[e+200>>2],f),i[e+204>>2]=i[e+204>>2]+1}r=i[f+20>>2],e=i[f+24>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r;break i}e=i[e+196>>2],r=i[e+20>>2],e=i[e+24>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r}v=n+48|0}function Yg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;i:{e:{r:{f:{A:{k:{n:{t:{o:{l:{if((e|0)>=12){if(f=u[A+8|0],!f||(r=u[A+9|0],!r)||(k=u[A+10|0],!k)||(n=u[A+11|0],!n))break r;if(r=r<<16|f<<24|k<<8|n,(r|0)<=1751479906){if(e=r-1751476579|0,e>>>0>21|!(1<<e&2163713))break f;return 19734}if((r|0)<=1781689192){if(e=r-1751479907|0,e>>>0<=21)break l;break A}u:{s:switch(r-1835623985|0){default:if((r|0)==1781689193)break u;if((r|0)!=1836279345)break r;return 16756;case 1:break r;case 0:break t;case 2:break s}if(e>>>0<16||(e=u[A+12|0],!e)||(r=u[A+13|0],!r)||(f=u[A+14|0],!f)||(A=u[A+15|0],!A))break k;if(A=A|(r<<16|e<<24|f<<8),e=A-1751476579|0,e>>>0<=21)break o;break n}return 11361}if((e|0)<8)break i;e=u[A|0];break e}if(!(1<<e&2163713))break A;return 16776}if(!(1<<e&2163713))break n;return 19734}return 12412}if((A|0)!=1635150182)break k;return 12401}return 12412}if((r|0)!=1781688691)break r;return 5654}f:switch(r-1635148649|0){default:A:{if(e=r-1635150182|0,e){if((e|0)==13)break A;break r}return 12401}return 16736;case 0:return 11584;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:break r;case 10:break f}return 6520}if(e=u[A|0],(e|0)!=255)break e;if(u[A+1|0]!=216|u[A+2|0]!=255)break i;r:switch(u[A+3|0]-224|0){case 0:if(u[A+4|0]|u[A+5|0]!=16|(u[A+6|0]!=74|u[A+7|0]!=70)||(f|0)!=73|u[A+9|0]!=70|(u[A+10|0]|u[A+11|0]!=1))break i;return 12325;case 1:break r;default:break i}if(u[A+6|0]!=69|u[A+7|0]!=120|((f|0)!=105|u[A+9|0]!=102)||u[A+10|0]|u[A+11|0])break i;return 12325}if((e&255)!=137|u[A+1|0]!=80|(u[A+2|0]!=78|u[A+3|0]!=71)||u[A+4|0]!=13|u[A+5|0]!=10|(u[A+6|0]!=26|u[A+7|0]!=10))break i;return 12e3}return 47881}function yg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;for(A=v-272|0,v=A,i[A+264>>2]=r,i[A+268>>2]=e,F5(A+208|0,f,A+224|0,A+223|0,A+222|0),r=v-16|0,v=r,e=A+196|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+192>>2]=r,i[A+28>>2]=A+32,i[A+24>>2]=0,t[A+23|0]=1,t[A+22|0]=69,f=0;;){i:{e:{r:{f:{if(d2(A+268|0,A+264|0))break f;l=i[A+192>>2],u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,(l|0)==(o+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,F2(e,o<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),o=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+192>>2]=o+r),o=i[A+268>>2],l=i[o+12>>2];A:{if((l|0)==i[o+16>>2]){o=W[i[i[o>>2]+36>>2]](o)|0;break A}o=t[l|0]}if(xA(o<<24>>24,A+23|0,A+22|0,r,A+192|0,t[A+223|0],t[A+222|0],A+208|0,A+32|0,A+28|0,A+24|0,A+224|0))break f;if(f)break r;if(f=0,l=i[A+192>>2]-r|0,(l|0)<=0)break e;A:{k:switch(o=u[r|0],s=o-43|0,s|0){case 0:case 2:break A;default:break k}if((o|0)==46)break r;if(f=1,(o-48&255)>>>0<10)break e;break f}if((l|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(o=u[r+1|0],(o|0)==46)break r;if(f=1,(o-48&255)>>>0<=9)break e}u[A+219|0]>>>7|0?f=i[A+212>>2]:f=u[A+219|0]&127;f:{if(!f|!(t[A+23|0]&1)||(f=i[A+28>>2],(f-(A+32|0)|0)>159))break f;i[A+28>>2]=f+4,i[f>>2]=i[A+24>>2]}$t(A,r,i[A+192>>2],k),r=i[A>>2],f=i[A+4>>2],o=i[A+12>>2],i[n+8>>2]=i[A+8>>2],i[n+12>>2]=o,i[n>>2]=r,i[n+4>>2]=f,G4(A+208|0,A+32|0,i[A+28>>2],k),d2(A+268|0,A+264|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+268>>2],_2(e),_2(A+208|0),v=A+272|0;break i}f=1}A4(A+268|0);continue}break}return r|0}function Eg(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0;for(Q=v-16|0,v=Q,h=r;;){i:{if((f|0)==(h|0)){h=f;break i}if(!u[h|0])break i;h=h+1|0;continue}break}i[l>>2]=n,i[k>>2]=r;i:for(;;){e:{r:{f:{if((r|0)==(f|0)|(n|0)==(o|0))break f;s=i[e+4>>2],i[Q+8>>2]=i[e>>2],i[Q+12>>2]=s,V=v-16|0,v=V,i[V+12>>2]=i[A+8>>2],R=C8(V+8|0,V+12|0),G=h-r|0,_=0,m=v-1040|0,v=m,s=i[k>>2],i[m+12>>2]=s,I=n||m+16|0,B=n?o-n>>2:256;A:{k:{n:{if(!(!s|!B)){for(;;){if(w=G>>>2|0,!(G>>>0>131|w>>>0>=B>>>0)){w=s;break k}if(Y=Sn(I,m+12|0,w>>>0<B>>>0?w:B,e),w=i[m+12>>2],(Y|0)==-1){B=0,_=-1;break n}if(E=(m+16|0)!=(I|0)?Y:0,B=B-E|0,I=(E<<2)+I|0,G=w?(s+G|0)-w|0:0,_=_+Y|0,!w)break n;if(s=w,!B)break}break n}w=s}if(!w)break A}if(!B|!G)break A;for(s=_;;){k:{_=ze(I,w,G,e);n:{if(_+2>>>0<=2){t:switch(_+1|0){case 1:i[m+12>>2]=0;break n;case 0:break A;default:break t}i[e>>2]=0;break n}if(w=i[m+12>>2]+_|0,i[m+12>>2]=w,s=s+1|0,B=B-1|0,B)break k}_=s;break A}if(I=I+4|0,G=G-_|0,_=s,!G)break}}n&&(i[k>>2]=i[m+12>>2]),v=m+1040|0,s=i[R>>2],s&&(i[33178]=(s|0)==-1?132592:s),v=V+16|0;A:{k:{n:{t:{if((_|0)==-1)for(;;){if(i[l>>2]=n,i[k>>2]==(r|0))break f;o=1;o:{l:{u:switch(e=Bs(n,r,h-r|0,Q+8|0,i[A+8>>2]),e+2|0){case 0:break k;case 1:break u;case 2:break o;default:break l}i[k>>2]=r;break t}o=e}r=r+o|0,n=i[l>>2]+4|0}if(n=i[l>>2]+(_<<2)|0,i[l>>2]=n,(n|0)==(o|0))break A;if(r=i[k>>2],(f|0)==(h|0))break e;if(!Bs(n,r,1,e,i[A+8>>2]))break n}A=2;break r}for(n=i[l>>2]+4|0,i[l>>2]=n,r=i[k>>2]+1|0,i[k>>2]=r,h=r;;){if((f|0)==(h|0))break e;if(!u[h|0])continue i;h=h+1|0}}i[k>>2]=r,A=1;break r}r=i[k>>2]}A=(r|0)!=(f|0)}return v=Q+16|0,A|0}h=f}}function c0(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,n=i[e>>2];i:{e:{r:{f:{A:{if(r){if(!n){k=54203,i[r+12>>2]=54203,r=0;break e}i[f+104>>2]=0,i[f+76>>2]=78164,i[f+20>>2]=78144,n=i[19545],i[f+12>>2]=n,k=i[n-12>>2],o=f+12|0,n=o,i[k+n>>2]=i[19546],i[f+16>>2]=0,n=n+i[i[f+12>>2]-12>>2]|0,l=f+24|0,J0(n,l),t[n+80|0]=0,i[n+72>>2]=0,n=i[19547],i[f+20>>2]=n,k=i[n-12>>2],n=f+20|0,i[k+n>>2]=i[19548],k=i[19544],i[f+12>>2]=k,i[o+i[k-12>>2]>>2]=i[19549],i[f+76>>2]=78164,i[f+12>>2]=78124,i[f+20>>2]=78144,s=R0(l),i[s>>2]=77200,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=24,k=i[e>>2],k>>>0>13?k=7186:k=i[(k<<2)+100596>>2],o=F(F(n,k,l2(k)),37807,2),k=ln(i[e+4>>2]),F(o,k,l2(k)),k=t[e+19|0],((k|0)<0?i[e+12>>2]:k)&&(o=F(n,37807,2),k=t[e+19|0],n=(k|0)<0,F(o,n?i[e+8>>2]:e+8|0,n?i[e+12>>2]:k)),n=i[f+72>>2];k:{if(n&16){k=i[f+68>>2],n=i[f+48>>2],k>>>0<n>>>0&&(i[f+68>>2]=n,k=n),n=f+44|0;break k}if(!(n&8)){k=0,t[f+11|0]=0,n=f;break r}k=i[f+40>>2],n=f+32|0}if(o=i[n>>2],k=k-o|0,k>>>0>=2147483640)break A;if(k>>>0>=11){l=k|7,n=C(l+1|0),i[f+8>>2]=l-2147483647,i[f>>2]=n,i[f+4>>2]=k;break f}if(t[f+11|0]=k,n=f,k)break f;k=0;break r}i[A>>2]=n,i[A+4>>2]=i[e+4>>2],k=i[25148];break i}I0(),M()}if(!k)break r;z(n,o,k)}t[k+n|0]=0;r:{if((r|0)==(f|0))break r;if(k=t[f+11|0],t[r+11|0]>=0){if((k|0)>=0){n=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=n,i[r+8>>2]=i[f+8>>2];break r}m1(r,i[f>>2],i[f+4>>2]);break r}n=(k|0)<0,R1(r,n?i[f>>2]:f,n?i[f+4>>2]:k)}i[r+12>>2]=t[r+11|0]<0?i[r>>2]:r,t[f+11|0]<0&&Z(i[f>>2]),n=i[19543],i[f+12>>2]=n,i[i[n-12>>2]+(f+12|0)>>2]=i[19551],i[f+20>>2]=i[19552],i[s>>2]=77200,t[f+67|0]<0&&Z(i[f+56>>2]),y0(s),Y0(f+76|0),k=i[r+12>>2],r=i[e>>2]}i[A>>2]=r,i[A+4>>2]=i[e+4>>2]}i[A+8>>2]=k,v=f+160|0}function Rg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;for(A=v-368|0,v=A,i[A+360>>2]=r,i[A+364>>2]=e,p5(A+220|0,f,A+240|0,A+236|0,A+232|0),r=v-16|0,v=r,e=A+208|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+204>>2]=r,i[A+28>>2]=A+32,i[A+24>>2]=0,t[A+23|0]=1,t[A+22|0]=69,f=0;;){i:{e:{r:{f:{if(b2(A+364|0,A+360|0))break f;l=i[A+204>>2],u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,(l|0)==(o+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,F2(e,o<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),o=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+204>>2]=o+r),o=i[A+364>>2],l=i[o+12>>2];A:{if((l|0)==i[o+16>>2]){o=W[i[i[o>>2]+36>>2]](o)|0;break A}o=i[l>>2]}if(zA(o,A+23|0,A+22|0,r,A+204|0,i[A+236>>2],i[A+232>>2],A+220|0,A+32|0,A+28|0,A+24|0,A+240|0))break f;if(f)break r;if(f=0,l=i[A+204>>2]-r|0,(l|0)<=0)break e;A:{k:switch(o=u[r|0],s=o-43|0,s|0){case 0:case 2:break A;default:break k}if((o|0)==46)break r;if(f=1,(o-48&255)>>>0<10)break e;break f}if((l|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(o=u[r+1|0],(o|0)==46)break r;if(f=1,(o-48&255)>>>0<=9)break e}u[A+231|0]>>>7|0?f=i[A+224>>2]:f=u[A+231|0]&127;f:{if(!f|!(t[A+23|0]&1)||(f=i[A+28>>2],(f-(A+32|0)|0)>159))break f;i[A+28>>2]=f+4,i[f>>2]=i[A+24>>2]}$t(A,r,i[A+204>>2],k),r=i[A>>2],f=i[A+4>>2],o=i[A+12>>2],i[n+8>>2]=i[A+8>>2],i[n+12>>2]=o,i[n>>2]=r,i[n+4>>2]=f,G4(A+220|0,A+32|0,i[A+28>>2],k),b2(A+364|0,A+360|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+364>>2],_2(e),_2(A+220|0),v=A+368|0;break i}f=1}k4(A+364|0);continue}break}return r|0}function bn(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0;if(!((k|0)<=0)){i:{if(n=i[A+8>>2],l=i[A+4>>2],n-l>>3>=(k|0)){if(n=l-e|0,s=n>>3,(s|0)>=(k|0)){h=(k<<3)+r|0,n=l;break i}h=r+n|0;e:{if((h|0)==(f|0)){n=l;break e}for(o=h,n=l;i[n>>2]=i[o>>2],w=i[o+4>>2],i[n+4>>2]=w,w&&(i[w+4>>2]=i[w+4>>2]+1),n=n+8|0,o=o+8|0,(o|0)!=(f|0););}if(i[A+4>>2]=n,(s|0)>0)break i;return}e:{if(h=i[A>>2],l=(l-h>>3)+k|0,l>>>0<536870912){if(n=n-h|0,f=n>>2,s=n>>>0>=2147483640?536870911:f>>>0>l>>>0?f:l,s){if(s>>>0>=536870912)break e;f=C(s<<3)}else f=0;if(o=k<<3,l=f+(e-h|0)|0,k&1?(i[l>>2]=i[r>>2],n=i[r+4>>2],i[l+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),r=r+8|0,n=l+8|0):n=l,o=o+l|0,(k&536870911)!=1)for(;i[n>>2]=i[r>>2],k=i[r+4>>2],i[n+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),i[n+8>>2]=i[r+8>>2],k=i[r+12>>2],i[n+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+16|0,n=n+16|0,(o|0)!=(n|0););k=i[A+4>>2]-e|0,k&&z(o,e,k),i[A+4>>2]=e,n=i[A>>2],r=e-n|0,e=l-r|0,r&&z(e,n,r),i[A+4>>2]=k+o,i[A>>2]=e,i[A+8>>2]=f+(s<<3),n&&Z(n);return}s0(),M()}x0(),M()}if(f=k<<3,s=f+e|0,k=n,o=n-f|0,l>>>0>o>>>0)for(f=o;i[k>>2]=i[f>>2],i[k+4>>2]=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,k=k+8|0,f=f+8|0,l>>>0>f>>>0;);if(i[A+4>>2]=k,(n|0)!=(s|0))for(;;){o=o-8|0,f=i[o>>2],A=i[o+4>>2],i[o>>2]=0,i[o+4>>2]=0,k=i[n-4>>2],n=n-8|0,i[n>>2]=f,i[n+4>>2]=A;i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}if((e|0)==(o|0))break}if((r|0)!=(h|0))for(n=e;;){A=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[n>>2]=A,f=i[n+4>>2],i[n+4>>2]=e;i:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}if(n=n+8|0,r=r+8|0,(h|0)==(r|0))break}}}function Jg(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0,_=0,B=0,m=0,G=0,I=0;w=v-32|0,v=w;i:{e:{r:{if(!(!e|!n)&&(B=(f|0)!=1970628964,k|B))break r;e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break e}h=C(128),i[h+4>>2]=0,i[h+8>>2]=0,i[h>>2]=98788,G=h+16|0,_=G,i[_+8>>2]=0,i[_+12>>2]=0,i[_+16>>2]=0,i[_+20>>2]=0,i[_+24>>2]=0,i[_+28>>2]=0,i[_+32>>2]=0,i[_>>2]=92500,i[h+60>>2]=0,i[h+64>>2]=0,i[h+52>>2]=0,i[h+56>>2]=0,i[h+72>>2]=-1,i[h+76>>2]=-1,i[h+80>>2]=-1,i[h+84>>2]=-1,i[h+88>>2]=0,i[h+92>>2]=0,i[h+96>>2]=0,i[h+100>>2]=0,i[h+104>>2]=0,i[h+108>>2]=0,t[h+112|0]=0,i[_>>2]=92936,i[h+124>>2]=0,i[h+116>>2]=0,i[h+120>>2]=0,i[h+32>>2]=f;r:{if(B||(f=C(16),i[w+20>>2]=f,I=f+16|0,i[w+28>>2]=I,_=u[k+12|0]|u[k+13|0]<<8|(u[k+14|0]<<16|u[k+15|0]<<24),B=u[k+8|0]|u[k+9|0]<<8|(u[k+10|0]<<16|u[k+11|0]<<24),t[f+8|0]=B,t[f+9|0]=B>>>8,t[f+10|0]=B>>>16,t[f+11|0]=B>>>24,t[f+12|0]=_,t[f+13|0]=_>>>8,t[f+14|0]=_>>>16,t[f+15|0]=_>>>24,_=u[k+4|0]|u[k+5|0]<<8|(u[k+6|0]<<16|u[k+7|0]<<24),k=u[k|0]|u[k+1|0]<<8|(u[k+2|0]<<16|u[k+3|0]<<24),t[f|0]=k,t[f+1|0]=k>>>8,t[f+2|0]=k>>>16,t[f+3|0]=k>>>24,t[f+4|0]=_,t[f+5|0]=_>>>8,t[f+6|0]=_>>>16,t[f+7|0]=_>>>24,i[w+24>>2]=I,js(G,w+20|0),f=i[w+20>>2],!f))break r;i[w+24>>2]=f,Z(f)}if(i[w+28>>2]=0,i[w+20>>2]=0,i[w+24>>2]=0,f=0,o){if((o|0)<0)break i;f=C(o),i[w+20>>2]=f,m=f+o|0,i[w+28>>2]=m,o&&z(f,n,o),i[w+24>>2]=m}if($4(h+116|0,f,m,m-f|0),e=i[e>>2],i[w+16>>2]=h,i[w+12>>2]=G,i[h+4>>2]=i[h+4>>2]+1,k=i[w+16>>2],i[w>>2]=i[w+12>>2],i[w+4>>2]=k,e=Ei(e,r,w,(l|0)!=0),s&&(i[s>>2]=e),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],f&&Z(f),A=i[h+4>>2],i[h+4>>2]=A-1,A)break e;W[i[i[h>>2]+8>>2]](h),y(h)}v=w+32|0;return}s0(),M()}function Ng(A,e,r,f,k,n,o,l,s,h,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0,h=h|0,w=w|0;var _=0,B=0;_=v+-64|0,v=_;i:{if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!(f|!r)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!(o|!n)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!(s|!l)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!(w|!h)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}i[_+32>>2]=0,i[_+36>>2]=0,i[_+40>>2]=0,i[_+44>>2]=0,B=_+48|0,i[B>>2]=0,i[B+4>>2]=0,i[_+56>>2]=0,t[_+13|0]=0,t[_+14|0]=0,t[_+15|0]=0,t[_+16|0]=0,t[_+17|0]=0,t[_+18|0]=0,t[_+19|0]=0,t[_+20|0]=0,i[_+8>>2]=0,i[_+12>>2]=0,i[_+24>>2]=0,i[_+28>>2]=0,h1(_+8|0,f,(r<<2)+f|0,r),t[_+20|0]=(k|0)!=0,h1(_+24|0,o,(n<<2)+o|0,n),h1(_+36|0,s,(l<<2)+s|0,l),f=i[B>>2],r=i[_+52>>2]-f>>3;e:{r:{if(r>>>0<h>>>0){fi(B,h-r|0);break r}if(r>>>0>h>>>0&&(i[_+52>>2]=f+(h<<3)),!h)break e}if(n=h&3,o=0,f=i[_+48>>2],r=0,h-1>>>0>=3)for(l=h&-4,h=0;k=r<<3,s=k+f|0,B=k+w|0,i[s>>2]=i[B>>2],i[s+4>>2]=i[B+4>>2],s=k|8,B=s+f|0,s=s+w|0,i[B>>2]=i[s>>2],i[B+4>>2]=i[s+4>>2],s=k|16,B=s+f|0,s=s+w|0,i[B>>2]=i[s>>2],i[B+4>>2]=i[s+4>>2],k=k|24,s=k+f|0,k=k+w|0,i[s>>2]=i[k>>2],i[s+4>>2]=i[k+4>>2],r=r+4|0,h=h+4|0,(l|0)!=(h|0););if(!n)break e;for(;k=r<<3,l=k+f|0,k=k+w|0,i[l>>2]=i[k>>2],i[l+4>>2]=i[k+4>>2],r=r+1|0,o=o+1|0,(n|0)!=(o|0););}if(e=i[e>>2],W[i[i[e>>2]+56>>2]](e,_+8|0),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,A=i[_+48>>2],A&&(i[_+52>>2]=A,Z(A)),A=i[_+36>>2],A&&(i[_+40>>2]=A,Z(A)),A=i[_+24>>2],A&&(i[_+28>>2]=A,Z(A)),A=i[_+8>>2],!A)break i;i[_+12>>2]=A,Z(A)}v=_- -64|0}function K4(A,e,r,f,k,n){var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;s=v-32|0,v=s,o=i[r>>2],h=i[o+208>>2],o=i[o+204>>2],l=o;i:{e:{for(;;){if(i[l>>2]==(f|0))break e;if(l=l+56|0,(h|0)==(l|0))break}B=0;break i}B=i[l+24>>2]}l=o;i:{e:{for(;;){if(i[l>>2]==(f|0))break e;if(l=l+56|0,(h|0)==(l|0))break}_=0;break i}_=i[l+28>>2]}l=o;i:{for(;;){if(i[l>>2]==(f|0))break i;if(l=l+56|0,(h|0)==(l|0))break}l=0}w=s+8|0;i:{e:{for(;;){if(i[o>>2]==(f|0))break e;if(o=o+56|0,(h|0)==(o|0))break}o=0;break i}o=p[o+20>>1]}a0(w,e,k,B,_,o,n,i[l+16>>2]);i:{if(i[s+8>>2]){e=i[s+12>>2],i[A>>2]=i[s+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[s+24>>2],e=i[s+20>>2],i[A+8>>2]=i[s+16>>2],i[A+12>>2]=e,i[s+24>>2]=0,i[s+16>>2]=0,i[s+20>>2]=0;break i}n=0;e:{r:{if(o=i[r>>2],r=i[o+204>>2],m=i[o+208>>2],G=(r|0)==(m|0),G)break r;for(o=r;;){if(i[o>>2]!=(f|0)){if(o=o+56|0,(m|0)!=(o|0))continue;break r}break}h=i[o+52>>2],l=i[o+40>>2];break e}h=0,l=0}o=i[e+204>>2],e=i[e+208>>2],w=0;e:{if((o|0)==(e|0))break e;r:{for(;;){if(i[o>>2]==(k|0))break r;if(o=o+56|0,(e|0)==(o|0))break}w=0;break e}n=i[o+52>>2],w=i[o+40>>2]}o=0;e:{if(G)break e;for(;;){if(i[r>>2]!=(f|0)){if(r=r+56|0,(m|0)!=(r|0))continue;break e}break}o=u[r+23|0]&31}e:{if(!_)break e;if(e=g(o,B),f=0,(_|0)!=1)for(r=_&-2,o=0;k=!e,k||z(w+g(f,n)|0,g(f,h)+l|0,e),k||(k=f|1,z(w+g(k,n)|0,g(k,h)+l|0,e)),f=f+2|0,o=o+2|0,(r|0)!=(o|0););if(!(_&1)|!e)break e;z(w+g(f,n)|0,g(f,h)+l|0,e)}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}t[s+27|0]<0&&Z(i[s+16>>2]),v=s+32|0}function Dg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=D(0);for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,F5(A+192|0,f,A+208|0,A+207|0,A+206|0),r=v-16|0,v=r,e=A+180|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,t[A+7|0]=1,t[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(d2(A+252|0,A+248|0))break f;l=i[A+176>>2],u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,(l|0)==(o+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,F2(e,o<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),o=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=o+r),o=i[A+252>>2],l=i[o+12>>2];A:{if((l|0)==i[o+16>>2]){o=W[i[i[o>>2]+36>>2]](o)|0;break A}o=t[l|0]}if(xA(o<<24>>24,A+7|0,A+6|0,r,A+176|0,t[A+207|0],t[A+206|0],A+192|0,A+16|0,A+12|0,A+8|0,A+208|0))break f;if(f)break r;if(f=0,l=i[A+176>>2]-r|0,(l|0)<=0)break e;A:{k:switch(o=u[r|0],s=o-43|0,s|0){case 0:case 2:break A;default:break k}if((o|0)==46)break r;if(f=1,(o-48&255)>>>0<10)break e;break f}if((l|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(o=u[r+1|0],(o|0)==46)break r;if(f=1,(o-48&255)>>>0<=9)break e}u[A+203|0]>>>7|0?f=i[A+196>>2]:f=u[A+203|0]&127;f:{if(!f|!(t[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}h=n,w=xl(r,i[A+176>>2],k),E0[h>>2]=w,G4(A+192|0,A+16|0,i[A+12>>2],k),d2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],_2(e),_2(A+192|0),v=A+256|0;break i}f=1}A4(A+252|0);continue}break}return r|0}function Ug(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(M2(F(k,34322,15),i[e+112>>2],i[e+116>>2]),47878,1),n=f+148|0,k0(n,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(D0(F(k,36162,23),u[e+120|0]),47878,1),n=f+148|0,k0(n,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(D0(F(k,36311,30),u[e+121|0]),47878,1),n=f+148|0,k0(n,r),o=k,r=t[f+159|0],k=(r|0)<0,F(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(f+8|0,37265,23),u[e+122|0]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function Mg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,F5(A+192|0,f,A+208|0,A+207|0,A+206|0),r=v-16|0,v=r,e=A+180|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,t[A+7|0]=1,t[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(d2(A+252|0,A+248|0))break f;l=i[A+176>>2],u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,(l|0)==(o+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,F2(e,o<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),o=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=o+r),o=i[A+252>>2],l=i[o+12>>2];A:{if((l|0)==i[o+16>>2]){o=W[i[i[o>>2]+36>>2]](o)|0;break A}o=t[l|0]}if(xA(o<<24>>24,A+7|0,A+6|0,r,A+176|0,t[A+207|0],t[A+206|0],A+192|0,A+16|0,A+12|0,A+8|0,A+208|0))break f;if(f)break r;if(f=0,l=i[A+176>>2]-r|0,(l|0)<=0)break e;A:{k:switch(o=u[r|0],s=o-43|0,s|0){case 0:case 2:break A;default:break k}if((o|0)==46)break r;if(f=1,(o-48&255)>>>0<10)break e;break f}if((l|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(o=u[r+1|0],(o|0)==46)break r;if(f=1,(o-48&255)>>>0<=9)break e}u[A+203|0]>>>7|0?f=i[A+196>>2]:f=u[A+203|0]&127;f:{if(!f|!(t[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}h=n,w=Sl(r,i[A+176>>2],k),u0[h>>3]=w,G4(A+192|0,A+16|0,i[A+12>>2],k),d2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],_2(e),_2(A+192|0),v=A+256|0;break i}f=1}A4(A+252|0);continue}break}return r|0}function Hg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=D(0);for(A=v-352|0,v=A,i[A+344>>2]=r,i[A+348>>2]=e,p5(A+204|0,f,A+224|0,A+220|0,A+216|0),r=v-16|0,v=r,e=A+192|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,t[A+7|0]=1,t[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(b2(A+348|0,A+344|0))break f;l=i[A+188>>2],u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,(l|0)==(o+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,F2(e,o<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),o=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=o+r),o=i[A+348>>2],l=i[o+12>>2];A:{if((l|0)==i[o+16>>2]){o=W[i[i[o>>2]+36>>2]](o)|0;break A}o=i[l>>2]}if(zA(o,A+7|0,A+6|0,r,A+188|0,i[A+220>>2],i[A+216>>2],A+204|0,A+16|0,A+12|0,A+8|0,A+224|0))break f;if(f)break r;if(f=0,l=i[A+188>>2]-r|0,(l|0)<=0)break e;A:{k:switch(o=u[r|0],s=o-43|0,s|0){case 0:case 2:break A;default:break k}if((o|0)==46)break r;if(f=1,(o-48&255)>>>0<10)break e;break f}if((l|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(o=u[r+1|0],(o|0)==46)break r;if(f=1,(o-48&255)>>>0<=9)break e}u[A+215|0]>>>7|0?f=i[A+208>>2]:f=u[A+215|0]&127;f:{if(!f|!(t[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}h=n,w=xl(r,i[A+188>>2],k),E0[h>>2]=w,G4(A+204|0,A+16|0,i[A+12>>2],k),b2(A+348|0,A+344|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+348>>2],_2(e),_2(A+204|0),v=A+352|0;break i}f=1}k4(A+348|0);continue}break}return r|0}function C1(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;if(n=v-16|0,v=n,i[A+4>>2]=i[A+4>>2]+1,r=v-16|0,v=r,i[r+12>>2]=A,i[n+12>>2]=i[r+12>>2],v=r+16|0,r=i[34208],i[34209]-r>>2>>>0<=e>>>0)i:{if(A=e+1|0,f=i[34209],r=f-r>>2,A>>>0>r>>>0){s=v-32|0,v=s,o=A-r|0;e:{if(o>>>0<=i[34210]-f>>2>>>0){Yu(o);break e}f=s+12|0,r=v-16|0,v=r,k=o+(i[34209]-i[34208]>>2)|0,i[r+12>>2]=k;r:{if(A=ks(),k>>>0<=A>>>0){k=i[34210]-i[34208]>>2,k>>>0<A>>>1>>>0&&(i[r+8>>2]=k<<1,A=v-16|0,v=A,v=A+16|0,A=r+12|0,k=r+8|0,A=i[(o0[k>>2]<o0[A>>2]?A:k)>>2]),v=r+16|0,r=A;break r}I4(),M()}for(l=i[34209]-i[34208]>>2,A=0,k=v-16|0,v=k,i[k+12>>2]=0,i[f+12>>2]=0,i[f+16>>2]=136844,r?(Qs(k+4|0,i[f+16>>2],r),A=i[k+4>>2],r=i[k+8>>2]):r=0,i[f>>2]=A,l=(l<<2)+A|0,i[f+8>>2]=l,i[f+4>>2]=l,i[f+12>>2]=(r<<2)+A,v=k+16|0,r=v-16|0,v=r,A=i[f+8>>2],i[r+12>>2]=f+8,i[r+4>>2]=A,i[r+8>>2]=A+(o<<2),A=i[r+4>>2];;){if(i[r+8>>2]!=(A|0)){i[i[r+4>>2]>>2]=0,A=i[r+4>>2]+4|0,i[r+4>>2]=A;continue}break}for(i[i[r+12>>2]>>2]=i[r+4>>2],v=r+16|0,A=i[34208],k=i[34209],r=i[f+4>>2]+(A-k|0)|0,k=k-A|0,k&&z(r,A,k),i[f+4>>2]=r,i[34209]=i[34208],A=i[34208],i[34208]=i[f+4>>2],i[f+4>>2]=A,A=i[34209],i[34209]=i[f+8>>2],i[f+8>>2]=A,A=i[34210],i[34210]=i[f+12>>2],i[f+12>>2]=A,i[f>>2]=i[f+4>>2],A=i[f+4>>2];;){if(r=i[f+8>>2],(r|0)!=(A|0)){i[f+8>>2]=r-4;continue}break}A=i[f>>2],A&&rh(i[f+16>>2],A)}v=s+32|0;break i}A>>>0<r>>>0&&fh(136832,i[34208]+(A<<2)|0)}A=i[i[34208]+(e<<2)>>2],A&&(r=i[A+4>>2]-1|0,i[A+4>>2]=r,(r|0)==-1&&W[i[i[A>>2]+8>>2]](A)),A=i[n+12>>2],i[n+12>>2]=0,i[i[34208]+(e<<2)>>2]=A,A=i[n+12>>2],i[n+12>>2]=0,A&&(e=i[A+4>>2]-1|0,i[A+4>>2]=e,(e|0)==-1&&W[i[i[A>>2]+8>>2]](A)),v=n+16|0}function zg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;for(A=v-352|0,v=A,i[A+344>>2]=r,i[A+348>>2]=e,p5(A+204|0,f,A+224|0,A+220|0,A+216|0),r=v-16|0,v=r,e=A+192|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,t[A+7|0]=1,t[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(b2(A+348|0,A+344|0))break f;l=i[A+188>>2],u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,(l|0)==(o+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?o=i[e+4>>2]:o=u[e+11|0]&127,F2(e,o<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),o=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=o+r),o=i[A+348>>2],l=i[o+12>>2];A:{if((l|0)==i[o+16>>2]){o=W[i[i[o>>2]+36>>2]](o)|0;break A}o=i[l>>2]}if(zA(o,A+7|0,A+6|0,r,A+188|0,i[A+220>>2],i[A+216>>2],A+204|0,A+16|0,A+12|0,A+8|0,A+224|0))break f;if(f)break r;if(f=0,l=i[A+188>>2]-r|0,(l|0)<=0)break e;A:{k:switch(o=u[r|0],s=o-43|0,s|0){case 0:case 2:break A;default:break k}if((o|0)==46)break r;if(f=1,(o-48&255)>>>0<10)break e;break f}if((l|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(o=u[r+1|0],(o|0)==46)break r;if(f=1,(o-48&255)>>>0<=9)break e}u[A+215|0]>>>7|0?f=i[A+208>>2]:f=u[A+215|0]&127;f:{if(!f|!(t[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}h=n,w=Sl(r,i[A+188>>2],k),u0[h>>3]=w,G4(A+204|0,A+16|0,i[A+12>>2],k),b2(A+348|0,A+344|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+348>>2],_2(e),_2(A+204|0),v=A+352|0;break i}f=1}k4(A+348|0);continue}break}return r|0}function xg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,K1(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,33282,14),i[e+108>>2]),47878,1);i:{if(!i[e+104>>2]){if(i[e+116>>2]==i[e+112>>2])break i;for(k=0;n=f+148|0,k0(n,r),l=n,n=t[f+159|0],s=(n|0)<0,F(f+8|0,s?i[f+148>>2]:l,s?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(B0(F(f+8|0,20885,1),k),37800,4),i[i[e+112>>2]+(k<<2)>>2]),47878,1),k=k+1|0,k>>>0<i[e+116>>2]-i[e+112>>2]>>2>>>0;);break i}k=f+148|0,k0(k,r),n=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,35953,19),i[e+104>>2]),47878,1)}e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,t[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(t[A+11|0]=k,k)break e;k=0;break i}I0(),M()}if(!k)break i;z(A,r,k)}t[A+k|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function a0(A,e,r,f,k,n,o,l){var s=0,h=0,w=0,_=0;s=v-80|0,v=s,h=i[e+200>>2],X[s+44>>1]=0,i[s+36>>2]=0,i[s+40>>2]=0,t[s+55|0]=0,t[s+56|0]=0,t[s+57|0]=0,t[s+58|0]=0,t[s+59|0]=0,t[s+60|0]=0,t[s+61|0]=0,t[s+62|0]=0,t[s+63|0]=0,t[s+64|0]=0,t[s+65|0]=0,t[s+66|0]=0,t[s+67|0]=0,t[s+68|0]=0,t[s+69|0]=0,t[s+70|0]=0,t[s+71|0]=0,t[s+72|0]=0,t[s+73|0]=0,t[s+74|0]=0,t[s+75|0]=0,t[s+76|0]=0,t[s+77|0]=0,t[s+78|0]=0,t[s+79|0]=0,i[s+28>>2]=0,i[s+32>>2]=0,t[s+47|0]=0,t[s+48|0]=0,t[s+49|0]=0,t[s+50|0]=0,t[s+51|0]=0,t[s+52|0]=0,t[s+53|0]=0,t[s+54|0]=0,t[s+46|0]=1,i[s+24>>2]=r,w=s+24|0,_=f,f=(n|0)==24&&(h|0)==10?8:n,n=(h|0)==11&&(f|0)==32?8:f,f=1;i:{e:switch(h|0){case 10:case 12:case 14:f=3;break i;case 11:case 13:case 15:f=4;break i;case 0:case 1:case 2:case 3:case 99:break i;default:break e}f=0}O6(A,w,_,k,l,n,f,o,e+216|0);i:{if(i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),f=s+12|0,kt(f,r,i[e+200>>2]),nt(e,s+24|0,f),r=i[s+12>>2],r&&(i[s+16>>2]=r,Z(r)),r=i[e+208>>2];e:{if(r>>>0<o0[e+212>>2]){f=i[s+24>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=f,i[r+4>>2]=i[s+28>>2],i[r+8>>2]=i[s+32>>2],i[r+12>>2]=i[s+36>>2],i[s+36>>2]=0,i[s+28>>2]=0,i[s+32>>2]=0,f=i[s+76>>2],i[r+48>>2]=i[s+72>>2],i[r+52>>2]=f,f=s- -64|0,k=i[f+4>>2],i[r+40>>2]=i[f>>2],i[r+44>>2]=k,f=i[s+60>>2],i[r+32>>2]=i[s+56>>2],i[r+36>>2]=f,f=i[s+52>>2],i[r+24>>2]=i[s+48>>2],i[r+28>>2]=f,f=i[s+44>>2],i[r+16>>2]=i[s+40>>2],i[r+20>>2]=f,r=r+56|0;break e}r=l3(e+204|0,s+24|0)}if(i[e+208>>2]=r,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}A=i[s+28>>2],A&&(i[s+32>>2]=A,Z(A)),v=s+80|0}function Tg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;k=v-48|0,v=k,i[k+44>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0;i:{if(!A){A=i[14505],i[k+24>>2]=i[14504],i[k+28>>2]=A,A=i[14503],i[k+16>>2]=i[14502],i[k+20>>2]=A,A=i[14501],i[k+8>>2]=i[14500],i[k+12>>2]=A,h1(k+36|0,k+8|0,k+32|0,6);break i}n=C(4),i[n>>2]=A,A=n+4|0,i[k+44>>2]=A,i[k+36>>2]=n,i[k+40>>2]=A}Zr();i:{if(n=i[28738],(n|0)==114956|i[k+36>>2]==i[k+40>>2])break i;e:{for(;;){r:{A=i[k+36>>2],f=i[k+40>>2];f:{if((A|0)==(f|0))break f;for(w=i[n+16>>2];;){if(_=W[i[w+16>>2]](i[A>>2])|0,!_){if(A=A+4|0,(f|0)!=(A|0))continue;break f}break}if(l>>>0<o>>>0){i[l+4>>2]=_,i[l>>2]=w,l=l+8|0;break f}if(A=l-s|0,B=A>>3,f=B+1|0,f>>>0>=536870912)break r;if(o=o-s|0,l=o>>2,h=o>>>0>=2147483640?536870911:f>>>0<l>>>0?l:f,h){if(h>>>0>=536870912)break e;o=C(h<<3)}else o=0;l=A+o|0,i[l+4>>2]=_,i[l>>2]=w,f=l-(B<<3)|0,A&&z(f,s,A),l=l+8|0,o=(h<<3)+o|0,s&&Z(s),s=f}f=i[n+4>>2];f:{if(f){for(;;)if(A=f,f=i[A>>2],!f)break f}for(;A=i[n+8>>2],f=i[A>>2]!=(n|0),n=A,!!f;);}if(n=A,(A|0)!=114956)continue;break i}break}m7(6870),M()}x0(),M()}n=l-s>>3;i:{if(!e||(A=0,U9(s,l,(l|0)!=(s|0)?62-(_1(n)<<1)|0:0,1),n=(r|0)>(n|0)?n:r,(n|0)<=0))break i;if(n>>>0>=4)for(r=n&2147483644,f=0;i[(A<<2)+e>>2]=i[(A<<3)+s>>2],o=A|1,i[(o<<2)+e>>2]=i[(o<<3)+s>>2],o=A|2,i[(o<<2)+e>>2]=i[(o<<3)+s>>2],o=A|3,i[(o<<2)+e>>2]=i[(o<<3)+s>>2],A=A+4|0,f=f+4|0,(r|0)!=(f|0););if(r=n&3,!r)break i;for(f=0;i[(A<<2)+e>>2]=i[(A<<3)+s>>2],A=A+1|0,f=f+1|0,(r|0)!=(f|0););}return A=i[k+36>>2],A&&(i[k+40>>2]=A,Z(A)),s&&Z(s),v=k+48|0,n|0}function jg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;if(f=i[A+144>>2],f>>>0<o0[A+148>>2]){G=A,I=Ue(f,e)+48|0,i[G+144>>2]=I;return}m=A,o=v-32|0,v=o,l=A+140|0,s=i[l>>2];i:{e:{if(A=i[l+4>>2]-s|0,n=((A|0)/48|0)+1|0,n>>>0<89478486){if(k=l+8|0,f=i[k>>2],i[o+28>>2]=k,k=(f-s|0)/48|0,f=k<<1,h=k>>>0>=44739242?89478485:f>>>0>n>>>0?f:n,h){if(h>>>0>=89478486)break e;f=C(g(h,48))}else f=0;if(w=Ue(A+f|0,e),A=i[l>>2],e=A,k=i[l+4>>2],_=k,B=w+g((k-A|0)/-48|0,48)|0,r=B,(A|0)!=(k|0)){for(;i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,i[r>>2]=i[A>>2],i[r+4>>2]=i[A+4>>2],i[r+8>>2]=i[A+8>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,s=i[A+20>>2],n=i[A+12>>2],k=i[A+16>>2],i[r+32>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+20>>2]=s,i[r+12>>2]=n,i[r+16>>2]=k,i[r+24>>2]=i[A+24>>2],i[r+28>>2]=i[A+28>>2],i[r+32>>2]=i[A+32>>2],i[A+32>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[r+44>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+36>>2]=i[A+36>>2],i[r+40>>2]=i[A+40>>2],i[r+44>>2]=i[A+44>>2],i[A+44>>2]=0,i[A+36>>2]=0,i[A+40>>2]=0,r=r+48|0,A=A+48|0,(_|0)!=(A|0););for(;A=i[e+36>>2],A&&(i[e+40>>2]=A,Z(A)),A=i[e+24>>2],A&&(i[e+28>>2]=A,Z(A)),A=i[e>>2],A&&(i[e+4>>2]=A,Z(A)),e=e+48|0,(_|0)!=(e|0););}if(k=i[l>>2],i[l>>2]=B,i[o+16>>2]=k,e=w+48|0,i[l+4>>2]=e,i[o+20>>2]=k,A=i[l+8>>2],i[l+8>>2]=g(h,48)+f,i[o+12>>2]=k,i[o+24>>2]=A,A=i[o+20>>2],k=i[o+16>>2],(A|0)!=(k|0))for(;f=A-48|0,i[o+20>>2]=f,n=i[A-12>>2],n&&(i[A-8>>2]=n,Z(n)),n=i[A-24>>2],n&&(i[A-20>>2]=n,Z(n)),f=i[f>>2],f&&(i[A-44>>2]=f,Z(f)),A=i[o+20>>2],(k|0)!=(A|0););A=i[o+12>>2],A&&Z(A),v=o+32|0,A=e;break i}s0(),M()}x0(),M()}i[m+144>>2]=A}function Vi(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;k=v-32|0,v=k;i:{if(n=i[A>>2],o=i[A+4>>2]-n|0,l=(o>>5)+1|0,l>>>0<134217728){if(f=i[A+8>>2],i[k+28>>2]=A+8,n=f-n|0,f=n>>4,f=n>>>0>=2147483616?134217727:f>>>0>l>>>0?f:l,f){if(f>>>0>=134217728)break i;r=C(f<<5)}if(i[k+12>>2]=r,i[k+24>>2]=(f<<5)+r,f=r+o|0,i[k+16>>2]=f,r=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=r,r=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=r,i[f+24>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,r=i[e+16>>2],e=i[e+20>>2],b6(f+16|0,r,e,(e-r|0)/40|0),i[k+20>>2]=f+32,o=A,r=i[A>>2],l=i[A+4>>2],f=i[k+16>>2]+(r-l|0)|0,(r|0)!=(l|0)){for(e=r,A=f;n=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=n,n=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=n,i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+16>>2]=i[e+16>>2],i[A+20>>2]=i[e+20>>2],i[A+24>>2]=i[e+24>>2],i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,A=A+32|0,e=e+32|0,(l|0)!=(e|0););for(;;){if(n=i[r+16>>2],n){if(A=n,e=i[r+20>>2],(A|0)!=(e|0)){for(;A=i[e-16>>2],A&&(i[e-12>>2]=A,Z(A)),e=e-40|0,(n|0)!=(e|0););A=i[r+16>>2]}i[r+20>>2]=n,Z(A)}if(r=r+32|0,(l|0)==(r|0))break}r=i[o>>2]}if(i[k+16>>2]=f,i[o+4>>2]=r,i[o>>2]=i[k+16>>2],i[k+16>>2]=r,A=i[o+4>>2],i[o+4>>2]=i[k+20>>2],i[k+20>>2]=A,A=i[o+8>>2],i[o+8>>2]=i[k+24>>2],i[k+24>>2]=A,i[k+12>>2]=i[k+16>>2],l=i[o+4>>2],e=i[k+20>>2],f=i[k+16>>2],(e|0)!=(f|0))for(;;){if(A=e-32|0,i[k+20>>2]=A,o=e-16|0,n=i[o>>2],n){if(e=e-12|0,A=i[e>>2],r=n,(A|0)!=(r|0)){for(;r=i[A-16>>2],r&&(i[A-12>>2]=r,Z(r)),A=A-40|0,(n|0)!=(A|0););r=i[o>>2]}i[e>>2]=n,Z(r),A=i[k+20>>2]}if(e=A,(f|0)==(e|0))break}return A=i[k+12>>2],A&&Z(A),v=k+32|0,l}s0(),M()}x0(),M()}function Sg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+184>>2],f=i[e+188>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=Z0(k,92792,106196),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=C(96),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=103720,f&&(i[f+4>>2]=i[f+4>>2]+1),o=r+16|0,i[r+72>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+92>>2]=f,i[r+88>>2]=k,t[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+16>>2]=105620,!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),i[e+552>>2]=o,k=i[e+556>>2],i[e+556>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]<0)break r;e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}if(r=r+8|0,(f|0)==(r|0))break}if(e=C(24),i[n+4>>2]=e,i[n+8>>2]=18,i[n+12>>2]=-2147483624,r=u[28539]|u[28540]<<8|(u[28541]<<16|u[28542]<<24),f=u[28535]|u[28536]<<8|(u[28537]<<16|u[28538]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+18|0]=0,r=u[28551]|u[28552]<<8,t[e+16|0]=r,t[e+17|0]=r>>>8,r=u[28547]|u[28548]<<8|(u[28549]<<16|u[28550]<<24),f=u[28543]|u[28544]<<8|(u[28545]<<16|u[28546]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,0,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[28730],i[28731])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function Og(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=78468,n=i[19620],i[f+24>>2]=n,k=i[n-12>>2],n=f+24|0,i[k+n>>2]=i[19621],l=n+i[i[f+24>>2]-12>>2]|0,k=f+28|0,J0(l,k),t[l+80|0]=0,i[l+72>>2]=0,i[f+80>>2]=78468,i[f+24>>2]=78448,l=R0(k),i[l>>2]=77200,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,k=f+164|0,J2(k,e,r),s=n,o=k,n=t[f+175|0],k=(n|0)<0,F(s,k?i[f+164>>2]:o,k?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),n=f+164|0,k0(n,r),o=n,n=t[f+175|0],k=(n|0)<0,F(f+24|0,k?i[f+164>>2]:o,k?i[f+168>>2]:n),t[f+175|0]<0&&Z(i[f+164>>2]),n=F(B0(F(f+24|0,37210,13),i[e+104>>2]),47878,1),k=f+164|0,k0(k,r),o=k,k=t[f+175|0],s=(k|0)<0,F(n,s?i[f+164>>2]:o,s?i[f+168>>2]:k),t[f+175|0]<0&&Z(i[f+164>>2]),n=F(n,36387,14),k=f+12|0,z1(k,i[e+108>>2]),s=n,o=k,n=t[f+23|0],k=(n|0)<0,n=F(F(s,k?i[f+12>>2]:o,k?i[f+16>>2]:n),47878,1),k=f+164|0,k0(k,r),o=k,r=t[f+175|0],k=(r|0)<0,F(n,k?i[f+164>>2]:o,k?i[f+168>>2]:r),t[f+175|0]<0&&Z(i[f+164>>2]),k=F(n,36699,6),r=t[e+135|0],n=(r|0)<0,F(F(k,n?i[e+124>>2]:e+124|0,n?i[e+128>>2]:r),47878,1),t[f+23|0]<0&&Z(i[f+12>>2]),e=i[f+76>>2];i:{e:{if(e&16){e=i[f+72>>2],r=i[f+52>>2],e>>>0<r>>>0&&(i[f+72>>2]=r,e=r),r=f+48|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+44>>2],r=f+36|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,n,e)}t[A+e|0]=0,A=i[19619],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[19622],i[l>>2]=77200,t[f+71|0]<0&&Z(i[f+60>>2]),y0(l),Y0(f+80|0),v=f+176|0}function Pg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0;r=v-96|0,v=r;i:{f=i[e+72>>2],k=i[f+132>>2],n=i[f+136>>2];e:{if((k|0)!=(n|0))for(e=k;;){r:{if(u[e+1|0]!=33||(l=i[e+4>>2],(l|0)==i[e+8>>2]))break r;if(e=p[f+126>>1]|p[f+128>>1]<<16,o=p[f+122>>1]|p[f+124>>1]<<16,X[r+70>>1]=o,X[r+72>>1]=o>>>16,X[r+74>>1]=e,X[r+76>>1]=e>>>16,o=i[f+120>>2],e=r- -64|0,i[e>>2]=i[f+116>>2],i[e+4>>2]=o,e=i[f+112>>2],i[r+56>>2]=i[f+108>>2],i[r+60>>2]=e,e=i[f+104>>2],i[r+48>>2]=i[f+100>>2],i[r+52>>2]=e,i[r+88>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,f=n-k|0,(f|0)<0)break i;for(e=C(f),i[r+80>>2]=e,i[r+88>>2]=e+f;f=p[k>>1],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,X[e>>1]=f,f=i[k+4>>2],o=i[k+8>>2],Oe(e+4|0,f,o,(o-f|0)/12|0),e=e+16|0,k=k+16|0,(n|0)!=(k|0););i[r+84>>2]=e,e=0,i[r+44>>2]=0,i[r+40>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,k=i[l>>2],Or(r+8|0,k,i[l+4>>2]-k|0,r+48|0,r+44|0,r+40|0,r+32|0);f:{if(i[r+8>>2]){if(e=A+12|0,k=i[r+12>>2],i[A+4>>2]=i[r+8>>2],i[A+8>>2]=k,t[r+27|0]>=0){k=i[r+20>>2],i[e>>2]=i[r+16>>2],i[e+4>>2]=k,i[e+8>>2]=i[r+24>>2],e=1;break f}T(e,i[r+16>>2],i[r+20>>2]),e=1;break f}k=i[r+36>>2],f=i[r+32>>2],t[A+12|0]=1,i[A+4>>2]=f,i[A+8>>2]=k}if(t[A+24|0]=e,t[r+27|0]<0&&Z(i[r+16>>2]),A=i[r+80>>2],!A)break e;if(e=A,n=i[r+84>>2],(e|0)!=(n|0)){for(;;){if(o=n-12|0,f=i[o>>2],f){if(s=n-8|0,e=i[s>>2],k=f,(e|0)!=(f|0)){for(;k=e-12|0,l=i[k>>2],l&&(i[e-8>>2]=l,Z(l)),e=k,(f|0)!=(e|0););k=i[o>>2]}i[s>>2]=f,Z(k)}if(n=n-16|0,(A|0)==(n|0))break}e=i[r+80>>2]}i[r+84>>2]=A,Z(e);break e}if(e=e+16|0,(n|0)==(e|0))break}t[A+24|0]=0,t[A+12|0]=0,t[A+4|0]=0}v=r+96|0;return}s0(),M()}function cn(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;B=v-16|0,v=B,h=$0(o,137e3),G=$0(o,137072),o=G,W[i[i[o>>2]+20>>2]](B+4|0,o),i[n>>2]=f;i:{e:switch(s=A,o=u[s|0],o-43|0){case 0:case 2:break e;default:break i}o=W[i[i[h>>2]+44>>2]](h,o<<24>>24)|0,l=i[n>>2],i[n>>2]=l+4,i[l>>2]=o,s=A+1|0}i:{if(o=s,!((r-o|0)<=1|u[o|0]!=48|(u[o+1|0]|32)!=120))for(l=W[i[i[h>>2]+44>>2]](h,48)|0,s=i[n>>2],i[n>>2]=s+4,i[s>>2]=l,l=W[i[i[h>>2]+44>>2]](h,t[o+1|0])|0,s=i[n>>2],i[n>>2]=s+4,i[s>>2]=l,s=o+2|0,o=s;;){if(r>>>0<=o>>>0||(l=t[o|0],e1(),!(l-48>>>0<10|(l|32)-97>>>0<6)))break i;o=o+1|0}for(;;){if(r>>>0<=o>>>0||(l=t[o|0],e1(),l-48>>>0>=10))break i;o=o+1|0}}u[B+15|0]>>>7|0?l=i[B+8>>2]:l=u[B+15|0]&127;i:{if(!l){W[i[i[h>>2]+48>>2]](h,s,o,i[n>>2])|0,i[n>>2]=i[n>>2]+(o-s<<2);break i}for(ti(s,o),Q=W[i[i[G>>2]+16>>2]](G)|0,l=s;;){if(o>>>0<=l>>>0)T3((s-A<<2)+f|0,i[n>>2]);else{w=B+4|0;e:{if(u[w+11|0]>>>7|0){m=i[w>>2];break e}m=w}V=t[m+I|0]<=0,u[w+11|0]>>>7|0?m=i[w>>2]:m=w,V|t[m+I|0]!=(_|0)||(_=i[n>>2],i[n>>2]=_+4,i[_>>2]=Q,u[w+11|0]>>>7|0?w=i[w+4>>2]:w=u[w+11|0]&127,I=(w-1>>>0>I>>>0)+I|0,_=0),w=W[i[i[h>>2]+44>>2]](h,t[l|0])|0,m=i[n>>2],i[n>>2]=m+4,i[m>>2]=w,l=l+1|0,_=_+1|0;continue}break}}i:{e:{for(;;){if(r>>>0<=o>>>0)break e;if(l=o+1|0,o=t[o|0],(o|0)!=46){o=W[i[i[h>>2]+44>>2]](h,o)|0,s=i[n>>2],i[n>>2]=s+4,i[s>>2]=o,o=l;continue}break}o=W[i[i[G>>2]+12>>2]](G)|0,s=i[n>>2],_=s+4|0,i[n>>2]=_,i[s>>2]=o;break i}_=i[n>>2],l=o}W[i[i[h>>2]+48>>2]](h,l,r,_)|0,o=n,n=i[n>>2]+(r-l<<2)|0,i[o>>2]=n,i[k>>2]=(e|0)==(r|0)?n:(e-A<<2)+f|0,_2(B+4|0),v=B+16|0}function Lg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]);i:{if(i[e+100>>2]){if(k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(f+8|0,36373,13),n=f+148|0,o=i[e+100>>2],z1(n,W[i[i[o>>2]+8>>2]](o)|0),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),47878,1),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,e=i[e+100>>2],W[i[i[e>>2]+12>>2]](k,e,r),e=t[f+159|0],r=(e|0)<0,F(f+8|0,r?i[f+148>>2]:k,r?i[f+152>>2]:e),t[f+159|0]>=0)break i;Z(i[f+148>>2]);break i}e=f+148|0,k0(e,r),k=e,e=t[f+159|0],r=(e|0)<0,F(f+8|0,r?i[f+148>>2]:k,r?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),e=f+8|0,F(e,47513,17),F(e,38473,17)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function pi(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;e=v-128|0,v=e,t[e+80|0]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+120>>2]=0,i[e+112>>2]=0,i[e+116>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+84>>2]=0,i[e+88>>2]=0,r=i[A+180>>2],i[e+64>>2]=i[r+48>>2],r=i[r+52>>2],i[e+68>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[A+196>>2],f=i[e+68>>2],i[e>>2]=i[e+64>>2],i[e+4>>2]=f,eu(e+72|0,e,r),A=i[A+552>>2],i[e+56>>2]=i[e+120>>2],r=i[e+116>>2],i[e+48>>2]=i[e+112>>2],i[e+52>>2]=r,f=i[e+72>>2],n=i[e+76>>2],i[e+72>>2]=0,i[e+76>>2]=0,t[e+16|0]=u[e+80|0],r=i[e+84>>2],i[e+84>>2]=0,i[e+20>>2]=r,r=i[e+88>>2],k=i[e+92>>2],i[e+88>>2]=0,i[e+92>>2]=0,i[e+24>>2]=r,i[e+28>>2]=k,r=i[e+96>>2],k=i[e+100>>2],i[e+96>>2]=0,i[e+100>>2]=0,i[e+32>>2]=r,i[e+36>>2]=k,r=i[e+108>>2],i[e+40>>2]=i[e+104>>2],i[e+44>>2]=r,i[e+8>>2]=0,i[e+12>>2]=0,r=i[A+12>>2],i[A+8>>2]=f,i[A+12>>2]=n;i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}t[A+16|0]=u[e+16|0],r=i[A+20>>2],r&&(i[A+24>>2]=r,Z(r)),i[A+20>>2]=i[e+20>>2],i[A+24>>2]=i[e+24>>2],i[A+28>>2]=i[e+28>>2],i[e+28>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,(A|0)!=(e|0)&&(k1(A+32|0),i[A+32>>2]=i[e+32>>2],i[A+36>>2]=i[e+36>>2],i[e+32>>2]=0,i[e+36>>2]=0),r=i[e+44>>2],i[A+40>>2]=i[e+40>>2],i[A+44>>2]=r,i[A+56>>2]=i[e+56>>2],r=i[e+52>>2],i[A+48>>2]=i[e+48>>2],i[A+52>>2]=r,k1(e+32|0),A=i[e+20>>2],A&&(i[e+24>>2]=A,Z(A)),r=e+96|0,A=i[e+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}k1(r),A=i[e+84>>2],A&&(i[e+88>>2]=A,Z(A)),A=i[e+76>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=e+128|0}function it(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;_=v-16|0,v=_,h=$0(o,137008),G=$0(o,137064),o=G,W[i[i[o>>2]+20>>2]](_+4|0,o),i[n>>2]=f;i:{e:switch(s=A,o=u[s|0],o-43|0){case 0:case 2:break e;default:break i}o=W[i[i[h>>2]+28>>2]](h,o<<24>>24)|0,l=i[n>>2],i[n>>2]=l+1,t[l|0]=o,s=A+1|0}i:{if(o=s,!((r-o|0)<=1|u[o|0]!=48|(u[o+1|0]|32)!=120))for(l=W[i[i[h>>2]+28>>2]](h,48)|0,s=i[n>>2],i[n>>2]=s+1,t[s|0]=l,l=W[i[i[h>>2]+28>>2]](h,t[o+1|0])|0,s=i[n>>2],i[n>>2]=s+1,t[s|0]=l,s=o+2|0,o=s;;){if(r>>>0<=o>>>0||(l=t[o|0],e1(),!(l-48>>>0<10|(l|32)-97>>>0<6)))break i;o=o+1|0}for(;;){if(r>>>0<=o>>>0||(l=t[o|0],e1(),l-48>>>0>=10))break i;o=o+1|0}}u[_+15|0]>>>7|0?l=i[_+8>>2]:l=u[_+15|0]&127;i:{if(!l){W[i[i[h>>2]+32>>2]](h,s,o,i[n>>2])|0,i[n>>2]=i[n>>2]+(o-s|0);break i}for(ti(s,o),Q=W[i[i[G>>2]+16>>2]](G)|0,l=s;;){if(o>>>0<=l>>>0)ti((s-A|0)+f|0,i[n>>2]);else{w=_+4|0;e:{if(u[w+11|0]>>>7|0){B=i[w>>2];break e}B=w}V=t[B+I|0]<=0,u[w+11|0]>>>7|0?B=i[w>>2]:B=w,V|t[B+I|0]!=(m|0)||(m=i[n>>2],i[n>>2]=m+1,t[m|0]=Q,u[w+11|0]>>>7|0?w=i[w+4>>2]:w=u[w+11|0]&127,I=(w-1>>>0>I>>>0)+I|0,m=0),w=W[i[i[h>>2]+28>>2]](h,t[l|0])|0,B=i[n>>2],i[n>>2]=B+1,t[B|0]=w,l=l+1|0,m=m+1|0;continue}break}}for(;;){i:{e:{if(r>>>0<=o>>>0){l=o;break e}if(l=o+1|0,o=t[o|0],(o|0)!=46)break i;o=W[i[i[G>>2]+12>>2]](G)|0,s=i[n>>2],i[n>>2]=s+1,t[s|0]=o}W[i[i[h>>2]+32>>2]](h,l,r,i[n>>2])|0,o=n,n=i[n>>2]+(r-l|0)|0,i[o>>2]=n,i[k>>2]=(e|0)==(r|0)?n:(e-A|0)+f|0,_2(_+4|0),v=_+16|0;return}o=W[i[i[h>>2]+28>>2]](h,o)|0,s=i[n>>2],i[n>>2]=s+1,t[s|0]=o,o=l}}function qg(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0;n=v+-64|0,v=n,wn(n+40|0,e,r);i:{if(i[n+40>>2]){e=i[n+44>>2],i[A>>2]=i[n+40>>2],i[A+4>>2]=e,e=A+8|0;e:{if(t[n+59|0]>=0){r=i[n+52>>2],i[e>>2]=i[n+48>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+56>>2];break e}T(e,i[n+48>>2],i[n+52>>2])}t[A+20|0]=1;break i}if(r=i[e+68>>2],!r){t[A+20|0]=0,i[A>>2]=0,i[A+4>>2]=0;break i}i[n+36>>2]=0;e:{r:{e=i[e+64>>2],o=i[e>>2];f:{if((o|0)>=5){if(o=i[e+68>>2],!o)break f;if(e=n+24|0,W[o|0](e,r,n+36|0,f,k),!i[n+24>>2])break e;if(Gi(n,e),e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,e=A+8|0,t[n+19|0]>=0){r=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+16>>2],t[A+20|0]=1;break i}if(T(e,i[n+8>>2],i[n+12>>2]),e=t[n+19|0],t[A+20|0]=1,(e|0)>=0)break i;Z(i[n+8>>2]);break i}if((o|0)!=4)break r}if(f=i[e+44>>2],!f)break r;if(e=n+24|0,W[f|0](e,r,n+36|0,k),!i[n+24>>2])break e;if(Gi(n,e),e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,e=A+8|0,t[n+19|0]>=0){r=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+16>>2],t[A+20|0]=1;break i}if(T(e,i[n+8>>2],i[n+12>>2]),e=t[n+19|0],t[A+20|0]=1,(e|0)>=0)break i;Z(i[n+8>>2]);break i}if(f=n+24|0,W[i[e+32>>2]](f,r,n+36|0),!i[n+24>>2])break e;if(Gi(n,f),e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,e=A+8|0,t[n+19|0]>=0){r=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+16>>2],t[A+20|0]=1;break i}if(T(e,i[n+8>>2],i[n+12>>2]),e=t[n+19|0],t[A+20|0]=1,(e|0)>=0)break i;Z(i[n+8>>2]);break i}if(e=i[n+36>>2],!e){t[A+20|0]=0,i[A>>2]=0,i[A+4>>2]=0;break i}r=i[e>>2],f=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,i8(e),t[A+20|0]=0,i[A>>2]=r,i[A+4>>2]=f}t[n+59|0]<0&&Z(i[n+48>>2]),v=n- -64|0}function ag(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]),k=u[e+97|0];i:{if(k>>>0>=4){B1(A,e,16519);break i}e:{r:{if(k>>>0>=2){i[e+112>>2]=0;break r}if(n=e,o=w2(r),i[n+104>>2]=o,n=e,o=w2(r),X[n+108>>1]=o,p4(f+20|0,r),t[e+127|0]<0&&Z(i[e+116>>2]),k=i[f+24>>2],i[e+116>>2]=i[f+20>>2],i[e+120>>2]=k,i[e+124>>2]=i[f+28>>2],p4(f+20|0,r),t[e+139|0]<0&&Z(i[e+128>>2]),k=i[f+24>>2],i[e+128>>2]=i[f+20>>2],i[e+132>>2]=k,i[e+136>>2]=i[f+28>>2],p4(f+20|0,r),t[e+151|0]<0&&Z(i[e+140>>2]),k=i[f+24>>2],i[e+140>>2]=i[f+20>>2],i[e+144>>2]=k,i[e+148>>2]=i[f+28>>2],i[e+112>>2]=0,k=u[e+97|0],k>>>0<2)break e}t[e+164|0]=t[e+100|0]&1;r:{if((k|0)==2){k=w2(r);break r}k=F0(r)}if(i[e+104>>2]=k,n=e,o=w2(r),X[n+108>>1]=o,n=e,o=F0(r),i[n+112>>2]=o,p4(f+20|0,r),t[e+127|0]<0&&Z(i[e+116>>2]),k=i[f+24>>2],i[e+116>>2]=i[f+20>>2],i[e+120>>2]=k,i[e+124>>2]=i[f+28>>2],k=i[e+112>>2],(k|0)!=1970432288){if((k|0)!=1835625829)break e;p4(f+20|0,r),t[e+139|0]<0&&Z(i[e+128>>2]),k=i[f+24>>2],i[e+128>>2]=i[f+20>>2],i[e+132>>2]=k,i[e+136>>2]=i[f+28>>2],p4(f+20|0,r),t[e+151|0]<0&&Z(i[e+140>>2]),k=i[f+24>>2],i[e+140>>2]=i[f+20>>2],i[e+144>>2]=k,i[e+148>>2]=i[f+28>>2];break e}p4(f+20|0,r),t[e+163|0]<0&&Z(i[e+152>>2]),k=i[f+24>>2],i[e+152>>2]=i[f+20>>2],i[e+156>>2]=k,i[e+160>>2]=i[f+28>>2]}if(u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Kg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78164,i[f+8>>2]=78144,n=i[19545],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[19546],i[f+4>>2]=0,n=i[i[f>>2]-12>>2]+f|0,s=f+12|0,J0(n,s),t[n+80|0]=0,i[n+72>>2]=0,n=i[19547],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19548],k=i[19544],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19549],i[f+64>>2]=78164,i[f>>2]=78124,i[f+8>>2]=78144,s=R0(s),i[s>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,K1(k,e,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(n,37670,14),i[e+104>>2]),37980,7),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(n,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(n,36186,13),i[e+108>>2]),46641,10),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(n,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(n,36200,13),i[e+112>>2]),46641,10),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,n,e)}t[A+e|0]=0,A=i[19543],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19551],i[f+8>>2]=i[19552],i[s>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(s),Y0(f- -64|0),v=f+160|0}function $g(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;o=v-80|0,v=o;i:{if(!r){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}s=i[e>>2],l=i[e+4>>2],l&&(i[l+4>>2]=i[l+4>>2]+1);e:{if(!i[s+84>>2]&o0[s+80>>2]<=o0[s+96>>2]){i[r>>2]=0,i[A+8>>2]=16796,i[A>>2]=13,i[A+4>>2]=0;break e}h=D5(),i5(h,n),n=Z0(s,113600,113736);r:{if(n){l&&(i[l+4>>2]=i[l+4>>2]+1),R9(o+44|0,n,h);f:{A:{k:{n:{t:{o:switch(u[o+64|0]){case 1:c0(A,o+44|0,i[e+8>>2]);break f;case 0:break o;default:break t}w=i[o+44>>2],n=i[o+48>>2];o:{if(!n){s=i[e+8>>2];break o}i[n+4>>2]=i[n+4>>2]+1,s=i[e+8>>2],i[n+4>>2]=i[n+4>>2]+1}switch(i[o+12>>2]=n,i[o+8>>2]=w,w=i[o+12>>2],i[o>>2]=i[o+8>>2],i[o+4>>2]=w,Cn(o+16|0,s,o,f,k,h),u[o+36|0]){case 0:break k;case 1:break n;default:break t}}e2(),M()}c0(A,o+16|0,i[e+8>>2]);break A}e=i[o+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),f=i[o+16>>2];k:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break k;W[i[i[n>>2]+8>>2]](n),y(n)}k=r,r=C(8),i[k>>2]=r,i[r+4>>2]=e,i[r>>2]=f,n=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}if(A=u[o+36|0],(A|0)!=255&&(e=i[25815],i[o+72>>2]=i[25814],i[o+76>>2]=e,W[i[(o+72|0)+(A<<2)>>2]](o+71|0,o+16|0)),!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break f;W[i[i[n>>2]+8>>2]](n),y(n)}if(A=u[o+64|0],(A|0)!=255&&(e=i[25815],i[o+16>>2]=i[25814],i[o+20>>2]=e,W[i[(o+16|0)+(A<<2)>>2]](o+72|0,o+44|0)),!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break r;W[i[i[l>>2]+8>>2]](l),y(l);break r}if(i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27147,!h)break e}a2(h)}if(!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break i;W[i[i[l>>2]+8>>2]](l),y(l)}v=o+80|0}function dg(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0;k=v-16|0,v=k;i:{e:{if(!i[A+64>>2]){o=-1;break e}r=i[A+92>>2]&8,r||(i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,o=u[A+98|0],e=i[(o?32:56)+A>>2],o=e+i[(o?52:60)+A>>2]|0,i[A+16>>2]=o,i[A+12>>2]=o,i[A+8>>2]=e,i[A+92>>2]=8),i[A+12>>2]||(e=k+16|0,i[A+16>>2]=e,i[A+12>>2]=e,i[A+8>>2]=k+15),r&&(e=i[A+16>>2],r=i[A+8>>2],i[k+4>>2]=4,i[k+8>>2]=(e-r|0)/2,e=v-16|0,v=e,v=e+16|0,e=k+4|0,r=k+8|0,n=i[(o0[e>>2]<o0[r>>2]?e:r)>>2]),o=-1,e=i[A+16>>2];r:{if((e|0)==i[A+12>>2]){if(r=i[A+8>>2],n&&z(r,e-n|0,n),u[A+98|0]==1){if(e=i[A+8>>2],e=ru(e+n|0,i[A+16>>2]-(e+n|0)|0,i[A+64>>2]),!e)break r;r=i[A+8>>2],f=e,e=i[A+8>>2]+n|0,i[A+16>>2]=f+e,i[A+12>>2]=e,i[A+8>>2]=r,o=u[i[A+12>>2]];break r}e=i[A+40>>2],r=i[A+36>>2];f:{if((e|0)==(r|0)){r=e;break f}e=e-r|0,e&&z(i[A+32>>2],r,e),e=i[A+36>>2],r=i[A+40>>2]}if(f=i[A+32>>2],e=r-e|0,i[A+36>>2]=f+e,r=(f|0)==(A+44|0)?8:i[A+52>>2],i[A+40>>2]=r+f,i[k+8>>2]=i[A+60>>2]-n,i[k+4>>2]=r-e,e=v-16|0,v=e,v=e+16|0,r=k+4|0,e=k+8|0,r=i[(o0[r>>2]<o0[e>>2]?r:e)>>2],f=i[A+76>>2],i[A+80>>2]=i[A+72>>2],i[A+84>>2]=f,f=ru(i[A+36>>2],r,i[A+64>>2]),!f)break r;if(r=i[A+68>>2],!r)break i;f=f+i[A+36>>2]|0,i[A+40>>2]=f,l=f,f=i[A+8>>2];f:{if((W[i[i[r>>2]+16>>2]](r,A+72|0,i[A+32>>2],l,A+36|0,f+n|0,f+i[A+60>>2]|0,e)|0)==3){e=i[A+32>>2],i[A+16>>2]=i[A+40>>2],i[A+12>>2]=e,i[A+8>>2]=e;break f}if(e=i[k+8>>2],r=i[A+8>>2],n=r+n|0,(e|0)==(n|0))break r;i[A+16>>2]=e,i[A+12>>2]=n,i[A+8>>2]=r}o=u[i[A+12>>2]];break r}o=u[i[A+12>>2]]}if(i[A+8>>2]!=(k+15|0))break e;i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0}return v=k+16|0,o|0}N1(),M()}function bg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;f=v-16|0,v=f,n=i[e+12>>2],s=n;i:{e:{r:{if(k=i[e+8>>2],n|k){if(n=i[e+32>>2],l=n>>>0>k>>>0,l&!s)break r;if(h=k-n|0,n=s-l|0,k=h,!n&k>>>0>=2147483648|n){if(e=C(24),i[f+4>>2]=e,i[f+8>>2]=18,i[f+12>>2]=-2147483624,r=u[15104]|u[15105]<<8|(u[15106]<<16|u[15107]<<24),k=u[15100]|u[15101]<<8|(u[15102]<<16|u[15103]<<24),t[e|0]=k,t[e+1|0]=k>>>8,t[e+2|0]=k>>>16,t[e+3|0]=k>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+18|0]=0,r=u[15116]|u[15117]<<8,t[e+16|0]=r,t[e+17|0]=r>>>8,r=u[15112]|u[15113]<<8|(u[15114]<<16|u[15115]<<24),k=u[15108]|u[15109]<<8|(u[15110]<<16|u[15111]<<24),t[e+8|0]=k,t[e+9|0]=k>>>8,t[e+10|0]=k>>>16,t[e+11|0]=k>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,2,1e3,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}o=i[e+104>>2],n=i[e+100>>2],h=o-n|0;f:{if(k>>>0>h>>>0){if(s=k-h|0,l=i[e+108>>2],s>>>0<=l-o>>>0){s&&l0(o,0,s),i[e+104>>2]=o+s;break f}if(o=l-n|0,l=o<<1,l=o>>>0>=1073741823?2147483647:k>>>0<l>>>0?l:k,o=C(l),s&&l0(o+h|0,0,s),h&&z(o,n,h),i[e+108>>2]=o+l,i[e+104>>2]=k+o,i[e+100>>2]=o,!n)break f;Z(n);break f}if(k>>>0>=h>>>0)break f;i[e+104>>2]=k+n}s6(r,i[e+100>>2],k)}if(u[r+20|0]!=1)break e;if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,101,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function JA(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;i:{e:{if((r|0)>=0){f=i[i[A+124>>2]+(e?16840:16832)>>2];r:{if(f-1>>>0<=7){if(!e){if(e=g(i[A+28>>2],i[A+40>>2]),!e)break r;l0(i[A+4>>2],r,e);return}if(f=g(i[A+36>>2],i[A+44>>2]),!f)break r;l0(i[(A+4|0)+(e<<2)>>2],r,f);return}if(f=f-9|0,(r&255)==(r>>>8|0)){if(f>>>0>=8)break e;if(!e){if(e=g(i[A+40>>2],i[A+28>>2])<<1,!e)break r;l0(i[A+4>>2],0,e);return}if(r=g(i[A+44>>2],i[A+36>>2])<<1,!r)break r;l0(i[(A+4|0)+(e<<2)>>2],0,r);return}if(f>>>0>=8)break i;if(e){n=i[A+32>>2];f:{if((n|0)<=0)break f;if(k=i[((e<<2)+A|0)+4>>2],f=0,n>>>0>=4)for(s=k+6|0,h=k+4|0,w=k+2|0,_=n&2147483644;o=f<<1,X[o+k>>1]=r,X[o+w>>1]=r,X[o+h>>1]=r,X[o+s>>1]=r,f=f+4|0,B=B+4|0,(_|0)!=(B|0););if(n=n&3,!n)break f;for(;X[k+(f<<1)>>1]=r,f=f+1|0,l=l+1|0,(n|0)!=(l|0););}if(i[A+36>>2]<2)break r;for(e=(e<<2)+A|0,r=1;f=i[A+32>>2]<<1,f&&(k=i[e+4>>2],z(k+(g(i[A+44>>2],r)<<1)|0,k,f)),r=r+1|0,(r|0)<i[A+36>>2];);break r}n=i[A+24>>2];f:{if((n|0)<=0)break f;if(k=i[A+4>>2],f=0,n>>>0>=4)for(s=k+6|0,h=k+4|0,w=k+2|0,_=n&2147483644,e=0;o=f<<1,X[o+k>>1]=r,X[o+w>>1]=r,X[o+h>>1]=r,X[o+s>>1]=r,f=f+4|0,e=e+4|0,(_|0)!=(e|0););if(e=n&3,!e)break f;for(;X[k+(f<<1)>>1]=r,f=f+1|0,l=l+1|0,(e|0)!=(l|0););}if(i[A+28>>2]<2)break r;for(r=1;e=i[A+32>>2]<<1,e&&(f=i[A+4>>2],z(f+(g(i[A+40>>2],r)<<1)|0,f,e)),r=r+1|0,(r|0)<i[A+28>>2];);}return}U0(23965,19968,534,14016),M()}U0(23433,19968,545,14016),M()}U0(23433,19968,556,14016),M()}function et(A,e,r,f,k,n){var o=0,l=0;$r(i[e+48>>2]),o=C(360),i[o>>2]=101208,i[o+4>>2]=0,i[o+8>>2]=0,l=v-16|0,v=l,f=I9(o+16|0,e,r,f),r=f,i[r+312>>2]=0,i[r+316>>2]=0,t[r+304|0]=0,i[r+300>>2]=0,i[r+292>>2]=0,i[r+320>>2]=0,i[r+324>>2]=0,i[r>>2]=113712,i[r+308>>2]=r+312,i[r+328>>2]=0,i[r+332>>2]=0,i[r+336>>2]=0,r=i[r+144>>2],i[r+184>>2]=n<<16,i[r+180>>2]=k<<16,r=C(128),i[r>>2]=99428,i[r+4>>2]=0,i[r+8>>2]=0,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,X[r+112>>1]=0,i[k>>2]=111656,i[r+116>>2]=1,i[r+32>>2]=1986881636,i[r+120>>2]=0,i[r+124>>2]=0,n=i[f+152>>2],i[l+12>>2]=r,i[l+8>>2]=k,i[r+4>>2]=i[r+4>>2]+1,P0(n+36|0,l+8|0),k=i[l+12>>2];i:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break i;W[i[i[k>>2]+8>>2]](k),y(k)}k=i[r+4>>2],i[r+4>>2]=k-1,k||(W[i[i[r>>2]+8>>2]](r),y(r)),v=l+16|0,n=f,i[o+4>>2]=i[o+4>>2]+1,l=i[o+40>>2];i:{e:{r=i[e+200>>2];r:{if(!r){k=e+200|0,f=k;break r}for(;;){if(f=r,r=i[r+16>>2],r>>>0>l>>>0){if(k=f,r=i[k>>2],r)continue;break r}if(r>>>0>=l>>>0)break e;if(r=i[f+4>>2],!r)break}k=f+4|0}r=C(28),i[r+24>>2]=o,i[r+20>>2]=n,i[r+16>>2]=l,i[r+8>>2]=f,i[r>>2]=0,i[r+4>>2]=0,i[k>>2]=r,f=i[i[e+196>>2]>>2],f&&(i[e+196>>2]=f),G1(i[e+200>>2],r),i[e+204>>2]=i[e+204>>2]+1;break i}if(e=i[o+4>>2],i[o+4>>2]=e-1,e)break i;W[i[i[o>>2]+8>>2]](o),y(o)}t[A+20|0]=0,i[A+4>>2]=o,i[A>>2]=n}function NA(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0;o=v-128|0,v=o;i:{if(!(r&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}i[r>>2]=0,h=i[i[e>>2]+196>>2],i[o+56>>2]=0,i[o+60>>2]=0,X[o- -64>>1]=0,i[o+96>>2]=0,i[o+100>>2]=0,i[o+104>>2]=0,i[o+108>>2]=0,t[o+112|0]=0,i[o+68>>2]=0,X[o+44>>1]=9,i[o+48>>2]=0,i[o+52>>2]=0,i[o+88>>2]=0,i[o+92>>2]=0,t[o+84|0]=0,i[o+76>>2]=2,i[o+80>>2]=2,t[o+72|0]=1;e:{if(!n)break e;r:{f:{A:{k:{n:{t:{o:{l:{u:switch(l=u[n|0],(l>>>0>=9?9:l)-1|0){case 8:break u;case 0:break r;case 1:break f;case 2:break A;case 3:break k;case 4:break n;case 5:break t;case 6:break o;case 7:break l;default:break e}t[o+112|0]=u[n+68|0]}i[o+104>>2]=i[n+60>>2],i[o+108>>2]=i[n+64>>2],i[o+100>>2]=i[n+56>>2],i[o+96>>2]=i[n+52>>2]}i[o+92>>2]=i[n+48>>2]}i[o+88>>2]=i[n+44>>2]}s=i[n+32>>2],l=o+72|0,i[l>>2]=i[n+28>>2],i[l+4>>2]=s,s=i[n+40>>2],i[l+8>>2]=i[n+36>>2],i[l+12>>2]=s}i[o+68>>2]=i[n+24>>2]}t[o+65|0]=u[n+21|0]}t[o+64|0]=u[n+20|0]}t[o+45|0]=u[n+1|0],i[o+48>>2]=i[n+4>>2],i[o+52>>2]=i[n+8>>2],i[o+56>>2]=i[n+12>>2],i[o+60>>2]=i[n+16>>2]}l=i[e+8>>2],i[o+8>>2]=o+12,i[o+12>>2]=0,i[o+16>>2]=0,n=o+20|0,s=f,f=o+8|0,pn(n,l,h,s,k,o+44|0,0,0,0,f),S1(f,i[o+12>>2]);e:switch(u[o+40|0]){default:e2(),M();case 0:k=i[o+20>>2],f=i[o+24>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),n=r,r=C(8),i[n>>2]=r,i[r+4>>2]=f,i[r>>2]=k,n=114912;break;case 1:break e}if(r=A,A=i[e>>2],c0(r,n,A?A+164|0:0),A=u[o+40|0],(A|0)==255)break i;e=i[25837],i[o+120>>2]=i[25836],i[o+124>>2]=e,W[i[(o+120|0)+(A<<2)>>2]](o+119|0,o+20|0)}v=o+128|0}function cg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;o=v-16|0,v=o;i:{if(!(f&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}i[f>>2]=0,k=i[e>>2],e=i[k+48>>2],l=i[k+52>>2],l&&(i[l+4>>2]=i[l+4>>2]+1);e:{if(!P3(e,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3854;break e}k=v-32|0,v=k,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,L1(k,e,r,k+20|0);r:{if(i[k>>2]){i[o+8>>2]=0,i[o+12>>2]=0;break r}f:{if(n=i[k+20>>2],r=i[k+24>>2],(n|0)!=(r|0)){if(e=i[n>>2],e&&(s=i[o+12>>2],e=Z0(e,92792,92836),e))break f;if(n=n+8|0,(r|0)!=(n|0))for(;;){if(e=i[n>>2],e&&(s=0,e=Z0(e,92792,92836),e))break f;if(n=n+8|0,(r|0)==(n|0))break}i[o+8>>2]=0,i[o+12>>2]=0}i[o+8>>2]=0,i[o+12>>2]=0;break r}if(i[o+12>>2]=s,i[o+8>>2]=e,e=i[n+4>>2],i[o+12>>2]=e,!e)break r;i[e+4>>2]=i[e+4>>2]+1}if(t[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(e=r,n=i[k+24>>2],(e|0)!=(n|0)){for(;;){e=i[n-4>>2];r:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(n=n-8|0,(r|0)==(n|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}if(v=k+32|0,e=i[o+8>>2],e&&(r=C(32),i[f>>2]=r,f=i[e+132>>2],i[r+24>>2]=i[e+128>>2],i[r+28>>2]=f,f=i[e+124>>2],i[r+16>>2]=i[e+120>>2],i[r+20>>2]=f,f=i[e+116>>2],i[r+8>>2]=i[e+112>>2],i[r+12>>2]=f,f=i[e+108>>2],i[r>>2]=i[e+104>>2],i[r+4>>2]=f),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[o+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break i;W[i[i[l>>2]+8>>2]](l),y(l)}v=o+16|0}function iG(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0;f=v-32|0,v=f,e=i[r>>2],n=i[e+192>>2],o=i[e+188>>2],e=C(248),i[e>>2]=101168,i[e+4>>2]=0,i[e+8>>2]=0,l0(e+16|0,0,156),i[e+76>>2]=0,i[e+80>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,t[e+24|0]=1,X[e+22>>1]=2,X[e+18>>1]=2,X[e+20>>1]=2,i[e+84>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+100>>2]=0,i[e+104>>2]=1,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,X[e+158>>1]=0,X[e+160>>1]=0,X[e+162>>1]=0,X[e+164>>1]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+172>>2]=255,i[e+192>>2]=0,i[e+196>>2]=5186,i[e+208>>2]=99,i[e+212>>2]=99,i[e+200>>2]=0,i[e+204>>2]=0,i[e+12>>2]=101488,i[e+216>>2]=0,i[e+220>>2]=0,i[e+224>>2]=0,i[e+228>>2]=0,i[e+232>>2]=0,i[e+236>>2]=0,i[e+240>>2]=0,i[e+244>>2]=0,k=e+12|0,i[e+176>>2]=k,i[e+8>>2]=i[e+8>>2]+1,i[e+180>>2]=e,i[e+4>>2]==-1&&(W[i[i[e>>2]+8>>2]](e),y(e)),s=n,n=i[r>>2],t1(k,o,s,i[n+196>>2],i[n+200>>2]);i:{if(!$2(i[r>>2],0)||(K4(f+12|0,k,r,0,0,l),t[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!$2(i[r>>2],1)||(K4(f+12|0,k,r,1,1,l),t[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!$2(i[r>>2],2)||(K4(f+12|0,k,r,2,2,l),t[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!$2(i[r>>2],3)||(K4(f+12|0,k,r,3,3,l),t[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!$2(i[r>>2],4)||(K4(f+12|0,k,r,4,4,l),t[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!$2(i[r>>2],5)||(K4(f+12|0,k,r,5,5,l),t[f+31|0]>=0))break i;Z(i[f+20>>2])}t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=k,v=f+32|0}function eG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;A=v-480|0,v=A,o=A+476|0,l=i[f+28>>2],i[o>>2]=l,(l|0)!=136824&&(i[l+4>>2]=i[l+4>>2]+1),G=$0(o,137e3),u[n+11|0]>>>7|0?o=i[n+4>>2]:o=u[n+11|0]&127,o&&(u[n+11|0]>>>7|0?o=i[n>>2]:o=n,I=i[o>>2]==(W[i[i[G>>2]+44>>2]](G,45)|0)),o=v-16|0,v=o,_=A+452|0,i[_>>2]=0,i[_+4>>2]=0,i[_+8>>2]=0,v=o+16|0,o=v-16|0,v=o,s=A+440|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=o+16|0,o=v-16|0,v=o,h=A+428|0,i[h>>2]=0,i[h+4>>2]=0,i[h+8>>2]=0,v=o+16|0,po(r,I,A+476|0,A+472|0,A+468|0,A+464|0,_,s,h,A+424|0),i[A+16>>2]=2126,r=A+16|0,w=J1(A+8|0,0,r);i:{u[n+11|0]>>>7|0?o=i[n+4>>2]:o=u[n+11|0]&127;e:{if((o|0)>i[A+424>>2]){u[n+11|0]>>>7|0?l=i[n+4>>2]:l=u[n+11|0]&127,o=i[A+424>>2],u[s+11|0]>>>7|0?B=i[s+4>>2]:B=u[s+11|0]&127,u[h+11|0]>>>7|0?m=i[h+4>>2]:m=u[h+11|0]&127,o=(o+(B+(m+(l-o<<1)|0)|0)|0)+1|0;break e}B=i[A+424>>2],u[h+11|0]>>>7|0?o=i[h+4>>2]:o=u[h+11|0]&127,u[s+11|0]>>>7|0?l=i[s+4>>2]:l=u[s+11|0]&127,o=(B+(o+l|0)|0)+2|0}if(o>>>0<101||(r=E2(o<<2),o=i[w>>2],i[w>>2]=r,o&&W[i[w+4>>2]](o),r=i[w>>2],r))break i;N1(),M()}return B=A+4|0,m=i[f+4>>2],u[n+11|0]>>>7|0?o=i[n>>2]:o=n,l=o,u[n+11|0]>>>7|0?o=i[n>>2]:o=n,u[n+11|0]>>>7|0?n=i[n+4>>2]:n=u[n+11|0]&127,On(r,B,A,m,l,o+(n<<2)|0,G,I,A+472|0,i[A+468>>2],i[A+464>>2],_,s,h,i[A+424>>2]),e=t6(e,r,i[A+4>>2],i[A>>2],f,k),r=i[w>>2],i[w>>2]=0,r&&W[i[w+4>>2]](r),q1(h),q1(s),_2(_),i2(A+476|0),v=A+480|0,e|0}function rG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;A=v-176|0,v=A,o=A+172|0,l=i[f+28>>2],i[o>>2]=l,(l|0)!=136824&&(i[l+4>>2]=i[l+4>>2]+1),G=$0(o,137008),u[n+11|0]>>>7|0?o=i[n+4>>2]:o=u[n+11|0]&127,o&&(u[n+11|0]>>>7|0?o=i[n>>2]:o=n,I=u[o|0]==(W[i[i[G>>2]+28>>2]](G,45)&255)),o=v-16|0,v=o,_=A+152|0,i[_>>2]=0,i[_+4>>2]=0,i[_+8>>2]=0,v=o+16|0,o=v-16|0,v=o,s=A+140|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=o+16|0,o=v-16|0,v=o,h=A+128|0,i[h>>2]=0,i[h+4>>2]=0,i[h+8>>2]=0,v=o+16|0,Fo(r,I,A+172|0,A+168|0,A+167|0,A+166|0,_,s,h,A+124|0),i[A+16>>2]=2126,r=A+16|0,w=J1(A+8|0,0,r);i:{u[n+11|0]>>>7|0?o=i[n+4>>2]:o=u[n+11|0]&127;e:{if((o|0)>i[A+124>>2]){u[n+11|0]>>>7|0?l=i[n+4>>2]:l=u[n+11|0]&127,o=i[A+124>>2],u[s+11|0]>>>7|0?B=i[s+4>>2]:B=u[s+11|0]&127,u[h+11|0]>>>7|0?m=i[h+4>>2]:m=u[h+11|0]&127,o=(o+(B+(m+(l-o<<1)|0)|0)|0)+1|0;break e}B=i[A+124>>2],u[h+11|0]>>>7|0?o=i[h+4>>2]:o=u[h+11|0]&127,u[s+11|0]>>>7|0?l=i[s+4>>2]:l=u[s+11|0]&127,o=(B+(o+l|0)|0)+2|0}if(o>>>0<101||(r=E2(o),o=i[w>>2],i[w>>2]=r,o&&W[i[w+4>>2]](o),r=i[w>>2],r))break i;N1(),M()}return B=A+4|0,m=i[f+4>>2],u[n+11|0]>>>7|0?o=i[n>>2]:o=n,l=o,u[n+11|0]>>>7|0?o=i[n>>2]:o=n,u[n+11|0]>>>7|0?n=i[n+4>>2]:n=u[n+11|0]&127,an(r,B,A,m,l,o+n|0,G,I,A+168|0,t[A+167|0],t[A+166|0],_,s,h,i[A+124>>2]),e=o6(e,r,i[A+4>>2],i[A>>2],f,k),r=i[w>>2],i[w>>2]=0,r&&W[i[w+4>>2]](r),_2(h),_2(s),_2(_),i2(A+172|0),v=A+176|0,e|0}function rt(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;i:{if(l=i[A+4>>2],o=i[A>>2],f=l-o|0,r=((f|0)/44|0)+1|0,r>>>0<97612894){if(n=(i[A+8>>2]-o|0)/44|0,k=n<<1,k=n>>>0>=48806446?97612893:r>>>0<k>>>0?k:r,k>>>0>=97612894)break i;h=g(k,44),w=C(h),n=w+f|0,k=i[e+4>>2],i[n>>2]=i[e>>2],i[n+4>>2]=k,r=u[e+25|0]|u[e+26|0]<<8|(u[e+27|0]<<16|u[e+28|0]<<24),k=u[e+21|0]|u[e+22|0]<<8|(u[e+23|0]<<16|u[e+24|0]<<24),t[n+21|0]=k,t[n+22|0]=k>>>8,t[n+23|0]=k>>>16,t[n+24|0]=k>>>24,t[n+25|0]=r,t[n+26|0]=r>>>8,t[n+27|0]=r>>>16,t[n+28|0]=r>>>24,k=i[e+20>>2],i[n+16>>2]=i[e+16>>2],i[n+20>>2]=k,k=i[e+12>>2],i[n+8>>2]=i[e+8>>2],i[n+12>>2]=k,r=n+32|0;e:{if(t[e+43|0]>=0){k=i[e+36>>2],i[r>>2]=i[e+32>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+40>>2];break e}T(r,i[e+32>>2],i[e+36>>2]),l=i[A+4>>2],o=i[A>>2],f=l-o|0}if(k=n+g((f|0)/-44|0,44)|0,(o|0)!=(l|0)){for(e=o,f=k;r=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=r,s=u[e+25|0]|u[e+26|0]<<8|(u[e+27|0]<<16|u[e+28|0]<<24),r=u[e+21|0]|u[e+22|0]<<8|(u[e+23|0]<<16|u[e+24|0]<<24),t[f+21|0]=r,t[f+22|0]=r>>>8,t[f+23|0]=r>>>16,t[f+24|0]=r>>>24,t[f+25|0]=s,t[f+26|0]=s>>>8,t[f+27|0]=s>>>16,t[f+28|0]=s>>>24,r=i[e+20>>2],i[f+16>>2]=i[e+16>>2],i[f+20>>2]=r,r=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=r,i[f+40>>2]=i[e+40>>2],r=i[e+36>>2],i[f+32>>2]=i[e+32>>2],i[f+36>>2]=r,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,f=f+44|0,e=e+44|0,(l|0)!=(e|0););for(;t[o+43|0]<0&&Z(i[o+32>>2]),o=o+44|0,(l|0)!=(o|0););o=i[A>>2]}return e=n+44|0,i[A+4>>2]=e,i[A>>2]=k,i[A+8>>2]=h+w,o&&Z(o),e}s0(),M()}x0(),M()}function ft(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;k=v-16|0,v=k;i:{f=i[A+4>>2];e:{if(f>>>0<e>>>0){o=e-f|0,n=i[A+8>>2],r=n<<5;r:{if(!(o>>>0>r>>>0|f>>>0>r-o>>>0)){i[A+4>>2]=e,r=f&31,e=i[A>>2]+(f>>>3&536870908)|0;break r}if(i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,(e|0)<0)break i;f:{if(r>>>0<=1073741822?(r=n<<6,e=e+31&-32,e=e>>>0<r>>>0?r:e):e=2147483647,e>>>0<=i[k+12>>2]<<5>>>0)break f;if((e|0)>=0){m=(e-1>>>5|0)+1|0,n=C(m<<2),r=i[k+4>>2],h=i[k+8>>2];A:{k:{if(h>>>0>=33){i[n+(h-1>>>3&536870908)>>2]=0;break k}if(i[n>>2]=0,!h)break A}for(G=h&31,I=r+(h>>>3&536870908)|0,e=n,l=r,f=r;s=1<<B,i[f>>2]>>>_&1?s=s|i[e>>2]:s=i[e>>2]&(s^-1),i[e>>2]=s,w=f+4|0,s=(_|0)==31,l=s?w:l,f=s?w:f,w=(B|0)==31,f=w?l:f,B=w?0:B+1|0,e=(w?4:0)+e|0,_=s?0:_+1|0,!!((G|0)!=(_|0)|(f|0)!=(I|0)););}if(i[k+12>>2]=m,i[k+8>>2]=h,i[k+4>>2]=n,!r)break f;Z(r);break f}s0(),M()}r=i[A+4>>2],i[k+8>>2]=r+o,f=i[A>>2],e=i[k+4>>2];f:{if((r|0)<=0){r=0;break f}n=r>>>5|0;A:{if(r>>>0<32||(l=n<<2,!l))break A;z(e,f,l)}n=n<<2,e=n+e|0,r=r&31,r&&(l=-1>>>32-r|0,i[e>>2]=i[e>>2]&(l^-1)|l&i[f+n>>2]),f=i[A>>2]}if(i[A>>2]=i[k+4>>2],i[k+4>>2]=f,n=i[A+4>>2],i[A+4>>2]=i[k+8>>2],i[k+8>>2]=n,n=i[A+8>>2],i[A+8>>2]=i[k+12>>2],i[k+12>>2]=n,!f)break r;Z(f)}r&&(A=32-r|0,f=A>>>0>o>>>0?o:A,i[e>>2]=i[e>>2]&(-1<<r&-1>>>A-f^-1),o=o-f|0,e=e+4|0),A=o>>>5|0;r:{if(o>>>0<32||(r=A<<2,!r))break r;l0(e,0,r)}if(r=o&31,!r)break e;A=(A<<2)+e|0,i[A>>2]=i[A>>2]&(-1>>>32-r^-1);break e}i[A+4>>2]=e}v=k+16|0;return}s0(),M()}function n4(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=107396,e=i[A+540>>2],e&&(i[A+544>>2]=e,Z(e)),r=i[A+504>>2],r){if(e=r,f=i[A+508>>2],(e|0)!=(f|0)){for(;t[f-1|0]<0&&Z(i[f-12>>2]),f=f-20|0,(r|0)!=(f|0););e=i[A+504>>2]}i[A+508>>2]=r,Z(e)}if(e=i[A+356>>2],e&&(i[A+360>>2]=e,Z(e)),r=i[A+340>>2],r){if(e=r,f=i[A+344>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+340>>2]}i[A+344>>2]=r,Z(e)}if(r=i[A+328>>2],r){if(e=r,f=i[A+332>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+328>>2]}i[A+332>>2]=r,Z(e)}t[A+327|0]<0&&Z(i[A+316>>2]),e=i[A+244>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+232>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=i[A+212>>2],r){if(e=r,f=i[A+216>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+212>>2]}i[A+216>>2]=r,Z(e)}if(r=i[A+184>>2],r){if(e=r,f=i[A+188>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+184>>2]}i[A+188>>2]=r,Z(e)}return t[A+175|0]<0&&Z(i[A+164>>2]),Ee(A)|0}function fG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,n=i[19620],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19621],o=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(o,k),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(k),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,K1(k,e,r),l=n,s=k,n=t[f+159|0],k=(n|0)<0,F(l,k?i[f+148>>2]:s,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,k0(n,r),l=n,n=t[f+159|0],k=(n|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(f+8|0,37387,20),k=i[i[n>>2]-12>>2]+n|0,i[k+4>>2]=i[k+4>>2]|1,n=F(i1(n,u[e+104|0]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],s=(k|0)<0,F(n,s?i[f+148>>2]:l,s?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(i1(F(n,37046,17),u[e+105|0]),47878,1),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(n,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(n,37289,17),u[e+106|0]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,n,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function AG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,k0(n,r),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),t[f+148|0]=39,k=f+148|0,n=F(f+8|0,k,1),z1(k,i[e+100>>2]),l=n,s=k,k=t[f+159|0],n=(k|0)<0,l=F(F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),34177,15),k=t[e+123|0],n=(k|0)<0,F(F(l,n?i[e+112>>2]:e+112|0,n?i[e+116>>2]:k),47878,1),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),n=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,32870,10);i:{e:switch(i[e+124>>2]){case 0:F(f+8|0,38304,6);break i;case 1:F(f+8|0,38491,10);break i;case 2:break e;default:break i}F(f+8|0,38311,9)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function At(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(B0(F(f+8|0,36985,10),i[e+104>>2]),47878,1),n=f+148|0,k0(n,r),l=n,r=t[f+159|0],n=(r|0)<0,F(k,n?i[f+148>>2]:l,n?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(k,34119,12),r=i[e+108>>2],k=i[e+112>>2];i:{if((r|0)==(k|0)||(B0(f+8|0,i[r>>2]),e=r+4|0,(k|0)==(e|0)))break i;for(;r=i[e>>2],t[f+148|0]=32,n=f+8|0,F(n,f+148|0,1),B0(n,r),e=e+4|0,(k|0)!=(e|0););}F(f+8|0,47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function L6(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;o=v-16|0,v=o,i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0;i:{if(r){if((r|0)<0)break i;f=C(r),r&&l0(f,0,r),k=r+f|0,i[o+12>>2]=k,i[o+8>>2]=k,i[o+4>>2]=f}r&&z(f,e,r),f=v-16|0,v=f,k=o+4|0,s=i[k>>2],e=u[s|0]>>>1|0;e:{r:{f:{if(r=i[A+132>>2],n=i[A+136>>2],(r|0)!=(n|0))for(;;){if((e|0)==u[r+1|0]){if(n=i[r+4>>2],e=i[r+8>>2],(n|0)!=(e|0))for(w=i[k+4>>2],l=w-s|0;;){if(A=0,_=i[n>>2],h=i[n+4>>2]-_|0,B=l>>>0<h>>>0?l:h,!B)break r;for(;;){if(u[A+_|0]==u[A+s|0]){if(A=A+1|0,(B|0)!=(A|0))continue;break r}break}if(n=n+12|0,(e|0)==(n|0))break}if(e>>>0<o0[r+12>>2]){if(i[e+8>>2]=0,i[e>>2]=0,i[e+4>>2]=0,A=i[k+4>>2],n=i[k>>2],(A|0)!=(n|0)){if(A=A-n|0,(A|0)<0)break f;k=C(A),i[e+4>>2]=k,i[e>>2]=k,l=A+k|0,i[e+8>>2]=l,A&&z(k,n,A),i[e+4>>2]=l}i[r+8>>2]=e+12;break e}m=r,G=ii(r+4|0,k),i[m+8>>2]=G;break e}if(r=r+16|0,(n|0)==(r|0))break}i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,t[f+1|0]=e,t[f|0]=1,r=ii(f+4|0,k),e=i[A+136>>2],i[f+8>>2]=r;A:{if(e>>>0<o0[A+140>>2]){r=p[f>>1],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,X[e>>1]=r,r=i[f+4>>2],k=i[f+8>>2],Oe(e+4|0,r,k,(k-r|0)/12|0),e=e+16|0;break A}e=St(A+132|0,f)}if(i[A+136>>2]=e,e=i[f+4>>2],!e)break e;if(r=i[f+8>>2],A=e,(r|0)!=(e|0)){for(;A=r-12|0,k=i[A>>2],k&&(i[r-8>>2]=k,Z(k)),r=A,(r|0)!=(e|0););A=i[f+4>>2]}i[f+8>>2]=e,Z(A);break e}s0(),M()}if((k|0)==(n|0)|l>>>0>=h>>>0)break e;$4(n,s,w,l)}v=f+16|0,A=i[o+4>>2],A&&(i[o+8>>2]=A,Z(A)),v=o+16|0;return}s0(),M()}function kG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;o=v-16|0,v=o;i:{if(!(f&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}i[f>>2]=0,k=i[e>>2],e=i[k+48>>2],l=i[k+52>>2],l&&(i[l+4>>2]=i[l+4>>2]+1);e:{if(!P3(e,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3737;break e}k=v-32|0,v=k,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,L1(k,e,r,k+20|0);r:{if(i[k>>2]){i[o+8>>2]=0,i[o+12>>2]=0;break r}f:{if(n=i[k+20>>2],r=i[k+24>>2],(n|0)!=(r|0)){if(e=i[n>>2],e&&(s=i[o+12>>2],e=Z0(e,92792,92848),e))break f;if(n=n+8|0,(r|0)!=(n|0))for(;;){if(e=i[n>>2],e&&(s=0,e=Z0(e,92792,92848),e))break f;if(n=n+8|0,(r|0)==(n|0))break}i[o+8>>2]=0,i[o+12>>2]=0}i[o+8>>2]=0,i[o+12>>2]=0;break r}if(i[o+12>>2]=s,i[o+8>>2]=e,e=i[n+4>>2],i[o+12>>2]=e,!e)break r;i[e+4>>2]=i[e+4>>2]+1}if(t[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(e=r,n=i[k+24>>2],(e|0)!=(n|0)){for(;;){e=i[n-4>>2];r:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(n=n-8|0,(r|0)==(n|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}if(v=k+32|0,e=i[o+8>>2],e&&(r=C(24),i[f>>2]=r,f=i[e+124>>2],i[r+16>>2]=i[e+120>>2],i[r+20>>2]=f,f=i[e+116>>2],i[r+8>>2]=i[e+112>>2],i[r+12>>2]=f,f=i[e+108>>2],i[r>>2]=i[e+104>>2],i[r+4>>2]=f),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[o+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break i;W[i[i[l>>2]+8>>2]](l),y(l)}v=o+16|0}function U8(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;i:{if(r=i[A>>2],n=i[A+4>>2]-r|0,f=((n|0)/44|0)+1|0,f>>>0<97612894){if(k=(i[A+8>>2]-r|0)/44|0,r=k<<1,r=k>>>0>=48806446?97612893:f>>>0<r>>>0?r:f,r>>>0>=97612894)break i;if(h=g(r,44),w=C(h),k=n+w|0,r=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=r,n=u[e+25|0]|u[e+26|0]<<8|(u[e+27|0]<<16|u[e+28|0]<<24),r=u[e+21|0]|u[e+22|0]<<8|(u[e+23|0]<<16|u[e+24|0]<<24),t[k+21|0]=r,t[k+22|0]=r>>>8,t[k+23|0]=r>>>16,t[k+24|0]=r>>>24,t[k+25|0]=n,t[k+26|0]=n>>>8,t[k+27|0]=n>>>16,t[k+28|0]=n>>>24,r=i[e+20>>2],i[k+16>>2]=i[e+16>>2],i[k+20>>2]=r,r=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=r,i[k+40>>2]=i[e+40>>2],r=i[e+36>>2],i[k+32>>2]=i[e+32>>2],i[k+36>>2]=r,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,l=i[A+4>>2],n=i[A>>2],r=k+g((l-n|0)/-44|0,44)|0,(n|0)!=(l|0)){for(e=n,f=r;o=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=o,s=u[e+25|0]|u[e+26|0]<<8|(u[e+27|0]<<16|u[e+28|0]<<24),o=u[e+21|0]|u[e+22|0]<<8|(u[e+23|0]<<16|u[e+24|0]<<24),t[f+21|0]=o,t[f+22|0]=o>>>8,t[f+23|0]=o>>>16,t[f+24|0]=o>>>24,t[f+25|0]=s,t[f+26|0]=s>>>8,t[f+27|0]=s>>>16,t[f+28|0]=s>>>24,o=i[e+20>>2],i[f+16>>2]=i[e+16>>2],i[f+20>>2]=o,o=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=o,i[f+40>>2]=i[e+40>>2],o=i[e+36>>2],i[f+32>>2]=i[e+32>>2],i[f+36>>2]=o,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,f=f+44|0,e=e+44|0,(l|0)!=(e|0););for(;t[n+43|0]<0&&Z(i[n+32>>2]),n=n+44|0,(l|0)!=(n|0););n=i[A>>2]}return e=k+44|0,i[A+4>>2]=e,i[A>>2]=r,i[A+8>>2]=h+w,n&&Z(n),e}s0(),M()}x0(),M()}function nG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,n=i[19620],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19621],o=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(o,k),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(k),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,k0(k,r),l=n,s=k,n=t[f+159|0],k=(n|0)<0,F(l,k?i[f+148>>2]:s,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(f+8|0,34001,18),p[e+4>>1]),47878,1),k=f+148|0,k0(k,r),s=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:s,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(n,34092,26),p[e+6>>1]),47878,1),k=f+148|0,k0(k,r),s=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:s,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(n,33644,21),p[e+8>>1]),47878,1),k=f+148|0,k0(k,r),s=k,r=t[f+159|0],k=(r|0)<0,F(n,k?i[f+148>>2]:s,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(i1(F(n,35652,17),u[e+10|0]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,n,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function tG(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0;if(A=v-144|0,v=A,i[A+136>>2]=r,i[A+140>>2]=e,i[A+20>>2]=2127,s=A+20|0,h=J1(A+24|0,A+32|0,s),l=A+16|0,e=i[k+28>>2],i[l>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(l,137008),t[A+15|0]=0,j9(A+140|0,r,f,l,i[k+4>>2],n,A+15|0,e,h,s,A+132|0)){r=v-16|0,v=r;i:if(u[o+11|0]>>>7|0)break i;i:{if(u[o+11|0]>>>7|0){f=i[o>>2],t[r+15|0]=0,t[f|0]=u[r+15|0],i[o+4>>2]=0;break i}t[r+14|0]=0,t[o|0]=u[r+14|0],t[o+11|0]=u[o+11|0]&128,t[o+11|0]=u[o+11|0]&127}for(v=r+16|0,u[A+15|0]==1&&Ai(o,W[i[i[e>>2]+28>>2]](e,45)|0),e=W[i[i[e>>2]+28>>2]](e,48)|0,r=i[h>>2],s=i[A+20>>2],f=s-1|0,e=e&255;;){if(!((e|0)!=u[r|0]|r>>>0>=f>>>0)){r=r+1|0;continue}break}f=v-16|0,v=f,u[o+11|0]>>>7|0?k=i[o+4>>2]:k=u[o+11|0]&127,l=u[o+11|0]>>>7|0?(i[o+8>>2]&2147483647)-1|0:10,w=s-r|0;i:{if(!w)break i;if(u[o+11|0]>>>7|0?e=i[o>>2]:e=o,B=e,u[o+11|0]>>>7|0?e=i[o>>2]:e=o,u[o+11|0]>>>7|0?_=i[o+4>>2]:_=u[o+11|0]&127,!q5(B,(e+_|0)+1|0,r)){w>>>0>l-k>>>0&&f5(o,l,w+(k-l|0)|0,k,k),u[o+11|0]>>>7|0?e=i[o>>2]:e=o,e=e+k|0,l=s-r|0,s=!l,s|s||z(e,r,l),t[f+15|0]=0,t[e+l|0]=u[f+15|0],J6(o,k+w|0);break i}e=v-16|0,v=e,ul(f,r,s),v=e+16|0,u[f+11|0]>>>7|0?e=i[f>>2]:e=f,u[f+11|0]>>>7|0?r=i[f+4>>2]:r=u[f+11|0]&127,ae(o,e,r),_2(f)}v=f+16|0}return d2(A+140|0,A+136|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+140>>2],i2(A+16|0),e=i[h>>2],i[h>>2]=0,e&&W[i[h+4>>2]](e),v=A+144|0,r|0}function oG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,34559,22),i[e+100>>2]),47878,1),n=f+148|0,k0(n,r),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,33187,17),p[e+104>>1]),47878,1),n=f+148|0,k0(n,r),l=k,r=t[f+159|0],k=(r|0)<0,F(l,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,32920,17),p[e+106>>1]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function lG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,n=i[19620],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19621],o=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(o,k),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(k),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,J2(k,e,r),l=n,s=k,n=t[f+159|0],k=(n|0)<0,F(l,k?i[f+148>>2]:s,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,k0(n,r),l=n,n=t[f+159|0],k=(n|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(f+8|0,36985,10),i[e+104>>2]),47878,1),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],s=(k|0)<0,F(n,s?i[f+148>>2]:l,s?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(n,37646,15),i[i[e+108>>2]>>2]),47878,1),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(n,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(n,37629,16),i[i[e+108>>2]+4>>2]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,n,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function uG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(D0(F(D0(F(D0(F(D0(F(k,36294,16),i[e+100>>2]),24035,1),i[e+104>>2]),30878,3),i[e+108>>2]),24035,1),i[e+112>>2]),47878,1),n=f+148|0,k0(n,r),o=k,r=t[f+159|0],k=(r|0)<0,F(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(D0(F(D0(F(D0(F(f+8|0,33517,8),i[e+116>>2]),24035,1),i[e+120>>2]),32823,3),i[e+124>>2]),24035,1),i[e+128>>2]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function sG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;l=v-48|0,v=l;i:{e:{if(!f){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break e}i[f>>2]=0,k=i[e>>2],i[l+44>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,o=i[k+328>>2],s=i[k+332>>2];r:{if((o|0)!=(s|0)){if(k=s-o|0,(k|0)<0)break i;for(n=C(k),i[l+36>>2]=n,i[l+44>>2]=k+n,k=n;i[k>>2]=i[o>>2],h=k,k=i[o+4>>2],i[h+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),k=h+8|0,o=o+8|0,(s|0)!=(o|0););for(i[l+40>>2]=k,o=n;;){if(s=i[o>>2],i[s+196>>2]==(r|0)){r=C(16),i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,k=i[o+4>>2];f:{if(!k){i[r+4>>2]=k,i[r>>2]=s;break f}if(i[k+4>>2]=i[k+4>>2]+1,i[r>>2]=s,n=i[r+4>>2],i[r+4>>2]=k,!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break f;W[i[i[n>>2]+8>>2]](n),y(n)}r=i[e+8>>2],f=i[f>>2],n=i[e+12>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=n;f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}r=A,A=i[e>>2],c0(r,114912,A?A+164|0:0),n=i[l+36>>2];break r}if(k=(o|0)!=(h|0),o=o+8|0,!k)break}}if(t[l+4|0]=0,t[l+15|0]=0,r=a(l+16|0,5,2e3,l+4|0),t[l+15|0]<0&&Z(i[l+4>>2]),f=A,A=i[e>>2],c0(f,r,A?A+164|0:0),t[r+19|0]>=0)break r;Z(i[r+8>>2])}if(!n)break e;if(A=n,o=i[l+40>>2],(o|0)!=(n|0)){for(;;){A=i[o-4>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(o=o-8|0,(o|0)==(n|0))break}A=i[l+36>>2]}i[l+40>>2]=n,Z(A)}v=l+48|0;return}s0(),M()}function hG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,n=i[19620],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19621],s=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(s,k),t[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,s=R0(k),i[s>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,K1(k,e,r),o=n,l=k,n=t[f+159|0],k=(n|0)<0,F(o,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(n=0;k=f+148|0,k0(k,r),l=k,k=t[f+159|0],o=(k|0)<0,F(f+8|0,o?i[f+148>>2]:l,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,20885,1),n),46799,2),i[r>>2]=i[r>>2]+1,o=f+148|0,l=i[i[e+104>>2]+(n<<3)>>2],W[i[i[l>>2]+12>>2]](o,l,r),l=k,h=o,k=t[f+159|0],o=(k|0)<0,F(l,o?i[f+148>>2]:h,o?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=i[r>>2],i[r>>2]=((k|0)<=1?1:k)-1,n=n+1|0,n>>>0<i[e+108>>2]-i[e+104>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}n=f+20|0,e=i[f+28>>2]}e:{if(n=i[n>>2],r=e-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,n,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[s>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(s),Y0(f- -64|0),v=f+160|0}function DA(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;r=v-48|0,v=r,n=e+12|0;i:{e:{if(i[e+12>>2]!=i[e+16>>2])break e;if(u[e+8|0]==1){lt(r+24|0,i[e>>2],i[e+32>>2],n);r:{if(i[r+24>>2]){e=i[r+28>>2],i[A>>2]=i[r+24>>2],i[A+4>>2]=e,e=A+8|0;f:{if(t[r+43|0]>=0){f=i[r+36>>2],i[e>>2]=i[r+32>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+40>>2];break f}T(e,i[r+32>>2],i[r+36>>2])}t[A+20|0]=1,e=0;break r}if(D4(r,e+24|0,i[e+16>>2]-i[e+12>>2]|0,i[i[e>>2]+168>>2],29746),k=i[r>>2],k){f=i[e+12>>2],i[e+16>>2]=f;f:{if((f|0)==i[e+20>>2]||(i[e+20>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,!f))break f;Z(f)}e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,e=A+8|0;f:{if(t[r+19|0]>=0){f=i[r+12>>2],i[e>>2]=i[r+8>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+16>>2];break f}T(e,i[r+8>>2],i[r+12>>2])}t[A+20|0]=1}t[r+19|0]<0&&Z(i[r+8>>2]),e=!k}if(t[r+43|0]<0&&Z(i[r+32>>2]),e)break e;break i}if(k=e+24|0,D4(r+24|0,k,i[e+48>>2],i[i[e>>2]+168>>2],29705),o=i[r+24>>2],o){f=i[r+28>>2],i[A>>2]=i[r+24>>2],i[A+4>>2]=f,f=A+8|0;r:{if(t[r+43|0]>=0){l=i[r+36>>2],i[f>>2]=i[r+32>>2],i[f+4>>2]=l,i[f+8>>2]=i[r+40>>2];break r}T(f,i[r+32>>2],i[r+36>>2])}t[A+20|0]=1}if(t[r+43|0]<0&&Z(i[r+32>>2]),o)break i;if(S9(r+24|0,i[e>>2],n,i[e+40>>2],i[e+44>>2],i[e+48>>2]),f=i[r+24>>2],f){k1(k),e=i[r+28>>2],i[A>>2]=i[r+24>>2],i[A+4>>2]=e,e=A+8|0;r:{if(t[r+43|0]>=0){k=i[r+36>>2],i[e>>2]=i[r+32>>2],i[e+4>>2]=k,i[e+8>>2]=i[r+40>>2];break r}T(e,i[r+32>>2],i[r+36>>2])}t[A+20|0]=1}if(t[r+43|0]<0&&Z(i[r+32>>2]),f)break i}t[A+20|0]=0,i[A>>2]=n}v=r+48|0}function wG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;l=v-48|0,v=l;i:{e:{if(r&&(l2(r)|0)==4)break e;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=29268;break i}o=i[e>>2],_=i[o+48>>2],s=i[o+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),w=l+12|0,o=v+-64|0,v=o,r=u[r|0]|u[r+1|0]<<8|(u[r+2|0]<<16|u[r+3|0]<<24),S6(o+24|0,_,r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24));e:{r:switch(u[o+44|0]){default:e2(),M();case 1:r=i[o+28>>2],i[w>>2]=i[o+24>>2],i[w+4>>2]=r,r=w+8|0;f:{if(t[o+43|0]>=0){f=i[o+36>>2],i[r>>2]=i[o+32>>2],i[r+4>>2]=f,i[r+8>>2]=i[o+40>>2];break f}T(r,i[o+32>>2],i[o+36>>2])}t[w+20|0]=1;break e;case 0:break r}if(h=i[o+24>>2],i[o+56>>2]=h,r=i[o+28>>2],i[o+60>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),t[h+164|0]=1,i[h+100>>2]=i[h+100>>2]&-2|1,h=i[h+104>>2],LA(o+4|0,_,o+56|0,f,k,0),t[o+23|0]<0&&Z(i[o+12>>2]),t[w+20|0]=0,i[w>>2]=h,!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;W[i[i[r>>2]+8>>2]](r),y(r)}r=u[o+44|0],(r|0)!=255&&(f=i[25325],i[o+56>>2]=i[25324],i[o+60>>2]=f,W[i[(o+56|0)+(r<<2)>>2]](o+55|0,o+24|0)),v=o- -64|0;e:{if(!s||(r=i[s+4>>2],i[s+4>>2]=r-1,r))break e;W[i[i[s>>2]+8>>2]](s),y(s)}e:{r:{if(r=u[l+32|0],!(r|!n)){i[n>>2]=1;break r}f:switch(r|0){default:e2(),M();case 1:break f;case 0:break r}if(c0(A,l+12|0,i[e>>2]),r=u[l+32|0],(r|0)==255)break i;break e}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],r=0}A=i[25811],i[l+40>>2]=i[25810],i[l+44>>2]=A,W[i[(l+40|0)+(r<<2)>>2]](l+39|0,l+12|0)}v=l+48|0}function kt(A,e,r){var f=0,k=0;f=v-32|0,v=f;i:{e:{r:switch(e|0){case 0:e=C(2),i[A>>2]=e,r=e+2|0,i[A+8>>2]=r,X[e>>1]=1,i[A+4>>2]=r;break i;case 1:e=C(2),i[A>>2]=e,r=e+2|0,i[A+8>>2]=r,X[e>>1]=2,i[A+4>>2]=r;break i;case 2:e=C(2),i[A>>2]=e,r=e+2|0,i[A+8>>2]=r,X[e>>1]=3,i[A+4>>2]=r;break i;case 3:e=C(2),i[A>>2]=e,r=e+2|0,i[A+8>>2]=r,X[e>>1]=4,i[A+4>>2]=r;break i;case 4:e=C(2),i[A>>2]=e,r=e+2|0,i[A+8>>2]=r,X[e>>1]=5,i[A+4>>2]=r;break i;case 5:e=C(2),i[A>>2]=e,r=e+2|0,i[A+8>>2]=r,X[e>>1]=6,i[A+4>>2]=r;break i;case 6:e=C(2),i[A>>2]=e,r=e+2|0,i[A+8>>2]=r,X[e>>1]=7,i[A+4>>2]=r;break i;case 11:e=C(2),i[A>>2]=e,r=e+2|0,i[A+8>>2]=r,X[e>>1]=11,i[A+4>>2]=r;break i;case 12:e=C(2),i[A>>2]=e,r=e+2|0,i[A+8>>2]=r,X[e>>1]=8,i[A+4>>2]=r;break i;case 13:e=C(2),i[A>>2]=e,r=e+2|0,i[A+8>>2]=r,X[e>>1]=9,i[A+4>>2]=r;break i;case 10:f:{if(r>>>0>15)break f;if(e=1<<r,e&21504)break e;if(!(e&43008))break f;e=C(8),i[A>>2]=e,r=e+8|0,i[A+8>>2]=r,X[e>>1]=4,X[e+2>>1]=5,X[e+4>>1]=6,X[e+6>>1]=7,i[A+4>>2]=r;break i}i[f+28>>2]=1,X[f+22>>1]=1010,i[f+24>>2]=f+22,e=i[f+28>>2],i[f+8>>2]=i[f+24>>2],i[f+12>>2]=e,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;f:{A:{if(e=i[f+12>>2],e){if((e|0)<0)break A;e=e<<1,r=C(e),i[A+4>>2]=r,i[A>>2]=r,k=e+r|0,i[A+8>>2]=k,e&&z(r,i[f+8>>2],e),i[A+4>>2]=k}break f}s0(),M()}break i;default:break r}r=C(2),i[A>>2]=r,k=r+2|0,i[A+8>>2]=k,X[r>>1]=e+1e3,i[A+4>>2]=k;break i}e=C(6),i[A>>2]=e,r=e+6|0,i[A+8>>2]=r,X[e+4>>1]=6,X[e>>1]=4,X[e+2>>1]=5,i[A+4>>2]=r}v=f+32|0}function _G(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;l=v-48|0,v=l;i:{e:{if(!f){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break e}k=i[e>>2],i[l+44>>2]=0,i[l+36>>2]=0,i[l+40>>2]=0,o=i[k+212>>2],s=i[k+216>>2];r:{if((o|0)!=(s|0)){if(k=s-o|0,(k|0)<0)break i;for(n=C(k),i[l+36>>2]=n,i[l+44>>2]=k+n,k=n;i[k>>2]=i[o>>2],h=k,k=i[o+4>>2],i[h+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),k=h+8|0,o=o+8|0,(s|0)!=(o|0););for(i[l+40>>2]=k,o=n;;){if(s=i[o>>2],i[s+196>>2]==(r|0)){r=C(16),i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,k=i[o+4>>2];f:{if(!k){i[r+4>>2]=k,i[r>>2]=s;break f}if(i[k+4>>2]=i[k+4>>2]+1,i[r>>2]=s,n=i[r+4>>2],i[r+4>>2]=k,!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break f;W[i[i[n>>2]+8>>2]](n),y(n)}r=i[e+8>>2],f=i[f>>2],n=i[e+12>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=n;f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}r=A,A=i[e>>2],c0(r,114912,A?A+164|0:0),n=i[l+36>>2];break r}if(k=(o|0)!=(h|0),o=o+8|0,!k)break}}if(t[l+4|0]=0,t[l+15|0]=0,r=a(l+16|0,5,2e3,l+4|0),t[l+15|0]<0&&Z(i[l+4>>2]),f=A,A=i[e>>2],c0(f,r,A?A+164|0:0),t[r+19|0]>=0)break r;Z(i[r+8>>2])}if(!n)break e;if(A=n,o=i[l+40>>2],(o|0)!=(n|0)){for(;;){A=i[o-4>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(o=o-8|0,(o|0)==(n|0))break}A=i[l+36>>2]}i[l+40>>2]=n,Z(A)}v=l+48|0;return}s0(),M()}function UA(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0;r=v+-64|0,v=r;i:{if(i[A+80>>2]!=i[A+84>>2])break i;W[i[i[A>>2]+156>>2]](r+40|0,A),e=u[r+60|0];e:{if(!e){if(!i[r+40>>2]){e=0;break e}i[r+36>>2]=99,i[r+32>>2]=99,W[i[i[A>>2]+116>>2]](r+8|0,A,r+36|0,r+32|0),e=i[r+8>>2],t[r+27|0]<0&&Z(i[r+16>>2]);r:{if(e)break r;e=i[A+184>>2],n=i[A+188>>2];f:{if((e|0)==(n|0))break f;A:{for(;;){k:{if(f=i[e>>2],!f||(f=Z0(f,92792,92812),!f))break k;if(e=i[e+4>>2],e)break A;f=i[f+104>>2];break f}if(e=e+8|0,(n|0)==(e|0))break}f=0;break f}if(n=i[e+4>>2],o=n+1|0,i[e+4>>2]=o,f=i[f+104>>2],i[e+4>>2]=n,o)break f;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+184>>2],n=i[A+188>>2];f:{if((e|0)==(n|0))break f;A:{for(;;){k:{if(k=i[e>>2],!k||(k=Z0(k,92792,92812),!k))break k;if(e=i[e+4>>2],e)break A;k=i[k+108>>2];break f}if(e=e+8|0,(n|0)==(e|0))break}k=0;break f}if(n=i[e+4>>2],o=n+1|0,i[e+4>>2]=o,k=i[k+108>>2],i[e+4>>2]=n,o)break f;W[i[i[e>>2]+8>>2]](e),y(e)}e=W[i[i[A>>2]+104>>2]](A)|0,e=(e|0)<=0?8:e,n=W[i[i[A>>2]+108>>2]](A)|0;f:switch(i[r+36>>2]){case 2:$6(A,0,0,e,f,k);break r;case 0:l=i[r+32>>2],o=f-(l-1>>>0<2?f>>>1|0:0)|0,$6(A,0,1,e,f,k),e=(n|0)<=0?e:n,f=k-((l|0)==1?k>>>1|0:0)|0,$6(A,1,2,e,o,f),$6(A,2,3,e,o,f);break r;case 1:break f;default:break r}$6(A,3,4,e,f,k),$6(A,4,5,e,f,k),$6(A,5,6,e,f,k)}e=u[r+60|0]}if((e&255)==255)break i}A=i[26905],i[r+8>>2]=i[26904],i[r+12>>2]=A,W[i[(r+8|0)+((e&255)<<2)>>2]](r+36|0,r+40|0)}v=r- -64|0}function BG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;f=v-96|0,v=f,i[f+92>>2]=0,i[f+88>>2]=0,In(f+76|0,e,r,f+92|0,f+88|0);i:{if(i[f+76>>2]){e=i[f+80>>2],i[A>>2]=i[f+76>>2],i[A+4>>2]=e,i[A+8>>2]=i[f+84>>2];break i}e:{if((r|0)<12||(r=u[e+8|0],!r)||(n=u[e+9|0],!n)||(l=u[e+10|0],!l)||(e=u[e+11|0],!e))break e;k=e|(n<<16|r<<24|l<<8)}i[f+56>>2]=i[14432],e=i[14431],i[f+48>>2]=i[14430],i[f+52>>2]=e,e=i[14429],i[f+40>>2]=i[14428],i[f+44>>2]=e,e=i[14427],i[f+32>>2]=i[14426],i[f+36>>2]=e,e=i[14425],i[f+24>>2]=i[14424],i[f+28>>2]=e,e=i[14423],i[f+16>>2]=i[14422],i[f+20>>2]=e,i[f+68>>2]=0,i[f+72>>2]=0,n=f+68|0,i[f+64>>2]=n,e=i[14421],i[f+8>>2]=i[14420],i[f+12>>2]=e,Ne(f- -64|0,f+8|0,f+60|0);e:{r:{l=i[f+68>>2];f:{A:{k:{if(l){for(r=n,e=l;s=r,h=e,o=o0[e+16>>2]<k>>>0,r=o?r:e,e=i[(o?4:0)+e>>2],!!e;);if((r|0)!=(n|0)&o0[(o?s:h)+16>>2]<=k>>>0)break r;if(k=i[f+92>>2],_=i[f+88>>2],(_|0)<=0)break k;for(o=0;;){for(B=i[(o<<2)+k>>2],r=n,e=l;s=r,h=e,w=o0[e+16>>2]<B>>>0,r=w?r:e,e=i[(w?4:0)+e>>2],!!e;);if(!((r|0)==(n|0)|o0[(w?s:h)+16>>2]>B>>>0)){Z(k),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e;break e}if(o=o+1|0,(_|0)==(o|0))break}break A}k=i[f+92>>2]}if(!k)break f}Z(k)}i[A>>2]=2,i[A+4>>2]=3001,i[A+8>>2]=28554;break e}e=i[f+92>>2],e&&Z(e),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}S1(f- -64|0,i[f+68>>2])}v=f+96|0}function nt(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;f=v-48|0,v=f;i:{e:{if(s=i[r>>2],_=i[r+4>>2],(s|0)!=(_|0))for(B=A+80|0;;){m=p[s>>1],w=i[A+92>>2],i[A+92>>2]=w+1,r=i[e+8>>2],n=i[e+12>>2];r:{if(r>>>0<n>>>0){i[r>>2]=w,r=r+4|0;break r}if(o=i[e+4>>2],r=r-o|0,h=r>>2,k=h+1|0,k>>>0>=1073741824)break e;if(n=n-o|0,l=n>>1,n=n>>>0>=2147483644?1073741823:k>>>0<l>>>0?l:k,n){if(n>>>0>=1073741824)break i;k=C(n<<2)}else k=0;if(l=k+r|0,i[l>>2]=w,h=l-(h<<2)|0,r&&z(h,o,r),i[e+12>>2]=k+(n<<2),r=l+4|0,i[e+8>>2]=r,i[e+4>>2]=h,!o)break r;Z(o)}i[e+8>>2]=r,r=i[e+24>>2],k=i[e+28>>2],o=p[e+20>>1],n=i[e+16>>2],i[f+8>>2]=i[e>>2],X[f+12>>1]=m,i[f+16>>2]=n,X[f+20>>1]=o,i[f+44>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,t[f+32|0]=1,i[f+24>>2]=r,i[f+28>>2]=k,i[f+4>>2]=w,r=i[A+84>>2];r:{if(r>>>0<o0[A+88>>2]){k=i[f+8>>2],i[r>>2]=i[f+4>>2],i[r+4>>2]=k,k=u[f+29|0]|u[f+30|0]<<8|(u[f+31|0]<<16|u[f+32|0]<<24),o=u[f+25|0]|u[f+26|0]<<8|(u[f+27|0]<<16|u[f+28|0]<<24),t[r+21|0]=o,t[r+22|0]=o>>>8,t[r+23|0]=o>>>16,t[r+24|0]=o>>>24,t[r+25|0]=k,t[r+26|0]=k>>>8,t[r+27|0]=k>>>16,t[r+28|0]=k>>>24,k=i[f+24>>2],i[r+16>>2]=i[f+20>>2],i[r+20>>2]=k,k=i[f+16>>2],i[r+8>>2]=i[f+12>>2],i[r+12>>2]=k,i[r+40>>2]=i[f+44>>2],k=i[f+40>>2],i[r+32>>2]=i[f+36>>2],i[r+36>>2]=k,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[A+84>>2]=r+44;break r}if(r=U8(B,f+4|0),k=t[f+47|0],i[A+84>>2]=r,(k|0)>=0)break r;Z(i[f+36>>2])}if(s=s+2|0,(_|0)==(s|0))break}v=f+48|0;return}s0(),M()}x0(),M()}function vG(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;for(m=v-16|0,v=m,s=r;;){i:{if((f|0)==(s|0)){s=f;break i}if(!i[s>>2])break i;s=s+4|0;continue}break}i[l>>2]=n,i[k>>2]=r;i:{for(;;){e:{r:{if(!((r|0)==(f|0)|(n|0)==(o|0))){h=i[e+4>>2],i[m+8>>2]=i[e>>2],i[m+12>>2]=h,Y=1,G=v-16|0,v=G,i[G+12>>2]=i[A+8>>2],E=C8(G+8|0,G+12|0),h=n,w=o-h|0,I=0,Q=v-16|0,v=Q,_=i[k>>2],V=s-r>>2;f:{if(!_|!V)break f;for(w=h?w:0;;){if(B=J3(w>>>0<4?Q+12|0:h,i[_>>2]),(B|0)==-1){I=-1;break f}if(h){if(w>>>0<=3){if(w>>>0<B>>>0)break f;v8(h,Q+12|0,B)}w=w-B|0,h=h+B|0}else h=0;if(!i[_>>2]){_=0;break f}if(I=I+B|0,_=_+4|0,V=V-1|0,!V)break}}h&&(i[k>>2]=_),v=Q+16|0,h=i[E>>2],h&&(i[33178]=(h|0)==-1?132592:h),v=G+16|0;f:{A:{k:switch(I+1|0){case 0:for(i[l>>2]=n;;){if(i[k>>2]==(r|0)||(e=a5(n,i[r>>2],i[A+8>>2]),(e|0)==-1))break A;n=e+i[l>>2]|0,i[l>>2]=n,r=r+4|0}case 1:break i;default:break k}if(n=i[l>>2]+I|0,i[l>>2]=n,(n|0)==(o|0))break f;if((f|0)==(s|0)){r=i[k>>2],s=f;continue}if(r=m+4|0,s=a5(r,0,i[A+8>>2]),(s|0)==-1)break e;if(o-i[l>>2]>>>0<s>>>0)break i;for(;;){if(s){n=u[r|0],h=i[l>>2],i[l>>2]=h+1,t[h|0]=n,s=s-1|0,r=r+1|0;continue}break}for(r=i[k>>2]+4|0,i[k>>2]=r,s=r;;){if((f|0)==(s|0)){s=f;break r}if(!i[s>>2])break r;s=s+4|0}}i[k>>2]=r;break e}r=i[k>>2]}Y=(r|0)!=(f|0);break i}n=i[l>>2];continue}break}Y=2}return v=m+16|0,Y|0}function tt(A,e){var r=0;i[A>>2]=0,i[A+4>>2]=0,t[A+28|0]=e,i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,e=C(160),i[e>>2]=100228,i[e+4>>2]=0,i[e+8>>2]=0,r=e+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[r>>2]=113064,t[e+128|0]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+32>>2]=1935763834,i[A>>2]=r,r=i[A+4>>2],i[A+4>>2]=e;i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;W[i[i[r>>2]+8>>2]](r),y(r)}e=C(168),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=100268,r=e+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[r>>2]=113144,t[e+128|0]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+160>>2]=0,i[e+32>>2]=1935763823,i[A+8>>2]=r,r=i[A+12>>2],i[A+12>>2]=e;i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;W[i[i[r>>2]+8>>2]](r),y(r)}return A}function ot(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0;r=i[A+4>>2],o=i[r+124>>2],i[A+24>>2]=o,w=i[r+132>>2],i[A+28>>2]=w;i:{if(!i[A+12>>2]){_=1,f=1;break i}_=i[o+16852>>2],f=i[o+16856>>2]}i[A+300>>2]=f,i[A+296>>2]=_,Q=g(i[A+20>>2],f),V=i[o+16892>>2],l=i[o+16876>>2],e=i[A+16>>2],Y=g(e,_),Y||(t[A+307|0]=0,t[A+304|0]=0),Q||(t[A+307|0]=0,t[A+305|0]=0,t[A+306|0]=0),R=i[A+8>>2],k=g(e+R|0,_),(k|0)>=i[o+484>>2]&&(t[A+306|0]=0),s=i[r+152>>2],B=Q>>l,x=g(g(s,B),24),G=Y>>l,e=g(G,24),n=i[r+140>>2],N=-1,E=Y-1>>l,U=-1,I=u[A+304|0],U=(I|0)==1?p[(n+g(E,24)|0)+x>>1]:U,h=e+n|0,m=Q-1>>l,r=u[A+305|0],N=(r|0)==1?p[h+g(g(s,m),24)>>1]:N,j=k>>l,O=-1,l=-1,k=u[A+306|0],(k|0)==1&&(l=p[(n+g(j,24)|0)+g(g(s,m),24)>>1]),e=u[A+307|0],(e|0)==1&&(O=p[(n+g(E,24)|0)+g(g(s,m),24)>>1]),s=g(B,V)<<2,n=i[w+8484>>2],w=-1,B=-1,B=I?i[s+(n+(E<<2)|0)>>2]:B,G=n+(G<<2)|0,w=r?i[G+(g(m,V)<<2)>>2]:w,I=-1,r=-1,e&&(r=i[(n+(E<<2)|0)+(g(m,V)<<2)>>2]),h=p[h+x>>1],k&&(I=i[(n+(j<<2)|0)+(g(m,V)<<2)>>2]),e=i[s+G>>2],(h|0)==(U|0)&(e|0)==(B|0)||(t[A+304|0]=0),(h|0)==(N|0)&(e|0)==(w|0)||(t[A+305|0]=0),(h|0)==(O|0)&(e|0)==(r|0)||(t[A+307|0]=0),(l|0)==(h|0)&(e|0)==(I|0)||(t[A+306|0]=0),f=(i[o+488>>2]+((Q^-1)+f|0)|0)/(f|0)|0,k=R<<1,i[A+308>>2]=(k|0)>(f|0)?f:k,e=i[o+484>>2],i[A+316>>2]=0,f=A+160|0,i[A+292>>2]=f,r=A,A=(e+((Y^-1)+_|0)|0)/(_|0)|0,i[r+312>>2]=(A|0)<(k|0)?A:k,A=R<<2|1,A&&l0(f-k|0,0,A)}function mG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;n=v-16|0,v=n,f=C(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=98268,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,X[f+118>>1]=0,X[f+120>>1]=0,X[f+122>>1]=0,X[f+124>>1]=0,X[f+116>>1]=1,X[f+126>>1]=0,X[f+128>>1]=0,X[f+130>>1]=0,X[f+132>>1]=0,X[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,X[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=98308,t[f+159|0]=5,i[f+32>>2]=1781689193,t[f+152|0]=u[21269],o=u[21265]|u[21266]<<8|(u[21267]<<16|u[21268]<<24),t[f+148|0]=o,t[f+149|0]=o>>>8,t[f+150|0]=o>>>16,t[f+151|0]=o>>>24,l=i[r>>2],s=i[r+4>>2];i:{if((l|0)!=(s|0))for(o=f+52|0;;){r=i[l>>2],i[n+8>>2]=r,k=i[l+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1781689160)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1781689160)break r}if(P0(o,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;W[i[i[k>>2]+8>>2]](k),y(k)}if(l=l+8|0,(s|0)==(l|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function MA(A,e,r,f){var k=0,n=0,o=0,l=0;if(k=i[A+8>>2],n=i[A>>2],(k-n|0)/28>>>0>=f>>>0){if(o=f,k=i[A+4>>2],f=k-n|0,o>>>0>(f|0)/28>>>0){if(o=e+f|0,(k|0)!=(n|0)){for(;;){i:{if((e|0)==(n|0)){i[n+12>>2]=i[e+12>>2];break i}k=i[e>>2],f=i[e+4>>2],h1(n,k,f,f-k>>2),i[n+12>>2]=i[e+12>>2],k=i[e+16>>2],f=i[e+20>>2],h1(n+16|0,k,f,f-k>>2)}if(n=n+28|0,e=e+28|0,(o|0)==(e|0))break}k=i[A+4>>2]}if(e=k,(r|0)!=(o|0))for(;Se(e,o),e=e+28|0,o=o+28|0,(o|0)!=(r|0););i[A+4>>2]=(e-k|0)+k;return}if((e|0)!=(r|0)){for(;;){i:{if((e|0)==(n|0)){i[n+12>>2]=i[e+12>>2];break i}k=i[e>>2],f=i[e+4>>2],h1(n,k,f,f-k>>2),i[n+12>>2]=i[e+12>>2],k=i[e+16>>2],f=i[e+20>>2],h1(n+16|0,k,f,f-k>>2)}if(n=n+28|0,e=e+28|0,(r|0)==(e|0))break}k=i[A+4>>2]}if((k|0)!=(n|0))for(;e=i[k-12>>2],e&&(i[k-8>>2]=e,Z(e)),e=k-28|0,r=i[e>>2],r&&(i[k-24>>2]=r,Z(r)),k=e,(n|0)!=(e|0););i[A+4>>2]=n;return}if(n){if(o=n,k=i[A+4>>2],(n|0)!=(k|0)){for(;o=i[k-12>>2],o&&(i[k-8>>2]=o,Z(o)),o=k-28|0,l=i[o>>2],l&&(i[k-24>>2]=l,Z(l)),k=o,(n|0)!=(k|0););o=i[A>>2]}i[A+4>>2]=n,Z(o),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0}i:{if(f>>>0>=153391690||(o=(k|0)/28|0,k=o<<1,f=o>>>0>=76695844?153391689:f>>>0<k>>>0?k:f,f>>>0>=153391690))break i;if(f=g(f,28),n=C(f),i[A+4>>2]=n,i[A>>2]=n,i[A+8>>2]=f+n,(e|0)!=(r|0))for(;Se(n,e),n=n+28|0,e=e+28|0,(r|0)!=(e|0););i[A+4>>2]=n;return}s0(),M()}function k3(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,k0(n,r),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(f+8|0,32961,5),n=f+148|0,Ce(n,e),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=W[i[i[e>>2]+8>>2]](e)|0;i:{if(k){F(F(F(f+8|0,30575,8),k,l2(k)),47877,2);break i}F(f+8|0,47441,7)}k=f+148|0,k0(k,r),n=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(M2(F(f+8|0,36047,6),i[e+8>>2],i[e+12>>2]),35803,17),i[e+32>>2]),47877,2),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function ZG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;o=v-16|0,v=o,f=i[A+8>>2],i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0;i:{e:{r:{n=i[f+12>>2],s=i[f+16>>2];f:{if((n|0)==(s|0)){f=0;break f}if(f=s-n|0,(f|0)<0)break r;for(k=C(f),i[o+4>>2]=k,i[o+12>>2]=f+k,f=k;i[f>>2]=i[n>>2],l=i[n+4>>2],i[f+4>>2]=l,l&&(i[l+4>>2]=i[l+4>>2]+1),f=f+8|0,n=n+8|0,(s|0)!=(n|0););i[o+8>>2]=f}if(f=f-k>>3,l=(r|0)>(f|0)?f:r,(l|0)<=0)break i;for(n=0;;){r=C(24),i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,f=i[A>>2],k=i[A+4>>2];f:{if(!k){i[r+4>>2]=k,i[r>>2]=f;break f}if(i[k+4>>2]=i[k+4>>2]+1,i[r>>2]=f,f=i[r+4>>2],i[r+4>>2]=k,!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[A+8>>2],k=i[A+12>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[r+8>>2]=f,f=i[r+12>>2],i[r+12>>2]=k;f:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[o+4>>2]+(n<<3)|0,s=i[f>>2],k=i[f+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[r+16>>2]=s,f=i[r+20>>2],i[r+20>>2]=k;f:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(i[(n<<2)+e>>2]=r,n=n+1|0,(l|0)==(n|0))break}break e}s0(),M()}k=i[o+4>>2]}if(k){if(f=i[o+8>>2],(k|0)!=(f|0)){for(;;){A=i[f-4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(f=f-8|0,(k|0)==(f|0))break}k=i[o+4>>2]}Z(k)}return v=o+16|0,l|0}function Q4(A,e,r,f,k,n,o,l,s,h){var w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;G=i[A+18592>>2],_=A+18548|0,w=W2(_,i[A+18572>>2]+147|0),B=w<<4&16|u[A+26|0]&-17,t[A+26|0]=B,I=A+16|0;i:{e:{if(w){w=0;r:{if(i[i[A+18592>>2]+812>>2]<2||!W2(_,i[A+18572>>2]+148|0)||(w=32,i[i[A+18592>>2]+812>>2]<3))break r;for(w=1;B4(_)&&(w=w+1|0,(w|0)<(i[i[A+18592>>2]+812>>2]-1|0)););w=w<<5}l=u[A+26|0]&31|w;break e}w=1;r:{f:{A:{if(!i[G+28>>2]){if(w=i[A+18572>>2],(n+o|0)==12||!W2(_,(l+w|0)+156|0))break A;B=u[A+26|0],w=3}t[A+26|0]=B&252|w;break f}if(w=W2(_,w+160|0)+1|0,t[A+26|0]=w&3|u[A+26|0]&252,B=2,(w|0)==2)break r}B=w,w=0,l=i[G+336>>2];f:{if((l|0)<2||!W2(_,i[A+18572>>2]+154|0))break f;if(m=l-2|0,!m){w=1;break f}if(w=1,!W2(_,i[A+18572>>2]+155|0))break f;for(l=l-1|0;;){if((w|0)==(m|0)){w=l;break f}if(w=w+1|0,!B4(_))break}}if(t[A+16|0]=w,bl(A,0),Q=A,V=W2(_,i[A+18572>>2]+152|0)<<2&4|u[A+26|0]&251,t[Q+26|0]=V,(B|0)==1)break i}w=0,l=i[G+340>>2];r:{if((l|0)<2||!W2(_,i[A+18572>>2]+154|0))break r;if(m=l-2|0,!m){w=1;break r}if(w=1,!W2(_,i[A+18572>>2]+155|0))break r;for(l=l-1|0;;){if((w|0)==(m|0)){w=l;break r}if(w=w+1|0,!B4(_))break}}t[A+17|0]=w;r:{if(!(!u[G+378|0]|(B|0)!=3)){X[A+22>>1]=0,X[A+24>>1]=0;break r}bl(A,1)}l=W2(_,i[A+18572>>2]+152|0)<<3&8|u[A+26|0]&-9}t[A+26|0]=l}V9(i[A+18584>>2],i[A+18592>>2],i[A+18588>>2],I,e,r,f,k,s,n,o,h)}function gG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,K1(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,B0(F(k,36808,15),p[e+104>>1]),p[e+104>>1]||F(k,29408,7),k=F(f+8|0,47878,1),n=f+148|0,k0(n,r),l=n,r=t[f+159|0],n=(r|0)<0,F(k,n?i[f+148>>2]:l,n?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(B0(F(B0(F(k,34193,10),p[e+106>>1]),32824,2),p[e+108>>1]),32824,2),p[e+110>>1]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function GG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78164,i[f+8>>2]=78144,n=i[19545],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[19546],i[f+4>>2]=0,n=i[i[f>>2]-12>>2]+f|0,o=f+12|0,J0(n,o),t[n+80|0]=0,i[n+72>>2]=0,n=i[19547],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19548],k=i[19544],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[19549],i[f+64>>2]=78164,i[f>>2]=78124,i[f+8>>2]=78144,o=R0(o),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,J2(k,e,r),s=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:s,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),s=k,k=t[f+159|0],l=(k|0)<0,F(n,l?i[f+148>>2]:s,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(n,33154,22),p[e+98>>1]),47878,1),k=f+148|0,A3(k,e,r,0),e=t[f+159|0],r=(e|0)<0,F(n,r?i[f+148>>2]:k,r?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,n,e)}t[A+e|0]=0,A=i[19543],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[19551],i[f+8>>2]=i[19552],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function lt(A,e,r,f){var k=0,n=0,o=0,l=0;k=v-160|0,v=k,o=i[e+64>>2];i:{if(!o){if(t[k+12|0]=0,t[k+23|0]=0,a(A,2,110,k+12|0),t[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}e:{if(n=i[o+104>>2],l=i[o+108>>2],(n|0)==(l|0))break e;for(;;){if(i[n>>2]!=(r|0)){if(n=n+32|0,(l|0)!=(n|0))continue;break e}break}gi(A,o,r,e+8|0,e+72|0,f,i[e+168>>2]);break i}i[k+104>>2]=0,i[k+76>>2]=78164,i[k+20>>2]=78144,e=i[19545],i[k+12>>2]=e,f=i[e-12>>2],e=k+12|0,i[f+e>>2]=i[19546],i[k+16>>2]=0,f=e+i[i[k+12>>2]-12>>2]|0,n=k+24|0,J0(f,n),t[f+80|0]=0,i[f+72>>2]=0,f=i[19547],i[k+20>>2]=f,o=k+20|0,i[o+i[f-12>>2]>>2]=i[19548],f=i[19544],i[k+12>>2]=f,i[e+i[f-12>>2]>>2]=i[19549],i[k+76>>2]=78164,i[k+12>>2]=78124,i[k+20>>2]=78144,f=R0(n),i[f>>2]=77200,e=k- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,F(B0(F(o,32809,13),r),20598,23),e=i[k+72>>2];e:{r:{if(e&16){n=i[k+68>>2],e=i[k+48>>2],n>>>0<e>>>0&&(i[k+68>>2]=e,n=e),e=k+44|0;break r}if(!(e&8)){n=0,t[k+11|0]=0,r=k;break e}n=i[k+40>>2],e=k+32|0}r:{if(e=i[e>>2],n=n-e|0,n>>>0<2147483640){if(n>>>0>=11){o=n|7,r=C(o+1|0),i[k+8>>2]=o-2147483647,i[k>>2]=r,i[k+4>>2]=n;break r}if(t[k+11|0]=n,r=k,n)break r;n=0;break e}I0(),M()}if(!n)break e;z(r,e,n)}t[r+n|0]=0,a(A,2,117,k),t[k+11|0]<0&&Z(i[k>>2]),A=i[19543],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[19551],i[k+20>>2]=i[19552],i[f>>2]=77200,t[k+67|0]<0&&Z(i[k+56>>2]),y0(f),Y0(k+76|0)}v=k+160|0}function WG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;n=v-16|0,v=n,f=C(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=98268,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,X[f+118>>1]=0,X[f+120>>1]=0,X[f+122>>1]=0,X[f+124>>1]=0,X[f+116>>1]=1,X[f+126>>1]=0,X[f+128>>1]=0,X[f+130>>1]=0,X[f+132>>1]=0,X[f+134>>1]=0,i[f+156>>2]=0,i[f+160>>2]=-65512,X[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=98308,t[f+159|0]=8,i[f+32>>2]=1781689193,t[f+148|0]=74,t[f+149|0]=80,t[f+150|0]=69,t[f+151|0]=71,t[f+152|0]=50,t[f+153|0]=48,t[f+154|0]=48,t[f+155|0]=48,o=i[r>>2],l=i[r+4>>2];i:{if((o|0)!=(l|0))for(s=f+52|0;;){r=i[o>>2],i[n+8>>2]=r,k=i[o+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1781689160)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1781689160)break r}if(P0(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;W[i[i[k>>2]+8>>2]](k),y(k)}if(o=o+8|0,(l|0)==(o|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function XG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+12>>2];i:{if(!k&o0[e+8>>2]>=o0[e+32>>2]|k){k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),r=F(f+8|0,33932,22),k=i[e+8>>2],n=i[e+32>>2],F(M2(r,k-n|0,i[e+12>>2]-(k>>>0<n>>>0)|0),47878,1);break i}e=f+148|0,k0(e,r),k=e,e=t[f+159|0],r=(e|0)<0,F(f+8|0,r?i[f+148>>2]:k,r?i[f+152>>2]:e),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,38502,32)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function IG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,K1(n,e,r),o=k,s=n,k=t[f+159|0],n=(k|0)<0,F(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(k=0;n=f+148|0,k0(n,r),s=n,n=t[f+159|0],o=(n|0)<0,F(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(f+8|0,20885,1),k),3170,6),o=i[i[n>>2]-12>>2]+n|0,i[o+4>>2]=i[o+4>>2]&-75|8,n=B0(n,i[i[e+104>>2]+(k<<2)>>2]),o=i[i[n>>2]-12>>2]+n|0,i[o+4>>2]=i[o+4>>2]&-75|2,F(n,47878,1),k=k+1|0,k>>>0<i[e+108>>2]-i[e+104>>2]>>2>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,t[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(t[A+11|0]=k,k)break e;k=0;break i}I0(),M()}if(!k)break i;z(A,r,k)}t[A+k|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function QG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;n=v-16|0,v=n,f=C(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=96948,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,X[f+118>>1]=0,X[f+120>>1]=0,X[f+122>>1]=0,X[f+124>>1]=0,X[f+116>>1]=1,X[f+126>>1]=0,X[f+128>>1]=0,X[f+130>>1]=0,X[f+132>>1]=0,X[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,X[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=96988,t[f+159|0]=3,i[f+32>>2]=1987470129,t[f+151|0]=0,t[f+150|0]=u[21658],k=u[21656]|u[21657]<<8,t[f+148|0]=k,t[f+149|0]=k>>>8,k=i[r>>2],l=i[r+4>>2];i:{if((k|0)!=(l|0))for(s=f+52|0;;){o=i[k>>2],i[n+8>>2]=o,r=i[k+4>>2],i[n+12>>2]=r;e:{r:{f:{if(!r){if(i[o+16>>2]==1987470147)break f;break e}if(i[r+4>>2]=i[r+4>>2]+1,i[o+16>>2]!=1987470147)break r}if(P0(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,A=i[n+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}if(o=i[r+4>>2],i[r+4>>2]=o-1,o)break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=k+8|0,(l|0)==(k|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function VG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;n=v-16|0,v=n,f=C(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=98548,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,X[f+118>>1]=0,X[f+120>>1]=0,X[f+122>>1]=0,X[f+124>>1]=0,X[f+116>>1]=1,X[f+126>>1]=0,X[f+128>>1]=0,X[f+130>>1]=0,X[f+132>>1]=0,X[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,X[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=98588,t[f+159|0]=3,i[f+32>>2]=1635148593,t[f+151|0]=0,t[f+150|0]=u[21722],k=u[21720]|u[21721]<<8,t[f+148|0]=k,t[f+149|0]=k>>>8,k=i[r>>2],l=i[r+4>>2];i:{if((k|0)!=(l|0))for(s=f+52|0;;){o=i[k>>2],i[n+8>>2]=o,r=i[k+4>>2],i[n+12>>2]=r;e:{r:{f:{if(!r){if(i[o+16>>2]==1635148611)break f;break e}if(i[r+4>>2]=i[r+4>>2]+1,i[o+16>>2]!=1635148611)break r}if(P0(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,A=i[n+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}if(o=i[r+4>>2],i[r+4>>2]=o-1,o)break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=k+8|0,(l|0)==(k|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function pG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0;k=v-16|0,v=k,f=i[e+12>>2],A=i[e+4>>2],n=(f+A|0)-1|0,o=(n|0)%(f|0)|0,l=(f+((A|0)/u[r+50|0]|0)|0)-1|0,s=(l|0)%(f|0)|0,h=i[e+8>>2],w=(h|0)/u[r+51|0]|0;i:{e:{r:{f:{if(A=u[r+48|0],(A-8&255)>>>0<9){if(f=u[r+49|0],(f-8&255)>>>0>=9)break f;if(e=0,i[k+4>>2]=0,o=n-o|0,A=_3(k+4|0,16,g(g(o,h),(A+7&248)>>>3|0)),h=i[k+4>>2],n=A?0:h,!i[r+20>>2]){if(w=0,s=0,!n)break e;break r}if(i[k+8>>2]=0,s=l-s|0,A=g(g(w,s),(f+7&248)>>>3|0),f=_3(k+8|0,16,A),e=i[k+8>>2],i[k+12>>2]=0,A=_3(k+12|0,16,A),w=i[k+12>>2],l=A?0:w,A=f?0:e,!(!n||!A|!l))break r;if(n&&Z(n),A&&Z(A),e=0,!l)break e;Z(l);break e}U0(23e3,19968,117,7772),M()}U0(23046,19968,118,7772),M()}if(i[r+292>>2]=0,i[r+4>>2]=n,i[r+40>>2]=o,i[r+8>>2]=e,i[r+296>>2]=0,i[r+300>>2]=0,i[r+12>>2]=w,i[r+44>>2]=s,A=i[i[r+124>>2]+16832>>2],A-1>>>0<=7)A=g(o,i[r+28>>2]);else{if(A-9>>>0>=8)break i;A=g(o,i[r+28>>2])<<1}A&&l0(h,0,A),e=i[r+8>>2];r:{if(!e)break r;if(A=i[i[r+124>>2]+16840>>2],A-1>>>0<=7)A=g(i[r+36>>2],i[r+44>>2]);else{if(A-9>>>0>=8)break i;A=g(i[r+44>>2],i[r+36>>2])<<1}if(!A)break r;l0(e,0,A)}if(e=1,f=i[r+12>>2],!f)break e;if(A=i[i[r+124>>2]+16840>>2],A-1>>>0<=7){if(A=g(i[r+36>>2],i[r+44>>2]),!A)break e;l0(f,0,A);break e}if(A-9>>>0>=8)break i;if(A=g(i[r+44>>2],i[r+36>>2])<<1,!A)break e;l0(f,0,A)}return v=k+16|0,e|0}U0(23433,19968,545,14016),M()}function ut(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0;A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:if((f-r|0)<3)break i;i:{e:{r:{for(;;){if(!(r>>>0>=f>>>0|n>>>0>=o>>>0)){e=2,B=r,h=u[r|0];f:{if(h<<24>>24>=0){X[n>>1]=h,e=1;break f}if(h>>>0<194)break e;if(h>>>0<=223){if(s=1,(f-r|0)<2)break i;if(s=u[r+1|0],(s&192)!=128)break r;X[n>>1]=s&63|h<<6&1984,e=2;break f}if(h>>>0<=239){if(e=1,w=f-r|0,(w|0)<2)break r;s=t[r+1|0];A:{k:{if((h|0)!=237){if((h|0)!=224)break k;if((s&-32)!=-96)break e;break A}if((s|0)>=-96)break e;break A}if((s|0)>-65)break e}if((w|0)==2)break r;if(e=u[r+2|0],(e&192)!=128)break e;X[n>>1]=e&63|((s&63)<<6|h<<12),e=3;break f}if(h>>>0>244)break e;if(e=1,w=f-r|0,(w|0)<2)break r;_=u[r+1|0],s=_<<24>>24;A:{k:switch(h-240|0){case 0:if((s+112&255)>>>0>=48)break e;break A;case 4:if((s|0)>=-112)break e;break A;default:break k}if((s|0)>-65)break e}if((w|0)==2)break r;if(s=u[r+2|0],(s&192)!=128)break e;if((w|0)==3)break r;if(w=u[r+3|0],(w&192)!=128)break e;if((o-n|0)<3||(e=2,w=w&63,r=s<<6,h=h&7,(w|(r&4032|(_<<12&258048|h<<18)))>>>0>1114111))break r;X[n+2>>1]=w|r&960|56320,e=_<<2,X[n>>1]=(s>>>4&3|(e&192|h<<8|e&60))+16320|55296,n=n+2|0,e=4}r=B+e|0,i[A+12>>2]=r,n=n+2|0,i[A+8>>2]=n;continue}break}e=r>>>0<f>>>0}s=e;break i}s=2}return i[k>>2]=i[A+12>>2],i[l>>2]=i[A+8>>2],v=A+16|0,s|0}function FG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),r=f+8|0,F(r,34874,18),k=i[e+104>>2];i:{if((k|0)==i[e+108>>2]||(D0(r,u[k|0]),r=1,i[e+108>>2]-i[e+104>>2]>>>0<=1))break i;for(;k=f+8|0,F(k,29397,1),D0(k,u[i[e+104>>2]+r|0]),r=r+1|0,r>>>0<i[e+108>>2]-i[e+104>>2]>>>0;);}F(f+8|0,47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function CG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),r=f+8|0,B0(F(r,37536,4),(i[e+116>>2]-i[e+112>>2]|0)/12|0),D0(F(r,37662,7),i[e+104>>2]-i[e+100>>2]&255),F(r,37685,5),r=i[e+100>>2],e=i[e+104>>2],(r|0)!=(e|0))for(;F(D0(f+8|0,u[r|0]),37811,2),r=r+1|0,(e|0)!=(r|0););F(f+8|0,47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function YG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;n=v+-64|0,v=n;i:{if(i4(e,91428,0)){i[r>>2]=0,f=1;break i}e:{if(u[A+8|0]&24)k=1;else{if(!e||(o=Z0(e,91032,91128),!o))break e;k=(u[o+8|0]&24)!=0}k=i4(A,e,k)}if(k){if(f=1,A=i[r>>2],!A)break i;i[r>>2]=i[A>>2];break i}e:{if(!e)break e;if(o=Z0(e,91032,91176),!o||(e=i[r>>2],e&&(i[r>>2]=i[e>>2]),k=i[o+8>>2],e=i[A+8>>2],k&(e^-1)&7|e&(k^-1)&96)||(f=1,i4(i[A+12>>2],i[o+12>>2],0)))break i;if(i4(i[A+12>>2],91416,0)){if(A=i[o+12>>2],!A)break i;f=!Z0(A,91032,91224);break i}if(k=i[A+12>>2],!k)break e;if(f=0,e=Z0(k,91032,91176),e){if(!(t[A+8|0]&1))break i;A=i[o+12>>2],r=0;r:{f:{for(;;){if(f=0,!A)break r;if(A=Z0(A,91032,91176),!A|i[A+8>>2]&(i[e+8>>2]^-1))break f;if(f=1,i4(i[e+12>>2],i[A+12>>2],0))break r;if(!(t[e+8|0]&1)||(f=i[e+12>>2],!f))break f;if(e=Z0(f,91032,91176),e){A=i[A+12>>2];continue}break}if(e=Z0(f,91032,91276),!e)break f;r=cu(e,i[A+12>>2])}f=r}break i}if(e=Z0(k,91032,91276),e){if(!(t[A+8|0]&1))break i;f=cu(e,i[o+12>>2]);break i}if(k=Z0(k,91032,91080),!k||(A=i[o+12>>2],!A)||(A=Z0(A,91032,91080),!A))break i;e=i[r>>2],l0(n+8|0,0,56),t[n+59|0]=(e|0)!=0,i[n+16>>2]=-1,i[n+12>>2]=k,i[n+4>>2]=A,i[n+52>>2]=1,W[i[i[A>>2]+28>>2]](A,n+4|0,e,1),A=i[n+28>>2],(A|0)==1&&(i[r>>2]=e?i[n+20>>2]:0),f=(A|0)==1;break i}f=0}return v=n- -64|0,f|0}function n3(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0;B=v-128|0,v=B,i[B+124>>2]=e,i[B+16>>2]=2126,h=B+16|0,m=J1(B+8|0,0,h);i:{e:{r:{if(_=(f-r|0)/12|0,_>>>0>=101){if(h=E2(_),!h)break r;e=i[m>>2],i[m>>2]=h,e&&W[i[m+4>>2]](e)}for(l=h,e=r;;)if((e|0)==(f|0))f:for(;;){if(e=B+124|0,Y=d2(A,e),E=1,R=_,R?Y:E)for(d2(A,e)&&(i[n>>2]=i[n>>2]|2);;){if((r|0)==(f|0))break e;if(u[h|0]==2)break i;h=h+1|0,r=r+12|0}e=i[A>>2],l=i[e+12>>2];A:{if((l|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break A}e=t[l|0]}for(I=e<<24>>24,o||(I=W[i[i[k>>2]+12>>2]](k,I)|0),s=Q+1|0,V=0,l=h,e=r;;)if((e|0)==(f|0)){if(Q=s,!V||(A4(A),l=h,e=r,_+G>>>0<2))continue f;for(;;){if((e|0)==(f|0))continue f;u[e+11|0]>>>7|0?s=i[e+4>>2]:s=u[e+11|0]&127,(s|0)==(Q|0)|u[l|0]!=2||(t[l|0]=0,G=G-1|0),l=l+1|0,e=e+12|0}}else{A:{if(u[l|0]!=1)break A;u[e+11|0]>>>7|0?w=i[e>>2]:w=e,w=t[w+Q|0],o||(w=W[i[i[k>>2]+12>>2]](k,w)|0);k:{if((I|0)==(w|0)){if(V=1,u[e+11|0]>>>7|0?w=i[e+4>>2]:w=u[e+11|0]&127,(w|0)!=(s|0))break A;t[l|0]=2,G=G+1|0;break k}t[l|0]=0}_=_-1|0}l=l+1|0,e=e+12|0;continue}}else{u[e+11|0]>>>7|0?s=i[e+4>>2]:s=u[e+11|0]&127,s=!s,t[l|0]=s?2:1,l=l+1|0,e=e+12|0,G=G+s|0,_=_-s|0;continue}}N1(),M()}i[n>>2]=i[n>>2]|4}return A=i[m>>2],i[m>>2]=0,A&&W[i[m+4>>2]](A),v=B+128|0,r}function t3(A,e){var r=0,f=0,k=0,n=0,o=0;f=v-48|0,v=f,i[f+44>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,r=i[e+180>>2],k=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),o=i[k+120>>2],k=i[k+124>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[e+180>>2],n=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+28>>2]=i[n+128>>2],n=i[n+132>>2],i[f+32>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1);i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;W[i[i[r>>2]+8>>2]](r),y(r)}Vn(f+8|0,o,i[e+196>>2],f+28|0,f+36|0);i:{if(i[f+8>>2]){if(e=i[f+12>>2],i[A>>2]=i[f+8>>2],i[A+4>>2]=e,e=A+8|0,t[f+27|0]>=0){r=i[f+20>>2],i[e>>2]=i[f+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+24>>2],e=1;break i}T(e,i[f+16>>2],i[f+20>>2]),e=1;break i}e=i[f+44>>2],i[f+44>>2]=0,r=i[f+36>>2],n=i[f+40>>2],i[f+36>>2]=0,i[f+40>>2]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=n,e=0}t[A+20|0]=e,t[f+27|0]<0&&Z(i[f+16>>2]),A=i[f+32>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}if(A=i[f+36>>2],A){if(r=i[f+40>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[f+36>>2]}i[f+40>>2]=A,Z(e)}v=f+48|0}function o3(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0;B=v-128|0,v=B,i[B+124>>2]=e,i[B+16>>2]=2126,h=B+16|0,m=J1(B+8|0,0,h);i:{e:{r:{if(_=(f-r|0)/12|0,_>>>0>=101){if(h=E2(_),!h)break r;e=i[m>>2],i[m>>2]=h,e&&W[i[m+4>>2]](e)}for(l=h,e=r;;)if((e|0)==(f|0))f:for(;;){if(e=B+124|0,Y=b2(A,e),E=1,R=_,R?Y:E)for(b2(A,e)&&(i[n>>2]=i[n>>2]|2);;){if((r|0)==(f|0))break e;if(u[h|0]==2)break i;h=h+1|0,r=r+12|0}e=i[A>>2],l=i[e+12>>2];A:{if((l|0)==i[e+16>>2]){s=W[i[i[e>>2]+36>>2]](e)|0;break A}s=i[l>>2]}for(o||(s=W[i[i[k>>2]+28>>2]](k,s)|0),Q=I+1|0,V=0,l=h,e=r;;)if((e|0)==(f|0)){if(I=Q,!V||(k4(A),l=h,e=r,_+G>>>0<2))continue f;for(;;){if((e|0)==(f|0))continue f;u[e+11|0]>>>7|0?s=i[e+4>>2]:s=u[e+11|0]&127,(s|0)==(I|0)|u[l|0]!=2||(t[l|0]=0,G=G-1|0),l=l+1|0,e=e+12|0}}else{A:{if(u[l|0]!=1)break A;u[e+11|0]>>>7|0?w=i[e>>2]:w=e,w=i[w+(I<<2)>>2],o||(w=W[i[i[k>>2]+28>>2]](k,w)|0);k:{if((s|0)==(w|0)){if(V=1,u[e+11|0]>>>7|0?w=i[e+4>>2]:w=u[e+11|0]&127,(w|0)!=(Q|0))break A;t[l|0]=2,G=G+1|0;break k}t[l|0]=0}_=_-1|0}l=l+1|0,e=e+12|0;continue}}else{u[e+11|0]>>>7|0?s=i[e+4>>2]:s=u[e+11|0]&127,s=!s,t[l|0]=s?2:1,l=l+1|0,e=e+12|0,G=s+G|0,_=_-s|0;continue}}N1(),M()}i[n>>2]=i[n>>2]|4}return A=i[m>>2],i[m>>2]=0,A&&W[i[m+4>>2]](A),v=B+128|0,r}function yG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;n=v-16|0,v=n,f=C(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=96788,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,X[f+118>>1]=0,X[f+120>>1]=0,X[f+122>>1]=0,X[f+124>>1]=0,X[f+116>>1]=1,X[f+126>>1]=0,X[f+128>>1]=0,X[f+130>>1]=0,X[f+132>>1]=0,X[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,X[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=96828,t[f+159|0]=4,i[f+32>>2]=1635135537,t[f+148|0]=65,t[f+149|0]=86,t[f+150|0]=73,t[f+151|0]=70,o=i[r>>2],l=i[r+4>>2];i:{if((o|0)!=(l|0))for(s=f+52|0;;){r=i[o>>2],i[n+8>>2]=r,k=i[o+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1635135811)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1635135811)break r}if(P0(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;W[i[i[k>>2]+8>>2]](k),y(k)}if(o=o+8|0,(l|0)==(o|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function EG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;n=v-16|0,v=n,f=C(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=96628,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,t[f+112|0]=0,X[f+118>>1]=0,X[f+120>>1]=0,X[f+122>>1]=0,X[f+124>>1]=0,X[f+116>>1]=1,X[f+126>>1]=0,X[f+128>>1]=0,X[f+130>>1]=0,X[f+132>>1]=0,X[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,X[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=96668,t[f+159|0]=4,i[f+32>>2]=1752589105,t[f+148|0]=72,t[f+149|0]=69,t[f+150|0]=86,t[f+151|0]=67,o=i[r>>2],l=i[r+4>>2];i:{if((o|0)!=(l|0))for(s=f+52|0;;){r=i[o>>2],i[n+8>>2]=r,k=i[o+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1752589123)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1752589123)break r}if(P0(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;W[i[i[k>>2]+8>>2]](k),y(k)}if(o=o+8|0,(l|0)==(o|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function Ce(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;r=v-144|0,v=r;i:{e:{if(k=i[e+16>>2],(k|0)==1970628964){for(k=0,i[r+84>>2]=0,i[r+56>>2]=78468,f=i[19620],i[r>>2]=f,i[i[f-12>>2]+r>>2]=i[19621],f=i[i[r>>2]-12>>2]+r|0,n=r+4|0,J0(f,n),t[f+80|0]=0,i[f+72>>2]=0,i[r+56>>2]=78468,i[r>>2]=78448,l=R0(n),i[l>>2]=77200,i[r+44>>2]=0,i[r+48>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+52>>2]=16,f=i[r>>2]-12|0,n=i[f>>2]+r|0,i[n+4>>2]=i[n+4>>2]&-75|8,f=i[f>>2]+r|0,u[f+80|0]||(o=r+140|0,n=i[f+28>>2],i[o>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=$0(o,137008),W[i[i[n>>2]+28>>2]](n,32)|0,i2(o)),n=r+56|0,t[f+76|0]=48,t[f+77|0]=0,t[f+78|0]=0,t[f+79|0]=0,t[f+80|0]=1,f=r+12|0;;){r:switch((k&13)-4|0){case 0:case 4:t[r+140|0]=45,F(r,r+140|0,1);break;default:break r}if(i[i[i[r>>2]-12>>2]+f>>2]=2,D0(r,u[i[e+20>>2]+k|0]),k=k+1|0,(k|0)==16)break}break e}z1(A,k);break i}e=i[r+52>>2];e:{r:{if(e&16){f=r+24|0,k=i[r+48>>2],e=i[r+28>>2],k>>>0<e>>>0?i[r+48>>2]=e:e=k;break r}if(!(e&8)){k=0,t[A+11|0]=0;break e}e=i[r+20>>2]}r:{if(f=i[f>>2],k=e-f|0,k>>>0<2147483640){if(k>>>0>=11){o=k|7,e=C(o+1|0),i[A+8>>2]=o-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break r}if(t[A+11|0]=k,k)break r;k=0;break e}I0(),M()}if(!k)break e;z(A,f,k)}t[A+k|0]=0,A=i[19619],i[r>>2]=A,i[i[A-12>>2]+r>>2]=i[19622],i[l>>2]=77200,t[r+47|0]<0&&Z(i[r+36>>2]),y0(l),Y0(n)}v=r+144|0}function RG(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;k=v-32|0,v=k,e=i[A+184>>2],o=i[A+188>>2];i:{if((e|0)==(o|0))break i;e:{for(;;){r:{if(f=i[e>>2],!f||(h=Z0(f,92792,104128),!h))break r;if(n=i[e+4>>2],!n)break e;i[n+4>>2]=i[n+4>>2]+1;break i}if(e=e+8|0,(o|0)==(e|0))break}h=0}n=0}i[k+24>>2]=0,i[k+28>>2]=0,i[k+12>>2]=1768778098,i[k+16>>2]=1668047216,i[k+4>>2]=1752589123,i[k+8>>2]=1769107316,i[k+20>>2]=k+24,s=k+20|0,Ne(s,k+4|0,s),f=v-48|0,v=f,t3(f+12|0,A),r=u[f+32|0];i:{e:{if(!r){if(l=i[f+12>>2],w=i[f+16>>2],(l|0)==(w|0)){r=0;break e}o=s+4|0;r:{for(;;){if(r=i[l>>2],e=i[r+16>>2]==1769173093,r=e?A:r,W[i[i[r>>2]+(e?84:40)>>2]](r)|0){if(_=1,r=i[o>>2],!r)break r;for(B=i[i[l>>2]+16>>2],e=o;m=o0[r+16>>2]<B>>>0,e=m?e:r,r=i[(m?4:0)+r>>2],!!r;);if((e|0)==(o|0)|o0[e+16>>2]>B>>>0)break r}if(l=l+8|0,(w|0)==(l|0))break}_=0}r=u[f+32|0]}if((r&255)==255)break i}A=i[26907],i[f+40>>2]=i[26906],i[f+44>>2]=A,W[i[(f+40|0)+((r&255)<<2)>>2]](f+39|0,f+12|0)}v=f+48|0,S1(s,i[k+24>>2]);i:if(_||(G=1751476579,e=h+100|0,A=i[e+4>>2],A&1073741824|u[e+3|0]==1)||(e=u[e+3|0],A&268435456|(e|0)==3)||(G=1751476600,A&536870912|(e|0)==2))break i;i:{if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n)}return v=k+32|0,G|0}function st(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;B=v-16|0,v=B,s=-9,_=i[A+12>>2],h=i[A+8>>2];i:{if((_|0)==(h|0))break i;for(w=_-h>>2,G=w>>>0<=1?1:w;;){if(m=i[h+(l<<2)>>2],!(u[m+104|0]|i[m+100>>2])){n5(m),_=i[A+12>>2],w=_-i[A+8>>2]>>2,s=l;break i}if(l=l+1|0,(G|0)==(l|0))break}}i:{if((w-1|0)==(s|0)|o0[A+4>>2]>=w>>>0||(l=i[_-4>>2],u[l+104|0]|i[l+100>>2]))break i;Z(A5(l)),_=i[A+12>>2]-4|0,i[A+12>>2]=_}i:{e:{r:{if((s|0)==-9){Q=i[A+8>>2],m=fl(C(416)),l=i[A+12>>2],h=i[A+16>>2];f:{if(l>>>0<h>>>0){i[l>>2]=m,l=l+4|0;break f}if(w=i[A+8>>2],l=l-w|0,I=l>>2,s=I+1|0,s>>>0>=1073741824)break r;if(h=h-w|0,G=h>>1,h=h>>>0>=2147483644?1073741823:s>>>0<G>>>0?G:s,h){if(h>>>0>=1073741824)break e;s=C(h<<2)}else s=0;if(G=s+l|0,i[G>>2]=m,m=G-(I<<2)|0,l&&z(m,w,l),i[A+16>>2]=s+(h<<2),l=G+4|0,i[A+12>>2]=l,i[A+8>>2]=m,!w)break f;Z(w)}i[A+12>>2]=l,s=_-Q>>2}f:{if((s|0)<0){l=i[e+4>>2];break f}if(l=i[e>>2],_=i[l+476>>2],_>>>0>=4)break i;if(A=i[i[A+8>>2]+(s<<2)>>2],w=i[l+488>>2],h=i[l+484>>2],i[B+8>>2]=l,l=i[e+4>>2],i[B+12>>2]=l,l&&(i[l+4>>2]=i[l+4>>2]+1),e=i[B+12>>2],i[B>>2]=i[B+8>>2],i[B+4>>2]=e,e=kn(A,h,w,_,B,1,r,f,k,n,o),e){s=0-e|0;break f}t[A+312|0]=0}f:{if(!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break f;W[i[i[l>>2]+8>>2]](l),y(l)}return v=B+16|0,s}s0(),M()}x0(),M()}U0(24033,20005,263,15567),M()}function K1(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=F(D0(F(f+8|0,34691,9),u[e+97|0]),47878,1),n=f+148|0,k0(n,r),l=n,r=t[f+159|0],n=(r|0)<0,F(k,n?i[f+148>>2]:l,n?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),r=F(k,33912,7),k=i[i[r>>2]-12>>2]+r|0,i[k+4>>2]=i[k+4>>2]&-75|8,F(B0(r,i[e+100>>2]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function ht(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;i:{e:{if(s=i[A+4>>2],o=i[A>>2],h=s-o|0,n=((h|0)/56|0)+1|0,n>>>0<76695845){if(r=(i[A+8>>2]-o|0)/56|0,f=r<<1,f=r>>>0>=38347922?76695844:f>>>0>n>>>0?f:n,f>>>0>=76695845)break e;if(w=g(f,56),_=C(w),f=i[e>>2],k=h+_|0,i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=f,n=i[e+4>>2],f=i[e+8>>2],(n|0)!=(f|0)){if(l=f-n|0,(l|0)<0)break i;r=C(l),i[k+4>>2]=r,f=r+l|0,i[k+12>>2]=f,l&&z(r,n,l),i[k+8>>2]=f}if(f=i[e+20>>2],i[k+16>>2]=i[e+16>>2],i[k+20>>2]=f,f=i[e+52>>2],i[k+48>>2]=i[e+48>>2],i[k+52>>2]=f,f=i[e+44>>2],i[k+40>>2]=i[e+40>>2],i[k+44>>2]=f,f=i[e+36>>2],i[k+32>>2]=i[e+32>>2],i[k+36>>2]=f,f=i[e+28>>2],i[k+24>>2]=i[e+24>>2],i[k+28>>2]=f,f=k+g((h|0)/-56|0,56)|0,(o|0)!=(s|0)){for(r=o,e=f;i[e>>2]=i[r>>2],i[e+4>>2]=i[r+4>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=i[r+12>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,n=i[r+52>>2],i[e+48>>2]=i[r+48>>2],i[e+52>>2]=n,n=i[r+44>>2],i[e+40>>2]=i[r+40>>2],i[e+44>>2]=n,n=i[r+36>>2],i[e+32>>2]=i[r+32>>2],i[e+36>>2]=n,n=i[r+28>>2],i[e+24>>2]=i[r+24>>2],i[e+28>>2]=n,n=i[r+20>>2],i[e+16>>2]=i[r+16>>2],i[e+20>>2]=n,e=e+56|0,r=r+56|0,(s|0)!=(r|0););for(;e=i[o+4>>2],e&&(i[o+8>>2]=e,Z(e)),o=o+56|0,(s|0)!=(o|0););o=i[A>>2]}return i[A+8>>2]=_+w,e=k+56|0,i[A+4>>2]=e,i[A>>2]=f,o&&Z(o),e}s0(),M()}x0(),M()}s0(),M()}function JG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;s=v-32|0,v=s,l=i[e+104>>2],n=i[e+108>>2];i:{if((l|0)==(n|0))break i;for(;;){e:{if(u[l+4|0]!=1||(f=i[l+16>>2],o=i[l+20>>2],(f|0)==(o|0)))break e;for(;k=(i[f+28>>2]+k|0)-i[f+24>>2]|0,f=f+40|0,(o|0)!=(f|0););}if(l=l+32|0,(n|0)==(l|0))break}if(!k||(p0(r,k+8|0),p0(r,1768186228),k=i[e+104>>2],n=i[e+108>>2],(k|0)==(n|0)))break i;for(;;){e:{if(u[k+4|0]!=1||(f=i[k+16>>2],o=i[k+20>>2],(f|0)==(o|0)))break e;for(;F4(r,f+24|0),f=f+40|0,(o|0)!=(f|0););}if(k=k+32|0,(n|0)==(k|0))break}}if(h=W[i[i[e>>2]+52>>2]](e,r,0)|0,i[e+116>>2]=i[r+12>>2],n=u[e+97|0],o=n>>>0<2,k=o?4:6,f=i[e+104>>2],w=i[e+108>>2],(f|0)!=(w|0))for(_=u[e+122|0]+(u[e+121|0]+((n?u[e+124|0]:0)&255)|0)|0,B=u[e+123|0]+((o?6:8)+(n?2:0)|0)|0,l=_+B|0;n=i[f+16>>2],o=i[f+20>>2],(n|0)==(o|0)?k=k+B|0:k=(k+l|0)+g(((o-n|0)-40>>>0)/40|0,_)|0,f=f+32|0,(w|0)!=(f|0););N3(r,k),i[r+12>>2]=h,W[i[i[e>>2]+56>>2]](s+12|0,e,r,i[r+4>>2]-(h+i[r>>2]|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[s+31|0]<0&&Z(i[s+20>>2]),ro(e,r),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0;i:{if(t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731])}v=s+32|0}function k6(A,e,r,f,k,n,o,l){var s=0,h=0,w=0,_=0,B=0;s=v-16|0,v=s,i[s+8>>2]=r,i[s+12>>2]=e,r=s+4|0,e=i[f+28>>2],i[r>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),h=$0(r,137008),i2(r),i[k>>2]=0,e=0;i:{for(;;){if(e|(o|0)==(l|0))break i;e:{if(d2(s+12|0,s+8|0))break e;r:{if((W[i[i[h>>2]+36>>2]](h,t[o|0],0)|0)==37){if((o+1|0)==(l|0))break e;r=0;f:{A:{if(e=W[i[i[h>>2]+36>>2]](h,t[o+1|0],0)|0,(e|0)==69||(w=1,(e&255)==48))break A;break f}if((o+2|0)==(l|0))break e;w=2,r=e,e=W[i[i[h>>2]+36>>2]](h,t[o+2|0],0)|0}_=s,B=W[i[i[A>>2]+36>>2]](A,i[s+12>>2],i[s+8>>2],f,k,n,e,r)|0,i[_+12>>2]=B,o=(o+w|0)+1|0;break r}if(e=t[o|0],(e|0)>=0?e=i[i[h+8>>2]+(e<<2)>>2]&1:e=0,e){for(;o=o+1|0,!!((l|0)!=(o|0)&&(e=t[o|0],(e|0)>=0?e=i[i[h+8>>2]+(e<<2)>>2]&1:e=0,e)););for(;;){if(r=s+12|0,d2(r,s+8|0))break r;e=i[r>>2],w=i[e+12>>2];f:{if((w|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break f}e=t[w|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[h+8>>2]+(e<<2)>>2]&1:e=0,!e)break r;A4(r)}}w=s+12|0,e=i[w>>2],r=i[e+12>>2];f:{if((r|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break f}e=t[r|0]}if((W[i[i[h>>2]+12>>2]](h,e<<24>>24)|0)==(W[i[i[h>>2]+12>>2]](h,t[o|0])|0)){o=o+1|0,A4(w);break r}i[k>>2]=4}e=i[k>>2];continue}break}i[k>>2]=4}return d2(s+12|0,s+8|0)&&(i[k>>2]=i[k>>2]|2),v=s+16|0,i[s+12>>2]}function NG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,n=i[19620],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19621],o=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(o,k),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(k),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,K1(k,e,r),s=n,l=k,n=t[f+159|0],k=(n|0)<0,F(s,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(n=0;k=f+148|0,k0(k,r),s=k,k=t[f+159|0],l=(k|0)<0,F(f+8|0,l?i[f+148>>2]:s,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=n<<3,F(B0(F(B0(F(B0(F(f+8|0,20885,1),n),22729,8),i[k+i[e+104>>2]>>2]),22819,8),i[(k+i[e+104>>2]|0)+4>>2]),47878,1),n=n+1|0,n>>>0<i[e+108>>2]-i[e+104>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}n=f+20|0,e=i[f+28>>2]}e:{if(n=i[n>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,n,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function DG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,n=i[19620],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19621],o=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(o,k),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(k),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,K1(k,e,r),s=n,l=k,n=t[f+159|0],k=(n|0)<0,F(s,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(n=0;k=f+148|0,k0(k,r),s=k,k=t[f+159|0],l=(k|0)<0,F(f+8|0,l?i[f+148>>2]:s,l?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=n<<3,F(D0(F(B0(F(B0(F(f+8|0,20885,1),n),22729,8),i[k+i[e+104>>2]>>2]),22738,9),i[(k+i[e+104>>2]|0)+4>>2]),47878,1),n=n+1|0,n>>>0<i[e+108>>2]-i[e+104>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}n=f+20|0,e=i[f+28>>2]}e:{if(n=i[n>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,n,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function UG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=C(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=u[30700]|u[30701]<<8|(u[30702]<<16|u[30703]<<24),k=u[30696]|u[30697]<<8|(u[30698]<<16|u[30699]<<24),t[r+21|0]=k,t[r+22|0]=k>>>8,t[r+23|0]=k>>>16,t[r+24|0]=k>>>24,t[r+25|0]=f,t[r+26|0]=f>>>8,t[r+27|0]=f>>>16,t[r+28|0]=f>>>24,f=u[30695]|u[30696]<<8|(u[30697]<<16|u[30698]<<24),k=u[30691]|u[30692]<<8|(u[30693]<<16|u[30694]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[30687]|u[30688]<<8|(u[30689]<<16|u[30690]<<24),k=u[30683]|u[30684]<<8|(u[30685]<<16|u[30686]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,f=u[30679]|u[30680]<<8|(u[30681]<<16|u[30682]<<24),k=u[30675]|u[30676]<<8|(u[30677]<<16|u[30678]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+29|0]=0,r=a(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}t[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function MG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=C(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=u[30639]|u[30640]<<8|(u[30641]<<16|u[30642]<<24),k=u[30635]|u[30636]<<8|(u[30637]<<16|u[30638]<<24),t[r+21|0]=k,t[r+22|0]=k>>>8,t[r+23|0]=k>>>16,t[r+24|0]=k>>>24,t[r+25|0]=f,t[r+26|0]=f>>>8,t[r+27|0]=f>>>16,t[r+28|0]=f>>>24,f=u[30634]|u[30635]<<8|(u[30636]<<16|u[30637]<<24),k=u[30630]|u[30631]<<8|(u[30632]<<16|u[30633]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[30626]|u[30627]<<8|(u[30628]<<16|u[30629]<<24),k=u[30622]|u[30623]<<8|(u[30624]<<16|u[30625]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,f=u[30618]|u[30619]<<8|(u[30620]<<16|u[30621]<<24),k=u[30614]|u[30615]<<8|(u[30616]<<16|u[30617]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+29|0]=0,r=a(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}t[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function HG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=C(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=u[30609]|u[30610]<<8|(u[30611]<<16|u[30612]<<24),k=u[30605]|u[30606]<<8|(u[30607]<<16|u[30608]<<24),t[r+21|0]=k,t[r+22|0]=k>>>8,t[r+23|0]=k>>>16,t[r+24|0]=k>>>24,t[r+25|0]=f,t[r+26|0]=f>>>8,t[r+27|0]=f>>>16,t[r+28|0]=f>>>24,f=u[30604]|u[30605]<<8|(u[30606]<<16|u[30607]<<24),k=u[30600]|u[30601]<<8|(u[30602]<<16|u[30603]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[30596]|u[30597]<<8|(u[30598]<<16|u[30599]<<24),k=u[30592]|u[30593]<<8|(u[30594]<<16|u[30595]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,f=u[30588]|u[30589]<<8|(u[30590]<<16|u[30591]<<24),k=u[30584]|u[30585]<<8|(u[30586]<<16|u[30587]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+29|0]=0,r=a(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(t[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],t[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=t[r+19|0],t[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}t[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function zG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;if(!(r&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}if(e=i[e>>2],n=u[r|0],f=u[101976],n>>>0<f>>>0){k=i[25497],i[e+72>>2]=i[25496],i[e+76>>2]=k,k=i[25499],i[e+80>>2]=i[25498],i[e+84>>2]=k,i[e+88>>2]=i[25500],i[e+92>>2]=i[25501],i[e+96>>2]=i[25502],k=i[25505],i[e+104>>2]=i[25504],i[e+108>>2]=k,i[e+112>>2]=i[25506],i[e+116>>2]=i[25507],i[e+120>>2]=i[25508],i[e+124>>2]=i[25509];i:{if(f>>>0<2||(k=i[25511],i[e+128>>2]=i[25510],i[e+132>>2]=k,i[e+136>>2]=i[25512],i[e+140>>2]=i[25513],(f|0)==2)||(i[e+144>>2]=i[25514],i[e+148>>2]=i[25515],f>>>0<4))break i;i[e+152>>2]=i[25516],i[e+156>>2]=i[25517]}i[e+160>>2]=0}f=i[r+12>>2],i[e+72>>2]=i[r+8>>2],i[e+76>>2]=f,f=i[r+20>>2],i[e+80>>2]=i[r+16>>2],i[e+84>>2]=f,i[e+88>>2]=i[r+24>>2],i[e+92>>2]=i[r+28>>2],i[e+96>>2]=i[r+32>>2],f=i[r+44>>2],i[e+104>>2]=i[r+40>>2],i[e+108>>2]=f,i[e+112>>2]=i[r+48>>2],i[e+116>>2]=i[r+52>>2],i[e+120>>2]=i[r+56>>2],i[e+124>>2]=i[r+60>>2];i:{if(n>>>0<2||(f=i[r+68>>2],i[e+128>>2]=i[r+64>>2],i[e+132>>2]=f,i[e+136>>2]=i[r+72>>2],i[e+140>>2]=i[r+76>>2],(n|0)==2)||(i[e+144>>2]=i[r+80>>2],i[e+148>>2]=i[r+84>>2],n>>>0<4))break i;i[e+152>>2]=i[r+88>>2],i[e+156>>2]=i[r+92>>2]}i[e+160>>2]=0,i[A+8>>2]=i[25788],e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e}function xG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;k=v-16|0,v=k,r=i[A>>2],A=i[r+248>>2],l=i[r+252>>2],l&&(i[l+4>>2]=i[l+4>>2]+1);i:{if(!A)break i;i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0;e:{r:{f:{if(f=i[A+100>>2],h=i[A+104>>2],(f|0)!=(h|0)){if(A=h-f|0,r=A>>4,r>>>0>=1073741824)break f;for(A=C(A>>2),i[k+8>>2]=A,i[k+4>>2]=A,i[k+12>>2]=(r<<2)+A;;){n=i[k+12>>2];A:{if(n>>>0>A>>>0){i[A>>2]=i[f>>2],A=A+4|0;break A}if(s=i[k+4>>2],A=A-s|0,w=A>>2,r=w+1|0,r>>>0>=1073741824)break f;if(n=n-s|0,o=n>>1,n=n>>>0>=2147483644?1073741823:r>>>0<o>>>0?o:r,n){if(n>>>0>=1073741824)break r;r=C(n<<2)}else r=0;if(o=r+A|0,i[o>>2]=i[f>>2],w=o-(w<<2)|0,A&&z(w,s,A),i[k+12>>2]=r+(n<<2),A=o+4|0,i[k+8>>2]=A,i[k+4>>2]=w,!s)break A;Z(s)}if(i[k+8>>2]=A,f=f+16|0,(h|0)==(f|0))break}}break e}s0(),M()}x0(),M()}A=i[k+8>>2],r=i[k+4>>2];e:{if((A|0)!=(r|0)){if(f=A-r>>2,n=f>>>0<=1?1:f,s=n&3,A=0,f>>>0>=4)for(h=n&-4,n=0;f=A<<2,i[f+e>>2]=i[r+f>>2],o=f|4,i[o+e>>2]=i[r+o>>2],o=f|8,i[o+e>>2]=i[r+o>>2],f=f|12,i[f+e>>2]=i[r+f>>2],A=A+4|0,n=n+4|0,(h|0)!=(n|0););if(!s)break e;for(;f=A<<2,i[f+e>>2]=i[r+f>>2],A=A+1|0,_=_+1|0,(s|0)!=(_|0););break e}if(!r)break i}i[k+8>>2]=r,Z(r)}i:{if(!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break i;W[i[i[l>>2]+8>>2]](l),y(l)}v=k+16|0}function TG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,35239,10),i[e+100>>2]),47878,1),n=f+148|0,k0(n,r),o=k,r=t[f+159|0],k=(r|0)<0,F(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,35228,10),i[e+104>>2]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function jG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,k=t[f+159|0],n=(k|0)<0,F(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,F(B0(F(k,34773,25),p[e+98>>1]),47878,1),n=f+148|0,k0(n,r),o=k,r=t[f+159|0],k=(r|0)<0,F(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,34844,29),p[e+100>>1]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function SG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v+-64|0,v=r,e6(r+40|0,i[e+180>>2],i[e+196>>2]);i:{e:switch(u[r+60|0]){case 1:e=i[r+44>>2],i[A>>2]=i[r+40>>2],i[A+4>>2]=e,e=A+8|0;r:{if(t[r+59|0]>=0){k=i[r+52>>2],i[e>>2]=i[r+48>>2],i[e+4>>2]=k,i[e+8>>2]=i[r+56>>2];break r}T(e,i[r+48>>2],i[r+52>>2])}t[A+20|0]=1;break i;default:e2(),M();case 0:break e}f=r+16|0,$1(f,i[e+180>>2],i[r+40>>2],1),k=i[r+20>>2],e=i[r+16>>2];e:{if(!e){t[r+4|0]=0,t[r+15|0]=0,e=a(f,2,2e3,r+4|0),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,f=A+8|0;r:{if(t[e+19|0]>=0){n=i[e+12>>2],i[f>>2]=i[e+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[e+16>>2],t[A+20|0]=1;break r}if(T(f,i[e+8>>2],i[e+12>>2]),f=t[e+19|0],t[A+20|0]=1,(f|0)>=0)break r;Z(i[e+8>>2])}if(t[r+15|0]>=0)break e;Z(i[r+4>>2]);break e}if(W[i[i[e>>2]+88>>2]](r+16|0,e),i[r+16>>2]){if(e=i[r+20>>2],i[A>>2]=i[r+16>>2],i[A+4>>2]=e,e=A+8|0,t[r+35|0]>=0){f=i[r+28>>2],i[e>>2]=i[r+24>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+32>>2],t[A+20|0]=1;break e}if(T(e,i[r+24>>2],i[r+28>>2]),e=t[r+35|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[r+24>>2]);break e}t[r+35|0]<0&&Z(i[r+24>>2]),W[i[i[e>>2]+156>>2]](A,e)}if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}A=u[r+60|0],(A|0)!=255&&(e=i[27063],i[r+16>>2]=i[27062],i[r+20>>2]=e,W[i[(r+16|0)+(A<<2)>>2]](r+4|0,r+40|0)),v=r- -64|0}function OG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,n=i[19620],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[19621],o=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(o,k),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(k),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,J2(k,e,r),s=n,l=k,n=t[f+159|0],k=(n|0)<0,F(s,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,k0(n,r),l=n,n=t[f+159|0],k=(n|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),n=F(B0(F(f+8|0,35144,13),i[e+104>>2]),47878,1),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(n,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(n,33382,14),i[e+108>>2]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,n,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function PG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0;f=v-16|0,v=f;i:{e:{if(!i[A+64>>2])break e;if(!(u[A+92|0]&16)){i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,r=i[A+52>>2];r:{if(r>>>0>=9){if(u[A+98|0]==1){n=r,r=i[A+32>>2],i[A+28>>2]=(n+r|0)-1,i[A+20>>2]=r,i[A+24>>2]=r;break r}r=i[A+56>>2],i[A+28>>2]=(r+i[A+60>>2]|0)-1,i[A+20>>2]=r,i[A+24>>2]=r;break r}i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0}i[A+92>>2]=16}if(o=i[A+20>>2],l=i[A+28>>2],(e|0)!=-1&&(i[A+24>>2]||(i[A+28>>2]=f+16,r=f+15|0,i[A+20>>2]=r,i[A+24>>2]=r),t[i[A+24>>2]]=e<<24>>24,i[A+24>>2]=i[A+24>>2]+1),k=i[A+24>>2],r=i[A+20>>2],(k|0)!=(r|0)){r:{if(u[A+98|0]==1){if(n=r,r=k-r|0,(r4(n,1,r,i[A+64>>2])|0)!=(r|0))break e;break r}for(i[f+8>>2]=i[A+32>>2],s=A+72|0;;){if(r=i[A+68>>2],r){if(k=i[A+32>>2],r=W[i[i[r>>2]+12>>2]](r,s,i[A+20>>2],i[A+24>>2],f+4|0,k,k+i[A+52>>2]|0,f+8|0)|0,i[A+20>>2]==i[f+4>>2])break e;if((r|0)==3){if(r=i[A+24>>2]-i[A+20>>2]|0,(r4(i[A+20>>2],1,r,i[A+64>>2])|0)!=(r|0))break e;break r}if(r>>>0>1||(n=i[A+32>>2],k=i[f+8>>2]-n|0,(r4(n,1,k,i[A+64>>2])|0)!=(k|0)))break e;if((r|0)!=1)break r;r=i[f+4>>2],i[A+28>>2]=i[A+24>>2],i[A+20>>2]=r,i[A+24>>2]=r,i[A+24>>2]=i[A+24>>2]+(i[A+28>>2]-i[A+20>>2]|0);continue}break}N1(),M()}i[A+28>>2]=l,i[A+20>>2]=o,i[A+24>>2]=o}A=(e|0)!=-1?e:0;break i}A=-1}return v=f+16|0,A|0}function wt(A){A=A|0;var e=0,r=0;i[A>>2]=114076,e=i[A+436>>2],e&&(i[A+440>>2]=e,Z(e)),e=i[A+424>>2],e&&(i[A+428>>2]=e,Z(e)),e=i[A+412>>2],e&&(i[A+416>>2]=e,Z(e)),e=i[A+400>>2],e&&(i[A+404>>2]=e,Z(e)),e=i[A+388>>2],e&&(i[A+392>>2]=e,Z(e)),e=i[A+300>>2],e&&(i[A+304>>2]=e,Z(e)),e=i[A+288>>2],e&&(i[A+292>>2]=e,Z(e)),e=i[A+276>>2],e&&(i[A+280>>2]=e,Z(e)),e=i[A+264>>2],e&&(i[A+268>>2]=e,Z(e)),e=i[A+252>>2],e&&(i[A+256>>2]=e,Z(e)),e=i[A+240>>2],e&&(i[A+244>>2]=e,Z(e)),e=i[A+236>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+228>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+220>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+212>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+200>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+192>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+184>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+176>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return n2(A)|0}function LG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+100>>2],e=i[e+104>>2],(k|0)!=(e|0))for(;n=f+148|0,k0(n,r),s=n,n=t[f+159|0],l=(n|0)<0,F(f+8|0,l?i[f+148>>2]:s,l?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(B0(F(B0(F(f+8|0,33044,15),p[k>>1]),36467,16),p[k+2>>1]),34582,23),p[k+4>>1]),47878,1),k=k+6|0,(e|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,t[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(t[A+11|0]=k,k)break e;k=0;break i}I0(),M()}if(!k)break i;z(A,r,k)}t[A+k|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function qG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+104>>2],e=i[e+108>>2],(k|0)!=(e|0))for(;n=f+148|0,k0(n,r),s=n,n=t[f+159|0],l=(n|0)<0,F(f+8|0,l?i[f+148>>2]:s,l?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(D0(F(B0(F(f+8|0,36974,10),p[k>>1]),33784,18),u[k+2|0]),33756,17),p[k+4>>1]),47878,1),k=k+6|0,(e|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,t[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(t[A+11|0]=k,k)break e;k=0;break i}I0(),M()}if(!k)break i;z(A,r,k)}t[A+k|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function aG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+100>>2],e=i[e+104>>2],(k|0)!=(e|0))for(;n=f+148|0,k0(n,r),s=n,n=t[f+159|0],l=(n|0)<0,F(f+8|0,l?i[f+148>>2]:s,l?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(D0(F(B0(F(f+8|0,32967,17),p[k>>1]),36513,16),u[k+2|0]),34158,18),u[k+3|0]),47878,1),k=k+4|0,(e|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,t[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(t[A+11|0]=k,k)break e;k=0;break i}I0(),M()}if(!k)break i;z(A,r,k)}t[A+k|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function KG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;n=v-32|0,v=n,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,u[e+184|0]==1&&p0(r,i[e+104>>2]),u[e+185|0]==1&&p0(r,i[e+108>>2]),u[e+186|0]==1&&p0(r,i[e+112>>2]);i:{if(u[e+187|0]!=1)break i;if(u[e+116|0]==1){if(f=u0[e+120>>3],u[e+117|0]==1){f=f*1073741824,B2(f)<2147483647?k=~~f:k=-2147483648,p0(r,k),f=u0[e+128>>3]*1073741824,B2(f)<2147483647?k=~~f:k=-2147483648,p0(r,k),f=u0[e+136>>3]*1073741824,B2(f)<2147483647?k=~~f:k=-2147483648,p0(r,k);break i}f=f*16384,B2(f)<2147483647?k=~~f:k=-2147483648,Xr(r,k),f=u0[e+128>>3]*16384,B2(f)<2147483647?k=~~f:k=-2147483648,Xr(r,k),f=u0[e+136>>3]*16384,B2(f)<2147483647?k=~~f:k=-2147483648,Xr(r,k);break i}f=u0[e+152>>3]*65536,B2(f)<2147483647?k=~~f:k=-2147483648,p0(r,k),f=u0[e+160>>3]*65536,B2(f)<2147483647?k=~~f:k=-2147483648,p0(r,k),f=u0[e+168>>3]*65536,B2(f)<2147483647?k=~~f:k=-2147483648,p0(r,k)}u[e+188|0]==1&&p0(r,i[e+176>>2]),i[r+12>>2]=o,W[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+o|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[n+31|0]<0&&Z(i[n+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+32|0}function $G(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;e=v-48|0,v=e,r=C(40),i[e+12>>2]=r,i[e+16>>2]=32,i[e+20>>2]=-2147483608,f=u[4736]|u[4737]<<8|(u[4738]<<16|u[4739]<<24),k=u[4732]|u[4733]<<8|(u[4734]<<16|u[4735]<<24),t[r+24|0]=k,t[r+25|0]=k>>>8,t[r+26|0]=k>>>16,t[r+27|0]=k>>>24,t[r+28|0]=f,t[r+29|0]=f>>>8,t[r+30|0]=f>>>16,t[r+31|0]=f>>>24,f=u[4728]|u[4729]<<8|(u[4730]<<16|u[4731]<<24),k=u[4724]|u[4725]<<8|(u[4726]<<16|u[4727]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[4720]|u[4721]<<8|(u[4722]<<16|u[4723]<<24),k=u[4716]|u[4717]<<8|(u[4718]<<16|u[4719]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,f=u[4712]|u[4713]<<8|(u[4714]<<16|u[4715]<<24),k=u[4708]|u[4709]<<8|(u[4710]<<16|u[4711]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+32|0]=0,f=a(e+24|0,4,6003,e+12|0),r=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=r,k=A+8|0;i:{if(t[f+19|0]>=0){r=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=r,i[k+8>>2]=i[f+16>>2],t[A+20|0]=1;break i}if(T(k,i[f+8>>2],i[f+12>>2]),r=t[f+19|0],t[A+20|0]=1,(r|0)>=0)break i;Z(i[f+8>>2])}t[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function dG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,K1(n,e,r),l=k,s=n,k=t[f+159|0],n=(k|0)<0,F(l,n?i[f+148>>2]:s,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(k=0;n=f+148|0,k0(n,r),s=n,n=t[f+159|0],l=(n|0)<0,F(f+8|0,l?i[f+148>>2]:s,l?i[f+152>>2]:n),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(B0(F(f+8|0,20885,1),k),37800,4),i[i[e+104>>2]+(k<<2)>>2]),47878,1),k=k+1|0,k>>>0<i[e+108>>2]-i[e+104>>2]>>2>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,t[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(t[A+11|0]=k,k)break e;k=0;break i}I0(),M()}if(!k)break i;z(A,r,k)}t[A+k|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function _t(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0;A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:if((f-r|0)<3)break i;i:{e:{for(;;){if(!(r>>>0>=f>>>0|n>>>0>=o>>>0)){s=t[r|0],e=s&255;r:{if((s|0)>=0){if(e>>>0>1114111)break e;s=1;break r}if(s>>>0<4294967234)break e;if(s>>>0<=4294967263){if(s=1,(f-r|0)<2||(s=2,h=u[r+1|0],(h&192)!=128))break i;e=h&63|e<<6&1984,s=2;break r}if(s>>>0<=4294967279){if(s=1,w=f-r|0,(w|0)<2)break i;h=t[r+1|0];f:{A:{if((e|0)!=237){if((e|0)!=224)break A;if((h&-32)==-96)break f;break e}if((h|0)<-96)break f;break e}if((h|0)>-65)break e}if((w|0)==2)break i;if(s=u[r+2|0],(s&192)!=128)break e;e=s&63|(e<<12&61440|(h&63)<<6),s=3;break r}if(s>>>0>4294967284)break e;if(s=1,w=f-r|0,(w|0)<2)break i;h=t[r+1|0];f:{A:switch(e-240|0){case 0:if((h+112&255)>>>0>=48)break e;break f;case 4:if((h|0)>=-112)break e;break f;default:break A}if((h|0)>-65)break e}if((w|0)==2)break i;if(_=u[r+2|0],(_&192)!=128)break e;if((w|0)==3)break i;if(w=u[r+3|0],(w&192)!=128)break e;if(s=2,e=w&63|(_<<6&4032|(e<<18&1835008|(h&63)<<12)),e>>>0>1114111)break i;s=4}i[n>>2]=e,r=r+s|0,i[A+12>>2]=r,n=n+4|0,i[A+8>>2]=n;continue}break}s=r>>>0<f>>>0;break i}s=2}return i[k>>2]=i[A+12>>2],i[l>>2]=i[A+8>>2],v=A+16|0,s|0}function bG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,36418,17);i:{e:switch(i[e+104>>2]){case 0:F(f+8|0,38200,16);break i;case 1:F(f+8|0,38217,9);break i;default:break e}F(D0(F(f+8|0,30432,9),i[e+104>>2]),47877,2)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function Bt(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;if(r=i[A+104>>2],!r){l=A+104|0,f=C(128),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=96068,r=f+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=92500,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,X[f+112>>1]=0,i[r>>2]=93416,i[f+32>>2]=1885959277,i[f+120>>2]=0,i[A+104>>2]=r,k=i[A+108>>2],i[A+108>>2]=f;i:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break i;W[i[i[k>>2]+8>>2]](k),y(k)}o=v-16|0,v=o,f=i[A+44>>2],n=i[f+36>>2],k=i[f+40>>2];i:{if((n|0)!=(k|0))for(;;){e:{if(r=i[n>>2],!r||!Z0(r,92792,93476))break e;if(r=i[n+4>>2],!r|i[r+4>>2]!=-1||(W[i[i[r>>2]+8>>2]](r),y(r)),r=i[l>>2],k=i[l+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[n>>2]=r,f=i[n+4>>2],i[n+4>>2]=k,!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break i;W[i[i[f>>2]+8>>2]](f),y(f);break i}if(n=n+8|0,(k|0)==(n|0))break}i[o+8>>2]=i[l>>2],r=i[l+4>>2],i[o+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),P0(f+36|0,o+8|0),k=i[o+12>>2];e:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break e;W[i[i[k>>2]+8>>2]](k),y(k)}}v=o+16|0,r=i[A+104>>2]}i[r+104>>2]=e}function cG(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;h=v-16|0,v=h;i:{if((r|0)<0)break i;A=i[A>>2],n=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),l=i[n+80>>2],s=i[n+84>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);e:{if(!A||(n=i[A+4>>2],i[A+4>>2]=n-1,n))break e;W[i[i[A>>2]+8>>2]](A),y(A)}e:{if(!l){n=0;break e}j3(h+4|0,l,e),A=i[h+8>>2],l=i[h+4>>2];r:{if(((A-l|0)/56|0)>(r|0)){r=l+g(r,56)|0,f&&(i[f>>2]=i[r+16>>2]);f:{if(!k){e=i[r+44>>2],n=i[r+48>>2];break f}if(e=i[r+48>>2]-i[r+44>>2]|0,w=C((e|0)<0?-1:e),i[k>>2]=w,e=i[r+44>>2],n=i[r+48>>2],(e|0)==(n|0)){e=n;break f}if(f=n-e>>2,o=f>>>0<=1?1:f,B=o&3,k=0,r=0,f>>>0>=4)for(m=o&-4,f=0;o=r<<2,i[o+w>>2]=i[e+o>>2],_=o|4,i[_+w>>2]=i[e+_>>2],_=o|8,i[_+w>>2]=i[e+_>>2],o=o|12,i[o+w>>2]=i[e+o>>2],r=r+4|0,f=f+4|0,(m|0)!=(f|0););if(!B)break f;for(;f=r<<2,i[f+w>>2]=i[e+f>>2],r=r+1|0,k=k+1|0,(B|0)!=(k|0););}n=n-e>>2;break r}if(n=0,!l)break e}if((A|0)==(l|0))A=l;else{for(;e=i[A-12>>2],e&&(i[A-8>>2]=e,Z(e)),e=A-56|0,i[e>>2]=92500,r=i[A-36>>2],r&&(i[A-32>>2]=r,Z(r)),A=e,(l|0)!=(A|0););A=i[h+4>>2]}i[h+8>>2]=l,Z(A)}if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}return v=h+16|0,n|0}function vt(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0;A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:{e:{for(;;){if(r>>>0>=f>>>0){n=0;break i}n=2;r:{e=p[r>>1];f:{if(e>>>0<=127){if(n=1,r=i[A+8>>2],(o-r|0)<=0)break i;i[A+8>>2]=r+1,t[r|0]=e;break f}if(e>>>0<=2047){if(r=i[A+8>>2],(o-r|0)<2)break e;i[A+8>>2]=r+1,t[r|0]=e>>>6|192,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e&63|128;break f}if(e>>>0<=55295){if(r=i[A+8>>2],(o-r|0)<3)break e;i[A+8>>2]=r+1,t[r|0]=e>>>12|224,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e>>>6&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e&63|128;break f}if(e>>>0<=56319){if(n=1,(f-r|0)<3)break i;if(s=p[r+2>>1],(s&64512)!=56320)break r;if(h=i[A+8>>2],(o-h|0)<4)break i;if(n=e&960,(s&1023|(e<<10&64512|n<<10))>>>0>1048575)break r;i[A+12>>2]=r+2,i[A+8>>2]=h+1,r=(n>>>6|0)+1|0,t[h|0]=r>>>2|240,n=i[A+8>>2],i[A+8>>2]=n+1,t[n|0]=r<<4&48|e>>>2&15|128,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=s>>>6&15|e<<4&48|128,e=i[A+8>>2],i[A+8>>2]=e+1,t[e|0]=s&63|128;break f}if(e>>>0<57344)break i;if(r=i[A+8>>2],(o-r|0)<3)break e;i[A+8>>2]=r+1,t[r|0]=e>>>12|224,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e>>>6&191,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e&63|128}r=i[A+12>>2]+2|0,i[A+12>>2]=r;continue}break}n=2;break i}n=1}return i[k>>2]=i[A+12>>2],i[l>>2]=i[A+8>>2],v=A+16|0,n|0}function iW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,e=v-16|0,v=e,l=A+196|0,i[l>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,v=e+16|0,o=A+16|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(o,137008),W[i[i[e>>2]+32>>2]](e,83888,83914,A+208|0)|0,i2(o),e=v-16|0,v=e,r=A+184|0,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,v=e+16|0,F2(r,u[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),u[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=e,i[A+12>>2]=o,i[A+8>>2]=0;;){i:{if(d2(A+252|0,A+248|0))break i;o=i[A+180>>2],u[r+11|0]>>>7|0?f=i[r+4>>2]:f=u[r+11|0]&127,(o|0)==(f+e|0)&&(u[r+11|0]>>>7|0?e=i[r+4>>2]:e=u[r+11|0]&127,u[r+11|0]>>>7|0?f=i[r+4>>2]:f=u[r+11|0]&127,F2(r,f<<1),F2(r,u[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),f=e,u[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=f+e),s=A+252|0,f=i[s>>2],o=i[f+12>>2];e:{if((o|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=t[o|0]}if(Ri(f<<24>>24,16,e,A+180|0,A+8|0,0,l,A+16|0,A+12|0,A+208|0))break i;A4(s);continue}break}return F2(r,i[A+180>>2]-e|0),u[r+11|0]>>>7|0?e=i[r>>2]:e=r,f=e1(),i[A>>2]=n,(As(e,f,A)|0)!=1&&(i[k>>2]=4),d2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),e=i[A+252>>2],_2(r),_2(l),v=A+256|0,e|0}function mt(A,e,r,f,k,n){var o=0,l=0,s=0,h=0,w=0,_=0;o=v-80|0,v=o,yA(o+56|0,e,1835625829);i:{e:{r:switch(u[o+76|0]){default:e2(),M();case 1:e=i[o+60>>2],i[A>>2]=i[o+56>>2],i[A+4>>2]=e,e=A+8|0;f:{if(t[o+75|0]>=0){r=o- -64|0,f=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+8>>2];break f}T(e,i[o+64>>2],i[o+68>>2])}t[A+20|0]=1;break e;case 0:break r}if(h=i[o+56>>2],i[o+48>>2]=h,s=i[o+60>>2],i[o+52>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),t[h+164|0]=1,i[h+100>>2]=i[h+100>>2]&-2|1,l=l2(r),l>>>0>=2147483640)break i;r:{f:{if(l>>>0>=11){_=l|7,w=C(_+1|0),i[o+40>>2]=_-2147483647,i[o+32>>2]=w,i[o+36>>2]=l;break f}if(t[o+43|0]=l,w=o+32|0,!l)break r}if(!l)break r;z(w,r,l)}t[l+w|0]=0,r=h+128|0;r:{if((r|0)==(o+32|0))break r;if(l=t[o+43|0],t[h+139|0]>=0){if((l|0)>=0){l=i[o+36>>2],i[r>>2]=i[o+32>>2],i[r+4>>2]=l,i[r+8>>2]=i[o+40>>2];break r}m1(r,i[o+32>>2],i[o+36>>2]);break r}w=r,r=(l|0)<0,R1(w,r?i[o+32>>2]:o+32|0,r?i[o+36>>2]:l)}if(t[o+43|0]<0&&Z(i[o+32>>2]),r=i[h+104>>2],LA(o+12|0,e,o+48|0,k,n,f),t[o+31|0]<0&&Z(i[o+20>>2]),t[A+20|0]=0,i[A>>2]=r,!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break e;W[i[i[s>>2]+8>>2]](s),y(s)}A=u[o+76|0],(A|0)!=255&&(e=i[25325],i[o+32>>2]=i[25324],i[o+36>>2]=e,W[i[(o+32|0)+(A<<2)>>2]](o+48|0,o+56|0)),v=o+80|0;return}I0(),M()}function eW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;k=v-32|0,v=k,S2(k,e,r),t[k+19|0]<0&&Z(i[k+8>>2]);i:{e:{r:{if(u[e+97|0]>=2){B1(A,e,8586);break r}if(G=e,I=F0(r),i[G+104>>2]=I,u[e+97|0]==1&&(n=F0(r),t[e+112|0]=1,i[e+108>>2]=n),_=F0(r),D4(A,e+128|0,_<<3,f,14903),i[A>>2])break r;t[A+19|0]<0&&Z(i[A+8>>2]);f:{if(_){for(;;){h=F0(r),f=F0(r),n=i[e+120>>2],o=i[e+124>>2];A:{if(n>>>0<o>>>0){i[n>>2]=h,i[n+4>>2]=f,f=n+8|0;break A}if(w=i[e+116>>2],n=n-w|0,B=n>>3,l=B+1|0,l>>>0>=536870912)break e;if(o=o-w|0,s=o>>2,o=o>>>0>=2147483640?536870911:s>>>0>l>>>0?s:l,o){if(o>>>0>=536870912)break i;l=C(o<<3)}else l=0;if(s=l+n|0,i[s>>2]=h,i[s+4>>2]=f,h=s-(B<<3)|0,n&&z(h,w,n),i[e+124>>2]=l+(o<<3),f=s+8|0,i[e+120>>2]=f,i[e+116>>2]=h,!w)break A;Z(w)}if(i[e+120>>2]=f,u[r+20|0]!=1){if(m=m+1|0,(m|0)==(_|0))break f;continue}break}if(t[k+20|0]=0,t[k+31|0]=0,a(A,2,100,k+20|0),t[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(!(t[r+20|0]&1))break f;if(t[k+20|0]=0,t[k+31|0]=0,a(A,2,100,k+20|0),t[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break r}T(A,i[28730],i[28731])}v=k+32|0;return}s0(),M()}x0(),M()}function Zt(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0;n=v-80|0,v=n,yA(n+56|0,e,1970432288);i:{e:{r:switch(u[n+76|0]){default:e2(),M();case 1:e=i[n+60>>2],i[A>>2]=i[n+56>>2],i[A+4>>2]=e,e=A+8|0;f:{if(t[n+75|0]>=0){r=n- -64|0,f=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+8>>2];break f}T(e,i[n+64>>2],i[n+68>>2])}t[A+20|0]=1;break e;case 0:break r}if(s=i[n+56>>2],i[n+48>>2]=s,l=i[n+60>>2],i[n+52>>2]=l,l&&(i[l+4>>2]=i[l+4>>2]+1),t[s+164|0]=1,i[s+100>>2]=i[s+100>>2]&-2|1,o=l2(r),o>>>0>=2147483640)break i;r:{f:{if(o>>>0>=11){w=o|7,h=C(w+1|0),i[n+40>>2]=w-2147483647,i[n+32>>2]=h,i[n+36>>2]=o;break f}if(t[n+43|0]=o,h=n+32|0,!o)break r}if(!o)break r;z(h,r,o)}t[o+h|0]=0,r=s+152|0;r:{if((r|0)==(n+32|0))break r;if(o=t[n+43|0],t[s+163|0]>=0){if((o|0)>=0){o=i[n+36>>2],i[r>>2]=i[n+32>>2],i[r+4>>2]=o,i[r+8>>2]=i[n+40>>2];break r}m1(r,i[n+32>>2],i[n+36>>2]);break r}h=r,r=(o|0)<0,R1(h,r?i[n+32>>2]:n+32|0,r?i[n+36>>2]:o)}if(t[n+43|0]<0&&Z(i[n+32>>2]),r=i[s+104>>2],LA(n+12|0,e,n+48|0,f,k,0),t[n+31|0]<0&&Z(i[n+20>>2]),t[A+20|0]=0,i[A>>2]=r,!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break e;W[i[i[l>>2]+8>>2]](l),y(l)}A=u[n+76|0],(A|0)!=255&&(e=i[25325],i[n+32>>2]=i[25324],i[n+36>>2]=e,W[i[(n+32|0)+(A<<2)>>2]](n+48|0,n+56|0)),v=n+80|0;return}I0(),M()}function rW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(f+8|0,34464,18);i:{e:switch(i[e+100>>2]+1|0){case 1:F(f+8|0,38321,9);break i;case 2:F(f+8|0,38292,11);break i;case 0:break e;default:break i}F(f+8|0,38526,8)}e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function gt(A,e){var r=0,f=0,k=0,n=0,o=0;f=v-16|0,v=f;i:{e:switch(t2(e-8|0,29)|0){case 0:if(!w4(A,1))break i;k=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{if(!(W[i[i[k>>2]+16>>2]](k,f+6|0,1)|0)){h8(A),k=0;break r}k=u[f+6|0]}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i;case 1:if(!w4(A,2))break i;k=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{if(!(W[i[i[k>>2]+16>>2]](k,f+7|0,2)|0)){h8(A),k=0;break r}A=u[f+7|0],k=u[f+8|0]|A<<8}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i;case 2:if(!w4(A,3))break i;e=i[A>>2],r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);r:{if(!(W[i[i[e>>2]+16>>2]](e,f+9|0,3)|0)){h8(A),n=0;break r}e=u[f+10|0],A=0,o=e<<8,e=u[f+9|0],k=u[f+11|0]|(e<<16|o),n=A|n}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r);break i;case 3:if(!w4(A,4))break i;e=i[A>>2],r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);r:{if(!(W[i[i[e>>2]+16>>2]](e,f+12|0,4)|0)){h8(A),n=0;break r}e=u[f+13|0],A=0,o=e<<16,e=u[f+12|0],e=e<<24|o,o=A|k,A=u[f+14|0],k=u[f+15|0]|(A<<8|e),n=n|o}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r);break i;case 7:break e;default:break i}k=S4(A),n=h0}return v=f+16|0,h0=n,k}function fW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;for(A=v-320|0,v=A,i[A+312>>2]=r,i[A+316>>2]=e,e=v-16|0,v=e,l=A+196|0,i[l>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,v=e+16|0,o=A+16|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(o,137e3),W[i[i[e>>2]+48>>2]](e,83888,83914,A+208|0)|0,i2(o),e=v-16|0,v=e,r=A+184|0,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,v=e+16|0,F2(r,u[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),u[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=e,i[A+12>>2]=o,i[A+8>>2]=0;;){i:{if(b2(A+316|0,A+312|0))break i;o=i[A+180>>2],u[r+11|0]>>>7|0?f=i[r+4>>2]:f=u[r+11|0]&127,(o|0)==(f+e|0)&&(u[r+11|0]>>>7|0?e=i[r+4>>2]:e=u[r+11|0]&127,u[r+11|0]>>>7|0?f=i[r+4>>2]:f=u[r+11|0]&127,F2(r,f<<1),F2(r,u[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),f=e,u[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=f+e),s=A+316|0,f=i[s>>2],o=i[f+12>>2];e:{if((o|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[o>>2]}if(Ji(f,16,e,A+180|0,A+8|0,0,l,A+16|0,A+12|0,A+208|0))break i;k4(s);continue}break}return F2(r,i[A+180>>2]-e|0),u[r+11|0]>>>7|0?e=i[r>>2]:e=r,f=e1(),i[A>>2]=n,(As(e,f,A)|0)!=1&&(i[k>>2]=4),b2(A+316|0,A+312|0)&&(i[k>>2]=i[k>>2]|2),e=i[A+316>>2],_2(r),_2(l),v=A+320|0,e|0}function AW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;k=v-32|0,v=k,S2(k,e,r),t[k+19|0]<0&&Z(i[k+8>>2]),t[e+100|0]&1&&(w=e,_=F0(r),i[w+104>>2]=_,w=e,_=F0(r),i[w+108>>2]=_),w=e,_=Q2(r),t[w+112|0]=_,o=F0(r),i[e+116>>2]=o;i:{e:{r:{if(!f||(l=i[f+80>>2],!l|o>>>0<=l>>>0))break r;if(e=C(72),i[k+20>>2]=e,i[k+24>>2]=71,i[k+28>>2]=-2147483576,z(e,26225,71),t[e+71|0]=0,a(A,6,1e3,k+20|0),t[k+31|0]>=0)break e;Z(i[k+20>>2]);break e}if(!u[e+112|0]){if(D4(A,e+132|0,o,f,14794),i[A>>2])break e;t[A+19|0]<0&&Z(i[A+8>>2]),f=i[e+116>>2],n=i[e+124>>2],o=i[e+120>>2],l=n-o|0;r:{if(f>>>0>l>>>0){if(h=f-l|0,s=i[e+128>>2],h>>>0<=s-n>>>0){h&&l0(n,0,h),i[e+124>>2]=n+h;break r}if((f|0)<0)break i;if(n=s-o|0,s=n<<1,s=n>>>0>=1073741823?2147483647:f>>>0<s>>>0?s:f,n=C(s),h&&l0(n+l|0,0,h),l&&z(n,o,l),i[e+128>>2]=n+s,i[e+124>>2]=f+n,i[e+120>>2]=n,!o)break r;Z(o);break r}if(f>>>0>=l>>>0)break r;i[e+124>>2]=f+o}s6(r,i[e+120>>2],i[e+116>>2])}if(u[r+20|0]==1){if(t[k+20|0]=0,t[k+31|0]=0,a(A,2,100,k+20|0),t[k+31|0]>=0)break e;Z(i[k+20>>2]);break e}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731])}v=k+32|0;return}s0(),M()}function kW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,l=L8(f),h=ur(f,A+208|0),nr(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(b2(A+332|0,A+328|0))break i;o=i[A+180>>2],u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,(o|0)==(f+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,F2(e,f<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),o=A+332|0,f=i[o>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(Ji(f,l,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,h))break i;k4(o);continue}break}u[A+207|0]>>>7|0?f=i[A+200>>2]:f=u[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,_=Hl(r,i[A+180>>2],k,l),i[w>>2]=_,i[n+4>>2]=h0,G4(A+196|0,A+16|0,i[A+12>>2],k),b2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],_2(e),_2(A+196|0),v=A+336|0,r|0}function nW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,l=L8(f),h=ur(f,A+208|0),nr(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(b2(A+332|0,A+328|0))break i;o=i[A+180>>2],u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,(o|0)==(f+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,F2(e,f<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),o=A+332|0,f=i[o>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(Ji(f,l,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,h))break i;k4(o);continue}break}u[A+207|0]>>>7|0?f=i[A+200>>2]:f=u[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,_=nl(r,i[A+180>>2],k,l),i[w>>2]=_,i[n+4>>2]=h0,G4(A+196|0,A+16|0,i[A+12>>2],k),b2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],_2(e),_2(A+196|0),v=A+336|0,r|0}function tW(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0;s=v-256|0,v=s,i[s+248>>2]=37,i[s+252>>2]=0,w=s+248|0,_=U3(w|1,21246,i[r+4>>2]),h=s+208|0,i[s+204>>2]=h,A=e1();i:{if(_){m=i[r+8>>2],B=s- -64|0,i[B>>2]=o,i[B+4>>2]=l,i[s+56>>2]=k,i[s+60>>2]=n,i[s+48>>2]=m,A=X4(h,30,A,w,s+48|0);break i}i[s+80>>2]=k,i[s+84>>2]=n,i[s+88>>2]=o,i[s+92>>2]=l,A=X4(s+208|0,30,A,s+248|0,s+80|0)}i[s+128>>2]=2126,w=J1(s+196|0,0,s+128|0),h=s+208|0;i:{e:{if((A|0)>=30){A=e1();r:{if(_){h=i[r+8>>2],i[s+16>>2]=o,i[s+20>>2]=l,i[s+8>>2]=k,i[s+12>>2]=n,i[s>>2]=h,A=S8(s+204|0,A,s+248|0,s);break r}i[s+32>>2]=k,i[s+36>>2]=n,i[s+40>>2]=o,i[s+44>>2]=l,A=S8(s+204|0,A,s+248|0,s+32|0)}if((A|0)==-1)break e;k=i[w>>2],i[w>>2]=i[s+204>>2],k&&W[i[w+4>>2]](k),h=i[s+204>>2]}k=h,h=A+h|0,_=c4(k,h,r),i[s+128>>2]=2126,k=s+128|0,n=J1(s+120|0,0,k),o=i[s+204>>2];r:{if((o|0)==(s+208|0)){A=k;break r}if(A=E2(A<<1),!A)break e;k=i[n>>2],i[n>>2]=A,k&&W[i[n+4>>2]](k),o=i[s+204>>2]}l=s+108|0,k=i[r+28>>2],i[l>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),it(o,_,h,A,s+116|0,s+112|0,l),i2(l),A=o6(e,A,i[s+116>>2],i[s+112>>2],r,f),e=i[n>>2],i[n>>2]=0,e&&W[i[n+4>>2]](e),e=i[w>>2],i[w>>2]=0,e&&W[i[w+4>>2]](e),v=s+256|0;break i}N1(),M()}return A|0}function oW(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0;s=v-416|0,v=s,i[s+408>>2]=37,i[s+412>>2]=0,w=s+408|0,_=U3(w|1,21246,i[r+4>>2]),h=s+368|0,i[s+364>>2]=h,A=e1();i:{if(_){m=i[r+8>>2],B=s- -64|0,i[B>>2]=o,i[B+4>>2]=l,i[s+56>>2]=k,i[s+60>>2]=n,i[s+48>>2]=m,A=X4(h,30,A,w,s+48|0);break i}i[s+80>>2]=k,i[s+84>>2]=n,i[s+88>>2]=o,i[s+92>>2]=l,A=X4(s+368|0,30,A,s+408|0,s+80|0)}i[s+128>>2]=2126,w=J1(s+356|0,0,s+128|0),h=s+368|0;i:{e:{if((A|0)>=30){A=e1();r:{if(_){h=i[r+8>>2],i[s+16>>2]=o,i[s+20>>2]=l,i[s+8>>2]=k,i[s+12>>2]=n,i[s>>2]=h,A=S8(s+364|0,A,s+408|0,s);break r}i[s+32>>2]=k,i[s+36>>2]=n,i[s+40>>2]=o,i[s+44>>2]=l,A=S8(s+364|0,A,s+408|0,s+32|0)}if((A|0)==-1)break e;k=i[w>>2],i[w>>2]=i[s+364>>2],k&&W[i[w+4>>2]](k),h=i[s+364>>2]}k=h,h=A+h|0,_=c4(k,h,r),i[s+128>>2]=2126,k=s+128|0,n=J1(s+120|0,0,k),o=i[s+364>>2];r:{if((o|0)==(s+368|0)){A=k;break r}if(A=E2(A<<3),!A)break e;k=i[n>>2],i[n>>2]=A,k&&W[i[n+4>>2]](k),o=i[s+364>>2]}l=s+108|0,k=i[r+28>>2],i[l>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),cn(o,_,h,A,s+116|0,s+112|0,l),i2(l),A=t6(e,A,i[s+116>>2],i[s+112>>2],r,f),e=i[n>>2],i[n>>2]=0,e&&W[i[n+4>>2]](e),e=i[w>>2],i[w>>2]=0,e&&W[i[w+4>>2]](e),v=s+416|0;break i}N1(),M()}return A|0}function n6(A,e,r,f,k,n,o,l){var s=0,h=0,w=0,_=0,B=0;s=v-16|0,v=s,i[s+8>>2]=r,i[s+12>>2]=e,r=s+4|0,e=i[f+28>>2],i[r>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),h=$0(r,137e3),i2(r),i[k>>2]=0,e=0;i:{for(;;){if(e|(o|0)==(l|0))break i;e:{if(b2(s+12|0,s+8|0))break e;r:{if((W[i[i[h>>2]+52>>2]](h,i[o>>2],0)|0)==37){if((o+4|0)==(l|0))break e;r=0;f:{A:{if(e=W[i[i[h>>2]+52>>2]](h,i[o+4>>2],0)|0,(e|0)==69||(w=4,(e&255)==48))break A;break f}if((o+8|0)==(l|0))break e;w=8,r=e,e=W[i[i[h>>2]+52>>2]](h,i[o+8>>2],0)|0}_=s,B=W[i[i[A>>2]+36>>2]](A,i[s+12>>2],i[s+8>>2],f,k,n,e,r)|0,i[_+12>>2]=B,o=(o+w|0)+4|0;break r}if(W[i[i[h>>2]+12>>2]](h,1,i[o>>2])|0){for(;o=o+4|0,!!((l|0)!=(o|0)&&W[i[i[h>>2]+12>>2]](h,1,i[o>>2])|0););for(;;){if(r=s+12|0,b2(r,s+8|0))break r;e=i[r>>2],w=i[e+12>>2];f:{if((w|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break f}e=i[w>>2]}if(!(W[i[i[h>>2]+12>>2]](h,1,e)|0))break r;k4(r)}}w=s+12|0,e=i[w>>2],r=i[e+12>>2];f:{if((r|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break f}e=i[r>>2]}if((W[i[i[h>>2]+28>>2]](h,e)|0)==(W[i[i[h>>2]+28>>2]](h,i[o>>2])|0)){o=o+4|0,k4(w);break r}i[k>>2]=4}e=i[k>>2];continue}break}i[k>>2]=4}return b2(s+12|0,s+8|0)&&(i[k>>2]=i[k>>2]|2),v=s+16|0,i[s+12>>2]}function Gt(A,e){var r=0,f=0,k=0,n=0,o=0;i:{e:{r:{f:{A:{r=i[A+4>>2];k:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=u[r|0];break k}r=q2(A)}switch(r-43|0){case 0:case 2:break A;default:break f}}o=(r|0)==45,e=!e,r=i[A+4>>2];A:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=u[r|0];break A}r=q2(A)}if(f=r-58|0,e|f>>>0>4294967285)break r;if(i[A+116>>2]<0)break e;i[A+4>>2]=i[A+4>>2]-1;break e}f=r-58|0}if(f>>>0<4294967286)break e;r:{if(r-48>>>0>=10)break r;for(;;){k=(g(k,10)+r|0)-48|0,n=(k|0)<214748364,r=i[A+4>>2];f:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=u[r|0];break f}r=q2(A)}if(e=r-48|0,!(n&e>>>0<=9))break}if(n=k>>31,e>>>0>=10)break r;for(;;){e=r,r=L0(k,n,10,0),f=e+r|0,e=h0,k=f-48|0,f=(r>>>0>f>>>0?e+1|0:e)-(f>>>0<48)|0,n=f,f=k>>>0<2061584302&(f|0)<=21474836|(f|0)<21474836,r=i[A+4>>2];f:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=u[r|0];break f}r=q2(A)}if(e=r-48|0,!(f&e>>>0<=9))break}if(e>>>0>=10)break r;for(;;){e=i[A+4>>2];f:{if((e|0)!=i[A+104>>2]){i[A+4>>2]=e+1,e=u[e|0];break f}e=q2(A)}if(!(e-48>>>0<10))break}}e=i[A+116>>2],(e|0)>0?e=1:e=(e|0)>=0,e&&(i[A+4>>2]=i[A+4>>2]-1),A=k,k=o?0-A|0:A,n=o?0-(((A|0)!=0)+n|0)|0:n;break i}if(n=-2147483648,i[A+116>>2]<0)break i;return i[A+4>>2]=i[A+4>>2]-1,h0=-2147483648,0}return h0=n,k}function lW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,l=L8(f),tr(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(d2(A+252|0,A+248|0))break i;o=i[A+180>>2],u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,(o|0)==(f+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,F2(e,f<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),o=A+252|0,f=i[o>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=t[s|0]}if(Ri(f<<24>>24,l,r,A+180|0,A+8|0,t[A+247|0],A+196|0,A+16|0,A+12|0,83888))break i;A4(o);continue}break}u[A+207|0]>>>7|0?f=i[A+200>>2]:f=u[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,w=Hl(r,i[A+180>>2],k,l),i[h>>2]=w,i[n+4>>2]=h0,G4(A+196|0,A+16|0,i[A+12>>2],k),d2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],_2(e),_2(A+196|0),v=A+256|0,r|0}function uW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,l=L8(f),tr(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(d2(A+252|0,A+248|0))break i;o=i[A+180>>2],u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,(o|0)==(f+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,F2(e,f<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),o=A+252|0,f=i[o>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=t[s|0]}if(Ri(f<<24>>24,l,r,A+180|0,A+8|0,t[A+247|0],A+196|0,A+16|0,A+12|0,83888))break i;A4(o);continue}break}u[A+207|0]>>>7|0?f=i[A+200>>2]:f=u[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,w=nl(r,i[A+180>>2],k,l),i[h>>2]=w,i[n+4>>2]=h0,G4(A+196|0,A+16|0,i[A+12>>2],k),d2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],_2(e),_2(A+196|0),v=A+256|0,r|0}function sW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;s=v-16|0,v=s,n=C(40),i[n+16>>2]=1,i[n+4>>2]=0,i[n+8>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+12>>2]=102380,i[n>>2]=102588,i[n+28>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,_=n+12|0;i:{if(!f||(fi(n+20|0,f),(f|0)<=0))break i;if(l=i[n+20>>2],(f|0)!=1)for(G=f&2147483646;o=w<<3,h=o+l|0,B=r+o|0,i[h>>2]=i[B>>2],i[h+4>>2]=i[B+4>>2],o=o|8,h=o+l|0,o=r+o|0,i[h>>2]=i[o>>2],i[h+4>>2]=i[o+4>>2],w=w+2|0,m=m+2|0,(G|0)!=(m|0););if(!(f&1))break i;f=w<<3,l=f+l|0,r=r+f|0,i[l>>2]=i[r>>2],i[l+4>>2]=i[r+4>>2]}t[n+16|0]=1,r=i[e+8>>2],i[s+12>>2]=n,i[s+8>>2]=_,i[n+4>>2]=i[n+4>>2]+1,P0(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!k||(i[n+4>>2]=i[n+4>>2]+1,r=C(24),i[n+4>>2]=i[n+4>>2]+1,i[r+20>>2]=n,i[r+16>>2]=_,l=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=l,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[k>>2]=r,e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[n+4>>2],i[n+4>>2]=A-1,A||(W[i[i[n>>2]+8>>2]](n),y(n)),v=s+16|0}function hW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;s=v-16|0,v=s,n=C(40),i[n+16>>2]=1,i[n+4>>2]=0,i[n+8>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+12>>2]=102380,i[n>>2]=102588,i[n+28>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,_=n+12|0;i:{if(!f||(fi(n+20|0,f),(f|0)<=0))break i;if(l=i[n+20>>2],(f|0)!=1)for(G=f&2147483646;o=w<<3,h=o+l|0,B=r+o|0,i[h>>2]=i[B>>2],i[h+4>>2]=i[B+4>>2],o=o|8,h=o+l|0,o=r+o|0,i[h>>2]=i[o>>2],i[h+4>>2]=i[o+4>>2],w=w+2|0,m=m+2|0,(G|0)!=(m|0););if(!(f&1))break i;f=w<<3,l=f+l|0,r=r+f|0,i[l>>2]=i[r>>2],i[l+4>>2]=i[r+4>>2]}t[n+16|0]=0,r=i[e+8>>2],i[s+12>>2]=n,i[s+8>>2]=_,i[n+4>>2]=i[n+4>>2]+1,P0(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!k||(i[n+4>>2]=i[n+4>>2]+1,r=C(24),i[n+4>>2]=i[n+4>>2]+1,i[r+20>>2]=n,i[r+16>>2]=_,l=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=l,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[k>>2]=r,e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[n+4>>2],i[n+4>>2]=A-1,A||(W[i[i[n>>2]+8>>2]](n),y(n)),v=s+16|0}function wW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,l=L8(f),h=ur(f,A+208|0),nr(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(b2(A+332|0,A+328|0))break i;o=i[A+180>>2],u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,(o|0)==(f+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,F2(e,f<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),o=A+332|0,f=i[o>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(Ji(f,l,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,h))break i;k4(o);continue}break}u[A+207|0]>>>7|0?f=i[A+200>>2]:f=u[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,_=tl(r,i[A+180>>2],k,l),i[w>>2]=_,G4(A+196|0,A+16|0,i[A+12>>2],k),b2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],_2(e),_2(A+196|0),v=A+336|0,r|0}function _W(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,l=L8(f),h=ur(f,A+208|0),nr(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(b2(A+332|0,A+328|0))break i;o=i[A+180>>2],u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,(o|0)==(f+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,F2(e,f<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),o=A+332|0,f=i[o>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(Ji(f,l,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,h))break i;k4(o);continue}break}u[A+207|0]>>>7|0?f=i[A+200>>2]:f=u[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,_=ol(r,i[A+180>>2],k,l),X[w>>1]=_,G4(A+196|0,A+16|0,i[A+12>>2],k),b2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],_2(e),_2(A+196|0),v=A+336|0,r|0}function BW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0;I=v-80|0,v=I;i:{if(!(r&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}f=I+8|0,i[f>>2]=0,i[f+4>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0;e:{if(u[e+12|0]==1){k=u0[e+24>>3],n=u0[e+32>>3],h=k*n,o=u0[e+16>>3],s=u0[e+40>>3],_=o*s,l=h-_,u0[f+40>>3]=l+l,l=o*k,B=n*s,w=l+B,u0[f+24>>3]=w+w,w=o*n,s=k*s,m=w+s,u0[f+16>>3]=m+m,l=l-B,u0[f+8>>3]=l+l,o=o*o,n=n*n,l=o+n,u0[f+32>>3]=1-(l+l),l=k*k,k=l+n,u0[f>>3]=1-(k+k),n=o+l,n=1-(n+n),o=h+_,o=o+o,k=w-s,k=k+k;break e}k=u0[e+56>>3]*.017453292519943295,o=g5(k),s=Z5(k),n=u0[e+48>>3]*.017453292519943295,k=g5(n),n=Z5(n),h=u0[e+64>>3],l=s*0,V=l+(0-o),_=V*0,B=o*0+(s+0),u0[f+24>>3]=_+(k*B+n*0),u0[f>>3]=_+(n*B+k*-0),h=h*.017453292519943295,_=Z5(h),G=o*-0,h=g5(h),w=h*-0,Y=s*_+(G+w),E=Y*0,w=o*_+(l+w),m=_*0,Q=m+(0-h),u0[f+40>>3]=E+(k*w+n*Q),G=s*h+(G+m),R=G*0,o=o*h+(l+m),s=h*0+(_+0),u0[f+32>>3]=R+(k*o+n*s),u0[f+16>>3]=E+(n*w-Q*k),u0[f+8>>3]=R+(n*o-s*k),n=Y+(w*0+Q*0),o=G+(o*0+s*0),k=V+(B*0+0)}u0[f+64>>3]=n,u0[f+56>>3]=o,u0[f+48>>3]=k,z(r,f,72),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}v=I+80|0}function Wt(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,l=L8(f),h=ur(f,A+208|0),nr(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(b2(A+332|0,A+328|0))break i;o=i[A+180>>2],u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,(o|0)==(f+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,F2(e,f<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),o=A+332|0,f=i[o>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(Ji(f,l,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,h))break i;k4(o);continue}break}u[A+207|0]>>>7|0?f=i[A+200>>2]:f=u[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,_=Bl(r,i[A+180>>2],k,l),i[w>>2]=_,G4(A+196|0,A+16|0,i[A+12>>2],k),b2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],_2(e),_2(A+196|0),v=A+336|0,r|0}function l3(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;i:{if(l=i[A+4>>2],o=i[A>>2],s=l-o|0,n=((s|0)/56|0)+1|0,n>>>0<76695845){if(r=(i[A+8>>2]-o|0)/56|0,f=r<<1,f=r>>>0>=38347922?76695844:f>>>0>n>>>0?f:n,f>>>0>=76695845)break i;if(h=g(f,56),w=C(h),k=s+w|0,i[k>>2]=i[e>>2],i[k+4>>2]=i[e+4>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=i[e+12>>2],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,f=i[e+52>>2],i[k+48>>2]=i[e+48>>2],i[k+52>>2]=f,f=i[e+44>>2],i[k+40>>2]=i[e+40>>2],i[k+44>>2]=f,f=i[e+36>>2],i[k+32>>2]=i[e+32>>2],i[k+36>>2]=f,f=i[e+28>>2],i[k+24>>2]=i[e+24>>2],i[k+28>>2]=f,f=i[e+20>>2],i[k+16>>2]=i[e+16>>2],i[k+20>>2]=f,f=k+g((s|0)/-56|0,56)|0,(o|0)!=(l|0)){for(e=o,r=f;i[r>>2]=i[e>>2],i[r+4>>2]=i[e+4>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=i[e+12>>2],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,n=i[e+52>>2],i[r+48>>2]=i[e+48>>2],i[r+52>>2]=n,n=i[e+44>>2],i[r+40>>2]=i[e+40>>2],i[r+44>>2]=n,n=i[e+36>>2],i[r+32>>2]=i[e+32>>2],i[r+36>>2]=n,n=i[e+28>>2],i[r+24>>2]=i[e+24>>2],i[r+28>>2]=n,n=i[e+20>>2],i[r+16>>2]=i[e+16>>2],i[r+20>>2]=n,r=r+56|0,e=e+56|0,(l|0)!=(e|0););for(;e=i[o+4>>2],e&&(i[o+8>>2]=e,Z(e)),o=o+56|0,(l|0)!=(o|0););o=i[A>>2]}return i[A+8>>2]=h+w,e=k+56|0,i[A+4>>2]=e,i[A>>2]=f,o&&Z(o),e}s0(),M()}x0(),M()}function vW(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0;A=v-624|0,v=A,i[A+616>>2]=r,i[A+620>>2]=e,i[A+16>>2]=2127,e=A+16|0,s=J1(A+200|0,A+208|0,e),h=A+192|0,l=i[k+28>>2],i[h>>2]=l,(l|0)!=136824&&(i[l+4>>2]=i[l+4>>2]+1),l=$0(h,137e3),t[A+191|0]=0;i:{if(!P9(A+620|0,r,f,h,i[k+4>>2],n,A+191|0,l,s,A+196|0,A+608|0))break i;r=u[22909]|u[22910]<<8|(u[22911]<<16|u[22912]<<24),t[A+183|0]=r,t[A+184|0]=r>>>8,t[A+185|0]=r>>>16,t[A+186|0]=r>>>24,r=u[22906]|u[22907]<<8|(u[22908]<<16|u[22909]<<24),i[A+176>>2]=u[22902]|u[22903]<<8|(u[22904]<<16|u[22905]<<24),i[A+180>>2]=r,W[i[i[l>>2]+48>>2]](l,A+176|0,A+186|0,A+128|0)|0,i[A+16>>2]=2126,f=J1(A+8|0,0,e),k=e;e:{if(e=i[A+196>>2]-i[s>>2]|0,(e|0)>=393&&(r=E2((e>>2)+2|0),e=i[f>>2],i[f>>2]=r,e&&W[i[f+4>>2]](e),k=i[f>>2],!k))break e;for(u[A+191|0]==1&&(t[k|0]=45,k=k+1|0),r=i[s>>2];;){if(o0[A+196>>2]<=r>>>0)r:{if(t[k|0]=0,i[A>>2]=o,(wh(A+16|0,A)|0)!=1)break r;e=i[f>>2],i[f>>2]=0,e&&W[i[f+4>>2]](e);break i}else{e=A+128|0,w=k,_=u[(A+176|0)+(u7(e,e+40|0,r)-e>>2)|0],t[w|0]=_,k=k+1|0,r=r+4|0;continue}break}N1(),M()}N1(),M()}return b2(A+620|0,A+616|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+620>>2],i2(A+192|0),e=i[s>>2],i[s>>2]=0,e&&W[i[s+4>>2]](e),v=A+624|0,r|0}function mW(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;k=v-16|0,v=k;i:{if(!i[A+64>>2])break i;e:{if(f=i[A+68>>2],f){if(r=i[A+92>>2],r&16){if(i[A+24>>2]!=i[A+20>>2]&&(e=-1,(W[i[i[A>>2]+52>>2]](A,-1)|0)==-1))break i;for(f=A+72|0;;){if(e=i[A+68>>2],r=i[A+32>>2],r=W[i[i[e>>2]+20>>2]](e,f,r,r+i[A+52>>2]|0,k+12|0)|0,n=i[A+32>>2],e=i[k+12>>2]-n|0,(r4(n,1,e,i[A+64>>2])|0)!=(e|0))break e;r:switch(r-1|0){case 1:break e;case 0:continue;default:break r}break}if(e=0,!Q6(i[A+64>>2]))break i;break e}if(!(r&8))break i;e=i[A+84>>2],i[k>>2]=i[A+80>>2],i[k+4>>2]=e;r:{f:{A:{if(u[A+98|0]==1){e=i[A+16>>2]-i[A+12>>2]|0,f=e>>31;break A}if(r=W[i[i[f>>2]+24>>2]](f)|0,e=i[A+40>>2]-i[A+36>>2]|0,f=e>>31,(r|0)>0){r=g(r,i[A+16>>2]-i[A+12>>2]|0),f=f+(r>>31)|0,n=e,e=e+r|0,f=n>>>0>e>>>0?f+1|0:f;break A}if(i[A+12>>2]!=i[A+16>>2])break f}r=0;break r}r=i[A+68>>2],r=W[i[i[r>>2]+32>>2]](r,k,i[A+32>>2],i[A+36>>2],i[A+12>>2]-i[A+8>>2]|0)|0,r=i[A+36>>2]-(r+i[A+32>>2]|0)|0,f=f+(r>>31)|0,n=e,e=e+r|0,f=n>>>0>e>>>0?f+1|0:f,r=1}if(lf(i[A+64>>2],0-e|0,0-(f+((e|0)!=0)|0)|0,1))break e;r&&(e=i[k+4>>2],i[A+72>>2]=i[k>>2],i[A+76>>2]=e),e=i[A+32>>2],i[A+40>>2]=e,i[A+36>>2]=e,e=0,i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,i[A+92>>2]=0;break i}N1(),M()}e=-1}return v=k+16|0,e|0}function Ye(A,e){var r=0,f=0,k=0,n=0;t[A+4|0]=u[e+4|0],r=u[e+9|0]|u[e+10|0]<<8|(u[e+11|0]<<16|u[e+12|0]<<24),t[A+9|0]=r,t[A+10|0]=r>>>8,t[A+11|0]=r>>>16,t[A+12|0]=r>>>24,r=p[e+6>>1]|p[e+8>>1]<<16,X[A+6>>1]=r,X[A+8>>1]=r>>>16,r=i[e+16>>2],f=i[e+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+16>>2]=r,r=i[A+20>>2],i[A+20>>2]=f;i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i[A+24>>2]=i[e+24>>2],i[A+28>>2]=i[e+28>>2],i[A+32>>2]=i[e+32>>2],r=i[e+40>>2],i[A+36>>2]=i[e+36>>2],i[A+40>>2]=r,r=i[e+48>>2],i[A+44>>2]=i[e+44>>2],i[A+48>>2]=r,r=i[e+56>>2],i[A+52>>2]=i[e+52>>2],i[A+56>>2]=r,t[A+60|0]=u[e+60|0],a2(i[A+64>>2]),i[A+64>>2]=0,i[e+64>>2]&&(r=bi(),i[A+64>>2]=r,li(r,i[e+64>>2]));i:{e:{r:{if((A|0)!=(e|0)){if(r=A+68|0,f=e+68|0,k=t[e+79|0],t[A+79|0]>=0){if((k|0)<0)break r;k=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=k,i[r+8>>2]=i[f+8>>2];break e}n=r,r=(k|0)<0,R1(n,r?i[e+68>>2]:f,r?i[e+72>>2]:k);break e}y3(A+96|0,e+96|0);break i}m1(r,i[e+68>>2],i[e+72>>2])}y3(A+96|0,e+96|0),r=i[e+116>>2],f=i[e+120>>2],MA(A+116|0,r,f,(f-r|0)/28|0),r=i[e+128>>2],f=i[e+132>>2],e5(A+128|0,r,f,(f-r|0)/52|0),r=i[e+140>>2],f=i[e+144>>2],EA(A+140|0,r,f,(f-r|0)/48|0)}X[A+152>>1]=p[e+152>>1],i[A+156>>2]=i[e+156>>2],i[A+160>>2]=i[e+160>>2]}function ZW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;k=v-80|0,v=k,W[i[i[e>>2]+156>>2]](k+48|0,e);i:{e:switch(u[k+68|0]){default:e2(),M();case 1:if(e=i[k+52>>2],i[A>>2]=i[k+48>>2],i[A+4>>2]=e,A=A+8|0,t[k+67|0]>=0){e=i[k+60>>2],i[A>>2]=i[k+56>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+64>>2];break i}T(A,i[k+56>>2],i[k+60>>2]);break i;case 0:break e}o=i[k+48>>2],n=i[k+52>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),W[i[i[o>>2]+20>>2]](k+24|0,o,r,f);e:{if(i[k+24>>2]){e=i[k+28>>2],i[A>>2]=i[k+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+40>>2],e=i[k+36>>2],i[A+8>>2]=i[k+32>>2],i[A+12>>2]=e,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0;break e}i[r>>2]|p[e+10>>1]||(i[r>>2]=1,i[f>>2]=3),e=i[28729],i[k>>2]=i[28728],i[k+4>>2]=e,e=k+8|0;r:{if(t[114931]>=0){r=i[28731],i[e>>2]=i[28730],i[e+4>>2]=r,i[e+8>>2]=i[28732];break r}T(e,i[28730],i[28731])}if(t[k+19|0]<0&&Z(i[k+8>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731])}if(t[k+43|0]<0&&Z(i[k+32>>2]),!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n)}A=u[k+68|0],(A|0)!=255&&(e=i[26905],i[k+24>>2]=i[26904],i[k+28>>2]=e,W[i[(k+24|0)+(A<<2)>>2]](k+79|0,k+48|0)),v=k+80|0}function gW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,l=L8(f),tr(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(d2(A+252|0,A+248|0))break i;o=i[A+180>>2],u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,(o|0)==(f+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,F2(e,f<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),o=A+252|0,f=i[o>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=t[s|0]}if(Ri(f<<24>>24,l,r,A+180|0,A+8|0,t[A+247|0],A+196|0,A+16|0,A+12|0,83888))break i;A4(o);continue}break}u[A+207|0]>>>7|0?f=i[A+200>>2]:f=u[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,w=tl(r,i[A+180>>2],k,l),i[h>>2]=w,G4(A+196|0,A+16|0,i[A+12>>2],k),d2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],_2(e),_2(A+196|0),v=A+256|0,r|0}function GW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,l=L8(f),tr(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(d2(A+252|0,A+248|0))break i;o=i[A+180>>2],u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,(o|0)==(f+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,F2(e,f<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),o=A+252|0,f=i[o>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=t[s|0]}if(Ri(f<<24>>24,l,r,A+180|0,A+8|0,t[A+247|0],A+196|0,A+16|0,A+12|0,83888))break i;A4(o);continue}break}u[A+207|0]>>>7|0?f=i[A+200>>2]:f=u[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,w=ol(r,i[A+180>>2],k,l),X[h>>1]=w,G4(A+196|0,A+16|0,i[A+12>>2],k),d2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],_2(e),_2(A+196|0),v=A+256|0,r|0}function Xt(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,l=L8(f),tr(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(d2(A+252|0,A+248|0))break i;o=i[A+180>>2],u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,(o|0)==(f+r|0)&&(u[e+11|0]>>>7|0?r=i[e+4>>2]:r=u[e+11|0]&127,u[e+11|0]>>>7|0?f=i[e+4>>2]:f=u[e+11|0]&127,F2(e,f<<1),F2(e,u[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,u[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),o=A+252|0,f=i[o>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=t[s|0]}if(Ri(f<<24>>24,l,r,A+180|0,A+8|0,t[A+247|0],A+196|0,A+16|0,A+12|0,83888))break i;A4(o);continue}break}u[A+207|0]>>>7|0?f=i[A+200>>2]:f=u[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,w=Bl(r,i[A+180>>2],k,l),i[h>>2]=w,G4(A+196|0,A+16|0,i[A+12>>2],k),d2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],_2(e),_2(A+196|0),v=A+256|0,r|0}function WW(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0;A=v-272|0,v=A,i[A+264>>2]=r,i[A+268>>2]=e,i[A+16>>2]=2127,e=A+16|0,s=J1(A+152|0,A+160|0,e),h=A+144|0,l=i[k+28>>2],i[h>>2]=l,(l|0)!=136824&&(i[l+4>>2]=i[l+4>>2]+1),l=$0(h,137008),t[A+143|0]=0;i:{if(!j9(A+268|0,r,f,h,i[k+4>>2],n,A+143|0,l,s,A+148|0,A+260|0))break i;r=u[22909]|u[22910]<<8|(u[22911]<<16|u[22912]<<24),t[A+135|0]=r,t[A+136|0]=r>>>8,t[A+137|0]=r>>>16,t[A+138|0]=r>>>24,r=u[22906]|u[22907]<<8|(u[22908]<<16|u[22909]<<24),i[A+128>>2]=u[22902]|u[22903]<<8|(u[22904]<<16|u[22905]<<24),i[A+132>>2]=r,W[i[i[l>>2]+32>>2]](l,A+128|0,A+138|0,A+118|0)|0,i[A+16>>2]=2126,f=J1(A+8|0,0,e),k=e;e:{if(e=i[A+148>>2]-i[s>>2]|0,(e|0)>=99&&(r=E2(e+2|0),e=i[f>>2],i[f>>2]=r,e&&W[i[f+4>>2]](e),k=i[f>>2],!k))break e;for(u[A+143|0]==1&&(t[k|0]=45,k=k+1|0),r=i[s>>2];;){if(o0[A+148>>2]<=r>>>0)r:{if(t[k|0]=0,i[A>>2]=o,(wh(A+16|0,A)|0)!=1)break r;e=i[f>>2],i[f>>2]=0,e&&W[i[f+4>>2]](e);break i}else{e=A+118|0,w=k,_=u[((s7(e,e+10|0,r)-A|0)+A|0)+10|0],t[w|0]=_,k=k+1|0,r=r+1|0;continue}break}N1(),M()}N1(),M()}return d2(A+268|0,A+264|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+268>>2],i2(A+144|0),e=i[s>>2],i[s>>2]=0,e&&W[i[s+4>>2]](e),v=A+272|0,r|0}function XW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0;f=v-160|0,v=f,i[f+100>>2]=0,i[f+72>>2]=78164,i[f+16>>2]=78144,r=i[19545],i[f+8>>2]=r,k=i[r-12>>2],o=f+8|0,r=o,i[k+r>>2]=i[19546],i[f+12>>2]=0,r=r+i[i[f+8>>2]-12>>2]|0,k=f+20|0,J0(r,k),t[r+80|0]=0,i[r+72>>2]=0,r=i[19547],i[f+16>>2]=r,n=f+16|0,i[n+i[r-12>>2]>>2]=i[19548],r=i[19544],i[f+8>>2]=r,i[o+i[r-12>>2]>>2]=i[19549],i[f+72>>2]=78164,i[f+8>>2]=78124,i[f+16>>2]=78144,o=R0(k),i[o>>2]=77200,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+68>>2]=24,r=i[e+4>>2];i:{if(!r){F(n,22853,18);break i}F(B0(n,r),22864,7)}if(r=i[e+8>>2],e=i[e+12>>2],(r|0)!=(e|0))for(;k=i[r>>2],t[f+159|0]=32,B0(F(n,f+159|0,1),k),r=r+4|0,(e|0)!=(r|0););e=i[f+68>>2];i:{e:{if(e&16){r=i[f+64>>2],e=i[f+44>>2],r>>>0<e>>>0&&(i[f+64>>2]=e,r=e),e=f+40|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+36>>2],e=f+28|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,n,r)}t[A+r|0]=0,A=i[19543],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19551],i[f+16>>2]=i[19552],i[o>>2]=77200,t[f+63|0]<0&&Z(i[f+52>>2]),y0(o),Y0(f+72|0),v=f+160|0}function A1(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;n=i[A+16>>2],k=i[A+20>>2],f=i[A+4>>2],r=i[A+24>>2],_=i[A+12>>2],o=_;i:{for(;;){B=A;e:{if((r|0)>0){h=k;break e}r=64-r|0;r:{f:{if(!o)break f;G=0;A:{for(;;){if(l=f+1|0,i[A+4>>2]=l,h=u[f|0],o=o-1|0,i[A+12>>2]=o,m=r-8|0,f=m&31,(m&63)>>>0>=32?(s=h<<f,f=0):(s=(1<<f)-1&h>>>32-f,f=h<<f),n=f|n,i[A+16>>2]=n,k=k|s,i[A+20>>2]=k,(r|0)<=15)break A;if(G=G-(r>>>0<8)|0,r=r-8|0,f=l,!o)break}_=o;break f}_=o,f=l;break r}o=0,m=r}h=k,r=64-m|0}if(l=r,r=r-1|0,i[B+24>>2]=r,s=h<<1|n>>>31,n=n<<1,i[A+16>>2]=n,k=s,i[A+20>>2]=k,(h|0)>0|(h|0)>=0){if(w=w+1|0,(w|0)!=21)continue;break i}break}if(I=e,w){if(m=A,!((l|0)>(w|0)|(l|0)>57)){for(r=65-l|0,G=0;;){e:{if(o=r,!_){e=r;break e}if(l=f+1|0,i[A+4>>2]=l,f=u[f|0],_=_-1|0,i[A+12>>2]=_,e=o-8|0,B=e&31,(e&63)>>>0>=32?(s=f<<B,f=0):(s=(1<<B)-1&f>>>32-B,f=f<<B),n=f|n,i[A+16>>2]=n,k=k|s,i[A+20>>2]=k,f=r,r=r-8|0,G=G-(f>>>0<8)|0,f=l,(o|0)>15)continue}break}r=64-e|0}i[m+24>>2]=r-w,r=n,e=w&31,(w&63)>>>0>=32?(s=r<<e,e=0):(s=(1<<e)-1&r>>>32-e|k<<e,e=r<<e),i[A+16>>2]=e,i[A+20>>2]=s,e=64-w|0,A=e&31,(e&63)>>>0>=32?A=k>>>A|0:A=((1<<A)-1&k)<<32-A|r>>>A,A=A+(-1<<w^-1)|0}else A=0;i[I>>2]=A}return h>>>31|0}function IW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;f=v-48|0,v=f;i:{e:{r:{f:{A:{if(r=i[e+184>>2],e=i[e+188>>2],(r|0)!=(e|0))for(;;){k:{if(k=i[r>>2],!k||(k=Z0(k,92792,106644),!k))break k;if(r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+20>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,jn(k,f+12|0))break r;if(t[f|0]=0,t[f+11|0]=0,e=a(f+24|0,2,117,f),k=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=k,k=A+8|0,t[e+19|0]<0)break A;n=i[e+12>>2],i[k>>2]=i[e+8>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+16>>2],t[A+20|0]=1;break f}if(r=r+8|0,(e|0)==(r|0))break}t[f+12|0]=0,t[f+23|0]=0,e=a(f+24|0,2,141,f+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;k:{if(t[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],t[A+20|0]=1;break k}if(T(r,i[e+8>>2],i[e+12>>2]),r=t[e+19|0],t[A+20|0]=1,(r|0)>=0)break k;Z(i[e+8>>2])}if(t[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}if(T(k,i[e+8>>2],i[e+12>>2]),k=t[e+19|0],t[A+20|0]=1,(k|0)>=0)break f;Z(i[e+8>>2])}if(t[f+11|0]<0&&Z(i[f>>2]),A=i[f+12>>2],!A)break e;i[f+16>>2]=A,Z(A);break e}e=i[f+16>>2],k=i[f+12>>2],n=i[f+20>>2],t[A+20|0]=0,i[A+8>>2]=n,i[A>>2]=k,i[A+4>>2]=e}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}v=f+48|0}function QW(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0;if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}i:{if((r|0)>=0&&(s=i[e>>2],e=i[s+128>>2],(i[s+132>>2]-e|0)/52>>>0>r>>>0))break i;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27877;return}e=e+g(r,52)|0;i:{if(!f||(r=i[e>>2],s=i[e+4>>2],(r|0)==(s|0))||(s=s-r|0,!s))break i;z(f,r,s)}i:{if(!k||(r=i[e+16>>2],f=i[e+20>>2],(r|0)==(f|0))||(f=f-r|0,!f))break i;z(k,r,f)}i:{if(!n||(r=i[e+28>>2],f=i[e+32>>2],(r|0)==(f|0))||(f=f-r|0,!f))break i;z(n,r,f)}i:{if(!o||(r=i[e+40>>2],e=i[e+44>>2],(r|0)==(e|0)))break i;if(f=e-r>>3,n=f>>>0<=1?1:f,s=n&3,k=0,e=0,f>>>0>=4)for(w=n&-4,f=0;n=e<<3,l=n+o|0,h=r+n|0,i[l>>2]=i[h>>2],i[l+4>>2]=i[h+4>>2],l=n|8,h=l+o|0,l=r+l|0,i[h>>2]=i[l>>2],i[h+4>>2]=i[l+4>>2],l=n|16,h=l+o|0,l=r+l|0,i[h>>2]=i[l>>2],i[h+4>>2]=i[l+4>>2],n=n|24,l=n+o|0,n=r+n|0,i[l>>2]=i[n>>2],i[l+4>>2]=i[n+4>>2],e=e+4|0,f=f+4|0,(w|0)!=(f|0););if(!s)break i;for(;f=e<<3,n=f+o|0,f=r+f|0,i[n>>2]=i[f>>2],i[n+4>>2]=i[f+4>>2],e=e+1|0,k=k+1|0,(s|0)!=(k|0););}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function VW(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;i[A+4>>2]=1,f=i[A+8>>2],i[f+324>>2]=i[f+324>>2]-1,i[f+328>>2]=i[f+328>>2]+1,f=i[A+12>>2],n=f+1|0,r=i[A+8>>2],e=i[r+124>>2],s=i[e+16884>>2]/4|0,h=i[r+276>>2],l=i[e+16892>>2],k=l-1|0,o=i[r+272>>2],w=u[A+16|0];i:{if(w){e=i[e+16900>>2]-1|0,O8(r,A,k,(e|0)<(n|0)?e:n,1);break i}if((f|0)<=0?e=f:(O8(r,A,k,f-1|0,2),r=i[A+8>>2],e=i[A+12>>2]),O8(r,A,k,e,2),r=i[A+12>>2]+1|0,e=i[A+8>>2],(r|0)>=i[i[e+124>>2]+16900>>2])break i;O8(e,A,k,r,2)}e=i[A+12>>2],r=i[A+8>>2];i:{e:{if(u[A+16|0]==1){if(e=un(r,e),r=i[A+8>>2],t[(i[r+140>>2]+g(g(i[r+152>>2],i[A+12>>2]),24)|0)+21|0]=e,!e)break i;k=u[A+16|0];break e}if(k=0,u[(i[r+140>>2]+g(g(e,i[r+152>>2]),24)|0)+21|0]!=1)break i}f=g(f,s),e=g(n,s),e=(e|0)<(h|0)?e:h,BA(r,k&1,f,e,o),r=u[A+16|0],k=i[A+8>>2];e:{if(i[i[k+124>>2]+16832>>2]>=9){lA(k,r&1,f,e,o);break e}sA(k,r&1,f,e,o)}if(r=i[A+8>>2],n=i[r+124>>2],!i[n+16848>>2])break i;if(k=u[A+16|0],i[n+16840>>2]>=9){wA(r,k&1,f,e,o);break i}_A(r,k&1,f,e,o)}if(r=0,(l|0)>0)for(f=w?2:3;e=i[A+8>>2],e=(i[e+320>>2]+g(r,76)|0)+g(g(i[A+12>>2],i[i[e+124>>2]+16892>>2]),76)|0,(f|0)>i[e>>2]&&(i[e>>2]=f),r=r+1|0,(l|0)!=(r|0););i[A+4>>2]=3,ff(i[A+8>>2])}function pW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,S2(k+12|0,e,r),t[k+31|0]<0&&Z(i[k+20>>2]);i:{if(u[e+97|0]){B1(A,e,12432);break i}if(n=F0(r),(n|0)<0){if(e=C(32),i[k>>2]=e,i[k+4>>2]=30,i[k+8>>2]=-2147483616,r=u[24287]|u[24288]<<8|(u[24289]<<16|u[24290]<<24),f=u[24283]|u[24284]<<8|(u[24285]<<16|u[24286]<<24),t[e|0]=f,t[e+1|0]=f>>>8,t[e+2|0]=f>>>16,t[e+3|0]=f>>>24,t[e+4|0]=r,t[e+5|0]=r>>>8,t[e+6|0]=r>>>16,t[e+7|0]=r>>>24,t[e+30|0]=0,r=u[24309]|u[24310]<<8|(u[24311]<<16|u[24312]<<24),f=u[24305]|u[24306]<<8|(u[24307]<<16|u[24308]<<24),t[e+22|0]=f,t[e+23|0]=f>>>8,t[e+24|0]=f>>>16,t[e+25|0]=f>>>24,t[e+26|0]=r,t[e+27|0]=r>>>8,t[e+28|0]=r>>>16,t[e+29|0]=r>>>24,r=u[24303]|u[24304]<<8|(u[24305]<<16|u[24306]<<24),f=u[24299]|u[24300]<<8|(u[24301]<<16|u[24302]<<24),t[e+16|0]=f,t[e+17|0]=f>>>8,t[e+18|0]=f>>>16,t[e+19|0]=f>>>24,t[e+20|0]=r,t[e+21|0]=r>>>8,t[e+22|0]=r>>>16,t[e+23|0]=r>>>24,r=u[24295]|u[24296]<<8|(u[24297]<<16|u[24298]<<24),f=u[24291]|u[24292]<<8|(u[24293]<<16|u[24294]<<24),t[e+8|0]=f,t[e+9|0]=f>>>8,t[e+10|0]=f>>>16,t[e+11|0]=f>>>24,t[e+12|0]=r,t[e+13|0]=r>>>8,t[e+14|0]=r>>>16,t[e+15|0]=r>>>24,a(A,6,1e3,k),t[k+11|0]>=0)break i;Z(i[k>>2]);break i}Xi(A,e,r,n,f)}v=k+32|0}function FW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(B0(F(B0(F(f+8|0,20872,14),i[e+100>>2]),29397,1),i[e+104>>2]),29397,1),i[e+108>>2]),46799,2),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function CW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,K1(n,e,r),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),o=F(f+8|0,36573,21),r=t[e+115|0],k=(r|0)<0,F(F(o,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function YW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),o=F(f+8|0,36788,19),r=t[e+115|0],k=(r|0)<0,F(F(o,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function yW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),o=F(f+8|0,34606,10),r=t[e+115|0],k=(r|0)<0,F(F(o,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function EW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),o=F(f+8|0,37567,12),r=t[e+111|0],k=(r|0)<0,F(F(o,k?i[e+100>>2]:e+100|0,k?i[e+104>>2]:r),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function RW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[19621],l=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(l,n),t[l+80|0]=0,i[l+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,l=R0(n),i[l>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,K1(n,e,r),s=k,o=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),o=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),o=F(f+8|0,34945,5),r=t[e+115|0],k=(r|0)<0,F(F(o,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[l>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(l),Y0(f- -64|0),v=f+160|0}function JW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,n=i[r+12>>2];i:{if((n|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if((n|0)!=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(i[r>>2]==1&i[r+4>>2]==3)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(n=u[r+8|0],!(!(i[r+16>>2]&-9)|(n|0)!=1)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:switch(p[f+24>>1]-11|0){case 0:case 3:i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i;default:break e}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[e+20>>2]=0,r=i[f+4>>2],!((r|0)==3|(u[k+12|0]?i[k+4>>2]!=1:0))){i[e+16>>2]=8,t[e+12|0]=n,i[e+8>>2]=r,i[e+4>>2]=0,r=u[f+23|0]|u[f+24|0]<<8|(u[f+25|0]<<16|u[f+26|0]<<24),t[e+27|0]=r,t[e+28|0]=r>>>8,t[e+29|0]=r>>>16,t[e+30|0]=r>>>24,i[e+24>>2]=i[f+20>>2],i[e>>2]=11,l8(A,e+4|0,e);break i}i[e+16>>2]=8,t[e+12|0]=n,i[e+4>>2]=0,i[e+8>>2]=3,r=u[f+23|0]|u[f+24|0]<<8|(u[f+25|0]<<16|u[f+26|0]<<24),t[e+27|0]=r,t[e+28|0]=r>>>8,t[e+29|0]=r>>>16,t[e+30|0]=r>>>24,i[e+24>>2]=i[f+20>>2],r=C(32),i[r+24>>2]=i[e+28>>2],f=i[e+24>>2],i[r+16>>2]=i[e+20>>2],i[r+20>>2]=f,f=i[e+16>>2],i[r+8>>2]=i[e+12>>2],i[r+12>>2]=f,f=i[e+8>>2],i[r>>2]=i[e+4>>2],i[r+4>>2]=f,i[r+28>>2]=11,f=r+32|0,i[A+8>>2]=f,i[A>>2]=r,i[A+4>>2]=f}v=e+32|0}function k2(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;k=i[A+8>>2],r=i[A+12>>2],n=i[A+16>>2];i:{for(;;){e:{if((n|0)>0){e=r,f=n;break e}for(f=64-n|0,w=0,n=i[A+4>>2],e=r;;){r:{if(s=f,!n){o=f;break r}if(r=i[A>>2],i[A>>2]=r+1,r=u[r|0],n=n-1|0,i[A+4>>2]=n,_=A,B=k,o=s-8|0,k=o&31,(o&63)>>>0>=32?(h=r<<k,r=0):(h=(1<<k)-1&r>>>32-k,r=r<<k),k=B|r,r=e|h,e=r,i[_+8>>2]=k,i[_+12>>2]=e,r=f,f=r-8|0,w=w-(r>>>0<8)|0,(s|0)>15)continue}break}f=64-o|0}if(n=f-1|0,i[A+16>>2]=n,h=e<<1|k>>>31,k=k<<1,i[A+8>>2]=k,r=h,i[A+12>>2]=r,(e|0)<0)break i;if(l=l+1|0,(l|0)==21)break}return-99999}if(!l)return 0;if(!((f|0)>(l|0)|(f|0)>57)){for(f=65-f|0,w=0,n=i[A+4>>2];;){i:{if(_=f,!n){o=f;break i}if(e=i[A>>2],i[A>>2]=e+1,e=u[e|0],n=n-1|0,i[A+4>>2]=n,h=A,B=k,o=_-8|0,k=o&31,(o&63)>>>0>=32?(s=e<<k,e=0):(s=(1<<k)-1&e>>>32-k,e=e<<k),k=B|e,i[h+8>>2]=k,r=r|s,i[A+12>>2]=r,e=f,f=e-8|0,w=w-(e>>>0<8)|0,(_|0)>15)continue}break}n=64-o|0}if(i[A+16>>2]=n-l,f=k,e=l&31,(l&63)>>>0>=32?(s=k<<e,f=0):(s=(1<<e)-1&f>>>32-e|r<<e,f=f<<e),i[A+8>>2]=f,i[A+12>>2]=s,A=k,f=64-l|0,e=f&31,(f&63)>>>0>=32?A=r>>>e|0:A=((1<<e)-1&r)<<32-e|A>>>e,A=A+(1<<l)|0,(A|0)>1)return A-1|0;U0(23763,19928,146,19720),M()}function It(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;i:{e:{r:{f:{A:{k:{n:{t:{o:{l:{if(k=e,k){if(!r)break l;if(!f)break o;if(k=_1(f)-_1(k)|0,k>>>0<=31)break t;break e}if((f|0)==1|f>>>0>1)break e;return e=(A>>>0)/(r>>>0)|0,T6=A-g(e,r)|0,j6=0,h0=0,e}if(!A)break n;if(!f||(n=f-1|0,n&f))break k;return T6=A,j6=k&n,A=k>>>w8(f)|0,h0=0,A}if(n=r-1|0,!(n&r))break A;w=(_1(r)+33|0)-_1(k)|0,o=0-w|0;break r}w=k+1|0,o=63-k|0;break r}return T6=0,A=(k>>>0)/(f>>>0)|0,j6=k-g(A,f)|0,h0=0,A}if(k=_1(f)-_1(k)|0,k>>>0<31)break f;break e}if(T6=A&n,j6=0,(r|0)==1)break i;return r=w8(r),f=r&31,(r&63)>>>0>=32?(k=0,A=e>>>f|0):(k=e>>>f|0,A=((1<<f)-1&e)<<32-f|A>>>f),h0=k,A}w=k+1|0,o=63-k|0}if(n=A,k=w&63,l=k&31,(k&63)>>>0>=32?(k=0,n=e>>>l|0):(k=e>>>l|0,n=((1<<l)-1&e)<<32-l|n>>>l),l=o&63,o=A,s=l&31,(l&63)>>>0>=32?(h=A<<s,A=0):(h=(1<<s)-1&o>>>32-s|e<<s,A=o<<s),e=h,w)for(o=f-1|0,_=r-1|0,o=(_|0)!=-1?o+1|0:o,l=_;k=k<<1|n>>>31,n=n<<1|e>>>31,_=k,s=o-(k+(n>>>0>l>>>0)|0)|0,B=s>>31,h=B,k=n,s=r&h,n=k-s|0,k=_-((f&h)+(k>>>0<s>>>0)|0)|0,h=e<<1|A>>>31,A=m|A<<1,e=h|G,_=B&1,m=_,w=w-1|0,!!w;);return T6=n,j6=k,h=e<<1|A>>>31,A=_|A<<1,h0=h|G,A}T6=A,j6=e,A=0,e=0}return h0=e,A}function q6(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;n=v-16|0,v=n,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0;i:{if(r){if((r|0)<0)break i;f=C(r),r&&l0(f,0,r),k=r+f|0,i[n+12>>2]=k,i[n+8>>2]=k,i[n+4>>2]=f}r&&z(f,e,r),f=v-16|0,v=f,e=n+4|0,k=u[i[e>>2]+1|0]>>>3|0;e:{r:{r=i[A+176>>2],o=i[A+180>>2];f:{if((r|0)!=(o|0))for(;;){if((k|0)==u[r+1|0]){if(A=i[r+8>>2],A>>>0<o0[r+12>>2]){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=i[e+4>>2],o=i[e>>2],(k|0)!=(o|0)){if(e=k-o|0,(e|0)<0)break r;k=C(e),i[A+4>>2]=k,i[A>>2]=k,l=e+k|0,i[A+8>>2]=l,e&&z(k,o,e),i[A+4>>2]=l}i[r+8>>2]=A+12;break f}s=r,h=ii(r+4|0,e),i[s+8>>2]=h;break f}if(r=r+16|0,(o|0)==(r|0))break}i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,t[f+1|0]=k,t[f|0]=1,r=ii(f+4|0,e),e=i[A+180>>2],i[f+8>>2]=r;A:{if(e>>>0<o0[A+184>>2]){r=p[f>>1],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,X[e>>1]=r,r=i[f+4>>2],k=i[f+8>>2],Oe(e+4|0,r,k,(k-r|0)/12|0),e=e+16|0;break A}e=St(A+176|0,f)}if(i[A+180>>2]=e,e=i[f+4>>2],!e)break f;if(A=e,r=i[f+8>>2],(e|0)!=(r|0)){for(;A=r-12|0,k=i[A>>2],k&&(i[r-8>>2]=k,Z(k)),r=A,(e|0)!=(r|0););A=i[f+4>>2]}i[f+8>>2]=e,Z(A)}v=f+16|0;break e}s0(),M()}A=i[n+4>>2],A&&(i[n+8>>2]=A,Z(A)),v=n+16|0;return}s0(),M()}function NW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;k=v-16|0,v=k;i:{if(!A|!e||(A=i[A>>2],!A))break i;i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,s=i[A+84>>2],r=i[A+80>>2],A=(s-r|0)/44|0;e:{r:{f:{if((r|0)!=(s|0)){if(A>>>0>=1073741824)break f;for(f=A<<2,A=C(f),i[k+8>>2]=A,i[k+4>>2]=A,i[k+12>>2]=A+f;;){n=i[k+12>>2];A:{if(n>>>0>A>>>0){i[A>>2]=i[r>>2],A=A+4|0;break A}if(l=i[k+4>>2],A=A-l|0,h=A>>2,f=h+1|0,f>>>0>=1073741824)break f;if(n=n-l|0,o=n>>1,n=n>>>0>=2147483644?1073741823:f>>>0<o>>>0?o:f,n){if(n>>>0>=1073741824)break r;f=C(n<<2)}else f=0;if(o=f+A|0,i[o>>2]=i[r>>2],h=o-(h<<2)|0,A&&z(h,l,A),i[k+12>>2]=f+(n<<2),A=o+4|0,i[k+8>>2]=A,i[k+4>>2]=h,!l)break A;Z(l)}if(i[k+8>>2]=A,r=r+44|0,(s|0)==(r|0))break}}break e}s0(),M()}x0(),M()}A=i[k+8>>2],f=i[k+4>>2];e:{if((A|0)!=(f|0)){if(r=A-f>>2,n=r>>>0<=1?1:r,l=n&3,A=0,r>>>0>=4)for(s=n&-4,n=0;r=A<<2,i[r+e>>2]=i[r+f>>2],o=r|4,i[o+e>>2]=i[f+o>>2],o=r|8,i[o+e>>2]=i[f+o>>2],r=r|12,i[r+e>>2]=i[r+f>>2],A=A+4|0,n=n+4|0,(s|0)!=(n|0););if(!l)break e;for(;r=A<<2,i[r+e>>2]=i[r+f>>2],A=A+1|0,w=w+1|0,(l|0)!=(w|0););break e}if(!f)break i}i[k+8>>2]=f,Z(f)}v=k+16|0}function u3(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0;for(m=v-2048|0,v=m,k=e;s=n,n=n+1|0,h=k>>>0>3,k=k>>>1|0,!!h;);for(k=e;h=o,o=o+1|0,n=k>>>0>3,k=k>>>1|0,!!n;);for(w=1<<s-1,o=0,k=e;n=o,o=n+1|0,l=k>>>0>3,k=k>>>1|0,!!l;);for(E=e&62,R=e&1,V=e-1|0,Y=4-n|0,N=h+7|0,l=0;;){for(G=(l<<1)+r|0,_=0;;){if(I=_<<Y,k=0,o=0,n=0,V)for(;B=k|1,U=X[G+(g(B,f)<<1)>>1],Q=B,B=(I<<5)+67712|0,o=g(U,t[Q+B|0])+(g(X[G+(g(f,k)<<1)>>1],t[k+B|0])+o|0)|0,k=k+2|0,n=n+2|0,(E|0)!=(n|0););if(n=(g(e,_)+l<<1)+m|0,R&&(o=g(X[G+(g(f,k)<<1)>>1],t[((I<<5)+k|0)+67712|0])+o|0),X[n>>1]=o+w>>s,_=_+1|0,(_|0)==(e|0))break}if(l=l+1|0,(l|0)==(e|0))break}for(l=e&62,_=e&1,G=64<<h,f=0;;){for(s=g(e,f),I=(s<<1)+A|0,r=0;;){if(h=r<<Y,k=0,o=0,n=0,V)for(;w=k|1,B=X[(w+s<<1)+m>>1],Q=w,w=(h<<5)+67712|0,o=g(B,t[Q+w|0])+(g(X[(k+s<<1)+m>>1],t[k+w|0])+o|0)|0,k=k+2|0,n=n+2|0,(l|0)!=(n|0););if(n=I+(r<<1)|0,_&&(o=g(X[(k+s<<1)+m>>1],t[((h<<5)+k|0)+67712|0])+o|0),X[n>>1]=o+G>>N,r=r+1|0,(r|0)==(e|0))break}if(f=f+1|0,(f|0)==(e|0))break}v=m+2048|0}function DW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0;if(i4(A,i[e+8>>2],k)){i[e+28>>2]==1|i[e+4>>2]!=(r|0)||(i[e+28>>2]=f);return}i:{e:{if(i4(A,i[e>>2],k)){if(!(i[e+16>>2]!=(r|0)&i[e+20>>2]!=(r|0))){if((f|0)!=1)break i;i[e+32>>2]=1;return}if(i[e+32>>2]=f,i[e+44>>2]==4)break e;for(n=A+16|0,o=n+(i[A+12>>2]<<3)|0,f=0;;){r:{f:{A:{k:{if(n>>>0>=o>>>0||(X[e+52>>1]=0,$5(n,e,r,r,1,k),u[e+54|0]))break k;if(u[e+53|0]!=1)break r;if(u[e+52|0]==1){if(i[e+24>>2]==1||(f=1,l=1,!(u[A+8|0]&2)))break f;break r}if(f=1,t[A+8|0]&1)break r;A=3;break A}A=f?3:4}if(i[e+44>>2]=A,l)break i;break e}i[e+44>>2]=3;break i}n=n+8|0}}if(n=i[A+12>>2],o=A+16|0,rf(o,e,r,f,k),n>>>0<2)break i;if(o=o+(n<<3)|0,n=A+24|0,A=i[A+8>>2],!(!(A&2)&i[e+36>>2]!=1)){for(;;){if(u[e+54|0])break i;if(rf(n,e,r,f,k),n=n+8|0,!(o>>>0>n>>>0))break}break i}if(!(A&1))for(;;){if(u[e+54|0]|i[e+36>>2]==1)break i;if(rf(n,e,r,f,k),n=n+8|0,!(o>>>0>n>>>0))break i}for(;;){if(u[e+54|0]|i[e+36>>2]==1&i[e+24>>2]==1)break i;if(rf(n,e,r,f,k),n=n+8|0,!(o>>>0>n>>>0))break}break i}if(i[e+20>>2]=r,i[e+40>>2]=i[e+40>>2]+1,i[e+36>>2]!=1|i[e+24>>2]!=2)break i;t[e+54|0]=1}}function UW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;e=v-32|0,v=e,n=i[r+12>>2];i:{if((n|0)<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(i[r>>2]==1&i[r+4>>2]==3)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:{if(o=u[r+8|0],(o|0)!=1||(r=i[r+16>>2],!r|(r|0)==(n|0)))break e;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:switch(p[f+24>>1]-11|0){case 0:case 3:i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i;default:break e}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[e+20>>2]=0,r=i[f+4>>2],!((r|0)==3|(u[k+12|0]?i[k+4>>2]!=1:0))){i[e+16>>2]=n,t[e+12|0]=o,i[e+8>>2]=r,i[e+4>>2]=0,r=u[f+23|0]|u[f+24|0]<<8|(u[f+25|0]<<16|u[f+26|0]<<24),t[e+27|0]=r,t[e+28|0]=r>>>8,t[e+29|0]=r>>>16,t[e+30|0]=r>>>24,i[e+24>>2]=i[f+20>>2],i[e>>2]=11,l8(A,e+4|0,e);break i}t[e+12|0]=o,i[e+16>>2]=n,i[e+4>>2]=0,i[e+8>>2]=3,r=u[f+23|0]|u[f+24|0]<<8|(u[f+25|0]<<16|u[f+26|0]<<24),t[e+27|0]=r,t[e+28|0]=r>>>8,t[e+29|0]=r>>>16,t[e+30|0]=r>>>24,i[e+24>>2]=i[f+20>>2],r=C(32),i[r+24>>2]=i[e+28>>2],f=i[e+24>>2],i[r+16>>2]=i[e+20>>2],i[r+20>>2]=f,f=i[e+16>>2],i[r+8>>2]=i[e+12>>2],i[r+12>>2]=f,f=i[e+8>>2],i[r>>2]=i[e+4>>2],i[r+4>>2]=f,i[r+28>>2]=11,f=r+32|0,i[A+8>>2]=f,i[A>>2]=r,i[A+4>>2]=f}v=e+32|0}function MW(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0;h=v+-64|0,v=h,Io(h+44|0,e+6|0,r),t[h+63|0]<0&&Z(i[h+52>>2]),w=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[h+40>>2]=r,i[h+36>>2]=w,r=i[f>>2];i:{e:{r:{if(!u[e+4|0]){if(W[i[r+120>>2]](h+24|0,i[f+4>>2],h+36|0,n,o,l,k),n=i[h+24>>2],n){if(f=i[h+28>>2],k=i[h+32>>2],r=l2(k),r>>>0>=2147483640)break e;f:{A:{if(r>>>0>=11){o=r|7,e=C(o+1|0),i[h+20>>2]=o-2147483647,i[h+12>>2]=e,i[h+16>>2]=r;break A}if(t[h+23|0]=r,e=h+12|0,!r)break f}if(!r)break f;z(e,k,r)}if(t[e+r|0]=0,a(A,n,f,h+12|0),t[h+23|0]>=0)break r;Z(i[h+12>>2]);break r}t[e+4|0]=1,r=i[f>>2]}if(W[i[r+124>>2]](h+24|0,i[f+4>>2],h+36|0,s),n=i[h+24>>2],n){if(f=i[h+28>>2],k=i[h+32>>2],r=l2(k),r>>>0>=2147483640)break i;f:{A:{if(r>>>0>=11){o=r|7,e=C(o+1|0),i[h+20>>2]=o-2147483647,i[h+12>>2]=e,i[h+16>>2]=r;break A}if(t[h+23|0]=r,e=h+12|0,!r)break f}if(!r)break f;z(e,k,r)}if(t[e+r|0]=0,a(A,n,f,h+12|0),t[h+23|0]>=0)break r;Z(i[h+12>>2]);break r}t[e+68|0]=!i[k+24>>2],on(A,e,f)}A=i[h+40>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=h- -64|0;return}I0(),M()}I0(),M()}function HW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;k=v-32|0,v=k,XA(k+8|0,e,r,f);i:{if(i[k+8>>2]){e=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+24>>2],e=i[k+20>>2],i[A+8>>2]=i[k+16>>2],i[A+12>>2]=e,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}m=e,G=w2(r),X[m+120>>1]=G,m=e,G=w2(r),X[m+122>>1]=G;e:{if(i[e+112>>2]==i[e+108>>2])break e;r:{for(;;){f:{l=w2(r),w=w2(r),_=w2(r),f=i[e+128>>2],n=i[e+132>>2];A:{if(f>>>0<n>>>0){X[f+4>>1]=_,X[f+2>>1]=w,X[f>>1]=l,f=f+6|0;break A}if(s=i[e+124>>2],h=f-s|0,f=((h|0)/6|0)+1|0,f>>>0>=715827883)break f;if(n=(n-s|0)/6|0,o=n<<1,o=n>>>0>=357913941?715827882:f>>>0<o>>>0?o:f,o){if(o>>>0>=715827883)break r;f=C(g(o,6))}else f=0;if(n=f+h|0,X[n+4>>1]=_,X[n+2>>1]=w,X[n>>1]=l,l=n+g((h|0)/-6|0,6)|0,h&&z(l,s,h),i[e+132>>2]=f+g(o,6),f=n+6|0,i[e+128>>2]=f,i[e+124>>2]=l,!s)break A;Z(s)}if(i[e+128>>2]=f,B=B+1|0,B>>>0<i[e+112>>2]-i[e+108>>2]>>2>>>0)continue;break e}break}s0(),M()}x0(),M()}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}t[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function Fi(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;_=v-16|0,v=_;i:{e:{r:{if((r|0)<=36){if(o=u[A|0],o)break r;n=A;break e}i[33136]=28,f=0,k=0;break i}n=A;r:{for(;;){if(l=o<<24>>24,!((l|0)==32|l-9>>>0<5))break r;if(o=u[n+1|0],n=n+1|0,!o)break}break e}r:switch(l=o&255,l-43|0){case 0:case 2:break r;default:break e}h=(l|0)==45?-1:0,n=n+1|0}e:{if(!((r|16)!=16|u[n|0]!=48)){if(m=1,(u[n+1|0]&223)==88){n=n+2|0,B=16;break e}n=n+1|0,B=r||8;break e}B=r||10}for(r=0;;){e:{l=u[n|0],o=l-48|0;r:{if((o&255)>>>0<10)break r;if((l-97&255)>>>0<=25){o=l-87|0;break r}if((l-65&255)>>>0>25)break e;o=l-55|0}if(o=o&255,(o|0)>=(B|0))break e;e4(_,B,0,0,0,w,s,0,0),l=1;r:{if(i[_+8>>2]|i[_+12>>2]||(G=L0(w,s,B,0),I=h0,(I|0)==-1&(o^-1)>>>0<G>>>0))break r;s=I,w=o+G|0,s=w>>>0<o>>>0?s+1|0:s,m=1,l=r}n=n+1|0,r=l;continue}break}e&&(i[e>>2]=m?n:A);e:{r:{if(r){i[33136]=68,A=f&1,h=A?0:h,w=f,s=k;break r}if((k|0)==(s|0)&f>>>0>w>>>0|k>>>0>s>>>0)break e;A=f&1}if(!(A|h)){i[33136]=68,A=f,f=A-1|0,k=k-!A|0;break i}if((k|0)==(s|0)&f>>>0>=w>>>0|k>>>0>s>>>0)break e;i[33136]=68;break i}A=h^w,f=A-h|0,e=h>>31,k=(e^s)-((A>>>0<h>>>0)+e|0)|0}return v=_+16|0,h0=k,f}function zW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,33920,11),i[e+104>>2]-i[e+100>>2]|0),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function Qt(A,e){var r=0,f=0,k=0,n=0;k=v-16|0,v=k;i:{if(!i[A+40>>2])break i;r=C(152),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=98468,n=r+16|0,f=n,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,X[r+112>>1]=0,i[f>>2]=95600,i[r+32>>2]=1952541027,f=r+120|0,t[f+24|0]=0,i[f+16>>2]=0,i[f+20>>2]=2147483647,i[f+8>>2]=-1,i[f+12>>2]=-1,t[f|0]=1,K3(f,i[A+44>>2]),f=i[e>>2],i[k+12>>2]=r,i[k+8>>2]=n,i[r+4>>2]=i[r+4>>2]+1,P0(f+36|0,k+8|0),f=i[k+12>>2];e:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(f=i[r+4>>2],i[r+4>>2]=f-1,f)break i;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[e>>2],f=i[A+184>>2],A=i[e+4>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),i[k+12>>2]=A,i[k+8>>2]=r,P0(f+104|0,k+8|0),A=i[k+12>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=k+16|0}function xW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(f+8|0,34505,10),i[e+100>>2]),47864,15),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function G1(A,e){var r=0,f=0,k=0,n=0;k=(A|0)==(e|0),t[e+12|0]=k;i:{if(k)break i;for(;;){if(k=i[e+8>>2],u[k+12|0])break i;e:{r=i[k+8>>2],f=i[r>>2];r:{if((k|0)==(f|0)){if(n=i[r+4>>2],!(!n|u[n+12|0])){t[k+12|0]=1,t[r+12|0]=(A|0)==(r|0),t[n+12|0]=1;break r}f:{if(i[k>>2]==(e|0)){e=k;break f}e=i[k+4>>2],A=i[e>>2],i[k+4>>2]=A;A:{if(!A){i[e+8>>2]=r,i[r>>2]=e;break A}if(i[A+8>>2]=k,f=i[k+8>>2],A=i[f>>2],i[e+8>>2]=f,(A|0)==(k|0)){i[f>>2]=e;break A}i[f+4>>2]=e}i[e>>2]=k,i[k+8>>2]=e,r=i[e+8>>2],f=i[r>>2]}t[e+12|0]=1,t[r+12|0]=0,A=i[f+4>>2],i[r>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[f+8>>2]=A;f:{if(i[A>>2]==(r|0)){i[A>>2]=f;break f}i[A+4>>2]=f}i[f+4>>2]=r,i[r+8>>2]=f;return}if(u[f+12|0]|!f)break e;t[k+12|0]=1,t[r+12|0]=(A|0)==(r|0),t[f+12|0]=1}if(e=r,(A|0)!=(r|0))continue;break i}break}f=i[k>>2];e:{if((f|0)!=(e|0)){f=k;break e}A=i[f+4>>2],i[k>>2]=A,A&&(i[A+8>>2]=k,r=i[k+8>>2]),i[f+8>>2]=r;r:{if((k|0)==i[r>>2]){i[r>>2]=f;break r}i[r+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,r=i[f+8>>2]}t[f+12|0]=1,t[r+12|0]=0,e=i[r+4>>2],A=i[e>>2],i[r+4>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[e+8>>2]=A;e:{if(i[A>>2]==(r|0)){i[A>>2]=e;break e}i[A+4>>2]=e}i[e>>2]=r,i[r+8>>2]=e}}function TW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,37541,9),i[e+104>>2]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function jW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;k=v-32|0,v=k,S2(k,e,r),t[k+19|0]<0&&Z(i[k+8>>2]);i:{e:{r:{if(u[e+97|0]){B1(A,e,8688);break r}if(w=F0(r),D4(A,e+116|0,w<<2,f,14948),i[A>>2])break r;t[A+19|0]<0&&Z(i[A+8>>2]);f:{if(w){for(;;){s=F0(r),f=i[e+108>>2],n=i[e+112>>2];A:{if(f>>>0<n>>>0){i[f>>2]=s,f=f+4|0;break A}if(h=i[e+104>>2],f=f-h|0,_=f>>2,o=_+1|0,o>>>0>=1073741824)break e;if(n=n-h|0,l=n>>1,n=n>>>0>=2147483644?1073741823:o>>>0<l>>>0?l:o,n){if(n>>>0>=1073741824)break i;o=C(n<<2)}else o=0;if(l=o+f|0,i[l>>2]=s,s=l-(_<<2)|0,f&&z(s,h,f),i[e+112>>2]=o+(n<<2),f=l+4|0,i[e+108>>2]=f,i[e+104>>2]=s,!h)break A;Z(h)}if(i[e+108>>2]=f,u[r+20|0]!=1){if(B=B+1|0,(B|0)==(w|0))break f;continue}break}if(t[k+20|0]=0,t[k+31|0]=0,a(A,2,100,k+20|0),t[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(!(t[r+20|0]&1))break f;if(t[k+20|0]=0,t[k+31|0]=0,a(A,2,100,k+20|0),t[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break r}T(A,i[28730],i[28731])}v=k+32|0;return}s0(),M()}x0(),M()}function SW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(f+8|0,34715,16),u[e+104|0]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function OW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;k=v-32|0,v=k,S2(k,e,r),t[k+19|0]<0&&Z(i[k+8>>2]);i:{e:{r:{if(u[e+97|0]){B1(A,e,5181);break r}if(w=F0(r),D4(A,e+116|0,w<<2,f,14886),i[A>>2])break r;t[A+19|0]<0&&Z(i[A+8>>2]);f:{if(w){for(;;){s=F0(r),f=i[e+108>>2],n=i[e+112>>2];A:{if(f>>>0<n>>>0){i[f>>2]=s,f=f+4|0;break A}if(h=i[e+104>>2],f=f-h|0,_=f>>2,o=_+1|0,o>>>0>=1073741824)break e;if(n=n-h|0,l=n>>1,n=n>>>0>=2147483644?1073741823:o>>>0<l>>>0?l:o,n){if(n>>>0>=1073741824)break i;o=C(n<<2)}else o=0;if(l=o+f|0,i[l>>2]=s,s=l-(_<<2)|0,f&&z(s,h,f),i[e+112>>2]=o+(n<<2),f=l+4|0,i[e+108>>2]=f,i[e+104>>2]=s,!h)break A;Z(h)}if(i[e+108>>2]=f,u[r+20|0]!=1){if(B=B+1|0,(B|0)==(w|0))break f;continue}break}if(t[k+20|0]=0,t[k+31|0]=0,a(A,2,100,k+20|0),t[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(!(t[r+20|0]&1))break f;if(t[k+20|0]=0,t[k+31|0]=0,a(A,2,100,k+20|0),t[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break r}T(A,i[28730],i[28731])}v=k+32|0;return}s0(),M()}x0(),M()}function PW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,36974,10),p[e+98>>1]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function LW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,J2(n,e,r),s=k,l=n,k=t[f+159|0],n=(k|0)<0,F(s,n?i[f+148>>2]:l,n?i[f+152>>2]:k),t[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,k0(k,r),l=k,r=t[f+159|0],k=(r|0)<0,F(f+8|0,k?i[f+148>>2]:l,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(D0(F(f+8|0,33097,10),u[e+97|0]),47878,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function F(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;l=v-16|0,v=l,_=X1(l+4|0,A);i:{if(u[_|0]!=1)break i;s=e+r|0,k=i[i[A>>2]-12>>2]+A|0,h=(i[k+4>>2]&176)==32?s:e,o=i[k+24>>2];e:{if(u[k+80|0]==1){r=u[k+76|0]|u[k+77|0]<<8|(u[k+78|0]<<16|u[k+79|0]<<24);break e}f=l+12|0,r=i[k+28>>2],i[f>>2]=r,(r|0)!=136824&&(i[r+4>>2]=i[r+4>>2]+1),r=$0(f,137008),r=W[i[i[r>>2]+28>>2]](r,32)|0,i2(f),t[k+76|0]=r,t[k+77|0]=r>>>8,t[k+78|0]=r>>>16,t[k+79|0]=r>>>24,t[k+80|0]=1}B=r<<24>>24,r=0,f=v-16|0,v=f;e:{r:{f:{if(!o||(n=i[k+12>>2],w=h-e|0,(w|0)>0&&(W[i[i[o>>2]+48>>2]](o,e,w)|0)!=(w|0)))break f;if(e=s-e|0,e=(e|0)<(n|0)?n-e|0:0,(e|0)>0){if(e>>>0>=2147483640)break r;A:{if(e>>>0>=11){r=e|7,n=C(r+1|0),i[f+12>>2]=r-2147483647,i[f+4>>2]=n,i[f+8>>2]=e;break A}t[f+15|0]=e,n=f+4|0}if(e&&l0(n,B,e),r=0,t[e+n|0]=0,n=W[i[i[o>>2]+48>>2]](o,t[f+15|0]<0?i[f+4>>2]:f+4|0,e)|0,t[f+15|0]<0&&Z(i[f+4>>2]),(e|0)!=(n|0))break f}A:{if(e=s-h|0,(e|0)<=0||(W[i[i[o>>2]+48>>2]](o,h,e)|0)==(e|0))break A;break f}i[k+12>>2]=0,r=o}v=f+16|0;break e}I0(),M()}if(r)break i;e=i[i[A>>2]-12>>2]+A|0,M1(e,i[e+16>>2]|5)}return v1(_),v=l+16|0,A}function HA(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r)for(;;){e:{r:{if(s=l+2|0,s>>>0>=r>>>0||(k=e+l|0,u[k|0]|u[k+1|0]|u[e+s|0]!=3))break r;n=i[A+8>>2];f:{if(n>>>0>f>>>0){t[f|0]=0,f=f+1|0;break f}if(o=i[A>>2],l=f-o|0,k=l+1|0,(k|0)<0)break i;if(f=n-o|0,n=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<n>>>0?n:k,f?k=C(f):k=0,n=k+l|0,t[n|0]=0,l&&z(k,o,l),i[A+8>>2]=f+k,f=n+1|0,i[A+4>>2]=f,i[A>>2]=k,!o)break f;Z(o)}if(i[A+4>>2]=f,n=i[A+8>>2],n>>>0>f>>>0){t[f|0]=0,f=f+1|0;break e}if(o=i[A>>2],l=f-o|0,k=l+1|0,(k|0)<0)break i;if(f=n-o|0,n=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<n>>>0?n:k,f?k=C(f):k=0,n=k+l|0,t[n|0]=0,l&&z(k,o,l),i[A+8>>2]=f+k,f=n+1|0,i[A+4>>2]=f,i[A>>2]=k,!o)break e;Z(o);break e}n=e+l|0,h=i[A+8>>2];r:{if(h>>>0>f>>>0){t[f|0]=u[n|0],f=f+1|0;break r}if(o=i[A>>2],s=f-o|0,k=s+1|0,(k|0)<0)break i;if(f=h-o|0,h=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<h>>>0?h:k,f?k=C(f):k=0,h=k+s|0,t[h|0]=u[n|0],s&&z(k,o,s),i[A+8>>2]=f+k,f=h+1|0,i[A+4>>2]=f,i[A>>2]=k,!o)break r;Z(o)}s=l}if(i[A+4>>2]=f,l=s+1|0,!(l>>>0<r>>>0))break}return}s0(),M()}function Vt(A,e,r){var f=0,k=0,n=0,o=0,l=D(0),s=D(0),h=D(0),w=D(0),_=D(0),B=D(0),m=D(0),G=D(0);f=v-16|0,v=f,i[r>>2]=0,k=Af();i:{if(!k){if(t[f+4|0]=0,t[f+15|0]=0,a(A,6,0,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(t[k|0]=1,n=f+4|0,B5(n,k,p[e>>1]),o=i[f+4>>2],o){if(e=i[f+8>>2],a2(k),t[f+4|0]=0,t[f+15|0]=0,a(A,o,e,n),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(n=f+4|0,v5(n,k,p[e+2>>1]),o=i[f+4>>2],o){if(e=i[f+8>>2],a2(k),t[f+4|0]=0,t[f+15|0]=0,a(A,o,e,n),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(n=f+4|0,w5(n,k,p[e+4>>1]),o=i[f+4>>2],o){if(e=i[f+8>>2],a2(k),t[f+4|0]=0,t[f+15|0]=0,a(A,o,e,n),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(t[k+16|0]=u[e+6|0],e=p[k+4>>1]-1|0,(e&65535)>>>0<=21&&(e=e<<2&262140,l=E0[e+56144>>2],s=E0[e+55792>>2],h=E0[e+55704>>2],w=E0[e+55616>>2],_=E0[e+55528>>2],B=E0[e+56056>>2],m=E0[e+55968>>2],G=E0[e+55880>>2]),E0[k+48>>2]=l,E0[k+44>>2]=B,E0[k+40>>2]=s,E0[k+36>>2]=h,E0[k+32>>2]=w,E0[k+28>>2]=_,E0[k+24>>2]=m,E0[k+20>>2]=G,i[r>>2]=k,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function B1(A,e,r){var f=0,k=0,n=0,o=0,l=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=78164,i[f+20>>2]=78144,n=i[19545],i[f+12>>2]=n,k=i[n-12>>2],n=f+12|0,i[k+n>>2]=i[19546],i[f+16>>2]=0,k=n+i[i[f+12>>2]-12>>2]|0,o=f+24|0,J0(k,o),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[f+20>>2]=k,l=f+20|0,i[l+i[k-12>>2]>>2]=i[19548],k=i[19544],i[f+12>>2]=k,i[n+i[k-12>>2]>>2]=i[19549],i[f+76>>2]=78164,i[f+12>>2]=78124,i[f+20>>2]=78144,n=R0(o),i[n>>2]=77200,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=24,F(D0(F(F(l,r,l2(r)),31504,18),u[e+97|0]),4559,23),e=i[f+72>>2];i:{e:{if(e&16){e=i[f+68>>2],r=i[f+48>>2],e>>>0<r>>>0&&(i[f+68>>2]=r,e=r),r=f+44|0;break e}if(!(e&8)){e=0,t[f+11|0]=0,r=f;break i}e=i[f+40>>2],r=f+32|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){o=e|7,r=C(o+1|0),i[f+8>>2]=o-2147483647,i[f>>2]=r,i[f+4>>2]=e;break e}if(t[f+11|0]=e,r=f,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(r,k,e)}t[e+r|0]=0,a(A,4,3002,f),t[f+11|0]<0&&Z(i[f>>2]),A=i[19543],i[f+12>>2]=A,i[i[A-12>>2]+(f+12|0)>>2]=i[19551],i[f+20>>2]=i[19552],i[n>>2]=77200,t[f+67|0]<0&&Z(i[f+56>>2]),y0(n),Y0(f+76|0),v=f+160|0}function qW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;n=v-32|0,v=n;i:{e:{r:{if(!(i[e+104>>2]-i[e+100>>2]&255)){if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]<0)break r;e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}if(h=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,(i[e+116>>2]-i[e+112>>2]|0)/12&255),h2(r,i[e+104>>2]-i[e+100>>2]&255),f=i[e+100>>2],k=i[e+104>>2],(f|0)!=(k|0))for(;h2(r,u[f|0]),f=f+1|0,(k|0)!=(f|0););if(k=i[e+112>>2],s=i[e+116>>2],(k|0)==(s|0))break e;for(;;){if(i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,f=i[k+4>>2],o=i[k>>2],(f|0)!=(o|0)){f:{if(f=f-o|0,(f|0)>=0){for(l=C(f),f&&z(l,o,f),f=f>>>1|0,w=f>>>0<=1?1:f,f=0;;){o=p[(f<<1)+l>>1];A:{if(u[i[e+100>>2]+f|0]<=8){h2(r,o&255);break A}u2(r,o)}if(f=f+1|0,(w|0)==(f|0))break}break f}s0(),M()}Z(l)}if(k=k+12|0,(s|0)==(k|0))break}break e}T(A,i[28730],i[28731]);break i}if(n1(n,e,r,h),t[n+19|0]<0&&Z(i[n+8>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+32|0}function k0(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;r=v-160|0,v=r,i[r+104>>2]=0,i[r+76>>2]=78164,i[r+20>>2]=78144,n=i[19545],i[r+12>>2]=n,k=i[n-12>>2],n=r+12|0,i[k+n>>2]=i[19546],i[r+16>>2]=0,k=n+i[i[r+12>>2]-12>>2]|0,o=r+24|0,J0(k,o),t[k+80|0]=0,i[k+72>>2]=0,k=i[19547],i[r+20>>2]=k,l=r+20|0,i[l+i[k-12>>2]>>2]=i[19548],k=i[19544],i[r+12>>2]=k,i[n+i[k-12>>2]>>2]=i[19549],i[r+76>>2]=78164,i[r+12>>2]=78124,i[r+20>>2]=78144,n=R0(o),i[n>>2]=77200,k=r- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+72>>2]=24;i:{e:{r:{if(i[e>>2]>0){for(;F(l,30857,2),f=f+1|0,(f|0)<i[e>>2];);if(e=i[r+72>>2],!(e&16))break r}f=i[r+68>>2],e=i[r+48>>2],f>>>0<e>>>0&&(i[r+68>>2]=e,f=e),e=r+44|0;break e}if(!(e&8)){f=0,t[A+11|0]=0;break i}f=i[r+40>>2],e=r+32|0}e:{if(k=i[e>>2],f=f-k|0,f>>>0<2147483640){if(f>>>0>=11){o=f|7,e=C(o+1|0),i[A+8>>2]=o-2147483647,i[A>>2]=e,i[A+4>>2]=f,A=e;break e}if(t[A+11|0]=f,f)break e;f=0;break i}I0(),M()}if(!f)break i;z(A,k,f)}t[A+f|0]=0,A=i[19543],i[r+12>>2]=A,i[i[A-12>>2]+(r+12|0)>>2]=i[19551],i[r+20>>2]=i[19552],i[n>>2]=77200,t[r+67|0]<0&&Z(i[r+56>>2]),y0(n),Y0(r+76|0),v=r+160|0}function aW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(k=v-16|0,v=k,e=C(168),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=97908,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,t[e+112|0]=0,X[e+118>>1]=0,X[e+120>>1]=0,X[e+122>>1]=0,X[e+124>>1]=0,X[e+116>>1]=1,X[e+126>>1]=0,X[e+128>>1]=0,X[e+130>>1]=0,X[e+132>>1]=0,X[e+134>>1]=0,i[e+160>>2]=-65512,i[e+152>>2]=0,i[e+156>>2]=0,X[e+144>>1]=1,i[e+136>>2]=4718592,i[e+140>>2]=4718592,i[f>>2]=97948,t[e+159|0]=4,i[e+32>>2]=1835692135,t[e+148|0]=74,t[e+149|0]=80,t[e+150|0]=69,t[e+151|0]=71,n=i[r>>2],l=i[r+4>>2],(n|0)!=(l|0))for(s=e+52|0;;){o=i[n>>2],i[k+8>>2]=o,r=i[n+4>>2],i[k+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),i[o+16>>2]==1785751363&&P0(s,k+8|0),r=i[k+12>>2];i:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(n=n+8|0,(l|0)==(n|0))break}i[A+4>>2]=e,i[A>>2]=f,v=k+16|0}function zA(A,e,r,f,k,n,o,l,s,h,w,_){var B=0;B=v-16|0,v=B,i[B+12>>2]=A;i:{e:{if((A|0)==(n|0)){if(u[e|0]!=1)break e;if(A=0,t[e|0]=0,e=i[k>>2],i[k>>2]=e+1,t[e|0]=46,u[l+11|0]>>>7|0?e=i[l+4>>2]:e=u[l+11|0]&127,!e||(e=i[h>>2],(e-s|0)>159))break i;r=i[w>>2],i[h>>2]=e+4,i[e>>2]=r;break i}r:{if(u[l+11|0]>>>7|0?n=i[l+4>>2]:n=u[l+11|0]&127,!(!n|(A|0)!=(o|0))){if(u[e|0]!=1)break e;if(A=i[h>>2],(A-s|0)>159)break r;e=i[w>>2],i[h>>2]=A+4,i[A>>2]=e,A=0,i[w>>2]=0;break i}if(A=u7(_,_+112|0,B+12|0)-_|0,o=A>>2,(o|0)>27)break e;n=t[o+83888|0];f:{A:{if(A=A&-5,(A|0)!=88){if((A|0)!=96)break A;if(e=i[k>>2],(e|0)!=(f|0)&&(A=-1,f=t[e-1|0],r=t[r|0],((f-97>>>0<26?f&95:f)|0)!=((r-97>>>0<26?r&95:r)|0)))break i;i[k>>2]=e+1,t[e|0]=n;break r}t[r|0]=80;break f}if(A=n-97>>>0<26?n&95:n,(A|0)!=t[r|0]||(t[r|0]=A-65>>>0<26?A|32:A,u[e|0]!=1)||(t[e|0]=0,u[l+11|0]>>>7|0?A=i[l+4>>2]:A=u[l+11|0]&127,!A)||(A=i[h>>2],(A-s|0)>159))break f;e=i[w>>2],i[h>>2]=A+4,i[A>>2]=e}if(A=i[k>>2],i[k>>2]=A+1,t[A|0]=n,A=0,(o|0)>21)break i;i[w>>2]=i[w>>2]+1;break i}A=0;break i}A=-1}return v=B+16|0,A}function xA(A,e,r,f,k,n,o,l,s,h,w,_){var B=0;B=v-16|0,v=B,t[B+15|0]=A;i:{e:{if((A|0)==(n|0)){if(u[e|0]!=1)break e;if(A=0,t[e|0]=0,e=i[k>>2],i[k>>2]=e+1,t[e|0]=46,u[l+11|0]>>>7|0?e=i[l+4>>2]:e=u[l+11|0]&127,!e||(e=i[h>>2],(e-s|0)>159))break i;r=i[w>>2],i[h>>2]=e+4,i[e>>2]=r;break i}r:{if(u[l+11|0]>>>7|0?n=i[l+4>>2]:n=u[l+11|0]&127,!(!n|(A|0)!=(o|0))){if(u[e|0]!=1)break e;if(A=i[h>>2],(A-s|0)>159)break r;e=i[w>>2],i[h>>2]=A+4,i[A>>2]=e,A=0,i[w>>2]=0;break i}if(o=s7(_,_+28|0,B+15|0)-_|0,(o|0)>27)break e;n=t[o+83888|0];f:{A:switch((o&-2)-22|0){case 2:if(e=i[k>>2],(e|0)!=(f|0)&&(A=-1,f=t[e-1|0],r=t[r|0],((f-97>>>0<26?f&95:f)|0)!=((r-97>>>0<26?r&95:r)|0)))break i;i[k>>2]=e+1,t[e|0]=n;break r;case 0:t[r|0]=80;break f;default:break A}if(A=n-97>>>0<26?n&95:n,(A|0)!=t[r|0]||(t[r|0]=A-65>>>0<26?A|32:A,u[e|0]!=1)||(t[e|0]=0,u[l+11|0]>>>7|0?A=i[l+4>>2]:A=u[l+11|0]&127,!A)||(A=i[h>>2],(A-s|0)>159))break f;e=i[w>>2],i[h>>2]=A+4,i[A>>2]=e}if(A=i[k>>2],i[k>>2]=A+1,t[A|0]=n,A=0,(o|0)>21)break i;i[w>>2]=i[w>>2]+1;break i}A=0;break i}A=-1}return v=B+16|0,A}function a6(A,e,r,f,k,n,o){var l=0,s=0,h=0;i:{e:{s=i[A+248>>2],l=e>>s;r:{if((l|0)<0||(h=i[A+252>>2],(h|0)<=(l|0)))break r;if(s=r>>s,(s|0)<0|(s|0)>=i[A+256>>2])break e;if(!(u[(l+i[A+240>>2]|0)+g(s,h)|0]>>>k&1)){l=f,f=e;break i}if(l=f-1|0,s=k+1|0,a6(A,e,r,l,s,n,o),k=1<<f>>1,f=k+e|0,a6(A,f,r,l,s,16,o),r=r+k|0,a6(A,e,r,l,s,n,32),e=i[A+248>>2],k=f>>e,(k|0)<0)break r;for(e=r>>e;;){if(n=i[A+252>>2],(n|0)<=(k|0))break r;if((e|0)<0|i[A+256>>2]<=(e|0))break e;if(!(u[(i[A+240>>2]+k|0)+g(e,n)|0]>>>s&1)){n=16,o=32;break i}if(k=l-1|0,s=s+1|0,a6(A,f,r,k,s,16,32),e=1<<l>>1,n=e+f|0,a6(A,n,r,k,s,16,32),r=e+r|0,a6(A,f,r,k,s,16,32),o=i[A+248>>2],e=r>>o,l=k,f=n,k=n>>o,!((k|0)>=0))break}}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}if((l|0)!=31){for(e=1<<l,k=(f|0)/4|0,s=0;h=i[A+272>>2],l=(r+s|0)/4|0,(h|0)<=(k|0)|(l|0)>=i[A+276>>2]||(l=(k+i[A+260>>2]|0)+g(l,h)|0,t[l|0]=u[l|0]|n),s=s+4|0,(e|0)>(s|0););for(k=(r|0)/4|0,r=0;n=(r+f|0)/4|0,l=i[A+272>>2],(n|0)>=(l|0)|(k|0)>=i[A+276>>2]||(n=(n+i[A+260>>2]|0)+g(k,l)|0,t[n|0]=u[n|0]|o),r=r+4|0,(e|0)>(r|0););}}function pt(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;f=v-32|0,v=f;i:{if(u[A+52|0]==1){if(r=i[A+48>>2],!e)break i;t[A+52|0]=0,i[A+48>>2]=-1;break i}e:{if(u[A+53|0]==1){r=i[A+32>>2];r:{if(i[r+76>>2]<0){r=mo(r);break r}r=mo(r)}if((r|0)!=-1&&(i[f+24>>2]=r),(r|0)==-1)break e;r=i[f+24>>2];r:{if(!e){if(!Ql(r,i[A+32>>2]))break e;break r}i[A+48>>2]=r}r=i[f+24>>2];break i}for(i[f+24>>2]=1,k=v-16|0,v=k,v=k+16|0,k=A+44|0,n=f+24|0,k=i[(i[n>>2]<i[k>>2]?k:n)>>2],n=(k|0)>0?k:0;;){if((r|0)!=(n|0)){if(o=de(i[A+32>>2]),(o|0)==-1)break e;t[(f+24|0)+r|0]=o,r=r+1|0;continue}break}h=f+24|0;r:{for(;;){f:{n=i[A+40>>2],r=i[n>>2],w=i[n+4>>2],l=f+24|0,o=l+k|0;A:switch(s=i[A+36>>2],(W[i[i[s>>2]+16>>2]](s,n,l,o,f+16|0,f+20|0,h,f+12|0)|0)-1|0){case 1:break e;case 0:break A;case 2:break f;default:break r}if(n=i[A+40>>2],i[n>>2]=r,i[n+4>>2]=w,(k|0)==8||(r=de(i[A+32>>2]),(r|0)==-1))break e;t[o|0]=r,k=k+1|0;continue}break}i[f+20>>2]=t[f+24|0]}r:{if(!e)for(;;){if((k|0)<=0)break r;if(k=k-1|0,(Si(t[k+(f+24|0)|0],i[A+32>>2])|0)==-1)break e}i[A+48>>2]=i[f+20>>2]}r=i[f+20>>2];break i}r=-1}return v=f+32|0,r}function s3(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;m=v-16|0,v=m,w=$0(o,137e3),s=m+4|0,o=$0(o,137072),W[i[i[o>>2]+20>>2]](s,o),u[s+11|0]>>>7|0?l=i[s+4>>2]:l=u[s+11|0]&127;i:{if(!l){W[i[i[w>>2]+48>>2]](w,A,r,f)|0,o=(r-A<<2)+f|0,i[n>>2]=o;break i}i[n>>2]=f;e:{r:switch(s=A,l=u[s|0],l-43|0){case 0:case 2:break r;default:break e}s=W[i[i[w>>2]+44>>2]](w,l<<24>>24)|0,l=i[n>>2],i[n>>2]=l+4,i[l>>2]=s,s=A+1|0}for(u[s|0]!=48|(r-s|0)<2|(u[s+1|0]|32)!=120||(l=W[i[i[w>>2]+44>>2]](w,48)|0,h=i[n>>2],i[n>>2]=h+4,i[h>>2]=l,l=W[i[i[w>>2]+44>>2]](w,t[s+1|0])|0,h=i[n>>2],i[n>>2]=h+4,i[h>>2]=l,s=s+2|0),ti(s,r),G=W[i[i[o>>2]+16>>2]](o)|0,h=0,o=s;;){if(r>>>0<=o>>>0)T3((s-A<<2)+f|0,i[n>>2]),o=i[n>>2];else{l=m+4|0;e:{if(u[l+11|0]>>>7|0){_=i[l>>2];break e}_=l}I=!u[_+h|0],u[l+11|0]>>>7|0?_=i[l>>2]:_=l,I|t[_+h|0]!=(B|0)||(B=i[n>>2],i[n>>2]=B+4,i[B>>2]=G,u[l+11|0]>>>7|0?l=i[l+4>>2]:l=u[l+11|0]&127,h=(l-1>>>0>h>>>0)+h|0,B=0),l=W[i[i[w>>2]+44>>2]](w,t[o|0])|0,_=i[n>>2],i[n>>2]=_+4,i[_>>2]=l,o=o+1|0,B=B+1|0;continue}break}}i[k>>2]=(e|0)==(r|0)?o:(e-A<<2)+f|0,_2(m+4|0),v=m+16|0}function ye(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;i:{e:{if(l=i[A+4>>2],o=i[A>>2],s=l-o|0,r=((s|0)/40|0)+1|0,r>>>0<107374183){if(k=(i[A+8>>2]-o|0)/40|0,f=k<<1,f=k>>>0>=53687091?107374182:r>>>0<f>>>0?f:r,f>>>0>=107374183)break e;if(h=g(f,40),w=C(h),k=s+w|0,f=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=f,_=i[e+8>>2],n=i[e+12>>2],r=i[e+16>>2],f=i[e+20>>2],i[k+32>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+16>>2]=r,i[k+20>>2]=f,i[k+8>>2]=_,i[k+12>>2]=n,f=i[e+28>>2],r=i[e+24>>2],(f|0)!=(r|0)){if(n=f-r|0,(n|0)<0)break i;f=C(n),i[k+24>>2]=f,e=f+n|0,i[k+32>>2]=e,n&&z(f,r,n),i[k+28>>2]=e}if(f=k+g((s|0)/-40|0,40)|0,(o|0)!=(l|0)){for(r=o,e=f;n=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=n,n=i[r+20>>2],i[e+16>>2]=i[r+16>>2],i[e+20>>2]=n,n=i[r+12>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=n,i[e+24>>2]=i[r+24>>2],i[e+28>>2]=i[r+28>>2],i[e+32>>2]=i[r+32>>2],i[r+32>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,e=e+40|0,r=r+40|0,(l|0)!=(r|0););for(;e=i[o+24>>2],e&&(i[o+28>>2]=e,Z(e)),o=o+40|0,(l|0)!=(o|0););o=i[A>>2]}return i[A+8>>2]=h+w,e=k+40|0,i[A+4>>2]=e,i[A>>2]=f,o&&Z(o),e}s0(),M()}x0(),M()}s0(),M()}function KW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=i[e+184>>2],f=i[e+188>>2];i:{e:{if((r|0)!=(f|0))for(;;){r:{if(k=i[r>>2],!k||(k=Z0(k,92792,105228),!k))break r;if(r=i[r+4>>2],!r)break e;i[r+4>>2]=i[r+4>>2]+1;break i}if(r=r+8|0,(f|0)==(r|0))break}k=0}r=0}f=C(120),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=103800,r&&(i[r+4>>2]=i[r+4>>2]+1),n=f+16|0,i[f+72>>2]=0,i[f+64>>2]=0,i[f+68>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+80>>2]=0,i[f+84>>2]=0,i[f+92>>2]=r,i[f+88>>2]=k,t[f+32|0]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+16>>2]=105248;i:{if(!r){t[f+112|0]=0,t[f+96|0]=0;break i}if(i[r+4>>2]=i[r+4>>2]+1,t[f+112|0]=0,t[f+96|0]=0,k=i[r+4>>2],i[r+4>>2]=k-1,k)break i;W[i[i[r>>2]+8>>2]](r),y(r)}i[e+552>>2]=n,k=i[e+556>>2],i[e+556>>2]=f;i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}}function v8(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;if(r>>>0>=512)return r&&z(A,e,r),A|0;f=A+r|0;i:{if(!((A^e)&3)){e:{if(!(A&3)){r=A;break e}if(!r){r=A;break e}for(r=A;;){if(t[r|0]=u[e|0],e=e+1|0,r=r+1|0,!(r&3))break e;if(!(r>>>0<f>>>0))break}}k=f&-4;e:{if(f>>>0<64||(n=k+-64|0,n>>>0<r>>>0))break e;for(;i[r>>2]=i[e>>2],i[r+4>>2]=i[e+4>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=i[e+12>>2],i[r+16>>2]=i[e+16>>2],i[r+20>>2]=i[e+20>>2],i[r+24>>2]=i[e+24>>2],i[r+28>>2]=i[e+28>>2],i[r+32>>2]=i[e+32>>2],i[r+36>>2]=i[e+36>>2],i[r+40>>2]=i[e+40>>2],i[r+44>>2]=i[e+44>>2],i[r+48>>2]=i[e+48>>2],i[r+52>>2]=i[e+52>>2],i[r+56>>2]=i[e+56>>2],i[r+60>>2]=i[e+60>>2],e=e- -64|0,r=r- -64|0,n>>>0>=r>>>0;);}if(r>>>0>=k>>>0)break i;for(;i[r>>2]=i[e>>2],e=e+4|0,r=r+4|0,k>>>0>r>>>0;);break i}if(f>>>0<4){r=A;break i}if(k=f-4|0,k>>>0<A>>>0){r=A;break i}for(r=A;t[r|0]=u[e|0],t[r+1|0]=u[e+1|0],t[r+2|0]=u[e+2|0],t[r+3|0]=u[e+3|0],e=e+4|0,r=r+4|0,k>>>0>=r>>>0;);}if(r>>>0<f>>>0)for(;t[r|0]=u[e|0],e=e+1|0,r=r+1|0,(f|0)!=(r|0););return A|0}function h3(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;m=v-16|0,v=m,w=$0(o,137008),s=m+4|0,o=$0(o,137064),W[i[i[o>>2]+20>>2]](s,o),u[s+11|0]>>>7|0?l=i[s+4>>2]:l=u[s+11|0]&127;i:{if(!l){W[i[i[w>>2]+32>>2]](w,A,r,f)|0,o=(r-A|0)+f|0,i[n>>2]=o;break i}i[n>>2]=f;e:{r:switch(s=A,l=u[s|0],l-43|0){case 0:case 2:break r;default:break e}s=W[i[i[w>>2]+28>>2]](w,l<<24>>24)|0,l=i[n>>2],i[n>>2]=l+1,t[l|0]=s,s=A+1|0}for(u[s|0]!=48|(r-s|0)<2|(u[s+1|0]|32)!=120||(l=W[i[i[w>>2]+28>>2]](w,48)|0,h=i[n>>2],i[n>>2]=h+1,t[h|0]=l,l=W[i[i[w>>2]+28>>2]](w,t[s+1|0])|0,h=i[n>>2],i[n>>2]=h+1,t[h|0]=l,s=s+2|0),ti(s,r),G=W[i[i[o>>2]+16>>2]](o)|0,h=0,o=s;;){if(r>>>0<=o>>>0)ti((s-A|0)+f|0,i[n>>2]),o=i[n>>2];else{l=m+4|0;e:{if(u[l+11|0]>>>7|0){_=i[l>>2];break e}_=l}I=!u[_+h|0],u[l+11|0]>>>7|0?_=i[l>>2]:_=l,I|t[_+h|0]!=(B|0)||(B=i[n>>2],i[n>>2]=B+1,t[B|0]=G,u[l+11|0]>>>7|0?l=i[l+4>>2]:l=u[l+11|0]&127,h=(l-1>>>0>h>>>0)+h|0,B=0),l=W[i[i[w>>2]+28>>2]](w,t[o|0])|0,_=i[n>>2],i[n>>2]=_+1,t[_|0]=l,o=o+1|0,B=B+1|0;continue}break}}i[k>>2]=(e|0)==(r|0)?o:(e-A|0)+f|0,_2(m+4|0),v=m+16|0}function $W(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0;r=v-48|0,v=r,n=C(128),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=98748,o=no(n+16|0);i:{if(f=l2(e),f>>>0<2147483640){e:{r:{if(f>>>0>=11){l=f|7,k=C(l+1|0),i[r+44>>2]=l-2147483647,i[r+36>>2]=k,i[r+40>>2]=f;break r}if(t[r+47|0]=f,k=r+36|0,!f)break e}if(!f)break e;z(k,e,f)}t[f+k|0]=0,k=n+116|0,f=t[r+47|0];e:{r:{if(t[n+127|0]>=0){if((f|0)>=0){f=i[r+40>>2],i[k>>2]=i[r+36>>2],i[k+4>>2]=f,i[k+8>>2]=i[r+44>>2];break e}m1(k,i[r+36>>2],i[r+40>>2]);break r}if(l=k,k=(f|0)<0,R1(l,k?i[r+36>>2]:r+36|0,k?i[r+40>>2]:f),t[r+47|0]>=0)break e}Z(i[r+36>>2])}if(k=i[A+8>>2],f=i[i[A>>2]+196>>2],i[r+32>>2]=n,i[r+28>>2]=o,i[n+4>>2]=i[n+4>>2]+1,o=i[r+32>>2],i[r+8>>2]=i[r+28>>2],i[r+12>>2]=o,Ei(k,f,r+8|0,0),f=i[A>>2],A=l2(e),A>>>0>=2147483640)break i;e:{r:{if(A>>>0>=11){o=A|7,k=C(o+1|0),i[r+24>>2]=o-2147483647,i[r+16>>2]=k,i[r+20>>2]=A;break r}if(t[r+27|0]=A,k=r+16|0,!A)break e}if(!A)break e;z(k,e,A)}t[A+k|0]=0,W[i[i[f>>2]+36>>2]](f,r+16|0),t[r+27|0]<0&&Z(i[r+16>>2]),A=i[n+4>>2],i[n+4>>2]=A-1,A||(W[i[i[n>>2]+8>>2]](n),y(n)),v=r+48|0;return}I0(),M()}I0(),M()}function U4(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;l=v-16|0,v=l,n=i[A+108>>2],o=i[A+104>>2],s=n-o>>4;i:{if((o|0)==(n|0))break i;for(k=s>>>0<=1?1:s;;){if(i[o+(f<<4)>>2]==(e|0))break i;if(f=f+1|0,(k|0)==(f|0))break}f=k}if((f|0)==(s|0)){o=A+104|0,i[l+12>>2]=0,i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=e;i:{if(n>>>0<o0[A+112>>2]){i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=e,i[A+108>>2]=n+16;break i}if(k=B3(o,l),e=i[l+4>>2],i[A+108>>2]=k,!e)break i;i[l+8>>2]=e,Z(e)}o=i[o>>2]}i:{e:{o=(f<<4)+o|0,A=i[o+4>>2],e=i[o+8>>2];r:{if((A|0)!=(e|0))for(k=p[r+2>>1],f=A;;){if((k|0)==p[f+2>>1])break r;if(f=f+4|0,(e|0)==(f|0))break}k=i[o+12>>2];f:{if(k>>>0>e>>>0){A=p[r>>1]|p[r+2>>1]<<16,X[e>>1]=A,X[e+2>>1]=A>>>16,r=e+4|0;break f}if(e=e-A|0,s=e>>2,f=s+1|0,f>>>0>=1073741824)break e;if(k=k-A|0,n=k>>1,k=k>>>0>=2147483644?1073741823:f>>>0<n>>>0?n:f,k){if(k>>>0>=1073741824)break i;f=C(k<<2)}else f=0;if(n=f+e|0,r=p[r>>1]|p[r+2>>1]<<16,X[n>>1]=r,X[n+2>>1]=r>>>16,s=n-(s<<2)|0,e&&z(s,A,e),i[o+12>>2]=f+(k<<2),r=n+4|0,i[o+8>>2]=r,i[o+4>>2]=s,!A)break f;Z(A)}i[o+8>>2]=r}v=l+16|0;return}s0(),M()}x0(),M()}function dW(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0;h=v-16|0,v=h,s=C(36),i[s+32>>2]=o,i[s+28>>2]=n,i[s+24>>2]=k,i[s+20>>2]=f,i[s+16>>2]=r,i[s+12>>2]=102336,i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=102628,r=i[e+8>>2],i[h+12>>2]=s,f=s+12|0,i[h+8>>2]=f,i[s+4>>2]=i[s+4>>2]+1,P0(r+12|0,h+8|0),r=i[h+12>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!l||(i[s+4>>2]=i[s+4>>2]+1,r=C(24),i[s+4>>2]=i[s+4>>2]+1,i[r+20>>2]=s,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,k=i[e>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+4>>2]=f,i[r>>2]=k,i[l>>2]=r,r=i[s+4>>2],i[s+4>>2]=r-1,r))break i;W[i[i[s>>2]+8>>2]](s),y(s)}f=i[e>>2],r=i[e+4>>2];i:{if(r){if(i[r+4>>2]=i[r+4>>2]+1,qu(f,i[i[e+8>>2]>>2],o),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,A=i[r+4>>2],i[r+4>>2]=A-1,A)break i;W[i[i[r>>2]+8>>2]](r),y(r);break i}qu(f,i[i[e+8>>2]>>2],o),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}A=i[s+4>>2],i[s+4>>2]=A-1,A||(W[i[i[s>>2]+8>>2]](s),y(s)),v=h+16|0}function Ft(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0;i:{e:{if((f|0)<=0)break e;if(o=i[A+8>>2],l=i[A+4>>2],(o-l|0)>=(f|0)){r:{if((f|0)<=(l|0)){o=e+f|0,n=l;break r}o=e+l|0;f:{if((o|0)==(r|0)){n=l;break f}for(k=o,n=l;t[n|0]=u[k|0],n=n+1|0,k=k+1|0,(k|0)!=(r|0););}if(i[A+4>>2]=n,(l|0)<=0)break e}s=f,k=n,r=k-f|0;r:{if(l>>>0<=r>>>0)break r;if(h=f+l|0,w=h-k&7,w)for(f=0;t[k|0]=u[r|0],k=k+1|0,r=r+1|0,f=f+1|0,(w|0)!=(f|0););if(n-h>>>0>=4294967289)break r;for(;t[k|0]=u[r|0],t[k+1|0]=u[r+1|0],t[k+2|0]=u[r+2|0],t[k+3|0]=u[r+3|0],t[k+4|0]=u[r+4|0],t[k+5|0]=u[r+5|0],t[k+6|0]=u[r+6|0],t[k+7|0]=u[r+7|0],k=k+8|0,r=r+8|0,(l|0)!=(r|0););}i[A+4>>2]=k;r:{if((n|0)==(s|0)||(A=n-s|0,!A))break r;z(n-A|0,0,A)}if((e|0)==(o|0)||(A=o-e|0,!A))break e;z(0,e,A);return}if(n=i[A>>2],r=(l-n|0)+f|0,(r|0)<0)break i;k=0-n|0,o=o-n|0,s=o<<1,o=o>>>0>=1073741823?2147483647:r>>>0<s>>>0?s:r,o?r=C(o):r=0,s=k+r|0,f&&z(s,e,f),e=f+s|0,l&&z(e,0,l),i[A+4>>2]=0,k&&z(r,n,k),i[A+8>>2]=r+o,i[A+4>>2]=e+l,i[A>>2]=r,n&&Z(n)}return}s0(),M()}function bW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+184>>2],f=i[e+188>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=Z0(k,92792,104760),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=C(96),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=103640,f&&(i[f+4>>2]=i[f+4>>2]+1),o=r+16|0,i[r+72>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+92>>2]=f,i[r+88>>2]=k,t[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+16>>2]=104632,!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),i[e+552>>2]=o,k=i[e+556>>2],i[e+556>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]<0)break r;e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}if(r=r+8|0,(f|0)==(r|0))break}if(t[n+4|0]=0,t[n+15|0]=0,a(A,2,131,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[28730],i[28731])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function cW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+184>>2],f=i[e+188>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=Z0(k,92792,106984),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=C(96),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=103680,f&&(i[f+4>>2]=i[f+4>>2]+1),o=r+16|0,i[r+72>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+92>>2]=f,i[r+88>>2]=k,t[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+16>>2]=107004,!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),i[e+552>>2]=o,k=i[e+556>>2],i[e+556>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]<0)break r;e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}if(r=r+8|0,(f|0)==(r|0))break}if(t[n+4|0]=0,t[n+15|0]=0,a(A,2,131,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[28730],i[28731])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function iX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+184>>2],f=i[e+188>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=Z0(k,92792,104128),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=C(96),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=103600,f&&(i[f+4>>2]=i[f+4>>2]+1),o=r+16|0,i[r+72>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+92>>2]=f,i[r+88>>2]=k,t[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+16>>2]=104216,!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),i[e+552>>2]=o,k=i[e+556>>2],i[e+556>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]<0)break r;e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}if(r=r+8|0,(f|0)==(r|0))break}if(t[n+4|0]=0,t[n+15|0]=0,a(A,2,106,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[28730],i[28731])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function eX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+184>>2],f=i[e+188>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=Z0(k,92792,106644),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=C(96),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=103760,f&&(i[f+4>>2]=i[f+4>>2]+1),o=r+16|0,i[r+72>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+92>>2]=f,i[r+88>>2]=k,t[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+16>>2]=106444,!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),i[e+552>>2]=o,k=i[e+556>>2],i[e+556>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]<0)break r;e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}if(r=r+8|0,(f|0)==(r|0))break}if(t[n+4|0]=0,t[n+15|0]=0,a(A,2,131,n+4|0),t[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[28730],i[28731])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function rX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;if(k=v+-64|0,v=k,ho(k+48|0,i[A+8>>2]),l=i[k+48>>2],B=i[k+52>>2],(l|0)!=(B|0)){for(G=i[25812],I=i[25813];;){i:{e:{if(o=i[l>>2],(o|0)==i[i[A>>2]+24>>2])break e;if(RA(k+24|0,i[A+8>>2],o),o=3,n=u[k+44|0],!n){if(s=i[k+28>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=i[k+24>>2],o=i[_+248>>2],h=i[_+252>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),o){m5(k+8|0,o,e),m=i[k+12>>2],n=i[k+8>>2];r:{if((m|0)==(n|0)|f>>>0<=w>>>0)break r;for(Q=i[i[A>>2]+24>>2],o=n;;){if(i[o>>2]!=(Q|0)){if(o=o+4|0,(m|0)!=(o|0))continue;break r}break}i[(w<<2)+r>>2]=i[_+24>>2],w=w+1|0}n&&(i[k+12>>2]=n,Z(n)),o=(f|0)==(w|0)?2:0}else o=3;r:{if(!h||(n=i[h+4>>2],i[h+4>>2]=n-1,n))break r;W[i[i[h>>2]+8>>2]](h),y(h)}r:{if(!s||(n=i[s+4>>2],i[s+4>>2]=n-1,n))break r;W[i[i[s>>2]+8>>2]](s),y(s)}n=u[k+44|0]}switch((n|0)!=255&&(i[k+8>>2]=G,i[k+12>>2]=I,W[i[(k+8|0)+(n<<2)>>2]](k+63|0,k+24|0)),o|0){case 0:case 3:break e;default:break i}}if(l=l+4|0,(B|0)!=(l|0))continue}break}l=i[k+48>>2]}return l&&(i[k+52>>2]=l,Z(l)),v=k- -64|0,w|0}function fX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=78468,k=i[19620],i[f+20>>2]=k,l=i[k-12>>2],k=f+20|0,i[l+k>>2]=i[19621],o=k+i[i[f+20>>2]-12>>2]|0,n=f+24|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+76>>2]=78468,i[f+20>>2]=78448,o=R0(n),i[o>>2]=77200,n=f- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,n=f+8|0,J2(n,e,r),s=k,l=n,k=t[f+19|0],n=(k|0)<0,F(s,n?i[f+8>>2]:l,n?i[f+12>>2]:k),t[f+19|0]<0&&Z(i[f+8>>2]),k=f+8|0,A3(k,e,r,1),e=t[f+19|0],r=(e|0)<0,F(f+20|0,r?i[f+8>>2]:k,r?i[f+12>>2]:e),t[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){r=i[f+68>>2],e=i[f+48>>2],r>>>0<e>>>0&&(i[f+68>>2]=e,r=e),e=f+44|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+40>>2],e=f+32|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[19622],i[o>>2]=77200,t[f+67|0]<0&&Z(i[f+56>>2]),y0(o),Y0(f+76|0),v=f+160|0}function X6(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=78468,k=i[19620],i[f+20>>2]=k,l=i[k-12>>2],k=f+20|0,i[l+k>>2]=i[19621],o=k+i[i[f+20>>2]-12>>2]|0,n=f+24|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+76>>2]=78468,i[f+20>>2]=78448,o=R0(n),i[o>>2]=77200,n=f- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,n=f+8|0,J2(n,e,r),s=k,l=n,k=t[f+19|0],n=(k|0)<0,F(s,n?i[f+8>>2]:l,n?i[f+12>>2]:k),t[f+19|0]<0&&Z(i[f+8>>2]),k=f+8|0,A3(k,e,r,0),e=t[f+19|0],r=(e|0)<0,F(f+20|0,r?i[f+8>>2]:k,r?i[f+12>>2]:e),t[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){r=i[f+68>>2],e=i[f+48>>2],r>>>0<e>>>0&&(i[f+68>>2]=e,r=e),e=f+44|0;break e}if(!(e&8)){r=0,t[A+11|0]=0;break i}r=i[f+40>>2],e=f+32|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,r)break e;r=0;break i}I0(),M()}if(!r)break i;z(A,k,r)}t[A+r|0]=0,A=i[19619],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[19622],i[o>>2]=77200,t[f+67|0]<0&&Z(i[f+56>>2]),y0(o),Y0(f+76|0),v=f+160|0}function Ct(A,e){var r=0,f=0;u[A|0]&&(r=A,f=G0(e,2),t[r+1|0]=f,r=A,f=G0(e,1),t[r+2|0]=f,r=A,f=G0(e,5),i[r+4>>2]=f,r=A,f=G0(e,1),t[r+8|0]=f,r=A,f=G0(e,1),t[r+9|0]=f,r=A,f=G0(e,1),t[r+10|0]=f,r=A,f=G0(e,1),t[r+11|0]=f,r=A,f=G0(e,1),t[r+12|0]=f,r=A,f=G0(e,1),t[r+13|0]=f,r=A,f=G0(e,1),t[r+14|0]=f,r=A,f=G0(e,1),t[r+15|0]=f,r=A,f=G0(e,1),t[r+16|0]=f,r=A,f=G0(e,1),t[r+17|0]=f,r=A,f=G0(e,1),t[r+18|0]=f,r=A,f=G0(e,1),t[r+19|0]=f,r=A,f=G0(e,1),t[r+20|0]=f,r=A,f=G0(e,1),t[r+21|0]=f,r=A,f=G0(e,1),t[r+22|0]=f,r=A,f=G0(e,1),t[r+23|0]=f,r=A,f=G0(e,1),t[r+24|0]=f,r=A,f=G0(e,1),t[r+25|0]=f,r=A,f=G0(e,1),t[r+26|0]=f,r=A,f=G0(e,1),t[r+27|0]=f,r=A,f=G0(e,1),t[r+28|0]=f,r=A,f=G0(e,1),t[r+29|0]=f,r=A,f=G0(e,1),t[r+30|0]=f,r=A,f=G0(e,1),t[r+31|0]=f,r=A,f=G0(e,1),t[r+32|0]=f,r=A,f=G0(e,1),t[r+33|0]=f,r=A,f=G0(e,1),t[r+34|0]=f,r=A,f=G0(e,1),t[r+35|0]=f,r=A,f=G0(e,1),t[r+36|0]=f,r=A,f=G0(e,1),t[r+37|0]=f,r=A,f=G0(e,1),t[r+38|0]=f,r=A,f=G0(e,1),t[r+39|0]=f,r=A,f=G0(e,1),t[r+40|0]=f,r=A,f=G0(e,1),t[r+41|0]=f,r=A,f=G0(e,1),t[r+42|0]=f,r=A,f=G0(e,1),t[r+43|0]=f,ei(e,44)),u[A+44|0]&&(r=A,f=G0(e,8),i[r+48>>2]=f)}function AX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,11378);break i}if(l=Q2(r),k=i[r>>2],n=W[i[i[k>>2]+8>>2]](k)|0,s=i[r>>2],k=h0,n=l+n|0,k=n>>>0<l>>>0?k+1|0:k,W[i[i[s>>2]+12>>2]](s,n,k)|0){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}o=i[e+108>>2],k=i[e+104>>2],n=o-k|0;e:{if(n>>>0<l>>>0){if(s=l-n|0,h=i[e+112>>2],s>>>0<=h-o>>>0){s&&l0(o,0,s),i[e+108>>2]=o+s;break e}if(o=h-k|0,h=o<<1,h=o>>>0>=1073741823?2147483647:l>>>0<h>>>0?h:l,o=C(h),s&&l0(n+o|0,0,s),n&&z(o,k,n),i[e+112>>2]=o+h,i[e+108>>2]=l+o,i[e+104>>2]=o,!k)break e;Z(k);break e}if(l>>>0>=n>>>0)break e;i[e+108>>2]=k+l}if(l)for(k=0;n=Q2(r),t[i[e+104>>2]+k|0]=n,k=k+1|0,(l|0)!=(k|0););if(u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function kX(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0;w=v-16|0,v=w,h=C(52),i[h+32>>2]=0,i[h+36>>2]=0,i[h+12>>2]=102424,i[h+4>>2]=0,i[h+8>>2]=0,i[h+28>>2]=n,i[h+24>>2]=k,i[h+20>>2]=f,i[h+16>>2]=r,i[h>>2]=102668,i[h+40>>2]=0,i[h+44>>2]=0,k=0,i[h+48>>2]=0;i:{e:{if(!l){n=0;break e}if((l|0)<0)break i;n=C(l),l&&l0(n,0,l),k=n+l|0,i[h+40>>2]=k,i[h+36>>2]=k,i[h+32>>2]=n}r=k-n|0,r&&z(n,o,r),r=i[e+8>>2],i[w+12>>2]=h,f=h+12|0,i[w+8>>2]=f,i[h+4>>2]=i[h+4>>2]+1,P0(r+12|0,w+8|0),r=i[w+12>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}e:{if(!s||(i[h+4>>2]=i[h+4>>2]+1,r=C(24),i[h+4>>2]=i[h+4>>2]+1,i[r+20>>2]=h,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[s>>2]=r,e=i[h+4>>2],i[h+4>>2]=e-1,e))break e;W[i[i[h>>2]+8>>2]](h),y(h)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[h+4>>2],i[h+4>>2]=A-1,A||(W[i[i[h>>2]+8>>2]](h),y(h)),v=w+16|0;return}s0(),M()}function Yt(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-48|0,v=f;i:{if(!r){if(t[f+16|0]=0,t[f+27|0]=0,r=a(f+28|0,5,2001,f+16|0),t[f+27|0]<0&&Z(i[f+16>>2]),c0(A,r,i[e>>2]),t[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}is(f+8|0,i[e>>2]),n=i[f+8>>2];e:{if(!n){if(t[f+16|0]=0,t[f+27|0]=0,r=a(f+28|0,2,124,f+16|0),t[f+27|0]<0&&Z(i[f+16>>2]),c0(A,r,i[e>>2]),t[r+19|0]>=0)break e;Z(i[r+8>>2]);break e}if(k=Z0(n,107564,100652),k){if(r=i[f+12>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),n=f+28|0,W[i[i[k>>2]+88>>2]](n,k),c0(A,n,i[e>>2]),t[f+47|0]<0&&Z(i[f+36>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;W[i[i[r>>2]+8>>2]](r),y(r);break e}k=C(16),i[k+8>>2]=0,i[k+12>>2]=0,i[r>>2]=k,r=i[f+12>>2],i[f+8>>2]=0,i[f+12>>2]=0,i[k+4>>2]=r,i[k>>2]=n,r=i[e>>2],n=i[e+4>>2];r:{if(!n){i[k+12>>2]=n,i[k+8>>2]=r;break r}if(i[n+4>>2]=i[n+4>>2]+1,i[k+8>>2]=r,r=i[k+12>>2],i[k+12>>2]=n,!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break r;W[i[i[r>>2]+8>>2]](r),y(r)}c0(A,114912,i[e>>2])}if(A=i[f+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f+48|0}function nX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;k=v-48|0,v=k;i:{e:{r:{if(!(r&&e)){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=18389;break r}if(h=i[e>>2],n=i[i[e+8>>2]>>2],o=l2(r),o>>>0>=2147483640)break e;f:{A:{if(o>>>0>=11){s=o|7,l=C(s+1|0),i[k+8>>2]=s-2147483647,i[k>>2]=l,i[k+4>>2]=o;break A}if(t[k+11|0]=o,l=k,!o)break f}if(!o)break f;z(l,r,o)}t[l+o|0]=0,Wn(k+20|0,h,n,k),t[k+11|0]<0&&Z(i[k>>2]),n=114912,h=114924,l=114931,r=114920;f:switch(u[k+40|0]){case 1:h=k+32|0,l=k+39|0,r=k+28|0,n=k+20|0;break;case 0:break f;default:break i}s=i[n>>2],n=i[n+4>>2],i[k>>2]=s,i[k+4>>2]=n,n=k+8|0;f:{if(t[l|0]>=0){l=i[r+4>>2],i[n>>2]=i[r>>2],i[n+4>>2]=l,i[n+8>>2]=i[r+8>>2];break f}T(n,i[r>>2],i[h>>2]),s=i[k>>2]}f:{if(s){if(c0(A,k,i[e>>2]),t[k+19|0]>=0)break f;Z(i[k+8>>2]);break f}if(t[k+19|0]<0&&Z(i[k+8>>2]),f){if(u[k+40|0])break i;i[f>>2]=i[k+20>>2]}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}if(e=u[k+40|0],(e|0)==255)break r;A=i[25869],i[k>>2]=i[25868],i[k+4>>2]=A,W[i[(e<<2)+k>>2]](k+47|0,k+20|0)}v=k+48|0;return}I0(),M()}e2(),M()}function tX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0;n=v-32|0,v=n,A=i[A>>2],l=i[A+48>>2],s=i[A+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,L1(n,l,e,n+20|0);i:{if(i[n>>2]||(A=i[n+20>>2],h=i[n+24>>2],(A|0)==(h|0)))break i;e=!f;e:{if(!r){if(e)break e;for(l=1;r=e,(k|0)>(o|0)&&(i[(o<<2)+f>>2]=l,r=1),l=l+1|0,o=r+o|0,A=A+8|0,(h|0)!=(A|0););break i}if(!f){for(;;)if(o=(e&i[i[A>>2]+16>>2]==(r|0))+o|0,A=A+8|0,(h|0)==(A|0))break i}for(l=1;;){r:{if(i[i[A>>2]+16>>2]!=(r|0))break r;if((k|0)>(o|0)){i[(o<<2)+f>>2]=l,o=o+1|0;break r}o=e+o|0}if(l=l+1|0,A=A+8|0,(h|0)==(A|0))break}break i}o=((h-A|0)-8>>>3|0)+1|0}if(t[n+19|0]<0&&Z(i[n+8>>2]),r=i[n+20>>2],r){if(A=i[n+24>>2],e=r,(A|0)!=(e|0)){for(;;){e=i[A-4>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(r|0)==(A|0))break}e=i[n+20>>2]}i[n+24>>2]=r,Z(e)}i:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}return v=n+32|0,o|0}function yt(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;f=v-32|0,v=f;i:{if(u[A+52|0]==1){if(r=i[A+48>>2],!e)break i;t[A+52|0]=0,i[A+48>>2]=-1;break i}e:{if(u[A+53|0]==1){if(r=de(i[A+32>>2]),(r|0)!=-1&&(t[f+24|0]=r),(r|0)==-1)break e;r=u[f+24|0];r:{if(!e){if(!kw(r,i[A+32>>2]))break e;break r}i[A+48>>2]=r}r=u[f+24|0];break i}for(i[f+24>>2]=1,k=v-16|0,v=k,v=k+16|0,k=A+44|0,n=f+24|0,k=i[(i[n>>2]<i[k>>2]?k:n)>>2],n=(k|0)>0?k:0;;){if((r|0)!=(n|0)){if(o=de(i[A+32>>2]),(o|0)==-1)break e;t[(f+24|0)+r|0]=o,r=r+1|0;continue}break}h=f+24|0;r:{for(;;){f:{n=i[A+40>>2],r=i[n>>2],w=i[n+4>>2],l=f+24|0,o=l+k|0;A:switch(s=i[A+36>>2],(W[i[i[s>>2]+16>>2]](s,n,l,o,f+16|0,f+23|0,h,f+12|0)|0)-1|0){case 1:break e;case 0:break A;case 2:break f;default:break r}if(n=i[A+40>>2],i[n>>2]=r,i[n+4>>2]=w,(k|0)==8||(r=de(i[A+32>>2]),(r|0)==-1))break e;t[o|0]=r,k=k+1|0;continue}break}t[f+23|0]=u[f+24|0]}r:{if(!e)for(;;){if((k|0)<=0)break r;if(k=k-1|0,(Si(u[k+(f+24|0)|0],i[A+32>>2])|0)==-1)break e}i[A+48>>2]=u[f+23|0]}r=u[f+23|0];break i}r=-1}return v=f+32|0,r}function oX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;e=v-16|0,v=e,r=C(32),i[e+4>>2]=r,i[e+8>>2]=29,i[e+12>>2]=-2147483616,f=u[24173]|u[24174]<<8|(u[24175]<<16|u[24176]<<24),k=u[24169]|u[24170]<<8|(u[24171]<<16|u[24172]<<24),t[r|0]=k,t[r+1|0]=k>>>8,t[r+2|0]=k>>>16,t[r+3|0]=k>>>24,t[r+4|0]=f,t[r+5|0]=f>>>8,t[r+6|0]=f>>>16,t[r+7|0]=f>>>24,t[r+29|0]=0,f=u[24194]|u[24195]<<8|(u[24196]<<16|u[24197]<<24),k=u[24190]|u[24191]<<8|(u[24192]<<16|u[24193]<<24),t[r+21|0]=k,t[r+22|0]=k>>>8,t[r+23|0]=k>>>16,t[r+24|0]=k>>>24,t[r+25|0]=f,t[r+26|0]=f>>>8,t[r+27|0]=f>>>16,t[r+28|0]=f>>>24,f=u[24189]|u[24190]<<8|(u[24191]<<16|u[24192]<<24),k=u[24185]|u[24186]<<8|(u[24187]<<16|u[24188]<<24),t[r+16|0]=k,t[r+17|0]=k>>>8,t[r+18|0]=k>>>16,t[r+19|0]=k>>>24,t[r+20|0]=f,t[r+21|0]=f>>>8,t[r+22|0]=f>>>16,t[r+23|0]=f>>>24,f=u[24181]|u[24182]<<8|(u[24183]<<16|u[24184]<<24),k=u[24177]|u[24178]<<8|(u[24179]<<16|u[24180]<<24),t[r+8|0]=k,t[r+9|0]=k>>>8,t[r+10|0]=k>>>16,t[r+11|0]=k>>>24,t[r+12|0]=f,t[r+13|0]=f>>>8,t[r+14|0]=f>>>16,t[r+15|0]=f>>>24,a(A,5,0,e+4|0),t[e+15|0]<0&&Z(i[e+4>>2]),v=e+16|0}function TA(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0;o=v-32|0,v=o,k=f&65535,n=f>>>16&32767,s=n;i:{if(n-15361>>>0<=2045){k=k<<4|r>>>28,r=r<<4,n=k,k=e>>>28|r,r=n,n=s-15360|0,e=e&268435455;e:{if((e|0)==134217728&(A|0)!=0|e>>>0>134217728){k=k+1|0,r=k?r:r+1|0;break e}if(A|(e|0)!=134217728)break e;A=k,k=k+(k&1)|0,r=A>>>0>k>>>0?r+1|0:r}l=r>>>0>1048575,A=l?0:k,e=l?0:r,k=0,r=n+l|0,n=r>>>0<n>>>0?1:k;break i}if(!(!(A|r|(e|k))|((n|0)!=32767|(l|0)!=0))){A=r,r=k<<4|r>>>28,A=A<<4|e>>>28,e=r|524288,r=2047,n=0;break i}if(s>>>0>17406){A=0,e=0,r=2047,n=0;break i}if(l=!(n|l),h=l?15360:15361,n=h-s|0,(n|0)>112){A=0,e=0,r=0,n=0;break i}k=l?k:k|65536,g4(o+16|0,A,e,r,k,128-n|0),I6(o,A,e,r,k,n),A=i[o+8>>2],l=A<<4,e=i[o+12>>2]<<4|A>>>28,A=i[o+4>>2],n=A,A=A>>>28|l,n=n&268435455,r=i[o>>2]|(s|0)!=(h|0)&(i[o+16>>2]|i[o+24>>2]|(i[o+20>>2]|i[o+28>>2]))!=0;e:{if((n|0)==134217728&(r|0)!=0|n>>>0>134217728){A=A+1|0,e=A?e:e+1|0;break e}if(r|(n|0)!=134217728)break e;k=e,e=A,A=A+(A&1)|0,e=e>>>0>A>>>0?k+1|0:k}r=e>>>0>1048575,e=r?e^1048576:e,n=0}return v=o+32|0,T2(0,A|0),T2(1,e|(f&-2147483648|r<<20)),+s1()}function lX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=+k;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;n=v-208|0,v=n,i[n+200>>2]=37,i[n+204>>2]=0,o=n+200|0,l=U3(o|1,47881,i[r+4>>2]),s=n+160|0,i[n+156>>2]=s,A=e1();i:{if(l){h=i[r+8>>2],u0[n+40>>3]=k,i[n+32>>2]=h,A=X4(s,30,A,o,n+32|0);break i}u0[n+48>>3]=k,A=X4(n+160|0,30,A,n+200|0,n+48|0)}i[n+80>>2]=2126,s=J1(n+148|0,0,n+80|0),o=n+160|0;i:{e:{if((A|0)>=30){A=e1();r:{if(l){o=i[r+8>>2],u0[n+8>>3]=k,i[n>>2]=o,A=S8(n+156|0,A,n+200|0,n);break r}u0[n+16>>3]=k,A=S8(n+156|0,A,n+200|0,n+16|0)}if((A|0)==-1)break e;o=i[s>>2],i[s>>2]=i[n+156>>2],o&&W[i[s+4>>2]](o),o=i[n+156>>2]}_=A+o|0,B=c4(o,_,r),i[n+80>>2]=2126,o=n+80|0,l=J1(n+72|0,0,o),h=i[n+156>>2];r:{if((h|0)==(n+160|0)){A=o;break r}if(A=E2(A<<1),!A)break e;o=i[l>>2],i[l>>2]=A,o&&W[i[l+4>>2]](o),h=i[n+156>>2]}w=n+60|0,o=i[r+28>>2],i[w>>2]=o,(o|0)!=136824&&(i[o+4>>2]=i[o+4>>2]+1),it(h,B,_,A,n+68|0,n- -64|0,w),i2(w),A=o6(e,A,i[n+68>>2],i[n+64>>2],r,f),e=i[l>>2],i[l>>2]=0,e&&W[i[l+4>>2]](e),e=i[s>>2],i[s>>2]=0,e&&W[i[s+4>>2]](e),v=n+208|0;break i}N1(),M()}return A|0}function uX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=+k;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;n=v-368|0,v=n,i[n+360>>2]=37,i[n+364>>2]=0,o=n+360|0,l=U3(o|1,47881,i[r+4>>2]),s=n+320|0,i[n+316>>2]=s,A=e1();i:{if(l){h=i[r+8>>2],u0[n+40>>3]=k,i[n+32>>2]=h,A=X4(s,30,A,o,n+32|0);break i}u0[n+48>>3]=k,A=X4(n+320|0,30,A,n+360|0,n+48|0)}i[n+80>>2]=2126,s=J1(n+308|0,0,n+80|0),o=n+320|0;i:{e:{if((A|0)>=30){A=e1();r:{if(l){o=i[r+8>>2],u0[n+8>>3]=k,i[n>>2]=o,A=S8(n+316|0,A,n+360|0,n);break r}u0[n+16>>3]=k,A=S8(n+316|0,A,n+360|0,n+16|0)}if((A|0)==-1)break e;o=i[s>>2],i[s>>2]=i[n+316>>2],o&&W[i[s+4>>2]](o),o=i[n+316>>2]}_=A+o|0,B=c4(o,_,r),i[n+80>>2]=2126,o=n+80|0,l=J1(n+72|0,0,o),h=i[n+316>>2];r:{if((h|0)==(n+320|0)){A=o;break r}if(A=E2(A<<3),!A)break e;o=i[l>>2],i[l>>2]=A,o&&W[i[l+4>>2]](o),h=i[n+316>>2]}w=n+60|0,o=i[r+28>>2],i[w>>2]=o,(o|0)!=136824&&(i[o+4>>2]=i[o+4>>2]+1),cn(h,B,_,A,n+68|0,n- -64|0,w),i2(w),A=t6(e,A,i[n+68>>2],i[n+64>>2],r,f),e=i[l>>2],i[l>>2]=0,e&&W[i[l+4>>2]](e),e=i[s>>2],i[s>>2]=0,e&&W[i[s+4>>2]](e),v=n+368|0;break i}N1(),M()}return A|0}function sX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0;n=v-48|0,v=n;i:{e:{r:{if(!(f&&e)){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=18389;break r}if(o=i[e>>2],l=l2(f),l>>>0>=2147483640)break e;f:{A:{if(l>>>0>=11){h=l|7,s=C(h+1|0),i[n+8>>2]=h-2147483647,i[n>>2]=s,i[n+4>>2]=l;break A}if(t[n+11|0]=l,s=n,!l)break f}if(!l)break f;z(s,f,l)}t[l+s|0]=0,Wn(n+20|0,o,r,n),t[n+11|0]<0&&Z(i[n>>2]),o=114912,s=114924,r=114931,f=114920;f:switch(u[n+40|0]){case 1:s=n+32|0,r=n+39|0,f=n+28|0,o=n+20|0;break;case 0:break f;default:break i}h=i[o>>2],o=i[o+4>>2],i[n>>2]=h,i[n+4>>2]=o,o=n+8|0;f:{if(t[r|0]>=0){r=i[f+4>>2],i[o>>2]=i[f>>2],i[o+4>>2]=r,i[o+8>>2]=i[f+8>>2];break f}T(o,i[f>>2],i[s>>2]),h=i[n>>2]}f:{if(h){if(c0(A,n,i[e>>2]),t[n+19|0]>=0)break f;Z(i[n+8>>2]);break f}if(t[n+19|0]<0&&Z(i[n+8>>2]),k){if(u[n+40|0])break i;i[k>>2]=i[n+20>>2]}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}if(e=u[n+40|0],(e|0)==255)break r;A=i[25811],i[n>>2]=i[25810],i[n+4>>2]=A,W[i[(e<<2)+n>>2]](n+47|0,n+20|0)}v=n+48|0;return}I0(),M()}e2(),M()}function V4(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0;i:{e:{if((k|0)<=0)break e;if(l=i[A+8>>2],s=i[A+4>>2],(l-s|0)>=(k|0)){n=s-e|0;r:{if((n|0)>=(k|0)){l=r+k|0,o=s;break r}if(l=r+n|0,o=f-l|0,!o|(f|0)==(l|0)||z(s,l,o),o=o+s|0,i[A+4>>2]=o,(n|0)<=0)break e}h=e+k|0,f=o,n=f-k|0;r:{if(s>>>0<=n>>>0)break r;if(w=k+s|0,_=w-f&7,_)for(k=0;t[f|0]=u[n|0],f=f+1|0,n=n+1|0,k=k+1|0,(_|0)!=(k|0););if(o-w>>>0>=4294967289)break r;for(;t[f|0]=u[n|0],t[f+1|0]=u[n+1|0],t[f+2|0]=u[n+2|0],t[f+3|0]=u[n+3|0],t[f+4|0]=u[n+4|0],t[f+5|0]=u[n+5|0],t[f+6|0]=u[n+6|0],t[f+7|0]=u[n+7|0],f=f+8|0,n=n+8|0,(s|0)!=(n|0););}i[A+4>>2]=f;r:{if((o|0)==(h|0)||(A=o-h|0,!A))break r;z(o-A|0,e,A)}if((r|0)==(l|0)||(A=l-r|0,!A))break e;z(e,r,A);return}if(o=i[A>>2],f=(s-o|0)+k|0,(f|0)<0)break i;n=e-o|0,l=l-o|0,h=l<<1,l=l>>>0>=1073741823?2147483647:f>>>0<h>>>0?h:f,l?f=C(l):f=0,h=n+f|0,k&&z(h,r,k),r=k+h|0,k=s-e|0,k&&z(r,e,k),i[A+4>>2]=e,n&&z(f,o,n),i[A+8>>2]=f+l,i[A+4>>2]=r+k,i[A>>2]=f,o&&Z(o)}return}s0(),M()}function hX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;k=v-32|0,v=k,S2(k,e,r),t[k+19|0]<0&&Z(i[k+8>>2]),t[e+100|0]&1&&(w=e,_=F0(r),i[w+104>>2]=_,w=e,_=F0(r),i[w+108>>2]=_),n=F0(r);i:{e:{if(!f||(o=i[f+80>>2],!o|n>>>0<=o>>>0))break e;if(e=C(72),i[k+20>>2]=e,i[k+24>>2]=70,i[k+28>>2]=-2147483576,z(e,26154,70),t[e+70|0]=0,a(A,6,1e3,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(D4(A,e+140|0,n<<3,f,14931),i[A>>2])break i;t[A+19|0]<0&&Z(i[A+8>>2]),l=e+128|0;e:{o=i[e+128>>2],f=i[e+132>>2]-o>>3;r:{if(f>>>0<n>>>0){fi(l,n-f|0);break r}if(f>>>0>n>>>0&&(i[e+132>>2]=(n<<3)+o),!n)break e}for(f=0;;){r:{if(u[e+97|0]==1){o=S4(r),s=h0;break r}o=F0(r),s=0}if(h=i[l>>2]+(f<<3)|0,i[h>>2]=o,i[h+4>>2]=s,u[r+20|0]!=1){if(f=f+1|0,(n|0)==(f|0))break e;continue}break}if(t[k+20|0]=0,t[k+31|0]=0,a(A,2,100,k+20|0),t[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function jA(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;f=v+-64|0,v=f,o=i[i[e+108>>2]-8>>2],W[i[i[o>>2]+12>>2]](f+44|0,o),n=A+8|0,o=i[28446],s=i[28447];i:{for(;;){if(k=i[f+44>>2],W[i[i[k>>2]+24>>2]](f+24|0,k,r),i[f+24>>2]){e=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=e,i[n+8>>2]=i[f+40>>2],A=i[f+36>>2],i[n>>2]=i[f+32>>2],i[n+4>>2]=A;break i}An(f,e,r);e:{r:{f:{A:switch(u[f+20|0]){case 1:if(k=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=k,t[f+19|0]<0)break f;k=i[f+12>>2],i[n>>2]=i[f+8>>2],i[n+4>>2]=k,i[n+8>>2]=i[f+16>>2],k=1,l=1;break r;default:e2(),M();case 0:break A}l=0,k=u[f|0]?0:2;break r}if(T(n,i[f+8>>2],i[f+12>>2]),k=1,l=u[f+20|0],(l|0)==255)break e}i[f+56>>2]=o,i[f+60>>2]=s,W[i[(f+56|0)+(l<<2)>>2]](f+55|0,f)}if(t[f+43|0]<0&&Z(i[f+32>>2]),!!k)break}if((k|0)!=2)break i;r=i[e+324>>2];e:{if(!r)break e;if(jA(A,r,i[e+336>>2]),i[A>>2])break i;if(t[A+19|0]>=0)break e;Z(i[A+8>>2])}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}A=i[f+48>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f- -64|0}function wX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0;r=v-80|0,v=r,f=i[e+72>>2],i[r+76>>2]=0,i[r+68>>2]=0,i[r+72>>2]=0,k=i[f+116>>2],f=i[f+120>>2],Oe(r+68|0,k,f,(f-k|0)/12|0),k=i[r+68>>2],o=i[r+72>>2];i:{if((k|0)!=(o|0))for(f=k;;){if(n=i[f>>2],l=i[f+4>>2],(n|0)!=(l|0)){e=i[e+72>>2],f=i[e+112>>2],i[r+56>>2]=i[e+108>>2],i[r+60>>2]=f,f=i[e+104>>2],i[r+48>>2]=i[e+100>>2],i[r+52>>2]=f,f=0,i[r+44>>2]=0,i[r+40>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,uA(r+8|0,n,l-n|0,r+48|0,r+44|0,r+40|0,r+32|0);e:{if(i[r+8>>2]){if(e=A+12|0,f=i[r+12>>2],i[A+4>>2]=i[r+8>>2],i[A+8>>2]=f,t[r+27|0]>=0){f=i[r+20>>2],i[e>>2]=i[r+16>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+24>>2],f=1;break e}T(e,i[r+16>>2],i[r+20>>2]),f=1;break e}e=i[r+36>>2],k=i[r+32>>2],t[A+12|0]=1,i[A+4>>2]=k,i[A+8>>2]=e}t[A+24|0]=f,t[r+27|0]<0&&Z(i[r+16>>2]),k=i[r+68>>2];break i}if(f=f+12|0,(o|0)==(f|0))break}t[A+24|0]=0,t[A+12|0]=0,t[A+4|0]=0}if(k){if(A=k,f=i[r+72>>2],(A|0)!=(f|0)){for(;A=f-12|0,e=i[A>>2],e&&(i[f-8>>2]=e,Z(e)),f=A,(k|0)!=(f|0););A=i[r+68>>2]}i[r+72>>2]=k,Z(A)}v=r+80|0}function _X(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;o=v-16|0,v=o;i:{e:{if(!e){r=0;break e}if(A=i[A>>2],i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,f=i[A+212>>2],k=i[A+216>>2],(f|0)!=(k|0)){if(A=k-f|0,(A|0)<0)break i;for(n=C(A),i[o+4>>2]=n,i[o+12>>2]=A+n,A=n;i[A>>2]=i[f>>2],l=i[f+4>>2],i[A+4>>2]=l,l&&(i[l+4>>2]=i[l+4>>2]+1),A=A+8|0,f=f+8|0,(k|0)!=(f|0););i[o+8>>2]=A,f=A-n>>3,r=(r|0)>(f|0)?f:r;r:{if((r|0)<=0)break r;if(l=0,f=0,r>>>0>=4)for(h=r&2147483644,k=0;i[(f<<2)+e>>2]=i[i[(f<<3)+n>>2]+196>>2],s=f|1,i[(s<<2)+e>>2]=i[i[(s<<3)+n>>2]+196>>2],s=f|2,i[(s<<2)+e>>2]=i[i[(s<<3)+n>>2]+196>>2],s=f|3,i[(s<<2)+e>>2]=i[i[(s<<3)+n>>2]+196>>2],f=f+4|0,k=k+4|0,(h|0)!=(k|0););if(k=r&3,!k)break r;for(;i[(f<<2)+e>>2]=i[i[(f<<3)+n>>2]+196>>2],f=f+1|0,l=l+1|0,(k|0)!=(l|0););}for(;;){e=A-8|0,A=i[A-4>>2];r:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=e,(n|0)==(A|0))break}Z(i[o+4>>2]);break e}r=r>>31&r}return v=o+16|0,r|0}s0(),M()}function BX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-80|0,v=f,n=-1;i:{if(!A|(e|0)<=0|(!r|!u[r|0])||!u[r+3|0]|(!u[r+1|0]|!u[r+2|0]))break i;k=C(72),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=101400,A=be(k+16|0,A,e,0),i[f+52>>2]=k,i[f+48>>2]=A,i[k+4>>2]=i[k+4>>2]+1,A=i[f+52>>2],i[f+8>>2]=i[f+48>>2],i[f+12>>2]=A,o=$i(f+56|0,f+8|0,e,0),i[f+40>>2]=0,i[f+44>>2]=0,c8(f+20|0,o,f+40|0,101976);e:{if(i[f+20>>2]){n=i[f+24>>2]==100?-1:-2;break e}if(n=-2,A=i[f+40>>2],!A||(e=Z0(A,92792,93156),!e)||(A=i[f+44>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),n=e,e=u[r|0]|u[r+1|0]<<8|(u[r+2|0]<<16|u[r+3|0]<<24),n=P4(n,e<<24|(e&65280)<<8|(e>>>8&65280|e>>>24)),!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}t[f+39|0]<0&&Z(i[f+28>>2]),A=i[f+44>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[o+4>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[k+4>>2],i[k+4>>2]=A-1,A)break i;W[i[i[k>>2]+8>>2]](k),y(k)}return v=f+80|0,n|0}function vX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;if(f=i[A+120>>2],f>>>0<o0[A+124>>2]){Se(f,e),i[A+120>>2]=f+28;return}i:{e:{if(n=i[A+116>>2],f=i[A+120>>2]-n|0,k=((f|0)/28|0)+1|0,k>>>0<153391690){if(r=f,f=(i[A+124>>2]-n|0)/28|0,n=f<<1,n=f>>>0>=76695844?153391689:k>>>0<n>>>0?n:k,n){if(n>>>0>=153391690)break e;f=C(g(n,28))}else f=0;if(o=r+f|0,Se(o,e),e=i[A+116>>2],k=e,r=i[A+120>>2],l=r,s=g((r-e|0)/-28|0,28)+o|0,r=s,(e|0)!=(l|0)){for(;i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,i[r>>2]=i[e>>2],i[r+4>>2]=i[e+4>>2],i[r+8>>2]=i[e+8>>2],i[e+8>>2]=0,i[e>>2]=0,i[e+4>>2]=0,h=i[e+12>>2],i[r+24>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+12>>2]=h,i[r+16>>2]=i[e+16>>2],i[r+20>>2]=i[e+20>>2],i[r+24>>2]=i[e+24>>2],i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,r=r+28|0,e=e+28|0,(l|0)!=(e|0););for(;e=i[k+16>>2],e&&(i[k+20>>2]=e,Z(e)),e=i[k>>2],e&&(i[k+4>>2]=e,Z(e)),k=k+28|0,(l|0)!=(k|0););}e=o+28|0,i[A+120>>2]=e,r=i[A+116>>2],i[A+116>>2]=s,i[A+124>>2]=g(n,28)+f,r&&Z(r);break i}s0(),M()}x0(),M()}i[A+120>>2]=e}function SA(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;i:{if(!e){o=A+112|0,r=u[A+112|0];break i}if(f=i[A+116>>2],!f){i[A+116>>2]=1,t[A+112|0]=e;return}if(o=A+112|0,r=u[o|0],(r|0)!=(e|0))break i;i[A+116>>2]=f+1;return}k=i[A+116>>2];i:{e:{r:{if(!(r&255)){f=k;break r}if(f=0,k)for(r=i[A+124>>2];;){l=i[A+128>>2];f:{if(l>>>0>r>>>0){t[r|0]=u[o|0],r=r+1|0;break f}if(n=i[A+120>>2],f=r-n|0,k=f+1|0,(k|0)<0)break e;if(r=l-n|0,l=r<<1,r=r>>>0>=1073741823?2147483647:k>>>0<l>>>0?l:k,r?k=C(r):k=0,l=k+f|0,t[l|0]=u[A+112|0],f&&z(k,n,f),i[A+128>>2]=r+k,r=l+1|0,i[A+124>>2]=r,i[A+120>>2]=k,!n)break f;Z(n)}if(i[A+124>>2]=r,f=i[A+116>>2],s=s+1|0,!(f>>>0>s>>>0))break}t[o|0]=0}if(i[A+116>>2]=f+1,f=i[A+124>>2],n=i[A+128>>2],f>>>0<n>>>0){t[f|0]=e,i[A+124>>2]=f+1;return}if(r=i[A+120>>2],f=f-r|0,k=f+1|0,(k|0)<0)break i;n=n-r|0,o=n<<1,n=n>>>0>=1073741823?2147483647:k>>>0<o>>>0?o:k,n?k=C(n):k=0,o=k+f|0,t[o|0]=e,f&&z(k,r,f),i[A+128>>2]=k+n,e=o+1|0,i[A+124>>2]=e,i[A+120>>2]=k,r&&Z(r),i[A+124>>2]=e;return}s0(),M()}s0(),M()}function K6(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;i[A+8>>2]=r,i[A>>2]=e,i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+12>>2]=r,i[A+4>>2]=e,s=-64;i:{if(!r||(i[A+4>>2]=e+1,f=u[e|0],k=r-1|0,i[A+12>>2]=k,f=f<<24,n=f,i[A+16>>2]=0,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+2,f=u[e+1|0],k=r-2|0,i[A+12>>2]=k,f=n|f<<16,o=f,i[A+16>>2]=l,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+3,f=u[e+2|0],k=r-3|0,i[A+12>>2]=k,f=o|f<<8,o=f,i[A+16>>2]=l,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+4,f=u[e+3|0],k=r-4|0,i[A+12>>2]=k,n=l,f=f|o,l=f,i[A+16>>2]=n,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+5,f=u[e+4|0],k=r-5|0,i[A+12>>2]=k,o=n,n=f>>>8|0,f=o|f<<24,n=n|l,l=n,i[A+16>>2]=f,i[A+20>>2]=n,!k)||(i[A+4>>2]=e+6,n=u[e+5|0],k=r-6|0,i[A+12>>2]=k,o=f,f=n>>>16|0,n=o|n<<16,f=f|l,l=f,i[A+16>>2]=n,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+7,f=u[e+6|0],k=r-7|0,i[A+12>>2]=k,o=n,n=f>>>24|0,f=o|f<<8,i[A+16>>2]=f,n=n|l,i[A+20>>2]=n,!k))break i;i[A+4>>2]=e+8,e=u[e+7|0],i[A+12>>2]=r-8,i[A+16>>2]=e|f,i[A+20>>2]=n,s=-56}return i[A+24>>2]=(((r>>>0>=7?7:r)<<3)+s|0)- -64,A}function mX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=78468,k=i[19620],i[f+8>>2]=k,l=i[k-12>>2],k=f+8|0,i[l+k>>2]=i[19621],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),t[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=78468,i[f+8>>2]=78448,o=R0(n),i[o>>2]=77200,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,k0(n,r),l=k,r=t[f+159|0],k=(r|0)<0,F(l,k?i[f+148>>2]:n,k?i[f+152>>2]:r),t[f+159|0]<0&&Z(i[f+148>>2]),F(B0(F(f+8|0,35985,14),i[e+12>>2]-i[e+8>>2]|0),47878,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=C(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0,A=i[19619],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[19622],i[o>>2]=77200,t[f+55|0]<0&&Z(i[f+44>>2]),y0(o),Y0(f- -64|0),v=f+160|0}function ZX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0;if(!(f&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}k=v-48|0,v=k,n=i[e>>2],l=i[n+92>>2],i[n+92>>2]=l+1,e=r>>>0>11?65535:i[(r<<2)+55356>>2],t[k+32|0]=0,i[k+44>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,X[k+20>>1]=0,i[k+16>>2]=255,X[k+12>>1]=r,i[k+8>>2]=e,i[k+4>>2]=l,i[k+24>>2]=0,i[k+28>>2]=0,e=i[n+84>>2];i:{if(e>>>0<o0[n+88>>2]){r=i[k+8>>2],i[e>>2]=i[k+4>>2],i[e+4>>2]=r,r=u[k+29|0]|u[k+30|0]<<8|(u[k+31|0]<<16|u[k+32|0]<<24),o=u[k+25|0]|u[k+26|0]<<8|(u[k+27|0]<<16|u[k+28|0]<<24),t[e+21|0]=o,t[e+22|0]=o>>>8,t[e+23|0]=o>>>16,t[e+24|0]=o>>>24,t[e+25|0]=r,t[e+26|0]=r>>>8,t[e+27|0]=r>>>16,t[e+28|0]=r>>>24,r=i[k+24>>2],i[e+16>>2]=i[k+20>>2],i[e+20>>2]=r,r=i[k+16>>2],i[e+8>>2]=i[k+12>>2],i[e+12>>2]=r,r=i[k+40>>2],i[e+32>>2]=i[k+36>>2],i[e+36>>2]=r,i[e+40>>2]=i[k+44>>2],i[n+84>>2]=e+44;break i}if(e=U8(n+80|0,k+4|0),r=t[k+47|0],i[n+84>>2]=e,(r|0)>=0)break i;Z(i[k+36>>2])}v=k+48|0,i[f>>2]=l,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}function Ee(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0;if(n=v-16|0,v=n,i[A>>2]=101648,a2(i[A+64>>2]),i[n+12>>2]=A+140,k=i[n+12>>2],r=i[k>>2],r){if(f=r,e=i[k+4>>2],(r|0)!=(e|0)){for(;f=i[e-12>>2],f&&(i[e-8>>2]=f,Z(f)),f=i[e-24>>2],f&&(i[e-20>>2]=f,Z(f)),f=e-48|0,o=i[f>>2],o&&(i[e-44>>2]=o,Z(o)),e=f,(r|0)!=(e|0););f=i[i[n+12>>2]>>2]}i[k+4>>2]=r,Z(f)}if(e=i[A+128>>2],e&&(N5(A+128|0,e),Z(i[A+128>>2])),k=i[A+116>>2],k){if(e=k,r=i[A+120>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),e=r-28|0,f=i[e>>2],f&&(i[r-24>>2]=f,Z(f)),r=e,(e|0)!=(k|0););e=i[A+116>>2]}i[A+120>>2]=k,Z(e)}i:{if(u[A+112|0]!=1||(e=i[A+100>>2],!e))break i;i[A+104>>2]=e,Z(e)}if(k=i[A+80>>2],k){if(e=k,r=i[A+84>>2],(e|0)!=(r|0)){for(;t[r-1|0]<0&&Z(i[r-12>>2]),r=r-44|0,(k|0)!=(r|0););e=i[A+80>>2]}i[A+84>>2]=k,Z(e)}t[A+79|0]<0&&Z(i[A+68>>2]),e=i[A+20>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=n+16|0,A|0}function gX(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0;l=v-160|0,v=l;i:{e:{if(s=i[e+16>>2],!s||(w=Z0(s,101112,102272),!w))break e;if(s=i[e+20>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),h=i[e>>2],i[l+104>>2]=i[h+48>>2],h=i[h+52>>2],i[l+108>>2]=h,h&&(i[h+4>>2]=i[h+4>>2]+1),e=i[e+8>>2],h=i[e+8>>2],_=i[e+4>>2],e=i[l+108>>2],i[l+32>>2]=i[l+104>>2],i[l+36>>2]=e,e=l+112|0,Lr(e,l+32|0,r,_,h),u0[l+72>>3]=i[w+4>>2],u0[l+80>>3]=i[w+8>>2],r=i[l+84>>2],i[l+24>>2]=i[l+80>>2],i[l+28>>2]=r,r=i[l+76>>2],i[l+16>>2]=i[l+72>>2],i[l+20>>2]=r,ef(l+88|0,e,l+16|0),u0[l+40>>3]=o0[w+12>>2],u0[l+48>>3]=o0[w+16>>2],r=i[l+52>>2],i[l+8>>2]=i[l+48>>2],i[l+12>>2]=r,r=i[l+44>>2],i[l>>2]=i[l+40>>2],i[l+4>>2]=r,Hs(l+56|0,e,l),u0[f>>3]=u0[l+88>>3],u0[k>>3]=u0[l+96>>3],u0[n>>3]=u0[l+56>>3],u0[o>>3]=u0[l+64>>3],i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s);break i}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794]}v=l+160|0}function GX(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0;l=v-160|0,v=l;i:{e:{if(s=i[e+16>>2],!s||(w=Z0(s,101112,102316),!w))break e;if(s=i[e+20>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),h=i[e>>2],i[l+104>>2]=i[h+48>>2],h=i[h+52>>2],i[l+108>>2]=h,h&&(i[h+4>>2]=i[h+4>>2]+1),e=i[e+8>>2],h=i[e+8>>2],_=i[e+4>>2],e=i[l+108>>2],i[l+32>>2]=i[l+104>>2],i[l+36>>2]=e,e=l+112|0,Lr(e,l+32|0,r,_,h),u0[l+72>>3]=i[w+4>>2],u0[l+80>>3]=i[w+8>>2],r=i[l+84>>2],i[l+24>>2]=i[l+80>>2],i[l+28>>2]=r,r=i[l+76>>2],i[l+16>>2]=i[l+72>>2],i[l+20>>2]=r,ef(l+88|0,e,l+16|0),u0[l+40>>3]=o0[w+12>>2],u0[l+48>>3]=o0[w+16>>2],r=i[l+52>>2],i[l+8>>2]=i[l+48>>2],i[l+12>>2]=r,r=i[l+44>>2],i[l>>2]=i[l+40>>2],i[l+4>>2]=r,Hs(l+56|0,e,l),u0[f>>3]=u0[l+88>>3],u0[k>>3]=u0[l+96>>3],u0[n>>3]=u0[l+56>>3],u0[o>>3]=u0[l+64>>3],i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s);break i}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794]}v=l+160|0}function WX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0;k=v-32|0,v=k,n=C(44),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=103400,o=n+12|0,i[o>>2]=92456,i[n+16>>2]=0,i[n+20>>2]=0,i[n+32>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+40>>2]=f,i[n+36>>2]=r,i[n+12>>2]=92368,f=i[e>>2],i[k+8>>2]=n,i[k+4>>2]=o,i[n+4>>2]=i[n+4>>2]+1,o=k+12|0,h=k+4|0,r=v-32|0,v=r,s=C(204),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=100736,w=f,_=e3(s+12|0),i[w+48>>2]=_,l=i[f+52>>2],i[f+52>>2]=s;i:{if(!l||(s=i[l+4>>2],i[l+4>>2]=s-1,s))break i;W[i[i[l>>2]+8>>2]](l),y(l)}l=i[f+48>>2],i[l+168>>2]=f- -64,fA(r+8|0,l,h);i:{if(i[r+8>>2]){f=i[r+12>>2],i[o>>2]=i[r+8>>2],i[o+4>>2]=f,f=i[r+20>>2],i[o+8>>2]=i[r+16>>2],i[o+12>>2]=f,i[o+16>>2]=i[r+24>>2];break i}if(rA(o,f),t[r+27|0]>=0)break i;Z(i[r+16>>2])}v=r+32|0,r=i[k+8>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}c0(A,k+12|0,i[e>>2]),t[k+31|0]<0&&Z(i[k+20>>2]),A=i[n+4>>2],i[n+4>>2]=A-1,A||(W[i[i[n>>2]+8>>2]](n),y(n)),v=k+32|0}function XX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-32|0,v=r,i[A+160>>2]=e,k=v-32|0,v=k;i:{if(i[A+160>>2]==255){i[r+16>>2]=0,i[r+20>>2]=0;break i}if(e=C(128),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=100508,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=92500,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[f>>2]=114196,i[e+32>>2]=1886545522,i[e+120>>2]=0,$n(k+12|0,f,i[A+160>>2]),n=i[k+12>>2],t[k+31|0]<0&&Z(i[k+20>>2]),!n){i[r+20>>2]=e,i[r+16>>2]=f;break i}if(i[r+16>>2]=0,i[r+20>>2]=0,f=i[e+4>>2],i[e+4>>2]=f-1,f)break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=k+32|0,f=i[r+20>>2],e=i[r+16>>2],i[r+24>>2]=e,i[r+28>>2]=f,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=e,i[r+12>>2]=f,O4(A,r+8|0,1),A=i[r+20>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=r+32|0}function IX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;k=v-32|0,v=k,A=i[A>>2],l=i[A+48>>2],n=i[A+52>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,L1(k,l,e,k+20|0);i:{if(i[k>>2]||(A=i[k+20>>2],l=i[k+24>>2],(A|0)==(l|0)))break i;if(e=!r,h=e,e){for(;;)if(e=i[i[A>>2]+16>>2],!((e|0)==1668047216|(e|0)==1769107316)&(e|0)!=1768778098||(o=o+h|0),A=A+8|0,(l|0)==(A|0))break i}for(e=1;;){s=i[i[A>>2]+16>>2];e:{if(!((s|0)==1668047216|(s|0)==1769107316)&(s|0)!=1768778098)break e;if((f|0)>(o|0)){i[(o<<2)+r>>2]=e,o=o+1|0;break e}o=o+h|0}if(e=e+1|0,A=A+8|0,(l|0)==(A|0))break}}if(t[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(A=i[k+24>>2],e=r,(A|0)!=(e|0)){for(;;){e=i[A-4>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(r|0)==(A|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}i:{if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n)}return v=k+32|0,o|0}function Et(A,e,r){var f=D(0),k=D(0),n=D(0),o=D(0),l=D(0),s=D(0),h=D(0),w=D(0),_=D(0),B=D(0),m=D(0),G=D(0),I=D(0),Q=D(0),V=D(0);i[A>>2]=0,i[A+4>>2]=0;i:{e:{if((e&65534)==12){if(e=r-1&65535,e>>>0<=21&&(e=e<<2,l=E0[e+56144>>2],_=E0[e+56056>>2],k=E0[e+55968>>2],s=E0[e+55880>>2],n=E0[e+55792>>2],h=E0[e+55704>>2],o=E0[e+55616>>2],f=E0[e+55528>>2]),w=D(D(1)-D(f+o)),B=D(D(1)-D(s+k)),I=D(D(k*w)-D(o*B)),m=D(D(1)-D(h+n)),Q=D(D(o*m)-D(n*w)),G=D(l*D(D(h*I)+D(D(s*Q)+D(f*D(D(n*B)-D(k*m)))))),G==D(0))break i;V=D(D(1)-D(_+l)),E0[A>>2]=D(k*D(D(V*D(D(f*n)-D(h*o)))+D(D(_*Q)+D(l*D(D(h*w)+D(f*D(-m)))))))/G,f=D(D(n*D(D(V*D(D(s*o)-D(f*k)))+D(D(_*I)+D(l*D(D(f*B)+D(s*D(-w)))))))/G);break e}r:switch(e-1|0){case 0:i[A>>2]=1046066128,f=D(.0722000002861023);break e;case 3:i[A>>2]=1050253722,f=D(.10999999940395355);break e;case 4:case 5:i[A>>2]=1050220167,f=D(.11400000005960464);break e;case 6:i[A>>2]=1046025863,f=D(.08699999749660492);break e;case 8:case 9:break r;default:break i}i[A>>2]=1049002141,f=D(.059300001710653305)}E0[A+4>>2]=f}}function Rt(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;k=v-112|0,v=k;i:{if(!f){e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794];break i}e:{if(n=i[e+16>>2],!n||(l=Z0(n,101112,102404),!l))break e;if(n=i[e+20>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),o=i[e>>2],i[k+56>>2]=i[o+48>>2],o=i[o+52>>2],i[k+60>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),e=i[e+8>>2],o=i[e+8>>2],e=i[e+4>>2],s=i[k+60>>2],i[k+16>>2]=i[k+56>>2],i[k+20>>2]=s,Lr(k- -64|0,k+16|0,r,e,o),r=i[l+8>>2],(i[l+12>>2]-r|0)>0)for(e=0;r=(e<<3)+r|0,u0[k+24>>3]=i[r>>2],u0[k+32>>3]=i[r+4>>2],r=i[k+36>>2],i[k+8>>2]=i[k+32>>2],i[k+12>>2]=r,r=i[k+28>>2],i[k>>2]=i[k+24>>2],i[k+4>>2]=r,ef(k+40|0,k- -64|0,k),r=(e<<4)+f|0,u0[r>>3]=u0[k+40>>3],u0[r+8>>3]=u0[k+48>>3],e=e+1|0,r=i[l+8>>2],(e|0)<i[l+12>>2]-r>>3;);if(e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n);break i}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794]}v=k+112|0}function QX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;f=v-16|0,v=f;i:{e:{r:{f:{k=u[r+20|0];A:{if(!(!i[r+16>>2]|k&1)){for(;;){l=w2(r),w=Q2(r),_=Q2(r),k=i[e+104>>2],n=i[e+108>>2];k:{if(k>>>0<n>>>0){o=l|(_<<24|w<<16),X[k>>1]=o,X[k+2>>1]=o>>>16,k=k+4|0;break k}if(h=i[e+100>>2],k=k-h|0,B=k>>2,o=B+1|0,o>>>0>=1073741824)break f;if(n=n-h|0,s=n>>1,n=n>>>0>=2147483644?1073741823:o>>>0<s>>>0?s:o,n){if(n>>>0>=1073741824)break r;o=C(n<<2)}else o=0;if(s=o+k|0,l=l|(_<<24|w<<16),X[s>>1]=l,X[s+2>>1]=l>>>16,l=s-(B<<2)|0,k&&z(l,h,k),i[e+108>>2]=o+(n<<2),k=s+4|0,i[e+104>>2]=k,i[e+100>>2]=l,!h)break k;Z(h)}if(i[e+104>>2]=k,k=t[r+20|0]&1,!(!k&&i[r+16>>2]))break}if(k)break A;break e}if(!(k&1))break e}if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}s0(),M()}x0(),M()}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function VX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]),k=u[e+97|0];i:{if(k>>>0>=2){B1(A,e,17505);break i}e:{if((k|0)==1){l=e,s=S4(r),i[l+104>>2]=s,i[e+108>>2]=h0,l=e,s=S4(r),i[l+112>>2]=s,i[e+116>>2]=h0,l=e,s=F0(r),i[l+120>>2]=s,k=S4(r),n=h0;break e}l=e,s=F0(r),i[l+104>>2]=s,i[e+108>>2]=0,l=e,s=F0(r),i[l+112>>2]=s,i[e+116>>2]=0,l=e,s=F0(r),i[l+120>>2]=s,k=F0(r),n=0}if(i[e+128>>2]=k,i[e+132>>2]=n,k=w2(r),t[e+139|0]=0,t[e+138|0]=k&31|96,t[e+136|0]=k>>>10|96,t[e+137|0]=k>>>5&31|96,e=i[r+16>>2],e=e>>>0>=2?2:e,k=i[r+8>>2],k&&l4(k,e),k=i[r>>2],o=W[i[i[k>>2]+8>>2]](k)|0,n=h0,o=e+o|0,n=e>>>0>o>>>0?n+1|0:n,W[i[i[k>>2]+20>>2]](k,o,n)|0,i[r+16>>2]=i[r+16>>2]-e,u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function pX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;k=v-32|0,v=k,e=i[e>>2],n=i[e+48>>2],e=i[e+52>>2];i:{if(!e){j1(k+24|0,n,r);break i}if(i[e+4>>2]=i[e+4>>2]+1,j1(k+24|0,n,r),r=i[e+4>>2],i[e+4>>2]=r-1,r)break i;W[i[i[e>>2]+8>>2]](e),y(e)}i:{n=i[k+24>>2];e:{if(!n){i[A>>2]=1,i[A+4>>2]=2e3,i[A+8>>2]=3757;break e}if(e=l2(f),e>>>0>=2147483640)break i;r:{f:{if(e>>>0>=11){o=e|7,r=C(o+1|0),i[k+20>>2]=o-2147483647,i[k+12>>2]=r,i[k+16>>2]=e;break f}if(t[k+23|0]=e,r=k+12|0,!e)break r}if(!e)break r;z(r,f,e)}t[e+r|0]=0,e=n+116|0;r:{if((e|0)==(k+12|0))break r;if(r=t[k+23|0],t[n+127|0]>=0){if((r|0)>=0){r=i[k+16>>2],i[e>>2]=i[k+12>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+20>>2];break r}m1(e,i[k+12>>2],i[k+16>>2]);break r}f=e,e=(r|0)<0,R1(f,e?i[k+12>>2]:k+12|0,e?i[k+16>>2]:r)}t[k+23|0]<0&&Z(i[k+12>>2]),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}A=i[k+28>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}v=k+32|0;return}I0(),M()}function FX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0,E=0,R=0,N=0,U=0,x=0,j=0,O=0,S=0,q=0,d=0,c=0,A0=0;f=g(r,6)+e|0,B=p[f+6>>1],s=p[e+6>>1],h=p[e+2>>1],k=s+h|0,m=p[e+4>>1],w=p[e>>1],o=m+w|0,l=k+o|0,n=(r<<2)+e|0,G=p[n+6>>1],I=p[n+2>>1],Q=G+I|0,Y=p[n>>1],n=p[n+4>>1],V=Y+n|0,_=Q+V|0,E=l-_|0,e=(r<<1)+e|0,r=p[e+6>>1],R=p[e+2>>1],N=r+R|0,U=p[e+4>>1],e=p[e>>1],x=U+e|0,j=N+x|0,O=p[f+2>>1],S=B+O|0,q=p[f+4>>1],f=p[f>>1],d=q+f|0,c=S+d|0,A0=j-c|0,X[A+24>>1]=E-A0,X[A+16>>1]=E+A0,l=l+_|0,_=j+c|0,X[A+8>>1]=l-_,X[A>>1]=l+_,k=o-k|0,o=V-Q|0,l=k-o|0,Q=x-N|0,V=d-S|0,_=Q-V|0,X[A+26>>1]=l-_,X[A+18>>1]=l+_,k=k+o|0,o=Q+V|0,X[A+10>>1]=k-o,X[A+2>>1]=k+o,s=h-s|0,h=w-m|0,k=s+h|0,m=I-G|0,n=Y-n|0,w=m+n|0,o=k-w|0,r=R-r|0,e=e-U|0,l=r+e|0,B=O-B|0,f=f-q|0,G=B+f|0,I=l-G|0,X[A+28>>1]=o-I,X[A+20>>1]=o+I,k=k+w|0,w=l+G|0,X[A+12>>1]=k-w,X[A+4>>1]=k+w,s=h-s|0,n=n-m|0,h=s-n|0,e=e-r|0,r=f-B|0,f=e-r|0,X[A+30>>1]=h-f,X[A+22>>1]=f+h,f=n+s|0,e=e+r|0,X[A+14>>1]=f-e,X[A+6>>1]=e+f}function Jt(A){var e=0,r=0,f=0,k=0,n=0,o=0;if(n=1,f=i[A>>2],o=i[A+4>>2],(f|0)!=(o|0))for(;;){A=i[f>>2];i:{if(!A)break i;e:{r:{if(Z0(A,92792,94104)){if(A=i[f+4>>2],!A)break e;if(i[A+4>>2]==-1)break r;break e}if(!Z0(A,92792,94184))break i;if(A=i[f+4>>2],!A|i[A+4>>2]!=-1)break e}W[i[i[A>>2]+8>>2]](A),y(A)}A=i[f>>2];e:{r:{if(!A)break r;f:{A:{k:{n:{if(r=Z0(A,92792,94104),!r){if(k=Z0(A,92792,94184),!k)break r;switch(e=i[f+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),A=2,r=0,i[k+100>>2]+1|0){case 0:break k;case 1:break n;case 2:break f;default:break A}}e=i[f+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),r=i[r+100>>2],A=8;t:{if((r|0)==90)break t;o:{if((r|0)!=270){if((r|0)!=180)break o;A=3;break t}A=6;break t}A=1}if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;W[i[i[e>>2]+8>>2]](e),y(e);break e}A=4;break f}A=1;break f}r=1}f:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break f;W[i[i[e>>2]+8>>2]](e),y(e)}if(!r)break e}A=1}n=cs(n,A)}if(f=f+8|0,(o|0)==(f|0))break}return n}function CX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0;k=v-16|0,v=k;i:{e:{r:{f:{if(!(i[r>>2]!=1|i[r+4>>2]!=3)&&(o=i[r+12>>2],(o|0)>8))break f;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break r}f:{if(u[r+8|0]==1){if(r=i[r+16>>2],e=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(r|0)!=(o|0)&&r)break r;r=0;break f}e=C(32),i[e+28>>2]=11,t[e+26|0]=1,X[e+24>>1]=2,i[e+16>>2]=0,i[e+20>>2]=131074,i[e+12>>2]=o,t[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=12,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}if(f=r-e|0,s=f>>5,r=s+1|0,r>>>0>=134217728)break e;if(n=f>>>4|0,l=f>>>0>=2147483616?134217727:r>>>0<n>>>0?n:r,l){if(l>>>0>=134217728)break i;r=C(l<<5)}else r=0;n=r+f|0,t[n+8|0]=1,i[n>>2]=1,i[n+4>>2]=13,h=u[k+13|0]|u[k+14|0]<<8,t[n+9|0]=h,t[n+10|0]=h>>>8,t[n+11|0]=u[k+15|0],i[n+28>>2]=11,t[n+26|0]=1,X[n+24>>1]=2,i[n+16>>2]=0,i[n+20>>2]=131074,i[n+12>>2]=o,o=n-(s<<5)|0,f&&z(o,e,f),i[A+8>>2]=(l<<5)+r,r=n+32|0,i[A+4>>2]=r,i[A>>2]=o,e&&Z(e),i[A+4>>2]=r}v=k+16|0;return}s0(),M()}x0(),M()}function M8(A,e,r,f,k,n,o,l,s,h,w){var _=0;i:{e:{r:{f:{A:{if(!((e+f|0)<=(h|0)|(e|0)>(h|0)|(r|0)>(w|0))&&(r+f|0)>(w|0))break A;if(f=0,(h|w)<0||(e=i[A+124>>2],i[e+484>>2]<=(h|0)|i[e+488>>2]<=(w|0))||(o=i[A+132>>2],l=i[o+8496>>2],r=i[e+16936>>2],s=i[e+16924>>2],i[(l+(h>>>r<<2)|0)+(g(s,w>>>r|0)<<2)>>2]>i[(l+(k>>r<<2)|0)+(g(s,n>>r)<<2)>>2])||(l=i[A+140>>2],r=i[e+16876>>2],k=k>>r,s=i[A+152>>2],n=n>>r,_=h>>>r|0,r=w>>>r|0,p[(l+g(k,24)|0)+g(g(s,n),24)>>1]!=p[(l+g(_,24)|0)+g(g(r,s),24)>>1]))break r;if(l=k<<2,k=i[o+8484>>2],e=i[e+16892>>2],i[(l+k|0)+(g(e,n)<<2)>>2]==i[(k+(_<<2)|0)+(g(e,r)<<2)>>2])break f;break r}if(o<<1!=(f|0)|l<<1!=(f|0)|((s|0)!=1|(r+l|0)>(w|0)))break f;if(f=0,(e+o|0)>(h|0))break r}if(r=i[A+168>>2],e=h>>r,(e|0)<0||(f=i[A+172>>2],(f|0)<=(e|0)))break e;if(r=w>>r,(r|0)<0|(r|0)>=i[A+176>>2])break i;f=(u[((i[A+160>>2]+g(e,3)|0)+g(g(r,f),3)|0)+1|0]&3)!=0}return f}U0(5068,11972,118,4625),M()}U0(5030,11972,119,4625),M()}function YX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=78468,n=i[19620],i[f+20>>2]=n,k=i[n-12>>2],n=f+20|0,i[k+n>>2]=i[19621],o=n+i[i[f+20>>2]-12>>2]|0,k=f+24|0,J0(o,k),t[o+80|0]=0,i[o+72>>2]=0,i[f+76>>2]=78468,i[f+20>>2]=78448,o=R0(k),i[o>>2]=77200,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,k=f+8|0,K1(k,e,r),e=t[f+19|0],r=(e|0)<0,F(n,r?i[f+8>>2]:k,r?i[f+12>>2]:e),t[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){e=i[f+68>>2],r=i[f+48>>2],e>>>0<r>>>0&&(i[f+68>>2]=r,e=r),r=f+44|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+40>>2],r=f+32|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,n,e)}t[A+e|0]=0,A=i[19619],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[19622],i[o>>2]=77200,t[f+67|0]<0&&Z(i[f+56>>2]),y0(o),Y0(f+76|0),v=f+160|0}function J2(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=78468,n=i[19620],i[f+20>>2]=n,k=i[n-12>>2],n=f+20|0,i[k+n>>2]=i[19621],o=n+i[i[f+20>>2]-12>>2]|0,k=f+24|0,J0(o,k),t[o+80|0]=0,i[o+72>>2]=0,i[f+76>>2]=78468,i[f+20>>2]=78448,o=R0(k),i[o>>2]=77200,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,k=f+8|0,k3(k,e,r),e=t[f+19|0],r=(e|0)<0,F(n,r?i[f+8>>2]:k,r?i[f+12>>2]:e),t[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){e=i[f+68>>2],r=i[f+48>>2],e>>>0<r>>>0&&(i[f+68>>2]=r,e=r),r=f+44|0;break e}if(!(e&8)){e=0,t[A+11|0]=0;break i}e=i[f+40>>2],r=f+32|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,n,e)}t[A+e|0]=0,A=i[19619],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[19622],i[o>>2]=77200,t[f+67|0]<0&&Z(i[f+56>>2]),y0(o),Y0(f+76|0),v=f+160|0}function OA(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;k=v-32|0,v=k;i:{if(!f){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=47881;break i}$1(k+24|0,i[e>>2],r,1);e:{r:{if(n=i[k+24>>2],n){if(o=Z0(n,107564,100652),!o)break r;if(r=i[k+28>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),f=k+4|0,W[i[i[o>>2]+88>>2]](f,o),c0(A,f,i[e>>2]),t[k+23|0]<0&&Z(i[k+12>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;W[i[i[r>>2]+8>>2]](r),y(r);break e}i[f>>2]=0,i[A+8>>2]=47881,i[A>>2]=5,i[A+4>>2]=2e3;break e}r=C(16),i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,f=i[k+28>>2],i[k+24>>2]=0,i[k+28>>2]=0,i[r+4>>2]=f,i[r>>2]=n,n=i[e>>2],f=i[e+4>>2];r:{if(!f){i[r+12>>2]=f,i[r+8>>2]=n;break r}if(i[f+4>>2]=i[f+4>>2]+1,i[r+8>>2]=n,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}if(A=i[k+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=k+32|0}function Ci(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0;k=v-32|0,v=k,o=i[e>>2];i:{e:{r:{f:{if(!u[e+16|0]){if(l=c3(o,f),n=0,!l)break r;if(n=i[e+36>>2],e=i[e+32>>2],n-e>>3>>>0<=f>>>0){i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}f=e+(f<<3)|0,e=i[f>>2],f=i[f+4>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0;break f}if(l=c3(o,0),o=i[e+24>>2],e=i[e+28>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,n=0,!l)break r;n=L0(l,0,f,0),f=e+h0|0,e=o+n|0,f=o>>>0>e>>>0?f+1|0:f}if(S9(k,r,k+20|0,e,f,l),i[k>>2]){if(e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,e=A+8|0,t[k+19|0]>=0){r=i[k+12>>2],i[e>>2]=i[k+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+16>>2],t[A+20|0]=1;break e}if(T(e,i[k+8>>2],i[k+12>>2]),e=t[k+19|0],t[A+20|0]=1,(e|0)>=0)break e;Z(i[k+8>>2]);break e}t[k+19|0]<0&&Z(i[k+8>>2]),s=i[k+28>>2],h=i[k+20>>2],n=i[k+24>>2]}i[k+24>>2]=0,i[k+28>>2]=0,t[A+20|0]=0,i[A+8>>2]=s,i[A+4>>2]=n,i[A>>2]=h;break i}if(A=i[k+20>>2],!A)break i;i[k+24>>2]=A,Z(A)}v=k+32|0}function yX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{e:{if(u[e+97|0]){B1(A,e,21530);break e}if(p4(f+20|0,r),t[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],i[r+16>>2])for(;;){h=Q2(r),k=i[e+120>>2],n=i[e+124>>2];r:{if(k>>>0<n>>>0){t[k|0]=h,k=k+1|0;break r}if(l=i[e+116>>2],k=k-l|0,o=k+1|0,(o|0)<0)break i;if(n=n-l|0,s=n<<1,n=n>>>0>=1073741823?2147483647:o>>>0<s>>>0?s:o,n?o=C(n):o=0,s=o+k|0,t[s|0]=h,k&&z(o,l,k),i[e+124>>2]=n+o,k=s+1|0,i[e+120>>2]=k,i[e+116>>2]=o,!l)break r;Z(l)}if(i[e+120>>2]=k,!i[r+16>>2])break}if(u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break e;Z(i[f+20>>2]);break e}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731])}v=f+32|0;return}s0(),M()}function EX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0;n=v-32|0,v=n;i:{e:{if((l2(r)|0)!=4){e=i[25781],i[A>>2]=i[25780],i[A+4>>2]=e,i[A+8>>2]=i[25782];break e}if(o=u[r|0]|u[r+1|0]<<8|(u[r+2|0]<<16|u[r+3|0]<<24),i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,V4(n+20|0,0,f,f+k|0,k),r=C(32),i[r+28>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+16>>2]=o<<24|(o&65280)<<8|(o>>>8&65280|o>>>24),i[r+12>>2]=101780,i[r>>2]=101940,i[r+4>>2]=0,i[r+8>>2]=0,f=i[n+24>>2],k=i[n+20>>2],(f|0)!=(k|0)){if(f=f-k|0,(f|0)<0)break i;o=C(f),i[r+20>>2]=o,l=f+o|0,i[r+28>>2]=l,f&&z(o,k,f),i[r+24>>2]=l}e=i[e>>2],i[n+16>>2]=r,i[n+12>>2]=r+12,i[r+4>>2]=i[r+4>>2]+1,W[i[i[e>>2]+12>>2]](e,n+12|0),e=i[n+16>>2];r:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[r+4>>2],i[r+4>>2]=A-1,A||(W[i[i[r>>2]+8>>2]](r),y(r)),A=i[n+20>>2],!A)break e;i[n+24>>2]=A,Z(A)}v=n+32|0;return}s0(),M()}function PA(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0;i:{r=i[A+18592>>2];e:{r:{if(u[r+20|0]){if(e=i[A+18588>>2],n=i[e+52>>2],k=i[e+132>>2],r=i[r+24>>2],f=p[(i[e+140>>2]+g(i[(i[k+8460>>2]+(i[i[k+8448>>2]+(r<<2)>>2]<<2)|0)-4>>2],24)|0)+2>>1],f>>>0>=i[e+56>>2]-n>>2>>>0)break e;if(n=i[n+(f<<2)>>2],f=i[i[e+124>>2]+16892>>2],e=(r|0)/(f|0)|0,Kl(k,r-g(e,f)|0,e)){if(e=i[A+18592>>2],r=i[e+804>>2],r>>>0>=3)break i;Ge(A+18572|0,r,i[e+800>>2]),t[A+18580|0]=0,t[A+18581|0]=0,t[A+18582|0]=0,t[A+18583|0]=0;break r}if(e=i[A+18596>>2],r=i[e+424>>2],k=i[e+428>>2]-r>>2,k>>>0<2)break e;for(f=i[A+18600>>2],e=1;;){if(o=r+(e<<2)|0,(f|0)!=i[o>>2]){if(e=e+1|0,(k|0)!=(e|0))continue;break e}break}if(e=i[o-4>>2],!e||(vh(e+44|0,i[e+120>>2]),u[n+1348|0]!=1))break e;e=A+18572|0,A=n+1340|0,Di(e,A),Qu(A);break r}if(e=i[r+804>>2],e>>>0>=3)break i;Ge(A+18572|0,e,i[r+800>>2]),t[A+18580|0]=0,t[A+18581|0]=0,t[A+18582|0]=0,t[A+18583|0]=0}l=1}return l}U0(23510,19977,1520,5620),M()}function w3(A,e,r,f){var k=0,n=0,o=0,l=0;k=i[r+4>>2],l=i[e+4>>2];i:{if((l|0)<=i[A+4>>2]){if((k|0)<=(l|0)||(n=i[e>>2],k=i[e+4>>2],o=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=o,i[r>>2]=n,i[r+4>>2]=k,i[e+4>>2]<=i[A+4>>2]))break i;n=i[A>>2],k=i[A+4>>2],o=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=o,i[e>>2]=n,i[e+4>>2]=k,k=i[r+4>>2];break i}if(o=i[A>>2],n=i[A+4>>2],(k|0)>(l|0)){k=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=k,i[r>>2]=o,i[r+4>>2]=n,k=n;break i}if(k=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=k,i[e>>2]=o,i[e+4>>2]=n,k=i[r+4>>2],(n|0)>=(k|0))break i;k=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=k,i[r>>2]=o,i[r+4>>2]=n,k=n}i:{if(i[f+4>>2]<=(k|0)||(n=i[r>>2],k=i[r+4>>2],o=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=o,i[f>>2]=n,i[f+4>>2]=k,i[r+4>>2]<=i[e+4>>2])||(f=i[e>>2],n=i[e+4>>2],k=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=k,i[r>>2]=f,i[r+4>>2]=n,i[e+4>>2]<=i[A+4>>2]))break i;r=i[A>>2],f=i[A+4>>2],n=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=n,i[e>>2]=r,i[e+4>>2]=f}}function Nt(A,e){var r=0,f=0,k=0,n=0,o=0;f=v-288|0,v=f,k=f+16|0,n=f+284|0,W[i[i[A>>2]+48>>2]](k,i[e+4>>2],n),W[i[i[A>>2]+44>>2]](k,i[A+4>>2],i[f+284>>2]),W[i[i[A>>2]+56>>2]](k,i[e+4>>2],n),W[i[i[A>>2]+52>>2]](k,i[A+4>>2],i[f+284>>2]),r=i[A>>2],o=i[r+64>>2],!o|!i[r+60>>2]||(W[o|0](k,i[e+4>>2],n),W[i[i[A>>2]+60>>2]](k,i[A+4>>2],i[f+284>>2]),r=i[A>>2]),n=W[i[r+68>>2]](i[e+4>>2])|0;i:{if(!n||(r=i[n>>2],!r))break i;for(;;){k=i[r+4>>2];e:{r:switch(i[r+8>>2]-1|0){case 0:if(r=f+16|0,W[i[i[A>>2]+76>>2]](r,i[e+4>>2],k,f+4|0),i[f+16>>2])break e;W[i[i[A>>2]+72>>2]](r,i[A+4>>2],k,i[f+4>>2]);break e;case 1:if(r=f+16|0,W[i[i[A>>2]+84>>2]](r,i[e+4>>2],k,f+4|0),i[f+16>>2])break e;W[i[i[A>>2]+80>>2]](r,i[A+4>>2],k,i[f+4>>2]);break e;case 2:break r;default:break e}if(r=f+4|0,o=f+16|0,W[i[i[A>>2]+92>>2]](r,i[e+4>>2],k,o,256),i[f+4>>2])break e;W[i[i[A>>2]+88>>2]](r,i[A+4>>2],k,o)}if(r=i[n+4>>2],n=n+4|0,!r)break}}v=f+288|0}function RX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;k=v-16|0,v=k;i:{e:{r:{if(!(!(i[r>>2]!=1|i[r+4>>2]!=3)&i[r+12>>2]==8)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break r}f:{if(u[r+8|0]==1){if(r=i[r+16>>2],e=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r&-9)break r;r=0;break f}e=C(32),i[e+28>>2]=11,t[e+26|0]=1,X[e+24>>1]=2,i[e+20>>2]=131074,i[e+12>>2]=8,i[e+16>>2]=0,t[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=12,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}if(f=r-e|0,o=f>>5,r=o+1|0,r>>>0>=134217728)break e;if(n=f>>>4|0,l=f>>>0>=2147483616?134217727:r>>>0<n>>>0?n:r,l){if(l>>>0>=134217728)break i;r=C(l<<5)}else r=0;n=r+f|0,t[n+8|0]=1,i[n>>2]=1,i[n+4>>2]=13,s=u[k+13|0]|u[k+14|0]<<8,t[n+9|0]=s,t[n+10|0]=s>>>8,t[n+11|0]=u[k+15|0],i[n+28>>2]=11,t[n+26|0]=1,X[n+24>>1]=2,i[n+20>>2]=131074,i[n+12>>2]=8,i[n+16>>2]=0,o=n-(o<<5)|0,f&&z(o,e,f),i[A+8>>2]=(l<<5)+r,r=n+32|0,i[A+4>>2]=r,i[A>>2]=o,e&&Z(e),i[A+4>>2]=r}v=k+16|0;return}s0(),M()}x0(),M()}function JX(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0;r=i[A+16>>2],k=i[r+18588>>2],o=i[k+124>>2],l=i[o+16892>>2],i[A+4>>2]=1,i[k+324>>2]=i[k+324>>2]-1,i[k+328>>2]=i[k+328>>2]+1,f=i[r+18588>>2],n=i[f+124>>2],e=i[n+16908>>2],s=i[r+4>>2],(e|0)>(s|0)&&(e=i[i[i[f+132>>2]+8460>>2]+(s<<2)>>2]),f=i[n+16892>>2],i[r>>2]=e,n=(e|0)/(f|0)|0,i[r+12>>2]=n,i[r+8>>2]=e-g(f,n),f=(e|0)/(l|0)|0;i:{e:{if(u[A+8|0]!=1||PA(r))break e;if((l|0)<=0)break i;for(e=0,f=g(g(f,l),76);o=(f+i[k+320>>2]|0)+g(e,76)|0,i[o>>2]<=0&&(i[o>>2]=1),e=e+1|0,(l|0)!=(e|0););break i}if(rr(r+18548|0),Sr(r,1,!(u[A+8|0]!=1||u[i[r+18592>>2]+20|0])),(f|0)!=i[r+12>>2]||(e=i[r+8>>2],n=i[o+16892>>2],(e|0)>=(n|0)))break i;for(l=g(g(f,l),76);i[o+16892>>2]<=(e|0)|(f|0)>=i[o+16900>>2]||(s=(l+i[k+320>>2]|0)+g(e,76)|0,i[s>>2]<=0&&(i[s>>2]=1)),e=e+1|0,(n|0)!=(e|0););}i[A+4>>2]=3,A=i[r+18600>>2],i[A+44>>2]=i[A+44>>2]+1,ff(k)}function NX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;k=v-16|0,v=k;i:{e:{r:{if(!(!(i[r+4>>2]|i[r>>2]!=2)&i[r+12>>2]==8)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break r}f:{if(u[r+8|0]==1){if(r=i[r+16>>2],e=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r&-9)break r;r=0;break f}e=C(32),i[e+28>>2]=11,t[e+26|0]=1,X[e+24>>1]=2,i[e+20>>2]=131074,i[e+12>>2]=8,i[e+16>>2]=0,t[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=10,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}if(f=r-e|0,o=f>>5,r=o+1|0,r>>>0>=134217728)break e;if(n=f>>>4|0,l=f>>>0>=2147483616?134217727:r>>>0<n>>>0?n:r,l){if(l>>>0>=134217728)break i;r=C(l<<5)}else r=0;n=r+f|0,t[n+8|0]=1,i[n>>2]=1,i[n+4>>2]=11,s=u[k+13|0]|u[k+14|0]<<8,t[n+9|0]=s,t[n+10|0]=s>>>8,t[n+11|0]=u[k+15|0],i[n+28>>2]=11,t[n+26|0]=1,X[n+24>>1]=2,i[n+20>>2]=131074,i[n+12>>2]=8,i[n+16>>2]=0,o=n-(o<<5)|0,f&&z(o,e,f),i[A+8>>2]=(l<<5)+r,r=n+32|0,i[A+4>>2]=r,i[A>>2]=o,e&&Z(e),i[A+4>>2]=r}v=k+16|0;return}s0(),M()}x0(),M()}function DX(){var A=0,e=0,r=0,f=0;i:{e:{r:switch(A=i[28754],A|0){case 0:break i;case 1:break r;default:break e}if(A=i[28738],(A|0)!=114956)for(;;){e=i[i[A+16>>2]+12>>2],e&&W[e|0](),e=i[A+4>>2];r:{if(e){for(;;)if(A=e,e=i[A>>2],!e)break r}for(;e=A,A=i[A+8>>2],(e|0)!=i[A>>2];);}if((A|0)==114956)break}if(wf(114952,i[28739]),i[28738]=114956,i[28739]=0,i[28740]=0,A=i[28741],(A|0)!=114968)for(;;){e=i[i[i[A+16>>2]>>2]+32>>2],e&&W[e|0](),e=i[A+4>>2];r:{if(e){for(;;)if(A=e,e=i[A>>2],!e)break r}for(;e=A,A=i[A+8>>2],(e|0)!=i[A>>2];);}if((A|0)==114968)break}if(nf(114964,i[28742]),i[28741]=114968,i[28742]=0,i[28743]=0,t[115020]=1,A=i[28783],r=i[28782],(A|0)!=(r|0))for(;;){e=i[A-4>>2];r:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(r|0)==(A|0))break}i[28783]=r,A=i[28754]}i[28754]=A-1}}function o8(A,e,r,f){var k=0,n=0,o=0,l=0;if(l=v-16|0,v=l,n=i[A+80>>2],!n){k=C(136),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=96548,n=k+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=92500,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,X[k+112>>1]=0,i[n>>2]=94284,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1769104742,i[A+80>>2]=n,o=i[A+84>>2],i[A+84>>2]=k;i:{e:{if(!o){o=i[A+44>>2],i[l+12>>2]=k,i[l+8>>2]=n;break e}if(n=i[o+4>>2],i[o+4>>2]=n-1,n||(W[i[i[o>>2]+8>>2]](o),y(o)),o=i[A+44>>2],n=i[A+80>>2],k=i[A+84>>2],i[l+12>>2]=k,i[l+8>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}P0(o+36|0,l+8|0),o=i[l+12>>2];i:{if(!o||(n=i[o+4>>2],i[o+4>>2]=n-1,n))break i;W[i[i[o>>2]+8>>2]](o),y(o)}n=i[A+80>>2]}C3(n,e,r,f),v=l+16|0}function UX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;i:{if(i[r>>2]==1&&(f=12,n=i[r+4>>2],(n&-4)==12))break i;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}e=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0;i:switch(n-12|0){case 0:f=14;case 2:k=i[r+12>>2],e=C(32),i[e+28>>2]=11,t[e+26|0]=1,X[e+24>>1]=2,i[e+16>>2]=0,i[e+20>>2]=131074,i[e+12>>2]=k,t[e+8|0]=0,i[e+4>>2]=f,i[e>>2]=1,k=e+32|0,i[A+8>>2]=k,i[A>>2]=e,i[A+4>>2]=k;break;default:break i}o=13;i:{e:{r:switch(n-13|0){case 0:o=15;case 2:if(f=k-e|0,l=f>>5,k=l+1|0,k>>>0>=134217728)break e;if(s=i[r+12>>2],r=f>>>4|0,n=f>>>0>=2147483616?134217727:r>>>0>k>>>0?r:k,n){if(n>>>0>=134217728)break i;r=C(n<<5)}else r=0;k=f+r|0,i[k+28>>2]=11,t[k+26|0]=1,X[k+24>>1]=2,i[k+16>>2]=0,i[k+20>>2]=131074,i[k+12>>2]=s,t[k+8|0]=1,i[k+4>>2]=o,i[k>>2]=1,o=k-(l<<5)|0,f&&z(o,e,f),i[A+8>>2]=(n<<5)+r,i[A>>2]=o,e&&Z(e),i[A+4>>2]=k+32;break;default:break r}return}s0(),M()}x0(),M()}function Z0(A,e,r){var f=0,k=0,n=0,o=0,l=0;o=v-16|0,v=o,k=i[A>>2],n=i[k-8>>2],i[o+12>>2]=n,i[o+4>>2]=A+n,i[o+8>>2]=i[k-4>>2],n=i[o+8>>2],k=i4(n,r,0),l=i[o+4>>2];i:{if(k){A=v+-64|0,v=A,v=A- -64|0,f=i[o+12>>2]?0:l;break i}if(k=v+-64|0,v=k,(A|0)>=(l|0)&&(i[k+28>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+16>>2]=0,i[k+12>>2]=r,i[k+4>>2]=n,i[k+60>>2]=0,i[k+52>>2]=1,i[k+56>>2]=16777216,i[k+8>>2]=A,W[i[i[n>>2]+20>>2]](n,k+4|0,l,l,1,0),f=i[k+28>>2]?A:0),v=k- -64|0,f)break i;f=v+-64|0,v=f,i[f+16>>2]=0,i[f+12>>2]=e,i[f+8>>2]=A,i[f+4>>2]=r,A=0,l0(f+20|0,0,39),i[f+60>>2]=0,t[f+59|0]=1,W[i[i[n>>2]+24>>2]](n,f+4|0,l,1,0);e:{r:switch(i[f+40>>2]){case 0:A=i[f+44>>2]==1&&i[f+32>>2]==1&&i[f+36>>2]==1?i[f+24>>2]:0;break e;case 1:break r;default:break e}if(i[f+28>>2]!=1&&i[f+44>>2]|i[f+32>>2]!=1|i[f+36>>2]!=1)break e;A=i[f+20>>2]}v=f- -64|0,f=A}return v=o+16|0,f}function MX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;f=v-16|0,v=f,k=i[e+12>>2],l=k,n=i[e+8>>2];i:{e:{if(!(k|n)){for(e=r;i[e+16>>2]=0,e=i[e+8>>2],!!e;);break e}if(o=i[e+32>>2],k=n-o|0,n=l-(n>>>0<o>>>0)|0,!n&k>>>0>=2147483648|n){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,101,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(!w4(r,k)||(n=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),l=i[e+8>>2],o=i[e+32>>2],s=l-o|0,e=i[e+12>>2]-(l>>>0<o>>>0)|0,o=W[i[i[n>>2]+8>>2]](n)|0,l=o+s|0,e=h0+e|0,W[i[i[n>>2]+20>>2]](n,l,l>>>0<o>>>0?e+1|0:e)|0,!k)||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break e;W[i[i[k>>2]+8>>2]](k),y(k)}if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function Dt(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:{e:{for(;;){r:{if(r>>>0>=f>>>0){n=0;break r}if(n=2,e=i[r>>2],e>>>0>1114111|(e&-2048)==55296)break r;f:{if(e>>>0<=127){if(n=1,r=i[A+8>>2],(o-r|0)<=0)break r;i[A+8>>2]=r+1,t[r|0]=e;break f}if(e>>>0<=2047){if(r=i[A+8>>2],(o-r|0)<2)break e;i[A+8>>2]=r+1,t[r|0]=e>>>6|192,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e&63|128;break f}if(r=i[A+8>>2],n=o-r|0,e>>>0<=65535){if((n|0)<3)break e;i[A+8>>2]=r+1,t[r|0]=e>>>12|224,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e>>>6&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e&63|128;break f}if((n|0)<4)break e;i[A+8>>2]=r+1,t[r|0]=e>>>18|240,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e>>>12&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e>>>6&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,t[r|0]=e&63|128}r=i[A+12>>2]+4|0,i[A+12>>2]=r;continue}break}break i}n=1}return i[k>>2]=i[A+12>>2],i[l>>2]=i[A+8>>2],v=A+16|0,n|0}function HX(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;m=n+7|0,G=n+4|0;i:{if((G|0)>=-2){if((k|0)<=0)break i;for(Q=o+6|0,V=k&2147483644,I=k&3,B=-3,Y=k>>>0<4;;){if(h=(B<<1)+Q|0,s=(g(f,B)<<1)+r|0,w=0,!Y)for(;X[h>>1]=p[s>>1],_=h,h=m<<1,_=_+h|0,X[_>>1]=p[s+2>>1],_=h+_|0,X[_>>1]=p[s+4>>1],_=h+_|0,X[_>>1]=p[s+6>>1],h=h+_|0,s=s+8|0,w=w+4|0,(V|0)!=(w|0););if(w=0,I)for(;X[h>>1]=p[s>>1],s=s+2|0,h=(m<<1)+h|0,w=w+1|0,(I|0)!=(w|0););if(B=B+1|0,(G|0)==(B|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(f=l-8|0,r=0,e=e<<1;;){for(h=(r<<1)+A|0,s=(g(r,m)<<1)+o|0,w=0;X[h>>1]=(((((X[s+2>>1]<<2)-X[s>>1]|0)+g(X[s+8>>1]+X[s+6>>1]|0,40)|0)+(X[s+12>>1]<<2)|0)-X[s+14>>1]|0)+g(X[s+10>>1]+X[s+4>>1]|0,-11)>>f,s=s+2|0,h=e+h|0,w=w+1|0,(w|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function zX(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;m=n+6|0,G=n+3|0;i:{if((G|0)>=-2){if((k|0)<=0)break i;for(Q=o+6|0,V=k&2147483644,I=k&3,B=-3,Y=k>>>0<4;;){if(h=(B<<1)+Q|0,s=(g(f,B)<<1)+r|0,w=0,!Y)for(;X[h>>1]=p[s>>1],_=h,h=m<<1,_=_+h|0,X[_>>1]=p[s+2>>1],_=h+_|0,X[_>>1]=p[s+4>>1],_=h+_|0,X[_>>1]=p[s+6>>1],h=h+_|0,s=s+8|0,w=w+4|0,(V|0)!=(w|0););if(w=0,I)for(;X[h>>1]=p[s>>1],s=s+2|0,h=(m<<1)+h|0,w=w+1|0,(I|0)!=(w|0););if(B=B+1|0,(G|0)==(B|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(f=l-8|0,r=0,e=e<<1;;){for(h=(r<<1)+A|0,s=(g(r,m)<<1)+o|0,w=0;X[h>>1]=X[s+12>>1]+((((((X[s+2>>1]<<2)-X[s>>1]|0)+g(X[s+4>>1],-10)|0)+g(X[s+6>>1],58)|0)+g(X[s+8>>1],17)|0)+g(X[s+10>>1],-5)|0)>>f,s=s+2|0,h=e+h|0,w=w+1|0,(w|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function xX(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;m=n+6|0,G=n+4|0;i:{if((G|0)>=-1){if((k|0)<=0)break i;for(Q=o+4|0,V=k&2147483644,I=k&3,B=-2,Y=k>>>0<4;;){if(h=(B<<1)+Q|0,s=(g(f,B)<<1)+r|0,w=0,!Y)for(;X[h>>1]=p[s>>1],_=h,h=m<<1,_=_+h|0,X[_>>1]=p[s+2>>1],_=h+_|0,X[_>>1]=p[s+4>>1],_=h+_|0,X[_>>1]=p[s+6>>1],h=h+_|0,s=s+8|0,w=w+4|0,(V|0)!=(w|0););if(w=0,I)for(;X[h>>1]=p[s>>1],s=s+2|0,h=(m<<1)+h|0,w=w+1|0,(I|0)!=(w|0););if(B=B+1|0,(G|0)==(B|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(f=l-8|0,r=0,e=e<<1;;){for(h=(r<<1)+A|0,s=(g(r,m)<<1)+o|0,w=0;X[h>>1]=(((((X[s>>1]+g(X[s+2>>1],-5)|0)+g(X[s+4>>1],17)|0)+g(X[s+6>>1],58)|0)+g(X[s+8>>1],-10)|0)+(X[s+10>>1]<<2)|0)-X[s+12>>1]>>f,s=s+2|0,h=e+h|0,w=w+1|0,(w|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function Ut(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0;o=v-32|0,v=o,n=f&65535,l=f>>>16&32767;i:{if(l-16257>>>0<=253){k=(n&33554431)<<7|r>>>25,n=0,r=r&33554431;e:{if(!(!n&(r|0)==16777216?!(A|e):!n&r>>>0<16777216)){k=k+1|0;break e}if(r^16777216|A|(e|n))break e;k=(k&1)+k|0}A=k>>>0>8388607,k=A?0:k,A=l+(A?-16255:-16256)|0;break i}if(!(!(A|r|(e|n))|((l|0)!=32767|(k|0)!=0))){k=(n&33554431)<<7|r>>>25|4194304,A=255;break i}if(l>>>0>16510){A=255;break i}if(k=!(k|l),h=k?16256:16257,s=h-l|0,(s|0)>112){k=0,A=0;break i}n=k?n:n|65536,g4(o+16|0,A,e,r,n,128-s|0),I6(o,A,e,r,n,s),A=i[o+8>>2],k=(i[o+12>>2]&33554431)<<7|A>>>25,r=i[o>>2]|(l|0)!=(h|0)&(i[o+16>>2]|i[o+24>>2]|(i[o+20>>2]|i[o+28>>2]))!=0,n=i[o+4>>2],e=0,A=A&33554431;e:{if(!(!e&(A|0)==16777216?!(r|n):!e&A>>>0<16777216)){k=k+1|0;break e}if(A^16777216|r|(e|n))break e;k=(k&1)+k|0}A=k>>>0>8388607,k=A?k^8388608:k}return v=o+32|0,T2(2,f&-2147483648|A<<23|k),t8()}function TX(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0;h=v-48|0,v=h;i:{if(!s||!e|!l){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!(f|!r)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!(o&&n)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=26580;break i}if(w=h+24|0,i[w>>2]=0,i[w+4>>2]=0,i[h+32>>2]=0,i[h+36>>2]=0,i[h+40>>2]=0,i[h+44>>2]=0,t[h+5|0]=0,t[h+6|0]=0,t[h+7|0]=0,t[h+8|0]=0,t[h+9|0]=0,t[h+10|0]=0,t[h+11|0]=0,t[h+12|0]=0,i[h>>2]=0,i[h+4>>2]=0,i[h+16>>2]=0,i[h+20>>2]=0,h1(h,f,(r<<2)+f|0,r),t[h+12|0]=(k|0)!=0,i[h+16>>2]=n,i[h+20>>2]=o,r=g(n,o),f=r<<2,h1(w,l,f+l|0,r),h1(h+36|0,s,f+s|0,r),e=i[e>>2],W[i[i[e>>2]+64>>2]](e,h),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,A=i[h+36>>2],A&&(i[h+40>>2]=A,Z(A)),A=i[h+24>>2],A&&(i[h+28>>2]=A,Z(A)),A=i[h>>2],!A)break i;i[h+4>>2]=A,Z(A)}v=h+48|0}function Mt(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0;A=r;i:if((f-A|0)<3)break i;for(;;){i:{if(k>>>0<=l>>>0|A>>>0>=f>>>0)break i;e=t[A|0],o=e&255,n=1;e:{if((e|0)>=0)break e;if(e>>>0<4294967234)break i;if(e>>>0<=4294967263){if((u[A+1|0]&192)!=128|(f-A|0)<2)break i;n=2;break e}if(e>>>0<=4294967279){if((f-A|0)<3)break i;n=u[A+2|0],e=t[A+1|0];r:{f:{if((o|0)!=237){if((o|0)!=224)break f;if((e&-32)==-96)break r;break i}if((e|0)>=-96)break i;break r}if((e|0)>-65)break i}if((n&192)!=128)break i;n=3;break e}if((f-A|0)<4|e>>>0>4294967284)break i;n=u[A+3|0],s=u[A+2|0],e=t[A+1|0];r:{f:switch(o-240|0){case 0:if((e+112&255)>>>0>=48)break i;break r;case 4:if((e|0)>=-112)break i;break r;default:break f}if((e|0)>-65)break i}if((s&192)!=128|(n&192)!=128|(n&63|(s<<6&4032|(o<<18&1835008|(e&63)<<12)))>>>0>1114111)break i;n=4}l=l+1|0,A=A+n|0;continue}break}return A-r|0}function Ht(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0;A=r;i:if((f-A|0)<3)break i;for(;;){i:{if(k>>>0<=o>>>0|A>>>0>=f>>>0)break i;e=u[A|0],n=A+1|0;e:{if(e<<24>>24>=0)break e;if(e>>>0<194)break i;if(e>>>0<=223){if((u[A+1|0]&192)!=128|(f-A|0)<2)break i;n=A+2|0;break e}if(e>>>0<=239){if((f-A|0)<3)break i;l=u[A+2|0],n=t[A+1|0];r:{f:{if((e|0)!=237){if((e|0)!=224)break f;if((n&-32)==-96)break r;break i}if((n|0)>=-96)break i;break r}if((n|0)>-65)break i}if((l&192)!=128)break i;n=A+3|0;break e}if((f-A|0)<4|e>>>0>244|k-o>>>0<2)break i;l=u[A+3|0],s=u[A+2|0],n=t[A+1|0];r:{f:switch(e-240|0){case 0:if((n+112&255)>>>0>=48)break i;break r;case 4:if((n|0)>=-112)break i;break r;default:break f}if((n|0)>-65)break i}if((s&192)!=128|(l&192)!=128|(l&63|(s<<6&4032|(e<<18&1835008|(n&63)<<12)))>>>0>1114111)break i;o=o+1|0,n=A+4|0}A=n,o=o+1|0;continue}break}return A-r|0}function jX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,6310);break i}if(p4(f+20|0,r),t[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],p4(f+20|0,r),t[e+127|0]<0&&Z(i[e+116>>2]),k=i[f+24>>2],i[e+116>>2]=i[f+20>>2],i[e+120>>2]=k,i[e+124>>2]=i[f+28>>2],p4(f+20|0,r),t[e+139|0]<0&&Z(i[e+128>>2]),k=i[f+24>>2],i[e+128>>2]=i[f+20>>2],i[e+132>>2]=k,i[e+136>>2]=i[f+28>>2],p4(f+20|0,r),t[e+151|0]<0&&Z(i[e+140>>2]),k=i[f+24>>2],i[e+140>>2]=i[f+20>>2],i[e+144>>2]=k,i[e+148>>2]=i[f+28>>2],u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Yi(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r)for(;;){if(o=i[e+16>>2],k=i[e+20>>2],n=i[e+24>>2],(n|0)<=7){for(n=64-n|0,B=0,f=i[e+4>>2],w=i[e+12>>2];;){e:{if(l=n,!w){s=n;break e}if(m=f+1|0,i[e+4>>2]=m,f=u[f|0],w=w-1|0,i[e+12>>2]=w,s=l-8|0,_=s&31,(s&63)>>>0>=32?(G=f<<_,f=0):(G=(1<<_)-1&f>>>32-_,f=f<<_),o=f|o,i[e+16>>2]=o,k=k|G,i[e+20>>2]=k,f=n,n=f-8|0,B=B-(f>>>0<8)|0,f=m,(l|0)>15)continue}break}n=64-s|0}i[e+24>>2]=n-8,i[e+16>>2]=o<<8,i[e+20>>2]=k<<8|o>>>24,s=k>>>24|0,f=i[A+8>>2];e:{if(f>>>0>h>>>0){t[h|0]=s,h=h+1|0;break e}if(o=i[A>>2],n=h-o|0,k=n+1|0,(k|0)<0)break i;if(f=f-o|0,l=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<l>>>0?l:k,f?k=C(f):k=0,l=k+n|0,t[l|0]=s,n&&z(k,o,n),i[A+8>>2]=f+k,i[A>>2]=k,h=l+1|0,!o)break e;Z(o)}if(i[A+4>>2]=h,I=I+1|0,(I|0)==(r|0))break}return}s0(),M()}function _3(A,e,r){var f=0,k=0,n=0,o=0,l=0;i:{e:{if((e|0)==8){e=E2(r);break e}if(f=28,e&3|e>>>0<4||(n=e>>>2|0,n-1&n))break i;if(-64-e>>>0<r>>>0)return 48;n=16,e=e>>>0<=16?16:e,f=e>>>0<=16?16:e;r:{if(!(f-1&f)){e=f;break r}for(;e=n,n=e<<1,e>>>0<f>>>0;);}r:{if(-64-e>>>0<=r>>>0){i[33136]=48,r=0;break r}if(n=r>>>0<11?16:r+11&-8,k=E2((n+e|0)+12|0),r=0,!k)break r;r=k-8|0;f:{if(!(k&e-1)){e=r;break f}if(o=k-4|0,l=i[o>>2],f=e,e=((e+k|0)-1&0-e)-8|0,e=(e-r>>>0<=15?f:0)+e|0,f=e-r|0,k=(l&-8)-f|0,!(l&3)){r=i[r>>2],i[e+4>>2]=k,i[e>>2]=r+f;break f}i[e+4>>2]=k|i[e+4>>2]&1|2,k=e+k|0,i[k+4>>2]=i[k+4>>2]|1,i[o>>2]=f|i[o>>2]&1|2,k=r+f|0,i[k+4>>2]=i[k+4>>2]|1,qr(r,f)}r=i[e+4>>2];f:{if(!(r&3)||(f=r&-8,f>>>0<=n+16>>>0))break f;i[e+4>>2]=n|r&1|2,r=e+n|0,n=f-n|0,i[r+4>>2]=n|3,f=e+f|0,i[f+4>>2]=i[f+4>>2]|1,qr(r,n)}r=e+8|0}e=r}if(!e)return 48;i[A>>2]=e,f=0}return f}function SX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0;n=v-112|0,v=n;i:{if(!(k&&f)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}e:{if(o=i[e+16>>2],!o||(h=Z0(o,101112,102228),!h))break e;if(o=i[e+20>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),l=i[e>>2],i[n+56>>2]=i[l+48>>2],l=i[l+52>>2],i[n+60>>2]=l,l&&(i[l+4>>2]=i[l+4>>2]+1),e=i[e+8>>2],l=i[e+8>>2],e=i[e+4>>2],s=i[n+60>>2],i[n+16>>2]=i[n+56>>2],i[n+20>>2]=s,s=n- -64|0,Lr(s,n+16|0,r,e,l),u0[n+24>>3]=i[h+4>>2],u0[n+32>>3]=i[h+8>>2],e=i[n+36>>2],i[n+8>>2]=i[n+32>>2],i[n+12>>2]=e,e=i[n+28>>2],i[n>>2]=i[n+24>>2],i[n+4>>2]=e,ef(n+40|0,s,n),u0[f>>3]=u0[n+40>>3],u0[k>>3]=u0[n+48>>3],i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o);break i}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794]}v=n+112|0}function OX(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;B=n+7|0,m=n+4|0;i:{if((m|0)>=-2){if((k|0)<=0)break i;for(I=o+6|0,Q=k&2147483644,G=k&3,_=-3,V=k>>>0<4;;){if(s=(_<<1)+I|0,l=g(f,_)+r|0,h=0,!V)for(;X[s>>1]=u[l|0],w=s,s=B<<1,w=w+s|0,X[w>>1]=u[l+1|0],w=s+w|0,X[w>>1]=u[l+2|0],w=s+w|0,X[w>>1]=u[l+3|0],s=s+w|0,l=l+4|0,h=h+4|0,(Q|0)!=(h|0););if(h=0,G)for(;X[s>>1]=u[l|0],l=l+1|0,s=(B<<1)+s|0,h=h+1|0,(G|0)!=(h|0););if(_=_+1|0,(m|0)==(_|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(r=0,e=e<<1;;){for(s=(r<<1)+A|0,l=(g(r,B)<<1)+o|0,h=0;X[s>>1]=(((((p[l+2>>1]<<2)-p[l>>1]|0)+g(p[l+8>>1]+p[l+6>>1]|0,40)|0)+(p[l+12>>1]<<2)|0)-p[l+14>>1]|0)+g(p[l+10>>1]+p[l+4>>1]|0,-11),l=l+2|0,s=e+s|0,h=h+1|0,(h|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function PX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;if(n=v-16|0,v=n,o=i[e+68>>2],o){o=W[i[i[o>>2]+24>>2]](o)|0;i:{e:{if(!(!i[e+64>>2]|(r|f)!=0&(o|0)<=0)&&!(W[i[i[e>>2]+24>>2]](e)|0))break e;i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}if(k>>>0>=3){i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}if(l=i[e+64>>2],f=L0(r,f,o,0),r=(o|0)>0,lf(l,r?f:0,r?h0:0,k)){i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}r=i[e+64>>2],f=W[i[r+40>>2]](r,0,0,u[r|0]&128?i[r+20>>2]==i[r+28>>2]?1:2:1)|0,k=h0;e:{if((k|0)<0)break e;if(o=i[r+8>>2],o)l=4;else{if(o=i[r+28>>2],!o)break e;l=20}r=i[l+r>>2]-o|0,f=r+f|0,k=(r>>31)+k|0,k=r>>>0>f>>>0?k+1|0:k}h0=k,i[A+8>>2]=f,i[A+12>>2]=h0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+76>>2],e=i[e+72>>2],i[n>>2]=e,i[n+4>>2]=r,i[n+8>>2]=e,i[n+12>>2]=r,e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e}v=n+16|0;return}N1(),M()}function LX(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;B=n+6|0,m=n+3|0;i:{if((m|0)>=-2){if((k|0)<=0)break i;for(I=o+6|0,Q=k&2147483644,G=k&3,_=-3,V=k>>>0<4;;){if(s=(_<<1)+I|0,l=g(f,_)+r|0,h=0,!V)for(;X[s>>1]=u[l|0],w=s,s=B<<1,w=w+s|0,X[w>>1]=u[l+1|0],w=s+w|0,X[w>>1]=u[l+2|0],w=s+w|0,X[w>>1]=u[l+3|0],s=s+w|0,l=l+4|0,h=h+4|0,(Q|0)!=(h|0););if(h=0,G)for(;X[s>>1]=u[l|0],l=l+1|0,s=(B<<1)+s|0,h=h+1|0,(G|0)!=(h|0););if(_=_+1|0,(m|0)==(_|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(r=0,e=e<<1;;){for(s=(r<<1)+A|0,l=(g(r,B)<<1)+o|0,h=0;X[s>>1]=p[l+12>>1]+((((((p[l+2>>1]<<2)-p[l>>1]|0)+g(p[l+4>>1],-10)|0)+g(p[l+6>>1],58)|0)+g(p[l+8>>1],17)|0)+g(p[l+10>>1],-5)|0),l=l+2|0,s=e+s|0,h=h+1|0,(h|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function qX(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;B=n+6|0,m=n+4|0;i:{if((m|0)>=-1){if((k|0)<=0)break i;for(I=o+4|0,Q=k&2147483644,G=k&3,_=-2,V=k>>>0<4;;){if(s=(_<<1)+I|0,l=g(f,_)+r|0,h=0,!V)for(;X[s>>1]=u[l|0],w=s,s=B<<1,w=w+s|0,X[w>>1]=u[l+1|0],w=s+w|0,X[w>>1]=u[l+2|0],w=s+w|0,X[w>>1]=u[l+3|0],s=s+w|0,l=l+4|0,h=h+4|0,(Q|0)!=(h|0););if(h=0,G)for(;X[s>>1]=u[l|0],l=l+1|0,s=(B<<1)+s|0,h=h+1|0,(G|0)!=(h|0););if(_=_+1|0,(m|0)==(_|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(r=0,e=e<<1;;){for(s=(r<<1)+A|0,l=(g(r,B)<<1)+o|0,h=0;X[s>>1]=(((((p[l>>1]+g(p[l+2>>1],-5)|0)+g(p[l+4>>1],17)|0)+g(p[l+6>>1],58)|0)+g(p[l+8>>1],-10)|0)+(p[l+10>>1]<<2)|0)-p[l+12>>1],l=l+2|0,s=e+s|0,h=h+1|0,(h|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function yi(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;i:{if(o=i[A+4>>2],f=i[A>>2],k=o-f|0,r=((k|0)/20|0)+1|0,r>>>0<214748365){if(l=(i[A+8>>2]-f|0)/20|0,s=l<<1,r=l>>>0>=107374182?214748364:r>>>0<s>>>0?s:r,r>>>0>=214748365)break i;s=g(r,20),h=C(s),l=h+k|0,r=l,n=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=n,r=r+8|0;e:{if(t[e+19|0]>=0){n=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=n,i[r+8>>2]=i[e+16>>2];break e}T(r,i[e+8>>2],i[e+12>>2]),o=i[A+4>>2],f=i[A>>2],k=o-f|0}if(r=l+g((k|0)/-20|0,20)|0,(f|0)!=(o|0)){for(e=f,k=r;n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+16>>2]=i[e+16>>2],n=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=n,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,k=k+20|0,e=e+20|0,(o|0)!=(e|0););for(;t[f+19|0]<0&&Z(i[f+8>>2]),f=f+20|0,(o|0)!=(f|0););f=i[A>>2]}return e=l+20|0,i[A+4>>2]=e,i[A>>2]=r,i[A+8>>2]=s+h,f&&Z(f),e}s0(),M()}x0(),M()}function zt(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;if(f=i[A+8>>2],r=i[A+4>>2],f-r>>3>>>0>=e>>>0){if(e){for(e=(e<<3)+r|0;i[r>>2]=0,i[r+4>>2]=0,r=r+8|0,(e|0)!=(r|0););r=e}i[A+4>>2]=r;return}i:{if(k=i[A>>2],r=r-k|0,n=(r>>3)+e|0,n>>>0<536870912){if(f=f-k|0,k=f>>2,l=f>>>0>=2147483640?536870911:n>>>0<k>>>0?k:n,l){if(l>>>0>=536870912)break i;k=C(l<<3)}else k=0;for(f=k+r|0,w=f+(e<<3)|0,r=f;i[r>>2]=0,i[r+4>>2]=0,r=r+8|0,(w|0)!=(r|0););if(e=i[A>>2],s=i[A+4>>2],f=f+(e-s|0)|0,(e|0)!=(s|0)){for(r=e,n=f;o=v-16|0,v=o,u[115885]==1&&(i[o+4>>2]=r,i[o>>2]=n,q8(38252,o)),h=i[r+4>>2],h&&(i[h>>2]=i[h>>2]+1),i[n+4>>2]=h,i[n>>2]=i[r>>2],v=o+16|0,n=n+8|0,r=r+8|0,(s|0)!=(r|0););for(;e=l6(e)+8|0,(s|0)!=(e|0););e=i[A>>2]}i[A+4>>2]=w,i[A>>2]=f,i[A+8>>2]=k+(l<<3),e&&Z(e);return}s0(),M()}x0(),M()}function W8(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;if((e|0)!=(r|0))for(l=A+4|0;;){n=i[A+4>>2];i:{e:{r:{if(f=l,h=i[A>>2],(f|0)==(h|0))break r;o=f;f:{if(k=n,k){for(;f=k,k=i[f+4>>2],!!k;);if(s=i[e+16>>2],s>>>0<=o0[f+16>>2])break f;break r}for(;f=i[o+8>>2],k=i[f>>2]==(o|0),o=f,!!k;);if(o=l,k=o,o0[f+16>>2]<o0[e+16>>2])break r;break e}for(;;){if(k=n,f=i[k+16>>2],f>>>0>s>>>0){if(o=k,n=i[k>>2],n)continue;break e}if(f>>>0>=s>>>0)break i;if(n=i[k+4>>2],!n)break}o=k+4|0;break e}if(o=n?f+4|0:l,i[o>>2])break i;k=n?f:l}f=C(20),n=i[e+16>>2],i[f+8>>2]=k,i[f>>2]=0,i[f+4>>2]=0,i[f+16>>2]=n,i[o>>2]=f,k=i[h>>2],k&&(i[A>>2]=k),G1(i[A+4>>2],f),i[A+8>>2]=i[A+8>>2]+1}k=i[e+4>>2];i:{if(k){for(;;)if(f=k,k=i[f>>2],!k)break i}for(;f=i[e+8>>2],k=i[f>>2]!=(e|0),e=f,!!k;);}if(e=f,(r|0)==(f|0))break}}function aX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(!(!e|!r)){f=p[e>>1],E0[r>>2]=(f+28535&65535)>>>0<28540?D(0):D(+(f>>>0)*2e-5),f=p[e+6>>1],E0[r+12>>2]=(f+23535&65535)>>>0<23540?D(0):D(+(f>>>0)*2e-5),f=p[e+2>>1],E0[r+4>>2]=(f+28535&65535)>>>0<28540?D(0):D(+(f>>>0)*2e-5),f=p[e+8>>1],E0[r+16>>2]=(f+23535&65535)>>>0<23540?D(0):D(+(f>>>0)*2e-5),f=p[e+4>>1],E0[r+8>>2]=(f+28535&65535)>>>0<28540?D(0):D(+(f>>>0)*2e-5),f=p[e+10>>1],E0[r+20>>2]=(f+23535&65535)>>>0<23540?D(0):D(+(f>>>0)*2e-5),f=p[e+12>>1],E0[r+24>>2]=(f+28535&65535)>>>0<28540?D(0):D(+(f>>>0)*2e-5),f=p[e+14>>1],E0[r+28>>2]=(f+23535&65535)>>>0<23540?D(0):D(+(f>>>0)*2e-5),f=i[e+16>>2],u0[r+32>>3]=f-100000001>>>0<4195017295?0:+(f>>>0)*1e-4,e=i[e+20>>2],u0[r+40>>3]=e-50001>>>0<4294917296?0:+(e>>>0)*1e-4,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e;return}e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147]}function KX(A){A=A|0;var e=0,r=0,f=0,k=0;e=i[A+100>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+92>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+72>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+64>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+56>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+48>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[A+32>>2],e){if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}}function Re(A,e){var r=0,f=0,k=0,n=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{r:{f:{if(r=i[e+4>>2],k=i[e>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break f;f=C(r),i[A+4>>2]=f,i[A>>2]=f,n=r+f|0,i[A+8>>2]=n,r&&z(f,k,r),i[A+4>>2]=n}if(r=u[e+12|0],i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,t[A+12|0]=r,r=i[e+20>>2],k=i[e+16>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break r;f=C(r),i[A+20>>2]=f,i[A+16>>2]=f,n=r+f|0,i[A+24>>2]=n,r&&z(f,k,r),i[A+20>>2]=n}if(i[A+36>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,r=i[e+32>>2],k=i[e+28>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break e;f=C(r),i[A+32>>2]=f,i[A+28>>2]=f,n=r+f|0,i[A+36>>2]=n,r&&z(f,k,r),i[A+32>>2]=n}if(i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,r=i[e+44>>2],f=i[e+40>>2],(r|0)!=(f|0)){if(e=r-f|0,(e|0)<0)break i;r=C(e),i[A+44>>2]=r,i[A+40>>2]=r,k=e+r|0,i[A+48>>2]=k,e&&z(r,f,e),i[A+44>>2]=k}return A}s0(),M()}s0(),M()}s0(),M()}s0(),M()}function LA(A,e,r,f,k,n){var o=0,l=0,s=0;o=v-32|0,v=o,i[o+8>>2]=0,i[o>>2]=0,i[o+4>>2]=0;i:{e:{r:{if(n>>>0<2)break r;f:switch(n-3|0){case 1:if(t[o+12|0]=0,t[o+23|0]=0,a(A,4,3005,o+12|0),t[o+23|0]>=0)break e;Z(i[o+12>>2]);break e;case 0:if(t[o+12|0]=0,t[o+23|0]=0,a(A,4,3005,o+12|0),t[o+23|0]>=0)break e;Z(i[o+12>>2]);break e;case 2:break f;default:break r}if(t[o+12|0]=0,t[o+23|0]=0,a(A,4,3005,o+12|0),t[o+23|0]>=0)break e;Z(i[o+12>>2]);break e}l=!k;r:{if(l)break r;if((k|0)<0)break i;if(n=C(k),i[o>>2]=n,s=k+n|0,i[o+8>>2]=s,i[o+4>>2]=s,l)break r;z(n,f,k)}if(jr(o+12|0,i[e+64>>2],i[i[r>>2]+104>>2],o,0),t[o+31|0]<0&&Z(i[o+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731])}A=i[o>>2],A&&(i[o+4>>2]=A,Z(A)),v=o+32|0;return}s0(),M()}function qA(A,e,r,f,k,n,o){var l=0,s=0,h=0,w=0;l=v-16|0,v=l,e=W[i[i[e>>2]+8>>2]](e)|0,s=i[r>>2],i[l+12>>2]=i[s+196>>2],i[l+8>>2]=i[s+200>>2],k=e||k,e=i[f>>2];i:{if(i[e>>2]>=2){W[i[e+108>>2]](i[f+4>>2],l+12|0,l+8|0);break i}W[i[e+96>>2]](l+12|0,l+8|0)}t[l+6|0]=1,X[l+4>>1]=2,i[l>>2]=131074;i:{if(k){ds(l,k);break i}if(r8(i[r>>2])){f=i[r>>2],e=p[f+6>>1]|p[f+8>>1]<<16,f=p[f+10>>1]|p[f+12>>1]<<16,i[l>>2]=e,t[l+6|0]=f>>>16,X[l+4>>1]=f;break i}t[l+6|0]=1,X[l+4>>1]=2,X[l>>1]=2,X[l+2>>1]=2}eh(l);i:{e:{if(h=i[l+12>>2],s=i[r>>2],w=i[l+8>>2],(h|0)!=i[s+196>>2]|(w|0)!=i[s+200>>2]||!(h|!k)&&(f=p[s+6>>1]|p[s+8>>1]<<16,e=p[s+10>>1]|p[s+12>>1]<<16,(!u[k+16|0]|0)==((e&65536)>>>16|0)|(i[k+12>>2]!=(e&65535)|i[k+4>>2]!=(f&65535))))break e;e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=s;break i}G6(A,r,h,w,l,0,n,0,o)}v=l+16|0}function $X(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;o=v-32|0,v=o,i[o+24>>2]=k,i[o+28>>2]=f;i:{if(!(n&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}e:{if(l=i[e>>2],!l||(s=Z0(l,107564,108216),!s))break e;l=i[e+4>>2],l&&(i[l+4>>2]=i[l+4>>2]+1);r:{f:{A:{if(r){if(r=o+4|0,Bn(r,s,o+28|0,o+24|0),!i[o+4>>2])break A;if(c0(A,r,i[e+8>>2]),t[o+23|0]>=0)break r;Z(i[o+12>>2]);break r}if(e=p[s+554>>1],f>>>0<e>>>0&p[s+552>>1]>k>>>0)break f;i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=15176;break r}t[o+23|0]<0&&Z(i[o+12>>2]),e=p[s+554>>1],f=i[o+28>>2],k=i[o+24>>2]}i[n>>2]=i[(i[s+564>>2]+(g(e,k)<<2)|0)+(f<<2)>>2],i[A+8>>2]=i[25788],e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e}if(!l||(A=i[l+4>>2],i[l+4>>2]=A-1,A))break i;W[i[i[l>>2]+8>>2]](l),y(l);break i}i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=16332}v=o+32|0}function dX(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0;s=v-16|0,v=s,l=C(32),i[l+28>>2]=n,i[l+24>>2]=k,i[l+20>>2]=f,i[l+16>>2]=r,i[l+12>>2]=102248,i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=102508,r=i[e+8>>2],i[s+12>>2]=l,f=l+12|0,i[s+8>>2]=f,i[l+4>>2]=i[l+4>>2]+1,P0(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!o||(i[l+4>>2]=i[l+4>>2]+1,r=C(24),i[l+4>>2]=i[l+4>>2]+1,i[r+20>>2]=l,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[o>>2]=r,e=i[l+4>>2],i[l+4>>2]=e-1,e))break i;W[i[i[l>>2]+8>>2]](l),y(l)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[l+4>>2],i[l+4>>2]=A-1,A||(W[i[i[l>>2]+8>>2]](l),y(l)),v=s+16|0}function bX(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0;s=v-16|0,v=s,l=C(32),i[l+28>>2]=n,i[l+24>>2]=k,i[l+20>>2]=f,i[l+16>>2]=r,i[l+12>>2]=102292,i[l+4>>2]=0,i[l+8>>2]=0,i[l>>2]=102548,r=i[e+8>>2],i[s+12>>2]=l,f=l+12|0,i[s+8>>2]=f,i[l+4>>2]=i[l+4>>2]+1,P0(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!o||(i[l+4>>2]=i[l+4>>2]+1,r=C(24),i[l+4>>2]=i[l+4>>2]+1,i[r+20>>2]=l,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[o>>2]=r,e=i[l+4>>2],i[l+4>>2]=e-1,e))break i;W[i[i[l>>2]+8>>2]](l),y(l)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[l+4>>2],i[l+4>>2]=A-1,A||(W[i[i[l>>2]+8>>2]](l),y(l)),v=s+16|0}function cX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-96|0,v=r;i:{e:{r:{if(i[A+16>>2]!=i[e+16>>2])break r;i[r+88>>2]=0,i[r+92>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,W[i[i[A>>2]+20>>2]](r+44|0,A,r+80|0),t[r+63|0]<0&&Z(i[r+52>>2]),W[i[i[e>>2]+20>>2]](r+24|0,e,r- -64|0),t[r+43|0]<0&&Z(i[r+32>>2]),i[r+20>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,A=i[r+84>>2],f=i[r+80>>2];f:{if((A|0)==(f|0)){e=0,f=0;break f}if(A=A-f|0,(A|0)<0)break e;e=C(A),A&&z(e,f,A),f=A+e|0}i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,A=i[r+68>>2],n=i[r+64>>2];f:{if((A|0)==(n|0)){A=0;break f}if(k=A-n|0,(k|0)<0)break i;A=C(k),k&&z(A,n,k),k=A+k|0}if(n=0,f=f-e|0,(f|0)==(k-A|0)&&(n=!N2(e,A,f)),A&&Z(A),e&&Z(e),A=i[r+64>>2],A&&(i[r+68>>2]=A,Z(A)),A=i[r+80>>2],!A)break r;i[r+84>>2]=A,Z(A)}return v=r+96|0,n|0}s0(),M()}s0(),M()}function Je(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;i:{if(f=i[A>>2],n=i[A+4>>2]-f|0,r=((n|0)/20|0)+1|0,r>>>0<214748365){if(f=(i[A+8>>2]-f|0)/20|0,k=f<<1,r=f>>>0>=107374182?214748364:r>>>0<k>>>0?k:r,r>>>0>=214748365)break i;if(s=g(r,20),h=C(s),k=n+h|0,r=k,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+16>>2]=i[e+16>>2],r=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=r,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,o=i[A+4>>2],r=i[A>>2],n=k+g((o-r|0)/-20|0,20)|0,(r|0)!=(o|0)){for(e=r,f=n;l=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=l,i[f+16>>2]=i[e+16>>2],l=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=l,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,f=f+20|0,e=e+20|0,(o|0)!=(e|0););for(;t[r+19|0]<0&&Z(i[r+8>>2]),r=r+20|0,(o|0)!=(r|0););r=i[A>>2]}return e=k+20|0,i[A+4>>2]=e,i[A>>2]=n,i[A+8>>2]=s+h,r&&Z(r),e}s0(),M()}x0(),M()}function iI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0,B=0;s=i[e+24>>2],s>>>0>o0[e+44>>2]&&(i[e+44>>2]=s),s=-1,B=-1,h=n&24;i:{if(!h|(k|0)==1&(h|0)==24)break i;h=i[e+44>>2],h&&(o=e+32|0,u[o+11|0]>>>7|0&&(o=i[o>>2]),o=h-o|0,w=o>>31);e:{r:switch(k|0){case 1:if(n&8){l=i[e+12>>2]-i[e+8>>2]|0,_=l>>31;break e}l=i[e+24>>2]-i[e+20>>2]|0,_=l>>31;break e;case 0:break e;case 2:break r;default:break i}l=o,_=w}if(f=f+_|0,r=r+l|0,f=l>>>0>r>>>0?f+1|0:f,(f|0)<0|(r>>>0>o>>>0&(f|0)>=(w|0)|(f|0)>(w|0)))break i;k=n&8;e:{if(!(r|f))break e;if(!i[e+12>>2]&&k)break i;if(!(n&16))break e;if(!i[e+24>>2])break i}k&&(k=i[e+8>>2],i[e+16>>2]=i[e+44>>2],i[e+12>>2]=r+k,i[e+8>>2]=k),n&16&&(k=i[e+20>>2],i[e+28>>2]=i[e+28>>2],i[e+20>>2]=k,i[e+24>>2]=k,i[e+24>>2]=r+i[e+24>>2]),s=r,B=f}i[A+8>>2]=s,i[A+12>>2]=B,i[A>>2]=0,i[A+4>>2]=0}function eI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;o=v-48|0,v=o;i:{e:{r:{if((r|f|k|n)<0||(h=i[e>>2],w=i[h+188>>2],l=r+f|0,s=l>>>0<r>>>0?1:s,!s&l>>>0>=w>>>0|s))break r;if(l=i[h+192>>2],s=0,_=k+n|0,!(_>>>0<k>>>0||s)&l>>>0>_>>>0)break e}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=5494;break i}oA(o+12|0,h,r,(f^-1)+w|0,k,(n^-1)+l|0,0);e:{r:switch(u[o+32|0]){default:e2(),M();case 1:r=A,A=i[e>>2],c0(r,o+12|0,A?A+172|0:0);break e;case 0:break r}r=i[o+12>>2],f=i[o+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e>>2]=r,r=i[e+4>>2],i[e+4>>2]=f;r:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break r;W[i[i[r>>2]+8>>2]](r),y(r)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}if(A=u[o+32|0],(A|0)==255)break i;e=i[25779],i[o+40>>2]=i[25778],i[o+44>>2]=e,W[i[(o+40|0)+(A<<2)>>2]](o+39|0,o+12|0)}v=o+48|0}function B3(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;i:{e:{if(l=i[A+4>>2],f=i[A>>2],k=l-f|0,s=k>>4,r=s+1|0,r>>>0<268435456){if(n=i[A+8>>2]-f|0,o=n>>3,r=n>>>0>=2147483632?268435455:r>>>0<o>>>0?o:r,r>>>0>=268435456)break e;if(h=r<<4,o=C(h),r=i[e>>2],n=k+o|0,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=r,k=i[e+8>>2],r=i[e+4>>2],(k|0)!=(r|0)){if(e=k-r|0,(e|0)<0)break i;k=C(e),i[n+4>>2]=k,w=e+k|0,i[n+12>>2]=w,e&&z(k,r,e),i[n+8>>2]=w}if(k=n-(s<<4)|0,(f|0)!=(l|0)){for(r=f,e=k;i[e>>2]=i[r>>2],i[e+4>>2]=i[r+4>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=i[r+12>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,e=e+16|0,r=r+16|0,(l|0)!=(r|0););for(;e=i[f+4>>2],e&&(i[f+8>>2]=e,Z(e)),f=f+16|0,(l|0)!=(f|0););f=i[A>>2]}return i[A+8>>2]=o+h,e=n+16|0,i[A+4>>2]=e,i[A>>2]=k,f&&Z(f),e}s0(),M()}x0(),M()}s0(),M()}function v3(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0;if(l=v-16|0,v=l,s=A+2140|0,vu(s,1)){if(k=(t[i[A+1384>>2]+13|0]<<3)+A|0,n=i[k+728>>2],o=i[k+732>>2],o&&(i[o+4>>2]=i[o+4>>2]+2),i[l+12>>2]=o,i[l+8>>2]=n,k=i[l+12>>2],i[l>>2]=i[l+8>>2],i[l+4>>2]=k,k=0,s=st(s,l,A,0,0,0,0),(s|0)>=0){if(n=i[A+2152>>2],A=i[A+2148>>2],s>>>0<n-A>>2>>>0&&(k=i[A+(s<<2)>>2]),n=1<<i[e+16832>>2]-1,A=1<<i[e+16840>>2]-1,i[k+4>>2]&&JA(k,0,n),i[k+8>>2]&&JA(k,1,A),i[k+12>>2]&&JA(k,2,A),i[k+164>>2]>0)for(A=0;n=i[k+160>>2]+g(A,3)|0,h=(u[n|0]|u[n+1|0]<<8)&64767,t[n|0]=h,t[n+1|0]=h>>>8,A=A+1|0,(A|0)<i[k+164>>2];);i[k+96>>2]=r,A=i[e+16868>>2],t[k+104|0]=0,t[k+312|0]=1,i[k+100>>2]=f?2:1,i[k+92>>2]=A-1&r}i:{if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o)}return v=l+16|0,s}U0(29674,19835,1428,13450),M()}function rI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;k=v-16|0,v=k,i[k+12>>2]=r,i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,e|r|i[A+92>>2]!=32||(f=i[A+64>>2],f?(i[f+80>>2]=-1,i[f+48>>2]=0,i[f>>2]=i[f>>2]|64,f=0):f=34,i[A+92>>2]=f);i:{if(u[A+96|0]!=1||(f=i[A+32>>2],!f))break i;Z(f)}i:{if(u[A+97|0]!=1||(f=i[A+56>>2],!f))break i;Z(f)}i[A+52>>2]=r;i:{e:{r:{f:{if(r>>>0>=9){if(f=u[A+98|0],!e|!(f&1))break f;t[A+96|0]=0,i[A+32>>2]=e;break r}if(t[A+96|0]=0,i[A+52>>2]=8,i[A+32>>2]=A+44,t[A+98|0]&1)break r;break e}if(r=C(r),t[A+96|0]=1,i[A+32>>2]=r,!(f&1))break e}e=0,i[A+60>>2]=0,r=0;break i}if(i[k+8>>2]=8,r=v-16|0,v=r,v=r+16|0,r=k+8|0,f=k+12|0,f=i[(i[f>>2]<i[r>>2]?r:f)>>2],i[A+60>>2]=f,e&&(r=0,f>>>0>8))break i;e=C(f),r=1}return t[A+97|0]=r,i[A+56>>2]=e,v=k+16|0,A|0}function fI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;i:{if(n=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,k=i[n>>2],!k)break i;for(;;){if(v4(i[k+4>>2],r)){if(k=i[n+4>>2],n=n+4|0,k)continue;break i}break}e:switch(i[k+8>>2]-1|0){case 0:for(k=A,n=e,o=r;A=f,f=f+1|0,e=t[A|0],!!((e|0)==32|e-9>>>0<5););r=1;r:switch((e&255)-43|0){case 2:r=0;case 0:e=t[f|0],A=f;break;default:break r}if(f=0,e=e-48|0,e>>>0<=9)for(;f=g(f,10)-e|0,e=t[A+1|0],A=A+1|0,e=e-48|0,e>>>0<10;);Ot(k,n,o,r?0-f|0:f);return;case 1:k=1;r:{if(!v4(f,13060)||(k=0,!v4(f,13347)|u[f|0]!=49))break r;k=!u[f+1|0]}W[i[i[e>>2]+80>>2]](A,i[e+4>>2],r,k);return;case 2:W[i[i[e>>2]+88>>2]](A,i[e+4>>2],r,f);return;default:break e}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680];return}W[i[i[e>>2]+88>>2]](A,i[e+4>>2],r,f)}function aA(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;f=i[A+100>>2],n=f,k=i[A+104>>2],r=k,l=f-r|0,o=f>>31,f=r>>31,o=o-(f+(r>>>0>n>>>0)|0)|0,s=0-((r>>>0>2147483647)+f|0)|0;i:{if(!(0-(o+(l>>>0>2147483647)|0)|s)){n=f;break i}for(;k=f>>31,n=r+(k|1)|0,f=f+k|0,r=p2(n,r>>>0>n>>>0?f+1|0:f,2,0),f=h0,k=o>>31,n=l+(k|1)|0,k=o+k|0,l=p2(n,n>>>0<l>>>0?k+1|0:k,2,0),o=h0,(o-(l>>>0<2147483648)|0)!=-1;);n=r>>31,s=0-(n+(r>>>0>2147483647)|0)|0,k=r}if(o=r,A=pe(A,e),A=L0(r,n,A,A>>31),r=A+l|0,e=h0+(l>>31)|0,f=A>>>0>r>>>0?e+1|0:e,s|0-(f+(r>>>0>2147483647)|0)){for(;A=n>>31,e=o+(A|1)|0,A=n+A|0,o=p2(e,e>>>0<o>>>0?A+1|0:A,2,0),n=h0,A=f>>31,k=A,A=r+(A|1)|0,f=f+k|0,r=p2(A,A>>>0<r>>>0?f+1|0:f,2,0),A=h0,f=A,(A-(r>>>0<2147483648)|0)!=-1;);k=o,n=k>>31}return A=(k|0)/2|0,e=r+A|0,A=(A>>31)+(r>>31)|0,p2(e,e>>>0<r>>>0?A+1|0:A,o,n)}function KA(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;f=i[A+108>>2],n=f,k=i[A+112>>2],r=k,l=f-r|0,o=f>>31,f=r>>31,o=o-(f+(r>>>0>n>>>0)|0)|0,s=0-((r>>>0>2147483647)+f|0)|0;i:{if(!(0-(o+(l>>>0>2147483647)|0)|s)){n=f;break i}for(;k=f>>31,n=r+(k|1)|0,f=f+k|0,r=p2(n,r>>>0>n>>>0?f+1|0:f,2,0),f=h0,k=o>>31,n=l+(k|1)|0,k=o+k|0,l=p2(n,n>>>0<l>>>0?k+1|0:k,2,0),o=h0,(o-(l>>>0<2147483648)|0)!=-1;);n=r>>31,s=0-(n+(r>>>0>2147483647)|0)|0,k=r}if(o=r,A=Qe(A,e),A=L0(r,n,A,A>>31),r=A+l|0,e=h0+(l>>31)|0,f=A>>>0>r>>>0?e+1|0:e,s|0-(f+(r>>>0>2147483647)|0)){for(;A=n>>31,e=o+(A|1)|0,A=n+A|0,o=p2(e,e>>>0<o>>>0?A+1|0:A,2,0),n=h0,A=f>>31,k=A,A=r+(A|1)|0,f=f+k|0,r=p2(A,A>>>0<r>>>0?f+1|0:f,2,0),A=h0,f=A,(A-(r>>>0<2147483648)|0)!=-1;);k=o,n=k>>31}return A=(k|0)/2|0,e=r+A|0,A=(A>>31)+(r>>31)|0,p2(e,e>>>0<r>>>0?A+1|0:A,o,n)}function xt(A){var e=0,r=0,f=0,k=0,n=0;if(r=i[A+8>>2],!!r){if(e=i[A+4>>2],(e|0)==6){e=i[r+24>>2];i:{if((e|0)<i[r+28>>2]){f=i[r+20>>2];break i}if(n=e+1|0,f=E2(n),!f)return;k=i[r+20>>2],k&&(e&&z(f,k,e),Z(k),e=i[r+24>>2]),i[r+28>>2]=n,i[r+20>>2]=f}t[e+f|0]=0,i[r+24>>2]=i[r+24>>2]+1,e=i[A+4>>2]}if((e|0)==7){e=i[r+24>>2],k=e+2|0;i:{if((k|0)<=i[r+28>>2]){f=i[r+20>>2];break i}if(f=E2(k),!f)return;n=i[r+20>>2],n&&(e&&z(f,n,e),Z(n),e=i[r+24>>2]),i[r+28>>2]=k,i[r+20>>2]=f}e=e+f|0,t[e|0]=0,t[e+1|0]=0,i[r+24>>2]=i[r+24>>2]+2,e=i[A+4>>2]}(e|0)>=5&&(k=i[A+32>>2],f=k+i[A+28>>2]|0,n=i[A+20>>2],e=i[A+16>>2],(f|0)==(((e|0)!=(n|0)?(n-e<<8)-1|0:0)|0)&&(ar(A+12|0),k=i[A+32>>2],f=k+i[A+28>>2]|0,e=i[A+16>>2]),i[i[e+(f>>>8&16777212)>>2]+((f&1023)<<2)>>2]=r,i[A+32>>2]=k+1,e=i[r+24>>2],i[A+8>>2]=0,i[A+36>>2]=e+i[A+36>>2]),i[A+4>>2]=0}}function AI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;n=v-32|0,v=n,vn(A,e);i:{if(i[A>>2])break i;if(t[A+19|0]<0&&Z(i[A+8>>2]),o=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+104>>2],l=i[e+108>>2],(f|0)!=(l|0))for(k=u[e+97|0],s=k?4:2,w=k?2:1;;){if(p0(r,((i[f+48>>2]-i[f+44>>2]>>2)+1<<w)+10|0),p0(r,i[f+16>>2]),Y1(r,s,i[f+40>>2],0),u2(r,i[f+48>>2]-i[f+44>>2]>>>2&65535),k=i[f+44>>2],h=i[f+48>>2],(k|0)!=(h|0))for(;Y1(r,s,i[k>>2],0),k=k+4|0,(h|0)!=(k|0););if(f=f+56|0,(l|0)==(f|0))break}if(i[r+12>>2]=o,W[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+o|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[n+31|0]<0&&Z(i[n+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+32|0}function Tt(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;k=v-32|0,v=k;i:{if(n=i[A>>2],l=i[A+4>>2]-n|0,f=(l>>4)+1|0,f>>>0<268435456){if(o=i[A+8>>2],i[k+28>>2]=A+8,n=o-n|0,o=n>>3,f=n>>>0>=2147483632?268435455:f>>>0<o>>>0?o:f,f){if(f>>>0>=268435456)break i;r=C(f<<4)}if(i[k+12>>2]=r,i[k+24>>2]=(f<<4)+r,r=r+l|0,i[k+16>>2]=r,X[r>>1]=p[e>>1],i[r+4>>2]=i[e+4>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=i[e+12>>2],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[k+20>>2]=r+16,lo(A,k+12|0),l=i[A+4>>2],r=i[k+20>>2],n=i[k+16>>2],(r|0)!=(n|0))for(;;){if(A=r-16|0,i[k+20>>2]=A,o=r-12|0,f=i[o>>2],f){if(s=r-8|0,A=i[s>>2],e=f,(A|0)!=(f|0)){for(;e=A-12|0,r=i[e>>2],r&&(i[A-8>>2]=r,Z(r)),A=e,(f|0)!=(A|0););e=i[o>>2]}i[s>>2]=f,Z(e),A=i[k+20>>2]}if(r=A,(n|0)==(r|0))break}return A=i[k+12>>2],A&&Z(A),v=k+32|0,l}s0(),M()}x0(),M()}function kI(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,o=v-80|0,v=o;i:{if(!((k|0)==1885954932|(k|0)==1986618469)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=16812;break i}i[o+52>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+64>>2]=0,i[o+44>>2]=0,i[o+48>>2]=0,t[o+40|0]=0,i[o+36>>2]=9e4,et(o+12|0,i[e>>2],n||o+36|0,k,r,f);e:{r:switch(u[o+32|0]){default:e2(),M();case 1:c0(A,o+12|0,i[e>>2]);break e;case 0:break r}l&&(r=C(16),k=i[o+12>>2],f=i[o+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+4>>2]=f,i[r>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=e,i[r+8>>2]=f,i[l>>2]=r),e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}if(A=u[o+32|0],(A|0)!=255&&(e=i[25821],i[o+72>>2]=i[25820],i[o+76>>2]=e,W[i[(o+72|0)+(A<<2)>>2]](o+71|0,o+12|0)),a2(i[o+48>>2]),t[o+67|0]>=0)break i;Z(i[o+56>>2])}v=o+80|0}function h4(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;i:{k=i[A+4>>2],l=i[A>>2],s=k-l|0,f=i[A+12>>2]+8|0;e:{if(s>>>0>=f>>>0)break e;if(o=f-s|0,n=i[A+8>>2],o>>>0<=n-k>>>0){o&&l0(k,0,o),i[A+4>>2]=k+o;break e}if((f|0)<0)break i;if(k=n-l|0,n=k<<1,n=k>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,k=C(n),o&&l0(k+s|0,0,o),s&&z(k,l,s),i[A+8>>2]=k+n,i[A+4>>2]=f+k,i[A>>2]=k,!l)break e;Z(l)}f=i[A+12>>2],i[A+12>>2]=f+1,t[f+i[A>>2]|0]=r>>>24,f=i[A+12>>2],i[A+12>>2]=f+1,t[f+i[A>>2]|0]=r>>>16,f=i[A+12>>2],i[A+12>>2]=f+1,t[f+i[A>>2]|0]=r>>>8,f=i[A+12>>2],i[A+12>>2]=f+1,t[f+i[A>>2]|0]=r,f=i[A+12>>2],i[A+12>>2]=f+1,t[f+i[A>>2]|0]=(r&16777215)<<8|e>>>24,f=i[A+12>>2],i[A+12>>2]=f+1,t[f+i[A>>2]|0]=(r&65535)<<16|e>>>16,f=i[A+12>>2],i[A+12>>2]=f+1,t[f+i[A>>2]|0]=(r&255)<<24|e>>>8,r=i[A+12>>2],i[A+12>>2]=r+1,t[r+i[A>>2]|0]=e;return}s0(),M()}function nI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;if(n=v-32|0,v=n,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+108>>2]-i[e+104>>2]>>4),k=i[e+104>>2],l=i[e+108>>2],(k|0)!=(l|0))for(;;){f=i[k>>2];i:{if(!u[e+97|0]){u2(r,f&65535);break i}p0(r,f)}if(h2(r,i[k+8>>2]-i[k+4>>2]>>>2&255),f=i[k+4>>2],s=i[k+8>>2],(f|0)!=(s|0))for(;;){h=u[f|0];i:{if(t[e+100|0]&1){u2(r,h<<15&32768|p[f+2>>1]&32767);break i}h2(r,u[f+2|0]&127|h<<7&128)}if(f=f+4|0,(s|0)==(f|0))break}if(k=k+16|0,(l|0)==(k|0))break}i[r+12>>2]=o,W[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+o|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[n+31|0]<0&&Z(i[n+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+32|0}function tI(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0;for(l=v-416|0,v=l,f=l+416|0,i[l+12>>2]=f,r=v-144|0,v=r,i[r+28>>2]=r+132,s=r+32|0,Uu(A+8|0,s,r+28|0,k,n,o),i[r+16>>2]=0,i[r+20>>2]=0,i[r+12>>2]=s,n=l+16|0,o=i[l+12>>2]-n>>2,k=v-16|0,v=k,i[k+12>>2]=i[A+8>>2],A=C8(k+8|0,k+12|0),o=Sn(n,r+12|0,o,r+16|0),A=i[A>>2],A&&(i[33178]=(A|0)==-1?132592:A),v=k+16|0,(o|0)==-1&&(N1(),M()),i[l+12>>2]=n+(o<<2),v=r+144|0,o=v-16|0,v=o,A=v-32|0,v=A,Ts(A+24|0,n,i[l+12>>2]),l=i[A+28>>2],k=v-16|0,v=k,r=i[A+24>>2],i[k+8>>2]=r,i[k+12>>2]=e;;){if((r|0)!=(l|0)){Ku(k+12|0,i[r>>2]),r=r+4|0,i[k+8>>2]=r;continue}break}return i[A+16>>2]=i[k+8>>2],i[A+20>>2]=i[k+12>>2],v=k+16|0,i[A+12>>2]=n+(i[A+16>>2]-n|0),i[A+8>>2]=i[A+20>>2],i[o+8>>2]=i[A+12>>2],i[o+12>>2]=i[A+8>>2],v=A+32|0,v=o+16|0,v=f,i[o+12>>2]}function oI(){var A=0,e=0,r=0;return A=u[7856]|u[7857]<<8|(u[7858]<<16|u[7859]<<24),i[28788]=u[7852]|u[7853]<<8|(u[7854]<<16|u[7855]<<24),i[28789]=A,A=u[7870]|u[7871]<<8|(u[7872]<<16|u[7873]<<24),e=u[7866]|u[7867]<<8|(u[7868]<<16|u[7869]<<24),X[57583]=e,X[57584]=e>>>16,X[57585]=A,X[57586]=A>>>16,A=u[7864]|u[7865]<<8|(u[7866]<<16|u[7867]<<24),i[28790]=u[7860]|u[7861]<<8|(u[7862]<<16|u[7863]<<24),i[28791]=A,A=l2(115152),(l2(22927)+A|0)+10>>>0<=79&&(e=u[31555]|u[31556]<<8|(u[31557]<<16|u[31558]<<24),A=A+115152|0,r=u[31551]|u[31552]<<8|(u[31553]<<16|u[31554]<<24),t[A|0]=r,t[A+1|0]=r>>>8,t[A+2|0]=r>>>16,t[A+3|0]=r>>>24,t[A+4|0]=e,t[A+5|0]=e>>>8,t[A+6|0]=e>>>16,t[A+7|0]=e>>>24,e=u[31558]|u[31559]<<8|(u[31560]<<16|u[31561]<<24),t[A+7|0]=e,t[A+8|0]=e>>>8,t[A+9|0]=e>>>16,t[A+10|0]=e>>>24,u8(l2(115152)+115152|0,22927)),115152}function jt(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;n=v-16|0,v=n;i:{if(!r|(!A|!e))break i;G5(n+4|0,i[A>>2]),o=i[n+8>>2],A=i[n+4>>2],f=o-A>>3,f=(r|0)>(f|0)?f:r;e:{if((f|0)>0){if(r=0,f>>>0>=4)for(l=f&2147483644;i[(r<<2)+e>>2]=i[i[A+(r<<3)>>2]+196>>2],k=r|1,i[(k<<2)+e>>2]=i[i[A+(k<<3)>>2]+196>>2],k=r|2,i[(k<<2)+e>>2]=i[i[A+(k<<3)>>2]+196>>2],k=r|3,i[(k<<2)+e>>2]=i[i[A+(k<<3)>>2]+196>>2],r=r+4|0,s=s+4|0,(l|0)!=(s|0););if(l=f&3,!l)break e;for(;i[(r<<2)+e>>2]=i[i[A+(r<<3)>>2]+196>>2],r=r+1|0,h=h+1|0,(l|0)!=(h|0););break e}if(!A)break i}if((A|0)==(o|0))e=A;else{for(;;){e=i[o-4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(o=o-8|0,(A|0)==(o|0))break}e=i[n+4>>2]}i[n+8>>2]=A,Z(e)}return v=n+16|0,f|0}function lI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;o=v-16|0,v=o;i:{if(!r)break i;bt(o+4|0,i[A>>2],e),A=i[o+8>>2],e=i[o+4>>2],k=A-e>>3,k=(f|0)>(k|0)?k:f;e:{if((k|0)>0){if(f=0,k>>>0>=4)for(l=k&2147483644;i[(f<<2)+r>>2]=i[i[e+(f<<3)>>2]+196>>2],n=f|1,i[(n<<2)+r>>2]=i[i[e+(n<<3)>>2]+196>>2],n=f|2,i[(n<<2)+r>>2]=i[i[e+(n<<3)>>2]+196>>2],n=f|3,i[(n<<2)+r>>2]=i[i[e+(n<<3)>>2]+196>>2],f=f+4|0,s=s+4|0,(l|0)!=(s|0););if(l=k&3,!l)break e;for(;i[(f<<2)+r>>2]=i[i[e+(f<<3)>>2]+196>>2],f=f+1|0,h=h+1|0,(l|0)!=(h|0););break e}if(!e)break i}if((A|0)==(e|0))A=e;else{for(;;){r=i[A-4>>2];e:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=A-8|0,(e|0)==(A|0))break}A=i[o+4>>2]}i[o+8>>2]=e,Z(A)}return v=o+16|0,k|0}function St(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;k=v-32|0,v=k;i:{if(n=i[A>>2],l=i[A+4>>2]-n|0,f=(l>>4)+1|0,f>>>0<268435456){if(o=i[A+8>>2],i[k+28>>2]=A+8,n=o-n|0,o=n>>3,f=n>>>0>=2147483632?268435455:f>>>0<o>>>0?o:f,f){if(f>>>0>=268435456)break i;r=C(f<<4)}if(i[k+12>>2]=r,i[k+24>>2]=(f<<4)+r,r=r+l|0,i[k+16>>2]=r,f=p[e>>1],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,X[r>>1]=f,f=i[e+4>>2],e=i[e+8>>2],Oe(r+4|0,f,e,(e-f|0)/12|0),i[k+20>>2]=r+16,lo(A,k+12|0),l=i[A+4>>2],e=i[k+20>>2],n=i[k+16>>2],(e|0)!=(n|0))for(;;){if(A=e-16|0,i[k+20>>2]=A,o=e-12|0,f=i[o>>2],f){if(s=e-8|0,A=i[s>>2],r=f,(A|0)!=(r|0)){for(;e=A-12|0,r=i[e>>2],r&&(i[A-8>>2]=r,Z(r)),A=e,(A|0)!=(f|0););r=i[o>>2]}i[s>>2]=f,Z(r),A=i[k+20>>2]}if(e=A,(n|0)==(e|0))break}return A=i[k+12>>2],A&&Z(A),v=k+32|0,l}s0(),M()}x0(),M()}function uI(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(_=l-8|0,B=r-6|0;;){for(r=(w<<1)+o|0,l=B+(g(f,w)<<1)|0,s=0;X[r>>1]=(((((p[l+2>>1]<<2)-p[l>>1]|0)+g(p[l+8>>1]+p[l+6>>1]|0,40)|0)+(p[l+12>>1]<<2)|0)-p[l+14>>1]|0)+g(p[l+10>>1]+p[l+4>>1]|0,-11)>>_,l=l+2|0,r=(n<<1)+r|0,s=s+1|0,(s|0)!=(k|0););if(w=w+1|0,(w|0)==(n|0))break}for(_=n&2147483644,w=n&3,f=0,B=n>>>0<4;;){if(r=(f<<1)+A|0,l=(g(f,n)<<1)+o|0,s=0,!B)for(;X[r>>1]=p[l>>1],h=r,r=e<<1,h=h+r|0,X[h>>1]=p[l+2>>1],h=r+h|0,X[h>>1]=p[l+4>>1],h=r+h|0,X[h>>1]=p[l+6>>1],r=r+h|0,l=l+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,w)for(;X[r>>1]=p[l>>1],l=l+2|0,r=(e<<1)+r|0,s=s+1|0,(w|0)!=(s|0););if(f=f+1|0,(k|0)==(f|0))break}}}function Ot(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0;i:{e:{r:{n=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,k=i[n>>2];f:{if(!k)break f;if(o=i[25678],!o)for(;;){l=n;A:{if(v4(i[k+4>>2],r))break A;if(i[k+8>>2]!=1)break r;if(n=0,o=0,s=0,w=u[k+16|0],w&&(s=i[k+24>>2],o=i[k+20>>2]),h=i[k+32>>2],n=(h|0)>0?i[k+28>>2]:n,(f|0)<(o|0)|(f|0)>(s|0)&&w)break i;if(k=0,(h|0)<=0)break A;for(;;){if(i[(k<<2)+n>>2]==(f|0))break A;if(k=k+1|0,(h|0)==(k|0))break}break i}if(n=l+4|0,k=i[l+4>>2],!k)break f}for(l=i[25679],s=i[25680];;){if(!v4(i[k+4>>2],r)){if(i[k+8>>2]==1)break e;break r}if(k=i[n+4>>2],n=n+4|0,!k)break}}W[i[i[e>>2]+72>>2]](A,i[e+4>>2],r,f);return}l=i[25827],s=i[25828],o=5}i[A+4>>2]=l,i[A+8>>2]=s,i[A>>2]=o;return}e=i[25830],i[A>>2]=i[25829],i[A+4>>2]=e,i[A+8>>2]=i[25831]}function Pt(A,e,r,f,k,n,o,l){var s=0,h=0,w=0,_=0;if(h=v-16|0,v=h,(e^-1)+1073741815>>>0>=r>>>0){if(u[A+11|0]>>>7|0?s=i[A>>2]:s=A,_=s,s=h+4|0,e>>>0<536870899?(i[h+12>>2]=e<<1,i[h+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=h+12|0,r=i[(o0[s>>2]<o0[r>>2]?r:s)>>2],r>>>0>=2?(w=r+2&-2,r=w-1|0,r=(r|0)==2?w:r):r=1,r=r+1|0):r=1073741815,Ae(s,r),r=i[h+4>>2],k)i:{if(!k||(s=k<<2,!s))break i;z(r,_,s)}if(o){s=r+(k<<2)|0;i:{if(!o||(w=o<<2,!w))break i;z(s,l,w)}}if(s=k+n|0,l=f-s|0,(f|0)!=(s|0)){f=k<<2,s=(f+r|0)+(o<<2)|0,f=(f+_|0)+(n<<2)|0;i:{if(!l||(n=l<<2,!n))break i;z(s,f,n)}}(e|0)!=1&&B6(_,4),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[h+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,e=A,A=l+(k+o|0)|0,i[e+4>>2]=A,i[h+12>>2]=0,i[r+(A<<2)>>2]=i[h+12>>2],v=h+16|0;return}I4(),M()}function sI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;f=v-32|0,v=f,i[A+32>>2]=p[e>>1]|p[e+2>>1]<<16,e=0,p[A+32>>1]|p[A+34>>1]&&(r=C(120),e=r,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=97628,e=e+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[e>>2]=95244,i[r+32>>2]=1668050025,k=i[A+32>>2],X[r+114>>1]=k,X[r+116>>1]=k>>>16),i[f+20>>2]=r,i[f+16>>2]=e,r=i[f+20>>2],e=i[f+16>>2],i[f+24>>2]=e,i[f+28>>2]=r,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=e,i[f+12>>2]=r,O4(A,f+8|0,0),e=i[f+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=f+32|0}function Lt(){ev(91416,17463),iv(91440,10665,1,0),d8(91452,8342,1,-128,127),d8(91476,8335,1,-128,127),d8(91464,8333,1,0,255),d8(91488,3983,2,-32768,32767),d8(91500,3974,2,0,65535),d8(91512,3998,4,-2147483648,2147483647),d8(91524,3989,4,0,-1),d8(91536,12019,4,-2147483648,2147483647),d8(91548,12010,4,0,-1),Th(91560,4795,-2147483648,2147483647),Th(91572,4794,0,-1),G9(91584,4633,4),G9(91596,14764,8),cB(102728,12115),eA(69964,4,12089),eA(70036,2,12127),eA(70112,4,12142),bB(102804),s4(70188,0,22469),s4(70228,0,22538),s4(102912,1,22499),s4(70268,2,22034),s4(70308,3,22065),s4(70348,4,22105),s4(70388,5,22134),s4(70428,4,22575),s4(70468,5,22605),s4(70228,0,22236),s4(102912,1,22203),s4(70268,2,22302),s4(70308,3,22268),s4(70348,4,22436),s4(70388,5,22402),s4(70508,8,22369),s4(70548,9,22335),s4(70588,6,22172),s4(70628,7,22644)}function hI(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(_=l-8|0,B=r-4|0;;){for(r=(w<<1)+o|0,l=B+(g(f,w)<<1)|0,s=0;X[r>>1]=(((((p[l>>1]+g(p[l+2>>1],-5)|0)+g(p[l+4>>1],17)|0)+g(p[l+6>>1],58)|0)+g(p[l+8>>1],-10)|0)+(p[l+10>>1]<<2)|0)-p[l+12>>1]>>_,l=l+2|0,r=(n<<1)+r|0,s=s+1|0,(s|0)!=(k|0););if(w=w+1|0,(w|0)==(n|0))break}for(_=n&2147483644,w=n&3,f=0,B=n>>>0<4;;){if(r=(f<<1)+A|0,l=(g(f,n)<<1)+o|0,s=0,!B)for(;X[r>>1]=p[l>>1],h=r,r=e<<1,h=h+r|0,X[h>>1]=p[l+2>>1],h=r+h|0,X[h>>1]=p[l+4>>1],h=r+h|0,X[h>>1]=p[l+6>>1],r=r+h|0,l=l+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,w)for(;X[r>>1]=p[l>>1],l=l+2|0,r=(e<<1)+r|0,s=s+1|0,(w|0)!=(s|0););if(f=f+1|0,(k|0)==(f|0))break}}}function wI(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(_=l-8|0,B=r-6|0;;){for(r=(w<<1)+o|0,l=B+(g(f,w)<<1)|0,s=0;X[r>>1]=p[l+12>>1]+((((((p[l+2>>1]<<2)-p[l>>1]|0)+g(p[l+4>>1],-10)|0)+g(p[l+6>>1],58)|0)+g(p[l+8>>1],17)|0)+g(p[l+10>>1],-5)|0)>>_,l=l+2|0,r=(n<<1)+r|0,s=s+1|0,(s|0)!=(k|0););if(w=w+1|0,(w|0)==(n|0))break}for(_=n&2147483644,w=n&3,f=0,B=n>>>0<4;;){if(r=(f<<1)+A|0,l=(g(f,n)<<1)+o|0,s=0,!B)for(;X[r>>1]=p[l>>1],h=r,r=e<<1,h=h+r|0,X[h>>1]=p[l+2>>1],h=r+h|0,X[h>>1]=p[l+4>>1],h=r+h|0,X[h>>1]=p[l+6>>1],r=r+h|0,l=l+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,w)for(;X[r>>1]=p[l>>1],l=l+2|0,r=(e<<1)+r|0,s=s+1|0,(w|0)!=(s|0););if(f=f+1|0,(k|0)==(f|0))break}}}function _I(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;n=v-32|0,v=n;i:{if(!f){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}k=i[e>>2],o=i[k+240>>2],k=i[k+244>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);e:{if(i[o+196>>2]!=(r|0)){if(i[f>>2]=0,t[n|0]=0,t[n+11|0]=0,r=a(n+12|0,5,2e3,n),t[n+11|0]<0&&Z(i[n>>2]),f=A,A=i[e>>2],c0(f,r,A?A+164|0:0),t[r+19|0]>=0)break e;Z(i[r+8>>2]);break e}r=C(16),i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,k&&(i[k+4>>2]=i[k+4>>2]+1),i[r+4>>2]=k,i[r>>2]=o,r=i[e+8>>2],f=i[f>>2],o=i[e+12>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=o;r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;W[i[i[r>>2]+8>>2]](r),y(r)}r=A,A=i[e>>2],c0(r,114912,A?A+164|0:0)}if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}v=n+32|0}function qt(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;if(!r){e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794];return}i:{if(f=i[e+16>>2],!f||(n=Z0(f,101112,102404),!n))break i;f=i[e+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),e=i[n+12>>2],n=i[n+8>>2],s=e-n|0,o=s>>3;e:{if((o|0)<=0)break e;if(e=0,(s|0)!=8)for(w=o&2147483646,o=0;k=e<<3,l=k+r|0,h=n+k|0,i[l>>2]=i[h>>2],i[l+4>>2]=i[h+4>>2],k=k|8,l=k+r|0,k=n+k|0,i[l>>2]=i[k>>2],i[l+4>>2]=i[k+4>>2],e=e+2|0,o=o+2|0,(w|0)!=(o|0););if(!(s&8))break e;e=e<<3,r=e+r|0,e=e+n|0,i[r>>2]=i[e>>2],i[r+4>>2]=i[e+4>>2]}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680];e:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break e;W[i[i[f>>2]+8>>2]](f),y(f)}return}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794]}function BI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-32|0,v=f,i[A+28>>2]=r,i[A+24>>2]=e,r=0,e=0,i[A+24>>2]!=i[A+28>>2]&&(r=C(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97468,e=r+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[e>>2]=95084,i[r+32>>2]=1885434736,i[r+116>>2]=i[A+24>>2],i[r+120>>2]=i[A+28>>2]),i[f+20>>2]=r,i[f+16>>2]=e,r=i[f+20>>2],e=i[f+16>>2],i[f+24>>2]=e,i[f+28>>2]=r,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=e,i[f+12>>2]=r,O4(A,f+8|0,0),e=i[f+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=f+32|0}function vI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0;o=v-16|0,v=o,n=C(24),i[n+20>>2]=f,i[n+16>>2]=r,i[n+12>>2]=102204,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=102468,r=i[e+8>>2],i[o+12>>2]=n,f=n+12|0,i[o+8>>2]=f,i[n+4>>2]=i[n+4>>2]+1,P0(r+12|0,o+8|0),r=i[o+12>>2];i:{if(!r||(l=i[r+4>>2],i[r+4>>2]=l-1,l))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!k||(i[n+4>>2]=i[n+4>>2]+1,r=C(24),i[n+4>>2]=i[n+4>>2]+1,i[r+20>>2]=n,i[r+16>>2]=f,l=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=l,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[k>>2]=r,e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[n+4>>2],i[n+4>>2]=A-1,A||(W[i[i[n>>2]+8>>2]](n),y(n)),v=o+16|0}function mI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;o=v-32|0,v=o,l=W[i[i[e>>2]+52>>2]](e,r,0)|0,k=+(1<<i[e+152>>2]>>>0),n=u0[e+104>>3]*k,B2(n)<2147483647?f=~~n:f=-2147483648,p0(r,f),n=u0[e+112>>3]*k,B2(n)<2147483647?f=~~n:f=-2147483648,p0(r,f),n=u0[e+120>>3]*k,B2(n)<2147483647?f=~~n:f=-2147483648,p0(r,f),t[e+100|0]&1&&(k=u0[e+136>>3]*k,B2(k)<2147483647?f=~~k:f=-2147483648,p0(r,f),k=u0[e+144>>3]*+(1<<i[e+156>>2]>>>0),B2(k)<2147483647?f=~~k:f=-2147483648,p0(r,f)),i[r+12>>2]=l,W[i[i[e>>2]+56>>2]](o+12|0,e,r,i[r+4>>2]-(i[r>>2]+l|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[o+31|0]<0&&Z(i[o+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=o+32|0}function ZI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;k=v-32|0,v=k,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=u[e+97|0];i:{if(f>>>0<=1&&(u2(r,p[e+104>>1]),u2(r,p[e+108>>1]),M4(r,e+116|0,1),M4(r,e+128|0,1),M4(r,e+140|0,1),f=u[e+97|0],f>>>0<2))break i;e:{r:switch(f-2|0){case 0:u2(r,p[e+104>>1]);break e;case 1:break r;default:break e}p0(r,i[e+104>>2])}if(u2(r,p[e+108>>1]),p0(r,i[e+112>>2]),M4(r,e+116|0,1),f=i[e+112>>2],(f|0)==1970432288)f=152;else{if((f|0)!=1835625829)break i;M4(r,e+128|0,1),f=140}M4(r,f+e|0,1)}i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function at(A){var e=0,r=0,f=0,k=0,n=0;if(e=i[A+428>>2],r=i[A+424>>2],(e|0)!=(r|0))for(;;){if(k=i[(f<<2)+r>>2],k){if(H4(i[k+140>>2]+548|0,i[k>>2]),e=i[k+132>>2],e){if(n=e-4|0,r=i[n>>2],r)for(r=e+g(r,18608)|0;l6(r-36|0),r=r-18608|0,(e|0)!=(r|0););Z(n)}Z(k),r=i[A+424>>2],e=i[A+428>>2]}if(f=f+1|0,!(f>>>0<e-r>>2>>>0))break}if(e=i[A+456>>2],f=i[A+460>>2],(e|0)!=(f|0))for(r=0;k=i[(r<<2)+e>>2],k&&(W[i[i[k>>2]+4>>2]](k),f=i[A+460>>2],e=i[A+456>>2]),r=r+1|0,r>>>0<f-e>>2>>>0;);if(f=i[A+468>>2],f){if(e=f,r=i[A+472>>2],(e|0)!=(r|0)){for(;r=l6(r-8|0),(f|0)!=(r|0););e=i[A+468>>2]}i[A+472>>2]=f,Z(e),e=i[A+456>>2]}return e&&(i[A+460>>2]=e,Z(e)),e=i[A+436>>2],e&&(i[A+440>>2]=e,Z(e)),e=i[A+424>>2],e&&(i[A+428>>2]=e,Z(e)),A5(A+8|0),A}function gI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+104>>2],o=i[e+108>>2];i:{if(u[e+97|0]==1){h4(r,k,o),h4(r,i[e+112>>2],i[e+116>>2]),p0(r,i[e+120>>2]),p0(r,0),h4(r,i[e+128>>2],i[e+132>>2]);break i}p0(r,k),p0(r,i[e+112>>2]),p0(r,i[e+120>>2]),p0(r,0),p0(r,i[e+128>>2])}h4(r,0,0),u2(r,p[e+136>>1]),u2(r,p[e+138>>1]),u2(r,p[e+140>>1]),u2(r,0),p0(r,i[e+144>>2]),p0(r,i[e+148>>2]),p0(r,i[e+152>>2]),p0(r,i[e+156>>2]),p0(r,i[e+160>>2]),p0(r,i[e+164>>2]),p0(r,i[e+168>>2]),p0(r,i[e+172>>2]),p0(r,i[e+176>>2]),p0(r,i[e+180>>2]),p0(r,i[e+184>>2]),n1(f+12|0,e,r,n),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function l8(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;i:{e:{f=i[A+4>>2],k=i[A+8>>2];r:{if(f>>>0<k>>>0){n=i[e+8>>2],s=i[e+12>>2],k=i[e+16>>2],o=i[e+20>>2],r=i[r>>2],h=i[e>>2],l=i[e+4>>2],i[f+24>>2]=i[e+24>>2],e=f,i[e+16>>2]=k,i[e+20>>2]=o,i[e+8>>2]=n,i[e+12>>2]=s,i[e>>2]=h,i[e+4>>2]=l,i[e+28>>2]=r,e=e+32|0;break r}if(n=i[A>>2],s=f-n|0,o=s>>5,f=o+1|0,f>>>0>=134217728)break e;if(k=k-n|0,h=k>>4,k=k>>>0>=2147483616?134217727:f>>>0<h>>>0?h:f,k){if(k>>>0>=134217728)break i;f=C(k<<5)}else f=0;if(h=i[r>>2],l=i[e+4>>2],r=f+s|0,i[r>>2]=i[e>>2],i[r+4>>2]=l,i[r+24>>2]=i[e+24>>2],l=i[e+20>>2],i[r+16>>2]=i[e+16>>2],i[r+20>>2]=l,l=i[e+12>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=l,i[r+28>>2]=h,o=r-(o<<5)|0,s&&z(o,n,s),i[A+8>>2]=f+(k<<5),e=r+32|0,i[A+4>>2]=e,i[A>>2]=o,!n)break r;Z(n)}i[A+4>>2]=e;return}s0(),M()}x0(),M()}function Kt(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;i:{if(r=i[A+8>>2],f=i[A>>2],r-f>>2){k=i[A+4>>2],l=k-f>>2,s=l&&1;e:{if(!s)break e;if(n=i[e>>2],r=f,o=s,h=o&7,h)for(;i[r>>2]=n,o=o-1|0,r=r+4|0,w=w+1|0,(w|0)!=(h|0););if(s>>>0<8)break e;for(;i[r+28>>2]=n,i[r+24>>2]=n,i[r+20>>2]=n,i[r+16>>2]=n,i[r+12>>2]=n,i[r+8>>2]=n,i[r+4>>2]=n,i[r>>2]=n,r=r+32|0,o=o-8|0,!!o;);}if(!l){for(f=(1-l<<2)+k|0,e=i[e>>2];i[k>>2]=e,k=k+4|0,(f|0)!=(k|0););i[A+4>>2]=f;return}break i}if(f&&(i[A+4>>2]=f,Z(f),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r=0),f=r>>1,f=r>>>0>=2147483644?1073741823:f>>>0<=1?1:f,f>>>0<1073741824){for(r=f<<2,f=C(r),i[A>>2]=f,i[A+8>>2]=r+f,e=i[e>>2],r=f;i[r>>2]=e,r=r+4|0,k=k+1|0,(k|0)!=1;);break i}s0(),M()}i[A+4>>2]=f+4}function $6(A,e,r,f,k,n){var o=0,l=0;o=v-48|0,v=o,l=i[A+92>>2],i[A+92>>2]=l+1,i[o+44>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,t[o+32|0]=1,i[o+28>>2]=n,i[o+24>>2]=k,X[o+20>>1]=f,i[o+16>>2]=0,X[o+12>>1]=r,i[o+8>>2]=e,i[o+4>>2]=l,e=i[A+84>>2];i:{if(e>>>0<o0[A+88>>2]){r=i[o+8>>2],i[e>>2]=i[o+4>>2],i[e+4>>2]=r,r=u[o+29|0]|u[o+30|0]<<8|(u[o+31|0]<<16|u[o+32|0]<<24),f=u[o+25|0]|u[o+26|0]<<8|(u[o+27|0]<<16|u[o+28|0]<<24),t[e+21|0]=f,t[e+22|0]=f>>>8,t[e+23|0]=f>>>16,t[e+24|0]=f>>>24,t[e+25|0]=r,t[e+26|0]=r>>>8,t[e+27|0]=r>>>16,t[e+28|0]=r>>>24,r=i[o+24>>2],i[e+16>>2]=i[o+20>>2],i[e+20>>2]=r,r=i[o+16>>2],i[e+8>>2]=i[o+12>>2],i[e+12>>2]=r,r=i[o+40>>2],i[e+32>>2]=i[o+36>>2],i[e+36>>2]=r,i[e+40>>2]=i[o+44>>2],i[A+84>>2]=e+44;break i}if(e=U8(A+80|0,o+4|0),r=t[o+47|0],i[A+84>>2]=e,(r|0)>=0)break i;Z(i[o+36>>2])}v=o+48|0}function GI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f,A=i[A>>2],n=i[A+48>>2],k=i[A+52>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,L1(f,n,e,f+20|0);i:{if(i[f>>2]|!r||(e=r-1|0,A=i[f+20>>2],e>>>0>=i[f+24>>2]-A>>3>>>0))break i;if(A=A+(e<<3)|0,e=i[A>>2],A=i[A+4>>2],!A){o=i[e+16>>2];break i}if(r=i[A+4>>2],n=r+1|0,i[A+4>>2]=n,o=i[e+16>>2],i[A+4>>2]=r,n)break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(t[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+20>>2],e){if(A=e,r=i[f+24>>2],(A|0)!=(r|0)){for(;;){A=i[r-4>>2];i:{if(!A||(n=i[A+4>>2],i[A+4>>2]=n-1,n))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=r-8|0,(e|0)==(r|0))break}A=i[f+20>>2]}i[f+24>>2]=e,Z(A)}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}return v=f+32|0,o|0}function $t(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;s=v-32|0,v=s;i:{e:{r:{if((e|0)!=(r|0)){if(w=i[33136],i[33136]=0,o=v-16|0,v=o,e1(),n=v-16|0,v=n,k=v-16|0,v=k,E5(k,e,s+28|0,2),l=i[k>>2],h=i[k+4>>2],e=n,n=i[k+12>>2],i[e+8>>2]=i[k+8>>2],i[e+12>>2]=n,i[e>>2]=l,i[e+4>>2]=h,v=k+16|0,n=i[e>>2],l=i[e+4>>2],k=o,o=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=o,i[k>>2]=n,i[k+4>>2]=l,v=e+16|0,o=i[k>>2],n=i[k+4>>2],l=i[k+12>>2],e=s,i[e+16>>2]=i[k+8>>2],i[e+20>>2]=l,i[e+8>>2]=o,i[e+12>>2]=n,v=k+16|0,k=i[e+16>>2],n=i[e+20>>2],o=i[e+8>>2],l=i[e+12>>2],h=i[33136],!h)break r;if(i[e+28>>2]!=(r|0))break e;if(_=o,B=l,m=k,G=n,(h|0)!=68)break i;break e}i[f>>2]=4;break i}if(i[33136]=w,i[s+28>>2]==(r|0))break i}i[f>>2]=4,o=_,l=B,k=m,n=G}i[A>>2]=o,i[A+4>>2]=l,i[A+8>>2]=k,i[A+12>>2]=n,v=s+32|0}function WI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+104>>2],o=i[e+108>>2];i:{if(u[e+97|0]==1){h4(r,k,o),h4(r,i[e+112>>2],i[e+116>>2]),p0(r,i[e+120>>2]),h4(r,i[e+128>>2],i[e+132>>2]);break i}p0(r,k),p0(r,i[e+112>>2]),p0(r,i[e+120>>2]),p0(r,i[e+128>>2])}p0(r,i[e+136>>2]),u2(r,p[e+140>>1]),u2(r,0),h4(r,0,0),p0(r,i[e+144>>2]),p0(r,i[e+148>>2]),p0(r,i[e+152>>2]),p0(r,i[e+156>>2]),p0(r,i[e+160>>2]),p0(r,i[e+164>>2]),p0(r,i[e+168>>2]),p0(r,i[e+172>>2]),p0(r,i[e+176>>2]),p0(r,0),p0(r,0),p0(r,0),p0(r,0),p0(r,0),p0(r,0),p0(r,i[e+180>>2]),n1(f+12|0,e,r,n),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function dt(A,e){var r=0,f=0;if(!(p[e+6>>1]!=2|p[e+8>>1]!=2|(!u[e+12|0]|p[e+10>>1]!=2))){i[A>>2]=0,i[A+4>>2]=0;return}r=C(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97388,f=r+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[f>>2]=101860,i[r+32>>2]=1668246642,i[r+116>>2]=0,i[r+120>>2]=0,i[A+4>>2]=r,i[A>>2]=f,f=p[e+10>>1]|p[e+12>>1]<<16,A=p[e+6>>1]|p[e+8>>1]<<16,e=C(24),i[e+16>>2]=A,i[e+20>>2]=f,i[e+12>>2]=101820,i[e>>2]=101740,i[e+4>>2]=1,i[e+8>>2]=0,i[r+120>>2]=e,i[r+116>>2]=e+12,A=i[e+4>>2],i[e+4>>2]=A-1,A||(W[i[i[e>>2]+8>>2]](e),y(e))}function XI(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;t[A+121|0]=0,t[A+122|0]=0,t[A+123|0]=0,t[A+124|0]=0,e=u[A+120|0],s=i[A+108>>2],k=i[A+104>>2],o=s-k>>>0>2097120&&e>>>0<=2?2:e;i:{if((k|0)!=(s|0)){for(e=k;f=o0[e>>2]>65535&&(o|0)<=2?2:o,o=u[e+4|0]&&(f|0)<=1?1:f,f=i[e+16>>2],l=i[f+16>>2],r=r+i[f+20>>2]|0,h=n,n=n+l|0,r=h>>>0>n>>>0?r+1|0:r,e=e+32|0,(s|0)!=(e|0););for(t[A+121|0]=4,t[A+122|0]=4,t[A+123|0]=(r-(n>>>0<4026531840)|0)!=-1?8:4;;){if(n=0,r=0,e=i[k+16>>2],h=i[k+20>>2],(e|0)!=(h|0))for(;(r|0)==1|r>>>0>1&&(t[A+121|0]=8),f=i[e+16>>2],l=i[e+20>>2],(l|0)==1|l>>>0>1&&(t[A+122|0]=8),r=r+l|0,n=f+n|0,r=n>>>0<f>>>0?r+1|0:r,e=e+40|0,(h|0)!=(e|0););if(k=k+32|0,(s|0)==(k|0))break}break i}t[A+121|0]=4,t[A+122|0]=4,t[A+123|0]=4}t[A+97|0]=o}function bt(A,e,r){var f=0,k=0;i:{e:{if(!r){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+332>>2],e=i[e+328>>2],(r|0)==(e|0))break e;if(k=r-e|0,(k|0)<0)break i;for(f=C(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k;i[f>>2]=i[e>>2],k=i[e+4>>2],i[f+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),f=f+8|0,e=e+8|0,(r|0)!=(e|0););i[A+4>>2]=f;return}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=i[e+328>>2],e=i[e+332>>2],(f|0)==(e|0))break e;if(k=r&4,!(r&2)){if(!k){for(;;)if(P0(A,f),f=f+8|0,(e|0)==(f|0))break e}for(;u[i[f>>2]+236|0]||P0(A,f),f=f+8|0,(e|0)!=(f|0););break e}if(!k){for(;;)if(u[i[f>>2]+224|0]||P0(A,f),f=f+8|0,(e|0)==(f|0))break e}for(;r=i[f>>2],u[r+224|0]|u[r+236|0]||P0(A,f),f=f+8|0,(e|0)!=(f|0););}return}s0(),M()}function ct(A,e){var r=0,f=0;if(!i[e+16>>2]){i[A>>2]=0,i[A+4>>2]=0;return}if(r=C(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97388,f=r+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=92500,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[f>>2]=101860,i[r+32>>2]=1668246642,i[r+116>>2]=0,i[r+120>>2]=0,i[A+4>>2]=r,i[A>>2]=f,A=i[e+16>>2],f=i[e+20>>2],f){i[f+4>>2]=i[f+4>>2]+2,i[r+116>>2]=A,e=i[r+120>>2],i[r+120>>2]=f;i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}A=i[f+4>>2],i[f+4>>2]=A-1,A||(W[i[i[f>>2]+8>>2]](f),y(f));return}i[r+120>>2]=f,i[r+116>>2]=A}function io(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0;l=v-32|0,v=l,o=C(204),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=100736,h=e,w=e3(o+12|0),i[h+48>>2]=w,n=i[e+52>>2],i[e+52>>2]=o;i:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break i;W[i[i[n>>2]+8>>2]](n),y(n)}s=i[e+48>>2],i[s+168>>2]=e- -64,o=v-16|0,v=o,n=C(72),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=101400,r=be(n+16|0,r,f,k),i[o+12>>2]=n,i[o+8>>2]=r,i[n+4>>2]=i[n+4>>2]+1,fA(l+8|0,s,o+8|0),r=i[o+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[n+4>>2],i[n+4>>2]=r-1,r||(W[i[i[n>>2]+8>>2]](n),y(n)),v=o+16|0;i:{if(i[l+8>>2]){e=i[l+12>>2],i[A>>2]=i[l+8>>2],i[A+4>>2]=e,e=i[l+20>>2],i[A+8>>2]=i[l+16>>2],i[A+12>>2]=e,i[A+16>>2]=i[l+24>>2];break i}if(rA(A,e),t[l+27|0]>=0)break i;Z(i[l+16>>2])}v=l+32|0}function II(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-16|0,v=r;i:{if((e|0)<12||(e=u[A+8|0],!e)||(k=u[A+9|0],!k)||(n=u[A+10|0],!n)||(A=u[A+11|0],!A))break i;if(t[r+15|0]=0,t[r+14|0]=A,t[r+13|0]=n,t[r+12|0]=k,t[r+11|0]=e,!N2(r+11|0,19740,5)){f=1;break i}if(!N2(r+11|0,3122,5)){f=2;break i}if(!N2(r+11|0,19595,5)){f=3;break i}if(!N2(r+11|0,1798,5)){f=4;break i}if(f=5,A=r+11|0,!N2(A,10141,5))break i;if(!N2(A,5649,5)){f=6;break i}if(!N2(r+11|0,10092,5)){f=7;break i}if(!N2(r+11|0,4803,5)){f=8;break i}if(!N2(r+11|0,23546,5)){f=9;break i}if(!N2(r+11|0,23541,5)){f=10;break i}if(!N2(r+11|0,12407,5)){f=11;break i}if(!N2(r+11|0,5644,5)){f=12;break i}if(!N2(r+11|0,19729,5)){f=13;break i}if(!N2(r+11|0,11579,5)){f=17;break i}f=N2(r+11|0,5660,5)?0:18}return v=r+16|0,f|0}function eo(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;i:{e:{if(s=i[A+24>>2],r=i[A+20>>2],(s|0)!=(r|0)){if(k=s-r|0,e=k>>2,e>>>0<2)break i;if(f=1,o=e-1|0,_=o&1,e=i[i[r>>2]+96>>2],(k|0)==8){o=0;break e}for(B=o&-2,o=0,k=0;n=i[i[r+(f<<2)>>2]+96>>2],l=(n|0)<(e|0),h=f+1|0,w=i[i[r+(h<<2)>>2]+96>>2],e=l?n:e,n=(w|0)<(e|0),e=n?w:e,o=n?h:l?f:o,f=f+2|0,k=k+2|0,(B|0)!=(k|0););break e}U0(30195,20005,147,7795),M()}if(!_)break i;o=i[i[r+(f<<2)>>2]+96>>2]<(e|0)?f:o}k=r,l=i[A+52>>2],e=l+i[A+48>>2]|0,n=i[A+40>>2],f=i[A+36>>2],(e|0)==(((f|0)!=(n|0)?(n-f<<8)-1|0:0)|0)&&(ar(A+32|0),l=i[A+52>>2],e=l+i[A+48>>2]|0,s=i[A+24>>2],f=i[A+36>>2],k=i[A+20>>2]),n=r,r=o<<2,i[i[(e>>>8&16777212)+f>>2]+((e&1023)<<2)>>2]=i[n+r>>2],i[A+52>>2]=l+1,k=r+k|0,r=s-4|0,i[k>>2]=i[r>>2],i[A+24>>2]=r}function QI(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(w=r-3|0;;){for(s=(h<<1)+o|0,r=w+g(f,h)|0,l=0;X[s>>1]=(((((u[r+1|0]<<2)-u[r|0]|0)+g(u[r+4|0]+u[r+3|0]|0,40)|0)+(u[r+6|0]<<2)|0)-u[r+7|0]|0)+g(u[r+5|0]+u[r+2|0]|0,-11),r=r+1|0,s=(n<<1)+s|0,l=l+1|0,(l|0)!=(k|0););if(h=h+1|0,(h|0)==(n|0))break}for(_=n&2147483644,w=n&3,f=0,B=n>>>0<4;;){if(s=(f<<1)+A|0,r=(g(f,n)<<1)+o|0,h=0,!B)for(;X[s>>1]=p[r>>1],l=s,s=e<<1,l=l+s|0,X[l>>1]=p[r+2>>1],l=s+l|0,X[l>>1]=p[r+4>>1],l=s+l|0,X[l>>1]=p[r+6>>1],s=s+l|0,r=r+8|0,h=h+4|0,(_|0)!=(h|0););if(l=0,w)for(;X[s>>1]=p[r>>1],r=r+2|0,s=(e<<1)+s|0,l=l+1|0,(w|0)!=(l|0););if(f=f+1|0,(k|0)==(f|0))break}}}function VI(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(w=r-3|0;;){for(s=(h<<1)+o|0,r=w+g(f,h)|0,l=0;X[s>>1]=u[r+6|0]+((((((u[r+1|0]<<2)-u[r|0]|0)+g(u[r+2|0],-10)|0)+g(u[r+3|0],58)|0)+g(u[r+4|0],17)|0)+g(u[r+5|0],-5)|0),r=r+1|0,s=(n<<1)+s|0,l=l+1|0,(l|0)!=(k|0););if(h=h+1|0,(h|0)==(n|0))break}for(_=n&2147483644,w=n&3,f=0,B=n>>>0<4;;){if(s=(f<<1)+A|0,r=(g(f,n)<<1)+o|0,h=0,!B)for(;X[s>>1]=p[r>>1],l=s,s=e<<1,l=l+s|0,X[l>>1]=p[r+2>>1],l=s+l|0,X[l>>1]=p[r+4>>1],l=s+l|0,X[l>>1]=p[r+6>>1],s=s+l|0,r=r+8|0,h=h+4|0,(_|0)!=(h|0););if(l=0,w)for(;X[s>>1]=p[r>>1],r=r+2|0,s=(e<<1)+s|0,l=l+1|0,(w|0)!=(l|0););if(f=f+1|0,(k|0)==(f|0))break}}}function pI(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(w=r-2|0;;){for(s=(h<<1)+o|0,r=w+g(f,h)|0,l=0;X[s>>1]=(((((u[r|0]+g(u[r+1|0],-5)|0)+g(u[r+2|0],17)|0)+g(u[r+3|0],58)|0)+g(u[r+4|0],-10)|0)+(u[r+5|0]<<2)|0)-u[r+6|0],r=r+1|0,s=(n<<1)+s|0,l=l+1|0,(l|0)!=(k|0););if(h=h+1|0,(h|0)==(n|0))break}for(_=n&2147483644,w=n&3,f=0,B=n>>>0<4;;){if(s=(f<<1)+A|0,r=(g(f,n)<<1)+o|0,h=0,!B)for(;X[s>>1]=p[r>>1],l=s,s=e<<1,l=l+s|0,X[l>>1]=p[r+2>>1],l=s+l|0,X[l>>1]=p[r+4>>1],l=s+l|0,X[l>>1]=p[r+6>>1],s=s+l|0,r=r+8|0,h=h+4|0,(_|0)!=(h|0););if(l=0,w)for(;X[s>>1]=p[r>>1],r=r+2|0,s=(e<<1)+s|0,l=l+1|0,(w|0)!=(l|0););if(f=f+1|0,(k|0)==(f|0))break}}}function ro(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;l=i[e+12>>2],i[e+12>>2]=i[A+116>>2],h2(e,u[A+122|0]|u[A+121|0]<<4&240),h2(e,u[A+124|0]|u[A+123|0]<<4&240),r=i[A+108>>2]-i[A+104>>2]|0;i:{if(u[A+97|0]<=1){u2(e,r>>>5&65535);break i}p0(e,r>>5)}if(r=i[A+104>>2],k=i[A+108>>2],(r|0)!=(k|0))for(;;){f=i[r>>2];i:{if(u[A+97|0]<=1){u2(e,f&65535);break i}p0(e,f)}if(u[A+97|0]&&u2(e,u[r+4|0]),u2(e,p[r+6>>1]),f=u[A+123|0],f&&Y1(e,f,i[r+8>>2],i[r+12>>2]),u2(e,(i[r+20>>2]-i[r+16>>2]|0)/40&65535),f=i[r+16>>2],n=i[r+20>>2],(f|0)!=(n|0))for(;;){i:{if(!u[A+97|0]||(o=u[A+124|0],!o))break i;Y1(e,o,i[f>>2],i[f+4>>2])}if(Y1(e,u[A+121|0],i[f+8>>2],i[f+12>>2]),Y1(e,u[A+122|0],i[f+16>>2],i[f+20>>2]),f=f+40|0,(n|0)==(f|0))break}if(r=r+32|0,(k|0)==(r|0))break}i[e+12>>2]=l}function FI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;n=v-32|0,v=n,f=i[A+28>>2],i[n+16>>2]=f,o=i[A+20>>2],i[n+28>>2]=r,i[n+24>>2]=e,e=o-f|0,i[n+20>>2]=e,o=e+r|0,s=2;i:{e:{e=n+16|0,f=iA(i[A+60>>2],e|0,2,n+12|0)|0,f?(i[33136]=f,f=-1):f=0;r:{f:{if(f){f=e;break f}for(;;){if(k=i[n+12>>2],(k|0)==(o|0))break r;if((k|0)<0){f=e;break e}if(l=i[e+4>>2],h=l>>>0<k>>>0,f=(h?8:0)+e|0,l=k-(h?l:0)|0,i[f>>2]=l+i[f>>2],e=(h?12:4)+e|0,i[e>>2]=i[e>>2]-l,o=o-k|0,e=f,s=s-h|0,k=iA(i[A+60>>2],e|0,s|0,n+12|0)|0,k?(i[33136]=k,k=-1):k=0,!!k)break}}if((o|0)!=-1)break e}e=i[A+44>>2],i[A+28>>2]=e,i[A+20>>2]=e,i[A+16>>2]=e+i[A+48>>2],A=r;break i}if(i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A>>2]=i[A>>2]|32,A=0,(s|0)==2)break i;A=r-i[f+4>>2]|0}return v=n+32|0,A|0}function q2(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;e=i[A+112>>2],f=i[A+116>>2],s=(e|f)!=0,l=e,k=i[A+4>>2],n=i[A+44>>2],e=k-n|0,o=e,r=e+i[A+120>>2]|0,e=i[A+124>>2]+(e>>31)|0;i:{if(e=r>>>0<o>>>0?e+1|0:e,!(((e|0)>=(f|0)&r>>>0>=l>>>0|(e|0)>(f|0))&s)){if(s=b3(A),(s|0)>=0)break i;k=i[A+4>>2],n=i[A+44>>2]}return i[A+112>>2]=-1,i[A+116>>2]=-1,i[A+104>>2]=k,o=r,r=n-k|0,f=o+r|0,e=(r>>31)+e|0,i[A+120>>2]=f,i[A+124>>2]=r>>>0>f>>>0?e+1|0:e,-1}f=r+1|0,e=f?e:e+1|0,l=i[A+4>>2],n=i[A+8>>2],r=i[A+116>>2],o=r,k=i[A+112>>2];i:{if(!(r|k)||(r=k-f|0,k=o-(e+(f>>>0>k>>>0)|0)|0,h=n-l|0,o=h>>31,(k|0)>=(o|0)&r>>>0>=h>>>0|(k|0)>(o|0)))break i;n=r+l|0}return i[A+104>>2]=n,r=i[A+44>>2],n=r-l|0,f=n+f|0,e=(n>>31)+e|0,i[A+120>>2]=f,i[A+124>>2]=f>>>0<n>>>0?e+1|0:e,r>>>0>=l>>>0&&(t[l-1|0]=s),s}function CI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0;n=v-48|0,v=n;i:{e:{if(!(k&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break e}hA(n+20|0,i[e>>2],r,f);r:{f:switch(u[n+40|0]){default:e2(),M();case 1:c0(A,n+20|0,i[e>>2]);break r;case 0:break f}if(e=i[n+20>>2],!e){i[A>>2]=5,i[A+4>>2]=2007,i[A+8>>2]=2333;break r}if(i[n+16>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0,r=i[e+104>>2],f=i[e+100>>2],(r|0)!=(f|0)){if(e=r-f|0,(e|0)<0)break i;r=C(e),o=!e,o||z(r,f,e),o||z(k,r,e),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,Z(r);break r}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}if(A=u[n+40|0],(A|0)==255)break e;e=i[25805],i[n+8>>2]=i[25804],i[n+12>>2]=e,W[i[(n+8|0)+(A<<2)>>2]](n+47|0,n+20|0)}v=n+48|0;return}s0(),M()}function YI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(n=v-32|0,v=n,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+104>>2]),p0(r,i[e+112>>2]-i[e+108>>2]>>2),f=i[e+108>>2],k=i[e+112>>2],(f|0)!=(k|0))for(;p0(r,i[f>>2]),f=f+4|0,(k|0)!=(f|0););if(u2(r,p[e+120>>1]),u2(r,p[e+122>>1]),i[e+112>>2]!=i[e+108>>2])for(f=0;k=i[e+124>>2]+g(f,6)|0,u2(r,p[k>>1]),u2(r,p[k+2>>1]),u2(r,p[k+4>>1]),f=f+1|0,f>>>0<i[e+112>>2]-i[e+108>>2]>>2>>>0;);i[r+12>>2]=o,W[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+o|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[n+31|0]<0&&Z(i[n+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+32|0}function fo(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;B=e,m=F0(r),i[B+4>>2]=m;i:{if(h=Q2(r),!h)break i;e:{for(;;){r:{l=F0(r),f=i[e+12>>2],k=i[e+16>>2];f:{if(f>>>0<k>>>0){i[f>>2]=l,f=f+4|0;break f}if(s=i[e+8>>2],f=f-s|0,w=f>>2,n=w+1|0,n>>>0>=1073741824)break r;if(k=k-s|0,o=k>>1,k=k>>>0>=2147483644?1073741823:n>>>0<o>>>0?o:n,k){if(k>>>0>=1073741824)break e;n=C(k<<2)}else n=0;if(o=n+f|0,i[o>>2]=l,l=o-(w<<2)|0,f&&z(l,s,f),i[e+16>>2]=n+(k<<2),f=o+4|0,i[e+12>>2]=f,i[e+8>>2]=l,!s)break f;Z(s)}if(i[e+12>>2]=f,_=_+1|0,(_&255)>>>0<h>>>0)continue;break i}break}s0(),M()}x0(),M()}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function Ei(A,e,r,f){var k=0,n=0,o=0,l=0,s=0;n=v-48|0,v=n;i:{e:{if(k=i[A+20>>2],!k){k=0;break e}for(o=A+20|0,l=o;s=o0[k+16>>2]<e>>>0,l=s?l:k,k=i[(s?4:0)+k>>2],!!k;);if(k=0,(o|0)==(l|0)|o0[l+16>>2]>e>>>0||(o=i[l+20>>2],W[i[i[o>>2]+88>>2]](n+28|0,o),o=i[n+28>>2],t[n+47|0]<0&&Z(i[n+36>>2]),o)||(o=i[l+20>>2],k=i[l+24>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),!o))break e;i[n+20>>2]=i[r>>2],A=i[r+4>>2],i[n+24>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=i[n+24>>2],i[n+8>>2]=i[n+20>>2],i[n+12>>2]=A,A=O4(o,n+8|0,f);break i}A=a3(i[A+48>>2],e,r,f)}i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=i[r+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=n+48|0,A}function Ri(A,e,r,f,k,n,o,l,s,h){var w=0,_=0,B=0;w=v-16|0,v=w,t[w+15|0]=A;i:{e:{r:{if(_=i[f>>2],(_|0)!=(r|0))break r;if(B=A&255,(B|0)==u[h+24|0])A=43;else{if(u[h+25|0]!=(B|0))break r;A=45}i[f>>2]=_+1,t[_|0]=A;break e}if(u[o+11|0]>>>7|0?o=i[o+4>>2]:o=u[o+11|0]&127,!(!o|(A|0)!=(n|0))){if(A=0,e=i[s>>2],(e-l|0)>159)break i;A=i[k>>2],i[s>>2]=e+4,i[e>>2]=A;break e}if(A=-1,n=s7(h,h+26|0,w+15|0)-h|0,(n|0)>23)break i;r:{f:switch(e-8|0){case 0:case 2:if((e|0)>(n|0))break r;break i;case 1:break r;default:break f}if((e|0)!=16|(n|0)<22)break r;if(e=i[f>>2],(e|0)==(r|0)|(e-r|0)>2|u[e-1|0]!=48)break i;A=0,i[k>>2]=0,i[f>>2]=e+1,t[e|0]=u[n+83888|0];break i}A=i[f>>2],i[f>>2]=A+1,t[A|0]=u[n+83888|0],i[k>>2]=i[k>>2]+1,A=0;break i}A=0,i[k>>2]=0}return v=w+16|0,A}function Ao(A,e){var r=0,f=0,k=0,n=0,o=0;k=v-16|0,v=k,o=i[33178],i[e+72>>2]<=0&&l7(e),i[33178]=i[e+136>>2];i:{e:{r:{if(A>>>0<=127){f:{if(i[e+80>>2]==(A|0)||(r=i[e+20>>2],(r|0)==i[e+16>>2]))break f;i[e+20>>2]=r+1,t[r|0]=A;break i}f=v-16|0,v=f,t[f+15|0]=A,r=i[e+16>>2];f:{if(!r){if(S5(e)){r=-1;break f}r=i[e+16>>2]}A:{if(n=i[e+20>>2],(r|0)==(n|0)||(r=A&255,(r|0)==i[e+80>>2]))break A;i[e+20>>2]=n+1,t[n|0]=A;break f}if((W[i[e+36>>2]](e,f+15|0,1)|0)!=1){r=-1;break f}r=u[f+15|0]}v=f+16|0,A=r;break r}if(r=i[e+20>>2],o0[e+16>>2]>r+4>>>0){if(r=Zf(r,A),(r|0)<0)break e;i[e+20>>2]=r+i[e+20>>2];break r}if(f=k+12|0,r=Zf(f,A),(r|0)<0||D3(f,r,e)>>>0<r>>>0)break e}if((A|0)!=-1)break i}i[e>>2]=i[e>>2]|32,A=-1}return i[33178]=o,v=k+16|0,A}function yI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,9964);break i}k=i[e+100>>2]>>>8|0,i[e+152>>2]=k&31,o=1,n=+(1<<k>>>0),l=e,s=+(F0(r)|0)/n,u0[l+104>>3]=s,l=e,s=+(F0(r)|0)/n,u0[l+112>>3]=s,l=e,s=+(F0(r)|0)/n,u0[l+120>>3]=s,k=i[e+100>>2];e:{if(k&1){k=k>>>16|0,i[e+156>>2]=k&31,l=e,s=+(F0(r)|0)/n,u0[l+136>>3]=s,n=+(F0(r)|0)/+(1<<k>>>0);break e}i[e+136>>2]=0,i[e+140>>2]=0,o=0,n=0}if(u0[e+144>>3]=n,t[e+128|0]=o,u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function $A(){var A=0,e=0,r=0,f=0,k=0;A=i[28463],A&&W[A|0](),e=i[28739];i:{e:{if(!e){r=114956,A=114956;break e}for(;;){if(A=e,e=i[A+16>>2],e>>>0>113844){if(r=A,e=i[A>>2],e)continue;break e}if(e>>>0>=113844)break i;if(e=i[A+4>>2],!e)break}r=A+4|0}e=C(20),i[e+8>>2]=A,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=113844,i[r>>2]=e,A=i[i[28738]>>2],A&&(i[28738]=A),G1(i[28739],e),i[28740]=i[28740]+1}A=i[28489],A&&W[A|0](),A=C(4),i[A>>2]=113928,f=C(20),i[f+16>>2]=A,e=i[28742];i:{if(!e){A=114968,r=114968;break i}for(k=i[28485];;){if(A=e,i[i[i[A+16>>2]>>2]+12>>2]<(k|0)){if(r=A,e=i[A>>2],e)continue;break i}if(e=i[A+4>>2],!e)break}r=A+4|0}i[f+8>>2]=A,i[f>>2]=0,i[f+4>>2]=0,i[r>>2]=f,A=i[i[28741]>>2],A&&(i[28741]=A),G1(i[28742],f),i[28743]=i[28743]+1}function m3(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;Zr(),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(o=i[28741],(o|0)!=114968)for(;;){h=i[o+16>>2],f=i[h>>2];r:{if(i[f+4>>2]!=(e|0)&&e||r&&v4(r,i[f+8>>2]))break r;f:{if(k>>>0<n>>>0){i[k>>2]=h,k=k+4|0;break f}if(f=k-s|0,_=f>>2,l=_+1|0,l>>>0>=1073741824)break e;if(k=n-s|0,n=k>>1,n=k>>>0>=2147483644?1073741823:n>>>0>l>>>0?n:l,n){if(n>>>0>=1073741824)break i;k=C(n<<2)}else k=0;w=k+f|0,i[w>>2]=h,l=w-(_<<2)|0,f&&z(l,s,f),n=k+(n<<2)|0,i[A+8>>2]=n,k=w+4|0,i[A+4>>2]=k,i[A>>2]=l,s&&Z(s),s=l}i[A+4>>2]=k}f=i[o+4>>2];r:{if(f){for(;;)if(o=f,f=i[f>>2],!f)break r}for(;f=o,o=i[o+8>>2],(f|0)!=i[o>>2];);}if((o|0)==114968)break}return}s0(),M()}x0(),M()}function Ji(A,e,r,f,k,n,o,l,s,h){var w=0,_=0;w=v-16|0,v=w,i[w+12>>2]=A;i:{e:{r:{if(_=i[f>>2],(_|0)!=(r|0))break r;if(i[h+96>>2]==(A|0))A=43;else{if(i[h+100>>2]!=(A|0))break r;A=45}i[f>>2]=_+1,t[_|0]=A;break e}if(u[o+11|0]>>>7|0?o=i[o+4>>2]:o=u[o+11|0]&127,!(!o|(A|0)!=(n|0))){if(A=0,e=i[s>>2],(e-l|0)>159)break i;A=i[k>>2],i[s>>2]=e+4,i[e>>2]=A;break e}if(A=-1,n=u7(h,h+104|0,w+12|0)-h>>2,(n|0)>23)break i;r:{f:switch(e-8|0){case 0:case 2:if((e|0)>(n|0))break r;break i;case 1:break r;default:break f}if((e|0)!=16|(n|0)<22)break r;if(e=i[f>>2],(e|0)==(r|0)|(e-r|0)>2|u[e-1|0]!=48)break i;A=0,i[k>>2]=0,i[f>>2]=e+1,t[e|0]=u[n+83888|0];break i}A=i[f>>2],i[f>>2]=A+1,t[A|0]=u[n+83888|0],i[k>>2]=i[k>>2]+1,A=0;break i}A=0,i[k>>2]=0}return v=w+16|0,A}function EI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0;f=v-16|0,v=f,o=i[r+16>>2],w4(r,o),k=f+4|0,i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,o&&C5(k,o),l=i[r>>2],n=i[r+4>>2];i:{if(n){if(i[n+4>>2]=i[n+4>>2]+1,W[i[i[l>>2]+16>>2]](l,t[k+11|0]<0?i[k>>2]:k,o)|0,k=i[n+4>>2],i[n+4>>2]=k-1,k)break i;W[i[i[n>>2]+8>>2]](n),y(n);break i}W[i[i[l>>2]+16>>2]](l,t[k+11|0]<0?i[k>>2]:k,o)|0}t[e+111|0]<0&&Z(i[e+100>>2]),k=i[f+8>>2],i[e+100>>2]=i[f+4>>2],i[e+104>>2]=k,i[e+108>>2]=i[f+12>>2];i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function RI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;o=v-48|0,v=o;i:{if(!(n|!k)){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=21158;break i}l=i[e>>2],s=i[l+48>>2],l=i[l+52>>2];e:{if(!l){tn(o+12|0,s,r,f);break e}if(i[l+4>>2]=i[l+4>>2]+1,tn(o+12|0,s,r,f),r=i[l+4>>2],i[l+4>>2]=r-1,r)break e;W[i[i[l>>2]+8>>2]](l),y(l)}e:{r:{if(r=u[o+32|0],r){if(i[n>>2]=0,k&&(i[k>>2]=0),(r|0)==1)break r;e2(),M()}n&&(i[n>>2]=i[o+16>>2]-i[o+12>>2]);f:{if(!k||(r=i[o+12>>2],e=i[o+16>>2]-r|0,f=C(e),i[k>>2]=f,!e))break f;z(f,r,e)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],k=0;break e}if(c0(A,o+12|0,i[e>>2]),k=u[o+32|0],(k|0)==255)break i}A=i[25807],i[o+40>>2]=i[25806],i[o+44>>2]=A,W[i[(o+40|0)+(k<<2)>>2]](o+39|0,o+12|0)}v=o+48|0}function JI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,f=i[r+4>>2];i:{if(!(!u[k+12|0]|((f|0)==3|i[k+8>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:{if(!(i[r>>2]|(f|0)!=1)&&(f=i[r+12>>2],(f|0)>8))break e;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:{if(k=u[r+8|0],(k|0)!=1||(n=i[r+16>>2],!n|(f|0)==(n|0)))break e;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(n=p[r+24>>1],!(n>>>0>14|!(1<<n&18689))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,t[e+30|0]=1,X[e+28>>1]=2,i[e+20>>2]=0,i[e+24>>2]=131074,i[e+16>>2]=f,i[e+4>>2]=1,t[e+12|0]=k,i[e+8>>2]=k?15:14,i[e>>2]=11,f=e+4|0,l8(A,f,e),i[e+4>>2]=1,k=u[r+8|0],t[e+12|0]=k,i[e+8>>2]=k?13:12,i[e+16>>2]=i[r+12>>2],i[e>>2]=11,l8(A,f,e)}v=e+32|0}function dA(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;l=e+31|0,n=i[A+12>>2]<<7,f=p[A+20>>1],r=i[A+16>>2];i:{for(;;){f=f+1|0,X[A+20>>1]=f,r=r<<1,i[A+16>>2]=r,f=f<<16>>16;e:{if((f|0)<0||(f=65528,X[A+20>>1]=65528,k=i[A+4>>2],k>>>0>=o0[A+8>>2]))break e;i[A+4>>2]=k+1,r=u[k|0]|r,i[A+16>>2]=r}if(r>>>0<n>>>0)break i;if(r=r-n|0,i[A+16>>2]=r,o=(1<<e)+o|0,k=(e|0)==(l|0),e=e+1|0,!!k)break}return 0}if((e|0)<=8){if(!e)return o;f=e+f|0,X[A+20>>1]=f,r=r<<e,i[A+16>>2]=r,f=f<<16>>16;i:{if((f|0)<0||(k=i[A+4>>2],k>>>0>=o0[A+8>>2]))break i;i[A+4>>2]=k+1,k=u[k|0],X[A+20>>1]=f-8,r=k<<f|r}return f=(r>>>0)/(n>>>0)|0,e=1<<e,(f|0)>=(e|0)&&(f=e-1|0),i[A+16>>2]=r-g(f,n),f+o|0}for(r=e-8|0,e=nu(A);e=B4(A)|e<<1,r=r-1|0,!!r;);return e+o|0}function NI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;k=v-16|0,v=k;i:{if((e|0)!=-1){if(l=i[A+12>>2],s=i[A+8>>2],n=i[A+24>>2],(n|0)==i[A+28>>2]){if(r=-1,!(u[A+48|0]&16))break i;o=i[A+20>>2],h=i[A+44>>2],f=A+32|0,Ai(f,0),F2(f,u[f+11|0]>>>7|0?(i[f+8>>2]&2147483647)-1|0:10),u[f+11|0]>>>7|0?r=i[f>>2]:r=f,u[f+11|0]>>>7|0?f=i[f+4>>2]:f=u[f+11|0]&127,i[A+28>>2]=f+r,i[A+20>>2]=r,i[A+24>>2]=r,i[A+24>>2]=i[A+24>>2]+(n-o|0),i[A+44>>2]=i[A+20>>2]+(h-o|0)}i[k+12>>2]=i[A+24>>2]+1,r=v-16|0,v=r,v=r+16|0,f=A+44|0,r=k+12|0,i[A+44>>2]=i[(o0[r>>2]<o0[f>>2]?f:r)>>2],u[A+48|0]&8&&(r=A+32|0,u[r+11|0]>>>7|0&&(r=i[r>>2]),i[A+16>>2]=i[A+44>>2],i[A+12>>2]=r+(l-s|0),i[A+8>>2]=r),r=Is(A,e<<24>>24);break i}r=(e|0)!=-1?e:0}return v=k+16|0,r|0}function DI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0;f=v-32|0,v=f,l0(A,0,72),i[A+4>>2]=p[e+554>>1],i[A+8>>2]=p[e+552>>1],i[A+20>>2]=i[e+556>>2],i[A+24>>2]=i[e+560>>2],i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0;i:{e:{r:{f:{if(n=i[e+564>>2],r=i[e+568>>2],(n|0)==(r|0))break f;if(r=r-n|0,(r|0)<0)break i;if(k=C(r),i[f+20>>2]=k,o=r+k|0,i[f+28>>2]=o,r&&z(k,n,r),i[f+24>>2]=o,r=i[k>>2],!r)break f;if($1(f,i[e+180>>2],r,1),e=i[f+4>>2],r=i[f>>2],!r||(W[i[i[r>>2]+88>>2]](f,r),k=i[f>>2],t[f+19|0]<0&&Z(i[f+8>>2]),k))break r;i[A+12>>2]=i[r+200>>2],i[A+16>>2]=i[r+204>>2];break r}i[A+12>>2]=0,i[A+16>>2]=0;break e}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}A=i[f+20>>2],A&&Z(A),v=f+32|0;return}s0(),M()}function ko(A){var e=0;e=C(208),i[e+24>>2]=0,i[e+28>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,X[e+132>>1]=1,i[e+128>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e>>2]=97788,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e- -64>>2]=0,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[e+16>>2]=95440,i[e+152>>2]=0,i[e+156>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+160>>2]=0,i[e+164>>2]=1072693248,i[e+192>>2]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+176>>2]=0,i[e+180>>2]=0,i[e+168>>2]=0,i[e+172>>2]=0,t[e+204|0]=0,i[e+200>>2]=0,i[e+32>>2]=1668113784,i[A+4>>2]=e,i[A>>2]=e+16}function UI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;e=v-32|0,v=e,n=i[f+4>>2];i:{if(!(!u[k+12|0]|((n|0)==3|i[k+4>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:{if(!(i[r>>2]!=1|(i[r+4>>2]&-4)!=12)&&(k=i[r+12>>2],(k|0)>8))break e;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(o=p[f+24>>1],!(o>>>0>14|!(1<<o&18689))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!u[f+26|0]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(n|0)!=1)break i;i[e+4>>2]=0,i[e+8>>2]=1,i[e+20>>2]=0,r=u[r+8|0],i[e+16>>2]=k,t[e+12|0]=r,r=u[f+23|0]|u[f+24|0]<<8|(u[f+25|0]<<16|u[f+26|0]<<24),t[e+27|0]=r,t[e+28|0]=r>>>8,t[e+29|0]=r>>>16,t[e+30|0]=r>>>24,i[e+24>>2]=i[f+20>>2],i[e>>2]=11,l8(A,e+4|0,e)}v=e+32|0}function Ne(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;if((e|0)!=(r|0))for(l=A+4|0;;){k=i[A+4>>2];i:{e:{r:{if(f=l,h=i[A>>2],(f|0)==(h|0))break r;n=f,o=k;f:{if(k){for(;f=o,o=i[f+4>>2],!!o;);if(s=i[e>>2],s>>>0<=o0[f+16>>2])break f;break r}for(;f=i[n+8>>2],o=i[f>>2]==(n|0),n=f,!!o;);if(n=l,o=n,o0[f+16>>2]<o0[e>>2])break r;break e}for(;;){if(o=k,f=i[k+16>>2],f>>>0>s>>>0){if(n=k,k=i[k>>2],k)continue;break e}if(f>>>0>=s>>>0)break i;if(k=i[o+4>>2],!k)break}n=o+4|0;break e}if(n=k?f+4|0:l,i[n>>2])break i;o=k?f:l}f=C(20),k=i[e>>2],i[f+8>>2]=o,i[f>>2]=0,i[f+4>>2]=0,i[f+16>>2]=k,i[n>>2]=f,n=i[h>>2],n&&(i[A>>2]=n),G1(i[A+4>>2],f),i[A+8>>2]=i[A+8>>2]+1}if(e=e+4|0,(r|0)==(e|0))break}}function no(A){var e=0,r=0,f=0;return r=v-16|0,v=r,i[A+8>>2]=0,i[A+12>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,i[A>>2]=92500,i[A+36>>2]=0,i[A+40>>2]=0,i[A+56>>2]=-1,i[A+60>>2]=-1,i[A+72>>2]=0,i[A+76>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,i[A>>2]=95736,i[A+44>>2]=0,i[A+48>>2]=0,e=A- -64|0,i[e>>2]=-1,i[e+4>>2]=-1,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,t[A+96|0]=0,i[A+108>>2]=0,e=C(16),i[r+4>>2]=e,f=e+16|0,i[r+12>>2]=f,t[e+8|0]=172,t[e+9|0]=189,t[e+10|0]=157,t[e+11|0]=44,t[e+12|0]=142,t[e+13|0]=167,t[e+14|0]=53,t[e+15|0]=34,t[e|0]=38,t[e+1|0]=30,t[e+2|0]=243,t[e+3|0]=116,t[e+4|0]=29,t[e+5|0]=151,t[e+6|0]=91,t[e+7|0]=186,i[r+8>>2]=f,js(A,r+4|0),e=i[r+4>>2],e&&(i[r+8>>2]=e,Z(e)),v=r+16|0,A}function to(A,e,r,f){i:switch(e-9|0){case 0:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=i[e>>2];return;case 6:e=i[r>>2],i[r>>2]=e+4,e=X[e>>1],i[A>>2]=e,i[A+4>>2]=e>>31;return;case 7:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=p[e>>1],i[A+4>>2]=0;return;case 8:e=i[r>>2],i[r>>2]=e+4,e=t[e|0],i[A>>2]=e,i[A+4>>2]=e>>31;return;case 9:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=u[e|0],i[A+4>>2]=0;return;case 16:e=i[r>>2]+7&-8,i[r>>2]=e+8,u0[A>>3]=u0[e>>3];return;case 17:W[f|0](A,r);default:return;case 1:case 4:case 14:e=i[r>>2],i[r>>2]=e+4,e=i[e>>2],i[A>>2]=e,i[A+4>>2]=e>>31;return;case 2:case 5:case 11:case 15:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=i[e>>2],i[A+4>>2]=0;return;case 3:case 10:case 12:case 13:break i}e=i[r>>2]+7&-8,i[r>>2]=e+8,r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r}function MI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0;h=v-32|0,v=h,S2(h+12|0,e,r),t[h+31|0]<0&&Z(i[h+20>>2]);i:{f=i[r+16>>2],k=i[e+108>>2],o=i[e+104>>2],l=k-o|0;e:{if(f>>>0>l>>>0){if(s=f-l|0,n=i[e+112>>2],s>>>0<=n-k>>>0){s&&l0(k,0,s),i[e+108>>2]=k+s;break e}if((f|0)<0)break i;if(k=n-o|0,n=k<<1,n=k>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,k=C(n),s&&l0(k+l|0,0,s),l&&z(k,o,l),i[e+112>>2]=k+n,i[e+108>>2]=f+k,i[e+104>>2]=k,!o)break e;Z(o);break e}if(f>>>0>=l>>>0)break e;i[e+108>>2]=f+o}s6(r,i[e+104>>2],f),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;e:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731])}v=h+32|0;return}s0(),M()}function De(A,e,r,f,k,n,o,l){var s=0,h=0,w=0,_=0;if(h=v-16|0,v=h,(e^-1)+2147483639>>>0>=r>>>0){u[A+11|0]>>>7|0?s=i[A>>2]:s=A,_=s,s=h+4|0,e>>>0<1073741811?(i[h+12>>2]=e<<1,i[h+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=h+12|0,r=i[(o0[s>>2]<o0[r>>2]?r:s)>>2],r>>>0>=11?(w=r+8&-8,r=w-1|0,r=(r|0)==11?w:r):r=10,r=r+1|0):r=2147483639,fe(s,r),r=i[h+4>>2],k&&(s=!k,s|s||z(r,_,k)),o&&(s=r+k|0,w=!o,w|w||z(s,l,o)),s=k+n|0,l=f-s|0,(f|0)!=(s|0)&&(f=(r+k|0)+o|0,n=(k+_|0)+n|0,s=!l,s|s||z(f,n,l)),(e|0)!=10&&B6(_,1),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[h+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,e=A,A=l+(k+o|0)|0,i[e+4>>2]=A,t[h+12|0]=0,t[A+r|0]=u[h+12|0],v=h+16|0;return}I4(),M()}function e1(){var A=0,e=0,r=0,f=0,k=0,n=0;if(u[136820])return i[34204];r=v-32|0,v=r;i:{e:{for(;;){if(e=r+8|0,f=so(A,1<<A&2147483647?21731:47881),i[e+(A<<2)>>2]=f,(f|0)==-1)break e;if(A=A+1|0,(A|0)==6)break}if(A=79272,!N2(e,79272,24)||(A=79296,!N2(e,79296,24)))break i;if(A=0,!u[136468]){for(;k=(A<<2)+136420|0,n=so(A,47881),i[k>>2]=n,A=A+1|0,(A|0)!=6;);t[136468]=1,i[34111]=i[34105]}if(A=136420,e=r+8|0,!N2(e,136420,24)||(A=136444,!N2(e,136444,24)))break i;if(A=E2(24),!A)break e;e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,e=i[r+28>>2],i[A+16>>2]=i[r+24>>2],i[A+20>>2]=e,e=i[r+20>>2],i[A+8>>2]=i[r+16>>2],i[A+12>>2]=e;break i}A=0}return v=r+32|0,t[136820]=1,i[34204]=A,A}function oo(A,e,r){var f=0,k=0,n=0,o=0,l=0;f=v-16|0,v=f,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[A+12>>2]=0,i[A+16>>2]=0,t[A+8|0]=0,i[A+20>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,k=i[e+4>>2],i[f+8>>2]=i[k+48>>2],k=i[k+52>>2],i[f+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=i[e+28>>2]+(r-i[e+16>>2]<<4)|0,k=i[r+8>>2],e=i[r>>2],o=i[r+4>>2],r=i[f+12>>2],i[f>>2]=i[f+8>>2],i[f+4>>2]=r,n=i[f>>2],l=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,r=i[A+4>>2],i[A>>2]=n,i[A+4>>2]=l;i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i[A+48>>2]=k,i[A+40>>2]=e,i[A+44>>2]=o,t[A+8|0]=2,A=i[f+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f+16|0}function bA(A,e,r,f,k,n){var o=0;o=v-80|0,v=o;i:{if((n|0)>=16384){if(Z1(o+32|0,e,r,f,k,0,0,0,2147352576),f=i[o+40>>2],k=i[o+44>>2],e=i[o+32>>2],r=i[o+36>>2],n>>>0<32767){n=n-16383|0;break i}Z1(o+16|0,e,r,f,k,0,0,0,2147352576),n=(n>>>0>=49149?49149:n)-32766|0,f=i[o+24>>2],k=i[o+28>>2],e=i[o+16>>2],r=i[o+20>>2];break i}if((n|0)>-16383)break i;if(Z1(o- -64|0,e,r,f,k,0,0,0,7471104),f=i[o+72>>2],k=i[o+76>>2],e=i[o+64>>2],r=i[o+68>>2],n>>>0>4294934644){n=n+16269|0;break i}Z1(o+48|0,e,r,f,k,0,0,0,7471104),n=(n>>>0<=4294918376?-48920:n)+32538|0,f=i[o+56>>2],k=i[o+60>>2],e=i[o+48>>2],r=i[o+52>>2]}Z1(o,e,r,f,k,0,0,0,n+16383<<16),e=i[o+12>>2],i[A+8>>2]=i[o+8>>2],i[A+12>>2]=e,e=i[o+4>>2],i[A>>2]=i[o>>2],i[A+4>>2]=e,v=o+80|0}function W2(A,e){var r=0,f=0,k=0,n=0;f=i[A+12>>2],r=u[((u[e|0]<<1&508)+(f>>>6|0)|0)+66796|0],f=f-r|0,i[A+12>>2]=f,k=i[A+16>>2],f=f<<7;i:{if(k>>>0<f>>>0){if(k=e,r=u[e|0],e=r&1,t[k|0]=e|u[(r>>>1|0)+67056|0]<<1,f>>>0>32767||(i[A+12>>2]=f>>>6,f=i[A+16>>2]<<1,i[A+16>>2]=f,r=p[A+20>>1]+1|0,X[A+20>>1]=r,(r|0)==(r&65535))||(X[A+20>>1]=65528,r=i[A+4>>2],r>>>0>=o0[A+8>>2]))break i;return i[A+4>>2]=r+1,i[A+16>>2]=f|u[r|0],e}if(n=u[(r>>>3|0)+67120|0],i[A+12>>2]=r<<n,i[A+16>>2]=k-f<<n,r=e,f=u[r|0],k=f&1,e=!k,t[r|0]=u[(f>>>1|0)+67152|0]<<1|(f>>>0<2?e:k),r=n+p[A+20>>1]|0,X[A+20>>1]=r,r=r<<16>>16,(r|0)<0)break i;f=i[A+4>>2],f>>>0<o0[A+8>>2]&&(i[A+4>>2]=f+1,i[A+16>>2]=i[A+16>>2]|u[f|0]<<r),X[A+20>>1]=r-8}return e}function lo(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;if(k=i[A>>2],o=i[A+4>>2],s=i[e+4>>2]+(k-o|0)|0,(k|0)!=(o|0)){for(r=k,f=s;n=p[r>>1],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,X[f>>1]=n,i[f+4>>2]=i[r+4>>2],i[f+8>>2]=i[r+8>>2],i[f+12>>2]=i[r+12>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,f=f+16|0,r=r+16|0,(o|0)!=(r|0););for(;;){if(n=i[k+4>>2],n){if(f=n,r=i[k+8>>2],(f|0)!=(r|0)){for(;f=r-12|0,l=i[f>>2],l&&(i[r-8>>2]=l,Z(l)),r=f,(r|0)!=(n|0););f=i[k+4>>2]}i[k+8>>2]=n,Z(f)}if(k=k+16|0,(o|0)==(k|0))break}k=i[A>>2]}i[e+4>>2]=s,i[A+4>>2]=k,i[A>>2]=i[e+4>>2],i[e+4>>2]=k,r=i[A+4>>2],i[A+4>>2]=i[e+8>>2],i[e+8>>2]=r,r=i[A+8>>2],i[A+8>>2]=i[e+12>>2],i[e+12>>2]=r,i[e>>2]=i[e+4>>2]}function HI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0;n=v-32|0,v=n;i:{e:{if(l=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,o=i[l>>2],!o)break e;for(;;){if(v4(i[o+4>>2],r)){if(o=i[l+4>>2],l=l+4|0,o)continue;break e}break}r:{f:switch(i[o+8>>2]-1|0){case 0:if(W[i[i[e>>2]+76>>2]](A,i[e+4>>2],r,n+28|0),i[A>>2])break i;i[n>>2]=i[n+28>>2],_6(f,k,19592,n);break r;case 1:if(W[i[i[e>>2]+84>>2]](A,i[e+4>>2],r,n+28|0),i[A>>2])break i;i[n+16>>2]=i[n+28>>2],_6(f,k,19592,n+16|0);break r;case 2:break f;default:break r}if(W[i[i[e>>2]+92>>2]](A,i[e+4>>2],r,f,k),i[A>>2])break i}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680];break i}e=i[25827],i[A>>2]=i[25826],i[A+4>>2]=e,i[A+8>>2]=i[25828]}v=n+32|0}function zI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-48|0,v=f;i:{if(!(r&&e)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=18389;break i}VA(f+20|0,i[e>>2],i[i[e+8>>2]>>2]);e:{r:switch(u[f+40|0]){default:e2(),M();case 1:c0(A,f+20|0,i[e>>2]);break e;case 0:break r}e=i[f+20>>2];r:{if(t[e+115|0]>=0){i[f+16>>2]=i[e+112>>2],k=i[e+108>>2],i[f+8>>2]=i[e+104>>2],i[f+12>>2]=k;break r}T(f+8|0,i[e+104>>2],i[e+108>>2])}if(e=t[f+19|0],k=(e|0)<0,n=r,r=C((k?i[f+12>>2]:e)+1|0),i[n>>2]=r,n=r,r=i[f+8>>2],u8(n,k?r:f+8|0),i[A+8>>2]=i[25680],k=i[25679],i[A>>2]=i[25678],i[A+4>>2]=k,(e|0)>=0)break e;Z(r)}if(A=u[f+40|0],(A|0)==255)break i;e=i[25867],i[f+8>>2]=i[25866],i[f+12>>2]=e,W[i[(f+8|0)+(A<<2)>>2]](f+47|0,f+20|0)}v=f+48|0}function xI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-48|0,v=k,e6(k+16|0,i[e+180>>2],i[e+196>>2]);i:{e:switch(u[k+36|0]){case 1:if(e=i[k+20>>2],i[A>>2]=i[k+16>>2],i[A+4>>2]=e,A=A+8|0,t[k+35|0]>=0){e=i[k+28>>2],i[A>>2]=i[k+24>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+32>>2];break i}T(A,i[k+24>>2],i[k+28>>2]);break i;default:e2(),M();case 0:break e}$1(k,i[e+180>>2],i[k+16>>2],1),e=i[k+4>>2],n=i[k>>2];e:{if(!n){if(t[k|0]=0,t[k+11|0]=0,a(A,2,2e3,k),t[k+11|0]>=0)break e;Z(i[k>>2]);break e}W[i[i[n>>2]+116>>2]](A,n,r,f)}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}A=u[k+36|0],(A|0)!=255&&(e=i[27179],i[k>>2]=i[27178],i[k+4>>2]=e,W[i[(A<<2)+k>>2]](k+47|0,k+16|0)),v=k+48|0}function Ue(A,e){var r=0,f=0,k=0,n=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{r:{if(r=i[e+4>>2],k=i[e>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break r;f=C(r),i[A+4>>2]=f,i[A>>2]=f,n=r+f|0,i[A+8>>2]=n,r&&z(f,k,r),i[A+4>>2]=n}if(r=i[e+16>>2],i[A+12>>2]=i[e+12>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+20>>2],i[A+32>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,r=i[e+28>>2],k=i[e+24>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break e;f=C(r),i[A+28>>2]=f,i[A+24>>2]=f,n=r+f|0,i[A+32>>2]=n,r&&z(f,k,r),i[A+28>>2]=n}if(i[A+44>>2]=0,i[A+36>>2]=0,i[A+40>>2]=0,r=i[e+40>>2],f=i[e+36>>2],(r|0)!=(f|0)){if(e=r-f|0,(e|0)<0)break i;r=C(e),i[A+40>>2]=r,i[A+36>>2]=r,k=e+r|0,i[A+44>>2]=k,e&&z(r,f,e),i[A+40>>2]=k}return A}s0(),M()}s0(),M()}s0(),M()}function TI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r,f=i[e+4>>2],i[A+36>>2]=i[e>>2],i[A+40>>2]=f,f=i[e+12>>2],i[A+44>>2]=i[e+8>>2],i[A+48>>2]=f,f=i[e+20>>2],i[A+52>>2]=i[e+16>>2],i[A+56>>2]=f,u[A+60|0]||(t[A+60|0]=1),e=0,u[A+60|0]==1&&(e=C(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=97668,k=R3(e+16|0),f=i[A+56>>2],i[e+132>>2]=i[A+52>>2],i[e+136>>2]=f,f=i[A+48>>2],i[e+124>>2]=i[A+44>>2],i[e+128>>2]=f,f=i[A+40>>2],i[e+116>>2]=i[A+36>>2],i[e+120>>2]=f),i[r+20>>2]=e,i[r+16>>2]=k,f=i[r+20>>2],e=i[r+16>>2],i[r+24>>2]=e,i[r+28>>2]=f,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=e,i[r+12>>2]=f,O4(A,r+8|0,0),e=i[r+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=r+32|0}function uo(A){var e=0,r=0,f=0,k=0;if(e=i[A+216>>2],f=i[A+212>>2],(e|0)!=(f|0))for(;;){r=i[e-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(e=e-8|0,(f|0)==(e|0))break}i[A+216>>2]=f,e=i[A+232>>2],i[A+228>>2]=0,i[A+232>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+244>>2],i[A+240>>2]=0,i[A+244>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[A+332>>2],f=i[A+328>>2],(e|0)!=(f|0))for(;;){r=i[e-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(e=e-8|0,(f|0)==(e|0))break}i[A+332>>2]=f}function Me(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(n=i[e+136>>2],s=e+140|0,(n|0)!=(s|0))for(;;){h=i[i[n+20>>2]+104>>2];r:{if(r>>>0<k>>>0){i[r>>2]=h,r=r+4|0;break r}if(e=r-o|0,w=e>>2,f=w+1|0,f>>>0>=1073741824)break e;if(r=k-o|0,k=r>>1,k=r>>>0>=2147483644?1073741823:f>>>0<k>>>0?k:f,k){if(k>>>0>=1073741824)break i;r=C(k<<2)}else r=0;l=r+e|0,i[l>>2]=h,f=l-(w<<2)|0,e&&z(f,o,e),k=r+(k<<2)|0,i[A+8>>2]=k,r=l+4|0,i[A+4>>2]=r,i[A>>2]=f,o&&Z(o),o=f}i[A+4>>2]=r,f=i[n+4>>2];r:{if(f){for(;;)if(e=f,f=i[e>>2],!f)break r}for(;e=i[n+8>>2],f=i[e>>2]!=(n|0),n=e,!!f;);}if(n=e,(e|0)==(s|0))break}return}s0(),M()}x0(),M()}function jI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-48|0,v=k;i:{if(!(f&&e)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=18389;break i}VA(k+20|0,i[e>>2],r);e:{r:switch(u[k+40|0]){default:e2(),M();case 1:c0(A,k+20|0,i[e>>2]);break e;case 0:break r}e=i[k+20>>2];r:{if(t[e+115|0]>=0){i[k+16>>2]=i[e+112>>2],r=i[e+108>>2],i[k+8>>2]=i[e+104>>2],i[k+12>>2]=r;break r}T(k+8|0,i[e+104>>2],i[e+108>>2])}if(e=t[k+19|0],r=(e|0)<0,n=f,f=C((r?i[k+12>>2]:e)+1|0),i[n>>2]=f,n=f,f=i[k+8>>2],u8(n,r?f:k+8|0),i[A+8>>2]=i[25680],r=i[25679],i[A>>2]=i[25678],i[A+4>>2]=r,(e|0)>=0)break e;Z(f)}if(A=u[k+40|0],(A|0)==255)break i;e=i[25809],i[k+8>>2]=i[25808],i[k+12>>2]=e,W[i[(k+8|0)+(A<<2)>>2]](k+47|0,k+20|0)}v=k+48|0}function SI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;l=v-16|0,v=l,Jo(l+4|0,i[A>>2]),k=i[l+4>>2],A=i[l+8>>2];i:{e:{if((k|0)!=(A|0)){if(r=A-k>>3,o=r>>>0<=1?1:r,w=o&3,A=0,r>>>0>=4)for(h=o&-4,o=0;r=A<<3,f=r+e|0,n=r+k|0,s=i[n+4>>2],i[f>>2]=i[n>>2],i[f+4>>2]=s,f=r|8,n=f+e|0,f=f+k|0,s=i[f+4>>2],i[n>>2]=i[f>>2],i[n+4>>2]=s,f=r|16,n=f+e|0,f=f+k|0,s=i[f+4>>2],i[n>>2]=i[f>>2],i[n+4>>2]=s,r=r|24,f=r+e|0,r=r+k|0,n=i[r+4>>2],i[f>>2]=i[r>>2],i[f+4>>2]=n,A=A+4|0,o=o+4|0,(h|0)!=(o|0););if(!w)break e;for(;r=A<<3,o=r+e|0,r=r+k|0,h=i[r+4>>2],i[o>>2]=i[r>>2],i[o+4>>2]=h,A=A+1|0,_=_+1|0,(_|0)!=(w|0););break e}if(!k)break i}i[l+8>>2]=k,Z(k)}v=l+16|0}function so(A,e){var r=0,f=0,k=0;i:{if(u[e|0]||(e=Y3(21228),u[e|0]&&e)||(e=Y3(g(A,12)+80304|0),u[e|0]&&e)||(e=Y3(21307),u[e|0]&&e))break i;e=22913}i:{for(;;){if(f=u[e+r|0],!(!f|(f|0)==47)){if(f=23,r=r+1|0,(r|0)!=23)continue;break i}break}f=r}k=22913;i:{e:{r=u[e|0];r:{f:{if(!(u[e+f|0]|(r|0)==46)&&(k=e,(r|0)!=67))break f;if(!u[k+1|0])break r}if(!v4(k,22913))break r;if(v4(k,20923))break e}if(!A&&(r=79236,u[k+1|0]==46))break i;return 0}if(r=i[34104],r)for(;;){if(!v4(k,r+8|0))break i;if(r=i[r+32>>2],!r)break}r=E2(36),r&&(e=i[19810],i[r>>2]=i[19809],i[r+4>>2]=e,e=r+8|0,v8(e,k,f),t[e+f|0]=0,i[r+32>>2]=i[34104],i[34104]=r),r=A|r?r:79236}return r}function cA(A,e,r,f,k,n,o,l){var s=0;s=v-48|0,v=s,i[s+28>>2]=i[e>>2],e=i[e+4>>2],i[s+32>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),G6(s,s+28|0,r,3,f,k,n,o,l);i:{e:{r:{f:switch(f=u[s+20|0],f|0){case 0:break e;case 1:break r;default:break f}e2(),M()}if(r=i[s+4>>2],i[A>>2]=i[s>>2],i[A+4>>2]=r,r=A+8|0,t[s+19|0]>=0){k=i[s+12>>2],i[r>>2]=i[s+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+16>>2];break i}T(r,i[s+8>>2],i[s+12>>2]);break i}k=i[s>>2],r=i[s+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[A+4>>2]=r,i[A>>2]=k}t[A+20|0]=f,A=u[s+20|0],(A|0)!=255&&(r=i[27193],i[s+40>>2]=i[27192],i[s+44>>2]=r,W[i[(s+40|0)+(A<<2)>>2]](s+39|0,s));i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=s+48|0}function OI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;n=v-16|0,v=n,k=i[A>>2],A=i[k+248>>2],k=i[k+252>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);i:{if(!A)break i;m5(n+4|0,A,e),A=i[n+8>>2],e=i[n+4>>2],l=A-e>>2;e:{if((A|0)!=(e|0)){if(f=l>>>0<=1?1:l,s=f&3,A=0,l>>>0>=4)for(_=f&-4;f=A<<2,i[f+r>>2]=i[e+f>>2],o=f|4,i[o+r>>2]=i[e+o>>2],o=f|8,i[o+r>>2]=i[e+o>>2],f=f|12,i[f+r>>2]=i[e+f>>2],A=A+4|0,h=h+4|0,(h|0)!=(_|0););if(!s)break e;for(;f=A<<2,i[f+r>>2]=i[e+f>>2],A=A+1|0,w=w+1|0,(w|0)!=(s|0););break e}if(!e)break i}i[n+8>>2]=e,Z(e)}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}return v=n+16|0,l|0}function M4(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;i:{k=i[A+4>>2],l=i[A>>2],s=k-l|0,f=t[e+11|0],f=(i[A+12>>2]+r|0)+((f|0)<0?i[e+4>>2]:f)|0;e:{if(s>>>0>=f>>>0)break e;if(n=f-s|0,o=i[A+8>>2],n>>>0<=o-k>>>0){n&&l0(k,0,n),i[A+4>>2]=k+n;break e}if((f|0)<0)break i;if(k=o-l|0,o=k<<1,o=k>>>0>=1073741823?2147483647:f>>>0<o>>>0?o:f,k=C(o),n&&l0(k+s|0,0,n),s&&z(k,l,s),i[A+8>>2]=k+o,i[A+4>>2]=f+k,i[A>>2]=k,!l)break e;Z(l)}if(f=t[e+11|0],(f|0)<0?i[e+4>>2]:f)for(f=f>>>31|0;f=u[(f?i[e>>2]:e)+h|0],n=i[A+12>>2],i[A+12>>2]=n+1,t[n+i[A>>2]|0]=f,n=t[e+11|0],f=n>>>31|0,h=h+1|0,h>>>0<((n|0)<0?i[e+4>>2]:n)>>>0;);r&&(e=i[A+12>>2],i[A+12>>2]=e+1,t[e+i[A>>2]|0]=0);return}s0(),M()}function ho(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(n=i[e+196>>2],s=e+200|0,(n|0)!=(s|0))for(;;){r:{if(f>>>0<k>>>0){i[f>>2]=i[n+16>>2],f=f+4|0;break r}if(e=f-o|0,h=e>>2,r=h+1|0,r>>>0>=1073741824)break e;if(f=k-o|0,k=f>>1,k=f>>>0>=2147483644?1073741823:r>>>0<k>>>0?k:r,k){if(k>>>0>=1073741824)break i;f=C(k<<2)}else f=0;l=f+e|0,i[l>>2]=i[n+16>>2],r=l-(h<<2)|0,e&&z(r,o,e),k=f+(k<<2)|0,i[A+8>>2]=k,f=l+4|0,i[A+4>>2]=f,i[A>>2]=r,o&&Z(o),o=r}i[A+4>>2]=f,r=i[n+4>>2];r:{if(r){for(;;)if(e=r,r=i[r>>2],!r)break r}for(;e=i[n+8>>2],r=i[e>>2]!=(n|0),n=e,!!r;);}if(n=e,(s|0)==(e|0))break}return}s0(),M()}x0(),M()}function PI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!p[r+24>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=1)break i;i[e+4>>2]=0,i[e+8>>2]=1,f=u[r+8|0],i[e+16>>2]=k,t[e+12|0]=f,i[e+20>>2]=i[r+16>>2],f=u[r+23|0]|u[r+24|0]<<8|(u[r+25|0]<<16|u[r+26|0]<<24),t[e+27|0]=f,t[e+28|0]=f>>>8,t[e+29|0]=f>>>16,t[e+30|0]=f>>>24,i[e+24>>2]=i[r+20>>2],i[e>>2]=11,l8(A,e+4|0,e)}v=e+32|0}function LI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!p[r+24>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=1)break i;i[e+4>>2]=0,i[e+8>>2]=1,f=u[r+8|0],i[e+16>>2]=k,t[e+12|0]=f,i[e+20>>2]=i[r+16>>2],f=u[r+23|0]|u[r+24|0]<<8|(u[r+25|0]<<16|u[r+26|0]<<24),t[e+27|0]=f,t[e+28|0]=f>>>8,t[e+29|0]=f>>>16,t[e+30|0]=f>>>24,i[e+24>>2]=i[r+20>>2],i[e>>2]=11,l8(A,e+4|0,e)}v=e+32|0}function qI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!p[r+24>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=2)break i;i[e+4>>2]=0,i[e+8>>2]=2,f=u[r+8|0],i[e+16>>2]=k,t[e+12|0]=f,i[e+20>>2]=i[r+16>>2],f=u[r+23|0]|u[r+24|0]<<8|(u[r+25|0]<<16|u[r+26|0]<<24),t[e+27|0]=f,t[e+28|0]=f>>>8,t[e+29|0]=f>>>16,t[e+30|0]=f>>>24,i[e+24>>2]=i[r+20>>2],i[e>>2]=11,l8(A,e+4|0,e)}v=e+32|0}function aI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!p[r+24>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=2)break i;i[e+4>>2]=0,i[e+8>>2]=2,f=u[r+8|0],i[e+16>>2]=k,t[e+12|0]=f,i[e+20>>2]=i[r+16>>2],f=u[r+23|0]|u[r+24|0]<<8|(u[r+25|0]<<16|u[r+26|0]<<24),t[e+27|0]=f,t[e+28|0]=f>>>8,t[e+29|0]=f>>>16,t[e+30|0]=f>>>24,i[e+24>>2]=i[r+20>>2],i[e>>2]=11,l8(A,e+4|0,e)}v=e+32|0}function i5(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!e)break i;e:{r:{f:{A:{k:{n:{t:{o:{l:switch(r=u[e|0],f=u[A|0],(r>>>0<f>>>0?r:f)-1|0){case 0:break e;case 1:break r;case 2:break f;case 3:break A;case 4:break k;case 5:break n;case 6:break t;case 7:break o;case 8:break l;default:break i}t[A+68|0]=u[e+68|0]}i[A+60>>2]=i[e+60>>2],i[A+64>>2]=i[e+64>>2],i[A+56>>2]=i[e+56>>2],i[A+52>>2]=i[e+52>>2]}i[A+48>>2]=i[e+48>>2]}i[A+44>>2]=i[e+44>>2]}r=i[e+32>>2],i[A+28>>2]=i[e+28>>2],i[A+32>>2]=r,r=i[e+40>>2],i[A+36>>2]=i[e+36>>2],i[A+40>>2]=r}i[A+24>>2]=i[e+24>>2]}t[A+21|0]=u[e+21|0]}t[A+20|0]=u[e+20|0]}t[A+1|0]=u[e+1|0],i[A+4>>2]=i[e+4>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=i[e+12>>2],i[A+16>>2]=i[e+16>>2]}}function KI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,h2(r,(u[e+128|0]<<4|u[e+97|0]<<5|u[e+136|0]<<3|u[e+144|0]<<2)&60),u[e+97|0]==1&&(p0(r,i[e+100>>2]),p0(r,i[e+112>>2]),p0(r,i[e+104>>2]),p0(r,i[e+116>>2]),p0(r,i[e+108>>2]),p0(r,i[e+120>>2])),u[e+128|0]==1&&p0(r,i[e+124>>2]),u[e+136|0]==1&&p0(r,i[e+132>>2]),u[e+144|0]==1&&p0(r,i[e+140>>2]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function $I(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;if(!r)return 0;i:{e:{if(e=i[A>>2],u[e+236|0]==1){if(A=i[A+4>>2],A)break e;A=0;break i}if(A=i[e+244>>2],e=i[e+240>>2],A)break e;A=0;break i}i[A+4>>2]=i[A+4>>2]+1}u[e+248|0]==1&&(f=C(56),k=i[e+308>>2],i[f+48>>2]=i[e+304>>2],i[f+52>>2]=k,k=i[e+300>>2],i[f+40>>2]=i[e+296>>2],i[f+44>>2]=k,k=i[e+292>>2],i[f+32>>2]=i[e+288>>2],i[f+36>>2]=k,k=i[e+284>>2],i[f+24>>2]=i[e+280>>2],i[f+28>>2]=k,k=i[e+276>>2],i[f+16>>2]=i[e+272>>2],i[f+20>>2]=k,k=i[e+268>>2],i[f+8>>2]=i[e+264>>2],i[f+12>>2]=k,k=i[e+260>>2],i[f>>2]=i[e+256>>2],i[f+4>>2]=k,k=1),i[r>>2]=f;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return k|0}function wo(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;r=v-48|0,v=r;i:{e:{r:{if(!e){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break r}if(i[r+40>>2]=0,i[r+44>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,W[i[i[e>>2]+20>>2]](r+12|0,e,r+32|0),t[r+31|0]<0&&Z(i[r+20>>2]),i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,e=0,k=i[r+32>>2],n=i[r+36>>2],(k|0)!=(n|0)){if(f=n-k|0,(f|0)<0)break e;e=C(f),f&&z(e,k,f),f=e+f|0}f:{if(f-e>>>0<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break f}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,n=e+8|0,(n|0)==(f|0))break f;if(f=f-n|0,(f|0)<0)break i;o=C(f),i[A>>2]=o,l=f+o|0,i[A+8>>2]=l,f&&z(o,n,f),i[A+4>>2]=l}if(e&&(Z(e),k=i[r+32>>2]),!k)break r;i[r+36>>2]=k,Z(k)}v=r+48|0;return}s0(),M()}s0(),M()}function dI(A,e,r,f,k,n,o,l,s,h,w,_,B){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0,h=h|0,w=w|0,_=_|0,B=B|0;var m=0,G=0,I=0,Q=0,V=0,Y=0,E=0;if((_|0)>0){if(!((o|0)<=0|(n|0)<=0))for(I=(s+w|0)+1<<_,Q=_+1|0,s=-1<<B^-1,Y=n&2147483646,E=n&1;;){if(_=(g(e,G)<<1)+A|0,w=g(k,G)<<1,B=w+f|0,w=r+w|0,V=0,(n|0)!=1)for(;m=(g(X[w>>1],l)+I|0)+g(X[B>>1],h)>>Q,X[_>>1]=(m|0)>=0?(s|0)>(m|0)?m:s:0,m=(g(X[w+2>>1],l)+I|0)+g(X[B+2>>1],h)>>Q,X[_+2>>1]=(m|0)>=0?(s|0)>(m|0)?m:s:0,B=B+4|0,w=w+4|0,_=_+4|0,V=V+2|0,(Y|0)!=(V|0););if(E&&(w=(g(X[w>>1],l)+I|0)+g(X[B>>1],h)>>Q,X[_>>1]=(w|0)>=0?(s|0)>(w|0)?w:s:0),G=G+1|0,(G|0)==(o|0))break}return}U0(23601,19896,213,11253),M()}function Ni(A,e,r){var f=0,k=0;i:{if(!r||(t[A|0]=e,f=A+r|0,t[f-1|0]=e,r>>>0<3)||(t[A+2|0]=e,t[A+1|0]=e,t[f-3|0]=e,t[f-2|0]=e,r>>>0<7)||(t[A+3|0]=e,t[f-4|0]=e,r>>>0<9)||(f=0-A&3,k=f+A|0,A=g(e&255,16843009),i[k>>2]=A,r=r-f&-4,e=r+k|0,i[e-4>>2]=A,r>>>0<9)||(i[k+8>>2]=A,i[k+4>>2]=A,i[e-8>>2]=A,i[e-12>>2]=A,r>>>0<25)||(i[k+24>>2]=A,i[k+20>>2]=A,i[k+16>>2]=A,i[k+12>>2]=A,i[e-16>>2]=A,i[e-20>>2]=A,i[e-24>>2]=A,i[e-28>>2]=A,e=k&4|24,r=r-e|0,r>>>0<32))break i;for(A=L0(A,0,1,1),f=h0,e=e+k|0;i[e+24>>2]=A,i[e+28>>2]=f,i[e+16>>2]=A,i[e+20>>2]=f,i[e+8>>2]=A,i[e+12>>2]=f,i[e>>2]=A,i[e+4>>2]=f,e=e+32|0,r=r-32|0,r>>>0>31;);}}function H8(A,e,r,f,k){var n=0,o=0,l=0,s=0;s=v-16|0,v=s,i[s+12>>2]=e,e=0,l=6;i:{e:{if(d2(A,s+12|0))break e;n=i[A>>2],o=i[n+12>>2];r:{if((o|0)==i[n+16>>2]){n=W[i[i[n>>2]+36>>2]](n)|0;break r}n=t[o|0]}if(o=n<<24>>24,(o|0)>=0?n=(i[i[f+8>>2]+(o<<2)>>2]&64)!=0:n=0,l=4,!n)break e;for(e=W[i[i[f>>2]+36>>2]](f,o,0)|0;;){r:{if(A4(A),e=e-48|0,d2(A,s+12|0)|(k|0)<2)break r;n=i[A>>2],o=i[n+12>>2];f:{if((o|0)==i[n+16>>2]){n=W[i[i[n>>2]+36>>2]](n)|0;break f}n=t[o|0]}if(n=n<<24>>24,(n|0)>=0?l=(i[i[f+8>>2]+(n<<2)>>2]&64)!=0:l=0,!l)break i;k=k-1|0,e=(W[i[i[f>>2]+36>>2]](f,n,0)|0)+g(e,10)|0;continue}break}if(!d2(A,s+12|0))break i;l=2}i[r>>2]=l|i[r>>2]}return v=s+16|0,e}function bI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(i[r>>2]!=1|i[r+4>>2]!=3|i[r+12>>2]!=8||!(!(i[r+16>>2]&-9)|u[r+8|0]!=1))break i;r=C(32),i[r+28>>2]=11,t[r+26|0]=1,i[r+20>>2]=131074,i[r+12>>2]=8,i[r+16>>2]=0,i[r>>2]=1,i[r+4>>2]=11,X[r+24>>1]=2,t[r+8|0]=1,e=C(64),i[e+60>>2]=11,t[e+58|0]=1,X[e+56>>1]=2,i[e+52>>2]=131074,i[e+44>>2]=8,i[e+48>>2]=0,t[e+40|0]=0,i[e+32>>2]=1,i[e+36>>2]=10,f=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=f,f=i[r+12>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=f,f=i[r+20>>2],i[e+16>>2]=i[r+16>>2],i[e+20>>2]=f,f=i[r+28>>2],i[e+24>>2]=i[r+24>>2],i[e+28>>2]=f,f=e- -64|0,i[A+8>>2]=f,i[A>>2]=e,Z(r),i[A+4>>2]=f;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function O2(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if(k=i[A+24>>2],!((k|0)>=(e|0)|(k|0)>56)){for(f=64-k|0,n=i[A+16>>2],w=i[A+20>>2],r=i[A+4>>2],k=i[A+12>>2];;){i:{if(o=f,!k){s=f;break i}if(l=r+1|0,i[A+4>>2]=l,r=u[r|0],k=k-1|0,i[A+12>>2]=k,s=o-8|0,h=s&31,(s&63)>>>0>=32?(_=r<<h,r=0):(_=(1<<h)-1&r>>>32-h,r=r<<h),n=r|n,r=w|_,w=r,i[A+16>>2]=n,i[A+20>>2]=r,r=f,f=r-8|0,B=B-(r>>>0<8)|0,r=l,(o|0)>15)continue}break}k=64-s|0}return i[A+24>>2]=k-e,r=i[A+16>>2],f=A,f=A,A=i[A+20>>2],o=r,n=e&31,(e&63)>>>0>=32?(l=r<<n,o=0):(l=(1<<n)-1&o>>>32-n|A<<n,o=o<<n),i[f+16>>2]=o,i[f+20>>2]=l,f=64-e|0,e=r,r=f&31,(f&63)>>>0>=32?A=A>>>r|0:A=((1<<r)-1&A)<<32-r|e>>>r,A&255}function e5(A,e,r,f){var k=0,n=0,o=0;o=v-16|0,v=o;i:{n=i[A+8>>2],k=i[A>>2];e:{if((n-k|0)/52>>>0>=f>>>0){if(n=f,f=i[A+4>>2]-k|0,n>>>0>(f|0)/52>>>0){if(f=e+f|0,jl(o+8|0,e,f,k),e=i[A+4>>2],(r|0)!=(f|0))for(;e=Re(e,f)+52|0,f=f+52|0,(f|0)!=(r|0););i[A+4>>2]=e;break e}jl(o+8|0,e,r,k),N5(A,i[o+12>>2]);break e}if(k&&(N5(A,k),Z(i[A>>2]),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,n=0),f>>>0>=82595525||(k=(n|0)/52|0,n=k<<1,f=k>>>0>=41297762?82595524:f>>>0<n>>>0?n:f,f>>>0>=82595525))break i;if(k=g(f,52),f=C(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,(e|0)!=(r|0))for(;f=Re(f,e)+52|0,e=e+52|0,(r|0)!=(e|0););i[A+4>>2]=f}v=o+16|0;return}s0(),M()}function cI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0;k=v-32|0,v=k,n=i[r+16>>2],n=n>>>0>=6?6:n,o=i[r+8>>2],o&&l4(o,n),o=i[r>>2],l=W[i[i[o>>2]+8>>2]](o)|0,s=h0,l=n+l|0,s=n>>>0>l>>>0?s+1|0:s,W[i[i[o>>2]+20>>2]](o,l,s)|0,i[r+16>>2]=i[r+16>>2]-n,h=e,w=w2(r),X[h+98>>1]=w,Xi(k+8|0,e,r,-1,f),e=A+8|0;i:{if(i[k+8>>2]){r=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=r,i[e+8>>2]=i[k+24>>2],A=i[k+20>>2],i[e>>2]=i[k+16>>2],i[e+4>>2]=A,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}if(r=i[28729],i[A>>2]=i[28728],i[A+4>>2]=r,t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731])}t[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function T0(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if(k=i[A+24>>2],!((k|0)>=(e|0)|(k|0)>56)){for(f=64-k|0,n=i[A+16>>2],w=i[A+20>>2],r=i[A+4>>2],k=i[A+12>>2];;){i:{if(o=f,!k){s=f;break i}if(l=r+1|0,i[A+4>>2]=l,r=u[r|0],k=k-1|0,i[A+12>>2]=k,s=o-8|0,h=s&31,(s&63)>>>0>=32?(_=r<<h,r=0):(_=(1<<h)-1&r>>>32-h,r=r<<h),n=r|n,r=w|_,w=r,i[A+16>>2]=n,i[A+20>>2]=r,r=f,f=r-8|0,B=B-(r>>>0<8)|0,r=l,(o|0)>15)continue}break}k=64-s|0}return i[A+24>>2]=k-e,r=i[A+16>>2],f=A,f=A,A=i[A+20>>2],o=r,n=e&31,(e&63)>>>0>=32?(l=r<<n,o=0):(l=(1<<n)-1&o>>>32-n|A<<n,o=o<<n),i[f+16>>2]=o,i[f+20>>2]=l,f=64-e|0,e=r,r=f&31,(f&63)>>>0>=32?A=A>>>r|0:A=((1<<r)-1&A)<<32-r|e>>>r,A}function p4(A,e){var r=0,f=0,k=0,n=0;r=v-32|0,v=r,i[r+24>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0;i:{if(!i[e+16>>2]){i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0;break i}k=i[e>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);e:{r:{if(!w4(e,1))break r;for(;;){if(!(W[i[i[k>>2]+16>>2]](k,r+15|0,1)|0)){h8(e),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break e}if(n=t[r+15|0],!(!n|!i[e+16>>2])){if(Ai(r+16|0,n),!w4(e,1))break r;continue}break}e=i[r+20>>2],i[A>>2]=i[r+16>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+24>>2],i[r+24>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0;break e}i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}t[r+27|0]<0&&Z(i[r+16>>2]),v=r+32|0}function iQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;n=v-32|0,v=n,h=W[i[i[e>>2]+52>>2]](e,r,0)|0;i:{if(u[e+97|0]){k=i[e+104>>2],o=i[e+108>>2];break i}if(l=2147483647,k=i[e+104>>2],o=i[e+108>>2],(k|0)==(o|0)){o=k;break i}for(f=k;s=i[f+4>>2],l=(l|0)>(s|0)?s:l,f=f+8|0,(o|0)!=(f|0););}if(p0(r,o-k>>3),f=i[e+104>>2],k=i[e+108>>2],(f|0)!=(k|0))for(;p0(r,i[f>>2]),p0(r,i[f+4>>2]-l|0),f=f+8|0,(k|0)!=(f|0););n1(n+12|0,e,r,h),t[n+31|0]<0&&Z(i[n+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=n+32|0}function _o(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;o=v-16|0,v=o,i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0;i:{e:{r:{if(r){if((r|0)<0)break r;k=C(r),r&&z(k,e,r),s=r+k|0}e=i[A+120>>2],f=i[A+124>>2];f:{if(e>>>0<f>>>0){i[e+8>>2]=s,i[e+4>>2]=s,i[e>>2]=k,r=e+12|0;break f}if(l=i[A+116>>2],e=e-l|0,r=((e|0)/12|0)+1|0,r>>>0>=357913942)break e;if(f=(f-l|0)/12|0,n=f<<1,n=f>>>0>=178956970?357913941:r>>>0<n>>>0?n:r,n){if(n>>>0>=357913942)break i;r=C(g(n,12))}else r=0;if(f=r+e|0,i[f+8>>2]=s,i[f+4>>2]=s,i[f>>2]=k,k=f+g((e|0)/-12|0,12)|0,e&&z(k,l,e),i[A+124>>2]=r+g(n,12),r=f+12|0,i[A+120>>2]=r,i[A+116>>2]=k,!l)break f;Z(l)}i[A+120>>2]=r,v=o+16|0;return}s0(),M()}s0(),M()}x0(),M()}function Bo(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;o=v-16|0,v=o,i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0;i:{e:{r:{if(r){if((r|0)<0)break r;k=C(r),r&&z(k,e,r),s=r+k|0}e=i[A+144>>2],f=i[A+148>>2];f:{if(e>>>0<f>>>0){i[e+8>>2]=s,i[e+4>>2]=s,i[e>>2]=k,r=e+12|0;break f}if(l=i[A+140>>2],e=e-l|0,r=((e|0)/12|0)+1|0,r>>>0>=357913942)break e;if(f=(f-l|0)/12|0,n=f<<1,n=f>>>0>=178956970?357913941:r>>>0<n>>>0?n:r,n){if(n>>>0>=357913942)break i;r=C(g(n,12))}else r=0;if(f=r+e|0,i[f+8>>2]=s,i[f+4>>2]=s,i[f>>2]=k,k=f+g((e|0)/-12|0,12)|0,e&&z(k,l,e),i[A+148>>2]=r+g(n,12),r=f+12|0,i[A+144>>2]=r,i[A+140>>2]=k,!l)break f;Z(l)}i[A+144>>2]=r,v=o+16|0;return}s0(),M()}s0(),M()}x0(),M()}function eQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0;f=v-16|0,v=f,k=Q2(r),n=k&32,t[e+97|0]=n>>>5,n&&(o=e,l=F0(r),i[o+100>>2]=l,o=e,l=F0(r),i[o+112>>2]=l,o=e,l=F0(r),i[o+104>>2]=l,o=e,l=F0(r),i[o+116>>2]=l,o=e,l=F0(r),i[o+108>>2]=l,o=e,l=F0(r),i[o+120>>2]=l),k&16&&(n=F0(r),t[e+128|0]=1,i[e+124>>2]=n),k&8&&(n=F0(r),t[e+136|0]=1,i[e+132>>2]=n),k&4&&(k=F0(r),t[e+144|0]=1,i[e+140>>2]=k);i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function rQ(A,e,r,f,k,n,o,l,s,h,w,_){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0,h=h|0,w=w|0,_=_|0;var B=0,m=0,G=0,I=0,Q=0,V=0,Y=0;if((_|0)>0){if(!((o|0)<=0|(n|0)<=0))for(G=(s+w|0)+1<<_,I=_+1|0,V=n&2147483646,Y=n&1;;){if(_=g(e,m)+A|0,s=g(k,m)<<1,w=s+f|0,s=r+s|0,Q=0,(n|0)!=1)for(;B=(g(X[s>>1],l)+G|0)+g(X[w>>1],h)>>I,B=(B|0)>=255?255:B,t[_|0]=(B|0)>0?B:0,B=(g(X[s+2>>1],l)+G|0)+g(X[w+2>>1],h)>>I,B=(B|0)>=255?255:B,t[_+1|0]=(B|0)>0?B:0,w=w+4|0,s=s+4|0,_=_+2|0,Q=Q+2|0,(V|0)!=(Q|0););if(Y&&(s=(g(X[s>>1],l)+G|0)+g(X[w>>1],h)>>I,s=(s|0)>=255?255:s,t[_|0]=(s|0)>0?s:0),m=m+1|0,(m|0)==(o|0))break}return}U0(23601,19896,80,11101),M()}function vo(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;o=v-16|0,v=o,i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0;i:{e:{r:{if(r){if((r|0)<0)break r;k=C(r),r&&z(k,e,r),s=r+k|0}e=i[A+132>>2],f=i[A+136>>2];f:{if(e>>>0<f>>>0){i[e+8>>2]=s,i[e+4>>2]=s,i[e>>2]=k,r=e+12|0;break f}if(l=i[A+128>>2],e=e-l|0,r=((e|0)/12|0)+1|0,r>>>0>=357913942)break e;if(f=(f-l|0)/12|0,n=f<<1,n=f>>>0>=178956970?357913941:r>>>0<n>>>0?n:r,n){if(n>>>0>=357913942)break i;r=C(g(n,12))}else r=0;if(f=r+e|0,i[f+8>>2]=s,i[f+4>>2]=s,i[f>>2]=k,k=f+g((e|0)/-12|0,12)|0,e&&z(k,l,e),i[A+136>>2]=r+g(n,12),r=f+12|0,i[A+132>>2]=r,i[A+128>>2]=k,!l)break f;Z(l)}i[A+132>>2]=r,v=o+16|0;return}s0(),M()}s0(),M()}x0(),M()}function fQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,7441);break i}if(n=e,o=F0(r),i[n+104>>2]=o,n=e,o=F0(r),i[n+108>>2]=o,n=e,o=F0(r),i[n+112>>2]=o,n=e,o=F0(r),i[n+116>>2]=o,n=e,o=F0(r),i[n+120>>2]=o,p4(f+20|0,r),t[e+135|0]<0&&Z(i[e+124>>2]),k=i[f+24>>2],i[e+124>>2]=i[f+20>>2],i[e+128>>2]=k,i[e+132>>2]=i[f+28>>2],u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function AQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,n=i[f+4>>2];i:{if(!(!u[k+12|0]|((n|0)==3|i[k+4>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(i[r>>2]==1&(i[r+4>>2]&-2)==10)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(n-1>>>0>=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(r=p[f+24>>1],!(r>>>0>14|!(1<<r&18689))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[e+8>>2]=n,i[e+4>>2]=0,i[e+20>>2]=0,r=u[f+8|0],i[e+16>>2]=8,t[e+12|0]=r,r=u[f+23|0]|u[f+24|0]<<8|(u[f+25|0]<<16|u[f+26|0]<<24),t[e+27|0]=r,t[e+28|0]=r>>>8,t[e+29|0]=r>>>16,t[e+30|0]=r>>>24,i[e+24>>2]=i[f+20>>2],i[e>>2]=11,l8(A,e+4|0,e)}v=e+32|0}function kQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r;i:{if((e|0)==-1){if(u[A+52|0])break i;e=i[A+48>>2],t[A+52|0]=(e|0)!=-1;break i}e:{r:{if(f=u[A+52|0],!(!(f&1)|u[A+53|0]!=1)){if(kw(i[A+48>>2],i[A+32>>2]))break r;break e}if(!(f&1))break r;t[r+19|0]=i[A+48>>2]<<24>>24;f:{A:switch(f=i[A+36>>2],k=r+20|0,(W[i[i[f>>2]+12>>2]](f,i[A+40>>2],r+19|0,k,r+12|0,r+24|0,r+32|0,k)|0)-1|0){case 0:case 1:break e;case 2:break A;default:break f}f=i[A+48>>2],i[r+20>>2]=r+25,t[r+24|0]=f}for(;;){if(f=i[r+20>>2],f>>>0<=r+24>>>0)break r;if(f=f-1|0,i[r+20>>2]=f,(Si(t[f|0],i[A+32>>2])|0)==-1)break}break e}t[A+52|0]=1,i[A+48>>2]=e;break i}e=-1}return v=r+32|0,e|0}function nQ(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0;l=v-32|0,v=l;i:{if(!(o&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!(f|!r)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!(n&&k)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=26530;break i}if(i[l+24>>2]=0,s=l+16|0,i[s>>2]=0,i[s+4>>2]=0,i[l+8>>2]=0,i[l+12>>2]=0,i[l>>2]=0,i[l+4>>2]=0,h1(l,f,(r<<2)+f|0,r),X[l+12>>1]=k,X[l+14>>1]=n,r=g(k,n),h1(s,o,(r<<2)+o|0,r),e=i[e>>2],W[i[i[e>>2]+48>>2]](e,l),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,A=i[s>>2],A&&(i[l+20>>2]=A,Z(A)),A=i[l>>2],!A)break i;i[l+4>>2]=A,Z(A)}v=l+32|0}function mo(A){var e=0,r=0,f=0,k=0,n=0;n=i[33178],i[A+72>>2]<=0&&l7(A),i[33178]=i[A+136>>2],r=v-32|0,v=r;i:{e:{r:{if(e=i[A+4>>2],f=i[A+8>>2],(e|0)==(f|0)||(e=Vo(r+28|0,e,f-e|0),(e|0)==-1))break r;i[A+4>>2]=i[A+4>>2]+(e>>>0<=1?1:e);break e}for(i[r+16>>2]=0,i[r+20>>2]=0,e=0;;){f=e;r:{if(e=i[A+4>>2],(e|0)!=i[A+8>>2]){i[A+4>>2]=e+1,t[r+15|0]=u[e|0];break r}if(e=b3(A),t[r+15|0]=e,(e|0)>=0)break r;if(e=-1,!(f&1))break i;i[A>>2]=i[A>>2]|32,i[33136]=25;break i}if(e=1,k=ze(r+28|0,r+15|0,1,r+16|0),(k|0)!=-2)break}if(e=-1,(k|0)!=-1)break e;if(!(f&1))break i;i[A>>2]=i[A>>2]|32,Si(u[r+15|0],A);break i}e=i[r+28>>2]}return v=r+32|0,i[33178]=n,e}function Zo(A,e){var r=0,f=0,k=0;f=v-16|0,v=f;i:{e:{if(r=i[e>>2],!r||(r=Z0(r,100680,101800),!r))break e;i[f+8>>2]=r,r=i[e+4>>2],i[f+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),W[i[i[A>>2]+12>>2]](A,f+8|0);break i}i[f+8>>2]=0,i[f+12>>2]=0}r=i[e>>2];i:{if(!r||(r=Z0(r,100680,101840),!r))break i;if(e=i[e+4>>2],e){if(i[e+4>>2]=i[e+4>>2]+1,k=i[r+8>>2],i[f>>2]=i[r+4>>2],i[f+4>>2]=k,W[i[i[A>>2]+8>>2]](A,f),A=i[e+4>>2],i[e+4>>2]=A-1,A)break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}e=i[r+8>>2],i[f>>2]=i[r+4>>2],i[f+4>>2]=e,W[i[i[A>>2]+8>>2]](A,f)}A=i[f+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f+16|0}function tQ(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0;s=v-48|0,v=s;i:{if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}w=i[i[e>>2]+196>>2],h=D5(),i5(h,n),_=i[e+8>>2],i[s>>2]=s+4,i[s+4>>2]=0,i[s+8>>2]=0,n=s+12|0,pn(n,_,w,f,k,h,1,o,l,s),S1(s,i[s+4>>2]),a2(h),f=n;e:switch(u[s+32|0]){default:e2(),M();case 0:k=i[s+12>>2],f=i[s+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),n=r,r=C(8),i[n>>2]=r,i[r+4>>2]=f,i[r>>2]=k,f=114912;break;case 1:break e}if(r=A,A=i[e>>2],c0(r,f,A?A+164|0:0),A=u[s+32|0],(A|0)==255)break i;e=i[25859],i[s+40>>2]=i[25858],i[s+44>>2]=e,W[i[(s+40|0)+(A<<2)>>2]](s+39|0,s+12|0)}v=s+48|0}function oQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}i:{if((r|0)>=0&&(o=i[e>>2],e=i[o+140>>2],(i[o+144>>2]-e|0)/48>>>0>r>>>0))break i;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27960;return}e=e+g(r,48)|0;i:{if(!f||(r=i[e>>2],o=i[e+4>>2],(r|0)==(o|0))||(o=o-r|0,!o))break i;z(f,r,o)}r=g(i[e+20>>2],i[e+16>>2]);i:{if(!k||(f=i[e+24>>2],!r|(f|0)==i[e+28>>2])||(o=r<<2,!o))break i;z(k,f,o)}i:{if(!n||(f=i[e+40>>2],e=i[e+36>>2],!r|(f|0)==(e|0))||(r=r<<2,!r))break i;z(n,e,r)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function lQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r;i:{if((e|0)==-1){if(u[A+52|0])break i;e=i[A+48>>2],t[A+52|0]=(e|0)!=-1;break i}e:{r:{if(f=u[A+52|0],!(!(f&1)|u[A+53|0]!=1)){if(Ql(i[A+48>>2],i[A+32>>2]))break r;break e}if(!(f&1))break r;i[r+16>>2]=i[A+48>>2];f:{A:switch(f=i[A+36>>2],k=r+20|0,(W[i[i[f>>2]+12>>2]](f,i[A+40>>2],r+16|0,k,r+12|0,r+24|0,r+32|0,k)|0)-1|0){case 0:case 1:break e;case 2:break A;default:break f}f=i[A+48>>2],i[r+20>>2]=r+25,t[r+24|0]=f}for(;;){if(f=i[r+20>>2],f>>>0<=r+24>>>0)break r;if(f=f-1|0,i[r+20>>2]=f,(Si(t[f|0],i[A+32>>2])|0)==-1)break}break e}t[A+52|0]=1,i[A+48>>2]=e;break i}e=-1}return v=r+32|0,e|0}function go(A,e,r,f,k){var n=0,o=0,l=0,s=0;o=v-16|0,v=o;i:{if(1073741815-e>>>0>=r>>>0){if(u[A+11|0]>>>7|0?n=i[A>>2]:n=A,s=n,n=o+4|0,e>>>0<536870899?(i[o+12>>2]=e<<1,i[o+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=o+12|0,r=i[(o0[n>>2]<o0[r>>2]?r:n)>>2],r>>>0>=2?(l=r+2&-2,r=l-1|0,r=(r|0)==2?l:r):r=1,r=r+1|0):r=1073741815,Ae(n,r),r=i[o+4>>2],k)e:{if(!k||(n=k<<2,!n))break e;z(r,s,n)}if((f|0)!=(k|0)){n=k<<2,l=n+r|0,n=n+s|0,k=f-k|0;e:{if(!k||(k=k<<2,!k))break e;z(l,n,k)}}(e|0)!=1&&B6(s,4),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[o+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,v=o+16|0;break i}I4(),M()}i[A+4>>2]=f}function Go(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;if(Zr(),r=i[28738],(r|0)==114956)return 0;i:{if(!e){for(;;){k=i[r+16>>2],n=W[i[k+16>>2]](A)|0,e=(n|0)>(o|0),f=i[r+4>>2];e:{if(f){for(;;)if(r=f,f=i[r>>2],!f)break e}for(;f=r,r=i[r+8>>2],(f|0)!=i[r>>2];);}if(o=e?n:o,l=e?k:l,(r|0)==114956)break}break i}for(;;){e:{if(k=i[r+16>>2],n=W[i[k+16>>2]](A)|0,(n|0)<=0|i[k>>2]<3||v4(e,i[k+40>>2]))break e;return k}s=(o|0)<(n|0),f=i[r+4>>2];e:{if(f){for(;;)if(r=f,f=i[r>>2],!f)break e}for(;f=r,r=i[r+8>>2],(f|0)!=i[r>>2];);}if(o=s?n:o,l=s?k:l,(r|0)==114956)break}}return l}function uQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=v-48|0,v=n;i:{if(!(k&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}hA(n+20|0,i[e>>2],r,f);e:{r:switch(u[n+40|0]){default:e2(),M();case 1:c0(A,n+20|0,i[e>>2]);break e;case 0:break r}if(e=i[n+20>>2],!e){i[A>>2]=5,i[A+4>>2]=2007,i[A+8>>2]=2333;break e}z3(n+8|0,e),r=i[n+12>>2],e=i[n+8>>2];r:{if((r|0)==(e|0)||(r=r-e|0,!r))break r;z(k,e,r)}if(r=i[25679],i[A>>2]=i[25678],i[A+4>>2]=r,i[A+8>>2]=i[25680],!e)break e;i[n+12>>2]=e,Z(e)}if(A=u[n+40|0],(A|0)==255)break i;e=i[25805],i[n+8>>2]=i[25804],i[n+12>>2]=e,W[i[(n+8|0)+(A<<2)>>2]](n+47|0,n+20|0)}v=n+48|0}function sQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0;f=v-16|0,v=f,n=i[r>>2],k=i[r+4>>2];i:{if(k){if(i[k+4>>2]=i[k+4>>2]+1,o=e,l=W[i[i[n>>2]+8>>2]](n)|0,i[o+112>>2]=l,i[e+116>>2]=h0,i[e+104>>2]=0,i[e+108>>2]=0,e=i[k+4>>2],i[k+4>>2]=e-1,e)break i;W[i[i[k>>2]+8>>2]](k),y(k);break i}o=e,l=W[i[i[n>>2]+8>>2]](n)|0,i[o+112>>2]=l,i[e+116>>2]=h0,i[e+104>>2]=0,i[e+108>>2]=0}i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function hQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;o=v-32|0,v=o,i[o+28>>2]=e;i:{if(!(i[f+4>>2]&1)){i[o>>2]=-1,e=W[i[i[A>>2]+16>>2]](A,e,r,f,k,o)|0;e:switch(i[o>>2]){case 0:t[n|0]=0;break i;case 1:t[n|0]=1;break i;default:break e}t[n|0]=1,i[k>>2]=4;break i}for(A=i[f+28>>2],i[o>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),e=$0(o,137008),i2(o),A=i[f+28>>2],i[o>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),A=$0(o,137064),i2(o),W[i[i[A>>2]+24>>2]](o,A),W[i[i[A>>2]+28>>2]](o|12,A),f=o+24|0,l=n,s=(n3(o+28|0,r,o,f,e,k,1)|0)==(o|0),t[l|0]=s,e=i[o+28>>2];f=_2(f-12|0),(o|0)!=(f|0););}return v=o+32|0,e|0}function wQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;o=v-32|0,v=o,i[o+28>>2]=e;i:{if(!(i[f+4>>2]&1)){i[o>>2]=-1,e=W[i[i[A>>2]+16>>2]](A,e,r,f,k,o)|0;e:switch(i[o>>2]){case 0:t[n|0]=0;break i;case 1:t[n|0]=1;break i;default:break e}t[n|0]=1,i[k>>2]=4;break i}for(A=i[f+28>>2],i[o>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),e=$0(o,137e3),i2(o),A=i[f+28>>2],i[o>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),A=$0(o,137072),i2(o),W[i[i[A>>2]+24>>2]](o,A),W[i[i[A>>2]+28>>2]](o|12,A),f=o+24|0,l=n,s=(o3(o+28|0,r,o,f,e,k,1)|0)==(o|0),t[l|0]=s,e=i[o+28>>2];f=q1(f-12|0),(o|0)!=(f|0););}return v=o+32|0,e|0}function _Q(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f;i:{e:{if(u[e+124|0]==1){if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]<0)break e;e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}if(o=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+108>>2]-i[e+104>>2]>>2),k=i[e+104>>2],n=i[e+108>>2],(k|0)!=(n|0))for(;p0(r,i[k>>2]),k=k+4|0,(n|0)!=(k|0););if(n1(f+12|0,e,r,o),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}T(A,i[28730],i[28731])}v=f+32|0}function Wo(A,e){var r=0,f=0,k=0,n=0,o=0;n=e+24|0,f=i[e>>2],k=f&63,t[n+k|0]=128,r=k+1|0,o=k^63;i:{if(o>>>0>7){k=r;break i}k=0,o&&l0(r+n|0,0,o),o=64,Pr(e,n,64),f=i[e>>2]}r=o-8|0,r&&l0(k+n|0,0,r),t[e+83|0]=f>>>21,t[e+82|0]=f>>>13,t[e+81|0]=f>>>5,r=f<<3,t[e+80|0]=r,i[e>>2]=r,i[e+84>>2]=i[e+4>>2],Pr(e,n,64),t[A|0]=i[e+8>>2],t[A+1|0]=i[e+8>>2]>>>8,t[A+2|0]=p[e+10>>1],t[A+3|0]=u[e+11|0],t[A+4|0]=i[e+12>>2],t[A+5|0]=i[e+12>>2]>>>8,t[A+6|0]=p[e+14>>1],t[A+7|0]=u[e+15|0],t[A+8|0]=i[e+16>>2],t[A+9|0]=i[e+16>>2]>>>8,t[A+10|0]=p[e+18>>1],t[A+11|0]=u[e+19|0],t[A+12|0]=i[e+20>>2],t[A+13|0]=i[e+20>>2]>>>8,t[A+14|0]=p[e+22>>1],t[A+15|0]=u[e+23|0],l0(e,0,152)}function Z3(A,e,r){var f=0,k=0,n=0,o=0,l=0;k=i[r+4>>2],l=i[r>>2],i[r>>2]=0,i[r+4>>2]=0;i:{e:{f=i[A+140>>2];r:{if(!f){o=A+140|0,n=o;break r}for(;;){if(n=f,f=i[f+16>>2],f>>>0>e>>>0){if(o=n,f=i[n>>2],f)continue;break r}if(e>>>0<=f>>>0)break e;if(f=i[n+4>>2],!f)break}o=n+4|0}f=C(28),i[f+24>>2]=k,i[f+20>>2]=l,i[f+16>>2]=e,i[f+8>>2]=n,i[f>>2]=0,i[f+4>>2]=0,i[o>>2]=f,e=i[i[A+136>>2]>>2],e&&(i[A+136>>2]=e),G1(i[A+140>>2],f),i[A+144>>2]=i[A+144>>2]+1;break i}if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}A=i[r+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function Xo(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;if(r=v-48|0,k=r,v=r,o=r-48|0,v=o,t[o+33|0]=0,l0(o,46,33),s=o+16|0,t[s|0]=124,r=u[A+96|0],r)for(h=A- -64|0;;){n=r,r=r-1|0,l=u[h+r|0],f=X[(r<<1)+A>>1];i:{if(!((f|0)>=-16&(f|0)<=16)){i[k+32>>2]=f,i[k+36>>2]=l?88:111,n0(e,32792,k+32|0);break i}if(f=f+s|0,l){t[f|0]=88;break i}t[f|0]=111}if(!(n>>>0>1))break}if(r=u[A+97|0],r)for(l=A+80|0,h=A+32|0;;){A=r,r=r-1|0,f=u[l+r|0],n=X[h+(r<<1)>>1];i:{if(!((n|0)>=-16&(n|0)<=16)){i[k+16>>2]=n,i[k+20>>2]=f?88:111,n0(e,32792,k+16|0);break i}if(n=n+s|0,f){t[n|0]=88;break i}t[n|0]=111}if(!(A>>>0>1))break}i[k>>2]=o,n0(e,37988,k),v=k+48|0}function BQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,10641);break i}e:{if(t[e+100|0]&1){if(t[e+115|0]<0){t[i[e+104>>2]]=0,i[e+108>>2]=0;break e}t[e+115|0]=0,t[e+104|0]=0;break e}p4(f+20|0,r),t[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2]}if(u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function G0(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;if(k=i[A+16>>2],!((k|0)>=(e|0)|(k|0)>56)){for(f=64-k|0,k=i[A+4>>2];;){i:{if(l=f,!k){n=f;break i}if(r=i[A>>2],i[A>>2]=r+1,r=u[r|0],k=k-1|0,i[A+4>>2]=k,o=i[A+12>>2],n=l-8|0,s=n&31,w=A,(n&63)>>>0>=32?(h=r<<s,r=0):(h=(1<<s)-1&r>>>32-s,r=r<<s),i[w+8>>2]=r|i[A+8>>2],i[A+12>>2]=o|h,r=f,f=r-8|0,_=_-(r>>>0<8)|0,(l|0)>15)continue}break}k=64-n|0}return i[A+16>>2]=k-e,r=i[A+8>>2],f=A,f=A,A=i[A+12>>2],n=r,o=e&31,(e&63)>>>0>=32?(l=r<<o,n=0):(l=(1<<o)-1&n>>>32-o|A<<o,n=n<<o),i[f+8>>2]=n,i[f+12>>2]=l,f=64-e|0,e=r,r=f&31,(f&63)>>>0>=32?A=A>>>r|0:A=((1<<r)-1&A)<<32-r|e>>>r,A}function vQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0;n=v-192|0,v=n,i[n+136>>2]=0,i[n+108>>2]=78984,o=i[19749],i[n+4>>2]=o,l=i[o-12>>2],o=n+4|0,i[l+o>>2]=i[19750],l=o+i[i[n+4>>2]-12>>2]|0,s=n+8|0,J0(l,s),t[l+80|0]=0,i[l+72>>2]=0,i[n+108>>2]=78984,i[n+4>>2]=78964,l=bo(s),Yn(l,k,20)||(k=o+i[i[n+4>>2]-12>>2]|0,M1(k,i[k+16>>2]|4)),o=v-16|0,v=o,k=n+4|0,X1(o+8|0,k);i:{if(!f|!u[o+8|0]||(s=i[(k+i[i[k>>2]-12>>2]|0)+24>>2],(W[i[i[s>>2]+48>>2]](s,r,f)|0)==(f|0)))break i;z4(k+i[i[k>>2]-12>>2]|0,1)}v1(o+8|0),v=o+16|0,c0(A,114912,i[e>>2]),A=i[19748],i[n+4>>2]=A,i[k+i[A-12>>2]>>2]=i[19751],Le(l),Y0(n+108|0),v=n+192|0}function mQ(A,e){A=A|0,e=e|0;var r=0;if(W[i[i[A>>2]+24>>2]](A)|0,e=$0(e,137016),i[A+68>>2]=e,r=u[A+98|0],e=W[i[i[e>>2]+28>>2]](e)|0,t[A+98|0]=e,(e|0)!=(r|0)){if(i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,e=u[A+96|0],u[A+98|0]==1){i:{if(!(e&1)||(e=i[A+32>>2],!e))break i;Z(e)}t[A+96|0]=u[A+97|0],i[A+52>>2]=i[A+60>>2],e=i[A+56>>2],i[A+56>>2]=0,i[A+60>>2]=0,i[A+32>>2]=e,t[A+97|0]=0;return}i:{if(e&1||(e=i[A+32>>2],(e|0)==(A+44|0)))break i;t[A+97|0]=0,i[A+56>>2]=e,e=i[A+52>>2],i[A+60>>2]=e,e=C(e),t[A+96|0]=1,i[A+32>>2]=e;return}e=i[A+52>>2],i[A+60>>2]=e,e=C(e),t[A+97|0]=1,i[A+56>>2]=e}}function r5(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;i:{if(k=i[A>>2],n=i[A+4>>2]-k|0,f=((n|0)/56|0)+1|0,f>>>0<76695845){if(r=(i[A+8>>2]-k|0)/56|0,k=r<<1,o=r>>>0>=38347922?76695844:f>>>0<k>>>0?k:f,o){if(o>>>0>=76695845)break i;f=C(g(o,56))}else f=0;if(k=f,s=n+k|0,xe(s,e),l=i[A+4>>2],e=i[A>>2],n=g((l-e|0)/-56|0,56)+s|0,(e|0)!=(l|0)){for(f=e,r=n;xe(r,f),r=r+56|0,f=f+56|0,(l|0)!=(f|0););for(;r=i[e+44>>2],r&&(i[e+48>>2]=r,Z(r)),i[e>>2]=92500,r=i[e+20>>2],r&&(i[e+24>>2]=r,Z(r)),e=e+56|0,(l|0)!=(e|0););e=i[A>>2]}return r=s+56|0,i[A+4>>2]=r,i[A>>2]=n,i[A+8>>2]=g(o,56)+k,e&&Z(e),r}s0(),M()}x0(),M()}function He(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0;l0(A+38|0,0,2064),i[A+18524>>2]=-1,i[A+18528>>2]=-1;i:{e:{if(f=i[i[A+18592>>2]+24>>2],(f|0)>0){if(o=i[A+18588>>2],e=i[o+124>>2],k=i[e+484>>2],n=i[o+132>>2],n=i[(i[n+8460>>2]+(i[i[n+8448>>2]+(f<<2)>>2]<<2)|0)-4>>2],r=i[e+16892>>2],f=(n|0)/(r|0)|0,r=(n-g(f,r)|0)+1|0,n=i[e+16876>>2],r=r<<n,k=((k|0)<(r|0)?k:r)-1|0,r=i[o+168>>2],k=k>>r,(k|0)<0||(l=i[o+172>>2],(k|0)>=(l|0)))break e;if(e=i[e+488>>2],f=f+1<<n,e=((e|0)<(f|0)?e:f)-1>>r,(e|0)<0|(e|0)>=i[o+176>>2])break i;i[A+18520>>2]=t[((i[o+160>>2]+g(k,3)|0)+g(g(e,l),3)|0)+2|0]}return}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function ZQ(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0;e=i[A+20>>2],k=i[e+18588>>2],i[A+4>>2]=1,i[k+324>>2]=i[k+324>>2]-1,i[k+328>>2]=i[k+328>>2]+1,r=i[e+18588>>2],n=i[r+124>>2],f=i[n+16908>>2],o=i[e+4>>2],(f|0)>(o|0)&&(f=i[i[i[r+132>>2]+8460>>2]+(o<<2)>>2]),r=i[n+16892>>2],i[e>>2]=f,n=(f|0)/(r|0)|0,i[e+12>>2]=n,i[e+8>>2]=f-g(r,n);i:{e:{r:{if(u[A+8|0]==1){if(PA(e))break r;break e}if(f=i[e+18592>>2],r=i[f+804>>2],r>>>0>=3)break i;Ge(e+18572|0,r,i[f+800>>2]),t[e+18580|0]=0,t[e+18581|0]=0,t[e+18582|0]=0,t[e+18583|0]=0}rr(e+18548|0),Sr(e,0,u[A+8|0])}i[A+4>>2]=3,A=i[e+18600>>2],i[A+44>>2]=i[A+44>>2]+1,ff(k);return}U0(23510,19977,1520,5620),M()}function gQ(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0;i:{if(h=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,e=i[h>>2],!e)break i;for(;;){if(v4(i[e+4>>2],r)){if(e=i[h+4>>2],h=h+4|0,e)continue;break i}break}if(i[e+8>>2]!=1){e=i[25827],i[A>>2]=i[25826],i[A+4>>2]=e,i[A+8>>2]=i[25828];return}e:{if(!u[e+16|0]||(n&&(i[n>>2]=i[e+20>>2]),!o))break e;i[o>>2]=i[e+24>>2]}f&&(i[f>>2]=u[e+16|0]),k&&(i[k>>2]=u[e+16|0]),!s|i[e+32>>2]<=0||(i[s>>2]=i[e+28>>2]),l&&(i[l>>2]=i[e+32>>2]),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680];return}e=i[25827],i[A>>2]=i[25826],i[A+4>>2]=e,i[A+8>>2]=i[25828]}function GQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0;r=v-32|0,v=r;i:{e:{r:{if((e|0)==-1)break r;if(f=e<<24>>24,t[r+23|0]=f,u[A+44|0]==1){if(k=i[A+32>>2],A=v-16|0,v=A,t[A+15|0]=f,f=r4(A+15|0,1,1,k),v=A+16|0,(f|0)!=1)break e;break r}for(n=r+24|0,i[r+16>>2]=n,l=r+32|0,f=r+23|0;;){if(k=i[A+36>>2],k=W[i[i[k>>2]+12>>2]](k,i[A+40>>2],f,n,r+12|0,r+24|0,l,r+16|0)|0,i[r+12>>2]==(f|0))break e;if((k|0)==3){if((r4(f,1,1,i[A+32>>2])|0)==1)break r;break e}if(k>>>0>1||(o=r+24|0,f=i[r+16>>2]-o|0,(r4(o,1,f,i[A+32>>2])|0)!=(f|0)))break e;if(f=i[r+12>>2],(k|0)!=1)break}}A=(e|0)!=-1?e:0;break i}A=-1}return v=r+32|0,A|0}function WQ(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;if(!((n|0)<=0|(k|0)<=0))for(o=k-1|0,B=o&4,m=(o>>>2|0)+1&2147483646,G=k>>>0<5;;){if(k=g(f,w)+r|0,o=(g(e,w)<<1)+A|0,l=0,!G)for(;s=u[k|0],h=u[k+1|0],_=u[k+2|0],X[o+6>>1]=u[k+3|0]<<6,X[o+4>>1]=_<<6,X[o+2>>1]=h<<6,X[o>>1]=s<<6,s=u[k+4|0],h=u[k+5|0],_=u[k+6|0],X[o+14>>1]=u[k+7|0]<<6,X[o+12>>1]=_<<6,X[o+10>>1]=h<<6,X[o+8>>1]=s<<6,k=k+8|0,o=o+16|0,l=l+2|0,(m|0)!=(l|0););if(B||(l=u[k|0],s=u[k+1|0],h=u[k+2|0],X[o+6>>1]=u[k+3|0]<<6,X[o+4>>1]=h<<6,X[o+2>>1]=s<<6,X[o>>1]=l<<6),w=w+1|0,(w|0)==(n|0))break}}function XQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;k=v-32|0,v=k,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,Y1(r,u[e+97|0]?4:2,i[e+40>>2]-i[e+36>>2]>>3,0),f=i[e+36>>2],o=i[e+40>>2];i:{if((f|0)!=(o|0))for(;;){if(l=i[f>>2],W[i[i[l>>2]+20>>2]](A,l,r),i[A>>2])break i;if(t[A+19|0]<0&&Z(i[A+8>>2]),f=f+8|0,(o|0)==(f|0))break}if(f=i[28729],i[A>>2]=i[28728],i[A+4>>2]=f,A=A+8|0,t[114931]>=0){f=i[28731],i[A>>2]=i[28730],i[A+4>>2]=f,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function IQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;k=v-32|0,v=k,s=W[i[i[e>>2]+52>>2]](e,r,0)|0,t[e+100|0]&1&&(p0(r,i[e+104>>2]),p0(r,i[e+108>>2])),h2(r,u[e+112|0]);i:{e:{if(!u[e+112|0]){for(o=i[e+120>>2],f=i[e+124>>2]-o|0;;){if(l=f,n=0,!f)break e;if(f=f-1|0,!!u[o+f|0])break}for(p0(r,l),f=0;h2(r,u[i[e+120>>2]+f|0]),f=f+1|0,l>>>0>f>>>0;);break i}n=i[e+116>>2]}p0(r,n)}n1(k+12|0,e,r,s),t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,e=A+8|0;i:{if(t[114931]>=0){A=i[28731],i[e>>2]=i[28730],i[e+4>>2]=A,i[e+8>>2]=i[28732];break i}T(e,i[28730],i[28731])}v=k+32|0}function QQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;k=v-32|0,v=k,mn(A,e);i:{if(i[A>>2])break i;if(t[A+19|0]<0&&Z(i[A+8>>2]),s=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+100>>2],o=i[e+104>>2],(f|0)!=(o|0))for(;;){if(p0(r,(i[f+8>>2]-i[f+4>>2]|0)+8|0),p0(r,i[f>>2]),n=i[f+4>>2],l=i[f+8>>2],(n|0)!=(l|0))for(;p0(r,i[n>>2]),n=n+4|0,(l|0)!=(n|0););if(f=f+16|0,(o|0)==(f|0))break}if(n1(k+12|0,e,r,s),t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function VQ(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0;l=v-48|0,v=l,s=i[e>>2],h=i[s+48>>2],s=i[s+52>>2];i:{if(!s){mt(l+12|0,h,r,f,k,n);break i}if(i[s+4>>2]=i[s+4>>2]+1,mt(l+12|0,h,r,f,k,n),r=i[s+4>>2],i[s+4>>2]=r-1,r)break i;W[i[i[s>>2]+8>>2]](s),y(s)}i:{e:{r:{if(r=u[l+32|0],!(r|!o)){i[o>>2]=i[l+12>>2];break r}f:switch(r|0){default:e2(),M();case 0:break r;case 1:break f}if(c0(A,l+12|0,i[e>>2]),A=u[l+32|0],(A|0)==255)break i;break e}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=0}e=i[25811],i[l+40>>2]=i[25810],i[l+44>>2]=e,W[i[(l+40|0)+(A<<2)>>2]](l+39|0,l+12|0)}v=l+48|0}function pQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}if(i[e>>2]>=5){e=i[25775],i[A>>2]=i[25774],i[A+4>>2]=e,i[A+8>>2]=i[25776];return}r=i[e+28>>2],r&&W[r|0](),r=C(4),i[r>>2]=e,f=C(20),i[f+16>>2]=r,r=i[28742];i:{if(!r){e=114968,k=114968;break i}for(n=i[e+12>>2];;){if(e=r,i[i[i[e+16>>2]>>2]+12>>2]<(n|0)){if(k=e,r=i[e>>2],r)continue;break i}if(r=i[e+4>>2],!r)break}k=e+4|0}i[f+8>>2]=e,i[f>>2]=0,i[f+4>>2]=0,i[k>>2]=f,e=i[i[28741]>>2],e&&(i[28741]=e),G1(i[28742],f),i[28743]=i[28743]+1,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}function Io(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;f=K0(i[r>>2],0),k=i[i[r>>2]+200>>2],n=(f|0)<11,o=n&&(k|0)==3?1:2,s=n?k>>>0>=2?o:0:o,n=V8(i[r>>2],0),r=p8(i[r>>2],0),o=g(n,r);i:{if(!((n|0)>8192|(r|0)>4352)&&(l=13,(o|0)<8912897))break i;l=(n|0)>=16385||(r|0)>=8705?31:(o|0)<35651585?17:31}if(t[e+2|0]=l,t[e+1|0]=s,t[e+6|0]=!k,t[e+5|0]=f>>>0>11,t[e+4|0]=f>>>0>8,r=k<<3,f=k>>>0<4,t[e+7|0]=((f?16908801>>>r|0:0)&3)>>>1,t[e+9|0]=(k|0)!=1?2:0,t[e+8|0]=((f?16843265>>>r|0:0)&3)>>>1,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function FQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,f=i[r+4>>2];i:{if(!(!u[k+12|0]|((f|0)==3|i[k+8>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(!(i[r>>2]|(f|0)!=1)&i[r+12>>2]==8)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(!(i[r+16>>2]&-9)|u[r+8|0]!=1)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=p[r+24>>1],!(f>>>0>14|!(1<<f&18689))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(r=u[r+26|0],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(r|0)!=1)break i;t[e+30|0]=1,X[e+28>>1]=2,i[e+24>>2]=131074,i[e+16>>2]=8,i[e+20>>2]=0,t[e+12|0]=1,i[e+4>>2]=1,i[e+8>>2]=11,i[e>>2]=11,l8(A,e+4|0,e)}v=e+32|0}function CQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,f=i[r+4>>2];i:{if(!(!u[k+12|0]|((f|0)==3|i[k+8>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(!i[r>>2]&f-1>>>0<=2)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:switch(p[r+24>>1]-11|0){case 0:case 3:i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i;default:break e}if(f=i[r+12>>2],(f|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=8)break i;t[e+30|0]=1,X[e+28>>1]=2,i[e+24>>2]=131074,i[e+4>>2]=1,i[e+8>>2]=3,f=u[r+8|0],i[e+16>>2]=8,t[e+12|0]=f,i[e+20>>2]=i[r+16>>2],i[e>>2]=11,l8(A,e+4|0,e)}v=e+32|0}function YQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,f=i[r+4>>2];i:{if(!(!u[k+12|0]|((f|0)==3|i[k+8>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(!i[r>>2]&f-1>>>0<=2)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:switch(p[r+24>>1]-11|0){case 0:case 3:i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i;default:break e}if(f=i[r+12>>2],(f|0)<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f>>>0>14)break i;t[e+30|0]=1,X[e+28>>1]=2,i[e+24>>2]=131074,i[e+4>>2]=1,i[e+8>>2]=3,k=u[r+8|0],i[e+16>>2]=f,t[e+12|0]=k,i[e+20>>2]=i[r+16>>2],i[e>>2]=11,l8(A,e+4|0,e)}v=e+32|0}function Qo(A){var e=0;e=C(176),i[e+24>>2]=0,i[e+28>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e>>2]=97748,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e- -64>>2]=0,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,X[e+112>>1]=0,i[e+16>>2]=95360,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,t[e+144|0]=0,i[e+168>>2]=0,i[e+172>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+32>>2]=1668114798,i[A+4>>2]=e,i[A>>2]=e+16}function yQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0;r=v-32|0,v=r;i:{e:{r:{if((e|0)==-1)break r;if(i[r+20>>2]=e,u[A+44|0]==1){A=i[A+32>>2];f:{if(i[A+76>>2]<0){A=Ao(e,A);break f}A=Ao(e,A)}if((A|0)==-1)break e;break r}for(n=r+24|0,i[r+16>>2]=n,l=r+32|0,f=r+20|0;;){if(k=i[A+36>>2],k=W[i[i[k>>2]+12>>2]](k,i[A+40>>2],f,n,r+12|0,r+24|0,l,r+16|0)|0,i[r+12>>2]==(f|0))break e;if((k|0)==3){if((r4(f,1,1,i[A+32>>2])|0)==1)break r;break e}if(k>>>0>1||(o=r+24|0,f=i[r+16>>2]-o|0,(r4(o,1,f,i[A+32>>2])|0)!=(f|0)))break e;if(f=i[r+12>>2],(k|0)!=1)break}}A=(e|0)!=-1?e:0;break i}A=-1}return v=r+32|0,A|0}function EQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;f=v-16|0,v=f;i:{if(!(u[n+11|0]>>>7|0)){i[A+8>>2]=i[n+8>>2],e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e;break i}r=i[n>>2],k=v-16|0,v=k;e:{r:{n=i[n+4>>2];f:{if(n>>>0<2){e=A,t[A+11|0]=u[A+11|0]&128|n&127,t[A+11|0]=u[A+11|0]&127;break f}if(n>>>0>1073741815)break r;l=k+8|0,n>>>0>=2?(o=n+2&-2,e=o-1|0,e=(e|0)==2?o:e):e=1,Ae(l,e+1|0),e=i[k+8>>2],i[A>>2]=e,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=n}A=n+1|0;f:{if(!A||(A=A<<2,!A))break f;z(e,r,A)}v=k+16|0;break e}I4(),M()}}v=f+16|0}function Vo(A,e,r){var f=0,k=0;if(!e)return 0;i:{e:{if(!r)break e;if(f=u[e|0],k=f<<24>>24,(k|0)>=0)return A&&(i[A>>2]=f),(k|0)!=0;if(!i[i[33178]>>2]){if(e=1,!A)break i;return i[A>>2]=k&57343,1}if(f=f-194|0,f>>>0>50||(f=i[(f<<2)+79328>>2],r>>>0<=3&&f<<g(r,6)-6<0)||(r=u[e+1|0],k=r>>>3|0,(k-16|k+(f>>26))>>>0>7))break e;if(r=r-128|f<<6,(r|0)>=0){if(e=2,!A)break i;return i[A>>2]=r,2}if(f=u[e+2|0]-128|0,f>>>0>63)break e;if(k=f,f=r<<6,r=k|f,(f|0)>=0){if(e=3,!A)break i;return i[A>>2]=r,3}if(f=u[e+3|0]-128|0,f>>>0>63)break e;if(e=4,!A)break i;return i[A>>2]=f|r<<6,4}i[33136]=25,e=-1}return e}function po(A,e,r,f,k,n,o,l,s,h){var w=0,_=0,B=0;w=v-16|0,v=w;i:{if(A){A=$0(r,136760);break i}A=$0(r,136752)}i:{if(e){e=w+4|0,W[i[i[A>>2]+44>>2]](e,A),r=i[w+4>>2],t[f|0]=r,t[f+1|0]=r>>>8,t[f+2|0]=r>>>16,t[f+3|0]=r>>>24,W[i[i[A>>2]+32>>2]](e,A);break i}e=w+4|0,W[i[i[A>>2]+40>>2]](e,A),r=i[w+4>>2],t[f|0]=r,t[f+1|0]=r>>>8,t[f+2|0]=r>>>16,t[f+3|0]=r>>>24,W[i[i[A>>2]+28>>2]](e,A)}er(s,e),q1(e),_=k,B=W[i[i[A>>2]+12>>2]](A)|0,i[_>>2]=B,_=n,B=W[i[i[A>>2]+16>>2]](A)|0,i[_>>2]=B,e=w+4|0,W[i[i[A>>2]+20>>2]](e,A),u6(o,e),_2(e),W[i[i[A>>2]+24>>2]](e,A),er(l,e),q1(e),_=h,B=W[i[i[A>>2]+36>>2]](A)|0,i[_>>2]=B,v=w+16|0}function S4(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0;e=v-16|0,v=e;i:{if(!w4(A,8))break i;k=i[A>>2],r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);e:{if(!(W[i[i[k>>2]+16>>2]](k,e+8|0,8)|0)){h8(A),k=0;break e}A=0,f=u[e+8|0]|u[e+9|0]<<8|(u[e+10|0]<<16|u[e+11|0]<<24),l=f<<24|(f&65280)<<8,n=f&16711680,k=n>>>8|0,n=n<<24,o=A,s=n,A=f&-16777216,n=A>>>24|0,o=o|(s|A<<8),A=u[e+12|0]|u[e+13|0]<<8|(u[e+14|0]<<16|u[e+15|0]<<24),f=o|(((A&255)<<24|f>>>8)&-16777216|((A&16777215)<<8|f>>>24)&16711680|(A>>>8&65280|A>>>24)),k=l|(k|n)}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}return v=e+16|0,h0=k,f}function Fo(A,e,r,f,k,n,o,l,s,h){var w=0,_=0,B=0;w=v-16|0,v=w;i:{if(A){A=$0(r,136744);break i}A=$0(r,136736)}i:{if(e){e=w+4|0,W[i[i[A>>2]+44>>2]](e,A),r=i[w+4>>2],t[f|0]=r,t[f+1|0]=r>>>8,t[f+2|0]=r>>>16,t[f+3|0]=r>>>24,W[i[i[A>>2]+32>>2]](e,A);break i}e=w+4|0,W[i[i[A>>2]+40>>2]](e,A),r=i[w+4>>2],t[f|0]=r,t[f+1|0]=r>>>8,t[f+2|0]=r>>>16,t[f+3|0]=r>>>24,W[i[i[A>>2]+28>>2]](e,A)}u6(s,e),_2(e),_=k,B=W[i[i[A>>2]+12>>2]](A)|0,t[_|0]=B,_=n,B=W[i[i[A>>2]+16>>2]](A)|0,t[_|0]=B,e=w+4|0,W[i[i[A>>2]+20>>2]](e,A),u6(o,e),_2(e),W[i[i[A>>2]+24>>2]](e,A),u6(l,e),_2(e),_=h,B=W[i[i[A>>2]+36>>2]](A)|0,i[_>>2]=B,v=w+16|0}function RQ(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0;i:{if(!(!k|(!r|!f))&&n)break i;e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}i:{if(l=i[e+16>>2],!l||(l=Z0(l,101112,102448),!l))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[l+4>>2],i[f>>2]=i[l+8>>2],i[k>>2]=i[l+12>>2],i[n>>2]=i[l+16>>2],r=i[l+20>>2],f=i[l+24>>2]-r|0,f&&z(o,r,f),i[A+8>>2]=i[25680],r=i[25679],i[A>>2]=i[25678],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}return}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794]}function f5(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0;o=v-16|0,v=o;i:{if(2147483639-e>>>0>=r>>>0){u[A+11|0]>>>7|0?n=i[A>>2]:n=A,s=n,n=o+4|0,e>>>0<1073741811?(i[o+12>>2]=e<<1,i[o+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=o+12|0,r=i[(o0[n>>2]<o0[r>>2]?r:n)>>2],r>>>0>=11?(l=r+8&-8,r=l-1|0,r=(r|0)==11?l:r):r=10,r=r+1|0):r=2147483639,fe(n,r),r=i[o+4>>2],k&&(n=!k,n|n||z(r,s,k)),(f|0)!=(k|0)&&(n=r+k|0,l=k+s|0,k=f-k|0,h=!k,h|h||z(n,l,k)),(e|0)!=10&&B6(s,1),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[o+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,v=o+16|0;break i}I4(),M()}i[A+4>>2]=f}function JQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0;n=v-48|0,v=n;i:{e:{if(o=i[e>>2],!o||(l=Z0(o,113600,113736),!l))break e;o=i[e+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[n+20>>2]=i[r>>2],r=i[r+4>>2],i[n+24>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[n+24>>2],i[n+8>>2]=i[n+20>>2],i[n+12>>2]=r,r=n+28|0,y9(r,l,n+8|0,f,k,1);r:{if(i[n+28>>2]){c0(A,r,i[e+8>>2]);break r}e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}if(t[n+47|0]<0&&Z(i[n+36>>2]),!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o);break i}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27105}v=n+48|0}function z8(A,e,r,f,k){var n=0,o=0,l=0;l=v-16|0,v=l,i[l+12>>2]=e,e=0,n=6;i:{e:{if(b2(A,l+12|0))break e;n=i[A>>2],o=i[n+12>>2];r:{if((o|0)==i[n+16>>2]){o=W[i[i[n>>2]+36>>2]](n)|0;break r}o=i[o>>2]}if(n=4,!(W[i[i[f>>2]+12>>2]](f,64,o)|0))break e;for(e=W[i[i[f>>2]+52>>2]](f,o,0)|0;;){r:{if(k4(A),e=e-48|0,b2(A,l+12|0)|(k|0)<2)break r;n=i[A>>2],o=i[n+12>>2];f:{if((o|0)==i[n+16>>2]){n=W[i[i[n>>2]+36>>2]](n)|0;break f}n=i[o>>2]}if(!(W[i[i[f>>2]+12>>2]](f,64,n)|0))break i;k=k-1|0,e=(W[i[i[f>>2]+52>>2]](f,n,0)|0)+g(e,10)|0;continue}break}if(!b2(A,l+12|0))break i;n=2}i[r>>2]=n|i[r>>2]}return v=l+16|0,e}function NQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(k=v-32|0,v=k,l=W[i[i[e>>2]+52>>2]](e,r,0)|0,t[e+100|0]&1&&(p0(r,i[e+104>>2]),p0(r,i[e+108>>2])),p0(r,i[e+132>>2]-i[e+128>>2]>>3),i[e+120>>2]=i[r+12>>2],i[e+124>>2]=0,f=i[e+128>>2],n=i[e+132>>2],(f|0)!=(n|0))for(;;){o=i[f>>2],s=i[f+4>>2];i:{if(u[e+112|0]==1){h4(r,o,s);break i}p0(r,o)}if(f=f+8|0,(n|0)==(f|0))break}n1(k+12|0,e,r,l),t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function ze(A,e,r,f){var k=0,n=0,o=0,l=0;o=f||135336,f=i[o>>2];i:{e:{r:{if(!e){if(f)break r;return 0}if(k=-2,!r)break e;f:{if(f){k=r;break f}if(f=u[e|0],n=f<<24>>24,(n|0)>=0)return A&&(i[A>>2]=f),(n|0)!=0;if(!i[i[33178]>>2]){if(k=1,!A)break e;return i[A>>2]=n&57343,1}if(f=f-194|0,f>>>0>50)break r;if(f=i[(f<<2)+79328>>2],k=r-1|0,!k)break i;e=e+1|0}if(n=u[e|0],l=n>>>3|0,(l-16|(f>>26)+l)>>>0>7)break r;for(;;){if(k=k-1|0,f=(n&255)-128|f<<6,(f|0)>=0)return i[o>>2]=0,A&&(i[A>>2]=f),r-k|0;if(!k)break i;if(e=e+1|0,n=t[e|0],!((n|0)<-64))break}}i[o>>2]=0,i[33136]=25,k=-1}return k}return i[o>>2]=f,-2}function DQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-48|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+100>>2],p0(r,W[i[i[k>>2]+8>>2]](k)|0),k=i[e+100>>2],W[i[i[k>>2]+16>>2]](f+24|0,k,r);i:{if(i[f+24>>2]){e=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[f+40>>2],e=i[f+36>>2],i[A+8>>2]=i[f+32>>2],i[A+12>>2]=e,i[f+40>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0;break i}if(n1(f+4|0,e,r,n),t[f+23|0]<0&&Z(i[f+12>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}t[f+43|0]<0&&Z(i[f+32>>2]),v=f+48|0}function Co(A,e,r,f){var k=0,n=0,o=0;if(n=i[A+8>>2],k=i[A>>2],(n-k|0)/48>>>0>=f>>>0){if(o=f,n=i[A+4>>2],f=n-k|0,o>>>0>(f|0)/48>>>0){(k|0)!=(n|0)&&(f&&z(k,e,f),n=i[A+4>>2]),f=e+f|0,e=r-f|0,!e|(r|0)==(f|0)||z(n,f,e),i[A+4>>2]=e+n;return}f=r-e|0,!f|(e|0)==(r|0)||z(k,e,f),i[A+4>>2]=f+k;return}k&&(i[A+4>>2]=k,Z(k),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,n=0);i:{if(f>>>0>=89478486||(k=(n|0)/48|0,n=k<<1,f=k>>>0>=44739242?89478485:f>>>0<n>>>0?n:f,f>>>0>=89478486))break i;k=g(f,48),f=C(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,k=r-e|0,!k|(e|0)==(r|0)||z(f,e,k),i[A+4>>2]=f+k;return}s0(),M()}function A5(A){var e=0,r=0,f=0;if(n5(A),e=i[A+320>>2],e){if(f=e-4|0,r=i[f>>2],r)for(r=e+g(r,76)|0;r=r-76|0,(e|0)!=(r|0););Z(f)}Z(i[A+260>>2]),Z(i[A+240>>2]),Z(i[A+220>>2]),Z(i[A+200>>2]),Z(i[A+180>>2]),Z(i[A+160>>2]),Z(i[A+140>>2]),e=i[A+136>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+128>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+120>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return e=i[A+52>>2],e&&(i[A+56>>2]=e,Z(e)),A}function Yo(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0;i[A+44>>2]=0,f=i[A+32>>2],k=A+32|0,l=t[A+43|0],e=(l|0)<0,r=e?f:k,e=e?i[A+36>>2]:l,n=i[A+48>>2],n&8&&(i[A+12>>2]=r,i[A+8>>2]=r,o=e+r|0,i[A+16>>2]=o,i[A+44>>2]=o);i:{if(!(n&16))break i;i[A+44>>2]=e+r,o=(i[A+40>>2]&2147483647)-1|0,n=(l|0)>=0?10:o;e:{if(n>>>0>e>>>0){C5(k,n-e|0);break e}r:{if((l|0)<0){i[A+36>>2]=o;break r}t[A+43|0]=10,f=k}t[f+n|0]=0}if(i[A+24>>2]=r,i[A+20>>2]=r,f=t[A+43|0],i[A+28>>2]=((f|0)<0?i[A+36>>2]:f)+r,!(u[A+48|0]&3))break i;e:{if((e|0)<0){f=e-2147483647|0,k=(f|0)<0,r=k?r-2|0:r+2147483647|0,e=k?1:f;break e}if(!e)break i}i[A+24>>2]=e+r}}function Di(A,e){var r=0,f=0,k=0;f=v-48|0,v=f,u[115885]==1&&(i[f+36>>2]=e,i[f+32>>2]=A,q8(38267,f+32|0)),r=i[e+4>>2];i:{if(!r){if(u[115885]==1&&(i[f+4>>2]=i[A+4>>2],i[f>>2]=A,q8(38227,f)),e=i[A+4>>2],!e)break i;r=i[e>>2]-1|0,i[e>>2]=r;e:{if(r||(r=i[A>>2],r&&(Z(r),e=i[A+4>>2],!e)))break e;Z(e)}i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r>>2]=i[r>>2]+1,u[115885]==1&&(i[f+20>>2]=i[A+4>>2],i[f+16>>2]=A,q8(38227,f+16|0)),r=i[A+4>>2],r){k=i[r>>2]-1|0,i[r>>2]=k;e:{if(k||(k=i[A>>2],k&&(Z(k),r=i[A+4>>2],!r)))break e;Z(r)}i[A>>2]=0,i[A+4>>2]=0}i[A>>2]=i[e>>2],i[A+4>>2]=i[e+4>>2]}v=f+48|0}function UQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;o=v-48|0,v=o,l=i[e>>2],s=i[l+48>>2],l=i[l+52>>2];i:{if(!l){Zt(o+12|0,s,r,f,k);break i}if(i[l+4>>2]=i[l+4>>2]+1,Zt(o+12|0,s,r,f,k),r=i[l+4>>2],i[l+4>>2]=r-1,r)break i;W[i[i[l>>2]+8>>2]](l),y(l)}i:{e:{r:{if(r=u[o+32|0],!(r|!n)){i[n>>2]=1;break r}f:switch(r|0){default:e2(),M();case 0:break r;case 1:break f}if(c0(A,o+12|0,i[e>>2]),A=u[o+32|0],(A|0)==255)break i;break e}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=0}e=i[25811],i[o+40>>2]=i[25810],i[o+44>>2]=e,W[i[(o+40|0)+(A<<2)>>2]](o+39|0,o+12|0)}v=o+48|0}function d6(A,e,r,f,k,n,o,l){var s=0,h=0,w=0,_=0;w=1,s=f&2147483647,h=s,_=(s|0)==2147418112;i:{if((_&!r?A|e:_&(r|0)!=0|s>>>0>2147418112)||(s=l&2147483647,!o&(s|0)==2147418112?k|n:(s|0)==2147418112&(o|0)!=0|s>>>0>2147418112))break i;if(!(A|k|(r|o)|(e|n|(s|h))))return 0;if(s=f&l,(s|0)>0?h=1:h=(s|0)>=0,h)return((r|0)==(o|0)&(f|0)==(l|0)?(e|0)==(n|0)&A>>>0<k>>>0|e>>>0<n>>>0:r>>>0<o>>>0&(f|0)<=(l|0)|(f|0)<(l|0))?-1:(A^k|r^o|(e^n|f^l))!=0;if((r|0)==(o|0)&(f|0)==(l|0)?(e|0)==(n|0)&A>>>0>k>>>0|e>>>0>n>>>0:r>>>0>o>>>0&(f|0)>=(l|0)|(f|0)>(l|0))return-1;w=(A^k|r^o|(e^n|f^l))!=0}return w}function MQ(A,e,r,f,k,n,o,l,s,h){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0,h=h|0;var w=0,_=0,B=0,m=0,G=0,I=0,Q=0,V=0;if((s|0)>0){if(!((n|0)<=0|(k|0)<=0))for(G=1<<s-1,_=-1<<h^-1,Q=k&2147483646,V=k&1;;){if(h=(g(e,m)<<1)+A|0,B=(g(f,m)<<1)+r|0,I=0,(k|0)!=1)for(;w=(g(X[B>>1],o)+G>>s)+l|0,X[h>>1]=(w|0)>=0?(_|0)>(w|0)?w:_:0,w=(g(X[B+2>>1],o)+G>>s)+l|0,X[h+2>>1]=(w|0)>=0?(_|0)>(w|0)?w:_:0,B=B+4|0,h=h+4|0,I=I+2|0,(Q|0)!=(I|0););if(V&&(w=h,h=(g(X[B>>1],o)+G>>s)+l|0,X[w>>1]=(h|0)>=0?(h|0)<(_|0)?h:_:0),m=m+1|0,(m|0)==(n|0))break}return}U0(23601,19896,193,11317),M()}function HQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(k=v-32|0,v=k,l=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,(i[e+108>>2]-i[e+104>>2]|0)/24|0),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;;){o=i[f>>2],s=i[f+4>>2];i:{if(u[e+97|0]==1){h4(r,o,s),h4(r,i[f+8>>2],i[f+12>>2]);break i}p0(r,o),p0(r,i[f+8>>2])}if(Xr(r,X[f+16>>1]),Xr(r,X[f+18>>1]),f=f+24|0,(n|0)==(f|0))break}n1(k+12|0,e,r,l),t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function g3(A,e,r){var f=D(0),k=D(0),n=0,o=D(0),l=D(0),s=D(0),h=D(0),w=D(0);n=v-16|0,v=n,Et(n+8|0,e,r),f=E0[n+12>>2],o=E0[n+8>>2];i:{if(!(f!=D(0)|o!=D(0))){w=D(-.41868799924850464),l=D(-.3312639892101288),f=D(.11400000005960464),h=D(.5870000123977661),o=D(.29899999499320984),k=D(-.08131200075149536),s=D(-.16873499751091003);break i}k=D(D(1)-o),h=D(k-f),l=D(-h),w=D(D(l/k)*D(.5)),s=D(D(1)-f),l=D(D(l/s)*D(.5)),k=D(D(D(-f)/k)*D(.5)),s=D(D(D(-o)/s)*D(.5))}E0[A+36>>2]=k,E0[A+32>>2]=w,i[A+24>>2]=1056964608,i[A+28>>2]=1056964608,E0[A+20>>2]=l,E0[A+16>>2]=s,E0[A+12>>2]=f,E0[A+8>>2]=h,E0[A+4>>2]=o,t[A|0]=1,v=n+16|0}function zQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=w2(r),X[k+100>>1]=n,k=e,n=w2(r),X[k+106>>1]=n,k=e,n=w2(r),X[k+102>>1]=n,k=e,n=w2(r),X[k+108>>1]=n,k=e,n=w2(r),X[k+104>>1]=n,k=e,n=w2(r),X[k+110>>1]=n,k=e,n=w2(r),X[k+112>>1]=n,k=e,n=w2(r),X[k+114>>1]=n,k=e,n=F0(r),i[k+116>>2]=n,k=e,n=F0(r),i[k+120>>2]=n;i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function yo(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=106924,e=i[A+140>>2],e){if(r=e,f=i[A+144>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+140>>2]}i[A+144>>2]=e,Z(r)}if(e=i[A+128>>2],e){if(r=e,f=i[A+132>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+128>>2]}i[A+132>>2]=e,Z(r)}if(e=i[A+116>>2],e){if(r=e,f=i[A+120>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+116>>2]}i[A+120>>2]=e,Z(r)}return n2(A)|0}function Eo(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;i:{k=i[A+4>>2],h=i[A>>2];e:{if((k|0)!=(h|0)){r=k;break e}if(f=i[A+8>>2],r=i[A+12>>2],f>>>0<r>>>0){n=((r-f>>2)+1|0)/2<<2,o=f-k|0,r=(n+f|0)-o|0,(f|0)!=(k|0)&&(o&&z(r,k,o),f=i[A+8>>2]),i[A+8>>2]=f+n;break e}if(n=(r|0)==(k|0)?1:r-k>>1,n>>>0>=1073741824)break i;if(r=n<<2,l=C(r),o=l+r|0,r=(n+3&-4)+l|0,s=r,(f|0)!=(k|0))for(s=(f-k|0)+r|0,n=r,f=k;i[n>>2]=i[f>>2],f=f+4|0,n=n+4|0,(s|0)!=(n|0););if(i[A+12>>2]=o,i[A+8>>2]=s,i[A+4>>2]=r,i[A>>2]=l,!k)break e;Z(h),r=i[A+4>>2]}r=r-4|0,i[r>>2]=i[e>>2],i[A+4>>2]=r;return}x0(),M()}function G3(A,e,r,f,k){var n=0,o=0,l=0,s=0;n=v-208|0,v=n,i[n+204>>2]=r,r=n+160|0,l0(r,0,40),i[n+200>>2]=i[n+204>>2];i:{if((K9(0,e,n+200|0,n+80|0,r,f,k)|0)<0){k=-1;break i}s=i[A+76>>2]<0,o=i[A>>2],i[A>>2]=o&-33;e:{r:{f:{if(!i[A+48>>2]){i[A+48>>2]=80,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,l=i[A+44>>2],i[A+44>>2]=n;break f}if(i[A+16>>2])break r}if(r=-1,S5(A))break e}r=K9(A,e,n+200|0,n+80|0,n+160|0,f,k)}if(l&&(W[i[A+36>>2]](A,0,0)|0,i[A+48>>2]=0,i[A+44>>2]=l,i[A+28>>2]=0,e=i[A+20>>2],i[A+16>>2]=0,i[A+20>>2]=0,r=e?r:-1),e=A,A=i[A>>2],i[e>>2]=A|o&32,k=A&32?-1:r,s)break i}return v=n+208|0,k}function Ro(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=101488,e=i[A+204>>2],r=i[A+208>>2],(e|0)!=(r|0))for(;Z(i[e+44>>2]),e=e+56|0,(r|0)!=(e|0););if(f=i[A+224>>2],f){if(e=i[A+228>>2],r=f,(e|0)!=(r|0)){for(;t[e-1|0]<0&&Z(i[e-12>>2]),e=e-20|0,(f|0)!=(e|0););r=i[A+224>>2]}i[A+228>>2]=f,Z(r)}if(k1(A+216|0),f=i[A+204>>2],f){if(e=i[A+208>>2],r=f,(e|0)!=(r|0)){for(;r=i[e-52>>2],r&&(i[e-48>>2]=r,Z(r)),e=e-56|0,(f|0)!=(e|0););r=i[A+204>>2]}i[A+208>>2]=f,Z(r)}return t[A+183|0]<0&&Z(i[A+172>>2]),A=Ee(A),r=i[A+168>>2],r&&y(r),A|0}function h1(A,e,r,f){var k=0,n=0,o=0;if(k=i[A+8>>2],n=i[A>>2],k-n>>2>>>0>=f>>>0){if(o=f,k=i[A+4>>2],f=k-n|0,o>>>0>f>>2>>>0){(k|0)!=(n|0)&&(f&&z(n,e,f),k=i[A+4>>2]),f=e+f|0,e=r-f|0,!e|(r|0)==(f|0)||z(k,f,e),i[A+4>>2]=e+k;return}f=r-e|0,!f|(e|0)==(r|0)||z(n,e,f),i[A+4>>2]=f+n;return}n&&(i[A+4>>2]=n,Z(n),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0);i:{if(f>>>0>=1073741824||(n=k>>1,f=k>>>0>=2147483644?1073741823:f>>>0<n>>>0?n:f,f>>>0>=1073741824))break i;k=f<<2,f=C(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,k=r-e|0,!k|(e|0)==(r|0)||z(f,e,k),i[A+4>>2]=f+k;return}s0(),M()}function xQ(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0;i:{if(!(!r|!f|(!k|!n))&&o)break i;e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}i:{if(l=i[e+16>>2],!l||(l=Z0(l,101112,102360),!l))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[l+4>>2],i[f>>2]=i[l+8>>2],i[k>>2]=i[l+12>>2],i[n>>2]=i[l+16>>2],i[o>>2]=i[l+20>>2],i[A+8>>2]=i[25680],r=i[25679],i[A>>2]=i[25678],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}return}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794]}function TQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+104>>2],o=i[e+108>>2];i:{if(u[e+97|0]==1){h4(r,k,o),h4(r,i[e+112>>2],i[e+116>>2]),p0(r,i[e+120>>2]),h4(r,i[e+128>>2],i[e+132>>2]);break i}p0(r,k),p0(r,i[e+112>>2]),p0(r,i[e+120>>2]),p0(r,i[e+128>>2])}u2(r,u[e+138|0]&31|((u[e+137|0]&31)<<5|(u[e+136|0]&31)<<10)),u2(r,0),n1(f+12|0,e,r,n),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function jQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-48|0,v=r,i[r+44>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0;i:{if(!jn(i[e+72>>2],r+36|0)){t[r+4|0]=0,t[r+15|0]=0,e=a(r+16|0,2,117,r+4|0),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,f=A+8|0;e:{if(t[e+19|0]>=0){k=i[e+12>>2],i[f>>2]=i[e+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[e+16>>2],t[A+20|0]=1;break e}if(T(f,i[e+8>>2],i[e+12>>2]),f=t[e+19|0],t[A+20|0]=1,(f|0)>=0)break e;Z(i[e+8>>2])}if(t[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+36>>2],!A)break i;i[r+40>>2]=A,Z(A);break i}e=i[r+40>>2],f=i[r+36>>2],k=i[r+44>>2],t[A+20|0]=0,i[A+8>>2]=k,i[A>>2]=f,i[A+4>>2]=e}v=r+48|0}function W3(A,e,r,f){var k=0,n=0,o=0;if(k=i[A+8>>2],n=i[A>>2],k-n>>3>>>0>=f>>>0){if(o=f,k=i[A+4>>2],f=k-n|0,o>>>0>f>>3>>>0){(k|0)!=(n|0)&&(f&&z(n,e,f),k=i[A+4>>2]),f=e+f|0,e=r-f|0,!e|(r|0)==(f|0)||z(k,f,e),i[A+4>>2]=e+k;return}f=r-e|0,!f|(e|0)==(r|0)||z(n,e,f),i[A+4>>2]=f+n;return}n&&(i[A+4>>2]=n,Z(n),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0);i:{if(f>>>0>=536870912||(n=k>>2,f=k>>>0>=2147483640?536870911:f>>>0<n>>>0?n:f,f>>>0>=536870912))break i;k=f<<3,f=C(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,k=r-e|0,!k|(e|0)==(r|0)||z(f,e,k),i[A+4>>2]=f+k;return}s0(),M()}function Jo(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+276>>2];i:{if(!r){r=0;break i}r=i[r>>2],k=i[r+104>>2],r=i[r+108>>2],f=C(8),i[f>>2]=k,i[f+4>>2]=r,r=f+8|0,i[A+8>>2]=r,i[A>>2]=f,i[A+4>>2]=r}i:{e:{if(e=i[e+280>>2],e){if(k=r-f|0,l=k>>3,n=l+1|0,n>>>0>=536870912)break e;if(r=i[e>>2],e=i[r+108>>2],s=i[r+104>>2],r=k>>>2|0,o=k>>>0>=2147483640?536870911:r>>>0>n>>>0?r:n,o){if(o>>>0>=536870912)break i;r=C(o<<3)}else r=0;n=k+r|0,i[n>>2]=s,i[n+4>>2]=e,e=n-(l<<3)|0,k&&z(e,f,k),i[A+8>>2]=(o<<3)+r,i[A>>2]=e,f&&Z(f),i[A+4>>2]=n+8}return}s0(),M()}x0(),M()}function SQ(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0,_=0,B=0,m=0,G=0,I=0,Q=0;if((s|0)>0){if(!((n|0)<=0|(k|0)<=0))for(G=1<<s-1,I=k&2147483646,Q=k&1;;){if(h=g(e,m)+A|0,_=(g(f,m)<<1)+r|0,B=0,(k|0)!=1)for(;w=(g(X[_>>1],o)+G>>s)+l|0,w=(w|0)>=255?255:w,t[h|0]=(w|0)>0?w:0,w=(g(X[_+2>>1],o)+G>>s)+l|0,w=(w|0)>=255?255:w,t[h+1|0]=(w|0)>0?w:0,_=_+4|0,h=h+2|0,B=B+2|0,(I|0)!=(B|0););if(Q&&(B=h,h=(g(X[_>>1],o)+G>>s)+l|0,h=(h|0)>=255?255:h,t[B|0]=(h|0)>0?h:0),m=m+1|0,(m|0)==(n|0))break}return}U0(23601,19896,60,11163),M()}function p0(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;i:{f=i[A+4>>2],o=i[A>>2],l=f-o|0,r=i[A+12>>2]+4|0;e:{if(l>>>0>=r>>>0)break e;if(n=r-l|0,k=i[A+8>>2],n>>>0<=k-f>>>0){n&&l0(f,0,n),i[A+4>>2]=f+n;break e}if((r|0)<0)break i;if(f=k-o|0,k=f<<1,k=f>>>0>=1073741823?2147483647:r>>>0<k>>>0?k:r,f=C(k),n&&l0(f+l|0,0,n),l&&z(f,o,l),i[A+8>>2]=f+k,i[A+4>>2]=r+f,i[A>>2]=f,!o)break e;Z(o)}r=i[A+12>>2],i[A+12>>2]=r+1,t[r+i[A>>2]|0]=e>>>24,r=i[A+12>>2],i[A+12>>2]=r+1,t[r+i[A>>2]|0]=e>>>16,r=i[A+12>>2],i[A+12>>2]=r+1,t[r+i[A>>2]|0]=e>>>8,r=i[A+12>>2],i[A+12>>2]=r+1,t[r+i[A>>2]|0]=e;return}s0(),M()}function OQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;k=v-32|0,v=k,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+36>>2],o=i[e+40>>2];i:{if((f|0)!=(o|0))for(;;){if(l=i[f>>2],W[i[i[l>>2]+20>>2]](A,l,r),i[A>>2])break i;if(t[A+19|0]<0&&Z(i[A+8>>2]),f=f+8|0,(o|0)==(f|0))break}if(f=i[28729],i[A>>2]=i[28728],i[A+4>>2]=f,A=A+8|0,t[114931]>=0){f=i[28731],i[A>>2]=i[28730],i[A+4>>2]=f,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function xe(A,e){var r=0,f=0,k=0,n=0;i[A>>2]=92500,r=i[e+12>>2],f=i[e+8>>2],i[A+8>>2]=f,i[A+12>>2]=r,i[A+16>>2]=i[e+16>>2],i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0;i:{e:{if(r=i[e+24>>2],k=i[e+20>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break e;f=C(r),i[A+24>>2]=f,i[A+20>>2]=f,n=r+f|0,i[A+28>>2]=n,r&&z(f,k,r),i[A+24>>2]=n}if(i[A+32>>2]=i[e+32>>2],r=i[e+40>>2],i[A+52>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,i[A+40>>2]=r,r=i[e+48>>2],f=i[e+44>>2],(r|0)!=(f|0)){if(e=r-f|0,(e|0)<0)break i;r=C(e),i[A+48>>2]=r,i[A+44>>2]=r,k=e+r|0,i[A+52>>2]=k,e&&z(r,f,e),i[A+48>>2]=k}return}s0(),M()}s0(),M()}function m2(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if(k=i[A+24>>2],(k|0)>=(e|0)|(k|0)>56)r=k;else{for(r=64-k|0,o=i[A+16>>2],s=i[A+20>>2],f=i[A+4>>2],k=i[A+12>>2];;){i:{if(h=r,!k){n=r;break i}if(w=f+1|0,i[A+4>>2]=w,f=u[f|0],k=k-1|0,i[A+12>>2]=k,n=h-8|0,l=n&31,(n&63)>>>0>=32?(_=f<<l,f=0):(_=(1<<l)-1&f>>>32-l,f=f<<l),o=f|o,f=s|_,s=f,i[A+16>>2]=o,i[A+20>>2]=f,f=r,r=f-8|0,B=B-(f>>>0<8)|0,f=w,(h|0)>15)continue}break}r=64-n|0}i[A+24>>2]=r-e,o=i[A+20>>2],n=i[A+16>>2],r=e&31,(e&63)>>>0>=32?(e=n<<r,r=0):(e=(1<<r)-1&n>>>32-r|o<<r,r=n<<r),i[A+16>>2]=r,i[A+20>>2]=e}function No(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;i:{e:{r=i[A+4>>2],k=i[A+8>>2];r:{if(r>>>0<k>>>0){i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),f=r+8|0;break r}if(n=i[A>>2],f=r-n|0,l=f>>3,r=l+1|0,r>>>0>=536870912)break e;if(k=k-n|0,o=k>>2,r=k>>>0>=2147483640?536870911:r>>>0<o>>>0?o:r,r>>>0>=536870912)break i;if(k=r<<3,o=C(k),r=o+f|0,i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1,n=i[A>>2],f=i[A+4>>2]-n|0,l=f>>3),e=r-(l<<3)|0,f&&z(e,n,f),i[A+8>>2]=k+o,f=r+8|0,i[A+4>>2]=f,i[A>>2]=e,!n)break r;Z(n)}i[A+4>>2]=f;return}s0(),M()}x0(),M()}function PQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0,_=0;if(i4(A,i[e+8>>2],n)){I5(e,r,f,k);return}l=u[e+53|0],o=i[A+12>>2],t[e+53|0]=0,s=u[e+52|0],t[e+52|0]=0,h=A+16|0,$5(h,e,r,f,k,n),w=u[e+52|0],s=s|w,_=u[e+53|0],l=l|_;i:{if(o>>>0<2)break i;for(h=h+(o<<3)|0,o=A+24|0;;){if(u[e+54|0])break i;e:{if(w&1){if(i[e+24>>2]==1)break i;if(u[A+8|0]&2)break e;break i}if(!(_&1))break e;if(!(t[A+8|0]&1))break i}if(X[e+52>>1]=0,$5(o,e,r,f,k,n),_=u[e+53|0],l=(_|l)&1,w=u[e+52|0],s=(w|s)&1,o=o+8|0,!(h>>>0>o>>>0))break}}t[e+53|0]=l&1,t[e+52|0]=s&1}function Do(A,e,r,f,k){var n=0,o=0,l=0;if(n=C(24),i[n+20>>2]=e,t[n+8|0]=r,i[n>>2]=69596,i[n+4>>2]=0,i[n+16>>2]=k,i[n+12>>2]=f,i[e+18604>>2]=n,ir(A+1392|0,n),r=i[e+18596>>2],A=i[r+460>>2],k=i[r+464>>2],A>>>0<k>>>0){i[A>>2]=n,i[r+460>>2]=A+4;return}i:{if(f=i[r+456>>2],A=A-f|0,l=A>>2,e=l+1|0,e>>>0<1073741824){if(k=k-f|0,o=k>>1,k=k>>>0>=2147483644?1073741823:e>>>0<o>>>0?o:e,k){if(k>>>0>=1073741824)break i;e=C(k<<2)}else e=0;o=e+A|0,i[o>>2]=n,n=o-(l<<2)|0,A&&z(n,f,A),i[r+464>>2]=e+(k<<2),A=o+4|0,i[r+460>>2]=A,i[r+456>>2]=n,f&&Z(f),i[r+460>>2]=A;return}s0(),M()}x0(),M()}function LQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;i:{if(k=i[r+12>>2],(k|0)>=9)break i;e:{if(e=u[r+8|0],(e|0)!=1||(o=i[r+16>>2],!o|(k|0)==(o|0)))break e;break i}if(o=i[r+4>>2],t[f+8|0]&1|(!e|o>>>0>3)||!i[n+4>>2])break i;f=i[r+16>>2],n=i[r+24>>2],l=i[r+20>>2],s=i[r>>2],e=C(32),t[e+8|0]=0,i[e+4>>2]=o,i[e>>2]=s,o=u[r+9|0]|u[r+10|0]<<8,t[e+9|0]=o,t[e+10|0]=o>>>8,t[e+11|0]=u[r+11|0],i[e+28>>2]=1,i[e+20>>2]=l,i[e+24>>2]=n,i[e+16>>2]=f,i[e+12>>2]=k,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function qQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;i:{if(k=i[r+12>>2],(k|0)<=8)break i;e:{if(e=u[r+8|0],(e|0)!=1||(o=i[r+16>>2],!o|(k|0)==(o|0)))break e;break i}if(o=i[r+4>>2],t[f+8|0]&1|(!e|o>>>0>3)||!i[n+4>>2])break i;f=i[r+16>>2],n=i[r+24>>2],l=i[r+20>>2],s=i[r>>2],e=C(32),t[e+8|0]=0,i[e+4>>2]=o,i[e>>2]=s,o=u[r+9|0]|u[r+10|0]<<8,t[e+9|0]=o,t[e+10|0]=o>>>8,t[e+11|0]=u[r+11|0],i[e+28>>2]=1,i[e+20>>2]=l,i[e+24>>2]=n,i[e+16>>2]=f,i[e+12>>2]=k,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function k5(A){var e=0;return i[A+8>>2]=0,i[A+12>>2]=0,i[A+56>>2]=-1,i[A+60>>2]=-1,i[A+72>>2]=0,i[A+76>>2]=0,i[A+100>>2]=0,i[A+136>>2]=0,i[A+128>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,e=A- -64|0,i[e>>2]=-1,i[e+4>>2]=-1,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,X[A+96>>1]=0,i[A+112>>2]=0,i[A+116>>2]=0,t[A+117|0]=0,t[A+118|0]=0,t[A+119|0]=0,t[A+120|0]=0,t[A+121|0]=0,t[A+122|0]=0,t[A+123|0]=0,t[A+124|0]=0,i[A>>2]=92528,t[A+132|0]=0,i[A+16>>2]=1768714083,A}function aQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,p[e+100>>1]),u2(r,p[e+106>>1]),u2(r,p[e+102>>1]),u2(r,p[e+108>>1]),u2(r,p[e+104>>1]),u2(r,p[e+110>>1]),u2(r,p[e+112>>1]),u2(r,p[e+114>>1]),p0(r,i[e+116>>2]),p0(r,i[e+120>>2]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function KQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;if(!(f&&r)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}i:{e:{if(k=i[e+16>>2],!k||(k=Z0(k,101112,102228),!k))break e;if(e=i[e+20>>2],e)break i;i[r>>2]=i[k+4>>2],i[f>>2]=i[k+8>>2],i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e;return}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794];return}i[e+4>>2]=i[e+4>>2]+1,i[r>>2]=i[k+4>>2],i[f>>2]=i[k+8>>2],i[A+8>>2]=i[25680],r=i[25679],i[A>>2]=i[25678],i[A+4>>2]=r,A=i[e+4>>2],i[e+4>>2]=A-1,A||(W[i[i[e>>2]+8>>2]](e),y(e))}function b6(A,e,r,f){var k=0,n=0,o=0,l=0;i:{e:{if(f){if(f>>>0>=107374183)break e;if(k=g(f,40),f=C(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,(e|0)!=(r|0))for(;;){if(k=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=k,k=i[e+20>>2],i[f+16>>2]=i[e+16>>2],i[f+20>>2]=k,k=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=k,i[f+32>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,o=i[e+24>>2],k=i[e+28>>2],(o|0)!=(k|0)){if(k=k-o|0,(k|0)<0)break i;n=C(k),i[f+28>>2]=n,i[f+24>>2]=n,l=k+n|0,i[f+32>>2]=l,k&&z(n,o,k),i[f+28>>2]=l}if(f=f+40|0,e=e+40|0,(r|0)==(e|0))break}i[A+4>>2]=f}return}s0(),M()}s0(),M()}function $Q(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;k=v-32|0,v=k;i:{e:{if(n=i[e>>2],o=i[n+340>>2],s=i[n+344>>2],(o|0)==(s|0))break e;for(;;){if(l=i[o>>2],i[l>>2]!=(r|0)){if(o=o+8|0,(s|0)!=(o|0))continue;break e}break}if(r=i[l+40>>2],o=i[l+44>>2],(r|0)!=(o|0)){if(!f){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}n=o-r|0,n&&z(f,r,n),n=i[e>>2]}c0(A,114912,n?n+164|0:0);break i}if(t[k|0]=0,t[k+11|0]=0,r=a(k+12|0,5,2e3,k),t[k+11|0]<0&&Z(i[k>>2]),f=A,A=i[e>>2],c0(f,r,A?A+164|0:0),t[r+19|0]>=0)break i;Z(i[r+8>>2])}v=k+32|0}function Uo(A,e,r,f,k){var n=0,o=0,l=0,s=0,h=0,w=0,_=0;i:{if((f|k)<0||(o=i[A+124>>2],i[o+484>>2]<=(f|0)|i[o+488>>2]<=(k|0))||(h=i[A+132>>2],s=i[h+8496>>2],n=i[o+16936>>2],l=i[o+16924>>2],i[(s+(f>>>n<<2)|0)+(g(l,k>>>n|0)<<2)>>2]>i[(s+(e>>n<<2)|0)+(g(r>>n,l)<<2)>>2])||(s=i[A+140>>2],l=e,e=i[o+16876>>2],n=l>>e,A=i[A+152>>2],r=r>>e,w=p[(s+g(n,24)|0)+g(g(A,r),24)>>1],f=f>>>e|0,l=A,A=k>>>e|0,(w|0)!=p[(s+g(f,24)|0)+g(g(l,A),24)>>1]))break i;e=i[h+8484>>2],k=r,r=i[o+16892>>2],_=i[(e+(n<<2)|0)+(g(k,r)<<2)>>2]==i[(e+(f<<2)|0)+(g(A,r)<<2)>>2]}return _}function H0(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;i:{if((r|0)>0)for(o=u[A+12|0],f=i[A+16>>2];;){if(k=f+1|0,i[A+16>>2]=k,h=r-1|0,o=(e>>>h&1)<<7-f|o,t[A+12|0]=o,(k|0)==8){f=i[A+4>>2],n=i[A+8>>2];e:{if(f>>>0<n>>>0){t[f|0]=o,f=f+1|0;break e}if(l=i[A>>2],f=f-l|0,k=f+1|0,(k|0)<0)break i;if(n=n-l|0,s=n<<1,n=n>>>0>=1073741823?2147483647:k>>>0<s>>>0?s:k,n?k=C(n):k=0,s=k+f|0,t[s|0]=o,f&&z(k,l,f),i[A+8>>2]=k+n,f=s+1|0,i[A+4>>2]=f,i[A>>2]=k,!l)break e;Z(l)}o=0,i[A+16>>2]=0,t[A+12|0]=0,i[A+4>>2]=f,k=0}if(f=k,k=r>>>0>1,r=h,!k)break}return}s0(),M()}function dQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=v-48|0,v=n;i:{if(!(k&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}hA(n+12|0,i[e>>2],r,f);e:{r:switch(u[n+32|0]){default:e2(),M();case 0:if(e=i[n+12>>2],!e){i[A>>2]=5,i[A+4>>2]=2007,i[A+8>>2]=2333,e=0;break e}i[k>>2]=i[e+104>>2]-i[e+100>>2],i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,e=0;break e;case 1:break r}if(c0(A,n+12|0,i[e>>2]),e=u[n+32|0],(e|0)==255)break i}A=i[25805],i[n+40>>2]=i[25804],i[n+44>>2]=A,W[i[(n+40|0)+(e<<2)>>2]](n+39|0,n+12|0)}v=n+48|0}function Mo(A,e,r,f){var k=0,n=0,o=0,l=0;if(k=C(20),i[k+16>>2]=e,t[k+8|0]=r,i[k>>2]=69660,i[k+4>>2]=0,i[k+12>>2]=f,i[e+18604>>2]=k,ir(A+1392|0,k),r=i[e+18596>>2],A=i[r+460>>2],n=i[r+464>>2],A>>>0<n>>>0){i[A>>2]=k,i[r+460>>2]=A+4;return}i:{if(f=i[r+456>>2],A=A-f|0,l=A>>2,e=l+1|0,e>>>0<1073741824){if(n=n-f|0,o=n>>1,n=n>>>0>=2147483644?1073741823:e>>>0<o>>>0?o:e,n){if(n>>>0>=1073741824)break i;e=C(n<<2)}else e=0;o=e+A|0,i[o>>2]=k,k=o-(l<<2)|0,A&&z(k,f,A),i[r+464>>2]=e+(n<<2),A=o+4|0,i[r+460>>2]=A,i[r+456>>2]=k,f&&Z(f),i[r+460>>2]=A;return}s0(),M()}x0(),M()}function bQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(f=v-32|0,v=f,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,h2(r,i[e+108>>2]-i[e+104>>2]&255),k=i[e+104>>2],(k|0)!=i[e+108>>2])for(;h2(r,u[k+n|0]),n=n+1|0,k=i[e+104>>2],n>>>0<i[e+108>>2]-k>>>0;);i[r+12>>2]=o,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+o|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Ho(A,e,r){var f=0,k=0,n=0,o=0,l=0;l=v-16|0,v=l,k=v-16|0,v=k,f=A;i:{if(e>>>0<=1073741815){e:{if(e>>>0<2){t[f+11|0]=u[f+11|0]&128|e&127,t[f+11|0]=u[f+11|0]&127;break e}o=k+8|0,e>>>0>=2?(n=e+2&-2,A=n-1|0,A=(A|0)==2?n:A):A=1,Ae(o,A+1|0),A=i[k+8>>2],i[f>>2]=A,i[f+8>>2]=i[f+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[f+8>>2]=i[f+8>>2]|-2147483648,i[f+4>>2]=e}for(n=v-16|0,v=n,i[n+12>>2]=r,r=A,o=e;;){if(o){i[r>>2]=i[n+12>>2],o=o-1|0,r=r+4|0;continue}break}v=n+16|0,i[k+4>>2]=0,i[(e<<2)+A>>2]=i[k+4>>2],v=k+16|0;break i}I4(),M()}return v=l+16|0,f}function cQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+104>>2]),p0(r,i[e+112>>2]-i[e+108>>2]>>2),k=i[e+108>>2],o=i[e+112>>2],(k|0)!=(o|0))for(;p0(r,i[k>>2]),k=k+4|0,(o|0)!=(k|0););i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function X3(A,e,r,f,k,n,o,l,s,h,w){var _=0,B=0,m=0,G=0;if(!u[r+332|0]){X[h>>1]=0,X[h+2>>1]=0,t[w|0]=0;return}if(B=i[i[e+124>>2]+16876>>2],i[r+28>>2]|u[r+380|0]?_=924:_=988,_=i[(_+r|0)+(i[r+384>>2]<<2)>>2],!(W[i[i[A>>2]+12>>2]](A,_)|0)){X[h>>1]=0,X[h+2>>1]=0,t[w|0]=0,C2(A+4|0,1012,0);return}i:{e:{r:{m=k+o|0;f:{if(k>>B!=m>>B||(G=f+n|0,B=i[e+124>>2],(G|0)>=i[B+484>>2]))break f;if(i[B+488>>2]>(m|0))break r}X[h>>1]=0,X[h+2>>1]=0,t[w|0]=0;break e}if(Un(A,e,r,_,G&-16,m&-16,l,s,h,w),u[w|0])break i}Un(A,e,r,_,(n>>1)+f&-16,(o>>1)+k&-16,l,s,h,w)}}function P0(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;if(r=i[A+4>>2],f=i[A+8>>2],r>>>0<f>>>0){i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),i[A+4>>2]=r+8;return}i:{if(k=i[A>>2],n=r-k|0,l=n>>3,r=l+1|0,r>>>0<536870912){if(f=f-k|0,o=f>>2,r=f>>>0>=2147483640?536870911:r>>>0<o>>>0?o:r,r>>>0>=536870912)break i;f=r<<3,o=C(f),r=o+n|0,i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1,k=i[A>>2],n=i[A+4>>2]-k|0,l=n>>3),e=r-(l<<3)|0,n&&z(e,k,n),i[A+8>>2]=f+o,r=r+8|0,i[A+4>>2]=r,i[A>>2]=e,k&&Z(k),i[A+4>>2]=r;return}s0(),M()}x0(),M()}function zo(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0;k=v-16|0,v=k,p0(r,f),p0(r,i[e+16>>2]);i:{e:{if(i[e+16>>2]!=1970628964)break e;if(i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,n=i[e+24>>2],f=i[e+20>>2],(n|0)!=(f|0)){if(e=n-f|0,(e|0)<0)break i;n=C(e),i[k+4>>2]=n,o=e+n|0,i[k+12>>2]=o,e&&z(n,f,e),i[k+8>>2]=o}if(F4(r,k+4|0),e=i[k+4>>2],!e)break e;i[k+8>>2]=e,Z(e)}e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;e:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break e}T(A,i[28730],i[28731])}v=k+16|0;return}s0(),M()}function iV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if((r|0)>0)for(_=r&2147483644,h=r&3,B=r>>>0<4;;){if(w=g(r,s),l=0,f=0,o=0,!B)for(;n=f,f=l+w|0,k=n+X[(f<<1)+e>>1]|0,i[(f<<2)+A>>2]=k,n=f+1|0,k=k+X[(n<<1)+e>>1]|0,i[(n<<2)+A>>2]=k,n=f+2|0,k=k+X[(n<<1)+e>>1]|0,i[(n<<2)+A>>2]=k,n=f+3|0,f=k+X[(n<<1)+e>>1]|0,i[(n<<2)+A>>2]=f,l=l+4|0,o=o+4|0,(_|0)!=(o|0););if(o=0,h)for(;k=l+w|0,f=X[(k<<1)+e>>1]+f|0,i[(k<<2)+A>>2]=f,l=l+1|0,o=o+1|0,(h|0)!=(o|0););if(s=s+1|0,(s|0)==(r|0))break}}function eV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;for(k=v-16|0,v=k;;){i:{if((r|0)<=(l|0))break i;f=i[A+12>>2],o=i[A+16>>2];e:{if(f>>>0<o>>>0){i[k+12>>2]=2147483647,i[k+8>>2]=o-f>>2,i[k+4>>2]=r-l,f=v-16|0,v=f,v=f+16|0,f=v-16|0,v=f,v=f+16|0,o=i[A+12>>2],f=k+4|0,n=k+8|0,f=i[f>>2]<i[n>>2]?f:n,n=k+12|0,f=i[(i[f>>2]<i[n>>2]?f:n)>>2];r:{if(!f||(n=f<<2,!n))break r;z(e,o,n)}o=f<<2,i[A+12>>2]=o+i[A+12>>2],e=e+o|0;break e}if(f=W[i[i[A>>2]+40>>2]](A)|0,(f|0)==-1)break i;i[e>>2]=f,f=1,e=e+4|0}l=f+l|0;continue}break}return v=k+16|0,l|0}function rV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-48|0,v=f;i:{if(!r){if(t[f+16|0]=0,t[f+27|0]=0,r=A,A=a(f+28|0,5,2001,f+16|0),c0(r,A,i[e>>2]),t[A+19|0]<0&&Z(i[A+8>>2]),t[f+27|0]>=0)break i;Z(i[f+16>>2]);break i}is(f+8|0,i[e>>2]),k=i[f+8>>2];e:{if(!k){if(t[f+16|0]=0,t[f+27|0]=0,r=A,A=a(f+28|0,2,124,f+16|0),c0(r,A,i[e>>2]),t[A+19|0]<0&&Z(i[A+8>>2]),t[f+27|0]>=0)break e;Z(i[f+16>>2]);break e}i[r>>2]=i[k+196>>2],c0(A,114912,i[e>>2])}if(A=i[f+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f+48|0}function c6(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if(e)for(f=i[A+16>>2],k=i[A+20>>2],n=i[A+4>>2],o=i[A+12>>2],r=i[A+24>>2];;){if((r|0)<=7){for(l=64-r|0,_=0,r=n;;){i:{if(B=l,!o){o=0,n=r,s=l;break i}if(n=r+1|0,i[A+4>>2]=n,r=u[r|0],o=o-1|0,i[A+12>>2]=o,s=B-8|0,h=s&31,(s&63)>>>0>=32?(w=r<<h,r=0):(w=(1<<h)-1&r>>>32-h,r=r<<h),f=r|f,r=k|w,k=r,i[A+16>>2]=f,i[A+20>>2]=r,r=l,l=r-8|0,_=_-(r>>>0<8)|0,r=n,(B|0)>15)continue}break}r=64-s|0}if(r=r-8|0,i[A+24>>2]=r,w=k<<8|f>>>24,f=f<<8,i[A+16>>2]=f,k=w,i[A+20>>2]=k,e=e-1|0,!e)break}}function xo(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;i:{e:{if(o=i[A+104>>2],r=i[A+108>>2],!((o|0)!=(r|0)&i[r-4>>2]==(e|0))){if(f=i[A+112>>2],f>>>0>r>>>0){i[r>>2]=1,i[r+4>>2]=e,i[A+108>>2]=r+8;return}if(r=r-o|0,l=r>>3,k=l+1|0,k>>>0>=536870912)break e;if(f=f-o|0,n=f>>2,f=f>>>0>=2147483640?536870911:n>>>0>k>>>0?n:k,f){if(f>>>0>=536870912)break i;k=C(f<<3)}else k=0;n=k+r|0,i[n>>2]=1,i[n+4>>2]=e,e=n-(l<<3)|0,r&&z(e,o,r),i[A+112>>2]=k+(f<<3),r=n+8|0,i[A+108>>2]=r,i[A+104>>2]=e,o&&Z(o),i[A+108>>2]=r;return}A=r-8|0,i[A>>2]=i[A>>2]+1;return}s0(),M()}x0(),M()}function fV(A,e,r,f,k){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,i4(A,i[e+8>>2],k)){i[e+28>>2]==1|i[e+4>>2]!=(r|0)||(i[e+28>>2]=f);return}i:{if(i4(A,i[e>>2],k)){if(!(i[e+16>>2]!=(r|0)&i[e+20>>2]!=(r|0))){if((f|0)!=1)break i;i[e+32>>2]=1;return}i[e+32>>2]=f;e:{if(i[e+44>>2]==4)break e;if(X[e+52>>1]=0,A=i[A+8>>2],W[i[i[A>>2]+20>>2]](A,e,r,r,1,k),u[e+53|0]==1){if(i[e+44>>2]=3,!u[e+52|0])break e;break i}i[e+44>>2]=4}if(i[e+20>>2]=r,i[e+40>>2]=i[e+40>>2]+1,i[e+36>>2]!=1|i[e+24>>2]!=2)break i;t[e+54|0]=1;return}A=i[A+8>>2],W[i[i[A>>2]+24>>2]](A,e,r,f,k)}}function AV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;k=v-32|0,v=k;i:{if(!r){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}f=i[e>>2],n=i[f+16>>2],f=i[f+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);e:{if(n){o=i[n+12>>2],n=i[n+8>>2],o=o-n|0,o&&z(r,n,o),r=A,A=i[e>>2],c0(r,114912,A?A+164|0:0);break e}if(t[k|0]=0,t[k+11|0]=0,r=a(k+12|0,10,0,k),t[k+11|0]<0&&Z(i[k>>2]),n=A,A=i[e>>2],c0(n,r,A?A+164|0:0),t[r+19|0]>=0)break e;Z(i[r+8>>2])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=k+32|0}function kV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;k=v-32|0,v=k;i:{if(!r){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}f=i[e>>2],n=i[f+16>>2],f=i[f+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);e:{if(n){o=i[n+12>>2],n=i[n+8>>2],o=o-n|0,o&&z(r,n,o),r=A,A=i[e>>2],c0(r,114912,A?A+172|0:0);break e}if(t[k|0]=0,t[k+11|0]=0,r=a(k+12|0,10,0,k),t[k+11|0]<0&&Z(i[k>>2]),n=A,A=i[e>>2],c0(n,r,A?A+172|0:0),t[r+19|0]>=0)break e;Z(i[r+8>>2])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=k+32|0}function To(A,e,r,f,k){var n=0,o=0,l=0;i:{e:{if(n=i[f>>2],f=i[n+104>>2],n=i[n+108>>2],(f|0)!=(n|0))for(;;){if(i[f>>2]==(r|0))break e;if(f=f+16|0,(n|0)==(f|0))break}break i}e:{r:{if(r=i[f+4>>2],f=i[f+8>>2],(r|0)==(f|0))break r;for(n=i[e+36>>2],l=i[e+40>>2]-n>>3;;){if(e=p[r+2>>1],!(e>>>0<=l>>>0&&e))break i;if(e=n+(e<<3)|0,o=i[e-8>>2],i[o+16>>2]!=(k|0)){if(r=r+4|0,(f|0)==(r|0))break r;continue}break}if(i[A>>2]=o,r=A,A=i[e-4>>2],i[r+4>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1;return}i[A>>2]=0,i[A+4>>2]=0}return}i[A>>2]=0,i[A+4>>2]=0}function jo(A,e,r,f){var k=0,n=0;i:{if(!r){e=p[e>>1]|p[e+2>>1]<<16,X[A>>1]=e,X[A+2>>1]=e>>>16;break i}k=(r|0)>=127?127:r,k=(k|0)<=-128?-128:k,n=k>>31,f=(f|0)>=127?127:f,f=g(((k^n)-n>>>1|16384)/(k|0)<<16>>16,(f|0)<=-128?-128:f)+32>>6,f=(f|0)>=4095?4095:f,n=(f|0)<=-4096?-4096:f,f=g(n,X[e>>1]),k=f>>31,f=g(((f|0)>0)-((f|0)<0)|0,((f^k)-k|0)+127>>>8|0),f=(f|0)>=32767?32767:f,X[A>>1]=(f|0)<=-32768?-32768:f,e=g(n,X[e+2>>1]),f=e>>31,k=A,A=g(((e|0)>0)-((e|0)<0)|0,((e^f)-f|0)+127>>>8|0),A=(A|0)>=32767?32767:A,X[k+2>>1]=(A|0)<=-32768?-32768:A}return(r|0)!=0}function ii(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;i:{e:{if(n=i[A>>2],o=i[A+4>>2]-n|0,r=((o|0)/12|0)+1|0,r>>>0<357913942){if(k=(i[A+8>>2]-n|0)/12|0,f=k<<1,r=k>>>0>=178956970?357913941:r>>>0<f>>>0?f:r,r>>>0>=357913942)break e;if(l=g(r,12),s=C(l),r=s+o|0,i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,f=i[e+4>>2],k=i[e>>2],(f|0)!=(k|0)){if(e=f-k|0,(e|0)<0)break i;f=C(e),i[r>>2]=f,h=e+f|0,i[r+8>>2]=h,e&&z(f,k,e),i[r+4>>2]=h}return e=r+g((o|0)/-12|0,12)|0,o&&z(e,n,o),i[A+8>>2]=l+s,r=r+12|0,i[A+4>>2]=r,i[A>>2]=e,n&&Z(n),r}s0(),M()}x0(),M()}s0(),M()}function So(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;if(f=i[A+8>>2],r=i[A+4>>2],(f-r|0)/12>>>0>=e>>>0){e&&(e=g(e,12)-12|0,e=(e-((e>>>0)%12|0)|0)+12|0,e&&l0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(n=r,r=i[A>>2],o=n-r|0,k=((o|0)/12|0)+e|0,k>>>0<357913942){if(f=(f-r|0)/12|0,n=f<<1,k=f>>>0>=178956970?357913941:k>>>0<n>>>0?n:k,k){if(k>>>0>=357913942)break i;l=C(g(k,12))}f=o+l|0,e=g(e,12)-12|0,e=(e-((e>>>0)%12|0)|0)+12|0,e&&l0(f,0,e),n=f+g((o|0)/-12|0,12)|0,o&&z(n,r,o),i[A+8>>2]=g(k,12)+l,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}s0(),M()}x0(),M()}function nV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+100>>2]),p0(r,i[e+104>>2]),k=i[e+108>>2],o=i[e+112>>2],(k|0)!=(o|0))for(;p0(r,i[k>>2]),k=k+4|0,(o|0)!=(k|0););i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function n5(A){var e=0,r=0,f=0,k=0;if(i[A+4>>2]&&(e=i[A+308>>2],r=i[A+112>>2],r&&(f=i[r+544>>2]),W[e|0](r,A,f),i[A+12>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,i[A+72>>2]=0,i[A+64>>2]=0,i[A+68>>2]=0),e=i[A+52>>2],k=i[A+56>>2],(e|0)!=(k|0))for(f=0;;){if(r=i[(f<<2)+e>>2],r){e=i[r+1352>>2],e&&(i[r+1356>>2]=e,Z(e)),l6(r+1340|0),e=i[r+784>>2],e&&(i[r+788>>2]=e,Z(e)),e=i[r+8>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(r),k=i[A+56>>2],e=i[A+52>>2]}if(f=f+1|0,!(f>>>0<k-e>>2>>>0))break}i[A+56>>2]=e}function Oo(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0;if(i[A>>2]=106584,n=i[A+176>>2],n){if(e=n,r=i[A+180>>2],(e|0)!=(r|0)){for(;;){if(l=r-12|0,f=i[l>>2],f){if(k=f,s=r-8|0,e=i[s>>2],(f|0)!=(e|0)){for(;k=e-12|0,o=i[k>>2],o&&(i[e-8>>2]=o,Z(o)),e=k,(f|0)!=(e|0););k=i[l>>2]}i[s>>2]=f,Z(k)}if(r=r-16|0,(n|0)==(r|0))break}e=i[A+176>>2]}i[A+180>>2]=n,Z(e)}return e=i[A+156>>2],e&&(i[A+160>>2]=e,Z(e)),e=i[A+144>>2],e&&(i[A+148>>2]=e,Z(e)),e=i[A+132>>2],e&&Z(e),e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),n2(A)|0}function tV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;k=v-16|0,v=k,f=i[A>>2],n=u[f+20|0];i:{if((n|0)!=255){if((n|0)==1){A=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=A,t[e+19|0]<0&&Z(i[e+8>>2]),A=i[r+12>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=A,i[e+16>>2]=i[r+16>>2],t[r+19|0]=0,t[r+8|0]=0;break i}A=i[25173],i[k+8>>2]=i[25172],i[k+12>>2]=A,W[i[(k+8|0)+(n<<2)>>2]](k+7|0,f)}t[f+20|0]=255,A=i[r+4>>2],i[f>>2]=i[r>>2],i[f+4>>2]=A,i[f+16>>2]=i[r+16>>2],A=i[r+12>>2],i[f+8>>2]=i[r+8>>2],i[f+12>>2]=A,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,t[f+20|0]=1}v=k+16|0}function I3(A,e,r){var f=0,k=0,n=0,o=0;o=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);i:{f=i[A+20>>2];e:{if(!f){n=A+20|0,r=n;break e}for(;;){if(r=f,f=i[f+16>>2],f>>>0>e>>>0){if(n=r,f=i[r>>2],f)continue;break e}if(e>>>0<=f>>>0)break i;if(f=i[r+4>>2],!f)break}n=r+4|0}f=C(28),i[f+24>>2]=k,i[f+20>>2]=o,i[f+16>>2]=e,i[f+8>>2]=r,i[f>>2]=0,i[f+4>>2]=0,i[n>>2]=f,e=i[i[A+16>>2]>>2],e&&(i[A+16>>2]=e),G1(i[A+20>>2],f),i[A+24>>2]=i[A+24>>2]+1;return}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}}function ei(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;if(k=i[A+16>>2],!((k|0)>=(e|0)|(k|0)>56)){for(n=64-k|0,k=i[A+4>>2];;){i:{if(f=n,!k){o=f;break i}if(r=i[A>>2],i[A>>2]=r+1,r=u[r|0],k=k-1|0,i[A+4>>2]=k,h=i[A+12>>2],o=f-8|0,l=o&31,w=A,(o&63)>>>0>=32?(s=r<<l,r=0):(s=(1<<l)-1&r>>>32-l,r=r<<l),i[w+8>>2]=r|i[A+8>>2],i[A+12>>2]=s|h,r=n,n=r-8|0,_=_-(r>>>0<8)|0,(f|0)>15)continue}break}k=64-o|0}i[A+16>>2]=k-e,n=i[A+12>>2],r=i[A+8>>2],f=e&31,(e&63)>>>0>=32?(e=r<<f,f=0):(e=(1<<f)-1&r>>>32-f|n<<f,f=r<<f),i[A+8>>2]=f,i[A+12>>2]=e}function c1(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;if(f=i[A+24>>2],(f|0)>=16|(f|0)>56)r=f;else{for(r=64-f|0,n=i[A+16>>2],l=i[A+20>>2],e=i[A+4>>2],f=i[A+12>>2];;){i:{if(s=r,!f){k=r;break i}if(h=e+1|0,i[A+4>>2]=h,e=u[e|0],f=f-1|0,i[A+12>>2]=f,k=s-8|0,o=k&31,(k&63)>>>0>=32?(w=e<<o,e=0):(w=(1<<o)-1&e>>>32-o,e=e<<o),n=e|n,e=l|w,l=e,i[A+16>>2]=n,i[A+20>>2]=e,e=r,r=e-8|0,_=_-(e>>>0<8)|0,e=h,(s|0)>15)continue}break}r=64-k|0}return i[A+24>>2]=r-16,k=i[A+20>>2],r=i[A+16>>2],n=k<<16|r>>>16,i[A+16>>2]=r<<16,i[A+20>>2]=n,k>>>16|0}function oV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;if((f|0)>0)for(B=f&2147483646,m=f&1,o=-1<<k^-1;;){if(l=(g(f,h)<<2)+r|0,w=(g(e,h)<<1)+A|0,k=0,_=0,(f|0)!=1)for(;s=w+(k<<1)|0,n=i[(k<<2)+l>>2]+p[s>>1]|0,X[s>>1]=(n|0)>=0?(n|0)<(o|0)?n:o:0,n=k|1,s=w+(n<<1)|0,n=i[(n<<2)+l>>2]+p[s>>1]|0,X[s>>1]=(n|0)>=0?(n|0)<(o|0)?n:o:0,k=k+2|0,_=_+2|0,(B|0)!=(_|0););if(m&&(n=i[(k<<2)+l>>2],l=w+(k<<1)|0,k=n+p[l>>1]|0,X[l>>1]=(k|0)>=0?(k|0)<(o|0)?k:o:0),h=h+1|0,(h|0)==(f|0))break}}function lV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+100>>2]),p0(r,i[e+104>>2]),p0(r,i[e+108>>2]),p0(r,i[e+112>>2]),p0(r,i[e+116>>2]),p0(r,i[e+120>>2]),p0(r,i[e+124>>2]),p0(r,i[e+128>>2]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Q3(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;i:{e:{if(r=i[A+108>>2],f=i[A+112>>2],r=ie(r,e,f-r>>2),r=r||f,f=i[A+112>>2],(r|0)==(f|0)){k=i[A+116>>2];r:{if(k>>>0>r>>>0){i[f>>2]=e,e=f+4|0;break r}if(o=i[A+108>>2],r=r-o|0,l=r>>2,f=l+1|0,f>>>0>=1073741824)break e;if(k=k-o|0,n=k>>1,k=k>>>0>=2147483644?1073741823:f>>>0<n>>>0?n:f,k){if(k>>>0>=1073741824)break i;f=C(k<<2)}else f=0;if(n=f+r|0,i[n>>2]=e,l=n-(l<<2)|0,r&&z(l,o,r),i[A+116>>2]=f+(k<<2),e=n+4|0,i[A+112>>2]=e,i[A+108>>2]=l,!o)break r;Z(o)}i[A+112>>2]=e}return}s0(),M()}x0(),M()}function uV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,n=i[e+12>>2];i:{if(!n&o0[e+8>>2]>=o0[e+32>>2]|n){if(F4(r,e+100|0),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}if(t[f|0]=0,t[f+11|0]=0,a(A,2,101,f),t[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function sV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0;n=v-32|0,v=n,i[n+28>>2]=e;i:{if(!(i[r+4>>2]&1)){r=W[i[i[A>>2]+24>>2]](A,e,r,f,k)|0;break i}e=n+16|0,A=i[r+28>>2],i[e>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),A=$0(e,137072),i2(e);e:{if(k){W[i[i[A>>2]+24>>2]](e,A);break e}W[i[i[A>>2]+28>>2]](n+16|0,A)}for(o=n,l=e8(n+16|0),i[o+12>>2]=l;;){if(A=n+16|0,o=n,l=y6(A),i[o+8>>2]=l,i[n+12>>2]==i[n+8>>2])r=i[n+28>>2],q1(A);else{Ku(n+28|0,i[i[n+12>>2]>>2]),i[n+12>>2]=i[n+12>>2]+4;continue}break}}return v=n+32|0,r|0}function hV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,31820);break i}if(p4(f+20|0,r),t[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function wV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,11373);break i}if(p4(f+20|0,r),t[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function _V(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,12024);break i}if(p4(f+20|0,r),t[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function BV(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0;if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}i:{if((r|0)>=0&&(s=i[e>>2],e=i[s+128>>2],(i[s+132>>2]-e|0)/52>>>0>r>>>0))break i;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27877;return}e=e+g(r,52)|0,f&&(i[f>>2]=i[e+4>>2]-i[e>>2]>>2),k&&(i[k>>2]=u[e+12|0]),n&&(i[n>>2]=i[e+20>>2]-i[e+16>>2]>>2),o&&(i[o>>2]=i[e+32>>2]-i[e+28>>2]>>2),l&&(i[l>>2]=i[e+44>>2]-i[e+40>>2]>>3),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function vV(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0;for(r=v-128|0,v=r,i[r+12>>2]=r+116,f=r+16|0,Uu(A+8|0,f,r+12|0,k,n,o),o=v-16|0,v=o,A=v-32|0,v=A,Ts(A+24|0,f,i[r+12>>2]),l=i[A+28>>2],n=v-16|0,v=n,k=i[A+24>>2],i[n+8>>2]=k,i[n+12>>2]=e;;){if((k|0)!=(l|0)){lh(n+12|0,t[k|0]),k=k+1|0,i[n+8>>2]=k;continue}break}return i[A+16>>2]=i[n+8>>2],i[A+20>>2]=i[n+12>>2],v=n+16|0,i[A+12>>2]=(i[A+16>>2]-f|0)+f,i[A+8>>2]=i[A+20>>2],i[o+8>>2]=i[A+12>>2],i[o+12>>2]=i[A+8>>2],v=A+32|0,v=o+16|0,v=r+128|0,i[o+12>>2]}function mV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0;n=v-32|0,v=n,i[n+28>>2]=e;i:{if(!(i[r+4>>2]&1)){r=W[i[i[A>>2]+24>>2]](A,e,r,f,k)|0;break i}e=n+16|0,A=i[r+28>>2],i[e>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),A=$0(e,137064),i2(e);e:{if(k){W[i[i[A>>2]+24>>2]](e,A);break e}W[i[i[A>>2]+28>>2]](n+16|0,A)}for(o=n,l=e8(n+16|0),i[o+12>>2]=l;;){if(A=n+16|0,o=n,l=E6(A),i[o+8>>2]=l,i[n+12>>2]==i[n+8>>2])r=i[n+28>>2],_2(A);else{lh(n+28|0,t[i[n+12>>2]]),i[n+12>>2]=i[n+12>>2]+1;continue}break}}return v=n+32|0,r|0}function Po(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;if(f=i[A+8>>2],r=i[A+4>>2],(f-r|0)/6>>>0>=e>>>0){e&&(e=g(e,6)-6|0,e=(e-((e>>>0)%6|0)|0)+6|0,e&&l0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(n=r,r=i[A>>2],o=n-r|0,k=((o|0)/6|0)+e|0,k>>>0<715827883){if(f=(f-r|0)/6|0,n=f<<1,k=f>>>0>=357913941?715827882:k>>>0<n>>>0?n:k,k){if(k>>>0>=715827883)break i;l=C(g(k,6))}f=o+l|0,e=g(e,6)-6|0,e=(e-((e>>>0)%6|0)|0)+6|0,e&&l0(f,0,e),n=f+g((o|0)/-6|0,6)|0,o&&z(n,r,o),i[A+8>>2]=g(k,6)+l,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}s0(),M()}x0(),M()}function Lo(A){var e=0;return i[A+8>>2]=0,i[A+12>>2]=0,i[A+56>>2]=-1,i[A+60>>2]=-1,i[A+72>>2]=0,i[A+76>>2]=0,t[A+144|0]=0,t[A+140|0]=0,t[A+136|0]=0,t[A+132|0]=0,t[A+128|0]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,e=A- -64|0,i[e>>2]=-1,i[e+4>>2]=-1,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,t[A+96|0]=0,i[A>>2]=92732,t[A+124|0]=0,i[A+116>>2]=0,i[A+120>>2]=0,i[A+108>>2]=0,i[A+112>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,t[A+97|0]=0,i[A+16>>2]=1667460214,A}function $4(A,e,r,f){var k=0,n=0,o=0;if(k=i[A+8>>2],n=i[A>>2],k-n>>>0>=f>>>0){if(o=f,k=i[A+4>>2],f=k-n|0,o>>>0>f>>>0){(k|0)!=(n|0)&&(f&&z(n,e,f),k=i[A+4>>2]),f=e+f|0,e=r-f|0,!e|(r|0)==(f|0)||z(k,f,e),i[A+4>>2]=e+k;return}f=r-e|0,!f|(e|0)==(r|0)||z(n,e,f),i[A+4>>2]=f+n;return}if(n&&(i[A+4>>2]=n,Z(n),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0),(f|0)>=0){n=k<<1,k=k>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,f=C(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,k=r-e|0,!k|(e|0)==(r|0)||z(f,e,k),i[A+4>>2]=f+k;return}s0(),M()}function ZV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(k=v-32|0,v=k,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+104>>2]),u[e+112|0]==1&&p0(r,i[e+108>>2]),p0(r,i[e+120>>2]-i[e+116>>2]>>3),f=i[e+116>>2],n=i[e+120>>2],(f|0)!=(n|0))for(;p0(r,i[f>>2]),p0(r,i[f+4>>2]),f=f+8|0,(n|0)!=(f|0););n1(k+12|0,e,r,o),t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function gV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0;i:{e:{if(!(o0[e+100>>2]>65535|o0[e+104>>2]>65535)){if(k=o0[e+108>>2]>65535,h2(r,k),k)break e;u2(r,p[e+100>>1]),u2(r,p[e+104>>1]),u2(r,p[e+108>>1]);break i}h2(r,1)}p0(r,i[e+100>>2]),p0(r,i[e+104>>2]),p0(r,i[e+108>>2])}n1(f+12|0,e,r,n),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function GV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;o=v-16|0,v=o,i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0;i:{if(n){if((n|0)<0)break i;n=n<<2,l=C(n),i[o+4>>2]=l,s=n+l|0,i[o+12>>2]=s,n&&z(l,k,n),i[o+8>>2]=s}e=i[e>>2],k=i[e+48>>2],e=i[e+52>>2];e:{if(!e){o8(k,f,r,o+4|0);break e}if(i[e+4>>2]=i[e+4>>2]+1,o8(k,f,r,o+4|0),r=i[e+4>>2],i[e+4>>2]=r-1,r)break e;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],A=i[o+4>>2],A&&(i[o+8>>2]=A,Z(A)),v=o+16|0;return}s0(),M()}function WV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,M4(r,e+104|0,1),k=i[e+116>>2],o=i[e+120>>2],(k|0)!=(o|0))for(;h2(r,u[k|0]),k=k+1|0,(o|0)!=(k|0););i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function XV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0;e=v-16|0,v=e,f=i[r+16>>2],f&&(k=i[r+8>>2],k&&(l4(k,f),f=i[r+16>>2]),k=i[r>>2],o=W[i[i[k>>2]+8>>2]](k)|0,n=h0,l=f,f=f+o|0,n=l>>>0>f>>>0?n+1|0:n,W[i[i[k>>2]+20>>2]](k,f,n)|0,i[r+16>>2]=0);i:{if(u[r+20|0]==1){if(t[e+4|0]=0,t[e+15|0]=0,a(A,2,100,e+4|0),t[e+15|0]>=0)break i;Z(i[e+4>>2]);break i}if(r=i[28729],i[A>>2]=i[28728],i[A+4>>2]=r,A=A+8|0,t[114931]>=0){r=i[28731],i[A>>2]=i[28730],i[A+4>>2]=r,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=e+16|0}function qo(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=113712,e=i[A+308>>2],f=A+312|0,(e|0)!=(f|0))for(;;){a2(i[e+40>>2]),i[e+40>>2]=0,r=i[e+4>>2];i:{if(r){for(;;)if(e=r,r=i[e>>2],!r)break i}for(;r=e,e=i[e+8>>2],(r|0)!=i[e>>2];);}if((e|0)==(f|0))break}e=i[A+336>>2],i[A+336>>2]=0,e&&(r=i[e+4>>2],r&&(W[i[i[e>>2]+40>>2]](r),i[e+4>>2]=0),Z(e)),r=A+308|0,e=i[A+328>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return t7(r,i[A+312>>2]),Ve(A)|0}function IV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,17490);break i}if(k=e,n=w2(r),X[k+104>>1]=n,k=e,n=w2(r),X[k+106>>1]=n,k=e,n=w2(r),X[k+108>>1]=n,k=e,n=w2(r),X[k+110>>1]=n,u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function QV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;if(!f){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}if(n=i[e>>2],k=i[n+172>>2],n=i[n+176>>2],(k|0)!=(n|0))for(;;){if(o=i[k>>2],i[o>>2]==(r|0)){k=i[k+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),r=C(16),n=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=k,i[r+8>>2]=o,i[r+4>>2]=e,i[r>>2]=n,i[f>>2]=r,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e;return}if(k=k+8|0,(n|0)==(k|0))break}i[A>>2]=5,i[A+4>>2]=2e3,i[A+8>>2]=3730}function VV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;if(!f){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}if(n=i[e>>2],k=i[n+184>>2],n=i[n+188>>2],(k|0)!=(n|0))for(;;){if(o=i[k>>2],i[o>>2]==(r|0)){k=i[k+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),r=C(16),n=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=k,i[r+8>>2]=o,i[r+4>>2]=e,i[r>>2]=n,i[f>>2]=r,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e;return}if(k=k+8|0,(n|0)==(k|0))break}i[A>>2]=5,i[A+4>>2]=2e3,i[A+8>>2]=3705}function ao(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;if(r=i[A+4>>2],f=i[A+8>>2],r>>>0<f>>>0){i[r>>2]=i[e>>2],i[r+4>>2]=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,i[A+4>>2]=r+8;return}i:{if(n=i[A>>2],o=r-n|0,l=o>>3,r=l+1|0,r>>>0<536870912){if(f=f-n|0,k=f>>2,f=f>>>0>=2147483640?536870911:r>>>0<k>>>0?k:r,f){if(f>>>0>=536870912)break i;r=C(f<<3)}else r=0;k=r+o|0,i[k>>2]=i[e>>2],i[k+4>>2]=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,e=k-(l<<3)|0,o&&z(e,n,o),i[A+8>>2]=r+(f<<3),r=k+8|0,i[A+4>>2]=r,i[A>>2]=e,n&&Z(n),i[A+4>>2]=r;return}s0(),M()}x0(),M()}function pV(A){return A=A|0,u[137108]?i[34276]:(u[138176]||(t[138176]=1),K2(137888,90192),K2(137900,90224),K2(137912,90260),K2(137924,90284),K2(137936,90308),K2(137948,90324),K2(137960,90344),K2(137972,90364),K2(137984,90392),K2(137996,90432),K2(138008,90464),K2(138020,90500),K2(138032,90536),K2(138044,90552),K2(138056,90568),K2(138068,90584),K2(138080,90308),K2(138092,90600),K2(138104,90616),K2(138116,90632),K2(138128,90648),K2(138140,90664),K2(138152,90680),K2(138164,90696),t[137108]=1,i[34276]=137888,137888)}function FV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;i:{if(o=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,e=i[o>>2],!e)break i;for(;;){if(v4(i[e+4>>2],r)){if(e=i[o+4>>2],o=o+4|0,e)continue;break i}break}if(i[e+8>>2]!=1){e=i[25827],i[A>>2]=i[25826],i[A+4>>2]=e,i[A+8>>2]=i[25828];return}e:{if(!u[e+16|0]||(k&&(i[k>>2]=i[e+20>>2]),!n))break e;i[n>>2]=i[e+24>>2]}f&&(i[f>>2]=u[e+16|0]),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680];return}e=i[25827],i[A>>2]=i[25826],i[A+4>>2]=e,i[A+8>>2]=i[25828]}function CV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;for(k=v-16|0,v=k;;){i:{if((r|0)<=(o|0))break i;f=i[A+12>>2],l=i[A+16>>2];e:{if(f>>>0<l>>>0){i[k+12>>2]=2147483647,i[k+8>>2]=l-f,i[k+4>>2]=r-o,f=v-16|0,v=f,v=f+16|0,f=v-16|0,v=f,v=f+16|0,l=i[A+12>>2],f=k+4|0,n=k+8|0,f=i[f>>2]<i[n>>2]?f:n,n=k+12|0,f=i[(i[f>>2]<i[n>>2]?f:n)>>2],n=!f,n|n||z(e,l,f),i[A+12>>2]=i[A+12>>2]+f;break e}if(f=W[i[i[A>>2]+40>>2]](A)|0,(f|0)==-1)break i;t[e|0]=f<<24>>24,f=1}e=e+f|0,o=f+o|0;continue}break}return v=k+16|0,o|0}function YV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;if(!(k&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}i:{if((r|0)>=0&&(n=i[e>>2],e=i[n+116>>2],(i[n+120>>2]-e|0)/28>>>0>r>>>0))break i;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27919;return}e=e+g(r,28)|0;i:{if(!f||(r=i[e>>2],n=i[e+4>>2],(r|0)==(n|0))||(n=n-r|0,!n))break i;z(f,r,n)}r=g(p[e+14>>1],p[e+12>>1]);i:{if(!r||(r=r<<2,!r))break i;z(k,i[e+16>>2],r)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function yV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;if(f=v-48|0,v=f,l=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+108>>2]-i[e+104>>2]>>3),k=i[e+104>>2],n=i[e+108>>2],(k|0)!=(n|0))for(;o=i[k>>2],W[i[i[o>>2]+20>>2]](f+28|0,o,r),t[f+47|0]<0&&Z(i[f+36>>2]),k=k+8|0,(n|0)!=(k|0););n1(f+8|0,e,r,l),t[f+27|0]<0&&Z(i[f+16>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+48|0}function EV(A,e,r,f,k,n,o,l,s,h){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0,h=h|0;var w=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0))for(o=14-h|0,_=k&2147483644,w=k&3,s=0,B=k>>>0<4;;){if(k=(g(f,s)<<1)+r|0,h=(g(e,s)<<1)+A|0,l=0,!B)for(;X[h>>1]=p[k>>1]<<o,X[h+2>>1]=p[k+2>>1]<<o,X[h+4>>1]=p[k+4>>1]<<o,X[h+6>>1]=p[k+6>>1]<<o,k=k+8|0,h=h+8|0,l=l+4|0,(_|0)!=(l|0););if(l=0,w)for(;X[h>>1]=p[k>>1]<<o,k=k+2|0,h=h+2|0,l=l+1|0,(w|0)!=(l|0););if(s=s+1|0,(s|0)==(n|0))break}}function U2(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;r=i[A+24>>2];i:{if((r|0)>0){f=i[A+16>>2],k=i[A+20>>2];break i}for(n=64-r|0,f=i[A+16>>2],k=i[A+20>>2],e=i[A+4>>2],r=i[A+12>>2];;){e:{if(s=n,!r){o=n;break e}if(h=e+1|0,i[A+4>>2]=h,e=u[e|0],r=r-1|0,i[A+12>>2]=r,o=s-8|0,l=o&31,(o&63)>>>0>=32?(w=e<<l,e=0):(w=(1<<l)-1&e>>>32-l,e=e<<l),f=e|f,i[A+16>>2]=f,k=k|w,i[A+20>>2]=k,e=n,n=e-8|0,_=_-(e>>>0<8)|0,e=h,(s|0)>15)continue}break}r=64-o|0}return i[A+24>>2]=r-1,i[A+16>>2]=f<<1,i[A+20>>2]=k<<1|f>>>31,k>>>31|0}function t5(A,e,r){var f=0,k=0,n=0;f=v-48|0,v=f,S6(f+8|0,e,r);i:{e:{r:{f:{A:{k:switch(r=u[f+28|0],r|0){case 0:break f;case 1:break A;default:break k}e2(),M()}if(e=i[f+12>>2],i[A>>2]=i[f+8>>2],i[A+4>>2]=e,e=A+8|0,t[f+27|0]>=0){k=f+16|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break r}if(T(e,i[f+16>>2],i[f+20>>2]),r=u[f+28|0],t[A+20|0]=1,(r|0)!=255)break e;break i}i[A>>2]=i[i[f+8>>2]+104>>2]}t[A+20|0]=r}A=i[25325],i[f+40>>2]=i[25324],i[f+44>>2]=A,W[i[(f+40|0)+(r<<2)>>2]](f+39|0,f+8|0)}v=f+48|0}function Ko(A,e,r){var f=0,k=0,n=0,o=0,l=0;n=v-16|0,v=n,f=v-32|0,v=f,Zs(f+24|0,A,e),l=i[f+24>>2],e=v-16|0,v=e,k=i[f+28>>2],i[e+12>>2]=k,k=k-l|0,o=k>>2;i:{if(!o||(o=o<<2,!o))break i;z(r,l,o)}return i[e+8>>2]=r+k,i[f+16>>2]=i[e+12>>2],i[f+20>>2]=i[e+8>>2],v=e+16|0,l=i[f+16>>2],e=v-16|0,v=e,i[e+12>>2]=A,A=v-16|0,v=A,k=e+12|0,i[A+12>>2]=i[k>>2],v=A+16|0,A=e7(k,l-i[A+12>>2]>>2),v=e+16|0,i[f+12>>2]=A,i[f+8>>2]=(i[f+20>>2]-r|0)+r,i[n+8>>2]=i[f+12>>2],i[n+12>>2]=i[f+8>>2],v=f+32|0,v=n+16|0,i[n+12>>2]}function V3(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,n=i[e>>2],i[k+8>>2]=i[A>>2],f=i[A+4>>2],i[k+12>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),P0(n+36|0,k+8|0),f=i[k+12>>2];i:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break i;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[e>>2],i[k+8>>2]=i[A+8>>2],e=i[A+12>>2],i[k+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),P0(f+36|0,k+8|0),e=i[k+12>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}i[A+16>>2]!=i[A+20>>2]&&(e=sr(i[r>>2],A+16|0),o5(i[A+8>>2],e)),v=k+16|0}function F4(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;i:{r=i[A+4>>2],o=i[A>>2],l=r-o|0,f=i[A+12>>2]+(i[e+4>>2]-i[e>>2]|0)|0;e:{if(l>>>0>=f>>>0)break e;if(k=f-l|0,n=i[A+8>>2],k>>>0<=n-r>>>0){k&&l0(r,0,k),i[A+4>>2]=r+k;break e}if((f|0)<0)break i;if(r=n-o|0,n=r<<1,n=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r=C(n),k&&l0(r+l|0,0,k),l&&z(r,o,l),i[A+8>>2]=r+n,i[A+4>>2]=r+f,i[A>>2]=r,!o)break e;Z(o)}f=i[e>>2],k=i[e+4>>2]-f|0,k&&z(i[A>>2]+i[A+12>>2]|0,f,k),i[A+12>>2]=i[A+12>>2]+(i[e+4>>2]-i[e>>2]|0);return}s0(),M()}function RV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);i:{e:{r:{if(!k||(k=Z0(k,113600,113736),!k))break r;if(e&&(i[e+4>>2]=i[e+4>>2]+1),r&&(X[r>>1]=p[k+292>>1]),f&&(X[f>>1]=p[k+294>>1]),r=i[25787],i[A>>2]=i[25786],i[A+4>>2]=r,i[A+8>>2]=i[25788],!e)break i;if(A=i[e+4>>2],i[e+4>>2]=A-1,A)break e;W[i[i[e>>2]+8>>2]](e),y(e);break e}if(i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27187,!e)break i}if(A=i[e+4>>2],i[e+4>>2]=A-1,A)break i;W[i[i[e>>2]+8>>2]](e),y(e)}}function p3(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!e)break i;e:{r:{f:{A:{k:{n:{t:{o:switch(r=u[e|0],f=u[A|0],(r>>>0<f>>>0?r:f)-1|0){case 0:break e;case 1:break r;case 2:break f;case 3:break A;case 4:break k;case 5:break n;case 6:break t;case 7:break o;default:break i}i[A+36>>2]=i[e+36>>2]}t[A+32|0]=u[e+32|0]}r=i[e+20>>2],i[A+16>>2]=i[e+16>>2],i[A+20>>2]=r,r=i[e+28>>2],i[A+24>>2]=i[e+24>>2],i[A+28>>2]=r}i[A+12>>2]=i[e+12>>2]}i[A+4>>2]=i[e+4>>2],t[A+8|0]=u[e+8|0]}t[A+3|0]=u[e+3|0]}t[A+2|0]=u[e+2|0]}t[A+1|0]=u[e+1|0]}}function F3(A,e){var r=0,f=0,k=0,n=0;if(f=v-16|0,v=f,i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,r=i[A+28>>2],k=i[A+32>>2],(r|0)!=(k|0)){for(;i[r>>2]!=i[e>>2]&&P0(f+4|0,r),r=r+8|0,(k|0)!=(r|0););r=i[A+28>>2]}if(r){if(k=r,e=i[A+32>>2],(r|0)!=(e|0)){for(;;){n=i[e-4>>2];i:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break i;W[i[i[n>>2]+8>>2]](n),y(n)}if(e=e-8|0,(r|0)==(e|0))break}k=i[A+28>>2]}i[A+32>>2]=r,Z(k)}i[A+28>>2]=i[f+4>>2],i[A+32>>2]=i[f+8>>2],i[A+36>>2]=i[f+12>>2],v=f+16|0}function JV(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,e6(e+12|0,i[A+180>>2],i[A+196>>2]),r=-1;i:{e:{r:{f:switch(f=u[e+32|0],f|0){case 0:break r;case 1:break e;default:break f}e2(),M()}$1(e+40|0,i[A+180>>2],i[e+12>>2],1),A=i[e+44>>2],r=i[e+40>>2],r?r=W[i[i[r>>2]+104>>2]](r)|0:r=-1;r:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(f=u[e+32|0],(f|0)==255)break i}A=i[27179],i[e+40>>2]=i[27178],i[e+44>>2]=A,W[i[(e+40|0)+(f<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,r|0}function NV(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,e6(e+12|0,i[A+180>>2],i[A+196>>2]),r=-1;i:{e:{r:{f:switch(f=u[e+32|0],f|0){case 0:break r;case 1:break e;default:break f}e2(),M()}$1(e+40|0,i[A+180>>2],i[e+12>>2],1),A=i[e+44>>2],r=i[e+40>>2],r?r=W[i[i[r>>2]+108>>2]](r)|0:r=-1;r:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(f=u[e+32|0],(f|0)==255)break i}A=i[27179],i[e+40>>2]=i[27178],i[e+44>>2]=A,W[i[(e+40|0)+(f<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,r|0}function DV(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,e6(e+12|0,i[A+180>>2],i[A+196>>2]),r=-1;i:{e:{r:{f:switch(f=u[e+32|0],f|0){case 0:break r;case 1:break e;default:break f}e2(),M()}$1(e+40|0,i[A+180>>2],i[e+12>>2],1),A=i[e+44>>2],r=i[e+40>>2],r?r=W[i[i[r>>2]+104>>2]](r)|0:r=-1;r:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(f=u[e+32|0],(f|0)==255)break i}A=i[27063],i[e+40>>2]=i[27062],i[e+44>>2]=A,W[i[(e+40|0)+(f<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,r|0}function $o(A,e,r,f){var k=0,n=0,o=0,l=0,s=0;if(k=i[A+24>>2],n=i[A+28>>2],k>>>0<n>>>0){i[k+8>>2]=f,i[k+4>>2]=r,i[k>>2]=e,i[A+24>>2]=k+12;return}i:{if(s=i[A+20>>2],k=k-s|0,o=((k|0)/12|0)+1|0,o>>>0<357913942){if(n=(n-s|0)/12|0,l=n<<1,l=n>>>0>=178956970?357913941:l>>>0>o>>>0?l:o,l){if(l>>>0>=357913942)break i;o=C(g(l,12))}else o=0;n=o+k|0,i[n+8>>2]=f,i[n+4>>2]=r,i[n>>2]=e,e=n+g((k|0)/-12|0,12)|0,k&&z(e,s,k),i[A+28>>2]=o+g(l,12),r=n+12|0,i[A+24>>2]=r,i[A+20>>2]=e,s&&Z(s),i[A+24>>2]=r;return}s0(),M()}x0(),M()}function UV(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0,m=0,G=0,I=0;if(!(n&1)){if(!((o|0)<=0|(n|0)<=0))for(G=15-l|0,I=1<<14-l,w=-1<<l^-1;;){for(l=(g(e,_)<<1)+A|0,s=g(k,_)<<1,B=s+f|0,s=r+s|0,m=0;h=X[B>>1]+(X[s>>1]+I|0)>>G,X[l>>1]=(h|0)>=0?(h|0)<(w|0)?h:w:0,h=X[B+2>>1]+(X[s+2>>1]+I|0)>>G,X[l+2>>1]=(h|0)>=0?(h|0)<(w|0)?h:w:0,B=B+4|0,s=s+4|0,l=l+4|0,m=m+2|0,(m|0)<(n|0););if(_=_+1|0,(_|0)==(o|0))break}return}U0(23827,19896,238,11219),M()}function MV(A){A=A|0;var e=0,r=0,f=0;if(e=v-128|0,v=e,f=e+104|0,r3(f,A,1),A=-1,r=u[e+124|0],!r){X[e+24>>1]=0,l0(e+28|0,0,72),Y9(e+4|0,e+24|0,f),A=-1;i:{if(i[e+4>>2]||(r=i[e+60>>2],A=-1,i[e+64>>2]-r>>>0<5))break i;A=u[r+6|0]}t[e+23|0]<0&&Z(i[e+12>>2]),r=i[e+84>>2],r&&(i[e+88>>2]=r,Z(r)),r=i[e+72>>2],r&&(i[e+76>>2]=r,Z(r)),r=i[e+60>>2],r&&(i[e+64>>2]=r,Z(r)),r=u[e+124|0]}return(r|0)!=255&&(f=i[26421],i[e+24>>2]=i[26420],i[e+28>>2]=f,W[i[(e+24|0)+(r<<2)>>2]](e+4|0,e+104|0)),v=e+128|0,A|0}function HV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0,G=0;if((e|0)>=2)for(w=(e|0)/2|0,_=e&2147483646,B=e&1;;){for(n=(g(e,l)<<1)+A|0,m=n+2|0,s=(g(e-l|0,e)<<1)+A|0,r=0,o=0;f=r<<1,k=f+n|0,G=p[k>>1],h=k,k=((r^-1)<<1)+s|0,X[h>>1]=p[k>>1],X[k>>1]=G,f=f+m|0,k=p[f>>1],h=f,f=((r^2147483646)<<1)+s|0,X[h>>1]=p[f>>1],X[f>>1]=k,r=r+2|0,o=o+2|0,(_|0)!=(o|0););if(B&&(n=n+(r<<1)|0,o=p[n>>1],r=((r^-1)<<1)+s|0,X[n>>1]=p[r>>1],X[r>>1]=o),l=l+1|0,(w|0)==(l|0))break}}function zV(A,e){A=A|0,e=e|0;var r=0,f=0;r=i[A>>2],A=i[r+184>>2],r=i[r+188>>2];i:{if((A|0)!=(r|0))for(;;){e:{if(f=i[A>>2],!f||(f=Z0(f,92792,95316),!f))break e;if(r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),e&&(A=i[f+104>>2],i[e>>2]=i[f+100>>2],i[e+4>>2]=A,A=i[f+120>>2],i[e+16>>2]=i[f+116>>2],i[e+20>>2]=A,A=i[f+112>>2],i[e+8>>2]=i[f+108>>2],i[e+12>>2]=A),A=1,!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;return W[i[i[r>>2]+8>>2]](r),y(r),1}if(A=A+8|0,(r|0)==(A|0))break}A=0}return A|0}function xV(A){A=A|0;var e=0,r=0,f=0;if(e=v-128|0,v=e,f=e+104|0,r3(f,A,1),A=-1,r=u[e+124|0],!r){X[e+24>>1]=0,l0(e+28|0,0,72),Y9(e+4|0,e+24|0,f),A=-1;i:{if(i[e+4>>2]||(r=i[e+60>>2],A=-1,(r|0)==i[e+64>>2]))break i;A=u[r+2|0]}t[e+23|0]<0&&Z(i[e+12>>2]),r=i[e+84>>2],r&&(i[e+88>>2]=r,Z(r)),r=i[e+72>>2],r&&(i[e+76>>2]=r,Z(r)),r=i[e+60>>2],r&&(i[e+64>>2]=r,Z(r)),r=u[e+124|0]}return(r|0)!=255&&(f=i[26421],i[e+24>>2]=i[26420],i[e+28>>2]=f,W[i[(e+24|0)+(r<<2)>>2]](e+4|0,e+104|0)),v=e+128|0,A|0}function TV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;if((f|0)>0)for(B=f&2147483646,m=f&1,o=-1<<k^-1;;){if(l=g(e,h)+A|0,w=(g(f,h)<<2)+r|0,k=0,_=0,(f|0)!=1)for(;s=k+l|0,n=i[(k<<2)+w>>2]+u[s|0]|0,t[s|0]=(n|0)>=0?(n|0)<(o|0)?n:o:0,n=k|1,s=n+l|0,n=i[(n<<2)+w>>2]+u[s|0]|0,t[s|0]=(n|0)>=0?(n|0)<(o|0)?n:o:0,k=k+2|0,_=_+2|0,(B|0)!=(_|0););if(m&&(l=k+l|0,k=i[(k<<2)+w>>2]+u[l|0]|0,t[l|0]=(k|0)>=0?(k|0)<(o|0)?k:o:0),h=h+1|0,(h|0)==(f|0))break}}function jV(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0;var s=0,h=0,w=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0))for(o=14-l|0,_=k&2147483644,w=k&3,B=k>>>0<4;;){if(k=(g(e,h)<<1)+A|0,l=(g(f,h)<<1)+r|0,s=0,!B)for(;X[k>>1]=p[l>>1]<<o,X[k+2>>1]=p[l+2>>1]<<o,X[k+4>>1]=p[l+4>>1]<<o,X[k+6>>1]=p[l+6>>1]<<o,k=k+8|0,l=l+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,w)for(;X[k>>1]=p[l>>1]<<o,k=k+2|0,l=l+2|0,s=s+1|0,(w|0)!=(s|0););if(h=h+1|0,(h|0)==(n|0))break}}function SV(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,W[i[i[A>>2]+156>>2]](e+12|0,A);i:{e:{r:switch(u[e+32|0]){default:e2(),M();case 1:r=i[e+12>>2]!=0,A=1;break e;case 0:break r}r=i[e+12>>2],A=i[e+16>>2];r:{if(!A){r=W[i[i[r>>2]+12>>2]](r)|0;break r}if(i[A+4>>2]=i[A+4>>2]+1,r=W[i[i[r>>2]+12>>2]](r)|0,f=i[A+4>>2],i[A+4>>2]=f-1,f)break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=u[e+32|0],(A|0)==255)break i}f=i[26905],i[e+40>>2]=i[26904],i[e+44>>2]=f,W[i[(e+40|0)+(A<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,r|0}function OV(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,W[i[i[A>>2]+156>>2]](e+12|0,A);i:{e:{r:switch(u[e+32|0]){default:e2(),M();case 1:r=i[e+12>>2]!=0,A=1;break e;case 0:break r}r=i[e+12>>2],A=i[e+16>>2];r:{if(!A){r=W[i[i[r>>2]+16>>2]](r)|0;break r}if(i[A+4>>2]=i[A+4>>2]+1,r=W[i[i[r>>2]+16>>2]](r)|0,f=i[A+4>>2],i[A+4>>2]=f-1,f)break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=u[e+32|0],(A|0)==255)break i}f=i[26905],i[e+40>>2]=i[26904],i[e+44>>2]=f,W[i[(e+40|0)+(A<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,r|0}function PV(A){return A=A|0,u[137100]?i[34274]:(u[137872]||(t[137872]=1),H2(137584,1619),H2(137596,1610),H2(137608,11935),H2(137620,10695),H2(137632,1782),H2(137644,13990),H2(137656,1627),H2(137668,3626),H2(137680,8267),H2(137692,8160),H2(137704,8258),H2(137716,8277),H2(137728,10088),H2(137740,20041),H2(137752,8395),H2(137764,6866),H2(137776,1782),H2(137788,8726),H2(137800,10637),H2(137812,11996),H2(137824,8591),H2(137836,4629),H2(137848,3376),H2(137860,19831),t[137100]=1,i[34274]=137584,137584)}function LV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,h2(r,u[e+97|0]|128),h2(r,u[e+99|0]&31|u[e+98|0]<<5&224),h2(r,(u[e+106|0]&3|((u[e+101|0]?64:0)|(u[e+100|0]?-128:0)|(u[e+102|0]?32:0)|(u[e+103|0]?16:0)|(u[e+104|0]?8:0)|(u[e+105|0]?4:0)))&255),h2(r,0),n1(f+12|0,e,r,k),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function qV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;if((r|0)>0)for(w=r&2147483644,s=r&3,_=r>>>0<4;;){if(h=g(r,l),k=0,n=0,!_)for(;f=k+h|0,i[(f<<2)+A>>2]=X[(f<<1)+e>>1],o=f+1|0,i[(o<<2)+A>>2]=X[(o<<1)+e>>1],o=f+2|0,i[(o<<2)+A>>2]=X[(o<<1)+e>>1],f=f+3|0,i[(f<<2)+A>>2]=X[(f<<1)+e>>1],k=k+4|0,n=n+4|0,(w|0)!=(n|0););if(f=0,s)for(;n=k+h|0,i[(n<<2)+A>>2]=X[(n<<1)+e>>1],k=k+1|0,f=f+1|0,(s|0)!=(f|0););if(l=l+1|0,(l|0)==(r|0))break}}function aV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]),t[e+104|0]=1,n=e,o=S4(r),i[n+112>>2]=o,i[e+116>>2]=h0,k=Q2(r),t[e+120|0]=k>>>7,t[e+122|0]=k>>>5&1,t[e+121|0]=k>>>6&1;i:{if(u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function m8(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;e=i[A+24>>2];i:{if((e|0)>=32){k=i[A+16>>2],n=i[A+20>>2];break i}for(o=64-e|0,k=i[A+16>>2],n=i[A+20>>2],r=i[A+4>>2],e=i[A+12>>2];;){e:{if(h=o,!e){l=o;break e}if(w=r+1|0,i[A+4>>2]=w,f=u[r|0],e=e-1|0,i[A+12>>2]=e,l=h-8|0,s=l&31,(l&63)>>>0>=32?(r=f<<s,f=0):(r=(1<<s)-1&f>>>32-s,f=f<<s),k=f|k,i[A+16>>2]=k,n=r|n,i[A+20>>2]=n,r=o,o=r-8|0,_=_-(r>>>0<8)|0,r=w,(h|0)>15)continue}break}e=64-l|0}return i[A+24>>2]=e-32,i[A+16>>2]=0,i[A+20>>2]=k,n}function KV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0;i:{if(!A|!e||(r=i[A>>2],A=i[r+84>>2],r=i[r+80>>2],(A|0)==(r|0)))break i;if(k=(A-r|0)/44|0,n=k>>>0<=1?1:k,o=n&3,A=0,k>>>0>=4)for(n=n&-4,k=0;i[(A<<2)+e>>2]=i[g(A,44)+r>>2],f=A|1,i[(f<<2)+e>>2]=i[g(f,44)+r>>2],f=A|2,i[(f<<2)+e>>2]=i[g(f,44)+r>>2],f=A|3,i[(f<<2)+e>>2]=i[g(f,44)+r>>2],A=A+4|0,k=k+4|0,(n|0)!=(k|0););if(!o)break i;for(;i[(A<<2)+e>>2]=i[g(A,44)+r>>2],A=A+1|0,l=l+1|0,(l|0)!=(o|0););}}function $V(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;f=v-16|0,v=f;i:{if(Q2(r)&1){n=e,o=F0(r),i[n+100>>2]=o,n=e,o=F0(r),i[n+104>>2]=o,k=F0(r);break i}n=e,o=w2(r),i[n+100>>2]=o,n=e,o=w2(r),i[n+104>>2]=o,k=w2(r)}i[e+108>>2]=k;i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function dV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;k=i[A>>2],A=i[k+340>>2],l=i[k+344>>2];i:{if((A|0)==(l|0))break i;if(e)for(;;){k=i[A>>2],o=t[k+15|0],s=(o|0)<0,o=s?i[k+8>>2]:o;e:{if((o|0)!=(l2(e)|0)||N2(s?i[k+4>>2]:k+4|0,e,o))break e;if((f|0)<=(n|0))break i;i[(n<<2)+r>>2]=i[k>>2],n=n+1|0}if(A=A+8|0,(l|0)==(A|0))break i}for(e=(f|0)>0?f:0;;){if((e|0)==(n|0))return e|0;if(i[(n<<2)+r>>2]=i[i[A>>2]>>2],n=n+1|0,A=A+8|0,(l|0)==(A|0))break}}return n|0}function bV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]),k=e,n=S4(r),i[k+112>>2]=n,i[e+116>>2]=h0,k=e,n=F0(r),i[k+120>>2]=n,k=e,n=F0(r),i[k+124>>2]=n,k=e,n=Q2(r),t[k+128|0]=n;i:{if(u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Ui(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;n=v-16|0,v=n,f=oh(e),k=v-16|0,v=k;i:{if(f>>>0<=1073741815){e:{if(f>>>0<2){t[A+11|0]=u[A+11|0]&128|f&127,t[A+11|0]=u[A+11|0]&127,r=A;break e}l=k+8|0,f>>>0>=2?(o=f+2&-2,r=o-1|0,r=(r|0)==2?o:r):r=1,Ae(l,r+1|0),r=i[k+8>>2],i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=f}e:{if(!f||(A=f<<2,!A))break e;z(r,e,A)}i[k+4>>2]=0,i[(f<<2)+r>>2]=i[k+4>>2],v=k+16|0;break i}I4(),M()}v=n+16|0}function cV(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e;i:{e:{if(i[A+80>>2]!=i[A+84>>2])break e;if(e6(e+12|0,i[A+180>>2],i[A+196>>2]),r=1,f=u[e+32|0],(f|0)!=1){if(f)break i;$1(e+40|0,i[A+180>>2],i[e+12>>2],1),r=i[e+40>>2],r&&Fn(A,r,i[r+200>>2],i[r+204>>2]),A=i[e+44>>2];r:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=u[e+32|0],(r|0)==255)break e}A=i[27179],i[e+40>>2]=i[27178],i[e+44>>2]=A,W[i[(e+40|0)+(r<<2)>>2]](e+39|0,e+12|0)}v=e+48|0;return}e2(),M()}function ip(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+104>>2]),p0(r,i[e+108>>2]),p0(r,i[e+112>>2]),p0(r,i[e+116>>2]),p0(r,i[e+120>>2]),M4(r,e+124|0,1),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function ep(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,e6(e+12|0,i[A+180>>2],i[A+196>>2]),f=-1;i:{e:{r:{f:switch(r=u[e+32|0],r|0){case 0:break r;case 1:break e;default:break f}e2(),M()}$1(e+40|0,i[A+180>>2],i[e+12>>2],1),A=i[e+44>>2],f=i[e+40>>2],f=W[i[i[f>>2]+104>>2]](f)|0;r:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=u[e+32|0],(r|0)==255)break i}A=i[27129],i[e+40>>2]=i[27128],i[e+44>>2]=A,W[i[(e+40|0)+(r<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,f|0}function rp(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,e6(e+12|0,i[A+180>>2],i[A+196>>2]),f=-1;i:{e:{r:{f:switch(r=u[e+32|0],r|0){case 0:break r;case 1:break e;default:break f}e2(),M()}$1(e+40|0,i[A+180>>2],i[e+12>>2],1),A=i[e+44>>2],f=i[e+40>>2],f=W[i[i[f>>2]+108>>2]](f)|0;r:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=u[e+32|0],(r|0)==255)break i}A=i[27129],i[e+40>>2]=i[27128],i[e+44>>2]=A,W[i[(e+40|0)+(r<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,f|0}function x8(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0;o=v-16|0,v=o,j2(+e),r=o2(1)|0,k=o2(0)|0,h=r,n=r&1048575,f=k,r=r>>>20&2047,k=0;i:{if(r|k){if((r|0)!=2047|k){l=(n&15)<<28|f>>>4,s=n>>>4|0,r=r+15360|0,k=f<<28,f=0;break i}l=(n&15)<<28|f>>>4,s=n>>>4|0,r=32767,k=f<<28,f=0;break i}if(!(n|f)){r=0,f=0;break i}k=n,n=_1(n),r=(n|0)==32?_1(f)+32|0:n,g4(o,f,k,0,0,r+49|0),l=i[o+8>>2],s=i[o+12>>2]^65536,r=15372-r|0,k=i[o+4>>2],f=i[o>>2]}i[A>>2]=f,i[A+4>>2]=k,i[A+8>>2]=l,i[A+12>>2]=s|(h&-2147483648|r<<16),v=o+16|0}function fp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f;i:{if(!(r&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(k=i[e>>2],!u[k+368|0]){if(t[f|0]=0,t[f+11|0]=0,r=a(f+12|0,5,138,f),t[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],c0(k,r,A?A+164|0:0),t[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}u0[r>>3]=u0[k+376>>3],u0[r+8>>3]=u0[k+384>>3],u0[r+16>>3]=u0[k+392>>3],u0[r+24>>3]=u0[k+400>>3],u0[r+32>>3]=u0[k+408>>3],i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}v=f+32|0}function Ap(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,e6(e+12|0,i[A+180>>2],i[A+196>>2]),f=-1;i:{e:{r:{f:switch(r=u[e+32|0],r|0){case 0:break r;case 1:break e;default:break f}e2(),M()}$1(e+40|0,i[A+180>>2],i[e+12>>2],1),A=i[e+44>>2],f=i[e+40>>2],f=W[i[i[f>>2]+108>>2]](f)|0;r:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=u[e+32|0],(r|0)==255)break i}A=i[27063],i[e+40>>2]=i[27062],i[e+44>>2]=A,W[i[(e+40|0)+(r<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,f|0}function kp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(k=v-32|0,v=k,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,(i[e+104>>2]-i[e+100>>2]|0)/6&65535),f=i[e+100>>2],n=i[e+104>>2],(f|0)!=(n|0))for(;u2(r,p[f>>1]),u2(r,p[f+2>>1]),u2(r,p[f+4>>1]),f=f+6|0,(n|0)!=(f|0););n1(k+12|0,e,r,o),t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function np(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(k=v-32|0,v=k,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,(i[e+108>>2]-i[e+104>>2]|0)/6&65535),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;u2(r,p[f>>1]),h2(r,u[f+2|0]),u2(r,p[f+4>>1]),f=f+6|0,(n|0)!=(f|0););n1(k+12|0,e,r,o),t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function tp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;i:{if(u[e+76|0]==1){if(t[e+76|0]=0,t[A+44|0]=0,t[A|0]=0,u[e+72|0]!=1)break i;i[A>>2]=i[e+28>>2],i[A+4>>2]=i[e+32>>2],i[A+8>>2]=i[e+36>>2],i[e+36>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[A+12>>2]=i[e+40>>2],i[A+16>>2]=i[e+44>>2],i[A+20>>2]=i[e+48>>2],i[e+48>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,r=i[e+60>>2],f=i[e+64>>2],k=i[e+68>>2],n=i[e+52>>2],e=i[e+56>>2],t[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=r,i[A+36>>2]=f,i[A+24>>2]=n,i[A+28>>2]=e;return}t[A+44|0]=0,t[A|0]=0}}function op(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(k=v-32|0,v=k,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,(i[e+108>>2]-i[e+104>>2]|0)/12|0),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;p0(r,i[f>>2]),p0(r,i[f+4>>2]),p0(r,i[f+8>>2]),f=f+12|0,(n|0)!=(f|0););n1(k+12|0,e,r,o),t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function I6(A,e,r,f,k,n){var o=0,l=0,s=0,h=0;i:{if(n&64){r=n+-64|0,e=r&31,(r&63)>>>0>=32?(r=0,e=k>>>e|0):(r=k>>>e|0,e=((1<<e)-1&k)<<32-e|f>>>e),f=0,k=0;break i}if(!n)break i;s=f,l=64-n|0,o=l&31,(l&63)>>>0>=32?(l=f<<o,h=0):(l=(1<<o)-1&s>>>32-o|k<<o,h=s<<o),s=e,e=n&31,(n&63)>>>0>=32?(o=0,e=r>>>e|0):(o=r>>>e|0,e=((1<<e)-1&r)<<32-e|s>>>e),e=h|e,r=o|l,o=f,f=n&31,(n&63)>>>0>=32?(l=0,f=k>>>f|0):(l=k>>>f|0,f=((1<<f)-1&k)<<32-f|o>>>f),k=l}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=f,i[A+12>>2]=k}function lp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+104>>2]),p0(r,i[e+108>>2]);i:{if(i[e+104>>2]||(k=i[e+112>>2],n=i[e+116>>2],(k|0)==(n|0)))break i;for(;p0(r,i[k>>2]),k=k+4|0,(n|0)!=(k|0););}n1(f+12|0,e,r,o),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Te(A,e,r,f){var k=0,n=0,o=0,l=0;i:{e:{if(!f){k=i[A+12>>2],f=i[A+8>>2],A=k-f>>2;break e}if(f=i[A+8>>2],k=i[A+12>>2],(f|0)==(k|0)){A=0;break e}for(A=k-f>>2,l=A>>>0<=1?1:A;;){if(o=i[(n<<2)+f>>2],!(i[o+96>>2]!=(e|0)|i[o+108>>2]<=(r|0))&i[o+100>>2]==2)break i;if(n=n+1|0,(l|0)==(n|0))break}}if(n=-1,(f|0)==(k|0))break i;for(o=A>>>0<=1?1:A,A=0;;){if(k=i[(A<<2)+f>>2],!(i[k+96>>2]!=(e|0)|i[k+108>>2]<=(r|0)|!i[k+100>>2]))return A;if(A=A+1|0,(o|0)==(A|0))break}}return n}function up(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0,w=0,_=0;if(!((n|0)<=0|(k|0)<=0))for(w=k&2147483644,h=k&3,s=0,_=k>>>0<4;;){if(k=g(f,s)+r|0,o=(g(e,s)<<1)+A|0,l=0,!_)for(;X[o>>1]=u[k|0]<<6,X[o+2>>1]=u[k+1|0]<<6,X[o+4>>1]=u[k+2|0]<<6,X[o+6>>1]=u[k+3|0]<<6,k=k+4|0,o=o+8|0,l=l+4|0,(w|0)!=(l|0););if(l=0,h)for(;X[o>>1]=u[k|0]<<6,k=k+1|0,o=o+2|0,l=l+1|0,(h|0)!=(l|0););if(s=s+1|0,(s|0)==(n|0))break}}function sp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f;i:{if(!r){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!r8(i[e>>2])){if(t[f|0]=0,t[f+11|0]=0,r=a(f+12|0,10,0,f),t[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],c0(k,r,A?A+164|0:0),t[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}if(k=i[e>>2],n=p[k+10>>1]|p[k+12>>1]<<16,i[f>>2]=p[k+6>>1]|p[k+8>>1]<<16,i[f+4>>2]=n,k=f+12|0,Vt(k,f,r),r=A,A=i[e>>2],c0(r,k,A?A+164|0:0),t[f+31|0]>=0)break i;Z(i[f+20>>2])}v=f+32|0}function hp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f;i:{if(!r){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!r8(i[e>>2])){if(t[f|0]=0,t[f+11|0]=0,r=a(f+12|0,10,0,f),t[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],c0(k,r,A?A+172|0:0),t[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}if(k=i[e>>2],n=p[k+10>>1]|p[k+12>>1]<<16,i[f>>2]=p[k+6>>1]|p[k+8>>1]<<16,i[f+4>>2]=n,k=f+12|0,Vt(k,f,r),r=A,A=i[e>>2],c0(r,k,A?A+172|0:0),t[f+31|0]>=0)break i;Z(i[f+20>>2])}v=f+32|0}function C3(A,e,r,f){var k=0,n=0;k=v+-64|0,v=k,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+24>>2]=r,i[k+16>>2]=0,i[k+20>>2]=0,i[k+60>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+48>>2]=e,i[k+8>>2]=92500,e=k+52|0,(e|0)!=(f|0)&&(n=e,e=i[f>>2],r=i[f+4>>2],h1(n,e,r,r-e>>2)),e=i[A+108>>2];i:{if(e>>>0<o0[A+112>>2]){xe(e,k+8|0),e=e+56|0;break i}e=r5(A+104|0,k+8|0)}i[A+108>>2]=e,A=i[k+52>>2],A&&(i[k+56>>2]=A,Z(A)),i[k+8>>2]=92500,A=i[k+28>>2],A&&(i[k+32>>2]=A,Z(A)),v=k- -64|0}function bo(A){var e=0,r=0,f=0,k=0,n=0;return f=v-16|0,v=f,A=R0(A),i[A+40>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A>>2]=77264,l0(A+52|0,0,40),t[A+98|0]=0,X[A+96>>1]=0,i[A+92>>2]=32,r=f+12|0,e=i[A+4>>2],i[r>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=th(i[r>>2],W1(137016)),i2(r),e&&(r=f+8|0,e=i[A+4>>2],i[r>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),k=A,n=$0(r,137016),i[k+68>>2]=n,i2(r),e=i[A+68>>2],k=A,n=W[i[i[e>>2]+28>>2]](e)|0,t[k+98|0]=n),W[i[i[A>>2]+12>>2]](A,0,4096)|0,v=f+16|0,A}function co(A,e){var r=0,f=0,k=0;i:{e:{r:{if(f=e&255,f){if(A&3)for(;;){if(r=u[A|0],!r|(r|0)==(f|0))break i;if(A=A+1|0,!(A&3))break}if(r=i[A>>2],((r|16843008-r)&-2139062144)!=-2139062144)break r;for(k=g(f,16843009);;){if(f=r^k,((16843008-f|f)&-2139062144)!=-2139062144)break r;if(r=i[A+4>>2],f=A+4|0,A=f,((16843008-r|r)&-2139062144)!=-2139062144)break}break e}return l2(A)+A|0}f=A}for(;;){if(A=f,r=u[A|0],!r)break i;if(f=A+1|0,(r|0)==(e&255))break}}return A}function il(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0;f=v-16|0,v=f,X1(f+8|0,A);i:{if(!u[f+8|0]||(r=i[i[A>>2]-12>>2]+A|0,o=i[r+4>>2],n=f+4|0,r=i[r+28>>2],i[n>>2]=r,(r|0)!=136824&&(i[r+4>>2]=i[r+4>>2]+1),r=$0(n,136688),i2(n),i[f>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],k=i[i[A>>2]-12>>2]+A|0,l=V6(k),s=k,k=e&65535,h=e,e=o&74,w=f,_=W[i[i[r>>2]+16>>2]](r,i[f>>2],s,l,(e|0)==64||(e|0)==8?k:h)|0,i[w+4>>2]=_,i[n>>2]))break i;z4(i[i[A>>2]-12>>2]+A|0,5)}return v1(f+8|0),v=f+16|0,A}function u2(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;i:{r=i[A+4>>2],o=i[A>>2],l=r-o|0,f=i[A+12>>2]+2|0;e:{if(l>>>0>=f>>>0)break e;if(n=f-l|0,k=i[A+8>>2],n>>>0<=k-r>>>0){n&&l0(r,0,n),i[A+4>>2]=r+n;break e}if((f|0)<0)break i;if(r=k-o|0,k=r<<1,k=r>>>0>=1073741823?2147483647:f>>>0<k>>>0?k:f,r=C(k),n&&l0(r+l|0,0,n),l&&z(r,o,l),i[A+8>>2]=r+k,i[A+4>>2]=r+f,i[A>>2]=r,!o)break e;Z(o)}f=i[A+12>>2],i[A+12>>2]=f+1,t[f+i[A>>2]|0]=e>>>8,f=i[A+12>>2],i[A+12>>2]=f+1,t[f+i[A>>2]|0]=e;return}s0(),M()}function el(A,e,r){var f=0,k=0,n=0,o=0,l=0;return n=v-16|0,v=n,f=v-32|0,v=f,Zs(f+24|0,A,e),o=i[f+24>>2],e=v-16|0,v=e,k=i[f+28>>2],i[e+12>>2]=k,k=k-o|0,l=!k,l|l||z(r,o,k),i[e+8>>2]=r+k,i[f+16>>2]=i[e+12>>2],i[f+20>>2]=i[e+8>>2],v=e+16|0,o=i[f+16>>2],e=v-16|0,v=e,i[e+12>>2]=A,A=v-16|0,v=A,k=e+12|0,i[A+12>>2]=i[k>>2],v=A+16|0,A=A7(k,o-i[A+12>>2]|0),v=e+16|0,i[f+12>>2]=A,i[f+8>>2]=(i[f+20>>2]-r|0)+r,i[n+8>>2]=i[f+12>>2],i[n+12>>2]=i[f+8>>2],v=f+32|0,v=n+16|0,i[n+12>>2]}function wp(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,k=v-32|0,v=k,zo(k+8|0,e,r,f,0);i:{if(i[k+8>>2]){e=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+24>>2],e=i[k+20>>2],i[A+8>>2]=i[k+16>>2],i[A+12>>2]=e,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}if(p0(r,i[e+100>>2]|u[e+97|0]<<24),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}t[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function $1(A,e,r,f){var k=0,n=0,o=0,l=0;k=v-32|0,v=k;i:{e:{n=i[e+20>>2];r:{if(!n)break r;for(o=e+20|0,e=o;l=o0[n+16>>2]<r>>>0,e=l?e:n,n=i[(l?4:0)+n>>2],!!n;);if((e|0)==(o|0))break r;if(o0[e+16>>2]<=r>>>0)break e}i[A>>2]=0,i[A+4>>2]=0;break i}if(r=i[e+20>>2],W[i[i[r>>2]+88>>2]](k+12|0,r),r=!i[k+12>>2]|f,t[k+31|0]<0&&Z(i[k+20>>2]),!r){i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A>>2]=i[e+20>>2],r=A,A=i[e+24>>2],i[r+4>>2]=A,!A)break i;i[A+4>>2]=i[A+4>>2]+1}v=k+32|0}function _p(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=v-32|0,v=k,sn(k+8|0,e);i:{if(i[k+8>>2]){e=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+24>>2],e=i[k+20>>2],i[A+8>>2]=i[k+16>>2],i[A+12>>2]=e,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}if(e=i[e+84>>2],i[f>>2]=e,i[r>>2]=e?0:2,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}t[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function rl(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;k=v-16|0,v=k;i:{if(!e)break i;A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];e:{if(!A){Me(k+4|0,f);break e}if(i[A+4>>2]=i[A+4>>2]+1,Me(k+4|0,f),f=i[A+4>>2],i[A+4>>2]=f-1,f)break e;W[i[i[A>>2]+8>>2]](A),y(A)}e:{r:{if(n=i[k+4>>2],f=i[k+8>>2]-n>>2,(f|0)<=0)break r;for(A=0;;){if((A|0)==(r|0)){f=r;break r}if(o=A<<2,i[o+e>>2]=i[n+o>>2],A=A+1|0,(f|0)==(A|0))break}break e}if(!n)break i}i[k+8>>2]=n,Z(n)}return v=k+16|0,f|0}function Bp(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,3917);break i}if(k=F0(r),t[e+104|0]=k>>>31,t[e+106|0]=k>>>26&15,t[e+105|0]=k>>>30&1,u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function H4(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;i:{if(e){if(r=i[A+44>>2],k=i[A+40>>2],o=r-k|0,l=o>>2,l>>>0<=15){if(f=i[A+48>>2],f>>>0>r>>>0){i[r>>2]=e,i[A+44>>2]=r+4;return}if(r=f-k|0,f=r>>1,n=l+1|0,r=r>>>0>=2147483644?1073741823:f>>>0>n>>>0?f:n,r>>>0>=1073741824)break i;f=r<<2,n=C(f),r=n+o|0,i[r>>2]=e,e=r-(l<<2)|0,o&&z(e,k,o),i[A+48>>2]=f+n,r=r+4|0,i[A+44>>2]=r,i[A+40>>2]=e,k&&Z(k),i[A+44>>2]=r;return}Z(i[e+20>>2]),A=i[e+32>>2],A&&(i[e+36>>2]=A,Z(A)),Z(e)}return}x0(),M()}function Y3(A){var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0;if(e=co(A,61),(e|0)==(A|0))return 0;k=e-A|0;i:{if(u[k+A|0]||(f=i[33137],!f)||(r=i[f>>2],!r))break i;for(;;){e:{n=A,o=k,e=0;r:{if(!k)break r;if(e=u[A|0],e)f:{for(;;){if(l=u[r|0],(l|0)!=(e|0)|!l||(o=o-1|0,!o))break f;if(r=r+1|0,e=u[n+1|0],n=n+1|0,!e)break}e=0}else e=0;e=e-u[r|0]|0}if(!e&&(e=i[f>>2]+k|0,u[e|0]==61))break e;if(r=i[f+4>>2],f=f+4|0,r)continue;break i}break}s=e+1|0}return s}function g4(A,e,r,f,k,n){var o=0,l=0,s=0;i:{if(n&64){k=n+-64|0,n=e,f=k&31,(k&63)>>>0>=32?(k=n<<f,f=0):(k=(1<<f)-1&n>>>32-f|r<<f,f=n<<f),e=0,r=0;break i}if(!n)break i;l=f,o=n&31,(n&63)>>>0>=32?(s=f<<o,l=0):(s=(1<<o)-1&l>>>32-o|k<<o,l=l<<o),o=e,k=64-n|0,f=k&31,(k&63)>>>0>=32?(k=0,f=r>>>f|0):(k=r>>>f|0,f=((1<<f)-1&r)<<32-f|o>>>f),f=l|f,k=k|s,l=e,o=n&31,(n&63)>>>0>=32?(s=e<<o,e=0):(s=(1<<o)-1&l>>>32-o|r<<o,e=l<<o),r=s}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=f,i[A+12>>2]=k}function vp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(f=v-32|0,v=f,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+108>>2]-i[e+104>>2]>>2),i[e+124>>2]=i[r+12>>2],k=i[e+104>>2],n=i[e+108>>2],(k|0)!=(n|0))for(;p0(r,i[k>>2]),k=k+4|0,(n|0)!=(k|0););n1(f+12|0,e,r,o),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function fl(A){return t[A+316|0]=0,X[A+314>>1]=0,i[A+60>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,l0(A+116|0,0,164),i[A+108>>2]=0,i[A+112>>2]=0,i[A>>2]=-1,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+64>>2]=0,i[A+68>>2]=0,i[A+72>>2]=0,i[A+320>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+280>>2]=0,i[A+284>>2]=0,i[A+288>>2]=0,i[A+292>>2]=0,i[A+296>>2]=0,i[A+300>>2]=0,t[A+312|0]=2,t[A+104|0]=0,i[A+100>>2]=0,i[A+92>>2]=-1,i[A+96>>2]=-1,i[A+340>>2]=0,i[A+332>>2]=0,i[A+336>>2]=0,i[A+324>>2]=0,i[A+328>>2]=0,A}function mp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-16|0,v=r,G5(r+4|0,i[A>>2]),A=i[r+8>>2],k=i[r+4>>2];i:{e:{if((A|0)!=(k|0)){f=k;r:{f:{for(;;){if(i[i[f>>2]+196>>2]==(e|0))break f;if(f=f+8|0,(f|0)==(A|0))break}f=0;break r}f=1}if(!k)break i;for(;;){e=i[A-4>>2];r:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(k|0)==(A|0))break}A=i[r+4>>2];break e}if(A=k,!A)break i}i[r+8>>2]=k,Z(A)}return v=r+16|0,f|0}function Q6(A){var e=0,r=0,f=0;if(!A){if(A=i[28684],A&&(e=Q6(A)),A=i[28646],A&&(e=Q6(A)|e),A=i[33139],A)for(;i[A+20>>2]!=i[A+28>>2]&&(e=Q6(A)|e),A=i[A+56>>2],!!A;);return e}f=i[A+76>>2]<0;i:{e:{if(i[A+20>>2]==i[A+28>>2]||(W[i[A+36>>2]](A,0,0)|0,i[A+20>>2]))break e;e=-1;break i}if(e=i[A+8>>2],r=i[A+4>>2],(e|0)!=(r|0)&&(e=r-e|0,W[i[A+40>>2]](A,e,e>>31,1)|0),e=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,f)break i}return e}function Zp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,h4(r,i[e+112>>2],i[e+116>>2]),p0(r,i[e+120>>2]),p0(r,i[e+124>>2]),h2(r,u[e+128|0]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function gp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;k=v-32|0,v=k,i[k+16>>2]=e,f=i[A+48>>2],i[k+20>>2]=r-((f|0)!=0),o=i[A+44>>2],i[k+28>>2]=f,i[k+24>>2]=o;i:{e:{if(f=g9(i[A+60>>2],k+16|0,2,k+12|0)|0,f?(i[33136]=f,f=-1):f=0,f)e=32;else{if(f=i[k+12>>2],(f|0)>0)break e;e=f?32:16}i[A>>2]=e|i[A>>2];break i}if(n=f,o=i[k+20>>2],o>>>0>=f>>>0)break i;n=i[A+44>>2],i[A+4>>2]=n,i[A+8>>2]=n+(f-o|0),i[A+48>>2]&&(i[A+4>>2]=n+1,t[(e+r|0)-1|0]=u[n|0]),n=r}return v=k+32|0,n|0}function Gp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;i:{if(k=i[r+4>>2],t[f+8|0]&1|(!u[r+8|0]|k>>>0>3)||i[n+4>>2])break i;f=i[r+12>>2],n=i[r+16>>2],o=i[r+24>>2],l=i[r+20>>2],s=i[r>>2],e=C(32),t[e+8|0]=0,i[e+4>>2]=k,i[e>>2]=s,k=u[r+9|0]|u[r+10|0]<<8,t[e+9|0]=k,t[e+10|0]=k>>>8,t[e+11|0]=u[r+11|0],i[e+28>>2]=1,i[e+20>>2]=l,i[e+24>>2]=o,i[e+12>>2]=f,i[e+16>>2]=n,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function Wp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;k=v-32|0,v=k;i:{e:{if(f=i[A+564>>2],(f|0)!=i[A+568>>2]&&(f=i[f>>2],f))break e;i[r>>2]=0,i[e>>2]=0;break i}n=k+12|0,$1(n,i[A+180>>2],f,1),A=i[k+16>>2];e:{r:{if(f=i[k+12>>2],f&&(W[i[i[f>>2]+88>>2]](n,f),n=i[k+12>>2],t[k+31|0]<0&&Z(i[k+20>>2]),!n))break r;i[r>>2]=0,i[e>>2]=0;break e}i[e>>2]=i[f+200>>2],i[r>>2]=i[f+204>>2]}if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=k+32|0}function o5(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;if(r=i[A+132>>2],f=i[A+136>>2],r>>>0<f>>>0){i[r>>2]=e,i[r+4>>2]=0,i[A+132>>2]=r+8;return}i:{if(k=r,r=i[A+128>>2],o=k-r|0,l=o>>3,n=l+1|0,n>>>0<536870912){if(f=f-r|0,k=f>>2,n=f>>>0>=2147483640?536870911:n>>>0<k>>>0?k:n,n){if(n>>>0>=536870912)break i;k=C(n<<3)}else k=0;f=k+o|0,i[f>>2]=e,i[f+4>>2]=0,e=f-(l<<3)|0,o&&z(e,r,o),i[A+136>>2]=k+(n<<3),o=f+8|0,i[A+132>>2]=o,i[A+128>>2]=e,r&&Z(r),i[A+132>>2]=o;return}s0(),M()}x0(),M()}function Xp(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]),k=u[e+97|0];i:{if(k>>>0>=2){B1(A,e,10097);break i}e:{if(!k){k=w2(r);break e}k=F0(r)}if(i[e+104>>2]=k,u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function y3(A,e){var r=0,f=0,k=0;i:{r=u[A+16|0];e:{if((r|0)==u[e+16|0]){if(!r||(i[A>>2]=i[e>>2],(A|0)==(e|0)))break e;r=A+4|0,A=i[e+4>>2],e=i[e+8>>2],W3(r,A,e,e-A>>3);return}if(r){e=i[A+4>>2],e&&(i[A+8>>2]=e,Z(e)),t[A+16|0]=0;return}if(r=i[e>>2],i[A+12>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=r,f=i[e+4>>2],e=i[e+8>>2],(f|0)!=(e|0)){if(e=e-f|0,(e|0)<0)break i;r=C(e),i[A+8>>2]=r,i[A+4>>2]=r,k=e+r|0,i[A+12>>2]=k,e&&z(r,f,e),i[A+8>>2]=k}t[A+16|0]=1}return}s0(),M()}function Ip(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0;if(!(n&1)){if(!((o|0)<=0|(n|0)<=0))for(;;){for(w=g(e,h)+A|0,s=g(k,h)<<1,_=s+f|0,s=r+s|0,B=0;l=(X[s>>1]+X[_>>1]|0)- -64>>7,l=(l|0)>=255?255:l,t[w|0]=(l|0)>0?l:0,l=(X[s+2>>1]+X[_+2>>1]|0)- -64>>7,l=(l|0)>=255?255:l,t[w+1|0]=(l|0)>0?l:0,_=_+4|0,s=s+4|0,w=w+2|0,B=B+2|0,(B|0)<(n|0););if(h=h+1|0,(h|0)==(o|0))break}return}U0(23827,19896,105,11068),M()}function Qp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(k=v-32|0,v=k,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+108>>2]-i[e+104>>2]>>3),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;p0(r,i[f>>2]),p0(r,i[f+4>>2]),f=f+8|0,(n|0)!=(f|0););n1(k+12|0,e,r,o),t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function l5(A,e,r){var f=0,k=0;f=(r|0)!=0;i:{e:{r:{if(!(A&3)|!r)break r;for(k=e&255;;){if((k|0)==u[A|0])break e;if(r=r-1|0,f=(r|0)!=0,A=A+1|0,!(A&3))break r;if(!r)break}}if(!f)break i;if(f=e&255,!((f|0)==u[A|0]|r>>>0<4))for(f=g(f,16843009);;){if(k=f^i[A>>2],((16843008-k|k)&-2139062144)!=-2139062144)break e;if(A=A+4|0,r=r-4|0,!(r>>>0>3))break}if(!r)break i}for(e=e&255;;){if((e|0)==u[A|0])return A;if(A=A+1|0,r=r-1|0,!r)break}}return 0}function je(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;n=v-16|0,v=n,f=l2(e),k=v-16|0,v=k;i:{if(f>>>0<=2147483639){e:{if(f>>>0<11){t[A+11|0]=u[A+11|0]&128|f&127,t[A+11|0]=u[A+11|0]&127,r=A;break e}l=k+8|0,f>>>0>=11?(o=f+8&-8,r=o-1|0,r=(r|0)==11?o:r):r=10,fe(l,r+1|0),r=i[k+8>>2],i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=f}A=!f,A|A||z(r,e,f),t[k+7|0]=0,t[f+r|0]=u[k+7|0],v=k+16|0;break i}I4(),M()}v=n+16|0}function Vp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;for(n=v-16|0,v=n;;){i:{if((r|0)<=(o|0))break i;if(f=i[A+24>>2],k=i[A+28>>2],f>>>0>=k>>>0){if((W[i[i[A>>2]+52>>2]](A,i[e>>2])|0)==-1)break i;o=o+1|0,e=e+4|0}else{i[n+12>>2]=k-f>>2,i[n+8>>2]=r-o,f=v-16|0,v=f,v=f+16|0,k=i[A+24>>2],f=n+8|0,l=n+12|0,f=i[(i[f>>2]<i[l>>2]?f:l)>>2];e:{if(!f||(l=f<<2,!l))break e;z(k,e,l)}k=f<<2,i[A+24>>2]=k+i[A+24>>2],o=f+o|0,e=e+k|0}continue}break}return v=n+16|0,o|0}function pp(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,13985);break i}if(k=e,n=F0(r),i[k+104>>2]=n,k=e,n=F0(r),i[k+108>>2]=n,u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Al(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0;if(i[A>>2]=92528,u[A+132|0]==1&&(e=aB(-100,A+140|0,0)|0,e>>>0>=4294963201&&(i[33136]=0-e)),k=i[A+104>>2],k){if(e=k,f=i[A+108>>2],(e|0)!=(f|0)){for(;;){if(o=f-16|0,n=i[o>>2],n){if(l=f-12|0,e=i[l>>2],r=n,(e|0)!=(r|0)){for(;r=i[e-16>>2],r&&(i[e-12>>2]=r,Z(r)),e=e-40|0,(n|0)!=(e|0););r=i[o>>2]}i[l>>2]=n,Z(r)}if(f=f-32|0,(k|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=k,Z(e)}return n2(A)|0}function Fp(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0;l=v-32|0,v=l;i:{e:{if(n&&(l2(n)|0)==4)break e;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=29325;break i}s=l+12|0,h=r,r=u[n|0]|u[n+1|0]<<8|(u[n+2|0]<<16|u[n+3|0]<<24),Fe(s,i[e>>2],h,f,k,r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),o,0,0);e:{if(i[l+12>>2]!=i[28728]){c0(A,s,i[e>>2]);break e}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}if(t[l+31|0]>=0)break i;Z(i[l+20>>2])}v=l+32|0}function Cp(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=106512;i:{if(u[A+80|0]!=1||(e=i[A+48>>2],e&&(i[A+52>>2]=e,Z(e)),e=i[A+36>>2],!e))break i;if(r=e,f=i[A+40>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+36>>2]}i[A+40>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function kl(A,e){var r=0;r=C(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=98788,e=i[e>>2],i[r+32>>2]=0,i[r+36>>2]=0,i[r- -64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,t[r+112|0]=0,i[r+124>>2]=0,i[r+116>>2]=0,i[r+120>>2]=0,i[r+16>>2]=92936,i[r+32>>2]=e,i[A+4>>2]=r,i[A>>2]=r+16}function Yp(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=107072;i:{if(u[A+72|0]!=1||(e=i[A+40>>2],e&&(i[A+44>>2]=e,Z(e)),e=i[A+28>>2],!e))break i;if(r=e,f=i[A+32>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+28>>2]}i[A+32>>2]=e,Z(r)}e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function yp(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=104284;i:{if(u[A+76|0]!=1||(e=i[A+44>>2],e&&(i[A+48>>2]=e,Z(e)),e=i[A+32>>2],!e))break i;if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function Ep(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-16|0,v=f;i:{e:{if(i[e+64>>2]&&!(W[i[i[e>>2]+24>>2]](e)|0))break e;i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}if(lf(i[e+64>>2],i[r+8>>2],i[r+12>>2],0)){i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}k=i[r+4>>2],i[f+8>>2]=i[r>>2],i[f+12>>2]=k,k=i[f+12>>2],i[e+72>>2]=i[f+8>>2],i[e+76>>2]=k,e=i[r+12>>2],i[A+8>>2]=i[r+8>>2],i[A+12>>2]=e,e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e}v=f+16|0}function Rp(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0,h=0,w=0,_=0,B=0,m=0;if(!(k&1)){if(!((n|0)<=0|(k|0)<=0))for(B=(o|0)<14?1<<13-o:0,m=14-o|0,s=-1<<o^-1;;){for(o=(g(e,h)<<1)+A|0,w=(g(f,h)<<1)+r|0,_=0;l=X[w>>1]+B>>m,X[o>>1]=(l|0)>=0?(l|0)<(s|0)?l:s:0,l=X[w+2>>1]+B>>m,X[o+2>>1]=(l|0)>=0?(l|0)<(s|0)?l:s:0,w=w+4|0,o=o+4|0,_=_+2|0,(_|0)<(k|0););if(h=h+1|0,(h|0)==(n|0))break}return}U0(23827,19896,172,11285),M()}function Jp(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-32|0,v=r,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[A+16>>2]=f,f=i[A+20>>2],i[A+20>>2]=e;i:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break i;W[i[i[f>>2]+8>>2]](f),y(f)}ct(r+16|0,A),f=i[r+20>>2],e=i[r+16>>2],i[r+24>>2]=e,i[r+28>>2]=f,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=e,i[r+12>>2]=f,O4(A,r+8|0,0),e=i[r+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=r+32|0}function nl(A,e,r,f){var k=0,n=0,o=0,l=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0))f:{A:{if(n=u[A|0],(n|0)!=45||(A=A+1|0,(e|0)!=(A|0)))break A;break f}l=i[33136],i[33136]=0,e1(),A=Fi(A,k+12|0,f,-1,-1),f=h0,o=i[33136];A:{if(o){if(i[k+12>>2]!=(e|0))break A;if((o|0)==68)break r;break e}if(i[33136]=l,i[k+12>>2]==(e|0))break e}}i[r>>2]=4,A=0,e=0;break i}i[r>>2]=4,A=-1,e=-1;break i}e=A,r=(n|0)==45,A=r?0-e|0:e,e=r?0-(f+((e|0)!=0)|0)|0:f}return v=k+16|0,h0=e,A}function Np(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=106512;i:{if(u[A+80|0]!=1||(e=i[A+48>>2],e&&(i[A+52>>2]=e,Z(e)),e=i[A+36>>2],!e))break i;if(r=e,f=i[A+40>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+36>>2]}i[A+40>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}function Dp(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=107072;i:{if(u[A+72|0]!=1||(e=i[A+40>>2],e&&(i[A+44>>2]=e,Z(e)),e=i[A+28>>2],!e))break i;if(r=e,f=i[A+32>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+28>>2]}i[A+32>>2]=e,Z(r)}e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}function Up(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=104284;i:{if(u[A+76|0]!=1||(e=i[A+44>>2],e&&(i[A+48>>2]=e,Z(e)),e=i[A+32>>2],!e))break i;if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}function tl(A,e,r,f){var k=0,n=0,o=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0)){o=i[33136],i[33136]=0,e1(),f=Fi(A,k+12|0,f,0,-2147483648),A=h0,n=i[33136];f:{if(n){if(i[k+12>>2]!=(e|0))break f;if((n|0)==68)break e;break r}if(i[33136]=o,i[k+12>>2]==(e|0))break r}}i[r>>2]=4,e=0;break i}if((A|0)<0&f>>>0<2147483648|(A|0)<-1|(f>>>0>2147483647&(A|0)>=0|(A|0)>0))break e;e=f;break i}if(i[r>>2]=4,e=2147483647,!!f&(A|0)>=0|(A|0)>0)break i;e=-2147483648}return v=k+16|0,e}function E3(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-48|0,v=r,f=i[A>>2],A=i[e+4>>2],e=i[e>>2],t[r+12|0]=0,t[r+23|0]=0,A=a(r+24|0,e,A,r+12|0),e=i[f+228>>2];i:{if(e>>>0<o0[f+232>>2]){k=i[A+4>>2],i[e>>2]=i[A>>2],i[e+4>>2]=k,i[e+16>>2]=i[A+16>>2],k=i[A+12>>2],i[e+8>>2]=i[A+8>>2],i[e+12>>2]=k,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[f+228>>2]=e+20;break i}if(e=Je(f+224|0,A),k=t[A+19|0],i[f+228>>2]=e,(k|0)>=0)break i;Z(i[A+8>>2])}t[r+23|0]<0&&Z(i[r+12>>2]),v=r+48|0}function Mp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,n=f+20|0,Yl(n,e+104|0),F4(r,n),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+19|0]<0&&Z(i[f+8>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}A=i[f+20>>2],A&&(i[f+24>>2]=A,Z(A)),v=f+32|0}function Se(A,e){var r=0,f=0,k=0,n=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(r=i[e+4>>2],k=i[e>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break e;f=C(r),i[A+4>>2]=f,i[A>>2]=f,n=r+f|0,i[A+8>>2]=n,r&&z(f,k,r),i[A+4>>2]=n}if(r=i[e+12>>2],i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+12>>2]=r,r=i[e+20>>2],f=i[e+16>>2],(r|0)!=(f|0)){if(e=r-f|0,(e|0)<0)break i;r=C(e),i[A+20>>2]=r,i[A+16>>2]=r,k=e+r|0,i[A+24>>2]=k,e&&z(r,f,e),i[A+20>>2]=k}return}s0(),M()}s0(),M()}function Hp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,n=i[e+104>>2];i:{if(!u[e+97|0]){u2(r,n&65535);break i}p0(r,n)}i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function zp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;i:{if(o=i[e+16>>2],!o||(o=Z0(o,101112,102272),!o))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[o+4>>2],i[f>>2]=i[o+8>>2],i[k>>2]=i[o+12>>2],i[n>>2]=i[o+16>>2],i[A+8>>2]=i[25680],r=i[25679],i[A>>2]=i[25678],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}return}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794]}function xp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;i:{if(o=i[e+16>>2],!o||(o=Z0(o,101112,102316),!o))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[o+4>>2],i[f>>2]=i[o+8>>2],i[k>>2]=i[o+12>>2],i[n>>2]=i[o+16>>2],i[A+8>>2]=i[25680],r=i[25679],i[A>>2]=i[25678],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}return}e=i[25793],i[A>>2]=i[25792],i[A+4>>2]=e,i[A+8>>2]=i[25794]}function Tp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(e=i[r+4>>2],!(!u[k+12|0]|((e|0)==3|i[k+8>>2]==1))||i[r>>2]|(e|0)!=1|i[r+12>>2]!=8||t[r+8|0]&1||(e=p[r+24>>1],!(e>>>0>14|!(1<<e&18689))|!u[r+26|0]))break i;e=C(32),i[e+28>>2]=11,t[e+26|0]=1,X[e+24>>1]=2,i[e+20>>2]=131074,i[e+12>>2]=8,i[e+16>>2]=0,t[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=10,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function jp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,r=v-16|0,v=r;i:{if(!(n&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(!(k&&f)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=26487;break i}if(i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,X[r>>1]=f,X[r+2>>1]=k,f=g(f,k),W3(r+4|0,n,(f<<3)+n|0,f),e=i[e>>2],W[i[i[e>>2]+40>>2]](e,r),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,A=i[r+4>>2],!A)break i;i[r+8>>2]=A,Z(A)}v=r+16|0}function ol(A,e,r,f){var k=0,n=0,o=0,l=0;k=v-16|0,v=k;i:{e:{r:{f:{if((A|0)!=(e|0))A:{k:{if(n=u[A|0],(n|0)!=45||(A=A+1|0,(e|0)!=(A|0)))break k;break A}l=i[33136],i[33136]=0,e1(),A=Fi(A,k+12|0,f,-1,-1),f=h0,o=i[33136];k:{if(o){if(i[k+12>>2]!=(e|0))break k;if((o|0)==68)break r;break f}if(i[33136]=l,i[k+12>>2]==(e|0))break f}}i[r>>2]=4,A=0;break i}if(!f&A>>>0<=65535)break e}i[r>>2]=4,A=65535;break i}A=(n|0)==45?0-A|0:A}return v=k+16|0,A&65535}function Sp(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0;if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}i:{if((r|0)>=0&&(l=i[e>>2],e=i[l+140>>2],(i[l+144>>2]-e|0)/48>>>0>r>>>0))break i;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27960;return}e=e+g(r,48)|0,f&&(i[f>>2]=i[e+4>>2]-i[e>>2]>>2),k&&(i[k>>2]=u[e+12|0]),n&&(i[n>>2]=i[e+16>>2]),o&&(i[o>>2]=i[e+20>>2]),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function Op(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,M4(r,e+104|0,1),M4(r,e+116|0,1),M4(r,e+128|0,1),M4(r,e+140|0,1),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function ll(A,e,r){var f=0,k=0,n=0,o=0,l=0;n=v-16|0,v=n,k=v-16|0,v=k;i:{if(e>>>0<=2147483639){e:{if(e>>>0<11){t[A+11|0]=u[A+11|0]&128|e&127,t[A+11|0]=u[A+11|0]&127,f=A;break e}l=k+8|0,e>>>0>=11?(o=e+8&-8,f=o-1|0,f=(f|0)==11?o:f):f=10,fe(l,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=e}d5(f,e,r),t[k+7|0]=0,t[e+f|0]=u[k+7|0],v=k+16|0;break i}I4(),M()}return v=n+16|0,A}function Pp(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-32|0,v=r,f=p[e>>1]|p[e+2>>1]<<16,X[A+6>>1]=f,X[A+8>>1]=f>>>16,e=u[e+3|0]|u[e+4|0]<<8|(u[e+5|0]<<16|u[e+6|0]<<24),t[A+9|0]=e,t[A+10|0]=e>>>8,t[A+11|0]=e>>>16,t[A+12|0]=e>>>24,dt(r+16|0,A),f=i[r+20>>2],e=i[r+16>>2],i[r+24>>2]=e,i[r+28>>2]=f,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=e,i[r+12>>2]=f,O4(A,r+8|0,0),A=i[r+20>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=r+32|0}function ri(A){var e=0,r=0,f=0,k=0;return i[A+92>>2]=0,i[A+64>>2]=78164,i[A+8>>2]=78144,e=i[19545],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[19546],i[A+4>>2]=0,e=i[i[A>>2]-12>>2]+A|0,r=A+12|0,J0(e,r),t[e+80|0]=0,i[e+72>>2]=0,e=i[19547],i[A+8>>2]=e,i[i[e-12>>2]+(A+8|0)>>2]=i[19548],e=i[19544],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[19549],i[A+64>>2]=78164,i[A>>2]=78124,i[A+8>>2]=78144,f=R0(r),k=77200,i[f>>2]=k,i[A+52>>2]=0,i[A+56>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,i[A+60>>2]=24,A}function ul(A,e,r){var f=0,k=0,n=0,o=0,l=0;i:{if(k=v-16|0,v=k,n=r-e|0,n>>>0<=2147483639){e:{if(n>>>0<11){t[A+11|0]=u[A+11|0]&128|n&127,t[A+11|0]=u[A+11|0]&127,f=A;break e}l=k+8|0,n>>>0>=11?(o=n+8&-8,f=o-1|0,f=(f|0)==11?o:f):f=10,fe(l,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=n}A=r-e|0,r=!A,r|r||z(f,e,A),t[k+7|0]=0,t[A+f|0]=u[k+7|0],v=k+16|0;break i}I4(),M()}}function Lp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(k=v-32|0,v=k,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+100>>2],n=i[e+104>>2],(f|0)!=(n|0))for(;u2(r,p[f>>1]),h2(r,u[f+2|0]),h2(r,u[f+3|0]),f=f+4|0,(n|0)!=(f|0););n1(k+12|0,e,r,o),t[k+31|0]<0&&Z(i[k+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+32|0}function u5(A){var e=0,r=0,f=0,k=0;if(i[A+20>>2]=0,r=i[A+8>>2],e=i[A+4>>2],f=r-e>>2,f>>>0>=3)for(;Z(i[e>>2]),e=i[A+4>>2]+4|0,i[A+4>>2]=e,r=i[A+8>>2],f=r-e>>2,f>>>0>2;);k=512;i:switch(f-1|0){case 1:k=1024;case 0:i[A+16>>2]=k;break;default:break i}i:{if((e|0)==(r|0))break i;for(;Z(i[e>>2]),e=e+4|0,(r|0)!=(e|0););if(r=i[A+4>>2],e=i[A+8>>2],(r|0)==(e|0))break i;i[A+8>>2]=e+((r-e|0)+3&-4)}A=i[A>>2],A&&Z(A)}function T8(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;if(f=i[A+8>>2],r=i[A+4>>2],f-r>>2>>>0>=e>>>0){e&&(e=e<<2,e&&l0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(o=r,r=i[A>>2],l=o-r|0,n=l>>2,k=n+e|0,k>>>0<1073741824){if(f=f-r|0,o=f>>1,k=f>>>0>=2147483644?1073741823:k>>>0<o>>>0?o:k,k){if(k>>>0>=1073741824)break i;s=C(k<<2)}f=l+s|0,e=e<<2,e&&l0(f,0,e),n=f-(n<<2)|0,l&&z(n,r,l),i[A+8>>2]=(k<<2)+s,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}s0(),M()}x0(),M()}function qp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,n=t[e+115|0],((n|0)<0?i[e+108>>2]:n)&&M4(r,e+104|0,1),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function ap(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;i:{if(f=i[A>>2],A=i[f+184>>2],k=i[f+188>>2],(A|0)!=(k|0))for(;;){e:{if(f=i[A>>2],!f||(f=Z0(f,92792,95144),!f))break e;if(A=i[A+4>>2],A)break i;return i[e>>2]=i[f+100>>2],i[r>>2]=i[f+104>>2],1}if(A=A+8|0,(k|0)==(A|0))break}return i[e>>2]=1,i[r>>2]=1,0}return i[A+4>>2]=i[A+4>>2]+1,i[e>>2]=i[f+100>>2],i[r>>2]=i[f+104>>2],e=i[A+4>>2],i[A+4>>2]=e-1,e||(W[i[i[A>>2]+8>>2]](A),y(A)),1}function Kp(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if((r|0)>0)for(h=1<<k-1,_=r&2147483646,B=r&1;;){if(n=0,o=0,w=0,(r|0)!=1)for(;s=g(r,n)+l|0,o=((X[(s<<1)+e>>1]<<f)+h>>k)+o|0,i[(s<<2)+A>>2]=o,s=g(n|1,r)+l|0,o=o+((X[(s<<1)+e>>1]<<f)+h>>k)|0,i[(s<<2)+A>>2]=o,n=n+2|0,w=w+2|0,(_|0)!=(w|0););if(B&&(n=g(r,n)+l|0,i[(n<<2)+A>>2]=((X[(n<<1)+e>>1]<<f)+h>>k)+o),l=l+1|0,(l|0)==(r|0))break}}function sl(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;if(r=i[A+360>>2],f=i[A+364>>2],r>>>0<f>>>0){i[r>>2]=e,i[A+360>>2]=r+4;return}i:{if(o=i[A+356>>2],r=r-o|0,l=r>>2,k=l+1|0,k>>>0<1073741824){if(f=f-o|0,n=f>>1,f=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,f){if(f>>>0>=1073741824)break i;k=C(f<<2)}else k=0;n=k+r|0,i[n>>2]=e,e=n-(l<<2)|0,r&&z(e,o,r),i[A+364>>2]=k+(f<<2),r=n+4|0,i[A+360>>2]=r,i[A+356>>2]=e,o&&Z(o),i[A+360>>2]=r;return}s0(),M()}x0(),M()}function hl(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;if(r=i[A+544>>2],f=i[A+548>>2],r>>>0<f>>>0){i[r>>2]=e,i[A+544>>2]=r+4;return}i:{if(o=i[A+540>>2],r=r-o|0,l=r>>2,k=l+1|0,k>>>0<1073741824){if(f=f-o|0,n=f>>1,f=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,f){if(f>>>0>=1073741824)break i;k=C(f<<2)}else k=0;n=k+r|0,i[n>>2]=e,e=n-(l<<2)|0,r&&z(e,o,r),i[A+548>>2]=k+(f<<2),r=n+4|0,i[A+544>>2]=r,i[A+540>>2]=e,o&&Z(o),i[A+544>>2]=r;return}s0(),M()}x0(),M()}function fi(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;if(f=i[A+8>>2],r=i[A+4>>2],f-r>>3>>>0>=e>>>0){e&&(e=e<<3,e&&l0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(o=r,r=i[A>>2],l=o-r|0,n=l>>3,k=n+e|0,k>>>0<536870912){if(f=f-r|0,o=f>>2,k=f>>>0>=2147483640?536870911:k>>>0<o>>>0?o:k,k){if(k>>>0>=536870912)break i;s=C(k<<3)}f=l+s|0,e=e<<3,e&&l0(f,0,e),n=f-(n<<3)|0,l&&z(n,r,l),i[A+8>>2]=(k<<3)+s,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}s0(),M()}x0(),M()}function wl(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;if(r=i[A+108>>2],f=i[A+112>>2],r>>>0<f>>>0){i[r>>2]=e,i[A+108>>2]=r+4;return}i:{if(o=i[A+104>>2],r=r-o|0,l=r>>2,k=l+1|0,k>>>0<1073741824){if(f=f-o|0,n=f>>1,f=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,f){if(f>>>0>=1073741824)break i;k=C(f<<2)}else k=0;n=k+r|0,i[n>>2]=e,e=n-(l<<2)|0,r&&z(e,o,r),i[A+112>>2]=k+(f<<2),r=n+4|0,i[A+108>>2]=r,i[A+104>>2]=e,o&&Z(o),i[A+108>>2]=r;return}s0(),M()}x0(),M()}function $p(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+100>>2]),u2(r,p[e+104>>1]),u2(r,p[e+106>>1]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function dp(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,7458);break i}if(k=e,n=Q2(r)&31,i[k+104>>2]=n,u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function bp(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0;l=v-16|0,v=l,s=i[A>>2],k=i[s+224>>2],n=(i[s+228>>2]-k|0)/20|0;i:{if(!f){o=n;break i}if((f|0)<=0|(e|0)>=(n|0))break i;for(;;){if(n=i[A>>2],c0(l+4|0,(g(o,20)+k|0)+g(e,20)|0,n?n+172|0:0),k=g(o,12)+r|0,i[k+8>>2]=i[l+12>>2],n=i[l+8>>2],i[k>>2]=i[l+4>>2],i[k+4>>2]=n,k=i[s+224>>2],o=o+1|0,(o|0)>=(f|0))break i;if(!((e+o|0)<((i[s+228>>2]-k|0)/20|0)))break}}return v=l+16|0,o|0}function cp(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0,m=0;if((r|0)>0)for(s=1<<k-1,B=r&2147483646,m=r&1;;){if(_=g(r,h),l=0,o=0,w=0,(r|0)!=1)for(;n=l+_|0,o=((X[(n<<1)+e>>1]<<f)+s>>k)+o|0,i[(n<<2)+A>>2]=o,n=n+1|0,o=o+((X[(n<<1)+e>>1]<<f)+s>>k)|0,i[(n<<2)+A>>2]=o,l=l+2|0,w=w+2|0,(B|0)!=(w|0););if(m&&(n=l+_|0,i[(n<<2)+A>>2]=((X[(n<<1)+e>>1]<<f)+s>>k)+o),h=h+1|0,(h|0)==(r|0))break}}function _l(A,e,r){var f=0,k=0,n=0,o=0,l=0;k=i[A+8>>2],f=i[A+12>>2];i:{e:{if((k|0)==(f|0)){A=0;break e}for(A=f-k>>2,l=A>>>0<=1?1:A;;){if(o=i[(n<<2)+k>>2],!(i[o+92>>2]!=(e|0)|i[o+108>>2]<=(r|0))&i[o+100>>2]==2)break i;if(n=n+1|0,(l|0)==(n|0))break}}if(n=-1,(f|0)==(k|0))break i;for(o=A>>>0<=1?1:A,A=0;;){if(f=i[(A<<2)+k>>2],!(i[f+92>>2]!=(e|0)|i[f+108>>2]<=(r|0)|!i[f+100>>2]))return A;if(A=A+1|0,(o|0)==(A|0))break}}return n}function h2(A,e){var r=0,f=0,k=0,n=0,o=0;i:{if(k=i[A+12>>2],f=i[A+4>>2],o=i[A>>2],(k|0)==(f-o|0)){r=i[A+8>>2];e:{if(r>>>0>f>>>0){t[f|0]=e,e=f+1|0;break e}if(n=k+1|0,(n|0)<0)break i;if(f=r-o|0,r=f<<1,n=f>>>0>=1073741823?2147483647:r>>>0>n>>>0?r:n,n?r=C(n):r=0,f=r+k|0,t[f|0]=e,k&&z(r,o,k),i[A+8>>2]=r+n,e=f+1|0,i[A+4>>2]=e,i[A>>2]=r,!o)break e;Z(o)}i[A+4>>2]=e,i[A+12>>2]=i[A+12>>2]+1;return}i[A+12>>2]=k+1,t[k+o|0]=e;return}s0(),M()}function t6(A,e,r,f,k,n){var o=0,l=0,s=0;l=v-16|0,v=l;i:{e:{if(!A||(o=i[k+12>>2],s=r-e>>2,(s|0)>0&&(W[i[i[A>>2]+48>>2]](A,e,s)|0)!=(s|0)))break e;if(e=f-e>>2,o=(e|0)<(o|0)?o-e|0:0,(o|0)>0){e=Ho(l+4|0,o,n);r:{if(u[e+11|0]>>>7|0){n=i[e>>2];break r}n=e}if(n=W[i[i[A>>2]+48>>2]](A,n,o)|0,q1(e),(n|0)!=(o|0))break e}if(e=f-r>>2,(e|0)>0&&(W[i[i[A>>2]+48>>2]](A,r,e)|0)!=(e|0))break e;i[k+12>>2]=0;break i}A=0}return v=l+16|0,A}function iF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;return o=W[i[i[A>>2]+8>>2]](A)|0,f=h0,l=r+o|0,f=l>>>0<r>>>0?f+1|0:f,s=i[A+36>>2],k=s,o=i[A+32>>2],(f|0)==(k|0)&l>>>0<=o>>>0|f>>>0<k>>>0&&(k=v-16|0,v=k,A=i[A+24>>2],i[A+4>>2]=0,lr(k+15|0,A),n=4,u[k+15|0]&&(n=i[(A+i[i[A>>2]-12>>2]|0)+24>>2],e=W[i[i[n>>2]+32>>2]](n,e,r)|0,i[A+4>>2]=e,n=(e|0)!=(r|0)?6:0),z4(A+i[i[A>>2]-12>>2]|0,n),v=k+16|0),(f|0)==(s|0)&o>>>0>=l>>>0|f>>>0<s>>>0}function R3(A){var e=0;return i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+56>>2]=-1,i[A+60>>2]=-1,i[A+72>>2]=0,i[A+76>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,e=A- -64|0,i[e>>2]=-1,i[e+4>>2]=-1,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,t[A+96|0]=0,i[A+108>>2]=0,i[A+112>>2]=0,i[A+116>>2]=0,i[A+120>>2]=0,i[A+16>>2]=1835295606,i[A>>2]=92596,A}function o6(A,e,r,f,k,n){var o=0,l=0,s=0;l=v-16|0,v=l;i:{e:{if(!A||(o=i[k+12>>2],s=r-e|0,(s|0)>0&&(W[i[i[A>>2]+48>>2]](A,e,s)|0)!=(s|0)))break e;if(e=f-e|0,o=(e|0)<(o|0)?o-e|0:0,(o|0)>0){e=ll(l+4|0,o,n);r:{if(u[e+11|0]>>>7|0){n=i[e>>2];break r}n=e}if(n=W[i[i[A>>2]+48>>2]](A,n,o)|0,_2(e),(n|0)!=(o|0))break e}if(e=f-r|0,(e|0)>0&&(W[i[i[A>>2]+48>>2]](A,r,e)|0)!=(e|0))break e;i[k+12>>2]=0;break i}A=0}return v=l+16|0,A}function eF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;for(k=v-16|0,v=k;;){i:{if((r|0)<=(n|0))break i;if(f=i[A+24>>2],l=i[A+28>>2],f>>>0>=l>>>0){if((W[i[i[A>>2]+52>>2]](A,u[e|0])|0)==-1)break i;n=n+1|0,e=e+1|0}else i[k+12>>2]=l-f,i[k+8>>2]=r-n,f=v-16|0,v=f,v=f+16|0,l=i[A+24>>2],f=k+8|0,o=k+12|0,f=i[(i[f>>2]<i[o>>2]?f:o)>>2],o=!f,o|o||z(l,e,f),i[A+24>>2]=f+i[A+24>>2],n=f+n|0,e=e+f|0;continue}break}return v=k+16|0,n|0}function s5(A,e){var r=0,f=0,k=0;f=v-16|0,v=f,i[f+12>>2]=e;i:{e:{r=u[A+11|0],k=r>>>7|0;r:{if(!k){r=r&127,e=1;break r}r=i[A+4>>2],e=(i[A+8>>2]&2147483647)-1|0}if((e|0)==(r|0)){go(A,e,1,e,e);r:if(u[A+11|0]>>>7|0)break r;break e}r:if(u[A+11|0]>>>7|0)break r;if(k)break e;e=A,t[A+11|0]=u[A+11|0]&128|r+1&127,t[A+11|0]=u[A+11|0]&127;break i}e=i[A>>2],i[A+4>>2]=r+1}A=(r<<2)+e|0,i[A>>2]=i[f+12>>2],i[f+8>>2]=0,i[A+4>>2]=i[f+8>>2],v=f+16|0}function rF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-16|0,v=f,k=i[A>>2],n=u[k+20|0];i:{if((n|0)!=255){if(!n){if(n=i[r>>2],A=i[r+4>>2],i[r>>2]=0,i[r+4>>2]=0,r=i[e+4>>2],i[e>>2]=n,i[e+4>>2]=A,!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r);break i}A=i[25173],i[f+8>>2]=i[25172],i[f+12>>2]=A,W[i[(f+8|0)+(n<<2)>>2]](f+7|0,k)}i[k>>2]=i[r>>2],i[k+4>>2]=i[r+4>>2],i[r>>2]=0,i[r+4>>2]=0,t[k+20|0]=0}v=f+16|0}function fF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;if(k=i[r+4>>2],!(i[r+12>>2]==8&k>>>0<=3)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}f=i[f+12>>2],o=i[r+24>>2],l=i[r+20>>2],n=i[r>>2],s=u[r+8|0],e=C(32),t[e+8|0]=s,i[e+4>>2]=k,i[e>>2]=n,k=u[r+9|0]|u[r+10|0]<<8,t[e+9|0]=k,t[e+10|0]=k>>>8,t[e+11|0]=u[r+11|0],i[e+28>>2]=11,i[e+20>>2]=l,i[e+24>>2]=o,i[e+16>>2]=f,i[e+12>>2]=f,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function AF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;if(k=i[r+4>>2],!(!(i[r+12>>2]!=8&k>>>0<=3)|i[f+12>>2]!=8)){f=i[r+24>>2],o=i[r+20>>2],l=i[r>>2],n=u[r+8|0],e=C(32),t[e+8|0]=n,i[e+4>>2]=k,i[e>>2]=l,k=u[r+9|0]|u[r+10|0]<<8,t[e+9|0]=k,t[e+10|0]=k>>>8,t[e+11|0]=u[r+11|0],i[e+28>>2]=11,i[e+20>>2]=o,i[e+24>>2]=f,i[e+12>>2]=8,i[e+16>>2]=8,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function Bl(A,e,r,f){var k=0,n=0,o=0,l=0;k=v-16|0,v=k;i:{e:{r:{f:{if((A|0)!=(e|0))A:{k:{if(n=u[A|0],(n|0)!=45||(A=A+1|0,(e|0)!=(A|0)))break k;break A}l=i[33136],i[33136]=0,e1(),A=Fi(A,k+12|0,f,-1,-1),f=h0,o=i[33136];k:{if(o){if(i[k+12>>2]!=(e|0))break k;if((o|0)==68)break r;break f}if(i[33136]=l,i[k+12>>2]==(e|0))break f}}i[r>>2]=4,A=0;break i}if(!f)break e}i[r>>2]=4,A=-1;break i}A=(n|0)==45?0-A|0:A}return v=k+16|0,A}function kF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;t[A+44|0]=0,t[A|0]=0,u[e+76|0]==1&&(i[A>>2]=i[e+32>>2],i[A+4>>2]=i[e+36>>2],i[A+8>>2]=i[e+40>>2],i[e+40>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[A+12>>2]=i[e+44>>2],i[A+16>>2]=i[e+48>>2],i[A+20>>2]=i[e+52>>2],i[e+52>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,r=e- -64|0,f=i[r>>2],r=i[r+4>>2],k=i[e+72>>2],n=i[e+56>>2],e=i[e+60>>2],t[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=f,i[A+36>>2]=r,i[A+24>>2]=n,i[A+28>>2]=e)}function J3(A,e){i:{if(A){if(e>>>0<=127)break i;e:{if(!i[i[33178]>>2]){if((e&-128)==57216)break i;break e}if(e>>>0<=2047)return t[A+1|0]=e&63|128,t[A|0]=e>>>6|192,2;if(!((e&-8192)!=57344&e>>>0>=55296))return t[A+2|0]=e&63|128,t[A|0]=e>>>12|224,t[A+1|0]=e>>>6&63|128,3;if(e-65536>>>0<=1048575)return t[A+3|0]=e&63|128,t[A|0]=e>>>18|240,t[A+2|0]=e>>>6&63|128,t[A+1|0]=e>>>12&63|128,4}i[33136]=25,A=-1}else A=1;return A}return t[A|0]=e,1}function nF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if((e|0)>0)for(;;){if(k=i[(n<<2)+A>>2],k){r=i[k+20>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[k+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[k+4>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}Z(k)}if(n=n+1|0,(n|0)==(e|0))break}}function N3(A,e){var r=0,f=0,k=0,n=0,o=0;i:{r=i[A+4>>2],n=i[A>>2],o=r-n|0,k=o+e|0;e:{if(k>>>0>o>>>0){if(f=i[A+8>>2],f-r>>>0>=e>>>0){e&&l0(r,0,e),i[A+4>>2]=e+r;break e}if((k|0)<0)break i;if(r=f-n|0,f=r<<1,f=r>>>0>=1073741823?2147483647:k>>>0<f>>>0?f:k,r=C(f),e&&l0(r+o|0,0,e),o&&z(r,n,o),i[A+8>>2]=r+f,i[A+4>>2]=r+k,i[A>>2]=r,!n)break e;Z(n);break e}if(k>>>0>=o>>>0)break e;i[A+4>>2]=k+n}i[A+12>>2]=i[A+12>>2]+e;return}s0(),M()}function u8(A,e){var r=0,f=0;f=A;i:{e:{if((f^e)&3){r=u[e|0];break e}if(e&3)for(;;){if(r=u[e|0],t[f|0]=r,!r)break i;if(f=f+1|0,e=e+1|0,!(e&3))break}if(r=i[e>>2],((r|16843008-r)&-2139062144)!=-2139062144)break e;for(;i[f>>2]=r,f=f+4|0,r=i[e+4>>2],e=e+4|0,((16843008-r|r)&-2139062144)==-2139062144;);}if(t[f|0]=r,!(r&255))break i;for(;r=u[e+1|0],t[f+1|0]=r,f=f+1|0,e=e+1|0,!!r;);}return A}function tF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;i:{if(i[r>>2]|i[r+4>>2]!=1|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)<=8)||(k=p[r+24>>1],!k))break i;n=u[r+8|0],o=i[r+20>>2],l=i[r+16>>2],r=u[r+26|0],e=C(32),i[e+28>>2]=11,t[e+26|0]=r,X[e+24>>1]=k,i[e+16>>2]=l,i[e+20>>2]=o,i[e+12>>2]=f,t[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function oF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;i:{if(i[r>>2]|i[r+4>>2]!=2|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)>=9)||(k=p[r+24>>1],!k))break i;n=u[r+8|0],o=i[r+20>>2],l=i[r+16>>2],r=u[r+26|0],e=C(32),i[e+28>>2]=11,t[e+26|0]=r,X[e+24>>1]=k,i[e+16>>2]=l,i[e+20>>2]=o,i[e+12>>2]=f,t[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function lF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;i:{if(i[r>>2]|i[r+4>>2]!=2|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)<=8)||(k=p[r+24>>1],!k))break i;n=u[r+8|0],o=i[r+20>>2],l=i[r+16>>2],r=u[r+26|0],e=C(32),i[e+28>>2]=11,t[e+26|0]=r,X[e+24>>1]=k,i[e+16>>2]=l,i[e+20>>2]=o,i[e+12>>2]=f,t[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function vl(A,e,r){var f=0,k=0,n=0,o=0,l=0;i:{if(k=v-16|0,v=k,n=r-e>>2,n>>>0<=1073741815){e:{if(n>>>0<2){t[A+11|0]=u[A+11|0]&128|n&127,t[A+11|0]=u[A+11|0]&127,f=A;break e}l=k+8|0,n>>>0>=2?(o=n+2&-2,f=o-1|0,f=(f|0)==2?o:f):f=1,Ae(l,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=n}A=bs(e,r,f),i[k+4>>2]=0,i[A>>2]=i[k+4>>2],v=k+16|0;break i}I4(),M()}}function uF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0;f=v-16|0,v=f,l=df()|0;i:{if(!e||(r=V5(e),(r|0)<=0))break i;if(n=f-((r<<2)+15&-16)|0,v=n,o=jt(e,n,r),o){if(e=0,(o|0)<=0)break i;for(;i[f+8>>2]=e,k=f+8|0,r=T1(91512,k|0)|0,i[f+8>>2]=i[(e<<2)+n>>2],k=T1(91524,k|0)|0,q4(l|0,r|0,k|0),k>>>0>=9&&g1(k|0),r>>>0>=9&&g1(r|0),e=e+1|0,(o|0)!=(e|0););break i}Z(n)}i[A+4>>2]=l,i[A>>2]=132616,v=f+16|0}function sF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;i:{if(i[r>>2]|i[r+4>>2]!=1|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)>=9)||(k=p[r+24>>1],!k))break i;n=u[r+8|0],o=i[r+20>>2],l=i[r+16>>2],r=u[r+26|0],e=C(32),i[e+28>>2]=11,t[e+26|0]=r,X[e+24>>1]=k,i[e+16>>2]=l,i[e+20>>2]=o,i[e+12>>2]=f,t[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function hF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(!r){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}if(i[r>>2]=0,e=i[i[e>>2]+64>>2],!e){e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680];return}f=r,r=C(24),i[f>>2]=r,f=i[e+20>>2],i[r+16>>2]=i[e+16>>2],i[r+20>>2]=f,f=i[e+12>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=f,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}function wF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;n=v-32|0,v=n,i[n+24>>2]=0,i[n+28>>2]=0,o=n+4|0,nA(o,i[e>>2],n+24|0,f,k,0),i[n+4>>2]||(k=C(8),i[r>>2]=k,f=i[n+24>>2],r=i[n+28>>2],i[n+24>>2]=0,i[n+28>>2]=0,i[k>>2]=f,i[k+4>>2]=r,o=114912),r=A,A=i[e>>2],c0(r,o,A?A+172|0:0),t[n+23|0]<0&&Z(i[n+12>>2]),e=i[n+28>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=n+32|0}function ml(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){j1(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,j1(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}e=0,A=i[r+8>>2],!A|i[A+112>>2]!=1835625829||(e=t[A+139|0]<0?i[A+128>>2]:A+128|0),A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,e|0}function Zl(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){j1(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,j1(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}e=0,A=i[r+8>>2],!A|i[A+112>>2]!=1835625829||(e=t[A+151|0]<0?i[A+140>>2]:A+140|0),A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,e|0}function _F(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+100>>2]),p0(r,i[e+104>>2]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function gl(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){j1(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,j1(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}e=0,A=i[r+8>>2],!A|i[A+112>>2]!=1970432288||(e=t[A+163|0]<0?i[A+152>>2]:A+152|0),A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,e|0}function BF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;t[A+44|0]=0,t[A|0]=0,u[e+80|0]==1&&(i[A>>2]=i[e+36>>2],i[A+4>>2]=i[e+40>>2],i[A+8>>2]=i[e+44>>2],i[e+44>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[A+12>>2]=i[e+48>>2],i[A+16>>2]=i[e+52>>2],i[A+20>>2]=i[e+56>>2],i[e+56>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,r=i[e+68>>2],f=i[e+72>>2],k=i[e+76>>2],n=i[e+60>>2],e=i[e+64>>2],t[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=r,i[A+36>>2]=f,i[A+24>>2]=n,i[A+28>>2]=e)}function vF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;t[A+44|0]=0,t[A|0]=0,u[e+64|0]==1&&(i[A>>2]=i[e+20>>2],i[A+4>>2]=i[e+24>>2],i[A+8>>2]=i[e+28>>2],i[e+28>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[A+12>>2]=i[e+32>>2],i[A+16>>2]=i[e+36>>2],i[A+20>>2]=i[e+40>>2],i[e+40>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,r=i[e+52>>2],f=i[e+56>>2],k=i[e+60>>2],n=i[e+44>>2],e=i[e+48>>2],t[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=r,i[A+36>>2]=f,i[A+24>>2]=n,i[A+28>>2]=e)}function mF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+104>>2]),p0(r,i[e+108>>2]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Ai(A,e){var r=0,f=0,k=0;f=v-16|0,v=f,t[f+15|0]=e;i:{e:{r=u[A+11|0],k=r>>>7|0;r:{if(!k){r=r&127,e=10;break r}r=i[A+4>>2],e=(i[A+8>>2]&2147483647)-1|0}if((e|0)==(r|0)){f5(A,e,1,e,e);r:if(u[A+11|0]>>>7|0)break r;break e}r:if(u[A+11|0]>>>7|0)break r;if(k)break e;e=A,t[A+11|0]=u[A+11|0]&128|r+1&127,t[A+11|0]=u[A+11|0]&127;break i}e=i[A>>2],i[A+4>>2]=r+1}A=e+r|0,t[A|0]=u[f+15|0],t[f+14|0]=0,t[A+1|0]=u[f+14|0],v=f+16|0}function ZF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,p[e+98>>1]),u2(r,p[e+100>>1]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function gF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k;i:{if(!f){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}m3(k+12|0,r,0),n=i[k+12>>2];e:{if((n|0)!=i[k+16>>2]){e=C(8),r=i[i[n>>2]>>2],i[e+4>>2]=0,i[e>>2]=r,i[f>>2]=e,o7(A,e);break e}if(i[f>>2]=0,t[k|0]=0,t[k+11|0]=0,r=a(k+12|0,3,0,k),t[k+11|0]<0&&Z(i[k>>2]),c0(A,r,e?i[e>>2]:0),t[r+19|0]<0&&Z(i[r+8>>2]),!n)break i}Z(n)}v=k+32|0}function G4(A,e,r,f){var k=0,n=0;i:{if(u[A+11|0]>>>7|0?k=i[A+4>>2]:k=u[A+11|0]&127,!k|(r-e|0)<5)break i;T3(e,r),n=r-4|0,u[A+11|0]>>>7|0?k=i[A+4>>2]:k=u[A+11|0]&127,u[A+11|0]>>>7|0&&(A=i[A>>2]),r=A,A=k+A|0;e:{for(;;){r:{if(k=t[r|0],e>>>0>=n>>>0)break r;if(!((k|0)<=0|(k|0)>=127)&(k|0)!=i[e>>2])break e;e=e+4|0,r=((A-r|0)>1)+r|0;continue}break}if((k|0)<=0|(k|0)>=127|t[r|0]>>>0>i[n>>2]-1>>>0)break i}i[f>>2]=4}}function GF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;i:{if(u[r+8|0]!=1||(e=i[r+16>>2],!e)||(f=i[r+12>>2],(f|0)==(e|0)|o0[r+4>>2]>=4))break i;k=i[r+20>>2],n=i[r+24>>2],e=C(32),o=i[r+12>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=o,o=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=o,i[e+28>>2]=11,i[e+20>>2]=k,i[e+24>>2]=n,i[e+16>>2]=f,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function WF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}i:{if((r|0)>=0&&(o=i[e>>2],e=i[o+116>>2],(i[o+120>>2]-e|0)/28>>>0>r>>>0))break i;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27919;return}e=e+g(r,28)|0,f&&(i[f>>2]=i[e+4>>2]-i[e>>2]>>2),k&&(X[k>>1]=p[e+12>>1]),n&&(X[n>>1]=p[e+14>>1]),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function Gl(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;t[A+44|0]=0,t[A|0]=0,u[e+48|0]==1&&(i[A>>2]=i[e+4>>2],i[A+4>>2]=i[e+8>>2],i[A+8>>2]=i[e+12>>2],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[A+12>>2]=i[e+16>>2],i[A+16>>2]=i[e+20>>2],i[A+20>>2]=i[e+24>>2],i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,r=i[e+36>>2],f=i[e+40>>2],k=i[e+44>>2],n=i[e+28>>2],e=i[e+32>>2],t[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=r,i[A+36>>2]=f,i[A+24>>2]=n,i[A+28>>2]=e)}function XF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(f=v-32|0,v=f,k=i[r>>2],k>>>0<2147483640){i:{e:{if(k>>>0>=11){o=k|7,n=C(o+1|0),i[f+16>>2]=o-2147483647,i[f+8>>2]=n,i[f+12>>2]=k;break e}if(t[f+19|0]=k,n=f+8|0,!k)break i}if(!k)break i;z(n,r+4|0,k)}return t[k+n|0]=0,W[A|0](f+20|0,e,f+8|0),A=C(12),i[A+8>>2]=i[f+28>>2],e=i[f+24>>2],i[A>>2]=i[f+20>>2],i[A+4>>2]=e,t[f+19|0]<0&&Z(i[f+8>>2]),v=f+32|0,A|0}I0(),M()}function Wl(A,e,r,f,k){var n=0,o=0,l=0;l=-1,o=f&2147483647,n=(o|0)==2147418112;i:{if((n&!r?A|e:n&(r|0)!=0|o>>>0>2147418112)||(n=k&2147483647,n>>>0>2147418112&(n|0)!=2147418112))break i;if(!(A|r|(n|o|e)))return 0;if(n=f&k,(n|0)>0?n=1:n=(n|0)>=0,n){if(((r|0)!=0|(f|0)!=(k|0))&(f|0)<(k|0))break i;return(A|r|(f^k|e))!=0}if(!r&(f|0)==(k|0)?A|e:(r|0)!=0&(f|0)>=(k|0)|(f|0)>(k|0))break i;l=(A|r|(f^k|e))!=0}return l}function Oe(A,e,r,f){var k=0,n=0,o=0,l=0;i:{e:{if(f){if(f>>>0>=357913942)break e;if(k=g(f,12),f=C(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,(e|0)!=(r|0))for(;;){if(i[f+8>>2]=0,i[f>>2]=0,i[f+4>>2]=0,o=i[e>>2],k=i[e+4>>2],(o|0)!=(k|0)){if(k=k-o|0,(k|0)<0)break i;n=C(k),i[f+4>>2]=n,i[f>>2]=n,l=k+n|0,i[f+8>>2]=l,k&&z(n,o,k),i[f+4>>2]=l}if(f=f+12|0,e=e+12|0,(r|0)==(e|0))break}i[A+4>>2]=f}return}s0(),M()}s0(),M()}function Xl(A,e){var r=0,f=0;if((A|0)==14)return i[e>>2]?22915:21279;if(r=A&65535,f=A>>16,!((r|0)!=65535|(f|0)>5))return A=i[(f<<2)+e>>2],A?A+8|0:21731;A=47881;i:{e:{r:switch(f-1|0){case 0:if(r>>>0>1)break i;A=80432;break e;case 1:if(r>>>0>49)break i;A=80448;break e;case 4:break r;default:break i}if(r>>>0>3)break i;A=80768}if(!r)return A;for(;e=u[A|0],A=A+1|0,!(!e&&(r=r-1|0,!r)););}return A}function IF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;i:{if(k=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,e=i[k>>2],!e)break i;for(;;){if(v4(i[e+4>>2],r)){if(e=i[k+4>>2],k=k+4|0,e)continue;break i}break}if(i[e+8>>2]!=3){e=i[25827],i[A>>2]=i[25826],i[A+4>>2]=e,i[A+8>>2]=i[25828];return}f&&(i[f>>2]=i[e+16>>2]),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680];return}e=i[25827],i[A>>2]=i[25826],i[A+4>>2]=e,i[A+8>>2]=i[25828]}function e4(A,e,r,f,k,n,o,l,s){var h=0,w=0,_=0,B=0;s=L0(e,r,l,s),l=h0,k=L0(f,k,n,o),s=k+s|0,f=h0+l|0,l=k>>>0>s>>>0?f+1|0:f,h=o,k=0,w=r,f=0,r=L0(o,k,r,f),o=r+s|0,s=h0+l|0,_=o,r=r>>>0>o>>>0?s+1|0:s,o=L0(n,0,e,0),l=h0,s=0,f=L0(n,s,w,f),l=l+f|0,n=h0+s|0,n=f>>>0>l>>>0?n+1|0:n,s=n+_|0,f=r,n=n>>>0>s>>>0?f+1|0:f,e=L0(e,B,h,k)+l|0,k=h0,k=e>>>0<l>>>0?k+1|0:k,l=k+s|0,s=n,i[A+8>>2]=l,i[A+12>>2]=k>>>0>l>>>0?s+1|0:s,i[A>>2]=o,i[A+4>>2]=e}function QF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f;i:{if(!(r&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(k=i[e>>2],!u[k+416|0]){if(t[f|0]=0,t[f+11|0]=0,r=a(f+12|0,5,139,f),t[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],c0(k,r,A?A+164|0:0),t[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}e=C(80),i[r>>2]=e,z(e,k+424|0,76),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}v=f+32|0}function VF(A,e){A=A|0,e=e|0;var r=0,f=0;r=i[A>>2],A=i[r+184>>2],r=i[r+188>>2];i:{if((A|0)!=(r|0))for(;;){e:{if(f=i[A>>2],!f||(f=Z0(f,92792,95304),!f))break e;if(r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),e&&(A=p[f+98>>1]|p[f+100>>1]<<16,X[e>>1]=A,X[e+2>>1]=A>>>16),A=1,!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;return W[i[i[r>>2]+8>>2]](r),y(r),1}if(A=A+8|0,(r|0)==(A|0))break}A=0}return A|0}function pF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,h2(r,i[e+100>>2]/90&255),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function T(A,e,r){var f=0,k=0,n=0,o=0;k=v-16|0,v=k;i:{e:{if(r>>>0<11){f=A,t[A+11|0]=u[A+11|0]&128|r&127,t[A+11|0]=u[A+11|0]&127;break e}if(r>>>0>2147483639)break i;o=k+8|0,r>>>0>=11?(n=r+8&-8,f=n-1|0,f=(f|0)==11?n:f):f=10,fe(o,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=r}A=r+1|0,r=!A,r|r||z(f,e,A),v=k+16|0;return}I4(),M()}function FF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=F0(r),i[k+100>>2]=n,k=e,n=w2(r),X[k+104>>1]=n,k=e,n=w2(r),X[k+106>>1]=n;i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function CF(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0;n=v-16|0,v=n,e=i[e>>2],s=i[e+48>>2],e=i[e+52>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),o=C(4),i[n+4>>2]=o,l=o+4|0,i[n+12>>2]=l,i[o>>2]=k,i[n+8>>2]=l,o8(s,f,r,n+4|0),r=i[n+4>>2],r&&(i[n+8>>2]=r,Z(r));i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680],v=n+16|0}function M2(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0,h=0;f=v-16|0,v=f,X1(f+8|0,A);i:{if(!u[f+8|0]||(n=f+4|0,k=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[n>>2]=k,(k|0)!=136824&&(i[k+4>>2]=i[k+4>>2]+1),k=$0(n,136688),i2(n),i[f>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],o=i[i[A>>2]-12>>2]+A|0,l=V6(o),s=f,h=W[i[i[k>>2]+28>>2]](k,i[f>>2],o,l,e,r)|0,i[s+4>>2]=h,i[n>>2]))break i;z4(i[i[A>>2]-12>>2]+A|0,5)}return v1(f+8|0),v=f+16|0,A}function YF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-80|0,v=f;i:{k=1;e:{if(i4(A,e,0)||(k=0,!e)||(e=Z0(e,91032,91080),k=0,!e))break e;if(k=i[r>>2],!k)break i;l0(f+24|0,0,56),t[f+75|0]=1,i[f+32>>2]=-1,i[f+28>>2]=A,i[f+20>>2]=e,i[f+68>>2]=1,W[i[i[e>>2]+28>>2]](e,f+20|0,k,1),A=i[f+44>>2],(A|0)==1&&(i[r>>2]=i[f+36>>2]),k=(A|0)==1}return v=f+80|0,k|0}i[f+8>>2]=21998,i[f+4>>2]=485,i[f>>2]=8503,N1(),M()}function yF(A,e,r,f,k,n,o,l){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,i[e+8>>2]!=1){e=i[25827],i[A>>2]=i[25826],i[A+4>>2]=e,i[A+8>>2]=i[25828];return}i:{if(!u[e+16|0]||(k&&(i[k>>2]=i[e+20>>2]),!n))break i;i[n>>2]=i[e+24>>2]}r&&(i[r>>2]=u[e+16|0]),f&&(i[f>>2]=u[e+16|0]),!l|i[e+32>>2]<=0||(i[l>>2]=i[e+28>>2]),o&&(i[o>>2]=i[e+32>>2]),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function EF(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if((r|0)>0)for(l=1<<k-1,_=r&2147483646,B=r&1;;){if(w=g(r,s),n=0,h=0,(r|0)!=1)for(;o=n+w|0,i[(o<<2)+A>>2]=(X[(o<<1)+e>>1]<<f)+l>>k,o=o+1|0,i[(o<<2)+A>>2]=(X[(o<<1)+e>>1]<<f)+l>>k,n=n+2|0,h=h+2|0,(_|0)!=(h|0););if(B&&(n=n+w|0,i[(n<<2)+A>>2]=(X[(n<<1)+e>>1]<<f)+l>>k),s=s+1|0,(s|0)==(r|0))break}}function RF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f;i:{e:{if(k=i[e>>2],!k||(k=Z0(k,113600,113736),!k))break e;if(e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),jA(f+12|0,k,r),t[f+31|0]<0&&Z(i[f+20>>2]),r=i[25787],i[A>>2]=i[25786],i[A+4>>2]=r,i[A+8>>2]=i[25788],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=27105}v=f+32|0}function n2(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=92868,t[A+95|0]<0&&Z(i[A+84>>2]),e=i[A+72>>2],e&&(i[A+76>>2]=e,Z(e)),e=i[A+36>>2],e){if(r=e,f=i[A+40>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+36>>2]}i[A+40>>2]=e,Z(r)}return i[A>>2]=92500,e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),A|0}function Il(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;r=v-16|0,v=r,X1(r+8|0,A);i:{if(!u[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=136824&&(i[f+4>>2]=i[f+4>>2]+1),f=$0(k,136688),i2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,o=V6(n),l=r,s=W[i[i[f>>2]+32>>2]](f,i[r>>2],n,o,+e)|0,i[l+4>>2]=s,i[k>>2]))break i;z4(i[i[A>>2]-12>>2]+A|0,5)}return v1(r+8|0),v=r+16|0,A}function h5(A){var e=0,r=0,f=0,k=0;r=53,k=i[A+24>>2],e=i[A+28>>2],f=k-e|0,e=(((e-((k+6>>>0)%7|0)|0)+7>>>0)/7|0)+((f+369>>>0)%7>>>0<3)|0;i:{if((e|0)!=53){if(r=e,e)break i;r=52;e:switch(((f+6>>>0)%7|0)-4|0){case 1:if(!zs((i[A+20>>2]%400|0)-1|0))break i;break;case 0:break e;default:break i}return 53}e:switch(((f+371>>>0)%7|0)-3|0){case 0:if(zs(i[A+20>>2]))break i;break;case 1:break i;default:break e}r=1}return r}function D0(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;r=v-16|0,v=r,X1(r+8|0,A);i:{if(!u[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=136824&&(i[f+4>>2]=i[f+4>>2]+1),f=$0(k,136688),i2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,o=V6(n),l=r,s=W[i[i[f>>2]+16>>2]](f,i[r>>2],n,o,e)|0,i[l+4>>2]=s,i[k>>2]))break i;z4(i[i[A>>2]-12>>2]+A|0,5)}return v1(r+8|0),v=r+16|0,A}function B0(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;r=v-16|0,v=r,X1(r+8|0,A);i:{if(!u[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=136824&&(i[f+4>>2]=i[f+4>>2]+1),f=$0(k,136688),i2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,o=V6(n),l=r,s=W[i[i[f>>2]+24>>2]](f,i[r>>2],n,o,e)|0,i[l+4>>2]=s,i[k>>2]))break i;z4(i[i[A>>2]-12>>2]+A|0,5)}return v1(r+8|0),v=r+16|0,A}function i1(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;r=v-16|0,v=r,X1(r+8|0,A);i:{if(!u[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=136824&&(i[f+4>>2]=i[f+4>>2]+1),f=$0(k,136688),i2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,o=V6(n),l=r,s=W[i[i[f>>2]+12>>2]](f,i[r>>2],n,o,e)|0,i[l+4>>2]=s,i[k>>2]))break i;z4(i[i[A>>2]-12>>2]+A|0,5)}return v1(r+8|0),v=r+16|0,A}function t4(A,e){var r=0,f=0,k=0,n=0,o=0,l=0,s=0;r=v-16|0,v=r,X1(r+8|0,A);i:{if(!u[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=136824&&(i[f+4>>2]=i[f+4>>2]+1),f=$0(k,136688),i2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,o=V6(n),l=r,s=W[i[i[f>>2]+32>>2]](f,i[r>>2],n,o,e)|0,i[l+4>>2]=s,i[k>>2]))break i;z4(i[i[A>>2]-12>>2]+A|0,5)}return v1(r+8|0),v=r+16|0,A}function j8(A,e){var r=0,f=0,k=0;if((e|0)<=8){if(!e)return 0;f=i[A+16>>2]<<e,i[A+16>>2]=f,r=p[A+20>>1]+e|0,X[A+20>>1]=r,r=r<<16>>16;i:{if((r|0)<0||(k=i[A+4>>2],k>>>0>=o0[A+8>>2]))break i;i[A+4>>2]=k+1,k=u[k|0],X[A+20>>1]=r-8,f=k<<r|f}return k=i[A+12>>2]<<7,r=(f>>>0)/(k>>>0)|0,e=1<<e,(r|0)>=(e|0)&&(r=e-1|0),i[A+16>>2]=f-g(r,k),r}for(f=e-8|0,e=nu(A);e=B4(A)|e<<1,f=f-1|0,!!f;);return e}function JF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0,h=0,w=0;if(!(k&1)){if(!((n|0)<=0|(k|0)<=0))for(;;){for(s=g(e,l)+A|0,h=(g(f,l)<<1)+r|0,w=0;o=X[h>>1]+32>>6,o=(o|0)>=255?255:o,t[s|0]=(o|0)>0?o:0,o=X[h+2>>1]+32>>6,o=(o|0)>=255?255:o,t[s+1|0]=(o|0)>0?o:0,h=h+4|0,s=s+2|0,w=w+2|0,(w|0)<(k|0););if(l=l+1|0,(l|0)==(n|0))break}return}U0(23827,19896,40,11132),M()}function NF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0;f=v-16|0,v=f,o=df()|0;i:{if(!e||(r=T5(e),(r|0)<=0)||(n=f-((r<<2)+15&-16)|0,v=n,l=rl(e,n,r),(l|0)<=0))break i;for(e=0;i[f+8>>2]=e,k=f+8|0,r=T1(91512,k|0)|0,i[f+8>>2]=i[(e<<2)+n>>2],k=T1(91524,k|0)|0,q4(o|0,r|0,k|0),k>>>0>=9&&g1(k|0),r>>>0>=9&&g1(r|0),e=e+1|0,(l|0)!=(e|0););}i[A+4>>2]=o,i[A>>2]=132616,v=f+16|0}function Ql(A,e){var r=0,f=0,k=0,n=0,o=0;k=v-16|0,v=k,o=i[33178],i[e+72>>2]<=0&&l7(e),i[33178]=i[e+136>>2],r=-1,i[e+4>>2]||(fr(e),f=!i[e+4>>2]);i:{if(f|(A|0)==-1||(f=J3(k+12|0,A),(f|0)<0)||(n=i[e+4>>2],n>>>0<(f+i[e+44>>2]|0)-8>>>0))break i;e:{if(A>>>0<=127){r=n-1|0,i[e+4>>2]=r,t[r|0]=A;break e}r=n-f|0,i[e+4>>2]=r,v8(r,k+12|0,f)}i[e>>2]=i[e>>2]&-17,r=A}return i[33178]=o,v=k+16|0,(r|0)!=-1}function DF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,h2(r,u[e+100|0]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function UF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,p[e+98>>1]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function Vl(A,e){var r=0,f=0,k=0;i:{e:{if(r=i[e+36>>2],f=i[e+40>>2],(r|0)!=(f|0)){if(e=i[r>>2],e&&(k=i[A+4>>2],e=Z0(e,92792,93636),e))break e;if(r=r+8|0,(f|0)!=(r|0))for(;;){if(e=i[r>>2],e&&(k=0,e=Z0(e,92792,93636),e))break e;if(r=r+8|0,(f|0)==(r|0))break}i[A>>2]=0,i[A+4>>2]=0}i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+4>>2]=k,i[A>>2]=e,e=A,A=i[r+4>>2],i[e+4>>2]=A,!A)break i;i[A+4>>2]=i[A+4>>2]+1}}function MF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,M4(r,e+104|0,1),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function HF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,M4(r,e+100|0,0),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function zF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]),k=e,n=Q2(r),t[k+104|0]=n;i:{if(u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function xF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F4(r,e+120|0),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function pl(A,e){var r=0,f=0,k=0,n=0,o=0;i:{r=i[A+4>>2],k=i[A>>2],n=r-k|0;e:{if(n>>>0<e>>>0){if(o=e-n|0,f=i[A+8>>2],o>>>0<=f-r>>>0){o&&l0(r,0,o),i[A+4>>2]=r+o;return}if((e|0)<0)break i;if(r=f-k|0,f=r<<1,f=r>>>0>=1073741823?2147483647:e>>>0<f>>>0?f:e,r=C(f),o&&l0(r+n|0,0,o),n&&z(r,k,n),i[A+8>>2]=r+f,i[A+4>>2]=e+r,i[A>>2]=r,!k)break e;Z(k);return}if(e>>>0>=n>>>0)break e;i[A+4>>2]=e+k}return}s0(),M()}function Fl(A,e){var r=0,f=0,k=0;i:{if((A|0)!=(e|0)){r=i[e+4>>2];e:{if(!r){r=0;break e}if(i[A+8>>2]<<5>>>0<r>>>0){if(f=i[A>>2],f&&(Z(f),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+4>>2]),(r|0)<0)break i;r=(r-1>>>5|0)+1|0,f=C(r<<2),i[A+8>>2]=r,i[A+4>>2]=0,i[A>>2]=f,r=i[e+4>>2]}if(f=i[e>>2],k=(f+(r-1>>>3&536870908)|0)+4|0,(k|0)==(f|0))break e;r=k-f|0,r&&z(i[A>>2],f,r),r=i[e+4>>2]}i[A+4>>2]=r}return}s0(),M()}function Pe(A,e,r){var f=D(0),k=D(0),n=D(0),o=D(0),l=0,s=D(0);l=v-16|0,v=l,Et(l+8|0,e,r),f=E0[l+12>>2],k=E0[l+8>>2];i:{if(!(f!=D(0)|k!=D(0))){k=D(-.714136004447937),f=D(-.34413599967956543),n=D(1.7719999551773071),o=D(1.4019999504089355);break i}o=D(D(1)-k),s=D(D(f+k)+D(-1)),k=D(D(D(k+k)*o)/s),n=D(D(1)-f),f=D(D(D(f+f)*n)/s),n=D(n+n),o=D(o+o)}E0[A+16>>2]=n,E0[A+12>>2]=k,E0[A+8>>2]=f,E0[A+4>>2]=o,t[A|0]=1,v=l+16|0}function TF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,f=v-32|0,v=f,S2(f,e,r),t[f+19|0]<0&&Z(i[f+8>>2]);i:{if(u[e+97|0]){B1(A,e,17495);break i}if(u[r+20|0]==1){if(t[f+20|0]=0,t[f+31|0]=0,a(A,2,100,f+20|0),t[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function w5(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f;i:{e:{if(k=i[28767],!k)break e;for(n=115068;o=o0[k+16>>2]<r>>>0,n=o?n:k,k=i[(o?4:0)+k>>2],!!k;);if((n|0)==115068|o0[n+16>>2]>r>>>0)break e;i[e+12>>2]=r,c0(A,114912,0);break i}if(i[e+12>>2]=2,t[f|0]=0,t[f+11|0]=0,e=A,A=a(f+12|0,2,135,f),c0(e,A,0),t[A+19|0]<0&&Z(i[A+8>>2]),t[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function jF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;k=i[A>>2],f=i[k+172>>2],k=i[k+176>>2];i:{if((f|0)!=(k|0))for(n=i[i[A+8>>2]>>2];;){if(A=i[f>>2],i[A>>2]==(n|0)){if(f=i[f+4>>2],!f){f=0;break i}i[f+4>>2]=i[f+4>>2]+1;break i}if(f=f+8|0,(k|0)==(f|0))break}f=0,A=0}e&&(i[e>>2]=i[A+4>>2]),r&&(i[r>>2]=i[A+8>>2]);i:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}}function Cl(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){j1(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,j1(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+8>>2],A?A=t[A+127|0]<0?i[A+116>>2]:A+116|0:A=0,e=i[r+12>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=r+16|0,A|0}function _5(A,e){var r=0,f=0,k=0,n=0,o=0;i:{if(e>>>0<=255){r=i[A+108>>2],f=i[A+112>>2];e:{if(r>>>0<f>>>0){t[r|0]=e,r=r+1|0;break e}if(n=i[A+104>>2],r=r-n|0,k=r+1|0,(k|0)<0)break i;if(f=f-n|0,o=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<o>>>0?o:k,f?k=C(f):k=0,o=k+r|0,t[o|0]=e,r&&z(k,n,r),i[A+112>>2]=f+k,r=o+1|0,i[A+108>>2]=r,i[A+104>>2]=k,!n)break e;Z(n)}i[A+108>>2]=r}return e>>>0<256}s0(),M()}function B5(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f;i:{e:{if(k=i[28761],!k)break e;for(n=115044;o=o0[k+16>>2]<r>>>0,n=o?n:k,k=i[(o?4:0)+k>>2],!!k;);if((n|0)==115044|o0[n+16>>2]>r>>>0)break e;i[e+4>>2]=r,c0(A,114912,0);break i}if(i[e+4>>2]=2,t[f|0]=0,t[f+11|0]=0,e=A,A=a(f+12|0,2,133,f),c0(e,A,0),t[A+19|0]<0&&Z(i[A+8>>2]),t[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function v5(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f;i:{e:{if(k=i[28764],!k)break e;for(n=115056;o=o0[k+16>>2]<r>>>0,n=o?n:k,k=i[(o?4:0)+k>>2],!!k;);if((n|0)==115056|o0[n+16>>2]>r>>>0)break e;i[e+8>>2]=r,c0(A,114912,0);break i}if(i[e+8>>2]=2,t[f|0]=0,t[f+11|0]=0,e=A,A=a(f+12|0,2,134,f),c0(e,A,0),t[A+19|0]<0&&Z(i[A+8>>2]),t[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function Yl(A,e){var r=0,f=0,k=0,n=0;r=v-16|0,v=r,i[r+8>>2]=0,i[r+12>>2]=0,i[r>>2]=0,i[r+4>>2]=0,h4(r,i[e+8>>2],i[e+12>>2]),h2(r,((u[e+17|0]?64:0)|(u[e+16|0]?-128:0)|(u[e+18|0]?32:0))&224),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(f=i[r+4>>2],e=i[r>>2],(f|0)!=(e|0)){if(f=f-e|0,(f|0)<0)break i;k=C(f),i[A>>2]=k,n=f+k|0,i[A+8>>2]=n,f&&z(k,e,f),i[A+4>>2]=n}e&&(i[r+4>>2]=e,Z(e)),v=r+16|0;return}s0(),M()}function Le(A){A=A|0;var e=0,r=0,f=0;i[A>>2]=77264,r=v-16|0,v=r,e=i[A+64>>2],e&&(i[r+4>>2]=2008,e=J1(r+8|0,e,r+4|0),W[i[i[A>>2]+24>>2]](A)|0,f=i[e>>2],i[e>>2]=0,z5(f),i[A+64>>2]=0,W[i[i[A>>2]+12>>2]](A,0,0)|0,f=i[e>>2],i[e>>2]=0,f&&W[i[e+4>>2]](f)|0),v=r+16|0;i:{if(u[A+96|0]!=1||(e=i[A+32>>2],!e))break i;Z(e)}i:{if(u[A+97|0]!=1||(e=i[A+56>>2],!e))break i;Z(e)}return y0(A)|0}function d4(A,e,r,f){var k=0;i:{k=i[e+104>>2],e=i[e+108>>2];e:{if((k|0)!=(e|0))for(;;){if(!(i[k+40>>2]!=(r|0)|i[k+16>>2]!=(f|0))){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,e=i[k+48>>2],r=i[k+44>>2],(e|0)==(r|0))break e;if(e=e-r|0,(e|0)<0)break i;f=C(e),i[A>>2]=f,k=e+f|0,i[A+8>>2]=k,e&&z(f,r,e),i[A+4>>2]=k;return}if(k=k+56|0,(e|0)==(k|0))break}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}return}s0(),M()}function ki(A,e){var r=0,f=0,k=0;r=i[e+60>>2];i:{e:{if(r&16){f=i[e+56>>2],r=i[e+36>>2],f>>>0<r>>>0&&(i[e+56>>2]=r,f=r),e=e+32|0;break e}if(!(r&8)){e=0,t[A+11|0]=0;break i}f=i[e+28>>2],e=e+20|0}e:{if(k=i[e>>2],e=f-k|0,e>>>0<2147483640){if(e>>>0>=11){f=e|7,r=C(f+1|0),i[A+8>>2]=f-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(t[A+11|0]=e,e)break e;e=0;break i}I0(),M()}if(!e)break i;z(A,k,e)}t[A+e|0]=0}function qe(A,e){var r=0,f=0,k=0,n=0,o=0;i:{if((e|0)<=0)break i;for(o=i[A+12>>2]<<7,f=p[A+20>>1],r=i[A+16>>2];;){f=f+1|0,X[A+20>>1]=f,r=r<<1,i[A+16>>2]=r,f=f<<16>>16;e:{if((f|0)<0||(f=65528,X[A+20>>1]=65528,n=i[A+4>>2],n>>>0>=o0[A+8>>2]))break e;i[A+4>>2]=n+1,r=u[n|0]|r,i[A+16>>2]=r}if(r>>>0<o>>>0)break i;if(r=r-o|0,i[A+16>>2]=r,k=k+1|0,(k|0)==(e|0))break}k=e}return(e|0)>(k|0)?k:e}function SF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;return A=v-256|0,v=A,i[A+248>>2]=37,i[A+252>>2]=0,o=A+248|0,F6(o|1,10692,1,i[r+4>>2]),l=e1(),i[A>>2]=k,i[A+4>>2]=n,k=A+224|0,o=X4(k,24,l,o,A)+k|0,s=c4(k,o,r),l=A+20|0,n=i[r+28>>2],i[l>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,s3(n,s,o,k,A+28|0,A+24|0,l),i2(l),e=t6(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+256|0,e|0}function OF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;return A=v-256|0,v=A,i[A+248>>2]=37,i[A+252>>2]=0,o=A+248|0,F6(o|1,10692,0,i[r+4>>2]),l=e1(),i[A>>2]=k,i[A+4>>2]=n,k=A+224|0,o=X4(k,24,l,o,A)+k|0,s=c4(k,o,r),l=A+20|0,n=i[r+28>>2],i[l>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,s3(n,s,o,k,A+28|0,A+24|0,l),i2(l),e=t6(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+256|0,e|0}function PF(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,!(!i[r+4>>2]&i[r>>2]==4)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}i:{if(r=i[r+12>>2],(r|0)==8)f=10;else{if(r-9>>>0>7)break i;f=14}e=C(32),i[e+28>>2]=11,t[e+26|0]=1,X[e+24>>1]=2,i[e+16>>2]=0,i[e+20>>2]=131074,i[e+12>>2]=r,t[e+8|0]=0,i[e+4>>2]=f,i[e>>2]=1,r=e+32|0,i[A+8>>2]=r,i[A+4>>2]=r,i[A>>2]=e;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function LF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;return A=v-112|0,v=A,i[A+104>>2]=37,i[A+108>>2]=0,o=A+104|0,F6(o|1,10692,1,i[r+4>>2]),l=e1(),i[A>>2]=k,i[A+4>>2]=n,k=A+80|0,o=X4(k,24,l,o,A)+k|0,s=c4(k,o,r),l=A+20|0,n=i[r+28>>2],i[l>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,h3(n,s,o,k,A+28|0,A+24|0,l),i2(l),e=o6(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+112|0,e|0}function qF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;return A=v-112|0,v=A,i[A+104>>2]=37,i[A+108>>2]=0,o=A+104|0,F6(o|1,10692,0,i[r+4>>2]),l=e1(),i[A>>2]=k,i[A+4>>2]=n,k=A+80|0,o=X4(k,24,l,o,A)+k|0,s=c4(k,o,r),l=A+20|0,n=i[r+28>>2],i[l>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,h3(n,s,o,k,A+28|0,A+24|0,l),i2(l),e=o6(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+112|0,e|0}function aF(A,e){A=A|0,e=e|0;var r=0,f=0;f=i[e+184>>2],e=i[e+188>>2];i:{if((f|0)==(e|0))break i;for(;;){e:{r:{if(r=i[f>>2],!r||!Z0(r,92792,106196))break r;if(r=i[f+4>>2],!r)break e;i[r+4>>2]=i[r+4>>2]+1;break i}if(f=f+8|0,(e|0)!=(f|0))continue}break}r=0}i[A>>2]=0,i[A+4>>2]=0,t[A+20|0]=0,i[A+8>>2]=0;i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}}function yl(A,e,r,f){var k=0,n=0;i:{if(f>>>0>=3){i[33136]=28;break i}e:{if((f|0)!=1||(k=i[A+8>>2],!k))break e;n=e,k=k-i[A+4>>2]|0,e=e-k|0,r=r-((k>>31)+(k>>>0>n>>>0)|0)|0}if(i[A+20>>2]!=i[A+28>>2]&&(W[i[A+36>>2]](A,0,0)|0,!i[A+20>>2])||(i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,W[i[A+40>>2]](A,e,r,f)|0,(h0|0)<0))break i;return i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=i[A>>2]&-17,0}return-1}function KF(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0;if(i[A>>2]=104068,n=i[A+132>>2],n){if(e=n,r=i[A+136>>2],(e|0)!=(r|0)){for(;;){if(l=r-12|0,f=i[l>>2],f){if(k=f,s=r-8|0,e=i[s>>2],(f|0)!=(e|0)){for(;k=e-12|0,o=i[k>>2],o&&(i[e-8>>2]=o,Z(o)),e=k,(f|0)!=(e|0););k=i[l>>2]}i[s>>2]=f,Z(k)}if(r=r-16|0,(n|0)==(r|0))break}e=i[A+132>>2]}i[A+136>>2]=n,Z(e)}return n2(A)|0}function $F(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-16|0,v=r,k=i[A>>2];i:{e:{if(e){if(f=l2(e),f>>>0>=2147483640)break i;r:{f:{if(f>>>0>=11){n=f|7,A=C(n+1|0),i[r+8>>2]=n-2147483647,i[r>>2]=A,i[r+4>>2]=f;break f}if(t[r+11|0]=f,A=r,!f)break r}if(!f)break r;z(A,e,f)}t[A+f|0]=0;break e}i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0}W[i[i[k>>2]+36>>2]](k,r),t[r+11|0]<0&&Z(i[r>>2]),v=r+16|0;return}I0(),M()}function El(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!e)break i;e:{r:{f:switch(r=u[e|0],f=u[A|0],(r>>>0<f>>>0?r:f)-1|0){case 0:break e;case 1:break r;case 2:break f;default:break i}i[A+40>>2]=i[e+40>>2]}i[A+24>>2]=i[e+24>>2],i[A+28>>2]=i[e+28>>2],i[A+32>>2]=i[e+32>>2],i[A+36>>2]=i[e+36>>2]}i[A+4>>2]=i[e+4>>2],r=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=r,r=i[e+20>>2],i[A+16>>2]=i[e+16>>2],i[A+20>>2]=r}}function dF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;i[A+96>>2]=i[e>>2];i:{e:{if(u[A+112|0]==1){if((A+96|0)==(e|0))break e;r=A+100|0,A=i[e+4>>2],e=i[e+8>>2],W3(r,A,e,e-A>>3);return}if(i[A+108>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,f=i[e+4>>2],e=i[e+8>>2],(f|0)!=(e|0)){if(e=e-f|0,(e|0)<0)break i;r=C(e),i[A+104>>2]=r,i[A+100>>2]=r,k=e+r|0,i[A+108>>2]=k,e&&z(r,f,e),i[A+104>>2]=k}t[A+112|0]=1}return}s0(),M()}function Rl(A,e){var r=0;return i[A+4>>2]=0,i[A+8>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,t[A+36|0]=0,i[A+32>>2]=9e4,i[A+24>>2]=0,i[A+28>>2]=0,i[A+92>>2]=0,i[A+96>>2]=0,i[A+88>>2]=1,i[A+12>>2]=0,i[A+16>>2]=5186,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,r=A- -64|0,i[r>>2]=0,i[r+4>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+80>>2]=0,i[A+84>>2]=0,t[A+100|0]=0,i[A>>2]=113576,l0(A+104|0,0,188),i[A+20>>2]=e,A}function bF(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0,s=0;if(i[A>>2]=104068,n=i[A+132>>2],n){if(e=n,r=i[A+136>>2],(e|0)!=(r|0)){for(;;){if(l=r-12|0,f=i[l>>2],f){if(k=f,s=r-8|0,e=i[s>>2],(f|0)!=(e|0)){for(;k=e-12|0,o=i[k>>2],o&&(i[e-8>>2]=o,Z(o)),e=k,(f|0)!=(e|0););k=i[l>>2]}i[s>>2]=f,Z(k)}if(r=r-16|0,(n|0)==(r|0))break}e=i[A+132>>2]}i[A+136>>2]=n,Z(e)}Z(n2(A))}function cF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function D3(A,e,r){var f=0,k=0,n=0;f=i[r+16>>2];i:{if(!f){if(S5(r))break i;f=i[r+16>>2]}if(k=i[r+20>>2],f-k>>>0<e>>>0)return W[i[r+36>>2]](r,A,e)|0;e:{r:{if(!e|i[r+80>>2]<0)break r;for(f=e;;){if(n=A+f|0,u[n-1|0]!=10){if(f=f-1|0,f)continue;break r}break}if(k=W[i[r+36>>2]](r,A,f)|0,k>>>0<f>>>0)break i;e=e-f|0,k=i[r+20>>2];break e}n=A,f=0}v8(k,n,e),i[r+20>>2]=i[r+20>>2]+e,k=e+f|0}return k}function Jl(A,e,r,f){var k=0,n=0,o=0;k=v-16|0,v=k,o=i[e+48>>2],f=i[i[f>>2]+196>>2],r=i[i[r>>2]+196>>2],e=C(4),i[k+4>>2]=e,n=e+4|0,i[k+12>>2]=n,i[e>>2]=r,i[k+8>>2]=n,o8(o,f,1953000802,k+4|0),e=i[k+4>>2],e&&(i[k+8>>2]=e,Z(e)),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=k+16|0}function iC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=F0(r),i[k+100>>2]=n,k=e,n=F0(r),i[k+104>>2]=n;i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function eC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;return r=v-48|0,v=r,RA(r+12|0,i[A>>2],e),e=0,f=u[r+32|0],f||(e=C(16),k=i[r+12>>2],f=i[r+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+4>>2]=f,i[e>>2]=k,f=i[A>>2],A=i[A+4>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),i[e+12>>2]=A,i[e+8>>2]=f,f=u[r+32|0]),(f|0)!=255&&(A=i[25813],i[r+40>>2]=i[25812],i[r+44>>2]=A,W[i[(r+40|0)+(f<<2)>>2]](r+39|0,r+12|0)),v=r+48|0,e|0}function Nl(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;i:{e:{if(A&&(f=i[A>>2],f))break e;if(A=0,!r)break i;return i[r>>2]=0,0}e:{r:{if(A=i[f+204>>2],f=i[f+208>>2],(A|0)!=(f|0))for(;;){if(k=i[A+4>>2],n=i[A+8>>2],k=ie(k,e,n-k>>2),((k||n)|0)!=i[A+8>>2])break r;if(A=A+56|0,(f|0)==(A|0))break}if(A=0,!r)break e;i[r>>2]=0,A=0;break e}r&&(i[r>>2]=i[A+52>>2]),A=i[A+40>>2]}}return A|0}function rC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=w2(r),X[k+98>>1]=n,k=e,n=w2(r),X[k+100>>1]=n;i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function fC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;n=64920;i:{if(!f)break i;for(;;){if(o=100,f-k>>>0<4){k=7,n=64928;break i}if(n=k+4|0,k=r+k|0,k=u[k|0]|u[k+1|0]<<8|(u[k+2|0]<<16|u[k+3|0]<<24),k=k<<24|(k&65280)<<8|(k>>>8&65280|k>>>24),f-n>>>0<k>>>0){k=7,n=64928;break i}if(o=0,pA(i[e>>2],r+n|0,k,0,0,0),k=k+n|0,!(k>>>0<f>>>0))break}k=0,n=64920}i[A+8>>2]=n,i[A+4>>2]=o,i[A>>2]=k}function AC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;for(var n=0,o=0,l=0,s=0,h=0,w=0;;){i:{if((r|0)==(f|0)|k>>>0<=s>>>0)break i;l=1,n=v-16|0,v=n,i[n+12>>2]=i[A+8>>2],o=C8(n+8|0,n+12|0),h=ze(0,r,f-r|0,e||136652),o=i[o>>2],o&&(i[33178]=(o|0)==-1?132592:o),v=n+16|0;e:switch(h+2|0){default:l=h;break;case 0:case 1:break i;case 2:break e}s=s+1|0,w=l+w|0,r=r+l|0;continue}break}return w|0}function kC(A,e){A=A|0,e=e|0;var r=0,f=0;r=i[A+24>>2],r>>>0>o0[A+44>>2]&&(i[A+44>>2]=r);i:{if(r=i[A+8>>2],f=i[A+12>>2],r>>>0>=f>>>0)break i;if((e|0)==-1)return i[A+16>>2]=i[A+44>>2],i[A+12>>2]=f-1,i[A+8>>2]=r,((e|0)!=-1?e:0)|0;if(f=i[A+12>>2]-1|0,!(u[A+48|0]&16)&u[f|0]!=(e&255))break i;return r=i[A+8>>2],i[A+16>>2]=i[A+44>>2],i[A+12>>2]=f,i[A+8>>2]=r,t[i[A+12>>2]]=e<<24>>24,e|0}return-1}function S2(A,e,r){var f=0,k=0;f=v-16|0,v=f,k=F0(r),i[e+100>>2]=k&16777215,t[e+97|0]=k>>>24,i[e+32>>2]=i[e+32>>2]+4;i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function nC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0;i:{if(f)for(;;){if(s=100,h=7,o=64928,f-n>>>0<4||(l=n+4|0,n=r+n|0,n=u[n|0]|u[n+1|0]<<8|(u[n+2|0]<<16|u[n+3|0]<<24),n=n<<24|(n&65280)<<8|(n>>>8&65280|n>>>24),o=64928,f-l>>>0<n>>>0))break i;if(pA(i[e>>2],r+l|0,n,0,0,k),n=n+l|0,!(n>>>0<f>>>0))break}h=0,s=0,o=64920}i[A+8>>2]=o,i[A+4>>2]=s,i[A>>2]=h}function Dl(A){var e=0;return i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+56>>2]=-1,i[A+60>>2]=-1,i[A+72>>2]=0,i[A+76>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,e=A- -64|0,i[e>>2]=-1,i[e+4>>2]=-1,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,t[A+96|0]=0,i[A+16>>2]=1634563685,i[A>>2]=92664,A}function tC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0,h=0;if((r|0)>0)for(s=r&2147483646,h=r&1;;){if(f=0,k=0,l=0,(r|0)!=1)for(;o=g(r,f)+n|0,k=X[(o<<1)+e>>1]+k|0,i[(o<<2)+A>>2]=k,o=g(f|1,r)+n|0,k=k+X[(o<<1)+e>>1]|0,i[(o<<2)+A>>2]=k,f=f+2|0,l=l+2|0,(s|0)!=(l|0););if(h&&(f=g(r,f)+n|0,i[(f<<2)+A>>2]=X[(f<<1)+e>>1]+k),n=n+1|0,(n|0)==(r|0))break}}function oC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-48|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,0),u2(r,0),u2(r,p[e+98>>1]),Pl(f+28|0,e,r),t[f+47|0]<0&&Z(i[f+36>>2]),n1(f+8|0,e,r,k),t[f+27|0]<0&&Z(i[f+16>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+48|0}function Ul(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){j1(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,j1(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+8>>2],A?A=u[A+164|0]:A=1,e=i[r+12>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=r+16|0,A|0}function Ml(A){var e=0,r=0,f=0;r=i[A+8>>2],r&&W[r|0](),e=i[28739];i:{e:{if(!e){f=114956,r=114956;break e}for(;;){if(r=e,e=i[e+16>>2],e>>>0>A>>>0){if(f=r,e=i[r>>2],e)continue;break e}if(A>>>0<=e>>>0)break i;if(e=i[r+4>>2],!e)break}f=r+4|0}e=C(20),i[e+8>>2]=r,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=A,i[f>>2]=e,A=i[i[28738]>>2],A&&(i[28738]=A),G1(i[28739],e),i[28740]=i[28740]+1}}function Hl(A,e,r,f){var k=0,n=0,o=0;k=v-16|0,v=k;i:{e:{if((A|0)!=(e|0)){o=i[33136],i[33136]=0,e1(),A=Fi(A,k+12|0,f,0,-2147483648),f=h0,n=i[33136];r:{if(n){if(i[k+12>>2]!=(e|0))break r;if((n|0)==68)break e;break i}if(i[33136]=o,i[k+12>>2]==(e|0))break i}}i[r>>2]=4,A=0,f=0;break i}if(i[r>>2]=4,!!A&(f|0)>=0|(f|0)>0){A=-1,f=2147483647;break i}A=0,f=-2147483648}return v=k+16|0,h0=f,A}function zl(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;k=v-16|0,v=k,n=i[A+4>>2],f=i[r>>2]-i[A>>2]|0;i:{if(f>>>0<2147483647){f=f<<1;break i}f=-1}if(o=f>>>0<=1?1:f,l=i[e>>2],s=i[A>>2],f=f3((n|0)!=2127?i[A>>2]:0,o),f){(n|0)!=2127&&(i[A>>2]=0),i[k+4>>2]=2126,f=J1(k+8|0,f,k+4|0),Ss(A,f),n=i[f>>2],i[f>>2]=0,n&&W[i[f+4>>2]](n),i[e>>2]=i[A>>2]+(l-s|0),i[r>>2]=o+i[A>>2],v=k+16|0;return}N1(),M()}function lC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;n=f,e=i[e+72>>2];i:{if(u[e+103|0]){o=2,k=0;break i}if(f=u[e+104|0],e=u[e+105|0],k=1,(f|0)==1&(e|0)==1||(k=2,!(e|(f|0)!=1)))break i;k=e|f?99:3}if(i[n>>2]=k,i[r>>2]=o,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function w4(A,e){var r=0,f=0,k=0;if(r=i[A+16>>2],r>>>0<e>>>0){if(r){if(e=i[A+8>>2],e){for(;i[e+16>>2]=i[e+16>>2]-r,e=i[e+8>>2],!!e;);r=i[A+16>>2]}f=i[A>>2],e=W[i[i[f>>2]+8>>2]](f)|0,k=h0,e=e+r|0,k=e>>>0<r>>>0?k+1|0:k,W[i[i[f>>2]+20>>2]](f,e,k)|0,i[A+16>>2]=0}return t[A+20|0]=1,0}f=i[A+8>>2];i:{if(f){if(r=0,!w4(f,e))break i;r=i[A+16>>2]}i[A+16>>2]=r-e,r=1}return r}function uC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0;return A=v-144|0,v=A,i[A+136>>2]=37,i[A+140>>2]=0,n=A+136|0,F6(n|1,10984,1,i[r+4>>2]),o=e1(),i[A>>2]=k,k=A+123|0,o=X4(k,13,o,n,A)+k|0,s=c4(k,o,r),l=A+4|0,n=i[r+28>>2],i[l>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,s3(n,s,o,k,A+12|0,A+8|0,l),i2(l),e=t6(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A+144|0,e|0}function sC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0;return A=v-144|0,v=A,i[A+136>>2]=37,i[A+140>>2]=0,n=A+136|0,F6(n|1,10984,0,i[r+4>>2]),o=e1(),i[A>>2]=k,k=A+123|0,o=X4(k,13,o,n,A)+k|0,s=c4(k,o,r),l=A+4|0,n=i[r+28>>2],i[l>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,s3(n,s,o,k,A+12|0,A+8|0,l),i2(l),e=t6(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A+144|0,e|0}function xl(A,e,r){var f=0,k=0,n=D(0),o=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0)){o=i[33136],i[33136]=0,e1(),f=v-16|0,v=f,E5(f,A,k+12|0,0),n=Ut(i[f>>2],i[f+4>>2],i[f+8>>2],i[f+12>>2]),v=f+16|0;f:{if(A=i[33136],A){if(i[k+12>>2]==(e|0))break f;break r}if(i[33136]=o,i[k+12>>2]!=(e|0))break r;break i}if((A|0)!=68)break i;break e}i[r>>2]=4;break i}n=D(0)}i[r>>2]=4}return v=k+16|0,n}function hC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;k=v-80|0,v=k;i:{if(!(f&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];break i}if(n=k+8|0,o=i[e>>2],W[i[i[o>>2]+152>>2]](n,o),z(f,n,72),r&&(En(n,i[e>>2],f),r=i[k+8>>2],r&&c0(A,n,i[e+8>>2]),t[k+27|0]<0&&Z(i[k+16>>2]),r))break i;e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}v=k+80|0}function Mi(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;k=v-16|0,v=k,n=i[A+4>>2],f=i[r>>2]-i[A>>2]|0;i:{if(f>>>0<2147483647){f=f<<1;break i}f=-1}if(o=f||4,l=i[e>>2],s=i[A>>2],f=f3((n|0)!=2127?i[A>>2]:0,o),f){(n|0)!=2127&&(i[A>>2]=0),i[k+4>>2]=2126,f=J1(k+8|0,f,k+4|0),Ss(A,f),n=i[f>>2],i[f>>2]=0,n&&W[i[f+4>>2]](n),i[e>>2]=i[A>>2]+(l-s|0),i[r>>2]=i[A>>2]+(o&-4),v=k+16|0;return}N1(),M()}function K2(A,e){var r=0,f=0,k=0;i:{if(r=oh(e),f=u[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:1,u[A+11|0]>>>7|0?k=i[A+4>>2]:k=u[A+11|0]&127,r>>>0<=f>>>0){u[A+11|0]>>>7|0?f=i[A>>2]:f=A;e:{if(!r||(k=r<<2,!k))break e;z(f,e,k)}e=v-16|0,v=e;e:if(u[A+11|0]>>>7|0)break e;J6(A,r),i[e+12>>2]=0,i[f+(r<<2)>>2]=i[e+12>>2],v=e+16|0;break i}Pt(A,f,r-f|0,k,0,k,r,e)}}function wC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;if(!(f&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}i:{if(k=i[e>>2],e=i[k+80>>2],k=i[k+84>>2],(e|0)!=(k|0))for(;;){if(i[e>>2]==(r|0))break i;if(e=e+44|0,(k|0)==(e|0))break}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=25536;return}H2(e+32|0,f),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}function Tl(A,e){A=A|0,e=e|0;var r=0;if((e|0)<8)return 3;i:{e:{if(u[A+4|0]!=102|u[A+5|0]!=116|(u[A+6|0]!=121|u[A+7|0]!=112))break e;if(e>>>0<12)return 3;r=1,A=Su(A,e);r:{if((A|0)<=1781689192){if((A|0)==1635150182|(A|0)==1751476579)break e;if((A|0)!=1751476600)break r;break e}if(A-1835623985>>>0<2)break i;if((A|0)==1781689193|(A|0)==1785750887)break e}r=2}return r|0}return 3}function _C(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,p[e+104>>1]),u2(r,p[e+106>>1]),u2(r,p[e+108>>1]),u2(r,p[e+110>>1]),n1(f+12|0,e,r,k),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function m5(A,e,r){var f=0,k=0;i:{f=i[e+100>>2],e=i[e+104>>2];e:{if((f|0)!=(e|0))for(;;){if(i[f>>2]==(r|0)){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,e=i[f+8>>2],r=i[f+4>>2],(e|0)==(r|0))break e;if(e=e-r|0,(e|0)<0)break i;f=C(e),i[A>>2]=f,k=e+f|0,i[A+8>>2]=k,e&&z(f,r,e),i[A+4>>2]=k;return}if(f=f+16|0,(e|0)==(f|0))break}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}return}s0(),M()}function BC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0;return A=v+-64|0,v=A,i[A+56>>2]=37,i[A+60>>2]=0,n=A+56|0,F6(n|1,10984,1,i[r+4>>2]),o=e1(),i[A>>2]=k,k=A+43|0,o=X4(k,13,o,n,A)+k|0,s=c4(k,o,r),l=A+4|0,n=i[r+28>>2],i[l>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,h3(n,s,o,k,A+12|0,A+8|0,l),i2(l),e=o6(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A- -64|0,e|0}function vC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0;return A=v+-64|0,v=A,i[A+56>>2]=37,i[A+60>>2]=0,n=A+56|0,F6(n|1,10984,0,i[r+4>>2]),o=e1(),i[A>>2]=k,k=A+43|0,o=X4(k,13,o,n,A)+k|0,s=c4(k,o,r),l=A+4|0,n=i[r+28>>2],i[l>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,h3(n,s,o,k,A+12|0,A+8|0,l),i2(l),e=o6(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A- -64|0,e|0}function F0(A){var e=0,r=0,f=0;r=v-16|0,v=r;i:{if(!w4(A,4))break i;f=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(W[i[i[f>>2]+16>>2]](f,r+12|0,4)|0)){h8(A),f=0;break e}A=u[r+12|0]|u[r+13|0]<<8|(u[r+14|0]<<16|u[r+15|0]<<24),f=A<<24|(A&65280)<<8|(A>>>8&65280|A>>>24)}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=r+16|0,f}function mC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(A=i[A>>2],f=i[A+248>>2],r=i[A+252>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),f){A=i[f+100>>2],f=i[f+104>>2];i:{if((A|0)!=(f|0))for(;;){if(k=i[A+8>>2]-i[A+4>>2]>>2,i[A>>2]==(e|0))break i;if(A=A+16|0,(f|0)==(A|0))break}k=0}A=k}else A=0;i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;W[i[i[r>>2]+8>>2]](r),y(r)}return A|0}function jl(A,e,r,f){var k=0,n=0;if((e|0)!=(r|0))for(;;){i:{if((e|0)==(f|0)){t[f+12|0]=u[e+12|0];break i}k=i[e>>2],n=i[e+4>>2],h1(f,k,n,n-k>>2),t[f+12|0]=u[e+12|0],k=i[e+16>>2],n=i[e+20>>2],h1(f+16|0,k,n,n-k>>2),k=i[e+28>>2],n=i[e+32>>2],h1(f+28|0,k,n,n-k>>2),k=i[e+40>>2],n=i[e+44>>2],W3(f+40|0,k,n,n-k>>3)}if(f=f+52|0,e=e+52|0,(r|0)==(e|0))break}i[A+4>>2]=f,i[A>>2]=e}function Sl(A,e,r){var f=0,k=0,n=0,o=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0)){o=i[33136],i[33136]=0,e1(),f=v-16|0,v=f,E5(f,A,k+12|0,1),n=TA(i[f>>2],i[f+4>>2],i[f+8>>2],i[f+12>>2]),v=f+16|0;f:{if(A=i[33136],A){if(i[k+12>>2]==(e|0))break f;break r}if(i[33136]=o,i[k+12>>2]!=(e|0))break r;break i}if((A|0)!=68)break i;break e}i[r>>2]=4;break i}n=0}i[r>>2]=4}return v=k+16|0,n}function ZC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=zr()|0;i:{if(!e){i[A+4>>2]=k,i[A>>2]=132616;break i}OA(f+8|0,e,r,f+20|0);e:{if(i[f+8>>2]){e=C(12),i[e+8>>2]=i[f+16>>2],r=i[f+12>>2],i[e>>2]=i[f+8>>2],i[e+4>>2]=r,i[f+24>>2]=e,e=T1(102748,f+24|0)|0;break e}i[f+24>>2]=i[f+20>>2],e=T1(102824,f+24|0)|0}if(i[A+4>>2]=e,i[A>>2]=132616,k>>>0<9)break i;g1(k|0)}v=f+32|0}function gC(A){A=A|0;var e=0,r=0,f=0,k=0;f=-1,e=i[A+184>>2],A=i[A+188>>2];i:{if((e|0)==(A|0))break i;for(;;){e:{r:{if(r=i[e>>2],!r||(r=Z0(r,92792,107188),!r))break r;if(A=i[e+4>>2],A)break e;return u[r+104|0]}if(e=e+8|0,(A|0)!=(e|0))continue;break i}break}if(e=i[A+4>>2],k=e+1|0,i[A+4>>2]=k,f=u[r+104|0],i[A+4>>2]=e,k)break i;W[i[i[A>>2]+8>>2]](A),y(A)}return f|0}function GC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=g(Q2(r)&3,90),i[k+100>>2]=n;i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function WC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;i:{if(!A||(r=i[A>>2],A=i[r+120>>2],k=i[r+116>>2],(A|0)==(k|0)))break i;for(A=(A-k|0)/28|0,n=A>>>0<=1?1:A,r=0;;){if(f=g(r,28)+k|0,A=i[f>>2],f=i[f+4>>2],(A|0)==(f|0))return r|0;e:{for(;;){if(i[A>>2]!=(e|0)){if(A=A+4|0,(f|0)!=(A|0))continue;break e}break}return r|0}if(r=r+1|0,(n|0)==(r|0))break}}return-1}function XC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0;n=v-16|0,v=n;i:{if(f&&(A=0,(k|0)<=0))break i;m3(n+4|0,e,r),o=i[n+8>>2],r=i[n+4>>2],e=o-r>>2;e:{r:{if(!f){A=e;break r}if(A=0,(r|0)==(o|0)|(k|0)<=0)break r;for(;;){if(o=A<<2,i[o+f>>2]=i[r+o>>2],A=A+1|0,(k|0)<=(A|0))break e;if(!(A>>>0<e>>>0))break}break e}if(!r)break i}Z(r)}return v=n+16|0,A|0}function IC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(p[f+24>>1]|!(i[r>>2]==1&(i[r+4>>2]&-2)==10)||(r=u[f+26|0],!r))break i;k=u[f+8|0],f=i[f+20>>2],e=C(32),i[e+28>>2]=11,t[e+26|0]=r,X[e+24>>1]=0,i[e+20>>2]=f,i[e+12>>2]=8,i[e+16>>2]=0,t[e+8|0]=k,i[e>>2]=0,i[e+4>>2]=3,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function Z5(A){var e=0,r=0,f=0;f=v-16|0,v=f,j2(+A),r=o2(1)|0,o2(0)|0,r=r&2147483647;i:{if(r>>>0<=1072243195){if(e=1,r>>>0<1044816030)break i;e=Ar(A,0);break i}if(e=A-A,r>>>0>=2146435072)break i;r=q9(A,f),A=u0[f+8>>3],e=u0[f>>3];e:switch((r&3)-1|0){default:e=Ar(e,A);break i;case 0:e=-ce(e,A,1);break i;case 1:e=-Ar(e,A);break i;case 2:break e}e=ce(e,A,1)}return v=f+16|0,e}function O4(A,e,r){var f=0,k=0;i:{if(!i[e>>2]){A=0;break i}if(P0(A+184|0,e),f=i[A+180>>2],k=i[f+48>>2],f=i[f+52>>2],!f){A=a3(k,i[A+196>>2],e,r);break i}if(i[f+4>>2]=i[f+4>>2]+1,A=a3(k,i[A+196>>2],e,r),r=i[f+4>>2],i[f+4>>2]=r-1,r)break i;W[i[i[f>>2]+8>>2]](f),y(f)}e=i[e+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A}function QC(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=104576;i:{if(u[A+64|0]!=1||(r=i[A+32>>2],r&&(i[A+36>>2]=r,Z(r)),r=i[A+20>>2],!r))break i;if(e=r,f=i[A+24>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+20>>2]}i[A+24>>2]=r,Z(e)}return A|0}function VC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r,f=zr()|0;i:{if(!e){i[A+4>>2]=f,i[A>>2]=132616;break i}Yt(r+8|0,e,r+20|0);e:{if(i[r+8>>2]){e=C(12),i[e+8>>2]=i[r+16>>2],k=i[r+12>>2],i[e>>2]=i[r+8>>2],i[e+4>>2]=k,i[r+24>>2]=e,e=T1(102748,r+24|0)|0;break e}i[r+24>>2]=i[r+20>>2],e=T1(102824,r+24|0)|0}if(i[A+4>>2]=e,i[A>>2]=132616,f>>>0<9)break i;g1(f|0)}v=r+32|0}function pC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0;return A=v-208|0,v=A,n=e1(),i[A>>2]=k,o=A+176|0,s=X4(o,20,n,8644,A),l=o+s|0,h=c4(o,l,r),k=A+16|0,n=i[r+28>>2],i[k>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=$0(k,137e3),i2(k),W[i[i[n>>2]+48>>2]](n,o,l,k)|0,n=e,e=k+(s<<2)|0,e=t6(n,k,(l|0)==(h|0)?e:((h-A<<2)+A|0)-688|0,e,r,f),v=A+208|0,e|0}function FC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=Q2(r)&1,i[k+100>>2]=n;i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function g5(A){var e=0,r=0,f=0;r=v-16|0,v=r,j2(+A),e=o2(1)|0,o2(0)|0,e=e&2147483647;i:{if(e>>>0<=1072243195){if(e>>>0<1045430272)break i;A=ce(A,0,0);break i}if(e>>>0>=2146435072){A=A-A;break i}e=q9(A,r),A=u0[r+8>>3],f=u0[r>>3];e:switch((e&3)-1|0){default:A=ce(f,A,1);break i;case 0:A=Ar(f,A);break i;case 1:A=-ce(f,A,1);break i;case 2:break e}A=-Ar(f,A)}return v=r+16|0,A}function Ol(A,e,r){var f=0,k=0,n=0,o=0,l=0,s=0;if(t[A+44|0]=1,t[A|0]=1,Ct(A,e),(r|0)>=2){for(k=r-1|0,o=A+52|0;n=g(f,52)+o|0,l=n,s=G0(e,1),t[l|0]=s,l=n,s=G0(e,1),t[l+44|0]=s,f=f+1|0,(k|0)!=(f|0););if(r-2>>>0<7)for(f=k;ei(e,2),f=f+1|0,(f|0)!=8;);for(A=A+52|0,f=0;Ct(A+g(f,52)|0,e),f=f+1|0,(k|0)!=(f|0););}}function CC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=w2(r),X[k+98>>1]=n;i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function YC(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=105696;i:{if(u[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}return A|0}function yC(A,e){A=A|0,e=e|0;var r=0,f=0;i:{r=i[A>>2],f=i[r+48>>2],A=i[r+52>>2];e:{if(!A){$r(f);break e}if(i[A+4>>2]=i[A+4>>2]+1,$r(f),f=i[A+4>>2],i[A+4>>2]=f-1,f)break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[r+48>>2],r=i[A+160>>2],A=i[A+164>>2],!A){i[r+120>>2]=e;break i}i[A+4>>2]=i[A+4>>2]+1,i[r+120>>2]=e,e=i[A+4>>2],i[A+4>>2]=e-1,e||(W[i[i[A>>2]+8>>2]](A),y(A))}}function EC(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=105328;i:{if(u[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}return A|0}function Pl(A,e,r){var f=0,k=0;i:{if(f=i[e+36>>2],e=i[e+40>>2],(f|0)!=(e|0))for(;;){if(k=i[f>>2],W[i[i[k>>2]+20>>2]](A,k,r),i[A>>2])break i;if(t[A+19|0]<0&&Z(i[A+8>>2]),f=f+8|0,(e|0)==(f|0))break}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}}function RC(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=104576;i:{if(u[A+64|0]!=1||(r=i[A+32>>2],r&&(i[A+36>>2]=r,Z(r)),r=i[A+20>>2],!r))break i;if(e=r,f=i[A+24>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+20>>2]}i[A+24>>2]=r,Z(e)}Z(A)}function JC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=Q2(r),t[k+97|0]=n;i:{if(u[r+20|0]==1){if(t[f+4|0]=0,t[f+15|0]=0,a(A,2,100,f+4|0),t[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+16|0}function Ll(A,e){var r=0,f=0,k=0,n=0;r=u[e+144|0],f=u[e+136|0],k=u[e+128|0],n=u[e+97|0],H0(A,0,2),H0(A,n,1),H0(A,k,1),H0(A,f,1),H0(A,r,1),H0(A,0,2),(n|0)==1&&(H0(A,i[e+100>>2],32),H0(A,i[e+112>>2],32),H0(A,i[e+104>>2],32),H0(A,i[e+116>>2],32),H0(A,i[e+108>>2],32),H0(A,i[e+120>>2],32)),k&&H0(A,i[e+124>>2],32),f&&H0(A,i[e+132>>2],32),r&&H0(A,i[e+140>>2],32)}function ni(A,e){var r=0,f=0,k=0,n=0,o=0;k=i[A+36>>2],o=i[A+40>>2];i:{if((k|0)!=(o|0))for(;;){f=i[(r<<3)+k>>2];e:{if(!f||(n=i[e>>2],!n|i[f+36>>2]!=i[f+40>>2]|i[n+36>>2]!=i[n+40>>2]))break e;if(W[i[i[f>>2]+32>>2]](f,n)|0)break i;k=i[A+36>>2],o=i[A+40>>2]}if(r=r+1|0,!(r>>>0<o-k>>3>>>0))break}P0(A+36|0,e),r=(i[A+40>>2]-i[A+36>>2]>>3)-1|0}return r}function NC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0,s=0,h=0;return A=v-96|0,v=A,n=e1(),i[A>>2]=k,o=A- -64|0,s=X4(o,20,n,8644,A),l=o+s|0,h=c4(o,l,r),k=A+16|0,n=i[r+28>>2],i[k>>2]=n,(n|0)!=136824&&(i[n+4>>2]=i[n+4>>2]+1),n=$0(k,137008),i2(k),W[i[i[n>>2]+32>>2]](n,o,l,k)|0,n=e,e=k+s|0,e=o6(n,k,(l|0)==(h|0)?e:((h-A|0)+A|0)-48|0,e,r,f),v=A+96|0,e|0}function G5(A,e){var r=0,f=0,k=0,n=0;n=v-32|0,v=n,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=i[e+32>>2];i:{if(e=i[e+28>>2],(k|0)!=(e|0)){if(r=k-e|0,(r|0)<0)break i;for(f=C(r),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+r;i[f>>2]=i[e>>2],r=i[e+4>>2],i[f+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f=f+8|0,e=e+8|0,(k|0)!=(e|0););i[A+4>>2]=f}v=n+32|0;return}s0(),M()}function ae(A,e,r){var f=0,k=0,n=0,o=0,l=0;n=v-16|0,v=n,f=u[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:10,u[A+11|0]>>>7|0?k=i[A+4>>2]:k=u[A+11|0]&127;i:{if(f-k>>>0>=r>>>0){if(o=!r,o)break i;u[A+11|0]>>>7|0?f=i[A>>2]:f=A,l=f+k|0,o||z(l,e,r),e=r+k|0,J6(A,e),t[n+15|0]=0,t[e+f|0]=u[n+15|0];break i}De(A,f,(r-f|0)+k|0,k,k,0,r,e)}return v=n+16|0,A}function DC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,i[e+104>>2]),p0(r,i[e+108>>2]),p0(r,i[e+112>>2]),n1(f+12|0,e,r,k),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function ql(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=105696;i:{if(u[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}Z(A)}function X8(A,e){var r=0,f=0,k=0;if(r=i[A+140>>2],!r)return 0;for(f=A+140|0,A=f;k=o0[r+16>>2]<e>>>0,A=k?A:r,r=i[(k?4:0)+r>>2],!!r;);r=0;i:{if((A|0)==(f|0)|o0[A+16>>2]>e>>>0||(e=i[A+20>>2],A=i[A+24>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),r=e?i[e+112>>2]:0,!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return r}function U3(A,e,r){var f=0,k=0;for(r&2048&&(t[A|0]=43,A=A+1|0),r&1024&&(t[A|0]=35,A=A+1|0),f=r&260,(f|0)!=260&&(t[A|0]=46,t[A+1|0]=42,A=A+2|0),r=r&16384;;){if(k=u[e|0],k){t[A|0]=k,A=A+1|0,e=e+1|0;continue}break}i:{e:{if((f|0)!=256){if((f|0)!=4)break e;e=r?70:102;break i}e=r?69:101;break i}if(e=r?65:97,(f|0)==260)break i;e=r?71:103}return t[A|0]=e,(f|0)!=260}function UC(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=105328;i:{if(u[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}Z(A)}function MC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,p0(r,u[e+105|0]<<30|u[e+104|0]<<31|u[e+106|0]<<26),n1(f+12|0,e,r,k),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function HC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;n=v-16|0,v=n;i:{if((f|0)<=0&&r)break i;m3(n+4|0,A,e),o=i[n+8>>2],e=i[n+4>>2],A=o-e>>2;e:{r:{if(!r){k=A;break r}if((e|0)==(o|0)|(f|0)<=0)break r;for(;;){if(o=k<<2,i[o+r>>2]=i[e+o>>2],k=k+1|0,(k|0)>=(f|0))break e;if(!(A>>>0>k>>>0))break}break e}if(!e)break i}Z(e)}return v=n+16|0,k|0}function zC(A,e,r,f,k){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,i4(A,i[e+8>>2],k)){i[e+28>>2]==1|i[e+4>>2]!=(r|0)||(i[e+28>>2]=f);return}i:{if(!i4(A,i[e>>2],k))break i;if(!(i[e+16>>2]!=(r|0)&i[e+20>>2]!=(r|0))){if((f|0)!=1)break i;i[e+32>>2]=1;return}i[e+20>>2]=r,i[e+32>>2]=f,i[e+40>>2]=i[e+40>>2]+1,i[e+36>>2]!=1|i[e+24>>2]!=2||(t[e+54|0]=1),i[e+44>>2]=4}}function xC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;A=i[A>>2],r=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),f=i[r+28>>2],r=i[r+32>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}i[f+100>>2]=e,Q3(f,e);i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}}function TC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;f=v-16|0,v=f;i:{r=i[e+72>>2];e:{if(r){if(i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,e=0,n=i[r+104>>2],r=i[r+100>>2],(n|0)!=(r|0)){if(e=n-r|0,(e|0)<0)break i;k=C(e),e&&z(k,r,e),e=e+k|0}t[A+20|0]=0,i[A+8>>2]=e,i[A+4>>2]=e,i[A>>2]=k;break e}i[A>>2]=0,i[A+4>>2]=0,t[A+20|0]=0,i[A+8>>2]=0}v=f+16|0;return}s0(),M()}function jC(A){return A=A|0,u[137092]?i[34272]:(u[137576]||(t[137576]=1),K2(137408,89852),K2(137420,89880),K2(137432,89908),K2(137444,89940),K2(137456,89980),K2(137468,90016),K2(137480,90044),K2(137492,90080),K2(137504,90096),K2(137516,90112),K2(137528,90128),K2(137540,90144),K2(137552,90160),K2(137564,90176),t[137092]=1,i[34272]=137408,137408)}function SC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,S2(k+12|0,e,r),t[k+31|0]<0&&Z(i[k+20>>2]);i:{if(!u[e+97|0]){n=w2(r);break i}n=F0(r)}i:{if(!n){if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731]);break i}Xi(A,e,r,n,f)}v=k+32|0}function Ke(A){var e=0,r=0,f=0;if(e=i[A+184>>2],A=i[A+188>>2],(e|0)==(A|0))return 0;i:{for(;;){e:{if(r=i[e>>2],!r||(r=Z0(r,92792,92812),!r))break e;if(A=i[e+4>>2],A)break i;return i[r+108>>2]}if(e=e+8|0,(A|0)==(e|0))break}return 0}return e=i[A+4>>2],f=e+1|0,i[A+4>>2]=f,r=i[r+108>>2],i[A+4>>2]=e,f||(W[i[i[A>>2]+8>>2]](A),y(A)),r}function $e(A){var e=0,r=0,f=0;if(e=i[A+184>>2],A=i[A+188>>2],(e|0)==(A|0))return 0;i:{for(;;){e:{if(r=i[e>>2],!r||(r=Z0(r,92792,92812),!r))break e;if(A=i[e+4>>2],A)break i;return i[r+104>>2]}if(e=e+8|0,(A|0)==(e|0))break}return 0}return e=i[A+4>>2],f=e+1|0,i[A+4>>2]=f,r=i[r+104>>2],i[A+4>>2]=e,f||(W[i[i[A>>2]+8>>2]](A),y(A)),r}function OC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;if(f=v-16|0,v=f,k=i[r>>2],k>>>0<2147483640){o=i[A>>2];i:{e:{if(k>>>0>=11){n=k|7,A=C(n+1|0),i[f+12>>2]=n-2147483647,i[f+4>>2]=A,i[f+8>>2]=k;break e}if(t[f+15|0]=k,A=f+4|0,!k)break i}if(!k)break i;z(A,r+4|0,k)}t[A+k|0]=0,W[o|0](e,f+4|0),t[f+15|0]<0&&Z(i[f+4>>2]),v=f+16|0;return}I0(),M()}function PC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(!(i[r>>2]!=1|(i[r+4>>2]&-2)!=12)&&(r=i[r+12>>2],(r|0)>8))break i;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}f=u[f+8|0],e=C(32),i[e+28>>2]=11,t[e+26|0]=1,X[e+24>>1]=2,i[e+20>>2]=131074,i[e+16>>2]=r,i[e+12>>2]=r,t[e+8|0]=f,i[e>>2]=1,i[e+4>>2]=3,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function al(A){A=A|0;var e=0,r=0,f=0,k=0;for(i[A>>2]=84136,k=A+8|0;;){if(e=i[A+8>>2],i[A+12>>2]-e>>2>>>0>r>>>0){e=i[e+(r<<2)>>2],e&&(f=i[e+4>>2]-1|0,i[e+4>>2]=f,(f|0)==-1&&W[i[i[e>>2]+8>>2]](e)),r=r+1|0;continue}break}return _2(A+144|0),e=v-16|0,v=e,i[e+12>>2]=k,r=i[e+12>>2],i[r>>2]&&(Xw(r),rh(i[e+12>>2]+12|0,i[i[e+12>>2]>>2])),v=e+16|0,A|0}function LC(A){A=A|0;var e=0,r=0;r=A+12|0,e=i[r+8496>>2],e&&(i[r+8500>>2]=e,Z(e)),e=i[r+8484>>2],e&&(i[r+8488>>2]=e,Z(e)),e=i[r+8472>>2],e&&(i[r+8476>>2]=e,Z(e)),e=i[r+8460>>2],e&&(i[r+8464>>2]=e,Z(e)),e=i[r+8448>>2],e&&(i[r+8452>>2]=e,Z(e)),A=i[A+20>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function Kl(A,e,r){var f=0,k=0,n=0;i:{e:{if(u[A+46|0]){if(k=i[A+48>>2],(k|0)>0)break e;break i}return!(e|r)}for(n=A+8360|0;;){if(i[(f<<2)+n>>2]!=(e|0)){if(f=f+1|0,(k|0)!=(f|0))continue;break i}break}if(f=0,e=i[A+52>>2],(e|0)<=0)return 0;for(A=A+8404|0;k=i[A+(f<<2)>>2]==(r|0),!k&&(f=f+1|0,(e|0)!=(f|0)););return k}return 0}function qC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;return k=i[A+84>>2],n=i[k>>2],f=i[k+4>>2],l=i[A+28>>2],o=i[A+20>>2]-l|0,o=f>>>0<o>>>0?f:o,o&&(v8(n,l,o),n=o+i[k>>2]|0,i[k>>2]=n,f=i[k+4>>2]-o|0,i[k+4>>2]=f),f=r>>>0>f>>>0?f:r,f&&(v8(n,e,f),n=f+i[k>>2]|0,i[k>>2]=n,i[k+4>>2]=i[k+4>>2]-f),t[n|0]=0,e=i[A+44>>2],i[A+28>>2]=e,i[A+20>>2]=e,r|0}function W5(A,e,r,f){var k=0,n=0,o=0,l=0;k=v-48|0,v=k,n=i[i[A>>2]-12>>2]+A|0,o=i[n+16>>2]&-3,M1(n,o),lr(k+47|0,A),u[k+47|0]&&(n=k+24|0,l=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],W[i[i[l>>2]+16>>2]](n,l,e,r,f,8),e=k+8|0,i[e+8>>2]=-1,i[e+12>>2]=-1,i[e>>2]=0,i[e+4>>2]=0,z4(i[i[A>>2]-12>>2]+A|0,i[e+8>>2]==i[n+8>>2]&i[n+12>>2]==i[e+12>>2]?o|4:o)),v=k+48|0}function $l(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e,A=i[A>>2],f=i[A+72>>2],r=t[A+79|0];i:{if(!((r|0)<0?f:r))break i;e:{if((r|0)>=0){i[e+8>>2]=i[A+76>>2],r=i[A+72>>2],i[e>>2]=i[A+68>>2],i[e+4>>2]=r;break e}T(e,i[A+68>>2],f)}if(A=t[e+11|0],r=(A|0)<0,k=C((r?i[e+4>>2]:A)+1|0),f=i[e>>2],k=u8(k,r?f:e),(A|0)>=0)break i;Z(f)}return v=e+16|0,k|0}function dl(A,e,r){var f=0,k=0,n=0,o=0;if(f=v-16|0,v=f,n=i[r>>2],o=i[e>>2],r=l2(16355),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=C(k+1|0),i[f+12>>2]=k-2147483647,i[f+4>>2]=e,i[f+8>>2]=r;break e}if(t[f+15|0]=r,e=f+4|0,!r)break i}if(!r)break i;z(e,16355,r)}t[e+r|0]=0,a(A,o,n,f+4|0),t[f+15|0]<0&&Z(i[f+4>>2]),v=f+16|0;return}I0(),M()}function aC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if((r|0)!=31)for(w=r+5|0,s=1<<r;;){for(_=A+o|0,B=(o<<1)+e|0,k=0,l=0;l=((X[(k<<r<<1)+B>>1]<<w)+2048>>12)+l|0,h=g(f,k)+_|0,n=l+u[h|0]|0,n=(n|0)>=255?255:n,t[h|0]=(n|0)>0?n:0,k=k+1|0,(s|0)!=(k|0););if(o=o+1|0,(s|0)==(o|0))break}}function KC(A){A=A|0;var e=0,r=0;r=v-16|0,v=r;i:{if(i[A+80>>2]!=i[A+84>>2])break i;if(e=i[A+564>>2],(e|0)==i[A+568>>2]){UA(A);break i}$1(r+8|0,i[A+180>>2],i[e>>2],1),e=i[r+8>>2];e:{if(e&&Fn(A,e,i[e+200>>2],i[e+204>>2]))break e;UA(A)}if(A=i[r+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=r+16|0}function $C(A){return A=A|0,u[137084]?i[34270]:(u[137400]||(t[137400]=1),H2(137232,1761),H2(137244,1768),H2(137256,1734),H2(137268,1742),H2(137280,1725),H2(137292,1775),H2(137304,1752),H2(137316,8722),H2(137328,9960),H2(137340,13247),H2(137352,19475),H2(137364,3380),H2(137376,11383),H2(137388,4790),t[137084]=1,i[34270]=137232,137232)}function dC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,r=i[e+16>>2],i[f>>2]=i[e+12>>2],i[f+4>>2]=r,e=f+16|0,M3(e,19533,f),r=l2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,!r)break i}if(!r)break i;z(A,f+16|0,r)}t[A+r|0]=0,v=f+128|0;return}I0(),M()}function bC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0,l=0,s=0,h=0,w=0,_=0,B=0;if((r|0)!=31)for(w=r+5|0,s=1<<r;;){for(_=g(f,o)+A|0,B=(o<<r<<1)+e|0,k=0,l=0;l=((X[(k<<1)+B>>1]<<w)+2048>>12)+l|0,h=k+_|0,n=l+u[h|0]|0,n=(n|0)>=255?255:n,t[h|0]=(n|0)>0?n:0,k=k+1|0,(s|0)!=(k|0););if(o=o+1|0,(s|0)==(o|0))break}}function X5(A){var e=0,r=0;if(e=v-16|0,v=e,i[(i[i[A>>2]-12>>2]+A|0)+24>>2]){i[e+12>>2]=A,t[e+8|0]=0,i[(i[i[A>>2]-12>>2]+A|0)+16>>2]||(r=i[(i[i[A>>2]-12>>2]+A|0)+72>>2],r&&X5(r),t[e+8|0]=1);i:{if(!u[e+8|0]||(r=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],(W[i[i[r>>2]+24>>2]](r)|0)!=-1))break i;z4(i[i[A>>2]-12>>2]+A|0,1)}v1(e+8|0)}v=e+16|0}function I5(A,e,r,f){t[A+53|0]=1;i:{if(i[A+4>>2]!=(r|0))break i;t[A+52|0]=1,r=i[A+16>>2];e:{if(!r){if(i[A+36>>2]=1,i[A+24>>2]=f,i[A+16>>2]=e,(f|0)!=1)break i;if(i[A+48>>2]==1)break e;break i}if((e|0)==(r|0)){if(r=i[A+24>>2],(r|0)==2&&(i[A+24>>2]=f,r=f),i[A+48>>2]!=1)break i;if((r|0)==1)break e;break i}i[A+36>>2]=i[A+36>>2]+1}t[A+54|0]=1}}function cC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0,s=0;if(s=i[e+12>>2],i[e+12>>2]=i[A+120>>2],f=i[A+128>>2],n=i[A+132>>2],(f|0)!=(n|0))for(;;){k=i[f+4>>2],o=i[f>>2],l=r+o|0,k=r>>>0>l>>>0?k+1|0:k;i:{if(!u[A+97|0]){if((k|0)==1|k>>>0>1){p0(e,0);break i}p0(e,r+o|0);break i}h4(e,l,k)}if(f=f+8|0,(n|0)==(f|0))break}i[e+12>>2]=s}function _4(A,e){i:{if((e|0)>=1024){if(A=A*898846567431158e293,e>>>0<2047){e=e-1023|0;break i}A=A*898846567431158e293,e=(e>>>0>=3069?3069:e)-2046|0;break i}if((e|0)>-1023)break i;if(A=A*2004168360008973e-307,e>>>0>4294965304){e=e+969|0;break i}A=A*2004168360008973e-307,e=(e>>>0<=4294964336?-2960:e)+1938|0}return T2(0,0),T2(1,e+1023<<20),A*+s1()}function iY(A){A=A|0;var e=0,r=0;if(A){e=i[A+20>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}}function eY(A,e){A=A|0,e=e|0;var r=0,f=0;A=i[A>>2],r=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),f=i[r+28>>2],r=i[r+32>>2];i:{if(!r){Q3(f,e);break i}if(i[r+4>>2]=i[r+4>>2]+1,Q3(f,e),e=i[r+4>>2],i[r+4>>2]=e-1,e)break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function bl(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;f=A+18548|0,r=W2(f,i[A+18572>>2]+150|0),k=1,n=W2(f,i[A+18572>>2]+150|0),o=1,r&&(o=!W2(f,i[A+18572>>2]+151|0)),n&&(k=!W2(f,i[A+18572>>2]+151|0)),r&&(r=-1,o||(r=dA(f,1)),l=B4(f)?65534-r|0:r+2|0),e=(e<<2)+A|0,n?(r=-1,k||(r=dA(f,1)),A=B4(f)?65534-r|0:r+2|0):A=0,X[e+20>>1]=A,X[e+18>>1]=l}function rY(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if(r=v-16|0,v=r,f=i[e>>2],f>>>0<2147483640){i:{e:{if(f>>>0>=11){n=f|7,k=C(n+1|0),i[r+12>>2]=n-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break e}if(t[r+15|0]=f,k=r+4|0,!f)break i}if(!f)break i;z(k,e+4|0,f)}return t[f+k|0]=0,A=W[A|0](r+4|0)|0,t[r+15|0]<0&&Z(i[r+4>>2]),v=r+16|0,A|0}I0(),M()}function fY(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,!(f&&e)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}if(e=i[e>>2],!u[e+112|0]){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=26643;return}r=g(p[e+98>>1],p[e+96>>1]);i:{if(!r||(r=r<<3,!r))break i;z(f,i[e+100>>2],r)}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function AY(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if(r=v-16|0,v=r,bt(r+4|0,i[A>>2],e),k=i[r+8>>2],e=i[r+4>>2],e){if(A=e,(e|0)!=(k|0)){for(A=k;;){f=i[A-4>>2];i:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break i;W[i[i[f>>2]+8>>2]](f),y(f)}if(A=A-8|0,(e|0)==(A|0))break}A=i[r+4>>2]}i[r+8>>2]=e,Z(A)}return v=r+16|0,k-e>>3}function cl(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0;e=v-16|0,v=e,k=e+16|0;i:{for(;;){if(f=i[A+36>>2],r=e+8|0,n=W[i[i[f>>2]+20>>2]](f,i[A+40>>2],r,k,e+4|0)|0,f=-1,o=r,r=i[e+4>>2]-r|0,(r4(o,1,r,i[A+32>>2])|0)!=(r|0))break i;e:switch(n-1|0){case 1:break i;case 0:continue;default:break e}break}f=Q6(i[A+32>>2])?-1:0}return v=e+16|0,f|0}function V6(A){var e=0,r=0,f=0;return u[A+80|0]||(r=v-16|0,v=r,f=r+12|0,e=i[A+28>>2],i[f>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(f,137008),e=W[i[i[e>>2]+28>>2]](e,32)|0,i2(f),v=r+16|0,t[A+76|0]=e,t[A+77|0]=e>>>8,t[A+78|0]=e>>>16,t[A+79|0]=e>>>24,t[A+80|0]=1),(u[A+76|0]|u[A+77|0]<<8|(u[A+78|0]<<16|u[A+79|0]<<24))<<24>>24}function Q5(A){var e=0,r=0,f=0;e=i[A+12>>2]-2|0,i[A+12>>2]=e,f=1,r=i[A+16>>2],e=e<<7;i:{if(r>>>0>=e>>>0||(f=0,e>>>0>32767)||(r=r<<1,i[A+16>>2]=r,i[A+12>>2]=e>>>6,e=p[A+20>>1]+1|0,X[A+20>>1]=e,(e|0)==(e&65535))||(X[A+20>>1]=65528,e=i[A+4>>2],e>>>0>=o0[A+8>>2]))break i;i[A+4>>2]=e+1,i[A+16>>2]=r+u[e|0]}return f}function V5(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(e=v-16|0,v=e,G5(e+4|0,i[A>>2]),k=i[e+8>>2],f=i[e+4>>2],f){if(A=f,(k|0)!=(A|0)){for(A=k;;){r=i[A-4>>2];i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=A-8|0,(f|0)==(A|0))break}A=i[e+4>>2]}i[e+8>>2]=f,Z(A)}return v=e+16|0,k-f>>3}function S8(A,e,r,f){var k=0,n=0,o=0,l=0;k=v-16|0,v=k,i[k+12>>2]=e,i[k+8>>2]=f,o=C8(k+4|0,k+12|0),e=v-16|0,v=e,f=i[k+8>>2],i[e+12>>2]=f,i[e+8>>2]=f,n=-1,f=S3(0,0,r,f);i:{if((f|0)<0||(l=A,f=f+1|0,A=E2(f),i[l>>2]=A,!A))break i;n=S3(A,f,r,i[e+12>>2])}return v=e+16|0,A=i[o>>2],A&&(i[33178]=(A|0)==-1?132592:A),v=k+16|0,n}function kY(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,!(!(i[r>>2]!=1|(i[r+4>>2]&-2)!=10)&i[r+12>>2]==8)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}r=u[f+8|0],e=C(32),i[e+28>>2]=11,t[e+26|0]=1,X[e+24>>1]=2,i[e+20>>2]=131074,i[e+12>>2]=8,i[e+16>>2]=8,t[e+8|0]=r,i[e>>2]=1,i[e+4>>2]=3,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function nY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;return f=i[A+44>>2],k=i[A+40>>2],o=r+k|0,f=o>>>0<r>>>0?f+1|0:f,n=i[A+36>>2],l=i[A+32>>2],(f|0)==(n|0)&l>>>0>=o>>>0|f>>>0<n>>>0&&(r&&z(e,i[A+24>>2]+k|0,r),k=i[A+44>>2],e=r+i[A+40>>2]|0,k=e>>>0<r>>>0?k+1|0:k,i[A+40>>2]=e,i[A+44>>2]=k),(f|0)==(n|0)&o>>>0<=l>>>0|f>>>0<n>>>0}function tY(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,!(!i[r+4>>2]&i[r>>2]==2)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}f=u[r+8|0],k=i[r+16>>2],r=i[r+12>>2],e=C(32),i[e+28>>2]=6,t[e+26|0]=1,X[e+24>>1]=2,i[e+20>>2]=131074,i[e+12>>2]=r,i[e+16>>2]=k,t[e+8|0]=f,i[e>>2]=0,i[e+4>>2]=1,r=e+32|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function oY(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0,l=0;if(r=i[A>>2],A=i[r+340>>2],k=i[r+344>>2],(A|0)==(k|0))return 0;i:{if(!e){r=((k-A|0)-8>>>3|0)+1|0;break i}for(n=l2(e),r=0;f=i[A>>2],o=t[f+15|0],l=(o|0)<0,((l?i[f+8>>2]:o)|0)==(n|0)&&(r=!N2(l?i[f+4>>2]:f+4|0,e,n)+r|0),A=A+8|0,(k|0)!=(A|0););}return r|0}function Hi(A){var e=0,r=0,f=0;r=v-16|0,v=r;i:{if(!w4(A,2))break i;f=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(W[i[i[f>>2]+16>>2]](f,r+14|0,2)|0)){h8(A),f=0;break e}A=u[r+14|0]|u[r+15|0]<<8,f=A<<8|A>>>8}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=r+16|0,f<<16>>16}function w2(A){var e=0,r=0,f=0;r=v-16|0,v=r;i:{if(!w4(A,2))break i;f=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(W[i[i[f>>2]+16>>2]](f,r+14|0,2)|0)){h8(A),f=0;break e}A=u[r+14|0]|u[r+15|0]<<8,f=A<<8|A>>>8}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=r+16|0,f&65535}function lY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f,t[f+12|0]=0,t[f+23|0]=0,e=ml(e,r),e&&H2(f+12|0,e),e=t[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=E2(e+4|0),i[k>>2]=e,e&&z(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,o=T1(102728,f+24|0)|0,i[n+4>>2]=o,i[A>>2]=132616,t[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function uY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,h2(r,u[e+104|0]),n1(f+12|0,e,r,k),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function sY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f,t[f+12|0]=0,t[f+23|0]=0,e=Zl(e,r),e&&H2(f+12|0,e),e=t[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=E2(e+4|0),i[k>>2]=e,e&&z(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,o=T1(102728,f+24|0)|0,i[n+4>>2]=o,i[A>>2]=132616,t[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function hY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f,t[f+12|0]=0,t[f+23|0]=0,e=gl(e,r),e&&H2(f+12|0,e),e=t[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=E2(e+4|0),i[k>>2]=e,e&&z(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,o=T1(102728,f+24|0)|0,i[n+4>>2]=o,i[A>>2]=132616,t[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function wY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0;f=v-32|0,v=f,t[f+12|0]=0,t[f+23|0]=0,e=Cl(e,r),e&&H2(f+12|0,e),e=t[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=E2(e+4|0),i[k>>2]=e,e&&z(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,o=T1(102728,f+24|0)|0,i[n+4>>2]=o,i[A>>2]=132616,t[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function iu(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,M4(r,e+104|0,1),n1(f+12|0,e,r,k),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function _Y(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,h2(r,u[e+97|0]),n1(f+12|0,e,r,k),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function BY(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e;i:{if(!A){A=0;break i}A=i[A+8>>2];e:{if(t[A+15|0]>=0){i[e+8>>2]=i[A+12>>2],r=i[A+8>>2],i[e>>2]=i[A+4>>2],i[e+4>>2]=r;break e}T(e,i[A+4>>2],i[A+8>>2])}if(r=t[e+11|0],A=(r|0)<0,k=C((A?i[e+4>>2]:r)+1|0),f=i[e>>2],A=u8(k,A?f:e),(r|0)>=0)break i;Z(f)}return v=e+16|0,A|0}function vY(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(n=v-16|0,v=n,e=i[A+652>>2],e&&(i[A+656>>2]=e,Z(e)),e=i[A+640>>2],e&&(i[A+644>>2]=e,Z(e)),e=i[A+604>>2],e){if(r=e,f=i[A+608>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+604>>2]}i[A+608>>2]=e,Z(r)}v=n+16|0}function mY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F4(r,e+100|0),n1(f+12|0,e,r,k),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function ZY(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(e=i[A+104>>2],f=i[A+108>>2],(e|0)!=(f|0))for(;;){if(o0[e+40>>2]>65535){t[A+97|0]=1;return}r=i[e+44>>2],k=i[e+48>>2];i:{if((r|0)==(k|0))break i;for(;;){if(o0[r>>2]<65536){if(r=r+4|0,(k|0)!=(r|0))continue;break i}break}n=1}if(e=e+56|0,(f|0)==(e|0))break}t[A+97|0]=n}function gY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;n=v-16|0,v=n,k=i[A>>2],A=0,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0;i:{if(f=i[k+360>>2],k=i[k+356>>2],(f|0)==(k|0))f=0;else{if(f=f-k|0,(f|0)<0)break i;A=C(f),f&&z(A,k,f),f=A+f|0}return f=f-A>>2,f=(r|0)<(f|0)?r:f,r=f<<2,r&&z(e,A,r),A&&Z(A),v=n+16|0,f|0}s0(),M()}function GY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;n=v-16|0,v=n,k=i[A>>2],A=0,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0;i:{if(f=i[k+544>>2],k=i[k+540>>2],(f|0)==(k|0))f=0;else{if(f=f-k|0,(f|0)<0)break i;A=C(f),f&&z(A,k,f),f=A+f|0}return f=f-A>>2,f=(r|0)<(f|0)?r:f,r=f<<2,r&&z(e,A,r),A&&Z(A),v=n+16|0,f|0}s0(),M()}function p5(A,e,r,f,k){var n=0,o=0,l=0,s=0;o=v-16|0,v=o,n=o+12|0,e=i[e+28>>2],i[n>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(n,137e3),W[i[i[e>>2]+48>>2]](e,83888,83916,r)|0,e=$0(n,137072),l=f,s=W[i[i[e>>2]+12>>2]](e)|0,i[l>>2]=s,l=k,s=W[i[i[e>>2]+16>>2]](e)|0,i[l>>2]=s,W[i[i[e>>2]+20>>2]](A,e),i2(n),v=o+16|0}function F5(A,e,r,f,k){var n=0,o=0,l=0,s=0;o=v-16|0,v=o,n=o+12|0,e=i[e+28>>2],i[n>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(n,137008),W[i[i[e>>2]+32>>2]](e,83888,83916,r)|0,e=$0(n,137064),l=f,s=W[i[i[e>>2]+12>>2]](e)|0,t[l|0]=s,l=k,s=W[i[i[e>>2]+16>>2]](e)|0,t[l|0]=s,W[i[i[e>>2]+20>>2]](A,e),i2(n),v=o+16|0}function eu(A,e,r){var f=0,k=0,n=0;k=i[e>>2],n=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,f=i[A+4>>2],i[A>>2]=k,i[A+4>>2]=n;i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;W[i[i[f>>2]+8>>2]](f),y(f)}t[A+8|0]=1,i[A+32>>2]=r,A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function ru(A,e,r){var f=0,k=0,n=0;if(f=i[r+72>>2],i[r+72>>2]=f-1|f,f=i[r+4>>2],k=i[r+8>>2],(f|0)==(k|0)?f=e:(n=f,f=k-f|0,f=e>>>0>f>>>0?f:e,v8(A,n,f),i[r+4>>2]=f+i[r+4>>2],A=A+f|0,f=e-f|0),f)for(;;){i:{if(!fr(r)&&(k=W[i[r+32>>2]](r,A,f)|0,k))break i;return e-f|0}if(A=A+k|0,f=f-k|0,!f)break}return e}function WY(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,i[f>>2]=i[e+12>>2],e=f+16|0,M3(e,19553,f),r=l2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,!r)break i}if(!r)break i;z(A,f+16|0,r)}t[A+r|0]=0,v=f+128|0;return}I0(),M()}function XY(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,i[f>>2]=i[e+12>>2],e=f+16|0,M3(e,19580,f),r=l2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,!r)break i}if(!r)break i;z(A,f+16|0,r)}t[A+r|0]=0,v=f+128|0;return}I0(),M()}function IY(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,i[f>>2]=i[e+8>>2],e=f+16|0,M3(e,19564,f),r=l2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,!r)break i}if(!r)break i;z(A,f+16|0,r)}t[A+r|0]=0,v=f+128|0;return}I0(),M()}function QY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;i:{e:{if(A=i[A+4>>2],f=i[A+168>>2],e=e>>f,(e|0)<0||(k=i[A+172>>2],(e|0)>=(k|0)))break e;if(r=r>>f,(r|0)<0|(r|0)>=i[A+176>>2])break i;return A=(i[A+160>>2]+g(e,3)|0)+g(g(r,k),3)|0,(u[A|0]|u[A+1|0]<<8)>>>3&7}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function j1(A,e,r){var f=0,k=0,n=0;i:{f=i[e+140>>2];e:{if(!f)break e;for(k=e+140|0,e=k;n=o0[f+16>>2]<r>>>0,e=n?e:f,f=i[(n?4:0)+f>>2],!!f;);if((e|0)==(k|0))break e;if(o0[e+16>>2]<=r>>>0)break i}i[A>>2]=0,i[A+4>>2]=0;return}i[A>>2]=i[e+20>>2],r=A,A=i[e+24>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function C2(A,e,r){var f=0,k=0;i:{e:{if(!r)break e;if(f=i[A+164>>2],(f|0)>0){for(k=A+84|0,r=0;;){if(i[(r<<2)+k>>2]==(e|0))break i;if(r=r+1|0,(f|0)==(r|0))break}if((f|0)>19)break e}i[A+164>>2]=f+1,i[((f<<2)+A|0)+84>>2]=e}if(r=i[A+80>>2],(r|0)==20){i[A+76>>2]=1001;return}i[A+80>>2]=r+1,i[(r<<2)+A>>2]=e}}function fu(A,e){var r=0,f=0;r=v-32|0,v=r,i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0,lr(r+31|0,e),u[r+31|0]&&(f=i[(i[i[e>>2]-12>>2]+e|0)+24>>2],W[i[i[f>>2]+16>>2]](r+8|0,f,0,0,1,8),f=i[r+20>>2],i[A+8>>2]=i[r+16>>2],i[A+12>>2]=f,f=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=f,z4(i[i[e>>2]-12>>2]+e|0,0)),v=r+32|0}function VY(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0,l=0;if(e=i[A+104>>2],k=i[A+108>>2],(e|0)!=(k|0)){for(;;){if(l=o0[e>>2]>65535,r=i[e+4>>2],n=i[e+8>>2],(r|0)!=(n|0))for(;o=p[r+2>>1]>127|o,r=r+4|0,(n|0)!=(r|0););if(f=l?1:f,e=e+16|0,(k|0)==(e|0))break}r=f,f=o&1}i[A+100>>2]=f,t[A+97|0]=r}function C5(A,e){var r=0,f=0,k=0,n=0;k=v-16|0,v=k,e&&(r=u[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:10,u[A+11|0]>>>7|0?f=i[A+4>>2]:f=u[A+11|0]&127,r-f>>>0<e>>>0&&f5(A,r,(e-r|0)+f|0,f,f),u[A+11|0]>>>7|0?r=i[A>>2]:r=A,d5(r+f|0,e,0),n=A,A=e+f|0,J6(n,A),t[k+15|0]=0,t[A+r|0]=u[k+15|0]),v=k+16|0}function Au(A,e){var r=0;r=v-16|0,v=r;i:{if(u[e+20|0]==1){if(t[r+4|0]=0,t[r+15|0]=0,a(A,2,100,r+4|0),t[r+15|0]>=0)break i;Z(i[r+4>>2]);break i}if(e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=r+16|0}function b4(A,e){var r=0,f=0,k=0,n=0;f=v-16|0,v=f;i:{if(!e){e=0;break i}r=e>>31,k=(r^e)-r|0,r=_1(k),g4(f,k,0,0,0,r+81|0),k=0+i[f+8>>2]|0,r=(i[f+12>>2]^65536)+(16414-r<<16)|0,r=k>>>0<n>>>0?r+1|0:r,e=(e|0)<0,k=0|k,n=(e?-2147483648:0)|r,r=i[f+4>>2],e=i[f>>2]}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=k,i[A+12>>2]=n,v=f+16|0}function pY(A,e){A=A|0,e=e|0;var r=0;i[A+8>>2]=1,i[A>>2]=1,i[A+4>>2]=1,i[A+36>>2]=0,r=i[e+200>>2],i[A+12>>2]=r,e=i[e+204>>2],i[A+40>>2]=0,i[A+44>>2]=0,i[A+24>>2]=e,i[A+20>>2]=r,i[A+16>>2]=e,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,e=A- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,t[A+36|0]=0}function Y5(A,e,r){var f=0,k=0,n=0;f=i[A>>2],k=f+r&536870911,i[A>>2]=k,i[A+4>>2]=i[A+4>>2]+(f>>>0>k>>>0)+(r>>>29),f=f&63;i:{if(f){if(n=A+24|0,k=f+n|0,f=64-f|0,f>>>0>r>>>0){if(!r)break i;z(k,e,r);return}f&&z(k,e,f),Pr(A,n,64),r=r-f|0,e=e+f|0}if(r>>>0>=64&&(e=Pr(A,e,r&-64),r=r&63),!r)break i;z(A+24|0,e,r)}}function FY(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;return o=v-32|0,v=o,l=i[21031],i[o+24>>2]=i[21030],i[o+28>>2]=l,l=i[21029],i[o+16>>2]=i[21028],i[o+20>>2]=l,l=i[21027],i[o+8>>2]=i[21026],i[o+12>>2]=l,l=i[21025],i[o>>2]=i[21024],i[o+4>>2]=l,l=A,A=o+32|0,e=n6(l,e,r,f,k,n,o,A),v=A,e|0}function CY(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e,A=i[A>>2];i:{if(t[A+267|0]>=0){i[e+8>>2]=i[A+264>>2],r=i[A+260>>2],i[e>>2]=i[A+256>>2],i[e+4>>2]=r;break i}T(e,i[A+256>>2],i[A+260>>2])}return A=t[e+11|0],r=(A|0)<0,f=r?i[e+4>>2]:A,f&&(k=u8(C(f+1|0),r?i[e>>2]:e)),(A|0)<0&&Z(i[e>>2]),v=e+16|0,k|0}function y5(A,e){var r=0,f=0,k=0;if(e>>>0>8){for(e=e>>>0<=4?4:e,f=A>>>0<=1?1:A;;){i:{if(A=0,r=(e+f|0)-1&0-e,k=r>>>0<f>>>0?f:r,r=v-16|0,v=r,(k>>>0)%(e>>>0)|e&3||(A=_3(r+12|0,e,k),A=A?0:i[r+12>>2]),v=r+16|0,A||(r=i[34639],!r))break i;W[r|0]();continue}break}return A||I4(),A}return C(A)}function YY(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(A=i[e+12>>2],A&&(i[e+16>>2]=A,Z(A)),A=i[e>>2],A){if(r=A,f=i[e+4>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(A|0)==(f|0))break}r=i[e>>2]}i[e+4>>2]=A,Z(r)}}function yY(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=112904,f=i[A+124>>2],f){if(e=f,r=i[A+128>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-12|0,(r|0)==(f|0))break}e=i[A+124>>2]}i[A+128>>2]=f,Z(e)}return n2(A)|0}function EY(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=111816,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}return n2(A)|0}function M3(A,e,r){var f=0,k=0,n=0,o=0;n=v-16|0,v=n,i[n+12>>2]=r,f=v-160|0,v=f,o=f+8|0,z(o,76256,144),i[f+52>>2]=A,i[f+28>>2]=A,k=-2-A|0,k=k>>>0>2147483647?2147483647:k,i[f+56>>2]=k,k=A+k|0,i[f+36>>2]=k,i[f+24>>2]=k,uw(o,e,r),(A|0)!=-2&&(A=i[f+28>>2],t[A-((A|0)==i[f+24>>2])|0]=0),v=f+160|0,v=n+16|0}function p6(A){var e=D(0),r=0,f=0;if(r=(P1(A),o2(2)),f=r>>>23&255,f>>>0<=149)if(f>>>0<=125)A=D(A*D(0));else{A=D(B2(A)),e=D(D(D(A+D(8388608))+D(-8388608))-A);i:{if(e>D(.5)){A=D(D(A+e)+D(-1));break i}if(A=D(A+e),!(e<=D(-.5)))break i;A=D(A+D(1))}A=(r|0)<0?D(-A):A}return D(B2(A))<D(2147483648)?~~A:-2147483648}function RY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-32|0,v=f,n1(f+12|0,e,r,W[i[i[e>>2]+52>>2]](e,r,0)|0),t[f+31|0]<0&&Z(i[f+20>>2]),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0;i:{if(t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];break i}T(A,i[28730],i[28731])}v=f+32|0}function ku(A,e){var r=0,f=0;r=i[e>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+40>>2]=r,r=i[A+44>>2],i[A+44>>2]=f;i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function de(A){var e=0,r=0;e=i[A+76>>2];i:{if(!((e|0)>=0&(!e|i[33160]!=(e&1073741823)))){if(e=i[A+4>>2],(e|0)!=i[A+8>>2]){i[A+4>>2]=e+1,A=u[e|0];break i}A=b3(A);break i}e=A+76|0,r=i[e>>2],i[e>>2]=r||1073741823,r=i[A+4>>2];e:{if((r|0)!=i[A+8>>2]){i[A+4>>2]=r+1,A=u[r|0];break e}A=b3(A)}i[e>>2]=0}return A}function JY(A,e,r,f,k){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,i[e+8>>2]!=1){e=i[25827],i[A>>2]=i[25826],i[A+4>>2]=e,i[A+8>>2]=i[25828];return}i:{if(!u[e+16|0]||(f&&(i[f>>2]=i[e+20>>2]),!k))break i;i[k>>2]=i[e+24>>2]}r&&(i[r>>2]=u[e+16|0]),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function NY(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=112904,f=i[A+124>>2],f){if(e=f,r=i[A+128>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-12|0,(r|0)==(f|0))break}e=i[A+124>>2]}i[A+128>>2]=f,Z(e)}Z(n2(A))}function l2(A){var e=0,r=0,f=0;i:{e:{if(e=A,!(e&3))break e;if(!u[e|0])return 0;for(;;){if(e=e+1|0,!(e&3))break e;if(!u[e|0])break}break i}for(;r=e,e=e+4|0,f=i[r>>2],((f|16843008-f)&-2139062144)==-2139062144;);for(;e=r,r=e+1|0,!!u[e|0];);}return e-A|0}function DY(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e,A=i[A>>2];i:{if(t[A+63|0]>=0){i[e+8>>2]=i[A+60>>2],r=i[A+56>>2],i[e>>2]=i[A+52>>2],i[e+4>>2]=r;break i}T(e,i[A+52>>2],i[A+56>>2])}return A=t[e+11|0],r=(A|0)<0,f=r?i[e+4>>2]:A,f&&(k=u8(C(f+1|0),r?i[e>>2]:e)),(A|0)<0&&Z(i[e>>2]),v=e+16|0,k|0}function UY(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=111816,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}Z(n2(A))}function MY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0;o=v-16|0,v=o,i[k>>2]=r,n=o+12|0,A=a5(n,0,i[A+8>>2]),e=2;i:{if(A+1>>>0<2||(r=A-1|0,e=1,r>>>0>f-i[k>>2]>>>0))break i;for(;;){if(r){A=u[n|0],e=i[k>>2],i[k>>2]=e+1,t[e|0]=A,r=r-1|0,n=n+1|0;continue}break}e=0}return v=o+16|0,e|0}function HY(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=94284,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),e=r-56|0,i[e>>2]=92500,k=i[r-36>>2],k&&(i[r-32>>2]=k,Z(k)),r=e,(f|0)!=(e|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}return n2(A)|0}function F6(A,e,r,f){var k=0;i:{if(!(f&2048)|!r||(k=f&74,(k|0)==8|(k|0)==64))break i;t[A|0]=43,A=A+1|0}for(f&512&&(t[A|0]=35,A=A+1|0);;){if(k=u[e|0],k){t[A|0]=k,A=A+1|0,e=e+1|0;continue}break}k=f&74,e=111;i:{if((k|0)==64||(e=f&16384?88:120,(k|0)==8))break i;e=r?100:117}t[A|0]=e}function zY(A){A=A|0;var e=0,r=0,f=0,k=0;if(e=i[A+104>>2],f=i[A+108>>2],(e|0)==(f|0)){t[A+97|0]=0;return}i:{for(;;){if(i[e+4>>2]||(k=i[e+8>>2],r=i[e+12>>2],(r|0)>0?r=1:r=(r|0)>=0&k>>>0>=2147483648,r))break i;if(e=e+24|0,(f|0)==(e|0))break}t[A+97|0]=0;return}t[A+97|0]=1}function H3(A,e){var r=0,f=0,k=0;r=i[A+140>>2];i:{if(!r)break i;for(k=A+140|0,A=k;f=o0[r+16>>2]<e>>>0,A=f?A:r,r=i[(f?4:0)+r>>2],!!r;);if(f=0,(A|0)==(k|0)|o0[A+16>>2]>e>>>0||(f=i[A+20>>2],A=i[A+24>>2],!A|i[A+4>>2]!=-1))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return(f|0)!=0}function nu(A){var e=0,r=0,f=0;f=i[A+16>>2]<<8,i[A+16>>2]=f,e=p[A+20>>1]+8|0,X[A+20>>1]=e,e=e<<16>>16;i:{if((e|0)<0||(r=i[A+4>>2],r>>>0>=o0[A+8>>2]))break i;i[A+4>>2]=r+1,r=u[r|0],X[A+20>>1]=e-8,f=r<<e|f}return r=i[A+12>>2]<<7,e=(f>>>0)/(r>>>0)|0,(e|0)>=256&&(e=255),i[A+16>>2]=f-g(e,r),e}function xY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,o=0,l=0;f=v-32|0,v=f,n=f+12|0,z1(n,Ou(e,r)),e=t[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=E2(e+4|0),i[k>>2]=e,e&&z(k+4|0,r?i[f+12>>2]:n,e),i[f+24>>2]=k,o=A,l=T1(102728,f+24|0)|0,i[o+4>>2]=l,i[A>>2]=132616,t[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function TY(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;o=A,l=e,A=W[i[i[A+8>>2]+20>>2]](A+8|0)|0;i:{if(u[A+11|0]>>>7|0){e=i[A>>2];break i}e=A}return s=e,u[A+11|0]>>>7|0?e=i[A>>2]:e=A,u[A+11|0]>>>7|0?A=i[A+4>>2]:A=u[A+11|0]&127,n6(o,l,r,f,k,n,s,e+(A<<2)|0)|0}function Q2(A){var e=0,r=0,f=0;f=v-16|0,v=f;i:{if(!w4(A,1))break i;r=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(W[i[i[r>>2]+16>>2]](r,f+15|0,1)|0)){h8(A),r=0;break e}r=u[f+15|0]}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=f+16|0,r}function jY(A){A=A|0;var e=0,r=0,f=0;r=v-16|0,v=r,e=i[A+584>>2];i:{if((e|0)==i[A+588>>2]||($1(r+8|0,i[A+180>>2],i[e>>2],0),A=i[r+12>>2],e=i[r+8>>2],e&&(f=W[i[i[e>>2]+128>>2]](e)|0),!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,f|0}function SY(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=94284,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),e=r-56|0,i[e>>2]=92500,k=i[r-36>>2],k&&(i[r-32>>2]=k,Z(k)),r=e,(f|0)!=(e|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}Z(n2(A))}function OY(A){A=A|0;var e=0,r=0;i[A>>2]=113504,e=i[A+52>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+44>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return e=i[A+28>>2],e&&(i[A+32>>2]=e,Z(e)),A|0}function PY(A){A=A|0;var e=0,r=0,f=0;r=v-16|0,v=r,e=i[A+564>>2];i:{if((e|0)==i[A+568>>2]||($1(r+8|0,i[A+180>>2],i[e>>2],0),A=i[r+12>>2],e=i[r+8>>2],e&&(f=W[i[i[e>>2]+128>>2]](e)|0),!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,f|0}function N2(A,e,r){var f=0,k=0;i:{e:{if(r>>>0>=4){if((A|e)&3)break e;for(;;){if(i[A>>2]!=i[e>>2])break e;if(e=e+4|0,A=A+4|0,r=r-4|0,!(r>>>0>3))break}}if(!r)break i}for(;;){if(f=u[A|0],k=u[e|0],(f|0)==(k|0)){if(e=e+1|0,A=A+1|0,r=r-1|0,r)continue;break i}break}return f-k|0}return 0}function zi(A,e){var r=0;if(r=i[A>>2],i[A>>2]=e,r){A=i[r+32>>2],A&&(i[r+36>>2]=A,Z(A)),A=i[r+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}Z(r)}}function xi(A,e){var r=0;if(r=i[A>>2],i[A>>2]=e,r){A=i[r+16>>2],A&&(i[r+20>>2]=A,Z(A)),A=i[r+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}Z(r)}}function L1(A,e,r,f){var k=0,n=0;k=v-16|0,v=k,n=i[e+120>>2];i:{if(!n){if(t[k+4|0]=0,t[k+15|0]=0,a(A,2,108,k+4|0),t[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(!i[e+128>>2]){if(t[k+4|0]=0,t[k+15|0]=0,a(A,2,109,k+4|0),t[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}Vn(A,n,r,e+128|0,f)}v=k+16|0}function LY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;i:{e:{if(A=i[A+4>>2],f=i[A+188>>2],e=e>>f,(e|0)<0||(k=i[A+192>>2],(e|0)>=(k|0)))break e;if(r=r>>f,(r|0)<0|(r|0)>=i[A+196>>2])break i;return(i[A+180>>2]+g(e,12)|0)+g(g(r,k),12)|0}U0(5068,11952,118,4625),M()}U0(5030,11952,119,4625),M()}function qY(A){A=A|0;var e=0,r=0,f=0,k=0;if(e=i[A+16>>2],!e)return 0;e=Z0(e,101112,102448);i:{if(!e)break i;if(A=i[A+20>>2],!A)return i[e+24>>2]-i[e+20>>2]|0;if(r=i[A+4>>2],f=r+1|0,i[A+4>>2]=f,k=i[e+20>>2],e=i[e+24>>2],i[A+4>>2]=r,r=e-k|0,f)break i;W[i[i[A>>2]+8>>2]](A),y(A)}return r|0}function k1(A){var e=0,r=0,f=0,k=0;if(i[A>>2]){u[115e3]||(t[115e3]=1),e=i[28752];i:{if(!e)break i;for(r=115008,f=i[A>>2];k=o0[e+16>>2]<f>>>0,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if((r|0)==115008|o0[r+16>>2]>f>>>0)break i;i[r+20>>2]=i[r+20>>2]-i[A+4>>2]}i[A>>2]=0,i[A+4>>2]=0}}function aY(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0,s=0;o=A,l=e,A=W[i[i[A+8>>2]+20>>2]](A+8|0)|0;i:{if(u[A+11|0]>>>7|0){e=i[A>>2];break i}e=A}return s=e,u[A+11|0]>>>7|0?e=i[A>>2]:e=A,u[A+11|0]>>>7|0?A=i[A+4>>2]:A=u[A+11|0]&127,k6(o,l,r,f,k,n,s,e+A|0)|0}function tu(A){A=A|0;var e=0,r=0,f=0,k=0;if(e=i[A+16>>2],!e)return 0;e=Z0(e,101112,102404);i:{if(!e)break i;if(A=i[A+20>>2],!A)return i[e+12>>2]-i[e+8>>2]>>3;if(r=i[A+4>>2],f=r+1|0,i[A+4>>2]=f,k=i[e+8>>2],e=i[e+12>>2],i[A+4>>2]=r,r=e-k>>3,f)break i;W[i[i[A>>2]+8>>2]](A),y(A)}return r|0}function KY(A){A=A|0;var e=0,r=0;i[A>>2]=113504,e=i[A+52>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+44>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+28>>2],e&&(i[A+32>>2]=e,Z(e)),Z(A)}function E5(A,e,r,f){var k=0,n=0,o=0,l=0;k=v-160|0,v=k,i[k+60>>2]=e,i[k+20>>2]=e,i[k+24>>2]=-1,n=k+16|0,I8(n,0,0),F9(k,n,f,1),f=i[k+8>>2],o=i[k+12>>2],n=i[k>>2],l=i[k+4>>2],r&&(i[r>>2]=i[k+136>>2]+((i[k+20>>2]-i[k+60>>2]|0)+e|0)),i[A+8>>2]=f,i[A+12>>2]=o,i[A>>2]=n,i[A+4>>2]=l,v=k+160|0}function ou(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0,s=0;l=v-32|0,v=l,s=l+12|0,a0(s,i[e>>2],r,f,k,n,o,0);i:{if(i[l+12>>2]){r=A,A=i[e>>2],c0(r,s,A?A+172|0:0);break i}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}t[l+31|0]<0&&Z(i[l+20>>2]),v=l+32|0}function z3(A,e){var r=0,f=0,k=0;if(i[e+16>>2]!=1970628964){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r=i[e+20>>2],e=i[e+24>>2],(r|0)!=(e|0)){if(e=e-r|0,(e|0)<0)break i;f=C(e),i[A>>2]=f,k=e+f|0,i[A+8>>2]=k,e&&z(f,r,e),i[A+4>>2]=k}return}s0(),M()}function $Y(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;if(k=e,n=F0(r),i[k+104>>2]=n,k=e,n=F0(r),i[k+108>>2]=n,k=e,n=F0(r),i[k+112>>2]=n,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function dY(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;o=v-32|0,v=o,l=o+12|0,Fe(l,i[e>>2],r,f,k,1835625829,10670,n,0);i:{if(i[o+12>>2]!=i[28728]){c0(A,l,i[e>>2]);break i}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}t[o+31|0]<0&&Z(i[o+20>>2]),v=o+32|0}function bY(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0;var l=0;n=v-32|0,v=n,l=n+12|0,Fe(l,i[e>>2],r,f,k,1970432288,0,0,o);i:{if(i[n+12>>2]!=i[28728]){c0(A,l,i[e>>2]);break i}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}t[n+31|0]<0&&Z(i[n+20>>2]),v=n+32|0}function lu(A){var e=0,r=0,f=0;e=A+256|0;i:{e:{r:{f:switch(r=i[A+260>>2],A=t[A+267|0],r=(A|0)<0?r:A,r-25|0){case 0:break e;case 1:break r;case 18:break f;default:break i}return!N2((A|0)<0?i[e>>2]:e,20706,43)}return!N2((A|0)<0?i[e>>2]:e,23611,r)}f=!N2((A|0)<0?i[e>>2]:e,23638,r)}return f}function cY(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=105976,r=i[A+112>>2],r){if(e=r,f=i[A+116>>2],(e|0)!=(f|0)){for(;e=f-12|0,k=i[e>>2],k&&(i[f-8>>2]=k,Z(k)),f=e,(e|0)!=(r|0););e=i[A+112>>2]}i[A+116>>2]=r,Z(e)}return e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),n2(A)|0}function R5(A,e){var r=0,f=0,k=0,n=0;if(i[A>>2]){u[115e3]||(t[115e3]=1),r=i[28752];i:{if(!r)break i;for(f=115008,k=i[A>>2];n=o0[r+16>>2]<k>>>0,f=n?f:r,r=i[(n?4:0)+r>>2],!!r;);if((f|0)==115008|o0[f+16>>2]>k>>>0)break i;i[f+20>>2]=i[f+20>>2]-e}i[A+4>>2]=i[A+4>>2]-e}}function uu(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!e||(r=u[e|0],f=u[A|0],((r>>>0<f>>>0?r:f)|0)!=1))break i;i[A+4>>2]=i[e+4>>2],X[A+8>>1]=p[e+8>>1],X[A+10>>1]=p[e+10>>1],X[A+12>>1]=p[e+12>>1],X[A+14>>1]=p[e+14>>1],X[A+16>>1]=p[e+16>>1],X[A+18>>1]=p[e+18>>1],X[A+20>>1]=p[e+20>>1]}}function iy(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,o=0;k=v-32|0,v=k,n=k+12|0,o=i[e>>2],W[i[i[o>>2]+116>>2]](n,o,r,f);i:{if(i[k+12>>2]){r=A,A=i[e>>2],c0(r,n,A?A+164|0:0);break i}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}t[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function ey(A){A=A|0;var e=0,r=0,f=0;e=i[A+24>>2],e>>>0>o0[A+44>>2]&&(i[A+44>>2]=e);i:{if(!(u[A+48|0]&8)||(e=i[A+44>>2],e>>>0>o0[A+16>>2]&&(r=i[A+8>>2],f=i[A+12>>2],i[A+16>>2]=e,i[A+12>>2]=f,i[A+8>>2]=r),e=i[A+16>>2],A=i[A+12>>2],e>>>0<=A>>>0))break i;return u[A|0]}return-1}function l6(A){var e=0,r=0,f=0;r=v-32|0,v=r,u[115885]==1&&(i[r+16>>2]=A,q8(38185,r+16|0)),e=i[A+4>>2];i:{if(!e||(f=e,e=i[e>>2]-1|0,i[f>>2]=e,e)||(u[115885]==1&&(i[r>>2]=i[A>>2],q8(38242,r)),e=i[A>>2],e&&Z(e),e=i[A+4>>2],!e))break i;Z(e)}return v=r+32|0,A}function su(A,e,r){var f=0;if(r-65537>>>0<4294836223)for(;e=(e|0)/2|0,r=(r|0)/2|0,r-65537>>>0<4294836223;);i:{if((r|0)<=1)break i;for(;;){if(e-65537>>>0>4294836222)break i;if(e=(e|0)/2|0,f=r>>>0>3,r=r>>>1|0,!f)break}}return i[A>>2]=e,i[A+4>>2]=r,A}function hu(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;o=v-32|0,v=o,l=o+12|0,a0(l,i[e>>2],r,f,k,n,0,0);i:{if(i[o+12>>2]){r=A,A=i[e>>2],c0(r,l,A?A+172|0:0);break i}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}t[o+31|0]<0&&Z(i[o+20>>2]),v=o+32|0}function ry(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=105976,r=i[A+112>>2],r){if(e=r,f=i[A+116>>2],(e|0)!=(f|0)){for(;e=f-12|0,k=i[e>>2],k&&(i[f-8>>2]=k,Z(k)),f=e,(e|0)!=(r|0););e=i[A+112>>2]}i[A+116>>2]=r,Z(e)}e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(n2(A))}function x3(A,e){var r=0,f=0;r=i[A+40>>2],r&&(t[r+208|0]=0),r=i[e>>2],t[r+208|0]=1,f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+40>>2]=r,r=i[A+44>>2],i[A+44>>2]=f;i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}Bt(i[A+48>>2],i[i[e>>2]+196>>2])}function J5(A,e){var r=0,f=0,k=0,n=0,o=0,l=0;r=i[A+104>>2],A=i[A+108>>2];i:{if((r|0)!=(A|0))for(n=r+12|0,A=(A-r|0)/12|0,o=A>>>0<=1?1:A,l=A-1|0,A=0;;){if(k=g(A,12),f=k+r|0,o0[f>>2]<=e>>>0&((A|0)==(l|0)|o0[n+k>>2]>e>>>0))break i;if(A=A+1|0,(o|0)==(A|0))break}f=0}return f}function fy(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0;n=v-32|0,v=n,o=n+12|0,Fe(o,i[e>>2],r,f,k,1835625829,10670,0,0);i:{if(i[n+12>>2]!=i[28728]){c0(A,o,i[e>>2]);break i}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}t[n+31|0]<0&&Z(i[n+20>>2]),v=n+32|0}function wu(A){var e=0,r=0,f=0,k=0;if(e=v-16|0,v=e,u[115885]==1&&(i[e+4>>2]=i[A+4>>2],i[e>>2]=A,q8(47603,e)),r=i[A+4>>2],r){f=i[r>>2],(f|0)>=2&&(i[r>>2]=f-1,r=i[A>>2],f=C(172),i[A>>2]=f,k=A,A=C(4),i[k+4>>2]=A,i[A>>2]=1,z(f,r,172)),v=e+16|0;return}U0(4118,19941,95,14221),M()}function _u(A,e){var r=0,f=0;r=u[A|0];i:{if((r|0)!=u[e|0]||r&&p[A+4>>1]!=p[e+4>>1]|p[A+6>>1]!=p[e+6>>1]|u[A+2|0]!=u[e+2|0]||(r=u[A+1|0],(r|0)!=u[e+1|0])||r&&p[A+8>>1]!=p[e+8>>1]|p[A+10>>1]!=p[e+10>>1]|u[A+3|0]!=u[e+3|0])break i;f=1}return f}function B4(A){var e=0,r=0;r=i[A+16>>2]<<1,i[A+16>>2]=r,e=p[A+20>>1]+1|0,X[A+20>>1]=e;i:{if(e<<16>>16<0||(X[A+20>>1]=65528,e=i[A+4>>2],e>>>0>=o0[A+8>>2]))break i;i[A+4>>2]=e+1,r=u[e|0]|r,i[A+16>>2]=r}return e=i[A+12>>2]<<7,e>>>0<=r>>>0?(i[A+16>>2]=r-e,A=1):A=0,A}function N5(A,e){var r=0,f=0,k=0;if(f=i[A+4>>2],(f|0)!=(e|0))for(;r=i[f-12>>2],r&&(i[f-8>>2]=r,Z(r)),r=i[f-24>>2],r&&(i[f-20>>2]=r,Z(r)),r=i[f-36>>2],r&&(i[f-32>>2]=r,Z(r)),r=f-52|0,k=i[r>>2],k&&(i[f-48>>2]=k,Z(k)),f=r,(r|0)!=(e|0););i[A+4>>2]=e}function be(A,e,r,f){var k=0;return i[A>>2]=92456,k=A+4|0,i[k>>2]=0,i[k+4>>2]=0,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=r,i[A+36>>2]=0,i[A>>2]=92324,f?(f=C(r),i[A+48>>2]=f,r&&z(f,e,r),i[A+24>>2]=f,A):(i[A+24>>2]=e,A)}function Ay(A,e){A=A|0,e=e|0;var r=0;i:{if(!i[A+64>>2]||(r=i[A+12>>2],r>>>0<=o0[A+8>>2]))break i;if((e|0)==-1)return i[A+12>>2]=r-1,((e|0)!=-1?e:0)|0;if(r=i[A+12>>2]-1|0,!(u[A+88|0]&16)&u[r|0]!=(e&255))break i;return i[A+12>>2]=r,t[i[A+12>>2]]=e<<24>>24,e|0}return-1}function Bu(A,e){var r=0,f=0,k=0,n=0;if(r=i[A+508>>2],r>>>0<o0[A+512>>2]){f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+16>>2]=i[e+16>>2],f=i[e+12>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=f,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,i[A+508>>2]=r+20;return}k=A,n=Je(A+504|0,e),i[k+508>>2]=n}function vu(A,e){var r=0,f=0,k=0;f=1;i:{if(e||(k=i[A>>2],r=i[A+12>>2],e=i[A+8>>2],A=r-e>>2,k>>>0>A>>>0))break i;if((e|0)!=(r|0))for(f=A>>>0<=1?1:A,A=0;;){if(r=i[e+(A<<2)>>2],!(u[r+104|0]|i[r+100>>2]))return 1;if(A=A+1|0,(f|0)==(A|0))break}f=0}return f}function ky(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-16|0,v=r,i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,e=i[e+72>>2],(e+108|0)!=(r|0)&&(f=i[e+112>>2],e=i[e+116>>2],$4(r+4|0,f,e,e-f|0),k=i[r+4>>2],n=i[r+12>>2],f=i[r+8>>2]),t[A+20|0]=0,i[A+8>>2]=n,i[A+4>>2]=f,i[A>>2]=k,v=r+16|0}function Ti(A,e,r){var f=0,k=0,n=0,o=0;i:{if(!e){f=e;break i}for(;r=r-1|0,k=A,A=O1(A,e,10,0),f=h0,n=r,o=k-L0(A,f,10,0)|48,t[n|0]=o,k=e>>>0>9,e=f,!!k;);}if(A|f)for(;r=r-1|0,e=(A>>>0)/10|0,t[r|0]=A-g(e,10)|48,f=A>>>0>9,A=e,!!f;);return r}function ny(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;o=v-16|0,v=o,W[i[i[e>>2]+160>>2]](o+8|0,e),e=A,A=i[o+8>>2],W[i[i[A>>2]+12>>2]](e,A,r,f,k,n),A=i[o+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=o+16|0}function ty(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=f+12|0,n=i[e>>2],W[i[i[n>>2]+32>>2]](k,n,r);i:{if(i[f+12>>2]){r=A,A=i[e>>2],c0(r,k,A?A+172|0:0);break i}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}t[f+31|0]<0&&Z(i[f+20>>2]),v=f+32|0}function oy(A){A=A|0;var e=0,r=0,f=0,k=0;if(f=i[A+24>>2],f){if(e=f,r=i[A+28>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A+24>>2]}i[A+28>>2]=f,Z(e)}}function mu(A,e,r){var f=0,k=0,n=0,o=0;for(n=v-16|0,v=n,t[n+14|0]=0,f=e-A>>2,e=v-16|0,v=e;;){if(f){i[e+12>>2]=A,k=f>>>1|0,i[e+12>>2]=i[e+12>>2]+(k<<2),o=(k^-1)+f|0,f=k,k=o0[i[e+12>>2]>>2]<o0[r>>2],f=k?o:f,A=k?i[e+12>>2]+4|0:A;continue}break}return v=e+16|0,v=n+16|0,A}function ly(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0,l=0;l=(k-f|0)+e|0;i:{for(;;){if((f|0)!=(k|0)){if(A=-1,(e|0)==(r|0)||(n=t[e|0],o=t[f|0],(n|0)<(o|0)))break i;if((n|0)>(o|0))return 1;f=f+1|0,e=e+1|0;continue}break}A=(r|0)!=(l|0)}return A|0}function uy(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(A=i[e>>2],A){if(r=A,f=i[e+4>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(f|0)==(A|0))break}r=i[e>>2]}i[e+4>>2]=A,Z(r)}}function Zu(A){A=A|0;var e=0,r=0;if(i[A+1884>>2]>0&&(e=A+1392|0,t[e|0]=1,i[e+156>>2]>0))for(;r=r+1|0,(r|0)<i[e+156>>2];);return W[i[i[A>>2]+4>>2]](A),u[115884]||(t[115884]=1),A=i[28964],(A|0)<=0?12:(A=A-1|0,i[28964]=A,A||tw(),0)}function D5(){var A=0;return A=C(72),i[A+24>>2]=0,X[A>>1]=9,i[A+4>>2]=0,i[A+8>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,t[A+40|0]=0,i[A+32>>2]=2,i[A+36>>2]=2,t[A+28|0]=1,i[A+12>>2]=0,i[A+16>>2]=0,X[A+20>>1]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,i[A+64>>2]=0,t[A+68|0]=0,A|0}function s8(A){A=A|0;var e=0,r=0;i[A>>2]=103488,e=i[A+68>>2],e&&(W[i[i[A+64>>2]+24>>2]](e),i[A+68>>2]=0),k1(A+32|0),e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function ce(A,e,r){var f=0,k=0,n=0;return f=A*A,n=f*(f*f)*(f*158969099521155e-24+-25050760253406863e-24)+(f*(f*27557313707070068e-22+-.0001984126982985795)+.00833333333332249),k=A*f,r?A-(f*(e*.5-k*n)-e+k*.16666666666666632):k*(f*n+-.16666666666666632)+A}function T3(A,e){var r=0,f=0;r=v-16|0,v=r,i[r+12>>2]=A;i:{if((A|0)==(e|0))break i;for(;;){if(e=e-4|0,i[r+8>>2]=e,A>>>0>=e>>>0)break i;A=i[r+12>>2],e=i[A>>2],f=A,A=i[r+8>>2],i[f>>2]=i[A>>2],i[A>>2]=e,A=i[r+12>>2]+4|0,i[r+12>>2]=A,e=i[r+8>>2]}}v=r+16|0}function gu(A){A=A|0;var e=0,r=0;e=i[A>>2],r=i[e+16>>2],e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);i:{if(r){A=W[i[i[r>>2]+8>>2]](r)|0;break i}A=r8(i[A>>2])?1852009592:0}i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function sy(A,e,r){if(A=A|0,e=e|0,r=r|0,!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}if(r>>>0>=7){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=29011;return}e=i[e>>2],W[i[i[e>>2]+68>>2]](e,r),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}function ji(A,e){var r=0,f=0,k=0,n=0;r=v-16|0,v=r;i:{if(!e){e=0;break i}f=e,e=_1(e),g4(r,f,0,0,0,112-(e^31)|0),f=0+i[r+8>>2]|0,e=(i[r+12>>2]^65536)+(16414-e<<16)|0,n=k>>>0>f>>>0?e+1|0:e,k=i[r+4>>2],e=i[r>>2]}i[A>>2]=e,i[A+4>>2]=k,i[A+8>>2]=f,i[A+12>>2]=n,v=r+16|0}function hy(A){A=A|0;var e=0,r=0;i[A>>2]=104348,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return n4(A)|0}function wy(A){A=A|0;var e=0,r=0;i[A>>2]=105392,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return n4(A)|0}function _y(A){A=A|0;var e=0,r=0;i[A>>2]=106696,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return n4(A)|0}function By(A){A=A|0;var e=0,r=0;i[A>>2]=103840,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return n4(A)|0}function vy(A){A=A|0;var e=0,r=0;i[A>>2]=104940,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return n4(A)|0}function my(A){A=A|0;var e=0,r=0;i[A>>2]=106216,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return n4(A)|0}function O8(A,e,r,f,k){r=g(i[i[A+124>>2]+16892>>2],f)+r|0;i:{if(!e||(r=i[A+320>>2]+g(r,76)|0,i[r>>2]>=(k|0)))break i;i[A+328>>2]=i[A+328>>2]-1,i[A+332>>2]=i[A+332>>2]+1,i[e+4>>2]=2,vh(r,k),i[e+4>>2]=1,i[A+332>>2]=i[A+332>>2]-1,i[A+328>>2]=i[A+328>>2]+1}}function Zy(A){A=A|0;var e=0,r=0,f=0;r=i[i[A>>2]+184>>2],e=i[r+104>>2],A=0;i:{if((e|0)==i[r+108>>2])break i;if(A=i[e>>2],e=i[e+4>>2],!e){A=i[A+16>>2];break i}r=i[e+4>>2],f=r+1|0,i[e+4>>2]=f,A=i[A+16>>2],i[e+4>>2]=r,f||(W[i[i[e>>2]+8>>2]](e),y(e))}return A|0}function Gu(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,r=i[e+560>>2],i[A>>2]=i[e+556>>2],i[A+4>>2]=r,r=A+8|0;i:{if(t[e+575|0]>=0){e=e+564|0,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2];break i}T(r,i[e+564>>2],i[e+568>>2])}t[A+20|0]=1}function ir(A,e){var r=0,f=0,k=0,n=0;u[A|0]||(r=i[A+24>>2],f=r+i[A+20>>2]|0,n=i[A+12>>2],k=i[A+8>>2],(f|0)==(((k|0)!=(n|0)?(n-k<<8)-1|0:0)|0)&&(ar(A+4|0),k=i[A+8>>2],r=i[A+24>>2],f=r+i[A+20>>2]|0),i[i[(f>>>8&16777212)+k>>2]+((f&1023)<<2)>>2]=e,i[A+24>>2]=r+1)}function gy(A){A=A|0;var e=0,r=0,f=0;if(A=i[28782],A){if(e=A,r=i[28783],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(r|0)==(A|0))break}e=i[28782]}i[28783]=A,Z(e)}}function Gy(A,e,r){if(A=A|0,e=e|0,r=r|0,u2(r,p[e+4>>1]),u2(r,p[e+6>>1]),u2(r,p[e+8>>1]),h2(r,u[e+10|0]<<7&128),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function ti(A,e){var r=0,f=0;r=v-16|0,v=r,i[r+12>>2]=A;i:{if((A|0)==(e|0))break i;for(;;){if(e=e-1|0,i[r+8>>2]=e,A>>>0>=e>>>0)break i;A=i[r+12>>2],e=u[A|0],f=A,A=i[r+8>>2],t[f|0]=u[A|0],t[A|0]=e,A=i[r+12>>2]+1|0,i[r+12>>2]=A,e=i[r+8>>2]}}v=r+16|0}function Si(A,e){var r=0,f=0,k=0;f=-1;i:{if((A|0)==-1)break i;k=i[e+76>>2]<0;e:{r=i[e+4>>2];r:{if(!r&&(fr(e),r=i[e+4>>2],!r))break r;if(i[e+44>>2]-8>>>0<r>>>0)break e}if(k)break i;return-1}r=r-1|0,i[e+4>>2]=r,t[r|0]=A,i[e>>2]=i[e>>2]&-17,f=A&255}return f}function Wu(A,e,r){var f=0,k=0,n=0,o=0;f=v-16|0,v=f,A=R0(A),i[A+32>>2]=e,i[A>>2]=79640,k=f+12|0,e=i[A+4>>2],i[k>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(k,137016),i2(k),i[A+40>>2]=r,i[A+36>>2]=e,n=A,o=W[i[i[e>>2]+28>>2]](e)|0,t[n+44|0]=o,v=f+16|0}function Xu(A,e,r){var f=0,k=0,n=0,o=0;f=v-16|0,v=f,A=Ys(A),i[A+32>>2]=e,i[A>>2]=79844,k=f+12|0,e=i[A+4>>2],i[k>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(k,137024),i2(k),i[A+40>>2]=r,i[A+36>>2]=e,n=A,o=W[i[i[e>>2]+28>>2]](e)|0,t[n+44|0]=o,v=f+16|0}function Wy(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,n=k+12|0,rn(n,i[e>>2],r,f,0);i:{if(i[k+12>>2]){r=A,A=i[e>>2],c0(r,n,A?A+172|0:0);break i}e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}t[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function U5(A){var e=0,r=0,f=0,k=0;if(f=i[A>>2],f){if(e=f,r=i[A+4>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A>>2]}i[A+4>>2]=f,Z(e)}}function er(A,e){var r=0,f=0;r=v-16|0,v=r,u[A+11|0]>>>7|0&&B6(i[A>>2],4);i:if(u[e+11|0]>>>7|0)break i;i[A+8>>2]=i[e+8>>2],f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,t[e+11|0]=u[e+11|0]&128,t[e+11|0]=u[e+11|0]&127,i[r+12>>2]=0,i[e>>2]=i[r+12>>2],v=r+16|0}function Xy(A){A=A|0;var e=0,r=0;i[A>>2]=104348,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(n4(A))}function Iy(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=i[e+8>>2],r=l2(f),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(t[A+11|0]=r,!r)break i}if(!r)break i;z(A,f,r)}t[A+r|0]=0;return}I0(),M()}function Qy(A){A=A|0;var e=0,r=0;i[A>>2]=105392,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(n4(A))}function Vy(A){A=A|0;var e=0,r=0;i[A>>2]=106696,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(n4(A))}function py(A){A=A|0;var e=0,r=0;i[A>>2]=103840,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(n4(A))}function Fy(A){A=A|0;var e=0,r=0;i[A>>2]=104940,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(n4(A))}function Cy(A){A=A|0;var e=0,r=0;i[A>>2]=106216,e=i[A+564>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(n4(A))}function rr(A){var e=0,r=0,f=0;X[A+20>>1]=8,i[A+12>>2]=510,i[A+16>>2]=0,e=i[A+4>>2],f=i[A+8>>2]-e|0;i:{if((f|0)<=0||(i[A+4>>2]=e+1,r=u[e|0],X[A+20>>1]=0,r=r<<8,i[A+16>>2]=r,(f|0)==1))break i;i[A+4>>2]=e+2,e=u[e+1|0],X[A+20>>1]=65528,i[A+16>>2]=e|r}}function Yy(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,!(!f|r)){i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=5289;return}i[e+8>>2]=f,f=i[e+12>>2],f&&Z(f);i:{if(r){f=e,e=b5(),i[f+12>>2]=e,K3(e,r);break i}i[e+12>>2]=0}e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}function yy(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;if(i4(A,i[e+8>>2],0)){M5(e,r,f);return}k=i[A+12>>2],n=A+16|0,Cu(n,e,r,f);i:{if(k>>>0<2)break i;for(k=(k<<3)+n|0,A=A+24|0;;){if(Cu(A,e,r,f),u[e+54|0])break i;if(A=A+8|0,!(k>>>0>A>>>0))break}}}function W1(A){var e=0,r=0,f=0,k=0;if(r=v-16|0,v=r,i[r+12>>2]=A,f=v-16|0,v=f,i[A>>2]!=-1){for(e=f+12|0,i[e>>2]=r+12,k=f+8|0,i[k>>2]=e;e=i[A>>2],(e|0)==1;);e||(i[A>>2]=1,sh(k),i[A>>2]=-1)}return v=f+16|0,v=r+16|0,i[A+4>>2]-1|0}function u6(A,e){var r=0,f=0;r=v-16|0,v=r,u[A+11|0]>>>7|0&&B6(i[A>>2],1);i:if(u[e+11|0]>>>7|0)break i;i[A+8>>2]=i[e+8>>2],f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,t[e+11|0]=u[e+11|0]&128,t[e+11|0]=u[e+11|0]&127,t[r+15|0]=0,t[e|0]=u[r+15|0],v=r+16|0}function Ey(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(f=i[e+64>>2],f&&Z(f),f=e,e=bi(),i[f+64>>2]=e,li(e,r),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function Ry(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,o=0;i:{for(;;){if((f|0)!=(k|0)){if(A=-1,(e|0)==(r|0)||(n=i[e>>2],o=i[f>>2],(n|0)<(o|0)))break i;if((n|0)>(o|0))return 1;f=f+4|0,e=e+4|0;continue}break}A=(e|0)!=(r|0)}return A|0}function Jy(A,e,r){if(A=A|0,e=e|0,r=r|0,!r){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}if(i[r>>2]>=7){e=i[25775],i[A>>2]=i[25774],i[A+4>>2]=e,i[A+8>>2]=i[25776];return}Ml(r),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}function j3(A,e,r){var f=0,k=0;if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=i[e+104>>2],e=i[e+108>>2],(f|0)!=(e|0))for(;;){if(i[f+40>>2]==(r|0)){i:{if(o0[A+8>>2]>k>>>0){xe(k,f),k=k+56|0;break i}k=r5(A,f)}i[A+4>>2]=k}if(f=f+56|0,(e|0)==(f|0))break}}function S3(A,e,r,f){var k=0,n=0;return k=v-160|0,v=k,A=e?A:k+158|0,i[k+148>>2]=A,n=e-1|0,i[k+152>>2]=e>>>0>=n>>>0?n:0,l0(k,0,144),i[k+76>>2]=-1,i[k+36>>2]=2006,i[k+80>>2]=-1,i[k+44>>2]=k+159,i[k+84>>2]=k+148,t[A|0]=0,A=G3(k,r,f,2004,2005),v=k+160|0,A}function I8(A,e,r){var f=0,k=0,n=0,o=0;i[A+112>>2]=e,i[A+116>>2]=r,n=i[A+4>>2],f=i[A+44>>2]-n|0,i[A+120>>2]=f,i[A+124>>2]=f>>31,f=i[A+8>>2];i:{if(!(e|r)||(k=f-n|0,o=e>>>0>=k>>>0,k=k>>31,o&(k|0)<=(r|0)|(r|0)>(k|0)))break i;f=e+n|0}i[A+104>>2]=f}function fr(A){var e=0,r=0;return e=i[A+72>>2],i[A+72>>2]=e-1|e,i[A+20>>2]!=i[A+28>>2]&&W[i[A+36>>2]](A,0,0)|0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,e=i[A>>2],e&4?(i[A>>2]=e|32,-1):(r=i[A+44>>2]+i[A+48>>2]|0,i[A+8>>2]=r,i[A+4>>2]=r,e<<27>>31)}function Iu(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,X[f+8>>1]=i[r+4>>2],X[f+10>>1]=i[r+8>>2],X[f+12>>1]=i[r+12>>2],t[f+14|0]=u[r+16|0]!=0,e=i[e>>2],W[i[i[e>>2]+8>>2]](e,f+8|0),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,v=f+16|0}function P8(A,e,r){var f=0,k=0;if(f=u[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:10,u[A+11|0]>>>7|0?k=i[A+4>>2]:k=u[A+11|0]&127,r>>>0<=f>>>0){u[A+11|0]>>>7|0?f=i[A>>2]:f=A,k=!r,k|k||z(f,e,r),Rs(A,f,r);return}De(A,f,r-f|0,k,0,k,r,e)}function M5(A,e,r){var f=0;if(f=i[A+36>>2],!f){i[A+24>>2]=r,i[A+16>>2]=e,i[A+36>>2]=1,i[A+20>>2]=i[A+56>>2];return}i:{if(!(i[A+20>>2]!=i[A+56>>2]|i[A+16>>2]!=(e|0))){if(i[A+24>>2]!=2)break i;i[A+24>>2]=r;return}t[A+54|0]=1,i[A+24>>2]=2,i[A+36>>2]=f+1}}function Oi(A){var e=0,r=0,f=0,k=0,n=0;for(e=v-16|0,v=e,f=A+4|0,r=i[f>>2],i[e+12>>2]=r;;){i:{if((r|0)==-1){A=0;break i}if(k=i[f>>2],n=(k|0)==i[e+12>>2],i[f>>2]=n?r+1|0:k,n||(i[e+12>>2]=k),n)break i;r=i[e+12>>2];continue}break}return v=e+16|0,A}function Qu(A){var e=0,r=0,f=0;if(r=v-16|0,v=r,u[115885]==1&&(i[r+4>>2]=i[A+4>>2],i[r>>2]=A,q8(38227,r)),e=i[A+4>>2],e){f=i[e>>2]-1|0,i[e>>2]=f;i:{if(f||(f=i[A>>2],f&&(Z(f),e=i[A+4>>2],!e)))break i;Z(e)}i[A>>2]=0,i[A+4>>2]=0}v=r+16|0}function Ny(A){A=A|0;var e=0;i:{if(e=i[A+12>>2],A=i[A+8>>2],e-A>>>0>524280)break i;if((A|0)==(e|0))return 0;for(;;){if(i[A>>2]-32768>>>0<4294901760|i[A+4>>2]-32768>>>0<=4294901759)break i;if(A=A+8|0,(e|0)==(A|0))break}return 0}return 1}function Dy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;A=i[A>>2],f=i[A+240>>2],A=i[A+244>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),!r|!f||(i[e>>2]=i[f+196>>2],k=1);i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return k|0}function Y0(A){A=A|0;var e=0,r=0;if(i[A>>2]=79176,i[A+28>>2]){for(e=i[A+40>>2];;){if(e){e=e-1|0,r=e<<2,W[i[i[A+32>>2]+r>>2]](0,A,i[r+i[A+36>>2]>>2]);continue}break}i2(A+28|0),Z(i[A+32>>2]),Z(i[A+36>>2]),Z(i[A+48>>2]),Z(i[A+60>>2])}return A|0}function Uy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;if(h2(e,u[A+4|0]?3:6),Y1(e,r,i[A+12>>2]-i[A+8>>2]>>3,0),f=i[A+8>>2],k=i[A+12>>2],(f|0)!=(k|0))for(;A=i[f>>2],Y1(e,r,A,A>>31),A=i[f+4>>2],Y1(e,r,A,A>>31),f=f+8|0,(k|0)!=(f|0););}function Vu(A){var e=0,r=0,f=0,k=0,n=0;if(f=i[A>>2],e=t[f|0]-48|0,e>>>0>9)return 0;for(;k=-1,r>>>0<=214748364&&(r=g(r,10),k=(r^2147483647)>>>0<e>>>0?-1:r+e|0),e=f+1|0,i[A>>2]=e,n=t[f+1|0],r=k,f=e,e=n-48|0,e>>>0<10;);return r}function My(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,e=i[28734],i[A>>2]=i[28733],i[A+4>>2]=e,e=A+8|0;i:{if(t[114951]>=0){r=i[28736],i[e>>2]=i[28735],i[e+4>>2]=r,i[e+8>>2]=i[28737];break i}T(e,i[28735],i[28736])}t[A+20|0]=1}function Hy(A,e){if(A=A|0,e=e|0,!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}if(i[e>>2]>=7){e=i[25775],i[A>>2]=i[25774],i[A+4>>2]=e,i[A+8>>2]=i[25776];return}Ml(e),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}function pu(A){var e=0,r=0,f=0;A=i[A+48>>2],r=i[A+160>>2],e=i[A+164>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),r?(A=i[r+128>>2],r=i[r+132>>2]):(A=0,r=0);i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return h0=r,A}function zy(A){A=A|0;var e=0,r=0,f=0;if(e=l2(23426),e>>>0<2147483640){i:{e:{if(e>>>0>=11){r=e|7,f=C(r+1|0),i[A+8>>2]=r-2147483647,i[A>>2]=f,i[A+4>>2]=e,A=f;break e}if(t[A+11|0]=e,!e)break i}if(!e)break i;z(A,23426,e)}t[A+e|0]=0;return}I0(),M()}function xy(A,e){A=A|0,e=e|0;var r=0;e=Z0(e,92792,92836);i:{if(!e|u[A+104|0]!=u[e+104|0]|(i[A+112>>2]!=i[e+112>>2]|i[A+116>>2]!=i[e+116>>2]|i[A+120>>2]!=i[e+120>>2])||i[A+124>>2]!=i[e+124>>2])break i;r=u[A+128|0]==u[e+128|0]}return r|0}function Fu(A,e){var r=0,f=0,k=0;if(j2(+A),f=o2(1)|0,k=o2(0)|0,r=f>>>20&2047,(r|0)!=2047){if(!r)return A==0?r=0:(A=Fu(A*18446744073709552e3,e),r=i[e>>2]+-64|0),i[e>>2]=r,A;i[e>>2]=r-1022,T2(0,k|0),T2(1,f&-2146435073|1071644672),A=+s1()}return A}function Ty(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=i[i[e+72>>2]+108>>2],i[f>>2]=e,i[r>>2]=e?0:2,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function jy(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;return o=v-16|0,v=o,i[o+12>>2]=e,l=o+8|0,e=i[f+28>>2],i[l>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(l,137008),i2(l),Fs(A,n+24|0,o+12|0,r,k,e),v=o+16|0,i[o+12>>2]}function Sy(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;return o=v-16|0,v=o,i[o+12>>2]=e,l=o+8|0,e=i[f+28>>2],i[l>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(l,137008),i2(l),Vs(A,n+16|0,o+12|0,r,k,e),v=o+16|0,i[o+12>>2]}function Oy(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=u[i[e+72>>2]+110|0],i[f>>2]=e,i[r>>2]=e?0:2,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function Py(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;return o=v-16|0,v=o,i[o+12>>2]=e,l=o+8|0,e=i[f+28>>2],i[l>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(l,137e3),i2(l),Cs(A,n+24|0,o+12|0,r,k,e),v=o+16|0,i[o+12>>2]}function Ly(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;return o=v-16|0,v=o,i[o+12>>2]=e,l=o+8|0,e=i[f+28>>2],i[l>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(l,137e3),i2(l),ps(A,n+16|0,o+12|0,r,k,e),v=o+16|0,i[o+12>>2]}function qy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=C(20),i[f>>2]=0,i[f+4>>2]=0,i[f+16>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0,i[A+8>>2]=i[28481],k=i[28480],i[A>>2]=i[28479],i[A+4>>2]=k,A=vA(),i[f>>2]=A,kr(A,7,1),kr(A,8,1),t[f+4|0]=i[r+4>>2]!=0,i[e>>2]=f}function ay(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=u[i[e+72>>2]+121|0],i[f>>2]=e,i[r>>2]=e?0:2,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function oi(A){A=A|0;var e=0,r=0;if(A){e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}}function Ky(A,e){A=A|0,e=e|0;var r=0;e=Z0(e,92792,92848);i:{if(!e|u[A+104|0]!=u[e+104|0]|(i[A+112>>2]!=i[e+112>>2]|i[A+116>>2]!=i[e+116>>2]|u[A+120|0]!=u[e+120|0])||u[A+121|0]!=u[e+121|0])break i;r=u[A+122|0]==u[e+122|0]}return r|0}function s6(A,e,r){var f=0,k=0;i:{if(!w4(A,r)||(k=i[A>>2],f=i[A+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),k=W[i[i[k>>2]+16>>2]](k,e,r)|0,k||h8(A),!f)||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}return k}function $y(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=113304,f=i[A+100>>2],f){if(e=f,r=i[A+104>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+100>>2]}i[A+104>>2]=f,Z(e)}return n2(A)|0}function Cu(A,e,r,f){var k=0,n=0,o=0;n=i[A+4>>2],o=n&1;i:{if(u[e+55|0]==1){if(k=n>>8,!o)break i;k=i[i[r>>2]+k>>2];break i}if(k=n>>8,!o)break i;i[e+56>>2]=i[i[A>>2]+4>>2],n=i[A+4>>2],r=0,k=0}A=i[A>>2],W[i[i[A>>2]+28>>2]](A,e,r+k|0,n&2?f:2)}function v1(A){var e=0,r=0;i:{if(e=i[A+4>>2],r=i[i[e>>2]-12>>2],r=e+r|0,!i[r+24>>2]|(i[r+16>>2]|!(i[r+4>>2]&8192))||(e=i[(e+i[i[e>>2]-12>>2]|0)+24>>2],(W[i[i[e>>2]+24>>2]](e)|0)!=-1))break i;A=i[A+4>>2],z4(i[i[A>>2]-12>>2]+A|0,1)}}function Yu(A){var e=0,r=0;for(e=v-16|0,v=e,i[e+4>>2]=136832,r=i[34209],i[e+8>>2]=r,i[e+12>>2]=r+(A<<2),A=i[e+8>>2],r=i[e+12>>2];;){if((A|0)==(r|0))i[i[e+4>>2]+4>>2]=i[e+8>>2],v=e+16|0;else{i[A>>2]=0,A=A+4|0,i[e+8>>2]=A;continue}break}}function dy(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=93884,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}return n2(A)|0}function Ar(A,e){var r=0,f=0,k=0,n=0;return r=A*A,f=r*.5,k=1-f,n=1-k-f,f=r*r,k+(n+(r*(r*(r*(r*2480158728947673e-20+-.001388888888887411)+.0416666666666666)+f*f*(r*(r*-11359647557788195e-27+2087572321298175e-24)+-27557314351390663e-23))-A*e))}function by(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;return A=v-16|0,v=A,i[A+12>>2]=e,o=A+8|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(o,137008),i2(o),qs(n+20|0,A+12|0,r,k,e),v=A+16|0,i[A+12>>2]}function cy(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;return A=v-16|0,v=A,i[A+12>>2]=e,o=A+8|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(o,137e3),i2(o),as(n+20|0,A+12|0,r,k,e),v=A+16|0,i[A+12>>2]}function O3(A){var e=0,r=0;if(e=v-16|0,v=e,i[(i[i[A>>2]-12>>2]+A|0)+24>>2]){X1(e+8|0,A);i:{if(!u[e+8|0]||(r=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],(W[i[i[r>>2]+24>>2]](r)|0)!=-1))break i;z4(i[i[A>>2]-12>>2]+A|0,1)}v1(e+8|0)}v=e+16|0}function iE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+340>>2],f=i[r+344>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=t[r+27|0]<0?i[r+16>>2]:r+16|0}return k|0}function eE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+340>>2],f=i[r+344>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=t[r+39|0]<0?i[r+28>>2]:r+28|0}return k|0}function rE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+340>>2],f=i[r+344>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=t[r+15|0]<0?i[r+4>>2]:r+4|0}return k|0}function V2(A,e){var r=0,f=0,k=0;if(r=l2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,f=C(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=f,i[A+4>>2]=r;break e}if(t[A+11|0]=r,f=A,!r)break i}if(!r)break i;z(f,e,r)}return t[r+f|0]=0,A}I0(),M()}function fE(A,e){A=A|0,e=e|0;var r=0,f=0;r=255;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+80>>2];e:{if(i[A>>2]==(e|0)){r=i[A+12>>2];break e}for(;f=i[A+44>>2],r=A,A=A+44|0,(e|0)!=(f|0););r=i[r+56>>2]}}return r|0}function AE(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=113304,f=i[A+100>>2],f){if(e=f,r=i[A+104>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+100>>2]}i[A+104>>2]=f,Z(e)}Z(n2(A))}function kE(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=93884,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}Z(n2(A))}function P3(A,e){var r=0,f=0,k=0;f=A+140|0,A=i[A+140>>2];i:{e:{if(!A)break e;for(r=f;k=o0[A+16>>2]<e>>>0,r=k?r:A,A=i[(k?4:0)+A>>2],!!A;);if((r|0)==(f|0))break e;if(o0[r+16>>2]<=e>>>0)break i}r=f}return(r|0)!=(f|0)}function C6(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,k=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),t[f+12|0]=k,t[f+13|0]=k>>>8,t[f+14|0]=k>>>16,t[f+15|0]=k>>>24,k=A+12|0,n=f+12|0,f=f+16|0,V4(k,i[A+16>>2],n,f,4),V4(k,i[A+16>>2],e,e+r|0,r),v=f}function yu(A,e){var r=0,f=0,k=0;f=A+20|0,A=i[A+20>>2];i:{e:{if(!A)break e;for(r=f;k=o0[A+16>>2]<e>>>0,r=k?r:A,A=i[(k?4:0)+A>>2],!!A;);if((r|0)==(f|0))break e;if(o0[r+16>>2]<=e>>>0)break i}r=f}return(r|0)!=(f|0)}function nE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+340>>2],f=i[r+344>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=i[r+44>>2]-i[r+40>>2]|0}return k|0}function R1(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,f=i[A+4>>2],n=i[A+8>>2]&2147483647;i:{if(n>>>0>r>>>0){f=i[A>>2],i[A+4>>2]=r,A=!r,A|A||z(f,e,r),t[k+15|0]=0,t[r+f|0]=u[k+15|0];break i}De(A,n-1|0,(r-n|0)+1|0,f,0,f,r,e)}v=k+16|0}function m1(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,n=u[A+11|0],f=n&127;i:{if(r>>>0<=10){t[A+11|0]=n&128|r&127,t[A+11|0]=u[A+11|0]&127,f=!r,f|f||z(A,e,r),t[k+15|0]=0,t[A+r|0]=u[k+15|0];break i}De(A,10,r-10|0,f,0,f,r,e)}v=k+16|0}function tE(A,e){A=A|0,e=e|0;var r=0,f=0;r=W[i[i[A>>2]+68>>2]](i[A+4>>2])|0,A=i[r>>2];i:{if(!A)break i;for(;;){if(v4(i[A+4>>2],e)){if(A=i[r+4>>2],r=r+4|0,A)continue;break i}break}if(f=1,i[A>>2]<2)break i;f=i[A+36>>2]}return f|0}function Eu(A,e){var r=0,f=0;if((A|0)!=(e|0)){if(r=t[e+11|0],t[A+11|0]>=0){if((r|0)>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];return}m1(A,i[e>>2],i[e+4>>2]);return}f=A,A=(r|0)<0,R1(f,A?i[e>>2]:e,A?i[e+4>>2]:r)}}function c4(A,e,r){if(r=i[r+4>>2]&176,(r|0)==32)return e;i:{if((r|0)!=16)break i;e:{r:switch(r=u[A|0],r-43|0){case 0:case 2:break r;default:break e}return A+1|0}if((r|0)!=48|(e-A|0)<2|(u[A+1|0]|32)!=120)break i;A=A+2|0}return A}function oE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}if(f=i[i[e>>2]+60>>2],f){W[f|0](A,i[e+4>>2],r);return}e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function lE(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+80>>2];e:{if(i[A>>2]==(e|0)){r=i[A+4>>2];break e}for(;f=i[A+44>>2],r=A,A=A+44|0,(e|0)!=(f|0););r=i[r+48>>2]}}return r|0}function uE(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+80>>2];e:{if(i[A>>2]==(e|0)){r=i[A+20>>2];break e}for(;f=i[A+44>>2],r=A,A=A+44|0,(e|0)!=(f|0););r=i[r+64>>2]}}return r|0}function sE(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+80>>2];e:{if(i[A>>2]==(e|0)){r=i[A+24>>2];break e}for(;f=i[A+44>>2],r=A,A=A+44|0,(e|0)!=(f|0););r=i[r+68>>2]}}return r|0}function hE(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+80>>2];e:{if(i[A>>2]==(e|0)){r=p[A+16>>1];break e}for(;f=i[A+44>>2],r=A,A=A+44|0,(e|0)!=(f|0););r=p[r+60>>1]}}return r|0}function wE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{if(!u[A+44|0])for(r=(r|0)>0?r:0;;){if((r|0)==(f|0))break i;if((W[i[i[A>>2]+52>>2]](A,i[e>>2])|0)==-1)return f|0;e=e+4|0,f=f+1|0}r=r4(e,4,r,i[A+32>>2])}return r|0}function _E(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{if(!u[A+44|0])for(r=(r|0)>0?r:0;;){if((r|0)==(f|0))break i;if((W[i[i[A>>2]+52>>2]](A,u[e|0])|0)==-1)return f|0;e=e+1|0,f=f+1|0}r=r4(e,1,r,i[A+32>>2])}return r|0}function BE(A){A=A|0;var e=0,r=0;e=i[A>>2],A=i[e+248>>2],e=i[e+252>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),A=A?i[A+104>>2]-i[A+100>>2]>>4:0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function kr(A,e,r){A=A|0,e=e|0,r=r|0;i:switch(e|0){case 6:t[A+514|0]=(r|0)!=0;return;case 7:t[A+532|0]=(r|0)!=0;return;case 8:t[A+533|0]=(r|0)!=0;return;default:U0(13347,20012,535,10645),M();case 0:break i}t[A+512|0]=(r|0)!=0}function vE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0;return r=v-16|0,v=r,k=r+4|0,W[i[A>>2]](k,e),e=t[r+15|0],n=(e|0)<0,A=n?i[r+8>>2]:e,f=E2(A+4|0),i[f>>2]=A,o=i[r+4>>2],A&&z(f+4|0,n?o:k,A),(e|0)<0&&Z(o),v=r+16|0,f|0}function mE(A,e){A=A|0,e=e|0;var r=0,f=0;r=C(20),i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[A+8>>2]=i[28481],f=i[28480],i[A>>2]=i[28479],i[A+4>>2]=f,A=vA(),i[r>>2]=A,kr(A,7,1),kr(A,8,1),t[r+4|0]=0,i[e>>2]=r}function ZE(A,e){A=A|0,e=e|0;var r=0,f=0;f=255;i:{if(!A||(r=i[A>>2],A=i[r+80>>2],r=i[r+84>>2],(A|0)==(r|0)))break i;for(;;){if(i[A>>2]!=(e|0)){if(A=A+44|0,(r|0)!=(A|0))continue;break i}break}f=i[A+12>>2]}return f|0}function Ru(){var A=0;return A=C(44),i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+40>>2]=0,i[A+32>>2]=0,i[A+36>>2]=1,i[A+24>>2]=1,i[A+28>>2]=0,t[A|0]=3,i[A+16>>2]=2,i[A+12>>2]=2,t[A+8|0]=1,A|0}function Ju(A,e){var r=0,f=0,k=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r=i[e+4>>2],r){if(r>>>0>=1073741824)break i;r=r<<2,f=C(r),i[A+4>>2]=f,i[A>>2]=f,k=r+f|0,i[A+8>>2]=k,r&&z(f,i[e>>2],r),i[A+4>>2]=k}return A}s0(),M()}function gE(A,e){A=A|0,e=e|0;var r=0,f=0;f=-1;i:{if(!A||(r=i[A>>2],A=i[r+80>>2],r=i[r+84>>2],(A|0)==(r|0)))break i;for(;;){if(i[A>>2]!=(e|0)){if(A=A+44|0,(r|0)!=(A|0))continue;break i}break}f=p[A+16>>1]}return f|0}function GE(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!A|!e||(r=i[A>>2],f=i[e>>2],(((r|0)<(f|0)?r:f)|0)!=1))break i;i[A+4>>2]=i[e+4>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=i[e+12>>2],i[A+16>>2]=i[e+16>>2],i[A+20>>2]=i[e+20>>2]}}function nr(A,e,r){var f=0,k=0,n=0,o=0;f=v-16|0,v=f,k=f+12|0,e=i[e+28>>2],i[k>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(k,137072),n=r,o=W[i[i[e>>2]+16>>2]](e)|0,i[n>>2]=o,W[i[i[e>>2]+20>>2]](A,e),i2(k),v=f+16|0}function p2(A,e,r,f){var k=0,n=0,o=0,l=0;return n=e^f,o=n>>31,k=e>>31,A=A^k,l=A-k|0,k=(e^k)-((A>>>0<k>>>0)+k|0)|0,A=f>>31,e=r^A,n=n>>31,A=O1(l,k,e-A|0,(A^f)-((A>>>0>e>>>0)+A|0)|0)^n,e=A-n|0,h0=(o^h0)-((A>>>0<n>>>0)+o|0)|0,e}function Nu(A){A=A|0;var e=0,r=0;e=i[A>>2],A=i[e+16>>2],e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),A=A?i[A+12>>2]-i[A+8>>2]|0:0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function tr(A,e,r){var f=0,k=0,n=0,o=0;f=v-16|0,v=f,k=f+12|0,e=i[e+28>>2],i[k>>2]=e,(e|0)!=136824&&(i[e+4>>2]=i[e+4>>2]+1),e=$0(k,137064),n=r,o=W[i[i[e>>2]+16>>2]](e)|0,t[n|0]=o,W[i[i[e>>2]+20>>2]](A,e),i2(k),v=f+16|0}function WE(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;i:{e:{r:{if(A&&(A=i[A>>2],u[A+112|0]))break r;if(r&&(X[r>>1]=0),r=0,A=0,f)break e;break i}if(r&&(X[r>>1]=p[A+96>>1]),!f)return 1;r=p[A+98>>1],A=1}X[f>>1]=r,r=A}return r|0}function L3(A,e,r,f,k,n){var o=0,l=0,s=0;if(r-1>>>0<=1){r=0,o=f>>>0<4?i[(f<<2)+56272>>2]:o,l=k,s=(o+A|0)-1>>>w8(o)|0,i[l>>2]=s,r=f>>>0<=3?i[(f<<2)+56288>>2]:r,l=n,s=(r+e|0)-1>>>w8(r)|0,i[l>>2]=s;return}i[k>>2]=A,i[n>>2]=e}function Du(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(!r)return 0;i:{e:{r:{if(!A||(A=i[A>>2],!A)||(f=Q0(A,e),!f))break r;if(A=0,e=i[f+52>>2],(e|0)<0)break i;A=i[f+40>>2];break e}e=0,A=0}i[r>>2]=e}return A|0}function XE(A){A=A|0;var e=0,r=0,f=0;return e=v-16|0,v=e,i[e+12>>2]=i[A+8>>2],r=C8(e+8|0,e+12|0),f=Vo(0,0,4),r=i[r>>2],r&&(i[33178]=(r|0)==-1?132592:r),v=e+16|0,f?-1:(A=i[A+8>>2],A?(hs(A)|0)==1|0:1)}function H5(A){var e=0,r=0,f=0;e=i[A+204>>2],f=i[A+208>>2];i:{if((e|0)!=(f|0))for(;;){if(r=1,i[e>>2]==6)break i;if(e=e+56|0,(f|0)==(e|0))break}if(A=i[A+200>>2],r=0,A>>>0>15)break i;r=43008>>>A|0}return r&1}function IE(A){A=A|0;var e=0,r=0,f=0;if(e=i[A+12>>2],e){if(r=i[e>>2],r){if(f=r,A=i[e+4>>2],(r|0)!=(A|0)){for(;t[A-1|0]<0&&Z(i[A-12>>2]),A=A-20|0,(r|0)!=(A|0););f=i[e>>2]}i[e+4>>2]=r,Z(f)}Z(e)}}function Uu(A,e,r,f,k,n){var o=0,l=0,s=0;o=v-16|0,v=o,t[o+15|0]=0,t[o+14|0]=n,t[o+13|0]=k,t[o+12|0]=37,n&&(k=u[o+13|0],t[o+13|0]=u[o+14|0],t[o+14|0]=k),l=r,s=T9(e,i[r>>2]-e|0,o+12|0,f,i[A>>2])+e|0,i[l>>2]=s,v=o+16|0}function QE(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,i[r>>2]=1,i[f>>2]=3,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function VE(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,i[r>>2]=0,i[f>>2]=3,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function pE(A,e){A=A|0,e=e|0;var r=0,f=0;r=i[A>>2],A=i[r+204>>2],r=i[r+208>>2];i:{if((A|0)==(r|0))break i;for(;;){if(i[A>>2]!=(e|0)){if(A=A+56|0,(r|0)!=(A|0))continue;break i}break}f=u[A+23|0]<<3&248}return(f||-1)|0}function FE(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!A||(r=i[A>>2],A=i[r+80>>2],r=i[r+84>>2],(A|0)==(r|0)))break i;for(;;){if(i[A>>2]!=(e|0)){if(A=A+44|0,(r|0)!=(A|0))continue;break i}break}f=p[A+8>>1]}return f|0}function CE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(r=v-16|0,v=r,ho(r+4|0,i[A>>2]),f=i[r+4>>2],k=i[r+8>>2],(f|0)!=(k|0))for(A=f;i[e>>2]=i[A>>2],e=e+4|0,A=A+4|0,(k|0)!=(A|0););f&&Z(f),v=r+16|0}function Mu(A,e,r,f){var k=0,n=0,o=0;k=v-16|0,v=k;i:{if((f|0)<0||(n=f>>>16&32767,n>>>0<16383)||(o=-1,n-16415>>>0<4294967264))break i;I6(k,A,e,r,f&65535|65536,16495-n|0),o=i[k>>2]}return v=k+16|0,o}function Pi(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{e:{r:{if(A&&(A=i[A>>2],A))break r;if(e=0,A=0,r)break e;break i}if(A=or(A,e),A?(f=i[A+52>>2]>>>2|0,e=i[A+40>>2]):e=0,A=e,!r)break i}i[r>>2]=f,A=e}return A|0}function YE(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,o=0;return e=v-16|0,v=e,k=e+4|0,W[A|0](k),r=t[e+15|0],n=(r|0)<0,A=n?i[e+8>>2]:r,f=E2(A+4|0),i[f>>2]=A,o=i[e+4>>2],A&&z(f+4|0,n?o:k,A),(r|0)<0&&Z(o),v=e+16|0,f|0}function Y6(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{e:{r:{if(A&&(A=i[A>>2],A))break r;if(e=0,A=0,r)break e;break i}if(A=or(A,e),A?(f=i[A+52>>2]>>>3|0,e=i[A+40>>2]):e=0,A=e,!r)break i}i[r>>2]=f,A=e}return A|0}function q3(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{e:{r:{if(A&&(A=i[A>>2],A))break r;if(e=0,A=0,r)break e;break i}if(A=or(A,e),A?(f=i[A+52>>2]>>>1|0,e=i[A+40>>2]):e=0,A=e,!r)break i}i[r>>2]=f,A=e}return A|0}function Hu(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{e:{r:{if(A&&(A=i[A>>2],A))break r;if(e=0,A=0,r)break e;break i}if(A=or(A,e),A?(f=i[A+52>>2]>>>4|0,e=i[A+40>>2]):e=0,A=e,!r)break i}i[r>>2]=f,A=e}return A|0}function yE(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function L0(A,e,r,f){var k=0,n=0,o=0,l=0,s=0,h=0;return k=r>>>16|0,n=A>>>16|0,h=g(k,n),o=r&65535,l=A&65535,s=g(o,l),n=(s>>>16|0)+g(n,o)|0,k=(n&65535)+g(k,l)|0,h0=(g(e,r)+h|0)+g(A,f)+(n>>>16)+(k>>>16)|0,s&65535|k<<16}function EE(A,e){A=A|0,e=e|0;var r=0;if(r=i[e+560>>2],i[A>>2]=i[e+556>>2],i[A+4>>2]=r,A=A+8|0,t[e+575|0]>=0){e=e+564|0,r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];return}T(A,i[e+564>>2],i[e+568>>2])}function or(A,e){var r=0,f=0,k=0;if(r=i[A+204>>2],A=i[A+208>>2],(r|0)!=(A|0))for(;;){if(f=i[r+4>>2],k=i[r+8>>2],f=ie(f,e,k-f>>2),((f||k)|0)!=i[r+8>>2])return r;if(r=r+56|0,(A|0)==(r|0))break}return 0}function zu(A,e,r,f){var k=0;if(e-1>>>0>1)return A;e=0,e=r>>>0<=3?i[(r<<2)+56272>>2]:e;i:switch(f|0){case 1:return(A+e|0)-1>>>w8(e)|0;case 0:return A>>>w8(e)|0;case 2:k=A>>>w8(e)|0;break;default:break i}return k}function xu(A,e,r,f){var k=0;if(e-1>>>0>1)return A;e=0,e=r>>>0<=3?i[(r<<2)+56288>>2]:e;i:switch(f|0){case 1:return(A+e|0)-1>>>w8(e)|0;case 0:return A>>>w8(e)|0;case 2:k=A>>>w8(e)|0;break;default:break i}return k}function RE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-16|0,v=r,f=i[e+64>>2];i:{if(i[f>>2]>=5){k=r+4|0,W[i[f+64>>2]](k,i[e+68>>2]),Gi(A,k);break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}v=r+16|0}function z5(A){A=A|0;var e=0,r=0,f=0,k=0;return f=Q6(A),k=W[i[A+12>>2]](A)|0,t[A|0]&1||(e=i[A+56>>2],r=i[A+52>>2],r&&(i[r+56>>2]=e),e&&(i[e+52>>2]=r),i[33139]==(A|0)&&(i[33139]=e),Z(i[A+96>>2]),Z(A)),f|k}function JE(A,e){A=A|0,e=e|0;var r=0;r=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[A+16>>2]=r,r=i[A+20>>2],i[A+20>>2]=e;i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}}function NE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;i:{if((e|0)<16||(e=u[A+12|0],!e)||(r=u[A+13|0],!r)||(f=u[A+14|0],!f)||(A=u[A+15|0],!A))break i;k=A|(r<<16|e<<24|f<<8)}return k|0}function Tu(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{e:{r:{if(A&&(A=i[A>>2],A))break r;if(e=0,A=0,r)break e;break i}if(A=or(A,e),A?(f=i[A+52>>2],e=i[A+40>>2]):e=0,A=e,!r)break i}i[r>>2]=f,A=e}return A|0}function DE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;if(k=i[e+12>>2],i[e+12>>2]=i[A+124>>2],f=i[A+104>>2],A=i[A+108>>2],(f|0)!=(A|0))for(;p0(e,i[f>>2]+r|0),f=f+4|0,(A|0)!=(f|0););i[e+12>>2]=k}function ju(A){var e=0,r=0;e=i[A+48>>2],A=i[e+160>>2],e=i[e+164>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),A=A?i[A+120>>2]:0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A}function UE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,o=0;A=i[A>>2],r=i[A+44>>2],f=i[A+48>>2],k=i[A+36>>2],n=i[A+40>>2],o=i[A+56>>2],i[e+16>>2]=i[A+52>>2],i[e+20>>2]=o,i[e+8>>2]=r,i[e+12>>2]=f,i[e>>2]=k,i[e+4>>2]=n}function Li(){var A=0;return A=C(40),X[A+2>>1]=0,X[A+4>>1]=0,X[A>>1]=264,i[A+36>>2]=0,t[A+32|0]=1,t[A+28|0]=0,i[A+20>>2]=2,i[A+24>>2]=2,t[A+16|0]=1,i[A+12>>2]=1,t[A+5|0]=0,t[A+6|0]=0,t[A+7|0]=0,t[A+8|0]=0,A|0}function Su(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;i:{if((e|0)<12||(e=u[A+8|0],!e)||(r=u[A+9|0],!r)||(f=u[A+10|0],!f)||(A=u[A+11|0],!A))break i;k=A|(r<<16|e<<24|f<<8)}return k|0}function x5(A,e){var r=0,f=0,k=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r=i[e+4>>2],r){if((r|0)<0)break i;f=C(r),i[A+4>>2]=f,i[A>>2]=f,k=r+f|0,i[A+8>>2]=k,r&&z(f,i[e>>2],r),i[A+4>>2]=k}return A}s0(),M()}function h6(A,e){var r=0,f=0;r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;i:{if(t[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2];break i}T(r,i[e+8>>2],i[e+12>>2])}t[A+20|0]=1}function Z8(A,e){var r=0,f=0;return r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,t[e+19|0]>=0?(e=e+8|0,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2],A):(T(r,i[e+8>>2],i[e+12>>2]),A)}function T5(A){A=A|0;var e=0,r=0,f=0;return A=i[A>>2],e=i[A+48>>2],A=i[A+52>>2],A?(r=i[A+4>>2],f=r+1|0,i[A+4>>2]=f,e=i[e+144>>2],i[A+4>>2]=r,f||(W[i[i[A>>2]+8>>2]](A),y(A)),e|0):i[e+144>>2]}function ME(A,e,r){if(A=A|0,e=e|0,r=r|0,F4(r,e+4|0),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function HE(A,e){A=A|0,e=e|0;var r=0;r=i[e+4>>2],i[A+36>>2]=i[e>>2],i[A+40>>2]=r,r=i[e+12>>2],i[A+44>>2]=i[e+8>>2],i[A+48>>2]=r,r=i[e+20>>2],i[A+52>>2]=i[e+16>>2],i[A+56>>2]=r,u[A+60|0]||(t[A+60|0]=1)}function zE(A,e,r){if(A=A|0,e=e|0,r=r|0,i[e+8>>2]!=3){e=i[25827],i[A>>2]=i[25826],i[A+4>>2]=e,i[A+8>>2]=i[25828];return}r&&(i[r>>2]=i[e+16>>2]),e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e,i[A+8>>2]=i[25680]}function xE(A,e,r){if(A=A|0,e=e|0,r=r|0,F4(r,e+8|0),e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function Ou(A,e){A=A|0,e=e|0;var r=0;return A=i[A>>2],r=i[A+48>>2],A=i[A+52>>2],A?(i[A+4>>2]=i[A+4>>2]+1,e=X8(r,e),r=i[A+4>>2],i[A+4>>2]=r-1,r||(W[i[i[A>>2]+8>>2]](A),y(A)),e|0):X8(r,e)|0}function TE(A,e){A=A|0,e=e|0;var r=0;r=p[e>>1]|p[e+2>>1]<<16,X[A+6>>1]=r,X[A+8>>1]=r>>>16,e=u[e+3|0]|u[e+4|0]<<8|(u[e+5|0]<<16|u[e+6|0]<<24),t[A+9|0]=e,t[A+10|0]=e>>>8,t[A+11|0]=e>>>16,t[A+12|0]=e>>>24}function j5(A,e){var r=0,f=0,k=0;r=i[A+104>>2],A=i[A+108>>2];i:{if((r|0)==(A|0))break i;for(;;){if(f=i[r>>2],f>>>0<=e>>>0){if(e=e-f|0,r=r+8|0,(A|0)!=(r|0))continue;break i}break}k=i[r+4>>2]}return k}function Pu(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(e>>>0<3)return f=i[((e<<2)+A|0)+64>>2],r&&(i[r>>2]=g(i[(e?44:40)+A>>2],(i[i[A+124>>2]+(e?16840:16832)>>2]+7|0)/8|0)),f|0;U0(23483,20012,671,14027),M()}function W4(A,e,r,f,k){var n=0;if(n=v-256|0,v=n,!(k&73728|(r|0)<=(f|0))){if(f=r-f|0,r=f>>>0<256,Ni(n,e,r?f:256),!r)for(;m4(A,n,256),f=f-256|0,f>>>0>255;);m4(A,n,f)}v=n+256|0}function jE(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function lr(A,e){var r=0,f=0;f=v-16|0,v=f,t[A|0]=0,r=i[i[e>>2]-12>>2]+e|0;i:{if(!i[r+16>>2]){i[r+72>>2]&&O3(i[r+72>>2]),t[A|0]=!i[(i[i[e>>2]-12>>2]+e|0)+16>>2];break i}z4(r,4)}return v=f+16|0,A}function SE(A,e){A=A|0,e=e|0;var r=0,f=0;e=$0(e,137016),i[A+36>>2]=e,r=A,f=W[i[i[e>>2]+24>>2]](e)|0,i[r+44>>2]=f,e=i[A+36>>2],r=A,f=W[i[i[e>>2]+28>>2]](e)|0,t[r+53|0]=f,i[A+44>>2]>=9&&(N1(),M())}function Lu(A,e){var r=0,f=0;if(r=i[A+8>>2],A=i[A+12>>2],(r|0)!=(A|0))for(A=A-r>>2,f=A>>>0<=1?1:A,A=0;;){if(i[i[(A<<2)+r>>2]>>2]==(e|0))return A;if(A=A+1|0,(f|0)==(A|0))break}return-1}function OE(A,e){A=A|0,e=e|0;var r=0,f=0;e=$0(e,137024),i[A+36>>2]=e,r=A,f=W[i[i[e>>2]+24>>2]](e)|0,i[r+44>>2]=f,e=i[A+36>>2],r=A,f=W[i[i[e>>2]+28>>2]](e)|0,t[r+53|0]=f,i[A+44>>2]>=9&&(N1(),M())}function PE(A){A=A|0;var e=0,r=0,f=0;e=v-16|0,v=e,m3(e+4|0,A,0),r=i[e+8>>2],A=i[e+4>>2];i:{e:{if((r|0)!=(A|0)){f=i[i[A>>2]>>2];break e}if(!r)break i}i[e+8>>2]=A,Z(A)}return v=e+16|0,(f|0)!=0|0}function qi(A,e){var r=0;r=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[A>>2]=r,r=i[A+4>>2],i[A+4>>2]=e;i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}}function qu(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,n=i[A+48>>2],A=C(4),i[f+4>>2]=A,k=A+4|0,i[f+12>>2]=k,i[A>>2]=r,i[f+8>>2]=k,o8(n,e,1835103083,f+4|0),A=i[f+4>>2],A&&(i[f+8>>2]=A,Z(A)),v=f+16|0}function LE(A){A=A|0;var e=0,r=0,f=0,k=0;i:{if(!A||(e=u[A|0],!e)||(r=u[A+1|0],!r)||(f=u[A+2|0],!f)||(A=u[A+3|0],!A))break i;k=A|(r<<16|e<<24|f<<8)}return k|0}function Q8(A,e){var r=0,f=0;r=i[e>>2],f=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,e=i[A+4>>2],i[A>>2]=r,i[A+4>>2]=f;i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}}function ur(A,e){var r=0,f=0;return r=v-16|0,v=r,f=r+12|0,A=i[A+28>>2],i[f>>2]=A,(A|0)!=136824&&(i[A+4>>2]=i[A+4>>2]+1),A=$0(f,137e3),W[i[i[A>>2]+48>>2]](A,83888,83914,e)|0,i2(f),v=r+16|0,e}function qE(A,e){A=A|0,e=e|0;var r=0;r=i[e+4>>2],A=i[A>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+16>>2]=i[e+16>>2],r=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=r,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0}function au(A){A=A|0;var e=0,r=0;i:{if(i[A+2192>>2]<=0||(e=i[A+2188>>2],e=i[i[i[A+2176>>2]+(e>>>8&16777212)>>2]+((e&1023)<<2)>>2],!e))break i;t[e+104|0]=0,ns(A+2140|0),r=e}return r|0}function Ku(A,e){var r=0,f=0;i:{if(r=i[A>>2],!r)break i;f=i[r+24>>2];e:{if((f|0)==i[r+28>>2]){e=W[i[i[r>>2]+52>>2]](r,e)|0;break e}i[r+24>>2]=f+4,i[f>>2]=e}if((e|0)!=-1)break i;i[A>>2]=0}}function $u(A,e){var r=0,f=0;f=32767,r=i[A+80>>2],A=i[A+84>>2];i:{if((r|0)==(A|0))break i;for(;;){if(i[r>>2]!=(e|0)){if(r=r+44|0,(A|0)!=(r|0))continue;break i}break}f=p[r+8>>1]}return f}function S5(A){var e=0;return e=i[A+72>>2],i[A+72>>2]=e-1|e,e=i[A>>2],e&8?(i[A>>2]=e|32,-1):(i[A+4>>2]=0,i[A+8>>2]=0,e=i[A+44>>2],i[A+28>>2]=e,i[A+20>>2]=e,i[A+16>>2]=e+i[A+48>>2],0)}function du(A,e,r,f){i:{if(!A)break i;e:switch(e+2|0){case 0:t[A|0]=r;return;case 1:X[A>>1]=r;return;case 2:case 3:i[A>>2]=r;return;case 5:break e;default:break i}i[A>>2]=r,i[A+4>>2]=f}}function O5(A,e,r,f,k,n,o,l,s){var h=0;h=v-16|0,v=h,j4(h,e,r,f,k,n,o,l,s^-2147483648),f=i[h>>2],r=i[h+4>>2],e=i[h+12>>2],i[A+8>>2]=i[h+8>>2],i[A+12>>2]=e,i[A>>2]=f,i[A+4>>2]=r,v=h+16|0}function aE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;return f=i[A+36>>2],k=i[A+32>>2],(r|0)==(f|0)&k>>>0>=e>>>0|r>>>0<f>>>0&&(i[A+40>>2]=e,i[A+44>>2]=r),(r|0)==(f|0)&e>>>0<=k>>>0|r>>>0<f>>>0}function v4(A,e){var r=0,f=0;r=u[A|0],f=u[e|0];i:{if(!r|(r|0)!=(f|0))break i;for(;;){if(f=u[e+1|0],r=u[A+1|0],!r)break i;if(e=e+1|0,A=A+1|0,(r|0)!=(f|0))break}}return r-f|0}function KE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;return k=i[A+84>>2],f=r+256|0,n=l5(k,0,f),f=n?n-k|0:f,r=r>>>0>f>>>0?f:r,v8(e,k,r),e=k+f|0,i[A+84>>2]=e,i[A+8>>2]=e,i[A+4>>2]=r+k,r|0}function $E(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0,l=0;return o=v-16|0,v=o,i[o+8>>2]=624576549,i[o+12>>2]=1394948685,l=A,A=o+16|0,e=k6(l,e,r,f,k,n,o+8|0,A),v=A,e|0}function bu(A,e){if(A=A|0,e=e|0,e=i[28729],i[A>>2]=i[28728],i[A+4>>2]=e,A=A+8|0,t[114931]>=0){e=i[28731],i[A>>2]=i[28730],i[A+4>>2]=e,i[A+8>>2]=i[28732];return}T(A,i[28730],i[28731])}function V8(A,e){var r=0,f=0;r=i[A+204>>2],A=i[A+208>>2];i:{if((r|0)==(A|0))break i;for(;;){if(i[r>>2]!=(e|0)){if(r=r+56|0,(A|0)!=(r|0))continue;break i}break}f=i[r+24>>2]}return f}function p8(A,e){var r=0,f=0;r=i[A+204>>2],A=i[A+208>>2];i:{if((r|0)==(A|0))break i;for(;;){if(i[r>>2]!=(e|0)){if(r=r+56|0,(A|0)!=(r|0))continue;break i}break}f=i[r+28>>2]}return f}function K0(A,e){var r=0,f=0;r=i[A+204>>2],A=i[A+208>>2];i:{if((r|0)==(A|0))break i;for(;;){if(i[r>>2]!=(e|0)){if(r=r+56|0,(A|0)!=(r|0))continue;break i}break}f=p[r+20>>1]}return f}function cu(A,e){var r=0;i:{if(!e||(e=Z0(e,91032,91276),!e|i[e+8>>2]&(i[A+8>>2]^-1))||!i4(i[A+12>>2],i[e+12>>2],0))break i;r=i4(i[A+16>>2],i[e+16>>2],0)}return r}function is(A,e){var r=0,f=0;f=v-32|0,v=f,r=i[e+40>>2];i:{if(!r){i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A>>2]=r,r=A,A=i[e+44>>2],i[r+4>>2]=A,!A)break i;i[A+4>>2]=i[A+4>>2]+1}v=f+32|0}function dE(A){return A=A|0,i[A>>2]=95520,t[A+151|0]<0&&Z(i[A+140>>2]),t[A+139|0]<0&&Z(i[A+128>>2]),t[A+127|0]<0&&Z(i[A+116>>2]),t[A+115|0]<0&&Z(i[A+104>>2]),n2(A)|0}function bE(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,!(f&&r)){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}e=C(8),r=i[r>>2],i[e+4>>2]=0,i[e>>2]=r,i[f>>2]=e,o7(A,e)}function cE(A){return A=A|0,i[A>>2]=93496,t[A+163|0]<0&&Z(i[A+152>>2]),t[A+151|0]<0&&Z(i[A+140>>2]),t[A+139|0]<0&&Z(i[A+128>>2]),t[A+127|0]<0&&Z(i[A+116>>2]),n2(A)|0}function iR(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;return f=i[A+36>>2],k=i[A+32>>2],(r|0)==(f|0)&k>>>0>=e>>>0|r>>>0<f>>>0&&W5(i[A+24>>2],e,r,0),(r|0)==(f|0)&e>>>0<=k>>>0|r>>>0<f>>>0}function eR(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,A=v-16|0,v=A,i[A+12>>2]=k,i[A+8>>2]=f-r,e=v-16|0,v=e,v=e+16|0,v=A+16|0,e=A+8|0,A=A+12|0,i[(o0[e>>2]<o0[A>>2]?e:A)>>2]}function y6(A){var e=0,r=0;return u[A+11|0]>>>7|0?e=i[A>>2]:e=A,u[A+11|0]>>>7|0?r=i[A+4>>2]:r=u[A+11|0]&127,A=v-16|0,v=A,i[A+12>>2]=(r<<2)+e,v=A+16|0,i[A+12>>2]}function a3(A,e,r,f){var k=0;return k=v-16|0,v=k,r=ni(i[A+120>>2],r),A=i[A+128>>2],r=r+1|0,X[k+14>>1]=r,t[k+12|0]=f,i[k+8>>2]=p[k+12>>1]|p[k+14>>1]<<16,U4(A,e,k+8|0),v=k+16|0,r}function F8(A){A=A|0;var e=0;return e=i[19543],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[19551],i[A+12>>2]=77200,i[A+8>>2]=i[19552],t[A+55|0]<0&&Z(i[A+44>>2]),y0(A+12|0),Y0(A- -64|0),A|0}function rR(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=v-32|0,v=k,S2(k+12|0,e,r),t[k+31|0]<0&&Z(i[k+20>>2]);i:{if(u[e+97|0]){B1(A,e,20080);break i}Xi(A,e,r,-1,f)}v=k+32|0}function sr(A,e){var r=0;r=i[A+148>>2];i:{if(r){A=i[r>>2];break i}r=C(16),i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101440,i[A+148>>2]=r,A=101440}return W[i[A+8>>2]](r,e)|0}function fR(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){if((e|0)!=(r|0)){A=i[e>>2],A>>>0<=127?A=i[(A<<2)+84208>>2]:A=0,i[f>>2]=A,f=f+4|0,e=e+4|0;continue}break}return e|0}function ai(A){var e=0,r=0;e=i[28685],r=A+7&-8,A=e+r|0;i:{if(!(A>>>0<=e>>>0&&r)&&(A>>>0<=Iw()<<16>>>0||qB(A|0)|0))break i;return i[33136]=48,-1}return i[28685]=A,e}function Ki(A,e,r){if(A=A|0,e=e|0,r=r|0,!r)return 0;i:{if(!A||(A=i[A>>2],!A)||(A=Q0(A,e),!A))break i;return i[r>>2]=i[A+52>>2],i[A+40>>2]}return i[r>>2]=0,0}function AR(A){A=A|0,i[A>>2]=95520,t[A+151|0]<0&&Z(i[A+140>>2]),t[A+139|0]<0&&Z(i[A+128>>2]),t[A+127|0]<0&&Z(i[A+116>>2]),t[A+115|0]<0&&Z(i[A+104>>2]),Z(n2(A))}function kR(A){A=A|0,i[A>>2]=93496,t[A+163|0]<0&&Z(i[A+152>>2]),t[A+151|0]<0&&Z(i[A+140>>2]),t[A+139|0]<0&&Z(i[A+128>>2]),t[A+127|0]<0&&Z(i[A+116>>2]),Z(n2(A))}function E6(A){var e=0,r=0;return u[A+11|0]>>>7|0?e=i[A>>2]:e=A,u[A+11|0]>>>7|0?r=i[A+4>>2]:r=u[A+11|0]&127,A=v-16|0,v=A,i[A+12>>2]=e+r,v=A+16|0,i[A+12>>2]}function es(A){var e=0,r=0;if(e=i[A>>2],e){r=i[e+12>>2];i:{if((r|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break i}e=i[r>>2]}if((e|0)!=-1)return!i[A>>2];i[A>>2]=0}return 1}function X4(A,e,r,f,k){var n=0;return n=v-16|0,v=n,i[n+12>>2]=r,i[n+8>>2]=k,r=C8(n+4|0,n+12|0),e=S3(A,e,f,i[n+8>>2]),A=i[r>>2],A&&(i[33178]=(A|0)==-1?132592:A),v=n+16|0,e}function rs(A){var e=0,r=0;if(e=i[A>>2],e){r=i[e+12>>2];i:{if((r|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break i}e=u[r|0]}if((e|0)!=-1)return!i[A>>2];i[A>>2]=0}return 1}function fs(A,e){var r=0,f=0,k=0;r=v-16|0,v=r,bA(r,0,0,0,1073676288,e),e=i[r>>2],f=i[r+4>>2],k=i[r+12>>2],i[A+8>>2]=i[r+8>>2],i[A+12>>2]=k,i[A>>2]=e,i[A+4>>2]=f,v=r+16|0}function nR(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;h2(e,5),f=i[A+4>>2],Y1(e,r,f,f>>31),f=i[A+8>>2],Y1(e,r,f,f>>31),Y1(e,r,i[A+12>>2],0),Y1(e,r,i[A+16>>2],0),h2(e,0),F4(e,A+20|0)}function tR(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){i:{if((r|0)==(f|0)||(A=i[r>>2],A>>>0>127|!(i[(A<<2)+84208>>2]&e)))break i;r=r+4|0;continue}break}return r|0}function P5(A,e){var r=0,f=0;r=v-16|0,v=r;i:{if(!(u[e+11|0]>>>7|0)){i[A+8>>2]=i[e+8>>2],f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f;break i}T(A,i[e>>2],i[e+4>>2])}v=r+16|0}function As(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=e,i[f+8>>2]=r,e=C8(f+4|0,f+12|0),r=E9(A,8644,i[f+8>>2]),A=i[e>>2],A&&(i[33178]=(A|0)==-1?132592:A),v=f+16|0,r}function oR(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){i:{if((r|0)==(f|0)||(A=i[r>>2],i[(A<<2)+84208>>2]&e&&A>>>0<=127))break i;r=r+4|0;continue}break}return r|0}function K3(A,e){A=A|0,e=e|0;var r=0;!u[A|0]|!u[e|0]||(r=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=r,i[A+16>>2]=i[e+16>>2],i[A+20>>2]=i[e+20>>2],t[A+24|0]=u[e+24|0])}function ks(){var A=0,e=0;return A=v-16|0,v=A,i[A+12>>2]=1073741823,i[A+8>>2]=2147483647,e=v-16|0,v=e,v=e+16|0,v=A+16|0,e=A+8|0,A=A+12|0,i[(o0[e>>2]<o0[A>>2]?e:A)>>2]}function a(A,e,r,f){return i[A+4>>2]=r,i[A>>2]=e,e=A+8|0,t[f+11|0]>=0?(r=i[f+4>>2],i[e>>2]=i[f>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+8>>2],A):(T(e,i[f>>2],i[f+4>>2]),A)}function lR(A,e){A=A|0,e=e|0;var r=0,f=0;i:{e:{if((e|0)>0){for(;;)if(f=i[((r<<4)+A|0)+8>>2],f&&Z(f),r=r+1|0,(r|0)==(e|0))break e}if(!A)break i}Z(A)}}function L5(A,e){var r=0;if(e){L5(A,i[e>>2]),L5(A,i[e+4>>2]),A=i[e+24>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}Z(e)}}function hr(A,e){var r=0;if(e){hr(A,i[e>>2]),hr(A,i[e+4>>2]),A=i[e+24>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}Z(e)}}function $3(A,e){var r=0;if(e){$3(A,i[e>>2]),$3(A,i[e+4>>2]),A=i[e+24>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}Z(e)}}function li(A,e){A=A|0,e=e|0;var r=0;!u[A|0]|!u[e|0]||(r=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=r,t[A+16|0]=u[e+16|0],t[A+18|0]=u[e+18|0],t[A+17|0]=u[e+17|0])}function $2(A,e){var r=0,f=0;if(r=i[A+204>>2],A=i[A+208>>2],(r|0)==(A|0))return 0;for(;f=i[r>>2]==(e|0),!f&&(r=r+56|0,(A|0)!=(r|0)););return f}function ns(A){var e=0;i[A+52>>2]=i[A+52>>2]-1,e=i[A+48>>2]+1|0,i[A+48>>2]=e,e>>>0>=2048&&(Z(i[i[A+36>>2]>>2]),i[A+36>>2]=i[A+36>>2]+4,i[A+48>>2]=i[A+48>>2]-1024)}function ts(A,e){var r=0,f=0;return i[A>>2]=91984,i[A>>2]=92096,r=l2(e),f=C(r+13|0),i[f+8>>2]=0,i[f+4>>2]=r,i[f>>2]=r,f=f+12|0,r=r+1|0,r&&z(f,e,r),i[A+4>>2]=f,A}function os(A,e,r){var f=0;if(W[i[i[A>>2]+28>>2]](A,e,r),f=i[A+36>>2],A=i[A+40>>2],(f|0)!=(A|0))for(;os(i[f>>2],e,r),f=f+8|0,(A|0)!=(f|0););}function wr(A,e,r,f){var k=0;return k=i[e>>2],i[A>>2]=k,e=i[e+4>>2],t[A+20|0]=0,i[A+16>>2]=f-r,i[A+8>>2]=0,i[A+12>>2]=0,i[A+4>>2]=e,W[i[i[k>>2]+20>>2]](k,r,0)|0,A}function uR(A){A=A|0;var e=0,r=0;i[A>>2]=101860,e=i[A+104>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return n2(A)|0}function sR(A){A=A|0;var e=0,r=0;i[A>>2]=106444,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return s8(A)|0}function hR(A){A=A|0;var e=0,r=0;i[A>>2]=105620,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return s8(A)|0}function wR(A){A=A|0;var e=0,r=0;i[A>>2]=104632,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return s8(A)|0}function _R(A){A=A|0;var e=0,r=0;i[A>>2]=107004,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return s8(A)|0}function BR(A){A=A|0;var e=0,r=0;i[A>>2]=104216,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return s8(A)|0}function vR(A){A=A|0;var e=0,r=0;i[A>>2]=105248,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return s8(A)|0}function mR(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;k=v-32|0,v=k,n=k+12|0,io(n,i[e>>2],r,f,0),c0(A,n,i[e>>2]),t[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function F2(A,e){var r=0;i:{if(u[A+11|0]>>>7|0?r=i[A+4>>2]:r=u[A+11|0]&127,r>>>0<e>>>0){C5(A,e-r|0);break i}r=A,u[A+11|0]>>>7|0&&(A=i[A>>2]),Rs(r,A,e)}}function ls(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;k=v-32|0,v=k,n=k+12|0,io(n,i[e>>2],r,f,1),c0(A,n,i[e>>2]),t[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function ZR(A){A=A|0;var e=0;e=i[A+52>>2],e&&(i[A+56>>2]=e,Z(e)),t[A+51|0]<0&&Z(i[A+40>>2]),t[A+39|0]<0&&Z(i[A+28>>2]),t[A+27|0]<0&&Z(i[A+16>>2])}function gR(A){A=A|0;var e=0,r=0;i[A>>2]=101860,e=i[A+104>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(n2(A))}function GR(A){A=A|0;var e=0,r=0;i[A>>2]=106444,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(s8(A))}function WR(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;for(A=0;;){if((e|0)!=(r|0)){A=i[e>>2]+(A<<4)|0,f=A&-268435456,A=(f|f>>>24)^A,e=e+4|0;continue}break}return A|0}function Q0(A,e){var r=0;if(r=i[A+204>>2],A=i[A+208>>2],(r|0)!=(A|0))for(;;){if(i[r>>2]==(e|0))return r;if(r=r+56|0,(A|0)==(r|0))break}return 0}function us(){var A=0,e=0;u[115884]||(t[115884]=1),A=i[28964],i[28964]=A+1;i:{if((A|0)>0||(N9(),H9()))break i;i[28964]=i[28964]-1,e=11}return e|0}function XR(A){A=A|0;var e=0,r=0;i[A>>2]=105620,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(s8(A))}function IR(A){A=A|0;var e=0,r=0;i[A>>2]=104632,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(s8(A))}function ss(A,e,r,f){var k=0;return k=v-16|0,v=k,A=jB(A|0,e|0,r|0,f&255,k+8|0)|0,A?(i[33136]=A,A=-1):A=0,v=k+16|0,h0=A?-1:i[k+12>>2],A?-1:i[k+8>>2]}function hs(A){var e=0,r=0;return e=v-16|0,v=e,i[e+12>>2]=A,A=C8(e+8|0,e+12|0),r=i[i[33178]>>2]?4:1,A=i[A>>2],A&&(i[33178]=(A|0)==-1?132592:A),v=e+16|0,r}function QR(A){A=A|0;var e=0,r=0;i[A>>2]=107004,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(s8(A))}function ws(){var A=0;return A=C(24),X[A+12>>1]=65535,t[A|0]=1,i[A+4>>2]=0,i[A+8>>2]=-1,X[A+14>>1]=52428,X[A+16>>1]=52428,X[A+18>>1]=52428,X[A+20>>1]=16,A|0}function VR(A){A=A|0;var e=0,r=0;i[A>>2]=104216,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(s8(A))}function pR(A){A=A|0;var e=0,r=0;i[A>>2]=105248,e=i[A+76>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(s8(A))}function FR(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;for(A=0;;){if((e|0)!=(r|0)){A=t[e|0]+(A<<4)|0,f=A&-268435456,A=(f|f>>>24)^A,e=e+1|0;continue}break}return A|0}function CR(A,e){A=A|0,e=e|0;var r=0;r=-1;i:{if(!A|(e|0)<4||(r=0,u[A|0]!=255|u[A+1|0]!=216|u[A+2|0]!=255))break i;r=(u[A+3|0]&240)==224}return r|0}function _s(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=r,i[f+8>>2]=e,A=iA(A|0,f+8|0,1,f+4|0)|0,A?(i[33136]=A,A=-1):A=0,v=f+16|0,A?-1:i[f+4>>2]}function YR(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=i[e>>2],A>>>0<=127&&(A=i[i[20197]+(A<<2)>>2]),i[e>>2]=A,e=e+4|0;continue}break}return e|0}function yR(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=i[e>>2],A>>>0<=127&&(A=i[i[20584]+(A<<2)>>2]),i[e>>2]=A,e=e+4|0;continue}break}return e|0}function ER(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,n=k+12|0,Jl(n,i[e>>2],f,r),c0(A,n,i[e>>2]),t[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function Bs(A,e,r,f,k){var n=0;return n=v-16|0,v=n,i[n+12>>2]=k,k=C8(n+8|0,n+12|0),e=ze(A,e,r,f),A=i[k>>2],A&&(i[33178]=(A|0)==-1?132592:A),v=n+16|0,e}function Y1(A,e,r,f){i:switch(e-1|0){case 0:h2(A,r&255);return;case 1:u2(A,r&65535);return;case 3:p0(A,r);return;case 7:h4(A,r,f);break;default:break i}}function RR(A){A=A|0;var e=0;return e=i[A+24>>2],i[A+24>>2]=0,i[A>>2]=92280,e&&W[i[i[e>>2]+4>>2]](e),i[A>>2]=92456,t[A+23|0]<0&&Z(i[A+12>>2]),A|0}function JR(A){return A=A|0,u[137116]?i[34278]:(u[138216]||(t[138216]=1),H2(138192,21112),H2(138204,21106),t[137116]=1,i[34278]=138192,138192)}function NR(A){return A=A|0,u[137124]?i[34280]:(u[138248]||(t[138248]=1),K2(138224,90712),K2(138236,90724),t[137124]=1,i[34280]=138224,138224)}function DR(A,e){A=A|0,e=e|0;var r=0;t[A+79|0]<0&&Z(i[A+68>>2]),r=i[e+4>>2],i[A+68>>2]=i[e>>2],i[A+72>>2]=r,i[A+76>>2]=i[e+8>>2],t[e+11|0]=0,t[e|0]=0}function q5(A,e,r){var f=0;return f=v-16|0,v=f,i[f+8>>2]=e,i[f+12>>2]=A,i[f+4>>2]=r,e=0,v=f+16|0,A=f+4|0,o0[A>>2]>=o0[f+12>>2]&&(e=o0[A>>2]<o0[f+8>>2]),e}function vs(A){var e=0;if(W[i[i[A>>2]+24>>2]](A),e=i[A+36>>2],A=i[A+40>>2],(e|0)!=(A|0))for(;vs(i[e>>2]),e=e+8|0,(A|0)!=(e|0););}function UR(A,e,r,f,k){for(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;;){if((e|0)!=(r|0)){A=i[e>>2],t[k|0]=A>>>0<128?A:f,k=k+1|0,e=e+4|0;continue}break}return e|0}function MR(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=t[e|0],(A|0)>=0&&(A=i[i[20197]+(A<<2)>>2]),t[e|0]=A,e=e+1|0;continue}break}return e|0}function HR(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=t[e|0],(A|0)>=0&&(A=i[i[20584]+(A<<2)>>2]),t[e|0]=A,e=e+1|0;continue}break}return e|0}function d3(A,e){var r=0,f=0;return r=v-16|0,v=r,f=A1(A,r+12|0),f&&(A=i[r+12>>2],A?A=A&1?A+1>>>1|0:0-(A>>>1|0)|0:A=0,i[e>>2]=A),v=r+16|0,f}function zR(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=i[e>>2],i[e+4>>2]=k,V4(e,k,r,r+f|0,f),i[A+8>>2]=i[25788],e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e}function xR(A){A=A|0;var e=0;return i[A>>2]=94684,e=i[A+124>>2],e&&(i[A+128>>2]=e,Z(e)),i[A>>2]=94524,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),n2(A)|0}function TR(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;h2(e,1),f=i[A+4>>2],Y1(e,r,f,f>>31),f=i[A+8>>2],Y1(e,r,f,f>>31),Y1(e,r,i[A+12>>2],0),Y1(e,r,i[A+16>>2],0)}function jR(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;h2(e,2),f=i[A+4>>2],Y1(e,r,f,f>>31),f=i[A+8>>2],Y1(e,r,f,f>>31),Y1(e,r,i[A+12>>2],0),Y1(e,r,i[A+16>>2],0)}function SR(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;h2(e,4),f=i[A+4>>2],Y1(e,r,f,f>>31),f=i[A+8>>2],Y1(e,r,f,f>>31),Y1(e,r,i[A+12>>2],0),Y1(e,r,i[A+16>>2],0)}function OR(A,e){A=A|0,e=e|0;var r=0;i:{r=i[e+332>>2];e:{if(!r)break e;if(jA(A,e,r),i[A>>2])break i;if(t[A+19|0]>=0)break e;Z(i[A+8>>2])}Dn(A,e)}}function n0(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,k=i[18381],n=u[e|0]==42,n||r4(37529,6,1,k),i[f+12>>2]=r,G3(A,e+n|0,r,2004,2005),Q6(k),v=f+16|0}function $i(A,e,r,f){return i[A>>2]=i[e>>2],e=i[e+4>>2],t[A+20|0]=0,i[A+16>>2]=r,i[A+12>>2]=0,i[A+8>>2]=f,i[A+4>>2]=e,f&&(i[A+12>>2]=i[f+12>>2]+1),A}function PR(A,e,r,f,k,n,o,l,s,h){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0,h=h|0;var w=0;return w=e,e=0,W[A|0](w,r,f,k,n,e|o,l,e|s,h)|0}function ms(A){A=A|0;var e=0;return e=1,i[A+4>>2]-32768>>>0<4294901760|i[A+8>>2]-32768>>>0<4294901760|o0[A+12>>2]>65535||(e=o0[A+16>>2]>65535),e|0}function LR(A){A=A|0;var e=0;e=i[A+24>>2],i[A+24>>2]=0,i[A>>2]=92280,e&&W[i[i[e>>2]+4>>2]](e),i[A>>2]=92456,t[A+23|0]<0&&Z(i[A+12>>2]),Z(A)}function qR(A,e,r,f,k){for(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;;){if((e|0)!=(r|0)){A=t[e|0],t[k|0]=(A|0)<0?f:A,k=k+1|0,e=e+1|0;continue}break}return e|0}function aR(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i4(A,i[e+8>>2],n)){I5(e,r,f,k);return}A=i[A+8>>2],W[i[i[A>>2]+20>>2]](A,e,r,f,k,n)}function Zs(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,k=f,n=R6(e),i[k+12>>2]=n,k=f,n=R6(r),i[k+8>>2]=n,i[A>>2]=i[f+12>>2],i[A+4>>2]=i[f+8>>2],v=f+16|0}function KR(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,e=i[A+32>>2],r=e,A=i[A+36>>2],e=(k|0)==(A|0)&e>>>0<f>>>0|A>>>0<k>>>0,h0=e?A:k,(e?r:f)|0}function a5(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=r,r=C8(f+8|0,f+12|0),e=J3(A,e),A=i[r>>2],A&&(i[33178]=(A|0)==-1?132592:A),v=f+16|0,e}function $R(A){A=A|0;var e=0;i[A>>2]=94684,e=i[A+124>>2],e&&(i[A+128>>2]=e,Z(e)),i[A>>2]=94524,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),Z(n2(A))}function dR(A,e,r){if(A=A|0,e=e|0,r=r|0,!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}W[i[i[e>>2]+44>>2]](A,i[e+4>>2],r)}function bR(A,e,r){if(A=A|0,e=e|0,r=r|0,!e){e=i[25146],i[A>>2]=i[25145],i[A+4>>2]=e,i[A+8>>2]=i[25147];return}W[i[i[e>>2]+52>>2]](A,i[e+4>>2],r)}function i8(A){A=A|0;var e=0,r=0;if(A){e=i[A+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}}function b3(A){var e=0,r=0;e=v-16|0,v=e,r=-1;i:{if(fr(A)||(W[i[A+32>>2]](A,e+15|0,1)|0)!=1)break i;r=u[e+15|0]}return v=e+16|0,r}function gs(A,e){var r=0;return r=e>>31,A=A^r,It(A-r|0,(e^r)-((A>>>0<r>>>0)+r|0)|0,100,0),h0=j6,A=r^T6,e=A-r|0,h0=(r^h0)-((A>>>0<r>>>0)+r|0)|0,e}function Gs(A){var e=0,r=0;if(e=i[A+104>>2],A=i[A+108>>2],(e|0)!=(A|0))for(;r=i[e>>2]+r|0,e=e+8|0,(A|0)!=(e|0););return r}function r4(A,e,r,f){var k=0;k=g(e,r);i:{if(i[f+76>>2]<0){A=D3(A,k,f);break i}A=D3(A,k,f)}return(k|0)==(A|0)?e?r:0:(A>>>0)/(e>>>0)|0}function cR(A){A=A|0;var e=0,r=0;return e=v-32|0,v=e,sn(e+12|0,A),A=u[A+80|0],r=i[e+12>>2],t[e+31|0]<0&&Z(i[e+20>>2]),v=e+32|0,(r?-1:A)|0}function iJ(A,e){A=A|0,e=e|0;i:{if(i[28754]||(kA(),!u[115020]))break i;$A()}i[28754]=i[28754]+1,i[A+8>>2]=54203,i[A>>2]=0,i[A+4>>2]=0}function K5(A,e,r,f,k,n,o,l,s,h,w,_,B,m){if((m|0)<=8){W[i[A+12>>2]](e,r,f,k,n,o,l,s,h,w,_,B);return}W[i[A+28>>2]](e,r,f,k,n,o,l,s,h,w,_,B,m)}function eJ(A){A=A|0;var e=0;return A=i[A>>2],e=i[A+284>>2],A=i[A+288>>2],!A|i[A+4>>2]!=-1||(W[i[i[A>>2]+8>>2]](A),y(A)),(e?e+104|0:0)|0}function Ws(A){A=A|0;var e=0;i[A+2192>>2]&&(e=i[A+2188>>2],t[i[i[i[A+2176>>2]+(e>>>8&16777212)>>2]+((e&1023)<<2)>>2]+104|0]=0,ns(A+2140|0))}function rJ(){var A=0;return A=C(32),i[A+8>>2]=0,i[A+12>>2]=0,t[A+4|0]=0,i[A>>2]=9e4,i[A+16>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,A|0}function fJ(){var A=0;return A=C(32),i[A>>2]=0,i[A+4>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A|0}function AJ(A){A=A|0;var e=0;A&&(e=i[A+4>>2],e&&Z(e),e=i[A+8>>2],e&&Z(e),e=i[A+12>>2],e&&Z(e),e=i[A+16>>2],e&&Z(e),Z(A))}function kJ(A){A=A|0;var e=0;return i[A>>2]=108312,e=i[A+584>>2],e&&(i[A+588>>2]=e,Z(e)),e=i[A+572>>2],e&&(i[A+576>>2]=e,Z(e)),n4(A)|0}function nJ(A,e,r,f,k,n,o,l,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,s=s|0;var h=0;return h=e,e=0,W[A|0](h,r,f,k,e|n,o,e|l,s)|0}function tJ(A,e){A=A|0,e=e|0;var r=0,f=0;W[i[i[A>>2]+24>>2]](A)|0,e=$0(e,137016),i[A+36>>2]=e,r=A,f=W[i[i[e>>2]+28>>2]](e)|0,t[r+44|0]=f}function oJ(A,e){A=A|0,e=e|0;var r=0,f=0;W[i[i[A>>2]+24>>2]](A)|0,e=$0(e,137024),i[A+36>>2]=e,r=A,f=W[i[i[e>>2]+28>>2]](e)|0,t[r+44|0]=f}function lJ(A){A=A|0;var e=0,r=0;return e=v-16|0,v=e,Jo(e+4|0,i[A>>2]),r=i[e+8>>2],A=i[e+4>>2],A&&(i[e+8>>2]=A,Z(A)),v=e+16|0,r-A>>3}function c3(A,e){var r=0,f=0;r=u[A+112|0];i:{if(r||(r=0,f=i[A+124>>2],A=i[A+120>>2],f-A>>>0<=e>>>0))break i;r=u[A+e|0]}return r}function ef(A,e,r){var f=0;f=u0[r>>3],u0[A>>3]=u0[e+32>>3]+(f*u0[e>>3]+f*u0[e+8>>3]),u0[A+8>>3]=u0[e+40>>3]+(f*u0[e+16>>3]+u0[r+8>>3]*u0[e+24>>3])}function uJ(A){A=A|0;var e=0;return A=i[A>>2],e=i[A+240>>2],A=i[A+244>>2],!A|i[A+4>>2]!=-1||(W[i[i[A>>2]+8>>2]](A),y(A)),(e|0)!=0|0}function Xs(A){var e=0,r=0;for(A=A>>>0<=1?1:A;;){i:{if(e=E2(A),e||(r=i[34639],!r))break i;W[r|0]();continue}break}return e}function sJ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=e,e=i[e>>2]+7&-8,i[r>>2]=e+16,f=A,k=TA(i[e>>2],i[e+4>>2],i[e+8>>2],i[e+12>>2]),u0[f>>3]=k}function Is(A,e){var r=0;return r=i[A+24>>2],(r|0)==i[A+28>>2]?W[i[i[A>>2]+52>>2]](A,e&255)|0:(i[A+24>>2]=r+1,t[r|0]=e,e&255)}function $5(A,e,r,f,k,n){var o=0,l=0;o=i[A+4>>2],l=o>>8,A=i[A>>2],o&1&&(l=i[i[f>>2]+l>>2]),W[i[i[A>>2]+20>>2]](A,e,r,f+l|0,o&2?k:2,n)}function Qs(A,e,r){var f=0;f=v-16|0,v=f;i:{if(!(t[e+120|0]&1|r>>>0>30)){t[e+120|0]=1;break i}e=Ch(r)}v=f+16|0,i[A+4>>2]=r,i[A>>2]=e}function hJ(A){A=A|0;var e=0;i[A>>2]=108312,e=i[A+584>>2],e&&(i[A+588>>2]=e,Z(e)),e=i[A+572>>2],e&&(i[A+576>>2]=e,Z(e)),Z(n4(A))}function wJ(A,e){A=A|0,e=e|0,e&&(A=A<<24|(A&65280)<<8|(A>>>8&65280|A>>>24),t[e|0]=A,t[e+1|0]=A>>>8,t[e+2|0]=A>>>16,t[e+3|0]=A>>>24)}function _J(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,W[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),X[e+4>>1]=256,IA(A,e,r),v=f+16|0}function BJ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,W[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),X[e+4>>1]=256,on(A,e,r),v=f+16|0}function vJ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,W[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),X[e+4>>1]=256,FA(A,e,r),v=f+16|0}function mJ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,W[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),X[e+4>>1]=256,mA(A,e,r),v=f+16|0}function ZJ(A,e){if(A=A|0,e=e|0,!e){if(t[A+31|0]<0){t[i[A+20>>2]]=0,i[A+24>>2]=0;return}t[A+31|0]=0,t[A+20|0]=0;return}H2(A+20|0,e)}function rf(A,e,r,f,k){var n=0,o=0;n=i[A+4>>2],o=n>>8,A=i[A>>2],n&1&&(o=i[i[r>>2]+o>>2]),W[i[i[A>>2]+24>>2]](A,e,r+o|0,n&2?f:2,k)}function gJ(A,e){if(A=A|0,e=e|0,e){H2(A+20|0,e);return}if(t[A+31|0]<0){t[i[A+20>>2]]=0,i[A+24>>2]=0;return}t[A+31|0]=0,t[A+20|0]=0}function GJ(A){A=A|0;var e=0;return i[A>>2]=93964,e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),t[A+115|0]<0&&Z(i[A+104>>2]),n2(A)|0}function WJ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;return f=i[A+4>>2],k=A+4|0,A=i[A+8>>2],r=i[e>>2],e=i[e+4>>2],V4(k,A,r,e,e-r|0),A-f|0}function XJ(A,e){A=A|0,e=e|0;var r=0;return e=Z0(e,92792,92812),!e|i[A+104>>2]!=i[e+104>>2]||(r=i[A+108>>2]==i[e+108>>2]),r|0}function o4(A,e){A=A|0,e=e|0;i:{if(A=i[e+4>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function Vs(A,e,r,f,k,n){A=W[i[i[A+8>>2]+4>>2]](A+8|0)|0,A=n3(r,f,A,A+288|0,n,k,0)-A|0,(A|0)<=287&&(i[e>>2]=((A|0)/12|0)%12)}function ps(A,e,r,f,k,n){A=W[i[i[A+8>>2]+4>>2]](A+8|0)|0,A=o3(r,f,A,A+288|0,n,k,0)-A|0,(A|0)<=287&&(i[e>>2]=((A|0)/12|0)%12)}function _r(A,e){var r=0,f=0;return r=t[A+11|0],f=(r|0)<0,r=f?i[A+4>>2]:r,(r|0)==(l2(e)|0)?A=N2(f?i[A>>2]:A,e,r):A=1,!A}function IJ(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){if((e|0)!=(r|0)){i[f>>2]=t[e|0],f=f+4|0,e=e+1|0;continue}break}return e|0}function QJ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,f&&(i[f>>2]=0),e=i[25547],i[A>>2]=i[25546],i[A+4>>2]=e,i[A+8>>2]=i[25548]}function VJ(A){A=A|0;var e=0,r=0;return e=C(8),r=i[A+8>>2],A=i[A+12>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),i[e+4>>2]=A,i[e>>2]=r,e|0}function ff(A){var e=0;e=i[A+328>>2],i[A+328>>2]=e-1,i[A+336>>2]=i[A+336>>2]+1,!((e|0)>0)&&(U0(23944,19968,733,6100),M())}function di(A,e){A=A|0,e=e|0;var r=0;r=i[e+552>>2],e=i[e+556>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),t[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r}function pJ(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){if((e|0)!=(r|0)){t[f|0]=u[e|0],f=f+1|0,e=e+1|0;continue}break}return e|0}function d5(A,e,r){var f=0;for(f=v-16|0,v=f,t[f+15|0]=r;;){if(e){t[A|0]=u[f+15|0],e=e-1|0,A=A+1|0;continue}break}v=f+16|0}function y(A){var e=0,r=0;i:{if(e=A+8|0,i[e>>2]&&(r=e,e=i[e>>2]-1|0,i[r>>2]=e,(e|0)!=-1))break i;W[i[i[A>>2]+16>>2]](A)}}function FJ(A){A=A|0;var e=0;i[A>>2]=93964,e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),t[A+115|0]<0&&Z(i[A+104>>2]),Z(n2(A))}function R6(A){var e=0;return e=v-16|0,v=e,i[e+12>>2]=A,A=v-16|0,v=A,i[A+12>>2]=i[e+12>>2],v=A+16|0,v=e+16|0,i[A+12>>2]}function CJ(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,i4(A,i[e+8>>2],0)){M5(e,r,f);return}A=i[A+8>>2],W[i[i[A>>2]+28>>2]](A,e,r,f)}function Fs(A,e,r,f,k,n){A=W[i[i[A+8>>2]>>2]](A+8|0)|0,A=n3(r,f,A,A+168|0,n,k,0)-A|0,(A|0)<=167&&(i[e>>2]=((A|0)/12|0)%7)}function b5(){var A=0;return A=C(32),t[A+24|0]=0,i[A+16>>2]=0,i[A+20>>2]=2147483647,i[A+8>>2]=-1,i[A+12>>2]=-1,t[A|0]=1,A|0}function R0(A){return i[A>>2]=76792,GA(A+4|0),i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A}function Cs(A,e,r,f,k,n){A=W[i[i[A+8>>2]>>2]](A+8|0)|0,A=o3(r,f,A,A+168|0,n,k,0)-A|0,(A|0)<=167&&(i[e>>2]=((A|0)/12|0)%7)}function YJ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=i[A+24>>2],i[n>>2]>=2&&W[i[n+28>>2]](e,r,f,k,i[A+28>>2])}function yJ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=i[A+24>>2],i[n>>2]>=2&&W[i[n+24>>2]](e,r,f,k,i[A+28>>2])}function EJ(A,e){A=A|0,e=e|0;var r=0;return r=i[A+2152>>2],A=i[A+2148>>2],r-A>>2>>>0>e>>>0?A=i[A+(e<<2)>>2]:A=0,A|0}function Ys(A){return i[A>>2]=77040,GA(A+4|0),i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A}function bi(){var A=0;return A=C(24),i[A+8>>2]=0,i[A+12>>2]=0,t[A|0]=1,t[A+15|0]=0,t[A+16|0]=0,t[A+17|0]=0,t[A+18|0]=0,A|0}function RJ(A){A=A|0;var e=0;return i[A>>2]=92324,e=i[A+48>>2],e&&Z(e),i[A>>2]=92456,t[A+23|0]<0&&Z(i[A+12>>2]),A|0}function J0(A,e){i[A+20>>2]=0,i[A+24>>2]=e,i[A+12>>2]=0,i[A+4>>2]=4098,i[A+8>>2]=6,i[A+16>>2]=!e,l0(A+32|0,0,40),GA(A+28|0)}function ys(){var A=0;return u[115884]||(t[115884]=1),A=i[28964],(A|0)<=0?12:(A=A-1|0,i[28964]=A,A||tw(),0)}function Es(A,e,r,f,k,n,o){i[A+112>>2]=r,i[A+100>>2]=e,t[A+97|0]=1,i[A+116>>2]=k,i[A+104>>2]=f,i[A+120>>2]=o,i[A+108>>2]=n}function g2(A){var e=0;i:{if(A=i[A+4>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function JJ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=i[e+12>>2],A=i[A+16>>2]==1970628964?24:8,N3(e,r?A+8|0:A),N3(e,4),f|0}function Rs(A,e,r){var f=0;f=v-16|0,v=f;i:if(u[A+11|0]>>>7|0)break i;J6(A,r),t[f+15|0]=0,t[e+r|0]=u[f+15|0],v=f+16|0}function Js(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=i[A+32>>2],A=i[A+36>>2],((A|0)==(r|0)&e>>>0>f>>>0|A>>>0<r>>>0?2:0)|0}function NJ(A){A=A|0;var e=0;A&&(a2(i[A+16>>2]),t[A+31|0]<0&&Z(i[A+20>>2]),e=i[A>>2],e&&(i[A+4>>2]=e,Z(e)),Z(A))}function Ns(A){A=A|0;var e=0,r=0;return i[A>>2]=92096,e=i[A+4>>2]-12|0,r=i[e+8>>2]-1|0,i[e+8>>2]=r,(r|0)<0&&Z(e),A|0}function c5(A,e){var r=0;r=A+4|0,i[r+28>>2]=0,i[r>>2]=79176,i[r>>2]=77328,i[A>>2]=76908,i[r>>2]=76928,vf(i[19224]+A|0,e)}function i7(A,e){var r=0;r=A+4|0,i[r+28>>2]=0,i[r>>2]=79176,i[r>>2]=77764,i[A>>2]=77156,i[r>>2]=77176,vf(i[19286]+A|0,e)}function Ds(A){var e=0;i[A+8>>2]=0,i[A+12>>2]=0,e=i[A+16>>2],i[A+16>>2]=0,e=e>>3,i[A>>2]=i[A>>2]-e,i[A+4>>2]=e+i[A+4>>2]}function DJ(A){A=A|0;var e=0;return(W[i[i[A>>2]+36>>2]](A)|0)==-1?-1:(e=A,A=i[A+12>>2],i[e+12>>2]=A+4,i[A>>2])}function Us(A){var e=0;return e=i[A+12>>2],(e|0)==i[A+16>>2]?W[i[i[A>>2]+40>>2]](A)|0:(i[A+12>>2]=e+4,i[e>>2])}function X1(A,e){return i[A+4>>2]=e,t[A|0]=0,e=i[i[e>>2]-12>>2]+e|0,i[e+16>>2]||(e=i[e+72>>2],e&&O3(e),t[A|0]=1),A}function UJ(A){A=A|0;var e=0;return(W[i[i[A>>2]+36>>2]](A)|0)==-1?-1:(e=A,A=i[A+12>>2],i[e+12>>2]=A+1,u[A|0])}function Ms(A){var e=0;return e=i[A+12>>2],(e|0)==i[A+16>>2]?W[i[i[A>>2]+40>>2]](A)|0:(i[A+12>>2]=e+1,u[e|0])}function n1(A,e,r,f){i[r+12>>2]=f,W[i[i[e>>2]+56>>2]](A,e,r,i[r+4>>2]-(i[r>>2]+f|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2]}function MJ(A){A=A|0;var e=0;i[A>>2]=92324,e=i[A+48>>2],e&&Z(e),i[A>>2]=92456,t[A+23|0]<0&&Z(i[A+12>>2]),Z(A)}function Hs(A,e,r){var f=0,k=0;f=u0[r>>3],k=u0[r+8>>3],u0[A>>3]=f*u0[e>>3]+k*u0[e+8>>3],u0[A+8>>3]=f*u0[e+16>>3]+k*u0[e+24>>3]}function zs(A){return A=(A|0)>2147481747?A-2e3|0:A,A&3?0:(A=A+1900|0,(A|0)%100|0?1:!((A|0)%400|0))}function HJ(A,e){A=A|0,e=e|0;var r=0,f=0;r=C(1),i[A+8>>2]=i[25788],f=i[25787],i[A>>2]=i[25786],i[A+4>>2]=f,i[e>>2]=r}function i2(A){var e=0;A=i[A>>2],(A|0)!=136824&&(e=i[A+4>>2]-1|0,i[A+4>>2]=e,(e|0)==-1&&W[i[i[A>>2]+8>>2]](A))}function zJ(A){A=A|0;var e=0,r=0;if(e=i[A>>2],e)for(;Z(e),r=r+1|0,e=i[(r<<2)+A>>2],!!e;);Z(A)}function xs(A,e,r,f,k,n){i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=f,i[A+12>>2]=k&65535|(n>>>16&32768|(k&2147418112)>>>16)<<16}function xJ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;return k=v-16|0,v=k,W[A|0](k+8|0,e,r,f),v=k+16|0,i[k+12>>2]}function C8(A,e){var r=0;return r=i[33178],e=i[e>>2],e&&(i[33178]=(e|0)==-1?132592:e),i[A>>2]=(r|0)==132592?-1:r,A}function TJ(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;e=(i[A+84>>2]-i[A+80>>2]|0)/44|0}return e|0}function ci(A,e){A=A|0,e=e|0;var r=0;i[A>>2]=i[e+560>>2],r=A,A=i[e+564>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function e7(A,e){var r=0;return r=v-16|0,v=r,i[r+12>>2]=i[A>>2],i[r+12>>2]=i[r+12>>2]+(e<<2),v=r+16|0,i[r+12>>2]}function Ts(A,e,r){var f=0;f=v-16|0,v=f,i[f+12>>2]=e,i[f+8>>2]=r,i[A>>2]=i[f+12>>2],i[A+4>>2]=i[f+8>>2],v=f+16|0}function js(A,e){var r=0;i[A+16>>2]=1970628964,A=A+20|0,(A|0)!=(e|0)&&(r=A,A=i[e>>2],e=i[e+4>>2],$4(r,A,e,e-A|0))}function jJ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=i[e+12>>2],A=i[A+16>>2]==1970628964?24:8,N3(e,r?A+8|0:A),f|0}function SJ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=A,k=e,A=t[r+11|0],e=(A|0)<0,ls(f,k,e?i[r>>2]:r,e?i[r+4>>2]:A,0)}function OJ(A){A=A|0;var e=0;return i[A>>2]=108048,a2(i[A+580>>2]),e=i[A+564>>2],e&&(i[A+568>>2]=e,Z(e)),n4(A)|0}function PJ(){var A=0;return A=C(24),i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=1,i[A+12>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,A|0}function LJ(A,e){A=A|0,e=e|0;var r=0;i[A>>2]=i[e+48>>2],r=A,A=i[e+52>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function qJ(A,e){A=A|0,e=e|0;var r=0;A=A+116|0,(A|0)!=(e|0)&&(r=A,A=i[e>>2],e=i[e+4>>2],MA(r,A,e,(e-A|0)/28|0))}function aJ(A,e){A=A|0,e=e|0;var r=0;A=A+128|0,(A|0)!=(e|0)&&(r=A,A=i[e>>2],e=i[e+4>>2],e5(r,A,e,(e-A|0)/52|0))}function KJ(A,e){A=A|0,e=e|0;var r=0;A=A+140|0,(A|0)!=(e|0)&&(r=A,A=i[e>>2],e=i[e+4>>2],EA(r,A,e,(e-A|0)/48|0))}function $J(A,e){A=A|0,e=e|0;var r=0;i[A>>2]=i[e+40>>2],r=A,A=i[e+44>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function w6(A,e,r,f){var k=0;k=v-32|0,v=k,jr(k+12|0,i[A+64>>2],e,r,f),t[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function dJ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,i[f+8>>2]=1,i[f+12>>2]=993,X9(A,e,f+8|0,r),v=f+16|0}function bJ(A){A=A|0;var e=0,r=0;return e=t[A+31|0],r=(e|0)<0,u8(C((r?i[A+24>>2]:e)+1|0),r?i[A+20>>2]:A+20|0)|0}function Ss(A,e){var r=0,f=0;f=i[e>>2],i[e>>2]=0,r=i[A>>2],i[A>>2]=f,r&&W[i[A+4>>2]](r),i[A+4>>2]=i[e+4>>2]}function L8(A){i:{if(A=i[A+4>>2]&74,A){if((A|0)==64)return 8;if((A|0)!=8)break i;return 16}return 0}return 10}function cJ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,e=i[25790],i[A>>2]=i[25789],i[A+4>>2]=e,i[A+8>>2]=i[25791]}function iN(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}function eN(A){A=A|0;var e=0;return i[A>>2]=112056,k1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),n2(A)|0}function rN(A){A=A|0;var e=0;return i[A>>2]=112136,k1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),n2(A)|0}function fN(A){A=A|0;var e=0;return i[A>>2]=112216,k1(A+124|0),e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),n2(A)|0}function AN(A,e,r){A=A|0,e=e|0,r=r|0,A=i[e+4>>2],A&&Z(A),A=i[e+8>>2],A&&Z(A),A=i[e+12>>2],A&&Z(A)}function kN(A){A=A|0;var e=0;return i[A>>2]=112296,k1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),n2(A)|0}function r7(A){A=A|0;var e=0;return e=i[19709],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[19712],Le(A+8|0),Y0(A+108|0),A|0}function f7(A){A=A|0;var e=0;return e=i[19748],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[19751],Le(A+4|0),Y0(A+104|0),A|0}function nN(A){A=A|0;var e=0;return i[A>>2]=112776,k1(A+128|0),e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),n2(A)|0}function Os(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+200>>2],e=(A|0)>0?A:0}return e|0}function tN(A){A=A|0;var e=0;return i[A>>2]=113064,k1(A+132|0),e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),n2(A)|0}function Ps(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+204>>2],e=(A|0)>0?A:0}return e|0}function oN(A){A=A|0;var e=0;return i[A>>2]=113144,k1(A+140|0),e=i[A+128>>2],e&&(i[A+132>>2]=e,Z(e)),n2(A)|0}function A7(A,e){var r=0;return r=v-16|0,v=r,i[r+12>>2]=i[A>>2],i[r+12>>2]=i[r+12>>2]+e,v=r+16|0,i[r+12>>2]}function i4(A,e,r){return r?(A|0)==(e|0)?1:!v4(i[A+4>>2],i[e+4>>2]):i[A+4>>2]==i[e+4>>2]}function J1(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=e,i[A>>2]=i[f+12>>2],i[A+4>>2]=i[r>>2],v=f+16|0,A}function lN(A){A=A|0;var e=0;return i[A>>2]=111896,k1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),n2(A)|0}function uN(A){A=A|0;var e=0;return i[A>>2]=111976,k1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),n2(A)|0}function k7(A){A=A|0;var e=0;return e=i[19619],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[19622],hf(A+4|0),Y0(A+56|0),A|0}function n7(A){A=A|0;var e=0;return e=i[19664],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[19667],hf(A+8|0),Y0(A+60|0),A|0}function Ls(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0}function sN(A,e,r){A=A|0,e=e|0,r=r|0,x3(i[e>>2],r),i[A+8>>2]=i[25680],e=i[25679],i[A>>2]=i[25678],i[A+4>>2]=e}function hN(A){A=A|0;var e=0;i[A>>2]=108048,a2(i[A+580>>2]),e=i[A+564>>2],e&&(i[A+568>>2]=e,Z(e)),Z(n4(A))}function J6(A,e){if(u[A+11|0]>>>7|0){i[A+4>>2]=e;return}t[A+11|0]=u[A+11|0]&128|e&127,t[A+11|0]=u[A+11|0]&127}function P4(A,e){var r=0,f=0;return r=i[A+108>>2],f=e,e=i[A+112>>2],r=ie(r,f,e-r>>2),((r||e)|0)!=i[A+112>>2]}function wN(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;h2(e,0),f=i[A+4>>2],Y1(e,r,f,f>>31),A=i[A+8>>2],Y1(e,r,A,A>>31)}function qs(A,e,r,f,k){e=H8(e,r,f,k,4),u[f|0]&4||(i[A>>2]=((e|0)<69?e+2e3|0:e>>>0<100?e+1900|0:e)-1900)}function as(A,e,r,f,k){e=z8(e,r,f,k,4),u[f|0]&4||(i[A>>2]=((e|0)<69?e+2e3|0:e>>>0<100?e+1900|0:e)-1900)}function _N(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;return o=e,e=0,W[A|0](o,e|r,f,e|k,n)|0}function ie(A,e,r){if(r)for(;;){if(i[A>>2]==(e|0))return A;if(A=A+4|0,r=r-1|0,!r)break}return 0}function e8(A){var e=0;return u[A+11|0]>>>7|0&&(A=i[A>>2]),e=v-16|0,v=e,i[e+12>>2]=A,v=e+16|0,i[e+12>>2]}function BN(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;A=i[A>>2],r=e>>31,f=A,k=L0(e,r,e,r),i[f+72>>2]=k,i[A+76>>2]=h0}function vN(A,e,r){return A=A|0,e=e|0,r=r|0,A=W[i[i[A+24>>2]+16>>2]](e,r,i[A+28>>2])|0,(A?(A|0)==1?1:2:0)|0}function t7(A,e){e&&(t7(A,i[e>>2]),t7(A,i[e+4>>2]),u[e+36|0]!=1|t[e+35|0]>=0||Z(i[e+24>>2]),Z(e))}function mN(A,e,r){A=A|0,e=e|0,r=r|0,i[r>>2]=100,i[A+8>>2]=i[25788],e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e}function ZN(A){if(A=A|0,u[A+112|0]==1){t[A+97|0]=1;return}if(u[A+120|0]==1){t[A+97|0]=2;return}t[A+97|0]=0}function Ks(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=v-16|0,v=f,W[A|0](f+8|0,e,r),v=f+16|0,i[f+12>>2]}function o7(A,e){if(!i[e+4>>2]){W[i[i[e>>2]+36>>2]](A,e+4|0);return}i[A+8>>2]=54203,i[A>>2]=0,i[A+4>>2]=0}function gN(A){A=A|0;var e=0;i[A>>2]=112056,k1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(n2(A))}function GN(A){A=A|0;var e=0;i[A>>2]=112136,k1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(n2(A))}function WN(A){A=A|0;var e=0;i[A>>2]=112216,k1(A+124|0),e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),Z(n2(A))}function XN(A){A=A|0;var e=0;i[A>>2]=112296,k1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(n2(A))}function IN(A){A=A|0;var e=0;i[A>>2]=112776,k1(A+128|0),e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),Z(n2(A))}function $s(A,e,r,f,k,n,o,l){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,i[k>>2]=r,i[l>>2]=n,3}function QN(A){A=A|0;var e=0;i[A>>2]=113064,k1(A+132|0),e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),Z(n2(A))}function VN(A){A=A|0;var e=0;i[A>>2]=113144,k1(A+140|0),e=i[A+128>>2],e&&(i[A+132>>2]=e,Z(e)),Z(n2(A))}function pN(A,e,r){A=A|0,e=e|0,r=r|0,i[r>>2]=1,i[A+8>>2]=i[25788],e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e}function FN(A,e,r){A=A|0,e=e|0,r=r|0,i[r>>2]=0,i[A+8>>2]=i[25788],e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e}function CN(A){A=A|0;var e=0;i[A>>2]=111896,k1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(n2(A))}function YN(A){A=A|0;var e=0;i[A>>2]=111976,k1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(n2(A))}function yN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}function ds(A,e){e&&(X[A>>1]=i[e+4>>2],X[A+2>>1]=i[e+8>>2],X[A+4>>1]=i[e+12>>2],t[A+6|0]=u[e+16|0]!=0)}function bs(A,e,r){var f=0;e=e-A|0,f=e>>2;i:{if(!f||(f=f<<2,!f))break i;z(r,A,f)}return e+r|0}function EN(A){A=A|0;var e=0;return i[A>>2]=102424,k1(A+32|0),e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),A|0}function Br(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=i[25790],i[A>>2]=i[25789],i[A+4>>2]=e,i[A+8>>2]=i[25791]}function RN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}function JN(A){A=A|0;var e=0;e=o0[A+104>>2]>65535?3:u[A+164|0]<<1&2,t[A+97|0]=i[A+112>>2]&&e>>>0<=2?2:e}function NN(A){A=A|0;var e=0;return i[A>>2]=102380,k1(A+20|0),e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),A|0}function DN(A){A=A|0;var e=0,r=0;return A=i[A+4>>2],e=l2(A)+1|0,r=E2(e),r?A=v8(r,A,e):A=0,A|0}function UN(){i[28833]=1,i[28827]=8301,i[28826]=3,i[28825]=13049,i[28824]=2,i[28809]=0,i[28808]=115296}function cs(A,e){return A=A|0,e=e|0,(8-e|8-A)>>>0<=7?A=i[((A<<5)+(e<<2)|0)+57708>>2]:A=1,A|0}function MN(A){A=A|0;var e=0;return e=v-16|0,v=e,fu(e,i[A+24>>2]),v=e+16|0,h0=i[e+12>>2],i[e+8>>2]}function HN(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,f6(A,e,r,f,k,n,o,2,2,l)}function zN(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,f6(A,e,r,f,k,n,o,2,3,l)}function xN(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,f6(A,e,r,f,k,n,o,3,1,l)}function TN(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,f6(A,e,r,f,k,n,o,3,2,l)}function jN(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,f6(A,e,r,f,k,n,o,3,3,l)}function SN(A,e){return A=A|0,e=e|0,e>>>0<=2?A=i[i[A+124>>2]+i[(e<<2)+65088>>2]>>2]:A=0,A|0}function Af(){var A=0;return A=C(52),t[A+16|0]=1,i[A+12>>2]=6,i[A+4>>2]=1,i[A+8>>2]=13,t[A|0]=1,A|0}function l7(A){i[A+136>>2]||(i[A+136>>2]=i[i[33178]>>2]?79296:79272),i[A+72>>2]||(i[A+72>>2]=1)}function ON(A,e){A=A|0,e=e|0;var r=0;i:{if(!A||(A=i[A>>2],!A))break i;r=$u(A,e)}return r|0}function ih(A){if(i[A+20>>2]!=i[A+24>>2])for(;eo(A),i[A+20>>2]!=i[A+24>>2];);}function PN(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,f6(A,e,r,f,k,n,o,1,1,l)}function LN(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,f6(A,e,r,f,k,n,o,1,2,l)}function qN(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,f6(A,e,r,f,k,n,o,1,3,l)}function aN(A,e,r,f,k,n,o,l){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,l=l|0,f6(A,e,r,f,k,n,o,2,1,l)}function KN(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var o=0;o=e,e=0,W[A|0](o,e|r,f,e|k,n)}function eh(A){p[A+4>>1]==2&&(X[A+4>>1]=6),p[A>>1]==2&&(X[A>>1]=1),p[A+2>>1]==2&&(X[A+2>>1]=13)}function $N(A,e,r){return A=A|0,e=e|0,r=r|0,r>>>0<=127?A=(i[(r<<2)+84208>>2]&e)!=0:A=0,A|0}function dN(A,e){A=A|0,e=e|0,Gh(i[e>>2]),i[A+8>>2]=i[25788],e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e}function kf(A){if(i[A+336>>2]!=i[A+340>>2])for(;i[A+336>>2]!=i[A+340>>2];);}function bN(A,e,r,f,k,n,o){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,W[A|0](e,r,f,k,n,o)|0}function cN(A){A=A|0;var e=0;i[A>>2]=102424,k1(A+32|0),e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),Z(A)}function iD(A){A=A|0;var e=0;return i[A>>2]=104700,e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),n2(A)|0}function u7(A,e,r){var f=0;return f=v-16|0,v=f,r=ie(A,i[r>>2],e-A>>2),v=f+16|0,((r||e)-A|0)+A|0}function eD(A){A=A|0;var e=0;return i[A>>2]=105816,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),n2(A)|0}function rD(A){A=A|0;var e=0;return i[A>>2]=105896,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),n2(A)|0}function fD(A){A=A|0;var e=0;return i[A>>2]=113224,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),n2(A)|0}function AD(A){A=A|0;var e=0;return i[A>>2]=105168,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),n2(A)|0}function kD(A){A=A|0;var e=0;return i[A>>2]=106056,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),n2(A)|0}function nD(A){A=A|0;var e=0;return i[A>>2]=113384,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),n2(A)|0}function tD(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i[A>>2]=4,i[A+4>>2]=0,i[A+8>>2]=28805}function rh(A,e){var r=0;r=v-16|0,v=r;i:{if((A|0)==(e|0)){t[A+120|0]=0;break i}B6(e,4)}v=r+16|0}function oD(A){A=A|0;var e=0;return i[A>>2]=95004,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),n2(A)|0}function nf(A,e){e&&(nf(A,i[e>>2]),nf(A,i[e+4>>2]),A=i[e+16>>2],i[e+16>>2]=0,A&&Z(A),Z(e))}function lD(A){A=A|0;var e=0;i[A>>2]=102380,k1(A+20|0),e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),Z(A)}function uD(A){A=A|0;var e=0;return i[A>>2]=93096,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),n2(A)|0}function sD(A){A=A|0;var e=0;return i[A>>2]=92936,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),n2(A)|0}function hD(A){A=A|0;var e=0;return i[A>>2]=94364,e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),n2(A)|0}function wD(A){A=A|0;var e=0;return i[A>>2]=94524,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),n2(A)|0}function fh(A,e){var r=0;for(r=i[A+4>>2];;){if((e|0)!=(r|0)){r=r-4|0;continue}break}i[A+4>>2]=e}function _D(A,e){A=A|0,e=e|0,A=i[A>>2],i[A>>2]=i[e>>2],i[A+4>>2]=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0}function s7(A,e,r){var f=0;return f=v-16|0,v=f,r=l5(A,t[r|0],e-A|0),v=f+16|0,((r||e)-A|0)+A|0}function Ah(A){A=A|0;var e=0;return i[A>>2]=84156,e=i[A+8>>2],!e|!(t[A+12|0]&1)||Z(e),A|0}function BD(A,e){A=A|0,e=e|0;var r=0;return r=v-16|0,v=r,W[A|0](r+8|0,e),v=r+16|0,i[r+12>>2]}function tf(A,e,r){A=A|0,e=e|0,r=r|0,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}function r8(A){var e=0;return e=1,p[A+6>>1]!=2|p[A+8>>1]!=2|p[A+10>>1]!=2||(e=!u[A+12|0]),e}function vD(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i4(A,i[e+8>>2],n)&&I5(e,r,f,k)}function mD(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,W[i[i[e>>2]+16>>2]](A,e,i[r+8>>2],i[r+12>>2],0,f)}function ZD(A){A=A|0;var e=0;A&&(e=i[A+4>>2],e&&(W[i[i[A>>2]+40>>2]](e),i[A+4>>2]=0),Z(A))}function vr(A,e,r){(r|0)<0&&(U0(23932,19996,138,7833),M()),i[A+4>>2]=e,i[A>>2]=e,i[A+8>>2]=e+r}function h7(A,e,r){A=A|0,e=e|0,r=r|0,e=i[25787],i[A>>2]=i[25786],i[A+4>>2]=e,i[A+8>>2]=i[25788]}function z1(A,e){t[A+4|0]=0,t[A+11|0]=4,t[A+3|0]=e,t[A+2|0]=e>>>8,t[A+1|0]=e>>>16,t[A|0]=e>>>24}function gD(A,e,r){A=A|0,e=e|0,r=r|0,e=i[25547],i[A>>2]=i[25546],i[A+4>>2]=e,i[A+8>>2]=i[25548]}function GD(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function t1(A,e,r,f,k){i[A+196>>2]=f,i[A+192>>2]=r,i[A+188>>2]=e,i[A+200>>2]=(f|0)==1?k||3:k}function WD(A){A=A|0;var e=0;i[A>>2]=104700,e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),Z(n2(A))}function XD(A){A=A|0;var e=0;i[A>>2]=105816,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(n2(A))}function ID(A){A=A|0;var e=0,r=0;return e=t[A+11|0],r=(e|0)<0,Tl(r?i[A>>2]:A,r?i[A+4>>2]:e)|0}function QD(A){A=A|0;var e=0;i[A>>2]=105896,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(n2(A))}function VD(A){A=A|0;var e=0;i[A>>2]=113224,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(n2(A))}function kh(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0}function pD(A){A=A|0;var e=0;i[A>>2]=105168,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(n2(A))}function FD(A){A=A|0;var e=0;i[A>>2]=106056,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(n2(A))}function CD(A){A=A|0;var e=0;i[A>>2]=113384,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(n2(A))}function x0(){var A=0;A=Wr(4),i[A>>2]=91984,i[A>>2]=91944,i[A>>2]=91964,Ze(A|0,92048,32),M()}function YD(A){A=A|0;var e=0;i[A>>2]=95004,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(n2(A))}function nh(A){A=A|0;var e=0;i[A>>2]=94524,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),Z(n2(A))}function th(A,e){var r=0;return r=A+8|0,A=i[r>>2],i[A+(e<<2)>>2]!=0&i[r+4>>2]-A>>2>>>0>e>>>0}function yD(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,W[i[i[e>>2]+92>>2]](A,i[e+4>>2],r,f,k)}function ED(A){A=A|0;var e=0;i[A>>2]=93096,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),Z(n2(A))}function RD(A){A=A|0;var e=0;i[A>>2]=94364,e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),Z(n2(A))}function JD(A){A=A|0;var e=0;i[A>>2]=92936,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(n2(A))}function oh(A){var e=0,r=0;for(r=A;e=r,r=e+4|0,!!i[e>>2];);return e-A>>2}function ND(A){A=A|0;var e=0;return i[A>>2]=92500,e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),A|0}function DD(A){A=A|0;var e=0;return i[A>>2]=101780,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),A|0}function UD(A){return A=A|0,i[28772]=6,t[115076]=1,t[115092]=1,i[28770]=6,i[28771]=6,115076}function lh(A,e){var r=0;i:{if(r=i[A>>2],!r||(Is(r,e)|0)!=-1)break i;i[A>>2]=0}}function MD(A){A=A|0;var e=0;return i[A>>2]=112856,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),A|0}function _6(A,e,r,f){var k=0;return k=v-16|0,v=k,i[k+12>>2]=f,A=S3(A,e,r,f),v=k+16|0,A}function HD(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;e=$e(A)}return e|0}function zD(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;e=Ke(A)}return e|0}function xD(A){A=A|0;var e=0;return i[A>>2]=101440,e=i[A+4>>2],e&&(i[A+8>>2]=e,Z(e)),A|0}function of(A,e){var r=0;return p[A+4>>1]!=p[e+4>>1]|p[A>>1]!=p[e>>1]?r:u[A+6|0]==u[e+6|0]}function w7(A,e){e&&(w7(A,i[e>>2]),w7(A,i[e+4>>2]),t[e+63|0]<0&&Z(i[e+52>>2]),Z(e))}function TD(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,A6(A,e,r,f,k,n,o,1,1)}function jD(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,A6(A,e,r,f,k,n,o,1,2)}function SD(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,A6(A,e,r,f,k,n,o,1,3)}function OD(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,A6(A,e,r,f,k,n,o,2,1)}function PD(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,A6(A,e,r,f,k,n,o,2,2)}function LD(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,A6(A,e,r,f,k,n,o,2,3)}function qD(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,A6(A,e,r,f,k,n,o,3,1)}function aD(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,A6(A,e,r,f,k,n,o,3,2)}function KD(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,A6(A,e,r,f,k,n,o,3,3)}function $D(A){return A=A|0,i[A+4>>2]-32768>>>0<4294901760|i[A+8>>2]-32768>>>0<4294901760}function dD(A,e,r){return A=A|0,e=e|0,r=r|0,!(W[i[i[A+24>>2]+12>>2]](e,r,i[A+28>>2])|0)|0}function bD(A,e,r,f,k,n,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,o=o|0,W[A|0](e,r,f,k,n,o)}function uh(A,e){A=A|0,e=e|0;i:{if(!e||(A=i[e>>2],!A))break i;Z(A),i[e>>2]=0}}function sh(A){A=A|0;var e=0;A=i[i[i[A>>2]>>2]>>2],e=i[34249]+1|0,i[34249]=e,i[A+4>>2]=e}function hh(A){(A|0)!=0&(A|0)!=79272&(A|0)!=79296&(A|0)!=136420&(A|0)!=136444&&Z(A)}function cD(A,e){A=A|0,e=e|0,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}function iU(A,e,r){return A=A|0,e=e|0,r=r|0,!(W[i[i[A+24>>2]+8>>2]](e,r,i[A+28>>2])|0)|0}function t2(A,e){var r=0,f=0;return r=e&31,f=(-1>>>r&A)<<r,r=A,A=0-e&31,f|(r&-1<<A)>>>A}function wh(A,e){var r=0;return r=v-16|0,v=r,i[r+12>>2]=e,A=E9(A,12443,e),v=r+16|0,A}function g8(A,e){A=A|0,e=e|0,e=v-16|0,v=e,i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,v=e+16|0}function eU(A,e){A=A|0,e=e|0,e=i[25547],i[A>>2]=i[25546],i[A+4>>2]=e,i[A+8>>2]=i[25548]}function _h(A){var e=0;return p[A>>1]!=2|p[A+2>>1]!=2|p[A+4>>1]!=2||(e=u[A+6|0]),e}function rU(A){A=A|0;var e=0;i[A>>2]=92500,e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),Z(A)}function fU(A){A=A|0;var e=0;i[A>>2]=112856,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),Z(A)}function AU(A){A=A|0;var e=0;i[A>>2]=101780,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),Z(A)}function $0(A,e){return A=i[A>>2],e=W1(e),th(A,e)||(N1(),M()),i[i[A+8>>2]+(e<<2)>>2]}function kU(A,e,r,f,k,n){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,pA(A,e,r,f,k,n)|0}function nU(A){A=A|0;var e=0;i[A>>2]=101440,e=i[A+4>>2],e&&(i[A+8>>2]=e,Z(e)),Z(A)}function tU(A){for(A=A|0,A=137400;A=_2(A-12|0),(A|0)!=137232;);}function oU(A){for(A=A|0,A=137576;A=q1(A-12|0),(A|0)!=137408;);}function lU(A){for(A=A|0,A=137872;A=_2(A-12|0),(A|0)!=137584;);}function uU(A){for(A=A|0,A=138176;A=q1(A-12|0),(A|0)!=137888;);}function sU(A){for(A=A|0,A=138216;A=_2(A-12|0),(A|0)!=138192;);}function hU(A){for(A=A|0,A=138248;A=q1(A-12|0),(A|0)!=138224;);}function wU(A){return A=A|0,A?(A=i[A>>2],(i[A+144>>2]-i[A+140>>2]|0)/48|0):0}function _U(A){return A=A|0,A?(A=i[A>>2],(i[A+120>>2]-i[A+116>>2]|0)/28|0):0}function BU(A){return A=A|0,A?(A=i[A>>2],(i[A+132>>2]-i[A+128>>2]|0)/52|0):0}function vU(A,e,r){A=A|0,e=e|0,r=r|0,A=i[A>>2],i[e>>2]=i[A+24>>2],i[r>>2]=i[A+28>>2]}function Y8(A,e){var r=0,f=0;r=A,f=i[A+4>>2],A=i[e>>2],e=i[e+4>>2],V4(r,f,A,e,e-A|0)}function mU(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,h0=i[A+36>>2],i[A+32>>2]}function ZU(A){return A=A|0,A?(A=i[A>>2],A=u[A+153|0]?u[A+152|0]:0):A=0,A&255}function gU(A,e){A=A|0,e=e|0;var r=0;a2(i[A+16>>2]),r=A,A=bi(),i[r+16>>2]=A,li(A,e)}function GU(A){return A=A|0,i[A>>2]=112456,t[A+115|0]<0&&Z(i[A+104>>2]),n2(A)|0}function WU(A){return A=A|0,i[A>>2]=113808,t[A+303|0]<0&&Z(i[A+292>>2]),Ve(A)|0}function XU(A){return A=A|0,i[A>>2]=112696,t[A+115|0]<0&&Z(i[A+104>>2]),n2(A)|0}function IU(A){return A=A|0,i[A>>2]=100856,t[A+575|0]<0&&Z(i[A+564>>2]),n4(A)|0}function QU(A,e){A=A|0,e=e|0;var r=0;return r=i[A>>2],e&&(i[e>>2]=i[A+4>>2]-r),r|0}function l4(A,e){for(;i[A+16>>2]=i[A+16>>2]-e,A=i[A+8>>2],!!A;);}function VU(A){return A=A|0,i[A>>2]=112536,t[A+143|0]<0&&Z(i[A+132>>2]),n2(A)|0}function pU(A){return A=A|0,A?(A=i[A>>2],(i[A+84>>2]-i[A+80>>2]|0)/44|0):0}function FU(A){return A=A|0,i[A>>2]=93336,t[A+135|0]<0&&Z(i[A+124>>2]),n2(A)|0}function Bh(A){return A=A|0,i[A>>2]=85240,i[A+8>>2]!=(e1()|0)&&hh(i[A+8>>2]),A|0}function CU(A){return A=A|0,i[A>>2]=95736,t[A+111|0]<0&&Z(i[A+100>>2]),n2(A)|0}function YU(A){return A=A|0,i[A>>2]=95816,t[A+115|0]<0&&Z(i[A+104>>2]),n2(A)|0}function yU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,W[i[i[e>>2]+80>>2]](A,i[e+4>>2],r,f)}function EU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,W[i[i[e>>2]+84>>2]](A,i[e+4>>2],r,f)}function RU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,W[i[i[e>>2]+88>>2]](A,i[e+4>>2],r,f)}function JU(A,e){return A=A|0,e=e|0,(e|0)>=0&&(e=i[i[20197]+(e<<2)>>2]),e<<24>>24}function NU(A,e){return A=A|0,e=e|0,(e|0)>=0&&(e=i[i[20584]+(e<<2)>>2]),e<<24>>24}function DU(A){return A=A|0,i[A>>2]=93016,t[A+123|0]<0&&Z(i[A+112>>2]),n2(A)|0}function UU(A){return A=A|0,i[A>>2]=94924,t[A+115|0]<0&&Z(i[A+104>>2]),n2(A)|0}function MU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,W[i[i[e>>2]+76>>2]](A,i[e+4>>2],r,f)}function HU(A){return A=A|0,A=Z9(i[A+60>>2])|0,A?(i[33136]=A,A=-1):A=0,A|0}function zU(A,e){A=A|0,e=e|0,e&&(A=i[i[A>>2]+32>>2],X[e>>1]=A,X[e+2>>1]=A>>>16)}function _7(A,e){A=A|0,e=e|0;var r=0;r=A,A=i[e+552>>2],W[i[i[A>>2]+24>>2]](r,A)}function xU(A){A=A|0;var e=0;e=A+12|0,A=i[e+8816>>2],A&&(i[e+8820>>2]=A,Z(A))}function TU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=v-16|0,v=e,ul(A,r,f),v=e+16|0}function jU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=v-16|0,v=e,vl(A,r,f),v=e+16|0}function SU(A,e){return A=A|0,e=e|0,i[A+2152>>2]-i[A+2148>>2]>>2>(e|0)&(e|0)>=0}function f4(A){return A=k2(A),(A|0)==-99999|!A||(A=A&1?A+1>>1:0-(A>>1)|0),A}function OU(A){A=A|0,A&&(a2(i[A+12>>2]),t[A+31|0]<0&&Z(i[A+20>>2]),Z(A))}function vh(A,e){if(i[A>>2]<(e|0))for(;i[A>>2]<(e|0););}function PU(A){A=A|0,i[A>>2]=112456,t[A+115|0]<0&&Z(i[A+104>>2]),Z(n2(A))}function LU(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,W[A|0](e,r,f,k)|0}function qU(A){A=A|0,i[A>>2]=113808,t[A+303|0]<0&&Z(i[A+292>>2]),Z(Ve(A))}function aU(A){A=A|0,i[A>>2]=112696,t[A+115|0]<0&&Z(i[A+104>>2]),Z(n2(A))}function KU(A){A=A|0,i[A>>2]=100856,t[A+575|0]<0&&Z(i[A+564>>2]),Z(n4(A))}function $U(A,e){A=A|0,e=e|0,A&&(A=i[A>>2],W[i[i[A>>2]+16>>2]](A,(e|0)!=0))}function dU(A){return A=A|0,u[137140]||(Ui(137128,85404),t[137140]=1),137128}function ui(A){A=A|0,i[A>>2]=112536,t[A+143|0]<0&&Z(i[A+132>>2]),Z(n2(A))}function bU(A,e){return A=A|0,e=e|0,e>>>0<=127&&(e=i[i[20197]+(e<<2)>>2]),e|0}function cU(A,e){return A=A|0,e=e|0,e>>>0<=127&&(e=i[i[20584]+(e<<2)>>2]),e|0}function iM(A){return A=A|0,u[137156]||(Ui(137144,85440),t[137156]=1),137144}function eM(A){return A=A|0,u[137172]||(je(137160,20902),t[137172]=1),137160}function rM(A){return A=A|0,u[137188]||(Ui(137176,85476),t[137188]=1),137176}function fM(A){return A=A|0,u[137220]||(Ui(137208,85560),t[137220]=1),137208}function AM(A,e,r,f){return A=A|0,e=e|0,r=r|0,f=f|0,A=ss(i[A+60>>2],e,r,f),A|0}function kM(A){A=A|0,i[A>>2]=94924,t[A+115|0]<0&&Z(i[A+104>>2]),Z(n2(A))}function nM(A){A=A|0,i[A>>2]=93016,t[A+123|0]<0&&Z(i[A+112>>2]),Z(n2(A))}function tM(A){A=A|0,i[A>>2]=93336,t[A+135|0]<0&&Z(i[A+124>>2]),Z(n2(A))}function oM(A){A=A|0,i[A>>2]=95736,t[A+111|0]<0&&Z(i[A+100>>2]),Z(n2(A))}function q8(A,e){var r=0;r=v-16|0,v=r,i[r+12>>2]=e,uw(114592,A,e),v=r+16|0}function lM(A){A=A|0,i[A>>2]=95816,t[A+115|0]<0&&Z(i[A+104>>2]),Z(n2(A))}function mr(A){for(var e=0;;){if(A){A=A-1&A,e=e+1|0;continue}break}return e}function uM(A){return A=A|0,u[137204]||(je(137192,8635),t[137204]=1),137192}function sM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,i4(A,i[e+8>>2],0)&&M5(e,r,f)}function hM(A,e,r){A=A|0,e=e|0,r=r|0,i[e>>2]=i[A+200>>2],i[r>>2]=i[A+204>>2]}function wM(A,e){return A=A|0,e=e|0,(e>>>0<=2?i[i[(e<<2)+65064>>2]+A>>2]:0)|0}function _M(A,e){return A=A|0,e=e|0,(e>>>0<=2?i[i[(e<<2)+65076>>2]+A>>2]:0)|0}function BM(A){return A=A|0,i[A>>2]=92456,t[A+23|0]<0&&Z(i[A+12>>2]),A|0}function vM(){var A=0;return A=C(12),i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,A|0}function lf(A,e,r,f){return i[A+76>>2]<0,yl(A,e,r,f)}function mh(A,e){A=A|0,e=e|0,i[A>>2]=0,i[A+4>>2]=0,t[A+20|0]=0,i[A+8>>2]=0}function Zh(A,e,r){A=A|0,e=e|0,r=r|0,A=i[A>>2],W[i[i[A>>2]+20>>2]](A,e,r)}function gh(A,e){var r=0;r=Ms(i[e>>2]),i[A+4>>2]=i[e>>2],t[A|0]=r<<24>>24}function mM(A){return A=A|0,A=i[A+72>>2],(u[A+101|0]?u[A+102|0]?12:10:8)|0}function ZM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,U0(24033,19845,68,11192),M()}function uf(){var A=0;A=ts(Wr(8),12102),i[A>>2]=92196,Ze(A|0,92208,1),M()}function Gh(A){A=A|0;var e=0;return e=A+548|0,xt(e),xt(e),t[A+548|0]=1,0}function Zr(){i[28754]||(kA(),u[115020]&&$A(),i[28754]=i[28754]+1)}function Wh(A,e){return A=A|0,e=e|0,A=V8(i[A>>2],e),(A?(A|0)<0?-1:A:-1)|0}function Xh(A,e){return A=A|0,e=e|0,A=p8(i[A>>2],e),(A?(A|0)<0?-1:A:-1)|0}function M1(A,e){e=!i[A+24>>2]|e,i[A+16>>2]=e,e&i[A+20>>2]&&(N1(),M())}function gM(A){return A=A|0,A=i[A+72>>2],(u[A+105|0]?u[A+111|0]+8|0:8)|0}function gr(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,i[k>>2]=r,3}function GM(A){A=A|0,i[A>>2]=92456,t[A+23|0]<0&&Z(i[A+12>>2]),Z(A)}function B7(A){A=A|0,t[A+97|0]=(i[A+108>>2]|i[A+116>>2]|i[A+132>>2])!=0}function h8(A){var e=0;i[A+16>>2]=0,e=i[A+8>>2],e&&h8(e),t[A+20|0]=1}function Ih(A,e){A=A|0,e=e|0,e&&(A=i[A>>2],W[i[i[A>>2]+24>>2]](A,e))}function Qh(A,e){A=A|0,e=e|0,e&&(A=i[A>>2],W[i[i[A>>2]+28>>2]](A,e))}function WM(A){return A=A|0,A=W[i[i[A+24>>2]+4>>2]](i[A+28>>2])|0,A|0}function N6(A,e){A=A|0,e=e|0,t[A|0]=2,t[A+1|0]=3,t[A+2|0]=0,t[A+3|0]=4}function v7(A){return A=A|0,i[A+8>>2]!=(e1()|0)&&hh(i[A+8>>2]),A|0}function XM(A,e,r,f){return A=A|0,e=e|0,r=r|0,f=f|0,W[A|0](e,r,f)|0}function IM(A){return A=A|0,A=i[i[A>>2]+188>>2],(A?(A|0)<0?-1:A:-1)|0}function QM(A){return A=A|0,A=i[i[A>>2]+192>>2],(A?(A|0)<0?-1:A:-1)|0}function VM(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,P5(A,n)}function pM(A){A=A|0,Zu(i[A>>2]),t[A+19|0]<0&&Z(i[A+8>>2]),Z(A)}function FM(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,h0=-1,-1}function CM(A,e,r){A=A|0,e=e|0,r=r|0,xn(i[A>>2],e,i[i[r>>2]+24>>2])}function Vh(A,e){A=A|0,e=e|0,e&&(A=i[e>>2],A&&Z(A),i[e>>2]=0)}function ph(A,e){var r=0;r=Us(i[e>>2]),i[A+4>>2]=i[e>>2],i[A>>2]=r}function YM(A,e,r){return A=A|0,e=e|0,r=r|0,(e>>>0<128?e:r)<<24>>24}function yM(A){return A=A|0,A=i[A+16>>2],W[i[i[A>>2]+8>>2]](A)|0}function sf(){var A=0;A=Wr(4),i[A>>2]=90928,Ze(A|0,90940,811),M()}function EM(A){A=A|0,t[A+12|0]=1,i[A+4>>2]=2,i[A+8>>2]=2,t[A|0]=1}function RM(A,e,r){A=A|0,e=e|0,r=r|0,U0(24033,19845,51,11042),M()}function JM(A){return A=A|0,A=i[A>>2],(p[A+32>>1]|p[A+34>>1])!=0|0}function NM(A){return A=A|0,A=i[A>>2],W[i[i[A>>2]+104>>2]](A)|0}function DM(A){return A=A|0,A=i[A>>2],W[i[i[A>>2]+108>>2]](A)|0}function UM(A,e){return A=A|0,e=e|0,(i[e+4>>2]==60445?A+12|0:0)|0}function MM(A){A=A|0,O3(135524),O3(135876),X5(135612),X5(135964)}function HM(A){return A=A|0,A=i[A>>2],i[A+360>>2]-i[A+356>>2]>>2}function Fh(A,e){A=A|0,e=e|0,A=i[A>>2],W[i[i[A>>2]+72>>2]](A,e)}function e2(){var A=0;A=Wr(4),i[A>>2]=90984,Ze(A|0,90996,32),M()}function zM(A){return A=A|0,A=i[A>>2],i[A+216>>2]-i[A+212>>2]>>3}function xM(A){return A=A|0,A=i[A+8>>2],i[A+16>>2]-i[A+12>>2]>>3}function TM(A){return A=A|0,A=i[A>>2],i[A+544>>2]-i[A+540>>2]>>2}function m7(A){A=ts(Wr(8),A),i[A>>2]=92144,Ze(A|0,92156,1),M()}function jM(A,e){A=A|0,e=e|0,t[A+24|0]=0,t[A+12|0]=0,t[A+4|0]=0}function SM(A,e){A=A|0,e=e|0,A=i[e>>2],A&&(i[e+4>>2]=A,Z(A))}function OM(A){return A=A|0,A=i[A>>2],W[i[i[A>>2]+16>>2]](A)|0}function PM(A){A=A|0,t[A+97|0]=i[A+40>>2]-i[A+36>>2]>>>0>524280}function LM(A,e){A=A|0,e=e|0,t[i[i[A>>2]+48>>2]+172|0]=(e|0)!=0}function qM(A){return A=A|0,A=i[A+8>>2],A?hs(A)|0:1}function aM(A,e){A=A|0,e=e|0,t[i[i[A>>2]+48>>2]+60|0]=(e|0)!=0}function KM(A,e,r){A=A|0,e=e|0,r=r|0,i[A+28>>2]=r,i[A+24>>2]=e}function Ch(A){return A>>>0>1073741823&&(N1(),M()),y5(A<<2,4)}function Yh(A){a2(i[A+12>>2]),t[A+31|0]<0&&Z(i[A+20>>2])}function $M(A,e){A=A|0,e=e|0,i[A+32>>2]=p[e>>1]|p[e+2>>1]<<16}function dM(A){return A=A|0,W[i[i[A>>2]+68>>2]](i[A+4>>2])|0}function bM(A){return A=A|0,u[137125]||(t[137125]=1),114888}function cM(A){return A=A|0,u[137141]||(t[137141]=1),114900}function yh(A,e){return A=A|0,e=e|0,A=K0(i[A>>2],e),(A||-1)|0}function iH(A,e){A=A|0,e=e|0,i[A+8>>2]=t[e+11|0]<0?i[e>>2]:e}function hf(A){return A=A|0,i[A>>2]=77200,_2(A+32|0),y0(A)|0}function eH(A){return A=A|0,A?u[i[A>>2]+368|0]:0}function rH(A){return A=A|0,A?u[i[A>>2]+416|0]:0}function fH(A){return A=A|0,A?u[i[A>>2]+153|0]:0}function AH(A){return A=A|0,A?i[i[A>>2]+56>>2]:4}function kH(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,br(A,r,16,e,f)}function nH(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,br(A,r,32,e,f)}function ee(A,e){e&&(ee(A,i[e>>2]),ee(A,i[e+4>>2]),Z(e))}function wf(A,e){e&&(wf(A,i[e>>2]),wf(A,i[e+4>>2]),Z(e))}function Z7(A,e){e&&(Z7(A,i[e>>2]),Z7(A,i[e+4>>2]),Z(e))}function g7(A,e){e&&(g7(A,i[e>>2]),g7(A,i[e+4>>2]),Z(e))}function G7(A,e){e&&(G7(A,i[e>>2]),G7(A,i[e+4>>2]),Z(e))}function re(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,Xi(A,e,r,-1,f)}function S1(A,e){e&&(S1(A,i[e>>2]),S1(A,i[e+4>>2]),Z(e))}function _f(A,e){e&&(_f(A,i[e>>2]),_f(A,i[e+4>>2]),Z(e))}function tH(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,cr(A,16,e,r,f)}function Eh(A){return A=A|0,A?i[i[A+8>>2]>>2]:0}function oH(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,cr(A,32,e,r,f)}function p1(A,e){A=A|0,e=e|0,t[e+19|0]<0&&Z(i[e+8>>2])}function lH(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,br(A,r,4,e,f)}function uH(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,br(A,r,8,e,f)}function sH(A){return A=A|0,A?i[A>>2]- -64|0:0}function hH(A,e,r,f){return A=A|0,e=e|0,r=r|0,f=f|0,h0=0,0}function wH(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,CA(A,e,r,0,f)}function _H(A,e,r){return A=A|0,e=e|0,r=r|0,((e|0)<0?r:e)|0}function BH(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,cr(A,4,e,r,f)}function vH(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,cr(A,8,e,r,f)}function mH(A,e,r){return A=A|0,e=e|0,r=r|0,W[A|0](e,r)|0}function ZH(A){return A=A|0,A?u[i[A>>2]+4|0]:0}function gH(A,e){A=A|0,e=e|0,t[e+11|0]<0&&Z(i[e>>2])}function _2(A){return u[A+11|0]>>>7|0&&B6(i[A>>2],1),A}function q1(A){return u[A+11|0]>>>7|0&&B6(i[A>>2],4),A}function Rh(A){return A=A|0,i[A>>2]=85288,_2(A+12|0),A|0}function Jh(A){return A=A|0,i[A>>2]=85328,_2(A+16|0),A|0}function fe(A,e){var r=0;r=y5(e,1),i[A+4>>2]=e,i[A>>2]=r}function Nh(A,e,r){return A=A|0,e=e|0,r=r|0,i4(A,e,0)|0}function y0(A){return A=A|0,i[A>>2]=76792,i2(A+4|0),A|0}function W7(A){return A=A|0,i[A>>2]=77040,i2(A+4|0),A|0}function GH(A){return A=A|0,i[i[i[A>>2]+160>>2]+120>>2]}function WH(A,e,r){A=A|0,e=e|0,r=r|0,CA(A,e,r,0,101976)}function Ae(A,e){var r=0;r=Ch(e),i[A+4>>2]=e,i[A>>2]=r}function XH(A){return A=A|0,F8(i[i[A>>2]-12>>2]+A|0)|0}function IH(A){return A=A|0,k7(i[i[A>>2]-12>>2]+A|0)|0}function QH(A){return A=A|0,n7(i[i[A>>2]-12>>2]+A|0)|0}function VH(A){return A=A|0,r7(i[i[A>>2]-12>>2]+A|0)|0}function pH(A){return A=A|0,f7(i[i[A>>2]-12>>2]+A|0)|0}function Dh(A,e,r){A=A|0,e=e|0,r=r|0,i[i[A>>2]+e>>2]=r}function Uh(A){return A=A|0,Wf(i[i[A>>2]-12>>2]+A|0)|0}function FH(A){return A=A|0,gf(i[i[A>>2]-12>>2]+A|0)|0}function Mh(A){return A=A|0,Gf(i[i[A>>2]-12>>2]+A|0)|0}function CH(A){return A=A|0,(i[A>>2]>=3?i[A+40>>2]:0)|0}function X7(A){return A=A|0,W[i[i[A>>2]+12>>2]](A)|0}function ke(A,e){return A=co(A,e),u[A|0]==(e&255)?A:0}function YH(A){return A=A|0,h0=i[A+44>>2],i[A+40>>2]}function Hh(A){return A=A|0,W[i[i[A>>2]+24>>2]]()|0}function yH(A){A=A|0,t[A+27|0]<0&&Z(i[A+16>>2])}function Bf(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0}function I7(A,e){return A=A|0,e=e|0,$2(i[A>>2],e)|0}function zh(A,e){return A=A|0,e=e|0,i[i[A>>2]+e>>2]}function y2(A){A=A|0,W[i[i[A+12>>2]>>2]](A+12|0)|0}function w8(A){return A?31-_1(A-1^A)|0:32}function O0(A){A=A|0,W[i[i[A+16>>2]>>2]](A+16|0)|0}function EH(A){return A=A|0,i[i[A>>2]+204>>2]!=0|0}function RH(A){A=A|0,t[114931]<0&&Z(i[28730])}function JH(A){A=A|0,t[114951]<0&&Z(i[28735])}function Gr(A,e,r){V4(A+12|0,i[A+16>>2],e,e+r|0,r)}function NH(A){return A=A|0,i[i[A>>2]+240>>2]!=0|0}function DH(A,e){A=A|0,e=e|0,i[A>>2]=0,i[A+4>>2]=0}function UH(){var A=0;return A=C(4),i[A>>2]=0,A|0}function MH(A,e,r){A=A|0,e=e|0,r=r|0,i3(A,r,16,e)}function HH(A,e,r){A=A|0,e=e|0,r=r|0,i3(A,r,32,e)}function zH(A,e,r){A=A|0,e=e|0,r=r|0,u3(A,16,e,r)}function xH(A){return A=A|0,u[i[A+124>>2]+9016|0]}function TH(A,e,r){A=A|0,e=e|0,r=r|0,u3(A,32,e,r)}function jH(A){return A=A|0,u[i[A+124>>2]+9018|0]}function SH(A){return A=A|0,u[i[A+124>>2]+9019|0]}function OH(A){return A=A|0,u[i[A+124>>2]+9020|0]}function PH(A,e,r){A=A|0,e=e|0,r=r|0,_n(A,16,e,r)}function LH(A,e,r){A=A|0,e=e|0,r=r|0,_n(A,32,e,r)}function qH(A){return A=A|0,i[A+8>>2]-i[A+4>>2]|0}function vf(A,e){J0(A,e),i[A+72>>2]=0,t[A+80|0]=0}function aH(A){return A=D(A),P1(A),(o2(2)|0)==-1|0}function KH(A,e,r){A=A|0,e=e|0,r=r|0,u3(A,4,e,r)}function $H(A,e,r){A=A|0,e=e|0,r=r|0,u3(A,8,e,r)}function dH(A){A=A|0,t[A+97|0]=o0[A+104>>2]>65535}function bH(A,e){A=A|0,e=e|0,i[i[A>>2]+212>>2]=e}function cH(A,e){A=A|0,e=e|0,i[i[A>>2]+156>>2]=e}function iz(A,e,r){A=A|0,e=e|0,r=r|0,i3(A,r,4,e)}function ez(A,e,r){A=A|0,e=e|0,r=r|0,i3(A,r,8,e)}function mf(A,e){return A=A|0,e=e|0,W[A|0](e)|0}function xh(A){var e=0,r=0;e=A,r=e1(),i[e>>2]=r}function B6(A,e){if(e>>>0>8){Z(A);return}Z(A)}function Th(A,e,r,f){SB(A|0,e|0,8,0,r|0,-1,f|0)}function Zf(A,e){return A?J3(A,e):0}function rz(A){return A=A|0,i[A+4>>2]-i[A>>2]|0}function fz(A){return A=A|0,u[i[A+72>>2]+112|0]}function Az(A){return A=A|0,(i[A>>2]==1?100:0)|0}function kz(A){return A=A|0,u[i[A+72>>2]+113|0]}function jh(A,e,r){return A=A|0,e=e|0,r=r|0,A|0}function nz(A){return A=A|0,u[i[A+72>>2]+122|0]}function tz(A){return A=A|0,u[i[A+72>>2]+123|0]}function oz(A,e){A=A|0,e=e|0,i[i[A>>2]+56>>2]=e}function lz(A){return A=A|0,i[A>>2]=100468,A|0}function uz(A){return A=A|0,i[A>>2]=101208,A|0}function sz(A){return A=A|0,i[A>>2]=109384,A|0}function hz(A){return A=A|0,i[A>>2]=113536,A|0}function wz(A){return A=A|0,i[A>>2]=100508,A|0}function _z(A){return A=A|0,i[A>>2]=101248,A|0}function Bz(A){return A=A|0,i[A>>2]=109424,A|0}function vz(A){return A=A|0,i[A>>2]=100548,A|0}function mz(A){return A=A|0,i[A>>2]=101320,A|0}function Zz(A){return A=A|0,i[A>>2]=104536,A|0}function gz(A){return A=A|0,i[A>>2]=109464,A|0}function Gz(A){return A=A|0,i[A>>2]=109540,A|0}function Wz(A){return A=A|0,i[A>>2]=101360,A|0}function Xz(A){return A=A|0,i[A>>2]=113672,A|0}function Iz(A){return A=A|0,i[A>>2]=109616,A|0}function Qz(A){return A=A|0,i[A>>2]=101400,A|0}function Vz(A){return A=A|0,i[A>>2]=103600,A|0}function pz(A){return A=A|0,i[A>>2]=105580,A|0}function Fz(A){return A=A|0,i[A>>2]=109656,A|0}function Sh(A,e){A=A|0,e=e|0,t[A+4|0]=(e|0)!=0}function Cz(A){return A=A|0,i[A>>2]=103640,A|0}function Yz(A){return A=A|0,i[A>>2]=109696,A|0}function yz(A){return A=A|0,i[A>>2]=103680,A|0}function Ez(A){return A=A|0,i[A>>2]=100736,A|0}function Rz(A){return A=A|0,i[A>>2]=109736,A|0}function Jz(A){return A=A|0,i[A>>2]=103720,A|0}function Nz(A){return A=A|0,i[A>>2]=109812,A|0}function Dz(A){return A=A|0,i[A>>2]=103760,A|0}function Uz(A){return A=A|0,i[A>>2]=100776,A|0}function Mz(A){return A=A|0,i[A>>2]=103360,A|0}function Hz(A){return A=A|0,i[A>>2]=103800,A|0}function zz(A){return A=A|0,i[A>>2]=107648,A|0}function xz(A){return A=A|0,i[A>>2]=109888,A|0}function Tz(A){return A=A|0,i[A>>2]=100816,A|0}function jz(A){return A=A|0,i[A>>2]=102468,A|0}function Sz(A){return A=A|0,i[A>>2]=107688,A|0}function Oz(A){return A=A|0,i[A>>2]=109928,A|0}function Pz(A){return A=A|0,i[A>>2]=103400,A|0}function Lz(A){return A=A|0,i[A>>2]=106884,A|0}function qz(A){return A=A|0,i[A>>2]=102508,A|0}function az(A){return A=A|0,i[A>>2]=107728,A|0}function Kz(A){return A=A|0,i[A>>2]=109968,A|0}function $z(A){return A=A|0,i[A>>2]=107768,A|0}function dz(A){return A=A|0,i[A>>2]=102588,A|0}function bz(A){return A=A|0,i[A>>2]=104028,A|0}function cz(A){return A=A|0,i[A>>2]=108832,A|0}function ix(A){return A=A|0,i[A>>2]=110084,A|0}function ex(A){return A=A|0,i[A>>2]=107808,A|0}function rx(A){return A=A|0,i[A>>2]=102628,A|0}function fx(A){return A=A|0,i[A>>2]=107848,A|0}function Ax(A){return A=A|0,i[A>>2]=108872,A|0}function kx(A){return A=A|0,i[A>>2]=110160,A|0}function nx(A){return A=A|0,i[A>>2]=100068,A|0}function tx(A){return A=A|0,i[A>>2]=102668,A|0}function ox(A){return A=A|0,i[A>>2]=107888,A|0}function lx(A){return A=A|0,i[A>>2]=108948,A|0}function ux(A){return A=A|0,i[A>>2]=110236,A|0}function sx(A){return A=A|0,i[A>>2]=100108,A|0}function hx(A){return A=A|0,i[A>>2]=107928,A|0}function wx(A){return A=A|0,i[A>>2]=109024,A|0}function _x(A){return A=A|0,i[A>>2]=110312,A|0}function Bx(A){return A=A|0,i[A>>2]=105128,A|0}function vx(A){return A=A|0,i[A>>2]=100148,A|0}function mx(A){return A=A|0,i[A>>2]=109064,A|0}function Zx(A){return A=A|0,i[A>>2]=110388,A|0}function gx(A){return A=A|0,i[A>>2]=104148,A|0}function Gx(A){return A=A|0,i[A>>2]=107968,A|0}function Wx(A){return A=A|0,i[A>>2]=100188,A|0}function Xx(A,e){A=A|0,e=e|0,X[A+152>>1]=e|256}function Ix(A){return A=A|0,i[A>>2]=109104,A|0}function Qx(A){return A=A|0,i[A>>2]=110464,A|0}function Vx(A){return A=A|0,i[A>>2]=108008,A|0}function px(A){return A=A|0,i[A>>2]=100228,A|0}function Fx(A){return A=A|0,i[A>>2]=109144,A|0}function Cx(A){return A=A|0,i[A>>2]=110540,A|0}function Yx(A){return A=A|0,i[A>>2]=100268,A|0}function yx(A){return A=A|0,i[A>>2]=101940,A|0}function Ex(A){return A=A|0,i[A>>2]=109184,A|0}function Rx(A){return A=A|0,i[A>>2]=110616,A|0}function Jx(A){return A=A|0,i[A>>2]=100308,A|0}function Nx(A){return A=A|0,i[A>>2]=101080,A|0}function Dx(A){return A=A|0,i[A>>2]=109224,A|0}function Ux(A){return A=A|0,i[A>>2]=100348,A|0}function Mx(A){return A=A|0,i[A>>2]=109264,A|0}function Hx(A){return A=A|0,i[A>>2]=101128,A|0}function zx(A){return A=A|0,i[A>>2]=113464,A|0}function xx(A){return A=A|0,i[A>>2]=100388,A|0}function Tx(A){return A=A|0,i[A>>2]=109304,A|0}function jx(A){return A=A|0,i[A>>2]=114156,A|0}function Sx(A){return A=A|0,i[A>>2]=100428,A|0}function Ox(A){return A=A|0,i[A>>2]=101168,A|0}function Px(A){return A=A|0,i[A>>2]=106404,A|0}function Lx(A){return A=A|0,i[A>>2]=109344,A|0}function qx(A){return A=A|0,i[A>>2]=101740,A|0}function ax(A){return A=A|0,i[A>>2]=102548,A|0}function m4(A,e,r){u[A|0]&32||D3(e,r,A)}function Kx(A){return A=A|0,i[A>>2]=108784,A|0}function $x(A){return A=A|0,i[A>>2]=110008,A|0}function dx(A){return A=A|0,i[A>>2]=96508,A|0}function bx(A){return A=A|0,i[A>>2]=99308,A|0}function cx(A){return A=A|0,i[A>>2]=97828,A|0}function iT(A){return A=A|0,i[A>>2]=96548,A|0}function eT(A){return A=A|0,i[A>>2]=97868,A|0}function rT(A){return A=A|0,i[A>>2]=99428,A|0}function fT(A,e){return A=A|0,e=e|0,W9(A,e)|0}function AT(A){return A=A|0,i[A>>2]=96588,A|0}function kT(A){return A=A|0,i[A>>2]=97908,A|0}function nT(A){return A=A|0,i[A>>2]=99468,A|0}function tT(A){return A=A|0,i[A>>2]=96628,A|0}function oT(A){return A=A|0,i[A>>2]=98028,A|0}function lT(A){return A=A|0,i[i[A>>2]+204>>2]}function uT(A){return A=A|0,i[A>>2]=96748,A|0}function sT(A){return A=A|0,i[A>>2]=99588,A|0}function hT(A){return A=A|0,i[A>>2]=98068,A|0}function wT(A){return A=A|0,i[A>>2]=96788,A|0}function _T(A){return A=A|0,i[A>>2]=99628,A|0}function BT(A){return A=A|0,i[A>>2]=98108,A|0}function vT(A){return A=A|0,i[A>>2]=96908,A|0}function mT(A){return A=A|0,i[A>>2]=98148,A|0}function ZT(A){return A=A|0,i[A>>2]=99668,A|0}function gT(A){return A=A|0,i[i[A>>2]+200>>2]}function GT(A){return A=A|0,i[A>>2]=96948,A|0}function WT(A){return A=A|0,i[A>>2]=98188,A|0}function XT(A){return A=A|0,i[A>>2]=99708,A|0}function IT(A){return A=A|0,i[A>>2]=97068,A|0}function QT(A){return A=A|0,i[A>>2]=98228,A|0}function VT(A){return A=A|0,i[A>>2]=99748,A|0}function pT(A){return A=A|0,i[A>>2]=97108,A|0}function FT(A){return A=A|0,i[A>>2]=98268,A|0}function CT(A){return A=A|0,i[A>>2]=99788,A|0}function YT(A){return A=A|0,i[A>>2]=67368,A|0}function yT(A){return A=A|0,i[A>>2]=97148,A|0}function ET(A){A=A|0,E7(i[i[A>>2]-12>>2]+A|0)}function RT(A){return A=A|0,i[A>>2]=98388,A|0}function JT(A){return A=A|0,i[A>>2]=99828,A|0}function NT(A){return A=A|0,i[i[A>>2]+156>>2]}function DT(A){return A=A|0,i[A>>2]=97188,A|0}function UT(A){return A=A|0,i[A>>2]=67484,A|0}function MT(A){return A=A|0,i[A>>2]=98428,A|0}function HT(A){return A=A|0,((A|0)==1?100:0)|0}function zT(A){A=A|0,hw(i[i[A>>2]-12>>2]+A|0)}function xT(A){return A=A|0,i[A>>2]=95908,A|0}function TT(A){return A=A|0,i[A>>2]=97228,A|0}function jT(A){return A=A|0,i[A>>2]=99868,A|0}function Oh(A,e,r){return A=A|0,e=e|0,r=r|0,-1}function ST(A){return A=A|0,i[A>>2]=98468,A|0}function OT(A){return A=A|0,i[A>>2]=98508,A|0}function PT(A){return A=A|0,i[A>>2]=99908,A|0}function LT(A){A=A|0,_w(i[i[A>>2]-12>>2]+A|0)}function qT(A){return A=A|0,i[A>>2]=95988,A|0}function aT(A){return A=A|0,i[A>>2]=97308,A|0}function KT(A){return A=A|0,i[A>>2]=98548,A|0}function $T(A){return A=A|0,i[A>>2]=99948,A|0}function dT(A){return A=A|0,i[A>>2]=96028,A|0}function bT(A){A=A|0,Bw(i[i[A>>2]-12>>2]+A|0)}function cT(A){return A=A|0,i[A>>2]=97348,A|0}function ij(A){return A=A|0,i[A>>2]=98668,A|0}function ej(A){return A=A|0,i[A>>2]=96068,A|0}function Ph(A){return A=A|0,i[i[A>>2]+196>>2]}function rj(A){return A=A|0,i[A>>2]=97388,A|0}function fj(A){return A=A|0,i[A>>2]=98708,A|0}function Aj(A){return A=A|0,i[A>>2]=96108,A|0}function kj(A){return A=A|0,i[A>>2]=97428,A|0}function nj(A){return A=A|0,i[A>>2]=98748,A|0}function tj(A){return A=A|0,i[A>>2]=96148,A|0}function oj(A){return A=A|0,i[A>>2]=97468,A|0}function lj(A){return A=A|0,i[A>>2]=98788,A|0}function uj(A){return A=A|0,i[A>>2]=96188,A|0}function sj(A){return A=A|0,i[A>>2]=97508,A|0}function hj(A){return A=A|0,i[A>>2]=98828,A|0}function wj(A){return A=A|0,i[A>>2]=96228,A|0}function _j(A){return A=A|0,i[A>>2]=97548,A|0}function Bj(A){return A=A|0,i[A>>2]=96268,A|0}function vj(A){return A=A|0,i[A>>2]=98948,A|0}function Lh(A){A=A|0,C7(i[i[A>>2]-12>>2]+A|0)}function mj(A){return A=A|0,i[A>>2]=97588,A|0}function qh(A){return A=A|0,i[i[A>>2]+160>>2]}function Zj(A){return A=A|0,i[A>>2]=96308,A|0}function gj(A){return A=A|0,i[A>>2]=98988,A|0}function Gj(A){return A=A|0,i[A>>2]=97628,A|0}function Wj(A){return A=A|0,i[A>>2]=96348,A|0}function Xj(A){return A=A|0,i[A>>2]=97668,A|0}function Ij(A){return A=A|0,i[A>>2]=99108,A|0}function ah(A){A=A|0,Y7(i[i[A>>2]-12>>2]+A|0)}function Qj(A){A=A|0,y7(i[i[A>>2]-12>>2]+A|0)}function Vj(A){return A=A|0,i[A>>2]=96388,A|0}function pj(A){return A=A|0,i[A>>2]=97708,A|0}function Fj(A){return A=A|0,i[A>>2]=99148,A|0}function Cj(A){return A=A|0,i[A>>2]=96428,A|0}function Yj(A){return A=A|0,W[i[A+4>>2]]()|0}function yj(A){return A=A|0,i[A>>2]=97748,A|0}function Ej(A){return A=A|0,i[A>>2]=96468,A|0}function Rj(A){return A=A|0,i[A>>2]=99268,A|0}function Jj(A){return A=A|0,i[A>>2]=97788,A|0}function Nj(A){return A=A|0,i[A>>2]=67596,A|0}function Dj(A){A=A|0,ww(i[i[A>>2]-12>>2]+A|0)}function Uj(A){return A=A|0,i[A>>2]=95948,A|0}function Mj(A){return A=A|0,i[A>>2]=97268,A|0}function Hj(A){return A=A|0,i[i[A>>2]+24>>2]}function zj(A){return A=A|0,i[i[A>>2]+28>>2]}function xj(A){return A=A|0,i[A+324>>2]!=0|0}function Tj(A){return A=A|0,i[i[A>>2]+88>>2]}function Kh(A){return A=A|0,i[i[A>>2]+16>>2]}function $h(A){return A=A|0,i[i[A>>2]+20>>2]}function dh(A){return A=A|0,u[i[A>>2]+208|0]}function bh(A){return A=A|0,u[i[A>>2]+225|0]}function jj(A){return A=A|0,i[A+16>>2]!=0|0}function Sj(A){return A=A|0,i[i[A>>2]+8>>2]}function Oj(A){return A=A|0,i[i[A>>2]+4>>2]}function Pj(A){return A=A|0,(u[A+4|0]?3:6)|0}function C(A){return A=Xs(A),A||I4(),A}function Lj(A){A=A|0,W[i[i[A>>2]+4>>2]](A)}function O1(A,e,r,f){return A=It(A,e,r,f),A}function qj(A){return A=A|0,u[i[A>>2]+60|0]}function aj(A){return A=A|0,(Go(A,0)|0)!=0|0}function Kj(A,e){A=A|0,e=e|0,i[A+160>>2]=e}function gf(A){return A=A|0,Y0(A+12|0),A|0}function $j(A){A=A|0,i[A>>2]=109344,Z(A)}function dj(A){A=A|0,i[A>>2]=100468,Z(A)}function bj(A){A=A|0,i[A>>2]=101208,Z(A)}function cj(A){A=A|0,i[A>>2]=109384,Z(A)}function iS(A){A=A|0,i[A>>2]=113536,Z(A)}function eS(A){A=A|0,i[A>>2]=101248,Z(A)}function rS(A){A=A|0,i[A>>2]=100508,Z(A)}function fS(A){A=A|0,i[A>>2]=109424,Z(A)}function AS(A,e){A=A|0,e=e|0,P5(A,e+12|0)}function kS(A){A=A|0,i[A>>2]=100548,Z(A)}function nS(A){A=A|0,i[A>>2]=101320,Z(A)}function tS(A){A=A|0,i[A>>2]=104536,Z(A)}function oS(A){A=A|0,i[A>>2]=109464,Z(A)}function lS(A,e){A=A|0,e=e|0,P5(A,e+16|0)}function uS(A){return A=A|0,ju(i[A>>2])|0}function sS(A){A=A|0,i[A>>2]=109540,Z(A)}function hS(A){A=A|0,i[A>>2]=101360,Z(A)}function wS(A){A=A|0,i[A>>2]=113672,Z(A)}function _S(A){A=A|0,i[A>>2]=109616,Z(A)}function BS(A){A=A|0,i[A>>2]=101400,Z(A)}function vS(A){A=A|0,i[A>>2]=103600,Z(A)}function mS(A){return A=A|0,pu(i[A>>2])|0}function ZS(A){A=A|0,i[A>>2]=105580,Z(A)}function gS(A){A=A|0,i[A>>2]=109656,Z(A)}function GS(A){A=A|0,t[A+97|0]=u[A+112|0]}function WS(A){A=A|0,i[A>>2]=103640,Z(A)}function XS(A){return A=A|0,lu(i[A>>2])|0}function IS(A){A=A|0,i[A>>2]=109696,Z(A)}function QS(A){A=A|0,i[A>>2]=103680,Z(A)}function VS(A){A=A|0,i[A>>2]=100736,Z(A)}function pS(A){A=A|0,i[A>>2]=109736,Z(A)}function FS(A){A=A|0,i[A>>2]=103720,Z(A)}function CS(A){A=A|0,i[A>>2]=109812,Z(A)}function YS(A){A=A|0,i[A>>2]=103760,Z(A)}function yS(A){A=A|0,i[A>>2]=100776,Z(A)}function ES(A){A=A|0,i[A>>2]=103360,Z(A)}function RS(A){A=A|0,i[A>>2]=103800,Z(A)}function JS(A){A=A|0,i[A>>2]=107648,Z(A)}function NS(A){A=A|0,i[A>>2]=109888,Z(A)}function DS(A){A=A|0,i[A>>2]=100816,Z(A)}function US(A){A=A|0,i[A>>2]=102468,Z(A)}function MS(A){A=A|0,i[A>>2]=107688,Z(A)}function HS(A){A=A|0,i[A>>2]=109928,Z(A)}function zS(A){A=A|0,i[A>>2]=103400,Z(A)}function xS(A){A=A|0,i[A>>2]=106884,Z(A)}function TS(A){A=A|0,i[A>>2]=102508,Z(A)}function jS(A){A=A|0,i[A>>2]=107728,Z(A)}function SS(A){A=A|0,i[A>>2]=109968,Z(A)}function OS(A){A=A|0,i[A>>2]=101740,Z(A)}function PS(A){A=A|0,i[A>>2]=102548,Z(A)}function LS(A){A=A|0,i[A>>2]=108784,Z(A)}function qS(A){A=A|0,i[A>>2]=110008,Z(A)}function Gf(A){return A=A|0,Y0(A+4|0),A|0}function aS(A){A=A|0,i[A>>2]=107768,Z(A)}function KS(A){A=A|0,i[A>>2]=102588,Z(A)}function $S(A){A=A|0,i[A>>2]=104028,Z(A)}function dS(A){A=A|0,i[A>>2]=108832,Z(A)}function bS(A){A=A|0,i[A>>2]=110084,Z(A)}function cS(A){A=A|0,i[A>>2]=107808,Z(A)}function iO(A){A=A|0,i[A>>2]=102628,Z(A)}function eO(A){A=A|0,i[A>>2]=107848,Z(A)}function rO(A){A=A|0,i[A>>2]=108872,Z(A)}function fO(A){A=A|0,i[A>>2]=110160,Z(A)}function AO(A){A=A|0,i[A>>2]=100068,Z(A)}function kO(A){A=A|0,i[A>>2]=102668,Z(A)}function nO(A){A=A|0,i[A>>2]=107888,Z(A)}function tO(A){A=A|0,i[A>>2]=108948,Z(A)}function oO(A){A=A|0,i[A>>2]=110236,Z(A)}function lO(A){A=A|0,i[A>>2]=100108,Z(A)}function uO(A,e){A=A|0,e=e|0,i[A+16>>2]=e}function sO(A){A=A|0,i[A>>2]=107928,Z(A)}function hO(A){A=A|0,i[A>>2]=109024,Z(A)}function wO(A){A=A|0,i[A>>2]=110312,Z(A)}function _O(A){A=A|0,i[A>>2]=105128,Z(A)}function BO(A){A=A|0,i[A>>2]=100148,Z(A)}function vO(A){A=A|0,i[A>>2]=109064,Z(A)}function mO(A){A=A|0,i[A>>2]=110388,Z(A)}function ZO(A){A=A|0,i[A>>2]=104148,Z(A)}function gO(A){A=A|0,i[A>>2]=107968,Z(A)}function GO(A){A=A|0,i[A>>2]=100188,Z(A)}function WO(A){A=A|0,i[A>>2]=109104,Z(A)}function XO(A){A=A|0,i[A>>2]=110464,Z(A)}function IO(A){A=A|0,i[A>>2]=108008,Z(A)}function QO(A){A=A|0,i[A>>2]=100228,Z(A)}function VO(A){A=A|0,i[A>>2]=109144,Z(A)}function pO(A){A=A|0,i[A>>2]=110540,Z(A)}function FO(A){A=A|0,i[A>>2]=100268,Z(A)}function CO(A){A=A|0,i[A>>2]=101940,Z(A)}function YO(A){A=A|0,i[A>>2]=109184,Z(A)}function yO(A){A=A|0,i[A>>2]=110616,Z(A)}function EO(A,e){A=A|0,e=e|0,i[A+12>>2]=e}function RO(A){A=A|0,i[A>>2]=100308,Z(A)}function JO(A){A=A|0,i[A>>2]=101080,Z(A)}function NO(A){A=A|0,i[A>>2]=109224,Z(A)}function DO(A){A=A|0,i[A>>2]=100348,Z(A)}function UO(A){A=A|0,i[A>>2]=109264,Z(A)}function MO(A){A=A|0,i[A>>2]=101128,Z(A)}function HO(A){A=A|0,i[A>>2]=113464,Z(A)}function zO(A){A=A|0,i[A>>2]=100388,Z(A)}function xO(A){A=A|0,i[A>>2]=109304,Z(A)}function TO(A){A=A|0,i[A>>2]=114156,Z(A)}function jO(A){A=A|0,i[A>>2]=100428,Z(A)}function SO(A){A=A|0,i[A>>2]=101168,Z(A)}function OO(A){A=A|0,i[A>>2]=106404,Z(A)}function Wf(A){return A=A|0,Y0(A+8|0),A|0}function PO(A){A=A|0,i[A>>2]=99268,Z(A)}function LO(A){A=A|0,i[A>>2]=97788,Z(A)}function qO(A){A=A|0,i[A>>2]=96508,Z(A)}function aO(A){A=A|0,i[A>>2]=99308,Z(A)}function KO(A){A=A|0,i[A>>2]=97828,Z(A)}function $O(A){A=A|0,i[A>>2]=96548,Z(A)}function dO(A){A=A|0,i[A>>2]=97868,Z(A)}function bO(A){A=A|0,i[A>>2]=99428,Z(A)}function cO(A){A=A|0,i[A>>2]=96588,Z(A)}function iP(A){A=A|0,i[A>>2]=97908,Z(A)}function eP(A){A=A|0,i[A>>2]=99468,Z(A)}function rP(A,e){A=A|0,e=e|0,je(A,13060)}function fP(A){A=A|0,i[A>>2]=96628,Z(A)}function AP(A,e){A=A|0,e=e|0,Ui(A,85360)}function kP(A){A=A|0,i[A>>2]=98028,Z(A)}function nP(A,e){A=A|0,e=e|0,je(A,13347)}function tP(A){A=A|0,i[A>>2]=96748,Z(A)}function oP(A){A=A|0,i[A>>2]=99588,Z(A)}function lP(A){A=A|0,i[A>>2]=98068,Z(A)}function uP(A,e){A=A|0,e=e|0,Ui(A,85380)}function sP(A){A=A|0,i[A>>2]=96788,Z(A)}function hP(A){A=A|0,i[A>>2]=99628,Z(A)}function wP(A){A=A|0,i[A>>2]=98108,Z(A)}function _P(A){A=A|0,i[A>>2]=96908,Z(A)}function BP(A){A=A|0,i[A>>2]=98148,Z(A)}function vP(A){A=A|0,i[A>>2]=99668,Z(A)}function mP(A){A=A|0,i[A>>2]=96948,Z(A)}function ZP(A){A=A|0,i[A>>2]=98188,Z(A)}function gP(A){A=A|0,i[A>>2]=99708,Z(A)}function GP(A){A=A|0,i[A>>2]=97068,Z(A)}function WP(A){A=A|0,i[A>>2]=98228,Z(A)}function XP(A){A=A|0,i[A>>2]=99748,Z(A)}function IP(A){A=A|0,i[A>>2]=97108,Z(A)}function QP(A){A=A|0,i[A>>2]=98268,Z(A)}function VP(A){A=A|0,i[A>>2]=99788,Z(A)}function pP(A){A=A|0,i[A>>2]=67368,Z(A)}function FP(A){A=A|0,i[A>>2]=97148,Z(A)}function CP(A){A=A|0,i[A>>2]=98388,Z(A)}function YP(A){A=A|0,i[A>>2]=99828,Z(A)}function yP(A){A=A|0,i[A>>2]=97188,Z(A)}function EP(A){A=A|0,i[A>>2]=67484,Z(A)}function RP(A){A=A|0,i[A>>2]=98428,Z(A)}function JP(A){A=A|0,i[A>>2]=95908,Z(A)}function NP(A){A=A|0,i[A>>2]=97228,Z(A)}function DP(A){A=A|0,i[A>>2]=67596,Z(A)}function UP(A){A=A|0,i[A>>2]=95948,Z(A)}function MP(A){A=A|0,i[A>>2]=97268,Z(A)}function HP(A){A=A|0,i[A>>2]=98508,Z(A)}function zP(A){A=A|0,i[A>>2]=99908,Z(A)}function xP(A){A=A|0,wf(114952,i[28739])}function TP(A){A=A|0,nf(114964,i[28742])}function jP(A){A=A|0,i[A>>2]=95988,Z(A)}function SP(A){A=A|0,i[A>>2]=97308,Z(A)}function OP(A){A=A|0,i[A>>2]=98548,Z(A)}function PP(A){A=A|0,i[A>>2]=99948,Z(A)}function LP(A){A=A|0,S1(115040,i[28761])}function qP(A){A=A|0,i[A>>2]=96028,Z(A)}function aP(A){A=A|0,S1(115052,i[28764])}function KP(A){A=A|0,i[A>>2]=97348,Z(A)}function $P(A){A=A|0,i[A>>2]=98668,Z(A)}function dP(A){A=A|0,S1(115064,i[28767])}function bP(A){A=A|0,i[A>>2]=96068,Z(A)}function cP(A){A=A|0,i[A>>2]=97388,Z(A)}function iL(A){A=A|0,i[A>>2]=98708,Z(A)}function eL(A){A=A|0,i[A>>2]=96108,Z(A)}function rL(A){A=A|0,i[A>>2]=97428,Z(A)}function fL(A){A=A|0,i[A>>2]=98748,Z(A)}function AL(A){A=A|0,i[A>>2]=96148,Z(A)}function kL(A){A=A|0,i[A>>2]=97468,Z(A)}function nL(A){A=A|0,i[A>>2]=98788,Z(A)}function tL(A){A=A|0,i[A>>2]=96188,Z(A)}function oL(A){A=A|0,i[A>>2]=97508,Z(A)}function lL(A){A=A|0,i[A>>2]=98828,Z(A)}function uL(A){A=A|0,i[A>>2]=96228,Z(A)}function sL(A){A=A|0,i[A>>2]=97548,Z(A)}function hL(A){A=A|0,i[A>>2]=96268,Z(A)}function wL(A){A=A|0,i[A>>2]=98948,Z(A)}function _L(A){A=A|0,i[A>>2]=97588,Z(A)}function BL(A){A=A|0,i[A>>2]=96308,Z(A)}function vL(A){A=A|0,i[A>>2]=98988,Z(A)}function mL(A){A=A|0,G7(115004,i[28752])}function ZL(A){A=A|0,i[A>>2]=97628,Z(A)}function gL(A){A=A|0,i[A>>2]=96348,Z(A)}function GL(A){A=A|0,i[A>>2]=97668,Z(A)}function WL(A){A=A|0,i[A>>2]=99108,Z(A)}function XL(A){A=A|0,i[A>>2]=96388,Z(A)}function IL(A){A=A|0,i[A>>2]=97708,Z(A)}function QL(A){A=A|0,i[A>>2]=99148,Z(A)}function VL(A){A=A|0,i[A>>2]=96428,Z(A)}function pL(A){A=A|0,i[A>>2]=97748,Z(A)}function FL(A){A=A|0,i[A>>2]=96468,Z(A)}function CL(A){A=A|0,i[A>>2]=98468,Z(A)}function YL(A){A=A|0,i[A>>2]=99868,Z(A)}function ch(A,e){A=A|0,e=e|0,ll(A,1,45)}function iw(A,e){A=A|0,e=e|0,Ho(A,1,45)}function yL(A){return A=A|0,i[A+288>>2]}function EL(A){return A=A|0,F8(A-8|0)|0}function Q7(A,e){A=A|0,e=e|0,W[A|0](e)}function ew(A){return A=A|0,W[A|0]()|0}function rw(A,e){return A=A|0,e=e|0,e|0}function RL(A){return A=A|0,i[A+124>>2]}function JL(A){return A=A|0,i[A+552>>2]}function NL(A){return A=A|0,gf(A-8|0)|0}function DL(A,e){A=A|0,e=e|0,t[A+4|0]=e}function UL(A){return A=A|0,1735551332}function fw(A){return A=A|0,1785750887}function ML(A){return A=A|0,i[A+16>>2]}function HL(A){return A=A|0,1635135537}function zL(A){return A=A|0,1635150182}function xL(A){return A=A|0,1781689193}function TL(A){return A=A|0,i[A+20>>2]}function jL(A){return A=A|0,1781689137}function Aw(A){return A=A|0,i[A+12>>2]}function SL(A){return A=A|0,1768912492}function kw(A,e){return(Si(A,e)|0)!=-1}function OL(A){return A=A|0,1635148593}function PL(A){return A=A|0,1635148649}function LL(A){return A=A|0,1768187246}function qL(A,e){A=A|0,e=e|0,i[A>>2]=e}function aL(A){return A=A|0,1852009592}function Xf(A){return A=A|0,2147483647}function KL(A){return A=A|0,1987471715}function $L(A){return A=A|0,1987470129}function dL(A){return A=A|0,1836280681}function bL(A){return A=A|0,1752589105}function nw(A){return A=A|0,u[A+48|0]}function Wr(A){return E2(A+80|0)+80|0}function tw(){Z(i[33064]),i[33064]=0}function cL(A){return A=A|0,u[A+96|0]}function d2(A,e){return rs(A)^rs(e)^1}function b2(A,e){return es(A)^es(e)^1}function V7(A){return A=A|0,i[A+4>>2]}function ow(A){return A=A|0,i[A+8>>2]}function If(A,e){return A=A|0,e=e|0,-1}function iq(A){return A=A|0,A>>>0<2|0}function Qf(A,e){return A=A|0,e=e|0,0}function eq(A){return A=A|0,yt(A,0)|0}function rq(A){return A=A|0,yt(A,1)|0}function fq(A){return A=A|0,pt(A,0)|0}function Aq(A){return A=A|0,pt(A,1)|0}function kq(A){return A=A|0,t[A+8|0]}function nq(A){return A=A|0,t[A+9|0]}function p7(A,e,r){A=A|0,e=e|0,r=r|0}function Vf(A){return A=A|0,u[A+4|0]}function z4(A,e){M1(A,i[A+16>>2]|e)}function A4(A){return Ms(i[A>>2]),A}function k4(A){return Us(i[A>>2]),A}function lw(A){return A=A|0,Y0(A)|0}function tq(A){return A=A|0,102840}function oq(A){return A=A|0,102896}function lq(A){return A=A|0,115232}function uq(A){return A=A|0,102772}function sq(A){return A=A|0,14230}function hq(A){return A=A|0,21121}function wq(A){return A=A|0,11020}function _q(A){return A=A|0,15034}function Bq(A){return A=A|0,19624}function vq(A){return A=A|0,14118}function mq(A){return A=A|0,13008}function Zq(A){return A=A|0,11812}function gq(A){return A=A|0,16966}function Gq(A){return A=A|0,14281}function Wq(A){return A=A|0,10478}function Xq(A){return A=A|0,13955}function Iq(A){return A=A|0,21514}function a2(A){A=A|0,A&&Z(A)}function Qq(A){return A=A|0,21271}function Vq(A){return A=A|0,15444}function pq(A){return A=A|0,23611}function Fq(A){return A=A|0,13331}function Cq(A){return A=A|0,12203}function Yq(A){return A=A|0,10491}function yq(A){return A=A|0,13435}function Eq(A){return A=A|0,16984}function Rq(A){return A=A|0,15047}function Jq(A){return A=A|0,13975}function Nq(A){return A=A|0,16999}function Dq(A){return A=A|0,20622}function Uq(A){return A=A|0,17046}function Mq(A){return A=A|0,20085}function Hq(A){return A=A|0,11036}function pf(A){return A=A|0,20706}function zq(A){return A=A|0,14257}function xq(A){return A=A|0,20659}function Tq(A){return A=A|0,17015}function jq(A){return A=A|0,4772}function Sq(A){return A=A|0,9157}function Oq(A){return A=A|0,9068}function Pq(A){return A=A|0,8669}function Lq(A){return A=A|0,4583}function qq(A){A=A|0,Le(A),Z(A)}function aq(A){return A=A|0,8955}function Kq(A){return A=A|0,8868}function $q(A){return A=A|0,9086}function dq(A){return A=A|0,4048}function bq(A){return A=A|0,3098}function cq(A){return A=A|0,3074}function ia(A){return A=A|0,4897}function ea(A){return A=A|0,8807}function ra(A){return A=A|0,9118}function fa(A){return A=A|0,8567}function Aa(A){return A=A|0,1515}function ka(A){return A=A|0,9247}function na(A){return A=A|0,8457}function ta(A){A=A|0,t[A+97|0]=0}function oa(A){return A=A|0,1499}function la(A){return A=A|0,9051}function ua(A){return A=A|0,7621}function uw(A,e,r){G3(A,e,r,0,0)}function sa(A){return A=A|0,4916}function ha(A){return A=A|0,8824}function wa(A){return A=A|0,7645}function _a(A){return A=A|0,9221}function Ba(A){return A=A|0,5697}function va(A){return A=A|0,6272}function ma(A){return A=A|0,9008}function Za(A){A=A|0,t[A+97|0]=1}function ga(A){A=A|0,y0(A),Z(A)}function sw(A){A=A|0,Y0(A),Z(A)}function Ga(A){return A=A|0,5139}function Wa(A){return A=A|0,8110}function Xa(A){return A=A|0,8097}function Ia(A){return A=A|0,5937}function Qa(A){return A=A|0,8147}function Va(A){return A=A|0,8123}function pa(A){return A=A|0,8142}function Fa(A){return A=A|0,6853}function Ca(A){return A=A|0,3905}function Ya(A){return A=A|0,5194}function ya(A){return A=A|0,7446}function Ea(A){return A=A|0,8849}function Ra(A){return A=A|0,3895}function F7(A){A=A|0,Ns(A),Z(A)}function Ja(A){A=A|0,W7(A),Z(A)}function Na(A){return A=A|0,8437}function Da(A){return A=A|0,9140}function Ua(A){return A=A|0,5996}function L4(A){return A=A|0,A|0}function Ma(A){A=A|0,q1(137128)}function Ff(A,e){return h0=A,e}function Ha(A){A=A|0,_2(114900)}function za(A){A=A|0,q1(137144)}function xa(A){A=A|0,_2(137160)}function Ta(A){A=A|0,q1(137176)}function Cf(A){return A=A|0,127}function ja(A){A=A|0,_2(137192)}function Sa(A){A=A|0,q1(137208)}function Oa(){return D(D(NaN))}function Pa(A){A=A|0,_2(114888)}function La(A){A=A|0,Z(Rh(A))}function qa(A){A=A|0,Z(Jh(A))}function hw(A){A=A|0,Z(k7(A))}function ww(A){A=A|0,Z(n7(A))}function _w(A){A=A|0,Z(r7(A))}function Xr(A,e){u2(A,e&65535)}function aa(A){A=A|0,Z(Ve(A))}function Bw(A){A=A|0,Z(f7(A))}function C7(A){A=A|0,Z(Wf(A))}function Ka(A){A=A|0,Z(qo(A))}function Y7(A){A=A|0,Z(Gf(A))}function y7(A){A=A|0,Z(gf(A))}function vw(A){A=A|0,Z(y0(A))}function E7(A){A=A|0,Z(F8(A))}function $a(A){A=A|0,Z(Oo(A))}function da(A){A=A|0,Z(hf(A))}function ba(A){A=A|0,Z(Ro(A))}function ca(A){A=A|0,Z(b9(A))}function R7(A){A=A|0,Z(n4(A))}function mw(A){A=A|0,Z(W7(A))}function iK(A){A=A|0,E7(A-8|0)}function P2(A){A=A|0,Z(n2(A))}function eK(A){A=A|0,Z(al(A))}function rK(A){A=A|0,Z(Ee(A))}function H2(A,e){P8(A,e,l2(e))}function fK(A){A=A|0,Z(yo(A))}function AK(A){A=A|0,Z(Al(A))}function kK(A){A=A|0,Z(Y0(A))}function nK(A){A=A|0,Z(Ah(A))}function Zw(A){A=A|0,Z(v7(A))}function tK(A){A=A|0,Z(Bh(A))}function oK(A){A=A|0,y7(A-8|0)}function lK(A){A=A|0,Z(wt(A))}function uK(A){return A=A|0,9}function gw(A){return A=A|0,3}function Gw(A){return A=A|0,7}function r1(A){return A=A|0,0}function C4(A){return A=A|0,2}function J7(A){return A=A|0,5}function Ww(){return 18219520}function si(A){return A=A|0,4}function x1(A){return A=A|0,1}function Yf(A){return A=A|0,-1}function Xw(A){fh(A,i[A>>2])}function G8(A,e){A=A|0,e=e|0}function sK(){return 101976}function hK(){return 102080}function I0(){m7(12102),M()}function wK(){return 22927}function _K(){return 23426}function w0(A){A=A|0,Z(A)}function s0(){m7(6870),M()}function BK(){return 11015}function yf(A){A=A|0,M()}function vK(){return 22}function mK(){return 1}function ZK(){return 2}function I4(){N1(),M()}function N1(){LB(),M()}function hi(A){A=A|0}function gK(){us()}function GK(){ys()}function WK(){}b=u,d0(V1);var W=e0([null,Ns,RR,LR,MN,Js,iF,iR,KR,Bf,Bf,RJ,MJ,YH,Js,nY,aE,mU,Bf,Bf,BM,GM,WM,vN,iU,dD,xv,YJ,yJ,yf,I4,FM,L4,ND,rU,r1,k3,r1,Al,AK,ka,rm,x1,JG,XI,p7,cX,r1,cL,r1,Xv,JJ,wp,n2,P2,vq,Bg,aQ,hi,C4,zQ,jJ,zo,P2,dq,oG,$p,C4,FF,P2,LZ,KI,C4,eQ,P2,J2,OQ,MX,sD,JD,qZ,uV,bg,DU,nM,AG,oX,RL,jE,uD,ED,Jq,SZ,nV,Cm,P2,Uq,J2,cF,XV,P2,Mq,X6,ta,rR,FU,tM,gq,Og,ip,fQ,P2,Wq,TW,Hp,dH,Xp,cE,kR,oa,wZ,ZI,JN,ag,P2,la,X6,XQ,PM,SC,P2,Ua,X6,re,P2,ua,fX,re,P2,sa,OG,mF,XJ,r1,pp,dy,kE,_a,Ov,nI,VY,oZ,GJ,FJ,va,Qg,WV,x1,yX,P2,ma,xW,pF,x1,x1,x1,GC,P2,Cq,rW,DF,x1,x1,x1,FC,P2,yq,uG,lV,x1,x1,x1,ng,HY,SY,Eq,XZ,AI,ZY,qv,hD,RD,Dq,XG,xF,sQ,P2,Ca,X6,re,wD,nh,At,cQ,XA,nh,ya,lG,aZ,xR,$R,Na,Wg,YI,x1,HW,P2,Da,X6,re,P2,Tq,X6,wg,pW,UU,kM,hq,yW,qp,BQ,oD,YD,Oq,FG,bQ,C4,AX,P2,Pq,TG,_F,C4,iC,P2,aq,PW,UF,C4,CC,P2,$q,jG,ZF,C4,rC,P2,bq,hg,mI,C4,yI,P2,cq,yZ,KG,C4,AZ,dE,AR,ea,_g,Op,C4,jX,P2,ra,tZ,Zp,xy,bV,P2,fa,Ug,Mp,Ky,aV,CU,oM,Iq,EW,HF,x1,r1,r1,EI,YU,lM,Vq,YW,MF,C4,_V,xT,JP,O0,Qf,w0,Uj,UP,O0,w0,qT,jP,O0,w0,dT,qP,O0,w0,ej,bP,O0,w0,Aj,eL,O0,w0,tj,AL,O0,w0,uj,tL,O0,w0,wj,uL,O0,w0,Bj,hL,O0,w0,Zj,BL,O0,w0,Wj,gL,O0,w0,Vj,XL,O0,w0,Cj,VL,O0,w0,Ej,FL,O0,w0,dx,qO,O0,w0,iT,$O,O0,w0,AT,cO,O0,w0,tT,fP,O0,w0,VU,ui,zm,MZ,lZ,uT,tP,O0,w0,wT,sP,O0,w0,ui,vT,_P,O0,w0,GT,mP,O0,w0,ui,IT,GP,O0,w0,pT,IP,O0,w0,yT,FP,O0,w0,DT,yP,O0,w0,TT,NP,O0,w0,Mj,MP,O0,w0,aT,SP,O0,w0,cT,KP,O0,w0,rj,cP,O0,w0,kj,rL,O0,w0,oj,kL,O0,w0,sj,oL,O0,w0,_j,sL,O0,w0,mj,_L,O0,w0,Gj,ZL,O0,w0,Xj,GL,O0,w0,pj,IL,O0,w0,yj,pL,O0,w0,Jj,LO,O0,w0,cx,KO,O0,w0,eT,dO,O0,w0,kT,iP,O0,w0,ui,oT,kP,O0,w0,hT,lP,O0,w0,BT,wP,O0,w0,mT,BP,O0,w0,WT,ZP,O0,w0,QT,WP,O0,w0,FT,QP,O0,w0,ui,RT,CP,O0,w0,MT,RP,O0,w0,ST,CL,O0,w0,OT,HP,O0,w0,KT,OP,O0,w0,ui,ij,$P,O0,w0,fj,iL,O0,w0,nj,fL,O0,w0,lj,nL,O0,w0,hj,lL,O0,w0,P2,Rq,X6,re,vj,wL,O0,w0,gj,vL,O0,w0,P2,Hq,Ij,WL,O0,w0,Fj,QL,O0,w0,P2,xq,Rj,PO,O0,w0,bx,aO,O0,w0,P2,Sq,rT,bO,O0,w0,nT,eP,O0,w0,P2,_q,sT,oP,O0,w0,_T,hP,O0,w0,ZT,vP,O0,w0,XT,gP,O0,w0,VT,XP,O0,w0,CT,VP,O0,w0,JT,YP,O0,w0,jT,YL,O0,w0,PT,zP,O0,w0,$T,PP,O0,w0,P2,wa,nx,AO,O0,w0,sx,lO,O0,w0,vx,BO,O0,w0,Wx,GO,O0,w0,px,QO,O0,w0,Yx,FO,O0,w0,Jx,RO,O0,w0,Ux,DO,O0,w0,xx,zO,O0,w0,Sx,jO,O0,w0,lz,dj,O0,w0,wz,rS,O0,w0,vz,kS,O0,w0,RH,JH,o4,p1,SM,p1,o4,p1,rF,tV,o4,p1,o4,p1,o4,p1,Ez,VS,eg,w0,Uz,yS,oy,w0,Tz,DS,O0,w0,IU,KU,Pp,Jp,DL,BI,sI,TI,Ey,DR,dF,qJ,vX,aJ,gg,KJ,jg,Xx,XX,JL,pf,r1,EE,r1,mh,UA,Yf,Yf,hM,ZW,cD,r1,r1,bu,hi,Gu,Gu,jv,pY,$G,DH,ny,Nx,JO,ZR,w0,Hx,MO,yH,w0,Ox,SO,y2,w0,uz,bj,O0,w0,_z,eS,O0,w0,G8,p1,G8,p1,mz,nS,KX,w0,Wz,hS,O0,w0,Qz,BS,O0,w0,xD,nU,WJ,qH,ME,L4,Ro,ba,TE,JE,KM,$M,HE,Kj,o4,p1,Ee,rK,qx,OS,y2,w0,xP,TP,DD,AU,V7,mX,xE,L4,w0,aL,nG,Gy,uR,gR,Lg,DQ,Mv,yx,CO,y2,w0,hi,mL,L4,w0,r1,kg,$D,wN,w0,x1,pZ,ms,TR,w0,C4,FZ,ms,jR,w0,si,BZ,r1,SR,NN,lD,Pj,Gv,Ny,Uy,EN,cN,J7,Nv,nR,jz,US,y2,w0,qz,TS,y2,w0,ax,PS,y2,w0,dz,KS,y2,w0,rx,iO,y2,w0,tx,kO,y2,w0,o4,p1,YE,zy,XF,SJ,rY,ID,BD,uF,Ks,ZC,VC,xJ,IZ,ew,Ww,ew,Gn,Q7,i8,mf,V5,Q7,oi,mf,Os,Ps,dh,Q7,i8,Kn,bh,NF,Ks,xY,lY,sY,hY,wY,mf,T5,mH,Ul,uq,i8,tq,oi,oq,i8,vM,a2,zh,Dh,zh,Dh,Iy,iH,vE,OC,c9,LP,aP,dP,o4,p1,o4,p1,o4,p1,o4,p1,o4,p1,o4,p1,gH,p1,G8,p1,o4,p1,o4,p1,o4,p1,vQ,Mz,ES,Gg,w0,Pz,zS,y2,w0,o4,p1,o4,p1,s8,yf,jM,Jm,hm,RE,qg,G8,p1,G8,p1,_D,qE,Vz,vS,O0,w0,Cz,WS,O0,w0,yz,QS,O0,w0,Jz,FS,O0,w0,Dz,YS,O0,w0,Hz,RS,O0,w0,By,py,bL,pq,bu,x1,_7,SV,OV,RG,iX,pi,lv,Gm,di,ci,bz,$S,y2,w0,KF,bF,Yq,Zv,Ym,x1,Hm,gx,ZO,O0,w0,L4,w0,o4,p1,BR,VR,x1,nz,tz,ay,OZ,Pg,yp,Up,r1,mm,Vf,lg,mJ,kF,EG,hy,Xy,HL,pf,si,_7,zL,bW,pi,di,ci,Zz,tS,y2,w0,QC,RC,gm,Vf,MW,BJ,vF,yG,wR,IR,si,mM,X7,lC,ky,iD,WD,Lm,LV,x1,bZ,P2,LW,_Y,JC,P2,FW,gV,$V,vy,Fy,fw,gw,_7,fw,KW,pi,di,ci,Bx,_O,y2,w0,AD,pD,zW,mY,am,vR,pR,gw,cR,X7,_p,TC,EC,UC,UD,rZ,nw,pg,tf,Gl,aW,YY,p1,wy,Qy,jL,Gw,aF,xL,Sg,pi,RZ,di,ci,pz,ZS,y2,w0,hR,XR,Gw,xV,MV,VE,mh,YC,ql,yv,nw,Fg,tf,Gl,WG,ql,mG,eD,XD,LG,kp,eZ,rD,QD,aG,Lp,QX,cY,ry,CG,qW,nm,kD,FD,qG,np,TZ,P2,X6,x1,re,my,Cy,$L,pf,J7,IW,KL,eX,pi,di,ci,Px,OO,y2,w0,sR,GR,J7,gM,X7,Oy,jQ,xZ,Cp,Np,om,Vf,NZ,_J,BF,QG,Oo,$a,Pv,Em,x1,Qv,_y,Vy,OL,pf,C4,PL,cW,pi,di,ci,Lz,xS,y2,w0,yo,fK,wv,mv,x1,JZ,_R,QR,C4,fz,kz,Ty,Bm,wX,Yp,Dp,_m,Vf,fg,vJ,tp,VG,P2,SW,uY,x1,zF,n4,R7,dL,x1,uK,gC,r1,zv,Rv,R7,r1,o4,p1,uy,p1,zz,JS,O0,w0,Sz,MS,O0,w0,az,jS,O0,w0,$z,aS,O0,w0,ex,cS,O0,w0,fx,eO,O0,w0,ox,nO,O0,w0,hx,sO,O0,w0,Gx,gO,O0,w0,Vx,IO,O0,w0,OJ,hN,UL,KC,DV,Ap,Wp,PY,Zm,nv,DI,SG,UG,L4,w0,IE,UM,w0,kJ,hJ,SL,CZ,ep,rp,QE,jY,Om,ov,MG,R7,LL,cV,JV,NV,xI,r1,vv,yE,HG,gy,Kx,LS,y2,w0,cz,dS,y2,w0,Ax,rO,y2,w0,L4,w0,YQ,Vv,lx,tO,y2,w0,w0,CQ,Dv,wx,hO,y2,w0,mx,vO,y2,w0,Ix,WO,y2,w0,Fx,VO,y2,w0,Ex,YO,y2,w0,Dx,NO,y2,w0,Mx,UO,y2,w0,Tx,xO,y2,w0,Lx,$j,y2,w0,sz,cj,y2,w0,Bz,fS,y2,w0,gz,oS,y2,w0,w0,JW,Wv,Gz,sS,y2,w0,w0,UW,gv,Iz,_S,y2,w0,Fz,gS,y2,w0,Yz,IS,y2,w0,Rz,pS,y2,w0,w0,LQ,Im,Nz,CS,y2,w0,w0,qQ,Wm,xz,NS,y2,w0,Oz,HS,y2,w0,Kz,SS,y2,w0,$x,qS,y2,w0,w0,sF,Jv,ix,bS,y2,w0,w0,tF,pv,kx,fO,y2,w0,w0,oF,fm,ux,oO,y2,w0,w0,lF,Kv,_x,wO,y2,w0,w0,PI,em,Zx,mO,y2,w0,w0,LI,Lv,Qx,XO,y2,w0,w0,qI,lm,Cx,pO,y2,w0,w0,aI,Am,Rx,yO,y2,w0,w0,UI,Tv,w0,AQ,_v,w0,IC,Xm,w0,GD,My,w0,Tp,fZ,w0,FQ,Sm,w0,JI,sm,w0,bI,jm,w0,CX,Dm,w0,RX,Km,w0,PC,Qm,w0,kY,Vm,w0,UX,EZ,w0,tY,wm,w0,NX,Pm,w0,fF,cZ,w0,AF,$m,w0,Gp,iG,w0,GF,km,w0,PF,Fv,P2,Wa,xm,WI,B7,VZ,P2,Xa,um,gI,B7,Zg,P2,Qa,vg,TQ,B7,VX,P2,Va,gG,_C,IV,P2,pa,YX,RY,TF,EY,UY,Ea,hG,yV,Ag,lN,CN,zq,NG,Qp,Um,uN,YN,sq,DG,iQ,Za,Nm,eN,gN,wq,Xg,op,UZ,rN,GN,Lq,IG,vp,DE,jW,fN,WN,mq,xg,lp,qm,kN,XN,Gq,dG,_Q,OW,P2,ia,fG,MC,Bp,GU,PU,Xq,CW,iu,wV,ui,P2,Aa,GG,oC,cI,XU,aU,Qq,RW,iu,hV,nN,IN,na,PZ,ZV,GS,eW,MD,fU,XW,tf,fo,yY,NY,ha,HZ,tf,ZN,vZ,P2,Fq,Kg,DC,$Y,tN,QN,Ba,zZ,IQ,AW,oN,VN,Ga,$Z,NQ,cC,hX,fD,VD,Ia,KZ,MI,$y,AE,Nq,QZ,QQ,Iv,nD,CD,Ra,YZ,HQ,zY,mZ,zx,HO,y2,w0,OY,KY,$J,LJ,hz,iS,y2,w0,Ve,aa,AA,yN,r1,Dn,G8,p1,Xz,wS,y2,w0,qo,Ka,tm,DZ,xj,OR,G8,p1,WU,qU,bm,oI,gK,GK,HT,mE,pM,fC,WH,Sh,wH,Az,qy,nC,dN,CA,BK,UN,WK,HJ,a2,h7,mN,h7,pN,h7,FN,lq,Br,Br,Br,Br,Br,cJ,G8,RN,iN,p7,wt,lK,tv,Yv,uv,jx,TO,O0,w0,P2,jq,bG,tg,C4,dp,hi,L4,w0,VW,XY,L4,yf,b9,ca,EJ,SU,YT,pP,vY,w0,UT,EP,xU,w0,Nj,DP,LC,w0,bC,RM,jN,TN,xN,hI,zN,HN,aN,uI,qN,LN,PN,wI,xX,HX,zX,jV,Fm,EV,KD,aD,qD,pI,LD,PD,OD,QI,SD,jD,TD,VI,qX,OX,LX,WQ,ym,up,dI,MQ,Rp,UV,rQ,SQ,JF,Ip,iV,aC,qV,tC,cv,iz,ez,MH,HH,ZM,Tm,lH,uH,kH,nH,HV,TV,oV,cp,EF,Kp,LH,PH,im,FX,TH,zH,$H,KH,uZ,oH,tH,vH,BH,sZ,pG,AN,w0,ZZ,IY,QY,LY,w0,ZQ,dC,w0,JX,WY,Lt,HU,FI,AM,r1,hH,av,sJ,qC,gp,z5,y0,ga,G8,jh,Ls,kh,r1,r1,CV,Yf,UJ,If,eF,If,Wf,C7,Uh,Lh,Gf,Y7,Mh,ah,gf,y7,NL,oK,FH,Qj,W7,Ja,G8,jh,Ls,kh,r1,r1,eV,Yf,DJ,If,Vp,If,Wf,C7,Uh,Lh,Gf,Y7,Mh,ah,hf,da,iI,mD,ey,kC,NI,Le,qq,mQ,rI,PX,Ep,mW,dg,Ay,PG,lw,sw,lw,sw,F8,E7,EL,iK,XH,ET,k7,hw,IH,zT,n7,ww,QH,Dj,r7,_w,VH,LT,f7,Bw,pH,bT,Y0,kK,MM,vw,SE,eq,rq,kQ,vw,tJ,cl,_E,GQ,mw,OE,fq,Aq,lQ,mw,oJ,cl,wE,yQ,KE,Z,hi,sh,tU,oU,lU,uU,sU,hU,Pa,Ma,Ha,za,xa,Ta,ja,Sa,al,eK,Lj,Ah,nK,JU,MR,NU,HR,rw,pJ,_H,qR,Bh,tK,vG,Eg,MY,XE,r1,AC,qM,Rh,La,kq,nq,AS,rP,nP,Jh,qa,ow,Aw,lS,AP,uP,L4,w0,w0,$N,fR,oR,tR,bU,YR,cU,yR,rw,IJ,YM,UR,w0,$s,$s,gr,x1,x1,eR,x1,w0,vt,ut,gr,r1,r1,Ht,si,w0,vt,ut,gr,r1,r1,Ht,si,w0,Dt,_t,gr,r1,r1,Mt,si,w0,Dt,_t,gr,r1,r1,Mt,si,L4,w0,ly,TU,FR,L4,w0,Ry,jU,WR,w0,hQ,gW,lW,GW,Xt,Xt,uW,Dg,Mg,yg,iW,w0,wQ,wW,kW,_W,Wt,Wt,nW,Hg,zg,Rg,fW,w0,mV,BC,LF,vC,qF,lX,tW,NC,w0,sV,uC,SF,sC,OF,uX,oW,pC,L4,w0,C4,$E,aY,jy,Sy,by,Mm,$C,PV,JR,eM,uM,bM,cM,L4,w0,C4,FY,TY,Py,Ly,cy,Rm,jC,pV,NR,rM,fM,dU,iM,v7,Zw,vV,v7,Zw,tI,w0,Cf,Cf,g8,g8,g8,ch,r1,N6,N6,w0,Cf,Cf,g8,g8,g8,ch,r1,N6,N6,w0,Xf,Xf,g8,g8,g8,iw,r1,N6,N6,w0,Xf,Xf,g8,g8,g8,iw,r1,N6,N6,w0,WW,tG,w0,vW,mg,w0,Cg,rG,w0,Ig,eG,w0,Oh,VM,G8,w0,Oh,EQ,G8,yf,w0,Fa,w0,Ya,L4,w0,hi,hi,Nh,w0,Nh,w0,YF,vD,zC,sM,w0,aR,fV,CJ,w0,PQ,DW,yy,w0,YG,w0,Bq,w0,Zq,w0,Kq,F7,V7,F7,F7]);function Iw(){return E1.byteLength/65536|0}function XK(A){A=A|0;var e=Iw()|0,r=e+A|0;if(e<r&&r<65536){var f=new ArrayBuffer(g(r,65536)),k=new Int8Array(f);k.set(t),t=new Int8Array(f),X=new Int16Array(f),i=new Int32Array(f),u=new Uint8Array(f),p=new Uint16Array(f),o0=new Uint32Array(f),E0=new Float32Array(f),u0=new Float64Array(f),E1=f,b=u}return e}return{P:Object.create(Object.prototype,{grow:{value:XK},buffer:{get:function(){return E1}}}),Q:dm,R:W,S:Af,T:a2,U:bi,V:li,W:sK,X:Z,Y:EM,Z:a2,_:B5,$:v5,aa:w5,ba:iJ,ca:DX,da:gD,ea:eU,fa:QJ,ga:UH,ha:zJ,ia:Ww,ja:Gn,ka:i8,la:V5,ma:oi,na:Os,oa:Ps,pa:dh,qa:i8,ra:Kn,sa:bh,ta:T5,ua:Ul,va:_K,wa:ls,xa:Tl,ya:jt,za:OA,Aa:Yt,Ba:NA,Ca:gT,Da:Ph,Ea:I7,Fa:Ki,Ga:Wh,Ha:Xh,Ia:yh,Ja:rl,Ka:Ou,La:E2,Ma:ml,Na:Zl,Oa:gl,Pa:Cl,Qa:mK,Ra:vK,Sa:ZK,Ta:Hy,Ua:pQ,Va:a2,Wa:Jy,Xa:IM,Ya:QM,Za:eI,_a:Cv,$a:pE,ab:Du,bb:Du,cb:Ki,db:wF,eb:Wy,fb:bp,gb:E3,hb:vU,ib:Zh,jb:Zh,kb:YA,lb:hu,mb:ou,nb:$U,ob:ZH,pb:iZ,qb:ws,rb:uu,sb:a2,tb:gu,ub:Nu,vb:AV,wb:sp,xb:gu,yb:Nu,zb:kV,Ab:hp,Bb:EX,Cb:Iu,Db:JM,Eb:zU,Fb:VF,Gb:Ih,Hb:Ih,Ib:qj,Jb:UE,Kb:zV,Lb:Qh,Mb:Qh,Nb:aX,Ob:HM,Pb:gY,Qb:QV,Rb:Eh,Sb:oi,Tb:jF,Ub:xM,Vb:ZG,Wb:iY,Xb:nF,Yb:yM,Zb:KQ,_b:SX,$b:zp,ac:gX,bc:xp,cc:GX,dc:tu,ec:qt,fc:Rt,gc:tu,hc:qt,ic:Rt,jc:xQ,kc:qY,lc:kX,mc:jZ,nc:dZ,oc:vI,pc:dX,qc:bX,rc:sW,sc:hW,tc:dW,uc:RQ,vc:Vg,wc:tX,xc:IX,yc:GI,zc:Ev,Ac:cm,Bc:AJ,Cc:$v,Dc:dv,Ec:Sv,Fc:Jg,Gc:dQ,Hc:CI,Ic:uQ,Jc:eH,Kc:fp,Lc:rH,Mc:QF,Nc:a2,Oc:BW,Pc:jp,Qc:ZX,Rc:WE,Sc:fY,Tc:Oa,Uc:aH,Vc:nQ,Wc:_U,Xc:WF,Yc:YV,Zc:WC,_c:Ng,$c:BU,ad:BV,bd:QW,cd:TX,dd:wU,ed:Sp,fd:oQ,gd:sy,hd:fH,id:ZU,jd:pX,kd:RI,ld:Vh,md:jI,nd:sX,od:cG,pd:Vh,qd:CF,rd:GV,sd:wG,td:VQ,ud:nZ,vd:UQ,wd:EH,xd:uS,yd:mS,zd:oi,Ad:lT,Bd:CE,Cd:Hj,Dd:eC,Ed:zj,Fd:XS,Gd:CY,Hd:OM,Id:GH,Jd:Tj,Kd:RV,Ld:$g,Md:D5,Nd:i5,Od:a2,Pd:NT,Qd:Zy,Rd:Hv,Sd:vm,Td:NJ,Ud:QU,Vd:rz,Wd:Aw,Xd:yC,Yd:bH,Zd:rJ,_d:OU,$d:a2,ae:qL,be:Sh,ce:Yy,de:b5,ee:K3,fe:uO,ge:ZJ,he:Ru,ie:El,je:a2,ke:kI,le:cH,me:RF,ne:JQ,oe:gZ,pe:fJ,qe:zR,re:EO,se:kZ,te:lJ,ue:SI,ve:DY,we:$l,xe:bJ,ye:$F,ze:gJ,Ae:jj,Be:ML,Ce:gU,De:eJ,Ee:CM,Fe:BE,Ge:xG,He:mC,Ie:OI,Je:rX,Ke:og,Le:cg,Me:ug,Ne:kG,Oe:ty,Pe:hF,Qe:Su,Re:LE,Se:NE,Te:wJ,Ue:BX,Ve:In,We:a2,Xe:Yg,Ye:BG,Ze:CR,_e:II,$e:iq,af:oY,bf:dV,cf:rE,df:iE,ef:nE,ff:$Q,gf:eE,hf:WZ,jf:fy,kf:dY,lf:Fp,mf:bY,nf:NH,of:uJ,pf:Dy,qf:_I,rf:a2,sf:$I,tf:zM,uf:_X,vf:_G,wf:pm,xf:Li,yf:p3,zf:a2,Af:ER,Bf:AY,Cf:lI,Df:sg,Ef:uh,Ff:sG,Gf:uh,Hf:GZ,If:lR,Jf:hK,Kf:sH,Lf:zG,Mf:BN,Nf:PE,Of:HC,Pf:Hh,Qf:Sj,Rf:Oj,Sf:Kh,Tf:$h,Uf:bE,Vf:gF,Wf:ZD,Xf:Hh,Yf:dR,Zf:bR,_f:oE,$f:dM,ag:V7,bg:ow,cg:JY,dg:yF,eg:zE,fg:Ot,gg:MU,hg:FV,ig:yU,jg:EU,kg:RU,lg:yD,mg:IF,ng:gQ,og:fI,pg:HI,qg:tE,rg:cs,sg:rg,tg:Bv,ug:sN,vg:xC,wg:eY,xg:LM,yg:Kh,zg:$h,Ag:XC,Bg:oz,Cg:AH,Dg:aj,Eg:Tg,Fg:Yj,Gg:CH,Hg:Ph,Ig:NM,Jg:DM,Kg:iy,Lg:HD,Mg:zD,Ng:ap,Og:VJ,Pg:$l,Qg:$W,Rg:r1,Sg:Qf,Tg:Qf,Ug:r1,Vg:Qf,Wg:p7,Xg:_Z,Yg:mR,Zg:WX,_g:mp,$g:rV,ah:sv,bh:aM,ch:dJ,dh:X9,eh:hC,fh:$X,gh:tQ,hh:Uv,ih:bv,jh:hv,kh:TJ,lh:NW,mh:lE,nh:uE,oh:sE,ph:hE,qh:ON,rh:fE,sh:pU,th:KV,uh:FE,vh:gE,wh:ZE,xh:ig,yh:Nl,zh:Nl,Ah:q3,Bh:q3,Ch:Pi,Dh:Pi,Eh:Y6,Fh:Y6,Gh:Tu,Hh:Tu,Ih:q3,Jh:q3,Kh:Pi,Lh:Pi,Mh:Y6,Nh:Y6,Oh:Pi,Ph:Pi,Qh:Y6,Rh:Y6,Sh:Y6,Th:Y6,Uh:Hu,Vh:Hu,Wh:wC,Xh:PJ,Yh:GE,Zh:a2,_h:tD,$h:hZ,ai:oi,bi:TM,ci:GY,di:VV,ei:Eh,fi:BY,gi:zI,hi:nX,ii:qh,ji:Fh,ki:qh,li:Fh,mi:vA,ni:kr,oi:wK,pi:us,qi:ys,ri:Zu,si:kU,ti:Gh,ui:fT,vi:au,wi:yL,xi:TL,yi:wM,zi:_M,Ai:SN,Bi:Pu,Ci:jH,Di:SH,Ei:OH,Fi:xH,Gi:Ws,Hi:DN,Ii:v8,Ji:mf,Ki:XM,Li:_N,Mi:KN,Ni:LU,Oi:bD,Pi:bN,Qi:nJ,Ri:PR}}return b1(K)})(H)},instantiate:function(J,H){return{then:function(P){var K=new wi.Module(J);P({instance:new wi.Instance(K,H)})}}},RuntimeError:Error,isWasm2js:!0};wi.isWasm2js&&(Vr=[]);var pr,zk=!1,R4,T4,a8,se,z2,w1,xk,Tk,Yw=!1,Nf=J=>J.startsWith("file://");function jk(){var J=pr.buffer;R4=new Int8Array(J),a8=new Int16Array(J),T4=new Uint8Array(J),se=new Uint16Array(J),z2=new Int32Array(J),w1=new Uint32Array(J),xk=new Float32Array(J),Tk=new Float64Array(J)}function yw(){if(L.preRun)for(typeof L.preRun=="function"&&(L.preRun=[L.preRun]);L.preRun.length;)zw(L.preRun.shift());Ok(Lk)}function Ew(){Yw=!0,!L.noFSInit&&!i0.initialized&&i0.init(),Z6.init(),$.Q(),i0.ignorePermissions=!1}function Rw(){if(L.postRun)for(typeof L.postRun=="function"&&(L.postRun=[L.postRun]);L.postRun.length;)Hw(L.postRun.shift());Ok(Pk)}var z6=0,he=null;function EK(J){return J}function Sk(J){var H;z6++,(H=L.monitorRunDependencies)==null||H.call(L,z6)}function Df(J){var P;if(z6--,(P=L.monitorRunDependencies)==null||P.call(L,z6),z6==0&&he){var H=he;he=null,H()}}function Fr(J){var P;(P=L.onAbort)==null||P.call(L,J),J="Aborted("+J+")",ue(J),zk=!0,J+=". Build with -sASSERTIONS for more info.";var H=new wi.RuntimeError(J);throw M6(H),H}var we;function Jw(){return Cw("libheif.wasm")}function Nw(J){if(J==we&&Vr)return new Uint8Array(Vr);if(le)return le(J);throw\'sync fetching of the wasm failed: you can preload it to Module["wasmBinary"] manually, or emcc.py will do that for you when generating HTML (but not JS)\'}function Dw(J,H){var P,K=Nw(J);P=new wi.Module(K);var e0=new wi.Instance(P,H);return[e0,P]}function Uw(){return{a:JB}}function Mw(){function J(K,e0){return $=K.exports,pr=$.P,jk(),t9=$.R,Df("wasm-instantiate"),$}Sk("wasm-instantiate");var H=Uw();if(L.instantiateWasm)return new Promise((K,e0)=>{L.instantiateWasm(H,(b,v0)=>{K(J(b,v0))})});we!=null||(we=Jw());var P=Dw(we,H);return J(P[0])}var l1,Z4;class RK{constructor(H){y8(this,"name","ExitStatus");this.message=`Program terminated with exit(${H})`,this.status=H}}var Ok=J=>{for(;J.length>0;)J.shift()(L)},Pk=[],Hw=J=>Pk.push(J),Lk=[],zw=J=>Lk.push(J),xw=!0,qk=typeof TextDecoder!="undefined"?new TextDecoder:void 0,_i=(J,H=0,P=NaN)=>{for(var K=H+P,e0=H;J[e0]&&!(e0>=K);)++e0;if(e0-H>16&&J.buffer&&qk)return qk.decode(J.subarray(H,e0));for(var b="";H<e0;){var v0=J[H++];if(!(v0&128)){b+=String.fromCharCode(v0);continue}var W0=J[H++]&63;if((v0&224)==192){b+=String.fromCharCode((v0&31)<<6|W0);continue}var m0=J[H++]&63;if((v0&240)==224?v0=(v0&15)<<12|W0<<6|m0:v0=(v0&7)<<18|W0<<12|m0<<6|J[H++]&63,v0<65536)b+=String.fromCharCode(v0);else{var d0=v0-65536;b+=String.fromCharCode(55296|d0>>10,56320|d0&1023)}}return b},_e=(J,H)=>J?_i(T4,J,H):"",Tw=(J,H,P,K)=>Fr(`Assertion failed: ${_e(J)}, at: `+[H?_e(H):"unknown filename",P,K?_e(K):"unknown function"]);class jw{constructor(H){this.excPtr=H,this.ptr=H-24}set_type(H){w1[this.ptr+4>>2]=H}get_type(){return w1[this.ptr+4>>2]}set_destructor(H){w1[this.ptr+8>>2]=H}get_destructor(){return w1[this.ptr+8>>2]}set_caught(H){H=H?1:0,R4[this.ptr+12]=H}get_caught(){return R4[this.ptr+12]!=0}set_rethrown(H){H=H?1:0,R4[this.ptr+13]=H}get_rethrown(){return R4[this.ptr+13]!=0}init(H,P){this.set_adjusted_ptr(0),this.set_type(H),this.set_destructor(P)}set_adjusted_ptr(H){w1[this.ptr+16>>2]=H}get_adjusted_ptr(){return w1[this.ptr+16>>2]}}var ak=0,Sw=0,Ow=(J,H,P)=>{var K=new jw(J);throw K.init(H,P),ak=J,Sw++,ak},Cr=()=>{var J=z2[+J4.varargs>>2];return J4.varargs+=4,J},Bi=Cr,U1={isAbs:J=>J.charAt(0)==="/",splitPath:J=>{var H=/^(\\/?|)([\\s\\S]*?)((?:\\.{1,2}|[^\\/]+?|)(\\.[^.\\/]*|))(?:[\\/]*)$/;return H.exec(J).slice(1)},normalizeArray:(J,H)=>{for(var P=0,K=J.length-1;K>=0;K--){var e0=J[K];e0==="."?J.splice(K,1):e0===".."?(J.splice(K,1),P++):P&&(J.splice(K,1),P--)}if(H)for(;P;P--)J.unshift("..");return J},normalize:J=>{var H=U1.isAbs(J),P=J.slice(-1)==="/";return J=U1.normalizeArray(J.split("/").filter(K=>!!K),!H).join("/"),!J&&!H&&(J="."),J&&P&&(J+="/"),(H?"/":"")+J},dirname:J=>{var H=U1.splitPath(J),P=H[0],K=H[1];return!P&&!K?".":(K&&(K=K.slice(0,-1)),P+K)},basename:J=>J&&J.match(/([^\\/]+|\\/)\\/*$/)[1],join:(...J)=>U1.normalize(J.join("/")),join2:(J,H)=>U1.normalize(J+"/"+H)},Pw=()=>{if(H6){var J=Uk("crypto");return H=>J.randomFillSync(H)}return H=>crypto.getRandomValues(H)},Kk=J=>{(Kk=Pw())(J)},vi={resolve:(...J)=>{for(var H="",P=!1,K=J.length-1;K>=-1&&!P;K--){var e0=K>=0?J[K]:i0.cwd();if(typeof e0!="string")throw new TypeError("Arguments to path.resolve must be strings");if(!e0)return"";H=e0+"/"+H,P=U1.isAbs(e0)}return H=U1.normalizeArray(H.split("/").filter(b=>!!b),!P).join("/"),(P?"/":"")+H||"."},relative:(J,H)=>{J=vi.resolve(J).slice(1),H=vi.resolve(H).slice(1);function P(d0){for(var b0=0;b0<d0.length&&d0[b0]==="";b0++);for(var I2=d0.length-1;I2>=0&&d0[I2]==="";I2--);return b0>I2?[]:d0.slice(b0,I2-b0+1)}for(var K=P(J.split("/")),e0=P(H.split("/")),b=Math.min(K.length,e0.length),v0=b,W0=0;W0<b;W0++)if(K[W0]!==e0[W0]){v0=W0;break}for(var m0=[],W0=v0;W0<K.length;W0++)m0.push("..");return m0=m0.concat(e0.slice(v0)),m0.join("/")}},Uf=[],Yr=J=>{for(var H=0,P=0;P<J.length;++P){var K=J.charCodeAt(P);K<=127?H++:K<=2047?H+=2:K>=55296&&K<=57343?(H+=4,++P):H+=3}return H},Mf=(J,H,P,K)=>{if(!(K>0))return 0;for(var e0=P,b=P+K-1,v0=0;v0<J.length;++v0){var W0=J.charCodeAt(v0);if(W0>=55296&&W0<=57343){var m0=J.charCodeAt(++v0);W0=65536+((W0&1023)<<10)|m0&1023}if(W0<=127){if(P>=b)break;H[P++]=W0}else if(W0<=2047){if(P+1>=b)break;H[P++]=192|W0>>6,H[P++]=128|W0&63}else if(W0<=65535){if(P+2>=b)break;H[P++]=224|W0>>12,H[P++]=128|W0>>6&63,H[P++]=128|W0&63}else{if(P+3>=b)break;H[P++]=240|W0>>18,H[P++]=128|W0>>12&63,H[P++]=128|W0>>6&63,H[P++]=128|W0&63}}return H[P]=0,P-e0},$k=(J,H,P)=>{var K=P>0?P:Yr(J)+1,e0=new Array(K),b=Mf(J,e0,0,e0.length);return H&&(e0.length=b),e0},Lw=()=>{if(!Uf.length){var J=null;if(H6){var H=256,P=Buffer.alloc(H),K=0,e0=process.stdin.fd;try{K=Jf.readSync(e0,P,0,H)}catch(b){if(b.toString().includes("EOF"))K=0;else throw b}K>0&&(J=P.slice(0,K).toString("utf-8"))}else typeof window!="undefined"&&typeof window.prompt=="function"&&(J=window.prompt("Input: "),J!==null&&(J+=`\n`));if(!J)return null;Uf=$k(J,!0)}return Uf.shift()},Z6={ttys:[],init(){},shutdown(){},register(J,H){Z6.ttys[J]={input:[],output:[],ops:H},i0.registerDevice(J,Z6.stream_ops)},stream_ops:{open(J){var H=Z6.ttys[J.node.rdev];if(!H)throw new i0.ErrnoError(43);J.tty=H,J.seekable=!1},close(J){J.tty.ops.fsync(J.tty)},fsync(J){J.tty.ops.fsync(J.tty)},read(J,H,P,K,e0){if(!J.tty||!J.tty.ops.get_char)throw new i0.ErrnoError(60);for(var b=0,v0=0;v0<K;v0++){var W0;try{W0=J.tty.ops.get_char(J.tty)}catch(m0){throw new i0.ErrnoError(29)}if(W0===void 0&&b===0)throw new i0.ErrnoError(6);if(W0==null)break;b++,H[P+v0]=W0}return b&&(J.node.atime=Date.now()),b},write(J,H,P,K,e0){if(!J.tty||!J.tty.ops.put_char)throw new i0.ErrnoError(60);try{for(var b=0;b<K;b++)J.tty.ops.put_char(J.tty,H[P+b])}catch(v0){throw new i0.ErrnoError(29)}return K&&(J.node.mtime=J.node.ctime=Date.now()),b}},default_tty_ops:{get_char(J){return Lw()},put_char(J,H){H===null||H===10?(Qr(_i(J.output)),J.output=[]):H!=0&&J.output.push(H)},fsync(J){var H;((H=J.output)==null?void 0:H.length)>0&&(Qr(_i(J.output)),J.output=[])},ioctl_tcgets(J){return{c_iflag:25856,c_oflag:5,c_cflag:191,c_lflag:35387,c_cc:[3,28,127,21,4,0,1,0,17,19,26,0,18,15,23,22,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}},ioctl_tcsets(J,H,P){return 0},ioctl_tiocgwinsz(J){return[24,80]}},default_tty1_ops:{put_char(J,H){H===null||H===10?(ue(_i(J.output)),J.output=[]):H!=0&&J.output.push(H)},fsync(J){var H;((H=J.output)==null?void 0:H.length)>0&&(ue(_i(J.output)),J.output=[])}}},dk=J=>{Fr()},x2={ops_table:null,mount(J){return x2.createNode(null,"/",16895,0)},createNode(J,H,P,K){if(i0.isBlkdev(P)||i0.isFIFO(P))throw new i0.ErrnoError(63);x2.ops_table||(x2.ops_table={dir:{node:{getattr:x2.node_ops.getattr,setattr:x2.node_ops.setattr,lookup:x2.node_ops.lookup,mknod:x2.node_ops.mknod,rename:x2.node_ops.rename,unlink:x2.node_ops.unlink,rmdir:x2.node_ops.rmdir,readdir:x2.node_ops.readdir,symlink:x2.node_ops.symlink},stream:{llseek:x2.stream_ops.llseek}},file:{node:{getattr:x2.node_ops.getattr,setattr:x2.node_ops.setattr},stream:{llseek:x2.stream_ops.llseek,read:x2.stream_ops.read,write:x2.stream_ops.write,mmap:x2.stream_ops.mmap,msync:x2.stream_ops.msync}},link:{node:{getattr:x2.node_ops.getattr,setattr:x2.node_ops.setattr,readlink:x2.node_ops.readlink},stream:{}},chrdev:{node:{getattr:x2.node_ops.getattr,setattr:x2.node_ops.setattr},stream:i0.chrdev_stream_ops}});var e0=i0.createNode(J,H,P,K);return i0.isDir(e0.mode)?(e0.node_ops=x2.ops_table.dir.node,e0.stream_ops=x2.ops_table.dir.stream,e0.contents={}):i0.isFile(e0.mode)?(e0.node_ops=x2.ops_table.file.node,e0.stream_ops=x2.ops_table.file.stream,e0.usedBytes=0,e0.contents=null):i0.isLink(e0.mode)?(e0.node_ops=x2.ops_table.link.node,e0.stream_ops=x2.ops_table.link.stream):i0.isChrdev(e0.mode)&&(e0.node_ops=x2.ops_table.chrdev.node,e0.stream_ops=x2.ops_table.chrdev.stream),e0.atime=e0.mtime=e0.ctime=Date.now(),J&&(J.contents[H]=e0,J.atime=J.mtime=J.ctime=e0.atime),e0},getFileDataAsTypedArray(J){return J.contents?J.contents.subarray?J.contents.subarray(0,J.usedBytes):new Uint8Array(J.contents):new Uint8Array(0)},expandFileStorage(J,H){var P=J.contents?J.contents.length:0;if(!(P>=H)){var K=1024*1024;H=Math.max(H,P*(P<K?2:1.125)>>>0),P!=0&&(H=Math.max(H,256));var e0=J.contents;J.contents=new Uint8Array(H),J.usedBytes>0&&J.contents.set(e0.subarray(0,J.usedBytes),0)}},resizeFileStorage(J,H){if(J.usedBytes!=H)if(H==0)J.contents=null,J.usedBytes=0;else{var P=J.contents;J.contents=new Uint8Array(H),P&&J.contents.set(P.subarray(0,Math.min(H,J.usedBytes))),J.usedBytes=H}},node_ops:{getattr(J){var H={};return H.dev=i0.isChrdev(J.mode)?J.id:1,H.ino=J.id,H.mode=J.mode,H.nlink=1,H.uid=0,H.gid=0,H.rdev=J.rdev,i0.isDir(J.mode)?H.size=4096:i0.isFile(J.mode)?H.size=J.usedBytes:i0.isLink(J.mode)?H.size=J.link.length:H.size=0,H.atime=new Date(J.atime),H.mtime=new Date(J.mtime),H.ctime=new Date(J.ctime),H.blksize=4096,H.blocks=Math.ceil(H.size/H.blksize),H},setattr(J,H){for(let P of["mode","atime","mtime","ctime"])H[P]!=null&&(J[P]=H[P]);H.size!==void 0&&x2.resizeFileStorage(J,H.size)},lookup(J,H){throw x2.doesNotExistError},mknod(J,H,P,K){return x2.createNode(J,H,P,K)},rename(J,H,P){var K;try{K=i0.lookupNode(H,P)}catch(b){}if(K){if(i0.isDir(J.mode))for(var e0 in K.contents)throw new i0.ErrnoError(55);i0.hashRemoveNode(K)}delete J.parent.contents[J.name],H.contents[P]=J,J.name=P,H.ctime=H.mtime=J.parent.ctime=J.parent.mtime=Date.now()},unlink(J,H){delete J.contents[H],J.ctime=J.mtime=Date.now()},rmdir(J,H){var P=i0.lookupNode(J,H);for(var K in P.contents)throw new i0.ErrnoError(55);delete J.contents[H],J.ctime=J.mtime=Date.now()},readdir(J){return[".","..",...Object.keys(J.contents)]},symlink(J,H,P){var K=x2.createNode(J,H,41471,0);return K.link=P,K},readlink(J){if(!i0.isLink(J.mode))throw new i0.ErrnoError(28);return J.link}},stream_ops:{read(J,H,P,K,e0){var b=J.node.contents;if(e0>=J.node.usedBytes)return 0;var v0=Math.min(J.node.usedBytes-e0,K);if(v0>8&&b.subarray)H.set(b.subarray(e0,e0+v0),P);else for(var W0=0;W0<v0;W0++)H[P+W0]=b[e0+W0];return v0},write(J,H,P,K,e0,b){if(H.buffer===R4.buffer&&(b=!1),!K)return 0;var v0=J.node;if(v0.mtime=v0.ctime=Date.now(),H.subarray&&(!v0.contents||v0.contents.subarray)){if(b)return v0.contents=H.subarray(P,P+K),v0.usedBytes=K,K;if(v0.usedBytes===0&&e0===0)return v0.contents=H.slice(P,P+K),v0.usedBytes=K,K;if(e0+K<=v0.usedBytes)return v0.contents.set(H.subarray(P,P+K),e0),K}if(x2.expandFileStorage(v0,e0+K),v0.contents.subarray&&H.subarray)v0.contents.set(H.subarray(P,P+K),e0);else for(var W0=0;W0<K;W0++)v0.contents[e0+W0]=H[P+W0];return v0.usedBytes=Math.max(v0.usedBytes,e0+K),K},llseek(J,H,P){var K=H;if(P===1?K+=J.position:P===2&&i0.isFile(J.node.mode)&&(K+=J.node.usedBytes),K<0)throw new i0.ErrnoError(28);return K},mmap(J,H,P,K,e0){if(!i0.isFile(J.node.mode))throw new i0.ErrnoError(43);var b,v0,W0=J.node.contents;if(!(e0&2)&&W0&&W0.buffer===R4.buffer)v0=!1,b=W0.byteOffset;else{if(v0=!0,b=dk(H),!b)throw new i0.ErrnoError(48);W0&&((P>0||P+H<W0.length)&&(W0.subarray?W0=W0.subarray(P,P+H):W0=Array.prototype.slice.call(W0,P,P+H)),R4.set(W0,b))}return{ptr:b,allocated:v0}},msync(J,H,P,K,e0){return x2.stream_ops.write(J,H,0,K,P,!1),0}}},qw=J=>D6(null,null,function*(){var H=yield Rf(J);return new Uint8Array(H)}),aw=(...J)=>i0.createDataFile(...J),bk=[],Kw=(J,H,P,K)=>{typeof Browser!="undefined"&&Browser.init();var e0=!1;return bk.forEach(b=>{e0||b.canHandle(H)&&(b.handle(J,H,P,K),e0=!0)}),e0},$w=(J,H,P,K,e0,b,v0,W0,m0,d0)=>{var b0=H?vi.resolve(U1.join2(J,H)):J,I2=`cp ${b0}`;function Y2(G2){function o2(T2){d0==null||d0(),W0||aw(J,H,T2,K,e0,m0),b==null||b(),Df(I2)}Kw(G2,b0,o2,()=>{v0==null||v0(),Df(I2)})||o2(G2)}Sk(I2),typeof P=="string"?qw(P).then(Y2,v0):Y2(P)},dw=J=>{var H={r:0,"r+":2,w:577,"w+":578,a:1089,"a+":1090},P=H[J];if(typeof P=="undefined")throw new Error(`Unknown file open mode: ${J}`);return P},Hf=(J,H)=>{var P=0;return J&&(P|=365),H&&(P|=146),P},i0={root:null,mounts:[],devices:{},streams:[],nextInode:1,nameTable:null,currentPath:"/",initialized:!1,ignorePermissions:!0,filesystems:null,syncFSRequests:0,readFiles:{},ErrnoError:class{constructor(J){y8(this,"name","ErrnoError");this.errno=J}},FSStream:class{constructor(){y8(this,"shared",{})}get object(){return this.node}set object(J){this.node=J}get isRead(){return(this.flags&2097155)!==1}get isWrite(){return(this.flags&2097155)!==0}get isAppend(){return this.flags&1024}get flags(){return this.shared.flags}set flags(J){this.shared.flags=J}get position(){return this.shared.position}set position(J){this.shared.position=J}},FSNode:class{constructor(J,H,P,K){y8(this,"node_ops",{});y8(this,"stream_ops",{});y8(this,"readMode",365);y8(this,"writeMode",146);y8(this,"mounted",null);J||(J=this),this.parent=J,this.mount=J.mount,this.id=i0.nextInode++,this.name=H,this.mode=P,this.rdev=K,this.atime=this.mtime=this.ctime=Date.now()}get read(){return(this.mode&this.readMode)===this.readMode}set read(J){J?this.mode|=this.readMode:this.mode&=~this.readMode}get write(){return(this.mode&this.writeMode)===this.writeMode}set write(J){J?this.mode|=this.writeMode:this.mode&=~this.writeMode}get isFolder(){return i0.isDir(this.mode)}get isDevice(){return i0.isChrdev(this.mode)}},lookupPath(J,H={}){var d0;if(!J)throw new i0.ErrnoError(44);(d0=H.follow_mount)!=null||(H.follow_mount=!0),U1.isAbs(J)||(J=i0.cwd()+"/"+J);i:for(var P=0;P<40;P++){for(var K=J.split("/").filter(b0=>!!b0),e0=i0.root,b="/",v0=0;v0<K.length;v0++){var W0=v0===K.length-1;if(W0&&H.parent)break;if(K[v0]!=="."){if(K[v0]===".."){if(b=U1.dirname(b),i0.isRoot(e0)){J=b+"/"+K.slice(v0+1).join("/");continue i}else e0=e0.parent;continue}b=U1.join2(b,K[v0]);try{e0=i0.lookupNode(e0,K[v0])}catch(b0){if((b0==null?void 0:b0.errno)===44&&W0&&H.noent_okay)return{path:b};throw b0}if(i0.isMountpoint(e0)&&(!W0||H.follow_mount)&&(e0=e0.mounted.root),i0.isLink(e0.mode)&&(!W0||H.follow)){if(!e0.node_ops.readlink)throw new i0.ErrnoError(52);var m0=e0.node_ops.readlink(e0);U1.isAbs(m0)||(m0=U1.dirname(b)+"/"+m0),J=m0+"/"+K.slice(v0+1).join("/");continue i}}}return{path:b,node:e0}}throw new i0.ErrnoError(32)},getPath(J){for(var H;;){if(i0.isRoot(J)){var P=J.mount.mountpoint;return H?P[P.length-1]!=="/"?`${P}/${H}`:P+H:P}H=H?`${J.name}/${H}`:J.name,J=J.parent}},hashName(J,H){for(var P=0,K=0;K<H.length;K++)P=(P<<5)-P+H.charCodeAt(K)|0;return(J+P>>>0)%i0.nameTable.length},hashAddNode(J){var H=i0.hashName(J.parent.id,J.name);J.name_next=i0.nameTable[H],i0.nameTable[H]=J},hashRemoveNode(J){var H=i0.hashName(J.parent.id,J.name);if(i0.nameTable[H]===J)i0.nameTable[H]=J.name_next;else for(var P=i0.nameTable[H];P;){if(P.name_next===J){P.name_next=J.name_next;break}P=P.name_next}},lookupNode(J,H){var P=i0.mayLookup(J);if(P)throw new i0.ErrnoError(P);for(var K=i0.hashName(J.id,H),e0=i0.nameTable[K];e0;e0=e0.name_next){var b=e0.name;if(e0.parent.id===J.id&&b===H)return e0}return i0.lookup(J,H)},createNode(J,H,P,K){var e0=new i0.FSNode(J,H,P,K);return i0.hashAddNode(e0),e0},destroyNode(J){i0.hashRemoveNode(J)},isRoot(J){return J===J.parent},isMountpoint(J){return!!J.mounted},isFile(J){return(J&61440)===32768},isDir(J){return(J&61440)===16384},isLink(J){return(J&61440)===40960},isChrdev(J){return(J&61440)===8192},isBlkdev(J){return(J&61440)===24576},isFIFO(J){return(J&61440)===4096},isSocket(J){return(J&49152)===49152},flagsToPermissionString(J){var H=["r","w","rw"][J&3];return J&512&&(H+="w"),H},nodePermissions(J,H){return i0.ignorePermissions?0:H.includes("r")&&!(J.mode&292)||H.includes("w")&&!(J.mode&146)||H.includes("x")&&!(J.mode&73)?2:0},mayLookup(J){if(!i0.isDir(J.mode))return 54;var H=i0.nodePermissions(J,"x");return H||(J.node_ops.lookup?0:2)},mayCreate(J,H){if(!i0.isDir(J.mode))return 54;try{var P=i0.lookupNode(J,H);return 20}catch(K){}return i0.nodePermissions(J,"wx")},mayDelete(J,H,P){var K;try{K=i0.lookupNode(J,H)}catch(b){return b.errno}var e0=i0.nodePermissions(J,"wx");if(e0)return e0;if(P){if(!i0.isDir(K.mode))return 54;if(i0.isRoot(K)||i0.getPath(K)===i0.cwd())return 10}else if(i0.isDir(K.mode))return 31;return 0},mayOpen(J,H){return J?i0.isLink(J.mode)?32:i0.isDir(J.mode)&&(i0.flagsToPermissionString(H)!=="r"||H&576)?31:i0.nodePermissions(J,i0.flagsToPermissionString(H)):44},checkOpExists(J,H){if(!J)throw new i0.ErrnoError(H);return J},MAX_OPEN_FDS:4096,nextfd(){for(var J=0;J<=i0.MAX_OPEN_FDS;J++)if(!i0.streams[J])return J;throw new i0.ErrnoError(33)},getStreamChecked(J){var H=i0.getStream(J);if(!H)throw new i0.ErrnoError(8);return H},getStream:J=>i0.streams[J],createStream(J,H=-1){return J=Object.assign(new i0.FSStream,J),H==-1&&(H=i0.nextfd()),J.fd=H,i0.streams[H]=J,J},closeStream(J){i0.streams[J]=null},dupStream(J,H=-1){var K,e0;var P=i0.createStream(J,H);return(e0=(K=P.stream_ops)==null?void 0:K.dup)==null||e0.call(K,P),P},doSetAttr(J,H,P){var K=J==null?void 0:J.stream_ops.setattr,e0=K?J:H;K!=null||(K=H.node_ops.setattr),i0.checkOpExists(K,63),K(e0,P)},chrdev_stream_ops:{open(J){var P,K;var H=i0.getDevice(J.node.rdev);J.stream_ops=H.stream_ops,(K=(P=J.stream_ops).open)==null||K.call(P,J)},llseek(){throw new i0.ErrnoError(70)}},major:J=>J>>8,minor:J=>J&255,makedev:(J,H)=>J<<8|H,registerDevice(J,H){i0.devices[J]={stream_ops:H}},getDevice:J=>i0.devices[J],getMounts(J){for(var H=[],P=[J];P.length;){var K=P.pop();H.push(K),P.push(...K.mounts)}return H},syncfs(J,H){typeof J=="function"&&(H=J,J=!1),i0.syncFSRequests++,i0.syncFSRequests>1&&ue(`warning: ${i0.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);var P=i0.getMounts(i0.root.mount),K=0;function e0(v0){return i0.syncFSRequests--,H(v0)}function b(v0){if(v0)return b.errored?void 0:(b.errored=!0,e0(v0));++K>=P.length&&e0(null)}P.forEach(v0=>{if(!v0.type.syncfs)return b(null);v0.type.syncfs(v0,J,b)})},mount(J,H,P){var K=P==="/",e0=!P,b;if(K&&i0.root)throw new i0.ErrnoError(10);if(!K&&!e0){var v0=i0.lookupPath(P,{follow_mount:!1});if(P=v0.path,b=v0.node,i0.isMountpoint(b))throw new i0.ErrnoError(10);if(!i0.isDir(b.mode))throw new i0.ErrnoError(54)}var W0={type:J,opts:H,mountpoint:P,mounts:[]},m0=J.mount(W0);return m0.mount=W0,W0.root=m0,K?i0.root=m0:b&&(b.mounted=W0,b.mount&&b.mount.mounts.push(W0)),m0},unmount(J){var H=i0.lookupPath(J,{follow_mount:!1});if(!i0.isMountpoint(H.node))throw new i0.ErrnoError(28);var P=H.node,K=P.mounted,e0=i0.getMounts(K);Object.keys(i0.nameTable).forEach(v0=>{for(var W0=i0.nameTable[v0];W0;){var m0=W0.name_next;e0.includes(W0.mount)&&i0.destroyNode(W0),W0=m0}}),P.mounted=null;var b=P.mount.mounts.indexOf(K);P.mount.mounts.splice(b,1)},lookup(J,H){return J.node_ops.lookup(J,H)},mknod(J,H,P){var K=i0.lookupPath(J,{parent:!0}),e0=K.node,b=U1.basename(J);if(!b)throw new i0.ErrnoError(28);if(b==="."||b==="..")throw new i0.ErrnoError(20);var v0=i0.mayCreate(e0,b);if(v0)throw new i0.ErrnoError(v0);if(!e0.node_ops.mknod)throw new i0.ErrnoError(63);return e0.node_ops.mknod(e0,b,H,P)},statfs(J){return i0.statfsNode(i0.lookupPath(J,{follow:!0}).node)},statfsStream(J){return i0.statfsNode(J.node)},statfsNode(J){var H={bsize:4096,frsize:4096,blocks:1e6,bfree:5e5,bavail:5e5,files:i0.nextInode,ffree:i0.nextInode-1,fsid:42,flags:2,namelen:255};return J.node_ops.statfs&&Object.assign(H,J.node_ops.statfs(J.mount.opts.root)),H},create(J,H=438){return H&=4095,H|=32768,i0.mknod(J,H,0)},mkdir(J,H=511){return H&=1023,H|=16384,i0.mknod(J,H,0)},mkdirTree(J,H){var P=J.split("/"),K="";for(var e0 of P)if(e0){(K||U1.isAbs(J))&&(K+="/"),K+=e0;try{i0.mkdir(K,H)}catch(b){if(b.errno!=20)throw b}}},mkdev(J,H,P){return typeof P=="undefined"&&(P=H,H=438),H|=8192,i0.mknod(J,H,P)},symlink(J,H){if(!vi.resolve(J))throw new i0.ErrnoError(44);var P=i0.lookupPath(H,{parent:!0}),K=P.node;if(!K)throw new i0.ErrnoError(44);var e0=U1.basename(H),b=i0.mayCreate(K,e0);if(b)throw new i0.ErrnoError(b);if(!K.node_ops.symlink)throw new i0.ErrnoError(63);return K.node_ops.symlink(K,e0,J)},rename(J,H){var P=U1.dirname(J),K=U1.dirname(H),e0=U1.basename(J),b=U1.basename(H),v0,W0,m0;if(v0=i0.lookupPath(J,{parent:!0}),W0=v0.node,v0=i0.lookupPath(H,{parent:!0}),m0=v0.node,!W0||!m0)throw new i0.ErrnoError(44);if(W0.mount!==m0.mount)throw new i0.ErrnoError(75);var d0=i0.lookupNode(W0,e0),b0=vi.relative(J,K);if(b0.charAt(0)!==".")throw new i0.ErrnoError(28);if(b0=vi.relative(H,P),b0.charAt(0)!==".")throw new i0.ErrnoError(55);var I2;try{I2=i0.lookupNode(m0,b)}catch(o2){}if(d0!==I2){var Y2=i0.isDir(d0.mode),G2=i0.mayDelete(W0,e0,Y2);if(G2)throw new i0.ErrnoError(G2);if(G2=I2?i0.mayDelete(m0,b,Y2):i0.mayCreate(m0,b),G2)throw new i0.ErrnoError(G2);if(!W0.node_ops.rename)throw new i0.ErrnoError(63);if(i0.isMountpoint(d0)||I2&&i0.isMountpoint(I2))throw new i0.ErrnoError(10);if(m0!==W0&&(G2=i0.nodePermissions(W0,"w"),G2))throw new i0.ErrnoError(G2);i0.hashRemoveNode(d0);try{W0.node_ops.rename(d0,m0,b),d0.parent=m0}catch(o2){throw o2}finally{i0.hashAddNode(d0)}}},rmdir(J){var H=i0.lookupPath(J,{parent:!0}),P=H.node,K=U1.basename(J),e0=i0.lookupNode(P,K),b=i0.mayDelete(P,K,!0);if(b)throw new i0.ErrnoError(b);if(!P.node_ops.rmdir)throw new i0.ErrnoError(63);if(i0.isMountpoint(e0))throw new i0.ErrnoError(10);P.node_ops.rmdir(P,K),i0.destroyNode(e0)},readdir(J){var H=i0.lookupPath(J,{follow:!0}),P=H.node,K=i0.checkOpExists(P.node_ops.readdir,54);return K(P)},unlink(J){var H=i0.lookupPath(J,{parent:!0}),P=H.node;if(!P)throw new i0.ErrnoError(44);var K=U1.basename(J),e0=i0.lookupNode(P,K),b=i0.mayDelete(P,K,!1);if(b)throw new i0.ErrnoError(b);if(!P.node_ops.unlink)throw new i0.ErrnoError(63);if(i0.isMountpoint(e0))throw new i0.ErrnoError(10);P.node_ops.unlink(P,K),i0.destroyNode(e0)},readlink(J){var H=i0.lookupPath(J),P=H.node;if(!P)throw new i0.ErrnoError(44);if(!P.node_ops.readlink)throw new i0.ErrnoError(28);return P.node_ops.readlink(P)},stat(J,H){var P=i0.lookupPath(J,{follow:!H}),K=P.node,e0=i0.checkOpExists(K.node_ops.getattr,63);return e0(K)},fstat(J){var H=i0.getStreamChecked(J),P=H.node,K=H.stream_ops.getattr,e0=K?H:P;return K!=null||(K=P.node_ops.getattr),i0.checkOpExists(K,63),K(e0)},lstat(J){return i0.stat(J,!0)},doChmod(J,H,P,K){i0.doSetAttr(J,H,{mode:P&4095|H.mode&-4096,ctime:Date.now(),dontFollow:K})},chmod(J,H,P){var K;if(typeof J=="string"){var e0=i0.lookupPath(J,{follow:!P});K=e0.node}else K=J;i0.doChmod(null,K,H,P)},lchmod(J,H){i0.chmod(J,H,!0)},fchmod(J,H){var P=i0.getStreamChecked(J);i0.doChmod(P,P.node,H,!1)},doChown(J,H,P){i0.doSetAttr(J,H,{timestamp:Date.now(),dontFollow:P})},chown(J,H,P,K){var e0;if(typeof J=="string"){var b=i0.lookupPath(J,{follow:!K});e0=b.node}else e0=J;i0.doChown(null,e0,K)},lchown(J,H,P){i0.chown(J,H,P,!0)},fchown(J,H,P){var K=i0.getStreamChecked(J);i0.doChown(K,K.node,!1)},doTruncate(J,H,P){if(i0.isDir(H.mode))throw new i0.ErrnoError(31);if(!i0.isFile(H.mode))throw new i0.ErrnoError(28);var K=i0.nodePermissions(H,"w");if(K)throw new i0.ErrnoError(K);i0.doSetAttr(J,H,{size:P,timestamp:Date.now()})},truncate(J,H){if(H<0)throw new i0.ErrnoError(28);var P;if(typeof J=="string"){var K=i0.lookupPath(J,{follow:!0});P=K.node}else P=J;i0.doTruncate(null,P,H)},ftruncate(J,H){var P=i0.getStreamChecked(J);if(H<0||(P.flags&2097155)===0)throw new i0.ErrnoError(28);i0.doTruncate(P,P.node,H)},utime(J,H,P){var K=i0.lookupPath(J,{follow:!0}),e0=K.node,b=i0.checkOpExists(e0.node_ops.setattr,63);b(e0,{atime:H,mtime:P})},open(J,H,P=438){if(J==="")throw new i0.ErrnoError(44);H=typeof H=="string"?dw(H):H,H&64?P=P&4095|32768:P=0;var K,e0;if(typeof J=="object")K=J;else{e0=J.endsWith("/");var b=i0.lookupPath(J,{follow:!(H&131072),noent_okay:!0});K=b.node,J=b.path}var v0=!1;if(H&64)if(K){if(H&128)throw new i0.ErrnoError(20)}else{if(e0)throw new i0.ErrnoError(31);K=i0.mknod(J,P|511,0),v0=!0}if(!K)throw new i0.ErrnoError(44);if(i0.isChrdev(K.mode)&&(H&=-513),H&65536&&!i0.isDir(K.mode))throw new i0.ErrnoError(54);if(!v0){var W0=i0.mayOpen(K,H);if(W0)throw new i0.ErrnoError(W0)}H&512&&!v0&&i0.truncate(K,0),H&=-131713;var m0=i0.createStream({node:K,path:i0.getPath(K),flags:H,seekable:!0,position:0,stream_ops:K.stream_ops,ungotten:[],error:!1});return m0.stream_ops.open&&m0.stream_ops.open(m0),v0&&i0.chmod(K,P&511),L.logReadFiles&&!(H&1)&&(J in i0.readFiles||(i0.readFiles[J]=1)),m0},close(J){if(i0.isClosed(J))throw new i0.ErrnoError(8);J.getdents&&(J.getdents=null);try{J.stream_ops.close&&J.stream_ops.close(J)}catch(H){throw H}finally{i0.closeStream(J.fd)}J.fd=null},isClosed(J){return J.fd===null},llseek(J,H,P){if(i0.isClosed(J))throw new i0.ErrnoError(8);if(!J.seekable||!J.stream_ops.llseek)throw new i0.ErrnoError(70);if(P!=0&&P!=1&&P!=2)throw new i0.ErrnoError(28);return J.position=J.stream_ops.llseek(J,H,P),J.ungotten=[],J.position},read(J,H,P,K,e0){if(K<0||e0<0)throw new i0.ErrnoError(28);if(i0.isClosed(J))throw new i0.ErrnoError(8);if((J.flags&2097155)===1)throw new i0.ErrnoError(8);if(i0.isDir(J.node.mode))throw new i0.ErrnoError(31);if(!J.stream_ops.read)throw new i0.ErrnoError(28);var b=typeof e0!="undefined";if(!b)e0=J.position;else if(!J.seekable)throw new i0.ErrnoError(70);var v0=J.stream_ops.read(J,H,P,K,e0);return b||(J.position+=v0),v0},write(J,H,P,K,e0,b){if(K<0||e0<0)throw new i0.ErrnoError(28);if(i0.isClosed(J))throw new i0.ErrnoError(8);if((J.flags&2097155)===0)throw new i0.ErrnoError(8);if(i0.isDir(J.node.mode))throw new i0.ErrnoError(31);if(!J.stream_ops.write)throw new i0.ErrnoError(28);J.seekable&&J.flags&1024&&i0.llseek(J,0,2);var v0=typeof e0!="undefined";if(!v0)e0=J.position;else if(!J.seekable)throw new i0.ErrnoError(70);var W0=J.stream_ops.write(J,H,P,K,e0,b);return v0||(J.position+=W0),W0},mmap(J,H,P,K,e0){if((K&2)!==0&&(e0&2)===0&&(J.flags&2097155)!==2)throw new i0.ErrnoError(2);if((J.flags&2097155)===1)throw new i0.ErrnoError(2);if(!J.stream_ops.mmap)throw new i0.ErrnoError(43);if(!H)throw new i0.ErrnoError(28);return J.stream_ops.mmap(J,H,P,K,e0)},msync(J,H,P,K,e0){return J.stream_ops.msync?J.stream_ops.msync(J,H,P,K,e0):0},ioctl(J,H,P){if(!J.stream_ops.ioctl)throw new i0.ErrnoError(59);return J.stream_ops.ioctl(J,H,P)},readFile(J,H={}){if(H.flags=H.flags||0,H.encoding=H.encoding||"binary",H.encoding!=="utf8"&&H.encoding!=="binary")throw new Error(`Invalid encoding type "${H.encoding}"`);var P,K=i0.open(J,H.flags),e0=i0.stat(J),b=e0.size,v0=new Uint8Array(b);return i0.read(K,v0,0,b,0),H.encoding==="utf8"?P=_i(v0):H.encoding==="binary"&&(P=v0),i0.close(K),P},writeFile(J,H,P={}){P.flags=P.flags||577;var K=i0.open(J,P.flags,P.mode);if(typeof H=="string"){var e0=new Uint8Array(Yr(H)+1),b=Mf(H,e0,0,e0.length);i0.write(K,e0,0,b,void 0,P.canOwn)}else if(ArrayBuffer.isView(H))i0.write(K,H,0,H.byteLength,void 0,P.canOwn);else throw new Error("Unsupported data type");i0.close(K)},cwd:()=>i0.currentPath,chdir(J){var H=i0.lookupPath(J,{follow:!0});if(H.node===null)throw new i0.ErrnoError(44);if(!i0.isDir(H.node.mode))throw new i0.ErrnoError(54);var P=i0.nodePermissions(H.node,"x");if(P)throw new i0.ErrnoError(P);i0.currentPath=H.path},createDefaultDirectories(){i0.mkdir("/tmp"),i0.mkdir("/home"),i0.mkdir("/home/web_user")},createDefaultDevices(){i0.mkdir("/dev"),i0.registerDevice(i0.makedev(1,3),{read:()=>0,write:(K,e0,b,v0,W0)=>v0,llseek:()=>0}),i0.mkdev("/dev/null",i0.makedev(1,3)),Z6.register(i0.makedev(5,0),Z6.default_tty_ops),Z6.register(i0.makedev(6,0),Z6.default_tty1_ops),i0.mkdev("/dev/tty",i0.makedev(5,0)),i0.mkdev("/dev/tty1",i0.makedev(6,0));var J=new Uint8Array(1024),H=0,P=()=>(H===0&&(Kk(J),H=J.byteLength),J[--H]);i0.createDevice("/dev","random",P),i0.createDevice("/dev","urandom",P),i0.mkdir("/dev/shm"),i0.mkdir("/dev/shm/tmp")},createSpecialDirectories(){i0.mkdir("/proc");var J=i0.mkdir("/proc/self");i0.mkdir("/proc/self/fd"),i0.mount({mount(){var H=i0.createNode(J,"fd",16895,73);return H.stream_ops={llseek:x2.stream_ops.llseek},H.node_ops={lookup(P,K){var e0=+K,b=i0.getStreamChecked(e0),v0={parent:null,mount:{mountpoint:"fake"},node_ops:{readlink:()=>b.path},id:e0+1};return v0.parent=v0,v0},readdir(){return Array.from(i0.streams.entries()).filter(([P,K])=>K).map(([P,K])=>P.toString())}},H}},{},"/proc/self/fd")},createStandardStreams(J,H,P){J?i0.createDevice("/dev","stdin",J):i0.symlink("/dev/tty","/dev/stdin"),H?i0.createDevice("/dev","stdout",null,H):i0.symlink("/dev/tty","/dev/stdout"),P?i0.createDevice("/dev","stderr",null,P):i0.symlink("/dev/tty1","/dev/stderr");var K=i0.open("/dev/stdin",0),e0=i0.open("/dev/stdout",1),b=i0.open("/dev/stderr",1)},staticInit(){i0.nameTable=new Array(4096),i0.mount(x2,{},"/"),i0.createDefaultDirectories(),i0.createDefaultDevices(),i0.createSpecialDirectories(),i0.filesystems={MEMFS:x2}},init(J,H,P){i0.initialized=!0,J!=null||(J=L.stdin),H!=null||(H=L.stdout),P!=null||(P=L.stderr),i0.createStandardStreams(J,H,P)},quit(){i0.initialized=!1;for(var J of i0.streams)J&&i0.close(J)},findObject(J,H){var P=i0.analyzePath(J,H);return P.exists?P.object:null},analyzePath(J,H){try{var P=i0.lookupPath(J,{follow:!H});J=P.path}catch(e0){}var K={isRoot:!1,exists:!1,error:0,name:null,path:null,object:null,parentExists:!1,parentPath:null,parentObject:null};try{var P=i0.lookupPath(J,{parent:!0});K.parentExists=!0,K.parentPath=P.path,K.parentObject=P.node,K.name=U1.basename(J),P=i0.lookupPath(J,{follow:!H}),K.exists=!0,K.path=P.path,K.object=P.node,K.name=P.node.name,K.isRoot=P.path==="/"}catch(e0){K.error=e0.errno}return K},createPath(J,H,P,K){J=typeof J=="string"?J:i0.getPath(J);for(var e0=H.split("/").reverse();e0.length;){var b=e0.pop();if(b){var v0=U1.join2(J,b);try{i0.mkdir(v0)}catch(W0){if(W0.errno!=20)throw W0}J=v0}}return v0},createFile(J,H,P,K,e0){var b=U1.join2(typeof J=="string"?J:i0.getPath(J),H),v0=Hf(K,e0);return i0.create(b,v0)},createDataFile(J,H,P,K,e0,b){var v0=H;J&&(J=typeof J=="string"?J:i0.getPath(J),v0=H?U1.join2(J,H):J);var W0=Hf(K,e0),m0=i0.create(v0,W0);if(P){if(typeof P=="string"){for(var d0=new Array(P.length),b0=0,I2=P.length;b0<I2;++b0)d0[b0]=P.charCodeAt(b0);P=d0}i0.chmod(m0,W0|146);var Y2=i0.open(m0,577);i0.write(Y2,P,0,P.length,0,b),i0.close(Y2),i0.chmod(m0,W0)}},createDevice(J,H,P,K){var W0,m0;var e0=U1.join2(typeof J=="string"?J:i0.getPath(J),H),b=Hf(!!P,!!K);(m0=(W0=i0.createDevice).major)!=null||(W0.major=64);var v0=i0.makedev(i0.createDevice.major++,0);return i0.registerDevice(v0,{open(d0){d0.seekable=!1},close(d0){var b0;(b0=K==null?void 0:K.buffer)!=null&&b0.length&&K(10)},read(d0,b0,I2,Y2,G2){for(var o2=0,T2=0;T2<Y2;T2++){var s1;try{s1=P()}catch(j2){throw new i0.ErrnoError(29)}if(s1===void 0&&o2===0)throw new i0.ErrnoError(6);if(s1==null)break;o2++,b0[I2+T2]=s1}return o2&&(d0.node.atime=Date.now()),o2},write(d0,b0,I2,Y2,G2){for(var o2=0;o2<Y2;o2++)try{K(b0[I2+o2])}catch(T2){throw new i0.ErrnoError(29)}return Y2&&(d0.node.mtime=d0.node.ctime=Date.now()),o2}}),i0.mkdev(e0,b,v0)},forceLoadFile(J){if(J.isDevice||J.isFolder||J.link||J.contents)return!0;if(typeof XMLHttpRequest!="undefined")throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");try{J.contents=le(J.url),J.usedBytes=J.contents.length}catch(H){throw new i0.ErrnoError(29)}},createLazyFile(J,H,P,K,e0){class b{constructor(){y8(this,"lengthKnown",!1);y8(this,"chunks",[])}get(G2){if(!(G2>this.length-1||G2<0)){var o2=G2%this.chunkSize,T2=G2/this.chunkSize|0;return this.getter(T2)[o2]}}setDataGetter(G2){this.getter=G2}cacheLength(){var G2=new XMLHttpRequest;if(G2.open("HEAD",P,!1),G2.send(null),!(G2.status>=200&&G2.status<300||G2.status===304))throw new Error("Couldn\'t load "+P+". Status: "+G2.status);var o2=Number(G2.getResponseHeader("Content-length")),T2,s1=(T2=G2.getResponseHeader("Accept-Ranges"))&&T2==="bytes",j2=(T2=G2.getResponseHeader("Content-Encoding"))&&T2==="gzip",l0=1024*1024;s1||(l0=o2);var M=(P1,t8)=>{if(P1>t8)throw new Error("invalid range ("+P1+", "+t8+") or no bytes requested!");if(t8>o2-1)throw new Error("only "+o2+" bytes available! programmer error!");var b1=new XMLHttpRequest;if(b1.open("GET",P,!1),o2!==l0&&b1.setRequestHeader("Range","bytes="+P1+"-"+t8),b1.responseType="arraybuffer",b1.overrideMimeType&&b1.overrideMimeType("text/plain; charset=x-user-defined"),b1.send(null),!(b1.status>=200&&b1.status<300||b1.status===304))throw new Error("Couldn\'t load "+P+". Status: "+b1.status);return b1.response!==void 0?new Uint8Array(b1.response||[]):$k(b1.responseText||"",!0)},z=this;z.setDataGetter(P1=>{var t8=P1*l0,b1=(P1+1)*l0-1;if(b1=Math.min(b1,o2-1),typeof z.chunks[P1]=="undefined"&&(z.chunks[P1]=M(t8,b1)),typeof z.chunks[P1]=="undefined")throw new Error("doXHR failed!");return z.chunks[P1]}),(j2||!o2)&&(l0=o2=1,o2=this.getter(0).length,l0=o2,Qr("LazyFiles on gzip forces download of the whole file when length is accessed")),this._length=o2,this._chunkSize=l0,this.lengthKnown=!0}get length(){return this.lengthKnown||this.cacheLength(),this._length}get chunkSize(){return this.lengthKnown||this.cacheLength(),this._chunkSize}}if(typeof XMLHttpRequest!="undefined"){if(!E8)throw"Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";var v0=new b,W0={isDevice:!1,contents:v0}}else var W0={isDevice:!1,url:P};var m0=i0.createFile(J,H,W0,K,e0);W0.contents?m0.contents=W0.contents:W0.url&&(m0.contents=null,m0.url=W0.url),Object.defineProperties(m0,{usedBytes:{get:function(){return this.contents.length}}});var d0={},b0=Object.keys(m0.stream_ops);b0.forEach(Y2=>{var G2=m0.stream_ops[Y2];d0[Y2]=(...o2)=>(i0.forceLoadFile(m0),G2(...o2))});function I2(Y2,G2,o2,T2,s1){var j2=Y2.node.contents;if(s1>=j2.length)return 0;var l0=Math.min(j2.length-s1,T2);if(j2.slice)for(var M=0;M<l0;M++)G2[o2+M]=j2[s1+M];else for(var M=0;M<l0;M++)G2[o2+M]=j2.get(s1+M);return l0}return d0.read=(Y2,G2,o2,T2,s1)=>(i0.forceLoadFile(m0),I2(Y2,G2,o2,T2,s1)),d0.mmap=(Y2,G2,o2,T2,s1)=>{i0.forceLoadFile(m0);var j2=dk(G2);if(!j2)throw new i0.ErrnoError(48);return I2(Y2,R4,j2,G2,o2),{ptr:j2,allocated:!0}},m0.stream_ops=d0,m0}},J4={DEFAULT_POLLMASK:5,calculateAt(J,H,P){if(U1.isAbs(H))return H;var K;if(J===-100)K=i0.cwd();else{var e0=J4.getStreamFromFD(J);K=e0.path}if(H.length==0){if(!P)throw new i0.ErrnoError(44);return K}return K+"/"+H},writeStat(J,H){z2[J>>2]=H.dev,z2[J+4>>2]=H.mode,w1[J+8>>2]=H.nlink,z2[J+12>>2]=H.uid,z2[J+16>>2]=H.gid,z2[J+20>>2]=H.rdev,Z4=[H.size>>>0,(l1=H.size,+Math.abs(l1)>=1?l1>0?+Math.floor(l1/4294967296)>>>0:~~+Math.ceil((l1-+(~~l1>>>0))/4294967296)>>>0:0)],z2[J+24>>2]=Z4[0],z2[J+28>>2]=Z4[1],z2[J+32>>2]=4096,z2[J+36>>2]=H.blocks;var P=H.atime.getTime(),K=H.mtime.getTime(),e0=H.ctime.getTime();return Z4=[Math.floor(P/1e3)>>>0,(l1=Math.floor(P/1e3),+Math.abs(l1)>=1?l1>0?+Math.floor(l1/4294967296)>>>0:~~+Math.ceil((l1-+(~~l1>>>0))/4294967296)>>>0:0)],z2[J+40>>2]=Z4[0],z2[J+44>>2]=Z4[1],w1[J+48>>2]=P%1e3*1e3*1e3,Z4=[Math.floor(K/1e3)>>>0,(l1=Math.floor(K/1e3),+Math.abs(l1)>=1?l1>0?+Math.floor(l1/4294967296)>>>0:~~+Math.ceil((l1-+(~~l1>>>0))/4294967296)>>>0:0)],z2[J+56>>2]=Z4[0],z2[J+60>>2]=Z4[1],w1[J+64>>2]=K%1e3*1e3*1e3,Z4=[Math.floor(e0/1e3)>>>0,(l1=Math.floor(e0/1e3),+Math.abs(l1)>=1?l1>0?+Math.floor(l1/4294967296)>>>0:~~+Math.ceil((l1-+(~~l1>>>0))/4294967296)>>>0:0)],z2[J+72>>2]=Z4[0],z2[J+76>>2]=Z4[1],w1[J+80>>2]=e0%1e3*1e3*1e3,Z4=[H.ino>>>0,(l1=H.ino,+Math.abs(l1)>=1?l1>0?+Math.floor(l1/4294967296)>>>0:~~+Math.ceil((l1-+(~~l1>>>0))/4294967296)>>>0:0)],z2[J+88>>2]=Z4[0],z2[J+92>>2]=Z4[1],0},writeStatFs(J,H){z2[J+4>>2]=H.bsize,z2[J+40>>2]=H.bsize,z2[J+8>>2]=H.blocks,z2[J+12>>2]=H.bfree,z2[J+16>>2]=H.bavail,z2[J+20>>2]=H.files,z2[J+24>>2]=H.ffree,z2[J+28>>2]=H.fsid,z2[J+44>>2]=H.flags,z2[J+36>>2]=H.namelen},doMsync(J,H,P,K,e0){if(!i0.isFile(H.node.mode))throw new i0.ErrnoError(43);if(K&2)return 0;var b=T4.slice(J,J+P);i0.msync(H,b,e0,P,K)},getStreamFromFD(J){var H=i0.getStreamChecked(J);return H},varargs:void 0,getStr(J){var H=_e(J);return H}};function bw(J,H,P){J4.varargs=P;try{var K=J4.getStreamFromFD(J);switch(H){case 0:{var e0=Cr();if(e0<0)return-28;for(;i0.streams[e0];)e0++;var b;return b=i0.dupStream(K,e0),b.fd}case 1:case 2:return 0;case 3:return K.flags;case 4:{var e0=Cr();return K.flags|=e0,0}case 12:{var e0=Bi(),v0=0;return a8[e0+v0>>1]=2,0}case 13:case 14:return 0}return-28}catch(W0){if(typeof i0=="undefined"||W0.name!=="ErrnoError")throw W0;return-W0.errno}}function cw(J,H,P){J4.varargs=P;try{var K=J4.getStreamFromFD(J);switch(H){case 21509:return K.tty?0:-59;case 21505:{if(!K.tty)return-59;if(K.tty.ops.ioctl_tcgets){var e0=K.tty.ops.ioctl_tcgets(K),b=Bi();z2[b>>2]=e0.c_iflag||0,z2[b+4>>2]=e0.c_oflag||0,z2[b+8>>2]=e0.c_cflag||0,z2[b+12>>2]=e0.c_lflag||0;for(var v0=0;v0<32;v0++)R4[b+v0+17]=e0.c_cc[v0]||0;return 0}return 0}case 21510:case 21511:case 21512:return K.tty?0:-59;case 21506:case 21507:case 21508:{if(!K.tty)return-59;if(K.tty.ops.ioctl_tcsets){for(var b=Bi(),W0=z2[b>>2],m0=z2[b+4>>2],d0=z2[b+8>>2],b0=z2[b+12>>2],I2=[],v0=0;v0<32;v0++)I2.push(R4[b+v0+17]);return K.tty.ops.ioctl_tcsets(K.tty,H,{c_iflag:W0,c_oflag:m0,c_cflag:d0,c_lflag:b0,c_cc:I2})}return 0}case 21519:{if(!K.tty)return-59;var b=Bi();return z2[b>>2]=0,0}case 21520:return K.tty?-28:-59;case 21531:{var b=Bi();return i0.ioctl(K,H,b)}case 21523:{if(!K.tty)return-59;if(K.tty.ops.ioctl_tiocgwinsz){var Y2=K.tty.ops.ioctl_tiocgwinsz(K.tty),b=Bi();a8[b>>1]=Y2[0],a8[b+2>>1]=Y2[1]}return 0}case 21524:return K.tty?0:-59;case 21515:return K.tty?0:-59;default:return-28}}catch(G2){if(typeof i0=="undefined"||G2.name!=="ErrnoError")throw G2;return-G2.errno}}function i_(J,H,P,K){J4.varargs=K;try{H=J4.getStr(H),H=J4.calculateAt(J,H);var e0=K?Cr():0;return i0.open(H,P,e0).fd}catch(b){if(typeof i0=="undefined"||b.name!=="ErrnoError")throw b;return-b.errno}}function e_(J,H,P){try{return H=J4.getStr(H),H=J4.calculateAt(J,H),P===0?i0.unlink(H):P===512?i0.rmdir(H):Fr("Invalid flags passed to unlinkat"),0}catch(K){if(typeof i0=="undefined"||K.name!=="ErrnoError")throw K;return-K.errno}}var r_=()=>Fr(""),yr={},zf=J=>{for(;J.length;){var H=J.pop(),P=J.pop();P(H)}};function Be(J){return this.fromWireType(w1[J>>2])}var mi={},x6={},Er={},f_=L.InternalError=class extends Error{constructor(H){super(H),this.name="InternalError"}},Rr=J=>{throw new f_(J)},xf=(J,H,P)=>{J.forEach(W0=>Er[W0]=H);function K(W0){var m0=P(W0);m0.length!==J.length&&Rr("Mismatched type converter count");for(var d0=0;d0<J.length;++d0)R8(J[d0],m0[d0])}var e0=new Array(H.length),b=[],v0=0;H.forEach((W0,m0)=>{x6.hasOwnProperty(W0)?e0[m0]=x6[W0]:(b.push(W0),mi.hasOwnProperty(W0)||(mi[W0]=[]),mi[W0].push(()=>{e0[m0]=x6[W0],++v0,v0===b.length&&K(e0)}))}),b.length===0&&K(e0)},A_=J=>{var H=yr[J];delete yr[J];var P=H.rawConstructor,K=H.rawDestructor,e0=H.fields,b=e0.map(v0=>v0.getterReturnType).concat(e0.map(v0=>v0.setterArgumentType));xf([J],b,v0=>{var W0={};return e0.forEach((m0,d0)=>{var b0=m0.fieldName,I2=v0[d0],Y2=v0[d0].optional,G2=m0.getter,o2=m0.getterContext,T2=v0[d0+e0.length],s1=m0.setter,j2=m0.setterContext;W0[b0]={read:l0=>I2.fromWireType(G2(o2,l0)),write:(l0,M)=>{var z=[];s1(j2,l0,T2.toWireType(z,M)),zf(z)},optional:Y2}}),[{name:H.name,fromWireType:m0=>{var d0={};for(var b0 in W0)d0[b0]=W0[b0].read(m0);return K(m0),d0},toWireType:(m0,d0)=>{for(var b0 in W0)if(!(b0 in d0)&&!W0[b0].optional)throw new TypeError(`Missing field: "${b0}"`);var I2=P();for(b0 in W0)W0[b0].write(I2,d0[b0]);return m0!==null&&m0.push(K,I2),I2},argPackAdvance:J8,readValueFromPointer:Be,destructorFunction:K}]})},k_=(J,H,P,K,e0)=>{},n_=()=>{for(var J=new Array(256),H=0;H<256;++H)J[H]=String.fromCharCode(H);ck=J},ck,N4=J=>{for(var H="",P=J;T4[P];)H+=ck[T4[P++]];return H},Jr=L.BindingError=class extends Error{constructor(H){super(H),this.name="BindingError"}},Q1=J=>{throw new Jr(J)};function t_(J,H,P={}){var K=H.name;if(J||Q1(`type "${K}" must have a positive integer typeid pointer`),x6.hasOwnProperty(J)){if(P.ignoreDuplicateRegistrations)return;Q1(`Cannot register type \'${K}\' twice`)}if(x6[J]=H,delete Er[J],mi.hasOwnProperty(J)){var e0=mi[J];delete mi[J],e0.forEach(b=>b())}}function R8(J,H,P={}){return t_(J,H,P)}var J8=8,o_=(J,H,P,K)=>{H=N4(H),R8(J,{name:H,fromWireType:function(e0){return!!e0},toWireType:function(e0,b){return b?P:K},argPackAdvance:J8,readValueFromPointer:function(e0){return this.fromWireType(T4[e0])},destructorFunction:null})},l_=J=>({count:J.count,deleteScheduled:J.deleteScheduled,preservePointerOnDelete:J.preservePointerOnDelete,ptr:J.ptr,ptrType:J.ptrType,smartPtr:J.smartPtr,smartPtrType:J.smartPtrType}),Tf=J=>{function H(P){return P.$$.ptrType.registeredClass.name}Q1(H(J)+" instance already deleted")},jf=!1,i9=J=>{},u_=J=>{J.smartPtr?J.smartPtrType.rawDestructor(J.smartPtr):J.ptrType.registeredClass.rawDestructor(J.ptr)},e9=J=>{J.count.value-=1;var H=J.count.value===0;H&&u_(J)},ve=J=>typeof FinalizationRegistry=="undefined"?(ve=H=>H,J):(jf=new FinalizationRegistry(H=>{e9(H.$$)}),ve=H=>{var P=H.$$,K=!!P.smartPtr;if(K){var e0={$$:P};jf.register(H,e0,H)}return H},i9=H=>jf.unregister(H),ve(J)),Nr=[],s_=()=>{for(;Nr.length;){var J=Nr.pop();J.$$.deleteScheduled=!1,J.delete()}},r9,h_=()=>{let J=Dr.prototype;Object.assign(J,{isAliasOf(P){if(!(this instanceof Dr)||!(P instanceof Dr))return!1;var K=this.$$.ptrType.registeredClass,e0=this.$$.ptr;P.$$=P.$$;for(var b=P.$$.ptrType.registeredClass,v0=P.$$.ptr;K.baseClass;)e0=K.upcast(e0),K=K.baseClass;for(;b.baseClass;)v0=b.upcast(v0),b=b.baseClass;return K===b&&e0===v0},clone(){if(this.$$.ptr||Tf(this),this.$$.preservePointerOnDelete)return this.$$.count.value+=1,this;var P=ve(Object.create(Object.getPrototypeOf(this),{$$:{value:l_(this.$$)}}));return P.$$.count.value+=1,P.$$.deleteScheduled=!1,P},delete(){this.$$.ptr||Tf(this),this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete&&Q1("Object already scheduled for deletion"),i9(this),e9(this.$$),this.$$.preservePointerOnDelete||(this.$$.smartPtr=void 0,this.$$.ptr=void 0)},isDeleted(){return!this.$$.ptr},deleteLater(){return this.$$.ptr||Tf(this),this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete&&Q1("Object already scheduled for deletion"),Nr.push(this),Nr.length===1&&r9&&r9(s_),this.$$.deleteScheduled=!0,this}});let H=Symbol.dispose;H&&(J[H]=J.delete)};function Dr(){}var Ur=(J,H)=>Object.defineProperty(H,"name",{value:J}),f9={},w_=(J,H,P)=>{if(J[H].overloadTable===void 0){var K=J[H];J[H]=function(...e0){return J[H].overloadTable.hasOwnProperty(e0.length)||Q1(`Function \'${P}\' called with an invalid number of arguments (${e0.length}) - expects one of (${J[H].overloadTable})!`),J[H].overloadTable[e0.length].apply(this,e0)},J[H].overloadTable=[],J[H].overloadTable[K.argCount]=K}},Sf=(J,H,P)=>{L.hasOwnProperty(J)?((P===void 0||L[J].overloadTable!==void 0&&L[J].overloadTable[P]!==void 0)&&Q1(`Cannot register public name \'${J}\' twice`),w_(L,J,J),L[J].overloadTable.hasOwnProperty(P)&&Q1(`Cannot register multiple overloads of a function with the same number of arguments (${P})!`),L[J].overloadTable[P]=H):(L[J]=H,L[J].argCount=P)},__=48,B_=57,v_=J=>{J=J.replace(/[^a-zA-Z0-9_]/g,"$");var H=J.charCodeAt(0);return H>=__&&H<=B_?`_${J}`:J};function m_(J,H,P,K,e0,b,v0,W0){this.name=J,this.constructor=H,this.instancePrototype=P,this.rawDestructor=K,this.baseClass=e0,this.getActualType=b,this.upcast=v0,this.downcast=W0,this.pureVirtualFunctions=[]}var Of=(J,H,P)=>{for(;H!==P;)H.upcast||Q1(`Expected null or instance of ${P.name}, got an instance of ${H.name}`),J=H.upcast(J),H=H.baseClass;return J};function Z_(J,H){if(H===null)return this.isReference&&Q1(`null is not a valid ${this.name}`),0;H.$$||Q1(`Cannot pass "${embindRepr(H)}" as a ${this.name}`),H.$$.ptr||Q1(`Cannot pass deleted object as a pointer of type ${this.name}`);var P=H.$$.ptrType.registeredClass,K=Of(H.$$.ptr,P,this.registeredClass);return K}function g_(J,H){var P;if(H===null)return this.isReference&&Q1(`null is not a valid ${this.name}`),this.isSmartPointer?(P=this.rawConstructor(),J!==null&&J.push(this.rawDestructor,P),P):0;(!H||!H.$$)&&Q1(`Cannot pass "${embindRepr(H)}" as a ${this.name}`),H.$$.ptr||Q1(`Cannot pass deleted object as a pointer of type ${this.name}`),!this.isConst&&H.$$.ptrType.isConst&&Q1(`Cannot convert argument of type ${H.$$.smartPtrType?H.$$.smartPtrType.name:H.$$.ptrType.name} to parameter type ${this.name}`);var K=H.$$.ptrType.registeredClass;if(P=Of(H.$$.ptr,K,this.registeredClass),this.isSmartPointer)switch(H.$$.smartPtr===void 0&&Q1("Passing raw pointer to smart pointer is illegal"),this.sharingPolicy){case 0:H.$$.smartPtrType===this?P=H.$$.smartPtr:Q1(`Cannot convert argument of type ${H.$$.smartPtrType?H.$$.smartPtrType.name:H.$$.ptrType.name} to parameter type ${this.name}`);break;case 1:P=H.$$.smartPtr;break;case 2:if(H.$$.smartPtrType===this)P=H.$$.smartPtr;else{var e0=H.clone();P=this.rawShare(P,n8.toHandle(()=>e0.delete())),J!==null&&J.push(this.rawDestructor,P)}break;default:Q1("Unsupporting sharing policy")}return P}function G_(J,H){if(H===null)return this.isReference&&Q1(`null is not a valid ${this.name}`),0;H.$$||Q1(`Cannot pass "${embindRepr(H)}" as a ${this.name}`),H.$$.ptr||Q1(`Cannot pass deleted object as a pointer of type ${this.name}`),H.$$.ptrType.isConst&&Q1(`Cannot convert argument of type ${H.$$.ptrType.name} to parameter type ${this.name}`);var P=H.$$.ptrType.registeredClass,K=Of(H.$$.ptr,P,this.registeredClass);return K}var A9=(J,H,P)=>{if(H===P)return J;if(P.baseClass===void 0)return null;var K=A9(J,H,P.baseClass);return K===null?null:P.downcast(K)},W_={},X_=(J,H)=>{for(H===void 0&&Q1("ptr should not be undefined");J.baseClass;)H=J.upcast(H),J=J.baseClass;return H},I_=(J,H)=>(H=X_(J,H),W_[H]),Mr=(J,H)=>{(!H.ptrType||!H.ptr)&&Rr("makeClassHandle requires ptr and ptrType");var P=!!H.smartPtrType,K=!!H.smartPtr;return P!==K&&Rr("Both smartPtrType and smartPtr must be specified"),H.count={value:1},ve(Object.create(J,{$$:{value:H,writable:!0}}))};function Q_(J){var H=this.getPointee(J);if(!H)return this.destructor(J),null;var P=I_(this.registeredClass,H);if(P!==void 0){if(P.$$.count.value===0)return P.$$.ptr=H,P.$$.smartPtr=J,P.clone();var K=P.clone();return this.destructor(J),K}function e0(){return this.isSmartPointer?Mr(this.registeredClass.instancePrototype,{ptrType:this.pointeeType,ptr:H,smartPtrType:this,smartPtr:J}):Mr(this.registeredClass.instancePrototype,{ptrType:this,ptr:J})}var b=this.registeredClass.getActualType(H),v0=f9[b];if(!v0)return e0.call(this);var W0;this.isConst?W0=v0.constPointerType:W0=v0.pointerType;var m0=A9(H,this.registeredClass,W0.registeredClass);return m0===null?e0.call(this):this.isSmartPointer?Mr(W0.registeredClass.instancePrototype,{ptrType:W0,ptr:m0,smartPtrType:this,smartPtr:J}):Mr(W0.registeredClass.instancePrototype,{ptrType:W0,ptr:m0})}var V_=()=>{Object.assign(Hr.prototype,{getPointee(J){return this.rawGetPointee&&(J=this.rawGetPointee(J)),J},destructor(J){var H;(H=this.rawDestructor)==null||H.call(this,J)},argPackAdvance:J8,readValueFromPointer:Be,fromWireType:Q_})};function Hr(J,H,P,K,e0,b,v0,W0,m0,d0,b0){this.name=J,this.registeredClass=H,this.isReference=P,this.isConst=K,this.isSmartPointer=e0,this.pointeeType=b,this.sharingPolicy=v0,this.rawGetPointee=W0,this.rawConstructor=m0,this.rawShare=d0,this.rawDestructor=b0,!e0&&H.baseClass===void 0?K?(this.toWireType=Z_,this.destructorFunction=null):(this.toWireType=G_,this.destructorFunction=null):this.toWireType=g_}var k9=(J,H,P)=>{L.hasOwnProperty(J)||Rr("Replacing nonexistent public symbol"),L[J].overloadTable!==void 0&&P!==void 0?L[J].overloadTable[P]=H:(L[J]=H,L[J].argCount=P)},n9=[],t9,o9=J=>{var H=n9[J];return H||(n9[J]=H=t9.get(J)),H},p_=(J,H,P=[],K=!1)=>{if(J.includes("j"))return dynCallLegacy(J,H,P);var e0=o9(H),b=e0(...P);return b},F_=(J,H,P=!1)=>(...K)=>p_(J,H,K,P),K8=(J,H,P=!1)=>{J=N4(J);function K(){if(J.includes("j"))return F_(J,H);var b=o9(H);return b}var e0=K();return typeof e0!="function"&&Q1(`unknown function pointer with signature ${J}: ${H}`),e0};class C_ extends Error{}var l9=J=>{var H=NB(J),P=N4(H);return g6(H),P},u9=(J,H)=>{var P=[],K={};function e0(b){if(!K[b]&&!x6[b]){if(Er[b]){Er[b].forEach(e0);return}P.push(b),K[b]=!0}}throw H.forEach(e0),new C_(`${J}: `+P.map(l9).join([", "]))},Y_=(J,H,P,K,e0,b,v0,W0,m0,d0,b0,I2,Y2)=>{b0=N4(b0),b=K8(e0,b),W0&&(W0=K8(v0,W0)),d0&&(d0=K8(m0,d0)),Y2=K8(I2,Y2);var G2=v_(b0);Sf(G2,function(){u9(`Cannot construct ${b0} due to unbound types`,[K])}),xf([J,H,P],K?[K]:[],o2=>{var b1,V1;o2=o2[0];var T2,s1;K?(T2=o2.registeredClass,s1=T2.instancePrototype):s1=Dr.prototype;var j2=Ur(b0,function(...E1){if(Object.getPrototypeOf(this)!==l0)throw new Jr(`Use \'new\' to construct ${b0}`);if(M.constructor_body===void 0)throw new Jr(`${b0} has no accessible constructor`);var t=M.constructor_body[E1.length];if(t===void 0)throw new Jr(`Tried to invoke ctor of ${b0} with invalid number of parameters (${E1.length}) - expected (${Object.keys(M.constructor_body).toString()}) parameters instead!`);return t.apply(this,E1)}),l0=Object.create(s1,{constructor:{value:j2}});j2.prototype=l0;var M=new m_(b0,j2,l0,Y2,T2,b,W0,d0);M.baseClass&&((V1=(b1=M.baseClass).__derivedClasses)!=null||(b1.__derivedClasses=[]),M.baseClass.__derivedClasses.push(M));var z=new Hr(b0,M,!0,!1,!1),P1=new Hr(b0+"*",M,!1,!1,!1),t8=new Hr(b0+" const*",M,!1,!0,!1);return f9[J]={pointerType:P1,constPointerType:t8},k9(G2,j2),[z,P1,t8]})},Pf=[],$8=[],Lf=J=>{J>9&&--$8[J+1]===0&&($8[J]=void 0,Pf.push(J))},y_=()=>$8.length/2-5-Pf.length,E_=()=>{$8.push(0,1,void 0,1,null,1,!0,1,!1,1),L.count_emval_handles=y_},n8={toValue:J=>(J||Q1(`Cannot use deleted val. handle = ${J}`),$8[J]),toHandle:J=>{switch(J){case void 0:return 2;case null:return 4;case!0:return 6;case!1:return 8;default:{let H=Pf.pop()||$8.length;return $8[H]=J,$8[H+1]=1,H}}}},R_={name:"emscripten::val",fromWireType:J=>{var H=n8.toValue(J);return Lf(J),H},toWireType:(J,H)=>n8.toHandle(H),argPackAdvance:J8,readValueFromPointer:Be,destructorFunction:null},J_=J=>R8(J,R_),N_=(J,H,P)=>{switch(H){case 1:return P?function(K){return this.fromWireType(R4[K])}:function(K){return this.fromWireType(T4[K])};case 2:return P?function(K){return this.fromWireType(a8[K>>1])}:function(K){return this.fromWireType(se[K>>1])};case 4:return P?function(K){return this.fromWireType(z2[K>>2])}:function(K){return this.fromWireType(w1[K>>2])};default:throw new TypeError(`invalid integer width (${H}): ${J}`)}},D_=(J,H,P,K)=>{H=N4(H);function e0(){}e0.values={},R8(J,{name:H,constructor:e0,fromWireType:function(b){return this.constructor.values[b]},toWireType:(b,v0)=>v0.value,argPackAdvance:J8,readValueFromPointer:N_(H,P,K),destructorFunction:null}),Sf(H,e0)},qf=(J,H)=>{var P=x6[J];return P===void 0&&Q1(`${H} has unknown type ${l9(J)}`),P},U_=(J,H,P)=>{var K=qf(J,"enum");H=N4(H);var e0=K.constructor,b=Object.create(K.constructor.prototype,{value:{value:P},constructor:{value:Ur(`${K.name}_${H}`,function(){})}});e0.values[P]=b,e0[H]=b},M_=(J,H)=>{switch(H){case 4:return function(P){return this.fromWireType(xk[P>>2])};case 8:return function(P){return this.fromWireType(Tk[P>>3])};default:throw new TypeError(`invalid float width (${H}): ${J}`)}},H_=(J,H,P)=>{H=N4(H),R8(J,{name:H,fromWireType:K=>K,toWireType:(K,e0)=>e0,argPackAdvance:J8,readValueFromPointer:M_(H,P),destructorFunction:null})};function z_(J){for(var H=1;H<J.length;++H)if(J[H]!==null&&J[H].destructorFunction===void 0)return!0;return!1}function x_(J,H,P,K,e0,b){var v0=H.length;v0<2&&Q1("argTypes array size mismatch! Must at least get return value and \'this\' types!");var W0=H[1]!==null&&P!==null,m0=z_(H),d0=H[0].name!=="void",b0=v0-2,I2=new Array(b0),Y2=[],G2=[],o2=function(...T2){G2.length=0;var s1;Y2.length=W0?2:1,Y2[0]=e0,W0&&(s1=H[1].toWireType(G2,this),Y2[1]=s1);for(var j2=0;j2<b0;++j2)I2[j2]=H[j2+2].toWireType(G2,T2[j2]),Y2.push(I2[j2]);var l0=K(...Y2);function M(z){if(m0)zf(G2);else for(var P1=W0?1:2;P1<H.length;P1++){var t8=P1===1?s1:I2[P1-2];H[P1].destructorFunction!==null&&H[P1].destructorFunction(t8)}if(d0)return H[0].fromWireType(z)}return M(l0)};return Ur(J,o2)}var T_=(J,H)=>{for(var P=[],K=0;K<J;K++)P.push(w1[H+K*4>>2]);return P},j_=J=>{J=J.trim();let H=J.indexOf("(");return H===-1?J:J.slice(0,H)},S_=(J,H,P,K,e0,b,v0,W0)=>{var m0=T_(H,P);J=N4(J),J=j_(J),e0=K8(K,e0,v0),Sf(J,function(){u9(`Cannot call ${J} due to unbound types`,m0)},H-1),xf([],m0,d0=>{var b0=[d0[0],null].concat(d0.slice(1));return k9(J,x_(J,b0,null,e0,b,v0),H-1),[]})},O_=(J,H,P)=>{switch(H){case 1:return P?K=>R4[K]:K=>T4[K];case 2:return P?K=>a8[K>>1]:K=>se[K>>1];case 4:return P?K=>z2[K>>2]:K=>w1[K>>2];default:throw new TypeError(`invalid integer width (${H}): ${J}`)}},P_=(J,H,P,K,e0)=>{H=N4(H),e0===-1&&(e0=4294967295);var b=b0=>b0;if(K===0){var v0=32-8*P;b=b0=>b0<<v0>>>v0}var W0=H.includes("unsigned"),m0=(b0,I2)=>{},d0;W0?d0=function(b0,I2){return m0(I2,this.name),I2>>>0}:d0=function(b0,I2){return m0(I2,this.name),I2},R8(J,{name:H,fromWireType:b,toWireType:d0,argPackAdvance:J8,readValueFromPointer:O_(H,P,K!==0),destructorFunction:null})},L_=(J,H,P)=>{var K=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array],e0=K[H];function b(v0){var W0=w1[v0>>2],m0=w1[v0+4>>2];return new e0(R4.buffer,m0,W0)}P=N4(P),R8(J,{name:P,fromWireType:b,argPackAdvance:J8,readValueFromPointer:b},{ignoreDuplicateRegistrations:!0})},Zi=(J,H,P)=>Mf(J,T4,H,P),q_=(J,H)=>{H=N4(H);var P=!0;R8(J,{name:H,fromWireType(K){var e0=w1[K>>2],b=K+4,v0;if(P)for(var W0=b,m0=0;m0<=e0;++m0){var d0=b+m0;if(m0==e0||T4[d0]==0){var b0=d0-W0,I2=_e(W0,b0);v0===void 0?v0=I2:(v0+="\\0",v0+=I2),W0=d0+1}}else{for(var Y2=new Array(e0),m0=0;m0<e0;++m0)Y2[m0]=String.fromCharCode(T4[b+m0]);v0=Y2.join("")}return g6(K),v0},toWireType(K,e0){e0 instanceof ArrayBuffer&&(e0=new Uint8Array(e0));var b,v0=typeof e0=="string";v0||ArrayBuffer.isView(e0)&&e0.BYTES_PER_ELEMENT==1||Q1("Cannot pass non-string to std::string"),P&&v0?b=Yr(e0):b=e0.length;var W0=w9(4+b+1),m0=W0+4;if(w1[W0>>2]=b,v0)if(P)Zi(e0,m0,b+1);else for(var d0=0;d0<b;++d0){var b0=e0.charCodeAt(d0);b0>255&&(g6(W0),Q1("String has UTF-16 code units that do not fit in 8 bits")),T4[m0+d0]=b0}else T4.set(e0,m0);return K!==null&&K.push(g6,W0),W0},argPackAdvance:J8,readValueFromPointer:Be,destructorFunction(K){g6(K)}})},s9=typeof TextDecoder!="undefined"?new TextDecoder("utf-16le"):void 0,a_=(J,H)=>{for(var P=J,K=P>>1,e0=K+H/2;!(K>=e0)&&se[K];)++K;if(P=K<<1,P-J>32&&s9)return s9.decode(T4.subarray(J,P));for(var b="",v0=0;!(v0>=H/2);++v0){var W0=a8[J+v0*2>>1];if(W0==0)break;b+=String.fromCharCode(W0)}return b},K_=(J,H,P)=>{if(P!=null||(P=2147483647),P<2)return 0;P-=2;for(var K=H,e0=P<J.length*2?P/2:J.length,b=0;b<e0;++b){var v0=J.charCodeAt(b);a8[H>>1]=v0,H+=2}return a8[H>>1]=0,H-K},$_=J=>J.length*2,d_=(J,H)=>{for(var P=0,K="";!(P>=H/4);){var e0=z2[J+P*4>>2];if(e0==0)break;if(++P,e0>=65536){var b=e0-65536;K+=String.fromCharCode(55296|b>>10,56320|b&1023)}else K+=String.fromCharCode(e0)}return K},b_=(J,H,P)=>{if(P!=null||(P=2147483647),P<4)return 0;for(var K=H,e0=K+P-4,b=0;b<J.length;++b){var v0=J.charCodeAt(b);if(v0>=55296&&v0<=57343){var W0=J.charCodeAt(++b);v0=65536+((v0&1023)<<10)|W0&1023}if(z2[H>>2]=v0,H+=4,H+4>e0)break}return z2[H>>2]=0,H-K},c_=J=>{for(var H=0,P=0;P<J.length;++P){var K=J.charCodeAt(P);K>=55296&&K<=57343&&++P,H+=4}return H},iB=(J,H,P)=>{P=N4(P);var K,e0,b,v0;H===2?(K=a_,e0=K_,v0=$_,b=W0=>se[W0>>1]):H===4&&(K=d_,e0=b_,v0=c_,b=W0=>w1[W0>>2]),R8(J,{name:P,fromWireType:W0=>{for(var m0=w1[W0>>2],d0,b0=W0+4,I2=0;I2<=m0;++I2){var Y2=W0+4+I2*H;if(I2==m0||b(Y2)==0){var G2=Y2-b0,o2=K(b0,G2);d0===void 0?d0=o2:(d0+="\\0",d0+=o2),b0=Y2+H}}return g6(W0),d0},toWireType:(W0,m0)=>{typeof m0!="string"&&Q1(`Cannot pass non-string to C++ string type ${P}`);var d0=v0(m0),b0=w9(4+d0+H);return w1[b0>>2]=d0/H,e0(m0,b0+4,d0+H),W0!==null&&W0.push(g6,b0),b0},argPackAdvance:J8,readValueFromPointer:Be,destructorFunction(W0){g6(W0)}})},eB=(J,H,P,K,e0,b)=>{yr[J]={name:N4(H),rawConstructor:K8(P,K),rawDestructor:K8(e0,b),fields:[]}},rB=(J,H,P,K,e0,b,v0,W0,m0,d0)=>{yr[J].fields.push({fieldName:N4(H),getterReturnType:P,getter:K8(K,e0),getterContext:b,setterArgumentType:v0,setter:K8(W0,m0),setterContext:d0})},fB=(J,H)=>{H=N4(H),R8(J,{isVoid:!0,name:H,argPackAdvance:0,fromWireType:()=>{},toWireType:(P,K)=>{}})},AB={},h9=J=>{var H=AB[J];return H===void 0?N4(J):H},af=[],kB=(J,H,P,K,e0)=>(J=af[J],H=n8.toValue(H),P=h9(P),J(H,H[P],K,e0)),nB=J=>{var H=af.length;return af.push(J),H},tB=(J,H)=>{for(var P=new Array(J),K=0;K<J;++K)P[K]=qf(w1[H+K*4>>2],`parameter ${K}`);return P},oB=(J,H,P)=>{var K=[],e0=J.toWireType(K,P);return K.length&&(w1[H>>2]=n8.toHandle(K)),e0},lB=Reflect.construct,uB=(J,H,P)=>{var K=tB(J,H),e0=K.shift();J--;var b=new Array(J),v0=(m0,d0,b0,I2)=>{for(var Y2=0,G2=0;G2<J;++G2)b[G2]=K[G2].readValueFromPointer(I2+Y2),Y2+=K[G2].argPackAdvance;var o2=P===1?lB(d0,b):d0.apply(m0,b);return oB(e0,b0,o2)},W0=`methodCaller<(${K.map(m0=>m0.name).join(", ")}) => ${e0.name}>`;return nB(Ur(W0,v0))},sB=J=>{J>9&&($8[J+1]+=1)},hB=()=>n8.toHandle([]),wB=J=>n8.toHandle(h9(J)),_B=()=>n8.toHandle({}),BB=J=>{var H=n8.toValue(J);zf(H),Lf(J)},vB=(J,H,P)=>{J=n8.toValue(J),H=n8.toValue(H),P=n8.toValue(P),J[H]=P},mB=(J,H)=>{J=qf(J,"_emval_take_value");var P=J.readValueFromPointer(H);return n8.toHandle(P)},ZB=(J,H,P,K)=>{var e0=new Date().getFullYear(),b=new Date(e0,0,1),v0=new Date(e0,6,1),W0=b.getTimezoneOffset(),m0=v0.getTimezoneOffset(),d0=Math.max(W0,m0);w1[J>>2]=d0*60,z2[H>>2]=+(W0!=m0);var b0=G2=>{var o2=G2>=0?"-":"+",T2=Math.abs(G2),s1=String(Math.floor(T2/60)).padStart(2,"0"),j2=String(T2%60).padStart(2,"0");return`UTC${o2}${s1}${j2}`},I2=b0(W0),Y2=b0(m0);m0<W0?(Zi(I2,P,17),Zi(Y2,K,17)):(Zi(I2,K,17),Zi(Y2,P,17))},gB=()=>2147483648,GB=(J,H)=>Math.ceil(J/H)*H,WB=J=>{var H=pr.buffer,P=(J-H.byteLength+65535)/65536|0;try{return pr.grow(P),jk(),1}catch(K){}},XB=J=>{var H=T4.length;J>>>=0;var P=gB();if(J>P)return!1;for(var K=1;K<=4;K*=2){var e0=H*(1+.2/K);e0=Math.min(e0,J+100663296);var b=Math.min(P,GB(Math.max(J,e0),65536)),v0=WB(b);if(v0)return!0}return!1},Kf={},IB=()=>Ef||"./this.program",me=()=>{if(!me.strings){var J=(typeof navigator=="object"&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8",H={USER:"web_user",LOGNAME:"web_user",PATH:"/",PWD:"/",HOME:"/home/web_user",LANG:J,_:IB()};for(var P in Kf)Kf[P]===void 0?delete H[P]:H[P]=Kf[P];var K=[];for(var P in H)K.push(`${P}=${H[P]}`);me.strings=K}return me.strings},QB=(J,H)=>{var P=0,K=0;for(var e0 of me()){var b=H+P;w1[J+K>>2]=b,P+=Zi(e0,b,1/0)+1,K+=4}return 0},VB=(J,H)=>{var P=me();w1[J>>2]=P.length;var K=0;for(var e0 of P)K+=Yr(e0)+1;return w1[H>>2]=K,0};function pB(J){try{var H=J4.getStreamFromFD(J);return i0.close(H),0}catch(P){if(typeof i0=="undefined"||P.name!=="ErrnoError")throw P;return P.errno}}var FB=(J,H,P,K)=>{for(var e0=0,b=0;b<P;b++){var v0=w1[H>>2],W0=w1[H+4>>2];H+=8;var m0=i0.read(J,R4,v0,W0,K);if(m0<0)return-1;if(e0+=m0,m0<W0)break;typeof K!="undefined"&&(K+=m0)}return e0};function CB(J,H,P,K){try{var e0=J4.getStreamFromFD(J),b=FB(e0,H,P);return w1[K>>2]=b,0}catch(v0){if(typeof i0=="undefined"||v0.name!=="ErrnoError")throw v0;return v0.errno}}var YB=(J,H)=>H+2097152>>>0<4194305-!!J?(J>>>0)+H*4294967296:NaN;function yB(J,H,P,K,e0){var b=YB(H,P);try{if(isNaN(b))return 61;var v0=J4.getStreamFromFD(J);return i0.llseek(v0,b,K),Z4=[v0.position>>>0,(l1=v0.position,+Math.abs(l1)>=1?l1>0?+Math.floor(l1/4294967296)>>>0:~~+Math.ceil((l1-+(~~l1>>>0))/4294967296)>>>0:0)],z2[e0>>2]=Z4[0],z2[e0+4>>2]=Z4[1],v0.getdents&&b===0&&K===0&&(v0.getdents=null),0}catch(W0){if(typeof i0=="undefined"||W0.name!=="ErrnoError")throw W0;return W0.errno}}var EB=(J,H,P,K)=>{for(var e0=0,b=0;b<P;b++){var v0=w1[H>>2],W0=w1[H+4>>2];H+=8;var m0=i0.write(J,R4,v0,W0,K);if(m0<0)return-1;if(e0+=m0,m0<W0)break;typeof K!="undefined"&&(K+=m0)}return e0};function RB(J,H,P,K){try{var e0=J4.getStreamFromFD(J),b=EB(e0,H,P);return w1[K>>2]=b,0}catch(v0){if(typeof i0=="undefined"||v0.name!=="ErrnoError")throw v0;return v0.errno}}i0.createPreloadedFile=$w,i0.staticInit(),x2.doesNotExistError=new i0.ErrnoError(44),x2.doesNotExistError.stack="<generic error, no stack>",n_(),h_(),V_(),E_(),L.noExitRuntime&&(xw=L.noExitRuntime),L.preloadPlugins&&(bk=L.preloadPlugins),L.print&&(Qr=L.print),L.printErr&&(ue=L.printErr),L.wasmBinary&&(Vr=L.wasmBinary),L.arguments&&(Hk=L.arguments),L.thisProgram&&(Ef=L.thisProgram);var JB={b:Tw,k:Ow,r:bw,A:cw,E:i_,D:e_,B:r_,v:A_,y:k_,J:o_,o:Y_,H:J_,j:D_,a:U_,u:H_,d:S_,i:P_,f:L_,I:q_,q:iB,w:eB,n:rB,K:fB,M:kB,c:Lf,N:uB,O:sB,m:hB,h:wB,l:_B,L:BB,g:vB,e:mB,z:ZB,C:XB,F:QB,G:VB,s:pB,t:CB,x:yB,p:RB},$=Mw(),JK=$.Q,NK=L._heif_nclx_color_profile_alloc=$.S,DK=L._heif_nclx_color_profile_free=$.T,UK=L._heif_tai_timestamp_packet_alloc=$.U,MK=L._heif_tai_timestamp_packet_copy=$.V,HK=L._heif_get_global_security_limits=$.W,g6=L._free=$.X,zK=L._heif_color_conversion_options_set_defaults=$.Y,xK=L._heif_tai_timestamp_packet_release=$.Z,TK=L._heif_nclx_color_profile_set_color_primaries=$._,jK=L._heif_nclx_color_profile_set_transfer_characteristics=$.$,SK=L._heif_nclx_color_profile_set_matrix_coefficients=$.aa,OK=L._heif_init=$.ba,PK=L._heif_deinit=$.ca,LK=L._heif_load_plugin=$.da,qK=L._heif_unload_plugin=$.ea,aK=L._heif_load_plugins=$.fa,KK=L._heif_get_plugin_directories=$.ga,$K=L._heif_free_plugin_directories=$.ha,dK=L._heif_get_version_number=$.ia,bK=L._heif_context_alloc=$.ja,cK=L._heif_context_free=$.ka,i$=L._heif_context_get_number_of_top_level_images=$.la,e$=L._heif_image_handle_release=$.ma,r$=L._heif_image_handle_get_width=$.na,f$=L._heif_image_handle_get_height=$.oa,A$=L._heif_image_handle_is_primary_image=$.pa,k$=L._heif_image_release=$.qa,n$=L._heif_image_handle_has_alpha_channel=$.ra,t$=L._heif_image_handle_is_premultiplied_alpha=$.sa,o$=L._heif_context_get_number_of_items=$.ta,l$=L._heif_item_is_item_hidden=$.ua,u$=L._heif_get_version=$.va,s$=L._heif_context_read_from_memory=$.wa,h$=L._heif_check_filetype=$.xa,w$=L._heif_context_get_list_of_top_level_image_IDs=$.ya,_$=L._heif_context_get_image_handle=$.za,B$=L._heif_context_get_primary_image_handle=$.Aa,v$=L._heif_decode_image=$.Ba,m$=L._heif_image_get_chroma_format=$.Ca,Z$=L._heif_image_get_colorspace=$.Da,g$=L._heif_image_has_channel=$.Ea,G$=L._heif_image_get_plane_readonly2=$.Fa,W$=L._heif_image_get_width=$.Ga,X$=L._heif_image_get_height=$.Ha,I$=L._heif_image_get_bits_per_pixel_range=$.Ia,Q$=L._heif_context_get_list_of_item_IDs=$.Ja,V$=L._heif_item_get_item_type=$.Ka,w9=L._malloc=$.La,p$=L._heif_item_get_mime_item_content_type=$.Ma,F$=L._heif_item_get_mime_item_content_encoding=$.Na,C$=L._heif_item_get_uri_item_uri_type=$.Oa,Y$=L._heif_item_get_item_name=$.Pa,y$=L._heif_get_version_number_major=$.Qa,E$=L._heif_get_version_number_minor=$.Ra,R$=L._heif_get_version_number_maintenance=$.Sa,J$=L._heif_register_decoder_plugin=$.Ta,N$=L._heif_register_encoder_plugin=$.Ua,D$=L._heif_string_release=$.Va,U$=L._heif_register_decoder=$.Wa,M$=L._heif_image_get_primary_width=$.Xa,H$=L._heif_image_get_primary_height=$.Ya,z$=L._heif_image_crop=$.Za,x$=L._heif_image_extract_area=$._a,T$=L._heif_image_get_bits_per_pixel=$.$a,j$=L._heif_image_get_plane_readonly=$.ab,S$=L._heif_image_get_plane=$.bb,O$=L._heif_image_get_plane2=$.cb,P$=L._heif_image_scale_image=$.db,L$=L._heif_image_extend_to_size_fill_with_zero=$.eb,q$=L._heif_image_get_decoding_warnings=$.fb,a$=L._heif_image_add_decoding_warning=$.gb,K$=L._heif_image_get_pixel_aspect_ratio=$.hb,$$=L._heif_image_set_pixel_aspect_ratio=$.ib,d$=L._heif_image_handle_set_pixel_aspect_ratio=$.jb,b$=L._heif_image_create=$.kb,c$=L._heif_image_add_plane=$.lb,id=L._heif_image_add_plane_safe=$.mb,ed=L._heif_image_set_premultiplied_alpha=$.nb,rd=L._heif_image_is_premultiplied_alpha=$.ob,fd=L._heif_image_extend_padding_to_size=$.pb,Ad=L._heif_color_conversion_options_ext_alloc=$.qb,kd=L._heif_color_conversion_options_ext_copy=$.rb,nd=L._heif_color_conversion_options_ext_free=$.sb,td=L._heif_image_handle_get_color_profile_type=$.tb,od=L._heif_image_handle_get_raw_color_profile_size=$.ub,ld=L._heif_image_handle_get_raw_color_profile=$.vb,ud=L._heif_image_handle_get_nclx_color_profile=$.wb,sd=L._heif_image_get_color_profile_type=$.xb,hd=L._heif_image_get_raw_color_profile_size=$.yb,wd=L._heif_image_get_raw_color_profile=$.zb,_d=L._heif_image_get_nclx_color_profile=$.Ab,Bd=L._heif_image_set_raw_color_profile=$.Bb,vd=L._heif_image_set_nclx_color_profile=$.Cb,md=L._heif_image_has_content_light_level=$.Db,Zd=L._heif_image_get_content_light_level=$.Eb,gd=L._heif_image_handle_get_content_light_level=$.Fb,Gd=L._heif_image_set_content_light_level=$.Gb,Wd=L._heif_image_handle_set_content_light_level=$.Hb,Xd=L._heif_image_has_mastering_display_colour_volume=$.Ib,Id=L._heif_image_get_mastering_display_colour_volume=$.Jb,Qd=L._heif_image_handle_get_mastering_display_colour_volume=$.Kb,Vd=L._heif_image_set_mastering_display_colour_volume=$.Lb,pd=L._heif_image_handle_set_mastering_display_colour_volume=$.Mb,Fd=L._heif_mastering_display_colour_volume_decode=$.Nb,Cd=L._heif_image_handle_get_number_of_region_items=$.Ob,Yd=L._heif_image_handle_get_list_of_region_item_ids=$.Pb,yd=L._heif_context_get_region_item=$.Qb,Ed=L._heif_region_item_get_id=$.Rb,Rd=L._heif_region_item_release=$.Sb,Jd=L._heif_region_item_get_reference_size=$.Tb,Nd=L._heif_region_item_get_number_of_regions=$.Ub,Dd=L._heif_region_item_get_list_of_regions=$.Vb,Ud=L._heif_region_release=$.Wb,Md=L._heif_region_release_many=$.Xb,Hd=L._heif_region_get_type=$.Yb,zd=L._heif_region_get_point=$.Zb,xd=L._heif_region_get_point_transformed=$._b,Td=L._heif_region_get_rectangle=$.$b,jd=L._heif_region_get_rectangle_transformed=$.ac,Sd=L._heif_region_get_ellipse=$.bc,Od=L._heif_region_get_ellipse_transformed=$.cc,Pd=L._heif_region_get_polygon_num_points=$.dc,Ld=L._heif_region_get_polygon_points=$.ec,qd=L._heif_region_get_polygon_points_transformed=$.fc,ad=L._heif_region_get_polyline_num_points=$.gc,Kd=L._heif_region_get_polyline_points=$.hc,$d=L._heif_region_get_polyline_points_transformed=$.ic,dd=L._heif_region_get_referenced_mask_ID=$.jc,bd=L._heif_region_get_inline_mask_data_len=$.kc,cd=L._heif_region_item_add_region_inline_mask_data=$.lc,ib=L._heif_region_get_mask_image=$.mc,eb=L._heif_image_handle_add_region_item=$.nc,rb=L._heif_region_item_add_region_point=$.oc,fb=L._heif_region_item_add_region_rectangle=$.pc,Ab=L._heif_region_item_add_region_ellipse=$.qc,kb=L._heif_region_item_add_region_polygon=$.rc,nb=L._heif_region_item_add_region_polyline=$.sc,tb=L._heif_region_item_add_region_referenced_mask=$.tc,ob=L._heif_region_get_inline_mask_data=$.uc,lb=L._heif_region_item_add_region_inline_mask=$.vc,ub=L._heif_item_get_properties_of_type=$.wc,sb=L._heif_item_get_transformation_properties=$.xc,hb=L._heif_item_get_property_type=$.yc,wb=L._heif_item_get_property_user_description=$.zc,_b=L._heif_item_add_property_user_description=$.Ac,Bb=L._heif_property_user_description_release=$.Bc,vb=L._heif_item_get_property_transform_mirror=$.Cc,mb=L._heif_item_get_property_transform_rotation_ccw=$.Dc,Zb=L._heif_item_get_property_transform_crop_borders=$.Ec,gb=L._heif_item_add_raw_property=$.Fc,Gb=L._heif_item_get_property_raw_size=$.Gc,Wb=L._heif_item_get_property_raw_data=$.Hc,Xb=L._heif_item_get_property_uuid_type=$.Ic,Ib=L._heif_image_handle_has_camera_intrinsic_matrix=$.Jc,Qb=L._heif_image_handle_get_camera_intrinsic_matrix=$.Kc,Vb=L._heif_image_handle_has_camera_extrinsic_matrix=$.Lc,pb=L._heif_image_handle_get_camera_extrinsic_matrix=$.Mc,Fb=L._heif_camera_extrinsic_matrix_release=$.Nc,Cb=L._heif_camera_extrinsic_matrix_get_rotation_matrix=$.Oc,Yb=L._heif_image_set_bayer_pattern=$.Pc,yb=L._heif_image_add_bayer_component=$.Qc,Eb=L._heif_image_get_bayer_pattern_size=$.Rc,Rb=L._heif_image_get_bayer_pattern=$.Sc,Jb=L._heif_polarization_angle_no_filter=$.Tc,Nb=L._heif_polarization_angle_is_no_filter=$.Uc,Db=L._heif_image_add_polarization_pattern=$.Vc,Ub=L._heif_image_get_number_of_polarization_patterns=$.Wc,Mb=L._heif_image_get_polarization_pattern_info=$.Xc,Hb=L._heif_image_get_polarization_pattern_data=$.Yc,zb=L._heif_image_get_polarization_pattern_index_for_component=$.Zc,xb=L._heif_image_add_sensor_bad_pixels_map=$._c,Tb=L._heif_image_get_number_of_sensor_bad_pixels_maps=$.$c,jb=L._heif_image_get_sensor_bad_pixels_map_info=$.ad,Sb=L._heif_image_get_sensor_bad_pixels_map_data=$.bd,Ob=L._heif_image_add_sensor_nuc=$.cd,Pb=L._heif_image_get_number_of_sensor_nucs=$.dd,Lb=L._heif_image_get_sensor_nuc_info=$.ed,qb=L._heif_image_get_sensor_nuc_data=$.fd,ab=L._heif_image_set_chroma_location=$.gd,Kb=L._heif_image_has_chroma_location=$.hd,$b=L._heif_image_get_chroma_location=$.id,db=L._heif_item_set_item_name=$.jd,bb=L._heif_item_get_item_data=$.kd,cb=L._heif_release_item_data=$.ld,ic=L._heif_item_get_property_extended_language=$.md,ec=L._heif_item_set_property_extended_language=$.nd,rc=L._heif_context_get_item_references=$.od,fc=L._heif_release_item_references=$.pd,Ac=L._heif_context_add_item_reference=$.qd,kc=L._heif_context_add_item_references=$.rd,nc=L._heif_context_add_item=$.sd,tc=L._heif_context_add_mime_item=$.td,oc=L._heif_context_add_precompressed_mime_item=$.ud,lc=L._heif_context_add_uri_item=$.vd,uc=L._heif_context_has_sequence=$.wd,sc=L._heif_context_get_sequence_timescale=$.xd,hc=L._heif_context_get_sequence_duration=$.yd,wc=L._heif_track_release=$.zd,_c=L._heif_context_number_of_sequence_tracks=$.Ad,Bc=L._heif_context_get_track_ids=$.Bd,vc=L._heif_track_get_id=$.Cd,mc=L._heif_context_get_track=$.Dd,Zc=L._heif_track_get_track_handler_type=$.Ed,gc=L._heif_track_get_auxiliary_info_type=$.Fd,Gc=L._heif_track_get_auxiliary_info_type_urn=$.Gd,Wc=L._heif_track_has_alpha_channel=$.Hd,Xc=L._heif_track_get_timescale=$.Id,Ic=L._heif_track_get_number_of_repetitions=$.Jd,Qc=L._heif_track_get_image_resolution=$.Kd,Vc=L._heif_track_decode_next_image=$.Ld,pc=L._heif_decoding_options_alloc=$.Md,Fc=L._heif_decoding_options_copy=$.Nd,Cc=L._heif_decoding_options_free=$.Od,Yc=L._heif_image_get_duration=$.Pd,yc=L._heif_track_get_sample_entry_type_of_first_cluster=$.Qd,Ec=L._heif_track_get_urim_sample_entry_uri_of_first_cluster=$.Rd,Rc=L._heif_track_get_next_raw_sequence_sample=$.Sd,Jc=L._heif_raw_sequence_sample_release=$.Td,Nc=L._heif_raw_sequence_sample_get_data=$.Ud,Dc=L._heif_raw_sequence_sample_get_data_size=$.Vd,Uc=L._heif_raw_sequence_sample_get_duration=$.Wd,Mc=L._heif_context_set_sequence_timescale=$.Xd,Hc=L._heif_context_set_number_of_sequence_repetitions=$.Yd,zc=L._heif_track_options_alloc=$.Zd,xc=L._heif_track_options_release=$._d,Tc=L._heif_tai_clock_info_release=$.$d,jc=L._heif_track_options_set_timescale=$.ae,Sc=L._heif_track_options_set_interleaved_sample_aux_infos=$.be,Oc=L._heif_track_options_enable_sample_tai_timestamps=$.ce,Pc=L._heif_tai_clock_info_alloc=$.de,Lc=L._heif_tai_clock_info_copy=$.ee,qc=L._heif_track_options_enable_sample_gimi_content_ids=$.fe,ac=L._heif_track_options_set_gimi_track_id=$.ge,Kc=L._heif_sequence_encoding_options_alloc=$.he,$c=L._heif_sequence_encoding_options_copy=$.ie,dc=L._heif_sequence_encoding_options_release=$.je,bc=L._heif_context_add_visual_sequence_track=$.ke,cc=L._heif_image_set_duration=$.le,i00=L._heif_track_encode_end_of_sequence=$.me,e00=L._heif_track_encode_sequence_image=$.ne,r00=L._heif_context_add_uri_metadata_sequence_track=$.oe,f00=L._heif_raw_sequence_sample_alloc=$.pe,A00=L._heif_raw_sequence_sample_set_data=$.qe,k00=L._heif_raw_sequence_sample_set_duration=$.re,n00=L._heif_track_add_raw_sequence_sample=$.se,t00=L._heif_track_get_number_of_sample_aux_infos=$.te,o00=L._heif_track_get_sample_aux_info_types=$.ue,l00=L._heif_track_get_gimi_track_content_id=$.ve,u00=L._heif_image_get_gimi_sample_content_id=$.we,s00=L._heif_raw_sequence_sample_get_gimi_sample_content_id=$.xe,h00=L._heif_image_set_gimi_sample_content_id=$.ye,w00=L._heif_raw_sequence_sample_set_gimi_sample_content_id=$.ze,_00=L._heif_raw_sequence_sample_has_tai_timestamp=$.Ae,B00=L._heif_raw_sequence_sample_get_tai_timestamp=$.Be,v00=L._heif_raw_sequence_sample_set_tai_timestamp=$.Ce,m00=L._heif_track_get_tai_clock_info_of_first_cluster=$.De,Z00=L._heif_track_add_reference_to_track=$.Ee,g00=L._heif_track_get_number_of_track_reference_types=$.Fe,G00=L._heif_track_get_track_reference_types=$.Ge,W00=L._heif_track_get_number_of_track_reference_of_type=$.He,X00=L._heif_track_get_references_from_track=$.Ie,I00=L._heif_track_find_referring_tracks=$.Je,Q00=L._heif_item_set_property_tai_clock_info=$.Ke,V00=L._heif_item_get_property_tai_clock_info=$.Le,p00=L._heif_item_set_property_tai_timestamp=$.Me,F00=L._heif_item_get_property_tai_timestamp=$.Ne,C00=L._heif_image_set_tai_timestamp=$.Oe,Y00=L._heif_image_get_tai_timestamp=$.Pe,y00=L._heif_read_main_brand=$.Qe,E00=L._heif_fourcc_to_brand=$.Re,R00=L._heif_read_minor_version_brand=$.Se,J00=L._heif_brand_to_fourcc=$.Te,N00=L._heif_has_compatible_brand=$.Ue,D00=L._heif_list_compatible_brands=$.Ve,U00=L._heif_free_list_of_compatible_brands=$.We,M00=L._heif_get_file_mime_type=$.Xe,H00=L._heif_has_compatible_filetype=$.Ye,z00=L._heif_check_jpeg_filetype=$.Ze,x00=L._heif_main_brand=$._e,T00=L._heif_metadata_compression_method_supported=$.$e,j00=L._heif_image_handle_get_number_of_metadata_blocks=$.af,S00=L._heif_image_handle_get_list_of_metadata_block_IDs=$.bf,O00=L._heif_image_handle_get_metadata_type=$.cf,P00=L._heif_image_handle_get_metadata_content_type=$.df,L00=L._heif_image_handle_get_metadata_size=$.ef,q00=L._heif_image_handle_get_metadata=$.ff,a00=L._heif_image_handle_get_metadata_item_uri_type=$.gf,K00=L._heif_context_add_exif_metadata=$.hf,$00=L._heif_context_add_XMP_metadata=$.jf,d00=L._heif_context_add_XMP_metadata2=$.kf,b00=L._heif_context_add_generic_metadata=$.lf,c00=L._heif_context_add_generic_uri_metadata=$.mf,i20=L._heif_image_handle_has_depth_image=$.nf,e20=L._heif_image_handle_get_number_of_depth_images=$.of,r20=L._heif_image_handle_get_list_of_depth_image_IDs=$.pf,f20=L._heif_image_handle_get_depth_image_handle=$.qf,A20=L._heif_depth_representation_info_free=$.rf,k20=L._heif_image_handle_get_depth_image_representation_info=$.sf,n20=L._heif_image_handle_get_number_of_thumbnails=$.tf,t20=L._heif_image_handle_get_list_of_thumbnail_IDs=$.uf,o20=L._heif_image_handle_get_thumbnail=$.vf,l20=L._heif_context_encode_thumbnail=$.wf,u20=L._heif_encoding_options_alloc=$.xf,s20=L._heif_encoding_options_copy=$.yf,h20=L._heif_encoding_options_free=$.zf,w20=L._heif_context_assign_thumbnail=$.Af,_20=L._heif_image_handle_get_number_of_auxiliary_images=$.Bf,B20=L._heif_image_handle_get_list_of_auxiliary_image_IDs=$.Cf,v20=L._heif_image_handle_get_auxiliary_type=$.Df,m20=L._heif_image_handle_release_auxiliary_type=$.Ef,Z20=L._heif_image_handle_get_auxiliary_image_handle=$.Ff,g20=L._heif_image_handle_free_auxiliary_types=$.Gf,G20=L._heif_context_get_entity_groups=$.Hf,W20=L._heif_entity_groups_release=$.If,X20=L._heif_get_disabled_security_limits=$.Jf,I20=L._heif_context_get_security_limits=$.Kf,Q20=L._heif_context_set_security_limits=$.Lf,V20=L._heif_context_set_maximum_image_size_limit=$.Mf,p20=L._heif_have_encoder_for_format=$.Nf,F20=L._heif_get_encoder_descriptors=$.Of,C20=L._heif_encoder_descriptor_get_name=$.Pf,Y20=L._heif_encoder_descriptor_get_id_name=$.Qf,y20=L._heif_encoder_descriptor_get_compression_format=$.Rf,E20=L._heif_encoder_descriptor_supports_lossy_compression=$.Sf,R20=L._heif_encoder_descriptor_supports_lossless_compression=$.Tf,J20=L._heif_context_get_encoder=$.Uf,N20=L._heif_context_get_encoder_for_format=$.Vf,D20=L._heif_encoder_release=$.Wf,U20=L._heif_encoder_get_name=$.Xf,M20=L._heif_encoder_set_lossy_quality=$.Yf,H20=L._heif_encoder_set_lossless=$.Zf,z20=L._heif_encoder_set_logging_level=$._f,x20=L._heif_encoder_list_parameters=$.$f,T20=L._heif_encoder_parameter_get_name=$.ag,j20=L._heif_encoder_parameter_get_type=$.bg,S20=L._heif_encoder_parameter_get_valid_integer_range=$.cg,O20=L._heif_encoder_parameter_get_valid_integer_values=$.dg,P20=L._heif_encoder_parameter_get_valid_string_values=$.eg,L20=L._heif_encoder_set_parameter_integer=$.fg,q20=L._heif_encoder_get_parameter_integer=$.gg,a20=L._heif_encoder_parameter_integer_valid_range=$.hg,K20=L._heif_encoder_set_parameter_boolean=$.ig,$20=L._heif_encoder_get_parameter_boolean=$.jg,d20=L._heif_encoder_set_parameter_string=$.kg,b20=L._heif_encoder_get_parameter_string=$.lg,c20=L._heif_encoder_parameter_string_valid_values=$.mg,i10=L._heif_encoder_parameter_integer_valid_values=$.ng,e10=L._heif_encoder_set_parameter=$.og,r10=L._heif_encoder_get_parameter=$.pg,f10=L._heif_encoder_has_default=$.qg,A10=L._heif_orientation_concat=$.rg,k10=L._heif_context_encode_image=$.sg,n10=L._heif_context_add_overlay_image=$.tg,t10=L._heif_context_set_primary_image=$.ug,o10=L._heif_context_set_major_brand=$.vg,l10=L._heif_context_add_compatible_brand=$.wg,u10=L._heif_context_set_unif=$.xg,s10=L._heif_encoder_descriptor_supportes_lossy_compression=$.yg,h10=L._heif_encoder_descriptor_supportes_lossless_compression=$.zg,w10=L._heif_context_get_encoder_descriptors=$.Ag,_10=L._heif_context_set_max_decoding_threads=$.Bg,B10=L._heif_context_get_max_decoding_threads=$.Cg,v10=L._heif_have_decoder_for_format=$.Dg,m10=L._heif_get_decoder_descriptors=$.Eg,Z10=L._heif_decoder_descriptor_get_name=$.Fg,g10=L._heif_decoder_descriptor_get_id_name=$.Gg,G10=L._heif_image_handle_get_item_id=$.Hg,W10=L._heif_image_handle_get_luma_bits_per_pixel=$.Ig,X10=L._heif_image_handle_get_chroma_bits_per_pixel=$.Jg,I10=L._heif_image_handle_get_preferred_decoding_colorspace=$.Kg,Q10=L._heif_image_handle_get_ispe_width=$.Lg,V10=L._heif_image_handle_get_ispe_height=$.Mg,p10=L._heif_image_handle_get_pixel_aspect_ratio=$.Ng,F10=L._heif_image_handle_get_context=$.Og,C10=L._heif_image_handle_get_gimi_content_id=$.Pg,Y10=L._heif_image_handle_set_gimi_content_id=$.Qg,y10=L._heif_image_handle_get_number_of_cmpd_components=$.Rg,E10=L._heif_image_handle_get_cmpd_component_type=$.Sg,R10=L._heif_image_handle_get_cmpd_component_type_uri=$.Tg,J10=L._heif_image_handle_has_gimi_component_content_ids=$.Ug,N10=L._heif_image_handle_get_gimi_component_content_id=$.Vg,D10=L._heif_image_handle_set_gimi_component_content_id=$.Wg,U10=L._heif_context_read_from_file=$.Xg,M10=L._heif_context_read_from_memory_without_copy=$.Yg,H10=L._heif_context_read_from_reader=$.Zg,z10=L._heif_context_is_top_level_image_ID=$._g,x10=L._heif_context_get_primary_image_ID=$.$g,T10=L._heif_context_debug_dump_boxes_to_file=$.ah,j10=L._heif_context_set_write_mini_format=$.bh,S10=L._heif_context_write_to_file=$.ch,O10=L._heif_context_write=$.dh,P10=L._heif_image_handle_get_image_tiling=$.eh,L10=L._heif_image_handle_get_grid_image_tile_id=$.fh,q10=L._heif_image_handle_decode_image_tile=$.gh,a10=L._heif_context_encode_grid=$.hh,K10=L._heif_context_add_grid_image=$.ih,$10=L._heif_context_add_image_tile=$.jh,d10=L._heif_image_get_number_of_used_components=$.kh,b10=L._heif_image_get_used_component_ids=$.lh,c10=L._heif_image_get_component_channel=$.mh,i40=L._heif_image_get_component_width=$.nh,e40=L._heif_image_get_component_height=$.oh,r40=L._heif_image_get_component_bits_per_pixel=$.ph,f40=L._heif_image_get_component_type=$.qh,A40=L._heif_image_get_component_datatype=$.rh,k40=L._heif_image_handle_get_number_of_components=$.sh,n40=L._heif_image_handle_get_used_component_ids=$.th,t40=L._heif_image_handle_get_component_type=$.uh,o40=L._heif_image_handle_get_component_bits_per_pixel=$.vh,l40=L._heif_image_handle_get_component_datatype=$.wh,u40=L._heif_image_add_component=$.xh,s40=L._heif_image_get_component_readonly=$.yh,h40=L._heif_image_get_component=$.zh,w40=L._heif_image_get_component_uint16_readonly=$.Ah,_40=L._heif_image_get_component_uint16=$.Bh,B40=L._heif_image_get_component_uint32_readonly=$.Ch,v40=L._heif_image_get_component_uint32=$.Dh,m40=L._heif_image_get_component_uint64_readonly=$.Eh,Z40=L._heif_image_get_component_uint64=$.Fh,g40=L._heif_image_get_component_int8_readonly=$.Gh,G40=L._heif_image_get_component_int8=$.Hh,W40=L._heif_image_get_component_int16_readonly=$.Ih,X40=L._heif_image_get_component_int16=$.Jh,I40=L._heif_image_get_component_int32_readonly=$.Kh,Q40=L._heif_image_get_component_int32=$.Lh,V40=L._heif_image_get_component_int64_readonly=$.Mh,p40=L._heif_image_get_component_int64=$.Nh,F40=L._heif_image_get_component_float32_readonly=$.Oh,C40=L._heif_image_get_component_float32=$.Ph,Y40=L._heif_image_get_component_float64_readonly=$.Qh,y40=L._heif_image_get_component_float64=$.Rh,E40=L._heif_image_get_component_complex32_readonly=$.Sh,R40=L._heif_image_get_component_complex32=$.Th,J40=L._heif_image_get_component_complex64_readonly=$.Uh,N40=L._heif_image_get_component_complex64=$.Vh,D40=L._heif_image_set_gimi_component_content_id=$.Wh,U40=L._heif_unci_image_parameters_alloc=$.Xh,M40=L._heif_unci_image_parameters_copy=$.Yh,H40=L._heif_unci_image_parameters_release=$.Zh,z40=L._heif_context_add_empty_unci_image=$._h,x40=L._heif_image_handle_add_text_item=$.$h,T40=L._heif_text_item_release=$.ai,j40=L._heif_image_handle_get_number_of_text_items=$.bi,S40=L._heif_image_handle_get_list_of_text_item_ids=$.ci,O40=L._heif_context_get_text_item=$.di,P40=L._heif_text_item_get_id=$.ei,L40=L._heif_text_item_get_content=$.fi,q40=L._heif_text_item_get_property_extended_language=$.gi,a40=L._heif_text_item_set_extended_language=$.hi,K40=L._heif_image_handle_get_omaf_image_projection=$.ii,$40=L._heif_image_handle_set_omaf_image_projection=$.ji,d40=L._heif_image_get_omaf_image_projection=$.ki,b40=L._heif_image_set_omaf_image_projection=$.li,c40=L._de265_new_decoder=$.mi,i80=L._de265_set_parameter_bool=$.ni,e80=L._de265_get_version=$.oi,r80=L._de265_init=$.pi,f80=L._de265_free=$.qi,A80=L._de265_free_decoder=$.ri,k80=L._de265_push_NAL=$.si,n80=L._de265_flush_data=$.ti,t80=L._de265_decode=$.ui,o80=L._de265_get_next_picture=$.vi,l80=L._de265_get_image_user_data=$.wi,u80=L._de265_get_chroma_format=$.xi,s80=L._de265_get_image_width=$.yi,h80=L._de265_get_image_height=$.zi,w80=L._de265_get_bits_per_pixel=$.Ai,_80=L._de265_get_image_plane=$.Bi,B80=L._de265_get_image_colour_primaries=$.Ci,v80=L._de265_get_image_transfer_characteristics=$.Di,m80=L._de265_get_image_matrix_coefficients=$.Ei,Z80=L._de265_get_image_full_range_flag=$.Fi,g80=L._de265_release_next_picture=$.Gi,NB=$.Hi,G80=L._memcpy=$.Ii,W80=L.dynCall_ji=$.Ji,X80=L.dynCall_iij=$.Ki,I80=L.dynCall_jijj=$.Li,Q80=L.dynCall_vijj=$.Mi,V80=L.dynCall_jiji=$.Ni,p80=L.dynCall_viijii=$.Oi,F80=L.dynCall_iiiiij=$.Pi,C80=L.dynCall_iiiiijj=$.Qi,Y80=L.dynCall_iiiiiijj=$.Ri,y80=L._heif_error_null_pointer_argument=100580,E80=L._heif_error_success=102712,R80=L._heif_error_ok=103144,J80=L._heif_error_invalid_parameter_value=103168,N80=L._heif_error_unsupported_parameter=103156;function $f(){if(z6>0){he=$f;return}if(yw(),z6>0){he=$f;return}function J(){var H;L.calledRun=!0,!zk&&(Ew(),U6(L),(H=L.onRuntimeInitialized)==null||H.call(L),Rw())}L.setStatus?(L.setStatus("Running..."),setTimeout(()=>{setTimeout(()=>L.setStatus(""),1),J()},1)):J()}function DB(){if(L.preInit)for(typeof L.preInit=="function"&&(L.preInit=[L.preInit]);L.preInit.length>0;)L.preInit.shift()()}DB(),$f();function _9(J){for(var H=new ArrayBuffer(J.length),P=new Uint8Array(H),K=0,e0=J.length;K<e0;K++)P[K]=J.charCodeAt(K);return H}var N8=function(J){this.handle=J,this.img=null};N8.prototype.free=function(){this.handle&&(L.heif_image_handle_release(this.handle),this.handle=null)},N8.prototype._ensureImage=function(){if(!this.img){var J=L.heif_js_decode_image(this.handle,L.heif_colorspace.heif_colorspace_YCbCr,L.heif_chroma.heif_chroma_420);if(!J||J.code){console.log("Decoding image failed",this.handle,J);return}this.data=new Uint8Array(_9(J.data)),delete J.data,this.img=J,J.alpha!==void 0&&(this.alpha=new Uint8Array(_9(J.alpha)),delete J.alpha)}},N8.prototype.get_width=function(){return L.heif_image_handle_get_width(this.handle)},N8.prototype.get_height=function(){return L.heif_image_handle_get_height(this.handle)},N8.prototype.is_primary=function(){return!!L.heif_image_handle_is_primary_image(this.handle)},N8.prototype.has_alpha_channel=function(){return!!L.heif_image_handle_has_alpha_channel(this.handle)},N8.prototype.is_premultiplied_alpha=function(){return!!L.heif_image_handle_is_premultiplied_alpha(this.handle)},N8.prototype.display=function(J,H){var P=this.get_width(),K=this.get_height();setTimeout(function(){return D6(this,null,function*(){if(!this.img){var e0=yield L.heif_js_decode_image2(this.handle,L.heif_colorspace.heif_colorspace_RGB,L.heif_chroma.heif_chroma_interleaved_RGBA);if(!e0||e0.code){console.log("Decoding image failed",this.handle,e0),H(null);return}for(let b of e0.channels)if(b.id==L.heif_channel.heif_channel_interleaved)if(b.stride==b.width*4)J.data.set(b.data);else for(let v0=0;v0<b.height;v0++){let W0=b.data.slice(v0*b.stride,v0*b.stride+b.width*4),m0=v0*b.width*4;J.data.set(W0,m0)}L.heif_image_release(e0.image)}H(J)})}.bind(this),0)};var B9=function(){this.decoder=null};B9.prototype.decode=function(J){if(this.decoder&&L.heif_context_free(this.decoder),this.decoder=L.heif_context_alloc(),!this.decoder)return console.log("Could not create HEIF context"),[];var H=L.heif_context_read_from_memory(this.decoder,J);if(H.code!==L.heif_error_code.heif_error_Ok)return console.log("Could not parse HEIF file",H.message),[];var P=L.heif_js_context_get_list_of_top_level_image_IDs(this.decoder);if(!P||P.code)return console.log("Error loading image ids",P),[];if(!P.length)return console.log("No images found"),[];for(var K=[],e0=0;e0<P.length;e0++){var b=L.heif_js_context_get_image_handle(this.decoder,P[e0]);if(!b||b.code){console.log("Could not get image data for id",P[e0],b);continue}K.push(new N8(b))}return K};var UB=function(J){return J.charCodeAt(0)<<24|J.charCodeAt(1)<<16|J.charCodeAt(2)<<8|J.charCodeAt(3)};L.HeifImage=N8,L.HeifDecoder=B9,L.fourcc=UB;let MB=["heif_error_code","heif_suberror_code","heif_compression_format","heif_chroma","heif_colorspace","heif_channel"];for(let J of MB)for(let H in L[J])!L[J].hasOwnProperty(H)||H==="values"||(L[H]=L[J][H]);for(let J in L)J.indexOf("_heif_")!==0||L[J.slice(1)]!==void 0||(L[J.slice(1)]=L[J]);return _8=L,_8})})(),Qw=FK});var YK=pK(Mk=>{Vw();var pw=Qw(),CK=H1=>D6(null,null,function*(){let I1,D1;try{if(I1=new pw.HeifDecoder,D1=I1.decode(H1),!D1.length)throw new Error("HEIF image not found");let _8=D1[0],L=_8.get_width(),U6=_8.get_height(),M6=new ImageData(L,U6);for(let x4=0;x4<L*U6;x4++)M6.data[x4*4+3]=255;return yield new Promise((x4,E8)=>{_8.display(M6,H6=>{if(!H6)return E8(new Error("HEIF processing error"));x4(H6)})})}finally{if(D1&&D1.length)for(let _8=0;_8<D1.length;_8++)D1[_8].free();I1&&I1.decoder&&pw.heif_context_free(I1.decoder)}});onmessage=H1=>D6(null,null,function*(){let I1=H1.data.id;try{let D1=yield CK(H1.data.buffer);postMessage({id:I1,imageData:D1,error:""})}catch(D1){postMessage({id:I1,imageData:null,error:D1&&D1.toString?D1.toString():D1})}})});YK();})();\n', t = new Blob([
            r
        ], {
            type: "application/javascript"
        });
        $dec4823f049ade19$var$i = new Worker(URL.createObjectURL(t)), $dec4823f049ade19$var$i.onerror = (e)=>console.error("Worker error:", e);
    }
    return $dec4823f049ade19$var$i;
}, $dec4823f049ade19$var$m = (r)=>$dec4823f049ade19$var$d(null, null, function*() {
        return new Promise((t, e)=>{
            $dec4823f049ade19$var$g();
            let c = (Math.random() * new Date().getTime()).toString(), f = {
                id: c,
                buffer: r
            };
            $dec4823f049ade19$var$i.postMessage(f);
            let o = (a)=>{
                if (a.data.id === c) return a.currentTarget.removeEventListener("message", o), a.currentTarget.removeEventListener("error", n), a.data.error ? e(a.data.error) : t(a.data.imageData);
            }, n = (a)=>(a.currentTarget.removeEventListener("message", o), a.currentTarget.removeEventListener("error", n), e(a.data));
            $dec4823f049ade19$var$i.addEventListener("message", o), $dec4823f049ade19$var$i.addEventListener("error", n);
        });
    }), $dec4823f049ade19$var$l = (r)=>$dec4823f049ade19$var$d(null, null, function*() {
        let t = yield $dec4823f049ade19$var$m(r), e = document.createElement("canvas");
        return e.width = t.width, e.height = t.height, e.getContext("2d").putImageData(t, 0, 0), e;
    }), $dec4823f049ade19$var$w = (r)=>{
    r.width = 1, r.height = 1;
    let t = r.getContext("2d");
    t && t.clearRect(0, 0, 1, 1);
}, $dec4823f049ade19$export$abdd76339270e372 = (f)=>$dec4823f049ade19$var$d(null, [
        f
    ], function*({ blob: r, type: t, quality: e, options: c }) {
        if (t == "bitmap") {
            let o = yield r.arrayBuffer(), n = yield $dec4823f049ade19$var$m(o);
            return createImageBitmap(n, c);
        } else {
            let o = yield r.arrayBuffer(), n;
            try {
                return n = yield $dec4823f049ade19$var$l(o), yield new Promise((a, s)=>n.toBlob((u)=>{
                        u != null ? a(u) : s("Can't convert canvas to blob.");
                    }, t, e));
            } finally{
                n && $dec4823f049ade19$var$w(n);
            }
        }
    });


var $5ce5aeca99e3b2a2$require$heicTo = $dec4823f049ade19$export$abdd76339270e372;
const $5ce5aeca99e3b2a2$var$FilePreviewMediaPort = {
    add: function(app) {
        const layoutObserver = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const requestId = entry.target.getAttribute("data-fp-request-id");
                if (!requestId || !app.ports.previewLayoutSized) continue;
                const cr = entry.contentRect;
                app.ports.previewLayoutSized.send({
                    requestId: requestId,
                    width: cr.width,
                    height: cr.height
                });
            }
        });
        const observedLayoutElements = new Map();
        if (app.ports.convertHeicFromUrl) app.ports.convertHeicFromUrl.subscribe(async ({ requestId: requestId, url: url })=>{
            try {
                const res = await fetch(url);
                if (!res.ok) throw new Error("fetch failed");
                const blob = await res.blob();
                const outBlob = await $5ce5aeca99e3b2a2$require$heicTo({
                    blob: blob,
                    type: "image/jpeg",
                    quality: 0.9
                });
                const objectUrl = URL.createObjectURL(outBlob);
                app.ports.heicPreviewResult.send({
                    requestId: requestId,
                    url: objectUrl
                });
            } catch  {
                app.ports.heicPreviewResult.send({
                    requestId: requestId,
                    url: null
                });
            }
        });
        if (app.ports.observePreviewLayout) app.ports.observePreviewLayout.subscribe(({ elementId: elementId, requestId: requestId })=>{
            const el = document.getElementById(elementId);
            if (!el) return;
            const prev = observedLayoutElements.get(elementId);
            if (prev) layoutObserver.unobserve(prev);
            el.setAttribute("data-fp-request-id", requestId);
            layoutObserver.observe(el);
            observedLayoutElements.set(elementId, el);
            const r = el.getBoundingClientRect();
            if (app.ports.previewLayoutSized) app.ports.previewLayoutSized.send({
                requestId: requestId,
                width: r.width,
                height: r.height
            });
        });
        if (app.ports.revokePreviewObjectUrl) app.ports.revokePreviewObjectUrl.subscribe((u)=>{
            try {
                if (u && String(u).startsWith("blob:")) URL.revokeObjectURL(u);
            } catch  {}
        });
        if (app.ports.mediaPlay) app.ports.mediaPlay.subscribe(({ elementId: elementId })=>{
            const el = document.getElementById(elementId);
            if (el && (el.tagName === "AUDIO" || el.tagName === "VIDEO")) el.play().catch(()=>{});
        });
        if (app.ports.mediaTogglePlayPause) app.ports.mediaTogglePlayPause.subscribe(({ elementId: elementId })=>{
            const el = document.getElementById(elementId);
            if (!el || el.tagName !== "AUDIO" && el.tagName !== "VIDEO") return;
            if (el.paused) el.play().catch(()=>{});
            else el.pause();
        });
        if (app.ports.mediaSetCurrentTime) app.ports.mediaSetCurrentTime.subscribe(({ elementId: elementId, seconds: seconds })=>{
            const el = document.getElementById(elementId);
            if (!el || el.tagName !== "AUDIO") return;
            const t = Number.isFinite(seconds) ? seconds : 0;
            el.currentTime = Math.max(0, t);
        });
        if (app.ports.videoSeekPreview) app.ports.videoSeekPreview.subscribe(({ videoElementId: videoElementId })=>{
            const v = document.getElementById(videoElementId);
            if (!v || v.tagName !== "VIDEO") return;
            const run = ()=>{
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        const d = v.duration;
                        if (d && !Number.isNaN(d) && d > 0) {
                            const t = Math.min(0.5, d * 0.1);
                            v.currentTime = t > 0 ? t : 0;
                        }
                    });
                });
            };
            if (v.readyState >= 1 && Number.isFinite(v.duration) && v.duration > 0) run();
            else v.addEventListener("loadedmetadata", run, {
                once: true
            });
        });
        return function cleanup() {
            observedLayoutElements.forEach((element)=>{
                layoutObserver.unobserve(element);
            });
            observedLayoutElements.clear();
            layoutObserver.disconnect();
        };
    }
};
$5ce5aeca99e3b2a2$exports = $5ce5aeca99e3b2a2$var$FilePreviewMediaPort;


var $73cbf435bf470aed$exports = {};
var $7d7fd9061cffbcaa$export$7b82ddf1ba8788ff;
var $7d7fd9061cffbcaa$export$16c74263c98473fb;
var $7d7fd9061cffbcaa$export$9c68d69a4c5bbcf9;
var $7d7fd9061cffbcaa$export$a1ba744cb18565b5;
var $7d7fd9061cffbcaa$export$6c746a5570b8b35c;
var $7d7fd9061cffbcaa$export$63e4f03d302d3e40;
var $7d7fd9061cffbcaa$export$425327af25286e5e;
var $7d7fd9061cffbcaa$export$7d85d7e73199d20c;
var $7d7fd9061cffbcaa$export$3d6d846391b5780c;
var $7d7fd9061cffbcaa$export$65b53a1b2f72fd4c;

var $7d7fd9061cffbcaa$require$Buffer = $91236539d1047655$export$a143d493d941bafc;
parcelRequire("eSbtG");
var $1kSpe = parcelRequire("1kSpe");
var $76ae973f152dcbe2$export$aafa59e2e03f2942;
var $76ae973f152dcbe2$export$2404ec9a8c74f37d;
$76ae973f152dcbe2$export$aafa59e2e03f2942 = $76ae973f152dcbe2$var$read;
$76ae973f152dcbe2$export$2404ec9a8c74f37d = $76ae973f152dcbe2$var$findPartPaths;

var $lUVKW = parcelRequire("lUVKW");
var $9a19f07fe6a873fd$export$b14ad400b1d09e0f;
var $9a19f07fe6a873fd$export$5a7bfc01df82fcd1;
var $9a19f07fe6a873fd$export$b34a105447964f9f;
var $9a19f07fe6a873fd$export$9c206ddddb32a9b;
var $9a19f07fe6a873fd$export$358a232cca1ab2ac;
var $9a19f07fe6a873fd$export$889ea624f2cb2c57;
var $9a19f07fe6a873fd$export$ddae37e51c7979e2;
var $9a19f07fe6a873fd$export$6f093cfa640b7166;
var $9a19f07fe6a873fd$export$5f1af8db9871e1d6;
var $9a19f07fe6a873fd$export$62d58b1c91e8e902;
var $9a19f07fe6a873fd$export$3e41faf802a29e71;
var $9a19f07fe6a873fd$export$b07e517d22efa1ca;
var $9a19f07fe6a873fd$export$48513f6b9f8ce62d;
var $9a19f07fe6a873fd$export$de48447bf377cd47;
var $9a19f07fe6a873fd$export$bc6e927f6446fee8;
var $9a19f07fe6a873fd$export$e67f182a50c27e10;
var $9a19f07fe6a873fd$export$aa31b211d2f4c3af;
var $9a19f07fe6a873fd$export$6c88bf799aca3d2b;
var $9a19f07fe6a873fd$export$841d4c6db70c1a65;
var $9a19f07fe6a873fd$export$4a34f930e789283c;
var $9a19f07fe6a873fd$export$3e431a229df88919;
var $9a19f07fe6a873fd$export$54ec01a60f47d33d;
var $9a19f07fe6a873fd$export$b05581f4e764e162;
var $9a19f07fe6a873fd$export$1e4baea7053fc0e3;
var $9a19f07fe6a873fd$export$a1aa2dd4ad0d3f6;
var $9a19f07fe6a873fd$export$1b438cdd7ed26c35;
var $9a19f07fe6a873fd$export$5a38f5b463e49b91;
var $9a19f07fe6a873fd$export$ad0c5cb04e0f1440;
var $9a19f07fe6a873fd$export$983b95e2e3722091;

var $9a19f07fe6a873fd$require$Buffer = $91236539d1047655$export$a143d493d941bafc;
parcelRequire("eSbtG");
var $6BxOE = parcelRequire("6BxOE");
var $9a19f07fe6a873fd$var$types = $9a19f07fe6a873fd$export$b14ad400b1d09e0f = {
    document: "document",
    paragraph: "paragraph",
    run: "run",
    text: "text",
    tab: "tab",
    checkbox: "checkbox",
    hyperlink: "hyperlink",
    noteReference: "noteReference",
    image: "image",
    note: "note",
    commentReference: "commentReference",
    comment: "comment",
    table: "table",
    tableRow: "tableRow",
    tableCell: "tableCell",
    "break": "break",
    bookmarkStart: "bookmarkStart"
};
function $9a19f07fe6a873fd$var$Document(children, options) {
    options = options || {};
    return {
        type: $9a19f07fe6a873fd$var$types.document,
        children: children,
        notes: options.notes || new $9a19f07fe6a873fd$var$Notes({}),
        comments: options.comments || []
    };
}
function $9a19f07fe6a873fd$var$Paragraph(children, properties) {
    properties = properties || {};
    var indent = properties.indent || {};
    return {
        type: $9a19f07fe6a873fd$var$types.paragraph,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null,
        numbering: properties.numbering || null,
        alignment: properties.alignment || null,
        indent: {
            start: indent.start || null,
            end: indent.end || null,
            firstLine: indent.firstLine || null,
            hanging: indent.hanging || null
        }
    };
}
function $9a19f07fe6a873fd$var$Run(children, properties) {
    properties = properties || {};
    return {
        type: $9a19f07fe6a873fd$var$types.run,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null,
        isBold: !!properties.isBold,
        isUnderline: !!properties.isUnderline,
        isItalic: !!properties.isItalic,
        isStrikethrough: !!properties.isStrikethrough,
        isAllCaps: !!properties.isAllCaps,
        isSmallCaps: !!properties.isSmallCaps,
        verticalAlignment: properties.verticalAlignment || $9a19f07fe6a873fd$var$verticalAlignment.baseline,
        font: properties.font || null,
        fontSize: properties.fontSize || null,
        highlight: properties.highlight || null
    };
}
var $9a19f07fe6a873fd$var$verticalAlignment = {
    baseline: "baseline",
    superscript: "superscript",
    subscript: "subscript"
};
function $9a19f07fe6a873fd$var$Text(value) {
    return {
        type: $9a19f07fe6a873fd$var$types.text,
        value: value
    };
}
function $9a19f07fe6a873fd$var$Tab() {
    return {
        type: $9a19f07fe6a873fd$var$types.tab
    };
}
function $9a19f07fe6a873fd$var$Checkbox(options) {
    return {
        type: $9a19f07fe6a873fd$var$types.checkbox,
        checked: options.checked
    };
}
function $9a19f07fe6a873fd$var$Hyperlink(children, options) {
    return {
        type: $9a19f07fe6a873fd$var$types.hyperlink,
        children: children,
        href: options.href,
        anchor: options.anchor,
        targetFrame: options.targetFrame
    };
}
function $9a19f07fe6a873fd$var$NoteReference(options) {
    return {
        type: $9a19f07fe6a873fd$var$types.noteReference,
        noteType: options.noteType,
        noteId: options.noteId
    };
}
function $9a19f07fe6a873fd$var$Notes(notes) {
    this._notes = $6BxOE.default(notes, function(note) {
        return $9a19f07fe6a873fd$var$noteKey(note.noteType, note.noteId);
    });
}
$9a19f07fe6a873fd$var$Notes.prototype.resolve = function(reference) {
    return this.findNoteByKey($9a19f07fe6a873fd$var$noteKey(reference.noteType, reference.noteId));
};
$9a19f07fe6a873fd$var$Notes.prototype.findNoteByKey = function(key) {
    return this._notes[key] || null;
};
function $9a19f07fe6a873fd$var$Note(options) {
    return {
        type: $9a19f07fe6a873fd$var$types.note,
        noteType: options.noteType,
        noteId: options.noteId,
        body: options.body
    };
}
function $9a19f07fe6a873fd$var$commentReference(options) {
    return {
        type: $9a19f07fe6a873fd$var$types.commentReference,
        commentId: options.commentId
    };
}
function $9a19f07fe6a873fd$var$comment(options) {
    return {
        type: $9a19f07fe6a873fd$var$types.comment,
        commentId: options.commentId,
        body: options.body,
        authorName: options.authorName,
        authorInitials: options.authorInitials
    };
}
function $9a19f07fe6a873fd$var$noteKey(noteType, id) {
    return noteType + "-" + id;
}
function $9a19f07fe6a873fd$var$Image(options) {
    return {
        type: $9a19f07fe6a873fd$var$types.image,
        // `read` is retained for backwards compatibility, but other read
        // methods should be preferred.
        read: function(encoding) {
            if (encoding) return options.readImage(encoding);
            else return options.readImage().then(function(arrayBuffer) {
                return $9a19f07fe6a873fd$require$Buffer.from(arrayBuffer);
            });
        },
        readAsArrayBuffer: function() {
            return options.readImage();
        },
        readAsBase64String: function() {
            return options.readImage("base64");
        },
        readAsBuffer: function() {
            return options.readImage().then(function(arrayBuffer) {
                return $9a19f07fe6a873fd$require$Buffer.from(arrayBuffer);
            });
        },
        altText: options.altText,
        contentType: options.contentType
    };
}
function $9a19f07fe6a873fd$var$Table(children, properties) {
    properties = properties || {};
    return {
        type: $9a19f07fe6a873fd$var$types.table,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null
    };
}
function $9a19f07fe6a873fd$var$TableRow(children, options) {
    options = options || {};
    return {
        type: $9a19f07fe6a873fd$var$types.tableRow,
        children: children,
        isHeader: options.isHeader || false
    };
}
function $9a19f07fe6a873fd$var$TableCell(children, options) {
    options = options || {};
    return {
        type: $9a19f07fe6a873fd$var$types.tableCell,
        children: children,
        colSpan: options.colSpan == null ? 1 : options.colSpan,
        rowSpan: options.rowSpan == null ? 1 : options.rowSpan
    };
}
function $9a19f07fe6a873fd$var$Break(breakType) {
    return {
        type: $9a19f07fe6a873fd$var$types["break"],
        breakType: breakType
    };
}
function $9a19f07fe6a873fd$var$BookmarkStart(options) {
    return {
        type: $9a19f07fe6a873fd$var$types.bookmarkStart,
        name: options.name
    };
}
$9a19f07fe6a873fd$export$5a7bfc01df82fcd1 = $9a19f07fe6a873fd$export$b34a105447964f9f = $9a19f07fe6a873fd$var$Document;
$9a19f07fe6a873fd$export$9c206ddddb32a9b = $9a19f07fe6a873fd$export$358a232cca1ab2ac = $9a19f07fe6a873fd$var$Paragraph;
$9a19f07fe6a873fd$export$889ea624f2cb2c57 = $9a19f07fe6a873fd$export$ddae37e51c7979e2 = $9a19f07fe6a873fd$var$Run;
$9a19f07fe6a873fd$export$6f093cfa640b7166 = $9a19f07fe6a873fd$export$5f1af8db9871e1d6 = $9a19f07fe6a873fd$var$Text;
$9a19f07fe6a873fd$export$62d58b1c91e8e902 = $9a19f07fe6a873fd$export$3e41faf802a29e71 = $9a19f07fe6a873fd$var$Tab;
$9a19f07fe6a873fd$export$b07e517d22efa1ca = $9a19f07fe6a873fd$export$48513f6b9f8ce62d = $9a19f07fe6a873fd$var$Checkbox;
$9a19f07fe6a873fd$export$de48447bf377cd47 = $9a19f07fe6a873fd$var$Hyperlink;
$9a19f07fe6a873fd$export$bc6e927f6446fee8 = $9a19f07fe6a873fd$export$e67f182a50c27e10 = $9a19f07fe6a873fd$var$NoteReference;
$9a19f07fe6a873fd$export$aa31b211d2f4c3af = $9a19f07fe6a873fd$var$Notes;
$9a19f07fe6a873fd$export$6c88bf799aca3d2b = $9a19f07fe6a873fd$var$Note;
$9a19f07fe6a873fd$export$841d4c6db70c1a65 = $9a19f07fe6a873fd$var$commentReference;
$9a19f07fe6a873fd$export$4a34f930e789283c = $9a19f07fe6a873fd$var$comment;
$9a19f07fe6a873fd$export$3e431a229df88919 = $9a19f07fe6a873fd$var$Image;
$9a19f07fe6a873fd$export$54ec01a60f47d33d = $9a19f07fe6a873fd$var$Table;
$9a19f07fe6a873fd$export$b05581f4e764e162 = $9a19f07fe6a873fd$var$TableRow;
$9a19f07fe6a873fd$export$1e4baea7053fc0e3 = $9a19f07fe6a873fd$var$TableCell;
$9a19f07fe6a873fd$export$a1aa2dd4ad0d3f6 = $9a19f07fe6a873fd$var$Break("line");
$9a19f07fe6a873fd$export$1b438cdd7ed26c35 = $9a19f07fe6a873fd$var$Break("page");
$9a19f07fe6a873fd$export$5a38f5b463e49b91 = $9a19f07fe6a873fd$var$Break("column");
$9a19f07fe6a873fd$export$ad0c5cb04e0f1440 = $9a19f07fe6a873fd$var$BookmarkStart;
$9a19f07fe6a873fd$export$983b95e2e3722091 = $9a19f07fe6a873fd$var$verticalAlignment;


var $b398cbdc7abf8f61$export$8fdcabde73f49165;
var $b398cbdc7abf8f61$export$fe7c49d056ea1d88;
var $b398cbdc7abf8f61$export$491112666e282270;
var $b398cbdc7abf8f61$export$a3bc9b8ed74fc;
parcelRequire("eSbtG");
var $6dYu1 = parcelRequire("6dYu1");
var $3CMFi = parcelRequire("3CMFi");
var $6yCKd = parcelRequire("6yCKd");
$b398cbdc7abf8f61$export$8fdcabde73f49165 = $b398cbdc7abf8f61$var$Result;
$b398cbdc7abf8f61$export$fe7c49d056ea1d88 = $b398cbdc7abf8f61$var$success;
$b398cbdc7abf8f61$export$491112666e282270 = $b398cbdc7abf8f61$var$warning;
$b398cbdc7abf8f61$export$a3bc9b8ed74fc = $b398cbdc7abf8f61$var$error;
function $b398cbdc7abf8f61$var$Result(value, messages) {
    this.value = value;
    this.messages = messages || [];
}
$b398cbdc7abf8f61$var$Result.prototype.map = function(func) {
    return new $b398cbdc7abf8f61$var$Result(func(this.value), this.messages);
};
$b398cbdc7abf8f61$var$Result.prototype.flatMap = function(func) {
    var funcResult = func(this.value);
    return new $b398cbdc7abf8f61$var$Result(funcResult.value, $b398cbdc7abf8f61$var$combineMessages([
        this,
        funcResult
    ]));
};
$b398cbdc7abf8f61$var$Result.prototype.flatMapThen = function(func) {
    var that = this;
    return func(this.value).then(function(otherResult) {
        return new $b398cbdc7abf8f61$var$Result(otherResult.value, $b398cbdc7abf8f61$var$combineMessages([
            that,
            otherResult
        ]));
    });
};
$b398cbdc7abf8f61$var$Result.combine = function(results) {
    var values = $3CMFi.default($6yCKd.default(results, "value"));
    var messages = $b398cbdc7abf8f61$var$combineMessages(results);
    return new $b398cbdc7abf8f61$var$Result(values, messages);
};
function $b398cbdc7abf8f61$var$success(value) {
    return new $b398cbdc7abf8f61$var$Result(value, []);
}
function $b398cbdc7abf8f61$var$warning(message) {
    return {
        type: "warning",
        message: message
    };
}
function $b398cbdc7abf8f61$var$error(exception) {
    return {
        type: "error",
        message: exception.message,
        error: exception
    };
}
function $b398cbdc7abf8f61$var$combineMessages(results) {
    var messages = [];
    $3CMFi.default($6yCKd.default(results, "messages"), true).forEach(function(message) {
        if (!$b398cbdc7abf8f61$var$containsMessage(messages, message)) messages.push(message);
    });
    return messages;
}
function $b398cbdc7abf8f61$var$containsMessage(messages, message) {
    return $6dYu1.default(messages, $b398cbdc7abf8f61$var$isSameMessage.bind(null, message)) !== undefined;
}
function $b398cbdc7abf8f61$var$isSameMessage(first, second) {
    return first.type === second.type && first.message === second.message;
}


var $76ae973f152dcbe2$require$Result = $b398cbdc7abf8f61$export$8fdcabde73f49165;
var $57cf05b5ae854a60$export$94ea64f322e5a37c;
var $57cf05b5ae854a60$export$824c337f43f2b64d;
var $57cf05b5ae854a60$export$b891921babc70093;

var $91b6f2b1090171cd$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $91b6f2b1090171cd$require$Buffer = $91236539d1047655$export$a143d493d941bafc;

var $jBmpJ = parcelRequire("jBmpJ");
!function(e) {
    $91b6f2b1090171cd$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $91b6f2b1090171cd$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($91b6f2b1090171cd$require$Buffer.from && $91b6f2b1090171cd$require$Buffer.from !== Uint8Array.from) return $91b6f2b1090171cd$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $91b6f2b1090171cd$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($91b6f2b1090171cd$require$Buffer.alloc) return $91b6f2b1090171cd$require$Buffer.alloc(e);
                        var t = new $91b6f2b1090171cd$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $91b6f2b1090171cd$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $91b6f2b1090171cd$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $91b6f2b1090171cd$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $jBmpJ.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});


$57cf05b5ae854a60$export$94ea64f322e5a37c = $57cf05b5ae854a60$var$openArrayBuffer;
$57cf05b5ae854a60$export$824c337f43f2b64d = $57cf05b5ae854a60$var$splitPath;
$57cf05b5ae854a60$export$b891921babc70093 = $57cf05b5ae854a60$var$joinPath;
function $57cf05b5ae854a60$var$openArrayBuffer(arrayBuffer) {
    return $91b6f2b1090171cd$exports.loadAsync(arrayBuffer).then(function(zipFile) {
        function exists(name) {
            return zipFile.file(name) !== null;
        }
        function read(name, encoding) {
            return zipFile.file(name).async("uint8array").then(function(array) {
                if (encoding === "base64") return $663230c064b646de$export$6100ba28696e12de(array);
                else if (encoding) {
                    var decoder = new TextDecoder(encoding);
                    return decoder.decode(array);
                } else return array;
            });
        }
        function write(name, contents) {
            zipFile.file(name, contents);
        }
        function toArrayBuffer() {
            return zipFile.generateAsync({
                type: "arraybuffer"
            });
        }
        return {
            exists: exists,
            read: read,
            write: write,
            toArrayBuffer: toArrayBuffer
        };
    });
}
function $57cf05b5ae854a60$var$splitPath(path) {
    var lastIndex = path.lastIndexOf("/");
    if (lastIndex === -1) return {
        dirname: "",
        basename: path
    };
    else return {
        dirname: path.substring(0, lastIndex),
        basename: path.substring(lastIndex + 1)
    };
}
function $57cf05b5ae854a60$var$joinPath() {
    var nonEmptyPaths = Array.prototype.filter.call(arguments, function(path) {
        return path;
    });
    var relevantPaths = [];
    nonEmptyPaths.forEach(function(path) {
        if (/^\//.test(path)) relevantPaths = [
            path
        ];
        else relevantPaths.push(path);
    });
    return relevantPaths.join("/");
}


var $117e9d448ca1bac0$export$aafa59e2e03f2942;
var $117e9d448ca1bac0$export$27eef0075cdf2763;
parcelRequire("eSbtG");
var $3CMFi = parcelRequire("3CMFi");

var $lUVKW = parcelRequire("lUVKW");
var $0743bccdd00b5f6b$export$db77ccec0bb4ccac;
var $0743bccdd00b5f6b$export$8454457683f90105;
var $0743bccdd00b5f6b$export$ae6de35c16b306df;
var $0743bccdd00b5f6b$export$6f093cfa640b7166;
var $0743bccdd00b5f6b$export$dda73877cb166cd3;
var $0743bccdd00b5f6b$export$48a3ce3d8cfe0ce1;

var $cCCVy = parcelRequire("cCCVy");
$0743bccdd00b5f6b$export$db77ccec0bb4ccac = $cCCVy.Element;
$0743bccdd00b5f6b$export$8454457683f90105 = $cCCVy.element;
$0743bccdd00b5f6b$export$ae6de35c16b306df = $cCCVy.emptyElement;
$0743bccdd00b5f6b$export$6f093cfa640b7166 = $cCCVy.text;

$0743bccdd00b5f6b$export$dda73877cb166cd3 = (parcelRequire("huomN")).readString;

$0743bccdd00b5f6b$export$48a3ce3d8cfe0ce1 = (parcelRequire("83iSM")).writeString;


$117e9d448ca1bac0$export$aafa59e2e03f2942 = $117e9d448ca1bac0$var$read;
$117e9d448ca1bac0$export$27eef0075cdf2763 = $117e9d448ca1bac0$var$readXmlFromZipFile;
var $117e9d448ca1bac0$var$xmlNamespaceMap = {
    // Transitional format
    "http://schemas.openxmlformats.org/wordprocessingml/2006/main": "w",
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships": "r",
    "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing": "wp",
    "http://schemas.openxmlformats.org/drawingml/2006/main": "a",
    "http://schemas.openxmlformats.org/drawingml/2006/picture": "pic",
    // Strict format
    "http://purl.oclc.org/ooxml/wordprocessingml/main": "w",
    "http://purl.oclc.org/ooxml/officeDocument/relationships": "r",
    "http://purl.oclc.org/ooxml/drawingml/wordprocessingDrawing": "wp",
    "http://purl.oclc.org/ooxml/drawingml/main": "a",
    "http://purl.oclc.org/ooxml/drawingml/picture": "pic",
    // Common
    "http://schemas.openxmlformats.org/package/2006/content-types": "content-types",
    "http://schemas.openxmlformats.org/package/2006/relationships": "relationships",
    "http://schemas.openxmlformats.org/markup-compatibility/2006": "mc",
    "urn:schemas-microsoft-com:vml": "v",
    "urn:schemas-microsoft-com:office:word": "office-word",
    // [MS-DOCX]: Word Extensions to the Office Open XML (.docx) File Format
    // https://learn.microsoft.com/en-us/openspecs/office_standards/ms-docx/b839fe1f-e1ca-4fa6-8c26-5954d0abbccd
    "http://schemas.microsoft.com/office/word/2010/wordml": "wordml"
};
function $117e9d448ca1bac0$var$read(xmlString) {
    return $0743bccdd00b5f6b$export$dda73877cb166cd3(xmlString, $117e9d448ca1bac0$var$xmlNamespaceMap).then(function(document) {
        return $117e9d448ca1bac0$var$collapseAlternateContent(document)[0];
    });
}
function $117e9d448ca1bac0$var$readXmlFromZipFile(docxFile, path) {
    if (docxFile.exists(path)) return docxFile.read(path, "utf-8").then($117e9d448ca1bac0$var$stripUtf8Bom).then($117e9d448ca1bac0$var$read);
    else return $lUVKW.resolve(null);
}
function $117e9d448ca1bac0$var$stripUtf8Bom(xmlString) {
    return xmlString.replace(/^\uFEFF/g, '');
}
function $117e9d448ca1bac0$var$collapseAlternateContent(node) {
    if (node.type === "element") {
        if (node.name === "mc:AlternateContent") return node.firstOrEmpty("mc:Fallback").children;
        else {
            node.children = $3CMFi.default(node.children.map($117e9d448ca1bac0$var$collapseAlternateContent, true));
            return [
                node
            ];
        }
    } else return [
        node
    ];
}


var $76ae973f152dcbe2$require$readXmlFromZipFile = $117e9d448ca1bac0$export$27eef0075cdf2763;
var $038979b6796d9af0$export$ca2bb6f0ea38a00f;
var $038979b6796d9af0$export$fbfda8999a345a11;
$038979b6796d9af0$export$ca2bb6f0ea38a00f = $038979b6796d9af0$var$createBodyReader;
$038979b6796d9af0$export$fbfda8999a345a11 = $038979b6796d9af0$var$readNumberingProperties;
var $13c06a37a173e3cd$exports = {};
"use strict";
var $13c06a37a173e3cd$var$__importDefault = $13c06a37a173e3cd$exports && $13c06a37a173e3cd$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($13c06a37a173e3cd$exports, "__esModule", {
    value: true
});
$13c06a37a173e3cd$exports.hex = $13c06a37a173e3cd$exports.dec = $13c06a37a173e3cd$exports.codePoint = void 0;

var $13c06a37a173e3cd$var$dingbats_1 = $13c06a37a173e3cd$var$__importDefault((parcelRequire("2nE2Y")));
var $13c06a37a173e3cd$var$dingbatsByCodePoint = {};
var $13c06a37a173e3cd$var$fromCodePoint = String.fromCodePoint ? String.fromCodePoint : $13c06a37a173e3cd$var$fromCodePointPolyfill;
for(var $13c06a37a173e3cd$var$_i = 0, $13c06a37a173e3cd$var$dingbats_2 = $13c06a37a173e3cd$var$dingbats_1.default; $13c06a37a173e3cd$var$_i < $13c06a37a173e3cd$var$dingbats_2.length; $13c06a37a173e3cd$var$_i++){
    var $13c06a37a173e3cd$var$dingbat = $13c06a37a173e3cd$var$dingbats_2[$13c06a37a173e3cd$var$_i];
    var $13c06a37a173e3cd$var$codePoint_1 = parseInt($13c06a37a173e3cd$var$dingbat["Unicode dec"], 10);
    var $13c06a37a173e3cd$var$scalarValue = {
        codePoint: $13c06a37a173e3cd$var$codePoint_1,
        string: $13c06a37a173e3cd$var$fromCodePoint($13c06a37a173e3cd$var$codePoint_1)
    };
    $13c06a37a173e3cd$var$dingbatsByCodePoint[$13c06a37a173e3cd$var$dingbat["Typeface name"].toUpperCase() + "_" + $13c06a37a173e3cd$var$dingbat["Dingbat dec"]] = $13c06a37a173e3cd$var$scalarValue;
}
function $13c06a37a173e3cd$var$codePoint(typeface, codePoint) {
    return $13c06a37a173e3cd$var$dingbatsByCodePoint[typeface.toUpperCase() + "_" + codePoint];
}
$13c06a37a173e3cd$exports.codePoint = $13c06a37a173e3cd$var$codePoint;
function $13c06a37a173e3cd$var$dec(typeface, dec) {
    return $13c06a37a173e3cd$var$codePoint(typeface, parseInt(dec, 10));
}
$13c06a37a173e3cd$exports.dec = $13c06a37a173e3cd$var$dec;
function $13c06a37a173e3cd$var$hex(typeface, hex) {
    return $13c06a37a173e3cd$var$codePoint(typeface, parseInt(hex, 16));
}
$13c06a37a173e3cd$exports.hex = $13c06a37a173e3cd$var$hex;
function $13c06a37a173e3cd$var$fromCodePointPolyfill(codePoint) {
    if (codePoint <= 0xFFFF) // BMP
    return String.fromCharCode(codePoint);
    else {
        // Astral
        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        var highSurrogate = Math.floor((codePoint - 0x10000) / 0x400) + 0xD800;
        var lowSurrogate = (codePoint - 0x10000) % 0x400 + 0xDC00;
        return String.fromCharCode(highSurrogate, lowSurrogate);
    }
}


parcelRequire("eSbtG");
var $4PhZa = parcelRequire("4PhZa");
var $1kSpe = parcelRequire("1kSpe");
var $e4fgt = parcelRequire("e4fgt");
var $3CMFi = parcelRequire("3CMFi");
var $bLfRy = parcelRequire("bLfRy");
var $6yCKd = parcelRequire("6yCKd");


var $038979b6796d9af0$require$Result = $b398cbdc7abf8f61$export$8fdcabde73f49165;

var $038979b6796d9af0$require$warning = $b398cbdc7abf8f61$export$491112666e282270;


var $jS8wL = parcelRequire("jS8wL");
var $8430e27e832867ec$export$483b6ae7cde9cd77;
var $8430e27e832867ec$export$75a2182ba6144c1c;
$8430e27e832867ec$export$483b6ae7cde9cd77 = $8430e27e832867ec$var$uriToZipEntryName;
$8430e27e832867ec$export$75a2182ba6144c1c = $8430e27e832867ec$var$replaceFragment;
function $8430e27e832867ec$var$uriToZipEntryName(base, uri) {
    if (uri.charAt(0) === "/") return uri.substr(1);
    else // In general, we should check first and second for trailing and leading slashes,
    // but in our specific case this seems to be sufficient
    return base + "/" + uri;
}
function $8430e27e832867ec$var$replaceFragment(uri, fragment) {
    var hashIndex = uri.indexOf("#");
    if (hashIndex !== -1) uri = uri.substring(0, hashIndex);
    return uri + "#" + fragment;
}


function $038979b6796d9af0$var$createBodyReader(options) {
    return {
        readXmlElement: function(element) {
            return new $038979b6796d9af0$var$BodyReader(options).readXmlElement(element);
        },
        readXmlElements: function(elements) {
            return new $038979b6796d9af0$var$BodyReader(options).readXmlElements(elements);
        }
    };
}
function $038979b6796d9af0$var$BodyReader(options) {
    var complexFieldStack = [];
    var currentInstrText = [];
    // When a paragraph is marked as deleted, its contents should be combined
    // with the following paragraph. See 17.13.5.15 del (Deleted Paragraph) of
    // ECMA-376 4th edition Part 1.
    var deletedParagraphContents = [];
    var relationships = options.relationships;
    var contentTypes = options.contentTypes;
    var docxFile = options.docxFile;
    var files = options.files;
    var numbering = options.numbering;
    var styles = options.styles;
    function readXmlElements(elements) {
        var results = elements.map(readXmlElement);
        return $038979b6796d9af0$var$combineResults(results);
    }
    function readXmlElement(element) {
        if (element.type === "element") {
            var handler = xmlElementReaders[element.name];
            if (handler) return handler(element);
            else if (!Object.prototype.hasOwnProperty.call($038979b6796d9af0$var$ignoreElements, element.name)) {
                var message = $038979b6796d9af0$require$warning("An unrecognised element was ignored: " + element.name);
                return $038979b6796d9af0$var$emptyResultWithMessages([
                    message
                ]);
            }
        }
        return $038979b6796d9af0$var$emptyResult();
    }
    function readParagraphProperties(element) {
        return readParagraphStyle(element).map(function(style) {
            return {
                type: "paragraphProperties",
                styleId: style.styleId,
                styleName: style.name,
                alignment: element.firstOrEmpty("w:jc").attributes["w:val"],
                numbering: $038979b6796d9af0$var$readNumberingProperties(style.styleId, element.firstOrEmpty("w:numPr"), numbering),
                indent: readParagraphIndent(element.firstOrEmpty("w:ind"))
            };
        });
    }
    function readParagraphIndent(element) {
        return {
            start: element.attributes["w:start"] || element.attributes["w:left"],
            end: element.attributes["w:end"] || element.attributes["w:right"],
            firstLine: element.attributes["w:firstLine"],
            hanging: element.attributes["w:hanging"]
        };
    }
    function readRunProperties(element) {
        return readRunStyle(element).map(function(style) {
            var fontSizeString = element.firstOrEmpty("w:sz").attributes["w:val"];
            // w:sz gives the font size in half points, so halve the value to get the size in points
            var fontSize = /^[0-9]+$/.test(fontSizeString) ? parseInt(fontSizeString, 10) / 2 : null;
            return {
                type: "runProperties",
                styleId: style.styleId,
                styleName: style.name,
                verticalAlignment: element.firstOrEmpty("w:vertAlign").attributes["w:val"],
                font: element.firstOrEmpty("w:rFonts").attributes["w:ascii"],
                fontSize: fontSize,
                isBold: readBooleanElement(element.first("w:b")),
                isUnderline: readUnderline(element.first("w:u")),
                isItalic: readBooleanElement(element.first("w:i")),
                isStrikethrough: readBooleanElement(element.first("w:strike")),
                isAllCaps: readBooleanElement(element.first("w:caps")),
                isSmallCaps: readBooleanElement(element.first("w:smallCaps")),
                highlight: readHighlightValue(element.firstOrEmpty("w:highlight").attributes["w:val"])
            };
        });
    }
    function readUnderline(element) {
        if (element) {
            var value = element.attributes["w:val"];
            return value !== undefined && value !== "false" && value !== "0" && value !== "none";
        } else return false;
    }
    function readBooleanElement(element) {
        if (element) {
            var value = element.attributes["w:val"];
            return value !== "false" && value !== "0";
        } else return false;
    }
    function readBooleanAttributeValue(value) {
        return value !== "false" && value !== "0";
    }
    function readHighlightValue(value) {
        if (!value || value === "none") return null;
        else return value;
    }
    function readParagraphStyle(element) {
        return readStyle(element, "w:pStyle", "Paragraph", styles.findParagraphStyleById);
    }
    function readRunStyle(element) {
        return readStyle(element, "w:rStyle", "Run", styles.findCharacterStyleById);
    }
    function readTableStyle(element) {
        return readStyle(element, "w:tblStyle", "Table", styles.findTableStyleById);
    }
    function readStyle(element, styleTagName, styleType, findStyleById) {
        var messages = [];
        var styleElement = element.first(styleTagName);
        var styleId = null;
        var name = null;
        if (styleElement) {
            styleId = styleElement.attributes["w:val"];
            if (styleId) {
                var style = findStyleById(styleId);
                if (style) name = style.name;
                else messages.push(undefinedStyleWarning(styleType, styleId));
            }
        }
        return $038979b6796d9af0$var$elementResultWithMessages({
            styleId: styleId,
            name: name
        }, messages);
    }
    function readFldChar(element) {
        var type = element.attributes["w:fldCharType"];
        if (type === "begin") {
            complexFieldStack.push({
                type: "begin",
                fldChar: element
            });
            currentInstrText = [];
        } else if (type === "end") {
            var complexFieldEnd = complexFieldStack.pop();
            if (complexFieldEnd.type === "begin") complexFieldEnd = parseCurrentInstrText(complexFieldEnd);
            if (complexFieldEnd.type === "checkbox") return $038979b6796d9af0$var$elementResult($9a19f07fe6a873fd$export$b07e517d22efa1ca({
                checked: complexFieldEnd.checked
            }));
        } else if (type === "separate") {
            var complexFieldSeparate = complexFieldStack.pop();
            var complexField = parseCurrentInstrText(complexFieldSeparate);
            complexFieldStack.push(complexField);
        }
        return $038979b6796d9af0$var$emptyResult();
    }
    function currentHyperlinkOptions() {
        var topHyperlink = $bLfRy.default(complexFieldStack.filter(function(complexField) {
            return complexField.type === "hyperlink";
        }));
        return topHyperlink ? topHyperlink.options : null;
    }
    function parseCurrentInstrText(complexField) {
        return parseInstrText(currentInstrText.join(''), complexField.type === "begin" ? complexField.fldChar : $0743bccdd00b5f6b$export$ae6de35c16b306df);
    }
    function parseInstrText(instrText, fldChar) {
        var linkResult = /^\s*HYPERLINK\s+(\\l\s+)?(?:"(.*)"|([^\\]\S*))/.exec(instrText);
        if (linkResult) {
            var location = linkResult[2] === undefined ? linkResult[3] : linkResult[2];
            var options = linkResult[1] === undefined ? {
                href: location
            } : {
                anchor: location
            };
            return {
                type: "hyperlink",
                options: options
            };
        }
        var checkboxResult = /\s*FORMCHECKBOX\s*/.exec(instrText);
        if (checkboxResult) {
            var checkboxElement = fldChar.firstOrEmpty("w:ffData").firstOrEmpty("w:checkBox");
            var checkedElement = checkboxElement.first("w:checked");
            var checked = checkedElement == null ? readBooleanElement(checkboxElement.first("w:default")) : readBooleanElement(checkedElement);
            return {
                type: "checkbox",
                checked: checked
            };
        }
        return {
            type: "unknown"
        };
    }
    function readInstrText(element) {
        currentInstrText.push(element.text());
        return $038979b6796d9af0$var$emptyResult();
    }
    function readSymbol(element) {
        // See 17.3.3.30 sym (Symbol Character) of ECMA-376 4th edition Part 1
        var font = element.attributes["w:font"];
        var char = element.attributes["w:char"];
        var unicodeCharacter = $13c06a37a173e3cd$exports.hex(font, char);
        if (unicodeCharacter == null && /^F0..$/.test(char)) unicodeCharacter = $13c06a37a173e3cd$exports.hex(font, char.substring(2));
        if (unicodeCharacter == null) return $038979b6796d9af0$var$emptyResultWithMessages([
            $038979b6796d9af0$require$warning("A w:sym element with an unsupported character was ignored: char " + char + " in font " + font)
        ]);
        else return $038979b6796d9af0$var$elementResult(new $9a19f07fe6a873fd$export$5f1af8db9871e1d6(unicodeCharacter.string));
    }
    function noteReferenceReader(noteType) {
        return function(element) {
            var noteId = element.attributes["w:id"];
            return $038979b6796d9af0$var$elementResult(new $9a19f07fe6a873fd$export$e67f182a50c27e10({
                noteType: noteType,
                noteId: noteId
            }));
        };
    }
    function readCommentReference(element) {
        return $038979b6796d9af0$var$elementResult($9a19f07fe6a873fd$export$841d4c6db70c1a65({
            commentId: element.attributes["w:id"]
        }));
    }
    function readChildElements(element) {
        return readXmlElements(element.children);
    }
    var xmlElementReaders = {
        "w:p": function(element) {
            var paragraphPropertiesElement = element.firstOrEmpty("w:pPr");
            var isDeleted = !!paragraphPropertiesElement.firstOrEmpty("w:rPr").first("w:del");
            if (isDeleted) {
                element.children.forEach(function(child) {
                    deletedParagraphContents.push(child);
                });
                return $038979b6796d9af0$var$emptyResult();
            } else {
                var childrenXml = element.children;
                if (deletedParagraphContents.length > 0) {
                    childrenXml = deletedParagraphContents.concat(childrenXml);
                    deletedParagraphContents = [];
                }
                return $038979b6796d9af0$var$ReadResult.map(readParagraphProperties(paragraphPropertiesElement), readXmlElements(childrenXml), function(properties, children) {
                    return new $9a19f07fe6a873fd$export$358a232cca1ab2ac(children, properties);
                }).insertExtra();
            }
        },
        "w:r": function(element) {
            return $038979b6796d9af0$var$ReadResult.map(readRunProperties(element.firstOrEmpty("w:rPr")), readXmlElements(element.children), function(properties, children) {
                var hyperlinkOptions = currentHyperlinkOptions();
                if (hyperlinkOptions !== null) children = [
                    new $9a19f07fe6a873fd$export$de48447bf377cd47(children, hyperlinkOptions)
                ];
                return new $9a19f07fe6a873fd$export$ddae37e51c7979e2(children, properties);
            });
        },
        "w:fldChar": readFldChar,
        "w:instrText": readInstrText,
        "w:t": function(element) {
            return $038979b6796d9af0$var$elementResult(new $9a19f07fe6a873fd$export$5f1af8db9871e1d6(element.text()));
        },
        "w:tab": function(element) {
            return $038979b6796d9af0$var$elementResult(new $9a19f07fe6a873fd$export$3e41faf802a29e71());
        },
        "w:noBreakHyphen": function() {
            return $038979b6796d9af0$var$elementResult(new $9a19f07fe6a873fd$export$5f1af8db9871e1d6("\u2011"));
        },
        "w:softHyphen": function(element) {
            return $038979b6796d9af0$var$elementResult(new $9a19f07fe6a873fd$export$5f1af8db9871e1d6("\u00AD"));
        },
        "w:sym": readSymbol,
        "w:hyperlink": function(element) {
            var relationshipId = element.attributes["r:id"];
            var anchor = element.attributes["w:anchor"];
            return readXmlElements(element.children).map(function(children) {
                function create(options) {
                    var targetFrame = element.attributes["w:tgtFrame"] || null;
                    return new $9a19f07fe6a873fd$export$de48447bf377cd47(children, $1kSpe.default({
                        targetFrame: targetFrame
                    }, options));
                }
                if (relationshipId) {
                    var href = relationships.findTargetByRelationshipId(relationshipId);
                    if (anchor) href = $8430e27e832867ec$export$75a2182ba6144c1c(href, anchor);
                    return create({
                        href: href
                    });
                } else if (anchor) return create({
                    anchor: anchor
                });
                else return children;
            });
        },
        "w:tbl": readTable,
        "w:tr": readTableRow,
        "w:tc": readTableCell,
        "w:footnoteReference": noteReferenceReader("footnote"),
        "w:endnoteReference": noteReferenceReader("endnote"),
        "w:commentReference": readCommentReference,
        "w:br": function(element) {
            var breakType = element.attributes["w:type"];
            if (breakType == null || breakType === "textWrapping") return $038979b6796d9af0$var$elementResult($9a19f07fe6a873fd$export$a1aa2dd4ad0d3f6);
            else if (breakType === "page") return $038979b6796d9af0$var$elementResult($9a19f07fe6a873fd$export$1b438cdd7ed26c35);
            else if (breakType === "column") return $038979b6796d9af0$var$elementResult($9a19f07fe6a873fd$export$5a38f5b463e49b91);
            else return $038979b6796d9af0$var$emptyResultWithMessages([
                $038979b6796d9af0$require$warning("Unsupported break type: " + breakType)
            ]);
        },
        "w:bookmarkStart": function(element) {
            var name = element.attributes["w:name"];
            if (name === "_GoBack") return $038979b6796d9af0$var$emptyResult();
            else return $038979b6796d9af0$var$elementResult(new $9a19f07fe6a873fd$export$ad0c5cb04e0f1440({
                name: name
            }));
        },
        "mc:AlternateContent": function(element) {
            return readChildElements(element.firstOrEmpty("mc:Fallback"));
        },
        "w:sdt": function(element) {
            var contentResult = readXmlElements(element.firstOrEmpty("w:sdtContent").children);
            return contentResult.map(function(content) {
                // From the WordML standard: https://learn.microsoft.com/en-us/openspecs/office_standards/ms-docx/3350cb64-931f-41f7-8824-f18b2568ce66
                //
                // > A CT_SdtCheckbox element that specifies that the parent
                // > structured document tag is a checkbox when displayed in the
                // > document. The parent structured document tag contents MUST
                // > contain a single character and optionally an additional
                // > character in a deleted run.
                var checkbox = element.firstOrEmpty("w:sdtPr").first("wordml:checkbox");
                if (checkbox) {
                    var checkedElement = checkbox.first("wordml:checked");
                    var isChecked = !!checkedElement && readBooleanAttributeValue(checkedElement.attributes["wordml:val"]);
                    var documentCheckbox = $9a19f07fe6a873fd$export$b07e517d22efa1ca({
                        checked: isChecked
                    });
                    var hasCheckbox = false;
                    var replacedContent = content.map($jS8wL._elementsOfType($9a19f07fe6a873fd$export$b14ad400b1d09e0f.text, function(text) {
                        if (text.value.length > 0 && !hasCheckbox) {
                            hasCheckbox = true;
                            return documentCheckbox;
                        } else return text;
                    }));
                    if (hasCheckbox) return replacedContent;
                    else return documentCheckbox;
                } else return content;
            });
        },
        "w:ins": readChildElements,
        "w:object": readChildElements,
        "w:smartTag": readChildElements,
        "w:drawing": readChildElements,
        "w:pict": function(element) {
            return readChildElements(element).toExtra();
        },
        "v:roundrect": readChildElements,
        "v:shape": readChildElements,
        "v:textbox": readChildElements,
        "w:txbxContent": readChildElements,
        "wp:inline": readDrawingElement,
        "wp:anchor": readDrawingElement,
        "v:imagedata": readImageData,
        "v:group": readChildElements,
        "v:rect": readChildElements
    };
    return {
        readXmlElement: readXmlElement,
        readXmlElements: readXmlElements
    };
    function readTable(element) {
        var propertiesResult = readTableProperties(element.firstOrEmpty("w:tblPr"));
        return readXmlElements(element.children).flatMap(calculateRowSpans).flatMap(function(children) {
            return propertiesResult.map(function(properties) {
                return $9a19f07fe6a873fd$export$54ec01a60f47d33d(children, properties);
            });
        });
    }
    function readTableProperties(element) {
        return readTableStyle(element).map(function(style) {
            return {
                styleId: style.styleId,
                styleName: style.name
            };
        });
    }
    function readTableRow(element) {
        var properties = element.firstOrEmpty("w:trPr");
        // See 17.13.5.12 del (Deleted Table Row) of ECMA-376 4th edition Part 1
        var isDeleted = !!properties.first("w:del");
        if (isDeleted) return $038979b6796d9af0$var$emptyResult();
        var isHeader = !!properties.first("w:tblHeader");
        return readXmlElements(element.children).map(function(children) {
            return $9a19f07fe6a873fd$export$b05581f4e764e162(children, {
                isHeader: isHeader
            });
        });
    }
    function readTableCell(element) {
        return readXmlElements(element.children).map(function(children) {
            var properties = element.firstOrEmpty("w:tcPr");
            var gridSpan = properties.firstOrEmpty("w:gridSpan").attributes["w:val"];
            var colSpan = gridSpan ? parseInt(gridSpan, 10) : 1;
            var cell = $9a19f07fe6a873fd$export$1e4baea7053fc0e3(children, {
                colSpan: colSpan
            });
            cell._vMerge = readVMerge(properties);
            return cell;
        });
    }
    function readVMerge(properties) {
        var element = properties.first("w:vMerge");
        if (element) {
            var val = element.attributes["w:val"];
            return val === "continue" || !val;
        } else return null;
    }
    function calculateRowSpans(rows) {
        var unexpectedNonRows = $4PhZa.default(rows, function(row) {
            return row.type !== $9a19f07fe6a873fd$export$b14ad400b1d09e0f.tableRow;
        });
        if (unexpectedNonRows) {
            removeVMergeProperties(rows);
            return $038979b6796d9af0$var$elementResultWithMessages(rows, [
                $038979b6796d9af0$require$warning("unexpected non-row element in table, cell merging may be incorrect")
            ]);
        }
        var unexpectedNonCells = $4PhZa.default(rows, function(row) {
            return $4PhZa.default(row.children, function(cell) {
                return cell.type !== $9a19f07fe6a873fd$export$b14ad400b1d09e0f.tableCell;
            });
        });
        if (unexpectedNonCells) {
            removeVMergeProperties(rows);
            return $038979b6796d9af0$var$elementResultWithMessages(rows, [
                $038979b6796d9af0$require$warning("unexpected non-cell element in table row, cell merging may be incorrect")
            ]);
        }
        var columns = {};
        rows.forEach(function(row) {
            var cellIndex = 0;
            row.children.forEach(function(cell) {
                if (cell._vMerge && columns[cellIndex]) columns[cellIndex].rowSpan++;
                else {
                    columns[cellIndex] = cell;
                    cell._vMerge = false;
                }
                cellIndex += cell.colSpan;
            });
        });
        rows.forEach(function(row) {
            row.children = row.children.filter(function(cell) {
                return !cell._vMerge;
            });
            row.children.forEach(function(cell) {
                delete cell._vMerge;
            });
        });
        return $038979b6796d9af0$var$elementResult(rows);
    }
    function removeVMergeProperties(rows) {
        rows.forEach(function(row) {
            var cells = $jS8wL.getDescendantsOfType(row, $9a19f07fe6a873fd$export$b14ad400b1d09e0f.tableCell);
            cells.forEach(function(cell) {
                delete cell._vMerge;
            });
        });
    }
    function readDrawingElement(element) {
        var blips = element.getElementsByTagName("a:graphic").getElementsByTagName("a:graphicData").getElementsByTagName("pic:pic").getElementsByTagName("pic:blipFill").getElementsByTagName("a:blip");
        return $038979b6796d9af0$var$combineResults(blips.map(readBlip.bind(null, element)));
    }
    function readBlip(element, blip) {
        var propertiesElement = element.firstOrEmpty("wp:docPr");
        var properties = propertiesElement.attributes;
        var altText = isBlank(properties.descr) ? properties.title : properties.descr;
        var blipImageFile = findBlipImageFile(blip);
        if (blipImageFile === null) return $038979b6796d9af0$var$emptyResultWithMessages([
            $038979b6796d9af0$require$warning("Could not find image file for a:blip element")
        ]);
        return readImage(blipImageFile, altText).map(function(imageElement) {
            var hlinkClickElement = propertiesElement.firstOrEmpty("a:hlinkClick");
            var relationshipId = hlinkClickElement.attributes["r:id"];
            if (relationshipId) {
                var href = relationships.findTargetByRelationshipId(relationshipId);
                return new $9a19f07fe6a873fd$export$de48447bf377cd47([
                    imageElement
                ], {
                    href: href
                });
            } else return imageElement;
        });
    }
    function isBlank(value) {
        return value == null || /^\s*$/.test(value);
    }
    function findBlipImageFile(blip) {
        var embedRelationshipId = blip.attributes["r:embed"];
        var linkRelationshipId = blip.attributes["r:link"];
        if (embedRelationshipId) return findEmbeddedImageFile(embedRelationshipId);
        else if (linkRelationshipId) {
            var imagePath = relationships.findTargetByRelationshipId(linkRelationshipId);
            return {
                path: imagePath,
                read: files.read.bind(files, imagePath)
            };
        } else return null;
    }
    function readImageData(element) {
        var relationshipId = element.attributes['r:id'];
        if (relationshipId) return readImage(findEmbeddedImageFile(relationshipId), element.attributes["o:title"]);
        else return $038979b6796d9af0$var$emptyResultWithMessages([
            $038979b6796d9af0$require$warning("A v:imagedata element without a relationship ID was ignored")
        ]);
    }
    function findEmbeddedImageFile(relationshipId) {
        var path = $8430e27e832867ec$export$483b6ae7cde9cd77("word", relationships.findTargetByRelationshipId(relationshipId));
        return {
            path: path,
            read: docxFile.read.bind(docxFile, path)
        };
    }
    function readImage(imageFile, altText) {
        var contentType = contentTypes.findContentType(imageFile.path);
        var image = $9a19f07fe6a873fd$export$3e431a229df88919({
            readImage: imageFile.read,
            altText: altText,
            contentType: contentType
        });
        var warnings = $038979b6796d9af0$var$supportedImageTypes[contentType] ? [] : $038979b6796d9af0$require$warning("Image of type " + contentType + " is unlikely to display in web browsers");
        return $038979b6796d9af0$var$elementResultWithMessages(image, warnings);
    }
    function undefinedStyleWarning(type, styleId) {
        return $038979b6796d9af0$require$warning(type + " style with ID " + styleId + " was referenced but not defined in the document");
    }
}
function $038979b6796d9af0$var$readNumberingProperties(styleId, element, numbering) {
    var level = element.firstOrEmpty("w:ilvl").attributes["w:val"];
    var numId = element.firstOrEmpty("w:numId").attributes["w:val"];
    if (level !== undefined && numId !== undefined) return numbering.findLevel(numId, level);
    if (styleId != null) {
        var levelByStyleId = numbering.findLevelByParagraphStyleId(styleId);
        if (levelByStyleId != null) return levelByStyleId;
    }
    // Some malformed documents define numbering levels without an index, and
    // reference the numbering using a w:numPr element without a w:ilvl child.
    // To handle such cases, we assume a level of 0 as a fallback.
    if (numId !== undefined) return numbering.findLevel(numId, "0");
    return null;
}
var $038979b6796d9af0$var$supportedImageTypes = {
    "image/png": true,
    "image/gif": true,
    "image/jpeg": true,
    "image/svg+xml": true,
    "image/tiff": true
};
var $038979b6796d9af0$var$ignoreElements = {
    "office-word:wrap": true,
    "v:shadow": true,
    "v:shapetype": true,
    "w:annotationRef": true,
    "w:bookmarkEnd": true,
    "w:sectPr": true,
    "w:proofErr": true,
    "w:lastRenderedPageBreak": true,
    "w:commentRangeStart": true,
    "w:commentRangeEnd": true,
    "w:del": true,
    "w:footnoteRef": true,
    "w:endnoteRef": true,
    "w:pPr": true,
    "w:rPr": true,
    "w:tblPr": true,
    "w:tblGrid": true,
    "w:trPr": true,
    "w:tcPr": true
};
function $038979b6796d9af0$var$emptyResultWithMessages(messages) {
    return new $038979b6796d9af0$var$ReadResult(null, null, messages);
}
function $038979b6796d9af0$var$emptyResult() {
    return new $038979b6796d9af0$var$ReadResult(null);
}
function $038979b6796d9af0$var$elementResult(element) {
    return new $038979b6796d9af0$var$ReadResult(element);
}
function $038979b6796d9af0$var$elementResultWithMessages(element, messages) {
    return new $038979b6796d9af0$var$ReadResult(element, null, messages);
}
function $038979b6796d9af0$var$ReadResult(element, extra, messages) {
    this.value = element || [];
    this.extra = extra || [];
    this._result = new $038979b6796d9af0$require$Result({
        element: this.value,
        extra: extra
    }, messages);
    this.messages = this._result.messages;
}
$038979b6796d9af0$var$ReadResult.prototype.toExtra = function() {
    return new $038979b6796d9af0$var$ReadResult(null, $038979b6796d9af0$var$joinElements(this.extra, this.value), this.messages);
};
$038979b6796d9af0$var$ReadResult.prototype.insertExtra = function() {
    var extra = this.extra;
    if (extra && extra.length) return new $038979b6796d9af0$var$ReadResult($038979b6796d9af0$var$joinElements(this.value, extra), null, this.messages);
    else return this;
};
$038979b6796d9af0$var$ReadResult.prototype.map = function(func) {
    var result = this._result.map(function(value) {
        return func(value.element);
    });
    return new $038979b6796d9af0$var$ReadResult(result.value, this.extra, result.messages);
};
$038979b6796d9af0$var$ReadResult.prototype.flatMap = function(func) {
    var result = this._result.flatMap(function(value) {
        return func(value.element)._result;
    });
    return new $038979b6796d9af0$var$ReadResult(result.value.element, $038979b6796d9af0$var$joinElements(this.extra, result.value.extra), result.messages);
};
$038979b6796d9af0$var$ReadResult.map = function(first, second, func) {
    return new $038979b6796d9af0$var$ReadResult(func(first.value, second.value), $038979b6796d9af0$var$joinElements(first.extra, second.extra), first.messages.concat(second.messages));
};
function $038979b6796d9af0$var$combineResults(results) {
    var result = $038979b6796d9af0$require$Result.combine($6yCKd.default(results, "_result"));
    return new $038979b6796d9af0$var$ReadResult($3CMFi.default($6yCKd.default(result.value, "element")), $e4fgt.default($3CMFi.default($6yCKd.default(result.value, "extra")), $038979b6796d9af0$var$identity), result.messages);
}
function $038979b6796d9af0$var$joinElements(first, second) {
    return $3CMFi.default([
        first,
        second
    ]);
}
function $038979b6796d9af0$var$identity(value) {
    return value;
}


var $76ae973f152dcbe2$require$createBodyReader = $038979b6796d9af0$export$ca2bb6f0ea38a00f;
var $437fff594e123c7d$export$ff28ea179c35f727;
$437fff594e123c7d$export$ff28ea179c35f727 = $437fff594e123c7d$var$DocumentXmlReader;


var $437fff594e123c7d$require$Result = $b398cbdc7abf8f61$export$8fdcabde73f49165;
function $437fff594e123c7d$var$DocumentXmlReader(options) {
    var bodyReader = options.bodyReader;
    function convertXmlToDocument(element) {
        var body = element.first("w:body");
        if (body == null) throw new Error("Could not find the body element: are you sure this is a docx file?");
        var result = bodyReader.readXmlElements(body.children).map(function(children) {
            return new $9a19f07fe6a873fd$export$b34a105447964f9f(children, {
                notes: options.notes,
                comments: options.comments
            });
        });
        return new $437fff594e123c7d$require$Result(result.value, result.messages);
    }
    return {
        convertXmlToDocument: convertXmlToDocument
    };
}


var $76ae973f152dcbe2$require$DocumentXmlReader = $437fff594e123c7d$export$ff28ea179c35f727;
var $3735edeb5786e962$export$caf6d0f1ae2fd4d5;
var $3735edeb5786e962$export$1a01ae0705bafd37;
var $3735edeb5786e962$export$ddbf7887bc0aa836;
$3735edeb5786e962$export$caf6d0f1ae2fd4d5 = $3735edeb5786e962$var$readRelationships;
$3735edeb5786e962$export$1a01ae0705bafd37 = new $3735edeb5786e962$var$Relationships([]);
$3735edeb5786e962$export$ddbf7887bc0aa836 = $3735edeb5786e962$var$Relationships;
function $3735edeb5786e962$var$readRelationships(element) {
    var relationships = [];
    element.children.forEach(function(child) {
        if (child.name === "relationships:Relationship") {
            var relationship = {
                relationshipId: child.attributes.Id,
                target: child.attributes.Target,
                type: child.attributes.Type
            };
            relationships.push(relationship);
        }
    });
    return new $3735edeb5786e962$var$Relationships(relationships);
}
function $3735edeb5786e962$var$Relationships(relationships) {
    var targetsByRelationshipId = {};
    relationships.forEach(function(relationship) {
        targetsByRelationshipId[relationship.relationshipId] = relationship.target;
    });
    var targetsByType = {};
    relationships.forEach(function(relationship) {
        if (!targetsByType[relationship.type]) targetsByType[relationship.type] = [];
        targetsByType[relationship.type].push(relationship.target);
    });
    return {
        findTargetByRelationshipId: function(relationshipId) {
            return targetsByRelationshipId[relationshipId];
        },
        findTargetsByType: function(type) {
            return targetsByType[type] || [];
        }
    };
}


var $d60e8c51ea8e1113$export$c97a5c0bc99ab2ff;
var $d60e8c51ea8e1113$export$dcc72562f777bfbb;
$d60e8c51ea8e1113$export$c97a5c0bc99ab2ff = $d60e8c51ea8e1113$var$readContentTypesFromXml;
var $d60e8c51ea8e1113$var$fallbackContentTypes = {
    "png": "png",
    "gif": "gif",
    "jpeg": "jpeg",
    "jpg": "jpeg",
    "tif": "tiff",
    "tiff": "tiff",
    "bmp": "bmp"
};
$d60e8c51ea8e1113$export$dcc72562f777bfbb = $d60e8c51ea8e1113$var$contentTypes({}, {});
function $d60e8c51ea8e1113$var$readContentTypesFromXml(element) {
    var extensionDefaults = {};
    var overrides = {};
    element.children.forEach(function(child) {
        if (child.name === "content-types:Default") extensionDefaults[child.attributes.Extension] = child.attributes.ContentType;
        if (child.name === "content-types:Override") {
            var name = child.attributes.PartName;
            if (name.charAt(0) === "/") name = name.substring(1);
            overrides[name] = child.attributes.ContentType;
        }
    });
    return $d60e8c51ea8e1113$var$contentTypes(overrides, extensionDefaults);
}
function $d60e8c51ea8e1113$var$contentTypes(overrides, extensionDefaults) {
    return {
        findContentType: function(path) {
            var overrideContentType = overrides[path];
            if (overrideContentType) return overrideContentType;
            else {
                var pathParts = path.split(".");
                var extension = pathParts[pathParts.length - 1];
                if (extensionDefaults.hasOwnProperty(extension)) return extensionDefaults[extension];
                else {
                    var fallback = $d60e8c51ea8e1113$var$fallbackContentTypes[extension.toLowerCase()];
                    if (fallback) return "image/" + fallback;
                    else return null;
                }
            }
        }
    };
}


var $2d5db13951870828$export$740149d4d5c5888e;
var $2d5db13951870828$export$521a466b2293b1d9;
var $2d5db13951870828$export$4a4adb64dd5d0f9b;
parcelRequire("eSbtG");
var $3CMFi = parcelRequire("3CMFi");
var $6BxOE = parcelRequire("6BxOE");
var $adQgf = parcelRequire("adQgf");
$2d5db13951870828$export$740149d4d5c5888e = $2d5db13951870828$var$readNumberingXml;
$2d5db13951870828$export$521a466b2293b1d9 = $2d5db13951870828$var$Numbering;
$2d5db13951870828$export$4a4adb64dd5d0f9b = new $2d5db13951870828$var$Numbering({}, {});
function $2d5db13951870828$var$Numbering(nums, abstractNums, styles) {
    var allLevels = $3CMFi.default($adQgf.default(abstractNums).map(function(abstractNum) {
        return $adQgf.default(abstractNum.levels);
    }));
    var levelsByParagraphStyleId = $6BxOE.default(allLevels.filter(function(level) {
        return level.paragraphStyleId != null;
    }), "paragraphStyleId");
    function findLevel(numId, level) {
        var num = nums[numId];
        if (num) {
            var abstractNum = abstractNums[num.abstractNumId];
            if (!abstractNum) return null;
            else if (abstractNum.numStyleLink == null) return abstractNums[num.abstractNumId].levels[level];
            else {
                var style = styles.findNumberingStyleById(abstractNum.numStyleLink);
                return findLevel(style.numId, level);
            }
        } else return null;
    }
    function findLevelByParagraphStyleId(styleId) {
        return levelsByParagraphStyleId[styleId] || null;
    }
    return {
        findLevel: findLevel,
        findLevelByParagraphStyleId: findLevelByParagraphStyleId
    };
}
function $2d5db13951870828$var$readNumberingXml(root, options) {
    if (!options || !options.styles) throw new Error("styles is missing");
    var abstractNums = $2d5db13951870828$var$readAbstractNums(root);
    var nums = $2d5db13951870828$var$readNums(root, abstractNums);
    return new $2d5db13951870828$var$Numbering(nums, abstractNums, options.styles);
}
function $2d5db13951870828$var$readAbstractNums(root) {
    var abstractNums = {};
    root.getElementsByTagName("w:abstractNum").forEach(function(element) {
        var id = element.attributes["w:abstractNumId"];
        abstractNums[id] = $2d5db13951870828$var$readAbstractNum(element);
    });
    return abstractNums;
}
function $2d5db13951870828$var$readAbstractNum(element) {
    var levels = {};
    // Some malformed documents define numbering levels without an index, and
    // reference the numbering using a w:numPr element without a w:ilvl child.
    // To handle such cases, we assume a level of 0 as a fallback.
    var levelWithoutIndex = null;
    element.getElementsByTagName("w:lvl").forEach(function(levelElement) {
        var levelIndex = levelElement.attributes["w:ilvl"];
        var numFmt = levelElement.firstOrEmpty("w:numFmt").attributes["w:val"];
        var isOrdered = numFmt !== "bullet";
        var paragraphStyleId = levelElement.firstOrEmpty("w:pStyle").attributes["w:val"];
        if (levelIndex === undefined) levelWithoutIndex = {
            isOrdered: isOrdered,
            level: "0",
            paragraphStyleId: paragraphStyleId
        };
        else levels[levelIndex] = {
            isOrdered: isOrdered,
            level: levelIndex,
            paragraphStyleId: paragraphStyleId
        };
    });
    if (levelWithoutIndex !== null && levels[levelWithoutIndex.level] === undefined) levels[levelWithoutIndex.level] = levelWithoutIndex;
    var numStyleLink = element.firstOrEmpty("w:numStyleLink").attributes["w:val"];
    return {
        levels: levels,
        numStyleLink: numStyleLink
    };
}
function $2d5db13951870828$var$readNums(root) {
    var nums = {};
    root.getElementsByTagName("w:num").forEach(function(element) {
        var numId = element.attributes["w:numId"];
        var abstractNumId = element.first("w:abstractNumId").attributes["w:val"];
        nums[numId] = {
            abstractNumId: abstractNumId
        };
    });
    return nums;
}


var $a3ffdba7515b7071$export$b4a897ae7d66dcc8;
var $a3ffdba7515b7071$export$e155666bf54a9f18;
var $a3ffdba7515b7071$export$214b055320e0bf32;
$a3ffdba7515b7071$export$b4a897ae7d66dcc8 = $a3ffdba7515b7071$var$readStylesXml;
$a3ffdba7515b7071$export$e155666bf54a9f18 = $a3ffdba7515b7071$var$Styles;
$a3ffdba7515b7071$export$214b055320e0bf32 = new $a3ffdba7515b7071$var$Styles({}, {});
function $a3ffdba7515b7071$var$Styles(paragraphStyles, characterStyles, tableStyles, numberingStyles) {
    return {
        findParagraphStyleById: function(styleId) {
            return paragraphStyles[styleId];
        },
        findCharacterStyleById: function(styleId) {
            return characterStyles[styleId];
        },
        findTableStyleById: function(styleId) {
            return tableStyles[styleId];
        },
        findNumberingStyleById: function(styleId) {
            return numberingStyles[styleId];
        }
    };
}
$a3ffdba7515b7071$var$Styles.EMPTY = new $a3ffdba7515b7071$var$Styles({}, {}, {}, {});
function $a3ffdba7515b7071$var$readStylesXml(root) {
    var paragraphStyles = {};
    var characterStyles = {};
    var tableStyles = {};
    var numberingStyles = {};
    var styles = {
        "paragraph": paragraphStyles,
        "character": characterStyles,
        "table": tableStyles,
        "numbering": numberingStyles
    };
    root.getElementsByTagName("w:style").forEach(function(styleElement) {
        var style = $a3ffdba7515b7071$var$readStyleElement(styleElement);
        var styleSet = styles[style.type];
        // Per 17.7.4.17 style (Style Definition) of ECMA-376 4th edition Part 1:
        //
        // > If multiple style definitions each declare the same value for their
        // > styleId, then the first such instance shall keep its current
        // > identifier with all other instances being reassigned in any manner
        // > desired.
        //
        // For the purpose of conversion, there's no point holding onto styles
        // with reassigned style IDs, so we ignore such style definitions.
        if (styleSet && styleSet[style.styleId] === undefined) styleSet[style.styleId] = style;
    });
    return new $a3ffdba7515b7071$var$Styles(paragraphStyles, characterStyles, tableStyles, numberingStyles);
}
function $a3ffdba7515b7071$var$readStyleElement(styleElement) {
    var type = styleElement.attributes["w:type"];
    if (type === "numbering") return $a3ffdba7515b7071$var$readNumberingStyleElement(type, styleElement);
    else {
        var styleId = $a3ffdba7515b7071$var$readStyleId(styleElement);
        var name = $a3ffdba7515b7071$var$styleName(styleElement);
        return {
            type: type,
            styleId: styleId,
            name: name
        };
    }
}
function $a3ffdba7515b7071$var$styleName(styleElement) {
    var nameElement = styleElement.first("w:name");
    return nameElement ? nameElement.attributes["w:val"] : null;
}
function $a3ffdba7515b7071$var$readNumberingStyleElement(type, styleElement) {
    var styleId = $a3ffdba7515b7071$var$readStyleId(styleElement);
    var numId = styleElement.firstOrEmpty("w:pPr").firstOrEmpty("w:numPr").firstOrEmpty("w:numId").attributes["w:val"];
    return {
        type: type,
        numId: numId,
        styleId: styleId
    };
}
function $a3ffdba7515b7071$var$readStyleId(styleElement) {
    return styleElement.attributes["w:styleId"];
}


var $1b6e9c1a721127c9$exports = {};


var $1b6e9c1a721127c9$require$Result = $b398cbdc7abf8f61$export$8fdcabde73f49165;
$1b6e9c1a721127c9$exports.createFootnotesReader = $1b6e9c1a721127c9$var$createReader.bind($1b6e9c1a721127c9$exports, "footnote");
$1b6e9c1a721127c9$exports.createEndnotesReader = $1b6e9c1a721127c9$var$createReader.bind($1b6e9c1a721127c9$exports, "endnote");
function $1b6e9c1a721127c9$var$createReader(noteType, bodyReader) {
    function readNotesXml(element) {
        return $1b6e9c1a721127c9$require$Result.combine(element.getElementsByTagName("w:" + noteType).filter(isFootnoteElement).map(readFootnoteElement));
    }
    function isFootnoteElement(element) {
        var type = element.attributes["w:type"];
        return type !== "continuationSeparator" && type !== "separator";
    }
    function readFootnoteElement(footnoteElement) {
        var id = footnoteElement.attributes["w:id"];
        return bodyReader.readXmlElements(footnoteElement.children).map(function(body) {
            return $9a19f07fe6a873fd$export$6c88bf799aca3d2b({
                noteType: noteType,
                noteId: id,
                body: body
            });
        });
    }
    return readNotesXml;
}


var $f20ffecb1a14893a$export$b170a9283c83e921;


var $f20ffecb1a14893a$require$Result = $b398cbdc7abf8f61$export$8fdcabde73f49165;
function $f20ffecb1a14893a$var$createCommentsReader(bodyReader) {
    function readCommentsXml(element) {
        return $f20ffecb1a14893a$require$Result.combine(element.getElementsByTagName("w:comment").map(readCommentElement));
    }
    function readCommentElement(element) {
        var id = element.attributes["w:id"];
        function readOptionalAttribute(name) {
            return (element.attributes[name] || "").trim() || null;
        }
        return bodyReader.readXmlElements(element.children).map(function(body) {
            return $9a19f07fe6a873fd$export$4a34f930e789283c({
                commentId: id,
                body: body,
                authorName: readOptionalAttribute("w:author"),
                authorInitials: readOptionalAttribute("w:initials")
            });
        });
    }
    return readCommentsXml;
}
$f20ffecb1a14893a$export$b170a9283c83e921 = $f20ffecb1a14893a$var$createCommentsReader;


var $b571b5ea7be9ad88$export$9330ab61a7e5c11b;

var $lUVKW = parcelRequire("lUVKW");
$b571b5ea7be9ad88$export$9330ab61a7e5c11b = $b571b5ea7be9ad88$var$Files;
function $b571b5ea7be9ad88$var$Files() {
    function read(uri) {
        return $lUVKW.reject(new Error("could not open external image: '" + uri + "'\ncannot open linked files from a web browser"));
    }
    return {
        read: read
    };
}


var $76ae973f152dcbe2$require$Files = $b571b5ea7be9ad88$export$9330ab61a7e5c11b;
function $76ae973f152dcbe2$var$read(docxFile, input, options) {
    input = input || {};
    options = options || {};
    var files = new $76ae973f152dcbe2$require$Files({
        externalFileAccess: options.externalFileAccess,
        relativeToFile: input.path
    });
    return $lUVKW.props({
        contentTypes: $76ae973f152dcbe2$var$readContentTypesFromZipFile(docxFile),
        partPaths: $76ae973f152dcbe2$var$findPartPaths(docxFile),
        docxFile: docxFile,
        files: files
    }).also(function(result) {
        return {
            styles: $76ae973f152dcbe2$var$readStylesFromZipFile(docxFile, result.partPaths.styles)
        };
    }).also(function(result) {
        return {
            numbering: $76ae973f152dcbe2$var$readNumberingFromZipFile(docxFile, result.partPaths.numbering, result.styles)
        };
    }).also(function(result) {
        return {
            footnotes: $76ae973f152dcbe2$var$readXmlFileWithBody(result.partPaths.footnotes, result, function(bodyReader, xml) {
                if (xml) return $1b6e9c1a721127c9$exports.createFootnotesReader(bodyReader)(xml);
                else return new $76ae973f152dcbe2$require$Result([]);
            }),
            endnotes: $76ae973f152dcbe2$var$readXmlFileWithBody(result.partPaths.endnotes, result, function(bodyReader, xml) {
                if (xml) return $1b6e9c1a721127c9$exports.createEndnotesReader(bodyReader)(xml);
                else return new $76ae973f152dcbe2$require$Result([]);
            }),
            comments: $76ae973f152dcbe2$var$readXmlFileWithBody(result.partPaths.comments, result, function(bodyReader, xml) {
                if (xml) return $f20ffecb1a14893a$export$b170a9283c83e921(bodyReader)(xml);
                else return new $76ae973f152dcbe2$require$Result([]);
            })
        };
    }).also(function(result) {
        return {
            notes: result.footnotes.flatMap(function(footnotes) {
                return result.endnotes.map(function(endnotes) {
                    return new $9a19f07fe6a873fd$export$aa31b211d2f4c3af(footnotes.concat(endnotes));
                });
            })
        };
    }).then(function(result) {
        return $76ae973f152dcbe2$var$readXmlFileWithBody(result.partPaths.mainDocument, result, function(bodyReader, xml) {
            return result.notes.flatMap(function(notes) {
                return result.comments.flatMap(function(comments) {
                    var reader = new $76ae973f152dcbe2$require$DocumentXmlReader({
                        bodyReader: bodyReader,
                        notes: notes,
                        comments: comments
                    });
                    return reader.convertXmlToDocument(xml);
                });
            });
        });
    });
}
function $76ae973f152dcbe2$var$findPartPaths(docxFile) {
    return $76ae973f152dcbe2$var$readPackageRelationships(docxFile).then(function(packageRelationships) {
        var mainDocumentPath = $76ae973f152dcbe2$var$findPartPath({
            docxFile: docxFile,
            relationships: packageRelationships,
            relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
            basePath: "",
            fallbackPath: "word/document.xml"
        });
        if (!docxFile.exists(mainDocumentPath)) throw new Error("Could not find main document part. Are you sure this is a valid .docx file?");
        return $76ae973f152dcbe2$var$xmlFileReader({
            filename: $76ae973f152dcbe2$var$relationshipsFilename(mainDocumentPath),
            readElement: $3735edeb5786e962$export$caf6d0f1ae2fd4d5,
            defaultValue: $3735edeb5786e962$export$1a01ae0705bafd37
        })(docxFile).then(function(documentRelationships) {
            function findPartRelatedToMainDocument(name) {
                return $76ae973f152dcbe2$var$findPartPath({
                    docxFile: docxFile,
                    relationships: documentRelationships,
                    relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/" + name,
                    basePath: $57cf05b5ae854a60$export$824c337f43f2b64d(mainDocumentPath).dirname,
                    fallbackPath: "word/" + name + ".xml"
                });
            }
            return {
                mainDocument: mainDocumentPath,
                comments: findPartRelatedToMainDocument("comments"),
                endnotes: findPartRelatedToMainDocument("endnotes"),
                footnotes: findPartRelatedToMainDocument("footnotes"),
                numbering: findPartRelatedToMainDocument("numbering"),
                styles: findPartRelatedToMainDocument("styles")
            };
        });
    });
}
function $76ae973f152dcbe2$var$findPartPath(options) {
    var docxFile = options.docxFile;
    var relationships = options.relationships;
    var relationshipType = options.relationshipType;
    var basePath = options.basePath;
    var fallbackPath = options.fallbackPath;
    var targets = relationships.findTargetsByType(relationshipType);
    var normalisedTargets = targets.map(function(target) {
        return $76ae973f152dcbe2$var$stripPrefix($57cf05b5ae854a60$export$b891921babc70093(basePath, target), "/");
    });
    var validTargets = normalisedTargets.filter(function(target) {
        return docxFile.exists(target);
    });
    if (validTargets.length === 0) return fallbackPath;
    else return validTargets[0];
}
function $76ae973f152dcbe2$var$stripPrefix(value, prefix) {
    if (value.substring(0, prefix.length) === prefix) return value.substring(prefix.length);
    else return value;
}
function $76ae973f152dcbe2$var$xmlFileReader(options) {
    return function(zipFile) {
        return $76ae973f152dcbe2$require$readXmlFromZipFile(zipFile, options.filename).then(function(element) {
            return element ? options.readElement(element) : options.defaultValue;
        });
    };
}
function $76ae973f152dcbe2$var$readXmlFileWithBody(filename, options, func) {
    var readRelationshipsFromZipFile = $76ae973f152dcbe2$var$xmlFileReader({
        filename: $76ae973f152dcbe2$var$relationshipsFilename(filename),
        readElement: $3735edeb5786e962$export$caf6d0f1ae2fd4d5,
        defaultValue: $3735edeb5786e962$export$1a01ae0705bafd37
    });
    return readRelationshipsFromZipFile(options.docxFile).then(function(relationships) {
        var bodyReader = new $76ae973f152dcbe2$require$createBodyReader({
            relationships: relationships,
            contentTypes: options.contentTypes,
            docxFile: options.docxFile,
            numbering: options.numbering,
            styles: options.styles,
            files: options.files
        });
        return $76ae973f152dcbe2$require$readXmlFromZipFile(options.docxFile, filename).then(function(xml) {
            return func(bodyReader, xml);
        });
    });
}
function $76ae973f152dcbe2$var$relationshipsFilename(filename) {
    var split = $57cf05b5ae854a60$export$824c337f43f2b64d(filename);
    return $57cf05b5ae854a60$export$b891921babc70093(split.dirname, "_rels", split.basename + ".rels");
}
var $76ae973f152dcbe2$var$readContentTypesFromZipFile = $76ae973f152dcbe2$var$xmlFileReader({
    filename: "[Content_Types].xml",
    readElement: $d60e8c51ea8e1113$export$c97a5c0bc99ab2ff,
    defaultValue: $d60e8c51ea8e1113$export$dcc72562f777bfbb
});
function $76ae973f152dcbe2$var$readNumberingFromZipFile(zipFile, path, styles) {
    return $76ae973f152dcbe2$var$xmlFileReader({
        filename: path,
        readElement: function(element) {
            return $2d5db13951870828$export$740149d4d5c5888e(element, {
                styles: styles
            });
        },
        defaultValue: $2d5db13951870828$export$4a4adb64dd5d0f9b
    })(zipFile);
}
function $76ae973f152dcbe2$var$readStylesFromZipFile(zipFile, path) {
    return $76ae973f152dcbe2$var$xmlFileReader({
        filename: path,
        readElement: $a3ffdba7515b7071$export$b4a897ae7d66dcc8,
        defaultValue: $a3ffdba7515b7071$export$214b055320e0bf32
    })(zipFile);
}
var $76ae973f152dcbe2$var$readPackageRelationships = $76ae973f152dcbe2$var$xmlFileReader({
    filename: "_rels/.rels",
    readElement: $3735edeb5786e962$export$caf6d0f1ae2fd4d5,
    defaultValue: $3735edeb5786e962$export$1a01ae0705bafd37
});


var $ca7d37d7ee43a4b6$export$f183c412da6b1c0;
var $ca7d37d7ee43a4b6$export$98fd944a2c837b93;
parcelRequire("eSbtG");
var $6dYu1 = parcelRequire("6dYu1");

var $lUVKW = parcelRequire("lUVKW");

$ca7d37d7ee43a4b6$export$f183c412da6b1c0 = $ca7d37d7ee43a4b6$var$writeStyleMap;
$ca7d37d7ee43a4b6$export$98fd944a2c837b93 = $ca7d37d7ee43a4b6$var$readStyleMap;
var $ca7d37d7ee43a4b6$var$schema = "http://schemas.zwobble.org/mammoth/style-map";
var $ca7d37d7ee43a4b6$var$styleMapPath = "mammoth/style-map";
var $ca7d37d7ee43a4b6$var$styleMapAbsolutePath = "/" + $ca7d37d7ee43a4b6$var$styleMapPath;
function $ca7d37d7ee43a4b6$var$writeStyleMap(docxFile, styleMap) {
    docxFile.write($ca7d37d7ee43a4b6$var$styleMapPath, styleMap);
    return $ca7d37d7ee43a4b6$var$updateRelationships(docxFile).then(function() {
        return $ca7d37d7ee43a4b6$var$updateContentTypes(docxFile);
    });
}
function $ca7d37d7ee43a4b6$var$updateRelationships(docxFile) {
    var path = "word/_rels/document.xml.rels";
    var relationshipsUri = "http://schemas.openxmlformats.org/package/2006/relationships";
    var relationshipElementName = "{" + relationshipsUri + "}Relationship";
    return docxFile.read(path, "utf8").then($0743bccdd00b5f6b$export$dda73877cb166cd3).then(function(relationshipsContainer) {
        var relationships = relationshipsContainer.children;
        $ca7d37d7ee43a4b6$var$addOrUpdateElement(relationships, relationshipElementName, "Id", {
            "Id": "rMammothStyleMap",
            "Type": $ca7d37d7ee43a4b6$var$schema,
            "Target": $ca7d37d7ee43a4b6$var$styleMapAbsolutePath
        });
        var namespaces = {
            "": relationshipsUri
        };
        return docxFile.write(path, $0743bccdd00b5f6b$export$48a3ce3d8cfe0ce1(relationshipsContainer, namespaces));
    });
}
function $ca7d37d7ee43a4b6$var$updateContentTypes(docxFile) {
    var path = "[Content_Types].xml";
    var contentTypesUri = "http://schemas.openxmlformats.org/package/2006/content-types";
    var overrideName = "{" + contentTypesUri + "}Override";
    return docxFile.read(path, "utf8").then($0743bccdd00b5f6b$export$dda73877cb166cd3).then(function(typesElement) {
        var children = typesElement.children;
        $ca7d37d7ee43a4b6$var$addOrUpdateElement(children, overrideName, "PartName", {
            "PartName": $ca7d37d7ee43a4b6$var$styleMapAbsolutePath,
            "ContentType": "text/prs.mammoth.style-map"
        });
        var namespaces = {
            "": contentTypesUri
        };
        return docxFile.write(path, $0743bccdd00b5f6b$export$48a3ce3d8cfe0ce1(typesElement, namespaces));
    });
}
function $ca7d37d7ee43a4b6$var$addOrUpdateElement(elements, name, identifyingAttribute, attributes) {
    var existingElement = $6dYu1.default(elements, function(element) {
        return element.name === name && element.attributes[identifyingAttribute] === attributes[identifyingAttribute];
    });
    if (existingElement) existingElement.attributes = attributes;
    else elements.push($0743bccdd00b5f6b$export$8454457683f90105(name, attributes));
}
function $ca7d37d7ee43a4b6$var$readStyleMap(docxFile) {
    if (docxFile.exists($ca7d37d7ee43a4b6$var$styleMapPath)) return docxFile.read($ca7d37d7ee43a4b6$var$styleMapPath, "utf8");
    else return $lUVKW.resolve(null);
}


var $9a5777efe8b713c0$export$d10d7ab91c778d60;
var $9a5777efe8b713c0$export$6e29e379a5b99e3b;
parcelRequire("eSbtG");
var $1kSpe = parcelRequire("1kSpe");
var $9YYAC = parcelRequire("9YYAC");
var $3CMFi = parcelRequire("3CMFi");
var $6BxOE = parcelRequire("6BxOE");

var $lUVKW = parcelRequire("lUVKW");


var $2q3gK = parcelRequire("2q3gK");


var $fb1ge = parcelRequire("fb1ge");

var $2bFLC = parcelRequire("2bFLC");
var $8c0f195da7fee3de$export$47a3d634abc09f70;
var $3eba7fe55afbbee0$export$47a3d634abc09f70;
parcelRequire("eSbtG");
var $apU8A = parcelRequire("apU8A");
var $4PhZa = parcelRequire("4PhZa");
$3eba7fe55afbbee0$export$47a3d634abc09f70 = $3eba7fe55afbbee0$var$writer;
function $3eba7fe55afbbee0$var$writer(options) {
    options = options || {};
    if (options.prettyPrint) return $3eba7fe55afbbee0$var$prettyWriter();
    else return $3eba7fe55afbbee0$var$simpleWriter();
}
var $3eba7fe55afbbee0$var$indentedElements = {
    div: true,
    p: true,
    ul: true,
    li: true
};
function $3eba7fe55afbbee0$var$prettyWriter() {
    var indentationLevel = 0;
    var indentation = "  ";
    var stack = [];
    var start = true;
    var inText = false;
    var writer = $3eba7fe55afbbee0$var$simpleWriter();
    function open(tagName, attributes) {
        if ($3eba7fe55afbbee0$var$indentedElements[tagName]) indent();
        stack.push(tagName);
        writer.open(tagName, attributes);
        if ($3eba7fe55afbbee0$var$indentedElements[tagName]) indentationLevel++;
        start = false;
    }
    function close(tagName) {
        if ($3eba7fe55afbbee0$var$indentedElements[tagName]) {
            indentationLevel--;
            indent();
        }
        stack.pop();
        writer.close(tagName);
    }
    function text(value) {
        startText();
        var text = isInPre() ? value : value.replace("\n", "\n" + indentation);
        writer.text(text);
    }
    function selfClosing(tagName, attributes) {
        indent();
        writer.selfClosing(tagName, attributes);
    }
    function insideIndentedElement() {
        return stack.length === 0 || $3eba7fe55afbbee0$var$indentedElements[stack[stack.length - 1]];
    }
    function startText() {
        if (!inText) {
            indent();
            inText = true;
        }
    }
    function indent() {
        inText = false;
        if (!start && insideIndentedElement() && !isInPre()) {
            writer._append("\n");
            for(var i = 0; i < indentationLevel; i++)writer._append(indentation);
        }
    }
    function isInPre() {
        return $4PhZa.default(stack, function(tagName) {
            return tagName === "pre";
        });
    }
    return {
        asString: writer.asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing
    };
}
function $3eba7fe55afbbee0$var$simpleWriter() {
    var fragments = [];
    function open(tagName, attributes) {
        var attributeString = generateAttributeString(attributes);
        fragments.push("<" + tagName + attributeString + ">");
    }
    function close(tagName) {
        fragments.push("</" + tagName + ">");
    }
    function selfClosing(tagName, attributes) {
        var attributeString = generateAttributeString(attributes);
        fragments.push("<" + tagName + attributeString + " />");
    }
    function generateAttributeString(attributes) {
        return $apU8A.default(attributes, function(value, key) {
            return " " + key + '="' + $3eba7fe55afbbee0$var$escapeHtmlAttribute(value) + '"';
        }).join("");
    }
    function text(value) {
        fragments.push($3eba7fe55afbbee0$var$escapeHtmlText(value));
    }
    function append(html) {
        fragments.push(html);
    }
    function asString() {
        return fragments.join("");
    }
    return {
        asString: asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing,
        _append: append
    };
}
function $3eba7fe55afbbee0$var$escapeHtmlText(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $3eba7fe55afbbee0$var$escapeHtmlAttribute(value) {
    return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}


var $e7ed7db11d9fcb2f$export$47a3d634abc09f70;
parcelRequire("eSbtG");
var $g4AGd = parcelRequire("g4AGd");
function $e7ed7db11d9fcb2f$var$symmetricMarkdownElement(end) {
    return $e7ed7db11d9fcb2f$var$markdownElement(end, end);
}
function $e7ed7db11d9fcb2f$var$markdownElement(start, end) {
    return function() {
        return {
            start: start,
            end: end
        };
    };
}
function $e7ed7db11d9fcb2f$var$markdownLink(attributes) {
    var href = attributes.href || "";
    if (href) return {
        start: "[",
        end: "](" + href + ")",
        anchorPosition: "before"
    };
    else return {};
}
function $e7ed7db11d9fcb2f$var$markdownImage(attributes) {
    var src = attributes.src || "";
    var altText = attributes.alt || "";
    if (src || altText) return {
        start: "![" + altText + "](" + src + ")"
    };
    else return {};
}
function $e7ed7db11d9fcb2f$var$markdownList(options) {
    return function(attributes, list) {
        return {
            start: list ? "\n" : "",
            end: list ? "" : "\n",
            list: {
                isOrdered: options.isOrdered,
                indent: list ? list.indent + 1 : 0,
                count: 0
            }
        };
    };
}
function $e7ed7db11d9fcb2f$var$markdownListItem(attributes, list, listItem) {
    list = list || {
        indent: 0,
        isOrdered: false,
        count: 0
    };
    list.count++;
    listItem.hasClosed = false;
    var bullet = list.isOrdered ? list.count + "." : "-";
    var start = $e7ed7db11d9fcb2f$var$repeatString("\t", list.indent) + bullet + " ";
    return {
        start: start,
        end: function() {
            if (!listItem.hasClosed) {
                listItem.hasClosed = true;
                return "\n";
            }
        }
    };
}
var $e7ed7db11d9fcb2f$var$htmlToMarkdown = {
    "p": $e7ed7db11d9fcb2f$var$markdownElement("", "\n\n"),
    "br": $e7ed7db11d9fcb2f$var$markdownElement("", "  \n"),
    "ul": $e7ed7db11d9fcb2f$var$markdownList({
        isOrdered: false
    }),
    "ol": $e7ed7db11d9fcb2f$var$markdownList({
        isOrdered: true
    }),
    "li": $e7ed7db11d9fcb2f$var$markdownListItem,
    "strong": $e7ed7db11d9fcb2f$var$symmetricMarkdownElement("__"),
    "em": $e7ed7db11d9fcb2f$var$symmetricMarkdownElement("*"),
    "a": $e7ed7db11d9fcb2f$var$markdownLink,
    "img": $e7ed7db11d9fcb2f$var$markdownImage
};
(function() {
    for(var i = 1; i <= 6; i++)$e7ed7db11d9fcb2f$var$htmlToMarkdown["h" + i] = $e7ed7db11d9fcb2f$var$markdownElement($e7ed7db11d9fcb2f$var$repeatString("#", i) + " ", "\n\n");
})();
function $e7ed7db11d9fcb2f$var$repeatString(value, count) {
    return new Array(count + 1).join(value);
}
function $e7ed7db11d9fcb2f$var$markdownWriter() {
    var fragments = [];
    var elementStack = [];
    var list = null;
    var listItem = {};
    function open(tagName, attributes) {
        attributes = attributes || {};
        var createElement = $e7ed7db11d9fcb2f$var$htmlToMarkdown[tagName] || function() {
            return {};
        };
        var element = createElement(attributes, list, listItem);
        elementStack.push({
            end: element.end,
            list: list
        });
        if (element.list) list = element.list;
        var anchorBeforeStart = element.anchorPosition === "before";
        if (anchorBeforeStart) writeAnchor(attributes);
        fragments.push(element.start || "");
        if (!anchorBeforeStart) writeAnchor(attributes);
    }
    function writeAnchor(attributes) {
        if (attributes.id) fragments.push('<a id="' + attributes.id + '"></a>');
    }
    function close(tagName) {
        var element = elementStack.pop();
        list = element.list;
        var end = $g4AGd.default(element.end) ? element.end() : element.end;
        fragments.push(end || "");
    }
    function selfClosing(tagName, attributes) {
        open(tagName, attributes);
        close(tagName);
    }
    function text(value) {
        fragments.push($e7ed7db11d9fcb2f$var$escapeMarkdown(value));
    }
    function asString() {
        return fragments.join("");
    }
    return {
        asString: asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing
    };
}
$e7ed7db11d9fcb2f$export$47a3d634abc09f70 = $e7ed7db11d9fcb2f$var$markdownWriter;
function $e7ed7db11d9fcb2f$var$escapeMarkdown(value) {
    return value.replace(/\\/g, '\\\\').replace(/([\`\*_\{\}\[\]\(\)\#\+\-\.\!])/g, '\\$1');
}


$8c0f195da7fee3de$export$47a3d634abc09f70 = $8c0f195da7fee3de$var$writer;
function $8c0f195da7fee3de$var$writer(options) {
    options = options || {};
    if (options.outputFormat === "markdown") return $e7ed7db11d9fcb2f$export$47a3d634abc09f70();
    else return $3eba7fe55afbbee0$export$47a3d634abc09f70(options);
}


$9a5777efe8b713c0$export$d10d7ab91c778d60 = $9a5777efe8b713c0$var$DocumentConverter;
function $9a5777efe8b713c0$var$DocumentConverter(options) {
    return {
        convertToHtml: function(element) {
            var comments = $6BxOE.default(element.type === $9a19f07fe6a873fd$export$b14ad400b1d09e0f.document ? element.comments : [], "commentId");
            var conversion = new $9a5777efe8b713c0$var$DocumentConversion(options, comments);
            return conversion.convertToHtml(element);
        }
    };
}
function $9a5777efe8b713c0$var$DocumentConversion(options, comments) {
    var noteNumber = 1;
    var noteReferences = [];
    var referencedComments = [];
    options = $1kSpe.default({
        ignoreEmptyParagraphs: true
    }, options);
    var idPrefix = options.idPrefix === undefined ? "" : options.idPrefix;
    var ignoreEmptyParagraphs = options.ignoreEmptyParagraphs;
    var defaultParagraphStyle = $2q3gK.topLevelElement("p");
    var styleMap = options.styleMap || [];
    function convertToHtml(document) {
        var messages = [];
        var html = elementToHtml(document, messages, {});
        var deferredNodes = [];
        $9a5777efe8b713c0$var$walkHtml(html, function(node) {
            if (node.type === "deferred") deferredNodes.push(node);
        });
        var deferredValues = {};
        return $lUVKW.mapSeries(deferredNodes, function(deferred) {
            return deferred.value().then(function(value) {
                deferredValues[deferred.id] = value;
            });
        }).then(function() {
            function replaceDeferred(nodes) {
                return $9a5777efe8b713c0$var$flatMap(nodes, function(node) {
                    if (node.type === "deferred") return deferredValues[node.id];
                    else if (node.children) return [
                        $1kSpe.default({}, node, {
                            children: replaceDeferred(node.children)
                        })
                    ];
                    else return [
                        node
                    ];
                });
            }
            var writer = $8c0f195da7fee3de$export$47a3d634abc09f70({
                prettyPrint: options.prettyPrint,
                outputFormat: options.outputFormat
            });
            $2bFLC.write(writer, $2bFLC.simplify(replaceDeferred(html)));
            return new $b398cbdc7abf8f61$export$8fdcabde73f49165(writer.asString(), messages);
        });
    }
    function convertElements(elements, messages, options) {
        return $9a5777efe8b713c0$var$flatMap(elements, function(element) {
            return elementToHtml(element, messages, options);
        });
    }
    function elementToHtml(element, messages, options) {
        if (!options) throw new Error("options not set");
        var handler = elementConverters[element.type];
        if (handler) return handler(element, messages, options);
        else return [];
    }
    function convertParagraph(element, messages, options) {
        return htmlPathForParagraph(element, messages).wrap(function() {
            var content = convertElements(element.children, messages, options);
            if (ignoreEmptyParagraphs) return content;
            else return [
                $2bFLC.forceWrite
            ].concat(content);
        });
    }
    function htmlPathForParagraph(element, messages) {
        var style = findStyle(element);
        if (style) return style.to;
        else {
            if (element.styleId) messages.push($9a5777efe8b713c0$var$unrecognisedStyleWarning("paragraph", element));
            return defaultParagraphStyle;
        }
    }
    function convertRun(run, messages, options) {
        var nodes = function() {
            return convertElements(run.children, messages, options);
        };
        var paths = [];
        if (run.highlight !== null) {
            var path = findHtmlPath({
                type: "highlight",
                color: run.highlight
            });
            if (path) paths.push(path);
        }
        if (run.isSmallCaps) paths.push(findHtmlPathForRunProperty("smallCaps"));
        if (run.isAllCaps) paths.push(findHtmlPathForRunProperty("allCaps"));
        if (run.isStrikethrough) paths.push(findHtmlPathForRunProperty("strikethrough", "s"));
        if (run.isUnderline) paths.push(findHtmlPathForRunProperty("underline"));
        if (run.verticalAlignment === $9a19f07fe6a873fd$export$983b95e2e3722091.subscript) paths.push($2q3gK.element("sub", {}, {
            fresh: false
        }));
        if (run.verticalAlignment === $9a19f07fe6a873fd$export$983b95e2e3722091.superscript) paths.push($2q3gK.element("sup", {}, {
            fresh: false
        }));
        if (run.isItalic) paths.push(findHtmlPathForRunProperty("italic", "em"));
        if (run.isBold) paths.push(findHtmlPathForRunProperty("bold", "strong"));
        var stylePath = $2q3gK.empty;
        var style = findStyle(run);
        if (style) stylePath = style.to;
        else if (run.styleId) messages.push($9a5777efe8b713c0$var$unrecognisedStyleWarning("run", run));
        paths.push(stylePath);
        paths.forEach(function(path) {
            nodes = path.wrap.bind(path, nodes);
        });
        return nodes();
    }
    function findHtmlPathForRunProperty(elementType, defaultTagName) {
        var path = findHtmlPath({
            type: elementType
        });
        if (path) return path;
        else if (defaultTagName) return $2q3gK.element(defaultTagName, {}, {
            fresh: false
        });
        else return $2q3gK.empty;
    }
    function findHtmlPath(element, defaultPath) {
        var style = findStyle(element);
        return style ? style.to : defaultPath;
    }
    function findStyle(element) {
        for(var i = 0; i < styleMap.length; i++){
            if (styleMap[i].from.matches(element)) return styleMap[i];
        }
    }
    function recoveringConvertImage(convertImage) {
        return function(image, messages) {
            return $lUVKW.attempt(function() {
                return convertImage(image, messages);
            }).caught(function(error) {
                messages.push($b398cbdc7abf8f61$export$a3bc9b8ed74fc(error));
                return [];
            });
        };
    }
    function noteHtmlId(note) {
        return referentHtmlId(note.noteType, note.noteId);
    }
    function noteRefHtmlId(note) {
        return referenceHtmlId(note.noteType, note.noteId);
    }
    function referentHtmlId(referenceType, referenceId) {
        return htmlId(referenceType + "-" + referenceId);
    }
    function referenceHtmlId(referenceType, referenceId) {
        return htmlId(referenceType + "-ref-" + referenceId);
    }
    function htmlId(suffix) {
        return idPrefix + suffix;
    }
    var defaultTablePath = $2q3gK.elements([
        $2q3gK.element("table", {}, {
            fresh: true
        })
    ]);
    function convertTable(element, messages, options) {
        return findHtmlPath(element, defaultTablePath).wrap(function() {
            return convertTableChildren(element, messages, options);
        });
    }
    function convertTableChildren(element, messages, options) {
        var bodyIndex = $9YYAC.default(element.children, function(child) {
            return !child.type === $9a19f07fe6a873fd$export$b14ad400b1d09e0f.tableRow || !child.isHeader;
        });
        if (bodyIndex === -1) bodyIndex = element.children.length;
        var children;
        if (bodyIndex === 0) children = convertElements(element.children, messages, $1kSpe.default({}, options, {
            isTableHeader: false
        }));
        else {
            var headRows = convertElements(element.children.slice(0, bodyIndex), messages, $1kSpe.default({}, options, {
                isTableHeader: true
            }));
            var bodyRows = convertElements(element.children.slice(bodyIndex), messages, $1kSpe.default({}, options, {
                isTableHeader: false
            }));
            children = [
                $2bFLC.freshElement("thead", {}, headRows),
                $2bFLC.freshElement("tbody", {}, bodyRows)
            ];
        }
        return [
            $2bFLC.forceWrite
        ].concat(children);
    }
    function convertTableRow(element, messages, options) {
        var children = convertElements(element.children, messages, options);
        return [
            $2bFLC.freshElement("tr", {}, [
                $2bFLC.forceWrite
            ].concat(children))
        ];
    }
    function convertTableCell(element, messages, options) {
        var tagName = options.isTableHeader ? "th" : "td";
        var children = convertElements(element.children, messages, options);
        var attributes = {};
        if (element.colSpan !== 1) attributes.colspan = element.colSpan.toString();
        if (element.rowSpan !== 1) attributes.rowspan = element.rowSpan.toString();
        return [
            $2bFLC.freshElement(tagName, attributes, [
                $2bFLC.forceWrite
            ].concat(children))
        ];
    }
    function convertCommentReference(reference, messages, options) {
        return findHtmlPath(reference, $2q3gK.ignore).wrap(function() {
            var comment = comments[reference.commentId];
            var count = referencedComments.length + 1;
            var label = "[" + $9a5777efe8b713c0$var$commentAuthorLabel(comment) + count + "]";
            referencedComments.push({
                label: label,
                comment: comment
            });
            // TODO: remove duplication with note references
            return [
                $2bFLC.freshElement("a", {
                    href: "#" + referentHtmlId("comment", reference.commentId),
                    id: referenceHtmlId("comment", reference.commentId)
                }, [
                    $2bFLC.text(label)
                ])
            ];
        });
    }
    function convertComment(referencedComment, messages, options) {
        // TODO: remove duplication with note references
        var label = referencedComment.label;
        var comment = referencedComment.comment;
        var body = convertElements(comment.body, messages, options).concat([
            $2bFLC.nonFreshElement("p", {}, [
                $2bFLC.text(" "),
                $2bFLC.freshElement("a", {
                    "href": "#" + referenceHtmlId("comment", comment.commentId)
                }, [
                    $2bFLC.text("\u2191")
                ])
            ])
        ]);
        return [
            $2bFLC.freshElement("dt", {
                "id": referentHtmlId("comment", comment.commentId)
            }, [
                $2bFLC.text("Comment " + label)
            ]),
            $2bFLC.freshElement("dd", {}, body)
        ];
    }
    function convertBreak(element, messages, options) {
        return htmlPathForBreak(element).wrap(function() {
            return [];
        });
    }
    function htmlPathForBreak(element) {
        var style = findStyle(element);
        if (style) return style.to;
        else if (element.breakType === "line") return $2q3gK.topLevelElement("br");
        else return $2q3gK.empty;
    }
    var elementConverters = {
        "document": function(document, messages, options) {
            var children = convertElements(document.children, messages, options);
            var notes = noteReferences.map(function(noteReference) {
                return document.notes.resolve(noteReference);
            });
            var notesNodes = convertElements(notes, messages, options);
            return children.concat([
                $2bFLC.freshElement("ol", {}, notesNodes),
                $2bFLC.freshElement("dl", {}, $9a5777efe8b713c0$var$flatMap(referencedComments, function(referencedComment) {
                    return convertComment(referencedComment, messages, options);
                }))
            ]);
        },
        "paragraph": convertParagraph,
        "run": convertRun,
        "text": function(element, messages, options) {
            return [
                $2bFLC.text(element.value)
            ];
        },
        "tab": function(element, messages, options) {
            return [
                $2bFLC.text("\t")
            ];
        },
        "hyperlink": function(element, messages, options) {
            var href = element.anchor ? "#" + htmlId(element.anchor) : element.href;
            var attributes = {
                href: href
            };
            if (element.targetFrame != null) attributes.target = element.targetFrame;
            var children = convertElements(element.children, messages, options);
            return [
                $2bFLC.nonFreshElement("a", attributes, children)
            ];
        },
        "checkbox": function(element) {
            var attributes = {
                type: "checkbox"
            };
            if (element.checked) attributes["checked"] = "checked";
            return [
                $2bFLC.freshElement("input", attributes)
            ];
        },
        "bookmarkStart": function(element, messages, options) {
            var anchor = $2bFLC.freshElement("a", {
                id: htmlId(element.name)
            }, [
                $2bFLC.forceWrite
            ]);
            return [
                anchor
            ];
        },
        "noteReference": function(element, messages, options) {
            noteReferences.push(element);
            var anchor = $2bFLC.freshElement("a", {
                href: "#" + noteHtmlId(element),
                id: noteRefHtmlId(element)
            }, [
                $2bFLC.text("[" + noteNumber++ + "]")
            ]);
            return [
                $2bFLC.freshElement("sup", {}, [
                    anchor
                ])
            ];
        },
        "note": function(element, messages, options) {
            var children = convertElements(element.body, messages, options);
            var backLink = $2bFLC.elementWithTag($2q3gK.element("p", {}, {
                fresh: false
            }), [
                $2bFLC.text(" "),
                $2bFLC.freshElement("a", {
                    href: "#" + noteRefHtmlId(element)
                }, [
                    $2bFLC.text("\u2191")
                ])
            ]);
            var body = children.concat([
                backLink
            ]);
            return $2bFLC.freshElement("li", {
                id: noteHtmlId(element)
            }, body);
        },
        "commentReference": convertCommentReference,
        "comment": convertComment,
        "image": $9a5777efe8b713c0$var$deferredConversion(recoveringConvertImage(options.convertImage || $fb1ge.dataUri)),
        "table": convertTable,
        "tableRow": convertTableRow,
        "tableCell": convertTableCell,
        "break": convertBreak
    };
    return {
        convertToHtml: convertToHtml
    };
}
var $9a5777efe8b713c0$var$deferredId = 1;
function $9a5777efe8b713c0$var$deferredConversion(func) {
    return function(element, messages, options) {
        return [
            {
                type: "deferred",
                id: $9a5777efe8b713c0$var$deferredId++,
                value: function() {
                    return func(element, messages, options);
                }
            }
        ];
    };
}
function $9a5777efe8b713c0$var$unrecognisedStyleWarning(type, element) {
    return $b398cbdc7abf8f61$export$491112666e282270("Unrecognised " + type + " style: '" + element.styleName + "'" + " (Style ID: " + element.styleId + ")");
}
function $9a5777efe8b713c0$var$flatMap(values, func) {
    return $3CMFi.default(values.map(func), true);
}
function $9a5777efe8b713c0$var$walkHtml(nodes, callback) {
    nodes.forEach(function(node) {
        callback(node);
        if (node.children) $9a5777efe8b713c0$var$walkHtml(node.children, callback);
    });
}
var $9a5777efe8b713c0$var$commentAuthorLabel = $9a5777efe8b713c0$export$6e29e379a5b99e3b = function commentAuthorLabel(comment) {
    return comment.authorInitials || "";
};


var $7d7fd9061cffbcaa$require$DocumentConverter = $9a5777efe8b713c0$export$d10d7ab91c778d60;
var $ad04addf639a7dc0$export$f04031f791975cf1;

function $ad04addf639a7dc0$var$convertElementToRawText(element) {
    if (element.type === "text") return element.value;
    else if (element.type === $9a19f07fe6a873fd$export$b14ad400b1d09e0f.tab) return "\t";
    else {
        var tail = element.type === "paragraph" ? "\n\n" : "";
        return (element.children || []).map($ad04addf639a7dc0$var$convertElementToRawText).join("") + tail;
    }
}
$ad04addf639a7dc0$export$f04031f791975cf1 = $ad04addf639a7dc0$var$convertElementToRawText;


var $7d7fd9061cffbcaa$require$convertElementToRawText = $ad04addf639a7dc0$export$f04031f791975cf1;
var $72e198c7a720dc60$export$c013b05e5703966c;
var $72e198c7a720dc60$export$8355e188a552b07e;
var $72e198c7a720dc60$export$433ccb34ac23a8e9;
parcelRequire("eSbtG");
var $1kSpe = parcelRequire("1kSpe");
var $a26353dd9cb118b7$export$7acfa6ed01010e37;
var $a26353dd9cb118b7$export$354076178bdef094;
var $a26353dd9cb118b7$export$30f3b02011db23c0;
var $a26353dd9cb118b7$export$5be82eb8d376fece;
var $a26353dd9cb118b7$export$7799bd957249d7a0;
var $a26353dd9cb118b7$export$50792b0e93539fde;
var $a26353dd9cb118b7$export$66e1bcdf7cde41a0;
var $a26353dd9cb118b7$export$74d15b5d79bf9ea;
var $a26353dd9cb118b7$export$fbeb3a3956e8a3c7;

$a26353dd9cb118b7$export$7acfa6ed01010e37 = (parcelRequire("5dm5a")).Parser;

$a26353dd9cb118b7$export$354076178bdef094 = (parcelRequire("2VAUF"));

$a26353dd9cb118b7$export$30f3b02011db23c0 = (parcelRequire("aZ3NE"));

$a26353dd9cb118b7$export$5be82eb8d376fece = (parcelRequire("3rodx"));

$a26353dd9cb118b7$export$7799bd957249d7a0 = (parcelRequire("1J3fu"));

$a26353dd9cb118b7$export$50792b0e93539fde = (parcelRequire("kojsS"));

$a26353dd9cb118b7$export$66e1bcdf7cde41a0 = (parcelRequire("77zof"));

$a26353dd9cb118b7$export$74d15b5d79bf9ea = (parcelRequire("1tQWe")).RegexTokeniser;
$a26353dd9cb118b7$export$fbeb3a3956e8a3c7 = function(ruleBuilder) {
    var rule;
    return function(input) {
        if (!rule) rule = ruleBuilder();
        return rule(input);
    };
};


var $2c701d5454d20a39$export$9c206ddddb32a9b;
var $2c701d5454d20a39$export$889ea624f2cb2c57;
var $2c701d5454d20a39$export$9852986a3ec5f6a0;
var $2c701d5454d20a39$export$73ba5813cda80a49;
var $2c701d5454d20a39$export$5540da1282cbf565;
var $2c701d5454d20a39$export$425327af25286e5e;
var $2c701d5454d20a39$export$19426ff118fe8be;
var $2c701d5454d20a39$export$dc07c1d187ec2934;
var $2c701d5454d20a39$export$394ff16a4cefe989;
var $2c701d5454d20a39$export$e4043f67d36cbb26;
var $2c701d5454d20a39$export$841d4c6db70c1a65;
var $2c701d5454d20a39$export$a1aa2dd4ad0d3f6;
var $2c701d5454d20a39$export$1b438cdd7ed26c35;
var $2c701d5454d20a39$export$5a38f5b463e49b91;
var $2c701d5454d20a39$export$bdcdec1f91f16dff;
var $2c701d5454d20a39$export$68326237475e9a7d;
$2c701d5454d20a39$export$9c206ddddb32a9b = $2c701d5454d20a39$var$paragraph;
$2c701d5454d20a39$export$889ea624f2cb2c57 = $2c701d5454d20a39$var$run;
$2c701d5454d20a39$export$9852986a3ec5f6a0 = $2c701d5454d20a39$var$table;
$2c701d5454d20a39$export$73ba5813cda80a49 = new $2c701d5454d20a39$var$Matcher("bold");
$2c701d5454d20a39$export$5540da1282cbf565 = new $2c701d5454d20a39$var$Matcher("italic");
$2c701d5454d20a39$export$425327af25286e5e = new $2c701d5454d20a39$var$Matcher("underline");
$2c701d5454d20a39$export$19426ff118fe8be = new $2c701d5454d20a39$var$Matcher("strikethrough");
$2c701d5454d20a39$export$dc07c1d187ec2934 = new $2c701d5454d20a39$var$Matcher("allCaps");
$2c701d5454d20a39$export$394ff16a4cefe989 = new $2c701d5454d20a39$var$Matcher("smallCaps");
$2c701d5454d20a39$export$e4043f67d36cbb26 = $2c701d5454d20a39$var$highlight;
$2c701d5454d20a39$export$841d4c6db70c1a65 = new $2c701d5454d20a39$var$Matcher("commentReference");
$2c701d5454d20a39$export$a1aa2dd4ad0d3f6 = new $2c701d5454d20a39$var$BreakMatcher({
    breakType: "line"
});
$2c701d5454d20a39$export$1b438cdd7ed26c35 = new $2c701d5454d20a39$var$BreakMatcher({
    breakType: "page"
});
$2c701d5454d20a39$export$5a38f5b463e49b91 = new $2c701d5454d20a39$var$BreakMatcher({
    breakType: "column"
});
$2c701d5454d20a39$export$bdcdec1f91f16dff = $2c701d5454d20a39$var$equalTo;
$2c701d5454d20a39$export$68326237475e9a7d = $2c701d5454d20a39$var$startsWith;
function $2c701d5454d20a39$var$paragraph(options) {
    return new $2c701d5454d20a39$var$Matcher("paragraph", options);
}
function $2c701d5454d20a39$var$run(options) {
    return new $2c701d5454d20a39$var$Matcher("run", options);
}
function $2c701d5454d20a39$var$table(options) {
    return new $2c701d5454d20a39$var$Matcher("table", options);
}
function $2c701d5454d20a39$var$highlight(options) {
    return new $2c701d5454d20a39$var$HighlightMatcher(options);
}
function $2c701d5454d20a39$var$Matcher(elementType, options) {
    options = options || {};
    this._elementType = elementType;
    this._styleId = options.styleId;
    this._styleName = options.styleName;
    if (options.list) {
        this._listIndex = options.list.levelIndex;
        this._listIsOrdered = options.list.isOrdered;
    }
}
$2c701d5454d20a39$var$Matcher.prototype.matches = function(element) {
    return element.type === this._elementType && (this._styleId === undefined || element.styleId === this._styleId) && (this._styleName === undefined || element.styleName && this._styleName.operator(this._styleName.operand, element.styleName)) && (this._listIndex === undefined || $2c701d5454d20a39$var$isList(element, this._listIndex, this._listIsOrdered)) && (this._breakType === undefined || this._breakType === element.breakType);
};
function $2c701d5454d20a39$var$HighlightMatcher(options) {
    options = options || {};
    this._color = options.color;
}
$2c701d5454d20a39$var$HighlightMatcher.prototype.matches = function(element) {
    return element.type === "highlight" && (this._color === undefined || element.color === this._color);
};
function $2c701d5454d20a39$var$BreakMatcher(options) {
    options = options || {};
    this._breakType = options.breakType;
}
$2c701d5454d20a39$var$BreakMatcher.prototype.matches = function(element) {
    return element.type === "break" && (this._breakType === undefined || element.breakType === this._breakType);
};
function $2c701d5454d20a39$var$isList(element, levelIndex, isOrdered) {
    return element.numbering && element.numbering.level == levelIndex && element.numbering.isOrdered == isOrdered;
}
function $2c701d5454d20a39$var$equalTo(value) {
    return {
        operator: $2c701d5454d20a39$var$operatorEqualTo,
        operand: value
    };
}
function $2c701d5454d20a39$var$startsWith(value) {
    return {
        operator: $2c701d5454d20a39$var$operatorStartsWith,
        operand: value
    };
}
function $2c701d5454d20a39$var$operatorEqualTo(first, second) {
    return first.toUpperCase() === second.toUpperCase();
}
function $2c701d5454d20a39$var$operatorStartsWith(first, second) {
    return second.toUpperCase().indexOf(first.toUpperCase()) === 0;
}



var $2q3gK = parcelRequire("2q3gK");
var $34e411aaaae99e8f$export$3e101593fe008f79;

var $34e411aaaae99e8f$var$RegexTokeniser = $a26353dd9cb118b7$export$74d15b5d79bf9ea;
$34e411aaaae99e8f$export$3e101593fe008f79 = $34e411aaaae99e8f$var$tokenise;
var $34e411aaaae99e8f$var$stringPrefix = "'((?:\\\\.|[^'])*)";
function $34e411aaaae99e8f$var$tokenise(string) {
    var identifierCharacter = "(?:[a-zA-Z\\-_]|\\\\.)";
    var tokeniser = new $34e411aaaae99e8f$var$RegexTokeniser([
        {
            name: "identifier",
            regex: new RegExp("(" + identifierCharacter + "(?:" + identifierCharacter + "|[0-9])*)")
        },
        {
            name: "dot",
            regex: /\./
        },
        {
            name: "colon",
            regex: /:/
        },
        {
            name: "gt",
            regex: />/
        },
        {
            name: "whitespace",
            regex: /\s+/
        },
        {
            name: "arrow",
            regex: /=>/
        },
        {
            name: "equals",
            regex: /=/
        },
        {
            name: "startsWith",
            regex: /\^=/
        },
        {
            name: "open-paren",
            regex: /\(/
        },
        {
            name: "close-paren",
            regex: /\)/
        },
        {
            name: "open-square-bracket",
            regex: /\[/
        },
        {
            name: "close-square-bracket",
            regex: /\]/
        },
        {
            name: "string",
            regex: new RegExp($34e411aaaae99e8f$var$stringPrefix + "'")
        },
        {
            name: "unterminated-string",
            regex: new RegExp($34e411aaaae99e8f$var$stringPrefix)
        },
        {
            name: "integer",
            regex: /([0-9]+)/
        },
        {
            name: "choice",
            regex: /\|/
        },
        {
            name: "bang",
            regex: /(!)/
        }
    ]);
    return tokeniser.tokenise(string);
}


var $72e198c7a720dc60$require$tokenise = $34e411aaaae99e8f$export$3e101593fe008f79;

$72e198c7a720dc60$export$c013b05e5703966c = $72e198c7a720dc60$var$readHtmlPath;
$72e198c7a720dc60$export$8355e188a552b07e = $72e198c7a720dc60$var$readDocumentMatcher;
$72e198c7a720dc60$export$433ccb34ac23a8e9 = $72e198c7a720dc60$var$readStyle;
function $72e198c7a720dc60$var$readStyle(string) {
    return $72e198c7a720dc60$var$parseString($72e198c7a720dc60$var$styleRule, string);
}
function $72e198c7a720dc60$var$createStyleRule() {
    return $a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.sequence.capture($72e198c7a720dc60$var$documentMatcherRule()), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("whitespace"), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("arrow"), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture($a26353dd9cb118b7$export$354076178bdef094.optional($a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("whitespace"), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture($72e198c7a720dc60$var$htmlPathRule())).head())), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("end")).map(function(documentMatcher, htmlPath) {
        return {
            from: documentMatcher,
            to: htmlPath.valueOrElse($2q3gK.empty)
        };
    });
}
function $72e198c7a720dc60$var$readDocumentMatcher(string) {
    return $72e198c7a720dc60$var$parseString($72e198c7a720dc60$var$documentMatcherRule(), string);
}
function $72e198c7a720dc60$var$documentMatcherRule() {
    var sequence = $a26353dd9cb118b7$export$354076178bdef094.sequence;
    var identifierToConstant = function(identifier, constant) {
        return $a26353dd9cb118b7$export$354076178bdef094.then($a26353dd9cb118b7$export$354076178bdef094.token("identifier", identifier), function() {
            return constant;
        });
    };
    var paragraphRule = identifierToConstant("p", $2c701d5454d20a39$export$9c206ddddb32a9b);
    var runRule = identifierToConstant("r", $2c701d5454d20a39$export$889ea624f2cb2c57);
    var elementTypeRule = $a26353dd9cb118b7$export$354076178bdef094.firstOf("p or r or table", paragraphRule, runRule);
    var styleIdRule = $a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("dot"), $a26353dd9cb118b7$export$354076178bdef094.sequence.cut(), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture($72e198c7a720dc60$var$identifierRule)).map(function(styleId) {
        return {
            styleId: styleId
        };
    });
    var styleNameMatcherRule = $a26353dd9cb118b7$export$354076178bdef094.firstOf("style name matcher", $a26353dd9cb118b7$export$354076178bdef094.then($a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("equals"), $a26353dd9cb118b7$export$354076178bdef094.sequence.cut(), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture($72e198c7a720dc60$var$stringRule)).head(), function(styleName) {
        return {
            styleName: $2c701d5454d20a39$export$bdcdec1f91f16dff(styleName)
        };
    }), $a26353dd9cb118b7$export$354076178bdef094.then($a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("startsWith"), $a26353dd9cb118b7$export$354076178bdef094.sequence.cut(), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture($72e198c7a720dc60$var$stringRule)).head(), function(styleName) {
        return {
            styleName: $2c701d5454d20a39$export$68326237475e9a7d(styleName)
        };
    }));
    var styleNameRule = $a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("open-square-bracket"), $a26353dd9cb118b7$export$354076178bdef094.sequence.cut(), $a26353dd9cb118b7$export$354076178bdef094.token("identifier", "style-name"), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture(styleNameMatcherRule), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("close-square-bracket")).head();
    var listTypeRule = $a26353dd9cb118b7$export$354076178bdef094.firstOf("list type", identifierToConstant("ordered-list", {
        isOrdered: true
    }), identifierToConstant("unordered-list", {
        isOrdered: false
    }));
    var listRule = sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("colon"), sequence.capture(listTypeRule), sequence.cut(), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("open-paren"), sequence.capture($72e198c7a720dc60$var$integerRule), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("close-paren")).map(function(listType, levelNumber) {
        return {
            list: {
                isOrdered: listType.isOrdered,
                levelIndex: levelNumber - 1
            }
        };
    });
    function createMatcherSuffixesRule(rules) {
        var matcherSuffix = $a26353dd9cb118b7$export$354076178bdef094.firstOf.apply($a26353dd9cb118b7$export$354076178bdef094.firstOf, [
            "matcher suffix"
        ].concat(rules));
        var matcherSuffixes = $a26353dd9cb118b7$export$354076178bdef094.zeroOrMore(matcherSuffix);
        return $a26353dd9cb118b7$export$354076178bdef094.then(matcherSuffixes, function(suffixes) {
            var matcherOptions = {};
            suffixes.forEach(function(suffix) {
                $1kSpe.default(matcherOptions, suffix);
            });
            return matcherOptions;
        });
    }
    var paragraphOrRun = sequence(sequence.capture(elementTypeRule), sequence.capture(createMatcherSuffixesRule([
        styleIdRule,
        styleNameRule,
        listRule
    ]))).map(function(createMatcher, matcherOptions) {
        return createMatcher(matcherOptions);
    });
    var table = sequence($a26353dd9cb118b7$export$354076178bdef094.token("identifier", "table"), sequence.capture(createMatcherSuffixesRule([
        styleIdRule,
        styleNameRule
    ]))).map(function(options) {
        return $2c701d5454d20a39$export$9852986a3ec5f6a0(options);
    });
    var bold = identifierToConstant("b", $2c701d5454d20a39$export$73ba5813cda80a49);
    var italic = identifierToConstant("i", $2c701d5454d20a39$export$5540da1282cbf565);
    var underline = identifierToConstant("u", $2c701d5454d20a39$export$425327af25286e5e);
    var strikethrough = identifierToConstant("strike", $2c701d5454d20a39$export$19426ff118fe8be);
    var allCaps = identifierToConstant("all-caps", $2c701d5454d20a39$export$dc07c1d187ec2934);
    var smallCaps = identifierToConstant("small-caps", $2c701d5454d20a39$export$394ff16a4cefe989);
    var highlight = sequence($a26353dd9cb118b7$export$354076178bdef094.token("identifier", "highlight"), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture($a26353dd9cb118b7$export$354076178bdef094.optional($a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("open-square-bracket"), $a26353dd9cb118b7$export$354076178bdef094.sequence.cut(), $a26353dd9cb118b7$export$354076178bdef094.token("identifier", "color"), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("equals"), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture($72e198c7a720dc60$var$stringRule), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("close-square-bracket")).head()))).map(function(color) {
        return $2c701d5454d20a39$export$e4043f67d36cbb26({
            color: color.valueOrElse(undefined)
        });
    });
    var commentReference = identifierToConstant("comment-reference", $2c701d5454d20a39$export$841d4c6db70c1a65);
    var breakMatcher = sequence($a26353dd9cb118b7$export$354076178bdef094.token("identifier", "br"), sequence.cut(), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("open-square-bracket"), $a26353dd9cb118b7$export$354076178bdef094.token("identifier", "type"), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("equals"), sequence.capture($72e198c7a720dc60$var$stringRule), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("close-square-bracket")).map(function(breakType) {
        switch(breakType){
            case "line":
                return $2c701d5454d20a39$export$a1aa2dd4ad0d3f6;
            case "page":
                return $2c701d5454d20a39$export$1b438cdd7ed26c35;
            case "column":
                return $2c701d5454d20a39$export$5a38f5b463e49b91;
            default:
        }
    });
    return $a26353dd9cb118b7$export$354076178bdef094.firstOf("element type", paragraphOrRun, table, bold, italic, underline, strikethrough, allCaps, smallCaps, highlight, commentReference, breakMatcher);
}
function $72e198c7a720dc60$var$readHtmlPath(string) {
    return $72e198c7a720dc60$var$parseString($72e198c7a720dc60$var$htmlPathRule(), string);
}
function $72e198c7a720dc60$var$htmlPathRule() {
    var capture = $a26353dd9cb118b7$export$354076178bdef094.sequence.capture;
    var whitespaceRule = $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("whitespace");
    var freshRule = $a26353dd9cb118b7$export$354076178bdef094.then($a26353dd9cb118b7$export$354076178bdef094.optional($a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("colon"), $a26353dd9cb118b7$export$354076178bdef094.token("identifier", "fresh"))), function(option) {
        return option.map(function() {
            return true;
        }).valueOrElse(false);
    });
    var separatorRule = $a26353dd9cb118b7$export$354076178bdef094.then($a26353dd9cb118b7$export$354076178bdef094.optional($a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("colon"), $a26353dd9cb118b7$export$354076178bdef094.token("identifier", "separator"), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("open-paren"), capture($72e198c7a720dc60$var$stringRule), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("close-paren")).head()), function(option) {
        return option.valueOrElse("");
    });
    var tagNamesRule = $a26353dd9cb118b7$export$354076178bdef094.oneOrMoreWithSeparator($72e198c7a720dc60$var$identifierRule, $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("choice"));
    var styleElementRule = $a26353dd9cb118b7$export$354076178bdef094.sequence(capture(tagNamesRule), capture($a26353dd9cb118b7$export$354076178bdef094.zeroOrMore($72e198c7a720dc60$var$attributeOrClassRule)), capture(freshRule), capture(separatorRule)).map(function(tagName, attributesList, fresh, separator) {
        var attributes = {};
        var options = {};
        attributesList.forEach(function(attribute) {
            if (attribute.append && attributes[attribute.name]) attributes[attribute.name] += " " + attribute.value;
            else attributes[attribute.name] = attribute.value;
        });
        if (fresh) options.fresh = true;
        if (separator) options.separator = separator;
        return $2q3gK.element(tagName, attributes, options);
    });
    return $a26353dd9cb118b7$export$354076178bdef094.firstOf("html path", $a26353dd9cb118b7$export$354076178bdef094.then($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("bang"), function() {
        return $2q3gK.ignore;
    }), $a26353dd9cb118b7$export$354076178bdef094.then($a26353dd9cb118b7$export$354076178bdef094.zeroOrMoreWithSeparator(styleElementRule, $a26353dd9cb118b7$export$354076178bdef094.sequence(whitespaceRule, $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("gt"), whitespaceRule)), $2q3gK.elements));
}
var $72e198c7a720dc60$var$identifierRule = $a26353dd9cb118b7$export$354076178bdef094.then($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("identifier"), $72e198c7a720dc60$var$decodeEscapeSequences);
var $72e198c7a720dc60$var$integerRule = $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("integer");
var $72e198c7a720dc60$var$stringRule = $a26353dd9cb118b7$export$354076178bdef094.then($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("string"), $72e198c7a720dc60$var$decodeEscapeSequences);
var $72e198c7a720dc60$var$escapeSequences = {
    "n": "\n",
    "r": "\r",
    "t": "\t"
};
function $72e198c7a720dc60$var$decodeEscapeSequences(value) {
    return value.replace(/\\(.)/g, function(match, code) {
        return $72e198c7a720dc60$var$escapeSequences[code] || code;
    });
}
var $72e198c7a720dc60$var$attributeRule = $a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("open-square-bracket"), $a26353dd9cb118b7$export$354076178bdef094.sequence.cut(), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture($72e198c7a720dc60$var$identifierRule), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("equals"), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture($72e198c7a720dc60$var$stringRule), $a26353dd9cb118b7$export$354076178bdef094.tokenOfType("close-square-bracket")).map(function(name, value) {
    return {
        name: name,
        value: value,
        append: false
    };
});
var $72e198c7a720dc60$var$classRule = $a26353dd9cb118b7$export$354076178bdef094.sequence($a26353dd9cb118b7$export$354076178bdef094.tokenOfType("dot"), $a26353dd9cb118b7$export$354076178bdef094.sequence.cut(), $a26353dd9cb118b7$export$354076178bdef094.sequence.capture($72e198c7a720dc60$var$identifierRule)).map(function(className) {
    return {
        name: "class",
        value: className,
        append: true
    };
});
var $72e198c7a720dc60$var$attributeOrClassRule = $a26353dd9cb118b7$export$354076178bdef094.firstOf("attribute or class", $72e198c7a720dc60$var$attributeRule, $72e198c7a720dc60$var$classRule);
function $72e198c7a720dc60$var$parseString(rule, string) {
    var tokens = $72e198c7a720dc60$require$tokenise(string);
    var parser = $a26353dd9cb118b7$export$7acfa6ed01010e37();
    var parseResult = parser.parseTokens(rule, tokens);
    if (parseResult.isSuccess()) return $b398cbdc7abf8f61$export$fe7c49d056ea1d88(parseResult.value());
    else return new $b398cbdc7abf8f61$export$8fdcabde73f49165(null, [
        $b398cbdc7abf8f61$export$491112666e282270($72e198c7a720dc60$var$describeFailure(string, parseResult))
    ]);
}
function $72e198c7a720dc60$var$describeFailure(input, parseResult) {
    return "Did not understand this style mapping, so ignored it: " + input + "\n" + parseResult.errors().map($72e198c7a720dc60$var$describeError).join("\n");
}
function $72e198c7a720dc60$var$describeError(error) {
    return "Error was at character number " + error.characterNumber() + ": " + "Expected " + error.expected + " but got " + error.actual;
}
var $72e198c7a720dc60$var$styleRule = $72e198c7a720dc60$var$createStyleRule();


var $7d7fd9061cffbcaa$require$readStyle = $72e198c7a720dc60$export$433ccb34ac23a8e9;
var $c5192c037dea0315$export$78af9b5fc65e58de;
var $c5192c037dea0315$export$eb9991766a046a21;
var $c5192c037dea0315$export$635424202fde079c;
$c5192c037dea0315$export$78af9b5fc65e58de = $c5192c037dea0315$var$readOptions;
parcelRequire("eSbtG");
var $1kSpe = parcelRequire("1kSpe");
var $04NNv = parcelRequire("04NNv");
var $c5192c037dea0315$var$defaultStyleMap = $c5192c037dea0315$export$eb9991766a046a21 = [
    "p.Heading1 => h1:fresh",
    "p.Heading2 => h2:fresh",
    "p.Heading3 => h3:fresh",
    "p.Heading4 => h4:fresh",
    "p.Heading5 => h5:fresh",
    "p.Heading6 => h6:fresh",
    "p[style-name='Heading 1'] => h1:fresh",
    "p[style-name='Heading 2'] => h2:fresh",
    "p[style-name='Heading 3'] => h3:fresh",
    "p[style-name='Heading 4'] => h4:fresh",
    "p[style-name='Heading 5'] => h5:fresh",
    "p[style-name='Heading 6'] => h6:fresh",
    "p[style-name='heading 1'] => h1:fresh",
    "p[style-name='heading 2'] => h2:fresh",
    "p[style-name='heading 3'] => h3:fresh",
    "p[style-name='heading 4'] => h4:fresh",
    "p[style-name='heading 5'] => h5:fresh",
    "p[style-name='heading 6'] => h6:fresh",
    // Apple Pages
    "p.Heading => h1:fresh",
    "p[style-name='Heading'] => h1:fresh",
    "r[style-name='Strong'] => strong",
    "p[style-name='footnote text'] => p:fresh",
    "r[style-name='footnote reference'] =>",
    "p[style-name='endnote text'] => p:fresh",
    "r[style-name='endnote reference'] =>",
    "p[style-name='annotation text'] => p:fresh",
    "r[style-name='annotation reference'] =>",
    // LibreOffice
    "p[style-name='Footnote'] => p:fresh",
    "r[style-name='Footnote anchor'] =>",
    "p[style-name='Endnote'] => p:fresh",
    "r[style-name='Endnote anchor'] =>",
    "p:unordered-list(1) => ul > li:fresh",
    "p:unordered-list(2) => ul|ol > li > ul > li:fresh",
    "p:unordered-list(3) => ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:unordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:unordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:ordered-list(1) => ol > li:fresh",
    "p:ordered-list(2) => ul|ol > li > ol > li:fresh",
    "p:ordered-list(3) => ul|ol > li > ul|ol > li > ol > li:fresh",
    "p:ordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh",
    "p:ordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh",
    "r[style-name='Hyperlink'] =>",
    "p[style-name='Normal'] => p:fresh",
    // Apple Pages
    "p.Body => p:fresh",
    "p[style-name='Body'] => p:fresh"
];
var $c5192c037dea0315$var$standardOptions = $c5192c037dea0315$export$635424202fde079c = {
    externalFileAccess: false,
    transformDocument: $c5192c037dea0315$var$identity,
    includeDefaultStyleMap: true,
    includeEmbeddedStyleMap: true
};
function $c5192c037dea0315$var$readOptions(options) {
    options = options || {};
    return $1kSpe.default({}, $c5192c037dea0315$var$standardOptions, options, {
        customStyleMap: $c5192c037dea0315$var$readStyleMap(options.styleMap),
        readStyleMap: function() {
            var styleMap = this.customStyleMap;
            if (this.includeEmbeddedStyleMap) styleMap = styleMap.concat($c5192c037dea0315$var$readStyleMap(this.embeddedStyleMap));
            if (this.includeDefaultStyleMap) styleMap = styleMap.concat($c5192c037dea0315$var$defaultStyleMap);
            return styleMap;
        }
    });
}
function $c5192c037dea0315$var$readStyleMap(styleMap) {
    if (!styleMap) return [];
    else if ($04NNv.default(styleMap)) return styleMap.split("\n").map(function(line) {
        return line.trim();
    }).filter(function(line) {
        return line !== "" && line.charAt(0) !== "#";
    });
    else return styleMap;
}
function $c5192c037dea0315$var$identity(value) {
    return value;
}


var $7d7fd9061cffbcaa$require$readOptions = $c5192c037dea0315$export$78af9b5fc65e58de;
var $ece9d2a7393edb70$export$dabc29ca0a11e3cc;

var $lUVKW = parcelRequire("lUVKW");

$ece9d2a7393edb70$export$dabc29ca0a11e3cc = $ece9d2a7393edb70$var$openZip;
function $ece9d2a7393edb70$var$openZip(options) {
    if (options.arrayBuffer) return $lUVKW.resolve($57cf05b5ae854a60$export$94ea64f322e5a37c(options.arrayBuffer));
    else return $lUVKW.reject(new Error("Could not find file in options"));
}



var $7d7fd9061cffbcaa$require$Result = $b398cbdc7abf8f61$export$8fdcabde73f49165;
$7d7fd9061cffbcaa$export$7b82ddf1ba8788ff = $7d7fd9061cffbcaa$var$convertToHtml;
$7d7fd9061cffbcaa$export$16c74263c98473fb = $7d7fd9061cffbcaa$var$convertToMarkdown;
$7d7fd9061cffbcaa$export$9c68d69a4c5bbcf9 = $7d7fd9061cffbcaa$var$convert;
$7d7fd9061cffbcaa$export$a1ba744cb18565b5 = $7d7fd9061cffbcaa$var$extractRawText;

$7d7fd9061cffbcaa$export$6c746a5570b8b35c = (parcelRequire("fb1ge"));

$7d7fd9061cffbcaa$export$63e4f03d302d3e40 = (parcelRequire("jS8wL"));

$7d7fd9061cffbcaa$export$425327af25286e5e = (parcelRequire("l1uRy"));
$7d7fd9061cffbcaa$export$7d85d7e73199d20c = $7d7fd9061cffbcaa$var$embedStyleMap;
$7d7fd9061cffbcaa$export$3d6d846391b5780c = $7d7fd9061cffbcaa$var$readEmbeddedStyleMap;
function $7d7fd9061cffbcaa$var$convertToHtml(input, options) {
    return $7d7fd9061cffbcaa$var$convert(input, options);
}
function $7d7fd9061cffbcaa$var$convertToMarkdown(input, options) {
    var markdownOptions = Object.create(options || {});
    markdownOptions.outputFormat = "markdown";
    return $7d7fd9061cffbcaa$var$convert(input, markdownOptions);
}
function $7d7fd9061cffbcaa$var$convert(input, options) {
    options = $7d7fd9061cffbcaa$require$readOptions(options);
    return $ece9d2a7393edb70$export$dabc29ca0a11e3cc(input).tap(function(docxFile) {
        return $ca7d37d7ee43a4b6$export$98fd944a2c837b93(docxFile).then(function(styleMap) {
            options.embeddedStyleMap = styleMap;
        });
    }).then(function(docxFile) {
        return $76ae973f152dcbe2$export$aafa59e2e03f2942(docxFile, input, options).then(function(documentResult) {
            return documentResult.map(options.transformDocument);
        }).then(function(documentResult) {
            return $7d7fd9061cffbcaa$var$convertDocumentToHtml(documentResult, options);
        });
    });
}
function $7d7fd9061cffbcaa$var$readEmbeddedStyleMap(input) {
    return $ece9d2a7393edb70$export$dabc29ca0a11e3cc(input).then($ca7d37d7ee43a4b6$export$98fd944a2c837b93);
}
function $7d7fd9061cffbcaa$var$convertDocumentToHtml(documentResult, options) {
    var styleMapResult = $7d7fd9061cffbcaa$var$parseStyleMap(options.readStyleMap());
    var parsedOptions = $1kSpe.default({}, options, {
        styleMap: styleMapResult.value
    });
    var documentConverter = new $7d7fd9061cffbcaa$require$DocumentConverter(parsedOptions);
    return documentResult.flatMapThen(function(document) {
        return styleMapResult.flatMapThen(function(styleMap) {
            return documentConverter.convertToHtml(document);
        });
    });
}
function $7d7fd9061cffbcaa$var$parseStyleMap(styleMap) {
    return $7d7fd9061cffbcaa$require$Result.combine((styleMap || []).map($7d7fd9061cffbcaa$require$readStyle)).map(function(styleMap) {
        return styleMap.filter(function(styleMapping) {
            return !!styleMapping;
        });
    });
}
function $7d7fd9061cffbcaa$var$extractRawText(input) {
    return $ece9d2a7393edb70$export$dabc29ca0a11e3cc(input).then($76ae973f152dcbe2$export$aafa59e2e03f2942).then(function(documentResult) {
        return documentResult.map($7d7fd9061cffbcaa$require$convertElementToRawText);
    });
}
function $7d7fd9061cffbcaa$var$embedStyleMap(input, styleMap) {
    return $ece9d2a7393edb70$export$dabc29ca0a11e3cc(input).tap(function(docxFile) {
        return $ca7d37d7ee43a4b6$export$f183c412da6b1c0(docxFile, styleMap);
    }).then(function(docxFile) {
        return docxFile.toArrayBuffer();
    }).then(function(arrayBuffer) {
        return {
            toArrayBuffer: function() {
                return arrayBuffer;
            },
            toBuffer: function() {
                return $7d7fd9061cffbcaa$require$Buffer.from(arrayBuffer);
            }
        };
    });
}
$7d7fd9061cffbcaa$export$65b53a1b2f72fd4c = function() {
    throw new Error('Use a raw string instead of mammoth.styleMapping e.g. "p[style-name=\'Title\'] => h1" instead of mammoth.styleMapping("p[style-name=\'Title\'] => h1")');
};


var $f72755886b9c5753$exports = {};
/*! @license DOMPurify 3.4.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.7/LICENSE */ (function(global, factory) {
    $f72755886b9c5753$exports = factory();
})($f72755886b9c5753$exports, function() {
    'use strict';
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = true, o = false;
            try {
                if (i = (t = t.call(r)).next, 0 === l) ;
                else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = true, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    const entries = Object.entries, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    let freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    let _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const arrayIsArray = Array.isArray;
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const numberToString = unapply(Number.prototype.toString);
    const booleanToString = unapply(Boolean.prototype.toString);
    const bigintToString = typeof BigInt === 'undefined' ? null : unapply(BigInt.prototype.toString);
    const symbolToString = typeof Symbol === 'undefined' ? null : unapply(Symbol.prototype.toString);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const objectToString = unapply(Object.prototype.toString);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        if (!arrayIsArray(array)) return set;
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const _ref2 of entries(object)){
            var _ref3 = _slicedToArray(_ref2, 2);
            const property = _ref3[0];
            const value = _ref3[1];
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (arrayIsArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * Convert non-node values into strings without depending on direct property access.
   *
   * @param value - The value to stringify.
   * @returns A string representation of the provided value.
   */ function stringifyValue(value) {
        switch(typeof value){
            case 'string':
                return value;
            case 'number':
                return numberToString(value);
            case 'boolean':
                return booleanToString(value);
            case 'bigint':
                return bigintToString ? bigintToString(value) : '0';
            case 'symbol':
                return symbolToString ? symbolToString(value) : 'Symbol()';
            case 'undefined':
                return objectToString(value);
            case 'function':
            case 'object':
                {
                    if (value === null) return objectToString(value);
                    const valueAsRecord = value;
                    const valueToString = lookupGetter(valueAsRecord, 'toString');
                    if (typeof valueToString === 'function') {
                        const stringified = valueToString(valueAsRecord);
                        return typeof stringified === 'string' ? stringified : objectToString(stringified);
                    }
                    return objectToString(value);
                }
            default:
                return objectToString(value);
        }
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    function isRegex(value) {
        try {
            regExpTest(value, '');
            return true;
        } catch (_unused) {
            return false;
        }
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'command',
        'commandfor',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'mask-type',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnalign',
        'columnlines',
        'columnspacing',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lquote',
        'lspace',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    const MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
    const ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
    const TMPLIT_EXPR = seal(/\${[\w\W]*/g);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.4.7';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let document = window1.document;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        window1.DocumentFragment;
        const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap;
        _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap;
        window1.HTMLFormElement;
        const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        const getShadowRoot = lookupGetter(ElementPrototype, 'shadowRoot');
        const getAttributes = lookupGetter(ElementPrototype, 'attributes');
        const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeType') : null;
        const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeName') : null;
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        const importNode = originalDocument.importNode;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') && arrayIsArray(cfg.ALLOWED_TAGS) ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') && arrayIsArray(cfg.ALLOWED_ATTR) ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') && arrayIsArray(cfg.ALLOWED_NAMESPACES) ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR) ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') && arrayIsArray(cfg.ADD_DATA_URI_TAGS) ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS) ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') && arrayIsArray(cfg.FORBID_TAGS) ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') && arrayIsArray(cfg.FORBID_ATTR) ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI; // Default regexp
            NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
            MATHML_TEXT_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'MATHML_TEXT_INTEGRATION_POINTS') && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === 'object' ? clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : addToSet({}, [
                'mi',
                'mo',
                'mn',
                'ms',
                'mtext'
            ]); // Default built-in map
            HTML_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'HTML_INTEGRATION_POINTS') && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === 'object' ? clone(cfg.HTML_INTEGRATION_POINTS) : addToSet({}, [
                'annotation-xml'
            ]); // Default built-in map
            const customElementHandling = objectHasOwnProperty(cfg, 'CUSTOM_ELEMENT_HANDLING') && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === 'object' ? clone(cfg.CUSTOM_ELEMENT_HANDLING) : create(null);
            CUSTOM_ELEMENT_HANDLING = create(null);
            if (objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
       * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
            EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            /* Merge configuration parameters */ if (objectHasOwnProperty(cfg, 'ADD_TAGS')) {
                if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else if (arrayIsArray(cfg.ADD_TAGS)) {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_ATTR')) {
                if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else if (arrayIsArray(cfg.ADD_ATTR)) {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            if (objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            /*
       * Mirror the clone-before-mutate pattern already applied above for
       * cfg.ADD_TAGS / cfg.ADD_ATTR: if any uponSanitize* hook is
       * registered AND the set still points at the default constant,
       * clone it. The hook then mutates the clone (in-call widening
       * still works exactly as documented) and the next default-cfg
       * call rebinds to the untouched original via the reassignment at
       * the top of this function.
       */ if ((hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) && ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
            if (hooks.uponSanitizeAttribute.length > 0 && ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
     * character data of an element subtree. Used as the final safety net for
     * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
     * which only form after text-node normalization (e.g. fragments split across
     * stripped elements) cannot survive into a template-evaluating framework.
     *
     * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
     * in place rather than round-tripping through innerHTML. This preserves
     * descendant node references (important for IN_PLACE callers), avoids a
     * serialize/reparse cycle, and reads literal character data — which means
     * `<%...%>` in text content matches the ERB regex against its real bytes
     * instead of the HTML-entity-escaped form innerHTML would produce.
     *
     * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
     * attributes is performed during the per-node `_sanitizeAttributes` pass.
     *
     * @param node The root element whose character data should be scrubbed.
     */ const _scrubTemplateExpressions = function _scrubTemplateExpressions(node) {
            node.normalize();
            const walker = createNodeIterator.call(node.ownerDocument || node, node, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
            let currentNode = walker.nextNode();
            while(currentNode){
                let data = currentNode.data;
                arrayForEach([
                    MUSTACHE_EXPR$1,
                    ERB_EXPR$1,
                    TMPLIT_EXPR$1
                ], (expr)=>{
                    data = stringReplace(data, expr, ' ');
                });
                currentNode.data = data;
                currentNode = walker.nextNode();
            }
        };
        /**
     * _isClobbered
     *
     * Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
     * interface with [LegacyOverrideBuiltIns]; a descendant element with a
     * `name` attribute matching a prototype property shadows that property
     * on direct reads. We use this check at the IN_PLACE entry-point and
     * during attribute sanitization to refuse clobbered forms.
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            // Realm-independent tag-name probe. If we can't determine the tag
            // name at all, we can't reason about clobbering — return false
            // (the caller's other defences still apply).
            const realTagName = getNodeName ? getNodeName(element) : null;
            if (typeof realTagName !== 'string') return false;
            if (transformCaseFunc(realTagName) !== 'form') return false;
            return typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || // Realm-safe NamedNodeMap detection: equality against the cached
            // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
            // makes the direct read diverge from the cached read; a clean form
            // (same-realm OR foreign-realm) has both reads pointing at the same
            // canonical NamedNodeMap.
            element.attributes !== getAttributes(element) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function' || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
            // returns the integer 1 for any Element regardless of realm; direct
            // read on a clobbered form (e.g. <input name="nodeType">) returns
            // the named child element. Cheap addition — nodeType is read from
            // an internal slot, no serialization cost — and removes a residual
            // clobbering surface used by several mXSS / PI / comment branches
            // in _sanitizeElements that compare currentNode.nodeType directly.
            element.nodeType !== getNodeType(element) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
            // "childNodes" shadows the prototype getter. Direct reads of
            // form.childNodes from a clobbered form return the named child
            // instead of the real NodeList, so any walk that reads it directly
            // skips the form's real children. Compare the direct read to the
            // cached Node.prototype getter — when the form's named-property
            // getter intercepts the read, the two values differ and we flag
            // the form. This catches every clobbering child type (input,
            // select, etc.) regardless of whether the named child happens to
            // carry a numeric .length, which a typeof-based probe would miss
            // (e.g. HTMLSelectElement.length is a defined unsigned-long).
            element.childNodes !== getChildNodes(element);
        };
        /**
     * Checks whether the given value is a DocumentFragment from any realm.
     *
     * The realm-independent replacement reads `nodeType` through the cached
     * Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
     * constant (11). nodeType is a numeric value resolved from the node's
     * internal slot, identical across realms for the same kind of node.
     *
     * @param value object to check
     * @return true if value is a DocumentFragment-shaped node from any realm
     */ const _isDocumentFragment = function _isDocumentFragment(value) {
            if (!getNodeType || typeof value !== 'object' || value === null) return false;
            try {
                return getNodeType(value) === NODE_TYPE.documentFragment;
            } catch (_) {
                return false;
            }
        };
        /**
     * Checks whether the given object is a DOM node, including nodes that
     * originate from a different window/realm (e.g. an iframe's
     * contentDocument). The previous `value instanceof Node` check was
     * realm-bound: nodes from a different window failed it, causing
     * sanitize() to silently stringify them and reset IN_PLACE to false,
     * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
     *
     * @param value object to check whether it's a DOM node
     * @return true if value is a DOM node from any realm
     */ const _isNode = function _isNode(value) {
            if (!getNodeType || typeof value !== 'object' || value === null) return false;
            try {
                return typeof getNodeType(value) === 'number';
            } catch (_) {
                return false;
            }
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove risky CSS construction leading to mXSS */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements.
           Use the cached prototype getters exclusively — the previous code
           had `|| currentNode.parentNode` / `|| currentNode.childNodes`
           fallbacks, but the cached getters always return the canonical
           value (or null for a real parent-less node), so the fallback
           path was dead in safe cases and a clobbering surface in unsafe
           ones. Falsy cached results stay falsy; the `if (childNodes &&
           parentNode)` check already gates correctly. */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode);
                    const childNodes = getChildNodes(currentNode);
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): use the cached Node.prototype
         nodeType getter rather than `instanceof Element`, which is realm-
         bound and short-circuits to false for any node minted in a different
         realm — letting a foreign-realm element with a forbidden namespace
         slip past the namespace check entirely. */ const nt = getNodeType ? getNodeType(currentNode) : currentNode.nodeType;
            if (nt === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR$1,
                    ERB_EXPR$1,
                    TMPLIT_EXPR$1
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!nameIsPermitted || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /* Names the HTML spec reserves from valid-custom-element-name; these must
     * never be treated as basic custom elements even when a permissive
     * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
            'annotation-xml',
            'color-profile',
            'font-face',
            'font-face-format',
            'font-face-name',
            'font-face-src',
            'font-face-uri',
            'missing-glyph'
        ]);
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                // Else: already prefixed, leave the attribute alone — the prefix is
                // itself the clobbering protection, and re-applying it is incorrect.
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR$1,
                    ERB_EXPR$1,
                    TMPLIT_EXPR$1
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType against the
           DOCUMENT_FRAGMENT_NODE constant rather than instanceof, so we
           recurse into <template>.content from foreign realms too. */ if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
                /* An element iterated here may itself host an attached
           shadow root. The default NodeIterator does not enter shadow
           trees, so a shadow root nested inside template.content was
           previously reached by no walk at all (the pre-pass at
           _sanitizeAttachedShadowRoots descends via childNodes, which
           doesn't enter template.content; the template-content recursion
           above iterates the content but never inspected shadowRoot).
           Walk it explicitly. The nodeType guard avoids reading
           shadowRoot off text / comment / CDATA / PI nodes that the
           iterator also surfaces. */ const shadowNodeType = getNodeType ? getNodeType(shadowNode) : shadowNode.nodeType;
                if (shadowNodeType === NODE_TYPE.element) {
                    const innerSr = getShadowRoot ? getShadowRoot(shadowNode) : shadowNode.shadowRoot;
                    if (_isDocumentFragment(innerSr)) {
                        _sanitizeAttachedShadowRoots2(innerSr);
                        _sanitizeShadowDOM2(innerSr);
                    }
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        /**
     * _sanitizeAttachedShadowRoots
     *
     * Walks `root` and feeds every attached shadow root we encounter into
     * the existing _sanitizeShadowDOM pipeline. The default node iterator
     * does not descend into shadow trees, so nodes inside an attached
     * shadow root would otherwise be skipped entirely.
     *
     * Two real input paths put attached shadow roots in front of us:
     *   1. IN_PLACE on a DOM node that already has shadow roots attached.
     *   2. DOM-node input where importNode(dirty, true) deep-clones the
     *      shadow root because it was created with `clonable: true`.
     *
     * This pass runs once, up front, so the main iteration loop (and the
     * existing _sanitizeShadowDOM template-content recursion) stay
     * untouched — string-input paths are not affected.
     *
     * @param root the subtree root to walk for attached shadow roots
     */ const _sanitizeAttachedShadowRoots2 = function _sanitizeAttachedShadowRoots(root) {
            const nodeType = getNodeType ? getNodeType(root) : root.nodeType;
            if (nodeType === NODE_TYPE.element) {
                const sr = getShadowRoot ? getShadowRoot(root) : root.shadowRoot;
                // Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType-based
                // detection rather than `instanceof DocumentFragment`, which is
                // realm-bound and silently skipped shadow roots whose host element
                // belonged to a foreign realm (e.g. iframe.contentDocument
                // attachShadow). A foreign-realm ShadowRoot extends the foreign
                // realm's DocumentFragment, not ours, so the old instanceof check
                // returned false and the shadow subtree was never walked.
                if (_isDocumentFragment(sr)) {
                    // Recurse first so that nested shadow roots are reached even if
                    // _sanitizeShadowDOM removes hosts at this level.
                    _sanitizeAttachedShadowRoots2(sr);
                    _sanitizeShadowDOM2(sr);
                }
            }
            // Snapshot children before recursing. Sanitization of one subtree
            // (e.g. via an uponSanitizeShadowNode hook) may detach siblings,
            // and naive nextSibling traversal would silently skip the rest of
            // the list once a node is detached.
            const childNodes = getChildNodes ? getChildNodes(root) : root.childNodes;
            if (!childNodes) return;
            const snapshot = [];
            arrayForEach(childNodes, (child)=>{
                arrayPush(snapshot, child);
            });
            for (const child of snapshot)_sanitizeAttachedShadowRoots2(child);
            /* When the root is a <template>, also descend into root.content */ if (nodeType === NODE_TYPE.element) {
                const rootName = getNodeName ? getNodeName(root) : null;
                if (typeof rootName === 'string' && transformCaseFunc(rootName) === 'template') {
                    const content = root.content;
                    if (_isDocumentFragment(content)) _sanitizeAttachedShadowRoots2(content);
                }
            }
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                dirty = stringifyValue(dirty);
                if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) {
                /* Do some early pre-sanitization to avoid unsafe root nodes.
           Read nodeName through the cached prototype getter — a clobbering
           child named "nodeName" on the form root would otherwise shadow
           the property and let this check skip the root-allowlist
           validation entirely. */ const nn = getNodeName ? getNodeName(dirty) : dirty.nodeName;
                if (typeof nn === 'string') {
                    const tagName = transformCaseFunc(nn);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
                /* Pre-flight the root through _isClobbered. The iterator-driven
           removal path can not detach a parent-less root: _forceRemove
           falls through to Element.prototype.remove(), which per spec
           is a no-op on a node with no parent. A clobbered root would
           then survive the main loop with its attributes uninspected,
           because _sanitizeAttributes early-returns on _isClobbered. The
           result would be an attacker-controlled form, complete with any
           event-handler attributes the caller passed in, handed back to
           the application unsanitized. Refuse to sanitize such a root
           the same way we refuse a forbidden tag. GHSA-r47g-fvhr-h676. */ if (_isClobbered(dirty)) throw typeErrorCreate('root node is clobbered and cannot be sanitized in-place');
                /* Sanitize attached shadow roots before the main iterator runs.
           The iterator does not descend into shadow trees. */ _sanitizeAttachedShadowRoots2(dirty);
            } else if (_isNode(dirty)) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
                /* Clonable shadow roots are deep-cloned by importNode(); sanitize
           them before the main iterator runs, since the iterator does not
           descend into shadow trees. The walk routes every read through a
           cached prototype getter so clobbering descendants on a form root
           cannot hide a shadow host from this pass. */ _sanitizeAttachedShadowRoots2(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
           instead of instanceof, so foreign-realm <template>.content is
           walked correctly. */ if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions(dirty);
                return dirty;
            }
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions(body);
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR$1,
                ERB_EXPR$1,
                TMPLIT_EXPR$1
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


function $73cbf435bf470aed$var$sanitizeDocxHtml(html) {
    if (typeof html !== "string") return "";
    if (!$f72755886b9c5753$exports.isSupported) return "";
    return $f72755886b9c5753$exports.sanitize(html);
}
function $73cbf435bf470aed$var$scheduleDocxHtmlMount(elementId, html) {
    const safeHtml = $73cbf435bf470aed$var$sanitizeDocxHtml(html);
    const paint = ()=>{
        const el = document.getElementById(elementId);
        if (el) el.innerHTML = safeHtml;
    };
    requestAnimationFrame(()=>{
        requestAnimationFrame(paint);
    });
}
const $73cbf435bf470aed$var$DocxPreviewPort = {
    add: function(app) {
        if (app.ports.mountDocxHtml) app.ports.mountDocxHtml.subscribe(({ elementId: elementId, html: html })=>{
            if (elementId && typeof html === "string") $73cbf435bf470aed$var$scheduleDocxHtmlMount(elementId, html);
        });
        if (app.ports.clearDocxMount) app.ports.clearDocxMount.subscribe((elementId)=>{
            if (!elementId) return;
            const el = document.getElementById(elementId);
            if (el) el.replaceChildren();
        });
        if (app.ports.convertDocxFromUrl) app.ports.convertDocxFromUrl.subscribe(async ({ requestId: requestId, url: url })=>{
            if (!app.ports.docxPreviewHtmlResult) return;
            const fail = ()=>app.ports.docxPreviewHtmlResult.send({
                    requestId: requestId,
                    ok: false,
                    html: null
                });
            try {
                const res = await fetch(url);
                if (!res.ok) {
                    fail();
                    return;
                }
                const arrayBuffer = await res.arrayBuffer();
                const result = await $7d7fd9061cffbcaa$export$7b82ddf1ba8788ff({
                    arrayBuffer: arrayBuffer
                });
                const rawHtml = result.value || "";
                app.ports.docxPreviewHtmlResult.send({
                    requestId: requestId,
                    ok: true,
                    html: $73cbf435bf470aed$var$sanitizeDocxHtml(rawHtml)
                });
            } catch  {
                fail();
            }
        });
    }
};
$73cbf435bf470aed$exports = $73cbf435bf470aed$var$DocxPreviewPort;


var $78b00d0027f221e5$exports = {};
var $38e5b7422416655b$exports = {};
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/ ((e, t)=>{
    "function" == typeof define && define.amd ? define([], t) : $38e5b7422416655b$exports = t();
})($38e5b7422416655b$exports, function r() {
    var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : {};
    var d, s = !n.document && !!n.postMessage, a = n.IS_PAPA_WORKER || !1, o = {}, h = 0, v = {};
    function u(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = b(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(t, e) {
            var i = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && 0 < i) {
                let e = this._config.newline;
                e || (r = this._config.quoteChar || '"', e = this._handle.guessLineEndings(t, r)), t = [
                    ...t.split(e).slice(i)
                ].join(e);
            }
            this.isFirstChunk && U(this._config.beforeFirstChunk) && void 0 !== (r = this._config.beforeFirstChunk(t)) && (t = r), this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + t, r = (this._partialLine = "", this._handle.parse(i, this._baseIndex, !this._finished));
            if (!this._handle.paused() && !this._handle.aborted()) {
                t = r.meta.cursor, i = (this._finished || (this._partialLine = i.substring(t - this._baseIndex), this._baseIndex = t), r && r.data && (this._rowCount += r.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
                if (a) n.postMessage({
                    results: r,
                    workerId: v.WORKER_ID,
                    finished: i
                });
                else if (U(this._config.chunk) && !e) {
                    if (this._config.chunk(r, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    this._completeResults = r = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r.data), this._completeResults.errors = this._completeResults.errors.concat(r.errors), this._completeResults.meta = r.meta), this._completed || !i || !U(this._config.complete) || r && r.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), i || r && r.meta.paused || this._nextChunk(), r;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            U(this._config.error) ? this._config.error(e) : a && this._config.error && n.postMessage({
                workerId: v.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function f(e) {
        var r;
        (e = e || {}).chunkSize || (e.chunkSize = v.RemoteChunkSize), u.call(this, e), this._nextChunk = s ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (r = new XMLHttpRequest, this._config.withCredentials && (r.withCredentials = this._config.withCredentials), s || (r.onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
                    var e, t = this._config.downloadRequestHeaders;
                    for(e in t)r.setRequestHeader(e, t[e]);
                }
                var i;
                this._config.chunkSize && (i = this._start + this._config.chunkSize - 1, r.setRequestHeader("Range", "bytes=" + this._start + "-" + i));
                try {
                    r.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                s && 0 === r.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize || r.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e)=>null !== (e = e.getResponseHeader("Content-Range")) ? parseInt(e.substring(e.lastIndexOf("/") + 1)) : -1)(r), this.parseChunk(r.responseText)));
        }, this._chunkError = function(e) {
            e = r.statusText || e;
            this._sendError(new Error(e));
        };
    }
    function l(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v.LocalChunkSize), u.call(this, e);
        var i, r, n = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((i = new FileReader).onload = y(this._chunkLoaded, this), i.onerror = y(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input, t = (this._config.chunkSize && (t = Math.min(this._start + this._config.chunkSize, this._input.size), e = r.call(e, this._start, t)), i.readAsText(e, this._config.encoding));
            n || this._chunkLoaded({
                target: {
                    result: t
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function c(e) {
        var i;
        u.call(this, e = e || {}), this.stream = function(e) {
            return i = e, this._nextChunk();
        }, this._nextChunk = function() {
            var e, t;
            if (!this._finished) return e = this._config.chunkSize, i = e ? (t = i.substring(0, e), i.substring(e)) : (t = i, ""), this._finished = !i, this.parseChunk(t);
        };
    }
    function p(e) {
        u.call(this, e = e || {});
        var t = [], i = !0, r = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            r && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
        }, this._streamData = y(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = y(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = y(function() {
            this._streamCleanUp(), r = !0, this._streamData("");
        }, this), this._streamCleanUp = y(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function i(m) {
        var n, s, a, t, o = Math.pow(2, 53), h = -o, u = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i = this, r = 0, f = 0, l = !1, e = !1, c = [], p = {
            data: [],
            errors: [],
            meta: {}
        };
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            if (p && a && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a = !1), m.skipEmptyLines && (p.data = p.data.filter(function(e) {
                return !y(e);
            })), _()) {
                if (p) {
                    if (Array.isArray(p.data[0])) {
                        for(var e = 0; _() && e < p.data.length; e++)p.data[e].forEach(t);
                        p.data.splice(0, 1);
                    } else p.data.forEach(t);
                }
                function t(e, t) {
                    U(m.transformHeader) && (e = m.transformHeader(e, t)), c.push(e);
                }
            }
            function i(e, t) {
                for(var i = m.header ? {} : [], r = 0; r < e.length; r++){
                    var n = r, s = e[r], s = ((e, t)=>((e)=>(m.dynamicTypingFunction && void 0 === m.dynamicTyping[e] && (m.dynamicTyping[e] = m.dynamicTypingFunction(e)), !0 === (m.dynamicTyping[e] || m.dynamicTyping)))(e) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (((e)=>{
                            if (u.test(e)) {
                                e = parseFloat(e);
                                if (h < e && e < o) return 1;
                            }
                        })(t) ? parseFloat(t) : d.test(t) ? new Date(t) : "" === t ? null : t) : t)(n = m.header ? r >= c.length ? "__parsed_extra" : c[r] : n, s = m.transform ? m.transform(s, n) : s);
                    "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                }
                return m.header && (r > c.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c.length + " fields but parsed " + r, f + t) : r < c.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c.length + " fields but parsed " + r, f + t)), i;
            }
            var r;
            p && (m.header || m.dynamicTyping || m.transform) && (r = 1, !p.data.length || Array.isArray(p.data[0]) ? (p.data = p.data.map(i), r = p.data.length) : p.data = i(p.data, 0), m.header && p.meta && (p.meta.fields = c), f += r);
        }
        function _() {
            return m.header && 0 === c.length;
        }
        function k(e, t, i, r) {
            e = {
                type: e,
                code: t,
                message: i
            };
            void 0 !== r && (e.row = r), p.errors.push(e);
        }
        U(m.step) && (t = m.step, m.step = function(e) {
            p = e, _() ? g() : (g(), 0 !== p.data.length && (r += e.data.length, m.preview && r > m.preview ? s.abort() : (p.data = p.data[0], t(p, i))));
        }), this.parse = function(e, t, i) {
            var r = m.quoteChar || '"', r = (m.newline || (m.newline = this.guessLineEndings(e, r)), a = !1, m.delimiter ? U(m.delimiter) && (m.delimiter = m.delimiter(e), p.meta.delimiter = m.delimiter) : ((r = ((e, t, i, r, n)=>{
                var s, a, o, h;
                n = n || [
                    ",",
                    "\t",
                    "|",
                    ";",
                    v.RECORD_SEP,
                    v.UNIT_SEP
                ];
                for(var u = 0; u < n.length; u++){
                    for(var d, f = n[u], l = 0, c = 0, p = 0, g = (o = void 0, new E({
                        comments: r,
                        delimiter: f,
                        newline: t,
                        preview: 10
                    }).parse(e)), _ = 0; _ < g.data.length; _++)i && y(g.data[_]) ? p++ : (d = g.data[_].length, c += d, void 0 === o ? o = d : 0 < d && (l += Math.abs(d - o), o = d));
                    0 < g.data.length && (c /= g.data.length - p), (void 0 === a || l <= a) && (void 0 === h || h < c) && 1.99 < c && (a = l, s = f, h = c);
                }
                return {
                    successful: !!(m.delimiter = s),
                    bestDelimiter: s
                };
            })(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess)).successful ? m.delimiter = r.bestDelimiter : (a = !0, m.delimiter = v.DefaultDelimiter), p.meta.delimiter = m.delimiter), b(m));
            return m.preview && m.header && r.preview++, n = e, s = new E(r), p = s.parse(n, t, i), g(), l ? {
                meta: {
                    paused: !0
                }
            } : p || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return l;
        }, this.pause = function() {
            l = !0, s.abort(), n = U(m.chunk) ? "" : n.substring(s.getCharIndex());
        }, this.resume = function() {
            i.streamer._halted ? (l = !1, i.streamer.parseChunk(n, !0)) : setTimeout(i.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, s.abort(), p.meta.aborted = !0, U(m.complete) && m.complete(p), n = "";
        }, this.guessLineEndings = function(e, t) {
            e = e.substring(0, 1048576);
            var t = new RegExp(P(t) + "([^]*?)" + P(t), "gm"), i = (e = e.replace(t, "")).split("\r"), t = e.split("\n"), e = 1 < t.length && t[0].length < i[0].length;
            if (1 === i.length || e) return "\n";
            for(var r = 0, n = 0; n < i.length; n++)"\n" === i[n][0] && r++;
            return r >= i.length / 2 ? "\r\n" : "\r";
        };
    }
    function P(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I = C.step, A = C.preview, T = C.fastMode, D = null, L = !1, F = null == C.quoteChar ? '"' : C.quoteChar, j = F;
        if (void 0 !== C.escapeChar && (j = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S) throw new Error("Comment character same as delimiter");
        !0 === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = !1), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z = 0, M = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = S.length, s = O.length, a = x.length, o = U(I), h = [], u = [], d = [], f = z = 0;
            if (!i) return w();
            if (T || !1 !== T && -1 === i.indexOf(F)) {
                for(var l = i.split(O), c = 0; c < l.length; c++){
                    if (d = l[c], z += d.length, c !== l.length - 1) z += O.length;
                    else if (r) return w();
                    if (!x || d.substring(0, a) !== x) {
                        if (o) {
                            if (h = [], k(d.split(S)), R(), M) return w();
                        } else k(d.split(S));
                        if (A && A <= c) return h = h.slice(0, A), w(!0);
                    }
                }
                return w();
            }
            for(var p = i.indexOf(S, z), g = i.indexOf(O, z), _ = new RegExp(P(j) + P(F), "g"), m = i.indexOf(F, z);;)if (i[z] === F) for(m = z, z++;;){
                if (-1 === (m = i.indexOf(F, m + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: z
                }), E();
                if (m === n - 1) return E(i.substring(z, m).replace(_, F));
                if (F === j && i[m + 1] === j) m++;
                else if (F === j || 0 === m || i[m - 1] !== j) {
                    -1 !== p && p < m + 1 && (p = i.indexOf(S, m + 1));
                    var y = v(-1 === (g = -1 !== g && g < m + 1 ? i.indexOf(O, m + 1) : g) ? p : Math.min(p, g));
                    if (i.substr(m + 1 + y, e) === S) {
                        d.push(i.substring(z, m).replace(_, F)), i[z = m + 1 + y + e] !== F && (m = i.indexOf(F, z)), p = i.indexOf(S, z), g = i.indexOf(O, z);
                        break;
                    }
                    y = v(g);
                    if (i.substring(m + 1 + y, m + 1 + y + s) === O) {
                        if (d.push(i.substring(z, m).replace(_, F)), b(m + 1 + y + s), p = i.indexOf(S, z), m = i.indexOf(F, z), o && (R(), M)) return w();
                        if (A && h.length >= A) return w(!0);
                        break;
                    }
                    u.push({
                        type: "Quotes",
                        code: "InvalidQuotes",
                        message: "Trailing quote on quoted field is malformed",
                        row: h.length,
                        index: z
                    }), m++;
                }
            }
            else if (x && 0 === d.length && i.substring(z, z + a) === x) {
                if (-1 === g) return w();
                z = g + s, g = i.indexOf(O, z), p = i.indexOf(S, z);
            } else if (-1 !== p && (p < g || -1 === g)) d.push(i.substring(z, p)), z = p + e, p = i.indexOf(S, z);
            else {
                if (-1 === g) break;
                if (d.push(i.substring(z, g)), b(g + s), o && (R(), M)) return w();
                if (A && h.length >= A) return w(!0);
            }
            return E();
            function k(e) {
                h.push(e), f = z;
            }
            function v(e) {
                var t = 0;
                return t = -1 !== e && (e = i.substring(m + 1, e)) && "" === e.trim() ? e.length : t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substring(z)), d.push(e), z = n, k(d), o && R()), w();
            }
            function b(e) {
                z = e, k(d), d = [], g = i.indexOf(O, z);
            }
            function w(e) {
                if (C.header && !t && h.length && !L) {
                    var s = h[0], a = Object.create(null), o = new Set(s);
                    let n = !1;
                    for(let r = 0; r < s.length; r++){
                        let i = s[r];
                        if (a[i = U(C.transformHeader) ? C.transformHeader(i, r) : i]) {
                            let e, t = a[i];
                            for(; e = i + "_" + t, t++, o.has(e););
                            o.add(e), s[r] = e, a[i]++, n = !0, (D = null === D ? {} : D)[e] = i;
                        } else a[i] = 1, s[r] = i;
                        o.add(i);
                    }
                    n && console.warn("Duplicate headers found and renamed."), L = !0;
                }
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: S,
                        linebreak: O,
                        aborted: M,
                        truncated: !!e,
                        cursor: f + (t || 0),
                        renamedHeaders: D
                    }
                };
            }
            function R() {
                I(w()), h = [], u = [];
            }
        }, this.abort = function() {
            M = !0;
        }, this.getCharIndex = function() {
            return z;
        };
    }
    function g(e) {
        var t = e.data, i = o[t.workerId], r = !1;
        if (t.error) i.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    r = !0, _(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: m,
                resume: m
            };
            if (U(i.userStep)) {
                for(var s = 0; s < t.results.data.length && (i.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !r); s++);
                delete t.results;
            } else U(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !r && _(t.workerId, t.results);
    }
    function _(e, t) {
        var i = o[e];
        U(i.userComplete) && i.userComplete(t), i.terminate(), delete o[e];
    }
    function m() {
        throw new Error("Not implemented.");
    }
    function b(e) {
        if ("object" != typeof e || null === e) return e;
        var t, i = Array.isArray(e) ? [] : {};
        for(t in e)i[t] = b(e[t]);
        return i;
    }
    function y(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function U(e) {
        return "function" == typeof e;
    }
    return v.parse = function(e, t) {
        var i = (t = t || {}).dynamicTyping || !1;
        U(i) && (t.dynamicTypingFunction = i, i = {});
        if (t.dynamicTyping = i, t.transform = !!U(t.transform) && t.transform, !t.worker || !v.WORKERS_SUPPORTED) return i = null, v.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e)=>65279 !== e.charCodeAt(0) ? e : e.slice(1))(e), i = new (t.download ? f : c)(t)) : !0 === e.readable && U(e.read) && U(e.on) ? i = new p(t) : (n.File && e instanceof File || e instanceof Object) && (i = new l(t)), i.stream(e);
        (i = (()=>{
            var e;
            return !!v.WORKERS_SUPPORTED && (e = (()=>{
                var e = n.URL || n.webkitURL || null, t = r.toString();
                return v.BLOB_URL || (v.BLOB_URL = e.createObjectURL(new Blob([
                    "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                    "(",
                    t,
                    ")();"
                ], {
                    type: "text/javascript"
                })));
            })(), (e = new n.Worker(e)).onmessage = g, e.id = h++, o[e.id] = e);
        })()).userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, i.postMessage({
            input: e,
            config: t,
            workerId: i.id
        });
    }, v.unparse = function(e, t) {
        var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, i = !1, r = null, o = !1, h = ((()=>{
            if ("object" == typeof t) {
                if ("string" != typeof t.delimiter || v.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter), "boolean" != typeof t.quotes && "function" != typeof t.quotes && !Array.isArray(t.quotes) || (n = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines), "string" == typeof t.newline && (y = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (_ = t.header), Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    r = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s), t.escapeFormulae instanceof RegExp ? o = t.escapeFormulae : "boolean" == typeof t.escapeFormulae && t.escapeFormulae && (o = /^[=+\-@\t\r].*$/);
            }
        })(), new RegExp(P(s), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
            if (!e.length || Array.isArray(e[0])) return u(null, e, i);
            if ("object" == typeof e[0]) return u(r || Object.keys(e[0]), e, i);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
            e.data
        ])), u(e.fields || [], e.data || [], i);
        throw new Error("Unable to serialize unrecognized input");
        function u(e, t, i) {
            var r = "", n = ("string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t)), Array.isArray(e) && 0 < e.length), s = !Array.isArray(t[0]);
            if (n && _) {
                for(var a = 0; a < e.length; a++)0 < a && (r += m), r += k(e[a], a);
                0 < t.length && (r += y);
            }
            for(var o = 0; o < t.length; o++){
                var h = (n ? e : t[o]).length, u = !1, d = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
                    for(var f = [], l = 0; l < h; l++){
                        var c = s ? e[l] : l;
                        f.push(t[o][c]);
                    }
                    u = "" === f.join("").trim();
                }
                if (!u) {
                    for(var p = 0; p < h; p++){
                        0 < p && !d && (r += m);
                        var g = n && s ? e[p] : p;
                        r += k(t[o][g], p);
                    }
                    o < t.length - 1 && (!i || 0 < h && !d) && (r += y);
                }
            }
            return r;
        }
        function k(e, t) {
            var i, r;
            return null == e ? "" : e.constructor === Date ? JSON.stringify(e).slice(1, 25) : (r = !1, o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0), i = e.toString().replace(h, a), (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || ((e, t)=>{
                for(var i = 0; i < t.length; i++)if (-1 < e.indexOf(t[i])) return !0;
                return !1;
            })(i, v.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i);
        }
    }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\ufeff", v.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        v.BYTE_ORDER_MARK
    ], v.WORKERS_SUPPORTED = !s && !!n.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E, v.ParserHandle = i, v.NetworkStreamer = f, v.FileStreamer = l, v.StringStreamer = c, v.ReadableStreamStreamer = p, n.jQuery && ((d = n.jQuery).fn.parse = function(o) {
        var i = o.config || {}, h = [];
        return this.each(function(e) {
            if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && n.FileReader) || !this.files || 0 === this.files.length) return !0;
            for(var t = 0; t < this.files.length; t++)h.push({
                file: this.files[t],
                inputElem: this,
                instanceConfig: d.extend({}, i)
            });
        }), e(), this;
        function e() {
            if (0 === h.length) U(o.complete) && o.complete();
            else {
                var e, t, i, r, n = h[0];
                if (U(o.before)) {
                    var s = o.before(n.file, n.inputElem);
                    if ("object" == typeof s) {
                        if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (U(o.error) && o.error({
                            name: e
                        }, t, i, r));
                        if ("skip" === s.action) return void u();
                        "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                    } else if ("skip" === s) return void u();
                }
                var a = n.instanceConfig.complete;
                n.instanceConfig.complete = function(e) {
                    U(a) && a(e, n.file, n.inputElem), u();
                }, v.parse(n.file, n.instanceConfig);
            }
        }
        function u() {
            h.splice(0, 1), e();
        }
    }), a && (n.onmessage = function(e) {
        e = e.data;
        void 0 === v.WORKER_ID && e && (v.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n.postMessage({
            workerId: v.WORKER_ID,
            results: v.parse(e.input, e.config),
            finished: !0
        }) : (n.File && e.input instanceof File || e.input instanceof Object) && (e = v.parse(e.input, e.config)) && n.postMessage({
            workerId: v.WORKER_ID,
            results: e,
            finished: !0
        });
    }), (f.prototype = Object.create(u.prototype)).constructor = f, (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(c.prototype)).constructor = c, (p.prototype = Object.create(u.prototype)).constructor = p, v;
});


var $2868ea4c6c841752$exports = {};
/*! ExcelJS 19-10-2023 */ !function(e) {
    $2868ea4c6c841752$exports = e();
}(function() {
    return (function e(t, r, n) {
        function i(o, a) {
            if (!r[o]) {
                if (!t[o]) {
                    var l = undefined;
                    if (!a && l) return l(o, !0);
                    if (s) return s(o, !0);
                    var c = new Error("Cannot find module '" + o + "'");
                    throw c.code = "MODULE_NOT_FOUND", c;
                }
                var u = r[o] = {
                    exports: {}
                };
                t[o][0].call(u.exports, function(e) {
                    return i(t[o][1][e] || e);
                }, u, u.exports, e, t, r, n);
            }
            return r[o].exports;
        }
        for(var s = undefined, o = 0; o < n.length; o++)i(n[o]);
        return i;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                const n = e("fs"), i = e("fast-csv"), s = e("dayjs/plugin/customParseFormat"), o = e("dayjs/plugin/utc"), a = e("dayjs").extend(s).extend(o), l = e("../utils/stream-buf"), { fs: { exists: c } } = e("../utils/utils"), u = {
                    true: !0,
                    false: !1,
                    "#N/A": {
                        error: "#N/A"
                    },
                    "#REF!": {
                        error: "#REF!"
                    },
                    "#NAME?": {
                        error: "#NAME?"
                    },
                    "#DIV/0!": {
                        error: "#DIV/0!"
                    },
                    "#NULL!": {
                        error: "#NULL!"
                    },
                    "#VALUE!": {
                        error: "#VALUE!"
                    },
                    "#NUM!": {
                        error: "#NUM!"
                    }
                };
                t.exports = class {
                    constructor(e){
                        this.workbook = e, this.worksheet = null;
                    }
                    async readFile(e, t) {
                        if (t = t || {}, !await c(e)) throw new Error("File not found: " + e);
                        const r = n.createReadStream(e), i = await this.read(r, t);
                        return r.close(), i;
                    }
                    read(e, t) {
                        return t = t || {}, new Promise((r, n)=>{
                            const s = this.workbook.addWorksheet(t.sheetName), o = t.dateFormats || [
                                "YYYY-MM-DD[T]HH:mm:ssZ",
                                "YYYY-MM-DD[T]HH:mm:ss",
                                "MM-DD-YYYY",
                                "YYYY-MM-DD"
                            ], l = t.map || function(e) {
                                if ("" === e) return null;
                                const t = Number(e);
                                if (!Number.isNaN(t) && t !== 1 / 0) return t;
                                const r = o.reduce((t, r)=>{
                                    if (t) return t;
                                    const n = a(e, r, !0);
                                    return n.isValid() ? n : null;
                                }, null);
                                if (r) return new Date(r.valueOf());
                                const n = u[e];
                                return void 0 !== n ? n : e;
                            }, c = i.parse(t.parserOptions).on("data", (e)=>{
                                s.addRow(e.map(l));
                            }).on("end", ()=>{
                                c.emit("worksheet", s);
                            });
                            c.on("worksheet", r).on("error", n), e.pipe(c);
                        });
                    }
                    createInputStream() {
                        throw new Error("`CSV#createInputStream` is deprecated. You should use `CSV#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                    }
                    write(e, t) {
                        return new Promise((r, n)=>{
                            t = t || {};
                            const s = this.workbook.getWorksheet(t.sheetName || t.sheetId), o = i.format(t.formatterOptions);
                            e.on("finish", ()=>{
                                r();
                            }), o.on("error", n), o.pipe(e);
                            const { dateFormat: l, dateUTC: c } = t, u = t.map || ((e)=>{
                                if (e) {
                                    if (e.text || e.hyperlink) return e.hyperlink || e.text || "";
                                    if (e.formula || e.result) return e.result || "";
                                    if (e instanceof Date) return l ? c ? a.utc(e).format(l) : a(e).format(l) : c ? a.utc(e).format() : a(e).format();
                                    if (e.error) return e.error;
                                    if ("object" == typeof e) return JSON.stringify(e);
                                }
                                return e;
                            }), h = void 0 === t.includeEmptyRows || t.includeEmptyRows;
                            let f = 1;
                            s && s.eachRow((e, t)=>{
                                if (h) for(; f++ < t - 1;)o.write([]);
                                const { values: r } = e;
                                r.shift(), o.write(r.map(u)), f = t;
                            }), o.end();
                        });
                    }
                    writeFile(e, t) {
                        const r = {
                            encoding: (t = t || {}).encoding || "utf8"
                        }, i = n.createWriteStream(e, r);
                        return this.write(i, t);
                    }
                    async writeBuffer(e) {
                        const t = new l;
                        return await this.write(t, e), t.read();
                    }
                };
            },
            {
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                dayjs: 391,
                "dayjs/plugin/customParseFormat": 392,
                "dayjs/plugin/utc": 393,
                "fast-csv": 424,
                fs: 216
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t){
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                        if (this.worksheet = e, t) {
                            if ("string" == typeof t) {
                                const e = n.decodeAddress(t);
                                this.nativeCol = e.col + r, this.nativeColOff = 0, this.nativeRow = e.row + r, this.nativeRowOff = 0;
                            } else void 0 !== t.nativeCol ? (this.nativeCol = t.nativeCol || 0, this.nativeColOff = t.nativeColOff || 0, this.nativeRow = t.nativeRow || 0, this.nativeRowOff = t.nativeRowOff || 0) : void 0 !== t.col ? (this.col = t.col + r, this.row = t.row + r) : (this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0);
                        } else this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0;
                    }
                    static asInstance(e) {
                        return e instanceof i || null == e ? e : new i(e);
                    }
                    get col() {
                        return this.nativeCol + Math.min(this.colWidth - 1, this.nativeColOff) / this.colWidth;
                    }
                    set col(e) {
                        this.nativeCol = Math.floor(e), this.nativeColOff = Math.floor((e - this.nativeCol) * this.colWidth);
                    }
                    get row() {
                        return this.nativeRow + Math.min(this.rowHeight - 1, this.nativeRowOff) / this.rowHeight;
                    }
                    set row(e) {
                        this.nativeRow = Math.floor(e), this.nativeRowOff = Math.floor((e - this.nativeRow) * this.rowHeight);
                    }
                    get colWidth() {
                        return this.worksheet && this.worksheet.getColumn(this.nativeCol + 1) && this.worksheet.getColumn(this.nativeCol + 1).isCustomWidth ? Math.floor(1e4 * this.worksheet.getColumn(this.nativeCol + 1).width) : 64e4;
                    }
                    get rowHeight() {
                        return this.worksheet && this.worksheet.getRow(this.nativeRow + 1) && this.worksheet.getRow(this.nativeRow + 1).height ? Math.floor(1e4 * this.worksheet.getRow(this.nativeRow + 1).height) : 18e4;
                    }
                    get model() {
                        return {
                            nativeCol: this.nativeCol,
                            nativeColOff: this.nativeColOff,
                            nativeRow: this.nativeRow,
                            nativeRowOff: this.nativeRowOff
                        };
                    }
                    set model(e) {
                        this.nativeCol = e.nativeCol, this.nativeColOff = e.nativeColOff, this.nativeRow = e.nativeRow, this.nativeRowOff = e.nativeRowOff;
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("../utils/under-dash"), s = e("./enums"), { slideFormula: o } = e("../utils/shared-formula"), a = e("./note");
                class l {
                    constructor(e, t, r){
                        if (!e || !t) throw new Error("A Cell needs a Row");
                        this._row = e, this._column = t, n.validateAddress(r), this._address = r, this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(e.style, t.style, {}), this._mergeCount = 0;
                    }
                    get worksheet() {
                        return this._row.worksheet;
                    }
                    get workbook() {
                        return this._row.worksheet.workbook;
                    }
                    destroy() {
                        delete this.style, delete this._value, delete this._row, delete this._column, delete this._address;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this.style.numFmt = e;
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this.style.font = e;
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this.style.alignment = e;
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this.style.border = e;
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this.style.fill = e;
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this.style.protection = e;
                    }
                    _mergeStyle(e, t, r) {
                        const n = e && e.numFmt || t && t.numFmt;
                        n && (r.numFmt = n);
                        const i = e && e.font || t && t.font;
                        i && (r.font = i);
                        const s = e && e.alignment || t && t.alignment;
                        s && (r.alignment = s);
                        const o = e && e.border || t && t.border;
                        o && (r.border = o);
                        const a = e && e.fill || t && t.fill;
                        a && (r.fill = a);
                        const l = e && e.protection || t && t.protection;
                        return l && (r.protection = l), r;
                    }
                    get address() {
                        return this._address;
                    }
                    get row() {
                        return this._row.number;
                    }
                    get col() {
                        return this._column.number;
                    }
                    get $col$row() {
                        return `$${this._column.letter}$${this.row}`;
                    }
                    get type() {
                        return this._value.type;
                    }
                    get effectiveType() {
                        return this._value.effectiveType;
                    }
                    toCsvString() {
                        return this._value.toCsvString();
                    }
                    addMergeRef() {
                        this._mergeCount++;
                    }
                    releaseMergeRef() {
                        this._mergeCount--;
                    }
                    get isMerged() {
                        return this._mergeCount > 0 || this.type === l.Types.Merge;
                    }
                    merge(e, t) {
                        this._value.release(), this._value = c.create(l.Types.Merge, this, e), t || (this.style = e.style);
                    }
                    unmerge() {
                        this.type === l.Types.Merge && (this._value.release(), this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(this._row.style, this._column.style, {}));
                    }
                    isMergedTo(e) {
                        return this._value.type === l.Types.Merge && this._value.isMergedTo(e);
                    }
                    get master() {
                        return this.type === l.Types.Merge ? this._value.master : this;
                    }
                    get isHyperlink() {
                        return this._value.type === l.Types.Hyperlink;
                    }
                    get hyperlink() {
                        return this._value.hyperlink;
                    }
                    get value() {
                        return this._value.value;
                    }
                    set value(e) {
                        this.type !== l.Types.Merge ? (this._value.release(), this._value = c.create(c.getType(e), this, e)) : this._value.master.value = e;
                    }
                    get note() {
                        return this._comment && this._comment.note;
                    }
                    set note(e) {
                        this._comment = new a(e);
                    }
                    get text() {
                        return this._value.toString();
                    }
                    get html() {
                        return i.escapeHtml(this.text);
                    }
                    toString() {
                        return this.text;
                    }
                    _upgradeToHyperlink(e) {
                        this.type === l.Types.String && (this._value = c.create(l.Types.Hyperlink, this, {
                            text: this._value.value,
                            hyperlink: e
                        }));
                    }
                    get formula() {
                        return this._value.formula;
                    }
                    get result() {
                        return this._value.result;
                    }
                    get formulaType() {
                        return this._value.formulaType;
                    }
                    get fullAddress() {
                        const { worksheet: e } = this._row;
                        return {
                            sheetName: e.name,
                            address: this.address,
                            row: this.row,
                            col: this.col
                        };
                    }
                    get name() {
                        return this.names[0];
                    }
                    set name(e) {
                        this.names = [
                            e
                        ];
                    }
                    get names() {
                        return this.workbook.definedNames.getNamesEx(this.fullAddress);
                    }
                    set names(e) {
                        const { definedNames: t } = this.workbook;
                        t.removeAllNames(this.fullAddress), e.forEach((e)=>{
                            t.addEx(this.fullAddress, e);
                        });
                    }
                    addName(e) {
                        this.workbook.definedNames.addEx(this.fullAddress, e);
                    }
                    removeName(e) {
                        this.workbook.definedNames.removeEx(this.fullAddress, e);
                    }
                    removeAllNames() {
                        this.workbook.definedNames.removeAllNames(this.fullAddress);
                    }
                    get _dataValidations() {
                        return this.worksheet.dataValidations;
                    }
                    get dataValidation() {
                        return this._dataValidations.find(this.address);
                    }
                    set dataValidation(e) {
                        this._dataValidations.add(this.address, e);
                    }
                    get model() {
                        const { model: e } = this._value;
                        return e.style = this.style, this._comment && (e.comment = this._comment.model), e;
                    }
                    set model(e) {
                        if (this._value.release(), this._value = c.create(e.type, this), this._value.model = e, e.comment) switch(e.comment.type){
                            case "note":
                                this._comment = a.fromModel(e.comment);
                        }
                        e.style ? this.style = e.style : this.style = {};
                    }
                }
                l.Types = s.ValueType;
                const c = {
                    getType: (e)=>null == e ? l.Types.Null : e instanceof String || "string" == typeof e ? l.Types.String : "number" == typeof e ? l.Types.Number : "boolean" == typeof e ? l.Types.Boolean : e instanceof Date ? l.Types.Date : e.text && e.hyperlink ? l.Types.Hyperlink : e.formula || e.sharedFormula ? l.Types.Formula : e.richText ? l.Types.RichText : e.sharedString ? l.Types.SharedString : e.error ? l.Types.Error : l.Types.JSON,
                    types: [
                        {
                            t: l.Types.Null,
                            f: class {
                                constructor(e){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Null
                                    };
                                }
                                get value() {
                                    return null;
                                }
                                set value(e) {}
                                get type() {
                                    return l.Types.Null;
                                }
                                get effectiveType() {
                                    return l.Types.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {}
                                toString() {
                                    return "";
                                }
                            }
                        },
                        {
                            t: l.Types.Number,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Number,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Number;
                                }
                                get effectiveType() {
                                    return l.Types.Number;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.String,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.model.value.replace(/"/g, '""')}"`;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.Date,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Date,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Date;
                                }
                                get effectiveType() {
                                    return l.Types.Date;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toISOString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Hyperlink,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Hyperlink,
                                        text: t ? t.text : void 0,
                                        hyperlink: t ? t.hyperlink : void 0
                                    }, t && t.tooltip && (this.model.tooltip = t.tooltip);
                                }
                                get value() {
                                    const e = {
                                        text: this.model.text,
                                        hyperlink: this.model.hyperlink
                                    };
                                    return this.model.tooltip && (e.tooltip = this.model.tooltip), e;
                                }
                                set value(e) {
                                    this.model = {
                                        text: e.text,
                                        hyperlink: e.hyperlink
                                    }, e.tooltip && (this.model.tooltip = e.tooltip);
                                }
                                get text() {
                                    return this.model.text;
                                }
                                set text(e) {
                                    this.model.text = e;
                                }
                                get hyperlink() {
                                    return this.model.hyperlink;
                                }
                                set hyperlink(e) {
                                    this.model.hyperlink = e;
                                }
                                get type() {
                                    return l.Types.Hyperlink;
                                }
                                get effectiveType() {
                                    return l.Types.Hyperlink;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.hyperlink;
                                }
                                release() {}
                                toString() {
                                    return this.model.text;
                                }
                            }
                        },
                        {
                            t: l.Types.Formula,
                            f: class {
                                constructor(e, t){
                                    this.cell = e, this.model = {
                                        address: e.address,
                                        type: l.Types.Formula,
                                        shareType: t ? t.shareType : void 0,
                                        ref: t ? t.ref : void 0,
                                        formula: t ? t.formula : void 0,
                                        sharedFormula: t ? t.sharedFormula : void 0,
                                        result: t ? t.result : void 0
                                    };
                                }
                                _copyModel(e) {
                                    const t = {}, r = (r)=>{
                                        const n = e[r];
                                        n && (t[r] = n);
                                    };
                                    return r("formula"), r("result"), r("ref"), r("shareType"), r("sharedFormula"), t;
                                }
                                get value() {
                                    return this._copyModel(this.model);
                                }
                                set value(e) {
                                    this.model = this._copyModel(e);
                                }
                                validate(e) {
                                    switch(c.getType(e)){
                                        case l.Types.Null:
                                        case l.Types.String:
                                        case l.Types.Number:
                                        case l.Types.Date:
                                            break;
                                        case l.Types.Hyperlink:
                                        case l.Types.Formula:
                                        default:
                                            throw new Error("Cannot process that type of result value");
                                    }
                                }
                                get dependencies() {
                                    return {
                                        ranges: this.formula.match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g),
                                        cells: this.formula.replace(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g, "").match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}/g)
                                    };
                                }
                                get formula() {
                                    return this.model.formula || this._getTranslatedFormula();
                                }
                                set formula(e) {
                                    this.model.formula = e;
                                }
                                get formulaType() {
                                    return this.model.formula ? s.FormulaType.Master : this.model.sharedFormula ? s.FormulaType.Shared : s.FormulaType.None;
                                }
                                get result() {
                                    return this.model.result;
                                }
                                set result(e) {
                                    this.model.result = e;
                                }
                                get type() {
                                    return l.Types.Formula;
                                }
                                get effectiveType() {
                                    const e = this.model.result;
                                    return null == e ? s.ValueType.Null : e instanceof String || "string" == typeof e ? s.ValueType.String : "number" == typeof e ? s.ValueType.Number : e instanceof Date ? s.ValueType.Date : e.text && e.hyperlink ? s.ValueType.Hyperlink : e.formula ? s.ValueType.Formula : s.ValueType.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                _getTranslatedFormula() {
                                    if (!this._translatedFormula && this.model.sharedFormula) {
                                        const { worksheet: e } = this.cell, t = e.findCell(this.model.sharedFormula);
                                        this._translatedFormula = t && o(t.formula, t.address, this.model.address);
                                    }
                                    return this._translatedFormula;
                                }
                                toCsvString() {
                                    return "" + (this.model.result || "");
                                }
                                release() {}
                                toString() {
                                    return this.model.result ? this.model.result.toString() : "";
                                }
                            }
                        },
                        {
                            t: l.Types.Merge,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Merge,
                                        master: t ? t.address : void 0
                                    }, this._master = t, t && t.addMergeRef();
                                }
                                get value() {
                                    return this._master.value;
                                }
                                set value(e) {
                                    e instanceof l ? (this._master && this._master.releaseMergeRef(), e.addMergeRef(), this._master = e) : this._master.value = e;
                                }
                                isMergedTo(e) {
                                    return e === this._master;
                                }
                                get master() {
                                    return this._master;
                                }
                                get type() {
                                    return l.Types.Merge;
                                }
                                get effectiveType() {
                                    return this._master.effectiveType;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {
                                    this._master.releaseMergeRef();
                                }
                                toString() {
                                    return this.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.JSON,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: JSON.stringify(t),
                                        rawValue: t
                                    };
                                }
                                get value() {
                                    return this.model.rawValue;
                                }
                                set value(e) {
                                    this.model.rawValue = e, this.model.value = JSON.stringify(e);
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.SharedString,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.SharedString,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.SharedString;
                                }
                                get effectiveType() {
                                    return l.Types.SharedString;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.RichText,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                toString() {
                                    return this.model.value.richText.map((e)=>e.text).join("");
                                }
                                get type() {
                                    return l.Types.RichText;
                                }
                                get effectiveType() {
                                    return l.Types.RichText;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.text.replace(/"/g, '""')}"`;
                                }
                                release() {}
                            }
                        },
                        {
                            t: l.Types.Boolean,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Boolean,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Boolean;
                                }
                                get effectiveType() {
                                    return l.Types.Boolean;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value ? 1 : 0;
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Error,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Error,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Error;
                                }
                                get effectiveType() {
                                    return l.Types.Error;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.error.toString();
                                }
                            }
                        }
                    ].reduce((e, t)=>(e[t.t] = t.f, e), []),
                    create (e, t, r) {
                        const n = this.types[e];
                        if (!n) throw new Error("Could not create Value of type " + e);
                        return new n(t, r);
                    }
                };
                t.exports = l;
            },
            {
                "../utils/col-cache": 19,
                "../utils/shared-formula": 23,
                "../utils/under-dash": 26,
                "./enums": 7,
                "./note": 9
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache");
                class o {
                    constructor(e, t, r){
                        this._worksheet = e, this._number = t, !1 !== r && (this.defn = r);
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    get letter() {
                        return s.n2l(this._number);
                    }
                    get isCustomWidth() {
                        return void 0 !== this.width && 9 !== this.width;
                    }
                    get defn() {
                        return {
                            header: this._header,
                            key: this.key,
                            width: this.width,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel
                        };
                    }
                    set defn(e) {
                        e ? (this.key = e.key, this.width = void 0 !== e.width ? e.width : 9, this.outlineLevel = e.outlineLevel, e.style ? this.style = e.style : this.style = {}, this.header = e.header, this._hidden = !!e.hidden) : (delete this._header, delete this._key, delete this.width, this.style = {}, this.outlineLevel = 0);
                    }
                    get headers() {
                        return this._header && this._header instanceof Array ? this._header : [
                            this._header
                        ];
                    }
                    get header() {
                        return this._header;
                    }
                    set header(e) {
                        void 0 !== e ? (this._header = e, this.headers.forEach((e, t)=>{
                            this._worksheet.getCell(t + 1, this.number).value = e;
                        })) : this._header = void 0;
                    }
                    get key() {
                        return this._key;
                    }
                    set key(e) {
                        (this._key && this._worksheet.getColumnKey(this._key)) === this && this._worksheet.deleteColumnKey(this._key), this._key = e, e && this._worksheet.setColumnKey(this._key, this);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelCol);
                    }
                    toString() {
                        return JSON.stringify({
                            key: this.key,
                            width: this.width,
                            headers: this.headers.length ? this.headers : void 0
                        });
                    }
                    equivalentTo(e) {
                        return this.width === e.width && this.hidden === e.hidden && this.outlineLevel === e.outlineLevel && n.isEqual(this.style, e.style);
                    }
                    get isDefault() {
                        if (this.isCustomWidth) return !1;
                        if (this.hidden) return !1;
                        if (this.outlineLevel) return !1;
                        const e = this.style;
                        return !e || !(e.font || e.numFmt || e.alignment || e.border || e.fill || e.protection);
                    }
                    get headerCount() {
                        return this.headers.length;
                    }
                    eachCell(e, t) {
                        const r = this.number;
                        t || (t = e, e = null), this._worksheet.eachRow(e, (e, n)=>{
                            t(e.getCell(r), n);
                        });
                    }
                    get values() {
                        const e = [];
                        return this.eachCell((t, r)=>{
                            t && t.type !== i.ValueType.Null && (e[r] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (!e) return;
                        const t = this.number;
                        let r = 0;
                        e.hasOwnProperty("0") && (r = 1), e.forEach((e, n)=>{
                            this._worksheet.getCell(n + r, t).value = e;
                        });
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this.eachCell((r)=>{
                            r[e] = t;
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    static toModel(e) {
                        const t = [];
                        let r = null;
                        return e && e.forEach((e, n)=>{
                            e.isDefault ? r && (r = null) : r && e.equivalentTo(r) ? r.max = n + 1 : (r = {
                                min: n + 1,
                                max: n + 1,
                                width: void 0 !== e.width ? e.width : 9,
                                style: e.style,
                                isCustomWidth: e.isCustomWidth,
                                hidden: e.hidden,
                                outlineLevel: e.outlineLevel,
                                collapsed: e.collapsed
                            }, t.push(r));
                        }), t.length ? t : void 0;
                    }
                    static fromModel(e, t) {
                        const r = [];
                        let n = 1, i = 0;
                        for(t = (t = t || []).sort(function(e, t) {
                            return e.min - t.min;
                        }); i < t.length;){
                            const s = t[i++];
                            for(; n < s.min;)r.push(new o(e, n++));
                            for(; n <= s.max;)r.push(new o(e, n++, s));
                        }
                        return r.length ? r : null;
                    }
                }
                t.exports = o;
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./enums": 7
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                t.exports = class {
                    constructor(e){
                        this.model = e || {};
                    }
                    add(e, t) {
                        return this.model[e] = t;
                    }
                    find(e) {
                        return this.model[e];
                    }
                    remove(e) {
                        this.model[e] = void 0;
                    }
                };
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("../utils/cell-matrix"), o = e("./range"), a = /[$](\w+)[$](\d+)(:[$](\w+)[$](\d+))?/;
                t.exports = class {
                    constructor(){
                        this.matrixMap = {};
                    }
                    getMatrix(e) {
                        return this.matrixMap[e] || (this.matrixMap[e] = new s);
                    }
                    add(e, t) {
                        const r = i.decodeEx(e);
                        this.addEx(r, t);
                    }
                    addEx(e, t) {
                        const r = this.getMatrix(t);
                        if (e.top) for(let t = e.left; t <= e.right; t++)for(let n = e.top; n <= e.bottom; n++){
                            const s = {
                                sheetName: e.sheetName,
                                address: i.n2l(t) + n,
                                row: n,
                                col: t
                            };
                            r.addCellEx(s);
                        }
                        else r.addCellEx(e);
                    }
                    remove(e, t) {
                        const r = i.decodeEx(e);
                        this.removeEx(r, t);
                    }
                    removeEx(e, t) {
                        this.getMatrix(t).removeCellEx(e);
                    }
                    removeAllNames(e) {
                        n.each(this.matrixMap, (t)=>{
                            t.removeCellEx(e);
                        });
                    }
                    forEach(e) {
                        n.each(this.matrixMap, (t, r)=>{
                            t.forEach((t)=>{
                                e(r, t);
                            });
                        });
                    }
                    getNames(e) {
                        return this.getNamesEx(i.decodeEx(e));
                    }
                    getNamesEx(e) {
                        return n.map(this.matrixMap, (t, r)=>t.findCellEx(e) && r).filter(Boolean);
                    }
                    _explore(e, t) {
                        t.mark = !1;
                        const { sheetName: r } = t, n = new o(t.row, t.col, t.row, t.col, r);
                        let i, s;
                        function a(i, s) {
                            const o = e.findCellAt(r, i, t.col);
                            return !(!o || !o.mark) && (n[s] = i, o.mark = !1, !0);
                        }
                        for(s = t.row - 1; a(s, "top"); s--);
                        for(s = t.row + 1; a(s, "bottom"); s++);
                        function l(t, i) {
                            const o = [];
                            for(s = n.top; s <= n.bottom; s++){
                                const n = e.findCellAt(r, s, t);
                                if (!n || !n.mark) return !1;
                                o.push(n);
                            }
                            n[i] = t;
                            for(let e = 0; e < o.length; e++)o[e].mark = !1;
                            return !0;
                        }
                        for(i = t.col - 1; l(i, "left"); i--);
                        for(i = t.col + 1; l(i, "right"); i++);
                        return n;
                    }
                    getRanges(e, t) {
                        if (!(t = t || this.matrixMap[e])) return {
                            name: e,
                            ranges: []
                        };
                        t.forEach((e)=>{
                            e.mark = !0;
                        });
                        return {
                            name: e,
                            ranges: t.map((e)=>e.mark && this._explore(t, e)).filter(Boolean).map((e)=>e.$shortRange)
                        };
                    }
                    normaliseMatrix(e, t) {
                        e.forEachInSheet(t, (e, t, r)=>{
                            e && (e.row === t && e.col === r || (e.row = t, e.col = r, e.address = i.n2l(r) + t));
                        });
                    }
                    spliceRows(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceRows(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    spliceColumns(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceColumns(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    get model() {
                        return n.map(this.matrixMap, (e, t)=>this.getRanges(t, e)).filter((e)=>e.ranges.length);
                    }
                    set model(e) {
                        const t = this.matrixMap = {};
                        e.forEach((e)=>{
                            const r = t[e.name] = new s;
                            e.ranges.forEach((e)=>{
                                a.test(e.split("!").pop() || "") && r.addCell(e);
                            });
                        });
                    }
                };
            },
            {
                "../utils/cell-matrix": 18,
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./range": 10
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    ValueType: {
                        Null: 0,
                        Merge: 1,
                        Number: 2,
                        String: 3,
                        Date: 4,
                        Hyperlink: 5,
                        Formula: 6,
                        SharedString: 7,
                        RichText: 8,
                        Boolean: 9,
                        Error: 10
                    },
                    FormulaType: {
                        None: 0,
                        Master: 1,
                        Shared: 2
                    },
                    RelationshipType: {
                        None: 0,
                        OfficeDocument: 1,
                        Worksheet: 2,
                        CalcChain: 3,
                        SharedStrings: 4,
                        Styles: 5,
                        Theme: 6,
                        Hyperlink: 7
                    },
                    DocumentType: {
                        Xlsx: 1
                    },
                    ReadingOrder: {
                        LeftToRight: 1,
                        RightToLeft: 2
                    },
                    ErrorValue: {
                        NotApplicable: "#N/A",
                        Ref: "#REF!",
                        Name: "#NAME?",
                        DivZero: "#DIV/0!",
                        Null: "#NULL!",
                        Value: "#VALUE!",
                        Num: "#NUM!"
                    }
                };
            },
            {}
        ],
        8: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("./anchor");
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, this.model = t;
                    }
                    get model() {
                        switch(this.type){
                            case "background":
                                return {
                                    type: this.type,
                                    imageId: this.imageId
                                };
                            case "image":
                                return {
                                    type: this.type,
                                    imageId: this.imageId,
                                    hyperlinks: this.range.hyperlinks,
                                    range: {
                                        tl: this.range.tl.model,
                                        br: this.range.br && this.range.br.model,
                                        ext: this.range.ext,
                                        editAs: this.range.editAs
                                    }
                                };
                            default:
                                throw new Error("Invalid Image Type");
                        }
                    }
                    set model(e) {
                        let { type: t, imageId: r, range: s, hyperlinks: o } = e;
                        if (this.type = t, this.imageId = r, "image" === t) {
                            if ("string" == typeof s) {
                                const e = n.decode(s);
                                this.range = {
                                    tl: new i(this.worksheet, {
                                        col: e.left,
                                        row: e.top
                                    }, -1),
                                    br: new i(this.worksheet, {
                                        col: e.right,
                                        row: e.bottom
                                    }, 0),
                                    editAs: "oneCell"
                                };
                            } else this.range = {
                                tl: new i(this.worksheet, s.tl, 0),
                                br: s.br && new i(this.worksheet, s.br, 0),
                                ext: s.ext,
                                editAs: s.editAs,
                                hyperlinks: o || s.hyperlinks
                            };
                        }
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "./anchor": 2
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash");
                class i {
                    constructor(e){
                        this.note = e;
                    }
                    get model() {
                        let e = null;
                        switch(typeof this.note){
                            case "string":
                                e = {
                                    type: "note",
                                    note: {
                                        texts: [
                                            {
                                                text: this.note
                                            }
                                        ]
                                    }
                                };
                                break;
                            default:
                                e = {
                                    type: "note",
                                    note: this.note
                                };
                        }
                        return n.deepMerge({}, i.DEFAULT_CONFIGS, e);
                    }
                    set model(e) {
                        const { note: t } = e, { texts: r } = t;
                        1 === r.length && 1 === Object.keys(r[0]).length ? this.note = r[0].text : this.note = t;
                    }
                    static fromModel(e) {
                        const t = new i;
                        return t.model = e, t;
                    }
                }
                i.DEFAULT_CONFIGS = {
                    note: {
                        margins: {
                            insetmode: "auto",
                            inset: [
                                .13,
                                .13,
                                .25,
                                .25
                            ]
                        },
                        protection: {
                            locked: "True",
                            lockText: "True"
                        },
                        editAs: "absolute"
                    }
                }, t.exports = i;
            },
            {
                "../utils/under-dash": 26
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(){
                        this.decode(arguments);
                    }
                    setTLBR(e, t, r, i, s) {
                        if (arguments.length < 4) {
                            const i = n.decodeAddress(e), o = n.decodeAddress(t);
                            this.model = {
                                top: Math.min(i.row, o.row),
                                left: Math.min(i.col, o.col),
                                bottom: Math.max(i.row, o.row),
                                right: Math.max(i.col, o.col),
                                sheetName: r
                            }, this.setTLBR(i.row, i.col, o.row, o.col, s);
                        } else this.model = {
                            top: Math.min(e, r),
                            left: Math.min(t, i),
                            bottom: Math.max(e, r),
                            right: Math.max(t, i),
                            sheetName: s
                        };
                    }
                    decode(e) {
                        switch(e.length){
                            case 5:
                                this.setTLBR(e[0], e[1], e[2], e[3], e[4]);
                                break;
                            case 4:
                                this.setTLBR(e[0], e[1], e[2], e[3]);
                                break;
                            case 3:
                                this.setTLBR(e[0], e[1], e[2]);
                                break;
                            case 2:
                                this.setTLBR(e[0], e[1]);
                                break;
                            case 1:
                                {
                                    const t = e[0];
                                    if (t instanceof i) this.model = {
                                        top: t.model.top,
                                        left: t.model.left,
                                        bottom: t.model.bottom,
                                        right: t.model.right,
                                        sheetName: t.sheetName
                                    };
                                    else if (t instanceof Array) this.decode(t);
                                    else if (t.top && t.left && t.bottom && t.right) this.model = {
                                        top: t.top,
                                        left: t.left,
                                        bottom: t.bottom,
                                        right: t.right,
                                        sheetName: t.sheetName
                                    };
                                    else {
                                        const e = n.decodeEx(t);
                                        e.top ? this.model = {
                                            top: e.top,
                                            left: e.left,
                                            bottom: e.bottom,
                                            right: e.right,
                                            sheetName: e.sheetName
                                        } : this.model = {
                                            top: e.row,
                                            left: e.col,
                                            bottom: e.row,
                                            right: e.col,
                                            sheetName: e.sheetName
                                        };
                                    }
                                    break;
                                }
                            case 0:
                                this.model = {
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0
                                };
                                break;
                            default:
                                throw new Error("Invalid number of arguments to _getDimensions() - " + e.length);
                        }
                    }
                    get top() {
                        return this.model.top || 1;
                    }
                    set top(e) {
                        this.model.top = e;
                    }
                    get left() {
                        return this.model.left || 1;
                    }
                    set left(e) {
                        this.model.left = e;
                    }
                    get bottom() {
                        return this.model.bottom || 1;
                    }
                    set bottom(e) {
                        this.model.bottom = e;
                    }
                    get right() {
                        return this.model.right || 1;
                    }
                    set right(e) {
                        this.model.right = e;
                    }
                    get sheetName() {
                        return this.model.sheetName;
                    }
                    set sheetName(e) {
                        this.model.sheetName = e;
                    }
                    get _serialisedSheetName() {
                        const { sheetName: e } = this.model;
                        return e ? /^[a-zA-Z0-9]*$/.test(e) ? e + "!" : `'${e}'!` : "";
                    }
                    expand(e, t, r, n) {
                        (!this.model.top || e < this.top) && (this.top = e), (!this.model.left || t < this.left) && (this.left = t), (!this.model.bottom || r > this.bottom) && (this.bottom = r), (!this.model.right || n > this.right) && (this.right = n);
                    }
                    expandRow(e) {
                        if (e) {
                            const { dimensions: t, number: r } = e;
                            t && this.expand(r, t.min, r, t.max);
                        }
                    }
                    expandToAddress(e) {
                        const t = n.decodeEx(e);
                        this.expand(t.row, t.col, t.row, t.col);
                    }
                    get tl() {
                        return n.n2l(this.left) + this.top;
                    }
                    get $t$l() {
                        return `$${n.n2l(this.left)}$${this.top}`;
                    }
                    get br() {
                        return n.n2l(this.right) + this.bottom;
                    }
                    get $b$r() {
                        return `$${n.n2l(this.right)}$${this.bottom}`;
                    }
                    get range() {
                        return `${this._serialisedSheetName + this.tl}:${this.br}`;
                    }
                    get $range() {
                        return `${this._serialisedSheetName + this.$t$l}:${this.$b$r}`;
                    }
                    get shortRange() {
                        return this.count > 1 ? this.range : this._serialisedSheetName + this.tl;
                    }
                    get $shortRange() {
                        return this.count > 1 ? this.$range : this._serialisedSheetName + this.$t$l;
                    }
                    get count() {
                        return (1 + this.bottom - this.top) * (1 + this.right - this.left);
                    }
                    toString() {
                        return this.range;
                    }
                    intersects(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && !(e.bottom < this.top) && !(e.top > this.bottom) && !(e.right < this.left) && !(e.left > this.right);
                    }
                    contains(e) {
                        const t = n.decodeEx(e);
                        return this.containsEx(t);
                    }
                    containsEx(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && e.row >= this.top && e.row <= this.bottom && e.col >= this.left && e.col <= this.right;
                    }
                    forEachAddress(e) {
                        for(let t = this.left; t <= this.right; t++)for(let r = this.top; r <= this.bottom; r++)e(n.encodeAddress(r, t), r, t);
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache"), o = e("./cell");
                t.exports = class {
                    constructor(e, t){
                        this._worksheet = e, this._number = t, this._cells = [], this.style = {}, this.outlineLevel = 0;
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    commit() {
                        this._worksheet._commitRow(this);
                    }
                    destroy() {
                        delete this._worksheet, delete this._cells, delete this.style;
                    }
                    findCell(e) {
                        return this._cells[e - 1];
                    }
                    getCellEx(e) {
                        let t = this._cells[e.col - 1];
                        if (!t) {
                            const r = this._worksheet.getColumn(e.col);
                            t = new o(this, r, e.address), this._cells[e.col - 1] = t;
                        }
                        return t;
                    }
                    getCell(e) {
                        if ("string" == typeof e) {
                            const t = this._worksheet.getColumnKey(e);
                            e = t ? t.number : s.l2n(e);
                        }
                        return this._cells[e - 1] || this.getCellEx({
                            address: s.encodeAddress(this._number, e),
                            row: this._number,
                            col: e
                        });
                    }
                    splice(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length - t, a = this._cells.length;
                        let l, c, u;
                        if (o < 0) for(l = e + i.length; l <= a; l++)u = this._cells[l - 1], c = this._cells[l - o - 1], c ? (u = this.getCell(l), u.value = c.value, u.style = c.style, u._comment = c._comment) : u && (u.value = null, u.style = {}, u._comment = void 0);
                        else if (o > 0) for(l = a; l >= r; l--)c = this._cells[l - 1], c ? (u = this.getCell(l + o), u.value = c.value, u.style = c.style, u._comment = c._comment) : this._cells[l + o - 1] = void 0;
                        for(l = 0; l < i.length; l++)u = this.getCell(e + l), u.value = i[l], u.style = {}, u._comment = void 0;
                    }
                    eachCell(e, t) {
                        if (t || (t = e, e = null), e && e.includeEmpty) {
                            const e = this._cells.length;
                            for(let r = 1; r <= e; r++)t(this.getCell(r), r);
                        } else this._cells.forEach((e, r)=>{
                            e && e.type !== i.ValueType.Null && t(e, r + 1);
                        });
                    }
                    addPageBreak(e, t) {
                        const r = this._worksheet, n = Math.max(0, e - 1) || 0, i = Math.max(0, t - 1) || 16838, s = {
                            id: this._number,
                            max: i,
                            man: 1
                        };
                        n && (s.min = n), r.rowBreaks.push(s);
                    }
                    get values() {
                        const e = [];
                        return this._cells.forEach((t)=>{
                            t && t.type !== i.ValueType.Null && (e[t.col] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (this._cells = [], e) {
                            if (e instanceof Array) {
                                let t = 0;
                                e.hasOwnProperty("0") && (t = 1), e.forEach((e, r)=>{
                                    void 0 !== e && (this.getCellEx({
                                        address: s.encodeAddress(this._number, r + t),
                                        row: this._number,
                                        col: r + t
                                    }).value = e);
                                });
                            } else this._worksheet.eachColumnKey((t, r)=>{
                                void 0 !== e[r] && (this.getCellEx({
                                    address: s.encodeAddress(this._number, t.number),
                                    row: this._number,
                                    col: t.number
                                }).value = e[r]);
                            });
                        } else ;
                    }
                    get hasValues() {
                        return n.some(this._cells, (e)=>e && e.type !== i.ValueType.Null);
                    }
                    get cellCount() {
                        return this._cells.length;
                    }
                    get actualCellCount() {
                        let e = 0;
                        return this.eachCell(()=>{
                            e++;
                        }), e;
                    }
                    get dimensions() {
                        let e = 0, t = 0;
                        return this._cells.forEach((r)=>{
                            r && r.type !== i.ValueType.Null && ((!e || e > r.col) && (e = r.col), t < r.col && (t = r.col));
                        }), e > 0 ? {
                            min: e,
                            max: t
                        } : null;
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this._cells.forEach((r)=>{
                            r && (r[e] = t);
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelRow);
                    }
                    get model() {
                        const e = [];
                        let t = 0, r = 0;
                        return this._cells.forEach((n)=>{
                            if (n) {
                                const i = n.model;
                                i && ((!t || t > n.col) && (t = n.col), r < n.col && (r = n.col), e.push(i));
                            }
                        }), this.height || e.length ? {
                            cells: e,
                            number: this.number,
                            min: t,
                            max: r,
                            height: this.height,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel,
                            collapsed: this.collapsed
                        } : null;
                    }
                    set model(e) {
                        if (e.number !== this._number) throw new Error("Invalid row number in model");
                        let t;
                        this._cells = [], e.cells.forEach((e)=>{
                            switch(e.type){
                                case o.Types.Merge:
                                    break;
                                default:
                                    {
                                        let r;
                                        if (e.address) r = s.decodeAddress(e.address);
                                        else if (t) {
                                            const { row: e } = t, n = t.col + 1;
                                            r = {
                                                row: e,
                                                col: n,
                                                address: s.encodeAddress(e, n),
                                                $col$row: `$${s.n2l(n)}$${e}`
                                            };
                                        }
                                        t = r;
                                        this.getCellEx(r).model = e;
                                        break;
                                    }
                            }
                        }), e.height ? this.height = e.height : delete this.height, this.hidden = e.hidden, this.outlineLevel = e.outlineLevel || 0, this.style = e.style && JSON.parse(JSON.stringify(e.style)) || {};
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./cell": 3,
                "./enums": 7
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t, r){
                        this.table = e, this.column = t, this.index = r;
                    }
                    _set(e, t) {
                        this.table.cacheState(), this.column[e] = t;
                    }
                    get name() {
                        return this.column.name;
                    }
                    set name(e) {
                        this._set("name", e);
                    }
                    get filterButton() {
                        return this.column.filterButton;
                    }
                    set filterButton(e) {
                        this.column.filterButton = e;
                    }
                    get style() {
                        return this.column.style;
                    }
                    set style(e) {
                        this.column.style = e;
                    }
                    get totalsRowLabel() {
                        return this.column.totalsRowLabel;
                    }
                    set totalsRowLabel(e) {
                        this._set("totalsRowLabel", e);
                    }
                    get totalsRowFunction() {
                        return this.column.totalsRowFunction;
                    }
                    set totalsRowFunction(e) {
                        this._set("totalsRowFunction", e);
                    }
                    get totalsRowResult() {
                        return this.column.totalsRowResult;
                    }
                    set totalsRowResult(e) {
                        this._set("totalsRowResult", e);
                    }
                    get totalsRowFormula() {
                        return this.column.totalsRowFormula;
                    }
                    set totalsRowFormula(e) {
                        this._set("totalsRowFormula", e);
                    }
                }
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, t && (this.table = t, this.validate(), this.store());
                    }
                    getFormula(e) {
                        switch(e.totalsRowFunction){
                            case "none":
                                return null;
                            case "average":
                                return `SUBTOTAL(101,${this.table.name}[${e.name}])`;
                            case "countNums":
                                return `SUBTOTAL(102,${this.table.name}[${e.name}])`;
                            case "count":
                                return `SUBTOTAL(103,${this.table.name}[${e.name}])`;
                            case "max":
                                return `SUBTOTAL(104,${this.table.name}[${e.name}])`;
                            case "min":
                                return `SUBTOTAL(105,${this.table.name}[${e.name}])`;
                            case "stdDev":
                                return `SUBTOTAL(106,${this.table.name}[${e.name}])`;
                            case "var":
                                return `SUBTOTAL(107,${this.table.name}[${e.name}])`;
                            case "sum":
                                return `SUBTOTAL(109,${this.table.name}[${e.name}])`;
                            case "custom":
                                return e.totalsRowFormula;
                            default:
                                throw new Error("Invalid Totals Row Function: " + e.totalsRowFunction);
                        }
                    }
                    get width() {
                        return this.table.columns.length;
                    }
                    get height() {
                        return this.table.rows.length;
                    }
                    get filterHeight() {
                        return this.height + (this.table.headerRow ? 1 : 0);
                    }
                    get tableHeight() {
                        return this.filterHeight + (this.table.totalsRow ? 1 : 0);
                    }
                    validate() {
                        const { table: e } = this, t = (e, t, r)=>{
                            void 0 === e[t] && (e[t] = r);
                        };
                        t(e, "headerRow", !0), t(e, "totalsRow", !1), t(e, "style", {}), t(e.style, "theme", "TableStyleMedium2"), t(e.style, "showFirstColumn", !1), t(e.style, "showLastColumn", !1), t(e.style, "showRowStripes", !1), t(e.style, "showColumnStripes", !1);
                        const r = (e, t)=>{
                            if (!e) throw new Error(t);
                        };
                        r(e.ref, "Table must have ref"), r(e.columns, "Table must have column definitions"), r(e.rows, "Table must have row definitions"), e.tl = n.decodeAddress(e.ref);
                        const { row: i, col: s } = e.tl;
                        r(i > 0, "Table must be on valid row"), r(s > 0, "Table must be on valid col");
                        const { width: o, filterHeight: a, tableHeight: l } = this;
                        e.autoFilterRef = n.encode(i, s, i + a - 1, s + o - 1), e.tableRef = n.encode(i, s, i + l - 1, s + o - 1), e.columns.forEach((e, n)=>{
                            r(e.name, `Column ${n} must have a name`), 0 === n ? t(e, "totalsRowLabel", "Total") : (t(e, "totalsRowFunction", "none"), e.totalsRowFormula = this.getFormula(e));
                        });
                    }
                    store() {
                        const e = (e, t)=>{
                            t && Object.keys(t).forEach((r)=>{
                                e[r] = t[r];
                            });
                        }, { worksheet: t, table: r } = this, { row: n, col: i } = r.tl;
                        let s = 0;
                        if (r.headerRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const { style: n, name: s } = t, a = o.getCell(i + r);
                                a.value = s, e(a, n);
                            });
                        }
                        if (r.rows.forEach((o)=>{
                            const a = t.getRow(n + s++);
                            o.forEach((t, n)=>{
                                const s = a.getCell(i + n);
                                s.value = t, e(s, r.columns[n].style);
                            });
                        }), r.totalsRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const n = o.getCell(i + r);
                                if (0 === r) n.value = t.totalsRowLabel;
                                else {
                                    const e = this.getFormula(t);
                                    n.value = e ? {
                                        formula: t.totalsRowFormula,
                                        result: t.totalsRowResult
                                    } : null;
                                }
                                e(n, t.style);
                            });
                        }
                    }
                    load(e) {
                        const { table: t } = this, { row: r, col: n } = t.tl;
                        let i = 0;
                        if (t.headerRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                s.getCell(n + t).value = e.name;
                            });
                        }
                        if (t.rows.forEach((t)=>{
                            const s = e.getRow(r + i++);
                            t.forEach((e, t)=>{
                                s.getCell(n + t).value = e;
                            });
                        }), t.totalsRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                const r = s.getCell(n + t);
                                if (0 === t) r.value = e.totalsRowLabel;
                                else this.getFormula(e) && (r.value = {
                                    formula: e.totalsRowFormula,
                                    result: e.totalsRowResult
                                });
                            });
                        }
                    }
                    get model() {
                        return this.table;
                    }
                    set model(e) {
                        this.table = e;
                    }
                    cacheState() {
                        this._cache || (this._cache = {
                            ref: this.ref,
                            width: this.width,
                            tableHeight: this.tableHeight
                        });
                    }
                    commit() {
                        if (!this._cache) return;
                        this.validate();
                        const e = n.decodeAddress(this._cache.ref);
                        if (this.ref !== this._cache.ref) for(let t = 0; t < this._cache.tableHeight; t++){
                            const r = this.worksheet.getRow(e.row + t);
                            for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                        }
                        else {
                            for(let t = this.tableHeight; t < this._cache.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                            for(let t = 0; t < this.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = this.width; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                        }
                        this.store();
                    }
                    addRow(e, t) {
                        this.cacheState(), void 0 === t ? this.table.rows.push(e) : this.table.rows.splice(t, 0, e);
                    }
                    removeRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.rows.splice(e, t);
                    }
                    getColumn(e) {
                        const t = this.table.columns[e];
                        return new i(this, t, e);
                    }
                    addColumn(e, t, r) {
                        this.cacheState(), void 0 === r ? (this.table.columns.push(e), this.table.rows.forEach((e, r)=>{
                            e.push(t[r]);
                        })) : (this.table.columns.splice(r, 0, e), this.table.rows.forEach((e, n)=>{
                            e.splice(r, 0, t[n]);
                        }));
                    }
                    removeColumns(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.columns.splice(e, t), this.table.rows.forEach((r)=>{
                            r.splice(e, t);
                        });
                    }
                    _assign(e, t, r) {
                        this.cacheState(), e[t] = r;
                    }
                    get ref() {
                        return this.table.ref;
                    }
                    set ref(e) {
                        this._assign(this.table, "ref", e);
                    }
                    get name() {
                        return this.table.name;
                    }
                    set name(e) {
                        this.table.name = e;
                    }
                    get displayName() {
                        return this.table.displyName || this.table.name;
                    }
                    set displayNamename(e) {
                        this.table.displayName = e;
                    }
                    get headerRow() {
                        return this.table.headerRow;
                    }
                    set headerRow(e) {
                        this._assign(this.table, "headerRow", e);
                    }
                    get totalsRow() {
                        return this.table.totalsRow;
                    }
                    set totalsRow(e) {
                        this._assign(this.table, "totalsRow", e);
                    }
                    get theme() {
                        return this.table.style.name;
                    }
                    set theme(e) {
                        this.table.style.name = e;
                    }
                    get showFirstColumn() {
                        return this.table.style.showFirstColumn;
                    }
                    set showFirstColumn(e) {
                        this.table.style.showFirstColumn = e;
                    }
                    get showLastColumn() {
                        return this.table.style.showLastColumn;
                    }
                    set showLastColumn(e) {
                        this.table.style.showLastColumn = e;
                    }
                    get showRowStripes() {
                        return this.table.style.showRowStripes;
                    }
                    set showRowStripes(e) {
                        this.table.style.showRowStripes = e;
                    }
                    get showColumnStripes() {
                        return this.table.style.showColumnStripes;
                    }
                    set showColumnStripes(e) {
                        this.table.style.showColumnStripes = e;
                    }
                };
            },
            {
                "../utils/col-cache": 19
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                const n = e("./worksheet"), i = e("./defined-names"), s = e("../xlsx/xlsx"), o = e("../csv/csv");
                t.exports = class {
                    constructor(){
                        this.category = "", this.company = "", this.created = new Date, this.description = "", this.keywords = "", this.manager = "", this.modified = this.created, this.properties = {}, this.calcProperties = {}, this._worksheets = [], this.subject = "", this.title = "", this.views = [], this.media = [], this._definedNames = new i;
                    }
                    get xlsx() {
                        return this._xlsx || (this._xlsx = new s(this)), this._xlsx;
                    }
                    get csv() {
                        return this._csv || (this._csv = new o(this)), this._csv;
                    }
                    get nextId() {
                        for(let e = 1; e < this._worksheets.length; e++)if (!this._worksheets[e]) return e;
                        return this._worksheets.length || 1;
                    }
                    addWorksheet(e, t) {
                        const r = this.nextId;
                        t && ("string" == typeof t ? (console.trace('tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { argb: "rbg value" } }'), t = {
                            properties: {
                                tabColor: {
                                    argb: t
                                }
                            }
                        }) : (t.argb || t.theme || t.indexed) && (console.trace("tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { ... } }"), t = {
                            properties: {
                                tabColor: t
                            }
                        }));
                        const i = this._worksheets.reduce((e, t)=>(t && t.orderNo) > e ? t.orderNo : e, 0), s = Object.assign({}, t, {
                            id: r,
                            name: e,
                            orderNo: i + 1,
                            workbook: this
                        }), o = new n(s);
                        return this._worksheets[r] = o, o;
                    }
                    removeWorksheetEx(e) {
                        delete this._worksheets[e.id];
                    }
                    removeWorksheet(e) {
                        const t = this.getWorksheet(e);
                        t && t.destroy();
                    }
                    getWorksheet(e) {
                        return void 0 === e ? this._worksheets.find(Boolean) : "number" == typeof e ? this._worksheets[e] : "string" == typeof e ? this._worksheets.find((t)=>t && t.name === e) : void 0;
                    }
                    get worksheets() {
                        return this._worksheets.slice(1).sort((e, t)=>e.orderNo - t.orderNo).filter(Boolean);
                    }
                    eachSheet(e) {
                        this.worksheets.forEach((t)=>{
                            e(t, t.id);
                        });
                    }
                    get definedNames() {
                        return this._definedNames;
                    }
                    clearThemes() {
                        this._themes = void 0;
                    }
                    addImage(e) {
                        const t = this.media.length;
                        return this.media.push(Object.assign({}, e, {
                            type: "image"
                        })), t;
                    }
                    getImage(e) {
                        return this.media[e];
                    }
                    get model() {
                        return {
                            creator: this.creator || "Unknown",
                            lastModifiedBy: this.lastModifiedBy || "Unknown",
                            lastPrinted: this.lastPrinted,
                            created: this.created,
                            modified: this.modified,
                            properties: this.properties,
                            worksheets: this.worksheets.map((e)=>e.model),
                            sheets: this.worksheets.map((e)=>e.model).filter(Boolean),
                            definedNames: this._definedNames.model,
                            views: this.views,
                            company: this.company,
                            manager: this.manager,
                            title: this.title,
                            subject: this.subject,
                            keywords: this.keywords,
                            category: this.category,
                            description: this.description,
                            language: this.language,
                            revision: this.revision,
                            contentStatus: this.contentStatus,
                            themes: this._themes,
                            media: this.media,
                            calcProperties: this.calcProperties
                        };
                    }
                    set model(e) {
                        this.creator = e.creator, this.lastModifiedBy = e.lastModifiedBy, this.lastPrinted = e.lastPrinted, this.created = e.created, this.modified = e.modified, this.company = e.company, this.manager = e.manager, this.title = e.title, this.subject = e.subject, this.keywords = e.keywords, this.category = e.category, this.description = e.description, this.language = e.language, this.revision = e.revision, this.contentStatus = e.contentStatus, this.properties = e.properties, this.calcProperties = e.calcProperties, this._worksheets = [], e.worksheets.forEach((t)=>{
                            const { id: r, name: i, state: s } = t, o = e.sheets && e.sheets.findIndex((e)=>e.id === r);
                            (this._worksheets[r] = new n({
                                id: r,
                                name: i,
                                orderNo: o,
                                state: s,
                                workbook: this
                            })).model = t;
                        }), this._definedNames.model = e.definedNames, this.views = e.views, this._themes = e.themes, this.media = e.media || [];
                    }
                };
            },
            {
                "../csv/csv": 1,
                "../xlsx/xlsx": 144,
                "./defined-names": 6,
                "./worksheet": 14
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("./range"), o = e("./row"), a = e("./column"), l = e("./enums"), c = e("./image"), u = e("./table"), h = e("./data-validations"), f = e("../utils/encryptor"), { copyStyle: d } = e("../utils/copy-style");
                t.exports = class {
                    constructor(e){
                        e = e || {}, this._workbook = e.workbook, this.id = e.id, this.orderNo = e.orderNo, this.name = e.name, this.state = e.state || "visible", this._rows = [], this._columns = null, this._keys = {}, this._merges = {}, this.rowBreaks = [], this.properties = Object.assign({}, {
                            defaultRowHeight: 15,
                            dyDescent: 55,
                            outlineLevelCol: 0,
                            outlineLevelRow: 0
                        }, e.properties), this.pageSetup = Object.assign({}, {
                            margins: {
                                left: .7,
                                right: .7,
                                top: .75,
                                bottom: .75,
                                header: .3,
                                footer: .3
                            },
                            orientation: "portrait",
                            horizontalDpi: 4294967295,
                            verticalDpi: 4294967295,
                            fitToPage: !(!e.pageSetup || !e.pageSetup.fitToWidth && !e.pageSetup.fitToHeight || e.pageSetup.scale),
                            pageOrder: "downThenOver",
                            blackAndWhite: !1,
                            draft: !1,
                            cellComments: "None",
                            errors: "displayed",
                            scale: 100,
                            fitToWidth: 1,
                            fitToHeight: 1,
                            paperSize: void 0,
                            showRowColHeaders: !1,
                            showGridLines: !1,
                            firstPageNumber: void 0,
                            horizontalCentered: !1,
                            verticalCentered: !1,
                            rowBreaks: null,
                            colBreaks: null
                        }, e.pageSetup), this.headerFooter = Object.assign({}, {
                            differentFirst: !1,
                            differentOddEven: !1,
                            oddHeader: null,
                            oddFooter: null,
                            evenHeader: null,
                            evenFooter: null,
                            firstHeader: null,
                            firstFooter: null
                        }, e.headerFooter), this.dataValidations = new h, this.views = e.views || [], this.autoFilter = e.autoFilter || null, this._media = [], this.sheetProtection = null, this.tables = {}, this.conditionalFormattings = [];
                    }
                    get name() {
                        return this._name;
                    }
                    set name(e) {
                        if (void 0 === e && (e = "sheet" + this.id), this._name !== e) {
                            if ("string" != typeof e) throw new Error("The name has to be a string.");
                            if ("" === e) throw new Error("The name can't be empty.");
                            if ("History" === e) throw new Error('The name "History" is protected. Please use a different name.');
                            if (/[*?:/\\[\]]/.test(e)) throw new Error(`Worksheet name ${e} cannot include any of the following characters: * ? : \\ / [ ]`);
                            if (/(^')|('$)/.test(e)) throw new Error("The first or last character of worksheet name cannot be a single quotation mark: " + e);
                            if (e && e.length > 31 && (console.warn(`Worksheet name ${e} exceeds 31 chars. This will be truncated`), e = e.substring(0, 31)), this._workbook._worksheets.find((t)=>t && t.name.toLowerCase() === e.toLowerCase())) throw new Error("Worksheet name already exists: " + e);
                            this._name = e;
                        }
                    }
                    get workbook() {
                        return this._workbook;
                    }
                    destroy() {
                        this._workbook.removeWorksheetEx(this);
                    }
                    get dimensions() {
                        const e = new s;
                        return this._rows.forEach((t)=>{
                            if (t) {
                                const r = t.dimensions;
                                r && e.expand(t.number, r.min, t.number, r.max);
                            }
                        }), e;
                    }
                    get columns() {
                        return this._columns;
                    }
                    set columns(e) {
                        this._headerRowCount = e.reduce((e, t)=>{
                            const r = (t.header ? 1 : t.headers && t.headers.length) || 0;
                            return Math.max(e, r);
                        }, 0);
                        let t = 1;
                        const r = this._columns = [];
                        e.forEach((e)=>{
                            const n = new a(this, t++, !1);
                            r.push(n), n.defn = e;
                        });
                    }
                    getColumnKey(e) {
                        return this._keys[e];
                    }
                    setColumnKey(e, t) {
                        this._keys[e] = t;
                    }
                    deleteColumnKey(e) {
                        delete this._keys[e];
                    }
                    eachColumnKey(e) {
                        n.each(this._keys, e);
                    }
                    getColumn(e) {
                        if ("string" == typeof e) {
                            const t = this._keys[e];
                            if (t) return t;
                            e = i.l2n(e);
                        }
                        if (this._columns || (this._columns = []), e > this._columns.length) {
                            let t = this._columns.length + 1;
                            for(; t <= e;)this._columns.push(new a(this, t++));
                        }
                        return this._columns[e - 1];
                    }
                    spliceColumns(e, t) {
                        const r = this._rows.length;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        if (i.length > 0) for(let n = 0; n < r; n++){
                            const r = [
                                e,
                                t
                            ];
                            i.forEach((e)=>{
                                r.push(e[n] || null);
                            });
                            const s = this.getRow(n + 1);
                            s.splice.apply(s, r);
                        }
                        else this._rows.forEach((r)=>{
                            r && r.splice(e, t);
                        });
                        const o = i.length - t, a = e + t, l = this._columns.length;
                        if (o < 0) for(let t = e + i.length; t <= l; t++)this.getColumn(t).defn = this.getColumn(t - o).defn;
                        else if (o > 0) for(let e = l; e >= a; e--)this.getColumn(e + o).defn = this.getColumn(e).defn;
                        for(let t = e; t < e + i.length; t++)this.getColumn(t).defn = null;
                        this.workbook.definedNames.spliceColumns(this.name, e, t, i.length);
                    }
                    get lastColumn() {
                        return this.getColumn(this.columnCount);
                    }
                    get columnCount() {
                        let e = 0;
                        return this.eachRow((t)=>{
                            e = Math.max(e, t.cellCount);
                        }), e;
                    }
                    get actualColumnCount() {
                        const e = [];
                        let t = 0;
                        return this.eachRow((r)=>{
                            r.eachCell((r)=>{
                                let { col: n } = r;
                                e[n] || (e[n] = !0, t++);
                            });
                        }), t;
                    }
                    _commitRow() {}
                    get _lastRowNumber() {
                        const e = this._rows;
                        let t = e.length;
                        for(; t > 0 && void 0 === e[t - 1];)t--;
                        return t;
                    }
                    get _nextRow() {
                        return this._lastRowNumber + 1;
                    }
                    get lastRow() {
                        if (this._rows.length) return this._rows[this._rows.length - 1];
                    }
                    findRow(e) {
                        return this._rows[e - 1];
                    }
                    findRows(e, t) {
                        return this._rows.slice(e - 1, e - 1 + t);
                    }
                    get rowCount() {
                        return this._lastRowNumber;
                    }
                    get actualRowCount() {
                        let e = 0;
                        return this.eachRow(()=>{
                            e++;
                        }), e;
                    }
                    getRow(e) {
                        let t = this._rows[e - 1];
                        return t || (t = this._rows[e - 1] = new o(this, e)), t;
                    }
                    getRows(e, t) {
                        if (t < 1) return;
                        const r = [];
                        for(let n = e; n < e + t; n++)r.push(this.getRow(n));
                        return r;
                    }
                    addRow(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = this._nextRow, n = this.getRow(r);
                        return n.values = e, this._setStyleOption(r, "i" === t[0] ? t : "n"), n;
                    }
                    addRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = [];
                        return e.forEach((e)=>{
                            r.push(this.addRow(e, t));
                        }), r;
                    }
                    insertRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        return this.spliceRows(e, 0, t), this._setStyleOption(e, r), this.getRow(e);
                    }
                    insertRows(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        if (this.spliceRows(e, 0, ...t), "n" !== r) for(let n = 0; n < t.length; n++)"o" === r[0] && void 0 !== this.findRow(t.length + e + n) ? this._copyStyle(t.length + e + n, e + n, "+" === r[1]) : "i" === r[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e + n, "+" === r[1]);
                        return this.getRows(e, t.length);
                    }
                    _setStyleOption(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        "o" === t[0] && void 0 !== this.findRow(e + 1) ? this._copyStyle(e + 1, e, "+" === t[1]) : "i" === t[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e, "+" === t[1]);
                    }
                    _copyStyle(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this.getRow(e), i = this.getRow(t);
                        i.style = d(n.style), n.eachCell({
                            includeEmpty: r
                        }, (e, t)=>{
                            i.getCell(t).style = d(e.style);
                        }), i.height = n.height;
                    }
                    duplicateRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this._rows[e - 1], i = new Array(t).fill(n.values);
                        this.spliceRows(e + 1, r ? 0 : t, ...i);
                        for(let r = 0; r < t; r++){
                            const t = this._rows[e + r];
                            t.style = n.style, t.height = n.height, n.eachCell({
                                includeEmpty: !0
                            }, (e, r)=>{
                                t.getCell(r).style = e.style;
                            });
                        }
                    }
                    spliceRows(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length, a = o - t, l = this._rows.length;
                        let c, u;
                        if (a < 0) for(e === l && (this._rows[l - 1] = void 0), c = r; c <= l; c++)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                e.getCell(r).style = t.style;
                            }), this._rows[c - 1] = void 0;
                        } else this._rows[c + a - 1] = void 0;
                        else if (a > 0) for(c = l; c >= r; c--)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                if (e.getCell(r).style = t.style, "MergeValue" === t._value.constructor.name) {
                                    const e = this.getRow(t._row._number + o).getCell(r), n = t._value._master, i = this.getRow(n._row._number + o).getCell(n._column._number);
                                    e.merge(i);
                                }
                            });
                        } else this._rows[c + a - 1] = void 0;
                        for(c = 0; c < o; c++){
                            const t = this.getRow(e + c);
                            t.style = {}, t.values = i[c];
                        }
                        this.workbook.definedNames.spliceRows(this.name, e, t, o);
                    }
                    eachRow(e, t) {
                        if (t || (t = e, e = void 0), e && e.includeEmpty) {
                            const e = this._rows.length;
                            for(let r = 1; r <= e; r++)t(this.getRow(r), r);
                        } else this._rows.forEach((e)=>{
                            e && e.hasValues && t(e, e.number);
                        });
                    }
                    getSheetValues() {
                        const e = [];
                        return this._rows.forEach((t)=>{
                            t && (e[t.number] = t.values);
                        }), e;
                    }
                    findCell(e, t) {
                        const r = i.getAddress(e, t), n = this._rows[r.row - 1];
                        return n ? n.findCell(r.col) : void 0;
                    }
                    getCell(e, t) {
                        const r = i.getAddress(e, t);
                        return this.getRow(r.row).getCellEx(r);
                    }
                    mergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n);
                    }
                    mergeCellsWithoutStyle() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n, !0);
                    }
                    _mergeCellsInternal(e, t) {
                        n.each(this._merges, (t)=>{
                            if (t.intersects(e)) throw new Error("Cannot merge already merged cells");
                        });
                        const r = this.getCell(e.top, e.left);
                        for(let n = e.top; n <= e.bottom; n++)for(let i = e.left; i <= e.right; i++)(n > e.top || i > e.left) && this.getCell(n, i).merge(r, t);
                        this._merges[r.address] = e;
                    }
                    _unMergeMaster(e) {
                        const t = this._merges[e.address];
                        if (t) {
                            for(let e = t.top; e <= t.bottom; e++)for(let r = t.left; r <= t.right; r++)this.getCell(e, r).unmerge();
                            delete this._merges[e.address];
                        }
                    }
                    get hasMerges() {
                        return n.some(this._merges, Boolean);
                    }
                    unMergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        for(let e = n.top; e <= n.bottom; e++)for(let t = n.left; t <= n.right; t++){
                            const r = this.findCell(e, t);
                            r && (r.type === l.ValueType.Merge ? this._unMergeMaster(r.master) : this._merges[r.address] && this._unMergeMaster(r));
                        }
                    }
                    fillFormula(e, t, r) {
                        let n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "shared";
                        const s = i.decode(e), { top: o, left: a, bottom: l, right: c } = s, u = c - a + 1, h = i.encodeAddress(o, a), f = "shared" === n;
                        let d;
                        d = "function" == typeof r ? r : Array.isArray(r) ? Array.isArray(r[0]) ? (e, t)=>r[e - o][t - a] : (e, t)=>r[(e - o) * u + (t - a)] : ()=>{};
                        let p = !0;
                        for(let r = o; r <= l; r++)for(let i = a; i <= c; i++)p ? (this.getCell(r, i).value = {
                            shareType: n,
                            formula: t,
                            ref: e,
                            result: d(r, i)
                        }, p = !1) : this.getCell(r, i).value = f ? {
                            sharedFormula: h,
                            result: d(r, i)
                        } : d(r, i);
                    }
                    addImage(e, t) {
                        const r = {
                            type: "image",
                            imageId: e,
                            range: t
                        };
                        this._media.push(new c(this, r));
                    }
                    getImages() {
                        return this._media.filter((e)=>"image" === e.type);
                    }
                    addBackgroundImage(e) {
                        const t = {
                            type: "background",
                            imageId: e
                        };
                        this._media.push(new c(this, t));
                    }
                    getBackgroundImageId() {
                        const e = this._media.find((e)=>"background" === e.type);
                        return e && e.imageId;
                    }
                    protect(e, t) {
                        return new Promise((r)=>{
                            this.sheetProtection = {
                                sheet: !0
                            }, t && "spinCount" in t && (t.spinCount = Number.isFinite(t.spinCount) ? Math.round(Math.max(0, t.spinCount)) : 1e5), e && (this.sheetProtection.algorithmName = "SHA-512", this.sheetProtection.saltValue = f.randomBytes(16).toString("base64"), this.sheetProtection.spinCount = t && "spinCount" in t ? t.spinCount : 1e5, this.sheetProtection.hashValue = f.convertPasswordToHash(e, "SHA512", this.sheetProtection.saltValue, this.sheetProtection.spinCount)), t && (this.sheetProtection = Object.assign(this.sheetProtection, t), !e && "spinCount" in t && delete this.sheetProtection.spinCount), r();
                        });
                    }
                    unprotect() {
                        this.sheetProtection = null;
                    }
                    addTable(e) {
                        const t = new u(this, e);
                        return this.tables[e.name] = t, t;
                    }
                    getTable(e) {
                        return this.tables[e];
                    }
                    removeTable(e) {
                        delete this.tables[e];
                    }
                    getTables() {
                        return Object.values(this.tables);
                    }
                    addConditionalFormatting(e) {
                        this.conditionalFormattings.push(e);
                    }
                    removeConditionalFormatting(e) {
                        "number" == typeof e ? this.conditionalFormattings.splice(e, 1) : this.conditionalFormattings = e instanceof Function ? this.conditionalFormattings.filter(e) : [];
                    }
                    get tabColor() {
                        return console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor;
                    }
                    set tabColor(e) {
                        console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor = e;
                    }
                    get model() {
                        const e = {
                            id: this.id,
                            name: this.name,
                            dataValidations: this.dataValidations.model,
                            properties: this.properties,
                            state: this.state,
                            pageSetup: this.pageSetup,
                            headerFooter: this.headerFooter,
                            rowBreaks: this.rowBreaks,
                            views: this.views,
                            autoFilter: this.autoFilter,
                            media: this._media.map((e)=>e.model),
                            sheetProtection: this.sheetProtection,
                            tables: Object.values(this.tables).map((e)=>e.model),
                            conditionalFormattings: this.conditionalFormattings
                        };
                        e.cols = a.toModel(this.columns);
                        const t = e.rows = [], r = e.dimensions = new s;
                        return this._rows.forEach((e)=>{
                            const n = e && e.model;
                            n && (r.expand(n.number, n.min, n.number, n.max), t.push(n));
                        }), e.merges = [], n.each(this._merges, (t)=>{
                            e.merges.push(t.range);
                        }), e;
                    }
                    _parseRows(e) {
                        this._rows = [], e.rows.forEach((e)=>{
                            const t = new o(this, e.number);
                            this._rows[t.number - 1] = t, t.model = e;
                        });
                    }
                    _parseMergeCells(e) {
                        n.each(e.mergeCells, (e)=>{
                            this.mergeCellsWithoutStyle(e);
                        });
                    }
                    set model(e) {
                        this.name = e.name, this._columns = a.fromModel(this, e.cols), this._parseRows(e), this._parseMergeCells(e), this.dataValidations = new h(e.dataValidations), this.properties = e.properties, this.pageSetup = e.pageSetup, this.headerFooter = e.headerFooter, this.views = e.views, this.autoFilter = e.autoFilter, this._media = e.media.map((e)=>new c(this, e)), this.sheetProtection = e.sheetProtection, this.tables = e.tables.reduce((e, t)=>{
                            const r = new u;
                            return r.model = t, e[t.name] = r, e;
                        }, {}), this.conditionalFormattings = e.conditionalFormattings;
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/copy-style": 20,
                "../utils/encryptor": 21,
                "../utils/under-dash": 26,
                "./column": 4,
                "./data-validations": 5,
                "./enums": 7,
                "./image": 8,
                "./range": 10,
                "./row": 11,
                "./table": 12
            }
        ],
        15: [
            function(e, t, r) {
                "use strict";
                e("core-js/modules/es.promise"), e("core-js/modules/es.promise.finally"), e("core-js/modules/es.object.assign"), e("core-js/modules/es.object.keys"), e("core-js/modules/es.object.values"), e("core-js/modules/es.symbol"), e("core-js/modules/es.symbol.async-iterator"), e("core-js/modules/es.array.iterator"), e("core-js/modules/es.array.includes"), e("core-js/modules/es.array.find-index"), e("core-js/modules/es.array.find"), e("core-js/modules/es.string.from-code-point"), e("core-js/modules/es.string.includes"), e("core-js/modules/es.number.is-nan"), e("regenerator-runtime/runtime");
                const n = {
                    Workbook: e("./doc/workbook")
                }, i = e("./doc/enums");
                Object.keys(i).forEach((e)=>{
                    n[e] = i[e];
                }), t.exports = n;
            },
            {
                "./doc/enums": 7,
                "./doc/workbook": 13,
                "core-js/modules/es.array.find": 359,
                "core-js/modules/es.array.find-index": 358,
                "core-js/modules/es.array.includes": 360,
                "core-js/modules/es.array.iterator": 361,
                "core-js/modules/es.number.is-nan": 363,
                "core-js/modules/es.object.assign": 364,
                "core-js/modules/es.object.keys": 366,
                "core-js/modules/es.object.values": 367,
                "core-js/modules/es.promise": 372,
                "core-js/modules/es.promise.finally": 371,
                "core-js/modules/es.string.from-code-point": 376,
                "core-js/modules/es.string.includes": 377,
                "core-js/modules/es.symbol": 381,
                "core-js/modules/es.symbol.async-iterator": 378,
                "regenerator-runtime/runtime": 492
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                r.bufferToString = function(e) {
                    return "string" == typeof e ? e : n ? n.decode(e) : e.toString();
                };
            },
            {}
        ],
        17: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextEncoder ? null : new TextEncoder("utf-8"), { Buffer: i } = e("buffer");
                r.stringToBuffer = function(e) {
                    return "string" != typeof e ? e : n ? i.from(n.encode(e).buffer) : i.from(e);
                };
            },
            {
                buffer: 220
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./col-cache");
                t.exports = class {
                    constructor(e){
                        this.template = e, this.sheets = {};
                    }
                    addCell(e) {
                        this.addCellEx(i.decodeEx(e));
                    }
                    getCell(e) {
                        return this.findCellEx(i.decodeEx(e), !0);
                    }
                    findCell(e) {
                        return this.findCellEx(i.decodeEx(e), !1);
                    }
                    findCellAt(e, t, r) {
                        const n = this.sheets[e], i = n && n[t];
                        return i && i[r];
                    }
                    addCellEx(e) {
                        if (e.top) for(let t = e.top; t <= e.bottom; t++)for(let r = e.left; r <= e.right; r++)this.getCellAt(e.sheetName, t, r);
                        else this.findCellEx(e, !0);
                    }
                    getCellEx(e) {
                        return this.findCellEx(e, !0);
                    }
                    findCellEx(e, t) {
                        const r = this.findSheet(e, t), n = this.findSheetRow(r, e, t);
                        return this.findRowCell(n, e, t);
                    }
                    getCellAt(e, t, r) {
                        const n = this.sheets[e] || (this.sheets[e] = []), s = n[t] || (n[t] = []);
                        return s[r] || (s[r] = {
                            sheetName: e,
                            address: i.n2l(r) + t,
                            row: t,
                            col: r
                        });
                    }
                    removeCellEx(e) {
                        const t = this.findSheet(e);
                        if (!t) return;
                        const r = this.findSheetRow(t, e);
                        r && delete r[e.col];
                    }
                    forEachInSheet(e, t) {
                        const r = this.sheets[e];
                        r && r.forEach((e, r)=>{
                            e && e.forEach((e, n)=>{
                                e && t(e, r, n);
                            });
                        });
                    }
                    forEach(e) {
                        n.each(this.sheets, (t, r)=>{
                            this.forEachInSheet(r, e);
                        });
                    }
                    map(e) {
                        const t = [];
                        return this.forEach((r)=>{
                            t.push(e(r));
                        }), t;
                    }
                    findSheet(e, t) {
                        const r = e.sheetName;
                        return this.sheets[r] ? this.sheets[r] : t ? this.sheets[r] = [] : void 0;
                    }
                    findSheetRow(e, t, r) {
                        const { row: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = [] : void 0;
                    }
                    findRowCell(e, t, r) {
                        const { col: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = this.template ? Object.assign(t, JSON.parse(JSON.stringify(this.template))) : t : void 0;
                    }
                    spliceRows(e, t, r, n) {
                        const i = this.sheets[e];
                        if (i) {
                            const e = [];
                            for(let t = 0; t < n; t++)e.push([]);
                            i.splice(t, r, ...e);
                        }
                    }
                    spliceColumns(e, t, r, i) {
                        const s = this.sheets[e];
                        if (s) {
                            const e = [];
                            for(let t = 0; t < i; t++)e.push(null);
                            n.each(s, (n)=>{
                                n.splice(t, r, ...e);
                            });
                        }
                    }
                };
            },
            {
                "./col-cache": 19,
                "./under-dash": 26
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                const n = /^[A-Z]+\d+$/, i = {
                    _dictionary: [
                        "A",
                        "B",
                        "C",
                        "D",
                        "E",
                        "F",
                        "G",
                        "H",
                        "I",
                        "J",
                        "K",
                        "L",
                        "M",
                        "N",
                        "O",
                        "P",
                        "Q",
                        "R",
                        "S",
                        "T",
                        "U",
                        "V",
                        "W",
                        "X",
                        "Y",
                        "Z"
                    ],
                    _l2nFill: 0,
                    _l2n: {},
                    _n2l: [],
                    _level: (e)=>e <= 26 ? 1 : e <= 676 ? 2 : 3,
                    _fill (e) {
                        let t, r, n, i, s, o = 1;
                        if (e >= 4) throw new Error("Out of bounds. Excel supports columns from 1 to 16384");
                        if (this._l2nFill < 1 && e >= 1) {
                            for(; o <= 26;)t = this._dictionary[o - 1], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 1;
                        }
                        if (this._l2nFill < 2 && e >= 2) {
                            for(o = 27; o <= 702;)r = o - 27, n = r % 26, i = Math.floor(r / 26), t = this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 2;
                        }
                        if (this._l2nFill < 3 && e >= 3) {
                            for(o = 703; o <= 16384;)r = o - 703, n = r % 26, i = Math.floor(r / 26) % 26, s = Math.floor(r / 676), t = this._dictionary[s] + this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 3;
                        }
                    },
                    l2n (e) {
                        if (this._l2n[e] || this._fill(e.length), !this._l2n[e]) throw new Error("Out of bounds. Invalid column letter: " + e);
                        return this._l2n[e];
                    },
                    n2l (e) {
                        if (e < 1 || e > 16384) throw new Error(e + " is out of bounds. Excel supports columns from 1 to 16384");
                        return this._n2l[e] || this._fill(this._level(e)), this._n2l[e];
                    },
                    _hash: {},
                    validateAddress (e) {
                        if (!n.test(e)) throw new Error("Invalid Address: " + e);
                        return !0;
                    },
                    decodeAddress (e) {
                        const t = e.length < 5 && this._hash[e];
                        if (t) return t;
                        let r = !1, n = "", i = 0, s = !1, o = "", a = 0;
                        for(let t, l = 0; l < e.length; l++)if (t = e.charCodeAt(l), !s && t >= 65 && t <= 90) r = !0, n += e[l], i = 26 * i + t - 64;
                        else if (t >= 48 && t <= 57) s = !0, o += e[l], a = 10 * a + t - 48;
                        else if (s && r && 36 !== t) break;
                        if (r) {
                            if (i > 16384) throw new Error("Out of bounds. Invalid column letter: " + n);
                        } else i = void 0;
                        s || (a = void 0);
                        const l = {
                            address: e = n + o,
                            col: i,
                            row: a,
                            $col$row: `$${n}$${o}`
                        };
                        return i <= 100 && a <= 100 && (this._hash[e] = l, this._hash[l.$col$row] = l), l;
                    },
                    getAddress (e, t) {
                        if (t) {
                            const r = this.n2l(t) + e;
                            return this.decodeAddress(r);
                        }
                        return this.decodeAddress(e);
                    },
                    decode (e) {
                        const t = e.split(":");
                        if (2 === t.length) {
                            const e = this.decodeAddress(t[0]), r = this.decodeAddress(t[1]), n = {
                                top: Math.min(e.row, r.row),
                                left: Math.min(e.col, r.col),
                                bottom: Math.max(e.row, r.row),
                                right: Math.max(e.col, r.col)
                            };
                            return n.tl = this.n2l(n.left) + n.top, n.br = this.n2l(n.right) + n.bottom, n.dimensions = `${n.tl}:${n.br}`, n;
                        }
                        return this.decodeAddress(e);
                    },
                    decodeEx (e) {
                        const t = e.match(/(?:(?:(?:'((?:[^']|'')*)')|([^'^ !]*))!)?(.*)/), r = t[1] || t[2], n = t[3], i = n.split(":");
                        if (i.length > 1) {
                            let e = this.decodeAddress(i[0]), t = this.decodeAddress(i[1]);
                            const n = Math.min(e.row, t.row), s = Math.min(e.col, t.col), o = Math.max(e.row, t.row), a = Math.max(e.col, t.col);
                            return e = this.n2l(s) + n, t = this.n2l(a) + o, {
                                top: n,
                                left: s,
                                bottom: o,
                                right: a,
                                sheetName: r,
                                tl: {
                                    address: e,
                                    col: s,
                                    row: n,
                                    $col$row: `$${this.n2l(s)}$${n}`,
                                    sheetName: r
                                },
                                br: {
                                    address: t,
                                    col: a,
                                    row: o,
                                    $col$row: `$${this.n2l(a)}$${o}`,
                                    sheetName: r
                                },
                                dimensions: `${e}:${t}`
                            };
                        }
                        if (n.startsWith("#")) return r ? {
                            sheetName: r,
                            error: n
                        } : {
                            error: n
                        };
                        const s = this.decodeAddress(n);
                        return r ? {
                            sheetName: r,
                            ...s
                        } : s;
                    },
                    encodeAddress: (e, t)=>i.n2l(t) + e,
                    encode () {
                        switch(arguments.length){
                            case 2:
                                return i.encodeAddress(arguments[0], arguments[1]);
                            case 4:
                                return `${i.encodeAddress(arguments[0], arguments[1])}:${i.encodeAddress(arguments[2], arguments[3])}`;
                            default:
                                throw new Error("Can only encode with 2 or 4 arguments");
                        }
                    },
                    inRange (e, t) {
                        const [r, n, , i, s] = e, [o, a] = t;
                        return o >= r && o <= i && a >= n && a <= s;
                    }
                };
                t.exports = i;
            },
            {}
        ],
        20: [
            function(e, t, r) {
                "use strict";
                const n = (e, t)=>({
                        ...e,
                        ...t.reduce((t, r)=>(e[r] && (t[r] = {
                                ...e[r]
                            }), t), {})
                    }), i = function(e, t, r) {
                    let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
                    e[r] && (t[r] = n(e[r], i));
                };
                r.copyStyle = (e)=>{
                    if (!e) return e;
                    if (t = e, 0 === Object.keys(t).length) return {};
                    var t;
                    const r = {
                        ...e
                    };
                    return i(e, r, "font", [
                        "color"
                    ]), i(e, r, "alignment"), i(e, r, "protection"), e.border && (i(e, r, "border"), i(e.border, r.border, "top", [
                        "color"
                    ]), i(e.border, r.border, "left", [
                        "color"
                    ]), i(e.border, r.border, "bottom", [
                        "color"
                    ]), i(e.border, r.border, "right", [
                        "color"
                    ]), i(e.border, r.border, "diagonal", [
                        "color"
                    ])), e.fill && (i(e, r, "fill", [
                        "fgColor",
                        "bgColor",
                        "center"
                    ]), e.fill.stops && (r.fill.stops = e.fill.stops.map((e)=>n(e, [
                            "color"
                        ])))), r;
                };
            },
            {}
        ],
        21: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("crypto"), i = {
                            hash (e) {
                                const t = n.createHash(e);
                                for(var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)s[o - 1] = arguments[o];
                                return t.update(r.concat(s)), t.digest();
                            },
                            convertPasswordToHash (e, t, i, s) {
                                t = t.toLowerCase();
                                if (n.getHashes().indexOf(t) < 0) throw new Error(`Hash algorithm '${t}' not supported!`);
                                const o = r.from(e, "utf16le");
                                let a = this.hash(t, r.from(i, "base64"), o);
                                for(let e = 0; e < s; e++){
                                    const n = r.alloc(4);
                                    n.writeUInt32LE(e, 0), a = this.hash(t, a, n);
                                }
                                return a.toString("base64");
                            },
                            randomBytes: (e)=>n.randomBytes(e)
                        };
                        t.exports = i;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                crypto: 390
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                const { SaxesParser: n } = e("saxes"), { PassThrough: i } = e("readable-stream"), { bufferToString: s } = e("./browser-buffer-decode");
                t.exports = async function*(e) {
                    e.pipe && !e[Symbol.asyncIterator] && (e = e.pipe(new i));
                    const t = new n;
                    let r;
                    t.on("error", (e)=>{
                        r = e;
                    });
                    let o = [];
                    t.on("opentag", (e)=>o.push({
                            eventType: "opentag",
                            value: e
                        })), t.on("text", (e)=>o.push({
                            eventType: "text",
                            value: e
                        })), t.on("closetag", (e)=>o.push({
                            eventType: "closetag",
                            value: e
                        }));
                    for await (const n of e){
                        if (t.write(s(n)), r) throw r;
                        yield o, o = [];
                    }
                };
            },
            {
                "./browser-buffer-decode": 16,
                "readable-stream": 491,
                saxes: 496
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                const n = e("./col-cache"), i = /(([a-z_\-0-9]*)!)?([a-z0-9_$]{2,})([(])?/gi, s = /^([$])?([a-z]+)([$])?([1-9][0-9]*)$/i;
                t.exports = {
                    slideFormula: function(e, t, r) {
                        const o = n.decode(t), a = n.decode(r);
                        return e.replace(i, (e, t, r, i, l)=>{
                            if (l) return e;
                            const c = s.exec(i);
                            if (c) {
                                const r = c[1], i = c[2].toUpperCase(), s = c[3], l = c[4];
                                if (i.length > 3 || 3 === i.length && i > "XFD") return e;
                                let u = n.l2n(i), h = parseInt(l, 10);
                                r || (u += a.col - o.col), s || (h += a.row - o.row);
                                return (t || "") + (r || "") + n.n2l(u) + (s || "") + h;
                            }
                            return e;
                        });
                    }
                };
            },
            {
                "./col-cache": 19
            }
        ],
        24: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("readable-stream"), s = e("./utils"), o = e("./string-buf");
                        class a {
                            constructor(e, t){
                                this._data = e, this._encoding = t;
                            }
                            get length() {
                                return this.toBuffer().length;
                            }
                            copy(e, t, r, n) {
                                return this.toBuffer().copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = n.from(this._data, this._encoding)), this._buffer;
                            }
                        }
                        class l {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                return this._data._buf.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data.toBuffer();
                            }
                        }
                        class c {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                this._data.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data;
                            }
                        }
                        class u {
                            constructor(e){
                                this.size = e, this.buffer = n.alloc(e), this.iRead = 0, this.iWrite = 0;
                            }
                            toBuffer() {
                                if (0 === this.iRead && this.iWrite === this.size) return this.buffer;
                                const e = n.alloc(this.iWrite - this.iRead);
                                return this.buffer.copy(e, 0, this.iRead, this.iWrite), e;
                            }
                            get length() {
                                return this.iWrite - this.iRead;
                            }
                            get eod() {
                                return this.iRead === this.iWrite;
                            }
                            get full() {
                                return this.iWrite === this.size;
                            }
                            read(e) {
                                let t;
                                return 0 === e ? null : void 0 === e || e >= this.length ? (t = this.toBuffer(), this.iRead = this.iWrite, t) : (t = n.alloc(e), this.buffer.copy(t, 0, this.iRead, e), this.iRead += e, t);
                            }
                            write(e, t, r) {
                                const n = Math.min(r, this.size - this.iWrite);
                                return e.copy(this.buffer, this.iWrite, t, t + n), this.iWrite += n, n;
                            }
                        }
                        const h = function(e) {
                            e = e || {}, this.bufSize = e.bufSize || 1048576, this.buffers = [], this.batch = e.batch || !1, this.corked = !1, this.inPos = 0, this.outPos = 0, this.pipes = [], this.paused = !1, this.encoding = null;
                        };
                        s.inherits(h, i.Duplex, {
                            toBuffer () {
                                switch(this.buffers.length){
                                    case 0:
                                        return null;
                                    case 1:
                                        return this.buffers[0].toBuffer();
                                    default:
                                        return n.concat(this.buffers.map((e)=>e.toBuffer()));
                                }
                            },
                            _getWritableBuffer () {
                                if (this.buffers.length) {
                                    const e = this.buffers[this.buffers.length - 1];
                                    if (!e.full) return e;
                                }
                                const e = new u(this.bufSize);
                                return this.buffers.push(e), e;
                            },
                            async _pipe (e) {
                                await Promise.all(this.pipes.map(function(t) {
                                    return new Promise((r)=>{
                                        t.write(e.toBuffer(), ()=>{
                                            r();
                                        });
                                    });
                                }));
                            },
                            _writeToBuffers (e) {
                                let t = 0;
                                const r = e.length;
                                for(; t < r;)t += this._getWritableBuffer().write(e, t, r - t);
                            },
                            async write (e, t, i) {
                                let u;
                                if (t instanceof Function && (i = t, t = "utf8"), i = i || s.nop, e instanceof o) u = new l(e);
                                else if (e instanceof n) u = new c(e);
                                else {
                                    if (!("string" == typeof e || e instanceof String || e instanceof ArrayBuffer)) throw new Error("Chunk must be one of type String, Buffer or StringBuf.");
                                    u = new a(e, t);
                                }
                                if (this.pipes.length) {
                                    if (this.batch) for(this._writeToBuffers(u); !this.corked && this.buffers.length > 1;)this._pipe(this.buffers.shift());
                                    else this.corked ? (this._writeToBuffers(u), r.nextTick(i)) : (await this._pipe(u), i());
                                } else this.paused || this.emit("data", u.toBuffer()), this._writeToBuffers(u), this.emit("readable");
                                return !0;
                            },
                            cork () {
                                this.corked = !0;
                            },
                            _flush () {
                                if (this.pipes.length) for(; this.buffers.length;)this._pipe(this.buffers.shift());
                            },
                            uncork () {
                                this.corked = !1, this._flush();
                            },
                            end (e, t, r) {
                                const n = (e)=>{
                                    e ? r(e) : (this._flush(), this.pipes.forEach((e)=>{
                                        e.end();
                                    }), this.emit("finish"));
                                };
                                e ? this.write(e, t, n) : n();
                            },
                            read (e) {
                                let t;
                                if (e) {
                                    for(t = []; e && this.buffers.length && !this.buffers[0].eod;){
                                        const r = this.buffers[0], n = r.read(e);
                                        e -= n.length, t.push(n), r.eod && r.full && this.buffers.shift();
                                    }
                                    return n.concat(t);
                                }
                                return t = this.buffers.map((e)=>e.toBuffer()).filter(Boolean), this.buffers = [], n.concat(t);
                            },
                            setEncoding (e) {
                                this.encoding = e;
                            },
                            pause () {
                                this.paused = !0;
                            },
                            resume () {
                                this.paused = !1;
                            },
                            isPaused () {
                                return !!this.paused;
                            },
                            pipe (e) {
                                this.pipes.push(e), !this.paused && this.buffers.length && this.end();
                            },
                            unpipe (e) {
                                this.pipes = this.pipes.filter((t)=>t !== e);
                            },
                            unshift () {
                                throw new Error("Not Implemented");
                            },
                            wrap () {
                                throw new Error("Not Implemented");
                            }
                        }), t.exports = h;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "./string-buf": 25,
                "./utils": 27,
                _process: 467,
                buffer: 220,
                "readable-stream": 491
            }
        ],
        25: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = class {
                            constructor(t){
                                this._buf = e.alloc(t && t.size || 16384), this._encoding = t && t.encoding || "utf8", this._inPos = 0, this._buffer = void 0;
                            }
                            get length() {
                                return this._inPos;
                            }
                            get capacity() {
                                return this._buf.length;
                            }
                            get buffer() {
                                return this._buf;
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = e.alloc(this.length), this._buf.copy(this._buffer, 0, 0, this.length)), this._buffer;
                            }
                            reset(e) {
                                e = e || 0, this._buffer = void 0, this._inPos = e;
                            }
                            _grow(t) {
                                let r = 2 * this._buf.length;
                                for(; r < t;)r *= 2;
                                const n = e.alloc(r);
                                this._buf.copy(n, 0), this._buf = n;
                            }
                            addText(e) {
                                this._buffer = void 0;
                                let t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                for(; t >= this._buf.length - 4;)this._grow(this._inPos + e.length), t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                this._inPos = t;
                            }
                            addStringBuf(e) {
                                e.length && (this._buffer = void 0, this.length + e.length > this.capacity && this._grow(this.length + e.length), e._buf.copy(this._buf, this._inPos, 0, e.length), this._inPos += e.length);
                            }
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                const { toString: n } = Object.prototype, i = /["&<>]/, s = {
                    each: function(e, t) {
                        e && (Array.isArray(e) ? e.forEach(t) : Object.keys(e).forEach((r)=>{
                            t(e[r], r);
                        }));
                    },
                    some: function(e, t) {
                        return !!e && (Array.isArray(e) ? e.some(t) : Object.keys(e).some((r)=>t(e[r], r)));
                    },
                    every: function(e, t) {
                        return !e || (Array.isArray(e) ? e.every(t) : Object.keys(e).every((r)=>t(e[r], r)));
                    },
                    map: function(e, t) {
                        return e ? Array.isArray(e) ? e.map(t) : Object.keys(e).map((r)=>t(e[r], r)) : [];
                    },
                    keyBy: (e, t)=>e.reduce((e, r)=>(e[r[t]] = r, e), {}),
                    isEqual: function(e, t) {
                        const r = typeof e, n = typeof t, i = Array.isArray(e), o = Array.isArray(t);
                        let a;
                        if (r !== n) return !1;
                        switch(typeof e){
                            case "object":
                                if (i || o) return !(!i || !o) && e.length === t.length && e.every((e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                                if (null === e || null === t) return e === t;
                                if (a = Object.keys(e), Object.keys(t).length !== a.length) return !1;
                                for (const e of a)if (!t.hasOwnProperty(e)) return !1;
                                return s.every(e, (e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                            default:
                                return e === t;
                        }
                    },
                    escapeHtml (e) {
                        const t = i.exec(e);
                        if (!t) return e;
                        let r = "", n = "", s = 0, o = t.index;
                        for(; o < e.length; o++){
                            switch(e.charAt(o)){
                                case '"':
                                    n = "&quot;";
                                    break;
                                case "&":
                                    n = "&amp;";
                                    break;
                                case "'":
                                    n = "&apos;";
                                    break;
                                case "<":
                                    n = "&lt;";
                                    break;
                                case ">":
                                    n = "&gt;";
                                    break;
                                default:
                                    continue;
                            }
                            s !== o && (r += e.substring(s, o)), s = o + 1, r += n;
                        }
                        return s !== o ? r + e.substring(s, o) : r;
                    },
                    strcmp: (e, t)=>e < t ? -1 : e > t ? 1 : 0,
                    isUndefined: (e)=>"[object Undefined]" === n.call(e),
                    isObject: (e)=>"[object Object]" === n.call(e),
                    deepMerge () {
                        const e = arguments[0] || {}, { length: t } = arguments;
                        let r, n, i;
                        function o(t, o) {
                            r = e[o], i = Array.isArray(t), s.isObject(t) || i ? (i ? (i = !1, n = r && Array.isArray(r) ? r : []) : n = r && s.isObject(r) ? r : {}, e[o] = s.deepMerge(n, t)) : s.isUndefined(t) || (e[o] = t);
                        }
                        for(let e = 0; e < t; e++)s.each(arguments[e], o);
                        return e;
                    }
                };
                t.exports = s;
            },
            {}
        ],
        27: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = /[<>&'"\x7F\x00-\x08\x0B-\x0C\x0E-\x1F]/, o = {
                            nop () {},
                            promiseImmediate: (e)=>new Promise((t)=>{
                                    r.setImmediate ? n(()=>{
                                        t(e);
                                    }) : setTimeout(()=>{
                                        t(e);
                                    }, 1);
                                }),
                            inherits: function(e, t, r, n) {
                                e.super_ = t, n || (n = r, r = null), r && Object.keys(r).forEach((t)=>{
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                                const i = {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !1,
                                        configurable: !0
                                    }
                                };
                                n && Object.keys(n).forEach((e)=>{
                                    i[e] = Object.getOwnPropertyDescriptor(n, e);
                                }), e.prototype = Object.create(t.prototype, i);
                            },
                            dateToExcel: (e, t)=>25569 + e.getTime() / 864e5 - (t ? 1462 : 0),
                            excelToDate (e, t) {
                                const r = Math.round(24 * (e - 25569 + (t ? 1462 : 0)) * 3600000);
                                return new Date(r);
                            },
                            parsePath (e) {
                                const t = e.lastIndexOf("/");
                                return {
                                    path: e.substring(0, t),
                                    name: e.substring(t + 1)
                                };
                            },
                            getRelsPath (e) {
                                const t = o.parsePath(e);
                                return `${t.path}/_rels/${t.name}.rels`;
                            },
                            xmlEncode (e) {
                                const t = s.exec(e);
                                if (!t) return e;
                                let r = "", n = "", i = 0, o = t.index;
                                for(; o < e.length; o++){
                                    const t = e.charCodeAt(o);
                                    switch(t){
                                        case 34:
                                            n = "&quot;";
                                            break;
                                        case 38:
                                            n = "&amp;";
                                            break;
                                        case 39:
                                            n = "&apos;";
                                            break;
                                        case 60:
                                            n = "&lt;";
                                            break;
                                        case 62:
                                            n = "&gt;";
                                            break;
                                        case 127:
                                            n = "";
                                            break;
                                        default:
                                            if (t <= 31 && (t <= 8 || t >= 11 && 13 !== t)) {
                                                n = "";
                                                break;
                                            }
                                            continue;
                                    }
                                    i !== o && (r += e.substring(i, o)), i = o + 1, n && (r += n);
                                }
                                return i !== o ? r + e.substring(i, o) : r;
                            },
                            xmlDecode: (e)=>e.replace(/&([a-z]*);/g, (e)=>{
                                    switch(e){
                                        case "&lt;":
                                            return "<";
                                        case "&gt;":
                                            return ">";
                                        case "&amp;":
                                            return "&";
                                        case "&apos;":
                                            return "'";
                                        case "&quot;":
                                            return '"';
                                        default:
                                            return e;
                                    }
                                }),
                            validInt (e) {
                                const t = parseInt(e, 10);
                                return Number.isNaN(t) ? 0 : t;
                            },
                            isDateFmt (e) {
                                if (!e) return !1;
                                return null !== (e = (e = e.replace(/\[[^\]]*]/g, "")).replace(/"[^"]*"/g, "")).match(/[ymdhMsb]+/);
                            },
                            fs: {
                                exists: (e)=>new Promise((t)=>{
                                        i.access(e, i.constants.F_OK, (e)=>{
                                            t(!e);
                                        });
                                    })
                            },
                            toIsoDateString: (e)=>e.toIsoString().subsstr(0, 10),
                            parseBoolean: (e)=>!0 === e || "true" === e || 1 === e || "1" === e
                        };
                        t.exports = o;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                fs: 216,
                timers: 523
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./utils");
                function s(e, t, r) {
                    e.push(` ${t}="${i.xmlEncode(r.toString())}"`);
                }
                function o(e, t) {
                    if (t) {
                        const r = [];
                        n.each(t, (e, t)=>{
                            void 0 !== e && s(r, t, e);
                        }), e.push(r.join(""));
                    }
                }
                class a {
                    constructor(){
                        this._xml = [], this._stack = [], this._rollbacks = [];
                    }
                    get tos() {
                        return this._stack.length ? this._stack[this._stack.length - 1] : void 0;
                    }
                    get cursor() {
                        return this._xml.length;
                    }
                    openXml(e) {
                        const t = this._xml;
                        t.push("<?xml"), o(t, e), t.push("?>\n");
                    }
                    openNode(e, t) {
                        const r = this.tos, n = this._xml;
                        r && this.open && n.push(">"), this._stack.push(e), n.push("<"), n.push(e), o(n, t), this.leaf = !0, this.open = !0;
                    }
                    addAttribute(e, t) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        void 0 !== t && s(this._xml, e, t);
                    }
                    addAttributes(e) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        o(this._xml, e);
                    }
                    writeText(e) {
                        const t = this._xml;
                        this.open && (t.push(">"), this.open = !1), this.leaf = !1, t.push(i.xmlEncode(e.toString()));
                    }
                    writeXml(e) {
                        this.open && (this._xml.push(">"), this.open = !1), this.leaf = !1, this._xml.push(e);
                    }
                    closeNode() {
                        const e = this._stack.pop(), t = this._xml;
                        this.leaf ? t.push("/>") : (t.push("</"), t.push(e), t.push(">")), this.open = !1, this.leaf = !1;
                    }
                    leafNode(e, t, r) {
                        this.openNode(e, t), void 0 !== r && this.writeText(r), this.closeNode();
                    }
                    closeAll() {
                        for(; this._stack.length;)this.closeNode();
                    }
                    addRollback() {
                        return this._rollbacks.push({
                            xml: this._xml.length,
                            stack: this._stack.length,
                            leaf: this.leaf,
                            open: this.open
                        }), this.cursor;
                    }
                    commit() {
                        this._rollbacks.pop();
                    }
                    rollback() {
                        const e = this._rollbacks.pop();
                        this._xml.length > e.xml && this._xml.splice(e.xml, this._xml.length - e.xml), this._stack.length > e.stack && this._stack.splice(e.stack, this._stack.length - e.stack), this.leaf = e.leaf, this.open = e.open;
                    }
                    get xml() {
                        return this.closeAll(), this._xml.join("");
                    }
                }
                a.StdDocAttributes = {
                    version: "1.0",
                    encoding: "UTF-8",
                    standalone: "yes"
                }, t.exports = a;
            },
            {
                "./under-dash": 26,
                "./utils": 27
            }
        ],
        29: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("events"), i = e("jszip"), s = e("./stream-buf"), { stringToBuffer: o } = e("./browser-buffer-encode");
                        class a extends n.EventEmitter {
                            constructor(e){
                                super(), this.options = Object.assign({
                                    type: "nodebuffer",
                                    compression: "DEFLATE"
                                }, e), this.zip = new i, this.stream = new s;
                            }
                            append(e, t) {
                                t.hasOwnProperty("base64") && t.base64 ? this.zip.file(t.name, e, {
                                    base64: !0
                                }) : (r.browser && "string" == typeof e && (e = o(e)), this.zip.file(t.name, e));
                            }
                            async finalize() {
                                const e = await this.zip.generateAsync(this.options);
                                this.stream.end(e), this.emit("finish");
                            }
                            read(e) {
                                return this.stream.read(e);
                            }
                            setEncoding(e) {
                                return this.stream.setEncoding(e);
                            }
                            pause() {
                                return this.stream.pause();
                            }
                            resume() {
                                return this.stream.resume();
                            }
                            isPaused() {
                                return this.stream.isPaused();
                            }
                            pipe(e, t) {
                                return this.stream.pipe(e, t);
                            }
                            unpipe(e) {
                                return this.stream.unpipe(e);
                            }
                            unshift(e) {
                                return this.stream.unshift(e);
                            }
                            wrap(e) {
                                return this.stream.wrap(e);
                            }
                        }
                        t.exports = {
                            ZipWriter: a
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./browser-buffer-encode": 17,
                "./stream-buf": 24,
                _process: 467,
                events: 422,
                jszip: 441
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    0: {
                        f: "General"
                    },
                    1: {
                        f: "0"
                    },
                    2: {
                        f: "0.00"
                    },
                    3: {
                        f: "#,##0"
                    },
                    4: {
                        f: "#,##0.00"
                    },
                    9: {
                        f: "0%"
                    },
                    10: {
                        f: "0.00%"
                    },
                    11: {
                        f: "0.00E+00"
                    },
                    12: {
                        f: "# ?/?"
                    },
                    13: {
                        f: "# ??/??"
                    },
                    14: {
                        f: "mm-dd-yy"
                    },
                    15: {
                        f: "d-mmm-yy"
                    },
                    16: {
                        f: "d-mmm"
                    },
                    17: {
                        f: "mmm-yy"
                    },
                    18: {
                        f: "h:mm AM/PM"
                    },
                    19: {
                        f: "h:mm:ss AM/PM"
                    },
                    20: {
                        f: "h:mm"
                    },
                    21: {
                        f: "h:mm:ss"
                    },
                    22: {
                        f: 'm/d/yy "h":mm'
                    },
                    27: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    28: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    29: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    30: {
                        "zh-tw": "m/d/yy ",
                        "zh-cn": "m-d-yy",
                        "ja-jp": "m/d/yy",
                        "ko-kr": "mm-dd-yy"
                    },
                    31: {
                        "zh-tw": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": 'yyyy"\ub144" mm"\uc6d4" dd"\uc77c"'
                    },
                    32: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"',
                        "ja-jp": 'h"\u6642"mm"\u5206"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84"'
                    },
                    33: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'h"\u6642"mm"\u5206"ss"\u79d2"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84" ss"\ucd08"'
                    },
                    34: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    35: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    36: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    37: {
                        f: "#,##0 ;(#,##0)"
                    },
                    38: {
                        f: "#,##0 ;[Red](#,##0)"
                    },
                    39: {
                        f: "#,##0.00 ;(#,##0.00)"
                    },
                    40: {
                        f: "#,##0.00 ;[Red](#,##0.00)"
                    },
                    45: {
                        f: "mm:ss"
                    },
                    46: {
                        f: "[h]:mm:ss"
                    },
                    47: {
                        f: "mmss.0"
                    },
                    48: {
                        f: "##0.0E+0"
                    },
                    49: {
                        f: "@"
                    },
                    50: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    51: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    52: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    53: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    54: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    55: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    56: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    57: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    58: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    59: {
                        "th-th": "t0"
                    },
                    60: {
                        "th-th": "t0.00"
                    },
                    61: {
                        "th-th": "t#,##0"
                    },
                    62: {
                        "th-th": "t#,##0.00"
                    },
                    67: {
                        "th-th": "t0%"
                    },
                    68: {
                        "th-th": "t0.00%"
                    },
                    69: {
                        "th-th": "t# ?/?"
                    },
                    70: {
                        "th-th": "t# ??/??"
                    },
                    81: {
                        "th-th": "d/m/bb"
                    }
                };
            },
            {}
        ],
        31: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    OfficeDocument: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
                    Worksheet: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
                    CalcChain: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/calcChain",
                    SharedStrings: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
                    Styles: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
                    Theme: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
                    Hyperlink: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
                    Image: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                    CoreProperties: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
                    ExtenderProperties: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
                    Comments: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
                    VmlDrawing: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
                    Table: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table"
                };
            },
            {}
        ],
        32: [
            function(e, t, r) {
                "use strict";
                const n = e("../../utils/parse-sax"), i = e("../../utils/xml-stream");
                class s {
                    prepare() {}
                    render() {}
                    parseOpen(e) {}
                    parseText(e) {}
                    parseClose(e) {}
                    reconcile(e, t) {}
                    reset() {
                        this.model = null, this.map && Object.values(this.map).forEach((e)=>{
                            e instanceof s ? e.reset() : e.xform && e.xform.reset();
                        });
                    }
                    mergeModel(e) {
                        this.model = Object.assign(this.model || {}, e);
                    }
                    async parse(e) {
                        for await (const t of e)for (const { eventType: e, value: r } of t)if ("opentag" === e) this.parseOpen(r);
                        else if ("text" === e) this.parseText(r);
                        else if ("closetag" === e && !this.parseClose(r.name)) return this.model;
                        return this.model;
                    }
                    async parseStream(e) {
                        return this.parse(n(e));
                    }
                    get xml() {
                        return this.toXml(this.model);
                    }
                    toXml(e) {
                        const t = new i;
                        return this.render(t, e), t.xml;
                    }
                    static toAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e.toString();
                    }
                    static toStringAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toStringValue(e, t) {
                        return void 0 === e ? t : e;
                    }
                    static toBoolAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e ? "1" : "0";
                    }
                    static toBoolValue(e, t) {
                        return void 0 === e ? t : "1" === e;
                    }
                    static toIntAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toIntValue(e, t) {
                        return void 0 === e ? t : parseInt(e, 10);
                    }
                    static toFloatAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toFloatValue(e, t) {
                        return void 0 === e ? t : parseFloat(e);
                    }
                }
                t.exports = s;
            },
            {
                "../../utils/parse-sax": 22,
                "../../utils/xml-stream": 28
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/col-cache");
                function s(e) {
                    try {
                        return i.decodeEx(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function o(e) {
                    const t = [];
                    let r = !1, n = "";
                    return e.split(",").forEach((e)=>{
                        if (!e) return;
                        const i = (e.match(/'/g) || []).length;
                        if (!i) return void (r ? n += e + "," : s(e) && t.push(e));
                        const o = i % 2 == 0;
                        !r && o && s(e) ? t.push(e) : r && !o ? (r = !1, s(n + e) && t.push(n + e), n = "") : (r = !0, n += e + ",");
                    }), t;
                }
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("definedName", {
                            name: t.name,
                            localSheetId: t.localSheetId
                        }), e.writeText(t.ranges.join(",")), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "definedName":
                                return this._parsedName = e.attributes.name, this._parsedLocalSheetId = e.attributes.localSheetId, this._parsedText = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._parsedText.push(e);
                    }
                    parseClose() {
                        return this.model = {
                            name: this._parsedName,
                            ranges: o(this._parsedText.join(""))
                        }, void 0 !== this._parsedLocalSheetId && (this.model.localSheetId = parseInt(this._parsedLocalSheetId, 10)), !1;
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    render(e, t) {
                        e.leafNode("sheet", {
                            sheetId: t.id,
                            name: t.name,
                            state: t.state,
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        return "sheet" === e.name && (this.model = {
                            name: n.xmlDecode(e.attributes.name),
                            id: parseInt(e.attributes.sheetId, 10),
                            state: e.attributes.state,
                            rId: e.attributes["r:id"]
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("calcPr", {
                            calcId: 171027,
                            fullCalcOnLoad: t.fullCalcOnLoad ? 1 : void 0
                        });
                    }
                    parseOpen(e) {
                        return "calcPr" === e.name && (this.model = {}, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        36: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("workbookPr", {
                            date1904: t.date1904 ? 1 : void 0,
                            defaultThemeVersion: 164011,
                            filterPrivacy: 1
                        });
                    }
                    parseOpen(e) {
                        return "workbookPr" === e.name && (this.model = {
                            date1904: "1" === e.attributes.date1904
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        37: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        const r = {
                            xWindow: t.x || 0,
                            yWindow: t.y || 0,
                            windowWidth: t.width || 12e3,
                            windowHeight: t.height || 24e3,
                            firstSheet: t.firstSheet,
                            activeTab: t.activeTab
                        };
                        t.visibility && "visible" !== t.visibility && (r.visibility = t.visibility), e.leafNode("workbookView", r);
                    }
                    parseOpen(e) {
                        if ("workbookView" === e.name) {
                            const t = this.model = {}, r = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = r : n;
                                void 0 !== i && (t[e] = i);
                            }, n = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = parseInt(r, 10) : n;
                                void 0 !== i && (t[e] = i);
                            };
                            return n("x", e.attributes.xWindow, 0), n("y", e.attributes.yWindow, 0), n("width", e.attributes.windowWidth, 25e3), n("height", e.attributes.windowHeight, 1e4), r("visibility", e.attributes.visibility, "visible"), n("activeTab", e.attributes.activeTab, void 0), n("firstSheet", e.attributes.firstSheet, void 0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../base-xform"), a = e("../static-xform"), l = e("../list-xform"), c = e("./defined-name-xform"), u = e("./sheet-xform"), h = e("./workbook-view-xform"), f = e("./workbook-properties-xform"), d = e("./workbook-calc-properties-xform");
                class p extends o {
                    constructor(){
                        super(), this.map = {
                            fileVersion: p.STATIC_XFORMS.fileVersion,
                            workbookPr: new f,
                            bookViews: new l({
                                tag: "bookViews",
                                count: !1,
                                childXform: new h
                            }),
                            sheets: new l({
                                tag: "sheets",
                                count: !1,
                                childXform: new u
                            }),
                            definedNames: new l({
                                tag: "definedNames",
                                count: !1,
                                childXform: new c
                            }),
                            calcPr: new d
                        };
                    }
                    prepare(e) {
                        e.sheets = e.worksheets;
                        const t = [];
                        let r = 0;
                        e.sheets.forEach((e)=>{
                            if (e.pageSetup && e.pageSetup.printArea && e.pageSetup.printArea.split("&&").forEach((n)=>{
                                const i = n.split(":"), s = {
                                    name: "_xlnm.Print_Area",
                                    ranges: [
                                        `'${e.name}'!$${i[0]}:$${i[1]}`
                                    ],
                                    localSheetId: r
                                };
                                t.push(s);
                            }), e.pageSetup && (e.pageSetup.printTitlesRow || e.pageSetup.printTitlesColumn)) {
                                const n = [];
                                if (e.pageSetup.printTitlesColumn) {
                                    const t = e.pageSetup.printTitlesColumn.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                if (e.pageSetup.printTitlesRow) {
                                    const t = e.pageSetup.printTitlesRow.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                const i = {
                                    name: "_xlnm.Print_Titles",
                                    ranges: n,
                                    localSheetId: r
                                };
                                t.push(i);
                            }
                            r++;
                        }), t.length && (e.definedNames = e.definedNames.concat(t)), (e.media || []).forEach((e, t)=>{
                            e.name = e.type + (t + 1);
                        });
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("workbook", p.WORKBOOK_ATTRIBUTES), this.map.fileVersion.render(e), this.map.workbookPr.render(e, t.properties), this.map.bookViews.render(e, t.views), this.map.sheets.render(e, t.sheets), this.map.definedNames.render(e, t.definedNames), this.map.calcPr.render(e, t.calcProperties), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "workbook":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "workbook":
                                return this.model = {
                                    sheets: this.map.sheets.model,
                                    properties: this.map.workbookPr.model || {},
                                    views: this.map.bookViews.model,
                                    calcProperties: {}
                                }, this.map.definedNames.model && (this.model.definedNames = this.map.definedNames.model), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e) {
                        const t = (e.workbookRels || []).reduce((e, t)=>(e[t.Id] = t, e), {}), r = [];
                        let s, o = 0;
                        (e.sheets || []).forEach((n)=>{
                            const i = t[n.rId];
                            i && (s = e.worksheetHash["xl/" + i.Target.replace(/^(\s|\/xl\/)+/, "")], s && (s.name = n.name, s.id = n.id, s.state = n.state, r[o++] = s));
                        });
                        const a = [];
                        n.each(e.definedNames, (e)=>{
                            if ("_xlnm.Print_Area" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = i.decodeEx(e.ranges[0]);
                                    s.pageSetup.printArea = s.pageSetup.printArea ? `${s.pageSetup.printArea}&&${t.dimensions}` : t.dimensions;
                                }
                            } else if ("_xlnm.Print_Titles" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = e.ranges.join(","), r = /\$/g, n = /\$\d+:\$\d+/, i = t.match(n);
                                    if (i && i.length) {
                                        const e = i[0];
                                        s.pageSetup.printTitlesRow = e.replace(r, "");
                                    }
                                    const o = /\$[A-Z]+:\$[A-Z]+/, a = t.match(o);
                                    if (a && a.length) {
                                        const e = a[0];
                                        s.pageSetup.printTitlesColumn = e.replace(r, "");
                                    }
                                }
                            } else a.push(e);
                        }), e.definedNames = a, e.media.forEach((e, t)=>{
                            e.index = t;
                        });
                    }
                }
                p.WORKBOOK_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x15",
                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                }, p.STATIC_XFORMS = {
                    fileVersion: new a({
                        tag: "fileVersion",
                        $: {
                            appName: "xl",
                            lastEdited: 5,
                            lowestEdited: 5,
                            rupBuild: 9303
                        }
                    })
                }, t.exports = p;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./defined-name-xform": 33,
                "./sheet-xform": 34,
                "./workbook-calc-properties-xform": 35,
                "./workbook-properties-xform": 36,
                "./workbook-view-xform": 37
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                const n = e("../strings/rich-text-xform"), i = e("../../../utils/utils"), s = e("../base-xform"), o = t.exports = function(e) {
                    this.model = e;
                };
                i.inherits(o, s, {
                    get tag () {
                        return "r";
                    },
                    get richTextXform () {
                        return this._richTextXform || (this._richTextXform = new n), this._richTextXform;
                    },
                    render (e, t) {
                        t = t || this.model, e.openNode("comment", {
                            ref: t.ref,
                            authorId: 0
                        }), e.openNode("text"), t && t.note && t.note.texts && t.note.texts.forEach((t)=>{
                            this.richTextXform.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "comment":
                                return this.model = {
                                    type: "note",
                                    note: {
                                        texts: []
                                    },
                                    ...e.attributes
                                }, !0;
                            case "r":
                                return this.parser = this.richTextXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "comment":
                                return !1;
                            case "r":
                                return this.model.note.texts.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../../../utils/utils"), s = e("../base-xform"), o = e("./comment-xform"), a = t.exports = function() {
                    this.map = {
                        comment: new o
                    };
                };
                i.inherits(a, s, {
                    COMMENTS_ATTRIBUTES: {
                        xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                    }
                }, {
                    render (e, t) {
                        t = t || this.model, e.openXml(n.StdDocAttributes), e.openNode("comments", a.COMMENTS_ATTRIBUTES), e.openNode("authors"), e.leafNode("author", null, "Author"), e.closeNode(), e.openNode("commentList"), t.comments.forEach((t)=>{
                            this.map.comment.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "commentList":
                                return this.model = {
                                    comments: []
                                }, !0;
                            case "comment":
                                return this.parser = this.map.comment, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "commentList":
                                return !1;
                            case "comment":
                                return this.model.comments.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./comment-xform": 39
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t, r) {
                        (t === r[2] || "x:SizeWithCells" === this.tag && t === r[1]) && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {}, this.model[this.tag] = !0, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        42: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x:Anchor";
                    }
                    getAnchorRect(e) {
                        const t = Math.floor(e.left), r = Math.floor(68 * (e.left - t)), n = Math.floor(e.top), i = Math.floor(18 * (e.top - n)), s = Math.floor(e.right), o = Math.floor(68 * (e.right - s)), a = Math.floor(e.bottom);
                        return [
                            t,
                            r,
                            n,
                            i,
                            s,
                            o,
                            a,
                            Math.floor(18 * (e.bottom - a))
                        ];
                    }
                    getDefaultRect(e) {
                        const t = e.col, r = Math.max(e.row - 2, 0);
                        return [
                            t,
                            6,
                            r,
                            14,
                            t + 2,
                            2,
                            r + 4,
                            16
                        ];
                    }
                    render(e, t) {
                        const r = t.anchor ? this.getAnchorRect(t.anchor) : this.getDefaultRect(t.refAddress);
                        e.leafNode("x:Anchor", null, r.join(", "));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        44: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-anchor-xform"), s = e("./style/vml-protection-xform"), o = e("./style/vml-position-xform"), a = [
                    "twoCells",
                    "oneCells",
                    "absolute"
                ];
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x:Anchor": new i,
                            "x:Locked": new s({
                                tag: "x:Locked"
                            }),
                            "x:LockText": new s({
                                tag: "x:LockText"
                            }),
                            "x:SizeWithCells": new o({
                                tag: "x:SizeWithCells"
                            }),
                            "x:MoveWithCells": new o({
                                tag: "x:MoveWithCells"
                            })
                        };
                    }
                    get tag() {
                        return "x:ClientData";
                    }
                    render(e, t) {
                        const { protection: r, editAs: n } = t.note;
                        e.openNode(this.tag, {
                            ObjectType: "Note"
                        }), this.map["x:MoveWithCells"].render(e, n, a), this.map["x:SizeWithCells"].render(e, n, a), this.map["x:Anchor"].render(e, t), this.map["x:Locked"].render(e, r.locked), e.leafNode("x:AutoFill", null, "False"), this.map["x:LockText"].render(e, r.lockText), e.leafNode("x:Row", null, t.refAddress.row - 1), e.leafNode("x:Column", null, t.refAddress.col - 1), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchor: [],
                                    protection: {},
                                    editAs: ""
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.normalizeModel(), !1;
                            default:
                                return !0;
                        }
                    }
                    normalizeModel() {
                        const e = Object.assign({}, this.map["x:MoveWithCells"].model, this.map["x:SizeWithCells"].model), t = Object.keys(e).length;
                        this.model.editAs = a[t], this.model.anchor = this.map["x:Anchor"].text, this.model.protection.locked = this.map["x:Locked"].text, this.model.protection.lockText = this.map["x:LockText"].text;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./style/vml-position-xform": 41,
                "./style/vml-protection-xform": 42,
                "./vml-anchor-xform": 43
            }
        ],
        45: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./vml-shape-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "v:shape": new s
                        };
                    }
                    get tag() {
                        return "xml";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, o.DRAWING_ATTRIBUTES), e.openNode("o:shapelayout", {
                            "v:ext": "edit"
                        }), e.leafNode("o:idmap", {
                            "v:ext": "edit",
                            data: 1
                        }), e.closeNode(), e.openNode("v:shapetype", {
                            id: "_x0000_t202",
                            coordsize: "21600,21600",
                            "o:spt": 202,
                            path: "m,l,21600r21600,l21600,xe"
                        }), e.leafNode("v:stroke", {
                            joinstyle: "miter"
                        }), e.leafNode("v:path", {
                            gradientshapeok: "t",
                            "o:connecttype": "rect"
                        }), e.closeNode(), t.comments.forEach((t, r)=>{
                            this.map["v:shape"].render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    comments: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.comments.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                o.DRAWING_ATTRIBUTES = {
                    "xmlns:v": "urn:schemas-microsoft-com:vml",
                    "xmlns:o": "urn:schemas-microsoft-com:office:office",
                    "xmlns:x": "urn:schemas-microsoft-com:office:excel"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./vml-shape-xform": 46
            }
        ],
        46: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-textbox-xform"), s = e("./vml-client-data-xform");
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            "v:textbox": new i,
                            "x:ClientData": new s
                        };
                    }
                    get tag() {
                        return "v:shape";
                    }
                    render(e, t, r) {
                        e.openNode("v:shape", o.V_SHAPE_ATTRIBUTES(t, r)), e.leafNode("v:fill", {
                            color2: "infoBackground [80]"
                        }), e.leafNode("v:shadow", {
                            color: "none [81]",
                            obscured: "t"
                        }), e.leafNode("v:path", {
                            "o:connecttype": "none"
                        }), this.map["v:textbox"].render(e, t), this.map["x:ClientData"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    margins: {
                                        insetmode: e.attributes["o:insetmode"]
                                    },
                                    anchor: "",
                                    editAs: "",
                                    protection: {}
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.margins.inset = this.map["v:textbox"].model && this.map["v:textbox"].model.inset, this.model.protection = this.map["x:ClientData"].model && this.map["x:ClientData"].model.protection, this.model.anchor = this.map["x:ClientData"].model && this.map["x:ClientData"].model.anchor, this.model.editAs = this.map["x:ClientData"].model && this.map["x:ClientData"].model.editAs, !1;
                            default:
                                return !0;
                        }
                    }
                }
                o.V_SHAPE_ATTRIBUTES = (e, t)=>({
                        id: "_x0000_s" + (1025 + t),
                        type: "#_x0000_t202",
                        style: "position:absolute; margin-left:105.3pt;margin-top:10.5pt;width:97.8pt;height:59.1pt;z-index:1;visibility:hidden",
                        fillcolor: "infoBackground [80]",
                        strokecolor: "none [81]",
                        "o:insetmode": e.note.margins && e.note.margins.insetmode
                    }), t.exports = o;
            },
            {
                "../base-xform": 32,
                "./vml-client-data-xform": 44,
                "./vml-textbox-xform": 47
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "v:textbox";
                    }
                    conversionUnit(e, t, r) {
                        return `${parseFloat(e) * t.toFixed(2)}${r}`;
                    }
                    reverseConversionUnit(e) {
                        return (e || "").split(",").map((e)=>Number(parseFloat(this.conversionUnit(parseFloat(e), .1, "")).toFixed(2)));
                    }
                    render(e, t) {
                        const r = {
                            style: "mso-direction-alt:auto"
                        };
                        if (t && t.note) {
                            let { inset: e } = t.note && t.note.margins;
                            Array.isArray(e) && (e = e.map((e)=>this.conversionUnit(e, 10, "mm")).join(",")), e && (r.inset = e);
                        }
                        e.openNode("v:textbox", r), e.leafNode("div", {
                            style: "text-align:left"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    inset: this.reverseConversionUnit(e.attributes.inset)
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        48: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    createNewModel(e) {
                        return {};
                    }
                    parseOpen(e) {
                        return this.parser = this.parser || this.map[e.name], this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag && (this.model = this.createNewModel(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.onParserClose(e, this.parser), this.parser = void 0), !0) : e !== this.tag;
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        49: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("HeadingPairs"), e.openNode("vt:vector", {
                            size: 2,
                            baseType: "variant"
                        }), e.openNode("vt:variant"), e.leafNode("vt:lpstr", void 0, "Worksheets"), e.closeNode(), e.openNode("vt:variant"), e.leafNode("vt:i4", void 0, t.length), e.closeNode(), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "HeadingPairs" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "HeadingPairs" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("TitlesOfParts"), e.openNode("vt:vector", {
                            size: t.length,
                            baseType: "lpstr"
                        }), t.forEach((t)=>{
                            e.leafNode("vt:lpstr", void 0, t.name);
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "TitlesOfParts" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "TitlesOfParts" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/string-xform"), o = e("./app-heading-pairs-xform"), a = e("./app-titles-of-parts-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            Company: new s({
                                tag: "Company"
                            }),
                            Manager: new s({
                                tag: "Manager"
                            }),
                            HeadingPairs: new o,
                            TitleOfParts: new a
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Properties", l.PROPERTY_ATTRIBUTES), e.leafNode("Application", void 0, "Microsoft Excel"), e.leafNode("DocSecurity", void 0, "0"), e.leafNode("ScaleCrop", void 0, "false"), this.map.HeadingPairs.render(e, t.worksheets), this.map.TitleOfParts.render(e, t.worksheets), this.map.Company.render(e, t.company || ""), this.map.Manager.render(e, t.manager), e.leafNode("LinksUpToDate", void 0, "false"), e.leafNode("SharedDoc", void 0, "false"), e.leafNode("HyperlinksChanged", void 0, "false"), e.leafNode("AppVersion", void 0, "16.0300"), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Properties":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "Properties":
                                return this.model = {
                                    worksheets: this.map.TitleOfParts.model,
                                    company: this.map.Company.model,
                                    manager: this.map.Manager.model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3,6}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
                    "xmlns:vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/string-xform": 119,
                "./app-heading-pairs-xform": 49,
                "./app-titles-of-parts-xform": 50
            }
        ],
        52: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform");
                class s extends i {
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Types", s.PROPERTY_ATTRIBUTES);
                        const r = {};
                        (t.media || []).forEach((t)=>{
                            if ("image" === t.type) {
                                const n = t.extension;
                                r[n] || (r[n] = !0, e.leafNode("Default", {
                                    Extension: n,
                                    ContentType: "image/" + n
                                }));
                            }
                        }), e.leafNode("Default", {
                            Extension: "rels",
                            ContentType: "application/vnd.openxmlformats-package.relationships+xml"
                        }), e.leafNode("Default", {
                            Extension: "xml",
                            ContentType: "application/xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/workbook.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
                        }), t.worksheets.forEach((t)=>{
                            const r = `/xl/worksheets/sheet${t.id}.xml`;
                            e.leafNode("Override", {
                                PartName: r,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"
                            });
                        }), e.leafNode("Override", {
                            PartName: "/xl/theme/theme1.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.theme+xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/styles.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"
                        });
                        t.sharedStrings && t.sharedStrings.count && e.leafNode("Override", {
                            PartName: "/xl/sharedStrings.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"
                        }), t.tables && t.tables.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: "/xl/tables/" + t.target,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml"
                            });
                        }), t.drawings && t.drawings.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: `/xl/drawings/${t.name}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.drawing+xml"
                            });
                        }), t.commentRefs && (e.leafNode("Default", {
                            Extension: "vml",
                            ContentType: "application/vnd.openxmlformats-officedocument.vmlDrawing"
                        }), t.commentRefs.forEach((t)=>{
                            let { commentName: r } = t;
                            e.leafNode("Override", {
                                PartName: `/xl/${r}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml"
                            });
                        })), e.leafNode("Override", {
                            PartName: "/docProps/core.xml",
                            ContentType: "application/vnd.openxmlformats-package.core-properties+xml"
                        }), e.leafNode("Override", {
                            PartName: "/docProps/app.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.extended-properties+xml"
                        }), e.closeNode();
                    }
                    parseOpen() {
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                s.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
                }, t.exports = s;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/date-xform"), o = e("../simple/string-xform"), a = e("../simple/integer-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            "dc:creator": new o({
                                tag: "dc:creator"
                            }),
                            "dc:title": new o({
                                tag: "dc:title"
                            }),
                            "dc:subject": new o({
                                tag: "dc:subject"
                            }),
                            "dc:description": new o({
                                tag: "dc:description"
                            }),
                            "dc:identifier": new o({
                                tag: "dc:identifier"
                            }),
                            "dc:language": new o({
                                tag: "dc:language"
                            }),
                            "cp:keywords": new o({
                                tag: "cp:keywords"
                            }),
                            "cp:category": new o({
                                tag: "cp:category"
                            }),
                            "cp:lastModifiedBy": new o({
                                tag: "cp:lastModifiedBy"
                            }),
                            "cp:lastPrinted": new s({
                                tag: "cp:lastPrinted",
                                format: l.DateFormat
                            }),
                            "cp:revision": new a({
                                tag: "cp:revision"
                            }),
                            "cp:version": new o({
                                tag: "cp:version"
                            }),
                            "cp:contentStatus": new o({
                                tag: "cp:contentStatus"
                            }),
                            "cp:contentType": new o({
                                tag: "cp:contentType"
                            }),
                            "dcterms:created": new s({
                                tag: "dcterms:created",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            }),
                            "dcterms:modified": new s({
                                tag: "dcterms:modified",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            })
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("cp:coreProperties", l.CORE_PROPERTY_ATTRIBUTES), this.map["dc:creator"].render(e, t.creator), this.map["dc:title"].render(e, t.title), this.map["dc:subject"].render(e, t.subject), this.map["dc:description"].render(e, t.description), this.map["dc:identifier"].render(e, t.identifier), this.map["dc:language"].render(e, t.language), this.map["cp:keywords"].render(e, t.keywords), this.map["cp:category"].render(e, t.category), this.map["cp:lastModifiedBy"].render(e, t.lastModifiedBy), this.map["cp:lastPrinted"].render(e, t.lastPrinted), this.map["cp:revision"].render(e, t.revision), this.map["cp:version"].render(e, t.version), this.map["cp:contentStatus"].render(e, t.contentStatus), this.map["cp:contentType"].render(e, t.contentType), this.map["dcterms:created"].render(e, t.created), this.map["dcterms:modified"].render(e, t.modified), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return this.model = {
                                    creator: this.map["dc:creator"].model,
                                    title: this.map["dc:title"].model,
                                    subject: this.map["dc:subject"].model,
                                    description: this.map["dc:description"].model,
                                    identifier: this.map["dc:identifier"].model,
                                    language: this.map["dc:language"].model,
                                    keywords: this.map["cp:keywords"].model,
                                    category: this.map["cp:category"].model,
                                    lastModifiedBy: this.map["cp:lastModifiedBy"].model,
                                    lastPrinted: this.map["cp:lastPrinted"].model,
                                    revision: this.map["cp:revision"].model,
                                    contentStatus: this.map["cp:contentStatus"].model,
                                    contentType: this.map["cp:contentType"].model,
                                    created: this.map["dcterms:created"].model,
                                    modified: this.map["dcterms:modified"].model
                                }, !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.CORE_PROPERTY_ATTRIBUTES = {
                    "xmlns:cp": "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
                    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                    "xmlns:dcterms": "http://purl.org/dc/terms/",
                    "xmlns:dcmitype": "http://purl.org/dc/dcmitype/",
                    "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/date-xform": 117,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119
            }
        ],
        54: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("Relationship", t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "Relationship":
                                return this.model = e.attributes, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        55: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./relationship-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            Relationship: new s
                        };
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("Relationships", o.RELATIONSHIPS_ATTRIBUTES), t.forEach((t)=>{
                            this.map.Relationship.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Relationships":
                                return this.model = [], !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case "Relationships":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                o.RELATIONSHIPS_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./relationship-xform": 54
            }
        ],
        56: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    range: {
                                        editAs: e.attributes.editAs || "oneCell"
                                    }
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    reconcilePicture(e, t) {
                        if (e && e.rId) {
                            const r = t.rels[e.rId].Target.match(/.*\/media\/(.+[.][a-zA-Z]{3,4})/);
                            if (r) {
                                const e = r[1], n = t.mediaIndex[e];
                                return t.media[n];
                            }
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        57: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./blip-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:blip": new i
                        };
                    }
                    get tag() {
                        return "xdr:blipFill";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["a:blip"].render(e, t), e.openNode("a:stretch"), e.leafNode("a:fillRect"), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:blip"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./blip-xform": 58
            }
        ],
        58: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:blip";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:embed": t.rId,
                            cstate: "print"
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:embed"]
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        59: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xdr:cNvPicPr";
                    }
                    render(e) {
                        e.openNode(this.tag), e.leafNode("a:picLocks", {
                            noChangeAspect: "1"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        60: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./hlink-click-xform"), s = e("./ext-lst-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:hlinkClick": new i,
                            "a:extLst": new s
                        };
                    }
                    get tag() {
                        return "xdr:cNvPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            id: t.index,
                            name: "Picture " + t.index
                        }), this.map["a:hlinkClick"].render(e, t), this.map["a:extLst"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:hlinkClick"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./ext-lst-xform": 63,
                "./hlink-click-xform": 65
            }
        ],
        61: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../simple/integer-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {
                            "xdr:col": new i({
                                tag: "xdr:col",
                                zero: !0
                            }),
                            "xdr:colOff": new i({
                                tag: "xdr:colOff",
                                zero: !0
                            }),
                            "xdr:row": new i({
                                tag: "xdr:row",
                                zero: !0
                            }),
                            "xdr:rowOff": new i({
                                tag: "xdr:rowOff",
                                zero: !0
                            })
                        };
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:col"].render(e, t.nativeCol), this.map["xdr:colOff"].render(e, t.nativeColOff), this.map["xdr:row"].render(e, t.nativeRow), this.map["xdr:rowOff"].render(e, t.nativeRowOff), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = {
                                    nativeCol: this.map["xdr:col"].model,
                                    nativeColOff: this.map["xdr:colOff"].model,
                                    nativeRow: this.map["xdr:row"].model,
                                    nativeRowOff: this.map["xdr:rowOff"].model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../simple/integer-xform": 118
            }
        ],
        62: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("./two-cell-anchor-xform"), a = e("./one-cell-anchor-xform");
                class l extends s {
                    constructor(){
                        super(), this.map = {
                            "xdr:twoCellAnchor": new o,
                            "xdr:oneCellAnchor": new a
                        };
                    }
                    prepare(e) {
                        e.anchors.forEach((e, t)=>{
                            e.anchorType = function(e) {
                                return ("string" == typeof e.range ? n.decode(e.range) : e.range).br ? "xdr:twoCellAnchor" : "xdr:oneCellAnchor";
                            }(e);
                            this.map[e.anchorType].prepare(e, {
                                index: t
                            });
                        });
                    }
                    get tag() {
                        return "xdr:wsDr";
                    }
                    render(e, t) {
                        e.openXml(i.StdDocAttributes), e.openNode(this.tag, l.DRAWING_ATTRIBUTES), t.anchors.forEach((t)=>{
                            this.map[t.anchorType].render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchors: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.anchors.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                l.DRAWING_ATTRIBUTES = {
                    "xmlns:xdr": "http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing",
                    "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main"
                }, t.exports = l;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./one-cell-anchor-xform": 67,
                "./two-cell-anchor-xform": 70
            }
        ],
        63: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:extLst";
                    }
                    render(e) {
                        e.openNode(this.tag), e.openNode("a:ext", {
                            uri: "{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}"
                        }), e.leafNode("a16:creationId", {
                            "xmlns:a16": "http://schemas.microsoft.com/office/drawing/2014/main",
                            id: "{00000000-0008-0000-0000-000002000000}"
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        64: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {};
                    }
                    render(e, t) {
                        e.openNode(this.tag);
                        const r = Math.floor(9525 * t.width), n = Math.floor(9525 * t.height);
                        e.addAttribute("cx", r), e.addAttribute("cy", n), e.closeNode();
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            width: parseInt(e.attributes.cx || "0", 10) / 9525,
                            height: parseInt(e.attributes.cy || "0", 10) / 9525
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        65: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:hlinkClick";
                    }
                    render(e, t) {
                        t.hyperlinks && t.hyperlinks.rId && e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:id": t.hyperlinks.rId,
                            tooltip: t.hyperlinks.tooltip
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    hyperlinks: {
                                        rId: e.attributes["r:id"],
                                        tooltip: e.attributes.tooltip
                                    }
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        66: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./c-nv-pr-xform"), s = e("./c-nv-pic-pr-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:cNvPr": new i,
                            "xdr:cNvPicPr": new s
                        };
                    }
                    get tag() {
                        return "xdr:nvPicPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:cNvPr"].render(e, t), this.map["xdr:cNvPicPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["xdr:cNvPr"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./c-nv-pic-pr-xform": 59,
                "./c-nv-pr-xform": 60
            }
        ],
        67: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./ext-xform"), a = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:ext": new o({
                                tag: "xdr:ext"
                            }),
                            "xdr:pic": new a,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:oneCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:ext"].render(e, t.range.ext), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.ext = this.map["xdr:ext"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./ext-xform": 64,
                "./pic-xform": 68
            }
        ],
        68: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../static-xform"), s = e("./blip-fill-xform"), o = e("./nv-pic-pr-xform"), a = e("./sp-pr");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:nvPicPr": new o,
                            "xdr:blipFill": new s,
                            "xdr:spPr": new i(a)
                        };
                    }
                    get tag() {
                        return "xdr:pic";
                    }
                    prepare(e, t) {
                        e.index = t.index + 1;
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:nvPicPr"].render(e, t), this.map["xdr:blipFill"].render(e, t), this.map["xdr:spPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.mergeModel(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../static-xform": 120,
                "./blip-fill-xform": 57,
                "./nv-pic-pr-xform": 66,
                "./sp-pr": 69
            }
        ],
        69: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    tag: "xdr:spPr",
                    c: [
                        {
                            tag: "a:xfrm",
                            c: [
                                {
                                    tag: "a:off",
                                    $: {
                                        x: "0",
                                        y: "0"
                                    }
                                },
                                {
                                    tag: "a:ext",
                                    $: {
                                        cx: "0",
                                        cy: "0"
                                    }
                                }
                            ]
                        },
                        {
                            tag: "a:prstGeom",
                            $: {
                                prst: "rect"
                            },
                            c: [
                                {
                                    tag: "a:avLst"
                                }
                            ]
                        }
                    ]
                };
            },
            {}
        ],
        70: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:to": new s({
                                tag: "xdr:to"
                            }),
                            "xdr:pic": new o,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:twoCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:to"].render(e, t.range.br), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.br = this.map["xdr:to"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./pic-xform": 68
            }
        ],
        71: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.always = !!e.always, this.count = e.count, this.empty = e.empty, this.$count = e.$count || "count", this.$ = e.$, this.childXform = e.childXform, this.maxItems = e.maxItems;
                    }
                    prepare(e, t) {
                        const { childXform: r } = this;
                        e && e.forEach((e, n)=>{
                            t.index = n, r.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        if (this.always || t && t.length) {
                            e.openNode(this.tag, this.$), this.count && e.addAttribute(this.$count, t && t.length || 0);
                            const { childXform: r } = this;
                            (t || []).forEach((t, n)=>{
                                r.render(e, t, n);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = [], !0;
                            default:
                                return !!this.childXform.parseOpen(e) && (this.parser = this.childXform, !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e) && (this.model.push(this.parser.model), this.parser = void 0, this.maxItems && this.model.length > this.maxItems)) throw new Error(`Max ${this.childXform.tag} count (${this.maxItems}) exceeded`);
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        if (e) {
                            const { childXform: r } = this;
                            e.forEach((e)=>{
                                r.reconcile(e, t);
                            });
                        }
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        72: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "autoFilter";
                    }
                    render(e, t) {
                        if (t) {
                            if ("string" == typeof t) e.leafNode("autoFilter", {
                                ref: t
                            });
                            else {
                                const r = function(e) {
                                    return "string" == typeof e ? e : n.getAddress(e.row, e.column).address;
                                }, i = r(t.from), s = r(t.to);
                                i && s && e.leafNode("autoFilter", {
                                    ref: `${i}:${s}`
                                });
                            }
                        }
                    }
                    parseOpen(e) {
                        "autoFilter" === e.name && (this.model = e.attributes.ref);
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        73: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform"), s = e("../../../doc/range"), o = e("../../../doc/enums"), a = e("../strings/rich-text-xform");
                function l(e) {
                    if (null == e) return o.ValueType.Null;
                    if (e instanceof String || "string" == typeof e) return o.ValueType.String;
                    if ("number" == typeof e) return o.ValueType.Number;
                    if ("boolean" == typeof e) return o.ValueType.Boolean;
                    if (e instanceof Date) return o.ValueType.Date;
                    if (e.text && e.hyperlink) return o.ValueType.Hyperlink;
                    if (e.formula) return o.ValueType.Formula;
                    if (e.error) return o.ValueType.Error;
                    throw new Error("I could not understand type of value");
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.richTextXForm = new a;
                    }
                    get tag() {
                        return "c";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {}, function(e) {
                            switch(e.type){
                                case o.ValueType.Formula:
                                    return l(e.result);
                                default:
                                    return e.type;
                            }
                        }(e));
                        switch(r && (e.styleId = r), e.comment && t.comments.push({
                            ...e.comment,
                            ref: e.address
                        }), e.type){
                            case o.ValueType.String:
                            case o.ValueType.RichText:
                                t.sharedStrings && (e.ssId = t.sharedStrings.add(e.value));
                                break;
                            case o.ValueType.Date:
                                t.date1904 && (e.date1904 = !0);
                                break;
                            case o.ValueType.Hyperlink:
                                t.sharedStrings && void 0 !== e.text && null !== e.text && (e.ssId = t.sharedStrings.add(e.text)), t.hyperlinks.push({
                                    address: e.address,
                                    target: e.hyperlink,
                                    tooltip: e.tooltip
                                });
                                break;
                            case o.ValueType.Merge:
                                t.merges.add(e);
                                break;
                            case o.ValueType.Formula:
                                if (t.date1904 && (e.date1904 = !0), "shared" === e.shareType && (e.si = t.siFormulae++), e.formula) t.formulae[e.address] = e;
                                else if (e.sharedFormula) {
                                    const r = t.formulae[e.sharedFormula];
                                    if (!r) throw new Error("Shared Formula master must exist above and or left of clone for cell " + e.address);
                                    void 0 === r.si ? (r.shareType = "shared", r.si = t.siFormulae++, r.range = new s(r.address, e.address)) : r.range && r.range.expandToAddress(e.address), e.si = r.si;
                                }
                        }
                    }
                    renderFormula(e, t) {
                        let r = null;
                        switch(t.shareType){
                            case "shared":
                                r = {
                                    t: "shared",
                                    ref: t.ref || t.range.range,
                                    si: t.si
                                };
                                break;
                            case "array":
                                r = {
                                    t: "array",
                                    ref: t.ref
                                };
                                break;
                            default:
                                void 0 !== t.si && (r = {
                                    t: "shared",
                                    si: t.si
                                });
                        }
                        switch(l(t.result)){
                            case o.ValueType.Null:
                                e.leafNode("f", r, t.formula);
                                break;
                            case o.ValueType.String:
                                e.addAttribute("t", "str"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Number:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Boolean:
                                e.addAttribute("t", "b"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result ? 1 : 0);
                                break;
                            case o.ValueType.Error:
                                e.addAttribute("t", "e"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result.error);
                                break;
                            case o.ValueType.Date:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, n.dateToExcel(t.result, t.date1904));
                                break;
                            default:
                                throw new Error("I could not understand type of value");
                        }
                    }
                    render(e, t) {
                        if (t.type !== o.ValueType.Null || t.styleId) {
                            switch(e.openNode("c"), e.addAttribute("r", t.address), t.styleId && e.addAttribute("s", t.styleId), t.type){
                                case o.ValueType.Null:
                                    break;
                                case o.ValueType.Number:
                                    e.leafNode("v", null, t.value);
                                    break;
                                case o.ValueType.Boolean:
                                    e.addAttribute("t", "b"), e.leafNode("v", null, t.value ? "1" : "0");
                                    break;
                                case o.ValueType.Error:
                                    e.addAttribute("t", "e"), e.leafNode("v", null, t.value.error);
                                    break;
                                case o.ValueType.String:
                                case o.ValueType.RichText:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : t.value && t.value.richText ? (e.addAttribute("t", "inlineStr"), e.openNode("is"), t.value.richText.forEach((t)=>{
                                        this.richTextXForm.render(e, t);
                                    }), e.closeNode("is")) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.value));
                                    break;
                                case o.ValueType.Date:
                                    e.leafNode("v", null, n.dateToExcel(t.value, t.date1904));
                                    break;
                                case o.ValueType.Hyperlink:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.text));
                                    break;
                                case o.ValueType.Formula:
                                    this.renderFormula(e, t);
                                    break;
                                case o.ValueType.Merge:
                            }
                            e.closeNode();
                        }
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "c":
                                return this.model = {
                                    address: e.attributes.r
                                }, this.t = e.attributes.t, e.attributes.s && (this.model.styleId = parseInt(e.attributes.s, 10)), !0;
                            case "f":
                                return this.currentNode = "f", this.model.si = e.attributes.si, this.model.shareType = e.attributes.t, this.model.ref = e.attributes.ref, !0;
                            case "v":
                                return this.currentNode = "v", !0;
                            case "t":
                                return this.currentNode = "t", !0;
                            case "r":
                                return this.parser = this.richTextXForm, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        if (this.parser) this.parser.parseText(e);
                        else switch(this.currentNode){
                            case "f":
                                this.model.formula = this.model.formula ? this.model.formula + e : e;
                                break;
                            case "v":
                            case "t":
                                this.model.value && this.model.value.richText ? this.model.value.richText.text = this.model.value.richText.text ? this.model.value.richText.text + e : e : this.model.value = this.model.value ? this.model.value + e : e;
                        }
                    }
                    parseClose(e) {
                        switch(e){
                            case "c":
                                {
                                    const { model: e } = this;
                                    if (e.formula || e.shareType) e.type = o.ValueType.Formula, e.value && ("str" === this.t ? e.result = n.xmlDecode(e.value) : "b" === this.t ? e.result = 0 !== parseInt(e.value, 10) : "e" === this.t ? e.result = {
                                        error: e.value
                                    } : e.result = parseFloat(e.value), e.value = void 0);
                                    else if (void 0 !== e.value) switch(this.t){
                                        case "s":
                                            e.type = o.ValueType.String, e.value = parseInt(e.value, 10);
                                            break;
                                        case "str":
                                            e.type = o.ValueType.String, e.value = n.xmlDecode(e.value);
                                            break;
                                        case "inlineStr":
                                            e.type = o.ValueType.String;
                                            break;
                                        case "b":
                                            e.type = o.ValueType.Boolean, e.value = 0 !== parseInt(e.value, 10);
                                            break;
                                        case "e":
                                            e.type = o.ValueType.Error, e.value = {
                                                error: e.value
                                            };
                                            break;
                                        default:
                                            e.type = o.ValueType.Number, e.value = parseFloat(e.value);
                                    }
                                    else e.styleId ? e.type = o.ValueType.Null : e.type = o.ValueType.Merge;
                                    return !1;
                                }
                            case "f":
                            case "v":
                            case "is":
                                return this.currentNode = void 0, !0;
                            case "t":
                                return this.parser ? (this.parser.parseClose(e), !0) : (this.currentNode = void 0, !0);
                            case "r":
                                return this.model.value = this.model.value || {}, this.model.value.richText = this.model.value.richText || [], this.model.value.richText.push(this.parser.model), this.parser = void 0, this.currentNode = void 0, !0;
                            default:
                                return !!this.parser && (this.parser.parseClose(e), !0);
                        }
                    }
                    reconcile(e, t) {
                        const r = e.styleId && t.styles && t.styles.getStyleModel(e.styleId);
                        switch(r && (e.style = r), void 0 !== e.styleId && (e.styleId = void 0), e.type){
                            case o.ValueType.String:
                                "number" == typeof e.value && t.sharedStrings && (e.value = t.sharedStrings.getString(e.value)), e.value.richText && (e.type = o.ValueType.RichText);
                                break;
                            case o.ValueType.Number:
                                r && n.isDateFmt(r.numFmt) && (e.type = o.ValueType.Date, e.value = n.excelToDate(e.value, t.date1904));
                                break;
                            case o.ValueType.Formula:
                                void 0 !== e.result && r && n.isDateFmt(r.numFmt) && (e.result = n.excelToDate(e.result, t.date1904)), "shared" === e.shareType && (e.ref ? t.formulae[e.si] = e.address : (e.sharedFormula = t.formulae[e.si], delete e.shareType), delete e.si);
                        }
                        const i = t.hyperlinkMap[e.address];
                        i && (e.type === o.ValueType.Formula ? (e.text = e.result, e.result = void 0) : (e.text = e.value, e.value = void 0), e.type = o.ValueType.Hyperlink, e.hyperlink = i);
                        const s = t.commentsMap && t.commentsMap[e.address];
                        s && (e.comment = s);
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        74: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x14:cfIcon";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            iconSet: t.iconSet,
                            iconId: t.iconId
                        });
                    }
                    parseOpen(e) {
                        let { attributes: t } = e;
                        this.model = {
                            iconSet: t.iconSet,
                            iconId: n.toIntValue(t.iconId)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        75: [
            function(e, t, r) {
                "use strict";
                const { v4: n } = e("uuid"), i = e("../../base-xform"), s = e("../../composite-xform"), o = e("./databar-ext-xform"), a = e("./icon-set-ext-xform"), l = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                };
                class c extends s {
                    constructor(){
                        super(), this.map = {
                            "x14:dataBar": this.databarXform = new o,
                            "x14:iconSet": this.iconSetXform = new a
                        };
                    }
                    get tag() {
                        return "x14:cfRule";
                    }
                    static isExt(e) {
                        return "dataBar" === e.type ? o.isExt(e) : !("iconSet" !== e.type || !e.custom && !l[e.iconSet]);
                    }
                    prepare(e) {
                        c.isExt(e) && (e.x14Id = `{${n()}}`.toUpperCase());
                    }
                    render(e, t) {
                        if (c.isExt(t)) switch(t.type){
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                        }
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            id: t.x14Id
                        }), this.databarXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority,
                            id: t.x14Id || `{${n()}}`
                        }), this.iconSetXform.render(e, t), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            type: t.type,
                            x14Id: t.id,
                            priority: i.toIntValue(t.priority)
                        };
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                }
                t.exports = c;
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./databar-ext-xform": 79,
                "./icon-set-ext-xform": 81,
                uuid: 528
            }
        ],
        76: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./f-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:f": this.fExtXform = new i
                        };
                    }
                    get tag() {
                        return "x14:cfvo";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            type: t.type
                        }), void 0 !== t.value && this.fExtXform.render(e, t.value), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            type: e.attributes.type
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:f":
                                this.model.value = t.model ? parseFloat(t.model) : 0;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./f-ext-xform": 80
            }
        ],
        77: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./sqref-ext-xform"), s = e("./cf-rule-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:sqref": this.sqRef = new i,
                            "x14:cfRule": this.cfRule = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormatting";
                    }
                    prepare(e, t) {
                        e.rules.forEach((e)=>{
                            this.cfRule.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        t.rules.some(s.isExt) && (e.openNode(this.tag, {
                            "xmlns:xm": "http://schemas.microsoft.com/office/excel/2006/main"
                        }), t.rules.filter(s.isExt).forEach((t)=>this.cfRule.render(e, t)), this.sqRef.render(e, t.ref), e.closeNode());
                    }
                    createNewModel() {
                        return {
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:sqref":
                                this.model.ref = t.model;
                                break;
                            case "x14:cfRule":
                                this.model.rules.push(t.model);
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./sqref-ext-xform": 82
            }
        ],
        78: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-ext-xform"), s = e("./conditional-formatting-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormatting": this.cfXform = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormattings";
                    }
                    hasContent(e) {
                        return void 0 === e.hasExtContent && (e.hasExtContent = e.some((e)=>e.rules.some(i.isExt))), e.hasExtContent;
                    }
                    prepare(e, t) {
                        e.forEach((e)=>{
                            this.cfXform.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode(this.tag), t.forEach((t)=>this.cfXform.render(e, t)), e.closeNode());
                    }
                    createNewModel() {
                        return [];
                    }
                    onParserClose(e, t) {
                        this.model.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./conditional-formatting-ext-xform": 77
            }
        ],
        79: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../style/color-xform"), o = e("./cfvo-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new o,
                            "x14:borderColor": this.borderColorXform = new s("x14:borderColor"),
                            "x14:negativeBorderColor": this.negativeBorderColorXform = new s("x14:negativeBorderColor"),
                            "x14:negativeFillColor": this.negativeFillColorXform = new s("x14:negativeFillColor"),
                            "x14:axisColor": this.axisColorXform = new s("x14:axisColor")
                        };
                    }
                    static isExt(e) {
                        return !e.gradient;
                    }
                    get tag() {
                        return "x14:dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            minLength: n.toIntAttribute(t.minLength, 0, !0),
                            maxLength: n.toIntAttribute(t.maxLength, 100, !0),
                            border: n.toBoolAttribute(t.border, !1),
                            gradient: n.toBoolAttribute(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolAttribute(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolAttribute(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toAttribute(t.axisPosition, "auto"),
                            direction: n.toAttribute(t.direction, "leftToRight")
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.borderColorXform.render(e, t.borderColor), this.negativeBorderColorXform.render(e, t.negativeBorderColor), this.negativeFillColorXform.render(e, t.negativeFillColor), this.axisColorXform.render(e, t.axisColor), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            minLength: n.toIntValue(t.minLength, 0),
                            maxLength: n.toIntValue(t.maxLength, 100),
                            border: n.toBoolValue(t.border, !1),
                            gradient: n.toBoolValue(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolValue(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolValue(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toStringValue(t.axisPosition, "auto"),
                            direction: n.toStringValue(t.direction, "leftToRight")
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-ext-xform": 76
            }
        ],
        80: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:f";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        81: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-ext-xform"), o = e("./cf-icon-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new s,
                            "x14:cfIcon": this.cfIconXform = new o
                        };
                    }
                    get tag() {
                        return "x14:iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0),
                            custom: n.toBoolAttribute(t.icons, !1)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.icons && t.icons.forEach((t, r)=>{
                            t.iconId = r, this.cfIconXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse, !1),
                            showValue: n.toBoolValue(t.showValue, !0)
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "cfIcon":
                                this.model.icons || (this.model.icons = []), this.model.icons.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cf-icon-ext-xform": 74,
                "./cfvo-ext-xform": 76
            }
        ],
        82: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:sqref";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        83: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../../../doc/range"), o = e("./databar-xform"), a = e("./ext-lst-ref-xform"), l = e("./formula-xform"), c = e("./color-scale-xform"), u = e("./icon-set-xform"), h = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                }, f = (e)=>{
                    const { type: t, operator: r } = e;
                    switch(t){
                        case "containsText":
                        case "containsBlanks":
                        case "notContainsBlanks":
                        case "containsErrors":
                        case "notContainsErrors":
                            return {
                                type: "containsText",
                                operator: t
                            };
                        default:
                            return {
                                type: t,
                                operator: r
                            };
                    }
                };
                class d extends i {
                    constructor(){
                        super(), this.map = {
                            dataBar: this.databarXform = new o,
                            extLst: this.extLstRefXform = new a,
                            formula: this.formulaXform = new l,
                            colorScale: this.colorScaleXform = new c,
                            iconSet: this.iconSetXform = new u
                        };
                    }
                    get tag() {
                        return "cfRule";
                    }
                    static isPrimitive(e) {
                        return "iconSet" !== e.type || !e.custom && !h[e.iconSet];
                    }
                    render(e, t) {
                        switch(t.type){
                            case "expression":
                                this.renderExpression(e, t);
                                break;
                            case "cellIs":
                                this.renderCellIs(e, t);
                                break;
                            case "top10":
                                this.renderTop10(e, t);
                                break;
                            case "aboveAverage":
                                this.renderAboveAverage(e, t);
                                break;
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "colorScale":
                                this.renderColorScale(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                                break;
                            case "containsText":
                                this.renderText(e, t);
                                break;
                            case "timePeriod":
                                this.renderTimePeriod(e, t);
                        }
                    }
                    renderExpression(e, t) {
                        e.openNode(this.tag, {
                            type: "expression",
                            dxfId: t.dxfId,
                            priority: t.priority
                        }), this.formulaXform.render(e, t.formulae[0]), e.closeNode();
                    }
                    renderCellIs(e, t) {
                        e.openNode(this.tag, {
                            type: "cellIs",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: t.operator
                        }), t.formulae.forEach((t)=>{
                            this.formulaXform.render(e, t);
                        }), e.closeNode();
                    }
                    renderTop10(e, t) {
                        e.leafNode(this.tag, {
                            type: "top10",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            percent: n.toBoolAttribute(t.percent, !1),
                            bottom: n.toBoolAttribute(t.bottom, !1),
                            rank: n.toIntValue(t.rank, 10, !0)
                        });
                    }
                    renderAboveAverage(e, t) {
                        e.leafNode(this.tag, {
                            type: "aboveAverage",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            aboveAverage: n.toBoolAttribute(t.aboveAverage, !0)
                        });
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            priority: t.priority
                        }), this.databarXform.render(e, t), this.extLstRefXform.render(e, t), e.closeNode();
                    }
                    renderColorScale(e, t) {
                        e.openNode(this.tag, {
                            type: "colorScale",
                            priority: t.priority
                        }), this.colorScaleXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        d.isPrimitive(t) && (e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority
                        }), this.iconSetXform.render(e, t), e.closeNode());
                    }
                    renderText(e, t) {
                        e.openNode(this.tag, {
                            type: t.operator,
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: n.toStringAttribute(t.operator, "containsText")
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.operator){
                                case "containsText":
                                    return `NOT(ISERROR(SEARCH("${e.text}",${r})))`;
                                case "containsBlanks":
                                    return `LEN(TRIM(${r}))=0`;
                                case "notContainsBlanks":
                                    return `LEN(TRIM(${r}))>0`;
                                case "containsErrors":
                                    return `ISERROR(${r})`;
                                case "notContainsErrors":
                                    return `NOT(ISERROR(${r}))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    renderTimePeriod(e, t) {
                        e.openNode(this.tag, {
                            type: "timePeriod",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            timePeriod: t.timePeriod
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.timePeriod){
                                case "thisWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)<=WEEKDAY(TODAY())-1,ROUNDDOWN(${r},0)-TODAY()<=7-WEEKDAY(TODAY()))`;
                                case "lastWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)>=(WEEKDAY(TODAY())),TODAY()-ROUNDDOWN(${r},0)<(WEEKDAY(TODAY())+7))`;
                                case "nextWeek":
                                    return `AND(ROUNDDOWN(${r},0)-TODAY()>(7-WEEKDAY(TODAY())),ROUNDDOWN(${r},0)-TODAY()<(15-WEEKDAY(TODAY())))`;
                                case "yesterday":
                                    return `FLOOR(${r},1)=TODAY()-1`;
                                case "today":
                                    return `FLOOR(${r},1)=TODAY()`;
                                case "tomorrow":
                                    return `FLOOR(${r},1)=TODAY()+1`;
                                case "last7Days":
                                    return `AND(TODAY()-FLOOR(${r},1)<=6,FLOOR(${r},1)<=TODAY())`;
                                case "lastMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0-1)),YEAR(${r})=YEAR(EDATE(TODAY(),0-1)))`;
                                case "thisMonth":
                                    return `AND(MONTH(${r})=MONTH(TODAY()),YEAR(${r})=YEAR(TODAY()))`;
                                case "nextMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0+1)),YEAR(${r})=YEAR(EDATE(TODAY(),0+1)))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ...f(t),
                            dxfId: n.toIntValue(t.dxfId),
                            priority: n.toIntValue(t.priority),
                            timePeriod: t.timePeriod,
                            percent: n.toBoolValue(t.percent),
                            bottom: n.toBoolValue(t.bottom),
                            rank: n.toIntValue(t.rank),
                            aboveAverage: n.toBoolValue(t.aboveAverage)
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "dataBar":
                            case "extLst":
                            case "colorScale":
                            case "iconSet":
                                Object.assign(this.model, t.model);
                                break;
                            case "formula":
                                this.model.formulae = this.model.formulae || [], this.model.formulae.push(t.model);
                        }
                    }
                }
                t.exports = d;
            },
            {
                "../../../../doc/range": 10,
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./color-scale-xform": 85,
                "./databar-xform": 88,
                "./ext-lst-ref-xform": 89,
                "./formula-xform": 90,
                "./icon-set-xform": 91
            }
        ],
        84: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "cfvo";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            type: t.type,
                            val: t.value
                        });
                    }
                    parseOpen(e) {
                        this.model = {
                            type: e.attributes.type,
                            value: n.toFloatValue(e.attributes.val)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        85: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "colorScale";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.color.forEach((t)=>{
                            this.colorXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            cfvo: [],
                            color: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        86: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfRule: new i
                        };
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    render(e, t) {
                        t.rules.some(i.isPrimitive) && (e.openNode(this.tag, {
                            sqref: t.ref
                        }), t.rules.forEach((r)=>{
                            i.isPrimitive(r) && (r.ref = t.ref, this.map.cfRule.render(e, r));
                        }), e.closeNode());
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ref: t.sqref,
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model.rules.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-xform": 83
            }
        ],
        87: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("./conditional-formatting-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.cfXform = new i;
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    reset() {
                        this.model = [];
                    }
                    prepare(e, t) {
                        let r = e.reduce((e, t)=>Math.max(e, ...t.rules.map((e)=>e.priority || 0)), 1);
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                e.priority || (e.priority = r++), e.style && (e.dxfId = t.styles.addDxfStyle(e.style));
                            });
                        });
                    }
                    render(e, t) {
                        t.forEach((t)=>{
                            this.cfXform.render(e, t);
                        });
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "conditionalFormatting":
                                return this.parser = this.cfXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (!!this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0, !1));
                    }
                    reconcile(e, t) {
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId), delete e.dxfId);
                            });
                        });
                    }
                };
            },
            {
                "../../base-xform": 32,
                "./conditional-formatting-xform": 86
            }
        ],
        88: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.colorXform.render(e, t.color), e.closeNode();
                    }
                    createNewModel() {
                        return {
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "color":
                                this.model.color = t.model;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        89: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform");
                class s extends n {
                    get tag() {
                        return "x14:id";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                }
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:id": this.idXform = new s
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            uri: "{B025F937-C7B1-47D3-B67F-A62EFF666E3E}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.idXform.render(e, t.x14Id), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model.x14Id = t.model;
                    }
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            ext: new o
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map.ext.render(e, t), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48
            }
        ],
        90: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "formula";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        91: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s
                        };
                    }
                    get tag() {
                        return "iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse),
                            showValue: n.toBoolValue(t.showValue),
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cfvo-xform": 84
            }
        ],
        92: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "col";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {});
                        r && (e.styleId = r);
                    }
                    render(e, t) {
                        e.openNode("col"), e.addAttribute("min", t.min), e.addAttribute("max", t.max), t.width && e.addAttribute("width", t.width), t.styleId && e.addAttribute("style", t.styleId), t.hidden && e.addAttribute("hidden", "1"), t.bestFit && e.addAttribute("bestFit", "1"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1"), e.addAttribute("customWidth", "1"), e.closeNode();
                    }
                    parseOpen(e) {
                        if ("col" === e.name) {
                            const t = this.model = {
                                min: parseInt(e.attributes.min || "0", 10),
                                max: parseInt(e.attributes.max || "0", 10),
                                width: void 0 === e.attributes.width ? void 0 : parseFloat(e.attributes.width || "0")
                            };
                            return e.attributes.style && (t.styleId = parseInt(e.attributes.style, 10)), n.parseBoolean(e.attributes.hidden) && (t.hidden = !0), n.parseBoolean(e.attributes.bestFit) && (t.bestFit = !0), e.attributes.outlineLevel && (t.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), n.parseBoolean(e.attributes.collapsed) && (t.collapsed = !0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    reconcile(e, t) {
                        e.styleId && (e.style = t.styles.getStyleModel(e.styleId));
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        93: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/utils"), s = e("../../../utils/col-cache"), o = e("../base-xform"), a = e("../../../doc/range");
                function l(e, t, r, n) {
                    const i = t[r];
                    void 0 !== i ? e[r] = i : void 0 !== n && (e[r] = n);
                }
                function c(e, t, r, n) {
                    const s = t[r];
                    void 0 !== s ? e[r] = i.parseBoolean(s) : void 0 !== n && (e[r] = n);
                }
                t.exports = class extends o {
                    get tag() {
                        return "dataValidations";
                    }
                    render(e, t) {
                        const r = function(e) {
                            const t = n.map(e, (e, t)=>({
                                    address: t,
                                    dataValidation: e,
                                    marked: !1
                                })).sort((e, t)=>n.strcmp(e.address, t.address)), r = n.keyBy(t, "address"), i = (t, r, i)=>{
                                for(let o = 0; o < r; o++){
                                    const r = s.encodeAddress(t.row + o, i);
                                    if (!e[r] || !n.isEqual(e[t.address], e[r])) return !1;
                                }
                                return !0;
                            };
                            return t.map((t)=>{
                                if (!t.marked) {
                                    const o = s.decodeEx(t.address);
                                    if (o.dimensions) return r[o.dimensions].marked = !0, {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                    let a = 1, l = s.encodeAddress(o.row + a, o.col);
                                    for(; e[l] && n.isEqual(t.dataValidation, e[l]);)a++, l = s.encodeAddress(o.row + a, o.col);
                                    let c = 1;
                                    for(; i(o, a, o.col + c);)c++;
                                    for(let e = 0; e < a; e++)for(let t = 0; t < c; t++)l = s.encodeAddress(o.row + e, o.col + t), r[l].marked = !0;
                                    if (a > 1 || c > 1) {
                                        const e = o.row + (a - 1), r = o.col + (c - 1);
                                        return {
                                            ...t.dataValidation,
                                            sqref: `${t.address}:${s.encodeAddress(e, r)}`
                                        };
                                    }
                                    return {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                }
                                return null;
                            }).filter(Boolean);
                        }(t);
                        r.length && (e.openNode("dataValidations", {
                            count: r.length
                        }), r.forEach((t)=>{
                            e.openNode("dataValidation"), "any" !== t.type && (e.addAttribute("type", t.type), t.operator && "list" !== t.type && "between" !== t.operator && e.addAttribute("operator", t.operator), t.allowBlank && e.addAttribute("allowBlank", "1")), t.showInputMessage && e.addAttribute("showInputMessage", "1"), t.promptTitle && e.addAttribute("promptTitle", t.promptTitle), t.prompt && e.addAttribute("prompt", t.prompt), t.showErrorMessage && e.addAttribute("showErrorMessage", "1"), t.errorStyle && e.addAttribute("errorStyle", t.errorStyle), t.errorTitle && e.addAttribute("errorTitle", t.errorTitle), t.error && e.addAttribute("error", t.error), e.addAttribute("sqref", t.sqref), (t.formulae || []).forEach((r, n)=>{
                                e.openNode("formula" + (n + 1)), "date" === t.type ? e.writeText(i.dateToExcel(new Date(r))) : e.writeText(r), e.closeNode();
                            }), e.closeNode();
                        }), e.closeNode());
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "dataValidations":
                                return this.model = {}, !0;
                            case "dataValidation":
                                {
                                    this._address = e.attributes.sqref;
                                    const t = {
                                        type: e.attributes.type || "any",
                                        formulae: []
                                    };
                                    switch(e.attributes.type && c(t, e.attributes, "allowBlank"), c(t, e.attributes, "showInputMessage"), c(t, e.attributes, "showErrorMessage"), t.type){
                                        case "any":
                                        case "list":
                                        case "custom":
                                            break;
                                        default:
                                            l(t, e.attributes, "operator", "between");
                                    }
                                    return l(t, e.attributes, "promptTitle"), l(t, e.attributes, "prompt"), l(t, e.attributes, "errorStyle"), l(t, e.attributes, "errorTitle"), l(t, e.attributes, "error"), this._dataValidation = t, !0;
                                }
                            case "formula1":
                            case "formula2":
                                return this._formula = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._formula && this._formula.push(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "dataValidations":
                                return !1;
                            case "dataValidation":
                                this._dataValidation.formulae && this._dataValidation.formulae.length || (delete this._dataValidation.formulae, delete this._dataValidation.operator);
                                return (this._address.split(/\s+/g) || []).forEach((e)=>{
                                    if (e.includes(":")) new a(e).forEachAddress((e)=>{
                                        this.model[e] = this._dataValidation;
                                    });
                                    else this.model[e] = this._dataValidation;
                                }), !0;
                            case "formula1":
                            case "formula2":
                                {
                                    let e = this._formula.join("");
                                    switch(this._dataValidation.type){
                                        case "whole":
                                        case "textLength":
                                            e = parseInt(e, 10);
                                            break;
                                        case "decimal":
                                            e = parseFloat(e);
                                            break;
                                        case "date":
                                            e = i.excelToDate(parseFloat(e));
                                    }
                                    return this._dataValidation.formulae.push(e), this._formula = void 0, !0;
                                }
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        94: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "dimension";
                    }
                    render(e, t) {
                        t && e.leafNode("dimension", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "dimension" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        95: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "drawing";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        96: [
            function(e, t, r) {
                "use strict";
                const n = e("../composite-xform"), i = e("./cf-ext/conditional-formattings-ext-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormattings": this.conditionalFormattings = new i
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    hasContent(e) {
                        return this.conditionalFormattings.hasContent(e.conditionalFormattings);
                    }
                    prepare(e, t) {
                        this.conditionalFormattings.prepare(e.conditionalFormattings, t);
                    }
                    render(e, t) {
                        e.openNode("ext", {
                            uri: "{78C0D931-6437-407d-A8EE-F0AAD7539E65}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.conditionalFormattings.render(e, t.conditionalFormattings), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                }
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            ext: this.ext = new s
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    prepare(e, t) {
                        this.ext.prepare(e, t);
                    }
                    hasContent(e) {
                        return this.ext.hasContent(e);
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode("extLst"), this.ext.render(e, t), e.closeNode());
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../composite-xform": 48,
                "./cf-ext/conditional-formattings-ext-xform": 78
            }
        ],
        97: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "headerFooter";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback();
                            let r = !1;
                            e.openNode("headerFooter"), t.differentFirst && (e.addAttribute("differentFirst", "1"), r = !0), t.differentOddEven && (e.addAttribute("differentOddEven", "1"), r = !0), t.oddHeader && "string" == typeof t.oddHeader && (e.leafNode("oddHeader", null, t.oddHeader), r = !0), t.oddFooter && "string" == typeof t.oddFooter && (e.leafNode("oddFooter", null, t.oddFooter), r = !0), t.evenHeader && "string" == typeof t.evenHeader && (e.leafNode("evenHeader", null, t.evenHeader), r = !0), t.evenFooter && "string" == typeof t.evenFooter && (e.leafNode("evenFooter", null, t.evenFooter), r = !0), t.firstHeader && "string" == typeof t.firstHeader && (e.leafNode("firstHeader", null, t.firstHeader), r = !0), t.firstFooter && "string" == typeof t.firstFooter && (e.leafNode("firstFooter", null, t.firstFooter), r = !0), r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "headerFooter":
                                return this.model = {}, e.attributes.differentFirst && (this.model.differentFirst = 1 === parseInt(e.attributes.differentFirst, 0)), e.attributes.differentOddEven && (this.model.differentOddEven = 1 === parseInt(e.attributes.differentOddEven, 0)), !0;
                            case "oddHeader":
                                return this.currentNode = "oddHeader", !0;
                            case "oddFooter":
                                return this.currentNode = "oddFooter", !0;
                            case "evenHeader":
                                return this.currentNode = "evenHeader", !0;
                            case "evenFooter":
                                return this.currentNode = "evenFooter", !0;
                            case "firstHeader":
                                return this.currentNode = "firstHeader", !0;
                            case "firstFooter":
                                return this.currentNode = "firstFooter", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        switch(this.currentNode){
                            case "oddHeader":
                                this.model.oddHeader = e;
                                break;
                            case "oddFooter":
                                this.model.oddFooter = e;
                                break;
                            case "evenHeader":
                                this.model.evenHeader = e;
                                break;
                            case "evenFooter":
                                this.model.evenFooter = e;
                                break;
                            case "firstHeader":
                                this.model.firstHeader = e;
                                break;
                            case "firstFooter":
                                this.model.firstFooter = e;
                        }
                    }
                    parseClose() {
                        switch(this.currentNode){
                            case "oddHeader":
                            case "oddFooter":
                            case "evenHeader":
                            case "evenFooter":
                            case "firstHeader":
                            case "firstFooter":
                                return this.currentNode = void 0, !0;
                            default:
                                return !1;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        98: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "hyperlink";
                    }
                    render(e, t) {
                        this.isInternalLink(t) ? e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip,
                            location: t.target
                        }) : e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip
                        });
                    }
                    parseOpen(e) {
                        return "hyperlink" === e.name && (this.model = {
                            address: e.attributes.ref,
                            rId: e.attributes["r:id"],
                            tooltip: e.attributes.tooltip
                        }, e.attributes.location && (this.model.target = e.attributes.location), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    isInternalLink(e) {
                        return e.target && /^[^!]+![a-zA-Z]+[\d]+$/.test(e.target);
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        99: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "mergeCell";
                    }
                    render(e, t) {
                        e.leafNode("mergeCell", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "mergeCell" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        100: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../doc/range"), s = e("../../../utils/col-cache"), o = e("../../../doc/enums");
                t.exports = class {
                    constructor(){
                        this.merges = {};
                    }
                    add(e) {
                        if (this.merges[e.master]) this.merges[e.master].expandToAddress(e.address);
                        else {
                            const t = `${e.master}:${e.address}`;
                            this.merges[e.master] = new i(t);
                        }
                    }
                    get mergeCells() {
                        return n.map(this.merges, (e)=>e.range);
                    }
                    reconcile(e, t) {
                        n.each(e, (e)=>{
                            const r = s.decode(e);
                            for(let e = r.top; e <= r.bottom; e++){
                                const n = t[e - 1];
                                for(let t = r.left; t <= r.right; t++){
                                    const i = n.cells[t - 1];
                                    i ? i.type === o.ValueType.Merge && (i.master = r.tl) : n.cells[t] = {
                                        type: o.ValueType.Null,
                                        address: s.encodeAddress(e, t)
                                    };
                                }
                            }
                        });
                    }
                    getMasterAddress(e) {
                        const t = this.hash[e];
                        return t && t.tl;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26
            }
        ],
        101: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = (e)=>void 0 !== e;
                t.exports = class extends n {
                    get tag() {
                        return "outlinePr";
                    }
                    render(e, t) {
                        return !(!t || !i(t.summaryBelow) && !i(t.summaryRight)) && (e.leafNode(this.tag, {
                            summaryBelow: i(t.summaryBelow) ? Number(t.summaryBelow) : void 0,
                            summaryRight: i(t.summaryRight) ? Number(t.summaryRight) : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            summaryBelow: i(e.attributes.summaryBelow) ? Boolean(Number(e.attributes.summaryBelow)) : void 0,
                            summaryRight: i(e.attributes.summaryRight) ? Boolean(Number(e.attributes.summaryRight)) : void 0
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        102: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "brk";
                    }
                    render(e, t) {
                        e.leafNode("brk", t);
                    }
                    parseOpen(e) {
                        return "brk" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        103: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "pageMargins";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                left: t.left,
                                right: t.right,
                                top: t.top,
                                bottom: t.bottom,
                                header: t.header,
                                footer: t.footer
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    left: parseFloat(e.attributes.left || .7),
                                    right: parseFloat(e.attributes.right || .7),
                                    top: parseFloat(e.attributes.top || .75),
                                    bottom: parseFloat(e.attributes.bottom || .75),
                                    header: parseFloat(e.attributes.header || .3),
                                    footer: parseFloat(e.attributes.footer || .3)
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        104: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "pageSetUpPr";
                    }
                    render(e, t) {
                        return !(!t || !t.fitToPage) && (e.leafNode(this.tag, {
                            fitToPage: t.fitToPage ? "1" : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            fitToPage: "1" === e.attributes.fitToPage
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        105: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                function o(e) {
                    switch(e){
                        case "overThenDown":
                            return e;
                        default:
                            return;
                    }
                }
                function a(e) {
                    switch(e){
                        case "atEnd":
                        case "asDisplyed":
                            return e;
                        default:
                            return;
                    }
                }
                function l(e) {
                    switch(e){
                        case "dash":
                        case "blank":
                        case "NA":
                            return e;
                        default:
                            return;
                    }
                }
                t.exports = class extends i {
                    get tag() {
                        return "pageSetup";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                paperSize: t.paperSize,
                                orientation: t.orientation,
                                horizontalDpi: t.horizontalDpi,
                                verticalDpi: t.verticalDpi,
                                pageOrder: o(t.pageOrder),
                                blackAndWhite: s(t.blackAndWhite),
                                draft: s(t.draft),
                                cellComments: a(t.cellComments),
                                errors: l(t.errors),
                                scale: t.scale,
                                fitToWidth: t.fitToWidth,
                                fitToHeight: t.fitToHeight,
                                firstPageNumber: t.firstPageNumber,
                                useFirstPageNumber: s(t.firstPageNumber),
                                usePrinterDefaults: s(t.usePrinterDefaults),
                                copies: t.copies
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    paperSize: (t = e.attributes.paperSize, void 0 !== t ? parseInt(t, 10) : void 0),
                                    orientation: e.attributes.orientation || "portrait",
                                    horizontalDpi: parseInt(e.attributes.horizontalDpi || "4294967295", 10),
                                    verticalDpi: parseInt(e.attributes.verticalDpi || "4294967295", 10),
                                    pageOrder: e.attributes.pageOrder || "downThenOver",
                                    blackAndWhite: "1" === e.attributes.blackAndWhite,
                                    draft: "1" === e.attributes.draft,
                                    cellComments: e.attributes.cellComments || "None",
                                    errors: e.attributes.errors || "displayed",
                                    scale: parseInt(e.attributes.scale || "100", 10),
                                    fitToWidth: parseInt(e.attributes.fitToWidth || "1", 10),
                                    fitToHeight: parseInt(e.attributes.fitToHeight || "1", 10),
                                    firstPageNumber: parseInt(e.attributes.firstPageNumber || "1", 10),
                                    useFirstPageNumber: "1" === e.attributes.useFirstPageNumber,
                                    usePrinterDefaults: "1" === e.attributes.usePrinterDefaults,
                                    copies: parseInt(e.attributes.copies || "1", 10)
                                }, !0;
                            default:
                                return !1;
                        }
                        var t;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        106: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "picture";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        107: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "printOptions";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                headings: s(t.showRowColHeaders),
                                gridLines: s(t.showGridLines),
                                horizontalCentered: s(t.horizontalCentered),
                                verticalCentered: s(t.verticalCentered)
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    showRowColHeaders: "1" === e.attributes.headings,
                                    showGridLines: "1" === e.attributes.gridLines,
                                    horizontalCentered: "1" === e.attributes.horizontalCentered,
                                    verticalCentered: "1" === e.attributes.verticalCentered
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        108: [
            function(e, t, r) {
                "use strict";
                const n = e("./page-breaks-xform"), i = e("../list-xform");
                t.exports = class extends i {
                    constructor(){
                        super({
                            tag: "rowBreaks",
                            count: !0,
                            childXform: new n
                        });
                    }
                    render(e, t) {
                        if (t && t.length) {
                            e.openNode(this.tag, this.$), this.count && (e.addAttribute(this.$count, t.length), e.addAttribute("manualBreakCount", t.length));
                            const { childXform: r } = this;
                            t.forEach((t)=>{
                                r.render(e, t);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                };
            },
            {
                "../list-xform": 71,
                "./page-breaks-xform": 102
            }
        ],
        109: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./cell-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.maxItems = e && e.maxItems, this.map = {
                            c: new s
                        };
                    }
                    get tag() {
                        return "row";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style);
                        r && (e.styleId = r);
                        const n = this.map.c;
                        e.cells.forEach((e)=>{
                            n.prepare(e, t);
                        });
                    }
                    render(e, t, r) {
                        e.openNode("row"), e.addAttribute("r", t.number), t.height && (e.addAttribute("ht", t.height), e.addAttribute("customHeight", "1")), t.hidden && e.addAttribute("hidden", "1"), t.min > 0 && t.max > 0 && t.min <= t.max && e.addAttribute("spans", `${t.min}:${t.max}`), t.styleId && (e.addAttribute("s", t.styleId), e.addAttribute("customFormat", "1")), e.addAttribute("x14ac:dyDescent", "0.25"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1");
                        const n = this.map.c;
                        t.cells.forEach((t)=>{
                            n.render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if ("row" === e.name) {
                            this.numRowsSeen += 1;
                            const t = e.attributes.spans ? e.attributes.spans.split(":").map((e)=>parseInt(e, 10)) : [
                                void 0,
                                void 0
                            ], r = this.model = {
                                number: parseInt(e.attributes.r, 10),
                                min: t[0],
                                max: t[1],
                                cells: []
                            };
                            return e.attributes.s && (r.styleId = parseInt(e.attributes.s, 10)), i.parseBoolean(e.attributes.hidden) && (r.hidden = !0), i.parseBoolean(e.attributes.bestFit) && (r.bestFit = !0), e.attributes.ht && (r.height = parseFloat(e.attributes.ht)), e.attributes.outlineLevel && (r.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), i.parseBoolean(e.attributes.collapsed) && (r.collapsed = !0), !0;
                        }
                        return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                if (this.model.cells.push(this.parser.model), this.maxItems && this.model.cells.length > this.maxItems) throw new Error(`Max column count (${this.maxItems}) exceeded`);
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        e.style = e.styleId ? t.styles.getStyleModel(e.styleId) : {}, void 0 !== e.styleId && (e.styleId = void 0);
                        const r = this.map.c;
                        e.cells.forEach((e)=>{
                            r.reconcile(e, t);
                        });
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./cell-xform": 73
            }
        ],
        110: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "sheetFormatPr";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                defaultRowHeight: t.defaultRowHeight,
                                outlineLevelRow: t.outlineLevelRow,
                                outlineLevelCol: t.outlineLevelCol,
                                "x14ac:dyDescent": t.dyDescent
                            };
                            t.defaultColWidth && (r.defaultColWidth = t.defaultColWidth), t.defaultRowHeight && 15 === t.defaultRowHeight || (r.customHeight = "1"), n.some(r, (e)=>void 0 !== e) && e.leafNode("sheetFormatPr", r);
                        }
                    }
                    parseOpen(e) {
                        return "sheetFormatPr" === e.name && (this.model = {
                            defaultRowHeight: parseFloat(e.attributes.defaultRowHeight || "0"),
                            dyDescent: parseFloat(e.attributes["x14ac:dyDescent"] || "0"),
                            outlineLevelRow: parseInt(e.attributes.outlineLevelRow || "0", 10),
                            outlineLevelCol: parseInt(e.attributes.outlineLevelCol || "0", 10)
                        }, e.attributes.defaultColWidth && (this.model.defaultColWidth = parseFloat(e.attributes.defaultColWidth)), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        111: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../style/color-xform"), s = e("./page-setup-properties-xform"), o = e("./outline-properties-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            tabColor: new i("tabColor"),
                            pageSetUpPr: new s,
                            outlinePr: new o
                        };
                    }
                    get tag() {
                        return "sheetPr";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback(), e.openNode("sheetPr");
                            let r = !1;
                            r = this.map.tabColor.render(e, t.tabColor) || r, r = this.map.pageSetUpPr.render(e, t.pageSetup) || r, r = this.map.outlinePr.render(e, t.outlineProperties) || r, r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag ? (this.reset(), !0) : !!this.map[e.name] && (this.parser = this.map[e.name], this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        return !!this.parser && (this.parser.parseText(e), !0);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (this.map.tabColor.model || this.map.pageSetUpPr.model || this.map.outlinePr.model ? (this.model = {}, this.map.tabColor.model && (this.model.tabColor = this.map.tabColor.model), this.map.pageSetUpPr.model && (this.model.pageSetup = this.map.pageSetUpPr.model), this.map.outlinePr.model && (this.model.outlineProperties = this.map.outlinePr.model)) : this.model = null, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "../style/color-xform": 128,
                "./outline-properties-xform": 101,
                "./page-setup-properties-xform": 104
            }
        ],
        112: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e, t) {
                    return e ? t : void 0;
                }
                function o(e, t) {
                    return e === t || void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "sheetProtection";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                sheet: s(t.sheet, "1"),
                                selectLockedCells: !1 === t.selectLockedCells ? "1" : void 0,
                                selectUnlockedCells: !1 === t.selectUnlockedCells ? "1" : void 0,
                                formatCells: s(t.formatCells, "0"),
                                formatColumns: s(t.formatColumns, "0"),
                                formatRows: s(t.formatRows, "0"),
                                insertColumns: s(t.insertColumns, "0"),
                                insertRows: s(t.insertRows, "0"),
                                insertHyperlinks: s(t.insertHyperlinks, "0"),
                                deleteColumns: s(t.deleteColumns, "0"),
                                deleteRows: s(t.deleteRows, "0"),
                                sort: s(t.sort, "0"),
                                autoFilter: s(t.autoFilter, "0"),
                                pivotTables: s(t.pivotTables, "0")
                            };
                            t.sheet && (r.algorithmName = t.algorithmName, r.hashValue = t.hashValue, r.saltValue = t.saltValue, r.spinCount = t.spinCount, r.objects = s(!1 === t.objects, "1"), r.scenarios = s(!1 === t.scenarios, "1")), n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    sheet: o(e.attributes.sheet, "1"),
                                    objects: "1" !== e.attributes.objects && void 0,
                                    scenarios: "1" !== e.attributes.scenarios && void 0,
                                    selectLockedCells: "1" !== e.attributes.selectLockedCells && void 0,
                                    selectUnlockedCells: "1" !== e.attributes.selectUnlockedCells && void 0,
                                    formatCells: o(e.attributes.formatCells, "0"),
                                    formatColumns: o(e.attributes.formatColumns, "0"),
                                    formatRows: o(e.attributes.formatRows, "0"),
                                    insertColumns: o(e.attributes.insertColumns, "0"),
                                    insertRows: o(e.attributes.insertRows, "0"),
                                    insertHyperlinks: o(e.attributes.insertHyperlinks, "0"),
                                    deleteColumns: o(e.attributes.deleteColumns, "0"),
                                    deleteRows: o(e.attributes.deleteRows, "0"),
                                    sort: o(e.attributes.sort, "0"),
                                    autoFilter: o(e.attributes.autoFilter, "0"),
                                    pivotTables: o(e.attributes.pivotTables, "0")
                                }, e.attributes.algorithmName && (this.model.algorithmName = e.attributes.algorithmName, this.model.hashValue = e.attributes.hashValue, this.model.saltValue = e.attributes.saltValue, this.model.spinCount = parseInt(e.attributes.spinCount, 10)), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        113: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform"), s = {
                    frozen: "frozen",
                    frozenSplit: "frozen",
                    split: "split"
                };
                t.exports = class extends i {
                    get tag() {
                        return "sheetView";
                    }
                    prepare(e) {
                        switch(e.state){
                            case "frozen":
                            case "split":
                                break;
                            default:
                                e.state = "normal";
                        }
                    }
                    render(e, t) {
                        e.openNode("sheetView", {
                            workbookViewId: t.workbookViewId || 0
                        });
                        const r = function(t, r, n) {
                            n && e.addAttribute(t, r);
                        };
                        let i, s, o, a;
                        switch(r("rightToLeft", "1", !0 === t.rightToLeft), r("tabSelected", "1", t.tabSelected), r("showRuler", "0", !1 === t.showRuler), r("showRowColHeaders", "0", !1 === t.showRowColHeaders), r("showGridLines", "0", !1 === t.showGridLines), r("zoomScale", t.zoomScale, t.zoomScale), r("zoomScaleNormal", t.zoomScaleNormal, t.zoomScaleNormal), r("view", t.style, t.style), t.state){
                            case "frozen":
                                s = t.xSplit || 0, o = t.ySplit || 0, i = t.topLeftCell || n.getAddress(o + 1, s + 1).address, a = (t.xSplit && t.ySplit ? "bottomRight" : t.xSplit && "topRight") || "bottomLeft", e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: i,
                                    activePane: a,
                                    state: "frozen"
                                }), e.leafNode("selection", {
                                    pane: a,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "split":
                                "topLeft" === t.activePane && (t.activePane = void 0), e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: t.topLeftCell,
                                    activePane: t.activePane
                                }), e.leafNode("selection", {
                                    pane: t.activePane,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "normal":
                                t.activeCell && e.leafNode("selection", {
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                        }
                        e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "sheetView":
                                return this.sheetView = {
                                    workbookViewId: parseInt(e.attributes.workbookViewId, 10),
                                    rightToLeft: "1" === e.attributes.rightToLeft,
                                    tabSelected: "1" === e.attributes.tabSelected,
                                    showRuler: !("0" === e.attributes.showRuler),
                                    showRowColHeaders: !("0" === e.attributes.showRowColHeaders),
                                    showGridLines: !("0" === e.attributes.showGridLines),
                                    zoomScale: parseInt(e.attributes.zoomScale || "100", 10),
                                    zoomScaleNormal: parseInt(e.attributes.zoomScaleNormal || "100", 10),
                                    style: e.attributes.view
                                }, this.pane = void 0, this.selections = {}, !0;
                            case "pane":
                                return this.pane = {
                                    xSplit: parseInt(e.attributes.xSplit || "0", 10),
                                    ySplit: parseInt(e.attributes.ySplit || "0", 10),
                                    topLeftCell: e.attributes.topLeftCell,
                                    activePane: e.attributes.activePane || "topLeft",
                                    state: e.attributes.state
                                }, !0;
                            case "selection":
                                {
                                    const t = e.attributes.pane || "topLeft";
                                    return this.selections[t] = {
                                        pane: t,
                                        activeCell: e.attributes.activeCell
                                    }, !0;
                                }
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        let t, r;
                        switch(e){
                            case "sheetView":
                                return this.sheetView && this.pane ? (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: s[this.pane.state] || "split",
                                    xSplit: this.pane.xSplit,
                                    ySplit: this.pane.ySplit,
                                    topLeftCell: this.pane.topLeftCell,
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, "split" === this.model.state && (t.activePane = this.pane.activePane), r = this.selections[this.pane.activePane], r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)) : (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: "normal",
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, r = this.selections.topLeft, r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile() {}
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        114: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tablePart";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        115: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../../rel-type"), a = e("./merges"), l = e("../base-xform"), c = e("../list-xform"), u = e("./row-xform"), h = e("./col-xform"), f = e("./dimension-xform"), d = e("./hyperlink-xform"), p = e("./merge-cell-xform"), m = e("./data-validations-xform"), b = e("./sheet-properties-xform"), g = e("./sheet-format-properties-xform"), y = e("./sheet-view-xform"), v = e("./sheet-protection-xform"), w = e("./page-margins-xform"), _ = e("./page-setup-xform"), x = e("./print-options-xform"), k = e("./auto-filter-xform"), S = e("./picture-xform"), M = e("./drawing-xform"), C = e("./table-part-xform"), T = e("./row-breaks-xform"), E = e("./header-footer-xform"), A = e("./cf/conditional-formattings-xform"), R = e("./ext-lst-xform"), O = (e, t)=>{
                    if (!t || !t.length) return e;
                    if (!e || !e.length) return t;
                    const r = {}, n = {};
                    return e.forEach((e)=>{
                        r[e.ref] = e, e.rules.forEach((e)=>{
                            const { x14Id: t } = e;
                            t && (n[t] = e);
                        });
                    }), t.forEach((t)=>{
                        t.rules.forEach((i)=>{
                            const s = n[i.x14Id];
                            s ? ((e, t)=>{
                                Object.keys(t).forEach((r)=>{
                                    const n = e[r], i = t[r];
                                    void 0 === n && void 0 !== i && (e[r] = i);
                                });
                            })(s, i) : r[t.ref] ? r[t.ref].rules.push(i) : e.push({
                                ref: t.ref,
                                rules: [
                                    i
                                ]
                            });
                        });
                    }), e;
                };
                class j extends l {
                    constructor(e){
                        super();
                        const { maxRows: t, maxCols: r, ignoreNodes: n } = e || {};
                        this.ignoreNodes = n || [], this.map = {
                            sheetPr: new b,
                            dimension: new f,
                            sheetViews: new c({
                                tag: "sheetViews",
                                count: !1,
                                childXform: new y
                            }),
                            sheetFormatPr: new g,
                            cols: new c({
                                tag: "cols",
                                count: !1,
                                childXform: new h
                            }),
                            sheetData: new c({
                                tag: "sheetData",
                                count: !1,
                                empty: !0,
                                childXform: new u({
                                    maxItems: r
                                }),
                                maxItems: t
                            }),
                            autoFilter: new k,
                            mergeCells: new c({
                                tag: "mergeCells",
                                count: !0,
                                childXform: new p
                            }),
                            rowBreaks: new T,
                            hyperlinks: new c({
                                tag: "hyperlinks",
                                count: !1,
                                childXform: new d
                            }),
                            pageMargins: new w,
                            dataValidations: new m,
                            pageSetup: new _,
                            headerFooter: new E,
                            printOptions: new x,
                            picture: new S,
                            drawing: new M,
                            sheetProtection: new v,
                            tableParts: new c({
                                tag: "tableParts",
                                count: !0,
                                childXform: new C
                            }),
                            conditionalFormatting: new A,
                            extLst: new R
                        };
                    }
                    prepare(e, t) {
                        t.merges = new a, e.hyperlinks = t.hyperlinks = [], e.comments = t.comments = [], t.formulae = {}, t.siFormulae = 0, this.map.cols.prepare(e.cols, t), this.map.sheetData.prepare(e.rows, t), this.map.conditionalFormatting.prepare(e.conditionalFormattings, t), e.mergeCells = t.merges.mergeCells;
                        const r = e.rels = [];
                        function n(e) {
                            return "rId" + (e.length + 1);
                        }
                        if (e.hyperlinks.forEach((e)=>{
                            const t = n(r);
                            e.rId = t, r.push({
                                Id: t,
                                Type: o.Hyperlink,
                                Target: e.target,
                                TargetMode: "External"
                            });
                        }), e.comments.length > 0) {
                            const s = {
                                Id: n(r),
                                Type: o.Comments,
                                Target: `../comments${e.id}.xml`
                            };
                            r.push(s);
                            const a = {
                                Id: n(r),
                                Type: o.VmlDrawing,
                                Target: `../drawings/vmlDrawing${e.id}.vml`
                            };
                            r.push(a), e.comments.forEach((e)=>{
                                e.refAddress = i.decodeAddress(e.ref);
                            }), t.commentRefs.push({
                                commentName: "comments" + e.id,
                                vmlDrawing: "vmlDrawing" + e.id
                            });
                        }
                        const s = [];
                        let l;
                        e.media.forEach((i)=>{
                            if ("background" === i.type) {
                                const s = n(r);
                                l = t.media[i.imageId], r.push({
                                    Id: s,
                                    Type: o.Image,
                                    Target: `../media/${l.name}.${l.extension}`
                                }), e.background = {
                                    rId: s
                                }, e.image = t.media[i.imageId];
                            } else if ("image" === i.type) {
                                let { drawing: a } = e;
                                l = t.media[i.imageId], a || (a = e.drawing = {
                                    rId: n(r),
                                    name: "drawing" + ++t.drawingsCount,
                                    anchors: [],
                                    rels: []
                                }, t.drawings.push(a), r.push({
                                    Id: a.rId,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
                                    Target: `../drawings/${a.name}.xml`
                                }));
                                let c = this.preImageId === i.imageId ? s[i.imageId] : s[a.rels.length];
                                c || (c = n(a.rels), s[a.rels.length] = c, a.rels.push({
                                    Id: c,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                                    Target: `../media/${l.name}.${l.extension}`
                                }));
                                const u = {
                                    picture: {
                                        rId: c
                                    },
                                    range: i.range
                                };
                                if (i.hyperlinks && i.hyperlinks.hyperlink) {
                                    const e = n(a.rels);
                                    s[a.rels.length] = e, u.picture.hyperlinks = {
                                        tooltip: i.hyperlinks.tooltip,
                                        rId: e
                                    }, a.rels.push({
                                        Id: e,
                                        Type: o.Hyperlink,
                                        Target: i.hyperlinks.hyperlink,
                                        TargetMode: "External"
                                    });
                                }
                                this.preImageId = i.imageId, a.anchors.push(u);
                            }
                        }), e.tables.forEach((e)=>{
                            const i = n(r);
                            e.rId = i, r.push({
                                Id: i,
                                Type: o.Table,
                                Target: "../tables/" + e.target
                            }), e.columns.forEach((e)=>{
                                const { style: r } = e;
                                r && (e.dxfId = t.styles.addDxfStyle(r));
                            });
                        }), this.map.extLst.prepare(e, t);
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("worksheet", j.WORKSHEET_ATTRIBUTES);
                        const r = t.properties ? {
                            defaultRowHeight: t.properties.defaultRowHeight,
                            dyDescent: t.properties.dyDescent,
                            outlineLevelCol: t.properties.outlineLevelCol,
                            outlineLevelRow: t.properties.outlineLevelRow
                        } : void 0;
                        t.properties && t.properties.defaultColWidth && (r.defaultColWidth = t.properties.defaultColWidth);
                        const n = {
                            outlineProperties: t.properties && t.properties.outlineProperties,
                            tabColor: t.properties && t.properties.tabColor,
                            pageSetup: t.pageSetup && t.pageSetup.fitToPage ? {
                                fitToPage: t.pageSetup.fitToPage
                            } : void 0
                        }, i = t.pageSetup && t.pageSetup.margins, a = {
                            showRowColHeaders: t.pageSetup && t.pageSetup.showRowColHeaders,
                            showGridLines: t.pageSetup && t.pageSetup.showGridLines,
                            horizontalCentered: t.pageSetup && t.pageSetup.horizontalCentered,
                            verticalCentered: t.pageSetup && t.pageSetup.verticalCentered
                        }, l = t.sheetProtection;
                        this.map.sheetPr.render(e, n), this.map.dimension.render(e, t.dimensions), this.map.sheetViews.render(e, t.views), this.map.sheetFormatPr.render(e, r), this.map.cols.render(e, t.cols), this.map.sheetData.render(e, t.rows), this.map.sheetProtection.render(e, l), this.map.autoFilter.render(e, t.autoFilter), this.map.mergeCells.render(e, t.mergeCells), this.map.conditionalFormatting.render(e, t.conditionalFormattings), this.map.dataValidations.render(e, t.dataValidations), this.map.hyperlinks.render(e, t.hyperlinks), this.map.printOptions.render(e, a), this.map.pageMargins.render(e, i), this.map.pageSetup.render(e, t.pageSetup), this.map.headerFooter.render(e, t.headerFooter), this.map.rowBreaks.render(e, t.rowBreaks), this.map.drawing.render(e, t.drawing), this.map.picture.render(e, t.background), this.map.tableParts.render(e, t.tables), this.map.extLst.render(e, t), t.rels && t.rels.forEach((t)=>{
                            t.Type === o.VmlDrawing && e.leafNode("legacyDrawing", {
                                "r:id": t.Id
                            });
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : "worksheet" === e.name ? (n.each(this.map, (e)=>{
                            e.reset();
                        }), !0) : (this.map[e.name] && !this.ignoreNodes.includes(e.name) && (this.parser = this.map[e.name], this.parser.parseOpen(e)), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "worksheet":
                                {
                                    const e = this.map.sheetFormatPr.model || {};
                                    this.map.sheetPr.model && this.map.sheetPr.model.tabColor && (e.tabColor = this.map.sheetPr.model.tabColor), this.map.sheetPr.model && this.map.sheetPr.model.outlineProperties && (e.outlineProperties = this.map.sheetPr.model.outlineProperties);
                                    const t = {
                                        fitToPage: this.map.sheetPr.model && this.map.sheetPr.model.pageSetup && this.map.sheetPr.model.pageSetup.fitToPage || !1,
                                        margins: this.map.pageMargins.model
                                    }, r = Object.assign(t, this.map.pageSetup.model, this.map.printOptions.model), n = O(this.map.conditionalFormatting.model, this.map.extLst.model && this.map.extLst.model["x14:conditionalFormattings"]);
                                    return this.model = {
                                        dimensions: this.map.dimension.model,
                                        cols: this.map.cols.model,
                                        rows: this.map.sheetData.model,
                                        mergeCells: this.map.mergeCells.model,
                                        hyperlinks: this.map.hyperlinks.model,
                                        dataValidations: this.map.dataValidations.model,
                                        properties: e,
                                        views: this.map.sheetViews.model,
                                        pageSetup: r,
                                        headerFooter: this.map.headerFooter.model,
                                        background: this.map.picture.model,
                                        drawing: this.map.drawing.model,
                                        tables: this.map.tableParts.model,
                                        conditionalFormattings: n
                                    }, this.map.autoFilter.model && (this.model.autoFilter = this.map.autoFilter.model), this.map.sheetProtection.model && (this.model.sheetProtection = this.map.sheetProtection.model), !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        const r = (e.relationships || []).reduce((r, n)=>{
                            if (r[n.Id] = n, n.Type === o.Comments && (e.comments = t.comments[n.Target].comments), n.Type === o.VmlDrawing && e.comments && e.comments.length) {
                                const r = t.vmlDrawings[n.Target].comments;
                                e.comments.forEach((e, t)=>{
                                    e.note = Object.assign({}, e.note, r[t]);
                                });
                            }
                            return r;
                        }, {});
                        if (t.commentsMap = (e.comments || []).reduce((e, t)=>(t.ref && (e[t.ref] = t), e), {}), t.hyperlinkMap = (e.hyperlinks || []).reduce((e, t)=>(t.rId && (e[t.address] = r[t.rId].Target), e), {}), t.formulae = {}, e.rows = e.rows && e.rows.filter(Boolean) || [], e.rows.forEach((e)=>{
                            e.cells = e.cells && e.cells.filter(Boolean) || [];
                        }), this.map.cols.reconcile(e.cols, t), this.map.sheetData.reconcile(e.rows, t), this.map.conditionalFormatting.reconcile(e.conditionalFormattings, t), e.media = [], e.drawing) {
                            const n = r[e.drawing.rId].Target.match(/\/drawings\/([a-zA-Z0-9]+)[.][a-zA-Z]{3,4}$/);
                            if (n) {
                                const r = n[1];
                                t.drawings[r].anchors.forEach((t)=>{
                                    if (t.medium) {
                                        const r = {
                                            type: "image",
                                            imageId: t.medium.index,
                                            range: t.range,
                                            hyperlinks: t.picture.hyperlinks
                                        };
                                        e.media.push(r);
                                    }
                                });
                            }
                        }
                        const n = e.background && r[e.background.rId];
                        if (n) {
                            const r = n.Target.split("/media/")[1], i = t.mediaIndex && t.mediaIndex[r];
                            void 0 !== i && e.media.push({
                                type: "background",
                                imageId: i
                            });
                        }
                        e.tables = (e.tables || []).map((e)=>{
                            const n = r[e.rId];
                            return t.tables[n.Target];
                        }), delete e.relationships, delete e.hyperlinks, delete e.comments;
                    }
                }
                j.WORKSHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"
                }, t.exports = j;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../../rel-type": 31,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 72,
                "./cf/conditional-formattings-xform": 87,
                "./col-xform": 92,
                "./data-validations-xform": 93,
                "./dimension-xform": 94,
                "./drawing-xform": 95,
                "./ext-lst-xform": 96,
                "./header-footer-xform": 97,
                "./hyperlink-xform": 98,
                "./merge-cell-xform": 99,
                "./merges": 100,
                "./page-margins-xform": 103,
                "./page-setup-xform": 105,
                "./picture-xform": 106,
                "./print-options-xform": 107,
                "./row-breaks-xform": 108,
                "./row-xform": 109,
                "./sheet-format-properties-xform": 110,
                "./sheet-properties-xform": 111,
                "./sheet-protection-xform": 112,
                "./sheet-view-xform": 113,
                "./table-part-xform": 114
            }
        ],
        116: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr;
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.model = !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        117: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this._format = e.format || function(e) {
                            try {
                                return Number.isNaN(e.getTime()) ? "" : e.toISOString();
                            } catch (e) {
                                return "";
                            }
                        }, this._parse = e.parse || function(e) {
                            return new Date(e);
                        };
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, this._format(t)) : e.writeText(this._format(t)), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = this._parse(e.attributes[this.attr]) : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this._parse(this.text.join(""))), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        118: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this.zero = e.zero;
                    }
                    render(e, t) {
                        (t || this.zero) && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.attr ? this.model = parseInt(e.attributes[this.attr], 10) : this.text = [], !0);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = parseInt(this.text.join("") || 0, 10)), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        119: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs;
                    }
                    render(e, t) {
                        void 0 !== t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = e.attributes[this.attr] : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this.text.join("")), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        120: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform"), i = e("../../utils/xml-stream");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    render(e) {
                        if (!this._xml) {
                            const e = new i;
                            !function e(t, r) {
                                t.openNode(r.tag, r.$), r.c && r.c.forEach((r)=>{
                                    e(t, r);
                                }), r.t && t.writeText(r.t), t.closeNode();
                            }(e, this._model), this._xml = e.xml;
                        }
                        e.writeXml(this._xml);
                    }
                    parseOpen() {
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this._model.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../utils/xml-stream": 28,
                "./base-xform": 32
            }
        ],
        121: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("../base-xform");
                t.exports = class extends s {
                    constructor(){
                        super(), this.map = {
                            r: new i,
                            t: new n
                        };
                    }
                    get tag() {
                        return "rPh";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag, {
                            sb: t.sb || 0,
                            eb: t.eb || 0
                        }), t && t.hasOwnProperty("richText") && t.richText) {
                            const { r: r } = this.map;
                            t.richText.forEach((t)=>{
                                r.render(e, t);
                            });
                        } else t && this.map.t.render(e, t.text);
                        e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {
                            sb: parseInt(e.attributes.sb, 10),
                            eb: parseInt(e.attributes.eb, 10)
                        }, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model.text = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        122: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("../style/font-xform"), s = e("../base-xform");
                class o extends s {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "r";
                    }
                    get textXform() {
                        return this._textXform || (this._textXform = new n);
                    }
                    get fontXform() {
                        return this._fontXform || (this._fontXform = new i(o.FONT_OPTIONS));
                    }
                    render(e, t) {
                        t = t || this.model, e.openNode("r"), t.font && this.fontXform.render(e, t.font), this.textXform.render(e, t.text), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "r":
                                return this.model = {}, !0;
                            case "t":
                                return this.parser = this.textXform, this.parser.parseOpen(e), !0;
                            case "rPr":
                                return this.parser = this.fontXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "r":
                                return !1;
                            case "t":
                                return this.model.text = this.parser.model, this.parser = void 0, !0;
                            case "rPr":
                                return this.model.font = this.parser.model, this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                }
                o.FONT_OPTIONS = {
                    tagName: "rPr",
                    fontNameTag: "rFont"
                }, t.exports = o;
            },
            {
                "../base-xform": 32,
                "../style/font-xform": 131,
                "./text-xform": 125
            }
        ],
        123: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("./phonetic-text-xform"), o = e("../base-xform");
                t.exports = class extends o {
                    constructor(e){
                        super(), this.model = e, this.map = {
                            r: new i,
                            t: new n,
                            rPh: new s
                        };
                    }
                    get tag() {
                        return "si";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t && t.hasOwnProperty("richText") && t.richText ? t.richText.length ? t.richText.forEach((t)=>{
                            this.map.r.render(e, t);
                        }) : this.map.t.render(e, "") : null != t && this.map.t.render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {}, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./phonetic-text-xform": 121,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        124: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./shared-string-xform");
                t.exports = class extends i {
                    constructor(e){
                        super(), this.model = e || {
                            values: [],
                            count: 0
                        }, this.hash = Object.create(null), this.rich = Object.create(null);
                    }
                    get sharedStringXform() {
                        return this._sharedStringXform || (this._sharedStringXform = new s);
                    }
                    get values() {
                        return this.model.values;
                    }
                    get uniqueCount() {
                        return this.model.values.length;
                    }
                    get count() {
                        return this.model.count;
                    }
                    getString(e) {
                        return this.model.values[e];
                    }
                    add(e) {
                        return e.richText ? this.addRichText(e) : this.addText(e);
                    }
                    addText(e) {
                        let t = this.hash[e];
                        return void 0 === t && (t = this.hash[e] = this.model.values.length, this.model.values.push(e)), this.model.count++, t;
                    }
                    addRichText(e) {
                        const t = this.sharedStringXform.toXml(e);
                        let r = this.rich[t];
                        return void 0 === r && (r = this.rich[t] = this.model.values.length, this.model.values.push(e)), this.model.count++, r;
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("sst", {
                            xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                            count: t.count,
                            uniqueCount: t.values.length
                        });
                        const r = this.sharedStringXform;
                        t.values.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "sst":
                                return !0;
                            case "si":
                                return this.parser = this.sharedStringXform, this.parser.parseOpen(e), !0;
                            default:
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.values.push(this.parser.model), this.model.count++, this.parser = void 0), !0;
                        switch(e){
                            case "sst":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./shared-string-xform": 123
            }
        ],
        125: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "t";
                    }
                    render(e, t) {
                        e.openNode("t"), /^\s|\n|\s$/.test(t) && e.addAttribute("xml:space", "preserve"), e.writeText(t), e.closeNode();
                    }
                    get model() {
                        return this._text.join("").replace(/_x([0-9A-F]{4})_/g, (e, t)=>String.fromCharCode(parseInt(t, 16)));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "t":
                                return this._text = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._text.push(e);
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        126: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/utils"), s = e("../base-xform"), o = {
                    horizontalValues: [
                        "left",
                        "center",
                        "right",
                        "fill",
                        "centerContinuous",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    horizontal (e) {
                        return this.horizontalValues[e] ? e : void 0;
                    },
                    verticalValues: [
                        "top",
                        "middle",
                        "bottom",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    vertical (e) {
                        return "middle" === e ? "center" : this.verticalValues[e] ? e : void 0;
                    },
                    wrapText: (e)=>!!e || void 0,
                    shrinkToFit: (e)=>!!e || void 0,
                    textRotation (e) {
                        switch(e){
                            case "vertical":
                                return e;
                            default:
                                return (e = i.validInt(e)) >= -90 && e <= 90 ? e : void 0;
                        }
                    },
                    indent: (e)=>(e = i.validInt(e), Math.max(0, e)),
                    readingOrder (e) {
                        switch(e){
                            case "ltr":
                                return n.ReadingOrder.LeftToRight;
                            case "rtl":
                                return n.ReadingOrder.RightToLeft;
                            default:
                                return;
                        }
                    }
                }, a = {
                    toXml (e) {
                        if (e = o.textRotation(e)) {
                            if ("vertical" === e) return 255;
                            const t = Math.round(e);
                            if (t >= 0 && t <= 90) return t;
                            if (t < 0 && t >= -90) return 90 - t;
                        }
                    },
                    toModel (e) {
                        const t = i.validInt(e);
                        if (void 0 !== t) {
                            if (255 === t) return "vertical";
                            if (t >= 0 && t <= 90) return t;
                            if (t > 90 && t <= 180) return 90 - t;
                        }
                    }
                };
                t.exports = class extends s {
                    get tag() {
                        return "alignment";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("alignment");
                        let r = !1;
                        function n(t, n) {
                            n && (e.addAttribute(t, n), r = !0);
                        }
                        n("horizontal", o.horizontal(t.horizontal)), n("vertical", o.vertical(t.vertical)), n("wrapText", !!o.wrapText(t.wrapText) && "1"), n("shrinkToFit", !!o.shrinkToFit(t.shrinkToFit) && "1"), n("indent", o.indent(t.indent)), n("textRotation", a.toXml(t.textRotation)), n("readingOrder", o.readingOrder(t.readingOrder)), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {};
                        let r = !1;
                        function n(e, n, i) {
                            e && (t[n] = i, r = !0);
                        }
                        n(e.attributes.horizontal, "horizontal", e.attributes.horizontal), n(e.attributes.vertical, "vertical", "center" === e.attributes.vertical ? "middle" : e.attributes.vertical), n(e.attributes.wrapText, "wrapText", i.parseBoolean(e.attributes.wrapText)), n(e.attributes.shrinkToFit, "shrinkToFit", i.parseBoolean(e.attributes.shrinkToFit)), n(e.attributes.indent, "indent", parseInt(e.attributes.indent, 10)), n(e.attributes.textRotation, "textRotation", a.toModel(e.attributes.textRotation)), n(e.attributes.readingOrder, "readingOrder", "2" === e.attributes.readingOrder ? "rtl" : "ltr"), this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        127: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./color-xform");
                class o extends n {
                    constructor(e){
                        super(), this.name = e, this.map = {
                            color: new s
                        };
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t, r) {
                        const n = t && t.color || r || this.defaultColor;
                        e.openNode(this.name), t && t.style && (e.addAttribute("style", t.style), n && this.map.color.render(e, n)), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.name:
                                {
                                    const { style: t } = e.attributes;
                                    return this.model = t ? {
                                        style: t
                                    } : void 0, !0;
                                }
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (e === this.name && this.map.color.model && (this.model || (this.model = {}), this.model.color = this.map.color.model), !1);
                    }
                    validStyle(e) {
                        return o.validStyleValues[e];
                    }
                }
                o.validStyleValues = [
                    "thin",
                    "dashed",
                    "dotted",
                    "dashDot",
                    "hair",
                    "dashDotDot",
                    "slantDashDot",
                    "mediumDashed",
                    "mediumDashDotDot",
                    "mediumDashDot",
                    "medium",
                    "double",
                    "thick"
                ].reduce((e, t)=>(e[t] = !0, e), {});
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            top: new o("top"),
                            left: new o("left"),
                            bottom: new o("bottom"),
                            right: new o("right"),
                            diagonal: new o("diagonal")
                        };
                    }
                    render(e, t) {
                        const { color: r } = t;
                        function n(n, i) {
                            n && !n.color && t.color && (n = {
                                ...n,
                                color: t.color
                            }), i.render(e, n, r);
                        }
                        e.openNode("border"), t.diagonal && t.diagonal.style && (t.diagonal.up && e.addAttribute("diagonalUp", "1"), t.diagonal.down && e.addAttribute("diagonalDown", "1")), n(t.left, this.map.left), n(t.right, this.map.right), n(t.top, this.map.top), n(t.bottom, this.map.bottom), n(t.diagonal, this.map.diagonal), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "border":
                                return this.reset(), this.diagonalUp = i.parseBoolean(e.attributes.diagonalUp), this.diagonalDown = i.parseBoolean(e.attributes.diagonalDown), !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        if ("border" === e) {
                            const e = this.model = {}, t = function(t, r, n) {
                                r && (n && Object.assign(r, n), e[t] = r);
                            };
                            t("left", this.map.left.model), t("right", this.map.right.model), t("top", this.map.top.model), t("bottom", this.map.bottom.model), t("diagonal", this.map.diagonal.model, {
                                up: this.diagonalUp,
                                down: this.diagonalDown
                            });
                        }
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        128: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.name = e || "color";
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t) {
                        return !!t && (e.openNode(this.name), t.argb ? e.addAttribute("rgb", t.argb) : void 0 !== t.theme ? (e.addAttribute("theme", t.theme), void 0 !== t.tint && e.addAttribute("tint", t.tint)) : void 0 !== t.indexed ? e.addAttribute("indexed", t.indexed) : e.addAttribute("auto", "1"), e.closeNode(), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.name && (e.attributes.rgb ? this.model = {
                            argb: e.attributes.rgb
                        } : e.attributes.theme ? (this.model = {
                            theme: parseInt(e.attributes.theme, 10)
                        }, e.attributes.tint && (this.model.tint = parseFloat(e.attributes.tint))) : e.attributes.indexed ? this.model = {
                            indexed: parseInt(e.attributes.indexed, 10)
                        } : this.model = void 0, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        129: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./border-xform"), o = e("./fill-xform"), a = e("./font-xform"), l = e("./numfmt-xform"), c = e("./protection-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            alignment: new i,
                            border: new s,
                            fill: new o,
                            font: new a,
                            numFmt: new l,
                            protection: new c
                        };
                    }
                    get tag() {
                        return "dxf";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag), t.font && this.map.font.render(e, t.font), t.numFmt && t.numFmtId) {
                            const r = {
                                id: t.numFmtId,
                                formatCode: t.numFmt
                            };
                            this.map.numFmt.render(e, r);
                        }
                        t.fill && this.map.fill.render(e, t.fill), t.alignment && this.map.alignment.render(e, t.alignment), t.border && this.map.border.render(e, t.border), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.reset(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : e !== this.tag || (this.model = {
                            alignment: this.map.alignment.model,
                            border: this.map.border.model,
                            fill: this.map.fill.model,
                            font: this.map.font.model,
                            numFmt: this.map.numFmt.model,
                            protection: this.map.protection.model
                        }, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./border-xform": 127,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./protection-xform": 133
            }
        ],
        130: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./color-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            color: new i
                        };
                    }
                    get tag() {
                        return "stop";
                    }
                    render(e, t) {
                        e.openNode("stop"), e.addAttribute("position", t.position), this.map.color.render(e, t.color), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "stop":
                                return this.model = {
                                    position: parseFloat(e.attributes.position)
                                }, !0;
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.color = this.parser.model, this.parser = void 0), !0);
                    }
                }
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            fgColor: new i("fgColor"),
                            bgColor: new i("bgColor")
                        };
                    }
                    get name() {
                        return "pattern";
                    }
                    get tag() {
                        return "patternFill";
                    }
                    render(e, t) {
                        e.openNode("patternFill"), e.addAttribute("patternType", t.pattern), t.fgColor && this.map.fgColor.render(e, t.fgColor), t.bgColor && this.map.bgColor.render(e, t.bgColor), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "patternFill":
                                return this.model = {
                                    type: "pattern",
                                    pattern: e.attributes.patternType
                                }, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.parser.model && (this.model[e] = this.parser.model), this.parser = void 0), !0);
                    }
                }
                class a extends n {
                    constructor(){
                        super(), this.map = {
                            stop: new s
                        };
                    }
                    get name() {
                        return "gradient";
                    }
                    get tag() {
                        return "gradientFill";
                    }
                    render(e, t) {
                        switch(e.openNode("gradientFill"), t.gradient){
                            case "angle":
                                e.addAttribute("degree", t.degree);
                                break;
                            case "path":
                                e.addAttribute("type", "path"), t.center.left && (e.addAttribute("left", t.center.left), void 0 === t.center.right && e.addAttribute("right", t.center.left)), t.center.right && e.addAttribute("right", t.center.right), t.center.top && (e.addAttribute("top", t.center.top), void 0 === t.center.bottom && e.addAttribute("bottom", t.center.top)), t.center.bottom && e.addAttribute("bottom", t.center.bottom);
                        }
                        const r = this.map.stop;
                        t.stops.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "gradientFill":
                                {
                                    const t = this.model = {
                                        stops: []
                                    };
                                    return e.attributes.degree ? (t.gradient = "angle", t.degree = parseInt(e.attributes.degree, 10)) : "path" === e.attributes.type && (t.gradient = "path", t.center = {
                                        left: e.attributes.left ? parseFloat(e.attributes.left) : 0,
                                        top: e.attributes.top ? parseFloat(e.attributes.top) : 0
                                    }, e.attributes.right !== e.attributes.left && (t.center.right = e.attributes.right ? parseFloat(e.attributes.right) : 0), e.attributes.bottom !== e.attributes.top && (t.center.bottom = e.attributes.bottom ? parseFloat(e.attributes.bottom) : 0)), !0;
                                }
                            case "stop":
                                return this.parser = this.map.stop, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.stops.push(this.parser.model), this.parser = void 0), !0);
                    }
                }
                class l extends n {
                    constructor(){
                        super(), this.map = {
                            patternFill: new o,
                            gradientFill: new a
                        };
                    }
                    get tag() {
                        return "fill";
                    }
                    render(e, t) {
                        switch(e.addRollback(), e.openNode("fill"), t.type){
                            case "pattern":
                                this.map.patternFill.render(e, t);
                                break;
                            case "gradient":
                                this.map.gradientFill.render(e, t);
                                break;
                            default:
                                return void e.rollback();
                        }
                        e.closeNode(), e.commit();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "fill":
                                return this.model = {}, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model = this.parser.model, this.model.type = this.parser.name, this.parser = void 0), !0);
                    }
                    validStyle(e) {
                        return l.validPatternValues[e];
                    }
                }
                l.validPatternValues = [
                    "none",
                    "solid",
                    "darkVertical",
                    "darkGray",
                    "mediumGray",
                    "lightGray",
                    "gray125",
                    "gray0625",
                    "darkHorizontal",
                    "darkVertical",
                    "darkDown",
                    "darkUp",
                    "darkGrid",
                    "darkTrellis",
                    "lightHorizontal",
                    "lightVertical",
                    "lightDown",
                    "lightUp",
                    "lightGrid",
                    "lightTrellis",
                    "lightGrid"
                ].reduce((e, t)=>(e[t] = !0, e), {}), l.StopXform = s, l.PatternFillXform = o, l.GradientFillXform = a, t.exports = l;
            },
            {
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        131: [
            function(e, t, r) {
                "use strict";
                const n = e("./color-xform"), i = e("../simple/boolean-xform"), s = e("../simple/integer-xform"), o = e("../simple/string-xform"), a = e("./underline-xform"), l = e("../../../utils/under-dash"), c = e("../base-xform");
                class u extends c {
                    constructor(e){
                        super(), this.options = e || u.OPTIONS, this.map = {
                            b: {
                                prop: "bold",
                                xform: new i({
                                    tag: "b",
                                    attr: "val"
                                })
                            },
                            i: {
                                prop: "italic",
                                xform: new i({
                                    tag: "i",
                                    attr: "val"
                                })
                            },
                            u: {
                                prop: "underline",
                                xform: new a
                            },
                            charset: {
                                prop: "charset",
                                xform: new s({
                                    tag: "charset",
                                    attr: "val"
                                })
                            },
                            color: {
                                prop: "color",
                                xform: new n
                            },
                            condense: {
                                prop: "condense",
                                xform: new i({
                                    tag: "condense",
                                    attr: "val"
                                })
                            },
                            extend: {
                                prop: "extend",
                                xform: new i({
                                    tag: "extend",
                                    attr: "val"
                                })
                            },
                            family: {
                                prop: "family",
                                xform: new s({
                                    tag: "family",
                                    attr: "val"
                                })
                            },
                            outline: {
                                prop: "outline",
                                xform: new i({
                                    tag: "outline",
                                    attr: "val"
                                })
                            },
                            vertAlign: {
                                prop: "vertAlign",
                                xform: new o({
                                    tag: "vertAlign",
                                    attr: "val"
                                })
                            },
                            scheme: {
                                prop: "scheme",
                                xform: new o({
                                    tag: "scheme",
                                    attr: "val"
                                })
                            },
                            shadow: {
                                prop: "shadow",
                                xform: new i({
                                    tag: "shadow",
                                    attr: "val"
                                })
                            },
                            strike: {
                                prop: "strike",
                                xform: new i({
                                    tag: "strike",
                                    attr: "val"
                                })
                            },
                            sz: {
                                prop: "size",
                                xform: new s({
                                    tag: "sz",
                                    attr: "val"
                                })
                            }
                        }, this.map[this.options.fontNameTag] = {
                            prop: "name",
                            xform: new o({
                                tag: this.options.fontNameTag,
                                attr: "val"
                            })
                        };
                    }
                    get tag() {
                        return this.options.tagName;
                    }
                    render(e, t) {
                        const { map: r } = this;
                        e.openNode(this.options.tagName), l.each(this.map, (n, i)=>{
                            r[i].xform.render(e, t[n.prop]);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if (this.map[e.name]) return this.parser = this.map[e.name].xform, this.parser.parseOpen(e);
                        switch(e.name){
                            case this.options.tagName:
                                return this.model = {}, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser && !this.parser.parseClose(e)) {
                            const t = this.map[e];
                            return this.parser.model && (this.model[t.prop] = this.parser.model), this.parser = void 0, !0;
                        }
                        switch(e){
                            case this.options.tagName:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                }
                u.OPTIONS = {
                    tagName: "font",
                    fontNameTag: "name"
                }, t.exports = u;
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32,
                "../simple/boolean-xform": 116,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119,
                "./color-xform": 128,
                "./underline-xform": 136
            }
        ],
        132: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../defaultnumformats"), s = e("../base-xform");
                const o = function() {
                    const e = {};
                    return n.each(i, (t, r)=>{
                        t.f && (e[t.f] = parseInt(r, 10));
                    }), e;
                }();
                class a extends s {
                    constructor(e, t){
                        super(), this.id = e, this.formatCode = t;
                    }
                    get tag() {
                        return "numFmt";
                    }
                    render(e, t) {
                        e.leafNode("numFmt", {
                            numFmtId: t.id,
                            formatCode: t.formatCode
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "numFmt":
                                return this.model = {
                                    id: parseInt(e.attributes.numFmtId, 10),
                                    formatCode: e.attributes.formatCode.replace(/[\\](.)/g, "$1")
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                a.getDefaultFmtId = function(e) {
                    return o[e];
                }, a.getDefaultFmtCode = function(e) {
                    return i[e] && i[e].f;
                }, t.exports = a;
            },
            {
                "../../../utils/under-dash": 26,
                "../../defaultnumformats": 30,
                "../base-xform": 32
            }
        ],
        133: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = {
                    boolean: (e, t)=>void 0 === e ? t : e
                };
                t.exports = class extends n {
                    get tag() {
                        return "protection";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("protection");
                        let r = !1;
                        function n(t, n) {
                            void 0 !== n && (e.addAttribute(t, n), r = !0);
                        }
                        n("locked", i.boolean(t.locked, !0) ? void 0 : "0"), n("hidden", i.boolean(t.hidden, !1) ? "1" : void 0), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {
                            locked: !("0" === e.attributes.locked),
                            hidden: "1" === e.attributes.hidden
                        }, r = !t.locked || t.hidden;
                        this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        134: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./protection-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.xfId = !(!e || !e.xfId), this.map = {
                            alignment: new i,
                            protection: new s
                        };
                    }
                    get tag() {
                        return "xf";
                    }
                    render(e, t) {
                        e.openNode("xf", {
                            numFmtId: t.numFmtId || 0,
                            fontId: t.fontId || 0,
                            fillId: t.fillId || 0,
                            borderId: t.borderId || 0
                        }), this.xfId && e.addAttribute("xfId", t.xfId || 0), t.numFmtId && e.addAttribute("applyNumberFormat", "1"), t.fontId && e.addAttribute("applyFont", "1"), t.fillId && e.addAttribute("applyFill", "1"), t.borderId && e.addAttribute("applyBorder", "1"), t.alignment && e.addAttribute("applyAlignment", "1"), t.protection && e.addAttribute("applyProtection", "1"), t.alignment && this.map.alignment.render(e, t.alignment), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "xf":
                                return this.model = {
                                    numFmtId: parseInt(e.attributes.numFmtId, 10),
                                    fontId: parseInt(e.attributes.fontId, 10),
                                    fillId: parseInt(e.attributes.fillId, 10),
                                    borderId: parseInt(e.attributes.borderId, 10)
                                }, this.xfId && (this.model.xfId = parseInt(e.attributes.xfId, 10)), !0;
                            case "alignment":
                                return this.parser = this.map.alignment, this.parser.parseOpen(e), !0;
                            case "protection":
                                return this.parser = this.map.protection, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.map.protection === this.parser ? this.model.protection = this.parser.model : this.model.alignment = this.parser.model, this.parser = void 0), !0) : "xf" !== e;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./protection-xform": 133
            }
        ],
        135: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("../static-xform"), a = e("../list-xform"), l = e("./font-xform"), c = e("./fill-xform"), u = e("./border-xform"), h = e("./numfmt-xform"), f = e("./style-xform"), d = e("./dxf-xform");
                class p extends s {
                    constructor(e){
                        super(), this.map = {
                            numFmts: new a({
                                tag: "numFmts",
                                count: !0,
                                childXform: new h
                            }),
                            fonts: new a({
                                tag: "fonts",
                                count: !0,
                                childXform: new l,
                                $: {
                                    "x14ac:knownFonts": 1
                                }
                            }),
                            fills: new a({
                                tag: "fills",
                                count: !0,
                                childXform: new c
                            }),
                            borders: new a({
                                tag: "borders",
                                count: !0,
                                childXform: new u
                            }),
                            cellStyleXfs: new a({
                                tag: "cellStyleXfs",
                                count: !0,
                                childXform: new f
                            }),
                            cellXfs: new a({
                                tag: "cellXfs",
                                count: !0,
                                childXform: new f({
                                    xfId: !0
                                })
                            }),
                            dxfs: new a({
                                tag: "dxfs",
                                always: !0,
                                count: !0,
                                childXform: new d
                            }),
                            numFmt: new h,
                            font: new l,
                            fill: new c,
                            border: new u,
                            style: new f({
                                xfId: !0
                            }),
                            cellStyles: p.STATIC_XFORMS.cellStyles,
                            tableStyles: p.STATIC_XFORMS.tableStyles,
                            extLst: p.STATIC_XFORMS.extLst
                        }, e && this.init();
                    }
                    initIndex() {
                        this.index = {
                            style: {},
                            numFmt: {},
                            numFmtNextId: 164,
                            font: {},
                            border: {},
                            fill: {}
                        };
                    }
                    init() {
                        this.model = {
                            styles: [],
                            numFmts: [],
                            fonts: [],
                            borders: [],
                            fills: [],
                            dxfs: []
                        }, this.initIndex(), this._addBorder({}), this._addStyle({
                            numFmtId: 0,
                            fontId: 0,
                            fillId: 0,
                            borderId: 0,
                            xfId: 0
                        }), this._addFill({
                            type: "pattern",
                            pattern: "none"
                        }), this._addFill({
                            type: "pattern",
                            pattern: "gray125"
                        }), this.weakMap = new WeakMap;
                    }
                    render(e, t) {
                        t = t || this.model, e.openXml(i.StdDocAttributes), e.openNode("styleSheet", p.STYLESHEET_ATTRIBUTES), this.index ? (t.numFmts && t.numFmts.length && (e.openNode("numFmts", {
                            count: t.numFmts.length
                        }), t.numFmts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()), t.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), e.openNode("fonts", {
                            count: t.fonts.length,
                            "x14ac:knownFonts": 1
                        }), t.fonts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("fills", {
                            count: t.fills.length
                        }), t.fills.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("borders", {
                            count: t.borders.length
                        }), t.borders.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), e.openNode("cellXfs", {
                            count: t.styles.length
                        }), t.styles.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()) : (this.map.numFmts.render(e, t.numFmts), this.map.fonts.render(e, t.fonts), this.map.fills.render(e, t.fills), this.map.borders.render(e, t.borders), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), this.map.cellXfs.render(e, t.styles)), p.STATIC_XFORMS.cellStyles.render(e), this.map.dxfs.render(e, t.dxfs), p.STATIC_XFORMS.tableStyles.render(e), p.STATIC_XFORMS.extLst.render(e), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "styleSheet":
                                return this.initIndex(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "styleSheet":
                                {
                                    this.model = {};
                                    const e = (e, t)=>{
                                        t.model && t.model.length && (this.model[e] = t.model);
                                    };
                                    if (e("numFmts", this.map.numFmts), e("fonts", this.map.fonts), e("fills", this.map.fills), e("borders", this.map.borders), e("styles", this.map.cellXfs), e("dxfs", this.map.dxfs), this.index = {
                                        model: [],
                                        numFmt: []
                                    }, this.model.numFmts) {
                                        const e = this.index.numFmt;
                                        this.model.numFmts.forEach((t)=>{
                                            e[t.id] = t.formatCode;
                                        });
                                    }
                                    return !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    addStyleModel(e, t) {
                        if (!e) return 0;
                        if (this.model.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), this.weakMap && this.weakMap.has(e)) return this.weakMap.get(e);
                        const r = {};
                        if (t = t || n.ValueType.Number, e.numFmt) r.numFmtId = this._addNumFmtStr(e.numFmt);
                        else switch(t){
                            case n.ValueType.Number:
                                r.numFmtId = this._addNumFmtStr("General");
                                break;
                            case n.ValueType.Date:
                                r.numFmtId = this._addNumFmtStr("mm-dd-yy");
                        }
                        e.font && (r.fontId = this._addFont(e.font)), e.border && (r.borderId = this._addBorder(e.border)), e.fill && (r.fillId = this._addFill(e.fill)), e.alignment && (r.alignment = e.alignment), e.protection && (r.protection = e.protection);
                        const i = this._addStyle(r);
                        return this.weakMap && this.weakMap.set(e, i), i;
                    }
                    getStyleModel(e) {
                        const t = this.model.styles[e];
                        if (!t) return null;
                        let r = this.index.model[e];
                        if (r) return r;
                        if (r = this.index.model[e] = {}, t.numFmtId) {
                            const e = this.index.numFmt[t.numFmtId] || h.getDefaultFmtCode(t.numFmtId);
                            e && (r.numFmt = e);
                        }
                        function n(e, t, n) {
                            if (n || 0 === n) {
                                const i = t[n];
                                i && (r[e] = i);
                            }
                        }
                        return n("font", this.model.fonts, t.fontId), n("border", this.model.borders, t.borderId), n("fill", this.model.fills, t.fillId), t.alignment && (r.alignment = t.alignment), t.protection && (r.protection = t.protection), r;
                    }
                    addDxfStyle(e) {
                        return e.numFmt && (e.numFmtId = this._addNumFmtStr(e.numFmt)), this.model.dxfs.push(e), this.model.dxfs.length - 1;
                    }
                    getDxfStyle(e) {
                        return this.model.dxfs[e];
                    }
                    _addStyle(e) {
                        const t = this.map.style.toXml(e);
                        let r = this.index.style[t];
                        return void 0 === r && (r = this.index.style[t] = this.model.styles.length, this.model.styles.push(t)), r;
                    }
                    _addNumFmtStr(e) {
                        let t = h.getDefaultFmtId(e);
                        if (void 0 !== t) return t;
                        if (t = this.index.numFmt[e], void 0 !== t) return t;
                        t = this.index.numFmt[e] = 164 + this.model.numFmts.length;
                        const r = this.map.numFmt.toXml({
                            id: t,
                            formatCode: e
                        });
                        return this.model.numFmts.push(r), t;
                    }
                    _addFont(e) {
                        const t = this.map.font.toXml(e);
                        let r = this.index.font[t];
                        return void 0 === r && (r = this.index.font[t] = this.model.fonts.length, this.model.fonts.push(t)), r;
                    }
                    _addBorder(e) {
                        const t = this.map.border.toXml(e);
                        let r = this.index.border[t];
                        return void 0 === r && (r = this.index.border[t] = this.model.borders.length, this.model.borders.push(t)), r;
                    }
                    _addFill(e) {
                        const t = this.map.fill.toXml(e);
                        let r = this.index.fill[t];
                        return void 0 === r && (r = this.index.fill[t] = this.model.fills.length, this.model.fills.push(t)), r;
                    }
                }
                p.STYLESHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac x16r2",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
                    "xmlns:x16r2": "http://schemas.microsoft.com/office/spreadsheetml/2015/02/main"
                }, p.STATIC_XFORMS = {
                    cellStyles: new o({
                        tag: "cellStyles",
                        $: {
                            count: 1
                        },
                        c: [
                            {
                                tag: "cellStyle",
                                $: {
                                    name: "Normal",
                                    xfId: 0,
                                    builtinId: 0
                                }
                            }
                        ]
                    }),
                    dxfs: new o({
                        tag: "dxfs",
                        $: {
                            count: 0
                        }
                    }),
                    tableStyles: new o({
                        tag: "tableStyles",
                        $: {
                            count: 0,
                            defaultTableStyle: "TableStyleMedium2",
                            defaultPivotStyle: "PivotStyleLight16"
                        }
                    }),
                    extLst: new o({
                        tag: "extLst",
                        c: [
                            {
                                tag: "ext",
                                $: {
                                    uri: "{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}",
                                    "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                                },
                                c: [
                                    {
                                        tag: "x14:slicerStyles",
                                        $: {
                                            defaultSlicerStyle: "SlicerStyleLight1"
                                        }
                                    }
                                ]
                            },
                            {
                                tag: "ext",
                                $: {
                                    uri: "{9260A510-F301-46a8-8635-F512D64BE5F5}",
                                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                                },
                                c: [
                                    {
                                        tag: "x15:timelineStyles",
                                        $: {
                                            defaultTimelineStyle: "TimeSlicerStyleLight1"
                                        }
                                    }
                                ]
                            }
                        ]
                    })
                };
                p.Mock = class extends p {
                    constructor(){
                        super(), this.model = {
                            styles: [
                                {
                                    numFmtId: 0,
                                    fontId: 0,
                                    fillId: 0,
                                    borderId: 0,
                                    xfId: 0
                                }
                            ],
                            numFmts: [],
                            fonts: [
                                {
                                    size: 11,
                                    color: {
                                        theme: 1
                                    },
                                    name: "Calibri",
                                    family: 2,
                                    scheme: "minor"
                                }
                            ],
                            borders: [
                                {}
                            ],
                            fills: [
                                {
                                    type: "pattern",
                                    pattern: "none"
                                },
                                {
                                    type: "pattern",
                                    pattern: "gray125"
                                }
                            ]
                        };
                    }
                    parseStream(e) {
                        return e.autodrain(), Promise.resolve();
                    }
                    addStyleModel(e, t) {
                        switch(t){
                            case n.ValueType.Date:
                                return this.dateStyleId;
                            default:
                                return 0;
                        }
                    }
                    get dateStyleId() {
                        if (!this._dateStyleId) {
                            const e = {
                                numFmtId: h.getDefaultFmtId("mm-dd-yy")
                            };
                            this._dateStyleId = this.model.styles.length, this.model.styles.push(e);
                        }
                        return this._dateStyleId;
                    }
                    getStyleModel() {
                        return {};
                    }
                }, t.exports = p;
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./border-xform": 127,
                "./dxf-xform": 129,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./style-xform": 134
            }
        ],
        136: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                class i extends n {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "u";
                    }
                    render(e, t) {
                        if (!0 === (t = t || this.model)) e.leafNode("u");
                        else {
                            const r = i.Attributes[t];
                            r && e.leafNode("u", r);
                        }
                    }
                    parseOpen(e) {
                        "u" === e.name && (this.model = e.attributes.val || !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                i.Attributes = {
                    single: {},
                    double: {
                        val: "double"
                    },
                    singleAccounting: {
                        val: "singleAccounting"
                    },
                    doubleAccounting: {
                        val: "doubleAccounting"
                    }
                }, t.exports = i;
            },
            {
                "../base-xform": 32
            }
        ],
        137: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./filter-column-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            filterColumn: new i
                        };
                    }
                    get tag() {
                        return "autoFilter";
                    }
                    prepare(e) {
                        e.columns.forEach((e, t)=>{
                            this.map.filterColumn.prepare(e, {
                                index: t
                            });
                        });
                    }
                    render(e, t) {
                        return e.openNode(this.tag, {
                            ref: t.autoFilterRef
                        }), t.columns.forEach((t)=>{
                            this.map.filterColumn.render(e, t);
                        }), e.closeNode(), !0;
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    autoFilterRef: e.attributes.ref,
                                    columns: []
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.columns.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./filter-column-xform": 139
            }
        ],
        138: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "customFilter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val,
                            operator: t.operator
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val,
                            operator: e.attributes.operator
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        139: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../list-xform"), s = e("./custom-filter-xform"), o = e("./filter-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            customFilters: new i({
                                tag: "customFilters",
                                count: !1,
                                empty: !0,
                                childXform: new s
                            }),
                            filters: new i({
                                tag: "filters",
                                count: !1,
                                empty: !0,
                                childXform: new o
                            })
                        };
                    }
                    get tag() {
                        return "filterColumn";
                    }
                    prepare(e, t) {
                        e.colId = t.index.toString();
                    }
                    render(e, t) {
                        return t.customFilters ? (e.openNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), this.map.customFilters.render(e, t.customFilters), e.closeNode(), !0) : (e.leafNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), !0);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { attributes: t } = e;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    filterButton: "0" === t.hiddenButton
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.customFilters = this.map.customFilters.model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../list-xform": 71,
                "./custom-filter-xform": 138,
                "./filter-xform": 140
            }
        ],
        140: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "filter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        141: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableColumn";
                    }
                    prepare(e, t) {
                        e.id = t.index + 1;
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            id: t.id.toString(),
                            name: t.name,
                            totalsRowLabel: t.totalsRowLabel,
                            totalsRowFunction: t.totalsRowFunction,
                            dxfId: t.dxfId
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                name: t.name,
                                totalsRowLabel: t.totalsRowLabel,
                                totalsRowFunction: t.totalsRowFunction,
                                dxfId: t.dxfId
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        142: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableStyleInfo";
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            name: t.theme ? t.theme : void 0,
                            showFirstColumn: t.showFirstColumn ? "1" : "0",
                            showLastColumn: t.showLastColumn ? "1" : "0",
                            showRowStripes: t.showRowStripes ? "1" : "0",
                            showColumnStripes: t.showColumnStripes ? "1" : "0"
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                theme: t.name ? t.name : null,
                                showFirstColumn: "1" === t.showFirstColumn,
                                showLastColumn: "1" === t.showLastColumn,
                                showRowStripes: "1" === t.showRowStripes,
                                showColumnStripes: "1" === t.showColumnStripes
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        143: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../list-xform"), o = e("./auto-filter-xform"), a = e("./table-column-xform"), l = e("./table-style-info-xform");
                class c extends i {
                    constructor(){
                        super(), this.map = {
                            autoFilter: new o,
                            tableColumns: new s({
                                tag: "tableColumns",
                                count: !0,
                                empty: !0,
                                childXform: new a
                            }),
                            tableStyleInfo: new l
                        };
                    }
                    prepare(e, t) {
                        this.map.autoFilter.prepare(e), this.map.tableColumns.prepare(e.columns, t);
                    }
                    get tag() {
                        return "table";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, {
                            ...c.TABLE_ATTRIBUTES,
                            id: t.id,
                            name: t.name,
                            displayName: t.displayName || t.name,
                            ref: t.tableRef,
                            totalsRowCount: t.totalsRow ? "1" : void 0,
                            totalsRowShown: t.totalsRow ? void 0 : "1",
                            headerRowCount: t.headerRow ? "1" : "0"
                        }), this.map.autoFilter.render(e, t), this.map.tableColumns.render(e, t.columns), this.map.tableStyleInfo.render(e, t.style), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { name: t, attributes: r } = e;
                        switch(t){
                            case this.tag:
                                this.reset(), this.model = {
                                    name: r.name,
                                    displayName: r.displayName || r.name,
                                    tableRef: r.ref,
                                    totalsRow: "1" === r.totalsRowCount,
                                    headerRow: "1" === r.headerRowCount
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.columns = this.map.tableColumns.model, this.map.autoFilter.model && (this.model.autoFilterRef = this.map.autoFilter.model.autoFilterRef, this.map.autoFilter.model.columns.forEach((e, t)=>{
                                    this.model.columns[t].filterButton = e.filterButton;
                                })), this.model.style = this.map.tableStyleInfo.model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.columns.forEach((e)=>{
                            void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId));
                        });
                    }
                }
                c.TABLE_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "xr xr3",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision",
                    "xmlns:xr3": "http://schemas.microsoft.com/office/spreadsheetml/2016/revision3"
                }, t.exports = c;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 137,
                "./table-column-xform": 141,
                "./table-style-info-xform": 142
            }
        ],
        144: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = e("jszip"), { PassThrough: o } = e("readable-stream"), a = e("../utils/zip-stream"), l = e("../utils/stream-buf"), c = e("../utils/utils"), u = e("../utils/xml-stream"), { bufferToString: h } = e("../utils/browser-buffer-decode"), f = e("./xform/style/styles-xform"), d = e("./xform/core/core-xform"), p = e("./xform/strings/shared-strings-xform"), m = e("./xform/core/relationships-xform"), b = e("./xform/core/content-types-xform"), g = e("./xform/core/app-xform"), y = e("./xform/book/workbook-xform"), v = e("./xform/sheet/worksheet-xform"), w = e("./xform/drawing/drawing-xform"), _ = e("./xform/table/table-xform"), x = e("./xform/comment/comments-xform"), k = e("./xform/comment/vml-notes-xform"), S = e("./xml/theme1");
                        class M {
                            constructor(e){
                                this.workbook = e;
                            }
                            async readFile(e, t) {
                                if (!await c.fs.exists(e)) throw new Error("File not found: " + e);
                                const r = i.createReadStream(e);
                                try {
                                    const e = await this.read(r, t);
                                    return r.close(), e;
                                } catch (e) {
                                    throw r.close(), e;
                                }
                            }
                            parseRels(e) {
                                return (new m).parseStream(e);
                            }
                            parseWorkbook(e) {
                                return (new y).parseStream(e);
                            }
                            parseSharedStrings(e) {
                                return (new p).parseStream(e);
                            }
                            reconcile(e, t) {
                                const r = new y, n = new v(t), i = new w, s = new _;
                                r.reconcile(e);
                                const o = {
                                    media: e.media,
                                    mediaIndex: e.mediaIndex
                                };
                                Object.keys(e.drawings).forEach((t)=>{
                                    const r = e.drawings[t], n = e.drawingRels[t];
                                    n && (o.rels = n.reduce((e, t)=>(e[t.Id] = t, e), {}), (r.anchors || []).forEach((e)=>{
                                        const t = e.picture && e.picture.hyperlinks;
                                        t && o.rels[t.rId] && (t.hyperlink = o.rels[t.rId].Target, delete t.rId);
                                    }), i.reconcile(r, o));
                                });
                                const a = {
                                    styles: e.styles
                                };
                                Object.values(e.tables).forEach((e)=>{
                                    s.reconcile(e, a);
                                });
                                const l = {
                                    styles: e.styles,
                                    sharedStrings: e.sharedStrings,
                                    media: e.media,
                                    mediaIndex: e.mediaIndex,
                                    date1904: e.properties && e.properties.date1904,
                                    drawings: e.drawings,
                                    comments: e.comments,
                                    tables: e.tables,
                                    vmlDrawings: e.vmlDrawings
                                };
                                e.worksheets.forEach((t)=>{
                                    t.relationships = e.worksheetRels[t.sheetNo], n.reconcile(t, l);
                                }), delete e.worksheetHash, delete e.worksheetRels, delete e.globalRels, delete e.sharedStrings, delete e.workbookRels, delete e.sheetDefs, delete e.styles, delete e.mediaIndex, delete e.drawings, delete e.drawingRels, delete e.vmlDrawings;
                            }
                            async _processWorksheetEntry(e, t, r, n, i) {
                                const s = new v(n), o = await s.parseStream(e);
                                o.sheetNo = r, t.worksheetHash[i] = o, t.worksheets.push(o);
                            }
                            async _processCommentEntry(e, t, r) {
                                const n = new x, i = await n.parseStream(e);
                                t.comments[`../${r}.xml`] = i;
                            }
                            async _processTableEntry(e, t, r) {
                                const n = new _, i = await n.parseStream(e);
                                t.tables[`../tables/${r}.xml`] = i;
                            }
                            async _processWorksheetRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.worksheetRels[r] = i;
                            }
                            async _processMediaEntry(e, t, r) {
                                const n = r.lastIndexOf(".");
                                if (n >= 1) {
                                    const i = r.substr(n + 1), s = r.substr(0, n);
                                    await new Promise((n, o)=>{
                                        const a = new l;
                                        a.on("finish", ()=>{
                                            t.mediaIndex[r] = t.media.length, t.mediaIndex[s] = t.media.length;
                                            const e = {
                                                type: "image",
                                                name: s,
                                                extension: i,
                                                buffer: a.toBuffer()
                                            };
                                            t.media.push(e), n();
                                        }), e.on("error", (e)=>{
                                            o(e);
                                        }), e.pipe(a);
                                    });
                                }
                            }
                            async _processDrawingEntry(e, t, r) {
                                const n = new w, i = await n.parseStream(e);
                                t.drawings[r] = i;
                            }
                            async _processDrawingRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.drawingRels[r] = i;
                            }
                            async _processVmlDrawingEntry(e, t, r) {
                                const n = new k, i = await n.parseStream(e);
                                t.vmlDrawings[`../drawings/${r}.vml`] = i;
                            }
                            async _processThemeEntry(e, t, r) {
                                await new Promise((n, i)=>{
                                    const s = new l;
                                    e.on("error", i), s.on("error", i), s.on("finish", ()=>{
                                        t.themes[r] = s.read().toString(), n();
                                    }), e.pipe(s);
                                });
                            }
                            createInputStream() {
                                throw new Error("`XLSX#createInputStream` is deprecated. You should use `XLSX#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                            }
                            async read(e, t) {
                                !e[Symbol.asyncIterator] && e.pipe && (e = e.pipe(new o));
                                const r = [];
                                for await (const t of e)r.push(t);
                                return this.load(n.concat(r), t);
                            }
                            async load(e, t) {
                                let i;
                                i = t && t.base64 ? n.from(e.toString(), "base64") : e;
                                const a = {
                                    worksheets: [],
                                    worksheetHash: {},
                                    worksheetRels: [],
                                    themes: {},
                                    media: [],
                                    mediaIndex: {},
                                    drawings: {},
                                    drawingRels: {},
                                    comments: {},
                                    tables: {},
                                    vmlDrawings: {}
                                }, l = await s.loadAsync(i);
                                for (const e of Object.values(l.files))if (!e.dir) {
                                    let n, i = e.name;
                                    if ("/" === i[0] && (i = i.substr(1)), i.match(/xl\/media\//) || i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/)) n = new o, n.write(await e.async("nodebuffer"));
                                    else {
                                        let t;
                                        n = new o({
                                            writableObjectMode: !0,
                                            readableObjectMode: !0
                                        }), t = r.browser ? h(await e.async("nodebuffer")) : await e.async("string");
                                        const i = 16384;
                                        for(let e = 0; e < t.length; e += i)n.write(t.substring(e, e + i));
                                    }
                                    switch(n.end(), i){
                                        case "_rels/.rels":
                                            a.globalRels = await this.parseRels(n);
                                            break;
                                        case "xl/workbook.xml":
                                            {
                                                const e = await this.parseWorkbook(n);
                                                a.sheets = e.sheets, a.definedNames = e.definedNames, a.views = e.views, a.properties = e.properties, a.calcProperties = e.calcProperties;
                                                break;
                                            }
                                        case "xl/_rels/workbook.xml.rels":
                                            a.workbookRels = await this.parseRels(n);
                                            break;
                                        case "xl/sharedStrings.xml":
                                            a.sharedStrings = new p, await a.sharedStrings.parseStream(n);
                                            break;
                                        case "xl/styles.xml":
                                            a.styles = new f, await a.styles.parseStream(n);
                                            break;
                                        case "docProps/app.xml":
                                            {
                                                const e = new g, t = await e.parseStream(n);
                                                a.company = t.company, a.manager = t.manager;
                                                break;
                                            }
                                        case "docProps/core.xml":
                                            {
                                                const e = new d, t = await e.parseStream(n);
                                                Object.assign(a, t);
                                                break;
                                            }
                                        default:
                                            {
                                                let e = i.match(/xl\/worksheets\/sheet(\d+)[.]xml/);
                                                if (e) {
                                                    await this._processWorksheetEntry(n, a, e[1], t, i);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/worksheets\/_rels\/sheet(\d+)[.]xml.rels/), e) {
                                                    await this._processWorksheetRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processThemeEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/media\/([a-zA-Z0-9]+[.][a-zA-Z0-9]{3,4})$/), e) {
                                                    await this._processMediaEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/(comments\d+)[.]xml/), e) {
                                                    await this._processCommentEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/tables\/(table\d+)[.]xml/), e) {
                                                    await this._processTableEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/_rels\/([a-zA-Z0-9]+)[.]xml[.]rels/), e) {
                                                    await this._processDrawingRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/(vmlDrawing\d+)[.]vml/), e) {
                                                    await this._processVmlDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                            }
                                    }
                                }
                                return this.reconcile(a, t), this.workbook.model = a, this.workbook;
                            }
                            async addMedia(e, t) {
                                await Promise.all(t.media.map(async (t)=>{
                                    if ("image" === t.type) {
                                        const r = `xl/media/${t.name}.${t.extension}`;
                                        if (t.filename) {
                                            const n = await function(e, t) {
                                                return new Promise((r, n)=>{
                                                    i.readFile(e, t, (e, t)=>{
                                                        e ? n(e) : r(t);
                                                    });
                                                });
                                            }(t.filename);
                                            return e.append(n, {
                                                name: r
                                            });
                                        }
                                        if (t.buffer) return e.append(t.buffer, {
                                            name: r
                                        });
                                        if (t.base64) {
                                            const n = t.base64, i = n.substring(n.indexOf(",") + 1);
                                            return e.append(i, {
                                                name: r,
                                                base64: !0
                                            });
                                        }
                                    }
                                    throw new Error("Unsupported media");
                                }));
                            }
                            addDrawings(e, t) {
                                const r = new w, n = new m;
                                t.worksheets.forEach((t)=>{
                                    const { drawing: i } = t;
                                    if (i) {
                                        r.prepare(i, {});
                                        let t = r.toXml(i);
                                        e.append(t, {
                                            name: `xl/drawings/${i.name}.xml`
                                        }), t = n.toXml(i.rels), e.append(t, {
                                            name: `xl/drawings/_rels/${i.name}.xml.rels`
                                        });
                                    }
                                });
                            }
                            addTables(e, t) {
                                const r = new _;
                                t.worksheets.forEach((t)=>{
                                    const { tables: n } = t;
                                    n.forEach((t)=>{
                                        r.prepare(t, {});
                                        const n = r.toXml(t);
                                        e.append(n, {
                                            name: "xl/tables/" + t.target
                                        });
                                    });
                                });
                            }
                            async addContentTypes(e, t) {
                                const r = (new b).toXml(t);
                                e.append(r, {
                                    name: "[Content_Types].xml"
                                });
                            }
                            async addApp(e, t) {
                                const r = (new g).toXml(t);
                                e.append(r, {
                                    name: "docProps/app.xml"
                                });
                            }
                            async addCore(e, t) {
                                const r = new d;
                                e.append(r.toXml(t), {
                                    name: "docProps/core.xml"
                                });
                            }
                            async addThemes(e, t) {
                                const r = t.themes || {
                                    theme1: S
                                };
                                Object.keys(r).forEach((t)=>{
                                    const n = r[t], i = `xl/theme/${t}.xml`;
                                    e.append(n, {
                                        name: i
                                    });
                                });
                            }
                            async addOfficeRels(e) {
                                const t = (new m).toXml([
                                    {
                                        Id: "rId1",
                                        Type: M.RelType.OfficeDocument,
                                        Target: "xl/workbook.xml"
                                    },
                                    {
                                        Id: "rId2",
                                        Type: M.RelType.CoreProperties,
                                        Target: "docProps/core.xml"
                                    },
                                    {
                                        Id: "rId3",
                                        Type: M.RelType.ExtenderProperties,
                                        Target: "docProps/app.xml"
                                    }
                                ]);
                                e.append(t, {
                                    name: "_rels/.rels"
                                });
                            }
                            async addWorkbookRels(e, t) {
                                let r = 1;
                                const n = [
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Styles,
                                        Target: "styles.xml"
                                    },
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Theme,
                                        Target: "theme/theme1.xml"
                                    }
                                ];
                                t.sharedStrings.count && n.push({
                                    Id: "rId" + r++,
                                    Type: M.RelType.SharedStrings,
                                    Target: "sharedStrings.xml"
                                }), t.worksheets.forEach((e)=>{
                                    e.rId = "rId" + r++, n.push({
                                        Id: e.rId,
                                        Type: M.RelType.Worksheet,
                                        Target: `worksheets/sheet${e.id}.xml`
                                    });
                                });
                                const i = (new m).toXml(n);
                                e.append(i, {
                                    name: "xl/_rels/workbook.xml.rels"
                                });
                            }
                            async addSharedStrings(e, t) {
                                t.sharedStrings && t.sharedStrings.count && e.append(t.sharedStrings.xml, {
                                    name: "xl/sharedStrings.xml"
                                });
                            }
                            async addStyles(e, t) {
                                const { xml: r } = t.styles;
                                r && e.append(r, {
                                    name: "xl/styles.xml"
                                });
                            }
                            async addWorkbook(e, t) {
                                const r = new y;
                                e.append(r.toXml(t), {
                                    name: "xl/workbook.xml"
                                });
                            }
                            async addWorksheets(e, t) {
                                const r = new v, n = new m, i = new x, s = new k;
                                t.worksheets.forEach((t)=>{
                                    let o = new u;
                                    r.render(o, t), e.append(o.xml, {
                                        name: `xl/worksheets/sheet${t.id}.xml`
                                    }), t.rels && t.rels.length && (o = new u, n.render(o, t.rels), e.append(o.xml, {
                                        name: `xl/worksheets/_rels/sheet${t.id}.xml.rels`
                                    })), t.comments.length > 0 && (o = new u, i.render(o, t), e.append(o.xml, {
                                        name: `xl/comments${t.id}.xml`
                                    }), o = new u, s.render(o, t), e.append(o.xml, {
                                        name: `xl/drawings/vmlDrawing${t.id}.vml`
                                    }));
                                });
                            }
                            _finalize(e) {
                                return new Promise((t, r)=>{
                                    e.on("finish", ()=>{
                                        t(this);
                                    }), e.on("error", r), e.finalize();
                                });
                            }
                            prepareModel(e, t) {
                                e.creator = e.creator || "ExcelJS", e.lastModifiedBy = e.lastModifiedBy || "ExcelJS", e.created = e.created || new Date, e.modified = e.modified || new Date, e.useSharedStrings = void 0 === t.useSharedStrings || t.useSharedStrings, e.useStyles = void 0 === t.useStyles || t.useStyles, e.sharedStrings = new p, e.styles = e.useStyles ? new f(!0) : new f.Mock;
                                const r = new y, n = new v;
                                r.prepare(e);
                                const i = {
                                    sharedStrings: e.sharedStrings,
                                    styles: e.styles,
                                    date1904: e.properties.date1904,
                                    drawingsCount: 0,
                                    media: e.media
                                };
                                i.drawings = e.drawings = [], i.commentRefs = e.commentRefs = [];
                                let s = 0;
                                e.tables = [], e.worksheets.forEach((t)=>{
                                    t.tables.forEach((t)=>{
                                        s++, t.target = `table${s}.xml`, t.id = s, e.tables.push(t);
                                    }), n.prepare(t, i);
                                });
                            }
                            async write(e, t) {
                                t = t || {};
                                const { model: r } = this.workbook, n = new a.ZipWriter(t.zip);
                                return n.pipe(e), this.prepareModel(r, t), await this.addContentTypes(n, r), await this.addOfficeRels(n, r), await this.addWorkbookRels(n, r), await this.addWorksheets(n, r), await this.addSharedStrings(n, r), await this.addDrawings(n, r), await this.addTables(n, r), await Promise.all([
                                    this.addThemes(n, r),
                                    this.addStyles(n, r)
                                ]), await this.addMedia(n, r), await Promise.all([
                                    this.addApp(n, r),
                                    this.addCore(n, r)
                                ]), await this.addWorkbook(n, r), this._finalize(n);
                            }
                            writeFile(e, t) {
                                const r = i.createWriteStream(e);
                                return new Promise((e, n)=>{
                                    r.on("finish", ()=>{
                                        e();
                                    }), r.on("error", (e)=>{
                                        n(e);
                                    }), this.write(r, t).then(()=>{
                                        r.end();
                                    }).catch((e)=>{
                                        n(e);
                                    });
                                });
                            }
                            async writeBuffer(e) {
                                const t = new l;
                                return await this.write(t, e), t.read();
                            }
                        }
                        M.RelType = e("./rel-type"), t.exports = M;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "../utils/browser-buffer-decode": 16,
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                "../utils/xml-stream": 28,
                "../utils/zip-stream": 29,
                "./rel-type": 31,
                "./xform/book/workbook-xform": 38,
                "./xform/comment/comments-xform": 40,
                "./xform/comment/vml-notes-xform": 45,
                "./xform/core/app-xform": 51,
                "./xform/core/content-types-xform": 52,
                "./xform/core/core-xform": 53,
                "./xform/core/relationships-xform": 55,
                "./xform/drawing/drawing-xform": 62,
                "./xform/sheet/worksheet-xform": 115,
                "./xform/strings/shared-strings-xform": 124,
                "./xform/style/styles-xform": 135,
                "./xform/table/table-xform": 143,
                "./xml/theme1": 145,
                _process: 467,
                buffer: 220,
                fs: 216,
                jszip: 441,
                "readable-stream": 491
            }
        ],
        145: [
            function(e, t, r) {
                "use strict";
                t.exports = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"> <a:themeElements> <a:clrScheme name="Office"> <a:dk1> <a:sysClr val="windowText" lastClr="000000"/> </a:dk1> <a:lt1> <a:sysClr val="window" lastClr="FFFFFF"/> </a:lt1> <a:dk2> <a:srgbClr val="1F497D"/> </a:dk2> <a:lt2> <a:srgbClr val="EEECE1"/> </a:lt2> <a:accent1> <a:srgbClr val="4F81BD"/> </a:accent1> <a:accent2> <a:srgbClr val="C0504D"/> </a:accent2> <a:accent3> <a:srgbClr val="9BBB59"/> </a:accent3> <a:accent4> <a:srgbClr val="8064A2"/> </a:accent4> <a:accent5> <a:srgbClr val="4BACC6"/> </a:accent5> <a:accent6> <a:srgbClr val="F79646"/> </a:accent6> <a:hlink> <a:srgbClr val="0000FF"/> </a:hlink> <a:folHlink> <a:srgbClr val="800080"/> </a:folHlink> </a:clrScheme> <a:fontScheme name="Office"> <a:majorFont> <a:latin typeface="Cambria"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Times New Roman"/> <a:font script="Hebr" typeface="Times New Roman"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="MoolBoran"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Times New Roman"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:majorFont> <a:minorFont> <a:latin typeface="Calibri"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Arial"/> <a:font script="Hebr" typeface="Arial"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="DaunPenh"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Arial"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:minorFont> </a:fontScheme> <a:fmtScheme name="Office"> <a:fillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="35000"> <a:schemeClr val="phClr"> <a:tint val="37000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="15000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="1"/> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="100000"/> <a:shade val="100000"/> <a:satMod val="130000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:shade val="100000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="0"/> </a:gradFill> </a:fillStyleLst> <a:lnStyleLst> <a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"> <a:shade val="95000"/> <a:satMod val="105000"/> </a:schemeClr> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> </a:lnStyleLst> <a:effectStyleLst> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="38000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> <a:scene3d> <a:camera prst="orthographicFront"> <a:rot lat="0" lon="0" rev="0"/> </a:camera> <a:lightRig rig="threePt" dir="t"> <a:rot lat="0" lon="0" rev="1200000"/> </a:lightRig> </a:scene3d> <a:sp3d> <a:bevelT w="63500" h="25400"/> </a:sp3d> </a:effectStyle> </a:effectStyleLst> <a:bgFillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="40000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="40000"> <a:schemeClr val="phClr"> <a:tint val="45000"/> <a:shade val="99000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="20000"/> <a:satMod val="255000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="-80000" r="50000" b="180000"/> </a:path> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="80000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="30000"/> <a:satMod val="200000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="50000" r="50000" b="50000"/> </a:path> </a:gradFill> </a:bgFillStyleLst> </a:fmtScheme> </a:themeElements> <a:objectDefaults> <a:spDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="1"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="3"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="2"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="lt1"/> </a:fontRef> </a:style> </a:spDef> <a:lnDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="2"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="0"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="1"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="tx1"/> </a:fontRef> </a:style> </a:lnDef> </a:objectDefaults> <a:extraClrSchemeLst/> </a:theme>';
            },
            {}
        ],
        146: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvFormatterStream = void 0;
                        const n = e("stream"), i = e("./formatter");
                        class s extends n.Transform {
                            constructor(e){
                                super({
                                    writableObjectMode: e.objectMode
                                }), this.hasWrittenBOM = !1, this.formatterOptions = e, this.rowFormatter = new i.RowFormatter(e), this.hasWrittenBOM = !e.writeBOM;
                            }
                            transform(e) {
                                return this.rowFormatter.rowTransform = e, this;
                            }
                            _transform(e, r, n) {
                                let i = !1;
                                try {
                                    this.hasWrittenBOM || (this.push(this.formatterOptions.BOM), this.hasWrittenBOM = !0), this.rowFormatter.format(e, (e, r)=>e ? (i = !0, n(e)) : (r && r.forEach((e)=>{
                                            this.push(t.from(e, "utf8"));
                                        }), i = !0, n()));
                                } catch (e) {
                                    if (i) throw e;
                                    n(e);
                                }
                            }
                            _flush(e) {
                                this.rowFormatter.finish((r, n)=>r ? e(r) : (n && n.forEach((e)=>{
                                        this.push(t.from(e, "utf8"));
                                    }), e()));
                            }
                        }
                        r.CsvFormatterStream = s;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./formatter": 150,
                buffer: 220,
                stream: 505
            }
        ],
        147: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FormatterOptions = void 0;
                r.FormatterOptions = class {
                    constructor(){
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        var t;
                        this.objectMode = !0, this.delimiter = ",", this.rowDelimiter = "\n", this.quote = '"', this.escape = this.quote, this.quoteColumns = !1, this.quoteHeaders = this.quoteColumns, this.headers = null, this.includeEndRowDelimiter = !1, this.writeBOM = !1, this.BOM = "\ufeff", this.alwaysWriteHeaders = !1, Object.assign(this, e || {}), void 0 === (null == e ? void 0 : e.quoteHeaders) && (this.quoteHeaders = this.quoteColumns), !0 === (null == e ? void 0 : e.quote) ? this.quote = '"' : !1 === (null == e ? void 0 : e.quote) && (this.quote = ""), "string" != typeof (null == e ? void 0 : e.escape) && (this.escape = this.quote), this.shouldWriteHeaders = !!this.headers && (null === (t = e.writeHeaders) || void 0 === t || t), this.headers = Array.isArray(this.headers) ? this.headers : null, this.escapedQuote = `${this.escape}${this.quote}`;
                    }
                };
            },
            {}
        ],
        148: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = void 0;
                const i = n(e("lodash.isboolean")), s = n(e("lodash.isnil")), o = n(e("lodash.escaperegexp"));
                r.FieldFormatter = class {
                    constructor(e){
                        this._headers = null, this.formatterOptions = e, null !== e.headers && (this.headers = e.headers), this.REPLACE_REGEXP = new RegExp(e.quote, "g");
                        const t = `[${e.delimiter}${o.default(e.rowDelimiter)}|\r|\n]`;
                        this.ESCAPE_REGEXP = new RegExp(t);
                    }
                    set headers(e) {
                        this._headers = e;
                    }
                    shouldQuote(e, t) {
                        const r = t ? this.formatterOptions.quoteHeaders : this.formatterOptions.quoteColumns;
                        return i.default(r) ? r : Array.isArray(r) ? r[e] : null !== this._headers && r[this._headers[e]];
                    }
                    format(e, t, r) {
                        const n = ("" + (s.default(e) ? "" : e)).replace(/\0/g, ""), { formatterOptions: i } = this;
                        if ("" !== i.quote) {
                            if (-1 !== n.indexOf(i.quote)) return this.quoteField(n.replace(this.REPLACE_REGEXP, i.escapedQuote));
                        }
                        return -1 !== n.search(this.ESCAPE_REGEXP) || this.shouldQuote(t, r) ? this.quoteField(n) : n;
                    }
                    quoteField(e) {
                        const { quote: t } = this.formatterOptions;
                        return `${t}${e}${t}`;
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isboolean": 444,
                "lodash.isnil": 447
            }
        ],
        149: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowFormatter = void 0;
                const i = n(e("lodash.isfunction")), s = n(e("lodash.isequal")), o = e("./FieldFormatter"), a = e("../types");
                class l {
                    constructor(e){
                        this.rowCount = 0, this.formatterOptions = e, this.fieldFormatter = new o.FieldFormatter(e), this.headers = e.headers, this.shouldWriteHeaders = e.shouldWriteHeaders, this.hasWrittenHeaders = !1, null !== this.headers && (this.fieldFormatter.headers = this.headers), e.transform && (this.rowTransform = e.transform);
                    }
                    static isRowHashArray(e) {
                        return !!Array.isArray(e) && Array.isArray(e[0]) && 2 === e[0].length;
                    }
                    static isRowArray(e) {
                        return Array.isArray(e) && !this.isRowHashArray(e);
                    }
                    static gatherHeaders(e) {
                        return l.isRowHashArray(e) ? e.map((e)=>e[0]) : Array.isArray(e) ? e : Object.keys(e);
                    }
                    static createTransform(e) {
                        return a.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : (t, r)=>{
                            e(t, r);
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = l.createTransform(e);
                    }
                    format(e, t) {
                        this.callTransformer(e, (r, n)=>{
                            if (r) return t(r);
                            if (!e) return t(null);
                            const i = [];
                            if (n) {
                                const { shouldFormatColumns: e, headers: t } = this.checkHeaders(n);
                                if (this.shouldWriteHeaders && t && !this.hasWrittenHeaders && (i.push(this.formatColumns(t, !0)), this.hasWrittenHeaders = !0), e) {
                                    const e = this.gatherColumns(n);
                                    i.push(this.formatColumns(e, !1));
                                }
                            }
                            return t(null, i);
                        });
                    }
                    finish(e) {
                        const t = [];
                        if (this.formatterOptions.alwaysWriteHeaders && 0 === this.rowCount) {
                            if (!this.headers) return e(new Error("`alwaysWriteHeaders` option is set to true but `headers` option not provided."));
                            t.push(this.formatColumns(this.headers, !0));
                        }
                        return this.formatterOptions.includeEndRowDelimiter && t.push(this.formatterOptions.rowDelimiter), e(null, t);
                    }
                    checkHeaders(e) {
                        if (this.headers) return {
                            shouldFormatColumns: !0,
                            headers: this.headers
                        };
                        const t = l.gatherHeaders(e);
                        return this.headers = t, this.fieldFormatter.headers = t, this.shouldWriteHeaders ? {
                            shouldFormatColumns: !s.default(t, e),
                            headers: t
                        } : {
                            shouldFormatColumns: !0,
                            headers: null
                        };
                    }
                    gatherColumns(e) {
                        if (null === this.headers) throw new Error("Headers is currently null");
                        return Array.isArray(e) ? l.isRowHashArray(e) ? this.headers.map((t, r)=>{
                            const n = e[r];
                            return n ? n[1] : "";
                        }) : l.isRowArray(e) && !this.shouldWriteHeaders ? e : this.headers.map((t, r)=>e[r]) : this.headers.map((t)=>e[t]);
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    formatColumns(e, t) {
                        const r = e.map((e, r)=>this.fieldFormatter.format(e, r, t)).join(this.formatterOptions.delimiter), { rowCount: n } = this;
                        return this.rowCount += 1, n ? [
                            this.formatterOptions.rowDelimiter,
                            r
                        ].join("") : r;
                    }
                }
                r.RowFormatter = l;
            },
            {
                "../types": 152,
                "./FieldFormatter": 148,
                "lodash.isequal": 445,
                "lodash.isfunction": 446
            }
        ],
        150: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = r.RowFormatter = void 0;
                var n = e("./RowFormatter");
                Object.defineProperty(r, "RowFormatter", {
                    enumerable: !0,
                    get: function() {
                        return n.RowFormatter;
                    }
                });
                var i = e("./FieldFormatter");
                Object.defineProperty(r, "FieldFormatter", {
                    enumerable: !0,
                    get: function() {
                        return i.FieldFormatter;
                    }
                });
            },
            {
                "./FieldFormatter": 148,
                "./RowFormatter": 149
            }
        ],
        151: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = Object.create ? function(e, t, r, n) {
                            void 0 === n && (n = r), Object.defineProperty(e, n, {
                                enumerable: !0,
                                get: function() {
                                    return t[r];
                                }
                            });
                        } : function(e, t, r, n) {
                            void 0 === n && (n = r), e[n] = t[r];
                        }, i = Object.create ? function(e, t) {
                            Object.defineProperty(e, "default", {
                                enumerable: !0,
                                value: t
                            });
                        } : function(e, t) {
                            e.default = t;
                        }, s = function(e) {
                            if (e && e.__esModule) return e;
                            var t = {};
                            if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                            return i(t, e), t;
                        }, o = function(e, t) {
                            for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                        };
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = r.FormatterOptions = r.CsvFormatterStream = void 0;
                        const a = e("util"), l = e("stream"), c = s(e("fs")), u = e("./FormatterOptions"), h = e("./CsvFormatterStream");
                        o(e("./types"), r);
                        var f = e("./CsvFormatterStream");
                        Object.defineProperty(r, "CsvFormatterStream", {
                            enumerable: !0,
                            get: function() {
                                return f.CsvFormatterStream;
                            }
                        });
                        var d = e("./FormatterOptions");
                        Object.defineProperty(r, "FormatterOptions", {
                            enumerable: !0,
                            get: function() {
                                return d.FormatterOptions;
                            }
                        }), r.format = (e)=>new h.CsvFormatterStream(new u.FormatterOptions(e)), r.write = (e, t)=>{
                            const n = r.format(t), i = a.promisify((e, t)=>{
                                n.write(e, void 0, t);
                            });
                            return e.reduce((e, t)=>e.then(()=>i(t)), Promise.resolve()).then(()=>n.end()).catch((e)=>{
                                n.emit("error", e);
                            }), n;
                        }, r.writeToStream = (e, t, n)=>r.write(t, n).pipe(e), r.writeToBuffer = function(e) {
                            let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            const i = [], s = new l.Writable({
                                write (e, t, r) {
                                    i.push(e), r();
                                }
                            });
                            return new Promise((o, a)=>{
                                s.on("error", a).on("finish", ()=>o(t.concat(i))), r.write(e, n).pipe(s);
                            });
                        }, r.writeToString = (e, t)=>r.writeToBuffer(e, t).then((e)=>e.toString()), r.writeToPath = (e, t, n)=>{
                            const i = c.createWriteStream(e, {
                                encoding: "utf8"
                            });
                            return r.write(t, n).pipe(i);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./CsvFormatterStream": 146,
                "./FormatterOptions": 147,
                "./types": 152,
                buffer: 220,
                fs: 216,
                stream: 505,
                util: 527
            }
        ],
        152: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length;
            },
            {}
        ],
        153: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvParserStream = void 0;
                        const n = e("string_decoder"), i = e("stream"), s = e("./transforms"), o = e("./parser");
                        class a extends i.Transform {
                            constructor(e){
                                super({
                                    objectMode: e.objectMode
                                }), this.lines = "", this.rowCount = 0, this.parsedRowCount = 0, this.parsedLineCount = 0, this.endEmitted = !1, this.headersEmitted = !1, this.parserOptions = e, this.parser = new o.Parser(e), this.headerTransformer = new s.HeaderTransformer(e), this.decoder = new n.StringDecoder(e.encoding), this.rowTransformerValidator = new s.RowTransformerValidator;
                            }
                            get hasHitRowLimit() {
                                return this.parserOptions.limitRows && this.rowCount >= this.parserOptions.maxRows;
                            }
                            get shouldEmitRows() {
                                return this.parsedRowCount > this.parserOptions.skipRows;
                            }
                            get shouldSkipLine() {
                                return this.parsedLineCount <= this.parserOptions.skipLines;
                            }
                            transform(e) {
                                return this.rowTransformerValidator.rowTransform = e, this;
                            }
                            validate(e) {
                                return this.rowTransformerValidator.rowValidator = e, this;
                            }
                            emit(e) {
                                if ("end" === e) return this.endEmitted || (this.endEmitted = !0, super.emit("end", this.rowCount)), !1;
                                for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                                return super.emit(e, ...r);
                            }
                            _transform(e, t, r) {
                                if (this.hasHitRowLimit) return r();
                                const n = a.wrapDoneCallback(r);
                                try {
                                    const { lines: t } = this, r = t + this.decoder.write(e), i = this.parse(r, !0);
                                    return this.processRows(i, n);
                                } catch (e) {
                                    return n(e);
                                }
                            }
                            _flush(e) {
                                const t = a.wrapDoneCallback(e);
                                if (this.hasHitRowLimit) return t();
                                try {
                                    const e = this.lines + this.decoder.end(), r = this.parse(e, !1);
                                    return this.processRows(r, t);
                                } catch (e) {
                                    return t(e);
                                }
                            }
                            parse(e, t) {
                                if (!e) return [];
                                const { line: r, rows: n } = this.parser.parse(e, t);
                                return this.lines = r, n;
                            }
                            processRows(e, r) {
                                const n = e.length, i = (s)=>{
                                    const o = (e)=>e ? r(e) : s % 100 != 0 ? i(s + 1) : void t(()=>i(s + 1));
                                    if (this.checkAndEmitHeaders(), s >= n || this.hasHitRowLimit) return r();
                                    if (this.parsedLineCount += 1, this.shouldSkipLine) return o();
                                    const a = e[s];
                                    this.rowCount += 1, this.parsedRowCount += 1;
                                    const l = this.rowCount;
                                    return this.transformRow(a, (e, t)=>{
                                        if (e) return this.rowCount -= 1, o(e);
                                        if (!t) return o(new Error("expected transform result"));
                                        if (t.isValid) {
                                            if (t.row) return this.pushRow(t.row, o);
                                        } else this.emit("data-invalid", t.row, l, t.reason);
                                        return o();
                                    });
                                };
                                i(0);
                            }
                            transformRow(e, t) {
                                try {
                                    this.headerTransformer.transform(e, (r, n)=>r ? t(r) : n ? n.isValid ? n.row ? this.shouldEmitRows ? this.rowTransformerValidator.transformAndValidate(n.row, t) : this.skipRow(t) : (this.rowCount -= 1, this.parsedRowCount -= 1, t(null, {
                                            row: null,
                                            isValid: !0
                                        })) : this.shouldEmitRows ? t(null, {
                                            isValid: !1,
                                            row: e
                                        }) : this.skipRow(t) : t(new Error("Expected result from header transform")));
                                } catch (e) {
                                    t(e);
                                }
                            }
                            checkAndEmitHeaders() {
                                !this.headersEmitted && this.headerTransformer.headers && (this.headersEmitted = !0, this.emit("headers", this.headerTransformer.headers));
                            }
                            skipRow(e) {
                                return this.rowCount -= 1, e(null, {
                                    row: null,
                                    isValid: !0
                                });
                            }
                            pushRow(e, t) {
                                try {
                                    this.parserOptions.objectMode ? this.push(e) : this.push(JSON.stringify(e)), t();
                                } catch (e) {
                                    t(e);
                                }
                            }
                            static wrapDoneCallback(e) {
                                let t = !1;
                                return function(r) {
                                    if (r) {
                                        if (t) throw r;
                                        return t = !0, void e(r);
                                    }
                                    for(var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)i[s - 1] = arguments[s];
                                    e(...i);
                                };
                            }
                        }
                        r.CsvParserStream = a;
                    }).call(this);
                }).call(this, e("timers").setImmediate);
            },
            {
                "./parser": 165,
                "./transforms": 168,
                stream: 505,
                string_decoder: 218,
                timers: 523
            }
        ],
        154: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ParserOptions = void 0;
                const i = n(e("lodash.escaperegexp")), s = n(e("lodash.isnil"));
                r.ParserOptions = class {
                    constructor(e){
                        var t;
                        if (this.objectMode = !0, this.delimiter = ",", this.ignoreEmpty = !1, this.quote = '"', this.escape = null, this.escapeChar = this.quote, this.comment = null, this.supportsComments = !1, this.ltrim = !1, this.rtrim = !1, this.trim = !1, this.headers = null, this.renameHeaders = !1, this.strictColumnHandling = !1, this.discardUnmappedColumns = !1, this.carriageReturn = "\r", this.encoding = "utf8", this.limitRows = !1, this.maxRows = 0, this.skipLines = 0, this.skipRows = 0, Object.assign(this, e || {}), this.delimiter.length > 1) throw new Error("delimiter option must be one character long");
                        this.escapedDelimiter = i.default(this.delimiter), this.escapeChar = null !== (t = this.escape) && void 0 !== t ? t : this.quote, this.supportsComments = !s.default(this.comment), this.NEXT_TOKEN_REGEXP = new RegExp(`([^\\s]|\\r\\n|\\n|\\r|${this.escapedDelimiter})`), this.maxRows > 0 && (this.limitRows = !0);
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isnil": 447
            }
        ],
        155: [
            function(e, t, r) {
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r), Object.defineProperty(e, n, {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    });
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }, s = function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, o = function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.parseString = r.parseFile = r.parseStream = r.parse = r.ParserOptions = r.CsvParserStream = void 0;
                const a = s(e("fs")), l = e("stream"), c = e("./ParserOptions"), u = e("./CsvParserStream");
                o(e("./types"), r);
                var h = e("./CsvParserStream");
                Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return h.CsvParserStream;
                    }
                });
                var f = e("./ParserOptions");
                Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return f.ParserOptions;
                    }
                }), r.parse = (e)=>new u.CsvParserStream(new c.ParserOptions(e)), r.parseStream = (e, t)=>e.pipe(new u.CsvParserStream(new c.ParserOptions(t))), r.parseFile = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return a.createReadStream(e).pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                }, r.parseString = (e, t)=>{
                    const r = new l.Readable;
                    return r.push(e), r.push(null), r.pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                };
            },
            {
                "./CsvParserStream": 153,
                "./ParserOptions": 154,
                "./types": 169,
                fs: 216,
                stream: 505
            }
        ],
        156: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Parser = void 0;
                const n = e("./Scanner"), i = e("./RowParser"), s = e("./Token");
                class o {
                    constructor(e){
                        this.parserOptions = e, this.rowParser = new i.RowParser(this.parserOptions);
                    }
                    static removeBOM(e) {
                        return e && 65279 === e.charCodeAt(0) ? e.slice(1) : e;
                    }
                    parse(e, t) {
                        const r = new n.Scanner({
                            line: o.removeBOM(e),
                            parserOptions: this.parserOptions,
                            hasMoreData: t
                        });
                        return this.parserOptions.supportsComments ? this.parseWithComments(r) : this.parseWithoutComments(r);
                    }
                    parseWithoutComments(e) {
                        const t = [];
                        let r = !0;
                        for(; r;)r = this.parseRow(e, t);
                        return {
                            line: e.line,
                            rows: t
                        };
                    }
                    parseWithComments(e) {
                        const { parserOptions: t } = this, r = [];
                        for(let n = e.nextCharacterToken; null !== n; n = e.nextCharacterToken)if (s.Token.isTokenComment(n, t)) {
                            if (null === e.advancePastLine()) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            if (!e.hasMoreCharacters) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            e.truncateToCursor();
                        } else if (!this.parseRow(e, r)) break;
                        return {
                            line: e.line,
                            rows: r
                        };
                    }
                    parseRow(e, t) {
                        if (!e.nextNonSpaceToken) return !1;
                        const r = this.rowParser.parse(e);
                        return null !== r && (this.parserOptions.ignoreEmpty && i.RowParser.isEmptyRow(r) || t.push(r), !0);
                    }
                }
                r.Parser = o;
            },
            {
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159
            }
        ],
        157: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowParser = void 0;
                const n = e("./column"), i = e("./Token");
                r.RowParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnParser = new n.ColumnParser(e);
                    }
                    static isEmptyRow(e) {
                        return "" === e.join("").replace(/\s+/g, "");
                    }
                    parse(e) {
                        const { parserOptions: t } = this, { hasMoreData: r } = e, n = e, s = [];
                        let o = this.getStartToken(n, s);
                        for(; o;){
                            if (i.Token.isTokenRowDelimiter(o)) return n.advancePastToken(o), !n.hasMoreCharacters && i.Token.isTokenCarriageReturn(o, t) && r ? null : (n.truncateToCursor(), s);
                            if (!this.shouldSkipColumnParse(n, o, s)) {
                                const e = this.columnParser.parse(n);
                                if (null === e) return null;
                                s.push(e);
                            }
                            o = n.nextNonSpaceToken;
                        }
                        return r ? null : (n.truncateToCursor(), s);
                    }
                    getStartToken(e, t) {
                        const r = e.nextNonSpaceToken;
                        return null !== r && i.Token.isTokenDelimiter(r, this.parserOptions) ? (t.push(""), e.nextNonSpaceToken) : r;
                    }
                    shouldSkipColumnParse(e, t, r) {
                        const { parserOptions: n } = this;
                        if (i.Token.isTokenDelimiter(t, n)) {
                            e.advancePastToken(t);
                            const s = e.nextCharacterToken;
                            if (!e.hasMoreCharacters || null !== s && i.Token.isTokenRowDelimiter(s)) return r.push(""), !0;
                            if (null !== s && i.Token.isTokenDelimiter(s, n)) return r.push(""), !0;
                        }
                        return !1;
                    }
                };
            },
            {
                "./Token": 159,
                "./column": 164
            }
        ],
        158: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Scanner = void 0;
                const n = e("./Token"), i = /((?:\r\n)|\n|\r)/;
                r.Scanner = class {
                    constructor(e){
                        this.cursor = 0, this.line = e.line, this.lineLength = this.line.length, this.parserOptions = e.parserOptions, this.hasMoreData = e.hasMoreData, this.cursor = e.cursor || 0;
                    }
                    get hasMoreCharacters() {
                        return this.lineLength > this.cursor;
                    }
                    get nextNonSpaceToken() {
                        const { lineFromCursor: e } = this, t = this.parserOptions.NEXT_TOKEN_REGEXP;
                        if (-1 === e.search(t)) return null;
                        const r = t.exec(e);
                        if (null == r) return null;
                        const i = r[1], s = this.cursor + (r.index || 0);
                        return new n.Token({
                            token: i,
                            startCursor: s,
                            endCursor: s + i.length - 1
                        });
                    }
                    get nextCharacterToken() {
                        const { cursor: e, lineLength: t } = this;
                        return t <= e ? null : new n.Token({
                            token: this.line[e],
                            startCursor: e,
                            endCursor: e
                        });
                    }
                    get lineFromCursor() {
                        return this.line.substr(this.cursor);
                    }
                    advancePastLine() {
                        const e = i.exec(this.lineFromCursor);
                        return e ? (this.cursor += (e.index || 0) + e[0].length, this) : this.hasMoreData ? null : (this.cursor = this.lineLength, this);
                    }
                    advanceTo(e) {
                        return this.cursor = e, this;
                    }
                    advanceToToken(e) {
                        return this.cursor = e.startCursor, this;
                    }
                    advancePastToken(e) {
                        return this.cursor = e.endCursor + 1, this;
                    }
                    truncateToCursor() {
                        return this.line = this.lineFromCursor, this.lineLength = this.line.length, this.cursor = 0, this;
                    }
                };
            },
            {
                "./Token": 159
            }
        ],
        159: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Token = void 0;
                r.Token = class {
                    constructor(e){
                        this.token = e.token, this.startCursor = e.startCursor, this.endCursor = e.endCursor;
                    }
                    static isTokenRowDelimiter(e) {
                        const t = e.token;
                        return "\r" === t || "\n" === t || "\r\n" === t;
                    }
                    static isTokenCarriageReturn(e, t) {
                        return e.token === t.carriageReturn;
                    }
                    static isTokenComment(e, t) {
                        return t.supportsComments && !!e && e.token === t.comment;
                    }
                    static isTokenEscapeCharacter(e, t) {
                        return e.token === t.escapeChar;
                    }
                    static isTokenQuote(e, t) {
                        return e.token === t.quote;
                    }
                    static isTokenDelimiter(e, t) {
                        return e.token === t.delimiter;
                    }
                };
            },
            {}
        ],
        160: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = void 0;
                r.ColumnFormatter = class {
                    constructor(e){
                        e.trim ? this.format = (e)=>e.trim() : e.ltrim ? this.format = (e)=>e.trimLeft() : e.rtrim ? this.format = (e)=>e.trimRight() : this.format = (e)=>e;
                    }
                };
            },
            {}
        ],
        161: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnParser = void 0;
                const n = e("./NonQuotedColumnParser"), i = e("./QuotedColumnParser"), s = e("../Token");
                r.ColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.quotedColumnParser = new i.QuotedColumnParser(e), this.nonQuotedColumnParser = new n.NonQuotedColumnParser(e);
                    }
                    parse(e) {
                        const { nextNonSpaceToken: t } = e;
                        return null !== t && s.Token.isTokenQuote(t, this.parserOptions) ? (e.advanceToToken(t), this.quotedColumnParser.parse(e)) : this.nonQuotedColumnParser.parse(e);
                    }
                };
            },
            {
                "../Token": 159,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        162: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NonQuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.NonQuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const { parserOptions: t } = this, r = [];
                        let n = e.nextCharacterToken;
                        for(; n && !i.Token.isTokenDelimiter(n, t) && !i.Token.isTokenRowDelimiter(n); n = e.nextCharacterToken)r.push(n.token), e.advancePastToken(n);
                        return this.columnFormatter.format(r.join(""));
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        163: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.QuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const t = e.cursor, { foundClosingQuote: r, col: n } = this.gatherDataBetweenQuotes(e);
                        if (!r) {
                            if (e.advanceTo(t), !e.hasMoreData) throw new Error(`Parse Error: missing closing: '${this.parserOptions.quote || ""}' in line: at '${e.lineFromCursor.replace(/[\r\n]/g, "\\n'")}'`);
                            return null;
                        }
                        return this.checkForMalformedColumn(e), n;
                    }
                    gatherDataBetweenQuotes(e) {
                        const { parserOptions: t } = this;
                        let r = !1, n = !1;
                        const s = [];
                        let o = e.nextCharacterToken;
                        for(; !n && null !== o; o = e.nextCharacterToken){
                            const a = i.Token.isTokenQuote(o, t);
                            if (!r && a) r = !0;
                            else if (r) {
                                if (i.Token.isTokenEscapeCharacter(o, t)) {
                                    e.advancePastToken(o);
                                    const r = e.nextCharacterToken;
                                    null !== r && (i.Token.isTokenQuote(r, t) || i.Token.isTokenEscapeCharacter(r, t)) ? (s.push(r.token), o = r) : a ? n = !0 : s.push(o.token);
                                } else a ? n = !0 : s.push(o.token);
                            }
                            e.advancePastToken(o);
                        }
                        return {
                            col: this.columnFormatter.format(s.join("")),
                            foundClosingQuote: n
                        };
                    }
                    checkForMalformedColumn(e) {
                        const { parserOptions: t } = this, { nextNonSpaceToken: r } = e;
                        if (r) {
                            const n = i.Token.isTokenDelimiter(r, t), s = i.Token.isTokenRowDelimiter(r);
                            if (!n && !s) {
                                const n = e.lineFromCursor.substr(0, 10).replace(/[\r\n]/g, "\\n'");
                                throw new Error(`Parse Error: expected: '${t.escapedDelimiter}' OR new line got: '${r.token}'. at '${n}`);
                            }
                            e.advanceToToken(r);
                        } else e.hasMoreData || e.advancePastLine();
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        164: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = void 0;
                var n = e("./ColumnParser");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return n.ColumnParser;
                    }
                });
                var i = e("./NonQuotedColumnParser");
                Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return i.NonQuotedColumnParser;
                    }
                });
                var s = e("./QuotedColumnParser");
                Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return s.QuotedColumnParser;
                    }
                });
                var o = e("./ColumnFormatter");
                Object.defineProperty(r, "ColumnFormatter", {
                    enumerable: !0,
                    get: function() {
                        return o.ColumnFormatter;
                    }
                });
            },
            {
                "./ColumnFormatter": 160,
                "./ColumnParser": 161,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        165: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = r.Token = r.Scanner = r.RowParser = r.Parser = void 0;
                var n = e("./Parser");
                Object.defineProperty(r, "Parser", {
                    enumerable: !0,
                    get: function() {
                        return n.Parser;
                    }
                });
                var i = e("./RowParser");
                Object.defineProperty(r, "RowParser", {
                    enumerable: !0,
                    get: function() {
                        return i.RowParser;
                    }
                });
                var s = e("./Scanner");
                Object.defineProperty(r, "Scanner", {
                    enumerable: !0,
                    get: function() {
                        return s.Scanner;
                    }
                });
                var o = e("./Token");
                Object.defineProperty(r, "Token", {
                    enumerable: !0,
                    get: function() {
                        return o.Token;
                    }
                });
                var a = e("./column");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.ColumnParser;
                    }
                }), Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.NonQuotedColumnParser;
                    }
                }), Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.QuotedColumnParser;
                    }
                });
            },
            {
                "./Parser": 156,
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159,
                "./column": 164
            }
        ],
        166: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = void 0;
                const i = n(e("lodash.isundefined")), s = n(e("lodash.isfunction")), o = n(e("lodash.uniq")), a = n(e("lodash.groupby"));
                r.HeaderTransformer = class {
                    constructor(e){
                        this.headers = null, this.receivedHeaders = !1, this.shouldUseFirstRow = !1, this.processedFirstRow = !1, this.headersLength = 0, this.parserOptions = e, !0 === e.headers ? this.shouldUseFirstRow = !0 : Array.isArray(e.headers) ? this.setHeaders(e.headers) : s.default(e.headers) && (this.headersTransform = e.headers);
                    }
                    transform(e, t) {
                        return this.shouldMapRow(e) ? t(null, this.processRow(e)) : t(null, {
                            row: null,
                            isValid: !0
                        });
                    }
                    shouldMapRow(e) {
                        const { parserOptions: t } = this;
                        if (!this.headersTransform && t.renameHeaders && !this.processedFirstRow) {
                            if (!this.receivedHeaders) throw new Error("Error renaming headers: new headers must be provided in an array");
                            return this.processedFirstRow = !0, !1;
                        }
                        if (!this.receivedHeaders && Array.isArray(e)) {
                            if (this.headersTransform) this.setHeaders(this.headersTransform(e));
                            else {
                                if (!this.shouldUseFirstRow) return !0;
                                this.setHeaders(e);
                            }
                            return !1;
                        }
                        return !0;
                    }
                    processRow(e) {
                        if (!this.headers) return {
                            row: e,
                            isValid: !0
                        };
                        const { parserOptions: t } = this;
                        if (!t.discardUnmappedColumns && e.length > this.headersLength) {
                            if (!t.strictColumnHandling) throw new Error(`Unexpected Error: column header mismatch expected: ${this.headersLength} columns got: ${e.length}`);
                            return {
                                row: e,
                                isValid: !1,
                                reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                            };
                        }
                        return t.strictColumnHandling && e.length < this.headersLength ? {
                            row: e,
                            isValid: !1,
                            reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                        } : {
                            row: this.mapHeaders(e),
                            isValid: !0
                        };
                    }
                    mapHeaders(e) {
                        const t = {}, { headers: r, headersLength: n } = this;
                        for(let s = 0; s < n; s += 1){
                            const n = r[s];
                            if (!i.default(n)) {
                                const r = e[s];
                                i.default(r) ? t[n] = "" : t[n] = r;
                            }
                        }
                        return t;
                    }
                    setHeaders(e) {
                        var t;
                        const r = e.filter((e)=>!!e);
                        if (o.default(r).length !== r.length) {
                            const e = a.default(r), t = Object.keys(e).filter((t)=>e[t].length > 1);
                            throw new Error("Duplicate headers found " + JSON.stringify(t));
                        }
                        this.headers = e, this.receivedHeaders = !0, this.headersLength = (null === (t = this.headers) || void 0 === t ? void 0 : t.length) || 0;
                    }
                };
            },
            {
                "lodash.groupby": 443,
                "lodash.isfunction": 446,
                "lodash.isundefined": 448,
                "lodash.uniq": 449
            }
        ],
        167: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowTransformerValidator = void 0;
                const i = n(e("lodash.isfunction")), s = e("../types");
                class o {
                    constructor(){
                        this._rowTransform = null, this._rowValidator = null;
                    }
                    static createTransform(e) {
                        return s.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : e;
                    }
                    static createValidator(e) {
                        return s.isSyncValidate(e) ? (t, r)=>{
                            r(null, {
                                row: t,
                                isValid: e(t)
                            });
                        } : (t, r)=>{
                            e(t, (e, n, i)=>e ? r(e) : r(null, n ? {
                                    row: t,
                                    isValid: n,
                                    reason: i
                                } : {
                                    row: t,
                                    isValid: !1,
                                    reason: i
                                }));
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = o.createTransform(e);
                    }
                    set rowValidator(e) {
                        if (!i.default(e)) throw new TypeError("The validate should be a function");
                        this._rowValidator = o.createValidator(e);
                    }
                    transformAndValidate(e, t) {
                        return this.callTransformer(e, (e, r)=>e ? t(e) : r ? this.callValidator(r, (e, n)=>e ? t(e) : n && !n.isValid ? t(null, {
                                    row: r,
                                    isValid: !1,
                                    reason: n.reason
                                }) : t(null, {
                                    row: r,
                                    isValid: !0
                                })) : t(null, {
                                row: null,
                                isValid: !0
                            }));
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    callValidator(e, t) {
                        return this._rowValidator ? this._rowValidator(e, t) : t(null, {
                            row: e,
                            isValid: !0
                        });
                    }
                }
                r.RowTransformerValidator = o;
            },
            {
                "../types": 169,
                "lodash.isfunction": 446
            }
        ],
        168: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = r.RowTransformerValidator = void 0;
                var n = e("./RowTransformerValidator");
                Object.defineProperty(r, "RowTransformerValidator", {
                    enumerable: !0,
                    get: function() {
                        return n.RowTransformerValidator;
                    }
                });
                var i = e("./HeaderTransformer");
                Object.defineProperty(r, "HeaderTransformer", {
                    enumerable: !0,
                    get: function() {
                        return i.HeaderTransformer;
                    }
                });
            },
            {
                "./HeaderTransformer": 166,
                "./RowTransformerValidator": 167
            }
        ],
        169: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncValidate = r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length, r.isSyncValidate = (e)=>1 === e.length;
            },
            {}
        ],
        170: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.bignum = e("bn.js"), n.define = e("./asn1/api").define, n.base = e("./asn1/base"), n.constants = e("./asn1/constants"), n.decoders = e("./asn1/decoders"), n.encoders = e("./asn1/encoders");
            },
            {
                "./asn1/api": 171,
                "./asn1/base": 173,
                "./asn1/constants": 177,
                "./asn1/decoders": 179,
                "./asn1/encoders": 182,
                "bn.js": 184
            }
        ],
        171: [
            function(e, t, r) {
                "use strict";
                const n = e("./encoders"), i = e("./decoders"), s = e("inherits");
                function o(e, t) {
                    this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
                }
                r.define = function(e, t) {
                    return new o(e, t);
                }, o.prototype._createNamed = function(e) {
                    const t = this.name;
                    function r(e) {
                        this._initNamed(e, t);
                    }
                    return s(r, e), r.prototype._initNamed = function(t, r) {
                        e.call(this, t, r);
                    }, new r(this);
                }, o.prototype._getDecoder = function(e) {
                    return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(i[e])), this.decoders[e];
                }, o.prototype.decode = function(e, t, r) {
                    return this._getDecoder(t).decode(e, r);
                }, o.prototype._getEncoder = function(e) {
                    return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(n[e])), this.encoders[e];
                }, o.prototype.encode = function(e, t, r) {
                    return this._getEncoder(t).encode(e, r);
                };
            },
            {
                "./decoders": 179,
                "./encoders": 182,
                inherits: 440
            }
        ],
        172: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("../base/reporter").Reporter, s = e("safer-buffer").Buffer;
                function o(e, t) {
                    i.call(this, t), s.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
                }
                function a(e, t) {
                    if (Array.isArray(e)) this.length = 0, this.value = e.map(function(e) {
                        return a.isEncoderBuffer(e) || (e = new a(e, t)), this.length += e.length, e;
                    }, this);
                    else if ("number" == typeof e) {
                        if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
                        this.value = e, this.length = 1;
                    } else if ("string" == typeof e) this.value = e, this.length = s.byteLength(e);
                    else {
                        if (!s.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
                        this.value = e, this.length = e.length;
                    }
                }
                n(o, i), r.DecoderBuffer = o, o.isDecoderBuffer = function(e) {
                    if (e instanceof o) return !0;
                    return "object" == typeof e && s.isBuffer(e.base) && "DecoderBuffer" === e.constructor.name && "number" == typeof e.offset && "number" == typeof e.length && "function" == typeof e.save && "function" == typeof e.restore && "function" == typeof e.isEmpty && "function" == typeof e.readUInt8 && "function" == typeof e.skip && "function" == typeof e.raw;
                }, o.prototype.save = function() {
                    return {
                        offset: this.offset,
                        reporter: i.prototype.save.call(this)
                    };
                }, o.prototype.restore = function(e) {
                    const t = new o(this.base);
                    return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, i.prototype.restore.call(this, e.reporter), t;
                }, o.prototype.isEmpty = function() {
                    return this.offset === this.length;
                }, o.prototype.readUInt8 = function(e) {
                    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
                }, o.prototype.skip = function(e, t) {
                    if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
                    const r = new o(this.base);
                    return r._reporterState = this._reporterState, r.offset = this.offset, r.length = this.offset + e, this.offset += e, r;
                }, o.prototype.raw = function(e) {
                    return this.base.slice(e ? e.offset : this.offset, this.length);
                }, r.EncoderBuffer = a, a.isEncoderBuffer = function(e) {
                    if (e instanceof a) return !0;
                    return "object" == typeof e && "EncoderBuffer" === e.constructor.name && "number" == typeof e.length && "function" == typeof e.join;
                }, a.prototype.join = function(e, t) {
                    return e || (e = s.alloc(this.length)), t || (t = 0), 0 === this.length || (Array.isArray(this.value) ? this.value.forEach(function(r) {
                        r.join(e, t), t += r.length;
                    }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : s.isBuffer(this.value) && this.value.copy(e, t), t += this.length)), e;
                };
            },
            {
                "../base/reporter": 175,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        173: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.Reporter = e("./reporter").Reporter, n.DecoderBuffer = e("./buffer").DecoderBuffer, n.EncoderBuffer = e("./buffer").EncoderBuffer, n.Node = e("./node");
            },
            {
                "./buffer": 172,
                "./node": 174,
                "./reporter": 175
            }
        ],
        174: [
            function(e, t, r) {
                "use strict";
                const n = e("../base/reporter").Reporter, i = e("../base/buffer").EncoderBuffer, s = e("../base/buffer").DecoderBuffer, o = e("minimalistic-assert"), a = [
                    "seq",
                    "seqof",
                    "set",
                    "setof",
                    "objid",
                    "bool",
                    "gentime",
                    "utctime",
                    "null_",
                    "enum",
                    "int",
                    "objDesc",
                    "bitstr",
                    "bmpstr",
                    "charstr",
                    "genstr",
                    "graphstr",
                    "ia5str",
                    "iso646str",
                    "numstr",
                    "octstr",
                    "printstr",
                    "t61str",
                    "unistr",
                    "utf8str",
                    "videostr"
                ], l = [
                    "key",
                    "obj",
                    "use",
                    "optional",
                    "explicit",
                    "implicit",
                    "def",
                    "choice",
                    "any",
                    "contains"
                ].concat(a);
                function c(e, t, r) {
                    const n = {};
                    this._baseState = n, n.name = r, n.enc = e, n.parent = t || null, n.children = null, n.tag = null, n.args = null, n.reverseArgs = null, n.choice = null, n.optional = !1, n.any = !1, n.obj = !1, n.use = null, n.useDecoder = null, n.key = null, n.default = null, n.explicit = null, n.implicit = null, n.contains = null, n.parent || (n.children = [], this._wrap());
                }
                t.exports = c;
                const u = [
                    "enc",
                    "parent",
                    "children",
                    "tag",
                    "args",
                    "reverseArgs",
                    "choice",
                    "optional",
                    "any",
                    "obj",
                    "use",
                    "alteredUse",
                    "key",
                    "default",
                    "explicit",
                    "implicit",
                    "contains"
                ];
                c.prototype.clone = function() {
                    const e = this._baseState, t = {};
                    u.forEach(function(r) {
                        t[r] = e[r];
                    });
                    const r = new this.constructor(t.parent);
                    return r._baseState = t, r;
                }, c.prototype._wrap = function() {
                    const e = this._baseState;
                    l.forEach(function(t) {
                        this[t] = function() {
                            const r = new this.constructor(this);
                            return e.children.push(r), r[t].apply(r, arguments);
                        };
                    }, this);
                }, c.prototype._init = function(e) {
                    const t = this._baseState;
                    o(null === t.parent), e.call(this), t.children = t.children.filter(function(e) {
                        return e._baseState.parent === this;
                    }, this), o.equal(t.children.length, 1, "Root node can have only one child");
                }, c.prototype._useArgs = function(e) {
                    const t = this._baseState, r = e.filter(function(e) {
                        return e instanceof this.constructor;
                    }, this);
                    e = e.filter(function(e) {
                        return !(e instanceof this.constructor);
                    }, this), 0 !== r.length && (o(null === t.children), t.children = r, r.forEach(function(e) {
                        e._baseState.parent = this;
                    }, this)), 0 !== e.length && (o(null === t.args), t.args = e, t.reverseArgs = e.map(function(e) {
                        if ("object" != typeof e || e.constructor !== Object) return e;
                        const t = {};
                        return Object.keys(e).forEach(function(r) {
                            r == (0 | r) && (r |= 0);
                            const n = e[r];
                            t[n] = r;
                        }), t;
                    }));
                }, [
                    "_peekTag",
                    "_decodeTag",
                    "_use",
                    "_decodeStr",
                    "_decodeObjid",
                    "_decodeTime",
                    "_decodeNull",
                    "_decodeInt",
                    "_decodeBool",
                    "_decodeList",
                    "_encodeComposite",
                    "_encodeStr",
                    "_encodeObjid",
                    "_encodeTime",
                    "_encodeNull",
                    "_encodeInt",
                    "_encodeBool"
                ].forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState;
                        throw new Error(e + " not implemented for encoding: " + t.enc);
                    };
                }), a.forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState, r = Array.prototype.slice.call(arguments);
                        return o(null === t.tag), t.tag = e, this._useArgs(r), this;
                    };
                }), c.prototype.use = function(e) {
                    o(e);
                    const t = this._baseState;
                    return o(null === t.use), t.use = e, this;
                }, c.prototype.optional = function() {
                    return this._baseState.optional = !0, this;
                }, c.prototype.def = function(e) {
                    const t = this._baseState;
                    return o(null === t.default), t.default = e, t.optional = !0, this;
                }, c.prototype.explicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.explicit = e, this;
                }, c.prototype.implicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.implicit = e, this;
                }, c.prototype.obj = function() {
                    const e = this._baseState, t = Array.prototype.slice.call(arguments);
                    return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
                }, c.prototype.key = function(e) {
                    const t = this._baseState;
                    return o(null === t.key), t.key = e, this;
                }, c.prototype.any = function() {
                    return this._baseState.any = !0, this;
                }, c.prototype.choice = function(e) {
                    const t = this._baseState;
                    return o(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function(t) {
                        return e[t];
                    })), this;
                }, c.prototype.contains = function(e) {
                    const t = this._baseState;
                    return o(null === t.use), t.contains = e, this;
                }, c.prototype._decode = function(e, t) {
                    const r = this._baseState;
                    if (null === r.parent) return e.wrapResult(r.children[0]._decode(e, t));
                    let n, i = r.default, o = !0, a = null;
                    if (null !== r.key && (a = e.enterKey(r.key)), r.optional) {
                        let n = null;
                        if (null !== r.explicit ? n = r.explicit : null !== r.implicit ? n = r.implicit : null !== r.tag && (n = r.tag), null !== n || r.any) {
                            if (o = this._peekTag(e, n, r.any), e.isError(o)) return o;
                        } else {
                            const n = e.save();
                            try {
                                null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), o = !0;
                            } catch (e) {
                                o = !1;
                            }
                            e.restore(n);
                        }
                    }
                    if (r.obj && o && (n = e.enterObject()), o) {
                        if (null !== r.explicit) {
                            const t = this._decodeTag(e, r.explicit);
                            if (e.isError(t)) return t;
                            e = t;
                        }
                        const n = e.offset;
                        if (null === r.use && null === r.choice) {
                            let t;
                            r.any && (t = e.save());
                            const n = this._decodeTag(e, null !== r.implicit ? r.implicit : r.tag, r.any);
                            if (e.isError(n)) return n;
                            r.any ? i = e.raw(t) : e = n;
                        }
                        if (t && t.track && null !== r.tag && t.track(e.path(), n, e.length, "tagged"), t && t.track && null !== r.tag && t.track(e.path(), e.offset, e.length, "content"), r.any || (i = null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t)), e.isError(i)) return i;
                        if (r.any || null !== r.choice || null === r.children || r.children.forEach(function(r) {
                            r._decode(e, t);
                        }), r.contains && ("octstr" === r.tag || "bitstr" === r.tag)) {
                            const n = new s(i);
                            i = this._getUse(r.contains, e._reporterState.obj)._decode(n, t);
                        }
                    }
                    return r.obj && o && (i = e.leaveObject(n)), null === r.key || null === i && !0 !== o ? null !== a && e.exitKey(a) : e.leaveKey(a, r.key, i), i;
                }, c.prototype._decodeGeneric = function(e, t, r) {
                    const n = this._baseState;
                    return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, n.args[0], r) : /str$/.test(e) ? this._decodeStr(t, e, r) : "objid" === e && n.args ? this._decodeObjid(t, n.args[0], n.args[1], r) : "objid" === e ? this._decodeObjid(t, null, null, r) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, r) : "null_" === e ? this._decodeNull(t, r) : "bool" === e ? this._decodeBool(t, r) : "objDesc" === e ? this._decodeStr(t, e, r) : "int" === e || "enum" === e ? this._decodeInt(t, n.args && n.args[0], r) : null !== n.use ? this._getUse(n.use, t._reporterState.obj)._decode(t, r) : t.error("unknown tag: " + e);
                }, c.prototype._getUse = function(e, t) {
                    const r = this._baseState;
                    return r.useDecoder = this._use(e, t), o(null === r.useDecoder._baseState.parent), r.useDecoder = r.useDecoder._baseState.children[0], r.implicit !== r.useDecoder._baseState.implicit && (r.useDecoder = r.useDecoder.clone(), r.useDecoder._baseState.implicit = r.implicit), r.useDecoder;
                }, c.prototype._decodeChoice = function(e, t) {
                    const r = this._baseState;
                    let n = null, i = !1;
                    return Object.keys(r.choice).some(function(s) {
                        const o = e.save(), a = r.choice[s];
                        try {
                            const r = a._decode(e, t);
                            if (e.isError(r)) return !1;
                            n = {
                                type: s,
                                value: r
                            }, i = !0;
                        } catch (t) {
                            return e.restore(o), !1;
                        }
                        return !0;
                    }, this), i ? n : e.error("Choice not matched");
                }, c.prototype._createEncoderBuffer = function(e) {
                    return new i(e, this.reporter);
                }, c.prototype._encode = function(e, t, r) {
                    const n = this._baseState;
                    if (null !== n.default && n.default === e) return;
                    const i = this._encodeValue(e, t, r);
                    return void 0 === i || this._skipDefault(i, t, r) ? void 0 : i;
                }, c.prototype._encodeValue = function(e, t, r) {
                    const i = this._baseState;
                    if (null === i.parent) return i.children[0]._encode(e, t || new n);
                    let s = null;
                    if (this.reporter = t, i.optional && void 0 === e) {
                        if (null === i.default) return;
                        e = i.default;
                    }
                    let o = null, a = !1;
                    if (i.any) s = this._createEncoderBuffer(e);
                    else if (i.choice) s = this._encodeChoice(e, t);
                    else if (i.contains) o = this._getUse(i.contains, r)._encode(e, t), a = !0;
                    else if (i.children) o = i.children.map(function(r) {
                        if ("null_" === r._baseState.tag) return r._encode(null, t, e);
                        if (null === r._baseState.key) return t.error("Child should have a key");
                        const n = t.enterKey(r._baseState.key);
                        if ("object" != typeof e) return t.error("Child expected, but input is not object");
                        const i = r._encode(e[r._baseState.key], t, e);
                        return t.leaveKey(n), i;
                    }, this).filter(function(e) {
                        return e;
                    }), o = this._createEncoderBuffer(o);
                    else if ("seqof" === i.tag || "setof" === i.tag) {
                        if (!i.args || 1 !== i.args.length) return t.error("Too many args for : " + i.tag);
                        if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
                        const r = this.clone();
                        r._baseState.implicit = null, o = this._createEncoderBuffer(e.map(function(r) {
                            const n = this._baseState;
                            return this._getUse(n.args[0], e)._encode(r, t);
                        }, r));
                    } else null !== i.use ? s = this._getUse(i.use, r)._encode(e, t) : (o = this._encodePrimitive(i.tag, e), a = !0);
                    if (!i.any && null === i.choice) {
                        const e = null !== i.implicit ? i.implicit : i.tag, r = null === i.implicit ? "universal" : "context";
                        null === e ? null === i.use && t.error("Tag could be omitted only for .use()") : null === i.use && (s = this._encodeComposite(e, a, r, o));
                    }
                    return null !== i.explicit && (s = this._encodeComposite(i.explicit, !1, "context", s)), s;
                }, c.prototype._encodeChoice = function(e, t) {
                    const r = this._baseState, n = r.choice[e.type];
                    return n || o(!1, e.type + " not found in " + JSON.stringify(Object.keys(r.choice))), n._encode(e.value, t);
                }, c.prototype._encodePrimitive = function(e, t) {
                    const r = this._baseState;
                    if (/str$/.test(e)) return this._encodeStr(t, e);
                    if ("objid" === e && r.args) return this._encodeObjid(t, r.reverseArgs[0], r.args[1]);
                    if ("objid" === e) return this._encodeObjid(t, null, null);
                    if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
                    if ("null_" === e) return this._encodeNull();
                    if ("int" === e || "enum" === e) return this._encodeInt(t, r.args && r.reverseArgs[0]);
                    if ("bool" === e) return this._encodeBool(t);
                    if ("objDesc" === e) return this._encodeStr(t, e);
                    throw new Error("Unsupported tag: " + e);
                }, c.prototype._isNumstr = function(e) {
                    return /^[0-9 ]*$/.test(e);
                }, c.prototype._isPrintstr = function(e) {
                    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(e);
                };
            },
            {
                "../base/buffer": 172,
                "../base/reporter": 175,
                "minimalistic-assert": 453
            }
        ],
        175: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits");
                function i(e) {
                    this._reporterState = {
                        obj: null,
                        path: [],
                        options: e || {},
                        errors: []
                    };
                }
                function s(e, t) {
                    this.path = e, this.rethrow(t);
                }
                r.Reporter = i, i.prototype.isError = function(e) {
                    return e instanceof s;
                }, i.prototype.save = function() {
                    const e = this._reporterState;
                    return {
                        obj: e.obj,
                        pathLen: e.path.length
                    };
                }, i.prototype.restore = function(e) {
                    const t = this._reporterState;
                    t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
                }, i.prototype.enterKey = function(e) {
                    return this._reporterState.path.push(e);
                }, i.prototype.exitKey = function(e) {
                    const t = this._reporterState;
                    t.path = t.path.slice(0, e - 1);
                }, i.prototype.leaveKey = function(e, t, r) {
                    const n = this._reporterState;
                    this.exitKey(e), null !== n.obj && (n.obj[t] = r);
                }, i.prototype.path = function() {
                    return this._reporterState.path.join("/");
                }, i.prototype.enterObject = function() {
                    const e = this._reporterState, t = e.obj;
                    return e.obj = {}, t;
                }, i.prototype.leaveObject = function(e) {
                    const t = this._reporterState, r = t.obj;
                    return t.obj = e, r;
                }, i.prototype.error = function(e) {
                    let t;
                    const r = this._reporterState, n = e instanceof s;
                    if (t = n ? e : new s(r.path.map(function(e) {
                        return "[" + JSON.stringify(e) + "]";
                    }).join(""), e.message || e, e.stack), !r.options.partial) throw t;
                    return n || r.errors.push(t), t;
                }, i.prototype.wrapResult = function(e) {
                    const t = this._reporterState;
                    return t.options.partial ? {
                        result: this.isError(e) ? null : e,
                        errors: t.errors
                    } : e;
                }, n(s, Error), s.prototype.rethrow = function(e) {
                    if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, s), !this.stack) try {
                        throw new Error(this.message);
                    } catch (e) {
                        this.stack = e.stack;
                    }
                    return this;
                };
            },
            {
                inherits: 440
            }
        ],
        176: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }
                r.tagClass = {
                    0: "universal",
                    1: "application",
                    2: "context",
                    3: "private"
                }, r.tagClassByName = n(r.tagClass), r.tag = {
                    0: "end",
                    1: "bool",
                    2: "int",
                    3: "bitstr",
                    4: "octstr",
                    5: "null_",
                    6: "objid",
                    7: "objDesc",
                    8: "external",
                    9: "real",
                    10: "enum",
                    11: "embed",
                    12: "utf8str",
                    13: "relativeOid",
                    16: "seq",
                    17: "set",
                    18: "numstr",
                    19: "printstr",
                    20: "t61str",
                    21: "videostr",
                    22: "ia5str",
                    23: "utctime",
                    24: "gentime",
                    25: "graphstr",
                    26: "iso646str",
                    27: "genstr",
                    28: "unistr",
                    29: "charstr",
                    30: "bmpstr"
                }, r.tagByName = n(r.tag);
            },
            {}
        ],
        177: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n._reverse = function(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }, n.der = e("./der");
            },
            {
                "./der": 176
            }
        ],
        178: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("bn.js"), s = e("../base/buffer").DecoderBuffer, o = e("../base/node"), a = e("../constants/der");
                function l(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c, this.tree._init(e.body);
                }
                function c(e) {
                    o.call(this, "der", e);
                }
                function u(e, t) {
                    let r = e.readUInt8(t);
                    if (e.isError(r)) return r;
                    const n = a.tagClass[r >> 6], i = 0 == (32 & r);
                    if (31 == (31 & r)) {
                        let n = r;
                        for(r = 0; 128 == (128 & n);){
                            if (n = e.readUInt8(t), e.isError(n)) return n;
                            r <<= 7, r |= 127 & n;
                        }
                    } else r &= 31;
                    return {
                        cls: n,
                        primitive: i,
                        tag: r,
                        tagStr: a.tag[r]
                    };
                }
                function h(e, t, r) {
                    let n = e.readUInt8(r);
                    if (e.isError(n)) return n;
                    if (!t && 128 === n) return null;
                    if (0 == (128 & n)) return n;
                    const i = 127 & n;
                    if (i > 4) return e.error("length octect is too long");
                    n = 0;
                    for(let t = 0; t < i; t++){
                        n <<= 8;
                        const t = e.readUInt8(r);
                        if (e.isError(t)) return t;
                        n |= t;
                    }
                    return n;
                }
                t.exports = l, l.prototype.decode = function(e, t) {
                    return s.isDecoderBuffer(e) || (e = new s(e, t)), this.tree._decode(e, t);
                }, n(c, o), c.prototype._peekTag = function(e, t, r) {
                    if (e.isEmpty()) return !1;
                    const n = e.save(), i = u(e, 'Failed to peek tag: "' + t + '"');
                    return e.isError(i) ? i : (e.restore(n), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || r);
                }, c.prototype._decodeTag = function(e, t, r) {
                    const n = u(e, 'Failed to decode tag of "' + t + '"');
                    if (e.isError(n)) return n;
                    let i = h(e, n.primitive, 'Failed to get length of "' + t + '"');
                    if (e.isError(i)) return i;
                    if (!r && n.tag !== t && n.tagStr !== t && n.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
                    if (n.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');
                    const s = e.save(), o = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');
                    return e.isError(o) ? o : (i = e.offset - s.offset, e.restore(s), e.skip(i, 'Failed to match body of: "' + t + '"'));
                }, c.prototype._skipUntilEnd = function(e, t) {
                    for(;;){
                        const r = u(e, t);
                        if (e.isError(r)) return r;
                        const n = h(e, r.primitive, t);
                        if (e.isError(n)) return n;
                        let i;
                        if (i = r.primitive || null !== n ? e.skip(n) : this._skipUntilEnd(e, t), e.isError(i)) return i;
                        if ("end" === r.tagStr) break;
                    }
                }, c.prototype._decodeList = function(e, t, r, n) {
                    const i = [];
                    for(; !e.isEmpty();){
                        const t = this._peekTag(e, "end");
                        if (e.isError(t)) return t;
                        const s = r.decode(e, "der", n);
                        if (e.isError(s) && t) break;
                        i.push(s);
                    }
                    return i;
                }, c.prototype._decodeStr = function(e, t) {
                    if ("bitstr" === t) {
                        const t = e.readUInt8();
                        return e.isError(t) ? t : {
                            unused: t,
                            data: e.raw()
                        };
                    }
                    if ("bmpstr" === t) {
                        const t = e.raw();
                        if (t.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");
                        let r = "";
                        for(let e = 0; e < t.length / 2; e++)r += String.fromCharCode(t.readUInt16BE(2 * e));
                        return r;
                    }
                    if ("numstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isNumstr(t) ? t : e.error("Decoding of string type: numstr unsupported characters");
                    }
                    if ("octstr" === t) return e.raw();
                    if ("objDesc" === t) return e.raw();
                    if ("printstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isPrintstr(t) ? t : e.error("Decoding of string type: printstr unsupported characters");
                    }
                    return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
                }, c.prototype._decodeObjid = function(e, t, r) {
                    let n;
                    const i = [];
                    let s = 0, o = 0;
                    for(; !e.isEmpty();)o = e.readUInt8(), s <<= 7, s |= 127 & o, 0 == (128 & o) && (i.push(s), s = 0);
                    128 & o && i.push(s);
                    const a = i[0] / 40 | 0, l = i[0] % 40;
                    if (n = r ? i : [
                        a,
                        l
                    ].concat(i.slice(1)), t) {
                        let e = t[n.join(" ")];
                        void 0 === e && (e = t[n.join(".")]), void 0 !== e && (n = e);
                    }
                    return n;
                }, c.prototype._decodeTime = function(e, t) {
                    const r = e.raw().toString();
                    let n, i, s, o, a, l;
                    if ("gentime" === t) n = 0 | r.slice(0, 4), i = 0 | r.slice(4, 6), s = 0 | r.slice(6, 8), o = 0 | r.slice(8, 10), a = 0 | r.slice(10, 12), l = 0 | r.slice(12, 14);
                    else {
                        if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
                        n = 0 | r.slice(0, 2), i = 0 | r.slice(2, 4), s = 0 | r.slice(4, 6), o = 0 | r.slice(6, 8), a = 0 | r.slice(8, 10), l = 0 | r.slice(10, 12), n = n < 70 ? 2e3 + n : 1900 + n;
                    }
                    return Date.UTC(n, i - 1, s, o, a, l, 0);
                }, c.prototype._decodeNull = function() {
                    return null;
                }, c.prototype._decodeBool = function(e) {
                    const t = e.readUInt8();
                    return e.isError(t) ? t : 0 !== t;
                }, c.prototype._decodeInt = function(e, t) {
                    const r = e.raw();
                    let n = new i(r);
                    return t && (n = t[n.toString(10)] || n), n;
                }, c.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
                };
            },
            {
                "../base/buffer": 172,
                "../base/node": 174,
                "../constants/der": 176,
                "bn.js": 184,
                inherits: 440
            }
        ],
        179: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 178,
                "./pem": 180
            }
        ],
        180: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("./der");
                function o(e) {
                    s.call(this, e), this.enc = "pem";
                }
                n(o, s), t.exports = o, o.prototype.decode = function(e, t) {
                    const r = e.toString().split(/[\r\n]+/g), n = t.label.toUpperCase(), o = /^-----(BEGIN|END) ([^-]+)-----$/;
                    let a = -1, l = -1;
                    for(let e = 0; e < r.length; e++){
                        const t = r[e].match(o);
                        if (null !== t && t[2] === n) {
                            if (-1 !== a) {
                                if ("END" !== t[1]) break;
                                l = e;
                                break;
                            }
                            if ("BEGIN" !== t[1]) break;
                            a = e;
                        }
                    }
                    if (-1 === a || -1 === l) throw new Error("PEM section not found for: " + n);
                    const c = r.slice(a + 1, l).join("");
                    c.replace(/[^a-z0-9+/=]+/gi, "");
                    const u = i.from(c, "base64");
                    return s.prototype.decode.call(this, u, t);
                };
            },
            {
                "./der": 178,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        181: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("../base/node"), o = e("../constants/der");
                function a(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new l, this.tree._init(e.body);
                }
                function l(e) {
                    s.call(this, "der", e);
                }
                function c(e) {
                    return e < 10 ? "0" + e : e;
                }
                t.exports = a, a.prototype.encode = function(e, t) {
                    return this.tree._encode(e, t).join();
                }, n(l, s), l.prototype._encodeComposite = function(e, t, r, n) {
                    const s = function(e, t, r, n) {
                        let i;
                        "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
                        if (o.tagByName.hasOwnProperty(e)) i = o.tagByName[e];
                        else {
                            if ("number" != typeof e || (0 | e) !== e) return n.error("Unknown tag: " + e);
                            i = e;
                        }
                        if (i >= 31) return n.error("Multi-octet tag encoding unsupported");
                        t || (i |= 32);
                        return i |= o.tagClassByName[r || "universal"] << 6, i;
                    }(e, t, r, this.reporter);
                    if (n.length < 128) {
                        const e = i.alloc(2);
                        return e[0] = s, e[1] = n.length, this._createEncoderBuffer([
                            e,
                            n
                        ]);
                    }
                    let a = 1;
                    for(let e = n.length; e >= 256; e >>= 8)a++;
                    const l = i.alloc(2 + a);
                    l[0] = s, l[1] = 128 | a;
                    for(let e = 1 + a, t = n.length; t > 0; e--, t >>= 8)l[e] = 255 & t;
                    return this._createEncoderBuffer([
                        l,
                        n
                    ]);
                }, l.prototype._encodeStr = function(e, t) {
                    if ("bitstr" === t) return this._createEncoderBuffer([
                        0 | e.unused,
                        e.data
                    ]);
                    if ("bmpstr" === t) {
                        const t = i.alloc(2 * e.length);
                        for(let r = 0; r < e.length; r++)t.writeUInt16BE(e.charCodeAt(r), 2 * r);
                        return this._createEncoderBuffer(t);
                    }
                    return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) || "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
                }, l.prototype._encodeObjid = function(e, t, r) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("string objid given, but no values map found");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
                        e = t[e].split(/[\s.]+/g);
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    } else if (Array.isArray(e)) {
                        e = e.slice();
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    }
                    if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));
                    if (!r) {
                        if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
                        e.splice(0, 2, 40 * e[0] + e[1]);
                    }
                    let n = 0;
                    for(let t = 0; t < e.length; t++){
                        let r = e[t];
                        for(n++; r >= 128; r >>= 7)n++;
                    }
                    const s = i.alloc(n);
                    let o = s.length - 1;
                    for(let t = e.length - 1; t >= 0; t--){
                        let r = e[t];
                        for(s[o--] = 127 & r; (r >>= 7) > 0;)s[o--] = 128 | 127 & r;
                    }
                    return this._createEncoderBuffer(s);
                }, l.prototype._encodeTime = function(e, t) {
                    let r;
                    const n = new Date(e);
                    return "gentime" === t ? r = [
                        c(n.getUTCFullYear()),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : "utctime" === t ? r = [
                        c(n.getUTCFullYear() % 100),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(r, "octstr");
                }, l.prototype._encodeNull = function() {
                    return this._createEncoderBuffer("");
                }, l.prototype._encodeInt = function(e, t) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("String int or enum given, but no values map");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
                        e = t[e];
                    }
                    if ("number" != typeof e && !i.isBuffer(e)) {
                        const t = e.toArray();
                        !e.sign && 128 & t[0] && t.unshift(0), e = i.from(t);
                    }
                    if (i.isBuffer(e)) {
                        let t = e.length;
                        0 === e.length && t++;
                        const r = i.alloc(t);
                        return e.copy(r), 0 === e.length && (r[0] = 0), this._createEncoderBuffer(r);
                    }
                    if (e < 128) return this._createEncoderBuffer(e);
                    if (e < 256) return this._createEncoderBuffer([
                        0,
                        e
                    ]);
                    let r = 1;
                    for(let t = e; t >= 256; t >>= 8)r++;
                    const n = new Array(r);
                    for(let t = n.length - 1; t >= 0; t--)n[t] = 255 & e, e >>= 8;
                    return 128 & n[0] && n.unshift(0), this._createEncoderBuffer(i.from(n));
                }, l.prototype._encodeBool = function(e) {
                    return this._createEncoderBuffer(e ? 255 : 0);
                }, l.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
                }, l.prototype._skipDefault = function(e, t, r) {
                    const n = this._baseState;
                    let i;
                    if (null === n.default) return !1;
                    const s = e.join();
                    if (void 0 === n.defaultBuffer && (n.defaultBuffer = this._encodeValue(n.default, t, r).join()), s.length !== n.defaultBuffer.length) return !1;
                    for(i = 0; i < s.length; i++)if (s[i] !== n.defaultBuffer[i]) return !1;
                    return !0;
                };
            },
            {
                "../base/node": 174,
                "../constants/der": 176,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        182: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 181,
                "./pem": 183
            }
        ],
        183: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("./der");
                function s(e) {
                    i.call(this, e), this.enc = "pem";
                }
                n(s, i), t.exports = s, s.prototype.encode = function(e, t) {
                    const r = i.prototype.encode.call(this, e).toString("base64"), n = [
                        "-----BEGIN " + t.label + "-----"
                    ];
                    for(let e = 0; e < r.length; e += 64)n.push(r.slice(e, e + 64));
                    return n.push("-----END " + t.label + "-----"), n.join("\n");
                };
            },
            {
                "./der": 181,
                inherits: 440
            }
        ],
        184: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : r - 48 & 15;
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, n) {
                        for(var i = 0, s = Math.min(e.length, r), o = t; o < s; o++){
                            var a = e.charCodeAt(o) - 48;
                            i *= n, i += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
                        }
                        return i;
                    }
                    s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this.strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this.strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this.strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype.strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, s.prototype.inspect = function() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    };
                    var u = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], h = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], f = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    function d(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r.strip();
                    }
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                r = 0 !== (s = a >>> 24 - i & 16777215) || o !== this.length - 1 ? u[6 - l.length] + l + r : l + r, (i += 2) >= 26 && (i -= 26, o--);
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = h[e], d = f[e];
                            r = "";
                            var p = this.clone();
                            for(p.negative = 0; !p.isZero();){
                                var m = p.modn(d).toString(e);
                                r = (p = p.idivn(d)).isZero() ? m + r : u[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16);
                    }, s.prototype.toBuffer = function(e, t) {
                        return n(void 0 !== o), this.toArrayLike(o, e, t);
                    }, s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    }, s.prototype.toArrayLike = function(e, t, r) {
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0"), this.strip();
                        var o, a, l = "le" === t, c = new e(s), u = this.clone();
                        if (l) {
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[a] = o;
                            for(; a < s; a++)c[a] = 0;
                        } else {
                            for(a = 0; a < s - i; a++)c[a] = 0;
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[s - a - 1] = o;
                        }
                        return c;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this.strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this.strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this.strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this.strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var p = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function m(e, t, r) {
                        return (new b).mulp(e, t, r);
                    }
                    function b(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (p = d), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? p(this, e, t) : r < 63 ? d(this, e, t) : r < 1024 ? function(e, t, r) {
                            r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                            for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                                var o = i;
                                i = 0;
                                for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                    var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                    a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                                }
                                r.words[s] = a, n = o, o = i;
                            }
                            return 0 !== n ? r.words[s] = n : r.length--, r.strip();
                        }(this, e, t) : m(this, e, t);
                    }, b.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, b.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, b.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, b.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, b.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, b.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, b.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, b.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, b.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, b.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), m(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        n("number" == typeof e), n(e < 67108864);
                        for(var t = 0, r = 0; r < this.length; r++){
                            var i = (0 | this.words[r]) * e, s = (67108863 & i) + (67108863 & t);
                            t >>= 26, t += i / 67108864 | 0, t += s >>> 26, this.words[r] = 67108863 & s;
                        }
                        return 0 !== t && (this.words[r] = t, this.length++), this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = (e.words[n] & 1 << i) >>> i;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this.strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this.strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this.strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this.strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this.strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modn = function(e) {
                        n(e <= 67108863);
                        for(var t = 67108864 % e, r = 0, i = this.length - 1; i >= 0; i--)r = (t * r + (0 | this.words[i])) % e;
                        return r;
                    }, s.prototype.idivn = function(e) {
                        n(e <= 67108863);
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var i = (0 | this.words[r]) + 67108864 * t;
                            this.words[r] = i / e | 0, t = i % e;
                        }
                        return this.strip();
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this.strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new k(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var g = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function y(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function v() {
                        y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function w() {
                        y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function _() {
                        y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function x() {
                        y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function k(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function S(e) {
                        k.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    y.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, y.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, y.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, y.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(v, y), v.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, v.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(w, y), i(_, y), i(x, y), x.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (g[e]) return g[e];
                        var t;
                        if ("k256" === e) t = new v;
                        else if ("p224" === e) t = new w;
                        else if ("p192" === e) t = new _;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new x;
                        }
                        return g[e] = t, t;
                    }, k.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, k.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, k.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
                    }, k.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, k.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, k.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, k.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, k.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, k.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, k.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, k.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, k.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, k.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, k.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, k.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, k.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, k.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, k.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new S(e);
                    }, i(S, k), S.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, S.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, S.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, S.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, S.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        185: [
            function(e, t, r) {
                "use strict";
                r.byteLength = function(e) {
                    var t = c(e), r = t[0], n = t[1];
                    return 3 * (r + n) / 4 - n;
                }, r.toByteArray = function(e) {
                    var t, r, n = c(e), o = n[0], a = n[1], l = new s(function(e, t, r) {
                        return 3 * (t + r) / 4 - r;
                    }(0, o, a)), u = 0, h = a > 0 ? o - 4 : o;
                    for(r = 0; r < h; r += 4)t = i[e.charCodeAt(r)] << 18 | i[e.charCodeAt(r + 1)] << 12 | i[e.charCodeAt(r + 2)] << 6 | i[e.charCodeAt(r + 3)], l[u++] = t >> 16 & 255, l[u++] = t >> 8 & 255, l[u++] = 255 & t;
                    2 === a && (t = i[e.charCodeAt(r)] << 2 | i[e.charCodeAt(r + 1)] >> 4, l[u++] = 255 & t);
                    1 === a && (t = i[e.charCodeAt(r)] << 10 | i[e.charCodeAt(r + 1)] << 4 | i[e.charCodeAt(r + 2)] >> 2, l[u++] = t >> 8 & 255, l[u++] = 255 & t);
                    return l;
                }, r.fromByteArray = function(e) {
                    for(var t, r = e.length, i = r % 3, s = [], o = 0, a = r - i; o < a; o += 16383)s.push(u(e, o, o + 16383 > a ? a : o + 16383));
                    1 === i ? (t = e[r - 1], s.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], s.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));
                    return s.join("");
                };
                for(var n = [], i = [], s = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, l = o.length; a < l; ++a)n[a] = o[a], i[o.charCodeAt(a)] = a;
                function c(e) {
                    var t = e.length;
                    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    var r = e.indexOf("=");
                    return -1 === r && (r = t), [
                        r,
                        r === t ? 0 : 4 - r % 4
                    ];
                }
                function u(e, t, r) {
                    for(var i, s, o = [], a = t; a < r; a += 3)i = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), o.push(n[(s = i) >> 18 & 63] + n[s >> 12 & 63] + n[s >> 6 & 63] + n[63 & s]);
                    return o.join("");
                }
                i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
            },
            {}
        ],
        186: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, i) {
                        for(var s = 0, o = 0, a = Math.min(e.length, r), l = t; l < a; l++){
                            var c = e.charCodeAt(l) - 48;
                            s *= i, o = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, n(c >= 0 && o < i, "Invalid character"), s += o;
                        }
                        return s;
                    }
                    function u(e, t) {
                        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
                    }
                    if (s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this._strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this._strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this._strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype._move = function(e) {
                        u(e, this);
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype._strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
                        s.prototype[Symbol.for("nodejs.util.inspect.custom")] = h;
                    } catch (e) {
                        s.prototype.inspect = h;
                    }
                    else s.prototype.inspect = h;
                    function h() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    }
                    var f = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], d = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], p = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                s = a >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, o--), r = 0 !== s || o !== this.length - 1 ? f[6 - l.length] + l + r : l + r;
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = d[e], u = p[e];
                            r = "";
                            var h = this.clone();
                            for(h.negative = 0; !h.isZero();){
                                var m = h.modrn(u).toString(e);
                                r = (h = h.idivn(u)).isZero() ? m + r : f[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16, 2);
                    }, o && (s.prototype.toBuffer = function(e, t) {
                        return this.toArrayLike(o, e, t);
                    }), s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    };
                    function m(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r._strip();
                    }
                    s.prototype.toArrayLike = function(e, t, r) {
                        this._strip();
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0");
                        var o = function(e, t) {
                            return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
                        }(e, s);
                        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](o, i), o;
                    }, s.prototype._toArrayLikeLE = function(e, t) {
                        for(var r = 0, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r++] = 255 & o, r < e.length && (e[r++] = o >> 8 & 255), r < e.length && (e[r++] = o >> 16 & 255), 6 === s ? (r < e.length && (e[r++] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r < e.length) for(e[r++] = n; r < e.length;)e[r++] = 0;
                    }, s.prototype._toArrayLikeBE = function(e, t) {
                        for(var r = e.length - 1, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r--] = 255 & o, r >= 0 && (e[r--] = o >> 8 & 255), r >= 0 && (e[r--] = o >> 16 & 255), 6 === s ? (r >= 0 && (e[r--] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r >= 0) for(e[r--] = n; r >= 0;)e[r--] = 0;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this._strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this._strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this._strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this._strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var b = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function g(e, t, r) {
                        r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                        for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                            var o = i;
                            i = 0;
                            for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                            }
                            r.words[s] = a, n = o, o = i;
                        }
                        return 0 !== n ? r.words[s] = n : r.length--, r._strip();
                    }
                    function y(e, t, r) {
                        return g(e, t, r);
                    }
                    function v(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (b = m), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? b(this, e, t) : r < 63 ? m(this, e, t) : r < 1024 ? g(this, e, t) : y(this, e, t);
                    }, v.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, v.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, v.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, v.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, v.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, v.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, v.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, v.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, v.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, v.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r._strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), y(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        var t = e < 0;
                        t && (e = -e), n("number" == typeof e), n(e < 67108864);
                        for(var r = 0, i = 0; i < this.length; i++){
                            var s = (0 | this.words[i]) * e, o = (67108863 & s) + (67108863 & r);
                            r >>= 26, r += s / 67108864 | 0, r += o >>> 26, this.words[i] = 67108863 & o;
                        }
                        return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = e.words[n] >>> i & 1;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this._strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this._strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this._strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this._strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this._strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a._strip(), n._strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modrn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modrn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modrn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 67108864 % e, i = 0, s = this.length - 1; s >= 0; s--)i = (r * i + (0 | this.words[s])) % e;
                        return t ? -i : i;
                    }, s.prototype.modn = function(e) {
                        return this.modrn(e);
                    }, s.prototype.idivn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 0, i = this.length - 1; i >= 0; i--){
                            var s = (0 | this.words[i]) + 67108864 * r;
                            this.words[i] = s / e | 0, r = s % e;
                        }
                        return this._strip(), t ? this.ineg() : this;
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this._strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new C(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var w = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function _(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function x() {
                        _.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function k() {
                        _.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function S() {
                        _.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function M() {
                        _.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function C(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function T(e) {
                        C.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    _.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, _.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, _.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, _.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(x, _), x.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, x.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(k, _), i(S, _), i(M, _), M.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (w[e]) return w[e];
                        var t;
                        if ("k256" === e) t = new x;
                        else if ("p224" === e) t = new k;
                        else if ("p192" === e) t = new S;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new M;
                        }
                        return w[e] = t, t;
                    }, C.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, C.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, C.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (u(e, e.umod(this.m)._forceRed(this)), e);
                    }, C.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, C.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, C.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, C.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, C.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, C.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, C.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, C.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, C.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, C.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, C.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, C.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, C.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, C.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, C.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new T(e);
                    }, i(T, C), T.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, T.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, T.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, T.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, T.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        187: [
            function(e, t, r) {
                "use strict";
                var n;
                function i(e) {
                    this.rand = e;
                }
                if (t.exports = function(e) {
                    return n || (n = new i(null)), n.generate(e);
                }, t.exports.Rand = i, i.prototype.generate = function(e) {
                    return this._rand(e);
                }, i.prototype._rand = function(e) {
                    if (this.rand.getBytes) return this.rand.getBytes(e);
                    for(var t = new Uint8Array(e), r = 0; r < t.length; r++)t[r] = this.rand.getByte();
                    return t;
                }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.crypto.getRandomValues(t), t;
                } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.msCrypto.getRandomValues(t), t;
                } : "object" == typeof window && (i.prototype._rand = function() {
                    throw new Error("Not implemented yet");
                });
                else try {
                    var s = e("crypto");
                    if ("function" != typeof s.randomBytes) throw new Error("Not supported");
                    i.prototype._rand = function(e) {
                        return s.randomBytes(e);
                    };
                } catch (e) {}
            },
            {
                crypto: 188
            }
        ],
        188: [
            function(e, t, r) {},
            {}
        ],
        189: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e) {
                    n.isBuffer(e) || (e = n.from(e));
                    for(var t = e.length / 4 | 0, r = new Array(t), i = 0; i < t; i++)r[i] = e.readUInt32BE(4 * i);
                    return r;
                }
                function s(e) {
                    for(; 0 < e.length; e++)e[0] = 0;
                }
                function o(e, t, r, n, i) {
                    for(var s, o, a, l, c = r[0], u = r[1], h = r[2], f = r[3], d = e[0] ^ t[0], p = e[1] ^ t[1], m = e[2] ^ t[2], b = e[3] ^ t[3], g = 4, y = 1; y < i; y++)s = c[d >>> 24] ^ u[p >>> 16 & 255] ^ h[m >>> 8 & 255] ^ f[255 & b] ^ t[g++], o = c[p >>> 24] ^ u[m >>> 16 & 255] ^ h[b >>> 8 & 255] ^ f[255 & d] ^ t[g++], a = c[m >>> 24] ^ u[b >>> 16 & 255] ^ h[d >>> 8 & 255] ^ f[255 & p] ^ t[g++], l = c[b >>> 24] ^ u[d >>> 16 & 255] ^ h[p >>> 8 & 255] ^ f[255 & m] ^ t[g++], d = s, p = o, m = a, b = l;
                    return s = (n[d >>> 24] << 24 | n[p >>> 16 & 255] << 16 | n[m >>> 8 & 255] << 8 | n[255 & b]) ^ t[g++], o = (n[p >>> 24] << 24 | n[m >>> 16 & 255] << 16 | n[b >>> 8 & 255] << 8 | n[255 & d]) ^ t[g++], a = (n[m >>> 24] << 24 | n[b >>> 16 & 255] << 16 | n[d >>> 8 & 255] << 8 | n[255 & p]) ^ t[g++], l = (n[b >>> 24] << 24 | n[d >>> 16 & 255] << 16 | n[p >>> 8 & 255] << 8 | n[255 & m]) ^ t[g++], [
                        s >>>= 0,
                        o >>>= 0,
                        a >>>= 0,
                        l >>>= 0
                    ];
                }
                var a = [
                    0,
                    1,
                    2,
                    4,
                    8,
                    16,
                    32,
                    64,
                    128,
                    27,
                    54
                ], l = function() {
                    for(var e = new Array(256), t = 0; t < 256; t++)e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
                    for(var r = [], n = [], i = [
                        [],
                        [],
                        [],
                        []
                    ], s = [
                        [],
                        [],
                        [],
                        []
                    ], o = 0, a = 0, l = 0; l < 256; ++l){
                        var c = a ^ a << 1 ^ a << 2 ^ a << 3 ^ a << 4;
                        c = c >>> 8 ^ 255 & c ^ 99, r[o] = c, n[c] = o;
                        var u = e[o], h = e[u], f = e[h], d = 257 * e[c] ^ 16843008 * c;
                        i[0][o] = d << 24 | d >>> 8, i[1][o] = d << 16 | d >>> 16, i[2][o] = d << 8 | d >>> 24, i[3][o] = d, d = 16843009 * f ^ 65537 * h ^ 257 * u ^ 16843008 * o, s[0][c] = d << 24 | d >>> 8, s[1][c] = d << 16 | d >>> 16, s[2][c] = d << 8 | d >>> 24, s[3][c] = d, 0 === o ? o = a = 1 : (o = u ^ e[e[e[f ^ u]]], a ^= e[e[a]]);
                    }
                    return {
                        SBOX: r,
                        INV_SBOX: n,
                        SUB_MIX: i,
                        INV_SUB_MIX: s
                    };
                }();
                function c(e) {
                    this._key = i(e), this._reset();
                }
                c.blockSize = 16, c.keySize = 32, c.prototype.blockSize = c.blockSize, c.prototype.keySize = c.keySize, c.prototype._reset = function() {
                    for(var e = this._key, t = e.length, r = t + 6, n = 4 * (r + 1), i = [], s = 0; s < t; s++)i[s] = e[s];
                    for(s = t; s < n; s++){
                        var o = i[s - 1];
                        s % t == 0 ? (o = o << 8 | o >>> 24, o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o], o ^= a[s / t | 0] << 24) : t > 6 && s % t == 4 && (o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o]), i[s] = i[s - t] ^ o;
                    }
                    for(var c = [], u = 0; u < n; u++){
                        var h = n - u, f = i[h - (u % 4 ? 0 : 4)];
                        c[u] = u < 4 || h <= 4 ? f : l.INV_SUB_MIX[0][l.SBOX[f >>> 24]] ^ l.INV_SUB_MIX[1][l.SBOX[f >>> 16 & 255]] ^ l.INV_SUB_MIX[2][l.SBOX[f >>> 8 & 255]] ^ l.INV_SUB_MIX[3][l.SBOX[255 & f]];
                    }
                    this._nRounds = r, this._keySchedule = i, this._invKeySchedule = c;
                }, c.prototype.encryptBlockRaw = function(e) {
                    return o(e = i(e), this._keySchedule, l.SUB_MIX, l.SBOX, this._nRounds);
                }, c.prototype.encryptBlock = function(e) {
                    var t = this.encryptBlockRaw(e), r = n.allocUnsafe(16);
                    return r.writeUInt32BE(t[0], 0), r.writeUInt32BE(t[1], 4), r.writeUInt32BE(t[2], 8), r.writeUInt32BE(t[3], 12), r;
                }, c.prototype.decryptBlock = function(e) {
                    var t = (e = i(e))[1];
                    e[1] = e[3], e[3] = t;
                    var r = o(e, this._invKeySchedule, l.INV_SUB_MIX, l.INV_SBOX, this._nRounds), s = n.allocUnsafe(16);
                    return s.writeUInt32BE(r[0], 0), s.writeUInt32BE(r[3], 4), s.writeUInt32BE(r[2], 8), s.writeUInt32BE(r[1], 12), s;
                }, c.prototype.scrub = function() {
                    s(this._keySchedule), s(this._invKeySchedule), s(this._key);
                }, t.exports.AES = c;
            },
            {
                "safe-buffer": 494
            }
        ],
        190: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = e("inherits"), a = e("./ghash"), l = e("buffer-xor"), c = e("./incr32");
                function u(e, t, r, o) {
                    s.call(this);
                    var l = i.alloc(4, 0);
                    this._cipher = new n.AES(t);
                    var u = this._cipher.encryptBlock(l);
                    this._ghash = new a(u), r = function(e, t, r) {
                        if (12 === t.length) return e._finID = i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                1
                            ])
                        ]), i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                2
                            ])
                        ]);
                        var n = new a(r), s = t.length, o = s % 16;
                        n.update(t), o && (o = 16 - o, n.update(i.alloc(o, 0))), n.update(i.alloc(8, 0));
                        var l = 8 * s, u = i.alloc(8);
                        u.writeUIntBE(l, 0, 8), n.update(u), e._finID = n.state;
                        var h = i.from(e._finID);
                        return c(h), h;
                    }(this, r, u), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
                }
                o(u, s), u.prototype._update = function(e) {
                    if (!this._called && this._alen) {
                        var t = 16 - this._alen % 16;
                        t < 16 && (t = i.alloc(t, 0), this._ghash.update(t));
                    }
                    this._called = !0;
                    var r = this._mode.encrypt(this, e);
                    return this._decrypt ? this._ghash.update(e) : this._ghash.update(r), this._len += e.length, r;
                }, u.prototype._final = function() {
                    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
                    var e = l(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
                    if (this._decrypt && function(e, t) {
                        var r = 0;
                        e.length !== t.length && r++;
                        for(var n = Math.min(e.length, t.length), i = 0; i < n; ++i)r += e[i] ^ t[i];
                        return r;
                    }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
                    this._authTag = e, this._cipher.scrub();
                }, u.prototype.getAuthTag = function() {
                    if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
                    return this._authTag;
                }, u.prototype.setAuthTag = function(e) {
                    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
                    this._authTag = e;
                }, u.prototype.setAAD = function(e) {
                    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
                    this._ghash.update(e), this._alen += e.length;
                }, t.exports = u;
            },
            {
                "./aes": 189,
                "./ghash": 194,
                "./incr32": 195,
                "buffer-xor": 219,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        191: [
            function(e, t, r) {
                "use strict";
                var n = e("./encrypter"), i = e("./decrypter"), s = e("./modes/list.json");
                r.createCipher = r.Cipher = n.createCipher, r.createCipheriv = r.Cipheriv = n.createCipheriv, r.createDecipher = r.Decipher = i.createDecipher, r.createDecipheriv = r.Decipheriv = i.createDecipheriv, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(s);
                };
            },
            {
                "./decrypter": 192,
                "./encrypter": 193,
                "./modes/list.json": 203
            }
        ],
        192: [
            function(e, t, r) {
                "use strict";
                var n = e("./authCipher"), i = e("safe-buffer").Buffer, s = e("./modes"), o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new h, this._last = void 0, this._cipher = new l.AES(t), this._prev = i.from(r), this._mode = e, this._autopadding = !0;
                }
                function h() {
                    this.cache = i.allocUnsafe(0);
                }
                function f(e, t, r) {
                    var a = s[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof r && (r = i.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    if ("string" == typeof t && (t = i.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    return "stream" === a.type ? new o(a.module, t, r, !0) : "auth" === a.type ? new n(a.module, t, r, !0) : new u(a.module, t, r);
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get(this._autopadding);)r = this._mode.decrypt(this, t), n.push(r);
                    return i.concat(n);
                }, u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return function(e) {
                        var t = e[15];
                        if (t < 1 || t > 16) throw new Error("unable to decrypt data");
                        var r = -1;
                        for(; ++r < t;)if (e[r + (16 - t)] !== t) throw new Error("unable to decrypt data");
                        if (16 === t) return;
                        return e.slice(0, 16 - t);
                    }(this._mode.decrypt(this, e));
                    if (e) throw new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, h.prototype.add = function(e) {
                    this.cache = i.concat([
                        this.cache,
                        e
                    ]);
                }, h.prototype.get = function(e) {
                    var t;
                    if (e) {
                        if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    return null;
                }, h.prototype.flush = function() {
                    if (this.cache.length) return this.cache;
                }, r.createDecipher = function(e, t) {
                    var r = s[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var n = c(t, !1, r.key, r.iv);
                    return f(e, n.key, n.iv);
                }, r.createDecipheriv = f;
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        193: [
            function(e, t, r) {
                "use strict";
                var n = e("./modes"), i = e("./authCipher"), s = e("safe-buffer").Buffer, o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new f, this._cipher = new l.AES(t), this._prev = s.from(r), this._mode = e, this._autopadding = !0;
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get();)r = this._mode.encrypt(this, t), n.push(r);
                    return s.concat(n);
                };
                var h = s.alloc(16, 16);
                function f() {
                    this.cache = s.allocUnsafe(0);
                }
                function d(e, t, r) {
                    var a = n[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof t && (t = s.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    if ("string" == typeof r && (r = s.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    return "stream" === a.type ? new o(a.module, t, r) : "auth" === a.type ? new i(a.module, t, r) : new u(a.module, t, r);
                }
                u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
                    if (!e.equals(h)) throw this._cipher.scrub(), new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, f.prototype.add = function(e) {
                    this.cache = s.concat([
                        this.cache,
                        e
                    ]);
                }, f.prototype.get = function() {
                    if (this.cache.length > 15) {
                        var e = this.cache.slice(0, 16);
                        return this.cache = this.cache.slice(16), e;
                    }
                    return null;
                }, f.prototype.flush = function() {
                    for(var e = 16 - this.cache.length, t = s.allocUnsafe(e), r = -1; ++r < e;)t.writeUInt8(e, r);
                    return s.concat([
                        this.cache,
                        t
                    ]);
                }, r.createCipheriv = d, r.createCipher = function(e, t) {
                    var r = n[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var i = c(t, !1, r.key, r.iv);
                    return d(e, i.key, i.iv);
                };
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        194: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.alloc(16, 0);
                function s(e) {
                    var t = n.allocUnsafe(16);
                    return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
                }
                function o(e) {
                    this.h = e, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0);
                }
                o.prototype.ghash = function(e) {
                    for(var t = -1; ++t < e.length;)this.state[t] ^= e[t];
                    this._multiply();
                }, o.prototype._multiply = function() {
                    for(var e, t, r, n = [
                        (e = this.h).readUInt32BE(0),
                        e.readUInt32BE(4),
                        e.readUInt32BE(8),
                        e.readUInt32BE(12)
                    ], i = [
                        0,
                        0,
                        0,
                        0
                    ], o = -1; ++o < 128;){
                        for(0 != (this.state[~~(o / 8)] & 1 << 7 - o % 8) && (i[0] ^= n[0], i[1] ^= n[1], i[2] ^= n[2], i[3] ^= n[3]), r = 0 != (1 & n[3]), t = 3; t > 0; t--)n[t] = n[t] >>> 1 | (1 & n[t - 1]) << 31;
                        n[0] = n[0] >>> 1, r && (n[0] = n[0] ^ -520093696);
                    }
                    this.state = s(i);
                }, o.prototype.update = function(e) {
                    var t;
                    for(this.cache = n.concat([
                        this.cache,
                        e
                    ]); this.cache.length >= 16;)t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
                }, o.prototype.final = function(e, t) {
                    return this.cache.length && this.ghash(n.concat([
                        this.cache,
                        i
                    ], 16)), this.ghash(s([
                        0,
                        e,
                        0,
                        t
                    ])), this.state;
                }, t.exports = o;
            },
            {
                "safe-buffer": 494
            }
        ],
        195: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    for(var t, r = e.length; r--;){
                        if (255 !== (t = e.readUInt8(r))) {
                            t++, e.writeUInt8(t, r);
                            break;
                        }
                        e.writeUInt8(0, r);
                    }
                };
            },
            {}
        ],
        196: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor");
                r.encrypt = function(e, t) {
                    var r = n(t, e._prev);
                    return e._prev = e._cipher.encryptBlock(r), e._prev;
                }, r.decrypt = function(e, t) {
                    var r = e._prev;
                    e._prev = t;
                    var i = e._cipher.decryptBlock(t);
                    return n(i, r);
                };
            },
            {
                "buffer-xor": 219
            }
        ],
        197: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("buffer-xor");
                function s(e, t, r) {
                    var s = t.length, o = i(t, e._cache);
                    return e._cache = e._cache.slice(s), e._prev = n.concat([
                        e._prev,
                        r ? t : o
                    ]), o;
                }
                r.encrypt = function(e, t, r) {
                    for(var i, o = n.allocUnsafe(0); t.length;){
                        if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = n.allocUnsafe(0)), !(e._cache.length <= t.length)) {
                            o = n.concat([
                                o,
                                s(e, t, r)
                            ]);
                            break;
                        }
                        i = e._cache.length, o = n.concat([
                            o,
                            s(e, t.slice(0, i), r)
                        ]), t = t.slice(i);
                    }
                    return o;
                };
            },
            {
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        198: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    for(var n, i, o = -1, a = 0; ++o < 8;)n = t & 1 << 7 - o ? 128 : 0, a += (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ n)) >> o % 8, e._prev = s(e._prev, r ? n : i);
                    return a;
                }
                function s(e, t) {
                    var r = e.length, i = -1, s = n.allocUnsafe(e.length);
                    for(e = n.concat([
                        e,
                        n.from([
                            t
                        ])
                    ]); ++i < r;)s[i] = e[i] << 1 | e[i + 1] >> 7;
                    return s;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        199: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
                    return e._prev = n.concat([
                        e._prev.slice(1),
                        n.from([
                            r ? t : i
                        ])
                    ]), i;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        200: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor"), i = e("safe-buffer").Buffer, s = e("../incr32");
                function o(e) {
                    var t = e._cipher.encryptBlockRaw(e._prev);
                    return s(e._prev), t;
                }
                r.encrypt = function(e, t) {
                    var r = Math.ceil(t.length / 16), s = e._cache.length;
                    e._cache = i.concat([
                        e._cache,
                        i.allocUnsafe(16 * r)
                    ]);
                    for(var a = 0; a < r; a++){
                        var l = o(e), c = s + 16 * a;
                        e._cache.writeUInt32BE(l[0], c + 0), e._cache.writeUInt32BE(l[1], c + 4), e._cache.writeUInt32BE(l[2], c + 8), e._cache.writeUInt32BE(l[3], c + 12);
                    }
                    var u = e._cache.slice(0, t.length);
                    return e._cache = e._cache.slice(t.length), n(t, u);
                };
            },
            {
                "../incr32": 195,
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        201: [
            function(e, t, r) {
                "use strict";
                r.encrypt = function(e, t) {
                    return e._cipher.encryptBlock(t);
                }, r.decrypt = function(e, t) {
                    return e._cipher.decryptBlock(t);
                };
            },
            {}
        ],
        202: [
            function(e, t, r) {
                "use strict";
                var n = {
                    ECB: e("./ecb"),
                    CBC: e("./cbc"),
                    CFB: e("./cfb"),
                    CFB8: e("./cfb8"),
                    CFB1: e("./cfb1"),
                    OFB: e("./ofb"),
                    CTR: e("./ctr"),
                    GCM: e("./ctr")
                }, i = e("./list.json");
                for(var s in i)i[s].module = n[i[s].mode];
                t.exports = i;
            },
            {
                "./cbc": 196,
                "./cfb": 197,
                "./cfb1": 198,
                "./cfb8": 199,
                "./ctr": 200,
                "./ecb": 201,
                "./list.json": 203,
                "./ofb": 204
            }
        ],
        203: [
            function(e, t, r) {
                t.exports = {
                    "aes-128-ecb": {
                        cipher: "AES",
                        key: 128,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-192-ecb": {
                        cipher: "AES",
                        key: 192,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-256-ecb": {
                        cipher: "AES",
                        key: 256,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-128-cbc": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-192-cbc": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-256-cbc": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes128: {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes192: {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes256: {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-128-cfb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-192-cfb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-256-cfb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-128-cfb8": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-192-cfb8": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-256-cfb8": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-128-cfb1": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-192-cfb1": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-256-cfb1": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-128-ofb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-192-ofb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-256-ofb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-128-ctr": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-192-ctr": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-256-ctr": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-128-gcm": {
                        cipher: "AES",
                        key: 128,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-192-gcm": {
                        cipher: "AES",
                        key: 192,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-256-gcm": {
                        cipher: "AES",
                        key: 256,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    }
                };
            },
            {}
        ],
        204: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("buffer-xor");
                        function i(e) {
                            return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
                        }
                        r.encrypt = function(e, r) {
                            for(; e._cache.length < r.length;)e._cache = t.concat([
                                e._cache,
                                i(e)
                            ]);
                            var s = e._cache.slice(0, r.length);
                            return e._cache = e._cache.slice(r.length), n(r, s);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                "buffer-xor": 219
            }
        ],
        205: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base");
                function o(e, t, r, o) {
                    s.call(this), this._cipher = new n.AES(t), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._mode = e;
                }
                e("inherits")(o, s), o.prototype._update = function(e) {
                    return this._mode.encrypt(this, e, this._decrypt);
                }, o.prototype._final = function() {
                    this._cipher.scrub();
                }, t.exports = o;
            },
            {
                "./aes": 189,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        206: [
            function(e, t, r) {
                "use strict";
                var n = e("browserify-des"), i = e("browserify-aes/browser"), s = e("browserify-aes/modes"), o = e("browserify-des/modes"), a = e("evp_bytestokey");
                function l(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createCipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e
                    });
                    throw new TypeError("invalid suite type");
                }
                function c(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createDecipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e,
                        decrypt: !0
                    });
                    throw new TypeError("invalid suite type");
                }
                r.createCipher = r.Cipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return l(e, i.key, i.iv);
                }, r.createCipheriv = r.Cipheriv = l, r.createDecipher = r.Decipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return c(e, i.key, i.iv);
                }, r.createDecipheriv = r.Decipheriv = c, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(o).concat(i.getCiphers());
                };
            },
            {
                "browserify-aes/browser": 191,
                "browserify-aes/modes": 202,
                "browserify-des": 207,
                "browserify-des/modes": 208,
                evp_bytestokey: 423
            }
        ],
        207: [
            function(e, t, r) {
                "use strict";
                var n = e("cipher-base"), i = e("des.js"), s = e("inherits"), o = e("safe-buffer").Buffer, a = {
                    "des-ede3-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede3": i.EDE,
                    "des-ede-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede": i.EDE,
                    "des-cbc": i.CBC.instantiate(i.DES),
                    "des-ecb": i.DES
                };
                function l(e) {
                    n.call(this);
                    var t, r = e.mode.toLowerCase(), i = a[r];
                    t = e.decrypt ? "decrypt" : "encrypt";
                    var s = e.key;
                    o.isBuffer(s) || (s = o.from(s)), "des-ede" !== r && "des-ede-cbc" !== r || (s = o.concat([
                        s,
                        s.slice(0, 8)
                    ]));
                    var l = e.iv;
                    o.isBuffer(l) || (l = o.from(l)), this._des = i.create({
                        key: s,
                        iv: l,
                        type: t
                    });
                }
                a.des = a["des-cbc"], a.des3 = a["des-ede3-cbc"], t.exports = l, s(l, n), l.prototype._update = function(e) {
                    return o.from(this._des.update(e));
                }, l.prototype._final = function() {
                    return o.from(this._des.final());
                };
            },
            {
                "cipher-base": 221,
                "des.js": 394,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        208: [
            function(e, t, r) {
                "use strict";
                r["des-ecb"] = {
                    key: 8,
                    iv: 0
                }, r["des-cbc"] = r.des = {
                    key: 8,
                    iv: 8
                }, r["des-ede3-cbc"] = r.des3 = {
                    key: 24,
                    iv: 8
                }, r["des-ede3"] = {
                    key: 24,
                    iv: 0
                }, r["des-ede-cbc"] = {
                    key: 16,
                    iv: 8
                }, r["des-ede"] = {
                    key: 16,
                    iv: 0
                };
            },
            {}
        ],
        209: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = e("randombytes");
                        function s(e) {
                            var t, r = e.modulus.byteLength();
                            do t = new n(i(r));
                            while (t.cmp(e.modulus) >= 0 || !t.umod(e.prime1) || !t.umod(e.prime2));
                            return t;
                        }
                        function o(e, t) {
                            var i = function(e) {
                                var t = s(e);
                                return {
                                    blinder: t.toRed(n.mont(e.modulus)).redPow(new n(e.publicExponent)).fromRed(),
                                    unblinder: t.invm(e.modulus)
                                };
                            }(t), o = t.modulus.byteLength(), a = new n(e).mul(i.blinder).umod(t.modulus), l = a.toRed(n.mont(t.prime1)), c = a.toRed(n.mont(t.prime2)), u = t.coefficient, h = t.prime1, f = t.prime2, d = l.redPow(t.exponent1).fromRed(), p = c.redPow(t.exponent2).fromRed(), m = d.isub(p).imul(u).umod(h).imul(f);
                            return p.iadd(m).imul(i.unblinder).umod(t.modulus).toArrayLike(r, "be", o);
                        }
                        o.getr = s, t.exports = o;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 186,
                buffer: 220,
                randombytes: 475
            }
        ],
        210: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./browser/algorithms.json");
            },
            {
                "./browser/algorithms.json": 211
            }
        ],
        211: [
            function(e, t, r) {
                t.exports = {
                    sha224WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    "RSA-SHA224": {
                        sign: "ecdsa/rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    sha256WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    "RSA-SHA256": {
                        sign: "ecdsa/rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    sha384WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    "RSA-SHA384": {
                        sign: "ecdsa/rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    sha512WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA512": {
                        sign: "ecdsa/rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA1": {
                        sign: "rsa",
                        hash: "sha1",
                        id: "3021300906052b0e03021a05000414"
                    },
                    "ecdsa-with-SHA1": {
                        sign: "ecdsa",
                        hash: "sha1",
                        id: ""
                    },
                    sha256: {
                        sign: "ecdsa",
                        hash: "sha256",
                        id: ""
                    },
                    sha224: {
                        sign: "ecdsa",
                        hash: "sha224",
                        id: ""
                    },
                    sha384: {
                        sign: "ecdsa",
                        hash: "sha384",
                        id: ""
                    },
                    sha512: {
                        sign: "ecdsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-SHA1": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    DSA: {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-WITH-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-WITH-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-WITH-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-WITH-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-RIPEMD160": {
                        sign: "dsa",
                        hash: "rmd160",
                        id: ""
                    },
                    ripemd160WithRSA: {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    "RSA-RIPEMD160": {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    md5WithRSAEncryption: {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    },
                    "RSA-MD5": {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    }
                };
            },
            {}
        ],
        212: [
            function(e, t, r) {
                t.exports = {
                    "1.3.132.0.10": "secp256k1",
                    "1.3.132.0.33": "p224",
                    "1.2.840.10045.3.1.1": "p192",
                    "1.2.840.10045.3.1.7": "p256",
                    "1.3.132.0.34": "p384",
                    "1.3.132.0.35": "p521"
                };
            },
            {}
        ],
        213: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hash"), s = e("readable-stream"), o = e("inherits"), a = e("./sign"), l = e("./verify"), c = e("./algorithms.json");
                function u(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hashType = t.hash, this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function h(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function f(e) {
                    return new u(e);
                }
                function d(e) {
                    return new h(e);
                }
                Object.keys(c).forEach(function(e) {
                    c[e].id = n.from(c[e].id, "hex"), c[e.toLowerCase()] = c[e];
                }), o(u, s.Writable), u.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, u.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, u.prototype.sign = function(e, t) {
                    this.end();
                    var r = this._hash.digest(), n = a(r, e, this._hashType, this._signType, this._tag);
                    return t ? n.toString(t) : n;
                }, o(h, s.Writable), h.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, h.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, h.prototype.verify = function(e, t, r) {
                    "string" == typeof t && (t = n.from(t, r)), this.end();
                    var i = this._hash.digest();
                    return l(t, i, e, this._signType, this._tag);
                }, t.exports = {
                    Sign: f,
                    Verify: d,
                    createSign: f,
                    createVerify: d
                };
            },
            {
                "./algorithms.json": 211,
                "./sign": 214,
                "./verify": 215,
                "create-hash": 386,
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        214: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hmac"), s = e("browserify-rsa"), o = e("elliptic").ec, a = e("bn.js"), l = e("parse-asn1"), c = e("./curves.json");
                function u(e, t, r, s) {
                    if ((e = n.from(e.toArray())).length < t.byteLength()) {
                        var o = n.alloc(t.byteLength() - e.length);
                        e = n.concat([
                            o,
                            e
                        ]);
                    }
                    var a = r.length, l = function(e, t) {
                        e = (e = h(e, t)).mod(t);
                        var r = n.from(e.toArray());
                        if (r.length < t.byteLength()) {
                            var i = n.alloc(t.byteLength() - r.length);
                            r = n.concat([
                                i,
                                r
                            ]);
                        }
                        return r;
                    }(r, t), c = n.alloc(a);
                    c.fill(1);
                    var u = n.alloc(a);
                    return u = i(s, u).update(c).update(n.from([
                        0
                    ])).update(e).update(l).digest(), c = i(s, u).update(c).digest(), {
                        k: u = i(s, u).update(c).update(n.from([
                            1
                        ])).update(e).update(l).digest(),
                        v: c = i(s, u).update(c).digest()
                    };
                }
                function h(e, t) {
                    var r = new a(e), n = (e.length << 3) - t.bitLength();
                    return n > 0 && r.ishrn(n), r;
                }
                function f(e, t, r) {
                    var s, o;
                    do {
                        for(s = n.alloc(0); 8 * s.length < e.bitLength();)t.v = i(r, t.k).update(t.v).digest(), s = n.concat([
                            s,
                            t.v
                        ]);
                        o = h(s, e), t.k = i(r, t.k).update(t.v).update(n.from([
                            0
                        ])).digest(), t.v = i(r, t.k).update(t.v).digest();
                    }while (-1 !== o.cmp(e));
                    return o;
                }
                function d(e, t, r, n) {
                    return e.toRed(a.mont(r)).redPow(t).fromRed().mod(n);
                }
                t.exports = function(e, t, r, i, p) {
                    var m = l(t);
                    if (m.curve) {
                        if ("ecdsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                        return function(e, t) {
                            var r = c[t.curve.join(".")];
                            if (!r) throw new Error("unknown curve " + t.curve.join("."));
                            var i = new o(r).keyFromPrivate(t.privateKey).sign(e);
                            return n.from(i.toDER());
                        }(e, m);
                    }
                    if ("dsa" === m.type) {
                        if ("dsa" !== i) throw new Error("wrong private key type");
                        return function(e, t, r) {
                            var i, s = t.params.priv_key, o = t.params.p, l = t.params.q, c = t.params.g, p = new a(0), m = h(e, l).mod(l), b = !1, g = u(s, l, e, r);
                            for(; !1 === b;)i = f(l, g, r), p = d(c, i, o, l), 0 === (b = i.invm(l).imul(m.add(s.mul(p))).mod(l)).cmpn(0) && (b = !1, p = new a(0));
                            return function(e, t) {
                                e = e.toArray(), t = t.toArray(), 128 & e[0] && (e = [
                                    0
                                ].concat(e));
                                128 & t[0] && (t = [
                                    0
                                ].concat(t));
                                var r = [
                                    48,
                                    e.length + t.length + 4,
                                    2,
                                    e.length
                                ];
                                return r = r.concat(e, [
                                    2,
                                    t.length
                                ], t), n.from(r);
                            }(p, b);
                        }(e, m, r);
                    }
                    if ("rsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                    e = n.concat([
                        p,
                        e
                    ]);
                    for(var b = m.modulus.byteLength(), g = [
                        0,
                        1
                    ]; e.length + g.length + 1 < b;)g.push(255);
                    g.push(0);
                    for(var y = -1; ++y < e.length;)g.push(e[y]);
                    return s(g, m);
                }, t.exports.getKey = u, t.exports.makeKey = f;
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                "browserify-rsa": 209,
                "create-hmac": 388,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        215: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("bn.js"), s = e("elliptic").ec, o = e("parse-asn1"), a = e("./curves.json");
                function l(e, t) {
                    if (e.cmpn(0) <= 0) throw new Error("invalid sig");
                    if (e.cmp(t) >= t) throw new Error("invalid sig");
                }
                t.exports = function(e, t, r, c, u) {
                    var h = o(r);
                    if ("ec" === h.type) {
                        if ("ecdsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = a[r.data.algorithm.curve.join(".")];
                            if (!n) throw new Error("unknown curve " + r.data.algorithm.curve.join("."));
                            var i = new s(n), o = r.data.subjectPrivateKey.data;
                            return i.verify(t, e, o);
                        }(e, t, h);
                    }
                    if ("dsa" === h.type) {
                        if ("dsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = r.data.p, s = r.data.q, a = r.data.g, c = r.data.pub_key, u = o.signature.decode(e, "der"), h = u.s, f = u.r;
                            l(h, s), l(f, s);
                            var d = i.mont(n), p = h.invm(s);
                            return 0 === a.toRed(d).redPow(new i(t).mul(p).mod(s)).fromRed().mul(c.toRed(d).redPow(f.mul(p).mod(s)).fromRed()).mod(n).mod(s).cmp(f);
                        }(e, t, h);
                    }
                    if ("rsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                    t = n.concat([
                        u,
                        t
                    ]);
                    for(var f = h.modulus.byteLength(), d = [
                        1
                    ], p = 0; t.length + d.length + 2 < f;)d.push(255), p++;
                    d.push(0);
                    for(var m = -1; ++m < t.length;)d.push(t[m]);
                    d = n.from(d);
                    var b = i.mont(h.modulus);
                    e = (e = new i(e).toRed(b)).redPow(new i(h.publicExponent)), e = n.from(e.fromRed().toArray());
                    var g = p < 8 ? 1 : 0;
                    for(f = Math.min(e.length, d.length), e.length !== d.length && (g = 1), m = -1; ++m < f;)g |= e[m] ^ d[m];
                    return 0 === g;
                };
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        216: [
            function(e, t, r) {},
            {}
        ],
        217: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        218: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.isEncoding || function(e) {
                    switch((e = "" + e) && e.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                function s(e) {
                    var t;
                    switch(this.encoding = function(e) {
                        var t = function(e) {
                            if (!e) return "utf8";
                            for(var t;;)switch(e){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return e;
                                default:
                                    if (t) return;
                                    e = ("" + e).toLowerCase(), t = !0;
                            }
                        }(e);
                        if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
                        return t || e;
                    }(e), this.encoding){
                        case "utf16le":
                            this.text = l, this.end = c, t = 4;
                            break;
                        case "utf8":
                            this.fillLast = a, t = 4;
                            break;
                        case "base64":
                            this.text = u, this.end = h, t = 3;
                            break;
                        default:
                            return this.write = f, void (this.end = d);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
                }
                function o(e) {
                    return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
                }
                function a(e) {
                    var t = this.lastTotal - this.lastNeed, r = function(e, t, r) {
                        if (128 != (192 & t[0])) return e.lastNeed = 0, "\ufffd";
                        if (e.lastNeed > 1 && t.length > 1) {
                            if (128 != (192 & t[1])) return e.lastNeed = 1, "\ufffd";
                            if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "\ufffd";
                        }
                    }(this, e);
                    return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
                }
                function l(e, t) {
                    if ((e.length - t) % 2 == 0) {
                        var r = e.toString("utf16le", t);
                        if (r) {
                            var n = r.charCodeAt(r.length - 1);
                            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
                        }
                        return r;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
                }
                function c(e) {
                    var t = e && e.length ? this.write(e) : "";
                    if (this.lastNeed) {
                        var r = this.lastTotal - this.lastNeed;
                        return t + this.lastChar.toString("utf16le", 0, r);
                    }
                    return t;
                }
                function u(e, t) {
                    var r = (e.length - t) % 3;
                    return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
                }
                function h(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
                }
                function f(e) {
                    return e.toString(this.encoding);
                }
                function d(e) {
                    return e && e.length ? this.write(e) : "";
                }
                r.StringDecoder = s, s.prototype.write = function(e) {
                    if (0 === e.length) return "";
                    var t, r;
                    if (this.lastNeed) {
                        if (void 0 === (t = this.fillLast(e))) return "";
                        r = this.lastNeed, this.lastNeed = 0;
                    } else r = 0;
                    return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
                }, s.prototype.end = function(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + "\ufffd" : t;
                }, s.prototype.text = function(e, t) {
                    var r = function(e, t, r) {
                        var n = t.length - 1;
                        if (n < r) return 0;
                        var i = o(t[n]);
                        if (i >= 0) return i > 0 && (e.lastNeed = i - 1), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (e.lastNeed = i - 2), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i;
                        return 0;
                    }(this, e, t);
                    if (!this.lastNeed) return e.toString("utf8", t);
                    this.lastTotal = r;
                    var n = e.length - (r - this.lastNeed);
                    return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
                }, s.prototype.fillLast = function(e) {
                    if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
                };
            },
            {
                "safe-buffer": 217
            }
        ],
        219: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = function(t, r) {
                            for(var n = Math.min(t.length, r.length), i = new e(n), s = 0; s < n; ++s)i[s] = t[s] ^ r[s];
                            return i;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        220: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ "use strict";
                        var t = e("base64-js"), n = e("ieee754");
                        r.Buffer = s, r.SlowBuffer = function(e) {
                            +e != e && (e = 0);
                            return s.alloc(+e);
                        }, r.INSPECT_MAX_BYTES = 50;
                        function i(e) {
                            if (e > 2147483647) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var t = new Uint8Array(e);
                            return t.__proto__ = s.prototype, t;
                        }
                        function s(e, t, r) {
                            if ("number" == typeof e) {
                                if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                                return l(e);
                            }
                            return o(e, t, r);
                        }
                        function o(e, t, r) {
                            if ("string" == typeof e) return function(e, t) {
                                "string" == typeof t && "" !== t || (t = "utf8");
                                if (!s.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                                var r = 0 | h(e, t), n = i(r), o = n.write(e, t);
                                o !== r && (n = n.slice(0, o));
                                return n;
                            }(e, t);
                            if (ArrayBuffer.isView(e)) return c(e);
                            if (null == e) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            if (F(e, ArrayBuffer) || e && F(e.buffer, ArrayBuffer)) return function(e, t, r) {
                                if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                                if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                var n;
                                n = void 0 === t && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, t) : new Uint8Array(e, t, r);
                                return n.__proto__ = s.prototype, n;
                            }(e, t, r);
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var n = e.valueOf && e.valueOf();
                            if (null != n && n !== e) return s.from(n, t, r);
                            var o = function(e) {
                                if (s.isBuffer(e)) {
                                    var t = 0 | u(e.length), r = i(t);
                                    return 0 === r.length || e.copy(r, 0, 0, t), r;
                                }
                                if (void 0 !== e.length) return "number" != typeof e.length || L(e.length) ? i(0) : c(e);
                                if ("Buffer" === e.type && Array.isArray(e.data)) return c(e.data);
                            }(e);
                            if (o) return o;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return s.from(e[Symbol.toPrimitive]("string"), t, r);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                        }
                        function a(e) {
                            if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                            if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                        }
                        function l(e) {
                            return a(e), i(e < 0 ? 0 : 0 | u(e));
                        }
                        function c(e) {
                            for(var t = e.length < 0 ? 0 : 0 | u(e.length), r = i(t), n = 0; n < t; n += 1)r[n] = 255 & e[n];
                            return r;
                        }
                        function u(e) {
                            if (e >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647..toString(16) + " bytes");
                            return 0 | e;
                        }
                        function h(e, t) {
                            if (s.isBuffer(e)) return e.length;
                            if (ArrayBuffer.isView(e) || F(e, ArrayBuffer)) return e.byteLength;
                            if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                            var r = e.length, n = arguments.length > 2 && !0 === arguments[2];
                            if (!n && 0 === r) return 0;
                            for(var i = !1;;)switch(t){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return r;
                                case "utf8":
                                case "utf-8":
                                    return P(e).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return 2 * r;
                                case "hex":
                                    return r >>> 1;
                                case "base64":
                                    return B(e).length;
                                default:
                                    if (i) return n ? -1 : P(e).length;
                                    t = ("" + t).toLowerCase(), i = !0;
                            }
                        }
                        function f(e, t, r) {
                            var n = !1;
                            if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                            if ((r >>>= 0) <= (t >>>= 0)) return "";
                            for(e || (e = "utf8");;)switch(e){
                                case "hex":
                                    return C(this, t, r);
                                case "utf8":
                                case "utf-8":
                                    return k(this, t, r);
                                case "ascii":
                                    return S(this, t, r);
                                case "latin1":
                                case "binary":
                                    return M(this, t, r);
                                case "base64":
                                    return x(this, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return T(this, t, r);
                                default:
                                    if (n) throw new TypeError("Unknown encoding: " + e);
                                    e = (e + "").toLowerCase(), n = !0;
                            }
                        }
                        function d(e, t, r) {
                            var n = e[t];
                            e[t] = e[r], e[r] = n;
                        }
                        function p(e, t, r, n, i) {
                            if (0 === e.length) return -1;
                            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), L(r = +r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                                if (i) return -1;
                                r = e.length - 1;
                            } else if (r < 0) {
                                if (!i) return -1;
                                r = 0;
                            }
                            if ("string" == typeof t && (t = s.from(t, n)), s.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, r, n, i);
                            if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : m(e, [
                                t
                            ], r, n, i);
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function m(e, t, r, n, i) {
                            var s, o = 1, a = e.length, l = t.length;
                            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                if (e.length < 2 || t.length < 2) return -1;
                                o = 2, a /= 2, l /= 2, r /= 2;
                            }
                            function c(e, t) {
                                return 1 === o ? e[t] : e.readUInt16BE(t * o);
                            }
                            if (i) {
                                var u = -1;
                                for(s = r; s < a; s++)if (c(e, s) === c(t, -1 === u ? 0 : s - u)) {
                                    if (-1 === u && (u = s), s - u + 1 === l) return u * o;
                                } else -1 !== u && (s -= s - u), u = -1;
                            } else for(r + l > a && (r = a - l), s = r; s >= 0; s--){
                                for(var h = !0, f = 0; f < l; f++)if (c(e, s + f) !== c(t, f)) {
                                    h = !1;
                                    break;
                                }
                                if (h) return s;
                            }
                            return -1;
                        }
                        function b(e, t, r, n) {
                            r = Number(r) || 0;
                            var i = e.length - r;
                            n ? (n = Number(n)) > i && (n = i) : n = i;
                            var s = t.length;
                            n > s / 2 && (n = s / 2);
                            for(var o = 0; o < n; ++o){
                                var a = parseInt(t.substr(2 * o, 2), 16);
                                if (L(a)) return o;
                                e[r + o] = a;
                            }
                            return o;
                        }
                        function g(e, t, r, n) {
                            return D(P(t, e.length - r), e, r, n);
                        }
                        function y(e, t, r, n) {
                            return D(function(e) {
                                for(var t = [], r = 0; r < e.length; ++r)t.push(255 & e.charCodeAt(r));
                                return t;
                            }(t), e, r, n);
                        }
                        function v(e, t, r, n) {
                            return y(e, t, r, n);
                        }
                        function w(e, t, r, n) {
                            return D(B(t), e, r, n);
                        }
                        function _(e, t, r, n) {
                            return D(function(e, t) {
                                for(var r, n, i, s = [], o = 0; o < e.length && !((t -= 2) < 0); ++o)r = e.charCodeAt(o), n = r >> 8, i = r % 256, s.push(i), s.push(n);
                                return s;
                            }(t, e.length - r), e, r, n);
                        }
                        function x(e, r, n) {
                            return 0 === r && n === e.length ? t.fromByteArray(e) : t.fromByteArray(e.slice(r, n));
                        }
                        function k(e, t, r) {
                            r = Math.min(e.length, r);
                            for(var n = [], i = t; i < r;){
                                var s, o, a, l, c = e[i], u = null, h = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                                if (i + h <= r) switch(h){
                                    case 1:
                                        c < 128 && (u = c);
                                        break;
                                    case 2:
                                        128 == (192 & (s = e[i + 1])) && (l = (31 & c) << 6 | 63 & s) > 127 && (u = l);
                                        break;
                                    case 3:
                                        s = e[i + 1], o = e[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & c) << 12 | (63 & s) << 6 | 63 & o) > 2047 && (l < 55296 || l > 57343) && (u = l);
                                        break;
                                    case 4:
                                        s = e[i + 1], o = e[i + 2], a = e[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & c) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a) > 65535 && l < 1114112 && (u = l);
                                }
                                null === u ? (u = 65533, h = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += h;
                            }
                            return function(e) {
                                var t = e.length;
                                if (t <= 4096) return String.fromCharCode.apply(String, e);
                                var r = "", n = 0;
                                for(; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += 4096));
                                return r;
                            }(n);
                        }
                        r.kMaxLength = 2147483647, s.TYPED_ARRAY_SUPPORT = function() {
                            try {
                                var e = new Uint8Array(1);
                                return e.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                }, 42 === e.foo();
                            } catch (e) {
                                return !1;
                            }
                        }(), s.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(s.prototype, "parent", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.buffer;
                            }
                        }), Object.defineProperty(s.prototype, "offset", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.byteOffset;
                            }
                        }), "undefined" != typeof Symbol && null != Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
                            value: null,
                            configurable: !0,
                            enumerable: !1,
                            writable: !1
                        }), s.poolSize = 8192, s.from = function(e, t, r) {
                            return o(e, t, r);
                        }, s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, s.alloc = function(e, t, r) {
                            return function(e, t, r) {
                                return a(e), e <= 0 ? i(e) : void 0 !== t ? "string" == typeof r ? i(e).fill(t, r) : i(e).fill(t) : i(e);
                            }(e, t, r);
                        }, s.allocUnsafe = function(e) {
                            return l(e);
                        }, s.allocUnsafeSlow = function(e) {
                            return l(e);
                        }, s.isBuffer = function(e) {
                            return null != e && !0 === e._isBuffer && e !== s.prototype;
                        }, s.compare = function(e, t) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), F(t, Uint8Array) && (t = s.from(t, t.offset, t.byteLength)), !s.isBuffer(e) || !s.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (e === t) return 0;
                            for(var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i)if (e[i] !== t[i]) {
                                r = e[i], n = t[i];
                                break;
                            }
                            return r < n ? -1 : n < r ? 1 : 0;
                        }, s.isEncoding = function(e) {
                            switch(String(e).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }, s.concat = function(e, t) {
                            if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (0 === e.length) return s.alloc(0);
                            var r;
                            if (void 0 === t) for(t = 0, r = 0; r < e.length; ++r)t += e[r].length;
                            var n = s.allocUnsafe(t), i = 0;
                            for(r = 0; r < e.length; ++r){
                                var o = e[r];
                                if (F(o, Uint8Array) && (o = s.from(o)), !s.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
                                o.copy(n, i), i += o.length;
                            }
                            return n;
                        }, s.byteLength = h, s.prototype._isBuffer = !0, s.prototype.swap16 = function() {
                            var e = this.length;
                            if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var t = 0; t < e; t += 2)d(this, t, t + 1);
                            return this;
                        }, s.prototype.swap32 = function() {
                            var e = this.length;
                            if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var t = 0; t < e; t += 4)d(this, t, t + 3), d(this, t + 1, t + 2);
                            return this;
                        }, s.prototype.swap64 = function() {
                            var e = this.length;
                            if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var t = 0; t < e; t += 8)d(this, t, t + 7), d(this, t + 1, t + 6), d(this, t + 2, t + 5), d(this, t + 3, t + 4);
                            return this;
                        }, s.prototype.toString = function() {
                            var e = this.length;
                            return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : f.apply(this, arguments);
                        }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(e) {
                            if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                            return this === e || 0 === s.compare(this, e);
                        }, s.prototype.inspect = function() {
                            var e = "", t = r.INSPECT_MAX_BYTES;
                            return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
                        }, s.prototype.compare = function(e, t, r, n, i) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), !s.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                            if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                            if (n >= i && t >= r) return 0;
                            if (n >= i) return -1;
                            if (t >= r) return 1;
                            if (this === e) return 0;
                            for(var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0), l = Math.min(o, a), c = this.slice(n, i), u = e.slice(t, r), h = 0; h < l; ++h)if (c[h] !== u[h]) {
                                o = c[h], a = u[h];
                                break;
                            }
                            return o < a ? -1 : a < o ? 1 : 0;
                        }, s.prototype.includes = function(e, t, r) {
                            return -1 !== this.indexOf(e, t, r);
                        }, s.prototype.indexOf = function(e, t, r) {
                            return p(this, e, t, r, !0);
                        }, s.prototype.lastIndexOf = function(e, t, r) {
                            return p(this, e, t, r, !1);
                        }, s.prototype.write = function(e, t, r, n) {
                            if (void 0 === t) n = "utf8", r = this.length, t = 0;
                            else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
                            else {
                                if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                            }
                            var i = this.length - t;
                            if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            n || (n = "utf8");
                            for(var s = !1;;)switch(n){
                                case "hex":
                                    return b(this, e, t, r);
                                case "utf8":
                                case "utf-8":
                                    return g(this, e, t, r);
                                case "ascii":
                                    return y(this, e, t, r);
                                case "latin1":
                                case "binary":
                                    return v(this, e, t, r);
                                case "base64":
                                    return w(this, e, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return _(this, e, t, r);
                                default:
                                    if (s) throw new TypeError("Unknown encoding: " + n);
                                    n = ("" + n).toLowerCase(), s = !0;
                            }
                        }, s.prototype.toJSON = function() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function S(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(127 & e[i]);
                            return n;
                        }
                        function M(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(e[i]);
                            return n;
                        }
                        function C(e, t, r) {
                            var n = e.length;
                            (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
                            for(var i = "", s = t; s < r; ++s)i += N(e[s]);
                            return i;
                        }
                        function T(e, t, r) {
                            for(var n = e.slice(t, r), i = "", s = 0; s < n.length; s += 2)i += String.fromCharCode(n[s] + 256 * n[s + 1]);
                            return i;
                        }
                        function E(e, t, r) {
                            if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                            if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
                        }
                        function A(e, t, r, n, i, o) {
                            if (!s.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
                            if (r + n > e.length) throw new RangeError("Index out of range");
                        }
                        function R(e, t, r, n, i, s) {
                            if (r + n > e.length) throw new RangeError("Index out of range");
                            if (r < 0) throw new RangeError("Index out of range");
                        }
                        function O(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 4), n.write(e, t, r, i, 23, 4), r + 4;
                        }
                        function j(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 8), n.write(e, t, r, i, 52, 8), r + 8;
                        }
                        s.prototype.slice = function(e, t) {
                            var r = this.length;
                            (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
                            var n = this.subarray(e, t);
                            return n.__proto__ = s.prototype, n;
                        }, s.prototype.readUIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n;
                        }, s.prototype.readUIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e + --t], i = 1; t > 0 && (i *= 256);)n += this[e + --t] * i;
                            return n;
                        }, s.prototype.readUInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), this[e];
                        }, s.prototype.readUInt16LE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] | this[e + 1] << 8;
                        }, s.prototype.readUInt16BE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] << 8 | this[e + 1];
                        }, s.prototype.readUInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                        }, s.prototype.readUInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                        }, s.prototype.readIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
                        }, s.prototype.readIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = t, i = 1, s = this[e + --n]; n > 0 && (i *= 256);)s += this[e + --n] * i;
                            return s >= (i *= 128) && (s -= Math.pow(2, 8 * t)), s;
                        }, s.prototype.readInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                        }, s.prototype.readInt16LE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e] | this[e + 1] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt16BE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e + 1] | this[e] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                        }, s.prototype.readInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                        }, s.prototype.readFloatLE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !0, 23, 4);
                        }, s.prototype.readFloatBE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !1, 23, 4);
                        }, s.prototype.readDoubleLE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !0, 52, 8);
                        }, s.prototype.readDoubleBE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !1, 52, 8);
                        }, s.prototype.writeUIntLE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = 1, s = 0;
                            for(this[t] = 255 & e; ++s < r && (i *= 256);)this[t + s] = e / i & 255;
                            return t + r;
                        }, s.prototype.writeUIntBE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = r - 1, s = 1;
                            for(this[t + i] = 255 & e; --i >= 0 && (s *= 256);)this[t + i] = e / s & 255;
                            return t + r;
                        }, s.prototype.writeUInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeUInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeUInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeUInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
                        }, s.prototype.writeUInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeIntLE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = 0, o = 1, a = 0;
                            for(this[t] = 255 & e; ++s < r && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s - 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeIntBE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = r - 1, o = 1, a = 0;
                            for(this[t + s] = 255 & e; --s >= 0 && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s + 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
                        }, s.prototype.writeInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeFloatLE = function(e, t, r) {
                            return O(this, e, t, !0, r);
                        }, s.prototype.writeFloatBE = function(e, t, r) {
                            return O(this, e, t, !1, r);
                        }, s.prototype.writeDoubleLE = function(e, t, r) {
                            return j(this, e, t, !0, r);
                        }, s.prototype.writeDoubleBE = function(e, t, r) {
                            return j(this, e, t, !1, r);
                        }, s.prototype.copy = function(e, t, r, n) {
                            if (!s.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                            if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
                            if (0 === e.length || 0 === this.length) return 0;
                            if (t < 0) throw new RangeError("targetStart out of bounds");
                            if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                            if (n < 0) throw new RangeError("sourceEnd out of bounds");
                            n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
                            var i = n - r;
                            if (this === e && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, r, n);
                            else if (this === e && r < t && t < n) for(var o = i - 1; o >= 0; --o)e[o + t] = this[o + r];
                            else Uint8Array.prototype.set.call(e, this.subarray(r, n), t);
                            return i;
                        }, s.prototype.fill = function(e, t, r, n) {
                            if ("string" == typeof e) {
                                if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                if ("string" == typeof n && !s.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                if (1 === e.length) {
                                    var i = e.charCodeAt(0);
                                    ("utf8" === n && i < 128 || "latin1" === n) && (e = i);
                                }
                            } else "number" == typeof e && (e &= 255);
                            if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                            if (r <= t) return this;
                            var o;
                            if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for(o = t; o < r; ++o)this[o] = e;
                            else {
                                var a = s.isBuffer(e) ? e : s.from(e, n), l = a.length;
                                if (0 === l) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                                for(o = 0; o < r - t; ++o)this[o + t] = a[o % l];
                            }
                            return this;
                        };
                        var I = /[^+/0-9A-Za-z-_]/g;
                        function N(e) {
                            return e < 16 ? "0" + e.toString(16) : e.toString(16);
                        }
                        function P(e, t) {
                            var r;
                            t = t || 1 / 0;
                            for(var n = e.length, i = null, s = [], o = 0; o < n; ++o){
                                if ((r = e.charCodeAt(o)) > 55295 && r < 57344) {
                                    if (!i) {
                                        if (r > 56319) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        if (o + 1 === n) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        i = r;
                                        continue;
                                    }
                                    if (r < 56320) {
                                        (t -= 3) > -1 && s.push(239, 191, 189), i = r;
                                        continue;
                                    }
                                    r = 65536 + (i - 55296 << 10 | r - 56320);
                                } else i && (t -= 3) > -1 && s.push(239, 191, 189);
                                if (i = null, r < 128) {
                                    if ((t -= 1) < 0) break;
                                    s.push(r);
                                } else if (r < 2048) {
                                    if ((t -= 2) < 0) break;
                                    s.push(r >> 6 | 192, 63 & r | 128);
                                } else if (r < 65536) {
                                    if ((t -= 3) < 0) break;
                                    s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                } else {
                                    if (!(r < 1114112)) throw new Error("Invalid code point");
                                    if ((t -= 4) < 0) break;
                                    s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                }
                            }
                            return s;
                        }
                        function B(e) {
                            return t.toByteArray(function(e) {
                                if ((e = (e = e.split("=")[0]).trim().replace(I, "")).length < 2) return "";
                                for(; e.length % 4 != 0;)e += "=";
                                return e;
                            }(e));
                        }
                        function D(e, t, r, n) {
                            for(var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i)t[i + r] = e[i];
                            return i;
                        }
                        function F(e, t) {
                            return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
                        }
                        function L(e) {
                            return e != e;
                        }
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "base64-js": 185,
                buffer: 220,
                ieee754: 439
            }
        ],
        221: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("stream").Transform, s = e("string_decoder").StringDecoder;
                function o(e) {
                    i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
                }
                e("inherits")(o, i), o.prototype.update = function(e, t, r) {
                    "string" == typeof e && (e = n.from(e, t));
                    var i = this._update(e);
                    return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
                }, o.prototype.setAutoPadding = function() {}, o.prototype.getAuthTag = function() {
                    throw new Error("trying to get auth tag in unsupported state");
                }, o.prototype.setAuthTag = function() {
                    throw new Error("trying to set auth tag in unsupported state");
                }, o.prototype.setAAD = function() {
                    throw new Error("trying to set aad in unsupported state");
                }, o.prototype._transform = function(e, t, r) {
                    var n;
                    try {
                        this.hashMode ? this._update(e) : this.push(this._update(e));
                    } catch (e) {
                        n = e;
                    } finally{
                        r(n);
                    }
                }, o.prototype._flush = function(e) {
                    var t;
                    try {
                        this.push(this.__final());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, o.prototype._finalOrDigest = function(e) {
                    var t = this.__final() || n.alloc(0);
                    return e && (t = this._toString(t, e, !0)), t;
                }, o.prototype._toString = function(e, t, r) {
                    if (this._decoder || (this._decoder = new s(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");
                    var n = this._decoder.write(e);
                    return r && (n += this._decoder.end()), n;
                }, t.exports = o;
            },
            {
                inherits: 440,
                "safe-buffer": 494,
                stream: 505,
                string_decoder: 218
            }
        ],
        222: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a function");
                };
            },
            {
                "../internals/is-callable": 285,
                "../internals/try-to-string": 349
            }
        ],
        223: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-constructor"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a constructor");
                };
            },
            {
                "../internals/is-constructor": 286,
                "../internals/try-to-string": 349
            }
        ],
        224: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = String, s = TypeError;
                t.exports = function(e) {
                    if ("object" == typeof e || n(e)) return e;
                    throw new s("Can't set " + i(e) + " as a prototype");
                };
            },
            {
                "../internals/is-callable": 285
            }
        ],
        225: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/object-create"), s = e("../internals/object-define-property").f, o = n("unscopables"), a = Array.prototype;
                void 0 === a[o] && s(a, o, {
                    configurable: !0,
                    value: i(null)
                }), t.exports = function(e) {
                    a[o][e] = !0;
                };
            },
            {
                "../internals/object-create": 306,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        226: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-is-prototype-of"), i = TypeError;
                t.exports = function(e, t) {
                    if (n(t, e)) return e;
                    throw new i("Incorrect invocation");
                };
            },
            {
                "../internals/object-is-prototype-of": 314
            }
        ],
        227: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = String, s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not an object");
                };
            },
            {
                "../internals/is-object": 289
            }
        ],
        228: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/to-absolute-index"), s = e("../internals/length-of-array-like"), o = function(e) {
                    return function(t, r, o) {
                        var a, l = n(t), c = s(l), u = i(o, c);
                        if (e && r != r) {
                            for(; c > u;)if ((a = l[u++]) != a) return !0;
                        } else for(; c > u; u++)if ((e || u in l) && l[u] === r) return e || u || 0;
                        return !e && -1;
                    };
                };
                t.exports = {
                    includes: o(!0),
                    indexOf: o(!1)
                };
            },
            {
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340,
                "../internals/to-indexed-object": 341
            }
        ],
        229: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-uncurry-this"), s = e("../internals/indexed-object"), o = e("../internals/to-object"), a = e("../internals/length-of-array-like"), l = e("../internals/array-species-create"), c = i([].push), u = function(e) {
                    var t = 1 === e, r = 2 === e, i = 3 === e, u = 4 === e, h = 6 === e, f = 7 === e, d = 5 === e || h;
                    return function(p, m, b, g) {
                        for(var y, v, w = o(p), _ = s(w), x = n(m, b), k = a(_), S = 0, M = g || l, C = t ? M(p, k) : r || f ? M(p, 0) : void 0; k > S; S++)if ((d || S in _) && (v = x(y = _[S], S, w), e)) {
                            if (t) C[S] = v;
                            else if (v) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return y;
                                case 6:
                                    return S;
                                case 2:
                                    c(C, y);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    c(C, y);
                            }
                        }
                        return h ? -1 : i || u ? u : C;
                    };
                };
                t.exports = {
                    forEach: u(0),
                    map: u(1),
                    filter: u(2),
                    some: u(3),
                    every: u(4),
                    find: u(5),
                    findIndex: u(6),
                    filterReject: u(7)
                };
            },
            {
                "../internals/array-species-create": 233,
                "../internals/function-bind-context": 262,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/length-of-array-like": 299,
                "../internals/to-object": 344
            }
        ],
        230: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-absolute-index"), i = e("../internals/length-of-array-like"), s = e("../internals/create-property"), o = Array, a = Math.max;
                t.exports = function(e, t, r) {
                    for(var l = i(e), c = n(t, l), u = n(void 0 === r ? l : r, l), h = o(a(u - c, 0)), f = 0; c < u; c++, f++)s(h, f, e[c]);
                    return h.length = f, h;
                };
            },
            {
                "../internals/create-property": 243,
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340
            }
        ],
        231: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n([].slice);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        232: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-array"), i = e("../internals/is-constructor"), s = e("../internals/is-object"), o = e("../internals/well-known-symbol")("species"), a = Array;
                t.exports = function(e) {
                    var t;
                    return n(e) && (t = e.constructor, (i(t) && (t === a || n(t.prototype)) || s(t) && null === (t = t[o])) && (t = void 0)), void 0 === t ? a : t;
                };
            },
            {
                "../internals/is-array": 284,
                "../internals/is-constructor": 286,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        233: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/array-species-constructor");
                t.exports = function(e, t) {
                    return new (n(e))(0 === t ? 0 : t);
                };
            },
            {
                "../internals/array-species-constructor": 232
            }
        ],
        234: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("iterator"), i = !1;
                try {
                    var s = 0, o = {
                        next: function() {
                            return {
                                done: !!s++
                            };
                        },
                        return: function() {
                            i = !0;
                        }
                    };
                    o[n] = function() {
                        return this;
                    }, Array.from(o, function() {
                        throw 2;
                    });
                } catch (e) {}
                t.exports = function(e, t) {
                    try {
                        if (!t && !i) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var r = !1;
                    try {
                        var s = {};
                        s[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e(s);
                    } catch (e) {}
                    return r;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        235: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = n({}.toString), s = n("".slice);
                t.exports = function(e) {
                    return s(i(e), 8, -1);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        236: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-string-tag-support"), i = e("../internals/is-callable"), s = e("../internals/classof-raw"), o = e("../internals/well-known-symbol")("toStringTag"), a = Object, l = "Arguments" === s(function() {
                    return arguments;
                }());
                t.exports = n ? s : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = a(e), o)) ? r : l ? s(t) : "Object" === (n = s(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-callable": 285,
                "../internals/to-string-tag-support": 347,
                "../internals/well-known-symbol": 357
            }
        ],
        237: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/own-keys"), s = e("../internals/object-get-own-property-descriptor"), o = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    for(var a = i(t), l = o.f, c = s.f, u = 0; u < a.length; u++){
                        var h = a[u];
                        n(e, h) || r && n(r, h) || l(e, h, c(t, h));
                    }
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/own-keys": 321
            }
        ],
        238: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t = /./;
                    try {
                        "/./"[e](t);
                    } catch (r) {
                        try {
                            return t[n] = !1, "/./"[e](t);
                        } catch (e) {}
                    }
                    return !1;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        239: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        240: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                };
            },
            {}
        ],
        241: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = n ? function(e, t, r) {
                    return i.f(e, t, s(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308
            }
        ],
        242: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            {}
        ],
        243: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-property-key"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = function(e, t, r) {
                    var o = n(t);
                    o in e ? i.f(e, o, s(0, r)) : e[o] = r;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/object-define-property": 308,
                "../internals/to-property-key": 346
            }
        ],
        244: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/make-built-in"), i = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    return r.get && n(r.get, t, {
                        getter: !0
                    }), r.set && n(r.set, t, {
                        setter: !0
                    }), i.f(e, t, r);
                };
            },
            {
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        245: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/object-define-property"), s = e("../internals/make-built-in"), o = e("../internals/define-global-property");
                t.exports = function(e, t, r, a) {
                    a || (a = {});
                    var l = a.enumerable, c = void 0 !== a.name ? a.name : t;
                    if (n(r) && s(r, c, a), a.global) l ? e[t] = r : o(t, r);
                    else {
                        try {
                            a.unsafe ? e[t] && (l = !0) : delete e[t];
                        } catch (e) {}
                        l ? e[t] = r : i.f(e, t, {
                            value: r,
                            enumerable: !1,
                            configurable: !a.nonConfigurable,
                            writable: !a.nonWritable
                        });
                    }
                    return e;
                };
            },
            {
                "../internals/define-global-property": 246,
                "../internals/is-callable": 285,
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        246: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = Object.defineProperty;
                t.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            {
                "../internals/global": 274
            }
        ],
        247: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        248: [
            function(e, t, r) {
                "use strict";
                var n = "object" == typeof document && document.all, i = void 0 === n && void 0 !== n;
                t.exports = {
                    all: n,
                    IS_HTMLDDA: i
                };
            },
            {}
        ],
        249: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-object"), s = n.document, o = i(s) && i(s.createElement);
                t.exports = function(e) {
                    return o ? s.createElement(e) : {};
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-object": 289
            }
        ],
        250: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-is-deno"), i = e("../internals/engine-is-node");
                t.exports = !n && !i && "object" == typeof window && "object" == typeof document;
            },
            {
                "../internals/engine-is-deno": 251,
                "../internals/engine-is-node": 254
            }
        ],
        251: [
            function(e, t, r) {
                "use strict";
                t.exports = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
            },
            {}
        ],
        252: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /ipad|iphone|ipod/i.test(n) && "undefined" != typeof Pebble;
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        253: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        254: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/classof-raw");
                t.exports = "process" === i(n.process);
            },
            {
                "../internals/classof-raw": 235,
                "../internals/global": 274
            }
        ],
        255: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /web0s(?!.*chrome)/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        256: [
            function(e, t, r) {
                "use strict";
                t.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            {}
        ],
        257: [
            function(e, t, r) {
                "use strict";
                var n, i, s = e("../internals/global"), o = e("../internals/engine-user-agent"), a = s.process, l = s.Deno, c = a && a.versions || l && l.version, u = c && c.v8;
                u && (i = (n = u.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && o && (!(n = o.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = o.match(/Chrome\/(\d+)/)) && (i = +n[1]), t.exports = i;
            },
            {
                "../internals/engine-user-agent": 256,
                "../internals/global": 274
            }
        ],
        258: [
            function(e, t, r) {
                "use strict";
                t.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            {}
        ],
        259: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/object-get-own-property-descriptor").f, s = e("../internals/create-non-enumerable-property"), o = e("../internals/define-built-in"), a = e("../internals/define-global-property"), l = e("../internals/copy-constructor-properties"), c = e("../internals/is-forced");
                t.exports = function(e, t) {
                    var r, u, h, f, d, p = e.target, m = e.global, b = e.stat;
                    if (r = m ? n : b ? n[p] || a(p, {}) : (n[p] || {}).prototype) for(u in t){
                        if (f = t[u], h = e.dontCallGetSet ? (d = i(r, u)) && d.value : r[u], !c(m ? u : p + (b ? "." : "#") + u, e.forced) && void 0 !== h) {
                            if (typeof f == typeof h) continue;
                            l(f, h);
                        }
                        (e.sham || h && h.sham) && s(f, "sham", !0), o(r, u, f, e);
                    }
                };
            },
            {
                "../internals/copy-constructor-properties": 237,
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/define-global-property": 246,
                "../internals/global": 274,
                "../internals/is-forced": 287,
                "../internals/object-get-own-property-descriptor": 309
            }
        ],
        260: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            {}
        ],
        261: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.apply, o = i.call;
                t.exports = "object" == typeof Reflect && Reflect.apply || (n ? o.bind(s) : function() {
                    return o.apply(s, arguments);
                });
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        262: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-clause"), i = e("../internals/a-callable"), s = e("../internals/function-bind-native"), o = n(n.bind);
                t.exports = function(e, t) {
                    return i(e), void 0 === t ? e : s ? o(e, t) : function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-bind-native": 263,
                "../internals/function-uncurry-this-clause": 267
            }
        ],
        263: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        264: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype.call;
                t.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        265: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/has-own-property"), s = Function.prototype, o = n && Object.getOwnPropertyDescriptor, a = i(s, "name"), l = a && "something" === (function() {}).name, c = a && (!n || n && o(s, "name").configurable);
                t.exports = {
                    EXISTS: a,
                    PROPER: l,
                    CONFIGURABLE: c
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/has-own-property": 275
            }
        ],
        266: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/a-callable");
                t.exports = function(e, t, r) {
                    try {
                        return n(i(Object.getOwnPropertyDescriptor(e, t)[r]));
                    } catch (e) {}
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-uncurry-this": 268
            }
        ],
        267: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/function-uncurry-this");
                t.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268
            }
        ],
        268: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.call, o = n && i.bind.bind(s, s);
                t.exports = n ? o : function(e) {
                    return function() {
                        return s.apply(e, arguments);
                    };
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        269: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = function(e) {
                    return i(e) ? e : void 0;
                };
                t.exports = function(e, t) {
                    return arguments.length < 2 ? s(n[e]) : n[e] && n[e][t];
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        270: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = e("../internals/get-method"), s = e("../internals/is-null-or-undefined"), o = e("../internals/iterators"), a = e("../internals/well-known-symbol")("iterator");
                t.exports = function(e) {
                    if (!s(e)) return i(e, a) || i(e, "@@iterator") || o[n(e)];
                };
            },
            {
                "../internals/classof": 236,
                "../internals/get-method": 273,
                "../internals/is-null-or-undefined": 288,
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        271: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/a-callable"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/get-iterator-method"), l = TypeError;
                t.exports = function(e, t) {
                    var r = arguments.length < 2 ? a(e) : t;
                    if (i(r)) return s(n(r, e));
                    throw new l(o(e) + " is not iterable");
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-iterator-method": 270,
                "../internals/try-to-string": 349
            }
        ],
        272: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-array"), s = e("../internals/is-callable"), o = e("../internals/classof-raw"), a = e("../internals/to-string"), l = n([].push);
                t.exports = function(e) {
                    if (s(e)) return e;
                    if (i(e)) {
                        for(var t = e.length, r = [], n = 0; n < t; n++){
                            var c = e[n];
                            "string" == typeof c ? l(r, c) : "number" != typeof c && "Number" !== o(c) && "String" !== o(c) || l(r, a(c));
                        }
                        var u = r.length, h = !0;
                        return function(e, t) {
                            if (h) return h = !1, t;
                            if (i(this)) return t;
                            for(var n = 0; n < u; n++)if (r[n] === e) return t;
                        };
                    }
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268,
                "../internals/is-array": 284,
                "../internals/is-callable": 285,
                "../internals/to-string": 348
            }
        ],
        273: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = e("../internals/is-null-or-undefined");
                t.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/is-null-or-undefined": 288
            }
        ],
        274: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = function(e) {
                            return e && e.Math === Math && e;
                        };
                        t.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || function() {
                            return this;
                        }() || this || Function("return this")();
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        275: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/to-object"), s = n({}.hasOwnProperty);
                t.exports = Object.hasOwn || function(e, t) {
                    return s(i(e), t);
                };
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/to-object": 344
            }
        ],
        276: [
            function(e, t, r) {
                "use strict";
                t.exports = {};
            },
            {}
        ],
        277: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    try {
                        1 === arguments.length ? console.error(e) : console.error(e, t);
                    } catch (e) {}
                };
            },
            {}
        ],
        278: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in");
                t.exports = n("document", "documentElement");
            },
            {
                "../internals/get-built-in": 269
            }
        ],
        279: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/document-create-element");
                t.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(s("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/document-create-element": 249,
                "../internals/fails": 260
            }
        ],
        280: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/classof-raw"), o = Object, a = n("".split);
                t.exports = i(function() {
                    return !o("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === s(e) ? a(e, "") : o(e);
                } : o;
            },
            {
                "../internals/classof-raw": 235,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268
            }
        ],
        281: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-callable"), s = e("../internals/shared-store"), o = n(Function.toString);
                i(s.inspectSource) || (s.inspectSource = function(e) {
                    return o(e);
                }), t.exports = s.inspectSource;
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/is-callable": 285,
                "../internals/shared-store": 333
            }
        ],
        282: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/weak-map-basic-detection"), a = e("../internals/global"), l = e("../internals/is-object"), c = e("../internals/create-non-enumerable-property"), u = e("../internals/has-own-property"), h = e("../internals/shared-store"), f = e("../internals/shared-key"), d = e("../internals/hidden-keys"), p = a.TypeError, m = a.WeakMap;
                if (o || h.state) {
                    var b = h.state || (h.state = new m);
                    b.get = b.get, b.has = b.has, b.set = b.set, n = function(e, t) {
                        if (b.has(e)) throw new p("Object already initialized");
                        return t.facade = e, b.set(e, t), t;
                    }, i = function(e) {
                        return b.get(e) || {};
                    }, s = function(e) {
                        return b.has(e);
                    };
                } else {
                    var g = f("state");
                    d[g] = !0, n = function(e, t) {
                        if (u(e, g)) throw new p("Object already initialized");
                        return t.facade = e, c(e, g, t), t;
                    }, i = function(e) {
                        return u(e, g) ? e[g] : {};
                    }, s = function(e) {
                        return u(e, g);
                    };
                }
                t.exports = {
                    set: n,
                    get: i,
                    has: s,
                    enforce: function(e) {
                        return s(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!l(t) || (r = i(t)).type !== e) throw new p("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/is-object": 289,
                "../internals/shared-key": 332,
                "../internals/shared-store": 333,
                "../internals/weak-map-basic-detection": 354
            }
        ],
        283: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/iterators"), s = n("iterator"), o = Array.prototype;
                t.exports = function(e) {
                    return void 0 !== e && (i.Array === e || o[s] === e);
                };
            },
            {
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        284: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw");
                t.exports = Array.isArray || function(e) {
                    return "Array" === n(e);
                };
            },
            {
                "../internals/classof-raw": 235
            }
        ],
        285: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/document-all"), i = n.all;
                t.exports = n.IS_HTMLDDA ? function(e) {
                    return "function" == typeof e || e === i;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            {
                "../internals/document-all": 248
            }
        ],
        286: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/classof"), a = e("../internals/get-built-in"), l = e("../internals/inspect-source"), c = function() {}, u = [], h = a("Reflect", "construct"), f = /^\s*(?:class|function)\b/, d = n(f.exec), p = !f.test(c), m = function(e) {
                    if (!s(e)) return !1;
                    try {
                        return h(c, u, e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, b = function(e) {
                    if (!s(e)) return !1;
                    switch(o(e)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return p || !!d(f, l(e));
                    } catch (e) {
                        return !0;
                    }
                };
                b.sham = !0, t.exports = !h || i(function() {
                    var e;
                    return m(m.call) || !m(Object) || !m(function() {
                        e = !0;
                    }) || e;
                }) ? b : m;
            },
            {
                "../internals/classof": 236,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285
            }
        ],
        287: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails"), i = e("../internals/is-callable"), s = /#|\.prototype\./, o = function(e, t) {
                    var r = l[a(e)];
                    return r === u || r !== c && (i(t) ? n(t) : !!t);
                }, a = o.normalize = function(e) {
                    return String(e).replace(s, ".").toLowerCase();
                }, l = o.data = {}, c = o.NATIVE = "N", u = o.POLYFILL = "P";
                t.exports = o;
            },
            {
                "../internals/fails": 260,
                "../internals/is-callable": 285
            }
        ],
        288: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        289: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/document-all"), s = i.all;
                t.exports = i.IS_HTMLDDA ? function(e) {
                    return "object" == typeof e ? null !== e : n(e) || e === s;
                } : function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            {
                "../internals/document-all": 248,
                "../internals/is-callable": 285
            }
        ],
        290: [
            function(e, t, r) {
                "use strict";
                t.exports = !1;
            },
            {}
        ],
        291: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = e("../internals/classof-raw"), s = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t;
                    return n(e) && (void 0 !== (t = e[s]) ? !!t : "RegExp" === i(e));
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        292: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/is-callable"), s = e("../internals/object-is-prototype-of"), o = e("../internals/use-symbol-as-uid"), a = Object;
                t.exports = o ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && s(t.prototype, a(e));
                };
            },
            {
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/object-is-prototype-of": 314,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        293: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-call"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/is-array-iterator-method"), l = e("../internals/length-of-array-like"), c = e("../internals/object-is-prototype-of"), u = e("../internals/get-iterator"), h = e("../internals/get-iterator-method"), f = e("../internals/iterator-close"), d = TypeError, p = function(e, t) {
                    this.stopped = e, this.result = t;
                }, m = p.prototype;
                t.exports = function(e, t, r) {
                    var b, g, y, v, w, _, x, k = r && r.that, S = !(!r || !r.AS_ENTRIES), M = !(!r || !r.IS_RECORD), C = !(!r || !r.IS_ITERATOR), T = !(!r || !r.INTERRUPTED), E = n(t, k), A = function(e) {
                        return b && f(b, "normal", e), new p(!0, e);
                    }, R = function(e) {
                        return S ? (s(e), T ? E(e[0], e[1], A) : E(e[0], e[1])) : T ? E(e, A) : E(e);
                    };
                    if (M) b = e.iterator;
                    else if (C) b = e;
                    else {
                        if (!(g = h(e))) throw new d(o(e) + " is not iterable");
                        if (a(g)) {
                            for(y = 0, v = l(e); v > y; y++)if ((w = R(e[y])) && c(m, w)) return w;
                            return new p(!1);
                        }
                        b = u(e, g);
                    }
                    for(_ = M ? e.next : b.next; !(x = i(_, b)).done;){
                        try {
                            w = R(x.value);
                        } catch (e) {
                            f(b, "throw", e);
                        }
                        if ("object" == typeof w && w && c(m, w)) return w;
                    }
                    return new p(!1);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-bind-context": 262,
                "../internals/function-call": 264,
                "../internals/get-iterator": 271,
                "../internals/get-iterator-method": 270,
                "../internals/is-array-iterator-method": 283,
                "../internals/iterator-close": 294,
                "../internals/length-of-array-like": 299,
                "../internals/object-is-prototype-of": 314,
                "../internals/try-to-string": 349
            }
        ],
        294: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/an-object"), s = e("../internals/get-method");
                t.exports = function(e, t, r) {
                    var o, a;
                    i(e);
                    try {
                        if (!(o = s(e, "return"))) {
                            if ("throw" === t) throw r;
                            return r;
                        }
                        o = n(o, e);
                    } catch (e) {
                        a = !0, o = e;
                    }
                    if ("throw" === t) throw r;
                    if (a) throw o;
                    return i(o), r;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-method": 273
            }
        ],
        295: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/iterators-core").IteratorPrototype, i = e("../internals/object-create"), s = e("../internals/create-property-descriptor"), o = e("../internals/set-to-string-tag"), a = e("../internals/iterators"), l = function() {
                    return this;
                };
                t.exports = function(e, t, r, c) {
                    var u = t + " Iterator";
                    return e.prototype = i(n, {
                        next: s(+!c, r)
                    }), o(e, u, !1, !0), a[u] = l, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-create": 306,
                "../internals/set-to-string-tag": 331
            }
        ],
        296: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/is-pure"), o = e("../internals/function-name"), a = e("../internals/is-callable"), l = e("../internals/iterator-create-constructor"), c = e("../internals/object-get-prototype-of"), u = e("../internals/object-set-prototype-of"), h = e("../internals/set-to-string-tag"), f = e("../internals/create-non-enumerable-property"), d = e("../internals/define-built-in"), p = e("../internals/well-known-symbol"), m = e("../internals/iterators"), b = e("../internals/iterators-core"), g = o.PROPER, y = o.CONFIGURABLE, v = b.IteratorPrototype, w = b.BUGGY_SAFARI_ITERATORS, _ = p("iterator"), x = function() {
                    return this;
                };
                t.exports = function(e, t, r, o, p, b, k) {
                    l(r, t, o);
                    var S, M, C, T = function(e) {
                        if (e === p && j) return j;
                        if (!w && e && e in R) return R[e];
                        switch(e){
                            case "keys":
                            case "values":
                            case "entries":
                                return function() {
                                    return new r(this, e);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }, E = t + " Iterator", A = !1, R = e.prototype, O = R[_] || R["@@iterator"] || p && R[p], j = !w && O || T(p), I = "Array" === t && R.entries || O;
                    if (I && (S = c(I.call(new e))) !== Object.prototype && S.next && (s || c(S) === v || (u ? u(S, v) : a(S[_]) || d(S, _, x)), h(S, E, !0, !0), s && (m[E] = x)), g && "values" === p && O && "values" !== O.name && (!s && y ? f(R, "name", "values") : (A = !0, j = function() {
                        return i(O, this);
                    })), p) {
                        if (M = {
                            values: T("values"),
                            keys: b ? j : T("keys"),
                            entries: T("entries")
                        }, k) for(C in M)(w || A || !(C in R)) && d(R, C, M[C]);
                        else n({
                            target: t,
                            proto: !0,
                            forced: w || A
                        }, M);
                    }
                    return s && !k || R[_] === j || d(R, _, j, {
                        name: p
                    }), m[t] = j, M;
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/function-name": 265,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/iterator-create-constructor": 295,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-set-prototype-of": 318,
                "../internals/set-to-string-tag": 331,
                "../internals/well-known-symbol": 357
            }
        ],
        297: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/fails"), a = e("../internals/is-callable"), l = e("../internals/is-object"), c = e("../internals/object-create"), u = e("../internals/object-get-prototype-of"), h = e("../internals/define-built-in"), f = e("../internals/well-known-symbol"), d = e("../internals/is-pure"), p = f("iterator"), m = !1;
                [].keys && ("next" in (s = [].keys()) ? (i = u(u(s))) !== Object.prototype && (n = i) : m = !0), !l(n) || o(function() {
                    var e = {};
                    return n[p].call(e) !== e;
                }) ? n = {} : d && (n = c(n)), a(n[p]) || h(n, p, function() {
                    return this;
                }), t.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: m
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/fails": 260,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-get-prototype-of": 313,
                "../internals/well-known-symbol": 357
            }
        ],
        298: [
            function(e, t, r) {
                arguments[4][276][0].apply(r, arguments);
            },
            {
                dup: 276
            }
        ],
        299: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-length");
                t.exports = function(e) {
                    return n(e.length);
                };
            },
            {
                "../internals/to-length": 343
            }
        ],
        300: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/has-own-property"), a = e("../internals/descriptors"), l = e("../internals/function-name").CONFIGURABLE, c = e("../internals/inspect-source"), u = e("../internals/internal-state"), h = u.enforce, f = u.get, d = String, p = Object.defineProperty, m = n("".slice), b = n("".replace), g = n([].join), y = a && !i(function() {
                    return 8 !== p(function() {}, "length", {
                        value: 8
                    }).length;
                }), v = String(String).split("String"), w = t.exports = function(e, t, r) {
                    "Symbol(" === m(d(t), 0, 7) && (t = "[" + b(d(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!o(e, "name") || l && e.name !== t) && (a ? p(e, "name", {
                        value: t,
                        configurable: !0
                    }) : e.name = t), y && r && o(r, "arity") && e.length !== r.arity && p(e, "length", {
                        value: r.arity
                    });
                    try {
                        r && o(r, "constructor") && r.constructor ? a && p(e, "prototype", {
                            writable: !1
                        }) : e.prototype && (e.prototype = void 0);
                    } catch (e) {}
                    var n = h(e);
                    return o(n, "source") || (n.source = g(v, "string" == typeof t ? t : "")), e;
                };
                Function.prototype.toString = w(function() {
                    return s(this) && f(this).source || c(this);
                }, "toString");
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-name": 265,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/inspect-source": 281,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285
            }
        ],
        301: [
            function(e, t, r) {
                "use strict";
                var n = Math.ceil, i = Math.floor;
                t.exports = Math.trunc || function(e) {
                    var t = +e;
                    return (t > 0 ? i : n)(t);
                };
            },
            {}
        ],
        302: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a, l = e("../internals/global"), c = e("../internals/function-bind-context"), u = e("../internals/object-get-own-property-descriptor").f, h = e("../internals/task").set, f = e("../internals/queue"), d = e("../internals/engine-is-ios"), p = e("../internals/engine-is-ios-pebble"), m = e("../internals/engine-is-webos-webkit"), b = e("../internals/engine-is-node"), g = l.MutationObserver || l.WebKitMutationObserver, y = l.document, v = l.process, w = l.Promise, _ = u(l, "queueMicrotask"), x = _ && _.value;
                if (!x) {
                    var k = new f, S = function() {
                        var e, t;
                        for(b && (e = v.domain) && e.exit(); t = k.get();)try {
                            t();
                        } catch (e) {
                            throw k.head && n(), e;
                        }
                        e && e.enter();
                    };
                    d || b || m || !g || !y ? !p && w && w.resolve ? ((o = w.resolve(void 0)).constructor = w, a = c(o.then, o), n = function() {
                        a(S);
                    }) : b ? n = function() {
                        v.nextTick(S);
                    } : (h = c(h, l), n = function() {
                        h(S);
                    }) : (i = !0, s = y.createTextNode(""), new g(S).observe(s, {
                        characterData: !0
                    }), n = function() {
                        s.data = i = !i;
                    }), x = function(e) {
                        k.head || n(), k.add(e);
                    };
                }
                t.exports = x;
            },
            {
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-ios-pebble": 252,
                "../internals/engine-is-node": 254,
                "../internals/engine-is-webos-webkit": 255,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/queue": 328,
                "../internals/task": 339
            }
        ],
        303: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = TypeError, s = function(e) {
                    var t, r;
                    this.promise = new e(function(e, n) {
                        if (void 0 !== t || void 0 !== r) throw new i("Bad Promise constructor");
                        t = e, r = n;
                    }), this.resolve = n(t), this.reject = n(r);
                };
                t.exports.f = function(e) {
                    return new s(e);
                };
            },
            {
                "../internals/a-callable": 222
            }
        ],
        304: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-regexp"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("The method doesn't accept regular expressions");
                    return e;
                };
            },
            {
                "../internals/is-regexp": 291
            }
        ],
        305: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-uncurry-this"), s = e("../internals/function-call"), o = e("../internals/fails"), a = e("../internals/object-keys"), l = e("../internals/object-get-own-property-symbols"), c = e("../internals/object-property-is-enumerable"), u = e("../internals/to-object"), h = e("../internals/indexed-object"), f = Object.assign, d = Object.defineProperty, p = i([].concat);
                t.exports = !f || o(function() {
                    if (n && 1 !== f({
                        b: 1
                    }, f(d({}, "a", {
                        enumerable: !0,
                        get: function() {
                            d(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) return !0;
                    var e = {}, t = {}, r = Symbol("assign detection");
                    return e[r] = 7, "abcdefghijklmnopqrst".split("").forEach(function(e) {
                        t[e] = e;
                    }), 7 !== f({}, e)[r] || "abcdefghijklmnopqrst" !== a(f({}, t)).join("");
                }) ? function(e, t) {
                    for(var r = u(e), i = arguments.length, o = 1, f = l.f, d = c.f; i > o;)for(var m, b = h(arguments[o++]), g = f ? p(a(b), f(b)) : a(b), y = g.length, v = 0; y > v;)m = g[v++], n && !s(d, b, m) || (r[m] = b[m]);
                    return r;
                } : f;
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-object": 344
            }
        ],
        306: [
            function(e, t, r) {
                "use strict";
                var n, i = e("../internals/an-object"), s = e("../internals/object-define-properties"), o = e("../internals/enum-bug-keys"), a = e("../internals/hidden-keys"), l = e("../internals/html"), c = e("../internals/document-create-element"), u = e("../internals/shared-key"), h = u("IE_PROTO"), f = function() {}, d = function(e) {
                    return "<script>" + e + "<\/script>";
                }, p = function(e) {
                    e.write(d("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, m = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t;
                    m = "undefined" != typeof document ? document.domain && n ? p(n) : ((t = c("iframe")).style.display = "none", l.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(d("document.F=Object")), e.close(), e.F) : p(n);
                    for(var r = o.length; r--;)delete m.prototype[o[r]];
                    return m();
                };
                a[h] = !0, t.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (f.prototype = i(e), r = new f, f.prototype = null, r[h] = e) : r = m(), void 0 === t ? r : s.f(r, t);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/document-create-element": 249,
                "../internals/enum-bug-keys": 258,
                "../internals/hidden-keys": 276,
                "../internals/html": 278,
                "../internals/object-define-properties": 307,
                "../internals/shared-key": 332
            }
        ],
        307: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/v8-prototype-define-bug"), s = e("../internals/object-define-property"), o = e("../internals/an-object"), a = e("../internals/to-indexed-object"), l = e("../internals/object-keys");
                r.f = n && !i ? Object.defineProperties : function(e, t) {
                    o(e);
                    for(var r, n = a(t), i = l(t), c = i.length, u = 0; c > u;)s.f(e, r = i[u++], n[r]);
                    return e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308,
                "../internals/object-keys": 316,
                "../internals/to-indexed-object": 341,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        308: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/ie8-dom-define"), s = e("../internals/v8-prototype-define-bug"), o = e("../internals/an-object"), a = e("../internals/to-property-key"), l = TypeError, c = Object.defineProperty, u = Object.getOwnPropertyDescriptor;
                r.f = n ? s ? function(e, t, r) {
                    if (o(e), t = a(t), o(r), "function" == typeof e && "prototype" === t && "value" in r && "writable" in r && !r.writable) {
                        var n = u(e, t);
                        n && n.writable && (e[t] = r.value, r = {
                            configurable: "configurable" in r ? r.configurable : n.configurable,
                            enumerable: "enumerable" in r ? r.enumerable : n.enumerable,
                            writable: !1
                        });
                    }
                    return c(e, t, r);
                } : c : function(e, t, r) {
                    if (o(e), t = a(t), o(r), i) try {
                        return c(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new l("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/ie8-dom-define": 279,
                "../internals/to-property-key": 346,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        309: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-call"), s = e("../internals/object-property-is-enumerable"), o = e("../internals/create-property-descriptor"), a = e("../internals/to-indexed-object"), l = e("../internals/to-property-key"), c = e("../internals/has-own-property"), u = e("../internals/ie8-dom-define"), h = Object.getOwnPropertyDescriptor;
                r.f = n ? h : function(e, t) {
                    if (e = a(e), t = l(t), u) try {
                        return h(e, t);
                    } catch (e) {}
                    if (c(e, t)) return o(!i(s.f, e, t), e[t]);
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/function-call": 264,
                "../internals/has-own-property": 275,
                "../internals/ie8-dom-define": 279,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346
            }
        ],
        310: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/to-indexed-object"), s = e("../internals/object-get-own-property-names").f, o = e("../internals/array-slice-simple"), a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                t.exports.f = function(e) {
                    return a && "Window" === n(e) ? function(e) {
                        try {
                            return s(e);
                        } catch (e) {
                            return o(a);
                        }
                    }(e) : s(i(e));
                };
            },
            {
                "../internals/array-slice-simple": 230,
                "../internals/classof-raw": 235,
                "../internals/object-get-own-property-names": 311,
                "../internals/to-indexed-object": 341
            }
        ],
        311: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys").concat("length", "prototype");
                r.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        312: [
            function(e, t, r) {
                "use strict";
                r.f = Object.getOwnPropertySymbols;
            },
            {}
        ],
        313: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/is-callable"), s = e("../internals/to-object"), o = e("../internals/shared-key"), a = e("../internals/correct-prototype-getter"), l = o("IE_PROTO"), c = Object, u = c.prototype;
                t.exports = a ? c.getPrototypeOf : function(e) {
                    var t = s(e);
                    if (n(t, l)) return t[l];
                    var r = t.constructor;
                    return i(r) && t instanceof r ? r.prototype : t instanceof c ? u : null;
                };
            },
            {
                "../internals/correct-prototype-getter": 239,
                "../internals/has-own-property": 275,
                "../internals/is-callable": 285,
                "../internals/shared-key": 332,
                "../internals/to-object": 344
            }
        ],
        314: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n({}.isPrototypeOf);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        315: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/has-own-property"), s = e("../internals/to-indexed-object"), o = e("../internals/array-includes").indexOf, a = e("../internals/hidden-keys"), l = n([].push);
                t.exports = function(e, t) {
                    var r, n = s(e), c = 0, u = [];
                    for(r in n)!i(a, r) && i(n, r) && l(u, r);
                    for(; t.length > c;)i(n, r = t[c++]) && (~o(u, r) || l(u, r));
                    return u;
                };
            },
            {
                "../internals/array-includes": 228,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/to-indexed-object": 341
            }
        ],
        316: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys");
                t.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        317: [
            function(e, t, r) {
                "use strict";
                var n = {}.propertyIsEnumerable, i = Object.getOwnPropertyDescriptor, s = i && !n.call({
                    1: 2
                }, 1);
                r.f = s ? function(e) {
                    var t = i(this, e);
                    return !!t && t.enumerable;
                } : n;
            },
            {}
        ],
        318: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-accessor"), i = e("../internals/an-object"), s = e("../internals/a-possible-prototype");
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, r = {};
                    try {
                        (e = n(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
                    } catch (e) {}
                    return function(r, n) {
                        return i(r), s(n), t ? e(r, n) : r.__proto__ = n, r;
                    };
                }() : void 0);
            },
            {
                "../internals/a-possible-prototype": 224,
                "../internals/an-object": 227,
                "../internals/function-uncurry-this-accessor": 266
            }
        ],
        319: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/function-uncurry-this"), o = e("../internals/object-get-prototype-of"), a = e("../internals/object-keys"), l = e("../internals/to-indexed-object"), c = s(e("../internals/object-property-is-enumerable").f), u = s([].push), h = n && i(function() {
                    var e = Object.create(null);
                    return e[2] = 2, !c(e, 2);
                }), f = function(e) {
                    return function(t) {
                        for(var r, i = l(t), s = a(i), f = h && null === o(i), d = s.length, p = 0, m = []; d > p;)r = s[p++], n && !(f ? r in i : c(i, r)) || u(m, e ? [
                            r,
                            i[r]
                        ] : i[r]);
                        return m;
                    };
                };
                t.exports = {
                    entries: f(!0),
                    values: f(!1)
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341
            }
        ],
        320: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-callable"), s = e("../internals/is-object"), o = TypeError;
                t.exports = function(e, t) {
                    var r, a;
                    if ("string" === t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    if (i(r = e.valueOf) && !s(a = n(r, e))) return a;
                    if ("string" !== t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    throw new o("Can't convert object to primitive value");
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/is-callable": 285,
                "../internals/is-object": 289
            }
        ],
        321: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/function-uncurry-this"), s = e("../internals/object-get-own-property-names"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/an-object"), l = i([].concat);
                t.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = s.f(a(e)), r = o.f;
                    return r ? l(t, r(e)) : t;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-symbols": 312
            }
        ],
        322: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n;
            },
            {
                "../internals/global": 274
            }
        ],
        323: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return {
                            error: !1,
                            value: e()
                        };
                    } catch (e) {
                        return {
                            error: !0,
                            value: e
                        };
                    }
                };
            },
            {}
        ],
        324: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/promise-native-constructor"), s = e("../internals/is-callable"), o = e("../internals/is-forced"), a = e("../internals/inspect-source"), l = e("../internals/well-known-symbol"), c = e("../internals/engine-is-browser"), u = e("../internals/engine-is-deno"), h = e("../internals/is-pure"), f = e("../internals/engine-v8-version"), d = i && i.prototype, p = l("species"), m = !1, b = s(n.PromiseRejectionEvent), g = o("Promise", function() {
                    var e = a(i), t = e !== String(i);
                    if (!t && 66 === f) return !0;
                    if (h && (!d.catch || !d.finally)) return !0;
                    if (!f || f < 51 || !/native code/.test(e)) {
                        var r = new i(function(e) {
                            e(1);
                        }), n = function(e) {
                            e(function() {}, function() {});
                        };
                        if ((r.constructor = {})[p] = n, !(m = r.then(function() {}) instanceof n)) return !0;
                    }
                    return !t && (c || u) && !b;
                });
                t.exports = {
                    CONSTRUCTOR: g,
                    REJECTION_EVENT: b,
                    SUBCLASSING: m
                };
            },
            {
                "../internals/engine-is-browser": 250,
                "../internals/engine-is-deno": 251,
                "../internals/engine-v8-version": 257,
                "../internals/global": 274,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285,
                "../internals/is-forced": 287,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/well-known-symbol": 357
            }
        ],
        325: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n.Promise;
            },
            {
                "../internals/global": 274
            }
        ],
        326: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/is-object"), s = e("../internals/new-promise-capability");
                t.exports = function(e, t) {
                    if (n(e), i(t) && t.constructor === e) return t;
                    var r = s.f(e);
                    return (0, r.resolve)(t), r.promise;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/is-object": 289,
                "../internals/new-promise-capability": 303
            }
        ],
        327: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/promise-native-constructor"), i = e("../internals/check-correctness-of-iteration"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR;
                t.exports = s || !i(function(e) {
                    n.all(e).then(void 0, function() {});
                });
            },
            {
                "../internals/check-correctness-of-iteration": 234,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        328: [
            function(e, t, r) {
                "use strict";
                var n = function() {
                    this.head = null, this.tail = null;
                };
                n.prototype = {
                    add: function(e) {
                        var t = {
                            item: e,
                            next: null
                        }, r = this.tail;
                        r ? r.next = t : this.head = t, this.tail = t;
                    },
                    get: function() {
                        var e = this.head;
                        if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
                    }
                }, t.exports = n;
            },
            {}
        ],
        329: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-null-or-undefined"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            {
                "../internals/is-null-or-undefined": 288
            }
        ],
        330: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/define-built-in-accessor"), s = e("../internals/well-known-symbol"), o = e("../internals/descriptors"), a = s("species");
                t.exports = function(e) {
                    var t = n(e);
                    o && t && !t[a] && i(t, a, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            {
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        331: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-define-property").f, i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol")("toStringTag");
                t.exports = function(e, t, r) {
                    e && !r && (e = e.prototype), e && !i(e, s) && n(e, s, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        332: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/shared"), i = e("../internals/uid"), s = n("keys");
                t.exports = function(e) {
                    return s[e] || (s[e] = i(e));
                };
            },
            {
                "../internals/shared": 334,
                "../internals/uid": 350
            }
        ],
        333: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/define-global-property"), s = n["__core-js_shared__"] || i("__core-js_shared__", {});
                t.exports = s;
            },
            {
                "../internals/define-global-property": 246,
                "../internals/global": 274
            }
        ],
        334: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-pure"), i = e("../internals/shared-store");
                (t.exports = function(e, t) {
                    return i[e] || (i[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.33.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            {
                "../internals/is-pure": 290,
                "../internals/shared-store": 333
            }
        ],
        335: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/a-constructor"), s = e("../internals/is-null-or-undefined"), o = e("../internals/well-known-symbol")("species");
                t.exports = function(e, t) {
                    var r, a = n(e).constructor;
                    return void 0 === a || s(r = n(a)[o]) ? t : i(r);
                };
            },
            {
                "../internals/a-constructor": 223,
                "../internals/an-object": 227,
                "../internals/is-null-or-undefined": 288,
                "../internals/well-known-symbol": 357
            }
        ],
        336: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-v8-version"), i = e("../internals/fails"), s = e("../internals/global").String;
                t.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !s(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            {
                "../internals/engine-v8-version": 257,
                "../internals/fails": 260,
                "../internals/global": 274
            }
        ],
        337: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/get-built-in"), s = e("../internals/well-known-symbol"), o = e("../internals/define-built-in");
                t.exports = function() {
                    var e = i("Symbol"), t = e && e.prototype, r = t && t.valueOf, a = s("toPrimitive");
                    t && !t[a] && o(t, a, function(e) {
                        return n(r, this);
                    }, {
                        arity: 1
                    });
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/function-call": 264,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        338: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !!Symbol.for && !!Symbol.keyFor;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        339: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a = e("../internals/global"), l = e("../internals/function-apply"), c = e("../internals/function-bind-context"), u = e("../internals/is-callable"), h = e("../internals/has-own-property"), f = e("../internals/fails"), d = e("../internals/html"), p = e("../internals/array-slice"), m = e("../internals/document-create-element"), b = e("../internals/validate-arguments-length"), g = e("../internals/engine-is-ios"), y = e("../internals/engine-is-node"), v = a.setImmediate, w = a.clearImmediate, _ = a.process, x = a.Dispatch, k = a.Function, S = a.MessageChannel, M = a.String, C = 0, T = {};
                f(function() {
                    n = a.location;
                });
                var E = function(e) {
                    if (h(T, e)) {
                        var t = T[e];
                        delete T[e], t();
                    }
                }, A = function(e) {
                    return function() {
                        E(e);
                    };
                }, R = function(e) {
                    E(e.data);
                }, O = function(e) {
                    a.postMessage(M(e), n.protocol + "//" + n.host);
                };
                v && w || (v = function(e) {
                    b(arguments.length, 1);
                    var t = u(e) ? e : k(e), r = p(arguments, 1);
                    return T[++C] = function() {
                        l(t, void 0, r);
                    }, i(C), C;
                }, w = function(e) {
                    delete T[e];
                }, y ? i = function(e) {
                    _.nextTick(A(e));
                } : x && x.now ? i = function(e) {
                    x.now(A(e));
                } : S && !g ? (o = (s = new S).port2, s.port1.onmessage = R, i = c(o.postMessage, o)) : a.addEventListener && u(a.postMessage) && !a.importScripts && n && "file:" !== n.protocol && !f(O) ? (i = O, a.addEventListener("message", R, !1)) : i = "onreadystatechange" in m("script") ? function(e) {
                    d.appendChild(m("script")).onreadystatechange = function() {
                        d.removeChild(this), E(e);
                    };
                } : function(e) {
                    setTimeout(A(e), 0);
                }), t.exports = {
                    set: v,
                    clear: w
                };
            },
            {
                "../internals/array-slice": 231,
                "../internals/document-create-element": 249,
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-node": 254,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/html": 278,
                "../internals/is-callable": 285,
                "../internals/validate-arguments-length": 353
            }
        ],
        340: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.max, s = Math.min;
                t.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : s(r, t);
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        341: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/indexed-object"), i = e("../internals/require-object-coercible");
                t.exports = function(e) {
                    return n(i(e));
                };
            },
            {
                "../internals/indexed-object": 280,
                "../internals/require-object-coercible": 329
            }
        ],
        342: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/math-trunc");
                t.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            {
                "../internals/math-trunc": 301
            }
        ],
        343: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.min;
                t.exports = function(e) {
                    return e > 0 ? i(n(e), 9007199254740991) : 0;
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        344: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/require-object-coercible"), i = Object;
                t.exports = function(e) {
                    return i(n(e));
                };
            },
            {
                "../internals/require-object-coercible": 329
            }
        ],
        345: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-object"), s = e("../internals/is-symbol"), o = e("../internals/get-method"), a = e("../internals/ordinary-to-primitive"), l = e("../internals/well-known-symbol"), c = TypeError, u = l("toPrimitive");
                t.exports = function(e, t) {
                    if (!i(e) || s(e)) return e;
                    var r, l = o(e, u);
                    if (l) {
                        if (void 0 === t && (t = "default"), r = n(l, e, t), !i(r) || s(r)) return r;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), a(e, t);
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/get-method": 273,
                "../internals/is-object": 289,
                "../internals/is-symbol": 292,
                "../internals/ordinary-to-primitive": 320,
                "../internals/well-known-symbol": 357
            }
        ],
        346: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-primitive"), i = e("../internals/is-symbol");
                t.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            {
                "../internals/is-symbol": 292,
                "../internals/to-primitive": 345
            }
        ],
        347: [
            function(e, t, r) {
                "use strict";
                var n = {};
                n[e("../internals/well-known-symbol")("toStringTag")] = "z", t.exports = "[object z]" === String(n);
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        348: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = String;
                t.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            {
                "../internals/classof": 236
            }
        ],
        349: [
            function(e, t, r) {
                "use strict";
                var n = String;
                t.exports = function(e) {
                    try {
                        return n(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            {}
        ],
        350: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = 0, s = Math.random(), o = n(1..toString);
                t.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + o(++i + s, 36);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        351: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        352: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails");
                t.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260
            }
        ],
        353: [
            function(e, t, r) {
                "use strict";
                var n = TypeError;
                t.exports = function(e, t) {
                    if (e < t) throw new n("Not enough arguments");
                    return e;
                };
            },
            {}
        ],
        354: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = n.WeakMap;
                t.exports = i(s) && /native code/.test(String(s));
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        355: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/path"), i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol-wrapped"), o = e("../internals/object-define-property").f;
                t.exports = function(e) {
                    var t = n.Symbol || (n.Symbol = {});
                    i(t, e) || o(t, e, {
                        value: s.f(e)
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/path": 322,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        356: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol");
                r.f = n;
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        357: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/shared"), s = e("../internals/has-own-property"), o = e("../internals/uid"), a = e("../internals/symbol-constructor-detection"), l = e("../internals/use-symbol-as-uid"), c = n.Symbol, u = i("wks"), h = l ? c.for || c : c && c.withoutSetter || o;
                t.exports = function(e) {
                    return s(u, e) || (u[e] = a && s(c, e) ? c[e] : h("Symbol." + e)), u[e];
                };
            },
            {
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-constructor-detection": 336,
                "../internals/uid": 350,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        358: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").findIndex, s = e("../internals/add-to-unscopables"), o = !0;
                "findIndex" in [] && Array(1).findIndex(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    findIndex: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("findIndex");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        359: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").find, s = e("../internals/add-to-unscopables"), o = !0;
                "find" in [] && Array(1).find(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    find: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("find");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        360: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-includes").includes, s = e("../internals/fails"), o = e("../internals/add-to-unscopables");
                n({
                    target: "Array",
                    proto: !0,
                    forced: s(function() {
                        return !Array(1).includes();
                    })
                }, {
                    includes: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), o("includes");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-includes": 228,
                "../internals/export": 259,
                "../internals/fails": 260
            }
        ],
        361: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/add-to-unscopables"), s = e("../internals/iterators"), o = e("../internals/internal-state"), a = e("../internals/object-define-property").f, l = e("../internals/iterator-define"), c = e("../internals/create-iter-result-object"), u = e("../internals/is-pure"), h = e("../internals/descriptors"), f = o.set, d = o.getterFor("Array Iterator");
                t.exports = l(Array, "Array", function(e, t) {
                    f(this, {
                        type: "Array Iterator",
                        target: n(e),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e = d(this), t = e.target, r = e.kind, n = e.index++;
                    if (!t || n >= t.length) return e.target = void 0, c(void 0, !0);
                    switch(r){
                        case "keys":
                            return c(n, !1);
                        case "values":
                            return c(t[n], !1);
                    }
                    return c([
                        n,
                        t[n]
                    ], !1);
                }, "values");
                var p = s.Arguments = s.Array;
                if (i("keys"), i("values"), i("entries"), !u && h && "values" !== p.name) try {
                    a(p, "name", {
                        value: "values"
                    });
                } catch (e) {}
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/create-iter-result-object": 240,
                "../internals/descriptors": 247,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/iterator-define": 296,
                "../internals/iterators": 298,
                "../internals/object-define-property": 308,
                "../internals/to-indexed-object": 341
            }
        ],
        362: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/function-apply"), o = e("../internals/function-call"), a = e("../internals/function-uncurry-this"), l = e("../internals/fails"), c = e("../internals/is-callable"), u = e("../internals/is-symbol"), h = e("../internals/array-slice"), f = e("../internals/get-json-replacer-function"), d = e("../internals/symbol-constructor-detection"), p = String, m = i("JSON", "stringify"), b = a(/./.exec), g = a("".charAt), y = a("".charCodeAt), v = a("".replace), w = a(1..toString), _ = /[\uD800-\uDFFF]/g, x = /^[\uD800-\uDBFF]$/, k = /^[\uDC00-\uDFFF]$/, S = !d || l(function() {
                    var e = i("Symbol")("stringify detection");
                    return "[null]" !== m([
                        e
                    ]) || "{}" !== m({
                        a: e
                    }) || "{}" !== m(Object(e));
                }), M = l(function() {
                    return '"\\udf06\\ud834"' !== m("\udf06\ud834") || '"\\udead"' !== m("\udead");
                }), C = function(e, t) {
                    var r = h(arguments), n = f(t);
                    if (c(n) || void 0 !== e && !u(e)) return r[1] = function(e, t) {
                        if (c(n) && (t = o(n, this, p(e), t)), !u(t)) return t;
                    }, s(m, null, r);
                }, T = function(e, t, r) {
                    var n = g(r, t - 1), i = g(r, t + 1);
                    return b(x, e) && !b(k, i) || b(k, e) && !b(x, n) ? "\\u" + w(y(e, 0), 16) : e;
                };
                m && n({
                    target: "JSON",
                    stat: !0,
                    arity: 3,
                    forced: S || M
                }, {
                    stringify: function(e, t, r) {
                        var n = h(arguments), i = s(S ? C : m, null, n);
                        return M && "string" == typeof i ? v(i, _, T) : i;
                    }
                });
            },
            {
                "../internals/array-slice": 231,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/get-json-replacer-function": 272,
                "../internals/is-callable": 285,
                "../internals/is-symbol": 292,
                "../internals/symbol-constructor-detection": 336
            }
        ],
        363: [
            function(e, t, r) {
                "use strict";
                e("../internals/export")({
                    target: "Number",
                    stat: !0
                }, {
                    isNaN: function(e) {
                        return e != e;
                    }
                });
            },
            {
                "../internals/export": 259
            }
        ],
        364: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-assign");
                n({
                    target: "Object",
                    stat: !0,
                    arity: 2,
                    forced: Object.assign !== i
                }, {
                    assign: i
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-assign": 305
            }
        ],
        365: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/symbol-constructor-detection"), s = e("../internals/fails"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/to-object");
                n({
                    target: "Object",
                    stat: !0,
                    forced: !i || s(function() {
                        o.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e) {
                        var t = o.f;
                        return t ? t(a(e)) : [];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/symbol-constructor-detection": 336,
                "../internals/to-object": 344
            }
        ],
        366: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/to-object"), s = e("../internals/object-keys");
                n({
                    target: "Object",
                    stat: !0,
                    forced: e("../internals/fails")(function() {
                        s(1);
                    })
                }, {
                    keys: function(e) {
                        return s(i(e));
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-keys": 316,
                "../internals/to-object": 344
            }
        ],
        367: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-to-array").values;
                n({
                    target: "Object",
                    stat: !0
                }, {
                    values: function(e) {
                        return i(e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-to-array": 319
            }
        ],
        368: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    all: function(e) {
                        var t = this, r = o.f(t), n = r.resolve, c = r.reject, u = a(function() {
                            var r = s(t.resolve), o = [], a = 0, u = 1;
                            l(e, function(e) {
                                var s = a++, l = !1;
                                u++, i(r, t, e).then(function(e) {
                                    l || (l = !0, o[s] = e, --u || n(o));
                                }, c);
                            }), --u || n(o);
                        });
                        return u.error && c(u.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        369: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR, o = e("../internals/promise-native-constructor"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/define-built-in"), u = o && o.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    forced: s,
                    real: !0
                }, {
                    catch: function(e) {
                        return this.then(void 0, e);
                    }
                }), !i && l(o)) {
                    var h = a("Promise").prototype.catch;
                    u.catch !== h && c(u, "catch", h, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        370: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/export"), a = e("../internals/is-pure"), l = e("../internals/engine-is-node"), c = e("../internals/global"), u = e("../internals/function-call"), h = e("../internals/define-built-in"), f = e("../internals/object-set-prototype-of"), d = e("../internals/set-to-string-tag"), p = e("../internals/set-species"), m = e("../internals/a-callable"), b = e("../internals/is-callable"), g = e("../internals/is-object"), y = e("../internals/an-instance"), v = e("../internals/species-constructor"), w = e("../internals/task").set, _ = e("../internals/microtask"), x = e("../internals/host-report-errors"), k = e("../internals/perform"), S = e("../internals/queue"), M = e("../internals/internal-state"), C = e("../internals/promise-native-constructor"), T = e("../internals/promise-constructor-detection"), E = e("../internals/new-promise-capability"), A = T.CONSTRUCTOR, R = T.REJECTION_EVENT, O = T.SUBCLASSING, j = M.getterFor("Promise"), I = M.set, N = C && C.prototype, P = C, B = N, D = c.TypeError, F = c.document, L = c.process, z = E.f, U = z, $ = !!(F && F.createEvent && c.dispatchEvent), H = function(e) {
                    var t;
                    return !(!g(e) || !b(t = e.then)) && t;
                }, V = function(e, t) {
                    var r, n, i, s = t.value, o = 1 === t.state, a = o ? e.ok : e.fail, l = e.resolve, c = e.reject, h = e.domain;
                    try {
                        a ? (o || (2 === t.rejection && Y(t), t.rejection = 1), !0 === a ? r = s : (h && h.enter(), r = a(s), h && (h.exit(), i = !0)), r === e.promise ? c(new D("Promise-chain cycle")) : (n = H(r)) ? u(n, r, l, c) : l(r)) : c(s);
                    } catch (e) {
                        h && !i && h.exit(), c(e);
                    }
                }, q = function(e, t) {
                    e.notified || (e.notified = !0, _(function() {
                        for(var r, n = e.reactions; r = n.get();)V(r, e);
                        e.notified = !1, t && !e.rejection && X(e);
                    }));
                }, W = function(e, t, r) {
                    var n, i;
                    $ ? ((n = F.createEvent("Event")).promise = t, n.reason = r, n.initEvent(e, !1, !0), c.dispatchEvent(n)) : n = {
                        promise: t,
                        reason: r
                    }, !R && (i = c["on" + e]) ? i(n) : "unhandledrejection" === e && x("Unhandled promise rejection", r);
                }, X = function(e) {
                    u(w, c, function() {
                        var t, r = e.facade, n = e.value;
                        if (K(e) && (t = k(function() {
                            l ? L.emit("unhandledRejection", n, r) : W("unhandledrejection", r, n);
                        }), e.rejection = l || K(e) ? 2 : 1, t.error)) throw t.value;
                    });
                }, K = function(e) {
                    return 1 !== e.rejection && !e.parent;
                }, Y = function(e) {
                    u(w, c, function() {
                        var t = e.facade;
                        l ? L.emit("rejectionHandled", t) : W("rejectionhandled", t, e.value);
                    });
                }, Z = function(e, t, r) {
                    return function(n) {
                        e(t, n, r);
                    };
                }, G = function(e, t, r) {
                    e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, q(e, !0));
                }, J = function(e, t, r) {
                    if (!e.done) {
                        e.done = !0, r && (e = r);
                        try {
                            if (e.facade === t) throw new D("Promise can't be resolved itself");
                            var n = H(t);
                            n ? _(function() {
                                var r = {
                                    done: !1
                                };
                                try {
                                    u(n, t, Z(J, r, e), Z(G, r, e));
                                } catch (t) {
                                    G(r, t, e);
                                }
                            }) : (e.value = t, e.state = 1, q(e, !1));
                        } catch (t) {
                            G({
                                done: !1
                            }, t, e);
                        }
                    }
                };
                if (A && (B = (P = function(e) {
                    y(this, B), m(e), u(n, this);
                    var t = j(this);
                    try {
                        e(Z(J, t), Z(G, t));
                    } catch (e) {
                        G(t, e);
                    }
                }).prototype, (n = function(e) {
                    I(this, {
                        type: "Promise",
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: new S,
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = h(B, "then", function(e, t) {
                    var r = j(this), n = z(v(this, P));
                    return r.parent = !0, n.ok = !b(e) || e, n.fail = b(t) && t, n.domain = l ? L.domain : void 0, 0 === r.state ? r.reactions.add(n) : _(function() {
                        V(n, r);
                    }), n.promise;
                }), i = function() {
                    var e = new n, t = j(e);
                    this.promise = e, this.resolve = Z(J, t), this.reject = Z(G, t);
                }, E.f = z = function(e) {
                    return e === P || void 0 === e ? new i(e) : U(e);
                }, !a && b(C) && N !== Object.prototype)) {
                    s = N.then, O || h(N, "then", function(e, t) {
                        var r = this;
                        return new P(function(e, t) {
                            u(s, r, e, t);
                        }).then(e, t);
                    }, {
                        unsafe: !0
                    });
                    try {
                        delete N.constructor;
                    } catch (e) {}
                    f && f(N, B);
                }
                o({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: A
                }, {
                    Promise: P
                }), d(P, "Promise", !1, !0), p("Promise");
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-instance": 226,
                "../internals/define-built-in": 245,
                "../internals/engine-is-node": 254,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/global": 274,
                "../internals/host-report-errors": 277,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/microtask": 302,
                "../internals/new-promise-capability": 303,
                "../internals/object-set-prototype-of": 318,
                "../internals/perform": 323,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/queue": 328,
                "../internals/set-species": 330,
                "../internals/set-to-string-tag": 331,
                "../internals/species-constructor": 335,
                "../internals/task": 339
            }
        ],
        371: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-native-constructor"), o = e("../internals/fails"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/species-constructor"), u = e("../internals/promise-resolve"), h = e("../internals/define-built-in"), f = s && s.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    real: !0,
                    forced: !!s && o(function() {
                        f.finally.call({
                            then: function() {}
                        }, function() {});
                    })
                }, {
                    finally: function(e) {
                        var t = c(this, a("Promise")), r = l(e);
                        return this.then(r ? function(r) {
                            return u(t, e()).then(function() {
                                return r;
                            });
                        } : e, r ? function(r) {
                            return u(t, e()).then(function() {
                                throw r;
                            });
                        } : e);
                    }
                }), !i && l(s)) {
                    var d = a("Promise").prototype.finally;
                    f.finally !== d && h(f, "finally", d, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326,
                "../internals/species-constructor": 335
            }
        ],
        372: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.promise.constructor"), e("../modules/es.promise.all"), e("../modules/es.promise.catch"), e("../modules/es.promise.race"), e("../modules/es.promise.reject"), e("../modules/es.promise.resolve");
            },
            {
                "../modules/es.promise.all": 368,
                "../modules/es.promise.catch": 369,
                "../modules/es.promise.constructor": 370,
                "../modules/es.promise.race": 373,
                "../modules/es.promise.reject": 374,
                "../modules/es.promise.resolve": 375
            }
        ],
        373: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    race: function(e) {
                        var t = this, r = o.f(t), n = r.reject, c = a(function() {
                            var o = s(t.resolve);
                            l(e, function(e) {
                                i(o, t, e).then(r.resolve, n);
                            });
                        });
                        return c.error && n(c.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        374: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/new-promise-capability");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-constructor-detection").CONSTRUCTOR
                }, {
                    reject: function(e) {
                        var t = s.f(this);
                        return i(t.reject, void 0, e), t.promise;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/new-promise-capability": 303,
                "../internals/promise-constructor-detection": 324
            }
        ],
        375: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/is-pure"), o = e("../internals/promise-native-constructor"), a = e("../internals/promise-constructor-detection").CONSTRUCTOR, l = e("../internals/promise-resolve"), c = i("Promise"), u = s && !a;
                n({
                    target: "Promise",
                    stat: !0,
                    forced: s || a
                }, {
                    resolve: function(e) {
                        return l(u && this === c ? o : this, e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326
            }
        ],
        376: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/to-absolute-index"), o = RangeError, a = String.fromCharCode, l = String.fromCodePoint, c = i([].join);
                n({
                    target: "String",
                    stat: !0,
                    arity: 1,
                    forced: !!l && 1 !== l.length
                }, {
                    fromCodePoint: function(e) {
                        for(var t, r = [], n = arguments.length, i = 0; n > i;){
                            if (t = +arguments[i++], s(t, 1114111) !== t) throw new o(t + " is not a valid code point");
                            r[i] = t < 65536 ? a(t) : a(55296 + ((t -= 65536) >> 10), t % 1024 + 56320);
                        }
                        return c(r, "");
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/to-absolute-index": 340
            }
        ],
        377: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/not-a-regexp"), o = e("../internals/require-object-coercible"), a = e("../internals/to-string"), l = e("../internals/correct-is-regexp-logic"), c = i("".indexOf);
                n({
                    target: "String",
                    proto: !0,
                    forced: !l("includes")
                }, {
                    includes: function(e) {
                        return !!~c(a(o(this)), a(s(e)), arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 238,
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/not-a-regexp": 304,
                "../internals/require-object-coercible": 329,
                "../internals/to-string": 348
            }
        ],
        378: [
            function(e, t, r) {
                "use strict";
                e("../internals/well-known-symbol-define")("asyncIterator");
            },
            {
                "../internals/well-known-symbol-define": 355
            }
        ],
        379: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/global"), s = e("../internals/function-call"), o = e("../internals/function-uncurry-this"), a = e("../internals/is-pure"), l = e("../internals/descriptors"), c = e("../internals/symbol-constructor-detection"), u = e("../internals/fails"), h = e("../internals/has-own-property"), f = e("../internals/object-is-prototype-of"), d = e("../internals/an-object"), p = e("../internals/to-indexed-object"), m = e("../internals/to-property-key"), b = e("../internals/to-string"), g = e("../internals/create-property-descriptor"), y = e("../internals/object-create"), v = e("../internals/object-keys"), w = e("../internals/object-get-own-property-names"), _ = e("../internals/object-get-own-property-names-external"), x = e("../internals/object-get-own-property-symbols"), k = e("../internals/object-get-own-property-descriptor"), S = e("../internals/object-define-property"), M = e("../internals/object-define-properties"), C = e("../internals/object-property-is-enumerable"), T = e("../internals/define-built-in"), E = e("../internals/define-built-in-accessor"), A = e("../internals/shared"), R = e("../internals/shared-key"), O = e("../internals/hidden-keys"), j = e("../internals/uid"), I = e("../internals/well-known-symbol"), N = e("../internals/well-known-symbol-wrapped"), P = e("../internals/well-known-symbol-define"), B = e("../internals/symbol-define-to-primitive"), D = e("../internals/set-to-string-tag"), F = e("../internals/internal-state"), L = e("../internals/array-iteration").forEach, z = R("hidden"), U = F.set, $ = F.getterFor("Symbol"), H = Object.prototype, V = i.Symbol, q = V && V.prototype, W = i.RangeError, X = i.TypeError, K = i.QObject, Y = k.f, Z = S.f, G = _.f, J = C.f, Q = o([].push), ee = A("symbols"), te = A("op-symbols"), re = A("wks"), ne = !K || !K.prototype || !K.prototype.findChild, ie = function(e, t, r) {
                    var n = Y(H, t);
                    n && delete H[t], Z(e, t, r), n && e !== H && Z(H, t, n);
                }, se = l && u(function() {
                    return 7 !== y(Z({}, "a", {
                        get: function() {
                            return Z(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? ie : Z, oe = function(e, t) {
                    var r = ee[e] = y(q);
                    return U(r, {
                        type: "Symbol",
                        tag: e,
                        description: t
                    }), l || (r.description = t), r;
                }, ae = function(e, t, r) {
                    e === H && ae(te, t, r), d(e);
                    var n = m(t);
                    return d(r), h(ee, n) ? (r.enumerable ? (h(e, z) && e[z][n] && (e[z][n] = !1), r = y(r, {
                        enumerable: g(0, !1)
                    })) : (h(e, z) || Z(e, z, g(1, {})), e[z][n] = !0), se(e, n, r)) : Z(e, n, r);
                }, le = function(e, t) {
                    d(e);
                    var r = p(t), n = v(r).concat(fe(r));
                    return L(n, function(t) {
                        l && !s(ce, r, t) || ae(e, t, r[t]);
                    }), e;
                }, ce = function(e) {
                    var t = m(e), r = s(J, this, t);
                    return !(this === H && h(ee, t) && !h(te, t)) && (!(r || !h(this, t) || !h(ee, t) || h(this, z) && this[z][t]) || r);
                }, ue = function(e, t) {
                    var r = p(e), n = m(t);
                    if (r !== H || !h(ee, n) || h(te, n)) {
                        var i = Y(r, n);
                        return !i || !h(ee, n) || h(r, z) && r[z][n] || (i.enumerable = !0), i;
                    }
                }, he = function(e) {
                    var t = G(p(e)), r = [];
                    return L(t, function(e) {
                        h(ee, e) || h(O, e) || Q(r, e);
                    }), r;
                }, fe = function(e) {
                    var t = e === H, r = G(t ? te : p(e)), n = [];
                    return L(r, function(e) {
                        !h(ee, e) || t && !h(H, e) || Q(n, ee[e]);
                    }), n;
                };
                c || (T(q = (V = function() {
                    if (f(q, this)) throw new X("Symbol is not a constructor");
                    var e = arguments.length && void 0 !== arguments[0] ? b(arguments[0]) : void 0, t = j(e), r = function(e) {
                        this === H && s(r, te, e), h(this, z) && h(this[z], t) && (this[z][t] = !1);
                        var n = g(1, e);
                        try {
                            se(this, t, n);
                        } catch (e) {
                            if (!(e instanceof W)) throw e;
                            ie(this, t, n);
                        }
                    };
                    return l && ne && se(H, t, {
                        configurable: !0,
                        set: r
                    }), oe(t, e);
                }).prototype, "toString", function() {
                    return $(this).tag;
                }), T(V, "withoutSetter", function(e) {
                    return oe(j(e), e);
                }), C.f = ce, S.f = ae, M.f = le, k.f = ue, w.f = _.f = he, x.f = fe, N.f = function(e) {
                    return oe(I(e), e);
                }, l && (E(q, "description", {
                    configurable: !0,
                    get: function() {
                        return $(this).description;
                    }
                }), a || T(H, "propertyIsEnumerable", ce, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: !c,
                    sham: !c
                }, {
                    Symbol: V
                }), L(v(re), function(e) {
                    P(e);
                }), n({
                    target: "Symbol",
                    stat: !0,
                    forced: !c
                }, {
                    useSetter: function() {
                        ne = !0;
                    },
                    useSimple: function() {
                        ne = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c,
                    sham: !l
                }, {
                    create: function(e, t) {
                        return void 0 === t ? y(e) : le(y(e), t);
                    },
                    defineProperty: ae,
                    defineProperties: le,
                    getOwnPropertyDescriptor: ue
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c
                }, {
                    getOwnPropertyNames: he
                }), B(), D(V, "Symbol"), O[z] = !0;
            },
            {
                "../internals/an-object": 227,
                "../internals/array-iteration": 229,
                "../internals/create-property-descriptor": 242,
                "../internals/define-built-in": 245,
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-define-properties": 307,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-names-external": 310,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-is-prototype-of": 314,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/set-to-string-tag": 331,
                "../internals/shared": 334,
                "../internals/shared-key": 332,
                "../internals/symbol-constructor-detection": 336,
                "../internals/symbol-define-to-primitive": 337,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346,
                "../internals/to-string": 348,
                "../internals/uid": 350,
                "../internals/well-known-symbol": 357,
                "../internals/well-known-symbol-define": 355,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        380: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/has-own-property"), o = e("../internals/to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("string-to-symbol-registry"), u = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    for: function(e) {
                        var t = o(e);
                        if (s(c, t)) return c[t];
                        var r = i("Symbol")(t);
                        return c[t] = r, u[r] = t, r;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/to-string": 348
            }
        ],
        381: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.symbol.constructor"), e("../modules/es.symbol.for"), e("../modules/es.symbol.key-for"), e("../modules/es.json.stringify"), e("../modules/es.object.get-own-property-symbols");
            },
            {
                "../modules/es.json.stringify": 362,
                "../modules/es.object.get-own-property-symbols": 365,
                "../modules/es.symbol.constructor": 379,
                "../modules/es.symbol.for": 380,
                "../modules/es.symbol.key-for": 382
            }
        ],
        382: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/has-own-property"), s = e("../internals/is-symbol"), o = e("../internals/try-to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    keyFor: function(e) {
                        if (!s(e)) throw new TypeError(o(e) + " is not a symbol");
                        if (i(c, e)) return c[e];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/has-own-property": 275,
                "../internals/is-symbol": 292,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/try-to-string": 349
            }
        ],
        383: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return Object.prototype.toString.call(e);
                }
                r.isArray = function(e) {
                    return Array.isArray ? Array.isArray(e) : "[object Array]" === n(e);
                }, r.isBoolean = function(e) {
                    return "boolean" == typeof e;
                }, r.isNull = function(e) {
                    return null === e;
                }, r.isNullOrUndefined = function(e) {
                    return null == e;
                }, r.isNumber = function(e) {
                    return "number" == typeof e;
                }, r.isString = function(e) {
                    return "string" == typeof e;
                }, r.isSymbol = function(e) {
                    return "symbol" == typeof e;
                }, r.isUndefined = function(e) {
                    return void 0 === e;
                }, r.isRegExp = function(e) {
                    return "[object RegExp]" === n(e);
                }, r.isObject = function(e) {
                    return "object" == typeof e && null !== e;
                }, r.isDate = function(e) {
                    return "[object Date]" === n(e);
                }, r.isError = function(e) {
                    return "[object Error]" === n(e) || e instanceof Error;
                }, r.isFunction = function(e) {
                    return "function" == typeof e;
                }, r.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                }, r.isBuffer = e("buffer").Buffer.isBuffer;
            },
            {
                buffer: 220
            }
        ],
        384: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("elliptic"), i = e("bn.js");
                        t.exports = function(e) {
                            return new o(e);
                        };
                        var s = {
                            secp256k1: {
                                name: "secp256k1",
                                byteLength: 32
                            },
                            secp224r1: {
                                name: "p224",
                                byteLength: 28
                            },
                            prime256v1: {
                                name: "p256",
                                byteLength: 32
                            },
                            prime192v1: {
                                name: "p192",
                                byteLength: 24
                            },
                            ed25519: {
                                name: "ed25519",
                                byteLength: 32
                            },
                            secp384r1: {
                                name: "p384",
                                byteLength: 48
                            },
                            secp521r1: {
                                name: "p521",
                                byteLength: 66
                            }
                        };
                        function o(e) {
                            this.curveType = s[e], this.curveType || (this.curveType = {
                                name: e
                            }), this.curve = new n.ec(this.curveType.name), this.keys = void 0;
                        }
                        function a(e, t, n) {
                            Array.isArray(e) || (e = e.toArray());
                            var i = new r(e);
                            if (n && i.length < n) {
                                var s = new r(n - i.length);
                                s.fill(0), i = r.concat([
                                    s,
                                    i
                                ]);
                            }
                            return t ? i.toString(t) : i;
                        }
                        s.p224 = s.secp224r1, s.p256 = s.secp256r1 = s.prime256v1, s.p192 = s.secp192r1 = s.prime192v1, s.p384 = s.secp384r1, s.p521 = s.secp521r1, o.prototype.generateKeys = function(e, t) {
                            return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
                        }, o.prototype.computeSecret = function(e, t, n) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), a(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), n, this.curveType.byteLength);
                        }, o.prototype.getPublicKey = function(e, t) {
                            var r = this.keys.getPublic("compressed" === t, !0);
                            return "hybrid" === t && (r[r.length - 1] % 2 ? r[0] = 7 : r[0] = 6), a(r, e);
                        }, o.prototype.getPrivateKey = function(e) {
                            return a(this.keys.getPrivate(), e);
                        }, o.prototype.setPublicKey = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.keys._importPublic(e), this;
                        }, o.prototype.setPrivateKey = function(e, t) {
                            t = t || "utf8", r.isBuffer(e) || (e = new r(e, t));
                            var n = new i(e);
                            return n = n.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(n), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 385,
                buffer: 220,
                elliptic: 405
            }
        ],
        385: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        386: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("md5.js"), s = e("ripemd160"), o = e("sha.js"), a = e("cipher-base");
                function l(e) {
                    a.call(this, "digest"), this._hash = e;
                }
                n(l, a), l.prototype._update = function(e) {
                    this._hash.update(e);
                }, l.prototype._final = function() {
                    return this._hash.digest();
                }, t.exports = function(e) {
                    return "md5" === (e = e.toLowerCase()) ? new i : "rmd160" === e || "ripemd160" === e ? new s : new l(o(e));
                };
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "md5.js": 450,
                ripemd160: 493,
                "sha.js": 498
            }
        ],
        387: [
            function(e, t, r) {
                "use strict";
                var n = e("md5.js");
                t.exports = function(e) {
                    return (new n).update(e).digest();
                };
            },
            {
                "md5.js": 450
            }
        ],
        388: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./legacy"), s = e("cipher-base"), o = e("safe-buffer").Buffer, a = e("create-hash/md5"), l = e("ripemd160"), c = e("sha.js"), u = o.alloc(128);
                function h(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = o.from(t));
                    var r = "sha512" === e || "sha384" === e ? 128 : 64;
                    (this._alg = e, this._key = t, t.length > r) ? t = ("rmd160" === e ? new l : c(e)).update(t).digest() : t.length < r && (t = o.concat([
                        t,
                        u
                    ], r));
                    for(var n = this._ipad = o.allocUnsafe(r), i = this._opad = o.allocUnsafe(r), a = 0; a < r; a++)n[a] = 54 ^ t[a], i[a] = 92 ^ t[a];
                    this._hash = "rmd160" === e ? new l : c(e), this._hash.update(n);
                }
                n(h, s), h.prototype._update = function(e) {
                    this._hash.update(e);
                }, h.prototype._final = function() {
                    var e = this._hash.digest();
                    return ("rmd160" === this._alg ? new l : c(this._alg)).update(this._opad).update(e).digest();
                }, t.exports = function(e, t) {
                    return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new h("rmd160", t) : "md5" === e ? new i(a, t) : new h(e, t);
                };
            },
            {
                "./legacy": 389,
                "cipher-base": 221,
                "create-hash/md5": 387,
                inherits: 440,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        389: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = i.alloc(128);
                function a(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = i.from(t)), this._alg = e, this._key = t, t.length > 64 ? t = e(t) : t.length < 64 && (t = i.concat([
                        t,
                        o
                    ], 64));
                    for(var r = this._ipad = i.allocUnsafe(64), n = this._opad = i.allocUnsafe(64), a = 0; a < 64; a++)r[a] = 54 ^ t[a], n[a] = 92 ^ t[a];
                    this._hash = [
                        r
                    ];
                }
                n(a, s), a.prototype._update = function(e) {
                    this._hash.push(e);
                }, a.prototype._final = function() {
                    var e = this._alg(i.concat(this._hash));
                    return this._alg(i.concat([
                        this._opad,
                        e
                    ]));
                }, t.exports = a;
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        390: [
            function(e, t, r) {
                "use strict";
                r.randomBytes = r.rng = r.pseudoRandomBytes = r.prng = e("randombytes"), r.createHash = r.Hash = e("create-hash"), r.createHmac = r.Hmac = e("create-hmac");
                var n = e("browserify-sign/algos"), i = Object.keys(n), s = [
                    "sha1",
                    "sha224",
                    "sha256",
                    "sha384",
                    "sha512",
                    "md5",
                    "rmd160"
                ].concat(i);
                r.getHashes = function() {
                    return s;
                };
                var o = e("pbkdf2");
                r.pbkdf2 = o.pbkdf2, r.pbkdf2Sync = o.pbkdf2Sync;
                var a = e("browserify-cipher");
                r.Cipher = a.Cipher, r.createCipher = a.createCipher, r.Cipheriv = a.Cipheriv, r.createCipheriv = a.createCipheriv, r.Decipher = a.Decipher, r.createDecipher = a.createDecipher, r.Decipheriv = a.Decipheriv, r.createDecipheriv = a.createDecipheriv, r.getCiphers = a.getCiphers, r.listCiphers = a.listCiphers;
                var l = e("diffie-hellman");
                r.DiffieHellmanGroup = l.DiffieHellmanGroup, r.createDiffieHellmanGroup = l.createDiffieHellmanGroup, r.getDiffieHellman = l.getDiffieHellman, r.createDiffieHellman = l.createDiffieHellman, r.DiffieHellman = l.DiffieHellman;
                var c = e("browserify-sign");
                r.createSign = c.createSign, r.Sign = c.Sign, r.createVerify = c.createVerify, r.Verify = c.Verify, r.createECDH = e("create-ecdh");
                var u = e("public-encrypt");
                r.publicEncrypt = u.publicEncrypt, r.privateEncrypt = u.privateEncrypt, r.publicDecrypt = u.publicDecrypt, r.privateDecrypt = u.privateDecrypt;
                var h = e("randomfill");
                r.randomFill = h.randomFill, r.randomFillSync = h.randomFillSync, r.createCredentials = function() {
                    throw new Error([
                        "sorry, createCredentials is not implemented yet",
                        "we accept pull requests",
                        "https://github.com/crypto-browserify/crypto-browserify"
                    ].join("\n"));
                }, r.constants = {
                    DH_CHECK_P_NOT_SAFE_PRIME: 2,
                    DH_CHECK_P_NOT_PRIME: 1,
                    DH_UNABLE_TO_CHECK_GENERATOR: 4,
                    DH_NOT_SUITABLE_GENERATOR: 8,
                    NPN_ENABLED: 1,
                    ALPN_ENABLED: 1,
                    RSA_PKCS1_PADDING: 1,
                    RSA_SSLV23_PADDING: 2,
                    RSA_NO_PADDING: 3,
                    RSA_PKCS1_OAEP_PADDING: 4,
                    RSA_X931_PADDING: 5,
                    RSA_PKCS1_PSS_PADDING: 6,
                    POINT_CONVERSION_COMPRESSED: 2,
                    POINT_CONVERSION_UNCOMPRESSED: 4,
                    POINT_CONVERSION_HYBRID: 6
                };
            },
            {
                "browserify-cipher": 206,
                "browserify-sign": 213,
                "browserify-sign/algos": 210,
                "create-ecdh": 384,
                "create-hash": 386,
                "create-hmac": 388,
                "diffie-hellman": 400,
                pbkdf2: 460,
                "public-encrypt": 468,
                randombytes: 475,
                randomfill: 476
            }
        ],
        391: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs = n();
                }(void 0, function() {
                    var e = 6e4, t = 36e5, r = "millisecond", n = "second", i = "minute", s = "hour", o = "day", a = "week", l = "month", c = "quarter", u = "year", h = "date", f = "Invalid Date", d = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, p = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, m = {
                        name: "en",
                        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                        ordinal: function(e) {
                            var t = [
                                "th",
                                "st",
                                "nd",
                                "rd"
                            ], r = e % 100;
                            return "[" + e + (t[(r - 20) % 10] || t[r] || t[0]) + "]";
                        }
                    }, b = function(e, t, r) {
                        var n = String(e);
                        return !n || n.length >= t ? e : "" + Array(t + 1 - n.length).join(r) + e;
                    }, g = {
                        s: b,
                        z: function(e) {
                            var t = -e.utcOffset(), r = Math.abs(t), n = Math.floor(r / 60), i = r % 60;
                            return (t <= 0 ? "+" : "-") + b(n, 2, "0") + ":" + b(i, 2, "0");
                        },
                        m: function e(t, r) {
                            if (t.date() < r.date()) return -e(r, t);
                            var n = 12 * (r.year() - t.year()) + (r.month() - t.month()), i = t.clone().add(n, l), s = r - i < 0, o = t.clone().add(n + (s ? -1 : 1), l);
                            return +(-(n + (r - i) / (s ? i - o : o - i)) || 0);
                        },
                        a: function(e) {
                            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
                        },
                        p: function(e) {
                            return ({
                                M: l,
                                y: u,
                                w: a,
                                d: o,
                                D: h,
                                h: s,
                                m: i,
                                s: n,
                                ms: r,
                                Q: c
                            })[e] || String(e || "").toLowerCase().replace(/s$/, "");
                        },
                        u: function(e) {
                            return void 0 === e;
                        }
                    }, y = "en", v = {};
                    v[y] = m;
                    var w = "$isDayjsObject", _ = function(e) {
                        return e instanceof M || !(!e || !e[w]);
                    }, x = function e(t, r, n) {
                        var i;
                        if (!t) return y;
                        if ("string" == typeof t) {
                            var s = t.toLowerCase();
                            v[s] && (i = s), r && (v[s] = r, i = s);
                            var o = t.split("-");
                            if (!i && o.length > 1) return e(o[0]);
                        } else {
                            var a = t.name;
                            v[a] = t, i = a;
                        }
                        return !n && i && (y = i), i || !n && y;
                    }, k = function(e, t) {
                        if (_(e)) return e.clone();
                        var r = "object" == typeof t ? t : {};
                        return r.date = e, r.args = arguments, new M(r);
                    }, S = g;
                    S.l = x, S.i = _, S.w = function(e, t) {
                        return k(e, {
                            locale: t.$L,
                            utc: t.$u,
                            x: t.$x,
                            $offset: t.$offset
                        });
                    };
                    var M = function() {
                        function m(e) {
                            this.$L = x(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[w] = !0;
                        }
                        var b = m.prototype;
                        return b.parse = function(e) {
                            this.$d = function(e) {
                                var t = e.date, r = e.utc;
                                if (null === t) return new Date(NaN);
                                if (S.u(t)) return new Date;
                                if (t instanceof Date) return new Date(t);
                                if ("string" == typeof t && !/Z$/i.test(t)) {
                                    var n = t.match(d);
                                    if (n) {
                                        var i = n[2] - 1 || 0, s = (n[7] || "0").substring(0, 3);
                                        return r ? new Date(Date.UTC(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s)) : new Date(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s);
                                    }
                                }
                                return new Date(t);
                            }(e), this.init();
                        }, b.init = function() {
                            var e = this.$d;
                            this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
                        }, b.$utils = function() {
                            return S;
                        }, b.isValid = function() {
                            return !(this.$d.toString() === f);
                        }, b.isSame = function(e, t) {
                            var r = k(e);
                            return this.startOf(t) <= r && r <= this.endOf(t);
                        }, b.isAfter = function(e, t) {
                            return k(e) < this.startOf(t);
                        }, b.isBefore = function(e, t) {
                            return this.endOf(t) < k(e);
                        }, b.$g = function(e, t, r) {
                            return S.u(e) ? this[t] : this.set(r, e);
                        }, b.unix = function() {
                            return Math.floor(this.valueOf() / 1e3);
                        }, b.valueOf = function() {
                            return this.$d.getTime();
                        }, b.startOf = function(e, t) {
                            var r = this, c = !!S.u(t) || t, f = S.p(e), d = function(e, t) {
                                var n = S.w(r.$u ? Date.UTC(r.$y, t, e) : new Date(r.$y, t, e), r);
                                return c ? n : n.endOf(o);
                            }, p = function(e, t) {
                                return S.w(r.toDate()[e].apply(r.toDate("s"), (c ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : [
                                    23,
                                    59,
                                    59,
                                    999
                                ]).slice(t)), r);
                            }, m = this.$W, b = this.$M, g = this.$D, y = "set" + (this.$u ? "UTC" : "");
                            switch(f){
                                case u:
                                    return c ? d(1, 0) : d(31, 11);
                                case l:
                                    return c ? d(1, b) : d(0, b + 1);
                                case a:
                                    var v = this.$locale().weekStart || 0, w = (m < v ? m + 7 : m) - v;
                                    return d(c ? g - w : g + (6 - w), b);
                                case o:
                                case h:
                                    return p(y + "Hours", 0);
                                case s:
                                    return p(y + "Minutes", 1);
                                case i:
                                    return p(y + "Seconds", 2);
                                case n:
                                    return p(y + "Milliseconds", 3);
                                default:
                                    return this.clone();
                            }
                        }, b.endOf = function(e) {
                            return this.startOf(e, !1);
                        }, b.$set = function(e, t) {
                            var a, c = S.p(e), f = "set" + (this.$u ? "UTC" : ""), d = (a = {}, a[o] = f + "Date", a[h] = f + "Date", a[l] = f + "Month", a[u] = f + "FullYear", a[s] = f + "Hours", a[i] = f + "Minutes", a[n] = f + "Seconds", a[r] = f + "Milliseconds", a)[c], p = c === o ? this.$D + (t - this.$W) : t;
                            if (c === l || c === u) {
                                var m = this.clone().set(h, 1);
                                m.$d[d](p), m.init(), this.$d = m.set(h, Math.min(this.$D, m.daysInMonth())).$d;
                            } else d && this.$d[d](p);
                            return this.init(), this;
                        }, b.set = function(e, t) {
                            return this.clone().$set(e, t);
                        }, b.get = function(e) {
                            return this[S.p(e)]();
                        }, b.add = function(r, c) {
                            var h, f = this;
                            r = Number(r);
                            var d = S.p(c), p = function(e) {
                                var t = k(f);
                                return S.w(t.date(t.date() + Math.round(e * r)), f);
                            };
                            if (d === l) return this.set(l, this.$M + r);
                            if (d === u) return this.set(u, this.$y + r);
                            if (d === o) return p(1);
                            if (d === a) return p(7);
                            var m = (h = {}, h[i] = e, h[s] = t, h[n] = 1e3, h)[d] || 1, b = this.$d.getTime() + r * m;
                            return S.w(b, this);
                        }, b.subtract = function(e, t) {
                            return this.add(-1 * e, t);
                        }, b.format = function(e) {
                            var t = this, r = this.$locale();
                            if (!this.isValid()) return r.invalidDate || f;
                            var n = e || "YYYY-MM-DDTHH:mm:ssZ", i = S.z(this), s = this.$H, o = this.$m, a = this.$M, l = r.weekdays, c = r.months, u = r.meridiem, h = function(e, r, i, s) {
                                return e && (e[r] || e(t, n)) || i[r].slice(0, s);
                            }, d = function(e) {
                                return S.s(s % 12 || 12, e, "0");
                            }, m = u || function(e, t, r) {
                                var n = e < 12 ? "AM" : "PM";
                                return r ? n.toLowerCase() : n;
                            };
                            return n.replace(p, function(e, n) {
                                return n || function(e) {
                                    switch(e){
                                        case "YY":
                                            return String(t.$y).slice(-2);
                                        case "YYYY":
                                            return S.s(t.$y, 4, "0");
                                        case "M":
                                            return a + 1;
                                        case "MM":
                                            return S.s(a + 1, 2, "0");
                                        case "MMM":
                                            return h(r.monthsShort, a, c, 3);
                                        case "MMMM":
                                            return h(c, a);
                                        case "D":
                                            return t.$D;
                                        case "DD":
                                            return S.s(t.$D, 2, "0");
                                        case "d":
                                            return String(t.$W);
                                        case "dd":
                                            return h(r.weekdaysMin, t.$W, l, 2);
                                        case "ddd":
                                            return h(r.weekdaysShort, t.$W, l, 3);
                                        case "dddd":
                                            return l[t.$W];
                                        case "H":
                                            return String(s);
                                        case "HH":
                                            return S.s(s, 2, "0");
                                        case "h":
                                            return d(1);
                                        case "hh":
                                            return d(2);
                                        case "a":
                                            return m(s, o, !0);
                                        case "A":
                                            return m(s, o, !1);
                                        case "m":
                                            return String(o);
                                        case "mm":
                                            return S.s(o, 2, "0");
                                        case "s":
                                            return String(t.$s);
                                        case "ss":
                                            return S.s(t.$s, 2, "0");
                                        case "SSS":
                                            return S.s(t.$ms, 3, "0");
                                        case "Z":
                                            return i;
                                    }
                                    return null;
                                }(e) || i.replace(":", "");
                            });
                        }, b.utcOffset = function() {
                            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
                        }, b.diff = function(r, h, f) {
                            var d, p = this, m = S.p(h), b = k(r), g = (b.utcOffset() - this.utcOffset()) * e, y = this - b, v = function() {
                                return S.m(p, b);
                            };
                            switch(m){
                                case u:
                                    d = v() / 12;
                                    break;
                                case l:
                                    d = v();
                                    break;
                                case c:
                                    d = v() / 3;
                                    break;
                                case a:
                                    d = (y - g) / 6048e5;
                                    break;
                                case o:
                                    d = (y - g) / 864e5;
                                    break;
                                case s:
                                    d = y / t;
                                    break;
                                case i:
                                    d = y / e;
                                    break;
                                case n:
                                    d = y / 1e3;
                                    break;
                                default:
                                    d = y;
                            }
                            return f ? d : S.a(d);
                        }, b.daysInMonth = function() {
                            return this.endOf(l).$D;
                        }, b.$locale = function() {
                            return v[this.$L];
                        }, b.locale = function(e, t) {
                            if (!e) return this.$L;
                            var r = this.clone(), n = x(e, t, !0);
                            return n && (r.$L = n), r;
                        }, b.clone = function() {
                            return S.w(this.$d, this);
                        }, b.toDate = function() {
                            return new Date(this.valueOf());
                        }, b.toJSON = function() {
                            return this.isValid() ? this.toISOString() : null;
                        }, b.toISOString = function() {
                            return this.$d.toISOString();
                        }, b.toString = function() {
                            return this.$d.toUTCString();
                        }, m;
                    }(), C = M.prototype;
                    return k.prototype = C, [
                        [
                            "$ms",
                            r
                        ],
                        [
                            "$s",
                            n
                        ],
                        [
                            "$m",
                            i
                        ],
                        [
                            "$H",
                            s
                        ],
                        [
                            "$W",
                            o
                        ],
                        [
                            "$M",
                            l
                        ],
                        [
                            "$y",
                            u
                        ],
                        [
                            "$D",
                            h
                        ]
                    ].forEach(function(e) {
                        C[e[1]] = function(t) {
                            return this.$g(t, e[0], e[1]);
                        };
                    }), k.extend = function(e, t) {
                        return e.$i || (e(t, M, k), e.$i = !0), k;
                    }, k.locale = x, k.isDayjs = _, k.unix = function(e) {
                        return k(1e3 * e);
                    }, k.en = v[y], k.Ls = v, k.p = {}, k;
                });
            },
            {}
        ],
        392: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_customParseFormat = n();
                }(void 0, function() {
                    var e = {
                        LTS: "h:mm:ss A",
                        LT: "h:mm A",
                        L: "MM/DD/YYYY",
                        LL: "MMMM D, YYYY",
                        LLL: "MMMM D, YYYY h:mm A",
                        LLLL: "dddd, MMMM D, YYYY h:mm A"
                    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d\d/, n = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, s = {}, o = function(e) {
                        return (e = +e) + (e > 68 ? 1900 : 2e3);
                    }, a = function(e) {
                        return function(t) {
                            this[e] = +t;
                        };
                    }, l = [
                        /[+-]\d\d:?(\d\d)?|Z/,
                        function(e) {
                            (this.zone || (this.zone = {})).offset = function(e) {
                                if (!e) return 0;
                                if ("Z" === e) return 0;
                                var t = e.match(/([+-]|\d\d)/g), r = 60 * t[1] + (+t[2] || 0);
                                return 0 === r ? 0 : "+" === t[0] ? -r : r;
                            }(e);
                        }
                    ], c = function(e) {
                        var t = s[e];
                        return t && (t.indexOf ? t : t.s.concat(t.f));
                    }, u = function(e, t) {
                        var r, n = s.meridiem;
                        if (n) {
                            for(var i = 1; i <= 24; i += 1)if (e.indexOf(n(i, 0, t)) > -1) {
                                r = i > 12;
                                break;
                            }
                        } else r = e === (t ? "pm" : "PM");
                        return r;
                    }, h = {
                        A: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !1);
                            }
                        ],
                        a: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !0);
                            }
                        ],
                        S: [
                            /\d/,
                            function(e) {
                                this.milliseconds = 100 * +e;
                            }
                        ],
                        SS: [
                            r,
                            function(e) {
                                this.milliseconds = 10 * +e;
                            }
                        ],
                        SSS: [
                            /\d{3}/,
                            function(e) {
                                this.milliseconds = +e;
                            }
                        ],
                        s: [
                            n,
                            a("seconds")
                        ],
                        ss: [
                            n,
                            a("seconds")
                        ],
                        m: [
                            n,
                            a("minutes")
                        ],
                        mm: [
                            n,
                            a("minutes")
                        ],
                        H: [
                            n,
                            a("hours")
                        ],
                        h: [
                            n,
                            a("hours")
                        ],
                        HH: [
                            n,
                            a("hours")
                        ],
                        hh: [
                            n,
                            a("hours")
                        ],
                        D: [
                            n,
                            a("day")
                        ],
                        DD: [
                            r,
                            a("day")
                        ],
                        Do: [
                            i,
                            function(e) {
                                var t = s.ordinal, r = e.match(/\d+/);
                                if (this.day = r[0], t) for(var n = 1; n <= 31; n += 1)t(n).replace(/\[|\]/g, "") === e && (this.day = n);
                            }
                        ],
                        M: [
                            n,
                            a("month")
                        ],
                        MM: [
                            r,
                            a("month")
                        ],
                        MMM: [
                            i,
                            function(e) {
                                var t = c("months"), r = (c("monthsShort") || t.map(function(e) {
                                    return e.slice(0, 3);
                                })).indexOf(e) + 1;
                                if (r < 1) throw new Error;
                                this.month = r % 12 || r;
                            }
                        ],
                        MMMM: [
                            i,
                            function(e) {
                                var t = c("months").indexOf(e) + 1;
                                if (t < 1) throw new Error;
                                this.month = t % 12 || t;
                            }
                        ],
                        Y: [
                            /[+-]?\d+/,
                            a("year")
                        ],
                        YY: [
                            r,
                            function(e) {
                                this.year = o(e);
                            }
                        ],
                        YYYY: [
                            /\d{4}/,
                            a("year")
                        ],
                        Z: l,
                        ZZ: l
                    };
                    function f(r) {
                        var n, i;
                        n = r, i = s && s.formats;
                        for(var o = (r = n.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, r, n) {
                            var s = n && n.toUpperCase();
                            return r || i[n] || e[n] || i[s].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, r) {
                                return t || r.slice(1);
                            });
                        })).match(t), a = o.length, l = 0; l < a; l += 1){
                            var c = o[l], u = h[c], f = u && u[0], d = u && u[1];
                            o[l] = d ? {
                                regex: f,
                                parser: d
                            } : c.replace(/^\[|\]$/g, "");
                        }
                        return function(e) {
                            for(var t = {}, r = 0, n = 0; r < a; r += 1){
                                var i = o[r];
                                if ("string" == typeof i) n += i.length;
                                else {
                                    var s = i.regex, l = i.parser, c = e.slice(n), u = s.exec(c)[0];
                                    l.call(t, u), e = e.replace(u, "");
                                }
                            }
                            return function(e) {
                                var t = e.afternoon;
                                if (void 0 !== t) {
                                    var r = e.hours;
                                    t ? r < 12 && (e.hours += 12) : 12 === r && (e.hours = 0), delete e.afternoon;
                                }
                            }(t), t;
                        };
                    }
                    return function(e, t, r) {
                        r.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
                        var n = t.prototype, i = n.parse;
                        n.parse = function(e) {
                            var t = e.date, n = e.utc, o = e.args;
                            this.$u = n;
                            var a = o[1];
                            if ("string" == typeof a) {
                                var l = !0 === o[2], c = !0 === o[3], u = l || c, h = o[2];
                                c && (h = o[2]), s = this.$locale(), !l && h && (s = r.Ls[h]), this.$d = function(e, t, r) {
                                    try {
                                        if ([
                                            "x",
                                            "X"
                                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                                        var n = f(t)(e), i = n.year, s = n.month, o = n.day, a = n.hours, l = n.minutes, c = n.seconds, u = n.milliseconds, h = n.zone, d = new Date, p = o || (i || s ? 1 : d.getDate()), m = i || d.getFullYear(), b = 0;
                                        i && !s || (b = s > 0 ? s - 1 : d.getMonth());
                                        var g = a || 0, y = l || 0, v = c || 0, w = u || 0;
                                        return h ? new Date(Date.UTC(m, b, p, g, y, v, w + 60 * h.offset * 1e3)) : r ? new Date(Date.UTC(m, b, p, g, y, v, w)) : new Date(m, b, p, g, y, v, w);
                                    } catch (e) {
                                        return new Date("");
                                    }
                                }(t, a, n), this.init(), h && !0 !== h && (this.$L = this.locale(h).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
                            } else if (a instanceof Array) for(var d = a.length, p = 1; p <= d; p += 1){
                                o[1] = a[p - 1];
                                var m = r.apply(this, o);
                                if (m.isValid()) {
                                    this.$d = m.$d, this.$L = m.$L, this.init();
                                    break;
                                }
                                p === d && (this.$d = new Date(""));
                            }
                            else i.call(this, e);
                        };
                    };
                });
            },
            {}
        ],
        393: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_utc = n();
                }(void 0, function() {
                    var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
                    return function(n, i, s) {
                        var o = i.prototype;
                        s.utc = function(e) {
                            var t = {
                                date: e,
                                utc: !0,
                                args: arguments
                            };
                            return new i(t);
                        }, o.utc = function(t) {
                            var r = s(this.toDate(), {
                                locale: this.$L,
                                utc: !0
                            });
                            return t ? r.add(this.utcOffset(), e) : r;
                        }, o.local = function() {
                            return s(this.toDate(), {
                                locale: this.$L,
                                utc: !1
                            });
                        };
                        var a = o.parse;
                        o.parse = function(e) {
                            e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), a.call(this, e);
                        };
                        var l = o.init;
                        o.init = function() {
                            if (this.$u) {
                                var e = this.$d;
                                this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
                            } else l.call(this);
                        };
                        var c = o.utcOffset;
                        o.utcOffset = function(n, i) {
                            var s = this.$utils().u;
                            if (s(n)) return this.$u ? 0 : s(this.$offset) ? c.call(this) : this.$offset;
                            if ("string" == typeof n && null === (n = function(e) {
                                void 0 === e && (e = "");
                                var n = e.match(t);
                                if (!n) return null;
                                var i = ("" + n[0]).match(r) || [
                                    "-",
                                    0,
                                    0
                                ], s = i[0], o = 60 * +i[1] + +i[2];
                                return 0 === o ? 0 : "+" === s ? o : -o;
                            }(n))) return this;
                            var o = Math.abs(n) <= 16 ? 60 * n : n, a = this;
                            if (i) return a.$offset = o, a.$u = 0 === n, a;
                            if (0 !== n) {
                                var l = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                                (a = this.local().add(o + l, e)).$offset = o, a.$x.$localOffset = l;
                            } else a = this.utc();
                            return a;
                        };
                        var u = o.format;
                        o.format = function(e) {
                            var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
                            return u.call(this, t);
                        }, o.valueOf = function() {
                            var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
                            return this.$d.valueOf() - 6e4 * e;
                        }, o.isUTC = function() {
                            return !!this.$u;
                        }, o.toISOString = function() {
                            return this.toDate().toISOString();
                        }, o.toString = function() {
                            return this.toDate().toUTCString();
                        };
                        var h = o.toDate;
                        o.toDate = function(e) {
                            return "s" === e && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
                        };
                        var f = o.diff;
                        o.diff = function(e, t, r) {
                            if (e && this.$u === e.$u) return f.call(this, e, t, r);
                            var n = this.local(), i = s(e).local();
                            return f.call(n, i, t, r);
                        };
                    };
                });
            },
            {}
        ],
        394: [
            function(e, t, r) {
                "use strict";
                r.utils = e("./des/utils"), r.Cipher = e("./des/cipher"), r.DES = e("./des/des"), r.CBC = e("./des/cbc"), r.EDE = e("./des/ede");
            },
            {
                "./des/cbc": 395,
                "./des/cipher": 396,
                "./des/des": 397,
                "./des/ede": 398,
                "./des/utils": 399
            }
        ],
        395: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = {};
                function o(e) {
                    n.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);
                    for(var t = 0; t < this.iv.length; t++)this.iv[t] = e[t];
                }
                r.instantiate = function(e) {
                    function t(t) {
                        e.call(this, t), this._cbcInit();
                    }
                    i(t, e);
                    for(var r = Object.keys(s), n = 0; n < r.length; n++){
                        var o = r[n];
                        t.prototype[o] = s[o];
                    }
                    return t.create = function(e) {
                        return new t(e);
                    }, t;
                }, s._cbcInit = function() {
                    var e = new o(this.options.iv);
                    this._cbcState = e;
                }, s._update = function(e, t, r, n) {
                    var i = this._cbcState, s = this.constructor.super_.prototype, o = i.iv;
                    if ("encrypt" === this.type) {
                        for(var a = 0; a < this.blockSize; a++)o[a] ^= e[t + a];
                        s._update.call(this, o, 0, r, n);
                        for(a = 0; a < this.blockSize; a++)o[a] = r[n + a];
                    } else {
                        s._update.call(this, e, t, r, n);
                        for(a = 0; a < this.blockSize; a++)r[n + a] ^= o[a];
                        for(a = 0; a < this.blockSize; a++)o[a] = e[t + a];
                    }
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        396: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert");
                function i(e) {
                    this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = !1 !== e.padding;
                }
                t.exports = i, i.prototype._init = function() {}, i.prototype.update = function(e) {
                    return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
                }, i.prototype._buffer = function(e, t) {
                    for(var r = Math.min(this.buffer.length - this.bufferOff, e.length - t), n = 0; n < r; n++)this.buffer[this.bufferOff + n] = e[t + n];
                    return this.bufferOff += r, r;
                }, i.prototype._flushBuffer = function(e, t) {
                    return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
                }, i.prototype._updateEncrypt = function(e) {
                    var t = 0, r = 0, n = (this.bufferOff + e.length) / this.blockSize | 0, i = new Array(n * this.blockSize);
                    0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (r += this._flushBuffer(i, r)));
                    for(var s = e.length - (e.length - t) % this.blockSize; t < s; t += this.blockSize)this._update(e, t, i, r), r += this.blockSize;
                    for(; t < e.length; t++, this.bufferOff++)this.buffer[this.bufferOff] = e[t];
                    return i;
                }, i.prototype._updateDecrypt = function(e) {
                    for(var t = 0, r = 0, n = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(n * this.blockSize); n > 0; n--)t += this._buffer(e, t), r += this._flushBuffer(i, r);
                    return t += this._buffer(e, t), i;
                }, i.prototype.final = function(e) {
                    var t, r;
                    return e && (t = this.update(e)), r = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(r) : r;
                }, i.prototype._pad = function(e, t) {
                    if (0 === t) return !1;
                    for(; t < e.length;)e[t++] = 0;
                    return !0;
                }, i.prototype._finalEncrypt = function() {
                    if (!this._pad(this.buffer, this.bufferOff)) return [];
                    var e = new Array(this.blockSize);
                    return this._update(this.buffer, 0, e, 0), e;
                }, i.prototype._unpad = function(e) {
                    return e;
                }, i.prototype._finalDecrypt = function() {
                    n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
                    var e = new Array(this.blockSize);
                    return this._flushBuffer(e, 0), this._unpad(e);
                };
            },
            {
                "minimalistic-assert": 453
            }
        ],
        397: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./utils"), o = e("./cipher");
                function a() {
                    this.tmp = new Array(2), this.keys = null;
                }
                function l(e) {
                    o.call(this, e);
                    var t = new a;
                    this._desState = t, this.deriveKeys(t, e.key);
                }
                i(l, o), t.exports = l, l.create = function(e) {
                    return new l(e);
                };
                var c = [
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1
                ];
                l.prototype.deriveKeys = function(e, t) {
                    e.keys = new Array(32), n.equal(t.length, this.blockSize, "Invalid key length");
                    var r = s.readUInt32BE(t, 0), i = s.readUInt32BE(t, 4);
                    s.pc1(r, i, e.tmp, 0), r = e.tmp[0], i = e.tmp[1];
                    for(var o = 0; o < e.keys.length; o += 2){
                        var a = c[o >>> 1];
                        r = s.r28shl(r, a), i = s.r28shl(i, a), s.pc2(r, i, e.keys, o);
                    }
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._desState, o = s.readUInt32BE(e, t), a = s.readUInt32BE(e, t + 4);
                    s.ip(o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, o, a, i.tmp, 0) : this._decrypt(i, o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], s.writeUInt32BE(r, o, n), s.writeUInt32BE(r, a, n + 4);
                }, l.prototype._pad = function(e, t) {
                    if (!1 === this.padding) return !1;
                    for(var r = e.length - t, n = t; n < e.length; n++)e[n] = r;
                    return !0;
                }, l.prototype._unpad = function(e) {
                    if (!1 === this.padding) return e;
                    for(var t = e[e.length - 1], r = e.length - t; r < e.length; r++)n.equal(e[r], t);
                    return e.slice(0, e.length - t);
                }, l.prototype._encrypt = function(e, t, r, n, i) {
                    for(var o = t, a = r, l = 0; l < e.keys.length; l += 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(a, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = a;
                        a = (o ^ s.permute(h)) >>> 0, o = f;
                    }
                    s.rip(a, o, n, i);
                }, l.prototype._decrypt = function(e, t, r, n, i) {
                    for(var o = r, a = t, l = e.keys.length - 2; l >= 0; l -= 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(o, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = o;
                        o = (a ^ s.permute(h)) >>> 0, a = f;
                    }
                    s.rip(o, a, n, i);
                };
            },
            {
                "./cipher": 396,
                "./utils": 399,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        398: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./cipher"), o = e("./des");
                function a(e, t) {
                    n.equal(t.length, 24, "Invalid key length");
                    var r = t.slice(0, 8), i = t.slice(8, 16), s = t.slice(16, 24);
                    this.ciphers = "encrypt" === e ? [
                        o.create({
                            type: "encrypt",
                            key: r
                        }),
                        o.create({
                            type: "decrypt",
                            key: i
                        }),
                        o.create({
                            type: "encrypt",
                            key: s
                        })
                    ] : [
                        o.create({
                            type: "decrypt",
                            key: s
                        }),
                        o.create({
                            type: "encrypt",
                            key: i
                        }),
                        o.create({
                            type: "decrypt",
                            key: r
                        })
                    ];
                }
                function l(e) {
                    s.call(this, e);
                    var t = new a(this.type, this.options.key);
                    this._edeState = t;
                }
                i(l, s), t.exports = l, l.create = function(e) {
                    return new l(e);
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._edeState;
                    i.ciphers[0]._update(e, t, r, n), i.ciphers[1]._update(r, n, r, n), i.ciphers[2]._update(r, n, r, n);
                }, l.prototype._pad = o.prototype._pad, l.prototype._unpad = o.prototype._unpad;
            },
            {
                "./cipher": 396,
                "./des": 397,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        399: [
            function(e, t, r) {
                "use strict";
                r.readUInt32BE = function(e, t) {
                    return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
                }, r.writeUInt32BE = function(e, t, r) {
                    e[0 + r] = t >>> 24, e[1 + r] = t >>> 16 & 255, e[2 + r] = t >>> 8 & 255, e[3 + r] = 255 & t;
                }, r.ip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 6; o >= 0; o -= 2){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >>> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >>> a + o & 1;
                    }
                    for(o = 6; o >= 0; o -= 2){
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= t >>> a + o & 1;
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= e >>> a + o & 1;
                    }
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.rip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 0; o < 4; o++)for(var a = 24; a >= 0; a -= 8)i <<= 1, i |= t >>> a + o & 1, i <<= 1, i |= e >>> a + o & 1;
                    for(o = 4; o < 8; o++)for(a = 24; a >= 0; a -= 8)s <<= 1, s |= t >>> a + o & 1, s <<= 1, s |= e >>> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.pc1 = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 7; o >= 5; o--){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                    for(o = 1; o <= 3; o++){
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.r28shl = function(e, t) {
                    return e << t & 268435455 | e >>> 28 - t;
                };
                var n = [
                    14,
                    11,
                    17,
                    4,
                    27,
                    23,
                    25,
                    0,
                    13,
                    22,
                    7,
                    18,
                    5,
                    9,
                    16,
                    24,
                    2,
                    20,
                    12,
                    21,
                    1,
                    8,
                    15,
                    26,
                    15,
                    4,
                    25,
                    19,
                    9,
                    1,
                    26,
                    16,
                    5,
                    11,
                    23,
                    8,
                    12,
                    7,
                    17,
                    0,
                    22,
                    3,
                    10,
                    14,
                    6,
                    20,
                    27,
                    24
                ];
                r.pc2 = function(e, t, r, i) {
                    for(var s = 0, o = 0, a = n.length >>> 1, l = 0; l < a; l++)s <<= 1, s |= e >>> n[l] & 1;
                    for(l = a; l < n.length; l++)o <<= 1, o |= t >>> n[l] & 1;
                    r[i + 0] = s >>> 0, r[i + 1] = o >>> 0;
                }, r.expand = function(e, t, r) {
                    var n = 0, i = 0;
                    n = (1 & e) << 5 | e >>> 27;
                    for(var s = 23; s >= 15; s -= 4)n <<= 6, n |= e >>> s & 63;
                    for(s = 11; s >= 3; s -= 4)i |= e >>> s & 63, i <<= 6;
                    i |= (31 & e) << 1 | e >>> 31, t[r + 0] = n >>> 0, t[r + 1] = i >>> 0;
                };
                var i = [
                    14,
                    0,
                    4,
                    15,
                    13,
                    7,
                    1,
                    4,
                    2,
                    14,
                    15,
                    2,
                    11,
                    13,
                    8,
                    1,
                    3,
                    10,
                    10,
                    6,
                    6,
                    12,
                    12,
                    11,
                    5,
                    9,
                    9,
                    5,
                    0,
                    3,
                    7,
                    8,
                    4,
                    15,
                    1,
                    12,
                    14,
                    8,
                    8,
                    2,
                    13,
                    4,
                    6,
                    9,
                    2,
                    1,
                    11,
                    7,
                    15,
                    5,
                    12,
                    11,
                    9,
                    3,
                    7,
                    14,
                    3,
                    10,
                    10,
                    0,
                    5,
                    6,
                    0,
                    13,
                    15,
                    3,
                    1,
                    13,
                    8,
                    4,
                    14,
                    7,
                    6,
                    15,
                    11,
                    2,
                    3,
                    8,
                    4,
                    14,
                    9,
                    12,
                    7,
                    0,
                    2,
                    1,
                    13,
                    10,
                    12,
                    6,
                    0,
                    9,
                    5,
                    11,
                    10,
                    5,
                    0,
                    13,
                    14,
                    8,
                    7,
                    10,
                    11,
                    1,
                    10,
                    3,
                    4,
                    15,
                    13,
                    4,
                    1,
                    2,
                    5,
                    11,
                    8,
                    6,
                    12,
                    7,
                    6,
                    12,
                    9,
                    0,
                    3,
                    5,
                    2,
                    14,
                    15,
                    9,
                    10,
                    13,
                    0,
                    7,
                    9,
                    0,
                    14,
                    9,
                    6,
                    3,
                    3,
                    4,
                    15,
                    6,
                    5,
                    10,
                    1,
                    2,
                    13,
                    8,
                    12,
                    5,
                    7,
                    14,
                    11,
                    12,
                    4,
                    11,
                    2,
                    15,
                    8,
                    1,
                    13,
                    1,
                    6,
                    10,
                    4,
                    13,
                    9,
                    0,
                    8,
                    6,
                    15,
                    9,
                    3,
                    8,
                    0,
                    7,
                    11,
                    4,
                    1,
                    15,
                    2,
                    14,
                    12,
                    3,
                    5,
                    11,
                    10,
                    5,
                    14,
                    2,
                    7,
                    12,
                    7,
                    13,
                    13,
                    8,
                    14,
                    11,
                    3,
                    5,
                    0,
                    6,
                    6,
                    15,
                    9,
                    0,
                    10,
                    3,
                    1,
                    4,
                    2,
                    7,
                    8,
                    2,
                    5,
                    12,
                    11,
                    1,
                    12,
                    10,
                    4,
                    14,
                    15,
                    9,
                    10,
                    3,
                    6,
                    15,
                    9,
                    0,
                    0,
                    6,
                    12,
                    10,
                    11,
                    1,
                    7,
                    13,
                    13,
                    8,
                    15,
                    9,
                    1,
                    4,
                    3,
                    5,
                    14,
                    11,
                    5,
                    12,
                    2,
                    7,
                    8,
                    2,
                    4,
                    14,
                    2,
                    14,
                    12,
                    11,
                    4,
                    2,
                    1,
                    12,
                    7,
                    4,
                    10,
                    7,
                    11,
                    13,
                    6,
                    1,
                    8,
                    5,
                    5,
                    0,
                    3,
                    15,
                    15,
                    10,
                    13,
                    3,
                    0,
                    9,
                    14,
                    8,
                    9,
                    6,
                    4,
                    11,
                    2,
                    8,
                    1,
                    12,
                    11,
                    7,
                    10,
                    1,
                    13,
                    14,
                    7,
                    2,
                    8,
                    13,
                    15,
                    6,
                    9,
                    15,
                    12,
                    0,
                    5,
                    9,
                    6,
                    10,
                    3,
                    4,
                    0,
                    5,
                    14,
                    3,
                    12,
                    10,
                    1,
                    15,
                    10,
                    4,
                    15,
                    2,
                    9,
                    7,
                    2,
                    12,
                    6,
                    9,
                    8,
                    5,
                    0,
                    6,
                    13,
                    1,
                    3,
                    13,
                    4,
                    14,
                    14,
                    0,
                    7,
                    11,
                    5,
                    3,
                    11,
                    8,
                    9,
                    4,
                    14,
                    3,
                    15,
                    2,
                    5,
                    12,
                    2,
                    9,
                    8,
                    5,
                    12,
                    15,
                    3,
                    10,
                    7,
                    11,
                    0,
                    14,
                    4,
                    1,
                    10,
                    7,
                    1,
                    6,
                    13,
                    0,
                    11,
                    8,
                    6,
                    13,
                    4,
                    13,
                    11,
                    0,
                    2,
                    11,
                    14,
                    7,
                    15,
                    4,
                    0,
                    9,
                    8,
                    1,
                    13,
                    10,
                    3,
                    14,
                    12,
                    3,
                    9,
                    5,
                    7,
                    12,
                    5,
                    2,
                    10,
                    15,
                    6,
                    8,
                    1,
                    6,
                    1,
                    6,
                    4,
                    11,
                    11,
                    13,
                    13,
                    8,
                    12,
                    1,
                    3,
                    4,
                    7,
                    10,
                    14,
                    7,
                    10,
                    9,
                    15,
                    5,
                    6,
                    0,
                    8,
                    15,
                    0,
                    14,
                    5,
                    2,
                    9,
                    3,
                    2,
                    12,
                    13,
                    1,
                    2,
                    15,
                    8,
                    13,
                    4,
                    8,
                    6,
                    10,
                    15,
                    3,
                    11,
                    7,
                    1,
                    4,
                    10,
                    12,
                    9,
                    5,
                    3,
                    6,
                    14,
                    11,
                    5,
                    0,
                    0,
                    14,
                    12,
                    9,
                    7,
                    2,
                    7,
                    2,
                    11,
                    1,
                    4,
                    14,
                    1,
                    7,
                    9,
                    4,
                    12,
                    10,
                    14,
                    8,
                    2,
                    13,
                    0,
                    15,
                    6,
                    12,
                    10,
                    9,
                    13,
                    0,
                    15,
                    3,
                    3,
                    5,
                    5,
                    6,
                    8,
                    11
                ];
                r.substitute = function(e, t) {
                    for(var r = 0, n = 0; n < 4; n++)r <<= 4, r |= i[64 * n + (e >>> 18 - 6 * n & 63)];
                    for(n = 0; n < 4; n++)r <<= 4, r |= i[256 + 64 * n + (t >>> 18 - 6 * n & 63)];
                    return r >>> 0;
                };
                var s = [
                    16,
                    25,
                    12,
                    11,
                    3,
                    20,
                    4,
                    15,
                    31,
                    17,
                    9,
                    6,
                    27,
                    14,
                    1,
                    22,
                    30,
                    24,
                    8,
                    18,
                    0,
                    5,
                    29,
                    23,
                    13,
                    19,
                    2,
                    26,
                    10,
                    21,
                    28,
                    7
                ];
                r.permute = function(e) {
                    for(var t = 0, r = 0; r < s.length; r++)t <<= 1, t |= e >>> s[r] & 1;
                    return t >>> 0;
                }, r.padSplit = function(e, t, r) {
                    for(var n = e.toString(2); n.length < t;)n = "0" + n;
                    for(var i = [], s = 0; s < t; s += r)i.push(n.slice(s, s + r));
                    return i.join(" ");
                };
            },
            {}
        ],
        400: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("./lib/generatePrime"), i = e("./lib/primes.json"), s = e("./lib/dh");
                        var o = {
                            binary: !0,
                            hex: !0,
                            base64: !0
                        };
                        r.DiffieHellmanGroup = r.createDiffieHellmanGroup = r.getDiffieHellman = function(e) {
                            var r = new t(i[e].prime, "hex"), n = new t(i[e].gen, "hex");
                            return new s(r, n);
                        }, r.createDiffieHellman = r.DiffieHellman = function e(r, i, a, l) {
                            return t.isBuffer(i) || void 0 === o[i] ? e(r, "binary", i, a) : (i = i || "binary", l = l || "binary", a = a || new t([
                                2
                            ]), t.isBuffer(a) || (a = new t(a, l)), "number" == typeof r ? new s(n(r, a), a, !0) : (t.isBuffer(r) || (r = new t(r, i)), new s(r, a, !0)));
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./lib/dh": 401,
                "./lib/generatePrime": 402,
                "./lib/primes.json": 403,
                buffer: 220
            }
        ],
        401: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = new (e("miller-rabin")), s = new n(24), o = new n(11), a = new n(10), l = new n(3), c = new n(7), u = e("./generatePrime"), h = e("randombytes");
                        function f(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._pub = new n(e), this;
                        }
                        function d(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._priv = new n(e), this;
                        }
                        t.exports = m;
                        var p = {};
                        function m(e, t, r) {
                            this.setGenerator(t), this.__prime = new n(e), this._prime = n.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, r ? (this.setPublicKey = f, this.setPrivateKey = d) : this._primeCode = 8;
                        }
                        function b(e, t) {
                            var n = new r(e.toArray());
                            return t ? n.toString(t) : n;
                        }
                        Object.defineProperty(m.prototype, "verifyError", {
                            enumerable: !0,
                            get: function() {
                                return "number" != typeof this._primeCode && (this._primeCode = function(e, t) {
                                    var r = t.toString("hex"), n = [
                                        r,
                                        e.toString(16)
                                    ].join("_");
                                    if (n in p) return p[n];
                                    var h, f = 0;
                                    if (e.isEven() || !u.simpleSieve || !u.fermatTest(e) || !i.test(e)) return f += 1, f += "02" === r || "05" === r ? 8 : 4, p[n] = f, f;
                                    switch(i.test(e.shrn(1)) || (f += 2), r){
                                        case "02":
                                            e.mod(s).cmp(o) && (f += 8);
                                            break;
                                        case "05":
                                            (h = e.mod(a)).cmp(l) && h.cmp(c) && (f += 8);
                                            break;
                                        default:
                                            f += 4;
                                    }
                                    return p[n] = f, f;
                                }(this.__prime, this.__gen)), this._primeCode;
                            }
                        }), m.prototype.generateKeys = function() {
                            return this._priv || (this._priv = new n(h(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
                        }, m.prototype.computeSecret = function(e) {
                            var t = (e = (e = new n(e)).toRed(this._prime)).redPow(this._priv).fromRed(), i = new r(t.toArray()), s = this.getPrime();
                            if (i.length < s.length) {
                                var o = new r(s.length - i.length);
                                o.fill(0), i = r.concat([
                                    o,
                                    i
                                ]);
                            }
                            return i;
                        }, m.prototype.getPublicKey = function(e) {
                            return b(this._pub, e);
                        }, m.prototype.getPrivateKey = function(e) {
                            return b(this._priv, e);
                        }, m.prototype.getPrime = function(e) {
                            return b(this.__prime, e);
                        }, m.prototype.getGenerator = function(e) {
                            return b(this._gen, e);
                        }, m.prototype.setGenerator = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.__gen = e, this._gen = new n(e), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./generatePrime": 402,
                "bn.js": 404,
                buffer: 220,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        402: [
            function(e, t, r) {
                "use strict";
                var n = e("randombytes");
                t.exports = y, y.simpleSieve = b, y.fermatTest = g;
                var i = e("bn.js"), s = new i(24), o = new (e("miller-rabin")), a = new i(1), l = new i(2), c = new i(5), u = (new i(16), new i(8), new i(10)), h = new i(3), f = (new i(7), new i(11)), d = new i(4), p = (new i(12), null);
                function m() {
                    if (null !== p) return p;
                    var e = [];
                    e[0] = 2;
                    for(var t = 1, r = 3; r < 1048576; r += 2){
                        for(var n = Math.ceil(Math.sqrt(r)), i = 0; i < t && e[i] <= n && r % e[i] != 0; i++);
                        t !== i && e[i] <= n || (e[t++] = r);
                    }
                    return p = e, e;
                }
                function b(e) {
                    for(var t = m(), r = 0; r < t.length; r++)if (0 === e.modn(t[r])) return 0 === e.cmpn(t[r]);
                    return !0;
                }
                function g(e) {
                    var t = i.mont(e);
                    return 0 === l.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
                }
                function y(e, t) {
                    if (e < 16) return new i(2 === t || 5 === t ? [
                        140,
                        123
                    ] : [
                        140,
                        39
                    ]);
                    var r, p;
                    for(t = new i(t);;){
                        for(r = new i(n(Math.ceil(e / 8))); r.bitLength() > e;)r.ishrn(1);
                        if (r.isEven() && r.iadd(a), r.testn(1) || r.iadd(l), t.cmp(l)) {
                            if (!t.cmp(c)) for(; r.mod(u).cmp(h);)r.iadd(d);
                        } else for(; r.mod(s).cmp(f);)r.iadd(d);
                        if (b(p = r.shrn(1)) && b(r) && g(p) && g(r) && o.test(p) && o.test(r)) return r;
                    }
                }
            },
            {
                "bn.js": 404,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        403: [
            function(e, t, r) {
                t.exports = {
                    modp1: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
                    },
                    modp2: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
                    },
                    modp5: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
                    },
                    modp14: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
                    },
                    modp15: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
                    },
                    modp16: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
                    },
                    modp17: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
                    },
                    modp18: {
                        gen: "02",
                        prime: "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"
                    }
                };
            },
            {}
        ],
        404: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        405: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.version = e("../package.json").version, n.utils = e("./elliptic/utils"), n.rand = e("brorand"), n.curve = e("./elliptic/curve"), n.curves = e("./elliptic/curves"), n.ec = e("./elliptic/ec"), n.eddsa = e("./elliptic/eddsa");
            },
            {
                "../package.json": 421,
                "./elliptic/curve": 408,
                "./elliptic/curves": 411,
                "./elliptic/ec": 412,
                "./elliptic/eddsa": 415,
                "./elliptic/utils": 419,
                brorand: 187
            }
        ],
        406: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.getNAF, o = i.getJSF, a = i.assert;
                function l(e, t) {
                    this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
                    var r = this.n && this.p.div(this.n);
                    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
                }
                function c(e, t) {
                    this.curve = e, this.type = t, this.precomputed = null;
                }
                t.exports = l, l.prototype.point = function() {
                    throw new Error("Not implemented");
                }, l.prototype.validate = function() {
                    throw new Error("Not implemented");
                }, l.prototype._fixedNafMul = function(e, t) {
                    a(e.precomputed);
                    var r = e._getDoubles(), n = s(t, 1, this._bitLength), i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);
                    i /= 3;
                    var o, l, c = [];
                    for(o = 0; o < n.length; o += r.step){
                        l = 0;
                        for(var u = o + r.step - 1; u >= o; u--)l = (l << 1) + n[u];
                        c.push(l);
                    }
                    for(var h = this.jpoint(null, null, null), f = this.jpoint(null, null, null), d = i; d > 0; d--){
                        for(o = 0; o < c.length; o++)(l = c[o]) === d ? f = f.mixedAdd(r.points[o]) : l === -d && (f = f.mixedAdd(r.points[o].neg()));
                        h = h.add(f);
                    }
                    return h.toP();
                }, l.prototype._wnafMul = function(e, t) {
                    var r = 4, n = e._getNAFPoints(r);
                    r = n.wnd;
                    for(var i = n.points, o = s(t, r, this._bitLength), l = this.jpoint(null, null, null), c = o.length - 1; c >= 0; c--){
                        for(var u = 0; c >= 0 && 0 === o[c]; c--)u++;
                        if (c >= 0 && u++, l = l.dblp(u), c < 0) break;
                        var h = o[c];
                        a(0 !== h), l = "affine" === e.type ? h > 0 ? l.mixedAdd(i[h - 1 >> 1]) : l.mixedAdd(i[-h - 1 >> 1].neg()) : h > 0 ? l.add(i[h - 1 >> 1]) : l.add(i[-h - 1 >> 1].neg());
                    }
                    return "affine" === e.type ? l.toP() : l;
                }, l.prototype._wnafMulAdd = function(e, t, r, n, i) {
                    var a, l, c, u = this._wnafT1, h = this._wnafT2, f = this._wnafT3, d = 0;
                    for(a = 0; a < n; a++){
                        var p = (c = t[a])._getNAFPoints(e);
                        u[a] = p.wnd, h[a] = p.points;
                    }
                    for(a = n - 1; a >= 1; a -= 2){
                        var m = a - 1, b = a;
                        if (1 === u[m] && 1 === u[b]) {
                            var g = [
                                t[m],
                                null,
                                null,
                                t[b]
                            ];
                            0 === t[m].y.cmp(t[b].y) ? (g[1] = t[m].add(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg())) : 0 === t[m].y.cmp(t[b].y.redNeg()) ? (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].add(t[b].neg())) : (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg()));
                            var y = [
                                -3,
                                -1,
                                -5,
                                -7,
                                0,
                                7,
                                5,
                                1,
                                3
                            ], v = o(r[m], r[b]);
                            for(d = Math.max(v[0].length, d), f[m] = new Array(d), f[b] = new Array(d), l = 0; l < d; l++){
                                var w = 0 | v[0][l], _ = 0 | v[1][l];
                                f[m][l] = y[3 * (w + 1) + (_ + 1)], f[b][l] = 0, h[m] = g;
                            }
                        } else f[m] = s(r[m], u[m], this._bitLength), f[b] = s(r[b], u[b], this._bitLength), d = Math.max(f[m].length, d), d = Math.max(f[b].length, d);
                    }
                    var x = this.jpoint(null, null, null), k = this._wnafT4;
                    for(a = d; a >= 0; a--){
                        for(var S = 0; a >= 0;){
                            var M = !0;
                            for(l = 0; l < n; l++)k[l] = 0 | f[l][a], 0 !== k[l] && (M = !1);
                            if (!M) break;
                            S++, a--;
                        }
                        if (a >= 0 && S++, x = x.dblp(S), a < 0) break;
                        for(l = 0; l < n; l++){
                            var C = k[l];
                            0 !== C && (C > 0 ? c = h[l][C - 1 >> 1] : C < 0 && (c = h[l][-C - 1 >> 1].neg()), x = "affine" === c.type ? x.mixedAdd(c) : x.add(c));
                        }
                    }
                    for(a = 0; a < n; a++)h[a] = null;
                    return i ? x : x.toP();
                }, l.BasePoint = c, c.prototype.eq = function() {
                    throw new Error("Not implemented");
                }, c.prototype.validate = function() {
                    return this.curve.validate(this);
                }, l.prototype.decodePoint = function(e, t) {
                    e = i.toArray(e, t);
                    var r = this.p.byteLength();
                    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? a(e[e.length - 1] % 2 == 0) : 7 === e[0] && a(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
                    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
                    throw new Error("Unknown point format");
                }, c.prototype.encodeCompressed = function(e) {
                    return this.encode(e, !0);
                }, c.prototype._encode = function(e) {
                    var t = this.curve.p.byteLength(), r = this.getX().toArray("be", t);
                    return e ? [
                        this.getY().isEven() ? 2 : 3
                    ].concat(r) : [
                        4
                    ].concat(r, this.getY().toArray("be", t));
                }, c.prototype.encode = function(e, t) {
                    return i.encode(this._encode(t), e);
                }, c.prototype.precompute = function(e) {
                    if (this.precomputed) return this;
                    var t = {
                        doubles: null,
                        naf: null,
                        beta: null
                    };
                    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
                }, c.prototype._hasDoubles = function(e) {
                    if (!this.precomputed) return !1;
                    var t = this.precomputed.doubles;
                    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
                }, c.prototype._getDoubles = function(e, t) {
                    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
                    for(var r = [
                        this
                    ], n = this, i = 0; i < t; i += e){
                        for(var s = 0; s < e; s++)n = n.dbl();
                        r.push(n);
                    }
                    return {
                        step: e,
                        points: r
                    };
                }, c.prototype._getNAFPoints = function(e) {
                    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
                    for(var t = [
                        this
                    ], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++)t[i] = t[i - 1].add(n);
                    return {
                        wnd: e,
                        points: t
                    };
                }, c.prototype._getBeta = function() {
                    return null;
                }, c.prototype.dblp = function(e) {
                    for(var t = this, r = 0; r < e; r++)t = t.dbl();
                    return t;
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        407: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, o.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), a(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
                }
                function c(e, t, r, n, s) {
                    o.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = s && new i(s, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
                }
                s(l, o), t.exports = l, l.prototype._mulA = function(e) {
                    return this.mOneA ? e.redNeg() : this.a.redMul(e);
                }, l.prototype._mulC = function(e) {
                    return this.oneC ? e : this.c.redMul(e);
                }, l.prototype.jpoint = function(e, t, r, n) {
                    return this.point(e, t, r, n);
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = this.c2.redSub(this.a.redMul(r)), s = this.one.redSub(this.c2.redMul(this.d).redMul(r)), o = n.redMul(s.redInvm()), a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    var l = a.fromRed().isOdd();
                    return (t && !l || !t && l) && (a = a.redNeg()), this.point(e, a);
                }, l.prototype.pointFromY = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = r.redSub(this.c2), s = r.redMul(this.d).redMul(this.c2).redSub(this.a), o = n.redMul(s.redInvm());
                    if (0 === o.cmp(this.zero)) {
                        if (t) throw new Error("invalid point");
                        return this.point(this.zero, e);
                    }
                    var a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    return a.fromRed().isOdd() !== t && (a = a.redNeg()), this.point(a, e);
                }, l.prototype.validate = function(e) {
                    if (e.isInfinity()) return !0;
                    e.normalize();
                    var t = e.x.redSqr(), r = e.y.redSqr(), n = t.redMul(this.a).redAdd(r), i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
                    return 0 === n.cmp(i);
                }, s(c, o.BasePoint), l.prototype.pointFromJSON = function(e) {
                    return c.fromJSON(this, e);
                }, l.prototype.point = function(e, t, r, n) {
                    return new c(this, e, t, r, n);
                }, c.fromJSON = function(e, t) {
                    return new c(e, t[0], t[1], t[2]);
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
                }, c.prototype._extDbl = function() {
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr();
                    r = r.redIAdd(r);
                    var n = this.curve._mulA(e), i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t), s = n.redAdd(t), o = s.redSub(r), a = n.redSub(t), l = i.redMul(o), c = s.redMul(a), u = i.redMul(a), h = o.redMul(s);
                    return this.curve.point(l, c, h, u);
                }, c.prototype._projDbl = function() {
                    var e, t, r, n, i, s, o = this.x.redAdd(this.y).redSqr(), a = this.x.redSqr(), l = this.y.redSqr();
                    if (this.curve.twisted) {
                        var c = (n = this.curve._mulA(a)).redAdd(l);
                        this.zOne ? (e = o.redSub(a).redSub(l).redMul(c.redSub(this.curve.two)), t = c.redMul(n.redSub(l)), r = c.redSqr().redSub(c).redSub(c)) : (i = this.z.redSqr(), s = c.redSub(i).redISub(i), e = o.redSub(a).redISub(l).redMul(s), t = c.redMul(n.redSub(l)), r = c.redMul(s));
                    } else n = a.redAdd(l), i = this.curve._mulC(this.z).redSqr(), s = n.redSub(i).redSub(i), e = this.curve._mulC(o.redISub(n)).redMul(s), t = this.curve._mulC(n).redMul(a.redISub(l)), r = n.redMul(s);
                    return this.curve.point(e, t, r);
                }, c.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
                }, c.prototype._extAdd = function(e) {
                    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)), r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)), n = this.t.redMul(this.curve.dd).redMul(e.t), i = this.z.redMul(e.z.redAdd(e.z)), s = r.redSub(t), o = i.redSub(n), a = i.redAdd(n), l = r.redAdd(t), c = s.redMul(o), u = a.redMul(l), h = s.redMul(l), f = o.redMul(a);
                    return this.curve.point(c, u, f, h);
                }, c.prototype._projAdd = function(e) {
                    var t, r, n = this.z.redMul(e.z), i = n.redSqr(), s = this.x.redMul(e.x), o = this.y.redMul(e.y), a = this.curve.d.redMul(s).redMul(o), l = i.redSub(a), c = i.redAdd(a), u = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(s).redISub(o), h = n.redMul(l).redMul(u);
                    return this.curve.twisted ? (t = n.redMul(c).redMul(o.redSub(this.curve._mulA(s))), r = l.redMul(c)) : (t = n.redMul(c).redMul(o.redSub(s)), r = this.curve._mulC(l).redMul(c)), this.curve.point(h, t, r);
                }, c.prototype.add = function(e) {
                    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
                }, c.prototype.mul = function(e) {
                    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !1);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !0);
                }, c.prototype.normalize = function() {
                    if (this.zOne) return this;
                    var e = this.z.redInvm();
                    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
                }, c.prototype.neg = function() {
                    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
                }, c.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.normalize(), this.y.fromRed();
                }, c.prototype.eq = function(e) {
                    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
                }, c.prototype.eqXToP = function(e) {
                    var t = e.toRed(this.curve.red).redMul(this.z);
                    if (0 === this.x.cmp(t)) return !0;
                    for(var r = e.clone(), n = this.curve.redN.redMul(this.z);;){
                        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
                        if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
                    }
                }, c.prototype.toP = c.prototype.normalize, c.prototype.mixedAdd = c.prototype.add;
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        408: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.base = e("./base"), n.short = e("./short"), n.mont = e("./mont"), n.edwards = e("./edwards");
            },
            {
                "./base": 406,
                "./edwards": 407,
                "./mont": 409,
                "./short": 410
            }
        ],
        409: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("inherits"), s = e("./base"), o = e("../utils");
                function a(e) {
                    s.call(this, "mont", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
                }
                function l(e, t, r) {
                    s.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(t, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
                }
                i(a, s), t.exports = a, a.prototype.validate = function(e) {
                    var t = e.normalize().x, r = t.redSqr(), n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
                    return 0 === n.redSqrt().redSqr().cmp(n);
                }, i(l, s.BasePoint), a.prototype.decodePoint = function(e, t) {
                    return this.point(o.toArray(e, t), 1);
                }, a.prototype.point = function(e, t) {
                    return new l(this, e, t);
                }, a.prototype.pointFromJSON = function(e) {
                    return l.fromJSON(this, e);
                }, l.prototype.precompute = function() {}, l.prototype._encode = function() {
                    return this.getX().toArray("be", this.curve.p.byteLength());
                }, l.fromJSON = function(e, t) {
                    return new l(e, t[0], t[1] || e.one);
                }, l.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, l.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                }, l.prototype.dbl = function() {
                    var e = this.x.redAdd(this.z).redSqr(), t = this.x.redSub(this.z).redSqr(), r = e.redSub(t), n = e.redMul(t), i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
                    return this.curve.point(n, i);
                }, l.prototype.add = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.diffAdd = function(e, t) {
                    var r = this.x.redAdd(this.z), n = this.x.redSub(this.z), i = e.x.redAdd(e.z), s = e.x.redSub(e.z).redMul(r), o = i.redMul(n), a = t.z.redMul(s.redAdd(o).redSqr()), l = t.x.redMul(s.redISub(o).redSqr());
                    return this.curve.point(a, l);
                }, l.prototype.mul = function(e) {
                    for(var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1))i.push(t.andln(1));
                    for(var s = i.length - 1; s >= 0; s--)0 === i[s] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
                    return n;
                }, l.prototype.mulAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.jumlAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.eq = function(e) {
                    return 0 === this.getX().cmp(e.getX());
                }, l.prototype.normalize = function() {
                    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
                }, l.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        410: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    o.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
                }
                function c(e, t, r, n) {
                    o.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
                }
                function u(e, t, r, n) {
                    o.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
                }
                s(l, o), t.exports = l, l.prototype._getEndomorphism = function(e) {
                    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
                        var t, r;
                        if (e.beta) t = new i(e.beta, 16).toRed(this.red);
                        else {
                            var n = this._getEndoRoots(this.p);
                            t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
                        }
                        if (e.lambda) r = new i(e.lambda, 16);
                        else {
                            var s = this._getEndoRoots(this.n);
                            0 === this.g.mul(s[0]).x.cmp(this.g.x.redMul(t)) ? r = s[0] : (r = s[1], a(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
                        }
                        return {
                            beta: t,
                            lambda: r,
                            basis: e.basis ? e.basis.map(function(e) {
                                return {
                                    a: new i(e.a, 16),
                                    b: new i(e.b, 16)
                                };
                            }) : this._getEndoBasis(r)
                        };
                    }
                }, l.prototype._getEndoRoots = function(e) {
                    var t = e === this.p ? this.red : i.mont(e), r = new i(2).toRed(t).redInvm(), n = r.redNeg(), s = new i(3).toRed(t).redNeg().redSqrt().redMul(r);
                    return [
                        n.redAdd(s).fromRed(),
                        n.redSub(s).fromRed()
                    ];
                }, l.prototype._getEndoBasis = function(e) {
                    for(var t, r, n, s, o, a, l, c, u, h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), f = e, d = this.n.clone(), p = new i(1), m = new i(0), b = new i(0), g = new i(1), y = 0; 0 !== f.cmpn(0);){
                        var v = d.div(f);
                        c = d.sub(v.mul(f)), u = b.sub(v.mul(p));
                        var w = g.sub(v.mul(m));
                        if (!n && c.cmp(h) < 0) t = l.neg(), r = p, n = c.neg(), s = u;
                        else if (n && 2 == ++y) break;
                        l = c, d = f, f = c, b = p, p = u, g = m, m = w;
                    }
                    o = c.neg(), a = u;
                    var _ = n.sqr().add(s.sqr());
                    return o.sqr().add(a.sqr()).cmp(_) >= 0 && (o = t, a = r), n.negative && (n = n.neg(), s = s.neg()), o.negative && (o = o.neg(), a = a.neg()), [
                        {
                            a: n,
                            b: s
                        },
                        {
                            a: o,
                            b: a
                        }
                    ];
                }, l.prototype._endoSplit = function(e) {
                    var t = this.endo.basis, r = t[0], n = t[1], i = n.b.mul(e).divRound(this.n), s = r.b.neg().mul(e).divRound(this.n), o = i.mul(r.a), a = s.mul(n.a), l = i.mul(r.b), c = s.mul(n.b);
                    return {
                        k1: e.sub(o).sub(a),
                        k2: l.add(c).neg()
                    };
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), n = r.redSqrt();
                    if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
                    var s = n.fromRed().isOdd();
                    return (t && !s || !t && s) && (n = n.redNeg()), this.point(e, n);
                }, l.prototype.validate = function(e) {
                    if (e.inf) return !0;
                    var t = e.x, r = e.y, n = this.a.redMul(t), i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
                    return 0 === r.redSqr().redISub(i).cmpn(0);
                }, l.prototype._endoWnafMulAdd = function(e, t, r) {
                    for(var n = this._endoWnafT1, i = this._endoWnafT2, s = 0; s < e.length; s++){
                        var o = this._endoSplit(t[s]), a = e[s], l = a._getBeta();
                        o.k1.negative && (o.k1.ineg(), a = a.neg(!0)), o.k2.negative && (o.k2.ineg(), l = l.neg(!0)), n[2 * s] = a, n[2 * s + 1] = l, i[2 * s] = o.k1, i[2 * s + 1] = o.k2;
                    }
                    for(var c = this._wnafMulAdd(1, n, i, 2 * s, r), u = 0; u < 2 * s; u++)n[u] = null, i[u] = null;
                    return c;
                }, s(c, o.BasePoint), l.prototype.point = function(e, t, r) {
                    return new c(this, e, t, r);
                }, l.prototype.pointFromJSON = function(e, t) {
                    return c.fromJSON(this, e, t);
                }, c.prototype._getBeta = function() {
                    if (this.curve.endo) {
                        var e = this.precomputed;
                        if (e && e.beta) return e.beta;
                        var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
                        if (e) {
                            var r = this.curve, n = function(e) {
                                return r.point(e.x.redMul(r.endo.beta), e.y);
                            };
                            e.beta = t, t.precomputed = {
                                beta: null,
                                naf: e.naf && {
                                    wnd: e.naf.wnd,
                                    points: e.naf.points.map(n)
                                },
                                doubles: e.doubles && {
                                    step: e.doubles.step,
                                    points: e.doubles.points.map(n)
                                }
                            };
                        }
                        return t;
                    }
                }, c.prototype.toJSON = function() {
                    return this.precomputed ? [
                        this.x,
                        this.y,
                        this.precomputed && {
                            doubles: this.precomputed.doubles && {
                                step: this.precomputed.doubles.step,
                                points: this.precomputed.doubles.points.slice(1)
                            },
                            naf: this.precomputed.naf && {
                                wnd: this.precomputed.naf.wnd,
                                points: this.precomputed.naf.points.slice(1)
                            }
                        }
                    ] : [
                        this.x,
                        this.y
                    ];
                }, c.fromJSON = function(e, t, r) {
                    "string" == typeof t && (t = JSON.parse(t));
                    var n = e.point(t[0], t[1], r);
                    if (!t[2]) return n;
                    function i(t) {
                        return e.point(t[0], t[1], r);
                    }
                    var s = t[2];
                    return n.precomputed = {
                        beta: null,
                        doubles: s.doubles && {
                            step: s.doubles.step,
                            points: [
                                n
                            ].concat(s.doubles.points.map(i))
                        },
                        naf: s.naf && {
                            wnd: s.naf.wnd,
                            points: [
                                n
                            ].concat(s.naf.points.map(i))
                        }
                    }, n;
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return this.inf;
                }, c.prototype.add = function(e) {
                    if (this.inf) return e;
                    if (e.inf) return this;
                    if (this.eq(e)) return this.dbl();
                    if (this.neg().eq(e)) return this.curve.point(null, null);
                    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
                    var t = this.y.redSub(e.y);
                    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
                    var r = t.redSqr().redISub(this.x).redISub(e.x), n = t.redMul(this.x.redSub(r)).redISub(this.y);
                    return this.curve.point(r, n);
                }, c.prototype.dbl = function() {
                    if (this.inf) return this;
                    var e = this.y.redAdd(this.y);
                    if (0 === e.cmpn(0)) return this.curve.point(null, null);
                    var t = this.curve.a, r = this.x.redSqr(), n = e.redInvm(), i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n), s = i.redSqr().redISub(this.x.redAdd(this.x)), o = i.redMul(this.x.redSub(s)).redISub(this.y);
                    return this.curve.point(s, o);
                }, c.prototype.getX = function() {
                    return this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.y.fromRed();
                }, c.prototype.mul = function(e) {
                    return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([
                        this
                    ], [
                        e
                    ]) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
                }, c.prototype.eq = function(e) {
                    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
                }, c.prototype.neg = function(e) {
                    if (this.inf) return this;
                    var t = this.curve.point(this.x, this.y.redNeg());
                    if (e && this.precomputed) {
                        var r = this.precomputed, n = function(e) {
                            return e.neg();
                        };
                        t.precomputed = {
                            naf: r.naf && {
                                wnd: r.naf.wnd,
                                points: r.naf.points.map(n)
                            },
                            doubles: r.doubles && {
                                step: r.doubles.step,
                                points: r.doubles.points.map(n)
                            }
                        };
                    }
                    return t;
                }, c.prototype.toJ = function() {
                    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
                }, s(u, o.BasePoint), l.prototype.jpoint = function(e, t, r) {
                    return new u(this, e, t, r);
                }, u.prototype.toP = function() {
                    if (this.isInfinity()) return this.curve.point(null, null);
                    var e = this.z.redInvm(), t = e.redSqr(), r = this.x.redMul(t), n = this.y.redMul(t).redMul(e);
                    return this.curve.point(r, n);
                }, u.prototype.neg = function() {
                    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
                }, u.prototype.add = function(e) {
                    if (this.isInfinity()) return e;
                    if (e.isInfinity()) return this;
                    var t = e.z.redSqr(), r = this.z.redSqr(), n = this.x.redMul(t), i = e.x.redMul(r), s = this.y.redMul(t.redMul(e.z)), o = e.y.redMul(r.redMul(this.z)), a = n.redSub(i), l = s.redSub(o);
                    if (0 === a.cmpn(0)) return 0 !== l.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var c = a.redSqr(), u = c.redMul(a), h = n.redMul(c), f = l.redSqr().redIAdd(u).redISub(h).redISub(h), d = l.redMul(h.redISub(f)).redISub(s.redMul(u)), p = this.z.redMul(e.z).redMul(a);
                    return this.curve.jpoint(f, d, p);
                }, u.prototype.mixedAdd = function(e) {
                    if (this.isInfinity()) return e.toJ();
                    if (e.isInfinity()) return this;
                    var t = this.z.redSqr(), r = this.x, n = e.x.redMul(t), i = this.y, s = e.y.redMul(t).redMul(this.z), o = r.redSub(n), a = i.redSub(s);
                    if (0 === o.cmpn(0)) return 0 !== a.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var l = o.redSqr(), c = l.redMul(o), u = r.redMul(l), h = a.redSqr().redIAdd(c).redISub(u).redISub(u), f = a.redMul(u.redISub(h)).redISub(i.redMul(c)), d = this.z.redMul(o);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.dblp = function(e) {
                    if (0 === e) return this;
                    if (this.isInfinity()) return this;
                    if (!e) return this.dbl();
                    var t;
                    if (this.curve.zeroA || this.curve.threeA) {
                        var r = this;
                        for(t = 0; t < e; t++)r = r.dbl();
                        return r;
                    }
                    var n = this.curve.a, i = this.curve.tinv, s = this.x, o = this.y, a = this.z, l = a.redSqr().redSqr(), c = o.redAdd(o);
                    for(t = 0; t < e; t++){
                        var u = s.redSqr(), h = c.redSqr(), f = h.redSqr(), d = u.redAdd(u).redIAdd(u).redIAdd(n.redMul(l)), p = s.redMul(h), m = d.redSqr().redISub(p.redAdd(p)), b = p.redISub(m), g = d.redMul(b);
                        g = g.redIAdd(g).redISub(f);
                        var y = c.redMul(a);
                        t + 1 < e && (l = l.redMul(f)), s = m, a = y, c = g;
                    }
                    return this.curve.jpoint(s, c.redMul(i), a);
                }, u.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
                }, u.prototype._zeroDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n), l = a.redSqr().redISub(o).redISub(o), c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), e = l, t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.x.redSqr(), h = this.y.redSqr(), f = h.redSqr(), d = this.x.redAdd(h).redSqr().redISub(u).redISub(f);
                        d = d.redIAdd(d);
                        var p = u.redAdd(u).redIAdd(u), m = p.redSqr(), b = f.redIAdd(f);
                        b = (b = b.redIAdd(b)).redIAdd(b), e = m.redISub(d).redISub(d), t = p.redMul(d.redISub(e)).redISub(b), r = (r = this.y.redMul(this.z)).redIAdd(r);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._threeDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), l = a.redSqr().redISub(o).redISub(o);
                        e = l;
                        var c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.z.redSqr(), h = this.y.redSqr(), f = this.x.redMul(h), d = this.x.redSub(u).redMul(this.x.redAdd(u));
                        d = d.redAdd(d).redIAdd(d);
                        var p = f.redIAdd(f), m = (p = p.redIAdd(p)).redAdd(p);
                        e = d.redSqr().redISub(m), r = this.y.redAdd(this.z).redSqr().redISub(h).redISub(u);
                        var b = h.redSqr();
                        b = (b = (b = b.redIAdd(b)).redIAdd(b)).redIAdd(b), t = d.redMul(p.redISub(e)).redISub(b);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._dbl = function() {
                    var e = this.curve.a, t = this.x, r = this.y, n = this.z, i = n.redSqr().redSqr(), s = t.redSqr(), o = r.redSqr(), a = s.redAdd(s).redIAdd(s).redIAdd(e.redMul(i)), l = t.redAdd(t), c = (l = l.redIAdd(l)).redMul(o), u = a.redSqr().redISub(c.redAdd(c)), h = c.redISub(u), f = o.redSqr();
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = a.redMul(h).redISub(f), p = r.redAdd(r).redMul(n);
                    return this.curve.jpoint(u, d, p);
                }, u.prototype.trpl = function() {
                    if (!this.curve.zeroA) return this.dbl().add(this);
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr(), n = t.redSqr(), i = e.redAdd(e).redIAdd(e), s = i.redSqr(), o = this.x.redAdd(t).redSqr().redISub(e).redISub(n), a = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(s)).redSqr(), l = n.redIAdd(n);
                    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
                    var c = i.redIAdd(o).redSqr().redISub(s).redISub(a).redISub(l), u = t.redMul(c);
                    u = (u = u.redIAdd(u)).redIAdd(u);
                    var h = this.x.redMul(a).redISub(u);
                    h = (h = h.redIAdd(h)).redIAdd(h);
                    var f = this.y.redMul(c.redMul(l.redISub(c)).redISub(o.redMul(a)));
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = this.z.redAdd(o).redSqr().redISub(r).redISub(a);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.mul = function(e, t) {
                    return e = new i(e, t), this.curve._wnafMul(this, e);
                }, u.prototype.eq = function(e) {
                    if ("affine" === e.type) return this.eq(e.toJ());
                    if (this === e) return !0;
                    var t = this.z.redSqr(), r = e.z.redSqr();
                    if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
                    var n = t.redMul(this.z), i = r.redMul(e.z);
                    return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
                }, u.prototype.eqXToP = function(e) {
                    var t = this.z.redSqr(), r = e.toRed(this.curve.red).redMul(t);
                    if (0 === this.x.cmp(r)) return !0;
                    for(var n = e.clone(), i = this.curve.redN.redMul(t);;){
                        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
                        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
                    }
                }, u.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
                }, u.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        411: [
            function(e, t, r) {
                "use strict";
                var n, i = r, s = e("hash.js"), o = e("./curve"), a = e("./utils").assert;
                function l(e) {
                    "short" === e.type ? this.curve = new o.short(e) : "edwards" === e.type ? this.curve = new o.edwards(e) : this.curve = new o.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
                }
                function c(e, t) {
                    Object.defineProperty(i, e, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            var r = new l(t);
                            return Object.defineProperty(i, e, {
                                configurable: !0,
                                enumerable: !0,
                                value: r
                            }), r;
                        }
                    });
                }
                i.PresetCurve = l, c("p192", {
                    type: "short",
                    prime: "p192",
                    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
                    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
                    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
                        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
                    ]
                }), c("p224", {
                    type: "short",
                    prime: "p224",
                    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
                    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
                    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
                        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
                    ]
                }), c("p256", {
                    type: "short",
                    prime: null,
                    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
                    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
                    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
                    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
                        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
                    ]
                }), c("p384", {
                    type: "short",
                    prime: null,
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
                    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
                    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
                    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
                    hash: s.sha384,
                    gRed: !1,
                    g: [
                        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
                        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
                    ]
                }), c("p521", {
                    type: "short",
                    prime: null,
                    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
                    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
                    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
                    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
                    hash: s.sha512,
                    gRed: !1,
                    g: [
                        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
                        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
                    ]
                }), c("curve25519", {
                    type: "mont",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "76d06",
                    b: "1",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "9"
                    ]
                }), c("ed25519", {
                    type: "edwards",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "-1",
                    c: "1",
                    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
                        "6666666666666666666666666666666666666666666666666666666666666658"
                    ]
                });
                try {
                    n = e("./precomputed/secp256k1");
                } catch (e) {
                    n = void 0;
                }
                c("secp256k1", {
                    type: "short",
                    prime: "k256",
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
                    a: "0",
                    b: "7",
                    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
                    h: "1",
                    hash: s.sha256,
                    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
                    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
                    basis: [
                        {
                            a: "3086d221a7d46bcde86c90e49284eb15",
                            b: "-e4437ed6010e88286f547fa90abfe4c3"
                        },
                        {
                            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                            b: "3086d221a7d46bcde86c90e49284eb15"
                        }
                    ],
                    gRed: !1,
                    g: [
                        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
                        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
                        n
                    ]
                });
            },
            {
                "./curve": 408,
                "./precomputed/secp256k1": 418,
                "./utils": 419,
                "hash.js": 426
            }
        ],
        412: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("hmac-drbg"), s = e("../utils"), o = e("../curves"), a = e("brorand"), l = s.assert, c = e("./key"), u = e("./signature");
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    "string" == typeof e && (l(Object.prototype.hasOwnProperty.call(o, e), "Unknown curve " + e), e = o[e]), e instanceof o.PresetCurve && (e = {
                        curve: e
                    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
                }
                t.exports = h, h.prototype.keyPair = function(e) {
                    return new c(this, e);
                }, h.prototype.keyFromPrivate = function(e, t) {
                    return c.fromPrivate(this, e, t);
                }, h.prototype.keyFromPublic = function(e, t) {
                    return c.fromPublic(this, e, t);
                }, h.prototype.genKeyPair = function(e) {
                    e || (e = {});
                    for(var t = new i({
                        hash: this.hash,
                        pers: e.pers,
                        persEnc: e.persEnc || "utf8",
                        entropy: e.entropy || a(this.hash.hmacStrength),
                        entropyEnc: e.entropy && e.entropyEnc || "utf8",
                        nonce: this.n.toArray()
                    }), r = this.n.byteLength(), s = this.n.sub(new n(2));;){
                        var o = new n(t.generate(r));
                        if (!(o.cmp(s) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
                    }
                }, h.prototype._truncateToN = function(e, t) {
                    var r = 8 * e.byteLength() - this.n.bitLength();
                    return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
                }, h.prototype.sign = function(e, t, r, s) {
                    "object" == typeof r && (s = r, r = null), s || (s = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));
                    for(var o = this.n.byteLength(), a = t.getPrivate().toArray("be", o), l = e.toArray("be", o), c = new i({
                        hash: this.hash,
                        entropy: a,
                        nonce: l,
                        pers: s.pers,
                        persEnc: s.persEnc || "utf8"
                    }), h = this.n.sub(new n(1)), f = 0;; f++){
                        var d = s.k ? s.k(f) : new n(c.generate(this.n.byteLength()));
                        if (!((d = this._truncateToN(d, !0)).cmpn(1) <= 0 || d.cmp(h) >= 0)) {
                            var p = this.g.mul(d);
                            if (!p.isInfinity()) {
                                var m = p.getX(), b = m.umod(this.n);
                                if (0 !== b.cmpn(0)) {
                                    var g = d.invm(this.n).mul(b.mul(t.getPrivate()).iadd(e));
                                    if (0 !== (g = g.umod(this.n)).cmpn(0)) {
                                        var y = (p.getY().isOdd() ? 1 : 0) | (0 !== m.cmp(b) ? 2 : 0);
                                        return s.canonical && g.cmp(this.nh) > 0 && (g = this.n.sub(g), y ^= 1), new u({
                                            r: b,
                                            s: g,
                                            recoveryParam: y
                                        });
                                    }
                                }
                            }
                        }
                    }
                }, h.prototype.verify = function(e, t, r, i) {
                    e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
                    var s = (t = new u(t, "hex")).r, o = t.s;
                    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return !1;
                    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
                    var a, l = o.invm(this.n), c = l.mul(e).umod(this.n), h = l.mul(s).umod(this.n);
                    return this.curve._maxwellTrick ? !(a = this.g.jmulAdd(c, r.getPublic(), h)).isInfinity() && a.eqXToP(s) : !(a = this.g.mulAdd(c, r.getPublic(), h)).isInfinity() && 0 === a.getX().umod(this.n).cmp(s);
                }, h.prototype.recoverPubKey = function(e, t, r, i) {
                    l((3 & r) === r, "The recovery param is more than two bits"), t = new u(t, i);
                    var s = this.n, o = new n(e), a = t.r, c = t.s, h = 1 & r, f = r >> 1;
                    if (a.cmp(this.curve.p.umod(this.curve.n)) >= 0 && f) throw new Error("Unable to find sencond key candinate");
                    a = f ? this.curve.pointFromX(a.add(this.curve.n), h) : this.curve.pointFromX(a, h);
                    var d = t.r.invm(s), p = s.sub(o).mul(d).umod(s), m = c.mul(d).umod(s);
                    return this.g.mulAdd(p, a, m);
                }, h.prototype.getKeyRecoveryParam = function(e, t, r, n) {
                    if (null !== (t = new u(t, n)).recoveryParam) return t.recoveryParam;
                    for(var i = 0; i < 4; i++){
                        var s;
                        try {
                            s = this.recoverPubKey(e, t, i);
                        } catch (e) {
                            continue;
                        }
                        if (s.eq(r)) return i;
                    }
                    throw new Error("Unable to find valid recovery factor");
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 413,
                "./signature": 414,
                "bn.js": 420,
                brorand: 187,
                "hmac-drbg": 438
            }
        ],
        413: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils").assert;
                function s(e, t) {
                    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
                }
                t.exports = s, s.fromPublic = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        pub: t,
                        pubEnc: r
                    });
                }, s.fromPrivate = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        priv: t,
                        privEnc: r
                    });
                }, s.prototype.validate = function() {
                    var e = this.getPublic();
                    return e.isInfinity() ? {
                        result: !1,
                        reason: "Invalid public key"
                    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
                        result: !0,
                        reason: null
                    } : {
                        result: !1,
                        reason: "Public key * N != O"
                    } : {
                        result: !1,
                        reason: "Public key is not a point"
                    };
                }, s.prototype.getPublic = function(e, t) {
                    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
                }, s.prototype.getPrivate = function(e) {
                    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
                }, s.prototype._importPrivate = function(e, t) {
                    this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
                }, s.prototype._importPublic = function(e, t) {
                    if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
                    this.pub = this.ec.curve.decodePoint(e, t);
                }, s.prototype.derive = function(e) {
                    return e.validate() || i(e.validate(), "public point not validated"), e.mul(this.priv).getX();
                }, s.prototype.sign = function(e, t, r) {
                    return this.ec.sign(e, this, t, r);
                }, s.prototype.verify = function(e, t) {
                    return this.ec.verify(e, t, this);
                }, s.prototype.inspect = function() {
                    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        414: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert;
                function o(e, t) {
                    if (e instanceof o) return e;
                    this._importDER(e, t) || (s(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
                }
                function a() {
                    this.place = 0;
                }
                function l(e, t) {
                    var r = e[t.place++];
                    if (!(128 & r)) return r;
                    var n = 15 & r;
                    if (0 === n || n > 4) return !1;
                    for(var i = 0, s = 0, o = t.place; s < n; s++, o++)i <<= 8, i |= e[o], i >>>= 0;
                    return !(i <= 127) && (t.place = o, i);
                }
                function c(e) {
                    for(var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;)t++;
                    return 0 === t ? e : e.slice(t);
                }
                function u(e, t) {
                    if (t < 128) e.push(t);
                    else {
                        var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
                        for(e.push(128 | r); --r;)e.push(t >>> (r << 3) & 255);
                        e.push(t);
                    }
                }
                t.exports = o, o.prototype._importDER = function(e, t) {
                    e = i.toArray(e, t);
                    var r = new a;
                    if (48 !== e[r.place++]) return !1;
                    var s = l(e, r);
                    if (!1 === s) return !1;
                    if (s + r.place !== e.length) return !1;
                    if (2 !== e[r.place++]) return !1;
                    var o = l(e, r);
                    if (!1 === o) return !1;
                    var c = e.slice(r.place, o + r.place);
                    if (r.place += o, 2 !== e[r.place++]) return !1;
                    var u = l(e, r);
                    if (!1 === u) return !1;
                    if (e.length !== u + r.place) return !1;
                    var h = e.slice(r.place, u + r.place);
                    if (0 === c[0]) {
                        if (!(128 & c[1])) return !1;
                        c = c.slice(1);
                    }
                    if (0 === h[0]) {
                        if (!(128 & h[1])) return !1;
                        h = h.slice(1);
                    }
                    return this.r = new n(c), this.s = new n(h), this.recoveryParam = null, !0;
                }, o.prototype.toDER = function(e) {
                    var t = this.r.toArray(), r = this.s.toArray();
                    for(128 & t[0] && (t = [
                        0
                    ].concat(t)), 128 & r[0] && (r = [
                        0
                    ].concat(r)), t = c(t), r = c(r); !(r[0] || 128 & r[1]);)r = r.slice(1);
                    var n = [
                        2
                    ];
                    u(n, t.length), (n = n.concat(t)).push(2), u(n, r.length);
                    var s = n.concat(r), o = [
                        48
                    ];
                    return u(o, s.length), o = o.concat(s), i.encode(o, e);
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        415: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("../curves"), s = e("../utils"), o = s.assert, a = s.parseBytes, l = e("./key"), c = e("./signature");
                function u(e) {
                    if (o("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof u)) return new u(e);
                    e = i[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
                }
                t.exports = u, u.prototype.sign = function(e, t) {
                    e = a(e);
                    var r = this.keyFromSecret(t), n = this.hashInt(r.messagePrefix(), e), i = this.g.mul(n), s = this.encodePoint(i), o = this.hashInt(s, r.pubBytes(), e).mul(r.priv()), l = n.add(o).umod(this.curve.n);
                    return this.makeSignature({
                        R: i,
                        S: l,
                        Rencoded: s
                    });
                }, u.prototype.verify = function(e, t, r) {
                    e = a(e), t = this.makeSignature(t);
                    var n = this.keyFromPublic(r), i = this.hashInt(t.Rencoded(), n.pubBytes(), e), s = this.g.mul(t.S());
                    return t.R().add(n.pub().mul(i)).eq(s);
                }, u.prototype.hashInt = function() {
                    for(var e = this.hash(), t = 0; t < arguments.length; t++)e.update(arguments[t]);
                    return s.intFromLE(e.digest()).umod(this.curve.n);
                }, u.prototype.keyFromPublic = function(e) {
                    return l.fromPublic(this, e);
                }, u.prototype.keyFromSecret = function(e) {
                    return l.fromSecret(this, e);
                }, u.prototype.makeSignature = function(e) {
                    return e instanceof c ? e : new c(this, e);
                }, u.prototype.encodePoint = function(e) {
                    var t = e.getY().toArray("le", this.encodingLength);
                    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
                }, u.prototype.decodePoint = function(e) {
                    var t = (e = s.parseBytes(e)).length - 1, r = e.slice(0, t).concat(-129 & e[t]), n = 0 != (128 & e[t]), i = s.intFromLE(r);
                    return this.curve.pointFromY(i, n);
                }, u.prototype.encodeInt = function(e) {
                    return e.toArray("le", this.encodingLength);
                }, u.prototype.decodeInt = function(e) {
                    return s.intFromLE(e);
                }, u.prototype.isPoint = function(e) {
                    return e instanceof this.pointClass;
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 416,
                "./signature": 417,
                "hash.js": 426
            }
        ],
        416: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = n.assert, s = n.parseBytes, o = n.cachedProperty;
                function a(e, t) {
                    this.eddsa = e, this._secret = s(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = s(t.pub);
                }
                a.fromPublic = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        pub: t
                    });
                }, a.fromSecret = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        secret: t
                    });
                }, a.prototype.secret = function() {
                    return this._secret;
                }, o(a, "pubBytes", function() {
                    return this.eddsa.encodePoint(this.pub());
                }), o(a, "pub", function() {
                    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
                }), o(a, "privBytes", function() {
                    var e = this.eddsa, t = this.hash(), r = e.encodingLength - 1, n = t.slice(0, e.encodingLength);
                    return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
                }), o(a, "priv", function() {
                    return this.eddsa.decodeInt(this.privBytes());
                }), o(a, "hash", function() {
                    return this.eddsa.hash().update(this.secret()).digest();
                }), o(a, "messagePrefix", function() {
                    return this.hash().slice(this.eddsa.encodingLength);
                }), a.prototype.sign = function(e) {
                    return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
                }, a.prototype.verify = function(e, t) {
                    return this.eddsa.verify(e, t, this);
                }, a.prototype.getSecret = function(e) {
                    return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
                }, a.prototype.getPublic = function(e) {
                    return n.encode(this.pubBytes(), e);
                }, t.exports = a;
            },
            {
                "../utils": 419
            }
        ],
        417: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert, o = i.cachedProperty, a = i.parseBytes;
                function l(e, t) {
                    this.eddsa = e, "object" != typeof t && (t = a(t)), Array.isArray(t) && (t = {
                        R: t.slice(0, e.encodingLength),
                        S: t.slice(e.encodingLength)
                    }), s(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
                }
                o(l, "S", function() {
                    return this.eddsa.decodeInt(this.Sencoded());
                }), o(l, "R", function() {
                    return this.eddsa.decodePoint(this.Rencoded());
                }), o(l, "Rencoded", function() {
                    return this.eddsa.encodePoint(this.R());
                }), o(l, "Sencoded", function() {
                    return this.eddsa.encodeInt(this.S());
                }), l.prototype.toBytes = function() {
                    return this.Rencoded().concat(this.Sencoded());
                }, l.prototype.toHex = function() {
                    return i.encode(this.toBytes(), "hex").toUpperCase();
                }, t.exports = l;
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        418: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    doubles: {
                        step: 4,
                        points: [
                            [
                                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
                            ],
                            [
                                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
                            ],
                            [
                                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
                            ],
                            [
                                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
                            ],
                            [
                                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
                            ],
                            [
                                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
                            ],
                            [
                                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
                            ],
                            [
                                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
                            ],
                            [
                                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
                            ],
                            [
                                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
                            ],
                            [
                                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
                            ],
                            [
                                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
                            ],
                            [
                                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
                            ],
                            [
                                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
                            ],
                            [
                                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
                            ],
                            [
                                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
                            ],
                            [
                                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
                            ],
                            [
                                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
                            ],
                            [
                                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
                            ],
                            [
                                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
                            ],
                            [
                                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
                            ],
                            [
                                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
                            ],
                            [
                                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
                            ],
                            [
                                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
                            ],
                            [
                                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
                            ],
                            [
                                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
                            ],
                            [
                                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
                            ],
                            [
                                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
                            ],
                            [
                                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
                            ],
                            [
                                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
                            ],
                            [
                                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
                            ],
                            [
                                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
                            ],
                            [
                                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
                            ],
                            [
                                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
                            ],
                            [
                                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
                            ],
                            [
                                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
                            ],
                            [
                                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
                            ],
                            [
                                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
                            ],
                            [
                                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
                            ],
                            [
                                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
                            ],
                            [
                                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
                            ],
                            [
                                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
                            ],
                            [
                                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
                            ],
                            [
                                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
                            ],
                            [
                                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
                            ],
                            [
                                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
                            ],
                            [
                                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
                            ],
                            [
                                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
                            ],
                            [
                                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
                            ],
                            [
                                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
                            ],
                            [
                                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
                            ],
                            [
                                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
                            ],
                            [
                                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
                            ],
                            [
                                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
                            ],
                            [
                                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
                            ],
                            [
                                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
                            ],
                            [
                                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
                            ],
                            [
                                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
                            ],
                            [
                                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
                            ],
                            [
                                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
                            ],
                            [
                                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
                            ],
                            [
                                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
                            ],
                            [
                                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
                            ],
                            [
                                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
                            ],
                            [
                                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
                            ]
                        ]
                    },
                    naf: {
                        wnd: 7,
                        points: [
                            [
                                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
                            ],
                            [
                                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
                            ],
                            [
                                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
                            ],
                            [
                                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
                            ],
                            [
                                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
                            ],
                            [
                                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
                            ],
                            [
                                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
                            ],
                            [
                                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
                            ],
                            [
                                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
                            ],
                            [
                                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
                            ],
                            [
                                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
                            ],
                            [
                                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
                            ],
                            [
                                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
                            ],
                            [
                                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
                            ],
                            [
                                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
                            ],
                            [
                                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
                            ],
                            [
                                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
                            ],
                            [
                                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
                            ],
                            [
                                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
                            ],
                            [
                                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
                            ],
                            [
                                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
                            ],
                            [
                                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
                            ],
                            [
                                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
                            ],
                            [
                                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
                            ],
                            [
                                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
                            ],
                            [
                                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
                            ],
                            [
                                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
                            ],
                            [
                                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
                            ],
                            [
                                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
                            ],
                            [
                                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
                            ],
                            [
                                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
                            ],
                            [
                                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
                            ],
                            [
                                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
                            ],
                            [
                                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
                            ],
                            [
                                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
                            ],
                            [
                                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
                            ],
                            [
                                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
                            ],
                            [
                                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
                            ],
                            [
                                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
                            ],
                            [
                                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
                            ],
                            [
                                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
                            ],
                            [
                                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
                            ],
                            [
                                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
                            ],
                            [
                                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
                            ],
                            [
                                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
                            ],
                            [
                                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
                            ],
                            [
                                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
                            ],
                            [
                                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
                            ],
                            [
                                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
                            ],
                            [
                                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
                            ],
                            [
                                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
                            ],
                            [
                                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
                            ],
                            [
                                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
                            ],
                            [
                                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
                            ],
                            [
                                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
                            ],
                            [
                                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
                            ],
                            [
                                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
                            ],
                            [
                                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
                            ],
                            [
                                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
                            ],
                            [
                                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
                            ],
                            [
                                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
                            ],
                            [
                                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
                            ],
                            [
                                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
                            ],
                            [
                                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
                            ],
                            [
                                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
                            ],
                            [
                                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
                            ],
                            [
                                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
                            ],
                            [
                                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
                            ],
                            [
                                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
                            ],
                            [
                                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
                            ],
                            [
                                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
                            ],
                            [
                                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
                            ],
                            [
                                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
                            ],
                            [
                                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
                            ],
                            [
                                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
                            ],
                            [
                                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
                            ],
                            [
                                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
                            ],
                            [
                                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
                            ],
                            [
                                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
                            ],
                            [
                                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
                            ],
                            [
                                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
                            ],
                            [
                                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
                            ],
                            [
                                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
                            ],
                            [
                                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
                            ],
                            [
                                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
                            ],
                            [
                                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
                            ],
                            [
                                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
                            ],
                            [
                                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
                            ],
                            [
                                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
                            ],
                            [
                                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
                            ],
                            [
                                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
                            ],
                            [
                                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
                            ],
                            [
                                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
                            ],
                            [
                                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
                            ],
                            [
                                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
                            ],
                            [
                                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
                            ],
                            [
                                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
                            ],
                            [
                                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
                            ],
                            [
                                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
                            ],
                            [
                                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
                            ],
                            [
                                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
                            ],
                            [
                                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
                            ],
                            [
                                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
                            ],
                            [
                                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
                            ],
                            [
                                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
                            ],
                            [
                                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
                            ],
                            [
                                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
                            ],
                            [
                                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
                            ],
                            [
                                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
                            ],
                            [
                                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
                            ],
                            [
                                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
                            ],
                            [
                                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
                            ],
                            [
                                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
                            ],
                            [
                                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
                            ],
                            [
                                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
                            ],
                            [
                                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
                            ],
                            [
                                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
                            ],
                            [
                                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
                            ],
                            [
                                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
                            ],
                            [
                                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
                            ],
                            [
                                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
                            ],
                            [
                                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
                            ],
                            [
                                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
                            ],
                            [
                                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
                            ],
                            [
                                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
                            ],
                            [
                                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
                            ],
                            [
                                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
                            ]
                        ]
                    }
                };
            },
            {}
        ],
        419: [
            function(e, t, r) {
                "use strict";
                var n = r, i = e("bn.js"), s = e("minimalistic-assert"), o = e("minimalistic-crypto-utils");
                n.assert = s, n.toArray = o.toArray, n.zero2 = o.zero2, n.toHex = o.toHex, n.encode = o.encode, n.getNAF = function(e, t, r) {
                    var n = new Array(Math.max(e.bitLength(), r) + 1);
                    n.fill(0);
                    for(var i = 1 << t + 1, s = e.clone(), o = 0; o < n.length; o++){
                        var a, l = s.andln(i - 1);
                        s.isOdd() ? (a = l > (i >> 1) - 1 ? (i >> 1) - l : l, s.isubn(a)) : a = 0, n[o] = a, s.iushrn(1);
                    }
                    return n;
                }, n.getJSF = function(e, t) {
                    var r = [
                        [],
                        []
                    ];
                    e = e.clone(), t = t.clone();
                    for(var n, i = 0, s = 0; e.cmpn(-i) > 0 || t.cmpn(-s) > 0;){
                        var o, a, l = e.andln(3) + i & 3, c = t.andln(3) + s & 3;
                        3 === l && (l = -1), 3 === c && (c = -1), o = 0 == (1 & l) ? 0 : 3 !== (n = e.andln(7) + i & 7) && 5 !== n || 2 !== c ? l : -l, r[0].push(o), a = 0 == (1 & c) ? 0 : 3 !== (n = t.andln(7) + s & 7) && 5 !== n || 2 !== l ? c : -c, r[1].push(a), 2 * i === o + 1 && (i = 1 - i), 2 * s === a + 1 && (s = 1 - s), e.iushrn(1), t.iushrn(1);
                    }
                    return r;
                }, n.cachedProperty = function(e, t, r) {
                    var n = "_" + t;
                    e.prototype[t] = function() {
                        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
                    };
                }, n.parseBytes = function(e) {
                    return "string" == typeof e ? n.toArray(e, "hex") : e;
                }, n.intFromLE = function(e) {
                    return new i(e, "hex", "le");
                };
            },
            {
                "bn.js": 420,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        420: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        421: [
            function(e, t, r) {
                t.exports = {
                    name: "elliptic",
                    version: "6.5.4",
                    description: "EC cryptography",
                    main: "lib/elliptic.js",
                    files: [
                        "lib"
                    ],
                    scripts: {
                        lint: "eslint lib test",
                        "lint:fix": "npm run lint -- --fix",
                        unit: "istanbul test _mocha --reporter=spec test/index.js",
                        test: "npm run lint && npm run unit",
                        version: "grunt dist && git add dist/"
                    },
                    repository: {
                        type: "git",
                        url: "git@github.com:indutny/elliptic"
                    },
                    keywords: [
                        "EC",
                        "Elliptic",
                        "curve",
                        "Cryptography"
                    ],
                    author: "Fedor Indutny <fedor@indutny.com>",
                    license: "MIT",
                    bugs: {
                        url: "https://github.com/indutny/elliptic/issues"
                    },
                    homepage: "https://github.com/indutny/elliptic",
                    devDependencies: {
                        brfs: "^2.0.2",
                        coveralls: "^3.1.0",
                        eslint: "^7.6.0",
                        grunt: "^1.2.1",
                        "grunt-browserify": "^5.3.0",
                        "grunt-cli": "^1.3.2",
                        "grunt-contrib-connect": "^3.0.0",
                        "grunt-contrib-copy": "^1.0.0",
                        "grunt-contrib-uglify": "^5.0.0",
                        "grunt-mocha-istanbul": "^5.0.2",
                        "grunt-saucelabs": "^9.0.1",
                        istanbul: "^0.4.5",
                        mocha: "^8.0.1"
                    },
                    dependencies: {
                        "bn.js": "^4.11.9",
                        brorand: "^1.1.0",
                        "hash.js": "^1.0.0",
                        "hmac-drbg": "^1.0.1",
                        inherits: "^2.0.4",
                        "minimalistic-assert": "^1.0.1",
                        "minimalistic-crypto-utils": "^1.0.1"
                    }
                };
            },
            {}
        ],
        422: [
            function(e, t, r) {
                "use strict";
                var n = Object.create || function(e) {
                    var t = function() {};
                    return t.prototype = e, new t;
                }, i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
                    return r;
                }, s = Function.prototype.bind || function(e) {
                    var t = this;
                    return function() {
                        return t.apply(e, arguments);
                    };
                };
                function o() {
                    this._events && Object.prototype.hasOwnProperty.call(this, "_events") || (this._events = n(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }
                t.exports = o, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._maxListeners = void 0;
                var a, l = 10;
                try {
                    var c = {};
                    Object.defineProperty && Object.defineProperty(c, "x", {
                        value: 0
                    }), a = 0 === c.x;
                } catch (e) {
                    a = !1;
                }
                function u(e) {
                    return void 0 === e._maxListeners ? o.defaultMaxListeners : e._maxListeners;
                }
                function h(e, t, r) {
                    if (t) e.call(r);
                    else for(var n = e.length, i = _(e, n), s = 0; s < n; ++s)i[s].call(r);
                }
                function f(e, t, r, n) {
                    if (t) e.call(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].call(r, n);
                }
                function d(e, t, r, n, i) {
                    if (t) e.call(r, n, i);
                    else for(var s = e.length, o = _(e, s), a = 0; a < s; ++a)o[a].call(r, n, i);
                }
                function p(e, t, r, n, i, s) {
                    if (t) e.call(r, n, i, s);
                    else for(var o = e.length, a = _(e, o), l = 0; l < o; ++l)a[l].call(r, n, i, s);
                }
                function m(e, t, r, n) {
                    if (t) e.apply(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].apply(r, n);
                }
                function b(e, t, r, i) {
                    var s, o, a;
                    if ("function" != typeof r) throw new TypeError('"listener" argument must be a function');
                    if ((o = e._events) ? (o.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), o = e._events), a = o[t]) : (o = e._events = n(null), e._eventsCount = 0), a) {
                        if ("function" == typeof a ? a = o[t] = i ? [
                            r,
                            a
                        ] : [
                            a,
                            r
                        ] : i ? a.unshift(r) : a.push(r), !a.warned && (s = u(e)) && s > 0 && a.length > s) {
                            a.warned = !0;
                            var l = new Error("Possible EventEmitter memory leak detected. " + a.length + ' "' + String(t) + '" listeners added. Use emitter.setMaxListeners() to increase limit.');
                            l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = a.length, "object" == typeof console && console.warn && console.warn("%s: %s", l.name, l.message);
                        }
                    } else a = o[t] = r, ++e._eventsCount;
                    return e;
                }
                function g() {
                    if (!this.fired) switch(this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length){
                        case 0:
                            return this.listener.call(this.target);
                        case 1:
                            return this.listener.call(this.target, arguments[0]);
                        case 2:
                            return this.listener.call(this.target, arguments[0], arguments[1]);
                        case 3:
                            return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);
                        default:
                            for(var e = new Array(arguments.length), t = 0; t < e.length; ++t)e[t] = arguments[t];
                            this.listener.apply(this.target, e);
                    }
                }
                function y(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, i = s.call(g, n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function v(e, t, r) {
                    var n = e._events;
                    if (!n) return [];
                    var i = n[t];
                    return i ? "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(i) : _(i, i.length) : [];
                }
                function w(e) {
                    var t = this._events;
                    if (t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (r) return r.length;
                    }
                    return 0;
                }
                function _(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                a ? Object.defineProperty(o, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return l;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || e != e) throw new TypeError('"defaultMaxListeners" must be a positive number');
                        l = e;
                    }
                }) : o.defaultMaxListeners = l, o.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
                    return this._maxListeners = e, this;
                }, o.prototype.getMaxListeners = function() {
                    return u(this);
                }, o.prototype.emit = function(e) {
                    var t, r, n, i, s, o, a = "error" === e;
                    if (o = this._events) a = a && null == o.error;
                    else if (!a) return !1;
                    if (a) {
                        if (arguments.length > 1 && (t = arguments[1]), t instanceof Error) throw t;
                        var l = new Error('Unhandled "error" event. (' + t + ")");
                        throw l.context = t, l;
                    }
                    if (!(r = o[e])) return !1;
                    var c = "function" == typeof r;
                    switch(n = arguments.length){
                        case 1:
                            h(r, c, this);
                            break;
                        case 2:
                            f(r, c, this, arguments[1]);
                            break;
                        case 3:
                            d(r, c, this, arguments[1], arguments[2]);
                            break;
                        case 4:
                            p(r, c, this, arguments[1], arguments[2], arguments[3]);
                            break;
                        default:
                            for(i = new Array(n - 1), s = 1; s < n; s++)i[s - 1] = arguments[s];
                            m(r, c, this, i);
                    }
                    return !0;
                }, o.prototype.addListener = function(e, t) {
                    return b(this, e, t, !1);
                }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(e, t) {
                    return b(this, e, t, !0);
                }, o.prototype.once = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.on(e, y(this, e, t)), this;
                }, o.prototype.prependOnceListener = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.prependListener(e, y(this, e, t)), this;
                }, o.prototype.removeListener = function(e, t) {
                    var r, i, s, o, a;
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    if (!(i = this._events)) return this;
                    if (!(r = i[e])) return this;
                    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = n(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(s = -1, o = r.length - 1; o >= 0; o--)if (r[o] === t || r[o].listener === t) {
                            a = r[o].listener, s = o;
                            break;
                        }
                        if (s < 0) return this;
                        0 === s ? r.shift() : function(e, t) {
                            for(var r = t, n = r + 1, i = e.length; n < i; r += 1, n += 1)e[r] = e[n];
                            e.pop();
                        }(r, s), 1 === r.length && (i[e] = r[0]), i.removeListener && this.emit("removeListener", e, a || t);
                    }
                    return this;
                }, o.prototype.removeAllListeners = function(e) {
                    var t, r, s;
                    if (!(r = this._events)) return this;
                    if (!r.removeListener) return 0 === arguments.length ? (this._events = n(null), this._eventsCount = 0) : r[e] && (0 == --this._eventsCount ? this._events = n(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var o, a = i(r);
                        for(s = 0; s < a.length; ++s)"removeListener" !== (o = a[s]) && this.removeAllListeners(o);
                        return this.removeAllListeners("removeListener"), this._events = n(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (t) for(s = t.length - 1; s >= 0; s--)this.removeListener(e, t[s]);
                    return this;
                }, o.prototype.listeners = function(e) {
                    return v(this, e, !0);
                }, o.prototype.rawListeners = function(e) {
                    return v(this, e, !1);
                }, o.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : w.call(e, t);
                }, o.prototype.listenerCount = w, o.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
                };
            },
            {}
        ],
        423: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("md5.js");
                t.exports = function(e, t, r, s) {
                    if (n.isBuffer(e) || (e = n.from(e, "binary")), t && (n.isBuffer(t) || (t = n.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");
                    for(var o = r / 8, a = n.alloc(o), l = n.alloc(s || 0), c = n.alloc(0); o > 0 || s > 0;){
                        var u = new i;
                        u.update(c), u.update(e), t && u.update(t), c = u.digest();
                        var h = 0;
                        if (o > 0) {
                            var f = a.length - o;
                            h = Math.min(o, c.length), c.copy(a, f, 0, h), o -= h;
                        }
                        if (h < c.length && s > 0) {
                            var d = l.length - s, p = Math.min(s, c.length - h);
                            c.copy(l, d, h, h + p), s -= p;
                        }
                    }
                    return c.fill(0), {
                        key: a,
                        iv: l
                    };
                };
            },
            {
                "md5.js": 450,
                "safe-buffer": 494
            }
        ],
        424: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CsvParserStream = r.ParserOptions = r.parseFile = r.parseStream = r.parseString = r.parse = r.FormatterOptions = r.CsvFormatterStream = r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = void 0;
                var n = e("@fast-csv/format");
                Object.defineProperty(r, "format", {
                    enumerable: !0,
                    get: function() {
                        return n.format;
                    }
                }), Object.defineProperty(r, "write", {
                    enumerable: !0,
                    get: function() {
                        return n.write;
                    }
                }), Object.defineProperty(r, "writeToStream", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToStream;
                    }
                }), Object.defineProperty(r, "writeToBuffer", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToBuffer;
                    }
                }), Object.defineProperty(r, "writeToString", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToString;
                    }
                }), Object.defineProperty(r, "writeToPath", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToPath;
                    }
                }), Object.defineProperty(r, "CsvFormatterStream", {
                    enumerable: !0,
                    get: function() {
                        return n.CsvFormatterStream;
                    }
                }), Object.defineProperty(r, "FormatterOptions", {
                    enumerable: !0,
                    get: function() {
                        return n.FormatterOptions;
                    }
                });
                var i = e("@fast-csv/parse");
                Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return i.parse;
                    }
                }), Object.defineProperty(r, "parseString", {
                    enumerable: !0,
                    get: function() {
                        return i.parseString;
                    }
                }), Object.defineProperty(r, "parseStream", {
                    enumerable: !0,
                    get: function() {
                        return i.parseStream;
                    }
                }), Object.defineProperty(r, "parseFile", {
                    enumerable: !0,
                    get: function() {
                        return i.parseFile;
                    }
                }), Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return i.ParserOptions;
                    }
                }), Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return i.CsvParserStream;
                    }
                });
            },
            {
                "@fast-csv/format": 151,
                "@fast-csv/parse": 155
            }
        ],
        425: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("readable-stream").Transform;
                function s(e) {
                    i.call(this), this._block = n.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [
                        0,
                        0,
                        0,
                        0
                    ], this._finalized = !1;
                }
                e("inherits")(s, i), s.prototype._transform = function(e, t, r) {
                    var n = null;
                    try {
                        this.update(e, t);
                    } catch (e) {
                        n = e;
                    }
                    r(n);
                }, s.prototype._flush = function(e) {
                    var t = null;
                    try {
                        this.push(this.digest());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, s.prototype.update = function(e, t) {
                    if (function(e, t) {
                        if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
                    }(e, "Data"), this._finalized) throw new Error("Digest already called");
                    n.isBuffer(e) || (e = n.from(e, t));
                    for(var r = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;){
                        for(var s = this._blockOffset; s < this._blockSize;)r[s++] = e[i++];
                        this._update(), this._blockOffset = 0;
                    }
                    for(; i < e.length;)r[this._blockOffset++] = e[i++];
                    for(var o = 0, a = 8 * e.length; a > 0; ++o)this._length[o] += a, (a = this._length[o] / 4294967296 | 0) > 0 && (this._length[o] -= 4294967296 * a);
                    return this;
                }, s.prototype._update = function() {
                    throw new Error("_update is not implemented");
                }, s.prototype.digest = function(e) {
                    if (this._finalized) throw new Error("Digest already called");
                    this._finalized = !0;
                    var t = this._digest();
                    void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;
                    for(var r = 0; r < 4; ++r)this._length[r] = 0;
                    return t;
                }, s.prototype._digest = function() {
                    throw new Error("_digest is not implemented");
                }, t.exports = s;
            },
            {
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        426: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.utils = e("./hash/utils"), n.common = e("./hash/common"), n.sha = e("./hash/sha"), n.ripemd = e("./hash/ripemd"), n.hmac = e("./hash/hmac"), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
            },
            {
                "./hash/common": 427,
                "./hash/hmac": 428,
                "./hash/ripemd": 429,
                "./hash/sha": 430,
                "./hash/utils": 437
            }
        ],
        427: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s() {
                    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
                }
                r.BlockHash = s, s.prototype.update = function(e, t) {
                    if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
                        var r = (e = this.pending).length % this._delta8;
                        this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);
                        for(var i = 0; i < e.length; i += this._delta32)this._update(e, i, i + this._delta32);
                    }
                    return this;
                }, s.prototype.digest = function(e) {
                    return this.update(this._pad()), i(null === this.pending), this._digest(e);
                }, s.prototype._pad = function() {
                    var e = this.pendingTotal, t = this._delta8, r = t - (e + this.padLength) % t, n = new Array(r + this.padLength);
                    n[0] = 128;
                    for(var i = 1; i < r; i++)n[i] = 0;
                    if (e <<= 3, "big" === this.endian) {
                        for(var s = 8; s < this.padLength; s++)n[i++] = 0;
                        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
                    } else for(n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, s = 8; s < this.padLength; s++)n[i++] = 0;
                    return n;
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        428: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s(e, t, r) {
                    if (!(this instanceof s)) return new s(e, t, r);
                    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
                }
                t.exports = s, s.prototype._init = function(e) {
                    e.length > this.blockSize && (e = (new this.Hash).update(e).digest()), i(e.length <= this.blockSize);
                    for(var t = e.length; t < this.blockSize; t++)e.push(0);
                    for(t = 0; t < e.length; t++)e[t] ^= 54;
                    for(this.inner = (new this.Hash).update(e), t = 0; t < e.length; t++)e[t] ^= 106;
                    this.outer = (new this.Hash).update(e);
                }, s.prototype.update = function(e, t) {
                    return this.inner.update(e, t), this;
                }, s.prototype.digest = function(e) {
                    return this.outer.update(this.inner.digest()), this.outer.digest(e);
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        429: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("./common"), s = n.rotl32, o = n.sum32, a = n.sum32_3, l = n.sum32_4, c = i.BlockHash;
                function u() {
                    if (!(this instanceof u)) return new u;
                    c.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.endian = "little";
                }
                function h(e, t, r, n) {
                    return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
                }
                function f(e) {
                    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
                }
                function d(e) {
                    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
                }
                n.inherits(u, c), r.ripemd160 = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 192, u.padLength = 64, u.prototype._update = function(e, t) {
                    for(var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], u = this.h[4], y = r, v = n, w = i, _ = c, x = u, k = 0; k < 80; k++){
                        var S = o(s(l(r, h(k, n, i, c), e[p[k] + t], f(k)), b[k]), u);
                        r = u, u = c, c = s(i, 10), i = n, n = S, S = o(s(l(y, h(79 - k, v, w, _), e[m[k] + t], d(k)), g[k]), x), y = x, x = _, _ = s(w, 10), w = v, v = S;
                    }
                    S = a(this.h[1], i, _), this.h[1] = a(this.h[2], c, x), this.h[2] = a(this.h[3], u, y), this.h[3] = a(this.h[4], r, v), this.h[4] = a(this.h[0], n, w), this.h[0] = S;
                }, u.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
                };
                var p = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], m = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], b = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], g = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ];
            },
            {
                "./common": 427,
                "./utils": 437
            }
        ],
        430: [
            function(e, t, r) {
                "use strict";
                r.sha1 = e("./sha/1"), r.sha224 = e("./sha/224"), r.sha256 = e("./sha/256"), r.sha384 = e("./sha/384"), r.sha512 = e("./sha/512");
            },
            {
                "./sha/1": 431,
                "./sha/224": 432,
                "./sha/256": 433,
                "./sha/384": 434,
                "./sha/512": 435
            }
        ],
        431: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = n.rotl32, a = n.sum32, l = n.sum32_5, c = s.ft_1, u = i.BlockHash, h = [
                    1518500249,
                    1859775393,
                    2400959708,
                    3395469782
                ];
                function f() {
                    if (!(this instanceof f)) return new f;
                    u.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.W = new Array(80);
                }
                n.inherits(f, u), t.exports = f, f.blockSize = 512, f.outSize = 160, f.hmacStrength = 80, f.padLength = 64, f.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = o(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
                    var i = this.h[0], s = this.h[1], u = this.h[2], f = this.h[3], d = this.h[4];
                    for(n = 0; n < r.length; n++){
                        var p = ~~(n / 20), m = l(o(i, 5), c(p, s, u, f), d, r[n], h[p]);
                        d = f, f = u, u = o(s, 30), s = i, i = m;
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], u), this.h[3] = a(this.h[3], f), this.h[4] = a(this.h[4], d);
                }, f.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436
            }
        ],
        432: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./256");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3238371032,
                        914150663,
                        812702999,
                        4144912697,
                        4290775857,
                        1750603025,
                        1694076839,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 512, s.outSize = 224, s.hmacStrength = 192, s.padLength = 64, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
                };
            },
            {
                "../utils": 437,
                "./256": 433
            }
        ],
        433: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = e("minimalistic-assert"), a = n.sum32, l = n.sum32_4, c = n.sum32_5, u = s.ch32, h = s.maj32, f = s.s0_256, d = s.s1_256, p = s.g0_256, m = s.g1_256, b = i.BlockHash, g = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ];
                function y() {
                    if (!(this instanceof y)) return new y;
                    b.call(this), this.h = [
                        1779033703,
                        3144134277,
                        1013904242,
                        2773480762,
                        1359893119,
                        2600822924,
                        528734635,
                        1541459225
                    ], this.k = g, this.W = new Array(64);
                }
                n.inherits(y, b), t.exports = y, y.blockSize = 512, y.outSize = 256, y.hmacStrength = 192, y.padLength = 64, y.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = l(m(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
                    var i = this.h[0], s = this.h[1], b = this.h[2], g = this.h[3], y = this.h[4], v = this.h[5], w = this.h[6], _ = this.h[7];
                    for(o(this.k.length === r.length), n = 0; n < r.length; n++){
                        var x = c(_, d(y), u(y, v, w), this.k[n], r[n]), k = a(f(i), h(i, s, b));
                        _ = w, w = v, v = y, y = a(g, x), g = b, b = s, s = i, i = a(x, k);
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], b), this.h[3] = a(this.h[3], g), this.h[4] = a(this.h[4], y), this.h[5] = a(this.h[5], v), this.h[6] = a(this.h[6], w), this.h[7] = a(this.h[7], _);
                }, y.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436,
                "minimalistic-assert": 453
            }
        ],
        434: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./512");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3418070365,
                        3238371032,
                        1654270250,
                        914150663,
                        2438529370,
                        812702999,
                        355462360,
                        4144912697,
                        1731405415,
                        4290775857,
                        2394180231,
                        1750603025,
                        3675008525,
                        1694076839,
                        1203062813,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 1024, s.outSize = 384, s.hmacStrength = 192, s.padLength = 128, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
                };
            },
            {
                "../utils": 437,
                "./512": 435
            }
        ],
        435: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("minimalistic-assert"), o = n.rotr64_hi, a = n.rotr64_lo, l = n.shr64_hi, c = n.shr64_lo, u = n.sum64, h = n.sum64_hi, f = n.sum64_lo, d = n.sum64_4_hi, p = n.sum64_4_lo, m = n.sum64_5_hi, b = n.sum64_5_lo, g = i.BlockHash, y = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ];
                function v() {
                    if (!(this instanceof v)) return new v;
                    g.call(this), this.h = [
                        1779033703,
                        4089235720,
                        3144134277,
                        2227873595,
                        1013904242,
                        4271175723,
                        2773480762,
                        1595750129,
                        1359893119,
                        2917565137,
                        2600822924,
                        725511199,
                        528734635,
                        4215389547,
                        1541459225,
                        327033209
                    ], this.k = y, this.W = new Array(160);
                }
                function w(e, t, r, n, i) {
                    var s = e & r ^ ~e & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function _(e, t, r, n, i, s) {
                    var o = t & n ^ ~t & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function x(e, t, r, n, i) {
                    var s = e & r ^ e & i ^ r & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function k(e, t, r, n, i, s) {
                    var o = t & n ^ t & s ^ n & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function S(e, t) {
                    var r = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function M(e, t) {
                    var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function C(e, t) {
                    var r = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function T(e, t) {
                    var r = a(e, t, 14) ^ a(e, t, 18) ^ a(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function E(e, t) {
                    var r = o(e, t, 1) ^ o(e, t, 8) ^ l(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function A(e, t) {
                    var r = a(e, t, 1) ^ a(e, t, 8) ^ c(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function R(e, t) {
                    var r = o(e, t, 19) ^ o(t, e, 29) ^ l(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                function O(e, t) {
                    var r = a(e, t, 19) ^ a(t, e, 29) ^ c(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                n.inherits(v, g), t.exports = v, v.blockSize = 1024, v.outSize = 512, v.hmacStrength = 192, v.padLength = 128, v.prototype._prepareBlock = function(e, t) {
                    for(var r = this.W, n = 0; n < 32; n++)r[n] = e[t + n];
                    for(; n < r.length; n += 2){
                        var i = R(r[n - 4], r[n - 3]), s = O(r[n - 4], r[n - 3]), o = r[n - 14], a = r[n - 13], l = E(r[n - 30], r[n - 29]), c = A(r[n - 30], r[n - 29]), u = r[n - 32], h = r[n - 31];
                        r[n] = d(i, s, o, a, l, c, u, h), r[n + 1] = p(i, s, o, a, l, c, u, h);
                    }
                }, v.prototype._update = function(e, t) {
                    this._prepareBlock(e, t);
                    var r = this.W, n = this.h[0], i = this.h[1], o = this.h[2], a = this.h[3], l = this.h[4], c = this.h[5], d = this.h[6], p = this.h[7], g = this.h[8], y = this.h[9], v = this.h[10], E = this.h[11], A = this.h[12], R = this.h[13], O = this.h[14], j = this.h[15];
                    s(this.k.length === r.length);
                    for(var I = 0; I < r.length; I += 2){
                        var N = O, P = j, B = C(g, y), D = T(g, y), F = w(g, y, v, E, A), L = _(g, y, v, E, A, R), z = this.k[I], U = this.k[I + 1], $ = r[I], H = r[I + 1], V = m(N, P, B, D, F, L, z, U, $, H), q = b(N, P, B, D, F, L, z, U, $, H);
                        N = S(n, i), P = M(n, i), B = x(n, i, o, a, l), D = k(n, i, o, a, l, c);
                        var W = h(N, P, B, D), X = f(N, P, B, D);
                        O = A, j = R, A = v, R = E, v = g, E = y, g = h(d, p, V, q), y = f(p, p, V, q), d = l, p = c, l = o, c = a, o = n, a = i, n = h(V, q, W, X), i = f(V, q, W, X);
                    }
                    u(this.h, 0, n, i), u(this.h, 2, o, a), u(this.h, 4, l, c), u(this.h, 6, d, p), u(this.h, 8, g, y), u(this.h, 10, v, E), u(this.h, 12, A, R), u(this.h, 14, O, j);
                }, v.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "minimalistic-assert": 453
            }
        ],
        436: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils").rotr32;
                function i(e, t, r) {
                    return e & t ^ ~e & r;
                }
                function s(e, t, r) {
                    return e & t ^ e & r ^ t & r;
                }
                function o(e, t, r) {
                    return e ^ t ^ r;
                }
                r.ft_1 = function(e, t, r, n) {
                    return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? o(t, r, n) : 2 === e ? s(t, r, n) : void 0;
                }, r.ch32 = i, r.maj32 = s, r.p32 = o, r.s0_256 = function(e) {
                    return n(e, 2) ^ n(e, 13) ^ n(e, 22);
                }, r.s1_256 = function(e) {
                    return n(e, 6) ^ n(e, 11) ^ n(e, 25);
                }, r.g0_256 = function(e) {
                    return n(e, 7) ^ n(e, 18) ^ e >>> 3;
                }, r.g1_256 = function(e) {
                    return n(e, 17) ^ n(e, 19) ^ e >>> 10;
                };
            },
            {
                "../utils": 437
            }
        ],
        437: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits");
                function s(e, t) {
                    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
                }
                function o(e) {
                    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
                }
                function a(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function l(e) {
                    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
                }
                r.inherits = i, r.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" == typeof e) {
                        if (t) {
                            if ("hex" === t) for((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2)r.push(parseInt(e[i] + e[i + 1], 16));
                        } else for(var n = 0, i = 0; i < e.length; i++){
                            var o = e.charCodeAt(i);
                            o < 128 ? r[n++] = o : o < 2048 ? (r[n++] = o >> 6 | 192, r[n++] = 63 & o | 128) : s(e, i) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = o >> 18 | 240, r[n++] = o >> 12 & 63 | 128, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128) : (r[n++] = o >> 12 | 224, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128);
                        }
                    } else for(i = 0; i < e.length; i++)r[i] = 0 | e[i];
                    return r;
                }, r.toHex = function(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += a(e[r].toString(16));
                    return t;
                }, r.htonl = o, r.toHex32 = function(e, t) {
                    for(var r = "", n = 0; n < e.length; n++){
                        var i = e[n];
                        "little" === t && (i = o(i)), r += l(i.toString(16));
                    }
                    return r;
                }, r.zero2 = a, r.zero8 = l, r.join32 = function(e, t, r, i) {
                    var s = r - t;
                    n(s % 4 == 0);
                    for(var o = new Array(s / 4), a = 0, l = t; a < o.length; a++, l += 4){
                        var c;
                        c = "big" === i ? e[l] << 24 | e[l + 1] << 16 | e[l + 2] << 8 | e[l + 3] : e[l + 3] << 24 | e[l + 2] << 16 | e[l + 1] << 8 | e[l], o[a] = c >>> 0;
                    }
                    return o;
                }, r.split32 = function(e, t) {
                    for(var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4){
                        var s = e[n];
                        "big" === t ? (r[i] = s >>> 24, r[i + 1] = s >>> 16 & 255, r[i + 2] = s >>> 8 & 255, r[i + 3] = 255 & s) : (r[i + 3] = s >>> 24, r[i + 2] = s >>> 16 & 255, r[i + 1] = s >>> 8 & 255, r[i] = 255 & s);
                    }
                    return r;
                }, r.rotr32 = function(e, t) {
                    return e >>> t | e << 32 - t;
                }, r.rotl32 = function(e, t) {
                    return e << t | e >>> 32 - t;
                }, r.sum32 = function(e, t) {
                    return e + t >>> 0;
                }, r.sum32_3 = function(e, t, r) {
                    return e + t + r >>> 0;
                }, r.sum32_4 = function(e, t, r, n) {
                    return e + t + r + n >>> 0;
                }, r.sum32_5 = function(e, t, r, n, i) {
                    return e + t + r + n + i >>> 0;
                }, r.sum64 = function(e, t, r, n) {
                    var i = e[t], s = n + e[t + 1] >>> 0, o = (s < n ? 1 : 0) + r + i;
                    e[t] = o >>> 0, e[t + 1] = s;
                }, r.sum64_hi = function(e, t, r, n) {
                    return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
                }, r.sum64_lo = function(e, t, r, n) {
                    return t + n >>> 0;
                }, r.sum64_4_hi = function(e, t, r, n, i, s, o, a) {
                    var l = 0, c = t;
                    return l += (c = c + n >>> 0) < t ? 1 : 0, l += (c = c + s >>> 0) < s ? 1 : 0, e + r + i + o + (l += (c = c + a >>> 0) < a ? 1 : 0) >>> 0;
                }, r.sum64_4_lo = function(e, t, r, n, i, s, o, a) {
                    return t + n + s + a >>> 0;
                }, r.sum64_5_hi = function(e, t, r, n, i, s, o, a, l, c) {
                    var u = 0, h = t;
                    return u += (h = h + n >>> 0) < t ? 1 : 0, u += (h = h + s >>> 0) < s ? 1 : 0, u += (h = h + a >>> 0) < a ? 1 : 0, e + r + i + o + l + (u += (h = h + c >>> 0) < c ? 1 : 0) >>> 0;
                }, r.sum64_5_lo = function(e, t, r, n, i, s, o, a, l, c) {
                    return t + n + s + a + c >>> 0;
                }, r.rotr64_hi = function(e, t, r) {
                    return (t << 32 - r | e >>> r) >>> 0;
                }, r.rotr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                }, r.shr64_hi = function(e, t, r) {
                    return e >>> r;
                }, r.shr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        438: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("minimalistic-crypto-utils"), s = e("minimalistic-assert");
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
                    var t = i.toArray(e.entropy, e.entropyEnc || "hex"), r = i.toArray(e.nonce, e.nonceEnc || "hex"), n = i.toArray(e.pers, e.persEnc || "hex");
                    s(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
                }
                t.exports = o, o.prototype._init = function(e, t, r) {
                    var n = e.concat(t).concat(r);
                    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
                    for(var i = 0; i < this.V.length; i++)this.K[i] = 0, this.V[i] = 1;
                    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
                }, o.prototype._hmac = function() {
                    return new n.hmac(this.hash, this.K);
                }, o.prototype._update = function(e) {
                    var t = this._hmac().update(this.V).update([
                        0
                    ]);
                    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([
                        1
                    ]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
                }, o.prototype.reseed = function(e, t, r, n) {
                    "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), s(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
                }, o.prototype.generate = function(e, t, r, n) {
                    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
                    "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));
                    for(var s = []; s.length < e;)this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
                    var o = s.slice(0, e);
                    return this._update(r), this._reseed++, i.encode(o, t);
                };
            },
            {
                "hash.js": 426,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        439: [
            function(e, t, r) {
                "use strict";
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ r.read = function(e, t, r, n, i) {
                    var s, o, a = 8 * i - n - 1, l = (1 << a) - 1, c = l >> 1, u = -7, h = r ? i - 1 : 0, f = r ? -1 : 1, d = e[t + h];
                    for(h += f, s = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; s = 256 * s + e[t + h], h += f, u -= 8);
                    for(o = s & (1 << -u) - 1, s >>= -u, u += n; u > 0; o = 256 * o + e[t + h], h += f, u -= 8);
                    if (0 === s) s = 1 - c;
                    else {
                        if (s === l) return o ? NaN : 1 / 0 * (d ? -1 : 1);
                        o += Math.pow(2, n), s -= c;
                    }
                    return (d ? -1 : 1) * o * Math.pow(2, s - n);
                }, r.write = function(e, t, r, n, i, s) {
                    var o, a, l, c = 8 * s - i - 1, u = (1 << c) - 1, h = u >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : s - 1, p = n ? 1 : -1, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (t += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= u ? (a = 0, o = u) : o + h >= 1 ? (a = (t * l - 1) * Math.pow(2, i), o += h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; e[r + d] = 255 & a, d += p, a /= 256, i -= 8);
                    for(o = o << i | a, c += i; c > 0; e[r + d] = 255 & o, d += p, o /= 256, c -= 8);
                    e[r + d - p] |= 128 * m;
                };
            },
            {}
        ],
        440: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : t.exports = function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                };
            },
            {}
        ],
        441: [
            function(e, t, r) {
                (function(n, i, s, o, a, l, c, u) {
                    (function() {
                        "use strict";
                        /*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ !function(e) {
                            "object" == typeof r && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                        }(function() {
                            return (function t(r, n, i) {
                                function s(a, l) {
                                    if (!n[a]) {
                                        if (!r[a]) {
                                            var c = "function" == typeof e && e;
                                            if (!l && c) return c(a, !0);
                                            if (o) return o(a, !0);
                                            var u = new Error("Cannot find module '" + a + "'");
                                            throw u.code = "MODULE_NOT_FOUND", u;
                                        }
                                        var h = n[a] = {
                                            exports: {}
                                        };
                                        r[a][0].call(h.exports, function(e) {
                                            return s(r[a][1][e] || e);
                                        }, h, h.exports, t, r, n, i);
                                    }
                                    return n[a].exports;
                                }
                                for(var o = "function" == typeof e && e, a = 0; a < i.length; a++)s(i[a]);
                                return s;
                            })({
                                1: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./support"), s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                                        r.encode = function(e) {
                                            for(var t, r, i, o, a, l, c, u = [], h = 0, f = e.length, d = f, p = "string" !== n.getTypeOf(e); h < e.length;)d = f - h, i = p ? (t = e[h++], r = h < f ? e[h++] : 0, h < f ? e[h++] : 0) : (t = e.charCodeAt(h++), r = h < f ? e.charCodeAt(h++) : 0, h < f ? e.charCodeAt(h++) : 0), o = t >> 2, a = (3 & t) << 4 | r >> 4, l = 1 < d ? (15 & r) << 2 | i >> 6 : 64, c = 2 < d ? 63 & i : 64, u.push(s.charAt(o) + s.charAt(a) + s.charAt(l) + s.charAt(c));
                                            return u.join("");
                                        }, r.decode = function(e) {
                                            var t, r, n, o, a, l, c = 0, u = 0, h = "data:";
                                            if (e.substr(0, h.length) === h) throw new Error("Invalid base64 input, it looks like a data url.");
                                            var f, d = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                                            if (e.charAt(e.length - 1) === s.charAt(64) && d--, e.charAt(e.length - 2) === s.charAt(64) && d--, d % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                                            for(f = i.uint8array ? new Uint8Array(0 | d) : new Array(0 | d); c < e.length;)t = s.indexOf(e.charAt(c++)) << 2 | (o = s.indexOf(e.charAt(c++))) >> 4, r = (15 & o) << 4 | (a = s.indexOf(e.charAt(c++))) >> 2, n = (3 & a) << 6 | (l = s.indexOf(e.charAt(c++))), f[u++] = t, 64 !== a && (f[u++] = r), 64 !== l && (f[u++] = n);
                                            return f;
                                        };
                                    },
                                    {
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                2: [
                                    function(e, t, r) {
                                        var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), o = e("./stream/DataLengthProbe");
                                        function a(e, t, r, n, i) {
                                            this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                                        }
                                        a.prototype = {
                                            getContentWorker: function() {
                                                var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new o("data_length")), t = this;
                                                return e.on("end", function() {
                                                    if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                                                }), e;
                                            },
                                            getCompressedWorker: function() {
                                                return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                                            }
                                        }, a.createWorkerFrom = function(e, t, r) {
                                            return e.pipe(new s).pipe(new o("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new o("compressedSize")).withStreamInfo("compression", t);
                                        }, t.exports = a;
                                    },
                                    {
                                        "./external": 6,
                                        "./stream/Crc32Probe": 25,
                                        "./stream/DataLengthProbe": 26,
                                        "./stream/DataWorker": 27
                                    }
                                ],
                                3: [
                                    function(e, t, r) {
                                        var n = e("./stream/GenericWorker");
                                        r.STORE = {
                                            magic: "\0\0",
                                            compressWorker: function() {
                                                return new n("STORE compression");
                                            },
                                            uncompressWorker: function() {
                                                return new n("STORE decompression");
                                            }
                                        }, r.DEFLATE = e("./flate");
                                    },
                                    {
                                        "./flate": 7,
                                        "./stream/GenericWorker": 28
                                    }
                                ],
                                4: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t) {
                                            return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t.charCodeAt(a))];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : 0;
                                        };
                                    },
                                    {
                                        "./utils": 32
                                    }
                                ],
                                5: [
                                    function(e, t, r) {
                                        r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
                                    },
                                    {}
                                ],
                                6: [
                                    function(e, t, r) {
                                        var n;
                                        n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                                            Promise: n
                                        };
                                    },
                                    {
                                        lie: 37
                                    }
                                ],
                                7: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), o = e("./stream/GenericWorker"), a = n ? "uint8array" : "array";
                                        function l(e, t) {
                                            o.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                                        }
                                        r.magic = "\b\0", s.inherits(l, o), l.prototype.processChunk = function(e) {
                                            this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(a, e.data), !1);
                                        }, l.prototype.flush = function() {
                                            o.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                                        }, l.prototype.cleanUp = function() {
                                            o.prototype.cleanUp.call(this), this._pako = null;
                                        }, l.prototype._createPako = function() {
                                            this._pako = new i[this._pakoAction]({
                                                raw: !0,
                                                level: this._pakoOptions.level || -1
                                            });
                                            var e = this;
                                            this._pako.onData = function(t) {
                                                e.push({
                                                    data: t,
                                                    meta: e.meta
                                                });
                                            };
                                        }, r.compressWorker = function(e) {
                                            return new l("Deflate", e);
                                        }, r.uncompressWorker = function() {
                                            return new l("Inflate", {});
                                        };
                                    },
                                    {
                                        "./stream/GenericWorker": 28,
                                        "./utils": 32,
                                        pako: 38
                                    }
                                ],
                                8: [
                                    function(e, t, r) {
                                        function n(e, t) {
                                            var r, n = "";
                                            for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                                            return n;
                                        }
                                        function i(e, t, r, i, o, u) {
                                            var h, f, d = e.file, p = e.compression, m = u !== a.utf8encode, b = s.transformTo("string", u(d.name)), g = s.transformTo("string", a.utf8encode(d.name)), y = d.comment, v = s.transformTo("string", u(y)), w = s.transformTo("string", a.utf8encode(y)), _ = g.length !== d.name.length, x = w.length !== y.length, k = "", S = "", M = "", C = d.dir, T = d.date, E = {
                                                crc32: 0,
                                                compressedSize: 0,
                                                uncompressedSize: 0
                                            };
                                            t && !r || (E.crc32 = e.crc32, E.compressedSize = e.compressedSize, E.uncompressedSize = e.uncompressedSize);
                                            var A = 0;
                                            t && (A |= 8), m || !_ && !x || (A |= 2048);
                                            var R = 0, O = 0;
                                            C && (R |= 16), "UNIX" === o ? (O = 798, R |= function(e, t) {
                                                var r = e;
                                                return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                                            }(d.unixPermissions, C)) : (O = 20, R |= function(e) {
                                                return 63 & (e || 0);
                                            }(d.dosPermissions)), h = T.getUTCHours(), h <<= 6, h |= T.getUTCMinutes(), h <<= 5, h |= T.getUTCSeconds() / 2, f = T.getUTCFullYear() - 1980, f <<= 4, f |= T.getUTCMonth() + 1, f <<= 5, f |= T.getUTCDate(), _ && (S = n(1, 1) + n(l(b), 4) + g, k += "up" + n(S.length, 2) + S), x && (M = n(1, 1) + n(l(v), 4) + w, k += "uc" + n(M.length, 2) + M);
                                            var j = "";
                                            return j += "\n\0", j += n(A, 2), j += p.magic, j += n(h, 2), j += n(f, 2), j += n(E.crc32, 4), j += n(E.compressedSize, 4), j += n(E.uncompressedSize, 4), j += n(b.length, 2), j += n(k.length, 2), {
                                                fileRecord: c.LOCAL_FILE_HEADER + j + b + k,
                                                dirRecord: c.CENTRAL_FILE_HEADER + n(O, 2) + j + n(v.length, 2) + "\0\0\0\0" + n(R, 4) + n(i, 4) + b + k + v
                                            };
                                        }
                                        var s = e("../utils"), o = e("../stream/GenericWorker"), a = e("../utf8"), l = e("../crc32"), c = e("../signature");
                                        function u(e, t, r, n) {
                                            o.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                                        }
                                        s.inherits(u, o), u.prototype.push = function(e) {
                                            var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                                            this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, o.prototype.push.call(this, {
                                                data: e.data,
                                                meta: {
                                                    currentFile: this.currentFile,
                                                    percent: r ? (t + 100 * (r - n - 1)) / r : 100
                                                }
                                            }));
                                        }, u.prototype.openedSource = function(e) {
                                            this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                                            var t = this.streamFiles && !e.file.dir;
                                            if (t) {
                                                var r = i(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                                this.push({
                                                    data: r.fileRecord,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            } else this.accumulate = !0;
                                        }, u.prototype.closedSource = function(e) {
                                            this.accumulate = !1;
                                            var t = this.streamFiles && !e.file.dir, r = i(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                            if (this.dirRecords.push(r.dirRecord), t) this.push({
                                                data: function(e) {
                                                    return c.DATA_DESCRIPTOR + n(e.crc32, 4) + n(e.compressedSize, 4) + n(e.uncompressedSize, 4);
                                                }(e),
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            else for(this.push({
                                                data: r.fileRecord,
                                                meta: {
                                                    percent: 0
                                                }
                                            }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                                            this.currentFile = null;
                                        }, u.prototype.flush = function() {
                                            for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                                                data: this.dirRecords[t],
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            var r = this.bytesWritten - e, i = function(e, t, r, i, o) {
                                                var a = s.transformTo("string", o(i));
                                                return c.CENTRAL_DIRECTORY_END + "\0\0\0\0" + n(e, 2) + n(e, 2) + n(t, 4) + n(r, 4) + n(a.length, 2) + a;
                                            }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                                            this.push({
                                                data: i,
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                        }, u.prototype.prepareNextSource = function() {
                                            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                                        }, u.prototype.registerPrevious = function(e) {
                                            this._sources.push(e);
                                            var t = this;
                                            return e.on("data", function(e) {
                                                t.processChunk(e);
                                            }), e.on("end", function() {
                                                t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                                            }), e.on("error", function(e) {
                                                t.error(e);
                                            }), this;
                                        }, u.prototype.resume = function() {
                                            return !!o.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                                        }, u.prototype.error = function(e) {
                                            var t = this._sources;
                                            if (!o.prototype.error.call(this, e)) return !1;
                                            for(var r = 0; r < t.length; r++)try {
                                                t[r].error(e);
                                            } catch (e) {}
                                            return !0;
                                        }, u.prototype.lock = function() {
                                            o.prototype.lock.call(this);
                                            for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                                        }, t.exports = u;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../signature": 23,
                                        "../stream/GenericWorker": 28,
                                        "../utf8": 31,
                                        "../utils": 32
                                    }
                                ],
                                9: [
                                    function(e, t, r) {
                                        var n = e("../compressions"), i = e("./ZipFileWorker");
                                        r.generateWorker = function(e, t, r) {
                                            var s = new i(t.streamFiles, r, t.platform, t.encodeFileName), o = 0;
                                            try {
                                                e.forEach(function(e, r) {
                                                    o++;
                                                    var i = function(e, t) {
                                                        var r = e || t, i = n[r];
                                                        if (!i) throw new Error(r + " is not a valid compression method !");
                                                        return i;
                                                    }(r.options.compression, t.compression), a = r.options.compressionOptions || t.compressionOptions || {}, l = r.dir, c = r.date;
                                                    r._compressWorker(i, a).withStreamInfo("file", {
                                                        name: e,
                                                        dir: l,
                                                        date: c,
                                                        comment: r.comment || "",
                                                        unixPermissions: r.unixPermissions,
                                                        dosPermissions: r.dosPermissions
                                                    }).pipe(s);
                                                }), s.entriesCount = o;
                                            } catch (e) {
                                                s.error(e);
                                            }
                                            return s;
                                        };
                                    },
                                    {
                                        "../compressions": 3,
                                        "./ZipFileWorker": 8
                                    }
                                ],
                                10: [
                                    function(e, t, r) {
                                        function n() {
                                            if (!(this instanceof n)) return new n;
                                            if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                                            this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                                                var e = new n;
                                                for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                                                return e;
                                            };
                                        }
                                        (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                                            return (new n).loadAsync(e, t);
                                        }, n.external = e("./external"), t.exports = n;
                                    },
                                    {
                                        "./defaults": 5,
                                        "./external": 6,
                                        "./load": 11,
                                        "./object": 15,
                                        "./support": 30
                                    }
                                ],
                                11: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./external"), s = e("./utf8"), o = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                                        function c(e) {
                                            return new i.Promise(function(t, r) {
                                                var n = e.decompressed.getContentWorker().pipe(new a);
                                                n.on("error", function(e) {
                                                    r(e);
                                                }).on("end", function() {
                                                    n.streamInfo.crc32 !== e.decompressed.crc32 ? r(new Error("Corrupted zip : CRC32 mismatch")) : t();
                                                }).resume();
                                            });
                                        }
                                        t.exports = function(e, t) {
                                            var r = this;
                                            return t = n.extend(t || {}, {
                                                base64: !1,
                                                checkCRC32: !1,
                                                optimizedBinaryString: !1,
                                                createFolders: !1,
                                                decodeFileName: s.utf8decode
                                            }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : n.prepareContent("the loaded zip file", e, !0, t.optimizedBinaryString, t.base64).then(function(e) {
                                                var r = new o(t);
                                                return r.load(e), r;
                                            }).then(function(e) {
                                                var r = [
                                                    i.Promise.resolve(e)
                                                ], n = e.files;
                                                if (t.checkCRC32) for(var s = 0; s < n.length; s++)r.push(c(n[s]));
                                                return i.Promise.all(r);
                                            }).then(function(e) {
                                                for(var i = e.shift(), s = i.files, o = 0; o < s.length; o++){
                                                    var a = s[o], l = a.fileNameStr, c = n.resolve(a.fileNameStr);
                                                    r.file(c, a.decompressed, {
                                                        binary: !0,
                                                        optimizedBinaryString: !0,
                                                        date: a.date,
                                                        dir: a.dir,
                                                        comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                                                        unixPermissions: a.unixPermissions,
                                                        dosPermissions: a.dosPermissions,
                                                        createFolders: t.createFolders
                                                    }), a.dir || (r.file(c).unsafeOriginalName = l);
                                                }
                                                return i.zipComment.length && (r.comment = i.zipComment), r;
                                            });
                                        };
                                    },
                                    {
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./stream/Crc32Probe": 25,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipEntries": 33
                                    }
                                ],
                                12: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../stream/GenericWorker");
                                        function s(e, t) {
                                            i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                                        }
                                        n.inherits(s, i), s.prototype._bindStream = function(e) {
                                            var t = this;
                                            (this._stream = e).pause(), e.on("data", function(e) {
                                                t.push({
                                                    data: e,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            }).on("error", function(e) {
                                                t.isPaused ? this.generatedError = e : t.error(e);
                                            }).on("end", function() {
                                                t.isPaused ? t._upstreamEnded = !0 : t.end();
                                            });
                                        }, s.prototype.pause = function() {
                                            return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../stream/GenericWorker": 28,
                                        "../utils": 32
                                    }
                                ],
                                13: [
                                    function(e, t, r) {
                                        var n = e("readable-stream").Readable;
                                        function i(e, t, r) {
                                            n.call(this, t), this._helper = e;
                                            var i = this;
                                            e.on("data", function(e, t) {
                                                i.push(e) || i._helper.pause(), r && r(t);
                                            }).on("error", function(e) {
                                                i.emit("error", e);
                                            }).on("end", function() {
                                                i.push(null);
                                            });
                                        }
                                        e("../utils").inherits(i, n), i.prototype._read = function() {
                                            this._helper.resume();
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "readable-stream": 16
                                    }
                                ],
                                14: [
                                    function(e, t, r) {
                                        t.exports = {
                                            isNode: void 0 !== s,
                                            newBufferFrom: function(e, t) {
                                                if (s.from && s.from !== Uint8Array.from) return s.from(e, t);
                                                if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                                                return new s(e, t);
                                            },
                                            allocBuffer: function(e) {
                                                if (s.alloc) return s.alloc(e);
                                                var t = new s(e);
                                                return t.fill(0), t;
                                            },
                                            isBuffer: function(e) {
                                                return s.isBuffer(e);
                                            },
                                            isStream: function(e) {
                                                return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                                            }
                                        };
                                    },
                                    {}
                                ],
                                15: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            var n, i = s.getTypeOf(t), a = s.extend(r || {}, l);
                                            a.date = a.date || new Date, null !== a.compression && (a.compression = a.compression.toUpperCase()), "string" == typeof a.unixPermissions && (a.unixPermissions = parseInt(a.unixPermissions, 8)), a.unixPermissions && 16384 & a.unixPermissions && (a.dir = !0), a.dosPermissions && 16 & a.dosPermissions && (a.dir = !0), a.dir && (e = m(e)), a.createFolders && (n = p(e)) && b.call(this, n, !0);
                                            var h = "string" === i && !1 === a.binary && !1 === a.base64;
                                            r && void 0 !== r.binary || (a.binary = !h), (t instanceof c && 0 === t.uncompressedSize || a.dir || !t || 0 === t.length) && (a.base64 = !1, a.binary = !0, t = "", a.compression = "STORE", i = "string");
                                            var g;
                                            g = t instanceof c || t instanceof o ? t : f.isNode && f.isStream(t) ? new d(e, t) : s.prepareContent(e, t, a.binary, a.optimizedBinaryString, a.base64);
                                            var y = new u(e, g, a);
                                            this.files[e] = y;
                                        }
                                        var i = e("./utf8"), s = e("./utils"), o = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), l = e("./defaults"), c = e("./compressedObject"), u = e("./zipObject"), h = e("./generate"), f = e("./nodejsUtils"), d = e("./nodejs/NodejsStreamInputAdapter"), p = function(e) {
                                            "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                                            var t = e.lastIndexOf("/");
                                            return 0 < t ? e.substring(0, t) : "";
                                        }, m = function(e) {
                                            return "/" !== e.slice(-1) && (e += "/"), e;
                                        }, b = function(e, t) {
                                            return t = void 0 !== t ? t : l.createFolders, e = m(e), this.files[e] || n.call(this, e, null, {
                                                dir: !0,
                                                createFolders: t
                                            }), this.files[e];
                                        };
                                        function g(e) {
                                            return "[object RegExp]" === Object.prototype.toString.call(e);
                                        }
                                        var y = {
                                            load: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            forEach: function(e) {
                                                var t, r, n;
                                                for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                                            },
                                            filter: function(e) {
                                                var t = [];
                                                return this.forEach(function(r, n) {
                                                    e(r, n) && t.push(n);
                                                }), t;
                                            },
                                            file: function(e, t, r) {
                                                if (1 !== arguments.length) return e = this.root + e, n.call(this, e, t, r), this;
                                                if (g(e)) {
                                                    var i = e;
                                                    return this.filter(function(e, t) {
                                                        return !t.dir && i.test(e);
                                                    });
                                                }
                                                var s = this.files[this.root + e];
                                                return s && !s.dir ? s : null;
                                            },
                                            folder: function(e) {
                                                if (!e) return this;
                                                if (g(e)) return this.filter(function(t, r) {
                                                    return r.dir && e.test(t);
                                                });
                                                var t = this.root + e, r = b.call(this, t), n = this.clone();
                                                return n.root = r.name, n;
                                            },
                                            remove: function(e) {
                                                e = this.root + e;
                                                var t = this.files[e];
                                                if (t || ("/" !== e.slice(-1) && (e += "/"), t = this.files[e]), t && !t.dir) delete this.files[e];
                                                else for(var r = this.filter(function(t, r) {
                                                    return r.name.slice(0, e.length) === e;
                                                }), n = 0; n < r.length; n++)delete this.files[r[n].name];
                                                return this;
                                            },
                                            generate: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            generateInternalStream: function(e) {
                                                var t, r = {};
                                                try {
                                                    if ((r = s.extend(e || {}, {
                                                        streamFiles: !1,
                                                        compression: "STORE",
                                                        compressionOptions: null,
                                                        type: "",
                                                        platform: "DOS",
                                                        comment: null,
                                                        mimeType: "application/zip",
                                                        encodeFileName: i.utf8encode
                                                    })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                                                    s.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                                                    var n = r.comment || this.comment || "";
                                                    t = h.generateWorker(this, r, n);
                                                } catch (e) {
                                                    (t = new o("error")).error(e);
                                                }
                                                return new a(t, r.type || "string", r.mimeType);
                                            },
                                            generateAsync: function(e, t) {
                                                return this.generateInternalStream(e).accumulate(t);
                                            },
                                            generateNodeStream: function(e, t) {
                                                return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                                            }
                                        };
                                        t.exports = y;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./defaults": 5,
                                        "./generate": 9,
                                        "./nodejs/NodejsStreamInputAdapter": 12,
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipObject": 35
                                    }
                                ],
                                16: [
                                    function(e, t, r) {
                                        t.exports = e("stream");
                                    },
                                    {
                                        stream: void 0
                                    }
                                ],
                                17: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                            for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data[this.zero + e];
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                                            return -1;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                                            return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                                        }, i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return [];
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                18: [
                                    function(e, t, r) {
                                        var n = e("../utils");
                                        function i(e) {
                                            this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                                        }
                                        i.prototype = {
                                            checkOffset: function(e) {
                                                this.checkIndex(this.index + e);
                                            },
                                            checkIndex: function(e) {
                                                if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                                            },
                                            setIndex: function(e) {
                                                this.checkIndex(e), this.index = e;
                                            },
                                            skip: function(e) {
                                                this.setIndex(this.index + e);
                                            },
                                            byteAt: function() {},
                                            readInt: function(e) {
                                                var t, r = 0;
                                                for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                                                return this.index += e, r;
                                            },
                                            readString: function(e) {
                                                return n.transformTo("string", this.readData(e));
                                            },
                                            readData: function() {},
                                            lastIndexOfSignature: function() {},
                                            readAndCheckSignature: function() {},
                                            readDate: function() {
                                                var e = this.readInt(4);
                                                return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                                            }
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32
                                    }
                                ],
                                19: [
                                    function(e, t, r) {
                                        var n = e("./Uint8ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                20: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data.charCodeAt(this.zero + e);
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            return this.data.lastIndexOf(e) - this.zero;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            return e === this.readData(4);
                                        }, i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                21: [
                                    function(e, t, r) {
                                        var n = e("./ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                                            var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./ArrayReader": 17
                                    }
                                ],
                                22: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), o = e("./StringReader"), a = e("./NodeBufferReader"), l = e("./Uint8ArrayReader");
                                        t.exports = function(e) {
                                            var t = n.getTypeOf(e);
                                            return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new a(e) : i.uint8array ? new l(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new o(e);
                                        };
                                    },
                                    {
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ArrayReader": 17,
                                        "./NodeBufferReader": 19,
                                        "./StringReader": 20,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                23: [
                                    function(e, t, r) {
                                        r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
                                    },
                                    {}
                                ],
                                24: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../utils");
                                        function s(e) {
                                            n.call(this, "ConvertWorker to " + e), this.destType = e;
                                        }
                                        i.inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.push({
                                                data: i.transformTo(this.destType, e.data),
                                                meta: e.meta
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                25: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../crc32");
                                        function s() {
                                            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                                        }
                                        e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                26: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                                        }
                                        n.inherits(s, i), s.prototype.processChunk = function(e) {
                                            if (e) {
                                                var t = this.streamInfo[this.propName] || 0;
                                                this.streamInfo[this.propName] = t + e.data.length;
                                            }
                                            i.prototype.processChunk.call(this, e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                27: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataWorker");
                                            var t = this;
                                            this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                                                t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                                            }, function(e) {
                                                t.error(e);
                                            });
                                        }
                                        n.inherits(s, i), s.prototype.cleanUp = function() {
                                            i.prototype.cleanUp.call(this), this.data = null;
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                                        }, s.prototype._tickAndRepeat = function() {
                                            this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                                        }, s.prototype._tick = function() {
                                            if (this.isPaused || this.isFinished) return !1;
                                            var e = null, t = Math.min(this.max, this.index + 16384);
                                            if (this.index >= this.max) return this.end();
                                            switch(this.type){
                                                case "string":
                                                    e = this.data.substring(this.index, t);
                                                    break;
                                                case "uint8array":
                                                    e = this.data.subarray(this.index, t);
                                                    break;
                                                case "array":
                                                case "nodebuffer":
                                                    e = this.data.slice(this.index, t);
                                            }
                                            return this.index = t, this.push({
                                                data: e,
                                                meta: {
                                                    percent: this.max ? this.index / this.max * 100 : 0
                                                }
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                28: [
                                    function(e, t, r) {
                                        function n(e) {
                                            this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                                                data: [],
                                                end: [],
                                                error: []
                                            }, this.previous = null;
                                        }
                                        n.prototype = {
                                            push: function(e) {
                                                this.emit("data", e);
                                            },
                                            end: function() {
                                                if (this.isFinished) return !1;
                                                this.flush();
                                                try {
                                                    this.emit("end"), this.cleanUp(), this.isFinished = !0;
                                                } catch (e) {
                                                    this.emit("error", e);
                                                }
                                                return !0;
                                            },
                                            error: function(e) {
                                                return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                                            },
                                            on: function(e, t) {
                                                return this._listeners[e].push(t), this;
                                            },
                                            cleanUp: function() {
                                                this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                                            },
                                            emit: function(e, t) {
                                                if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                                            },
                                            pipe: function(e) {
                                                return e.registerPrevious(this);
                                            },
                                            registerPrevious: function(e) {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                                                var t = this;
                                                return e.on("data", function(e) {
                                                    t.processChunk(e);
                                                }), e.on("end", function() {
                                                    t.end();
                                                }), e.on("error", function(e) {
                                                    t.error(e);
                                                }), this;
                                            },
                                            pause: function() {
                                                return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                                            },
                                            resume: function() {
                                                if (!this.isPaused || this.isFinished) return !1;
                                                var e = this.isPaused = !1;
                                                return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                                            },
                                            flush: function() {},
                                            processChunk: function(e) {
                                                this.push(e);
                                            },
                                            withStreamInfo: function(e, t) {
                                                return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                                            },
                                            mergeStreamInfo: function() {
                                                for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                                            },
                                            lock: function() {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.isLocked = !0, this.previous && this.previous.lock();
                                            },
                                            toString: function() {
                                                var e = "Worker " + this.name;
                                                return this.previous ? this.previous + " -> " + e : e;
                                            }
                                        }, t.exports = n;
                                    },
                                    {}
                                ],
                                29: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./ConvertWorker"), o = e("./GenericWorker"), a = e("../base64"), l = e("../support"), c = e("../external"), u = null;
                                        if (l.nodestream) try {
                                            u = e("../nodejs/NodejsStreamOutputAdapter");
                                        } catch (e) {}
                                        function h(e, t, r) {
                                            var s = t;
                                            switch(t){
                                                case "blob":
                                                case "arraybuffer":
                                                    s = "uint8array";
                                                    break;
                                                case "base64":
                                                    s = "string";
                                            }
                                            try {
                                                this._internalType = s, this._outputType = t, this._mimeType = r, n.checkSupport(s), this._worker = e.pipe(new i(s)), e.lock();
                                            } catch (e) {
                                                this._worker = new o("error"), this._worker.error(e);
                                            }
                                        }
                                        h.prototype = {
                                            accumulate: function(e) {
                                                return function(e, t) {
                                                    return new c.Promise(function(r, i) {
                                                        var o = [], l = e._internalType, c = e._outputType, u = e._mimeType;
                                                        e.on("data", function(e, r) {
                                                            o.push(e), t && t(r);
                                                        }).on("error", function(e) {
                                                            o = [], i(e);
                                                        }).on("end", function() {
                                                            try {
                                                                var e = function(e, t, r) {
                                                                    switch(e){
                                                                        case "blob":
                                                                            return n.newBlob(n.transformTo("arraybuffer", t), r);
                                                                        case "base64":
                                                                            return a.encode(t);
                                                                        default:
                                                                            return n.transformTo(e, t);
                                                                    }
                                                                }(c, function(e, t) {
                                                                    var r, n = 0, i = null, o = 0;
                                                                    for(r = 0; r < t.length; r++)o += t[r].length;
                                                                    switch(e){
                                                                        case "string":
                                                                            return t.join("");
                                                                        case "array":
                                                                            return Array.prototype.concat.apply([], t);
                                                                        case "uint8array":
                                                                            for(i = new Uint8Array(o), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                                                            return i;
                                                                        case "nodebuffer":
                                                                            return s.concat(t);
                                                                        default:
                                                                            throw new Error("concat : unsupported type '" + e + "'");
                                                                    }
                                                                }(l, o), u);
                                                                r(e);
                                                            } catch (e) {
                                                                i(e);
                                                            }
                                                            o = [];
                                                        }).resume();
                                                    });
                                                }(this, e);
                                            },
                                            on: function(e, t) {
                                                var r = this;
                                                return "data" === e ? this._worker.on(e, function(e) {
                                                    t.call(r, e.data, e.meta);
                                                }) : this._worker.on(e, function() {
                                                    n.delay(t, arguments, r);
                                                }), this;
                                            },
                                            resume: function() {
                                                return n.delay(this._worker.resume, [], this._worker), this;
                                            },
                                            pause: function() {
                                                return this._worker.pause(), this;
                                            },
                                            toNodejsStream: function(e) {
                                                if (n.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                                                return new u(this, {
                                                    objectMode: "nodebuffer" !== this._outputType
                                                }, e);
                                            }
                                        }, t.exports = h;
                                    },
                                    {
                                        "../base64": 1,
                                        "../external": 6,
                                        "../nodejs/NodejsStreamOutputAdapter": 13,
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ConvertWorker": 24,
                                        "./GenericWorker": 28
                                    }
                                ],
                                30: [
                                    function(e, t, r) {
                                        if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = void 0 !== s, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                                        else {
                                            var n = new ArrayBuffer(0);
                                            try {
                                                r.blob = 0 === new Blob([
                                                    n
                                                ], {
                                                    type: "application/zip"
                                                }).size;
                                            } catch (e) {
                                                try {
                                                    var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                                                } catch (e) {
                                                    r.blob = !1;
                                                }
                                            }
                                        }
                                        try {
                                            r.nodestream = !!e("readable-stream").Readable;
                                        } catch (e) {
                                            r.nodestream = !1;
                                        }
                                    },
                                    {
                                        "readable-stream": 16
                                    }
                                ],
                                31: [
                                    function(e, t, r) {
                                        for(var n = e("./utils"), i = e("./support"), s = e("./nodejsUtils"), o = e("./stream/GenericWorker"), a = new Array(256), l = 0; l < 256; l++)a[l] = 252 <= l ? 6 : 248 <= l ? 5 : 240 <= l ? 4 : 224 <= l ? 3 : 192 <= l ? 2 : 1;
                                        function c() {
                                            o.call(this, "utf-8 decode"), this.leftOver = null;
                                        }
                                        function u() {
                                            o.call(this, "utf-8 encode");
                                        }
                                        a[254] = a[254] = 1, r.utf8encode = function(e) {
                                            return i.nodebuffer ? s.newBufferFrom(e, "utf-8") : function(e) {
                                                var t, r, n, s, o, a = e.length, l = 0;
                                                for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                                for(t = i.uint8array ? new Uint8Array(l) : new Array(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                                return t;
                                            }(e);
                                        }, r.utf8decode = function(e) {
                                            return i.nodebuffer ? n.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                                                var t, r, i, s, o = e.length, l = new Array(2 * o);
                                                for(t = r = 0; t < o;)if ((i = e[t++]) < 128) l[r++] = i;
                                                else if (4 < (s = a[i])) l[r++] = 65533, t += s - 1;
                                                else {
                                                    for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && t < o;)i = i << 6 | 63 & e[t++], s--;
                                                    1 < s ? l[r++] = 65533 : i < 65536 ? l[r++] = i : (i -= 65536, l[r++] = 55296 | i >> 10 & 1023, l[r++] = 56320 | 1023 & i);
                                                }
                                                return l.length !== r && (l.subarray ? l = l.subarray(0, r) : l.length = r), n.applyFromCharCode(l);
                                            }(e = n.transformTo(i.uint8array ? "uint8array" : "array", e));
                                        }, n.inherits(c, o), c.prototype.processChunk = function(e) {
                                            var t = n.transformTo(i.uint8array ? "uint8array" : "array", e.data);
                                            if (this.leftOver && this.leftOver.length) {
                                                if (i.uint8array) {
                                                    var s = t;
                                                    (t = new Uint8Array(s.length + this.leftOver.length)).set(this.leftOver, 0), t.set(s, this.leftOver.length);
                                                } else t = this.leftOver.concat(t);
                                                this.leftOver = null;
                                            }
                                            var o = function(e, t) {
                                                var r;
                                                for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                                return r < 0 || 0 === r ? t : r + a[e[r]] > t ? r : t;
                                            }(t), l = t;
                                            o !== t.length && (i.uint8array ? (l = t.subarray(0, o), this.leftOver = t.subarray(o, t.length)) : (l = t.slice(0, o), this.leftOver = t.slice(o, t.length))), this.push({
                                                data: r.utf8decode(l),
                                                meta: e.meta
                                            });
                                        }, c.prototype.flush = function() {
                                            this.leftOver && this.leftOver.length && (this.push({
                                                data: r.utf8decode(this.leftOver),
                                                meta: {}
                                            }), this.leftOver = null);
                                        }, r.Utf8DecodeWorker = c, n.inherits(u, o), u.prototype.processChunk = function(e) {
                                            this.push({
                                                data: r.utf8encode(e.data),
                                                meta: e.meta
                                            });
                                        }, r.Utf8EncodeWorker = u;
                                    },
                                    {
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                32: [
                                    function(e, t, r) {
                                        var n = e("./support"), i = e("./base64"), s = e("./nodejsUtils"), o = e("./external");
                                        function a(e) {
                                            return e;
                                        }
                                        function l(e, t) {
                                            for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                                            return t;
                                        }
                                        e("setimmediate"), r.newBlob = function(e, t) {
                                            r.checkSupport("blob");
                                            try {
                                                return new Blob([
                                                    e
                                                ], {
                                                    type: t
                                                });
                                            } catch (r) {
                                                try {
                                                    var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    return n.append(e), n.getBlob(t);
                                                } catch (e) {
                                                    throw new Error("Bug : can't construct the Blob.");
                                                }
                                            }
                                        };
                                        var c = {
                                            stringifyByChunk: function(e, t, r) {
                                                var n = [], i = 0, s = e.length;
                                                if (s <= r) return String.fromCharCode.apply(null, e);
                                                for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                                                return n.join("");
                                            },
                                            stringifyByChar: function(e) {
                                                for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                                                return t;
                                            },
                                            applyCanBeUsed: {
                                                uint8array: function() {
                                                    try {
                                                        return n.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }(),
                                                nodebuffer: function() {
                                                    try {
                                                        return n.nodebuffer && 1 === String.fromCharCode.apply(null, s.allocBuffer(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }()
                                            }
                                        };
                                        function h(e) {
                                            var t = 65536, n = r.getTypeOf(e), i = !0;
                                            if ("uint8array" === n ? i = c.applyCanBeUsed.uint8array : "nodebuffer" === n && (i = c.applyCanBeUsed.nodebuffer), i) for(; 1 < t;)try {
                                                return c.stringifyByChunk(e, n, t);
                                            } catch (e) {
                                                t = Math.floor(t / 2);
                                            }
                                            return c.stringifyByChar(e);
                                        }
                                        function f(e, t) {
                                            for(var r = 0; r < e.length; r++)t[r] = e[r];
                                            return t;
                                        }
                                        r.applyFromCharCode = h;
                                        var d = {};
                                        d.string = {
                                            string: a,
                                            array: function(e) {
                                                return l(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.string.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return l(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: function(e) {
                                                return l(e, s.allocBuffer(e.length));
                                            }
                                        }, d.array = {
                                            string: h,
                                            array: a,
                                            arraybuffer: function(e) {
                                                return new Uint8Array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.arraybuffer = {
                                            string: function(e) {
                                                return h(new Uint8Array(e));
                                            },
                                            array: function(e) {
                                                return f(new Uint8Array(e), new Array(e.byteLength));
                                            },
                                            arraybuffer: a,
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(new Uint8Array(e));
                                            }
                                        }, d.uint8array = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return e.buffer;
                                            },
                                            uint8array: a,
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.nodebuffer = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.nodebuffer.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return f(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: a
                                        }, r.transformTo = function(e, t) {
                                            if (t = t || "", !e) return t;
                                            r.checkSupport(e);
                                            var n = r.getTypeOf(t);
                                            return d[n][e](t);
                                        }, r.resolve = function(e) {
                                            for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                                                var i = t[n];
                                                "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                                            }
                                            return r.join("/");
                                        }, r.getTypeOf = function(e) {
                                            return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : n.nodebuffer && s.isBuffer(e) ? "nodebuffer" : n.uint8array && e instanceof Uint8Array ? "uint8array" : n.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                                        }, r.checkSupport = function(e) {
                                            if (!n[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                                        }, r.MAX_VALUE_16BITS = 65535, r.MAX_VALUE_32BITS = -1, r.pretty = function(e) {
                                            var t, r, n = "";
                                            for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                                            return n;
                                        }, r.delay = function(e, t, r) {
                                            u(function() {
                                                e.apply(r || null, t || []);
                                            });
                                        }, r.inherits = function(e, t) {
                                            function r() {}
                                            r.prototype = t.prototype, e.prototype = new r;
                                        }, r.extend = function() {
                                            var e, t, r = {};
                                            for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                                            return r;
                                        }, r.prepareContent = function(e, t, s, a, c) {
                                            return o.Promise.resolve(t).then(function(e) {
                                                return n.blob && (e instanceof Blob || -1 !== [
                                                    "[object File]",
                                                    "[object Blob]"
                                                ].indexOf(Object.prototype.toString.call(e))) && "undefined" != typeof FileReader ? new o.Promise(function(t, r) {
                                                    var n = new FileReader;
                                                    n.onload = function(e) {
                                                        t(e.target.result);
                                                    }, n.onerror = function(e) {
                                                        r(e.target.error);
                                                    }, n.readAsArrayBuffer(e);
                                                }) : e;
                                            }).then(function(t) {
                                                var u = r.getTypeOf(t);
                                                return u ? ("arraybuffer" === u ? t = r.transformTo("uint8array", t) : "string" === u && (c ? t = i.decode(t) : s && !0 !== a && (t = function(e) {
                                                    return l(e, n.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                                                }(t))), t) : o.Promise.reject(new Error("Can't read the data of '" + e + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                                            });
                                        };
                                    },
                                    {
                                        "./base64": 1,
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./support": 30,
                                        setimmediate: 54
                                    }
                                ],
                                33: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), o = e("./zipEntry"), a = e("./support");
                                        function l(e) {
                                            this.files = [], this.loadOptions = e;
                                        }
                                        l.prototype = {
                                            checkSignature: function(e) {
                                                if (!this.reader.readAndCheckSignature(e)) {
                                                    this.reader.index -= 4;
                                                    var t = this.reader.readString(4);
                                                    throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                                                }
                                            },
                                            isSignature: function(e, t) {
                                                var r = this.reader.index;
                                                this.reader.setIndex(e);
                                                var n = this.reader.readString(4) === t;
                                                return this.reader.setIndex(r), n;
                                            },
                                            readBlockEndOfCentral: function() {
                                                this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                                                var e = this.reader.readData(this.zipCommentLength), t = a.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                                                this.zipComment = this.loadOptions.decodeFileName(r);
                                            },
                                            readBlockZip64EndOfCentral: function() {
                                                this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                                                for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                                                    id: e,
                                                    length: t,
                                                    value: r
                                                };
                                            },
                                            readBlockZip64EndOfCentralLocator: function() {
                                                if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                                            },
                                            readLocalFiles: function() {
                                                var e, t;
                                                for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                                            },
                                            readCentralDir: function() {
                                                var e;
                                                for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new o({
                                                    zip64: this.zip64
                                                }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                                                if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                                            },
                                            readEndOfCentral: function() {
                                                var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                                                if (e < 0) throw this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
                                                this.reader.setIndex(e);
                                                var t = e;
                                                if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                                                    if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                                                    if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                                                    this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                                                }
                                                var r = this.centralDirOffset + this.centralDirSize;
                                                this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                                                var n = t - r;
                                                if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                                                else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                                            },
                                            prepareReader: function(e) {
                                                this.reader = n(e);
                                            },
                                            load: function(e) {
                                                this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                                            }
                                        }, t.exports = l;
                                    },
                                    {
                                        "./reader/readerFor": 22,
                                        "./signature": 23,
                                        "./support": 30,
                                        "./utils": 32,
                                        "./zipEntry": 34
                                    }
                                ],
                                34: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./compressedObject"), o = e("./crc32"), a = e("./utf8"), l = e("./compressions"), c = e("./support");
                                        function u(e, t) {
                                            this.options = e, this.loadOptions = t;
                                        }
                                        u.prototype = {
                                            isEncrypted: function() {
                                                return 1 == (1 & this.bitFlag);
                                            },
                                            useUTF8: function() {
                                                return 2048 == (2048 & this.bitFlag);
                                            },
                                            readLocalPart: function(e) {
                                                var t, r;
                                                if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                                                if (null === (t = function(e) {
                                                    for(var t in l)if (Object.prototype.hasOwnProperty.call(l, t) && l[t].magic === e) return l[t];
                                                    return null;
                                                }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + i.pretty(this.compressionMethod) + " unknown (inner file : " + i.transformTo("string", this.fileName) + ")");
                                                this.decompressed = new s(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                                            },
                                            readCentralPart: function(e) {
                                                this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                                                var t = e.readInt(2);
                                                if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                                                e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                                            },
                                            processAttributes: function() {
                                                this.unixPermissions = null, this.dosPermissions = null;
                                                var e = this.versionMadeBy >> 8;
                                                this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                                            },
                                            parseZIP64ExtraField: function() {
                                                if (this.extraFields[1]) {
                                                    var e = n(this.extraFields[1].value);
                                                    this.uncompressedSize === i.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === i.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === i.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === i.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                                                }
                                            },
                                            readExtraFields: function(e) {
                                                var t, r, n, i = e.index + this.extraFieldsLength;
                                                for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                                                    id: t,
                                                    length: r,
                                                    value: n
                                                };
                                                e.setIndex(i);
                                            },
                                            handleUTF8: function() {
                                                var e = c.uint8array ? "uint8array" : "array";
                                                if (this.useUTF8()) this.fileNameStr = a.utf8decode(this.fileName), this.fileCommentStr = a.utf8decode(this.fileComment);
                                                else {
                                                    var t = this.findExtraFieldUnicodePath();
                                                    if (null !== t) this.fileNameStr = t;
                                                    else {
                                                        var r = i.transformTo(e, this.fileName);
                                                        this.fileNameStr = this.loadOptions.decodeFileName(r);
                                                    }
                                                    var n = this.findExtraFieldUnicodeComment();
                                                    if (null !== n) this.fileCommentStr = n;
                                                    else {
                                                        var s = i.transformTo(e, this.fileComment);
                                                        this.fileCommentStr = this.loadOptions.decodeFileName(s);
                                                    }
                                                }
                                            },
                                            findExtraFieldUnicodePath: function() {
                                                var e = this.extraFields[28789];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileName) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            },
                                            findExtraFieldUnicodeComment: function() {
                                                var e = this.extraFields[25461];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileComment) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            }
                                        }, t.exports = u;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./compressions": 3,
                                        "./crc32": 4,
                                        "./reader/readerFor": 22,
                                        "./support": 30,
                                        "./utf8": 31,
                                        "./utils": 32
                                    }
                                ],
                                35: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                                                compression: r.compression,
                                                compressionOptions: r.compressionOptions
                                            };
                                        }
                                        var i = e("./stream/StreamHelper"), s = e("./stream/DataWorker"), o = e("./utf8"), a = e("./compressedObject"), l = e("./stream/GenericWorker");
                                        n.prototype = {
                                            internalStream: function(e) {
                                                var t = null, r = "string";
                                                try {
                                                    if (!e) throw new Error("No output type specified.");
                                                    var n = "string" === (r = e.toLowerCase()) || "text" === r;
                                                    "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                                                    var s = !this._dataBinary;
                                                    s && !n && (t = t.pipe(new o.Utf8EncodeWorker)), !s && n && (t = t.pipe(new o.Utf8DecodeWorker));
                                                } catch (e) {
                                                    (t = new l("error")).error(e);
                                                }
                                                return new i(t, r, "");
                                            },
                                            async: function(e, t) {
                                                return this.internalStream(e).accumulate(t);
                                            },
                                            nodeStream: function(e, t) {
                                                return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                                            },
                                            _compressWorker: function(e, t) {
                                                if (this._data instanceof a && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                                                var r = this._decompressWorker();
                                                return this._dataBinary || (r = r.pipe(new o.Utf8EncodeWorker)), a.createWorkerFrom(r, e, t);
                                            },
                                            _decompressWorker: function() {
                                                return this._data instanceof a ? this._data.getContentWorker() : this._data instanceof l ? this._data : new s(this._data);
                                            }
                                        };
                                        for(var c = [
                                            "asText",
                                            "asBinary",
                                            "asNodeBuffer",
                                            "asUint8Array",
                                            "asArrayBuffer"
                                        ], u = function() {
                                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                        }, h = 0; h < c.length; h++)n.prototype[c[h]] = u;
                                        t.exports = n;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./stream/DataWorker": 27,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31
                                    }
                                ],
                                36: [
                                    function(e, t, r) {
                                        (function(e) {
                                            var r, n, i = e.MutationObserver || e.WebKitMutationObserver;
                                            if (i) {
                                                var s = 0, o = new i(u), a = e.document.createTextNode("");
                                                o.observe(a, {
                                                    characterData: !0
                                                }), r = function() {
                                                    a.data = s = ++s % 2;
                                                };
                                            } else if (e.setImmediate || void 0 === e.MessageChannel) r = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function() {
                                                var t = e.document.createElement("script");
                                                t.onreadystatechange = function() {
                                                    u(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
                                                }, e.document.documentElement.appendChild(t);
                                            } : function() {
                                                setTimeout(u, 0);
                                            };
                                            else {
                                                var l = new e.MessageChannel;
                                                l.port1.onmessage = u, r = function() {
                                                    l.port2.postMessage(0);
                                                };
                                            }
                                            var c = [];
                                            function u() {
                                                var e, t;
                                                n = !0;
                                                for(var r = c.length; r;){
                                                    for(t = c, c = [], e = -1; ++e < r;)t[e]();
                                                    r = c.length;
                                                }
                                                n = !1;
                                            }
                                            t.exports = function(e) {
                                                1 !== c.push(e) || n || r();
                                            };
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ],
                                37: [
                                    function(e, t, r) {
                                        var n = e("immediate");
                                        function i() {}
                                        var s = {}, o = [
                                            "REJECTED"
                                        ], a = [
                                            "FULFILLED"
                                        ], l = [
                                            "PENDING"
                                        ];
                                        function c(e) {
                                            if ("function" != typeof e) throw new TypeError("resolver must be a function");
                                            this.state = l, this.queue = [], this.outcome = void 0, e !== i && d(this, e);
                                        }
                                        function u(e, t, r) {
                                            this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                                        }
                                        function h(e, t, r) {
                                            n(function() {
                                                var n;
                                                try {
                                                    n = t(r);
                                                } catch (n) {
                                                    return s.reject(e, n);
                                                }
                                                n === e ? s.reject(e, new TypeError("Cannot resolve promise with itself")) : s.resolve(e, n);
                                            });
                                        }
                                        function f(e) {
                                            var t = e && e.then;
                                            if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                                                t.apply(e, arguments);
                                            };
                                        }
                                        function d(e, t) {
                                            var r = !1;
                                            function n(t) {
                                                r || (r = !0, s.reject(e, t));
                                            }
                                            function i(t) {
                                                r || (r = !0, s.resolve(e, t));
                                            }
                                            var o = p(function() {
                                                t(i, n);
                                            });
                                            "error" === o.status && n(o.value);
                                        }
                                        function p(e, t) {
                                            var r = {};
                                            try {
                                                r.value = e(t), r.status = "success";
                                            } catch (e) {
                                                r.status = "error", r.value = e;
                                            }
                                            return r;
                                        }
                                        (t.exports = c).prototype.finally = function(e) {
                                            if ("function" != typeof e) return this;
                                            var t = this.constructor;
                                            return this.then(function(r) {
                                                return t.resolve(e()).then(function() {
                                                    return r;
                                                });
                                            }, function(r) {
                                                return t.resolve(e()).then(function() {
                                                    throw r;
                                                });
                                            });
                                        }, c.prototype.catch = function(e) {
                                            return this.then(null, e);
                                        }, c.prototype.then = function(e, t) {
                                            if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === o) return this;
                                            var r = new this.constructor(i);
                                            return this.state !== l ? h(r, this.state === a ? e : t, this.outcome) : this.queue.push(new u(r, e, t)), r;
                                        }, u.prototype.callFulfilled = function(e) {
                                            s.resolve(this.promise, e);
                                        }, u.prototype.otherCallFulfilled = function(e) {
                                            h(this.promise, this.onFulfilled, e);
                                        }, u.prototype.callRejected = function(e) {
                                            s.reject(this.promise, e);
                                        }, u.prototype.otherCallRejected = function(e) {
                                            h(this.promise, this.onRejected, e);
                                        }, s.resolve = function(e, t) {
                                            var r = p(f, t);
                                            if ("error" === r.status) return s.reject(e, r.value);
                                            var n = r.value;
                                            if (n) d(e, n);
                                            else {
                                                e.state = a, e.outcome = t;
                                                for(var i = -1, o = e.queue.length; ++i < o;)e.queue[i].callFulfilled(t);
                                            }
                                            return e;
                                        }, s.reject = function(e, t) {
                                            e.state = o, e.outcome = t;
                                            for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                                            return e;
                                        }, c.resolve = function(e) {
                                            return e instanceof this ? e : s.resolve(new this(i), e);
                                        }, c.reject = function(e) {
                                            var t = new this(i);
                                            return s.reject(t, e);
                                        }, c.all = function(e) {
                                            var t = this;
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var r = e.length, n = !1;
                                            if (!r) return this.resolve([]);
                                            for(var o = new Array(r), a = 0, l = -1, c = new this(i); ++l < r;)u(e[l], l);
                                            return c;
                                            function u(e, i) {
                                                t.resolve(e).then(function(e) {
                                                    o[i] = e, ++a !== r || n || (n = !0, s.resolve(c, o));
                                                }, function(e) {
                                                    n || (n = !0, s.reject(c, e));
                                                });
                                            }
                                        }, c.race = function(e) {
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var t = e.length, r = !1;
                                            if (!t) return this.resolve([]);
                                            for(var n, o = -1, a = new this(i); ++o < t;)n = e[o], this.resolve(n).then(function(e) {
                                                r || (r = !0, s.resolve(a, e));
                                            }, function(e) {
                                                r || (r = !0, s.reject(a, e));
                                            });
                                            return a;
                                        };
                                    },
                                    {
                                        immediate: 36
                                    }
                                ],
                                38: [
                                    function(e, t, r) {
                                        var n = {};
                                        (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
                                    },
                                    {
                                        "./lib/deflate": 39,
                                        "./lib/inflate": 40,
                                        "./lib/utils/common": 41,
                                        "./lib/zlib/constants": 44
                                    }
                                ],
                                39: [
                                    function(e, t, r) {
                                        var n = e("./zlib/deflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/messages"), a = e("./zlib/zstream"), l = Object.prototype.toString;
                                        function c(e) {
                                            if (!(this instanceof c)) return new c(e);
                                            this.options = i.assign({
                                                level: -1,
                                                method: 8,
                                                chunkSize: 16384,
                                                windowBits: 15,
                                                memLevel: 8,
                                                strategy: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new a, this.strm.avail_out = 0;
                                            var r = n.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                                            if (0 !== r) throw new Error(o[r]);
                                            if (t.header && n.deflateSetHeader(this.strm, t.header), t.dictionary) {
                                                var u;
                                                if (u = "string" == typeof t.dictionary ? s.string2buf(t.dictionary) : "[object ArrayBuffer]" === l.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, 0 !== (r = n.deflateSetDictionary(this.strm, u))) throw new Error(o[r]);
                                                this._dict_set = !0;
                                            }
                                        }
                                        function u(e, t) {
                                            var r = new c(t);
                                            if (r.push(e, !0), r.err) throw r.msg || o[r.err];
                                            return r.result;
                                        }
                                        c.prototype.push = function(e, t) {
                                            var r, o, a = this.strm, c = this.options.chunkSize;
                                            if (this.ended) return !1;
                                            o = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? a.input = s.string2buf(e) : "[object ArrayBuffer]" === l.call(e) ? a.input = new Uint8Array(e) : a.input = e, a.next_in = 0, a.avail_in = a.input.length;
                                            do {
                                                if (0 === a.avail_out && (a.output = new i.Buf8(c), a.next_out = 0, a.avail_out = c), 1 !== (r = n.deflate(a, o)) && 0 !== r) return this.onEnd(r), this.ended = !0, false;
                                                0 !== a.avail_out && (0 !== a.avail_in || 4 !== o && 2 !== o) || ("string" === this.options.to ? this.onData(s.buf2binstring(i.shrinkBuf(a.output, a.next_out))) : this.onData(i.shrinkBuf(a.output, a.next_out)));
                                            }while ((0 < a.avail_in || 0 === a.avail_out) && 1 !== r);
                                            return 4 === o ? (r = n.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, 0 === r) : 2 !== o || (this.onEnd(0), a.avail_out = 0, true);
                                        }, c.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, c.prototype.onEnd = function(e) {
                                            0 === e && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Deflate = c, r.deflate = u, r.deflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, u(e, t);
                                        }, r.gzip = function(e, t) {
                                            return (t = t || {}).gzip = !0, u(e, t);
                                        };
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/deflate": 46,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                40: [
                                    function(e, t, r) {
                                        var n = e("./zlib/inflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/constants"), a = e("./zlib/messages"), l = e("./zlib/zstream"), c = e("./zlib/gzheader"), u = Object.prototype.toString;
                                        function h(e) {
                                            if (!(this instanceof h)) return new h(e);
                                            this.options = i.assign({
                                                chunkSize: 16384,
                                                windowBits: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l, this.strm.avail_out = 0;
                                            var r = n.inflateInit2(this.strm, t.windowBits);
                                            if (r !== o.Z_OK) throw new Error(a[r]);
                                            this.header = new c, n.inflateGetHeader(this.strm, this.header);
                                        }
                                        function f(e, t) {
                                            var r = new h(t);
                                            if (r.push(e, !0), r.err) throw r.msg || a[r.err];
                                            return r.result;
                                        }
                                        h.prototype.push = function(e, t) {
                                            var r, a, l, c, h, f, d = this.strm, p = this.options.chunkSize, m = this.options.dictionary, b = !1;
                                            if (this.ended) return !1;
                                            a = t === ~~t ? t : !0 === t ? o.Z_FINISH : o.Z_NO_FLUSH, "string" == typeof e ? d.input = s.binstring2buf(e) : "[object ArrayBuffer]" === u.call(e) ? d.input = new Uint8Array(e) : d.input = e, d.next_in = 0, d.avail_in = d.input.length;
                                            do {
                                                if (0 === d.avail_out && (d.output = new i.Buf8(p), d.next_out = 0, d.avail_out = p), (r = n.inflate(d, o.Z_NO_FLUSH)) === o.Z_NEED_DICT && m && (f = "string" == typeof m ? s.string2buf(m) : "[object ArrayBuffer]" === u.call(m) ? new Uint8Array(m) : m, r = n.inflateSetDictionary(this.strm, f)), r === o.Z_BUF_ERROR && !0 === b && (r = o.Z_OK, b = !1), r !== o.Z_STREAM_END && r !== o.Z_OK) return this.onEnd(r), this.ended = !0, false;
                                                d.next_out && (0 !== d.avail_out && r !== o.Z_STREAM_END && (0 !== d.avail_in || a !== o.Z_FINISH && a !== o.Z_SYNC_FLUSH) || ("string" === this.options.to ? (l = s.utf8border(d.output, d.next_out), c = d.next_out - l, h = s.buf2string(d.output, l), d.next_out = c, d.avail_out = p - c, c && i.arraySet(d.output, d.output, l, c, 0), this.onData(h)) : this.onData(i.shrinkBuf(d.output, d.next_out)))), 0 === d.avail_in && 0 === d.avail_out && (b = !0);
                                            }while ((0 < d.avail_in || 0 === d.avail_out) && r !== o.Z_STREAM_END);
                                            return r === o.Z_STREAM_END && (a = o.Z_FINISH), a === o.Z_FINISH ? (r = n.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === o.Z_OK) : a !== o.Z_SYNC_FLUSH || (this.onEnd(o.Z_OK), d.avail_out = 0, true);
                                        }, h.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, h.prototype.onEnd = function(e) {
                                            e === o.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Inflate = h, r.inflate = f, r.inflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, f(e, t);
                                        }, r.ungzip = f;
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/constants": 44,
                                        "./zlib/gzheader": 47,
                                        "./zlib/inflate": 49,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                41: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                                        r.assign = function(e) {
                                            for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                                                var r = t.shift();
                                                if (r) {
                                                    if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                                                    for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                                                }
                                            }
                                            return e;
                                        }, r.shrinkBuf = function(e, t) {
                                            return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                                        };
                                        var i = {
                                            arraySet: function(e, t, r, n, i) {
                                                if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                                                else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                var t, r, n, i, s, o;
                                                for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                                                for(o = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], o.set(s, i), i += s.length;
                                                return o;
                                            }
                                        }, s = {
                                            arraySet: function(e, t, r, n, i) {
                                                for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                return [].concat.apply([], e);
                                            }
                                        };
                                        r.setTyped = function(e) {
                                            e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                                        }, r.setTyped(n);
                                    },
                                    {}
                                ],
                                42: [
                                    function(e, t, r) {
                                        var n = e("./common"), i = !0, s = !0;
                                        try {
                                            String.fromCharCode.apply(null, [
                                                0
                                            ]);
                                        } catch (e) {
                                            i = !1;
                                        }
                                        try {
                                            String.fromCharCode.apply(null, new Uint8Array(1));
                                        } catch (e) {
                                            s = !1;
                                        }
                                        for(var o = new n.Buf8(256), a = 0; a < 256; a++)o[a] = 252 <= a ? 6 : 248 <= a ? 5 : 240 <= a ? 4 : 224 <= a ? 3 : 192 <= a ? 2 : 1;
                                        function l(e, t) {
                                            if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, n.shrinkBuf(e, t));
                                            for(var r = "", o = 0; o < t; o++)r += String.fromCharCode(e[o]);
                                            return r;
                                        }
                                        o[254] = o[254] = 1, r.string2buf = function(e) {
                                            var t, r, i, s, o, a = e.length, l = 0;
                                            for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                            for(t = new n.Buf8(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                            return t;
                                        }, r.buf2binstring = function(e) {
                                            return l(e, e.length);
                                        }, r.binstring2buf = function(e) {
                                            for(var t = new n.Buf8(e.length), r = 0, i = t.length; r < i; r++)t[r] = e.charCodeAt(r);
                                            return t;
                                        }, r.buf2string = function(e, t) {
                                            var r, n, i, s, a = t || e.length, c = new Array(2 * a);
                                            for(r = n = 0; r < a;)if ((i = e[r++]) < 128) c[n++] = i;
                                            else if (4 < (s = o[i])) c[n++] = 65533, r += s - 1;
                                            else {
                                                for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                                                1 < s ? c[n++] = 65533 : i < 65536 ? c[n++] = i : (i -= 65536, c[n++] = 55296 | i >> 10 & 1023, c[n++] = 56320 | 1023 & i);
                                            }
                                            return l(c, n);
                                        }, r.utf8border = function(e, t) {
                                            var r;
                                            for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                            return r < 0 || 0 === r ? t : r + o[e[r]] > t ? r : t;
                                        };
                                    },
                                    {
                                        "./common": 41
                                    }
                                ],
                                43: [
                                    function(e, t, r) {
                                        t.exports = function(e, t, r, n) {
                                            for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, o = 0; 0 !== r;){
                                                for(r -= o = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --o;);
                                                i %= 65521, s %= 65521;
                                            }
                                            return i | s << 16 | 0;
                                        };
                                    },
                                    {}
                                ],
                                44: [
                                    function(e, t, r) {
                                        t.exports = {
                                            Z_NO_FLUSH: 0,
                                            Z_PARTIAL_FLUSH: 1,
                                            Z_SYNC_FLUSH: 2,
                                            Z_FULL_FLUSH: 3,
                                            Z_FINISH: 4,
                                            Z_BLOCK: 5,
                                            Z_TREES: 6,
                                            Z_OK: 0,
                                            Z_STREAM_END: 1,
                                            Z_NEED_DICT: 2,
                                            Z_ERRNO: -1,
                                            Z_STREAM_ERROR: -2,
                                            Z_DATA_ERROR: -3,
                                            Z_BUF_ERROR: -5,
                                            Z_NO_COMPRESSION: 0,
                                            Z_BEST_SPEED: 1,
                                            Z_BEST_COMPRESSION: 9,
                                            Z_DEFAULT_COMPRESSION: -1,
                                            Z_FILTERED: 1,
                                            Z_HUFFMAN_ONLY: 2,
                                            Z_RLE: 3,
                                            Z_FIXED: 4,
                                            Z_DEFAULT_STRATEGY: 0,
                                            Z_BINARY: 0,
                                            Z_TEXT: 1,
                                            Z_UNKNOWN: 2,
                                            Z_DEFLATED: 8
                                        };
                                    },
                                    {}
                                ],
                                45: [
                                    function(e, t, r) {
                                        var n = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t, r, i) {
                                            var s = n, o = i + r;
                                            e ^= -1;
                                            for(var a = i; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                            return -1 ^ e;
                                        };
                                    },
                                    {}
                                ],
                                46: [
                                    function(e, t, r) {
                                        var n, i = e("../utils/common"), s = e("./trees"), o = e("./adler32"), a = e("./crc32"), l = e("./messages"), c = -2, u = 258, h = 262, f = 113;
                                        function d(e, t) {
                                            return e.msg = l[t], t;
                                        }
                                        function p(e) {
                                            return (e << 1) - (4 < e ? 9 : 0);
                                        }
                                        function m(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        function b(e) {
                                            var t = e.state, r = t.pending;
                                            r > e.avail_out && (r = e.avail_out), 0 !== r && (i.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                                        }
                                        function g(e, t) {
                                            s._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, b(e.strm);
                                        }
                                        function y(e, t) {
                                            e.pending_buf[e.pending++] = t;
                                        }
                                        function v(e, t) {
                                            e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                                        }
                                        function w(e, t) {
                                            var r, n, i = e.max_chain_length, s = e.strstart, o = e.prev_length, a = e.nice_match, l = e.strstart > e.w_size - h ? e.strstart - (e.w_size - h) : 0, c = e.window, f = e.w_mask, d = e.prev, p = e.strstart + u, m = c[s + o - 1], b = c[s + o];
                                            e.prev_length >= e.good_match && (i >>= 2), a > e.lookahead && (a = e.lookahead);
                                            do if (c[(r = t) + o] === b && c[r + o - 1] === m && c[r] === c[s] && c[++r] === c[s + 1]) {
                                                s += 2, r++;
                                                do ;
                                                while (c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && s < p);
                                                if (n = u - (p - s), s = p - u, o < n) {
                                                    if (e.match_start = t, a <= (o = n)) break;
                                                    m = c[s + o - 1], b = c[s + o];
                                                }
                                            }
                                            while ((t = d[t & f]) > l && 0 != --i);
                                            return o <= e.lookahead ? o : e.lookahead;
                                        }
                                        function _(e) {
                                            var t, r, n, s, l, c, u, f, d, p, m = e.w_size;
                                            do {
                                                if (s = e.window_size - e.lookahead - e.strstart, e.strstart >= m + (m - h)) {
                                                    for(i.arraySet(e.window, e.window, m, m, 0), e.match_start -= m, e.strstart -= m, e.block_start -= m, t = r = e.hash_size; n = e.head[--t], e.head[t] = m <= n ? n - m : 0, --r;);
                                                    for(t = r = m; n = e.prev[--t], e.prev[t] = m <= n ? n - m : 0, --r;);
                                                    s += m;
                                                }
                                                if (0 === e.strm.avail_in) break;
                                                if (c = e.strm, u = e.window, f = e.strstart + e.lookahead, p = void 0, (d = s) < (p = c.avail_in) && (p = d), r = 0 === p ? 0 : (c.avail_in -= p, i.arraySet(u, c.input, c.next_in, p, f), 1 === c.state.wrap ? c.adler = o(c.adler, u, p, f) : 2 === c.state.wrap && (c.adler = a(c.adler, u, p, f)), c.next_in += p, c.total_in += p, p), e.lookahead += r, e.lookahead + e.insert >= 3) for(l = e.strstart - e.insert, e.ins_h = e.window[l], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 3 - 1]) & e.hash_mask, e.prev[l & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = l, l++, e.insert--, !(e.lookahead + e.insert < 3)););
                                            }while (e.lookahead < h && 0 !== e.strm.avail_in);
                                        }
                                        function x(e, t) {
                                            for(var r, n;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r)), e.match_length >= 3) {
                                                    if (n = s._tr_tally(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
                                                        for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                                        e.strstart++;
                                                    } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                                                } else n = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                                                if (n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                            }
                                            return e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function k(e, t) {
                                            for(var r, n, i;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r), e.match_length <= 5 && (1 === e.strategy || 3 === e.match_length && 4096 < e.strstart - e.match_start) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
                                                    for(i = e.strstart + e.lookahead - 3, n = s._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                                                    if (e.match_available = 0, e.match_length = 2, e.strstart++, n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                } else if (e.match_available) {
                                                    if ((n = s._tr_tally(e, 0, e.window[e.strstart - 1])) && g(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return 1;
                                                } else e.match_available = 1, e.strstart++, e.lookahead--;
                                            }
                                            return e.match_available && (n = s._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function S(e, t, r, n, i) {
                                            this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                                        }
                                        function M() {
                                            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(1146), this.dyn_dtree = new i.Buf16(122), this.bl_tree = new i.Buf16(78), m(this.dyn_ltree), m(this.dyn_dtree), m(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(16), this.heap = new i.Buf16(573), m(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(573), m(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                                        }
                                        function C(e) {
                                            var t;
                                            return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = 2, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? 42 : f, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = 0, s._tr_init(t), 0) : d(e, c);
                                        }
                                        function T(e) {
                                            var t = C(e);
                                            return 0 === t && function(e) {
                                                e.window_size = 2 * e.w_size, m(e.head), e.max_lazy_match = n[e.level].max_lazy, e.good_match = n[e.level].good_length, e.nice_match = n[e.level].nice_length, e.max_chain_length = n[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = 2, e.match_available = 0, e.ins_h = 0;
                                            }(e.state), t;
                                        }
                                        function E(e, t, r, n, s, o) {
                                            if (!e) return c;
                                            var a = 1;
                                            if (-1 === t && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), s < 1 || 9 < s || 8 !== r || n < 8 || 15 < n || t < 0 || 9 < t || o < 0 || 4 < o) return d(e, c);
                                            8 === n && (n = 9);
                                            var l = new M;
                                            return (e.state = l).strm = e, l.wrap = a, l.gzhead = null, l.w_bits = n, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = s + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + 3 - 1) / 3), l.window = new i.Buf8(2 * l.w_size), l.head = new i.Buf16(l.hash_size), l.prev = new i.Buf16(l.w_size), l.lit_bufsize = 1 << s + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new i.Buf8(l.pending_buf_size), l.d_buf = 1 * l.lit_bufsize, l.l_buf = 3 * l.lit_bufsize, l.level = t, l.strategy = o, l.method = r, T(e);
                                        }
                                        n = [
                                            new S(0, 0, 0, 0, function(e, t) {
                                                var r = 65535;
                                                for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                                                    if (e.lookahead <= 1) {
                                                        if (_(e), 0 === e.lookahead && 0 === t) return 1;
                                                        if (0 === e.lookahead) break;
                                                    }
                                                    e.strstart += e.lookahead, e.lookahead = 0;
                                                    var n = e.block_start + r;
                                                    if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    if (e.strstart - e.block_start >= e.w_size - h && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                }
                                                return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : (e.strstart > e.block_start && (g(e, !1), e.strm.avail_out), 1);
                                            }),
                                            new S(4, 4, 8, 4, x),
                                            new S(4, 5, 16, 8, x),
                                            new S(4, 6, 32, 32, x),
                                            new S(4, 4, 16, 16, k),
                                            new S(8, 16, 32, 32, k),
                                            new S(8, 16, 128, 128, k),
                                            new S(8, 32, 128, 256, k),
                                            new S(32, 128, 258, 1024, k),
                                            new S(32, 258, 258, 4096, k)
                                        ], r.deflateInit = function(e, t) {
                                            return E(e, t, 8, 15, 8, 0);
                                        }, r.deflateInit2 = E, r.deflateReset = T, r.deflateResetKeep = C, r.deflateSetHeader = function(e, t) {
                                            return e && e.state ? 2 !== e.state.wrap ? c : (e.state.gzhead = t, 0) : c;
                                        }, r.deflate = function(e, t) {
                                            var r, i, o, l;
                                            if (!e || !e.state || 5 < t || t < 0) return e ? d(e, c) : c;
                                            if (i = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === i.status && 4 !== t) return d(e, 0 === e.avail_out ? -5 : c);
                                            if (i.strm = e, r = i.last_flush, i.last_flush = t, 42 === i.status) {
                                                if (2 === i.wrap) e.adler = 0, y(i, 31), y(i, 139), y(i, 8), i.gzhead ? (y(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), y(i, 255 & i.gzhead.time), y(i, i.gzhead.time >> 8 & 255), y(i, i.gzhead.time >> 16 & 255), y(i, i.gzhead.time >> 24 & 255), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (y(i, 255 & i.gzhead.extra.length), y(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = a(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 3), i.status = f);
                                                else {
                                                    var h = 8 + (i.w_bits - 8 << 4) << 8;
                                                    h |= (2 <= i.strategy || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (h |= 32), h += 31 - h % 31, i.status = f, v(i, h), 0 !== i.strstart && (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), e.adler = 1;
                                                }
                                            }
                                            if (69 === i.status) {
                                                if (i.gzhead.extra) {
                                                    for(o = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending !== i.pending_buf_size));)y(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
                                                } else i.status = 73;
                                            }
                                            if (73 === i.status) {
                                                if (i.gzhead.name) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.gzindex = 0, i.status = 91);
                                                } else i.status = 91;
                                            }
                                            if (91 === i.status) {
                                                if (i.gzhead.comment) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.status = 103);
                                                } else i.status = 103;
                                            }
                                            if (103 === i.status && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && b(e), i.pending + 2 <= i.pending_buf_size && (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), e.adler = 0, i.status = f)) : i.status = f), 0 !== i.pending) {
                                                if (b(e), 0 === e.avail_out) return i.last_flush = -1, 0;
                                            } else if (0 === e.avail_in && p(t) <= p(r) && 4 !== t) return d(e, -5);
                                            if (666 === i.status && 0 !== e.avail_in) return d(e, -5);
                                            if (0 !== e.avail_in || 0 !== i.lookahead || 0 !== t && 666 !== i.status) {
                                                var w = 2 === i.strategy ? function(e, t) {
                                                    for(var r;;){
                                                        if (0 === e.lookahead && (_(e), 0 === e.lookahead)) {
                                                            if (0 === t) return 1;
                                                            break;
                                                        }
                                                        if (e.match_length = 0, r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : 3 === i.strategy ? function(e, t) {
                                                    for(var r, n, i, o, a = e.window;;){
                                                        if (e.lookahead <= u) {
                                                            if (_(e), e.lookahead <= u && 0 === t) return 1;
                                                            if (0 === e.lookahead) break;
                                                        }
                                                        if (e.match_length = 0, e.lookahead >= 3 && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                                            o = e.strstart + u;
                                                            do ;
                                                            while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < o);
                                                            e.match_length = u - (o - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                                        }
                                                        if (e.match_length >= 3 ? (r = s._tr_tally(e, 1, e.match_length - 3), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : n[i.level].func(i, t);
                                                if (3 !== w && 4 !== w || (i.status = 666), 1 === w || 3 === w) return 0 === e.avail_out && (i.last_flush = -1), 0;
                                                if (2 === w && (1 === t ? s._tr_align(i) : 5 !== t && (s._tr_stored_block(i, 0, 0, !1), 3 === t && (m(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), b(e), 0 === e.avail_out)) return i.last_flush = -1, 0;
                                            }
                                            return 4 !== t ? 0 : i.wrap <= 0 ? 1 : (2 === i.wrap ? (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), y(i, e.adler >> 16 & 255), y(i, e.adler >> 24 & 255), y(i, 255 & e.total_in), y(i, e.total_in >> 8 & 255), y(i, e.total_in >> 16 & 255), y(i, e.total_in >> 24 & 255)) : (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), b(e), 0 < i.wrap && (i.wrap = -i.wrap), 0 !== i.pending ? 0 : 1);
                                        }, r.deflateEnd = function(e) {
                                            var t;
                                            return e && e.state ? 42 !== (t = e.state.status) && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== f && 666 !== t ? d(e, c) : (e.state = null, t === f ? d(e, -3) : 0) : c;
                                        }, r.deflateSetDictionary = function(e, t) {
                                            var r, n, s, a, l, u, h, f, d = t.length;
                                            if (!e || !e.state) return c;
                                            if (2 === (a = (r = e.state).wrap) || 1 === a && 42 !== r.status || r.lookahead) return c;
                                            for(1 === a && (e.adler = o(e.adler, t, d, 0)), r.wrap = 0, d >= r.w_size && (0 === a && (m(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), f = new i.Buf8(r.w_size), i.arraySet(f, t, d - r.w_size, r.w_size, 0), t = f, d = r.w_size), l = e.avail_in, u = e.next_in, h = e.input, e.avail_in = d, e.next_in = 0, e.input = t, _(r); r.lookahead >= 3;){
                                                for(n = r.strstart, s = r.lookahead - 2; r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + 3 - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --s;);
                                                r.strstart = n, r.lookahead = 2, _(r);
                                            }
                                            return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, e.next_in = u, e.input = h, e.avail_in = l, r.wrap = a, 0;
                                        }, r.deflateInfo = "pako deflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./messages": 51,
                                        "./trees": 52
                                    }
                                ],
                                47: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                                        };
                                    },
                                    {}
                                ],
                                48: [
                                    function(e, t, r) {
                                        t.exports = function(e, t) {
                                            var r, n, i, s, o, a, l, c, u, h, f, d, p, m, b, g, y, v, w, _, x, k, S, M, C;
                                            r = e.state, n = e.next_in, M = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, o = s - (t - e.avail_out), a = s + (e.avail_out - 257), l = r.dmax, c = r.wsize, u = r.whave, h = r.wnext, f = r.window, d = r.hold, p = r.bits, m = r.lencode, b = r.distcode, g = (1 << r.lenbits) - 1, y = (1 << r.distbits) - 1;
                                            e: do {
                                                p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = m[d & g];
                                                t: for(;;){
                                                    if (d >>>= w = v >>> 24, p -= w, 0 == (w = v >>> 16 & 255)) C[s++] = 65535 & v;
                                                    else {
                                                        if (!(16 & w)) {
                                                            if (0 == (64 & w)) {
                                                                v = m[(65535 & v) + (d & (1 << w) - 1)];
                                                                continue t;
                                                            }
                                                            if (32 & w) {
                                                                r.mode = 12;
                                                                break e;
                                                            }
                                                            e.msg = "invalid literal/length code", r.mode = 30;
                                                            break e;
                                                        }
                                                        _ = 65535 & v, (w &= 15) && (p < w && (d += M[n++] << p, p += 8), _ += d & (1 << w) - 1, d >>>= w, p -= w), p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = b[d & y];
                                                        r: for(;;){
                                                            if (d >>>= w = v >>> 24, p -= w, !(16 & (w = v >>> 16 & 255))) {
                                                                if (0 == (64 & w)) {
                                                                    v = b[(65535 & v) + (d & (1 << w) - 1)];
                                                                    continue r;
                                                                }
                                                                e.msg = "invalid distance code", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (x = 65535 & v, p < (w &= 15) && (d += M[n++] << p, (p += 8) < w && (d += M[n++] << p, p += 8)), l < (x += d & (1 << w) - 1)) {
                                                                e.msg = "invalid distance too far back", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (d >>>= w, p -= w, (w = s - o) < x) {
                                                                if (u < (w = x - w) && r.sane) {
                                                                    e.msg = "invalid distance too far back", r.mode = 30;
                                                                    break e;
                                                                }
                                                                if (S = f, (k = 0) === h) {
                                                                    if (k += c - w, w < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        k = s - x, S = C;
                                                                    }
                                                                } else if (h < w) {
                                                                    if (k += c + h - w, (w -= h) < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        if (k = 0, h < _) {
                                                                            for(_ -= w = h; C[s++] = f[k++], --w;);
                                                                            k = s - x, S = C;
                                                                        }
                                                                    }
                                                                } else if (k += h - w, w < _) {
                                                                    for(_ -= w; C[s++] = f[k++], --w;);
                                                                    k = s - x, S = C;
                                                                }
                                                                for(; 2 < _;)C[s++] = S[k++], C[s++] = S[k++], C[s++] = S[k++], _ -= 3;
                                                                _ && (C[s++] = S[k++], 1 < _ && (C[s++] = S[k++]));
                                                            } else {
                                                                for(k = s - x; C[s++] = C[k++], C[s++] = C[k++], C[s++] = C[k++], 2 < (_ -= 3););
                                                                _ && (C[s++] = C[k++], 1 < _ && (C[s++] = C[k++]));
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    break;
                                                }
                                            }while (n < i && s < a);
                                            n -= _ = p >> 3, d &= (1 << (p -= _ << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < a ? a - s + 257 : 257 - (s - a), r.hold = d, r.bits = p;
                                        };
                                    },
                                    {}
                                ],
                                49: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = e("./adler32"), s = e("./crc32"), o = e("./inffast"), a = e("./inftrees"), l = -2;
                                        function c(e) {
                                            return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                                        }
                                        function u() {
                                            this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                                        }
                                        function h(e) {
                                            var t;
                                            return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = 1, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new n.Buf32(852), t.distcode = t.distdyn = new n.Buf32(592), t.sane = 1, t.back = -1, 0) : l;
                                        }
                                        function f(e) {
                                            var t;
                                            return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, h(e)) : l;
                                        }
                                        function d(e, t) {
                                            var r, n;
                                            return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? l : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, f(e))) : l;
                                        }
                                        function p(e, t) {
                                            var r, n;
                                            return e ? (n = new u, (e.state = n).window = null, 0 !== (r = d(e, t)) && (e.state = null), r) : l;
                                        }
                                        var m, b, g = !0;
                                        function y(e) {
                                            if (g) {
                                                var t;
                                                for(m = new n.Buf32(512), b = new n.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                                                for(; t < 256;)e.lens[t++] = 9;
                                                for(; t < 280;)e.lens[t++] = 7;
                                                for(; t < 288;)e.lens[t++] = 8;
                                                for(a(1, e.lens, 0, 288, m, 0, e.work, {
                                                    bits: 9
                                                }), t = 0; t < 32;)e.lens[t++] = 5;
                                                a(2, e.lens, 0, 32, b, 0, e.work, {
                                                    bits: 5
                                                }), g = !1;
                                            }
                                            e.lencode = m, e.lenbits = 9, e.distcode = b, e.distbits = 5;
                                        }
                                        function v(e, t, r, i) {
                                            var s, o = e.state;
                                            return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new n.Buf8(o.wsize)), i >= o.wsize ? (n.arraySet(o.window, t, r - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : (i < (s = o.wsize - o.wnext) && (s = i), n.arraySet(o.window, t, r - i, s, o.wnext), (i -= s) ? (n.arraySet(o.window, t, r - i, i, 0), o.wnext = i, o.whave = o.wsize) : (o.wnext += s, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += s))), 0;
                                        }
                                        r.inflateReset = f, r.inflateReset2 = d, r.inflateResetKeep = h, r.inflateInit = function(e) {
                                            return p(e, 15);
                                        }, r.inflateInit2 = p, r.inflate = function(e, t) {
                                            var r, u, h, f, d, p, m, b, g, w, _, x, k, S, M, C, T, E, A, R, O, j, I, N, P = 0, B = new n.Buf8(4), D = [
                                                16,
                                                17,
                                                18,
                                                0,
                                                8,
                                                7,
                                                9,
                                                6,
                                                10,
                                                5,
                                                11,
                                                4,
                                                12,
                                                3,
                                                13,
                                                2,
                                                14,
                                                1,
                                                15
                                            ];
                                            if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return l;
                                            12 === (r = e.state).mode && (r.mode = 13), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, w = p, _ = m, j = 0;
                                            e: for(;;)switch(r.mode){
                                                case 1:
                                                    if (0 === r.wrap) {
                                                        r.mode = 13;
                                                        break;
                                                    }
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (2 & r.wrap && 35615 === b) {
                                                        B[r.check = 0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0), g = b = 0, r.mode = 2;
                                                        break;
                                                    }
                                                    if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & b) << 8) + (b >> 8)) % 31) {
                                                        e.msg = "incorrect header check", r.mode = 30;
                                                        break;
                                                    }
                                                    if (8 != (15 & b)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (g -= 4, O = 8 + (15 & (b >>>= 4)), 0 === r.wbits) r.wbits = O;
                                                    else if (O > r.wbits) {
                                                        e.msg = "invalid window size", r.mode = 30;
                                                        break;
                                                    }
                                                    r.dmax = 1 << O, e.adler = r.check = 1, r.mode = 512 & b ? 10 : 12, g = b = 0;
                                                    break;
                                                case 2:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.flags = b, 8 != (255 & r.flags)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (57344 & r.flags) {
                                                        e.msg = "unknown header flags set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.head && (r.head.text = b >> 8 & 1), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 3;
                                                case 3:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.time = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, B[2] = b >>> 16 & 255, B[3] = b >>> 24 & 255, r.check = s(r.check, B, 4, 0)), g = b = 0, r.mode = 4;
                                                case 4:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.xflags = 255 & b, r.head.os = b >> 8), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 5;
                                                case 5:
                                                    if (1024 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length = b, r.head && (r.head.extra_len = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0;
                                                    } else r.head && (r.head.extra = null);
                                                    r.mode = 6;
                                                case 6:
                                                    if (1024 & r.flags && (p < (x = r.length) && (x = p), x && (r.head && (O = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, u, f, x, O)), 512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, r.length -= x), r.length)) break e;
                                                    r.length = 0, r.mode = 7;
                                                case 7:
                                                    if (2048 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.name += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.name = null);
                                                    r.length = 0, r.mode = 8;
                                                case 8:
                                                    if (4096 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.comment += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.comment = null);
                                                    r.mode = 9;
                                                case 9:
                                                    if (512 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (65535 & r.check)) {
                                                            e.msg = "header crc mismatch", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                                                    break;
                                                case 10:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    e.adler = r.check = c(b), g = b = 0, r.mode = 11;
                                                case 11:
                                                    if (0 === r.havedict) return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, 2;
                                                    e.adler = r.check = 1, r.mode = 12;
                                                case 12:
                                                    if (5 === t || 6 === t) break e;
                                                case 13:
                                                    if (r.last) {
                                                        b >>>= 7 & g, g -= 7 & g, r.mode = 27;
                                                        break;
                                                    }
                                                    for(; g < 3;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    switch(r.last = 1 & b, g -= 1, 3 & (b >>>= 1)){
                                                        case 0:
                                                            r.mode = 14;
                                                            break;
                                                        case 1:
                                                            if (y(r), r.mode = 20, 6 !== t) break;
                                                            b >>>= 2, g -= 2;
                                                            break e;
                                                        case 2:
                                                            r.mode = 17;
                                                            break;
                                                        case 3:
                                                            e.msg = "invalid block type", r.mode = 30;
                                                    }
                                                    b >>>= 2, g -= 2;
                                                    break;
                                                case 14:
                                                    for(b >>>= 7 & g, g -= 7 & g; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if ((65535 & b) != (b >>> 16 ^ 65535)) {
                                                        e.msg = "invalid stored block lengths", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.length = 65535 & b, g = b = 0, r.mode = 15, 6 === t) break e;
                                                case 15:
                                                    r.mode = 16;
                                                case 16:
                                                    if (x = r.length) {
                                                        if (p < x && (x = p), m < x && (x = m), 0 === x) break e;
                                                        n.arraySet(h, u, f, x, d), p -= x, f += x, m -= x, d += x, r.length -= x;
                                                        break;
                                                    }
                                                    r.mode = 12;
                                                    break;
                                                case 17:
                                                    for(; g < 14;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.nlen = 257 + (31 & b), b >>>= 5, g -= 5, r.ndist = 1 + (31 & b), b >>>= 5, g -= 5, r.ncode = 4 + (15 & b), b >>>= 4, g -= 4, 286 < r.nlen || 30 < r.ndist) {
                                                        e.msg = "too many length or distance symbols", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 18;
                                                case 18:
                                                    for(; r.have < r.ncode;){
                                                        for(; g < 3;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.lens[D[r.have++]] = 7 & b, b >>>= 3, g -= 3;
                                                    }
                                                    for(; r.have < 19;)r.lens[D[r.have++]] = 0;
                                                    if (r.lencode = r.lendyn, r.lenbits = 7, I = {
                                                        bits: r.lenbits
                                                    }, j = a(0, r.lens, 0, 19, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid code lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 19;
                                                case 19:
                                                    for(; r.have < r.nlen + r.ndist;){
                                                        for(; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (T < 16) b >>>= M, g -= M, r.lens[r.have++] = T;
                                                        else {
                                                            if (16 === T) {
                                                                for(N = M + 2; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                if (b >>>= M, g -= M, 0 === r.have) {
                                                                    e.msg = "invalid bit length repeat", r.mode = 30;
                                                                    break;
                                                                }
                                                                O = r.lens[r.have - 1], x = 3 + (3 & b), b >>>= 2, g -= 2;
                                                            } else if (17 === T) {
                                                                for(N = M + 3; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 3 + (7 & (b >>>= M)), b >>>= 3, g -= 3;
                                                            } else {
                                                                for(N = M + 7; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 11 + (127 & (b >>>= M)), b >>>= 7, g -= 7;
                                                            }
                                                            if (r.have + x > r.nlen + r.ndist) {
                                                                e.msg = "invalid bit length repeat", r.mode = 30;
                                                                break;
                                                            }
                                                            for(; x--;)r.lens[r.have++] = O;
                                                        }
                                                    }
                                                    if (30 === r.mode) break;
                                                    if (0 === r.lens[256]) {
                                                        e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.lenbits = 9, I = {
                                                        bits: r.lenbits
                                                    }, j = a(1, r.lens, 0, r.nlen, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid literal/lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.distbits = 6, r.distcode = r.distdyn, I = {
                                                        bits: r.distbits
                                                    }, j = a(2, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, I), r.distbits = I.bits, j) {
                                                        e.msg = "invalid distances set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.mode = 20, 6 === t) break e;
                                                case 20:
                                                    r.mode = 21;
                                                case 21:
                                                    if (6 <= p && 258 <= m) {
                                                        e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, o(e, _), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, 12 === r.mode && (r.back = -1);
                                                        break;
                                                    }
                                                    for(r.back = 0; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (C && 0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.lencode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, r.length = T, 0 === C) {
                                                        r.mode = 26;
                                                        break;
                                                    }
                                                    if (32 & C) {
                                                        r.back = -1, r.mode = 12;
                                                        break;
                                                    }
                                                    if (64 & C) {
                                                        e.msg = "invalid literal/length code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.extra = 15 & C, r.mode = 22;
                                                case 22:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    r.was = r.length, r.mode = 23;
                                                case 23:
                                                    for(; C = (P = r.distcode[b & (1 << r.distbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.distcode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, 64 & C) {
                                                        e.msg = "invalid distance code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.offset = T, r.extra = 15 & C, r.mode = 24;
                                                case 24:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.offset += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    if (r.offset > r.dmax) {
                                                        e.msg = "invalid distance too far back", r.mode = 30;
                                                        break;
                                                    }
                                                    r.mode = 25;
                                                case 25:
                                                    if (0 === m) break e;
                                                    if (x = _ - m, r.offset > x) {
                                                        if ((x = r.offset - x) > r.whave && r.sane) {
                                                            e.msg = "invalid distance too far back", r.mode = 30;
                                                            break;
                                                        }
                                                        k = x > r.wnext ? (x -= r.wnext, r.wsize - x) : r.wnext - x, x > r.length && (x = r.length), S = r.window;
                                                    } else S = h, k = d - r.offset, x = r.length;
                                                    for(m < x && (x = m), m -= x, r.length -= x; h[d++] = S[k++], --x;);
                                                    0 === r.length && (r.mode = 21);
                                                    break;
                                                case 26:
                                                    if (0 === m) break e;
                                                    h[d++] = r.length, m--, r.mode = 21;
                                                    break;
                                                case 27:
                                                    if (r.wrap) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b |= u[f++] << g, g += 8;
                                                        }
                                                        if (_ -= m, e.total_out += _, r.total += _, _ && (e.adler = r.check = r.flags ? s(r.check, h, _, d - _) : i(r.check, h, _, d - _)), _ = m, (r.flags ? b : c(b)) !== r.check) {
                                                            e.msg = "incorrect data check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 28;
                                                case 28:
                                                    if (r.wrap && r.flags) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (4294967295 & r.total)) {
                                                            e.msg = "incorrect length check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 29;
                                                case 29:
                                                    j = 1;
                                                    break e;
                                                case 30:
                                                    j = -3;
                                                    break e;
                                                case 31:
                                                    return -4;
                                                case 32:
                                                default:
                                                    return l;
                                            }
                                            return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, (r.wsize || _ !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && v(e, e.output, e.next_out, _ - e.avail_out) ? (r.mode = 31, -4) : (w -= e.avail_in, _ -= e.avail_out, e.total_in += w, e.total_out += _, r.total += _, r.wrap && _ && (e.adler = r.check = r.flags ? s(r.check, h, _, e.next_out - _) : i(r.check, h, _, e.next_out - _)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == w && 0 === _ || 4 === t) && 0 === j && (j = -5), j);
                                        }, r.inflateEnd = function(e) {
                                            if (!e || !e.state) return l;
                                            var t = e.state;
                                            return t.window && (t.window = null), e.state = null, 0;
                                        }, r.inflateGetHeader = function(e, t) {
                                            var r;
                                            return e && e.state ? 0 == (2 & (r = e.state).wrap) ? l : ((r.head = t).done = !1, 0) : l;
                                        }, r.inflateSetDictionary = function(e, t) {
                                            var r, n = t.length;
                                            return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? l : 11 === r.mode && i(1, t, n, 0) !== r.check ? -3 : v(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, 0) : l;
                                        }, r.inflateInfo = "pako inflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./inffast": 48,
                                        "./inftrees": 50
                                    }
                                ],
                                50: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = [
                                            3,
                                            4,
                                            5,
                                            6,
                                            7,
                                            8,
                                            9,
                                            10,
                                            11,
                                            13,
                                            15,
                                            17,
                                            19,
                                            23,
                                            27,
                                            31,
                                            35,
                                            43,
                                            51,
                                            59,
                                            67,
                                            83,
                                            99,
                                            115,
                                            131,
                                            163,
                                            195,
                                            227,
                                            258,
                                            0,
                                            0
                                        ], s = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            17,
                                            17,
                                            18,
                                            18,
                                            18,
                                            18,
                                            19,
                                            19,
                                            19,
                                            19,
                                            20,
                                            20,
                                            20,
                                            20,
                                            21,
                                            21,
                                            21,
                                            21,
                                            16,
                                            72,
                                            78
                                        ], o = [
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                            7,
                                            9,
                                            13,
                                            17,
                                            25,
                                            33,
                                            49,
                                            65,
                                            97,
                                            129,
                                            193,
                                            257,
                                            385,
                                            513,
                                            769,
                                            1025,
                                            1537,
                                            2049,
                                            3073,
                                            4097,
                                            6145,
                                            8193,
                                            12289,
                                            16385,
                                            24577,
                                            0,
                                            0
                                        ], a = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            18,
                                            18,
                                            19,
                                            19,
                                            20,
                                            20,
                                            21,
                                            21,
                                            22,
                                            22,
                                            23,
                                            23,
                                            24,
                                            24,
                                            25,
                                            25,
                                            26,
                                            26,
                                            27,
                                            27,
                                            28,
                                            28,
                                            29,
                                            29,
                                            64,
                                            64
                                        ];
                                        t.exports = function(e, t, r, l, c, u, h, f) {
                                            var d, p, m, b, g, y, v, w, _, x = f.bits, k = 0, S = 0, M = 0, C = 0, T = 0, E = 0, A = 0, R = 0, O = 0, j = 0, I = null, N = 0, P = new n.Buf16(16), B = new n.Buf16(16), D = null, F = 0;
                                            for(k = 0; k <= 15; k++)P[k] = 0;
                                            for(S = 0; S < l; S++)P[t[r + S]]++;
                                            for(T = x, C = 15; 1 <= C && 0 === P[C]; C--);
                                            if (C < T && (T = C), 0 === C) return c[u++] = 20971520, c[u++] = 20971520, f.bits = 1, 0;
                                            for(M = 1; M < C && 0 === P[M]; M++);
                                            for(T < M && (T = M), k = R = 1; k <= 15; k++)if (R <<= 1, (R -= P[k]) < 0) return -1;
                                            if (0 < R && (0 === e || 1 !== C)) return -1;
                                            for(B[1] = 0, k = 1; k < 15; k++)B[k + 1] = B[k] + P[k];
                                            for(S = 0; S < l; S++)0 !== t[r + S] && (h[B[t[r + S]]++] = S);
                                            if (y = 0 === e ? (I = D = h, 19) : 1 === e ? (I = i, N -= 257, D = s, F -= 257, 256) : (I = o, D = a, -1), k = M, g = u, A = S = j = 0, m = -1, b = (O = 1 << (E = T)) - 1, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                            for(;;){
                                                for(v = k - A, _ = h[S] < y ? (w = 0, h[S]) : h[S] > y ? (w = D[F + h[S]], I[N + h[S]]) : (w = 96, 0), d = 1 << k - A, M = p = 1 << E; c[g + (j >> A) + (p -= d)] = v << 24 | w << 16 | _ | 0, 0 !== p;);
                                                for(d = 1 << k - 1; j & d;)d >>= 1;
                                                if (0 !== d ? (j &= d - 1, j += d) : j = 0, S++, 0 == --P[k]) {
                                                    if (k === C) break;
                                                    k = t[r + h[S]];
                                                }
                                                if (T < k && (j & b) !== m) {
                                                    for(0 === A && (A = T), g += M, R = 1 << (E = k - A); E + A < C && !((R -= P[E + A]) <= 0);)E++, R <<= 1;
                                                    if (O += 1 << E, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                                    c[m = j & b] = T << 24 | E << 16 | g - u | 0;
                                                }
                                            }
                                            return 0 !== j && (c[g + j] = k - A << 24 | 4194304), f.bits = T, 0;
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                51: [
                                    function(e, t, r) {
                                        t.exports = {
                                            2: "need dictionary",
                                            1: "stream end",
                                            0: "",
                                            "-1": "file error",
                                            "-2": "stream error",
                                            "-3": "data error",
                                            "-4": "insufficient memory",
                                            "-5": "buffer error",
                                            "-6": "incompatible version"
                                        };
                                    },
                                    {}
                                ],
                                52: [
                                    function(e, t, r) {
                                        var n = e("../utils/common");
                                        function i(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        var s = 256, o = 286, a = 30, l = 15, c = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            1,
                                            1,
                                            2,
                                            2,
                                            2,
                                            2,
                                            3,
                                            3,
                                            3,
                                            3,
                                            4,
                                            4,
                                            4,
                                            4,
                                            5,
                                            5,
                                            5,
                                            5,
                                            0
                                        ], u = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            2,
                                            2,
                                            3,
                                            3,
                                            4,
                                            4,
                                            5,
                                            5,
                                            6,
                                            6,
                                            7,
                                            7,
                                            8,
                                            8,
                                            9,
                                            9,
                                            10,
                                            10,
                                            11,
                                            11,
                                            12,
                                            12,
                                            13,
                                            13
                                        ], h = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            2,
                                            3,
                                            7
                                        ], f = [
                                            16,
                                            17,
                                            18,
                                            0,
                                            8,
                                            7,
                                            9,
                                            6,
                                            10,
                                            5,
                                            11,
                                            4,
                                            12,
                                            3,
                                            13,
                                            2,
                                            14,
                                            1,
                                            15
                                        ], d = new Array(576);
                                        i(d);
                                        var p = new Array(60);
                                        i(p);
                                        var m = new Array(512);
                                        i(m);
                                        var b = new Array(256);
                                        i(b);
                                        var g = new Array(29);
                                        i(g);
                                        var y, v, w, _ = new Array(a);
                                        function x(e, t, r, n, i) {
                                            this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                                        }
                                        function k(e, t) {
                                            this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                                        }
                                        function S(e) {
                                            return e < 256 ? m[e] : m[256 + (e >>> 7)];
                                        }
                                        function M(e, t) {
                                            e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                                        }
                                        function C(e, t, r) {
                                            e.bi_valid > 16 - r ? (e.bi_buf |= t << e.bi_valid & 65535, M(e, e.bi_buf), e.bi_buf = t >> 16 - e.bi_valid, e.bi_valid += r - 16) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                                        }
                                        function T(e, t, r) {
                                            C(e, r[2 * t], r[2 * t + 1]);
                                        }
                                        function E(e, t) {
                                            for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                                            return r >>> 1;
                                        }
                                        function A(e, t, r) {
                                            var n, i, s = new Array(16), o = 0;
                                            for(n = 1; n <= l; n++)s[n] = o = o + r[n - 1] << 1;
                                            for(i = 0; i <= t; i++){
                                                var a = e[2 * i + 1];
                                                0 !== a && (e[2 * i] = E(s[a]++, a));
                                            }
                                        }
                                        function R(e) {
                                            var t;
                                            for(t = 0; t < o; t++)e.dyn_ltree[2 * t] = 0;
                                            for(t = 0; t < a; t++)e.dyn_dtree[2 * t] = 0;
                                            for(t = 0; t < 19; t++)e.bl_tree[2 * t] = 0;
                                            e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                                        }
                                        function O(e) {
                                            8 < e.bi_valid ? M(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                                        }
                                        function j(e, t, r, n) {
                                            var i = 2 * t, s = 2 * r;
                                            return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                                        }
                                        function I(e, t, r) {
                                            for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && j(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !j(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                                            e.heap[r] = n;
                                        }
                                        function N(e, t, r) {
                                            var n, i, o, a, l = 0;
                                            if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * l] << 8 | e.pending_buf[e.d_buf + 2 * l + 1], i = e.pending_buf[e.l_buf + l], l++, 0 === n ? T(e, i, t) : (T(e, (o = b[i]) + s + 1, t), 0 !== (a = c[o]) && C(e, i -= g[o], a), T(e, o = S(--n), r), 0 !== (a = u[o]) && C(e, n -= _[o], a)), l < e.last_lit;);
                                            T(e, 256, t);
                                        }
                                        function P(e, t) {
                                            var r, n, i, s = t.dyn_tree, o = t.stat_desc.static_tree, a = t.stat_desc.has_stree, c = t.stat_desc.elems, u = -1;
                                            for(e.heap_len = 0, e.heap_max = 573, r = 0; r < c; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                                            for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, a && (e.static_len -= o[2 * i + 1]);
                                            for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)I(e, s, r);
                                            for(i = c; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], I(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, I(e, s, 1), 2 <= e.heap_len;);
                                            e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                                                var r, n, i, s, o, a, c = t.dyn_tree, u = t.max_code, h = t.stat_desc.static_tree, f = t.stat_desc.has_stree, d = t.stat_desc.extra_bits, p = t.stat_desc.extra_base, m = t.stat_desc.max_length, b = 0;
                                                for(s = 0; s <= l; s++)e.bl_count[s] = 0;
                                                for(c[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < 573; r++)m < (s = c[2 * c[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = m, b++), c[2 * n + 1] = s, u < n || (e.bl_count[s]++, o = 0, p <= n && (o = d[n - p]), a = c[2 * n], e.opt_len += a * (s + o), f && (e.static_len += a * (h[2 * n + 1] + o)));
                                                if (0 !== b) {
                                                    do {
                                                        for(s = m - 1; 0 === e.bl_count[s];)s--;
                                                        e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[m]--, b -= 2;
                                                    }while (0 < b);
                                                    for(s = m; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (c[2 * i + 1] !== s && (e.opt_len += (s - c[2 * i + 1]) * c[2 * i], c[2 * i + 1] = s), n--);
                                                }
                                            }(e, t), A(s, u, e.bl_count);
                                        }
                                        function B(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = o, o = t[2 * (n + 1) + 1], ++a < l && i === o || (a < c ? e.bl_tree[2 * i] += a : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[32]++) : a <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4));
                                        }
                                        function D(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), n = 0; n <= r; n++)if (i = o, o = t[2 * (n + 1) + 1], !(++a < l && i === o)) {
                                                if (a < c) for(; T(e, i, e.bl_tree), 0 != --a;);
                                                else 0 !== i ? (i !== s && (T(e, i, e.bl_tree), a--), T(e, 16, e.bl_tree), C(e, a - 3, 2)) : a <= 10 ? (T(e, 17, e.bl_tree), C(e, a - 3, 3)) : (T(e, 18, e.bl_tree), C(e, a - 11, 7));
                                                s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4);
                                            }
                                        }
                                        i(_);
                                        var F = !1;
                                        function L(e, t, r, i) {
                                            C(e, 0 + (i ? 1 : 0), 3), function(e, t, r, i) {
                                                O(e), M(e, r), M(e, ~r), n.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                                            }(e, t, r);
                                        }
                                        r._tr_init = function(e) {
                                            F || (function() {
                                                var e, t, r, n, i, s = new Array(16);
                                                for(n = r = 0; n < 28; n++)for(g[n] = r, e = 0; e < 1 << c[n]; e++)b[r++] = n;
                                                for(b[r - 1] = n, n = i = 0; n < 16; n++)for(_[n] = i, e = 0; e < 1 << u[n]; e++)m[i++] = n;
                                                for(i >>= 7; n < a; n++)for(_[n] = i << 7, e = 0; e < 1 << u[n] - 7; e++)m[256 + i++] = n;
                                                for(t = 0; t <= l; t++)s[t] = 0;
                                                for(e = 0; e <= 143;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(; e <= 255;)d[2 * e + 1] = 9, e++, s[9]++;
                                                for(; e <= 279;)d[2 * e + 1] = 7, e++, s[7]++;
                                                for(; e <= 287;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(A(d, 287, s), e = 0; e < a; e++)p[2 * e + 1] = 5, p[2 * e] = E(e, 5);
                                                y = new x(d, c, 257, o, l), v = new x(p, u, 0, a, l), w = new x(new Array(0), h, 0, 19, 7);
                                            }(), F = !0), e.l_desc = new k(e.dyn_ltree, y), e.d_desc = new k(e.dyn_dtree, v), e.bl_desc = new k(e.bl_tree, w), e.bi_buf = 0, e.bi_valid = 0, R(e);
                                        }, r._tr_stored_block = L, r._tr_flush_block = function(e, t, r, n) {
                                            var i, o, a = 0;
                                            0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                                                var t, r = 4093624447;
                                                for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return 0;
                                                if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;
                                                for(t = 32; t < s; t++)if (0 !== e.dyn_ltree[2 * t]) return 1;
                                                return 0;
                                            }(e)), P(e, e.l_desc), P(e, e.d_desc), a = function(e) {
                                                var t;
                                                for(B(e, e.dyn_ltree, e.l_desc.max_code), B(e, e.dyn_dtree, e.d_desc.max_code), P(e, e.bl_desc), t = 18; 3 <= t && 0 === e.bl_tree[2 * f[t] + 1]; t--);
                                                return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                                            }(e), i = e.opt_len + 3 + 7 >>> 3, (o = e.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = r + 5, r + 4 <= i && -1 !== t ? L(e, t, r, n) : 4 === e.strategy || o === i ? (C(e, 2 + (n ? 1 : 0), 3), N(e, d, p)) : (C(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                                                var i;
                                                for(C(e, t - 257, 5), C(e, r - 1, 5), C(e, n - 4, 4), i = 0; i < n; i++)C(e, e.bl_tree[2 * f[i] + 1], 3);
                                                D(e, e.dyn_ltree, t - 1), D(e, e.dyn_dtree, r - 1);
                                            }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), N(e, e.dyn_ltree, e.dyn_dtree)), R(e), n && O(e);
                                        }, r._tr_tally = function(e, t, r) {
                                            return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (b[r] + s + 1)]++, e.dyn_dtree[2 * S(t)]++), e.last_lit === e.lit_bufsize - 1;
                                        }, r._tr_align = function(e) {
                                            C(e, 2, 3), T(e, 256, d), function(e) {
                                                16 === e.bi_valid ? (M(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                                            }(e);
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                53: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                                        };
                                    },
                                    {}
                                ],
                                54: [
                                    function(e, t, r) {
                                        (function(e) {
                                            !function(e, t) {
                                                if (!e.setImmediate) {
                                                    var r, i, s, o, a = 1, l = {}, c = !1, u = e.document, h = Object.getPrototypeOf && Object.getPrototypeOf(e);
                                                    h = h && h.setTimeout ? h : e, r = "[object process]" === ({}).toString.call(e.process) ? function(e) {
                                                        n.nextTick(function() {
                                                            d(e);
                                                        });
                                                    } : function() {
                                                        if (e.postMessage && !e.importScripts) {
                                                            var t = !0, r = e.onmessage;
                                                            return e.onmessage = function() {
                                                                t = !1;
                                                            }, e.postMessage("", "*"), e.onmessage = r, t;
                                                        }
                                                    }() ? (o = "setImmediate$" + Math.random() + "$", e.addEventListener ? e.addEventListener("message", p, !1) : e.attachEvent("onmessage", p), function(t) {
                                                        e.postMessage(o + t, "*");
                                                    }) : e.MessageChannel ? ((s = new MessageChannel).port1.onmessage = function(e) {
                                                        d(e.data);
                                                    }, function(e) {
                                                        s.port2.postMessage(e);
                                                    }) : u && "onreadystatechange" in u.createElement("script") ? (i = u.documentElement, function(e) {
                                                        var t = u.createElement("script");
                                                        t.onreadystatechange = function() {
                                                            d(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                                                        }, i.appendChild(t);
                                                    }) : function(e) {
                                                        setTimeout(d, 0, e);
                                                    }, h.setImmediate = function(e) {
                                                        "function" != typeof e && (e = new Function("" + e));
                                                        for(var t = new Array(arguments.length - 1), n = 0; n < t.length; n++)t[n] = arguments[n + 1];
                                                        var i = {
                                                            callback: e,
                                                            args: t
                                                        };
                                                        return l[a] = i, r(a), a++;
                                                    }, h.clearImmediate = f;
                                                }
                                                function f(e) {
                                                    delete l[e];
                                                }
                                                function d(e) {
                                                    if (c) setTimeout(d, 0, e);
                                                    else {
                                                        var t = l[e];
                                                        if (t) {
                                                            c = !0;
                                                            try {
                                                                !function(e) {
                                                                    var t = e.callback, r = e.args;
                                                                    switch(r.length){
                                                                        case 0:
                                                                            t();
                                                                            break;
                                                                        case 1:
                                                                            t(r[0]);
                                                                            break;
                                                                        case 2:
                                                                            t(r[0], r[1]);
                                                                            break;
                                                                        case 3:
                                                                            t(r[0], r[1], r[2]);
                                                                            break;
                                                                        default:
                                                                            t.apply(void 0, r);
                                                                    }
                                                                }(t);
                                                            } finally{
                                                                f(e), c = !1;
                                                            }
                                                        }
                                                    }
                                                }
                                                function p(t) {
                                                    t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(o) && d(+t.data.slice(o.length));
                                                }
                                            }("undefined" == typeof self ? void 0 === e ? this : e : self);
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ]
                            }, {}, [
                                10
                            ])(10);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], e("timers").setImmediate);
            },
            {
                _process: 467,
                buffer: 220,
                timers: 523
            }
        ],
        442: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /[\\^$.*+?()[\]{}|]/g, n = RegExp(r.source), i = "object" == typeof e && e && e.Object === Object && e, s = "object" == typeof self && self && self.Object === Object && self, o = i || s || Function("return this")(), a = Object.prototype.toString, l = o.Symbol, c = l ? l.prototype : void 0, u = c ? c.toString : void 0;
                        function h(e) {
                            if ("string" == typeof e) return e;
                            if (function(e) {
                                return "symbol" == typeof e || function(e) {
                                    return !!e && "object" == typeof e;
                                }(e) && "[object Symbol]" == a.call(e);
                            }(e)) return u ? u.call(e) : "";
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        t.exports = function(e) {
                            var t;
                            return (e = null == (t = e) ? "" : h(t)) && n.test(e) ? e.replace(r, "\\$&") : e;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        443: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l = /^\w*$/, c = /^\./, u = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, h = /\\(\\)?/g, f = /^\[object .+?Constructor\]$/, d = /^(?:0|[1-9]\d*)$/, p = {};
                        p["[object Float32Array]"] = p["[object Float64Array]"] = p["[object Int8Array]"] = p["[object Int16Array]"] = p["[object Int32Array]"] = p["[object Uint8Array]"] = p["[object Uint8ClampedArray]"] = p["[object Uint16Array]"] = p["[object Uint32Array]"] = !0, p[n] = p["[object Array]"] = p["[object ArrayBuffer]"] = p["[object Boolean]"] = p["[object DataView]"] = p["[object Date]"] = p["[object Error]"] = p["[object Function]"] = p[i] = p["[object Number]"] = p[s] = p["[object RegExp]"] = p[o] = p["[object String]"] = p["[object WeakMap]"] = !1;
                        var m = "object" == typeof e && e && e.Object === Object && e, b = "object" == typeof self && self && self.Object === Object && self, g = m || b || Function("return this")(), y = "object" == typeof r && r && !r.nodeType && r, v = y && "object" == typeof t && t && !t.nodeType && t, w = v && v.exports === y && m.process, _ = function() {
                            try {
                                return w && w.binding("util");
                            } catch (e) {}
                        }(), x = _ && _.isTypedArray;
                        function k(e, t, r, n) {
                            for(var i = -1, s = e ? e.length : 0; ++i < s;){
                                var o = e[i];
                                t(n, o, r(o), e);
                            }
                            return n;
                        }
                        function S(e, t) {
                            for(var r = -1, n = e ? e.length : 0; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function M(e) {
                            var t = !1;
                            if (null != e && "function" != typeof e.toString) try {
                                t = !!(e + "");
                            } catch (e) {}
                            return t;
                        }
                        function C(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function T(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var E, A, R, O = Array.prototype, j = Function.prototype, I = Object.prototype, N = g["__core-js_shared__"], P = (E = /[^.]+$/.exec(N && N.keys && N.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "", B = j.toString, D = I.hasOwnProperty, F = I.toString, L = RegExp("^" + B.call(D).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), z = g.Symbol, U = g.Uint8Array, $ = I.propertyIsEnumerable, H = O.splice, V = (A = Object.keys, R = Object, function(e) {
                            return A(R(e));
                        }), q = Ce(g, "DataView"), W = Ce(g, "Map"), X = Ce(g, "Promise"), K = Ce(g, "Set"), Y = Ce(g, "WeakMap"), Z = Ce(Object, "create"), G = Ne(q), J = Ne(W), Q = Ne(X), ee = Ne(K), te = Ne(Y), re = z ? z.prototype : void 0, ne = re ? re.valueOf : void 0, ie = re ? re.toString : void 0;
                        function se(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function oe(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ae(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function le(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new ae; ++t < r;)this.add(e[t]);
                        }
                        function ce(e) {
                            this.__data__ = new oe(e);
                        }
                        function ue(e, t) {
                            var r = Ue(e) || ze(e) ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], n = r.length, i = !!n;
                            for(var s in e)!t && !D.call(e, s) || i && ("length" == s || Ee(s, n)) || r.push(s);
                            return r;
                        }
                        function he(e, t) {
                            for(var r = e.length; r--;)if (Le(e[r][0], t)) return r;
                            return -1;
                        }
                        function fe(e, t, r, n) {
                            return me(e, function(e, i, s) {
                                t(n, e, r(e), s);
                            }), n;
                        }
                        se.prototype.clear = function() {
                            this.__data__ = Z ? Z(null) : {};
                        }, se.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, se.prototype.get = function(e) {
                            var t = this.__data__;
                            if (Z) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return D.call(t, e) ? t[e] : void 0;
                        }, se.prototype.has = function(e) {
                            var t = this.__data__;
                            return Z ? void 0 !== t[e] : D.call(t, e);
                        }, se.prototype.set = function(e, t) {
                            return this.__data__[e] = Z && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, oe.prototype.clear = function() {
                            this.__data__ = [];
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : H.call(t, r, 1), !0);
                        }, oe.prototype.get = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, oe.prototype.has = function(e) {
                            return he(this.__data__, e) > -1;
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__, n = he(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, ae.prototype.clear = function() {
                            this.__data__ = {
                                hash: new se,
                                map: new (W || oe),
                                string: new se
                            };
                        }, ae.prototype.delete = function(e) {
                            return Me(this, e).delete(e);
                        }, ae.prototype.get = function(e) {
                            return Me(this, e).get(e);
                        }, ae.prototype.has = function(e) {
                            return Me(this, e).has(e);
                        }, ae.prototype.set = function(e, t) {
                            return Me(this, e).set(e, t), this;
                        }, le.prototype.add = le.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, le.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.clear = function() {
                            this.__data__ = new oe;
                        }, ce.prototype.delete = function(e) {
                            return this.__data__.delete(e);
                        }, ce.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, ce.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof oe) {
                                var n = r.__data__;
                                if (!W || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this;
                                r = this.__data__ = new ae(n);
                            }
                            return r.set(e, t), this;
                        };
                        var de, pe, me = (de = function(e, t) {
                            return e && be(e, t, Ye);
                        }, function(e, t) {
                            if (null == e) return e;
                            if (!$e(e)) return de(e, t);
                            for(var r = e.length, n = pe ? r : -1, i = Object(e); (pe ? n-- : ++n < r) && !1 !== t(i[n], n, i););
                            return e;
                        }), be = function(e) {
                            return function(t, r, n) {
                                for(var i = -1, s = Object(t), o = n(t), a = o.length; a--;){
                                    var l = o[e ? a : ++i];
                                    if (!1 === r(s[l], l, s)) break;
                                }
                                return t;
                            };
                        }();
                        function ge(e, t) {
                            for(var r = 0, n = (t = Ae(t, e) ? [
                                t
                            ] : ke(t)).length; null != e && r < n;)e = e[Ie(t[r++])];
                            return r && r == n ? e : void 0;
                        }
                        function ye(e, t) {
                            return null != e && t in Object(e);
                        }
                        function ve(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !qe(e) && !We(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Ue(e), h = Ue(t), f = "[object Array]", d = "[object Array]";
                                u || (f = (f = Te(e)) == n ? s : f);
                                h || (d = (d = Te(t)) == n ? s : d);
                                var p = f == s && !M(e), m = d == s && !M(t), b = f == d;
                                if (b && !p) return c || (c = new ce), u || Ke(e) ? Se(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !n(new U(e), new U(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return Le(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = C;
                                        case o:
                                            var u = 2 & a;
                                            if (c || (c = T), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            a |= 1, l.set(e, t);
                                            var f = Se(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (ne) return ne.call(e) == ne.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(2 & l)) {
                                    var g = p && D.call(e, "__wrapped__"), y = m && D.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, w = y ? t.value() : t;
                                        return c || (c = new ce), r(v, w, a, l, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new ce), function(e, t, r, n, i, s) {
                                    var o = 2 & i, a = Ye(e), l = a.length, c = Ye(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : D.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || r(m, b, n, i, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, ve, r, a, l));
                        }
                        function we(e) {
                            return !(!qe(e) || function(e) {
                                return !!P && P in e;
                            }(e)) && (He(e) || M(e) ? L : f).test(Ne(e));
                        }
                        function _e(e) {
                            var t, r;
                            return "function" == typeof e ? e : null == e ? Ze : "object" == typeof e ? Ue(e) ? function(e, t) {
                                if (Ae(e) && Re(t)) return Oe(Ie(e), t);
                                return function(r) {
                                    var n = function(e, t, r) {
                                        var n = null == e ? void 0 : ge(e, t);
                                        return void 0 === n ? r : n;
                                    }(r, e);
                                    return void 0 === n && n === t ? function(e, t) {
                                        return null != e && function(e, t, r) {
                                            t = Ae(t, e) ? [
                                                t
                                            ] : ke(t);
                                            var n, i = -1, s = t.length;
                                            for(; ++i < s;){
                                                var o = Ie(t[i]);
                                                if (!(n = null != e && r(e, o))) break;
                                                e = e[o];
                                            }
                                            if (n) return n;
                                            return !!(s = e ? e.length : 0) && Ve(s) && Ee(o, s) && (Ue(e) || ze(e));
                                        }(e, t, ye);
                                    }(r, e) : ve(t, n, void 0, 3);
                                };
                            }(e[0], e[1]) : function(e) {
                                var t = function(e) {
                                    var t = Ye(e), r = t.length;
                                    for(; r--;){
                                        var n = t[r], i = e[n];
                                        t[r] = [
                                            n,
                                            i,
                                            Re(i)
                                        ];
                                    }
                                    return t;
                                }(e);
                                if (1 == t.length && t[0][2]) return Oe(t[0][0], t[0][1]);
                                return function(r) {
                                    return r === e || function(e, t, r, n) {
                                        var i = r.length, s = i, o = !n;
                                        if (null == e) return !s;
                                        for(e = Object(e); i--;){
                                            var a = r[i];
                                            if (o && a[2] ? a[1] !== e[a[0]] : !(a[0] in e)) return !1;
                                        }
                                        for(; ++i < s;){
                                            var l = (a = r[i])[0], c = e[l], u = a[1];
                                            if (o && a[2]) {
                                                if (void 0 === c && !(l in e)) return !1;
                                            } else {
                                                var h = new ce;
                                                if (n) var f = n(c, u, l, e, t, h);
                                                if (!(void 0 === f ? ve(u, c, n, 3, h) : f)) return !1;
                                            }
                                        }
                                        return !0;
                                    }(r, e, t);
                                };
                            }(e) : Ae(t = e) ? (r = Ie(t), function(e) {
                                return null == e ? void 0 : e[r];
                            }) : function(e) {
                                return function(t) {
                                    return ge(t, e);
                                };
                            }(t);
                        }
                        function xe(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || I, t !== n) return V(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))D.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function ke(e) {
                            return Ue(e) ? e : je(e);
                        }
                        function Se(e, t, r, n, i, s) {
                            var o = 2 & i, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 1 & i ? new le : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!S(t, function(e, t) {
                                        if (!f.has(t) && (d === e || r(d, e, n, i, s))) return f.add(t);
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !r(d, p, n, i, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function Me(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function Ce(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return we(r) ? r : void 0;
                        }
                        var Te = function(e) {
                            return F.call(e);
                        };
                        function Ee(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || d.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function Ae(e, t) {
                            if (Ue(e)) return !1;
                            var r = typeof e;
                            return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Xe(e)) || l.test(e) || !a.test(e) || null != t && e in Object(t);
                        }
                        function Re(e) {
                            return e == e && !qe(e);
                        }
                        function Oe(e, t) {
                            return function(r) {
                                return null != r && r[e] === t && (void 0 !== t || e in Object(r));
                            };
                        }
                        (q && "[object DataView]" != Te(new q(new ArrayBuffer(1))) || W && Te(new W) != i || X && "[object Promise]" != Te(X.resolve()) || K && Te(new K) != o || Y && "[object WeakMap]" != Te(new Y)) && (Te = function(e) {
                            var t = F.call(e), r = t == s ? e.constructor : void 0, n = r ? Ne(r) : void 0;
                            if (n) switch(n){
                                case G:
                                    return "[object DataView]";
                                case J:
                                    return i;
                                case Q:
                                    return "[object Promise]";
                                case ee:
                                    return o;
                                case te:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var je = Fe(function(e) {
                            var t;
                            e = null == (t = e) ? "" : function(e) {
                                if ("string" == typeof e) return e;
                                if (Xe(e)) return ie ? ie.call(e) : "";
                                var t = e + "";
                                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                            }(t);
                            var r = [];
                            return c.test(e) && r.push(""), e.replace(u, function(e, t, n, i) {
                                r.push(n ? i.replace(h, "$1") : t || e);
                            }), r;
                        });
                        function Ie(e) {
                            if ("string" == typeof e || Xe(e)) return e;
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        function Ne(e) {
                            if (null != e) {
                                try {
                                    return B.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        var Pe, Be, De = (Pe = function(e, t, r) {
                            D.call(e, r) ? e[r].push(t) : e[r] = [
                                t
                            ];
                        }, function(e, t) {
                            var r = Ue(e) ? k : fe, n = Be ? Be() : {};
                            return r(e, Pe, _e(t), n);
                        });
                        function Fe(e, t) {
                            if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                            var r = function() {
                                var n = arguments, i = t ? t.apply(this, n) : n[0], s = r.cache;
                                if (s.has(i)) return s.get(i);
                                var o = e.apply(this, n);
                                return r.cache = s.set(i, o), o;
                            };
                            return r.cache = new (Fe.Cache || ae), r;
                        }
                        function Le(e, t) {
                            return e === t || e != e && t != t;
                        }
                        function ze(e) {
                            return function(e) {
                                return We(e) && $e(e);
                            }(e) && D.call(e, "callee") && (!$.call(e, "callee") || F.call(e) == n);
                        }
                        Fe.Cache = ae;
                        var Ue = Array.isArray;
                        function $e(e) {
                            return null != e && Ve(e.length) && !He(e);
                        }
                        function He(e) {
                            var t = qe(e) ? F.call(e) : "";
                            return "[object Function]" == t || "[object GeneratorFunction]" == t;
                        }
                        function Ve(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function qe(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        function We(e) {
                            return !!e && "object" == typeof e;
                        }
                        function Xe(e) {
                            return "symbol" == typeof e || We(e) && "[object Symbol]" == F.call(e);
                        }
                        var Ke = x ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(x) : function(e) {
                            return We(e) && Ve(e.length) && !!p[F.call(e)];
                        };
                        function Ye(e) {
                            return $e(e) ? ue(e) : xe(e);
                        }
                        function Ze(e) {
                            return e;
                        }
                        t.exports = De;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        444: [
            function(e, t, r) {
                "use strict";
                var n = Object.prototype.toString;
                t.exports = function(e) {
                    return !0 === e || !1 === e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Boolean]" == n.call(e);
                };
            },
            {}
        ],
        445: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /^\[object .+?Constructor\]$/, l = /^(?:0|[1-9]\d*)$/, c = {};
                        c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c[n] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c[i] = c["[object Number]"] = c[s] = c["[object RegExp]"] = c[o] = c["[object String]"] = c["[object WeakMap]"] = !1;
                        var u = "object" == typeof e && e && e.Object === Object && e, h = "object" == typeof self && self && self.Object === Object && self, f = u || h || Function("return this")(), d = "object" == typeof r && r && !r.nodeType && r, p = d && "object" == typeof t && t && !t.nodeType && t, m = p && p.exports === d, b = m && u.process, g = function() {
                            try {
                                return b && b.binding && b.binding("util");
                            } catch (e) {}
                        }(), y = g && g.isTypedArray;
                        function v(e, t) {
                            for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function w(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function _(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var x, k, S, M = Array.prototype, C = Function.prototype, T = Object.prototype, E = f["__core-js_shared__"], A = C.toString, R = T.hasOwnProperty, O = (x = /[^.]+$/.exec(E && E.keys && E.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x : "", j = T.toString, I = RegExp("^" + A.call(R).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), N = m ? f.Buffer : void 0, P = f.Symbol, B = f.Uint8Array, D = T.propertyIsEnumerable, F = M.splice, L = P ? P.toStringTag : void 0, z = Object.getOwnPropertySymbols, U = N ? N.isBuffer : void 0, $ = (k = Object.keys, S = Object, function(e) {
                            return k(S(e));
                        }), H = ge(f, "DataView"), V = ge(f, "Map"), q = ge(f, "Promise"), W = ge(f, "Set"), X = ge(f, "WeakMap"), K = ge(Object, "create"), Y = _e(H), Z = _e(V), G = _e(q), J = _e(W), Q = _e(X), ee = P ? P.prototype : void 0, te = ee ? ee.valueOf : void 0;
                        function re(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ne(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ie(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function se(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.__data__ = new ie; ++t < r;)this.add(e[t]);
                        }
                        function oe(e) {
                            var t = this.__data__ = new ne(e);
                            this.size = t.size;
                        }
                        function ae(e, t) {
                            var r = Se(e), n = !r && ke(e), i = !r && !n && Me(e), s = !r && !n && !i && Re(e), o = r || n || i || s, a = o ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], l = a.length;
                            for(var c in e)!t && !R.call(e, c) || o && ("length" == c || i && ("offset" == c || "parent" == c) || s && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || we(c, l)) || a.push(c);
                            return a;
                        }
                        function le(e, t) {
                            for(var r = e.length; r--;)if (xe(e[r][0], t)) return r;
                            return -1;
                        }
                        function ce(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : L && L in Object(e) ? function(e) {
                                var t = R.call(e, L), r = e[L];
                                try {
                                    e[L] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = j.call(e);
                                n && (t ? e[L] = r : delete e[L]);
                                return i;
                            }(e) : function(e) {
                                return j.call(e);
                            }(e);
                        }
                        function ue(e) {
                            return Ae(e) && ce(e) == n;
                        }
                        function he(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !Ae(e) && !Ae(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Se(e), h = Se(t), f = u ? "[object Array]" : ve(e), d = h ? "[object Array]" : ve(t), p = (f = f == n ? s : f) == s, m = (d = d == n ? s : d) == s, b = f == d;
                                if (b && Me(e)) {
                                    if (!Me(t)) return !1;
                                    u = !0, p = !1;
                                }
                                if (b && !p) return c || (c = new oe), u || Re(e) ? pe(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !a(new B(e), new B(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return xe(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = w;
                                        case o:
                                            var u = 1 & n;
                                            if (c || (c = _), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            n |= 2, l.set(e, t);
                                            var f = pe(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (te) return te.call(e) == te.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(1 & r)) {
                                    var g = p && R.call(e, "__wrapped__"), y = m && R.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, x = y ? t.value() : t;
                                        return c || (c = new oe), l(v, x, r, a, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new oe), function(e, t, r, n, i, s) {
                                    var o = 1 & r, a = me(e), l = a.length, c = me(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : R.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || i(m, b, r, n, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, r, a, he, l));
                        }
                        function fe(e) {
                            return !(!Ee(e) || function(e) {
                                return !!O && O in e;
                            }(e)) && (Ce(e) ? I : a).test(_e(e));
                        }
                        function de(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || T, t !== n) return $(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))R.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function pe(e, t, r, n, i, s) {
                            var o = 1 & r, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 2 & r ? new se : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!v(t, function(e, t) {
                                        if (o = t, !f.has(o) && (d === e || i(d, e, r, n, s))) return f.push(t);
                                        var o;
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !i(d, p, r, n, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function me(e) {
                            return function(e, t, r) {
                                var n = t(e);
                                return Se(e) ? n : function(e, t) {
                                    for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
                                    return e;
                                }(n, r(e));
                            }(e, Oe, ye);
                        }
                        function be(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function ge(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return fe(r) ? r : void 0;
                        }
                        re.prototype.clear = function() {
                            this.__data__ = K ? K(null) : {}, this.size = 0;
                        }, re.prototype.delete = function(e) {
                            var t = this.has(e) && delete this.__data__[e];
                            return this.size -= t ? 1 : 0, t;
                        }, re.prototype.get = function(e) {
                            var t = this.__data__;
                            if (K) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return R.call(t, e) ? t[e] : void 0;
                        }, re.prototype.has = function(e) {
                            var t = this.__data__;
                            return K ? void 0 !== t[e] : R.call(t, e);
                        }, re.prototype.set = function(e, t) {
                            var r = this.__data__;
                            return this.size += this.has(e) ? 0 : 1, r[e] = K && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, ne.prototype.clear = function() {
                            this.__data__ = [], this.size = 0;
                        }, ne.prototype.delete = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : F.call(t, r, 1), --this.size, !0);
                        }, ne.prototype.get = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, ne.prototype.has = function(e) {
                            return le(this.__data__, e) > -1;
                        }, ne.prototype.set = function(e, t) {
                            var r = this.__data__, n = le(r, e);
                            return n < 0 ? (++this.size, r.push([
                                e,
                                t
                            ])) : r[n][1] = t, this;
                        }, ie.prototype.clear = function() {
                            this.size = 0, this.__data__ = {
                                hash: new re,
                                map: new (V || ne),
                                string: new re
                            };
                        }, ie.prototype.delete = function(e) {
                            var t = be(this, e).delete(e);
                            return this.size -= t ? 1 : 0, t;
                        }, ie.prototype.get = function(e) {
                            return be(this, e).get(e);
                        }, ie.prototype.has = function(e) {
                            return be(this, e).has(e);
                        }, ie.prototype.set = function(e, t) {
                            var r = be(this, e), n = r.size;
                            return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
                        }, se.prototype.add = se.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, se.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.clear = function() {
                            this.__data__ = new ne, this.size = 0;
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = t.delete(e);
                            return this.size = t.size, r;
                        }, oe.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, oe.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof ne) {
                                var n = r.__data__;
                                if (!V || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this.size = ++r.size, this;
                                r = this.__data__ = new ie(n);
                            }
                            return r.set(e, t), this.size = r.size, this;
                        };
                        var ye = z ? function(e) {
                            return null == e ? [] : (e = Object(e), function(e, t) {
                                for(var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;){
                                    var o = e[r];
                                    t(o, r, e) && (s[i++] = o);
                                }
                                return s;
                            }(z(e), function(t) {
                                return D.call(e, t);
                            }));
                        } : function() {
                            return [];
                        }, ve = ce;
                        function we(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || l.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function _e(e) {
                            if (null != e) {
                                try {
                                    return A.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        function xe(e, t) {
                            return e === t || e != e && t != t;
                        }
                        (H && "[object DataView]" != ve(new H(new ArrayBuffer(1))) || V && ve(new V) != i || q && "[object Promise]" != ve(q.resolve()) || W && ve(new W) != o || X && "[object WeakMap]" != ve(new X)) && (ve = function(e) {
                            var t = ce(e), r = t == s ? e.constructor : void 0, n = r ? _e(r) : "";
                            if (n) switch(n){
                                case Y:
                                    return "[object DataView]";
                                case Z:
                                    return i;
                                case G:
                                    return "[object Promise]";
                                case J:
                                    return o;
                                case Q:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var ke = ue(function() {
                            return arguments;
                        }()) ? ue : function(e) {
                            return Ae(e) && R.call(e, "callee") && !D.call(e, "callee");
                        }, Se = Array.isArray;
                        var Me = U || function() {
                            return !1;
                        };
                        function Ce(e) {
                            if (!Ee(e)) return !1;
                            var t = ce(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        }
                        function Te(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function Ee(e) {
                            var t = typeof e;
                            return null != e && ("object" == t || "function" == t);
                        }
                        function Ae(e) {
                            return null != e && "object" == typeof e;
                        }
                        var Re = y ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(y) : function(e) {
                            return Ae(e) && Te(e.length) && !!c[ce(e)];
                        };
                        function Oe(e) {
                            var t;
                            return null != (t = e) && Te(t.length) && !Ce(t) ? ae(e) : de(e);
                        }
                        t.exports = function(e, t) {
                            return he(e, t);
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        446: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = "object" == typeof e && e && e.Object === Object && e, n = "object" == typeof self && self && self.Object === Object && self, i = r || n || Function("return this")(), s = Object.prototype, o = s.hasOwnProperty, a = s.toString, l = i.Symbol, c = l ? l.toStringTag : void 0;
                        function u(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : c && c in Object(e) ? function(e) {
                                var t = o.call(e, c), r = e[c];
                                try {
                                    e[c] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = a.call(e);
                                n && (t ? e[c] = r : delete e[c]);
                                return i;
                            }(e) : function(e) {
                                return a.call(e);
                            }(e);
                        }
                        t.exports = function(e) {
                            if (!function(e) {
                                var t = typeof e;
                                return null != e && ("object" == t || "function" == t);
                            }(e)) return !1;
                            var t = u(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        447: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        448: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return void 0 === e;
                };
            },
            {}
        ],
        449: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /^\[object .+?Constructor\]$/, n = "object" == typeof e && e && e.Object === Object && e, i = "object" == typeof self && self && self.Object === Object && self, s = n || i || Function("return this")();
                        function o(e, t) {
                            return !!(e ? e.length : 0) && function(e, t, r) {
                                if (t != t) return function(e, t, r, n) {
                                    var i = e.length, s = r + (n ? 1 : -1);
                                    for(; n ? s-- : ++s < i;)if (t(e[s], s, e)) return s;
                                    return -1;
                                }(e, l, r);
                                var n = r - 1, i = e.length;
                                for(; ++n < i;)if (e[n] === t) return n;
                                return -1;
                            }(e, t, 0) > -1;
                        }
                        function a(e, t, r) {
                            for(var n = -1, i = e ? e.length : 0; ++n < i;)if (r(t, e[n])) return !0;
                            return !1;
                        }
                        function l(e) {
                            return e != e;
                        }
                        function c(e, t) {
                            return e.has(t);
                        }
                        function u(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var h, f = Array.prototype, d = Function.prototype, p = Object.prototype, m = s["__core-js_shared__"], b = (h = /[^.]+$/.exec(m && m.keys && m.keys.IE_PROTO || "")) ? "Symbol(src)_1." + h : "", g = d.toString, y = p.hasOwnProperty, v = p.toString, w = RegExp("^" + g.call(y).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), _ = f.splice, x = I(s, "Map"), k = I(s, "Set"), S = I(Object, "create");
                        function M(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function C(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function T(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function E(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new T; ++t < r;)this.add(e[t]);
                        }
                        function A(e, t) {
                            for(var r, n, i = e.length; i--;)if ((r = e[i][0]) === (n = t) || r != r && n != n) return i;
                            return -1;
                        }
                        function R(e) {
                            var t;
                            return !(!N(e) || (t = e, b && b in t)) && ((function(e) {
                                var t = N(e) ? v.call(e) : "";
                                return "[object Function]" == t || "[object GeneratorFunction]" == t;
                            })(e) || function(e) {
                                var t = !1;
                                if (null != e && "function" != typeof e.toString) try {
                                    t = !!(e + "");
                                } catch (e) {}
                                return t;
                            }(e) ? w : r).test(function(e) {
                                if (null != e) {
                                    try {
                                        return g.call(e);
                                    } catch (e) {}
                                    try {
                                        return e + "";
                                    } catch (e) {}
                                }
                                return "";
                            }(e));
                        }
                        M.prototype.clear = function() {
                            this.__data__ = S ? S(null) : {};
                        }, M.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, M.prototype.get = function(e) {
                            var t = this.__data__;
                            if (S) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return y.call(t, e) ? t[e] : void 0;
                        }, M.prototype.has = function(e) {
                            var t = this.__data__;
                            return S ? void 0 !== t[e] : y.call(t, e);
                        }, M.prototype.set = function(e, t) {
                            return this.__data__[e] = S && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, C.prototype.clear = function() {
                            this.__data__ = [];
                        }, C.prototype.delete = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : _.call(t, r, 1), !0);
                        }, C.prototype.get = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, C.prototype.has = function(e) {
                            return A(this.__data__, e) > -1;
                        }, C.prototype.set = function(e, t) {
                            var r = this.__data__, n = A(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, T.prototype.clear = function() {
                            this.__data__ = {
                                hash: new M,
                                map: new (x || C),
                                string: new M
                            };
                        }, T.prototype.delete = function(e) {
                            return j(this, e).delete(e);
                        }, T.prototype.get = function(e) {
                            return j(this, e).get(e);
                        }, T.prototype.has = function(e) {
                            return j(this, e).has(e);
                        }, T.prototype.set = function(e, t) {
                            return j(this, e).set(e, t), this;
                        }, E.prototype.add = E.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, E.prototype.has = function(e) {
                            return this.__data__.has(e);
                        };
                        var O = k && 1 / u(new k([
                            ,
                            -0
                        ]))[1] == 1 / 0 ? function(e) {
                            return new k(e);
                        } : function() {};
                        function j(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function I(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return R(r) ? r : void 0;
                        }
                        function N(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        t.exports = function(e) {
                            return e && e.length ? function(e, t, r) {
                                var n = -1, i = o, s = e.length, l = !0, h = [], f = h;
                                if (r) l = !1, i = a;
                                else if (s >= 200) {
                                    var d = t ? null : O(e);
                                    if (d) return u(d);
                                    l = !1, i = c, f = new E;
                                } else f = t ? [] : h;
                                e: for(; ++n < s;){
                                    var p = e[n], m = t ? t(p) : p;
                                    if (p = r || 0 !== p ? p : 0, l && m == m) {
                                        for(var b = f.length; b--;)if (f[b] === m) continue e;
                                        t && f.push(m), h.push(p);
                                    } else i(f, m, r) || (f !== h && f.push(m), h.push(p));
                                }
                                return h;
                            }(e) : [];
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        450: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("hash-base"), s = e("safe-buffer").Buffer, o = new Array(16);
                function a() {
                    i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
                }
                function l(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function c(e, t, r, n, i, s, o) {
                    return l(e + (t & r | ~t & n) + i + s | 0, o) + t | 0;
                }
                function u(e, t, r, n, i, s, o) {
                    return l(e + (t & n | r & ~n) + i + s | 0, o) + t | 0;
                }
                function h(e, t, r, n, i, s, o) {
                    return l(e + (t ^ r ^ n) + i + s | 0, o) + t | 0;
                }
                function f(e, t, r, n, i, s, o) {
                    return l(e + (r ^ (t | ~n)) + i + s | 0, o) + t | 0;
                }
                n(a, i), a.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    var r = this._a, n = this._b, i = this._c, s = this._d;
                    r = c(r, n, i, s, e[0], 3614090360, 7), s = c(s, r, n, i, e[1], 3905402710, 12), i = c(i, s, r, n, e[2], 606105819, 17), n = c(n, i, s, r, e[3], 3250441966, 22), r = c(r, n, i, s, e[4], 4118548399, 7), s = c(s, r, n, i, e[5], 1200080426, 12), i = c(i, s, r, n, e[6], 2821735955, 17), n = c(n, i, s, r, e[7], 4249261313, 22), r = c(r, n, i, s, e[8], 1770035416, 7), s = c(s, r, n, i, e[9], 2336552879, 12), i = c(i, s, r, n, e[10], 4294925233, 17), n = c(n, i, s, r, e[11], 2304563134, 22), r = c(r, n, i, s, e[12], 1804603682, 7), s = c(s, r, n, i, e[13], 4254626195, 12), i = c(i, s, r, n, e[14], 2792965006, 17), r = u(r, n = c(n, i, s, r, e[15], 1236535329, 22), i, s, e[1], 4129170786, 5), s = u(s, r, n, i, e[6], 3225465664, 9), i = u(i, s, r, n, e[11], 643717713, 14), n = u(n, i, s, r, e[0], 3921069994, 20), r = u(r, n, i, s, e[5], 3593408605, 5), s = u(s, r, n, i, e[10], 38016083, 9), i = u(i, s, r, n, e[15], 3634488961, 14), n = u(n, i, s, r, e[4], 3889429448, 20), r = u(r, n, i, s, e[9], 568446438, 5), s = u(s, r, n, i, e[14], 3275163606, 9), i = u(i, s, r, n, e[3], 4107603335, 14), n = u(n, i, s, r, e[8], 1163531501, 20), r = u(r, n, i, s, e[13], 2850285829, 5), s = u(s, r, n, i, e[2], 4243563512, 9), i = u(i, s, r, n, e[7], 1735328473, 14), r = h(r, n = u(n, i, s, r, e[12], 2368359562, 20), i, s, e[5], 4294588738, 4), s = h(s, r, n, i, e[8], 2272392833, 11), i = h(i, s, r, n, e[11], 1839030562, 16), n = h(n, i, s, r, e[14], 4259657740, 23), r = h(r, n, i, s, e[1], 2763975236, 4), s = h(s, r, n, i, e[4], 1272893353, 11), i = h(i, s, r, n, e[7], 4139469664, 16), n = h(n, i, s, r, e[10], 3200236656, 23), r = h(r, n, i, s, e[13], 681279174, 4), s = h(s, r, n, i, e[0], 3936430074, 11), i = h(i, s, r, n, e[3], 3572445317, 16), n = h(n, i, s, r, e[6], 76029189, 23), r = h(r, n, i, s, e[9], 3654602809, 4), s = h(s, r, n, i, e[12], 3873151461, 11), i = h(i, s, r, n, e[15], 530742520, 16), r = f(r, n = h(n, i, s, r, e[2], 3299628645, 23), i, s, e[0], 4096336452, 6), s = f(s, r, n, i, e[7], 1126891415, 10), i = f(i, s, r, n, e[14], 2878612391, 15), n = f(n, i, s, r, e[5], 4237533241, 21), r = f(r, n, i, s, e[12], 1700485571, 6), s = f(s, r, n, i, e[3], 2399980690, 10), i = f(i, s, r, n, e[10], 4293915773, 15), n = f(n, i, s, r, e[1], 2240044497, 21), r = f(r, n, i, s, e[8], 1873313359, 6), s = f(s, r, n, i, e[15], 4264355552, 10), i = f(i, s, r, n, e[6], 2734768916, 15), n = f(n, i, s, r, e[13], 1309151649, 21), r = f(r, n, i, s, e[4], 4149444226, 6), s = f(s, r, n, i, e[11], 3174756917, 10), i = f(i, s, r, n, e[2], 718787259, 15), n = f(n, i, s, r, e[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + s | 0;
                }, a.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = s.allocUnsafe(16);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
                }, t.exports = a;
            },
            {
                "hash-base": 425,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        451: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("brorand");
                function s(e) {
                    this.rand = e || new i.Rand;
                }
                t.exports = s, s.create = function(e) {
                    return new s(e);
                }, s.prototype._randbelow = function(e) {
                    var t = e.bitLength(), r = Math.ceil(t / 8);
                    do var i = new n(this.rand.generate(r));
                    while (i.cmp(e) >= 0);
                    return i;
                }, s.prototype._randrange = function(e, t) {
                    var r = t.sub(e);
                    return e.add(this._randbelow(r));
                }, s.prototype.test = function(e, t, r) {
                    var i = e.bitLength(), s = n.mont(e), o = new n(1).toRed(s);
                    t || (t = Math.max(1, i / 48 | 0));
                    for(var a = e.subn(1), l = 0; !a.testn(l); l++);
                    for(var c = e.shrn(l), u = a.toRed(s); t > 0; t--){
                        var h = this._randrange(new n(2), a);
                        r && r(h);
                        var f = h.toRed(s).redPow(c);
                        if (0 !== f.cmp(o) && 0 !== f.cmp(u)) {
                            for(var d = 1; d < l; d++){
                                if (0 === (f = f.redSqr()).cmp(o)) return !1;
                                if (0 === f.cmp(u)) break;
                            }
                            if (d === l) return !1;
                        }
                    }
                    return !0;
                }, s.prototype.getDivisor = function(e, t) {
                    var r = e.bitLength(), i = n.mont(e), s = new n(1).toRed(i);
                    t || (t = Math.max(1, r / 48 | 0));
                    for(var o = e.subn(1), a = 0; !o.testn(a); a++);
                    for(var l = e.shrn(a), c = o.toRed(i); t > 0; t--){
                        var u = this._randrange(new n(2), o), h = e.gcd(u);
                        if (0 !== h.cmpn(1)) return h;
                        var f = u.toRed(i).redPow(l);
                        if (0 !== f.cmp(s) && 0 !== f.cmp(c)) {
                            for(var d = 1; d < a; d++){
                                if (0 === (f = f.redSqr()).cmp(s)) return f.fromRed().subn(1).gcd(e);
                                if (0 === f.cmp(c)) break;
                            }
                            if (d === a) return (f = f.redSqr()).fromRed().subn(1).gcd(e);
                        }
                    }
                    return !1;
                };
            },
            {
                "bn.js": 452,
                brorand: 187
            }
        ],
        452: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        453: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    if (!e) throw new Error(t || "Assertion failed");
                }
                t.exports = n, n.equal = function(e, t, r) {
                    if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
                };
            },
            {}
        ],
        454: [
            function(e, t, r) {
                "use strict";
                var n = r;
                function i(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function s(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += i(e[r].toString(16));
                    return t;
                }
                n.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" != typeof e) {
                        for(var n = 0; n < e.length; n++)r[n] = 0 | e[n];
                        return r;
                    }
                    if ("hex" === t) {
                        (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);
                        for(n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
                    } else for(n = 0; n < e.length; n++){
                        var i = e.charCodeAt(n), s = i >> 8, o = 255 & i;
                        s ? r.push(s, o) : r.push(o);
                    }
                    return r;
                }, n.zero2 = i, n.toHex = s, n.encode = function(e, t) {
                    return "hex" === t ? s(e) : e;
                };
            },
            {}
        ],
        455: [
            function(e, t, r) {
                t.exports = {
                    "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
                    "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
                    "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
                    "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
                    "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
                    "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
                    "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
                    "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
                    "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
                    "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
                    "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
                    "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
                };
            },
            {}
        ],
        456: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js");
                r.certificate = e("./certificate");
                var i = n.define("RSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
                });
                r.RSAPrivateKey = i;
                var s = n.define("RSAPublicKey", function() {
                    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
                });
                r.RSAPublicKey = s;
                var o = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(a), this.key("subjectPublicKey").bitstr());
                });
                r.PublicKey = o;
                var a = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
                }), l = n.define("PrivateKeyInfo", function() {
                    this.seq().obj(this.key("version").int(), this.key("algorithm").use(a), this.key("subjectPrivateKey").octstr());
                });
                r.PrivateKey = l;
                var c = n.define("EncryptedPrivateKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
                });
                r.EncryptedPrivateKey = c;
                var u = n.define("DSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
                });
                r.DSAPrivateKey = u, r.DSAparam = n.define("DSAparam", function() {
                    this.int();
                });
                var h = n.define("ECPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(f), this.key("publicKey").optional().explicit(1).bitstr());
                });
                r.ECPrivateKey = h;
                var f = n.define("ECParameters", function() {
                    this.choice({
                        namedCurve: this.objid()
                    });
                });
                r.signature = n.define("signature", function() {
                    this.seq().obj(this.key("r").int(), this.key("s").int());
                });
            },
            {
                "./certificate": 457,
                "asn1.js": 170
            }
        ],
        457: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js"), i = n.define("Time", function() {
                    this.choice({
                        utcTime: this.utctime(),
                        generalTime: this.gentime()
                    });
                }), s = n.define("AttributeTypeValue", function() {
                    this.seq().obj(this.key("type").objid(), this.key("value").any());
                }), o = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
                }), a = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(o), this.key("subjectPublicKey").bitstr());
                }), l = n.define("RelativeDistinguishedName", function() {
                    this.setof(s);
                }), c = n.define("RDNSequence", function() {
                    this.seqof(l);
                }), u = n.define("Name", function() {
                    this.choice({
                        rdnSequence: this.use(c)
                    });
                }), h = n.define("Validity", function() {
                    this.seq().obj(this.key("notBefore").use(i), this.key("notAfter").use(i));
                }), f = n.define("Extension", function() {
                    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
                }), d = n.define("TBSCertificate", function() {
                    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(o), this.key("issuer").use(u), this.key("validity").use(h), this.key("subject").use(u), this.key("subjectPublicKeyInfo").use(a), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(f).optional());
                }), p = n.define("X509Certificate", function() {
                    this.seq().obj(this.key("tbsCertificate").use(d), this.key("signatureAlgorithm").use(o), this.key("signatureValue").bitstr());
                });
                t.exports = p;
            },
            {
                "asn1.js": 170
            }
        ],
        458: [
            function(e, t, r) {
                "use strict";
                var n = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, s = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, o = e("evp_bytestokey"), a = e("browserify-aes"), l = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    var r, c = e.toString(), u = c.match(n);
                    if (u) {
                        var h = "aes" + u[1], f = l.from(u[2], "hex"), d = l.from(u[3].replace(/[\r\n]/g, ""), "base64"), p = o(t, f.slice(0, 8), parseInt(u[1], 10)).key, m = [], b = a.createDecipheriv(h, p, f);
                        m.push(b.update(d)), m.push(b.final()), r = l.concat(m);
                    } else {
                        var g = c.match(s);
                        r = l.from(g[2].replace(/[\r\n]/g, ""), "base64");
                    }
                    return {
                        tag: c.match(i)[1],
                        data: r
                    };
                };
            },
            {
                "browserify-aes": 191,
                evp_bytestokey: 423,
                "safe-buffer": 494
            }
        ],
        459: [
            function(e, t, r) {
                "use strict";
                var n = e("./asn1"), i = e("./aesid.json"), s = e("./fixProc"), o = e("browserify-aes"), a = e("pbkdf2"), l = e("safe-buffer").Buffer;
                function c(e) {
                    var t;
                    "object" != typeof e || l.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = l.from(e));
                    var r, c, u = s(e, t), h = u.tag, f = u.data;
                    switch(h){
                        case "CERTIFICATE":
                            c = n.certificate.decode(f, "der").tbsCertificate.subjectPublicKeyInfo;
                        case "PUBLIC KEY":
                            switch(c || (c = n.PublicKey.decode(f, "der")), r = c.algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPublicKey.decode(c.subjectPublicKey.data, "der");
                                case "1.2.840.10045.2.1":
                                    return c.subjectPrivateKey = c.subjectPublicKey, {
                                        type: "ec",
                                        data: c
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.pub_key = n.DSAparam.decode(c.subjectPublicKey.data, "der"), {
                                        type: "dsa",
                                        data: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "ENCRYPTED PRIVATE KEY":
                            f = function(e, t) {
                                var r = e.algorithm.decrypt.kde.kdeparams.salt, n = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), s = i[e.algorithm.decrypt.cipher.algo.join(".")], c = e.algorithm.decrypt.cipher.iv, u = e.subjectPrivateKey, h = parseInt(s.split("-")[1], 10) / 8, f = a.pbkdf2Sync(t, r, n, h, "sha1"), d = o.createDecipheriv(s, f, c), p = [];
                                return p.push(d.update(u)), p.push(d.final()), l.concat(p);
                            }(f = n.EncryptedPrivateKey.decode(f, "der"), t);
                        case "PRIVATE KEY":
                            switch(r = (c = n.PrivateKey.decode(f, "der")).algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPrivateKey.decode(c.subjectPrivateKey, "der");
                                case "1.2.840.10045.2.1":
                                    return {
                                        curve: c.algorithm.curve,
                                        privateKey: n.ECPrivateKey.decode(c.subjectPrivateKey, "der").privateKey
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.priv_key = n.DSAparam.decode(c.subjectPrivateKey, "der"), {
                                        type: "dsa",
                                        params: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "RSA PUBLIC KEY":
                            return n.RSAPublicKey.decode(f, "der");
                        case "RSA PRIVATE KEY":
                            return n.RSAPrivateKey.decode(f, "der");
                        case "DSA PRIVATE KEY":
                            return {
                                type: "dsa",
                                params: n.DSAPrivateKey.decode(f, "der")
                            };
                        case "EC PRIVATE KEY":
                            return {
                                curve: (f = n.ECPrivateKey.decode(f, "der")).parameters.value,
                                privateKey: f.privateKey
                            };
                        default:
                            throw new Error("unknown key type " + h);
                    }
                }
                t.exports = c, c.signature = n.signature;
            },
            {
                "./aesid.json": 455,
                "./asn1": 456,
                "./fixProc": 458,
                "browserify-aes": 191,
                pbkdf2: 460,
                "safe-buffer": 494
            }
        ],
        460: [
            function(e, t, r) {
                "use strict";
                r.pbkdf2 = e("./lib/async"), r.pbkdf2Sync = e("./lib/sync");
            },
            {
                "./lib/async": 461,
                "./lib/sync": 464
            }
        ],
        461: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i, s = e("safe-buffer").Buffer, o = e("./precondition"), a = e("./default-encoding"), l = e("./sync"), c = e("./to-buffer"), u = r.crypto && r.crypto.subtle, h = {
                            sha: "SHA-1",
                            "sha-1": "SHA-1",
                            sha1: "SHA-1",
                            sha256: "SHA-256",
                            "sha-256": "SHA-256",
                            sha384: "SHA-384",
                            "sha-384": "SHA-384",
                            "sha-512": "SHA-512",
                            sha512: "SHA-512"
                        }, f = [];
                        function d() {
                            return i || (i = r.process && r.process.nextTick ? r.process.nextTick : r.queueMicrotask ? r.queueMicrotask : r.setImmediate ? r.setImmediate : r.setTimeout);
                        }
                        function p(e, t, r, n, i) {
                            return u.importKey("raw", e, {
                                name: "PBKDF2"
                            }, !1, [
                                "deriveBits"
                            ]).then(function(e) {
                                return u.deriveBits({
                                    name: "PBKDF2",
                                    salt: t,
                                    iterations: r,
                                    hash: {
                                        name: i
                                    }
                                }, e, n << 3);
                            }).then(function(e) {
                                return s.from(e);
                            });
                        }
                        t.exports = function(e, t, i, m, b, g) {
                            "function" == typeof b && (g = b, b = void 0);
                            var y = h[(b = b || "sha1").toLowerCase()];
                            if (y && "function" == typeof r.Promise) {
                                if (o(i, m), e = c(e, a, "Password"), t = c(t, a, "Salt"), "function" != typeof g) throw new Error("No callback provided to pbkdf2");
                                !function(e, t) {
                                    e.then(function(e) {
                                        d()(function() {
                                            t(null, e);
                                        });
                                    }, function(e) {
                                        d()(function() {
                                            t(e);
                                        });
                                    });
                                }((function(e) {
                                    if (r.process && !r.process.browser) return Promise.resolve(!1);
                                    if (!u || !u.importKey || !u.deriveBits) return Promise.resolve(!1);
                                    if (void 0 !== f[e]) return f[e];
                                    var t = p(n = n || s.alloc(8), n, 10, 128, e).then(function() {
                                        return !0;
                                    }).catch(function() {
                                        return !1;
                                    });
                                    return f[e] = t, t;
                                })(y).then(function(r) {
                                    return r ? p(e, t, i, m, y) : l(e, t, i, m, b);
                                }), g);
                            } else d()(function() {
                                var r;
                                try {
                                    r = l(e, t, i, m, b);
                                } catch (e) {
                                    return g(e);
                                }
                                g(null, r);
                            });
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./sync": 464,
                "./to-buffer": 465,
                "safe-buffer": 494
            }
        ],
        462: [
            function(e, t, r) {
                (function(e, r) {
                    (function() {
                        "use strict";
                        var n;
                        if (r.process && r.process.browser) n = "utf-8";
                        else if (r.process && r.process.version) n = parseInt(e.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
                        else n = "utf-8";
                        t.exports = n;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467
            }
        ],
        463: [
            function(e, t, r) {
                "use strict";
                var n = Math.pow(2, 30) - 1;
                t.exports = function(e, t) {
                    if ("number" != typeof e) throw new TypeError("Iterations not a number");
                    if (e < 0) throw new TypeError("Bad iterations");
                    if ("number" != typeof t) throw new TypeError("Key length not a number");
                    if (t < 0 || t > n || t != t) throw new TypeError("Bad key length");
                };
            },
            {}
        ],
        464: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash/md5"), i = e("ripemd160"), s = e("sha.js"), o = e("safe-buffer").Buffer, a = e("./precondition"), l = e("./default-encoding"), c = e("./to-buffer"), u = o.alloc(128), h = {
                    md5: 16,
                    sha1: 20,
                    sha224: 28,
                    sha256: 32,
                    sha384: 48,
                    sha512: 64,
                    rmd160: 20,
                    ripemd160: 20
                };
                function f(e, t, r) {
                    var a = function(e) {
                        function t(t) {
                            return s(e).update(t).digest();
                        }
                        return "rmd160" === e || "ripemd160" === e ? function(e) {
                            return (new i).update(e).digest();
                        } : "md5" === e ? n : t;
                    }(e), l = "sha512" === e || "sha384" === e ? 128 : 64;
                    t.length > l ? t = a(t) : t.length < l && (t = o.concat([
                        t,
                        u
                    ], l));
                    for(var c = o.allocUnsafe(l + h[e]), f = o.allocUnsafe(l + h[e]), d = 0; d < l; d++)c[d] = 54 ^ t[d], f[d] = 92 ^ t[d];
                    var p = o.allocUnsafe(l + r + 4);
                    c.copy(p, 0, 0, l), this.ipad1 = p, this.ipad2 = c, this.opad = f, this.alg = e, this.blocksize = l, this.hash = a, this.size = h[e];
                }
                f.prototype.run = function(e, t) {
                    return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
                }, t.exports = function(e, t, r, n, i) {
                    a(r, n);
                    var s = new f(i = i || "sha1", e = c(e, l, "Password"), (t = c(t, l, "Salt")).length), u = o.allocUnsafe(n), d = o.allocUnsafe(t.length + 4);
                    t.copy(d, 0, 0, t.length);
                    for(var p = 0, m = h[i], b = Math.ceil(n / m), g = 1; g <= b; g++){
                        d.writeUInt32BE(g, t.length);
                        for(var y = s.run(d, s.ipad1), v = y, w = 1; w < r; w++){
                            v = s.run(v, s.ipad2);
                            for(var _ = 0; _ < m; _++)y[_] ^= v[_];
                        }
                        y.copy(u, p), p += m;
                    }
                    return u;
                };
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./to-buffer": 465,
                "create-hash/md5": 387,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        465: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    if (n.isBuffer(e)) return e;
                    if ("string" == typeof e) return n.from(e, t);
                    if (ArrayBuffer.isView(e)) return n.from(e.buffer);
                    throw new TypeError(r + " must be a string, a Buffer, a typed array or a DataView");
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        466: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        void 0 === e || !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
                            nextTick: function(t, r, n, i) {
                                if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
                                var s, o, a = arguments.length;
                                switch(a){
                                    case 0:
                                    case 1:
                                        return e.nextTick(t);
                                    case 2:
                                        return e.nextTick(function() {
                                            t.call(null, r);
                                        });
                                    case 3:
                                        return e.nextTick(function() {
                                            t.call(null, r, n);
                                        });
                                    case 4:
                                        return e.nextTick(function() {
                                            t.call(null, r, n, i);
                                        });
                                    default:
                                        for(s = new Array(a - 1), o = 0; o < s.length;)s[o++] = arguments[o];
                                        return e.nextTick(function() {
                                            t.apply(null, s);
                                        });
                                }
                            }
                        } : t.exports = e;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        467: [
            function(e, t, r) {
                "use strict";
                var n, i, s = t.exports = {};
                function o() {
                    throw new Error("setTimeout has not been defined");
                }
                function a() {
                    throw new Error("clearTimeout has not been defined");
                }
                function l(e) {
                    if (n === setTimeout) return setTimeout(e, 0);
                    if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
                    try {
                        return n(e, 0);
                    } catch (t) {
                        try {
                            return n.call(null, e, 0);
                        } catch (t) {
                            return n.call(this, e, 0);
                        }
                    }
                }
                !function() {
                    try {
                        n = "function" == typeof setTimeout ? setTimeout : o;
                    } catch (e) {
                        n = o;
                    }
                    try {
                        i = "function" == typeof clearTimeout ? clearTimeout : a;
                    } catch (e) {
                        i = a;
                    }
                }();
                var c, u = [], h = !1, f = -1;
                function d() {
                    h && c && (h = !1, c.length ? u = c.concat(u) : f = -1, u.length && p());
                }
                function p() {
                    if (!h) {
                        var e = l(d);
                        h = !0;
                        for(var t = u.length; t;){
                            for(c = u, u = []; ++f < t;)c && c[f].run();
                            f = -1, t = u.length;
                        }
                        c = null, h = !1, function(e) {
                            if (i === clearTimeout) return clearTimeout(e);
                            if ((i === a || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);
                            try {
                                i(e);
                            } catch (t) {
                                try {
                                    return i.call(null, e);
                                } catch (t) {
                                    return i.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function m(e, t) {
                    this.fun = e, this.array = t;
                }
                function b() {}
                s.nextTick = function(e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new m(e, t)), 1 !== u.length || h || l(p);
                }, m.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = b, s.addListener = b, s.once = b, s.off = b, s.removeListener = b, s.removeAllListeners = b, s.emit = b, s.prependListener = b, s.prependOnceListener = b, s.listeners = function(e) {
                    return [];
                }, s.binding = function(e) {
                    throw new Error("process.binding is not supported");
                }, s.cwd = function() {
                    return "/";
                }, s.chdir = function(e) {
                    throw new Error("process.chdir is not supported");
                }, s.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        468: [
            function(e, t, r) {
                "use strict";
                r.publicEncrypt = e("./publicEncrypt"), r.privateDecrypt = e("./privateDecrypt"), r.privateEncrypt = function(e, t) {
                    return r.publicEncrypt(e, t, !0);
                }, r.publicDecrypt = function(e, t) {
                    return r.privateDecrypt(e, t, !0);
                };
            },
            {
                "./privateDecrypt": 471,
                "./publicEncrypt": 472
            }
        ],
        469: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash"), i = e("safe-buffer").Buffer;
                function s(e) {
                    var t = i.allocUnsafe(4);
                    return t.writeUInt32BE(e, 0), t;
                }
                t.exports = function(e, t) {
                    for(var r, o = i.alloc(0), a = 0; o.length < t;)r = s(a++), o = i.concat([
                        o,
                        n("sha1").update(e).update(r).digest()
                    ]);
                    return o.slice(0, t);
                };
            },
            {
                "create-hash": 386,
                "safe-buffer": 494
            }
        ],
        470: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        471: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("./mgf"), s = e("./xor"), o = e("bn.js"), a = e("browserify-rsa"), l = e("create-hash"), c = e("./withPublic"), u = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var h;
                    h = e.padding ? e.padding : r ? 1 : 4;
                    var f, d = n(e), p = d.modulus.byteLength();
                    if (t.length > p || new o(t).cmp(d.modulus) >= 0) throw new Error("decryption error");
                    f = r ? c(new o(t), d) : a(t, d);
                    var m = u.alloc(p - f.length);
                    if (f = u.concat([
                        m,
                        f
                    ], p), 4 === h) return function(e, t) {
                        var r = e.modulus.byteLength(), n = l("sha1").update(u.alloc(0)).digest(), o = n.length;
                        if (0 !== t[0]) throw new Error("decryption error");
                        var a = t.slice(1, o + 1), c = t.slice(o + 1), h = s(a, i(c, o)), f = s(c, i(h, r - o - 1));
                        if (function(e, t) {
                            e = u.from(e), t = u.from(t);
                            var r = 0, n = e.length;
                            e.length !== t.length && (r++, n = Math.min(e.length, t.length));
                            var i = -1;
                            for(; ++i < n;)r += e[i] ^ t[i];
                            return r;
                        }(n, f.slice(0, o))) throw new Error("decryption error");
                        var d = o;
                        for(; 0 === f[d];)d++;
                        if (1 !== f[d++]) throw new Error("decryption error");
                        return f.slice(d);
                    }(d, f);
                    if (1 === h) return function(e, t, r) {
                        var n = t.slice(0, 2), i = 2, s = 0;
                        for(; 0 !== t[i++];)if (i >= t.length) {
                            s++;
                            break;
                        }
                        var o = t.slice(2, i - 1);
                        ("0002" !== n.toString("hex") && !r || "0001" !== n.toString("hex") && r) && s++;
                        o.length < 8 && s++;
                        if (s) throw new Error("decryption error");
                        return t.slice(i);
                    }(0, f, r);
                    if (3 === h) return f;
                    throw new Error("unknown padding");
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        472: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("randombytes"), s = e("create-hash"), o = e("./mgf"), a = e("./xor"), l = e("bn.js"), c = e("./withPublic"), u = e("browserify-rsa"), h = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var f;
                    f = e.padding ? e.padding : r ? 1 : 4;
                    var d, p = n(e);
                    if (4 === f) d = function(e, t) {
                        var r = e.modulus.byteLength(), n = t.length, c = s("sha1").update(h.alloc(0)).digest(), u = c.length, f = 2 * u;
                        if (n > r - f - 2) throw new Error("message too long");
                        var d = h.alloc(r - n - f - 2), p = r - u - 1, m = i(u), b = a(h.concat([
                            c,
                            d,
                            h.alloc(1, 1),
                            t
                        ], p), o(m, p)), g = a(m, o(b, u));
                        return new l(h.concat([
                            h.alloc(1),
                            g,
                            b
                        ], r));
                    }(p, t);
                    else if (1 === f) d = function(e, t, r) {
                        var n, s = t.length, o = e.modulus.byteLength();
                        if (s > o - 11) throw new Error("message too long");
                        n = r ? h.alloc(o - s - 3, 255) : function(e) {
                            var t, r = h.allocUnsafe(e), n = 0, s = i(2 * e), o = 0;
                            for(; n < e;)o === s.length && (s = i(2 * e), o = 0), (t = s[o++]) && (r[n++] = t);
                            return r;
                        }(o - s - 3);
                        return new l(h.concat([
                            h.from([
                                0,
                                r ? 1 : 2
                            ]),
                            n,
                            h.alloc(1),
                            t
                        ], o));
                    }(p, t, r);
                    else {
                        if (3 !== f) throw new Error("unknown padding");
                        if ((d = new l(t)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
                    }
                    return r ? u(d, p) : c(d, p);
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        473: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    return i.from(e.toRed(n.mont(t.modulus)).redPow(new n(t.publicExponent)).fromRed().toArray());
                };
            },
            {
                "bn.js": 470,
                "safe-buffer": 494
            }
        ],
        474: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    for(var r = e.length, n = -1; ++n < r;)e[n] ^= t[n];
                    return e;
                };
            },
            {}
        ],
        475: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("safe-buffer").Buffer, s = n.crypto || n.msCrypto;
                        s && s.getRandomValues ? t.exports = function(e, t) {
                            if (e > 4294967295) throw new RangeError("requested too many random bytes");
                            var n = i.allocUnsafe(e);
                            if (e > 0) {
                                if (e > 65536) for(var o = 0; o < e; o += 65536)s.getRandomValues(n.slice(o, o + 65536));
                                else s.getRandomValues(n);
                            }
                            if ("function" == typeof t) return r.nextTick(function() {
                                t(null, n);
                            });
                            return n;
                        } : t.exports = function() {
                            throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                "safe-buffer": 494
            }
        ],
        476: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        function i() {
                            throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
                        }
                        var s = e("safe-buffer"), o = e("randombytes"), a = s.Buffer, l = s.kMaxLength, c = n.crypto || n.msCrypto, u = Math.pow(2, 32) - 1;
                        function h(e, t) {
                            if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
                            if (e > u || e < 0) throw new TypeError("offset must be a uint32");
                            if (e > l || e > t) throw new RangeError("offset out of range");
                        }
                        function f(e, t, r) {
                            if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
                            if (e > u || e < 0) throw new TypeError("size must be a uint32");
                            if (e + t > r || e > l) throw new RangeError("buffer too small");
                        }
                        function d(e, r, n, i) {
                            if (t.browser) {
                                var s = e.buffer, a = new Uint8Array(s, r, n);
                                return c.getRandomValues(a), i ? void t.nextTick(function() {
                                    i(null, e);
                                }) : e;
                            }
                            if (!i) return o(n).copy(e, r), e;
                            o(n, function(t, n) {
                                if (t) return i(t);
                                n.copy(e, r), i(null, e);
                            });
                        }
                        c && c.getRandomValues || !t.browser ? (r.randomFill = function(e, t, r, i) {
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            if ("function" == typeof t) i = t, t = 0, r = e.length;
                            else if ("function" == typeof r) i = r, r = e.length - t;
                            else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
                            return h(t, e.length), f(r, t, e.length), d(e, t, r, i);
                        }, r.randomFillSync = function(e, t, r) {
                            void 0 === t && (t = 0);
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            h(t, e.length), void 0 === r && (r = e.length - t);
                            return f(r, t, e.length), d(e, t, r);
                        }) : (r.randomFill = i, r.randomFillSync = i);
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        477: [
            function(e, t, r) {
                "use strict";
                var n = {};
                function i(e, t, r) {
                    r || (r = Error);
                    var i = function(e) {
                        var r, n;
                        function i(r, n, i) {
                            return e.call(this, function(e, r, n) {
                                return "string" == typeof t ? t : t(e, r, n);
                            }(r, n, i)) || this;
                        }
                        return n = e, (r = i).prototype = Object.create(n.prototype), r.prototype.constructor = r, r.__proto__ = n, i;
                    }(r);
                    i.prototype.name = r.name, i.prototype.code = e, n[e] = i;
                }
                function s(e, t) {
                    if (Array.isArray(e)) {
                        var r = e.length;
                        return e = e.map(function(e) {
                            return String(e);
                        }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : 2 === r ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                    }
                    return "of ".concat(t, " ").concat(String(e));
                }
                i("ERR_INVALID_OPT_VALUE", function(e, t) {
                    return 'The value "' + t + '" is invalid for option "' + e + '"';
                }, TypeError), i("ERR_INVALID_ARG_TYPE", function(e, t, r) {
                    var n, i, o, a;
                    if ("string" == typeof t && (i = "not ", t.substr(!o || o < 0 ? 0 : +o, i.length) === i) ? (n = "must not be", t = t.replace(/^not /, "")) : n = "must be", function(e, t, r) {
                        return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                    }(e, " argument")) a = "The ".concat(e, " ").concat(n, " ").concat(s(t, "type"));
                    else {
                        var l = function(e, t, r) {
                            return "number" != typeof r && (r = 0), !(r + t.length > e.length) && -1 !== e.indexOf(t, r);
                        }(e, ".") ? "property" : "argument";
                        a = 'The "'.concat(e, '" ').concat(l, " ").concat(n, " ").concat(s(t, "type"));
                    }
                    return a += ". Received type ".concat(typeof r);
                }, TypeError), i("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), i("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
                    return "The " + e + " method is not implemented";
                }), i("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), i("ERR_STREAM_DESTROYED", function(e) {
                    return "Cannot call " + e + " after a stream was destroyed";
                }), i("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), i("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), i("ERR_STREAM_WRITE_AFTER_END", "write after end"), i("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), i("ERR_UNKNOWN_ENCODING", function(e) {
                    return "Unknown encoding: " + e;
                }, TypeError), i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), t.exports.codes = n;
            },
            {}
        ],
        478: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = Object.keys || function(e) {
                            var t = [];
                            for(var r in e)t.push(r);
                            return t;
                        };
                        t.exports = c;
                        var i = e("./_stream_readable"), s = e("./_stream_writable");
                        e("inherits")(c, i);
                        for(var o = n(s.prototype), a = 0; a < o.length; a++){
                            var l = o[a];
                            c.prototype[l] || (c.prototype[l] = s.prototype[l]);
                        }
                        function c(e) {
                            if (!(this instanceof c)) return new c(e);
                            i.call(this, e), s.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", u)));
                        }
                        function u() {
                            this._writableState.ended || r.nextTick(h, this);
                        }
                        function h(e) {
                            e.end();
                        }
                        Object.defineProperty(c.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), Object.defineProperty(c.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(c.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(c.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function(e) {
                                void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                            }
                        });
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./_stream_readable": 480,
                "./_stream_writable": 482,
                _process: 467,
                inherits: 440
            }
        ],
        479: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("./_stream_transform");
                function i(e) {
                    if (!(this instanceof i)) return new i(e);
                    n.call(this, e);
                }
                e("inherits")(i, n), i.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 481,
                inherits: 440
            }
        ],
        480: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i;
                        t.exports = M, M.ReadableState = S;
                        e("events").EventEmitter;
                        var s = function(e, t) {
                            return e.listeners(t).length;
                        }, o = e("./internal/streams/stream"), a = e("buffer").Buffer, l = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var c, u = e("util");
                        c = u && u.debuglog ? u.debuglog("stream") : function() {};
                        var h, f, d, p = e("./internal/streams/buffer_list"), m = e("./internal/streams/destroy"), b = e("./internal/streams/state").getHighWaterMark, g = e("../errors").codes, y = g.ERR_INVALID_ARG_TYPE, v = g.ERR_STREAM_PUSH_AFTER_EOF, w = g.ERR_METHOD_NOT_IMPLEMENTED, _ = g.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                        e("inherits")(M, o);
                        var x = m.errorOrDestroy, k = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function S(t, r, n) {
                            i = i || e("./_stream_duplex"), t = t || {}, "boolean" != typeof n && (n = r instanceof i), this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode), this.highWaterMark = b(this, t, "readableHighWaterMark", n), this.buffer = new p, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (h || (h = e("string_decoder/").StringDecoder), this.decoder = new h(t.encoding), this.encoding = t.encoding);
                        }
                        function M(t) {
                            if (i = i || e("./_stream_duplex"), !(this instanceof M)) return new M(t);
                            var r = this instanceof i;
                            this._readableState = new S(t, this, r), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), o.call(this);
                        }
                        function C(e, t, r, n, i) {
                            c("readableAddChunk", t);
                            var s, o = e._readableState;
                            if (null === t) o.reading = !1, function(e, t) {
                                if (c("onEofChunk"), t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, t.sync ? A(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, R(e)));
                            }(e, o);
                            else if (i || (s = function(e, t) {
                                var r;
                                n = t, a.isBuffer(n) || n instanceof l || "string" == typeof t || void 0 === t || e.objectMode || (r = new y("chunk", [
                                    "string",
                                    "Buffer",
                                    "Uint8Array"
                                ], t));
                                var n;
                                return r;
                            }(o, t)), s) x(e, s);
                            else if (o.objectMode || t && t.length > 0) {
                                if ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === a.prototype || (t = function(e) {
                                    return a.from(e);
                                }(t)), n) o.endEmitted ? x(e, new _) : T(e, o, t, !0);
                                else if (o.ended) x(e, new v);
                                else {
                                    if (o.destroyed) return !1;
                                    o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? T(e, o, t, !1) : O(e, o)) : T(e, o, t, !1);
                                }
                            } else n || (o.reading = !1, O(e, o));
                            return !o.ended && (o.length < o.highWaterMark || 0 === o.length);
                        }
                        function T(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", r)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && A(e)), O(e, t);
                        }
                        Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), M.prototype.destroy = m.destroy, M.prototype._undestroy = m.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        }, M.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = a.from(e, t), t = ""), r = !0), C(this, e, t, !1, r);
                        }, M.prototype.unshift = function(e) {
                            return C(this, e, null, !0, !1);
                        }, M.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, M.prototype.setEncoding = function(t) {
                            h || (h = e("string_decoder/").StringDecoder);
                            var r = new h(t);
                            this._readableState.decoder = r, this._readableState.encoding = this._readableState.decoder.encoding;
                            for(var n = this._readableState.buffer.head, i = ""; null !== n;)i += r.write(n.data), n = n.next;
                            return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
                        };
                        function E(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 1073741824 ? e = 1073741824 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function A(e) {
                            var t = e._readableState;
                            c("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (c("emitReadable", t.flowing), t.emittedReadable = !0, r.nextTick(R, e));
                        }
                        function R(e) {
                            var t = e._readableState;
                            c("emitReadable_", t.destroyed, t.length, t.ended), t.destroyed || !t.length && !t.ended || (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, B(e);
                        }
                        function O(e, t) {
                            t.readingMore || (t.readingMore = !0, r.nextTick(j, e, t));
                        }
                        function j(e, t) {
                            for(; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);){
                                var r = t.length;
                                if (c("maybeReadMore read 0"), e.read(0), r === t.length) break;
                            }
                            t.readingMore = !1;
                        }
                        function I(e) {
                            var t = e._readableState;
                            t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
                        }
                        function N(e) {
                            c("readable nexttick read 0"), e.read(0);
                        }
                        function P(e, t) {
                            c("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), B(e), t.flowing && !t.reading && e.read(0);
                        }
                        function B(e) {
                            var t = e._readableState;
                            for(c("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function D(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : r = t.buffer.consume(e, t.decoder), r);
                        }
                        function F(e) {
                            var t = e._readableState;
                            c("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, r.nextTick(L, t, e));
                        }
                        function L(e, t) {
                            if (c("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
                                var r = t._writableState;
                                (!r || r.autoDestroy && r.finished) && t.destroy();
                            }
                        }
                        function z(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        M.prototype.read = function(e) {
                            c("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 !== t.highWaterMark ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return c("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? F(this) : A(this), null;
                            if (0 === (e = E(e, t)) && t.ended) return 0 === t.length && F(this), null;
                            var n, i = t.needReadable;
                            return c("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && c("length less than watermark", i = !0), t.ended || t.reading ? c("reading or ended", i = !1) : i && (c("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = E(r, t))), null === (n = e > 0 ? D(e, t) : null) ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && F(this)), null !== n && this.emit("data", n), n;
                        }, M.prototype._read = function(e) {
                            x(this, new w("_read()"));
                        }, M.prototype.pipe = function(e, t) {
                            var n = this, i = this._readableState;
                            switch(i.pipesCount){
                                case 0:
                                    i.pipes = e;
                                    break;
                                case 1:
                                    i.pipes = [
                                        i.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    i.pipes.push(e);
                            }
                            i.pipesCount += 1, c("pipe count=%d opts=%j", i.pipesCount, t);
                            var o = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? l : b;
                            function a(t, r) {
                                c("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, c("cleanup"), e.removeListener("close", p), e.removeListener("finish", m), e.removeListener("drain", u), e.removeListener("error", d), e.removeListener("unpipe", a), n.removeListener("end", l), n.removeListener("end", b), n.removeListener("data", f), h = !0, !i.awaitDrain || e._writableState && !e._writableState.needDrain || u());
                            }
                            function l() {
                                c("onend"), e.end();
                            }
                            i.endEmitted ? r.nextTick(o) : n.once("end", o), e.on("unpipe", a);
                            var u = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    c("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s(e, "data") && (t.flowing = !0, B(e));
                                };
                            }(n);
                            e.on("drain", u);
                            var h = !1;
                            function f(t) {
                                c("ondata");
                                var r = e.write(t);
                                c("dest.write", r), !1 === r && ((1 === i.pipesCount && i.pipes === e || i.pipesCount > 1 && -1 !== z(i.pipes, e)) && !h && (c("false write response, pause", i.awaitDrain), i.awaitDrain++), n.pause());
                            }
                            function d(t) {
                                c("onerror", t), b(), e.removeListener("error", d), 0 === s(e, "error") && x(e, t);
                            }
                            function p() {
                                e.removeListener("finish", m), b();
                            }
                            function m() {
                                c("onfinish"), e.removeListener("close", p), b();
                            }
                            function b() {
                                c("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", f), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", d), e.once("close", p), e.once("finish", m), e.emit("pipe", n), i.flowing || (c("pipe resume"), n.resume()), e;
                        }, M.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = z(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, M.prototype.on = function(e, t) {
                            var n = o.prototype.on.call(this, e, t), i = this._readableState;
                            return "data" === e ? (i.readableListening = this.listenerCount("readable") > 0, !1 !== i.flowing && this.resume()) : "readable" === e && (i.endEmitted || i.readableListening || (i.readableListening = i.needReadable = !0, i.flowing = !1, i.emittedReadable = !1, c("on readable", i.length, i.reading), i.length ? A(this) : i.reading || r.nextTick(N, this))), n;
                        }, M.prototype.addListener = M.prototype.on, M.prototype.removeListener = function(e, t) {
                            var n = o.prototype.removeListener.call(this, e, t);
                            return "readable" === e && r.nextTick(I, this), n;
                        }, M.prototype.removeAllListeners = function(e) {
                            var t = o.prototype.removeAllListeners.apply(this, arguments);
                            return "readable" !== e && void 0 !== e || r.nextTick(I, this), t;
                        }, M.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (c("resume"), e.flowing = !e.readableListening, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, r.nextTick(P, e, t));
                            }(this, e)), e.paused = !1, this;
                        }, M.prototype.pause = function() {
                            return c("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                        }, M.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (c("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (c("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < k.length; s++)e.on(k[s], this.emit.bind(this, k[s]));
                            return this._read = function(t) {
                                c("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, "function" == typeof Symbol && (M.prototype[Symbol.asyncIterator] = function() {
                            return void 0 === f && (f = e("./internal/streams/async_iterator")), f(this);
                        }), Object.defineProperty(M.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), Object.defineProperty(M.prototype, "readableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState && this._readableState.buffer;
                            }
                        }), Object.defineProperty(M.prototype, "readableFlowing", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.flowing;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.flowing = e);
                            }
                        }), M._fromList = D, Object.defineProperty(M.prototype, "readableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.length;
                            }
                        }), "function" == typeof Symbol && (M.from = function(t, r) {
                            return void 0 === d && (d = e("./internal/streams/from")), d(M, t, r);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/async_iterator": 483,
                "./internal/streams/buffer_list": 484,
                "./internal/streams/destroy": 485,
                "./internal/streams/from": 487,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                events: 422,
                inherits: 440,
                "string_decoder/": 522,
                util: 188
            }
        ],
        481: [
            function(e, t, r) {
                "use strict";
                t.exports = u;
                var n = e("../errors").codes, i = n.ERR_METHOD_NOT_IMPLEMENTED, s = n.ERR_MULTIPLE_CALLBACK, o = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, a = n.ERR_TRANSFORM_WITH_LENGTH_0, l = e("./_stream_duplex");
                function c(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (null === n) return this.emit("error", new s);
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function u(e) {
                    if (!(this instanceof u)) return new u(e);
                    l.call(this, e), this._transformState = {
                        afterTransform: c.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", h);
                }
                function h() {
                    var e = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? f(this, null, null) : this._flush(function(t, r) {
                        f(e, t, r);
                    });
                }
                function f(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new a;
                    if (e._transformState.transforming) throw new o;
                    return e.push(null);
                }
                e("inherits")(u, l), u.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, l.prototype.push.call(this, e, t);
                }, u.prototype._transform = function(e, t, r) {
                    r(new i("_transform()"));
                }, u.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, u.prototype._read = function(e) {
                    var t = this._transformState;
                    null === t.writechunk || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
                }, u.prototype._destroy = function(e, t) {
                    l.prototype._destroy.call(this, e, function(e) {
                        t(e);
                    });
                };
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                inherits: 440
            }
        ],
        482: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        function i(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        var s;
                        t.exports = M, M.WritableState = S;
                        var o = {
                            deprecate: e("util-deprecate")
                        }, a = e("./internal/streams/stream"), l = e("buffer").Buffer, c = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var u, h = e("./internal/streams/destroy"), f = e("./internal/streams/state").getHighWaterMark, d = e("../errors").codes, p = d.ERR_INVALID_ARG_TYPE, m = d.ERR_METHOD_NOT_IMPLEMENTED, b = d.ERR_MULTIPLE_CALLBACK, g = d.ERR_STREAM_CANNOT_PIPE, y = d.ERR_STREAM_DESTROYED, v = d.ERR_STREAM_NULL_VALUES, w = d.ERR_STREAM_WRITE_AFTER_END, _ = d.ERR_UNKNOWN_ENCODING, x = h.errorOrDestroy;
                        function k() {}
                        function S(t, n, o) {
                            s = s || e("./_stream_duplex"), t = t || {}, "boolean" != typeof o && (o = n instanceof s), this.objectMode = !!t.objectMode, o && (this.objectMode = this.objectMode || !!t.writableObjectMode), this.highWaterMark = f(this, t, "writableHighWaterMark", o), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var a = !1 === t.decodeStrings;
                            this.decodeStrings = !a, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var n = e._writableState, i = n.sync, s = n.writecb;
                                    if ("function" != typeof s) throw new b;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(n), t) !function(e, t, n, i, s) {
                                        --t.pendingcb, n ? (r.nextTick(s, i), r.nextTick(O, e, t), e._writableState.errorEmitted = !0, x(e, i)) : (s(i), e._writableState.errorEmitted = !0, x(e, i), O(e, t));
                                    }(e, n, i, t, s);
                                    else {
                                        var o = A(n) || e.destroyed;
                                        o || n.corked || n.bufferProcessing || !n.bufferedRequest || E(e, n), i ? r.nextTick(T, e, n, o, s) : T(e, n, o, s);
                                    }
                                }(n, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new i(this);
                        }
                        function M(t) {
                            var r = this instanceof (s = s || e("./_stream_duplex"));
                            if (!r && !u.call(M, this)) return new M(t);
                            this._writableState = new S(t, this, r), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), a.call(this);
                        }
                        function C(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new y("write")) : r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function T(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), O(e, t);
                        }
                        function E(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, s = new Array(n), o = t.corkedRequestsFree;
                                o.entry = r;
                                for(var a = 0, l = !0; r;)s[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                s.allBuffers = l, C(e, t, !0, t.length, s, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new i(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (C(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function A(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function R(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && x(e, r), t.prefinished = !0, e.emit("prefinish"), O(e, t);
                            });
                        }
                        function O(e, t) {
                            var n = A(t);
                            if (n && (function(e, t) {
                                t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, r.nextTick(R, e, t)));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
                                var i = e._readableState;
                                (!i || i.autoDestroy && i.endEmitted) && e.destroy();
                            }
                            return n;
                        }
                        e("inherits")(M, a), S.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(S.prototype, "buffer", {
                                    get: o.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (u = Function.prototype[Symbol.hasInstance], Object.defineProperty(M, Symbol.hasInstance, {
                            value: function(e) {
                                return !!u.call(this, e) || this === M && e && e._writableState instanceof S;
                            }
                        })) : u = function(e) {
                            return e instanceof this;
                        }, M.prototype.pipe = function() {
                            x(this, new g);
                        }, M.prototype.write = function(e, t, n) {
                            var i, s = this._writableState, o = !1, a = !s.objectMode && (i = e, l.isBuffer(i) || i instanceof c);
                            return a && !l.isBuffer(e) && (e = function(e) {
                                return l.from(e);
                            }(e)), "function" == typeof t && (n = t, t = null), a ? t = "buffer" : t || (t = s.defaultEncoding), "function" != typeof n && (n = k), s.ending ? function(e, t) {
                                var n = new w;
                                x(e, n), r.nextTick(t, n);
                            }(this, n) : (a || function(e, t, n, i) {
                                var s;
                                return null === n ? s = new v : "string" == typeof n || t.objectMode || (s = new p("chunk", [
                                    "string",
                                    "Buffer"
                                ], n)), !s || (x(e, s), r.nextTick(i, s), !1);
                            }(this, s, e, n)) && (s.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = l.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var c = t.length < t.highWaterMark;
                                c || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var u = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, u ? u.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else C(e, t, !1, a, n, i, s);
                                return c;
                            }(this, s, a, e, t, n)), o;
                        }, M.prototype.cork = function() {
                            this._writableState.corked++;
                        }, M.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || E(this, e));
                        }, M.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new _(e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(M.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(M.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), M.prototype._write = function(e, t, r) {
                            r(new m("_write()"));
                        }, M.prototype._writev = null, M.prototype.end = function(e, t, n) {
                            var i = this._writableState;
                            return "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null != e && this.write(e, t), i.corked && (i.corked = 1, this.uncork()), i.ending || function(e, t, n) {
                                t.ending = !0, O(e, t), n && (t.finished ? r.nextTick(n) : e.once("finish", n));
                                t.ended = !0, e.writable = !1;
                            }(this, i, n), this;
                        }, Object.defineProperty(M.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), M.prototype.destroy = h.destroy, M.prototype._undestroy = h.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/destroy": 485,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                inherits: 440,
                "util-deprecate": 524
            }
        ],
        483: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n;
                        function i(e, t, r) {
                            return (t = function(e) {
                                var t = function(e, t) {
                                    if ("object" != typeof e || null === e) return e;
                                    var r = e[Symbol.toPrimitive];
                                    if (void 0 !== r) {
                                        var n = r.call(e, t || "default");
                                        if ("object" != typeof n) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return ("string" === t ? String : Number)(e);
                                }(e, "string");
                                return "symbol" == typeof t ? t : String(t);
                            }(t)) in e ? Object.defineProperty(e, t, {
                                value: r,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : e[t] = r, e;
                        }
                        var s = e("./end-of-stream"), o = Symbol("lastResolve"), a = Symbol("lastReject"), l = Symbol("error"), c = Symbol("ended"), u = Symbol("lastPromise"), h = Symbol("handlePromise"), f = Symbol("stream");
                        function d(e, t) {
                            return {
                                value: e,
                                done: t
                            };
                        }
                        function p(e) {
                            var t = e[o];
                            if (null !== t) {
                                var r = e[f].read();
                                null !== r && (e[u] = null, e[o] = null, e[a] = null, t(d(r, !1)));
                            }
                        }
                        function m(e) {
                            r.nextTick(p, e);
                        }
                        var b = Object.getPrototypeOf(function() {}), g = Object.setPrototypeOf((i(n = {
                            get stream () {
                                return this[f];
                            },
                            next: function() {
                                var e = this, t = this[l];
                                if (null !== t) return Promise.reject(t);
                                if (this[c]) return Promise.resolve(d(void 0, !0));
                                if (this[f].destroyed) return new Promise(function(t, n) {
                                    r.nextTick(function() {
                                        e[l] ? n(e[l]) : t(d(void 0, !0));
                                    });
                                });
                                var n, i = this[u];
                                if (i) n = new Promise(function(e, t) {
                                    return function(r, n) {
                                        e.then(function() {
                                            t[c] ? r(d(void 0, !0)) : t[h](r, n);
                                        }, n);
                                    };
                                }(i, this));
                                else {
                                    var s = this[f].read();
                                    if (null !== s) return Promise.resolve(d(s, !1));
                                    n = new Promise(this[h]);
                                }
                                return this[u] = n, n;
                            }
                        }, Symbol.asyncIterator, function() {
                            return this;
                        }), i(n, "return", function() {
                            var e = this;
                            return new Promise(function(t, r) {
                                e[f].destroy(null, function(e) {
                                    e ? r(e) : t(d(void 0, !0));
                                });
                            });
                        }), n), b);
                        t.exports = function(e) {
                            var t, r = Object.create(g, (i(t = {}, f, {
                                value: e,
                                writable: !0
                            }), i(t, o, {
                                value: null,
                                writable: !0
                            }), i(t, a, {
                                value: null,
                                writable: !0
                            }), i(t, l, {
                                value: null,
                                writable: !0
                            }), i(t, c, {
                                value: e._readableState.endEmitted,
                                writable: !0
                            }), i(t, h, {
                                value: function(e, t) {
                                    var n = r[f].read();
                                    n ? (r[u] = null, r[o] = null, r[a] = null, e(d(n, !1))) : (r[o] = e, r[a] = t);
                                },
                                writable: !0
                            }), t));
                            return r[u] = null, s(e, function(e) {
                                if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
                                    var t = r[a];
                                    return null !== t && (r[u] = null, r[o] = null, r[a] = null, t(e)), void (r[l] = e);
                                }
                                var n = r[o];
                                null !== n && (r[u] = null, r[o] = null, r[a] = null, n(d(void 0, !0))), r[c] = !0;
                            }), e.on("readable", m.bind(null, r)), r;
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./end-of-stream": 486,
                _process: 467
            }
        ],
        484: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function i(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? n(Object(r), !0).forEach(function(t) {
                            s(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function s(e, t, r) {
                    return (t = a(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function o(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a(n.key), n);
                    }
                }
                function a(e) {
                    var t = function(e, t) {
                        if ("object" != typeof e || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == typeof t ? t : String(t);
                }
                var l = e("buffer").Buffer, c = e("util").inspect, u = c && c.custom || "inspect";
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    var t, r, n;
                    return t = e, r = [
                        {
                            key: "push",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: null
                                };
                                this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = t), this.head = t, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var e = this.head.data;
                                    return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(e) {
                                if (0 === this.length) return "";
                                for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                                return r;
                            }
                        },
                        {
                            key: "concat",
                            value: function(e) {
                                if (0 === this.length) return l.alloc(0);
                                for(var t, r, n, i = l.allocUnsafe(e >>> 0), s = this.head, o = 0; s;)t = s.data, r = i, n = o, l.prototype.copy.call(t, r, n), o += s.data.length, s = s.next;
                                return i;
                            }
                        },
                        {
                            key: "consume",
                            value: function(e, t) {
                                var r;
                                return e < this.head.data.length ? (r = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : r = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), r;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(e) {
                                var t = this.head, r = 1, n = t.data;
                                for(e -= n.length; t = t.next;){
                                    var i = t.data, s = e > i.length ? i.length : e;
                                    if (s === i.length ? n += i : n += i.slice(0, e), 0 == (e -= s)) {
                                        s === i.length ? (++r, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = i.slice(s));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, n;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(e) {
                                var t = l.allocUnsafe(e), r = this.head, n = 1;
                                for(r.data.copy(t), e -= r.data.length; r = r.next;){
                                    var i = r.data, s = e > i.length ? i.length : e;
                                    if (i.copy(t, t.length - e, 0, s), 0 == (e -= s)) {
                                        s === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(s));
                                        break;
                                    }
                                    ++n;
                                }
                                return this.length -= n, t;
                            }
                        },
                        {
                            key: u,
                            value: function(e, t) {
                                return c(this, i(i({}, t), {}, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ], o(t.prototype, r), n && o(t, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            {
                buffer: 220,
                util: 188
            }
        ],
        485: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(e, t) {
                            i(e, t), n(e);
                        }
                        function n(e) {
                            e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
                        }
                        function i(e, t) {
                            e.emit("error", t);
                        }
                        t.exports = {
                            destroy: function(t, s) {
                                var o = this, a = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
                                return a || l ? (s ? s(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, e.nextTick(i, this, t)) : e.nextTick(i, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(t) {
                                    !s && t ? o._writableState ? o._writableState.errorEmitted ? e.nextTick(n, o) : (o._writableState.errorEmitted = !0, e.nextTick(r, o, t)) : e.nextTick(r, o, t) : s ? (e.nextTick(n, o), s(t)) : e.nextTick(n, o);
                                }), this);
                            },
                            undestroy: function() {
                                this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                            },
                            errorOrDestroy: function(e, t) {
                                var r = e._readableState, n = e._writableState;
                                r && r.autoDestroy || n && n.autoDestroy ? e.destroy(t) : e.emit("error", t);
                            }
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        486: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                function i() {}
                t.exports = function e(t, r, s) {
                    if ("function" == typeof r) return e(t, null, r);
                    r || (r = {}), s = function(e) {
                        var t = !1;
                        return function() {
                            if (!t) {
                                t = !0;
                                for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                                e.apply(this, n);
                            }
                        };
                    }(s || i);
                    var o = r.readable || !1 !== r.readable && t.readable, a = r.writable || !1 !== r.writable && t.writable, l = function() {
                        t.writable || u();
                    }, c = t._writableState && t._writableState.finished, u = function() {
                        a = !1, c = !0, o || s.call(t);
                    }, h = t._readableState && t._readableState.endEmitted, f = function() {
                        o = !1, h = !0, a || s.call(t);
                    }, d = function(e) {
                        s.call(t, e);
                    }, p = function() {
                        var e;
                        return o && !h ? (t._readableState && t._readableState.ended || (e = new n), s.call(t, e)) : a && !c ? (t._writableState && t._writableState.ended || (e = new n), s.call(t, e)) : void 0;
                    }, m = function() {
                        t.req.on("finish", u);
                    };
                    return !function(e) {
                        return e.setHeader && "function" == typeof e.abort;
                    }(t) ? a && !t._writableState && (t.on("end", l), t.on("close", l)) : (t.on("complete", u), t.on("abort", p), t.req ? m() : t.on("request", m)), t.on("end", f), t.on("finish", u), !1 !== r.error && t.on("error", d), t.on("close", p), function() {
                        t.removeListener("complete", u), t.removeListener("abort", p), t.removeListener("request", m), t.req && t.req.removeListener("finish", u), t.removeListener("end", l), t.removeListener("close", l), t.removeListener("finish", u), t.removeListener("end", f), t.removeListener("error", d), t.removeListener("close", p);
                    };
                };
            },
            {
                "../../../errors": 477
            }
        ],
        487: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            {}
        ],
        488: [
            function(e, t, r) {
                "use strict";
                var n;
                var i = e("../../../errors").codes, s = i.ERR_MISSING_ARGS, o = i.ERR_STREAM_DESTROYED;
                function a(e) {
                    if (e) throw e;
                }
                function l(t, r, i, s) {
                    s = function(e) {
                        var t = !1;
                        return function() {
                            t || (t = !0, e.apply(void 0, arguments));
                        };
                    }(s);
                    var a = !1;
                    t.on("close", function() {
                        a = !0;
                    }), void 0 === n && (n = e("./end-of-stream")), n(t, {
                        readable: r,
                        writable: i
                    }, function(e) {
                        if (e) return s(e);
                        a = !0, s();
                    });
                    var l = !1;
                    return function(e) {
                        if (!a && !l) return l = !0, function(e) {
                            return e.setHeader && "function" == typeof e.abort;
                        }(t) ? t.abort() : "function" == typeof t.destroy ? t.destroy() : void s(e || new o("pipe"));
                    };
                }
                function c(e) {
                    e();
                }
                function u(e, t) {
                    return e.pipe(t);
                }
                function h(e) {
                    return e.length ? "function" != typeof e[e.length - 1] ? a : e.pop() : a;
                }
                t.exports = function() {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    var n, i = h(t);
                    if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new s("streams");
                    var o = t.map(function(e, r) {
                        var s = r < t.length - 1;
                        return l(e, s, r > 0, function(e) {
                            n || (n = e), e && o.forEach(c), s || (o.forEach(c), i(n));
                        });
                    });
                    return t.reduce(u);
                };
            },
            {
                "../../../errors": 477,
                "./end-of-stream": 486
            }
        ],
        489: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                t.exports = {
                    getHighWaterMark: function(e, t, r, i) {
                        var s = function(e, t, r) {
                            return null != e.highWaterMark ? e.highWaterMark : t ? e[r] : null;
                        }(t, i, r);
                        if (null != s) {
                            if (!isFinite(s) || Math.floor(s) !== s || s < 0) throw new n(i ? r : "highWaterMark", s);
                            return Math.floor(s);
                        }
                        return e.objectMode ? 16 : 16384;
                    }
                };
            },
            {
                "../../../errors": 477
            }
        ],
        490: [
            function(e, t, r) {
                "use strict";
                t.exports = e("events").EventEmitter;
            },
            {
                events: 422
            }
        ],
        491: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js"), r.finished = e("./lib/internal/streams/end-of-stream.js"), r.pipeline = e("./lib/internal/streams/pipeline.js");
            },
            {
                "./lib/_stream_duplex.js": 478,
                "./lib/_stream_passthrough.js": 479,
                "./lib/_stream_readable.js": 480,
                "./lib/_stream_transform.js": 481,
                "./lib/_stream_writable.js": 482,
                "./lib/internal/streams/end-of-stream.js": 486,
                "./lib/internal/streams/pipeline.js": 488
            }
        ],
        492: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    var t = Object.prototype, r = t.hasOwnProperty, n = Object.defineProperty || function(e, t, r) {
                        e[t] = r.value;
                    }, i = "function" == typeof Symbol ? Symbol : {}, s = i.iterator || "@@iterator", o = i.asyncIterator || "@@asyncIterator", a = i.toStringTag || "@@toStringTag";
                    function l(e, t, r) {
                        return Object.defineProperty(e, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        l({}, "");
                    } catch (e) {
                        l = function(e, t, r) {
                            return e[t] = r;
                        };
                    }
                    function c(e, t, r, i) {
                        var s = t && t.prototype instanceof f ? t : f, o = Object.create(s.prototype), a = new M(i || []);
                        return n(o, "_invoke", {
                            value: _(e, r, a)
                        }), o;
                    }
                    function u(e, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, r)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    e.wrap = c;
                    var h = {};
                    function f() {}
                    function d() {}
                    function p() {}
                    var m = {};
                    l(m, s, function() {
                        return this;
                    });
                    var b = Object.getPrototypeOf, g = b && b(b(C([])));
                    g && g !== t && r.call(g, s) && (m = g);
                    var y = p.prototype = f.prototype = Object.create(m);
                    function v(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            l(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function w(e, t) {
                        var i;
                        n(this, "_invoke", {
                            value: function(n, s) {
                                function o() {
                                    return new t(function(i, o) {
                                        !function n(i, s, o, a) {
                                            var l = u(e[i], e, s);
                                            if ("throw" !== l.type) {
                                                var c = l.arg, h = c.value;
                                                return h && "object" == typeof h && r.call(h, "__await") ? t.resolve(h.__await).then(function(e) {
                                                    n("next", e, o, a);
                                                }, function(e) {
                                                    n("throw", e, o, a);
                                                }) : t.resolve(h).then(function(e) {
                                                    c.value = e, o(c);
                                                }, function(e) {
                                                    return n("throw", e, o, a);
                                                });
                                            }
                                            a(l.arg);
                                        }(n, s, i, o);
                                    });
                                }
                                return i = i ? i.then(o, o) : o();
                            }
                        });
                    }
                    function _(e, t, r) {
                        var n = "suspendedStart";
                        return function(i, s) {
                            if ("executing" === n) throw new Error("Generator is already running");
                            if ("completed" === n) {
                                if ("throw" === i) throw s;
                                return T();
                            }
                            for(r.method = i, r.arg = s;;){
                                var o = r.delegate;
                                if (o) {
                                    var a = x(o, r);
                                    if (a) {
                                        if (a === h) continue;
                                        return a;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if ("suspendedStart" === n) throw n = "completed", r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                n = "executing";
                                var l = u(e, t, r);
                                if ("normal" === l.type) {
                                    if (n = r.done ? "completed" : "suspendedYield", l.arg === h) continue;
                                    return {
                                        value: l.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
                            }
                        };
                    }
                    function x(e, t) {
                        var r = t.method, n = e.iterator[r];
                        if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), h;
                        var i = u(n, e.iterator, t.arg);
                        if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, h;
                        var s = i.arg;
                        return s ? s.done ? (t[e.resultName] = s.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : s : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
                    }
                    function k(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function S(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function M(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(k, this), this.reset(!0);
                    }
                    function C(e) {
                        if (e) {
                            var t = e[s];
                            if (t) return t.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var n = -1, i = function t() {
                                    for(; ++n < e.length;)if (r.call(e, n)) return t.value = e[n], t.done = !1, t;
                                    return t.value = void 0, t.done = !0, t;
                                };
                                return i.next = i;
                            }
                        }
                        return {
                            next: T
                        };
                    }
                    function T() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return d.prototype = p, n(y, "constructor", {
                        value: p,
                        configurable: !0
                    }), n(p, "constructor", {
                        value: d,
                        configurable: !0
                    }), d.displayName = l(p, a, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
                    }, e.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, p) : (e.__proto__ = p, l(e, a, "GeneratorFunction")), e.prototype = Object.create(y), e;
                    }, e.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, v(w.prototype), l(w.prototype, o, function() {
                        return this;
                    }), e.AsyncIterator = w, e.async = function(t, r, n, i, s) {
                        void 0 === s && (s = Promise);
                        var o = new w(c(t, r, n, i), s);
                        return e.isGeneratorFunction(r) ? o : o.next().then(function(e) {
                            return e.done ? e.value : o.next();
                        });
                    }, v(y), l(y, a, "Generator"), l(y, s, function() {
                        return this;
                    }), l(y, "toString", function() {
                        return "[object Generator]";
                    }), e.keys = function(e) {
                        var t = Object(e), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e.value = n, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, e.values = C, M.prototype = {
                        constructor: M,
                        reset: function(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !e) for(var t in this)"t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(e) {
                            if (this.done) throw e;
                            var t = this;
                            function n(r, n) {
                                return o.type = "throw", o.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var s = this.tryEntries[i], o = s.completion;
                                if ("root" === s.tryLoc) return n("end");
                                if (s.tryLoc <= this.prev) {
                                    var a = r.call(s, "catchLoc"), l = r.call(s, "finallyLoc");
                                    if (a && l) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    } else if (a) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                    } else {
                                        if (!l) throw new Error("try statement without catch or finally");
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var i = this.tryEntries[n];
                                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var s = i;
                                    break;
                                }
                            }
                            s && ("break" === e || "continue" === e) && s.tryLoc <= t && t <= s.finallyLoc && (s = null);
                            var o = s ? s.completion : {};
                            return o.type = e, o.arg = t, s ? (this.method = "next", this.next = s.finallyLoc, h) : this.complete(o);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), S(r), h;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        S(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e, t, r) {
                            return this.delegate = {
                                iterator: C(e),
                                resultName: t,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = void 0), h;
                        }
                    }, e;
                }("object" == typeof t ? t.exports : {});
                try {
                    regeneratorRuntime = n;
                } catch (e) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
                }
            },
            {}
        ],
        493: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer").Buffer, i = e("inherits"), s = e("hash-base"), o = new Array(16), a = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], l = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], c = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], u = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ], h = [
                    0,
                    1518500249,
                    1859775393,
                    2400959708,
                    2840853838
                ], f = [
                    1352829926,
                    1548603684,
                    1836072691,
                    2053994217,
                    0
                ];
                function d() {
                    s.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
                }
                function p(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function m(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ r ^ n) + s + o | 0, a) + i | 0;
                }
                function b(e, t, r, n, i, s, o, a) {
                    return p(e + (t & r | ~t & n) + s + o | 0, a) + i | 0;
                }
                function g(e, t, r, n, i, s, o, a) {
                    return p(e + ((t | ~r) ^ n) + s + o | 0, a) + i | 0;
                }
                function y(e, t, r, n, i, s, o, a) {
                    return p(e + (t & n | r & ~n) + s + o | 0, a) + i | 0;
                }
                function v(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ (r | ~n)) + s + o | 0, a) + i | 0;
                }
                i(d, s), d.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    for(var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, s = 0 | this._d, d = 0 | this._e, w = 0 | this._a, _ = 0 | this._b, x = 0 | this._c, k = 0 | this._d, S = 0 | this._e, M = 0; M < 80; M += 1){
                        var C, T;
                        M < 16 ? (C = m(r, n, i, s, d, e[a[M]], h[0], c[M]), T = v(w, _, x, k, S, e[l[M]], f[0], u[M])) : M < 32 ? (C = b(r, n, i, s, d, e[a[M]], h[1], c[M]), T = y(w, _, x, k, S, e[l[M]], f[1], u[M])) : M < 48 ? (C = g(r, n, i, s, d, e[a[M]], h[2], c[M]), T = g(w, _, x, k, S, e[l[M]], f[2], u[M])) : M < 64 ? (C = y(r, n, i, s, d, e[a[M]], h[3], c[M]), T = b(w, _, x, k, S, e[l[M]], f[3], u[M])) : (C = v(r, n, i, s, d, e[a[M]], h[4], c[M]), T = m(w, _, x, k, S, e[l[M]], f[4], u[M])), r = d, d = s, s = p(i, 10), i = n, n = C, w = S, S = k, k = p(x, 10), x = _, _ = T;
                    }
                    var E = this._b + i + k | 0;
                    this._b = this._c + s + S | 0, this._c = this._d + d + w | 0, this._d = this._e + r + _ | 0, this._e = this._a + n + x | 0, this._a = E;
                }, d.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = n.alloc ? n.alloc(20) : new n(20);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
                }, t.exports = d;
            },
            {
                buffer: 220,
                "hash-base": 425,
                inherits: 440
            }
        ],
        494: [
            function(e, t, r) {
                "use strict";
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), o.prototype = Object.create(i.prototype), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        495: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i = e("buffer"), s = i.Buffer, o = {};
                        for(n in i)i.hasOwnProperty(n) && "SlowBuffer" !== n && "Buffer" !== n && (o[n] = i[n]);
                        var a = o.Buffer = {};
                        for(n in s)s.hasOwnProperty(n) && "allocUnsafe" !== n && "allocUnsafeSlow" !== n && (a[n] = s[n]);
                        if (o.Buffer.prototype = s.prototype, a.from && a.from !== Uint8Array.from || (a.from = function(e, t, r) {
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof e);
                            if (e && void 0 === e.length) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            return s(e, t, r);
                        }), a.alloc || (a.alloc = function(e, t, r) {
                            if ("number" != typeof e) throw new TypeError('The "size" argument must be of type number. Received type ' + typeof e);
                            if (e < 0 || e >= 2 * 1073741824) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var n = s(e);
                            return t && 0 !== t.length ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                        }), !o.kStringMaxLength) try {
                            o.kStringMaxLength = r.binding("buffer").kStringMaxLength;
                        } catch (e) {}
                        o.constants || (o.constants = {
                            MAX_LENGTH: o.kMaxLength
                        }, o.kStringMaxLength && (o.constants.MAX_STRING_LENGTH = o.kStringMaxLength)), t.exports = o;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467,
                buffer: 220
            }
        ],
        496: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                const n = e("xmlchars/xml/1.0/ed5"), i = e("xmlchars/xml/1.1/ed2"), s = e("xmlchars/xmlns/1.0/ed3");
                var o = n.isS, a = n.isChar, l = n.isNameStartChar, c = n.isNameChar, u = n.S_LIST, h = n.NAME_RE, f = i.isChar, d = s.isNCNameStartChar, p = s.isNCNameChar, m = s.NC_NAME_RE;
                const b = "http://www.w3.org/XML/1998/namespace", g = "http://www.w3.org/2000/xmlns/", y = {
                    __proto__: null,
                    xml: b,
                    xmlns: g
                }, v = {
                    __proto__: null,
                    amp: "&",
                    gt: ">",
                    lt: "<",
                    quot: '"',
                    apos: "'"
                }, w = (e)=>34 === e || 39 === e, _ = [
                    34,
                    39
                ], x = [
                    ..._,
                    91,
                    62
                ], k = [
                    ..._,
                    60,
                    93
                ], S = [
                    61,
                    63,
                    ...u
                ], M = [
                    ...u,
                    62,
                    38,
                    60
                ];
                function C(e, t, r) {
                    switch(t){
                        case "xml":
                            r !== b && e.fail(`xml prefix must be bound to ${b}.`);
                            break;
                        case "xmlns":
                            r !== g && e.fail(`xmlns prefix must be bound to ${g}.`);
                    }
                    switch(r){
                        case g:
                            e.fail("" === t ? `the default namespace may not be set to ${r}.` : `may not assign a prefix (even "xmlns") to the URI ${g}.`);
                            break;
                        case b:
                            switch(t){
                                case "xml":
                                    break;
                                case "":
                                    e.fail(`the default namespace may not be set to ${r}.`);
                                    break;
                                default:
                                    e.fail("may not assign the xml namespace to another prefix.");
                            }
                    }
                }
                const T = (e)=>m.test(e), E = (e)=>h.test(e);
                r.EVENTS = [
                    "xmldecl",
                    "text",
                    "processinginstruction",
                    "doctype",
                    "comment",
                    "opentagstart",
                    "attribute",
                    "opentag",
                    "closetag",
                    "cdata",
                    "error",
                    "end",
                    "ready"
                ];
                const A = {
                    xmldecl: "xmldeclHandler",
                    text: "textHandler",
                    processinginstruction: "piHandler",
                    doctype: "doctypeHandler",
                    comment: "commentHandler",
                    opentagstart: "openTagStartHandler",
                    attribute: "attributeHandler",
                    opentag: "openTagHandler",
                    closetag: "closeTagHandler",
                    cdata: "cdataHandler",
                    error: "errorHandler",
                    end: "endHandler",
                    ready: "readyHandler"
                };
                r.SaxesParser = class {
                    constructor(e){
                        this.opt = null != e ? e : {}, this.fragmentOpt = !!this.opt.fragment;
                        const t = this.xmlnsOpt = !!this.opt.xmlns;
                        if (this.trackPosition = !1 !== this.opt.position, this.fileName = this.opt.fileName, t) {
                            this.nameStartCheck = d, this.nameCheck = p, this.isName = T, this.processAttribs = this.processAttribsNS, this.pushAttrib = this.pushAttribNS, this.ns = Object.assign({
                                __proto__: null
                            }, y);
                            const e = this.opt.additionalNamespaces;
                            null != e && (!function(e, t) {
                                for (const r of Object.keys(t))C(e, r, t[r]);
                            }(this, e), Object.assign(this.ns, e));
                        } else this.nameStartCheck = l, this.nameCheck = c, this.isName = E, this.processAttribs = this.processAttribsPlain, this.pushAttrib = this.pushAttribPlain;
                        this.stateTable = [
                            this.sBegin,
                            this.sBeginWhitespace,
                            this.sDoctype,
                            this.sDoctypeQuote,
                            this.sDTD,
                            this.sDTDQuoted,
                            this.sDTDOpenWaka,
                            this.sDTDOpenWakaBang,
                            this.sDTDComment,
                            this.sDTDCommentEnding,
                            this.sDTDCommentEnded,
                            this.sDTDPI,
                            this.sDTDPIEnding,
                            this.sText,
                            this.sEntity,
                            this.sOpenWaka,
                            this.sOpenWakaBang,
                            this.sComment,
                            this.sCommentEnding,
                            this.sCommentEnded,
                            this.sCData,
                            this.sCDataEnding,
                            this.sCDataEnding2,
                            this.sPIFirstChar,
                            this.sPIRest,
                            this.sPIBody,
                            this.sPIEnding,
                            this.sXMLDeclNameStart,
                            this.sXMLDeclName,
                            this.sXMLDeclEq,
                            this.sXMLDeclValueStart,
                            this.sXMLDeclValue,
                            this.sXMLDeclSeparator,
                            this.sXMLDeclEnding,
                            this.sOpenTag,
                            this.sOpenTagSlash,
                            this.sAttrib,
                            this.sAttribName,
                            this.sAttribNameSawWhite,
                            this.sAttribValue,
                            this.sAttribValueQuoted,
                            this.sAttribValueClosed,
                            this.sAttribValueUnquoted,
                            this.sCloseTag,
                            this.sCloseTagSawWhite
                        ], this._init();
                    }
                    get closed() {
                        return this._closed;
                    }
                    _init() {
                        var e;
                        this.openWakaBang = "", this.text = "", this.name = "", this.piTarget = "", this.entity = "", this.q = null, this.tags = [], this.tag = null, this.topNS = null, this.chunk = "", this.chunkPosition = 0, this.i = 0, this.prevI = 0, this.carriedFromPrevious = void 0, this.forbiddenState = 0, this.attribList = [];
                        const { fragmentOpt: t } = this;
                        this.state = t ? 13 : 0, this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = t, this.xmlDeclPossible = !t, this.xmlDeclExpects = [
                            "version"
                        ], this.entityReturnState = void 0;
                        let { defaultXMLVersion: r } = this.opt;
                        if (void 0 === r) {
                            if (!0 === this.opt.forceXMLVersion) throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
                            r = "1.0";
                        }
                        this.setXMLVersion(r), this.positionAtNewLine = 0, this.doctype = !1, this._closed = !1, this.xmlDecl = {
                            version: void 0,
                            encoding: void 0,
                            standalone: void 0
                        }, this.line = 1, this.column = 0, this.ENTITIES = Object.create(v), null === (e = this.readyHandler) || void 0 === e || e.call(this);
                    }
                    get position() {
                        return this.chunkPosition + this.i;
                    }
                    get columnIndex() {
                        return this.position - this.positionAtNewLine;
                    }
                    on(e, t) {
                        this[A[e]] = t;
                    }
                    off(e) {
                        this[A[e]] = void 0;
                    }
                    makeError(e) {
                        var t;
                        let r = null !== (t = this.fileName) && void 0 !== t ? t : "";
                        return this.trackPosition && (r.length > 0 && (r += ":"), r += `${this.line}:${this.column}`), r.length > 0 && (r += ": "), new Error(r + e);
                    }
                    fail(e) {
                        const t = this.makeError(e), r = this.errorHandler;
                        if (void 0 === r) throw t;
                        return r(t), this;
                    }
                    write(e) {
                        if (this.closed) return this.fail("cannot write after close; assign an onready handler.");
                        let t = !1;
                        null === e ? (t = !0, e = "") : "object" == typeof e && (e = e.toString()), void 0 !== this.carriedFromPrevious && (e = `${this.carriedFromPrevious}${e}`, this.carriedFromPrevious = void 0);
                        let r = e.length;
                        const n = e.charCodeAt(r - 1);
                        !t && (13 === n || n >= 55296 && n <= 56319) && (this.carriedFromPrevious = e[r - 1], r--, e = e.slice(0, r));
                        const { stateTable: i } = this;
                        for(this.chunk = e, this.i = 0; this.i < r;)i[this.state].call(this);
                        return this.chunkPosition += r, t ? this.end() : this;
                    }
                    close() {
                        return this.write(null);
                    }
                    getCode10() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r >= 32 || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    return 10 === e.charCodeAt(t + 1) && (this.i = t + 2), this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCode11() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r > 31 && r < 127 || r > 159 && 8232 !== r || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    {
                                        const r = e.charCodeAt(t + 1);
                                        10 !== r && 133 !== r || (this.i = t + 2);
                                    }
                                case 133:
                                case 8232:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCodeNorm() {
                        const e = this.getCode();
                        return -2 === e ? 10 : e;
                    }
                    unget() {
                        this.i = this.prevI, this.column--;
                    }
                    captureTo(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            const n = this.getCode(), i = -2 === n, s = i ? 10 : n;
                            if (-1 === s || e.includes(s)) return this.text += r.slice(t, this.prevI), s;
                            i && (this.text += r.slice(t, this.prevI) + "\n", t = this.i);
                        }
                    }
                    captureToChar(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            let n = this.getCode();
                            switch(n){
                                case -2:
                                    this.text += r.slice(t, this.prevI) + "\n", t = this.i, n = 10;
                                    break;
                                case -1:
                                    return this.text += r.slice(t), !1;
                            }
                            if (n === e) return this.text += r.slice(t, this.prevI), !0;
                        }
                    }
                    captureNameChars() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCode();
                            if (-1 === r) return this.name += e.slice(t), -1;
                            if (!c(r)) return this.name += e.slice(t, this.prevI), -2 === r ? 10 : r;
                        }
                    }
                    skipSpaces() {
                        for(;;){
                            const e = this.getCodeNorm();
                            if (-1 === e || !o(e)) return e;
                        }
                    }
                    setXMLVersion(e) {
                        this.currentXMLVersion = e, "1.0" === e ? (this.isChar = a, this.getCode = this.getCode10) : (this.isChar = f, this.getCode = this.getCode11);
                    }
                    sBegin() {
                        65279 === this.chunk.charCodeAt(0) && (this.i++, this.column++), this.state = 1;
                    }
                    sBeginWhitespace() {
                        const e = this.i, t = this.skipSpaces();
                        switch(this.prevI !== e && (this.xmlDeclPossible = !1), t){
                            case 60:
                                if (this.state = 15, 0 !== this.text.length) throw new Error("no-empty text at start");
                                break;
                            case -1:
                                break;
                            default:
                                this.unget(), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sDoctype() {
                        var e;
                        const t = this.captureTo(x);
                        switch(t){
                            case 62:
                                null === (e = this.doctypeHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13, this.doctype = !0;
                                break;
                            case -1:
                                break;
                            default:
                                this.text += String.fromCodePoint(t), 91 === t ? this.state = 4 : w(t) && (this.state = 3, this.q = t);
                        }
                    }
                    sDoctypeQuote() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.q = null, this.state = 2);
                    }
                    sDTD() {
                        const e = this.captureTo(k);
                        -1 !== e && (this.text += String.fromCodePoint(e), 93 === e ? this.state = 2 : 60 === e ? this.state = 6 : w(e) && (this.state = 5, this.q = e));
                    }
                    sDTDQuoted() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.state = 4, this.q = null);
                    }
                    sDTDOpenWaka() {
                        const e = this.getCodeNorm();
                        switch(this.text += String.fromCodePoint(e), e){
                            case 33:
                                this.state = 7, this.openWakaBang = "";
                                break;
                            case 63:
                                this.state = 11;
                                break;
                            default:
                                this.state = 4;
                        }
                    }
                    sDTDOpenWakaBang() {
                        const e = String.fromCodePoint(this.getCodeNorm()), t = this.openWakaBang += e;
                        this.text += e, "-" !== t && (this.state = "--" === t ? 8 : 4, this.openWakaBang = "");
                    }
                    sDTDComment() {
                        this.captureToChar(45) && (this.text += "-", this.state = 9);
                    }
                    sDTDCommentEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), this.state = 45 === e ? 10 : 8;
                    }
                    sDTDCommentEnded() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e ? this.state = 4 : (this.fail("malformed comment."), this.state = 8);
                    }
                    sDTDPI() {
                        this.captureToChar(63) && (this.text += "?", this.state = 12);
                    }
                    sDTDPIEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e && (this.state = 4);
                    }
                    sText() {
                        0 !== this.tags.length ? this.handleTextInRoot() : this.handleTextOutsideRoot();
                    }
                    sEntity() {
                        let { i: e } = this;
                        const { chunk: t } = this;
                        e: for(;;)switch(this.getCode()){
                            case -2:
                                this.entity += t.slice(e, this.prevI) + "\n", e = this.i;
                                break;
                            case 59:
                                {
                                    const { entityReturnState: r } = this, n = this.entity + t.slice(e, this.prevI);
                                    let i;
                                    this.state = r, "" === n ? (this.fail("empty entity name."), i = "&;") : (i = this.parseEntity(n), this.entity = ""), 13 === r && void 0 === this.textHandler || (this.text += i);
                                    break e;
                                }
                            case -1:
                                this.entity += t.slice(e);
                                break e;
                        }
                    }
                    sOpenWaka() {
                        const e = this.getCode();
                        if (l(e)) this.state = 34, this.unget(), this.xmlDeclPossible = !1;
                        else switch(e){
                            case 47:
                                this.state = 43, this.xmlDeclPossible = !1;
                                break;
                            case 33:
                                this.state = 16, this.openWakaBang = "", this.xmlDeclPossible = !1;
                                break;
                            case 63:
                                this.state = 23;
                                break;
                            default:
                                this.fail("disallowed character in tag name"), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sOpenWakaBang() {
                        switch(this.openWakaBang += String.fromCodePoint(this.getCodeNorm()), this.openWakaBang){
                            case "[CDATA[":
                                this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0), this.state = 20, this.openWakaBang = "";
                                break;
                            case "--":
                                this.state = 17, this.openWakaBang = "";
                                break;
                            case "DOCTYPE":
                                this.state = 2, (this.doctype || this.sawRoot) && this.fail("inappropriately located doctype declaration."), this.openWakaBang = "";
                                break;
                            default:
                                this.openWakaBang.length >= 7 && this.fail("incorrect syntax.");
                        }
                    }
                    sComment() {
                        this.captureToChar(45) && (this.state = 18);
                    }
                    sCommentEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        45 === t ? (this.state = 19, null === (e = this.commentHandler) || void 0 === e || e.call(this, this.text), this.text = "") : (this.text += "-" + String.fromCodePoint(t), this.state = 17);
                    }
                    sCommentEnded() {
                        const e = this.getCodeNorm();
                        62 !== e ? (this.fail("malformed comment."), this.text += "--" + String.fromCodePoint(e), this.state = 17) : this.state = 13;
                    }
                    sCData() {
                        this.captureToChar(93) && (this.state = 21);
                    }
                    sCDataEnding() {
                        const e = this.getCodeNorm();
                        93 === e ? this.state = 22 : (this.text += "]" + String.fromCodePoint(e), this.state = 20);
                    }
                    sCDataEnding2() {
                        var e;
                        const t = this.getCodeNorm();
                        switch(t){
                            case 62:
                                null === (e = this.cdataHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13;
                                break;
                            case 93:
                                this.text += "]";
                                break;
                            default:
                                this.text += "]]" + String.fromCodePoint(t), this.state = 20;
                        }
                    }
                    sPIFirstChar() {
                        const e = this.getCodeNorm();
                        this.nameStartCheck(e) ? (this.piTarget += String.fromCodePoint(e), this.state = 24) : 63 === e || o(e) ? (this.fail("processing instruction without a target."), this.state = 63 === e ? 26 : 25) : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(e), this.state = 24);
                    }
                    sPIRest() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCodeNorm();
                            if (-1 === r) return void (this.piTarget += e.slice(t));
                            if (!this.nameCheck(r)) {
                                this.piTarget += e.slice(t, this.prevI);
                                const n = 63 === r;
                                n || o(r) ? "xml" === this.piTarget ? (this.xmlDeclPossible || this.fail("an XML declaration must be at the start of the document."), this.state = n ? 33 : 27) : this.state = n ? 26 : 25 : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(r));
                                break;
                            }
                        }
                    }
                    sPIBody() {
                        if (0 === this.text.length) {
                            const e = this.getCodeNorm();
                            63 === e ? this.state = 26 : o(e) || (this.text = String.fromCodePoint(e));
                        } else this.captureToChar(63) && (this.state = 26);
                    }
                    sPIEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        if (62 === t) {
                            const { piTarget: t } = this;
                            "xml" === t.toLowerCase() && this.fail("the XML declaration must appear at the start of the document."), null === (e = this.piHandler) || void 0 === e || e.call(this, {
                                target: t,
                                body: this.text
                            }), this.piTarget = this.text = "", this.state = 13;
                        } else 63 === t ? this.text += "?" : (this.text += "?" + String.fromCodePoint(t), this.state = 25);
                        this.xmlDeclPossible = !1;
                    }
                    sXMLDeclNameStart() {
                        const e = this.skipSpaces();
                        63 !== e ? -1 !== e && (this.state = 28, this.name = String.fromCodePoint(e)) : this.state = 33;
                    }
                    sXMLDeclName() {
                        const e = this.captureTo(S);
                        if (63 === e) return this.state = 33, this.name += this.text, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (o(e) || 61 === e) {
                            if (this.name += this.text, this.text = "", !this.xmlDeclExpects.includes(this.name)) switch(this.name.length){
                                case 0:
                                    this.fail("did not expect any more name/value pairs.");
                                    break;
                                case 1:
                                    this.fail(`expected the name ${this.xmlDeclExpects[0]}.`);
                                    break;
                                default:
                                    this.fail("expected one of " + this.xmlDeclExpects.join(", "));
                            }
                            this.state = 61 === e ? 30 : 29;
                        }
                    }
                    sXMLDeclEq() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (61 !== e && this.fail("value required."), this.state = 30);
                    }
                    sXMLDeclValueStart() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (w(e) ? this.q = e : (this.fail("value must be quoted."), this.q = 32), this.state = 31);
                    }
                    sXMLDeclValue() {
                        const e = this.captureTo([
                            this.q,
                            63
                        ]);
                        if (63 === e) return this.state = 33, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (-1 === e) return;
                        const t = this.text;
                        switch(this.text = "", this.name){
                            case "version":
                                {
                                    this.xmlDeclExpects = [
                                        "encoding",
                                        "standalone"
                                    ];
                                    const e = t;
                                    this.xmlDecl.version = e, /^1\.[0-9]+$/.test(e) ? this.opt.forceXMLVersion || this.setXMLVersion(e) : this.fail("version number must match /^1\\.[0-9]+$/.");
                                    break;
                                }
                            case "encoding":
                                /^[A-Za-z][A-Za-z0-9._-]*$/.test(t) || this.fail("encoding value must match /^[A-Za-z0-9][A-Za-z0-9._-]*$/."), this.xmlDeclExpects = [
                                    "standalone"
                                ], this.xmlDecl.encoding = t;
                                break;
                            case "standalone":
                                "yes" !== t && "no" !== t && this.fail('standalone value must match "yes" or "no".'), this.xmlDeclExpects = [], this.xmlDecl.standalone = t;
                        }
                        this.name = "", this.state = 32;
                    }
                    sXMLDeclSeparator() {
                        const e = this.getCodeNorm();
                        63 !== e ? (o(e) || (this.fail("whitespace required."), this.unget()), this.state = 27) : this.state = 33;
                    }
                    sXMLDeclEnding() {
                        var e;
                        62 === this.getCodeNorm() ? ("xml" !== this.piTarget ? this.fail("processing instructions are not allowed before root.") : "version" !== this.name && this.xmlDeclExpects.includes("version") && this.fail("XML declaration must contain a version."), null === (e = this.xmldeclHandler) || void 0 === e || e.call(this, this.xmlDecl), this.name = "", this.piTarget = this.text = "", this.state = 13) : this.fail("The character ? is disallowed anywhere in XML declarations."), this.xmlDeclPossible = !1;
                    }
                    sOpenTag() {
                        var e;
                        const t = this.captureNameChars();
                        if (-1 === t) return;
                        const r = this.tag = {
                            name: this.name,
                            attributes: Object.create(null)
                        };
                        switch(this.name = "", this.xmlnsOpt && (this.topNS = r.ns = Object.create(null)), null === (e = this.openTagStartHandler) || void 0 === e || e.call(this, r), this.sawRoot = !0, !this.fragmentOpt && this.closedRoot && this.fail("documents may contain only one root."), t){
                            case 62:
                                this.openTag();
                                break;
                            case 47:
                                this.state = 35;
                                break;
                            default:
                                o(t) || this.fail("disallowed character in tag name."), this.state = 36;
                        }
                    }
                    sOpenTagSlash() {
                        62 === this.getCode() ? this.openSelfClosingTag() : (this.fail("forward-slash in opening tag not followed by >."), this.state = 36);
                    }
                    sAttrib() {
                        const e = this.skipSpaces();
                        -1 !== e && (l(e) ? (this.unget(), this.state = 37) : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : this.fail("disallowed character in attribute name."));
                    }
                    sAttribName() {
                        const e = this.captureNameChars();
                        61 === e ? this.state = 39 : o(e) ? this.state = 38 : 62 === e ? (this.fail("attribute without value."), this.pushAttrib(this.name, this.name), this.name = this.text = "", this.openTag()) : -1 !== e && this.fail("disallowed character in attribute name.");
                    }
                    sAttribNameSawWhite() {
                        const e = this.skipSpaces();
                        switch(e){
                            case -1:
                                return;
                            case 61:
                                this.state = 39;
                                break;
                            default:
                                this.fail("attribute without value."), this.text = "", this.name = "", 62 === e ? this.openTag() : l(e) ? (this.unget(), this.state = 37) : (this.fail("disallowed character in attribute name."), this.state = 36);
                        }
                    }
                    sAttribValue() {
                        const e = this.getCodeNorm();
                        w(e) ? (this.q = e, this.state = 40) : o(e) || (this.fail("unquoted attribute value."), this.state = 42, this.unget());
                    }
                    sAttribValueQuoted() {
                        const { q: e, chunk: t } = this;
                        let { i: r } = this;
                        for(;;)switch(this.getCode()){
                            case e:
                                return this.pushAttrib(this.name, this.text + t.slice(r, this.prevI)), this.name = this.text = "", this.q = null, void (this.state = 41);
                            case 38:
                                return this.text += t.slice(r, this.prevI), this.state = 14, void (this.entityReturnState = 40);
                            case 10:
                            case -2:
                            case 9:
                                this.text += t.slice(r, this.prevI) + " ", r = this.i;
                                break;
                            case 60:
                                return this.text += t.slice(r, this.prevI), void this.fail("disallowed character.");
                            case -1:
                                return void (this.text += t.slice(r));
                        }
                    }
                    sAttribValueClosed() {
                        const e = this.getCodeNorm();
                        o(e) ? this.state = 36 : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : l(e) ? (this.fail("no whitespace between attributes."), this.unget(), this.state = 37) : this.fail("disallowed character in attribute name.");
                    }
                    sAttribValueUnquoted() {
                        const e = this.captureTo(M);
                        switch(e){
                            case 38:
                                this.state = 14, this.entityReturnState = 42;
                                break;
                            case 60:
                                this.fail("disallowed character.");
                                break;
                            case -1:
                                break;
                            default:
                                this.text.includes("]]>") && this.fail('the string "]]>" is disallowed in char data.'), this.pushAttrib(this.name, this.text), this.name = this.text = "", 62 === e ? this.openTag() : this.state = 36;
                        }
                    }
                    sCloseTag() {
                        const e = this.captureNameChars();
                        62 === e ? this.closeTag() : o(e) ? this.state = 44 : -1 !== e && this.fail("disallowed character in closing tag.");
                    }
                    sCloseTagSawWhite() {
                        switch(this.skipSpaces()){
                            case 62:
                                this.closeTag();
                                break;
                            case -1:
                                break;
                            default:
                                this.fail("disallowed character in closing tag.");
                        }
                    }
                    handleTextInRoot() {
                        let { i: e, forbiddenState: t } = this;
                        const { chunk: r, textHandler: n } = this;
                        e: for(;;)switch(this.getCode()){
                            case 60:
                                if (this.state = 15, void 0 !== n) {
                                    const { text: t } = this, i = r.slice(e, this.prevI);
                                    0 !== t.length ? (n(t + i), this.text = "") : 0 !== i.length && n(i);
                                }
                                t = 0;
                                break e;
                            case 38:
                                this.state = 14, this.entityReturnState = 13, void 0 !== n && (this.text += r.slice(e, this.prevI)), t = 0;
                                break e;
                            case 93:
                                switch(t){
                                    case 0:
                                        t = 1;
                                        break;
                                    case 1:
                                        t = 2;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        throw new Error("impossible state");
                                }
                                break;
                            case 62:
                                2 === t && this.fail('the string "]]>" is disallowed in char data.'), t = 0;
                                break;
                            case -2:
                                void 0 !== n && (this.text += r.slice(e, this.prevI) + "\n"), e = this.i, t = 0;
                                break;
                            case -1:
                                void 0 !== n && (this.text += r.slice(e));
                                break e;
                            default:
                                t = 0;
                        }
                        this.forbiddenState = t;
                    }
                    handleTextOutsideRoot() {
                        let { i: e } = this;
                        const { chunk: t, textHandler: r } = this;
                        let n = !1;
                        e: for(;;){
                            const i = this.getCode();
                            switch(i){
                                case 60:
                                    if (this.state = 15, void 0 !== r) {
                                        const { text: n } = this, i = t.slice(e, this.prevI);
                                        0 !== n.length ? (r(n + i), this.text = "") : 0 !== i.length && r(i);
                                    }
                                    break e;
                                case 38:
                                    this.state = 14, this.entityReturnState = 13, void 0 !== r && (this.text += t.slice(e, this.prevI)), n = !0;
                                    break e;
                                case -2:
                                    void 0 !== r && (this.text += t.slice(e, this.prevI) + "\n"), e = this.i;
                                    break;
                                case -1:
                                    void 0 !== r && (this.text += t.slice(e));
                                    break e;
                                default:
                                    o(i) || (n = !0);
                            }
                        }
                        n && (this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0));
                    }
                    pushAttribNS(e, t) {
                        var r;
                        const { prefix: n, local: i } = this.qname(e), s = {
                            name: e,
                            prefix: n,
                            local: i,
                            value: t
                        };
                        if (this.attribList.push(s), null === (r = this.attributeHandler) || void 0 === r || r.call(this, s), "xmlns" === n) {
                            const e = t.trim();
                            "1.0" === this.currentXMLVersion && "" === e && this.fail("invalid attempt to undefine prefix in XML 1.0"), this.topNS[i] = e, C(this, i, e);
                        } else if ("xmlns" === e) {
                            const e = t.trim();
                            this.topNS[""] = e, C(this, "", e);
                        }
                    }
                    pushAttribPlain(e, t) {
                        var r;
                        const n = {
                            name: e,
                            value: t
                        };
                        this.attribList.push(n), null === (r = this.attributeHandler) || void 0 === r || r.call(this, n);
                    }
                    end() {
                        var e, t;
                        this.sawRoot || this.fail("document must contain a root element.");
                        const { tags: r } = this;
                        for(; r.length > 0;){
                            const e = r.pop();
                            this.fail("unclosed tag: " + e.name);
                        }
                        0 !== this.state && 13 !== this.state && this.fail("unexpected end.");
                        const { text: n } = this;
                        return 0 !== n.length && (null === (e = this.textHandler) || void 0 === e || e.call(this, n), this.text = ""), this._closed = !0, null === (t = this.endHandler) || void 0 === t || t.call(this), this._init(), this;
                    }
                    resolve(e) {
                        var t, r;
                        let n = this.topNS[e];
                        if (void 0 !== n) return n;
                        const { tags: i } = this;
                        for(let t = i.length - 1; t >= 0; t--)if (n = i[t].ns[e], void 0 !== n) return n;
                        return n = this.ns[e], void 0 !== n ? n : null === (r = (t = this.opt).resolvePrefix) || void 0 === r ? void 0 : r.call(t, e);
                    }
                    qname(e) {
                        const t = e.indexOf(":");
                        if (-1 === t) return {
                            prefix: "",
                            local: e
                        };
                        const r = e.slice(t + 1), n = e.slice(0, t);
                        return ("" === n || "" === r || r.includes(":")) && this.fail(`malformed name: ${e}.`), {
                            prefix: n,
                            local: r
                        };
                    }
                    processAttribsNS() {
                        var e;
                        const { attribList: t } = this, r = this.tag;
                        {
                            const { prefix: t, local: n } = this.qname(r.name);
                            r.prefix = t, r.local = n;
                            const i = r.uri = null !== (e = this.resolve(t)) && void 0 !== e ? e : "";
                            "" !== t && ("xmlns" === t && this.fail('tags may not have "xmlns" as prefix.'), "" === i && (this.fail(`unbound namespace prefix: ${JSON.stringify(t)}.`), r.uri = t));
                        }
                        if (0 === t.length) return;
                        const { attributes: n } = r, i = new Set;
                        for (const e of t){
                            const { name: t, prefix: r, local: s } = e;
                            let o, a;
                            "" === r ? (o = "xmlns" === t ? g : "", a = t) : (o = this.resolve(r), void 0 === o && (this.fail(`unbound namespace prefix: ${JSON.stringify(r)}.`), o = r), a = `{${o}}${s}`), i.has(a) && this.fail(`duplicate attribute: ${a}.`), i.add(a), e.uri = o, n[t] = e;
                        }
                        this.attribList = [];
                    }
                    processAttribsPlain() {
                        const { attribList: e } = this, t = this.tag.attributes;
                        for (const { name: r, value: n } of e)void 0 !== t[r] && this.fail(`duplicate attribute: ${r}.`), t[r] = n;
                        this.attribList = [];
                    }
                    openTag() {
                        var e;
                        this.processAttribs();
                        const { tags: t } = this, r = this.tag;
                        r.isSelfClosing = !1, null === (e = this.openTagHandler) || void 0 === e || e.call(this, r), t.push(r), this.state = 13, this.name = "";
                    }
                    openSelfClosingTag() {
                        var e, t, r;
                        this.processAttribs();
                        const { tags: n } = this, i = this.tag;
                        i.isSelfClosing = !0, null === (e = this.openTagHandler) || void 0 === e || e.call(this, i), null === (t = this.closeTagHandler) || void 0 === t || t.call(this, i);
                        null === (this.tag = null !== (r = n[n.length - 1]) && void 0 !== r ? r : null) && (this.closedRoot = !0), this.state = 13, this.name = "";
                    }
                    closeTag() {
                        const { tags: e, name: t } = this;
                        if (this.state = 13, this.name = "", "" === t) return this.fail("weird empty close tag."), void (this.text += "</>");
                        const r = this.closeTagHandler;
                        let n = e.length;
                        for(; n-- > 0;){
                            const n = this.tag = e.pop();
                            if (this.topNS = n.ns, null == r || r(n), n.name === t) break;
                            this.fail("unexpected close tag.");
                        }
                        0 === n ? this.closedRoot = !0 : n < 0 && (this.fail(`unmatched closing tag: ${t}.`), this.text += `</${t}>`);
                    }
                    parseEntity(e) {
                        if ("#" !== e[0]) {
                            const t = this.ENTITIES[e];
                            return void 0 !== t ? t : (this.fail(this.isName(e) ? "undefined entity." : "disallowed character in entity name."), `&${e};`);
                        }
                        let t = NaN;
                        return "x" === e[1] && /^#x[0-9a-f]+$/i.test(e) ? t = parseInt(e.slice(2), 16) : /^#[0-9]+$/.test(e) && (t = parseInt(e.slice(1), 10)), this.isChar(t) ? String.fromCodePoint(t) : (this.fail("malformed character entity."), `&${e};`);
                    }
                };
            },
            {
                "xmlchars/xml/1.0/ed5": 543,
                "xmlchars/xml/1.1/ed2": 544,
                "xmlchars/xmlns/1.0/ed3": 545
            }
        ],
        497: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t) {
                    this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
                }
                i.prototype.update = function(e, t) {
                    "string" == typeof e && (t = t || "utf8", e = n.from(e, t));
                    for(var r = this._block, i = this._blockSize, s = e.length, o = this._len, a = 0; a < s;){
                        for(var l = o % i, c = Math.min(s - a, i - l), u = 0; u < c; u++)r[l + u] = e[a + u];
                        a += c, (o += c) % i == 0 && this._update(r);
                    }
                    return this._len += s, this;
                }, i.prototype.digest = function(e) {
                    var t = this._len % this._blockSize;
                    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
                    var r = 8 * this._len;
                    if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);
                    else {
                        var n = (4294967295 & r) >>> 0, i = (r - n) / 4294967296;
                        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
                    }
                    this._update(this._block);
                    var s = this._hash();
                    return e ? s.toString(e) : s;
                }, i.prototype._update = function() {
                    throw new Error("_update must be implemented by subclass");
                }, t.exports = i;
            },
            {
                "safe-buffer": 494
            }
        ],
        498: [
            function(e, t, r) {
                "use strict";
                var n = t.exports = function(e) {
                    e = e.toLowerCase();
                    var t = n[e];
                    if (!t) throw new Error(e + " is not supported (we accept pull requests)");
                    return new t;
                };
                n.sha = e("./sha"), n.sha1 = e("./sha1"), n.sha224 = e("./sha224"), n.sha256 = e("./sha256"), n.sha384 = e("./sha384"), n.sha512 = e("./sha512");
            },
            {
                "./sha": 499,
                "./sha1": 500,
                "./sha224": 501,
                "./sha256": 502,
                "./sha384": 503,
                "./sha512": 504
            }
        ],
        499: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 30 | e >>> 2;
                }
                function u(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, h = 0; h < 16; ++h)r[h] = e.readInt32BE(4 * h);
                    for(; h < 80; ++h)r[h] = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16];
                    for(var f = 0; f < 80; ++f){
                        var d = ~~(f / 20), p = 0 | ((t = n) << 5 | t >>> 27) + u(d, i, s, a) + l + r[f] + o[d];
                        l = a, a = s, s = c(i), i = n, n = p;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        500: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 5 | e >>> 27;
                }
                function u(e) {
                    return e << 30 | e >>> 2;
                }
                function h(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, f = 0; f < 16; ++f)r[f] = e.readInt32BE(4 * f);
                    for(; f < 80; ++f)r[f] = (t = r[f - 3] ^ r[f - 8] ^ r[f - 14] ^ r[f - 16]) << 1 | t >>> 31;
                    for(var d = 0; d < 80; ++d){
                        var p = ~~(d / 20), m = c(n) + h(p, i, s, a) + l + r[d] + o[p] | 0;
                        l = a, a = s, s = u(i), i = n, n = m;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        501: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha256"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(64);
                function l() {
                    this.init(), this._w = a, s.call(this, 64, 56);
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(28);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha256": 502,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        502: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ], a = new Array(64);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e) {
                    return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
                }
                function f(e) {
                    return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                }
                function d(e) {
                    return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, p = 0 | this._f, m = 0 | this._g, b = 0 | this._h, g = 0; g < 16; ++g)r[g] = e.readInt32BE(4 * g);
                    for(; g < 64; ++g)r[g] = 0 | (((t = r[g - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + r[g - 7] + d(r[g - 15]) + r[g - 16];
                    for(var y = 0; y < 64; ++y){
                        var v = b + f(l) + c(l, p, m) + o[y] + r[y] | 0, w = h(n) + u(n, i, s) | 0;
                        b = m, m = p, p = l, l = a + v | 0, a = s, s = i, i = n, n = v + w | 0;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0, this._f = p + this._f | 0, this._g = m + this._g | 0, this._h = b + this._h | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(32);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        503: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha512"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(160);
                function l() {
                    this.init(), this._w = a, s.call(this, 128, 112);
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(48);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha512": 504,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        504: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ], a = new Array(160);
                function l() {
                    this.init(), this._w = a, i.call(this, 128, 112);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e, t) {
                    return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
                }
                function f(e, t) {
                    return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
                }
                function d(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
                }
                function p(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
                }
                function m(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
                }
                function b(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
                }
                function g(e, t) {
                    return e >>> 0 < t >>> 0 ? 1 : 0;
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
                }, l.prototype._update = function(e) {
                    for(var t = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, s = 0 | this._dh, a = 0 | this._eh, l = 0 | this._fh, y = 0 | this._gh, v = 0 | this._hh, w = 0 | this._al, _ = 0 | this._bl, x = 0 | this._cl, k = 0 | this._dl, S = 0 | this._el, M = 0 | this._fl, C = 0 | this._gl, T = 0 | this._hl, E = 0; E < 32; E += 2)t[E] = e.readInt32BE(4 * E), t[E + 1] = e.readInt32BE(4 * E + 4);
                    for(; E < 160; E += 2){
                        var A = t[E - 30], R = t[E - 30 + 1], O = d(A, R), j = p(R, A), I = m(A = t[E - 4], R = t[E - 4 + 1]), N = b(R, A), P = t[E - 14], B = t[E - 14 + 1], D = t[E - 32], F = t[E - 32 + 1], L = j + B | 0, z = O + P + g(L, j) | 0;
                        z = (z = z + I + g(L = L + N | 0, N) | 0) + D + g(L = L + F | 0, F) | 0, t[E] = z, t[E + 1] = L;
                    }
                    for(var U = 0; U < 160; U += 2){
                        z = t[U], L = t[U + 1];
                        var $ = u(r, n, i), H = u(w, _, x), V = h(r, w), q = h(w, r), W = f(a, S), X = f(S, a), K = o[U], Y = o[U + 1], Z = c(a, l, y), G = c(S, M, C), J = T + X | 0, Q = v + W + g(J, T) | 0;
                        Q = (Q = (Q = Q + Z + g(J = J + G | 0, G) | 0) + K + g(J = J + Y | 0, Y) | 0) + z + g(J = J + L | 0, L) | 0;
                        var ee = q + H | 0, te = V + $ + g(ee, q) | 0;
                        v = y, T = C, y = l, C = M, l = a, M = S, a = s + Q + g(S = k + J | 0, k) | 0, s = i, k = x, i = n, x = _, n = r, _ = w, r = Q + te + g(w = J + ee | 0, J) | 0;
                    }
                    this._al = this._al + w | 0, this._bl = this._bl + _ | 0, this._cl = this._cl + x | 0, this._dl = this._dl + k | 0, this._el = this._el + S | 0, this._fl = this._fl + M | 0, this._gl = this._gl + C | 0, this._hl = this._hl + T | 0, this._ah = this._ah + r + g(this._al, w) | 0, this._bh = this._bh + n + g(this._bl, _) | 0, this._ch = this._ch + i + g(this._cl, x) | 0, this._dh = this._dh + s + g(this._dl, k) | 0, this._eh = this._eh + a + g(this._el, S) | 0, this._fh = this._fh + l + g(this._fl, M) | 0, this._gh = this._gh + y + g(this._gl, C) | 0, this._hh = this._hh + v + g(this._hl, T) | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(64);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        505: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("events").EventEmitter;
                function i() {
                    n.call(this);
                }
                e("inherits")(i, n), i.Readable = e("readable-stream/readable.js"), i.Writable = e("readable-stream/writable.js"), i.Duplex = e("readable-stream/duplex.js"), i.Transform = e("readable-stream/transform.js"), i.PassThrough = e("readable-stream/passthrough.js"), i.Stream = i, i.prototype.pipe = function(e, t) {
                    var r = this;
                    function i(t) {
                        e.writable && !1 === e.write(t) && r.pause && r.pause();
                    }
                    function s() {
                        r.readable && r.resume && r.resume();
                    }
                    r.on("data", i), e.on("drain", s), e._isStdio || t && !1 === t.end || (r.on("end", a), r.on("close", l));
                    var o = !1;
                    function a() {
                        o || (o = !0, e.end());
                    }
                    function l() {
                        o || (o = !0, "function" == typeof e.destroy && e.destroy());
                    }
                    function c(e) {
                        if (u(), 0 === n.listenerCount(this, "error")) throw e;
                    }
                    function u() {
                        r.removeListener("data", i), e.removeListener("drain", s), r.removeListener("end", a), r.removeListener("close", l), r.removeListener("error", c), e.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), e.removeListener("close", u);
                    }
                    return r.on("error", c), e.on("error", c), r.on("end", u), r.on("close", u), e.on("close", u), e.emit("pipe", r), e;
                };
            },
            {
                events: 422,
                inherits: 440,
                "readable-stream/duplex.js": 507,
                "readable-stream/passthrough.js": 516,
                "readable-stream/readable.js": 517,
                "readable-stream/transform.js": 518,
                "readable-stream/writable.js": 519
            }
        ],
        506: [
            function(e, t, r) {
                "use strict";
                var n = {}.toString;
                t.exports = Array.isArray || function(e) {
                    return "[object Array]" == n.call(e);
                };
            },
            {}
        ],
        507: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_duplex.js");
            },
            {
                "./lib/_stream_duplex.js": 508
            }
        ],
        508: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args"), i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)t.push(r);
                    return t;
                };
                t.exports = h;
                var s = Object.create(e("core-util-is"));
                s.inherits = e("inherits");
                var o = e("./_stream_readable"), a = e("./_stream_writable");
                s.inherits(h, o);
                for(var l = i(a.prototype), c = 0; c < l.length; c++){
                    var u = l[c];
                    h.prototype[u] || (h.prototype[u] = a.prototype[u]);
                }
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    o.call(this, e), a.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", f);
                }
                function f() {
                    this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this);
                }
                function d(e) {
                    e.end();
                }
                Object.defineProperty(h.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), Object.defineProperty(h.prototype, "destroyed", {
                    get: function() {
                        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function(e) {
                        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                    }
                }), h.prototype._destroy = function(e, t) {
                    this.push(null), this.end(), n.nextTick(t, e);
                };
            },
            {
                "./_stream_readable": 510,
                "./_stream_writable": 512,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466
            }
        ],
        509: [
            function(e, t, r) {
                "use strict";
                t.exports = s;
                var n = e("./_stream_transform"), i = Object.create(e("core-util-is"));
                function s(e) {
                    if (!(this instanceof s)) return new s(e);
                    n.call(this, e);
                }
                i.inherits = e("inherits"), i.inherits(s, n), s.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 511,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        510: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("process-nextick-args");
                        t.exports = v;
                        var s, o = e("isarray");
                        v.ReadableState = y;
                        e("events").EventEmitter;
                        var a = function(e, t) {
                            return e.listeners(t).length;
                        }, l = e("./internal/streams/stream"), c = e("safe-buffer").Buffer, u = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var h = Object.create(e("core-util-is"));
                        h.inherits = e("inherits");
                        var f = e("util"), d = void 0;
                        d = f && f.debuglog ? f.debuglog("stream") : function() {};
                        var p, m = e("./internal/streams/BufferList"), b = e("./internal/streams/destroy");
                        h.inherits(v, l);
                        var g = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function y(t, r) {
                            t = t || {};
                            var n = r instanceof (s = s || e("./_stream_duplex"));
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
                            var i = t.highWaterMark, o = t.readableHighWaterMark, a = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (o || 0 === o) ? o : a, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new m, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = e("string_decoder/").StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
                        }
                        function v(t) {
                            if (s = s || e("./_stream_duplex"), !(this instanceof v)) return new v(t);
                            this._readableState = new y(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), l.call(this);
                        }
                        function w(e, t, r, n, i) {
                            var s, o = e._readableState;
                            null === t ? (o.reading = !1, function(e, t) {
                                if (t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, k(e);
                            }(e, o)) : (i || (s = function(e, t) {
                                var r;
                                n = t, c.isBuffer(n) || n instanceof u || "string" == typeof t || void 0 === t || e.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
                                var n;
                                return r;
                            }(o, t)), s ? e.emit("error", s) : o.objectMode || t && t.length > 0 ? ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === c.prototype || (t = function(e) {
                                return c.from(e);
                            }(t)), n ? o.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : _(e, o, t, !0) : o.ended ? e.emit("error", new Error("stream.push() after EOF")) : (o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? _(e, o, t, !1) : M(e, o)) : _(e, o, t, !1))) : n || (o.reading = !1));
                            return function(e) {
                                return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
                            }(o);
                        }
                        function _(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (e.emit("data", r), e.read(0)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && k(e)), M(e, t);
                        }
                        Object.defineProperty(v.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), v.prototype.destroy = b.destroy, v.prototype._undestroy = b.undestroy, v.prototype._destroy = function(e, t) {
                            this.push(null), t(e);
                        }, v.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = c.from(e, t), t = ""), r = !0), w(this, e, t, !1, r);
                        }, v.prototype.unshift = function(e) {
                            return w(this, e, null, !0, !1);
                        }, v.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, v.prototype.setEncoding = function(t) {
                            return p || (p = e("string_decoder/").StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
                        };
                        function x(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 8388608 ? e = 8388608 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function k(e) {
                            var t = e._readableState;
                            t.needReadable = !1, t.emittedReadable || (d("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? i.nextTick(S, e) : S(e));
                        }
                        function S(e) {
                            d("emit readable"), e.emit("readable"), A(e);
                        }
                        function M(e, t) {
                            t.readingMore || (t.readingMore = !0, i.nextTick(C, e, t));
                        }
                        function C(e, t) {
                            for(var r = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (d("maybeReadMore read 0"), e.read(0), r !== t.length);)r = t.length;
                            t.readingMore = !1;
                        }
                        function T(e) {
                            d("readable nexttick read 0"), e.read(0);
                        }
                        function E(e, t) {
                            t.reading || (d("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), A(e), t.flowing && !t.reading && e.read(0);
                        }
                        function A(e) {
                            var t = e._readableState;
                            for(d("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function R(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : r = function(e, t, r) {
                                var n;
                                e < t.head.data.length ? (n = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : n = e === t.head.data.length ? t.shift() : r ? function(e, t) {
                                    var r = t.head, n = 1, i = r.data;
                                    e -= i.length;
                                    for(; r = r.next;){
                                        var s = r.data, o = e > s.length ? s.length : e;
                                        if (o === s.length ? i += s : i += s.slice(0, e), 0 === (e -= o)) {
                                            o === s.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = s.slice(o));
                                            break;
                                        }
                                        ++n;
                                    }
                                    return t.length -= n, i;
                                }(e, t) : function(e, t) {
                                    var r = c.allocUnsafe(e), n = t.head, i = 1;
                                    n.data.copy(r), e -= n.data.length;
                                    for(; n = n.next;){
                                        var s = n.data, o = e > s.length ? s.length : e;
                                        if (s.copy(r, r.length - e, 0, o), 0 === (e -= o)) {
                                            o === s.length ? (++i, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = s.slice(o));
                                            break;
                                        }
                                        ++i;
                                    }
                                    return t.length -= i, r;
                                }(e, t);
                                return n;
                            }(e, t.buffer, t.decoder), r);
                        }
                        function O(e) {
                            var t = e._readableState;
                            if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
                            t.endEmitted || (t.ended = !0, i.nextTick(j, t, e));
                        }
                        function j(e, t) {
                            e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
                        }
                        function I(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        v.prototype.read = function(e) {
                            d("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return d("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? O(this) : k(this), null;
                            if (0 === (e = x(e, t)) && t.ended) return 0 === t.length && O(this), null;
                            var n, i = t.needReadable;
                            return d("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && d("length less than watermark", i = !0), t.ended || t.reading ? d("reading or ended", i = !1) : i && (d("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = x(r, t))), null === (n = e > 0 ? R(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && O(this)), null !== n && this.emit("data", n), n;
                        }, v.prototype._read = function(e) {
                            this.emit("error", new Error("_read() is not implemented"));
                        }, v.prototype.pipe = function(e, t) {
                            var n = this, s = this._readableState;
                            switch(s.pipesCount){
                                case 0:
                                    s.pipes = e;
                                    break;
                                case 1:
                                    s.pipes = [
                                        s.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    s.pipes.push(e);
                            }
                            s.pipesCount += 1, d("pipe count=%d opts=%j", s.pipesCount, t);
                            var l = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? u : v;
                            function c(t, r) {
                                d("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, d("cleanup"), e.removeListener("close", g), e.removeListener("finish", y), e.removeListener("drain", h), e.removeListener("error", b), e.removeListener("unpipe", c), n.removeListener("end", u), n.removeListener("end", v), n.removeListener("data", m), f = !0, !s.awaitDrain || e._writableState && !e._writableState.needDrain || h());
                            }
                            function u() {
                                d("onend"), e.end();
                            }
                            s.endEmitted ? i.nextTick(l) : n.once("end", l), e.on("unpipe", c);
                            var h = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    d("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && a(e, "data") && (t.flowing = !0, A(e));
                                };
                            }(n);
                            e.on("drain", h);
                            var f = !1;
                            var p = !1;
                            function m(t) {
                                d("ondata"), p = !1, !1 !== e.write(t) || p || ((1 === s.pipesCount && s.pipes === e || s.pipesCount > 1 && -1 !== I(s.pipes, e)) && !f && (d("false write response, pause", s.awaitDrain), s.awaitDrain++, p = !0), n.pause());
                            }
                            function b(t) {
                                d("onerror", t), v(), e.removeListener("error", b), 0 === a(e, "error") && e.emit("error", t);
                            }
                            function g() {
                                e.removeListener("finish", y), v();
                            }
                            function y() {
                                d("onfinish"), e.removeListener("close", g), v();
                            }
                            function v() {
                                d("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", m), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? o(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", b), e.once("close", g), e.once("finish", y), e.emit("pipe", n), s.flowing || (d("pipe resume"), n.resume()), e;
                        }, v.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = I(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, v.prototype.on = function(e, t) {
                            var r = l.prototype.on.call(this, e, t);
                            if ("data" === e) !1 !== this._readableState.flowing && this.resume();
                            else if ("readable" === e) {
                                var n = this._readableState;
                                n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && k(this) : i.nextTick(T, this));
                            }
                            return r;
                        }, v.prototype.addListener = v.prototype.on, v.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (d("resume"), e.flowing = !0, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(E, e, t));
                            }(this, e)), this;
                        }, v.prototype.pause = function() {
                            return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
                        }, v.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (d("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < g.length; s++)e.on(g[s], this.emit.bind(this, g[s]));
                            return this._read = function(t) {
                                d("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, Object.defineProperty(v.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), v._fromList = R;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/BufferList": 513,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                events: 422,
                inherits: 440,
                isarray: 506,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                "string_decoder/": 521,
                util: 188
            }
        ],
        511: [
            function(e, t, r) {
                "use strict";
                t.exports = o;
                var n = e("./_stream_duplex"), i = Object.create(e("core-util-is"));
                function s(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (!n) return this.emit("error", new Error("write callback called multiple times"));
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    n.call(this, e), this._transformState = {
                        afterTransform: s.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", a);
                }
                function a() {
                    var e = this;
                    "function" == typeof this._flush ? this._flush(function(t, r) {
                        l(e, t, r);
                    }) : l(this, null, null);
                }
                function l(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
                    if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
                    return e.push(null);
                }
                i.inherits = e("inherits"), i.inherits(o, n), o.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, n.prototype.push.call(this, e, t);
                }, o.prototype._transform = function(e, t, r) {
                    throw new Error("_transform() is not implemented");
                }, o.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, o.prototype._read = function(e) {
                    var t = this._transformState;
                    null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
                }, o.prototype._destroy = function(e, t) {
                    var r = this;
                    n.prototype._destroy.call(this, e, function(e) {
                        t(e), r.emit("close");
                    });
                };
            },
            {
                "./_stream_duplex": 508,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        512: [
            function(e, t, r) {
                (function(r, n, i) {
                    (function() {
                        "use strict";
                        var s = e("process-nextick-args");
                        function o(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        t.exports = y;
                        var a, l = !r.browser && [
                            "v0.10",
                            "v0.9."
                        ].indexOf(r.version.slice(0, 5)) > -1 ? i : s.nextTick;
                        y.WritableState = g;
                        var c = Object.create(e("core-util-is"));
                        c.inherits = e("inherits");
                        var u = {
                            deprecate: e("util-deprecate")
                        }, h = e("./internal/streams/stream"), f = e("safe-buffer").Buffer, d = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var p, m = e("./internal/streams/destroy");
                        function b() {}
                        function g(t, r) {
                            a = a || e("./_stream_duplex"), t = t || {};
                            var n = r instanceof a;
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
                            var i = t.highWaterMark, c = t.writableHighWaterMark, u = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : u, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var h = !1 === t.decodeStrings;
                            this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var r = e._writableState, n = r.sync, i = r.writecb;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(r), t) !function(e, t, r, n, i) {
                                        --t.pendingcb, r ? (s.nextTick(i, n), s.nextTick(S, e, t), e._writableState.errorEmitted = !0, e.emit("error", n)) : (i(n), e._writableState.errorEmitted = !0, e.emit("error", n), S(e, t));
                                    }(e, r, n, t, i);
                                    else {
                                        var o = x(r);
                                        o || r.corked || r.bufferProcessing || !r.bufferedRequest || _(e, r), n ? l(w, e, r, o, i) : w(e, r, o, i);
                                    }
                                }(r, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
                        }
                        function y(t) {
                            if (a = a || e("./_stream_duplex"), !(p.call(y, this) || this instanceof a)) return new y(t);
                            this._writableState = new g(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), h.call(this);
                        }
                        function v(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function w(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), S(e, t);
                        }
                        function _(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, i = new Array(n), s = t.corkedRequestsFree;
                                s.entry = r;
                                for(var a = 0, l = !0; r;)i[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                i.allBuffers = l, v(e, t, !0, t.length, i, "", s.finish), t.pendingcb++, t.lastBufferedRequest = null, s.next ? (t.corkedRequestsFree = s.next, s.next = null) : t.corkedRequestsFree = new o(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (v(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function x(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function k(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && e.emit("error", r), t.prefinished = !0, e.emit("prefinish"), S(e, t);
                            });
                        }
                        function S(e, t) {
                            var r = x(t);
                            return r && (!function(e, t) {
                                t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, s.nextTick(k, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), r;
                        }
                        c.inherits(y, h), g.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(g.prototype, "buffer", {
                                    get: u.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(y, Symbol.hasInstance, {
                            value: function(e) {
                                return !!p.call(this, e) || this === y && e && e._writableState instanceof g;
                            }
                        })) : p = function(e) {
                            return e instanceof this;
                        }, y.prototype.pipe = function() {
                            this.emit("error", new Error("Cannot pipe, not readable"));
                        }, y.prototype.write = function(e, t, r) {
                            var n, i = this._writableState, o = !1, a = !i.objectMode && (n = e, f.isBuffer(n) || n instanceof d);
                            return a && !f.isBuffer(e) && (e = function(e) {
                                return f.from(e);
                            }(e)), "function" == typeof t && (r = t, t = null), a ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof r && (r = b), i.ended ? function(e, t) {
                                var r = new Error("write after end");
                                e.emit("error", r), s.nextTick(t, r);
                            }(this, r) : (a || function(e, t, r, n) {
                                var i = !0, o = !1;
                                return null === r ? o = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || t.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (e.emit("error", o), s.nextTick(n, o), i = !1), i;
                            }(this, i, e, r)) && (i.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = f.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var l = t.length < t.highWaterMark;
                                l || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var c = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, c ? c.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else v(e, t, !1, a, n, i, s);
                                return l;
                            }(this, i, a, e, t, r)), o;
                        }, y.prototype.cork = function() {
                            this._writableState.corked++;
                        }, y.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || _(this, e));
                        }, y.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(y.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), y.prototype._write = function(e, t, r) {
                            r(new Error("_write() is not implemented"));
                        }, y.prototype._writev = null, y.prototype.end = function(e, t, r) {
                            var n = this._writableState;
                            "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || function(e, t, r) {
                                t.ending = !0, S(e, t), r && (t.finished ? s.nextTick(r) : e.once("finish", r));
                                t.ended = !0, e.writable = !1;
                            }(this, n, r);
                        }, Object.defineProperty(y.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), y.prototype.destroy = m.destroy, y.prototype._undestroy = m.undestroy, y.prototype._destroy = function(e, t) {
                            this.end(), t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                timers: 523,
                "util-deprecate": 524
            }
        ],
        513: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("util");
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    return e.prototype.push = function(e) {
                        var t = {
                            data: e,
                            next: null
                        };
                        this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                    }, e.prototype.unshift = function(e) {
                        var t = {
                            data: e,
                            next: this.head
                        };
                        0 === this.length && (this.tail = t), this.head = t, ++this.length;
                    }, e.prototype.shift = function() {
                        if (0 !== this.length) {
                            var e = this.head.data;
                            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                        }
                    }, e.prototype.clear = function() {
                        this.head = this.tail = null, this.length = 0;
                    }, e.prototype.join = function(e) {
                        if (0 === this.length) return "";
                        for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                        return r;
                    }, e.prototype.concat = function(e) {
                        if (0 === this.length) return n.alloc(0);
                        for(var t, r, i, s = n.allocUnsafe(e >>> 0), o = this.head, a = 0; o;)t = o.data, r = s, i = a, t.copy(r, i), a += o.data.length, o = o.next;
                        return s;
                    }, e;
                }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function() {
                    var e = i.inspect({
                        length: this.length
                    });
                    return this.constructor.name + " " + e;
                });
            },
            {
                "safe-buffer": 520,
                util: 188
            }
        ],
        514: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args");
                function i(e, t) {
                    e.emit("error", t);
                }
                t.exports = {
                    destroy: function(e, t) {
                        var r = this, s = this._readableState && this._readableState.destroyed, o = this._writableState && this._writableState.destroyed;
                        return s || o ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, n.nextTick(i, this, e)) : n.nextTick(i, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(e) {
                            !t && e ? r._writableState ? r._writableState.errorEmitted || (r._writableState.errorEmitted = !0, n.nextTick(i, r, e)) : n.nextTick(i, r, e) : t && t(e);
                        }), this);
                    },
                    undestroy: function() {
                        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                    }
                };
            },
            {
                "process-nextick-args": 466
            }
        ],
        515: [
            function(e, t, r) {
                arguments[4][490][0].apply(r, arguments);
            },
            {
                dup: 490,
                events: 422
            }
        ],
        516: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").PassThrough;
            },
            {
                "./readable": 517
            }
        ],
        517: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js");
            },
            {
                "./lib/_stream_duplex.js": 508,
                "./lib/_stream_passthrough.js": 509,
                "./lib/_stream_readable.js": 510,
                "./lib/_stream_transform.js": 511,
                "./lib/_stream_writable.js": 512
            }
        ],
        518: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").Transform;
            },
            {
                "./readable": 517
            }
        ],
        519: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_writable.js");
            },
            {
                "./lib/_stream_writable.js": 512
            }
        ],
        520: [
            function(e, t, r) {
                arguments[4][217][0].apply(r, arguments);
            },
            {
                buffer: 220,
                dup: 217
            }
        ],
        521: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 520
            }
        ],
        522: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 494
            }
        ],
        523: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = e("process/browser.js").nextTick, s = Function.prototype.apply, o = Array.prototype.slice, a = {}, l = 0;
                        function c(e, t) {
                            this._id = e, this._clearFn = t;
                        }
                        r.setTimeout = function() {
                            return new c(s.call(setTimeout, window, arguments), clearTimeout);
                        }, r.setInterval = function() {
                            return new c(s.call(setInterval, window, arguments), clearInterval);
                        }, r.clearTimeout = r.clearInterval = function(e) {
                            e.close();
                        }, c.prototype.unref = c.prototype.ref = function() {}, c.prototype.close = function() {
                            this._clearFn.call(window, this._id);
                        }, r.enroll = function(e, t) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
                        }, r.unenroll = function(e) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
                        }, r._unrefActive = r.active = function(e) {
                            clearTimeout(e._idleTimeoutId);
                            var t = e._idleTimeout;
                            t >= 0 && (e._idleTimeoutId = setTimeout(function() {
                                e._onTimeout && e._onTimeout();
                            }, t));
                        }, r.setImmediate = "function" == typeof t ? t : function(e) {
                            var t = l++, n = !(arguments.length < 2) && o.call(arguments, 1);
                            return a[t] = !0, i(function() {
                                a[t] && (n ? e.apply(null, n) : e.call(null), r.clearImmediate(t));
                            }), t;
                        }, r.clearImmediate = "function" == typeof n ? n : function(e) {
                            delete a[e];
                        };
                    }).call(this);
                }).call(this, e("timers").setImmediate, e("timers").clearImmediate);
            },
            {
                "process/browser.js": 467,
                timers: 523
            }
        ],
        524: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(t) {
                            try {
                                if (!e.localStorage) return !1;
                            } catch (e) {
                                return !1;
                            }
                            var r = e.localStorage[t];
                            return null != r && "true" === String(r).toLowerCase();
                        }
                        t.exports = function(e, t) {
                            if (r("noDeprecation")) return e;
                            var n = !1;
                            return function() {
                                if (!n) {
                                    if (r("throwDeprecation")) throw new Error(t);
                                    r("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        525: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    });
                } : t.exports = function(e, t) {
                    e.super_ = t;
                    var r = function() {};
                    r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                };
            },
            {}
        ],
        526: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            {}
        ],
        527: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = /%[sdj%]/g;
                        r.format = function(e) {
                            if (!g(e)) {
                                for(var t = [], r = 0; r < arguments.length; r++)t.push(a(arguments[r]));
                                return t.join(" ");
                            }
                            r = 1;
                            for(var n = arguments, s = n.length, o = String(e).replace(i, function(e) {
                                if ("%%" === e) return "%";
                                if (r >= s) return e;
                                switch(e){
                                    case "%s":
                                        return String(n[r++]);
                                    case "%d":
                                        return Number(n[r++]);
                                    case "%j":
                                        try {
                                            return JSON.stringify(n[r++]);
                                        } catch (e) {
                                            return "[Circular]";
                                        }
                                    default:
                                        return e;
                                }
                            }), l = n[r]; r < s; l = n[++r])m(l) || !w(l) ? o += " " + l : o += " " + a(l);
                            return o;
                        }, r.deprecate = function(e, i) {
                            if (y(n.process)) return function() {
                                return r.deprecate(e, i).apply(this, arguments);
                            };
                            if (!0 === t.noDeprecation) return e;
                            var s = !1;
                            return function() {
                                if (!s) {
                                    if (t.throwDeprecation) throw new Error(i);
                                    t.traceDeprecation ? console.trace(i) : console.error(i), s = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                        var s, o = {};
                        function a(e, t) {
                            var n = {
                                seen: [],
                                stylize: c
                            };
                            return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), p(t) ? n.showHidden = t : t && r._extend(n, t), y(n.showHidden) && (n.showHidden = !1), y(n.depth) && (n.depth = 2), y(n.colors) && (n.colors = !1), y(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), u(n, e, n.depth);
                        }
                        function l(e, t) {
                            var r = a.styles[t];
                            return r ? "\x1b[" + a.colors[r][0] + "m" + e + "\x1b[" + a.colors[r][1] + "m" : e;
                        }
                        function c(e, t) {
                            return e;
                        }
                        function u(e, t, n) {
                            if (e.customInspect && t && k(t.inspect) && t.inspect !== r.inspect && (!t.constructor || t.constructor.prototype !== t)) {
                                var i = t.inspect(n, e);
                                return g(i) || (i = u(e, i, n)), i;
                            }
                            var s = function(e, t) {
                                if (y(t)) return e.stylize("undefined", "undefined");
                                if (g(t)) {
                                    var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                                    return e.stylize(r, "string");
                                }
                                if (b(t)) return e.stylize("" + t, "number");
                                if (p(t)) return e.stylize("" + t, "boolean");
                                if (m(t)) return e.stylize("null", "null");
                            }(e, t);
                            if (s) return s;
                            var o = Object.keys(t), a = function(e) {
                                var t = {};
                                return e.forEach(function(e, r) {
                                    t[e] = !0;
                                }), t;
                            }(o);
                            if (e.showHidden && (o = Object.getOwnPropertyNames(t)), x(t) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return h(t);
                            if (0 === o.length) {
                                if (k(t)) {
                                    var l = t.name ? ": " + t.name : "";
                                    return e.stylize("[Function" + l + "]", "special");
                                }
                                if (v(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                                if (_(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                                if (x(t)) return h(t);
                            }
                            var c, w = "", S = !1, M = [
                                "{",
                                "}"
                            ];
                            (d(t) && (S = !0, M = [
                                "[",
                                "]"
                            ]), k(t)) && (w = " [Function" + (t.name ? ": " + t.name : "") + "]");
                            return v(t) && (w = " " + RegExp.prototype.toString.call(t)), _(t) && (w = " " + Date.prototype.toUTCString.call(t)), x(t) && (w = " " + h(t)), 0 !== o.length || S && 0 != t.length ? n < 0 ? v(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), c = S ? function(e, t, r, n, i) {
                                for(var s = [], o = 0, a = t.length; o < a; ++o)E(t, String(o)) ? s.push(f(e, t, r, n, String(o), !0)) : s.push("");
                                return i.forEach(function(i) {
                                    i.match(/^\d+$/) || s.push(f(e, t, r, n, i, !0));
                                }), s;
                            }(e, t, n, a, o) : o.map(function(r) {
                                return f(e, t, n, a, r, S);
                            }), e.seen.pop(), function(e, t, r) {
                                if (e.reduce(function(e, t) {
                                    return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                                }, 0) > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
                                return r[0] + t + " " + e.join(", ") + " " + r[1];
                            }(c, w, M)) : M[0] + w + M[1];
                        }
                        function h(e) {
                            return "[" + Error.prototype.toString.call(e) + "]";
                        }
                        function f(e, t, r, n, i, s) {
                            var o, a, l;
                            if ((l = Object.getOwnPropertyDescriptor(t, i) || {
                                value: t[i]
                            }).get ? a = l.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : l.set && (a = e.stylize("[Setter]", "special")), E(n, i) || (o = "[" + i + "]"), a || (e.seen.indexOf(l.value) < 0 ? (a = m(r) ? u(e, l.value, null) : u(e, l.value, r - 1)).indexOf("\n") > -1 && (a = s ? a.split("\n").map(function(e) {
                                return "  " + e;
                            }).join("\n").substr(2) : "\n" + a.split("\n").map(function(e) {
                                return "   " + e;
                            }).join("\n")) : a = e.stylize("[Circular]", "special")), y(o)) {
                                if (s && i.match(/^\d+$/)) return a;
                                (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
                            }
                            return o + ": " + a;
                        }
                        function d(e) {
                            return Array.isArray(e);
                        }
                        function p(e) {
                            return "boolean" == typeof e;
                        }
                        function m(e) {
                            return null === e;
                        }
                        function b(e) {
                            return "number" == typeof e;
                        }
                        function g(e) {
                            return "string" == typeof e;
                        }
                        function y(e) {
                            return void 0 === e;
                        }
                        function v(e) {
                            return w(e) && "[object RegExp]" === S(e);
                        }
                        function w(e) {
                            return "object" == typeof e && null !== e;
                        }
                        function _(e) {
                            return w(e) && "[object Date]" === S(e);
                        }
                        function x(e) {
                            return w(e) && ("[object Error]" === S(e) || e instanceof Error);
                        }
                        function k(e) {
                            return "function" == typeof e;
                        }
                        function S(e) {
                            return Object.prototype.toString.call(e);
                        }
                        function M(e) {
                            return e < 10 ? "0" + e.toString(10) : e.toString(10);
                        }
                        r.debuglog = function(e) {
                            if (y(s) && (s = t.env.NODE_DEBUG || ""), e = e.toUpperCase(), !o[e]) {
                                if (new RegExp("\\b" + e + "\\b", "i").test(s)) {
                                    var n = t.pid;
                                    o[e] = function() {
                                        var t = r.format.apply(r, arguments);
                                        console.error("%s %d: %s", e, n, t);
                                    };
                                } else o[e] = function() {};
                            }
                            return o[e];
                        }, r.inspect = a, a.colors = {
                            bold: [
                                1,
                                22
                            ],
                            italic: [
                                3,
                                23
                            ],
                            underline: [
                                4,
                                24
                            ],
                            inverse: [
                                7,
                                27
                            ],
                            white: [
                                37,
                                39
                            ],
                            grey: [
                                90,
                                39
                            ],
                            black: [
                                30,
                                39
                            ],
                            blue: [
                                34,
                                39
                            ],
                            cyan: [
                                36,
                                39
                            ],
                            green: [
                                32,
                                39
                            ],
                            magenta: [
                                35,
                                39
                            ],
                            red: [
                                31,
                                39
                            ],
                            yellow: [
                                33,
                                39
                            ]
                        }, a.styles = {
                            special: "cyan",
                            number: "yellow",
                            boolean: "yellow",
                            undefined: "grey",
                            null: "bold",
                            string: "green",
                            date: "magenta",
                            regexp: "red"
                        }, r.isArray = d, r.isBoolean = p, r.isNull = m, r.isNullOrUndefined = function(e) {
                            return null == e;
                        }, r.isNumber = b, r.isString = g, r.isSymbol = function(e) {
                            return "symbol" == typeof e;
                        }, r.isUndefined = y, r.isRegExp = v, r.isObject = w, r.isDate = _, r.isError = x, r.isFunction = k, r.isPrimitive = function(e) {
                            return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                        }, r.isBuffer = e("./support/isBuffer");
                        var C = [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ];
                        function T() {
                            var e = new Date, t = [
                                M(e.getHours()),
                                M(e.getMinutes()),
                                M(e.getSeconds())
                            ].join(":");
                            return [
                                e.getDate(),
                                C[e.getMonth()],
                                t
                            ].join(" ");
                        }
                        function E(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }
                        r.log = function() {
                            console.log("%s - %s", T(), r.format.apply(r, arguments));
                        }, r.inherits = e("inherits"), r._extend = function(e, t) {
                            if (!t || !w(t)) return e;
                            for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                            return e;
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./support/isBuffer": 526,
                _process: 467,
                inherits: 525
            }
        ],
        528: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), Object.defineProperty(r, "v1", {
                    enumerable: !0,
                    get: function() {
                        return n.default;
                    }
                }), Object.defineProperty(r, "v3", {
                    enumerable: !0,
                    get: function() {
                        return i.default;
                    }
                }), Object.defineProperty(r, "v4", {
                    enumerable: !0,
                    get: function() {
                        return s.default;
                    }
                }), Object.defineProperty(r, "v5", {
                    enumerable: !0,
                    get: function() {
                        return o.default;
                    }
                }), Object.defineProperty(r, "NIL", {
                    enumerable: !0,
                    get: function() {
                        return a.default;
                    }
                }), Object.defineProperty(r, "version", {
                    enumerable: !0,
                    get: function() {
                        return l.default;
                    }
                }), Object.defineProperty(r, "validate", {
                    enumerable: !0,
                    get: function() {
                        return c.default;
                    }
                }), Object.defineProperty(r, "stringify", {
                    enumerable: !0,
                    get: function() {
                        return u.default;
                    }
                }), Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return h.default;
                    }
                });
                var n = f(e("./v1.js")), i = f(e("./v3.js")), s = f(e("./v4.js")), o = f(e("./v5.js")), a = f(e("./nil.js")), l = f(e("./version.js")), c = f(e("./validate.js")), u = f(e("./stringify.js")), h = f(e("./parse.js"));
                function f(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
            },
            {
                "./nil.js": 530,
                "./parse.js": 531,
                "./stringify.js": 535,
                "./v1.js": 536,
                "./v3.js": 537,
                "./v4.js": 539,
                "./v5.js": 540,
                "./validate.js": 541,
                "./version.js": 542
            }
        ],
        529: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return 14 + (e + 64 >>> 9 << 4) + 1;
                }
                function i(e, t) {
                    const r = (65535 & e) + (65535 & t);
                    return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
                }
                function s(e, t, r, n, s, o) {
                    var a, l;
                    return i((a = i(i(t, e), i(n, o))) << (l = s) | a >>> 32 - l, r);
                }
                function o(e, t, r, n, i, o, a) {
                    return s(t & r | ~t & n, e, t, i, o, a);
                }
                function a(e, t, r, n, i, o, a) {
                    return s(t & n | r & ~n, e, t, i, o, a);
                }
                function l(e, t, r, n, i, o, a) {
                    return s(t ^ r ^ n, e, t, i, o, a);
                }
                function c(e, t, r, n, i, o, a) {
                    return s(r ^ (t | ~n), e, t, i, o, a);
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var u = function(e) {
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = new Uint8Array(t.length);
                        for(let r = 0; r < t.length; ++r)e[r] = t.charCodeAt(r);
                    }
                    return function(e) {
                        const t = [], r = 32 * e.length;
                        for(let n = 0; n < r; n += 8){
                            const r = e[n >> 5] >>> n % 32 & 255, i = parseInt("0123456789abcdef".charAt(r >>> 4 & 15) + "0123456789abcdef".charAt(15 & r), 16);
                            t.push(i);
                        }
                        return t;
                    }(function(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[n(t) - 1] = t;
                        let r = 1732584193, s = -271733879, u = -1732584194, h = 271733878;
                        for(let t = 0; t < e.length; t += 16){
                            const n = r, f = s, d = u, p = h;
                            r = o(r, s, u, h, e[t], 7, -680876936), h = o(h, r, s, u, e[t + 1], 12, -389564586), u = o(u, h, r, s, e[t + 2], 17, 606105819), s = o(s, u, h, r, e[t + 3], 22, -1044525330), r = o(r, s, u, h, e[t + 4], 7, -176418897), h = o(h, r, s, u, e[t + 5], 12, 1200080426), u = o(u, h, r, s, e[t + 6], 17, -1473231341), s = o(s, u, h, r, e[t + 7], 22, -45705983), r = o(r, s, u, h, e[t + 8], 7, 1770035416), h = o(h, r, s, u, e[t + 9], 12, -1958414417), u = o(u, h, r, s, e[t + 10], 17, -42063), s = o(s, u, h, r, e[t + 11], 22, -1990404162), r = o(r, s, u, h, e[t + 12], 7, 1804603682), h = o(h, r, s, u, e[t + 13], 12, -40341101), u = o(u, h, r, s, e[t + 14], 17, -1502002290), s = o(s, u, h, r, e[t + 15], 22, 1236535329), r = a(r, s, u, h, e[t + 1], 5, -165796510), h = a(h, r, s, u, e[t + 6], 9, -1069501632), u = a(u, h, r, s, e[t + 11], 14, 643717713), s = a(s, u, h, r, e[t], 20, -373897302), r = a(r, s, u, h, e[t + 5], 5, -701558691), h = a(h, r, s, u, e[t + 10], 9, 38016083), u = a(u, h, r, s, e[t + 15], 14, -660478335), s = a(s, u, h, r, e[t + 4], 20, -405537848), r = a(r, s, u, h, e[t + 9], 5, 568446438), h = a(h, r, s, u, e[t + 14], 9, -1019803690), u = a(u, h, r, s, e[t + 3], 14, -187363961), s = a(s, u, h, r, e[t + 8], 20, 1163531501), r = a(r, s, u, h, e[t + 13], 5, -1444681467), h = a(h, r, s, u, e[t + 2], 9, -51403784), u = a(u, h, r, s, e[t + 7], 14, 1735328473), s = a(s, u, h, r, e[t + 12], 20, -1926607734), r = l(r, s, u, h, e[t + 5], 4, -378558), h = l(h, r, s, u, e[t + 8], 11, -2022574463), u = l(u, h, r, s, e[t + 11], 16, 1839030562), s = l(s, u, h, r, e[t + 14], 23, -35309556), r = l(r, s, u, h, e[t + 1], 4, -1530992060), h = l(h, r, s, u, e[t + 4], 11, 1272893353), u = l(u, h, r, s, e[t + 7], 16, -155497632), s = l(s, u, h, r, e[t + 10], 23, -1094730640), r = l(r, s, u, h, e[t + 13], 4, 681279174), h = l(h, r, s, u, e[t], 11, -358537222), u = l(u, h, r, s, e[t + 3], 16, -722521979), s = l(s, u, h, r, e[t + 6], 23, 76029189), r = l(r, s, u, h, e[t + 9], 4, -640364487), h = l(h, r, s, u, e[t + 12], 11, -421815835), u = l(u, h, r, s, e[t + 15], 16, 530742520), s = l(s, u, h, r, e[t + 2], 23, -995338651), r = c(r, s, u, h, e[t], 6, -198630844), h = c(h, r, s, u, e[t + 7], 10, 1126891415), u = c(u, h, r, s, e[t + 14], 15, -1416354905), s = c(s, u, h, r, e[t + 5], 21, -57434055), r = c(r, s, u, h, e[t + 12], 6, 1700485571), h = c(h, r, s, u, e[t + 3], 10, -1894986606), u = c(u, h, r, s, e[t + 10], 15, -1051523), s = c(s, u, h, r, e[t + 1], 21, -2054922799), r = c(r, s, u, h, e[t + 8], 6, 1873313359), h = c(h, r, s, u, e[t + 15], 10, -30611744), u = c(u, h, r, s, e[t + 6], 15, -1560198380), s = c(s, u, h, r, e[t + 13], 21, 1309151649), r = c(r, s, u, h, e[t + 4], 6, -145523070), h = c(h, r, s, u, e[t + 11], 10, -1120210379), u = c(u, h, r, s, e[t + 2], 15, 718787259), s = c(s, u, h, r, e[t + 9], 21, -343485551), r = i(r, n), s = i(s, f), u = i(u, d), h = i(h, p);
                        }
                        return [
                            r,
                            s,
                            u,
                            h
                        ];
                    }(function(e) {
                        if (0 === e.length) return [];
                        const t = 8 * e.length, r = new Uint32Array(n(t));
                        for(let n = 0; n < t; n += 8)r[n >> 5] |= (255 & e[n / 8]) << n % 32;
                        return r;
                    }(e), 8 * e.length));
                };
                r.default = u;
            },
            {}
        ],
        530: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = "00000000-0000-0000-0000-000000000000";
            },
            {}
        ],
        531: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    let t;
                    const r = new Uint8Array(16);
                    return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        532: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
            },
            {}
        ],
        533: [
            function(e, t, r) {
                "use strict";
                let n;
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function() {
                    if (!n && (n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto), !n)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    return n(i);
                };
                const i = new Uint8Array(16);
            },
            {}
        ],
        534: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r, n) {
                    switch(e){
                        case 0:
                            return t & r ^ ~t & n;
                        case 1:
                            return t ^ r ^ n;
                        case 2:
                            return t & r ^ t & n ^ r & n;
                        case 3:
                            return t ^ r ^ n;
                    }
                }
                function i(e, t) {
                    return e << t | e >>> 32 - t;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = function(e) {
                    const t = [
                        1518500249,
                        1859775393,
                        2400959708,
                        3395469782
                    ], r = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ];
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = [];
                        for(let r = 0; r < t.length; ++r)e.push(t.charCodeAt(r));
                    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
                    e.push(128);
                    const s = e.length / 4 + 2, o = Math.ceil(s / 16), a = new Array(o);
                    for(let t = 0; t < o; ++t){
                        const r = new Uint32Array(16);
                        for(let n = 0; n < 16; ++n)r[n] = e[64 * t + 4 * n] << 24 | e[64 * t + 4 * n + 1] << 16 | e[64 * t + 4 * n + 2] << 8 | e[64 * t + 4 * n + 3];
                        a[t] = r;
                    }
                    a[o - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), a[o - 1][14] = Math.floor(a[o - 1][14]), a[o - 1][15] = 8 * (e.length - 1) & 4294967295;
                    for(let e = 0; e < o; ++e){
                        const s = new Uint32Array(80);
                        for(let t = 0; t < 16; ++t)s[t] = a[e][t];
                        for(let e = 16; e < 80; ++e)s[e] = i(s[e - 3] ^ s[e - 8] ^ s[e - 14] ^ s[e - 16], 1);
                        let o = r[0], l = r[1], c = r[2], u = r[3], h = r[4];
                        for(let e = 0; e < 80; ++e){
                            const r = Math.floor(e / 20), a = i(o, 5) + n(r, l, c, u) + h + t[r] + s[e] >>> 0;
                            h = u, u = c, c = i(l, 30) >>> 0, l = o, o = a;
                        }
                        r[0] = r[0] + o >>> 0, r[1] = r[1] + l >>> 0, r[2] = r[2] + c >>> 0, r[3] = r[3] + u >>> 0, r[4] = r[4] + h >>> 0;
                    }
                    return [
                        r[0] >> 24 & 255,
                        r[0] >> 16 & 255,
                        r[0] >> 8 & 255,
                        255 & r[0],
                        r[1] >> 24 & 255,
                        r[1] >> 16 & 255,
                        r[1] >> 8 & 255,
                        255 & r[1],
                        r[2] >> 24 & 255,
                        r[2] >> 16 & 255,
                        r[2] >> 8 & 255,
                        255 & r[2],
                        r[3] >> 24 & 255,
                        r[3] >> 16 & 255,
                        r[3] >> 8 & 255,
                        255 & r[3],
                        r[4] >> 24 & 255,
                        r[4] >> 16 & 255,
                        r[4] >> 8 & 255,
                        255 & r[4]
                    ];
                };
                r.default = s;
            },
            {}
        ],
        535: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                const s = [];
                for(let e = 0; e < 256; ++e)s.push((e + 256).toString(16).substr(1));
                var o = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    const r = (s[e[t + 0]] + s[e[t + 1]] + s[e[t + 2]] + s[e[t + 3]] + "-" + s[e[t + 4]] + s[e[t + 5]] + "-" + s[e[t + 6]] + s[e[t + 7]] + "-" + s[e[t + 8]] + s[e[t + 9]] + "-" + s[e[t + 10]] + s[e[t + 11]] + s[e[t + 12]] + s[e[t + 13]] + s[e[t + 14]] + s[e[t + 15]]).toLowerCase();
                    if (!(0, i.default)(r)) throw TypeError("Stringified UUID is invalid");
                    return r;
                };
                r.default = o;
            },
            {
                "./validate.js": 541
            }
        ],
        536: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                let o, a, l = 0, c = 0;
                var u = function(e, t, r) {
                    let s = t && r || 0;
                    const u = t || new Array(16);
                    let h = (e = e || {}).node || o, f = void 0 !== e.clockseq ? e.clockseq : a;
                    if (null == h || null == f) {
                        const t = e.random || (e.rng || n.default)();
                        null == h && (h = o = [
                            1 | t[0],
                            t[1],
                            t[2],
                            t[3],
                            t[4],
                            t[5]
                        ]), null == f && (f = a = 16383 & (t[6] << 8 | t[7]));
                    }
                    let d = void 0 !== e.msecs ? e.msecs : Date.now(), p = void 0 !== e.nsecs ? e.nsecs : c + 1;
                    const m = d - l + (p - c) / 1e4;
                    if (m < 0 && void 0 === e.clockseq && (f = f + 1 & 16383), (m < 0 || d > l) && void 0 === e.nsecs && (p = 0), p >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    l = d, c = p, a = f, d += 122192928e5;
                    const b = (1e4 * (268435455 & d) + p) % 4294967296;
                    u[s++] = b >>> 24 & 255, u[s++] = b >>> 16 & 255, u[s++] = b >>> 8 & 255, u[s++] = 255 & b;
                    const g = d / 4294967296 * 1e4 & 268435455;
                    u[s++] = g >>> 8 & 255, u[s++] = 255 & g, u[s++] = g >>> 24 & 15 | 16, u[s++] = g >>> 16 & 255, u[s++] = f >>> 8 | 128, u[s++] = 255 & f;
                    for(let e = 0; e < 6; ++e)u[s + e] = h[e];
                    return t || (0, i.default)(u);
                };
                r.default = u;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        537: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./md5.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v3", 48, i.default);
                r.default = o;
            },
            {
                "./md5.js": 529,
                "./v35.js": 538
            }
        ],
        538: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function(e, t, r) {
                    function s(e, s, o, a) {
                        if ("string" == typeof e && (e = function(e) {
                            e = unescape(encodeURIComponent(e));
                            const t = [];
                            for(let r = 0; r < e.length; ++r)t.push(e.charCodeAt(r));
                            return t;
                        }(e)), "string" == typeof s && (s = (0, i.default)(s)), 16 !== s.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                        let l = new Uint8Array(16 + e.length);
                        if (l.set(s), l.set(e, s.length), l = r(l), l[6] = 15 & l[6] | t, l[8] = 63 & l[8] | 128, o) {
                            a = a || 0;
                            for(let e = 0; e < 16; ++e)o[a + e] = l[e];
                            return o;
                        }
                        return (0, n.default)(l);
                    }
                    try {
                        s.name = e;
                    } catch (e) {}
                    return s.DNS = o, s.URL = a, s;
                }, r.URL = r.DNS = void 0;
                var n = s(e("./stringify.js")), i = s(e("./parse.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                const o = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
                r.DNS = o;
                const a = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
                r.URL = a;
            },
            {
                "./parse.js": 531,
                "./stringify.js": 535
            }
        ],
        539: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = function(e, t, r) {
                    const s = (e = e || {}).random || (e.rng || n.default)();
                    if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, t) {
                        r = r || 0;
                        for(let e = 0; e < 16; ++e)t[r + e] = s[e];
                        return t;
                    }
                    return (0, i.default)(s);
                };
                r.default = o;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        540: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./sha1.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v5", 80, i.default);
                r.default = o;
            },
            {
                "./sha1.js": 534,
                "./v35.js": 538
            }
        ],
        541: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./regex.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    return "string" == typeof e && i.default.test(e);
                };
                r.default = s;
            },
            {
                "./regex.js": 532
            }
        ],
        542: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    return parseInt(e.substr(14, 1), 16);
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        543: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\t\n\r -\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 32 && e <= 55295 || 10 === e || 13 === e || 9 === e || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        544: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\x01-\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.RESTRICTED_CHAR = "\x01-\b\v\f\x0e-\x1f\x7f-\x84\x86-\x9f", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.RESTRICTED_CHAR_RE = new RegExp("^[" + r.RESTRICTED_CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 1 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isRestrictedChar = function(e) {
                    return e >= 1 && e <= 8 || 11 === e || 12 === e || e >= 14 && e <= 31 || e >= 127 && e <= 132 || e >= 134 && e <= 159;
                }, r.isCharAndNotRestricted = function(e) {
                    return 9 === e || 10 === e || 13 === e || e > 31 && e < 127 || 133 === e || e > 159 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        545: [
            function(e, t, r) {
                "use strict";
                /**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ function n(e) {
                    return e >= 65 && e <= 90 || 95 === e || e >= 97 && e <= 122 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NC_NAME_START_CHAR = "A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c-\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NC_NAME_CHAR = "-" + r.NC_NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.NC_NAME_START_CHAR_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "]$", "u"), r.NC_NAME_CHAR_RE = new RegExp("^[" + r.NC_NAME_CHAR + "]$", "u"), r.NC_NAME_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "][" + r.NC_NAME_CHAR + "]*$", "u"), r.isNCNameStartChar = n, r.isNCNameChar = function(e) {
                    return n(e) || 45 === e || 46 === e || e >= 48 && e <= 57 || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ]
    }, {}, [
        15
    ])(15);
});


function $78b00d0027f221e5$var$parseDelimitedText(text) {
    const result = $38e5b7422416655b$exports.parse(text, {
        header: true,
        skipEmptyLines: "greedy",
        transform: (value)=>value == null ? "" : value
    });
    const fields = result.meta.fields;
    if (!fields || fields.length === 0) return {
        headers: [],
        rows: []
    };
    const headers = fields.map((field)=>String(field ?? "").trim());
    const rows = result.data.map((row)=>fields.map((field)=>String(row[field] ?? "")));
    return {
        headers: headers,
        rows: rows
    };
}
async function $78b00d0027f221e5$var$parseXlsxWorkbook(buffer) {
    const workbook = new $2868ea4c6c841752$exports.Workbook();
    await workbook.xlsx.load(buffer);
    const sheets = [];
    workbook.eachSheet((worksheet)=>{
        const matrix = [];
        let maxCols = 0;
        worksheet.eachRow((row)=>{
            const cells = [];
            row.eachCell({
                includeEmpty: true
            }, (cell)=>{
                cells.push(cell.text ?? "");
            });
            matrix.push(cells);
            maxCols = Math.max(maxCols, cells.length);
        });
        if (matrix.length === 0) {
            sheets.push({
                name: worksheet.name,
                headers: [],
                rows: []
            });
            return;
        }
        const padRow = (r)=>{
            const result = r.map((c)=>String(c ?? ""));
            while(result.length < maxCols)result.push("");
            return result;
        };
        const headers = padRow(matrix[0]).map((h)=>h.trim());
        const rows = matrix.slice(1).map(padRow);
        sheets.push({
            name: worksheet.name,
            headers: headers,
            rows: rows
        });
    });
    return sheets;
}
const $78b00d0027f221e5$var$SpreadsheetPreviewPort = {
    add: function(app) {
        if (!app.ports.requestSpreadsheetPreview || !app.ports.spreadsheetPreviewResult) return;
        app.ports.requestSpreadsheetPreview.subscribe(async ({ requestId: requestId, url: url, kind: kind })=>{
            const sendFail = ()=>{
                app.ports.spreadsheetPreviewResult.send({
                    requestId: requestId,
                    ok: false,
                    kind: kind
                });
            };
            try {
                const res = await fetch(url);
                if (!res.ok) {
                    sendFail();
                    return;
                }
                if (kind === "csv") {
                    const text = await res.text();
                    const grid = $78b00d0027f221e5$var$parseDelimitedText(text);
                    app.ports.spreadsheetPreviewResult.send({
                        requestId: requestId,
                        ok: true,
                        kind: "csv",
                        grid: grid
                    });
                } else if (kind === "xlsx") {
                    const buffer = await res.arrayBuffer();
                    const sheets = await $78b00d0027f221e5$var$parseXlsxWorkbook(buffer);
                    app.ports.spreadsheetPreviewResult.send({
                        requestId: requestId,
                        ok: true,
                        kind: "xlsx",
                        sheets: sheets
                    });
                } else sendFail();
            } catch  {
                sendFail();
            }
        });
    }
};
$78b00d0027f221e5$exports = $78b00d0027f221e5$var$SpreadsheetPreviewPort;


var $2c37c159df5c9e36$exports = {};

class $2c37c159df5c9e36$var$SafeHtmlElement extends HTMLElement {
    static get observedAttributes() {
        return [
            "content"
        ];
    }
    connectedCallback() {
        this.render();
    }
    attributeChangedCallback() {
        this.render();
    }
    render() {
        const content = this.getAttribute("content") || "";
        if (!$f72755886b9c5753$exports.isSupported) return;
        this.innerHTML = $f72755886b9c5753$exports.sanitize(content);
        this.querySelectorAll("span.mention").forEach((el)=>{
            el.style.fontWeight = "bold";
        });
    }
}
const $2c37c159df5c9e36$var$SafeHtmlPort = {
    add: function() {
        if (typeof customElements !== "undefined" && !customElements.get("safe-html")) customElements.define("safe-html", $2c37c159df5c9e36$var$SafeHtmlElement);
    }
};
$2c37c159df5c9e36$exports = $2c37c159df5c9e36$var$SafeHtmlPort;


var $47c36a4cc88ed0d5$exports = {};
const $47c36a4cc88ed0d5$var$ClipboardPort = {
    add: (app)=>{
        app.ports.copyToClipboard.subscribe((text)=>{
            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).catch((err)=>{
                console.error("Clipboard write failed:", err);
            });
        });
    }
};
$47c36a4cc88ed0d5$exports = $47c36a4cc88ed0d5$var$ClipboardPort;


var $b37dfd354225ae06$exports = {};
"use strict";
const $b37dfd354225ae06$var$MeticulousPort = {
    add: function(app) {
        app.ports.meticulousRecordContext.subscribe(function(context) {
            const ctx = window.Meticulous?.context;
            if (!ctx) return;
            if (context.userId) ctx.recordUserId?.(context.userId);
            if (context.practiceId) ctx.recordCustomContext?.("practiceId", context.practiceId);
            if (context.scope) ctx.recordCustomContext?.("scope", context.scope);
        });
    }
};
$b37dfd354225ae06$exports = $b37dfd354225ae06$var$MeticulousPort;


var $3693c32c97d718e7$exports = {};
// Swipe-down-to-dismiss for modal bottom sheets on mobile.
//
// Standard modals render as bottom sheets below the `sm` breakpoint. This lets
// the user drag the sheet down and, past a threshold, dismiss it. Dismissal
// reuses the sheet's existing `.modal__backdrop-dismiss` control (wired to the
// modal's `onClose`), so every bottom sheet gets the gesture with no per-modal
// Elm wiring.
const $3693c32c97d718e7$var$MOBILE_QUERY = "(max-width: 767px)";
const $3693c32c97d718e7$var$CLOSE_THRESHOLD_PX = 100;
const $3693c32c97d718e7$var$CLOSE_TRANSITION = "transform 0.2s ease-out";
const $3693c32c97d718e7$var$BottomSheetSwipePort = {
    add: function() {
        let sheet = null;
        let scroller = null;
        let startY = null;
        let delta = 0;
        let dragging = false;
        const isMobile = ()=>window.matchMedia($3693c32c97d718e7$var$MOBILE_QUERY).matches;
        const sheetFor = (target)=>target && target.closest ? target.closest(".modal") : null;
        const resetSheetStyles = (transition)=>{
            if (!sheet) return;
            sheet.style.transition = transition || "";
            sheet.style.transform = "";
        };
        const clearState = ()=>{
            sheet = null;
            scroller = null;
            startY = null;
            delta = 0;
            dragging = false;
        };
        const onTouchStart = (event)=>{
            if (!isMobile() || event.touches.length !== 1) return;
            const target = sheetFor(event.target);
            if (!target) return;
            sheet = target;
            scroller = sheet.querySelector(".modal__body") || sheet.querySelector("#modal-scroll-content");
            startY = event.touches[0].clientY;
            delta = 0;
            dragging = false;
        };
        const onTouchMove = (event)=>{
            if (startY === null || !sheet) return;
            delta = event.touches[0].clientY - startY;
            const scrollerAtTop = !scroller || scroller.scrollTop <= 0;
            if (delta > 0 && scrollerAtTop) {
                dragging = true;
                sheet.style.transition = "none";
                sheet.style.transform = "translateY(" + delta + "px)";
                // Prevent the page/body from scrolling while dragging the sheet.
                event.preventDefault();
            } else if (dragging) // Dragged back above the start point: pin to the top edge.
            sheet.style.transform = "translateY(0px)";
        };
        const dismiss = ()=>{
            const wrap = sheet.closest(".modal-wrap");
            const dismissControl = wrap ? wrap.querySelector(".modal__backdrop-dismiss") : null;
            const target = sheet;
            target.style.transition = $3693c32c97d718e7$var$CLOSE_TRANSITION;
            target.style.transform = "translateY(100%)";
            let finished = false;
            let fallbackTimer = null;
            const finish = ()=>{
                if (finished) return;
                finished = true;
                clearTimeout(fallbackTimer);
                target.removeEventListener("transitionend", finish);
                if (dismissControl) dismissControl.click();
            };
            target.addEventListener("transitionend", finish);
            // Fallback in case transitionend doesn't fire (e.g. reduced motion).
            fallbackTimer = setTimeout(finish, 250);
            clearState();
        };
        const onTouchEnd = ()=>{
            if (startY === null || !sheet) {
                clearState();
                return;
            }
            if (dragging && delta > $3693c32c97d718e7$var$CLOSE_THRESHOLD_PX) dismiss();
            else {
                resetSheetStyles($3693c32c97d718e7$var$CLOSE_TRANSITION);
                clearState();
            }
        };
        document.addEventListener("touchstart", onTouchStart, {
            passive: true
        });
        document.addEventListener("touchmove", onTouchMove, {
            passive: false
        });
        document.addEventListener("touchend", onTouchEnd, {
            passive: true
        });
        document.addEventListener("touchcancel", ()=>{
            resetSheetStyles($3693c32c97d718e7$var$CLOSE_TRANSITION);
            clearState();
        }, {
            passive: true
        });
    }
};
$3693c32c97d718e7$exports = $3693c32c97d718e7$var$BottomSheetSwipePort;


const $736c28728eccce35$var$sentryDsn = `https://${CONFIGURATION.sentryKey}@${CONFIGURATION.sentryOrganizationId}.ingest.sentry.io/${CONFIGURATION.sentryProjectId}`;
$fb9aa293de3186c7$export$2cd8252107eb640b({
    dsn: $736c28728eccce35$var$sentryDsn,
    environment: CONFIGURATION.sentryEnvironment,
    release: CONFIGURATION.sentryReleaseVersion,
    maxValueLength: 1000,
    ignoreErrors: [
        "Cannot resolve iframe with unknown index"
    ],
    denyUrls: [
        /extensions\//i
    ]
});
$b073bf4933b0a980$exports.setExtra("api_version", CONFIGURATION.apiVersion);
// Initial data passed to Elm (should match `Flags` defined in `Shared.elm`)
// https://guide.elm-lang.org/interop/flags.html
var $736c28728eccce35$var$flags = {
    locationHref: location.href,
    accountToken: $36331f456e6baed0$exports.getItem("accountToken") || null,
    bustCacheRandom: Math.random().toString(36).slice(2),
    accountPracticeId: $f2086779cc7dd10e$exports.getItem("accountPracticeId"),
    apiUrl: CONFIGURATION.apiUrl,
    apiVersion: CONFIGURATION.apiVersion || null,
    emrNotesUrl: CONFIGURATION.emrNotesUrl,
    emrNotesVersion: CONFIGURATION.emrNotesVersion || null,
    emrCalendarsUrl: CONFIGURATION.emrCalendarsUrl,
    emrCalendarsVersion: CONFIGURATION.emrCalendarsVersion || null,
    emrMessagingUrl: CONFIGURATION.emrMessagingUrl,
    emrMessagingVersion: CONFIGURATION.emrMessagingVersion || null,
    release: CONFIGURATION.release || null,
    currentTime: new Date().getTime(),
    language: $f2086779cc7dd10e$exports.getItem("hint-language") || navigator.language,
    hintEnv: CONFIGURATION.hintEnv || null,
    meticulous: !!window.Meticulous
};
// Start our Elm application
const $736c28728eccce35$var$app = (0, $b9e750d20bbc1f0f$exports.Elm).Main.init({
    node: document.getElementById("elm-main"),
    flags: $736c28728eccce35$var$flags
});
// Ports go here
// https://guide.elm-lang.org/interop/ports.html
$397bcf58b99e38b9$exports.add($736c28728eccce35$var$app);
$085e3b96bb7da772$exports.add($736c28728eccce35$var$app, CONFIGURATION.fullStoryOrgId);
$0d34a6c94bf1f37e$exports.add($736c28728eccce35$var$app, CONFIGURATION.googleMapsKey);
$44d2ba25a7bfecb2$exports.add($736c28728eccce35$var$app);
$f2086779cc7dd10e$exports.add($736c28728eccce35$var$app);
$1e586fe0a96f962b$exports.add($736c28728eccce35$var$app);
$3cef90824005e2d6$exports.add($736c28728eccce35$var$app, CONFIGURATION.env);
$d5d5137484b98c41$exports.add($736c28728eccce35$var$app, CONFIGURATION.stripePublishableKey);
$b78de99e3cb6b90b$exports.add($736c28728eccce35$var$app);
$72eb1b7e8424fce8$exports.add($736c28728eccce35$var$app);
$f4b7f13ee09e6363$exports.add($736c28728eccce35$var$app);
$53030c4d0d659628$exports.add($736c28728eccce35$var$app);
$88841e90a30ba512$exports.add($736c28728eccce35$var$app);
$13a1730e1cbf1cc4$exports.add($736c28728eccce35$var$app);
$b28e419d9143a3c3$exports.add($736c28728eccce35$var$app);
$f2c7c3c854a3894f$exports.add($736c28728eccce35$var$app, CONFIGURATION.intercomAppId);
$15ca76013f461cc0$exports.add($736c28728eccce35$var$app);
$d13a3aa875c41ca7$exports.add($736c28728eccce35$var$app);
$d2be32b72d8b955d$exports.add($736c28728eccce35$var$app);
$a8ede6276a337434$exports.initFileSelection($736c28728eccce35$var$app);
$70bed06a98643566$exports.add($736c28728eccce35$var$app);
$ba7a6a20ab3b4d24$exports.add($736c28728eccce35$var$app);
$36331f456e6baed0$exports.add($736c28728eccce35$var$app);
$3b9526d384f0dd3d$exports.add($736c28728eccce35$var$app);
$8e7e1145409c40a4$exports.add($736c28728eccce35$var$app);
$5ce5aeca99e3b2a2$exports.add($736c28728eccce35$var$app);
$73cbf435bf470aed$exports.add($736c28728eccce35$var$app);
$78b00d0027f221e5$exports.add($736c28728eccce35$var$app);
(0, $5b09ccb12fff0951$export$2e2bcd8739ae039).add($736c28728eccce35$var$app);
(0, $b25dfe2ee2c25921$export$2e2bcd8739ae039).add($736c28728eccce35$var$app);
$2c37c159df5c9e36$exports.add();
$47c36a4cc88ed0d5$exports.add($736c28728eccce35$var$app);
$b37dfd354225ae06$exports.add($736c28728eccce35$var$app);
$3693c32c97d718e7$exports.add();
if (CONFIGURATION.statuspageEmbedCode) window.setupStatusPage(CONFIGURATION.statuspageEmbedCode);
if (CONFIGURATION.newRelicAccountId && CONFIGURATION.newRelicLicenseKey && CONFIGURATION.newRelicApplicationId && typeof setupNewRelic !== "undefined") setupNewRelic(CONFIGURATION.newRelicAccountId, CONFIGURATION.newRelicLicenseKey, CONFIGURATION.newRelicApplicationId);


//# sourceMappingURL=member-portal-elm.a534c3d0.js.map
